(function () {
    'use strict';
    angular
        .module('app.paperwork.exceptions', [])
        .config(config)
        .run(PaperworkExceptionConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.paperwork-exceptions', {
                url: '/paperwork-exceptions',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/paperworkExceptions/paperwork-exceptions-main.html'
                        , controller: 'PaperworkExceptionsController as vm'
                    }
                },
                title: 'Timesheet Warnings',
                titleBar: 'Alloc8 - Timesheet Warnings',
                data: {
                    requireLogin: true
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/paperworkExceptions');
    }

    function PaperworkExceptionConfig(PaperworkExceptionSignalRService) {
        PaperworkExceptionSignalRService.register();
    }

})();

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var smallPaperWorkTable = function (_React$Component) {
    _inherits(smallPaperWorkTable, _React$Component);

    //Headers


    //Current row holder
    function smallPaperWorkTable(props) {
        _classCallCheck(this, smallPaperWorkTable);

        var _this = _possibleConstructorReturn(this, (smallPaperWorkTable.__proto__ || Object.getPrototypeOf(smallPaperWorkTable)).call(this, props));

        _this.row = null;
        _this.rows = [];
        _this.headers = [];
        _this.icon_style = {
            'cursor': 'pointer',
            'color': '#475A65',
            'fontSize': '20px'
        };

        _this.showdialog = _this.showdialog.bind(_this);
        _this.showtimesheet = _this.showtimesheet.bind(_this);
        _this.converttime = _this.converttime.bind(_this);
        _this.gototimesheet = _this.gototimesheet.bind(_this);
        _this.downloadpdf = _this.downloadpdf.bind(_this);
        _this.handlechange = _this.handlechange.bind(_this);
        return _this;
    }
    //Rows collection


    _createClass(smallPaperWorkTable, [{
        key: 'showdialog',
        value: function showdialog(Id) {
            this.props.showdialog(Id);
        }
    }, {
        key: 'converttime',
        value: function converttime(time) {
            return this.props.converttime(time);
        }
    }, {
        key: 'showtimesheet',
        value: function showtimesheet(params) {
            this.props.showtimesheet(params);
        }
    }, {
        key: 'gototimesheet',
        value: function gototimesheet(params) {
            this.props.gototimesheet(params);
        }
    }, {
        key: 'downloadpdf',
        value: function downloadpdf(params) {
            this.props.downloadpdf(params);
        }
    }, {
        key: 'handlechange',
        value: function handlechange(params) {
            params.Value = !params.Value;
            this.props.handlechange({ params: params });
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;

            //Clear virtual rows
            self.rows.length = 0;
            self.headers.length = 0;

            //Utils & Helpers
            function orderProps(row) {
                //Order by OrderSequence
                return _.orderBy(row, ['OrderSequence'], ['asc']);
            }

            //Utils & Helpers

            _.forEach(self.props.rows, function (row) {
                //a virtual row copy for formatted props
                self.rows.push(orderProps(row));
            });

            //Filter headers
            self.headers = _.filter(self.props.headers, function (header) {
                return !_.isNil(header);
            });

            //Render header names
            function createHeader(header) {
                return React.createElement(
                    'th',
                    null,
                    header.HeaderName
                );
            }

            //Field Render Functions
            function renderCheckbox(payload) {
                //For checkbox
                return React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'label',
                        { className: 'pure-material-checkbox' },
                        React.createElement('input', { type: 'checkbox',
                            onChange: self.handlechange.bind(this, payload),
                            checked: payload.Value }),
                        React.createElement('span', null)
                    )
                );
            }

            function renderTextField(value) {
                //For text fields/plain texts
                return React.createElement(
                    'span',
                    null,
                    value
                );
            }

            function renderTimeField(value) {
                //For time field
                //If time value is null or undefined, display an empty field by calling 'renderEmptyField()'
                //Else Display time value by calling 'renderActualTimeField()'
                return _.isNil(value) ? renderEmptyField() : renderActualTimeField(value);
            }

            function renderEmptyField() {
                //Empty table field/td
                return React.createElement('span', null);
            }

            function renderActualTimeField(value) {
                //Time field with 'time-box' style/class
                var time = self.converttime(value);

                var style = {
                    borderRadius: '2px',
                    padding: '4px 8px',
                    margin: '0 8px',
                    fontSize: '11px',
                    fontWeight: '500',
                    whiteSpace: 'nowrap',
                    backgroundColor: '#2978BF',
                    color: 'white'
                };

                var spacing = {
                    position: 'relative',
                    left: '-7px'
                };

                return React.createElement(
                    'div',
                    { style: spacing },
                    React.createElement(
                        'span',
                        { style: style },
                        time
                    )
                );
            }

            function renderLink(field) {
                //For link/ticket number
                //Show ticket details
                return React.createElement(
                    'span',
                    null,
                    React.createElement(
                        'a',
                        { className: 'text-bold', onClick: self.showdialog.bind(this, field.TicketId), href: '#' },
                        field.Value
                    )
                );
            }

            function renderActions(field) {
                //For action buttons
                //If ReportCategory is 0, return Paperwork Action Button(s) (Downlaod PDF)
                //If ReportCategory is 1, return Timesheet Action Button(s) (Go to timesheet and Show timesheet dialog)
                return field.ReportCategory === 0 ? renderPaperworkActions(field) : renderTimesheetActions(field);
            }

            //Actions Buttons Functions
            function renderPaperworkActions(field) {
                //Paperwork-based Actions
                return React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'span',
                        { className: 'action-span timesheet-buttons' },
                        React.createElement('i', { style: self.icon_style, onClick: self.downloadpdf.bind(this, field.Payload),
                            className: 'icon icon-file-pdf-box download-pdf',
                            'aria-label': 'Download PDF' })
                    )
                );
            }

            function renderTimesheetActions(field) {
                var is_locked = _.find(self.row, { HeaderKey: "IsLocked" });

                var edit_timesheet_style = {
                    'cursor': 'pointer',
                    'color': '#475A65',
                    'fontSize': '20px',
                    'marginLeft': '5px',
                    'marginTop': '2px'
                };

                if (is_locked.Value === "True") {
                    {/*This is for 'Locked' Timesheets*/
                    }
                    return React.createElement(
                        'td',
                        null,
                        React.createElement(
                            'span',
                            { className: 'action-span timesheet-buttons' },
                            React.createElement('i', { style: self.icon_style, onClick: self.gototimesheet.bind(this, field.Payload),
                                className: 'icon icon-clock',
                                'aria-label': 'View Timesheet' })
                        )
                    );
                } else {
                    return React.createElement(
                        'td',
                        null,
                        React.createElement(
                            'span',
                            { className: 'action-span timesheet-buttons' },
                            React.createElement('i', { style: self.icon_style, onClick: self.showtimesheet.bind(this, field.Payload),
                                className: 'icon-table-edit',
                                'aria-label': 'Edit Timesheet' }),
                            React.createElement('i', { style: edit_timesheet_style, onClick: self.gototimesheet.bind(this, field.Payload),
                                className: 'icon icon-clock',
                                'aria-label': 'View Timesheet' })
                        )
                    );
                }
            }

            //Actions Buttons Functions

            //Field Render Functions
            function createField(field) {
                if (field.FieldType === 0) {
                    //Plain text fieldcreateField
                    return renderTextField(field.Value);
                } else if (field.FieldType === 3) {
                    //Time field
                    //With specified 'boxed' design
                    return renderTimeField(field.Value);
                } else if (field.FieldType === 1) {
                    //Link to display ticket details
                    var data = {
                        Value: field.Value,
                        TicketId: getTicketId(field)
                    };
                    return renderLink(data);
                }
            }

            function getTicketId(field) {
                var id = null;
                var report_category = getReportCategory();
                var matched_row = _.find(self.row, { HeaderKey: "TicketNumber" });
                if (matched_row.Value === field.Value) {
                    if (report_category === 1) {
                        //The ticketId prop for timesheet based report is 'TicketId'
                        id = _.find(self.row, { HeaderKey: "TicketId" }).Value;
                    } else {
                        //The ticketId prop for paperwork based report is 'SecondaryId'
                        id = _.find(self.row, { HeaderKey: "SecondaryId" }).Value;
                    }
                }
                return id;
            }

            function getReportCategory() {
                return _.find(self.row, { HeaderKey: "ReportTypeCategory" }).Value;
            }

            function render(field) {
                return renderTextField(field.Value);
            }

            function createTr(header) {

                var td_style = {
                    width: '50%',
                    padding: '5px'
                };

                var field = _.find(self.row, { HeaderKey: header.HeaderKey });

                return React.createElement(
                    'tr',
                    { style: header.Line % 2 ? { backgroundColor: '#F4F4F4' } : null },
                    React.createElement(
                        'td',
                        { className: 'text-bold cyan-900-fg flex-50', style: td_style },
                        header.HeaderName
                    ),
                    React.createElement(
                        'td',
                        { style: td_style, className: 'flex-50' },
                        createField(field)
                    )
                );
            }

            function timesheetActions(row) {

                var icon_style = {
                    cursor: 'pointer'
                };

                var edit_style = {
                    cursor: 'pointer',
                    position: 'relative',
                    right: '20px;'
                };

                var is_ticket_locked = _.find(row, { HeaderKey: "IsLocked" }).Value === "True" ? true : false;
                var payload = {
                    PrimaryId: _.find(self.row, { HeaderKey: "PrimaryId" }).Value,
                    SecondaryId: _.find(self.row, { HeaderKey: "SecondaryId" }).Value,
                    TicketId: _.find(self.row, { HeaderKey: "TicketId" }).Value,
                    TicketNumber: _.find(self.row, { HeaderKey: "TicketNumber" }).Value
                };

                if (is_ticket_locked) {
                    return React.createElement(
                        'div',
                        { className: 'flex-100 cyan-900-fg layout-row layout-align-space-between-center' },
                        React.createElement(
                            'span',
                            null,
                            React.createElement('i', { style: icon_style,
                                className: 'icon-clock',
                                onClick: self.gototimesheet.bind(this, payload),
                                'aria-label': 'View Timesheet' })
                        )
                    );
                } else {
                    return React.createElement(
                        'div',
                        { className: 'flex-100 cyan-900-fg layout-row layout-align-space-between-center' },
                        React.createElement(
                            'span',
                            { style: edit_style },
                            React.createElement('i', { style: icon_style, className: 'icon-table-edit',
                                onClick: self.showtimesheet.bind(this, payload),
                                'aria-label': 'Edit Timesheet' })
                        ),
                        React.createElement(
                            'span',
                            null,
                            React.createElement('i', { style: icon_style,
                                className: 'icon-clock',
                                onClick: self.gototimesheet.bind(this, payload),
                                'aria-label': 'View Timesheet' })
                        )
                    );
                }
            }

            function paperworkActions(row) {

                var payload = {
                    TicketId: _.find(row, { HeaderKey: "SecondaryId" }).Value,
                    TicketNumber: _.find(row, { HeaderKey: "TicketNumber" }).Value
                };

                var icon_style = {
                    cursor: 'pointer'
                };

                return React.createElement(
                    'div',
                    { className: 'flex-100 cyan-900-fg layout-row layout-align-space-between-center' },
                    React.createElement(
                        'span',
                        null,
                        React.createElement('i', { style: icon_style,
                            onClick: self.downloadpdf.bind(this, payload),
                            className: 'icon-file-pdf-box',
                            'aria-label': 'Download PDF' })
                    )
                );
            }

            //Creates rows
            function createRow(row) {
                self.row = row;

                var headers = _.reject(self.headers, function (header) {
                    return header.HeaderKey === "IsSelected" || header.HeaderKey === "Actions";
                });

                var category = _.find(self.row, { HeaderKey: "ReportTypeCategory" }).Value;

                headers.forEach(function (header, index) {
                    header['Line'] = index + 1;
                });

                var table_style = {
                    width: '100%'
                };

                var payload = {
                    Value: _.find(self.row, { HeaderKey: "IsSelected" }).Value,
                    PrimaryId: _.find(self.row, { HeaderKey: "PrimaryId" }).Value,
                    SecondaryId: _.find(self.row, { HeaderKey: "SecondaryId" }).Value,
                    ExceptionType: _.find(self.row, { HeaderKey: "ExceptionType" }).Value,
                    ReportTypeCategory: _.find(self.row, { HeaderKey: "ReportTypeCategory" }).Value
                };

                return React.createElement(
                    'div',
                    { className: 'flex-100 margin-top-20 md-whiteframe-3dp layout-padding' },
                    React.createElement(
                        'table',
                        { style: table_style, className: 'flex-100 simple h5 invoice-table table-main' },
                        headers.map(createTr)
                    ),
                    React.createElement(
                        'div',
                        { className: 'flex-100 layout-row layout-align-space-between-center margin-top-20' },
                        React.createElement(
                            'div',
                            { className: 'flex-none layout-row layout-align-start-center' },
                            React.createElement(
                                'label',
                                { className: 'pure-material-checkbox' },
                                React.createElement('input', { type: 'checkbox',
                                    onChange: self.handlechange.bind(this, payload),
                                    checked: payload.Value }),
                                React.createElement('span', null)
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'flex-initial layout-row layout-align-end-center' },
                            category === 0 ? paperworkActions(row) : timesheetActions(row)
                        )
                    )
                );
            }

            return (
                //Main renderer
                //Main table
                React.createElement(
                    'div',
                    null,
                    self.rows.map(createRow)
                )
            );
        }
    }]);

    return smallPaperWorkTable;
}(React.Component);

smallPaperWorkTable.propTypes = {
    headers: React.PropTypes.array.isRequired,
    rows: React.PropTypes.array.isRequired,
    showdialog: React.PropTypes.func,
    showtimesheet: React.PropTypes.func,
    converttime: React.PropTypes.func,
    gototimesheet: React.PropTypes.func,
    downloadpdf: React.PropTypes.func,
    handlechange: React.PropTypes.func
};
smallPaperWorkTable.defaultProps = {
    headers: [],
    rows: [],
    showdialog: function showdialog() {},
    showtimesheet: function showtimesheet() {},
    converttime: function converttime() {},
    gototimesheet: function gototimesheet() {},
    downloadpdf: function downloadpdf() {},
    handlechange: function handlechange() {}
};


angular.module('app.paperwork.exceptions').value('smallPaperWorkTable', smallPaperWorkTable);
(function () {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .directive('smallPaperWorkTable', smallPaperWorkTable);

    /** @ngInject */
    function smallPaperWorkTable(reactDirective, smallPaperWorkTable) {
        return reactDirective(smallPaperWorkTable);
    }

})();


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var largePaperWorkTable = function (_React$Component) {
    _inherits(largePaperWorkTable, _React$Component);

    //Headers


    //Current row holder
    function largePaperWorkTable(props) {
        _classCallCheck(this, largePaperWorkTable);

        var _this = _possibleConstructorReturn(this, (largePaperWorkTable.__proto__ || Object.getPrototypeOf(largePaperWorkTable)).call(this, props));

        _this.row = null;
        _this.rows = [];
        _this.headers = [];
        _this.icon_style = {
            'cursor': 'pointer',
            'color': '#475A65',
            'fontSize': '20px'
        };

        _this.showdialog = _this.showdialog.bind(_this);
        _this.showtimesheet = _this.showtimesheet.bind(_this);
        _this.converttime = _this.converttime.bind(_this);
        _this.gototimesheet = _this.gototimesheet.bind(_this);
        _this.downloadpdf = _this.downloadpdf.bind(_this);
        _this.handlechange = _this.handlechange.bind(_this);
        return _this;
    }
    //Rows collection


    _createClass(largePaperWorkTable, [{
        key: 'showdialog',
        value: function showdialog(Id) {
            this.props.showdialog(Id);
        }
    }, {
        key: 'converttime',
        value: function converttime(time) {
            return this.props.converttime(time);
        }
    }, {
        key: 'showtimesheet',
        value: function showtimesheet(params) {
            this.props.showtimesheet(params);
        }
    }, {
        key: 'gototimesheet',
        value: function gototimesheet(params) {
            this.props.gototimesheet(params);
        }
    }, {
        key: 'downloadpdf',
        value: function downloadpdf(params) {
            this.props.downloadpdf(params);
        }
    }, {
        key: 'handlechange',
        value: function handlechange(params) {
            params.Value = !params.Value;
            this.props.handlechange({ params: params });
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;

            //Clear virtual rows
            self.rows.length = 0;
            self.headers.length = 0;

            //Utils & Helpers
            function orderProps(row) {
                //Order by OrderSequence
                return _.orderBy(row, ['OrderSequence'], ['asc']);
            }

            //Utils & Helpers

            _.forEach(self.props.rows, function (row) {
                //a virtual row copy for formatted props
                self.rows.push(orderProps(row));
            });

            //Filter headers
            self.headers = _.filter(self.props.headers, function (header) {
                return !_.isNil(header);
            });

            //Render header names
            function createHeader(header) {
                return React.createElement(
                    'th',
                    null,
                    header.HeaderName
                );
            }

            //Field Render Functions
            function renderCheckbox(payload) {
                //For checkbox
                return React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'label',
                        { className: 'pure-material-checkbox' },
                        React.createElement('input', { type: 'checkbox',
                            onChange: self.handlechange.bind(this, payload),
                            checked: payload.Value }),
                        React.createElement('span', null)
                    )
                );
            }

            function renderTextField(value) {
                //For text fields/plain texts
                return React.createElement(
                    'td',
                    null,
                    value
                );
            }

            function renderTimeField(value) {
                //For time field
                //If time value is null or undefined, display an empty field by calling 'renderEmptyField()'
                //Else Display time value by calling 'renderActualTimeField()'
                return _.isNil(value) ? renderEmptyField() : renderActualTimeField(value);
            }

            function renderEmptyField() {
                //Empty table field/td
                return React.createElement('td', null);
            }

            function renderActualTimeField(value) {
                //Time field with 'time-box' style/class
                var time = self.converttime(value);
                return React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'span',
                        { className: 'time-box' },
                        time
                    )
                );
            }

            function renderLink(field) {
                //For link/ticket number
                //Show ticket details
                return React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'a',
                        { className: 'text-bold', onClick: self.showdialog.bind(this, field.TicketId), href: '#' },
                        field.Value
                    )
                );
            }

            function renderActions(field) {
                //For action buttons
                //If ReportCategory is 0, return Paperwork Action Button(s) (Downlaod PDF)
                //If ReportCategory is 1, return Timesheet Action Button(s) (Go to timesheet and Show timesheet dialog)
                return field.ReportCategory === 0 ? renderPaperworkActions(field) : renderTimesheetActions(field);
            }

            //Actions Buttons Functions
            function renderPaperworkActions(field) {
                //Paperwork-based Actions
                return React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'span',
                        { className: 'action-span timesheet-buttons' },
                        React.createElement('i', { style: self.icon_style, onClick: self.downloadpdf.bind(this, field.Payload),
                            className: 'icon icon-file-pdf-box download-pdf',
                            'aria-label': 'Download PDF' })
                    )
                );
            }

            function renderTimesheetActions(field) {
                var is_locked = _.find(self.row, { HeaderKey: "IsLocked" });

                var edit_timesheet_style = {
                    'cursor': 'pointer',
                    'color': '#475A65',
                    'fontSize': '20px',
                    'marginLeft': '5px',
                    'marginTop': '2px'
                };

                if (is_locked.Value === "True") {
                    {/*This is for 'Locked' Timesheets*/
                    }
                    return React.createElement(
                        'td',
                        null,
                        React.createElement(
                            'span',
                            { className: 'action-span timesheet-buttons' },
                            React.createElement('i', { style: self.icon_style, onClick: self.gototimesheet.bind(this, field.Payload),
                                className: 'icon icon-clock',
                                'aria-label': 'View Timesheet' })
                        )
                    );
                } else {
                    return React.createElement(
                        'td',
                        null,
                        React.createElement(
                            'span',
                            { className: 'action-span timesheet-buttons' },
                            React.createElement('i', { style: edit_timesheet_style, onClick: self.gototimesheet.bind(this, field.Payload),
                                className: 'icon-table-edit',
                                'aria-label': 'View Timesheet' })
                        )
                    );
                }
            }

            //Actions Buttons Functions

            //Field Render Functions
            function createField(field) {
                if (field.FieldType === 0) {
                    //Plain text field
                    return renderTextField(field.Value);
                } else if (field.FieldType === 3) {
                    //Time field
                    //With specified 'boxed' design
                    return renderTimeField(field.Value);
                } else if (field.FieldType === 1) {
                    //Link to display ticket details
                    var data = {
                        Value: field.Value,
                        TicketId: getTicketId(field)
                    };
                    return renderLink(data);
                } else if (field.FieldType === "c") {
                    //Checkbox
                    var payload = {
                        Value: field.Value,
                        PrimaryId: _.find(self.row, { HeaderKey: "PrimaryId" }).Value,
                        SecondaryId: _.find(self.row, { HeaderKey: "SecondaryId" }).Value,
                        ExceptionType: _.find(self.row, { HeaderKey: "ExceptionType" }).Value,
                        ReportTypeCategory: _.find(self.row, { HeaderKey: "ReportTypeCategory" }).Value
                    };
                    return renderCheckbox(payload);
                } else if (field.FieldType === "a") {
                    //Action buttons
                    var category = getReportCategory();
                    var _payload = {};

                    if (category === 0) {
                        //Paperwork-based payload
                        _payload = {
                            TicketId: _.find(self.row, { HeaderKey: "SecondaryId" }).Value,
                            TicketNumber: _.find(self.row, { HeaderKey: "TicketNumber" }).Value
                        };
                    } else {
                        _payload = {
                            PrimaryId: _.find(self.row, { HeaderKey: "PrimaryId" }).Value,
                            SecondaryId: _.find(self.row, { HeaderKey: "SecondaryId" }).Value,
                            TicketId: _.find(self.row, { HeaderKey: "TicketId" }).Value,
                            TicketNumber: _.find(self.row, { HeaderKey: "TicketNumber" }).Value
                            //Time sheet-based payload
                        };
                    }

                    var _data = {
                        ReportCategory: category,
                        Payload: _payload
                    };

                    return renderActions(_data);
                }
            }

            function getTicketId(field) {
                var id = null;
                var report_category = getReportCategory();
                var matched_row = _.find(self.row, { HeaderKey: "TicketNumber" });
                if (matched_row.Value === field.Value) {
                    if (report_category === 1) {
                        //The ticketId prop for timesheet based report is 'TicketId'
                        id = _.find(self.row, { HeaderKey: "TicketId" }).Value;
                    } else {
                        //The ticketId prop for paperwork based report is 'SecondaryId'
                        id = _.find(self.row, { HeaderKey: "SecondaryId" }).Value;
                    }
                }
                return id;
            }

            function getReportCategory() {
                return _.find(self.row, { HeaderKey: "ReportTypeCategory" }).Value;
            }

            //Creates rows
            function createRow(row) {
                self.row = row;
                return React.createElement(
                    'tr',
                    null,
                    row.map(createField)
                );
            }

            return (
                //Main renderer
                //Main table
                React.createElement(
                    'div',
                    { className: 'flex-100' },
                    React.createElement(
                        'table',
                        { className: 'simple h5 invoice-table table-main flex' },
                        React.createElement(
                            'thead',
                            null,
                            React.createElement(
                                'tr',
                                null,
                                self.headers.map(createHeader)
                            )
                        ),
                        React.createElement(
                            'tbody',
                            null,
                            self.rows.map(createRow)
                        )
                    )
                )
            );
        }
    }]);

    return largePaperWorkTable;
}(React.Component);

largePaperWorkTable.propTypes = {
    headers: React.PropTypes.array.isRequired,
    rows: React.PropTypes.array.isRequired,
    showdialog: React.PropTypes.func,
    showtimesheet: React.PropTypes.func,
    converttime: React.PropTypes.func,
    gototimesheet: React.PropTypes.func,
    downloadpdf: React.PropTypes.func,
    handlechange: React.PropTypes.func
};
largePaperWorkTable.defaultProps = {
    headers: [],
    rows: [],
    showdialog: function showdialog() {},
    showtimesheet: function showtimesheet() {},
    converttime: function converttime() {},
    gototimesheet: function gototimesheet() {},
    downloadpdf: function downloadpdf() {},
    handlechange: function handlechange() {}
};


angular.module('app.paperwork.exceptions').value('largePaperWorkTable', largePaperWorkTable);
(function () {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .directive('largePaperWorkTable', largePaperWorkTable);

    /** @ngInject */
    function largePaperWorkTable(reactDirective, largePaperWorkTable) {
        return reactDirective(largePaperWorkTable);
    }

})();


"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TicketFooterComponent = function (_React$Component) {
  _inherits(TicketFooterComponent, _React$Component);

  function TicketFooterComponent() {
    _classCallCheck(this, TicketFooterComponent);

    return _possibleConstructorReturn(this, (TicketFooterComponent.__proto__ || Object.getPrototypeOf(TicketFooterComponent)).call(this));
  }

  _createClass(TicketFooterComponent, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "layout-row flex ticket-other-detail md-whiteframe-4dp" },
        React.createElement(
          "div",
          { className: "layout-row flex" },
          React.createElement(
            "div",
            { className: "flex md-body-2 grey-700-fg layout-padding layout-row layout-align-center-center" },
            "#",
            this.props.ticketno
          )
        )
      );
    }
  }]);

  return TicketFooterComponent;
}(React.Component);

TicketFooterComponent.propTypes = {
  ticketno: React.PropTypes.string
};
TicketFooterComponent.defaultProps = {
  ticketno: null
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingSection = function (_React$Component) {
    _inherits(BillingSection, _React$Component);

    function BillingSection() {
        _classCallCheck(this, BillingSection);

        var _this = _possibleConstructorReturn(this, (BillingSection.__proto__ || Object.getPrototypeOf(BillingSection)).call(this));

        _this.showDialog = _this.showDialog.bind(_this);
        return _this;
    }

    _createClass(BillingSection, [{
        key: "showDialog",
        value: function showDialog(item) {
            this.props.showdialog(item);
        }
    }, {
        key: "render",
        value: function render() {
            var self = this;

            function splitWords(item) {
                return React.createElement(
                    "span",
                    null,
                    " ",
                    item,
                    " ",
                    React.createElement("br", null),
                    " "
                );
            }

            function splitBy3(items) {
                var splitted = items.split(" ");
                var divisions = Math.ceil(splitted.length / 2);
                var sentence = "";
                var sentences = [];
                var cur_index = 0;
                for (var x = 0; x < divisions; x++) {
                    sentence = "";
                    for (var y = 0; y < 2; y++) {
                        if (cur_index < splitted.length) {
                            sentence += splitted[cur_index] + " ";
                            cur_index++;
                        }
                    }
                    sentences.push(sentence.slice(0, -1));
                }
                return sentences;
            }

            function createTableRow(row) {
                return React.createElement(
                    "tr",
                    null,
                    React.createElement(
                        "td",
                        { className: "bill-table-item" },
                        React.createElement("i", { className: row.Class })
                    ),
                    React.createElement(
                        "td",
                        { className: "bill-table-item" },
                        row.ItemQuantity
                    ),
                    React.createElement(
                        "td",
                        { className: "bill-table-item2" },
                        splitBy3(row.ItemName).map(splitWords)
                    )
                );
            }

            function createBillingList(item) {
                if (item.Items.length > 0) {
                    return React.createElement(
                        "div",
                        { onClick: self.showDialog.bind(this, item), className: "layout-column md-whiteframe-4dp flex-auto bill item-separator" },
                        React.createElement(
                            "div",
                            { className: "layout-row flex-auto badge" },
                            React.createElement(
                                "div",
                                { className: item.BadgeClass },
                                React.createElement(
                                    "span",
                                    { className: "inv-text" },
                                    "Hidden"
                                )
                            ),
                            React.createElement(
                                "div",
                                { className: "flex-auto layout-column layout-align-start-start layout-padding" },
                                React.createElement(
                                    "div",
                                    { className: "layout-row flex-10 md-body-2 bill_header" },
                                    React.createElement(
                                        "h5",
                                        null,
                                        React.createElement(
                                            "b",
                                            null,
                                            item.Name
                                        )
                                    )
                                ),
                                React.createElement(
                                    "div",
                                    { className: "layout-column md-caption grey-900-fg layout-padding flex-auto bill_items md-body-2" },
                                    React.createElement(
                                        "table",
                                        { className: "flex-auto bill-table" },
                                        React.createElement(
                                            "tbody",
                                            null,
                                            item.Items.map(createTableRow)
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement("md-divider", null)
                    );
                } else {
                    return null;
                }
            }

            return React.createElement(
                "div",
                { className: "layout-column" },
                this.props.items.map(createBillingList)
            );
        }
    }]);

    return BillingSection;
}(React.Component);

BillingSection.propTypes = {
    items: React.PropTypes.array,
    showdialog: React.PropTypes.func
};
BillingSection.defaultProps = {
    items: [],
    showDialog: function showDialog() {}
};
/**
 * Created by Ben Rei on 8/19/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.jobs.allocate.droppable',['fixed.table.header'])
})();

(function () {
  'use strict';

  angular.module('app.jobs.allocate.droppable')
    .directive('droppableXL', droppableAllocateResourceComponent);

  /** @ngInject */
  function droppableAllocateResourceComponent() {

    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl : 'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/XL/droppable-xl.html'
      , scope: {
        ngService: '=',
        name: '@'
      }
      , bindToController: true
      , controller: 'droppableAllocateResourceController as droppableVm'
    };
    return directive;
  }
})();

(function () {
  'use strict';

  angular.module('app.jobs.allocate.droppable')
    .directive('droppableSmall', droppableAllocateResourceComponent);

  /** @ngInject */
  function droppableAllocateResourceComponent() {

    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl : 'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/SM/droppable-sm.html'
      , scope: {
        ngService: '=',
        name: '@'
      }
      , bindToController: true
      , controller: 'droppableAllocateResourceController as droppableVm'
    };

    return directive;
  }
})();

(function () {
    'use strict';

    angular.module('app.jobs.allocate.droppable')
        .directive('a8AllocateOptions', a8AllocateOptions);

    function a8AllocateOptions() {
        var directive = {
            restrict: 'E',
            scope: {
                layout: '@',
                ngModel: '=',
                startDate: '=',
                endDate: '=',
                multiple: '='
            },
            templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/OPT/top-option.html',
            controller: a8AllocateOptionsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function a8AllocateOptionsController(claimsUtilService) {
            var vm = this;
            vm.alignment = "row";
            vm.filterEndDate = filterEndDate;
            vm.claimsUtilService = claimsUtilService;
            vm.filterStartDate = filterStartDate;

            function filterEndDate(date) {
                if (vm.startDate) {
                    return moment(date).isAfter(moment(vm.startDate))
                } else {
                    return date;
                }
            }

            function filterStartDate(date) {
                if (vm.endDate) {
                    return moment(date).isBefore(moment(vm.endDate))
                } else {
                    return date;
                }
            }
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.jobs.allocate.droppable')
    .directive('droppableBetween', droppableAllocateResourceComponent);

  /** @ngInject */
  function droppableAllocateResourceComponent() {

    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl : 'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/BT/droppable-bt.html'
      , scope: {
        ngService: '=',
        name: '@'
      }
      , bindToController: true
      , controller: 'droppableAllocateResourceController as droppableVm'
    };

    return directive;
  }
})();

(function() {
    'use strict';

    angular.module('app.invoice', [
            'app.invoice.reports',
            'app.invoice.reports.view',
            'app.invoice.reports.export',
            'app.invoice.forms.manualInvoice',
            'app.api',
            'app.corelib',
            'app.widgets',
            'LocalStorageModule'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function runConfig(
        msNavigationService,
        claimsUtilService,
        invoiceClaimsService
    ) {
        msNavigationService.saveItem('apps.invoice', {
            title: 'Invoicing',
            icon: 'icon-chart-arc',
            weight: 6,
            hidden: function() {
                return !invoiceClaimsService.hasInvoicingMenu;
            }
        });

        msNavigationService.saveItem('apps.invoice.report', {
            title: 'Preview Invoices',
            state: 'app.invoice_report',
            weight: 1,
            hidden: function() {
                return !invoiceClaimsService.hasPreviewInvoiceMenu;
            }
        });

        msNavigationService.saveItem('apps.invoice.manualInvoice', {
            title: 'Create an Invoice',
            state: 'app.invoice_manual',
            weight: 2,
            hidden: function() {
                return !invoiceClaimsService.hasCreateInvoiceMenu;
            }
        });

        msNavigationService.saveItem('apps.invoice.report_pdf', {
            title: 'View Invoices',
            state: 'app.invoice_report_pdf',
            weight: 3,
            hidden: function() {
                return !invoiceClaimsService.hasViewInvoiceMenu;
            }
        });

        msNavigationService.saveItem('apps.invoice.export_viewer', {
            title: 'Export Invoices',
            state: 'app.invoice_export_viewer',
            weight: 4,
            hidden: function() {
                return !invoiceClaimsService.hasExportInvoiceMenu;
            }
        });

        msNavigationService.saveItem('apps.invoice.email_dist', {
            title: 'Send Invoices',
            state: 'app.invoice_email_sender',
            weight: 5,
            hidden: function() {
                return !invoiceClaimsService.hasExportInvoiceMenu;
            }
        });

        msNavigationService.saveItem('apps.invoice.rate_card', {
            title: 'Rate Cards',
            state: 'app.ratecards',
            weight: 6,
            hidden: function() {
                return !invoiceClaimsService.hasManageRateCardsMenu;
            }
        });
    }

    function config(localStorageServiceProvider) {
        localStorageServiceProvider.setStorageType('localStorage');
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice')
        .directive('rowActionPaneComponent', rowActionPaneComponent);

    /** @ngInject */
    function rowActionPaneComponent($log, exceptionService, _) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/reports/dialogs/edit-invoice/directives/editable-table/row-action-pane/row-action-pane.html',
            scope: {
                rowId: '='
            },
            require: '^editableTableComponent',
            controller: RowActionPaneController,
            controllerAs: 'rowActionPaneVm',
            bindToController: true,
            link: link
        };

        return directive;

        function RowActionPaneController() {}

        function link(scope, elems, attrs, controller) {

            scope.rowActionPaneVm.isEditMode = false;
            scope.rowActionPaneVm.isActionDisabled = false;

            scope.rowActionPaneVm.edit = edit;
            scope.rowActionPaneVm.update = update;
            scope.rowActionPaneVm.cancel = cancel;
            scope.rowActionPaneVm.remove = remove;

            // Disable all on edit mode control
            controller.onDisableAction(function(isDisabled) {
                scope.rowActionPaneVm.isActionDisabled = isDisabled;
            });

            controller.onForceActionEdit(function(id) {
                edit(id);
            });

            function edit(id) {
                if (scope.rowActionPaneVm.rowId === id) {
                    scope.rowActionPaneVm.isEditMode = true;
                    controller.disableAllAction(true);
                    controller.editField(id, true);
                }
            }

            function update(id) {
                if (scope.rowActionPaneVm.rowId === id) {
                    if (controller.onValidate(id)) {
                        scope.rowActionPaneVm.isEditMode = false;
                        controller.disableAllAction(false);
                        controller.updateEdit(id);
                    }
                }
            }

            function cancel(id) {
                if (scope.rowActionPaneVm.rowId === id) {
                    scope.rowActionPaneVm.isEditMode = false;
                    controller.disableAllAction(false);
                    controller.cancelEdit(id);
                }
            }

            function remove(id) {
                if (scope.rowActionPaneVm.rowId === id) {
                    scope.rowActionPaneVm.isEditMode = false;
                    controller.disableAllAction(false);
                    controller.removeItem(id);
                }
            }

            // Listen to onEdit event
            // controller.onEditField(function (id, val) {
            //     

            //     if (id === scope.fieldEditorVm.rowId)
            //         scope.rowActionPaneVm.isEditMode = val;
            // });

        }
    }

})();
(function() {
    'use strict';

    angular.module('app.invoice')
        .directive('fieldEditorComponent', fieldEditorComponent);

    /** @ngInject */
    function fieldEditorComponent($log, exceptionService, _) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/reports/dialogs/edit-invoice/directives/editable-table/field-editor/field-editor.html',
            scope: {
                props: '=',
                srcModel: '=',
                rowId: '='
            },
            require: '^editableTableComponent',
            controller: FieldEditorController,
            controllerAs: 'fieldEditorVm',
            bindToController: true,
            link: link
        };

        return directive;

        function FieldEditorController() {
            var vm = this;

            vm.oldValue = this.srcModel;;
        }

        function link(scope, elems, attrs, controller) {
            scope.fieldEditorVm.isEditMode = false;

            scope.fieldEditorVm.onChange = onChange;

            // Listen to onEdit event
            controller.onEditField(function(id, val) {
                if (id === scope.fieldEditorVm.rowId) {
                    scope.fieldEditorVm.oldValue = scope.fieldEditorVm.srcModel;
                    scope.fieldEditorVm.isEditMode = val;
                }
            });

            controller.onCancelEdit(function(id) {
                if (id === scope.fieldEditorVm.rowId) {
                    scope.fieldEditorVm.isEditMode = false;
                    scope.fieldEditorVm.srcModel = scope.fieldEditorVm.oldValue;
                }
            });

            controller.onUpdateEdit(function(id) {
                if (id === scope.fieldEditorVm.rowId) {
                    scope.fieldEditorVm.isEditMode = false;
                    // Fire callback event    
                }
            });

            function onChange(colName) {
                if (!!scope.fieldEditorVm.props.observeOnChangeEvt) {
                    if (scope.fieldEditorVm.props.observeOnChangeEvt == true) {
                        controller.columnChange(colName, scope.fieldEditorVm.rowId);
                    }
                }
            }
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.invoice')
        .directive('addRowComponent', addRowComponent);

    /** @ngInject */
    function addRowComponent($log, exceptionService, _) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/reports/dialogs/edit-invoice/directives/editable-table/add-row/add-row.html',
            scope: {
                rowId: '='
            },
            require: '^editableTableComponent',
            controller: AddRowController,
            controllerAs: 'addRowVm',
            bindToController: true,
            link: link
        };

        return directive;

        function AddRowController() {
            var vm = this;
            vm.showAdd = true;
        }

        function link(scope, elems, attrs, controller) {

            scope.addRowVm.isActionDisabled = false;
            scope.addRowVm.add = add;

            function add() {
                controller.addNew(scope.addRowVm.rowId);
            }

            controller.onForceActionEdit(function(id) {
                scope.addRowVm.isActionDisabled = true;
            });

            controller.onCancelEdit(function(id) {
                scope.addRowVm.isActionDisabled = false;
            });

            controller.onUpdateEdit(function(id) {
                scope.addRowVm.isActionDisabled = false;
            });

            controller.onEditField(function(id) {
                scope.addRowVm.isActionDisabled = true;
            });

        }
    }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReadOnlyRow = function (_React$Component) {
    _inherits(ReadOnlyRow, _React$Component);

    function ReadOnlyRow(props) {
        _classCallCheck(this, ReadOnlyRow);

        var _this = _possibleConstructorReturn(this, (ReadOnlyRow.__proto__ || Object.getPrototypeOf(ReadOnlyRow)).call(this, props));

        _this.moveRow = _this.moveRow.bind(_this);
        _this.addLine = _this.addLine.bind(_this);
        _this.editLine = _this.editLine.bind(_this);
        _this.deleteLine = _this.deleteLine.bind(_this);
        _this.updateItem = _this.updateItem.bind(_this);
        _this.cancelLineEditing = _this.cancelLineEditing.bind(_this);
        _this.addComment = _this.addComment.bind(_this);
        _this.changeCheckSelection = _this.changeCheckSelection.bind(_this);
        _this.refreshRateCard = _this.refreshRateCard.bind(_this);
        _this.editTaxRate = _this.editTaxRate.bind(_this);
        _this.changeItemCode = _this.changeItemCode.bind(_this);
        return _this;
    }

    _createClass(ReadOnlyRow, [{
        key: 'moveRow',
        value: function moveRow(id) {
            alert('Move Row ' + id);
        }
    }, {
        key: 'addLine',
        value: function addLine(parentId) {
            this.props.onaddrow(parentId, 'entry');
        }
    }, {
        key: 'editLine',
        value: function editLine(id) {
            this.props.oneditrow(id);
        }
    }, {
        key: 'deleteLine',
        value: function deleteLine(id) {
            this.props.ondeleterow(id, this.props.item.Description);
        }

        /**
         * This will update the state list
         */

    }, {
        key: 'updateItem',
        value: function updateItem(data) {
            this.props.onupdateitem(data);
        }
    }, {
        key: 'cancelLineEditing',
        value: function cancelLineEditing(data) {
            this.props.oncancelrow(data);
        }
    }, {
        key: 'addComment',
        value: function addComment(parentId) {
            this.props.onaddrow(parentId, 'comment');
        }
    }, {
        key: 'changeCheckSelection',
        value: function changeCheckSelection(id) {
            this.props.onchangecheckselection(id);
        }
    }, {
        key: 'refreshRateCard',
        value: function refreshRateCard(id) {
            return this.props.onrefreshratecard(id);
        }
    }, {
        key: 'checkDescriptionControlType',
        value: function checkDescriptionControlType(data) {
            return this.props.checkdescriptioncontroltype(data);
        }
    }, {
        key: 'analyzeRowTypeType',
        value: function analyzeRowTypeType() {
            if (this.props.item.Quantity != null && this.props.item.UnitPriceExcludingTax != null) {
                if (_.isFinite(parseFloat(this.props.item.Quantity)) && _.isFinite(parseFloat(this.props.item.UnitPriceExcludingTax)) || _.isFinite(parseFloat(this.props.item.Quantity)) && _.isNaN(parseFloat(this.props.item.UnitPriceExcludingTax))) {
                    if (parseFloat(this.props.item.Quantity) !== 0) {
                        return 'entry';
                    }
                }
            }
            return 'comment';
        }
    }, {
        key: 'editTaxRate',
        value: function editTaxRate(data) {
            this.props.onedittaxrate(data);
        }
    }, {
        key: 'changeItemCode',
        value: function changeItemCode(data) {
            return this.props.onchangeitemcode(data);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var currentView;
            var movePartial;
            var editButtonPartial;
            var commentButtonPartial;
            var deleteButtonPartial;
            var insertButtonPartial;
            var rowStyle;
            var rowStyleDecimal;
            var checkboxPartial;
            var taxRatePartial;
            var costCodePartial;
            var itemDescriptionColSpan = 5;

            // Check action buttons availability
            if (self.props.item.isRowEnabled || _.isUndefined(self.props.item.isRowEnabled)) {
                movePartial = React.createElement('i', { className: 'moveHandle icon-drag s20 padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.moveRow.bind(this, self.props.item.Id) });
                insertButtonPartial = React.createElement('i', { className: 'icon-plus s20 padding-bottom-0 margin-bottom-0 clickable-item grey-600-fg', onClick: self.addLine.bind(this, self.props.item.Id) });
                commentButtonPartial = React.createElement('i', { className: 'icon-comment-text-outline s20 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.addComment.bind(this, self.props.item.Id) });
                editButtonPartial = React.createElement('i', { className: 'icon-pencil s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.editLine.bind(this, self.props.item.Id) });
                deleteButtonPartial = React.createElement('i', { className: 'icon-trash s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.deleteLine.bind(this, self.props.item.Id) });
                checkboxPartial = React.createElement('input', { type: 'checkbox', className: 'react-checkbox', checked: self.props.item.IsChecked, onChange: self.changeCheckSelection.bind(this, self.props.item.Id) });
                rowStyle = 'grey-600-fg';
                rowStyleDecimal = 'grey-600-fg text-right';
            } else {
                movePartial = React.createElement('i', { className: 'moveHandle icon-drag s20 padding-bottom-0 margin-bottom-0 grey-400-fg' });
                insertButtonPartial = React.createElement('i', { className: 'icon-plus s20 not-clickable-item padding-bottom-0 margin-bottom-0 grey-400-fg' });
                commentButtonPartial = React.createElement('i', { className: 'icon-comment-text-outline s20 not-clickable-item padding-bottom-0 margin-bottom-0 grey-400-fg' });
                editButtonPartial = React.createElement('i', { className: 'icon-pencil s18 not-clickable-item padding-bottom-0 margin-bottom-0 grey-400-fg' });
                deleteButtonPartial = React.createElement('i', { className: 'icon-trash s18 not-clickable-item padding-bottom-0 margin-bottom-0 grey-400-fg' });
                rowStyle = 'grey-400-fg';
                rowStyleDecimal = 'grey-400-fg text-right';
            }

            if (!self.props.isaltusspecialenabled) {
                if (!self.props.item.CostCode) {
                    costCodePartial = React.createElement(
                        'td',
                        null,
                        React.createElement(
                            'span',
                            { className: 'layout-row' },
                            React.createElement(
                                'span',
                                { className: 'material-icons md-18 amber600', style: { marginRight: "5px", paddingTop: "2px" } },
                                'warning'
                            ),
                            React.createElement(
                                'span',
                                { style: { color: "#ff8000", paddingTop: "3px" } },
                                'GL Code is missing'
                            )
                        )
                    );
                } else {
                    costCodePartial = React.createElement(
                        'td',
                        { className: rowStyle },
                        self.props.item.CostCode
                    );
                }

                itemDescriptionColSpan += 1;
            }

            // Identify row type
            var rowType = _.isUndefined(self.props.item.rowType) ? self.analyzeRowTypeType(self.props.item.rowType) : self.props.item.rowType;

            // Entry - means we have a full Line item transact
            // Comment - means comment only entry
            if (self.props.item.mode === 'R' && rowType == 'entry') {
                currentView = React.createElement(
                    'tr',
                    { key: self.props.uid, onDoubleClick: self.editLine.bind(this, self.props.item.Id) },
                    React.createElement(
                        'td',
                        null,
                        checkboxPartial,
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            insertButtonPartial
                        ),
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            commentButtonPartial
                        )
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyle },
                        self.props.item.Description
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyle },
                        self.props.item.ItemCodeDesc
                    ),
                    costCodePartial,
                    React.createElement(
                        'td',
                        { className: rowStyleDecimal },
                        self.props.item.Quantity
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyleDecimal },
                        self.props.item.UnitPriceExcludingTax
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyleDecimal },
                        self.props.item.Amount
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            editButtonPartial
                        ),
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            deleteButtonPartial
                        )
                    )
                );
            } else if (self.props.item.mode === 'R' && rowType == 'comment') {
                currentView = React.createElement(
                    'tr',
                    { key: self.props.uid, onDoubleClick: self.editLine.bind(this, self.props.item.Id) },
                    React.createElement(
                        'td',
                        null,
                        checkboxPartial,
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            insertButtonPartial
                        ),
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            commentButtonPartial
                        )
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyle, colSpan: itemDescriptionColSpan },
                        self.props.item.Description
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            editButtonPartial
                        ),
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            deleteButtonPartial
                        )
                    )
                );
            } else if ((self.props.item.mode === 'E' || self.props.item.mode === 'C') && rowType === 'entry') {
                // E = Edit and C = Create

                currentView = React.createElement(EditableRow, { uid: self.props.uid,
                    item: self.props.item,
                    ratecarditems: self.props.ratecarditems,
                    isaltusspecialenabled: self.props.isaltusspecialenabled,
                    itemcodes: self.props.itemcodes,
                    costcodes: self.props.costcodes,
                    onUpdateItem: self.updateItem.bind(this),
                    onCancelLine: self.cancelLineEditing.bind(this, self.props.item.Id),
                    onRefreshRateCard: self.refreshRateCard.bind(this),
                    checkDescriptionControlType: self.checkDescriptionControlType.bind(this),
                    localization: self.props.localization,
                    defaulttaxrate: self.props.defaulttaxrate,
                    onEditTaxRate: self.editTaxRate.bind(this),
                    taxroundingrule: self.props.taxroundingrule,
                    onChangeItemCode: self.changeItemCode.bind(this)
                });
            } else if ((self.props.item.mode === 'E' || self.props.item.mode === 'C') && rowType === 'comment') {

                currentView = React.createElement(CommentRow, { uid: self.props.uid,
                    item: self.props.item,
                    onUpdateItem: self.updateItem.bind(this),
                    onCancelLine: self.cancelLineEditing.bind(this, self.props.item.Id)
                });
            }

            return React.createElement(
                'tbody',
                null,
                currentView
            );
        }
    }]);

    return ReadOnlyRow;
}(React.Component);

ReadOnlyRow.propTypes = {
    uid: React.PropTypes.string.isRequired,
    item: React.PropTypes.object.isRequired,
    ratecarditems: React.PropTypes.array.isRequired,
    isaltusspecialenabled: React.PropTypes.bool.isRequired,
    costcodes: React.PropTypes.array.isRequired,
    itemcodes: React.PropTypes.array.isRequired,
    localization: React.PropTypes.string.isRequired,
    defaulttaxrate: React.PropTypes.number.isRequired,
    onaddrow: React.PropTypes.func.isRequired,
    oneditrow: React.PropTypes.func.isRequired,
    oncancelrow: React.PropTypes.func.isRequired,
    onupdateitem: React.PropTypes.func.isRequired,
    ondeleterow: React.PropTypes.func.isRequired,
    onchangecheckselection: React.PropTypes.func.isRequired,
    onrefreshratecard: React.PropTypes.func.isRequired,
    checkdescriptioncontroltype: React.PropTypes.func.isRequired,
    onedittaxrate: React.PropTypes.func.isRequired,
    taxroundingrule: React.PropTypes.string.isRequired,
    onchangeitemcode: React.PropTypes.func.isRequired
};
ReadOnlyRow.defaultProps = {
    item: null,
    uid: null,
    ratecarditems: [],
    costcodes: [],
    itemcodes: [],
    localization: 'AU',
    defaulttaxrate: 0,
    taxroundingrule: null,
    onaddrow: function onaddrow() {}, // noop
    oneditrow: function oneditrow() {},
    oncancelrow: function oncancelrow() {},
    onupdateitem: function onupdateitem() {},
    ondeleterow: function ondeleterow() {},
    onchangecheckselection: function onchangecheckselection() {},
    onrefreshratecard: function onrefreshratecard() {},
    checkdescriptioncontroltype: function checkdescriptioncontroltype() {},
    onedittaxrate: function onedittaxrate() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemCodes = function (_React$Component) {
    _inherits(ItemCodes, _React$Component);

    function ItemCodes(props) {
        _classCallCheck(this, ItemCodes);

        var _this = _possibleConstructorReturn(this, (ItemCodes.__proto__ || Object.getPrototypeOf(ItemCodes)).call(this, props));

        _this.state = {
            value: props.value
        };

        //this.handleChange = this.handleChange.bind(this);
        return _this;
    }

    _createClass(ItemCodes, [{
        key: 'componentDidMount',


        /**
        * ========================
        * React Life Cycle Events
        * ========================
        */
        value: function componentDidMount() {
            var self = this;
            this.$node = $('#' + this.componentId); //this.refs.select2);
            this.$node.select2({
                data: this.props.itemcodes,
                width: 'element',
                placeholder: "Select Item Code",
                templateResult: this.formatItems,
                allowClear: true
            });

            this.$node.on('change', function () {
                var $this = $(this);
                self.setValue($this.val());
            });

            // Set initial value
            this.$node.val(this.state.value);
            this.$node.trigger('change');
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Each time when component receives new props,
            // we should trigger refresh or perform anything else we need.
            // For this example, we'll update only the enable/disable option,
            // as soon as we receive a different value for this.props.enable
            //this.state.value
            if (nextProps.value !== this.props.value) {
                this.$node.val(nextProps.value);
                this.$node.trigger('change');
            }
        }
    }, {
        key: 'formatItems',
        value: function formatItems(obj) {
            return obj.text;
        }

        // handleChange(event) {
        //     this.setState({ value: event.target.value });
        //     this.props.itemchange(event.target.value);
        // }

    }, {
        key: 'setValue',
        value: function setValue(data) {
            this.setState({ value: data });
            this.props.itemchange(data);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;

            // var createSelectItems = function(itm) {
            //     return (
            //         <option value={itm.Id}>{itm.Description}</option>
            //     );
            // }

            // return (
            //     <select value={this.state.value} className="mousetrap input-control" onChange={this.handleChange}>
            //         {
            //             this.props.itemcodes.map(createSelectItems)
            //         }
            //     </select>
            // );
            self.componentId = _.uniqueId('selectItemCode');

            return React.createElement(
                'select',
                { id: self.componentId, className: 'invr-select-size' },
                React.createElement('option', null)
            );
        }
    }]);

    return ItemCodes;
}(React.Component);

ItemCodes.propTypes = {
    value: React.PropTypes.string.isRequired,
    itemcodes: React.PropTypes.array.isRequired,
    itemchange: React.PropTypes.func.isRequired
};
ItemCodes.defaultProps = {
    value: null,
    itemcodes: [],
    itemchange: function itemchange() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvoiceRateCardItemSelect = function (_React$Component) {
    _inherits(InvoiceRateCardItemSelect, _React$Component);

    function InvoiceRateCardItemSelect() {
        _classCallCheck(this, InvoiceRateCardItemSelect);

        return _possibleConstructorReturn(this, (InvoiceRateCardItemSelect.__proto__ || Object.getPrototypeOf(InvoiceRateCardItemSelect)).call(this));
        //this.onchangevalue = this.onchangevalue.bind(this);
    }

    _createClass(InvoiceRateCardItemSelect, [{
        key: 'componentDidMount',


        /**
         * ========================
         * React Life Cycle Events
         * ========================
         */
        value: function componentDidMount() {
            var self = this;

            this.$node = $('#' + this.componentId);
            this.$node.select2({
                data: this.props.data,
                templateResult: this.formatItems,
                templateSelection: this.formatSelectionItem,
                matcher: this.matchCustom,
                width: 'element',
                placeholder: "Select item rate",
                allowClear: true
            });

            this.$node.on('change', function () {
                var $this = $(this);
                if (_.isNil($this.val())) return;
                self.props.onchangevalue($this.val());
            });

            // Set initial value
            this.$node.val(this.props.value);
            this.$node.trigger('change');
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {}
        // Each time when component receives new props,
        // we should trigger refresh or perform anything else we need.
        // For this example, we'll update only the enable/disable option,
        // as soon as we receive a different value for this.props.enable
        // if (nextProps.enable !== this.props.enable) {
        //     this.$node.sortable(nextProps.enable ? 'enable' : 'disable');
        // }


        /**
         * Returns jquery template object
         * @param {*} obj
         */

    }, {
        key: 'formatItems',
        value: function formatItems(obj) {
            if (!obj.id || obj.id == -1) {
                return obj.text;
            }

            var $formattedObj = $('<div><div style="width: 80%; display: inline-block;">' + obj.text + '</div><div class="text-right" style="display: inline-block; width: 20%;">$' + obj.unitPrice.toFixed(2) + '</div></div>');
            return $formattedObj;
        }

        /**
         * Returns query template object
         * @param {*} obj
         */

    }, {
        key: 'formatSelectionItem',
        value: function formatSelectionItem(obj) {
            if (!obj.id || obj.id == -1 || obj.groupName == null) {
                //return obj.text;
                //return $('<strong>' + obj.text + '</strong>');
                return $('<span>' + obj.text + '</span>');
            }

            //return $('<strong> ' + obj.parentName + ' (' + obj.text + ') </strong>');
            // return $('<strong> ' + obj.lineItem + '</strong>');
            return $('<span> ' + obj.lineItem + '</span>');
        }
    }, {
        key: 'matchCustom',
        value: function matchCustom(params, data) {
            // If there are no search terms, return all of the data
            if ($.trim(params.term) === '') {
                return data;
            }

            // Do not display the item if there is no 'text' property
            if (typeof data.text === 'undefined') {
                return null;
            }

            // `params.term` should be the term that is used for searching
            // `data.text` is the text that is displayed for the data object
            if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
                var modifiedData = $.extend({}, data, true);
                modifiedData.text += ' (matched)';

                // You can return modified objects from here
                // This includes matching the `children` how you want in nested data sets
                return modifiedData;
            } else if (data.hasOwnProperty('children') && data.children.length > 0) {
                var findResults = _.filter(data.children, function (c) {
                    return c.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1;
                });

                if (findResults.length > 0) {
                    var modifiedData = $.extend({}, data, true);
                    modifiedData.text += ' (matched)';

                    return modifiedData;
                }
            }

            // Return `null` if the term should not be displayed
            return null;
        }

        // editInvoice(id) {
        //     this.props.oneditinvoice(id);
        // }

    }, {
        key: 'moneyFormat',
        value: function moneyFormat(number, decimalPlaces) {
            var parsedNumber = number;
            var isNegative = number < 0;

            var decimalPadding = function decimalPadding() {
                var tNum = ".";
                if (decimalPlaces > 0) {
                    for (var i = 0; i < decimalPlaces; i++) {
                        tNum += "0";
                    }
                } else {
                    tNum += "00";
                }
                return tNum;
            };

            if (!number || isNaN(number)) return "0" + decimalPadding();

            if (decimalPlaces > 0) {
                parsedNumber = number.toFixed(decimalPlaces);
            }

            var arr = parsedNumber.toString().split('.');
            var result = arr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            result += arr.length > 1 ? "." + arr[1] : decimalPadding();

            return result;
        }

        // renderItems(item) {
        // }

    }, {
        key: 'render',
        value: function render() {
            var self = this;
            self.componentId = _.uniqueId('select');

            return React.createElement(
                'select',
                { id: self.componentId, className: 'invr-select-size' },
                React.createElement('option', null),
                React.createElement(
                    'option',
                    { value: '-1' },
                    'Other Item'
                )
            );
        }
    }]);

    return InvoiceRateCardItemSelect;
}(React.Component);

//angular.module('app.invoice').value('InvoiceRateCardItemSelect', InvoiceRateCardItemSelect);


InvoiceRateCardItemSelect.propTypes = {
    data: React.PropTypes.array.isRequired,
    onchangevalue: React.PropTypes.func.isRequired
};
InvoiceRateCardItemSelect.defaultProps = {
    data: [],
    onchangevalue: function onchangevalue() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableRow = function (_React$Component) {
    _inherits(EditableRow, _React$Component);

    function EditableRow(props) {
        _classCallCheck(this, EditableRow);

        var _this = _possibleConstructorReturn(this, (EditableRow.__proto__ || Object.getPrototypeOf(EditableRow)).call(this, props));

        _this.updateLine = _this.updateLine.bind(_this);
        _this.cancelChangeLine = _this.cancelChangeLine.bind(_this);
        _this.descHandleModelChange = _this.descHandleModelChange.bind(_this);
        _this.onRateCardItemChange = _this.onRateCardItemChange.bind(_this);

        _this.unitPriceExcludingTaxHandleModelChange = _this.unitPriceExcludingTaxHandleModelChange.bind(_this);
        _this.quantityHandleModelChange = _this.quantityHandleModelChange.bind(_this);
        _this.itemCodeChange = _this.itemCodeChange.bind(_this);
        _this.costCodeChange = _this.costCodeChange.bind(_this);
        _this.itemGLCodeTextChange = _this.itemGLCodeTextChange.bind(_this);
        _this.editTaxRate = _this.editTaxRate.bind(_this);

        // =============
        // Build state
        // =============

        // Get Code by examining the description colum
        var rateCardItemObject = _this.getRateCardItemCode(props.item.Description);

        _this.state = {
            Id: props.item.Id,
            Description: props.item.Description,
            CostCode: _.isNull(props.item.CostCode) || _.isUndefined(props.item.CostCode) ? '' : props.item.CostCode,
            ItemCode: _.isNull(props.item.ItemCode) || _.isUndefined(props.item.ItemCode) ? '-1' : props.item.ItemCode,
            Quantity: props.item.Quantity,
            UnitPriceExcludingTax: props.item.UnitPriceExcludingTax,
            UnitTax: props.item.UnitTax,
            TotalTax: props.item.TotalTax,
            Amount: props.item.Amount,
            TaxRate: props.item.TaxRate, // Combined tax rate
            CityTaxRate: props.item.CityTaxRate,
            CountyTaxRate: props.item.CountyTaxRate,
            StateSalesTaxRate: props.item.StateSalesTaxRate,
            SpecialTaxRate: props.item.SpecialTaxRate,
            HasError: false,
            DescError: '',
            QtyError: '',
            UnitPriceError: '',
            CostCodeError: '',
            ItemCodeError: '',
            RateCardItemMode: _.isUndefined(rateCardItemObject) ? true : rateCardItemObject.RateCardItemMode,
            RateCardItemCode: _.isUndefined(rateCardItemObject) ? null : rateCardItemObject.RateCardItemCode,
            IsInitialLoad: true,
            IsPreventReplacingUnitPrice: false
        };
        return _this;
    }

    _createClass(EditableRow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var self = this;
            // Setup shortcut keys
            window.Mousetrap.bind('enter', function (e) {
                self.updateLine(self.state.Id);
            });

            window.Mousetrap.bind('esc', function (e) {
                self.cancelChangeLine(self.state.Id);
            });

            // Mark initial component loading completed
            this.setState({ IsInitialLoad: false });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.Mousetrap.unbind('enter');
            window.Mousetrap.unbind('esc');
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Each time when component receives new props,
            // we should trigger refresh or perform anything else we need.
            // For this example, we'll update only the enable/disable option,
            // as soon as we receive a different value for this.props.enable
            //this.state.value
            var self = this;

            if (nextProps.item.TaxRate !== this.props.item.TaxRate) this.setState({ TaxRate: nextProps.item.TaxRate }, function () {
                self.compute(self.state);
            });
            if (nextProps.item.CityTaxRate !== this.props.item.CityTaxRate) this.setState({ CityTaxRate: nextProps.item.CityTaxRate }, function () {
                self.compute(self.state);
            });
            if (nextProps.item.StateSalesTaxRate !== this.props.item.StateSalesTaxRate) this.setState({ StateSalesTaxRate: nextProps.item.StateSalesTaxRate }, function () {
                self.compute(self.state);
            });
            if (nextProps.item.SpecialTaxRate !== this.props.item.SpecialTaxRate) this.setState({ SpecialTaxRate: nextProps.item.SpecialTaxRate }, function () {
                self.compute(self.state);
            });
            if (nextProps.item.CountyTaxRate !== this.props.item.CountyTaxRate) this.setState({ CountyTaxRate: nextProps.item.CountyTaxRate }, function () {
                self.compute(self.state);
            });
        }
    }, {
        key: 'updateLine',
        value: function updateLine(id) {
            if (this.validate()) {
                this.props.onUpdateItem(this.state);
            }
        }
    }, {
        key: 'cancelChangeLine',
        value: function cancelChangeLine(id) {
            this.props.onCancelLine(this.state);
        }
    }, {
        key: 'descHandleModelChange',
        value: function descHandleModelChange(e) {
            this.validateDescription(e.target.value);
            this.setState({ Description: e.target.value });
        }
    }, {
        key: 'quantityHandleModelChange',
        value: function quantityHandleModelChange(e) {
            var value = e.target.value;

            this.setState({
                Quantity: value
            }, function () {
                this.validateUnitPriceAndQty(value, this.state.UnitPriceExcludingTax);
                this.compute(this.state);
            });
        }
    }, {
        key: 'unitPriceExcludingTaxHandleModelChange',
        value: function unitPriceExcludingTaxHandleModelChange(e) {
            var value = e.target.value;

            this.setState({
                UnitPriceExcludingTax: value
            }, function () {
                this.validateUnitPriceAndQty(this.state.Quantity, value);
                this.compute(this.state);
            });
        }
    }, {
        key: 'costCodeChange',
        value: function costCodeChange(data) {
            this.setState({
                CostCode: data
            });
        }
    }, {
        key: 'itemGLCodeTextChange',
        value: function itemGLCodeTextChange(e) {
            this.setState({
                ItemCode: '',
                CostCode: e.target.value
            });
        }
    }, {
        key: 'itemCodeChange',
        value: function itemCodeChange(data) {
            this.validateItemCode(data);
            this.setState({ ItemCode: data });
        }
    }, {
        key: 'performCleanupBeforeChangingMode',
        value: function performCleanupBeforeChangingMode() {
            this.setState({
                Description: '',
                ItemCode: this.props.isaltusspecialenabled ? '-1' : '',
                CostCode: '',
                Quantity: '',
                UnitPriceExcludingTax: '',
                HasError: false,
                DescError: '',
                QtyError: '',
                UnitPriceError: '',
                CostCodeError: '',
                ItemCodeError: '',
                UnitTax: '',
                TotalTax: '',
                Amount: ''
            });
        }
    }, {
        key: 'onRateCardItemChange',
        value: function onRateCardItemChange(id) {
            // It means the user selected "Other Item" option
            // Change control/component to Description textbox with item code dropdown
            if (id === "-1") {
                this.setState({ RateCardItemMode: false }); //isRateCardItemVisible: false
                this.performCleanupBeforeChangingMode();
                return;
            }

            var rateCardItemSelected = this.props.onRefreshRateCard(id);
            if (rateCardItemSelected == null) {
                this.setState({ Description: '' });
                return;
            }

            this.setState({ Description: rateCardItemSelected.lineItem, RateCardItemCode: rateCardItemSelected.id }, function () {
                this.validateDescription(this.state.Description);
            });

            this.setState({ ItemCode: rateCardItemSelected.glItemCode }, function () {
                this.validateItemCode(rateCardItemSelected.glItemCode);
            });

            if (this.state.CostCode == '') {
                this.setState({ CostCode: rateCardItemSelected.glAccountCode }, function () {
                    this.validateCostCode(rateCardItemSelected.glAccountCode);
                });
            }

            if (!this.state.IsInitialLoad) {
                this.setState({ UnitPriceExcludingTax: rateCardItemSelected.unitPrice }, function () {
                    this.validateUnitPriceAndQty(this.state.Quantity, rateCardItemSelected.unitPrice);
                    this.compute(this.state);
                });
            }

            this.setState({ ItemId: rateCardItemSelected.itemId, ItemType: rateCardItemSelected.itemType });
        }
    }, {
        key: 'getRateCardItemCode',
        value: function getRateCardItemCode(data) {
            if (this.props.ratecarditems.length <= 0) {
                return {
                    RateCardItemMode: false,
                    RateCardItemCode: null
                };
            }

            if (_.isNil(data) || _.isEmpty(data)) {
                return;
            }

            var controlType = this.props.checkDescriptionControlType(data);
            var isRateCardItemControl = controlType.type == 'rate-card-item-control';

            return {
                RateCardItemMode: isRateCardItemControl,
                RateCardItemCode: controlType.id
            };
        }
    }, {
        key: 'compute',
        value: function compute(itm) {
            var DEFAULT_FRACTION_DIGITS = 2;

            var fractionDigits = DEFAULT_FRACTION_DIGITS;

            if (this.props.taxroundingrule == "TotalInvoiceRule") {
                fractionDigits = 4;
            }

            if (_.isFinite(parseFloat(this.state.UnitPriceExcludingTax)) && _.isFinite(parseFloat(this.state.Quantity))) {
                var taxAmt, taxRate, unitTax;

                itm.TaxRate = this.props.TaxRate == undefined || this.props.TaxRate == null || this.props.TaxRate.length <= 0 || this.props.TaxRate === 0 ? this.props.defaulttaxrate : itm.TaxRate;

                if (parseFloat(itm.Quantity) < 0) {
                    itm.UnitPriceExcludingTax = Math.abs(itm.UnitPriceExcludingTax);
                }

                taxRate = itm.TaxRate / 100;
                unitTax = parseFloat(itm.UnitPriceExcludingTax) * taxRate;
                taxAmt = parseFloat(itm.Quantity) * parseFloat(itm.UnitPriceExcludingTax) * taxRate;

                itm.UnitTax = this.round(unitTax, fractionDigits);
                itm.TotalTax = this.round(taxAmt, fractionDigits);
                itm.Amount = this.round(parseFloat(parseFloat(itm.Quantity) * parseFloat(itm.UnitPriceExcludingTax)), 2);
            } else {
                itm.UnitTax = this.round(parseFloat(0), fractionDigits);
                itm.TotalTax = this.round(parseFloat(0), fractionDigits);
                itm.Amount = this.round(parseFloat(0), 2);
            }

            this.setState({ UnitTax: itm.UnitTax });
            this.setState({ TotalTax: itm.TotalTax });
            this.setState({ Amount: itm.Amount });
        }
    }, {
        key: 'validate',
        value: function validate() {
            var isValid = this.validateDescription(this.state.Description);
            if (!isValid) {
                this.setState({ HasError: !isValid });
                return isValid;
            }

            if (!this.state.RateCardItemMode) {
                isValid = this.validateItemCode(this.state.ItemCode);
                if (!isValid) {
                    this.setState({ HasError: !isValid });
                    return isValid;
                }
            }

            isValid = this.validateUnitPriceAndQty(this.state.Quantity, this.state.UnitPriceExcludingTax);
            if (!isValid) {
                this.setState({ HasError: !isValid });
                return isValid;
            }

            this.setState({ HasError: false });

            return isValid;
        }
    }, {
        key: 'validateDescription',
        value: function validateDescription(value) {
            this.setState({ DescError: '' });

            if (_.isNull(value) || _.isUndefined(value) || value.length <= 0) {
                this.setState({ DescError: 'Description is required.' });
                return false;
            }

            return true;
        }
    }, {
        key: 'validateQty',
        value: function validateQty(value) {
            this.setState({ QtyError: '' });

            if (_.isNull(value) || !_.isFinite(parseFloat(value)) || isNaN(value)) {
                this.setState({ QtyError: 'Quantity is required.' });
                return false;
            }

            if (parseFloat(value) == 0) {
                this.setState({ QtyError: 'Zero (0) value is not a valid Quantity.' });
                return false;
            }

            return true;
        }
    }, {
        key: 'validateUnitPrice',
        value: function validateUnitPrice(value) {
            this.setState({ UnitPriceError: '' });

            if (_.isNull(value) || !_.isFinite(parseFloat(value)) || isNaN(value)) {
                this.setState({ UnitPriceError: 'Unit Price is required.' });
                return false;
            }

            if (parseFloat(value) == 0) {
                this.setState({ UnitPriceError: 'Zero (0) value is not a valid UnitPriceExcludingTax.' });
                return false;
            }

            return true;
        }
    }, {
        key: 'validateUnitPriceAndQty',
        value: function validateUnitPriceAndQty(qty, unitPrice) {
            this.setState({ QtyError: '' });
            this.setState({ UnitPriceError: '' });

            var qtyValue = _.isNaN(parseFloat(qty)) ? 0 : parseFloat(qty);
            var unitPriceValue = _.isNaN(parseFloat(unitPrice)) ? 0 : parseFloat(unitPrice);

            if (qty == null || qty.length <= 0) {
                this.setState({ QtyError: 'Quantity is required.' });
                return false;
            }

            if (unitPrice == null || unitPrice.length <= 0) {
                this.setState({ UnitPriceError: 'Unit Price is required.' });
                return false;
            }

            if (qtyValue === 0 && unitPriceValue !== 0) {
                this.setState({ QtyError: 'Invalid Quantity.' });
                return false;
            }

            if (qtyValue === 0 && unitPriceValue === 0) {
                this.setState({ QtyError: 'Quantity is required.' });
                this.setState({ UnitPriceError: 'Unit Price is required.' });
                return false;
            }

            return true;
        }
    }, {
        key: 'validateCostCode',
        value: function validateCostCode(value) {
            this.setState({ CostCodeError: '' });

            var isCostCodeMissing = _.isNull(value) || value == '-1' || _.isUndefined(value);
            if (!isCostCodeMissing) {
                return true;
            }

            this.setState({ CostCodeError: 'Cost Code is required.' });
            return false;
        }
    }, {
        key: 'validateItemCode',
        value: function validateItemCode(value) {
            this.setState({ ItemCodeError: '' });

            var isItemCodeMissing = _.isNull(value) || value == '-1' || _.isUndefined(value) || _.isEmpty(value);
            var isItemCodeRequired = isItemCodeMissing && this.props.isaltusspecialenabled;
            if (!isItemCodeRequired) {
                return true;
            }

            this.setState({ ItemCodeError: 'Item Code is required.' });
            return false;
        }
    }, {
        key: 'editTaxRate',
        value: function editTaxRate(id) {
            // Dont allow to override unit price if coming from Tax rate dialog
            this.setState({ IsPreventReplacingUnitPrice: true });

            this.props.onEditTaxRate({
                Id: id,
                TaxRate: this.state.TaxRate, // Combined tax rate
                CityTaxRate: this.state.CityTaxRate,
                CountyTaxRate: this.state.CountyTaxRate,
                StateSalesTaxRate: this.state.StateSalesTaxRate,
                SpecialTaxRate: this.state.SpecialTaxRate
            });
        }
    }, {
        key: 'round',
        value: function round(value, decimals) {
            var numberOfDecimalPlaces = 1;

            switch (decimals) {
                case 2:
                    numberOfDecimalPlaces = 100;
                    break;
                case 3:
                    numberOfDecimalPlaces = 1000;
                    break;
                case 4:
                    numberOfDecimalPlaces = 10000;
                    break;
                default:
                    numberOfDecimalPlaces = 1;
                    break;
            }

            return Number(Math.round(value * numberOfDecimalPlaces) / numberOfDecimalPlaces);
        }
    }, {
        key: 'itemCodeChange',
        value: function itemCodeChange(data) {
            var selectedItemCodeGLCode = this.props.onChangeItemCode(data);

            if (!(_.isNil(selectedItemCodeGLCode) || _.isEmpty(selectedItemCodeGLCode))) {

                this.setState({ CostCode: selectedItemCodeGLCode }, function () {
                    this.validateCostCode(selectedItemCodeGLCode);
                });
            }

            this.validateItemCode(data);
            this.setState({
                ItemCode: data
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var descriptionPartial = void 0;
            var descriptionPartial2 = void 0;
            var taxRatePartial = void 0;

            if (this.state.RateCardItemMode) {
                descriptionPartial = React.createElement(InvoiceRateCardItemSelect, { data: self.props.ratecarditems, value: self.state.RateCardItemCode, onchangevalue: self.onRateCardItemChange });
            } else {
                $('#rateCardItemDiv').hide();
                descriptionPartial2 = React.createElement('input', { type: 'text', value: self.state.Description, className: 'mousetrap input-control', onChange: self.descHandleModelChange });
            }

            return React.createElement(
                'tr',
                { key: this.props.uid },
                React.createElement('td', null),
                React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        React.createElement(
                            'div',
                            { id: 'rateCardItemDiv' },
                            descriptionPartial
                        ),
                        React.createElement(
                            'div',
                            null,
                            descriptionPartial2
                        )
                    ),
                    this.state.HasError && React.createElement(
                        'div',
                        { className: 'red-600-fg font-size-10' },
                        this.state.DescError
                    )
                ),
                React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        this.state.RateCardItemMode && this.state.ItemCode != "" && React.createElement(
                            'span',
                            null,
                            React.createElement(ItemCodes, { itemcodes: this.props.itemcodes, value: this.state.ItemCode, itemchange: this.itemCodeChange })
                        ),
                        this.state.RateCardItemMode && this.state.ItemCode == "" && React.createElement(
                            'span',
                            null,
                            'N/A'
                        ),
                        !this.state.RateCardItemMode && this.props.isaltusspecialenabled && React.createElement(
                            'span',
                            null,
                            React.createElement(ItemCodes, { itemcodes: this.props.itemcodes, value: this.state.ItemCode, itemchange: this.itemCodeChange })
                        ),
                        !this.state.RateCardItemMode && !this.props.isaltusspecialenabled && React.createElement(
                            'span',
                            null,
                            'N/A'
                        )
                    ),
                    React.createElement(
                        'div',
                        null,
                        this.state.HasError && React.createElement(
                            'div',
                            { className: 'red-600-fg font-size-10' },
                            this.state.ItemCodeError
                        )
                    )
                ),
                !this.props.isaltusspecialenabled && React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        React.createElement(
                            'span',
                            null,
                            React.createElement('input', { type: 'text', value: self.state.CostCode, className: 'mousetrap input-control', placeholder: 'Enter GL Code', onChange: self.itemGLCodeTextChange })
                        )
                    )
                ),
                React.createElement(
                    'td',
                    { className: 'text-rightx' },
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        React.createElement('input', { type: 'text', value: self.state.Quantity, className: 'mousetrap input-control', onChange: self.quantityHandleModelChange })
                    ),
                    this.state.HasError && React.createElement(
                        'div',
                        { className: 'red-600-fg font-size-10' },
                        this.state.QtyError
                    )
                ),
                React.createElement(
                    'td',
                    { className: 'text-rightx' },
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        React.createElement('input', { type: 'text', value: self.state.UnitPriceExcludingTax, className: 'mousetrap input-control', onChange: self.unitPriceExcludingTaxHandleModelChange })
                    ),
                    this.state.HasError && React.createElement(
                        'div',
                        { className: 'red-600-fg font-size-10' },
                        this.state.UnitPriceError
                    )
                ),
                React.createElement(
                    'td',
                    { className: 'text-right' },
                    self.state.Amount
                ),
                React.createElement(
                    'td',
                    { className: 'text-right' },
                    React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                        React.createElement('i', { className: 'icon-check s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.updateLine.bind(this, self.props.item.Id) })
                    ),
                    React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                        React.createElement('i', { className: 'icon-cancel s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.cancelChangeLine.bind(this, self.props.item.Id) })
                    )
                )
            );
        }
    }]);

    return EditableRow;
}(React.Component);

EditableRow.propTypes = {
    uid: React.PropTypes.string.isRequired,
    item: React.PropTypes.object.isRequired,
    ratecarditems: React.PropTypes.array.isRequired,
    isaltusspecialenabled: React.PropTypes.bool.isRequired,
    itemcodes: React.PropTypes.array.isRequired,
    costcodes: React.PropTypes.array.isRequired,
    localization: React.PropTypes.string.isRequired,
    defaulttaxrate: React.PropTypes.number.isRequired,
    onUpdateItem: React.PropTypes.func.isRequired,
    onCancelLine: React.PropTypes.func.isRequired,
    onRefreshRateCard: React.PropTypes.func.isRequired,
    checkDescriptionControlType: React.PropTypes.func.isRequired, // Use to determine the exact control type for the edited row item (fires an event outside)
    onEditTaxRate: React.PropTypes.func.isRequired,
    taxroundingrule: React.PropTypes.string.isRequired,
    onChangeItemCode: React.PropTypes.func.isRequired
};
EditableRow.defaultProps = {
    item: null,
    uid: null,
    ratecarditems: [],
    itemcodes: [],
    costcodes: [],
    localization: 'AU',
    defaulttaxrate: 0,
    taxroundingrule: 'TaxableSupplyRule',
    onUpdateItem: function onUpdateItem() {}, // noop
    onCancelLine: function onCancelLine() {},
    onRefreshRateCard: function onRefreshRateCard() {},
    checkDescriptionControlType: function checkDescriptionControlType() {},
    onEditTaxRate: function onEditTaxRate() {},
    onChangeItemCode: function onChangeItemCode() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CostCodes = function (_React$Component) {
    _inherits(CostCodes, _React$Component);

    function CostCodes(props) {
        _classCallCheck(this, CostCodes);

        var _this = _possibleConstructorReturn(this, (CostCodes.__proto__ || Object.getPrototypeOf(CostCodes)).call(this, props));

        _this.state = {
            value: props.value
        };

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(CostCodes, [{
        key: "handleChange",
        value: function handleChange(event) {
            this.setState({ value: event.target.value });
            this.props.itemchange(event.target.value);
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("input", { type: "text", value: this.state.value, className: "mousetrap input-control", onChange: this.handleChange });
        }
    }]);

    return CostCodes;
}(React.Component);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentRow = function (_React$Component) {
    _inherits(CommentRow, _React$Component);

    function CommentRow(props) {
        _classCallCheck(this, CommentRow);

        var _this = _possibleConstructorReturn(this, (CommentRow.__proto__ || Object.getPrototypeOf(CommentRow)).call(this, props));

        _this.updateLine = _this.updateLine.bind(_this);
        _this.cancelChangeLine = _this.cancelChangeLine.bind(_this);
        _this.descHandleModelChange = _this.descHandleModelChange.bind(_this);

        // Build state
        _this.state = {
            Id: props.item.Id,
            Description: props.item.Description,
            CostCode: '-1',
            ItemCode: '-1',
            Quantity: 0,
            UnitPriceExcludingTax: 0,
            UnitTax: 0,
            Amount: 0,
            TaxRate: 0,
            HasError: false,
            DescError: '',
            QtyError: '',
            UnitPriceError: '',
            CostCodeError: '',
            ItemCodeError: ''
        };
        return _this;
    }

    _createClass(CommentRow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var self = this;
            // Setup shortcut keys
            window.Mousetrap.bind('enter', function (e) {
                self.updateLine(self.state.Id);
            });

            window.Mousetrap.bind('esc', function (e) {
                self.cancelChangeLine(self.state.Id);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.Mousetrap.unbind('enter');
            window.Mousetrap.unbind('esc');
        }
    }, {
        key: 'updateLine',
        value: function updateLine(id) {
            if (_.isNull(this.state.Description) || _.isUndefined(this.state.Description) || this.state.Description.length == 0) {
                this.setState({ Description: ' ' }, function () {
                    this.props.onUpdateItem(this.state);
                });
            } else {
                this.props.onUpdateItem(this.state);
            }
        }
    }, {
        key: 'cancelChangeLine',
        value: function cancelChangeLine(id) {
            this.props.onCancelLine(this.state);
        }
    }, {
        key: 'descHandleModelChange',
        value: function descHandleModelChange(e) {
            this.setState({ Description: e.target.value });
        }

        /**
         * Returns TRUE if valid state
         */

    }, {
        key: 'validate',
        value: function validate() {
            var isError = false;
            this.setState({ DescError: '' });

            if (_.isNull(this.state.Description) || _.isUndefined(this.state.Description) || this.state.Description.length <= 0) {
                this.setState({ DescError: 'Comment is required.' });
                isError = true;
            }

            this.setState({ HasError: isError });
            return !isError;
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var itemDescriptionColSpan = 6;

            if (!self.props.isaltusspecialenabled) {
                itemDescriptionColSpan += 1;
            }

            return React.createElement(
                'tr',
                { key: this.props.uid },
                React.createElement('td', null),
                React.createElement(
                    'td',
                    { colSpan: itemDescriptionColSpan },
                    React.createElement('input', { type: 'text', value: self.state.Description, className: 'mousetrap input-control', onChange: self.descHandleModelChange }),
                    this.state.HasError && React.createElement(
                        'div',
                        { className: 'red-600-fg font-size-10' },
                        this.state.DescError
                    )
                ),
                React.createElement(
                    'td',
                    { className: 'text-right' },
                    React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                        React.createElement('i', { className: 'icon-check s18 s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.updateLine.bind(this, self.props.item.Id) })
                    ),
                    React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                        React.createElement('i', { className: 'icon-cancel s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.cancelChangeLine.bind(this, self.props.item.Id) })
                    )
                )
            );
        }
    }]);

    return CommentRow;
}(React.Component);

CommentRow.propTypes = {
    uid: React.PropTypes.string.isRequired,
    item: React.PropTypes.object.isRequired,
    onUpdateItem: React.PropTypes.func.isRequired,
    onCancelLine: React.PropTypes.func.isRequired
};
CommentRow.defaultProps = {
    item: null,
    uid: null,
    onUpdateItem: function onUpdateItem() {}, // noop
    onCancelLine: function onCancelLine() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CeReadOnlyRow = function (_React$Component) {
    _inherits(CeReadOnlyRow, _React$Component);

    function CeReadOnlyRow(props) {
        _classCallCheck(this, CeReadOnlyRow);

        var _this = _possibleConstructorReturn(this, (CeReadOnlyRow.__proto__ || Object.getPrototypeOf(CeReadOnlyRow)).call(this, props));

        _this.moveRow = _this.moveRow.bind(_this);
        _this.addLine = _this.addLine.bind(_this);
        _this.editLine = _this.editLine.bind(_this);
        _this.deleteLine = _this.deleteLine.bind(_this);
        _this.updateItem = _this.updateItem.bind(_this);
        _this.cancelLineEditing = _this.cancelLineEditing.bind(_this);
        _this.addComment = _this.addComment.bind(_this);
        _this.changeCheckSelection = _this.changeCheckSelection.bind(_this);
        _this.refreshRateCard = _this.refreshRateCard.bind(_this);
        _this.editTaxRate = _this.editTaxRate.bind(_this);
        _this.changeItemCode = _this.changeItemCode.bind(_this);
        return _this;
    }

    _createClass(CeReadOnlyRow, [{
        key: 'moveRow',
        value: function moveRow(id) {
            alert('Move Row ' + id);
        }
    }, {
        key: 'addLine',
        value: function addLine(parentId) {
            this.props.onaddrow(parentId, 'entry');
        }
    }, {
        key: 'editLine',
        value: function editLine(id) {
            this.props.oneditrow(id);
        }
    }, {
        key: 'deleteLine',
        value: function deleteLine(id) {
            this.props.ondeleterow(id, this.props.item.Description);
        }

        /**
         * This will update the state list
         */

    }, {
        key: 'updateItem',
        value: function updateItem(data) {
            this.props.onupdateitem(data);
        }
    }, {
        key: 'cancelLineEditing',
        value: function cancelLineEditing(data) {
            this.props.oncancelrow(data);
        }
    }, {
        key: 'addComment',
        value: function addComment(parentId) {
            this.props.onaddrow(parentId, 'comment');
        }
    }, {
        key: 'changeCheckSelection',
        value: function changeCheckSelection(id) {
            this.props.onchangecheckselection(id);
        }
    }, {
        key: 'refreshRateCard',
        value: function refreshRateCard(id) {
            return this.props.onrefreshratecard(id);
        }
    }, {
        key: 'checkDescriptionControlType',
        value: function checkDescriptionControlType(data) {
            return this.props.checkdescriptioncontroltype(data);
        }
    }, {
        key: 'analyzeRowTypeType',
        value: function analyzeRowTypeType() {
            if (this.props.item.Quantity != null && this.props.item.UnitPriceExcludingTax != null) {
                if (_.isFinite(parseFloat(this.props.item.Quantity)) && _.isFinite(parseFloat(this.props.item.UnitPriceExcludingTax)) || _.isFinite(parseFloat(this.props.item.Quantity)) && _.isNaN(parseFloat(this.props.item.UnitPriceExcludingTax))) {
                    if (parseFloat(this.props.item.Quantity) !== 0) {
                        // && parseFloat(this.props.item.UnitPriceExcludingTax) !== 0) {
                        return 'entry';
                    }
                }
            }
            return 'comment';
        }
    }, {
        key: 'editTaxRate',
        value: function editTaxRate(data) {
            this.props.onedittaxrate(data);
        }
    }, {
        key: 'changeItemCode',
        value: function changeItemCode(data) {
            return this.props.onchangeitemcode(data);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var currentView;
            var editButtonPartial;
            var commentButtonPartial;
            var deleteButtonPartial;
            var insertButtonPartial;
            var rowStyle;
            var rowStyleDecimal;
            var checkboxPartial;
            var itemDescriptionColSpan = 5;
            var costCodePartial;

            // Check action buttons availability
            if (self.props.item.isRowEnabled || _.isUndefined(self.props.item.isRowEnabled)) {
                insertButtonPartial = React.createElement('i', { className: 'icon-plus s20 padding-bottom-0 margin-bottom-0 clickable-item grey-600-fg', onClick: self.addLine.bind(this, self.props.item.Id) });
                commentButtonPartial = React.createElement('i', { className: 'icon-comment-text-outline s20 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.addComment.bind(this, self.props.item.Id) });
                editButtonPartial = React.createElement('i', { className: 'icon-pencil s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.editLine.bind(this, self.props.item.Id) });
                deleteButtonPartial = React.createElement('i', { className: 'icon-trash s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.deleteLine.bind(this, self.props.item.Id) });
                checkboxPartial = React.createElement('input', { type: 'checkbox', className: 'react-checkbox', checked: self.props.item.IsChecked, onChange: self.changeCheckSelection.bind(this, self.props.item.Id) });
                rowStyle = 'grey-600-fg';
                rowStyleDecimal = 'grey-600-fg text-right';
            } else {
                insertButtonPartial = React.createElement('i', { className: 'icon-plus s20 not-clickable-item padding-bottom-0 margin-bottom-0 grey-400-fg' });
                commentButtonPartial = React.createElement('i', { className: 'icon-comment-text-outline s20 not-clickable-item padding-bottom-0 margin-bottom-0 grey-400-fg' });
                editButtonPartial = React.createElement('i', { className: 'icon-pencil s18 not-clickable-item padding-bottom-0 margin-bottom-0 grey-400-fg' });
                deleteButtonPartial = React.createElement('i', { className: 'icon-trash s18 not-clickable-item padding-bottom-0 margin-bottom-0 grey-400-fg' });
                rowStyle = 'grey-400-fg';
                rowStyleDecimal = 'grey-400-fg text-right';
            }

            if (!self.props.isaltusspecialenabled) {
                costCodePartial = React.createElement(
                    'td',
                    { className: rowStyle },
                    self.props.item.CostCode
                );
                itemDescriptionColSpan += 1;
            }

            // Identify row type
            var rowType = _.isUndefined(self.props.item.rowType) ? self.analyzeRowTypeType(self.props.item.rowType) : self.props.item.rowType;

            // Entry - means we have a full Line item transact
            // Comment - means comment only entry
            if (self.props.item.mode === 'R' && rowType == 'entry') {
                currentView = React.createElement(
                    'tr',
                    { key: self.props.uid, onDoubleClick: self.editLine.bind(this, self.props.item.Id) },
                    React.createElement(
                        'td',
                        null,
                        checkboxPartial,
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            insertButtonPartial
                        ),
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            commentButtonPartial
                        )
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyle },
                        self.props.item.Description
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyle },
                        self.props.item.ItemCodeDesc
                    ),
                    costCodePartial,
                    React.createElement(
                        'td',
                        { className: rowStyleDecimal },
                        self.props.item.Quantity
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyleDecimal },
                        self.props.item.UnitPriceExcludingTax
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyleDecimal },
                        self.props.item.Amount
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            editButtonPartial
                        ),
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            deleteButtonPartial
                        )
                    )
                );
            } else if (self.props.item.mode === 'R' && rowType == 'comment') {
                currentView = React.createElement(
                    'tr',
                    { key: self.props.uid, onDoubleClick: self.editLine.bind(this, self.props.item.Id) },
                    React.createElement(
                        'td',
                        null,
                        checkboxPartial,
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            insertButtonPartial
                        ),
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            commentButtonPartial
                        )
                    ),
                    React.createElement(
                        'td',
                        { className: rowStyle, colSpan: itemDescriptionColSpan },
                        self.props.item.Description
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            editButtonPartial
                        ),
                        React.createElement(
                            'span',
                            { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                            deleteButtonPartial
                        )
                    )
                );
            } else if ((self.props.item.mode === 'E' || self.props.item.mode === 'C') && rowType === 'entry') {
                // E = Edit and C = Create

                currentView = React.createElement(CeEditableRow, { uid: self.props.uid,
                    item: self.props.item,
                    ratecarditems: self.props.ratecarditems,
                    isaltusspecialenabled: self.props.isaltusspecialenabled,
                    itemcodes: self.props.itemcodes,
                    costcodes: self.props.costcodes,
                    onUpdateItem: self.updateItem.bind(this),
                    onCancelLine: self.cancelLineEditing.bind(this, self.props.item.Id),
                    onRefreshRateCard: self.refreshRateCard.bind(this),
                    checkDescriptionControlType: self.checkDescriptionControlType.bind(this),
                    localization: self.props.localization,
                    defaulttaxrate: self.props.defaulttaxrate,
                    onEditTaxRate: self.editTaxRate.bind(this),
                    onChangeItemCode: self.changeItemCode.bind(this)
                });
            } else if ((self.props.item.mode === 'E' || self.props.item.mode === 'C') && rowType === 'comment') {

                currentView = React.createElement(CeCommentRow, { uid: self.props.uid,
                    item: self.props.item,
                    onUpdateItem: self.updateItem.bind(this),
                    onCancelLine: self.cancelLineEditing.bind(this, self.props.item.Id)
                });
            }

            return React.createElement(
                'tbody',
                null,
                currentView
            );
        }
    }]);

    return CeReadOnlyRow;
}(React.Component);

CeReadOnlyRow.propTypes = {
    uid: React.PropTypes.string.isRequired,
    item: React.PropTypes.object.isRequired,
    ratecarditems: React.PropTypes.array.isRequired,
    isaltusspecialenabled: React.PropTypes.bool.isRequired,
    costcodes: React.PropTypes.array.isRequired,
    itemcodes: React.PropTypes.array.isRequired,
    localization: React.PropTypes.string.isRequired,
    defaulttaxrate: React.PropTypes.number.isRequired,
    onaddrow: React.PropTypes.func.isRequired,
    oneditrow: React.PropTypes.func.isRequired,
    oncancelrow: React.PropTypes.func.isRequired,
    onupdateitem: React.PropTypes.func.isRequired,
    ondeleterow: React.PropTypes.func.isRequired,
    onchangecheckselection: React.PropTypes.func.isRequired,
    onrefreshratecard: React.PropTypes.func.isRequired,
    checkdescriptioncontroltype: React.PropTypes.func.isRequired,
    onedittaxrate: React.PropTypes.func.isRequired,
    onchangeitemcode: React.PropTypes.func.isRequired
};
CeReadOnlyRow.defaultProps = {
    item: null,
    uid: null,
    ratecarditems: [],
    costcodes: [],
    itemcodes: [],
    localization: 'AU',
    defaulttaxrate: 0,
    onaddrow: function onaddrow() {}, // noop
    oneditrow: function oneditrow() {},
    oncancelrow: function oncancelrow() {},
    onupdateitem: function onupdateitem() {},
    ondeleterow: function ondeleterow() {},
    onchangecheckselection: function onchangecheckselection() {},
    onrefreshratecard: function onrefreshratecard() {},
    checkdescriptioncontroltype: function checkdescriptioncontroltype() {},
    onedittaxrate: function onedittaxrate() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CeItemCodes = function (_React$Component) {
    _inherits(CeItemCodes, _React$Component);

    function CeItemCodes(props) {
        _classCallCheck(this, CeItemCodes);

        var _this = _possibleConstructorReturn(this, (CeItemCodes.__proto__ || Object.getPrototypeOf(CeItemCodes)).call(this, props));

        _this.state = {
            value: props.value
        };

        //this.handleChange = this.handleChange.bind(this);
        return _this;
    }

    _createClass(CeItemCodes, [{
        key: 'componentDidMount',


        /**
        * ========================
        * React Life Cycle Events
        * ========================
        */
        value: function componentDidMount() {
            var self = this;
            this.$node = $('#' + this.componentId); //this.refs.select2);
            this.$node.select2({
                data: this.props.itemcodes,
                width: 'element',
                placeholder: "Select Item Code",
                templateResult: this.formatItems,
                allowClear: true
            });

            this.$node.on('change', function () {
                var $this = $(this);
                self.setValue($this.val());
            });

            // Set initial value
            this.$node.val(this.state.value);
            this.$node.trigger('change');
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Each time when component receives new props,
            // we should trigger refresh or perform anything else we need.
            // For this example, we'll update only the enable/disable option,
            // as soon as we receive a different value for this.props.enable
            //this.state.value
            if (nextProps.value !== this.props.value) {
                this.$node.val(nextProps.value);
                this.$node.trigger('change');
            }
        }
    }, {
        key: 'formatItems',
        value: function formatItems(obj) {
            return obj.text;
        }

        // handleChange(event) {
        //     this.setState({ value: event.target.value });
        //     this.props.itemchange(event.target.value);
        // }

    }, {
        key: 'setValue',
        value: function setValue(data) {
            this.setState({ value: data });
            this.props.itemchange(data);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;

            self.componentId = _.uniqueId('selectItemCode');

            return React.createElement(
                'select',
                { id: self.componentId, className: 'invr-select-size' },
                React.createElement('option', null)
            );
        }
    }]);

    return CeItemCodes;
}(React.Component);

CeItemCodes.propTypes = {
    value: React.PropTypes.string.isRequired,
    itemcodes: React.PropTypes.array.isRequired,
    itemchange: React.PropTypes.func.isRequired
};
CeItemCodes.defaultProps = {
    value: null,
    itemcodes: [],
    itemchange: function itemchange() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CeRateCardItemSelect = function (_React$Component) {
    _inherits(CeRateCardItemSelect, _React$Component);

    function CeRateCardItemSelect() {
        _classCallCheck(this, CeRateCardItemSelect);

        return _possibleConstructorReturn(this, (CeRateCardItemSelect.__proto__ || Object.getPrototypeOf(CeRateCardItemSelect)).call(this));
    }

    _createClass(CeRateCardItemSelect, [{
        key: 'componentDidMount',


        /**
         * ========================
         * React Life Cycle Events
         * ========================
         */
        value: function componentDidMount() {
            var self = this;

            this.$node = $('#' + this.componentId);
            this.$node.select2({
                data: this.props.data,
                templateResult: this.formatItems,
                templateSelection: this.formatSelectionItem,
                matcher: this.matchCustom,
                width: 'element',
                placeholder: "Select item rate",
                allowClear: true
            });

            this.$node.on('change', function () {
                var $this = $(this);
                //if (_.isNil($this.val()) || _.isEmpty($this.val())) return;
                if (_.isNil($this.val())) return;
                self.props.onchangevalue($this.val());
            });

            // Set initial value
            this.$node.val(this.props.value);
            this.$node.trigger('change');
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {}
        // Each time when component receives new props,
        // we should trigger refresh or perform anything else we need.
        // For this example, we'll update only the enable/disable option,
        // as soon as we receive a different value for this.props.enable
        // if (nextProps.enable !== this.props.enable) {
        //     this.$node.sortable(nextProps.enable ? 'enable' : 'disable');
        // }


        /**
         * Returns jquery template object
         * @param {*} obj
         */

    }, {
        key: 'formatItems',
        value: function formatItems(obj) {
            if (!obj.id || obj.id == -1) {
                return obj.text;
            }

            var $formattedObj = $('<div><div style="width: 80%; display: inline-block;">' + obj.text + '</div><div class="text-right" style="display: inline-block; width: 20%;">$' + obj.unitPrice.toFixed(2) + '</div></div>');
            return $formattedObj;
        }

        /**
         * Returns query template object
         * @param {*} obj
         */

    }, {
        key: 'formatSelectionItem',
        value: function formatSelectionItem(obj) {
            if (!obj.id || obj.id == -1 || obj.groupName == null) {
                //return obj.text;
                //return $('<strong>' + obj.text + '</strong>');
                return $('<span>' + obj.text + '</span>');
            }

            //return $('<strong> ' + obj.parentName + ' (' + obj.text + ') </strong>');
            // return $('<strong> ' + obj.lineItem + '</strong>');
            return $('<span> ' + obj.lineItem + '</span>');
        }
    }, {
        key: 'matchCustom',
        value: function matchCustom(params, data) {
            // If there are no search terms, return all of the data
            if ($.trim(params.term) === '') {
                return data;
            }

            // Do not display the item if there is no 'text' property
            if (typeof data.text === 'undefined') {
                return null;
            }

            // `params.term` should be the term that is used for searching
            // `data.text` is the text that is displayed for the data object
            if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
                var modifiedData = $.extend({}, data, true);
                modifiedData.text += ' (matched)';

                // You can return modified objects from here
                // This includes matching the `children` how you want in nested data sets
                return modifiedData;
            } else if (data.hasOwnProperty('children') && data.children.length > 0) {
                var findResults = _.filter(data.children, function (c) {
                    return c.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1;
                });

                if (findResults.length > 0) {
                    var modifiedData = $.extend({}, data, true);
                    modifiedData.text += ' (matched)';

                    return modifiedData;
                }
            }

            // Return `null` if the term should not be displayed
            return null;
        }

        // editInvoice(id) {
        //     this.props.oneditinvoice(id);
        // }

    }, {
        key: 'moneyFormat',
        value: function moneyFormat(number, decimalPlaces) {
            var parsedNumber = number;
            var isNegative = number < 0;

            var decimalPadding = function decimalPadding() {
                var tNum = ".";
                if (decimalPlaces > 0) {
                    for (var i = 0; i < decimalPlaces; i++) {
                        tNum += "0";
                    }
                } else {
                    tNum += "00";
                }
                return tNum;
            };

            if (!number || isNaN(number)) return "0" + decimalPadding();

            if (decimalPlaces > 0) {
                parsedNumber = number.toFixed(decimalPlaces);
            }

            var arr = parsedNumber.toString().split('.');
            var result = arr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            result += arr.length > 1 ? "." + arr[1] : decimalPadding();

            return result;
        }

        // renderItems(item) {
        // }

    }, {
        key: 'render',
        value: function render() {
            var self = this;
            self.componentId = _.uniqueId('select');

            return React.createElement(
                'select',
                { id: self.componentId, className: 'invr-select-size' },
                React.createElement('option', null),
                React.createElement(
                    'option',
                    { value: '-1' },
                    'Other Item'
                )
            );
        }
    }]);

    return CeRateCardItemSelect;
}(React.Component);

CeRateCardItemSelect.propTypes = {
    data: React.PropTypes.array.isRequired,
    onchangevalue: React.PropTypes.func.isRequired
};
CeRateCardItemSelect.defaultProps = {
    data: [],
    onchangevalue: function onchangevalue() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CeEditableRow = function (_React$Component) {
    _inherits(CeEditableRow, _React$Component);

    function CeEditableRow(props) {
        _classCallCheck(this, CeEditableRow);

        var _this = _possibleConstructorReturn(this, (CeEditableRow.__proto__ || Object.getPrototypeOf(CeEditableRow)).call(this, props));

        _this.updateLine = _this.updateLine.bind(_this);
        _this.cancelChangeLine = _this.cancelChangeLine.bind(_this);
        _this.descHandleModelChange = _this.descHandleModelChange.bind(_this);
        _this.onRateCardItemChange = _this.onRateCardItemChange.bind(_this);

        _this.unitPriceExcludingTaxHandleModelChange = _this.unitPriceExcludingTaxHandleModelChange.bind(_this);
        _this.quantityHandleModelChange = _this.quantityHandleModelChange.bind(_this);
        _this.itemCodeChange = _this.itemCodeChange.bind(_this);
        _this.itemGLCodeTextChange = _this.itemGLCodeTextChange.bind(_this);
        _this.costCodeItemChange = _this.costCodeItemChange.bind(_this);
        _this.editTaxRate = _this.editTaxRate.bind(_this);

        // =============
        // Build state
        // =============

        // Get Code by examining the description colum
        var rateCardItemObject = _this.getRateCardItemCode(props.item.Description);

        _this.state = {
            Id: props.item.Id,
            Description: props.item.Description,
            CostCode: _.isNull(props.item.CostCode) || _.isUndefined(props.item.CostCode) ? '' : props.item.CostCode, // Deprecated
            ItemCode: _.isNull(props.item.ItemCode) || _.isUndefined(props.item.ItemCode) ? '-1' : props.item.ItemCode,
            Quantity: props.item.Quantity,
            UnitPriceExcludingTax: props.item.UnitPriceExcludingTax,
            UnitTax: props.item.UnitTax,
            TotalTax: props.item.TotalTax,
            Amount: props.item.Amount,
            TaxRate: props.item.TaxRate, // Combined tax rate
            CityTaxRate: props.item.CityTaxRate,
            CountyTaxRate: props.item.CountyTaxRate,
            StateSalesTaxRate: props.item.StateSalesTaxRate,
            SpecialTaxRate: props.item.SpecialTaxRate,
            HasError: false,
            DescError: '',
            QtyError: '',
            UnitPriceError: '',
            CostCodeError: '',
            ItemCodeError: '',
            RateCardItemMode: _.isUndefined(rateCardItemObject) ? true : rateCardItemObject.RateCardItemMode,
            RateCardItemCode: _.isUndefined(rateCardItemObject) ? null : rateCardItemObject.RateCardItemCode,
            IsInitialLoad: true,
            IsPreventReplacingUnitPrice: false
        };
        return _this;
    }

    _createClass(CeEditableRow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var self = this;
            // Setup shortcut keys
            window.Mousetrap.bind('enter', function (e) {
                self.updateLine(self.state.Id);
            });

            window.Mousetrap.bind('esc', function (e) {
                self.cancelChangeLine(self.state.Id);
            });

            // Mark initial component loading completed
            this.setState({ IsInitialLoad: false });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.Mousetrap.unbind('enter');
            window.Mousetrap.unbind('esc');
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Each time when component receives new props,
            // we should trigger refresh or perform anything else we need.
            // For this example, we'll update only the enable/disable option,
            // as soon as we receive a different value for this.props.enable
            //this.state.value 
            var self = this;

            if (nextProps.item.TaxRate !== this.props.item.TaxRate) this.setState({ TaxRate: nextProps.item.TaxRate }, function () {
                self.compute(self.state);
            });
            if (nextProps.item.CityTaxRate !== this.props.item.CityTaxRate) this.setState({ CityTaxRate: nextProps.item.CityTaxRate }, function () {
                self.compute(self.state);
            });
            if (nextProps.item.StateSalesTaxRate !== this.props.item.StateSalesTaxRate) this.setState({ StateSalesTaxRate: nextProps.item.StateSalesTaxRate }, function () {
                self.compute(self.state);
            });
            if (nextProps.item.SpecialTaxRate !== this.props.item.SpecialTaxRate) this.setState({ SpecialTaxRate: nextProps.item.SpecialTaxRate }, function () {
                self.compute(self.state);
            });
            if (nextProps.item.CountyTaxRate !== this.props.item.CountyTaxRate) this.setState({ CountyTaxRate: nextProps.item.CountyTaxRate }, function () {
                self.compute(self.state);
            });
        }
    }, {
        key: 'updateLine',
        value: function updateLine(id) {
            // Call update item callback in parent component
            if (this.validate()) {
                this.props.onUpdateItem(this.state);
            }
        }
    }, {
        key: 'cancelChangeLine',
        value: function cancelChangeLine(id) {
            this.props.onCancelLine(this.state);
        }
    }, {
        key: 'descHandleModelChange',
        value: function descHandleModelChange(e) {
            this.validateDescription(e.target.value);
            this.setState({ Description: e.target.value });
        }
    }, {
        key: 'quantityHandleModelChange',
        value: function quantityHandleModelChange(e) {
            var value = e.target.value;
            this.setState({ Quantity: value }, function () {
                //this.validateQty(value);
                this.validateUnitPriceAndQty(value, this.state.UnitPriceExcludingTax);
                this.compute(this.state);
            });
        }
    }, {
        key: 'unitPriceExcludingTaxHandleModelChange',
        value: function unitPriceExcludingTaxHandleModelChange(e) {
            var value = e.target.value;
            this.setState({ UnitPriceExcludingTax: value }, function () {
                this.validateUnitPriceAndQty(this.state.Quantity, value);
                this.compute(this.state);
            });
        }
    }, {
        key: 'costCodeItemChange',
        value: function costCodeItemChange(data) {
            this.validateCostCode(data);
            this.setState({ CostCode: data });
        }
    }, {
        key: 'itemCodeChange',
        value: function itemCodeChange(data) {
            this.validateItemCode(data);
            this.setState({ ItemCode: data });
        }
    }, {
        key: 'itemGLCodeTextChange',
        value: function itemGLCodeTextChange(e) {
            this.setState({ ItemCode: '', CostCode: e.target.value });
        }

        /**
         * This only fires when switch to Description Textbox and Item Code dropdown mode
         */

    }, {
        key: 'performCleanupBeforeChangingMode',
        value: function performCleanupBeforeChangingMode() {
            this.setState({
                Description: '',
                ItemCode: this.props.isaltusspecialenabled ? '-1' : '',
                CostCode: '',
                Quantity: '',
                UnitPriceExcludingTax: '',
                HasError: false,
                DescError: '',
                QtyError: '',
                UnitPriceError: '',
                CostCodeError: '',
                ItemCodeError: '',
                UnitTax: '',
                TotalTax: '',
                Amount: ''
            });
        }
    }, {
        key: 'onRateCardItemChange',
        value: function onRateCardItemChange(id) {
            // It means the user selected "Other Item" option
            // Change control/component to Description textbox with item code dropdown
            if (id === "-1") {
                this.setState({ RateCardItemMode: false }); //isRateCardItemVisible: false
                this.performCleanupBeforeChangingMode();
                return;
            }

            // Fire to outside caller to fetch rate card item details
            var rateCardItemSelected = this.props.onRefreshRateCard(id);
            if (rateCardItemSelected == null) {
                this.setState({ Description: '' });
                return;
            }

            // Set Description
            this.setState({ Description: rateCardItemSelected.lineItem, RateCardItemCode: rateCardItemSelected.id }, function () {
                this.validateDescription(this.state.Description);
            });

            // Set Item code
            this.setState({ ItemCode: rateCardItemSelected.glItemCode }, function () {
                this.validateItemCode(rateCardItemSelected.glItemCode);
            });

            this.setState({ CostCode: rateCardItemSelected.glAccountCode }, function () {
                this.validateCostCode(rateCardItemSelected.glAccountCode);
            });

            this.setState({ ItemId: rateCardItemSelected.itemId, ItemType: rateCardItemSelected.itemType });

            // If initial load of component and IsPrevent replacing of unit price then dont run codes below
            if (!this.state.IsInitialLoad) {
                // Set Unit price
                this.setState({ UnitPriceExcludingTax: rateCardItemSelected.unitPrice }, function () {
                    this.validateUnitPriceAndQty(this.state.Quantity, rateCardItemSelected.unitPrice);
                    this.compute(this.state);
                });
            }
        }

        /**
         * Determine what kind of control either RateCardItemControl or Description textbox/item code combo
         * @param {*} data 
         */

    }, {
        key: 'getRateCardItemCode',
        value: function getRateCardItemCode(data) {
            if (this.props.ratecarditems.length <= 0) {
                return {
                    RateCardItemMode: false,
                    RateCardItemCode: null
                };
            }

            if (_.isNil(data) || _.isEmpty(data)) return;
            var controlType = this.props.checkDescriptionControlType(data);
            var isRateCardItemControl = controlType.type == 'rate-card-item-control';

            return {
                RateCardItemMode: isRateCardItemControl,
                RateCardItemCode: isRateCardItemControl ? controlType.id : null
            };
        }

        /**
         * Compute Line item
         */

    }, {
        key: 'compute',
        value: function compute(itm) {

            // Get tax rate to use
            if (_.isFinite(parseFloat(this.state.UnitPriceExcludingTax)) && _.isFinite(parseFloat(this.state.Quantity))) {
                var taxAmt, taxRate, unitTax;

                itm.TaxRate = this.props.TaxRate == undefined || this.props.TaxRate == null || this.props.TaxRate.length <= 0 || this.props.TaxRate === 0 ? this.props.defaulttaxrate : itm.TaxRate;

                if (parseFloat(itm.Quantity) < 0) {
                    itm.UnitPriceExcludingTax = Math.abs(itm.UnitPriceExcludingTax);
                }

                taxRate = itm.TaxRate / 100;
                unitTax = parseFloat(itm.UnitPriceExcludingTax) * taxRate;
                taxAmt = parseFloat(itm.Quantity) * parseFloat(itm.UnitPriceExcludingTax) * taxRate;

                itm.UnitTax = taxAmt.toFixed(2);
                itm.TotalTax = taxAmt.toFixed(2);
                itm.Amount = parseFloat(parseFloat(itm.Quantity) * parseFloat(itm.UnitPriceExcludingTax)).toFixed(2);
            } else {
                itm.Amount = parseFloat(0).toFixed(2);
                itm.UnitTax = parseFloat(0).toFixed(2);
                itm.TotalTax = parseFloat(0).toFixed(2);
            }

            this.setState({ TotalTax: itm.TotalTax });
            this.setState({ UnitTax: itm.UnitTax });
            this.setState({ Amount: itm.Amount });
        }

        /**
         * Returns TRUE if valid state
         */

    }, {
        key: 'validate',
        value: function validate() {
            var isValid = this.validateDescription(this.state.Description);
            if (!isValid) {
                this.setState({ HasError: !isValid });
                return isValid;
            }

            if (!this.state.RateCardItemMode) {
                isValid = this.validateItemCode(this.state.ItemCode);
                if (!isValid) {
                    this.setState({ HasError: !isValid });
                    return isValid;
                }
            }

            isValid = this.validateUnitPriceAndQty(this.state.Quantity, this.state.UnitPriceExcludingTax);
            if (!isValid) {
                this.setState({ HasError: !isValid });
                return isValid;
            }

            this.setState({ HasError: false });

            return isValid;
        }
    }, {
        key: 'validateDescription',
        value: function validateDescription(value) {
            this.setState({ DescError: '' });
            if (_.isNull(value) || _.isUndefined(value) || value.length <= 0) {
                this.setState({ DescError: 'Description is required.' });
                return false;
            } else {
                return true;
            }
        }
    }, {
        key: 'validateQty',
        value: function validateQty(value) {
            this.setState({ QtyError: '' });
            if (_.isNull(value) || !_.isFinite(parseFloat(value)) || isNaN(value)) {
                this.setState({ QtyError: 'Quantity is required.' });
                return false;
            } else if (parseFloat(value) == 0) {
                this.setState({ QtyError: 'Zero (0) value is not a valid Quantity.' });
                return false;
            } else {
                return true;
            }
        }
    }, {
        key: 'validateUnitPrice',
        value: function validateUnitPrice(value) {
            this.setState({ UnitPriceError: '' });
            if (_.isNull(value) || !_.isFinite(parseFloat(value)) || isNaN(value)) {
                this.setState({ UnitPriceError: 'Unit Price is required.' });
                return false;
            } else if (parseFloat(value) == 0) {
                this.setState({ UnitPriceError: 'Zero (0) value is not a valid UnitPriceExcludingTax.' });
                return false;
            } else {
                return true;
            }
        }
    }, {
        key: 'validateUnitPriceAndQty',
        value: function validateUnitPriceAndQty(qty, unitPrice) {
            this.setState({ QtyError: '' });
            this.setState({ UnitPriceError: '' });

            var qtyValue = _.isNaN(parseFloat(qty)) ? 0 : parseFloat(qty);
            var unitPriceValue = _.isNaN(parseFloat(unitPrice)) ? 0 : parseFloat(unitPrice);

            if (qty == null || qty.length <= 0) {
                this.setState({ QtyError: 'Quantity is required.' });
                return false;
            } else if (unitPrice == null || unitPrice.length <= 0) {
                this.setState({ UnitPriceError: 'Unit Price is required.' });
                return false;
            } else if (qtyValue === 0 && unitPriceValue !== 0) {
                this.setState({ QtyError: 'Invalid Quantity.' });
                return false;
            } else if (qtyValue === 0 && unitPriceValue === 0) {
                this.setState({ QtyError: 'Quantity is required.' });
                this.setState({ UnitPriceError: 'Unit Price is required.' });
                return false;
            } else {
                return true;
            }
        }
    }, {
        key: 'validateCostCode',
        value: function validateCostCode(value) {
            this.setState({ CostCodeError: '' });

            var isCostCodeMissing = _.isNull(value) || value == '-1' || _.isUndefined(value);
            if (!isCostCodeMissing) {
                return true;
            }

            this.setState({ CostCodeError: 'Cost Code is required.' });
            return false;
        }
    }, {
        key: 'validateItemCode',
        value: function validateItemCode(value) {
            this.setState({ ItemCodeError: '' });

            var isItemCodeMissing = _.isNull(value) || value == '-1' || _.isUndefined(value) || _.isEmpty(value);
            var isItemCodeRequired = isItemCodeMissing && this.props.isaltusspecialenabled;
            if (!isItemCodeRequired) {
                return true;
            }

            this.setState({ ItemCodeError: 'Item Code is required.' });
            return false;
        }
    }, {
        key: 'editTaxRate',
        value: function editTaxRate(id) {
            // Dont allow to override unit price if coming from Tax rate dialog
            this.setState({ IsPreventReplacingUnitPrice: true });
            this.props.onEditTaxRate({
                Id: id,
                TaxRate: this.state.TaxRate, // Combined tax rate
                CityTaxRate: this.state.CityTaxRate,
                CountyTaxRate: this.state.CountyTaxRate,
                StateSalesTaxRate: this.state.StateSalesTaxRate,
                SpecialTaxRate: this.state.SpecialTaxRate
            });
        }
    }, {
        key: 'itemCodeChange',
        value: function itemCodeChange(data) {
            var selectedItemCodeGLCode = this.props.onChangeItemCode(data);

            if (!(_.isNil(selectedItemCodeGLCode) || _.isEmpty(selectedItemCodeGLCode))) {

                this.setState({ CostCode: selectedItemCodeGLCode }, function () {
                    this.validateCostCode(selectedItemCodeGLCode);
                });
            }

            this.validateItemCode(data);
            this.setState({
                ItemCode: data
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var descriptionPartial = void 0;
            var descriptionPartial2 = void 0;
            var itemCodePartial = void 0;
            var taxRatePartial = void 0;
            var costCodePartial = void 0;

            if (this.state.RateCardItemMode) {
                descriptionPartial = React.createElement(InvoiceRateCardItemSelect, { data: self.props.ratecarditems, value: self.state.RateCardItemCode, onchangevalue: self.onRateCardItemChange });

                if (this.props.isaltusspecialenabled) {
                    itemCodePartial = React.createElement(ItemCodes, { itemcodes: self.props.itemcodes, value: self.state.ItemCode, itemchange: self.itemCodeChange });
                } else {
                    itemCodePartial = React.createElement(
                        'span',
                        null,
                        'N/A'
                    );
                }
            } else {
                $('#rateCardItemDiv').hide();

                descriptionPartial2 = React.createElement('input', { type: 'text', value: self.state.Description, className: 'mousetrap input-control', onChange: self.descHandleModelChange });

                if (this.props.isaltusspecialenabled) {
                    itemCodePartial = React.createElement(ItemCodes, { itemcodes: self.props.itemcodes, value: self.state.ItemCode, itemchange: self.itemCodeChange });
                } else {
                    itemCodePartial = React.createElement(
                        'span',
                        null,
                        'N/A'
                    );
                }
            }

            if (!this.props.isaltusspecialenabled) {
                costCodePartial = React.createElement(
                    'td',
                    null,
                    React.createElement('input', { type: 'text', value: self.state.CostCode, className: 'mousetrap input-control', placeholder: 'Enter GL Code', onChange: self.itemGLCodeTextChange })
                );
            }

            // Tax rate editable
            var linkStyle = { textDecoration: 'underline' };
            if (self.props.localization == 'US') {
                taxRatePartial = React.createElement(
                    'td',
                    { className: 'text-right' },
                    React.createElement(
                        'a',
                        { href: '#', className: 'blue-400-fg', style: linkStyle, onClick: self.editTaxRate.bind(this, self.props.item.Id) },
                        self.props.item.TaxRate
                    ),
                    ' %'
                );
            }

            return React.createElement(
                'tr',
                { key: this.props.uid },
                React.createElement('td', null),
                React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        React.createElement(
                            'div',
                            { id: 'rateCardItemDiv' },
                            descriptionPartial
                        ),
                        React.createElement(
                            'div',
                            null,
                            descriptionPartial2
                        )
                    ),
                    this.state.HasError && React.createElement(
                        'div',
                        { className: 'red-600-fg font-size-10' },
                        this.state.DescError
                    )
                ),
                React.createElement(
                    'td',
                    null,
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        itemCodePartial
                    ),
                    React.createElement(
                        'div',
                        null,
                        this.state.HasError && React.createElement(
                            'div',
                            { className: 'red-600-fg font-size-10' },
                            this.state.ItemCodeError
                        )
                    )
                ),
                costCodePartial,
                React.createElement(
                    'td',
                    { className: 'text-rightx' },
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        React.createElement('input', { type: 'text', value: self.state.Quantity, className: 'mousetrap input-control', onChange: self.quantityHandleModelChange })
                    ),
                    this.state.HasError && React.createElement(
                        'div',
                        { className: 'red-600-fg font-size-10' },
                        this.state.QtyError
                    )
                ),
                React.createElement(
                    'td',
                    { className: 'text-rightx' },
                    React.createElement(
                        'div',
                        { className: 'margin-top-5 margin-bottom-5' },
                        React.createElement('input', { type: 'text', value: self.state.UnitPriceExcludingTax, className: 'mousetrap input-control', onChange: self.unitPriceExcludingTaxHandleModelChange })
                    ),
                    this.state.HasError && React.createElement(
                        'div',
                        { className: 'red-600-fg font-size-10' },
                        this.state.UnitPriceError
                    )
                ),
                taxRatePartial,
                React.createElement(
                    'td',
                    { className: 'text-right' },
                    self.state.Amount
                ),
                React.createElement(
                    'td',
                    { className: 'text-right' },
                    React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                        React.createElement('i', { className: 'icon-check s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.updateLine.bind(this, self.props.item.Id) })
                    ),
                    React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                        React.createElement('i', { className: 'icon-cancel s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.cancelChangeLine.bind(this, self.props.item.Id) })
                    )
                )
            );
        }
    }]);

    return CeEditableRow;
}(React.Component);

CeEditableRow.propTypes = {
    uid: React.PropTypes.string.isRequired,
    item: React.PropTypes.object.isRequired,
    ratecarditems: React.PropTypes.array.isRequired,
    isaltusspecialenabled: React.PropTypes.bool.isRequired,
    itemcodes: React.PropTypes.array.isRequired,
    costcodes: React.PropTypes.array.isRequired,
    localization: React.PropTypes.string.isRequired,
    defaulttaxrate: React.PropTypes.number.isRequired,
    onUpdateItem: React.PropTypes.func.isRequired,
    onCancelLine: React.PropTypes.func.isRequired,
    onRefreshRateCard: React.PropTypes.func.isRequired,
    checkDescriptionControlType: React.PropTypes.func.isRequired, // Use to determine the exact control type for the edited row item (fires an event outside)
    onEditTaxRate: React.PropTypes.func.isRequired,
    onChangeItemCode: React.PropTypes.func.isRequired
};
CeEditableRow.defaultProps = {
    item: null,
    uid: null,
    ratecarditems: [],
    itemcodes: [],
    costcodes: [],
    localization: 'AU',
    defaulttaxrate: 0,
    onUpdateItem: function onUpdateItem() {}, // noop
    onCancelLine: function onCancelLine() {},
    onRefreshRateCard: function onRefreshRateCard() {},
    checkDescriptionControlType: function checkDescriptionControlType() {},
    onEditTaxRate: function onEditTaxRate() {},
    onChangeItemCode: function onChangeItemCode() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CeCostCodes = function (_React$Component) {
    _inherits(CeCostCodes, _React$Component);

    function CeCostCodes(props) {
        _classCallCheck(this, CeCostCodes);

        var _this = _possibleConstructorReturn(this, (CeCostCodes.__proto__ || Object.getPrototypeOf(CeCostCodes)).call(this, props));

        _this.state = {
            value: props.value
        };

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(CeCostCodes, [{
        key: "handleChange",


        // shouldComponentUpdate(nextProps, nextState) {
        //     return false;
        // }

        value: function handleChange(event) {
            this.setState({ value: event.target.value });
            this.props.itemchange(event.target.value);
        }
    }, {
        key: "render",
        value: function render() {
            var self = this;

            var createSelectItems = function createSelectItems(itm) {
                return React.createElement(
                    "option",
                    { value: itm.Id },
                    itm.Description
                );
            };

            return React.createElement(
                "select",
                { value: this.state.value, className: "mousetrap input-control", onChange: this.handleChange },
                this.props.costcodes.map(createSelectItems)
            );
        }
    }]);

    return CeCostCodes;
}(React.Component);

CeCostCodes.propTypes = {
    value: React.PropTypes.string.isRequired,
    costcodes: React.PropTypes.array.isRequired,
    itemchange: React.PropTypes.func.isRequired
};
CeCostCodes.defaultProps = {
    value: null,
    costcodes: [],
    itemchange: function itemchange() {}
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CeCommentRow = function (_React$Component) {
    _inherits(CeCommentRow, _React$Component);

    function CeCommentRow(props) {
        _classCallCheck(this, CeCommentRow);

        var _this = _possibleConstructorReturn(this, (CeCommentRow.__proto__ || Object.getPrototypeOf(CeCommentRow)).call(this, props));

        _this.updateLine = _this.updateLine.bind(_this);
        _this.cancelChangeLine = _this.cancelChangeLine.bind(_this);
        _this.descHandleModelChange = _this.descHandleModelChange.bind(_this);

        // Build state
        _this.state = {
            Id: props.item.Id,
            Description: props.item.Description,
            CostCode: '-1',
            ItemCode: '-1',
            Quantity: 0,
            UnitPriceExcludingTax: 0,
            UnitTax: 0,
            Amount: 0,
            TaxRate: 0,
            HasError: false,
            DescError: '',
            QtyError: '',
            UnitPriceError: '',
            CostCodeError: '',
            ItemCodeError: ''
        };
        return _this;
    }

    _createClass(CeCommentRow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var self = this;
            // Setup shortcut keys
            window.Mousetrap.bind('enter', function (e) {
                self.updateLine(self.state.Id);
            });

            window.Mousetrap.bind('esc', function (e) {
                self.cancelChangeLine(self.state.Id);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.Mousetrap.unbind('enter');
            window.Mousetrap.unbind('esc');
        }
    }, {
        key: 'updateLine',
        value: function updateLine(id) {
            // Call update item callback in parent component
            if (_.isNull(this.state.Description) || _.isUndefined(this.state.Description) || this.state.Description.length == 0) {
                this.setState({ Description: ' ' }, function () {
                    this.props.onUpdateItem(this.state);
                });
            } else {
                this.props.onUpdateItem(this.state);
            }
        }
    }, {
        key: 'cancelChangeLine',
        value: function cancelChangeLine(id) {
            this.props.onCancelLine(this.state);
        }
    }, {
        key: 'descHandleModelChange',
        value: function descHandleModelChange(e) {
            this.setState({ Description: e.target.value });
        }

        /**
         * Returns TRUE if valid state
         */

    }, {
        key: 'validate',
        value: function validate() {
            var isError = false;
            this.setState({ DescError: '' });

            if (_.isNull(this.state.Description) || _.isUndefined(this.state.Description) || this.state.Description.length <= 0) {
                this.setState({ DescError: 'Comment is required.' });
                isError = true;
            }

            this.setState({ HasError: isError });
            return !isError;
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var itemDescriptionColSpan = 6;

            if (!self.props.isaltusspecialenabled) {
                itemDescriptionColSpan += 1;
            }

            return React.createElement(
                'tr',
                { key: this.props.uid },
                React.createElement('td', null),
                React.createElement(
                    'td',
                    { colSpan: itemDescriptionColSpan },
                    React.createElement('input', { type: 'text', value: self.state.Description, className: 'mousetrap input-control', onChange: self.descHandleModelChange }),
                    this.state.HasError && React.createElement(
                        'div',
                        { className: 'red-600-fg font-size-10' },
                        this.state.DescError
                    )
                ),
                React.createElement(
                    'td',
                    { className: 'text-right' },
                    React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                        React.createElement('i', { className: 'icon-check s18 s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.updateLine.bind(this, self.props.item.Id) })
                    ),
                    React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltipx' },
                        React.createElement('i', { className: 'icon-cancel s18 clickable-item padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.cancelChangeLine.bind(this, self.props.item.Id) })
                    )
                )
            );
        }
    }]);

    return CeCommentRow;
}(React.Component);

CeCommentRow.propTypes = {
    uid: React.PropTypes.string.isRequired,
    item: React.PropTypes.object.isRequired,
    onUpdateItem: React.PropTypes.func.isRequired,
    onCancelLine: React.PropTypes.func.isRequired
};
CeCommentRow.defaultProps = {
    item: null,
    uid: null,
    onUpdateItem: function onUpdateItem() {}, // noop
    onCancelLine: function onCancelLine() {}
};
(function () {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .service('timesheetModel', timesheetModel)

    function timesheetModel(TimeLibrary) {
        return function (opts) {
            var self = this;
            var defaults = {
                id : null,
                TicketId : null,
                TicketNumber : null,
                ContactId : null,
                TravelStartTime : null,
                JobStartTime : null,
                BreakStartTime : null,
                BreakEndTime : null,
                JobEndTime : null,
                TravelEndTime : null,
                InclementWeatherHours: null,
                TravelToDistance : null,
                TravelDuringDistance : null,
                TravelFromDistance : null,
            };

            self.map = mapper;
            self.transform = transformToModel;

            function mapper(opts) {
                angular.extend(this, defaults, opts);
            }

            function transformToModel() {
                return {
                    id : self.id,
                    TicketId : self.TicketId,
                    TicketNumber : self.TicketNumber,
                    ContactId : self.ContactId,
                    TravelStartTime : TimeLibrary.convertToServerTime(self.TravelStartTime),
                    JobStartTime : TimeLibrary.convertToServerTime(self.JobStartTime),
                    BreakStartTime : TimeLibrary.convertToServerTime(self.BreakStartTime),
                    BreakEndTime : TimeLibrary.convertToServerTime(self.BreakEndTime),
                    JobEndTime : TimeLibrary.convertToServerTime(self.JobEndTime),
                    TravelEndTime : TimeLibrary.convertToServerTime(self.TravelEndTime),
                    InclementWeatherHours: self.InclementWeatherHours,
                    TravelToDistance : self.TravelToDistance,
                    TravelDuringDistance : self.TravelDuringDistance,
                    TravelFromDistance : self.TravelFromDistance,
                };
            }

            self.map(opts);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.paperwork.exceptions')
        .controller('paperWorkTimeSheetDialogController', paperWorkTimeSheetDialogController);

    function paperWorkTimeSheetDialogController($mdDialog,
        timesheetModel,
        locals,
        claimsUtilService) {

        var vm = this;
        vm.model = null;
        vm.claimsUtilService = claimsUtilService;
        vm.onCancel = onCancel;
        vm.activate = activate;
        vm.onSave = onSave;

        function onCancel() {
            $mdDialog.hide();
        }

        function activate() {
            vm.model = new timesheetModel(locals);
        }

        function onSave() {
            let transformed_data = vm.model.transform();
            $mdDialog.hide(transformed_data);
        }

        vm.activate();
    }
})();

(function () {
    'use strict';

    angular.module('app.messaging', [
            'app.api',
            'app.corelib',
            'app.widgets',
            'app.messaging.job',
            'LocalStorageModule'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function runConfig(msNavigationService, claimsUtilService) {

        msNavigationService.saveItem('apps.messaging', {
            title: 'Messaging',
            icon: 'icon-message-text-outline',
            weight: 7,
            hidden: function () {
                return !claimsUtilService.isMobileAppEnabled();
            }
        });

        msNavigationService.saveItem('apps.messaging.job_messaging', {
            title: 'Job Notifications',
            state: 'app.job_messaging_state',
            weight: 1
        });

        msNavigationService.saveItem('apps.messaging.general_messaging', {
            title: 'Send a Message',
            state: 'app.generalMessaging',
            weight: 2
        });
    }

    function config(localStorageServiceProvider) {
        localStorageServiceProvider.setStorageType('localStorage');
    }

})();

(function(){
    'use strict';

    angular.module('app.messaging')
        .directive('specialTextArea', specialTextArea);

    function specialTextArea() {
        var directive = {
            restrict: 'E',
            scope : {
                rows : '=',
                limit : '=',
                isDisabled : '=',
                ngModel : '='
            },
            templateUrl: 'app/main/messaging/generalMessaging/components/messageArea/message/textArea/textArea.html',
            controller: specialTextAreaController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function specialTextAreaController($scope, mediaQueryService) {
            var vm = this;
            vm.limitChars = limitChars;

            function limitChars(message){
                let lines = _.isNil(message) ? 0 : message.split("\n");
                if(_.isNil(message) || message.length > vm.limit || vm.rows === lines.length){
                    if(_.isNil(vm.ngModel)){
                        let backup = document.getElementById('textarea').value;
                        vm.ngModel = backup.substring(0, 320);
                    }else{
                        vm.ngModel = vm.ngModel.substring(0, 320);
                    }
                }
            }

            $scope.$watch(function(){return mediaQueryService.isDeviceMessagingBig()},function(res){if(res){let text_area=document.getElementById("textZone");$scope.$apply(function () {text_area.rows=15});}});
            $scope.$watch(function(){return mediaQueryService.isDeviceMessagingSmall()},function(res){if(res){let text_area=document.getElementById("textZone");$scope.$apply(function () {text_area.rows=5});}});
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard', [
            'ui.calendar',
            'mdPickers',
            'react',
            //'infiniteScrollx'
            'infinite-scroll'
        ])
        .config(config)
        .run(whiteBoardRunConfig);

    angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.jobs_whiteboard', {
            url: '/jobs/whiteboard',
            params: {
                whiteboardType: '1',
                view: null,
                redirectFromCreateJob: false
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/whiteBoard/jobBoard/job-board.default.html',
                    controller: 'JobBoardController as jobBoardVm'
                }
            },
            data: { requireLogin: true },
            resolve: {
                cardFilterData: cardFilterResolver
            },
            title: 'Jobs Whiteboard',
            titleBar: 'Job Whiteboard',
            bodyClass: 'calendar'
        })
        .state('app.jobs_whiteboard_eq', {
            url: '/jobs/whiteboard/equipment',
            params: {
                whiteboardType: '2',
                view: null,
                redirectFromCreateJob: false
             },
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/whiteBoard/jobBoard/job-board.default.html',
                    controller: 'JobBoardController as jobBoardVm'
                }
            },
            data: { requireLogin: true },
            resolve: {
                cardFilterData: cardFilterResolver
            },
            title: 'Equipment Whiteboard',
            titleBar: 'Equipment Whiteboard',
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/jobs/whiteBoard');
        $translatePartialLoaderProvider.addPart('app/main/jobs/whiteBoard/jobBoard/weekly');
    }

    /** @ngInject */
    function whiteBoardRunConfig(whiteboardHubService, whiteboardCustomRouteService) {
        whiteboardHubService.register();
        whiteboardCustomRouteService.registerRouteLogic();
    }

    /** @ngInject */
    function cardFilterResolver(CardFilters) {
        return CardFilters.loadLookups();
    }

})();

/**
 * Date Navigation Component
 * - rcnet 8.16.2016
 */
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('ticketStatusDetailsComponent', ticketStatusDetailsComponent);

    /** @ngInject */
    function ticketStatusDetailsComponent(
    ) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/weekly/newComponents/ticketStatusDetails/ticket-status-details.html',
            scope: {
                status: '=',
                allowGroupByClient: '=',
                showEquipmentAllocationIcon: '=',
                showShiftAllocationIcon: '=',
                showRequireAllocationIcon: '=',
                ticketType: '=',
                isDayShift: '=',
                whiteboardType: '=',
                isEmailSent: '=',
                isRequiredAttachmentsCompleted: '=',
                hasRequiredAttachments: '='
            },
            controller: TicketStatusDetailsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function TicketStatusDetailsController($scope) {
            var vm = this;
            activate();

            vm.getHeaderColorClass = getHeaderColorClass;

            ///////
            function activate() {
            }

            function getHeaderColorClass() {
                if (vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted) return 'md-red-bg';
                if (!vm.status || !vm.status[0]) return '';
                var abbrev = vm.status[0].abbrev;
                if (abbrev === 'AR') return 'md-red-bg';
                if (abbrev === 'C') return 'md-blue-bg';
                if (abbrev === 'R') return 'md-green-bg';
                if (abbrev === 'A') return 'md-orange-bg';
                return '';
            }

            $scope.$on('$destroy', function () {
                vm.status = null;
                vm.showEquipmentAllocationIcon = null;
                vm.showShiftAllocationIcon = null;
                vm.showRequireAllocationIcon = null;
                vm.ticketType = null;
                vm.isDayShift = null;
                vm.isEmailSent = null;
                vm.isRequiredAttachmentsCompleted = false;
                vm.hasRequiredAttachments = false;
            });

        }

    }
})();
/**
 * Week ticket info Component
 * - rcnet 7.19.2018
 */
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('weekTicketInfoComponent', weekTicketInfoComponent);

    /** @ngInject */
    function weekTicketInfoComponent(
    ) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/weekly/newComponents/ticketInfo/week-ticket-info.html',
            scope: {
                cardName: '=',
                allowGroupByClient: '=',
                ticketCount: '=',
                startDate: '=',
                endDate: '=',
                branch: '=',
                jobAddress: '=',
                jobLocationAddress: '=',
                projectName: '=',
                showProject: '='
            },
            controller: WeekTicketInfoController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function WeekTicketInfoController($scope) {
            var vm = this;
            vm.contentInfoCss;
            vm.getAddress=getAddress;

            activate();

            ///////
            function activate() {
                vm.contentInfoCss = vm.allowGroupByClient == false && vm.showProject == false ? 'week-ticket-info-container-big' : 'week-ticket-info-container-small';
            }

            function getAddress(address) {
                return address.join(" ");
            }


            $scope.$on('$destroy', function () {
                vm.cardName = null;
                vm.cardName = null;
                vm.allowGroupByClient = null;
                vm.ticketCount = null;
                vm.startDate = null;
                vm.endDate = null;
                vm.branch = null;
                vm.jobAddress = null;
                vm.jobLocationAddress = null;
                vm.projectName = null;
                vm.showProject = null;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('weekTicketFooterComponent', weekTicketFooterComponent);

    /** @ngInject */
    function weekTicketFooterComponent(claimsUtilService, jobsClaimsService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/weekly/newComponents/ticketFooter/week-ticket-footer.html',
            scope: {
                id: '=',
                ticket: '=',
                ticketNo: '=',
                relatedNumber: '=',
                allowGroupByClient: '=',
                ticketCount: '=',
                menuName: '=',
                containsPeople: '=',
                containsEquipment: '=',
                startDate: '=',
                onAddRelatedTicket: '&',
                onOpenResourceAllocation: '&',
                onOpenTimesheet: '&',
                onOpenEditTicket: '&',
                onCancelTicket: '&',
                onCloneTicket: '&',
                onDownloadPdf: '&',
                onDownloadPaperworkPdf: '&',
                onDownloadTimesheetPdf: '&',
                onTicketBillingPref: '&',
                isUnConfirmedDate: '=',
                isLocked: '=',
                isLockedByPreSchedule: '=',
                showRelatedTicketNumber: '=',
                ticketType: '=',
                disableBillingPref: '=',
                onExtraMenu: '&',
                parentTicketNo: '=',
                whiteboardType: '=',
                hasGeneratedPaperworkPdf: '='
            },
            controller: WeekTicketFooterController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function WeekTicketFooterController($state) {

            var vm = this;
            vm.disableTimesheet = false;

            vm.openEditTicket = openEditTicket;
            vm.openResourceAllocation = openResourceAllocation;
            vm.openTimesheet = openTimesheet;
            vm.cloneTicket = cloneTicket;
            vm.cancelTicket = cancelTicket;
            vm.addRelatedTicket = addRelatedTicket;
            vm.downloadPdf = downloadPdf;
            vm.addTicketBillingPref = addTicketBillingPref;
            vm.openMenu = openMenu;
            vm.downloadPaperworkPdf = downloadPaperworkPdf;
            vm.downloadTimesheetPdf = downloadTimesheetPdf;
            vm.claimsUtilService = claimsUtilService;
            vm.jobsClaims = jobsClaimsService;
            vm.isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
            vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
            vm.isCustomFormsEnabled = claimsUtilService.isCustomFormsEnabled();
            vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();

            vm.goToFormsAndAttachment = function(){
                $state.go('app.formsattachments', { TicketId: vm.id, TicketNo : vm.ticketNo });
            };

            vm.isTimesheetDisabled = function () {
                return (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled) || ((vm.isLocked) && vm.ticketType !== 6 && vm.ticketType !== 3 && vm.ticketType !== 7) || vm.ticketType === 1 || vm.ticketType === 4;
            };

            activate();

            function activate() {
                vm.disableTimesheet = (vm.isSmartSchedulingEnabled && (vm.ticket.status[0].abbrev == 'AIP' || vm.ticket.status[0].abbrev == 'AID')) || ((vm.isLocked) && vm.ticketType != 6 && vm.ticketType != 3 && vm.ticketType != 7) || vm.ticketType == 1 || vm.ticketType == 4;
            }

            function openEditTicket(id, ticketNo, isLocked, isLockedByPreSchedule, parentTicketNo) {
                (vm.onOpenEditTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        isLocked: isLocked,
                        isLockedByPreSchedule: isLockedByPreSchedule,
                        parentTicketNo: parentTicketNo
                    }
                });
            }

            function openResourceAllocation(id, ticketNo, parentTicketNo) {
                (vm.onOpenResourceAllocation || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        parentTicketNo: parentTicketNo
                    }
                });
            }

            function openTimesheet(id, isLocked, isLockedByPreSchedule, ticketNo) {
                (vm.onOpenTimesheet || angular.noop)({
                    value: {
                        id: id,
                        isLocked: isLocked,
                        isLockedByPreSchedule: isLockedByPreSchedule,
                        ticketNo: ticketNo
                    }
                });
            }

            function cloneTicket(id, ticketNo) {
                (vm.onCloneTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function cancelTicket(id, ticketNo) {
                (vm.onCancelTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        ticketType: vm.ticketType
                    }
                });
            }

            function addRelatedTicket(e, id) {
                (vm.onAddRelatedTicket || angular.noop)({
                    value: {
                        id: id
                    }
                });
            }

            function downloadPdf(e, id) {
                (vm.onDownloadPdf || angular.noop)({
                    value: {
                        id: id
                    }
                });
            }

            function addTicketBillingPref(e, dt, id) {
                (vm.onTicketBillingPref || angular.noop)({
                    value: {
                        dt: dt,
                        id: id
                    }
                });
            }

            function downloadPaperworkPdf(e, id, ticketNo) {
                (vm.onDownloadPaperworkPdf || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function downloadTimesheetPdf(e, id, ticketNo) {
                (vm.onDownloadTimesheetPdf || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function openMenu($mdOpenMenu, e) {
                $mdOpenMenu(e);
            }
        }
    }
})();

/**
 * Allocation conflict listing
 * Created date: 2.2.2017
 * rcnet
 */
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .controller('AllocationConflictDialogController', AllocationConflictDialogController);

    /** @ngInject */
    function AllocationConflictDialogController($mdDialog, blockUI, moveTicketService) {
        var vm = this;

        // Data
        vm.model = moveTicketService;

        // Actions
        vm.onCancel = onCancel;
        vm.onYes = yes;
        vm.onNo = no;

        activate();

        ///////
        function activate() {}

        function onCancel() {
            $mdDialog.hide();
        }

        function yes() {
            $mdDialog.hide('Yes');
        }

        function no() {
            $mdDialog.hide('Cancel');
        }

    }
})();
/**
 * Date Navigation Component
 * - rcnet 8.16.2016
 */
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('dailyTicketStatusComponent', dailyTicketStatusComponent);

    /** @ngInject */
    function dailyTicketStatusComponent() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/daily/newComponents/dailyTicketStatus/daily-ticket-status.html',
            scope: {
                status: '=',
                allowGroupByClient: '=',
                showEquipmentAllocationIcon: '=',
                showShiftAllocationIcon: '=',
                showRequireAllocationIcon: '=',
                ticketType: '=',
                isDayShift: '=',
                whiteboardType: '=',
                isEmailSent: '=',
                isRequiredAttachmentsCompleted: '=',
                hasRequiredAttachments: '='
            },
            controller: DailyTicketStatusController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DailyTicketStatusController($scope) {
            var vm = this;
            activate();

            vm.getHeaderColorClass = getHeaderColorClass;

            ///////
            function activate() {}

            function getHeaderColorClass() {
                if (vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted) return 'md-red-bg';
                if (!vm.status || !vm.status[0]) return '';
                var abbrev = vm.status[0].abbrev;
                if (abbrev === 'AR') return 'md-red-bg';
                if (abbrev === 'C') return 'md-blue-bg';
                if (abbrev === 'R') return 'md-green-bg';
                if (abbrev === 'A') return 'md-orange-bg';
                return '';
            }
            
            $scope.$on('$destroy', function() {
                vm.status = null;
                vm.showEquipmentAllocationIcon = null;
                vm.showShiftAllocationIcon = null;
                vm.showRequireAllocationIcon = null;
                vm.ticketType = null;
                vm.isDayShift = null;
                vm.isEmailSent = null;
                vm.isRequiredAttachmentsCompleted = false;
                vm.hasRequiredAttachments = false;
            });
        }

    }
})();
/**
 * Daily ticket info Component
 * - rcnet 7.29.2018
 */
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('dailyTicketInfoComponent', dailyTicketInfoComponent);

    /** @ngInject */
    function dailyTicketInfoComponent() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/daily/newComponents/dailyTicketInfo/daily-ticket-info.html',
            scope: {
                cardName: '=',
                allowGroupByClient: '=',
                ticketCount: '=',
                startDate: '=',
                endDate: '=',
                branch: '=',
                jobAddress: '=',
                jobLocationAddress: '=',
                projectName: '=',
                showProject: '=',
                whiteboardType: '='
            },
            controller: DailyTicketInfoController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DailyTicketInfoController($scope) {
            var vm = this;
            vm.getAddress=getAddress;

            activate();

            ///////
            function activate() {}

            function getAddress(address) {
                return address.join(" ");
            }

            $scope.$on('$destroy', function() {
                vm.cardName = null;
                vm.cardName = null;
                vm.allowGroupByClient = null;
                vm.ticketCount = null;
                vm.startDate = null;
                vm.endDate = null;
                vm.branch = null;
                vm.jobAddress = null;
                vm.jobLocationAddress = null;
                vm.projectName = null;
                vm.showProject = null;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('dailyTicketFooterComponent', dailyTicketFooterComponent);

    /** @ngInject */
    function dailyTicketFooterComponent(claimsUtilService, jobsClaimsService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/daily/newComponents/dailyTicketFooter/daily-ticket-footer.html',
            scope: {
                id: '=',
                ticket: '=',
                ticketNo: '=',
                relatedNumber: '=',
                allowGroupByClient: '=',
                ticketCount: '=',
                menuName: '=',
                containsPeople: '=',
                containsEquipment: '=',
                startDate: '=',
                onAddRelatedTicket: '&',
                onOpenResourceAllocation: '&',
                onOpenTimesheet: '&',
                onOpenEditTicket: '&',
                onCancelTicket: '&',
                onCloneTicket: '&',
                onDownloadPdf: '&',
                onTicketBillingPref: '&',
                onDownloadPaperworkPdf: '&',
                onDownloadTimesheetPdf: '&',
                isUnConfirmedDate: '=',
                isLocked: '=',
                isLockedByPreSchedule: '=',
                showRelatedTicketNumber: '=',
                ticketType: '=',
                disableBillingPref: '=',
                onExtraMenu: '&',
                parentTicketNo: '=',
                whiteboardType: '=',
                hasGeneratedPaperworkPdf: '='
            },
            controller: DailyTicketFooterController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DailyTicketFooterController($state) {

            var vm = this;
            vm.disableTimesheet = false;

            vm.openEditTicket = openEditTicket;
            vm.openResourceAllocation = openResourceAllocation;
            vm.openTimesheet = openTimesheet;
            vm.cloneTicket = cloneTicket;
            vm.cancelTicket = cancelTicket;
            vm.addRelatedTicket = addRelatedTicket;
            vm.downloadPdf = downloadPdf;
            vm.addTicketBillingPref = addTicketBillingPref;
            vm.openMenu = openMenu;
            vm.downloadPaperworkPdf = downloadPaperworkPdf;
            vm.downloadTimesheetPdf = downloadTimesheetPdf;
            vm.claimsUtilService = claimsUtilService;
            vm.jobsClaims = jobsClaimsService;
            vm.isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
            vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
            vm.isCustomFormsEnabled = claimsUtilService.isCustomFormsEnabled();
            vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();

            vm.goToFormsAndAttachment = function(){
                $state.go('app.formsattachments', { TicketId: vm.id, TicketNo : vm.ticketNo });
            };

            activate();

            function activate() {
                vm.disableTimesheet = (vm.isLocked && vm.ticketType != 6 && vm.ticketType != 3 && vm.ticketType != 7) || vm.ticketType == 1 || vm.ticketType == 4 || (vm.isSmartSchedulingEnabled && (vm.ticket.status[0].abbrev == 'AIP' || vm.ticket.status[0].abbrev == 'AID') && vm.ticket.IsLockedByPreSchedule);
            }

            function openEditTicket(id, ticketNo, isLocked, isLockedByPreSchedule, parentTicketNo) {
                (vm.onOpenEditTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        isLocked: isLocked,
                        isLockedByPreSchedule: isLockedByPreSchedule,
                        parentTicketNo: parentTicketNo
                    }
                });
            }

            function openResourceAllocation(id, ticketNo, parentTicketNo) {
                (vm.onOpenResourceAllocation || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        parentTicketNo: parentTicketNo
                    }
                });
            }

            function openTimesheet(id, isLocked, isLockedByPreSchedule, ticketNo) {
                (vm.onOpenTimesheet || angular.noop)({
                    value: {
                        id: id,
                        isLocked: isLocked,
                        isLockedByPreSchedule: isLockedByPreSchedule,
                        ticketNo: ticketNo
                    }
                });
            }

            function cloneTicket(id, ticketNo) {
                (vm.onCloneTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function cancelTicket(id, ticketNo) {
                (vm.onCancelTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        ticketType: vm.ticketType
                    }
                });
            }

            function addRelatedTicket(e, id) {
                (vm.onAddRelatedTicket || angular.noop)({
                    value: {
                        id: id
                    }
                });
            }

            function downloadPdf(e, id) {
                (vm.onDownloadPdf || angular.noop)({
                    value: {
                        id: id
                    }
                });
            }

            function addTicketBillingPref(e, dt, id) {
                (vm.onTicketBillingPref || angular.noop)({
                    value: {
                        dt: dt,
                        id: id
                    }
                });
            }

            function downloadPaperworkPdf(e, id, ticketNo) {
                (vm.onDownloadPaperworkPdf || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function downloadTimesheetPdf(e, id, ticketNo) {
                (vm.onDownloadTimesheetPdf || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function openMenu($mdOpenMenu, e) {
                $mdOpenMenu(e);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.resourceSidenav', ['app.resourceSearchFilter'])
})();

(function() {
    'use strict';

    angular.module('app.resourceSidenav')
        .directive('peopleGroup', peopleGroup);

    function peopleGroup() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceSidenav/components/resourceList/groups/people/people-group.directive.html',
            scope: {
                list: '=',
                title: '@'
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller(
            _,
            utils,
            $scope,
            contactService,
            resourceSidenavService,
            $rootScope,
            msgboxService,
            identityService,
            dateNavigationService,
            tenantSettings,
            timesheetApi,
            $q
        ) {
            var vm = this;
            vm.round = round;
            vm.getEmploymentStatus = getEmploymentStatus;
            vm.getGroup = getGroup;
            vm.showDetails = showDetails;
            vm.show = show;
            vm.finalList = [];
            vm.allocate = allocate;
            vm.service = resourceSidenavService;
            vm.showAllocateButton = showAllocateButton;
            vm.showAllocateButtonOverride = showAllocateButtonOverride;

            var measurementPostfix = utils.translate('RESOURCEALLOCATION.MEASUREMENT_POSTFIX_KILOMETERS');

            if (tenantSettings.measurementForDistance != null && tenantSettings.measurementForDistance.toLowerCase() == 'miles') {
                measurementPostfix = utils.translate('RESOURCEALLOCATION.MEASUREMENT_POSTFIX_MILES');
            }

            function show(list) {
                let count = list.filter(function(itm) {
                    return itm.Show;
                });
                return count.length > 0 ? true : false;
            }

            function showDetails(Id, $event) {
                //Show resource/contact details from the available resources
                contactService.showContactDetails(Id, true);
                $event.stopPropagation();
            }

            function getGroup(title) {
                return title === 'General' ? null : (title === 'Company Preferred' ? 0 : 1)
            }

            $scope.$watch('vm.list', function() {
                let group = vm.getGroup(vm.title);
                vm.finalList = vm.list.filter(function(l) {
                    return l.AllocationGroup === group;
                });
            });

            // Blue / red + colour is decided by resourceSidenavService (isBlueAllocatable /
            // isOverrideAllocatable) so the button colour and the "view without issues"
            // list filter stay in lock-step — a blue + always appears in the default view.
            function showAllocateButton(lookUp)
            {
                return vm.service.isBlueAllocatable(lookUp);
            }

            function showAllocateButtonOverride(lookUp)
            {
                return vm.service.isOverrideAllocatable(lookUp);
            }

            function getEmploymentStatus(empStatus) {
                let statuses = [{
                        Code: 'Casual',
                        Translation: 'RESOURCEALLOCATION.EMP_CAS'
                    },
                    {
                        Code: 'Permanent Parttime',
                        Translation: 'RESOURCEALLOCATION.EMP_PT'
                    },
                    {
                        Code: 'Labour Hire',
                        Translation: 'RESOURCEALLOCATION.EMP_LAB'
                    },
                    {
                        Code: 'Permanent Fulltime',
                        Translation: 'RESOURCEALLOCATION.EMP_FT'
                    },
                    {
                        Code: 'Salary',
                        Translation: 'RESOURCEALLOCATION.EMP_SAL'
                    }
                ];

                let status = statuses.find(function(s) {
                    return s.Code === empStatus
                });

                return status ? utils.translate(status.Translation) : null;
            }

            function round(distance) {
                return _.isNil(distance) ? null : Math.round(distance) + measurementPostfix;
            }

            function allocate(resource, isOverride) {
                var isAlreadyAllocated = _.isNil(vm.service.itm.allocatedId) && _.isNil(vm.service.itm.allocatedItemName);
                if (isAlreadyAllocated) {
                    checkForLockedAndSubmittedTimesheet(resource, isOverride);
                    return;
                }

                let msg = 'Are you sure you want to replace ' + vm.service.itm.allocatedItemName + '?';

                msgboxService.yepNo(msg, 'Resource Whiteboard', 'Yes', 'Cancel').then(function() {
                    checkForLockedAndSubmittedTimesheet(resource, isOverride);
                })
            }

            function checkForLockedAndSubmittedTimesheet(resource, isOverride) {
                getTimesheetByTicketId(vm.service.itm.ticketId).then(function(timesheet) {
                    if (timesheet) {
                        showTimesheetLockedAndSubmittedAlert(resource, isOverride, timesheet);
                    } else {
                        allocateProceed(resource, isOverride);
                    }
                });
            }

            async function showTimesheetLockedAndSubmittedAlert(resource, isOverride, timesheet) {
                const timesheetDetails = Object.values(timesheet.TicketTimesheetsDetails);
                const hasATimesheetSubmitted = timesheetDetails.some(function(data) {
                    return data.JobStartTime && data.JobEndTime
                });

                const isCurrentAllocatedHaveTimesheetSubmitted = timesheetDetails.some(function(data) {
                    return data.JobStartTime && data.JobEndTime && data.ContactId == vm.service.itm.allocatedId
                });

                if (hasATimesheetSubmitted) {
                    if (timesheet.IsLocked) {
                        let msg = utils.translate('RESOURCEALLOCATION.ADD_RESOURCE_WITH_LOCKED_AND_SUBMITTED_TIMESHEET');
                        msgboxService.yepNo(msg, 'Resource Whiteboard', 'Yes', 'No').then(function() {
                            unlockTimesheet(timesheet.id);
                            allocateProceed(resource, isOverride);
                        })

                    } else if (isCurrentAllocatedHaveTimesheetSubmitted) {
                        msgboxService.alert('Resource Whiteboard', utils.translate('RESOURCEALLOCATION.ADD_RESOURCE_WITH_SUBMITTED_TIMESHEET'), 'Okay')
                            .then(function(res) {
                                if (res) {
                                    allocateProceed(resource, isOverride);
                                }
                            });
                    } else {
                        allocateProceed(resource, isOverride);
                    }
                } else {
                    allocateProceed(resource, isOverride);
                }
            };

            function getTimesheetByTicketId(ticketId) {
                let deferred = $q.defer();

                timesheetApi.getTimesheet(ticketId).then(function(response) {
                    deferred.resolve(response.data);
                }, function(err) {
                    exceptionService.resolve(err);
                    deferred.reject(err);
                });

                return deferred.promise;
            };

            function unlockTimesheet(timesheetId) {
                blockUI.start("Unlocking timesheet...");

                timesheetApi.lockUnlockTimesheet(timesheetId, true)
                    .then(function() {
                        blockUI.stop();
                    })
                    .catch(function(err) {
                        blockUI.stop();
                        exceptionService.resolve(err);
                    });
            };

            function allocateProceed(resource, isOverride) {
                if (isOverride) {
                    msgboxService.showPromptDialog(
                            utils.translate('RESOURCEALLOCATION.OVERRIDE_REASON_TITLE'),
                            utils.translate('RESOURCEALLOCATION.OVERRIDE_REASON_MESSAGE'),
                            utils.translate('RESOURCEALLOCATION.OVERRIDE_REASON_PLACEHOLDER'),
                            true,
                            utils.translate('RESOURCEALLOCATION.ALLOCATE'),
                            "Cancel")
                        .then(function(data) {
                            broadCastData({
                                Resource: resource,
                                CurrentItem: {
                                    Id: vm.service.itm.id,
                                    ItemId: vm.service.itm.itemId,
                                    TicketId: vm.service.itm.ticketId,
                                    ResourceType: vm.service.itm.resourceType
                                },
                                Override: {
                                    Reason: data,
                                    OverrideUserId: identityService.userData.UserId
                                },
                                View: getView()
                            })
                        });

                    return;
                }

                broadCastData({
                    Resource: resource,
                    CurrentItem: {
                        Id: vm.service.itm.id,
                        ItemId: vm.service.itm.itemId,
                        TicketId: vm.service.itm.ticketId,
                        ResourceType: vm.service.itm.resourceType
                    },
                    View: getView()
                });
            }

            function getView() {
                return dateNavigationService.isDaily ? 'Daily' : 'Weekly';
            }

            function broadCastData(data) {
                $rootScope.$broadcast('Resource:Allocate', data);
                resourceSidenavService.close();
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.resourceSidenav')
        .directive('equipmentGroup', equipmentGroup);

    function equipmentGroup() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceSidenav/components/resourceList/groups/equipment/equipment-group.directive.html',
            scope: {
                list: '='
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller(
            utils,
            resourceSidenavService,
            $rootScope,
            msgboxService,
            identityService,
            dateNavigationService
        ) {
            var vm = this;
            vm.allocate = allocate;
            vm.service = resourceSidenavService;

            function allocate(resource) {
                if (vm.service.itm.allocatedId == null && vm.service.itm.allocatedItemName == null) {
                    allocateProceed(resource);
                    return;
                }

                let allocatedResourceName = vm.service.itm.allocatedItemName || vm.service.itm.allocatedCode;
                let msg = utils.translate('RESOURCEALLOCATION.REPLACE_RESOURCE') + ' ' + allocatedResourceName + '?';

                msgboxService.yepNo(msg, 'Resource Whiteboard', 'Yes', 'Cancel').then(function() {
                    allocateProceed(resource);
                })
            }

            function allocateProceed(resource) {
                // #51715: gate the override-reason prompt on CanBeOverriden (which already encodes
                // Medium && hasOverridePermission) instead of raw LockoutType, so a no-override user
                // falls through to a normal allocate (vehicle allocated, operator-error popup) and
                // never the modal. Mirrors draggable-equipment.js:40 — the original #51715 fix patched
                // that sibling but missed this Available Equipment panel handler.
                let canOverride = resource.AllocationIssues.some(x => x.CanBeOverriden)
                                && resource.AllocationIssues.every(x => x.LockoutType != vm.service.lockoutType.HardLockout);

                if (canOverride) {
                    msgboxService.showPromptDialog(
                            utils.translate('RESOURCEALLOCATION.OVERRIDE_REASON_TITLE'),
                            utils.translate('RESOURCEALLOCATION.OVERRIDE_REASON_MESSAGE'),
                            utils.translate('RESOURCEALLOCATION.OVERRIDE_REASON_PLACEHOLDER'),
                            true,
                            utils.translate('RESOURCEALLOCATION.ALLOCATE'),
                            "Cancel")
                        .then(function(data) {

                            broadCastData({
                                Resource: resource,
                                CurrentItem: {
                                    Id: vm.service.itm.id,
                                    ItemId: vm.service.itm.itemId,
                                    TicketId: vm.service.itm.ticketId,
                                    ResourceType: vm.service.itm.resourceType
                                },
                                Override: {
                                    Reason: data,
                                    OverrideUserId: identityService.userData.UserId
                                },
                                View: getView()
                            })
                        });

                    return;
                }

                broadCastData({
                    Resource: resource,
                    CurrentItem: {
                        Id: vm.service.itm.id,
                        ItemId: vm.service.itm.itemId,
                        TicketId: vm.service.itm.ticketId,
                        ResourceType: vm.service.itm.resourceType
                    },
                    View: getView()
                })
            }

            function broadCastData(data) {
                $rootScope.$broadcast('Resource:Allocate', data);
                resourceSidenavService.close();
            }

            function getView() {
                return dateNavigationService.isDaily ? 'Daily' : 'Weekly';
            }
        }
    }
})();

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelComponent = function (_React$Component) {
  _inherits(LabelComponent, _React$Component);

  function LabelComponent() {
    _classCallCheck(this, LabelComponent);

    return _possibleConstructorReturn(this, (LabelComponent.__proto__ || Object.getPrototypeOf(LabelComponent)).call(this));
  }

  _createClass(LabelComponent, [{
    key: "render",
    value: function render() {
      var is_locked = this.props.locked;
      if (is_locked) {
        return React.createElement(
          "div",
          { className: "layout-row header_style_locked flex layout-align-end-center" },
          React.createElement("i", { "class": "icon-lock s16 grey-50-fg" })
        );
      } else {
        return React.createElement("div", { className: "layout-row header_style flex layout-align-end-center" });
      }
    }
  }]);

  return LabelComponent;
}(React.Component);

LabelComponent.propTypes = {
  locked: React.PropTypes.bool
};
LabelComponent.defaultProps = {
  locked: false
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TicketDetailComponent = function (_React$Component) {
  _inherits(TicketDetailComponent, _React$Component);

  function TicketDetailComponent() {
    _classCallCheck(this, TicketDetailComponent);

    var _this = _possibleConstructorReturn(this, (TicketDetailComponent.__proto__ || Object.getPrototypeOf(TicketDetailComponent)).call(this));

    _this.showdialog = _this.showdialog.bind(_this);
    return _this;
  }

  _createClass(TicketDetailComponent, [{
    key: "showdialog",
    value: function showdialog(item) {
      this.props.showdialog(item);
    }
  }, {
    key: "render",
    value: function render() {
      var self = this;
      return React.createElement(
        "div",
        { key: this.props.item.Id, className: "layout-column ticket-detail" },
        React.createElement(
          "div",
          { className: "layout-column flex md-whiteframe-4dp" },
          React.createElement(
            "div",
            { className: "layout-column flex ticket-main-detail" },
            React.createElement(
              "div",
              { className: "card-company 16px layout-padding layout-row company layout-align-start-start" },
              React.createElement(
                "span",
                null,
                this.props.item.CompanyName
              )
            ),
            React.createElement(
              "div",
              { className: "small-font layout-padding layout-row layout-align-start-start" },
              React.createElement(
                "span",
                null,
                React.createElement("i", { className: "icon-map-marker s16 red-700-fg" })
              ),
              React.createElement(
                "span",
                null,
                this.props.item.BranchName
              )
            ),
            React.createElement(
              "div",
              { className: "small-font address layout-padding layout-row layout-align-start-start address-section" },
              React.createElement(
                "span",
                null,
                React.createElement("i", { className: "icon-map-marker s16 red-700-fg" })
              ),
              React.createElement(
                "span",
                null,
                this.props.item.JobLocationAddress.FullAddress
              )
            )
          ),
          React.createElement(TicketFooterComponent, { ticketno: this.props.item.TicketNumber })
        ),
        React.createElement(
          "div",
          { className: "layout-row layout-align-center-center item-separator" },
          React.createElement("i", { className: "blue-700-fg icon-filter-variant" })
        ),
        React.createElement(BillingSection, { showdialog: self.showdialog, items: this.props.item.Items })
      );
    }
  }]);

  return TicketDetailComponent;
}(React.Component);

TicketDetailComponent.propTypes = {
  item: React.PropTypes.object,
  showdialog: React.PropTypes.func
};
TicketDetailComponent.defaultProps = {
  item: null,
  showdialog: function showdialog() {}
};
(function () {
    'use strict';

    angular
        .module('app.jobs.allocate',
            [
                'app.jobs.allocate.draggable',
                'app.jobs.allocate.droppable',
                'app.resourceSearchFilter'
            ]).config(config)
        .run(AllocateResourceRunConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $translatePartialLoaderProvider.addPart('app/main/jobs/allocateResource');

        $stateProvider
            .state('app.allocate', {
                url: '/allocate-ticket-resources/:id?/:ticketNo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/jobs/allocateResource/allocate-resource.html'
                        , controller: 'AllocateResourceController as vm'
                    }
                }
                , params: {parentTicketNo: null}
                , data: {requireLogin: true}
                , title: 'Allocate Resource'
                , titleBar: 'Alloc8 - Allocate Resource'
            });
    }

    function AllocateResourceRunConfig(ResourceAllocationSignalRService) {
        ResourceAllocationSignalRService.register();
    }
})();

(function() {
    'use strict';

    angular.module('app.jobs.allocate')
        .directive('draggablePerson', draggableComponent);

    function draggableComponent(utils, _) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/allocateResource/components/draggableComponent/draggableComponent/people/draggable-person.html',
            scope: {
                service: '=',
                sectionTitle: '@',
                filter: '@'
            },
            controller: draggableComponentController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function draggableComponentController($scope) {
            let vm = this;
            vm.utilService = utils;
            vm.showAllocateButton = showAllocateButton;
            vm.showAllocateButtonOverride = showAllocateButtonOverride;

            let allocationGroup = vm.filter === "" ? null : parseInt(vm.filter);
            let people = angular.copy(vm.service.lookUps2);
            vm.available_people = _.filter(people, {
                AllocationGroup: allocationGroup
            });

            $scope.$watch('vm.service.lookUps2', function() {
                vm.available_people = angular.copy(vm.service.lookUps2);
                vm.available_people = _.filter(vm.available_people, {
                    AllocationGroup: allocationGroup
                });
            });

            // Blue / red + colour is decided by allocate-resource.service (isBlueAllocatable /
            // isOverrideAllocatable) so the button colour and the "view without issues"
            // list filter stay in lock-step — a blue + always appears in the default view.
            function showAllocateButton(lookUp)
            {
                return vm.service.isBlueAllocatable(lookUp);
            }

            function showAllocateButtonOverride(lookUp)
            {
                return vm.service.isOverrideAllocatable(lookUp);
            }
        }
    }
})();

(function(){
  'use strict';

  angular.module('app.jobs.allocate')
    .directive('draggableEquipment', draggableEquipment);

  function draggableEquipment(utils) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/jobs/allocateResource/components/draggableComponent/draggableComponent/equipment/draggable-equipment.html',
      scope: {
        service : '='
      },
      controller: draggableComponentController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function draggableComponentController($scope) {
      var vm = this;
      vm.utilService = utils;
      vm.allocateEquipment = allocateEquipment;

      $scope.$watch('vm.service.lookUps2', function(){
          if(vm.service.lookUps2.length > 0){
              angular.forEach(vm.service.lookUps2, function(lookup){
                  lookup['Display'] = lookup.Code + " - " + lookup.Name;
              });
          }
      })

      function allocateEquipment(lookUp) {

        // #51715: route to the override-reason modal only when the operator's issues are
        // actually overridable for THIS user — CanBeOverriden already encodes
        // (Medium && hasOverridePermission). A no-override user therefore falls through to a
        // normal allocate (vehicle allocated, operator-error popup), never the modal.
        let canOverride = lookUp.AllocationIssues.some(x => x.CanBeOverriden)
                          && lookUp.AllocationIssues.every(x => x.LockoutType != vm.service.lockoutType.HardLockout);
        
        if (canOverride)
        {
          vm.service.allocateOverride(lookUp)
          return;
        }

        vm.service.allocateToggle(lookUp)
      }
    }
  }
})();

/**
 * Editable grid using Angular material
 * Note: Control is specific only to invoicing module, to make it generic needs more decoupling design
 * - decouple the header column creation and the templating should use angular Transclusion
 * 
 * Author: Rcnet
 * 12.22.2016
 */
(function() {
    'use strict';

    angular.module('app.invoice')
        .directive('editableTableComponent', editableTableComponent);

    /** @ngInject */
    function editableTableComponent(exceptionService,
        _,
        utils,
        $timeout,
        assetsApi,
        alasql,
        $rootScope,
        $mdDialog,
        invoiceRulesService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/reports/dialogs/edit-invoice/directives/editable-table/editable-table.html',
            scope: {
                srcData: '=',
                linkObject: '=',
                fieldDef: '=',
                onColChange: '&',
                onRemoveRow: '&',
                onEdit: '&',
                onEditDone: '&'
            },
            controller: EditableTableController,
            controllerAs: 'editableTableVm',
            bindToController: true,
            link: link
        };

        function EditableTableController($scope) {
            var vm = this;
            vm.currentEditedId = 0;

            // Data
            vm.sortableOpts = {
                handle: '.moveHandle',
                stop: function(e, ui) {
                    sortableUpdateFunc(e, ui);
                }
            };
            vm.isEditMode = false;

            // Methods
            vm.showAdd = false;
            vm.onMouseOver = onMouseOver;
            vm.onDoubleClick = onDoubleClick;

            vm.handlers = {
                fieldEditDelegates: [],
                cancelEditDelegates: [],
                updateDelegates: [],
                disableActionDelegates: [],
                forceActionEditDelegates: [],
                columnChangeDelegates: []
            };

            activate();

            ///////
            function activate() {
                // Add API (expose it)
                if (vm.linkObject) {
                    vm.linkObject.onCancel = onCancel;
                }
            }

            /**
             * Mouse over row event
             */
            function onMouseOver() {
                //vm.showAdd = true;
            }

            /**
             * For double click row event
             */
            function onDoubleClick(id) {
                if (vm.isEditMode) return;
                vm.currentEditedId = id;
                this.disableAllAction(true);
                this.forceActionEdit(id);
            }

            /**
             * Sortable update logic
             */
            function sortableUpdateFunc(e, ui) {
                reSortSrcData();
            }

            function reSortSrcData() {
                var i = 0;
                vm.srcData.map(function(itm) {
                    itm.SequenceNo = ++i;
                });
            }

            /**
             * The code below is a workaround just to cope with Scoping issues in javascript
             */
            function onCancel() {
                var id = vm.currentEditedId;
                vm.currentEditedId = 0;

                //if (vm.isEditMode == false) return;
                vm.isEditMode = false;

                // Check data if newly created and if no field values then remove it from the list
                let data = _.find(vm.srcData, function(o) {
                    return o.Id === id;
                });

                // Validate if nulls then remove it
                if (data) {
                    if (data.IsNewlyCreated &&
                        data.Description === null &&
                        data.CostCodeObj === null &&
                        data.ItemCodeObj === null &&
                        data.Quantity === null &&
                        data.UnitPriceExcludingTax === null &&
                        data.UnitTax === null &&
                        data.Amount === null) {

                        _.remove(vm.srcData, function(o) {
                            return o.Id === id;
                        });
                    }
                }

                vm.handlers.cancelEditDelegates.forEach(function(handler) {
                    handler(id);
                });
            }
        }

        EditableTableController.prototype.editField = function(id, isEdit) {
            this.isEditMode = true;
            this.currentEditedId = id;
            this.handlers.fieldEditDelegates.forEach(function(handler) {
                handler(id, isEdit);
            });

            // Notify client consumer
            (this.onEdit || angular.noop)();
        }

        EditableTableController.prototype.onEditField = function(handler) {
            this.handlers.fieldEditDelegates.push(handler);
        }

        EditableTableController.prototype.cancelEdit = function(id) {
            this.currentEditedId = 0;
            if (this.isEditMode == false) return;
            this.isEditMode = false;

            // Check data if newly created and if no field values then remove it from the list
            let data = _.find(this.srcData, function(o) {
                return o.Id === id;
            });

            // Todo: Revise this code below
            // Note: Workaround again here this event cancelEdit fires first before the field editor cancelEdit :(
            $timeout(function() {
                invoiceRulesService.computeLineItem(data);
            }, 500);

            // Validate if nulls then remove it
            if (data) {
                if (data.IsNewlyCreated &&
                    data.Description === null &&
                    data.CostCodeObj === null &&
                    data.ItemCodeObj === null &&
                    data.Quantity === null &&
                    data.UnitPriceExcludingTax === null &&
                    data.UnitTax === null &&
                    data.Amount === null) {

                    _.remove(this.srcData, function(o) {
                        return o.Id === id;
                    });
                }
            }

            this.handlers.cancelEditDelegates.forEach(function(handler) {
                handler(id);
            });

            (this.onEditDone || angular.noop)();
        }

        EditableTableController.prototype.onCancelEdit = function(handler) {
            this.handlers.cancelEditDelegates.push(handler);
        }

        EditableTableController.prototype.updateEdit = function(id) {
            this.isEditMode = false;
            this.currentEditedId = 0;
            this.handlers.updateDelegates.forEach(function(handler) {
                handler(id);
            });

            (this.onEditDone || angular.noop)();
        }

        EditableTableController.prototype.onUpdateEdit = function(handler) {
            this.handlers.updateDelegates.push(handler);
        }

        EditableTableController.prototype.disableAllAction = function(isDisabled) {
            this.handlers.disableActionDelegates.forEach(function(handler) {
                handler(isDisabled);
            });
        }

        EditableTableController.prototype.onDisableAction = function(handler) {
            this.handlers.disableActionDelegates.push(handler);
        }

        /**
         * Todo: Fire onValidate to consumer to support loose coupling!!!
         */
        EditableTableController.prototype.onValidate = function(id) {
            let data = _.find(this.srcData, function(o) {
                return o.Id === id;
            });


            let retFlag = true;

            // Todo: Move this code to consumer!!!
            if ((data.Quantity !== null && data.Quantity !== 0) && (!utils.isNullOrEmpty(data.UnitPriceExcludingTax))) {
                if (utils.isUndefinedOrNull(data.CostCodeObj) || utils.isUndefinedOrNull(data.ItemCodeObj)) {
                    showValidationMessage('Please enter a valid Cost and Item Code.', 'Invalid Input');
                    retFlag = false;
                }
            } else if (data.Quantity !== null && (utils.isNullOrEmpty(data.UnitPriceExcludingTax))) {
                showValidationMessage('Please enter a valid Unit Price.', 'Invalid Input');
                retFlag = false;
            } else if (!utils.isNullOrEmpty(data.UnitPriceExcludingTax) && (utils.isNullOrEmpty(data.Quantity) || data.Quantity === 0)) {
                showValidationMessage('Please enter a valid Quantity.', 'Invalid Input');
                retFlag = false;
            } else if (!utils.isUndefinedOrNull(data.CostCodeObj) && !utils.isUndefinedOrNull(data.ItemCodeObj)) {
                if (utils.isNullOrEmpty(data.UnitPriceExcludingTax) && utils.isNullOrEmpty(data.Quantity)) {
                    showValidationMessage('Please enter a valid Unit Price and Quantity.', 'Invalid Input');
                    retFlag = false;
                }
            } else if ((utils.isUndefinedOrNull(data.CostCodeObj) || utils.isUndefinedOrNull(data.ItemCodeObj)) && (!utils.isNullOrEmpty(data.UnitPriceExcludingTax) && utils.isNullOrEmpty(data.Quantity))) {
                showValidationMessage('Please enter a valid Cost and Item Code.', 'Invalid Input');
                retFlag = false;
            }

            return retFlag;
        }

        function showValidationMessage(desc) {
            $mdDialog.show({
                templateUrl: 'app/main/invoice/reports/dialogs/inv-line-item-val/inv-line-item-dialog.html',
                controller: 'InvoiceLineItemDialogController',
                controllerAs: 'vm',
                locals: { desc: desc },
                multiple: true
            }).then(function(resp) {}, function(resp) {});
        }

        EditableTableController.prototype.onForceActionEdit = function(handler) {
            this.handlers.forceActionEditDelegates.push(handler);
        }

        EditableTableController.prototype.forceActionEdit = function(id) {
            this.isEditMode = true;
            this.currentEditedId = id;
            this.handlers.forceActionEditDelegates.forEach(function(handler) {
                handler(id);
            });

            (this.onEdit || angular.noop)();
        }

        EditableTableController.prototype.onColumnChange = function(handler) {
            this.handlers.columnChangeDelegates.push(handler);
        }

        EditableTableController.prototype.columnChange = function(columnName, id) {
            this.handlers.columnChangeDelegates.forEach(function(handler) {
                handler(columnName, id);
            });

            // Notify consumer
            (this.onColChange || angular.noop)({ columnName: columnName, id: id });
        }

        /**
         * Accepts promise object
         */
        EditableTableController.prototype.removeItem = function(id) {
            let self = this;

            let itemToRemove = _.find(this.srcData, function(o) {
                return o.Id === id;
            });

            // Fire up confirmation to consumer
            let removeItemPromise = (this.onRemoveRow || angular.noop)({ desc: itemToRemove.Description });

            removeItemPromise.then(function(resp) {
                _.remove(self.srcData, function(o) {
                    return o.Id === id;
                });
            });
        }

        EditableTableController.prototype.addNew = function(relativeRowId) {
            if (this.srcData != null) {
                let self = this;
                let data = this.createEmptyTemplateModel();


                // Find and insert on top of the relative row id
                let rowResultIndex = _.findIndex(this.srcData, function(o) {
                    return o.Id === relativeRowId;
                });

                // Insert
                this.srcData.splice(rowResultIndex, 0, data);

                // Give angular time to schedule Digest cycle, we want to make sure that it renders the new data in DOM first before proceeding to editing.
                $timeout(function() {
                    self.forceActionEdit(data.Id);
                }, 0);
            }
        }

        EditableTableController.prototype.createEmptyTemplateModel = function() {
            return {
                Id: utils.newGuid(),
                Description: null,
                CostCodeObj: null,
                ItemCodeObj: null,
                Quantity: null,
                UnitPriceExcludingTax: null,
                UnitTax: null,
                Amount: null,
                IsEdit: false,
                IsNewlyCreated: true
            };
        }

        function link(scope, elems, attr, controller) {}

        return directive;
    }
})();
/**
 * Invoice report module
 * Created date: 12.12.2016
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports', [])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.invoice_report', {
            url: '/invoice/reports/preview_invoices',
            views: {
                'content@app': {
                    templateUrl: 'app/main/invoice/reports/invoice-report-manager.default.html',
                    controller: 'InvoiceReportManagerController as invRepVm'
                }
            },
            data: { 
                requireLogin: true, 
                validateAccess: ['invoiceClaimsService', function (invoiceClaimsService) {
                    return invoiceClaimsService.hasPreviewInvoiceMenu;
                }] 
            },
            resolve: {
                branchesData: branchResolver,
                costCodes: costCodesResolver
            },
            title: 'Preview Invoices',
            titleBar: 'Alloc8 - Preview Invoices'
         })
        .state('app.invoice_popup_details_preview',{
            url: '/invoice/reports/popup-resource-details',
            views: {
                'content@app': {
                    templateUrl: 'app/main/invoice/reports/directives/reportViewer/invoice-popup-resource.html',
                    controller: 'InvoicePopupResourceController as vm'
                }
            },
            data: { requireLogin: true },
            title: 'Invoice Resource Details',
        });

        $translatePartialLoaderProvider.addPart('app/main/invoice');


    };

    /** @ngInject */
    function branchResolver(invoiceLookupService) { //reportSideNavService) {
        invoiceLookupService.loadAll();
        //return reportSideNavService.loadLookups();
    }

    /** @ngInject */
    function costCodesResolver(editInvoiceReportService) {
        return editInvoiceReportService.loadLookups();
    }

    function runConfig(invoiceHubService) {
        // SignalR hub
        invoiceHubService.register();
    }


})();
/**
 * Editable Line Item Service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('editableLineItemService', editableLineItemService);

    /** @ngInject */
    function editableLineItemService($q,
        exceptionService,
        moment
    ) {
        var service = {
            addExtendedProperties: addExtendedProperties,
            sanitizeModel: sanitizeModel,
            fixId: fixId
        };

        activate();

        return service;
        //////

        function activate() {}

        /**
         * Mutates line item object to support grid functionality
         * @param {*} Line Item object 
         */
        function addExtendedProperties(lineItem) {
            lineItem['mode'] = 'R';
            lineItem['IsChecked'] = false;
        }

        /**
         * Remove unnecessary properties in the model
         * @param {*} data 
         */
        function sanitizeModel(data) {
            var clonedData = angular.copy(data);
            clonedData.forEach(function(lineItem) {
                lineItem.Id = _.startsWith(lineItem.Id, 'new') ? null : lineItem.Id;
            });
            return clonedData;
        }

        /**
         * This will fix ID created by editable-line item grid (React ver)
         * @param {*} id 
         */
        function fixId(id) {
            return _.startsWith(id, 'new') ? null : id;
        }

    }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableLineItem = function (_React$Component) {
    _inherits(EditableLineItem, _React$Component);

    function EditableLineItem(props) {
        _classCallCheck(this, EditableLineItem);

        var _this = _possibleConstructorReturn(this, (EditableLineItem.__proto__ || Object.getPrototypeOf(EditableLineItem)).call(this, props));

        _this.addLine = _this.addLine.bind(_this);
        _this.editLine = _this.editLine.bind(_this);
        _this.deleteLine = _this.deleteLine.bind(_this);
        _this.cancelLineEditing = _this.cancelLineEditing.bind(_this);
        _this.updateLine = _this.updateLine.bind(_this);
        _this.addInitialLineItem = _this.addInitialLineItem.bind(_this);
        _this.changeCheckSelection = _this.changeCheckSelection.bind(_this);
        _this.changeCheckAllSelection = _this.changeCheckAllSelection.bind(_this);
        _this.deleteSelected = _this.deleteSelected.bind(_this);
        _this.refreshRateCard = _this.refreshRateCard.bind(_this);
        _this.checkDescriptionControlType = _this.checkDescriptionControlType.bind(_this);
        _this.editTaxRate = _this.editTaxRate.bind(_this);
        _this.changeItemCode = _this.changeItemCode.bind(_this);

        _this.state = {
            lineitems: _this.props.lineitems,
            ratecarditems: _this.props.ratecarditems,
            isaltusspecialenabled: _this.props.isaltusspecialenabled,
            costcodes: _this.extendCostCodes(_this.props.costcodes),
            itemcodes: _this.props.itemcodes,
            isEditMode: false,
            isCheckedAll: false,
            taxroundingrule: _this.props.taxroundingrule
        };
        return _this;
    }

    _createClass(EditableLineItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var self = this;
            // Note: Anti-pattern dont do this just a work around for now!!!
            // Pain in the ass to encounter this issue - rcnet
            window.callReactDeleteLineItem = function (id) {
                self.performDeleteLine(id);
            };

            window.callReactDeleteLineItems = function () {
                self.performDeleteLines();
            };

            window.getLineItemDataInReact = function () {
                // Sanitize line item collection
                // Set id to null if new line item (prefixed by 'new')
                var clonedItems = _.cloneDeep(self.state.lineitems);
                _.forEach(clonedItems, function (o) {
                    //o.Id = _.startsWith(o.Id, 'new') ? null : o.Id;
                    o.CostCode = o.CostCode == '-1' ? null : o.CostCode;
                    o.ItemCode = o.ItemCode == '-1' ? null : o.ItemCode;
                    delete o['mode'];
                    delete o['rowType'];
                });

                return clonedItems;
            };

            // Note: For US client only
            window.updateTaxRate = function (tax) {
                self.updateTaxRate(tax);
            };

            window.updateTaxRateForAllSelectedItems = function (items) {
                self.updateTaxRateForAllSelectedItems(items);
            };
        }
    }, {
        key: 'extendCostCodes',
        value: function extendCostCodes() {
            var codes = _.cloneDeep(this.props.costcodes);
            codes.splice(0, 0, { Id: '-1', Description: '- Select Cost Code -' });
            return codes;
        }
    }, {
        key: 'extendItemCodes',
        value: function extendItemCodes() {
            var codes = _.cloneDeep(this.props.itemcodes);
            codes.splice(0, 0, { Id: '-1', Description: '- Select Item Code -' });
            return codes;
        }
    }, {
        key: 'moveRow',
        value: function moveRow(id) {}
    }, {
        key: 'addLine',
        value: function addLine(id, rowType) {
            if (!this.state.isEditMode) {
                var self = this;
                var clonedLineItems = _.cloneDeep(this.state.lineitems);

                // Disable all buttons if edit mode
                _.forEach(clonedLineItems, function (i) {
                    i['isRowEnabled'] = false;
                });

                // Then prepare adding new empty line
                var index = _.findIndex(this.state.lineitems, function (o) {
                    return o.Id === id;
                });

                var indx = index + 1;
                clonedLineItems.splice(indx, 0, {
                    mode: 'C',
                    rowType: rowType,
                    Id: 'new-' + self.newGuid(),
                    ItemId: '',
                    ItemType: '',
                    RateCardItems: self.state.ratecarditems,
                    Description: '',
                    CostCodeDesc: '',
                    ItemCodeDesc: '',
                    Quantity: '',
                    UnitPriceExcludingTax: '',
                    CityAmount: 0,
                    CityTaxRate: 0,
                    CountyAmount: 0,
                    CountyTaxRate: 0,
                    StateAmount: 0,
                    StateSalesTaxRate: 0,
                    SpecialDistrictAmount: 0,
                    SpecialTaxRate: 0,
                    TaxRate: 0, // Combined Tax rate
                    UnitTax: '',
                    TotalTax: '',
                    Amount: ''
                });

                // Re-Sort line items sequence no.
                self.reSortSrcData(clonedLineItems);

                this.setState({
                    lineitems: clonedLineItems,
                    isEditMode: true
                });

                this.props.ontoggleedit(true);
            }
        }
    }, {
        key: 'getPreviousTaxRate',
        value: function getPreviousTaxRate(index) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            if (clonedLineItems.length <= 0) return;
            var previousTaxItem = clonedLineItems[index];

            if (self.isLineComment(previousTaxItem)) return;

            // Copy previous tax rate
            return previousTaxItem;
        }
    }, {
        key: 'isLineComment',
        value: function isLineComment(item) {
            return item.Description == null || item.Description.toUpperCase() == 'SUPPLY OF TRAFFIC CONTROLLERS AT' || item.Quantity == 0 && item.UnitPriceExcludingTax <= 0;
        }
    }, {
        key: 'reSortSrcData',
        value: function reSortSrcData(items) {
            var i = 0;
            items.map(function (itm) {
                itm['SequenceNo'] = ++i;
            });
        }
    }, {
        key: 'editLine',
        value: function editLine(id) {
            if (!this.state.isEditMode) {
                var clonedLineItems = _.cloneDeep(this.state.lineitems);

                // Disable all buttons if edit mode
                _.forEach(clonedLineItems, function (i) {
                    i['isRowEnabled'] = false;
                });

                var itemToUpdate = _.find(clonedLineItems, function (o) {
                    return o.Id === id;
                });

                itemToUpdate.mode = 'E';
                itemToUpdate.isRowEdit = false;
                this.setState({
                    lineitems: clonedLineItems,
                    isEditMode: true
                });

                this.props.ontoggleedit(true);
            }
        }
    }, {
        key: 'updateLine',
        value: function updateLine(data) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);

            // Disable all buttons if edit mode
            _.forEach(clonedLineItems, function (i) {
                i['isRowEnabled'] = true;
            });

            var itemToUpdate = _.find(clonedLineItems, function (o) {
                return o.Id === data.Id;
            });

            var ItemId = '';
            var ItemType = '';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.state.ratecarditems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.hasOwnProperty('itemId')) {
                        if (item.id == data.RateCardItemCode) {
                            ItemId = item.itemId;
                            ItemType = item.itemType;
                            break;
                        }
                    }

                    if (item.hasOwnProperty('children')) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = item.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var i = _step2.value;

                                if (i.id == data.RateCardItemCode) {
                                    ItemId = i.itemId;
                                    ItemType = i.itemType;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            itemToUpdate.mode = 'R';
            itemToUpdate.Id = data.Id;
            itemToUpdate.ItemId = ItemId;
            itemToUpdate.ItemType = ItemType;
            itemToUpdate.Description = data.Description;
            itemToUpdate.CostCode = data.CostCode;
            itemToUpdate.ItemCode = data.ItemCode;
            itemToUpdate.CostCodeDesc = this.getCostCodeDescription(data.CostCode);
            itemToUpdate.ItemCodeDesc = this.getItemCodeDescription(data.ItemCode);
            itemToUpdate.Quantity = data.Quantity;
            itemToUpdate.UnitPriceExcludingTax = data.UnitPriceExcludingTax;
            itemToUpdate.UnitTax = data.UnitTax;
            itemToUpdate.TotalTax = data.TotalTax;
            itemToUpdate.Amount = data.Amount;
            itemToUpdate.CityAmount = data.CityAmount;
            itemToUpdate.CityTaxRate = data.CityTaxRate;
            itemToUpdate.CountyAmount = data.CountyAmount;
            itemToUpdate.CountyTaxRate = data.CountyTaxRate;
            itemToUpdate.StateAmount = data.StateAmount;
            itemToUpdate.StateSalesTaxRate = data.StateSalesTaxRate;
            itemToUpdate.SpecialDistrictAmount = data.SpecialDistrictAmount;
            itemToUpdate.SpecialTaxRate = data.SpecialTaxRate;
            itemToUpdate.TaxRate = data.TaxRate;

            // Re-Sort line items sequence no.
            self.reSortSrcData(clonedLineItems);

            this.setState({
                lineitems: clonedLineItems,
                isEditMode: false
            });

            this.props.ontoggleedit(false);
        }

        // Note: Only for US

    }, {
        key: 'updateTaxRate',
        value: function updateTaxRate(data) {
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            var itemToUpdate = _.find(clonedLineItems, function (o) {
                return o.Id === data.Id;
            });

            itemToUpdate.TaxRate = data.CombinedTaxRate;
            itemToUpdate.CityTaxRate = data.CityTaxRate;
            itemToUpdate.CountyTaxRate = data.CountyTaxRate;
            itemToUpdate.StateSalesTaxRate = data.StateSalesTaxRate;
            itemToUpdate.SpecialTaxRate = data.SpecialTaxRate;

            this.setState({
                lineitems: clonedLineItems
            });
        }
    }, {
        key: 'getCostCodeDescription',
        value: function getCostCodeDescription(code) {
            if (!this.state.isaltusspecialenabled) {
                return code;
            }
            var result = _.find(this.state.costcodes, function (o) {
                return o.Id == code;
            });

            return result == null || result.Id == '-1' ? '' : result.Description;
        }
    }, {
        key: 'getItemCodeDescription',
        value: function getItemCodeDescription(code) {
            if (!this.state.isaltusspecialenabled) {
                return code;
            }
            var result = _.find(this.state.itemcodes, function (o) {
                return o.id == code;
            });

            return result == null || result.id == '-1' ? '' : result.text;
        }
    }, {
        key: 'cancelLineEditing',
        value: function cancelLineEditing(id) {
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            // Disable all buttons if edit mode
            _.forEach(clonedLineItems, function (i) {
                i['isRowEnabled'] = true;
            });

            var itemToCancel = _.find(clonedLineItems, function (o) {
                return o.Id === id;
            });

            // Check if CREATE mode
            if (itemToCancel.mode === 'C') {
                _.remove(clonedLineItems, function (o) {
                    return o.Id === id;
                });
                // Check if EDIT mode
            } else if (itemToCancel.mode === 'E') {
                itemToCancel.mode = 'R';
            }

            this.setState({
                lineitems: clonedLineItems,
                isEditMode: false
            });

            this.props.ontoggleedit(false);
        }
    }, {
        key: 'deleteLine',
        value: function deleteLine(id, desc) {
            this.props.ondelete(id, desc);
        }
    }, {
        key: 'performDeleteLine',
        value: function performDeleteLine(id) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            _.remove(clonedLineItems, function (o) {
                return o.Id === id;
            });

            // Re-Sort line items sequence no.
            self.reSortSrcData(clonedLineItems);

            this.setState({
                lineitems: clonedLineItems
            });
        }
    }, {
        key: 'performDeleteLines',
        value: function performDeleteLines() {
            var checkedItems = this.getCheckedItems();
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            _.forEach(checkedItems, function (i) {
                _.remove(clonedLineItems, function (o) {
                    return o.Id === i.Id;
                });
            });

            // Re-Sort line items sequence no.
            this.reSortSrcData(clonedLineItems);
            this.setState({
                lineitems: clonedLineItems,
                isCheckedAll: false
            });
        }
    }, {
        key: 'editTaxRate',
        value: function editTaxRate(id) {
            this.props.onedittaxrate(id);
        }

        /**
         * Update selected line item's Monetary and rate props
         */

    }, {
        key: 'updateTaxRateForAllSelectedItems',
        value: function updateTaxRateForAllSelectedItems(data) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);

            _.forEach(data, function (itm) {
                var itemToUpdate = _.find(clonedLineItems, function (o) {
                    return o.Id === itm.Id;
                });

                itemToUpdate.UnitPriceExcludingTax = itm.UnitPriceExcludingTax;
                itemToUpdate.UnitTax = itm.UnitTax;
                itemToUpdate.TotalTax = itm.TotalTax;
                itemToUpdate.Amount = itm.Amount;
                itemToUpdate.CityAmount = itm.CityAmount;
                itemToUpdate.CityTaxRate = itm.CityTaxRate;
                itemToUpdate.CountyAmount = itm.CountyAmount;
                itemToUpdate.CountyTaxRate = itm.CountyTaxRate;
                itemToUpdate.StateAmount = itm.StateAmount;
                itemToUpdate.StateSalesTaxRate = itm.StateSalesTaxRate;
                itemToUpdate.SpecialDistrictAmount = itm.SpecialDistrictAmount;
                itemToUpdate.SpecialTaxRate = itm.SpecialTaxRate;
                itemToUpdate.TaxRate = itm.TaxRate;
            });

            this.setState({
                lineitems: clonedLineItems
            });
        }

        /**
         * Individual checkbox handling/ this is per item
         * @param {*} id
         */

    }, {
        key: 'changeCheckSelection',
        value: function changeCheckSelection(id) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);

            var itemToUpdate = _.find(clonedLineItems, function (o) {
                return o.Id === id;
            });

            // Toggle
            itemToUpdate.IsChecked = !itemToUpdate.IsChecked;

            // Re-Sort line items sequence no.
            // Update and wait for synchronous update
            this.setState({
                lineitems: clonedLineItems
            }, function () {
                var hasCheckedItemsResult = this.hasCheckedItems();
                self.setState({ isCheckedAll: hasCheckedItemsResult });
            });
        }

        /**
         * Manages the Check All checkbox
         * @param {*} event
         */

    }, {
        key: 'changeCheckAllSelection',
        value: function changeCheckAllSelection(event) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);

            // Toggle
            _.forEach(clonedLineItems, function (o) {
                o.IsChecked = event.target.checked;
            });

            this.setState({
                lineitems: clonedLineItems,
                isCheckedAll: event.target.checked
            });
        }

        /**
         * Check if there's any checked items
         */

    }, {
        key: 'hasCheckedItems',
        value: function hasCheckedItems() {
            return this.getNumberOfCheckedItems() > 0;
        }

        /**
         * Returns Total number of checked items
         */

    }, {
        key: 'getNumberOfCheckedItems',
        value: function getNumberOfCheckedItems() {
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            var resultsFound = _.filter(clonedLineItems, function (o) {
                return o.IsChecked == true;
            });

            return resultsFound.length;
        }
    }, {
        key: 'deleteSelected',
        value: function deleteSelected() {
            this.props.ondeleteselected(this.getNumberOfCheckedItems());
        }

        /**
         * Get checked items for (deletion or something else)
         */

    }, {
        key: 'getCheckedItems',
        value: function getCheckedItems() {
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            var resultsFound = _.filter(clonedLineItems, function (o) {
                return o.IsChecked == true;
            });

            return resultsFound;
        }
    }, {
        key: 'refreshRateCard',
        value: function refreshRateCard(id) {
            return this.props.onrefreshratecard(id);
        }
    }, {
        key: 'checkDescriptionControlType',
        value: function checkDescriptionControlType(data) {
            return this.props.checkdescriptioncontroltype(data);
        }

        /**
         * Create blank item here
         */

    }, {
        key: 'addInitialLineItem',
        value: function addInitialLineItem() {
            this.addLine('id-not-exist', 'entry');
        }
    }, {
        key: 'newGuid',
        value: function newGuid() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : r & 0x7 | 0x8).toString(16);
            });
            return uuid;
        }
    }, {
        key: 'changeItemCode',
        value: function changeItemCode(data) {
            return this.props.onchangeitemcode(data);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var costCodePartial = void 0;

            if (!self.props.isaltusspecialenabled) {
                costCodePartial = React.createElement(
                    'th',
                    null,
                    'GL Code'
                );
            }

            //style={tableStyle}
            var createRow = function createRow(itemObj) {
                var id = _.uniqueId('il');

                return React.createElement(ReadOnlyRow, { uid: id,
                    item: itemObj,
                    ratecarditems: self.state.ratecarditems,
                    isaltusspecialenabled: self.props.isaltusspecialenabled,
                    costcodes: self.state.costcodes,
                    itemcodes: self.state.itemcodes,
                    onaddrow: self.addLine.bind(this),
                    oneditrow: self.editLine.bind(this),
                    onupdateitem: self.updateLine.bind(this),
                    ondeleterow: self.deleteLine.bind(this),
                    oncancelrow: self.cancelLineEditing.bind(this),
                    onchangecheckselection: self.changeCheckSelection.bind(this),
                    onrefreshratecard: self.refreshRateCard.bind(this),
                    checkdescriptioncontroltype: self.checkDescriptionControlType.bind(this),
                    localization: self.props.localization,
                    defaulttaxrate: self.props.defaulttaxrate,
                    onedittaxrate: self.editTaxRate.bind(this),
                    taxroundingrule: self.props.taxroundingrule,
                    onchangeitemcode: self.changeItemCode.bind(this)
                });
            };

            var idForAddRow = _.uniqueId('ar');
            var addRowItemPartial;
            var checkboxAllPartial;
            var deleteAllPartial;
            var countCheckedItemsPartial;
            var taxRateApplyAllPartial;
            var localizationPartial;
            var taxRatePartial;
            var colSpanCount = 9;

            if (this.state.lineitems.length <= 0) {
                addRowItemPartial = React.createElement(
                    'div',
                    { key: idForAddRow, className: 'padding-15 h6 app-grid-norecord secondary-text' },
                    React.createElement('i', { className: 'icon-playlist-plus s25 padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.addInitialLineItem.bind(this) })
                );
            }

            if (!this.state.isEditMode) {
                if (this.state.lineitems.length > 0) {
                    checkboxAllPartial = React.createElement('input', { type: 'checkbox', className: 'react-checkbox', checked: self.state.isCheckedAll, onChange: self.changeCheckAllSelection.bind(this) });
                } else {
                    checkboxAllPartial = React.createElement('input', { type: 'checkbox', className: 'react-checkbox not-clickable-item', disabled: true });
                }

                if (this.state.isCheckedAll) {
                    deleteAllPartial = React.createElement('i', { className: 'icon-trash clickable-item s18  red-500-fg padding-left-15 padding-bottom-0 margin-bottom-0', onClick: self.deleteSelected.bind(this) });
                } else {
                    deleteAllPartial = React.createElement('i', { className: 'icon-trash not-clickable-item s18 padding-left-15 padding-bottom-0 margin-bottom-0 grey-400-fg' });
                }

                // Count CheckedItems
                var checkedCount = this.getNumberOfCheckedItems();
                if (checkedCount > 0) {
                    countCheckedItemsPartial = React.createElement(
                        'span',
                        { className: 'padding-left-15' },
                        React.createElement(
                            'strong',
                            null,
                            checkedCount
                        ),
                        ' selected'
                    );
                }
            }

            if (!this.props.isaltusspecialenabled) {
                colSpanCount += 1;
            }

            return React.createElement(
                'table',
                { className: 'simple editable-table' },
                React.createElement(
                    'thead',
                    null,
                    React.createElement(
                        'tr',
                        null,
                        React.createElement(
                            'th',
                            { className: 'text-left' },
                            checkboxAllPartial,
                            deleteAllPartial,
                            taxRateApplyAllPartial,
                            countCheckedItemsPartial
                        ),
                        React.createElement(
                            'th',
                            { className: 'desc-col' },
                            'Description'
                        ),
                        React.createElement(
                            'th',
                            null,
                            'Item Code'
                        ),
                        costCodePartial,
                        React.createElement(
                            'th',
                            { className: 'text-right qty-col' },
                            'Qty'
                        ),
                        React.createElement(
                            'th',
                            { className: 'text-right amt-col' },
                            'Unit Price'
                        ),
                        React.createElement(
                            'th',
                            { className: 'text-right amt-col' },
                            'Amount'
                        ),
                        React.createElement(
                            'th',
                            { className: 'text-right' },
                            'Actions'
                        )
                    )
                ),
                React.createElement(
                    'tfoot',
                    null,
                    React.createElement(
                        'tr',
                        null,
                        React.createElement(
                            'td',
                            { colSpan: colSpanCount },
                            addRowItemPartial
                        )
                    )
                ),
                this.state.lineitems.map(createRow)
            );
        }
    }]);

    return EditableLineItem;
}(React.Component);

EditableLineItem.propTypes = {
    lineitems: React.PropTypes.array.isRequired,
    ratecarditems: React.PropTypes.array.isRequired,
    isaltusspecialenabled: React.PropTypes.bool.isRequired,
    itemcodes: React.PropTypes.array.isRequired,
    costcodes: React.PropTypes.array.isRequired,
    localization: React.PropTypes.string.isRequired,
    defaulttaxrate: React.PropTypes.number.isRequired,
    onaddrow: React.PropTypes.func.isRequired,
    ondelete: React.PropTypes.func.isRequired,
    ontoggleedit: React.PropTypes.func.isRequired,
    ondeleteselected: React.PropTypes.func.isRequired,
    onrefreshratecard: React.PropTypes.func.isRequired,
    checkdescriptioncontroltype: React.PropTypes.func.isRequired,
    onedittaxrate: React.PropTypes.func.isRequired,
    oneditalltaxrate: React.PropTypes.func.isRequired,
    taxroundingrule: React.PropTypes.string.isRequired,
    onchangeitemcode: React.PropTypes.func.isRequired
};
EditableLineItem.defaultProps = {
    lineitems: [],
    ratecarditems: [],
    itemcodes: [],
    costcodes: [],
    localization: 'AU',
    defaulttaxrate: 0,
    taxroundingrule: 'TaxableSupplyRule',
    onaddrow: function onaddrow() {}, // noop
    ondelete: function ondelete() {},
    ontoggleedit: function ontoggleedit() {},
    ondeleteselected: function ondeleteselected() {},
    onrefreshratecard: function onrefreshratecard() {},
    checkdescriptioncontroltype: function checkdescriptioncontroltype() {},
    onedittaxrate: function onedittaxrate() {},
    oneditalltaxrate: function oneditalltaxrate() {},
    onchangeitemcode: function onchangeitemcode() {}
};


angular.module('app.invoice.reports').value('EditableLineItem', EditableLineItem);
/**
 * Host directive for React component
 * 5.17.2017 rcnet
 */
(function () {
    'use strict';

    angular.module('app.invoice.reports')
        .directive('editableLineItemComponent', editableLineItemComponent);

     /** @ngInject */
    function editableLineItemComponent(reactDirective, EditableLineItem) {
        return reactDirective(EditableLineItem);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.custom-fields.view', ['ngAnimate'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.custom_fields_view', {
            url: '/custom-fields/manager',
            views: {
                'content@app': {
                    templateUrl: 'app/main/customFieldsManager/views/custom-fields-manager-view.html',
                    controller: 'CustomFieldsManagerController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasCustomFieldsMenu;
                }] 
            },
            title: 'Custom Fields Manager',
            titleBar: 'Alloc8 - Custom Fields Manager'
        });

        $translatePartialLoaderProvider.addPart('app/main/customFieldsManager/views');
    }

})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('editorSection', editorSection);

    function editorSection() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/utils/editorSection/mainSection/editor-section.html',
            controller: editorSectionController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function editorSectionController(CustomFieldsManagerService) {
            var vm = this;
            vm.field_virtual_copy = angular.copy(vm.field);
            vm.service = CustomFieldsManagerService;
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('editorHeaderSection', editorHeaderSection);

    function editorHeaderSection() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/utils/editorSection/headerSection/editor-header-section.html',
            controller: editorHeaderSectionController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function editorHeaderSectionController(CustomFieldsManagerService) {
            var vm = this;
            vm.field_types = [];
            vm.service = CustomFieldsManagerService;
            vm.original_fields_copy = angular.copy(vm.service.field_types);

            vm.changeFields = changeFields;

            function activate(){
                if(vm.service.is_for_edit){
                    changeFields(vm.field.FieldType);
                }else{
                    vm.field_types = alasql('select * from ? order by Name', [angular.copy(vm.original_fields_copy)]);
                }
            }

            function changeFields(module){
                let related_fields = vm.original_fields_copy.find(function(field) {return field.Id === module}).RelatedFields;
                vm.field_types = related_fields.map(function(Id) {
                    return vm.original_fields_copy.find(function(field) { return field.Id === Id });
                });
                vm.field_types = alasql('select * from ? order by Name', [vm.field_types]);
            }

            activate();
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('editorFooterSection', editorFooterSection);

    function editorFooterSection() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                form : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/utils/editorSection/footerSection/editor-footer-section.html',
            controller: editorFooterSectionController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function editorFooterSectionController(CustomFieldsManagerService, customFieldsService) {
            var vm = this;
            vm.has_validation = (!_.isNil(vm.field.MinValue) || !_.isNil(vm.field.MaxValue) || !_.isNil(vm.field.ValidationRegexPattern))
            vm.service = CustomFieldsManagerService;

            vm.save = save;
            vm.changeValidation = changeValidation;
            vm.closeForm = closeForm;

            function changeValidation(){
                if(!vm.has_validation){
                    vm.field.MinValue = null;
                    vm.field.MaxValue = null;
                    vm.field.ValidationRegexPattern = null;
                }
            }

            function closeForm(){
                vm.service.closeForm(vm.field);
            }

            function save(field){
                CustomFieldsManagerService.saving = true;
                setTimeout(function(){
                    customFieldsService.saveCustomFields2(field, CustomFieldsManagerService.chosen_module, CustomFieldsManagerService.is_for_edit)
                        .then(function(){
                            CustomFieldsManagerService.initial_load = true;
                            CustomFieldsManagerService.saving = false;
                            CustomFieldsManagerService.loading = false;
                            CustomFieldsManagerService.getCustomFields(CustomFieldsManagerService.chosen_module);
                        }).catch(function(){
                            CustomFieldsManagerService.saving = false;
                        CustomFieldsManagerService.loading = false;
                         });
                }, 1000);
            }
        }
    }
})();

(function() {
    'use strict';
    angular.module('app.widgets', ['dndLists'])
        .config(config);

    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/shared/widgets');
        $translatePartialLoaderProvider.addPart('app/shared/widgets/documentManager');
        $translatePartialLoaderProvider.addPart('app/shared/widgets/formTemplatesList');
    }
})();
(function() {
    'use strict';

    angular
        .module('app.widgets')
        .controller('contactSkillDialogController2', contactSkillDialogController2);

    function contactSkillDialogController2(
        $mdDialog,
        companies,
        skillsMatrixService,
        skills_lookup,
        tenantSettings,
        downloadService,
        _,
        utils,
        is_edit,
        skills_list,
        contact,
        skill
    ) {
        const MAX_INT_VALUE = 2147483647;

        var vm = this;
        vm.contact = contact;
        vm.is_edit = is_edit;
        vm.skillsMatrixService = skillsMatrixService;
        vm.uploadUrl = tenantSettings.coreApiUrl + "api/contacts/skillsmatrix/upload";
        vm.companies = companies;
        vm.selectedItem = null;
        vm.searchText = null;
        vm.showProgress = false;
        vm.uploadAdded = false;
        vm.skills_model = {
            Skill: null,
            Company: [],
            ReferenceNumber: null,
            Description: null,
            Skill_Children: [],
            ExpiryDate: null,
            UploadFileName: null
        }

        vm.onCancel = onCancel;
        vm.onSave = onSave;
        vm.sanitizeField = sanitizeField;
        vm.nullByteWarnings = {};
        vm.itemAdded = itemAdded;
        vm.onUploadSuccess = onUploadSuccess;
        vm.onUploadValidate = onUploadValidate;
        vm.onUploadError = onUploadError;
        vm.onUploadStart = onUploadStart;
        vm.removeFile = removeFile;
        vm.downloadFile = downloadFile;
        vm.filterChildSkills = filterChildSkills;
        vm.caption = is_edit ? utils.translate('CONTACTSMODULE.SKILL_UPDATE') : utils.translate('CONTACTSMODULE.ADD_SKILL');
        vm.skills_list = skills_list;
        vm.skill = skill;
        vm.maxDate = new Date(utils.epochToJsDateTime(MAX_INT_VALUE));
        vm.currentDate = new Date();
        vm.minDate = new Date(vm.currentDate.getFullYear()-2, vm.currentDate.getMonth(), 1);



        var contactBranchIds = {};
        _.each(contact.Branches2, function(b) {
            contactBranchIds[b.Id] = true;
        });

        vm.skills_lookup = _.filter(skills_lookup, function(s) {
            if (s.SkillBranches.length == 0) {
                return true;
            }

            s.isOfInValidBranch = false;

            if (is_edit) {
                var selectedSkill = _.find(skills_lookup, {
                    id: skill.Id
                });

                var selectedChildSkill = _.find(s.ChildSkills, {
                    id: skill.Id
                });

                if ((selectedSkill && s.id == skill.Id) || selectedChildSkill) {
                    s.isOfInValidBranch = !_.some(s.SkillBranches, function(sb) {
                        return contactBranchIds[sb.Id];
                    });
                }
            }

            var containsValidBranches = _.some(s.SkillBranches, function(sb) {
                return contactBranchIds[sb.Id];
            });

            return containsValidBranches || s.isOfInValidBranch;

        });


        function filterChildSkills(childSkills) {
            let filteredSkills = _.filter(childSkills, function(cs) {
                if (cs.SkillBranches.length == 0) {
                    return true;
                }



                cs.isOfInValidBranch = false;
                if (is_edit) {
                    var selectedSkill = _.find(skills_list, {
                        id: skill.Id
                    });
                    if (selectedSkill && cs.id == skill.Id) {
                        cs.isOfInValidBranch = !_.some(selectedSkill.SkillBranches, function(csb) {
                            return contactBranchIds[csb.Id];
                        });
                    }
                }

                var containsValidBranches = _.some(cs.SkillBranches, function(csb) {
                    return contactBranchIds[csb.Id];
                });

                return containsValidBranches || cs.isOfInValidBranch;
            });
            return filteredSkills;
        }

        function downloadFile() {
            let apiString = '/api/contacts/' + vm.contact + '/skills/' + vm.group_id + '/file';
            downloadService.downloadFile(apiString);
        }

        function onUploadStart() {
            vm.showProgress = true;
            vm.uploadAdded = true;
        }

        function activate() {
            //Handler of original selected skills to removed/replaced during update
            vm.skills_original_base = null;
            if (is_edit) {

                vm.group_id = skill.GroupId;
                if (isChild(skill.Id)) {
                    //get parent
                    let parent = getParent(skill.Id);

                    //get siblings
                    let siblings = alasql('select * from ? where GroupId = ?', [vm.skills_list, skill.GroupId]);

                    _.forEach(siblings, function(sibling) {
                        sibling['id'] = sibling.Id;
                    });
                    let first_child = siblings[0];
                    vm.skills_original_base = angular.copy(siblings);

                    //get base properties - uploaded file name, expiry date (if there is), description, reference number, company
                    //Bind Company
                    var company;
                    if (!_.isNil(first_child.ClientCompany)) {
                        let result = _.find(companies, {
                            id: first_child.ClientCompany.Id
                        });
                        company = result;
                    }

                    vm.skills_model = {
                        Skill: angular.copy(parent),
                        Company: company,
                        ReferenceNumber: first_child.ReferenceNumber,
                        Description: first_child.Description,
                        Skill_Children: angular.copy(siblings),
                        ExpiryDate: first_child.ExpiryDate,
                        UploadFileName: first_child.UploadFileName
                    }

                    var selectedSkill = _.find(vm.skills_model.Skill.ChildSkills, {
                        id: skill.Id
                    });

                    let childSkills = _.filter(vm.skills_model.Skill.ChildSkills, function(s) {
                        if (s.SkillBranches.length == 0) {
                            return true;
                        }

                        s.isOfInValidBranch = false;
                        if (selectedSkill && s.id == skill.Id) {
                            s.isOfInValidBranch = !_.some(selectedSkill.SkillBranches, function(sb) {
                                return contactBranchIds[sb.Id];
                            });
                        }

                        var containsValidBranches = _.some(s.SkillBranches, function(sb) {
                            return contactBranchIds[sb.Id];
                        });

                        return containsValidBranches || s.isOfInValidBranch;
                    });
                    vm.skills_model.Skill.ChildSkills = childSkills;

                    vm.skills_model.isSkillChildrenOfInValidBranch = _.some(vm.skills_model.Skill.ChildSkills, {
                        isOfInValidBranch: true
                    });

                    //Bind Uploaded File
                    if (vm.skills_model.UploadFileName) {
                        let lastIndex = vm.skills_model.UploadFileName.lastIndexOf("/");
                        vm.fileName = vm.skills_model.UploadFileName.substring(lastIndex + 1);
                        vm.uploadAdded = true;
                    }

                    //child skills share same base properties
                } else {
                    //display
                    vm.skills_original_base = angular.copy(skill);
                    let skill_base = _.find(skills_lookup, {
                        id: skill.Id
                    })

                    //get base properties - uploaded file name, expiry date (if there is), description, reference number, company
                    //Bind Company
                    var company;
                    if (!_.isNil(skill.ClientCompany)) {
                        let result = _.find(companies, {
                            id: skill.ClientCompany.Id
                        });
                        company = result;
                    }

                    vm.skills_model = {
                        Skill: angular.copy(skill_base),
                        Company: company,
                        ReferenceNumber: skill.ReferenceNumber,
                        Description: skill.Description,
                        Skill_Children: [],
                        ExpiryDate: skill.ExpiryDate,
                        UploadFileName: skill.UploadFileName
                    }

                    //Bind Uploaded File
                    if (vm.skills_model.UploadFileName) {
                        let lastIndex = vm.skills_model.UploadFileName.lastIndexOf("/");
                        vm.fileName = vm.skills_model.UploadFileName.substring(lastIndex + 1);
                        vm.uploadAdded = true;
                    }
                }
            }
        }

        function getParent(id) {
            let parent = null;
            _.forEach(skills_lookup, function(parent_skill) {
                _.forEach(parent_skill.ChildSkills, function(child_skill) {
                    if (id === child_skill.id) {
                        parent = angular.copy(parent_skill);
                    }
                });
            });
            return parent;
        }

        function isChild(id) {
            let match = _.find(skills_lookup, {
                id: id
            });
            if (match) {
                return false;
            } else {
                return true;
            }
        }

        function removeFile() {
            vm.skills_model.UploadFileName = null;
        }

        function onUploadSuccess(data) {
            vm.showProgress = false;
            vm.skills_model.UploadFileName = data.Url[0];
            let lastIndex = vm.skills_model.UploadFileName.lastIndexOf("/");
            vm.fileName = vm.skills_model.UploadFileName.substring(lastIndex + 1);
        }

        function onUploadValidate(fileObj) {
            var ext = utils.getFileExtension(fileObj.name);
            var isValid = true;
            if (ext != '.jpeg' && ext != '.jpg' && ext != '.png' && ext != '.gif' && ext != '.doc' && ext != '.docx' && ext != '.pdf') {
                isValid = false;
                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(utils.translate('CONTACTSMODULE.SKILLS_INVALID_FILE'))
                    .ariaLabel(utils.translate('CONTACTSMODULE.SKILLS_INVALID_FILE'))
                    .ok(utils.translate('CONTACTSMODULE.SKILLS_OK'))
                $mdDialog.show(notif);
            }
            return isValid;
        }

        function onUploadError() {
            vm.uploadAdded = false;
        }

        function itemAdded() {
            if (vm.skills_model.Company.length > 0) {
                vm.skills_model.Company.splice(1, 1);
            }
        }

        function sanitizeField(fieldName) {
            if (vm.skills_model[fieldName]) {
                var hasNullByte = /\x00/.test(vm.skills_model[fieldName]);
                if (hasNullByte) {
                    vm.nullByteWarnings[fieldName] = true;
                    vm.skills_model[fieldName] = vm.skills_model[fieldName].replace(/\x00/g, '');
                } else {
                    vm.nullByteWarnings[fieldName] = false;
                }
            } else {
                vm.nullByteWarnings[fieldName] = false;
            }
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function generateSingleSkill(chosen_skill, skills_model, group_id) {
            return {
                Id: chosen_skill.id,
                SkillName: chosen_skill.SkillName,
                ReferenceNumber: skills_model.ReferenceNumber,
                Description: skills_model.Description,
                ClientCompany: chosen_skill.CompanyNotRequired ? null : getCompany(skills_model.Company),
                ExpiryDate: skills_model.ExpiryDate ? new Date(moment(skills_model.ExpiryDate).format('YYYY-MM-DD')) : null,
                UploadFileName: skills_model.UploadFileName,
                GroupId: group_id,
                SkillGroupName: chosen_skill.SkillGroupName,
                SkillGroupId: chosen_skill.SkillGroupId,
                UniqueId: utils.newGuid()
            }
        }

        function getCompany(company) {
            if (!company) return null;

            if (company.length > 0) {
                company = angular.copy(company[0]);
            }

            return {
                Id: company.id,
                Name: company.Name
            }
        }

        function generatePayLoad(data, original_skills) {
            return {
                data: data,
                base: original_skills,
                edit: is_edit
            }
        }

        function onSave() {
            sanitizeField('ReferenceNumber');
            sanitizeField('Description');

            if(vm.skills_model.Skill.ChildSkills.length === 0) {
                //Parent Skills
                let data = generateSingleSkill(vm.skills_model.Skill, vm.skills_model, utils.newGuid());
                let pay_load = generatePayLoad(data, vm.skills_original_base);
                $mdDialog.hide(pay_load);
            } else {
                //Child Skills
                let data = [];
                let group_id = utils.newGuid();
                _.forEach(vm.skills_model.Skill_Children, function(skill) {
                    data.push(generateSingleSkill(skill, vm.skills_model, group_id))
                });
                let pay_load = generatePayLoad(data, vm.skills_original_base);
                $mdDialog.hide(pay_load);
            }
        }
        activate();
    }
})();

/**
 * Cost Estimate module
 * Created date: 4.10.2018
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview', [])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.cost_estimate_preview', {
            url: '/costestimate/preview/:ceGrpId/:viewCancelled',
            views: {
                'content@app': {
                    templateUrl: 'app/main/costEstimate/preview/cost-estimate-preview.default.html',
                    controller: 'CostEstimatePreviewController as invRepVm'
                }
            },
            data: { requireLogin: true },
            resolve: {
                branchesData: branchResolver,
                costCodes: costCodesResolver,
                ceGroupInfoData: costEstimateGroupInfoResolver,
                winlostData: winLostLookupResolver
            },
            title: 'Preview Cost Estimate',
            titleBar: 'Alloc8 - Preview Cost Estimate'
        })
            .state('app.ce_popup_details_preview', {
                url: '/costEstimate/preview/popup-resource-details',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/costEstimate/preview/directives/ceItemList/ce-popup-resource.html',
                        controller: 'CePopupResourceController as vm'
                    }
                },
                data: { requireLogin: true },
                title: 'Cost Estimate Resource Details',
            });

        $translatePartialLoaderProvider.addPart('app/main/costEstimate');
    };

    /** @ngInject */
    function branchResolver(ceLookupService) {
        ceLookupService.loadAll();
    }

    /** @ngInject */
    function costCodesResolver(editCeReportService) {
        return editCeReportService.loadLookups();
    }

    /** @ngInject */
    function costEstimateGroupInfoResolver(ceGroupInfoService, $stateParams) {
        return ceGroupInfoService.fetchData($stateParams.ceGrpId);
    }

    /** @ngInject */
    function winLostLookupResolver(winLostLookupService) {
        return winLostLookupService.loadLookups();
    }

    /** @ngInject */
    function runConfig(ceHubService) {
        // SignalR hub
        ceHubService.registerSignalRCallback();
    }
})();

/**
 * Editable Line Item Service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceEditableLineItemService', ceEditableLineItemService);

    /** @ngInject */
    function ceEditableLineItemService($q,
        exceptionService,
        moment
    ) {
        var service = {
            addExtendedProperties: addExtendedProperties,
            sanitizeModel: sanitizeModel,
            fixId: fixId
        };

        activate();

        return service;
        //////

        function activate() {}

        /**
         * Mutates line item object to support grid functionality
         * @param {*} Line Item object 
         */
        function addExtendedProperties(lineItem) {
            lineItem['mode'] = 'R';
            lineItem['IsChecked'] = false;
        }

        /**
         * Remove unnecessary properties in the model
         * @param {*} data 
         */
        function sanitizeModel(data) {
            var clonedData = angular.copy(data);
            clonedData.forEach(function(lineItem) {
                lineItem.Id = _.startsWith(lineItem.Id, 'new') ? null : lineItem.Id;
            });
            return clonedData;
        }

        /**
         * This will fix ID created by editable-line item grid (React ver)
         * @param {*} id 
         */
        function fixId(id) {
            return _.startsWith(id, 'new') ? null : id;
        }

    }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CeEditableLineItem = function (_React$Component) {
    _inherits(CeEditableLineItem, _React$Component);

    function CeEditableLineItem(props) {
        _classCallCheck(this, CeEditableLineItem);

        var _this = _possibleConstructorReturn(this, (CeEditableLineItem.__proto__ || Object.getPrototypeOf(CeEditableLineItem)).call(this, props));

        _this.addLine = _this.addLine.bind(_this);
        _this.editLine = _this.editLine.bind(_this);
        _this.deleteLine = _this.deleteLine.bind(_this);
        _this.cancelLineEditing = _this.cancelLineEditing.bind(_this);
        _this.updateLine = _this.updateLine.bind(_this);
        _this.addInitialLineItem = _this.addInitialLineItem.bind(_this);
        _this.changeCheckSelection = _this.changeCheckSelection.bind(_this);
        _this.changeCheckAllSelection = _this.changeCheckAllSelection.bind(_this);
        _this.deleteSelected = _this.deleteSelected.bind(_this);
        _this.refreshRateCard = _this.refreshRateCard.bind(_this);
        _this.checkDescriptionControlType = _this.checkDescriptionControlType.bind(_this);
        _this.editTaxRate = _this.editTaxRate.bind(_this);
        _this.changeItemCode = _this.changeItemCode.bind(_this);

        _this.state = {
            lineitems: _this.props.lineitems,
            ratecarditems: _this.props.ratecarditems,
            isaltusspecialenabled: _this.props.isaltusspecialenabled,
            costcodes: _this.extendCostCodes(_this.props.costcodes),
            itemcodes: _this.props.itemcodes,
            isEditMode: false,
            isCheckedAll: false
        };
        return _this;
    }

    _createClass(CeEditableLineItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var self = this;
            // Note: Anti-pattern dont do this just a work around for now!!!
            // Pain in the ass to encounter this issue - rcnet
            window.ceCallReactDeleteLineItem = function (id) {
                self.performDeleteLine(id);
            };

            window.ceCallReactDeleteLineItems = function () {
                self.performDeleteLines();
            };

            window.ceGetLineItemDataInReact = function () {
                // Sanitize line item collection
                // Set id to null if new line item (prefixed by 'new')
                var clonedItems = _.cloneDeep(self.state.lineitems);
                _.forEach(clonedItems, function (o) {
                    //o.Id = _.startsWith(o.Id, 'new') ? null : o.Id;
                    o.CostCode = o.CostCode == '-1' ? null : o.CostCode;
                    o.ItemCode = o.ItemCode == '-1' ? null : o.ItemCode;
                    delete o['mode'];
                    delete o['rowType'];
                });

                return clonedItems;
            };

            // Note: For US client only
            window.ceUpdateTaxRate = function (tax) {
                self.updateTaxRate(tax);
            };

            window.ceUpdateTaxRateForAllSelectedItems = function (items) {
                self.updateTaxRateForAllSelectedItems(items);
            };
        }
    }, {
        key: 'extendCostCodes',
        value: function extendCostCodes() {
            var codes = _.cloneDeep(this.props.costcodes);
            codes.splice(0, 0, { Id: '-1', Description: '- Select Cost Code -' });
            return codes;
        }
    }, {
        key: 'extendItemCodes',
        value: function extendItemCodes() {
            var codes = _.cloneDeep(this.props.itemcodes);
            codes.splice(0, 0, { Id: '-1', Description: '- Select Item Code -' });
            return codes;
        }
    }, {
        key: 'moveRow',
        value: function moveRow(id) {}
    }, {
        key: 'addLine',
        value: function addLine(id, rowType) {
            if (!this.state.isEditMode) {
                var self = this;
                var clonedLineItems = _.cloneDeep(this.state.lineitems);

                // Disable all buttons if edit mode
                _.forEach(clonedLineItems, function (i) {
                    i['isRowEnabled'] = false;
                });

                // Then prepare adding new empty line
                var index = _.findIndex(this.state.lineitems, function (o) {
                    return o.Id === id;
                });

                var indx = index + 1;
                clonedLineItems.splice(indx, 0, {
                    mode: 'C',
                    rowType: rowType,
                    Id: 'new-' + self.newGuid(),
                    Description: '',
                    CostCodeDesc: '',
                    ItemCodeDesc: '',
                    Quantity: '',
                    UnitPriceExcludingTax: '',
                    CityAmount: 0,
                    CityTaxRate: 0,
                    CountyAmount: 0,
                    CountyTaxRate: 0,
                    StateAmount: 0,
                    StateSalesTaxRate: 0,
                    SpecialDistrictAmount: 0,
                    SpecialTaxRate: 0,
                    TaxRate: 0, // Combined Tax rate
                    UnitTax: '',
                    TotalTax: '',
                    Amount: ''
                });

                // Copy previous tax rates above the item list
                if (self.props.localization == 'US') {
                    var prevTaxRate = self.getPreviousTaxRate(index);
                    if (prevTaxRate != null) {
                        clonedLineItems[indx].CityTaxRate = prevTaxRate.CityTaxRate;
                        clonedLineItems[indx].CountyTaxRate = prevTaxRate.CountyTaxRate;
                        clonedLineItems[indx].StateSalesTaxRate = prevTaxRate.StateSalesTaxRate;
                        clonedLineItems[indx].SpecialTaxRate = prevTaxRate.SpecialTaxRate;
                        clonedLineItems[indx].TaxRate = prevTaxRate.TaxRate;
                    }
                }

                // Re-Sort line items sequence no.
                self.reSortSrcData(clonedLineItems);

                this.setState({
                    lineitems: clonedLineItems,
                    isEditMode: true
                });

                this.props.ontoggleedit(true);
            }
        }
    }, {
        key: 'getPreviousTaxRate',
        value: function getPreviousTaxRate(index) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            if (clonedLineItems.length <= 0) return;
            var previousTaxItem = clonedLineItems[index];

            if (self.isLineComment(previousTaxItem)) return;

            // Copy previous tax rate
            return previousTaxItem;
        }
    }, {
        key: 'isLineComment',
        value: function isLineComment(item) {
            return item.Description == null || item.Description.toUpperCase() == 'SUPPLY OF TRAFFIC CONTROLLERS AT' || item.Quantity == 0 && item.UnitPriceExcludingTax <= 0;
        }
    }, {
        key: 'reSortSrcData',
        value: function reSortSrcData(items) {
            var i = 0;
            items.map(function (itm) {
                itm['SequenceNo'] = ++i;
            });
        }
    }, {
        key: 'editLine',
        value: function editLine(id) {
            if (!this.state.isEditMode) {
                var clonedLineItems = _.cloneDeep(this.state.lineitems);

                // Disable all buttons if edit mode
                _.forEach(clonedLineItems, function (i) {
                    i['isRowEnabled'] = false;
                });

                var itemToUpdate = _.find(clonedLineItems, function (o) {
                    return o.Id === id;
                });

                itemToUpdate.mode = 'E';
                itemToUpdate.isRowEdit = false;
                this.setState({
                    lineitems: clonedLineItems,
                    isEditMode: true
                });

                this.props.ontoggleedit(true);
            }
        }
    }, {
        key: 'updateLine',
        value: function updateLine(data) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);

            // Disable all buttons if edit mode
            _.forEach(clonedLineItems, function (i) {
                i['isRowEnabled'] = true;
            });

            var itemToUpdate = _.find(clonedLineItems, function (o) {
                return o.Id === data.Id;
            });

            var ItemId = '';
            var ItemType = '';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.state.ratecarditems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.hasOwnProperty('itemId') && item.id == data.RateCardItemCode) {
                        ItemId = item.itemId;
                        ItemType = item.itemType;
                        break;
                    }

                    if (item.hasOwnProperty('children')) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = item.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var _item = _step2.value;

                                if (_item.id == data.RateCardItemCode) {
                                    ItemId = _item.itemId;
                                    ItemType = _item.itemType;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            itemToUpdate.mode = 'R';
            itemToUpdate.Id = data.Id;
            itemToUpdate.Description = data.Description;
            itemToUpdate.ItemId = ItemId;
            itemToUpdate.ItemType = ItemType;
            itemToUpdate.CostCode = data.CostCode;
            itemToUpdate.ItemCode = data.ItemCode;
            itemToUpdate.CostCodeDesc = this.getCostCodeDescription(data.CostCode);
            itemToUpdate.ItemCodeDesc = this.getItemCodeDescription(data.ItemCode);
            itemToUpdate.Quantity = data.Quantity;
            itemToUpdate.UnitPriceExcludingTax = data.UnitPriceExcludingTax;
            itemToUpdate.UnitTax = data.UnitTax;
            itemToUpdate.TotalTax = data.TotalTax;
            itemToUpdate.Amount = data.Amount;
            itemToUpdate.CityAmount = data.CityAmount;
            itemToUpdate.CityTaxRate = data.CityTaxRate;
            itemToUpdate.CountyAmount = data.CountyAmount;
            itemToUpdate.CountyTaxRate = data.CountyTaxRate;
            itemToUpdate.StateAmount = data.StateAmount;
            itemToUpdate.StateSalesTaxRate = data.StateSalesTaxRate;
            itemToUpdate.SpecialDistrictAmount = data.SpecialDistrictAmount;
            itemToUpdate.SpecialTaxRate = data.SpecialTaxRate;
            itemToUpdate.TaxRate = data.TaxRate;

            // Re-Sort line items sequence no.
            self.reSortSrcData(clonedLineItems);

            this.setState({
                lineitems: clonedLineItems,
                isEditMode: false
            });

            this.props.ontoggleedit(false);
        }

        // Note: Only for US

    }, {
        key: 'updateTaxRate',
        value: function updateTaxRate(data) {
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            var itemToUpdate = _.find(clonedLineItems, function (o) {
                return o.Id === data.Id;
            });

            itemToUpdate.TaxRate = data.CombinedTaxRate;
            itemToUpdate.CityTaxRate = data.CityTaxRate;
            itemToUpdate.CountyTaxRate = data.CountyTaxRate;
            itemToUpdate.StateSalesTaxRate = data.StateSalesTaxRate;
            itemToUpdate.SpecialTaxRate = data.SpecialTaxRate;

            this.setState({
                lineitems: clonedLineItems
            });
        }
    }, {
        key: 'getCostCodeDescription',
        value: function getCostCodeDescription(code) {
            if (!this.state.isaltusspecialenabled) {
                return code;
            }
            var result = _.find(this.state.costcodes, function (o) {
                return o.Id == code;
            });

            return result == null || result.Id == '-1' ? '' : result.Description;
        }
    }, {
        key: 'getItemCodeDescription',
        value: function getItemCodeDescription(code) {
            if (!this.state.isaltusspecialenabled) {
                return code;
            }
            var result = _.find(this.state.itemcodes, function (o) {
                return o.id == code;
            });

            return result == null || result.id == '-1' ? '' : result.text;
        }
    }, {
        key: 'cancelLineEditing',
        value: function cancelLineEditing(id) {
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            // Disable all buttons if edit mode
            _.forEach(clonedLineItems, function (i) {
                i['isRowEnabled'] = true;
            });

            var itemToCancel = _.find(clonedLineItems, function (o) {
                return o.Id === id;
            });

            // Check if CREATE mode
            if (itemToCancel.mode === 'C') {
                _.remove(clonedLineItems, function (o) {
                    return o.Id === id;
                });
                // Check if EDIT mode
            } else if (itemToCancel.mode === 'E') {
                itemToCancel.mode = 'R';
            }

            this.setState({
                lineitems: clonedLineItems,
                isEditMode: false
            });

            this.props.ontoggleedit(false);
        }
    }, {
        key: 'deleteLine',
        value: function deleteLine(id, desc) {
            this.props.ondelete(id, desc);
        }
    }, {
        key: 'performDeleteLine',
        value: function performDeleteLine(id) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            _.remove(clonedLineItems, function (o) {
                return o.Id === id;
            });

            // Re-Sort line items sequence no.
            self.reSortSrcData(clonedLineItems);

            this.setState({
                lineitems: clonedLineItems
            });
        }
    }, {
        key: 'performDeleteLines',
        value: function performDeleteLines() {
            var checkedItems = this.getCheckedItems();
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            _.forEach(checkedItems, function (i) {
                _.remove(clonedLineItems, function (o) {
                    return o.Id === i.Id;
                });
            });

            // Re-Sort line items sequence no.
            this.reSortSrcData(clonedLineItems);
            this.setState({
                lineitems: clonedLineItems,
                isCheckedAll: false
            });
        }
    }, {
        key: 'editTaxRate',
        value: function editTaxRate(id) {
            this.props.onedittaxrate(id);
        }

        /**
         * Update selected line item's Monetary and rate props
         */

    }, {
        key: 'updateTaxRateForAllSelectedItems',
        value: function updateTaxRateForAllSelectedItems(data) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);

            _.forEach(data, function (itm) {
                var itemToUpdate = _.find(clonedLineItems, function (o) {
                    return o.Id === itm.Id;
                });

                itemToUpdate.UnitPriceExcludingTax = itm.UnitPriceExcludingTax;
                itemToUpdate.UnitTax = itm.UnitTax;
                itemToUpdate.TotalTax = itm.TotalTax;
                itemToUpdate.Amount = itm.Amount;
                itemToUpdate.CityAmount = itm.CityAmount;
                itemToUpdate.CityTaxRate = itm.CityTaxRate;
                itemToUpdate.CountyAmount = itm.CountyAmount;
                itemToUpdate.CountyTaxRate = itm.CountyTaxRate;
                itemToUpdate.StateAmount = itm.StateAmount;
                itemToUpdate.StateSalesTaxRate = itm.StateSalesTaxRate;
                itemToUpdate.SpecialDistrictAmount = itm.SpecialDistrictAmount;
                itemToUpdate.SpecialTaxRate = itm.SpecialTaxRate;
                itemToUpdate.TaxRate = itm.TaxRate;
            });

            this.setState({
                lineitems: clonedLineItems
            });
        }

        /**
         * Individual checkbox handling/ this is per item
         * @param {*} id
         */

    }, {
        key: 'changeCheckSelection',
        value: function changeCheckSelection(id) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);

            var itemToUpdate = _.find(clonedLineItems, function (o) {
                return o.Id === id;
            });

            // Toggle
            itemToUpdate.IsChecked = !itemToUpdate.IsChecked;

            // Re-Sort line items sequence no.
            // Update and wait for synchronous update
            this.setState({
                lineitems: clonedLineItems
            }, function () {
                var hasCheckedItemsResult = this.hasCheckedItems();
                self.setState({ isCheckedAll: hasCheckedItemsResult });
            });
        }

        /**
         * Manages the Check All checkbox
         * @param {*} event
         */

    }, {
        key: 'changeCheckAllSelection',
        value: function changeCheckAllSelection(event) {
            var self = this;
            var clonedLineItems = _.cloneDeep(this.state.lineitems);

            // Toggle
            _.forEach(clonedLineItems, function (o) {
                o.IsChecked = event.target.checked;
            });

            this.setState({
                lineitems: clonedLineItems,
                isCheckedAll: event.target.checked
            });
        }

        /**
         * Check if there's any checked items
         */

    }, {
        key: 'hasCheckedItems',
        value: function hasCheckedItems() {
            return this.getNumberOfCheckedItems() > 0;
        }

        /**
         * Returns Total number of checked items
         */

    }, {
        key: 'getNumberOfCheckedItems',
        value: function getNumberOfCheckedItems() {
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            var resultsFound = _.filter(clonedLineItems, function (o) {
                return o.IsChecked == true;
            });

            return resultsFound.length;
        }
    }, {
        key: 'deleteSelected',
        value: function deleteSelected() {
            this.props.ondeleteselected(this.getNumberOfCheckedItems());
        }

        /**
         * Get checked items for (deletion or something else)
         */

    }, {
        key: 'getCheckedItems',
        value: function getCheckedItems() {
            var clonedLineItems = _.cloneDeep(this.state.lineitems);
            var resultsFound = _.filter(clonedLineItems, function (o) {
                return o.IsChecked == true;
            });

            return resultsFound;
        }
    }, {
        key: 'refreshRateCard',
        value: function refreshRateCard(id) {
            return this.props.onrefreshratecard(id);
        }
    }, {
        key: 'checkDescriptionControlType',
        value: function checkDescriptionControlType(data) {
            return this.props.checkdescriptioncontroltype(data);
        }

        /**
         * Create blank item here
         */

    }, {
        key: 'addInitialLineItem',
        value: function addInitialLineItem() {
            this.addLine('id-not-exist', 'entry');
        }
    }, {
        key: 'newGuid',
        value: function newGuid() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : r & 0x7 | 0x8).toString(16);
            });
            return uuid;
        }
    }, {
        key: 'changeItemCode',
        value: function changeItemCode(data) {
            return this.props.onchangeitemcode(data);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var costCodePartial = void 0;

            if (!self.props.isaltusspecialenabled) {
                costCodePartial = React.createElement(
                    'th',
                    null,
                    'GL Code'
                );
            }

            //style={tableStyle}
            var createRow = function createRow(itemObj) {
                var id = _.uniqueId('il');

                return React.createElement(CeReadOnlyRow, { uid: id,
                    item: itemObj,
                    ratecarditems: self.state.ratecarditems,
                    isaltusspecialenabled: self.props.isaltusspecialenabled,
                    costcodes: self.state.costcodes,
                    itemcodes: self.state.itemcodes,
                    onaddrow: self.addLine.bind(this),
                    oneditrow: self.editLine.bind(this),
                    onupdateitem: self.updateLine.bind(this),
                    ondeleterow: self.deleteLine.bind(this),
                    oncancelrow: self.cancelLineEditing.bind(this),
                    onchangecheckselection: self.changeCheckSelection.bind(this),
                    onrefreshratecard: self.refreshRateCard.bind(this),
                    checkdescriptioncontroltype: self.checkDescriptionControlType.bind(this),
                    localization: self.props.localization,
                    defaulttaxrate: self.props.defaulttaxrate,
                    onedittaxrate: self.editTaxRate.bind(this),
                    onchangeitemcode: self.changeItemCode.bind(this)
                });
            };

            var idForAddRow = _.uniqueId('ar');
            var addRowItemPartial;
            var checkboxAllPartial;
            var deleteAllPartial;
            var countCheckedItemsPartial;
            var colSpanCount = 8;

            if (this.state.lineitems.length <= 0) {
                addRowItemPartial = React.createElement(
                    'div',
                    { key: idForAddRow, className: 'padding-15 h6 app-grid-norecord secondary-text' },
                    React.createElement('i', { className: 'icon-playlist-plus s25 padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.addInitialLineItem.bind(this) })
                );
            }

            if (!this.state.isEditMode) {
                if (this.state.lineitems.length > 0) {
                    checkboxAllPartial = React.createElement('input', { type: 'checkbox', className: 'react-checkbox', checked: self.state.isCheckedAll, onChange: self.changeCheckAllSelection.bind(this) });
                } else {
                    checkboxAllPartial = React.createElement('input', { type: 'checkbox', className: 'react-checkbox not-clickable-item', disabled: true });
                }

                if (this.state.isCheckedAll) {
                    deleteAllPartial = React.createElement('i', { className: 'icon-trash clickable-item s18  red-500-fg padding-left-15 padding-bottom-0 margin-bottom-0', onClick: self.deleteSelected.bind(this) });
                } else {
                    deleteAllPartial = React.createElement('i', { className: 'icon-trash not-clickable-item s18 padding-left-15 padding-bottom-0 margin-bottom-0 grey-400-fg' });
                }

                // Count CheckedItems
                var checkedCount = this.getNumberOfCheckedItems();
                if (checkedCount > 0) {
                    countCheckedItemsPartial = React.createElement(
                        'span',
                        { className: 'padding-left-15' },
                        React.createElement(
                            'strong',
                            null,
                            checkedCount
                        ),
                        ' selected'
                    );
                }
            }

            if (!this.props.isaltusspecialenabled) {
                colSpanCount += 1;
            }

            return React.createElement(
                'table',
                { className: 'simple editable-table' },
                React.createElement(
                    'thead',
                    null,
                    React.createElement(
                        'tr',
                        null,
                        React.createElement(
                            'th',
                            { className: 'text-left' },
                            checkboxAllPartial,
                            deleteAllPartial,
                            countCheckedItemsPartial
                        ),
                        React.createElement(
                            'th',
                            { className: 'desc-col' },
                            'Description'
                        ),
                        React.createElement(
                            'th',
                            null,
                            'Item Code'
                        ),
                        costCodePartial,
                        React.createElement(
                            'th',
                            { className: 'text-right qty-col' },
                            'Qty'
                        ),
                        React.createElement(
                            'th',
                            { className: 'text-right amt-col' },
                            'Unit Price'
                        ),
                        React.createElement(
                            'th',
                            { className: 'text-right amt-col' },
                            'Amount'
                        ),
                        React.createElement(
                            'th',
                            { className: 'text-right' },
                            'Actions'
                        )
                    )
                ),
                React.createElement(
                    'tfoot',
                    null,
                    React.createElement(
                        'tr',
                        null,
                        React.createElement(
                            'td',
                            { colSpan: colSpanCount },
                            addRowItemPartial
                        )
                    )
                ),
                this.state.lineitems.map(createRow)
            );
        }
    }]);

    return CeEditableLineItem;
}(React.Component);

CeEditableLineItem.propTypes = _defineProperty({
    lineitems: React.PropTypes.array.isRequired,
    ratecarditems: React.PropTypes.array.isRequired,
    isaltusspecialenabled: React.PropTypes.bool.isRequired,
    itemcodes: React.PropTypes.array.isRequired,
    costcodes: React.PropTypes.array.isRequired,
    localization: React.PropTypes.string.isRequired,
    defaulttaxrate: React.PropTypes.number.isRequired,
    onaddrow: React.PropTypes.func.isRequired,
    ondelete: React.PropTypes.func.isRequired,
    ontoggleedit: React.PropTypes.func.isRequired,
    ondeleteselected: React.PropTypes.func.isRequired,
    onrefreshratecard: React.PropTypes.func.isRequired,
    checkdescriptioncontroltype: React.PropTypes.func.isRequired,
    onedittaxrate: React.PropTypes.func.isRequired,
    oneditalltaxrate: React.PropTypes.func.isRequired,
    onchangeitemcode: React.PropTypes.func.isRequired
}, 'onchangeitemcode', function onchangeitemcode() {});
CeEditableLineItem.defaultProps = {
    lineitems: [],
    ratecarditems: [],
    itemcodes: [],
    costcodes: [],
    localization: 'AU',
    defaulttaxrate: 0,
    onaddrow: function onaddrow() {}, // noop
    ondelete: function ondelete() {},
    ontoggleedit: function ontoggleedit() {},
    ondeleteselected: function ondeleteselected() {},
    onrefreshratecard: function onrefreshratecard() {},
    checkdescriptioncontroltype: function checkdescriptioncontroltype() {},
    onedittaxrate: function onedittaxrate() {},
    oneditalltaxrate: function oneditalltaxrate() {}
};


angular.module('app.costEstimate.preview').value('CeEditableLineItem', CeEditableLineItem);
/**
 * Host directive for React component
 * 4.07.2018 rcnet
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .directive('ceEditableLineItemComponent', ceEditableLineItemComponent);

    /** @ngInject */
    function ceEditableLineItemComponent(reactDirective, CeEditableLineItem) {
        return reactDirective(CeEditableLineItem);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.skillsmatrix.manage', ['angularInlineEdit', 'ngMaterial'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.skillsmatrix_manage', {
            url: '/skillsmatrix/manage',
            views: {
                'content@app': {
                    templateUrl: 'app/main/skillsmatrix/manage/skillsmatrix-manage.html',
                    controller: 'SkillsMatrixController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManageSkillsMenu;
                }]
            },
            title: 'Manage Skills',
            titleBar: 'Alloc8 - Skills'
        });
        $translatePartialLoaderProvider.addPart('app/main/skillsmatrix');
    };

})();

(function () {
    'use strict';

    angular.module('app.skillsmatrix.manage')
        .directive('companyEditSkillDialog', function ($log, $mdDialog, skillsMatrixApi) {
            return {
                restrict: 'E'
                , replace: true
                , template: '<md-icon md-svg-icon="pencil" class="teal-500-fg" ng-click="spawnDialog()"></md-icon>'
                , scope: {
                  skillsList: '=',
                  branches: '='
                }
                , link: function (scope, elem, attrs) {
                    scope.spawnDialog = function () {
                        skillsMatrixApi.getSkillsByBranch(scope.branches).then(function(resp) {
                          $mdDialog.show({
                            parent: angular.element(document.body)
                            ,
                            templateUrl: 'app/main/company/create/companyDetails/Skills/templates/edit/company-skill.html'
                            ,
                            locals: {
                              skill: JSON.parse(attrs.skill),
                              skills: scope.skillsList,
                              filteredList : resp.data
                            }
                            ,
                            controller: 'CompanySkillsEditController as vm'
                          });
                        });
                    }

                }
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('app.skillsmatrix.manage')
        .controller('CompanySkillsEditController', CompanySkillsEditController);

    /** @ngInject */
    function CompanySkillsEditController(
        $mdDialog,
        _,
        CompanySkillService,
        filteredList,
        companyService,
        skill,
        skills) {

        //Data
        var vm = this;
        vm.Skill = null;
        vm.service = CompanySkillService;
        vm.companyService = companyService;
        vm.currentSkills = [];
        vm.SkillId = null;
        vm.currentSkill = skill;

        // Method
        vm.onCancel = onCancel;
        vm.addSkill = addSkill;
        vm.populateContactSkills = populateContactSkills;
        vm.activate = activate;

        //Initialization
        vm.activate();

        function activate() {
            populateContactSkills();
            setData();
        }

        function populateContactSkills() {
            vm.currentSkills = [];
            angular.forEach(filteredList, function (filteredSkill) {
                angular.forEach(skills, function (value) {
                    let res = alasql('select * from ? where id = ?', [value.Skills, filteredSkill.Id]);
                    if (res.length > 0) {
                        var skill = {
                            Id: res[0].id,
                            SkillName: res[0].SkillName,
                            SkillType: res[0].SkillType,
                            LockoutType: res[0].LockoutType,
                            GroupId: value.id,
                            GroupName: value.GroupName
                        }

                        vm.currentSkills.push(skill);
                    }
                });
            });
        }

        function setData() {
            vm.skill = _.find(vm.currentSkills, function (skl) {
                return skl.SkillName == skill.SkillName;
            });
            vm.lockout = skill.LockoutType;
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function addSkill(behavior) {

            var skillGroup = {
                id: vm.skill.GroupId,
                GroupName: vm.skill.GroupName,
                Skills: []
            }

            var skill1 = {
                Id: vm.skill.Id,
                SkillName: vm.skill.SkillName,
                SkillType: vm.skill.SkillType,
                LockoutType: vm.lockout
            }

            if (vm.companyService.companyInfoData.CompanyRequiredSkills.length > 0) {
                angular.forEach(companyService.companyInfoData.CompanyRequiredSkills, function (itmSkill) {
                    if (itmSkill.id == skill.id) {
                        angular.forEach(itmSkill.Skills, function (skl, key) {
                            if (skl.id == skill.Id) {
                                itmSkill.Skills.splice(key, 1);
                            }
                        })
                    }
                });
            }

            if (vm.companyService.companyInfoData.CompanyRequiredSkills.length > 0) {
                var groupCount = alasql('select * from ? where id = ?', [vm.companyService.companyInfoData.CompanyRequiredSkills, vm.skill.GroupId]);
            }

            if (groupCount.length == 0) {
                skillGroup.Skills.push(skill1);
                vm.companyService.companyInfoData.CompanyRequiredSkills.push(skillGroup);
            }
            else {
                angular.forEach(vm.companyService.companyInfoData.CompanyRequiredSkills, function (value, key) {
                    if (value.id == vm.skill.GroupId) {
                        value.Skills.push(skill1);
                    }
                });
            }

            vm.companyService.formatData();

            if (behavior == 1) {
                $mdDialog.hide();
            }
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.skillsmatrix.manage')
        .directive('companySkillDialog', function ($log, $mdDialog, skillsMatrixApi) {
            return {
                restrict: 'E'
                , replace: true
                , scope : {
                  branches : '=',
                  skillsList : '='
                }
                , template: '<a ng-click="spawnCompanyDialog()" style="cursor : pointer">Add Skill</a>'
                , link: function (scope, elem, attrs) {
                    scope.spawnCompanyDialog = function () {
                      skillsMatrixApi.getSkillsByBranch(scope.branches).then(function(resp){
                        $mdDialog.show({
                          parent: angular.element(document.body)
                          , templateUrl: 'app/main/company/create/companyDetails/Skills/templates/add/company-skill.html'
                          , locals: {
                            skillGroupID: attrs.skillid,
                            skills: scope.skillsList,
                            filteredList : resp.data
                          }
                          , controller: 'CompanySkillsController as vm'
                        });
                      })
                    }
                }
            }
        });
})();

(function () {
  'use strict';

  angular
    .module('app.skillsmatrix.manage')
    .controller('CompanySkillsController', CompanySkillsController);

  /** @ngInject */
  function CompanySkillsController($mdDialog,
                                   CompanySkillService,
                                   filteredList,
                                   companyService,
                                   skills) {

    //Data
    var vm = this;
    vm.service = CompanySkillService;
    vm.companyService = companyService;
    vm.currentSkills = [];

    // Method
    vm.onCancel = onCancel;
    vm.addSkill = addSkill;
    vm.populateContactSkills = populateContactSkills;
    vm.populateContactSkills();

    function populateContactSkills() {
      vm.currentSkills = [];
      angular.forEach(filteredList, function (filteredSkill) {
        angular.forEach(skills, function (value) {
          let res = alasql('select * from ? where id = ?', [value.Skills, filteredSkill.Id]);
          if (res.length > 0) {
            var skill = {
              Id: res[0].id,
              SkillName: res[0].SkillName,
              SkillType: res[0].SkillType,
              LockoutType: res[0].LockoutType,
              GroupId: value.id,
              GroupName: value.GroupName
            }

            vm.currentSkills.push(skill);
          }
        });
      });
    }

    function onCancel() {
      $mdDialog.hide();
    }

    function addSkill(behavior) {
      var skillGroup = {
        id: vm.skill.GroupId,
        GroupName: vm.skill.GroupName,
        Skills: []
      }

      var skill = {
        Id: vm.skill.Id,
        SkillName: vm.skill.SkillName,
        SkillType: vm.skill.SkillType,
        LockoutType: vm.lockout
      }

      var groupCount = alasql('select * from ? where id = ?', [vm.companyService.companyInfoData.CompanyRequiredSkills, vm.skill.GroupId]);

      if (groupCount.length == 0) {
        skillGroup.Skills.push(skill);
        vm.companyService.companyInfoData.CompanyRequiredSkills.push(skillGroup);
      }
      else {
        angular.forEach(vm.companyService.companyInfoData.CompanyRequiredSkills, function (value, key) {
          if (value.id == vm.skill.GroupId) {
            value.Skills.push(skill);
          }
        });
      }

      vm.companyService.formatData();

      if (behavior == 1) {
        $mdDialog.hide();
      }
    }

  }
})();

(function() {
    'use strict';
    angular.module('app.paperwork.exceptions')
        .directive('paperWorkDynamicGrid', paperWorkDynamicGrid);

    /** @ngInject */
    function paperWorkDynamicGrid(
        paperworkExceptionsApi,
        msgboxService,
        exceptionService,
        utils,
        TimeLibrary,
        blockUI
    ) {
        var directive = {
            restrict: 'E',
            scope: {
                refresh: '&',
                isBusy: '=',
                loaderMessage: '=',
                item: '=',
                handlecheck: '&'
            },
            templateUrl: 'app/main/paperworkExceptions/directives/mainView/gridContainer/dynamicGrid/dynamic-grid.html',
            controller: paperWorkDynamicGridController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function paperWorkDynamicGridController(
            $state,
            mediaQueryService,
            DialogService
        ) {
            var vm = this;
            vm.media = mediaQueryService;

            vm.activate = activate;
            vm.showDetailsReact = showDetailsReact;
            vm.queryTimeSheetReact = queryTimeSheetReact;
            vm.convertTime = convertTime;
            vm.goToTimesheetReact = goToTimesheetReact;
            vm.downloadPDFReact = downloadPDFReact;
            vm.handle = handle;

            function showDetailsReact(Id) {
                DialogService.openTicketDetailDialog(Id, false, true);
            }

            function handle(params) {
                vm.handlecheck(params);
            }

            function convertTime(time) {
                return TimeLibrary.convertTimeAppend(time);
            }

            function queryTimeSheetReact(params) {
                setProcess(utils.translate("PAPERWORK_EXCEPTION.LOADING_TIMESHEET"));
                paperworkExceptionsApi.fetchTimesheet(params.PrimaryId, params.SecondaryId)
                    .then(queryTimeSheetCallback)
                    .catch(errorCallback);
            }

            function goToTimesheetReact(params) {
                proceedToTimesheet(params.TicketId, params.TicketNumber);
            }

            function proceedToTimesheet(ticket_id, ticket_number) {
                $state.go('app.timesheet', {
                    id: ticket_id,
                    TicketNo: ticket_number
                });
            }

            function queryTimeSheetCallback(resp) {
                stopProcess();
                let template = "app/main/paperworkExceptions/directives/mainView/gridContainer/dynamicGrid/timeSheet/timesheet-dialog.html";
                let controller = "paperWorkTimeSheetDialogController as vm";
                let locals = angular.copy(resp.data);
                msgboxService.showCustomDialog(template, controller, locals).then(saveTimesheet);
            }

            function downloadPDFReact(params) {
                blockUI.start("Downloading");
                let payload = {
                    RequestToken: utils.newGuid(),
                    TicketId: params.TicketId,
                    TicketNumber: params.TicketNumber
                }
                paperworkExceptionsApi.downloadPDF(payload).then(checkPDF).catch(errorCallback);
            }
            //React functions

            function setProcess(message) {
                vm.isBusy = true;
                vm.loaderMessage = message;
            }

            function stopProcess() {
                vm.isBusy = false;
                vm.loaderMessage = null;
            }

            function saveTimesheet(timesheet) {
                if (!_.isNil(timesheet)) {
                    setProcess(utils.translate("PAPERWORK_EXCEPTION.SAVING_TIMESHEET"));
                    paperworkExceptionsApi.saveTimesheet(timesheet.id, timesheet).then(saveTimesheetCallback).catch(errorCallback);
                }
            }

            function saveTimesheetCallback() {
                stopProcess();
                vm.refresh();
            }

            function errorCallback(ex) {
                stopProcess();
                exceptionService.resolve(ex);
            }

            function activate() {
                //Rows activation
                vm.item.DataRows.forEach(function(row) {
                    row['ExceptionType'] = vm.item.ExceptionType;
                    row['ReportTypeCategory'] = vm.item.ReportTypeCategory;
                });
                vm.item.DataRows = format(vm.item.DataRows);
            }

            function format(rows) {
                //To add additional row data for binding purposes
                let rows_list = [];
                rows.forEach(function(row) {
                    let columns = vm.item.HeaderColumns;
                    let new_row_form = formatRow(row, columns);
                    rows_list.push(new_row_form);
                });
                return rows_list;
            }

            function formatRow(row, columns) {
                let rows = [];
                _.forIn(row, function(value, key) {
                    let column = _.find(columns, {
                        HeaderKey: key
                    });
                    let display = !_.isNil(column) ? true : false;
                    let column_model = buildColumnModel(column, value, display, key);
                    rows.push(column_model);
                });
                return rows;
            }

            function buildColumnModel(column, value, display, header) {
                //Final column binding
                return {
                    HeaderKey: display ? column.HeaderKey : header,
                    HeaderName: display ? column.HeaderName : header,
                    FieldType: display ? column.FieldType : null,
                    OrderSequence: display ? column.OrderSequence : null,
                    Value: value,
                    Display: display
                }
            }

            function noPDFIssue(message) {
                return message === "" || message === '' || _.isNil(message)
            }

            function checkPDF(resp) {
                let res = resp.data;
                if (res.ErrorDescription.length > 0) {
                    blockUI.stop();
                }
                noPDFIssue(res.ErrorDescription) ? fetchPDF(res) : msgboxService.show(res.ErrorDescription)
            }

            function fetchPDF(res) {
                let anchor = angular.element('<a/>');
                let filenameParts = res.FileUri.split('/');
                anchor.attr({
                    href: encodeURI(res.FileUri),
                    target: '_blank',
                    download: filenameParts[filenameParts.length - 1]
                })[0].click();

                blockUI.stop();
            }

            vm.activate();
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.messaging')
        .directive('specialTextArea2', specialTextArea);

    function specialTextArea() {
        var directive = {
            restrict: 'E',
            scope : {
                rows : '=',
                limit : '=',
                isDisabled : '=',
                ngModel : '='
            },
            templateUrl: 'app/main/messaging/generalMessaging/sendMessageAsService/message/textArea/textArea.html',
            controller: specialTextAreaController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function specialTextAreaController($scope, mediaQueryService) {
            var vm = this;
            vm.limitChars = limitChars;
            vm.rows  = 10;
            vm.limit = 320;

            function limitChars(message){
                let lines = message.split("\n");
                if(message.length > vm.limit || vm.rows == lines.length){
                    vm.ngModel = vm.ngModel.substring(0, 320);
                    event.preventDefault();
                }
            }

            $scope.$watch(function(){return mediaQueryService.isDeviceMessagingBig()},function(res){if(res){let text_area=document.getElementById("textZone");$scope.$apply(function () {text_area.rows=15});}});
            $scope.$watch(function(){return mediaQueryService.isDeviceMessagingSmall()},function(res){if(res){let text_area=document.getElementById("textZone");$scope.$apply(function () {text_area.rows=5});}});
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.messaging')
        .directive('messageSection', messageSection);

    function messageSection() {
        var directive = {
            restrict: 'E',
            scope : {},
            templateUrl: 'app/main/messaging/generalMessaging/components/messageArea/message/message.html',
            controller: messageSectionController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function messageSectionController(messagingService) {
            var vm = this;
            vm.service = messagingService;
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.messaging')
        .directive('messageContainer', messageContainer);

    function messageContainer() {
        var directive = {
            restrict: 'E',
            scope : {},
            controller : controller,
            controllerAs : 'vm',
            templateUrl: 'app/main/messaging/generalMessaging/components/messageArea/container/container.html',
        };

        return directive;

        function controller(mediaQueryService, messagingService){
            var vm = this;
            vm.service = messagingService;
            vm.mediaService = mediaQueryService;
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.messaging')
        .directive('contactsSelected', contactsSelected);

    function contactsSelected() {
        var directive = {
            restrict: 'E',
            scope : {},
            templateUrl: 'app/main/messaging/generalMessaging/components/messageArea/contacts/contacts.html',
            controller: contactsSelectedController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function contactsSelectedController(_, messagingService, messageDialogService) {

            var vm = this;
            vm.searchText = null;
            vm.service = messagingService;

            vm.showFilterDialog = showFilterDialog;
            vm.querySearch = querySearch;

            function showFilterDialog(){
                messageDialogService.showMessageDialog();
            }

            function querySearch(search_text){
                let lowered_search_text = angular.copy(search_text.toLowerCase());
                let results = search_text ? vm.service.Employees.filter(function(employee){
                    return employee.Name.toLocaleLowerCase().includes(lowered_search_text);
                }) : [];
                return results.length > 0 ? _.orderBy(results, ['Name', 'asc']) : results;
            }

            
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.messaging')
      .directive('messagingTicketDetail', messagingTicketDetail);

    function messagingTicketDetail() {
        var directive = {
            restrict : 'E',
            templateUrl : 'app/main/messaging/generalMessaging/components/dialog/ticket-detail/ticket-detail.directive.html'
        };

        return directive;
    }
  })();

(function () {
    'use strict';

    angular
        .module('app.lockout-settings.view', ['angularInlineEdit', 'app.decimal'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.lockout-settings', {
            url: '/lockout-settings',
            views: {
                'content@app': {
                    templateUrl: 'app/main/lockoutSettings/view/lockout-settings-view.html',
                    controller: 'LockoutSettingsViewController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasLockoutMenu;
                }] 
            },
            title: 'Lockout Settings',
            titleBar: 'Alloc8 - Lockout Settings'
        });
        $translatePartialLoaderProvider.addPart('app/main/lockoutSettings/');
    }

})();

(function(){
  'use strict';

  angular.module('app.lockout-settings.view')
    .directive('rulesItem', rulesItem);

  function rulesItem() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/lockoutSettings/view/components/rulesList/ruleItem/rule-item.html',
      scope: {
        data : '='
      },
      controller : lockoutController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function lockoutController(lockoutSettingsService) {
      var vm = this;
      vm.service = lockoutSettingsService;
    }
  }
})();

/**
 * Job Detail Dialog
 * Created date: 8.22.2016
 */
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .controller('TicketDetailDialogController', TicketDetailDialogController);

    /** @ngInject */
    function TicketDetailDialogController($mdDialog,
            _,
            locals,
            auditApi,
            historyLogService,
            ticketInfoService,
             TimeLibrary,
            blockUI,
            $state,
            ticketsApi,
            ticketPdfService,
            exceptionService,
            claimsUtilService,
            jobsClaimsService,
            ticketStatus
        ) {
        var vm = this;

        vm.model = ticketInfoService.getData();

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            ordering: false
        };
        vm.showBack = false;

        vm.onBack = onBack;
        vm.onCancel = onCancel;
        vm.viewParentJob = viewParentJob;
        vm.onOpenAllocateResource = onOpenAllocateResource;
        vm.onOpenTimesheet = onOpenTimesheet;
        vm.Edit = Edit;
        vm.hideButtons = locals.hideButtons;
        vm.cloneTicket = cloneTicket;
        vm.printPDF = printPDF;
        vm.viewHistory = viewHistory;
        vm.convertTime = convertTime;
        vm.formsIds = vm.model.CreatedFormIds;
        vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();
        vm.jobsClaims = jobsClaimsService;
        vm.isPendingApproval = vm.model.Status == ticketStatus.PENDING_CLIENT_CONFIRMATION 
        || vm.model.Status == ticketStatus.PENDING_UPLOADS;
        activate();

        function activate() {
            if (locals) {
                vm.showBack = locals.showBack;
            }
        }

        function convertTime(time){
            return _.isNil(time) ? null : TimeLibrary.convertTime(time);
        }

        async function viewHistory(id, no) {
            var resp = await auditApi.getAuditEntries(id);
            historyLogService.showHistory("Ticket", resp.data, "#" + no);
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function onBack() {
            $mdDialog.hide({ action: 'back' });
        }

        function viewParentJob() {
            alert('Not yet available.');
        }

        function onOpenAllocateResource(ticketId, ticketNo) {
            $mdDialog.hide();
            $state.go('app.allocate', { id: ticketId, ticketNo: ticketNo, parentTicketNo: null });
        }

        function onOpenTimesheet(data) {
            $mdDialog.hide();
            $state.go('app.timesheet', { id: data.id || data.Id, isLocked: data.IsLocked, isLockedByPreSchedule: data.isLockedByPreSchedule, TicketNo: data.TicketNumber });
        }

        function Edit(ticketId, ticketNumber, parentTicketNumber) {
            $mdDialog.hide();
            $state.go('app.jobs_update', { id: ticketId, ticketNumber: ticketNumber, parentTicketNo: parentTicketNumber });
        }

        function cloneTicket(id, ticketNumber) {
            $mdDialog.hide();
            blockUI.start({ message: 'Checking related ticket...' });
            ticketsApi.getRelatedTicket(id).then(function (resp) {
                blockUI.stop();
                var related = { ticketId: resp.data.Id, ticketNumber: resp.data.TicketNumber };
                $state.go('app.jobs_clone', { cloneId: id, related: related });
            }).catch(function (ex) {
                blockUI.stop();
                exceptionService.resolve(ex);
            });
        }

        function printPDF(id) {
            $mdDialog.hide();
            ticketPdfService.getTicketPDF(id);
        }
    }
})();

/**
 * Job Detail Dialog
 * Created date: 8.22.2016
 */
(function () {
    'use strict';
    
    angular.module('app.jobs.whiteBoard')
           .controller('JobDetailDialogController2', JobDetailDialogController2);
    
    /** @ngInject */
    function JobDetailDialogController2($mdDialog, locals) {
         var vm = this;

         // Data
     
         // Actions
         vm.onCancel = onCancel;
         vm.onBack = onBack;

         activate();

         ///////
         function activate() {
         }

         function onCancel() {
             $mdDialog.hide();
         }

         function onBack() {
              $mdDialog.hide({ action: 'back' });
         }
    }
})();
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .controller('CardTicketDialogController', CardTicketDialogController);

    /** @ngInject */
    function CardTicketDialogController(
        $mdDialog,
        cardTicketDetailService
    ) {
        var vm = this;

        // Data
        vm.model = cardTicketDetailService;
        vm.nameLabel = 'Company Name';
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };

        vm.onCancel = onCancel;
        vm.viewJobDetails = viewJobDetails;

        activate();

        function activate() {}

        function onCancel() {
            $mdDialog.hide();
        }

        function viewJobDetails(ticketId) {

            if (cardTicketDetailService.previousState.type === 'dayview' || cardTicketDetailService.previousState.type === 'weekview') {
                $mdDialog.hide({
                    action: 'view_ticket',
                    model: vm.model,
                    ticketId: ticketId
                });
            } else {
                // Monthly
                $mdDialog.hide({
                    action: 'view_ticket',
                    model: vm.model,
                    ticketId: ticketId
                });
            }
        }
    }
})();

/**
 * Custom filtering
 * OBSOLETE!!!! Due to implementation of virtual repeat
 * By Rcnet
 */
(function () {
  'use strict';

  angular.module('app.jobs.whiteBoard')
    .filter('wboardCustomFilter', wboardCustomFilter);

  function wboardCustomFilter(_, alasql) {
    return function (collection, searchText) {
      var out = [];

      // Iterate in every search properties
      if (collection.length > 0) {

        if (!searchText) {
          return collection;
        }

        var searchKeywords = searchText.split(" "); //(/(\s+)/);
        var tmpCollection = collection;
        var allNumeric = isAllNumericKeyword(searchKeywords);

        if (!allNumeric) {
          searchKeywords.forEach(function (keyword) {
            if (keyword) {
              var sql = "select * from ?";
              sql += keyword != null ? " where branch like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or name like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or state like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or ticketNo like '" + keyword + "%'" : '';
              sql += keyword != null ? " or jobAddress like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or startDate like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or projectName like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or relatedTicketNumber like '%" + keyword + "%'" : '';              
              sql += keyword != null ? " or parentTicketNumber like '%" + keyword + "%'" : '';
              var result = alasql(sql, [tmpCollection]);

              tmpCollection = [];
              result.forEach(function (itm) {
                tmpCollection.push(itm);
              });
            }
          });

          tmpCollection.forEach(function (itm) {
            out.push(itm);
          });

          out = _.uniqBy(out, function (o) {
            return o.id;
          });
        } else {
          // For numeric
          searchKeywords.forEach(function (keyword) {
            if (keyword) {
              var sql = "select * from ?";
              sql += keyword != null ? " where branch like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or name like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or state like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or ticketNo like '" + keyword + "%'" : '';
              sql += keyword != null ? " or jobAddress like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or startDate like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or projectName like '%" + keyword + "%'" : '';
              sql += keyword != null ? " or relatedTicketNumber like '%" + keyword + "%'" : '';              
              sql += keyword != null ? " or parentTicketNumber like '%" + keyword + "%'" : '';
              var result = alasql(sql, [collection]);

              result.forEach(function (itm) {
                out.push(itm);
              });
            }
          });
          out = _.uniqBy(out, function (o) {
            return o.id;
          });
        }
      }

      function isAllNumericKeyword(keywords) {
        var f = _.filter(keywords, function (o) {
          return !isFinite(o);
        }).length;

        return f <= 0;
      }

      return out;
    }
  }
})();
/**
 * Using Jquery contextMenu.js
 * Todo: move the code into shared/widgets
 * by Rcnet
 * 02.28.2018 7.14pm
 */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopupMenuReact = function (_React$Component) {
    _inherits(PopupMenuReact, _React$Component);

    function PopupMenuReact(props) {
        _classCallCheck(this, PopupMenuReact);

        return _possibleConstructorReturn(this, (PopupMenuReact.__proto__ || Object.getPrototypeOf(PopupMenuReact)).call(this, props));
    }

    _createClass(PopupMenuReact, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var self = this;
            $.contextMenu({
                selector: '.' + self.props.componentId + '_popname',
                trigger: 'left',
                callback: function callback(key, options) {
                    self.props.itemSelected(key);
                },
                items: self.props.items
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            $.contextMenu('destroy', '.' + this.componentId + '_popname');
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {}
    }, {
        key: 'render',
        value: function render() {
            var self = this,
                classCustom = void 0;

            classCustom = self.props.componentId + '_popname ' + 'icon-dots-vertical s18';

            return React.createElement('i', { className: classCustom });
        }
    }]);

    return PopupMenuReact;
}(React.Component);

PopupMenuReact.propTypes = {
    componentId: React.PropTypes.string.isRequired,
    items: React.PropTypes.object.isRequired,
    itemSelected: React.PropTypes.func.isRequired,
    ticketId: React.PropTypes.string.isRequired,
    ticketNumber: React.PropTypes.string.isRequired
};
PopupMenuReact.defaultProps = {
    componentId: 'defaultPopupMenu',
    ticketId: null,
    ticketNumber: null,
    itemSelected: function itemSelected() {}
};
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('filterWhiteboardComponent', filterWhiteboardComponent);

    /** @ngInject */
    function filterWhiteboardComponent(
        _,
        BoardService,
        CardFilters,
        $rootScope
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/components/filter/filter-whiteboard.html',
            scope: {
                applyFilter: '&',
                canSearchText: '=',
                filterSearchText: '=',
                onTextSearch: '&',
                isResourceWhiteboard: '=',
                selectedShowHideFilters: '='
            },
            controller: filterWhiteboardComponent,
            controllerAs: 'vm',
            bindToController: true
        };
        filterWhiteboardComponent.$inject = ['$scope'];

        return directive;


        function filterWhiteboardComponent($scope) {
            let vm = this;

            vm.board = BoardService.data;
            vm.cardFilters = CardFilters;
            vm.isLoaded = false;
            vm.hasFilterToApply = false;
            vm.hasFilterToClear = false;
            vm.selectedMenu = 'Settings';
            vm.clearFilters = clearFilters;
            vm.onApplyFilter = onApplyFilter;

            /**
             * Tags Dropdown Search
             */
            vm.searchText = "";
            vm.tempSearchText = "";

            /**
             * Lookup Fields
             */
            vm.branches = [];
            vm.states = [];
            vm.tags = [];
            vm.filterGrouping = [];
            vm.filterTimeOfDay = [];
            vm.timesheetSubmissionTypes = [];
            vm.ticketTypes = [];
            vm.ticketStatus = [];

            /**
             * User Selected Values
             */
            vm.filterSearchText = '';
            vm.selectedStateIds = [];
            vm.selectedBranchIds = [];
            vm.selectedShowHideFilters = [];
            vm.selectedTimeOfDayIds = [];
            vm.selectedTicketTypeIds = [];
            vm.selectedTimesheetSubmissionTypeIds = [];
            vm.selectedIncludedTags = [];
            vm.selectedExcludedTags = [];
            vm.selectedTicketsGroupingId = '';
            vm.selectedTicketStatus = [];

            $rootScope.$on('refreshTagLookup', function(ev, tag) {
                if (tag && !vm.tags.some(f => f.Id === tag.id)) {
                    CardFilters.loadLookups(true);
                    vm.tags.push({
                        Id: tag.id,
                        Name: tag.Name,
                        IsActive: tag.IsActive,
                        NumberOfUsages: 0,
                        selected: false,
                        excluded: false
                    });
                    vm.tags = _.orderBy(vm.tags, ['Name'], ['asc']);
                }
            });

            vm.getFilterPlaceholder = function(text, model) {
                return "<div class='filter-placeholder'>" + text + " <span class='filter-counter'>" + _.size(model) + "</span></div>";
            };

            vm.convertStartCase = function(chip) {
                if(chip == 'SchedulingCopilotIsInProgress'){
                    return 'Scheduling Copilot is in progress';
                }
                else if(chip == 'SchedulingCopilotIsComplete'){
                    return 'Scheduling Copilot is complete';
                }

                return _.startCase(chip);
            };

            vm.getSelectedBranchName = function(id) {
                let branch = _.find(vm.branches, {
                    'Id': id
                });
                return branch ? branch.Name : '';
            };

            vm.getTagName = function(id) {
                let tag = _.find(vm.tags, {
                    'Id': id
                });
                return tag ? tag.Name : '';
            };

            vm.querySearchTag = function(e) {
                e.stopImmediatePropagation();
            };

            function activate() {
                populateLookups();

                if (CardFilters.filterMode) {
                    syncSelectedValuesFromCardFilters();
                }

                watchFilterChanges();
            }

            function populateLookups() {
                vm.branches = CardFilters.branches;
                vm.states = CardFilters.states;
                vm.tags = CardFilters.tags;
                vm.filterGrouping = CardFilters.filterGrouping;
                vm.filterTimeOfDay = CardFilters.filterTimeOfDay;
                vm.ticketStatus = CardFilters.ticketStatus.filter(e => e.show);

                if (vm.isResourceWhiteboard) {
                    vm.timesheetSubmissionTypes = CardFilters.timesheetSubmissionTypes;
                    vm.ticketTypes = CardFilters.ticketTypes;
                }
            }

            function onApplyFilter(resetFilterHash) {
                syncSelectedValuesWithCardFilters();

                if (resetFilterHash) {
                    CardFilters.resetFilterHash();
                }
                (vm.applyFilter || angular.noop)();
                vm.cardFilters.hasFilterToApply = false;
            }

            function syncSelectedValuesFromCardFilters() {
                vm.filterSearchText = CardFilters.searchText;
                vm.selectedTicketsGroupingId = CardFilters.allowGroupByClient ? 'groupByClient' : '';

                if (CardFilters.showProject) {
                    vm.selectedShowHideFilters.push('showProject');
                }

                if (CardFilters.showRelatedTicketNumber) {
                    vm.selectedShowHideFilters.push('showRelatedTicketNumber');
                }

                if (CardFilters.showNightShift) {
                    vm.selectedTimeOfDayIds.push('showNightShift');
                }

                if (CardFilters.showDayShift) {
                    vm.selectedTimeOfDayIds.push('showDayShift');
                }

                vm.selectedBranchIds = CardFilters.branches
                    .filter(p => p.selected)
                    .map(p => p.Id);

                vm.selectedStateIds = CardFilters.states
                    .filter(p => p.selected)
                    .map(p => p.id);

                CardFilters.tags.forEach(tag => {
                    if (tag.included) {
                        vm.selectedIncludedTags.push(tag.Id);
                    }

                    if (tag.excluded) {
                        vm.selectedExcludedTags.push(tag.Id);
                    }
                });

                if (vm.isResourceWhiteboard) {
                    if (CardFilters.showResources) {
                        vm.selectedShowHideFilters.push('showResources');
                    }

                    if (CardFilters.showWorkOrderNumber) {
                        vm.selectedShowHideFilters.push('showWorkOrderNumber');
                    }

                    vm.selectedTicketTypeIds = CardFilters.ticketTypes
                        .filter(p => p.selected)
                        .map(p => p.Id);

                    vm.selectedTimesheetSubmissionTypeIds = CardFilters.timesheetSubmissionTypes
                        .filter(p => p.selected)
                        .map(p => p.Id);
                        
                    vm.selectedTicketStatus = CardFilters.ticketStatus
                        .filter(p => p.selected)
                        .map(p => p.Id);
                }
            }

            function syncSelectedValuesWithCardFilters() {
                CardFilters.searchText = vm.filterSearchText;
                CardFilters.allowGroupByClient = vm.selectedTicketsGroupingId == 'groupByClient';
                CardFilters.showProject = _.includes(vm.selectedShowHideFilters, 'showProject');
                CardFilters.showRelatedTicketNumber = _.includes(vm.selectedShowHideFilters, 'showRelatedTicketNumber');
                CardFilters.showResources = _.includes(vm.selectedShowHideFilters, 'showResources');
                CardFilters.showNightShift = _.includes(vm.selectedTimeOfDayIds, 'showNightShift');
                CardFilters.showDayShift = _.includes(vm.selectedTimeOfDayIds, 'showDayShift');

                CardFilters.branches.forEach(branch => {
                    branch.selected = _.includes(vm.selectedBranchIds, branch.Id);
                });

                CardFilters.states.forEach(state => {
                    state.selected = _.includes(vm.selectedStateIds, state.id);
                });

                CardFilters.tags.forEach(tag => {
                    tag.included = _.includes(vm.selectedIncludedTags, tag.Id);
                    tag.excluded = _.includes(vm.selectedExcludedTags, tag.Id);
                });

                if (vm.isResourceWhiteboard) {
                    CardFilters.showResources = _.includes(vm.selectedShowHideFilters, 'showResources');
                    CardFilters.showWorkOrderNumber = _.includes(vm.selectedShowHideFilters, 'showWorkOrderNumber');

                    CardFilters.ticketTypes.forEach(ticketType => {
                        ticketType.selected = _.includes(vm.selectedTicketTypeIds, ticketType.Id);
                    });

                    CardFilters.timesheetSubmissionTypes.forEach(submissionType => {
                        submissionType.selected = _.includes(vm.selectedTimesheetSubmissionTypeIds, submissionType.Id);
                    });

                    CardFilters.ticketStatus.forEach(status => {
                        status.selected = _.includes(vm.selectedTicketStatus, status.Id);
                    });
                }

                CardFilters.onUpdateFilterValues();
            }

            function clearFilters() {

                vm.filterSearchText = '';
                vm.selectedStateIds = [];
                vm.selectedBranchIds = [];
                vm.selectedShowHideFilters = [];
                vm.selectedTimeOfDayIds = [];
                vm.selectedTicketTypeIds = [];
                vm.selectedTimesheetSubmissionTypeIds = [];
                vm.selectedIncludedTags = [];
                vm.selectedExcludedTags = [];
                vm.selectedTicketsGroupingId = '';
                vm.hasFilterToClear = false;
                vm.selectedTicketStatus = [];

                onApplyFilter(true);
            }

            function toggleButtons(IsEmptyFilter) {

                if (!vm.cardFilters.hasFilterToApply && !vm.hasFilterToClear && !IsEmptyFilter) {
                    vm.cardFilters.hasFilterToApply = true;
                    vm.hasFilterToClear = true;
                } else if (!vm.hasFilterToClear && IsEmptyFilter) {
                    vm.cardFilters.hasFilterToApply = false;
                } else if (!vm.cardFilters.hasFilterToApply) {
                    vm.cardFilters.hasFilterToApply = true;
                }
            }

            function watchFilterChanges() {

                 $scope.$watchCollection(function() {
                     return [...vm.filterSearchText,
                         ...vm.selectedStateIds,
                         ...vm.selectedBranchIds,
                         ...vm.selectedShowHideFilters,
                         ...vm.selectedTimeOfDayIds,
                         ...vm.selectedTicketTypeIds,
                         ...vm.selectedTimesheetSubmissionTypeIds,
                         ...vm.selectedIncludedTags,
                         ...vm.selectedExcludedTags,
                         ...vm.selectedTicketsGroupingId,
                         ...vm.selectedTicketStatus
                     ]
                 }, function(newVal, oldVal) {
                     if (newVal !== oldVal) {
                         var IsEmptyFilter = false;
                        if(newVal.length == 0){
                            IsEmptyFilter = true;
                        }
                         toggleButtons(IsEmptyFilter);

                     }
                 });
            }

            activate();
        }
    }
})();

'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isMouseBeyond(mousePos, elementPos, elementSize) {
  //TODO refactor for UP
  var breakPoint = elementSize / 2; //break point is set to the middle line of element
  var mouseOverlap = mousePos - elementPos;
  return mouseOverlap > breakPoint;
}

function SortableComposition(Component) {
  var _class, _temp;

  var elementEdge = 0;
  var updateEdge = true;

  return _temp = _class = function (_React$Component) {
    _inherits(SortablePropsProxy, _React$Component);

    function SortablePropsProxy() {
      _classCallCheck(this, SortablePropsProxy);

      var _this = _possibleConstructorReturn(this, (SortablePropsProxy.__proto__ || Object.getPrototypeOf(SortablePropsProxy)).call(this));

      _this.state = {
        draggingIndex: null
      };

      _this.sortStart = _this.sortStart.bind(_this);
      _this.dragOver = _this.dragOver.bind(_this);
      _this.sortEnd = _this.sortEnd.bind(_this);
      _this.isDragging = _this.isDragging.bind(_this);
      _this.dropMe = _this.dropMe.bind(_this);
      return _this;
    }

    _createClass(SortablePropsProxy, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.setState({
          draggingIndex: nextProps.draggingIndex
        });
      }
    }, {
      key: 'sortEnd',
      value: function sortEnd() {
        this.props.updateState({
          draggingIndex: null
        });

        sessionStorage.setItem('dragData', null);
      }
    }, {
      key: 'sortStart',
      value: function sortStart(e) {
        var draggingIndex = Number(e.currentTarget.dataset.id);

        sessionStorage.setItem('dragData', this.props.dropZoneId);

        this.props.updateState({
          draggingIndex: draggingIndex
        });
        this.setState({
          draggingIndex: draggingIndex
        });
        if (e.dataTransfer !== undefined) {
          e.dataTransfer.setData('ticketNo', this.props.ticketNo);
          e.dataTransfer.setData('dragData', this.props.dropZoneId);
          e.dataTransfer.setData('text', e.target);
          e.dataTransfer.setData('isLocked', this.props.isLocked);
        }
        updateEdge = true;
      }
    }, {
      key: 'dragOver',
      value: function dragOver(e) {
        e.preventDefault();

        var mouseBeyond;
        var positionX, positionY;
        var height, topOffset;
        var overEl = e.currentTarget;
        var indexDragged = Number(overEl.dataset.id);
        var indexFrom = Number(this.state.draggingIndex);
        var zoneIdDragged = Number(sessionStorage.getItem('dragData'));

        height = overEl.getBoundingClientRect().height;

        if (e.type === "dragover") {
          positionX = e.clientX;
          positionY = e.clientY;
          topOffset = overEl.getBoundingClientRect().top;
        }

        if (e.type === "touchmove") {
          positionX = e.touches[0].pageX;
          positionY = e.touches[0].pageY;
          if (updateEdge) {
            elementEdge = e.currentTarget.getBoundingClientRect().top;
            updateEdge = false;
          }
          topOffset = elementEdge;
        }

        if (this.props.outline === "list") {
          mouseBeyond = isMouseBeyond(positionY, topOffset, height);
        }

        if (this.props.outline === "column") {
          mouseBeyond = isMouseBeyond(positionX, overEl.getBoundingClientRect().left, overEl.getBoundingClientRect().width);
        }

        if (indexDragged !== indexFrom && mouseBeyond) {
          this.props.updateState({
            action: 'swap',
            draggingIndex: indexDragged,
            indexFrom: indexFrom,
            indexTo: indexDragged,
            fromZoneId: zoneIdDragged,
            toZoneId: this.props.dropZoneId
          });
        }
      }
    }, {
      key: 'dropMe',
      value: function dropMe(e) {
        e.preventDefault();
      }
    }, {
      key: 'isDragging',
      value: function isDragging() {
        return this.props.draggingIndex == this.props.sortId;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {}
    }, {
      key: 'render',
      value: function render() {
        var draggingClassName = Component.displayName + "-dragging";

        return React.createElement(Component, _extends({
          className: this.isDragging() ? draggingClassName : "",
          draggable: true,
          onDragOver: this.dragOver,
          onDragStart: this.sortStart,
          onDragEnd: this.sortEnd,
          onDrop: this.dropMe,
          onTouchStart: this.sortStart,
          onTouchMove: this.dragOver,
          onTouchEnd: this.sortEnd,
          children: this.props.children,
          'data-id': this.props.sortId
        }, this.props.childProps || {}));
      }
    }]);

    return SortablePropsProxy;
  }(React.Component), _class.propTypes = {
    updateState: React.PropTypes.func.isRequired,
    sortId: React.PropTypes.number,
    outline: React.PropTypes.string.isRequired,
    draggingIndex: React.PropTypes.number,
    childProps: React.PropTypes.object
  }, _temp;
}

var ListItem = React.createClass({
  displayName: 'SortableListItem',
  render: function render() {
    return React.createElement(
      'div',
      _extends({}, this.props, { className: 'list-item' }),
      this.props.children
    );
  }
});

var SortableListItem = SortableComposition(ListItem);
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function DropZoneComposition(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(DropZonePropsProxy, _React$Component);

        function DropZonePropsProxy() {
            _classCallCheck(this, DropZonePropsProxy);

            var _this = _possibleConstructorReturn(this, (DropZonePropsProxy.__proto__ || Object.getPrototypeOf(DropZonePropsProxy)).call(this));

            _this.dropMe = _this.dropMe.bind(_this);
            _this.sortEnd = _this.sortEnd.bind(_this);
            return _this;
        }

        _createClass(DropZonePropsProxy, [{
            key: 'componentDidMount',
            value: function componentDidMount() {}
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {}
        }, {
            key: 'sortEnd',
            value: function sortEnd() {
                sessionStorage.setItem('dragData', null);
            }
        }, {
            key: 'dropMe',
            value: function dropMe(e) {
                e.preventDefault();
                var overEl = e.currentTarget;
                var ticketNo = e.dataTransfer.getData('ticketNo');
                var zoneIdDragged = e.dataTransfer.getData('dragData');
                var isLocked = e.dataTransfer.getData('isLocked');

                if (isLocked === 'true') {
                    e.stopPropagation();
                    return;
                }

                if (!zoneIdDragged) {
                    zoneIdDragged = Number(sessionStorage.getItem('dragData'));
                }

                if (ticketNo != null && zoneIdDragged != null) {
                    this.props.updateState({
                        action: 'moveToDropZone',
                        fromZoneId: zoneIdDragged,
                        toZoneId: this.props.dropZoneId,
                        ticketNo: ticketNo
                    });
                }

                e.dataTransfer.setData('ticketNo', null);
            }
        }, {
            key: 'dragOver',
            value: function dragOver(e) {
                e.preventDefault();
            }
        }, {
            key: 'render',
            value: function render() {
                var droppingClassName = Component.displayName + "-dropping";
                return React.createElement(Component, _extends({
                    className: droppingClassName,
                    onDragEnd: this.sortEnd,
                    onDrop: this.dropMe,
                    onDragOver: this.dragOver,
                    onTouchEnd: this.sortEnd,
                    children: this.props.children
                }, this.props.childProps || {}));
            }
        }]);

        return DropZonePropsProxy;
    }(React.Component), _class.propTypes = {
        updateState: React.PropTypes.func.isRequired,
        childProps: React.PropTypes.object
    }, _class.self = this, _temp;
}

var DropZoneItem = React.createClass({
    displayName: 'DropZoneArea',
    render: function render() {
        return React.createElement(
            'div',
            this.props,
            this.props.children
        );
    }
});

var DropZoneArea = DropZoneComposition(DropZoneItem);
(function() {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard', [
            'ui.calendar',
            'mdPickers',
            'react',
            'infinite-scroll'
        ])
        .config(config)
        .run(whiteBoardRunConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider.state('app.jobs_whiteboard_resource', {
            url: '/jobs/whiteboard/resource',
            params: {
                view: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/resource-wboard.default.html',
                    controller: 'ResourceWhiteBoardController as jobBoardVm'
                }
            },
            data: { requireLogin: true },
            resolve: {
                cardFilterData: cardFilterResolver
            },
            title: 'Resource Whiteboard',
            titleBar: 'Alloc8 - Resource Whiteboard',
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/jobs/resourceWhiteBoard');
        $translatePartialLoaderProvider.addPart('app/main/jobs/resourceWhiteBoard/wBoard/weekly');
    }

    /** @ngInject */
    function whiteBoardRunConfig(whiteboardHubServiceRw, whiteboardCustomRouteService, jobMessagingHubService) {
        whiteboardHubServiceRw.register();
        whiteboardCustomRouteService.registerRouteLogic();
        jobMessagingHubService.register();
    }

    /** @ngInject */
    function cardFilterResolver(CardFilters) {
        return CardFilters.loadLookups();
    }

})();

/**
 * Date Navigation Component
 * - rcnet 11.29.2018
 */
(function () {
    'use strict';

    // Matches ItemTypes.People on the server.
    var ITEM_TYPE_PEOPLE = 4;
    // Matches TicketType.EquipmentOnly on the server.
    var TICKET_TYPE_EQUIPMENT_ONLY = 1;

    angular.module('app.jobs.resourceWhiteboard')
        .directive('ticketStatusDetailsRwComponent', ticketStatusDetailsRwComponent);

    /** @ngInject */
    function ticketStatusDetailsRwComponent(
    ) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/weekly/ticketStatusDetails/ticket-status-details-rw.html',
            scope: {
                status: '=',
                allowGroupByClient: '=',
                showEquipmentAllocationIcon: '=',
                showShiftAllocationIcon: '=',
                showRequireAllocationIcon: '=',
                allocatedResourceItems: '=',
                ticketType: '=',
                isDayShift: '=',
                whiteboardType: '=',
                isEmailSent: '=',
                isRequiredAttachmentsCompleted: '=',
                hasRequiredAttachments: '='
            },
            controller: TicketStatusDetailsRwController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function TicketStatusDetailsRwController($scope, claimsUtilService) {
            var vm = this;
            activate();

            vm.getHeaderColorClass = getHeaderColorClass;
            vm.hasUnlinkedRequiredItem = hasUnlinkedRequiredItem;

            ///////
            function activate() {
            }

            // "Missing linked item" indicator: an allocated non-people item whose config
            // requires it to be linked but which has no parent link yet. Mirrors the backend
            // job-readiness rule so the icon and the red Not-Ready state never disagree —
            // including when linking is disabled, where readiness ignores the rule entirely, and
            // the AllocatedId guard, so an item that is not allocated at all is reported by the
            // equipment indicator rather than as a missing link.
            // Equipment Only is exempt for the same reason it is on the server: the customer
            // supplies the towing vehicle, so there is never a parent to link to and readiness
            // does not hold the job. Showing the icon here would flag a green card as a problem.
            function hasUnlinkedRequiredItem() {
                if (!claimsUtilService.isLinkedItemsEnabled()) {
                    return false;
                }

                if (vm.ticketType == TICKET_TYPE_EQUIPMENT_ONLY) {
                    return false;
                }

                return (vm.allocatedResourceItems || []).some(function(item) {
                    return item.requireToBeLinked &&
                           item.allocatedId &&
                           !item.parentAllocatedResourceId &&
                           item.itemType != ITEM_TYPE_PEOPLE;
                });
            }

            function getHeaderColorClass() {
                if (vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted) return 'md-red-bg';
                if (!vm.status || !vm.status[0]) return '';
                var abbrev = vm.status[0].abbrev;
                if (abbrev === 'AR') return 'md-red-bg';
                if (abbrev === 'C' || abbrev === 'AIC') return 'md-blue-bg';
                if (abbrev === 'R' || abbrev === 'AIR') return 'md-green-bg';
                if (abbrev === 'A') return 'md-orange-bg';
                if (abbrev === 'AIP') return 'md-purple-200-bg';
                if (abbrev === 'AID') return 'md-deep-purple-500-bg';
                if (abbrev === 'CJPA') return 'md-yellow-bg';
                return '';
            }

            $scope.$on('$destroy', function () {
                vm.status = null;
                vm.showEquipmentAllocationIcon = null;
                vm.showShiftAllocationIcon = null;
                vm.showRequireAllocationIcon = null;
                vm.allocatedResourceItems = null;
                vm.ticketType = null;
                vm.isDayShift = null;
                vm.isRequiredAttachmentsCompleted = false;
                vm.hasRequiredAttachments = false;
            });

        }

    }
})();
/**
 * Week ticket info Component
 * - rcnet 11.29.2018
 */
(function () {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .directive('weekTicketInfoRwComponent', weekTicketInfoRwComponent);

    /** @ngInject */
    function weekTicketInfoRwComponent(
    ) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/weekly/ticketInfo/week-ticket-info-rw.html',
            scope: {
                cardName: '=',
                allowGroupByClient: '=',
                ticketCount: '=',
                startDate: '=',
                endDate: '=',
                branch: '=',
                jobAddress: '=',
                jobLocationAddress: '=',
                projectName: '=',
                showProject: '=',
                resourceItems: '='
            },
            controller: WeekTicketInfoRwController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function WeekTicketInfoRwController($scope) {
            var vm = this;
            vm.contentInfoCss;
            vm.getAddress = getAddress;
            activate();

            ///////
            function activate() {
                vm.contentInfoCss = vm.allowGroupByClient == false && vm.showProject == false ? 'week-ticket-info-container-big' : 'week-ticket-info-container-small';
            }

            function getAddress(address) {
                return address.join(" ");
            }

            $scope.$on('$destroy', function () {
                vm.cardName = null;
                vm.cardName = null;
                vm.allowGroupByClient = null;
                vm.ticketCount = null;
                vm.startDate = null;
                vm.endDate = null;
                vm.branch = null;
                vm.jobAddress = null;
                vm.jobLocationAddress = null;
                vm.projectName = null;
                vm.showProject = null;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .directive('weekTicketFooterRwComponent', weekTicketFooterRwComponent);

    /** @ngInject */
    function weekTicketFooterRwComponent(claimsUtilService, jobsClaimsService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/weekly/ticketFooter/week-ticket-footer-rw.html',
            scope: {
                id: '=',
                ticketNo: '=',
                parentTicketNo: '=',
                allowGroupByClient: '=',
                isUnConfirmedDate: '=',
                isLocked: '=',
                isLockedByPreSchedule: '=',
                startDate: '=',
                onAddRelatedTicket: '&',
                onOpenResourceAllocation: '&',
                onOpenTimesheet: '&',
                onOpenEditTicket: '&',
                onCancelTicket: '&',
                onCloneTicket: '&',
                onDownloadPdf: '&',
                onDownloadPaperworkPdf: '&',
                onDownloadTimesheetPdf: '&',
                onTicketBillingPref: '&',
                showRelatedTicketNumber: '=',
                ticketType: '=',
                hasGeneratedPaperworkPdf: '=',
                whiteboardType: '=',
                onPreSchedule: '&',
                ticket : '='
            },
            controller: WeekTicketFooterRwController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function WeekTicketFooterRwController($state, ticketStatus) {

            const TICKET_TYPE_PLAN_ONLY = 4;

            var vm = this;

            // Data
            vm.disableTimesheet = false;

            // Methods
            vm.openEditTicket = openEditTicket;
            vm.openResourceAllocation = openResourceAllocation;
            vm.openTimesheet = openTimesheet;
            vm.cloneTicket = cloneTicket;
            vm.cancelTicket = cancelTicket;
            vm.addRelatedTicket = addRelatedTicket;
            vm.downloadPdf = downloadPdf;
            vm.addTicketBillingPref = addTicketBillingPref;
            vm.openMenu = openMenu;
            vm.downloadPaperworkPdf = downloadPaperworkPdf;
            vm.downloadTimesheetPdf = downloadTimesheetPdf;
            vm.claimsUtilService = claimsUtilService;
            vm.jobsClaims = jobsClaimsService;
            vm.isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
            vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
            vm.isCustomFormsEnabled = claimsUtilService.isCustomFormsEnabled();
            vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();
            vm.hasSmartSchedulingAccess = claimsUtilService.hasSmartSchedulingAccess();
            vm.preSchedule = preSchedule;
            vm.showSmartScheduling = showSmartScheduling;
            vm.disabledTicketBillingPreference = disabledTicketBillingPreference;
            vm.disableAddRelatedTicket = disableAddRelatedTicket;
            
            vm.goToFormsAndAttachment = function(){
                $state.go('app.formsattachments', { TicketId: vm.id, TicketNo : vm.ticketNo });
            };

            vm.isTimesheetDisabled = function () {
                return (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled) || ((vm.isLocked) && vm.ticketType !== 6 && vm.ticketType !== 3 && vm.ticketType !== 7) || vm.ticketType === 1 || vm.ticketType === 4;
            };

            activate();

            function activate() {
                vm.disableTimesheet = (vm.isSmartSchedulingEnabled && (vm.ticket.status[0].abbrev == 'AIP' || vm.ticket.status[0].abbrev == 'AID')) || ((vm.isLocked) && vm.ticketType != 6 && vm.ticketType != 3 && vm.ticketType != 7) || vm.ticketType == 1 || vm.ticketType == 4;
                vm.disableCloneTimesheet = (vm.isSmartSchedulingEnabled && vm.isLockedByPreSchedule)
            }

            function disableAddRelatedTicket()
            {
                return vm.ticket.status[0].id == ticketStatus.PENDING_CLIENT_CONFIRMATION
                || vm.ticket.status[0].id == ticketStatus.PENDING_UPLOADS;
            }

            function disabledTicketBillingPreference()
            {
                return vm.ticket.status[0].id == ticketStatus.PENDING_CLIENT_CONFIRMATION
                || vm.ticket.status[0].id == ticketStatus.PENDING_UPLOADS;
            }

            function openEditTicket(id, ticketNo, isLocked, isLockedByPreSchedule, parentTicketNo) {
                (vm.onOpenEditTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        isLocked: isLocked,
                        isLockedByPreSchedule: isLockedByPreSchedule,
                        parentTicketNo: parentTicketNo
                    }
                });
            }

            function openResourceAllocation(id, ticketNo, parentTicketNo) {
                (vm.onOpenResourceAllocation || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        parentTicketNo: parentTicketNo
                    }
                });
            }

            function openTimesheet(id, isLocked, isLockedByPreSchedule, ticketNo) {
                (vm.onOpenTimesheet || angular.noop)({
                    value: {
                        id: id,
                        isLocked: isLocked,
                        isLockedByPreSchedule: isLockedByPreSchedule,
                        ticketNo: ticketNo
                    }
                });
            }

            function cloneTicket(id, ticketNo) {
                (vm.onCloneTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function cancelTicket(id, ticketNo) {
                (vm.onCancelTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        ticketType: vm.ticketType
                    }
                });
            }

            function addRelatedTicket(e, id) {
                (vm.onAddRelatedTicket || angular.noop)({
                    value: {
                        id: id
                    }
                });
            }

            function downloadPdf(e, id) {
                (vm.onDownloadPdf || angular.noop)({
                    value: {
                        id: id
                    }
                });
            }

            function addTicketBillingPref(e, dt, id) {
                (vm.onTicketBillingPref || angular.noop)({
                    value: {
                        dt: dt,
                        id: id
                    }
                });
            }

            function downloadPaperworkPdf(e, id, ticketNo) {
                (vm.onDownloadPaperworkPdf || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function downloadTimesheetPdf(e, id, ticketNo) {
                (vm.onDownloadPaperworkPdf || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function openMenu($mdOpenMenu, e) {
                $mdOpenMenu(e);
            }

            function preSchedule(id){
                (vm.onPreSchedule || angular.noop)({
                    value: {
                        id: id,
                        ticket:vm.ticket
                    },

                });
            }

            function showSmartScheduling(){
                return vm.hasSmartSchedulingAccess &&
                        !vm.ticket.IsLockedByPreSchedule &&
                        vm.ticket.ticketType != TICKET_TYPE_PLAN_ONLY
                        vm.ticket.allocatedResourceItems.some(x => !x.allocatedId);
            }
        }
    }
})();

/**
 * Date Navigation Component
 * - rcnet 8.16.2016
 */
(function() {
    'use strict';

    // Matches ItemTypes.People on the server.
    var ITEM_TYPE_PEOPLE = 4;
    // Matches TicketType.EquipmentOnly on the server.
    var TICKET_TYPE_EQUIPMENT_ONLY = 1;

    angular.module('app.jobs.resourceWhiteboard')
        .directive('dailyTicketStatusRwComponent', dailyTicketStatusRwComponent);

    /** @ngInject */
    function dailyTicketStatusRwComponent() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/daily/dailyTicketStatus/daily-ticket-status-rw.html',
            scope: {
                status: '=',
                allowGroupByClient: '=',
                showEquipmentAllocationIcon: '=',
                showShiftAllocationIcon: '=',
                showRequireAllocationIcon: '=',
                allocatedResourceItems: '=',
                ticketType: '=',
                isDayShift: '=',
                whiteboardType: '=',
                isEmailSent: '=',
                isRequiredAttachmentsCompleted: '=',
                hasRequiredAttachments: '='
            },
            controller: DailyTicketStatusRwController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DailyTicketStatusRwController($scope, claimsUtilService) {
            var vm = this;
            activate();

            vm.getHeaderColorClass = getHeaderColorClass;
            vm.hasUnlinkedRequiredItem = hasUnlinkedRequiredItem;

            ///////
            function activate() {}

            // "Missing linked item" indicator: an allocated non-people item whose config
            // requires it to be linked but which has no parent link yet. Mirrors the backend
            // job-readiness rule so the icon and the red Not-Ready state never disagree —
            // including when linking is disabled, where readiness ignores the rule entirely, and
            // the AllocatedId guard, so an item that is not allocated at all is reported by the
            // equipment indicator rather than as a missing link.
            // Equipment Only is exempt for the same reason it is on the server: the customer
            // supplies the towing vehicle, so there is never a parent to link to and readiness
            // does not hold the job. Showing the icon here would flag a green card as a problem.
            function hasUnlinkedRequiredItem() {
                if (!claimsUtilService.isLinkedItemsEnabled()) {
                    return false;
                }

                if (vm.ticketType == TICKET_TYPE_EQUIPMENT_ONLY) {
                    return false;
                }

                return (vm.allocatedResourceItems || []).some(function(item) {
                    return item.requireToBeLinked &&
                           item.allocatedId &&
                           !item.parentAllocatedResourceId &&
                           item.itemType != ITEM_TYPE_PEOPLE;
                });
            }

            function getHeaderColorClass() {
                if (vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted) return 'md-red-bg';
                if (!vm.status || !vm.status[0]) return '';
                var abbrev = vm.status[0].abbrev;
                if (abbrev === 'AR') return 'md-red-bg';
                if (abbrev === 'C' || abbrev === 'AIC') return 'md-blue-bg';
                if (abbrev === 'R' || abbrev === 'AIR') return 'md-green-bg';
                if (abbrev === 'A') return 'md-orange-bg';
                if (abbrev === 'AIP') return 'md-purple-200-bg';
                if (abbrev === 'AID') return 'md-deep-purple-500-bg';
                if (abbrev === 'CJPA') return 'md-yellow-bg';
                return '';
            }
            
            $scope.$on('$destroy', function() {
                vm.status = null;
                vm.showEquipmentAllocationIcon = null;
                vm.showShiftAllocationIcon = null;
                vm.showRequireAllocationIcon = null;
                vm.allocatedResourceItems = null;
                vm.ticketType = null;
                vm.isDayShift = null;
                vm.isRequiredAttachmentsCompleted = false;
                vm.hasRequiredAttachments = false;
            });
        }

    }
})();
/**
 * Daily ticket info Component
 * - rcnet 11.29.2018
 */
(function() {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .directive('dailyTicketInfoRwComponent', dailyTicketInfoRwComponent);

    /** @ngInject */
    function dailyTicketInfoRwComponent() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/daily/dailyTicketInfo/daily-ticket-info-rw.html',
            scope: {
                cardName: '=',
                allowGroupByClient: '=',
                ticketCount: '=',
                startDate: '=',
                endDate: '=',
                branch: '=',
                jobAddress: '=',
                jobLocationAddress: '=',
                projectName: '=',
                showProject: '=',
                whiteboardType: '='
            },
            controller: DailyTicketInfoRwController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DailyTicketInfoRwController($scope) {
            var vm = this;
            vm.getAddress = getAddress;

            activate();

            ///////
            function activate() {}

            function getAddress(address) {
                return address.join(" ");
            }

            $scope.$on('$destroy', function() {
                vm.cardName = null;
                vm.cardName = null;
                vm.allowGroupByClient = null;
                vm.ticketCount = null;
                vm.startDate = null;
                vm.endDate = null;
                vm.branch = null;
                vm.jobAddress = null;
                vm.jobLocationAddress = null;
                vm.projectName = null;
                vm.showProject = null;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .directive('dailyTicketFooterRwComponent', dailyTicketFooterRwComponent);

    /** @ngInject */
    function dailyTicketFooterRwComponent(claimsUtilService, jobsClaimsService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/daily/dailyTicketFooter/daily-ticket-footer-rw.html',
            scope: {
                id: '=',
                ticketNo: '=',
                allowGroupByClient: '=',
                startDate: '=',
                onAddRelatedTicket: '&',
                onOpenResourceAllocation: '&',
                onOpenTimesheet: '&',
                onOpenEditTicket: '&',
                onCancelTicket: '&',
                onCloneTicket: '&',
                onDownloadPdf: '&',
                onTicketBillingPref: '&',
                onPreSchedule: '&',
                onDownloadPaperworkPdf: '&',
                onDownloadTimesheetPdf: '&',
                isUnConfirmedDate: '=',
                isLocked: '=',
                isLockedByPreSchedule: '=',
                ticketType: '=',
                parentTicketNo: '=',
                whiteboardType: '=',
                hasGeneratedPaperworkPdf: '=',
                ticket:'='
            },
            controller: DailyTicketFooterRwController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        function DailyTicketFooterRwController($state, ticketStatus) {

            const TICKET_TYPE_PLAN_ONLY = 4;

            var vm = this;

            // Data
            vm.disableTimesheet = false;

            // Method
            vm.openEditTicket = openEditTicket;
            vm.openResourceAllocation = openResourceAllocation;
            vm.openTimesheet = openTimesheet;
            vm.cloneTicket = cloneTicket;
            vm.cancelTicket = cancelTicket;
            vm.addRelatedTicket = addRelatedTicket;
            vm.downloadPdf = downloadPdf;
            vm.addTicketBillingPref = addTicketBillingPref;
            vm.openMenu = openMenu;
            vm.downloadPaperworkPdf = downloadPaperworkPdf;
            vm.downloadTimesheetPdf = downloadTimesheetPdf;
            vm.claimsUtilService = claimsUtilService;
            vm.jobsClaims = jobsClaimsService;
            vm.isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
            vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
            vm.isCustomFormsEnabled = claimsUtilService.isCustomFormsEnabled();
            vm.showSmartScheduling = showSmartScheduling;
            vm.preSchedule = preSchedule;
            vm.disableCloneTicket = disableCloneTicket;
            vm.disableTimesheet = disableTimesheet;
            vm.disableAddRelatedTicket = disableAddRelatedTicket;
            vm.disabledTicketBillingPreference = disabledTicketBillingPreference;

            vm.goToFormsAndAttachment = function(){
                $state.go('app.formsattachments', { TicketId: vm.id, TicketNo : vm.ticketNo });
            };

            function disableAddRelatedTicket()
            {
                return vm.ticket.status[0].id == ticketStatus.PENDING_CLIENT_CONFIRMATION
                || vm.ticket.status[0].id == ticketStatus.PENDING_UPLOADS;
            }

            function disabledTicketBillingPreference()
            {
                return vm.ticket.status[0].id == ticketStatus.PENDING_CLIENT_CONFIRMATION
                || vm.ticket.status[0].id == ticketStatus.PENDING_UPLOADS;
            }

            function disableTimesheet()
            {
                // Ticket Types: Equip = 1, Sale = 2, FullService = 3,  PlanOnly = 4, Internal = 6
                return (vm.isLockedByPreSchedule && (vm.ticket.status[0].abbrev == 'AIP' || vm.ticket.status[0].abbrev == 'AID')) || ((vm.isLocked) && vm.ticketType != 6 && vm.ticketType != 3 && vm.ticketType != 7) || vm.ticketType == 1 || vm.ticketType == 4;
            }

            function disableCloneTicket()
            {
                return (vm.isLockedByPreSchedule)
            }

            function openEditTicket(id, ticketNo, isLocked, isLockedByPreSchedule, parentTicketNo) {
                (vm.onOpenEditTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        isLocked: isLocked,
                        isLockedByPreSchedule: isLockedByPreSchedule,
                        parentTicketNo: parentTicketNo
                    }
                });
            }

            function openResourceAllocation(id, ticketNo, parentTicketNo) {
                (vm.onOpenResourceAllocation || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        parentTicketNo: parentTicketNo
                    }
                });
            }

            function openTimesheet(id, isLocked, isLockedByPreSchedule, ticketNo) {
                (vm.onOpenTimesheet || angular.noop)({
                    value: {
                        id: id,
                        isLocked: isLocked,
                        isLockedByPreSchedule: isLockedByPreSchedule,
                        ticketNo: ticketNo
                    }
                });
            }

            function cloneTicket(id, ticketNo) {
                (vm.onCloneTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function cancelTicket(id, ticketNo) {
                (vm.onCancelTicket || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo,
                        ticketType: vm.ticketType
                    }
                });
            }

            function addRelatedTicket(e, id) {
                (vm.onAddRelatedTicket || angular.noop)({
                    value: {
                        id: id
                    }
                });
            }

            function downloadPdf(e, id) {
                (vm.onDownloadPdf || angular.noop)({
                    value: {
                        id: id
                    }
                });
            }

            function addTicketBillingPref(e, dt, id) {
                (vm.onTicketBillingPref || angular.noop)({
                    value: {
                        dt: dt,
                        id: id
                    }
                });
            }

            function downloadPaperworkPdf(e, id, ticketNo) {
                (vm.onDownloadPaperworkPdf || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function downloadTimesheetPdf(e, id, ticketNo) {
                (vm.onDownloadTimesheetPdf || angular.noop)({
                    value: {
                        id: id,
                        ticketNo: ticketNo
                    }
                });
            }

            function openMenu($mdOpenMenu, e) {
                $mdOpenMenu(e);
            }

            function preSchedule(e, id){
                (vm.onPreSchedule || angular.noop)({
                    value: {
                        id: id,
                        ticket: vm.ticket
                    }
                });
            }

            function showSmartScheduling(){
                return claimsUtilService.hasSmartSchedulingAccess() &&
                        !vm.ticket.IsLockedByPreSchedule &&
                        vm.ticketType != TICKET_TYPE_PLAN_ONLY &&
                        vm.ticket.allocatedResourceItems.some(x => !x.allocatedId);
            }



        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.related-ticket-billing-preferences',
      []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state('app.related-ticket-billing', {
        url: '/relatedTicket/billing/:Id/:Month/:Year',
        views: {
          'content@app': {
            templateUrl: 'app/main/jobs/relatedTicketBillingPreferences/related-ticket-billing.html',
            controller: 'RelatedTicketBillingController as vm'
          }
        } , data: {requireLogin : true}
        , title: 'Related Ticket Billing Preference'
        , titleBar: 'Related Ticket Billing Preference'
      });
    $translatePartialLoaderProvider.addPart('app/main/jobs/relatedTicketBillingPreferences');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.related-ticket-billing-preferences')
    .controller('SingleDayController', SingleDayController);

  /** @ngInject */
  function SingleDayController(classService, data_list, _, blockUI, utils, item, $mdDialog, billing_periods, relatedTicketBillingPreferencesApi) {
    var vm = this;
    vm.item = item;
    vm.billing_periods = billing_periods;
    vm.activity = null;
    vm.something_has_been_updated = false;
    vm.classService = classService;
    vm.header = utils.translate("RELATEDTICKETBILLINGPREFERENCES.HEADER");
    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      sort: false
    };

    vm.onCancel = onCancel;
    vm.changeActivity = changeActivity;
    vm.deleteItem = deleteItem;
    vm.update = update;
    vm.changeBilling = changeBilling;
    vm.updateSingle = updateSingle;

    function changeBilling(item){
      let billing =  _.find(billing_periods, {
        ItemId : item.ItemId
      });
      item['BillingPeriod'] = billing.Id;
      item['IsItemBillable'] = !billing.IsNotBillable;
      item['ItemBillingName'] = billing.Name;
    }

    function changeActivity(activity){
      activity = parseInt(activity);
      if(activity === 0){
        vm.items_copy = _.find(data_list, {Id : vm.item.Id});
        _.forEach(vm.items_copy.ResourceItems, function(item){
          if(item.BillingPeriod === 0){
            item.BillingPeriod = 1;
          }
          let billing =  _.find(billing_periods, {
            Id : item.BillingPeriod,
            IsNotBillable : !item.IsItemBillable
          });
          item['ItemId'] = billing.ItemId;
          item['BillingPeriod'] = billing.Id;
          item['ItemBillingName'] = billing.Name;
        });
        vm.header = utils.translate("RELATEDTICKETBILLINGPREFERENCES.OPTION-CHANGE-BILLING");
      }else if(activity === 1){
        vm.items_copy = copy(angular.copy(vm.item));
        vm.header = utils.translate("RELATEDTICKETBILLINGPREFERENCES.OPTION-CHANGE-QUANTITY");
      }else{
        vm.items_copy = copy(angular.copy(vm.item));
        vm.header = utils.translate("RELATEDTICKETBILLINGPREFERENCES.OPTION-DELETE");
      }
    }

    function copy(item){
      item.Items = _.forEach(item.Items, function(item){
        item['IsSaving'] = false;
      });
      return item;
    }

    function update(item){
      item.IsSaving = true;
      let payload = {
        TicketId : vm.item.Id,
        ItemId : item.ItemId,
        Quantity : item.ItemQuantity
      }
      relatedTicketBillingPreferencesApi
        .updateQty(payload)
        .then(function(){
          vm.something_has_been_updated = true;
          item.IsSaving = false;
        });
    }

    function updateSingle(){
      let blocker = blockUI.instances.get('blockUI');
      blocker.start({message : utils.translate("RELATEDTICKETBILLINGPREFERENCES.UPDATING")});
      relatedTicketBillingPreferencesApi.updateSingle(vm.items_copy.Id, vm.items_copy. ResourceItems).then(function(){
        blocker.stop();
        $mdDialog.hide(true);
      });
    }

    function onCancel(){
      if(vm.activity){
        $mdDialog.hide(vm.something_has_been_updated);
      } else{
        $mdDialog.hide();
      }
    }

    function deleteItem(item){
      let blocker = blockUI.instances.get('blockUI');
      blocker.start({message : utils.translate("RELATEDTICKETBILLINGPREFERENCES.DELETING")});
      let payload = {
        TicketId : vm.item.Id,
        ItemId : item.ItemId
      }
      relatedTicketBillingPreferencesApi
        .deleteItem(payload)
        .then(function(){
            _.forEach(vm.items_copy.Items, function(i, key){
              if(i.ItemId === item.ItemId){
                vm.items_copy.Items.splice(key, 1);
              }
            });
            vm.something_has_been_updated = true;
            blocker.stop();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.related-ticket-billing-preferences')
    .controller('MultiDayController', MultiDayController);

  /** @ngInject */
  function MultiDayController(utils, $mdDialog, current_date, weekService, periods, unique_items, classService, parent) {

    var vm = this;
    vm.model = {
      ItemIds : [],
      StartDate : null,
      EndDate : null,
      BillingPeriod : null
    }
    vm.utils = utils;
    vm.unique_items = unique_items;
    vm.billing_periods = angular.copy(periods);

    setLimits();

    vm.onCancel = onCancel;
    vm.getClass = getClass;
    vm.filterEndDate = filterEndDate;
    vm.filterStartDate = filterStartDate;
    vm.save =  save;

    function getClass(name){
      return classService.getOptionItemColor(name);
    }

    function save(){
      let model =  format(vm.model);
      $mdDialog.hide(model);
    }

    function format(model){
      return {
        TicketId : parent,
        ItemIds : model.ItemIds,
        StartDate : moment(model.StartDate).format('YYYY-MM-DD'),
        EndDate : moment(model.EndDate).format('YYYY-MM-DD'),
        BillingPeriod: model.BillingPeriod.Id,
        IsItemBillable: !model.BillingPeriod.IsNotBillable
      };
    }

    function filterEndDate(date){
      if(vm.model.StartDate){
        return moment(date).isAfter(moment(vm.model.StartDate))
      }else{
        return date;
      }
    }

    function filterStartDate(date){
      if(vm.model.EndDate){
        return moment(date).isBefore(moment(vm.model.EndDate))
      }else{
        return date;
      }
    }

    function onCancel(){
      $mdDialog.hide();
    }

    function setLimits(){
      let year = current_date.year();
      let month = current_date.month() + 1;
      vm.first_day = new Date(month + "/1/" + year);
      vm.last_day = new Date(month + "/" + weekService.lastday(year, current_date.month()) + "/" + year);
    }
  }
})();

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WeekHeaderComponent = function (_React$Component) {
  _inherits(WeekHeaderComponent, _React$Component);

  function WeekHeaderComponent() {
    _classCallCheck(this, WeekHeaderComponent);

    return _possibleConstructorReturn(this, (WeekHeaderComponent.__proto__ || Object.getPrototypeOf(WeekHeaderComponent)).call(this));
  }

  _createClass(WeekHeaderComponent, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "column layout-padding" },
        React.createElement(
          "div",
          { className: "md-body-2 layout-row layout-align-center-center" },
          this.props.ticketdate
        ),
        React.createElement("md-divider", null)
      );
    }
  }]);

  return WeekHeaderComponent;
}(React.Component);

WeekHeaderComponent.propTypes = {
  ticketdate: React.PropTypes.string
};
WeekHeaderComponent.defaultProps = {
  ticketdate: null
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TicketComponent = function (_React$Component) {
  _inherits(TicketComponent, _React$Component);

  function TicketComponent() {
    _classCallCheck(this, TicketComponent);

    var _this = _possibleConstructorReturn(this, (TicketComponent.__proto__ || Object.getPrototypeOf(TicketComponent)).call(this));

    _this.showdialog = _this.showdialog.bind(_this);
    return _this;
  }

  _createClass(TicketComponent, [{
    key: "showdialog",
    value: function showdialog(item) {
      this.props.showdialog(item);
    }
  }, {
    key: "render",
    value: function render() {
      var self = this;

      function createBox(item) {
        return React.createElement(
          "div",
          { className: "column layout-padding layout-align-center-center ticket-holder" },
          React.createElement(
            "div",
            { className: "layout-margin layout-column layout-align-center-center" },
            React.createElement(
              "div",
              { className: "list-card layout-column layout-align-center-none ticket_data ticket-item" },
              React.createElement(LabelComponent, { locked: item.IsLocked || item.IsLockedByPreSchedule }),
              React.createElement(TicketDetailComponent, { showdialog: self.showdialog, item: item })
            )
          )
        );
      }

      return React.createElement(
        "div",
        null,
        this.props.item.map(createBox)
      );
    }
  }]);

  return TicketComponent;
}(React.Component);

TicketComponent.propTypes = {
  item: React.PropTypes.object,
  showdialog: React.PropTypes.func
};
TicketComponent.defaultProps = {
  item: null,
  showdialog: function showdialog() {}
};
/**
 * Created by Ben Rei on 8/19/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.jobs.components.resource.droppable',[])
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.components.resource.droppable')
    .controller('droppableResourceController', droppableResourceController);

  /** @ngInject */
  function droppableResourceController (
    $scope,
    resourceComponentService
  ) {
    var vm = this;
    vm.dropped = dropped;

    function dropped (data) {
      $scope.$apply(function () {
        resourceComponentService.dropped(data, null, vm.ngService.jobModel.Resource, vm.ngService);
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.jobs.components.resource.droppable')
    .directive('droppableResourceComponent', droppableResourceComponent);

  /** @ngInject */
  function droppableResourceComponent() {

    //
    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/manage/components/ResourceComponent/DroppableComponent/Droppable-Resource.html'
      , scope: {
        ngService: '=',
        name: '@'
      }
      , bindToController: true
      , controller: 'droppableResourceController as droppableVm'
    };

    return directive;
  }
})();

/**
 * Created by Ben Rei on 8/19/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.jobs.components.orderedBy', [])
})();

/**
 * Created by Ben Rei on 9/2/2016.
 */
{
    angular
        .module('app.jobs.components.orderedBy')
        .controller('projectDropDownPopUpComponentController', projectDropDownPopUpComponentController);

    /** @ngInject */
    function projectDropDownPopUpComponentController(_, $mdDialog, projectApi, $q, $timeout, blockUI, claimsUtilService) {
        var vm = this;
        var previousBranchSelected = null;
        vm.showDialog = showDialog;
        vm.querySearch = querySearch;
        vm.thereIsAClient = thereIsAClient;

        function querySearch(query) {
            var deferred = $q.defer();
            if ((vm.ngService.jobModel.Branch && vm.ngService.jobModel.Client) && previousBranchSelected != vm.ngService.jobModel.Branch.Id && vm.ngService.projectLookup.length <= 0) {
                vm.ngService.getProjectByBranchAndCompanyLookup(vm.ngService.jobModel.Branch.Id, vm.ngService.jobModel.Client.Id)
                    .then(function () {
                        var results = query ? vm.ngService.projectLookup.filter(createFilterFor(query)) : vm.ngService.projectLookup;
                        deferred.resolve(results);
                        previousBranchSelected = angular.copy(vm.ngService.jobModel.Branch.Id);
                    })
                    .catch(function () {
                        deferred.reject();
                    });
            }
            else {
                var results = query ? vm.ngService.projectLookup.filter(createFilterFor(query)) : vm.ngService.projectLookup;
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 10, false);
            }
            return deferred.promise;


            // var results = query ? vm.ngService.projectLookup.filter( createFilterFor(query) ) : vm.ngService.projectLookup;
            // //var results = query ? self.states.filter( createFilterFor(query) ) : self.states;
            // var deferred = $q.defer();
            // $timeout(function () { deferred.resolve( results ); }, Math.random() * 100, false);
            // return deferred.promise;
            //return results;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(item) {
                return (angular.lowercase(item.Name).indexOf(lowercaseQuery) === 0);
            };
        }

        function thereIsAClient(client) {
            return _.isNil(client) ? false : true;
        }

        function showDialog(arg) {
            var locals = vm.ngService;
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/jobs/manage/components/OrderedByComponent/ProjectDropdownPopupComponent/project-dropdown-popup-add-dialog.html',
                controller: 'addProjectDialogController as addProjectDialogVm',
                locals: locals,
                searchText: vm.searchText
            }).then(function (result) {
                if (result) {
                    saveNewProject(result);
                }

            }, function () {
                // cancel
            });
        }

        function saveNewProject(payload) {
            payload['Companies'] = [];
            payload['Companies'].push(vm.client);
            projectApi.postProject(payload)
                .then(function (resp) {
                    if (_.find(resp.data.Branches, function (o) {
                        return o.id == vm.ngService.jobModel.Branch.Id
                    })) {
                        previousBranchSelected = null;
                    }

                    blockUI.start('Loading Projects');
                    if (vm.ngService.jobModel.Client) {
                        vm.ngService.getProjectByBranchAndCompanyLookup(vm.ngService.jobModel.Branch.Id, vm.ngService.jobModel.Client.Id)
                            .then(function () {
                                blockUI.message('Loading Client\'s Contacts');
                                vm.ngService.getContactClientByBranchAndCompanyLookup(vm.ngService.jobModel.Client.Id, vm.ngService.jobModel.Branch.Id)
                                    .then(function () {
                                        blockUI.message('Loading Previous Job Location');
                                        vm.ngService.getLatestJobLocations(vm.ngService.jobModel.Client.Id)
                                            .then(function () {
                                                blockUI.stop();
                                            })
                                            .catch(function () {
                                                blockUI.stop();
                                            });
                                    })
                                    .catch(function () {
                                        blockUI.stop();
                                    });
                            })
                            .catch(function () {
                                blockUI.stop();
                            });
                    }
                });
        }

        vm.canCreateProject = function() {
            return claimsUtilService.checkAccessByRole('CreateProjects');
        }

        vm.isTicketLockedByPreSchedule = function isTicketLockedByPreSchedule() {
            return vm.ngService.jobModel.IsLockedByPreSchedule && claimsUtilService.isSmartSchedulingEnabled();
        };
    }
}

/**
 * Created by Ben Rei on 9/2/2016.
 */
{
    angular
        .module('app.jobs.components.orderedBy')
        .directive('projectDropDownPopUpComponent', projectDropDownPopUpComponent);

    /** @ngInject */
    function projectDropDownPopUpComponent(branchApi, exceptionService) {
        //
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/manage/components/OrderedByComponent/ProjectDropdownPopupComponent/project-dropdown-popup.html',
            //templateUrl: 'app/main/jobs/create/orderedByComponent/ordered-by.html',
            scope: {
                ngModel: '=',
                ngService: '=',
                client: '='
            },
            controller: 'projectDropDownPopUpComponentController as projectDropDownPopUpComponentvm',
            bindToController: true,
            replace: true
        };

        return directive;

    }
}

/**
 * Created by Ben Rei on 9/2/2016.
 */
{
  angular
    .module('app.jobs.components.orderedBy')
    .controller('addProjectDialogController', addProjectDialogController);

  /** @ngInject */
  function addProjectDialogController($mdDialog,locals,searchText){
    var vm =this;
    vm.branches = locals.branchLookup;
    vm.selectedBranches = [{Id :locals.jobModel.Branch.Id}];
    vm.newProject = searchText;
    vm.onCancel = closeDialog;
    vm.onAdd = onAdd;
    //"ng-selected="addProjectDialogVm.isSelected(branch)"
    //vm.isSelected = isSelected;

    function onAdd() {
      angular.forEach(vm.selectedBranches, function (value) {
        value.id = value.Id;
      });
      $mdDialog.hide({Name: vm.newProject, Branches:vm.selectedBranches});
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    // var defaultSelectedBranches = [{BranchId : locals.jobModel.Branch}];
    //
    // function isSelected(branch) {
    //   return defaultSelectedBranches.filter(function(_branch) {
    //       return angular.equals(branch.BranchId, _branch.BranchId);
    //     }).length > 0;
    // }

  }
}

/**
 * Created by Ben Rei on 9/2/2016.
 */
{
  angular
    .module('app.jobs.components.orderedBy')
    .controller('divisionDropdownComponentController', divisionDropdownComponentController);

  /** @ngInject */
  function divisionDropdownComponentController(orderByComponentService,$mdDialog,companyApi,$q,$timeout,$scope, blockUI, claimsUtilService)
  {
    var vm =this;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;
    vm.querySearch = querySearch;
    vm.isTicketLockedByPreSchedule = isTicketLockedByPreSchedule;

    function querySearch(query) {
      var deferred = $q.defer();
      var results = query ? vm.ngService.divisionLookup.filter( createFilterFor(query) ) : vm.ngService.divisionLookup;
      $timeout(function () {
        deferred.resolve(results);
      }, Math.random() * 10, false);
      return deferred.promise;
    }

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(item) {
        return (angular.lowercase(item.Name).indexOf(lowercaseQuery) === 0);
      };
    }

    function searchTextChange(client) {
      if(!vm.ngService.isEditMode){
        clearRelatedField();
      }
    }

    function selectedItemChange(client) {
      if(!vm.ngService.isInit){
        //if(!vm.ngService.isEditMode){
          clearRelatedField();
          blockUI.start('Loading Clients');
          $timeout(function() {
            var _client = null;
            if(client){
              if(client.id){
                _client = client.id;
              }
              else{
                _client = client.Id;
              }
            }
            else{
              _client = ""
            }

            if(!vm.ngService.isSaving){
              vm.ngService.getCompanyByBranchLookup({BranchId:  vm.ngService.jobModel.Branch.Id, DivisionId:  _client})
              .then(function () {
                blockUI.stop();
              });
            }
            else{
               blockUI.stop();
            }
          });
        //}
      }
    }

    function clearRelatedField(){
      vm.ngService.jobModel.PersonOrdering = null;
      vm.ngService.jobModel.Client = null;
      vm.ngService.jobModel.Project = null;
      vm.ngService.clientLookup = [];
    }

    function isTicketLockedByPreSchedule()
    {
      return vm.ngService.jobModel.IsLockedByPreSchedule && claimsUtilService.isSmartSchedulingEnabled();
    }
  }
}

/**
 * Created by Ben Rei on 9/2/2016.
 */
{
  angular
    .module('app.jobs.components.orderedBy')
    .directive('divisionDropDownComponent',divisionDropDownComponent);

  /** @ngInject */
  function divisionDropDownComponent(branchApi,exceptionService){
    //
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/jobs/manage/components/OrderedByComponent/DivisionDropdownComponent/division-dropdown.html',
      //templateUrl: 'app/main/jobs/create/orderedByComponent/ordered-by.html',
      scope: {
        ngModel : '=',
        ngService: '='
      },
      controller: 'divisionDropdownComponentController as divisionDropdownComponentvm',
      bindToController: true,
      replace: true
    };

    return directive;

  }
}

{
    angular
        .module('app.jobs.components.orderedBy')
        .controller('companyDropDownPopUpComponentController', companyDropDownPopUpComponentController);

    /** @ngInject */
    function companyDropDownPopUpComponentController(_, utils, $mdDialog, companyApi, $q, $timeout, blockUI, companyClaimsService, claimsUtilService) {
        var vm = this;
        var previousBranchSelected = null;
        var previousClientSelected = null;
        var previousClientLookup = null;
        var previousDivisionSelected = null;
        vm.reload = false;

        vm.showDialog = showDialog;
        vm.openMenu = openMenu;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.minlength = 1;
        vm.companyClaims = companyClaimsService;

        vm.simulateQuery = false;
        vm.isDisabled = false;

        vm.querySearch = querySearch;
        vm.reloadAll = reloadAll;
        vm.searchText = null;

        function reloadAll() {
            vm.searchText = "";
            vm.minlength = 0;
            vm.reload = true;
        }

        function querySearch(query) {
            var divisionId = null;
            var deferred = $q.defer();
            if (vm.reload) {
                vm.ngService.getCompanyByBranchLookup({
                        BranchId: vm.ngService.jobModel.Branch.Id,
                        DivisionId: null
                    })
                    .then(function () {
                        if (vm.ngService.jobModel.Branch && previousBranchSelected != vm.ngService.jobModel.Branch.Id) {
                            if (vm.ngService.jobModel.Division) {
                                divisionId = vm.ngService.jobModel.Division.id;
                            }
                            if (!vm.reload) {
                                vm.ngService.getCompanyByBranchLookup({
                                        BranchId: vm.ngService.jobModel.Branch.Id,
                                        DivisionId: divisionId
                                    })
                                    .then(function () {
                                        var results = query ? vm.ngService.companyLookup.filter(createFilterFor(query)) : vm.ngService.companyLookup;
                                        deferred.resolve(results);
                                        vm.minlength = 1;
                                        vm.reload = false;
                                        previousBranchSelected = angular.copy(vm.ngService.jobModel.Branch.Id);
                                    })
                                    .catch(function () {
                                        deferred.reject();
                                    });
                            } else {
                                var results = query ? vm.ngService.companyLookup.filter(createFilterFor(query)) : vm.ngService.companyLookup;
                                deferred.resolve(results);
                                vm.minlength = 1;
                                vm.reload = false;
                            }
                        } else {
                            var results = query ? vm.ngService.companyLookup.filter(createFilterFor(query)) : vm.ngService.companyLookup;
                            deferred.resolve(results);
                            vm.minlength = 1;
                            vm.reload = false;
                        }
                    });
            } else {
                if (vm.ngService.jobModel.Division) {
                    divisionId = vm.ngService.jobModel.Division.id;
                }
                if (vm.ngService.jobModel.Branch &&
                    vm.ngService.companyLookup.length <= 0 &&
                    (previousBranchSelected != vm.ngService.jobModel.Branch.Id || previousDivisionSelected != divisionId)) {
                    previousDivisionSelected = angular.copy(divisionId);
                    if (!vm.reload) {
                        vm.ngService.getCompanyByBranchLookup({
                            BranchId: vm.ngService.jobModel.Branch.Id,
                            DivisionId: divisionId
                        }).then(function () {
                            var results = query ? vm.ngService.companyLookup.filter(createFilterFor(query)) : vm.ngService.companyLookup;
                            deferred.resolve(results);
                            vm.reload = false;
                            previousBranchSelected = angular.copy(vm.ngService.jobModel.Branch.Id);
                        }).catch(function () {
                            deferred.reject();
                        });
                    } else {
                        var results = query ? vm.ngService.companyLookup.filter(createFilterFor(query)) : vm.ngService.companyLookup;
                        deferred.resolve(results);
                        vm.minlength = 1;
                        vm.reload = false;
                    }
                } else {
                    var results = query ? vm.ngService.companyLookup.filter(createFilterFor(query)) : vm.ngService.companyLookup;
                    deferred.resolve(results);
                    vm.reload = false;
                }
            }
            return deferred.promise;
        }

        vm.isTicketLockedByPreSchedule = function isTicketLockedByPreSchedule() {
            return vm.ngService.jobModel.IsLockedByPreSchedule && claimsUtilService.isSmartSchedulingEnabled();
        };

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(item) {
                return (angular.lowercase(item.Name).indexOf(lowercaseQuery) === 0);
            };
        }

        function searchTextChange() {
            if (!vm.ngService.isInit) {
                if (vm.ngService.clientLookup.length > 0) {
                    previousClientLookup = angular.copy(vm.ngService.clientLookup);
                }
                vm.ngService.clientLookup = [];
                vm.ngService.jobModel.PersonOrdering = null;
                vm.ngService.jobModel.SiteContact = null;
            }
        }

        function showClientCreditStatusError() {
            $mdDialog.show(
                $mdDialog.alert()
                .title(utils.translate('MANAGE.ERROR'))
                .textContent(utils.translate('MANAGE.ERRORTEXT'))
                .ariaLabel(utils.translate('MANAGE.ERRORTEXT'))
                .ok(utils.translate('MANAGE.ERRORBUTTONTEXT'))
            );
        }

        function selectedItemChange(client) {
            if (!vm.ngService.isInit && client) {

                if (claimsUtilService.isBillingEnabled())
                {
                    blockUI.start(utils.translate('MANAGE.CREDITSTATUSCHECK'));
                    companyApi.getCompany(client.Id)
                        .then(function (resp) {
                            blockUI.stop();
                            if (resp.data.CreditType == 0) {
                                showClientCreditStatusError();
                                vm.ngService.jobModel.Client = null;
                                client = null;
                            }
                        })
                        .catch(function () {
                            blockUI.stop();
                        });
                }

                if (JSON.stringify(client) == JSON.stringify(previousClientSelected)) {
                    vm.ngService.clientLookup = previousClientLookup;
                }

                if (JSON.stringify(client) != JSON.stringify(previousClientSelected) && client) {
                    previousClientSelected = angular.copy(client);
                    previousClientLookup = angular.copy(vm.ngService.clientLookup);

                    $timeout(function () {
                        if (vm.ngService.jobModel.Client) {
                            blockUI.start(utils.translate('MANAGE.LOADINGPROJECTS'));
                            vm.ngService.jobModel.isThisAQuote = vm.ngService.jobModel.Client.IsProspect;
                            vm.ngService.getProjectByBranchAndCompanyLookup(vm.ngService.jobModel.Branch.Id, vm.ngService.jobModel.Client.Id)
                                .then(function () {
                                    blockUI.message(utils.translate('MANAGE.LOADINGCLIENTSCONTACTS'));
                                    vm.ngService.getContactClientByBranchAndCompanyLookup(vm.ngService.jobModel.Client.Id, vm.ngService.jobModel.Branch.Id)
                                        .then(function () {
                                            blockUI.message(utils.translate('MANAGE.LOADINGPREVIOUSJOBLOCATIONS'));
                                            vm.ngService.getLatestJobLocations(vm.ngService.jobModel.Client.Id)
                                                .then(function () {
                                                    blockUI.stop();
                                                })
                                                .catch(function () {
                                                    blockUI.stop();
                                                });
                                        })
                                        .catch(function () {
                                            blockUI.stop();
                                        });
                                })
                                .catch(function () {
                                    blockUI.stop();
                                });

                            //Check if client contains the existing project (If there's any)
                            //Fix for BUG #7565
                            if (!_.isNil(vm.ngService.jobModel.Project)) {
                                vm.ngService.checkProject(vm.ngService.jobModel.Client.Id, vm.ngService.jobModel.Project.Id).then(function (resp) {
                                    vm.ngService.jobModel.Project = null;
                                });
                            }
                        }
                    }, 250);
                }

                //Fix for #7572 [FE] Create/Edit Ticket - Project field value was not removed when Client was deselected
                $timeout(function () {
                    if (_.isNil(client)) {
                        vm.ngService.jobModel.Project = null;
                    }
                })
                //Fix for #7572 [FE] Create/Edit Ticket - Project field value was not removed when Client was deselected
            }
        }

        function openMenu($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };

        function showDialog(arg) {
            var locals = {
                service: vm.ngService,
                id: arg
            };

            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/jobs/manage/components/OrderedByComponent/CompanyDropdownPopupComponent/company-dropdown-popup-manage-dialog.html',
                controller: 'manageCompanyDialogController as manageCompanyDialogVm',
                locals: locals
            }).then(function (result) {
                if (result) {
                    saveNewCompany(result);
                }
            }, function () {});
        }

        function saveNewCompany(payload) {
            companyApi.postCompanyMinified(payload)
                .then(function (resp) {
                    if (_.find(resp.data.Branches, function (o) {
                            return o.id == vm.ngService.jobModel.Branch
                        })) {
                        angular.forEach(resp.data.Branches, function (value) {
                            value.Id = value.id;
                        });
                        var newCompanyCreated = {
                            Name: resp.data.Name,
                            Id: resp.data.id
                        };
                        vm.ngService.companyLookup.push(newCompanyCreated);
                    }
                    vm.ngService.rememberThis('LastCompanyList', vm.ngService.companyLookup);
                });
        }
    }
}

/**
 * Created by Ben Rei on 9/2/2016.
 */
{
  angular
    .module('app.jobs.components.orderedBy')
    .directive('companyDropDownPopUpComponent',companyDropDownPopUpComponent);

  /** @ngInject */
  function companyDropDownPopUpComponent(branchApi,exceptionService){
    //
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/jobs/manage/components/OrderedByComponent/CompanyDropdownPopupComponent/company-dropdown-popup.html',
      //templateUrl: 'app/main/jobs/create/orderedByComponent/ordered-by.html',
      scope: {
        ngModel : '=',
        ngService : '=',
        selfService : '='
      },
      controller: 'companyDropDownPopUpComponentController as companyDropDownPopUpComponentvm',
      bindToController: true,
      replace: true
    };

    return directive;

  }
}

{
    angular
        .module('app.jobs.components.orderedBy')
        .controller('manageCompanyDialogController', manageCompanyDialogController);

    /** @ngInject */
    function manageCompanyDialogController(
        locals,
        $mdDialog,
        $translate,
        companyApi,
    ) {
        var vm = this;

        vm.title = 'New Company';
        vm.saveButtonText = 'Save';
        vm.branches = locals.service.branchLookup;
        vm.creditTypes = [];

        vm.selectedBranches = [];
        vm.selectedCreditType = null;
        vm.companyName = "";

        vm.onAdd = onAdd;
        vm.onCancel = closeDialog;

        init();

        function init() {
            companyApi.getCreditTypes()
                .then(function(resp) {
                    vm.creditTypes = resp.data
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            if (locals.service.jobModel.Branch) {
                vm.selectedBranches = [{
                    Id: locals.service.jobModel.Branch.Id
                }];
            }

            $translate(['MANAGE.COMPANYPOPUPTITLENEW', 'MANAGE.COMPANYPOPUPSAVETEXTNEW']).then(function(translations) {
                vm.title = translations['MANAGE.COMPANYPOPUPTITLENEW'];
                vm.saveButtonText = translations['MANAGE.COMPANYPOPUPSAVETEXTNEW'];
            });
        }

        function onAdd() {
            angular.forEach(vm.selectedBranches, function(value) {
                value.id = value.Id;
            });

            $mdDialog.hide({
                Name: vm.companyName,
                Branches: vm.selectedBranches,
                CreditType: vm.selectedCreditType.Id,
                IsActive: true
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }
    }
}

(function () {
    'use strict';

    angular
        .module('app.jobs.allocate')
        .controller('ResourceLikeErrorController', ResourceLikeErrorController);

    /** @ngInject */
    function ResourceLikeErrorController(errorlist, $mdDialog, TimeLibrary) {
        var vm = this;
        vm.errorlist = errorlist;
        vm.close = close;
        vm.isObject = isObject;
        vm.formatMessage = formatMessage;

        function close() {
            $mdDialog.hide();
        }

        function isObject(obj) {
            return _.isObject(obj);
        }

        function formatMessage(message){
            return TimeLibrary.covertTimesInString(message);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.allocate')
        .controller('ResourceLikeController', ResourceLikeController);

    /** @ngInject */
    function ResourceLikeController($mdDialog, TicketData, resourceLikeService, Droppables, DialogService, _, TicketNumber, TicketId, FutureResourceLike, utils) {

        var vm = this;
        vm.droppables = null;
        vm.pasttickets = [];
        vm.futuretickets = [];
        vm.futuretickets = null;
        vm.checkedItems = 0;
        vm.resource_select_all = false;
        vm.utils = utils;

        vm.close = close;
        vm.toggleData = toggleData;
        vm.sanitizeData = sanitizeData;
        vm.showTicketDetails = showTicketDetails;
        vm.save = save;
        vm.toggleFutureData = toggleFutureData;
        vm.preSelect = preSelect;

        function close() {
            $mdDialog.hide();
        }

        function clearSelections() {
            //Clear checked items
            angular.forEach(vm.pasttickets, function (ticket) {
                ticket.Items = isSelectToFalse(ticket.Items);
            });
        }

        function isSelectToFalse(items) {
            //Set item's Selected to 'false'
            angular.forEach(items, function (item) {
                item.Selected = false;
            });
            return items;
        }

        function preSelect() {
            //Auto-select
            //Pre-selects items from the dialog to satisfy the allocation requirements
            clearSelections();
            if (vm.resource_select_all) {
                angular.forEach(vm.available_droppables, function (available_item) {
                    available_item['HasAssignment'] = false;
                    angular.forEach(vm.pasttickets, function (ticket) {
                        angular.forEach(ticket.Items, function (item) {
                            if (preSelectCondition(available_item, item)) {
                                item.Selected = true;
                                available_item['HasAssignment'] = true;
                            }
                        });
                    });
                });
            }
            vm.checkedItems = countChecks(vm.pasttickets);
        }

        function preSelectCondition(available_item, item){
            //Condition to be satisfied for an item to be auto-selected
            return !available_item.HasAssignment && item.ItemId == available_item.ItemId && !item.Selected && item.AllocatedItemName != null;
        }

        function activate() {
            //Loads activation variables(current UI Requirements, past tickets, future tickets)
            vm.droppables = Droppables;
            vm.available_droppables = _.filter(vm.droppables, {AllocatedId: null}); // item without allocation
            vm.pasttickets = resourceLikeService.formatResourceLikeData(TicketData, vm.droppables);
            vm.futuretickets = formatFutureTickets(FutureResourceLike);
        }

        function formatFutureTicketsJSON(Id, TicketNumber, StartDate, JobFullAddress, Selected, Parent, Order) {
            //Future data JSON object pattern
            return {
                Id: Id,
                TicketNumber: TicketNumber,
                StartDate: StartDate,
                JobFullAddress: JobFullAddress,
                Selected: Selected,
                Parent: Parent,
                Order: Order
            }
        }

        function formatFutureTickets(tickets) {
            let temp_tickets = _.map(tickets, function (ticket) {
                return formatFutureTicketsJSON(ticket.Id, ticket.TicketNumber, ticket.StartDate, ticket.JobFullAddress, false, false, 2);
            });
            temp_tickets.push(formatFutureTicketsJSON(null, null, null, null, false, true, 1));
            return temp_tickets;
        }

        function toggleFutureData(ticket) {
            ticket.Parent ? toggleFutureParentTicket(ticket) : toggleNonFutureParentTicket(ticket);
        }

        function toggleFutureParentTicket(ticket) {
            angular.forEach(vm.futuretickets, function (ticket2) {
                ticket2.Selected = ticket.Selected ? true : false;
            });
        }

        function toggleNonFutureParentTicket(ticket) {
            let parent = _.find(vm.futuretickets, {Parent: true});
            if (parent.Selected) {
                angular.forEach(vm.futuretickets, function (ticket2) {
                    if (ticket.Parent) {
                        ticket2.Selected = false;
                    }
                });
            }
        }

        function toggleData(data) {
            vm.resource_select_all = false;
            let req_counter = _.filter(vm.droppables, {ItemName: data.ItemName, AllocatedId: null}).length;
            let req_item_name = data.ItemName;
            let Id = data.Id;
            let checked_counter = 0;
            let unselected_counter = 0;

            //Checked Class Counter
            angular.forEach(vm.pasttickets, function (item) {
                angular.forEach(item.Items, function (line) {
                    if ((line.ItemName == req_item_name) && (line.Selected)) {
                        checked_counter++;
                    }
                });
            });

            if (checked_counter > req_counter) {
                if (req_counter == 0) {
                    data.Selected = false;
                } else {
                    angular.forEach(vm.pasttickets, function (item) {
                        angular.forEach(item.Items, function (line) {
                            if ((line.ItemName == req_item_name) && (line.Id != Id) && (line.Selected) && (unselected_counter == 0)) {
                                line.Selected = false;
                                unselected_counter++;
                            }
                        });
                    });
                }
            }
            vm.checkedItems = countChecks(vm.pasttickets);
        }

        function countChecks(tickets) {
            //Return number of items that have been checked by he user
            let counter = 0;
            _.forEach(tickets, function (item) {
                counter += _.filter(item.Items, {Selected: true}).length;
            });
            return counter;
        }

        function assignItems(droppables, pasttickets) {
            //function to format data for saving
            _.forEach(droppables, function (droppable) {
                let counter = 0;
                _.forEach(pasttickets, function (pastticket) {
                    _.forEach(pastticket.Items, function (item) {
                        if ((item.ItemName == droppable.ItemName) && item.Selected && !item.Assigned && (counter == 0)) {
                            droppable = assignItemProps(droppable, item);
                            item.Assigned = true;
                            counter++;
                        }
                    });
                });
            });
            return formatData(sanitizeData(droppables), sanitizeFutureData(vm.futuretickets));
        }

        function assignItemProps(droppable, item) {
            droppable.AllocatedId = item.AllocatedId;
            droppable.AllocatedItemName = item.AllocatedItemName;
            droppable.AllocatedCode = item.AllocatedCode;
            droppable.AssignedOperatorId = item.OperatorId;
            droppable.AssignedOperatorName = item.OperatorName;
            return droppable;
        }

        function sanitizeFutureData(data) {
            let cleaned_data = _.filter(data, {Selected: true, Parent: false});
            return _.map(cleaned_data, 'Id');
        }

        function formatData(data, sanitizedFutureData) {
            return {
                TicketId: TicketId,
                TicketNumber: TicketNumber,
                SuggestedResources: data,
                FutureTicketIds: sanitizedFutureData
            };
        }

        function save() {
            let data = assignItems(_.filter(vm.droppables, {AllocatedId: null}), vm.pasttickets);
            $mdDialog.hide(data);
        }

        function sanitizeData(data) {
            return _.reject(data, {AllocatedId: null});
        }

        function showTicketDetails(Id) {
            DialogService.openTicketDetailDialog(Id, false, true);
        }

        activate();
    }
})();

(function () {
    'use strict';

    angular.module('app.jobs.allocate')
        .factory('resourceLikeService', jobService);

    /** @ngInject */
    function jobService(_) {
        var service = {
            formatResourceLikeData : formatData
        };

        return service;

        //Refactoring formatResourceLikeData
        function formatData(data, droppables) {
            angular.forEach(data, function (item) {
                item.Items = validateAndFormatEachLine(item.ResourceLikeAllocatedResources, droppables);
            });

            //Eliminate Invalid lines and Tickets
            data = _.filter(data, function(item){
                return validateTicketContent(item.Items);
            });

            return data;
        }

        function validateAndFormatEachLine(lines, droppables){
            //Adds and Sets new properties Selected and Assigned
            lines = eliminateNonRelatedItems(lines, droppables);
            angular.forEach(lines, function (line) {
                line['Selected'] = false;
                line['Assigned'] = false;
                line['Counter'] = assignItemNumber(lines, line);
            });
            return lines;
        }

        function assignItemNumber(lines, line){
            //Assigns a counter to be displayed
            //Example : Ute with AB #1, Ute with AB #2
            let same_items = _.filter(lines, {ItemName: line.ItemName});
            if(same_items.length > 0){
                return _.findIndex(same_items, function(i) { return i.AllocatedId == line.AllocatedId }) + 1;
            }
        }

        function eliminateNonRelatedItems(lines, droppables){
            //Eliminate non related items
            //Eliminate related lines without allocated resource (people or equipment)
            return _.filter(lines, function(line){
                return hideNotRelatedItem(line, droppables) && checkIfOperatorExists(line, droppables);
            });
        }

        function hideNotRelatedItem(item, droppables) {
            //function eliminate Non Related Item
            return _.filter(droppables, {ItemName: item.ItemName}).length == 0 ? false : true;
        }

        function checkIfOperatorExists(line, droppables) {
            //function to eliminate related lines without allocated resource (people or equipment)
            //Remove Resource Like Items that already exist/allocated in  the current ticket
            return !_.isNil(line.AllocatedId) && !_.find(droppables, {AllocatedId : line.AllocatedId});
        }

        function validateTicketContent(items) {
            let item_counter = items.length;
            let null_counter = _.filter(items, function (item) {
                return item.AllocatedItemName === null;
            });
            return (item_counter === null_counter.length) ? false : true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.allocate.droppable')
        .controller('timeDialogController', timeDialogController);

    function timeDialogController(
        $mdDialog,
        line,
        resourceAllocateService,
        timeSheetService,
        msgboxService,
        allocationApi,
        TimeLibrary,
        identityService,
        utils
    ) {
        const errorDialogTitle = utils.translate('RESOURCEALLOCATION.CHANGE_SHIFT_TIME_ERROR');
        const okayButtonText = utils.translate('RESOURCEALLOCATION.OKAY')

        var vm = this;
        vm.close = close;
        vm.save = save;
        vm.isSaving = false;

        activate();

        function activate() {
            vm.service = resourceAllocateService;
            vm.line = line;
        }

        function close() {
            abortSaveTime();
            $mdDialog.hide();
        }

        async function save() {
            vm.isSaving = true;

            var isValidInput = isTimeValid(vm.line.StartTime) && isTimeValid(vm.line.FinishTime);

            if (!isValidInput) {
                msgboxService.alert(errorDialogTitle, "Please provide valid shift times.", okayButtonText);
                abortSaveTime();
                return;
            }

            const hasSubmittedTimesheets = await timeSheetService.checkIfJobHasTimesheet(vm.line.TicketId);

            if (hasSubmittedTimesheets == true) {
                close();
                msgboxService.alert(
                    errorDialogTitle,
                    "A submitted timesheet already exists for this job. The date or shift times will not be updated.",
                    okayButtonText);
                return;
            }

            saveTime();
        }

        function isTimeValid(time) {
            return !_.isNil(time) && time !== "" && time !== '';
        }

        function saveTime() {
            //Saving of shift time(PEOPLE Section)
            allocationApi.saveTimes({
                Id: vm.line.Id,
                StartTime: TimeLibrary.convertToServerTime(vm.line.StartTime),
                FinishTime: TimeLibrary.convertToServerTime(vm.line.FinishTime),
                TokenId: identityService.getToken(),
                TicketId: vm.line.TicketId,
                ItemId: vm.line.ItemId,
            }).then(function(resp) {
                let allocationIssues = resp.data.AllocationIssues;

                if (allocationIssues && allocationIssues.length > 0) {
                    let resourceName = "<strong>" + time_line.AllocatedItemName + "</strong>";
                    let issues = allocationIssues.map(x => `<li>${x.Message}</li>`).join("");
                    let message = resourceName + issues;

                    close();
                    msgboxService.alert(errorDialogTitle, message, okayButtonText);
                    return;
                }

                setNewLineItemTimes();
                vm.isSaving = true;
                close();
            }).catch(function() {
                close();
                msgboxService
                    .show(utils.translate('RESOURCEALLOCATION.SHIFT_TIME_ERROR'))
                    .then(function() {
                        vm.service.reloader = true;
                        vm.service.fetchTicket2();
                    });
            });
        }

        function abortSaveTime() {
            vm.line.StartTime = vm.line['PreviousStartTime'];
            vm.line.FinishTime = vm.line['PreviousFinishTime'];
            vm.isSaving = false;
        }

        function setNewLineItemTimes() {
            vm.line['PreviousStartTime'] = angular.copy(vm.line.StartTime);
            vm.line['PreviousFinishTime'] = angular.copy(vm.line.FinishTime);
            vm.line['TimesAreValid'] = vm.service.checkTimeIfValid(vm.line);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.allocate.droppable')
        .controller('shiftTagsDialogController', shiftTagsDialogController)
        .directive('isTagActive', isTagActiveDirective);

    function shiftTagsDialogController(
        $mdDialog,
        locals
    ) {
        var vm = this;

        vm.getTicketTags = getTicketTags;
        vm.onSelectTag = onSelectTag;
        vm.addTag = addTag;
        vm.removeTag = removeTag;
        vm.save = save;
        vm.close = close;
        vm.selectedTags = [];
        vm.onSelectTag = onSelectTag;
        vm.querySearch = querySearch;
        vm.searchText = "";
        vm.selectedItem = null;
        vm.isTagActive = isTagActive
        vm.selectedTag = null;
        vm.searchText = null;

        activate();

        function activate() {
            vm.selectedTags = angular.copy(locals.currentTags);
        }

        function getTicketTags() {
            var availableTags = locals.availableTags.filter(x => {
                return !vm.selectedTags.find((selectedTag) => x.Id === selectedTag.Id)
            });

            return alasql("SELECT * FROM ? WHERE Name LIKE '%" + (vm.searchText || '') + "%' LIMIT 50", [availableTags]);
            }

        function addTag() {
            if (!_.isNil(vm.selectedTag)) {

                if (vm.selectedTags.indexOf(vm.selectedTag) != -1) {
                    return;
        }

                vm.selectedTags.push(vm.selectedTag);
                vm.searchText = '';
            }
        }

        function removeTag(removedTag) {
            vm.selectedTags = _.filter(vm.selectedTags, 
                (tag) => tag.Id !== removedTag.Id);
        }

        function onSelectTag(tag) {
            if (vm.selectedTags.indexOf(tag) != -1) {
                return;
            }

            vm.selectedTags.push(tag);
        }

        function save() {
            var noChangesInTags  = (vm.selectedTags.length == locals.currentTags.length) && locals.currentTags.every(x =>
                vm.selectedTags.some(y => y.Id === x.Id)
            )

            var shift = {
                selectedTags : vm.selectedTags,
                noChangesInTags : noChangesInTags
        }

            $mdDialog.hide(shift);
    }

        function close() {
            $mdDialog.hide();
        } 

        function querySearch(query) {
            var availableTags = locals.availableTags.filter(x => {
                return !vm.selectedTags.find((selectedTag) => x.Id === selectedTag.Id)
            });

            var results = alasql("SELECT * FROM ? WHERE Name LIKE '%" + query + "%' LIMIT 24", [availableTags]);
            return results;
        }

        function isTagActive(tagId) {
            let tag = locals.availableTags.find(x => x.Id == tagId);
            return tag ? tag.IsActive : false;
        }


        activate();
    }

    function isTagActiveDirective() {
        return {
            restrict: 'EA',
            link: function (scope, elem, attrs) {
                var mdChip = elem.parent().parent();

                let isActive = attrs.isTagActive
                if (isActive === 'true') {
                    mdChip.removeClass('tag-inactive');
                    return;
                }

                mdChip.addClass('tag-inactive');
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.allocate.droppable')
    .controller('overrideReasonDialogController', overrideReasonDialogController);

  function overrideReasonDialogController($mdDialog, locals) {

    var vm = this;
    vm.onClose = onClose;
    vm.onDone = onDone;

    function onClose(){
      $mdDialog.hide();
    }

    function onDone(){
      let data = locals ? locals.data : null;
      $mdDialog.hide({
          Data : data,
          Reason : vm.overrideReason
      });
    }

    function activate(){
    }

    activate()

  }
})();

(function () {
    "use strict";

    angular
        .module("app.jobs.allocate.droppable")
        .controller("linkItemsDialogController", linkItemsDialogController);

    /** @ngInject */
    function linkItemsDialogController($mdDialog, data, equipmentLists, allocationApi, exceptionService) {
        var vm = this;
        vm.onClose = onClose;
        vm.dismissDialog = dismissDialog;
        vm.addLinkItemRow = addLinkItemRow;
        vm.removeLinkItem = removeLinkItem;
        vm.onLinkItemChange = onLinkItemChange;
        vm.linkItemRows = [];
        vm.onSave = onSave;
        vm.isLinkedItemChange = false;
        // Per-linked-item operator-skill issues keyed by allocated resource item id, plus the
        // aggregate Save gate. Populated by validateLinkedItems against the parent's operator.
        vm.issuesByItemId = {};
        vm.canSave = true;
        // #52016: true when the only blocking gaps are overridable (Medium) and the user holds
        // the Override Lockout Rules claim — Save is enabled but requires an override reason.
        vm.canOverride = false;
        // Monotonic token so an out-of-order validation response can't overwrite state captured
        // after the selection changed again (e.g. a stale in-flight result landing after the
        // last linked item was removed).
        var validateSeq = 0;
        // #52016: ids the user removed at some point this session. Removing signals intent to
        // unlink, so if such an item is re-added it must re-justify a Medium gap (its previously
        // recorded override no longer applies).
        var removedIds = [];
        activate();

        function onClose() {
            $mdDialog.hide();
        }

        function dismissDialog(dialogData) {
            $mdDialog.hide({
                Data: dialogData,
            });
        }

        function activate() {
            vm.data = data;
            vm.operatorName = data.AssignedOperatorName;
            vm.equipmentLists = equipmentLists.filter(function (e) {
                return (
                    e.ItemType == 1 &&
                    e.IsOperatorRequired === false
                );
            });

            vm.equipmentLists.forEach(function (i) {
                if(i.ParentAllocatedResourceId === data.Id) {
                    vm.linkItemRows.push({
                        id: i.Id,
                        equipmentLists: vm.equipmentLists.filter(x => x.ParentAllocatedResourceId === data.Id)
                    });
                }
            });

            vm.equipmentLists = vm.equipmentLists.filter(x => x.ParentAllocatedResourceId !== data.Id &&
                                                                x.ParentAllocatedResourceId === null);

            validateLinkedItems();
        }

        // Validates the parent's operator against the currently-selected linked items so bad
        // items can be flagged and Save blocked. Soft issues warn but still allow Save.
        function validateLinkedItems() {
            var selectedIds = vm.linkItemRows.map(x => x.id).filter(Boolean);
            // Bump the token first so any in-flight request becomes stale — including on the
            // empty path below, which sets state synchronously and must not be overwritten by an
            // earlier response that is still pending.
            var seq = ++validateSeq;

            if (!selectedIds.length) {
                vm.issuesByItemId = {};
                vm.canSave = true;
                vm.canOverride = false;
                return;
            }

            // Keep Save disabled while validation is in flight and re-enable only on a clean or
            // overridable result, so a click during the request or a failed request can't save
            // unvalidated.
            vm.canSave = false;
            vm.canOverride = false;

            allocationApi.validateLinkedResourceItems({
                TicketId: vm.data.TicketId,
                ParentAllocatedResourceId: vm.data.Id,
                LinkedAllocatedResourceItemIds: selectedIds,
                ResetOverrideItemIds: getResetOverrideIds()
            }).then(function (response) {
                // Ignore a response superseded by a newer validation (out-of-order resolution).
                if (seq !== validateSeq) { return; }
                var result = response.data;
                vm.issuesByItemId = {};
                (result.Items || []).forEach(function (item) {
                    vm.issuesByItemId[item.AllocatedResourceItemId] = item;
                });
                vm.canSave = result.CanSave;
                vm.canOverride = result.CanOverride;
            }).catch(function (ex) {
                if (seq !== validateSeq) { return; }
                // Fail safe: leave Save disabled (the server-side gate is the backstop).
                vm.canSave = false;
                vm.canOverride = false;
                exceptionService.resolve(ex);
            });
        }

        function addLinkItemRow() {
            vm.linkItemRows.push({
                id: "",
                text: "",
                equipmentLists: vm.equipmentLists,
            });
        }

        function removeLinkItem(data) {
            vm.linkItemRows = vm.linkItemRows.filter((el) => el.id != data.id);

            var equipment = equipmentLists.filter((x) => x.Id == data.id);

            if (equipment.length > 0) {
                vm.equipmentLists.push(equipment[0]);
            }

            if(data.id) {
                vm.isLinkedItemChange = true;
                if (removedIds.indexOf(data.id) === -1) {
                    removedIds.push(data.id);
                }
            }

            validateLinkedItems();
        }

        // #52016: currently-selected items that were removed at some point this session — their
        // prior override must be re-justified.
        function getResetOverrideIds() {
            return vm.linkItemRows
                .map(x => x.id)
                .filter(id => id && removedIds.indexOf(id) !== -1);
        }

        function onLinkItemChange(data) {
            vm.equipmentLists = vm.equipmentLists.filter(
                (x) => x.Id != data.id
            );
            if(data.id) {
                vm.isLinkedItemChange = true;
            }

            validateLinkedItems();
        }

        function onSave() {
            var payload = {
                TicketId: vm.data.TicketId,
                ParentAllocatedResourceId: vm.data.Id,
                LinkedAllocatedResourceItemIds: vm.linkItemRows.map(x => x.id),
                ResetOverrideItemIds: getResetOverrideIds()
            };

            // Clean (or Soft-only) save — no override needed.
            if (vm.canSave) {
                vm.dismissDialog(payload);
                return;
            }

            // #52016: the only blocking gaps are overridable (Medium) and the user holds the
            // override claim. Capture a single reason for all overridden items, then save.
            // Dismissing the reason dialog (or leaving it empty) aborts the save.
            if (vm.canOverride) {
                $mdDialog.show({
                    templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                    controller: 'overrideReasonDialogController as vm',
                    multiple: true,
                    locals: { data: payload }
                }).then(function (overrideResult) {
                    if (overrideResult && overrideResult.Reason) {
                        payload.OverrideReason = overrideResult.Reason;
                        vm.dismissDialog(payload);
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.allocate.droppable')
        .controller('resourceMessagingController', resourceMessagingController);

    function resourceMessagingController($rootScope,
        $mdDialog,
        utils, _,
        $timeout,
        ticketGUID,
        allocationApi,
        exceptionService,
        mediaQueryService,
        messageStatusService,
        claimsUtilService,
        smartSchedulingService) {

        var vm = this;
        vm.utilService = utils;
        vm.enable_button = false;
        vm.sending = false;
        vm.media = mediaQueryService;
        vm.is_past_job = false;

        vm.getMessageStatus = getMessageStatus;
        vm.close = onClose;
        vm.activate = activate;
        vm.analyzeCheckItems = analyzeCheckItems;
        vm.send = send;
        vm.getMessageStatusText = getMessageStatusText;
        vm.checkAll = checkAll;
        vm.isPastJobStyle = isPastJobStyle;
        vm.isCheckboxDisabled = isCheckboxDisabled;
        vm.displayUnableToSendJobNotificationMessage = displayUnableToSendJobNotificationMessage;

        vm.isSmsEnabled = claimsUtilService.isSmsEnabled();

        function getItems() {
            return allocationApi.getRecipients(ticketGUID);
        }

        function isPastJobStyle() {
            let past_job_style = { 'text-decoration': 'line-through' };
            let not_past_job_style = { 'text-decoration': 'none' };
            return vm.is_past_job ? past_job_style : not_past_job_style;
        }

        function checkAll() {
            angular.forEach(vm.items, function (item) {
                if (item.MessageStatus === 0 && ((vm.isSmsEnabled && item.HasPhoneNumbers) || item.HasDevices)) {
                    item.IsSelected = vm.isSelectAllChecked;
                }
            });
            analyzeCheckItems();
        }

        function getMessageStatus(status) {
            return messageStatusService.getStatusColor(status).color;
        }

        function isCheckboxDisabled(contact) {
            return contact.MessageStatus != 0 // Notification not yet sent
                || vm.is_past_job
                || vm.sending
                || ((!vm.isSmsEnabled || !contact.HasPhoneNumbers) && (!contact.HasPushNotificationToken || !contact.HasDevices))
        }

        function isSelectAllChecked() {
            let countOfEnabledCheckboxes = _.filter(vm.items, function (item) {
                return !isCheckboxDisabled(item)
            }).length;
            let countOfSelectedCheckboxes = _.filter(vm.items, {
                IsSelected: true
            }).length;
            return countOfSelectedCheckboxes > 0 && (countOfSelectedCheckboxes === countOfEnabledCheckboxes);
        }

        function getMessageStatusText(status) {
            return messageStatusService.getStatusColor(status).name;
        }

        function onClose() {
            $mdDialog.hide();
        }

        function activate() {
            setActivationVariables();
            getItems().then(operateItems).catch(fetchingItemsFailed);
        }

        function setActivationVariables() {
            vm.message = "Loading ... ";
            vm.sending = true;
        }

        function unsetActivationVariables() {
            vm.sending = false;
            vm.message = null;
        }

        function operateItems(resp) {
            vm.items = setItems(resp.data)
            $timeout(function () {
                vm.is_past_job = evaluateIfPastJob(vm.items);
                unsetActivationVariables();
                analyzeCheckItems();
                vm.isSelectAllChecked = isSelectAllChecked();
            });
        }

        function evaluateIfPastJob(items) {
            return items.length === 0 ? false : items[0].IsPastJob;
        }

        function setItems(contacts) {
            contacts.map(function (recipient) {
                return {
                    IsSelected: false,
                    Id: recipient.Id,
                    ContactName: recipient.ContactName,
                    Shift: recipient.Shift,
                    MessageStatus: recipient.MessageStatus,
                    IsPastJob: recipient.IsPastJob
                }
            });
            return contacts;
        }

        function fetchingItemsFailed(err) {
            exceptionService.resolve(err);
            resetDefaultVariables();
        }

        function getIds(users) {
            return _.filter(users, { IsSelected: true }).map(function (item) {
                return item.Id;
            });
        }

        function send() {
            vm.message = "Sending ...";
            vm.sending = true;
            let allocatedResourceId = getIds(vm.items);

            allocationApi.sendMessage(allocatedResourceId).then(x => {
                reset(x);
                
                if(claimsUtilService.isSmartSchedulingEnabled())
                {
                    smartSchedulingService.confirmPreScheduleJobByTicketIds([ticketGUID]);
                }

            }).catch(messageSentFailed);
        }

        function messageSentFailed(err) {
            reset();
            exceptionService.resolve(err);
        }

        function reset(resp) {
            //To fetch api callback
            //To display 'Queued to Send'
            _.forEach(resp.data, function (itm) {
                $rootScope.$broadcast('resourceMessagingStatusCallback', itm);
            });
            vm.message = null;
            vm.sending = false;
        }

        function analyzeCheckItems() {
            let checked_items = _.filter(vm.items, { IsSelected: true }).length > 0;
            checked_items ? vm.enable_button = true : vm.enable_button = false;
            vm.isSelectAllChecked = isSelectAllChecked();
        }

        $rootScope.$on('resourceMessagingStatusCallback', function (event, args) {
            $timeout(function () {
                angular.forEach(vm.items, function (item) {
                    //Only change the message status to 'Queued to Send' if :
                    //Item id === args.key (Allocated resource Id) and
                    //Current message status is '0' or 'Notification not yet sent'
                    if (item.Id == args.Key && item.MessageStatus === 0) {
                        item.IsSelected = false;
                        item.MessageStatus = args.Value;
                    }
                });
                analyzeCheckItems();
                vm.isSelectAllChecked = isSelectAllChecked();
            })
        });

        $rootScope.$on('urn:updateMessagingStatus', function (event, args) {
            $timeout(function () {
                angular.forEach(vm.items, function (item) {
                    if (item.Id == args.AllocatedResourceItemId) {
                        item.IsSelected = false;
                        item.MessageStatus = args.Status;
                    }
                });
                analyzeCheckItems();
                vm.isSelectAllChecked = isSelectAllChecked();
            })
        });

        function displayUnableToSendJobNotificationMessage(allocatedResource){
            return (!vm.isSmsEnabled || !allocatedResource.HasPhoneNumbers) &&
                   (!allocatedResource.HasPushNotificationToken || !allocatedResource.HasDevices) &&
                   !(allocatedResource.MessageStatus === 6 || allocatedResource.MessageStatus === 7);

        }

        vm.activate();
    }
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.allocate.droppable')
    .controller('assignOperatorDialogController', assignOperatorDialogController);

  function assignOperatorDialogController($mdDialog, operators, line, resourceAllocateService) {

    var vm = this;
    vm.service = resourceAllocateService;
    vm.onClose = onClose;
    vm.onDone = onDone;

    function onClose(){
      $mdDialog.hide();
    }

    function onDone(){
      $mdDialog.hide();
    }

    function activate(){
      vm.operators = operators;
      vm.line = line;
    }
    activate();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.allocate.droppable')
    .controller('ResourceNoteController', ResourceNoteController);

  /** @ngInject */
  function ResourceNoteController($mdDialog,
                                  id,
                                  notes)
  {
    //Data
    var vm = this;
    vm.notes = null;

    //Functions
    vm.close = close;
    vm.save = save;
    vm.activate = activate;

    //Implementations
    function close(){
      $mdDialog.hide();
    }

    function save(){
      $mdDialog.hide({
        Id : vm.id,
        Notes : vm.notes
      });
    }

    function activate(){
      vm.id = id;
      vm.notes = notes
    }

    vm.activate();
  }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.allocate.droppable')
        .controller('resourceDialogController', resourceDialogController);

    function resourceDialogController($mdDialog,
        $q,
        oldAwardAPI,
        allocationApi,
        people,
        ticketBillingService,
        resourceAllocateService,
        exceptionService,
        _,
        claimsUtilService,
        adminClaimsService,
        utils,
        blockUI,
        equipment,
        lineItem,
        skills,
        itemType,
        timesheetApi) {

        var vm = this;
        vm.utilService = utils;
        vm.activeTab = 0;
        vm.item = null;
        vm.list = [];
        vm.lineItem = lineItem;
        vm.itemType = null;
        vm.checkAccessService = claimsUtilService;
        vm.adminClaimsService = adminClaimsService;
        vm.onClose = onClose;
        vm.onSave = onSave;
        vm.activate = activate;
        vm.onTabChanges = onTabChanges;
        vm.skills = skills;
        vm.resetClassificationsAndShiftRoles = resetClassificationsAndShiftRoles;
        vm.onAwardChange = onAwardChange;
        vm.saveManageShiftAwards = saveManageShiftAwards;
        vm.awards = [];
        vm.classifications = [];
        vm.roles = [];
        vm.ariRestriction = null;
        vm.isPayrollEnabled = claimsUtilService.isPayrollEnabled();
        vm.isBillingEnabled = claimsUtilService.isBillingEnabled();
        vm.onRecalculateAward = recalculateAward;

        const blocker = blockUI.instances.get('resource-dialog');

        function onClose() {
            $mdDialog.hide();
        }

        function onTabChanges(tab) {
            vm.activeTab = tab;

            if (tab == 0) {
                vm.chosenItem = vm.lineItem.ItemId;
            } else if (tab == 1) {
                vm.chosenItem = vm.lineItem.InvoiceAsItemId;
            } else if (tab == 2) {
                vm.chosenItem = vm.lineItem.BillingPeriod;
            }
        }

        function onSave() {
            if (vm.activeTab == 0) {
                $mdDialog.hide({
                    Transaction: 0,
                    Data: {
                        Id: vm.item.Id,
                        ItemId: vm.chosenItem,
                        TicketId: vm.item.TicketId,
                        ReferenceId: vm.item.ReferenceId
                    }
                });
            } else if (vm.activeTab == 1) {
                $mdDialog.hide({
                    Transaction: 1,
                    Data: {
                        Id: vm.item.Id,
                        ItemId: vm.chosenItem,
                        ReferenceId: vm.item.ReferenceId,
                        TicketId: vm.item.TicketId
                    }
                });
            } else if (vm.activeTab == 2) {
                $mdDialog.hide({
                    Transaction: 2,
                    Data: {
                        ReferenceId: vm.item.ReferenceId,
                        Id: vm.item.Id,
                        BillingPreference: vm.chosenItem2.ItemId
                    }
                });
            }
        }

        function activate() {
            vm.item = angular.copy(lineItem);
            vm.itemType = itemType;
            vm.list = getList(itemType);

            // Changing the resource type swaps the item this line stands for, which would leave a
            // parent/child link pointing at something the user never linked. With linking off
            // there are no links to protect, so the tab behaves as it always has.
            vm.canChangeResourceType = !resourceAllocateService.isLinkedItem(lineItem);

            if (itemType === 'People') {
                blocker.start(utils.translate('RESOURCEALLOCATION.LOADING_LOOKUPS'));

                var lookups = [
                    oldAwardAPI.getAwards(),
                    oldAwardAPI.getClassificationsLookup(),
                    oldAwardAPI.getShiftRoles()
                ];

                $q.all(lookups).then(function(resp) {
                    vm.awards = resp[0].data || [];
                    vm.classifications = resp[1].data || [];
                    vm.roles = resp[2].data || [];

                    allocationApi.getAriAwardClassificationRestrictions(vm.item.Id).then(function(resp2) {
                        vm.ariRestriction = resp2.data || null;
                        if (vm.ariRestriction) {
                            vm.item.Award = vm.ariRestriction.ContactAward;
                            vm.item.AwardClassification = vm.ariRestriction.ContactClassification;
                            vm.resetClassificationsAndShiftRoles();
                            vm.onAwardChange(true);
                        }
                    });

                    blocker.stop();
                }).catch(function() {
                    blocker.stop();
                });

                return;
            }

            blocker.start(utils.translate('RESOURCEALLOCATION.LOADING'));

            ticketBillingService.getBillingPeriod().then(function(resp) {
                vm.hirePeriods = angular.copy(resp.data);
                vm.chosenItem2 = _.find(vm.hirePeriods, {
                    Id: vm.item.BillingPeriod,
                    IsNotBillable: vm.item.IsNotBillable
                });
                blocker.stop();
            }).catch(function(ex) {
                blocker.stop();
                exceptionService.resolve(ex);
            });
        }

        function resetClassificationsAndShiftRoles() {
            vm.item.awardChanged = false;
            angular.forEach(vm.classifications, function(classification) {
                classification.isDisabled = false;
            });
            angular.forEach(vm.roles, function(role) {
                role.isDisabled = false;
            });
        }

        function onAwardChange(forced) {
            if (!vm.item.awardChanged && !forced) {
                return;
            }

            blocker.start(utils.translate('RESOURCEALLOCATION.LOADING_CLASSIFICATION_AND_ROLES'));

            var urls = [];

            if (vm.item.Award && vm.item.Award.Id) {
                urls.push(oldAwardAPI.getRolesByAwardAndBranch(vm.item.Award.Id));
                if (resourceAllocateService &&
                    resourceAllocateService.BranchId &&
                    vm.ariRestriction &&
                    !vm.ariRestriction.IsClassificationCannotBeOverridden) {
                    urls.push(oldAwardAPI.getClassificationsByAwardAndBranch(vm.item.Award.Id, resourceAllocateService.BranchId));
                }
            }

            $q.all(urls).then(function(resp) {
                if (resp[0] && resp[0].data) {
                    var shiftRoles = resp[0].data || [];
                    angular.forEach(vm.roles, function(role, i) {
                        role.isDisabled = true;
                        var index = _.findIndex(shiftRoles, {
                            Id: role.Id
                        });
                        if (index !== -1) {
                            role.isDisabled = false;
                        }
                        // remove disabled roles from the current selected roles.
                        var selectedIndex = _.findIndex(vm.item.ShiftRoles, {
                            Id: role.Id
                        });
                        if (role.isDisabled && selectedIndex !== -1) {
                            vm.item.ShiftRoles.splice(selectedIndex, 1);
                        }
                    });
                }
                if (resp[1] && resp[1].data) {
                    var classifications = resp[1].data || [];
                    angular.forEach(vm.classifications, function(classification, i) {
                        classification.isDisabled = true;
                        var index = _.findIndex(classifications, {
                            Id: classification.Id
                        });
                        if (index !== -1) {
                            classification.isDisabled = false;
                        }
                        if (classification.isDisabled && vm.item.AwardClassification && vm.item.AwardClassification.Id === classification.Id) {
                            vm.item.AwardClassification = null;
                        }
                    });
                }
                blocker.stop();
            }).catch(function() {
                blocker.stop();
            });
        }

        function saveManageShiftAwards(data) {
            $mdDialog.hide({
                Transaction: 4,
                Data: data,
                Id: vm.item.Id,
                Item: vm.item
            });
        }

        function getList(type) {
            let peopleList = people;
            let equipmentList = equipment;

            if (type == 'People') {
                return orderList(peopleList);
            } else {
                return orderList(equipmentList);
            }
        }

        function polishList(item, list) {
            angular.forEach(list, function(itm, index) {
                if (item.ItemName == itm.ItemName) {
                    list.splice(index, 1);
                }
            });
            return list;
        }

        function orderList(list) {
            return polishList(lineItem, alasql('select * from ? order by Name', [list]));
        }

        function recalculateAward() {
            var alreadyHasAward = vm.item.Award != null;
            var alreadyHasAwardClassification = vm.item.AwardClassification != null;
            vm.oldAward = vm.item.Award;
            vm.oldClassification = vm.item.AwardClassification;
            blocker.start(utils.translate('RESOURCEALLOCATION.RECALCULATING_AWARD'));
            timesheetApi.recalculateAwardClassification(vm.item.TicketId, vm.item.AllocatedId)
                .then(function(resp) {
                    if (resp.data.id) {

                        if ((alreadyHasAward && vm.item.Award.Name !== resp.data.Award.Name) || (!alreadyHasAward && resp.data.Award)) {
                            vm.isAwardClassificationUpdated = true;
                            vm.item.Award = resp.data.Award;
                            vm.updateAwardInof = alreadyHasAward? utils.translate('RESOURCEALLOCATION.RECALCULATE_AWARD_INFO') + vm.oldAward.Name + "'" : '';
                        }

                        if ((alreadyHasAwardClassification && vm.item.AwardClassification.Name !== resp.data.AwardClassification.Name) || (!alreadyHasAwardClassification && resp.data.AwardClassification)) {
                            vm.isAwardClassificationUpdated = true;
                            vm.item.AwardClassification = resp.data.AwardClassification;
                            vm.updateAwardClassificationInof = alreadyHasAwardClassification? utils.translate('RESOURCEALLOCATION.RECALCULATE_CLASSIFICATION_INFO') + vm.oldClassification.Name + "'": '';
                        }
                        blocker.stop();
                    }
                    blocker.stop();
                })
                .catch(function(ex) {
                    blocker.stop();
                });
        }
        vm.activate();
    }

})();

(function () {
  'use strict';

  angular
    .module('app.jobs.allocate.draggable',[])
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.allocate.draggable')
        .controller('AdvancedOptionsController', AdvancedOptionsController);

    /** @ngInject */
    function AdvancedOptionsController(
        $mdDialog,
        locals
    ) {
        var vm = this;
        vm.filterOptions = null;
        vm.showOption = {
            vehicle: false,
            distance: false,
            suburb: false,
            employmentStatus: false,
            showPrevAndNextShiftDetails: true
        }
        vm.sortOption = null;
        vm.hasVehicleFilter = false;
        vm.isVehicleFilterActive = false;
        vm.filterOption = null;
        vm.returnObject = {
            reset: false,
            showOption: vm.showOption,
            sortOption: null,
            filterOption: null,
            hasVehicleFilter: false,
            isVehicleFilterActive: false
        }

        vm.save = save;
        vm.close = close;
        vm.employmentStatusChange = employmentStatusChange;
        vm.suburbDistanceChange = suburbDistanceChange;
        vm.activateVehicleFilter = activateVehicleFilter;

        function suburbDistanceChange(source) {
            if (source == 'suburb') {
                vm.showOption.disable = false;
                vm.showOption.distance = !vm.showOption.suburb;
            }

            if (source == 'distance') {
                vm.showOption.disable = false;
                vm.showOption.suburb = !vm.showOption.distance;
            }

            if (source == 'disable') {
                vm.showOption.suburb = false;
                vm.showOption.distance = false;
            }
        }

        function employmentStatusChange() {
            if (!vm.showOption.employmentStatus) {
                vm.filterOption = null;
            }
        }

        function activate() {
            angular.extend(vm.showOption, locals.showOption);
            vm.sortOption = locals.sortOption;
            vm.filterOption = locals.filterOption;
            vm.hasVehicleFilter = locals.hasVehicleFilter;
            vm.isVehicleFilterActive = locals.isVehicleFilterActive;
        }

        function activateVehicleFilter() {
            vm.isVehicleFilterActive = vm.hasVehicleFilter;
        }

        function save() {
            vm.returnObject.reset = false;
            angular.extend(vm.returnObject.showOption, vm.showOption);
            vm.returnObject.sortOption = vm.sortOption;
            vm.returnObject.hasVehicleFilter = vm.hasVehicleFilter;
            vm.returnObject.isVehicleFilterActive = vm.isVehicleFilterActive;
            vm.returnObject.filterOption = vm.filterOption;
            $mdDialog.hide(vm.returnObject);
        }

        function close() {
            $mdDialog.hide();
        }

        activate();
    }
})();

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvoiceTicketDetails = function (_React$Component) {
    _inherits(InvoiceTicketDetails, _React$Component);

    function InvoiceTicketDetails() {
        _classCallCheck(this, InvoiceTicketDetails);

        return _possibleConstructorReturn(this, (InvoiceTicketDetails.__proto__ || Object.getPrototypeOf(InvoiceTicketDetails)).call(this));
    }

    _createClass(InvoiceTicketDetails, [{
        key: 'createStyle',


        /**
         * Hard coded styles for now
         */
        value: function createStyle() {
            var css = '<style>' + 'table.simple{font-family:"Roboto","Helvetica Neue","Arial",sans-serif;width:100%;border:0;border-spacing:0;text-align:left}table.simple.clickable tr{cursor:pointer}table.simple.clickable tr:hover{background:rgba(0,0,0,0.03)}table.simple th{padding:16px 8px;font-weight:500;color:rgba(0,0,0,0.54);border-bottom:1px solid rgba(0,0,0,0.12);white-space:nowrap;min-width:120px}table.simple th:first-child{padding-left:24px}table.simple th:last-child{padding-right:24px}table.simple td{padding:9px 8px;border-bottom:1px solid rgba(0,0,0,0.12)}table.simple td:first-child{padding-left:24px}table.simple td:last-child{padding-right:24px}table.simple tr:last-child td{border-bottom:0}.invoice-table{margin-top:16pt}thead{margin-bottom:5px}th{font-size:10pt;max-width:60pt}th:first-child{padding-left:0}th:last-child{padding-right:0}td{font-size:12px;border-bottom:0;padding:5px 8px}td:first-child{padding-left:0}td:last-child{padding-right:0}tr:nth-child(odd){background-color:#f4f4f4}tr:nth-child(even){background-color:#fff}tbody:before{content:"-";display:block;line-height:1em;color:transparent}.title{font-size:10pt}.detail{margin-top:4pt;font-size:9pt;max-width:none}.qty-col{width:100px}.unit-price-col{width:120px}.amt-col{width:130px}.start-time-col{width:180px}.end-time-col{width:180px}.hrs-col{width:180px}' + '</style>';
            return css;
        }
    }, {
        key: 'popWindow',
        value: function popWindow(id) {
            var html = $('#' + id).html();
            var win = window.open("", "", "toolbar=no,scrollbars=no,resizable=no,top=100,left=100,width=1200,height=600");
            var style = this.createStyle();
            win.document.write('<html><head><title>Ticket Details</title>');
            win.document.write(style);
            win.document.write('</head><body>');
            win.document.write(html);
            win.document.write('</body></html>');
        }

        /**
         * Render view
         */

    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var pUid = _.uniqueId('parentTicketDetail');

            /**
             * Resource items
             */
            var createResourceItems = function createResourceItems(resource) {
                var uid = _.uniqueId('ticketRowDetail');

                return React.createElement(
                    'tr',
                    { key: uid },
                    React.createElement(
                        'td',
                        null,
                        resource.ItemName
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        resource.StartTime
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        resource.Break
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        resource.EndTime
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        resource.TotalHoursWorked
                    )
                );
            };

            return React.createElement(
                'div',
                { key: pUid },
                React.createElement(
                    'div',
                    { className: 'custom-tooltip' },
                    React.createElement('i', { className: 'icon-open-in-new s16', onClick: self.popWindow.bind(this, pUid) }),
                    React.createElement(
                        'span',
                        { className: 'custom-tooltiptext' },
                        'Open Details'
                    )
                ),
                React.createElement(
                    'div',
                    { id: pUid },
                    React.createElement(
                        'table',
                        { className: 'simple invoice-table invoice-resource-table' },
                        React.createElement(
                            'thead',
                            null,
                            React.createElement(
                                'tr',
                                null,
                                React.createElement(
                                    'th',
                                    null,
                                    'Resource Item'
                                ),
                                React.createElement(
                                    'th',
                                    { className: 'text-right start-time-col' },
                                    'Start Time'
                                ),
                                React.createElement(
                                    'th',
                                    { className: 'text-right end-time-col' },
                                    'Break'
                                ),
                                React.createElement(
                                    'th',
                                    { className: 'text-right end-time-col' },
                                    'End Time'
                                ),
                                React.createElement(
                                    'th',
                                    { className: 'text-right hrs-col' },
                                    'Hours'
                                )
                            )
                        ),
                        React.createElement(
                            'tbody',
                            null,
                            this.props.ticketlist.map(createResourceItems)
                        )
                    )
                )
            );
        }
    }]);

    return InvoiceTicketDetails;
}(React.Component);

InvoiceTicketDetails.propTypes = {
    ticketlist: React.PropTypes.array.isRequired
};
InvoiceTicketDetails.defaultProps = {
    ticketlist: [] };
/**
 * Invoice Manual Invoice module
 * Created date: 3.13.2017
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.forms.manualInvoice', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.invoice_manual', {
            url: '/invoice/forms/manual_invoice',
            views: {
                'content@app': {
                    templateUrl: 'app/main/invoice/forms/manual-invoice/manual-invoice.html',
                    controller: 'ManualInvoiceController as manualInvoiceVm'
                }
            },
            data: { 
                requireLogin: true,
                validateAccess: ['invoiceClaimsService', function (invoiceClaimsService) {
                    return invoiceClaimsService.hasCreateInvoiceMenu;
                }]
            },
            resolve: {
                lookups: lookupResolver,
                costCodes: costCodesResolver
            },
            title: 'Create an Invoice',
            titleBar: 'Alloc8 - Create an Invoice'
        });

        $translatePartialLoaderProvider.addPart('app/main/invoice');
    };

    /** @ngInject */
    function lookupResolver(manualInvoiceEntryFormService) {
        return manualInvoiceEntryFormService.loadLookups();
    }

    /** @ngInject */
    function costCodesResolver(editInvoiceReportService) {
        return editInvoiceReportService.loadLookups();
    }

})();
/**
 * Report filter component
 */
(function () {
    'use strict';

    angular.module('app.invoice.forms.manualInvoice')
        .directive('lineItemManualInvoiceComponent', lineItemManualInvoiceComponent);

    /** @ngInject */
    function lineItemManualInvoiceComponent(lineItemManualInvoiceService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/forms/manual-invoice/directive/line-item-manual-invoice/line-item-manual-invoice.html',
            scope: {
                clientId: '=',
                taxRoundingRule: '='
            },
            controller: LineItemManualInvoiceController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function LineItemManualInvoiceController() {
            var vm = this;

            // Data
            vm.model = lineItemManualInvoiceService;

            // Events
            vm.editLineItem = editLineItem;

            activate();

            ///////
            function activate() {
                lineItemManualInvoiceService.summary.reset();
            }

            function editLineItem() {
                lineItemManualInvoiceService.editInvoiceLineItem(vm.clientId.Id, vm.taxRoundingRule);
            }

        }
    }
})();
/**
 * Report filter component
 */
(function () {
    'use strict';

    angular.module('app.invoice.forms.manualInvoice')
        .directive('manualInvoiceEntryFormComponent', manualInvoiceEntryFormComponent);

    /** @ngInject */
    function manualInvoiceEntryFormComponent(invoiceLookupService,
        manualInvoiceEntryFormService,
        businessesService,
        _,
        $mdDialog) {

        const DEFAULT_TAX_ROUNDING_RULE = "TaxableSupplyRule";

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/forms/manual-invoice/directive/entry-form-manual-invoice/manual-invoice-entry-form.html',
            scope: {
                onClientSelected: '&'
            },
            controller: ManualInvoiceEntryFormController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function ManualInvoiceEntryFormController() {
            var vm = this;

            // Data
            vm.lookups = invoiceLookupService;
            vm.model = manualInvoiceEntryFormService;

            // Method
            vm.addInvoiceTerm = addInvoiceTerm;
            vm.onClientChange = onClientChange;
            vm.onBranchChange = onBranchChange;

            activate();

            ///////
            function activate() {
                invoiceLookupService.loadAll();
            }

            function addInvoiceTerm() {
                $mdDialog.show({
                    templateUrl: 'app/main/company/create/companyDetails/invoice-term-dialog.html',
                    controller: 'InvoiceTermDialogController as vm'
                }).then(function (data) {
                    if (data) {
                        invoiceLookupService.loadTerms();
                    }
                });
            }

            function onClientChange(oldValue) {
                if (_.isEmpty(oldValue)) {
                    oldValue = { Id: '', Name: '' };
                }

                if (oldValue.Id != vm.model.data.selectedClient.Id) {
                    var data = { oldValue: oldValue.Name, newValue: vm.model.data.selectedClient.Name };
                    var deferred = (vm.onClientSelected || angular.noop)({ data: data });
                    deferred.then(function(resp) {
                        // Revert change
                        if (resp == 'no') {
                            vm.model.data.selectedClient = oldValue;
                        }
                    });
                }

            }

            function onBranchChange() {
                let selectedBranchId = vm.model.data.selectedBranch;
                let selectedBranch = vm.lookups.data.branchLookups.find(br => br.Id === selectedBranchId);

                if (selectedBranch.InvoicingBusiness) {
                    let branchBusinessId = selectedBranch.InvoicingBusiness.Id;

                    businessesService.getBusiness(branchBusinessId)
                        .then(resp => {
                            let taxRoundingRule = resp.data.fields["TaxRoundingRule"];

                            if(taxRoundingRule) {
                                vm.model.data.taxRoundingRule = taxRoundingRule
                            }
                            else {
                                vm.model.data.taxRoundingRule = DEFAULT_TAX_ROUNDING_RULE;
                            }
                        })
                }
            }

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.custom-validations-create', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.custom_rules_create', {
            url: '/custom/rules/:Id',
            params: {Id : null}
            , views: {
                'content@app': {
                    templateUrl: 'app/main/customValidations/create/custom-validations-create.html'
                    , controller: 'customValidationsCreateController as vm'
                }
            }
            , title: 'Create Custom Rule'
            , data: {
                requireLogin: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.custom-validations-create')
        .controller('thenDialogController', thenDialogController);

    function thenDialogController($mdDialog, model, service, _, utils, statement) {
        var vm = this;
        vm.then_model = {
            MemberName : null,
            Field : null,
            AllowedValues : [],
            IsRequired : false,
            RegexValidation : null,
        }
        vm.is_edit_mode = false;
        vm.utils = utils;
        vm.service = service;
        vm.isSelectType = false;
        vm.model = model;
        vm.onCancel = onCancel;
        vm.changeField = changeField;
        vm.save = save;

        function activate(){

            vm.then_model = {
                MemberName : null,
                Field : null,
                AllowedValues : [],
                IsRequired : false,
                RegexValidation : null,
            }

            //Map rule properties, order alphabetically, remove text fields
            vm.properties = _.orderBy(service.contacts_models.map(function(model){
                return {
                    FieldName : model.FieldName,
                    FieldRuleName : model.FieldRuleName,
                    FieldType : model.FieldType
                }
            }), ['FieldName'], ['asc']);

            //remove fields are were already added in the list
            if(!_.isNil(statement)){
                vm.is_edit_mode = true;
                vm.changeField(statement.Alias);

                vm.then_model = {
                    MemberName : statement.MemberName,
                    Field : statement.Alias,
                    AllowedValues : statement.AllowedValues,
                    IsRequired : (statement.CustomValidationRequiredType == 0 || statement.CustomValidationRequiredType == 1) ? true : false,
                    RegexValidation : statement.RegexValidation,
                }

                if(vm.then_model.Field == "Contact Types"){
                    angular.forEach(vm.then_model.AllowedValues, function(val){
                        val['id'] = val.Id;                    });
                }
                vm.properties = _.filter(vm.properties, {FieldName : statement.Alias});
            }else{
                vm.properties = _.filter(vm.properties, function(prop){
                    return !_.find(vm.model, function(m){
                        return prop.FieldName === m.Alias;
                    });
                });
            }
        }

        function changeField(field_name){
            let match = _.find(vm.service.contacts_models, {FieldName : field_name});
            vm.then_model.AllowedValues = [];
            if(match){
                if(match.FieldType == "text"){
                    vm.isSelectType = false;
                    vm.available_options = [];
                }else{
                    if(field_name == "Contact Types"){
                        vm.available_options = alasql('select * from ? order by TypeName', [match.Lookup]);
                    }else{
                        vm.available_options = alasql('select * from ? order by Name', [match.Lookup]);
                    }
                    vm.then_model.RegexValidation = null;
                    vm.isSelectType = true;
                }
            }else{
                vm.available_options = [];
                vm.isSelectType = false;
            }
        }

        function save(){
            let match = _.find(vm.service.contacts_models, {FieldName : vm.then_model.Field});
            let data = {
                MemberName : match.BackEndModel,
                Field : match.FieldRuleName,
                Alias : match.FieldName,
                AllowedValues : _.orderBy(vm.then_model.AllowedValues.map(function(value){
                    if(value.Id == 0){
                        return {
                            Id : value.Id,
                            Name : value.Name || value.TypeName
                        }
                    }

                    return {
                        Id : value.Id || value.id,
                        Name : value.Name || value.TypeName
                    }
                }), ['Name'], ['asc']),
                CustomValidationRequiredType : vm.then_model.IsRequired ? 0 : 2,
                RegexValidation : vm.then_model.RegexValidation
            }
            $mdDialog.hide({Model : data, Statement : statement});
        }

        function onCancel(){
            $mdDialog.hide();
        }

        activate();
    }

})();

(function() {
    'use strict';

    angular
        .module('app.custom-validations-create')
        .controller('ifDialogController', ifDialogController);

    function ifDialogController($mdDialog, model, service, _, condition) {
        var vm = this;
        vm.properties = [];
        vm.model = model;
        vm.available_options = [];
        vm.service = service;
        vm.is_edit_mode = false;
        vm.rule_model = {
            FieldName : null,
            Value : null
        }

        vm.onCancel = onCancel;
        vm.changeField = changeField;
        vm.save = save;

        function activate(){
            //Map rule properties, order alphabetically, remove text fields
            vm.properties = _.reject(_.orderBy(service.contacts_models.map(function(model){
                return {
                    FieldName : model.FieldName,
                    FieldRuleName : model.FieldRuleName,
                    FieldType : model.FieldType
                }
            }), ['FieldName'], ['asc']), {FieldType : 'text'});

            //remove fields are were already added in the list
            if(!_.isNil(condition)){
                vm.is_edit_mode = true;
                vm.properties = _.filter(vm.properties, {FieldName : condition.Alias});

                //Set condition model
                vm.rule_model = {
                    FieldName : condition.Alias,
                    Value : condition.Id
                }

                //get available options
                vm.changeField(vm.rule_model.FieldName);
            }else{
                vm.properties = _.filter(vm.properties, function(prop){
                    return !_.find(vm.model, function(m){
                        return prop.FieldName === m.Alias;
                    });
                });
            }
        }

        function changeField(field_name){
            let match = _.find(vm.service.contacts_models, {FieldName : field_name});
            if(field_name == "Contact Types"){
                vm.available_options = alasql('select * from ? order by TypeName', [match.Lookup]);
            }else{
                vm.available_options = alasql('select * from ? order by Name', [match.Lookup]);
            }
        }

        function save(){
            let field = _.find(vm.service.contacts_models, {FieldName : vm.rule_model.FieldName});
            let value = _.find(vm.available_options, function(opt){
                return opt.id == vm.rule_model.Value || opt.Id == vm.rule_model.Value;
            });
            let model = {
                Alias : field.FieldName,
                MemberName : field.BackEndModel,
                Id : value.id ? value.id : value.Id,
                Field : field.FieldRuleName,
                Value : value.TypeName ?value.TypeName : value.Name
            }
            $mdDialog.hide({Model : model, Condition : condition});
        }

        function onCancel(){
            $mdDialog.hide();
        }

        activate();
    }

})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('actionSection', actionSection);

    function actionSection() {
        var directive = {
            restrict: 'E',
            scope : {
                id : '=',
                field : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/utils/actionSection/actionSection.html',
            controller: actionSectionController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function actionSectionController(CustomFieldsManagerService, _, $mdDialog) {

            var vm = this;
            vm.global_service = CustomFieldsManagerService;
            vm.remove = remove;

            function remove(){

                var confirm = $mdDialog.confirm()
                    .title('Custom Fields Manager')
                    .textContent('Would you like to delete this field?')
                    .ok('Yes')
                    .cancel('Cancel');

                $mdDialog.show(confirm).then(function() {
                   vm.global_service.deleteField(vm.id);
                });
            }

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('wholeNumberDisplay', wholeNumberDisplay);

    function wholeNumberDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/wholeNumber/wholeNumberDisplay.html',
            controller: wholeNumberDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function wholeNumberDisplayController() {

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('urlDisplay', urlDisplay);

    function urlDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/url/urlDisplay.html',
            controller: urlDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function urlDisplayController() {

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('timeDisplay', timeDisplay);

    function timeDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/time/timeDisplay.html',
            controller: timeDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function timeDisplayController() {

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('shortTextDisplay', shortTextDisplay);

    function shortTextDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/shortText/shortTextDisplay.html',
            controller: shortTextDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function shortTextDisplayController() {

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('paragraphDisplay', paragraphDisplay);

    function paragraphDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/paragraph/paragraphDisplay.html',
            controller: paragraphDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function paragraphDisplayController() {

        }
    }
})();

(function () {
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('multipleChoiceDisplay', multipleChoiceDisplay);

    function multipleChoiceDisplay() {
        var directive = {
            restrict: 'E',
            scope: {
                field: '=',
                edit: '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/multipleChoice/multipleChoiceDisplay.html',
            controller: multipleChoiceDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function multipleChoiceDisplayController(_, CustomFieldsManagerService, utils) {
            var vm = this;
            vm.options_has_other = false;
            vm.service = CustomFieldsManagerService;

            vm.activate = activate;
            vm.removeItem = removeItem;
            vm.addOption = addOption;
            vm.addOther = addOther;

            function activate() {
                vm.model = false;

                if (vm.field.Option.length === 0) {
                    vm.options = [
                        {
                            Id: utils.newGuid(),
                            Value: 'Option 1',
                            Name: 'Option1',
                            Type: 'Regular'
                        },
                        {
                            Id: utils.newGuid(),
                            Value: 'Option 2',
                            Name: 'Option2',
                            Type: 'Regular'
                        }
                    ];
                    vm.field.Option = vm.options;
                } else {
                    vm.options = vm.field.Option;
                }

                evaluateOptions();
            }

            function removeItem(key) {
                if(vm.field.Option.length > 2){
                    vm.field.Option.splice(key, 1);
                }
                activate();
                evaluateOptions();
            }

            function addOption(){
                let arranged_options_by_id = alasql('select * from ? order by Id desc', [vm.field.Option]);
                let next_id = arranged_options_by_id[0].Id + 1;
                vm.field.Option.push({
                    Id: next_id,
                    Value: 'Option ' + (vm.field.Option.length + 1),
                    Name: 'Option'  + (vm.field.Option.length + 1),
                    Type: 'Regular'
                });
                activate();
                evaluateOptions();
            }

            function addOther(){
                let arranged_options_by_id = alasql('select * from ? order by Id desc', [vm.field.Option]);
                let next_id = arranged_options_by_id[0].Id + 1;
                vm.field.Option.push({
                    Id: next_id,
                    Value: 'Option ' + (vm.field.Option.length + 1),
                    Name: 'Option'  + (vm.field.Option.length + 1),
                    Type: 'Other'
                });
                activate();
                evaluateOptions();
            }

            function evaluateOptions(){
                let match = _.find(vm.field.Option, {
                    Type : 'Other'
                });

                match ? vm.options_has_other = true : vm.options_has_other = false;

                if(match){
                    let other_index = _.findIndex(vm.field.Option, function(o) { return o.Type === 'Other'; });
                    let other_option = angular.copy(vm.field.Option[other_index]);
                    vm.field.Option.splice(other_index, 1);
                    vm.field.Option.push(other_option);
                }
            }

            vm.activate();
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('emailDisplay', emailDisplay);

    function emailDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/email/email.html',
            controller: emailDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function emailDisplayController() {

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('dropDownDisplay', dropDownDisplay);

    function dropDownDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/dropDown/dropDownDisplay.html',
            controller: dropDownDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function dropDownDisplayController(_, CustomFieldsManagerService, utils) {
            var vm = this;
            vm.options_has_other = false;
            vm.service = CustomFieldsManagerService;

            vm.activate = activate;
            vm.removeItem = removeItem;
            vm.addOption = addOption;

            function activate() {
                vm.model = false;

                let other_exists = _.find(vm.field.Option, {
                    Type : "Other"
                });

                if(other_exists){
                    let other_index = _.findIndex(vm.field.Option, function(o) { return o.Type === 'Other'; });
                    vm.field.Option.splice(other_index, 1);
                    if(vm.field.Option.length < 2){
                        vm.addOption();
                    }
                }

                if (vm.field.Option.length === 0) {
                    vm.options = [
                        {
                            Id: utils.newGuid(),
                            Value: 'Option 1',
                            Name: 'Option1',
                            Type: 'Regular'
                        },
                        {
                            Id: utils.newGuid(),
                            Value: 'Option 2',
                            Name: 'Option2',
                            Type: 'Regular'
                        }
                    ];
                    vm.field.Option = vm.options;
                } else {
                    vm.options = vm.field.Option;
                }

                evaluateOptions();
            }

            function removeItem(key) {
                if(vm.field.Option.length > 2){
                    vm.field.Option.splice(key, 1);
                }
                activate();
                evaluateOptions();
            }

            function addOption(){
                let arranged_options_by_id = alasql('select * from ? order by Id desc', [vm.field.Option]);
                let next_id = arranged_options_by_id[0].Id + 1;
                vm.field.Option.push({
                    Id: next_id,
                    Value: 'Option ' + (vm.field.Option.length + 1),
                    Name: 'Option'  + (vm.field.Option.length + 1),
                    Type: 'Regular'
                });
                activate();
                evaluateOptions();
            }

            function evaluateOptions(){
                let match = _.find(vm.field.Option, {
                    Type : 'Other'
                });

                match ? vm.options_has_other = true : vm.options_has_other = false;

                if(match){
                    let other_index = _.findIndex(vm.field.Option, function(o) { return o.Type === 'Other'; });
                    let other_option = angular.copy(vm.field.Option[other_index]);
                    vm.field.Option.splice(other_index, 1);
                    vm.field.Option.push(other_option);
                }
            }

            vm.activate();
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('decimalDisplay', decimalDisplay);

    function decimalDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/decimal/decimalDisplay.html',
            controller: decimalDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function decimalDisplayController() {

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('checkBoxWithEntryDisplay', checkBoxWithEntryDisplay);

    function checkBoxWithEntryDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/checkBoxWithEntry/checkBoxWithEntry.html',
            controller: checkBoxWithEntryDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function checkBoxWithEntryDisplayController(_, CustomFieldsManagerService, utils) {
            var vm = this;
            vm.options_has_other = false;
            vm.service = CustomFieldsManagerService;
            vm.other = "Other Entry";

            vm.activate = activate;
            vm.removeItem = removeItem;
            vm.addOption = addOption;

            function activate() {
                vm.model = false;

                let other_exists = _.find(vm.field.Option, {
                    Type : "Other"
                });

                if(other_exists){
                    let other_index = _.findIndex(vm.field.Option, function(o) { return o.Type === 'Other'; });
                    vm.field.Option.splice(other_index, 1);
                    if(vm.field.Option.length < 2){
                        vm.addOption();
                    }
                }

                if (vm.field.Option.length === 0) {
                    vm.options = [
                        {
                            Id: utils.newGuid(),
                            Value: 'Option 1',
                            Name: 'Option1',
                            Type: 'Regular'
                        }
                    ];
                    vm.field.Option = vm.options;
                } else {
                    vm.options = vm.field.Option;
                }

                evaluateOptions();
            }

            function removeItem(key) {
                if(vm.field.Option.length > 1){
                    vm.field.Option.splice(key, 1);
                }
                activate();
                evaluateOptions();
            }

            function addOption(){
                let arranged_options_by_id = alasql('select * from ? order by Id desc', [vm.field.Option]);
                let next_id = arranged_options_by_id[0].Id + 1;
                vm.field.Option.push({
                    Id: next_id,
                    Value: 'Option ' + (vm.field.Option.length + 1),
                    Name: 'Option'  + (vm.field.Option.length + 1),
                    Type: 'Regular'
                });
                console.log('vm.field.Option')
                console.log(vm.field.Option)
                activate();
                evaluateOptions();
            }

            function evaluateOptions(){
                let match = _.find(vm.field.Option, {
                    Type : 'Other'
                });

                match ? vm.options_has_other = true : vm.options_has_other = false;

                if(match){
                    let other_index = _.findIndex(vm.field.Option, function(o) { return o.Type === 'Other'; });
                    let other_option = angular.copy(vm.field.Option[other_index]);
                    vm.field.Option.splice(other_index, 1);
                    vm.field.Option.push(other_option);
                }
            }

            vm.activate();
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-fields.view')
        .directive('checkBoxDisplay', checkBoxDisplay);

    function checkBoxDisplay() {
        var directive = {
            restrict: 'E',
            scope : {
                field : '=',
                edit : '='
            },
            templateUrl: 'app/main/customFieldsManager/views/directives/display/checkBox/checkBoxDisplay.html',
            controller: checkBoxDisplayController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function checkBoxDisplayController(_, CustomFieldsManagerService, utils) {
            var vm = this;
            vm.options_has_other = false;
            vm.service = CustomFieldsManagerService;

            vm.activate = activate;
            vm.removeItem = removeItem;
            vm.addOption = addOption;
            vm.addOther = addOther;

            function activate() {
                vm.model = false;
                if (vm.field.Option.length === 0) {
                    vm.options = [
                        {
                            Id: utils.newGuid(),
                            Value: 'Option 1',
                            Name: 'Option1',
                            Type: 'Regular'
                        }
                    ];
                    vm.field.Option = vm.options;
                } else {
                    vm.options = vm.field.Option;
                }

                evaluateOptions();
            }

            function removeItem(key) {
                if(vm.field.Option.length > 1){
                    vm.field.Option.splice(key, 1);
                }
                activate();
                evaluateOptions();
            }

            function addOption(){
                let arranged_options_by_id = alasql('select * from ? order by Id desc', [vm.field.Option]);
                let next_id = arranged_options_by_id[0].Id + 1;
                vm.field.Option.push({
                    Id: next_id,
                    Value: 'Option ' + (vm.field.Option.length + 1),
                    Name: 'Option'  + (vm.field.Option.length + 1),
                    Type: 'Regular'
                });
                activate();
                evaluateOptions();
            }

            function addOther(){
                let arranged_options_by_id = alasql('select * from ? order by Id desc', [vm.field.Option]);
                let next_id = arranged_options_by_id[0].Id + 1;
                vm.field.Option.push({
                    Id: next_id,
                    Value: 'Option ' + (vm.field.Option.length + 1),
                    Name: 'Option'  + next_id,
                    Type: 'Other'
                });
                activate();
                evaluateOptions();
            }

            function evaluateOptions(){
                let match = _.find(vm.field.Option, {
                    Type : 'Other'
                });

                match ? vm.options_has_other = true : vm.options_has_other = false;

                if(match){
                    let other_index = _.findIndex(vm.field.Option, function(o) { return o.Type === 'Other'; });
                    let other_option = angular.copy(vm.field.Option[other_index]);
                    vm.field.Option.splice(other_index, 1);
                    vm.field.Option.push(other_option);
                }

                
            }

            vm.activate();
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.contact.create', [
      'uiGmapgoogle-maps'
    ])
    .config(config)
    .config(['uiGmapGoogleMapApiProvider', function (GoogleMapApi) {
      GoogleMapApi.configure({
        //  key: 'AIzaSyA7blIhlm1qVU8QVKK9SFZmAe2pKhsXnvY',
        //    v: '3.20',
        libraries: 'places'
      });
    }]);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state('app.contact_create', {
        url: '/contacts/create-contact'
        , views: {
          'content@app': {
            templateUrl: 'app/main/contact/create/contact-create.html'
            , controller: 'ContactCreateController as vmContact'
          }
        }
        , data:  {
            requireLogin: true
        },
          params : {
            company : null
          }
        , resolve: {
          lookupService: lookupServiceResolver
        }
        ,title: 'Create Contact'
        ,titleBar: 'Alloc8 - Create Contact'
      })
      // state for Update Contact
      .state('app.contact_update', {
        url: '/contacts/update/:cid?/:cname'
        , params: {
          skillid: null,
          trainingid: null
        }
        , views: {
          'content@app': {
            templateUrl: 'app/main/contact/create/contact-create.html'
            , controller: 'ContactCreateController as vmContact'
          }
        }
        , data: {
          requireLogin: true
        }
        , title: 'Update Contact'
        , titleBar: 'Alloc8 - Contact Update'
        , resolve: {
          lookupService: lookupServiceResolver
        }
      });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/contact/create');
  }

  /** @ngInject */
  function lookupServiceResolver(contactLookupsService) {
    return contactLookupsService.fetchLookups();
  }
})();

(function() {
    'use strict';

    angular.module('app.contact.create')
        .controller('ContactTrainingDialogController', ContactTrainingDialogController);

    /** @ngInject */
    function ContactTrainingDialogController(
        downloadService,
        $mdDialog,
        utils,
        contactLookupsService,
        contactService,
        _,
        isEdit,
        data,
        contactApi,
        skillsMatrixService) {

        var vm = this;
        
        vm.caption = utils.translate('CONTACTSMODULE.TRAINING_ADD');
        vm.trainings = arrangeTrainings(contactLookupsService.contactLookupsObj.Trainings);
        vm.isEdit = isEdit;
        vm.uploadUrl = contactApi.uploadTrainingDoc;
        vm.skillsMatrixService = skillsMatrixService;

        vm.onCancel = onCancel;
        vm.onDone = onDone;
        vm.onChangeItem = onChangeItem;
        vm.onUploadSuccess = onUploadSuccess;
        vm.onUploadError = onUploadError;
        vm.onUploadStart = onUploadStart;
        vm.onUploadValidate = onUploadValidate;
        vm.preview = preview;
        vm.removeUpload = removeUpload;
        vm.downloadFile = downloadFile;

        activate();

        function activate() {
            if (vm.isEdit) {
                vm.model = angular.copy(data);
                vm.model.UploadFileName = data.UploadFileName;
                vm.fileName = vm.model.UploadFileName === null ? null : vm.model.UploadFileName.substring(vm.model.UploadFileName.lastIndexOf("/") + 1);

            } else {
                vm.model = angular.copy(training_model());
            }
        }

        function downloadFile() {
            let apiString = '/api/contacts/' + contactService.contactData.id + '/trainings/' + vm.model.Id + '/file';
            downloadService.downloadFile(apiString);
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function onUploadStart() {
            vm.showProgress = true;
            vm.uploadAdded = true;
        }

        function preview() {
            window.open(vm.model.UploadFileName, "_blank");
        }

        function onUploadSuccess(data) {
            vm.showProgress = false;
            vm.model.UploadFileName = data.Url[0];
            var lastIndex = vm.model.UploadFileName.lastIndexOf("/");
            vm.fileName = vm.model.UploadFileName.substring(lastIndex + 1);
        }

        function removeUpload() {
            vm.uploadAdded = false;
            vm.model.UploadFileName = null;
            vm.fileName = null;
        }

        function onUploadValidate(fileObj) {
            var ext = utils.getFileExtension(fileObj.name);
            var isValid = true;
            if (ext != '.jpeg' && ext != '.jpg' && ext != '.png' && ext != '.gif' && ext != '.doc' && ext != '.docx' && ext != '.pdf') {
                isValid = false;
                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(utils.translate('CONTACTSMODULE.SKILLS_INVALID_FILE'))
                    .ariaLabel(utils.translate('CONTACTSMODULE.SKILLS_INVALID_FILE'))
                    .ok(utils.translate('CONTACTSMODULE.SKILLS_OK'))
                $mdDialog.show(notif);
            }
            return isValid;
        }

        function onUploadError() {
            vm.uploadAdded = false;
        }

        function onChangeItem(Id) {
            let item = _.find(vm.trainings, {
                Id: Id
            });
            vm.model.TrainingName = item.TrainingName;
            vm.model.ExpiryIsMandatory = item.ExpiryIsMandatory;
            vm.model.ExpiryDate = null;
            vm.model.CompletedDate = null;
        }

        function onDone() {
            if (vm.isEdit) {
                let index = _.findIndex(contactService.contactData.PersonalTrainings, function(o) {
                    return o.Temp_Id == data.Temp_Id;
                });
                contactService.contactData.PersonalTrainings.splice(index, 1);
            }
            vm.model.Temp_Id = utils.newGuid();
            contactService.contactData.PersonalTrainings.push(vm.model);
            angular.extend(contactService.contactData.PersonalTrainings, contactService.contactData.PersonalTrainings);
            contactService.updateContact();
            $mdDialog.hide();
        }

        function arrangeTrainings(trainings) {
            let list = [];
            angular.forEach(trainings, function(training) {
                angular.forEach(training.Trainings, function(training_item) {
                    list.push(training_item);
                });
            });
            return list;
        }

        function training_model() {
            return {
                Id: null,
                TrainingName: null,
                Description: null,
                ExpiryDate: null,
                CompletedDate: null,
                UploadFileName: null,
                ReferenceNumber: null,
                ExpiryIsMandatory: false,
                Temp_Id: null
            };
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('contactSkills', contactSkills);

    function contactSkills(
        contactService,
        $timeout
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/contact/create/work/skills/view/contact-skills.html',
            scope: {
                skills: '=',
                companies: '=',
                contact: '=',
                skillsLookup: '='
            },
            controller: skillsViewController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function skillsViewController(claimsUtilService, $mdDialog, _) {
            var vm = this;
            vm.dtOptions = {
                pagingType: 'simple',
                pageLength: 25,
                autoWidth: false,
                responsive: true,
                sort: false
            };

            let hasManageSkillsPermission = claimsUtilService.checkAccessByRole('Manage Contact Skills');
            let hasRemoveSkillsPermission = claimsUtilService.checkAccessByRole('Remove Contact Skills');
            vm.canAddSkills = hasManageSkillsPermission;
            vm.canEditSkills = hasManageSkillsPermission;
            vm.canDeleteSkills = hasRemoveSkillsPermission;

            vm.openDialog = openDialog;
            vm.removeSkill = removeSkill;
            vm.activate = activate;

            vm.isExpiringSoon = isExpiringSoon;
            vm.today = moment();

            vm.activate();

            function isExpiringSoon(expiryDate) {
                var daysToExpiry = moment(expiryDate).diff(vm.today, 'days');
                return daysToExpiry <= 14;
            }

            function activate() {
                if (typeof contactService.openSkillDialog !== 'function') {
                    contactService.openSkillDialog = openDialog;
                }
            }

            function removeSkill(skill) {
                vm.skills = _.reject(vm.skills, {
                    UniqueId: skill.UniqueId
                });
            }

            function openDialog(is_edit, skill, onComplete) {

                $mdDialog.show({
                    templateUrl: 'app/main/contact/create/work/skills/view/dialog/contact-skill-dialog.html',
                    controller: 'contactSkillDialogController2 as vm',
                    onComplete: onComplete || angular.noop,
                    locals: {
                        is_edit: is_edit,
                        skill: skill,
                        skills_list: vm.skills,
                        companies: vm.companies,
                        skills_lookup: vm.skillsLookup,
                        contact: vm.contact
                    }
                }).then(function(resp) {
                    if (resp) {

                        vm.skills = contactService.contactData.PersonalSkills;

                        //Remove Original Base Skills (For Update)
                        if (resp.edit) {
                            if (_.isArray(resp.base)) {
                                let first_child = resp.base[0];
                                vm.skills = _.reject(vm.skills, {
                                    GroupId: first_child.GroupId
                                })
                            } else if (resp.base.GroupId) {
                                vm.skills = _.reject(vm.skills, {
                                    GroupId: resp.base.GroupId
                                })
                            } else {
                                vm.skills = _.reject(vm.skills, {
                                    Id: resp.base.Id
                                })
                            }
                        }
                        //Remove Original Base Skills (For Update)

                        if (_.isArray(resp.data)) {
                            _.forEach(resp.data, function(skill) {
                                vm.skills.push(skill)
                            });
                        } else {
                            vm.skills.push(resp.data)
                        }

                        contactService.contactData.PersonalSkills = vm.skills;

                        $timeout(function() {
                            contactService.updateContact();
                        })
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';
    angular.module('app.skillsmatrix.manage')
        .controller('ContactSkillsController', ContactSkillsController);

    /** @ngInject */
    function ContactSkillsController(
        $mdDialog,
        ContactSkillService,
        contactLookupsService,
        completeSkills,
        skillsMatrixService,
        tenantSettings,
        blockUI,
        skills,
        editMode,
        skillModel,
        companies,
        contactService,
        utils
    ) {
        var vm = this;
        var ClientCompany = null;
        vm.companies2 = [];
        vm.Skill = null;
        vm.skilltype = null;
        vm.errorMessage = false;
        vm.selectedItem = null;
        vm.searchText = null;
        vm.service = ContactSkillService;
        vm.skillsMatrixService = skillsMatrixService;
        vm.contactService = contactService;
        vm.uploadUrl = tenantSettings.coreApiUrl + "api/contacts/skillsmatrix/upload";
        vm.currentSkills = [];
        vm.bahavior = "dynamic";
        vm.uploadAdded = false;
        vm.showProgress = false;
        vm.showExpiry = false;
        vm.isEditMode = editMode;
        vm.allSkills = [];
        vm.formattedSkills = []
        vm.childSkills = [];
        vm.rawSkills = [];
        vm.filteredSkills = contactLookupsService.contactLookupsObj.Skills;
        vm.utilService = utils;
        vm.myDate = new Date();
        vm.minDate = new Date(vm.myDate.getFullYear(), vm.myDate.getMonth(), vm.myDate.getDate());
        vm.ParentId = null;

        // Method
        vm.onCancel = onCancel;
        vm.addSkill = addSkill;
        vm.onUploadSuccess = onUploadSuccess;
        vm.onUploadError = onUploadError;
        vm.onUploadStart = onUploadStart;
        vm.populateContactSkills = populateContactSkills;
        vm.onUploadValidate = onUploadValidate;
        vm.removeUpload = removeUpload;
        vm.activate = activate;
        vm.filterDate = filterDate;
        vm.changeSkill = changeSkill;
        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.checkChildIfHasExpiry = checkChildIfHasExpiry;
        vm.transformChip = transformChip;
        vm.downloadFile = downloadFile;
        vm.activate();
        vm.populateContactSkills();

        function transformChip(company) {
            let data = null;
            _.isObject(company) ? data = company : data = {
                Name: company
            };
            return data;
        }

        function downloadFile(link) {
            let file_download = link.substring(link.lastIndexOf("/") + 1);
            var a = document.createElement('a');
            a.href = link;
            a.target = '_blank';
            a.download = file_download;
            document.body.appendChild(a);
            a.click();
        }

        function selectedItemChange(item) {
            if (!_.isNil(item)) {
                ClientCompany = item.id;
            }
        }

        function querySearch(query) {
            let results = alasql("select * from ? where Name like '" + query + "%'", [vm.companies]);
            return alasql('select * from ? order by Name', [results]);
        }

        function filterDate(date) {
            return moment()
                .diff(moment(date)) > 0;
        }

        function changeSkill(skill) {
            vm.skilltype = [];
            let match = alasql('select * from ? where id = ?', [completeSkills, skill.Id]);
            if (match.length > 0) {
                if (editMode) {
                    let parent = getParent(match[0]);
                    _.isNil(parent) ? vm.showExpiry = match[0].ExpiryIsMandatory : checkChildIfHasExpiry(parent.Children);
                } else {
                    skill.Children.length > 0 ? vm.showExpiry = false : vm.showExpiry = match[0].ExpiryIsMandatory;
                }
            } else {
                vm.showExpiry = false;
            }
        }

        function isChild(data) {
            let ischild = false;
            angular.forEach(vm.skills, function(skill) {
                angular.forEach(skill.Children, function(child) {
                    if (data.Id == child.Id) {
                        ischild = true;
                    }
                });
            });
            return ischild;
        }

        function getParent(data) {
            let parent = null;
            angular.forEach(vm.skills, function(skill) {
                angular.forEach(skill.Children, function(child) {
                    if ((data.Id || data.id) == child.Id) {
                        parent = skill;
                    }
                });
            });
            return parent;
        }

        function getSelf(data) {
            let self = null;
            angular.forEach(vm.skills, function(skill) {
                if (data.Id == skill.Id) {
                    self = skill;
                }
            });
            return self;
        }

        function getRelatedSkills() {
            let matches = alasql('select * from ? where ParentId = ?', [vm.contactService.FormattedSkills, vm.skill.ParentId]);
            let skills = angular.copy(matches);
            return skills;
        }

        function checkChildIfHasExpiry(skills) {
            let skills_with_expiry_count = _.filter(skills, {
                    ExpiryIsMandatory: true
                })
                .length;
            skills_with_expiry_count > 0 ? vm.showExpiry = true : vm.showExpiry = false;
        }

        function activate() {
            vm.skills = skills;
            vm.companies = companies;
            if (editMode) {
                vm.ParentId = angular.copy(skillModel.ParentId);
                changeSkill(skillModel);
                let child = isChild(skillModel);
                if (child) {
                    vm.parent = getParent(skillModel);
                    vm.skill = {
                        Id: vm.parent.Id,
                        Name: vm.parent.SkillName,
                        ParentId: skillModel.ParentId
                    }
                    let related_skills = getRelatedSkills();
                    vm.skilltype = angular.copy(related_skills);
                } else {
                    vm.parent = getSelf(skillModel);
                    vm.skill = {
                        Id: skillModel.Id,
                        Name: skillModel.SkillName
                    }
                }!vm.showExpiry ? vm.ExpiryDate = null : vm.ExpiryDate = utils.epochToJsDateTime(skillModel.ExpiryDate);
                vm.Description = skillModel.Description;
                vm.UploadFileName = skillModel.UploadFileName;
                vm.fileName = vm.UploadFileName === null ? null : vm.UploadFileName.substring(vm.UploadFileName.lastIndexOf("/") + 1);
                vm.ClientCompany = skillModel.ClientCompany === null ? null : (skillModel.ClientCompany.Id || skillModel.ClientCompany.id);
                vm.ReferenceNumber = skillModel.ReferenceNumber;
                vm.selectedItem = skillModel.ClientCompany;
            } else {
                vm.ExpiryDate = null;
                vm.Description = null;
                vm.UploadFileName = null;
                vm.skill = null;
                vm.ReferenceNumber = null;
                vm.ClientCompany = null;
            }
        }

        function populateContactSkills() {
            vm.currentSkills = [];
            angular.forEach(skills, function(value) {
                angular.forEach(value.Skills, function(val, key) {
                    val.ClientCompany == null ? ClientCompany = null : ClientCompany = val.ClientCompany.Name;
                    var skill = {
                        id: val.id,
                        SkillName: val.SkillName,
                        ReferenceNumber: val.ReferenceNumber,
                        Description: val.Description,
                        ClientCompany: ClientCompany,
                        ExpiryDate: utils.epochToJsDateTime(val.ExpiryDate, 'MM/DD/YYYY'),
                        UploadFileName: val.UploadFileName,
                        GroupName: value.GroupName,
                        GroupId: value.id,
                        ExpiryMandatory: val.ExpiryIsMandatory,
                        ParentId: val.GroupId
                    }
                    vm.currentSkills.push(skill);
                })
            });
            vm.currentSkills = alasql('select * from ? order by SkillName asc', [vm.currentSkills]);
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function generateCompanyGUIDs(companies) {
            angular.forEach(companies, function(company) {
                company['GUID'] = utils.newGuid();
            });
            return companies;
        }

        function formatSkill(skl, ReferenceNumber, Description, expiryDate, UploadFileName, guid) {
            let companies = angular.copy(vm.companies2);
            let guid_copy = null;
            let skills = [];
            if (companies.length > 0 && !vm.isEditMode) {
                angular.forEach(companies, function(company) {
                    let ClientCompany = {
                        id: company.id,
                        Name: company.Name,
                    };
                    guid_copy = company.GUID;
                    skills.push({
                        id: skl.Id,
                        UniqueId: utils.newGuid(),
                        SkillName: skl.SkillName,
                        ReferenceNumber: ReferenceNumber,
                        Description: Description,
                        ClientCompany: ClientCompany,
                        ExpiryDate: skl.ExpiryIsMandatory ? expiryDate : null,
                        UploadFileName: UploadFileName,
                        GroupId: guid ? guid_copy : null
                    });
                });
            } else {
                guid_copy = _.isNil(skillModel) ? null : _.isNil(skillModel.GroupId) ? null : skillModel.GroupId;
                skills.push({
                    id: skl.Id,
                    UniqueId: utils.newGuid(),
                    SkillName: skl.SkillName,
                    ReferenceNumber: ReferenceNumber,
                    Description: Description,
                    ClientCompany: vm.isEditMode ? !_.isNil(skillModel.ClientCompany) ? {
                        id: skillModel.ClientCompany.Id,
                        Name: skillModel.ClientCompany.Name
                    } : null : null,
                    ExpiryDate: skl.ExpiryIsMandatory ? expiryDate : null,
                    UploadFileName: UploadFileName,
                    GroupId: guid ? guid_copy : null
                });
            }
            return skills;
        }

        function addSkill(behavior) {
            vm.companies2 = generateCompanyGUIDs(vm.companies2);
            let expiryDate = null;
            let ReferenceNumber = null;
            let Description = null;
            let UploadFileName = null;
            let match = alasql('select * from ? where id = ?', [completeSkills, vm.skill.Id]);
            let skillGroup = {
                Id: match[0].Group.id,
                GroupName: match[0].Group.GroupName,
                CreatedDate: utils.jsDateTimeToEpoch(new Date()),
                UpdatedDate: utils.jsDateTimeToEpoch(new Date()),
                Skills: []
            }
            vm.isEditMode ? ClientCompany = _.find(vm.companies, {
                id: vm.ClientCompany
            }) : ClientCompany = null;
            _.isNil(vm.ExpiryDate) ? expiryDate = null : expiryDate = utils.jsDateTimeToEpoch(vm.ExpiryDate);
            _.isNil(vm.ReferenceNumber) ? ReferenceNumber = null : ReferenceNumber = vm.ReferenceNumber;
            _.isNil(vm.Description) ? Description = null : Description = vm.Description;
            _.isNil(vm.UploadFileName) ? UploadFileName = null : UploadFileName = vm.UploadFileName;
            if (!vm.showExpiry) {
                expiryDate = null;
            }
            if (editMode) {
                let child = isChild(skillModel);
                if (child) {
                    angular.forEach(contactService.contactData.PersonalSkills, function(group) {
                        group.Skills = _.reject(group.Skills, {
                            GroupId: vm.ParentId
                        });
                    });
                } else {
                    angular.forEach(contactService.contactData.PersonalSkills, function(group) {
                        angular.forEach(group.Skills, function(skl, index) {
                            if (skl.UniqueId == skillModel.UniqueId) {
                                group.Skills.splice(index, 1);
                            }
                        });
                    });
                }
            }
            var groupCount = alasql('select * from ? where GroupName = ?', [contactService.contactData.PersonalSkills, match[0].Group.GroupName]);
            if (groupCount.length == 0) {
                if (_.isNil(vm.skilltype) || vm.skilltype.length == 0) {
                    let data = formatSkill(vm.skill, ReferenceNumber, Description, expiryDate, UploadFileName, null);
                    skillGroup.Skills = pushSkills(skillGroup.Skills, data);
                } else {
                    // let guid = utils.newGuid();
                    angular.forEach(vm.skilltype, function(skl) {
                        let data = formatSkill(skl, ReferenceNumber, Description, expiryDate, UploadFileName, true);
                        skillGroup.Skills = pushSkills(skillGroup.Skills, data);
                    });
                }
                contactService.contactData.PersonalSkills.push(skillGroup);
            } else {
                let matchedSkill = match[0];
                angular.forEach(contactService.contactData.PersonalSkills, function(skl) {
                    let Id = (skl.Id || skl.id);
                    if (Id === matchedSkill.Group.id) {
                        if (_.isNil(vm.skilltype) || vm.skilltype.length == 0) {
                            let data = formatSkill(vm.skill, ReferenceNumber, Description, expiryDate, UploadFileName, null);
                            skl.Skills = pushSkills(skl.Skills, data);
                        } else {
                            // let guid = utils.newGuid();
                            angular.forEach(vm.skilltype, function(skltype) {
                                let data = formatSkill(skltype, ReferenceNumber, Description, expiryDate, UploadFileName, true);
                                skl.Skills = pushSkills(skl.Skills, data);
                            });
                        }
                    }
                });
            }
            contactService.formatData();
            vm.populateContactSkills();
            if (behavior == 1) {
                $mdDialog.hide();
            }
        }

        function pushSkills(skill_group_skills_array, skills) {
            angular.forEach(skills, function(skill) {
                skill_group_skills_array.push(skill);
            });
            return skill_group_skills_array;
        }

        function onUploadStart() {
            vm.showProgress = true;
            vm.uploadAdded = true;
        }

        function onUploadSuccess(data) {
            vm.showProgress = false;
            vm.UploadFileName = data.Url[0];
            var lastIndex = vm.UploadFileName.lastIndexOf("/");
            vm.fileName = vm.UploadFileName.substring(lastIndex + 1);
        }

        function onUploadValidate(fileObj) {
            var ext = utils.getFileExtension(fileObj.name);
            var isValid = true;
            if (ext != '.jpeg' && ext != '.jpg' && ext != '.png' && ext != '.gif' && ext != '.doc' && ext != '.docx' && ext != '.pdf') {
                isValid = false;
                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(utils.translate('CONTACTSMODULE.SKILLS_INVALID_FILE'))
                    .ariaLabel(utils.translate('CONTACTSMODULE.SKILLS_INVALID_FILE'))
                    .ok(utils.translate('CONTACTSMODULE.SKILLS_OK'))
                $mdDialog.show(notif);
            }
            return isValid;
        }

        function onUploadError() {
            vm.uploadAdded = false;
        }

        function removeUpload() {
            blockUI.start(utils.translate('CONTACTSMODULE.DELETING_SKILL_MESSAGE'));
            contactService.deletefile(vm.fileName)
                .then(function(resp) {
                    vm.uploadAdded = false;
                    vm.UploadFileName = null;
                    vm.fileName = null;
                    blockUI.stop();
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.widgets')
        .controller('contactAllowanceDialogController', contactAllowanceDialogController);

    function contactAllowanceDialogController(
        $mdDialog,
        _,
        utils,
        locals
    ) {
        var vm = this;

        vm.onCancel = onCancel;
        vm.onSave = onSave;
        vm.getShiftType = getShiftType;


        function activate() {
            vm.caption = utils.translate("CONTACTSMODULE.ALLOWANCE.DIALOG.ADD_ALLOWANCE");
            vm.allowancesLookup = locals.allowancesLookup.filter(x => x.Active === true);
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function onSave() {
            $mdDialog.hide({
                AllowanceId: vm.payrollAllowance.Id
            });
        }

        function getShiftType(shiftType) {
            switch (shiftType) {
                case 1:
                    return utils.translate("CONTACTSMODULE.ALLOWANCE.DIALOG.PER_HOUR")
                case 4:
                    return utils.translate("CONTACTSMODULE.ALLOWANCE.DIALOG.PER_SHIFT")
                default:
                    return "";
            }
        }

        activate();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.contact.calendarEntry.manage', []);

})();

(function () {
    'use strict';

    angular
        .module('app.contact.calendarEntry.manage')
        .directive('calendarEntrySettings', calendarEntrySettings);

    /** @ngInject */
    function calendarEntrySettings(manageCalendarEntryService, exceptionService) {
        let directive = {
            restrict: 'E',
            templateUrl: 'app/main/contact/calendar/calendar-entry/manage/settings/calendar-entry-settings.component.html',
            scope: {
                onClose: '&',
                onSave: '&'
            },
            controller: CalendarEntrySettingsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function CalendarEntrySettingsController() {
            var vm = this;

            vm.entryTypes = [];
            vm.isLoading = false;
            vm.isSaving = false;

            vm.cancel = cancel;
            vm.save = save;

            activate();

            // ============ Implementation ============

            function activate() {
                vm.entryTypes = angular.copy(manageCalendarEntryService.entryTypeSettings) || [];

                // If no settings loaded yet, fetch them
                if (!vm.entryTypes || vm.entryTypes.length === 0) {
                    vm.isLoading = true;
                    manageCalendarEntryService.loadEntryTypeSettings()
                        .then(function (settings) {
                            vm.entryTypes = angular.copy(settings);
                        })
                        .finally(function () {
                            vm.isLoading = false;
                        });
                }
            }

            function cancel() {
                vm.onClose();
            }

            function save() {
                vm.isSaving = true;

                manageCalendarEntryService.saveEntryTypeSettings(vm.entryTypes)
                    .then(function (savedSettings) {
                        manageCalendarEntryService.entryTypeSettings = savedSettings;
                        if (vm.onSave) {
                            vm.onSave({ settings: savedSettings });
                        }
                    })
                    .catch(function (ex) {
                        exceptionService.resolve(ex);
                    })
                    .finally(function () {
                        vm.isSaving = false;
                    });
            }
        }
    }
})();

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CeTicketDetails = function (_React$Component) {
    _inherits(CeTicketDetails, _React$Component);

    function CeTicketDetails() {
        _classCallCheck(this, CeTicketDetails);

        return _possibleConstructorReturn(this, (CeTicketDetails.__proto__ || Object.getPrototypeOf(CeTicketDetails)).call(this));
    }

    _createClass(CeTicketDetails, [{
        key: 'createStyle',


        /**
         * Hard coded styles for now
         */
        value: function createStyle() {
            var css = '<style>' + 'table.simple{font-family:"Roboto","Helvetica Neue","Arial",sans-serif;width:100%;border:0;border-spacing:0;text-align:left}table.simple.clickable tr{cursor:pointer}table.simple.clickable tr:hover{background:rgba(0,0,0,0.03)}table.simple th{padding:16px 8px;font-weight:500;color:rgba(0,0,0,0.54);border-bottom:1px solid rgba(0,0,0,0.12);white-space:nowrap;min-width:120px}table.simple th:first-child{padding-left:24px}table.simple th:last-child{padding-right:24px}table.simple td{padding:9px 8px;border-bottom:1px solid rgba(0,0,0,0.12)}table.simple td:first-child{padding-left:24px}table.simple td:last-child{padding-right:24px}table.simple tr:last-child td{border-bottom:0}.invoice-table{margin-top:16pt}thead{margin-bottom:5px}th{font-size:10pt;max-width:60pt}th:first-child{padding-left:0}th:last-child{padding-right:0}td{font-size:12px;border-bottom:0;padding:5px 8px}td:first-child{padding-left:0}td:last-child{padding-right:0}tr:nth-child(odd){background-color:#f4f4f4}tr:nth-child(even){background-color:#fff}tbody:before{content:"-";display:block;line-height:1em;color:transparent}.title{font-size:10pt}.detail{margin-top:4pt;font-size:9pt;max-width:none}.qty-col{width:100px}.unit-price-col{width:120px}.amt-col{width:130px}.start-time-col{width:180px}.end-time-col{width:180px}.hrs-col{width:180px}' + '</style>';
            return css;
        }
    }, {
        key: 'popWindow',
        value: function popWindow(id) {
            var html = $('#' + id).html();
            var win = window.open("", "", "toolbar=no,scrollbars=no,resizable=no,top=100,left=100,width=1200,height=600");
            var style = this.createStyle();
            win.document.write('<html><head><title>Ticket Details</title>');
            win.document.write(style);
            win.document.write('</head><body>');
            win.document.write(html);
            win.document.write('</body></html>');
        }

        /**
         * Render view
         */

    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var pUid = _.uniqueId('parentTicketDetail');

            /**
             * Resource items
             */
            var createResourceItems = function createResourceItems(resource) {
                var uid = _.uniqueId('ticketRowDetail');

                return React.createElement(
                    'tr',
                    { key: uid },
                    React.createElement(
                        'td',
                        null,
                        resource.ItemName
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        resource.StartTime
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        resource.Break
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        resource.EndTime
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        resource.TotalHoursWorked
                    )
                );
            };

            return React.createElement(
                'div',
                { key: pUid },
                React.createElement(
                    'div',
                    { className: 'custom-tooltip' },
                    React.createElement('i', { className: 'icon-open-in-new s16', onClick: self.popWindow.bind(this, pUid) }),
                    React.createElement(
                        'span',
                        { className: 'custom-tooltiptext' },
                        'Open Details'
                    )
                ),
                React.createElement(
                    'div',
                    { id: pUid },
                    React.createElement(
                        'table',
                        { className: 'simple invoice-table invoice-resource-table' },
                        React.createElement(
                            'thead',
                            null,
                            React.createElement(
                                'tr',
                                null,
                                React.createElement(
                                    'th',
                                    null,
                                    'Resource Item'
                                ),
                                React.createElement(
                                    'th',
                                    { className: 'text-right start-time-col' },
                                    'Start Time'
                                ),
                                React.createElement(
                                    'th',
                                    { className: 'text-right end-time-col' },
                                    'Break'
                                ),
                                React.createElement(
                                    'th',
                                    { className: 'text-right end-time-col' },
                                    'End Time'
                                ),
                                React.createElement(
                                    'th',
                                    { className: 'text-right hrs-col' },
                                    'Hours'
                                )
                            )
                        ),
                        React.createElement(
                            'tbody',
                            null,
                            this.props.ticketlist.map(createResourceItems)
                        )
                    )
                )
            );
        }
    }]);

    return CeTicketDetails;
}(React.Component);

CeTicketDetails.propTypes = {
    ticketlist: React.PropTypes.array.isRequired
};
CeTicketDetails.defaultProps = {
    ticketlist: [] };
/**
 * Custom filtering
 * By Rcnet
 */
(function () {
    'use strict';
  
    angular.module('app.costEstimate.preview')
      .filter('ceCustomFilter', ceCustomFilter);
  
    function ceCustomFilter(_, alasql) {
      return function (collection, searchText) {
        var out = [];
  
        // Iterate in every search properties
        if (collection.length > 0) {
  
          if (!searchText) {
            return collection;
          }
  
          var searchKeywords = searchText.split(" "); //(/(\s+)/);
          var tmpCollection = collection;
          var allNumeric = isAllNumericKeyword(searchKeywords);
  
          if (!allNumeric) {
            searchKeywords.forEach(function (keyword) {
              if (keyword) {
                var sql = "select * from ?";
                sql += keyword != null ? " where branch like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or name like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or state like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or ticketNo like '" + keyword + "%'" : '';
                sql += keyword != null ? " or jobAddress like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or startDate like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or projectName like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or relatedTicketNumber like '%" + keyword + "%'" : '';
                var result = alasql(sql, [tmpCollection]);
  
                tmpCollection = [];
                result.forEach(function (itm) {
                  tmpCollection.push(itm);
                });
              }
            });
  
            tmpCollection.forEach(function (itm) {
              out.push(itm);
            });
  
            out = _.uniqBy(out, function (o) {
              return o.id;
            });
          } else {
            // For numeric
            searchKeywords.forEach(function (keyword) {
              if (keyword) {
                var sql = "select * from ?";
                sql += keyword != null ? " where branch like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or name like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or state like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or ticketNo like '" + keyword + "%'" : '';
                sql += keyword != null ? " or jobAddress like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or startDate like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or projectName like '%" + keyword + "%'" : '';
                sql += keyword != null ? " or relatedTicketNumber like '%" + keyword + "%'" : '';
                var result = alasql(sql, [collection]);
  
                result.forEach(function (itm) {
                  out.push(itm);
                });
              }
            });
            out = _.uniqBy(out, function (o) {
              return o.id;
            });
          }
        }
  
        function isAllNumericKeyword(keywords) {
          var f = _.filter(keywords, function (o) {
            return !isFinite(o);
          }).length;
  
          return f <= 0;
        }
  
        return out;
      }
    }
  })();
(function () {
  'use strict';

  angular
    .module('app.skillsmatrix', [
      'app.skillsmatrix.manage',
      'ngDragDrop'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

  }
})();

(function() {
    'use strict';

    angular.module('app.skillsmatrix')
        .factory('CompanySkillService', CompanySkillService);

    /** @ngInject */
    function CompanySkillService(
        skillsMatrixApi
    ) {
        var service = {
            skillsMatrixList: [],
            populateSkills: populateSkills,
            SkillGroup: []
        }

        return service;

        function populateSkills() {
            service.skillsMatrixList = [];
            skillsMatrixApi.getSkillsGroups().then(function(resp) {
                angular.forEach(resp.data, function(gvalue) {
                    angular.forEach(gvalue.Skills, function(svalue) {
                        var skill = {
                            Id: svalue.Id,
                            SkillType: svalue.SkillType,
                            SkillName: svalue.SkillName,
                            SkillLockoutType: svalue.LockoutType,
                            IsProtected: svalue.IsProtected,
                            SkillGroup: gvalue.GroupName,
                            SkillGroupId: gvalue.id
                        }
                        service.skillsMatrixList.push(skill);
                        service.skillsMatrixList = alasql('select * from ? order by SkillName', [service.skillsMatrixList]);
                    });
                });
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.contact.create')
    .directive('editDivision', function ($mdDialog) {
      return {
        restrict: 'E'
        , replace: true
        , template: '<md-icon md-svg-icon="pencil" ng-click="spawnDialog()"></md-icon>'
        , scope: {
          onShowDialog: '&'
        }
        , link: function (scope, element, attrs) {
          var division = JSON.parse(attrs.value);
          scope.spawnDialog = function () {
            $mdDialog.show({
              templateUrl: 'app/main/branch/create/template/Divisions/edit/branch-division-edit.html',
              controller: 'DivisionEditController as vmDivision',
              locals: {
                division : division
              }
            });
          }
        }
      }
    });
})
();


(function() {
    'use strict';

    angular
        .module('app.branch.create', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/branch/create');
        $stateProvider
            .state('app.branch_create', {
                url: '/branch/create-a-branch',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/branch/create/branch-create.html',
                        controller: 'BranchCreateController as vm'
                    }
                },
                title: 'Create Branch',
                data: {
                    requireLogin: true
                }
            })
            .state('app.branch_update', {
                url: '/branch/update/:id?/:branch',
                params: {
                    branch: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/branch/create/branch-create.html',
                        controller: 'BranchCreateController as vm'
                    }
                },
                title: 'Update Branch',
                data: {
                    requireLogin: true
                }
            })
    };
})();

(function () {
  'use strict';

  angular
    .module('app.branch.create')
    .controller('DivisionEditController', DivisionController);

  function DivisionController($mdDialog
                              , branchService
                              , division
                              , utils
                              , blockUI) {
    //Data
    var vm = this;
    vm.branchData = branchService.branchData;

    //Methods
    vm.onClose = onClose;
    vm.onSave = onSave;

    activate();

    function onClose(){
      $mdDialog.hide();
    }

    function activate(){
      vm.Id = division.Id;
      vm.Name = division.Name;
    }

    function onSave() {
      blockUI.instances.get('edit-division').start(utils.translate('BRANCH_CREATE.SAVING'));
      angular.forEach(vm.branchData.Division, function (value) {
        if(division.id == value.id) {
          value.Name = vm.Name;
        }
      });
      branchService.putBranch2(vm.branchData).then(reloadData);
    }

    function reloadData() {
        branchService.getBranchById(vm.branchData.id).then(function(resp) {
            branchService.branchData.mapBranchData(resp.data);
            blockUI.stop();
            $mdDialog.hide();
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.contact.create')
    .directive('addDivision', function ($mdDialog) {
      return {
        restrict: 'E'
        , replace: true
        , template: '<a href="#" ng-click="spawnDialog()">Add Division</a>'
        , link: function (scope) {
          scope.spawnDialog = function () {
            $mdDialog.show({
              templateUrl: 'app/main/branch/create/template/Divisions/add/branch-division.html',
              controller: 'DivisionController as vmDivision'
            });
          }
        }
      }
    });
})
();


(function () {
  'use strict';

  angular
    .module('app.branch.create')
    .controller('DivisionController', DivisionController);

  function DivisionController($mdDialog,
                              utils,
                              branchService,
                              blockUI) {
    //Data
    var vm = this;
    vm.branchData = branchService.branchData;

    //Methods
    vm.onClose = onClose;
    vm.onSave = onSave;

    function onClose(){
      $mdDialog.hide();
    }

    function onSave(){
      blockUI.instances.get('add-division').start(utils.translate('BRANCH_CREATE.SAVING'));

      var division = {
        Name : vm.Name
      }

      vm.branchData.Division.push(division);
      branchService.putBranch2(vm.branchData).then(reloadData);
    }

    function reloadData() {
        branchService.getBranchById(vm.branchData.id).then(function(resp) {
            branchService.branchData.mapBranchData(resp.data);
            blockUI.stop();
            $mdDialog.hide();
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.awards.view', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.awards_view', {
      url: '/awards/view-awards',
      views: {
        'content@app': {
          templateUrl: 'app/main/awards/manage/awards/awards-view.html',
          controller: 'OldAwardsViewController as vm'
        }
      },
      data: {
        requireLogin: true,
        validateAccess: ['adminClaimsService', function (adminClaimsService) {
          return adminClaimsService.hasManageAwardsMenu;
        }]
      },
      title: 'Manage Awards',
      titleBar: 'Alloc8 - View Awards'
    });
  }

})();

(function(){
  'use strict';

  angular.module('app.awards.view')
    .directive('shiftsComponent', shiftsComponent);

  function shiftsComponent() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/awards/manage/awards/components/shiftRoles/shifts-component.html'
    };

    return directive;
  }
})();

(function(){
  'use strict';

  angular.module('app.awards.view')
    .directive('classificationsComponent', classificationsComponent);

  function classificationsComponent() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/awards/manage/awards/components/classifications/classifications-component.html'
    };

    return directive;
  }
})();

(function(){
  'use strict';

  angular.module('app.awards.view')
    .directive('awardsComponent', awardsComponent);

  function awardsComponent() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/awards/manage/awards/components/awards/awards-component.html'
    };

    return directive;
  }
})();

/**
 * Item module
 * Created date: 6.24.2016
 */
(function () {
    'use strict';

    angular
        .module('app.assets.manage.shift', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.manage_shift', {
            url: '/assets/manage/shift',
            views: {
                'content@app': {
                    templateUrl: 'app/main/assets/manage/item/item.default.html',
                    controller: 'ItemController as itemVm'
                }
            },
            resolve: {
                itemManagerResolver: itemManagerResolver
            },
            data: {
                requireLogin: true,
                source: 'people'
            },
            title: 'Create Shift Type',
            titleBar: 'Alloc8 - Shift Types'
        }).state('app.manage_shift_update', {
            url: '/assets/manage/shift/update/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/assets/manage/item/item.default.html',
                    controller: 'ItemController as itemVm'
                }
            },
            resolve: {
                itemManagerResolver: itemManagerResolver
            },
            title: 'Update Shift Type',
            titleBar: 'Alloc8 - Shift Types',
            data: {
                requireLogin: true,
                source: 'people'
            }
        }).state('app.shift_view_items', {
            url: '/shift/view-types',
            views: {
                'content@app': {
                    templateUrl: 'app/main/assets/manage/shift/view/shift-view.html',
                    controller: 'ShiftTypesViewController as itemGridVm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManageShiftTypes;
                }]
            },
            title: 'Manage Shift Types',
            titleBar: 'Alloc8 - Shift Types'
        });
        $translatePartialLoaderProvider.addPart('app/main/assets');
    };

    /** @ngInject */
    function itemManagerResolver(itemManagerService) {
        return itemManagerService.loadLookups();
    }
})();

(function () {
    'use strict';

    angular.module('app.assets.manage.shift')
        .factory('shiftTypeViewService', shiftTypeViewService);

    /** @ngInject */
    function shiftTypeViewService(itemGridService,
        blockUI,
        $q,
        utils,
        oldAwardAPI) {

        var service = {
            shiftTypes: [],
            awards: [],
            query1: null,
            load: load
        };

        return service;

        function load() {
            blockUI.start(utils.translate('ASSETSMODULE.SHIFT_VIEW_LOADING'));
            $q.all([itemGridService.loadGridData(), oldAwardAPI.getAwards()])
                .then(function (resp) {
                    service.shiftTypes = _.filter(resp[0], {
                        ItemTypes: 'People'
                    });
                    service.awards = resp[1].data;
                    blockUI.stop();
                })
                .catch(function () {
                    blockUI.stop();
                });
        }

    }

})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.vehicle', [
            'app.vehicle.manage',
            'ngDragDrop'
        ])
        .config(config);

    /** @ngInject */
    function config ($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        //
    }
})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular.module('app.vehicle')
        .factory('VehicleService', VehicleService);

    /** @ngInject */
    function VehicleService (VehicleModel) {
        var service = {
            vehicleMakeData: new VehicleMakeModel(),
            vehicleModelData: new vehicleModelData()
        };
        return service;
    }
})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular.module('app.vehicle')
        .service('VehicleModelModel', VehicleModelModel);
    /** @ngInject */
    function VehicleModelModel () {
        return function () {
            var self = this
                , defaults = {
                    Id: null
                    , Model: null
                    , CreatedDate: utils.jsDateTimeToEpoch(new Date())
                    , UpdatedDate: utils.jsDateTimeToEpoch(new Date())
                };

            self.map = mapper;
            self.map();
            function mapper (options) {
                var mapValue = options || defaults
                    , opts = angular.extend({}, defaults, mapValue);
                self.Id = opts.Id;
                self.Model = opts.Model;
                self.CreatedDate = utils.jsDateTimeToEpoch(new Date());
                self.UpdatedDate = utils.jsDateTimeToEpoch(new Date());
            }
        }
    }
})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular.module('app.vehicle')
        .service('VehicleMakeModel', VehicleMakeModel);
    /** @ngInject */
    function VehicleMakeModel () {
        return function () {
            var self = this
                , defaults = {
                    Id: null
                    , Make: null
                    , CreatedDate: utils.jsDateTimeToEpoch(new Date())
                    , UpdatedDate: utils.jsDateTimeToEpoch(new Date())
                };

            self.map = mapper;
            self.map();
            function mapper (options) {
                var mapValue = options || defaults
                    , opts = angular.extend({}, defaults, mapValue);
                self.Id = opts.Id;
                self.Make = opts.Make;
                self.CreatedDate = utils.jsDateTimeToEpoch(new Date());
                self.UpdatedDate = utils.jsDateTimeToEpoch(new Date());
            }
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('app.training', [
			'app.training.manage',
			'ngDragDrop'
		])
		.config(config);

	/** @ngInject */
	function config ($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		//
	}
})();

(function () {
  'use strict';

  angular.module('app.training')
    .factory('TrainingService', TrainingService);

  /** @ngInject */
  function TrainingService(TrainingModel) {

    var service = {
      trainingData : new TrainingModel()
    }

    return service;

  }
})();

/**
 * Created by ALTUS on 5/27/2016.
 */
(function () {
  'use strict';

  angular.module('app.training')
    .service('TrainingModel', TrainingModel);

  /** @ngInject */
  function TrainingModel() {
    return function () {
      var self = this
        , defaults = {
          Id: null
        , TrainingName: null
        , TrainingType: null
        , CreatedDate: utils.jsDateTimeToEpoch(new Date())
        , UpdatedDate: utils.jsDateTimeToEpoch(new Date())
      };

      self.map = mapper;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend({}, defaults, mapValue);
            self.Id = opts.Id;
            self.TrainingName = opts.TrainingName;
            self.TrainingType = opts.TrainingType;
            self.ExpiryIsMandatory = opts.ExpiryIsMandatory;
            self.CreatedDate = utils.jsDateTimeToEpoch(new Date());
            self.UpdatedDate = utils.jsDateTimeToEpoch(new Date());
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.skillsmatrix')
    .factory('SkillService', SkillService);

  /** @ngInject */
  function SkillService(SkillModel) {

    var service = {
      skillData : new SkillModel()
    }

    return service;

  }
})();

/**
 * Created by ALTUS on 5/27/2016.
 */
(function () {
  'use strict';

  angular.module('app.skillsmatrix')
    .service('SkillModel', SkillModel);

  /** @ngInject */
  function SkillModel() {
    return function () {
      var self = this
        , defaults = {
          Id: null
        , SkillName: null
        , SkillType: null
        , LockoutType: null
        , IsProtected: null
        , CreatedDate: utils.jsDateTimeToEpoch(new Date())
        , UpdatedDate: utils.jsDateTimeToEpoch(new Date())
      };

      self.map = mapper;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend({}, defaults, mapValue);
            self.Id = opts.Id;
            self.SkillName = opts.SkillName;
            self.SkillType = opts.SkillType;
            self.LockoutType = opts.LockoutType;
            self.ExpiryIsMandatory = opts.ExpiryIsMandatory;
            self.IsProtected = opts.IsProtected;
            self.CreatedDate = utils.jsDateTimeToEpoch(new Date());
            self.UpdatedDate = utils.jsDateTimeToEpoch(new Date());
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.skill_status_report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.skill_status_report', {
                url: '/view-specific-report/skill-status',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/reporting/view/report/skillStatus/skill-status-report.html',
                        controller: 'SkillStatusReportController as vm'
                    }
                },
                data: {
                    requireLogin: true,
                    validateAccess: ['adminClaimsService', function(adminClaimsService) {
                        return adminClaimsService.hasEmployeeReportsAccess;
                    }]
                },
                title: 'Skill Status Report',
                titleBar: 'Alloc8 - Skill Status Report'
            });

        $translatePartialLoaderProvider.addPart('app/main/reporting/view/report/skillStatus');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.skill_status_report')
        .controller('SkillStatusReportController', SkillStatusReportController);

    /** @ngInject */
    function SkillStatusReportController($scope, $translate, DTColumnDefBuilder, _, searchDelay, blockUI, branchService, skillStatusReportService) {
        const SKILL_STATUS_INDIVIDUAL_VIEW = "1";

        var vm = this;
        vm.branchTitle = '';
        vm.regeneratingView = false;
        vm.isGroupView = false;
        vm.selectedBranchText = "";
        vm.service = skillStatusReportService;
        vm.reportJobId = "";
        vm.skillStatusReportStatus = 0;
        vm.viewOption = SKILL_STATUS_INDIVIDUAL_VIEW;
        vm.lookups = {
            branches: null
        };

        //default view
        vm.gridModel = skillStatusReportService.defaultDataView;
        vm.dtInstance = {};
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            lengthMenu: [
                [10, 50, 100, -1],
                [10, 50, 100, "All"]
            ],
            lengthChange: true,
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            initComplete: function() {
                searchTable();
            }
        };
        vm.dtColumns = [
            DTColumnDefBuilder.newColumnDef(0).withClass('all'),
            DTColumnDefBuilder.newColumnDef(4).withClass('all')
        ];

        //group view
        vm.gridModelGroup = skillStatusReportService.groupDataView;
        vm.dtInstanceGroup = {};
        vm.dtOptionsGroup = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            lengthMenu: [
                [10, 50, 100, -1],
                [10, 50, 100, "All"]
            ],
            lengthChange: true,
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            initComplete: function() {
                searchTable();
            }
        };
        vm.dtColumnsGroup = [
            DTColumnDefBuilder.newColumnDef(0).withClass('all'),
            DTColumnDefBuilder.newColumnDef(3).withClass('all')
        ];

        vm.searchTable = searchTable;
        vm.getSelectedText = getSelectedText;
        vm.generate = generate;
        vm.getGroupSkillsCss = getGroupSkillsCss;;

        activate();

        async function activate() {
            blockUI.start();

            $translate('REPORT.BRANCHES')
                .then(function(translation) {
                    vm.branchTitle = translation;
                });
            skillStatusReportService.register();
            vm.lookups.branches = await branchService.getBranchesAndStates();
            await skillStatusReportService.generateSkillStatusReport();

            blockUI.stop();
        }

        function searchTable() {
            if (_.isNil(vm.service.query)) {
                return;
            }

            if (!vm.isGroupView) {
                setTimeout(function() {
                    vm.dtInstance.DataTable.search(vm.service.query);
                    vm.dtInstance.DataTable.search(vm.service.query).draw();
                }, searchDelay);
                return;
            } else {
                setTimeout(function() {
                    vm.dtInstanceGroup.DataTable.search(vm.service.query);
                    vm.dtInstanceGroup.DataTable.search(vm.service.query).draw();
                }, searchDelay);
            }
        }

        function getSelectedText(selected, title) {
            if (!selected || selected.length === 0) {
                return vm.branchTitle;
            }

            var selectedItems = selected;
            var displayText = "";

            for (var i = 0; i < selectedItems.length; i++) {
                var match;
                if (selectedItems[i].indexOf('-state') !== -1) {
                    var _id = selectedItems[i].substr(0, selectedItems[i].indexOf("-state"));
                    match = alasql('SELECT Name FROM ? WHERE Id = ? AND State IS NULL', [vm.lookups.branches, _id]);
                } else {
                    match = alasql('SELECT Name FROM ? WHERE Id = ? AND State IS NOT NULL', [vm.lookups.branches, selectedItems[i]]);
                }
                if (match[0])
                    displayText += (displayText != "" ? ", " : "") + match[0].Name;
            }
            vm.selectedBranchText = displayText;
            return displayText;
        };

        function generate() {
            if (!vm.service.reportIsGenerated || vm.regeneratingView) {
                return;
            }

            vm.regeneratingView = true;
            blockUI.start();
            var skillStatusRecords = null;


            if (vm.viewOption === SKILL_STATUS_INDIVIDUAL_VIEW) {
                vm.isGroupView = false;

                skillStatusRecords = angular.copy(skillStatusReportService.defaultDataView);
            } else {
                vm.isGroupView = true;

                if (skillStatusReportService.groupDataView.length < 1) {
                    skillStatusReportService.mapToGroupView();
                }

                skillStatusRecords = angular.copy(skillStatusReportService.groupDataView);
            }

            //filter branch
            if (vm.lookups.branches && vm.lookups.branches.length > 0 && vm.selectedBranchText) {
                const selectedBranchList = vm.selectedBranchText.split(',');

                if (selectedBranchList.length > 0) {
                    var filteredSkillStatusRecord = [];

                    angular.forEach(skillStatusRecords, function(item) {
                        const itemBranchNamesList = item.branches.split(',');
                        var breakout = false;

                        for (var i = 0; i < selectedBranchList.length; i++) {
                            if (breakout) {
                                break;
                            }

                            for (var j = 0; j < itemBranchNamesList.length; j++) {
                                var match = selectedBranchList[i].trim() === itemBranchNamesList[j].trim();;

                                if (match) {
                                    breakout = true;
                                    filteredSkillStatusRecord.push(item);
                                    break;
                                }
                            }
                        }
                    });
                    skillStatusRecords = filteredSkillStatusRecord;
                }
            }

            if (vm.isGroupView) {
                vm.regeneratingView = false;
                vm.gridModelGroup = skillStatusRecords;
                vm.dtInstanceGroup.reloadData();
                blockUI.stop();
                return;
            }

            vm.regeneratingView = false;
            vm.gridModel = skillStatusRecords;
            vm.dtInstance.reloadData();
            blockUI.stop();
        }

        function getGroupSkillsCss(backgroundCssColor, isFirst, isLast) {
            if (isFirst && isLast) {
                return backgroundCssColor + ' only-one-skill';
            }

            if (isFirst) {
                return backgroundCssColor + ' top-skill';
            }

            if (isLast) {
                return backgroundCssColor + ' bottom-skill';
            }

            return backgroundCssColor;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.skill_status_report')
        .factory('skillStatusReportService', skillStatusReportService);

    /** @ngInject */
    function skillStatusReportService(
        $http,
        $rootScope,
        reportsApi,
        utils,
        localisationService,
        exceptionService,
        signalRService
    ) {
        const CURRENT_SKILL_COLOR = "current-skill-bg-color";
        const EXPIRING_SKILL_COLOR = "expiring-skill-bg-color";
        const EXPIRED_SKILL_COLOR = "expired-skill-bg-color";
        const LAPSED_SKILL_COLOR = "lapsed-skill-bg-color";
        var isInitialized = false; // To prevent double subscription to event

        var service = {
            reportIsGenerated: false,
            skillStatusReportData: {},
            reportData: {},
            defaultDataView: [],
            groupDataView: [],
            register: register,
            generateSkillStatusReport: generateSkillStatusReport,
            mapToGroupView: mapToGroupView
        };

        activate();

        return service;

        function activate() {
            var localeSettings = localisationService.getLocaleFormatSettings();
            service.expiryDateFormat = localeSettings.shortdateFormatWithSlash;
        }

        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {
            service.reportIsGenerated = false;
            if (!signalRService.isConnected) {
                $rootScope.$on('signalR_OnConnected', function() {
                    if (!isInitialized) {
                        registerSkillStatusReportStatusEvent();
                        isInitialized = true;
                    }
                });
                return;
            }

            if (!isInitialized) {
                registerSkillStatusReportStatusEvent();
                isInitialized = true;
            }
        }

        function registerSkillStatusReportStatusEvent() {
            signalRService.messageHub.on('skillStatusReportRequestCallback', function(response) {
                skillStatusReportStatusCallback(response)
            });
        }

        function skillStatusReportStatusCallback(response) {
            service.skillStatusReportData = JSON.parse(angular.toJson(response));

            service.reportIsGenerated = (service.skillStatusReportData.JobStatus === "Generated");

            if (!service.reportIsGenerated) {
                return;
            }

            $http({
                method: 'GET',
                url: service.skillStatusReportData.ReportDataUrl,
                responseType: 'json',
                skipInterceptor: true
            }).then(function(response) {
                service.reportData = response.data;
                mapToDefaultView();
            }).catch(function(ex) {
                exceptionService.resolve(ex);
            });

        }

        function mapToDefaultView() {

            if (!service.reportData) {
                return;
            }

            const hasReportData = service.reportData.Rows.length > 0;

            if (hasReportData) {
                if (service.defaultDataView.length > 1) {
                    service.defaultDataView.splice(0, service.defaultDataView.length);
                }

                service.reportData.Rows.forEach(itm => {
                    const bgColor = expiryDateColor(itm.ExpiryDate);
                    const mappedItem = {
                        employee: itm.FirstName + ' ' + itm.LastName,
                        branches: itm.BranchNames,
                        skillGroup: itm.SkillGroup,
                        skill: itm.Skill,
                        skillBgColor: bgColor,
                        skillStatus: formatExpiryDate(itm.ExpiryDate),
                        skillStatusSortValue: getSkillStatusSortValue(itm.ExpiryDate),
                        skillStatusTooltip: getSkillStatusToolTip(bgColor)
                    };
                    service.defaultDataView.push(mappedItem);
                });
            }
        }

        function getSkillStatusSortValue(expiryDate) {
            return expiryDate ? moment(expiryDate, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYYMMDD') : null;
        }

        function getSkillStatusToolTip(bgColor) {
            switch (bgColor) {
                case CURRENT_SKILL_COLOR:
                    return "REPORT.SKILL_STATUS_REPORT.SKILL_STATUS_TOOLTIP.CURRENT"

                case EXPIRING_SKILL_COLOR:
                    return "REPORT.SKILL_STATUS_REPORT.SKILL_STATUS_TOOLTIP.EXPIRING";

                case EXPIRED_SKILL_COLOR:
                    return "REPORT.SKILL_STATUS_REPORT.SKILL_STATUS_TOOLTIP.EXPIRED";

                case LAPSED_SKILL_COLOR:
                default:
                    return "REPORT.SKILL_STATUS_REPORT.SKILL_STATUS_TOOLTIP.LAPSED";

            }
        }

        function formatExpiryDate(expiryDate) {
            if (!expiryDate) {
                return utils.translate("REPORT.NO_EXPIRY");
            }

            return moment(expiryDate, 'YYYY-MM-DD[T]HH:mm:ss').format(service.expiryDateFormat);
        }

        function getDateDiff(expiryDate, today) {
            const fromDate = moment(expiryDate, 'YYYY-MM-DD[T]HH:mm:ss');
            return fromDate.diff(moment(today).format("YYYY-MM-DD"), 'days');
        }

        function expiryDateColor(expiryDate) {
            if (!expiryDate)
                return CURRENT_SKILL_COLOR;

            const diffInDays = getDateDiff(expiryDate, new Date());

            if (diffInDays > 14) {
                return CURRENT_SKILL_COLOR;
            }

            if (diffInDays > 0 && diffInDays <= 14) {
                return EXPIRING_SKILL_COLOR;
            }

            if (diffInDays <= 0 && diffInDays > -29) {
                return EXPIRED_SKILL_COLOR;
            }

            return LAPSED_SKILL_COLOR;
        }

        async function generateSkillStatusReport() {
            const response = await reportsApi.generateSkillStatusReport();
            return response.data;
        }

        function mapToGroupView() {
            if (service.defaultDataView.length === 0) {
                return;
            }

            service.groupDataView = [];

            const firstRecord = service.defaultDataView[0];
            var employee = firstRecord.employee;
            var branches = firstRecord.branches;
            var skillGroup = firstRecord.skillGroup;

            var skillList = [{
                skill: firstRecord.skill,
                skillBgColor: firstRecord.skillBgColor,
                skillStatus: firstRecord.skillStatus,
                skillStatusTooltip: firstRecord.skillStatusTooltip
            }];

            if (service.defaultDataView.length === 1) {
                service.groupDataView.push({
                    employee: employee,
                    branches: branches,
                    skillGroup: skillGroup,
                    skillList: skillList
                });
            }

            for (var i = 1; i < service.defaultDataView.length; i++) {
                const item = service.defaultDataView[i];

                const isDifferentRecord = (employee !== item.employee || branches !== item.branches || skillGroup !== item.skillGroup);
                const isLastRecord = i + 1 === service.defaultDataView.length;

                if (isDifferentRecord || isLastRecord) {
                    if (isLastRecord) {
                        skillList.push({
                            skill: item.skill,
                            skillBgColor: item.skillBgColor,
                            skillStatus: item.skillStatus,
                            skillStatusTooltip: item.skillStatusTooltip
                        });
                    }
                    service.groupDataView.push({
                        employee: employee,
                        branches: branches,
                        skillGroup: skillGroup,
                        skillList: skillList
                    });

                    employee = item.employee;
                    branches = item.branches;
                    skillGroup = item.skillGroup;
                    skillList = [];
                }

                skillList.push({
                    skill: item.skill,
                    skillBgColor: item.skillBgColor,
                    skillStatus: item.skillStatus,
                    skillStatusTooltip: item.skillStatusTooltip
                });
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.projects', [
      'app.projects.view',
      'app.project.create'
    ]);
})();

(function() {
    'use strict';

    angular.module('app.projects')
        .factory('editProjectService', editProjectService);

    /** @ngInject */
    function editProjectService(
        projectApi
    ) {
        var service = {
            putProject: putProject
        };

        return service;

        function putProject(payLoad) {
            return projectApi.putProject(payLoad);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.projects')
    .controller('EditProjectController', EditProjectController);

  function EditProjectController($mdDialog,
                                 branches,
                                 awards,
                                 _,
                                 blockUI,
                                 $mdToast,
                                 utils,
                                 rateCards,
                                 initialSkills,
                                 clients,
                                 editProjectService,
                                 project) {
    //Data
    var vm = this;
    vm.branchLookUp = branches;
    vm.awardsLookUp = awards;
    vm.clientsList = clients;
    vm.rateCardsList = rateCards;
    vm.awards = [];
    vm.Clients = [];
    vm.utilService = utils;
    vm.initialSkills = initialSkills;

    //Methods
    vm.onClose = onClose;
    vm.onSave = onSave;
    vm.activate = activate;
    vm.querySearch = querySearch;
    vm.branchHasChanged = branchHasChanged;

    //Implementations

    vm.activate();

    function activate(){
      vm.project = angular.copy(project);
      vm.Award = vm.project.Award;
      vm.RateCard = vm.project.RateCard;
      vm.chosenSkills = vm.project.ProjectSkills;

      if(!_.find(vm.awardsLookUp, { Name : 'Use Default Branch Award'})){
        vm.awardsLookUp.unshift({
          Id : null,
          Name : 'Use Default Branch Award'
        });
      }

      if(!_.find(vm.rateCardsList, { Name : 'Use Default Rate Card'})){
        vm.rateCardsList.unshift({
          Id : null,
          Name : 'Use Default Rate Card'
        });
      }

      if(_.isNull(vm.Award)){
        vm.Award = vm.awardsLookUp[0];
      }

      if(_.isNull(vm.RateCard)){
        vm.RateCard = vm.rateCardsList[0];
      }

      checkBranches();

      vm.Clients = vm.project.Companies;
    }

    function onClose(){
      $mdDialog.hide();
    }

    function branchHasChanged(){
      //vm.skills = vm.utilService.getBranchSkills(vm.branches, vm.initialSkills);
    }

    function querySearch(query){
      var results = alasql("select * from ? where Name like '%" + query + "%'", [vm.clientsList]);
      return results;
    }

    function onSave(){
      var block = blockUI.instances.get('edit-project');
      block.start('Saving...');
      var payLoad = formData();
      editProjectService.putProject(payLoad).then(function(resp){
        $mdDialog.hide(vm.project);
        $mdToast.show(
          $mdToast.simple()
            .textContent('Project updated.')
            .position('bottom right')
            .hideDelay(5000)
        );
      });
    }

    function formData(){
      vm.project.Branches = vm.branches;
      vm.project.Award = vm.Award;
      vm.project.RateCard = vm.RateCard;
      vm.project.Companies = vm.Clients;
      vm.project.ProjectSkills = vm.chosenSkills;

      if(vm.project.Award.Id === null){
        vm.project.Award = null;
      }

      if(vm.project.RateCard.Id === null){
        vm.project.RateCard = null;
      }

      delete vm.project["BranchesArray"];
      delete vm.project["FormattedBranches"];
      return vm.project;
    }

    function checkBranches(){
      resetBranches();
      angular.forEach(project.Branches, function(itm){
        angular.forEach(vm.branchLookUp, function(branch){
          if(branch.Name == itm.Name){
            branch['Selected'] = true;
          }
        });
      });
      vm.branchLookUp = alasql('select * from ? order by Selected desc, Name', [vm.branchLookUp]);
    }

    function resetBranches(){
      angular.forEach(vm.branchLookUp, function(branch){
          branch['Selected'] = false;
      });
    }
  }
})();

(function() {
    'use strict';

    angular.module('app.projects')
        .factory('addProjectService', addProjectService);

    /** @ngInject */
    function addProjectService(
        projectApi,
        _
    ) {
        var service = {
            postProject: postProject
        };

        return service;

        function postProject(payLoad) {
            return projectApi.postProject(payLoad);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.projects')
    .controller('AddProjectController', AddProjectController);

  function AddProjectController($mdDialog,
                                branches,
                                _,
                                utils,
                                $mdToast,
                                awards,
                                addProjectService,
                                initialSkills,
                                clients,
                                rateCards,
                                blockUI) {
    //Data
    var vm = this;
    vm.branchLookUp = branches;
    vm.awardsLookUp = awards;
    vm.clientsList = clients;
    vm.rateCardsList = rateCards;
    vm.awards = [];
    vm.Clients = [];
    vm.utilService = utils;
    vm.initialSkills = initialSkills;


    //Methods
    vm.onClose = onClose;
    vm.onSave = onSave;
    vm.validateBranches = validateBranches;
    vm.activate = activate;
    vm.querySearch = querySearch;
    vm.branchHasChanged = branchHasChanged;

    vm.activate();

    function querySearch(query){
      var results = alasql("select * from ? where Name like '%" + query + "%'", [vm.clientsList]);
      return results;
    }

    function onSave(){
      var block = blockUI.instances.get('add-project');
      block.start('Saving...');
      var payLoad = formData();
      addProjectService.postProject(payLoad).then(function(resp){
        $mdDialog.hide(resp.data);
        $mdToast.show(
          $mdToast.simple()
            .textContent('Project saved.')
            .position('bottom right')
            .hideDelay(5000)
        );
      });
    }

    function branchHasChanged(){
      validateBranches();
      vm.skills = vm.utilService.getBranchSkills(vm.branches, vm.initialSkills);
    }

    function activate(){
      if(!_.find(vm.awardsLookUp, { Name : 'Use Default Branch Award'})){
        vm.awardsLookUp.unshift({
          Id : null,
          Name : 'Use Default Branch Award'
        });
      }
      if(!_.find(vm.rateCardsList, { Name : 'Use Default Rate Card'})){
        vm.rateCardsList.unshift({
          Id : null,
          Name : 'Use Default Rate Card'
        });
      }
    }

    function validateBranches(){
      if(vm.branches.length == 0){
        vm.awards = [];
      }else{
        vm.awards = vm.awardsLookUp;
      }
    }

    function formData(){
      var project = {
        Name : vm.name,
        Branches : vm.branches,
        Companies : vm.Clients,
        Award : vm.Award === undefined ? null : vm.Award,
        RateCard : vm.RateCard === undefined ? null : vm.RateCard,
        ProjectSkills : vm.chosenSkills
      }

      if(project.Award){
        if(project.Award.Id === null){
          project.Award = null;
        }
      }
      if(project.RateCard){
        if(project.RateCard.Id === null){
          project.RateCard = null;
        }
      }
      return project;
    }

    function onClose(){
      $mdDialog.hide();
    }

  }
})();

/**
* Search Component
*/
(function () {
    'use strict';
    angular.module('app.paperwork.exceptions')
        .directive('paperWorkExceptionSearchBox', paperWorkExceptionSearchBox);

    /** @ngInject */
    function paperWorkExceptionSearchBox() {
        var directive = {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/main/paperworkExceptions/directives/mainView/searchBox/searchBox.html',
            controller: paperWorkExceptionSearchBoxController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function paperWorkExceptionSearchBoxController() {}

        function link() {

        }
    }
})();

(function () {
    'use strict';
    angular.module('app.paperwork.exceptions')
        .directive('paperWorkGridContainer', paperWorkGridContainer);

    /** @ngInject */
    function paperWorkGridContainer() {
        var directive = {
            restrict: 'E',
            scope: {
                refresh : '&',
                isBusy : '=',
                gridData : '=',
                loaderMessage: '=',
                handlecheckbox : '&'
            },
            templateUrl: 'app/main/paperworkExceptions/directives/mainView/gridContainer/grid-container.html',
            controller: paperWorkGridContainerController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function paperWorkGridContainerController() {
            var vm = this;
            vm.handle = handle;

            function handle(params){
                vm.handlecheckbox({params : params});
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.auth.login-v2', ['ui.router', 'satellizer', 'hj.imagesLoaded'])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, $authProvider) {

        $stateProvider.state('empty', {
            url: '/externalauth.html'
        });

        $stateProvider.state('app.pages_auth_login-v2', {
            titleBar: 'Alloc8 - Login',
            url: '/',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_login-v2': {
                    templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
                    controller: 'LoginV2Controller as vm'
                }
            },
            resolve: {
                clientLoginImages: lookupServiceResolver
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');

        //Google Client ID
        $authProvider.google({
            responseType: 'token'
        });
    }

    function lookupServiceResolver(loginService) {
        return loginService.getclientLoginImages();
    }

    /** @ngInject */
    function runConfig(refreshTokenHubService) {
        refreshTokenHubService.register();
    }

})();

(function() {
    'use strict';

    angular.module('app.pages.auth.login-v2')
        .service('refreshTokenHubService', refreshTokenHubService);

    /** @ngInject */
    function refreshTokenHubService(
        $mdToast,
        signalRService,
        $rootScope,
        identityService,
        exceptionService,
        msgboxService) {

        var service = {
            register: register
        };

        var isInitialized = false;

        return service;

        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function() {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }
        }

        function regs() {
            signalRService.messageHub.on('refreshAccount', function(data) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Refreshing account settings, please wait...')
                    .position('bottom right')
                    .hideDelay(5000)
                );

                identityService.refreshAccount()
                    .then(function(resp) {})
                    .catch(function(ex) {
                        if (ex.data.Message === 'invalid_grant') {
                            msgboxService.show('Invalid grant access. You need to re-login.')
                                .then(function() {
                                    identityService.expire();
                                });
                        } else {
                            exceptionService.resolve(ex);
                        }
                    });
            });
        }
    };
})();

(function() {
    'use strict';

    angular.module('app.pages.auth.login-v2')
        .factory('loginService', loginService);

    /** @ngInject */
    function loginService(
        $q,
        $cacheFactory,
        authApi,
        loginBackgroundApi,
        $location,
        $rootScope,
        identityService,
        exceptionService,
        signalRService,
        loginModel,
        tenantSettings,
        localisationService,
        $injector,
        $window
    ) {
        var service = {
            model: new loginModel(),
            clientLoginImages: [],
            onLogin: login,
            onLogout: logout,
            onAuthenticate: authenticate,
            getAccessToken: getAccessToken,
            getclientLoginImages: getclientLoginImages
        };

        var isLogout = false;

        activate();

        return service;

        function activate() {
            $rootScope.$on('loginService:logout', function() {
                service.onLogout();
            });
        }

        function login() {
            var data = service.model.transformToServerModelV2();
            var promise = authApi.postLogin(serializeObj(data))
                .then(success)
                .catch(failed);
            return promise;
        }

        function logout() {
            if (isLogout) {
                return;
            }

            var appInsights = $window.appInsights;
            appInsights.clearAuthenticatedUserContext();

            isLogout = true;
            signalRService.disconnect();

            identityService.expire();
            clearGlobalCache();
            location.reload();
        }

        function clearGlobalCache() {
            angular.forEach($cacheFactory.info(), function(ob, key) {
                $cacheFactory.get(key)
                    .removeAll();
            });
        }

        function success(resp) {
            var appInsights = $window.appInsights;
            appInsights.setAuthenticatedUserContext(resp.data.user.ContactId, tenantSettings.tenantKey, true);

            var localeSettings = localisationService.getLocaleFormatSettings();

            isLogout = false;
            service.model.isProcessing = 'fadeIn';
            service.model.show = false;
            service.model.showLoginError = false;
            service.model.loginError = '';
            service.model.contactId = resp.data.user.ContactId;
            service.model.dateFormat = localeSettings.shortdateFormatWithSlash;

            identityService.setUser(resp.data.user, resp.data.token, resp.data.refreshToken, service.model.rememberMe);
            identityService.setAllocationSettings(resp.data.user.AllocationSettings);
            signalRService.connect();

            var stateProvider = $injector.get('$state');
            stateProvider.go('app.dashboard');

            return resp;
        }

        function failed(ex) {
            service.model.isProcessing = 'fadeIn';
            service.model.show = false;

            exceptionService.resolve(ex, {
                intercept400: function(e, status) {
                    service.model.showLoginError = true;
                    service.model.loginError = e.data.Message;
                }
            });

            return ex;
        }

        function authenticate(provider) {
            $auth.authenticate(provider)
                .then(function() {})
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function serializeObj(obj) {
            var result = [];
            for (var property in obj) {
                result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
            }

            return result.join("&");
        }

        function getAccessToken(provider) {
            var win = window.open("", "_blank", "location=0,status=0,width=600,height=750");
            win.document.write('Loading...');

            // Use new SSO controller for Microsoft
            if (provider === 'microsoft') {
                authApi.getMicrosoftSsoLogin()
                    .then(function successCallback(response) {
                        win.location.href = response.data.authorizationUrl;
                        var timer = setInterval(function() {
                            if (win && win.closed) {
                                loadUserLogInInfo();
                                signalRService.connect();
                                clearInterval(timer);
                            }
                        }, 500);
                    }, function errorCallback(ex) {
                        win.close();
                        exceptionService.resolve(ex);
                    });
            } else {
                // Use existing OWIN flow for Google and other providers
                authApi.getExternalLogin(provider)
                    .then(function successCallback(response) {
                        var stateUrl = response.data[0].Url;
                        win.location.href = tenantSettings.coreApiUrl + stateUrl;
                        var timer = setInterval(function() {
                            if (win && win.closed) {
                                loadUserLogInInfo();
                                signalRService.connect();
                                clearInterval(timer);
                            }
                        }, 500);

                    }, function errorCallback(ex) {
                        win.close();
                        exceptionService.resolve(ex);
                    });
            }
        }

        function loadUserLogInInfo() {
            var access_token = sessionStorage.getItem("access_token");
            var refresh_token = sessionStorage.getItem("refresh_token");

            if (!access_token) {
                return;
            }

            var appInsights = $window.appInsights;

            identityService.setTokens(access_token, refresh_token);
            sessionStorage.removeItem("access_token");
            sessionStorage.removeItem("refresh_token");

            identityService.fetchUserData()
                .then(function(resp) {
                    appInsights.setAuthenticatedUserContext(resp.ContactId, tenantSettings.tenantKey, true);
                    identityService.setUser(resp, access_token, null, false);
                    $location.url('/dashboard');
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function getclientLoginImages() {
            var deferred = $q.defer();
            loginBackgroundApi.getBackgroundList()
                .then(function(resp) {
                    service.clientLoginImages = resp.data;
                    deferred.resolve(service.clientLoginImages);
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                });
            return deferred.promise;
        }
    }
})();

function keepToken(key, value) {
    sessionStorage.setItem(key, value);
}

  /**
   *  Login Model/VM
  */
(function(){
   'use strict';

   angular.module('app.pages.auth.login-v2')
          .service('loginModel', loginModel)

   function loginModel(appClientId) {

       return function(options){
          var self = this,
          defaults = {
             email: '',
             password: '',
             rememberMe: false,
             isProcessing: 'fadeIn',
             show: false,
             showLoginError: false,
             loginError: '',
             contactId: null
          };

         self.map = mapper;
         self.transformToServerModel = transformToModel;
         self.transformToServerModelV2 = transformToModelV2;
         self.reset = reset;
         self.map(options);

          /**
           * Perform mapping and update model
           */
          function mapper (optionBag) {
             var mapValue = optionBag || {};
             angular.extend(this, defaults, mapValue);

            return self;
          }

          function reset() {
             self.map(null);
          }

          function transformToModel() {
              var loginData = {
                Email: this.email,
                Password: this.password,
                RememberMe: this.rememberMe
              }

              return loginData;
          }

          function transformToModelV2() {
              var loginData = {
                Email: this.email,
                Password: this.password,
                RememberMe: this.rememberMe,
                ClientId: appClientId
              }
              return loginData;
          }
       };

   };
})();

/**
 * Job Messaging module
 * Created date: 6.25.2018
 */
(function() {
    'use strict';

    angular
        .module('app.messaging.job', [])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.job_messaging_state', {
            url: '/messaging/job',
            views: {
                'content@app': {
                    templateUrl: 'app/main/messaging/jobMessaging/job-messaging.html',
                    controller: 'JobMessagingController as vm'
                }
            },
            data: { requireLogin: true },
            title: 'Job Notifications',
            titleBar: 'Alloc8 - Send Job Messages',
            resolve: {
                lookups: lookupResolver
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/messaging/jobMessaging');
    };

    /** @ngInject */
    function lookupResolver(messageLookupService) {
        return messageLookupService.loadAll();
    }

    /** @ngInject */
    function runConfig(jobMessagingHubService) {
        jobMessagingHubService.register();
    }

})();

(function () {
    'use strict';

    angular.module('app.messaging.job')
           .directive('jobMessagingGridContentComponent', jobMessagingGridContentComponent);

    /** @ngInject */
    function jobMessagingGridContentComponent($mdDialog,
                                              $q,
                                              $state,
                                              jobMessagingApi,
                                              jobMessagingGridService,
                                              contactService,
                                              messageStatusService,
                                              sendMessageService,
                                              ToastService,
                                              exceptionService,
                                              claimsUtilService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/messaging/jobMessaging/directives/jobMessagingGridContent/job-messaging-grid-content.html',
            scope: {
                checkItem: '&',
                onContextMenuClick: '&'
            },
            controller: JobMessagingGridContentController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function JobMessagingGridContentController() {
            var vm = this;

            // Data
            vm.model = jobMessagingGridService;
            vm.showHeader = true;
            vm.menuSource = [{
                    id: 0,
                    name: 'View Contact Profile'
                },
                {
                    id: 1,
                    name: 'View Message Status Log'
                },
                {
                    id: 2,
                    name: 'Send a Message'
                },
                {
                    id: 3,
                    name: 'Manage Resource Allocations'
                }
            ];
            vm.menus = [];

            // Events
            vm.addRecipient = addRecipient;
            vm.onCheckeditem = onCheckeditem;
            vm.onGetRecipientLogs = onGetRecipientLogs;
            vm.getEmailRecipients = getEmailRecipients;
            vm.contextClick = contextClick;
            vm.onMenuClick = onMenuClick;
            vm.sendMessageAll = sendMessageAll;
            vm.isSmsEnabled = claimsUtilService.isSmsEnabled();
            vm.isMenuDisabled = isMenuDisabled;

            activate();

            ///////
            function activate() {
                // Job Accepted
                let acceptedId = messageStatusService.getId('Job Accepted');
                vm.menus[acceptedId] = angular.copy(vm.menuSource);
                vm.menus[acceptedId].push({
                    id: 4,
                    name: 'Mark as Rejected'
                });

                // Job Rejected
                let rejectedId = messageStatusService.getId('Job Rejected');
                vm.menus[rejectedId] = angular.copy(vm.menuSource);
                vm.menus[rejectedId].push({
                    id: 5,
                    name: 'Mark as Accepted'
                });

                // SMS Waiting for Reply
                if (vm.isSmsEnabled) {
                    let smsWaitingId = messageStatusService.getId('SMS Waiting for Reply');
                    vm.menus[smsWaitingId] = angular.copy(vm.menuSource);
                    vm.menus[smsWaitingId].push({
                        id: 6,
                        name: 'Resend as SMS'
                    });
                    vm.menus[smsWaitingId].push({
                        id: 5,
                        name: 'Mark as Accepted'
                    });
                    vm.menus[smsWaitingId].push({
                        id: 4,
                        name: 'Mark as Rejected'
                    });
                }

                // Waiting for Reply (Viewed in App)
                // Notification Send (Not Viewed)
                let notifSentNotViewedId = messageStatusService.getId('Notification Sent (Not Viewed)');
                vm.menus[notifSentNotViewedId] = angular.copy(vm.menuSource);
                vm.menus[notifSentNotViewedId].push({
                    id: 7,
                    name: 'Resend Notification'
                });
                vm.menus[notifSentNotViewedId].push({
                    id: 5,
                    name: 'Mark as Accepted'
                });
                vm.menus[notifSentNotViewedId].push({
                    id: 4,
                    name: 'Mark as Rejected'
                });

                let notifSentViewedId = messageStatusService.getId('Notification Sent (Awaiting Response)');
                vm.menus[notifSentViewedId] = angular.copy(vm.menuSource);
                vm.menus[notifSentViewedId].push({
                    id: 7,
                    name: 'Resend Notification'
                });
                vm.menus[notifSentViewedId].push({
                    id: 5,
                    name: 'Mark as Accepted'
                });
                vm.menus[notifSentViewedId].push({
                    id: 4,
                    name: 'Mark as Rejected'
                });

                // Failed to Send
                let failedToSendId = messageStatusService.getId('Failed to Send');
                vm.menus[failedToSendId] = angular.copy(vm.menuSource);
                vm.menus[failedToSendId].push({
                    id: 6,
                    name: 'Resend as SMS'
                });
                vm.menus[failedToSendId].push({
                    id: 5,
                    name: 'Mark as Accepted'
                });
                vm.menus[failedToSendId].push({
                    id: 4,
                    name: 'Mark as Rejected'
                });

                // SMS to Queued
                let smsQueuedId = messageStatusService.getId('Queued to Send');
                vm.menus[smsQueuedId] = angular.copy(vm.menuSource);
                vm.menus[smsQueuedId].push({
                    id: 5,
                    name: 'Mark as Accepted'
                });
                vm.menus[smsQueuedId].push({
                    id: 4,
                    name: 'Mark as Rejected'
                });

                // Notification Not Yet Sent
                let notifNotYetSentId = messageStatusService.getId('Notification Not Sent');
                vm.menus[notifNotYetSentId] = angular.copy(vm.menuSource);
                vm.menus[notifNotYetSentId].push({
                    id: 8,
                    name: 'Send Now'
                });
                vm.menus[notifNotYetSentId].push({
                    id: 5,
                    name: 'Mark as Accepted'
                });
                vm.menus[notifNotYetSentId].push({
                    id: 4,
                    name: 'Mark as Rejected'
                });
            }

            function isMenuDisabled(menuItem, contact){
                return menuItem.id === 8 && 
                        (!contact.HasDevices || !contact.HasPushNotificationToken && 
                        (contact.isJobAccepted || contact.isJobRejected))
            }

            function getEmailRecipients(recipients) {
                const MAX_RECIPIENTS_TO_SHOW = 4;
                let emailRecipientsArr = [];

                recipients.forEach(function (itm) {
                    emailRecipientsArr.push(itm.Email);
                });

                let emailRecipients = recipients.length > MAX_RECIPIENTS_TO_SHOW ?
                    _.slice(emailRecipientsArr, 0, MAX_RECIPIENTS_TO_SHOW).join('; ') :
                    emailRecipientsArr.join('; ');

                return emailRecipients;
            }

            function addRecipient(id, companyName, emailRecipients, companyId) {

                $mdDialog.show({
                    templateUrl: 'app/main/messaging/jobMessaging/dialogs/recipient/recipient.html',
                    controller: 'ManageRecipientDialogController',
                    controllerAs: 'vm',
                    locals: {
                        id: id,
                        name: companyName,
                        recipients: emailRecipients,
                        companyId: companyId
                    },
                    multiple: true
                }).then(function (recipient) {

                }, function (resp) {

                });
            }

            function onCheckeditem(id) {
                (vm.checkItem || angular.noop)({
                    id: id
                });
            }

            function onGetRecipientLogs(id, invNumber, emailRecipients) {

                $mdDialog.show({
                    templateUrl: 'app/main/messaging/jobMessaging/dialogs/recipient-logs/recipient-log.html',
                    controller: 'RecipientLogsDialogController',
                    controllerAs: 'vm',
                    locals: {
                        id: id,
                        invoiceNumber: invNumber,
                        recipients: emailRecipients
                    },
                    multiple: true
                }).then(function (recipient) {

                }, function (resp) {

                });
            }

            /**
             * Context Menu handler
             */
            function contextClick(menuOption, contact, jobMessage) {
                switch (menuOption.id) {
                    case 0:
                        contactService.showContactDetails(contact.ContactId);
                        break;
                    case 1:
                        showMessageLogs(contact.Id, contact.ContactId);
                        break;
                    case 2:
                        sendMessageService.open([contact]);
                        break;
                    case 3:
                        openResourceAlloc({
                            id: jobMessage.Id,
                            ticketNo: jobMessage.TicketNumber
                        });
                        break;
                    case 4:
                        rejectingJob(contact.Id, contact.ContactId, contact.Name);
                        break;
                    case 5:
                        acceptJob(contact.Id, contact.ContactId, contact.Name);
                        break;
                    case 6:
                        resendSms(contact.Id, contact.ContactId);
                        break;
                    case 7:
                        resendNotif(contact.Id, contact.ContactId);
                        break;
                    case 8:
                        (vm.onContextMenuClick || angular.noop)({
                            contextParam: {
                                contextMenuId: 8,
                                ariId: contact.Id
                            }
                        });
                        break;
                }
            }

            function resendSms(id, cId) {
                ToastService.toast('Re-sending SMS.');
                jobMessagingApi.resendNotification(id, cId, true)
                    .then(function (resp) {
                        ToastService.toast('Done re-sending SMS.');
                    }).catch(function (ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function resendNotif(id, cId) {
                ToastService.toast('Re-sending notification.');
                jobMessagingApi.resendNotification(id, cId, false)
                    .then(function (resp) {
                        ToastService.toast('Done re-sending notification.');
                    }).catch(function (ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function acceptJob(ariId, contactId, name) {
                ToastService.toast('Accepting job of ' + name);
                jobMessagingApi.acceptRejectJob(ariId, {
                    AllocatedContactId: contactId,
                    AcceptJob: true
                }).then(function (resp) {
                    ToastService.toast('Done accepting job.');
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                });
            }

            function rejectingJob(ariId, contactId, name) {
                ToastService.toast('Rejecting job of ' + name);
                jobMessagingApi.acceptRejectJob(ariId, {
                    AllocatedContactId: contactId,
                    AcceptJob: false
                }).then(function (resp) {
                    ToastService.toast('Done rejecting job.');
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                });
            }

            function openResourceAlloc(value) {
                $state.go('app.allocate', {
                    id: value.id,
                    ticketNo: value.ticketNo
                });
            }

            function showMessageLogs(ariId, contactId) {
                var deferred = $q.defer();

                $mdDialog.show({
                    templateUrl: 'app/main/messaging/jobMessaging/dialogs/message-status-logs/message-dialog.html',
                    controller: 'MessageDialogController',
                    controllerAs: 'vm',
                    locals: {
                        id: ariId,
                        cId: contactId
                    },
                    multiple: true
                }).then(function (resp) {
                    deferred.resolve(resp);
                }, function () {
                    deferred.resolve('oks!');
                });

                return deferred.promise;
            }

            function onMenuClick(menu, e) {
                menu.open(e);
            }

            function sendMessageAll(contacts) {
                sendMessageService.open(contacts);
            }
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.messaging.job')
        .directive('jobMessagingContentViewComponent', jobMessagingContentViewComponent);

    /** @ngInject */
    function jobMessagingContentViewComponent(
        $window,
        jmVirtualRepeatFixService,
        messageLookupService,
        utils,
        claimsUtilService
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/messaging/jobMessaging/directives/jobMessagingContent/job-messaging-content-view.html',
            scope: {
                api: '=',
                onCheckToggle: '&',
                onDownloadInvoice: '&',
                onSendMessage: '&',
                onOpenIssue: '&',
                onCheckSingleItem: '&',
                onSelectViewType: '&',
                onSort: '&',
                onContextMenuClick: '&',
                onAcceptShifts: '&'
            },
            controller: JobMessagingContentViewController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function JobMessagingContentViewController($scope) {
            var vm = this;

            vm.utilService = utils;
            vm.initialToggle = false;
            vm.isBusy = false;
            vm.message = 'Issue';
            vm.issues = null;
            vm.gridInfo = {
                totalItems: 0,
                rawTotalItemCount: 0,
                inProgress: false,
                isFiltered: false
            };
            vm.selectedItemsCount = 0;
            vm.viewType = -1;
            vm.viewTypeDesc = 'All';
            vm.statesLookup = angular.copy(messageLookupService.data.messageStatus);
            vm.selectedStates = angular.copy(messageLookupService.data.messageStatus);
            vm.canAcceptShift = false;

            vm.checkToggle = checkToggle;
            vm.checkItem = checkItem;
            vm.downloadInvoice = downloadInvoice;
            vm.sendMessage = sendMessage;
            vm.openIssues = openIssues;
            vm.onCreditNoteChange = onCreditNoteChange;
            vm.sort = sort;
            vm.selectState = selectState;
            vm.contextMenuClick = contextMenuClick;
            vm.acceptShifts = acceptShifts;

            vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled()

            activate();

            function activate() {
                if (vm.api) {
                    vm.api.refresh = refresh;
                    vm.api.setBusy = setBusy;
                    vm.api.setInvoiceIssue = setInvoiceIssue;
                    vm.api.populateGridInfo = populateGridInfo;
                    vm.api.setNumberOfCheckedItems = setNumberOfCheckedItems;
                    vm.api.reselectViewType = reselectViewType;
                    vm.api.clearIssues = clearIssues;
                    vm.api.setShiftToAccept = setShiftToAccept;
                }

                listenForWindowResize();
                $scope.$on('$destroy', cleanUp);
            }

            function getContainerHeight() {
                var boardEl = angular.element('#job-message-wrapper');
                return boardEl.height();
            }

            function listenForWindowResize() {
                angular.element($window).bind('resize', onResize);
            }

            function onResize() {
                var boardElHeight = getContainerHeight();
                adjustHeight(boardElHeight - 10);
            }

            function adjustHeight(h) {
                var container = angular.element('#vertical-container');
                container.css("height", h + 'px');
            }

            function cleanUp() {
                window.angular.element($window).off('resize', onResize);
            }

            function setBusy(flag) {
                vm.isBusy = flag;
            }

            function selectState() {
                clearIssues();
                (vm.onSelectViewType || angular.noop)({
                    type: {
                        selectedStatus: vm.selectedStates
                    }
                });
            }

            function reselectViewType() {
                select(vm.viewType);
                clearIssues();
            }

            function refresh() {
                vm.selectedItemsCount = 0;
                vm.shiftsToAcceptCount = 0;
                vm.initialToggle = false;
                clearIssues();
                jmVirtualRepeatFixService.fixBlankSpace();
            }

            function populateGridInfo(data) {
                vm.gridInfo = data;
                var h = getContainerHeight();
                adjustHeight(h);
            }

            function checkToggle() {
                vm.initialToggle = !vm.initialToggle;
                (vm.onCheckToggle || angular.noop)({
                    toggleFlag: vm.initialToggle
                });
            }

            function checkItem(id) {
                var data = (vm.onCheckSingleItem || angular.noop)({
                    id: id
                });
                vm.selectedItemsCount = data.itemsCheckedCount;

                if (!data.hasItemsChecked) {
                    vm.initialToggle = data.hasItemsChecked;
                }
            }

            function setNumberOfCheckedItems(itemsChecked) {
                vm.selectedItemsCount = itemsChecked;
            }

            function downloadInvoice() {
                (vm.onDownloadInvoice || angular.noop)();
            }

            function sendMessage() {
                (vm.onSendMessage || angular.noop)();
            }

            function acceptShifts() {
                (vm.onAcceptShifts || angular.noop)();
            }

            function setInvoiceIssue(issues) {
                vm.issues = issues;
                vm.message = issues.length > 1 ? 'Issues' : 'Issue';
            }

            function openIssues() {
                (vm.onOpenIssue || angular.noop)({
                    issues: vm.issues
                });
            }

            function clearIssues() {
                if (vm.issues)
                    vm.issues.length = 0;
            }

            function onCreditNoteChange(state) {
                select(vm.viewType);
            }

            function sort(sortDir) {
                (vm.onSort || angular.noop)({
                    sortDir: sortDir
                });
            }

            function contextMenuClick(contextParam) {
                (vm.onContextMenuClick || angular.noop)({
                    contextParam: contextParam
                });
            }

            function setShiftToAccept(shiftsToAccept, canAcceptShift) {
                vm.shiftsToAccept = shiftsToAccept;
                vm.shiftsToAcceptCount = shiftsToAccept.length;
                vm.canAcceptShift = canAcceptShift
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.messaging.job')
        .controller('AcceptShiftsDialogController', AcceptShiftsDialogController);

    function AcceptShiftsDialogController($mdDialog, locals) {

        var vm = this;

        vm.shiftsToAcceptCount = locals.shiftsToAcceptCount;

        vm.onCancel = onCancel;
        vm.onOk = onOk;

        function onCancel() {
            $mdDialog.hide();
        }

        function onOk() {
            $mdDialog.hide('ok');
        }

    }
})();
(function() {
    'use strict';
    angular.module('app.messaging.job')
        .directive('jobMessagingCustomGridSearchComponent', jobMessagingCustomGridSearchComponent);

    /** @ngInject */
    function jobMessagingCustomGridSearchComponent() {
        var directive = {
            restrict: 'E',
            scope: {
                srcData: '=',
                onSearch: '&',
                api: '='
            },
            templateUrl: 'app/main/messaging/jobMessaging/directives/customGridSearch/job-messaging-custom-grid-search.html',
            controller: JobMessagingCustomGridSearchController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function JobMessagingCustomGridSearchController() {}

        function link($scope) {
            var vm = $scope.vm;

            if (vm.api) {
                vm.api.forceTriggerSearch = forceTriggerSearch;
            }

            $scope.$watch('vm.srcData', function(newVal) {
                if (newVal != null) {
                    (vm.onSearch || angular.noop)({
                        value: encodeURIComponent(newVal)
                    });
                }
            });

            function forceTriggerSearch() {
                (vm.onSearch || angular.noop)({
                    value: encodeURIComponent(vm.srcData)
                });
            }
        }
    }
})();

/**
* Email Grid Information Component
*/
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .directive('jobMessagingGridInfoComponent', jobMessagingGridInfoComponent);

    /** @ngInject */
    function jobMessagingGridInfoComponent() {
        var directive = {
            restrict: 'E',
            scope: {
               srcData: '='
            },
            templateUrl: 'app/main/messaging/jobMessaging/directives/customGridInfo/job-messaging-grid-info.html',
            controller: JobMessagingGridInfoController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function JobMessagingGridInfoController() {
            var vm = this;
        }

    }
})();
/**
 * Invoice Email distributor module
 * Created date: 4.05.2017
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.emailsender', [])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.invoice_email_sender', {
            url: '/invoice/reports/send_invoices',
            views: {
                'content@app': {
                    templateUrl: 'app/main/invoice/emailSender/email-sender.html',
                    controller: 'EmailSenderController as emailSenderVm'
                }
            },
            data: { 
                requireLogin: true,  
                validateAccess: ['invoiceClaimsService', function (invoiceClaimsService) {
                    return invoiceClaimsService.hasExportInvoiceMenu;
                }]
            },
            title: 'Send Invoices',
            titleBar: 'Alloc8 - Send Invoices',
            resolve: {
                lookups: lookupResolver
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/invoice');
    };

    /** @ngInject */
    function lookupResolver(invoiceLookupService) {
        return invoiceLookupService.loadAll();
    }

    /** @ngInject */
    function runConfig(invoiceDistHubService) {
        invoiceDistHubService.register();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.invoice.emailsender')
        .controller('MessageDialogController', MessageDialogController);

    function MessageDialogController($mdDialog,
        locals,
        gridMessageStatusLogsService,
        searchDelay,
        _) {

        var vm = this;

        // Data
        vm.issues = locals.issues;
        vm.message = locals.message;
        vm.isShowProceed = locals.isShowProceed;
        vm.dataGrid = gridMessageStatusLogsService;
        vm.delay = { debounce: searchDelay };

        // Events
        vm.onCancel = onCancel;
        vm.onContinue = onContinue;

        activate();

        ///////
        function activate() {
            vm.dataGrid.filterData = {id: locals.id, cId: locals.cId};
        }

        function onCancel() {
            $mdDialog.hide(null);
        }

        function onContinue() {
            $mdDialog.hide('continue');
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.messaging')
        .directive('messageSection2', messageSection);

    function messageSection() {
        var directive = {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/main/messaging/generalMessaging/sendMessageAsService/message/message.html',
            controller: messageSectionController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function messageSectionController(sendMessageService) {
            var vm = this;
            vm.service = sendMessageService;
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.messaging')
        .directive('messageContainer2', messageContainer);

    function messageContainer() {
        var directive = {
            restrict: 'E',
            scope : {
                employees : '='
            },
            controller : messageController,
            controllerAs : 'vm',
            bindToController : true,
            templateUrl: 'app/main/messaging/generalMessaging/sendMessageAsService/container/container.html',
        };

        return directive;

        function messageController(mediaQueryService){
            var vm = this;
            vm.employees = vm.employees;
            vm.mediaService = mediaQueryService;
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.messaging')
        .directive('contactsSelected2', contactsSelected);

    function contactsSelected() {
        var directive = {
            restrict: 'E',
            scope : {
                employees : '='
            },
            templateUrl: 'app/main/messaging/generalMessaging/sendMessageAsService/contacts/contacts.html',
            controller: contactsSelectedController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function contactsSelectedController($scope, _, sendMessageService) {

            var vm = this;
            vm.searchText = null;
            vm.service = sendMessageService;

            //The label id is per instance. This directive is single-instance today, but two of
            //them on one page sharing a hardcoded id would silently point aria-labelledby at
            //the wrong label.
            vm.quickFillLabelId = 'quick-fill-label-' + $scope.$id;

            //Values come from the shared constant, so they always match the group names the
            //caller supplies on sendMessageService.quickFill.groups.
            vm.quickFillOptions = [
                { value: sendMessageService.QUICK_FILL_GROUPS.ALLOCATED, label: 'MESSAGING.QUICK_FILL_ALLOCATED' },
                { value: sendMessageService.QUICK_FILL_GROUPS.ACCEPTED, label: 'MESSAGING.QUICK_FILL_ACCEPTED' }
            ];

            vm.querySearch = querySearch;

            function querySearch(search_text){
                let lowered_search_text = angular.copy(search_text.toLowerCase());
                let results = search_text ? vm.employees.filter(function(employee){
                    return employee.Name.toLocaleLowerCase().includes(lowered_search_text);
                }) : [];
                return results.length > 0 ? _.orderBy(results, ['Name', 'asc']) : results;
            }

        }
    }
})();

(function () {
    'use strict';

    angular.module('app.messaging')
        .factory('messageDialogService', messageDialogService);

    /** @ngInject */
    function messageDialogService($mdDialog, messagingService, utils) {

        var service = {
            showMessageDialog : showMessageDialog,
            searching : false,
            process_message : null,
            contacts_filter : {
                BranchId : null,
                DivisionIds : [],
                EmploymentStatus : null,
                SkillLevelId : null,
                CompanyIds : null,
                SkillIds : [],
                Date : null,
                Time : null,
                StartDate : null,
                ShiftDuration : null,
                ShiftId : null,
                TicketId : null,
                EnableLockout : false
            },
            Ticket : null
        }

        return service;

        function showMessageDialog(){
            $mdDialog.show({
                templateUrl : 'app/main/messaging/generalMessaging/components/dialog/message-dialog.html',
                controller : 'messageDialogController',
                controllerAs : 'vm',
                multiple : true,
                skipHide: true
            }).then(function(resp){
                if(resp.Data){
                    clear();
                    if(resp.Data.length === 0){
                        messagingService.showDialog(utils.translate("MESSAGING.TITLE"), utils.translate("MESSAGING.NO_CONTACTS"), utils.translate("MESSAGING.CLOSE"));
                    }else{
                        messagingService.contacts_available = resp.Data;
                        messagingService.separateSelected();
                    }
                }
            });
        }

        function clear(){
            messagingService.contacts_available = [];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.messaging')
        .controller('messageDialogController', messageDialogController);

    function messageDialogController(messagingApi, msgboxService, exceptionService, $scope, messageDialogService, $q, $timeout, $mdDialog, mediaQueryService, messagingService, _, utils, TimeLibrary) {

        var vm = this;
        vm.showFiltersArea = true;
        vm.utils = utils;
        vm.company_list = [];
        vm.selectedItem = null;
        vm.filter_by_ticket_number = false;
        vm.messagingService = messagingService;
        vm.messageDialogService = messageDialogService;
        vm.mediaService = mediaQueryService;
        vm.search_model = messageDialogService.contacts_filter;
        vm.ticket_number = null;
        vm.ticket_detail = null;
        vm.ticket_errors = ["NO_ALLOCATED_PEOPLE", "NOT_A_FULL_SERVICE", "TICKET_NOT_FOUND"];

        vm.onClose = onClose;
        vm.changeBranch = changeBranch;
        vm.itemChange = itemChange;
        vm.querySearch = querySearch;
        vm.addTicket = addTicket;
        vm.filter = filter;
        vm.changeView = changeView;
        vm.getDivisionsText = getDivisionsText;
        vm.skillsSelected = skillsSelected;
        vm.isTicketNil = isTicketNil;
        vm.isEmpty = isEmpty;
        vm.changeSearchCriteria = changeSearchCriteria;
        vm.isDisabled = isDisabled;
        vm.removeTicket = removeTicket;
        vm.getCompanies = getCompanies;

        function isDisabled(messageFilter) {
            return vm.filter_by_ticket_number ? (_.isNil(vm.ticket_detail) || vm.messageDialogService.searching || _.isNil(vm.search_model.ShiftId)) : 
                                                (messageFilter.$invalid || vm.messageDialogService.searching);
        }

        function removeTicket() {
            let defer = $q.defer;

            vm.messageDialogService.process_message = "Removing Ticket";
            vm.messageDialogService.searching = true;

            $timeout(function () {
                vm.ticket_number = null;
                vm.ticket_detail = null;

                vm.messageDialogService.process_message = "";
                vm.messageDialogService.searching = false;

                defer.resolve(true);
            }, 1500)

            return defer.promise;
        }

        function itemChange(res) {
            vm.search_model.CompanyIds = _.isNil(res) ? null : res.Id;
        }

        function changeSearchCriteria() {
            vm.filter_by_ticket_number = !vm.filter_by_ticket_number;
            vm.ticket_detail = null;
            vm.ticket_number = null;
        }

        function isTicketNil(ticket) {
            return _.isNil(ticket);
        }

        function isEmpty(ticket) {
            return ticket === "" || ticket === '';
        }

        function changeView() {
            vm.showFiltersArea = !vm.showFiltersArea;
        }

        function getDivisionsText(divisions, lookup) {
            let data = divisions.length === 0 ? utils.translate("MESSAGING.DIVISIONS") : _.filter(lookup, function (item) {
                return divisions.includes(item.Id);
            });

            if (divisions.length > 0) {
                data = limit(data.map(function (d) {
                    return d.Name
                }));
            }

            return data;
        }

        function skillsSelected(skills, lookup) {
            let data = skills.length === 0 ? utils.translate("MESSAGING.SKILLS") : _.filter(lookup, function (item) {
                return skills.includes(item.Id);
            });

            if (skills.length > 0) {
                data = limit(data.map(function (d) {
                    return d.Name
                }));
            }

            return data;
        }

        function limit(arr) {
            return arr.length > 3 ? (sliceArray(arr)) : arr.join(", ");
        }

        function sliceArray(arr){
            return arr.sort().slice(0, 3).join(", ") + " + " + hiddenArrayCount(arr);
        }

        function hiddenArrayCount(arr){
            return (arr.length - 3) + " " + moreString()
        }

        function moreString(){
            return utils.translate("MESSAGING.MORE");
        }

        function formatFilterParamaters(params) {
            if (vm.filter_by_ticket_number) {
                params.TicketId = vm.ticket_detail.TicketId;
                delete params.Date;
                delete params.Time;
                delete params.BranchId;
                delete params.DivisionIds;
                delete params.CompanyIds;
                delete params.SkillIds;
                delete params.StartDate;
                delete params.ShiftDuration;
                delete params.EnableLockout;
            }
            else {
                params.CompanyIds = params.CompanyIds != null ? params.CompanyIds.length > 0 ? [params.CompanyIds] : [] : [];
                params.StartDate = params.Date != null ? formatDateTime(utils.jsDateTime(params.Date), TimeLibrary.convertToServerTime(params.Time)) : null;
                delete params.ShiftId;
                delete params.TicketId;
                delete params.Date;
                delete params.Time;
            }

            return {
                Data: params,
                FilterByTicket: vm.filter_by_ticket_number
            };
        }

        function formatDateTime(date, time) {
            return date.substring(0, date.indexOf(" ")) + " " + time;
        }

        function filter() {
            let defer = $q.defer();

            let params = formatFilterParamaters(angular.copy(vm.search_model));

            vm.messageDialogService.process_message = utils.translate("MESSAGING.SEARCHING_PEOPLE");
            vm.messageDialogService.searching = true;

            vm.messagingService.filter(params).then(function (resp) {
                defer.resolve(resp.data);
                vm.messageDialogService.process_message = null;
                vm.messageDialogService.searching = false;
                let data = _.orderBy(resp.data, ['Name'], ['asc']);

                if (vm.mediaService.isDeviceMessagingSmall()) {
                    vm.messagingService.contacts_available = data;
                    vm.showFiltersArea = false;
                } else {
                    $mdDialog.hide({Data: data});
                }
            }).catch(function (err) {
                vm.messageDialogService.searching = false;
                exceptionService.resolve(err);
            });
        }

        function querySearch(query) {
            if(!_.isNil(vm.search_model.BranchId)){
                let branch =  getBranchName(vm.search_model.BranchId);
                return filterByNameAndBranch(query, branch, vm.company_list);
            }
        }

        function filterByNameAndBranch(query, branch_name, companies){
            return _.filter(companies, function(company){
                let does_name_matches = company.Name.toLowerCase().includes(query.toLowerCase());
                let branch_exists_in_company = company.Branches.find(function(branch) {
                    return branch.m_Item1.toLowerCase() === branch_name.toLowerCase();
                });
                return does_name_matches && branch_exists_in_company;
            })
        }

        function getBranchName(branch_id){
            let branch = vm.branch_lookup.find(function(branch){
                return branch.Id === branch_id;
            });
            return branch.Name.trim();
        }

        function addTicket(ticket) {
            vm.search_model.ShiftId = null;
            isTicketNil(ticket) ? msgboxService.show('No Ticket Added', 'Send a Message Dialog') : searchTicket(ticket);
        }

        function searchTicket(ticket) {
            vm.messageDialogService.process_message = "Searching Ticket";
            vm.messageDialogService.searching = true;
            vm.messagingService.searchByTicketNumber(ticket.toString().trim()).then(ticketFoundOnServer).catch(ticketNotFoundOnServer);
        }

        function ticketFoundOnServer(resp) {
            vm.ticket_detail = resp.data;
            vm.messageDialogService.searching = false;
            vm.messageDialogService.process_message = "";
        }

        function ticketNotFoundOnServer(err) {
            let msg = err.data.Message;
            let final_msg = evaluateError(msg) ? utils.translate("MESSAGING." + msg) : msg;
            let dialog_title = utils.translate('MESSAGING.ERROR_DIALOG');

            msgboxService.show(final_msg, dialog_title).then(function () {
                vm.messageDialogService.searching = false;
                vm.ticket_detail = null;
                vm.ticket_number = null;
            });
        }

        function evaluateError(err){
            return vm.ticket_errors.find(function(error){
                return error === err;
            });
        }

        function onClose() {
            $mdDialog.hide();
        }

        function activate() {
            vm.showFiltersArea = true;
            vm.branch_lookup = angular.copy(_.orderBy(vm.messagingService.branches, ['Name'], ['asc']));
            vm.skills_level_list = tweakLevel(angular.copy(vm.messagingService.SkillsLevel));
            vm.employment_status_list = tweak(angular.copy(vm.messagingService.EmploymentStatus));
            vm.getCompanies();
            vm.Skills_list = angular.copy(vm.messagingService.Skills);

            function tweak(statuses){
                angular.forEach(statuses, function(status){
                    if(status.Id === 0){
                        status.Name = "";
                    }
                });

                return statuses;
            }

            function tweakLevel(skills){
                skills.unshift({
                    Id : "",
                    Name : ""
                });

                return skills;
            }

            //Binding if any
            if (vm.search_model.BranchId != null) {
                vm.changeBranch(vm.search_model.BranchId);
            }

            if (vm.search_model.CompanyIds != null) {
                vm.selectedItem = _.find(vm.company_list, {Id: vm.search_model.CompanyIds});
            }
            //Binding if any

            vm.showFiltersArea = (vm.mediaService.isDeviceMessagingSmall() && vm.messagingService.contacts_available.length > 0) ? false : true;
        }

        function changeBranch(branch) {
            getCompanies();
            filterDivisions();
            vm.division_lookup = angular.copy(_.orderBy(_.filter(vm.messagingService.divisions, {BranchId: branch}), ['BranchName', 'Name'], ['asc', 'asc']));
            filterDivisions();
        }

        function getCompanies() {
            if(!_.isNil(vm.search_model.BranchId)) {
                messagingApi.getCompanies(vm.search_model.DivisionIds, vm.search_model.BranchId).then(function(resp) {
                    //List of companies returned will be populated to company_list
                    vm.company_list = resp.data;
                    checkCompany();
                });
            }
        }

        function checkCompany() {
            if(!_.isNil(vm.selectedItem)) {
                findCompany(vm.selectedItem.Id);
            }else if(!_.isNil(vm.search_model.CompanyIds)) {
                findCompany(vm.search_model.CompanyIds);
            }
        }

        function findCompany(id) {
            let company = _.find(vm.company_list, {Id : id}) ;
            if(!company) {
                //If company exists in the new branch selected, retain the company
                vm.searchText = null;
                vm.selectedItem = null;
            }else{
                vm.searchText = company.Name;
                vm.selectedItem = company;
            }
        }

        function filterDivisions() {
            if(!_.isNil(vm.search_model.DivisionIds)) {
                let currentDivisions = vm.search_model.DivisionIds.map(function(division) {
                    return {
                        Id : division,
                        Included : true
                    }
                });

                angular.forEach(currentDivisions, function(division) {
                    let match = _.find(vm.division_lookup, {Id : division.Id});
                    if(match){
                        division.Included = match.BranchId === vm.search_model.BranchId ? true : false;
                    }
                });

                vm.search_model.DivisionIds = _.filter(currentDivisions, {Included : true});
                vm.search_model.DivisionIds = vm.search_model.DivisionIds.map(function(division) {
                    return division.Id;
                });
            }
        }

        $scope.$watch('vm.mediaService.isDeviceMessagingBig()', function () {
            if (vm.mediaService.isDeviceMessagingBig()) {
                vm.showFiltersArea = true;
            }
        });

        activate();
    }
})();

(function(){
    'use strict';

    angular.module('app.messaging')
        .directive('contactsArea', contactsArea);

    function contactsArea() {
        var directive = {
            restrict: 'E',
            scope : {},
            templateUrl: 'app/main/messaging/generalMessaging/components/contactsArea/contactsArea.html',
            controller: contactsAreaController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function contactsAreaController(messagingService, mediaQueryService, _, messageDialogService) {
            var vm = this;
            vm.service = messagingService;
            vm.mediaService = mediaQueryService;
            vm.showFilterDialog = showFilterDialog;

            function showFilterDialog(){
                messageDialogService.showMessageDialog();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.lockout-settings.view')
        .service('ruleModelComponent', ruleModelComponent);

    function ruleModelComponent() {
        return {
            Id: null,
            Name: null,
            Description: null,
            CountTravelHours: false,
            StandardSettings: {
                MaxShiftLength: null,
                MaxHoursIn24HourPeriod: null,
                MaxHoursIn7DayPeriod: null,
                BreakHoursBetweenToReset: null,
                MinBreakHoursBetweenShifts: null,
                WarningMaxShiftLength: null,
                WarningMaxHoursIn24HourPeriod: null,
                WarningMaxHoursIn7DayPeriod: null,
                MaxContinuousShiftGap: null,
            },
            OverrideSettings: {
                MaxShiftLength: null,
                MaxHoursIn24HourPeriod: null,
                MaxHoursIn7DayPeriod: null,
                MinBreakHoursBetweenShifts: null,
                MaxContinuousShiftGap: null,
            },
            IsGlobalSettings: false,
            ShiftTypes: []
        }
    }
}());

(function(){
  'use strict';

  angular.module('app.lockout-settings.view')
    .directive('rulesComponent', rulesComponent);

  function rulesComponent() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/lockoutSettings/view/components/rulesList/rules-component.html',
      scope: {
        data : '=',
        loading : '='
      },
      controller : lockoutController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function lockoutController(lockoutSettingsService) {
      var vm = this;
      vm.selectRule = selectRule;
      vm.service = lockoutSettingsService;

      function selectRule(rule){
        lockoutSettingsService.select(true, rule);
      }
    }
  }
})();

(function() {
    "use strict";

    angular
        .module("app.lockout-settings.view")
        .directive("lockOutOverrideComponent", lockOutOverrideComponent);

    function lockOutOverrideComponent() {
        var directive = {
            restrict: "E",
            templateUrl: "app/main/lockoutSettings/view/components/overrideLockout/lockout-component-override.html",
            scope: {
                loading: "=",
            },
            controller: lockoutOverrideController,
            controllerAs: "vm",
            bindToController: true,
        };

        return directive;

        function lockoutOverrideController(
            lockoutSettingsService,
            utils,
            _,
            mediaQueryService
        ) {
            var vm = this;
            vm.service = lockoutSettingsService;
            vm.mediaQueryService = mediaQueryService;
            vm.utilService = utils;
            vm.validate = validate;

            function validate(newValue) {
                if (_.isNil(newValue) || newValue == "" || newValue == "") {
                    vm.service.selectedRule.Name = utils.translate(
                        "LOCKOUTSETTINGS.VIEW_NEW_RULE_NAME"
                    );
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs', [
            'app.jobs.manage',
            'app.jobs.confirmBooking',
            'app.jobs.view',
            'app.jobs.whiteBoard',
            'app.jobs.droppedAsset',
            'app.jobs.draggable',
            'app.jobs.mapView',
            'app.widgets',
            'app.jobs.ticketBilling',
            'app.related-ticket-billing-preferences',
            'app.paperwork.manage-paperwork',
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config(localStorageServiceProvider) {
        localStorageServiceProvider.setStorageType('sessionStorage');
    }

    function runConfig(
        msNavigationService,
        jobsClaimsService
    ) {
        msNavigationService.saveItem('apps.jobs', {
            title: 'Jobs',
            icon: 'icon-format-list-bulleted',
            weight: 3
        });

        msNavigationService.saveItem('apps.jobs.whiteboard', {
            title: 'Whiteboard',
            state: 'app.jobs_whiteboard',
            weight: 1
        });

        msNavigationService.saveItem('apps.jobs.resourceWhiteboard', {
            title: 'Resource Whiteboard',
            state: 'app.jobs_whiteboard_resource',
            weight: 2
        });

        msNavigationService.saveItem('apps.jobs.mapView', {
            title: 'Map View',
            state: 'app.jobs_map_view',
            weight: 3,
            hidden: function(){
                return true;
            }
        });

        msNavigationService.saveItem('apps.jobs.view', {
            title: 'View Jobs',
            state: 'app.jobs_view',
            weight: 4
        });

        msNavigationService.saveItem('apps.jobs.manage', {
            title: 'Create a New Job',
            state: 'app.jobs_manage',
            weight: 5
        });

        msNavigationService.saveItem('apps.jobs.ticketBillingPreference', {
            title: 'Ticket Billing Preference',
            state: 'app.ticket_billing',
            weight: 6,
            hidden: function() {
                return !jobsClaimsService.hasTicketBillingPreferenceMenu;
            }
        });

        msNavigationService.saveItem('apps.jobs.paperwork', {
            title: 'Manage Paperwork',
            state: 'app.manage_paperwork',
            weight: 7,
            hidden: function() {
                return !jobsClaimsService.hasManagePaperworkMenu;
            }
        });
    }
})();

/**
 * http://www.alloc8pro.com/
 * Copyright (c) 2016
 * Created on 5/10/2016
 * sangracetiu@gmail.com
 */

(function () {
  'use strict';

  angular.module('app.jobs')
    .directive('jobLocation', jobLocation);

  /** @ngInject */
  function jobLocation($mdDialog, addressModel, _) {
    var directive = {
      restrict: 'E'
      , replace: true
      , template: '<input type="text" ng-click="spawnAddressDialog()" placeholder="Job Location" ng-required="true">'
      , link: linkFunc
      , require: 'ngModel'
      , scope: {
        ngModel: '='
      }
    };

    return directive;

    function linkFunc(scope, element, attr) {
      var controller = 'JobLocationController as vm';
      var title = "Job Location";
      scope.spawnAddressDialog = spawnAddressDialog;

      activate();

      function activate() {

        // Fix issues in lodash
        if( typeof _.contains === 'undefined' ) {
          _.contains = _.includes;
        }
      }

      function spawnAddressDialog() {
        $mdDialog.show({
          parent: angular.element(document.body)
          , locals: { title: title }
          , templateUrl: 'app/main/jobs/widget/JobLocation/add/address.html'
          , controller: controller
        }).then(function(address){
          scope.ngModel = address;
        });
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.jobs')
    .controller('JobLocationController', JobLocationController);

  /** @ngInject */
  function JobLocationController($log,
                                       $scope,
                                       $mdDialog,
                                       utils,
                                       uiGmapGoogleMapApi,
                                       contactService,
                                       contactLookupsService,
                                       addressModel,
                                       locals) {

    var vm = this;
    vm.title = locals.title;
    vm.address = {};
    vm.addressTypes = []; //companyLookupService.companyLookups.AddressTypes;
    vm.usedGoogleMaps = false;
    vm.customAddressLink = true;
    vm.showCustomAddress = true;

    vm.countries = [
      {Name: 'Afghanistan', code: 'AF'},
      {Name: 'Aland Islands', code: 'AX'},
      {Name: 'Albania', code: 'AL'},
      {Name: 'Algeria', code: 'DZ'},
      {Name: 'American Samoa', code: 'AS'},
      {Name: 'Andorra', code: 'AD'},
      {Name: 'Angola', code: 'AO'},
      {Name: 'Anguilla', code: 'AI'},
      {Name: 'Antarctica', code: 'AQ'},
      {Name: 'Antigua and Barbuda', code: 'AG'},
      {Name: 'Argentina', code: 'AR'},
      {Name: 'Armenia', code: 'AM'},
      {Name: 'Aruba', code: 'AW'},
      {Name: 'Australia', code: 'AU' ,
        States : [
          {
            Name : 'ACT'
          },
          {
            Name : 'NSW'
          },
          {
            Name : 'NT'
          },
          {
            Name : 'QLD'
          },
          {
            Name : 'SA'
          },
          {
            Name : 'TAS'
          },
          {
            Name : 'VIC'
          },
          {
            Name : 'WA'
          }
        ]
      },
      {Name: 'Austria', code: 'AT'},
      {Name: 'Azerbaijan', code: 'AZ'},
      {Name: 'Bahamas', code: 'BS'},
      {Name: 'Bahrain', code: 'BH'},
      {Name: 'Bangladesh', code: 'BD'},
      {Name: 'Barbados', code: 'BB'},
      {Name: 'Belarus', code: 'BY'},
      {Name: 'Belgium', code: 'BE'},
      {Name: 'Belize', code: 'BZ'},
      {Name: 'Benin', code: 'BJ'},
      {Name: 'Bermuda', code: 'BM'},
      {Name: 'Bhutan', code: 'BT'},
      {Name: 'Bolivia', code: 'BO'},
      {Name: 'Bosnia and Herzegovina', code: 'BA'},
      {Name: 'Botswana', code: 'BW'},
      {Name: 'Bouvet Island', code: 'BV'},
      {Name: 'Brazil', code: 'BR'},
      {Name: 'British Indian Ocean Territory', code: 'IO'},
      {Name: 'Brunei Darussalam', code: 'BN'},
      {Name: 'Bulgaria', code: 'BG'},
      {Name: 'Burkina Faso', code: 'BF'},
      {Name: 'Burundi', code: 'BI'},
      {Name: 'Cambodia', code: 'KH'},
      {Name: 'Cameroon', code: 'CM'},
      {Name: 'Canada', code: 'CA'},
      {Name: 'Cape Verde', code: 'CV'},
      {Name: 'Cayman Islands', code: 'KY'},
      {Name: 'Central African Republic', code: 'CF'},
      {Name: 'Chad', code: 'TD'},
      {Name: 'Chile', code: 'CL'},
      {Name: 'China', code: 'CN'},
      {Name: 'Christmas Island', code: 'CX'},
      {Name: 'Cocos (Keeling) Islands', code: 'CC'},
      {Name: 'Colombia', code: 'CO'},
      {Name: 'Comoros', code: 'KM'},
      {Name: 'Congo', code: 'CG'},
      {Name: 'Congo, The Democratic Republic of the', code: 'CD'},
      {Name: 'Cook Islands', code: 'CK'},
      {Name: 'Costa Rica', code: 'CR'},
      {Name: 'Cote D\'Ivoire', code: 'CI'},
      {Name: 'Croatia', code: 'HR'},
      {Name: 'Cuba', code: 'CU'},
      {Name: 'Cyprus', code: 'CY'},
      {Name: 'Czech Republic', code: 'CZ'},
      {Name: 'Denmark', code: 'DK'},
      {Name: 'Djibouti', code: 'DJ'},
      {Name: 'Dominica', code: 'DM'},
      {Name: 'Dominican Republic', code: 'DO'},
      {Name: 'Ecuador', code: 'EC'},
      {Name: 'Egypt', code: 'EG'},
      {Name: 'El Salvador', code: 'SV'},
      {Name: 'Equatorial Guinea', code: 'GQ'},
      {Name: 'Eritrea', code: 'ER'},
      {Name: 'Estonia', code: 'EE'},
      {Name: 'Ethiopia', code: 'ET'},
      {Name: 'Falkland Islands (Malvinas)', code: 'FK'},
      {Name: 'Faroe Islands', code: 'FO'},
      {Name: 'Fiji', code: 'FJ'},
      {Name: 'Finland', code: 'FI'},
      {Name: 'France', code: 'FR'},
      {Name: 'French Guiana', code: 'GF'},
      {Name: 'French Polynesia', code: 'PF'},
      {Name: 'French Southern Territories', code: 'TF'},
      {Name: 'Gabon', code: 'GA'},
      {Name: 'Gambia', code: 'GM'},
      {Name: 'Georgia', code: 'GE'},
      {Name: 'Germany', code: 'DE'},
      {Name: 'Ghana', code: 'GH'},
      {Name: 'Gibraltar', code: 'GI'},
      {Name: 'Greece', code: 'GR'},
      {Name: 'Greenland', code: 'GL'},
      {Name: 'Grenada', code: 'GD'},
      {Name: 'Guadeloupe', code: 'GP'},
      {Name: 'Guam', code: 'GU'},
      {Name: 'Guatemala', code: 'GT'},
      {Name: 'Guernsey', code: 'GG'},
      {Name: 'Guinea', code: 'GN'},
      {Name: 'Guinea-Bissau', code: 'GW'},
      {Name: 'Guyana', code: 'GY'},
      {Name: 'Haiti', code: 'HT'},
      {Name: 'Heard Island and Mcdonald Islands', code: 'HM'},
      {Name: 'Holy See (Vatican City State)', code: 'VA'},
      {Name: 'Honduras', code: 'HN'},
      {Name: 'Hong Kong', code: 'HK'},
      {Name: 'Hungary', code: 'HU'},
      {Name: 'Iceland', code: 'IS'},
      {Name: 'India', code: 'IN'},
      {Name: 'Indonesia', code: 'ID'},
      {Name: 'Iran, Islamic Republic Of', code: 'IR'},
      {Name: 'Iraq', code: 'IQ'},
      {Name: 'Ireland', code: 'IE'},
      {Name: 'Isle of Man', code: 'IM'},
      {Name: 'Israel', code: 'IL'},
      {Name: 'Italy', code: 'IT'},
      {Name: 'Jamaica', code: 'JM'},
      {Name: 'Japan', code: 'JP'},
      {Name: 'Jersey', code: 'JE'},
      {Name: 'Jordan', code: 'JO'},
      {Name: 'Kazakhstan', code: 'KZ'},
      {Name: 'Kenya', code: 'KE'},
      {Name: 'Kiribati', code: 'KI'},
      {Name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
      {Name: 'Korea, Republic of', code: 'KR'},
      {Name: 'Kuwait', code: 'KW'},
      {Name: 'Kyrgyzstan', code: 'KG'},
      {Name: 'Lao People\'S Democratic Republic', code: 'LA'},
      {Name: 'Latvia', code: 'LV'},
      {Name: 'Lebanon', code: 'LB'},
      {Name: 'Lesotho', code: 'LS'},
      {Name: 'Liberia', code: 'LR'},
      {Name: 'Libyan Arab Jamahiriya', code: 'LY'},
      {Name: 'Liechtenstein', code: 'LI'},
      {Name: 'Lithuania', code: 'LT'},
      {Name: 'Luxembourg', code: 'LU'},
      {Name: 'Macao', code: 'MO'},
      {Name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
      {Name: 'Madagascar', code: 'MG'},
      {Name: 'Malawi', code: 'MW'},
      {Name: 'Malaysia', code: 'MY'},
      {Name: 'Maldives', code: 'MV'},
      {Name: 'Mali', code: 'ML'},
      {Name: 'Malta', code: 'MT'},
      {Name: 'Marshall Islands', code: 'MH'},
      {Name: 'Martinique', code: 'MQ'},
      {Name: 'Mauritania', code: 'MR'},
      {Name: 'Mauritius', code: 'MU'},
      {Name: 'Mayotte', code: 'YT'},
      {Name: 'Mexico', code: 'MX'},
      {Name: 'Micronesia, Federated States of', code: 'FM'},
      {Name: 'Moldova, Republic of', code: 'MD'},
      {Name: 'Monaco', code: 'MC'},
      {Name: 'Mongolia', code: 'MN'},
      {Name: 'Montserrat', code: 'MS'},
      {Name: 'Morocco', code: 'MA'},
      {Name: 'Mozambique', code: 'MZ'},
      {Name: 'Myanmar', code: 'MM'},
      {Name: 'Namibia', code: 'NA'},
      {Name: 'Nauru', code: 'NR'},
      {Name: 'Nepal', code: 'NP'},
      {Name: 'Netherlands', code: 'NL'},
      {Name: 'Netherlands Antilles', code: 'AN'},
      {Name: 'New Caledonia', code: 'NC'},
      {Name: 'New Zealand', code: 'NZ'},
      {Name: 'Nicaragua', code: 'NI'},
      {Name: 'Niger', code: 'NE'},
      {Name: 'Nigeria', code: 'NG'},
      {Name: 'Niue', code: 'NU'},
      {Name: 'Norfolk Island', code: 'NF'},
      {Name: 'Northern Mariana Islands', code: 'MP'},
      {Name: 'Norway', code: 'NO'},
      {Name: 'Oman', code: 'OM'},
      {Name: 'Pakistan', code: 'PK'},
      {Name: 'Palau', code: 'PW'},
      {Name: 'Palestinian Territory, Occupied', code: 'PS'},
      {Name: 'Panama', code: 'PA'},
      {Name: 'Papua New Guinea', code: 'PG'},
      {Name: 'Paraguay', code: 'PY'},
      {Name: 'Peru', code: 'PE'},
      {Name: 'Philippines', code: 'PH'},
      {Name: 'Pitcairn', code: 'PN'},
      {Name: 'Poland', code: 'PL'},
      {Name: 'Portugal', code: 'PT'},
      {Name: 'Puerto Rico', code: 'PR'},
      {Name: 'Qatar', code: 'QA'},
      {Name: 'Reunion', code: 'RE'},
      {Name: 'Romania', code: 'RO'},
      {Name: 'Russian Federation', code: 'RU'},
      {Name: 'RWANDA', code: 'RW'},
      {Name: 'Saint Helena', code: 'SH'},
      {Name: 'Saint Kitts and Nevis', code: 'KN'},
      {Name: 'Saint Lucia', code: 'LC'},
      {Name: 'Saint Pierre and Miquelon', code: 'PM'},
      {Name: 'Saint Vincent and the Grenadines', code: 'VC'},
      {Name: 'Samoa', code: 'WS'},
      {Name: 'San Marino', code: 'SM'},
      {Name: 'Sao Tome and Principe', code: 'ST'},
      {Name: 'Saudi Arabia', code: 'SA'},
      {Name: 'Senegal', code: 'SN'},
      {Name: 'Serbia and Montenegro', code: 'CS'},
      {Name: 'Seychelles', code: 'SC'},
      {Name: 'Sierra Leone', code: 'SL'},
      {Name: 'Singapore', code: 'SG'},
      {Name: 'Slovakia', code: 'SK'},
      {Name: 'Slovenia', code: 'SI'},
      {Name: 'Solomon Islands', code: 'SB'},
      {Name: 'Somalia', code: 'SO'},
      {Name: 'South Africa', code: 'ZA'},
      {Name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
      {Name: 'Spain', code: 'ES'},
      {Name: 'Sri Lanka', code: 'LK'},
      {Name: 'Sudan', code: 'SD'},
      {Name: 'Suriname', code: 'SR'},
      {Name: 'Svalbard and Jan Mayen', code: 'SJ'},
      {Name: 'Swaziland', code: 'SZ'},
      {Name: 'Sweden', code: 'SE'},
      {Name: 'Switzerland', code: 'CH'},
      {Name: 'Syrian Arab Republic', code: 'SY'},
      {Name: 'Taiwan, Province of China', code: 'TW'},
      {Name: 'Tajikistan', code: 'TJ'},
      {Name: 'Tanzania, United Republic of', code: 'TZ'},
      {Name: 'Thailand', code: 'TH'},
      {Name: 'Timor-Leste', code: 'TL'},
      {Name: 'Togo', code: 'TG'},
      {Name: 'Tokelau', code: 'TK'},
      {Name: 'Tonga', code: 'TO'},
      {Name: 'Trinidad and Tobago', code: 'TT'},
      {Name: 'Tunisia', code: 'TN'},
      {Name: 'Turkey', code: 'TR'},
      {Name: 'Turkmenistan', code: 'TM'},
      {Name: 'Turks and Caicos Islands', code: 'TC'},
      {Name: 'Tuvalu', code: 'TV'},
      {Name: 'Uganda', code: 'UG'},
      {Name: 'Ukraine', code: 'UA'},
      {Name: 'United Arab Emirates', code: 'AE'},
      {Name: 'United Kingdom', code: 'GB'},
      {Name: 'United States', code: 'US', States : [
        {
          Name : 'AL'
        },
        {
          Name : 'AK'
        },
        {
          Name : 'AS'
        },
        {
          Name : 'AZ'
        },
        {
          Name : 'AR'
        },
        {
          Name : 'CA'
        },
        {
          Name : 'CO'
        },
        {
          Name : 'CT'
        },
        {
          Name : 'DE'
        },
        {
          Name : 'FL'
        },
        {
          Name : 'GA'
        },
        {
          Name : 'HI'
        },
        {
          Name : 'ID'
        },
        {
          Name : 'IL'
        },
        {
          Name : 'IN'
        },
        {
          Name : 'IA'
        },
        {
          Name : 'KS'
        },
        {
          Name : 'KY'
        },
        {
          Name : 'LA'
        },
        {
          Name : 'ME'
        },
        {
          Name : 'MD'
        },
        {
          Name : 'MA'
        },
        {
          Name : 'MI'
        },
        {
          Name : 'MN'
        },
        {
          Name : 'MS'
        },
        {
          Name : 'MO'
        },
        {
          Name : 'MT'
        },
        {
          Name : 'NE'
        },
        {
          Name : 'NV'
        },
        {
          Name : 'NH'
        },
        {
          Name : 'NJ'
        },
        {
          Name : 'NM'
        },
        {
          Name : 'NY'
        },
        {
          Name : 'NC'
        },
        {
          Name : 'ND'
        },
        {
          Name : 'OH'
        },
        {
          Name : 'OK'
        },
        {
          Name : 'OR'
        },
        {
          Name : 'PA'
        },
        {
          Name : 'RI'
        },
        {
          Name : 'SC'
        },
        {
          Name : 'SD'
        },
        {
          Name : 'TN'
        },
        {
          Name : 'TX'
        },
        {
          Name : 'UT'
        },
        {
          Name : 'VT'
        },
        {
          Name : 'VA'
        },
        {
          Name : 'WA'
        },
        {
          Name : 'WV'
        },
        {
          Name : 'WI'
        },
        {
          Name : 'WY'
        }
      ] },
      {Name: 'United States Minor Outlying Islands', code: 'UM'},
      {Name: 'Uruguay', code: 'UY'},
      {Name: 'Uzbekistan', code: 'UZ'},
      {Name: 'Vanuatu', code: 'VU'},
      {Name: 'Venezuela', code: 'VE'},
      {Name: 'Viet Nam', code: 'VN'},
      {Name: 'Virgin Islands, British', code: 'VG'},
      {Name: 'Virgin Islands, U.S.', code: 'VI'},
      {Name: 'Wallis and Futuna', code: 'WF'},
      {Name: 'Western Sahara', code: 'EH'},
      {Name: 'Yemen', code: 'YE'},
      {Name: 'Zambia', code: 'ZM'},
      {Name: 'Zimbabwe', code: 'ZW'}
    ];
    vm.States = vm.countries[13].States;

    //Default Country and State Values
    vm.address.Country = vm.countries[13].Name;
    vm.address.State = vm.States[0].Name;

    // Methods
    vm.onDone = onDone;
    vm.onCancel = onCancel;
    vm.onShowExtraFields = onShowExtraFields;
    vm.stateChanger = stateChanger;

    activate();

    function activate() {
      angular.extend(vm.address, locals.loadedData);
      vm.menu = checkIfObjectIsPopulated(locals.loadedData);
      vm.addressTypes = contactLookupsService.contactLookupsObj.AddressTypes;
    }

    function stateChanger(country, query){
      vm.States = alasql("select States from ? where Name = ?", [vm.countries, country])[0].States;
      if(angular.isDefined(vm.States)){
        if(!query)
          vm.address.State = vm.States[0].Name;
      }
      else{
        vm.States = [];
        vm.address.State = "";
      }
    }

    function onDone(answer) {
      // TODO: Add multiple addresses
      var addrObj = {
        AddressType: vm.address.AddressType
        , BldgName: answer.BldgName
        , StreetName: answer.StreetName
        , StreetNumber: answer.StreetNumber
        , City: answer.City
        , State: answer.State
        , PostCode: answer.PostCode
        , FullAddress: answer.FullAddress
        , Country: answer.Country
        , UnitNumber: vm.address.UnitNumber
      };

      // Check full address if not available then construct
      if (!answer.FullAddress || !vm.usedGoogleMaps) {
        addrObj.FullAddress = utils.isNull(addrObj.BldgName, '') + appendSeparator(addrObj.BldgName) +
          utils.isNull(addrObj.StreetNumber, '') + appendSeparator(addrObj.StreetNumber) +
          utils.isNull(addrObj.StreetName, '') + appendSeparator(addrObj.StreetName) +
          utils.isNull(addrObj.City, '') + appendSeparator(addrObj.StreetName) +
          utils.isNull(addrObj.Country, '') + appendSeparator(addrObj.Country);
      }

      $mdDialog.hide(addrObj.FullAddress);
    }

    function onCancel() {
      $mdDialog.cancel();
    }

    function onShowExtraFields() {
      vm.menu = !vm.menu;
      vm.customAddressLink = false;
      vm.showCustomAddress = false;
    }

    function checkIfObjectIsPopulated(data) {
      if (!data) return false;

      return (data.PostCode ||
      data.BldgName ||
      data.StreetNumber ||
      data.StreetName ||
      data.City ||
      data.State);
    }

    function appendSeparator(value) {
      return value ?  ', ' : '';
    }


    /**
     * Google api map
     */
    angular.extend($scope, {
      map: {
        center: {
          latitude: 40.1451,
          longitude: -99.6680
        },
        zoom: 4
      },
      searchbox: {
        template: 'app/main/contact/create/address/add/address-searchbox.html',
        events: {
          places_changed: function (searchBox) {
            var place = searchBox.getPlaces()
              , tempAddress = {};

            // Simplify it from being an array to being an object
            place = place[0];
            tempAddress.FullAddress = place.formatted_address;
            $log.debug(place);

            if (place !== undefined) {
              // Open
              vm.menu = true;
              vm.customAddressLink = false;
              vm.usedGoogleMaps = true;

              var componentForm = {
                premise: 'long_name'
                , street_number: 'short_name'
                , route: 'long_name'
                , locality: 'long_name'
                , administrative_area_level_1: 'short_name'
                , country: 'long_name'
                , postal_code: 'short_name'
              };

              // Get each component of the address from the place details
              // and fill the corresponding field on the form.
              for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];

                if (componentForm[addressType]) {
                  if (addressType === 'premise')
                    tempAddress.BldgName = place.address_components[i][componentForm[addressType]];
                  if (addressType === 'route')
                    tempAddress.StreetName = place.address_components[i][componentForm[addressType]];
                  if (addressType === 'street_number')
                    tempAddress.StreetNumber = place.address_components[i][componentForm[addressType]];
                  if (addressType === 'locality')
                    tempAddress.City = place.address_components[i][componentForm[addressType]];
                  if (addressType === 'administrative_area_level_1')
                    tempAddress.State = place.address_components[i][componentForm[addressType]];
                  if (addressType === 'postal_code')
                    tempAddress.PostCode = place.address_components[i][componentForm[addressType]];
                  if (addressType === 'country')
                    tempAddress.Country = place.address_components[i][componentForm[addressType]];
                }
              }

              //vm.address = tempAddress;
              angular.extend(vm.address, tempAddress);
              vm.stateChanger(vm.address.Country, true);
            }
          }
        }
      },
      options: {
        scrollwheel: false
      }
    });

    uiGmapGoogleMapApi.then(function (maps) {
      maps.visualRefresh = true;
    });
  }

})();

/**
 * Created by Ben Rei on 8/19/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.jobs.droppedAsset',[])
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.droppedAsset')
        .controller('droppedAssetOptionalItemsDialogController', droppedAssetOptionalItemsDialogController);

    function droppedAssetOptionalItemsDialogController(
        $mdDialog,
        jobService,
        locals) {

        var vm = this;
        vm.jobService = jobService;
        vm.selectedOptionalItem = null;

        vm.onCancel = onCancel;
        vm.onSave = onSave;

        activate();

        function activate() {
            vm.item = locals.item;
            vm.optionalItems = locals.optionalItems;
        }

        function onSave() {
            $mdDialog.hide({
                item: locals.item,
                selectedOptionalItem: vm.selectedOptionalItem
            });
        }

        function onCancel() {
            $mdDialog.hide({
                item: locals.item,
                selectedOptionalItem: null
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module('app.jobs.droppedAsset')
        .controller("assetUnlinkItemsDialogController", assetUnlinkItemsDialogController);

    function assetUnlinkItemsDialogController($mdDialog,items) {
        var vm = this;
        vm.dismissDialog = dismissDialog;
        vm.onConfirm = onConfirm;
        activate();

        function activate() {
            vm.items = items;
        }

        function onConfirm() {
            $mdDialog.hide();
        }

        function dismissDialog() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.droppedAsset')
        .controller('droppedAssetDialogController', droppedAssetDialogController);

    function droppedAssetDialogController(
        $mdDialog,
        hubService,
        jobService,
        claimsUtilService,
        locals) {

        var vm = this;
        vm.jobService = jobService;

        vm.onCancel = onCancel;
        vm.checkApplyOnEndDate = checkApplyOnEndDate;
        vm.onChangeBillingPeriod = onChangeBillingPeriod;
        vm.claimsUtilService = claimsUtilService;
        vm.onSave = onSave;

        activate();

        function activate() {

            // Check for editing
            if (locals.dataToEdit) {
                vm.assetName = locals.dataToEdit.ItemName;
                vm.billingPeriod = locals.dataToEdit.billingPeriod;
                vm.Quantity = locals.dataToEdit.ItemQuantity;
                vm.Billable = locals.dataToEdit.isBillable;

                vm.IsDeleted = locals.dataToEdit.IsDeleted;
                vm.IsNew = locals.dataToEdit.IsNew;
                vm.BillingPeriod = locals.dataToEdit.BillingPeriod == null || locals.dataToEdit.BillingPeriod == undefined ? -1 : locals.dataToEdit.BillingPeriod;
                if (vm.BillingPeriod == -1) {
                    vm.BillingPeriod = 1;
                    vm.Billable = true;
                }
                if ((locals.dataToEdit.ItemBillingPeriod == null || locals.dataToEdit.ItemBillingPeriod == undefined) && vm.BillingPeriod) {
                    var billingPeriod = _.find(vm.jobService.billingPeriodLookup, function (bp, i) {
                        return bp.Id == vm.BillingPeriod && !bp.IsNotBillable == !!vm.Billable;
                    });
                    if (billingPeriod) {
                        vm.ItemBillingPeriod = billingPeriod.ItemId;
                    }
                } else {
                    vm.ItemBillingPeriod = locals.dataToEdit.ItemBillingPeriod;
                }
                vm.UpdateTransaction = locals.dataToEdit.UpdateTransaction || 1;
                vm.ApplyOnStartDate = locals.dataToEdit.ApplyOnStartDate;
                vm.ApplyOnEndDate = locals.dataToEdit.ApplyOnEndDate;
            }

            vm.toDelete = locals.toDelete;
            vm.editMode = locals.editMode;
        }

        function onSave(toDelete) {
            locals.dataToEdit.IsProperlyConfirmed = true;
            $mdDialog.hide({
                toDelete: toDelete,
                assetQty: vm.Quantity,
                Billable: vm.Billable,
                IsDeleted: vm.IsDeleted,
                IsNew: vm.IsNew,
                ItemBillingPeriod: vm.ItemBillingPeriod,
                BillingPeriod: vm.BillingPeriod,
                UpdateTransaction: vm.UpdateTransaction,
                ApplyOnStartDate: vm.ApplyOnStartDate,
                ApplyOnEndDate: vm.ApplyOnEndDate,
                Id: locals.dataToEdit.Id,
                quantityOldValue: locals.quantityOldValue
            });
        }

        function onCancel() {
            locals.dataToEdit.IsProperlyConfirmed = true;
            if (vm.IsNew && !vm.editMode) {
                $mdDialog.cancel({
                    IsNew: vm.IsNew,
                    Id: locals.dataToEdit.Id
                });
            } else {
                $mdDialog.hide();
            }
        }

        function checkApplyOnEndDate() {
            if (!vm.ApplyOnStartDate || !vm.ApplyOnEndDate)
                return
            let diff = date_diff_indays(vm.ApplyOnStartDate, vm.ApplyOnEndDate);
            if (diff < 0) {
                hubService.showToast('The end date must be on or after the start date');
                vm.ApplyOnEndDate = null;
            }
        }

        function onChangeBillingPeriod(ItemBillingPeriod) {
            vm.billingPeriod = _.find(vm.jobService.billingPeriodLookup, function (o, i) {
                return o.ItemId === ItemBillingPeriod;
            });
            if (vm.billingPeriod) {
                vm.BillingPeriod = vm.billingPeriod.Id;
                vm.Billable = !vm.billingPeriod.IsNotBillable;
            }
        }

        var date_diff_indays = function (date1, date2) {
            let dt1 = new Date(date1);
            let dt2 = new Date(date2);
            return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
        }
    }

})();

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraggableKit = function (_React$Component) {
  _inherits(DraggableKit, _React$Component);

  function DraggableKit() {
    _classCallCheck(this, DraggableKit);

    var _this = _possibleConstructorReturn(this, (DraggableKit.__proto__ || Object.getPrototypeOf(DraggableKit)).call(this));

    _this.doubleClicked = _this.doubleClicked.bind(_this);
    _this.clicked = _this.clicked.bind(_this);
    _this.mouseEntered = _this.mouseEntered.bind(_this);
    _this.mouseLeaved = _this.mouseLeaved.bind(_this);
    return _this;
  }

  _createClass(DraggableKit, [{
    key: "doubleClicked",

    //
    value: function doubleClicked(id) {
      this.props.onDoubleClick(id, null, this.props.resourceModel);
    }
  }, {
    key: "clicked",
    value: function clicked() {
      this.props.onClick(this.props.resourceModel);
    }
  }, {
    key: "mouseEntered",
    value: function mouseEntered() {
      this.props.onMouseEnter(this.props.resourceModel);
    }
  }, {
    key: "mouseLeaved",
    value: function mouseLeaved() {
      this.props.onMouseLeave(this.props.resourceModel);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        null,
        React.createElement(DraggableKitList, { data: this.props.kitList,
          doubleClickEvent: this.doubleClicked,
          clickEvent: this.clicked,
          mouseEnterEvent: this.mouseEntered,
          mouseLeaveEvent: this.mouseLeaved })
      );
    }
  }]);

  return DraggableKit;
}(React.Component);

//Using ES6 Class


DraggableKit.propTypes = {
  kitList: React.PropTypes.array.isRequired,
  resourceModel: React.PropTypes.array.isRequired,
  onDoubleClick: React.PropTypes.func.isRequired,
  onClick: React.PropTypes.func.isRequired,
  onMouseEnter: React.PropTypes.func.isRequired,
  onMouseLeave: React.PropTypes.func.isRequired
};
DraggableKit.defaultProps = {
  kitList: [],
  onDoubleClick: function onDoubleClick() {},
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};

var DraggableKitList = function (_React$Component2) {
  _inherits(DraggableKitList, _React$Component2);

  function DraggableKitList() {
    _classCallCheck(this, DraggableKitList);

    var _this2 = _possibleConstructorReturn(this, (DraggableKitList.__proto__ || Object.getPrototypeOf(DraggableKitList)).call(this));

    _this2.doubleClickedEvent = _this2.doubleClickedEvent.bind(_this2);
    _this2.clickEvent = _this2.clickEvent.bind(_this2);
    _this2.mouseEnterEvent = _this2.mouseEnterEvent.bind(_this2);
    _this2.mouseLeaveEvent = _this2.mouseLeaveEvent.bind(_this2);
    return _this2;
  }

  _createClass(DraggableKitList, [{
    key: "doubleClickedEvent",


    //>
    value: function doubleClickedEvent(id) {
      this.props.doubleClickEvent(id);
    }
  }, {
    key: "clickEvent",
    value: function clickEvent() {
      this.props.clickEvent();
    }
  }, {
    key: "mouseEnterEvent",
    value: function mouseEnterEvent() {
      this.props.mouseEnterEvent();
    }
  }, {
    key: "mouseLeaveEvent",
    value: function mouseLeaveEvent() {
      this.props.mouseLeaveEvent();
    }
  }, {
    key: "render",
    value: function render() {
      var items = this.props.data.map(function (item) {
        return React.createElement(DraggableKitListItem, { key: item.Id,
          id: item.Id,
          name: item.KitName,
          onDoubleClick: this.doubleClickedEvent,
          Click: this.clickEvent,
          onMouseEnter: this.mouseEnterEvent,
          onMouseLeave: this.mouseLeaveEvent });
      }.bind(this));
      var uid = _.uniqueId("ul-");
      return React.createElement(
        "ul",
        { key: uid, className: "no-style" },
        items
      );
    }
  }]);

  return DraggableKitList;
}(React.Component);
//


DraggableKitList.propTypes = {
  doubleClickEvent: React.PropTypes.func.isRequired,
  clickEvent: React.PropTypes.func.isRequired,
  mouseEnterEvent: React.PropTypes.func.isRequired,
  mouseLeaveEvent: React.PropTypes.func.isRequired
};
DraggableKitList.defaultProps = {
  doubleClickEvent: function doubleClickEvent() {},
  clickEvent: function clickEvent() {},
  mouseEnterEvent: function mouseEnterEvent() {},
  mouseLeaveEvent: function mouseLeaveEvent() {}
};

var DraggableKitListItem = function (_React$Component3) {
  _inherits(DraggableKitListItem, _React$Component3);

  function DraggableKitListItem() {
    _classCallCheck(this, DraggableKitListItem);

    var _this3 = _possibleConstructorReturn(this, (DraggableKitListItem.__proto__ || Object.getPrototypeOf(DraggableKitListItem)).call(this));

    _this3.state = {
      hover_flag: false
    };
    _this3.hoverEvent = _this3.hoverEvent.bind(_this3);
    _this3.dragStart = _this3.dragStart.bind(_this3);
    _this3.doubleClick = _this3.doubleClick.bind(_this3);
    _this3.click = _this3.click.bind(_this3);
    _this3.mouseEnter = _this3.mouseEnter.bind(_this3);
    _this3.mouseLeave = _this3.mouseLeave.bind(_this3);
    return _this3;
  }

  _createClass(DraggableKitListItem, [{
    key: "hoverEvent",
    value: function hoverEvent() {
      this.setState({ hover_flag: !this.state.hover_flag });
    }
  }, {
    key: "dragStart",
    value: function dragStart(e) {
      e.dataTransfer.setData("text/plain", e.currentTarget.id);
    }
  }, {
    key: "doubleClick",
    value: function doubleClick(e) {
      this.props.onDoubleClick(e.currentTarget.id);
    }
  }, {
    key: "click",
    value: function click() {
      this.props.Click();
    }
  }, {
    key: "mouseEnter",
    value: function mouseEnter() {
      this.props.onMouseEnter();
    }
  }, {
    key: "mouseLeave",
    value: function mouseLeave() {
      this.props.onMouseLeave();
    }
  }, {
    key: "render",
    value: function render() {
      var liStyle = {
        paddingLeft: 15
      };
      if (this.props.isSelected || this.state.hover_flag) {
        liStyle = {
          background: '#999999',
          color: '#FFFFFF',
          paddingLeft: 15
        };
      }
      return React.createElement(
        "li",
        { key: this.props.id,
          id: this.props.id,
          className: "assets-item-inner md-no-proxy",
          draggable: "true",
          onDragStart: this.dragStart,
          onMouseOver: this.hoverEvent,
          onMouseOut: this.hoverEvent,
          onDoubleClick: this.doubleClick,
          onClick: this.click,
          onMouseEnter: this.mouseEnter,
          onMouseLeave: this.mouseLeave,
          style: liStyle },
        this.props.name
      );
    }
  }]);

  return DraggableKitListItem;
}(React.Component);

angular.module('app.jobs').value('DraggableKit', DraggableKit);
/**
 * Created by Ben Rei on 10/19/2016.
 */
(function () {
  'use strict';

  angular.module('app.jobs')
    .directive('draggableKitComponent', draggableKitComponent);

  /** @ngInject */
  function draggableKitComponent(reactDirective, DraggableKit) {
    return reactDirective(DraggableKit);
  }

})();

(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('jobBoardComponent', jobBoardComponent);

    /** @ngInject */
    function jobBoardComponent(
        $timeout,
        $state,
        $mdDialog,
        utils,
        _,
        ticketPdfService,
        ticketsApi,
        timesheetApi,
        jobsApi,
        exceptionService,
        blockUI,
        whiteboardClaimsService,
        DialogService,
        msgboxService,
        tenantSettings
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/weekly/jobBoardComponent.html',
            scope: {
                headers: '=',
                sourceData: '=',
                isNavigating: '=',
                allowGrouping: '=',
                showProject: '=',
                showRelatedTicketNumber: '=',
                removeTicket: '=',
                whiteboardType: '=',
                onCancelTicket: '&'
            },
            controller: JobBoardController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function JobBoardController($scope) {
            var vm = this;
            vm.disableBillingPref = whiteboardClaimsService.disableBillingPref;

            vm.onOpenEditTicket = openEditTicket;
            vm.openResourceAlloc = openResourceAlloc;
            vm.openTimesheet = openTimesheet;
            vm.cloneTicket = cloneTicket;
            vm.cancelTicket = cancelTicket;
            vm.addRelatedTicket = addRelatedTicket;
            vm.downloadPdf = downloadPdf;
            vm.ticketBillingPref = ticketBillingPref;
            vm.openCardTicket = openCardTicket;
            vm.addTicket = addTicket;
            vm.onDownloadPaperworkPdf = downloadPaperworkPdf;
            vm.onDownloadTimesheetPdf = downloadTimesheetPdf;

            activate();

            function activate() {
                setDefaultContentSize();
            }

            function openEditTicket(value) {
                blockUI.start({
                    message: 'Loading Ticket...'
                });
                $state.go('app.jobs_update', {
                    id: value.id,
                    ticketNumber: value.ticketNo,
                    parentTicketNo: value.parentTicketNo
                });
            }

            function openResourceAlloc(value) {
                $state.go('app.allocate', {
                    id: value.id,
                    ticketNo: value.ticketNo,
                    parentTicketNo: value.parentTicketNo
                });
            }

            function openTimesheet(value) {
                $state.go('app.timesheet', {
                    id: value.id,
                    isLocked: value.isLocked,                    
                    isLockedByPreSchedule: value.isLockedByPreSchedule,
                    TicketNo: value.ticketNo
                });
            }

            function downloadPaperworkPdf(value) {
                ticketPdfService.getPaperworkPDF(value.id, value.ticketNo)
                    .then(function(resp) {}).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function downloadTimesheetPdf(value) {
                ticketPdfService.getTimesheetPDF(value.id, value.ticketNo)
                    .then(function(resp) {}).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function cloneTicket(value) {
                blockUI.start({
                    message: 'Checking related ticket...'
                });
                ticketsApi.getRelatedTicket(value.id).then(function(resp) {
                    blockUI.stop();
                    var related = {
                        ticketId: resp.data.Id,
                        ticketNumber: resp.data.TicketNumber
                    };
                    $state.go('app.jobs_clone', {
                        cloneId: value.id,
                        related: related
                    });
                }).catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
            }

            async function cancelTicket(value) {
                const hasExportedTimesheets = (await timesheetApi.checkIfTimesheetExported(value.id)).data;
                
                if (hasExportedTimesheets) {
                    msgboxService.alert(
                        utils.translate('SB.CANCEL_TICKET_TITLE'),
                        utils.translate('SB.CANCEL_TICKET_MESSAGE'),
                        utils.translate('SB.CANCEL_TICKET_OKAY'));
                    return;
                } else {
                    let dialog = showCancelTicketDialog({
                        Id: value.id,
                        TicketNumber: value.ticketNo,
                        TicketType: value.ticketType
                    });

                    $mdDialog.show(dialog).then(function(res) {
                        if (res) {
                            blockUI.start('Cancelling Ticket...')
                            performCancelTicket(value.id, res.reason, res.chargeMinHours).then(success).catch(failed);
                        }
                    });
                }

                function success(resp) {

                    let ticketNumbers = resp.data;

                    (vm.onCancelTicket || angular.noop)({
                        cancelledTickets: {
                            tickets: ticketNumbers
                        }
                    });

                    blockUI.stop();
                    cancelSuccess(value.ticketNo);
                }

                function failed(ex) {
                    blockUI.stop();
                    exceptionService.resolve(_.isNil(ex.data) ? ex : ex.data.Message);
                }
            }

            function cancelSuccess(ticketNumber) {
                let notification = $mdDialog.confirm()
                    .title('Cancel Ticket')
                    .textContent('Ticket #' + ticketNumber + ' has been cancelled.')
                    .ariaLabel('Cancel Ticket')
                    .ok('Ok')

                $mdDialog.show(notification)
            }

            function showCancelTicketDialog(ticket) {
                let dialog = {
                    locals: {
                        ticket: angular.copy(ticket)
                    },
                    templateUrl: 'app/main/jobs/services/cancelReasonDialog/cancel-reason.html',
                    controller: 'CancelReasonController as vm'
                }
                return dialog;
            }

            function performCancelTicket(ticketId, reason, chargeMinHours) {
                return jobsApi.cancelTicket(ticketId, reason, chargeMinHours);
            }

            function addRelatedTicket(value) {
                blockUI.start({
                    message: 'Checking related ticket...'
                });
                ticketsApi.getRelatedTicket(value.id)
                    .then(function(resp) {
                        blockUI.stop();
                        var related = {
                            ticketId: resp.data.Id,
                            ticketNumber: resp.data.TicketNumber
                        };
                        $state.go('app.jobs_manage', {
                            related: related
                        });
                    }).catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            }

            function downloadPdf(value) {
                getTicketPDF(value.id);
            }

            function getTicketPDF(id) {
                ticketPdfService.getTicketPDF(id);
            }

            function ticketBillingPref(value) {
                const [month1, month2, yearAndTime] = value.dt.split('/');
                const year = yearAndTime.slice(0, 4);
                const month = tenantSettings.countryCode === 'US' || tenantSettings.countryCode === 'CA' ? month1 : month2;

                $state.go('app.related-ticket-billing', {
                    Id: value.id,
                    Month: month,
                    Year: year
                });
            }

            function openCardTicket(ticket) {
                let clonedTicket = angular.copy(ticket);
                let objParam = {
                    id: clonedTicket.id,
                    ticketNo: clonedTicket.ticketNo,
                    ticketCount: clonedTicket.ticketCount,
                    tickets: clonedTicket.tickets,
                    type: 'weekview',
                    companyCode: clonedTicket.companyCode,
                    date: clonedTicket.startDate
                };
                DialogService.openTicketDialog(objParam);
            }

            function addTicket(ev, date) {
                let dt = moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
                $state.go('app.jobs_manage', {
                    dt: dt
                });
            }

            function setDefaultContentSize() {
                $timeout(function() {
                    var boardEl = angular.element('#board');
                    var boardElHeight = boardEl.height() - 90;
                    var result = document.getElementsByClassName('list-wrapper');
                    var wrappedResult = angular.element(result);
                    var w = (angular.element(wrappedResult[0]).width() * 7);
                    var bw = w + 100;

                    var virtualRepeatContainer = angular.element('#vertical-container');

                    virtualRepeatContainer.css('min-height', boardElHeight + 'px');
                    virtualRepeatContainer.css('min-width', w + 'px');
                    boardEl.css('min-width', bw + 'px');

                });
            }
        }
    }
})();
/**
 * jobMonthly Component
 * - rcnet 8.11.2016
 */
(function() {
    'use strict';

    angular.module('app.jobs')
        .directive('jobMonthlyComponent', jobMonthlyComponent);

    /** @ngInject */
    function jobMonthlyComponent($mdDialog, $document, _, uiCalendarConfig, DialogService, localisationService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/monthly/jobMonthly.html',
            scope: {
                name: '@',
                eventData: '=',
                currentMonthShort: '=',
                behavior: '=',
                onRender: '&',
                onChangeView: '&'
            },
            controller: JobMonthlyController,
            controllerAs: 'jobMonthlyVm',
            bindToController: true
        };

        return directive;

        function JobMonthlyController() {
            var vm = this;

            vm.calendarUiConfig;
            vm.calendarView;
            vm.calendar;
            vm.currentMonthShort; // Temporary

            activate();

            //////
            function activate() {
                
                var localeSettings = localisationService.getLocaleFormatSettings();
                vm.calendarUiConfig = {
                    calendar: {
                        editable: false,
                        eventLimit: true,
                        header: '',
                        handleWindowResize: false,
                        aspectRatio: 1,
                        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                        viewRender: onViewRender,
                        columnFormat: {
                            month: 'ddd',
                            week: 'ddd D',
                            day: 'ddd M'
                        },
                        eventClick: eventDetail,
                        selectable: true,
                        selectHelper: true,
                        select: select,
                        displayEventTime: false,
                        dayClick: dayClick,
                        firstDay: localeSettings.firstDayOfWeek
                    }
                };

                // Set behavior object
                if (vm.behavior && angular.isObject(vm.behavior)) {
                    vm.behavior.prev = prev;
                    vm.behavior.next = next;
                    vm.behavior.setToDailyView = setToDailyView;
                    vm.behavior.setToWeeklyView = setToWeeklyView;
                    vm.behavior.setToMonthlyView = setToMonthlyView;
                    vm.behavior.setToday = setToday;
                    vm.behavior.addEvent = addEvent;
                    vm.behavior.setDate = setDate;
                }
            }

            function onViewRender(view) {
                vm.calendarView = view;
                vm.calendar = vm.calendarView.calendar;
                vm.currentMonthShort = vm.calendar.getDate().format('MMM');

                (vm.onRender || angular.noop)({
                    calViewObj: view
                });
            }

            function setToDailyView() {
                vm.calendar.changeView('agendaDay');
            }

            function setToWeeklyView() {
                vm.calendar.changeView('agendaWeek');
            }

            function setToMonthlyView() {
                //vm.calendar.changeView('month');
                uiCalendarConfig.calendars.jobCalendar2.fullCalendar('render');
                vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                (vm.onRender || angular.noop)({
                    calViewObj: vm.calendarView
                });
            }

            /**
             * Change the calendar date
             */
            function setDate(date) {
                uiCalendarConfig.calendars.jobCalendar2.fullCalendar('gotoDate', date);
            }

            /**
             * Set to current date
             */
            function setToday() {
                vm.calendar.today();
            }

            /**
             * Go to next on current view (week, month etc.)
             */
            function prev() {
                vm.calendarView.calendar.prev();
                return vm.calendar.getDate();
            }

            /**
             *  Go to next on current view (week, month etc.)
             */
            function next() {
                vm.calendarView.calendar.next();
                return vm.calendar.getDate();
            }

            /**
             * Show event detail
             *
             * @param calendarEvent
             * @param e
             */
            function eventDetail(calendarEvent, e) {
                showEventDetailDialog(calendarEvent, e);
            }

            /**
             * Add new event in between selected dates
             *
             * @param start
             * @param end
             * @param e
             */
            function select(start, end, e) {
                //showEventFormDialog('add', false, start, end, e);
            }

            /**
             * Show event detail dialog
             * @param calendarEvent
             * @param e
             */
            function showEventDetailDialog(calendarEvent, e) {
                //DialogService.openMonthViewCardTicketDialog(null, { ticketCount: calendarEvent.ticketCount, tickets: calendarEvent.tickets, title: calendarEvent.titleName }, 'monthview');
                DialogService.openTicketDialog({
                    ticketCount: calendarEvent.ticketCount,
                    tickets: calendarEvent.tickets,
                    title: calendarEvent.titleName,
                    type: 'monthview'
                });
            }

            /**
             * Navigate to Day view
             */
            function dayClick(date, jsEvent, view) {
                (vm.onChangeView || angular.noop)({
                    e: date
                });
            }

            /**
             * Add event
             *
             * @param e
             */
            function addEvent(e) {
                var start = new Date(),
                    end = new Date();

                showEventFormDialog('add', false, start, end, e);
            }

            /**
             * Show event add/edit form dialog
             *
             * @param type
             * @param calendarEvent
             * @param start
             * @param end
             * @param e
             */
            function showEventFormDialog(type, calendarEvent, start, end, e) {
                var dialogData = {
                    type: type,
                    calendarEvent: calendarEvent,
                    start: start,
                    end: end
                };

                $mdDialog.show({
                    controller: 'JobFormDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/jobs/whiteBoard/jobBoard/jobForm/job-form-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    clickOutsideToClose: true,
                    locals: {
                        dialogData: dialogData
                    }
                }).then(function(response) {
                    if (response.type === 'add') {
                        // Add new
                        vm.eventData[0].push({
                            id: vm.eventData[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end: response.calendarEvent.end
                        });
                    } else {
                        for (var i = 0; i < vm.eventData[0].length; i++) {
                            // Update
                            if (vm.eventData[0][i].id === response.calendarEvent.id) {
                                vm.eventData[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end: response.calendarEvent.end
                                };

                                break;
                            }
                        }
                    }
                });
            }

        }

    }
})();
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('dateNavigationComponent', dateNavigationComponent);

    /** @ngInject */
    function dateNavigationComponent(
        _,
        dateNavigationService,
        $mdpDatePicker
    ) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/dateNavigation/dateNavigation.html',
            scope: {
                next: '&',
                prev: '&',
                onChangeCalendar: '&',
                behavior: '='
            },
            controller: DateNavigationController,
            controllerAs: 'dateNavigationVm',
            bindToController: true
        };

        return directive;

        function DateNavigationController(
            $scope
        ) {
            var vm = this;
            vm.title;
            vm.goNext = goNext;
            vm.goPrev = goPrev;
            vm.showCalendar = showCalendar;

            const DATE_FORMAT = 'MM/DD/YYYY';

            var nextDebounce, prevDebounce;

            activate();

            ///////
            function activate() {
                vm.title = dateNavigationService.isWeekly ? dateNavigationService.getWeeklyDate() : dateNavigationService.getDailyDate();

                nextDebounce = _.debounce((vm.next || angular.noop), 300, false);
                prevDebounce = _.debounce((vm.prev || angular.noop), 300, false);

                if (vm.behavior) {
                    vm.behavior.setTitle = setTitle;
                    vm.behavior.refresh = refresh;
                }
            }

            $scope.$on('$destroy', function() {
                nextDebounce = null;
                prevDebounce = null;
                vm.next = null;
                vm.prev = null;
                vm.onChangeCalendar = null;
                vm.behavior = null;
            });

            function goNext() {
                if (dateNavigationService.isWeekly || dateNavigationService.isDaily) {
                    dateNavigationService.next();
                    refreshTitle();
                }

                // Allow our third party calendar component to handle such change for Next event
                nextDebounce();
            }

            function goPrev() {
                if (dateNavigationService.isWeekly || dateNavigationService.isDaily) {
                    dateNavigationService.prev();
                    refreshTitle();
                }

                prevDebounce();
            }

            function setTitle(title) {
                vm.title = title;
            }

            function refresh() {
                refreshTitle();
            }

            function refreshTitle() {
                if (dateNavigationService.isWeekly) {
                    vm.title = dateNavigationService.getWeeklyDate();
                } else if (dateNavigationService.isDaily) {
                    vm.title = dateNavigationService.getDailyDate();
                }
            }

            function showCalendar(ev) {
                $mdpDatePicker(dateNavigationService.getDateData().format(DATE_FORMAT), {
                    targetEvent: ev
                }).then(function(selectedDate) {
                    dateNavigationService.updateDate(moment(selectedDate));
                    refreshTitle();
                    (vm.onChangeCalendar || angular.noop)();
                });;
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .directive('jobBoardDayViewComponent', jobBoardDayViewComponent);

    /** @ngInject */
    function jobBoardDayViewComponent(
        $state,
        $mdDialog,
        utils,
        _,
        DialogService,
        msgboxService,
        exceptionService,
        ticketPdfService,
        jobsApi,
        ticketsApi,
        timesheetApi,
        whiteboardClaimsService,
        localisationService,
        blockUI,
        tenantSettings
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/whiteBoard/jobBoard/daily/jobBoardDayViewComponent.html',
            scope: {
                header: '=',
                currentDate: '=',
                sourceData: '=',
                isNavigating: '=',
                allowGrouping: '=',
                showProject: '=',
                showRelatedTicketNumber: '=',
                removeTicket: '=',
                whiteboardType: '=',
                onCancelTicket: '&'
            },
            controller: DayViewController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DayViewController() {
            var vm = this;

            // Data
            vm.disableBillingPref = whiteboardClaimsService.disableBillingPref;

            // Methods
            vm.onOpenEditTicket = openEditTicket;
            vm.openResourceAlloc = openResourceAlloc;
            vm.openTimesheet = openTimesheet;
            vm.cloneTicket = cloneTicket;
            vm.cancelTicket = cancelTicket;
            vm.addRelatedTicket = addRelatedTicket;
            vm.downloadPdf = downloadPdf;
            vm.ticketBillingPref = ticketBillingPref;
            vm.openCardTicket = openCardTicket;
            vm.addTicket = addTicket;
            vm.onDownloadPaperworkPdf = downloadPaperworkPdf;
            vm.onDownloadTimesheetPdf = downloadTimesheetPdf;

            var localeSettings = {};

            activate();

            ///////
            function activate() {
                localeSettings = localisationService.getLocaleFormatSettings();
            }

            // NEW METHODS
            function openEditTicket(value) {
                blockUI.start({
                    message: 'Loading Ticket...'
                });
                $state.go('app.jobs_update', {
                    id: value.id,
                    ticketNumber: value.ticketNo,
                    parentTicketNo: value.parentTicketNo
                });
            }

            function openResourceAlloc(value) {
                $state.go('app.allocate', {
                    id: value.id,
                    ticketNo: value.ticketNo,
                    parentTicketNo: value.parentTicketNo
                });
            }

            function openTimesheet(value) {
                $state.go('app.timesheet', {
                    id: value.id,
                    isLocked: value.isLocked,
                    isLockedByPreSchedule: value.isLockedByPreSchedule,
                    TicketNo: value.ticketNo
                });
            }

            function cloneTicket(value) {
                blockUI.start({
                    message: 'Checking related ticket...'
                });
                ticketsApi.getRelatedTicket(value.id).then(function(resp) {
                    blockUI.stop();
                    var related = {
                        ticketId: resp.data.Id,
                        ticketNumber: resp.data.TicketNumber
                    };
                    $state.go('app.jobs_clone', {
                        cloneId: value.id,
                        related: related
                    });
                }).catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
            }

            async function cancelTicket(value) {
                const hasExportedTimesheets = (await timesheetApi.checkIfTimesheetExported(value.id)).data;

                if (hasExportedTimesheets) {
                    msgboxService.alert(
                        utils.translate('WHITEBOARD.CANCEL_TICKET_TITLE'),
                        utils.translate('WHITEBOARD.CANCEL_TICKET_MESSAGE'),
                        utils.translate('WHITEBOARD.CANCEL_TICKET_OKAY'));
                    return;
                } else {
                    let dialog = showCancelTicketDialog({
                        Id: value.id,
                        TicketNumber: value.ticketNo,
                        TicketType: value.ticketType
                    });

                    $mdDialog.show(dialog).then(function(res) {
                        if (res) {
                            blockUI.start('Cancelling Ticket...')
                            performCancelTicket(value.id, res.reason, res.chargeMinHours).then(success).catch(failed);
                        }
                    });
                }

                function success(resp) {
                    let ticketNumbers = resp.data;

                    (vm.onCancelTicket || angular.noop)({
                        cancelledTickets: {
                            tickets: ticketNumbers
                        }
                    });

                    blockUI.stop();
                    cancelSuccess(value.ticketNo);
                }

                function failed(ex) {
                    blockUI.stop();
                    exceptionService.resolve(_.isNil(ex.data) ? ex : ex.data.Message);
                }
            }

            function cancelSuccess(ticketNumber) {
                let notification = $mdDialog.confirm()
                    .title('Cancel Ticket')
                    .textContent('Ticket #' + ticketNumber + ' has been cancelled.')
                    .ariaLabel('Cancel Ticket')
                    .ok('Ok')

                $mdDialog.show(notification)
            }

            function showCancelTicketDialog(ticket) {
                let dialog = {
                    locals: {
                        ticket: angular.copy(ticket)
                    },
                    templateUrl: 'app/main/jobs/services/cancelReasonDialog/cancel-reason.html',
                    controller: 'CancelReasonController as vm'
                }
                return dialog;
            }

            function performCancelTicket(ticketId, reason, chargeMinHours) {
                return jobsApi.cancelTicket(ticketId, reason, chargeMinHours);
            }

            function addRelatedTicket(value) {
                blockUI.start({
                    message: 'Checking related ticket...'
                });
                ticketsApi.getRelatedTicket(value.id)
                    .then(function(resp) {
                        blockUI.stop();
                        var related = {
                            ticketId: resp.data.Id,
                            ticketNumber: resp.data.TicketNumber
                        };
                        $state.go('app.jobs_manage', {
                            related: related
                        });
                    }).catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            }

            function downloadPdf(value) {
                getTicketPDF(value.id);
            }

            function downloadPaperworkPdf(value) {
                ticketPdfService.getPaperworkPDF(value.id, value.ticketNo)
                    .then(function(resp) {}).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function downloadTimesheetPdf(value) {
                ticketPdfService.getTimesheetPDF(value.id, value.ticketNo)
                    .then(function(resp) {}).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function getTicketPDF(id) {
                ticketPdfService.getTicketPDF(id);
            }

            function ticketBillingPref(value) {
                const [month1, month2, yearAndTime] = value.dt.split('/');
                const year = yearAndTime.slice(0, 4);
                const month = tenantSettings.countryCode === 'US' || tenantSettings.countryCode === 'CA' ? month1 : month2;

                $state.go('app.related-ticket-billing', {
                    Id: value.id,
                    Month: month,
                    Year: year
                });
            }

            function openCardTicket(ticket) {
                let clonedTicket = angular.copy(ticket);
                let objParam = {
                    id: clonedTicket.id,
                    ticketNo: clonedTicket.ticketNo,
                    ticketCount: clonedTicket.ticketCount,
                    tickets: clonedTicket.tickets,
                    type: 'weekview',
                    companyCode: clonedTicket.companyCode,
                    date: clonedTicket.startDate
                };
                DialogService.openTicketDialog(objParam);
            }

            function addTicket(ev, date) {
                let dt = moment(date, localeSettings.displayDateFormat).format('YYYY-MM-DD');

                $state.go('app.jobs_manage', {
                    dt: dt
                });
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.timesheet',
      []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state('app.timesheet', {
        url: '/job-timesheet/:id?/:isLocked?/:TicketNo',
        views: {
          'content@app': {
            templateUrl: 'app/main/jobs/timeSheet/job-timesheet.html',
            controller: 'TimesheetController as vm'
          }
        } , data: {requireLogin : true}
          , title: 'Timesheet'
          , titleBar: 'Alloc8 - Time Sheet'
    });
    $translatePartialLoaderProvider.addPart('app/main/jobs/timeSheet');
  }
})();

(function () {
    'use strict';

    angular.module('app.jobs.timesheet')
        .controller('SubmitTimesheetDialogController', SubmitTimesheetDialogController);

    /** @ngInject */
    function SubmitTimesheetDialogController($mdDialog, service, exceptionService) {
        var vm = this;
        vm.service = service;
        vm.reasonForEditing = '';
        vm.isSignatureRequired = null;
        vm.maxLength = 0;
        vm.onCancelClick = onCancelClick;
        vm.onSubmitClick = onSubmitClick;
        vm.onRequireSignatureChange = onRequireSignatureChange;
        vm.checkValue = checkValue;
        vm.isFirstTimeSubmit = service.ticketTimesheetsDetailsCopy.every(isJobStartAndEndIsNull);
        vm.disableSubmit = true;

        function isJobStartAndEndIsNull(data){
            return !(data.JobStartTime && data.JobEndTime);
        }

        if (!service.isMobileAppEnabled) {
            vm.maxLength = 60;
            vm.isSignatureRequired = false;
        }

        function onCancelClick() {
            $mdDialog.hide();
        }

        function onSubmitClick() {
            vm.disableSubmit = true;
            vm.service.isSignatureRequired = vm.isSignatureRequired;
            vm.service.reasonForEditing = vm.reasonForEditing;
            if (vm.isSignatureRequired) {
                $mdDialog.hide();
                service.save();
            } else {
                service.checkIncompleteRequiredFormsBeforeSave();
            }
        }

        function onRequireSignatureChange() {
            vm.reasonForEditing = '';
            vm.maxLength = 400;

            let isReasonForEditEmpty = vm.reasonForEditing === '' || vm.reasonForEditing === undefined;

            if(vm.isSignatureRequired){
                vm.maxLength = 60;
                vm.disableSubmit = isReasonForEditEmpty;
            }
            else{
                vm.disableSubmit = !vm.isFirstTimeSubmit || (isReasonForEditEmpty && !vm.isFirstTimeSubmit);
            }
        }

        function checkValue(){
            vm.disableSubmit = vm.reasonForEditing === '' || vm.reasonForEditing === undefined;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.timesheet')
        .controller('TimesheetDialogController', TimesheetDialogController);

    /** @ngInject */
    function TimesheetDialogController(
        locked,
        $mdDialog,
        service,
        line,
        adminClaimsService,
        oldAwardAPI,
        _,
        blockUI,
        $q,
        timesheetApi,
        utils,
        allocationApi) {

        var vm = this;
        vm.is_locked = locked;
        vm.line = line;
        vm.service = service;
        vm.onSave = saveRecalculatedAward;
        vm.onClose = closeDialog;
        vm.adminClaimsService = adminClaimsService;
        vm.activate = activate;
        vm.resetAwardsAndClassifications = resetAwardsAndClassifications;
        vm.onAwardChange = onAwardChange;
        vm.awardChanged = false;
        vm._shiftRoles = [];
        vm._classifications = [];
        vm.onRecalculate = recalculateAwardClassification;
        vm.isAwardClassificationRecalculated = false;
        vm.AwardInfoText = '';
        vm.ClassificationInfoText = '';
        vm.allocatedResourceItem = null;

        function activate() {
            vm.resetAwardsAndClassifications();
            vm.onAwardChange(true);
        }

        function resetAwardsAndClassifications() {
            vm.awardChanged = false;

            angular.forEach(vm.service.shiftRoles, function(role, i) {
                role.isDisabled = false;
            });

            angular.forEach(vm.service.classifications, function(classification, i) {
                classification.isDisabled = false;
            });
        }

        function onAwardChange(forced) {
            if (!vm.awardChanged && !forced) {
                return;
            }

            var block = blockUI.instances.get('add-project');
            block.start(utils.translate("TIMESHEET.LOADING_SHIFTROLES_MESSAGE"));

            var urls = [];
            if (vm.line.Award && vm.line.Award.Id) {
                urls.push(oldAwardAPI.getRolesByAwardAndBranch(vm.line.Award.Id));
                if (vm.service.timeSheet && vm.service.timeSheet.BranchId) {
                    urls.push(oldAwardAPI.getClassificationsByAwardAndBranch(vm.line.Award.Id, vm.service.timeSheet.BranchId));
                }
            }

            $q.all(urls)
                .then(function(resp) {

                    if (resp.length > 0) {
                        var _a_shiftRoles = resp[0].data || [];

                        angular.forEach(vm.service.shiftRoles, function(role, i) {
                            role.isDisabled = true;

                            var index = _.findIndex(_a_shiftRoles, {
                                Id: role.Id
                            });

                            if (index !== -1) {
                                role.isDisabled = false;
                            }

                            var selectedIndex = _.findIndex(vm.line.ShiftRoles, {
                                Id: role.Id
                            });

                            if (role.isDisabled && selectedIndex !== -1) {
                                vm.line.ShiftRoles.splice(selectedIndex, 1);
                            }
                        });

                        var _a_classifications = resp[1].data || [];
                        angular.forEach(vm.service.classifications, function(classification, i) {
                            classification.isDisabled = true;

                            var index = _.findIndex(_a_classifications, {
                                Id: classification.Id
                            });

                            if (index !== -1) {
                                classification.isDisabled = false;
                            }

                            if (classification.isDisabled && vm.line.AwardClassification && vm.line.AwardClassification.Id === classification.Id) {
                                vm.line.AwardClassification = null;
                            }
                        });
                    }
                    block.stop();
                })
                .catch(function() {
                    block.stop();
                });
        }
        function closeDialog() {
            $mdDialog.hide();
        }

        function saveRecalculatedAward() {
            var block = blockUI.instances.get('add-project');
            block.start(utils.translate("TIMESHEET.SAVING_AWARD_MESSAGE"));

            vm.allocatedResourceItemId = vm.service.allocatedResourceItems.find(x=> x.AllocatedId == vm.line.ContactId).Id;

            let params = {
                Award: vm.line.Award,
                AwardClassification: vm.line.AwardClassification,
                ShiftRoles: vm.line.ShiftRoles,
                NoMinimumShift: vm.line.NoMinimumShift
            };


            allocationApi.saveManageShiftAwards(vm.allocatedResourceItemId, params).then(function() {
                vm.isAwardClassificationRecalculated = false;
                block.stop();
            }).catch(function(err) {
                exceptionService.resolve(err);
                block.stop();
            });

        }

        function recalculateAwardClassification() {
            var block = blockUI.instances.get('add-project');
            block.start(utils.translate("TIMESHEET.RECALCULATE_AWARD_MESSAGE"));
            var alreadyHasAward = vm.line.Award != null;
            var alreadyHasAwardClassification = vm.line.AwardClassification != null;

            timesheetApi.recalculateAwardClassification(vm.service.ticketId, vm.line.ContactId)
                .then(function(resp) {

                    if (resp.data.id) {
                        vm.allocatedResourceItemId = resp.data.id;
                        if ((alreadyHasAward && vm.line.Award.Name !== resp.data.Award.Name) || (!alreadyHasAward && resp.data.Award)) {
                            vm.isAwardClassificationRecalculated = true;
                            vm.AwardInfoText = alreadyHasAward? utils.translate('TIMESHEET.AWARD_RECALCULATED_INFO') + `'${vm.line.Award.Name}'`: '';
                            vm.line.Award = resp.data.Award;
                        }

                        if ((alreadyHasAwardClassification && vm.line.AwardClassification.Name !== resp.data.AwardClassification.Name) || (!alreadyHasAwardClassification && resp.data.AwardClassification)) {
                            vm.isAwardClassificationRecalculated = true;
                            vm.ClassificationInfoText = alreadyHasAwardClassification? utils.translate('TIMESHEET.CLASSIFICATION_RECALCULATED_INFO') + `'${vm.line.AwardClassification.Name}'`:'';
                            vm.line.AwardClassification = resp.data.AwardClassification;
                        }
                    }
                    block.stop();
                })
                .catch(function(ex) {
                    block.stop();
                });
        }

        vm.activate();
    }
})();

 (function() {
     'use strict';

     angular.module('app.jobs.resourceWhiteboard')
         .directive('jobBoardRwComponent', jobBoardRwComponent);

     /** @ngInject */
     function jobBoardRwComponent(
         $timeout,
         $state,
         $mdDialog,
         $q,
         utils,
         _,
         ticketPdfService,
         ticketsApi,
         timesheetApi,
         jobsApi,
         exceptionService,
         blockUI,
         whiteboardClaimsService,
         DialogService,
         msgboxService,
         claimsUtilService,
         jobsWhiteboardApi2,
         resourceAllocateService,
         smartSchedulingService,
         tenantSettings,
         identityService
     ) {
         var directive = {
             restrict: 'E',
             templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/weekly/jweek.html',
             scope: {
                 headers: '=',
                 sourceData: '=',
                 isNavigating: '=',
                 allowGrouping: '=',
                 showProject: '=',
                 showResources: '=',
                 showRelatedTicketNumber: '=',
                 showWorkOrderNumber: '=',
                 removeTicket: '=',
                 whiteboardType: '=',
                 onCancelTicket: '&'
             },
             controller: JobBoardRwController,
             controllerAs: 'vm',
             bindToController: true
         };

         return directive;

         function JobBoardRwController($scope, allocationApi, _, externalApi) {
             var vm = this;

             // Data
             vm.disableBillingPref = whiteboardClaimsService.disableBillingPref;

             // Methods
             vm.onOpenEditTicket = openEditTicket;
             vm.openResourceAlloc = openResourceAlloc;
             vm.openTimesheet = openTimesheet;
             vm.cloneTicket = cloneTicket;
             vm.cancelTicket = cancelTicket;
             vm.addRelatedTicket = addRelatedTicket;
             vm.downloadPdf = downloadPdf;
             vm.ticketBillingPref = ticketBillingPref;
             vm.openCardTicket = openCardTicket;
             vm.addTicket = addTicket;
             vm.onDownloadPaperworkPdf = downloadPaperworkPdf;
             vm.onDownloadTimesheetPdf = downloadTimesheetPdf;
             vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();
             vm.preSchedule = preSchedule;
             vm.cancelScheduling= cancelScheduling;
             vm.hasSmartSchedulingAccess = claimsUtilService.hasSmartSchedulingAccess();
            vm.approveTicket = approveTicket;
            vm.rejectTicket = rejectTicket;

             activate();

             $scope.$on('Whiteboard:ExternalApprovalChanged', function(event, data){
                 try {
                     if (!vm.sourceData || !vm.sourceData.length) return;
                     var ticketId = data.TicketId || data.Id;
                     var ticketNumber = data.TicketNumber || data.TicketNo;

                     // Iterate all repeated items; each has day0..day6
                     angular.forEach(vm.sourceData, function(ticket){
                         var days = ['day0','day1','day2','day3','day4','day5','day6'];
                         angular.forEach(days, function(d){
                             var t = ticket[d];
                             if (!t) return;
                             var matches = (ticketId && t.id == ticketId) || (ticketNumber && (t.ticketNo == ticketNumber || t.TicketNumber == ticketNumber));
                            if (matches){
                               if (data.Status === 4) {
                                   // Preserve array shape; set to Awaiting Resourcing status object
                                   t.status = [{
                                       id: 4,
                                       name: 'Awaiting Resourcing',
                                       color: 'red',
                                       abbrev: 'AR',
                                       sortOrder: '1'
                                   }];

                                   t.IsLockedByPreSchedule = false;
                                   t.showEquipmentAllocationIcon = true;
                                   t.showRequireAllocationIcon = true;
                                   t.showShiftAllocationIcon = true;
                                   t.IsLocked = false;
                                   t.IsUnconfirmedDate = false;
                               } else {
                                    // Hide the nearest card container for this ticket
                                   $('#' + t.ticketNo).closest('.list-card').hide();
                               }
                           }
                         });
                     });
                     $scope.$evalAsync();
                 } catch(ex) {
                     // swallow
                 }
             });

             $scope.$on('Resource:Allocate', function(event, payLoad) {
                 if (payLoad.View === 'Weekly') {
                     _.forEach(vm.sourceData, function(row) {
                         _.each(row, function(day) {
                             _.forEach(day.allocatedResourceItems, function(itm) {
                                 if (itm.itemId == payLoad.CurrentItem.ItemId && itm.ticketId == payLoad.CurrentItem.TicketId && itm.id == payLoad.CurrentItem.Id) {
                                     var resourceIssues = (payLoad.Resource && payLoad.Resource.AllocationIssues) || [];
                                     var hasBlocking = resourceIssues.some(function(x) { return !x.CanBeOverriden && !x.IsValidToAllocate; });
                                     var needsOverride = !payLoad.Override && !hasBlocking && resourceIssues.some(function(x) { return x.CanBeOverriden && !x.IsValidToAllocate; });

                                     var proceed = function() {
                                         itm['isProcessing'] = true;
                                         let formattedPayload = formatPayload(payLoad);
                                         allocationApi.allocateResource(formattedPayload).then(function(resp) {
                                         if (resp.data) {
                                             let messages = "";
                                             let autoAllocationResults = resp.data.RelatedResourceAutoAllocationResults;

                                             // Escape user-editable names/messages before interpolating into the
                                             // $mdDialog htmlContent. Mirrors allocate-resource.service.js escapeHtml.
                                             let escapeHtml = function(value) {
                                                 if (value === null || value === undefined) return '';
                                                 return String(value)
                                                     .replace(/&/g, '&amp;')
                                                     .replace(/</g, '&lt;')
                                                     .replace(/>/g, '&gt;')
                                                     .replace(/"/g, '&quot;')
                                                     .replace(/'/g, '&#39;');
                                             };

                                             const groupBy = (array, fn) => {
                                                 var groups = {};
                                                 array.forEach(function(obj) {
                                                     var group = JSON.stringify(fn(obj));
                                                     (groups[group] = groups[group] || []).push(obj);
                                                 });

                                                 return groups;
                                             };

                                             if (autoAllocationResults && autoAllocationResults.length > 0) {
                                                 let relatedResourceName = resp.data.RelatedResourceName;
                                                 let relationToMainResource = resp.data.RelatedResourceRelationToMainResource;

                                                 messages = `Unable to allocate ${escapeHtml(relationToMainResource)} <strong>${escapeHtml(relatedResourceName)}</strong><br/><br/>`;

                                                 var groupedAllocationIssues = groupBy(autoAllocationResults, function(item) {
                                                     return [item.AllocationIssues];
                                                 });

                                                 let renderIssueList = function(issues) {
                                                     return '<ul class="allocation-errors">' + issues.map(x => `<li style="color:${!x.CanBeOverriden && !x.IsValidToAllocate ? '#d50000' : '#FF7800'}">${escapeHtml(x.Message)}</li>`).join("") + '</ul>';
                                                 };

                                                 messages += Object.keys(groupedAllocationIssues).map(function(key) {
                                                     let shiftsByIssue = groupedAllocationIssues[key];
                                                     // Issues are identical within a group (part of the group key); read
                                                     // them off the first item so we keep the objects (incl. SourceItemName).
                                                     let allocationIssues = (shiftsByIssue[0].AllocationIssues || []).flat();
                                                     let message = "";

                                                     // Dedup repeated headings within a group; the heading is the equipment
                                                     // or shift the operator is auto-allocated to. Guard EquipmentName first
                                                     // so a vehicle-only violation (ShiftName null) still prints its heading,
                                                     // matching the Allocate Resource page (both surfaces must behave alike).
                                                     let seenHeadings = new Set();
                                                     shiftsByIssue.forEach(x => {
                                                         let heading = x.EquipmentName || x.ShiftName;
                                                         if (heading && !seenHeadings.has(heading)) {
                                                             seenHeadings.add(heading);
                                                             message += `<strong>${escapeHtml(heading)}</strong><br/>`;
                                                         }
                                                     });

                                                     // Parent issues (no SourceItemName) render under the heading above;
                                                     // linked-item issues group under their own item name, stripping the
                                                     // redundant "(required by ...)" clause now conveyed by the heading.
                                                     let ownIssues = allocationIssues.filter(x => !x.SourceItemName);
                                                     if (ownIssues.length > 0) {
                                                         message += renderIssueList(ownIssues);
                                                     }

                                                     let bySource = {};
                                                     let sourceOrder = [];
                                                     allocationIssues.filter(x => x.SourceItemName).forEach(x => {
                                                         if (!bySource[x.SourceItemName]) {
                                                             bySource[x.SourceItemName] = [];
                                                             sourceOrder.push(x.SourceItemName);
                                                         }
                                                         let cleaned = angular.extend({}, x, {
                                                             Message: x.Message.replace(/\s*\(required by (?:trailer|equipment) "[^"]*"\)\s*$/i, '')
                                                         });
                                                         bySource[x.SourceItemName].push(cleaned);
                                                     });

                                                     sourceOrder.forEach(function(src) {
                                                         message += `<strong>${escapeHtml(src)}</strong><br/>` + renderIssueList(bySource[src]);
                                                     });

                                                     return message;
                                                 }).join("");
                                             }

                                             let allocationIssues = resp.data.AllocationIssues;
                                             if (allocationIssues && allocationIssues.length > 0) {
                                                 messages += '<ul class="allocation-errors">' + allocationIssues.map(x => `<li style="color:${!x.CanBeOverriden && !x.IsValidToAllocate ? '#d50000' : '#FF7800'}">${escapeHtml(x.Message)}</li>`).join("") + '</ul>';
                                             }

                                             // #51714/#51715 parity with the Allocate Resource page
                                             // (allocate-resource.service.js:1802-1825). The override
                                             // decision (needsOverride) above only inspects the panel
                                             // chips (Company/Project/Operator) BEFORE posting. When a
                                             // Medium shift skill only surfaces in the allocate RESPONSE
                                             // (the operator being auto-allocated to the shift), the
                                             // whiteboard previously rendered it as a blocking alert and
                                             // never prompted. Reveal the override-reason modal here and
                                             // re-post, so both surfaces behave identically (SPEC §2.4).
                                             var canPromptOverride = !payLoad.Override
                                                 && allocationIssues
                                                 && allocationIssues.some(function(x) { return x.CanBeOverriden && !x.IsValidToAllocate; })
                                                 && !allocationIssues.some(function(x) { return !x.CanBeOverriden && !x.IsValidToAllocate; });

                                             if (canPromptOverride) {
                                                 itm['isProcessing'] = false;
                                                 $mdDialog.show({
                                                     templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                                                     controller: 'overrideReasonDialogController as vm',
                                                     locals: { data: payLoad }
                                                 }).then(function(overrideResult) {
                                                     if (overrideResult) {
                                                         payLoad.Override = {
                                                             Reason: overrideResult.Reason,
                                                             OverrideUserId: identityService.userData.UserId
                                                         };
                                                         proceed();
                                                     }
                                                 });

                                                 return;
                                             }

                                             if (messages) {
                                                 var notif = $mdDialog.alert()
                                                     .parent(angular.element(document.body))
                                                     .clickOutsideToClose(false)
                                                     .title('Resource Whiteboard')
                                                     .htmlContent(messages)
                                                     .ariaLabel('Resource Whiteboard')
                                                     .ok('Ok')

                                                 $mdDialog.show(notif);
                                             }
                                         }
                                         else {
                                            msgboxService.alert('Resource Allocation', 'This ticket has been updated by another user. Please refresh the page', 'Okay').then(function(res) {
                                            });
                                         }

                                         itm['isProcessing'] = false;
                                     }).catch(function(err) {
                                         itm['isProcessing'] = false;
                                         exceptionService.resolve(err);
                                     });
                                     };

                                     if (needsOverride) {
                                         $mdDialog.show({
                                             templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                                             controller: 'overrideReasonDialogController as vm',
                                             locals: { data: payLoad }
                                         }).then(function(resp) {
                                             if (resp) {
                                                 payLoad.Override = {
                                                     Reason: resp.Reason,
                                                     OverrideUserId: identityService.userData.UserId
                                                 };
                                                 proceed();
                                             }
                                         });
                                     } else {
                                         proceed();
                                     }
                                 }
                             });
                         })
                     });
                 }
             });

             function formatPayload(payLoad) {
                 return {
                     AllocatedCode: payLoad.Resource.Code,
                     AllocatedId: payLoad.Resource.Id,
                     AllocatedItemName: payLoad.Resource.Name,
                     AllocatedResourceItemId: payLoad.CurrentItem.Id,
                     EndDate: null,
                     Id: payLoad.CurrentItem.Id,
                     ItemId: payLoad.CurrentItem.ItemId,
                     IsOverridden: !_.isNil(payLoad.Override) ? true : false,
                     OverrideUserId: !_.isNil(payLoad.Override) ? payLoad.Override.OverrideUserId : null,
                     OverrideReason: !_.isNil(payLoad.Override) ? payLoad.Override.Reason : null,
                     PreviousAllocatedId: null,
                     Process: null,
                     IsMultidayEquipmentJob: false,
                     ResourceType: payLoad.CurrentItem.ResourceType,
                     StartDate: null,
                     TicketId: payLoad.CurrentItem.TicketId
                 }
             }

             $scope.$on('Resource:Deallocate', function(event, payLoad) {
                 if (payLoad.View === 'Weekly') {
                     _.forEach(vm.sourceData, function(row) {
                         _.each(row, function(day) {
                             _.forEach(day.allocatedResourceItems, async function(itm) {
                                 if (itm.itemId == payLoad.itemId && itm.ticketId == payLoad.ticketId && itm.id == payLoad.id) {
                                    itm['isProcessing'] = true;

                                    try{
                                        await allocationApi.unAllocateResourceRegular({
                                            Id: itm.id
                                        });

                                        itm['isProcessing'] = false;
                                    }
                                    catch(ex){
                                        itm['isProcessing'] = false;
                                        exceptionService.resolve(ex);
                                    }
                                 }
                             });
                         })
                     });
                 }
             });

             function activate() {
                 setDefaultContentSize();
             }

             function openEditTicket(value) {
                 blockUI.start({
                     message: 'Loading Ticket...'
                 });
                 $state.go('app.jobs_update', {
                     id: value.id,
                     ticketNumber: value.ticketNo,
                     parentTicketNo: value.parentTicketNo
                 });
             }

             function openResourceAlloc(value) {
                 $state.go('app.allocate', {
                     id: value.id,
                     ticketNo: value.ticketNo,
                     parentTicketNo: value.parentTicketNo
                 });
             }

             function openTimesheet(value) {
                 $state.go('app.timesheet', {
                     id: value.id,
                     isLocked: value.isLocked,
                     isLockedByPreSchedule: value.isLockedByPreSchedule,
                     TicketNo: value.ticketNo
                 });
             }

             function downloadPaperworkPdf(value) {
                 ticketPdfService.getPaperworkPDF(value.id, value.ticketNo)
                     .then(function(resp) {}).catch(function(ex) {
                         exceptionService.resolve(ex);
                     });
             }

             function downloadTimesheetPdf(value) {
                 ticketPdfService.getPaperworkPDF(value.id, value.ticketNo)
                     .then(function(resp) {}).catch(function(ex) {
                         exceptionService.resolve(ex);
                     });
             }

             function cloneTicket(value) {
                 blockUI.start({
                     message: 'Checking related ticket...'
                 });
                 ticketsApi.getRelatedTicket(value.id).then(function(resp) {
                     blockUI.stop();
                     var related = {
                         ticketId: resp.data.Id,
                         ticketNumber: resp.data.TicketNumber
                     };
                     $state.go('app.jobs_clone', {
                         cloneId: value.id,
                         related: related
                     });
                 }).catch(function(ex) {
                     blockUI.stop();
                     exceptionService.resolve(ex);
                 });
             }

             async function cancelTicket(value) {
                 const hasExportedTimesheets = (await timesheetApi.checkIfTimesheetExported(value.id)).data;

                 if (hasExportedTimesheets) {
                    msgboxService.alert(
                        utils.translate('SB.CANCEL_TICKET_TITLE'),
                        utils.translate('SB.CANCEL_TICKET_MESSAGE'),
                        utils.translate('SB.CANCEL_TICKET_OKAY'));
                     return;
                 } else {
                     let dialog = showCancelTicketDialog({
                         Id: value.id,
                         TicketNumber: value.ticketNo,
                         TicketType: value.ticketType
                     });

                     $mdDialog.show(dialog).then(function(res) {
                         if (res) {
                             blockUI.start('Cancelling Ticket...')
                             performCancelTicket(value.id, res.reason, res.chargeMinHours).then(success).catch(failed);
                         }
                     });
                 }

                 function success(resp) {
                     let ticketNumbers = resp.data;

                     (vm.onCancelTicket || angular.noop)({
                         cancelledTickets: {
                             tickets: ticketNumbers
                         }
                     });

                     blockUI.stop();
                     cancelSuccess(value.ticketNo);
                 }

                 function failed(ex) {
                     blockUI.stop();
                     exceptionService.resolve(_.isNil(ex.data) ? ex : ex.data.Message);
                 }
             }

             function cancelSuccess(ticketNumber) {
                 let notification = $mdDialog.confirm()
                     .title('Cancel Ticket')
                     .textContent('Ticket #' + ticketNumber + ' has been cancelled.')
                     .ariaLabel('Cancel Ticket')
                     .ok('Ok')

                 $mdDialog.show(notification)
             }

             function showCancelTicketDialog(ticket) {
                 let dialog = {
                     locals: {
                         ticket: angular.copy(ticket)
                     },
                     templateUrl: 'app/main/jobs/services/cancelReasonDialog/cancel-reason.html',
                     controller: 'CancelReasonController as vm'
                 }
                 return dialog;
             }

             function performCancelTicket(ticketId, reason, chargeMinHours) {
                 return jobsApi.cancelTicket(ticketId, reason, chargeMinHours);
             }

             function addRelatedTicket(value) {
                 blockUI.start({
                     message: 'Checking related ticket...'
                 });
                 ticketsApi.getRelatedTicket(value.id)
                     .then(function(resp) {
                         blockUI.stop();
                         var related = {
                             ticketId: resp.data.Id,
                             ticketNumber: resp.data.TicketNumber
                         };
                         $state.go('app.jobs_manage', {
                             related: related
                         });
                     }).catch(function(ex) {
                         blockUI.stop();
                         exceptionService.resolve(ex);
                     });
             }

             function downloadPdf(value) {
                 getTicketPDF(value.id);
             }

             function getTicketPDF(id) {
                 ticketPdfService.getTicketPDF(id);
             }

             function ticketBillingPref(value) {
                const [month1, month2, yearAndTime] = value.dt.split('/');
                const year = yearAndTime.slice(0, 4);
                const month = tenantSettings.countryCode === 'US' || tenantSettings.countryCode === 'CA' ? month1 : month2;

                 $state.go('app.related-ticket-billing', {
                     Id: value.id,
                     Month: month,
                     Year: year
                 });
             }

             function openCardTicket(ticket) {
                 let clonedTicket = angular.copy(ticket);
                 let objParam = {
                     id: clonedTicket.id,
                     ticketNo: clonedTicket.ticketNo,
                     ticketCount: clonedTicket.ticketCount,
                     tickets: clonedTicket.tickets,
                     type: 'weekview',
                     companyCode: clonedTicket.companyCode,
                     date: clonedTicket.startDate
                 };
                 DialogService.openTicketDialog(objParam);
             }

             function addTicket(ev, date) {
                 let dt = moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
                 $state.go('app.jobs_manage', {
                     dt: dt
                 });
             }

             function approveTicket(ticket) {
               if (!ticket) { return; }
               var dialog = {
                 template:
                   '<md-dialog aria-label="Approve Ticket" class="md-dialog-full-width">' +
                   '  <form>' +
                   '    <md-toolbar>' +
                   '      <div class="md-toolbar-tools">' +
                   '        <h2>Approve Ticket</h2>' +
                   '      </div>' +
                   '    </md-toolbar>' +
                   '    <md-dialog-content style="width:700px;">' +
                   '      <div class="md-dialog-content">' +
                   '        <md-input-container class="md-block">' +
                   '          <label>Comments (optional)</label>' +
                   '          <textarea ng-model="vm.comment" rows="3" md-maxlength="2000" maxlength="2000" style="min-width: 100%;"></textarea>' +
                   '        </md-input-container>' +
                   '      </div>' +
                   '    </md-dialog-content>' +
                   '    <md-dialog-actions layout="row" layout-align="end center">' +
                   '      <md-button ng-click="vm.cancel()">Cancel</md-button>' +
                   '      <md-button class="md-primary" ng-click="vm.ok()">OK</md-button>' +
                   '    </md-dialog-actions>' +
                   '  </form>' +
                   '</md-dialog>',
                 controller: function($mdDialog) {
                   var vm = this;
                   vm.comment = '';
                   vm.cancel = function(){ $mdDialog.cancel(); };
                   vm.ok = function(){ $mdDialog.hide(vm.comment); };
                 },
                 controllerAs: 'vm',
                 clickOutsideToClose: true
               };

               $mdDialog.show(dialog)
                 .then(function(comment){
                     var data = { IsApproved: true, Etag: ticket.etag };
                     if (comment) { data.ApproverComments = comment; }
                     return externalApi.approveOrRejectTicket(ticket.id, data);
                 })
                 .catch(e => {
                        exceptionService.resolve(e);
                    });
           }

            function rejectTicket(ticket) {
                if (!ticket) { return; }
                var dialog = {
                  template:
                    '<md-dialog aria-label="Reject Ticket" class="md-dialog-full-width">' +
                    '  <form>' +
                    '    <md-toolbar>' +
                    '      <div class="md-toolbar-tools">' +
                    '        <h2>Reject Ticket</h2>' +
                    '      </div>' +
                    '    </md-toolbar>' +
                    '    <md-dialog-content style="width:700px;">' +
                    '      <div class="md-dialog-content">' +
                    '        <md-input-container class="md-block">' +
                    '          <label>Comments (optional)</label>' +
                    '          <textarea ng-model="vm.comment" rows="3" md-maxlength="2000" maxlength="2000" style="min-width: 100%;"></textarea>' +
                    '        </md-input-container>' +
                    '      </div>' +
                    '    </md-dialog-content>' +
                    '    <md-dialog-actions layout="row" layout-align="end center">' +
                    '      <md-button ng-click="vm.cancel()">Cancel</md-button>' +
                    '      <md-button class="md-warn" ng-click="vm.ok()">OK</md-button>' +
                    '    </md-dialog-actions>' +
                    '  </form>' +
                    '</md-dialog>',
                  controller: function($mdDialog) {
                    var vm = this;
                    vm.comment = '';
                    vm.cancel = function(){ $mdDialog.cancel(); };
                    vm.ok = function(){ $mdDialog.hide(vm.comment); };
                  },
                  controllerAs: 'vm',
                  clickOutsideToClose: true
                };

                $mdDialog.show(dialog)
                  .then(function(comment){
                    var data = { IsApproved: false, Etag: ticket.etag };
                    if (comment) { data.ApproverComments = comment; }
                    return externalApi.approveOrRejectTicket(ticket.id, data);
                  })
                  .catch(e => {
                        exceptionService.resolve(e);
                    });
            }

             /**
              * very essential in calculating size of virtual scroll wrapper
              */
             function setDefaultContentSize() {
                 $timeout(function() {
                     var boardEl = angular.element('#board');
                     var boardElHeight = boardEl.height() - 90;
                     var result = document.getElementsByClassName('list-wrapper');
                     var wrappedResult = angular.element(result);
                     var w = (angular.element(wrappedResult[0]).width() * 7);
                     var bw = w + 100;

                     var virtualRepeatContainer = angular.element('#vertical-container');

                     virtualRepeatContainer.css('min-height', boardElHeight + 'px');
                     virtualRepeatContainer.css('min-width', w + 'px');
                     boardEl.css('min-width', bw + 'px');
                 });
             }

            async function preSchedule(value) {

                if (!claimsUtilService.isSmartSchedulingEnabled()) {
                    smartSchedulingService.showScheduleBooking();
                    return;
                }

                var allocatedResources = await allocationApi.fetchTicket(value.id);
                resourceAllocateService.assignDisplayName(allocatedResources.data);
                resourceAllocateService.allocatedResource = allocatedResources.data;

                var unallocatedPeople = resourceAllocateService.allocatedResource.filter(x => x.ItemType == 4 && !x.AllocatedId);
                var unallocatedAssets = resourceAllocateService.allocatedResource.filter(x => x.ItemType == 1 && (!x.AllocatedId && !x.AssignedOperatorId));
                var deferred = $q.defer();

                smartSchedulingService.showAllocationDialog(unallocatedPeople, unallocatedAssets)
                .then(async function(data){
                    if(!data){
                        return;
                    }

                    blockUI.start("Initiating Scheduling Copilot...");

                    let result = await smartSchedulingService.generateSchedule(value.id, data);

                    $timeout(async function(){
                        blockUI.stop();
                    });

                    if (result && result.data && result.data.ErrorMessage) {
                        isSuccess = false;

                        await msgboxService.alert(
                            utils.translate(
                                "RESOURCEALLOCATION.SMART_SCHEDULING_FAILED_TITLE_DIALOG"
                            ),
                            result.data.ErrorMessage,
                            utils.translate(
                                "RESOURCEALLOCATION.CLOSE"
                            )
                        );
                    }

                    value.ticket.IsLockedByPreSchedule = true;
                    ticket.IsLockedByPreSchedule = true;

                    var headerCard = document.getElementById(ticket.TicketNumber.toString()).getElementsByClassName('list-card-label2')[0];
                    headerCard.classList.remove("md-red-bg");
                    headerCard.classList.remove("md-orange-bg");
                    headerCard.classList.add("md-purple-200-bg");

                    var aiScheduleHeaderIcon = document.getElementById(ticket.TicketNumber.toString()).getElementsByClassName('smart-schedule-rw-top')[0];
                    aiScheduleHeaderIcon.classList.remove("ng-hide");

                    deferred.resolve();
                });

                return deferred.promise;
            }

             async function cancelScheduling(value) {
                 try {
                     blockUI.start('Cancelling Scheduling Copilot...');

                     let jobTickets = await jobsApi.getTicketByTicketId(value.id);
                     let ticket = jobTickets.data;

                     var cancelStatus = await smartSchedulingService.cancelScheduling(ticket.LatestPreScheduleJobId)

                     value.IsLockedByPreSchedule = false;

                     let status = jobsWhiteboardApi2.getStatusInfo(cancelStatus.data[0].Status);

                     var headerCard = document.getElementById(ticket.TicketNumber.toString()).getElementsByClassName('list-card-label2')[0];

                     headerCard.classList.remove("md-purple-200-bg");

                     if (status.abbrev === 'AR') {
                         headerCard.classList.add("md-red-bg");
                     } else {
                         headerCard.classList.add("md-orange-bg");
                     }

                     $timeout(function () {
                         blockUI.stop();
                     })
                 } catch (ex) {
                     blockUI.stop();
                 }
            }

         }
     }

 })();

(function() {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .directive('jobBoardTicketNumber', jobBoardTicketNumber);

    /** @ngInject */
    function jobBoardTicketNumber() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/ticketInfoNumber/ticketNumber.directive.html',
            scope: {
                ticketNumber: '=',
                isLocked: '=',                
                isLockedByPreSchedule: '=',
                showRelated: '=',
                relatedNumber: '=',
                allowGroupByClient: '=',
                whiteboardType: '=',
                purchaseOrderNumber: '=',
                workOrderNumber: '=',
                showWorkOrderNumber: '='
            },
            controller: DayViewController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DayViewController() {
            var vm = this;
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .directive('jobBoardResourcesComponent', jobBoardResourcesComponent);

    /** @ngInject */
    function jobBoardResourcesComponent() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/resources/jobBoardResources.html',
            scope: {
                ticket: '='
            },
            controller: DayViewController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DayViewController(
            resourceSidenavService,
            msgboxService,
            $rootScope,
            messageStatusService,
            claimsUtilService,
            dateNavigationService,
            resourceAllocateService,
            $mdDialog,
            utils,
            $state,
            allocationApi,
            smartSchedulingService
        ) {
            var vm = this;
            vm.isAllocated = isAllocated;
            vm.getAvailableResources = getAvailableResources;
            vm.messageStatusService = messageStatusService;
            vm.deallocate = deallocate;
            vm.getClass = getClass;
            vm.isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
            vm.isUnconfirmedDateCanAllocateResources = isUnconfirmedDateCanAllocateResources;
            vm.companiesOkToAllocate = new Set();
            vm.companiesOnCreditHold = new Set();
            vm.isSmartSchedulingEnabled = (claimsUtilService.isSmartSchedulingEnabled());

            function deallocate(itm) {
                itm.TicketId = itm.ticketId;
                itm.AllocatedId = itm.allocatedId;
                resourceAllocateService.hasASubmittedTimesheet(itm, false)
                    .then(function(isSubmitted) {
                        if (isSubmitted) {
                            var dialog = $mdDialog
                                .confirm()
                                .title("")
                                .htmlContent(utils.translate('RESOURCEALLOCATION.REMOVE_RESOURCE_WITH_SUBMITTED_TIMESHEET'))
                                .ok("GO TO TIMESHEET")
                                .cancel("CANCEL");

                            $mdDialog.show(dialog)
                                .then(function() {
                                    $state.go('app.timesheet', {
                                        id: itm.ticketId,
                                        TicketNo: itm.ticketNumber
                                    });
                                });
                        } else {
                            let title = 'Resource Whiteboard';
                            itm['View'] = getView();
                            var confirm = confirmGenerator(title, utils.translate('RESOURCEALLOCATION.REMOVE_RESOURCE_MESSSAGE'), utils.translate('RESOURCEALLOCATION.CONFIRMATION'), utils.translate('RESOURCEALLOCATION.YES'), utils.translate('RESOURCEALLOCATION.CANCEL'));

                            $mdDialog.show(confirm)
                                .then(async function(resp) {
                                    if (resp)
                                    {
                                        $rootScope.$broadcast('Resource:Deallocate', itm);
                                        
                                        let result = await smartSchedulingService.getLinkedPreScheduleJobs(itm.TicketId);
                                        let prescheduleJobIds = result.data.map(x => x.Id);
                                        await smartSchedulingService.updatePreScheduleJobStatus(prescheduleJobIds);
                                    }
                                });
                        }
                    });
            }

            function getView() {
                return dateNavigationService.isDaily ? 'Daily' : 'Weekly';
            }

            function isAllocated(allocatedProp) {
                return allocatedProp == null ? false : true;
            }

            function getClass(status) {
                let list = [{
                        Id: 0,
                        Class: 'text-italic grey-700-fg'
                    },
                    {
                        Id: 1,
                        Class: 'text-italic yellow-700-fg'
                    },
                    {
                        Id: 2,
                        Class: 'text-italic grey-700-fg'
                    },
                    {
                        Id: 3,
                        Class: 'text-italic blue-700-fg'
                    },
                    {
                        Id: 4,
                        Class: 'text-italic deep-purple-700-fg'
                    },
                    {
                        Id: 5,
                        Class: 'text-italic orange-700-fg'
                    },
                    {
                        Id: 6,
                        Class: 'text-italic red-700-fg'
                    },
                    {
                        Id: 7,
                        Class: 'text-italic teal-700-fg'
                    },
                    {
                        Id: 9,
                        Class: 'text-italic red-700-fg'
                    }
                ];

                return list.find(function(l) {
                        return l.Id === status;
                    })
                    .Class;
            }

            async function getAvailableResources(ticket, itm) {
                if (ticket.IsUnconfirmedDate && !isAllocated(itm.allocatedId)) {
                    return;
                }

                if (ticket.IsLocked || (ticket.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled)) {
                    return;
                }

                if (ticket.ticketType == 4) {
                    msgboxService.alert('Resource Whiteboard', 'You cannot allocate resource(s) to Plan Only Jobs', 'Close');
                    return;
                }

                if (vm.companiesOkToAllocate.has(ticket.companyCode)) {
                    resourceSidenavService.openSideNav(ticket, itm);
                    return;
                }

                if (vm.companiesOnCreditHold.has(ticket.companyCode)) {
                    msgboxService.alert('Resource Allocation', utils.translate('RESOURCEALLOCATION.CREDIT_HOLD_MESSAGE_CONFIRM'), utils.translate('Close'));
                    return;
                }

                var resp = await allocationApi.getCompanyCreditType(ticket.id);
                if (resp.data.CanAllocateResources) {
                    vm.companiesOkToAllocate.add(ticket.companyCode);
                    resourceSidenavService.openSideNav(ticket, itm);
                    return;
                }

                vm.companiesOnCreditHold.add(ticket.companyCode);
                msgboxService.alert('Resource Allocation', utils.translate('RESOURCEALLOCATION.CREDIT_HOLD_MESSAGE_CONFIRM'), utils.translate('Close'));
            }

            function confirmGenerator(title, content, ariaLabel, okMessage, cancelMessage) {
                return $mdDialog.confirm()
                    .title(title)
                    .textContent(content)
                    .ariaLabel(ariaLabel)
                    .ok(okMessage)
                    .cancel(cancelMessage);
            }

            function isUnconfirmedDateCanAllocateResources(IsUnconfirmedDate, allocatedId) {
                return IsUnconfirmedDate && !vm.isAllocated(allocatedId)
            }
        }
    }
})();

/**
 * JobBoard Day View Component
 * Feeds data from outside source
 * Created date: 8.25.2016
 * by Rcnet
 */
(function() {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .directive('jobBoardDayViewRwComponent', jobBoardDayViewRwComponent);

    /** @ngInject */
    function jobBoardDayViewRwComponent(
        $state,
        allocationApi,
        $mdDialog,
        utils,
        _,
        DialogService,
        msgboxService,
        ticketPdfService,
        jobsApi,
        ticketsApi,
        timesheetApi,
        whiteboardClaimsService,
        localisationService,
        exceptionService,
        blockUI,
        claimsUtilService,
        jobsWhiteboardApi2,
        $timeout,
        resourceAllocateService,
        smartSchedulingService,
        tenantSettings,
        $q,
        externalApi,
        identityService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceWhiteboard/wboard/daily/jday.html',
            scope: {
                header: '=',
                currentDate: '=',
                sourceData: '=',
                isNavigating: '=',
                allowGrouping: '=',
                showProject: '=',
                showResources: '=',
                showRelatedTicketNumber: '=',
                showWorkOrderNumber: '=',
                removeTicket: '=',
                whiteboardType: '=',
                onCancelTicket: '&',
            },
            controller: DayViewController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function DayViewController($scope, _) {
            var vm = this;
            vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();
            vm.hasSmartSchedulingAccess = claimsUtilService.hasSmartSchedulingAccess();
            // Listen for external approval changes and update UI accordingly
            $scope.$on('Whiteboard:ExternalApprovalChanged', function(event, data){
                try {
                    if (!vm.sourceData || !vm.sourceData.length) return;
                    var ticketId = data.TicketId || data.Id;
                    var ticketNumber = data.TicketNumber || data.TicketNo;

                    // vm.sourceData is an array of arrays (tickets)
                    angular.forEach(vm.sourceData, function(tickets){
                        angular.forEach(tickets, function(t){
                            if (!t) return;
                            var matches = (ticketId && t.id == ticketId) || (ticketNumber && (t.ticketNo == ticketNumber || t.TicketNumber == ticketNumber));
                            if (matches){
                                if (data.Status === 4) {
                                    // Set to Awaiting Resourcing status object
                                    t.status = [{
                                        id: 4,
                                        name: 'Awaiting Resourcing',
                                        color: 'red',
                                        abbrev: 'AR',
                                        sortOrder: '1'
                                    }];

                                    t.IsLockedByPreSchedule = false;
                                    t.showEquipmentAllocationIcon = true;
                                    t.showRequireAllocationIcon = true;
                                    t.showShiftAllocationIcon = true;
                                    t.IsLocked = false;
                                    t.IsUnconfirmedDate = false;
                                } else {
                                    // Hide the visual card for this ticket number
                                    $('#' + t.ticketNo).closest('.list-card').hide();
                                }
                            }
                        });
                    });
                    $scope.$evalAsync();
                } catch(ex) {
                    // swallow
                }
            });
            $scope.$on('Resource:Allocate', function(event, payLoad) {
                if (payLoad.View === 'Daily') {
                    angular.forEach(vm.sourceData, function(data) {
                        angular.forEach(data, function(d) {
                            angular.forEach(d.allocatedResourceItems, function(itm) {
                                if (itm.itemId == payLoad.CurrentItem.ItemId && itm.ticketId == payLoad.CurrentItem.TicketId && itm.id == payLoad.CurrentItem.Id) {
                                    var resourceIssues = (payLoad.Resource && payLoad.Resource.AllocationIssues) || [];
                                    var hasBlocking = resourceIssues.some(function(x) { return !x.CanBeOverriden && !x.IsValidToAllocate; });
                                    var needsOverride = !payLoad.Override && !hasBlocking && resourceIssues.some(function(x) { return x.CanBeOverriden && !x.IsValidToAllocate; });

                                    var proceed = function() {
                                        itm['isProcessing'] = true;
                                        let formattedPayload = formatPayload(payLoad);
                                        allocationApi.allocateResource(formattedPayload).then(function(resp) {
                                        if (resp.data) {
                                            let messages = "";
                                            let autoAllocationResults = resp.data.RelatedResourceAutoAllocationResults;

                                            // Escape user-editable names/messages before interpolating into the
                                            // $mdDialog htmlContent. Mirrors allocate-resource.service.js escapeHtml.
                                            let escapeHtml = function(value) {
                                                if (value === null || value === undefined) return '';
                                                return String(value)
                                                    .replace(/&/g, '&amp;')
                                                    .replace(/</g, '&lt;')
                                                    .replace(/>/g, '&gt;')
                                                    .replace(/"/g, '&quot;')
                                                    .replace(/'/g, '&#39;');
                                            };

                                            const groupBy = (array, fn) => {
                                                var groups = {};
                                                array.forEach(function(obj) {
                                                    var group = JSON.stringify(fn(obj));
                                                    (groups[group] = groups[group] || []).push(obj);
                                                });

                                                return groups;
                                            };

                                            if (autoAllocationResults && autoAllocationResults.length > 0) {
                                                let relatedResourceName = resp.data.RelatedResourceName;
                                                let relationToMainResource = resp.data.RelatedResourceRelationToMainResource;

                                                messages = `Unable to allocate ${escapeHtml(relationToMainResource)} <strong>${escapeHtml(relatedResourceName)}</strong><br/><br/>`;

                                                var groupedAllocationIssues = groupBy(autoAllocationResults, function(item) {
                                                    return [item.AllocationIssues];
                                                });

                                                let renderIssueList = function(issues) {
                                                    return '<ul class="allocation-errors">' + issues.map(x => `<li style="color:${!x.CanBeOverriden && !x.IsValidToAllocate ? '#d50000' : '#FF7800'}">${escapeHtml(x.Message)}</li>`).join("") + '</ul>';
                                                };

                                                messages += Object.keys(groupedAllocationIssues).map(function(key) {
                                                    let shiftsByIssue = groupedAllocationIssues[key];
                                                    // Issues are identical within a group (part of the group key); read
                                                    // them off the first item so we keep the objects (incl. SourceItemName).
                                                    let allocationIssues = (shiftsByIssue[0].AllocationIssues || []).flat();
                                                    let message = "";

                                                    // Dedup repeated headings within a group; the heading is the equipment
                                                    // or shift the operator is auto-allocated to. Guard EquipmentName first
                                                    // so a vehicle-only violation (ShiftName null) still prints its heading,
                                                    // matching the Allocate Resource page (both surfaces must behave alike).
                                                    let seenHeadings = new Set();
                                                    shiftsByIssue.forEach(x => {
                                                        let heading = x.EquipmentName || x.ShiftName;
                                                        if (heading && !seenHeadings.has(heading)) {
                                                            seenHeadings.add(heading);
                                                            message += `<strong>${escapeHtml(heading)}</strong><br/>`;
                                                        }
                                                    });

                                                    // Parent issues (no SourceItemName) render under the heading above;
                                                    // linked-item issues group under their own item name, stripping the
                                                    // redundant "(required by ...)" clause now conveyed by the heading.
                                                    let ownIssues = allocationIssues.filter(x => !x.SourceItemName);
                                                    if (ownIssues.length > 0) {
                                                        message += renderIssueList(ownIssues);
                                                    }

                                                    let bySource = {};
                                                    let sourceOrder = [];
                                                    allocationIssues.filter(x => x.SourceItemName).forEach(x => {
                                                        if (!bySource[x.SourceItemName]) {
                                                            bySource[x.SourceItemName] = [];
                                                            sourceOrder.push(x.SourceItemName);
                                                        }
                                                        let cleaned = angular.extend({}, x, {
                                                            Message: x.Message.replace(/\s*\(required by (?:trailer|equipment) "[^"]*"\)\s*$/i, '')
                                                        });
                                                        bySource[x.SourceItemName].push(cleaned);
                                                    });

                                                    sourceOrder.forEach(function(src) {
                                                        message += `<strong>${escapeHtml(src)}</strong><br/>` + renderIssueList(bySource[src]);
                                                    });

                                                    return message;
                                                }).join("");
                                            }

                                            let allocationIssues = resp.data.AllocationIssues;
                                            if (allocationIssues && allocationIssues.length > 0) {
                                                messages += '<ul class="allocation-errors">' + allocationIssues.map(x => `<li style="color:${!x.CanBeOverriden && !x.IsValidToAllocate ? '#d50000' : '#FF7800'}">${escapeHtml(x.Message)}</li>`).join("") + '</ul>';
                                            }

                                            // #51714/#51715 parity with the Allocate Resource page
                                            // (allocate-resource.service.js:1802-1825). needsOverride above
                                            // only inspects the panel chips (Company/Project/Operator)
                                            // BEFORE posting. When a Medium shift skill only surfaces in the
                                            // allocate RESPONSE (the operator being auto-allocated to the
                                            // shift), the whiteboard previously rendered it as a blocking
                                            // alert and never prompted. Reveal the override-reason modal here
                                            // and re-post, so both surfaces behave identically (SPEC §2.4).
                                            var canPromptOverride = !payLoad.Override
                                                && allocationIssues
                                                && allocationIssues.some(function(x) { return x.CanBeOverriden && !x.IsValidToAllocate; })
                                                && !allocationIssues.some(function(x) { return !x.CanBeOverriden && !x.IsValidToAllocate; });

                                            if (canPromptOverride) {
                                                itm['isProcessing'] = false;
                                                $mdDialog.show({
                                                    templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                                                    controller: 'overrideReasonDialogController as vm',
                                                    locals: { data: payLoad }
                                                }).then(function(overrideResult) {
                                                    if (overrideResult) {
                                                        payLoad.Override = {
                                                            Reason: overrideResult.Reason,
                                                            OverrideUserId: identityService.userData.UserId
                                                        };
                                                        proceed();
                                                    }
                                                });

                                                return;
                                            }

                                            if (messages) {
                                                var notif = $mdDialog.alert()
                                                    .parent(angular.element(document.body))
                                                    .clickOutsideToClose(false)
                                                    .title('Resource Whiteboard')
                                                    .htmlContent(messages)
                                                    .ariaLabel('Resource Whiteboard')
                                                    .ok('Ok')

                                                $mdDialog.show(notif);
                                            }
                                        }
                                        else {
                                            msgboxService.alert('Resource Allocation', 'This ticket has been updated by another user. Please refresh the page', 'Okay').then(function(res) {
                                            });
                                        }

                                        itm['isProcessing'] = false;
                                    }).catch(function(err) {
                                        itm['isProcessing'] = false;
                                        exceptionService.resolve(err);
                                    });
                                    };

                                    if (needsOverride) {
                                        $mdDialog.show({
                                            templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                                            controller: 'overrideReasonDialogController as vm',
                                            locals: { data: payLoad }
                                        }).then(function(resp) {
                                            if (resp) {
                                                payLoad.Override = {
                                                    Reason: resp.Reason,
                                                    OverrideUserId: identityService.userData.UserId
                                                };
                                                proceed();
                                            }
                                        });
                                    } else {
                                        proceed();
                                    }
                                }
                            });
                        });
                    });
                }
            });

            function formatPayload(payLoad) {
                return {
                    AllocatedCode: payLoad.Resource.Code,
                    AllocatedId: payLoad.Resource.Id,
                    AllocatedItemName: payLoad.Resource.Name,
                    AllocatedResourceItemId: payLoad.CurrentItem.Id,
                    EndDate: null,
                    Id: payLoad.CurrentItem.Id,
                    ItemId: payLoad.CurrentItem.ItemId,
                    IsOverridden: !_.isNil(payLoad.Override) ? true : false,
                    OverrideUserId: !_.isNil(payLoad.Override) ? payLoad.Override.OverrideUserId : null,
                    OverrideReason: !_.isNil(payLoad.Override) ? payLoad.Override.Reason : null,
                    PreviousAllocatedId: null,
                    Process: null,
                    IsMultidayEquipmentJob: false,
                    ResourceType: payLoad.CurrentItem.ResourceType,
                    StartDate: null,
                    TicketId: payLoad.CurrentItem.TicketId
                }
            }

            //Deallocate Resource
            $scope.$on('Resource:Deallocate', function(event, payLoad) {
                if (payLoad.View === 'Daily') {
                    angular.forEach(vm.sourceData, function(data) {
                        angular.forEach(data, function(d) {
                            angular.forEach(d.allocatedResourceItems, async function(itm) {
                                if (itm.itemId == payLoad.itemId && itm.ticketId == payLoad.ticketId && itm.id == payLoad.id) {
                                    itm['isProcessing'] = true;

                                    try{
                                        await allocationApi.unAllocateResourceRegular({
                                            Id: itm.id
                                        });

                                        itm['isProcessing'] = false;
                                    }
                                    catch(ex){
                                        itm['isProcessing'] = false;
                                        exceptionService.resolve(ex);
                                    }
                                }
                            });
                        });
                    });
                }
            });
            //Deallocate Resource

            // Data
            vm.disableBillingPref = whiteboardClaimsService.disableBillingPref;

            // Methods
            vm.onOpenEditTicket = openEditTicket;
            vm.openResourceAlloc = openResourceAlloc;
            vm.openTimesheet = openTimesheet;
            vm.cloneTicket = cloneTicket;
            vm.cancelTicket = cancelTicket;
            vm.addRelatedTicket = addRelatedTicket;
            vm.downloadPdf = downloadPdf;
            vm.ticketBillingPref = ticketBillingPref;
            vm.openCardTicket = openCardTicket;
            vm.addTicket = addTicket;
            vm.onDownloadPaperworkPdf = downloadPaperworkPdf;
            vm.onDownloadTimesheetPdf = downloadTimesheetPdf;
            vm.preSchedule = preSchedule;
            vm.cancelScheduling = cancelScheduling;
            vm.approveTicket = approveTicket;
            vm.rejectTicket = rejectTicket;
            var localeSettings = {};

            activate();

            function activate() {
                localeSettings = localisationService.getLocaleFormatSettings();
            }

            function openEditTicket(value) {
                blockUI.start({
                    message: 'Loading Ticket...'
                });
                $state.go('app.jobs_update', {
                    id: value.id,
                    ticketNumber: value.ticketNo,
                    parentTicketNo: value.parentTicketNo
                });
            }

            function openResourceAlloc(value) {
                $state.go('app.allocate', {
                    id: value.id,
                    ticketNo: value.ticketNo,
                    parentTicketNo: value.parentTicketNo
                });
            }

            function openTimesheet(value) {
                $state.go('app.timesheet', {
                    id: value.id,
                    isLocked: value.isLocked,
                    isLockedByPreSchedule: value.isLockedByPreSchedule,
                    TicketNo: value.ticketNo
                });
            }

            function cloneTicket(value) {
                blockUI.start({
                    message: 'Checking related ticket...'
                });
                ticketsApi.getRelatedTicket(value.id).then(function(resp) {
                    blockUI.stop();
                    var related = {
                        ticketId: resp.data.Id,
                        ticketNumber: resp.data.TicketNumber
                    };
                    $state.go('app.jobs_clone', {
                        cloneId: value.id,
                        related: related
                    });
                }).catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
            }

            async function cancelTicket(value) {
                const hasExportedTimesheets = (await timesheetApi.checkIfTimesheetExported(value.id)).data;

                if (hasExportedTimesheets) {
                    msgboxService.alert(
                        utils.translate('WHITEBOARD.CANCEL_TICKET_TITLE'),
                        utils.translate('WHITEBOARD.CANCEL_TICKET_MESSAGE'),
                        utils.translate('WHITEBOARD.CANCEL_TICKET_OKAY'));
                    return;
                } else {
                    let dialog = showCancelTicketDialog({
                        Id: value.id,
                        TicketNumber: value.ticketNo,
                        TicketType: value.ticketType
                    });

                    $mdDialog.show(dialog).then(function(res) {
                        if (res) {
                            blockUI.start('Cancelling Ticket...')
                            performCancelTicket(value.id, res.reason, res.chargeMinHours).then(success).catch(failed);
                        }
                    });
                }

                function success(resp) {
                    let ticketNumbers = resp.data;

                    (vm.onCancelTicket || angular.noop)({
                        cancelledTickets: {
                            tickets: ticketNumbers
                        }
                    });

                    blockUI.stop();
                    cancelSuccess(value.ticketNo);
                }

                function failed(ex) {
                    blockUI.stop();
                    exceptionService.resolve(_.isNil(ex.data) ? ex : ex.data.Message);
                }
            }

            function cancelSuccess(ticketNumber) {
                let notification = $mdDialog.confirm()
                    .title('Cancel Ticket')
                    .textContent('Ticket #' + ticketNumber + ' has been cancelled.')
                    .ariaLabel('Cancel Ticket')
                    .ok('Ok')

                $mdDialog.show(notification)
            }

            function showCancelTicketDialog(ticket) {
                let dialog = {
                    locals: {
                        ticket: angular.copy(ticket)
                    },
                    templateUrl: 'app/main/jobs/services/cancelReasonDialog/cancel-reason.html',
                    controller: 'CancelReasonController as vm'
                }
                return dialog;
            }

            function performCancelTicket(ticketId, reason, chargeMinHours) {
                return jobsApi.cancelTicket(ticketId, reason, chargeMinHours);
            }

            function addRelatedTicket(value) {
                blockUI.start({
                    message: 'Checking related ticket...'
                });
                ticketsApi.getRelatedTicket(value.id)
                    .then(function(resp) {
                        blockUI.stop();
                        var related = {
                            ticketId: resp.data.Id,
                            ticketNumber: resp.data.TicketNumber
                        };
                        $state.go('app.jobs_manage', {
                            related: related
                        });
                    }).catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            }

            function downloadPdf(value) {
                getTicketPDF(value.id);
            }

            function downloadPaperworkPdf(value) {
                ticketPdfService.getPaperworkPDF(value.id, value.ticketNo)
                    .then(function(resp) {}).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function downloadTimesheetPdf(value) {
                ticketPdfService.getTimesheetPDF(value.id, value.ticketNo)
                    .then(function(resp) {}).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function getTicketPDF(id) {
                ticketPdfService.getTicketPDF(id);
            }

            function ticketBillingPref(value) {
                const [month1, month2, yearAndTime] = value.dt.split('/');
                const year = yearAndTime.slice(0, 4);
                const month = tenantSettings.countryCode === 'US' || tenantSettings.countryCode === 'CA' ? month1 : month2;
                    
                $state.go('app.related-ticket-billing', {
                    Id: value.id,
                    Month: month,
                    Year: year
                });
            }

            /**
             * Open dialog based on the ticket count
             */
            function openCardTicket(ticket) {
                let clonedTicket = angular.copy(ticket);
                let objParam = {
                    id: clonedTicket.id,
                    ticketNo: clonedTicket.ticketNo,
                    ticketCount: clonedTicket.ticketCount,
                    tickets: clonedTicket.tickets,
                    type: 'weekview',
                    companyCode: clonedTicket.companyCode,
                    date: clonedTicket.startDate
                };
                DialogService.openTicketDialog(objParam);
            }

            /**
             * AddTicket
             *
             * @param ev
             * @param list
             */
            function addTicket(ev, date) {
                let dt = moment(date, localeSettings.displayDateFormat).format('YYYY-MM-DD');

                $state.go('app.jobs_manage', {
                    dt: dt
                });
            }

            function approveTicket(ticket) {
                if (!ticket) { return; }
                var prompt = $mdDialog.prompt()
                    .title('Approve Ticket')
                    .placeholder('Comments (optional)')
                    .ariaLabel('Approve Ticket')
                    .ok('OK')
                    .cancel('Cancel');

                $mdDialog.show(prompt)
                    .then(function(comment){
                        var data = { IsApproved: true, Etag: ticket.etag };
                        if (comment) { data.ApproverComments = comment; }
                        return externalApi.approveOrRejectTicket(ticket.id, data);
                    })
                    .catch(e => {
                        exceptionService.resolve(e);
                    });
            }

            function rejectTicket(ticket) {
                if (!ticket) { return; }
                var prompt = $mdDialog.prompt()
                    .title('Reject Ticket')
                    .placeholder('Comments (optional)')
                    .ariaLabel('Reject Ticket')
                    .ok('OK')
                    .cancel('Cancel');

                $mdDialog.show(prompt)
                    .then(function(comment){
                        var data = { IsApproved: false, Etag: ticket.etag };
                        if (comment) { data.ApproverComments = comment; }
                        return externalApi.approveOrRejectTicket(ticket.id, data);
                    })
                    .catch(e => {
                        exceptionService.resolve(e);
                    });
            }

            async function preSchedule(value) {
                
                if (!claimsUtilService.isSmartSchedulingEnabled()) {
                    smartSchedulingService.showScheduleBooking();
                    return;
                }

                var allocatedResources = await allocationApi.fetchTicket(value.id);
                resourceAllocateService.assignDisplayName(allocatedResources.data);
                resourceAllocateService.allocatedResource = allocatedResources.data;

                var unallocatedPeople = resourceAllocateService.allocatedResource.filter(x => x.ItemType == 4 && !x.AllocatedId);
                var unallocatedAssets = resourceAllocateService.allocatedResource.filter(x => x.ItemType == 1 && (!x.AllocatedId && !x.AssignedOperatorId));
                var deferred = $q.defer();

                smartSchedulingService.showAllocationDialog(unallocatedPeople, unallocatedAssets)
                .then(async function(data){
                    if(!data){
                        return;
                    }

                    blockUI.start("Initiating Scheduling Copilot...");

                    let result = await smartSchedulingService.generateSchedule(value.id, data);

                    if (result && result.data && result.data.ErrorMessage) {
                        blockUI.stop();
                        await msgboxService.alert(
                            utils.translate(
                                "RESOURCEALLOCATION.SMART_SCHEDULING_FAILED_TITLE_DIALOG"
                            ),
                            result.data.ErrorMessage,
                            utils.translate(
                                "RESOURCEALLOCATION.CLOSE"
                            )
                        );

                        deferred.resolve();

                        return deferred.promise;
                    }

                    let ticket = value.ticket;

                    ticket.IsLockedByPreSchedule = true;

                    let ticketCard = document.getElementById(ticket.ticketNo.toString());

                    var ticketCardHeader = ticketCard.getElementsByClassName('list-card-label2')[0];
                    ticketCardHeader.classList.remove("md-red-bg");
                    ticketCardHeader.classList.remove("md-orange-bg");
                    ticketCardHeader.classList.remove("md-deep-purple-500-bg");
                    ticketCardHeader.classList.add("md-purple-200-bg");

                    var ticketCardSmartSchedulingIcon = ticketCard.getElementsByClassName('smart-schedule-rw-top')[0];
                    ticketCardSmartSchedulingIcon.classList.remove("ng-hide");

                    $timeout(async function(){
                        blockUI.stop();
                    });

                    deferred.resolve();
                });

                return deferred.promise;
            }

            async function cancelScheduling(value) {
                try {
                    blockUI.start('Cancelling Scheduling Copilot...');

                    let jobTickets = await jobsApi.getTicketByTicketId(value.id);
                    let ticket = jobTickets.data;

                    let cancelStatus = await smartSchedulingService.cancelScheduling(ticket.LatestPreScheduleJobId)
                    value.IsLockedByPreSchedule = false;

                    let status = jobsWhiteboardApi2.getStatusInfo(cancelStatus.data[0].Status);

                    var headerCard = document.getElementById(ticket.TicketNumber.toString()).getElementsByClassName('list-card-label2')[0];

                    headerCard.classList.remove("md-purple-200-bg");

                    if (status.abbrev === 'AR') {
                        headerCard.classList.add("md-red-bg");
                    } else {
                        headerCard.classList.add("md-orange-bg");
                    }

                    $timeout(function () {
                        blockUI.stop();
                    })
                } catch (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                }
            }

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.resourceSidenav')
        .directive('resourceSidenavToolbar', resourceSidenavToolbar);

    function resourceSidenavToolbar($mdSidenav) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceSidenav/components/toolbar/resource-toolbar.directive.html',
            scope: {},
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller(resourceSidenavService) {
            var vm = this;
            vm.service = resourceSidenavService;
            vm.closeSidenav = closeSidenav;

            function closeSidenav(){
                $mdSidenav("resource-sidenav").close();
            }
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.resourceSidenav')
        .directive('resourceSearch', resourceSearch);

    function resourceSearch() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceSidenav/components/search/resource-search.directive.html',
            scope: {},
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller(resourceSidenavService) {
            var vm = this;
            vm.service = resourceSidenavService;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.resourceSidenav')
        .directive('resourceList', resourceList);

    function resourceList() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceSidenav/components/resourceList/resource-list.directive.html',
            scope: {
                list: '='
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller(
            resourceSidenavService,
            $scope,
            msgboxService,
            $mdSidenav
        ) {
            var vm = this;
            vm.filterList = filterList;
            vm.service = resourceSidenavService;

            function filterList(type) {
                return vm.list.filter(function(emp) {
                    return emp.AllocationGroup === type;
                })
            }

            $scope.$on('whiteboard:resource:allocationChanged', function(ev, data) {

                if (vm.service.itm && vm.service.itm.ticketId === data.TicketId) {
                    angular.forEach(vm.list, function(item, key) {
                        angular.forEach(data.AllocatedResourceItems, function(itm) {
                            if (!item['Allocated'] &&
                                itm.AllocatedId === item.Id &&
                                itm.Id === vm.service.itm.id &&
                                $mdSidenav("resource-sidenav").isOpen()) {
                                item['Allocated'] = true;
                                msgboxService.alert('Resource Whiteboard', item.Name + ' has been allocated to another ticket', 'Okay')
                            }
                        });
                    });
                }
            });

            $scope.$on('whiteboard:resource:preScheduleStatusChanged', function(ev, data) {
                if (vm.service.itm) {
                    let ticket = data.Tickets.filter(x => x.TicketId == vm.service.itm.ticketId)
                    angular.forEach(vm.list, function(item, key) {
                        angular.forEach(ticket.AllocatedResourceItems, function(itm) {
                            if (!item['Allocated'] &&
                                itm.AllocatedId === item.Id &&
                                itm.Id === vm.service.itm.id &&
                                $mdSidenav("resource-sidenav").isOpen()) {
                                item['Allocated'] = true;
                                msgboxService.alert('Resource Whiteboard', item.Name + ' has been allocated to another ticket', 'Okay')
                            }
                        });
                    });
                }
            })

        }
    }
})();

(function() {
    'use strict';

    angular.module('app.resourceSidenav')
        .directive('resourceSidenavOptions', resourceSidenavOptions);

    function resourceSidenavOptions(
        resourceSidenavService
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceSidenav/components/options/resource-options.directive.html',
            scope: {},
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller() {
            var vm = this;
            vm.service = resourceSidenavService;
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.resourceSidenav')
        .directive('resourceDivisions', resourceDivisions);

    function resourceDivisions() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceSidenav/components/divisions/resource-divisions.directive.html',
            scope: {},
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller(resourceSidenavService) {
            var vm = this;
            vm.service = resourceSidenavService;
        }
    }
})();

"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var weekComponentDirective = function (_React$Component) {
  _inherits(weekComponentDirective, _React$Component);

  function weekComponentDirective() {
    _classCallCheck(this, weekComponentDirective);

    var _this = _possibleConstructorReturn(this, (weekComponentDirective.__proto__ || Object.getPrototypeOf(weekComponentDirective)).call(this));

    _this.showdialog = _this.showdialog.bind(_this);
    return _this;
  }

  _createClass(weekComponentDirective, [{
    key: "showdialog",
    value: function showdialog(item) {
      this.props.showdialog(item);
    }
  }, {
    key: "render",
    value: function render() {
      var self = this;

      function createDailyDisplay(day) {
        return React.createElement(
          "div",
          { className: day.Class },
          React.createElement(WeekHeaderComponent, { ticketdate: day.DateString }),
          React.createElement(TicketComponent, { showdialog: self.showdialog, item: day.Data })
        );
      }

      function createWeeklyGroupings(item) {
        return React.createElement(
          "div",
          { className: "layout-row flex layout-margin week-group" },
          item.WeekDays.map(createDailyDisplay)
        );
      }

      return React.createElement(
        "div",
        { className: "layout-column flex layout-margin" },
        this.props.datalist.map(createWeeklyGroupings)
      );
    }
  }]);

  return weekComponentDirective;
}(React.Component);

weekComponentDirective.propTypes = {
  datalist: React.PropTypes.array.isRequired,
  showdialog: React.PropTypes.func
};
weekComponentDirective.defaultProps = {
  datalist: [],
  showdialog: function showdialog() {}
};


angular.module('app.related-ticket-billing-preferences').value('weekComponentDirective', weekComponentDirective);
(function () {
  'use strict';

  angular
    .module('app.related-ticket-billing-preferences')
    .directive('weekComponentDirective', weekComponentDirective);

  /** @ngInject */
  function weekComponentDirective(reactDirective, weekComponentDirective) {
    return reactDirective(weekComponentDirective);
  }
})();

(function () {
    'use strict';

    angular.module('app.jobs.components.customFields', [])
        .directive('jobCustomFields', jobCustomFields);

    /** @ngInject */
    function jobCustomFields() {

        var directive = {
            restrict: 'E'
            , replace: true
            , templateUrl: 'app/main/jobs/manage/components/customized/customized.html'
        };

        return directive;
    }
})();

/**
 * Created by Ben Rei on 8/19/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.jobs.components.resource',[
      //'app.jobs.components.resource.draggable',
      'app.jobs.components.resource.droppable'
    ])
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.components.resource')
    .controller('JobResourceController', JobResourceController);

    /** @ngInject */
    function JobResourceController()
    {
        var vm = this;
    }

})();

(function () {
  'use strict';

  angular.module('app.jobs.components.resource')
    .directive('jobResource', jobResource);

  /** @ngInject */
  function jobResource() {
    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/manage/components/ResourceComponent/resource.html'
      , scope: {
        ngService: '=',
        name: '@'
      }
      , controller: 'JobResourceController as JobResourceComponentvm'
      , bindToController: true
    };

    return directive;
  }
})();

{
    angular.module('app.jobs.components.resource')
        .service('resourceComponentService', resourceComponentService);

    function resourceComponentService(
        $timeout,
        jobService,
        droppedAssetComponentService,
        AssetDataModel,
        confirmBookingService
    ) {
        var service = {
            activate: activate,
            dropped: dropped
        }

        return service;

        function activate(branchid, ticketType) {

            jobService.jobModel.Branch = {
                Id: branchid
            };
            jobService.jobModel.TicketType = ticketType;
            jobService.isLoadingAsset = true;
            jobService.getAsset()
                .then(function() {
                    jobService.splitAssetLookup();
                    jobService.isLoadingAsset = false;
                    $timeout(function() {
                        jobService.getKit()
                            .catch(function() {
                                blockUI.stop();
                                exceptionService.resolve(ex);
                            });
                    })
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function dropped(itemId, event, itemArray) {
            confirmBookingService.isClonedTicketUpdated = true;

            var items = [];
            items = alasql("SELECT * FROM ? WHERE Id = ?", [itemArray, itemId]);

            var kits = _.find(jobService.kitsLookup, function(o) {
                return o.Id == itemId
            })

            if (kits) {
                angular.forEach(kits.Items, function(item) {
                    processItem(item, itemArray)
                });
            } else {
                var asset = _.find(jobService.assetsLookup, {
                    'id': itemId
                });

                asset.ItemPrerequisites = asset.ItemPrerequisites.map((x) => {
                    x.disabled = false;
                    if(Array.isArray(x.BranchIds) && x.BranchIds.length) {
                        x.disabled = !x.BranchIds.includes(jobService.jobModel.Branch.Id);
                    }
                    return x;
                }
            );
                processItem(asset, itemArray)
            }

            if (event) {
                event.stopPropagation();
            }

            let isEquipmentOnlyTicket = jobService.jobModel.TicketType === 1;
            if (isEquipmentOnlyTicket) {
                if (items.length > 0) {
                    droppedAssetComponentService.showDialog(itemId, itemArray, jobService, false, true);
                } else {
                    droppedAssetComponentService.showDialog(itemId, itemArray, jobService, false, false);
                }
            }
        };

        function processItem(asset, itemArray) {
            var _asset = asset;
            var _qty = 0;

            if (asset.Items) {
                _asset = asset.Items;
                _qty = asset.Quantity;
            }

            includeItemInItemArray(itemArray, _asset, _qty);

            let isFullServiceTicket = jobService.jobModel.TicketType === 3;
            let isTravelOnlyTicket = jobService.jobModel.TicketType === 7;
            let isInternalTicket = jobService.jobModel.TicketType === 6;
            let hasPrerequisites = _asset.ItemPrerequisites && _asset.ItemPrerequisites.length > 0;

            if (hasPrerequisites && (isInternalTicket || isFullServiceTicket || isTravelOnlyTicket)) {
                processPrerequisites(_asset, itemArray);
            }
        }

        function processPrerequisites(_asset, itemArray) {
            let optionalItems = _asset.ItemPrerequisites.filter(function(a) {
                return a.IsOptional;
            });

            let hasOptionalItems = optionalItems.length > 0;
            if (!hasOptionalItems) {
                angular.forEach(_asset.ItemPrerequisites, function(item) {
                    if (item.id != null && !item.IsOptional) {
                        let foundPrereqs = alasql("select ItemPrerequisites from ? where id = ?", [jobService.assetsLookup, item.id]);
                        item.ItemPrerequisites = foundPrereqs[0].ItemPrerequisites;
                        processItem(item, itemArray);
                    }
                });

                return;
            }

            if (_asset.ItemPrerequisites.every((x) => x.disabled)){
                _asset.disabled = true;
            }

            droppedAssetComponentService
                .showChooseOptionalItemDialog(_asset, optionalItems)
                .then(function(result) {
                    if (!result.selectedOptionalItem) {
                        droppedAssetComponentService.remove(result.item.id, true);
                        return;
                    }

                    let foundPrereqs = alasql("select ItemPrerequisites from ? where id = ?", [jobService.assetsLookup, result.selectedOptionalItem.id]);
                    result.selectedOptionalItem.ItemPrerequisites = foundPrereqs[0].ItemPrerequisites;
                    processItem(result.selectedOptionalItem, itemArray);

                    angular.forEach(result.item.ItemPrerequisites, function(item) {
                        if (item.id != null && !item.IsOptional) {
                            var foundPrereqs = alasql("select ItemPrerequisites from ? where id = ?", [jobService.assetsLookup, item.id]);
                            item.ItemPrerequisites = foundPrereqs[0].ItemPrerequisites;
                            processItem(item, itemArray);
                        }
                    });
                });
        }

        function includeItemInItemArray(itemArray, item, qty) {
            if (qty > 0) {
                item.Quantity = qty;
            }
            
            if (itemArray.length == 0) {
                return itemArray.push(mapItemToServerModel(item));
            }

            var items = [];
            items = alasql("SELECT * from ? where Id =?", [itemArray, item.id == null ? item.Id : item.id]);

            if (items.length > 0) {
                updateItemQuantity(itemArray, item);
                return;
            }

            return itemArray.push(mapItemToServerModel(item));
        }

        function updateItemQuantity(itemArray, item) {
            angular.forEach(itemArray, function(value) {
                if ((item.id == null ? item.Id : item.id) == value.Id) {
                    // Only add to quantity if ticket type is not Equipment Only
                    if (jobService.jobModel.TicketType !== 1) {
                        value.ItemQuantity = item.Quantity == null ? value.ItemQuantity + 1 : value.ItemQuantity + (item.ItemQuantity == null ? item.Quantity : item.ItemQuantity);
                    }
                    value.ripple = 'elementToFadeInAndOut';
                }
            });
        }

        function mapItemToServerModel(item) {
            var newModel = new AssetDataModel();
            newModel.id = item.id == null ? item.Id : item.id;
            newModel.assetType = item.ItemTypes;
            newModel.assetName = item.ItemName;
            newModel.assetQty = item.Quantity == null ? 1 : item.Quantity;

            newModel.Id = item.Id || item.id;
            newModel.IsDeleted = false;
            newModel.IsNew = true; // New item FE flag
            newModel.UpdateTransaction = 1; // Default: 1 - Update this ticket's date only
            newModel.ApplyOnStartDate = null;
            newModel.ApplyOnEndDate = null;
            
            newModel.ItemBillingPeriod = item.ItemBillingPeriod;
            newModel.BillingPeriod = item.BillingPeriod;
            newModel.isBillable = item.IsItemBillable;
            newModel.isAllocatable = item.isAllocatable
            newModel.InvoiceGroupName = item.InvoiceGroupName;

            return newModel.tranformToServerModel();
        }
    }
}

(function() {
    'use strict';

    angular
        .module('app.jobs.components.orderedBy')
        .controller('OrderedByComponentController', OrderedByComponentController);

    /** @ngInject */
    function OrderedByComponentController(orderByComponentService,
        jobService,
        utils,
        $translate,
        $timeout,
        tenantSettings,
        adminClaimsService,
        claimsUtilService,
        timeSheetService,
        ticketType) {

        var vm = this;
        var previousSelectedBranch = null;
        var previousSelectedTicketType = null;
        vm.selfService = orderByComponentService;

        vm.country = tenantSettings.countryCode;
        vm.adminClaimsService = adminClaimsService;
        vm.claimsUtilService = claimsUtilService;
        vm.disable = disable;
        vm.selfService.linkedFormTemplates = null
        vm.selfService.unlinkedFormTemplates = null;
        vm.selfService.overriddenFormTemplates = null;
        vm.hasTimesheets = false;
        vm.ticketType = ticketType;

        function disable(model, type) {
            return !_.isNil(model) && (vm.ngService.isEditMode || vm.ngService.isCloning) && !type.AllowedUpdateTicketType.includes(model);
        }

        vm.contactAttribute = {
            placeholder: 'Person Ordering'
        }

        vm.onChanging = function onChanging(branch) {
            if (jobService.isCloning) {
                previousSelectedBranch = jobService.jobModel.Branch;
            }
            if (JSON.stringify(utils.objectSanitize(branch)) != JSON.stringify(previousSelectedBranch)) {
                orderByComponentService.onChange('branch');
                previousSelectedBranch = angular.copy(branch);
            }
        };

        vm.onChange = function onChanging(ticketType) {
            if (ticketType != previousSelectedTicketType) {
                orderByComponentService.onChange('ticket');
            }
        };

        vm.isTicketLockedByPreSchedule = function isTicketLockedByPreSchedule() {
            return vm.ngService.jobModel.IsLockedByPreSchedule && vm.claimsUtilService.isSmartSchedulingEnabled();
        };

        async function activate() {
            $translate('MANAGE.PERSONORDERING').then(function(translations) {
                vm.contactAttribute.placeholder = translations;
                $timeout(function() {
                    orderByComponentService.activate();
                }, 1000);
            });

            vm.hasTimesheets = await timeSheetService.checkIfJobHasTimesheet(jobService.ticketId);
        }

        activate();

    }

})();

(function () {
    'use strict';

    angular
        .module('app.jobs.components.orderedBy')
        .directive('orderedByComponent', orderedByComponent);

    /** @ngInject */
    function orderedByComponent() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/manage/components/OrderedByComponent/ordered-by.html',
            scope: {
                ngService: '=',
                name: '@'
            },
            controller: 'OrderedByComponentController as OrderedByComponentvm',
            bindToController: true,
            replace: true
        };

        return directive;

    }
})();

/**
 * Created by Ben Rei on 9/20/2016.
 */
{
    angular.module('app.jobs.components.orderedBy')
        .service('orderByComponentService', orderByComponentService);

    function orderByComponentService(jobService,
        exceptionService,
        localStorageService,
        $q,
        $stateParams,
        blockUI,
        $timeout,
        $mdDialog,
        ticketDataModel,
        claimsUtilService,
        ticketType) {
        var service = {
            is_client_inactive: false,
            client_name: null,
            activate: activate,
            onChange: onChanging
        }

        return service;

        function onChanging(src) {
            if (src == 'branch') {
                jobService.clientLookup = [];
                jobService.jobModel.PersonOrdering = null;
                jobService.jobModel.SiteContact = null;
                jobService.jobModel.Client = null;
                jobService.jobModel.Project = null;
                jobService.jobModel.Division = null;
                jobService.rememberThis('LastSelectedBranch', jobService.jobModel.Branch);
                if (jobService.branchLookup.length > 0) {
                    var selectedBranch = alasql('select * from ? where Id = ?', [jobService.branchLookup, jobService.jobModel.Branch.Id]);
                    if (selectedBranch.length > 0) {
                        jobService.divisionLookup = selectedBranch[0].Division;
                        jobService.rememberThis('divisionOfSelectedBranch', jobService.divisionLookup);
                    }
                    blockUI.start('Loading Clients...');
                    jobService.getCompanyByBranchLookup({
                            BranchId: jobService.jobModel.Branch.Id,
                            DivisionId: ""
                        })
                        .then(function() {
                            blockUI.stop();
                            jobService.getAsset()
                            .then(function() {
                                    jobService.splitAssetLookup();
                                    jobService.getKit()
                                        .then(function() {
                                            jobService.isLoadingAsset = false;
                                            blockUI.stop();
                                        })
                                })
                                .catch(function(ex) {
                                    blockUI.stop();
                                    exceptionService.resolve(ex);
                                });
                        })
                        .catch(function(ex) {
                            blockUI.stop();
                            exceptionService.resolve(ex);
                        });
                }
            }

            if (src == 'division') {
                blockUI.start('Loading Clients...');
                if (!jobService.isEditMode) {
                    jobService.getCompanyByBranchLookup({
                            BranchId: jobService.jobModel.Branch.Id,
                            DivisionId: jobService.jobModel.Division.id === null ? "" : jobService.jobModel.Division.id
                        })
                        .then(function() {
                            jobService.getAsset().then(function() {
                                    jobService.splitAssetLookup();
                                    jobService.isLoadingAsset = false;
                                    blockUI.stop();
                                })
                                .catch(function(ex) {
                                    blockUI.stop();
                                    exceptionService.resolve(ex);
                                });
                        });
                }
            }
            
            if (src == 'ticket') {
                if (jobService.isEditMode) {
                    let isFullServiceJob = [ticketType.FULL_SERVICE, ticketType.TRAVEL_ONLY].includes(Number(jobService.jobModel.TicketType));

                    if (isFullServiceJob  && jobService.jobModel.TicketType === ticketType.EQUIPMENT_ONLY) {
                        jobService.jobModel.TicketType = jobService.cloneJobModel.TicketType;
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Change Ticket Type')
                            .textContent('You cannot change Ticket Type from Full Service/Travel Only to Equipment Only!')
                            .ariaLabel('Change Ticket Type')
                            .ok('Ok!')
                        );
                    } else if (jobService.cloneJobModel.TicketType === ticketType.INTERNAL && !isFullServiceJob &&
                        jobService.cloneJobModel.TicketType !== ticketType.INTERNAL
                    ) {
                        jobService.jobModel.TicketType = jobService.cloneJobModel.TicketType;
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Change Ticket Type')
                            .textContent('You cannot change Ticket Type from Internal to Equipment Only / Plan Only!')
                            .ariaLabel('Change Ticket Type')
                            .ok('Ok!')
                        );
                    } else {
                        jobService.rememberThis('LastSelectedTicketType', jobService.jobModel.TicketType);
                    }
                } else {
                    jobService.rememberThis('LastSelectedTicketType', jobService.jobModel.TicketType);
                    jobService.jobModel.Is24HourRotation = false;
                    jobService.jobModel.LengthOfShift = null;
                    jobService.jobModel.JobStartTime = null;
                    jobService.jobModel.JobEndTime = null;
                    jobService.jobModel.Resource = [];
                }
            }
        }

        function activate() {
            service.is_client_inactive = false;
            service.client_name = null;
            jobService.clientLookup = [];
            jobService.divisionLookup = [];
            jobService.classifiedAssetLookup = {};
            jobService.isSaving = false;

            if (!blockUI.isBlocking())
            {
                if (jobService.isCloning || jobService.isEditMode) {
                    blockUI.start('Loading Ticket...');
                } else {
                    blockUI.start('Loading...');
                }
            }

            jobService.loadTicket()
                .then(async function(resp) {
                    jobService.jobModel.reset();
                    var ticket = new ticketDataModel();
                    jobService.customisedFields = resp.data.m_Item2;
                    jobService.linkedFormTemplates = (resp.data.m_Item1 || {}).LinkedFormTemplates;
                    jobService.unlinkedFormTemplates = (resp.data.m_Item1 || {}).UnlinkedFormTemplates;
                    jobService.overriddenFormTemplates = (resp.data.m_Item1 || {}).OverriddenFormTemplates;
                    jobService.excludedDocuments = new Set((resp.data.m_Item1 || {}).ExcludedDocuments);
                    jobService.isInit = true;
                    var _divisionId = "";
                    var is_client_inactive = false;

                    if (!(resp.data.m_Item3 == "" || _.isNil(resp.data.m_Item3))) {
                        is_client_inactive = true;
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Just letting you know')
                            .textContent(resp.data.m_Item3)
                            .ok('Okay')
                        );
                    }

                    if(resp.data.m_Item1 != null){
                        jobService.isSmartSchedulingFailed = await jobService.isSmartSchedulingCallbackFailed(resp.data.m_Item1.LatestPreScheduleJobId);
                    }

                    if (jobService.isEditMode) {
                        jobService.getTicketType();
                        _divisionId = resp.data.m_Item1.DivisionId;
                        blockUI.message('Loading Clients...');
                        jobService.getCompanyByBranchLookup({
                                BranchId: resp.data.m_Item1.BranchId,
                                DivisionId: _divisionId
                            })
                            .then(function() {
                                if (!(_.find(jobService.companyLookup, function(o) {
                                        return o.Id == resp.data.m_Item1.CompanyId
                                    }))) {
                                    _divisionId = "";
                                    jobService.getCompanyByBranchLookup({
                                        BranchId: resp.data.m_Item1.BranchId,
                                        DivisionId: _divisionId
                                    }).then(function() {
                                        var transformTicket = ticket.transformToModel(resp.data);
                                        var _client = _.find(jobService.companyLookup, function(o) {
                                            return o.Id == resp.data.m_Item1.CompanyId
                                        });

                                        if (_client) {
                                            service.is_client_inactive = false;
                                            transformTicket.Client = {
                                                IsProjectMandatory: _client.IsProjectMandatory,
                                                IsPurchaseOrderMandatory: _client.IsPurchaseOrderMandatory,
                                                Name: _client.Name,
                                                Id: _client.Id
                                            }
                                        } else {
                                            service.is_client_inactive = true;
                                            service.client_name = resp.data.m_Item1.CompanyName;
                                            transformTicket.Client = null;
                                            transformTicket.Project = null;
                                            transformTicket.PersonOrdering = null;
                                            transformTicket.SiteContact = null;
                                            if (!resp.data.m_Item1.IsLocked && !isTicketLockedByPreSchedule(resp.data.m_Item1)) {
                                                jobService.getTicketType();
                                            }
                                        }

                                        //var test = angular.copy(transformTicket.Client);
                                        //transformTicket.Client = null

                                        jobService.jobModel.map(transformTicket);
                                        jobService.cloneJobModel = angular.copy(jobService.jobModel);
                                        jobService.savedTicketType = jobService.jobModel.TicketType;
                                        processDependecy(resp);
                                        if (!resp.data.m_Item1.IsLocked && !isTicketLockedByPreSchedule(resp.data.m_Item1) && !resp.data.m_Item1.IsCancelled) {
                                            //jobService.jobModel.Client = test;
                                            blockUI.message('Loading Contacts...');
                                            let client = jobService.jobModel.Client ? jobService.jobModel.Client.Id : null;


                                            getContactClientByBranchAndCompanyLookup(client, jobService.jobModel.Branch.Id)
                                                .then(function() {
                                                    blockUI.message('Loading Projects...');
                                                    jobService.getProjectByBranchAndCompanyLookup(jobService.jobModel.Branch.Id, client)
                                                        .then(function() {
                                                            blockUI.stop();
                                                            jobService.isInit = false;
                                                            jobService.getAsset()
                                                                .then(function() {
                                                                    jobService.splitAssetLookup();
                                                                    jobService.isLoadingAsset = false;
                                                                    loadLatestJobLocations();
                                                                })
                                                                .catch(function(ex) {
                                                                    blockUI.stop();
                                                                    exceptionService.resolve(ex);
                                                                });
                                                        })
                                                        .catch(function(ex) {
                                                            blockUI.stop();
                                                            exceptionService.resolve(ex);
                                                        });
                                                })
                                                .catch(function(ex) {
                                                    blockUI.stop();
                                                    exceptionService.resolve(ex);
                                                });
                                        } else {
                                            blockUI.stop();
                                            jobService.isLoadingAsset = false;
                                            jobService.isLoadingKit = false;
                                        }
                                    }).catch(function(ex) {
                                        blockUI.stop();
                                        exceptionService.resolve(ex);
                                    });
                                } else {
                                    var transformTicket = ticket.transformToModel(resp.data);
                                    var _client = _.find(jobService.companyLookup, function(o) {
                                        return o.Id == resp.data.m_Item1.CompanyId
                                    });
                                    transformTicket.Client = {
                                        IsProjectMandatory: _client.IsProjectMandatory,
                                        IsPurchaseOrderMandatory: _client.IsPurchaseOrderMandatory,
                                        Name: _client.Name,
                                        Id: _client.Id
                                    }

                                    jobService.jobModel.map(transformTicket);
                                    jobService.cloneJobModel = angular.copy(jobService.jobModel);
                                    jobService.savedTicketType = jobService.jobModel.TicketType;
                                    processDependecy(resp);

                                    jobService.jobModel.origTicketType = angular.copy(jobService.jobModel.TicketType);

                                    if (!resp.data.m_Item1.IsLocked && !isTicketLockedByPreSchedule(resp.data.m_Item1) && !resp.data.m_Item1.IsCancelled) {
                                        blockUI.message('Loading Contacts...');
                                        let client = jobService.jobModel.Client ? jobService.jobModel.Client.Id : null;
                                        getContactClientByBranchAndCompanyLookup(client, jobService.jobModel.Branch.Id)
                                            .then(function() {
                                                blockUI.message('Loading Projects...');
                                                let client = jobService.jobModel.Client ? jobService.jobModel.Client.Id : null;
                                                jobService.getProjectByBranchAndCompanyLookup(jobService.jobModel.Branch.Id, client)
                                                    .then(function() {
                                                        blockUI.stop();
                                                        jobService.isInit = false;
                                                        jobService.getAsset()
                                                            .then(function() {
                                                                jobService.splitAssetLookup();
                                                                jobService.isLoadingAsset = false;
                                                                loadLatestJobLocations();
                                                            })
                                                            .catch(function(ex) {
                                                                blockUI.stop();
                                                                exceptionService.resolve(ex);
                                                            });
                                                    })
                                                    .catch(function(ex) {
                                                        blockUI.stop();
                                                        exceptionService.resolve(ex);
                                                    });
                                            })
                                            .catch(function(ex) {
                                                blockUI.stop();
                                                exceptionService.resolve(ex);
                                            });
                                    } else {
                                        blockUI.stop();
                                        jobService.isLoadingAsset = false;
                                        jobService.isLoadingKit = false;
                                    }
                                }
                            })
                            .catch(function(ex) {
                                blockUI.stop();
                                exceptionService.resolve(ex);
                            });
                    } else {
                        if (resp.data.m_Item1 && jobService.isCloning) {
                            var transformTicket = ticket.transformToModel(resp.data, 'Cloning');
                            transformTicket.JobDuration = jobService.JobDuration;
                            //Clear other fields when client is inactive and when cloning a job
                            if (is_client_inactive) {
                                transformTicket.Client = null;
                                transformTicket.Project = null;
                                transformTicket.PersonOrdering = null;
                                transformTicket.SiteContact = null;
                            }

                            jobService.jobModel.map(transformTicket);
                            
                            if ($stateParams.transformModelType === 'clone-a-job/:cloneId' && ($stateParams.costEstimateId != null || $stateParams.costEstimateGroupId != null)) {
                                jobService.dateParam = resp.data.m_Item1.StartDate;
                                jobService.jobModel.JobEndDate = moment(resp.data.m_Item1.StartDate).clone().add(jobService.JobDuration - 1,'days');
                            }
                        }  

                        if (resp.data.m_Item1) {
                            if (!resp.data.m_Item1.IsLocked || !isTicketLockedByPreSchedule(resp.data.m_Item1) || jobService.isCloning) {
                                processDependecy(resp);
                            }
                            //else{
                            //  blockUI.stop();
                            //}
                        } else {
                            processDependecy(resp);
                            jobService.jobModel.IsLongRunningJob = claimsUtilService.isTicketEndTimeOnMobileHiddenByDefaultEnabled();
                        }
                    }
                    if (resp.data.m_Item1) {
                        if (resp.data.m_Item1.IsLocked || isTicketLockedByPreSchedule(resp.data.m_Item1) || jobService.isCloning) {
                            jobService.getTicketType()
                                .then(function() {
                                    if (!jobService.isEditMode && !jobService.isCloning) {
                                        var LastSelectedTicketType = localStorageService.get('LastSelectedTicketType');
                                        if (LastSelectedTicketType) {
                                            jobService.jobModel.TicketType = LastSelectedTicketType;
                                        }
                                    }
                                })
                                .catch(function(ex) {
                                    blockUI.stop();
                                    exceptionService.resolve(ex);
                                });
                            jobService.getCompanyTypeLookup();
                            jobService.getContactTypeLookup();
                        }
                        if (resp.data.m_Item1.TicketType == 1) {
                            jobService.getNewBillingPeriodValues2();
                        }
                    } else {
                        jobService.getTicketType()
                            .then(function() {
                                var LastSelectedTicketType = localStorageService.get('LastSelectedTicketType');
                                if (LastSelectedTicketType) {
                                    jobService.jobModel.TicketType = LastSelectedTicketType;
                                }
                            })
                            .catch(function(ex) {
                                blockUI.stop();
                                exceptionService.resolve(ex);
                            });
                        jobService.getCompanyTypeLookup();
                        jobService.getContactTypeLookup();
                        jobService.getNewBillingPeriodValues2();
                    }

                    if ($stateParams.related != null) {
                        jobService.RelatedTicketId = $stateParams.related.ticketId;
                        jobService.jobModel.RelatedTicketId = $stateParams.related.ticketId;
                        jobService.RelatedTicketNumber = $stateParams.related.ticketNumber;
                        jobService.jobModel.RelatedTicketNumber = $stateParams.related.ticketNumber;
                    } else {
                        jobService.RelatedTicketId = null;
                        jobService.jobModel.RelatedTicketId = null;
                        jobService.RelatedTicketNumber = null;
                        jobService.jobModel.RelatedTicketNumber = null;
                    }

                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function loadLatestJobLocations() {
            $timeout(function() {
                let client = jobService.jobModel.Client ? jobService.jobModel.Client.Id : null;
                jobService.getLatestJobLocations(client)
                    .then(function() {
                        jobService.getKit()
                            .catch(function(ex) {
                                blockUI.stop();
                                exceptionService.resolve(ex);
                            });
                    })
                    .catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            })
        }

        function processDependecy(resp) {
            var _divisionId = "";

            jobService.getBranchLookup()
                .then(function() {
                    if (jobService.isCloning && jobService.jobModel.Division) {
                        _divisionId = angular.isUndefined(jobService.jobModel.Division.Id) ? jobService.jobModel.Division.id : jobService.jobModel.Division.Id;
                    }

                    if (!jobService.isEditMode) {
                        $timeout(function() {
                            blockUI.message('Loading Lookups...');
                        }, 200);

                        var LastSelectedBranch = localStorageService.get('LastSelectedBranch');
                        if (LastSelectedBranch && !jobService.isCloning) {
                            $timeout(function() {
                                blockUI.message('Loading Previous Selected Branch...');
                            }, 400);

                            var divisionOfSelectedBranch = localStorageService.get('divisionOfSelectedBranch');
                            jobService.jobModel.Branch = LastSelectedBranch;
                            jobService.divisionLookup = divisionOfSelectedBranch;
                        }

                        if (LastSelectedBranch || jobService.isCloning) {
                            blockUI.message('Loading Clients...');
                            jobService.getCompanyByBranchLookup({
                                    BranchId: jobService.jobModel.Branch.Id,
                                    DivisionId: _divisionId
                                })
                                .then(function() {
                                    if (jobService.isCloning) {
                                        blockUI.message('Loading Contacts...');
                                        let client = jobService.jobModel.Client ? jobService.jobModel.Client.Id : null;
                                        getContactClientByBranchAndCompanyLookup(client, jobService.jobModel.Branch.Id)
                                            .then(function() {
                                                jobService.isInit = false;
                                                blockUI.stop();
                                                jobService.getAsset()
                                                    .then(function() {
                                                        jobService.splitAssetLookup();
                                                        jobService.getKit()
                                                            .then(function() {
                                                                jobService.isLoadingAsset = false;
                                                                jobService.jobModel.JobStartDate = jobService.dateParam;
                                                            })
                                                        loadLatestJobLocations();
                                                    })
                                                    .catch(function(ex) {
                                                        blockUI.stop();
                                                        exceptionService.resolve(ex);
                                                    })
                                            })
                                            .catch(function(ex) {
                                                exceptionService.resolve(ex);
                                            })
                                    } else {
                                        jobService.isInit = false;
                                        blockUI.stop();
                                        if (!jobService.IsLocked && !jobService.IsLockedByPreSchedule) {
                                            jobService.getAsset()
                                                .then(function() {
                                                    jobService.splitAssetLookup();
                                                    jobService.getKit()
                                                        .then(function() {
                                                            jobService.isLoadingAsset = false;
                                                            jobService.jobModel.JobStartDate = jobService.dateParam;
                                                        })
                                                        .catch(function(ex) {
                                                            blockUI.stop();
                                                            exceptionService.resolve(ex);
                                                        });
                                                })
                                                .catch(function(ex) {
                                                    blockUI.stop();
                                                    exceptionService.resolve(ex);
                                                });
                                        }
                                    }
                                })
                                .catch(function(ex) {
                                    exceptionService.resolve(ex);
                                })
                        } else {
                            jobService.isInit = false;
                            blockUI.stop();
                        }
                    } else {
                        if (jobService.branchLookup) {
                            //var test = _.find(jobService.branchLookup, function(o){return o.Id == jobService.jobModel.Branch.Id});
                            jobService.divisionLookup = _.find(jobService.branchLookup, function(o) {
                                return o.Id == jobService.jobModel.Branch.Id
                            }).Division;
                        }
                    }
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function getCompanybyBranch(arg) {
            var deferred = $q.defer();
            var LastCompanyList = localStorageService.get('LastCompanyList');
            if (matchWithPreviousSelected(arg)) {
                jobService.companyLookup = LastCompanyList;
                deferred.resolve(LastCompanyList);
            } else {
                jobService.getCompanyByBranchLookup(arg)
                    .then(function() {
                        jobService.rememberThis('LastCompanyList', jobService.companyLookup);
                        //vm.Clients = service.companyLookup;
                        deferred.resolve();
                    });
            }
            return deferred.promise;
        }

        function getContactClientByBranchAndCompanyLookup(company, branch) {
            var deferred = $q.defer();
            jobService.getContactClientByBranchAndCompanyLookup(company, branch)
                .then(function() {

                    jobService.rememberThis('LastContactList', jobService.clientLookup);
                    deferred.resolve();
                });
            return deferred.promise;
        }

        function getProjectByBranch(arg) {
            var deferred = $q.defer();
            var LastProjectList = localStorageService.get('LastProjectList');

            if (matchWithPreviousSelected(arg)) {
                jobService.projectLookup = LastProjectList;
                deferred.resolve(LastProjectList);
            } else {
                jobService.getProjectByBranchLookup(arg)
                    .then(function() {
                        //vm.Projects = service.projectLookup;
                        jobService.rememberThis('LastProjectList', jobService.projectLookup);
                        deferred.resolve();
                    });
            }
            return deferred.promise;
        }

        function matchWithPreviousSelected(arg) {
            var LastSelectedBranch = localStorageService.get('LastSelectedBranch');
            if (LastSelectedBranch) {
                return LastSelectedBranch.BranchId == arg;
            }
            return false;
        }

        function isTicketLockedByPreSchedule(ticket)
        {
            return ticket.IsLockedByPreSchedule && claimsUtilService.isSmartSchedulingEnabled()
        }
    }
}

/**
 * Created by Ben Rei on 8/19/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.jobs.components.jobDetails', [])
})();


(function() {
    'use strict';

    angular
        .module('app.jobs.components.jobDetails')
        .controller('JobDetailsController', JobDetailsController);

    /** @ngInject */
    function JobDetailsController(
        $mdDateLocale,
        $translate,
        TimeLibrary,
        hubService,
        $compile,
        $scope,
        customisedFieldsFactory,
        $document,
        claimsUtilService,
        utils,
        tenantSettings,
        jobTagService
    ) {
        var vm = this;

        vm.jobTagService = jobTagService;
        vm.jobDurationVisible = true;
        vm.jobEndDateVisible = false;
        vm.dateFormat = utils.setDateFormat();
        vm.showFields = true;
        vm.invalid = false;
        vm.showOtherOption = showOtherOption;
        vm.onChangeStartDate = onChangeStartDate;
        vm.onChangeBillingPeriod = onChangeBillingPeriod;
        vm.filterStartDate = filterStartDate;
        vm.filterEndDate = filterEndDate;
        vm.minDate = minDate;
        vm.validateJobEndDate = validateJobEndDate;
        vm.checkEndDate = checkEndDate;
        vm.claimsUtilService = claimsUtilService;
        vm.jobDuration = 0;
        vm.jobDetailsMaxLength = 1500;
        vm.showError = false;
        vm.showJobDurationError = false;
        vm.onChangeEndDate = onChangeEndDate;
        vm.onKeyUpJobDuration = onKeyUpJobDuration;
        vm.isTicketLockedByPreSchedule = isTicketLockedByPreSchedule;

        var start_time_already_set = false;
        var end_time_already_set = false;
        var start_date_already_set = false;
        var client_already_set = false;
        var division_already_set = false;
        var project_already_set = false;

        vm.contactAttribute = {
            placeholder: 'Site Contact'
        }
        vm.countryGmap = tenantSettings.countryCode;

        $translate('MANAGE.SITECONTACT')
            .then(function(translations) {
                vm.contactAttribute.placeholder = translations;
            });

        $mdDateLocale.formatDate = function(date) {
            return utils.formatToLocaleDate(date, vm.dateFormat);
        }

        $mdDateLocale.parseDate = function(dateString) {
            return utils.parseToLocaleDate(dateString, vm.dateFormat);
        };

        vm.activate = function() {
            vm.jobTagService.getTicketTags(); //get all active tags
        }

        vm.selectedTag = null;
        vm.searchText = null;

        vm.searchTagChange = function(text) {
            if (text.length > 25) {
                vm.searchText = text.substring(0, 25);
            }
        }

        vm.getTicketTags = function() {
            var allTags = vm.jobTagService.tagsLookup;
            var searchText = vm.searchText ? vm.searchText.toLowerCase() : '';

            if (allTags) {
                allTags = vm.jobTagService.tagsLookup.filter((tag) => {
                    return tag.Name.toLowerCase()
                        .includes(searchText) &&
                        !vm.ngService.jobModel.Tags
                        .some(_ => _.Name.toLowerCase() === tag.Name.toLowerCase());
                });
            }

            return allTags;
        }

        vm.addTag = function() {
            if (!_.isNil(vm.selectedTag)) {
                vm.jobTagService.pushTagToArrayModel(vm.selectedTag, vm.ngService.jobModel.Tags);
                vm.jobTagService.tagsLookup = _.filter(vm.jobTagService.tagsLookup,
                    (tag) => tag.Id !== vm.selectedTag.Id);
                vm.searchText = '';
            }
        }

        vm.removeTag = function(removedTag) {
            if (!(vm.ngService.jobModel.IsLocked || vm.ngService.jobModel.IsCancelled)) {
                vm.ngService.jobModel.Tags = _.filter(vm.ngService.jobModel.Tags,
                    (tag) => tag.Id !== removedTag.Id);
                vm.jobTagService.pushTagToArrayModel(removedTag, vm.jobTagService.tagsLookup);
            }
        }

        function calculateShiftLength() {
            if (!vm.ngService.jobModel.JobStartTime || !vm.ngService.jobModel.JobEndTime) {
                return 0;
            }

            var jobStartTime = vm.ngService.jobModel.JobStartTime != null ? vm.ngService.jobModel.JobStartTime : '00:00:00';
            var convertedStartDate = new Date(moment()
                .format('YYYY-MM-DD') + ' ' + jobStartTime);

            var jobEndTime = vm.ngService.jobModel.JobEndTime != null ? vm.ngService.jobModel.JobEndTime : '00:00:00';
            var convertedEndDate = new Date(moment()
                .format('YYYY-MM-DD') + ' ' + jobEndTime)

            var dateDiff = convertedEndDate - convertedStartDate;
            var diffInHours = Math.abs(dateDiff) / (60 * 60 * 1000)
            return (dateDiff < 0) ? 24 - diffInHours : diffInHours;
        }

        function minDate() {
            return !_.isNil(vm.ngService.jobModel.JobStartDate) ? new Date(vm.ngService.jobModel.JobStartDate) : new Date();
        }

        function checkEndDate() {
            let diff = date_diff_indays(vm.ngService.jobModel.JobStartDate, vm.ngService.jobModel.JobEndDate);
            if (diff < 0) {
                hubService.showToast('The job end date must be on or after the job start date');
                vm.ngService.jobModel.JobEndDate = null;
            }
        }

        var date_diff_indays = function(date1, date2) {
            let dt1 = new Date(date1);
            let dt2 = new Date(date2);
            return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
        }

        function isTicketLockedByPreSchedule(ticket)
        {
            if (!ticket) return false;

            return ticket.IsLockedByPreSchedule && vm.claimsUtilService.isSmartSchedulingEnabled();
        }

        function onChangeBillingPeriod(ItemBillingPeriod) {
            if (!vm.ngService.isEditMode && vm.BillingPeriodChanged && vm.ngService.jobModel.TicketType == 1) {
                var defaultbillingPeriod = _.find(vm.ngService.billingPeriodLookup, function(o) {
                    return o.ItemId == ItemBillingPeriod
                });
                angular.forEach(vm.ngService.jobModel.Resource, function(resource, i) {
                    resource.ItemBillingPeriod = ItemBillingPeriod;
                    resource.isBillable = !defaultbillingPeriod.IsNotBillable;
                    resource.BillingPeriod = defaultbillingPeriod.Id;
                });
            }
        }

        function onChangeStartDate() {
            var hasStartDateAndEndDate = (vm.ngService.jobModel.JobStartDate && vm.ngService.jobModel.JobEndDate);
            if (hasStartDateAndEndDate) {
                var convertedStartDate = new Date(moment(vm.ngService.jobModel.JobStartDate)
                    .format('YYYY-MM-DD') + ' ' + (vm.ngService.jobModel.JobStartTime != null ? vm.ngService.jobModel.JobStartTime : '00:00:00'));
                var convertedEndDate = (vm.jobEndDateVisible || (vm.ngService.isEditMode && vm.ngService.jobModel.TicketType === 1)) ? new Date(moment(vm.ngService.jobModel.JobEndDate)
                    .format('YYYY-MM-DD') + ' ' + (vm.ngService.jobModel.JobEndTime != null ? vm.ngService.jobModel.JobEndTime : '00:00:00')) : null;

                var diff = date_diff_indays(vm.ngService.jobModel.JobStartDate, vm.ngService.jobModel.JobEndDate);

                vm.ngService.jobModel.JobEndDate = utils.validateDateOnChange(
                    convertedStartDate,
                    convertedEndDate,
                    vm.ngService.isEditMode,
                    disableSameDayEndDate(
                        vm.ngService.jobModel.JobStartTime,
                        vm.ngService.jobModel.JobEndTime,
                        vm.ngService.jobModel.JobStartDate,
                        vm.ngService.jobModel.JobEndDate
                    ));

                    vm.showError = diff > 90;
                    if(vm.showError && vm.ngService.jobModel.JobEndDate !== null){
                        vm.ngService.jobModel.JobStartDate = null;
                    }

                return;
            }

            vm.showError = false;
        }

        function onChangeEndDate(){
            var hasStartDateAndEndDate = (vm.ngService.jobModel.JobStartDate && vm.ngService.jobModel.JobEndDate);
            if (hasStartDateAndEndDate) {
                var diff = date_diff_indays(vm.ngService.jobModel.JobStartDate, vm.ngService.jobModel.JobEndDate);

                vm.showError = diff > 90;
                if(vm.showError){
                    vm.ngService.jobModel.JobStartDate = null;
                    vm.ngService.jobModel.JobEndDate = null;

                    return;
                }
            }

            vm.showError = false;
        }

        function onKeyUpJobDuration(){
            if(vm.ngService.jobModel.JobDuration > 90){
                vm.showJobDurationError = true;
                vm.ngService.jobModel.JobDuration = null;

                return;
            }

            vm.showJobDurationError = false;
        }

        function filterStartDate(date) {
            return true;
        }

        function filterEndDate(date) {
            return utils.filterEndDate(
                date,
                -2,
                vm.ngService.jobModel.JobStartDate,
                vm.dateFormat,
                disableSameDayEndDate(
                    vm.ngService.jobModel.JobStartTime,
                    vm.ngService.jobModel.JobEndTime,
                    vm.ngService.jobModel.JobStartDate,
                    vm.ngService.jobModel.JobStartDate
                ));
        }

        function disableSameDayEndDate(startTime, endTime, startDate, endDate) {
            if (vm.ngService.jobModel.TicketType != 1) {
                return vm.ngService.jobModel.Is24HourRotation;
            } else {
                return validateTime(startTime, endTime, startDate, endDate);
            }
        }

        function validateTime(startTime, endTime, startDate, endDate) {
            var processedDateTime = composedDateTime(startTime, endTime, startDate, endDate);

            if (processedDateTime.convertedStartTime >= processedDateTime.convertedEndTime) {
                return true;
            }
            return false;
        }

        function composedDateTime(startTime, endTime, startDate, endDate) {
            var _convertedStartTime = new Date(moment(startDate)
                .format('YYYY-MM-DD') + ' ' + startTime);
            var _convertedEndTime = new Date(moment(endDate)
                .format('YYYY-MM-DD') + ' ' + endTime);

            var newComposedDateTime = {
                convertedStartTime: _convertedStartTime,
                convertedEndTime: _convertedEndTime
            }

            return newComposedDateTime;
        }

        function validateJobEndDate() {
            if (vm.ngService.jobModel.JobEndDate) {
                if (vm.ngService.jobModel.TicketType == 1) {
                    if (!vm.ngService.isEditMode) {
                        var processedDateTime = composedDateTime(
                            vm.ngService.jobModel.JobStartTime,
                            vm.ngService.jobModel.JobEndTime,
                            vm.ngService.jobModel.JobStartDate,
                            vm.ngService.jobModel.JobEndDate);
                        if (processedDateTime.convertedEndTime <= processedDateTime.convertedStartTime && vm.ngService.jobModel.JobEndTime) {
                            vm.ngService.jobModel.JobEndDate = null;
                        }
                    }
                }

                if (vm.ngService.jobModel.TicketType == 3 || vm.ngService.jobModel.TicketType == 7) {
                    if (!vm.ngService.isEditMode) {
                        var startTime = formatDateTime(vm.ngService.jobModel.JobStartDate, vm.ngService.jobModel.JobStartTime);
                        var endTime = formatDateTime(vm.ngService.jobModel.JobStartDate, vm.ngService.jobModel.JobEndTime);

                        if (startTime > endTime) {
                            endTime.setDate(endTime.getDate() + 1);
                        }

                        var lengthOfShift = (endTime - startTime) / 36e5;

                        if (lengthOfShift > 24) {
                            vm.ngService.jobModel.JobEndDate = null;
                        }
                        if (vm.ngService.jobModel.Is24HourRotation && vm.ngService.jobModel.JobStartDate.getTime() === vm.ngService.jobModel.JobEndDate.getTime()) {
                            vm.ngService.jobModel.JobEndDate = null;
                        }
                    }
                }
            }
        }

        function formatDateTime(stringDate, stringTime) {
            var dateTimeString = moment(stringDate)
                .format('YYYY-MM-DD') + ' ' + stringTime;
            var formattedDate = new Date(dateTimeString);

            return formattedDate;
        }

        function showOtherOption() {
            vm.jobDurationVisible = !vm.jobDurationVisible;
            if (!vm.jobDurationVisible) {
                vm.ngService.jobModel.JobDuration = 0;
            } else {
                vm.ngService.jobModel.JobDuration = 1;
                vm.ngService.jobModel.JobEndDate = null;
                vm.showJobDurationError = false;
                vm.showError = false;
            }
            vm.jobEndDateVisible = !vm.jobEndDateVisible;
            vm.title = vm.jobDurationVisible ? 'Job Duration' : 'Job End Date';
        }

        function bindElement(elements) {
            $document.find('#customisedFields2')
                .empty();
            $document.find('#customisedFields2')
                .append($compile(elements)($scope));

            if (vm.claimsUtilService.isAltusSpecialEnabled()) {
                vm.ngService.customFieldsValid = vm.CustomForm;
            }
        }

        function filterFields() {
            var elements = [];
            angular.forEach(vm.ngService.customisedFields, function(field) {
                angular.forEach(field.LookupTypes, function(type) {
                    if (type.id == vm.ngService.jobModel.TicketType) {
                        elements.push(field);
                    }
                });
            });
            bindElement(customisedFieldsFactory.constructUIForm(elements, 'vm', false, true));
        }

        function bindValues() {
            filterFields();

            angular.forEach(vm.ngService.customisedFields, function(field) {
                if (field.FieldType == 12) {
                    angular.forEach(field.Option, function(opt) {
                        vm['ChkRegcs' + field.Variable + opt.Name] = false;
                        vm['ChkRegcs' + field.Variable + opt.Name + "Specify"] = "";
                    });
                }
            });

            angular.forEach(vm.ngService.jobModel.CustomFields, function(value) {
                let chk = value.Id.indexOf('Chk') >= 0 ? true : false;
                let other = value.Id.indexOf('Other') >= 0 ? true : false;

                if (!chk && !other) {
                    let Id = parseInt(value.Id.slice(value.Id.length - 3));
                    let field = _.find(vm.ngService.customisedFields, {
                        Variable: Id
                    });

                    if (field.FieldType == 12 || field.FieldType == 2) {
                        let field_value = _.find(field.Option, {
                            Value: value.FieldValue
                        });
                        vm['ChkRegcs' + Id + field_value.Name] = true;
                        vm['ChkRegcs' + Id + field_value.Name + "Specify"] = "";
                    }
                }

                vm[value.Id] = value.FieldValue;

                if (value.Type == null) {
                    vm['Other' + value.Id] = value.FieldValue;
                    let doubleSlashExist = (angular.isUndefined(value.FieldValue) || _.isNumber(value.FieldValue) || _.isBoolean(value.FieldValue) || _.isNull(value.FieldValue)) ? false : value.FieldValue.includes('||');
                    if (doubleSlashExist) {
                        value.FieldValue = value.FieldValue.replace("null", "");
                        vm[value.Id] = value.FieldValue.substring(0, value.FieldValue.indexOf("|")) === "true" ? true : false;
                        vm[value.Id + "Specify"] = value.FieldValue.substring(value.FieldValue.lastIndexOf("|") + 1)
                    }
                }
            });
        }

        function getTimeIcon(timeStr) {
            var time = TimeLibrary.getTimeFromString(timeStr);
            if (!time) {
                return null;
            }
            return (time.hour >= 5 && time.hour < 17) ? 'icon-white-balance-sunny' : 'icon-brightness-2';
        }

        $scope.$watch('vm.ngService.customisedFields', function() {
            if (vm.ngService.customisedFields.length > 0) {
                bindValues()
            }
        });

        $scope.$watch('vm.ngService.jobModel.CustomFields', function() {
            if (vm.ngService.jobModel.CustomFields.length > 0) {
                bindValues();
            }
        });

        $scope.$watch('vm.ngService.jobModel.TicketType', function() {
            if (vm.ngService.customisedFields.length > 0) {
                filterFields();
            }
        });

        $scope.$watch('vm.ngService.saveMonitor', function() {
            vm.ngService.values = vm;
        });

        $scope.$watch('vm.ngService.jobModel.JobStartTime', function() {
            if (!_.isNil(vm.ngService.jobModel.JobStartTime) && !start_time_already_set) {
                if (vm.ngService.isEditMode || vm.ngService.isCloning) {
                    vm.ngService.jobModel.JobStartTime = TimeLibrary.convertTime(vm.ngService.jobModel.JobStartTime);
                    vm.ngService.currentJobStartTime = vm.ngService.jobModel.JobStartTime;
                    start_time_already_set = true;
                }
            }

            vm.jobStartTimeIcon = getTimeIcon(vm.ngService.jobModel.JobStartTime);
            vm.jobDuration = calculateShiftLength();
        });

        $scope.$watch('vm.ngService.jobModel.JobEndTime', function() {
            if (!_.isNil(vm.ngService.jobModel.JobEndTime) && !end_time_already_set) {
                if (vm.ngService.isEditMode || vm.ngService.isCloning) {
                    vm.ngService.jobModel.JobEndTime = TimeLibrary.convertTime(vm.ngService.jobModel.JobEndTime);
                    vm.ngService.currentJobEndTime = vm.ngService.jobModel.JobEndTime;
                    end_time_already_set = true;
                }
            }
            vm.jobEndTimeIcon = getTimeIcon(vm.ngService.jobModel.JobEndTime);
            vm.jobDuration = calculateShiftLength();
        });

        $scope.$watch('vm.ngService.jobModel.JobStartDate', function() {
            if (!_.isNil(vm.ngService.jobModel.JobStartDate) && !start_date_already_set) {
                if (vm.ngService.isEditMode || vm.ngService.isCloning) {
                    vm.ngService.jobModel.JobStartDate = vm.ngService.jobModel.JobStartDate;
                    vm.ngService.currentJobStartDate = vm.ngService.jobModel.JobStartDate;
                    start_date_already_set = true;
                }
            }
        });

        $scope.$watch('vm.ngService.jobModel.Client', function() {
            if (!_.isNil(vm.ngService.jobModel.Client) && !client_already_set) {
                if (vm.ngService.isEditMode || vm.ngService.isCloning) {
                    vm.ngService.jobModel.Client = vm.ngService.jobModel.Client;
                    vm.ngService.selectedClient = vm.ngService.jobModel.Client;
                    client_already_set = true;
                }
            }
        });

        $scope.$watch('vm.ngService.jobModel.Division', function() {
            if (!_.isNil(vm.ngService.jobModel.Division) && !division_already_set) {
                if (vm.ngService.isEditMode || vm.ngService.isCloning) {
                    vm.ngService.jobModel.Division = vm.ngService.jobModel.Division;
                    vm.ngService.selectedDivision = vm.ngService.jobModel.Division;
                    division_already_set = true;
                }
            }
        });

        $scope.$watch('vm.ngService.jobModel.Project', function() {
            if (!_.isNil(vm.ngService.jobModel.Project) && !project_already_set) {
                if (vm.ngService.isEditMode || vm.ngService.isCloning) {
                    vm.ngService.jobModel.Project = vm.ngService.jobModel.Project;
                    vm.ngService.selectedProject = vm.ngService.jobModel.Project;
                    project_already_set = true;
                }
            }
        });

        vm.activate();
    }
})();

(function () {
  'use strict';

  angular.module('app.jobs.components.jobDetails')
    .directive('jobDetailsComponent', jobDetailsComponent);

  /** @ngInject */
  function jobDetailsComponent() {

    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/manage/components/JobDetailsComponent/job-details.html'
      , scope: {
          ngService: '=',
          name: '@',
          stepperForm: '<'
      }
      , controller: 'JobDetailsController as vm'
      , bindToController: true
    };

    return directive;
  }
})();

{
    angular
        .module('app.jobs.components.orderedBy')
        .controller('contactDropDownPopUpComponentController', contactDropDownPopUpComponentController);

    /** @ngInject */
    function contactDropDownPopUpComponentController(
        $mdDialog,
        exceptionService,
        contactApi,
        jobToastService,
        $q,
        $timeout,
        $rootScope,
        blockUI,
        $translate,
        claimsUtilService
    ) {
        var vm = this;

        var previousClientSelected = null;
        $rootScope.cache.removeAll();
        vm.showDialog = showDialog;
        vm.openMenu = openMenu;
        vm.formatResourceNotes = formatResourceNotes;
        vm.hasMatchingResult = true;
        vm.searchTextChange = searchTextChange;
        vm.isTicketLockedByPreSchedule = isTicketLockedByPreSchedule;
        vm.showMoreInformationButton = showMoreInformationButton;

        const types = [{
            id: "person-ordering",
        },
        {
            id: "site-contact",
        }];

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;

        function isTicketLockedByPreSchedule()
        {
            return vm.ngService.jobModel.IsLockedByPreSchedule && claimsUtilService.isSmartSchedulingEnabled();
        }

        function formatResourceNotes(note) {
            if (note == null) {
                return "";
            } else {
                if (note.length > 50) {
                    return note.substring(0, 47) + "...";
                } else {
                    return note;
                }
            }
        }

        function querySearch(query) {
            var deferred = $q.defer();

            previousClientSelected = $rootScope.cache.get('_previousClientSelected');
            if ((vm.ngService.jobModel.Client && JSON.stringify(previousClientSelected) != JSON.stringify(vm.ngService.jobModel.Client)) &&
                !vm.ngService.isEditMode &&
                vm.ngService.clientLookup.length <= 0) {
                vm.ngService.clientLookup = [];
                vm.ngService.getContactClientByBranchAndCompanyLookup(vm.ngService.jobModel.Client.Id, vm.ngService.jobModel.Branch.Id)
                    .then(function() {
                        var results = query ? vm.ngService.clientLookup.filter(createFilterFor(query)) : vm.ngService.clientLookup;
                        deferred.resolve(results);
                        previousClientSelected = angular.copy(vm.ngService.jobModel.Client);
                        $rootScope.cache.put('_previousClientSelected', previousClientSelected);
                    })
                    .catch(function() {
                        deferred.reject();
                    });
            } else {
                var results = query ? vm.ngService.clientLookup.filter(createFilterFor(query)) : vm.ngService.clientLookup;
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 10, false);
            }
            return deferred.promise;
        }

        function searchTextChange(queryString) {
            vm.hasMatchingResult = false;
            vm.ngService.isContactFieldValid = false;

            if (queryString)
            {
                if (vm.ngService.clientLookup)
                {
                    var contact = vm.ngService.clientLookup.filter(x => x.FullName.toLowerCase() === queryString.trim().toLowerCase())[0];
                    if (contact)
                    {
                        mapContactFields(contact);
                        vm.hasMatchingResult = true;
                        vm.ngService.isContactFieldValid = true;
                    }
                }
            }
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(item) {
                if (angular.lowercase(item.FullName).indexOf(lowercaseQuery) === 0) {
                    return (angular.lowercase(item.FullName).indexOf(lowercaseQuery) === 0);
                } else {
                    return (angular.lowercase(item.LastName).indexOf(lowercaseQuery) === 0);
                }

            };
        }

        function openMenu($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        };

        function showDialog(arg) {
            if (vm.ngService.jobModel.Client) {
                var locals = vm.ngService;

                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/main/jobs/manage/components/ContactDropdownPopupComponent/contact-dropdown-popup-manage-dialog.html',
                    controller: 'manageContactDialogController as manageContactDialogVm',
                    locals: locals
                }).then(function(result) {
                    if (result) {
                        saveNewContact(result);
                    }

                }, function() {});
            } else {
                $translate('MANAGE.PERSONORDERINGADDNEWCONTACTERROR').then(function(translations) {
                    jobToastService.toast(translations);
                });
            }
        }

        function saveNewContact(payload) {
            blockUI.start("Saving New Contact");
            contactApi.postContactMinify(payload)
                .then(function(resp) {
                    if (_.find(resp.data.Branches, function(o) {
                            return o.Id == vm.ngService.jobModel.Branch.Id
                        })) {
                        previousClientSelected = null;
                        $rootScope.cache.removeAll();
                        jobToastService.toast("New Contact Successfully Created");
                        vm.ngService.clientLookup = [];
                        querySearch(resp.data.LastName);
                        $timeout(function() {
                            vm.ngModel = {
                                Id: resp.data.Id,
                                FirstName: resp.data.FirstName,
                                LastName: resp.data.LastName,
                                FullName: resp.data.FirstName + ' ' + resp.data.LastName
                            };
                            blockUI.stop();;
                        }, 300)
                    }
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function mapContactFields(contactMatchWithquery)
        {
            angular.forEach(types, function(value) {
                if (vm.id === value.id && value.id === 'person-ordering' && vm.ngService.jobModel.PersonOrdering == null) {
                    vm.ngService.jobModel.PersonOrdering = {
                        Id: contactMatchWithquery.Id,
                        FirstName: contactMatchWithquery.FirstName,
                        LastName: contactMatchWithquery.LastName,
                        FullName: contactMatchWithquery.FullName
                    }
                }
                else if (vm.id === value.id && value.id === 'site-contact' && vm.ngService.jobModel.SiteContact == null)
                {
                    vm.ngService.jobModel.SiteContact = {
                        Id: contactMatchWithquery.Id,
                        FirstName: contactMatchWithquery.FirstName,
                        LastName: contactMatchWithquery.LastName,
                        FullName: contactMatchWithquery.FullName
                    }
                }

            });
        }

        function selectedItemChange(item) {
            if (!item)
            {
                vm.ngService.isContactFieldValid = false;
                vm.hasMatchingResult = false;
                return;
            }

            vm.hasMatchingResult = true;
            vm.ngService.isContactFieldValid = true;
            mapContactFields(item);

            if (!vm.ngService.jobModel.PersonOrdering || !vm.ngService.jobModel.SiteContact) {
                vm.ngService.isContactFieldValid = false;
            }
        }

        function showMoreInformationButton() {
            return (!vm.ngService.jobModel.IsLocked && !vm.isTicketLockedByPreSchedule() && !vm.ngService.jobModel.IsCancelled)
                   && (!vm.ngService.isEditMode || (vm.ngService.isCloning || vm.ngService.isEditMode))
        }
    }
}

{
    angular
        .module('app.jobs.components.orderedBy')
        .directive('contactDropDownPopUpComponent', contactDropDownPopUpComponent);

    /** @ngInject */
    function contactDropDownPopUpComponent(branchApi, exceptionService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/manage/components/ContactDropdownPopupComponent/contact-dropdown-popup.html',
            scope: {
                ngModel: '=',
                ngService: '=',
                attribute: '=',
                id: '@'
            },
            controller: 'contactDropDownPopUpComponentController as contactDropDownPopUpComponentvm',
            bindToController: true,
            replace: true
        };

        return directive;

    }
}

{
    angular
        .module('app.jobs.components.orderedBy')
        .controller('manageContactDialogController', manageContactDialogController);

    /** @ngInject */
    function manageContactDialogController(
        emailPattern,
        locals,
        $mdDialog
    ) {
        var vm = this;

        vm.Branches = locals.branchLookup;
        vm.ContactTypes = locals.contactTypeLookup;

        vm.selectedBranches = [];

        vm.onCancel = closeDialog
        vm.onAdd = onAdd;

        vm.emailPattern = emailPattern;

        init();

        function init() {
            if (locals.jobModel.Branch) {
                vm.selectedBranches = [{
                    Id: locals.jobModel.Branch.Id
                }];
            }
        }

        function onAdd() {
            angular.forEach(vm.selectedBranches, function(value) {
                value.id = value.Id;
                delete value.Division;
            });

            var Emails = [{
                EmailAddress: vm.Email,
                IsPrimary: true
            }];

            var Phones = [{
                Number: vm.Number,
                PhoneType: {
                    Id: 1,
                    TypeName: "Mobile"
                },
                IsPrimary: true
            }];

            var company = _.find(locals.companyLookup, function(o) {
                return o.Id == locals.jobModel.Client.Id;
            });
            var Companies = [{
                Company: {
                    id: company.Id,
                    Name: company.Name
                }
            }];

            $mdDialog.hide({
                Emails: Emails,
                ResourceNotes: vm.ResourceNotes,
                FirstName: vm.FirstName,
                LastName: vm.LastName,
                Phones: Phones,
                Companies: Companies,
                Branches: vm.selectedBranches
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }
    }
}

(function () {
  'use strict';

  angular
    .module('app.jobs.components.jobTags', [])
})();


(function () {
    'use strict';

    angular
        .module('app.jobs.components.jobTags')
        .controller('JobTagsController', JobTagsController);

    /** @ngInject */
    function JobTagsController(
        jobTagService,
        $translate) {

        var vm = this;
        vm.jobTagService = jobTagService;

        vm.activate = function () {
            jobTagService.getTicketTags(); //get all active tags      
        }

        vm.selectedTag = null;
        vm.searchText = null;

        vm.searchTagChange = function (text) {
            if (text.length > 25) {
                vm.searchText = text.substring(0, 25);
            }
        }

        vm.getTicketTags = function () {
            var allTags = vm.jobTagService.tagsLookup;
            var searchText = vm.searchText ? vm.searchText.toLowerCase() : '';
            if (allTags) {
                allTags = vm.jobTagService.tagsLookup.filter((tag) => {
                    return tag.Name.toLowerCase()
                        .includes(searchText) &&
                        !vm.ngService.ticketData.Tags
                            .some(_ => _.Name.toLowerCase() === tag.Name.toLowerCase());
                });
            }

            return allTags;
        }

        vm.addTag = function () {
            if (!_.isNil(vm.selectedTag)) {
                vm.jobTagService.pushTagToArrayModel(vm.selectedTag, vm.ngService.ticketData.Tags);
                vm.jobTagService.tagsLookup = _.filter(vm.jobTagService.tagsLookup, 
                    (tag) => tag.Id !== vm.selectedTag.Id);
                vm.searchText = '';
            }
        }

        vm.removeTag = function (removedTag) {
            vm.ngService.ticketData.Tags = _.filter(vm.ngService.ticketData.Tags, 
                (tag) => tag.Id !== removedTag.Id);
            vm.jobTagService.pushTagToArrayModel(removedTag, vm.jobTagService.tagsLookup);
        }

        vm.activate();
    }
})();

(function () {
  'use strict';
  
  angular.module('app.jobs.components.jobTags')
    .directive('jobTagsComponent', jobTagsComponent);

  /** @ngInject */
  function jobTagsComponent() {

    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/formsAndAttachments/components/JobTagsComponent/job-tags.html'
      , scope: {
          ticketId: '@',
          ngService: '='
      }
      , controller: 'JobTagsController as vm'
      , bindToController: true
    };

    return directive;
  }
})();

/**
 * Created by Ben Rei on 9/26/2016.
 */
{
  angular
    .module('app.jobs.confirmTicket',[])
}

/**
 * Created by Ben Rei on 9/26/2016.
 */
{
  angular
    .module('app.jobs.confirmTicket')
    .controller('confirmTicketController', confirmTicketController);

  /** @ngInject */
  function confirmTicketController($mdDialog,confirmBookingService, $translate) {
    var vm = this;
    var HashedTicket = null;
    var ticketToHash = null;
    $translate('CONFIRMBOOKING.ADD').then(function (translations) {
      confirmBookingService.currentLabel = translations;
    });

    vm.selectedUserIndex = undefined;
    vm.selectUserIndex = function (index, ticket) {
      if(confirmBookingService.currentIndex != null) {
        confirmBookingService.showDraggables = false;
        //confirmBookingService.currentLabel = 'Add';
      }
      confirmBookingService.currentIndex = index;

      if (vm.selectedUserIndex !== index) {
        vm.selectedUserIndex = index;
        if(ticketToHash){
          var selectedTicket = _.find(vm.ngService.Tickets,function(o){
            return o.id == ticketToHash;
          });

          if(HashedTicket){
            if(HashedTicket != JSON.stringify(selectedTicket).hashCode()){
              vm.ngService.disabledSaveButton = false;
              selectedTicket.Edited = true;
            }
          }
        }

        ticketToHash = angular.copy(ticket.id);
        HashedTicket = JSON.stringify(ticket).hashCode();
      }
      else {
        vm.selectedUserIndex = undefined;
        confirmBookingService.currentIndex = null;
        var selectedTicket = _.find(vm.ngService.Tickets,function(o){
          return o.id == ticketToHash;
        });
        if(HashedTicket != JSON.stringify(selectedTicket).hashCode()){
          ticket.Edited = true;
        }
      }
    };

    vm.markedChanges = function(ticket){
      if(HashedTicket){
        if(HashedTicket != JSON.stringify(ticket).hashCode()){
          vm.ngService.disabledSaveButton = false;
          ticket.Edited = true;
        }
      }
    }

    vm.removeItem = function(ev, index,id)
    {
      var confirm = $mdDialog.confirm()
        //.title('Would you like to delete?')
        //.textContent('All of the banks have agreed to forgive you your debts.')
        //.ariaLabel('Lucky day')
        .title('Are you sure you would like to remove that ticket?')
        .targetEvent(ev)
        .ok('Yes!')
        .cancel('No');

      $mdDialog.show(confirm).then(function() {
        vm.ngService.deleteTicket(index,id);
        $mdDialog.hide();
      }, function() {
        $mdDialog.hide();
      });

    }

    vm.setUpdateFlag = function() {
        vm.ngService.isClonedTicketUpdated = true;
    }
  }
}

/**
 * Created by Ben Rei on 9/26/2016.
 */
{
  angular.module('app.jobs.confirmTicket')
    .directive('confirmTicketComponent', confirmTicketComponent);
  /** @ngInject */
  function confirmTicketComponent() {

    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/confirmBooking/components/confirmTicketComponent/confirm-ticket.html'
      , scope: {
        ngService: '=',
        ngJobService:'=',
        name: '@'
      }
      , bindToController: true
      , controller: 'confirmTicketController as vm'
    };

    return directive;
  }
}

/**
 * Created by Ben Rei on 8/19/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.jobs.components.droppableConfirmTicket',[])
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.components.droppableConfirmTicket')
    .controller('droppableConfirmTicketController', droppableConfirmTicketController);

  /** @ngInject */
  function droppableConfirmTicketController($scope,$translate,
                                       resourceComponentService)
  {
    var vm = this;
    vm.dropped = dropped;
    vm.Add = add;

    function add(){
      if(vm.ngService.showDraggables){
        vm.ngService.showDraggables = false;
        $translate('CONFIRMBOOKING.ADD').then(function (translations) {
          vm.ngService.currentLabel = translations;
        });
      }
      else{
        vm.ngService.showDraggables = true;
        $translate('CONFIRMBOOKING.HIDE').then(function (translations) {
          vm.ngService.currentLabel = translations;
        });
      }

    }

    function dropped(data)
    {
      $scope.$apply(function () {
        resourceComponentService.dropped(data,null,vm.ngService.Tickets[vm.ngService.currentIndex].ResourceItems);
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.jobs.components.droppableConfirmTicket')
    .directive('droppableConfirmTicketComponent', droppableConfirmTicketComponent);

  /** @ngInject */
  function droppableConfirmTicketComponent() {

    //
    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/confirmBooking/components/DroppableConfirmTicketComponent/Droppable-Confirm-Ticket.html'
      , scope: {
        ngModel:'=',
        ngService: '=',
        ticketIndex: '=',
        name: '@'
      }
      , bindToController: true
      , controller: 'droppableConfirmTicketController as droppableConfirmTicketVm'
    };

    return directive;
  }
})();

(function () {
    'use strict';

    angular.module('app.jobs.allocate.droppable')
        .service('ResourceAllocationSignalRService', ResourceAllocationSignalRService);

    /** @ngInject */
    function ResourceAllocationSignalRService(signalRService,
                                              $state,
                                              $rootScope,
                                              msgboxService,
                                              _,
                                              identityService,
                                              resourceAllocateService,
                                              jobService,
                                              $mdDialog,
                                              $timeout,
                                              blockUI) {

        var service = {
            register: register,
            isDialogOpen: false
        };

        var isInitialized = false; // To prevent multiple subscription to event
        const PREALLOCATE_CALLBACK_FAILED = 4;
        const AWAITING_DETAILS = 3;
        const AWAITING_RESOURCING = 4;
        const JOBMESSAGINGSTATUS_UNAVAILABLE = 9;

        return service;

        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function () {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }
        }

        function isModuleResourceAllocation() {
            return $state.current.name === "app.allocate"
        }

        function regs() {
            signalRService.messageHub.on('allocationChanged', function (data) {
                var throttle = _.debounce(function () {
                    if (isModuleResourceAllocation() && isSameTicket(data.TicketId)) {
                        let items = data.AllocatedResourceItems;
                        isSameUser(data.UserId) ? updateView(items) : showAllocationChangeMessage(items);
                    }

                    if ($state.current.name == 'app.jobs_whiteboard_resource') {
                        if(data.Status == AWAITING_RESOURCING || data.Status == AWAITING_DETAILS){
                            var ticketElement = document.getElementById(data.TicketNumber.toString());
                            if (!ticketElement) {
                                return;
                            }
                            var headerCard = ticketElement.getElementsByClassName('list-card-label2');

                            if(headerCard.length > 0){
                                headerCard[0].classList.remove("md-deep-purple-500-bg");

                                let hasRemainingCopilotScheduledResources = data.AllocatedResourceItems.some(x => x.AllocatedId && x.IsAllocatedBySmartScheduling);
                                
                                if(data.Status == AWAITING_DETAILS){
                                    headerCard[0].classList.add("md-orange-bg");
                                }
                                else if(data.Status == AWAITING_RESOURCING && !hasRemainingCopilotScheduledResources){
                                    headerCard[0].classList.add("md-red-bg");
                                }
                                else {
                                    headerCard[0].classList.add("md-deep-purple-500-bg");
                                }
                            }
                        }

                        return;
                    }
                }, 1500, [{leading: false}, {trailing: false}]);
                throttle();
            });

            // External ticket approval/rejection event from backend (new)
            signalRService.messageHub.on('externalTicketApprovalChanged', function (data) {
                if ($state.current.name == 'app.jobs_whiteboard_resource') {
                    $rootScope.$broadcast('Whiteboard:ExternalApprovalChanged', data);
                }
            });

            signalRService.messageHub.on('messagingStatusChanged', function (data) {
                var throttle = _.debounce(function () {

                    if ($state.current.name == 'app.jobs_whiteboard_resource') {
                        if(data.Status == JOBMESSAGINGSTATUS_UNAVAILABLE){
                            var ticketElement = document.getElementById(data.TicketNumber.toString());
                            if (!ticketElement) {
                                return;
                            }
                            var headerCard = ticketElement.getElementsByClassName('list-card-label2');

                            if(headerCard.length > 0){
                                headerCard[0].classList.remove("md-deep-purple-500-bg");
                                headerCard[0].classList.remove("md-green-bg");
                                headerCard[0].classList.add("md-red-bg");
                            }
                        }

                        return;
                    }
                }, 1500, [{leading: false}, {trailing: false}]);
                throttle();
            });

            signalRService.messageHub.on('preScheduleStatusChanged', function(data) {
                var throttle = _.debounce(function() {
                    if ($state.current.name == 'app.jobs_update') {
                        let currentTicket = data.Tickets.find(x => x.TicketId == jobService.ticketId);

                        if (!currentTicket)
                        {
                            return;
                        }

                        jobService.jobModel.AllResourcesAllocated = currentTicket.AllResourcesAllocated;
                        jobService.jobModel.PreScheduleJobStatus = data.PreScheduleJobStatus;
                        jobService.jobModel.LatestPreScheduleJobId = data.PreScheduleJobId;
                        jobService.allocatedResources = currentTicket.AllocatedResourceItems;

                        if (data.PreScheduleJobStatus == PREALLOCATE_CALLBACK_FAILED) {
                            jobService.isSmartSchedulingFailed = true;
                            jobService.jobModel.IsLockedByPreSchedule = true;
                        }
                        else{
                            jobService.isSmartSchedulingFailed = false;
                            jobService.isSmartSchedulingSuccess = true;
                            jobService.jobModel.IsLockedByPreSchedule = false;
                            jobService.jobModel.HasResourcesAllocated = true;
                        }

                        $rootScope.$digest();
                        return;
                    }

                    if (isModuleResourceAllocation()) {
                        let currentTicket = data.Tickets.find(x => x.TicketId == resourceAllocateService.ticketInfo.id);

                        if (!currentTicket)
                        {
                            return;
                        }

                        resourceAllocateService.ticketInfo.AllResourcesAllocated = currentTicket.AllResourcesAllocated;
                        resourceAllocateService.ticketInfo.LatestPreScheduleJobId = data.PreScheduleJobId;
                        resourceAllocateService.allocatedResource = currentTicket.AllocatedResourceItems;
                        resourceAllocateService.droppables = currentTicket.AllocatedResourceItems;
                        
                        if (data.PreScheduleJobStatus == PREALLOCATE_CALLBACK_FAILED) {
                            resourceAllocateService.isSmartSchedulingFailed = true;
                            resourceAllocateService.ticketInfo.IsLockedByPreSchedule = true;
                        }
                        else{
                            resourceAllocateService.isSmartSchedulingFailed = false;
                            resourceAllocateService.ticketInfo.IsLockedByPreSchedule = false;
                        }

                    }

                    if ($state.current.name == 'app.jobs_whiteboard_resource') {
                        var ticketNumber = data.Tickets[0].TicketNumber;

                        if (data.PreScheduleJobStatus == PREALLOCATE_CALLBACK_FAILED) {
                            $timeout(function ()
                            {
                                blockUI.stop();

                                var headerCard = document.getElementById(ticketNumber.toString()).getElementsByClassName('list-card-label2');

                                if(headerCard.length > 0){
                                    headerCard[0].classList.remove("md-red-bg");
                                    headerCard[0].classList.remove("md-orange-bg");
                                    headerCard[0].classList.add("md-purple-200-bg");
                                }

                                var smartScheduleHeaderIcon = document.getElementById(ticketNumber.toString()).getElementsByClassName('smart-schedule-rw-top');

                                if(smartScheduleHeaderIcon.length > 0){
                                    smartScheduleHeaderIcon[0].classList.remove("ng-hide");
                                }

                                var smartScheduleIcon = document.getElementById(ticketNumber.toString()).parentElement.getElementsByClassName('smart-schedule');

                                if(smartScheduleIcon.length > 0){
                                    smartScheduleIcon[0].parentElement.remove();
                                }

                                var timesheetIcon = document.getElementById(ticketNumber.toString()).parentElement.getElementsByClassName('icon-calendar-clock');

                                if(timesheetIcon.length > 0){
                                    timesheetIcon[0].removeAttribute("ng-click");
                                    timesheetIcon[0].classList.remove("grey-900-fg");
                                    timesheetIcon[0].classList.add("grey-400-fg");
                                    timesheetIcon[0].classList.add("not-clickable-resource-whiteboard-item");
                                }

                                var cloneIcon = document.getElementById(ticketNumber.toString()).parentElement.getElementsByClassName('icon-content-copy');

                                if(cloneIcon.length > 0){
                                    cloneIcon[0].removeAttribute("ng-click");
                                    cloneIcon[0].classList.remove("grey-900-fg");
                                    cloneIcon[0].classList.add("grey-400-fg");
                                    cloneIcon[0].classList.add("not-clickable-resource-whiteboard-item");
                                }

                                var deleteIcon = document.getElementById(ticketNumber.toString()).parentElement.getElementsByClassName('icon-delete');

                                if(deleteIcon.length > 0){
                                    deleteIcon[0].removeAttribute("ng-click");
                                    deleteIcon[0].classList.remove("grey-900-fg");
                                    deleteIcon[0].classList.add("grey-400-fg");
                                    deleteIcon[0].classList.add("not-clickable-resource-whiteboard-item");
                                }

                                var spaceBetweenCenter = document.getElementById(ticketNumber.toString()).parentElement.getElementsByClassName('layout-align-space-between-center');

                                if(spaceBetweenCenter.length > 1){
                                    spaceBetweenCenter[1].remove();
                                }

                                var newElement = document.getElementById(ticketNumber.toString()).parentElement.getElementsByClassName('layout-align-space-between-center');

                                if(newElement.length > 0){
                                    var resourceElement = newElement[0].parentElement;

                                    if(resourceElement.lastChild.textContent != "Scheduling Copilot Failed.") {
                                        resourceElement.appendChild(document.createTextNode("Scheduling Copilot Failed."));
                                        resourceElement.classList.add('ai-failed-scheduling');
                                    }
                                }
                                blockUI.stop();
                            });

                            return;
                        }

                        $timeout(function ()
                        {
                            var headerCard = document.getElementById(ticketNumber.toString()).getElementsByClassName('list-card-label2');

                            headerCard[0].classList.forEach(cls => {
                                if (cls.match(/md-.*-bg/))
                                {
                                    headerCard[0].classList.remove(cls);
                                }
                            });

                            if(headerCard.length > 0){
                                headerCard[0].classList.add("md-deep-purple-500-bg");
                            }

                            var smartScheduleHeaderIcon = document.getElementById(ticketNumber.toString()).getElementsByClassName('smart-schedule-rw-top');

                            if(smartScheduleHeaderIcon.length > 0){
                                smartScheduleHeaderIcon[0].classList.remove("ng-hide");
                            }

                            blockUI.stop();
                        });

                        return;
                    }

                    angular.forEach(data.Tickets, function(ticket) {
                        let items = ticket.AllocatedResourceItems;
                        updateView(items)
                    });

                    $rootScope.$digest();
                    return;
                }, 1500, [{
                    leading: false
                }, {
                    trailing: false
                }]);
                throttle();
            });
            }

        function isSameTicket(ticketId) {
            return resourceAllocateService.ticketGUID === ticketId;
        }

        function isSameUser(userId) {
            return (identityService.userData.UserId === userId) ? true : false
        }

        function showAllocationChangeMessage(items) {
            if(!service.isDialogOpen) {
                switchDialogStatus();
                msgboxService.alert('Resource Allocation', 'This ticket has been updated by another user. Please refresh the page', 'Okay').then(function(res) {
                    if(res){
                        refreshTicket(items);
                    }
                });
            }
        }

        function switchDialogStatus() {
            service.isDialogOpen = !service.isDialogOpen;
        }

        function refreshTicket(items) {
            switchDialogStatus();
            resourceAllocateService.refreshFromSignalR(items);
        }

        function updateView(items) {
            resourceAllocateService.refreshFromSignalR(items);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.allocate.droppable')
        .controller('droppableAllocateResourceController', droppableAllocateResourceController);

    /** @ngInject */
    function droppableAllocateResourceController(
        $state,
        allocationApi,
        identityService,
        mediaQueryService,
        $rootScope,
        $timeout,
        $mdDialog,
        messageStatusService,
        utils,
        exceptionService,
        ResourceAllocationSignalRService,
        resourceAllocateService,
        claimsUtilService,
        smartSchedulingService
    ) {
        //Data
        var vm = this;
        vm.service = resourceAllocateService;
        vm.utilService = utils;
        vm.mediaQueryService = mediaQueryService;
        vm.isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
        vm.isPayrollEnabled = claimsUtilService.isPayrollEnabled();
        vm.isLinkedItemsEnabled = claimsUtilService.isLinkedItemsEnabled();

        // With linking disabled the equipment list renders flat, as it did before the feature:
        // linked children are no longer filtered out of the top level, so they stay visible and
        // no parent/child connector is drawn. Stored links are untouched, so re-enabling the
        // feature restores the grouping with no re-linking.
        vm.equipmentListFilter = vm.isLinkedItemsEnabled
            ? { ItemType: '!' + 4, ParentAllocatedResourceId: null }
            : { ItemType: '!' + 4 };

        //Methods
        vm.activate = activate;
        vm.unAllocate = unAllocate;
        vm.confirm = confirm;
        vm.changeResource = changeResource;
        vm.getOperatorName = getOperatorName;
        vm.getMessageStatus = getMessageStatus;
        vm.getMessageStatusText = getMessageStatusText;
        vm.linkedItemsCount = linkedItemsCount;
        vm.linkedItemsOf = linkedItemsOf;
        vm.hasLinkedItems = hasLinkedItems;

        vm.activate();

        function activate() {
            vm.service.droppables = [];
            vm.service.divisionId = null;

            ResourceAllocationSignalRService.register();

            if (vm.service.ticketGUID) {
                vm.service.showDroppableLoader = true;
                vm.service.fetchTicket();
            }
        }

        function getMessageStatus(status) {
            return messageStatusService.getStatusColor(status).color;
        }

        function getMessageStatusText(status) {
            return messageStatusService.getStatusColor(status).name;
        }

        function getOperatorName(operator_id, operators) {
            let operator = _.find(operators, {
                AllocatedId: operator_id
            });
            return operator ? operator.AllocatedItemName : null;
        }

        function changeResource(line, itemType) {
            if (itemType === 'People' && !line.AllocatedId) {
                exceptionService.showError("Please allocate a resource to continue.", function() {
                    onClose();
                }, 'Resource Allocation');
                return;
            }

            vm.service.showResourceDialog({
                people: vm.service.peopleTypes,
                equipment: vm.service.EquipmentTypes,
                lineItem: line,
                itemType: itemType,
                skills: vm.service.SkillsList
            });
        }

        function showLinkItemModal(line) {
            vm.service.showLinkItemModal({
                people: vm.service.peopleTypes,
                equipment: vm.service.EquipmentTypes,
                lineItem: line,
                itemType: itemType,
                skills: vm.service.SkillsList
            });
        }

        function drop(data) {}

        function unAllocate(itm) {
            var hasATimesheetSubmitted = vm.service.hasASubmittedTimesheet(itm, false);

            hasATimesheetSubmitted.then(function(isSubmitted) {
                if (isSubmitted) {
                    var dialog = $mdDialog
                        .confirm()
                        .title("")
                        .htmlContent(utils.translate('RESOURCEALLOCATION.REMOVE_RESOURCE_WITH_SUBMITTED_TIMESHEET'))
                        .ok("GO TO TIMESHEET")
                        .cancel("CANCEL");

                    $mdDialog.show(dialog).then(function() {
                        $state.go('app.timesheet', {
                            id: itm.TicketId,
                            TicketNo: itm.TicketNumber
                        });
                    });
                } else {
                    var confirm = vm.service.confirmGenerator(utils.translate('RESOURCEALLOCATION.CONFIRMATION'), utils.translate('RESOURCEALLOCATION.REMOVE_RESOURCE_MESSSAGE'), utils.translate('RESOURCEALLOCATION.CONFIRMATION'), utils.translate('RESOURCEALLOCATION.YES'), utils.translate('RESOURCEALLOCATION.NO'));

                    $mdDialog.show(confirm).then(async function(resp) {
                        if (resp)
                            await unallocateNow(itm);
                    });
                }
            });
        }

        async function unallocateNow(itm) {
            let data = vm.service.IsMultiDayEquipmentJob ?
                setMultidayDeallocationModel(itm) :
                setNonMultidayDeallocationModel(itm);

            vm.service.unAllocateResource(data);
        }

        function setMultidayDeallocationModel(itm) {
            return {
                ItemId: itm.ItemId,
                TicketId: itm.TicketId,
                Id: itm.Id,
                Process: vm.service.allocation_option,
                TicketNumber: itm.TicketNumber,
                IsMultidayEquipmentJob: vm.service.IsMultiDayEquipmentJob,
                ReferenceId: itm.ReferenceId
            }
        }

        function setNonMultidayDeallocationModel(itm) {
            return {
                ItemId: itm.ItemId,
                TicketId: itm.TicketId,
                Id: itm.Id
            }
        }

        function setConfirmationData(itm) {
            return {
                ItemId: itm.ItemId,
                TicketId: itm.TicketId,
                Id: itm.Id
            }
        }

        function setDroppablesStatusToConfirmed(Id, droppables) {
            angular.forEach(droppables, function(droppable) {
                if (droppable.Id == Id) {
                    droppable.Status = 3;
                    droppable.MessageStatus = 7;
                }
            });
            return droppables;
        }

        function preSaveConfirmation(itm) {
            var data = setConfirmationData(itm);
            setDroppablesStatusToConfirmed(data.Id);
            saveConfirmation(data);
        }

        function saveConfirmation(data) {
            allocationApi.confirmResource(data).then(result => {
                {
                const {ErrorMessage} = result.data;

                if (ErrorMessage)
                {
                    var title= ErrorMessage.indexOf('approved unavailability request') >= 0 ? 'Approved Unavailability Request' : 'Pending Unavailability Request';
                    var notif = $mdDialog.alert()
                        .title(title)
                        .htmlContent(ErrorMessage)
                        .ariaLabel(ErrorMessage)
                        .ok('Ok')

                    $mdDialog.show(notif);
                    return;
                }
                vm.service.droppables = setDroppablesStatusToConfirmed(data.Id, vm.service.droppables);
                vm.service.pushV2(data.Id, vm.service.ticketGUID, data, identityService.userData.UserId);

                if (claimsUtilService.isSmartSchedulingEnabled())
                {
                    smartSchedulingService.confirmPreScheduleJobByTicketIds([vm.service.ticketGUID]);
                }

            }
            }).catch(showConfirmationIssue);
        }

        function showConfirmationIssue(err) {
            vm.service.reloader = false;
            vm.service.fetchTicket();
            exceptionService.resolve(err);
        }

        function isValidToAllocate() {
            return allocationApi.getCompanyCreditType(vm.service.ticketGUID);
        }

        function confirm(itm) {
            isValidToAllocate().then(function(resp) {
                resp.data.CanAllocateResources ? showConfirmPrompt(itm) : showCreditTypeIssue();
            });
        }

        function showConfirmPrompt(itm) {
            var confirm = vm.service.confirmGenerator(utils.translate('RESOURCEALLOCATION.CONFIRMATION'), utils.translate('RESOURCEALLOCATION.CONFIRM_RESOURCE'), utils.translate('RESOURCEALLOCATION.CONFIRMATION'), utils.translate('RESOURCEALLOCATION.YES'), utils.translate('RESOURCEALLOCATION.NO'));
            return $mdDialog.show(confirm).then(function() {
                preSaveConfirmation(itm);
            });
        }

        function showCreditTypeIssue() {
            $mdDialog.show(
                $mdDialog.alert()
                .title(utils.translate('RESOURCEALLOCATION.RESOURCE-ALLOCATION'))
                .textContent(utils.translate('RESOURCEALLOCATION.CREDIT_HOLD_MESSAGE_CONFIRM'))
                .ariaLabel(utils.translate('RESOURCEALLOCATION.RESOURCE-ALLOCATION'))
                .ok(utils.translate('RESOURCEALLOCATION.OKAY'))
            );
        }

        // Delegates to the service so the equipment list, the resource dialog and anything else
        // asking "what is linked to this item" read the same predicate.
        function linkedItemsOf(itemId) {
            return vm.service.linkedItemsOf(itemId);
        }

        function linkedItemsCount(itemId) {
            return linkedItemsOf(itemId).length;
        }

        // True when the equipment list has at least one linked item, so the marker
        // (diamond/connector) column can be dropped entirely when nothing is linked instead of
        // reserving an empty left gutter.
        function hasLinkedItems() {
            return (vm.service.droppables || []).some(x => x.ParentAllocatedResourceId);
        }

        $rootScope.$on('resourceMessagingStatusCallback', function(event, args) {
            $timeout(function() {
                angular.forEach(vm.service.droppables, function(item) {
                    //Only change the message status to 'Queued to Send' if :
                    //Item id === args.key (Allocated resource Id) and
                    //Current message status is '0' or 'Notification not yet sent'
                    if (item.Id == args.Key && item.MessageStatus === 0) {
                        item.MessageStatus = args.Value;
                    }
                });
            })
        });

        $rootScope.$on('urn:updateMessagingStatus', function(event, args) {
            $timeout(function() {
                angular.forEach(vm.service.droppables, function(item) {
                    if (item.Id == args.AllocatedResourceItemId) {
                        item.MessageStatus = args.Status;

                        if (args.Status === 7) {
                            //being invoked when user clicked 'mark as accepted' button on job notifications
                            //will set the Job Status to 'Confirmed' on Resource Allocation
                            item.Status = 3;
                        }

                        if (args.Status === 6) {
                            //being invoked when app user clicked rejected the job
                            //will set the Job Status to 'Rejected' on Resource Allocation
                            item.Status = 4;
                        }

                        let waiting_statuses = [0, 1, 2, 3, 4, 5];

                        if (waiting_statuses.includes(args.Status)) {
                            //If MessageStatus is in [0, 1, 2, 3, 4, 5]
                            //Change Job Status to '2' or 'Allocated, Waiting for Confirmation'
                            item.Status = 2;
                        }
                    }
                });
            });
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.allocate.draggable')
        .controller('draggableAllocateResourceController', draggableAllocateResourceController);

    /** @ngInject */
    function draggableAllocateResourceController(
        resourceAllocateService,
        mediaQueryService,
        contactService,
        utils
    ) {
        var vm = this;
        vm.utilService = utils;
        vm.service = resourceAllocateService;
        vm.mediaQueryService = mediaQueryService;

        vm.select = select;
        vm.round = round;
        vm.formatName = formatName;
        vm.showDetails = showDetails;

        function select(index) {
            vm.selectedRow = index;
            vm.service.chosen_division = null;
        }

        function showDetails(lookup, $event) {
            contactService.showContactDetails(lookup.Id, true);
            $event.stopPropagation();
        }

        function formatName(name) {
            return _.isNil(name) ? "" : name.length > 35 ? name.substring(0, 32) + "..." : name;
        }

        function round(distance) {
            return Math.round(distance);
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.jobs.allocate.draggable')
    .directive('draggableAllocateResourceComponent', draggableAllocateResourceComponent);
  /** @ngInject */
  function draggableAllocateResourceComponent() {

    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/allocateResource/components/draggableComponent/Draggable-Allocate-Resource.html'
      , scope: {
        ngModel: '=',
        name: '@'
      }
      , bindToController: true
      , controller: 'draggableAllocateResourceController as vm'
    };

    return directive;
  }
})();

/**
 * Invoice report module
 * Created date: 12.12.2016
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports.view', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.invoice_report_pdf', {
            url: '/invoice/reports/view_invoices',
            views: {
                'content@app': {
                    templateUrl: 'app/main/invoice/view/invoice-list-view.html',
                    controller: 'InvoiceListViewController as invPdfViewVm'
                }
            },

            data: { 
                requireLogin: true,
                validateAccess: ['invoiceClaimsService', function (invoiceClaimsService) {
                    return invoiceClaimsService.hasViewInvoiceMenu;
                }]
            },
            resolve: {
                branchData: branchResolver
            }
          , title: 'View Invoices'
          , titleBar: 'Alloc8 - View Invoices'
        });

        $translatePartialLoaderProvider.addPart('app/main/invoice');
    };

    /** @ngInject */
    function branchResolver(invoiceFilterService) {
        return invoiceFilterService.loadLookups();
    }

})();

/**
 * Report filter component
 */
(function() {
    'use strict';

    angular.module('app.invoice.reports.view')
        .directive('invoiceReportFilterComponent', invoiceReportFilterComponent);

    /** @ngInject */
    function invoiceReportFilterComponent(invoiceFilterService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/view/directive/invoice-report-filter/invoice-report-filter.html',
            scope: {},
            controller: InvoiceReportFilterController,
            controllerAs: 'invReportFilterVm',
            bindToController: true
        };

        return directive;

        function InvoiceReportFilterController($mdDialog) {
            var vm = this;

            vm.showDatesFilter = showDatesFilter;
            vm.model = invoiceFilterService;
            vm.applyFilter = applyFilter;
            vm.resetFilter = resetFilter;
            vm.disableString = disableString;            

            function disableString(e) {
                var x = String.fromCharCode(e.which);

                if ((/[A-Za-z]/.test(x))) {
                    e.preventDefault();
                }
            }

            function showDatesFilter() {
                $mdDialog.show({
                    templateUrl: 'app/main/invoice/view/inv-date-chooser/inv-date-chooser.html',
                    controller: 'InvoiceDateChooserController as vm'
                }).then(function(resp) {
                    if (resp !== 'cancel')
                        invoiceFilterService.applyFilter();
                });
            }

            function applyFilter() {
                invoiceFilterService.applyFilter();
            }

            function resetFilter() {
                invoiceFilterService.reset();
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .directive('reportViewerComponent', reportViewerComponent);

    /** @ngInject */
    function reportViewerComponent(
        reportManagerService,
        invoiceCustomGridSearchService
    ) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/reports/directives/reportViewer/report-viewer.html',
            scope: {},
            controller: InvoiceReportViewerController,
            controllerAs: 'invRepVm',
            bindToController: true
        };

        return directive;

        function InvoiceReportViewerController(utils) {
            var vm = this;

            vm.model = reportManagerService;
            vm.customGridService = invoiceCustomGridSearchService;
            vm.dateFormat = utils.setDateFormat();
        }
    }
})();

/**
 * Invoice Resource Popup Controller
 * Created date: 12.12.2016
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .controller('InvoicePopupResourceController', InvoicePopupResourceController);

    /** @ngInject */
    function InvoicePopupResourceController($log
    ) {
        var vm = this;

        activate();

        //////////
        function activate() {
        
        }
    }
})();

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvoiceContent = function (_React$Component) {
    _inherits(InvoiceContent, _React$Component);

    function InvoiceContent() {
        _classCallCheck(this, InvoiceContent);

        var _this = _possibleConstructorReturn(this, (InvoiceContent.__proto__ || Object.getPrototypeOf(InvoiceContent)).call(this));

        _this.editInvoice = _this.editInvoice.bind(_this);
        _this.downloadInvoice = _this.downloadInvoice.bind(_this);
        _this.deleteInvoice = _this.deleteInvoice.bind(_this);
        _this.editTicket = _this.editTicket.bind(_this);
        _this.editTimeSheet = _this.editTimeSheet.bind(_this);
        _this.markAsReviewed = _this.markAsReviewed.bind(_this);
        return _this;
    }

    _createClass(InvoiceContent, [{
        key: 'editInvoice',
        value: function editInvoice(id) {
            this.props.oneditinvoice(id);
        }
    }, {
        key: 'downloadInvoice',
        value: function downloadInvoice(invoiceId, includePaperwork) {
            this.props.ondownloadinvoice(invoiceId, includePaperwork);
        }
    }, {
        key: 'deleteInvoice',
        value: function deleteInvoice(id) {
            this.props.ondeleteinvoice(id);
        }
    }, {
        key: 'editTicket',
        value: function editTicket(id, ticketNo, invId) {
            this.props.oneditticket(id, ticketNo, invId);
        }
    }, {
        key: 'editTimeSheet',
        value: function editTimeSheet(id, invId) {
            this.props.onedittimesheet(id, invId);
        }
    }, {
        key: 'markAsReviewed',
        value: function markAsReviewed(invId, e) {
            this.props.onmarkasreviewed(invId, e.target.checked);
        }

        /**
         * --------------------------------------
         * Utilities here
         * TODO: Create a reusable react utility
         * --------------------------------------
         */

    }, {
        key: 'epochToJsDateTime',
        value: function epochToJsDateTime(unixtime, format) {
            var fmt = format ? format : 'YYYY/MM/DD hh:mm:ss';
            if (unixtime === -2147483648 || !unixtime) return null;

            // Apply server date format 'MM/DD/YYYY HH:mm' together with Unix time
            var dt = moment(moment.unix(unixtime), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

            return format ? moment(dt).format(fmt) : moment(dt).toDate();
        }
    }, {
        key: 'moneyFormat',
        value: function moneyFormat(number, decimalPlaces) {
            var parsedNumber = number;

            var decimalPadding = function decimalPadding() {
                var tNum = ".";
                if (decimalPlaces > 0) {
                    for (var i = 0; i < decimalPlaces; i++) {
                        tNum += "0";
                    }
                } else {
                    tNum += "00";
                }
                return tNum;
            };

            if (!number || isNaN(number)) return "0" + decimalPadding();

            if (decimalPlaces > 0) {
                parsedNumber = Number(Math.round(number + 'e' + decimalPlaces) + 'e-' + decimalPlaces);
            }

            var arr = parsedNumber.toString().split('.');

            var result = arr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            result += arr.length > 1 ? "." + arr[1] : decimalPadding();

            return result;
        }
    }, {
        key: 'jsDateTime',
        value: function jsDateTime(date) {
            if (date == '' || date == undefined || date == null || moment(date).format('DD MMM YYYY').toUpperCase() == '01 JAN 1900') {
                return "";
            }
            return moment(date).format(this.props.dateformat).toUpperCase();
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var statusStyle = void 0;
            var tableStyle = void 0;

            statusStyle = {
                color: '#fff'
            };

            tableStyle = {
                width: '100%',
                minWidth: '100%'
            };

            /**
             * Create invoice body
             */
            var createInvoiceBody = function createInvoiceBody(lineItem) {
                var lineItemPartial = void 0;

                if (lineItem.TicketId != null) {
                    lineItemPartial = React.createElement(
                        'tr',
                        { key: lineItem.Id },
                        React.createElement(
                            'td',
                            { colSpan: '5' },
                            React.createElement(
                                'strong',
                                null,
                                lineItem.Description
                            ),
                            ' | ',
                            React.createElement(
                                'a',
                                { href: '#', onClick: self.editTicket.bind(this, lineItem.TicketId, lineItem.TicketNumber, lineItem.InvId) },
                                'Edit Ticket'
                            ),
                            ' \u2022 ',
                            React.createElement(
                                'a',
                                { href: '#', onClick: self.editTimeSheet.bind(this, lineItem.TicketId, lineItem.InvId) },
                                'Edit Timesheet'
                            )
                        )
                    );

                    return lineItemPartial;
                }

                if (!lineItem.Description) {
                    lineItemPartial = React.createElement(
                        'tr',
                        { key: lineItem.Id },
                        React.createElement(
                            'td',
                            { colSpan: '5' },
                            '\xA0'
                        )
                    );

                    return lineItemPartial;
                }

                var hasTags = lineItem.Description.includes("tags:");
                var shiftTags = lineItem.Description.includes(":[tags]:");

                var isNonChargeableEntry = lineItem.Description.toUpperCase() == 'SUPPLY OF TRAFFIC CONTROLLERS AT' || lineItem.Quantity == 0 && lineItem.UnitPriceExcludingTax <= 0;

                if (isNonChargeableEntry && !hasTags && !shiftTags) {
                    var timein24HourFormat = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/; // Shift hours
                    var phoneNumberFormat = /^[0-9 ]+$/;

                    var isAnAddressLine = lineItem.Description.toUpperCase() != 'SUPPLY OF TRAFFIC CONTROLLERS AT' && !lineItem.Description.substring(0, 5).match(timein24HourFormat) && !lineItem.Description.includes('Authorised By') && !lineItem.Description.match(phoneNumberFormat);

                    var descriptionValuePlaceholder = isAnAddressLine ? React.createElement(
                        'strong',
                        null,
                        lineItem.Description
                    ) : lineItem.Description;

                    lineItemPartial = React.createElement(
                        'tr',
                        { key: lineItem.Id },
                        React.createElement(
                            'td',
                            { colSpan: '5' },
                            descriptionValuePlaceholder
                        )
                    );

                    return lineItemPartial;
                }

                if (shiftTags) {

                    var tagsEl = void 0;

                    if (self.props.showtags) {
                        var descriptionTags = lineItem.Description.split(":[tags]:")[1];

                        tagsEl = descriptionTags.split(',').map(function (tag) {

                            if (!self.props.showtags) {
                                return "";
                            }

                            var tagStatus = tag.split(":")[1];
                            var tagValue = tag.split(":")[0];

                            if (tagValue == "") {
                                return '';
                            }

                            if (self.props.showincludedtags && tag.includes("notincluded")) {
                                return "";
                            }

                            if (tagStatus == 'active') {
                                return React.createElement(
                                    'span',
                                    { className: 'rounded-pill' },
                                    tagValue
                                );
                            }

                            return React.createElement(
                                'span',
                                { className: 'rounded-pill-gray' },
                                tagValue
                            );
                        });
                    }

                    var _description = lineItem.Description.split(":[tags]:")[0];

                    lineItemPartial = React.createElement(
                        'tr',
                        { key: lineItem.Id },
                        React.createElement(
                            'td',
                            { colSpan: '5' },
                            _description,
                            tagsEl
                        )
                    );

                    return lineItemPartial;
                }

                if (hasTags) {
                    var description = lineItem.Description.split("tags:")[1];

                    var _descriptionValuePlaceholder = "";

                    if (description.indexOf(',') !== -1) {
                        var tags = description.split(',').map(function (tag) {

                            if (!self.props.showtags) {
                                return "";
                            }

                            var tagStatus = tag.split(":")[1];
                            var tagValue = tag.split(":")[0];

                            if (self.props.showincludedtags && tag.includes("notincluded")) {
                                return "";
                            }

                            if (tagStatus == 'active') {
                                return React.createElement(
                                    'span',
                                    { className: 'rounded-pill' },
                                    tagValue
                                );
                            }

                            return React.createElement(
                                'span',
                                { className: 'rounded-pill-gray' },
                                tagValue
                            );
                        });

                        _descriptionValuePlaceholder = React.createElement(
                            'strong',
                            null,
                            tags
                        );
                    } else {
                        if (self.props.showtags && description != '') {
                            var tagStatus = description.split(":")[1];
                            var tagValue = description.split(":")[0];

                            var included = tagStatus.split(":")[1];

                            if (included == "included") {
                                _descriptionValuePlaceholder = "";
                            }

                            _descriptionValuePlaceholder = React.createElement(
                                'strong',
                                null,
                                React.createElement(
                                    'span',
                                    { className: 'rounded-pill-gray' },
                                    tagValue
                                )
                            );

                            if (tagStatus == 'active') {
                                _descriptionValuePlaceholder = React.createElement(
                                    'strong',
                                    null,
                                    React.createElement(
                                        'span',
                                        { className: 'rounded-pill' },
                                        tagValue
                                    )
                                );
                            }
                        }
                    }

                    if (self.props.showtags) {
                        lineItemPartial = React.createElement(
                            'tr',
                            { key: lineItem.Id },
                            React.createElement(
                                'td',
                                { colSpan: '5' },
                                _descriptionValuePlaceholder
                            )
                        );
                    }

                    return lineItemPartial;
                }

                var amount = parseFloat(lineItem.UnitPriceExcludingTax) * parseFloat(lineItem.Quantity);
                var amt = self.moneyFormat(amount.toFixed(3), 2);
                var unitPriceExcludingTax = self.moneyFormat(parseFloat(lineItem.UnitPriceExcludingTax), 2);

                lineItemPartial = React.createElement(
                    'tr',
                    { key: lineItem.Id },
                    React.createElement(
                        'td',
                        null,
                        lineItem.Description
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        lineItem.Quantity
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        '$',
                        unitPriceExcludingTax
                    ),
                    React.createElement(
                        'td',
                        { className: 'text-right' },
                        '$',
                        amt
                    )
                );

                return lineItemPartial;
            };

            var createTaxRow = function createTaxRow(taxes, totalTax) {
                if (taxes && taxes.length > 1) {
                    React.createElement(
                        'tr',
                        { className: 'tax' },
                        React.createElement(
                            'td',
                            null,
                            'TOTAL TAX'
                        ),
                        React.createElement(
                            'td',
                            null,
                            '$',
                            totalTax
                        )
                    );
                }

                return taxes.map(function (x) {
                    return React.createElement(
                        'tr',
                        null,
                        React.createElement(
                            'td',
                            { style: { fontSize: '14px', paddingLeft: '1rem' } },
                            x.Name,
                            ' (',
                            x.Rate,
                            '%)'
                        ),
                        React.createElement(
                            'td',
                            { style: { fontSize: '14px' } },
                            '$',
                            x.TotalTaxApplied
                        )
                    );
                });
            };

            function getStatus(id) {
                switch (id) {
                    case 1:
                        return 'Preview';
                    case 2:
                        return 'Finalized';
                }
            }

            /**
             * Creation Invoice Item
             */
            var createInvoiceItem = function createInvoiceItem(invoice) {
                var uid = _.uniqueId('invoice');
                var ticketDetailsUid = _.uniqueId('invoiceDetails');
                var totalTax = self.moneyFormat(parseFloat(invoice.TotalTax), 2);
                var subTotal = self.moneyFormat(parseFloat(invoice.TotalExcludingTax), 2);
                var grandTotal = self.moneyFormat(parseFloat(invoice.TotalIncludingTax), 2);
                var taxes = invoice.InvoiceTaxes == null ? [] : invoice.InvoiceTaxes.map(function (x) {
                    return {
                        Name: x.Name,
                        Rate: x.Rate,
                        TotalTaxApplied: self.moneyFormat(parseFloat(x.TotalTaxApplied), 2)
                    };
                });

                // Surcharges land as InvoiceSurchargeLineItem snapshots written by the calculator.
                // The renderer reads from the snapshot, never the live surcharge entity, so
                // historical invoices stay stable across surcharge edits or deletes. Each snapshot
                // is rendered twice: once as a row in the main line-items table (Qty / Unit Price /
                // Amount), and once in the summary block between SUBTOTAL and TAXABLE AMOUNT.
                // Subtotal stays = Sum(LineItems) byte-identical to a pre-feature invoice; the
                // surcharges contribute only to TaxableAmount.
                var surchargeLines = (invoice.SurchargeLineItems || []).map(function (s, i) {
                    return {
                        SurchargeId: s.SurchargeId,
                        // Vehicle surcharges emit one line per vehicle, all sharing the surcharge's
                        // id; pair it with the vehicle type and index so sibling rows get distinct
                        // React keys (a bare SurchargeId collides and drops all but the first).
                        Key: s.SurchargeId + '-' + (s.VehicleTypeItemId || '') + '-' + i,
                        Description: s.Description,
                        Amount: self.moneyFormat(parseFloat(s.Amount), 2)
                    };
                });
                var hasSurcharges = surchargeLines.length > 0;

                // Surcharge rows render BEFORE the "Authorised By" entries so the signature block
                // stays at the bottom of the line-items table. Split the line items at the first
                // Authorised By so the surcharges can be injected between.
                var rawLineItems = invoice.LineItems || [];
                var authorisedByIndex = rawLineItems.findIndex(function (li) {
                    return li && li.Description && li.Description.indexOf('Authorised By') !== -1;
                });
                var lineItemsBeforeAuth = authorisedByIndex >= 0 ? rawLineItems.slice(0, authorisedByIndex) : rawLineItems;
                var lineItemsFromAuth = authorisedByIndex >= 0 ? rawLineItems.slice(authorisedByIndex) : [];
                // TaxableAmount = subtotal + sum(surcharges). The renderer trusts the backend-emitted
                // value when present and falls back to subtotal alone otherwise, so pre-feature
                // invoices render byte-identically (no insertion of a TAXABLE AMOUNT row when there
                // are no surcharges).
                var taxableAmount = invoice.TaxableAmount != null ? self.moneyFormat(parseFloat(invoice.TaxableAmount), 2) : subTotal;

                var invoiceProjectPartial = void 0;
                var ticketDetailsPartial = void 0;
                var invoiceSpinnerPartial = void 0;
                var purchaseOrderNumberPartial = void 0;

                // -------------------------
                // Invoice Footer Partial
                // -------------------------
                var invDetailFooterPartial = React.createElement(
                    'table',
                    { className: 'simple invoice-table-footer', style: tableStyle },
                    React.createElement(
                        'tbody',
                        null,
                        React.createElement(
                            'tr',
                            { className: 'subtotal' },
                            React.createElement(
                                'td',
                                null,
                                'SUBTOTAL'
                            ),
                            React.createElement(
                                'td',
                                null,
                                '$',
                                subTotal
                            )
                        ),
                        surchargeLines.map(function (s) {
                            return React.createElement(
                                'tr',
                                { key: s.Key, className: 'surcharge' },
                                React.createElement(
                                    'td',
                                    null,
                                    s.Description
                                ),
                                React.createElement(
                                    'td',
                                    null,
                                    '$',
                                    s.Amount
                                )
                            );
                        }),
                        hasSurcharges && React.createElement(
                            'tr',
                            { className: 'taxable-amount' },
                            React.createElement(
                                'td',
                                null,
                                'TAXABLE AMOUNT'
                            ),
                            React.createElement(
                                'td',
                                null,
                                '$',
                                taxableAmount
                            )
                        ),
                        createTaxRow(taxes, totalTax),
                        React.createElement(
                            'tr',
                            { className: 'total' },
                            React.createElement(
                                'td',
                                null,
                                'TOTAL'
                            ),
                            React.createElement(
                                'td',
                                null,
                                '$',
                                grandTotal
                            )
                        )
                    )
                );

                // -------------------------
                //  Ticket details partial
                // -------------------------
                if (self.props.showdetails) {
                    var resourceResults = invoice.ResourceInformation;
                    ticketDetailsPartial = React.createElement(InvoiceTicketDetails, { key: ticketDetailsUid, ticketlist: resourceResults });
                }

                // Project field
                if (invoice.Project != null) {
                    if (invoice.Project.length > 0) {
                        invoiceProjectPartial = React.createElement(
                            'span',
                            null,
                            '- ',
                            invoice.Project
                        );
                    }
                }

                // Invoice progress spinner
                if (invoice.IsBusy) {
                    invoiceSpinnerPartial = React.createElement(
                        'div',
                        { className: 'react-linear-activity' },
                        React.createElement('div', { className: 'react-indeterminate' })
                    );
                } else {
                    invoiceSpinnerPartial = null;
                }

                var invoiceDate = self.jsDateTime(invoice.InvoiceDate);
                var status = getStatus(invoice.InvoiceStatus);

                var downloadInvoiceIconClass = 'icon-download s18 padding-bottom-0 margin-bottom-0 ' + (invoice.GeneratedInvoicePdfExists ? 'grey-600-fg' : 'grey-400-fg');
                var downloadInvoiceAndPaperworkIconClass = 'icon-file-document-box s18 padding-bottom-0 margin-bottom-0 ' + (invoice.GeneratedInvoicePdfExists ? 'grey-600-fg' : 'grey-400-fg');

                if (invoice.PurchaseOrderNumber != null) {
                    purchaseOrderNumberPartial = React.createElement(
                        'span',
                        { className: 'margin-left-5' },
                        '\u2022 PO# ',
                        invoice.PurchaseOrderNumber
                    );
                }

                return React.createElement(
                    'div',
                    { className: 'padding-10' },
                    invoiceSpinnerPartial,
                    React.createElement(
                        'div',
                        { key: uid, style: { borderRadius: '6px', border: '1px solid #e6e6e6' }, className: 'margin-0 padding-15 invoice-detail', onDoubleClick: self.editInvoice.bind(this, invoice.Id) },
                        React.createElement(
                            'div',
                            { className: 'layout-column mb-20' },
                            React.createElement(
                                'div',
                                { className: 'layout-row flex' },
                                React.createElement(
                                    'div',
                                    { className: 'flex layout-column layout-align-start-start' },
                                    React.createElement(
                                        'div',
                                        { className: 'md-title mb-5' },
                                        invoice.CompanyName,
                                        ' ',
                                        invoiceProjectPartial
                                    ),
                                    React.createElement(
                                        'div',
                                        null,
                                        invoice.BranchName
                                    ),
                                    React.createElement(
                                        'span',
                                        { className: 'md-subhead mt-5 mb-5' },
                                        'INV# ',
                                        invoice.InvoiceNumber
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'mt-5 mb-5' },
                                        React.createElement(
                                            'span',
                                            null,
                                            invoiceDate
                                        ),
                                        React.createElement(
                                            'span',
                                            { className: 'margin-left-5' },
                                            '\u2022 Term: ',
                                            invoice.TermDays
                                        ),
                                        purchaseOrderNumberPartial
                                    )
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'flex-20 layout-column layout-align-center-end' },
                                    React.createElement(
                                        'div',
                                        { className: 'flex' },
                                        React.createElement(
                                            'span',
                                            { className: 'status md-grey-500-bg', style: statusStyle },
                                            status
                                        )
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'flex layout-row layout-align-start-center' },
                                        React.createElement(
                                            'span',
                                            { className: 'margin-left-15 md-ink-ripple custom-tooltip' },
                                            React.createElement('i', { className: 'icon-pencil s18 padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.editInvoice.bind(this, invoice.Id) }),
                                            React.createElement(
                                                'span',
                                                { className: 'custom-tooltiptext' },
                                                'Edit invoice'
                                            )
                                        ),
                                        React.createElement(
                                            'span',
                                            { className: 'margin-left-15 md-ink-ripple custom-tooltip' },
                                            React.createElement('i', { className: downloadInvoiceIconClass, onClick: invoice.GeneratedInvoicePdfExists ? self.downloadInvoice.bind(this, invoice.Id, false) : false }),
                                            React.createElement(
                                                'span',
                                                { className: 'custom-tooltiptext' },
                                                'Download invoice'
                                            )
                                        ),
                                        React.createElement(
                                            'span',
                                            { className: 'margin-left-15 md-ink-ripple custom-tooltip' },
                                            React.createElement('i', { className: downloadInvoiceAndPaperworkIconClass, onClick: invoice.GeneratedInvoicePdfExists ? self.downloadInvoice.bind(this, invoice.Id, true) : false }),
                                            React.createElement(
                                                'span',
                                                { className: 'custom-tooltiptext' },
                                                'Download invoice and paperwork'
                                            )
                                        ),
                                        React.createElement(
                                            'span',
                                            { className: 'margin-left-15 md-ink-ripple custom-tooltip' },
                                            React.createElement('i', { className: 'icon-trash s18 padding-bottom-0 margin-bottom-0 red-600-fg', onClick: self.deleteInvoice.bind(this, invoice.Id) }),
                                            React.createElement(
                                                'span',
                                                { className: 'custom-tooltiptext' },
                                                'Delete invoice'
                                            )
                                        )
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'flex layout-row layout-align-end-center' },
                                        React.createElement('input', { type: 'checkbox', className: 'm-5', onChange: self.markAsReviewed.bind(this, invoice.Id), checked: invoice.IsReviewed, disabled: !invoice.GeneratedInvoicePdfExists }),
                                        React.createElement(
                                            'label',
                                            { style: { paddingTop: '2px' } },
                                            'Mark as reviewed'
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement('md-divider', null),
                        React.createElement(
                            'div',
                            { className: 'layout-column' },
                            React.createElement(
                                'div',
                                { className: 'layout-row flex' },
                                React.createElement(
                                    'div',
                                    { className: 'flex' },
                                    React.createElement(
                                        'table',
                                        { className: 'simple invoice-table', style: tableStyle },
                                        React.createElement(
                                            'thead',
                                            null,
                                            React.createElement(
                                                'tr',
                                                null,
                                                React.createElement(
                                                    'th',
                                                    null,
                                                    'Description'
                                                ),
                                                React.createElement(
                                                    'th',
                                                    { className: 'text-right qty-col' },
                                                    'Qty'
                                                ),
                                                React.createElement(
                                                    'th',
                                                    { className: 'text-right unit-price-col' },
                                                    'Unit Price'
                                                ),
                                                React.createElement(
                                                    'th',
                                                    { className: 'text-right amt-col' },
                                                    'Amount'
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'tbody',
                                            null,
                                            lineItemsBeforeAuth.map(createInvoiceBody),
                                            surchargeLines.map(function (s) {
                                                return React.createElement(
                                                    'tr',
                                                    { key: 'surcharge-line-' + s.Key, className: 'surcharge-line-item' },
                                                    React.createElement(
                                                        'td',
                                                        null,
                                                        s.Description
                                                    ),
                                                    React.createElement(
                                                        'td',
                                                        { className: 'text-right' },
                                                        '1'
                                                    ),
                                                    React.createElement(
                                                        'td',
                                                        { className: 'text-right' },
                                                        '$',
                                                        s.Amount
                                                    ),
                                                    React.createElement(
                                                        'td',
                                                        { className: 'text-right' },
                                                        '$',
                                                        s.Amount
                                                    )
                                                );
                                            }),
                                            hasSurcharges && lineItemsFromAuth.length > 0 && React.createElement(
                                                'tr',
                                                { className: 'surcharge-auth-separator' },
                                                React.createElement(
                                                    'td',
                                                    { colSpan: '4' },
                                                    '\xA0'
                                                )
                                            ),
                                            lineItemsFromAuth.map(createInvoiceBody)
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'layout-column' },
                            React.createElement(
                                'div',
                                { className: 'layout-row flex' },
                                React.createElement(
                                    'div',
                                    { className: 'flex' },
                                    invDetailFooterPartial
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            null,
                            ticketDetailsPartial
                        )
                    )
                );
            };

            return React.createElement(
                'div',
                null,
                this.props.invoicelist.map(createInvoiceItem)
            );
        }
    }]);

    return InvoiceContent;
}(React.Component);

InvoiceContent.propTypes = {
    invoicelist: React.PropTypes.array.isRequired,
    oneditinvoice: React.PropTypes.func.isRequired,
    ondownloadinvoice: React.PropTypes.func.isRequired,
    oneditticket: React.PropTypes.func.isRequired,
    onedittimesheet: React.PropTypes.func.isRequired,
    onmarkasreviewed: React.PropTypes.func.isRequired,
    ondeleteinvoice: React.PropTypes.func.isRequired,
    dateformat: React.PropTypes.string.isRequired,
    showdetails: React.PropTypes.bool.isRequired,
    showtags: React.PropTypes.bool.isRequired,
    showincludedtags: React.PropTypes.bool.isRequired
};
InvoiceContent.defaultProps = {
    invoicelist: [],
    oneditinvoice: function oneditinvoice() {},
    ondownloadinvoice: function ondownloadinvoice() {},
    ondeleteinvoice: function ondeleteinvoice() {},
    oneditticket: function oneditticket() {},
    onedittimesheet: function onedittimesheet() {},
    onmarkasreviewed: function onmarkasreviewed() {},
    showdetails: false,
    dateformat: 'YYYY/MM/DD',
    showtags: false,
    showincludedtags: false
};


angular.module('app.invoice.reports').value('InvoiceContent', InvoiceContent);
/**
 * Host directive for React component
 * 10.19.2016 rcnet
 */
(function () {
    'use strict';

    angular.module('app.invoice.reports')
        .directive('invReportContentComponent', invReportContentComponent);

     /** @ngInject */
    function invReportContentComponent(reactDirective, InvoiceContent) {
        return reactDirective(InvoiceContent);
    }

})();
(function() {
    'use strict';

    angular.module('app.invoice')
        .directive('invoiceContentViewComponent', invoiceContentViewComponent);

    /** @ngInject */
    function invoiceContentViewComponent(
        $mdDialog,
        exceptionService,
        reportManagerService,
        invoiceFinaliseService,
        $mdToast,
        blockUI
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/reports/directives/invoiceContent/invoice-content-view.html',
            scope: true,
            controller: InvoiceContentViewController,
            controllerAs: 'invContentVm',
            bindToController: true
        };

        return directive;

        function InvoiceContentViewController() {
            var vm = this;

            // Data
            vm.model = reportManagerService;
            vm.viewMode = 'all';

            // Methods
            vm.finalise = finalise;
            vm.filterByReviewed = filterByReviewed;
            vm.showAll = showAll;
            vm.notReviewed = notReviewed;
            vm.showTags = showTags;

            activate();

            ///////
            function activate() {
                reportManagerService.setClientSideFilter(vm.viewMode);
            }

            function finalise() {
                let pluralize = reportManagerService.grid.data.length > 1;
                let invWord = pluralize ? 'invoices' : 'invoice';

                let confirm = $mdDialog.confirm()
                    .title('Confirm finalisation of invoices')
                    .textContent('Finalise ' + invWord + '?')
                    .ariaLabel('Finalise invoice')
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function() {
                    blockUI.start('Finalising ' + invWord + '...');
                    invoiceFinaliseService.finalise(reportManagerService.grid.data)
                        .then(finaliseSuccess)
                        .catch(finaliseError)

                }, function() {
                    // cancel
                });
            }

            function finaliseSuccess(resp) {
                blockUI.stop();
                reportManagerService.clearPreview();

                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Finalise successfully completed.')
                    .position('bottom right')
                    .hideDelay(4000)
                );
            }

            function finaliseError(ex) {
                blockUI.stop();
                exceptionService.resolve(ex);
            }

            function filterByReviewed() {
                vm.viewMode = 'byReviewed';
                reportManagerService.setClientSideFilter(vm.viewMode);
            }
            function showAll() {
                vm.viewMode = 'all';
                reportManagerService.setClientSideFilter(vm.viewMode);
            }

            function notReviewed() {
                vm.viewMode = 'notReviewed';
                reportManagerService.setClientSideFilter(vm.viewMode);
            }

            function showTags() {
                reportManagerService.showTags = reportSideNavService.data.showTags;
            }

        }
    }
})();

/**
* Grid Information Component
*/
(function () {
    'use strict';

    angular.module('app.invoice.reports')
        .directive('customGridInfoComponent', customGridInfoComponent);

    /** @ngInject */
    function customGridInfoComponent() {
        var directive = {
            restrict: 'E',
            scope: {
               srcData: '='
            },
            templateUrl: 'app/main/invoice/reports/directives/customGridInfo/custom-grid-info.html',
            controller: CustomGridInfoController,
            controllerAs: 'customGridInfoVm',
            bindToController: true
        };

        return directive;

        function CustomGridInfoController() {
            var vm = this;
        }

    }
})();
/**
 * Created date: 12.19.2016
 * Rcnet
 */
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .controller('InvoiceLineItemDialogController', InvoiceLineItemDialogController);

    /** @ngInject */
    function InvoiceLineItemDialogController(locals, $mdDialog) {

        var vm = this;

        // Data
        vm.desc = locals.desc;

        // Events
        vm.onCancel = onCancel;
        //vm.onYes = onYes;

        activate();

        ///////
        function activate() {}

        function onCancel() {
            $mdDialog.cancel();
        }

        // function onYes() {
        //     $mdDialog.hide();
        // }

    }
})();
/**
 * Created date: 12.19.2016
 * Rcnet
 */
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .controller('InvoiceConfirmDialogController', InvoiceConfirmDialogController);

    /** @ngInject */
    function InvoiceConfirmDialogController(locals, $mdDialog) {

        var vm = this;

        // Data
        vm.desc = locals.desc;

        // Events
        vm.onCancel = onCancel;
        vm.onYes = onYes;

        activate();

        ///////
        function activate() {}

        function onCancel() {
            $mdDialog.cancel();
        }

        function onYes() {
            $mdDialog.hide();
        }

    }
})();
/**
 * Created date: 12.19.2016
 * Rcnet
 */
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .controller('EditInvoiceLineDialogController', EditInvoiceLineDialogController);

    /** @ngInject */
    function EditInvoiceLineDialogController($mdDialog,
        editInvoiceReportService,
        claimsUtilService,
        utils) {

        var vm = this;

        // Data
        vm.showLineItemValError = false;
        vm.model = editInvoiceReportService;
        vm.linkObj = {};
        vm.model.disableSave = false;

        // Events
        vm.onCancel = onCancel;
        vm.onSave = onSave;

        activate();

        ///////
        function activate() {}

        function onCancel() {
            $mdDialog.cancel();
            vm.model.onToggleEdit(false);
        }

        function onSave() {
            var lineItems = window.getLineItemDataInReact();
            vm.model.disableSave = true;

            if (lineItems.length > 0) {
                let isAltusSpecialEnabled = claimsUtilService.isAltusSpecialEnabled();

                if (isAltusSpecialEnabled) {
                    $mdDialog.hide(lineItems);
                    return;
                }

                let dialogMessage = utils.translate('INVOICE_REPORT.INVOICE_HAS_MISSING_GL_CODES_MESSAGE');
                let dialogTitle = utils.translate('INVOICE_REPORT.MISSING_GL_CODE_DIALOG_TITLE');

                var lineItemsWithMissingGLCodes = lineItems.filter(lineItem => (!lineItem.TicketNumber || lineItem.TicketNumber > 0)
                    && (!lineItem.CostCode || lineItem.CostCode.Length == 0)
                    && !lineItem.IsHistorical
                    && lineItem.Quantity > 0);
                    
                if (!lineItemsWithMissingGLCodes.length) {
                    $mdDialog.hide(lineItems);
                    return;
                }

                var confirm = $mdDialog.confirm()
                    .title(dialogTitle)
                    .textContent(dialogMessage)
                    .ariaLabel(dialogTitle)
                    .cancel('Cancel')
                    .ok('Okay')
                    .multiple(true);

                $mdDialog.show(confirm)
                    .then(function () {
                        $mdDialog.hide(lineItems);
                    });

            } else {
                vm.showLineItemValError = true;
            }
        }
    }
})();
/**
 * Created date: 12.19.2016
 * Rcnet
 */
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .controller('ConfirmDeleteCheckedItemsDialogController', ConfirmDeleteCheckedItemsDialogController);

    /** @ngInject */
    function ConfirmDeleteCheckedItemsDialogController(locals, $mdDialog) {

        var vm = this;

        // Data
        vm.desc = locals.desc;

        // Events
        vm.onCancel = onCancel;
        vm.onYes = onYes;

        activate();

        ///////
        function activate() {}

        function onCancel() {
            $mdDialog.cancel();
        }

        function onYes() {
            $mdDialog.hide();
        }

    }
})();
/**
 * Invoice Preview Configuration
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.forms.manualInvoice')
        .factory('manualInvoiceEntryFormService', manualInvoiceEntryFormService);

    /** @ngInject */
    function manualInvoiceEntryFormService($q,
        exceptionService,
        invoiceLookupService,
        manualInvoiceModel
    ) {

        var service = {
            data: new manualInvoiceModel(),
            loadLookups: loadLookups
        };

        activate();

        return service;
        //////

        function activate() {}

        /**
         * Load required lookups here
         */
        function loadLookups() {
            var promise1 = invoiceLookupService.loadClients();
            var promise2 = invoiceLookupService.loadBranches();

            return $q.all([promise1, promise2]);
        }
    }
})();
/**
 * Invoice Preview Configuration
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.forms.manualInvoice')
        .factory('lineItemManualInvoiceService', lineItemManualInvoiceService);

    /** @ngInject */
    function lineItemManualInvoiceService(exceptionService,
        lineItemSummaryModel,
        invoiceLineItemService
    ) {

        var service = {
            data: [],
            summary: new lineItemSummaryModel(),
            editInvoiceLineItem: editInvoiceLineItem,
            reset: reset
        };

        activate();

        return service;
        //////

        function activate() {
        }

        function reset() {
            service.data.length = 0;
        }

        function updateSummary(taxes, subTotal, totalTax, grandTotal) {
            service.summary.Taxes = taxes;
            service.summary.SubTotal = parseFloat(subTotal).toFixed(2);;
            service.summary.TotalTax = parseFloat(totalTax).toFixed(2);
            service.summary.GrandTotal = parseFloat(grandTotal).toFixed(2);
        }

        function editInvoiceLineItem(clientId, taxRoundingRule) {

            var src = service.data.length > 0 ? recreateModel(service.data) : null;

            invoiceLineItemService.showEditorForManualInvoice(src, clientId, taxRoundingRule)
                .then(function(resp) {
                    service.data = resp.lines;
                    updateSummary(resp.totalSummary.Taxes, resp.totalSummary.SubTotal, resp.totalSummary.TotalTax, resp.totalSummary.GrandTotal);
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function recreateModel(lines) {
            return {
                Id: null,
                InvoiceNumber: null,
                LineItems: lines
            };
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.forms.manualInvoice')
        .service('manualInvoiceModel', manualInvoiceModel)

    function manualInvoiceModel(utils) {
        return function() {
            var self = this,
                defaults = {
                    selectedClient: null,
                    invoiceDate: null,
                    purchaseOrderNumber: null,
                    invoiceTerms: null,
                    selectedBranch: null,
                    taxRoundingRule: null
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                return {
                    ClientId: self.selectedClient.Id,
                    InvoiceDate:  utils.jsDateTime(self.invoiceDate),
                    PurchaseOrderNumber: self.purchaseOrderNumber,
                    Terms: self.invoiceTerms.Name,
                    BranchId: self.selectedBranch,
                    BusinessId: self.selectedBusiness
                };
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.forms.manualInvoice')
        .service('lineItemSummaryModel', lineItemSummaryModel)

    function lineItemSummaryModel(utils) {
        return function() {
            var self = this,
                defaults = {
                    Taxes: [],
                    SubTotal: 0.00,
                    TotalTax: 0.00,
                    GrandTotal: 0.00
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // not yet implemented
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.forms.manualInvoice')
        .service('lineItemManualInvoiceModel', lineItemManualInvoiceModel)

    function lineItemManualInvoiceModel(utils) {
        return function() {
            var self = this,
                defaults = {
                    Description: null,
                    Quantity: 0.0,
                    UnitPriceExcludingTax: 0.00,
                    Amt: 0.00
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // not yet implemented
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.emailsender')
        .directive('emailSenderContentViewComponent', emailSenderContentViewComponent);

    /** @ngInject */
    function emailSenderContentViewComponent(
        $window,
        virtualRepeatFixService,
        emailSenderMainService,
        tenantsApi
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/emailSender/directives/emailSenderContent/email-sender-content-view.html',
            scope: {
                api: '=',
                onCheckToggle: '&',
                onDownloadInvoice: '&',
                onCheckPaymentClaim: '&',
                onSendMail: '&',
                onOpenIssue: '&',
                onCheckSingleItem: '&',
                onSelectViewType: '&'
            },
            controller: EmailSenderContentViewController,
            controllerAs: 'invContentVm',
            bindToController: true
        };

        return directive;

        function EmailSenderContentViewController($scope) {
            var vm = this;

            // Data
            vm.initialToggle = false;
            vm.isBusy = false;
            vm.message = 'Issue';
            vm.issues = null;
            vm.gridInfo = {
                totalItems: 0,
                rawTotalItemCount: 0,
                inProgress: false,
                isFiltered: false
            };
            vm.paymentClaimRequestType = {
                timesheetsOnly: 0,
                invoicesAndTimesheets: 1
            };
            vm.selectedItemsCount = 0;
            vm.viewType = -1;
            vm.viewTypeDesc = 'All';
            vm.isShowCreditNotes = true;
            vm.isPaymentClaimEnabled = false;

            // Event
            vm.checkToggle = checkToggle;
            vm.checkItem = checkItem;
            vm.downloadInvoicesAndPaperwork = downloadInvoicesAndPaperwork;
            vm.downloadInvoices = downloadInvoices;
            vm.downloadPaymentClaims = downloadPaymentClaims;
            vm.sendMail = sendMail;
            vm.openIssues = openIssues;
            vm.select = select;
            vm.onCreditNoteChange = onCreditNoteChange;
            vm.downloadPaperworkOnly = downloadPaperworkOnly;
            vm.checkPaymentClaim = checkPaymentClaim;

            activate();

            function activate() {
                if (vm.api) {
                    vm.api.refresh = refresh;
                    vm.api.setBusy = setBusy;
                    vm.api.setInvoiceIssue = setInvoiceIssue;
                    vm.api.populateGridInfo = populateGridInfo;
                    vm.api.setNumberOfCheckedItems = setNumberOfCheckedItems;
                    vm.api.reselectViewType = reselectViewType;
                    vm.api.clearIssues = clearIssues;
                }

                getGeneralSettings();
                listenForWindowResize();
                $scope.$on('$destroy', cleanUp);
            }

            function getGeneralSettings(){
                return tenantsApi.getGeneralSettings().then(function(resp) {
                    var data = resp.data;
                    vm.isPaymentClaimEnabled = data.EnablePaymentClaim == null? false : data.EnablePaymentClaim.toLowerCase() === 'true';
                });
            }

            function getContainerHeight() {
                var boardEl = angular.element('#invoice-dist-wrapper');
                return boardEl.height();
            }

            function listenForWindowResize() {
                angular.element($window).bind('resize', onResize);
            }

            function onResize() {
                var boardElHeight = getContainerHeight();
                adjustHeight(boardElHeight - 10);
            }

            function adjustHeight(h) {
                var container = angular.element('#vertical-container');
                container.css("height", h + 'px');
            }

            function cleanUp() {
                window.angular.element($window).off('resize', onResize);
            }

            function setBusy(flag) {
                vm.isBusy = flag;
            }

            function select(option) {
                clearIssues();
                vm.viewType = option;
                vm.viewTypeDesc = option == 1 ? 'Sent' : option == 2 ? 'Unsent' : option == 3 ? 'Failed' : option == 4 ? 'Skipped' : 'All';
                (vm.onSelectViewType || angular.noop)({
                    type: {
                        viewType: vm.viewType,
                        showCreditNotes: vm.isShowCreditNotes
                    }
                });
            }

            function reselectViewType() {
                select(vm.viewType);
                clearIssues();
            }

            function refresh() {
                vm.selectedItemsCount = 0;
                vm.initialToggle = false;
                clearIssues();
                virtualRepeatFixService.fixBlankSpace();
            }

            function populateGridInfo(data) {
                vm.gridInfo = data;
                var h = getContainerHeight();
                adjustHeight(h);
            }

            function checkToggle() {
                vm.initialToggle = !vm.initialToggle;
                (vm.onCheckToggle || angular.noop)({
                    toggleFlag: vm.initialToggle
                });
            }

            function checkItem(id) {
                var data = (vm.onCheckSingleItem || angular.noop)({
                    id: id
                });
                vm.selectedItemsCount = data.itemsChecked;
                vm.initialToggle = data.hasItemsChecked;
            }

            function checkPaymentClaim(){
                return !(vm.initialToggle && emailSenderMainService.clientSelectionStatus);
            }

            function setNumberOfCheckedItems(itemsChecked) {
                vm.selectedItemsCount = itemsChecked;
            }

            function downloadInvoicesAndPaperwork() {
                (vm.onDownloadInvoice || angular.noop)({
                    includePaperwork: true,
                    isPaperworkOnly: false
                });
            }

            function downloadInvoices() {
                (vm.onDownloadInvoice || angular.noop)();
            }

            function downloadPaperworkOnly() {
                (vm.onDownloadInvoice || angular.noop)({
                    includePaperwork: false,
                    isPaperworkOnly: true
                });
            }

            function downloadPaymentClaims(requestType){
                (vm.onDownloadInvoice || angular.noop)({
                    includePaperwork: false,
                    isPaperworkOnly: false,
                    isPaymentClaim: true,
                    paymentClaimRequestType: requestType
                });
            }

            function sendMail() {
                (vm.onSendMail || angular.noop)();
            }

            function setInvoiceIssue(issues) {
                vm.issues = issues;
                vm.message = issues.length > 1 ? 'Issues' : 'Issue';
            }

            function openIssues() {
                (vm.onOpenIssue || angular.noop)({
                    issues: vm.issues
                });
            }

            function clearIssues() {
                if (vm.issues)
                    vm.issues.length = 0;
            }

            function onCreditNoteChange(state) {
                select(vm.viewType);
            }
        }
    }
})();

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailInvoiceThreadList = function (_React$Component) {
    _inherits(EmailInvoiceThreadList, _React$Component);

    function EmailInvoiceThreadList(props) {
        _classCallCheck(this, EmailInvoiceThreadList);

        var _this = _possibleConstructorReturn(this, (EmailInvoiceThreadList.__proto__ || Object.getPrototypeOf(EmailInvoiceThreadList)).call(this, props));

        _this.changeCheckSelection = _this.changeCheckSelection.bind(_this);
        return _this;
    }

    _createClass(EmailInvoiceThreadList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var self = this;
            window.setSpinner = function (invoices, flag) {
                self.setSpinner(invoices, flag);
            };
        }
    }, {
        key: 'getProcessStatus',
        value: function getProcessStatus(status) {
            switch (status) {
                case 'queueing':
                    return 'QUEUEING';
                case 'queued':
                    return 'QUEUED';
                case 'sent':
                    return 'SENT';
                case 'bounce':
                    return 'BOUNCE';
                case 'error':
                    return 'ERROR';
                default:
                    return 'UNKNOWN';
            }
        }
    }, {
        key: 'getOverallStatus',
        value: function getOverallStatus(status) {
            switch (status) {
                case 1:
                    return 'SENT';
                case 2:
                    return 'UNSENT';
                case 3:
                    return 'FAILED';
                default:
                    return 'UNKNOWN';
            }
        }
    }, {
        key: 'clearAll',
        value: function clearAll() {
            var invoiceListCloned = _.cloneDeep(this.state.invoicelist);
            invoiceListCloned.length = 0;
            this.setState({
                invoicelist: invoiceListCloned
            });
        }

        // Obsolete

    }, {
        key: 'setProcessStatus',
        value: function setProcessStatus(invoices, status) {
            var self = this;
            var invoiceListCloned = _.cloneDeep(this.state.invoicelist);

            invoices.forEach(function (id) {
                var item = _.find(invoiceListCloned, function (o) {
                    return o.Id === id;
                });

                item.ProcessStatus = self.getProcessStatus(status);
                item.IsProcessing = status == 'sent' ? false : true;
            });

            this.setState({
                invoicelist: invoiceListCloned
            });
        }

        // For testing only

    }, {
        key: 'setStatusSentToAllChecked',
        value: function setStatusSentToAllChecked() {
            var self = this;
            var items = self.getCheckedItems();
            var invoiceListCloned = _.cloneDeep(this.state.invoicelist);

            items.forEach(function (id) {
                var item = _.find(invoiceListCloned, function (o) {
                    return o.Id === id;
                });

                item.ProcessStatus = ''; //self.getProcessStatus('sent');
                item.IsProcessing = false;
            });

            this.setState({
                invoicelist: invoiceListCloned
            });
        }
    }, {
        key: 'changeCheckSelection',
        value: function changeCheckSelection(id) {
            this.props.oncheckitem(id);
        }
    }, {
        key: 'moneyFormat',
        value: function moneyFormat(number, decimalPlaces) {
            var parsedNumber = number;
            var isNegative = number < 0;

            var decimalPadding = function decimalPadding() {
                var tNum = ".";
                if (decimalPlaces > 0) {
                    for (var i = 0; i < decimalPlaces; i++) {
                        tNum += "0";
                    }
                } else {
                    tNum += "00";
                }
                return tNum;
            };

            if (!number || isNaN(number)) return "0" + decimalPadding();

            if (decimalPlaces > 0) {
                parsedNumber = number.toFixed(decimalPlaces);
            }

            var arr = parsedNumber.toString().split('.');

            var result = arr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            result += arr.length > 1 ? "." + arr[1] : decimalPadding();

            // if (isNegative) {
            //     result = "(" + result.replace("-", "") + ")";
            // }

            return result;
        }
    }, {
        key: 'jsDateTime',
        value: function jsDateTime(date) {
            if (date == '' || date == undefined || date == null || moment(date).format('DD MMM YYYY').toUpperCase() == '01 JAN 1900') {
                return "";
            }
            return moment(date).format(this.props.dateformat).toUpperCase();
        }
    }, {
        key: 'getRandomColor',
        value: function getRandomColor() {
            var colors = ['av-red', 'av-cyan', 'av-green', 'av-orange', 'av-blue'];
            var color = colors[Math.floor(Math.random() * colors.length)];
            return color;
        }
    }, {
        key: 'getRandomClient',
        value: function getRandomClient() {
            var names = ['Energex', 'Microsoft', 'Google', 'Apple Mac', 'RcnetLabs'];
            var name = names[Math.floor(Math.random() * names.length)];
            return name;
        }
    }, {
        key: 'getEmailRecipientPartial',
        value: function getEmailRecipientPartial(recipients) {
            var MAX_RECIPIENTS_TO_SHOW = 4;
            var emailRecipientsArr = [];
            recipients.forEach(function (itm) {
                emailRecipientsArr.push(itm.Email);
            });
            var emailRecipients = recipients.length > MAX_RECIPIENTS_TO_SHOW ? _.slice(emailRecipientsArr, 0, MAX_RECIPIENTS_TO_SHOW).join('; ') : emailRecipientsArr.join('; ');
            var emailRecipientPartial = void 0;
            if (recipients.length > MAX_RECIPIENTS_TO_SHOW) {
                emailRecipientPartial = React.createElement(
                    'span',
                    null,
                    emailRecipients,
                    '...'
                );
            } else if (recipients.length != 0) {
                emailRecipientPartial = React.createElement(
                    'span',
                    null,
                    emailRecipients
                );
            } else {
                emailRecipientPartial = React.createElement(
                    'span',
                    null,
                    '- No recipients -'
                );
            }
            return emailRecipientPartial;
        }

        /**
         * 
         * @param {*}  
         *  Unsent = 0,
            Queued = 1,
            Sent = 2,
            Bounce = 3,
            Error = 4} items 
         */

    }, {
        key: 'getInvoiceItemStatus',
        value: function getInvoiceItemStatus(items) {
            // var flag = true;
            // items.forEach(function (itm) {
            //     if (itm.Status == 0) 
            // });
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;

            /**
             * Creation Invoice Item
             */
            var createInvoiceItem = function createInvoiceItem(invoice) {
                var uid = _.uniqueId('invEmail');

                var avatarCaption = React.createElement(
                    'div',
                    { className: 'margin-bottom-8' },
                    React.createElement(
                        'span',
                        { className: 'item-title' },
                        invoice.CompanyName
                    )
                );

                // Formatting
                var total = self.moneyFormat(parseFloat(invoice.TotalIncludingTax), 2);

                // Check if Greater than 4 email recipients
                var emailRecipientPartial = self.getEmailRecipientPartial(invoice.EmailRecipients);

                // Spinner 
                var spinnerPartial = void 0;
                if (invoice.IsProcessing) {
                    spinnerPartial = React.createElement(
                        'div',
                        { className: 'react-linear-activity' },
                        React.createElement('div', { className: 'react-indeterminate' })
                    );
                } else {
                    spinnerPartial = React.createElement(
                        'div',
                        { className: 'text-center' },
                        React.createElement(
                            'a',
                            { href: '#', onClick: self.props.onaddrecipient.bind(this, invoice.Id, invoice.CompanyName, invoice.EmailRecipients, invoice.CompanyId), title: 'Add Recipients' },
                            React.createElement('i', { className: 'icon-account-plus s16 grey-500-fg margin-left-5 margin-top-5' })
                        ),
                        React.createElement(
                            'a',
                            { href: '#', onClick: self.props.ongetrecipientlogs.bind(this, invoice.Id, invoice.InvoiceNumber, invoice.EmailRecipients), title: 'Log Entries' },
                            React.createElement('i', { className: 'icon-message-text-outline s16 grey-500-fg margin-left-5 margin-top-5' })
                        )
                    );
                }

                // Get Overall Status
                var overallStatus = self.getOverallStatus(invoice.EmailDeliveryStatus);
                var statusPartial = void 0;

                if (overallStatus == 'SENT') {
                    statusPartial = React.createElement(
                        'span',
                        { className: 'label sent' },
                        overallStatus
                    );
                } else if (overallStatus == 'UNSENT') {
                    statusPartial = React.createElement(
                        'span',
                        { className: 'label unsent' },
                        overallStatus
                    );
                } else if (overallStatus == 'FAILED') {
                    statusPartial = React.createElement(
                        'span',
                        { className: 'label failed' },
                        overallStatus
                    );
                }

                return React.createElement(
                    'div',
                    { className: 'main-row-item unsent-item' },
                    React.createElement(
                        'div',
                        { className: 'layout-row item' },
                        React.createElement(
                            'div',
                            { className: 'layout-row flex-5 layout-align-start-center' },
                            React.createElement(
                                'div',
                                { className: 'check-itm' },
                                React.createElement(
                                    'div',
                                    { className: 'flex' },
                                    React.createElement('input', { type: 'checkbox', className: 'react-checkbox', checked: invoice.Selected, 'ng-checked': self.changeCheckSelection.bind(this, invoice.Id) })
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'layout-row flex-60 item-body' },
                            React.createElement(
                                'div',
                                null,
                                avatarCaption,
                                React.createElement(
                                    'h5',
                                    { className: 'margin-0 padding-0' },
                                    invoice.BranchName
                                ),
                                React.createElement(
                                    'h6',
                                    { className: 'margin-0 padding-0 grey-600-fg' },
                                    'Recipients: ',
                                    emailRecipientPartial
                                ),
                                React.createElement(
                                    'h5',
                                    { className: 'margin-top-8 padding-top-2' },
                                    'Total $',
                                    total
                                ),
                                React.createElement(
                                    'h4',
                                    null,
                                    invoice.Selected
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'layout-row flex-25 layout-align-end-start item-body' },
                            React.createElement(
                                'div',
                                { className: 'text-right' },
                                React.createElement(
                                    'span',
                                    null,
                                    'Invoice No# ',
                                    invoice.InvoiceNumber
                                ),
                                React.createElement('br', null),
                                React.createElement(
                                    'span',
                                    null,
                                    'PO# ',
                                    invoice.PurchaseOrderNumber
                                ),
                                React.createElement('br', null),
                                React.createElement(
                                    'span',
                                    null,
                                    'Company Code: ',
                                    invoice.CompanyCode
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'layout-row flex-10 layout-align-end-center' },
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    'div',
                                    { className: 'h6 text-center font-size-10' },
                                    invoice.ProcessStatus
                                ),
                                spinnerPartial,
                                React.createElement(
                                    'span',
                                    null,
                                    self.jsDateTime(invoice.InvoiceDate)
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'labels' },
                                    statusPartial
                                )
                            )
                        )
                    )
                );
            };

            return React.createElement(
                'div',
                { className: 'thread-list' },
                React.createElement(
                    'div',
                    { className: 'thread' },

                    //this.state.invoicelist.map(createInvoiceItem)
                    this.props.invoicelist.map(createInvoiceItem)
                )
            );
        }
    }]);

    return EmailInvoiceThreadList;
}(React.Component);

EmailInvoiceThreadList.propTypes = {
    invoicelist: React.PropTypes.array.isRequired,
    dateformat: React.PropTypes.string.isRequired,
    onaddrecipient: React.PropTypes.func.isRequired,
    oncheckitem: React.PropTypes.func.isRequired,
    ongetrecipientlogs: React.PropTypes.func.isRequired
};
EmailInvoiceThreadList.defaultProps = {
    invoicelist: [],
    onaddrecipient: function onaddrecipient() {},
    oncheckitem: function oncheckitem() {},
    ongetrecipientlogs: function ongetrecipientlogs() {},
    dateformat: 'DD MMM YYYY'
};


angular.module('app.invoice.emailsender').value('EmailInvoiceThreadList', EmailInvoiceThreadList);
/**
 * Host directive for React component
 * 06.29.2017 rcnet
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .directive('emailInvoiceItemHostComponent', emailInvoiceItemHostComponent);

     /** @ngInject */
    function emailInvoiceItemHostComponent(reactDirective, EmailInvoiceThreadList) {
        return reactDirective(EmailInvoiceThreadList);
    }

})();
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .directive('emailGridContentComponent', emailGridContentComponent);

    /** @ngInject */
    function emailGridContentComponent($mdDialog,
        exceptionService,
        $mdToast,
        blockUI,
        invoiceDistributionGridService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/invoice/emailSender/directives/emailGridContent/email-grid-content.html',
            scope: {
                checkItem: '&'
            },
            controller: EmailThreadListController,
            controllerAs: 'emailGridContentVm',
            bindToController: true
        };

        return directive;

        function EmailThreadListController() {
            var vm = this;

            // Data
            vm.model = invoiceDistributionGridService;

            // Events
            vm.addRecipient = addRecipient;
            vm.onCheckeditem = onCheckeditem;
            vm.onGetRecipientLogs = onGetRecipientLogs;
            vm.getEmailRecipients = getEmailRecipients;
            
            activate();

            ///////
            function activate () { }

            function getEmailRecipients(recipients) {
                const MAX_RECIPIENTS_TO_SHOW = 4;
                let emailRecipientsArr = [];
                
                recipients.forEach(function (itm) {
                    emailRecipientsArr.push(itm.Email);
                });
                let emailRecipients = recipients.length > MAX_RECIPIENTS_TO_SHOW ? _.slice(emailRecipientsArr, 0, MAX_RECIPIENTS_TO_SHOW).join('; ') : emailRecipientsArr.join('; ');

                return emailRecipients; 
            }
          
            function addRecipient(id, companyName, emailRecipients, companyId) {

                $mdDialog.show({
                    templateUrl: 'app/main/invoice/emailSender/dialogs/recipient/recipient.html',
                    controller: 'ManageRecipientDialogController',
                    controllerAs: 'vm',
                    locals: { id: id, name: companyName, recipients: emailRecipients, companyId: companyId },
                    multiple: true
                }).then(function (recipient) {
                    //blockUI.start('Processing Credit Invoice');

                }, function (resp) {
                    //deferred.reject();
                });
            }

            function onCheckeditem(id) {
                (vm.checkItem || angular.noop)({id: id});
            }

            function onGetRecipientLogs(id, invNumber, emailRecipients) {
                $mdDialog.show({
                    templateUrl: 'app/main/invoice/emailSender/dialogs/recipient-logs/recipient-log.html',
                    controller: 'RecipientLogsDialogController',
                    controllerAs: 'vm',
                    locals: { id: id, invoiceNumber: invNumber, recipients: emailRecipients },
                    multiple: true
                }).then(function (recipient) {
                    //blockUI.start('Processing Credit Invoice');

                }, function (resp) {
                    //deferred.reject();
                });
            }
        }
    }
})();
/**
* Email Grid Information Component
*/
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .directive('emailGridInfoComponent', emailGridInfoComponent);

    /** @ngInject */
    function emailGridInfoComponent() {
        var directive = {
            restrict: 'E',
            scope: {
               srcData: '='
            },
            templateUrl: 'app/main/invoice/emailSender/directives/customGridInfo/email-grid-info.html',
            controller: EmailGridInfoController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function EmailGridInfoController() {
            var vm = this;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.invoice.emailsender')
        .controller('RecipientLogsDialogController', RecipientLogsDialogController);

    function RecipientLogsDialogController($mdDialog,
        utils,
        $mdToast,
        locals,
        emailRecipientService,
        sendMailService,
        msgboxService,
        exceptionService,
        _) {

        var vm = this;
        // Data
        vm.id = locals.id;
        vm.recipients = locals.recipients;
        vm.invoiceNumber = locals.invoiceNumber;
        vm.showProgress = false;

        // Events
        vm.save = save;
        vm.onCancel = onCancel;
        vm.resend = resend;
        vm.getDescriptionForIsPrimary = getDescriptionForIsPrimary;
        vm.getEmailTypeDescription = getEmailTypeDescription;
        vm.getStatus = getStatus;
        vm.getStatusColor = getStatusColor;

        ///////
        function save() {
            $mdDialog.hide();
        }

        function onCancel() {
            $mdDialog.hide(null);
        }

        function getDescriptionForIsPrimary(value) {
            return value == true ? 'Yes' : 'No';
        }

        function getEmailTypeDescription(type) {
            if (!type)
                return '';
            return (_.find(vm.emailTypes, function (f) {
                return f.Id == type;
            })).Value;
        }

        // Todo: move this code to separate class
        function getStatus(status) {
            switch (status) {
                case 1: return 'UNSENT';
                case 2: return 'SENDING';
                case 4: return 'SENT';
                case 8: return 'BOUNCE';
                case 16: return 'ERROR';
                case 32: return 'READ'
                case 64: return 'UNKNOWN PROVIDER';
                default: return 'UNKNOWN';
            }
        }

        function getStatusColor(status) {
            switch (status) {
                case 1: return 'unsent';
                case 2: return 'queueing';
                case 4: return 'sent';
                case 8: return 'failed';
                case 16: return 'failed';
                case 32: return 'sent'
                // The server counts UnknownMailProvider as delivered - it ranks with Sent and Read in
                // ReturnOverallStatus - and puts the provider's reason in StatusText, shown alongside.
                case 64: return 'sent'
                // Without a default an unmapped status renders an unstyled label: white text on
                // white. Anything not recognised has not been confirmed as delivered.
                default: return 'unsent';
            }
        }

        function resend(recipient) {
            sendMailService.sendSingleMail(vm.id, recipient)
                .then(function (resp) {
                    // Update the UI
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.invoice.emailsender')
        .controller('ManageRecipientDialogController', ManageRecipientDialogController);

    function ManageRecipientDialogController($mdDialog,
        $q,
        utils,
        invoiceLookupService,
        $mdToast,
        locals,
        emailRecipientService,
        emailRecipientModel,
        msgboxService,
        exceptionService,
        _) {

        // Alloc8.Common.Shared.EmailType. None is the legacy value the server folds into Accounts.
        const EMAIL_TYPE_NONE = 0;
        const EMAIL_TYPE_ACCOUNTS = 3;

        var vm = this;
        // Data
        vm.recipients = locals.recipients;
        vm.emailTypes = invoiceLookupService.data.emailTypes;
        vm.companyName = locals.name;
        vm.showProgress = false;

        // Events
        vm.save = save;
        vm.onCancel = onCancel;
        vm.addRecipient = addRecipient;
        vm.onRemoveRecipient = onRemoveRecipient;
        vm.addCompanyRecipient = addCompanyRecipient;
        vm.getDescriptionForIsPrimary = getDescriptionForIsPrimary;
        vm.getEmailTypeDescription = getEmailTypeDescription;

        activate();

        ///////
        function activate() {
        }

        function save() {
            $mdDialog.hide(vm.creditInvoiceDate);
        }

        function onCancel() {
            $mdDialog.hide(null);
        }

        function addRecipient() {

            $mdDialog.show({
                templateUrl: 'app/main/invoice/emailSender/dialogs/recipient/recipient-entry.html',
                controller: 'RecipientEntryDialogController',
                controllerAs: 'vm',
                locals: { id: locals.id, recipients: locals.recipients, companyId: locals.companyId },
                multiple: true
            }).then(function (data) {
                //blockUI.start('Processing Credit Invoice');
                if (data != null) {
                    if (data.IsPrimary) {
                        vm.recipients.forEach(function (o) {
                            o.IsPrimary = false;
                        });
                    }
                    vm.recipients.push(data);
                }


            }, function (resp) {
                //deferred.reject();
            });
        }

        function onRemoveRecipient(data) {
            vm.showProgress = true;
            var deferred = $q.defer();

            msgboxService.yepNo('Would you like to remove this email from the company for all future invoice distribution?', 'Remove Email Confirmation')
                .then(function (resp) {
                    deferred.resolve(true);
                }, function (resp) {
                    deferred.resolve(false);
                });

            deferred.promise.then(function (isUpdateCompany) {
                emailRecipientService.removeRecipient(locals.id, data, isUpdateCompany)
                    .then(function (resp) {
                        // Remove from list
                        _.remove(vm.recipients, function (o) {
                            return o.Id == data.Id;
                        });

                        vm.showProgress = false;
                    }).catch(function (ex) {
                        vm.showProgress = false;
                        exceptionService.resolve(ex);
                    });
            });
        }

        /**
         * Company recipients
         */
        function addCompanyRecipient() {
            vm.showProgress = true;

            emailRecipientService.getDefaultRecipients(locals.companyId)
                .then(function (resp) {
                    vm.showProgress = false;
                    var trimmedRecipients = removeDuplicates(resp.data);

                    $mdDialog.show({
                        templateUrl: 'app/main/invoice/emailSender/dialogs/company-recipient/company-recipient.html',
                        controller: 'CompanyRecipientDialogController',
                        controllerAs: 'vm',
                        locals: { id: locals.id, name: locals.name, recipients: trimmedRecipients, companyId: locals.companyId },
                        multiple: true
                    }).then(function (data) {
                        if (data != null) {

                            // Call api to save
                            vm.showProgress = true;
                            emailRecipientService.addBatchRecipient(data)
                                .then(function (resp) {
                                    // Adopt the saved list: a row whose Id the server never saw cannot
                                    // be matched to its delivery callback and sits on SENDING.
                                    // Replaced in place - the grid row shares this array by reference.
                                    // See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#recipient-status-reported-back-to-the-portal
                                    var savedRecipients = resp.data;

                                    // The batch add returns every recipient on the invoice and it just
                                    // added at least one, so an empty list means the save did not take.
                                    // Keeping our own client-minted ids would hide that.
                                    if (!savedRecipients || savedRecipients.length === 0) {
                                        throw new Error('Adding the company recipients returned no saved rows.');
                                    }

                                    // Preview rows are not stored, so the saved list omits them, and the
                                    // send emails exactly what this array is posted as. Saved rows win a
                                    // collision - they carry the persisted Id the callback quotes.
                                    // See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#the-grids-company-preview
                                    var savedKeys = _.map(savedRecipients, function (o) {
                                        return recipientKey(o.Email, o.EmailType);
                                    });

                                    var previewOnly = _.filter(vm.recipients, function (o) {
                                        return !_.includes(savedKeys, recipientKey(o.Email, o.EmailType));
                                    });

                                    vm.recipients.splice(0, vm.recipients.length);

                                    savedRecipients.forEach(function (itm) {
                                        vm.recipients.push(itm);
                                    });

                                    previewOnly.forEach(function (itm) {
                                        vm.recipients.push(itm);
                                    });

                                    vm.showProgress = false;
                                }).catch(function (ex) {
                                    vm.showProgress = false;
                                    exceptionService.resolve(ex);
                                });
                        }
                    });

                });
        }

        function getDescriptionForIsPrimary(value) {
            return value == true ? 'Yes' : 'No';
        }

        function getEmailTypeDescription(type) {
            if (!type)
                return '';
            return (_.find(vm.emailTypes, function (f) {
                return f.Id == type;
            })).Value;
        }

        // EmailRecipientKey.For on the server: address AND type, with the legacy None folded into
        // Accounts. One address is legitimately two rows - once as Accounts, once as Paperwork -
        // each carrying its own attachment preference, so the address alone does not name a
        // recipient. Keying on it here dropped the Paperwork row from the list this dialog posts,
        // and the send emails exactly what is posted.
        // See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#one-definition-of-same-address
        function recipientKey(email, emailType) {
            var address = email == null ? '' : email.trim().toLowerCase();
            var type = (emailType == null || emailType === EMAIL_TYPE_NONE)
                ? EMAIL_TYPE_ACCOUNTS
                : emailType;

            return address + '|' + type;
        }

        function removeDuplicates(companyRecipients) {
            return _.differenceBy(companyRecipients, vm.recipients, function (o) {
                return recipientKey(o.Email, o.EmailType);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.invoice.emailsender')
        .controller('RecipientEntryDialogController', RecipientEntryDialogController);

    function RecipientEntryDialogController($mdDialog,
        utils,
        invoiceLookupService,
        $mdToast,
        locals,
        emailRecipientService,
        emailRecipientModel,
        msgboxService,
        exceptionService,
        _) {

        var vm = this;
        // Data
        vm.model = new emailRecipientModel();
        vm.recipients = locals.recipients;
        vm.emailTypes = invoiceLookupService.data.emailTypes;
        vm.showInlineError = false;
        vm.inlineMsg = null;
        vm.showProgress = false;

        // Events
        vm.onCancel = onCancel;
        vm.onSave = onSave;

        activate();

        ///////
        function activate() {
        }

        function onCancel() {
            $mdDialog.hide(null);
        }

        function onSave() {
            vm.showProgress = true;
            showInlineError(false);
            var valResult = emailRecipientService.canAddRecipient(vm.model, vm.recipients)

            if (valResult) {
                showInlineError(true, valResult);
                return;
            }

            var model = vm.model.toBackendModel();
            emailRecipientService.addRecipient(locals.id, model)
                .then(function (resp) {
                    vm.showProgress = false;
                    $mdDialog.hide(resp.data);
                }).catch(function (ex) {
                    vm.showProgress = false;
                    exceptionService.resolve(ex);
                });
        }

        function showInlineError(show, msg) {
            vm.showInlineError = false;
            vm.inlineMsg = null;
            if (show) {
                vm.showInlineError = true;
                vm.inlineMsg = msg;
            }
        }

        // function addCompanyRecipient() {
        //     alert('Add company recipient!');
        // }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.invoice.emailsender')
        .controller('IssueDialogController', IssueDialogController);

    function IssueDialogController($mdDialog,
        utils,
        locals,
        msgboxService,
        exceptionService,
        _) {

        var vm = this;

        // Data
        vm.issues = locals.issues;
        vm.message = locals.message;
        vm.isShowProceed = locals.isShowProceed;

        // Events
        vm.onCancel = onCancel;
        vm.onContinue = onContinue;

        activate();

        ///////
        function activate() {
        }

        function onCancel() {
            $mdDialog.hide(null);
        }

        function onContinue() {
            $mdDialog.hide('continue');
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.invoice.emailsender')
        .controller('DownloadInvoiceDialogController', DownloadInvoiceDialogController);

    function DownloadInvoiceDialogController($mdDialog,
        blockUI,
        contactService,
        identityService,
        invoiceDistributionApi,
        invoices,
        currentRequestToken,
        includePaperwork,
        isPaperworkOnly,
        isPaymentClaim,
        paymentClaimRequestType,
        paymentClaimsApi,
        utils) {

        var vm = this;
        vm.utilService = utils;

        // Events
        vm.close = close;
        vm.sendEmail = sendEmail;

        vm.downloadInProgress = false;

        activate();

        function activate() {
            if (isPaperworkOnly) {
                vm.Title = vm.utilService.translate('EMAILSENDER.SEND_BULK_PAPERWORK_TITLE');
            } else if(isPaymentClaim && paymentClaimRequestType == 0){
                vm.Title = vm.utilService.translate('EMAILSENDER.SEND_BULK_TIMESHEETS_TITLE');
            } else{
                vm.Title = vm.utilService.translate('EMAILSENDER.SEND_BULK_INVOICES_TITLE');
            }

            blockUI.start({
                message: 'Loading......'
            });

            if (identityService.isAuthenticated()) {
                identityService.fetchUserData()
                    .then(loadUserData);
            }
        }

        function loadUserData(resp) {
            contactService.getContactDetails(resp.ContactId).then(function(resp) {
                blockUI.stop();
                var email = alasql('select * from ? where IsPrimary = ?', [resp.data.Emails, true]);
                vm.email = email[0].EmailAddress;
            });
        }

        function close() {
            $mdDialog.hide(null);
        }

        function sendEmail() {
            vm.downloadInProgress = true;

            var ids = [];

            invoices.checkedItems.forEach(function(o) {
                ids.push(o.Id);
            });

            if(isPaymentClaim){
                var contactId = identityService.userData.ContactId;

                var data = {
                    contactId: contactId,
                    invoiceIds: ids,
                    requestType: paymentClaimRequestType,
                    emailAddress: vm.email
                }

                paymentClaimsApi.downloadPaymentClaims(data);

                return;
            }

            var payload = {
                Ids: ids,
                Email: vm.email,
                RequestToken: currentRequestToken,
                IncludePaperwork: includePaperwork,
                isPaperworkOnly: isPaperworkOnly
            };

            invoiceDistributionApi.download(payload);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.invoice.emailsender')
        .controller('CompanyRecipientDialogController', CompanyRecipientDialogController);

    function CompanyRecipientDialogController($mdDialog,
        utils,
        invoiceLookupService,
        $mdToast,
        locals,
        emailRecipientService,
        emailRecipientModel,
        msgboxService,
        exceptionService,
        _) {

        var vm = this;
        // Data
        vm.recipients = locals.recipients;
        vm.emailTypes = invoiceLookupService.data.emailTypes;
        vm.companyName = locals.name;
        vm.showProgress = false;
        vm.initialToggle = false;
        vm.checkCount = 0;

        // Events
        vm.addRecipient = addRecipient;
        vm.onCancel = onCancel;
        vm.checkToggle = checkToggle;
        vm.getDescriptionForIsPrimary = getDescriptionForIsPrimary;
        vm.getEmailTypeDescription = getEmailTypeDescription;
        vm.updateCheckCount = updateCheckCount;

        activate();

        ///////
        function activate() {
        }

        function onCancel() {
            $mdDialog.hide(null);
        }

        function addRecipient() {
            vm.showProgress = true;

            // Get checked items
            var recipientsToSave= _.filter(vm.recipients, function (o) {
                return o.isSelected == true;
            });

            if (recipientsToSave.length <= 0) return;

            recipientsToSave.forEach(function(o) {
                o['InvoiceId'] = locals.id;
                o['IsUpdateCompany'] = false;
                // The API binds InvoiceRecipientViewModel.Type. The company lookup returns the
                // address's type as EmailType, which binds to nothing, so every recipient added
                // here saved as None - visible in the Recipients dialog's Type column now that
                // the saved list is adopted rather than the posted rows kept. Defaulted because
                // the company's copy is nullable and Type is not: null is a binding error, not a
                // silent None.
                o['Type'] = o.EmailType || 0;
            });
            
            $mdDialog.hide(recipientsToSave);
        }

        // Not use yet
        function checkToggle(toggleFlag) {
            vm.initialToggle = !toggleFlag;

            alert(vm.initialToggle);

            vm.recipients.forEach(function (o) {
                o.isSelected = vm.initialToggle;
            });
        }

        function updateCheckCount() {
            vm.checkCount = (_.filter(vm.recipients, function(o) { return o.isSelected == true; })).length > 0;
        }

        function getDescriptionForIsPrimary(value) {
            return value == true ? 'Yes' : 'No';
        }

        function getEmailTypeDescription(type) {
            if (!type)
                return '';

            return (_.find(vm.emailTypes, function (f) {
                return f.Id == type;
            })).Value;
        }
    }
})();
/**
* Status Component
*/
(function () {
    'use strict';

    angular.module('app.invoice')
        .directive('invoiceStatusComponent', invoiceStatusComponent);

    /** @ngInject */
    function invoiceStatusComponent($http, $timeout, $rootScope) {
        var directive = {
            restrict: 'E',
            scope: {
            },
            require: '^invoiceGridComponent',
            templateUrl: 'app/main/invoice/directives/invoiceGrid/status/invoice-status.html',
            controller: InvoiceStatusController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function link($scope, elems, attrs, controller) {
            var vm = $scope.vm;
           
            controller.onSetStatus(function (val) {
                vm.status = val;
            });
           
        }

        function InvoiceStatusController() {}

    }
})();
/**
 * Sort engine 
 * Alloc8 Slick Grid
 * by Rcnet 07.03.2018
 */
(function () {
    'use strict';

    angular
        .module('app.invoice')
        .factory('a8SlickSortService', a8SlickSortService);

    /** @ngInject */
    function a8SlickSortService(_, alasql, utils) {
        var service = {
            sort: sort
        };

        return service;
        ///////

        // TODO: provide search columns parameter to override extractSearchFields
        function sort(collection, sortBy, sortDir) {
            if (collection.length <= 0
                || sortBy == null
                || sortBy == undefined
                || sortBy == ''
               // || sortDir == null
               // || sortDir == undefined
                || sortDir == '') return collection;

            let sExpr = createSortExpression(sortBy, sortDir);
            let results = alasql("SELECT * FROM ? " + sExpr, [collection]);

            return results;
        }

        // For complex sorting pass null to sortDir then include sort expression in the SortBy
        function createSortExpression(sortBy, sortDir) {
            return  (sortDir == null) ? ' ORDER BY ' + sortBy 
            : ' ORDER BY ' + sortBy + ' ' + sortDir.toUpperCase();
        }
    }
})();

/**
 * Search engine
 * by Rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.invoice')
        .factory('invoiceGridSearchEngineService', invoiceGridSearchEngineService);

    /** @ngInject */
    function invoiceGridSearchEngineService(_, alasql, utils) {
        var service = {
            search: search
        };

        return service;
        ///////

        // TODO: provide search columns parameter to override extractSearchFields
        function search(collection, stext) {
            
            if (collection.length <= 0 || stext == null || stext == undefined || stext == '' || stext == 'undefined') return null;

            let props = extractSearchFields(collection[0]);
            let qryPredicate = createQueryPredicate(props, stext);

            let results = alasql("SELECT * FROM ? WHERE " + qryPredicate, [collection]);

            return results;
        }

        function createQueryPredicate(propsColl, stext) {
            let pred = '';
            angular.forEach(propsColl, function(p) {
                pred += p + ' LIKE "%' + stext + '%" OR ';
            });

            return pred.substring(0, pred.length - 4);
        }

        function extractSearchFields(obj) {
            let objSanitized = utils.objectSanitize(obj);
            let propsArr = [];
            for(var p in objSanitized) {
                if (!angular.isFunction(propsArr))
                    propsArr.push(p);
            }
            return propsArr;
        }
    }

})();

/**
* Search Component
*/
(function () {
    'use strict';
    angular.module('app.invoice')
        .directive('invoiceGridSearchComponent', invoiceGridSearchComponent);

    /** @ngInject */
    function invoiceGridSearchComponent($log) {
        var directive = {
            restrict: 'E',
            scope: {
                source: '=',
                delay :'=',
                onSearch: '&'
            },
            require: '^invoiceGridComponent',
            templateUrl: 'app/main/invoice/invoiceGrid/search/invoiceGridSearch.html',
            controller: invoiceGridSearchController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function invoiceGridSearchController() { }

        function link($scope, elem, attrs, controller) {
            var vm = $scope.vm;

            $scope.$watch('vm.source', function (newVal) {
                if (newVal != null) {
                    controller.goSearch(newVal);

                    // Notify consumer
                    (vm.onSearch || angular.noop)({ value: encodeURIComponent(newVal) });
                }
            });

            controller.onGoSearch(function (val) {
                //$log.debug(val);
            });
        }
    }
})();

/**
* Grid Information Component
* by rcnet 12.14.2016
*/
(function () {
    'use strict';

    angular.module('app.invoice')
        .directive('gridInfoComponent', gridInfoComponent);

    /** @ngInject */
    function gridInfoComponent($http, $timeout, $rootScope) {
        var directive = {
            restrict: 'E',
            scope: {
            },
            require: '^invoiceGridComponent',
            templateUrl: 'app/main/invoice/directives/invoiceGrid/gridInfo/grid-info.html',
            controller: GridInfoController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function link($scope, elems, attrs, controller) {
            var vm = $scope.vm;
           
            controller.onSetGridInfo(function (info) {
                vm.totalItems = info.totalItems;
                vm.rawTotalItemCount = info.rawTotalItemCount;
                vm.inProgress = info.inProgress;
                vm.isFiltered = info.isFiltered;
            });  
        }

        function GridInfoController() {}

    }
})();
/**
 * signalrDataProvider
 * Note: it always create new instance of object
 */
(function () {
    'use strict';

    angular.module('app.invoice')
        .factory('signalrDataProvider', signalrDataProvider);

    /** @ngInject */
    function signalrDataProvider($q,
        signalRService,
        $interval,
        utils) {

        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        //////
        function activate() { }

        /**
         * Return new instance of object every we request getInstance
         */
        function getInstance(opts) {
            var provider = function () {
                var self = this,
                    stop,
                    isStopped,
                    requestId;

                self.downloadTickets = downloadTickets;
                self.stopDownload = stopDownload;
                self.data = [];

                self.onDownloadCompleted = angular.noop;
                self.onChunkReceived = angular.noop;
                self.onErrorDownloading = angular.noop;

                self.options = {
                    hub: 'messageHub',
                    endpoint: null,
                    bufferSize: 2000
                };

                angular.extend(self.options, opts);

                activate();

                //////
                function activate() {
                    isStopped = false;
                }

                function downloadTickets(params) {
                    var deferred = $q.defer();

                    requestId = utils.newGuid();
                    isStopped = false;
                    stop = undefined;
                    self.data.length = 0; // Remove this one!!!

                    signalRService.safeSend(function () {
                        params['ContinuationToken'] = null;
                        params['BufferSize'] = self.options.bufferSize;
                        params['RequestId'] = requestId;

                        signalRService[self.options.hub].invoke(self.options.endpoint, params)
                            .done(function (resp) {

                                if (isStopped) return;
                                if (resp.hasOwnProperty('Item3')) {
                                    if (resp.Item3 != null && requestId != resp.Item3) return;
                                }

                                angular.forEach(resp.Item1, function (itm) {
                                    self.data.push(itm);
                                });

                                // Fire event to subscriber
                                self.onChunkReceived({
                                    chunkData: resp.Item1,
                                    totalChunks: -1, // Undetermined
                                    totalItems: -1
                                }, 'dbHub');

                                // Continue fetching the next chunk data
                                if (resp.Item2 != null) {
                                    continueDl(resp.Item2, params);
                                } else {
                                    // Trigger event download completed
                                    // Note: Completed data aggregated for each download will not be use by alloc8 grid.
                                    // Only the chunk data from onChunkReceived is accepted as a superset collection.
                                    self.onDownloadCompleted(self.data);
                                }

                                deferred.resolve(resp);
                            }).fail(function (error) {
                                self.onErrorDownloading(error);
                                deferred.reject(error);
                            });
                    });

                    return deferred.promise;
                }

                function continueDl(contToken, params) {
                    if (angular.isDefined(stop))
                        return;

                    let isContinue = true;

                    stop = $interval(function () {
                        if (isContinue) {
                            isContinue = false;

                            if (contToken === null) {
                                stopDl();
                                // Trigger event download completed
                                self.onDownloadCompleted(self.data);
                                return;
                            }

                            params['ContinuationToken'] = contToken;
                            params['BufferSize'] = self.options.bufferSize;

                            continueDownloading(params)
                                .then(function (respData) {

                                    if (isStopped) return;
                                    if (resp.hasOwnProperty('Item3')) {
                                        if (resp.Item3 != null && requestId != resp.Item3) return;
                                    }
                                    if (respData) {
                                        // Bind data here
                                        angular.forEach(respData.Item1, function (itm) {
                                            self.data.push(itm);
                                        });

                                        // Fire event to subscriber
                                        self.onChunkReceived({
                                            chunkData: respData.Item1,
                                            totalChunks: -1, // Undetermined
                                            totalItems: -1
                                            //extraData: null //resp.hasOwnProperty('Item3') ? resp.Item3 : null
                                        }, 'dbHub');
                                    }

                                    isContinue = true;
                                    contToken = respData.Item2;
                                }).catch(function (ex) {
                                    // Terminate process if something went wrong
                                    if (ex.message !== 'Connection was disconnected before invocation result was received.') {
                                        stopDl();
                                    }
                                });
                        }
                    }, 100);
                }

                /**
                 * Stop downloading
                 */
                function stopDl() {
                    if (angular.isDefined(stop)) {
                        $interval.cancel(stop);
                        stop = undefined;
                    }
                }

                function stopDownload() {
                    isStopped = true;
                    stopDl();
                    self.data.length = 0;
                }

                /**
                 * Continue downloading
                 */
                function continueDownloading(params) {
                    let deferred = $q.defer();
                    signalRService[self.options.hub]
                        .invoke(self.options.endpoint, params)
                        .done(function (resp) {
                            deferred.resolve(resp);
                        }).fail(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }


            }; // End object instance

            return new provider();
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.equipment', [
      'app.equipment.view',
      'app.equipment.calendar'
    ])
    .config(config)
    .run(runConfig);

  /** @ngInject */
  function config() {
  }

  function runConfig() {

  }

})();

(function() {
    'use strict';

    angular.module('app.equipment')
        .controller('manageEquipmentController', manageEquipmentController);

    /** @ngInject */
    function manageEquipmentController(
        exceptionService,
        assetsApi,
        contactApi,
        $scope,
        $mdDialog,
        locals,
        individualItemService,
        _,
        utils,
        equipmentModel,
        claimsUtilService,
        blockUI) {

        var vm = this;

        vm.itemStates = [];
        vm.branches = [];
        vm.divisions = [];
        vm.model = individualItemService;
        vm.searchText = null;
        vm.utilService = utils;
        vm.isEditMode = false;
        vm.canCreateAssetItem = claimsUtilService.checkAccessByRole("Create a New Asset Individual Item");
        vm.canCreateRentalItem = claimsUtilService.checkAccessByRole("Create a New Rental Individual Item");
        vm.showStatusEffectiveDate = false;

        vm.querySearch = querySearch;
        vm.onItemChange = onItemChange;
        vm.onBranchSelectionChange = onBranchSelectionChange;
        vm.onCancel = onCancel;
        vm.onUpdate = onUpdate;
        vm.limit = limit;

        activate();

        function activate() {
            vm.model.hasChangesEvent = hasChangesEvt;
            vm.model.resetData();
            vm.editData = locals.editData;
            vm.itemStates = locals.itemStates;
            vm.items = locals.items;
            vm.costCodes = locals.costCodes;
            vm.isVehicle = isVehicle;
            vm.onItemTypeChange = onItemTypeChange;
            vm.users = [];

            let tempItemList = [];

            //Remove 'People'
            vm.ownershipTypes = locals.ownershipTypes;

            vm.itemTypes = locals.itemTypes.filter(function(type) {
                return type.Id === 1 || type.Id === 3 || type.Id === 5;
            });

            angular.forEach(vm.itemTypes, function(item) {
                if (item.Id === 1) {
                    item['Disabled'] = vm.canCreateAssetItem ? false : true;
                }

                if (item.Id === 3) {
                    item['Disabled'] = vm.canCreateRentalItem ? false : true;
                }
            });

            //Limit Items
            vm.items.forEach(function(item) {
                let counter = item.ItemTypes.filter(function(i) {
                    return (i === 1 || i === 3 || i === 5);
                });
                if (counter.length > 0) {
                    tempItemList.push(item)
                }
            });

            if (vm.canCreateRentalItem && vm.canCreateAssetItem) {
                tempItemList.forEach(function(itm) {
                    itm['Disabled'] = false;
                });
            } else {
                if (vm.canCreateRentalItem) {
                    tempItemList.forEach(function(itm) {
                        let counter = itm.ItemTypes.filter(function(i) {
                            return (i === 3);
                        });
                        itm['Disabled'] = counter.length > 0 ? false : true;
                    });
                }
                if (vm.canCreateAssetItem) {
                    angular.forEach(tempItemList, function(itm) {
                        let counter = itm.ItemTypes.filter(function(i) {
                            return (i === 1);
                        });
                        itm['Disabled'] = counter.length > 0 ? false : true;
                    });
                }
                if (!vm.canCreateAssetItem && !vm.canCreateRentalItem) {
                    angular.forEach(tempItemList, function(itm) {
                        itm['Disabled'] = true;
                    });
                }
                
                angular.forEach(tempItemList, function (itm) {
                    let counter = itm.ItemTypes.filter(function (i) {
                        return (i === 5);
                    });
                    itm['Disabled'] = counter.length > 0 ? false : true;
                });
            }

            vm.items = tempItemList;

            if (locals.editData) {
                vm.isEditMode = true;

                individualItemService.load2(locals.editData.ItemId).then(function(resp) {
                    blockUI.stop();

                    let assignedUser = resp[0].data.User;
                    let individualItem = resp[0].data;

                    if (assignedUser) {
                        assignedUser.FullName = assignedUser.FirstName + ' ' + assignedUser.LastName;
                        vm.searchText = assignedUser.FullName;
                    }

                    vm.branches = individualItem.Branches.length == 0 ? locals.branches : individualItem.Branches;

                    vm.model.data.map(individualItem);
                    vm.model.data.Divisions = individualItem.Branches.flatMap(br => br.Division);

                    vm.OriginalItemStatus = vm.model.data.ItemStatus;

                    loadDivisions();
                    loadUsers();
                });
            }
        }

        function onItemChange(individualItemId) {
            let individualItem = vm.items.find(itm => itm.id === individualItemId);

            vm.branches = locals.branches.filter(function(o) {
                for (let i in individualItem.Branches) {
                    if (individualItem.Branches.length > 0 && o.Id != individualItem.Branches[i].Id) {
                        continue;
                    }
                    return true;
                }
            }).sort((a, b) => a.Name.localeCompare(b.Name));
        }

        function onCancel() {
            individualItemService.hideDialog();
        }

        function onUpdate() {

            var individualItemData = vm.model.data;

            var equipment = new equipmentModel();
            equipment.IndividualItemId = individualItemData.id;
            equipment.ItemType = individualItemData.ItemType;
            equipment.ItemStatus = individualItemData.ItemStatus;
            equipment.Branches = individualItemData.Branches;
            equipment.User = individualItemData.User;
            equipment.UniqueItemId = individualItemData.UniqueItemId;
            equipment.Description = individualItemData.Description;
            equipment.ItemId = individualItemData.ItemId;
            equipment.StatusEffectiveDate = individualItemData.StatusEffectiveDate;
            equipment.VehicleOwnershipType = individualItemData.VehicleOwnershipType;

            let branches = angular.copy(individualItemData.Branches);
            let divisions = angular.copy(individualItemData.Divisions);

            angular.forEach(branches, function(branch) {
                branch['Division'] = divisions.filter(d => d.BranchId == branch.Id);
            });

            equipment.Branches = branches;

            if (vm.isEditMode) {
                blockUI.start('Updating.');
                assetsApi.updateIndividualItemEquipmentOnly(equipment.toBackendModel()).then(function() {
                    $mdDialog.hide(equipment.toBackendModel());
                    blockUI.stop();
                }).catch(function(err) {
                    blockUI.stop();
                    exceptionService.resolve(err);
                });
            } else {
                $mdDialog.hide(equipment.toBackendModel());
            }
        }

        function querySearch(query) {
            var results = query ? vm.users.filter(createFilterFor(query)) : vm.users;
            return results;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(emp) {
                return (angular.lowercase(emp.FullName).indexOf(lowercaseQuery) > -1);
            };
        }

        function limit(arr) {
            let arr_copy = angular.copy(arr.map(function(a) {
                return a.Name;
            }));

            if (arr_copy.length === 0) {
                return utils.translate("EQUIPMENT_VIEW.MANAGE_DIVISION(S)");
            } else if (arr_copy.length > 2) {
                return (arr_copy.sort().slice(0, 2).join(", ")) + " + " + (arr_copy.length - 2) + " " + utils.translate("EQUIPMENT_VIEW.MORE");
            } else {
                return arr_copy.sort().join(", ");
            }
        }

        function hasChangesEvt() {
            $scope.IndividualItemEntryForm.$setDirty();
        }

        function onBranchSelectionChange(){
            loadDivisions();
            loadUsers();
        }

        vm.hasItemStatusChange = function() {
            vm.model.data.StatusEffectiveDate = parseInt(vm.OriginalItemStatus) !== parseInt(vm.model.data.ItemStatus) ? new Date() : null;
            vm.showStatusEffectiveDate = parseInt(vm.OriginalItemStatus) !== parseInt(vm.model.data.ItemStatus);
        };

        function loadDivisions() {
            vm.divisions = [];

            let selectedBranches = vm.model.data.Branches;
            if (!Array.isArray(selectedBranches) || selectedBranches.length === 0) {
                return;
            }

            let branchLookup = locals.branches;
            let divisionLookup = [];

            angular.forEach(selectedBranches, function (branch) {
                let lookupBranchItem = branchLookup.find(lookupItem => lookupItem.Id === branch.Id);
                if (lookupBranchItem) {
                    angular.forEach(lookupBranchItem.Division, function (division) {
                        division.BranchId = branch.Id;
                        division.BranchName = branch.Name;
                        divisionLookup.push(division);
                    });
                }
            });

            vm.divisions = divisionLookup.sort((a, b) => a.Name.localeCompare(b.Name));

            let selectedDivisions = angular.copy(vm.model.data.Divisions);

            if (Array.isArray(selectedDivisions) && selectedDivisions.length > 0) {
                vm.model.data.Divisions.length = 0;

                angular.forEach(selectedDivisions, function (division) {
                    var existingDivision = divisionLookup.find(itm => itm.id === division.id);
                    if (existingDivision) {
                        vm.model.data.Divisions.push(existingDivision);
                    }
                });
            }
        }

        function onItemTypeChange() {
            vm.model.data.VehicleOwnershipType = null;
        }

        function isVehicle() {
            return vm.model.data.ItemType === 5;
        }

        function loadUsers() {
            let selectedBranches = vm.model.data.Branches;
            let selectedUser = angular.copy(vm.model.data.User);

            vm.users = [];
            vm.model.data.User = null;
            vm.searchText = null;

            if (!Array.isArray(selectedBranches) || selectedBranches.length === 0) {
                return;
            }

            blockUI.start('Getting employees...');

            let branchIds = selectedBranches.map(b => b.Id);

            contactApi.getEmployeesBelongToAllByBranches(branchIds).then(function (resp) {
                let users = resp.data;

                angular.forEach(users, function (user) {
                    user['FullName'] = user.FirstName + " " + user.LastName;
                });

                vm.users = users.sort((a, b) => a.FullName.localeCompare(b.FullName));

                if (selectedUser) {
                    let existingUser = users.find(usr => usr.Id === selectedUser.id || usr.Id === selectedUser.Id);
                    if (existingUser) {
                        vm.model.data.User = selectedUser;
                        vm.searchText = selectedUser.FullName
                    }
                }

                blockUI.stop();
            }).catch(function (ex) {
                blockUI.stop();
                exceptionService.resolve(ex);
            });;
        }
    };
})();

(function(){
    'use strict';

    angular.module('app.custom-validations-create')
        .directive('thenComponent', thenComponent);

    function thenComponent() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/customValidations/create/components/then/then.html',
            scope: {
                ngModel : '='
            },
            controller: thenComponentController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function thenComponentController(customValidationCreateService, $mdDialog, mediaQueryService) {

            var vm = this;
            vm.create_service = customValidationCreateService;
            vm.mediaQueryService = mediaQueryService;
            vm.addThenStatement = addThenStatement;
            vm.remove = remove;

            function addThenStatement(statement){
                $mdDialog.show({
                    templateUrl : 'app/main/customValidations/create/components/then/thenDialog/then-dialog.html',
                    controller : 'thenDialogController as vm',
                    locals : {
                        statement : statement,
                        model : vm.ngModel,
                        service : vm.create_service
                    }
                }).then(function(data){
                    if(data){
                        if(data.Statement){
                            angular.forEach(vm.ngModel, function(model){
                                if(data.Model.Field == model.Field){
                                    model.AllowedValues = data.Model.AllowedValues;
                                    model.CustomValidationRequiredType = data.Model.CustomValidationRequiredType;
                                    model.RegexValidation = data.Model.RegexValidation;
                                }
                            });
                        }else{
                            vm.ngModel.push(data.Model);
                        }
                    }
                });
            }

            function remove(index){
                let confirm = $mdDialog.confirm()
                    .title('Custom Rules')
                    .textContent('Are you sure you want to remove this rule?')
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function(){
                    vm.ngModel.splice(index, 1);
                });
            }
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.custom-validations-create')
        .directive('ifComponent', ifComponent);

    function ifComponent() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/customValidations/create/components/if/if.html',
            scope: {
                ngModel : '='
            },
            controller: ifComponentController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function ifComponentController($mdDialog, customValidationCreateService) {
            var vm = this;
            vm.create_service = customValidationCreateService;
            vm.condition_model = {
                MemberName : null,
                Id : null,
                Field : null,
                Value : null
            }

            vm.addCondition = addCondition;
            vm.remove = remove;

            function addCondition(condition){
                $mdDialog.show({
                    templateUrl : 'app/main/customValidations/create/components/if/ifDialog/if-dialog.html',
                    controller : 'ifDialogController as vm',
                    locals : {
                        condition : condition,
                        model : vm.ngModel,
                        service : vm.create_service
                    }
                }).then(function(data){
                    if(data){
                        if(_.isNil(data.Condition)){
                            vm.ngModel.push(data.Model);
                        }else{
                            angular.forEach(vm.ngModel, function(model){
                                if(data.Model.Field == model.Field){
                                    model.Id = data.Model.Id;
                                    model.Value = data.Model.Value;
                                }
                            });
                        }
                    }
                });
            }

            function remove(index){
                let confirm = $mdDialog.confirm()
                    .title('Custom Rules')
                    .textContent('Are you sure you want to remove this rule?')
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function(){
                    vm.ngModel.splice(index, 1);
                    // if(vm.ngModel.length === 0){
                    //     vm.create_service.rule_model.ThenStatements.length = 0;
                    // }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder', [])
        .directive('customFieldsBinder', customFieldsBinder)

    function customFieldsBinder(){
        var directive = {
            restrict : 'E',
            templateUrl : 'app/main/customFieldsManager/binder/custom-fields-binder.html',
            scope : {
                source : '@',
                isDisabled : '=',
                types : '=',
                fieldsList : '=',
                values : '=',
                fontSize : '@',
                ngModel : '=',
                padding : '@',
                triggerSave : '='
            },
            controller : controller,
            controllerAs : 'vm',
            bindToController : true
        };
        return directive;

        function controller($scope, _){
            var vm = this;
            vm.filtered_fields = [];
            vm.style = {
                'font-size' : vm.fontSize
            }

            vm.comply = comply;
            vm.complyMultiple = complyMultiple;

            function getFields(){
                if(vm.source == "Branches"){
                    vm.filtered_fields = orderByDescription(mapField(angular.copy(vm.fieldsList)));
                }else{
                    if(vm.fieldsList){
                        if(vm.fieldsList.length > 0){
                            vm.filtered_fields = [];
                            vm.fieldsList.forEach(function(field){
                                if(vm.types){
                                    vm.types.forEach(function(type){
                                        if(_.find(field.LookupTypes, {TypeName : type.TypeName})){
                                            if(!_.find(vm.filtered_fields, {id : field.id})){
                                                vm.filtered_fields.push(field);
                                            }
                                        }
                                    });
                                }
                            });
                            vm.filtered_fields = orderByDescription(mapField(angular.copy(vm.filtered_fields)));
                        }
                    }
                }
            }

            function orderByDescription(list){
                return _.orderBy(list, ['Description'], ['asc']);
            }

            function mapField(fields){
                fields = fields ? spreadCheckbox(fields) : fields;
                return fields ? fields.map(function(f){
                    return {
                        id : f.id,
                        FieldTitle : f.FieldTitle,
                        FieldType : f.FieldType,
                        Description : f.Description,
                        Option : f.Option,
                        OptionType : f.OptionType ? f.OptionType : null,
                        IsRequired : f.IsRequired,
                        ValidationType : f.ValidationType,
                        ValidationRegexPattern : f.ValidationRegexPattern,
                        MinValue : f.MinValue,
                        MaxValue : f.MaxValue,
                        Variable : f.Variable,
                        Value : (f.FieldType == "2" || f.FieldType == "12") ? getCheckboxValue(f)  : getValue(f.Variable)
                    }
                }) : [];
            }

            function spreadCheckbox(fields){
                //To be refactored
                let chk_fields = [];
                let new_fields = [];
                fields.forEach(function(field){
                    let generated_new_models = []
                    if(field.FieldType == 2 || field.FieldType == 12){
                        field.Option.forEach(function(opt){
                            generated_new_models.push({
                                id : opt.Id,
                                FieldTitle : opt.Value,
                                FieldType : field.FieldType,
                                Description : field.FieldTitle,
                                Option : [],
                                OptionType : opt.Type,
                                IsRequired : false,
                                ValidationType : null,
                                ValidationRegexPattern : null,
                                MinValue : null,
                                MaxValue : null,
                                Variable : field.Variable,
                                Value : false
                            });
                        });
                        chk_fields.push(field.id);
                    }

                    generated_new_models.forEach(function(field){
                        new_fields.push(field);
                    });
                });

                new_fields.forEach(function(field){
                    fields.push(field);
                });

                chk_fields.forEach(function(field){
                    fields.forEach(function(f){
                        if(field === f.id){
                            //Field Type 200 is checkbox || checkbox with entry header
                            f.FieldType = 200;

                            //Also change the description
                            f.Description = f.FieldTitle
                        }
                    });
                });

                return fields;
            }

            function getValue(field){
                let match = _.find(vm.values, {Id : "cs" + field});
                return match ? match.FieldValue : null;
            }

            function getCheckboxValue(field){
                let match = _.find(vm.values, {Id : "cs" + field.Variable + "_" + replace(field.id, "-", "")});
                return match ? match.FieldValue : false;
            }

            function bindData(fields, other_data){
                return excludeDescription(fields).map(function(field){
                    field.Value = bindValue(field);
                    return {
                        Id : getModel(field),
                        Title : field.FieldTitle,
                        Type : field.FieldType,
                        Value : (field.FieldType == "2" || field.FieldType == "12") ? bindComplete(field, other_data) : !_.isNil(field.Value) ? bindComplete(field, other_data) : null
                    }
                });
            }

            function bindValue(field){
                let returned_value = (field.FieldType == "2" || field.FieldType == "12") ? field.Value = _.isNil(field.ModelValue) ? field.Value : field.ModelValue : field.Value = field.Value
                return returned_value;
            }

            function excludeDescription(fields){
                return _.reject(fields, {FieldType : 200});
            }

            function bindComplete(field, other_data){
                //Especially made for binding other values (Multiple Choice, Checkbox)
                if(other_data){
                    if(field.id === other_data.Field.id){
                        return [{m_Item1: {Value: field.Value}, m_Item2: {Value: other_data.OtherValue}}];
                    }else{
                        if(field.FieldType == "12"){
                            let cs_id = "cs" + field.Variable + "_" + replace(field.id, "-", "");
                            let match = _.find(vm.values, {Id : cs_id});
                            return [{m_Item1: {Value: field.Value}}, {m_Item2: {Value : match.FieldValue}}];
                        }else{
                            return [{m_Item1: {Value: field.Value}}];
                        }
                    }
                }else{
                    //Radio Binding
                    if(field.FieldType == "1"){
                        let index = _.isNil(field.Value) ? -1 : field.Value.indexOf("|");
                        if(index >= 0){
                            let Id = field.Value.substring(0, index).trim();
                            let other = field.Value.substring(index + 1);
                            return [{m_Item1: {Value: Id}, m_Item2: {Value: other}}];
                        }else{
                            let match = _.find(vm.values, {Id : "cs" + field.Variable});
                            if(_.isNil(match.FieldValue)){
                                return [{m_Item1: {Value: field.Value}}];
                            }else if(match.FieldValue.indexOf("|") >= 0){
                                let index = match.FieldValue.indexOf("|");
                                let Id = match.FieldValue.substring(0, index).trim();
                                let other = match.FieldValue.substring(index + 1);
                                return [{m_Item1: {Value: Id}, m_Item2: {Value: other}}];
                            }else{
                                return [{m_Item1: {Value: field.Value}}];
                            }
                        }
                    }
                    //Checkbox Binding
                    else if(field.FieldType == "2" || field.FieldType == "12"){
                        let index = _.isNil(field.Value) ? -1 : _.isString(field.Value) ? field.Value.indexOf("|") : -1;
                        if(index >= 0){
                            let Id = field.Value.substring(0, index).trim();
                            let other = field.Value.substring(index + 1);
                            return [{m_Item1: {Value: Id}, m_Item2: {Value: other}}];
                        }else{
                            let cs_id = "cs" + field.Variable + "_" + replace(field.id, "-", "");
                            let match = _.find(vm.values, {Id : cs_id});

                            if(_.isNil(match)){
                                return [{m_Item1: {Value: field.Value}}];
                            }else if(_.isNil(match.FieldValue)){
                                return [{m_Item1: {Value: false}}];
                            }else if(match.FieldValue.toString().indexOf("|") >= 0){
                                let index = match.FieldValue.indexOf("|");
                                let Id = match.FieldValue.substring(0, index).trim();
                                let other = match.FieldValue.substring(index + 1);
                                return [{m_Item1: {Value: Id == "true" ? true : false}, m_Item2: {Value: other}}];
                            }else{
                                return [{m_Item1: {Value: field.Value}}];
                            }
                        }
                    }
                    else{
                        return [{m_Item1: {Value: field.Value}}];
                    }
                }
            }

            function bindDataFinal(fields, other_data){
                return excludeDescription(fields).map(function(field){
                    return {
                        Id : getModel(field),
                        Title : field.FieldTitle,
                        Type : field.FieldType,
                        FieldValue : getFinalValue(field, other_data),
                    }
                });
            }

            function getFinalValue(field, other_data){
                let value = null;
                if(other_data && other_data.Field.id === field.id){
                    value = field.Value + "|" + other_data.OtherValue;
                }else{
                    if(field.FieldType == "1"){
                        let selected_option = _.find(field.Option, {Id : field.Value});
                        if(selected_option){
                            if(selected_option.Type == "Regular"){
                                value = field.Value
                            }else{
                                let match = _.find(vm.values, {Id : "cs" + field.Variable});
                                value = match.FieldValue;
                            }
                        }else{
                            value = field.FieldValue;
                        }
                    }
                    else if(field.FieldType == "2" || field.FieldType == "12"){
                        if((field.Value && field.OptionType == "Other") || (field.Value && field.FieldType == "12")){
                            let cs_id = "cs" + field.Variable + "_" + replace(field.id, "-", "");
                            let match = _.find(vm.values, {Id : cs_id});
                            value = match.FieldValue
                        }
                        else{
                            value = field.Value;
                        }
                    }else{
                        value = field.Value;
                    }
                }
                return value;
            }

            function getModel(field){
                if(field.FieldType == 2 || field.FieldType == 12){
                    return "cs" + field.Variable + "_" + replace(field.id, "-", "");
                }else{
                    return "cs" + field.Variable;
                }
            }

            function replace(target, search, replacement){
                return target.split(search).join(replacement);
            }

            function comply(){
                vm.ngModel = bindData(vm.filtered_fields);
                vm.values = bindDataFinal(vm.filtered_fields);
            }

            function complyMultiple(data){
                vm.ngModel = bindData(vm.filtered_fields, data);
                vm.values = bindDataFinal(vm.filtered_fields, data);
            }

            $scope.$watch('vm.types', function(newValue, oldValue){
                if(vm.source != "Branches"){
                    if(newValue != oldValue){
                        getFields();
                    }
                }
            });

            $scope.$watch('vm.fieldsList', function(newValue, oldValue){
                if(newValue != oldValue){
                    getFields();
                }
            });

            $scope.$watch('vm.triggerSave', function(newValue, oldValue){
                if(newValue != oldValue){
                    vm.ngModel.forEach(function(model){
                        if(model.Type == 4 || model.Type == 1){
                            let found_field = vm.filtered_fields.find(function(field){
                                return field.FieldTitle === model.Title
                            });
                            let value_id = model.Value[0].m_Item1.Value;
                            let equivalent = _.find(found_field.Option, {Id : value_id});
                            model.Value[0].m_Item1.Value =equivalent.Value;
                        }
                    });

                    vm.values.forEach(function(model){
                        if(model.Type == 4 || model.Type == 1){
                            let found_field = vm.filtered_fields.find(function(field){
                                return field.FieldTitle === model.Title
                            });
                            let value_id = model.FieldValue;
                            let equivalent = _.find(found_field.Option, {Id : value_id});
                            model.FieldValue = equivalent.Value;
                        }
                    });
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('wholeNumberBinder', wholeNumberBinder)

    function wholeNumberBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/wholeNumber/wholeNumber.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
            vm.paste = paste;

            function paste(e){
                let data = e.originalEvent.clipboardData.getData('text/plain');
                if(data.indexOf('E')>-1 || data.indexOf('e')>-1) {
                    e.stopPropagation();
                    e.preventDefault();
                }
            }

            vm.comply();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('urlBinder', urlBinder)

    function urlBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/url/url.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
            vm.comply();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('timeBinder', timeBinder)

    function timeBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/time/time.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
            vm.comply();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('shortTextBinder', shortTextBinder)

    function shortTextBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/shortText/shortText.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
            vm.comply();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('paragraphBinder', paragraphBinder)

    function paragraphBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/paragraph/paragraph.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
            vm.comply();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('multipleChoiceBinder', multipleChoiceBinder)

    function multipleChoiceBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/multipleChoice/multipleChoice.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(_){
            var vm = this;
            vm.other_value = null;
            vm.enable_other_value = false;

            vm.complyMultiple = complyMultiple;

            function complyMultiple(Id){
                let match = _.find(vm.fieldDetail.Option, { Id : Id });
                if(match){
                    if(match.Type === "Regular") {
                        bindRegular(match)
                    }else{
                        vm.enable_other_value = true;
                        vm.other_value = null;
                        vm.fieldDetail.Value = Id;
                        vm.comply();
                    }
                }else{
                    let value = _.find(vm.fieldDetail.Option, { Type : "Other" });
                    bindOtherValue(value);
                }
            }

            function bindRegular(value){
                vm.enable_other_value = false;
                vm.other_value = null;
                vm.fieldDetail.Value = value.Id;
                vm.comply();
            }

            function bindOtherValue(value){
                vm.enable_other_value = true;
                vm.fieldDetail.Value = value.Id;
                vm.comply({data : {Field : vm.fieldDetail, OtherValue : vm.other_value}});
            }

            function activate(){
                //for merging old data
                let old_data_match  = _.find(vm.fieldDetail.Option, function(opt) {
                    return opt.Value == vm.fieldDetail.Value || opt.Id == vm.fieldDetail.Value;
                });
                if(old_data_match){
                    vm.fieldDetail.Value = old_data_match.Id;
                }else{
                    let other =  _.find(vm.fieldDetail.Option, {Type : "Other"});
                    if(other && !_.isNil(vm.fieldDetail.Value)){
                        vm.fieldDetail.Value = other.Id + "|" + vm.fieldDetail.Value;
                    }
                }
                //for merging old data
                let value = vm.fieldDetail.Value;
                let limiter = value ? value.lastIndexOf("|") : -1;
                let Id = limiter > 0 ? value.substring(0, value.indexOf("|")).trim() : value;
                let match = _.find(vm.fieldDetail.Option, { Id : Id });
                if(match){
                    if(match.Type === "Other"){
                        vm.fieldDetail.Value = Id;
                        vm.enable_other_value = true;
                        vm.other_value = value.substring(limiter + 1).trim();
                        vm.complyMultiple({data : {Field : vm.fieldDetail, OtherValue : vm.other_value}});
                    }else{
                        vm.fieldDetail.Value = Id;
                        vm.enable_other_value = false;
                        vm.other_value = null;
                        vm.comply();
                    }
                }
            }

            activate();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('emailBinder', emailBinder)

    function emailBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/email/email.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
            vm.comply();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('dropdownBinder', dropdownBinder)

    function dropdownBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/dropDown/dropDown.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(_){
            var vm = this;

            function activate(){
                //for merging old data
                let old_data_match  = _.find(vm.fieldDetail.Option, {Value : vm.fieldDetail.Value});
                if(old_data_match){
                    vm.fieldDetail.Value = old_data_match.Id;
                }
                //for merging old data
                vm.comply();
            }
            activate();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('decimalsBinder', decimalsBinder)

    function decimalsBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/decimals/decimals.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
            vm.comply();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('checkboxWithEntryBinder', checkboxWithEntryBinder)

    function checkboxWithEntryBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/checkboxWithEntry/checkboxWithEntry.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
            vm.other_value = null;

            vm.change = change;
            vm.complyMultiple = complyMultiple;

            function activate(){
                vm.fieldDetail['ModelValue'] = bind(vm.fieldDetail.Value);
            }

            function bind(raw_value){
                if(_.isString(raw_value)){
                    let index_of_limiter = raw_value.indexOf("|");
                    let boolean_value = raw_value.substring(0, index_of_limiter);
                    if(boolean_value == 'true'){
                        let other_value = raw_value.substring(index_of_limiter + 1);
                        vm.other_value = other_value == 'null' ? null : other_value;
                        return true;
                    }else{
                        vm.other_value = null;
                        return false;
                    }
                }
                return raw_value;
            }

            function change(value){
                vm.fieldDetail['ModelValue'] = value;
                if(vm.fieldDetail.OptionType == "Regular"){
                    vm.other_value = null;
                    vm.comply();
                }else{
                    vm.other_value = value ? vm.other_value : null;
                    value ? vm.comply({data : {Field : vm.fieldDetail, OtherValue : vm.other_value}}) : vm.comply();
                }
            }

            function complyMultiple(value){
                vm.comply({data : {Field : vm.fieldDetail, OtherValue : value}});
            }

            activate();
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('description', description)

    function description() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/checkboxDescription/description.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){
            var vm = this;
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('checkboxBinder', checkboxBinder)

    function checkboxBinder() {
        return {
            restrict : 'E',
            scope : {
                fieldDetail : '=',
                comply : '&',
                isDisabled : '='
            },
            templateUrl : 'app/main/customFieldsManager/binder/fields/checkbox/checkbox.html',
            controller : control,
            controllerAs : 'vm',
            bindToController : true
        }

        function control(){

            var vm = this;
            vm.other_value = null;

            vm.change = change;
            vm.complyMultiple = complyMultiple;

            function activate(){
                vm.fieldDetail['ModelValue'] = bind(vm.fieldDetail.Value);
            }

            function bind(raw_value){
                if(_.isString(raw_value)){
                    let index_of_limiter = raw_value.indexOf("|");
                    let boolean_value = raw_value.substring(0, index_of_limiter);
                    if(boolean_value == 'true'){
                        let other_value = raw_value.substring(index_of_limiter + 1);
                        vm.other_value = other_value == 'null' ? null : other_value;
                        return true;
                    }else{
                        vm.other_value = null;
                        return false;
                    }
                }
                return raw_value;
            }

            function change(value){
               vm.fieldDetail['ModelValue'] = value;
               if(vm.fieldDetail.OptionType == "Regular"){
                   vm.other_value = null;
                   vm.comply();
               }else{
                   vm.other_value = value ? vm.other_value : null;
                   value ? vm.comply({data : {Field : vm.fieldDetail, OtherValue : vm.other_value}}) : vm.comply();
               }
            }

            function complyMultiple(value){
                vm.comply({data : {Field : vm.fieldDetail, OtherValue : value}});
            }

            activate();
        }
    }

}());

(function () {
    'use strict';

    angular.module('app.contact.create')
        .factory('contactTrainingService', contactTrainingService);

    /** @ngInject */
    function contactTrainingService($mdDialog) {

        let service = {
            openTrainingDialog: openTrainingDialog,
        }

        return service;

        function openTrainingDialog(isEdit, data, onComplete) {
            $mdDialog.show({
                templateUrl: "app/main/contact/create/work/training/dialog/contact-training-dialog.html",
                controller: 'ContactTrainingDialogController as vm',
                onComplete: onComplete || function () {
                },
                locals: {
                    isEdit: isEdit,
                    data: data
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.contact.create')
        .directive('contactTraining', function() {
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/main/contact/create/work/training/contact-training.html',
                scope: {
                    list: '='
                },
                controller: ContactTrainingController,
                controllerAs: 'vm',
                bindToController: true
            };

            function ContactTrainingController(contactTrainingService) {
                var vm = this;
                vm.list = vm.list;
                vm.service = contactTrainingService;

                vm.remove = remove;
                vm.isExpiringSoon = isExpiringSoon;

                vm.dtOptions = {
                    pagingType: 'simple',
                    autoWidth: false,
                    responsive: true,
                    sort: false
                };

                function remove(index) {
                    vm.list.splice(index, 1);
                }

                function isExpiringSoon(expiryDate) {
                    var daysToExpiry = moment(expiryDate).diff(vm.today, 'days');
                    return daysToExpiry <= 14;
                }
            }
        });
})();

(function () {
  'use strict';

  angular.module('app.contact.create')
    .directive('companyDialog', function ($log, $mdDialog) {
      return {
        restrict: 'E'
        , replace: true
        , templateUrl: 'app/main/contact/create/work/company/workInfo-company-link.html'
        , scope: {
          behavior: '='
        }
        , link: function (scope) {
          scope.alert = '';

          // Attach behaviors
          if (scope.behavior) {
            scope.behavior.showDialog = showDialog;
          }

          scope.spawnCompanyDialog = function (loadData, editMode, index) {
            $mdDialog.show({
                parent: angular.element(document.body)
              , locals: { selectedCompany: loadData, editMode : editMode, index: index, quickOption : false}
              , templateUrl: 'app/main/contact/create/work/company/workInfo-company.html'
              , controller: 'ContactCreateCompanyController as vm'
            }).then(function (answer) {
            });
          }

          function showDialog (loadData, editMode, index) {
             scope.spawnCompanyDialog(loadData, editMode, index);
          }
        }
      }

    });
})();

(function () {
  'use strict';

  angular
    .module('app.contact.create')
    .controller('ContactCreateCompanyController', ContactCreateCompanyController);

  /** @ngInject */
  function ContactCreateCompanyController(utils
    , $mdDialog
    , contactLookupsService
    , contactService
    , editMode
    , index
    , _
    , quickOption
    , companyApi
    , locals
    , contactCompanyService) {

    var vm = this;

    // Data
    vm.company = {
      id: null,
      Name: '',
      Logo: '',
      ContactType: null,
      Position: ''
    };

   // New Methods
    vm.model2 = contactCompanyService.contactCompanyData;
    vm.service = contactCompanyService;
    vm.utilService = utils;
    vm.contactTypes = utils.objectSanitize(contactLookupsService.contactLookupsObj.ContactTypes);
    vm.branchList = contactLookupsService.contactLookupsObj.Branches;
    vm.branches = [];
    vm.initialLoad = true;
    vm.searchText;

    // Method
    vm.onDone = onDone;
    vm.onCancel = onCancel;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.filterStartDate = filterStartDate;
    vm.filterEndDate =  filterEndDate;
    vm.onChange = onChange;

    activate();

    function filterStartDate(date){
      return utils.filterStartDate(date, -1);
    }

    function filterEndDate(date){
      return utils.filterEndDate(date, -1, vm.model2.StartDate);
    }

    function onChange(){
      vm.model2.EndDate = utils.validateDateOnChange(vm.model2.StartDate, vm.model2.EndDate, null);
    }

    function activate() {
      contactCompanyService.reset();
      contactCompanyService.init(locals.selectedCompany);
      if(locals.selectedCompany){
        if(quickOption){
          vm.model2.Company = locals.selectedCompany;
          vm.service.selectedItem = vm.model2.Company;
          companyApi.getCompany(vm.model2.Company.Id ||vm.model2.Company.id).then(function(resp){
            contactCompanyService.branchList = resp.data.Branches;
          }).finally(function () {
            vm.model2.Position = contactService.contactData.Position;
            vm.model2.ContactType = { id: 1, TypeName: "Employee" };
            angular.forEach(contactService.contactData.Branches2, function (branch, i) {
              vm.branches.push(branch);
            })
          });
        }else{
          vm.service.selectedItem = vm.model2.Company;
          vm.model2.Company = locals.selectedCompany.Company;
          vm.model2.ContactType = locals.selectedCompany.ContactType;
          vm.model2.EndDate = locals.selectedCompany.EndDate;
          vm.model2.StartDate = locals.selectedCompany.StartDate;
          vm.model2.Position = locals.selectedCompany.Position;
          vm.branches = vm.model2.Company.Branches;
          companyApi.getCompany(vm.model2.Company.Id ||vm.model2.Company.id).then(function(resp){
            contactCompanyService.branchList = resp.data.Branches;
          });
        }
      }

    }

    function onDone(answer) {
      var company = {
        Company : answer.Company[0] || answer.Company,
        ContactType : answer.ContactType,
        StartDate : answer.StartDate,
        EndDate : answer.EndDate,
        Position : answer.Position
      }

      company.Company.Branches = _.uniqBy(vm.branches, 'Id');;
      if(editMode){
        contactService.contactData.Companies[index] = company;
      }else{
        contactService.contactData.Companies.push(company);
      }
      $mdDialog.hide(company);
    }

    function onCancel() {
      $mdDialog.cancel();
    }

    function querySearch(query) {
      var q = null;
      var sanitizedQuery = query ? query.replace(/'/g, "''") : '';
      let existing_companies = angular.copy(contactService.contactData.Companies);
      if(existing_companies.length > 0){
        let not_in = "(";
         existing_companies.map(function(item){
           let Id  = item.Company.Id || item.Company.id;
          not_in = not_in + "'" + Id + "',";
        });
        not_in = not_in.slice(0, - 1)
        not_in = not_in + ")";
        q = "select * from ? where Name like '%" + sanitizedQuery + "%' and id not in " + not_in;
      }else{
        q = "select * from ? where Name like '%" + sanitizedQuery + "%'";
      }
      let source = alasql(q, [vm.service.companyList]);
      return source;
    }

    function selectedItemChange(item) {
      if(vm.initialLoad){
        vm.initialLoad = false;
      }else{
        vm.branches = [];
        vm.model2.Company.Branches = [];
      }

      var id = item ? item.id : null;
      if (contactService.isContactCompanyExist(id) && !contactCompanyService.isEditMode) {
         contactCompanyService.selectedItem = null;
         vm.searchText = null;
         utils.translate('CONTACTS_MODULE.COMPANY_EXISTS');
      } else {
         contactCompanyService.onSelectedItemChange(id);
      }
    }
  }
})();

(function() {
    'use strict';

    angular.module('app.contact.create')
        .directive('contactAllowances', contactAllowances);

    function contactAllowances(
        payrollClaimsService,
        utils,
        contactService,
        $timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/contact/create/work/allowances/contact-allowances.html',
            scope: {
                payrollAllowances: '=',
                allowancesLookup: '='
            },
            controller: allowancesViewController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function allowancesViewController($mdDialog, _) {
            var vm = this;
            vm.dtOptions = {
                pagingType: 'simple',
                pageLength: 25,
                autoWidth: false,
                responsive: true,
                sort: false
            };

            vm.formattedAllowanceList = [];
            vm.openDialog = openDialog;
            vm.removeAllowance = removeAllowance;
            vm.activate = activate;
            vm.addAllowanceError = false;
            vm.addAllowanceErrorMessage = '';

            function activate() {
                vm.hasModifyAllowancesAccess = payrollClaimsService.hasModifyAllowancesAccess;
                formatAllowanceList();
            }

            function formatAllowanceList() {
                vm.formattedAllowanceList = [];
                if (vm.payrollAllowances && vm.allowancesLookup && vm.payrollAllowances.length > 0) {
                    angular.forEach(vm.payrollAllowances, function(item) {

                        var allowance = alasql('select * from ? where UPPER(Id) = UPPER(?)', [vm.allowancesLookup, item.AllowanceId])[0];
                        var shiftType = allowance.Type == 1 ? "per hour" : "per shift";
                        var label = `${allowance.Name} (${allowance.PayCode})`;

                        vm.formattedAllowanceList.push({
                            id: item.AllowanceId,
                            label: label,
                            amount: allowance.Amount,
                            shiftType: shiftType,
                            isActive: allowance.Active
                        });
                    });
                }
            }

            function removeAllowance(allowanceId) {
                _.remove(vm.payrollAllowances, {
                    AllowanceId: allowanceId
                });
                formatAllowanceList();
                updateContact();
            }

            function getFilteredAllowancesLookup() {
                let allowancesCopy = angular.copy(vm.allowancesLookup);

                angular.forEach(vm.payrollAllowances, function(payrollAllowance) {
                    _.remove(allowancesCopy, function(item) {
                        return item.Id == payrollAllowance.AllowanceId;
                    });
                });

                return allowancesCopy;
            }

            function openDialog() {

                let activeAllowances = vm.allowancesLookup.filter(x => x.Active === true);
                let availableActiveAllowances = activeAllowances.filter(a => !vm.payrollAllowances.some(pa => pa.AllowanceId == a.Id));

                if (vm.allowancesLookup.length > 0 && availableActiveAllowances.length == 0) {
                    vm.addAllowanceError = true;
                    vm.addAllowanceErrorMessage = utils.translate("CONTACTSMODULE.ALLOWANCE.MAXIMUM_ALLOWANCE_REACH");
                    return;
                } else if (vm.allowancesLookup.length <= 0 || activeAllowances.length <= 0) {
                    vm.addAllowanceError = true;
                    vm.addAllowanceErrorMessage = utils.translate("CONTACTSMODULE.ALLOWANCE.ALLOWANCE_NOT_SETUP");
                    return;
                }

                var locals = {
                    allowancesLookup: getFilteredAllowancesLookup(),
                };

                $mdDialog.show({
                    templateUrl: 'app/main/contact/create/work/allowances/dialog/contact-allowance-dialog.html',
                    controller: 'contactAllowanceDialogController as vm',
                    locals: locals
                }).then(function(resp) {
                    if (resp) {
                        var now = utils.jsDateTimeToEpoch(new Date());
                        vm.payrollAllowances.push({
                            AllowanceId: resp.AllowanceId,
                            AppliedOn: now
                        });
                        contactService.contactData.PayRollAllowances = vm.payRollAllowances;

                        updateContact();
                    }
                });
            }

            function updateContact() {
                $timeout(function() {
                    contactService.updateContact();
                    formatAllowanceList();
                })

                vm.addAllowanceError = false;
                vm.addAllowanceErrorMessage = '';
            }

            $timeout(function() {
                vm.activate();
            }, 500);

        }
    }
})();
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('nothingFound', nothingFound);

    function nothingFound() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/contact/create/directives/nothingFound/nothing.found.html',
            scope: {
                title: '@'
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller() {
            var vm = this;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('highlightBox', highlightBox);

    function highlightBox() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/contact/create/directives/highlightBox/highlight-box.html',
            scope: {
                content: '@',
                classes: '@',
                description: '@',
                isReference: '@'
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller() {
            var vm = this;
            vm.trim = function (text) {
                if (vm.description || vm.isReference) {
                    if (vm.description) {
                        return (vm.description == "true" && text.length > 30 ? limit(text, 27) : text);
                    } else {
                        return (vm.isReference == "true" && text.length > 15 ? limit(text, 12) : text);
                    }
                } else {
                    return text;
                }
            }

            function limit(text, count) {
                return text.substring(0, count) + '...';
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('fileViewer', fileViewer);

    function fileViewer() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/contact/create/directives/fileViewer/file-viewer.html',
            scope: {
                file: '=',
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller(skillsMatrixService) {
            var vm = this;
            vm.view = function (fileName) {
                skillsMatrixService.preview(fileName);
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.contact.create')
        .directive('contactComponentHeader', contactsHeader);

    function contactsHeader() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/contact/create/directives/componentHeader/contactComponentHeader.html',
            scope: {
                showAction: "@",
                title: '@',
                onAdd: '&'
            },
            controller: contactsHeaderController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function contactsHeaderController($scope, mediaQueryService) {
            $scope.mediaQueryService = mediaQueryService;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.contact.calendar', [
            'ui.calendar'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.contact_calendar', {
            url: '/contact/calendar/:Id?/:Name',
            views: {
                'content@app': {
                    templateUrl: 'app/main/contact/calendar/contact-calendar.html',
                    controller: 'contactCalendarController as vm'
                }
            },
            data: { requireLogin: true },
            title: 'Contact Calendar',
            titleBar: 'Alloc8 - Contact Calendar',
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/contact/calendar');

        // Navigation
        // msNavigationServiceProvider.saveItem('apps.calendar', {
        //     title : 'Calendar',
        //     icon  : 'icon-calendar-today',
        //     state : 'app.calendar',
        //     weight: 2
        // });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.contact.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController(hubService, $mdDialog, dialogData, dialogLookUp, TimeLibrary)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.repeat = [];
        vm.RepeatEvery = [];
        vm.recurring = dialogData.calendarEvent.Repeats ? true : false;
        vm.hasSelected= true;
        vm.chosenOption = null;

        // Methods
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;
        vm.deleteEvent = deleteEvent;
        vm.onRepeatOn = onRepeatOn;
        vm.onSelectRepeatType = onSelectRepeatType;
        vm.showEndDate = showEndDate;
        vm.onSelectOption = onSelectOption;
        vm.processDependency = processDependency;
        vm.computeEndDate = computeEndDate;
        vm.validateDate = validateDate;
        vm.showTheEndDate = false;

        vm.dayInWeek = [1, 2, 3, 4, 5, 6, 0];

        function getDateDiff(date1, date2) {
          let dt1 = new Date(date1);
          let dt2 = new Date(date2);
          return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
        }

        function activate() {
            if(vm.dialogData.calendarEvent){
                let start = vm.dialogData.calendarEvent.StartDate;
                let end = vm.dialogData.calendarEvent.EndDate;
                vm.showTheEndDate = showEndDateOnActivation(start, end);
            }
        }

        function getDateString(date) {
            return date.substring(0, 10);
        }

        function showEndDateOnActivation(start, end){
            let startString = getDateString(start);
            let endString = getDateString(end);
            return startString === endString ? false : true;
        }

        activate();

        function validateDate(date_type){
          if(vm.showTheEndDate){
            if(!_.isNil(vm.calendarEvent.start) && !_.isNil(vm.calendarEvent.end)){
              let diff = getDateDiff(vm.calendarEvent.start, vm.calendarEvent.end);
              if(diff < 0){
                hubService.showToast('The job end date must be on or after the job start date');
                if(date_type === 'start'){
                  vm.calendarEvent.start = null;
                }else{
                  vm.calendarEvent.end = null;
                }
              }
            }
          }
        }

        vm.convertToDayName = function (code) {
            switch (code) {
                case 0:
                    return "Sunday";
                //break;
                case 1:
                    return "Monday";
                //break;
                case 2:
                    return "Tuesday";
                //break;
                case 3:
                    return "Wendesday";
                //break;
                case 4:
                    return "Thursday";
                //break;
                case 5:
                    return "Friday";
               //break;
                case 6:
                    return "Saturday";
                //break;
                default:
                break;
            }
        };

        vm.convertToRepeatTypeValue = function(id){
            switch (id) {
                case 0:
                    return "Day/s";
                case 1:
                    return "Week/s";
                case 2:
                    return "Month/s";
                default:
                break;
            }
        }

        vm.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            }
            else {
                list.push(item);
            }

            if(list.length > 0){
                vm.hasSelected = true;
                if(vm.dialogData.type === 'edit'){
                    eventForm.$invalid = false;
                    eventForm.$pristine = false;
                }
                vm.calendarEvent.Repeats.RepeatsOn = list;
            }
            else{
                vm.hasSelected = false;
                if(vm.dialogData.type === 'edit'){
                    eventForm.$invalid = true;
                    eventForm.$pristine = true;
                }
            }
        };

        vm.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };

        vm.isIndeterminate = function () {
            return (vm.repeat.length !== 0 &&
            vm.repeat.length !== vm.dayInWeek.length);
        };

        vm.isChecked = function () {
            return vm.repeat.length === vm.dayInWeek.length;
        };

        vm.toggleAll = function () {
            if (vm.repeat.length === vm.dayInWeek.length) {
                vm.repeat = [];
            } else if (vm.repeat.length === 0 || vm.repeat.length > 0) {
                vm.repeat = vm.dayInWeek.slice(0);
            }

            if(vm.repeat.length > 0){
                vm.hasSelected = true;
                if(vm.dialogData.type === 'edit'){
                    eventForm.$invalid = false;
                    eventForm.$pristine = false;
                }
                vm.calendarEvent.Repeats.RepeatsOn = vm.repeat;
            }
            else{
                vm.hasSelected = false;
                if(vm.dialogData.type === 'edit'){
                    eventForm.$invalid = true;
                    eventForm.$pristine = true;
                }
            }
        };

        init();

        function init(){
            var i = 1;
            for(i=1; i <= 30; i++){
                vm.RepeatEvery.push(i);
            }
            vm.dialogTitle = (vm.dialogData.type === 'add' ? 'Add Entry' : 'Edit Entry');
            vm.EntryTypeLookup = dialogLookUp.EntryType;
            vm.RepeatTypeLookup = dialogLookUp.RepeatType;

            // Edit
            if (vm.dialogData.calendarEvent)
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake the Full Calendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);
                vm.calendarEvent.EntryType = vm.calendarEvent.CalendarEntryType;
                vm.calendarEvent.EntryReason = vm.calendarEvent.CalendarEntryTypeDetails;

                // Convert moment.js dates to javascript date object
                //var d = new Date();
                //var n = d.getTimezoneOffset() / 60;
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    // if(vm.calendarEvent.Repeats){
                    //     if(vm.calendarEvent.Repeats.RepeatType === 1){
                    //         //vm.calendarEvent.start = moment(vm.calendarEvent.start).add(n, 'hours').toDate();
                    //         //vm.calendarEvent.startTime = moment(vm.calendarEvent.start).format('HH:mm');
                    //     }
                    //     else{
                    //         vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                    //         vm.calendarEvent.startTime = moment(vm.calendarEvent.start).format('HH:mm');
                    //     }
                    // }
                    // else{
                        vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                        vm.calendarEvent.startTime = TimeLibrary.convertTime(moment(vm.calendarEvent.start).format('HH:mm'));
                    // }

                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    // if(vm.calendarEvent.Repeats){
                    //     if(vm.calendarEvent.Repeats.RepeatType === 1){
                    //         //vm.calendarEvent.end = moment(vm.calendarEvent.end).add(n, 'hours').toDate();
                    //         //vm.calendarEvent.endTime = moment(vm.calendarEvent.end).format('HH:mm')
                    //     }
                    //     else{
                    //          vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                    //         vm.calendarEvent.endTime = moment(vm.calendarEvent.end).format('HH:mm')
                    //     }
                    // }
                    // else{
                        vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                        vm.calendarEvent.endTime = TimeLibrary.convertTime(moment(vm.calendarEvent.end).format('HH:mm'));
                    // }
                }

                if(!vm.calendarEvent.Repeats && !vm.calendarEvent.IsAllDayEvent){
                    vm.dateTimeRangeOption = true;
                    vm.chosenOption = 1;
                }

                if(vm.calendarEvent.IsAllDayEvent){
                    vm.allDayOption = true;
                    vm.chosenOption = 2;
                    vm.calendarEvent.startTime = null;
                    vm.calendarEvent.endTime = null;
                    //vm.calendarEvent.end = (vm.calendarEvent.end.subtract(1, 'd')).toDate();
                }

                if(vm.recurring){
                    if(!vm.calendarEvent.Repeats.RepeatEvery){
                        vm.repeatPeriodOption = true;
                        vm.recurring = false;
                    }
                    else{
                        vm.repeat = vm.calendarEvent.Repeats.RepeatsOn;
                    }

                    if(vm.repeatPeriodOption){
                      vm.chosenOption = 3;
                    }else{
                      vm.chosenOption = 4;
                    }
                }
            }
            // Add
            else
            {
                vm.calendarEvent = {};
                // Convert moment.js dates to javascript date object
                if(vm.dialogData.start && vm.dialogData.end){
                    if ( moment.isMoment(vm.dialogData.start) )
                    {
                        vm.calendarEvent.start = vm.dialogData.start.toDate();
                    }

                    if ( moment.isMoment(vm.dialogData.end) )
                    {
                        vm.calendarEvent.end = (vm.dialogData.end.subtract(1, 'd')).toDate();
                    }
                }
                vm.dateTimeRangeOption = true;

                // vm.calendarEvent = {
                //     CalendarEntryType : vm.EntryType,
                //     StartDate : vm.dialogData.start,
                //     EndDate : vm.dialogData.end,
                //     repeat  : []
                // };
            }
        }

        function saveEvent(){
            if(vm.chosenOption === 1){
              if(!_.isNil(vm.calendarEvent.Repeats)){
                delete vm.calendarEvent.Repeats;
              }
            }

            if(vm.chosenOption === 2){
              if(!_.isNil(vm.calendarEvent.Repeats)){
                vm.calendarEvent.Repeats = null;
              }
            }

            var response = {
                type         : vm.dialogData.type,
                calendarEvent:  vm.calendarEvent,
                repeats : vm.repeat,
                IsAllDayEvent: vm.allDayOption
            };

            $mdDialog.hide(response);
        }

        function deleteEvent(){
            var response = {
                type         : 'delete',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        function onRepeatOn(){
            vm.hasSelected = true;
        }

        function onSelectRepeatType(){
            if(vm.calendarEvent.Repeats.RepeatType === 1){
                //$timeout( function(){vm.hasSelected= true;}, 1000 );
                vm.hasSelected= false;
                vm.getSelectedDateDOW(vm.calendarEvent.start);
            }
            else{
                vm.hasSelected= true;
            }
        }

        /**
         * Close the dialog
         */
        function closeDialog(){
            $mdDialog.cancel();
        }

        function showEndDate(){
            if(vm.showTheEndDate){
                vm.showTheEndDate = false;
            }
            else{
                vm.showTheEndDate = true;
            }
        }

        function onSelectOption(from){
            //vm.repeat = null;

            if(from === 'Date/Time Range'){
                vm.allDayOption = false;
                vm.repeatPeriodOption = false;
                vm.recurring = false;
                vm.dateTimeRangeOption = true;
                vm.Repeats = null;
                vm.chosenOption = 1;
            }

            if(from ==='All Day'){
                vm.dateTimeRangeOption = false;
                vm.repeatPeriodOption = false;
                vm.recurring = false;
                vm.calendarEvent.Repeats = null;
                vm.calendarEvent.IsAllDayEvent = true;
                vm.calendarEvent.startTime = TimeLibrary.convertTime("00:00");
                vm.calendarEvent.endTime = TimeLibrary.convertTime("00:00");

                if(vm.calendarEvent.start){
                    vm.calendarEvent.start = moment(moment(vm.calendarEvent.start).format('MM/DD/YYYY') + ' ' + TimeLibrary.convertToServerTime(vm.calendarEvent.startTime)).toDate();
                }

                if(vm.calendarEvent.end){
                    vm.calendarEvent.end = moment(moment(vm.calendarEvent.end).format('MM/DD/YYYY') + ' ' + TimeLibrary.convertToServerTime(vm.calendarEvent.endTime)).toDate();
                }

                vm.allDayOption = true;
                vm.Repeats = null;
                vm.chosenOption = 2;
            }

            if(from ==='Repeat Period'){
                vm.dateTimeRangeOption = false;
                vm.allDayOption = false;
                vm.recurring = false;
                vm.calendarEvent.Repeats = {RepeatType : 1, RepeatsOn : []};
                vm.repeatPeriodOption = true;
                vm.chosenOption = 3;
            }

            if(from === 'Repeat in Specific Day'){
                vm.calendarEvent.end = null;
                vm.dateTimeRangeOption = false;
                vm.allDayOption = false;
                vm.repeatPeriodOption = false;
                vm.recurring = true;
                onRepeatOn();
                getSelectedDateDOW(vm.calendarEvent.start);
                vm.chosenOption = 4;
            }
        }

        function getSelectedDateDOW(date){
            if(vm.calendarEvent.Repeats){
                if(vm.calendarEvent.Repeats.RepeatType === 1 && !vm.repeatPeriodOption){
                    vm.repeat.splice(0);
                    var dow = moment(date).day();
                    vm.repeat.push(dow);
                    if(vm.repeat.length > 0){
                        vm.hasSelected = true;
                        vm.calendarEvent.Repeats.RepeatsOn = vm.repeat;
                    }
                }
            }
        }

        function processDependency(date){
            getSelectedDateDOW(date);
            vm.computeEndDate();
        }

        function computeEndDate(time_type){

            if(!vm.calendarEvent.end){
                if(vm.calendarEvent.start){
                    vm.calendarEvent.end = vm.calendarEvent.start;
                }
            }

            if((!vm.calendarEvent.startTime || !vm.calendarEvent.endTime) && vm.calendarEvent.end < vm.calendarEvent.start){
                if(vm.calendarEvent.start){
                    vm.calendarEvent.end = vm.calendarEvent.start;
                }
            }

            if(vm.calendarEvent.startTime && vm.calendarEvent.endTime){
                if(vm.calendarEvent.start){
                    vm.calendarEvent.start = moment(moment(vm.calendarEvent.start).format('YYYY-MM-DD') + ' ' + TimeLibrary.convertToServerTime(vm.calendarEvent.startTime)).toDate()
                }

                if(vm.calendarEvent.end){
                    vm.calendarEvent.end = moment(moment(vm.calendarEvent.end).format('YYYY-MM-DD') + ' ' + TimeLibrary.convertToServerTime(vm.calendarEvent.endTime)).toDate()
                }

                if(vm.calendarEvent.end < vm.calendarEvent.start){
                    if(vm.calendarEvent.start){
                        vm.calendarEvent.end = vm.calendarEvent.start;
                    }
                }

                if(moment(moment(vm.calendarEvent.end).format('YYYY-MM-DD' + ' ' + TimeLibrary.convertToServerTime(vm.calendarEvent.endTime)))
                <= moment(moment(vm.calendarEvent.start).format('YYYY-MM-DD' + ' ' + TimeLibrary.convertToServerTime(vm.calendarEvent.startTime)))){
                    //vm.calendarEvent.end = moment(moment(vm.calendarEvent.end).add(1, 'days'), 'YYYY-MM-DD').format('YYYY-MM-DD');
                }
            }

            if(!vm.allDayOption){
              let start_time = moment();
              let end_time = moment();
              if(!_.isNil(vm.calendarEvent.startTime) && !_.isNil(vm.calendarEvent.endTime)){
                start_time.set({hour : getHour(TimeLibrary.convertToServerTime(vm.calendarEvent.startTime)), minute : getMinute(TimeLibrary.convertToServerTime(vm.calendarEvent.startTime))});
                end_time.set({hour : getHour(TimeLibrary.convertToServerTime(vm.calendarEvent.endTime)), minute : getMinute(TimeLibrary.convertToServerTime(vm.calendarEvent.endTime))});
                //difference in time
                let diff = end_time.diff(start_time, 'minutes');

                //difference in days
                // let startDate = moment(vm.calendarEvent.start);
                // let endDate = moment(vm.calendarEvent.end);
                // startDate.set({hour : 0});
                // endDate.set({hour : 0});
                // //Get the difference of the 2 dates (end - start)
                // let diffInDays = endDate.diff(startDate, 'days');

                if(diff < 0){
                  hubService.showToast('The job start time must be before job end time');
                  if(time_type === 'start'){
                    vm.calendarEvent.startTime = null;
                  }else{
                    vm.calendarEvent.endTime = null;
                  }
                }
              }
            }
        }

        function getHour(time_string){
          time_string = time_string.replace(" ", "");
          let index = time_string.indexOf(":");
          let result = time_string.substring(0, index);
          result = result.replace(" ", "");
          return parseInt(result);
        }

        function getMinute(time_string){
          time_string = time_string.replace(" ", "");
          let index = time_string.indexOf(":");
          let result = time_string.substring(index + 1);
          result = result.replace(" ", "");
          return parseInt(result);
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.contact.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event, TimeLibrary, adminClaimsService, historyLogService)
    {
        var vm = this;

        // Data
        vm.start_time = null;
        vm.end_time = null;
        vm.calendarEvent = calendarEvent;
        vm.adminClaimsService = adminClaimsService;

        // Methods
        vm.editEvent = editEvent;
        vm.viewHistory = viewHistory;
        vm.closeDialog = closeDialog;
        vm.activate = activate;

        function closeDialog() {
            $mdDialog.hide();
        }

        function editEvent(calendarEvent) {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }

        function viewHistory(calendarEvent) {
            historyLogService.showHistoryLogV2([calendarEvent.ParentId], calendarEvent.title);
        }

        function activate(){
            if(!vm.calendarEvent.IsAllDayEvent){
                vm.start_time = moment(vm.calendarEvent.start).format("MMMM Do YYYY, ") + TimeLibrary.convertTime(moment(vm.calendarEvent.start).format("HH: mm"));
                vm.end_time = moment(vm.calendarEvent.end).format("MMMM Do YYYY, ") + TimeLibrary.convertTime(moment(vm.calendarEvent.end).format("HH: mm"));
            }
        }

        vm.activate();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.contact.calendarEntry.manage')
        .controller('manageCalendarEntryController', manageCalendarEntryController);

    /** @ngInject */
    function manageCalendarEntryController(manageCalendarEntryService,$q, ToastService, blockUI, $mdDateLocale, utils, calendarEntryStatus, moment, TimeLibrary, $mdDialog, historyLogService, adminClaimsService, $state, $location, $translate) {
        var vm = this;

        vm.service = manageCalendarEntryService;
        vm.selectAll = false;
        vm.calendarEntryStatus = calendarEntryStatus;
        vm.searchText = '';
        vm.showSettings = false;
        vm.dateRangeError = '';

        vm.activate = activate;
        vm.onFilterChange = onFilterChange;
        vm.onBranchChange = onBranchChange;
        vm.onStatusChange = onStatusChange;
        vm.approveRequest = approveRequest;
        vm.rejectRequest = rejectRequest;
        vm.bulkApprove = bulkApprove;
        vm.bulkReject = bulkReject;
        vm.toggleSelectAll = toggleSelectAll;
        vm.openSettings = openSettings;
        vm.isBulkActionDisabled = isBulkActionDisabled;
        vm.getStatusDesc = getStatusDesc;
        vm.loadMore = loadMore;
        vm.fetchDate = fetchDate;
        vm.canBeSelected = canBeSelected;
        vm.dateFormat = utils.localeSettings().dateFormat;
        vm.querySearch = querySearch;
        vm.onSelectEmployee = onSelectEmployee;
        vm.onRemoveEmployee = onRemoveEmployee;
        vm.canDoBulkActions = canDoBulkActions;
        vm.viewHistory = viewHistory;

        vm.closeSettings = closeSettings;
        vm.onSettingsSaved = onSettingsSaved;
        vm.onStartDateChange = onStartDateChange;
        vm.onEndDateChange = onEndDateChange;
        vm.setLastMonth = setLastMonth;
        vm.setThisMonth = setThisMonth;
        vm.setNextMonth = setNextMonth;

        $mdDateLocale.formatDate = function(date) {
            return utils.formatToLocaleDate(date, "DD MMM YYYY");
        }

        function handlePermissionError(ex) {
            if (ex && ex.status === 403) {
                ToastService.toast($translate.instant('CALENDAR.ERRORS.NO_APPROVE_PERMISSION'));
                return true;
            }
            return false;
        }

        function activate() {

            if (!adminClaimsService.hasApproveCalendarEntries) {
                $state.go('app.pages_errors_error-403', {
                    returnUrl: encodeURIComponent($location.path())
                });
                return;
            }

            manageCalendarEntryService.isLoading = true;
            manageCalendarEntryService.loadBranches().then(function () {
                manageCalendarEntryService.fetchUnavailableCalendarEntriesCount().then(function () {
                    $q.all([
                        manageCalendarEntryService.getEmployeesbyBranchOrDivision(),
                        manageCalendarEntryService.loadUnavailableCalendarEntries()
                    ]).then(x => {
                        manageCalendarEntryService.isLoading = false;
                    })
                })
            }).then(function () {
                return manageCalendarEntryService.loadEntryTypeSettings();
            })
        }

        function canDoBulkActions() {
            return manageCalendarEntryService.filters.selectedFilter === calendarEntryStatus.PENDING;
        }

        function onBranchChange() {
            vm.searchText = '';
            manageCalendarEntryService.selectBranchFilter();
        }

        function onSelectEmployee(item)
        {
            vm.searchText = '';
            onFilterChange();
        }

        function onRemoveEmployee(item) {
            vm.searchText = '';
            onFilterChange();
        }


        function querySearch(query) {
            var results = alasql("select * from ? where Name like '" + query + "%' order by Name ASC", [manageCalendarEntryService.employees]);
            _.forEach(manageCalendarEntryService.filters.selectedEmployees, function (employee) {
                _.remove(results, function (result) {
                    return result.Id === employee.Id;
                })
            });
            return results;
        }

        function onFilterChange()
        {
            manageCalendarEntryService.isLoading = true;

            manageCalendarEntryService.resetData();

            manageCalendarEntryService.fetchUnavailableCalendarEntriesCount().then(function () {
                manageCalendarEntryService.loadUnavailableCalendarEntries().then(function () {
                    manageCalendarEntryService.isLoading = false;
                }).catch(function (ex) {
                    manageCalendarEntryService.isLoading = false;
                });

            }).catch(function (ex) {
                manageCalendarEntryService.isLoading = false;
            });
        }

        function onStatusChange() {
            manageCalendarEntryService.isLoading = true;

            manageCalendarEntryService.loadUnavailableCalendarEntries().then(function () {
                manageCalendarEntryService.isLoading = false;
            }).catch(function (ex) {
                manageCalendarEntryService.isLoading = false;
            });
        }

        function approveRequest(request) {
            blockUI.start();

            manageCalendarEntryService.approveRequest(request)
                .then(function (result) {
                    if (result.hasConflicts) {
                        blockUI.stop();
                        showConflictDialog(result.conflictingAllocations, request);
                    } else {
                        ToastService.toast('Request approved and added to calendar.');
                        blockUI.stop();
                    }
                })
                .catch(function (ex) {
                    handlePermissionError(ex);
                    blockUI.stop();
                });
        }

        function showConflictDialog(conflictingAllocations, request) {
            var listItems = conflictingAllocations.map(function (allocation) {
                var date = moment(allocation.StartDateTime).format(vm.dateFormat);
                var startTime = TimeLibrary.convertTime(moment(allocation.StartDateTime).format('HH:mm'));
                var endTime = TimeLibrary.convertTime(moment(allocation.FinishDateTime).format('HH:mm'));
                return '<li>' + date + ' - Ticket #' + allocation.TicketNumber + ' - ' + startTime + '-' + endTime + '</li>';
            }).join('');

            var htmlContent =
                '<p>This resource is currently allocated to a job for this date and time. ' +
                'Approving this unavailability request will automatically remove them from the following job(s)</p>' +
                '<ul>' + listItems + '</ul>';

            var confirm = $mdDialog.confirm()
                .title('Resource Currently Allocated')
                .htmlContent(htmlContent)
                .ariaLabel('Resource Currently Allocated')
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {
                blockUI.start();
                manageCalendarEntryService.approveRequestWithConflicts(request)
                    .then(function () {
                        ToastService.toast('Request approved and added to calendar.');
                        blockUI.stop();
                    })
                    .catch(function (ex) {
                        handlePermissionError(ex);
                        blockUI.stop();
                    });
            }, function () {

            });
        }

        function rejectRequest(request) {
            blockUI.start();

            manageCalendarEntryService.rejectRequest(request)
                .then(function () {
                    ToastService.toast('Request rejected.');
                })
                .catch(function (ex) {
                    handlePermissionError(ex);
                })
                .finally(function () {
                    blockUI.stop();
                });
        }

        function bulkApprove() {
            var selectedCount = manageCalendarEntryService.getSelectedRequests().length;

            if (selectedCount === 0) {
                ToastService.toast('Please select at least one request');
                return;
            }

            blockUI.start();

            manageCalendarEntryService.bulkApprove()
                .then(function (results) {
                    vm.selectAll = false;

                    var conflictResults = results.filter(function (r) { return r.hasConflicts; });
                    var approvedCount = results.filter(function (r) { return !r.hasConflicts; }).length;

                    if (approvedCount > 0) {
                        ToastService.toast(approvedCount + ' request(s) approved successfully');
                    }

                    if (conflictResults.length > 0) {
                        blockUI.stop();
                        showBulkConflictDialogs(conflictResults, 0);
                    } else {
                        blockUI.stop();
                    }
                })
                .catch(function (ex) {
                    handlePermissionError(ex);
                    blockUI.stop();
                });
        }

        function showBulkConflictDialogs(conflictResults, index) {
            if (index >= conflictResults.length) {
                return;
            }

            var result = conflictResults[index];
            var listItems = result.conflictingAllocations.map(function (allocation) {
                var date = moment(allocation.StartDateTime).format(vm.dateFormat);
                var startTime = TimeLibrary.convertTime(moment(allocation.StartDateTime).format('HH:mm'));
                var endTime = TimeLibrary.convertTime(moment(allocation.FinishDateTime).format('HH:mm'));
                return '<li>' + date + ' - Ticket #' + allocation.TicketNumber + ' - ' + startTime + '-' + endTime + '</li>';
            }).join('');

            var htmlContent =
                '<p><strong>' + result.request.FullName + '</strong></p>' +
                '<p>This resource is currently allocated to a job for this date and time. ' +
                'Approving this unavailability request will automatically remove them from the following job(s)</p>' +
                '<ul>' + listItems + '</ul>';

            var confirm = $mdDialog.confirm()
                .title('Resource Currently Allocated')
                .htmlContent(htmlContent)
                .ariaLabel('Resource Currently Allocated')
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {
                blockUI.start();
                manageCalendarEntryService.approveRequestWithConflicts(result.request)
                    .then(function () {
                        ToastService.toast('Request approved and added to calendar');
                    })
                    .catch(function (ex) {
                        handlePermissionError(ex);
                    })
                    .finally(function () {
                        blockUI.stop();
                        showBulkConflictDialogs(conflictResults, index + 1);
                    });
            }, function () {
                showBulkConflictDialogs(conflictResults, index + 1);
            });
        }

        function bulkReject() {
            var selectedCount = manageCalendarEntryService.getSelectedRequests().length;

            if (selectedCount === 0) {
                ToastService.toast('Please select at least one request');
                return;
            }

            blockUI.start();

            manageCalendarEntryService.bulkReject()
                .then(function () {
                    vm.selectAll = false;
                    ToastService.toast(selectedCount + ' request(s) rejected');
                })
                .catch(function (ex) {
                    handlePermissionError(ex);
                })
                .finally(function () {
                    blockUI.stop();
                });
        }

        function toggleSelectAll() {
            manageCalendarEntryService.toggleSelectAll();
        }

        function openSettings() {
            ToastService.toast('Settings coming soon');
        }

        function isBulkActionDisabled()
        {
            return manageCalendarEntryService.getSelectedRequests().length === 0;
        }

        function canBeSelected(request)
        {
            return request.Status === calendarEntryStatus.PENDING;
        }

        function getStatusDesc(status) {
            return Object.keys(calendarEntryStatus).find(
                key => calendarEntryStatus[key] === status
            )
        }

        function loadMore() {
            manageCalendarEntryService.loadUnavailableCalendarEntries();
        }

        function fetchDate(value) {
            if (!value) return 'Not Applicable';

            let formatted_date = moment(value).format(vm.dateFormat);
            let formatted_time = TimeLibrary.convertTime(moment(value).format("HH:mm"));
            return formatted_date + " - " + formatted_time;
        }

        function openSettings() {
            vm.showSettings = true;
        }

        function closeSettings() {
            vm.showSettings = false;
        }

        function onSettingsSaved(settings) {
            ToastService.toast('Settings saved successfully');
            vm.showSettings = false;
        }

        function validateDateRange() {
            vm.dateRangeError = '';
            let start = manageCalendarEntryService.filters.startDate;
            let end = manageCalendarEntryService.filters.endDate;

            if (!start || !end) return false;

            if (moment(end).isBefore(moment(start))) {
                vm.dateRangeError = 'Invalid date range.';
                manageCalendarEntryService.filters.startDate = null;
                manageCalendarEntryService.filters.endDate = null;
                return false;
            }

            let diffDays = moment(end).diff(moment(start), 'days');
            if (diffDays > 90) {
                vm.dateRangeError = 'Please enter a date range that is not more than 90 days.';
                manageCalendarEntryService.filters.startDate = null;
                manageCalendarEntryService.filters.endDate = null;
                return false;
            }

            return true;
        }

        function onStartDateChange() {
            if (!manageCalendarEntryService.filters.startDate) {
                return;
            }
            let startDate = moment(manageCalendarEntryService.filters.startDate);
            let today = moment().endOf('day');

            manageCalendarEntryService.filters.endDate = (startDate.isAfter(today) ? startDate : today).toDate();

            if (validateDateRange()) {
                onFilterChange();
            }
        }

        function onEndDateChange() {
            if (!manageCalendarEntryService.filters.startDate || !manageCalendarEntryService.filters.endDate) {
                return;
            }
            if (validateDateRange()) {
                onFilterChange();
            }
        }

        function setLastMonth() {
            vm.dateRangeError = '';
            manageCalendarEntryService.filters.startDate = moment().subtract(1, 'month').startOf('month').toDate();
            manageCalendarEntryService.filters.endDate = moment().subtract(1, 'month').endOf('month').toDate();
            onFilterChange();
        }

        function setThisMonth() {
            vm.dateRangeError = '';
            manageCalendarEntryService.filters.startDate = moment().startOf('month').toDate();
            manageCalendarEntryService.filters.endDate = moment().endOf('month').toDate();
            onFilterChange();
        }

        function setNextMonth() {
            vm.dateRangeError = '';
            manageCalendarEntryService.filters.startDate = moment().add(1, 'month').startOf('month').toDate();
            manageCalendarEntryService.filters.endDate = moment().add(1, 'month').endOf('month').toDate();
            onFilterChange();
        }
        function viewHistory(request) {
            historyLogService.showHistoryLogV2([request.Id], request.FullName);
        }

        vm.activate();
    }
})();


(function () {
  'use strict';

  angular
    .module('app.contact.calendarEntry.add', [])

})();

(function () {
    'use strict';

    angular
        .module('app.contact.calendarEntry.add')
        .controller('addContactCalendarController', addContactCalendarController);

    /** @ngInject */
    function addContactCalendarController(TimeLibrary, $scope, $injector, $timeout, hubService, contactApi, blockUI, exceptionService, ToastService, contactCalendarModel) {
        var vm = this;
        vm.repeat = [];
        vm.recurring = false;
        vm.hasSelected = true;
        vm.hasSelectedContact = true;
        vm.dayInWeek = [1, 2, 3, 4, 5, 6, 0];
        vm.divisions = [];
        vm.Divisions = [];
        vm.employees = [];
        vm.Employees = [];
        vm.branches = [];
        vm.RepeatEvery = [];
        vm.selectedItem = null;
        vm.searchText = null;
        vm.EntryType = null;

        vm.getDivisionByBranches = getDivisionByBranches;
        vm.getEmployeesbyBranchOrDivision = getEmployeesbyBranchOrDivision;
        vm.convertToDayName = convertToDayName;
        vm.convertToRepeatTypeValue = convertToRepeatTypeValue;
        vm.querySearch = querySearch;
        vm.activate = activate;
        vm.bulkSave = bulkSave;
        vm.onRepeatOn = onRepeatOn;
        vm.onSelectRepeatType = onSelectRepeatType;
        vm.goToContactView = goToContactView;
        vm.showEndDate = showEndDate;
        vm.onSelectOption = onSelectOption;
        vm.processDependency = processDependency;
        vm.computeEndDate = computeEndDate;
        vm.validateDate = validateDate;

        function getDateDiff(date1, date2) {
            let dt1 = new Date(date1);
            let dt2 = new Date(date2);
            return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
        }

        function validateDate(date_type) {
            if (vm.showTheEndDate) {
                if (!_.isNil(vm.start) && !_.isNil(vm.end)) {
                    let diff = getDateDiff(vm.start, vm.end);
                    if (diff < 0) {
                        hubService.showToast('The job end date must be on or after the job start date');
                        if (date_type === 'start') {
                            vm.start = null;
                        } else {
                            vm.end = null;
                        }
                    }
                }
            }
        }

        function convertToDayName(code) {
            switch (code) {
                case 0:
                    return "Sunday";
                case 1:
                    return "Monday";
                case 2:
                    return "Tuesday";
                case 3:
                    return "Wendesday";
                case 4:
                    return "Thursday";
                case 5:
                    return "Friday";
                case 6:
                    return "Saturday";
                default:
                    break;
            }
        }

        function convertToRepeatTypeValue(id) {
            switch (id) {
                case 0:
                    return "Day/s";
                case 1:
                    return "Week/s";
                case 2:
                    return "Month/s";
                default:
                    break;
            }
        }

        vm.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }

            if (list.length > 0) {
                vm.hasSelected = true;
                vm.Repeats.RepeatsOn = list;
            } else {
                vm.hasSelected = false;
            }
        };

        vm.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };

        vm.isIndeterminate = function () {
            return (vm.repeat.length !== 0 &&
                vm.repeat.length !== vm.dayInWeek.length);
        };

        vm.isChecked = function () {
            return vm.repeat.length === vm.dayInWeek.length;
        };

        vm.toggleAll = function () {
            if (vm.repeat.length === vm.dayInWeek.length) {
                vm.repeat = [];
            } else if (vm.repeat.length === 0 || vm.repeat.length > 0) {
                vm.repeat = vm.dayInWeek.slice(0);
            }

            if (vm.repeat.length > 0) {
                vm.hasSelected = true;
                vm.Repeats.RepeatsOn = vm.repeat;
            } else {
                vm.hasSelected = false;
            }
        };

        function activate() {
            blockUI.start();
            var i = 1;
            for (i = 1; i <= 30; i++) {
                vm.RepeatEvery.push(i);
            }
            getBranches().then(function () {
                getRepeatType().then(function () {
                    getEntryType().then(function () {
                        blockUI.stop();
                    })
                })
            })
            vm.dateTimeRangeOption = true;
        }

        function getBranches() {
            return contactApi.getBranches().then(function (resp) {
                vm.Branches = resp.data
            }).catch(function (ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }

        function getRepeatType() {
            return contactApi.getRepeatType().then(function (resp) {
                vm.RepeatTypeLookup = resp.data;
            }).catch(function (ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }

        function getEntryType() {
            return contactApi.getEntryType().then(function (resp) {
                vm.EntryTypeLookup = resp.data;
            }).catch(function (ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }


        function getDivisionByBranches(branches) {
            vm.Divisions.splice(0);
            if (branches) {
                var Branches = angular.copy(vm.Branches)
                var selectedDivisions = angular.copy(vm.divisions);
                vm.divisions.splice(0);
                angular.forEach(Branches, function (branch) {
                    angular.forEach(branches, function (_branch) {
                        if (branch.Id === _branch.Id && branch.Division.length > 0) {
                            angular.forEach(branch.Division, function (division) {
                                division.branchName = _branch.Name;
                                vm.Divisions.push(division);
                            });
                            angular.forEach(selectedDivisions, function (division) {
                                if (_branch.Name === division.branchName)
                                    vm.divisions.push(division);
                            });
                        }
                    });
                });

                getEmployeesbyBranchOrDivision(branches);
            } else {
                vm.employees.splice(0);
                vm.EntryType = null;
                vm.allDayOption = false;
                vm.repeatPeriodOption = false;
                vm.recurring = false;
                vm.Repeats = null;
            }
        }

        function getBranchAndDivisionIds() {
            blockUI.start();
            var ids = null;
            var branchIds = [];
            var divisionIds = [];

            angular.forEach(vm.branches, function (branch) {
                branchIds.push(branch.Id);
            });

            angular.forEach(vm.divisions, function (division) {
                divisionIds.push(division.id);
            });

            return ids = {
                branches: branchIds,
                divisions: divisionIds
            }
        }

        function getEmployeesbyBranchOrDivision(param) {
            if (param) {
                if (param.length > 0) {
                    vm.Employees.splice(0)
                    var ids = getBranchAndDivisionIds();
                    var payload = {
                        m_Item1: ids.branches,
                        m_Item2: ids.divisions
                    }

                    contactApi.getEmployeesByBranchOrDivision(payload).then(function (resp) {
                        vm.Employees = resp.data;
                        if (vm.employees.length > 0) {
                            let employees = angular.copy(vm.employees);
                            let Employees = angular.copy(vm.Employees);
                            vm.employees = [];
                            vm.employees = _.flatten(
                                _.map(
                                    Employees,
                                    function (employee) {
                                        return _.filter(employees, employee);
                                    }
                                )
                            );
                        }

                        blockUI.stop();
                    }).catch(function (ex) {
                        exceptionService.resolve(ex);
                        blockUI.stop();
                    });
                }
            }
        }

        function querySearch(query) {
            var results = alasql("select * from ? where Name like '" + query + "%' order by Name ASC", [vm.Employees]);
            _.forEach(vm.employees, function (employee) {
                _.remove(results, function (result) {
                    return result.Id === employee.Id;
                })
            });
            return results;
        }

        function bulkSave() {
            var contactCalendar = new contactCalendarModel();
            var payload = {
                EntryType: vm.EntryType,
                EntryReason: vm.EntryReason,
                Remarks: vm.Remarks,
                contactId: getEmployeeIds(),
                start: vm.start,
                startTime: vm.startTime,
                end: vm.end,
                endTime: vm.endTime,
                repeat: vm.Repeats,
                IsAllDayEvent: vm.allDayOption
            }

            contactCalendar.map(payload);
            var transformContactCalendar = contactCalendar.transformToServerModel();
            contactApi.saveContactCalendar(transformContactCalendar).then(function () {
                ToastService.toast("Contacts Calendar Events Created");
                clearFields();
                $timeout(function () {
                    $scope.bulkCreateCalendar.$setUntouched();
                }, 1000);
            }).catch(function (e) {
                blockUI.stop();
                exceptionService.resolve(e);
            });
        }

        function getEmployeeIds() {
            var employeeIds = [];

            angular.forEach(vm.employees, function (employee) {
                employeeIds.push(employee.Id);
            });

            return employeeIds;
        }

        function onRepeatOn() {
            vm.hasSelected = true;
        }

        function onSelectRepeatType() {
            if (vm.Repeats.RepeatType === 1) {
                vm.hasSelected = false;
                getSelectedDateDOW(vm.start);
            } else {
                vm.hasSelected = true;
            }
        }

        function goToContactView() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.contact_view');
        }

        function clearFields() {
            vm.branches.splice(0);
            vm.divisions.splice(0);
            vm.employees.splice(0);
            vm.EntryType = null;
            vm.start = null;
            vm.startTime = null;
            vm.end = null;
            vm.endTime = null;
            vm.recurring = false;
            vm.Repeats = null;
            vm.repeat.splice(0);
            vm.repeatPeriodOption = false;
            vm.allDayOption = false;
            vm.dateTimeRangeOption = true;

        }

        function showEndDate() {
            if (vm.showTheEndDate) {
                vm.showTheEndDate = false;
            } else {
                vm.showTheEndDate = true;
            }
        }

        function onSelectOption(from) {
            if (from === 'Date/Time Range') {
                vm.allDayOption = false;
                vm.repeatPeriodOption = false;
                vm.recurring = false;
                vm.dateTimeRangeOption = true;
                vm.Repeats = null;
            }

            if (from === 'All Day') {
                vm.dateTimeRangeOption = false;
                vm.repeatPeriodOption = false;
                vm.recurring = false;
                vm.allDayOption = true;
                vm.Repeats = null;
            }

            if (from === 'Repeat Period') {
                vm.dateTimeRangeOption = false;
                vm.allDayOption = false;
                vm.recurring = false;
                vm.Repeats = {
                    RepeatType: 1,
                    RepeatsOn: []
                };
                vm.repeatPeriodOption = true;
            }

            if (from === 'Repeat in Specific Day') {
                vm.dateTimeRangeOption = false;
                vm.allDayOption = false;
                vm.repeatPeriodOption = false;
                onRepeatOn();
                getSelectedDateDOW(vm.start);
                vm.recurring = true;
            }
        }

        function getSelectedDateDOW(date) {
            if (vm.Repeats) {
                if (vm.Repeats.RepeatType === 1 && !vm.repeatPeriodOption) {
                    vm.repeat.splice(0);
                    var dow = moment(date).day();
                    vm.repeat.push(dow);
                    if (vm.repeat.length > 0) {
                        vm.hasSelected = true;
                        vm.Repeats.RepeatsOn = vm.repeat;
                    }
                }
            }
        }

        function processDependency(date) {
            getSelectedDateDOW(date);
            vm.computeEndDate();
        }

        function computeEndDate(time_type) {
            if (!vm.end) {
                if (vm.start) {
                    vm.end = vm.start;
                }
            }

            if ((!vm.startTime || !vm.endTime) && vm.end < vm.start) {
                if (vm.start) {
                    vm.end = vm.start;
                }
            }

            if (vm.startTime && vm.endTime) {
                if (vm.end < vm.start) {
                    if (vm.start) {
                        vm.end = vm.start;
                    }
                }

                if (moment(moment(vm.end).format('YYYY-MM-DD' + ' ' + vm.endTime)) <=
                    moment(moment(vm.start).format('YYYY-MM-DD' + ' ' + vm.startTime))) {
                }

                if (vm.end < vm.start) {
                    if (vm.start) {
                        vm.end = vm.start;
                    }
                }

                if (moment(moment(vm.end).format('YYYY-MM-DD' + ' ' + TimeLibrary.convertToServerTime(vm.endTime))) <=
                    moment(moment(vm.start).format('YYYY-MM-DD' + ' ' + TimeLibrary.convertToServerTime(vm.startTime)))) {
                }
            }

            if (!vm.allDayOption) {
                let start_time = moment();
                let end_time = moment();
                if (!_.isNil(vm.startTime) && !_.isNil(vm.endTime)) {
                    start_time.set({
                        hour: getHour(vm.startTime),
                        minute: getMinute(vm.startTime)
                    });
                    end_time.set({
                        hour: getHour(vm.endTime),
                        minute: getMinute(vm.endTime)
                    });
                    let diff = end_time.diff(start_time, 'minutes');
                    if (diff < 0) {
                        hubService.showToast('The job start time must be before job end time');
                        if (time_type === 'start') {
                            vm.startTime = null;
                        } else {
                            vm.endTime = null;
                        }
                    }
                }
            }
        }

        vm.activate();

        function getHour(time_string) {
            time_string = time_string.replace(" ", "");
            let index = time_string.indexOf(":");
            let result = time_string.substring(0, index);
            result = result.replace(" ", "");
            return parseInt(result);
        }

        function getMinute(time_string) {
            time_string = time_string.replace(" ", "");
            let index = time_string.indexOf(":");
            let result = time_string.substring(index + 1);
            result = result.replace(" ", "");
            return parseInt(result);
        }
    }
})();

/**
 * Cost Estimate View module
 * Created date: 12.12.2016
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.view', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.cost_estimate_view', {
            url: '/costEstimate/view',
            views: {
                'content@app': {
                    templateUrl: 'app/main/costEstimate/view/ce-list-view.html',
                    controller: 'CeListViewController as invPdfViewVm' 
                }
            },

            data: { requireLogin: true },
            resolve: {
                branchData: branchResolver
            },
           title: 'View Cost Estimates',
           titleBar: 'Alloc8 - View Cost Estimates'
        });

        $translatePartialLoaderProvider.addPart('app/main/costEstimate');
    };

    /** @ngInject */
    function branchResolver(ceFilterService) {
        return ceFilterService.loadLookups();
    }

})();

/**
 * Report filter component
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.view')
        .directive('ceReportFilterComponent', ceReportFilterComponent);

    /** @ngInject */
    function ceReportFilterComponent($mdDialog, exceptionService, ceFilterService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/costEstimate/view/directive/ce-report-filter/ce-report-filter.html',
            scope: {},
            controller: CeReportFilterController,
            controllerAs: 'invReportFilterVm',
            bindToController: true
        };

        return directive;

        function CeReportFilterController($mdDialog) {
            var vm = this;

            vm.showDatesFilter = showDatesFilter;
            vm.model = ceFilterService;
            vm.applyFilter = applyFilter;
            vm.resetFilter = resetFilter;

            activate();

            ///////
            function activate() {}

            function showDatesFilter() {
                $mdDialog.show({
                    templateUrl: 'app/main/costEstimate/view/ce-date-chooser/ce-date-chooser.html',
                    controller: 'CeDateChooserController as vm'
                }).then(function(resp) {
                    if (resp !== 'cancel')
                    ceFilterService.applyFilter();
                });
            }

            function applyFilter() {
                ceFilterService.applyFilter();
            }

            function resetFilter() {
                ceFilterService.reset();
            }
        }
    }
})();
/**
 * Cost Estimate winlost service
 *
 * Rcnet 4.30.2018
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('winLostService', winLostService);

    /** @ngInject */
    function winLostService($log,
        $q,
        utils,
        exceptionService,
        moment,
        $mdToast,
        winlostModel
        ) {

        var service = {
            data: new  winlostModel()
        };

        activate();

        return service;

        ///////
        function activate() {}

    }
})();

/**
 * Cost Estimate winlost service
 *
 * Rcnet 4.30.2018
 */
(function () {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('winLostLookupService', winLostLookupService);

    /** @ngInject */
    function winLostLookupService($log,
        $q,
        utils,
        exceptionService,
        moment,
        $mdToast,
        costEstimateApi
    ) {

        var service = {
            lostStates: [],
            winningCompanies: [],
            winningCompetitors: [],
            loadLookups: loadLookups,
            getWinningCompanies: getWinningCompanies,
            getWinningCompetitors: getWinningCompetitors
        };

        activate();

        return service;

        ///////
        function activate() { }

        function loadLookups() {
            // Load lost states
            let promise1 = getLostStates();

            return $q.all([promise1]);
        }

        function getLostStates() {
            let deferred = $q.defer();
            service.lostStates.length = 0;
            costEstimateApi.getLostStates()
                .then(function (resp) {
                    angular.forEach(resp.data, function(itm) {
                        service.lostStates.push(itm);
                    });
                    deferred.resolve(service.lostStates);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function getWinningCompanies(id) {
            let deferred = $q.defer();
          
            service.winningCompanies.length = 0;
            costEstimateApi.getWinningCompanies(id)
                .then(function (resp) {
                    angular.forEach(resp.data, function (itm) {
                        service.winningCompanies.push(itm);
                    });

                    deferred.resolve(service.winningCompanies);
                })
                .catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function getWinningCompetitors(id) {
            let deferred = $q.defer();
            
            service.winningCompetitors.length = 0;
             costEstimateApi.getWinningCompetitors(id)
                .then(function (resp) {
                    angular.forEach(resp.data, function (itm) {
                        service.winningCompetitors.push(itm);
                    });

                    deferred.resolve(service.winningCompetitors);
                })
                .catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

    }
})();

/**
 * Mark as Lost service
 *
 * Rcnet 5.2.2018
 */
(function () {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('markAsLostService', markAsLostService);

    /** @ngInject */
    function markAsLostService($log,
        $q,
        $mdDialog,
        utils,
        exceptionService,
        moment,
        $mdToast,
        winlostModel,
        winLostLookupService,
        ceGroupInfoService
    ) {

        var service = {
            showWinLostDialog: showWinLostDialog
        };

        activate();

        return service;

        ///////
        function activate() {
        }

        function showWinLostDialog() {
            let deferred = $q.defer();

            getSource(ceGroupInfoService.data.BranchId)
                .then(function (resp) {

                    $mdDialog.show({
                        templateUrl: 'app/main/costEstimate/preview/winlost/win-lost-dialog.html',
                        controller: 'WinlostDialogController',
                        controllerAs: 'vm',
                        locals: {
                            winningCompanies: resp[0],
                            competitors: resp[1],
                            lostStates: winLostLookupService.lostStates,
                            branchId: ceGroupInfoService.data.BranchId,
                            branchName: ceGroupInfoService.data.BranchName,
                            reloadWinningCompetitorLookups: reloadWinningCompetitorLookups  // Callback for refreshing the lookup
                        },
                        multiple: true
                    }).then(function (resp) {
                        deferred.resolve(resp);
                    }, function (resp) {
                        deferred.resolve(resp);
                    });
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                });

            return deferred.promise;
        }

        function getSource(branchId) {
            let promise1 = winLostLookupService.getWinningCompanies(branchId);
            let promise2 = winLostLookupService.getWinningCompetitors(branchId);

            return $q.all([promise1, promise2]);
        }

        /**
         * Reloading logic
         */
        function reloadWinningCompetitorLookups() {
            let deferred = $q.defer();
            winLostLookupService.getWinningCompetitors(ceGroupInfoService.data.BranchId)
                .then(function (resp) {
                    deferred.resolve(resp);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });
            return deferred.promise;
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('winlostModel', winlostModel)

    function winlostModel(alasql, utils) {
        return function() {
            var self = this,
                defaults = {
                    costEstimateGroupId: null,
                    selectedLostStatus: null,
                    winningCompany: null,
                    winningCompetitor: null,
                    winningAmount: null,
                    lostReason: null,
                    showWinningCompany: false,
                    showCompetitor: false
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.recomputeModel = recomputeModel;
            self.map();
            
            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                //self.selectedBranches.length = 0;
            }

            function recomputeModel() {
                self.showCompetitor = false;
                self.showWinningCompany = false;

                if (self.selectedLostStatus.Id == 4)
                    self.showWinningCompany = true;
                else if (self.selectedLostStatus.Id != 4)
                    self.showCompetitor = true;
            }

            function transformToModel() {
                // Collect item types
                let prm = {
                    CostEstimateGroupId: null,
                    LostStatus: null,
                    WinningCompanyId: null,
                    WinningCompetitorId: null,
                    WinningAmount: null,
                    LostReason: null
                };

                prm.CostEstimateGroupId = self.costEstimateGroupId;
                prm.LostStatus = self.selectedLostStatus.Id;
                prm.WinningCompanyId = self.winningCompany && self.winningCompany.Id || null;
                prm.WinningCompetitorId = self.winningCompetitor && self.winningCompetitor.Id || null;
                prm.WinningAmount = _.isNil(self.winningAmount) ? 0 : self.winningAmount;
                prm.LostReason = self.lostReason;

                return prm;
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('competitorModel', competitorModel)

    function competitorModel(alasql, utils) {
        return function() {
            var self = this,
                defaults = {
                   companyName: null,
                   selectedBranches: []
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();
            
            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.selectedBranches.length = 0;
            }

            function transformToModel() {
                // Collect item types
                let prm = {
                    Name: self.companyName,
                    Branches: []
                };
                
                angular.forEach(self.selectedBranches, function(resp) {
                    let branch = {
                        Id: resp.Id,
                        Name: resp.Name,
                        State: resp.State
                    };
                    prm.Branches.push(branch);
                });

                return prm;
            }
        }

    }
})();
/**
 * by Rcnet
 * 4.30.2018
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .controller('CreateCompetitorDialogController', CreateCompetitorDialogController);

    /** @ngInject */
    function CreateCompetitorDialogController(
        $mdDialog,
        $rootScope,
        $q,
        $translate,
        $stateParams,
        exceptionService,
        companyCompetitorApi,
        competitorModel,
        blockUI,
        locals) {
        var vm = this;
        // Data
        vm.branchesLookup = [];
        vm.inputModel = new competitorModel();

        // Events
        vm.onCancel = onCancel;
        vm.onUpdate = onUpdate;

        activate();

        ///////
        function activate() {
            if (locals == null) alert('Locals should be set.');

            // // Populate lookups
            angular.forEach(locals.branches, function (item) {
                vm.branchesLookup.push(item);
            });
        }

        function onCancel() {
            $mdDialog.hide('cancel');
        }

        function onUpdate() {
            blockUI.start('Creating new Company Competitor...');
            let payload = vm.inputModel.toBackendModel();
            companyCompetitorApi.createCompetitor(payload)
                .then(function (resp) {
                    blockUI.stop();
                    $mdDialog.hide(resp.data);
                }).catch(function (ex) {
                    blockUI.stop();
                });
        }

    }
})();

/**
 * By rcnet copied from Ben Rei create job
 */
(function () {
  'use strict';

  angular.module('app.costEstimate.view')
    .directive('companySelectComponent', companySelectComponent);

  /** @ngInject */
  function companySelectComponent($mdDialog, $timeout, companyApi, $q, blockUI) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/costEstimate/preview/winlost/company-select/company-select.html',
      scope: {
        ngModel: '=',
        label: '=',
        allowAdd: '@',
        preSelect: '=',
        onSelectCompany: '&',
        onCreateCompetitor: '&'
      },
      controller: companySelectController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function companySelectController() {
      var vm = this;

      vm.reload = false;
      vm.selectedCompany = null;
      vm.searchText = null;
      vm.minlength = 300;
      vm.client = null;
      vm.minlength = 50;
      vm.labelCaption = null;
      vm.showControl = false;

      // Events
      vm.querySearch = querySearch;
      vm.selectedItemChange = selectedItemChange;
      vm.createCompetitor = createCompetitor;
      

      ///////
      activate();

      // ==========================
      // Internal methods
      // ==========================
      function activate() {
        vm.labelCaption = vm.label;

        // Workaround to remove flashing of md-autocomplete control
        $timeout(function() {
          vm.showControl = true;
        }, 100);
      }

      function querySearch(query) {
        var results = query ? vm.ngModel.filter(createFilterFor(query)) : vm.ngModel;
        return results;
      }

      /**
    * Create filter function for a query string
    */
      function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(company) {
          return (angular.lowercase(company.Name).indexOf(lowercaseQuery) === 0);
        };
      }

      /**
       * Fire output to consumer of component
       * @param {*} item 
       */
      function selectedItemChange(item) {
        (vm.onSelectCompany || angular.noop)({ item: item });
      }

      function createCompetitor() {
        (vm.onCreateCompetitor || angular.noop)();
      }

    }
  }
})();

/**
 * Grid Information Component
 */
(function () {
    'use strict';

    angular.module('app.costEstimate.preview')
        .directive('ceCustomGridInfoComponent', ceCustomGridInfoComponent);

    /** @ngInject */
    function ceCustomGridInfoComponent(ceStateService) {
        var directive = {
            restrict: 'E',
            scope: {
                srcData: '=',
                status: '=',
                statusText: '=',
                viewCancelled: '='
            },
            templateUrl: 'app/main/costEstimate/preview/directives/customGridInfo/ce-custom-grid-info.html',
            controller: CostEstimateCustomGridInfoController,
            controllerAs: 'customGridInfoVm',
            bindToController: true
        };

        return directive;

        function CostEstimateCustomGridInfoController() {
            var vm = this;

            // Event
            vm.getStatusColor = getStatusColor;

            ///////
            function getStatusColor(status) {
               return status; //ceStateService.getStatusColor(status);
            }
        }

    }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CostEstimateItem = function (_React$Component) {
    _inherits(CostEstimateItem, _React$Component);

    function CostEstimateItem() {
        _classCallCheck(this, CostEstimateItem);

        var _this = _possibleConstructorReturn(this, (CostEstimateItem.__proto__ || Object.getPrototypeOf(CostEstimateItem)).call(this));

        _this.editInvoice = _this.editInvoice.bind(_this);
        _this.downloadInvoice = _this.downloadInvoice.bind(_this);
        _this.deleteInvoice = _this.deleteInvoice.bind(_this);
        _this.editTicket = _this.editTicket.bind(_this);
        _this.editTimeSheet = _this.editTimeSheet.bind(_this);
        _this.markAsReviewed = _this.markAsReviewed.bind(_this);
        _this.setAsPrimary = _this.setAsPrimary.bind(_this);
        return _this;
    }

    _createClass(CostEstimateItem, [{
        key: 'setAsPrimary',
        value: function setAsPrimary(id) {
            this.props.onsetasprimary(id);
        }
    }, {
        key: 'editInvoice',
        value: function editInvoice(id, e) {
            if (!this.props.isfinalised) this.props.oneditinvoice(id);else e.preventDefault();
        }
    }, {
        key: 'downloadInvoice',
        value: function downloadInvoice(invoiceId) {
            this.props.ondownloadinvoice(invoiceId);
        }
    }, {
        key: 'deleteInvoice',
        value: function deleteInvoice(id) {
            this.props.ondeleteinvoice(id);
        }
    }, {
        key: 'editTicket',
        value: function editTicket(id, ticketNo, invId) {
            this.props.oneditticket(id, ticketNo, invId);
        }
    }, {
        key: 'editTimeSheet',
        value: function editTimeSheet(id, invId) {
            this.props.onedittimesheet(id, invId);
        }
    }, {
        key: 'markAsReviewed',
        value: function markAsReviewed(invId, e) {
            this.props.onmarkasreviewed(invId, e.target.checked);
        }

        /**
         * --------------------------------------
         * Utilities here
         * TODO: Create a reusable react utility
         * --------------------------------------
         */

    }, {
        key: 'epochToJsDateTime',
        value: function epochToJsDateTime(unixtime, format) {
            var fmt = format ? format : 'YYYY/MM/DD hh:mm:ss';
            if (unixtime === -2147483648 || !unixtime) return null;

            // Apply server date format 'MM/DD/YYYY HH:mm' together with Unix time
            var dt = moment(moment.unix(unixtime), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
            return format ? moment(dt).format(fmt) : moment(dt).toDate();
        }
    }, {
        key: 'moneyFormat',
        value: function moneyFormat(number, decimalPlaces) {
            var parsedNumber = number;
            var isNegative = number < 0;

            var decimalPadding = function decimalPadding() {
                var tNum = ".";
                if (decimalPlaces > 0) {
                    for (var i = 0; i < decimalPlaces; i++) {
                        tNum += "0";
                    }
                } else {
                    tNum += "00";
                }
                return tNum;
            };

            if (!number || isNaN(number)) return "0" + decimalPadding();

            if (decimalPlaces > 0) {
                parsedNumber = number.toFixed(decimalPlaces);
            }

            var arr = parsedNumber.toString().split('.');

            var result = arr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            result += arr.length > 1 ? "." + arr[1] : decimalPadding();

            return result;
        }
    }, {
        key: 'jsDateTime',
        value: function jsDateTime(date) {
            if (date == '' || date == undefined || date == null || moment(date).format('DD MMM YYYY').toUpperCase() == '01 JAN 1900') {
                return "";
            }
            return moment(date).format(this.props.dateformat).toUpperCase();
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            var statusStyle = void 0;
            var tableStyle = void 0;
            var descriptionValuePlaceholder = void 0;

            statusStyle = {
                color: '#fff'
            };

            tableStyle = {
                width: '100%',
                minWidth: '100%'
            };

            /**
             * Create invoice body
             */
            var createInvoiceBody = function createInvoiceBody(lineItem) {
                var lineItemPartial = void 0;
                var isNonChargeableEntry = !lineItem.Description.includes('Ticket') && (!lineItem.Description || lineItem.Description.toUpperCase() == 'SUPPLY OF TRAFFIC CONTROLLERS AT' || lineItem.Quantity == 0 && lineItem.UnitPriceExcludingTax <= 0 || lineItem.Description.includes('Authorised By'));

                if (lineItem.TicketId != null && lineItem.Description.includes('Ticket')) {
                    lineItemPartial = React.createElement(
                        'tr',
                        { key: lineItem.Id },
                        React.createElement(
                            'td',
                            { colSpan: '5' },
                            React.createElement(
                                'strong',
                                null,
                                lineItem.Description
                            )
                        )
                    );
                } else if (isNonChargeableEntry) {

                    var descriptionEmptyValue = "";
                    if (!lineItem.Description) {
                        descriptionEmptyValue = ' '.replace(/ /g, '\xA0');
                    }

                    var timein24HourFormat = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/; // Shift hours
                    var phoneNumberFormat = /^[0-9 ]+$/;

                    var isAnAddressLine = lineItem.Description && lineItem.Description.toUpperCase() != 'SUPPLY OF TRAFFIC CONTROLLERS AT' && !lineItem.Description.substring(0, 5).match(timein24HourFormat) && !lineItem.Description.includes('Authorised By') && !lineItem.Description.match(phoneNumberFormat);

                    var _descriptionValuePlaceholder = isAnAddressLine ? React.createElement(
                        'strong',
                        null,
                        lineItem.Description
                    ) : descriptionEmptyValue ? descriptionEmptyValue : lineItem.Description;

                    lineItemPartial = React.createElement(
                        'tr',
                        { key: lineItem.Id },
                        React.createElement(
                            'td',
                            { colSpan: '5' },
                            _descriptionValuePlaceholder
                        )
                    );
                } else {
                    var amount = 0;

                    var tax = parseFloat(lineItem.UnitPriceExcludingTax) * parseFloat(lineItem.Quantity) * (lineItem.TaxRate / 100);
                    amount = parseFloat(lineItem.UnitPriceExcludingTax) * parseFloat(lineItem.Quantity);

                    var amt = self.moneyFormat(amount, 2);
                    var unitPriceExcludingTax = self.moneyFormat(parseFloat(lineItem.UnitPriceExcludingTax), 2);

                    lineItemPartial = React.createElement(
                        'tr',
                        { key: lineItem.Id },
                        React.createElement(
                            'td',
                            null,
                            lineItem.Description
                        ),
                        React.createElement(
                            'td',
                            { className: 'text-right' },
                            lineItem.Quantity
                        ),
                        React.createElement(
                            'td',
                            { className: 'text-right' },
                            '$',
                            unitPriceExcludingTax
                        ),
                        React.createElement(
                            'td',
                            { className: 'text-right' },
                            '$',
                            amt
                        )
                    );
                }

                return lineItemPartial;
            };

            function removeExtraBreakLine(lineItems) {
                var maxBreakLine = 1;
                var currentBreakLine = [];

                return lineItems.filter(function (s) {
                    var Description = s.Description;

                    if (!Description) {
                        if (currentBreakLine.length >= maxBreakLine) {
                            return false;
                        }
                        currentBreakLine.push(!0);
                    } else {
                        currentBreakLine = [];
                    }

                    return true;
                });
            }

            function getStatus(id) {
                switch (id) {
                    case 1:
                        return 'Preview';
                    case 2:
                        return 'Finalized';
                }
            }

            /**
             * Creation Invoice Item
             */
            var createInvoiceItem = function createInvoiceItem(invoice) {
                var uid = _.uniqueId('invoice');
                var ticketDetailsUid = _.uniqueId('invoiceDetails');
                var totalTax = self.moneyFormat(parseFloat(invoice.TotalTax), 2);
                var subTotal = self.moneyFormat(parseFloat(invoice.TotalExcludingTax), 2);
                var grandTotal = self.moneyFormat(parseFloat(invoice.TotalIncludingTax), 2);
                var taxes = invoice.InvoiceTaxes == null ? [] : invoice.InvoiceTaxes.map(function (x) {
                    return {
                        Name: x.Name,
                        Rate: x.Rate,
                        TotalTaxApplied: self.moneyFormat(parseFloat(x.TotalTaxApplied), 2)
                    };
                });

                // Surcharges come from the snapshot stored on this estimate version (stable across rate card
                // changes) and render like the interpreted invoice: rows before "Authorised By" in the table,
                // plus summary rows between SUBTOTAL and TAXABLE AMOUNT. Subtotal stays = Sum(LineItems).
                var surchargeLines = (invoice.SurchargeLineItems || []).map(function (s, i) {
                    return {
                        SurchargeId: s.SurchargeId,
                        // Vehicle surcharges share one SurchargeId across vehicles; add type + index for unique keys.
                        Key: s.SurchargeId + '-' + (s.VehicleTypeItemId || '') + '-' + i,
                        Description: s.Description,
                        Amount: self.moneyFormat(parseFloat(s.Amount), 2)
                    };
                });
                var hasSurcharges = surchargeLines.length > 0;

                var rawLineItems = removeExtraBreakLine(invoice.LineItems || []);
                var authorisedByIndex = rawLineItems.findIndex(function (li) {
                    return li && li.Description && li.Description.indexOf('Authorised By') !== -1;
                });
                var lineItemsBeforeAuth = authorisedByIndex >= 0 ? rawLineItems.slice(0, authorisedByIndex) : rawLineItems;
                var lineItemsFromAuth = authorisedByIndex >= 0 ? rawLineItems.slice(authorisedByIndex) : [];
                // TAXABLE AMOUNT row only when surcharges exist so pre-feature estimates render byte-identically.
                var taxableAmount = invoice.TaxableAmount != null ? self.moneyFormat(parseFloat(invoice.TaxableAmount), 2) : subTotal;

                var invoiceProjectPartial = void 0;
                var ticketDetailsPartial = void 0;
                var invoiceSpinnerPartial = void 0;
                var primaryPartial = void 0;
                var editCostEstimatePartial = void 0;
                var deleteCostEstimatePartial = void 0;
                var markAsReviewPartial = void 0;
                var costEstimatePdfDownloadIcon = void 0;

                // -------------------------
                // Invoice Footer Partial
                // -------------------------
                var invDetailFooterPartial = React.createElement(
                    'table',
                    { className: 'simple invoice-table-footer', style: tableStyle },
                    React.createElement(
                        'tbody',
                        null,
                        React.createElement(
                            'tr',
                            { className: 'subtotal' },
                            React.createElement(
                                'td',
                                null,
                                'SUBTOTAL'
                            ),
                            React.createElement(
                                'td',
                                null,
                                '$',
                                subTotal
                            )
                        ),
                        surchargeLines.map(function (s) {
                            return React.createElement(
                                'tr',
                                { key: s.Key, className: 'surcharge' },
                                React.createElement(
                                    'td',
                                    null,
                                    s.Description
                                ),
                                React.createElement(
                                    'td',
                                    null,
                                    '$',
                                    s.Amount
                                )
                            );
                        }),
                        hasSurcharges && React.createElement(
                            'tr',
                            { className: 'taxable-amount' },
                            React.createElement(
                                'td',
                                null,
                                'TAXABLE AMOUNT'
                            ),
                            React.createElement(
                                'td',
                                null,
                                '$',
                                taxableAmount
                            )
                        ),
                        createTaxRow(taxes, totalTax),
                        React.createElement(
                            'tr',
                            { className: 'total' },
                            React.createElement(
                                'td',
                                null,
                                'TOTAL'
                            ),
                            React.createElement(
                                'td',
                                null,
                                '$',
                                grandTotal
                            )
                        )
                    )
                );

                // -------------------------
                //  Ticket details partial
                // -------------------------
                if (self.props.showdetails) {
                    var resourceResults = invoice.ResourceInformation;
                    ticketDetailsPartial = React.createElement(CeTicketDetails, { key: ticketDetailsUid, ticketlist: resourceResults });
                }

                // Project field
                if (invoice.Project != null) {
                    if (invoice.Project.length > 0) {
                        invoiceProjectPartial = React.createElement(
                            'span',
                            null,
                            '- ',
                            invoice.Project
                        );
                    }
                }

                // Invoice progress spinner
                if (invoice.IsBusy) {
                    invoiceSpinnerPartial = React.createElement(
                        'div',
                        { className: 'react-linear-activity' },
                        React.createElement('div', { className: 'react-indeterminate' })
                    );
                } else {
                    invoiceSpinnerPartial = null;
                }

                // IsPrimary CostEstimate
                if (invoice.IsPrimary) {
                    primaryPartial = React.createElement(
                        'span',
                        { className: 'margin-left-2 md-ink-ripple custom-tooltip margin-right-10' },
                        React.createElement('i', { className: 'icon-star yellow-700-fg s18 padding-bottom-0 margin-bottom-0 not-clickable-item' }),
                        React.createElement(
                            'span',
                            { className: 'custom-tooltiptext custom-tooltip-style' },
                            'Primary CE'
                        )
                    );
                } else {
                    if (!self.props.isfinalised) {
                        primaryPartial = React.createElement(
                            'span',
                            { className: 'margin-left-2 md-ink-ripple custom-tooltip margin-right-10' },
                            React.createElement('i', { className: 'icon-star-outline s18 padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.setAsPrimary.bind(this, invoice.Id) }),
                            React.createElement(
                                'span',
                                { className: 'custom-tooltiptext custom-tooltip-style' },
                                'Set as Primary CE'
                            )
                        );
                    } else {
                        primaryPartial = React.createElement(
                            'span',
                            { className: 'margin-left-2 md-ink-ripple custom-tooltip margin-right-10' },
                            React.createElement('i', { className: 'icon-star-outline s18 padding-bottom-0 margin-bottom-0 grey-400-fg not-clickable-item' })
                        );
                    }
                }

                // CostEstimate Pdf Download Icon
                if (invoice.IsPdfGenerating) {
                    costEstimatePdfDownloadIcon = React.createElement('button', { className: 'icon-download s18 padding-bottom-0 margin-bottom-0 material-icons md-18', onClick: self.downloadInvoice.bind(this, invoice.Id), disabled: true });
                } else {
                    costEstimatePdfDownloadIcon = React.createElement('button', { className: 'icon-download s18 padding-bottom-0 margin-bottom-0 grey-600-fg material-icons md-18', onClick: self.downloadInvoice.bind(this, invoice.Id) });
                }

                // IsFinalized
                if (!self.props.isfinalised) {
                    editCostEstimatePartial = React.createElement(
                        'span',
                        { className: 'margin-left-15 md-ink-ripple custom-tooltip' },
                        React.createElement('i', { className: 'icon-pencil s18 padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.editInvoice.bind(this, invoice.Id) }),
                        React.createElement(
                            'span',
                            { className: 'custom-tooltiptext' },
                            'Edit cost estimate'
                        )
                    );
                } else {
                    editCostEstimatePartial = React.createElement(
                        'span',
                        { className: 'margin-left-15 md-ink-ripple custom-tooltip' },
                        React.createElement('i', { className: 'icon-pencil s18 padding-bottom-0 margin-bottom-0 grey-400-fg not-clickable-item' })
                    );
                }

                if (!self.props.isfinalised) {
                    deleteCostEstimatePartial = React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltip' },
                        React.createElement('i', { className: 'icon-trash s18 padding-bottom-0 margin-bottom-0 grey-600-fg', onClick: self.deleteInvoice.bind(this, invoice.Id) }),
                        React.createElement(
                            'span',
                            { className: 'custom-tooltiptext' },
                            'Delete cost estimate'
                        )
                    );
                } else {
                    deleteCostEstimatePartial = React.createElement(
                        'span',
                        { className: 'margin-left-25 md-ink-ripple custom-tooltip' },
                        React.createElement('i', { className: 'icon-trash s18 padding-bottom-0 margin-bottom-0 grey-400-fg  not-clickable-item' })
                    );
                }

                if (!self.props.isfinalised) {
                    markAsReviewPartial = React.createElement(
                        'div',
                        { className: 'custom-tooltip margin-left-15' },
                        React.createElement('input', { type: 'checkbox', className: 'react-checkbox', onChange: self.markAsReviewed.bind(this, invoice.Id), checked: invoice.IsReviewed }),
                        React.createElement(
                            'span',
                            { className: 'custom-tooltiptext' },
                            'Mark as reviewed'
                        )
                    );
                } else {
                    if (invoice.IsReviewed) {
                        markAsReviewPartial = React.createElement(
                            'div',
                            { className: 'custom-tooltip margin-left-15' },
                            React.createElement('input', { type: 'checkbox', className: 'react-checkbox', checked: invoice.IsReviewed, disabled: true }),
                            React.createElement(
                                'span',
                                { className: 'custom-tooltiptext' },
                                'Reviewed'
                            )
                        );
                    }
                }

                var invoiceDate = self.jsDateTime(invoice.InvoiceDate);

                return React.createElement(
                    'div',
                    null,
                    invoiceSpinnerPartial,
                    React.createElement(
                        'div',
                        { key: uid, className: 'md-whiteframe-4dp layout-margin margin-bottom-15 padding-10 invoice-detail', onDoubleClick: self.editInvoice.bind(this, invoice.Id) },
                        React.createElement(
                            'div',
                            { className: 'layout-column' },
                            React.createElement(
                                'div',
                                { className: 'layout-row flex' },
                                React.createElement(
                                    'div',
                                    { className: 'flex-60' },
                                    React.createElement(
                                        'div',
                                        { className: 'md-title' },
                                        primaryPartial,
                                        invoice.CompanyName,
                                        ' ',
                                        invoiceProjectPartial
                                    ),
                                    React.createElement(
                                        'div',
                                        null,
                                        invoice.BranchName
                                    )
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'layout-row flex-40 layout-align-end-start' },
                                    React.createElement(
                                        'div',
                                        { className: 'layout-column' },
                                        React.createElement(
                                            'div',
                                            { className: 'text-right' },
                                            React.createElement(
                                                'span',
                                                { className: 'md-subhead' },
                                                'CE# ',
                                                invoice.InvoiceNumber
                                            ),
                                            editCostEstimatePartial,
                                            React.createElement(
                                                'span',
                                                { className: 'margin-left-15 md-ink-ripple custom-tooltip' },
                                                costEstimatePdfDownloadIcon,
                                                React.createElement(
                                                    'span',
                                                    { className: 'custom-tooltiptext' },
                                                    'Download cost estimate'
                                                )
                                            ),
                                            markAsReviewPartial,
                                            deleteCostEstimatePartial
                                        ),
                                        React.createElement(
                                            'div',
                                            { className: 'text-right' },
                                            React.createElement(
                                                'span',
                                                null,
                                                invoice.RateCard.Name,
                                                ' '
                                            ),
                                            React.createElement(
                                                'span',
                                                null,
                                                '\u2022 ',
                                                invoiceDate
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement('md-divider', null),
                        React.createElement(
                            'div',
                            { className: 'layout-column' },
                            React.createElement(
                                'div',
                                { className: 'layout-row flex' },
                                React.createElement(
                                    'div',
                                    { className: 'flex-100 margin-top-15' },
                                    React.createElement(
                                        'table',
                                        { className: 'simple invoice-table', style: tableStyle },
                                        React.createElement(
                                            'thead',
                                            null,
                                            React.createElement(
                                                'tr',
                                                null,
                                                React.createElement(
                                                    'th',
                                                    null,
                                                    'Description'
                                                ),
                                                React.createElement(
                                                    'th',
                                                    { className: 'text-right qty-col' },
                                                    'Qty'
                                                ),
                                                React.createElement(
                                                    'th',
                                                    { className: 'text-right unit-price-col' },
                                                    'Unit Price'
                                                ),
                                                React.createElement(
                                                    'th',
                                                    { className: 'text-right amt-col' },
                                                    'Amount'
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'tbody',
                                            null,
                                            lineItemsBeforeAuth.map(createInvoiceBody),
                                            surchargeLines.map(function (s) {
                                                return React.createElement(
                                                    'tr',
                                                    { key: 'surcharge-line-' + s.Key, className: 'surcharge-line-item' },
                                                    React.createElement(
                                                        'td',
                                                        null,
                                                        s.Description
                                                    ),
                                                    React.createElement(
                                                        'td',
                                                        { className: 'text-right' },
                                                        '1'
                                                    ),
                                                    React.createElement(
                                                        'td',
                                                        { className: 'text-right' },
                                                        '$',
                                                        s.Amount
                                                    ),
                                                    React.createElement(
                                                        'td',
                                                        { className: 'text-right' },
                                                        '$',
                                                        s.Amount
                                                    )
                                                );
                                            }),
                                            hasSurcharges && lineItemsFromAuth.length > 0 && React.createElement(
                                                'tr',
                                                { className: 'surcharge-auth-separator' },
                                                React.createElement(
                                                    'td',
                                                    { colSpan: '4' },
                                                    '\xA0'
                                                )
                                            ),
                                            lineItemsFromAuth.map(createInvoiceBody)
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'layout-column' },
                            React.createElement(
                                'div',
                                { className: 'layout-row flex' },
                                React.createElement(
                                    'div',
                                    { className: 'flex-100' },
                                    invDetailFooterPartial
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            null,
                            ticketDetailsPartial
                        )
                    )
                );
            };

            var createTaxRow = function createTaxRow(taxes, totalTax) {
                if (taxes && taxes.length > 1) {
                    React.createElement(
                        'tr',
                        { className: 'tax' },
                        React.createElement(
                            'td',
                            null,
                            'TOTAL TAX'
                        ),
                        React.createElement(
                            'td',
                            null,
                            '$',
                            totalTax
                        )
                    );
                }

                return taxes.map(function (x) {
                    return React.createElement(
                        'tr',
                        null,
                        React.createElement(
                            'td',
                            { style: { fontSize: '14px', paddingLeft: '1rem' } },
                            x.Name,
                            ' (',
                            x.Rate,
                            '%)'
                        ),
                        React.createElement(
                            'td',
                            { style: { fontSize: '14px' } },
                            '$',
                            x.TotalTaxApplied
                        )
                    );
                });
            };

            return React.createElement(
                'div',
                null,
                this.props.invoicelist.map(createInvoiceItem)
            );
        }
    }]);

    return CostEstimateItem;
}(React.Component);

CostEstimateItem.propTypes = {
    invoicelist: React.PropTypes.array.isRequired,
    oneditinvoice: React.PropTypes.func.isRequired,
    ondownloadinvoice: React.PropTypes.func.isRequired,
    oneditticket: React.PropTypes.func.isRequired,
    onedittimesheet: React.PropTypes.func.isRequired,
    onmarkasreviewed: React.PropTypes.func.isRequired,
    ondeleteinvoice: React.PropTypes.func.isRequired,
    onsetasprimary: React.PropTypes.func.isRequired,
    dateformat: React.PropTypes.string.isRequired,
    showdetails: React.PropTypes.bool.isRequired,
    isfinalised: React.PropTypes.bool.isRequired
};
CostEstimateItem.defaultProps = {
    invoicelist: [],
    oneditinvoice: function oneditinvoice() {},
    ondownloadinvoice: function ondownloadinvoice() {},
    ondeleteinvoice: function ondeleteinvoice() {},
    oneditticket: function oneditticket() {},
    onedittimesheet: function onedittimesheet() {},
    onmarkasreviewed: function onmarkasreviewed() {},
    onsetasprimary: function onsetasprimary() {},
    showdetails: false,
    dateformat: 'YYYY/MM/DD',
    isfinalised: false
};


angular.module('app.costEstimate.preview').value('CostEstimateItem', CostEstimateItem);
/**
 * Host directive for React component
 * 10.19.2016 rcnet
 */
(function () {
    'use strict';

    angular.module('app.costEstimate.preview')
        .directive('costEstimateItemHostComponent', costEstimateItemHostComponent);

     /** @ngInject */
    function costEstimateItemHostComponent(reactDirective, CostEstimateItem) {
        return reactDirective(CostEstimateItem);
    }

})();
/**
 * Invoice Resource Popup Controller
 * Created date: 12.12.2016
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .controller('CePopupResourceController', CePopupResourceController);

    /** @ngInject */
    function CePopupResourceController($log
    ) {
        var vm = this;

        activate();

        //////////
        function activate() {
        
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .directive('ceItemListComponent', ceItemListComponent);

    /** @ngInject */
    function ceItemListComponent(
        $stateParams,
        ceManagerService,
        ceGroupInfoService,
        ceCustomGridSearchService,
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/costEstimate/preview/directives/ceItemList/ce-item-list.html',
            scope: {},
            controller: CeReportViewerController,
            controllerAs: 'invRepVm',
            bindToController: true
        };

        return directive;

        function CeReportViewerController(utils) {
            var vm = this;

            vm.model = ceManagerService;
            vm.customGridService = ceCustomGridSearchService;
            vm.dateFormat = utils.setDateFormat();
            vm.viewCancelled = parseInt($stateParams.viewCancelled) == 1;
            vm.groupInfoService = ceGroupInfoService;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.costEstimate.preview')
        .directive('ceContentViewComponent', ceContentViewComponent);

    /** @ngInject */
    function ceContentViewComponent($mdDialog,
        $stateParams,
        $state,
        exceptionService,
        ceManagerService,
        ceFinaliseService,
        ceSideNavService,
        ceGroupInfoService,
        $mdToast,
        $anchorScroll,
        $location,
        ticketsApi,
        msgboxService,
        costEstimateApi,
        winLostLookupService,
        markAsLostService,
        historyLogService,
        auditApi,
        blockUI) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/costEstimate/preview/directives/ceContent/ce-content-view.html',
            scope: true,
            controller: CeContentViewController,
            controllerAs: 'invContentVm',
            bindToController: true
        };

        return directive;

        function CeContentViewController($anchorScroll, $location) {
            var vm = this;

            // Data
            vm.model = ceManagerService;
            vm.sideNavModel = ceSideNavService;
            vm.viewMode = 'all';
            vm.groupInfoModel = ceGroupInfoService;
            vm.groupId = $stateParams.ceGrpId;
            vm.viewCancelled = parseInt($stateParams.viewCancelled) == 1;  // 1 for view cancelled or 0 to view active only

            // Methods
            //vm.finalise = finalise;
            vm.filterByReviewed = filterByReviewed;
            vm.showAll = showAll;
            vm.notReviewed = notReviewed;
            vm.gotoTop = gotoTop;
            vm.bookJob = bookJob;
            vm.markAsLost = markAsLost;
            vm.viewHistory = viewHistory;

            activate();

            ///////
            function activate() {

                ceManagerService.setClientSideFilter(vm.viewMode);
                ceManagerService.onDownloadComplete = function(){
                    if (ceGroupInfoService.data.Status !== 1) {
                        return;
                    }
                    if (!vm.sideNavModel.hasRateCard) {
                        let confirm = $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .htmlContent("There is no rate card for " + vm.groupInfoModel.data.CompanyName + ". Please select a rate card.")
                            .ok('Close');

                        $mdDialog.show(confirm);
                    }
                };
            }

            function finalise() {
                let pluralize = ceManagerService.grid.data.length > 1;
                let invWord = pluralize ? 'cost estimates' : 'cost estimate';

                let confirm = $mdDialog.confirm()
                    .title('Confirm finalisation')
                    .textContent('Finalise ' + invWord + '?')
                    .ariaLabel('Finalise cost estimates')
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function () {
                    blockUI.start('Finalising ' + invWord + '...');
                    ceFinaliseService.finalise($stateParams.ceGrpId)
                        .then(finaliseSuccess)
                        .catch(finaliseError)

                }, function () {
                    // cancel
                });
            }

            function finaliseSuccess(resp) {
                // Reload group info service because Finalizing will change the status of the Cost Estimate group
                ceGroupInfoService.fetchData($stateParams.ceGrpId)
                    .then(function (resp) {
                        blockUI.stop();
                        ceManagerService.refreshGrid();
                        ceSideNavService.lock(true);

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Finalise successfully completed.')
                                .position('bottom right')
                                .hideDelay(4000)
                        );
                    }).catch(function (ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            }

            function finaliseError(ex) {
                blockUI.stop();
                exceptionService.resolve(ex);
            }

            function filterByReviewed() {
                vm.viewMode = 'byReviewed';
                ceManagerService.setClientSideFilter(vm.viewMode);
            }

            function showAll() {
                vm.viewMode = 'all';
                ceManagerService.setClientSideFilter(vm.viewMode);
            }

            function notReviewed() {
                vm.viewMode = 'notReviewed';
                ceManagerService.setClientSideFilter(vm.viewMode);
            }

            function gotoTop() {
                $location.hash('anchor1');
                // call $anchorScroll()
                $anchorScroll();
            }

            function bookJob() {
                costEstimateApi.getCostEstimateTicketForBooking($stateParams.ceGrpId)
                    .then(function (r) {
                        blockUI.start({ message: 'Checking related ticket...' });
                        ticketsApi.getRelatedTicketByCostEstimateSource(r.data.TicketId).then(function (resp) {
                            blockUI.stop();
                            var related = { ticketId: resp.data.Id, ticketNumber: resp.data.TicketNumber };
                            var groupId = $stateParams.ceGrpId;
                            $state.go('app.jobs_clone', { cloneId: resp.data.Id, costEstimateGroupId: groupId, related: related, costEstimateId: r.data.TicketId, ticketCount: r.data.TicketCount});
                        }).catch(function (ex) {
                            blockUI.stop();
                            exceptionService.resolve(ex);
                        });
                    }).catch(function (ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function markAsLost() {
                markAsLostService.showWinLostDialog()
                    .then(function (resp) {
                        if (resp == 'cancel' || resp != 'ok') return;
                        // Reload group info service because Finalizing will change the status of the Cost Estimate group
                        ceGroupInfoService.fetchData($stateParams.ceGrpId)
                            .then(function (resp) {
                                ceManagerService.refreshGrid();
                                ceSideNavService.lock(true);

                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent('Adding Lost Reason successfully completed.')
                                        .position('bottom right')
                                        .hideDelay(4000)
                                );
                            }).catch(function (ex) {
                                exceptionService.resolve(ex);
                            });

                    }).catch(function (ex) {
                        exceptionService.resolve(ex);
                    });
            }

            async function viewHistory(id, companyName) {
                blockUI.start('Loading History Logs...');
                var resp = await auditApi.getAuditEntries(id);
                
                blockUI.stop();
                historyLogService.showHistory("Cost Estimate", resp.data, "(" + companyName + ")");
            }

        }
    }
})();

/**
 * Created date: 12.19.2016
 * Rcnet
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .controller('CeEditLineItemDialogController', CeEditLineItemDialogController);

    /** @ngInject */
    function CeEditLineItemDialogController($mdDialog, editCeReportService) {

        var vm = this;

        // Data
        vm.showLineItemValError = false;
        vm.model = editCeReportService;
        vm.linkObj = {};

        // Events
        vm.onCancel = onCancel;
        vm.onSave = onSave;

        activate();

        function activate() {}

        function onCancel() {
            $mdDialog.cancel();
            vm.model.onToggleEdit(false);
        }

        function onSave() {
            var lineItems = window.ceGetLineItemDataInReact();

            if (lineItems.length > 0) {
                $mdDialog.hide(lineItems);
            } else {
                vm.showLineItemValError = true;
            }
        }
    }
})();
/**
 * Created date: 12.19.2016
 * Rcnet
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .controller('ConfirmDeleteCheckedItemsDialogController', ConfirmDeleteCheckedItemsDialogController);

    /** @ngInject */
    function ConfirmDeleteCheckedItemsDialogController(locals, $mdDialog) {

        var vm = this;

        // Data
        vm.desc = locals.desc;

        // Events
        vm.onCancel = onCancel;
        vm.onYes = onYes;

        activate();

        ///////
        function activate() {}

        function onCancel() {
            $mdDialog.cancel();
        }

        function onYes() {
            $mdDialog.hide();
        }

    }
})();
/**
 * Created date: 12.19.2016
 * Rcnet
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .controller('CeLineItemDialogController', CeLineItemDialogController);

    /** @ngInject */
    function CeLineItemDialogController(locals, $mdDialog) {

        var vm = this;

        // Data
        vm.desc = locals.desc;

        // Events
        vm.onCancel = onCancel;

        activate();

        ///////
        function activate() {}

        function onCancel() {
            $mdDialog.cancel();
        }
    }
})();
/**
 * Created date: 12.19.2016
 * Rcnet
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .controller('CeConfirmDialogController', CeConfirmDialogController);

    /** @ngInject */
    function CeConfirmDialogController(locals, $mdDialog) {

        var vm = this;

        // Data
        vm.desc = locals.desc;

        // Events
        vm.onCancel = onCancel;
        vm.onYes = onYes;

        activate();

        ///////
        function activate() {}

        function onCancel() {
            $mdDialog.cancel();
        }

        function onYes() {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.costEstimate', [
            'app.costEstimate.preview',
            'app.costEstimate.view',
            'app.api',
            'app.corelib',
            'app.widgets',
            'LocalStorageModule'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function runConfig(
        msNavigationService,
        claimsUtilService,
        ceDownloadService
    ) {
        msNavigationService.saveItem('apps.costEstimate', {
            title: 'Cost Estimate',
            icon: 'icon-currency-usd',
            weight: 6,
            hidden: function() {
                return !claimsUtilService.isBillingEnabled();
            }
        });

        msNavigationService.saveItem('apps.costEstimate.view', {
            title: 'View Cost Estimates',
            state: 'app.cost_estimate_view',
            weight: 1
        });

        ceDownloadService.registerSignalRCallback();
    }

    function config(localStorageServiceProvider) {
        localStorageServiceProvider.setStorageType('localStorage');
    }
})();

/**
 * Status Component
 */
(function() {
    'use strict';

    angular.module('app.costEstimate')
        .directive('ceStatusComponent', ceStatusComponent);

    /** @ngInject */
    function ceStatusComponent($http, $timeout, $rootScope) {
        var directive = {
            restrict: 'E',
            scope: {},
            require: '^ceGridComponent',
            templateUrl: 'app/main/costEstimate/directives/grid/status/ce-status.html',
            controller: CeStatusController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function link($scope, elems, attrs, controller) {
            var vm = $scope.vm;

            controller.onSetStatus(function(val) {
                vm.status = val;
            });

        }

        function CeStatusController() {}

    }
})();
/**
 * Search engine
 * by Rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate')
        .factory('ceGridSearchEngineService', ceGridSearchEngineService);

    /** @ngInject */
    function ceGridSearchEngineService(_, alasql, utils) {
        var service = {
            search: search
        };

        return service;
        ///////

        // TODO: provide search columns parameter to override extractSearchFields
        function search(collection, stext) {
            if (collection.length <= 0 || stext == null || stext == undefined || stext == '' || stext == 'undefined') return null;

            let props = extractSearchFields(collection[0]);
            let qryPredicate = createQueryPredicate(props, stext);

            let results = alasql("SELECT * FROM ? WHERE " + qryPredicate, [collection]);

            return results;
        }

        function createQueryPredicate(propsColl, stext) {
            let pred = '';
            angular.forEach(propsColl, function(p) {
                pred += p + ' LIKE "%' + stext + '%" OR ';
            });

            return pred.substring(0, pred.length - 4);
        }

        function extractSearchFields(obj) {
            let objSanitized = utils.objectSanitize(obj);
            let propsArr = [];
            for (var p in objSanitized) {
                if (!angular.isFunction(propsArr))
                    propsArr.push(p);
            }
            return propsArr;
        }
    }

})();
/**
 * Search Component
 */
(function() {
    'use strict';
    angular.module('app.costEstimate')
        .directive('ceGridSearchComponent', ceGridSearchComponent);

    /** @ngInject */
    function ceGridSearchComponent($log) {
        var directive = {
            restrict: 'E',
            scope: {
                source: '=',
                delay: '=',
                onSearch: '&'
            },
            require: '^ceGridComponent',
            templateUrl: 'app/main/costEstimate/grid/search/ceGridSearch.html',
            controller: ceGridSearchController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function ceGridSearchController() {}

        function link($scope, elem, attrs, controller) {
            var vm = $scope.vm;

            $scope.$watch('vm.source', function(newVal) {
                if (newVal != null) {
                    controller.goSearch(newVal);

                    // Notify consumer
                    (vm.onSearch || angular.noop)({ value: encodeURIComponent(newVal) });
                }
            });

            controller.onGoSearch(function(val) {
                //$log.debug(val);
            });
        }
    }
})();
/**
 * Grid Information Component
 * by rcnet 12.14.2016
 */
(function() {
    'use strict';

    angular.module('app.costEstimate')
        .directive('ceGridInfoComponent', ceGridInfoComponent);

    /** @ngInject */
    function ceGridInfoComponent($http, $timeout, $rootScope) {
        var directive = {
            restrict: 'E',
            scope: {},
            require: '^ceGridComponent',
            templateUrl: 'app/main/costEstimate/directives/grid/gridInfo/ce-grid-info.html',
            controller: CeGridInfoController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function link($scope, elems, attrs, controller) {
            var vm = $scope.vm;

            controller.onSetGridInfo(function(info) {
                vm.totalItems = info.totalItems;
                vm.rawTotalItemCount = info.rawTotalItemCount;
                vm.inProgress = info.inProgress;
                vm.isFiltered = info.isFiltered;
            });
        }

        function CeGridInfoController() {}

    }
})();
(function() {
    'use strict';

    angular.module('app.costEstimate')
        .factory('ceSignalrDataProvider', ceSignalrDataProvider);

    /** @ngInject */
    function ceSignalrDataProvider(
        $q,
        signalRService,
        $interval,
        utils) {

        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        function activate() {}

        function getInstance(opts) {
            var provider = function() {
                var self = this,
                    stop,
                    isStopped,
                    requestId;

                self.downloadTickets = downloadTickets;
                self.stopDownload = stopDownload;
                self.data = [];

                self.onDownloadCompleted = angular.noop;
                self.onChunkReceived = angular.noop;
                self.onErrorDownloading = angular.noop;

                self.options = {
                    hub: 'messageHub',
                    endpoint: null,
                    bufferSize: 2000
                };

                angular.extend(self.options, opts);

                activate();

                function activate() {
                    isStopped = false;
                }

                function downloadTickets(params) {
                    var deferred = $q.defer();

                    requestId = utils.newGuid();
                    isStopped = false;
                    stop = undefined;
                    self.data.length = 0;

                    signalRService.safeSend(function() {
                        params['ContinuationToken'] = null;
                        params['BufferSize'] = self.options.bufferSize;
                        params['RequestId'] = requestId;

                        signalRService[self.options.hub].invoke(self.options.endpoint, params)
                            .done(function(resp) {

                                if (isStopped) return;
                                if (resp.hasOwnProperty('Item3')) {
                                    if (resp.Item3 != null && requestId != resp.Item3) return;
                                }

                                angular.forEach(resp.Item1, function(itm) {
                                    self.data.push(itm);
                                });

                                // Fire event to subscriber
                                self.onChunkReceived({
                                    chunkData: resp.Item1,
                                    totalChunks: -1, // Undetermined
                                    totalItems: -1
                                    //extraData: resp.hasOwnProperty('Item3') ? resp.Item3 : null
                                }, 'dbHub');

                                // Continue fetching the next chunk data
                                if (resp.Item2 != null) {
                                    continueDl(resp.Item2, params);
                                } else {
                                    // Trigger event download completed
                                    // Note: Completed data aggregated for each download will not be use by alloc8 grid.
                                    // Only the chunk data from onChunkReceived is accepted as a superset collection.
                                    self.onDownloadCompleted(self.data);
                                }

                                //return resp;
                                deferred.resolve(resp);
                            })
                            .fail(function(error) {
                                self.onErrorDownloading(error);
                                deferred.reject(error);
                            });
                    });

                    return deferred.promise;
                }

                function continueDl(contToken, params) {
                    if (angular.isDefined(stop))
                        return;

                    let isContinue = true;

                    stop = $interval(function() {
                        if (isContinue) {
                            isContinue = false;

                            if (contToken === null) {
                                stopDl();
                                self.onDownloadCompleted(self.data);
                                return;
                            }

                            params['ContinuationToken'] = contToken;
                            params['BufferSize'] = self.options.bufferSize;

                            continueDownloading(params)
                                .then(function(respData) {

                                    if (isStopped) {
                                        return;
                                    }

                                    if (resp.hasOwnProperty('Item3')) {
                                        if (resp.Item3 != null && requestId != resp.Item3) {
                                            return
                                        };
                                    }

                                    if (respData) {
                                        // Bind data here
                                        angular.forEach(respData.Item1, function(itm) {
                                            self.data.push(itm);
                                        });

                                        // Fire event to subscriber
                                        self.onChunkReceived({
                                            chunkData: respData.Item1,
                                            totalChunks: -1,
                                            totalItems: -1
                                        }, 'dbHub');
                                    }

                                    isContinue = true;
                                    contToken = respData.Item2;
                                })
                                .catch(function(ex) {
                                    if (ex.message !== 'Connection was disconnected before invocation result was received.') {
                                        stopDl();
                                    }
                                });
                        }
                    }, 100);
                }

                function stopDl() {
                    if (angular.isDefined(stop)) {
                        $interval.cancel(stop);
                        stop = undefined;
                    }
                }

                function stopDownload() {
                    isStopped = true;
                    stopDl();
                    self.data.length = 0;
                }

                function continueDownloading(params) {
                    let deferred = $q.defer();
                    signalRService[self.options.hub]
                        .invoke(self.options.endpoint, params)
                        .done(function(resp) {
                            deferred.resolve(resp);
                        })
                        .fail(function(error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }


            };

            return new provider();
        }
    }
})();

/**
 * Create company module
 * Created date: 4.8.2016
 */
(function () {
  'use strict';

  angular
    .module('app.company.create', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    $stateProvider.state('app.company_create', {
      url: '/company/create',

      views: {
        'content@app': {
          templateUrl: 'app/main/company/create/company-create.html',
          controller: 'CompanyCreateController as companyVm'
        }
      },
      resolve: {
        lookupService: lookupServiceResolver
      },
      title: 'Create New Company',
      titleBar: 'Alloc8 - Create Company',
      data: { 
        requireLogin: true,
        validateAccess: ['companyClaimsService', function (companyClaimsService) {
          return companyClaimsService.hasCreateNewCompanyMenu;
        }] 
      }

    })
    .state('app.company_update', {
      url: '/company/update/:cid?/:cname',
      params: {
        skillid: null
      },
      views: {
        'content@app': {
          templateUrl: 'app/main/company/create/company-create.html',
          controller: 'CompanyCreateController as companyVm'
        }
      },
      resolve: {
        lookupService: lookupServiceResolver
      },
      title: 'Update Company',
      titleBar: 'Alloc8 - Company Update',
      data: { requireLogin: true }
    })

    $translatePartialLoaderProvider.addPart('app/main/company');
  };

  /** @ngInject */
  function lookupServiceResolver(companyLookupService) {
    return companyLookupService.fetchAndCacheAllLookups();
  }

})();

(function() {
    'use strict';

    angular.module('app.company.create')
        .directive('xeroCompany', xeroCompany);

    function xeroCompany() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/company/create/companyDetails/xero-company/xero-company.html',
            controller: xeroCompanyController,
            scope: {
                ngModel: '=',
                branches: '='
            },
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function xeroCompanyController(
            _,            
            claimsUtilService,
            msgboxService,
            blockUI,
            utils) {

            var vm = this;

            vm.addXeroCompany = addXeroCompany;
            vm.activate = activate;
            vm.checkAccessService = claimsUtilService;
            vm.remove = remove;
            vm.formatXeroCustomerName = formatXeroCustomerName;
            vm.canManageClientCompanies = vm.checkAccessService.checkAccessByRole('Manage Client Companies');

            function remove(index) {
                vm.ngModel.XeroCustomers.splice(index, 1);
            }

            function addXeroCompany(xeroCustomer) {
                blockUI.start('Loading Xero Companies...');
                        let locals = {
                            locals: {
                                branches: vm.branches,                                
                                xeroCustomerData: xeroCustomer,
                                selectedXeroCustomers: vm.ngModel.XeroCustomers
                            }
                        }
                        blockUI.stop();

                        msgboxService.showCustomDialog('app/main/company/create/companyDetails/xero-company/xero-company.dialog.html',
                                'xeroCompanyDialogController as vm', locals)
                            .then(function(resp) {
                                if (resp) {
                                    resp.EditMode ? edit(resp) : add(resp);
                                }
                            });                 
            }

            function activate() {
                generateIDs();
            }

            vm.activate();

            function add(resp) {
                let data = {
                    BranchId: resp.Branch.Id,
                    BranchName: resp.Branch.Name,
                    ProviderCustomer: resp.xeroCustomer
                }
                vm.ngModel.XeroCustomers.push(data);
                generateIDs();
            }

            function generateIDs() {
                angular.forEach(vm.ngModel.XeroCustomers, function(xeroCustomer) {
                    xeroCustomer['uniqueID'] = utils.newGuid();
                });
            }

            function edit(resp) {
                angular.forEach(vm.ngModel.XeroCustomers, function(xeroCustomer, index) {
                    if (xeroCustomer.uniqueID === resp.UniqueId) {
                        vm.ngModel.XeroCustomers.splice(index, 1);
                    }
                });
                add(resp);
            }

            function formatXeroCustomerName(branchXeroCustomer) {
                if (!branchXeroCustomer || !branchXeroCustomer.ProviderCustomer) return;
    
                return `${branchXeroCustomer.ProviderCustomer.CustomerName}`;
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.company.create')
        .controller('xeroCompanyDialogController', xeroCompanyDialogController);

    function xeroCompanyDialogController(
        $rootScope,
        $mdDialog,
        locals,
        $scope,
        utils,
        integrationsService,
        exceptionService,
        xeroService,
        companyService,
        claimsUtilService,
        branchService,
        tenantsApi) {

        var vm = this;

        vm.xeroCustomers = [];
        vm.xeroCustomerData = null;
        vm.service = companyService;
        vm.checkAccessService = claimsUtilService;
        vm.isXeroCustomerDisabled = true;
        vm.isBusinessConnectedToXero = true;

        vm.redirectToIntegrationsPage = redirectToIntegrationsPage;
        vm.searchXeroCustomerByName = searchXeroCustomerByName;
        vm.formatXeroCustomerName = formatXeroCustomerName;
        vm.selectXeroCustomer = selectXeroCustomer;

        vm.onCancel = onCancel;
        vm.onDone = onDone;
        vm.onSelection = onSelection;

        function activate() {
            vm.branches = locals.locals.branches;
            vm.xeroCustomerData = locals.locals.xeroCustomerData;
            vm.selectedXeroCustomers = locals.locals.selectedXeroCustomers;
            vm.isEditMode = !_.isNil(vm.xeroCustomerData);
            vm.xeroCustomers = [companyService.companyInfoData.XeroCustomers];

            if (vm.isEditMode) {
                vm.branch = _.find(vm.branches, {
                    Id: vm.xeroCustomerData.BranchId
                });
                delete vm.branch.Division;
            }

            if (claimsUtilService.isXeroEnabled()) {
                integrationsService.getProviders()
                    .then(resp => {
                        vm.isConnectedToXero = resp.isConnectedToXero;
                        if (vm.isConnectedToXero) {
                            populateXeroCustomersDropdownForSelectedBranch();
                        }
                    })
            }
        }

        function redirectToIntegrationsPage() {
            $mdDialog.hide();
            $rootScope.state.go('app.integrations');
        }

        function onSelection() {
            vm.isBusinessConnectedToXero = true;

            let doesBranchAlreadyExist = vm.selectedXeroCustomers && vm.selectedXeroCustomers.find(item => item.BranchId === vm.branch.Id) != null;
            $scope.xeroCompanyForm.Branch.$setValidity('valid', !doesBranchAlreadyExist);

            if (!doesBranchAlreadyExist && vm.isConnectedToXero) {
                populateXeroCustomersDropdownForSelectedBranch(true);
            }
        }

        function onDone() {
            let xeroCustomerObject = {
                xeroCustomer: vm.xeroCustomer,
                Branch: vm.branch,
                EditMode: _.isNil(vm.xeroCustomerData) ? false : true,
                UniqueId: _.isNil(vm.xeroCustomerData) ? null : locals.locals.xeroCustomerData.uniqueID
            }
            $mdDialog.hide(xeroCustomerObject);
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function populateXeroCustomersDropdownForSelectedBranch(doAutomatch) {
            if (!vm.branch) {
                return;
            }

            vm.isXeroCustomerDisabled = true;

            let promise;

            if (vm.branch.InvoicingBusiness && vm.branch.InvoicingBusiness.Fields["AccountId"]) {
                promise = Promise.resolve(vm.branch.InvoicingBusiness.Fields["AccountId"]);
            } else {
                promise = branchService.getBranchById(vm.branch.Id)
                    .then(resp => {
                        return tenantsApi.getBusiness(resp.data.InvoicingBusiness.Id);
                    }).then(resp => {
                        vm.business = resp.data.fields;

                        return vm.business["AccountId"];
                    });
            }

            vm.isLoadingCompanies = true;

            promise.then(InvoicingXeroCompanyId => {

                if(!InvoicingXeroCompanyId){
                    vm.isBusinessConnectedToXero = false;
                    return;
                }

                xeroService.getXeroCompaniesByTenant(InvoicingXeroCompanyId)
                    .then(resp => {
                        vm.isLoadingCompanies = false;
                        vm.xeroCustomers = resp.data;
                        vm.isXeroCustomerDisabled = false;
                        vm.isBusinessConnectedToXero = true;

                        if (vm.isEditMode) {
                            vm.xeroCustomer = _.find(vm.xeroCustomers, {
                                CustomerId: vm.xeroCustomerData.ProviderCustomer.CustomerId
                            });
                        }

                        if (doAutomatch) {
                            let matchingXeroCustomer = vm.xeroCustomers.find(xeroCust => {
                                let matchingCompanyName = (xeroCust.CustomerName.toLowerCase() === companyService.companyInfoData.CompanyName.toLowerCase());
                                return matchingCompanyName;
                            });

                            if (matchingXeroCustomer) {
                                vm.xeroCustomer = matchingXeroCustomer;
                                vm.isXeroCustomerAutomatched = true;
                                vm.automatchMessage = utils.translate('COMPANYMODULE.INSTRUCTIONS.CUSTOMER_FOUND_VIA_AUTOMATCH')
                                    .replace('{Customer}', formatXeroCustomerName(matchingXeroCustomer));
                            }
                        }
                    }).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            })
        }

        function formatXeroCustomerName(xeroCustomer) {
            if (!xeroCustomer) return;

            return `${xeroCustomer.CustomerName}`;
        }

        function searchXeroCustomerByName(query) {
            if (!query) return vm.xeroCustomers;

            query = query.toLowerCase();
            let filteredCustomers = vm.xeroCustomers.filter(c => c.CustomerName.toLowerCase().includes(query));
            return filteredCustomers;
        }

        function selectXeroCustomer(item) {
            if (item) {
                if (item.CustomerName !== companyService.companyInfoData.CompanyName) {
                    vm.isXeroCustomerAutomatched = false;
                }
                vm.xeroCustomer = item;
            } else {
                vm.xeroCustomer = null;
                vm.isXeroCustomerAutomatched = false;
            }
        }

        activate();
    }
})();

(function() {
    'use strict';

    angular.module('app.company.create')
        .directive('myobCompany', myobCompany);

    function myobCompany() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/company/create/companyDetails/myob-company/myob-company.html',
            controller: myobCompanyController,
            scope: {
                ngModel: '=',
                branches: '='
            },
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function myobCompanyController(
            _,
            claimsUtilService,
            msgboxService,
            myobService,
            integrationsService,
            utils) {

            var vm = this;

            vm.addMyobCompany = addMyobCompany;
            vm.activate = activate;
            vm.checkAccessService = claimsUtilService;
            vm.remove = remove;
            vm.formatMyobCustomerName = formatMyobCustomerName;
            vm.formatMyobJobName = formatMyobJobName;
            vm.canManageClientCompanies = vm.checkAccessService.checkAccessByRole('Manage Client Companies');

            vm.activate();

            function activate() {
                generateIDs();

                if (claimsUtilService.isMyobEnabled()) {
                    integrationsService.getProviders()
                        .then(resp => {
                            if (resp.isConnectedToMyob) {
                                getMyobCustomerJobs();
                            }
                        })
                }
            }

            function generateIDs() {
                angular.forEach(vm.ngModel.MyobCustomers, function(myobCustomer) {
                    myobCustomer['uniqueID'] = utils.newGuid();
                });
            }

            function getMyobCustomerJobs() {
                vm.ngModel.MyobCustomers.forEach(myobCustomer => {
                    let customerBranchId = myobCustomer.BranchId;
                    let branch = vm.branches.find(b => b.Id === customerBranchId);

                    if (!branch || !branch.InvoicingBusiness) {
                        return;
                    }

                    let invoicingMyobTenantId = branch.InvoicingBusiness.Fields["AccountId"];

                    if (!invoicingMyobTenantId) {
                        return;
                    }

                    myobService.getMyobJobs(invoicingMyobTenantId)
                        .then(resp => {
                            branch.myobJobs = resp.data;
                            myobCustomer.Jobs = branch.myobJobs;
                            checkIfMyobJobsAreFound(myobCustomer);
                    });
                });
            }

            function checkIfMyobJobsAreFound(myobCustomer) {
                let jobFound = myobCustomer.Jobs.some(j => j.JobId === myobCustomer.ProviderJob.JobId);
                if (!jobFound) {
                    myobCustomer.isJobNotFound = true;
                }
            }

            function remove(index) {
                vm.ngModel.MyobCustomers.splice(index, 1);
            }

            function addMyobCompany(myobCustomer) {
                let locals = {
                    locals: {
                        branches: vm.branches,
                        myobCustomerData: myobCustomer,
                        selectedMyobCustomers: vm.ngModel.MyobCustomers
                    }
                }

                msgboxService.showCustomDialog('app/main/company/create/companyDetails/myob-company/myob-company.dialog.html',
                        'myobCompanyDialogController as vm', locals)
                    .then(function(resp) {
                        let myobCustomer = resp;
                        if (myobCustomer) {
                            myobCustomer.EditMode ? edit(myobCustomer) : add(myobCustomer);
                        }
                    });
            }

            function add(myobCustomer) {
                let data = {
                    BranchId: myobCustomer.Branch.Id,
                    BranchName: myobCustomer.Branch.Name,
                    ProviderCustomer: myobCustomer.myobCustomer,
                    ProviderJob: myobCustomer.myobJob
                }
                vm.ngModel.MyobCustomers.push(data);
                generateIDs();
            }

            function edit(myobCustomer) {
                angular.forEach(vm.ngModel.MyobCustomers, function(myobC, index) {
                    if (myobC.uniqueID === myobCustomer.UniqueId) {
                        vm.ngModel.MyobCustomers.splice(index, 1);
                    }
                });
                add(myobCustomer);
            }

            function formatMyobCustomerName(branchMyobCustomer) {
                if (!branchMyobCustomer || !branchMyobCustomer.ProviderCustomer) return;

                let customerDisplayId = branchMyobCustomer.ProviderCustomer.CustomerDisplayID || branchMyobCustomer.ProviderCustomer.CustomerDisplayId;

                return `${branchMyobCustomer.ProviderCustomer.CustomerName} (${customerDisplayId})`;
            }

            function formatMyobJobName(branchMyobCustomer) {
                if (!branchMyobCustomer || !branchMyobCustomer.ProviderJob) return;
                
                let jobNumber = branchMyobCustomer.ProviderJob.JobNumber;

                if (branchMyobCustomer.isJobNotFound) {
                    jobNumber += ' (not found)';
                }

                return jobNumber;
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.company.create')
        .controller('myobCompanyDialogController', myobCompanyDialogController);

    function myobCompanyDialogController(
        $rootScope,
        $mdDialog,
        locals,
        $scope,
        utils,
        integrationsService,
        exceptionService,
        myobService,
        companyService,
        claimsUtilService,
        branchService,
        tenantsApi) {

        var vm = this;

        vm.myobCustomers = [];
        vm.myobCustomerData = null;
        vm.service = companyService;
        vm.checkAccessService = claimsUtilService;
        vm.isMyobCustomerDisabled = true;
        vm.isMyobJobDisabled = true;
        vm.isBusinessConnectedToMyob = true;

        vm.redirectToIntegrationsPage = redirectToIntegrationsPage;
        vm.searchMyobCustomerByName = searchMyobCustomerByName;
        vm.searchMyobJob = searchMyobJob;
        vm.formatMyobCustomerName = formatMyobCustomerName;
        vm.formatMyobJobName = formatMyobJobName;
        vm.selectMyobCustomer = selectMyobCustomer;

        vm.onCancel = onCancel;
        vm.onDone = onDone;
        vm.onSelection = onSelection;

        function activate() {
            vm.branches = locals.locals.branches;
            vm.myobCustomerData = locals.locals.myobCustomerData;
            vm.selectedMyobCustomers = locals.locals.selectedMyobCustomers;
            vm.isEditMode = !_.isNil(vm.myobCustomerData);
            vm.myobCustomers = [companyService.companyInfoData.MyobCustomers];

            if (vm.isEditMode) {
                vm.branch = _.find(vm.branches, {
                    Id: vm.myobCustomerData.BranchId
                });
                delete vm.branch.Division;
            }

            if (claimsUtilService.isMyobEnabled()) {
                integrationsService.getProviders()
                    .then(resp => {
                        vm.isConnectedToMyob = resp.isConnectedToMyob;
                        if (vm.isConnectedToMyob) {
                            populateMyobCustomersDropdownForSelectedBranch();
                        }
                    })
            }
        }

        function redirectToIntegrationsPage() {
            $mdDialog.hide();
            $rootScope.state.go('app.integrations');
        }

        function onSelection() {
            vm.isBusinessConnectedToMyob = true;

            let doesBranchAlreadyExist = vm.selectedMyobCustomers && vm.selectedMyobCustomers.find(item => item.BranchId === vm.branch.Id) != null;
            $scope.myobCompanyForm.Branch.$setValidity('valid', !doesBranchAlreadyExist);

            if (!doesBranchAlreadyExist && vm.isConnectedToMyob) {
                populateMyobCustomersDropdownForSelectedBranch(true);
            }
        }

        function onDone() {
            let myobCustomerObject = {
                myobCustomer: vm.myobCustomer,
                myobJob: vm.myobJob,
                Branch: vm.branch,
                EditMode: _.isNil(vm.myobCustomerData) ? false : true,
                UniqueId: _.isNil(vm.myobCustomerData) ? null : locals.locals.myobCustomerData.uniqueID
            }
            $mdDialog.hide(myobCustomerObject);
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function populateMyobCustomersDropdownForSelectedBranch(doAutomatch) {
            if (!vm.branch) {
                return;
            }

            vm.isMyobCustomerDisabled = true;
            vm.isMyobJobDisabled = true;

            let promise;

            if (vm.branch.InvoicingBusiness && vm.branch.InvoicingBusiness.Fields["AccountId"]) {
                promise = Promise.resolve(vm.branch.InvoicingBusiness.Fields["AccountId"]);
            } else {
                promise = branchService.getBranchById(vm.branch.Id)
                    .then(resp => {
                        return tenantsApi.getBusiness(resp.data.InvoicingBusiness.Id);
                    }).then(resp => {
                        vm.business = resp.data.fields;

                        return vm.business["AccountId"];
                    });
            }

            vm.isLoadingCompanies = true;
            vm.isLoadingJobs = true;

            promise.then(InvoicingMyobTenantId => {

                if (!InvoicingMyobTenantId) {
                    vm.isBusinessConnectedToMyob = false;
                    return;
                }

                myobService.getMyobCompaniesByTenant(InvoicingMyobTenantId)
                    .then(resp => {
                        vm.isLoadingCompanies = false;
                        vm.myobCustomers = resp.data;
                        vm.isMyobCustomerDisabled = false;
                        vm.isBusinessConnectedToMyob = true;

                        if (vm.isEditMode) {
                            vm.myobCustomer = _.find(vm.myobCustomers, {
                                CustomerId: vm.myobCustomerData.ProviderCustomer.CustomerId
                            });
                        }

                        if (doAutomatch) {
                            let matchingMyobCustomer = vm.myobCustomers.find(myobCust => {
                                let matchingCompanyName = (myobCust.CustomerName.toLowerCase() === companyService.companyInfoData.CompanyName.toLowerCase());
                                return matchingCompanyName;
                            });

                            if (matchingMyobCustomer) {
                                vm.myobCustomer = matchingMyobCustomer;
                                vm.isMyobCustomerAutomatched = true;
                                vm.automatchMessage = utils.translate('COMPANYMODULE.INSTRUCTIONS.CUSTOMER_FOUND_VIA_AUTOMATCH')
                                    .replace('{Customer}', formatMyobCustomerName(matchingMyobCustomer));
                            }
                        }
                    }).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });

                myobService.getMyobJobs(InvoicingMyobTenantId)
                    .then(resp => {
                        vm.isLoadingJobs = false;
                        vm.myobJobs = resp.data;
                        vm.isMyobJobDisabled = false;
                        vm.isBusinessConnectedToMyob = true;

                        if (vm.isEditMode && vm.myobCustomerData.ProviderJob) {
                            vm.myobJob = _.find(vm.myobJobs, {
                                JobId: vm.myobCustomerData.ProviderJob.JobId
                            });
                        }
                    }).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            })
        }

        function formatMyobCustomerName(myobCustomer) {
            if (!myobCustomer) return;

            return `${myobCustomer.CustomerName} (${myobCustomer.CustomerDisplayId})`;
        }

        function formatMyobJobName(myobJob) {
            if (!myobJob) return;

            return `${myobJob.JobNumber} (${myobJob.JobName})`;
        }

        function searchMyobCustomerByName(query) {
            if (!query) return vm.myobCustomers;

            query = query.toLowerCase();
            let filteredCustomers = vm.myobCustomers.filter(c => c.CustomerName.toLowerCase().includes(query) || c.CustomerDisplayId.toLowerCase().includes(query))
            return filteredCustomers;
        }

        function searchMyobJob(query) {
            if (!query) return vm.myobJobs;

            query = query.toLowerCase();
            let filteredJobs = vm.myobJobs.filter(c => c.JobNumber.toLowerCase().includes(query) || c.JobName.toLowerCase().includes(query))
            return filteredJobs;
        }

        function selectMyobCustomer(item) {
            if (item) {
                if (item.CustomerName !== companyService.companyInfoData.CompanyName) {
                    vm.isMyobCustomerAutomatched = false;
                }
                vm.myobCustomer = item;
            } else {
                vm.myobCustomer = null;
                vm.isMyobCustomerAutomatched = false;
            }
        }

        activate();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.company.create')
        .controller('companyUpdateAwardDialogController', companyUpdateAwardDialogController);

    function companyUpdateAwardDialogController(
        $mdDialog,
        locals) {

        var vm = this;

        vm.onCancel = onCancel;
        vm.onSave = onSave;

        function activate() {
            let changedAwards = locals.filter(a => a.IsNew || a.IsDeleted);

            if (!_.isEmpty(changedAwards)) {
                vm.Awards = changedAwards;
            }
        }

        function onSave() {
            $mdDialog.hide(locals);
        }

        function onCancel() {
            $mdDialog.hide();
        }

        activate();
    }
})();
(function() {
    'use strict';

    angular.module('app.company.create')
        .directive('companyAward', companyAward);

    function companyAward() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/company/create/award/component/company-award.html',
            controller: companyAwardController,
            scope: {
                ngModel: '=',
                branches: '='
            },
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function companyAwardController(
            _,
            oldAwardAPI,
            branchApi,
            $q,
            claimsUtilService,
            msgboxService,
            blockUI,
            utils) {

            var vm = this;

            vm.addAward = addAward;
            vm.activate = activate;
            vm.checkAccessService = claimsUtilService;
            vm.remove = remove;
            vm.Awards = angular.copy(vm.ngModel.Awards);


            function remove(award) {
                var existingBranchAward = _.filter(vm.Awards, function(a) {
                    return a.BranchId === award.BranchId;
                });

                if (existingBranchAward.length > 0) {
                    var branchAwardToDelete = vm.ngModel.Awards.find(x => x.BranchId === award.BranchId);
                    branchAwardToDelete.IsDeleted = true;
                    return;
                }
                _.remove(vm.ngModel.Awards, function(a) {
                    return a.BranchId === award.BranchId;
                });
            }

            function addAward(award) {
                blockUI.start('Loading Branches and Awards...');

                $q.all([oldAwardAPI.getAwards(), branchApi.getBranchLookUp()])
                    .then(function(resp) {
                        let awards = resp[0].data.filter(function(obj) {
                            if (!obj.IsArchived || (award != null && award.Award != null && obj.Id == award.Award.Id)) {
                                return obj;
                            }
                        });
                        let branches = resp[1].data;
                        let locals = {
                            locals: {
                                branches: branches,
                                awards: awards,
                                award_data: award,
                                selectedAwards: vm.ngModel.Awards
                            }
                        }

                        blockUI.stop();

                        msgboxService.showCustomDialog('app/main/company/create/award/component/company-award.dialog.html',
                                'companyAwardDialogController as vm', locals)
                            .then(function(resp) {
                                if (resp) {
                                    resp.EditMode ? edit(resp) : add(resp);
                                }
                            });
                    });
            }

            function activate() {
                generateIDs();
            }

            vm.activate();

            function add(resp) {
                var existingBranchAward = _.filter(vm.Awards, function(a) {
                    return a.BranchId === resp.Branch.Id;
                });

                var branchAward = _.filter(vm.ngModel.Awards, function(a) {
                    return a.BranchId === resp.Branch.Id;
                });

                if (existingBranchAward.length > 0 && branchAward.length > 0) {
                    branchAward[0].IsDeleted = false;
                    branchAward[0].IsNew = branchAward[0].Award.Id !== resp.Award.Id;
                    branchAward[0].Award = resp.Award;
                    return;
                }

                let data = {
                    BranchId: resp.Branch.Id,
                    BranchName: resp.Branch.Name,
                    Award: resp.Award,
                    IsNew: true
                }

                if (existingBranchAward.length > 0 && branchAward.length === 0) {
                    data.IsNew = existingBranchAward[0].Award.Id !== resp.Award.Id;
                }

                vm.ngModel.Awards.push(data);
                generateIDs();
            }


            function generateIDs() {
                angular.forEach(vm.ngModel.Awards, function(award) {
                    award['uniqueID'] = utils.newGuid();
                });
            }

            function edit(resp) {
                angular.forEach(vm.ngModel.Awards, function(award, index) {
                    if (award.uniqueID === resp.UniqueId) {
                        vm.ngModel.Awards.splice(index, 1);
                    }
                });
                add(resp);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.company.create')
        .controller('companyAwardDialogController', companyAwardDialogController);

    function companyAwardDialogController(
        $mdDialog,
        locals,
        $scope) {

        var vm = this;

        vm.awards = [];
        vm.award_data = null;

        vm.onCancel = onCancel;
        vm.onDone = onDone;
        vm.onSelection = onSelection;

        function activate() {
            vm.branches = locals.locals.branches;
            vm.award_data = locals.locals.award_data;
            vm.awards = locals.locals.awards;
            vm.selectedAwards = locals.locals.selectedAwards;

            if (!_.isNil(vm.award_data)) {
                vm.branch = _.find(vm.branches, {
                    Id: vm.award_data.BranchId
                });
                vm.award = _.find(vm.awards, {
                    Id: vm.award_data.Award.Id
                });
                delete vm.award.Classifications;
                delete vm.award.ShiftAdjustments;
                delete vm.branch.Division;
            }
        }

        function onSelection() {
            let doesBranchAlreadyExist = vm.selectedAwards.find(item => item.BranchId === vm.branch.Id && !item.IsDeleted) != null;
            $scope.awardForm.Branch.$setValidity('valid', !doesBranchAlreadyExist);
        }

        function onDone() {
            let awardObject = {
                Award: vm.award,
                Branch: vm.branch,
                EditMode: _.isNil(vm.award_data) ? false : true,
                UniqueId: _.isNil(vm.award_data) ? null : locals.locals.award_data.uniqueID,
                IsNew: true
            }
            $mdDialog.hide(awardObject);
        }

        function onCancel() {
            $mdDialog.hide();
        }

        activate();
    }
})();
(function () {
    'use strict';

        angular
            .module('app.branch.create')
            .directive('divisionsDirective', divisions);

        function divisions(){
            return {
                restrict: 'E',
                templateUrl : 'app/main/branch/create/template/directive/division.html',
                scope : {
                    service : '='
                },
                controller : control,
                bindToController : true,
                controllerAs : 'vm'
            }

            function control(){
                var vm = this;
                vm.dtOptions = {
                    dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    pagingType: 'simple',
                    autoWidth: false,
                    responsive: true
                };
            }
        }

}());

(function() {
    'use strict';

    angular
        .module('app.manage-awards.view', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.manage_awards', {
            url: '/manage-awards',
            views: {
                'content@app': {
                    templateUrl: 'app/main/awards/manage/view/awards-view.html',
                    controller: 'AwardsViewController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasManageAwardsMenu;
                }]
            },
            title: 'Manage Awards',
            titleBar: 'Alloc8 - Manage Awards'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.view')
        .controller('ManageAwardDialogController', ManageAwardDialogController);

    function ManageAwardDialogController(
        AwardsViewService,
        $mdDialog,
        blockUI,
        locals,
        $mdToast,
        exceptionService,
        moment,
        awardsApi
    ) {
        var vm = this;
        vm.isEditMode = !!locals.award;

        vm.awardName = "";
        vm.agreementName = "";
        vm.agreementNumber = "";
        vm.expiryDate = "";
        vm.isArchived = false;

        vm.onClose = onClose;
        vm.onAdd = onAdd;
        vm.onUpdate = onUpdate;
        vm.onArchive = onArchive;
        vm.onUnarchive = onUnarchive;

        activate();

        function onClose() {
            $mdDialog.hide();
        }

        function activate() {
            if (vm.isEditMode) {
                vm.awardName = locals.award.Name;
                vm.isArchived = locals.award.IsArchived;
                vm.agreementName = locals.award.AgreementName;
                vm.agreementNumber = locals.award.AgreementNumber;
                vm.expiryDate = moment(locals.award.AgreementExpiry);
                return;
            }
        }

        async function onAdd() {
            blockUI.start('Saving...');

            var payload = {
                AwardName: vm.awardName,
                AgreementName: vm.agreementName,
                AgreementNumber: vm.agreementNumber,
                AgreementExpiry: moment(vm.expiryDate).utcOffset(0, true).format()
            };

            try {
                await awardsApi.addAward(payload);
                await onSaveComplete("Award created.");
            } catch (err) {
                exceptionService.resolve(err);
            }

            blockUI.stop();
        }

        async function onUpdate() {
            blockUI.start('Saving...');

            var payload = {
                AgreementName: vm.agreementName,
                AgreementNumber: vm.agreementNumber,
                AgreementExpiry: moment(vm.expiryDate).utcOffset(0, true).format()
            };

            try {
                await awardsApi.updateAward(locals.award.Id, payload);
                await onSaveComplete("Award updated.");
            } catch (err) {
                exceptionService.resolve(err);
            }

            blockUI.stop();
        }


        async function onArchive() {
            blockUI.start('Saving...');

            try {
                await awardsApi.archiveAward(locals.award.Id, vm.originalClassificationName)
                await onSaveComplete("Award archived.");
            } catch (err) {
                exceptionService.resolve(err);
            }

            blockUI.stop();
        }

        async function onUnarchive() {
            blockUI.start('Saving...');

            try {
                await awardsApi.unarchiveAward(locals.award.Id, vm.originalClassificationName)
                await onSaveComplete("Award unarchived.");
            } catch (err) {
                exceptionService.resolve(err);
            }

            blockUI.stop();
        }

        async function onSaveComplete(toastMessage) {
            await AwardsViewService.loadAwards(true);

            $mdDialog.hide();
            $mdToast.show($mdToast.simple()
                .textContent(toastMessage)
                .position('bottom right')
                .hideDelay(3000));
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.classifications', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.manage_awardclassifications', {
            url: '/manage-awards/:awardId/classifications',
            views: {
                'content@app': {
                    templateUrl: 'app/main/awards/manage/classifications/award-classifications.html',
                    controller: 'AwardClassificationsController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasManageAwardsMenu;
                }]
            },
            title: 'Manage Classifications',
            titleBar: 'Alloc8 - Manage Classifications'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.classifications')
        .controller('ManageClassificationDialogController', ManageClassificationDialogController);

    function ManageClassificationDialogController(
        AwardsViewService,
        $mdDialog,
        blockUI,
        locals,
        $mdToast,
        exceptionService,
        awardsApi,
        utils,
    ) {
        var vm = this;
        vm.utilService = utils;
        vm.isEditMode = !!locals.isEditMode;

        vm.awardName = locals.award.Name;
        vm.isAwardArchived = locals.award.IsArchived;
        vm.originalClassificationName = locals.classificationName;
        vm.classificationName = locals.classificationName;
        vm.description = "";
        vm.baseRateOfPay = 0;
        vm.isArchived = false;

        vm.selectedBranches = [];
        vm.branchesLookup = AwardsViewService.branchesLookup;

        vm.onClose = onClose;
        vm.onAdd = onAdd;
        vm.onUpdate = onUpdate;
        vm.onArchive = onArchive;
        vm.onUnarchive = onUnarchive;

        activate();

        function activate() {
            if (vm.isEditMode) {
                const classification = locals.award.Classifications.find(p => p.ClassificationName == locals.classificationName);

                if (classification) {
                    vm.description = classification.Description;
                    vm.baseRateOfPay = classification.BaseRateOfPay;
                    vm.isArchived = classification.IsArchived;
                    vm.selectedBranches = getSelectedBranches(classification.BranchIds);
                }
            }
        }

        function onClose() {
            $mdDialog.hide();
        }

        async function onAdd() {
            blockUI.start('Saving...');

            var payload = {
                ClassificationName: vm.classificationName,
                Description: vm.description,
                BranchIds: vm.selectedBranches.map(p => p.Id),
                BaseRateOfPay: vm.baseRateOfPay
            };

            try {
                await awardsApi.addClassification(locals.award.Id, payload);
                await onSaveComplete("Classification created.");
            } catch (err) {
                exceptionService.resolve(err);
            }
        }

        async function onUpdate() {
            blockUI.start('Saving...');

            var payload = {
                NewClassificationName: vm.classificationName,
                Description: vm.description,
                BranchIds: vm.selectedBranches.map(p => p.Id),
                BaseRateOfPay: vm.baseRateOfPay
            };

            try {
                await awardsApi.updateClassification(locals.award.Id, vm.originalClassificationName, payload)
                await onSaveComplete("Classification updated.");
            } catch (err) {
                exceptionService.resolve(err);
            }

            blockUI.stop();
        }

        async function onArchive() {
            blockUI.start('Saving...');

            try {
                await awardsApi.archiveClassification(locals.award.Id, vm.originalClassificationName)
                await onSaveComplete("Classification archived.");
            } catch (err) {
                exceptionService.resolve(err);
            }

            blockUI.stop();
        }

        async function onUnarchive() {
            blockUI.start('Saving...');

            try {
                await awardsApi.unarchiveClassification(locals.award.Id, vm.originalClassificationName)
                await onSaveComplete("Classification unarchived.");
            } catch (err) {
                exceptionService.resolve(err);
            }

            blockUI.stop();
        }

        async function onSaveComplete(toastMessage) {
            await AwardsViewService.loadAwards(true);

            $mdDialog.hide();
            $mdToast.show($mdToast.simple()
                .textContent(toastMessage)
                .position('bottom right')
                .hideDelay(3000));
        }

        function getSelectedBranches(branchIds) {
            if (!branchIds) {
                return;
            }

            return AwardsViewService.branchesLookup.filter(branchLookup => branchIds.findIndex(branchId => branchId === branchLookup.Id) > -1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.classificationrates', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.manage_awardclassificationrates', {
            url: '/manage-awards/:awardId/classifications/:classificationName',
            views: {
                'content@app': {
                    templateUrl: 'app/main/awards/manage/classification-rates/award-classification-rates.html',
                    controller: 'AwardClassificationRatesController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasManageAwardsMenu;
                }]
            },
            title: 'Manage Classification Rates',
            titleBar: 'Alloc8 - Manage Classification Rates'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.classificationrates')
        .controller('ManageClassificationRateDialogController', ManageClassificationRateDialogController);

    function ManageClassificationRateDialogController(
        AwardsViewService,
        $mdDialog,
        blockUI,
        locals,
        $mdToast,
        exceptionService,
        awardsApi
    ) {
        const RATE_TYPE_STANDARD = 1;
        const RATE_TYPE_CASUAL = 2;

        var vm = this;

        vm.awardName = locals.award.Name;
        vm.classificationName = locals.classificationName;
        vm.isArchived = false;

        vm.rateName = "";
        vm.rateType = locals.rateType;
        vm.payCode = "";
        vm.payRate = 0;
        vm.rateTypes = [{
            Id: RATE_TYPE_STANDARD,
            Name: "Standard"
        }, {
            Id: RATE_TYPE_CASUAL,
            Name: "Casual"
        }];
        vm.payRates = locals.award.PayRates;

        vm.onRateSelection = onRateSelection;
        vm.onRateTypeSelection = onRateTypeSelection;

        vm.onClose = onClose;
        vm.onUpdate = onUpdate;
        vm.onDelete = onDelete;

        activate();

        function onClose() {
            $mdDialog.hide();
        }

        function onRateSelection() {
            if (!vm.rateName) {
                vm.rateName = null;
            }
        }

        function onRateTypeSelection() {
            if (!vm.rateType) {
                vm.rateType = null;
            }
        }

        function activate() {
            const classification = locals.award.Classifications.find(p => p.ClassificationName == locals.classificationName);

            if (classification) {
                vm.baseRateOfPay = classification.BaseRateOfPay;
                vm.isArchived = classification.IsArchived;

                const rate = classification.Rules.find(p => p.Id == locals.rateId);
                vm.rateName = rate.RuleName;

                if (rate) {
                    if (locals.rateType == RATE_TYPE_STANDARD) {
                        vm.payCode = rate.RuleCode;
                        vm.payRate = toFixedNumber((classification.BaseRateOfPay * rate.RuleLoading) / 100, 8);
                    } else if (locals.rateType == RATE_TYPE_CASUAL) {
                        vm.payCode = rate.CasualCode;
                        vm.payRate = toFixedNumber((classification.BaseRateOfPay * rate.CasualLoading) / 100, 8);
                    }
                    return;
                }
            }
        }

        function toFixedNumber(num, digits) {
            var pow = Math.pow(10, digits);
            return Math.round(num * pow) / pow;
        }

        async function onUpdate() {
            blockUI.start('Saving...');

            var payload = {
                PayCode: vm.payCode,
                PayRate: vm.payRate,
                RateType: locals.rateType
            };

            try {
                await awardsApi.updateClassificationRate(locals.award.Id, locals.classificationName, locals.rateId, payload);
                await onSaveComplete("Classification Rate updated.");
            } catch (err) {
                exceptionService.resolve(err);
            }

            blockUI.stop();
        }

        async function onDelete() {
            blockUI.start('Deleting...');

            var payload = {
                PayCode: null,
                PayRate: null,
                RateType: locals.rateType
            };

            try {
                await awardsApi.updateClassificationRate(locals.award.Id, locals.classificationName, locals.rateId, payload);
                await onSaveComplete("Classification Rate updated.");
            } catch (err) {
                exceptionService.resolve(err);
            }


            blockUI.stop();
        }

        async function onSaveComplete(toastMessage) {
            await AwardsViewService.loadAwards(true);

            $mdDialog.hide();
            $mdToast.show($mdToast.simple()
                .textContent(toastMessage)
                .position('bottom right')
                .hideDelay(3000));
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.awards.view')
        .factory('OldAwardsViewService', OldAwardsViewService);

    /** @ngInject */
    function OldAwardsViewService(
        oldAwardAPI,
        blockUI,
        $mdDialog,
        $q,
        branchApi
    ) {
        var service = {
            awards: [],
            classifications: [],
            shiftRoles: [],
            query1: null,
            query2: null,
            query3: null,
            getAwards: getAwards,
            branchesLookup: [],
            getShiftRoles: getShiftRoles,
            getClassifications: getClassifications,
            addAward: addAward,
            editAward: editAward,
            editClassification: editClassification,
            saveAward: saveAward,
            putAward: putAward,
            getAll: getAll,
            addClassification: addClassification,
            addShiftRole: addShiftRole,
            saveShiftRole: saveShiftRole,
            putShiftRole: putShiftRole,
            editShiftRole: editShiftRole,
            saveClassification: saveClassification,
            putClassification: putClassification,
            archiveAward: archiveAward
        };

        return service;

        function getAll() {
            blockUI.start('Loading Data...');
            var urls = [
                oldAwardAPI.getAwards(),
                oldAwardAPI.getShiftRoles(),
                oldAwardAPI.getClassifications(),
                branchApi.getBranches()
            ];

            $q.all(urls).then(function(resp) {
                service.awards = resp[0].data;
                service.shiftRoles = resp[1].data;
                service.classifications = resp[2].data;
                service.branchesLookup = resp[3].data;
                blockUI.stop();
            })
        }

        function getAwards() {
            blockUI.start('Loading Awards...');
            oldAwardAPI.getAwards().then(function(resp) {
                service.awards = resp.data;
                blockUI.stop();
            });
        }

        function getShiftRoles() {
            blockUI.start('Loading Shift Allowances...');
            oldAwardAPI.getShiftRoles().then(function(resp) {
                service.shiftRoles = resp.data;
                blockUI.stop();
            });
        }

        function getClassifications() {
            blockUI.start('Loading Classifications...');
            oldAwardAPI.getClassifications().then(function(resp) {
                service.classifications = resp.data;
                blockUI.stop();
            });
        }

        function saveAward(payLoad) {
            return oldAwardAPI.saveAward(payLoad);
        }

        function saveShiftRole(payLoad) {
            return oldAwardAPI.saveShiftRole(payLoad);
        }

        function saveClassification(payLoad) {
            return oldAwardAPI.saveClassificationV2(payLoad);
        }

        function putAward(payLoad) {
            return oldAwardAPI.editAward(payLoad);
        }

        function putShiftRole(payLoad) {
            return oldAwardAPI.editShiftRole(payLoad);
        }

        function putClassification(payLoad, OldId) {
            return oldAwardAPI.editClassificationV2(payLoad, OldId);
        }

        function archiveAward(payLoad) {
            return oldAwardAPI.archiveAward(payLoad);
        }

        function addAward() {
            var locals = {
                editMode: false,
                award: null,
                source: 'award'
            }
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/awards/dialog/award-dialog.html',
                controller: 'OldAwardsViewDialogController as vm',
                locals: {
                    locals: locals
                }
            });
        }

        function editAward(award) {
            var locals = {
                editMode: true,
                award: award,
                source: 'award'
            }
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/awards/dialog/award-dialog.html',
                controller: 'OldAwardsViewDialogController as vm',
                locals: {
                    locals: locals
                }
            });
        }

        function editClassification(classification) {
            var locals = {
                editMode: true,
                classification: classification,
                source: 'classification'
            }
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/awards/dialog/award-dialog.html',
                controller: 'OldAwardsViewDialogController as vm',
                locals: {
                    locals: locals
                }
            });
        }

        function addClassification(classification) {
            var locals = {
                editMode: false,
                classification: classification,
                source: 'classification'
            }
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/awards/dialog/award-dialog.html',
                controller: 'OldAwardsViewDialogController as vm',
                locals: {
                    locals: locals
                }
            });
        }

        function addShiftRole() {
            var locals = {
                editMode: false,
                role: null,
                source: 'shiftAllowance'
            }
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/awards/dialog/award-dialog.html',
                controller: 'OldAwardsViewDialogController as vm',
                locals: {
                    locals: locals
                }
            });
        }

        function editShiftRole(role) {
            var locals = {
                editMode: true,
                role: role,
                source: 'shiftAllowance'
            }
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/awards/dialog/award-dialog.html',
                controller: 'OldAwardsViewDialogController as vm',
                locals: {
                    locals: locals
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.awards.view')
        .controller('OldAwardsViewDialogController', OldAwardsViewDialogController);

    function OldAwardsViewDialogController(OldAwardsViewService, $mdDialog, blockUI, locals, $mdToast, utils, exceptionService, restrictSpecialCharacters) {
        //Variables
        var vm = this;

        var isAwardSource = locals.locals.source !== 'classification' && locals.locals.source !== 'shiftAllowance';
        vm.namePattern = isAwardSource ? restrictSpecialCharacters : null;
        //Methods
        vm.onClose = onClose;
        vm.onDone = onDone;
        vm.activate = activate;
        vm.BranchesLookup = OldAwardsViewService.branchesLookup;
        vm.utilService = utils;
        vm.source = locals.locals.source;
        vm.onArchive = onArchive;
        vm.isArchiveAward = false;
        vm.archiveButtonLabel = "Archive"

        function onClose() {
            $mdDialog.hide();
        }

        function toast() {
            $mdToast.show($mdToast.simple()
                .textContent('Saved.')
                .position('bottom right')
                .hideDelay(3000));
        }

        function activate() {
            //Award
            if (locals.locals.source == "award") {
                vm.idPlaceholder = "Award Id";
                vm.namePlaceholder = "Award Name";
                vm.archiveCaption = "Archive Award";
                if (locals.locals.editMode) {
                    vm.Id = locals.locals.award.AwardId;
                    vm.Name = locals.locals.award.Name;
                    vm.IsArchived = locals.locals.award.IsArchived;
                    vm.caption = "Edit Award";
                    vm.isArchiveAward = true;
                    if (vm.IsArchived) {
                        vm.archiveButtonLabel = "Unarchive";
                    }
                } else {
                    vm.Id = null;
                    vm.Name = null;
                    vm.IsArchived = false;
                    vm.caption = "Add Award";
                }
            }

            //Classification
            if (locals.locals.source == "classification") {
                vm.idPlaceholder = "Award Classification";
                vm.namePlaceholder = "Classification Name";
                vm.archiveCaption = "Archive Classification";
                if (locals.locals.editMode) {
                    vm.Id = locals.locals.classification.ClassificationId;
                    vm.Name = locals.locals.classification.Name;
                    vm.Branches = locals.locals.classification.Branches;
                    vm.IsArchived = locals.locals.classification.IsArchived;
                    vm.caption = "Edit Classification";

                    vm.OldClassificationId = angular.copy(vm.Id);

                } else {
                    vm.Id = null;
                    vm.Name = null;
                    vm.Branches = [];
                    vm.IsArchived = false;
                    vm.caption = "Add Classification";
                }
            }

            if (locals.locals.source == "shiftAllowance") {
                vm.idPlaceholder = "Shift Allowance Id";
                vm.namePlaceholder = "Shift Allowance Name";
                vm.archiveCaption = "Archive Shift Allowance";
                if (locals.locals.editMode) {
                    vm.Id = locals.locals.role.RoleId;
                    vm.Name = locals.locals.role.Name;
                    vm.IsArchived = locals.locals.role.IsArchived;
                    vm.caption = "Edit Shift Allowance";
                } else {
                    vm.Id = null;
                    vm.Name = null;
                    vm.IsArchived = false;
                    vm.caption = "Add Shift Allowance";
                }
            }
        }

        function onDone() {
            blockUI.start('Saving...');
            var data = buildData(locals.locals.editMode);

            //Award
            if (locals.locals.source == "award") {
                if (locals.locals.editMode) {
                    OldAwardsViewService.putAward(data).then(function () {
                        blockUI.stop();
                        OldAwardsViewService.getAwards();
                        $mdDialog.hide();
                        toast();
                    }).catch(showError);
                } else {
                    OldAwardsViewService.saveAward(data).then(function () {
                        blockUI.stop();
                        OldAwardsViewService.getAwards();
                        $mdDialog.hide();
                        toast();
                    }).catch(showError);
                }
            }

            //Shift Allowance
            if (locals.locals.source == "shiftAllowance") {
                if (locals.locals.editMode) {
                    OldAwardsViewService.putShiftRole(data).then(function () {
                        blockUI.stop();
                        OldAwardsViewService.getShiftRoles();
                        $mdDialog.hide();
                        toast();
                    }).catch(showError);
                } else {
                    OldAwardsViewService.saveShiftRole(data).then(function () {
                        blockUI.stop();
                        OldAwardsViewService.getShiftRoles();
                        $mdDialog.hide();
                        toast();
                    }).catch(showError);
                }
            }

            //Classifications
            if (locals.locals.source == "classification") {
                if (locals.locals.editMode) {
                    OldAwardsViewService.putClassification(data, vm.OldClassificationId).then(function () {
                        blockUI.stop();
                        OldAwardsViewService.getClassifications();
                        $mdDialog.hide();
                        toast();
                    }).catch(showError);
                } else {
                    OldAwardsViewService.saveClassification(data).then(function () {
                        blockUI.stop();
                        OldAwardsViewService.getClassifications();
                        $mdDialog.hide();
                        toast();
                    }).catch(showError);
                }
            }
        }

        function showError(err) {
            blockUI.stop();
            exceptionService.resolve(err);
        }

        function buildData(editMode) {
            //Award
            if (locals.locals.source == "award") {
                if (editMode) {
                    return {
                        Id: locals.locals.award.Id,
                        AwardId: vm.Id,
                        Name: vm.Name,
                        IsArchived: vm.IsArchived
                    }
                } else {
                    return {
                        AwardId: vm.Id,
                        Name: vm.Name,
                        IsArchived: vm.IsArchived
                    }
                }
            }

            //Shift Allowance
            if (locals.locals.source == "shiftAllowance") {
                if (editMode) {
                    return {
                        Id: locals.locals.role.Id,
                        RoleId: vm.Id,
                        Name: vm.Name,
                        IsArchived: vm.IsArchived
                    }
                } else {
                    return {
                        RoleId: vm.Id,
                        Name: vm.Name,
                        IsArchived: vm.IsArchived
                    }
                }
            }

            //Classifications
            if (locals.locals.source == "classification") {
                if (editMode) {
                    return {
                        Id: locals.locals.classification.Id,
                        ClassificationId: vm.Id,
                        Name: vm.Name,
                        Branches: vm.Branches,
                        IsArchived: vm.IsArchived
                    }
                } else {
                    return {
                        ClassificationId: vm.Id,
                        Name: vm.Name,
                        Branches: vm.Branches,
                        IsArchived: vm.IsArchived
                    }
                }
            }
        }

        function onArchive() {
            blockUI.start('Saving...');
            vm.IsArchived = !vm.IsArchived;
            var data = buildData(locals.locals.editMode);

            OldAwardsViewService.archiveAward(data).then(function() {
                blockUI.stop();
                OldAwardsViewService.getAwards();
                $mdDialog.hide();
                toast();
            }).catch(showError);
        }

        vm.activate();
    }
})();

/**
 * Cost codes module
 * Created date: 6.22.2016
 */
(function () {
    'use strict';

    angular
        .module('app.assets.manage.costcodes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.manage_cost_codes', {
            url: '/assets/manage/costcodes',

            views: {
                'content@app': {
                    templateUrl: 'app/main/assets/manage/costCodes/cost-codes.default.html',
                    controller: 'CostCodesCreateController as costCodesVm'
                }
            },
            resolve: {
                gridCostCodeData: lookupServiceResolver
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManageCostCodesMenu;
                }] 
            },
            title: 'Manage Cost Codes',
            titleBar: 'Alloc8 - Cost Codes',
        });

        $translatePartialLoaderProvider.addPart('app/main/assets');
    };

    /** @ngInject */
    function lookupServiceResolver(costCodeGridService) {
        return costCodeGridService.loadGridData();
    }

})();

(function() {
    'use strict';

    angular
        .module('app.assets.manage.costcodes')
        .controller('KitViewController', KitViewController);

    /** @ngInject */
    function KitViewController(
        kitItemGridService,
        _,
        kitGridData,
        searchDelay,
        claimsUtilService
    ) {
        var vm = this;
        vm.model = kitItemGridService;
        vm.gridModel = kitGridData;
        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            initComplete: function() {
                searchTable();
            }
        };

        vm.addNew = addNew;
        vm.onEdit = onEdit;
        vm.onRemove = onRemove;
        vm.searchTable = searchTable;

        vm.canDeleteKit = claimsUtilService.isCustomerOnboardingEnabled();

        function searchTable() {
            if (!_.isNil(vm.model.query)) {
                setTimeout(function() {
                    vm.dtInstance.DataTable.search(vm.model.query);
                    vm.dtInstance.DataTable.search(vm.model.query).draw();
                }, searchDelay);
            }
        }

        function addNew() {
            kitItemGridService.createKitItem();
        }

        function onEdit(kitId) {
            kitItemGridService.editKitItem(kitId);
        }

        function onRemove(kitId, kitName) {
            kitItemGridService.removeKitItem(kitId, kitName);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.assets.manage.shift')
        .controller('ShiftTypesViewController', ShiftTypesViewController);

    /** @ngInject */
    function ShiftTypesViewController(itemGridService, shiftTypeViewService, searchDelay, _) {

        //Data
        var vm = this;
        vm.service = shiftTypeViewService;
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            initComplete: function () {
                searchTable(1);
            }
        };
        vm.dtInstance1 = {};

        vm.addNew = addNew;
        vm.onEdit = onEdit;
        vm.searchTable = searchTable;

        activate();

        function searchTable() {
            setTimeout(function () {
                if (!_.isNil(vm.service.query1)) {
                    vm.dtInstance1.DataTable.search(vm.service.query1);
                    vm.dtInstance1.DataTable.search(vm.service.query1).draw();
                }
            }, searchDelay);
        }

        function activate() {
            vm.service.load();
        }

        function addNew() {
            itemGridService.createShiftType();
        }

        function onEdit(id) {
            itemGridService.editShiftType(id);
        }
    }

})();

/**
 * Item module
 * Created date: 6.24.2016
 */
(function () {
  'use strict';

  angular
    .module('app.assets.manage.kit', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    $stateProvider.state('app.manage_kit', {
      url: '/assets/manage/kit',
      views: {
        'content@app': {
          templateUrl: 'app/main/assets/manage/kit/kit.default.html',
          controller: 'KitController as kitVm'
        }
      },
      resolve: {
        itemManagerResolver: itemManagerResolver
      },
      title: 'Create Kit Item',
      titleBar: 'Alloc8 - Create Kit',
      data: { 
        requireLogin: true,
        validateAccess: ['assetsClaimService', function (assetsClaimService) {
          return assetsClaimService.hasCreateNewKit;
      }],
      }
    })
      .state('app.manage_kit_update', {
        url: '/assets/manage/kit/update/:kid',
        params: {
          itemid: null
        },
        views: {
          'content@app': {
            templateUrl: 'app/main/assets/manage/kit/kit.default.html',
            controller: 'KitController as kitVm'
          }
        },
        resolve: {
          itemManagerResolver: itemManagerResolver
        },
        title: 'Update Kit Item',
        titleBar:'Alloc8 - Kit Item Update',
        data: { requireLogin: true }
      })
      .state('app.kit_view_items', {
        url: '/assets/kit/view',

        views: {
          'content@app': {
            templateUrl: 'app/main/assets/manage/kit/kitview/kit-view.html',
            controller: 'KitViewController as kitGridVm'
          }
        },
        resolve: {
          kitGridData: kitViewItemResolver
        },
        title: 'Manage Kit Items',
        titleBar :'Alloc8 - View Kit Items',
        data: { 
          requireLogin: true,
          validateAccess: ['assetsClaimService', function (assetsClaimService) {
            return assetsClaimService.hasViewKitsMenu;
          }]
        }
      });


    $translatePartialLoaderProvider.addPart('app/main/assets');
  };

  function itemManagerResolver(kitManagerService) {
    return kitManagerService.loadLookups();
  }

  function kitViewItemResolver(kitItemGridService) {
    return kitItemGridService.loadGridData();
  }

})();

/**
 * Basic
 * Created date: 6.27.2016
 */
(function () {
    'use strict';

    angular.module('app.assets.manage.kit')
        .directive('saleAndHirePriceComponent', saleAndHirePriceComponent);

    /** @ngInject */
    function saleAndHirePriceComponent(kitHirePriceService,
        claimsUtilService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/kit/hirePrice/hire-price.html',
            controller: saleAndHirePriceController,
            controllerAs: 'kitHirePriceVm',
            bindToController: true
        };

        return directive;

        function saleAndHirePriceController() {
            var vm = this;
            vm.claimsUtilService = claimsUtilService;

            vm.model = kitHirePriceService;

            activate();

            function activate() {

            }

        }
    }

})();

/**
 * Basic
 * Created date: 6.27.2016
 */
(function () {
    'use strict';

    angular.module('app.assets.manage.kit')
           .directive('kitItemFormComponent', kitItemFormComponent);

    /** @ngInject */
    function kitItemFormComponent(basicKitInfoService, $mdDialog, kitManagerService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/kit/basic/kit-item-form.html',
            controller: kitItemFormController,
            controllerAs: 'kitFormVm',
            bindToController: true
        };

        return directive;

        function kitItemFormController() {
            var vm = this;

            vm.model = basicKitInfoService;
            vm.onAddKitItem = onAddKitItem;
            vm.onEdit = onEdit;
            vm.remove = remove;

            activate();

            ///////
            function activate() {
            }

            function remove(index){
              vm.model.data.KitItems.splice(index,1)
            }

            function onAddKitItem() {
                 // List of asset items
                 var locals = {
                    itemList: basicKitInfoService.itemList
                 };

                showModal();
            }

            function onEdit(id) {
                showModal(id);
            }

            function showModal(id) {
                 var locals = {};

                if (id) {
                   var toEdit = _.filter(basicKitInfoService.data.KitItems, function(o) {
                                    return o.Items.id == id;
                                })[0];
                    locals.dataToEdit = toEdit;
                }

                locals.itemList = kitManagerService.itemList;

                 $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/main/assets/manage/kit/basic/kit-item-dialog.html',
                    controller: 'KitItemDialogController as kitItemVm',
                    locals: locals
                    }).then(function(result) {
                        if (result) {
                            
                             basicKitInfoService.addKitItem(result.data, result.isEdit);
                        }

                    }, function() {
                        // cancel
                });
            }
        }
    }

})();

/**
 * Create Kit Item Controller
 * Created date: 7.11.2016
 */
(function() {
    'use strict';

    angular
    .module('app.assets.manage.kit')
    .controller('KitItemDialogController', KitItemDialogController);

   /** @ngInject */
   function KitItemDialogController($log, $scope, $q, $mdDialog, blockUI, $timeout, locals, _) {
        var vm = this;

        vm.itemSelected;
        vm.qty = null;

        // Autocomplete for Items
        vm.searchText = null;
        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.searchTextChange = searchTextChange;
        vm.itemList = [];
        vm.selectedItem = null;

        vm.onAdd = onAdd;
        vm.onCancel = onCancel;

        var isEditMode = false;

        activate();

        //////////
        function activate() {

            vm.itemList = locals.itemList;

            // Check for editing
            if (locals.dataToEdit) {
                isEditMode = true;

                vm.itemSelected = locals.dataToEdit.Items;
                //vm.qty = locals.Qty;
                vm.qty = locals.dataToEdit.Quantity;
            }
        }

        function onAdd() {
            var item = angular.copy(vm.itemSelected);
            if (locals.dataToEdit) {
                item.oldId = locals.dataToEdit.Items.id;
            }

            //item.Qty =  vm.qty;
          var dataToReturned = {Items: item, Quantity: vm.qty}
            $mdDialog.hide({ data: dataToReturned, isEdit: isEditMode });

        }

        function onCancel() {
            $mdDialog.hide();
        }

        /**
        * Autocomplete functions
        */
        function querySearch(query) {
            var results = query ? vm.itemList.filter(createFilterFor(query)) : vm.itemList;
            return results;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(emp) {
                return (angular.lowercase(emp.ItemName).indexOf(lowercaseQuery) > -1);
            };
        }

        function searchTextChange(text) {
          $log.info('Text changed to ' + text);
        }

        function selectedItemChange(item) {
        }
    }
})();

/**
 * Basic
 * Created date: 6.27.2016
 */
(function () {
    'use strict';
    
    angular.module('app.assets.manage.kit')
           .directive('basicCreateKitItemComponent', basicCreateKitItemComponent);

    /** @ngInject */
    function basicCreateKitItemComponent(a8TreeMdBoxService, kitManagerService, basicKitInfoService, utils) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/kit/basic/basic-create-kit-item.html',
            controller: basicCreateKitItemController,
            controllerAs: 'kitBasicVm',
            bindToController: true  
        };

        return directive;

        function basicCreateKitItemController() {
            var vm = this;

            vm.model = basicKitInfoService;
            vm.categoryModel = a8TreeMdBoxService;
            vm.Branches = kitManagerService.branchesLookup;
            vm.utilService = utils;

            activate();

            ///////

            function activate() {
               kitManagerService.loadCategoryTree(); 
            }
        
        }
    }       

})();
/**
 * Item module
 * Created date: 6.24.2016
 */
(function () {
    'use strict';

    angular
    .module('app.assets.manage.item', [])
    .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.manage_item', {
             url: '/assets/manage/item',
             views: {
                'content@app': {
                    templateUrl: 'app/main/assets/manage/item/item.default.html',
                    controller: 'ItemController as itemVm'
                }
            },
            resolve: {
                itemManagerResolver: itemManagerResolver
            },
            title: 'Create Item',
            titleBar :'Alloc8 - Create Item',
            data: { 
                requireLogin: true, 
                validateAccess: ['assetsClaimService', function (assetsClaimService) {
                    return assetsClaimService.hasCreateNewItemMenu;
                }],
                source: 'item' 
            }
        })
        .state('app.manage_item_update', {
             url: '/assets/manage/item/update/:id?/itemName:',
             params: {
               itemid: null
             },
             views: {
                'content@app': {
                    templateUrl: 'app/main/assets/manage/item/item.default.html',
                    controller: 'ItemController as itemVm'
                }
            },
            resolve: {
                itemManagerResolver: itemManagerResolver
            },
            title: 'Item Update',
            titleBar :'Alloc8 - Item Update',
            data: { requireLogin: true, source: 'item' }
        })
        .state('app.view_items', {
             url: '/assets/item/view',

             views: {
                'content@app': {
                    templateUrl: 'app/main/assets/manage/item/itemView/item-view.html',
                    controller: 'ItemViewController as itemGridVm'
                }
            },
            resolve: {
                itemGridData: itemViewItemResolver
            },
          title: 'Manage Items',
          titleBar :'Alloc8 - View Items',
            data: { 
                requireLogin: true,
                validateAccess: ['assetsClaimService', function (assetsClaimService) {
                    return assetsClaimService.hasViewItemsMenu;
                }]
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/assets');
    };

     /** @ngInject */
    function itemManagerResolver(itemManagerService) {
        return itemManagerService.loadLookups();
     }

    /** @ngInject */
    function itemViewItemResolver(itemGridService) {
        return itemGridService.loadGridData();
    }


})();

/**
 * Stock Level
 * Created date: 6.27.2016
 */
(function () {
    'use strict';

    angular.module('app.assets.manage.item')
        .directive('stockLevelComponent', stockLevelComponent);

    /** @ngInject */
    function stockLevelComponent(itemManagerService, stockLevelService, basicInfoService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/item/stockLevel/stock-level.html',
            controller: stockLevelController,
            controllerAs: 'stockLevelVm',
            bindToController: true,
            link: linkFunc
        };

        return directive;

        function stockLevelController() {
            var vm = this;

            vm.itemTrackingLookup = itemManagerService.stockLevelTrackingLookup;
            vm.individualTrackingTypesLookup = itemManagerService.individualTrackingTypesLookup;
            vm.lowStockNotificationsLookup = itemManagerService.lowStockNotificationsLookup;
            vm.model = stockLevelService;
            vm.basicInfoModel = basicInfoService;
            vm.modelItemManager = itemManagerService;
            vm.itemTypes = [];

            vm.onStockLevelTrackingChange = onStockLevelChange;
            vm.onLowStockLevelChange = onLowStockLevelChange;
            vm.onIndividualTrackingTypeChange = onIndividualTrackingTypeChange;
            vm.onAddStock = addStock;
            vm.onRemoveStock = removeStock;
            vm.onConvertStock = convertStock;

            vm.daysOfTheWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

            function onStockLevelChange() {
                stockLevelService.changeStockLevelTracking();
                var basicInfoModel = this.basicInfoModel;
                if (basicInfoModel != undefined) {
                    if (!angular.equals(basicInfoModel.data.StockLevel.Id, this.model.data.StockLevelTracking.Id)) {
                        basicInfoModel.data.StockLevel = this.model.data.StockLevelTracking;
                    }
                }
            }

            function onLowStockLevelChange() {
                stockLevelService.changeLowStockNotif();
            }

            function onIndividualTrackingTypeChange() {
                stockLevelService.changeIndividualTrackingType();
            }

            function addStock() {
                // Check if initial stock or new entry
                stockLevelService.addStock(itemManagerService.getBasicInfoData().ItemTypes, !itemManagerService.isEditMode);
            }

            function removeStock() {
                stockLevelService.removeStock(itemManagerService.getBasicInfoData().ItemTypes);
            }

            function convertStock() {
                stockLevelService.convertStock(itemManagerService.getBasicInfoData().ItemTypes);
            }

            vm.toggleTrackingDays = function (day) {
                let idx = vm.basicInfoModel.data.UtilisationDays.indexOf(day);

                if (idx > -1) {
                    vm.basicInfoModel.data.UtilisationDays.splice(idx, 1);
                } else {
                    vm.basicInfoModel.data.UtilisationDays.push(day);
                }
            };

            vm.isTrackingDaySelected = function (dayId) {
                return !_.isNil(_.find(vm.basicInfoModel.data.UtilisationDays, function (day) {
                    return parseInt(day) === parseInt(dayId)
                }));
            };

        }

        /** @ngInject */
        function linkFunc(scope, elem, attrs) {
            scope.$on('asset:performValidation', function (e, d) {
                if (scope.stockLevelForm.$invalid) {
                    scope.stockLevelForm.$submitted = true;
                    // scope.stockLevelForm.$pristine = false;
                    // scope.stockLevelForm.$dirty = true;
                    return;
                }
            });
        }
    }
})();

/**
 * Remove Stock Controller
 * Created date: 7.13.2016
 */
(function() {
    'use strict';

    angular
    .module('app.assets.manage.item')
    .controller('RemoveStockController', RemoveStockController);

   /** @ngInject */
   function RemoveStockController($log, $scope, $q, $mdDialog, blockUI, $timeout, locals, _) { 
        var vm = this;

        vm.branch;
        vm.branches;
        vm.itemType;
        vm.qty;
        vm.reason;   
        vm.itemTypes = [];

        vm.onAdd = onAdd;
        vm.onCancel = onCancel;

        activate();

        //////////

        function activate() {
            vm.itemTypes = locals.itemTypes;
            vm.branches = locals.branches;
            vm.showBranch = locals.showBranch;
        }

        function onAdd() {
            
            $mdDialog.hide({ branch: vm.branch, itemType: vm.itemType, qty: vm.qty, reason: vm.reason, showBranch: locals.showBranch });
        }

        function onCancel() {
            $mdDialog.hide();
        }
    }
})();
/**
 * Convert Stock Controller
 * Created date: 7.13.2016
 */
(function() {
    'use strict';

    angular
    .module('app.assets.manage.item')
    .controller('ConvertStockController', ConvertStockController);

   /** @ngInject */
   function ConvertStockController($log, $scope, $q, $mdDialog, blockUI, $timeout, locals, _) { 
        var vm = this;

        vm.branch;
        vm.branches;
        vm.fromItemType;
        vm.toItemType;
        vm.qty;
        vm.reason;   
        vm.fromItemTypes = [];
        vm.toItemTypes = [];

        vm.onAdd = onAdd;
        vm.onCancel = onCancel;
        vm.onConvertStockLevelChange = onConvertStockLevelChange;

        activate();

        //////////

        function activate() {
            vm.fromItemTypes = locals.itemTypes;
            vm.toItemTypes = locals.itemTypes;
            vm.branches = locals.branches;
            vm.showBranch = locals.showBranch;
        }

        function onAdd() {
            $mdDialog.hide({ branch: vm.branch,  showBranch: locals.showBranch, fromItemType: vm.fromItemType, toItemType: vm.toItemType, qty: vm.qty, reason: vm.reason });
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function onConvertStockLevelChange() {
            var clonedItms = angular.copy(vm.fromItemTypes);
            
            _.remove(clonedItms, function(n) { return n.Id == vm.fromItemType.Id; });
            vm.toItemTypes = clonedItms;
        }
    }
})();
/**
 * Create Hire Rate Controller
 * Created date: 6.27.2016
 */
(function() {
    'use strict';

    angular
    .module('app.assets.manage.item')
    .controller('AddStockController', AddStockController);

   /** @ngInject */
   function AddStockController($log, $scope, $q, $mdDialog, blockUI, $timeout, locals, _) { 
        var vm = this;

        vm.branch;
        vm.branches;
        vm.itemType;
        vm.qty;     
        vm.itemTypes = [];

        vm.onAdd = onAdd;
        vm.onCancel = onCancel;

        activate();

        //////////

        function activate() {
            vm.itemTypes = locals.itemTypes;
            vm.branches = locals.branches;
            vm.showBranch = locals.showBranch;
        }

        function onAdd() {
            $mdDialog.hide({ branch: vm.branch, itemType: vm.itemType, qty: vm.qty, showBranch: locals.showBranch });
        }

        function onCancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets.manage.item')
        .directive('relatedItemComponent', relatedItemComponent);

    /** @ngInject */
    function relatedItemComponent(basicInfoService,
        assetsApi,
        $mdDialog) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/item/relatedItem/related-item.html',
            controller: relatedItemController,
            controllerAs: 'relatedItemVm',
            bindToController: true
        };

        var locals = {};

        return directive;

        function relatedItemController() {

            var vm = this;
            vm.service = basicInfoService;
            vm.dtOptions = {
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
            };

            vm.onAddRelatedItem = onAddRelatedItem;
            vm.onEdit = onEdit;
            vm.remove = remove;

            function onAddRelatedItem() {
                assetsApi.getItems().then(function(resp) {
                    locals = {};
                    locals.itemList = resp.data;
                    showModal();
                });
            }

            function remove(index) {
                vm.service.data.ItemPrerequisites.splice(index, 1)
            }

            function onEdit(id) {
                assetsApi.getItems().then(function(resp) {
                    locals = {};
                    locals.itemList = resp.data;
                    showModal(id);
                });
            }

            function showModal(id) {
                if (id) {
                    var toEdit = alasql('select * from ? where id = ?', [basicInfoService.data.ItemPrerequisites, id])[0];
                    locals.dataToEdit = toEdit;
                }

                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/main/assets/manage/item/relatedItem/related-item-dialog.html',
                    controller: 'RelatedItemDialogController as relatedItemVm',
                    locals: locals
                }).then(function(result) {
                    if (result) {
                        var item = result.data;
                        var found = alasql('select * from ? where id = ?', [basicInfoService.data.ItemPrerequisites, item.id]);

                        //Add the qty if item already exists on the list
                        if(found.length > 0){
                          angular.forEach(basicInfoService.data.ItemPrerequisites, function(item){
                            if(item.id == found[0].id){
                              item.Qty = parseInt(item.Qty) + parseInt(result.data.Qty);
                            }
                          });
                        }
                        else{
                          //if item does not exist on the list
                          basicInfoService.data.ItemPrerequisites.push(item);
                        }
                      }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
    .module('app.assets.manage.item')
    .controller('RelatedItemDialogController', RelatedItemDialogController);

   /** @ngInject */
   function RelatedItemDialogController(utils,
                                        $mdDialog,
                                        basicInfoService,
                                        locals) {
        var vm = this;
        var isEditMode = false;

        vm.itemSelected;
        vm.qty = null;
        vm.isRequired = true;
        vm.searchText = null;
        vm.itemList = [];
        vm.selectedItem = null;
        vm.originalItem = null;
        vm.headerTitle = null;
        vm.btnTitle = null;
        vm.utilService = utils;

        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.searchTextChange = searchTextChange;
        vm.onAdd = onAdd;
        vm.onCancel = onCancel;

        activate();

        function activate() {
            vm.itemList = locals.itemList.filter(function(item) {
                return item.ItemTypes.some(function(itemType) {
                    return itemType === 4;
                });
            });

            if (locals.dataToEdit) {
                isEditMode = true;
                vm.itemSelected = locals.dataToEdit;
                vm.originalItem = locals.dataToEdit;
                vm.qty = locals.dataToEdit.Qty;
                vm.isRequired = !locals.dataToEdit.IsOptional;
                vm.headerTitle = vm.utilService.translate('ASSETSMODULE.RELATED_ITEM_DIALOG_EDIT_TITLE');
                vm.btnTitle = vm.utilService.translate('ASSETSMODULE.RELATED_ITEM_DIALOG_EDIT_BUTTON');
                return;
            }

            vm.qty = 1;
            vm.isRequired = true;
            vm.headerTitle = vm.utilService.translate('ASSETSMODULE.RELATED_ITEM_DIALOG_ADD_TITLE');
            vm.btnTitle = vm.utilService.translate('ASSETSMODULE.RELATED_ITEM_DIALOG_ADD_BUTTON');
        }

        function onAdd() {
            if(vm.originalItem){
              angular.forEach(basicInfoService.data.ItemPrerequisites, function(item, key){
                if(item.id == vm.originalItem.id){
                  basicInfoService.data.ItemPrerequisites.splice(key, 1);
                }
              });
            }

            var item = angular.copy(vm.itemSelected);
            item.Qty =  vm.qty;
            item.IsOptional = !vm.isRequired;

            $mdDialog.hide({ data: item, isEdit: isEditMode });
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function querySearch(query) {
            var results = query ? vm.itemList.filter(createFilterFor(query)) : vm.itemList;
            return results;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(emp) {
                return (angular.lowercase(emp.ItemName).indexOf(lowercaseQuery) > -1);
            };
        }

        function searchTextChange(text) {
        }

        function selectedItemChange(item) {
        }
    }
})();

/**
 * Basic
 * Created date: 6.27.2016
 */
(function () {
    'use strict';

    angular.module('app.assets.manage.item')

           .directive('peopleSkillComponent', peopleSkillComponent);

    /** @ngInject */
    function peopleSkillComponent(basicInfoService,
                                  DTColumnDefBuilder,
                                  $mdDialog,
                                  utils,
                                  skillsMatrixApi,
                                  _) {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/main/assets/manage/item/peopleSkill/people-skill.html',
        controller: peopleSkillController,
        controllerAs: 'peopleSkillVm',
        bindToController: true
      };

      var locals = {};

      return directive;

      function peopleSkillController(){

        //Variables
        var vm = this;
        vm.service = basicInfoService;
        vm.utilService = utils;
        var locals = {};
        vm.dtOptions = {
          pagingType: 'simple',
          autoWidth: false,
          responsive: true
        };

        vm.dtColumns = [
          DTColumnDefBuilder.newColumnDef(0).withClass('all'),
          DTColumnDefBuilder.newColumnDef(4).withClass('all')
        ];

        //Methods
        vm.onAdd = onAdd;
        vm.onEdit = onEdit;
        vm.onRemove = onRemove;
        vm.getLockOut = getLockOut;

        function onAdd() {
          locals['isEditMode'] = false;
          showModal();
        }

        function onEdit(skill) {
          locals['isEditMode'] = true;
          locals['currentSkill'] = skill;
          showModal(locals);
        }

        function onRemove(skill){
          angular.forEach(basicInfoService.data.ItemRequiredSkills, function(itm){
            if(skill.GroupName == itm.GroupName){
              angular.forEach(itm.Skills, function(skl, key){
                if(skill.SkillName == skl.SkillName){
                  itm.Skills.splice(key, 1);
                }
              });
            }
          });
          basicInfoService.formatSkills();
        }

        function showModal() {
          skillsMatrixApi.getSkillsByBranch(basicInfoService.data.Branches).then(function(resp){
            locals['skills'] = resp.data;
            $mdDialog.show({
              parent: angular.element(document.body),
              templateUrl: 'app/main/assets/manage/item/peopleSkill/people-skill-dialog.html',
              controller: 'PeopleSkillDialogController as peopleSkillVm',
              locals: locals
            }).then(function(result) {
              if(result)
                basicInfoService.formatSkills();
            });
          });
        }

        function getLockOut(lockoutType){
          if(lockoutType == 0){
            return 	vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_NO_LOCKOUT');
          }
          if(lockoutType == 1){
            return vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_SOFT_LOCKOUT');
          }
          if(lockoutType == 2){
            return vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_MEDIUM_LOCKOUT');
          }
          if(lockoutType == 3){
            return vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_HARD_LOCKOUT');
          }
        }
      }
    }

})();

/**
 * Create Kit Item Controller
 * Created date: 7.11.2016
 */
(function () {
    'use strict';

    angular
      .module('app.assets.manage.item')
      .controller('PeopleSkillDialogController', PeopleSkillDialogController);

    /** @ngInject */
    function PeopleSkillDialogController($mdDialog,
                                         blockUI,
                                         _,
                                         basicInfoService,
                                         itemManagerService,
                                         branchService,
                                         $mdToast,
                                         utils,
                                         locals) {
      //Variables
      var vm = this;
      vm.isEditMode = locals.isEditMode;
      vm.skillsLookUps = [];
      vm.skillGroups = basicInfoService.data.ItemRequiredSkills;
      vm.utilService = utils;
      vm.skillsbybranch = locals.skills;

      //Methods
      vm.onAdd = onAdd;
      vm.onCancel = onCancel;
      vm.getGroupKey = getGroupKey;

      activate();

      //Implementations
      function activate() {
        blockUI.start(vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_FETCHING_BRANCHES'));
        branchService.getAllBranches().then(function (resp) {
          vm.branches = resp;
          setLookUps();
          if (vm.isEditMode) {
            vm.headerTitle = vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_EDIT_SKILL');
            vm.lockOutType = locals.currentSkill.LockoutType;
            vm.chosenSkill = alasql('select * from ? where id = ?', [vm.skillsLookUps, locals.currentSkill.id])[0];
            vm.chosenSkill['Id'] = _.isNil(vm.chosenSkill) ? null : vm.chosenSkill.id;
            vm.Branches = locals.currentSkill.Branches;
          } else {
            vm.headerTitle = vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_ADD_SKILL');
          }
          vm.btnTitle = 	vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_SAVE');
          blockUI.stop();
        }).catch(function (err) {
          blockUI.stop();
        });
      }

      function onAdd() {
        var counter = 0;
        if (vm.isEditMode) {
          angular.forEach(vm.skillGroups, function(skill){
            angular.forEach(skill.Skills, function(skill2){
              if((vm.chosenSkill.Id === skill2.id) && (locals.currentSkill.id != vm.chosenSkill.Id)){
                counter++;
              }
            });
          });

          if(counter > 0){
            $mdDialog.hide(true);
            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_DUPLICATE_SKILLS_ARE_NOT_ALLOWED'))
                .position('bottom right')
                .hideDelay(1000)
            );
            return false;
          }

          var groupKey = vm.getGroupKey(locals.currentSkill.GroupName);
          angular.forEach(vm.skillGroups[groupKey].Skills, function (skl, key) {
            if (skl.SkillName == locals.currentSkill.SkillName) {
              vm.skillGroups[groupKey].Skills.splice(key, 1);
            }
          });
        }
        else {
          let match = alasql('select * from ? where id = ?', [basicInfoService.data.ItemRequiredSkillsFormatted, vm.chosenSkill.Id]);
          if (match.length > 0) {
            $mdDialog.hide(true);
            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.utilService.translate('ASSETSMODULE.PEOPLE_SKILL_DUPLICATE_SKILLS_ARE_NOT_ALLOWED'))
                .position('bottom right')
                .hideDelay(1000)
            );
            return;
          }
        }

        let group = getGroup(vm.chosenSkill);
        let groupkey = vm.getGroupKey(group.GroupName);

        if (groupkey == null) {
          let data = formSkillAndGroup();
          vm.skillGroups.push(data)
        } else {
          let data = formSkill();
          vm.skillGroups[groupkey].Skills.push(data);
        }
        $mdDialog.hide(true);
      }

      function getGroup(skill) {
        let result = _.find(vm.skillsLookUps, {id: skill.Id});
        return result;
      }

      function getGroupKey(name) {
        let key = _.findIndex(vm.skillGroups, {'GroupName': name});
        return (key === -1 ? null : key);
      }

      function formSkillAndGroup() {
        let selectedSkill = alasql('select * from ? where id = ?', [vm.skillsLookUps, vm.chosenSkill.Id]);
        let skillGroup = {id: selectedSkill[0].GroupId, GroupName: selectedSkill[0].GroupName, Skills: []}
        var skill = {
          id: selectedSkill[0].id,
          SkillName: selectedSkill[0].SkillName,
          LockoutType: vm.lockOutType,
          Branches: vm.Branches === undefined ? [] : vm.Branches
        }
        skillGroup.Skills.push(skill);
        return skillGroup;
      }

      function formSkill() {
        var skill = {
          id: vm.chosenSkill.Id,
          SkillName: vm.chosenSkill.Name,
          LockoutType: vm.lockOutType,
          Branches: vm.Branches
        }
        return skill;
      }

      function onCancel() {
        $mdDialog.hide();
      }

      function setLookUps() {
        let skillsWithParent = [];
        let skillsWithoutParent = [];
        angular.forEach(itemManagerService.skillGroupsLookUp.data, function (itm) {
          angular.forEach(itm.Skills, function (skill) {
            if (skill.ParentId) {
              skill['GroupName'] = itm.GroupName;
              skill['GroupId'] = itm.id;
              skill['Selected'] = false;
              skillsWithParent.push(skill);
            } else {
              skill['GroupName'] = itm.GroupName;
              skill['GroupId'] = itm.id;
              skill['Selected'] = false;
              skillsWithoutParent.push(skill);
            }
          });
        });

        angular.forEach(skillsWithoutParent, function (skl) {
          let counter = alasql('select * from ? where ParentId = ?', [skillsWithParent, skl.id]);
          if (counter.length === 0) {
            skillsWithParent.push(skl);
          }
        });

        vm.skillsLookUps = angular.copy(skillsWithParent);

        let finalskills = [];
        angular.forEach(vm.skillsLookUps, function(lookup){
          angular.forEach(vm.skillsbybranch, function(lookupbybranch){
            if(lookupbybranch.Id === lookup.id){
              finalskills.push(lookupbybranch);
            }
          });
        });

        vm.skillsbybranch = angular.copy(finalskills);
      }
    }
  })();

(function() {
    'use strict';

    angular
        .module('app.assets.manage.item')
        .controller('ItemViewController', ItemViewController);

    /** @ngInject */
    function ItemViewController(
        searchDelay,
        itemGridService,
        itemGridData,
        DTColumnDefBuilder,
        _,
        claimsUtilService
    ) {
        var vm = this;

        vm.model = itemGridService;
        vm.dtInstance = {};
        vm.gridModel = itemGridData;
        vm.dtOptions = {
            pagingType: 'full',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            initComplete: function() {
                searchTable();
            }
        };

        vm.dtColumns = [
            DTColumnDefBuilder.newColumnDef(0).withClass('all'),
            DTColumnDefBuilder.newColumnDef(3).withClass('all')
        ];

        vm.addNew = addNew;
        vm.onEdit = onEdit;
        vm.onRemove = onRemove;
        vm.searchTable = searchTable;

        vm.canDeleteItem = claimsUtilService.isCustomerOnboardingEnabled();

        function searchTable() {
            if (!_.isNil(vm.model.query)) {
                setTimeout(function() {
                    vm.dtInstance.DataTable.search(vm.model.query);
                    vm.dtInstance.DataTable.search(vm.model.query).draw();
                }, searchDelay);
            }
        }

        function addNew() {
            itemGridService.createItem();
        }

        function onEdit(itemId, itemName) {
            itemGridService.editItem(itemId, itemName);
        }

        function onRemove(itemId, itemName) {
            itemGridService.removeItem(itemId, itemName);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets.manage.item')
        .directive('individualItemComponent', individualItemComponent);

    /** @ngInject */
    function individualItemComponent(
        utils,
        DTColumnDefBuilder,
        individualItemGridService,
        exceptionService,
        basicInfoService,
        importFileService,
        stockLevelService,
        assetsClaimService
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/item/individualItem/individual-item.html',
            controller: individualItemController,
            controllerAs: 'indvItemVm',
            bindToController: true
        };

        return directive;

        function individualItemController() {
            var vm = this;
            vm.utilService = utils;
            vm.model = individualItemGridService;
            vm.hasEditIndividualItem = assetsClaimService.hasEditIndividualItem;
            
            vm.dtOptions = {
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
            };

            vm.dtColumns = [
                DTColumnDefBuilder.newColumnDef(0).withClass('all'),
                DTColumnDefBuilder.newColumnDef(5).withClass('all')
            ];

            vm.onAdd = onAdd;
            vm.onEdit = onEdit;
            vm.onImport = onImport;
            vm.onViewApprovals = onViewApprovals;
            vm.hasVehicleType = hasVehicleType;
            vm.hasUserBranchConflict = hasUserBranchConflict;

            activate();

            function activate() {};

            function hasVehicleType() {
                return _.find(basicInfoService.data.ItemTypes, function(o) {
                    return o.Id == 5;
                });
            }

            function onAdd() {
                importFileService.showDialog(null);
            };

            function onEdit(id) {
                importFileService.showDialog(id);
            };

            function onViewApprovals(id) {
                individualItemGridService.showApprovals(id);
            }

            function onImport() {
                var promise = importFileService.onImport();

                promise.then(function(resp) {
                    if (resp === true) {
                        individualItemGridService.loadGridData(basicInfoService.data.id);
                        stockLevelService.refreshStockLevelCounts(basicInfoService.data.id);
                    }
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
            }

            function hasUserBranchConflict(vehicle){
                let hasConflicts = false;
    
                if (vehicle) {
                    hasConflicts = vehicle.HasUserBranchConflict;
                }
                else {
                    hasConflicts = vm.model.data.some(function (vehicle) {
                        return vehicle.HasUserBranchConflict;
                    });
                }
    
                return hasConflicts;
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets.manage.item')
        .controller('individualItemDialogController', individualItemDialogController);

    /** @ngInject */
    function individualItemDialogController($scope,
        claimsUtilService,
        locals,
        individualItemService,
        _,
        utils,
        vehicleService,
        assetsClaimService) {

        var vm = this;

        // Data
        vm.itemStates = [];
        vm.itemTypes = [];
        vm.vehicleOwnershipTypes = [];
        vm.depreciationTypes = [];
        vm.itemBranches = [];
        vm.branches = [];
        vm.costCodes = [];
        vm.minEndDate = null;
        vm.model = individualItemService;
        vm.userContactList = [];
        vm.searchText;
        vm.utilService = utils;
        vm.hasVehicleType = false;
        vm.vehicleService = vehicleService;
        vm.showStatusEffectiveDate = false;
        vm.hasEditIndividualItem = false;
        vm.claimsUtilService = claimsUtilService;
        vm.assetsClaimService = assetsClaimService;


        // Autocomplete
        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.searchTextChange = searchTextChange;

        // Methods
        vm.onCancel = onCancel;
        vm.onEdit = onEdit;
        vm.onRemove = onRemove;
        vm.onAddUpdate = onAddUpdate;
        vm.onAddDepreciation = onAddDepreciation;
        vm.getDepreciationTypeName = getDepreciationTypeName;
        vm.isItemTypeDisabled = isItemTypeDisabled;

        activate();

        function activate() {

            vm.vehicleService.getVehiclesMakesAndModels();

            individualItemService.hasChangesEvent = hasChangesEvt;
            individualItemService.resetData();

            var branchLookups = locals.branches.filter(function(o) {
                for (let i in locals.itemBranches) {
                    if (locals.itemBranches.length > 0 && o.Id != locals.itemBranches[i].Id) {
                        continue;
                    }
                    return true;
                }
            });

            vm.editData = locals.editData;
            vm.itemStates = locals.itemStates;
            vm.itemTypes = locals.itemTypes;
            vm.branches = branchLookups;
            vm.costCodes = locals.costCodes;
            vm.userContactList = [];
            vm.vehicleOwnershipTypes = locals.vehicleOwnershipTypes;
            vm.hasEditIndividualItem = assetsClaimService.hasEditIndividualItem;
            individualItemService.users = [];
            individualItemService.branchesLookup = branchLookups;

            var itemTypesHasVehicleCheck = vm.itemTypes.find(function(o) {
                return o.Id == 5;
            });
            if (itemTypesHasVehicleCheck) {
                vm.hasVehicleType = true;
            }

            if (locals.editData) {
                individualItemService.load(locals.editData).then(function() {
                    vm.OriginalItemStatus = vm.model.data.ItemStatus;
                });
            }
        }

        function onAddUpdate() {
            if ($scope.IndividualItemEntryForm.$invalid)
                return;

            if (!individualItemService.isEditMode)
                individualItemService.save(locals.itemId);
            else
                individualItemService.update(locals.editData);
        }

        function onCancel() {
            individualItemService.hideDialog();
        }

        function onAddDepreciation() {
            individualItemService.showDepreciationDialog();
        }

        function onEdit(id) {
            individualItemService.showDepreciationDialog(id);
        }

        function onRemove(index) {
            vm.model.data.Depreciation.splice(index, 1);
            individualItemService.remove();
        }

        function getDepreciationTypeName(id) {
            var depreciation = vm.depreciationTypes.filter(function(o) {
                return o.Id == id;
            })[0];
            return depreciation.Name;
        }

        function querySearch(query) {

            var results = query ? individualItemService.users.filter(createFilterFor(query)) : individualItemService.users;
            return results;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(emp) {
                return (angular.lowercase(emp.FullName).indexOf(lowercaseQuery) > -1);
            };
        }

        function searchTextChange(text) {}

        function selectedItemChange(item) {
            var id = item ? item.id : null;
        }

        function hasChangesEvt() {
            $scope.IndividualItemEntryForm.$setDirty();
        }

        vm.isVehicle = function() {
            return vm.model.data.ItemType && vm.model.data.ItemType.Id === 5;
        };

        vm.hasItemStatusChange = function() {
            vm.model.data.StatusEffectiveDate = parseInt(vm.OriginalItemStatus) !== parseInt(vm.model.data.ItemStatus) ? new Date() : null;
            vm.showStatusEffectiveDate = parseInt(vm.OriginalItemStatus) !== parseInt(vm.model.data.ItemStatus);
        };

        function isItemTypeDisabled(item){
            debugger
            return item && item.Name === "Asset" && !assetsClaimService.hasCreateNewIndividualItem;
        }
    };
})();


(function () {
  'use strict';

  angular.module('app.assets.manage.item')
    .controller('individualItemApprovalDialogController', individualItemApprovalDialogController);

  /** @ngInject */
  function individualItemApprovalDialogController($mdDialog) {

      //Data
      var vm = this;
      vm.dtOptions = {
        dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        autoWidth: false,
        responsive: true,
        pageLength: 5,
        lengthMenu: [[5, 10], [5, 10]],
        ordering: false
      };

      //Methods
      vm.onClose = onClose;

      function onClose(){
        $mdDialog.hide();
      }

  };
})();

/**
 * Individual Item
 * Created date: 6.27.2016
 */
(function () {
    'use strict';

    angular.module('app.assets.manage.item')
        .controller('importErrorDialogController', importErrorDialogController);

    /** @ngInject */
    function importErrorDialogController($mdDialog, locals) {
        var vm = this;

        vm.issues = locals.issues;
        vm.onDone = onDone;
        vm.onCancel = onCancel;

        activate();
        ///////

        function activate() {
        }

        function onDone() {
            $mdDialog.hide();
        }

        function onCancel() {

        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets.manage.item')
        .controller('importDialogController', importDialogController);

    /** @ngInject */
    function importDialogController(
        $mdDialog,
        utils,
        locals,
        tenantSettings,
        exceptionService
    ) {
        var vm = this;

        vm.fileName = null;
        vm.utilService = utils;
        vm.uploadUrl = tenantSettings.coreApiUrl + 'api/Individual/upload/' + locals.itemId;
        vm.onCancel = onCancel;
        vm.onUploadCompleted = onUploadCompleted;
        vm.onUploadError = onUploadError;
        vm.onUploadStart = onUploadStart;
        vm.onUploadProgress = onUploadProgress;
        vm.onUploadValidate = onUploadValidate;
        vm.showProgress = false;

        activate();
        ///////

        function activate() {}

        function onCancel() {
            $mdDialog.hide();
        }

        function onUploadError(ex) {
            exceptionService.resolve(ex);
        }

        function onUploadStart() {
            vm.showProgress = true;
        }

        function onUploadCompleted(data) {
            $mdDialog.hide(data);
            vm.showProgress = false;
        }

        function onUploadProgress(filename) {
            vm.fileName = filename;
        }

        function onUploadValidate(fileObj) {
            var ext = utils.getFileExtension(fileObj.name);
            var isValid = true;

            if (ext != '.xlsx' && ext != '.xls' && ext != '.ods' && ext != '.csv' && ext != '.jpeg' && ext != '.jpg' && ext != '.png' && ext != '.gif') {
                isValid = false;
                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(vm.utilService.translate('ASSETSMODULE.IMPORT_DIALOG_INVALID_FILE'))
                    .content(vm.utilService.translate('ASSETSMODULE.IMPORT_DIALOG_IMPORT_FILE_EXT'))
                    .ariaLabel(vm.utilService.translate('ASSETSMODULE.IMPORT_DIALOG_IMPORT_FILE'))
                    .ok(vm.utilService.translate('ASSETSMODULE.IMPORT_DIALOG_OK'))

                $mdDialog.show(notif);
            }

            return isValid;
        }

    }
})();

/**
 * Depreciation Item
 * Created date: 7.4.2016
 */
(function () {
    'use strict';
    
    angular.module('app.assets.manage.item')
           .controller('depreciationDialogController', depreciationDialogController);
    
    /** @ngInject */
    function depreciationDialogController($mdDialog, locals, depreciationModel) {
         var vm = this;

         // Data
         vm.model = new depreciationModel();
         var isEditMode = false;

         // Actions
         vm.onCancel = onCancel;
         vm.onAdd = onAdd;

         activate();

         ///////
         function activate() {
            // Check for editing
            if (locals.dataToEdit) {
                isEditMode = true;
                vm.model.map({
                    id: locals.dataToEdit.id,
                    Year: locals.dataToEdit.Year,
                    YearText: locals.dataToEdit.YearText,
                    PercentPerYear: locals.dataToEdit.PercentPerYear
                });
            }
         }

         function onAdd() {
            $mdDialog.hide({ data: vm.model });
         }

         function onCancel() {
             $mdDialog.hide();
         }

    }
})();
(function() {
    'use strict';

    angular.module('app.assets.manage.item')
        .directive('basicCreateItemComponent', basicCreateItemComponent);

    /** @ngInject */
    function basicCreateItemComponent(
        basicInfoService,
        itemManagerService,
        a8TreeMdBoxService,
        _,
        utils,
        claimsUtilService,
        lookupApi,
        oldAwardAPI,
        tenantSettings,
        $q
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/item/basic/basic-create-item.html',
            controller: basicCreateItemController,
            controllerAs: 'basicInfoVm',
            bindToController: true
        };

        return directive;

        function basicCreateItemController($scope, $stateParams) {
            var self = this;
            var isFirstLoad = true;
            self.model = basicInfoService;
            self.utilService = utils;
            self.shiftRoles = itemManagerService.shiftRoles;
            self.branches = itemManagerService.branchesLookup;
            self.itemTypes = _.reject(itemManagerService.itemTypesLookup, {
                'Name': 'People'
            });

            self.vehicleOwnershipTypes = itemManagerService.vehicleOwnershipTypesLookup;
            self.taxTypes = itemManagerService.taxTypesLookup;
            self.onItemTypeChange = onItemTypeChange;
            self.onRequiresOperatorChange = onRequiresOperatorChange;
            self.onRequiresLinkedItemsChange = onRequiresLinkedItemsChange;
            self.categories = [];
            self.nodes = [];
            self.selectedParentNodes = [];
            self.selectedChildren = [];
            self.categoryModel = a8TreeMdBoxService;
            self.country = tenantSettings.countryCode;
            self.claimsUtilService = claimsUtilService;
            self.awardsLookup = itemManagerService.awardsLookup.filter(x=> !x.IsArchived);
            self.awardClassificationsLookup = itemManagerService.awardClassificationsLookup;
            self.onBranchChange = onBranchChange;
            self.onAwardChange = onAwardChange;
            self.clonedBasicInfoService = angular.copy(basicInfoService);
            self.itemManagerService = itemManagerService;
            activate();

            function activate() {
                refreshClassificationLookups();
                itemManagerService.loadCategoryTree();
                a8TreeMdBoxService.onSelected = onSelected;
                lookupApi.getNewBillingPeriodValues3().then(function(resp) {
                    self.BillingPeriods = resp.data;
                }).catch(function() {
                    self.BillingPeriods = [];
                });
            }

            $scope.$watch("basicInfoVm.categoryModel", function(modelAfterChange, modelBeforeChange) {
                var categoriesAfterChange = modelAfterChange.getSelectedItems();
                self.model.data.Categories = categoriesAfterChange;
            }, true);

            $scope.$watch("basicInfoVm.model.data", function(modelAfterChange, modelBeforeChange) {
                if(isFirstLoad && self.model.data.Award != null && $stateParams.id != null){
                    self.awardsLookup = itemManagerService.awardsLookup.filter(function(award) {
                        if (!award.IsArchived || award.Id == self.model.data.Award.Id) {
                            return award;
                        }
                    });
                }
                if (modelBeforeChange.id == null && modelAfterChange.id != null) {
                    self.clonedBasicInfoService = angular.copy(modelAfterChange);
                    itemManagerService.isDirty = false;
                }
                if (modelBeforeChange.id != null && modelAfterChange.id != null) {
                    var basicInfoRawData = self.clonedBasicInfoService;
                    var modifiedFields = getChangeSet(modelAfterChange, basicInfoRawData);
                    itemManagerService.isDirty = modifiedFields.length > 0
                } else if (modelBeforeChange.id == null && modelAfterChange.id == null) {
                    itemManagerService.isDirty = true;

                }

            }, true);

            function getChangeSet(modelAfterChange, modelBeforeChange) {
                var modifiedFields = getModifiedObjectKeys(modelBeforeChange, modelAfterChange);
                return modifiedFields;
            }

            function getArrayObjectProperties(objectBeforeChange) {
                var _obj = [];
                Object.keys(objectBeforeChange)
                    .forEach(function(x) {
                        if (typeof(objectBeforeChange[x]) == "object") {
                            _obj.push(x);
                        }
                    });
                return _obj;
            }

            function getModifiedObjectKeys(objectBeforeChange, objectAfterChange) {
                var modifiedFields = [];
                var objectProperties = getArrayObjectProperties(objectBeforeChange);
                var isChanged = function(x, y) {
                    if (angular.equals(x, y)) {
                        return false;
                    } else {
                        return true;
                    }
                };

                if (objectAfterChange == null) {
                    return;
                }

                Object.keys(objectAfterChange)
                    .forEach(function(x) {
                        if (typeof(objectAfterChange[x]) != "function") {
                            if (objectAfterChange[x] == null || objectAfterChange[x].length == 0) {
                                if (isChanged(objectAfterChange[x], objectBeforeChange[x])) {
                                    modifiedFields.push(x);
                                }
                            } else if (typeof(objectAfterChange[x]) == "object" && typeof(objectBeforeChange[x]) == "object") {
                                var _subObjectBeforeChange = objectAfterChange[x];
                                var _subObjectAfterChange = objectBeforeChange[x];
                                if (Array.isArray(objectAfterChange[x])) {
                                    _subObjectBeforeChange = objectAfterChange[x].filter(function(x) {
                                        return typeof(x) == "object" || typeof(x) == "number" || typeof(x) == "string"
                                    });

                                    _subObjectAfterChange = objectBeforeChange[x].filter(function(x) {
                                        return typeof(x) == "object" || typeof(x) == "number" || typeof(x) == "string"
                                    });
                                }
                                if (objectProperties.indexOf(x) > -1) {
                                    if (x == "ItemTypes") {
                                        var itemTypeSubObjectBeforeChange = angular.copy(_subObjectBeforeChange);
                                        itemTypeSubObjectBeforeChange.forEach(function(z) {
                                            delete z.Selected;
                                        });
                                        if (isChanged(_subObjectAfterChange, JSON.parse(angular.toJson(itemTypeSubObjectBeforeChange)))) {
                                            modifiedFields.push(x);
                                        }
                                    } else {
                                        if (isChanged(_subObjectAfterChange, JSON.parse(angular.toJson(_subObjectBeforeChange)))) {
                                            modifiedFields.push(x);
                                        }
                                    }

                                }

                            } else if (isChanged(objectAfterChange[x], objectBeforeChange[x])) {
                                modifiedFields.push(x);
                            }
                        }
                    });
                return modifiedFields;
            }

            function onSelected(node) {
                self.nodes = node;
                self.selectedChildren = [];
                self.selectedParentNodes = alasql('select label from ? where selected = ?', [self.nodes, true]);

                angular.forEach(self.nodes, function(node) {
                    var selected = alasql('select label from ? where selected = ?', [node.children, true]);
                    if (selected.length > 0) {
                        self.selectedChildren.push(selected);
                    }
                });
            }

            function onBranchChange() {
                refreshClassificationLookups();
            }

            function onAwardChange() {
                if(self.model.data.AwardClassification !=null && isFirstLoad){
                    isFirstLoad = false;
                }
                else{
                    refreshClassificationLookups();
                }
            }

            function refreshClassificationLookups() {
                self.model.data.AwardClassification = null;
                let award = self.model.data.Award;
                let selectedBranches = self.model.data.Branches;

                angular.forEach(self.awardClassificationsLookup, function(classification) {
                    classification.isDisabled = true;
                });

                if (!_.isNil(award) && !_.isEmpty(award)) {

                    if (!_.isNil(selectedBranches)) {

                        angular.forEach(selectedBranches, function(branch) {
                            if (!_.isNil(branch)) {
                                let deferred = $q.defer();

                                oldAwardAPI.getClassificationsByAwardAndBranch(award.Id, branch.Id)
                                    .then(function(resp) {
                                        let classificationsByBranchAndAward = [];
                                        classificationsByBranchAndAward = resp.data;
                                        deferred.resolve(resp.data);

                                        angular.forEach(self.awardClassificationsLookup, function(classification) {

                                            if (!_.isNil(classificationsByBranchAndAward)) {

                                                var itemIndex = _.findIndex(classificationsByBranchAndAward, function(o) {
                                                    return o.Id === classification.Id;
                                                })

                                                if (itemIndex !== -1) {
                                                    classification.isDisabled = false;
                                                }
                                            }
                                        });

                                    }).catch(function(ex) {
                                        deferred.reject(ex);
                                    });
                            }
                        });
                    }
                }
            }

            // "Requires Operator" and "Requires Linked Items" are mutually exclusive:
            // an item can require neither, but not both. Ticking one clears the other.
            // Only enforced while linking is enabled: with the feature off the linked-items
            // checkbox is hidden, so clearing it here would silently discard a stored
            // configuration the user cannot see or restore.
            function onRequiresOperatorChange() {
                if (self.model.data.RequiresOperator && claimsUtilService.isLinkedItemsEnabled()) {
                    self.model.data.RequireToBeLinked = false;
                }
            }

            function onRequiresLinkedItemsChange() {
                if (self.model.data.RequireToBeLinked) {
                    self.model.data.RequiresOperator = false;
                }
            }

            function onItemTypeChange() {
                let itemTypeDropdown = basicInfoService.data.ItemTypes;

                var hasInventory = itemTypeDropdown.find(function (item) {
                    return item.Id === 2;
                });

                var isValid = !(hasInventory && itemTypeDropdown.length > 1);

                $scope.basicInfoForm.itemType2.$setValidity('valid', isValid);

                itemManagerService.changeItemType();
            }
        }
    }
})();

/**
 * CostCode
 * Created date: 6.27.2016
 */
(function () {
    'use strict';
    
    angular.module('app.assets.manage.item')
           .directive('costCodeComponent', costCodeComponent);

    /** @ngInject */
    function costCodeComponent(itemManagerService, costCodeEntryService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/item/costCode/cost-code.html',
            controller: costCodeController,
            controllerAs: 'costCodeVm',
            bindToController: true  
        };

        return directive;

        function costCodeController() {
            var vm = this;

            //vm.onAddHireRate = addHireRate;
            vm.onRemove = onRemove;
            vm.onEdit = onEdit;

            vm.model = costCodeEntryService;
            vm.costCodeLookup = itemManagerService.costCodesLookup;
            vm.hireRateData = itemManagerService.hireRateData;

            activate();

            ///////

            function activate() {

            }

            function onRemove() {
                alert('Remove');
            }

            function onEdit() {
                alert('Edit');
            }
        
        }
    }       

})();
/**
 * Status Component
 */
(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('a8GridStatusComponent', a8GridStatusComponent);

    /** @ngInject */
    function a8GridStatusComponent($http, $timeout, $rootScope) {
        var directive = {
            restrict: 'E',
            scope: {},
            require: '^a8GridComponent',
            templateUrl: 'app/shared/widgets/a8PaginationGrid/status/a8GridStatus.html',
            controller: GridStatusController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function link($scope, elems, attrs, controller) {
            var vm = $scope.vm;
            controller.onSetStatus(function(val) {
                vm.status = val;
            });

        }

        function GridStatusController() {}

    }
})();
/**
* Sort Column Component
*/
(function () {
    'use strict';
    angular.module('app.widgets')
        .directive('a8SortColumn', a8SortColumn);

    /** @ngInject */
    function a8SortColumn() {
        var directive = {
            restrict: 'E',
            scope: {
                sortBy: '@',
                fieldLabel: '@',
                onSort: '&',
                default: '@',   // True or False
                initialDefaultDir: '@', // Initial default direction
                api: '='
            },
            require: '^a8GridComponent',
            templateUrl: 'app/shared/widgets/a8PaginationGrid/sort/a8SortColumn.html',
            controller: SortColumnController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function link($scope, elems, attrs, controller) {
            var vm = $scope.vm;

            vm.sortDir = 'asc';
            vm.onClickSort = onClickSort;
            vm.sortDirections = [['icon-unfold-more', '-'], ['icon-chevron-up', 'asc'], ['icon-chevron-down', 'desc']];

            vm.ctr = 0;
            vm.icon = vm.sortDirections[0][0];

            controller.onSortReset(function () {
                vm.icon = vm.sortDirections[0][0];
                vm.sortDir = vm.sortDirections[0][1];
            });

            if (vm.api) {
                vm.api.sortDir = vm.sortDir;
                vm.api.onClickSort = onClickSort;
            }

            activate();

            function activate() { 
                // Set default sort column if set
                if (vm.default && vm.default.toLowerCase() == 'true')
                    controller.setSortProps({ defaultSortColumn: vm.sortBy, hasDefaultSortColumn: true, initialDefaultDir: !!vm.initialDefaultDir ? vm.initialDefaultDir : 'asc' });
            }

            function onClickSort() {
                controller.sortReset();
                let sortRes = toggleSortDirection();

                vm.icon = sortRes.icon;
                vm.sortDir = sortRes.sortDir;
                if (vm.api) vm.api.sortDir = sortRes.sortDir;

                controller.sort({ sortParams: { sortBy: vm.sortBy, sortDir: vm.sortDir } });
                (vm.onSort || angular.noop)({ sortParams: { sortBy: vm.sortBy, sortDir: vm.sortDir } });
            }

            function toggleSortDirection() {
                ++vm.ctr;
                if (vm.ctr > 2) vm.ctr = 1;
                return {
                    icon: vm.sortDirections[vm.ctr][0],
                    sortDir: vm.sortDirections[vm.ctr][1]
                };
            }
        }

        function SortColumnController($rootScope) {}
    }
})();
/**
 * Sort engine
 * by Rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .factory('a8SortService', a8SortService);

    /** @ngInject */
    function a8SortService(_, alasql, utils) {
        var service = {
            sort: sort
        };

        return service;
        ///////

        // TODO: provide search columns parameter to override extractSearchFields
        function sort(collection, sortBy, sortDir) {
            if (collection.length <= 0 
                || sortBy == null 
                || sortBy == undefined 
                || sortBy == '' 
                || sortDir == null 
                || sortDir == undefined 
                || sortDir == '') return collection;

            let sExpr =  createSortExpression(sortBy, sortDir);
            let results = alasql("SELECT * FROM ? " + sExpr, [collection]);

            return results;
        }

        function createSortExpression(sortBy, sortDir) {
            return ' ORDER BY ' + sortBy + ' ' + sortDir.toUpperCase();
        }
    }

})();

/**
 * Search engine algorithm
 * by Rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .factory('a8GridSearchEngineService', a8GridSearchEngineService);

    /** @ngInject */
    function a8GridSearchEngineService(_, alasql, utils) {
        var service = {
            search: search
        };

        return service;
        ///////

        // TODO: provide search columns parameter to override extractSearchFields
        function search(collection, stext) {
            var out = [];
            if (collection.length <= 0 || stext == null || stext == undefined || stext == '') return null;
            var props = extractSearchFields(collection[0]);
            var qryPredicate = createQueryPredicate(props, stext);

            //var results = alasql(qryPredicate , [collection]);
            if (!stext) {
                return collection;
            }

            var searchKeywords = stext.split(" ");
            var tmpCollection = collection;

            searchKeywords.forEach(function (keyword) {
                if (keyword) {
                    var sanitizedKeyword = sanitizeQuery(keyword);

                    var query = "select * from ? where ";
                    var cnt = 0; // 0 = first item indicator
                    props.forEach(function (propItem) {
                        var qryPredicate = createQueryPredicate2(propItem, sanitizedKeyword);
                        query = (cnt == 0 ? query += qryPredicate
                               : query = query + ' or ' + qryPredicate);
                        cnt++;
                    });

                    if (_.includes(props, "FirstName") && _.includes(props, "MiddleName") && _.includes(props, "LastName")) {
                        var sanitizedStext = sanitizeQuery(stext);
                        query += " or CONCAT(FirstName,' ',LastName) like '%" + sanitizedStext + "%'";
                    }

                    var result = alasql(query, [tmpCollection]);

                    tmpCollection = [];
                    result.forEach(function (itm) {
                        tmpCollection.push(itm);
                    });
                }
            });

            tmpCollection.forEach(function (itm) {
                out.push(itm);
            });

            return out;
        }

        // Ver2.0
        function createQueryPredicate2(prop, searchKeyword) {
            return searchKeyword != null ? prop + " like '%" + searchKeyword + "%'" : '';
        }

        // Obsolete (Ver1.0)
        function createQueryPredicate(propsColl, stext) {
            var fields = propsColl;
            var qryString = stext;
            var query = "select * from ? where ";
            var params = qryString.split(" ");

            angular.forEach(params, function (param) {
                angular.forEach(fields, function (field) {
                    query += field + " like '%" + param + "%' or "
                });
            });

            query = query.trim();
            query = query.substring(0, query.length - 3);
            return query;
        }

        function sanitizeQuery(value) {
            return value ? value.replace(/'/g, "''") : '';
        }

        function extractSearchFields(obj) {
            var objSanitized = utils.objectSanitize(obj);
            var propsArr = [];
            for (var p in objSanitized) {
                // Todo: Fix exclusion of properties in the search props
                if (!angular.isFunction(propsArr) && p != 'CreatedDate' && p != 'UpdatedDate' && !_.isBoolean(objSanitized[p]))
                    propsArr.push(p);
            }
            return propsArr;
        }
    }

})();

/**
* Search Component
*/
(function () {
    'use strict';
    angular.module('app.widgets')
        .directive('a8GridSearchComponent', a8GridSearchComponent);

    /** @ngInject */
    function a8GridSearchComponent($log) {
        var directive = {
            restrict: 'E',
            scope: {
                source: '=',
                delay: '=',
                onSearch: '&'
            },
            require: '^a8GridComponent',
            templateUrl: 'app/shared/widgets/a8PaginationGrid/search/a8GridSearch.html',
            controller: GridSearchController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function GridSearchController() { }

        function link($scope, elem, attrs, controller) {
            var vm = $scope.vm;

            $scope.$watch('vm.source', function (newVal) {
                if (newVal != null) {
                    controller.goSearch(newVal);

                    // Notify consumer
                    (vm.onSearch || angular.noop)({ value: encodeURIComponent(newVal) });
                }
            });


            controller.onGoSearch(function (val) {
                $log.debug(val);
            });
        }
    }
})();

/**
* Page Size Component
*/
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('a8GridPageSizeComponent', a8GridPageSizeComponent);

    /** @ngInject */
    function a8GridPageSizeComponent($http, $timeout, $rootScope) {
        var directive = {
            restrict: 'E',
            scope: {
                source: '=',
                onPageSizeSelected: '&',
                selected: '@'
            },
            require: '^a8GridComponent',
            templateUrl: 'app/shared/widgets/a8PaginationGrid/pageSize/a8GridPageSize.html',
            controller: GridPageSizeController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function link($scope, elems, attrs, controller) {
            var vm = $scope.vm,
                opts = {
                    source: [5, 20, 50]
                };

            vm.options = angular.extend(opts.source, vm.source);
            vm.selected = vm.selected == null ? vm.source[0] : vm.selected;

            // ----------------
            // Internal Events
            // ----------------
            vm.onPageSizeEvt = function () {
                // Fire callback (external event)
                controller.changePageSize(vm.selected);
                (vm.onPageSizeSelected || angular.noop)({ value: vm.selected });
            };
        }

        function GridPageSizeController() {}

    }
})();
(function() {
    'use strict';

    angular.module('app.widgets')
        .factory('a8WebApiNoChunkDataProvider', a8WebApiNoChunkDataProvider);

    /** @ngInject */
    function a8WebApiNoChunkDataProvider(
        $q
    ) {
        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        function activate() {}


        function getInstance() {
            var provider = function() {
                var self = this;
                self.fetch = fetch;
                self.onDownloadCompleted = angular.noop;
                self.onChunkReceived = angular.noop;
                self.onErrorDownloading = angular.noop;

                activate();

                function activate() {}

                function fetch(apiMethod) {
                    var deferred = $q.defer();
                    var promise = (apiMethod || angular.noop)();

                    promise.then(function(resp) {
                        if (resp == null) {
                            self.onDownloadCompleted();
                            return;
                        }

                        let data = !resp.hasOwnProperty('data') ? resp : resp.data;

                        self.onChunkReceived({
                            chunkData: data,
                            totalChunks: -1, // Undetermined
                            totalItems: -1,
                            extraData: null
                        }, 'dbHub');

                        self.onDownloadCompleted(data);
                    }).catch(function(error) {
                        self.onErrorDownloading(error);
                        deferred.reject(error);
                    });

                    return deferred.promise;
                }

            };

            return new provider();
        }
    }
})();

/**
 * a8SignalrDataProvider
 * Note: it always create new instance of an object
 */
(function () {
    'use strict';

    angular.module('app.widgets')
        .factory('a8SignalrDataProvider', a8SignalrDataProvider);

    /** @ngInject */
    function a8SignalrDataProvider($q,
        signalRService,
        $interval) {

        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        //////
        function activate() { }

        /**
         * Return new instance of object every we request getInstance
         */
        function getInstance(opts) {
            var provider = function () {
                var self = this,
                    stop;

                self.fetch = fetch;
                self.stopDownload = stopDownload;
                self.data = [];

                self.onDownloadCompleted = angular.noop;
                self.onChunkReceived = angular.noop;
                self.onErrorDownloading = angular.noop;

                self.options = {
                    hub: 'messageHub',
                    endpoint: null,
                    bufferSize: 2000
                };

                angular.extend(self.options, opts);

                activate();

                //////
                function activate() {}

                function fetch(params) {
                    var deferred = $q.defer();

                    stop = undefined;
                    self.data.length = 0; // Remove this one!!!

                    signalRService.safeSend(function () {
                        params['ContinuationToken'] = null;
                        params['BufferSize'] = self.options.bufferSize;

                        signalRService[self.options.hub].invoke(self.options.endpoint, params)
                            .done(function (resp) {
                                angular.forEach(resp.Item1, function (itm) {
                                    self.data.push(itm);
                                });

                                // Fire event to subscriber
                                self.onChunkReceived({
                                    chunkData: resp.Item1,
                                    totalChunks: -1, // Undetermined
                                    totalItems: -1,
                                    extraData: resp.hasOwnProperty('Item3') ? resp.Item3 : null
                                }, 'dbHub');

                                // Continue fetching the next chunk data
                                if (resp.Item2 != null) {
                                    continueDl(resp.Item2, params);
                                } else {
                                    // Trigger event download completed
                                    // Note: Completed data aggregated for each download will not be use by alloc8 grid.
                                    // Only the chunk data from onChunkReceived is accepted as a superset collection.
                                    self.onDownloadCompleted(self.data);
                                }

                                deferred.resolve(resp);
                            }).fail(function (error) {
                                self.onErrorDownloading(error);
                                deferred.reject(error);
                            });
                    });

                    return deferred.promise;
                }

                function continueDl(contToken, params) {
                     if (angular.isDefined(stop))
                        return;

                    let isContinue = true;

                    stop = $interval(function () {
                        if (isContinue) {
                            isContinue = false;

                            if (contToken === null) {
                                stopDl();
                                // Trigger event download completed
                                self.onDownloadCompleted(self.data);
                                return;
                            }

                            params['ContinuationToken'] = contToken;
                            params['BufferSize'] = self.options.bufferSize;

                            continueDownloading(params)
                                .then(function (respData) {

                                    if (respData) {
                                        // Bind data here
                                        angular.forEach(respData.Item1, function (itm) {
                                            self.data.push(itm);
                                        });

                                        // Fire event to subscriber
                                        self.onChunkReceived({
                                            chunkData: respData.Item1,
                                            totalChunks: -1, // Undetermined
                                            totalItems: -1,
                                            extraData: resp.hasOwnProperty('Item3') ? resp.Item3 : null
                                        }, 'dbHub');
                                    }

                                    isContinue = true;
                                    contToken = respData.Item2;
                                }).catch(function (ex) {
                                    // Terminate process if something went wrong
                                    if (ex.message !== 'Connection was disconnected before invocation result was received.') {
                                        stopDl();
                                    }
                                });
                        }
                    }, 100);
                }

                /**
                 * Stop downloading
                 */
                function stopDl() {
                    if (angular.isDefined(stop)) {
                        $interval.cancel(stop);
                        stop = undefined;
                    }
                }

                function stopDownload() {
                    stopDl();
                    self.data.length = 0;
                }

                /**
                 * Continue downloading
                 */
                function continueDownloading(params) {
                    let deferred = $q.defer();
                    signalRService[self.options.hub]
                        .invoke(self.options.endpoint, params)
                        .done(function (resp) {
                            deferred.resolve(resp);
                        }).fail(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }


            }; // End object instance

            return new provider();
        }

    }
})();

/**
* Page Size Component
*/
(function () {
    'use strict';
    angular.module('app.widgets')
        .directive('a8SortField', a8SortField);

    /** @ngInject */
    function a8SortField($log) {
        var directive = {
            restrict: 'E',
            scope: {
                sortBy: '@',
                fieldLabel: '@',
                onSort: '&'
            },
            templateUrl: 'app/shared/widgets/a8Pagination/sort/a8SortField.html',
            controller: PagerSearchController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function PagerSearchController($rootScope) {
            var vm = this;
            vm.sortDir = 'asc';
            vm.onClickSort = onClickSort;
            vm.sortDirections = [['icon-unfold-more', '-'], ['icon-chevron-up', 'asc'], ['icon-chevron-down', 'desc']];

            vm.ctr = 0;
            vm.icon = vm.sortDirections[0][0];

            activate();

            function activate() {
                $rootScope.$on('a8SortField:reset', function() {
                    vm.icon = vm.sortDirections[0][0];
                    vm.sortDir = vm.sortDirections[0][1];
                });
            }

            function onClickSort() {
                $rootScope.$broadcast('a8SortField:reset');
                let sortRes = toggleSortDirection();
                
                $log.debug('Sort Dir: ' + sortRes.sortDir + '  Sort by: ' + vm.sortBy);
                vm.icon = sortRes.icon;
                vm.sortDir = sortRes.sortDir;
                (vm.onSort || angular.noop)({ sortParams: { sortBy: vm.sortBy, sortDir: vm.sortDir } });
            }

            function toggleSortDirection() {
                ++vm.ctr;
                if (vm.ctr > 2) vm.ctr = 1;
                return {
                    icon: vm.sortDirections[vm.ctr][0],
                    sortDir: vm.sortDirections[vm.ctr][1]
                };
            }

        }
    }
})();
/**
* Page Size Component
*/
(function () {
    'use strict';
    angular.module('app.widgets')
        .directive('a8PagerSearchComponent', a8PagerSearchComponent);

    /** @ngInject */
    function a8PagerSearchComponent() {
        var directive = {
            restrict: 'E',
            scope: {
                source: '=',
                delay: '=',
                onSearch: '&'
            },
            templateUrl: 'app/shared/widgets/a8Pagination/search/a8PagerSearch.html',
            controller: PagerSearchController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function PagerSearchController($scope) {
            var vm = this;

            $scope.$watch('vm.source', function (newVal) {
                if (newVal != null) {
                    (vm.onSearch || angular.noop)({ value: encodeURIComponent(newVal) });
                }
            });
        }
    }
})();

/**
* Page Size Component
*/
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('a8PageSizeComponent', a8PageSizeComponent);

    /** @ngInject */
    function a8PageSizeComponent($http, $timeout, $rootScope) {
        var directive = {
            restrict: 'E',
            scope: {
                source: '=',
                onPageSizeSelected: '&',
                selected: '='
            },
            templateUrl: 'app/shared/widgets/a8Pagination/pageSize/a8PageSize.html',
            controller: PageSizeController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

         function PageSizeController() {
            var vm = this,
                opts = {
                    source: [5, 20, 50]
                };

            vm.options = angular.extend(opts.source, vm.source);
            vm.selected = vm.selected == null ? vm.source[0] : vm.selected; 

            //$rootScope.$broadcast('a8PaginationComponent:changePageSize', vm.selected);

            // ----------------
            // Internal Events
            // ----------------
            vm.onPageSizeEvt = function () {
                // Fire callback (external event)
                (vm.onPageSizeSelected || angular.noop)({ value: vm.selected });
            };
        }

    }

})();
(function () {
  'use strict';

  angular
    .module('app.quick-panel', ['app.api'])
    .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('app/quick-panel');
  }
})();

(function() {
    'use strict';

    angular.module('app.quick-panel')
        .service('todoNotificationDirective', todoNotificationDirective);

    function todoNotificationDirective() {
        this.showNotification = function(notification) {
            var notification = new Notification(notification.SenderContact.FullName, {
                icon: notification.SenderContact.PhotoUrl,
                body: notification.Message,
            });

            notification.onclick = function() {};

            return null;
        }
    }
}());

(function() {
    'use strict';

    angular.module('app.quick-panel')
        .factory('todoNotificationService', todoNotificationService);

    function todoNotificationService(
        $q,
        notificationApi,
        todoNotificationModel,
        exceptionService
    ) {
        var service = {
            refreshOptions: {
                getUnread: 1,
                getRead: 2,
                getAll: 3,
                hasUnreadNotification: 4
            },
            unReadNotifications: [],
            readNotifications: [],
            hasUnreadNotification: false,
            refreshNotifications: refreshNotifications,
            openNotification: openNotification,
            dismissAll: dismissAll,
            hasUnreadData: hasUnreadData,
            onNotificationReceived: null, // Callback (we can use $watch instead)
            showProgress: true,
            getUnreadNotifications: getUnreadNotifications,
            updateUnreadNotifications: updateUnreadNotifications
        };

        init();

        return service;

        function init() {
            service.PageRoutes = [{
                    Id: 1,
                    Name: "ContactCreate",
                    BaseURL: "contacts/create-contact",
                    state: "app.contact_create",
                    params: {}
                },
                {
                    Id: 2,
                    Name: "ContactUpdate",
                    BaseURL: "contacts/update/{{ResourceId}}",
                    state: "app.contact_update",
                    params: {}
                },
                {
                    Id: 3,
                    Name: "ContactUpdateSkills",
                    BaseURL: "contacts/update/{{ResourceId}}",
                    state: "app.contact_update",
                    params: {}
                },
                {
                    Id: 4,
                    Name: "ContactUpdateTraining",
                    BaseURL: "contacts/update/{{ResourceId}}",
                    state: "app.contact_update",
                    params: {}
                },
                {
                    Id: 5,
                    Name: "ContactCalendar",
                    BaseURL: "contact/calendar/{{ResourceId}}",
                    state: "app.contact_calendar",
                    params: {}
                },
                {
                    Id: 6,
                    Name: "CompanyCreate",
                    BaseURL: "company/create",
                    state: "app.company_create",
                    params: {}
                },
                {
                    Id: 7,
                    Name: "CompanyUpdate",
                    BaseURL: "company/update/{{ResourceId}}",
                    state: "app.company_update",
                    params: {}
                },
                {
                    Id: 8,
                    Name: "CompanyUpdateSkills",
                    BaseURL: "company/update/{{ResourceId}}",
                    state: "app.company_update",
                    params: {}
                },
                {
                    Id: 9,
                    Name: "AssetCreate",
                    BaseURL: "assets/manage/item",
                    state: "app.manage_item",
                    params: {}
                },
                {
                    Id: 10,
                    Name: "AssetUpdate",
                    BaseURL: "assets/manage/item/update/{{ResourceId}}",
                    state: "app.manage_item_update",
                    params: {}
                },
                {
                    Id: 11,
                    Name: "AssetUpdateItem",
                    BaseURL: "assets/manage/item/update/{{ResourceId}}",
                    state: "app.manage_item_update",
                    params: {}
                },
                {
                    Id: 12,
                    Name: "KitCreate",
                    BaseURL: "assets/manage/kit",
                    state: "app.manage_kit",
                    params: {}
                },
                {
                    Id: 13,
                    Name: "KitUpdate",
                    BaseURL: "assets/manage/kit/update/{{ResourceId}}",
                    state: "app.manage_kit_update",
                    params: {}
                },
                {
                    Id: 14,
                    Name: "ViewEquipment",
                    BaseURL: "equipment/view-equipment",
                    state: "app.equipment_view",
                    params: {}
                },
                {
                    Id: 15,
                    Name: "ViewEquipmentCreate",
                    BaseURL: "equipment/view-equipment",
                    state: "app.equipment_view",
                    params: {}
                },
                {
                    Id: 16,
                    Name: "ViewEquipmentUpdate",
                    BaseURL: "equipment/view-equipment",
                    state: "app.equipment_view",
                    params: {}
                },
                {
                    Id: 17,
                    Name: "ViewEquipmentCalendar",
                    BaseURL: "equipment/calendar/{{ResourceId}}",
                    state: "app.equipment_calendar",
                    params: {}
                },
                {
                    Id: 18,
                    Name: "ViewJobs",
                    BaseURL: "jobs/view-jobs",
                    state: "app.jobs_view",
                    params: {}
                },
                {
                    Id: 19,
                    Name: "JobCreate",
                    BaseURL: "jobs/create-a-job/",
                    state: "app.jobs_manage",
                    params: {}
                },
                {
                    Id: 20,
                    Name: "JobUpdate",
                    BaseURL: "jobs/update-a-job/{{ResourceId}}",
                    state: "app.jobs_update",
                    params: {}
                },
                {
                    Id: 21,
                    Name: "WhiteboardDay",
                    BaseURL: "jobs/whiteboard/original",
                    state: "app.jobs_whiteboard",
                    params: {}
                },
                {
                    Id: 22,
                    Name: "WhiteboardWeek",
                    BaseURL: "jobs/whiteboard/original",
                    state: "app.jobs_whiteboard",
                    params: {}
                },
                {
                    Id: 23,
                    Name: "EquipmentWhiteboardDay",
                    BaseURL: "jobs/whiteboard/equipment",
                    state: "app.jobs_whiteboard_eq",
                    params: {}
                },
                {
                    Id: 24,
                    Name: "EquipmentWhiteboardWeek",
                    BaseURL: "jobs/whiteboard/equipment",
                    state: "app.jobs_whiteboard_eq",
                    params: {}
                },
                {
                    Id: 25,
                    Name: "ResourceAllocation",
                    BaseURL: "allocate-ticket-resources/{{ResourceId}}",
                    state: "app.allocate",
                    params: {}
                },
                {
                    Id: 26,
                    Name: "Timesheets",
                    BaseURL: "job-timesheet/{{ResourceId}}",
                    state: "app.timesheet",
                    params: {}
                },
                {
                    Id: 27,
                    Name: "SendInvoices",
                    BaseURL: "invoice/reports/send_invoices",
                    state: "app.invoice_email_sender",
                    params: {}
                },
                {
                    Id: 28,
                    Name: "ViewReports",
                    BaseURL: "reports",
                    state: "app.view_reports",
                    params: {}
                }
            ];
        }

        /**
         * @refreshMode = 1 - get unread Notifications, 2 - get read notifications, 3 - get all notifications
         */
        function refreshNotifications(options) {
            var defaults = {
                refreshMode: service.refreshOptions.hasUnreadNotification
            };

            var opts = angular.extend({}, defaults, options);
            switch (opts.refreshMode) {
                case service.refreshOptions.getUnread:
                    getNotifications();
                    break;

                case service.refreshOptions.getRead:
                    getReadNotifications();
                    break;

                case service.refreshOptions.getAll:
                    $q.when(getNotifications());
                    $q.when(getReadNotifications());
                    break;
                case service.refreshOptions.hasUnreadNotification:
                    hasUnreadNotifications();
            };
        }

        async function getNotifications() {
            service.showProgress = true;
            try {
                const response = await notificationApi.getAllUnread();

                service.unReadNotifications.length = 0;
                angular.forEach(response.data, function(itm) {
                    var notificationItem = new todoNotificationModel();
                    notificationItem.map(itm);
                    service.unReadNotifications.push(notificationItem);
                });
                (service.onNotificationReceived || angular.noop)();

            } catch (ex) {
                exceptionHandler(ex);
            }

        }

        async function hasUnreadNotifications() {
            service.showProgress = true;
            try {
                const response = await notificationApi.hasUnreadNotifications();

                service.hasUnreadNotification = response.data;
                (service.onNotificationReceived || angular.noop)();
                service.showProgress = false;
            } catch (ex) {
                exceptionHandler(ex);
            }
        }

        function exceptionHandler(ex) {
            service.showProgress = false;
            exceptionService.resolve(ex);
        }

        async function getReadNotifications() {
            service.showProgress = true;
            try {
                const response = await notificationApi.getRead();
                if (response.data) {
                    service.readNotifications.length = 0;
                    angular.forEach(response.data, function(itm) {
                        var notificationItem = new todoNotificationModel();
                        notificationItem.map(itm);
                        service.readNotifications.push(notificationItem);
                    });
                    (service.onNotificationReceived || angular.noop)();
                    service.showProgress = false;
                }
            } catch (ex) {
                exceptionHandler(ex);
            }

        }

        function updateUnreadNotifications(data) {
            service.showProgress = true;
            service.unReadNotifications.length = 0;
            angular.forEach(data, function(itm) {
                var notificationItem = new todoNotificationModel();
                notificationItem.map(itm);
                service.unReadNotifications.push(notificationItem);
            });
            service.showProgress = false;
        }

        async function openNotification(notification) {
            var deferred = $q.defer();

            try {
                const response = await notificationApi.markNotificationAsRead(notification.Id, notification.NotificationType);

                if (response.data) {
                    var notificationItem = new todoNotificationModel();
                    notificationItem.map(response.data);
                    deferred.resolve(notificationItem);
                    refreshNotifications({
                        refreshMode: service.refreshOptions.getAll
                    });
                    return deferred.promise;
                }

            } catch (ex) {
                exceptionService.resolve(ex);
                deferred.reject(ex);
            }
        }

        async function dismissAll() {
            try {
                await notificationApi.dismissAll();

                service.unReadNotifications.length = 0;
                refreshNotifications({
                    refreshMode: service.refreshOptions.getAll
                });
                (service.onNotificationReceived || angular.noop)();

            } catch (ex) {
                exceptionService.resolve(ex);
            }
        }

        function hasUnreadData() {
            return (service.hasUnreadNotification);
        }

        function getUnreadNotifications() {
            return notificationApi.getAllUnread();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.quick-panel')
        .service('todoNotificationModel', todoNotificationModel)

    function todoNotificationModel() {

        return function() {
            var self = this;
            var defaults = {
                id: null,
                Id: null,
                SenderContact: null,
                Message: null,
                NotificationDate: null,
                ReadDate: null,
                NotificationType: null,
                PageRouting: null
            };

            self.map = mapper;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults;
                var opts = angular.extend({}, defaults, mapValue);
                self.id = opts.Id || opts.id;
                self.Id = opts.Id || opts.id;
                self.SenderContact = opts.SenderContact;
                self.Message = opts.Message;
                self.NotificationDate = opts.NotificationDate;
                self.NotificationType = opts.NotificationType;
                self.PageRouting = opts.PageRouting;
                self.ReadDate = opts.ReadDate;
            };
        };
    };
})();

(function () {
    'use strict';

    angular
        .module('app.workforce', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.workforce_view', {
            url: '/workforce',
            views: {
                'content@app': {
                    templateUrl: 'app/main/workForceParticipation/view/work-force-participation-view.html',
                    controller: 'WorkforceViewController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasWorkForceMenu;
                }]
            },
            title: 'Work Force Participation',
            titleBar: 'Alloc8 - Workforce Participation'
        });
        $translatePartialLoaderProvider.addPart('app/main/workForceParticipation/view');
    }

})();

angular
  .module('app.workforce')
  .controller('WorkforceDialogController', WorkforceDialogController);

/** @ngInject */
function WorkforceDialogController($mdDialog, utils, workforceApi, isEdit, data) {
  var vm = this;
  vm.Id = null;
  vm.name = null;
  vm.loaderMessage = utils.translate('WORKFORCE.SAVING');
  vm.isSaving = false;

  vm.onClose = onClose;
  vm.save = save;

  function onClose(){
    $mdDialog.hide();
  }

  function activate(){
    if(isEdit){
      vm.Id = data.Id;
      vm.name = data.Name
    }
  }

  function save(){
    vm.isSaving = true;
    let pay_load = {
      Name : vm.name
    }
    if(isEdit){
      workforceApi.edit(vm.Id, pay_load).then(function(resp){
        $mdDialog.hide(resp.data);
      });
    }else{
      workforceApi.add(pay_load).then(function(resp){
        $mdDialog.hide(resp.data);
      });
    }
  }

  activate();
}


/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.vehicle.manage', ['angularInlineEdit', 'ngMaterial'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.vehicle', {
            url: '/vehicle/manage',
            views: {
                'content@app': {
                    templateUrl: 'app/main/vehicle/manage/vehicle-manage.html',
                    controller: 'vehicleController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManageVehicles;
                }]
            },
            title: 'Manage Vehicle Models',
            titleBar: 'Alloc8 - Vehicle Models'
        });
        $translatePartialLoaderProvider.addPart('app/main/vehicle');
    };

})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.vehicle.manage')
        .controller('vehicleRemoveController', vehicleRemoveController);

    /** @ngInject */
    function vehicleRemoveController (
        $mdDialog,
        vehicleService,
        variables) {

        //Data
        var vm = this;
        vm.variables = variables;

        // Method
        vm.onDone = onDone;
        vm.onCancel = onCancel;
        vm.activate = activate;

        vm.activate();

        function activate () {
            vm.activeList;
            if (vm.variables.mode === 'Make') {
                vm.activeList = vehicleService.vehicleMakes;
            }
            else if (vm.variables.mode === 'Model') {
                vm.activeList = vehicleService.vehicleModels;
            }
        }

        function onDone (proceed) {
            if (proceed) {
                removeVehicle();
            }
            $mdDialog.hide();
        }

        function removeVehicle () {
            var itemId;
            angular.forEach(vm.activeList, function (value, key) {
                if (vm.variables.Id == value.Id || vm.variables.Id == value.id) {
                    vm.activeList.splice(key, 1);
                }
            });
            vehicleService.deleteItem(vm.variables.mode, variables.Id);
        }

        function onCancel () {
            $mdDialog.cancel();
        }
    }
})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';
    angular
        .module('app.vehicle.manage')

        .factory('vehiclesFactory', function ($mdDialog, lookupApi) {
            return {
                removeVehicle: function (mode, Id) {
                    $mdDialog.show({
                        parent: angular.element(document.body)
                        , templateUrl: 'app/main/vehicle/directive/removevehicle/remove-vehicle.html'
                        , locals: {
                            variables: {
                                Id: Id,
                                mode: mode
                            }
                        }
                        , controller: 'vehicleRemoveController as vm'
                    });
                },
                // behavior 0 = Add Vehicle, 1 = Edit Vehicle
                // mode "make", "model"
                saveVehicle: function (mode, data, behavior) {
                    $mdDialog.show({
                        parent: angular.element(document.body)
                        , templateUrl: 'app/main/vehicle/directive/addvehicle/add-vehicle.html'
                        , locals: {
                            variables: {
                                mode: mode,
                                data: data,
                                behavior: behavior,
                            }
                        }
                        , controller: 'vehicleManageController as vm'
                    });
                }
            }
        });
})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.vehicle.manage')
        .controller('vehicleManageController', vehicleManageController);

    /** @ngInject */
    function vehicleManageController (
        $mdDialog,
        utils,
        _,
        vehicleService,
        variables) {

        //Data
        var vm = this;
        vm.utilService = utils;

        // Method
        vm.onDone = onDone;
        vm.onCancel = onCancel;
        vm.transformtoModel = transformtoModel;
        vm.activate = activate;
        vm.variables = variables;

        vm.activate();

        function onDone () {
            var data = transformtoModel();
            // New
            if (variables.behavior == 0) {
                data.Id = vm.utilService.createGuid();
                vm.activeList.push(data);
                vehicleService.addItem(vm.variables.mode, data);
                $mdDialog.hide();
            }
            // Edit
            else {
                // *** Update data in list
                angular.forEach(vm.activeList, function (value, key) {
                    if (value.id == data.Id || value.Id == data.Id) {
                        value.Value = vm.Value;
                    }
                });
                vehicleService.editItem(vm.variables.mode, vm.variables.data);
                $mdDialog.hide();
            }
        }

        function activate () {
            vm.activeList;
            if (vm.variables.mode === 'Make') {
                vm.activeList = vehicleService.vehicleMakes;
            }
            else if (vm.variables.mode === 'Model') {
                vm.activeList = vehicleService.vehicleModels;
            }
            if (variables.behavior == 1) {
                vm.Id = variables.data.id || variables.data.Id;
                vm.Value = variables.data.Value;
            }
        }

        function transformtoModel () {
            var data = {
                Id: vm.Id,
                CreatedDate: vm.utilService.jsDateTimeToEpoch(new Date()),
                UpdatedDate: vm.utilService.jsDateTimeToEpoch(new Date())
            }
            data.Value = vm.Value;
            return data;
        }

        function onCancel () {
            $mdDialog.cancel();
        }
    }
})();

(function () {
  'use strict';
  angular
    .module('app.useraccess', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state('app.useraccess', {
        url: '/useraccess',
        views: {
          'content@app': {
            templateUrl: 'app/main/useraccess/view/useraccess-view.html'
            , controller: 'UserAccessViewController as vm'
          }
        },
        title:'Manage User Access',
        titleBar:'Alloc8 - Manage User Access',
        data: {
          requireLogin: true,
          validateAccess: ['adminClaimsService', function (adminClaimsService) {
            return adminClaimsService.hasManageUserAccess;
          }] 
        }
      });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/useraccess');
  }
})();

(function() {
    'use strict';

    angular.module('app.useraccess')
        .factory('userAccessViewService', userAccessViewService);

    /** @ngInject */
    function userAccessViewService(
        userAccessApi,
        _,
        $q,
        hubService,
        $mdDialog,
        $window,
        claimsUtilService,
        adminClaimsService
    ) {
        let service = {
            rawAccessList: [],
            accessList: [],
            loader: false,
            disableButton: true,
            accessType: null,
            accessTypeItems: [],
            accessGroups: [],
            loaderMessage: null,
            contacts: [],
            contactsWithChanges: [],
            currentTab: null,
            selectedAccess : null,
            reset: reset,
            getAccessList: getAccessList,
            getAccessFromAccessType: getAccessFromAccessType,
            getContactInformation: getContactInformation,
            changeTab: changeTab,
            contactExists: contactExists,
            save: save,
            formList: formList,
            isPayrollGroupsEnabled: adminClaimsService.isPayrollGroupsEnabled,
            payrollGroupClaimName: claimsUtilService.payrollGroupClaimName
        }

        function reset() {
            service.rawAccessList.length = 0;
            service.accessList.length = 0;
            service.loader = false;
            service.disableButton = true;
            service.accessType = null;
            service.accessTypeItems.length = 0;
            service.accessGroups.length = 0;
            service.loaderMessage = null;
            service.contacts.length = 0;
            service.contactsWithChanges.length = 0;
            service.currentTab = null;
        }

        function getAccessFromAccessType(access) {
            service.searchText = null;
            angular.forEach(service.accessList, function(item, key) {
                if (key == access) {
                    service.accessTypeItems = item
                    service.currentTab = item[0];
                    service.disableButton = false;
                    service.selectedAccess = access;
                }

                let manageLoginAcctClaimIndex = service.accessTypeItems.findIndex(x => x.ClaimName.toLowerCase() === "manage login accounts");

                if (manageLoginAcctClaimIndex !== -1) {
                    service.accessTypeItems[manageLoginAcctClaimIndex].Name = "Manage Portal Access";
                }
            });
        }

        function getContactInformation(contactId, property) {
            let contact = _.find(service.contacts, {
                Id: contactId
            });
            return contact ? contact[property] : false;
        }

        function contactExists(contactId) {
            let contact = _.find(service.contacts, {
                Id: contactId
            });
            return contact ? true : false;
        }

        function changeTab(access) {
            service.searchText = null;
            service.currentTab = access;
        }

        function save() {
            service.loader = true;
            service.loaderMessage = "Saving Access List";

            userAccessApi.getAccessList().then(function(resp) {
                let updatedAccessList = resp.data;

                if (service.unchangedAccessList === angular.toJson(updatedAccessList)) {
                    userAccessApi.save(service.rawAccessList, service.contactsWithChanges).then(function() {
                        
                        resetAccessList();
                        service.loader = false;
                        service.loaderMessage = null;
                        service.contactsWithChanges.length = 0;
                        hubService.showToast('Access list has been succesfully saved');

                    }).catch(function() {
                        service.loader = false;
                        service.loaderMessage = null;
                        hubService.showToast('There was an error saving the access list');
                    });
                } else {
                    var confirm = $mdDialog.confirm()
                        .title('New user permissions detected')
                        .multiple(true)
                        .textContent('Another user has edited permissions. Please refresh this screen and update the user permissions again and save.')
                        .ok('Refresh')
                        .cancel('Close');
                    $mdDialog.show(confirm).then(function() {
                        $window.location.reload();
                    });
                    service.loaderMessage = null;
                    service.loader = false;
                }
            });
        }

        function formList() {
            angular.forEach(service.accessList, function(accessgroup) {
                angular.forEach(accessgroup, function(group) {
                    group.Id = group.Id;
                    group.GroupName = group.GroupName;
                    group.Name = group.Name;
                    group.ClaimName = group.ClaimName;
                    group.ContactIds = _.map(group.ContactIds, function(Id) {
                        let contact_information = _.find(service.contacts, {
                            Id: Id
                        });
                        return {
                            Id: Id,
                            FullName: contact_information ? (contact_information.FullName ? contact_information.FullName : null) : null,
                            Email: contact_information ? (contact_information.Email ? contact_information.Email : null) : null,
                            Phone: contact_information ? (contact_information.Phone ? contact_information.Phone : null) : null,
                            Position: contact_information ? (contact_information.Position ? contact_information.Position : null) : null
                        }
                    });
                });
            });
        }

        function resetAccessList() {
            service.rawAccessList = [];
            service.accessList = [];
            service.accessGroups = [];
            service.accessTypeItems = [];
            service.loader = true;
            service.loaderMessage = "Loading Access List";
            service.contacts = [];
            $q.all(
                    [
                        userAccessApi.getAccessList(),
                        userAccessApi.getUsers()
                    ])
                .then(function(resp) {
                    //Access List
                    service.rawAccessList = resp[0].data;

                    service.unchangedAccessList = angular.toJson(service.rawAccessList);
                    service.accessList = _.groupBy(service.rawAccessList, function(item) {
                        return item.GroupName;
                    });
                    service.accessGroups = _.keys(service.accessList);
                    service.loader = false;
                    service.loaderMessage = null;
                    //Users/Contacts
                    service.contacts = resp[1].data;
                    angular.forEach(service.contacts, function(contact) {
                        contact['FullName'] = contact.FirstName + " " + contact.LastName
                    });   
                    getAccessFromAccessType(service.selectedAccess);                 
                });
        }

        function getAccessList() {
            service.rawAccessList = [];
            service.accessList = [];
            service.accessGroups = [];
            service.accessTypeItems = [];
            service.loader = true;
            service.loaderMessage = "Loading Access List";
            service.contacts = [];
            $q.all(
                    [userAccessApi.getAccessList(),
                        userAccessApi.getUsers()
                    ])
                .then(function(resp) {
                    //Access List
                    service.rawAccessList = resp[0].data;

                    service.unchangedAccessList = angular.toJson(service.rawAccessList);
                    service.accessList = _.groupBy(service.rawAccessList, function(item) {
                        return item.GroupName;
                    });
                    service.accessGroups = _.keys(service.accessList);
                    service.loader = false;
                    service.loaderMessage = null;
                    //Users/Contacts
                    service.contacts = resp[1].data;
                    angular.forEach(service.contacts, function(contact) {
                        contact['FullName'] = contact.FirstName + " " + contact.LastName
                    });
                });
        }

        function activate() {
            service.accessType = null;
        }

        activate();

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.training.manage', ['angularInlineEdit', 'ngMaterial'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.training', {
            url: '/training/manage',
            views: {
                'content@app': {
                    templateUrl: 'app/main/training/manage/training-manage.html',
                    controller: 'trainingController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManageTrainings;
                }]
            },
            title: 'Manage Training',
            titleBar: 'Alloc8 - Manage Training'
        });
        $translatePartialLoaderProvider.addPart('app/main/training');
    };

})();

(function () {
  'use strict';

  angular
    .module('app.training.manage')
    .controller('trainingRemoveController', trainingRemoveController);

  /** @ngInject */
  function trainingRemoveController (
    $mdDialog,
    trainingService,
    variables) {

    //Data
    var vm = this;
    vm.Training = null;

    // Method
    vm.onDone = onDone;
    vm.onCancel = onCancel;

    function onDone (proceed) {
      if (proceed) {
        if (variables.trainingGroup.Trainings.length == 1) {
          removeGroup(variables.trainingGroup.id || variables.trainingGroup.Id);
        }
        else {
          removeTraining(variables.trainingGroup);
        }
      }
      $mdDialog.hide();
    }

    function removeTraining (trainingGroup) {
      var itemId;
      angular.forEach(trainingGroup.Trainings, function (value, key) {
        if (variables.Id == value.id) {
          trainingGroup.Trainings.splice(key, 1);
        }
      });
      trainingService.deleteTrainingGroupItem(trainingGroup.Id, variables.Id);
    }

    function removeGroup (Id) {
      trainingService.deleteTrainingGroup(Id);
    }

    function onCancel () {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('app.training.manage')

    .factory('trainingsFactory', function ($mdDialog, lookupApi) {
      return {
        removeTraining: function (Id, trainingGroup) {
          $mdDialog.show({
            parent: angular.element(document.body)
            , templateUrl: 'app/main/training/directive/removetraining/remove-training.html'
            , locals :{
              variables : {
                Id : Id,
                trainingGroup : trainingGroup
              }
            }
            , controller: 'trainingRemoveController as vm'
          });
        }, //Behavior 0 = Add Training, 1 = Edit Training
        saveTraining: function (trainingGroup, training, behavior) {
          lookupApi.getMinifiedBranches().then(function(resp){
            $mdDialog.show({
                parent: angular.element(document.body)
              , templateUrl: 'app/main/training/directive/addtraining/add-training.html'
              , locals: {
                variables:{
                  trainingGroup: trainingGroup,
                  training: training,
                  behavior: behavior,
                  branches : resp.data
                }
              }
              , controller: 'trainingManageController as vm'
            });
          });
        },
        addTrainingGroup: function(){
          $mdDialog.show({
            parent: angular.element(document.body)
            , templateUrl: 'app/main/training/directive/addtraininggroup/add-traininggroup.html'
            , controller: 'trainingGroupManageController as vm'
          });
        },
        addTrainingToContact: function(){
          $mdDialog.show({
            parent: angular.element(document.body)
            , templateUrl: 'app/main/training/directive/contacttraining/addcontacttraining/add-contact-training.html'
            , controller: 'AddContactTrainingController as vm'
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.training.manage')
    .controller('trainingGroupManageController', trainingGroupManageController);

  /** @ngInject */
  function trainingGroupManageController(
    $mdDialog,
    utils,
    trainingService) {

    //Data
    var vm = this;
    vm.TrainingGroup = null;

    // Method
    vm.onDone = onDone;
    vm.onCancel = onCancel;

    function onDone(answer) {

      var trainingGroup = {
          GroupName : answer,
          CreatedDate : utils.jsDateTimeToEpoch(new Date()),
          UpdatedDate : utils.jsDateTimeToEpoch(new Date()),
          Trainings : []
      }
      trainingService.addTrainingGroup(trainingGroup);

      $mdDialog.hide();
    }

    function onCancel() {
      $mdDialog.cancel();
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.training.manage')
    .controller('trainingManageController', trainingManageController);

  /** @ngInject */
  function trainingManageController(
    $mdDialog,
    utils, _,
    trainingService,
    variables) {

    //Data
    var vm = this;
    vm.ExpiryIsMandatory = false;
    vm.null = null;
    vm.utilService = utils;

    // Method
    vm.onDone = onDone;
    vm.onCancel = onCancel;
    vm.transformtoModel = transformtoModel;
    vm.activate = activate;
    vm.variables = variables;

    vm.activate();

    function onDone() {
      if(variables.behavior == 0){
        var training = transformtoModel();
        training.Id = utils.createGuid();
        variables.trainingGroup.Trainings.push(training);
        trainingService.addTrainingGroupItem(variables.trainingGroup, training);
        $mdDialog.hide();
      }
      else{
        var training = transformtoModel();
        angular.forEach(variables.trainingGroup.Trainings, function(value, key){
          if(value.id == training.Id || value.Id == training.Id){
            value.TrainingName = vm.TrainingName;
            value.ExpiryIsMandatory = vm.ExpiryIsMandatory;
            value.Branches = vm.branches;
          }
        });
        trainingService.editTrainingGroupItem(variables.trainingGroup, variables.training);
        $mdDialog.hide();
      }
    }

    function activate(){
      vm.branchesLookUp = variables.branches;

      if(variables.behavior == 1){
        vm.Id = variables.training.id || variables.training.Id;
        vm.TrainingName = variables.training.TrainingName;
        vm.ExpiryIsMandatory = variables.training.ExpiryIsMandatory;
        vm.branches = variables.training.Branches;
      }
    }

    function transformtoModel(){
      var training = {
        Id: vm.Id,
        TrainingName: vm.TrainingName,
        ExpiryIsMandatory: vm.ExpiryIsMandatory,
        CreatedDate: utils.jsDateTimeToEpoch(new Date()),
        UpdatedDate: utils.jsDateTimeToEpoch(new Date()),
        Branches : vm.branches
      }

      return training;
    }

    function onCancel() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.tags',
      []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state('app.tags', {
        url: '/tags',
        views: {
          'content@app': {
            templateUrl: 'app/main/tags/tags.html',
            controller: 'TagsController as tagsCtrl'
          }
        }, 
        title: 'Manage Tags', 
        titleBar: 'Alloc8 - Tags',
        data: {
          requireLogin: true,
          validateAccess: ['adminClaimsService', function (adminClaimsService) {
              return adminClaimsService.hasAdminOnly;
          }]
        }
    });
    $translatePartialLoaderProvider.addPart('app/main/tags');
  }
})();

(function () {
    'use strict';

    angular
        .module('app.tags')
        .controller('AddTagsController', AddTagsController);

    /** @ngInject */
    function AddTagsController(
        $mdDialog,
        blockUI,
        utils,
        hubService,
        tagsService) {

        let self = this;
        self.utilService = utils;
        self.service = tagsService;
        self.hasError = false;
        self.errorMessage = "";

        self.addTag = function(){
            blockUI.start(utils.translate('TAGS.MESSAGE_ADDING_TAG'));
            self.hasError = false;
            let params = { Name: self.tagName };
            self.service.addTag(params)
                .then(function(data){
                    blockUI.stop();
                    self.onCancel();
                    hubService.showToast(utils.translate('TAGS.MESSAGE_TAG_ADD'));
                }, function(err){
                    blockUI.stop();
                    self.hasError = true;
                    self.errorMessage = err.data.Message;
                });
        };

        self.onCancel = function() {
            $mdDialog.cancel();
        }

    }
})();

(function () {
  'use strict';
  angular
    .module('app.skillsmatrix.manage')

    .factory('skillsFactory', function ($mdDialog, lookupApi, skillsMatrixService, msgboxService, utils) {
      return {
        saveSkill: function (skillGroup, skill, behavior) {
          lookupApi.getMinifiedBranches().then(function(resp){
            $mdDialog.show({
                parent: angular.element(document.body)
              , templateUrl: 'app/main/skillsmatrix/directive/addskill/add-skill.html'
              , locals: {
                variables:{
                  skillGroup: skillGroup,
                  skill: skill,
                  behavior: behavior,
                  branches : resp.data
                }
              }
              , controller: 'SkillsMatrixManageController as vm'
            }).then(function(data){
                if(data){
                    if(data.Behavior === 0){
                        skillsMatrixService.add(data.Skill, data.Group);
                    }else{
                      skillsMatrixService.editSkillGroup(data.Skill.Id, data.Group);
                    }
                }
            });
          });
        },
        addSkillGroup: function(){
          $mdDialog.show({
            parent: angular.element(document.body)
            , templateUrl: 'app/main/skillsmatrix/directive/addskillgroup/add-skillgroup.html'
            , controller: 'SkillsMatrixGroupManageController as vm'
          })
        },
        addSkillToContact: function(){
          $mdDialog.show({
            parent: angular.element(document.body)
            , templateUrl: 'app/main/skillsmatrix/directive/contactskill/addcontactskill/add-contact-skill.html'
            , controller: 'AddContactSkillController as vm'
          })
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.skillsmatrix.manage')
    .controller('SkillsMatrixGroupManageController', SkillsMatrixGroupManageController);

  /** @ngInject */
  function SkillsMatrixGroupManageController(
    $mdDialog,
    utils,
    skillsMatrixService) {

    //Data
    var vm = this;
    vm.SkillGroup = null;

    // Method
    vm.onDone = onDone;
    vm.onCancel = onCancel;

    function onDone(answer) {

      var skillGroup = {
          GroupName : answer,
          CreatedDate : utils.jsDateTimeToEpoch(new Date()),
          UpdatedDate : utils.jsDateTimeToEpoch(new Date()),
          Skills : []
      }
      skillsMatrixService.addSkillGroup(skillGroup);

      $mdDialog.hide();
    }

    function onCancel() {
      $mdDialog.cancel();
    }


  }
})();

(function() {
    'use strict';

    angular
        .module('app.skillsmatrix.manage')
        .controller('SkillsMatrixManageController', SkillsMatrixManageController);

    /** @ngInject */
    function SkillsMatrixManageController($mdDialog,
        utils, _,
        variables) {

        var vm = this;
        vm.ExpiryIsMandatory = false;
        vm.CompanyRequired = false;
        vm.IsProtected = false;
        vm.parentSkills = [];
        vm.null = null;
        vm.utilService = utils;
        vm.onDone = onDone;
        vm.onCancel = onCancel;
        vm.transformtoModel = transformtoModel;
        vm.activate = activate;

        vm.activate();

        function onDone() {
            var skill = transformtoModel();

            if (variables.behavior == 0) {
                skill.Id = utils.createGuid();
                variables.skillGroup.Skills.push(skill);
                $mdDialog.hide({
                    Skill: skill,
                    Group: variables.skillGroup,
                    Behavior: 0
                });
            } else {

                var skillToUpdate = variables.skillGroup.Skills.find(x => x.id == skill.Id);

                const hasSkillNameChanged = skillToUpdate.SkillName != skill.SkillName;

                skillToUpdate.SkillName = vm.SkillName;
                skillToUpdate.ParentId = vm.ParentId;
                skillToUpdate.IsProtected = vm.IsProtected;
                skillToUpdate.ExpiryIsMandatory = vm.ExpiryIsMandatory;
                skillToUpdate.SkillBranches = vm.branches;
                skillToUpdate.CompanyNotRequired = !vm.CompanyRequired;

                $mdDialog.hide({
                    Skill: skill,
                    Group: variables.skillGroup,
                    Behavior: 1,
                    HasSkillNameChanged: hasSkillNameChanged
                });
            };
        }

        function activate() {
            vm.branchesLookUp = variables.branches;

            angular.forEach(variables.skillGroup.Skills, function(skill) {
                if (skill.ParentId == null) {
                    vm.parentSkills.push(skill);
                }
            });

            if (variables.skill) {
                angular.forEach(vm.parentSkills, function(skill, key) {
                    if (skill.id == variables.skill.id) {
                        vm.parentSkills.splice(key, 1);
                    }
                });
            }

            if (variables.behavior == 1) {
                vm.Id = variables.skill.id;
                vm.SkillName = variables.skill.SkillName;
                vm.ParentId = variables.skill.ParentId;
                vm.IsProtected = variables.skill.IsProtected;
                vm.ExpiryIsMandatory = variables.skill.ExpiryIsMandatory;
                vm.branches = variables.skill.SkillBranches;
                vm.CompanyRequired = !variables.skill.CompanyNotRequired
            }
        }

        function transformtoModel() {
            var skill = {
                Id: vm.Id,
                SkillName: vm.SkillName,
                IsProtected: vm.IsProtected,
                ParentId: vm.ParentId,
                ExpiryIsMandatory: vm.ExpiryIsMandatory,
                CreatedDate: utils.jsDateTimeToEpoch(new Date()),
                UpdatedDate: utils.jsDateTimeToEpoch(new Date()),
                SkillBranches: vm.branches,
                CompanyNotRequired: !vm.CompanyRequired
            }

            return skill;
        }

        function onCancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.skilllevel.view', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.skilllevel_view', {
      url: '/skillslevel',
      views: {
        'content@app': {
          templateUrl: 'app/main/skilllevel/view/skill-level-view.html', 
          controller: 'SkillsLevelViewController as vm'
        }
      }, 
      data: {
        requireLogin: true,
        validateAccess: ['adminClaimsService', function (adminClaimsService) {
          return adminClaimsService.hasManageSkillsLevelMenu;
        }] 
      },
      title: 'Manage Skill Levels',
      titleBar: 'Alloc8 - Skill Levels'
    });
    $translatePartialLoaderProvider.addPart('app/main/skilllevel/view');
  }
})();

angular
  .module('app.skilllevel.view')
  .controller('addSkillLevelDialogController', addSkillLevelDialogController);

/** @ngInject */
function addSkillLevelDialogController($mdDialog, utils, skillLevelApi, isEdit, data) {
  var vm = this;
  vm.Id = null;
  vm.skill_name = null;
  vm.loaderMessage = utils.translate('SKILLSLEVEL.SAVING');
  vm.isSaving = false;

  vm.onClose = onClose;
  vm.save = save;

  function onClose(){
    $mdDialog.hide();
  }

  function activate(){
    if(isEdit){
      vm.Id = data.Id;
      vm.skill_name = data.Name
    }
  }

  function save(){
    vm.isSaving = true;
    let pay_load = {
      Name : vm.skill_name
    }
    if(isEdit){
      skillLevelApi.editSkillsLevel(vm.Id, pay_load).then(function(resp){
        $mdDialog.hide(resp.data);
      });
    }else{
      skillLevelApi.addSkillsLevel(pay_load).then(function(resp){
        $mdDialog.hide(resp.data);
      });
    }
  }

  activate();
}


(function() {
    'use strict';

    angular
        .module('app.ratecards', [
            'wj',
            'dndLists',
            'app.rateCardSettings'
        ])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        $stateProvider
            .state('app.ratecards', {
                url: '/ratecards',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ratecards/ratecards.html',
                        controller: 'RateCardsController as rateCard'
                    },
                    'content@manage': {
                        templateUrl: 'app/main/ratecards/manage/ratecard-manage.html',
                        controller: 'RateCardManageController as rateCardManage',
                    },
                    'content@pricing': {
                        templateUrl: 'app/main/ratecards/pricing/ratecard-pricing.html',
                        controller: 'RateCardPricingController as rateCardPricing',
                    }
                },
                data: {
                    requireLogin: true,
                    validateAccess: ['invoiceClaimsService', function (invoiceClaimsService) {
                        return invoiceClaimsService.hasManageRateCardsMenu;
                    }]
                },
                title: 'Rate Cards',
                titleBar: 'Alloc8 - Rate Cards'
            });

        $translatePartialLoaderProvider.addPart('app/main/ratecards');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.ratecards')
        .controller('RatecardPackagesController', RatecardPackagesController);

    function RatecardPackagesController(
        $mdDialog,
        rateCardManage
    ) {
        var vm = this;

        vm.onCancel = onCancel;
        vm.onSave = onSave;
        vm.onPackageMoved = onPackageMoved;
        vm.rateCardManage = rateCardManage;
        vm.selectedPackagesOnReverseOrder = [];

        sortPackages();

        function onCancel() {
            $mdDialog.hide();
        }

        function onSave() {
            vm.rateCardManage.currentRatecard.formData.SelectedPackages = vm.selectedPackagesOnReverseOrder;

            $mdDialog.hide();
        }

        function onPackageMoved(idx) {
            vm.selectedPackagesOnReverseOrder.splice(idx, 1);
            sortPackages();
        }

        function sortPackages() {
            var counter = 1;
            if (vm.selectedPackagesOnReverseOrder.length > 0) {
                counter = vm.selectedPackagesOnReverseOrder.length;
                vm.selectedPackagesOnReverseOrder.forEach((e) => {
                    e.Tag = counter--;
                });
            } else {
                vm.selectedPackagesOnReverseOrder = vm.rateCardManage.currentRatecard.formData.SelectedPackages;
                let hasNullTag = vm.rateCardManage.currentRatecard.formData.SelectedPackages.find(x => x.Tag == null);

                if (hasNullTag) {
                    vm.selectedPackagesOnReverseOrder.forEach((e) => {
                        e.Tag = counter++;
                    });
                }

                vm.selectedPackagesOnReverseOrder = vm.selectedPackagesOnReverseOrder.sort((a, b) => b.Tag - a.Tag);
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.view_reports', ['app.reporting.components.report_viewer', 'app.reporting.components.headings'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.view_reports', {
        url: '/reports',
        views: {
          'content@app': {
            templateUrl: 'app/main/reporting/view/view_reports.html'
            , controller: 'ViewReportsController as vm'
          }
        }
        , data: {requireLogin: true}
        , title: 'View Reports'
        , titleBar: 'Alloc8 - View Reports'
      });
  }
})();

"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewReportsComponent = function (_React$Component) {
  _inherits(ViewReportsComponent, _React$Component);

  function ViewReportsComponent() {
    _classCallCheck(this, ViewReportsComponent);

    var _this = _possibleConstructorReturn(this, (ViewReportsComponent.__proto__ || Object.getPrototypeOf(ViewReportsComponent)).call(this));

    _this.viewdetails = _this.viewdetails.bind(_this);

    return _this;
  }

  _createClass(ViewReportsComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $('#view-reports').DataTable({
        "responsive": true,
        "ordering": true,
        "bAutoWidth": false,
        "bDestroy": true,
        "lengthMenu": [[10, 50, 100, -1], [10, 50, 100, "All"]],
        "pageLength": 100,
        "iDisplayStart": 0,
        "sDom": 'rt<"bottom"lip>',
        "buttons": ['copy', 'excel', 'print', 'pdf']
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      $('#view-reports').DataTable({
        "responsive": true,
        "ordering": true,
        "bAutoWidth": false,
        "bDestroy": true,
        "lengthMenu": [[10, 50, 100, -1], [10, 50, 100, "All"]],
        "pageLength": 100,
        "iDisplayStart": 0,
        "sDom": 'rt<"bottom"lip>',
        "buttons": ['copy', 'excel', 'print', 'pdf']
      });
    }
  }, {
    key: "viewdetails",
    value: function viewdetails(data) {
      this.props.viewdetails(data);
    }
  }, {
    key: "render",
    value: function render() {
      var self = this;

      /**
       * Get header settings
       * @param {headername} headerName
       */
      function getHeader(headerName) {
        if (!self.props.data.gridMetadata) return;
        if (!headerName) return;

        var defaultOption = {
          ForegroundColor: null, // not set use default instead
          BackgroundColor: null,
          Bold: null,
          Italic: null,
          Underline: null
        };

        if (self.props.data.gridMetadata.hasOwnProperty('HeaderRow')) {
          _.assignWith(defaultOption, self.props.data.gridMetadata.HeaderRow, function (objValue, srcValue) {
            return _.isNil(srcValue) ? objValue : srcValue;
          });
        }

        // Apply rows collection styles
        if (self.props.data.gridMetadata.hasOwnProperty('HeaderColumns')) {
          // let headerColumns = self.props.data.gridMetadata.HeaderColumns;
          // Find first in columns
          var headerColNameSetting = _.find(self.props.data.gridMetadata.HeaderColumns, function (r) {
            return r.ModelName === headerName;
          });

          if (!_.isNil(headerColNameSetting)) {
            _.assignWith(defaultOption, headerColNameSetting, function (objValue, srcValue) {
              return _.isNil(srcValue) ? objValue : srcValue;
            });
          }
        }

        return defaultOption;
      }

      /**
       * Content object settings
       */
      function getContent() {
        if (!self.props.data.gridMetadata) return null;

        return {
          ContentRow: self.props.data.gridMetadata.ContentRow || null,
          ContentRows: self.props.data.gridMetadata.ContentRows || null,
          ContentColumn: self.props.data.gridMetadata.ContentColumn || null,
          ContentColumns: self.props.data.gridMetadata.ContentColumns || null,
          ContentCells: self.props.data.gridMetadata.ContentCells || null
        };
      }

      /**
       * Create partial header html
       * @param {header} header object
       */
      function createHeader(header) {
        var formatSettings = getHeader(header.ModelName);
        if (!formatSettings) return;

        var style = {};

        if (formatSettings.Bold) style.fontWeight = 'bold';
        if (formatSettings.Italic) style.fontStyle = 'italic';
        if (!_.isNil(formatSettings.ForegroundColor)) style.color = formatSettings.ForegroundColor;
        if (!_.isNil(formatSettings.BackgroundColor)) style.backgroundColor = formatSettings.BackgroundColor;
        if (!_.isNil(formatSettings.Underline)) style.textDecoration = formatSettings.Underline ? 'underline' : '';

        return React.createElement(
          "th",
          { className: "secondary-text" },
          React.createElement(
            "div",
            { className: "table-header" },
            React.createElement(
              "span",
              { style: style },
              header.DisplayName
            )
          )
        );
      }

      /**
       * Content Row Style
       * Returns a css class
       * @param {row} row object
       */
      function consolidateContentRowStyle(row) {
        var content = getContent();
        if (!content) return;

        var rowNum = row.RowNumber;

        // Default
        var rowStyle = { backgroundColor: null };

        if (!_.isNil(content.ContentRow)) {
          if (content.ContentRow.hasOwnProperty('BackgroundColor')) rowStyle.backgroundColor = content.ContentRow.BackgroundColor || rowStyle.backgroundColor;
        }

        // Apply rows collection styles
        if (!_.isNil(content.ContentRows)) {
          var rowFound = findInRows(rowNum, content.ContentRows);
          if (rowFound) {
            // Try to override if properties are override in Rows collection
            if (rowFound.hasOwnProperty('BackgroundColor')) rowStyle.backgroundColor = rowFound.BackgroundColor || rowStyle.backgroundColor;
          }
        }

        return rowStyle;
      }

      /**
       * Content Style (Includes row, column and cell)
       * @param {*} row
       * @param {*} modelName
       */
      function consolidateContentStyle(row, modelName) {
        var content = getContent();
        if (!content) return;

        var rowNum = row.RowNumber;

        var rowStyle = {};
        var valueStyle = {};

        var rowFormat = {
          ForegroundColor: null, // not set use default instead
          BackgroundColor: null,
          Bold: false,
          Italic: false,
          Underline: null
        };

        if (!_.isNil(content.ContentRow)) {
          _.assignWith(rowFormat, self.props.data.gridMetadata.ContentRow, function (objValue, srcValue) {
            return _.isNil(srcValue) ? objValue : srcValue;
          });
        }

        // Mutate rowFormat along the way
        // Apply ContentRows collection styles
        if (!_.isNil(content.ContentRows)) {
          var rowFound = findInRows(rowNum, content.ContentRows);
          if (rowFound) {
            _.assignWith(rowFormat, rowFound, function (objValue, srcValue) {
              return _.isNil(srcValue) ? objValue : srcValue;
            });
          }
        }

        // Apply ContentColumn styles
        if (!_.isNil(content.ContentColumn)) {
          _.assignWith(rowFormat, content.ContentColumn, function (objValue, srcValue) {
            return _.isNil(srcValue) ? objValue : srcValue;
          });
        }

        // Apply ContentColumns collection styles
        if (!_.isNil(content.ContentColumns)) {
          var columnFound = findInColumns(modelName, content.ContentColumns);
          if (columnFound) {
            _.assignWith(rowFormat, columnFound, function (objValue, srcValue) {
              return _.isNil(srcValue) ? objValue : srcValue;
            });
          }
        }

        // Apply cell formatting
        if (!_.isNil(content.ContentCells)) {
          var cellsFound = findInCells(rowNum, modelName, content.ContentCells);
          if (cellsFound) {
            _.forEach(cellsFound, function (cellFound) {
              _.assignWith(rowFormat, cellFound, function (objValue, srcValue) {
                return _.isNil(srcValue) ? objValue : srcValue;
              });
            });
          }
        }

        // Create value style
        valueStyle.color = !_.isNil(rowFormat.ForegroundColor) ? rowFormat.ForegroundColor : '';
        valueStyle.backgroundColor = !_.isNil(rowFormat.BackgroundColor) ? rowFormat.BackgroundColor : '';
        if (!_.isNil(rowFormat.Bold)) valueStyle.fontWeight = rowFormat.Bold ? 'bold' : 'normal';
        if (!_.isNil(rowFormat.Italic)) valueStyle.fontStyle = rowFormat.Italic ? 'italic' : 'normal';
        if (!_.isNil(rowFormat.Underline)) valueStyle.textDecoration = rowFormat.Underline ? 'underline' : '';

        return valueStyle;
      }

      function findInRows(rowNum, rows) {
        return _.find(rows, function (o) {
          return o.RowNumber === rowNum;
        });
      }

      function findInColumns(modelName, columns) {
        return _.find(columns, function (o) {
          return o.ModelName === modelName;
        });
      }

      function findInCells(rowNum, modelName, cells) {
        return _.filter(cells, function (o) {
          return o.RowNumber === rowNum && o.ModelName === modelName;
        });
        // return _.find(cells, function (o) {
        //   return o.RowNumber === rowNum && o.ModelName === modelName;
        // });
      }

      function createRow(row) {
        var linkStyle = {
          cursor: 'pointer'
        };

        var rowStyle = consolidateContentRowStyle(row);

        return React.createElement(
          "tr",
          { style: rowStyle },
          self.props.data.Headers.map(function (header) {
            var contentStyle = consolidateContentStyle(row, header.ModelName);
            var haslink = header.ModelName == "TicketNumber" && self.props.haslink;
            //
            // let dataorder = row[header.ModelName];
            // if (header.ModelName.toLowerCase().includes("date")) {
            //    dataorder = moment(Date(row[header.ModelName])).unix();
            // }
            //dataOrder={dataorder}

            if (haslink) {
              return React.createElement(
                "td",
                { style: contentStyle },
                React.createElement(
                  "a",
                  { onClick: self.viewdetails.bind(this, row.TicketNumber), style: linkStyle },
                  row[header.ModelName]
                )
              );
            } else {
              return React.createElement(
                "td",
                { style: contentStyle },
                row[header.ModelName]
              );
            }
          })
        );
      }

      return React.createElement(
        "table",
        { className: "dataTable row-border hover", id: "view-reports" },
        React.createElement(
          "thead",
          null,
          React.createElement(
            "tr",
            null,
            self.props.data.Headers.map(createHeader)
          )
        ),
        React.createElement(
          "tbody",
          null,
          self.props.data.Rows.map(createRow)
        )
      );
    }
  }]);

  return ViewReportsComponent;
}(React.Component);

ViewReportsComponent.propTypes = {
  data: React.PropTypes.object.isRequired,
  haslink: React.PropTypes.bool.isRequired,
  viewdetails: React.PropTypes.func.isRequired
  //onlinkclick: React.PropTypes.func.isRequired
};
ViewReportsComponent.defaultProps = {
  data: {},
  haslink: false,
  viewdetails: function viewdetails() {}
  //onlinkclick: function () {}
};


angular.module('app.view_reports').value('ViewReportsComponent', ViewReportsComponent);
(function () {
  'use strict';

  angular.module('app.view_reports')
    .directive('viewReportsComponent', viewReportsComponent);

  /** @ngInject */
  function viewReportsComponent(reactDirective, ViewReportsComponent) {
    return reactDirective(ViewReportsComponent);
  }

})();


/**
 * Created by Ben Rei on 11/24/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.reporting.components.report_viewer',[])
})();

(function () {
  'use strict';

  angular
    .module('app.reporting.components.report_viewer')
    .controller('reportViewerComponentController', reportViewerComponentController);

  /** @ngInject */
  function reportViewerComponentController(){
    var vm = this;
    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      sort: true,
      lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "All"]],
      iDisplayStart: 100,
    };
  }
})();

/**
 * Created by Ben Rei on 11/24/2016.
 */
(function () {
  'use strict';

  angular.module('app.reporting.components.report_viewer')
    .directive('reportsViewerComponent', reportsViewerComponent);

  /** @ngInject */
  function reportsViewerComponent() {
    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl : 'app/main/reporting/view/ReportViewerComponent/report_viewer.html'
      , scope: {
        ngModel: '=',
        ngService: '=',
        name: '@'
      }
      , controller: 'reportViewerComponentController as vm'
      , bindToController: true
    };

    return directive;
  }
})();

/**
 * Created by Ben Rei on 11/24/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.reporting.components.headings',[])
})();

(function () {
  'use strict';

  angular
    .module('app.reporting.components.headings')
    .controller('headingsComponentController', headingsComponentController);

  /** @ngInject */
  function headingsComponentController(){
    var vm = this;
  }
})();

/**
 * Created by Ben Rei on 11/24/2016.
 */
(function () {
  'use strict';

  angular.module('app.reporting.components.headings')
    .directive('headingsComponent', headingsComponent);

  /** @ngInject */
  function headingsComponent() {
    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl : 'app/main/reporting/view/HeadingsComponent/headings.html'
      , scope: {
        ngModel: '=',
        ngService: '=',
        name: '@'
      }
      , controller: 'headingsComponentController as vm'
      , bindToController: true
    };

    return directive;
  }
})();

(function() {
    'use strict';

    angular
        .module('app.rateCardSettings', [
            'wj',
            'dndLists'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.rateCardSettings', {
                url: '/ratecard-settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/rateCardSettings/rateCardSettings.html',
                        controller: 'RateCardSettingsController as rateCard'
                    },
                    'content@allowances': {
                        templateUrl: 'app/main/rateCardSettings/allowances/allowances.html',
                        controller: 'RateCardSettingsAllowancesController as rateCardAllowances'
                    },
                    'content@timesheets': {
                        templateUrl: 'app/main/rateCardSettings/timesheets/timesheets.html',
                        controller: 'RateCardSettingsTimesheetsController as rateCardTimesheets'
                    },
                    'content@packages': {
                        templateUrl: 'app/main/rateCardSettings/packages/packages.html',
                        controller: 'RateCardSettingsPackagesController as rateCardPackages'
                    }
                },
                data: {
                    requireLogin: true,
                    validateAccess: ['adminClaimsService', function (adminClaimsService) {
                        return adminClaimsService.hasManageRateCardSettings;
                    }] 
                },
                title: 'Rate Card Settings',
                titleBar: 'Alloc8 - Rate Card Settings'
            });

        $translatePartialLoaderProvider.addPart('app/main/rateCardSettings');
    }
})();

(function () {
    'use strict';

    angular.module('app.rateCardSettings')
        .controller('surchargeHistoryLogDataController', surchargeHistoryLogDataController);

    /** @ngInject */
    function surchargeHistoryLogDataController($filter) {
        var vm = this;

        // The data prop comes in as a JSON string with the shape
        // { Old?: {...}, New?: {...} } per the standard audit pipeline.
        var logData = vm.data ? JSON.parse(vm.data) : {};
        var newData = logData['New'] || null;
        var oldData = logData['Old'] || null;

        var rows = [];
        if (newData && oldData) {
            // Updated: only show fields whose values differ.
            Object.keys(newData).forEach(function (key) {
                if (oldData[key] !== newData[key]) {
                    rows.push({
                        FieldName: friendlyFieldName(key),
                        Previous: formatValue(key, oldData[key]),
                        New: formatValue(key, newData[key])
                    });
                }
            });
        } else if (newData) {
            // Created: every field is "new".
            Object.keys(newData).forEach(function (key) {
                rows.push({
                    FieldName: friendlyFieldName(key),
                    Previous: null,
                    New: formatValue(key, newData[key])
                });
            });
        } else if (oldData) {
            // Deleted: snapshot the deleted entity for the audit trail.
            Object.keys(oldData).forEach(function (key) {
                rows.push({
                    FieldName: friendlyFieldName(key),
                    Previous: null,
                    New: formatValue(key, oldData[key])
                });
            });
        }

        vm.rows = rows;
        vm.hasPrevious = rows.some(function (r) { return r.Previous !== null && r.Previous !== undefined; });

        function friendlyFieldName(key) {
            switch (key) {
                case 'CalculationMethod': return 'Calculation Method';
                case 'EffectiveDate': return 'Effective Date';
                case 'IncludeAllowances': return 'Include Allowances';
                case 'IncludeEstablishmentFee': return 'Include Establishment Fee';
                case 'IncludedShifts': return 'Included Shifts';
                case 'IncludedVehicles': return 'Included Vehicles';
                default: return key;
            }
        }

        function formatValue(key, raw) {
            if (raw == null || raw === '') return '';

            switch (key) {
                case 'CalculationMethod':
                    return formatCalculationMethod(raw);
                case 'Taxable':
                    return formatBoolean(raw);
                case 'EffectiveDate':
                    return formatDate(raw);
                default:
                    return raw;
            }
        }

        function formatCalculationMethod(raw) {
            switch (String(raw)) {
                case 'PercentageInvoice': return 'percentage of invoice subtotal';
                case 'PercentageVehicle': return 'percentage per vehicle';
                case 'FixedVehicle': return 'fixed amount per vehicle';
                default: return raw;
            }
        }

        function formatBoolean(raw) {
            if (raw === true || String(raw).toLowerCase() === 'true') return 'Yes';
            if (raw === false || String(raw).toLowerCase() === 'false') return 'No';
            return raw;
        }

        function formatDate(raw) {
            var parsed = new Date(raw);
            if (isNaN(parsed.getTime())) return raw;
            return $filter('date')(parsed, 'dd/MM/yyyy');
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.rateCardSettings')
        .directive('surchargeHistoryLogData', surchargeHistoryLogDataComponent);

    /** @ngInject */
    function surchargeHistoryLogDataComponent() {
        return {
            restrict: 'E',
            templateUrl: 'app/main/rateCardSettings/surcharges/historyLog/surcharge-history-log-data.html',
            scope: {
                data: '='
            },
            controller: 'surchargeHistoryLogDataController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.rateCardSettings')
        .constant('surchargeCalculationMethods', {
            PercentageInvoice: 1,
            PercentageVehicle: 2,
            FixedVehicle: 3
        })
        .controller('AddSurchargeController', AddSurchargeController);

    /** @ngInject */
    function AddSurchargeController(
        $rootScope,
        $mdDialog,
        utils,
        blockUI,
        hubService,
        exceptionService,
        surchargesAPI,
        lookupApi,
        surchargeCalculationMethods,
        locals
    ) {
        let self = this;
        self.calculationMethods = surchargeCalculationMethods;
        self.surcharge = locals.surcharge || null;
        self.isEdit = !!locals.isEdit;
        // Rate-card-owned mode: the dialog returns the surcharge to the parent rate-card form
        // (which persists it with the rate card) instead of calling the per-surcharge API.
        self.embedded = !!locals.embedded;
        self.formData = defaultFormData();
        self.errors = {};
        self.shiftTypes = [];
        self.shiftTypesLoading = false;
        self.shiftSearch = '';
        self.vehicleTypes = [];
        self.vehicleTypesLoading = false;
        self.vehicleSearch = '';

        if (self.surcharge) {
            self.formData = formDataFromSurcharge(self.surcharge);
        }

        // 'all' = the empty-list state (all types incl. future). 'specific' = an explicit subset,
        // which may be transiently empty while the admin is picking (blocked on save).
        self.shiftMode = self.formData.IncludedShiftTypeIds.length === 0 ? 'all' : 'specific';
        self.vehicleMode = self.formData.IncludedVehicleTypeIds.length === 0 ? 'all' : 'specific';

        loadShiftTypes();
        loadVehicleTypes();

        function loadShiftTypes() {
            self.shiftTypesLoading = true;
            lookupApi.getMinifiedPeopleTypes(true)
                .then(function (resp) {
                    self.shiftTypes = mapAndSortTypes(resp.data);
                    // A saved selection that already covers every known type (with no orphans)
                    // is normalised to the empty "All" state so the picker opens consistently.
                    normaliseShiftSelection();
                    self.shiftTypesLoading = false;
                }, function (err) {
                    self.shiftTypesLoading = false;
                    exceptionService.resolve(err);
                });
        }

        function loadVehicleTypes() {
            self.vehicleTypesLoading = true;
            lookupApi.getMinifiedVehicleTypes(true)
                .then(function (resp) {
                    self.vehicleTypes = mapAndSortTypes(resp.data);
                    normaliseVehicleSelection();
                    self.vehicleTypesLoading = false;
                }, function (err) {
                    self.vehicleTypesLoading = false;
                    exceptionService.resolve(err);
                });
        }

        function mapAndSortTypes(data) {
            return (data || [])
                .map(function (t) {
                    return { Id: t.Id || t.id, Name: t.Name || t.name };
                })
                .sort(function (a, b) {
                    return (a.Name || '').localeCompare(b.Name || '');
                });
        }

        // Both selectors apply only to Percentage-of-subtotal; the per-vehicle methods narrow
        // per vehicle line and have no notion of an invoice-subtotal base to filter.
        self.showShiftTypeSelector = function () {
            return self.formData.CalculationMethod === self.calculationMethods.PercentageInvoice;
        };

        self.showVehicleTypeSelector = function () {
            return self.formData.CalculationMethod === self.calculationMethods.PercentageInvoice;
        };

        self.showIncludeAllowances = function () {
            return self.formData.CalculationMethod === self.calculationMethods.PercentageInvoice;
        };

        self.showIncludeEstablishmentFee = function () {
            return self.formData.CalculationMethod === self.calculationMethods.PercentageInvoice;
        };

        // FixedVehicle stores per-vehicle rates on SurchargeVehicleRate rows, so the modal hides
        // the Rate (%) input entirely; admins set per-vehicle rates from Rate Card Pricing.
        self.showRateInput = function () {
            return self.formData.CalculationMethod !== self.calculationMethods.FixedVehicle;
        };

        self.onMethodChange = function () {
            self.errors = {};
            // Retain included ids across method changes so a switch back to Percentage-of-subtotal
            // restores them; buildPayload omits the fields for other methods, so the persisted IDs
            // stay intact. FixedVehicle hides the Rate (%) input, so clear any stale value.
            if (!self.showRateInput()) {
                self.formData.RatePercentage = null;
            }
        };

        // --- Shift-type selector -------------------------------------------------------------

        // The "All shift types" master reflects shiftMode: 'all' => checked, 'specific' with picks
        // => indeterminate, 'specific' with none => unchecked (the "cleared, pick some" state).
        self.isAllMode = function () {
            return self.shiftMode === 'all';
        };

        self.isPartialSelection = function () {
            return self.shiftMode === 'specific'
                && self.formData.IncludedShiftTypeIds.length > 0;
        };

        // Toggling the master switches between "all (incl. future)" and an empty Specific list the
        // admin then fills in. Both states clear the array; only the mode differs.
        self.toggleAllMode = function () {
            self.shiftMode = self.shiftMode === 'all' ? 'specific' : 'all';
            self.formData.IncludedShiftTypeIds = [];
        };

        self.isShiftChecked = function (id) {
            return self.isAllMode()
                || self.formData.IncludedShiftTypeIds.indexOf(id) >= 0;
        };

        self.toggleShiftType = function (id) {
            if (self.isAllMode()) {
                // Unticking one type while "All" is selected drops into Specific mode with every
                // other known type kept; future types are no longer covered.
                self.shiftMode = 'specific';
                self.formData.IncludedShiftTypeIds = knownIds(self.shiftTypes)
                    .filter(function (knownId) { return knownId !== id; });
                return;
            }

            toggleIn(self.formData.IncludedShiftTypeIds, id);
            normaliseShiftSelection();
        };

        // Orphan = an ID in formData that no longer resolves to a known type.
        self.getOrphanedShiftIds = function () {
            return orphanIds(self.formData.IncludedShiftTypeIds, self.shiftTypes);
        };

        self.removeOrphanedShift = function (id) {
            removeFrom(self.formData.IncludedShiftTypeIds, id);
            normaliseShiftSelection();
        };

        function normaliseShiftSelection() {
            if (self.shiftMode === 'specific'
                && self.getOrphanedShiftIds().length === 0
                && allKnownSelected(self.formData.IncludedShiftTypeIds, self.shiftTypes)) {
                self.shiftMode = 'all';
                self.formData.IncludedShiftTypeIds = [];
            }
        }

        // --- Vehicle-type selector (mirrors the shift-type selector) -------------------------

        self.isAllVehicleMode = function () {
            return self.vehicleMode === 'all';
        };

        self.isPartialVehicleSelection = function () {
            return self.vehicleMode === 'specific'
                && self.formData.IncludedVehicleTypeIds.length > 0;
        };

        self.toggleAllVehicleMode = function () {
            self.vehicleMode = self.vehicleMode === 'all' ? 'specific' : 'all';
            self.formData.IncludedVehicleTypeIds = [];
        };

        self.isVehicleChecked = function (id) {
            return self.isAllVehicleMode()
                || self.formData.IncludedVehicleTypeIds.indexOf(id) >= 0;
        };

        self.toggleVehicleType = function (id) {
            if (self.isAllVehicleMode()) {
                self.vehicleMode = 'specific';
                self.formData.IncludedVehicleTypeIds = knownIds(self.vehicleTypes)
                    .filter(function (knownId) { return knownId !== id; });
                return;
            }

            toggleIn(self.formData.IncludedVehicleTypeIds, id);
            normaliseVehicleSelection();
        };

        self.getOrphanedVehicleIds = function () {
            return orphanIds(self.formData.IncludedVehicleTypeIds, self.vehicleTypes);
        };

        self.removeOrphanedVehicle = function (id) {
            removeFrom(self.formData.IncludedVehicleTypeIds, id);
            normaliseVehicleSelection();
        };

        function normaliseVehicleSelection() {
            if (self.vehicleMode === 'specific'
                && self.getOrphanedVehicleIds().length === 0
                && allKnownSelected(self.formData.IncludedVehicleTypeIds, self.vehicleTypes)) {
                self.vehicleMode = 'all';
                self.formData.IncludedVehicleTypeIds = [];
            }
        }

        // --- Shared selection helpers --------------------------------------------------------

        function toggleIn(list, id) {
            const idx = list.indexOf(id);
            if (idx >= 0) {
                list.splice(idx, 1);
            } else {
                list.push(id);
            }
        }

        function removeFrom(list, id) {
            const idx = list.indexOf(id);
            if (idx >= 0) {
                list.splice(idx, 1);
            }
        }

        function orphanIds(selectedIds, knownTypes) {
            if (!knownTypes.length) return [];
            const known = {};
            knownTypes.forEach(function (t) { known[t.Id] = true; });
            return selectedIds.filter(function (id) { return !known[id]; });
        }

        function allKnownSelected(selectedIds, knownTypes) {
            const known = knownIds(knownTypes);
            return known.length > 0 && known.every(function (knownId) {
                return selectedIds.indexOf(knownId) >= 0;
            });
        }

        function knownIds(knownTypes) {
            return knownTypes.map(function (t) { return t.Id; });
        }

        // --- Save / validate / payload -------------------------------------------------------

        self.save = function () {
            if (!validate()) return;

            const payload = buildPayload();

            if (self.embedded) {
                // Return to the parent rate-card form; it holds the surcharge on
                // formData.Surcharges and saves it when the rate card is saved.
                $mdDialog.hide(self.isEdit && self.surcharge && self.surcharge.Id
                    ? angular.extend({ Id: self.surcharge.Id }, payload)
                    : payload);
                return;
            }

            blockUI.start();

            const promise = self.isEdit
                ? surchargesAPI.patch(self.surcharge.Id, payload, self.formData.ETag)
                : surchargesAPI.create(payload);

            promise.then(function () {
                hubService.showToast(utils.translate(
                    self.isEdit
                        ? 'RATECARD_V2.SURCHARGES.UPDATE_MESSAGE'
                        : 'RATECARD_V2.SURCHARGES.CREATE_MESSAGE'));
                $rootScope.$broadcast('surcharge.saved');
                blockUI.stop();
                $mdDialog.hide();
            }, function (err) {
                blockUI.stop();
                if (err && err.status === 412) {
                    hubService.showToast(utils.translate('RATECARD_V2.SURCHARGES.CONFLICT_MESSAGE'));
                    if (err.data && err.data.current) {
                        self.surcharge = err.data.current;
                        self.formData = formDataFromSurcharge(self.surcharge);
                        self.shiftMode = self.formData.IncludedShiftTypeIds.length === 0 ? 'all' : 'specific';
                        self.vehicleMode = self.formData.IncludedVehicleTypeIds.length === 0 ? 'all' : 'specific';
                    }
                    return;
                }
                if (err && err.status === 400 && err.data && err.data.modelState) {
                    self.errors = err.data.modelState;
                    return;
                }
                exceptionService.resolve(err);
            });
        };

        self.cancel = function () {
            $mdDialog.cancel();
        };

        function validate() {
            self.errors = {};
            if (!self.formData.Name || !self.formData.Name.trim()) {
                self.errors.Name = utils.translate('RATECARD_V2.SURCHARGES.ERR_NAME_REQUIRED');
            } else if (self.formData.Name.length > 100) {
                self.errors.Name = utils.translate('RATECARD_V2.SURCHARGES.ERR_NAME_TOO_LONG');
            }

            if (!self.formData.EffectiveDate) {
                self.errors.EffectiveDate = utils.translate('RATECARD_V2.SURCHARGES.ERR_EFFECTIVE_REQUIRED');
            }

            const isPercentage = self.formData.CalculationMethod === self.calculationMethods.PercentageInvoice
                              || self.formData.CalculationMethod === self.calculationMethods.PercentageVehicle;
            if (isPercentage) {
                const rate = parseFloat(self.formData.RatePercentage);
                if (isNaN(rate) || rate < 0.01 || rate > 100.00) {
                    self.errors.RatePercentage = utils.translate('RATECARD_V2.SURCHARGES.ERR_RATE_RANGE');
                }
            }
            // FixedVehicle skips the rate validation entirely -- per-vehicle rates live on
            // SurchargeVehicleRate rows, not on the surcharge itself.

            // "All" (empty list) is valid, but Specific mode must include at least one entry --
            // an empty Specific selection would be read by the engine as "all".
            if (self.showShiftTypeSelector()
                && self.shiftMode === 'specific'
                && self.formData.IncludedShiftTypeIds.length === 0) {
                self.errors.IncludedShiftTypeIds =
                    utils.translate('RATECARD_V2.SURCHARGES.ERR_SHIFTS_REQUIRED');
            }

            if (self.showVehicleTypeSelector()
                && self.vehicleMode === 'specific'
                && self.formData.IncludedVehicleTypeIds.length === 0) {
                self.errors.IncludedVehicleTypeIds =
                    utils.translate('RATECARD_V2.SURCHARGES.ERR_VEHICLES_REQUIRED');
            }

            return Object.keys(self.errors).length === 0;
        }

        function buildPayload() {
            const payload = {
                Name: self.formData.Name,
                CalculationMethod: self.formData.CalculationMethod,
                // FixedVehicle: RatePercentage must be null per the backend validator (rates
                // live on SurchargeVehicleRate rows). Other methods send the form value (or
                // null when blank).
                RatePercentage: self.showRateInput() && self.formData.RatePercentage != null
                    ? Number(self.formData.RatePercentage)
                    : null,
                IsTaxable: true,
                EffectiveDate: self.formData.EffectiveDate,
                IsActive: !!self.formData.IsActive
            };
            // Only send the included-type lists for Percentage-of-subtotal. Omitting them on PATCH
            // leaves the persisted values untouched (so selections survive a method switch); omitting
            // them on CREATE for other methods keeps them at the "All" default.
            if (self.showShiftTypeSelector()) {
                payload.IncludedShiftTypeIds = self.formData.IncludedShiftTypeIds || [];
            }
            if (self.showVehicleTypeSelector()) {
                payload.IncludedVehicleTypeIds = self.formData.IncludedVehicleTypeIds || [];
            }
            if (self.showIncludeAllowances()) {
                payload.IncludeAllowances = !!self.formData.IncludeAllowances;
            }
            if (self.showIncludeEstablishmentFee()) {
                payload.IncludeEstablishmentFee = !!self.formData.IncludeEstablishmentFee;
            }
            return payload;
        }

        function formDataFromSurcharge(surcharge) {
            return {
                Name: surcharge.Name,
                CalculationMethod: surcharge.CalculationMethod,
                RatePercentage: surcharge.RatePercentage,
                EffectiveDate: surcharge.EffectiveDate ? new Date(surcharge.EffectiveDate) : new Date(),
                IsActive: !!surcharge.IsActive,
                IncludedShiftTypeIds: angular.copy(surcharge.IncludedShiftTypeIds) || [],
                IncludedVehicleTypeIds: angular.copy(surcharge.IncludedVehicleTypeIds) || [],
                // Absent (legacy) or true => included; only an explicit false excludes.
                IncludeAllowances: surcharge.IncludeAllowances !== false,
                IncludeEstablishmentFee: surcharge.IncludeEstablishmentFee !== false,
                ETag: surcharge.ETag
            };
        }

        function defaultFormData() {
            return {
                Name: '',
                CalculationMethod: self.calculationMethods.PercentageInvoice,
                RatePercentage: null,
                EffectiveDate: new Date(),
                IsActive: true,
                IncludedShiftTypeIds: [],
                IncludedVehicleTypeIds: [],
                IncludeAllowances: true,
                IncludeEstablishmentFee: true,
                ETag: null
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.rateCardSettings')
        .controller('PackageDialogController', PackageDialogController);

    function PackageDialogController($scope,
        $mdDialog,
        locals
    ) {
        let vm = this;
        vm.packageGroupsMsg = locals.packageGroupsMsg;

        $scope.hasUserAccepted = function(hasUserAccepted) {
            $mdDialog.hide(hasUserAccepted);
        };
    }
})();

(function() {
    'use strict';
    angular.module('app.rateCardSettings')
        .directive('addPackageGroupComponent', addPackageGroupComponent);

    /** @ngInject */
    function addPackageGroupComponent($mdDialog) {
        let directive = {
            restrict: 'E',
            scope: {
                datacount: '@'
            },
            templateUrl: 'app/main/rateCardSettings/directives/addPackageGroup/addPackageGroupComponent.directive.html',
            controller: AddPackageGroupComponent,
            controllerAs: 'addPackageGroup',
            bindToController: true
        };

        return directive;

        function AddPackageGroupComponent(
            $rootScope,
            $scope,
            $attrs,
            $element,
            rateCardSettingsService
        ) {
            let self = this;

            self.counter = parseInt($attrs.datacount);

            self.datasrc = !_.isNil(rateCardSettingsService.getPackageGroup()) ? rateCardSettingsService.getPackageGroup() : [];

            if (_.isNil(self.datasrc[self.counter])) {
                self.datasrc[self.counter] = [];
            }

            self.packageItem = [];
            self.packageItem.count = _.size(self.datasrc[self.counter]);
            self.packageItem.innerCount = 0;

            self.$onInit = function() {
                self.invoiceGroupsLookup = $scope.$parent.rateCardPackages.invoiceGroupsLookup;
            };

            self.launchAddPackageItem = function(isItemCollection, itemCollectionCount) {
                self.packageItem.formData = [];

                if (isItemCollection) {
                    self.packageItem.isItemCollection = isItemCollection;
                    self.packageItem.currentCollectionCount = itemCollectionCount;
                } else {
                    self.packageItem.isItemCollection = false;
                }

                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/main/rateCardSettings/directives/addPackageGroup/_add-package-item.html',
                    controller: function() {
                        return self;
                    },
                    controllerAs: 'packageItemController',
                });
            };

            self.closePricingModal = function() {
                $mdDialog.cancel();
            };

            self.addPricingItem = function() {
                let formData = self.packageItem.formData;
                let params = {
                    "InvoiceGroupName": formData.InvoiceGroupName,
                    "Quantity": formData.Quantity,
                    "InvoiceSeparatelyAlso": formData.InvoiceSeparatelyAlso
                };

                if (self.packageItem.isItemCollection) {
                    (self.datasrc[self.counter][self.packageItem.currentCollectionCount].PackageItems).push(params);
                } else {
                    self.datasrc[self.counter][self.packageItem.count] = {};
                    self.datasrc[self.counter][self.packageItem.count].PackageItems = [];
                    self.datasrc[self.counter][self.packageItem.count].PackageItems[self.packageItem.innerCount] = params;

                    self.packageItem.count++;
                }

                rateCardSettingsService.setPackageGroup(self.counter, self.datasrc[self.counter]);

                self.packageItem.formData = [];
                $mdDialog.cancel();
            };

            self.updateQuantity = function(counter) {
                rateCardSettingsService.setPackageGroup(counter, self.datasrc[counter]);
            };

            self.updateInvoiceSeparatelyAlso = function(counter) {
                rateCardSettingsService.setPackageGroup(counter, self.datasrc[counter]);
            };

            self.removePackageItem = function(groupCounter, itemCounter, subItemCounter) {
                let initialCount = _.size(self.datasrc[self.counter]);
                rateCardSettingsService.removeItem(groupCounter, itemCounter, subItemCounter);
                if (initialCount > _.size(self.datasrc[self.counter])) {
                    self.packageItem.count--;
                }
            };

            self.removePackageGroup = function(groupCounter, itemCounter) {
                self.packageItem.count--;
                rateCardSettingsService.removePackageGroup(groupCounter, itemCounter, !_.isNil(itemCounter));

                if (_.isNil(itemCounter)) {
                    $element.remove();
                    $rootScope.$broadcast("removePackageGroup");
                }
            };

            self.filterInvoiceGroupsLookup = function(){
                let packageGroupInvoiceNames = [];

                self.datasrc[self.counter].forEach(packageGroup => {
                    packageGroup.PackageItems.forEach(packageItem => {
                        packageGroupInvoiceNames.push(packageItem.InvoiceGroupName);
                    });
                });

                self.invoiceGroupsLookup = self.invoiceGroupsLookup.filter(invoiceGroupName => !packageGroupInvoiceNames.includes(invoiceGroupName));
            }

            $scope.$on("removePackageGroup", function() {
                if (self.counter >= rateCardSettingsService.lastPackageGroupCounter) {
                    self.counter--;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.project.create', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.project_create', {
            url: '/project/create-a-project',
            views: {
                'content@app': {
                    templateUrl: 'app/main/projects/create/project-create.html',
                    controller: 'ProjectCreateController as vm'
                }
            },
            title: 'Create Project',
            data: {
                requireLogin: true
            }
        }).state('app.project_update', {
            url: '/project/update/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/projects/create/project-create.html',
                    controller: 'ProjectCreateController as vm'
                }
            },
            title: 'Update Project',
            data: {
                requireLogin: true
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/projects/create');
    };

})();

(function(){
    'use strict';

    angular.module('app.project.create')
        .directive('projectSkills', projectSkills);

    function projectSkills() {
        var directive = {
            restrict : 'E',
            templateUrl : 'app/main/projects/create/skills/project-skills.html',
            scope : {
                ngModel : '=',
                skills : '='
            },
            controller : projectSkillsController,
            controllerAs : 'vm',
            bindToController : true
        };

        return directive;

        function projectSkillsController(claimsUtilService, $mdDialog) {

            var vm = this;

            vm.has_access = claimsUtilService.checkAccessByRole("Manage Company Skills");

            vm.remove = remove;
            vm.add = add;

            function remove(skill){
                vm.ngModel = vm.ngModel.filter(function(item){
                    return item.Id != skill.Id;
                });
            }

            function add(){
                $mdDialog.show({
                    templateUrl : "app/main/projects/create/skills/project-skills.dialog.html",
                    controller : "projectSkillsDialogController",
                    controllerAs : "vm",
                    locals : {
                        skills : vm.skills,
                        current_skills : vm.ngModel
                    }
                })
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.project.create')
        .controller('projectSkillsDialogController', projectSkillsDialogController);

    function projectSkillsDialogController($mdDialog, skills, current_skills, _) {

        var vm = this;
        vm.look_up = [];
        vm.skill_model = null;

        //Methods
        vm.activate = activate;
        vm.onCancel = onCancel;
        vm.onDone = onDone;

        vm.activate();

        //Implementations
        function activate(){

            let flattened_skill = [];

            skills.forEach(function(s){
                if(s.ChildSkills.length === 0){
                    flattened_skill.push({
                        Id : s.id,
                        Name : s.SkillName
                    });
                }else{
                    s.ChildSkills.forEach(function(sk){
                        flattened_skill.push({
                            Id : sk.id,
                            Name : sk.SkillName
                        });
                    });
                }
            });

            vm.look_up = _.orderBy(_.filter(flattened_skill, function(obj){
                return !_.find(current_skills, {Id: obj.Id});
            }), ['Name'], ['asc']);
        }

        function onCancel(){
            $mdDialog.hide();
        }

        function onDone() {
            current_skills.push(vm.skill_model);
            $mdDialog.hide();
        }

        vm.activate();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.payroll-settings.manage', ['wj', 'ui.ace'])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        $stateProvider.state('app.payroll-settings', {
            url: '/payroll-settings/manage',
            views: {
                'content@app': {
                    templateUrl: 'app/main/payrollSettings/manage/payroll-settings-manage.html',
                    controller: 'PayrollSettingsController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManagePayrollSettingsMenu;
                }]
            },
            title: 'Manage Payroll Settings',
            titleBar: 'Alloc8 - Manage Payroll Settings'
        });

        $translatePartialLoaderProvider.addPart('app/main/payrollSettings');
    }

    function runConfig(
        tenantSettings
    ) {
        wijmo.setLicenseKey(tenantSettings.wijmoLicenseKey);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.payroll-settings.manage')
        .controller('PayrollSettingsAddTimesheetHeadingsController', PayrollSettingsAddTimesheetHeadingsController);

    /** @ngInject */
    function PayrollSettingsAddTimesheetHeadingsController(
        $mdDialog,
        utils,
        _,
        variables,
        payrollSettingsService) {

        //Data
        var self = this;
        self.utilService = utils;
        self.service = payrollSettingsService;

        // Method
        self.onDone = onDone;
        self.onCancel = onCancel;
        self.activate = activate;
        self.addTimesheetHeadings = addTimesheetHeadings;
        self.isEdit = isEdit;
        self.hasError = false;
        self.errorMessage = "";

        self.activate();

        function onDone() {
        }

        function isEdit() {
            return (!_.isNil(variables.formData) || !_.isEmpty(variables.formData));
        }

        function activate(){
            self.timesheetHeading = isEdit() ? variables.formData.Name : "";
            self.timesheetCodes = isEdit() ? _.join(variables.formData.HeaderCodes, "\n") : "";
            self.timesheetDisplayOrder = isEdit() ? variables.formData.DisplayOrder : 0;
        }

        function addTimesheetHeadings(){
            self.hasError = false;
            if (isEdit()) {
                let params = {
                    Name: self.timesheetHeading,
                    HeaderCodes: _.split(self.timesheetCodes, "\n"),
                    DisplayOrder: self.timesheetDisplayOrder
                };

                self.service.updateTimesheetDetails(self.timesheetHeading, params, variables.rateIndex)
                    .then(function(){
                        onCancel();
                    }, function(err){
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                    });
            } else {
                let params = {
                                Name: self.timesheetHeading,
                                HeaderCodes: _.split(self.timesheetCodes, "\n"),
                                DisplayOrder: self.timesheetDisplayOrder
                            };

                self.service.addTimesheetDetails(params)
                    .then(function(data){
                        onCancel();
                    }, function(err){
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                    });
            }
        }

        function onCancel() {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.payroll-settings.manage')
        .controller('PayrollSettingsAddTaxRateController', PayrollSettingsAddTaxRateController);

    /** @ngInject */
    function PayrollSettingsAddTaxRateController(
        $mdDialog,
        utils,
        _,
        variables,
        payrollSettingsService) {

        //Data
        var self = this;
        self.utilService = utils;
        self.service = payrollSettingsService;

        // Method
        self.onDone = onDone;
        self.onCancel = onCancel;
        self.activate = activate;
        self.addTaxRatesByBranch = addTaxRatesByBranch;
        self.isEdit = isEdit;
        self.hasError = false;
        self.errorMessage = "";

        self.activate();

        function onDone() {
        }

        function isEdit() {
            return (!_.isNil(variables.formData) || !_.isEmpty(variables.formData)) && !variables.branches;
        }

        function activate(){
            self.branchesLookUp = !isEdit() ? variables.branches : [];
            self.branchTax = isEdit() ? variables.formData.BranchId : "";
            self.branchTaxRate = isEdit() ? variables.formData.TaxRate : 0;
            self.branchTaxYear = isEdit() ? variables.formData.Year : 0;
            self.branchName = isEdit() ? variables.formData.BranchName : "";
        }

        function addTaxRatesByBranch(){
            self.hasError = false;
            if (isEdit()) {
                let params = {  BranchId: self.branchTax,
                                Year: self.branchTaxYear,
                                Rate: _.toNumber(self.branchTaxRate)
                            };

                self.service.updatePayrollTaxRates(params, variables.rateIndex)
                    .then(function(){
                        onCancel();
                    }, function(err){
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                    });
            } else {
                let branchParams = _.map(self.branchTax, function (branch) {
                                        return {
                                                 Id: branch.Id,
                                                 Name: branch.Name
                                                };
                                    });

                self.service.addPayrollTaxRate(self.branchTaxYear, self.branchTaxRate, branchParams)
                    .then(function(data){
                        onCancel();
                    }, function(err){
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                    });
            }
        }

        function onCancel() {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.payroll-settings.manage')
        .controller('PayrollSettingsAddSuperannuationRateController', PayrollSettingsAddSuperannuationRateController);

    /** @ngInject */
    function PayrollSettingsAddSuperannuationRateController(
        $mdDialog,
        utils,
        _,
        variables,
        payrollSettingsService) {

        //Data
        var self = this;
        self.utilService = utils;
        self.service = payrollSettingsService;

        // Method
        self.onDone = onDone;
        self.onCancel = onCancel;
        self.activate = activate;
        self.addSuperannuationRatesByBranch = addSuperannuationRatesByBranch;
        self.isEdit = isEdit;
        self.hasError = false;
        self.errorMessage = "";

        self.activate();

        function onDone() {
        }

        function isEdit() {
            return (!_.isNil(variables.formData) || !_.isEmpty(variables.formData)) && !variables.branches;
        }

        function activate(){
            self.branchesLookUp = !isEdit() ? variables.branches : [];
            self.branchSuperannuation = isEdit() ? variables.formData.BranchId : "";
            self.branchSuperannuationRate = isEdit() ? variables.formData.SuperannuationRate : 0;
            self.branchSuperannuationYear = isEdit() ? variables.formData.Year : 0;
            self.branchName = isEdit() ? variables.formData.BranchName : "";
        }

        function addSuperannuationRatesByBranch(){
            self.hasError = false;
            if (isEdit()) {
                let params = {  BranchId: self.branchSuperannuation,
                    Year: self.branchSuperannuationYear,
                    Rate: _.toNumber(self.branchSuperannuationRate)
                };

                self.service.updatePayrollSuperannuationRates(params, variables.rateIndex)
                    .then(function(){
                        onCancel();
                    }, function(err){
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                    });
            } else {
                let branchParams = _.map(self.branchSuperannuation, function (branch) {
                    return {
                        Id: branch.Id,
                        Name: branch.Name
                    };
                });

                self.service.addPayrollSuperannuationRate(self.branchSuperannuationYear, self.branchSuperannuationRate, branchParams)
                    .then(function(data){
                        onCancel();
                    }, function(err){
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                    });
            }
        }

        function onCancel() {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.payroll-settings.manage')
        .controller('PayrollSettingsAddCompensationRateController', PayrollSettingsAddCompensationRateController);

    /** @ngInject */
    function PayrollSettingsAddCompensationRateController(
        $mdDialog,
        utils,
        _,
        variables,
        payrollSettingsService) {

        //Data
        var self = this;
        self.utilService = utils;
        self.service = payrollSettingsService;

        // Method
        self.onDone = onDone;
        self.onCancel = onCancel;
        self.activate = activate;
        self.addCompensationRatesByBranch = addCompensationRatesByBranch;
        self.isEdit = isEdit;
        self.hasError = false;
        self.errorMessage = "";

        self.activate();

        function onDone() {
        }

        function isEdit() {
            return (!_.isNil(variables.formData) || !_.isEmpty(variables.formData)) && !variables.branches;
        }

        function activate(){
            self.branchesLookUp = !isEdit() ? variables.branches : [];
            self.branchCompensation = isEdit() ? variables.formData.BranchId : "";
            self.branchCompensationRate = isEdit() ? variables.formData.CompensationRate : 0;
            self.branchCompensationYear = isEdit() ? variables.formData.Year : 0;
            self.branchName = isEdit() ? variables.formData.BranchName : "";
        }

        function addCompensationRatesByBranch(){
            self.hasError = false;
            if (isEdit()) {
                let params = {  BranchId: self.branchCompensation,
                    Year: self.branchCompensationYear,
                    Rate: _.toNumber(self.branchCompensationRate)
                };

                self.service.updatePayrollCompensationRates(params, variables.rateIndex)
                    .then(function(data){
                        onCancel();
                    }, function(err) {
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                    });
            } else {
                let branchParams = _.map(self.branchCompensation, function(branch) {
                    return {
                        Id: branch.Id,
                        Name: branch.Name
                    };
                });

                self.service.addPayrollCompensationRate(self.branchCompensationYear, self.branchCompensationRate, branchParams)
                    .then(function(data){
                        onCancel();
                    }, function(data){
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                    });
            }
        }

        function onCancel() {
            $mdDialog.cancel();
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .directive('paperWorkExceptionsMainView', paperWorkExceptionsMainView);

    /** @ngInject */
    function paperWorkExceptionsMainView(
        paperworkExceptionsApi
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/paperworkExceptions/directives/mainView/main-container.html',
            scope: {
                refresh: '&',
                isBusy: '=',
                loaderMessage: '=',
                gridData: '=',
                filter: '&'
            },
            controller: paperWorkExceptionsMainViewController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function paperWorkExceptionsMainViewController(
            _, utils,
            mediaQueryService,
            PaperworkExceptionService
        ) {
            var vm = this;
            vm.service = PaperworkExceptionService;
            vm.report_filter = [];
            vm.media = mediaQueryService;

            vm.activateSave = activateSave;
            vm.save = save;
            vm.getReportsLength = getReportsLength;
            vm.filterReportsInClientSide = filterReportsInClientSide;
            vm.limit = limit;
            vm.handle = handle;

            function handle(params) {
                angular.forEach(vm.gridData, function(grid) {
                    angular.forEach(grid.DataRows, function(row) {
                        let PrimaryId = _.find(row, {
                            HeaderKey: "PrimaryId"
                        }).Value;
                        let SecondaryId = _.find(row, {
                            HeaderKey: "SecondaryId"
                        }).Value;
                        let ExceptionType = _.find(row, {
                            HeaderKey: "ExceptionType"
                        }).Value;
                        let ReportTypeCategory = _.find(row, {
                            HeaderKey: "ReportTypeCategory"
                        }).Value;
                        if (PrimaryId === params.PrimaryId && SecondaryId === params.SecondaryId && ExceptionType === params.ExceptionType && ReportTypeCategory === params.ReportTypeCategory) {
                            angular.forEach(row, function(r) {
                                if (r.HeaderKey === "IsSelected") {
                                    r.Value = params.Value;
                                }
                            })
                        }
                    });
                });
            }

            function filterReportsInClientSide() {
                let reports_ids = getReportIds(vm.report_filter);
                vm.filter({
                    id: reports_ids
                });
            }

            function getReportIds(report_types) {
                return report_types.map(function(report) {
                    return report.Id;
                });
            }

            function getReportsLength() {
                return _.filter(vm.gridData, function(itm) {
                    return itm;
                }).length;
            }

            function limit(arr, title) {
                return (_.isNil(arr) || arr.length === 0) ? utils.translate(title) : limitDisplay(arr);
            }

            function limitDisplay(arr) {
                arr = flatToNamesOnly(arr);
                //Display limiter
                let num = vm.media.isDeviceLessThan1426() ? 1 : 2;
                return arr.length > num ? (arr.slice(0, num).join(", ")) + " + " + (arr.length - num) + " " + utils.translate("MESSAGING.MORE") : arr.join(", ");
            }

            function flatToNamesOnly(arr) {
                return _.map(arr, function(itm) {
                    return itm.Name || itm.Value;
                });
            }

            function activateSave() {
                return vm.isBusy ? abortActivation() : activateButton();
            }

            function abortActivation() {
                return false;
            }

            function activateButton() {
                let data = angular.copy(vm.gridData).map(mapSelected);
                let collection_of_results = collectResult(data);
                return collection_of_results.some(areSomeSelected);
            }

            function collectResult(data) {
                let collection = [];
                data.forEach(function(itm) {
                    collection.push(_.some(itm, {
                        IsSelected: true
                    }));
                });
                return collection;
            }

            function mapSelected(grid) {
                return grid.DataRows.map(function(row) {
                    let res = _.find(row, {
                        HeaderKey: 'IsSelected'
                    });
                    return res && res.Value ? {
                        IsSelected: res.Value
                    } : {
                        IsSelected: false
                    };
                });
            }

            function areSomeSelected(res) {
                return res;
            }

            function setProcess(message) {
                vm.isBusy = true;
                vm.loaderMessage = message;
            }

            function stopProcess() {
                vm.isBusy = false;
                vm.loaderMessage = null;
            }

            function save() {
                setProcess(utils.translate("PAPERWORK_EXCEPTION.SAVING"));
                let selected_lines = preSaveModelFormat(angular.copy(vm.gridData));
                paperworkExceptionsApi.resolve(selected_lines).then(refresh).catch(handleError);
            }

            function refresh() {
                stopProcess();
                vm.refresh();
            }

            function handleError(ex) {
                exceptionService.resolve(ex);
                stopProcess();
            }

            function preSaveModelFormat(data) {
                let selected_lines = [];
                data.forEach(function(line) {
                    line.DataRows.forEach(function(row) {
                        let is_selected = _.find(row, {
                            HeaderKey: 'IsSelected'
                        }).Value;
                        if (is_selected) {
                            selected_lines.push(model(row));
                        }
                    });
                });
                return selected_lines;
            }

            function model(row) {
                return {
                    PrimaryId: _.find(row, {
                        HeaderKey: "PrimaryId"
                    }).Value,
                    SecondaryId: _.find(row, {
                        HeaderKey: "SecondaryId"
                    }).Value,
                    ExceptionType: _.find(row, {
                        HeaderKey: "ExceptionType"
                    }).Value,
                    ReportTypeCategory: _.find(row, {
                        HeaderKey: "ReportTypeCategory"
                    }).Value
                }
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.paperwork.exceptions.configurations', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.paperwork-exceptions-configuration', {
                url: '/paperwork-exceptions-configuration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/paperWorkConfigurationOptions/paperWorkConfigurationOptions.html'
                        , controller: 'PaperworkExceptionsConfigurationController as vm'
                    }
                },
                title:'Timesheet Warning Rules',
                titleBar:'Alloc8 - Timesheet Warning Rules',
                data : {
                    requireLogin : true,
                    validateAccess: ['adminClaimsService', function (adminClaimsService) {
                        return adminClaimsService.hasAdminOnly;
                    }]
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/paperWorkConfigurationOptions');
    }
})();

(function(){
    'use strict';

    angular.module('app.paperwork.exceptions.configurations')
        .directive('configSmallView', configSmallView);

    function configSmallView() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/paperWorkConfigurationOptions/views/Small/config-small-view.html',
            scope: {
                item : '='
            },
            controller : controller,
            controllerAs : 'vm'
        };

        return directive;

        function controller(){

        }
    }
})();

(function(){
    'use strict';

    angular.module('app.paperwork.exceptions.configurations')
        .directive('configLargeView', configLargeView);

    function configLargeView() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/paperWorkConfigurationOptions/views/Large/config-extra-large-view.html',
            scope: {
                item : '='
            },
            controller : controller,
            controllerAs : 'vm',
            bindToController : true
        };

        return directive;

        function controller(){
            var vm = this;
            vm.isRelationalField = isRelationalField;

            function isRelationalField(value){
                return (value === 1 || value === 0 || value === '1' || value === '0') ? true : false
            }
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.paperwork.exceptions.configurations')
        .directive('configExtraSmallView', configExtraSmallView);

    function configExtraSmallView() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/paperWorkConfigurationOptions/views/ExtraSmall/config-extra-small-view.html',
            scope: {
                item : '='
            },
            controller : controller,
            controllerAs : 'vm',
            bindToController : true
        };

        return directive;

        function controller(){
            var vm = this;
            vm.isRelationalField = isRelationalField;

            function isRelationalField(value){
                return (value === 1 || value === 0 || value === '1' || value === '0') ? true : false
            }
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.paperwork.exceptions.configurations')
        .directive('configSmallHeader', configSmallHeader);

    function configSmallHeader() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/paperWorkConfigurationOptions/headers/Small/config-small-header.html',
            scope: {}
        };

        return directive;
    }
})();

(function(){
    'use strict';

    angular.module('app.paperwork.exceptions.configurations')
        .directive('configLargeHeader', configLargeHeader);

    function configLargeHeader() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/paperWorkConfigurationOptions/headers/Large/config-large-header.html',
            scope: {
                length : '='
            },
            controller : function(){},
            controllerAs : 'vm',
            bindToController : true
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular.module('app.paperwork.manage-paperwork', [])
        .config(config)
        .run(runConfig);

    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.manage_paperwork', {
            url: '/paperwork/manage',
            views: {
                'content@app': {
                    templateUrl: 'app/main/paperwork/manage-paperwork/manage-paperwork.html',
                    controller: 'ManagePaperworkController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['jobsClaimsService', function(jobsClaimsService) {
                    return jobsClaimsService.hasManagePaperworkMenu;
                }]
            },
            title: 'Manage Paperwork',
            titleBar: 'Alloc8 - Manage Paperwork'
        })

        $translatePartialLoaderProvider.addPart('app/main/paperwork');
    }

    function runConfig(managePaperworkService) {
        managePaperworkService.register();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.paperwork.manage-paperwork')
        .controller('DownloadPaperworkDialogController', DownloadPaperworkDialogController);

    function DownloadPaperworkDialogController($mdDialog,
        blockUI,
        contactService,
        identityService,
        ticketsApi,
        ticketIds,
        currentRequestToken) {

        var vm = this;
        // Data
        vm.zipSize = 5;

        // Events
        vm.close = close;
        vm.sendEmail = sendEmail;

        vm.downloadInProgress = false;

        activate();

        function activate() {
            blockUI.start({
                message: 'Loading......'
            });

            if (identityService.isAuthenticated()) {
                identityService.fetchUserData()
                    .then(loadUserData);
            }
        }

        function loadUserData(resp) {
            contactService.getContactDetails(resp.ContactId).then(function(resp) {
                blockUI.stop();
                var email = alasql('select * from ? where IsPrimary = ?', [resp.data.Emails, true]);
                vm.email = email[0].EmailAddress;
            });
        }

        function close() {
            $mdDialog.hide(null);
        }

        function sendEmail() {
            var zipSize = (vm.zipSize * 1024) * 1024;

            vm.downloadInProgress = true;

            var payload = {
                TicketIds: ticketIds,
                ZipSize: zipSize, // 5242880
                Email: vm.email,
                RequestToken: currentRequestToken
            };

            ticketsApi.downloadPaperwork(payload);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.contact', [
            'app.contact.create',
            'app.contact.view',
            'app.api',
            'app.corelib',
            'app.widgets',
            'app.shared.models',
            'purplefox.numeric',
            'app.contact.calendar',
            'app.contact.calendarEntry'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config(msNavigationServiceProvider) {}

    /** @ngInject */
    function runConfig(msNavigationService) {

        // Navigation
        msNavigationService.saveItem('apps.contact', {
            title: 'Contacts',
            icon: 'icon-account-multiple',
            weight: 2,
            stateParam: {
                id: 'Test'
            }
        });

        msNavigationService.saveItem('apps.contact.view', {
            title: 'View Contacts',
            state: 'app.contact_view',
            weight: 1
        });

        msNavigationService.saveItem('apps.contact.create', {
            title: 'Create New Contact',
            state: 'app.contact_create',
            weight: 3
        });

        msNavigationService.saveItem('apps.contact.calendarEntry', {
            title: 'Calendar Entry',
            state: 'app.calendar_entry.add',  // Default to add tab
            weight: 5
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.contact')
        .factory('profileService', profileService);

    /** @ngInject */
    function profileService(
        blockUI,
        contactService,
        $mdToast,
        identityService,
        $rootScope
    ) {
        var service = {
            updateProfile: updateProfile,
        };

        return service;

        function updateProfile(profileData) {
            var data = profileData;
            blockUI.start({
                message: 'Saving....'
            });
            contactService.updateProfile(profileData).then(function(resp) {
                identityService.userData.map({
                    PhotoUrl: data.ImageUrl,
                    FullName: data.FirstName + " " + data.LastName
                });
                if (resp.data.success) {
                    $rootScope.$emit("LoadToolbarUserData", {});
                    $rootScope.$emit("identityService:invokeRefreshAccount", {});
                }
                blockUI.stop();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Profile successfully updated.')
                    .position('bottom right')
                    .hideDelay(3000)
                )
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.contact')
        .factory('passwordService', contactService);

    /** @ngInject */
    function contactService(
        blockUI,
        ToastService,
        passwordApi,
        passwordDataModel,
        identityService
    ) {
        var service = {
            updatePassword: updatePassword,
            passwordData: new passwordDataModel()
        };

        return service;

        function updatePassword() {
            var passwordModel = service.passwordData;
            passwordModel.Id = identityService.userData.UserId;

            blockUI.start('Changing Password.');

            return passwordApi.updatePassword(passwordModel).then(function(resp) {
                resetPasswordFields();
                blockUI.stop();
            }).catch(function(error) {
                blockUI.stop();
                ToastService.toast(error.data.ModelState[""][0], 5000)
            });
        }

        function resetPasswordFields() {
            service.passwordData.Id = null;
            service.passwordData.OldPassword = null;
            service.passwordData.NewPassword = null;
            service.passwordData.ConfirmPassword = null;
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.widgets')
    .service('profileDataModel', profileDataModel);

  /** @ngInject */
  function profileDataModel() {
    return function () {
      var self = this
        , defaults = {
          id: null
        , Branches: []
        , SelectedBranches: []
        , CommunicationMethod: null
        , Companies: []
        , PersonalSkills: []
        , ContactTitle: null
        , ContactTypes: []
        , DateOfBirth: null
        , Emails: []
        , Addresses: []
        , FirstName: ''
        , ImageUrl: ''
        , IsInActive: false
        , IsArchived: ''
        , LastName: ''
        , MiddleName: ''
        , Phones: []
        , Numbers: []
        , Position: ''
        , CustomFields : []
        , ContactsPreferences : []
        , Email: ''
        , Mobile: ''
        , ContactType2: []
        , Branches2: []
        , FullAddress: ''
      };

      self.map = mapper;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend({}, defaults, mapValue);

        self.Emails = opts.Emails;
        self.Phones = opts.Phones;
        self.id = opts.id;
        self.DateOfBirth = opts.DateOfBirth;
        self.Position = opts.Position;
        self.IsActive = opts.IsActive;
        self.FullName = opts.FullName;
        self.IsArchived = opts.IsArchived;
        self.IsActive = opts.IsActive;
        self.ContactTitle = opts.ContactTitle;
        self.Addresses = opts.Addresses;
        self.Companies = opts.Companies;
        self.Branches = opts.Branches;
        self.CommunicationMethod = opts.CommunicationMethod;
        self.ContactTypes = opts.ContactTypes;
        self.SidebarPageHistory = opts.SidebarPageHistory;
        self.CreatedDate = opts.CreatedDate;
        self.UpdatedDate = opts.UpdatedDate;
        self.PhotoUrl = opts.PhotoUrl;
        self.ImageUrl = opts.ImageUrl;
        self.ContactId = opts.ContactId;
        self.UserId = opts.UserId;
        self.Username = opts.Username;
        self.ContactId = opts.ContactId;
        self.FirstName = opts.FirstName;
        self.MiddleName = opts.MiddleName;
        self.LastName = opts.LastName;
        self.Email = getPrimary(opts.Emails, "Email");
        self.Phone = getPrimary(opts.Phones, "Phone");
      }

      //Get Primary Email
      function getPrimary(obj, key){
        var result = null;
        if(obj != null){
          if(obj.length != 0){
            if(key == "Email"){
              var result = alasql('select EmailAddress from ? where IsPrimary = ?', [obj, true]);
              if(result.length > 0){
                result = result[0].EmailAddress;
              }
            }
            else
            {
              var result = alasql('select Number from ? where IsPrimary = ?', [obj, true]);
              if(result.length > 0){
                result = result[0].Number;
              }
            }
          }
        }

        return result;
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.widgets')
        .service('passwordDataModel', passwordDataModel);

    /** @ngInject */
    function passwordDataModel() {
        return function () {
            var self = this
                , defaults = {
                  Id : null
                , OldPassword : null
                , NewPassword : null
                , ConfirmPassword : null
            };

            self.map = mapper;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                    , opts = angular.extend({}, defaults, mapValue);
                self.Id = opts.UserID;
                self.OldPassword = opts.OldPassword;
                self.NewPassword = opts.NewPassword;
                self.ConfirmPassword = opts.ConfirmPassword;
            }
            
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-unhandled', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-unhandled', {
            url      : '/pages/errors/error-unhandled/:code',
            views    : {
                'main@' : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-unhandled': {
                    templateUrl: 'app/main/pages/errors/unhandled/error-unhandled.html',
                    controller : 'ErrorUnhandledController as vm'
                }
            },
            // data: {
            //    code: '' 
            // },
            bodyClass: 'error-unhandled'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/unhandled');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors.error-unhandled', {
        //     title : 'Unhandled Error',
        //     state : 'app.pages_errors_error-unhandled',
        //     weight: 2
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-unhandled')
        .controller('ErrorUnhandledController', ErrorUnhandledController);

    /** @ngInject */
    function ErrorUnhandledController($state)
    {
        var vm = this;
        
        // Data
        vm.code = $state.params.code;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors.error-500', {
        //     title : '500',
        //     state : 'app.pages_errors_error-500',
        //     weight: 2
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors', {
        //     title : 'Errors',
        //     icon  : 'icon-alert',
        //     weight: 3
        // });

        // msNavigationServiceProvider.saveItem('pages.errors.error-404', {
        //     title : '404',
        //     state : 'app.pages_errors_error-404',
        //     weight: 1
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-403', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-403', {
            url      : '/pages/errors/error-403',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-403': {
                    templateUrl: 'app/main/pages/errors/403/error-403.html',
                    controller : 'Error403Controller as vm'
                }
            },
            bodyClass: 'error-403'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/403');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors.error-403', {
        //     title : '403',
        //     state : 'app.pages_errors_error-403',
        //     weight: 2
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-403')
        .controller('Error403Controller', Error403Controller);

    /** @ngInject */
    function Error403Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function () {
  'use strict';

  angular
    .module('app.pages.auth.update-password', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.pages_auth_update-password', {
      url: '/update-password',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.pages_auth_update-password': {
          templateUrl: 'app/main/pages/auth/update-password/update-password.html',
          controller: 'UpdatePasswordController as vm'
        }
      },
      title: 'Update Password Form',
      bodyClass: 'update-password'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/auth/update-password');

  }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.auth.update-password')
        .controller('UpdatePasswordController', UpdatePasswordController);

    /** @ngInject */
    function UpdatePasswordController(
        $state,
        $http,
        apiService,
        _,
        cdnUrl
    ) {
        var vm = this;

        vm.updatePasswordBg = cdnUrl + '/backgrounds/web_bg.jpg';
        vm.regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        vm.password = null;
        vm.confirmPassword = null;
        vm.email = null;
        vm.token = null;
        vm.success = false;
        vm.error = false;
        vm.error_message = "";
        vm.isMobileAppRequest = false;

        let activated = false;

        activate();

        vm.validatePassword = validatePassword;
        vm.handleUpdatePassword = handleUpdatePassword;

        function activate() {
            activated = true;
            let aboslute_url = angular.copy(window.location.href);
            let params = getUrlVars(aboslute_url);

            if (_.isNil(params.email) || _.isNil(params.token)) {
                vm.email = null;
                vm.token = null;
                if (!activated) {
                    $state.go('app.pages_auth_login-v2');
                }
            } else {
                vm.email = params.email;
                vm.token = params.token;
                vm.isMobileAppRequest = params.isMobileAppRequest;
            }
        }

        function getUrlVars(url) {
            var vars = {};
            var parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi,
                function(m, key, value) {
                    vars[key] = value;
                });
            return vars;
        }

        function validatePassword(password, confirmPassword) {
            return password === confirmPassword;
        }

        function handleUpdatePassword() {
            vm.isProcessing = 'fadeOut';
            vm.show = true;
            let payload = {
                Email: vm.email,
                PasswordToken: vm.token,
                NewPassword: vm.password
            }
            update(payload).then(successHandler).catch(errorHandler);
        }

        function successHandler() {
            vm.isProcessing = 'fadeIn';
            vm.show = false;
            vm.success = true;
            vm.error = false;
        }

        function errorHandler(err) {
            vm.isProcessing = 'fadeIn';
            vm.show = false;
            vm.success = false;
            vm.error = true;
            vm.error = true;
            angular.forEach(err.data.ModelState, function(e) {
                angular.forEach(e, function(val) {
                    vm.error_message += _.includes(val, ".") ? (val + " ") : (val + ". ");
                });
            });
        }

        function update(payload) {
            return $http.post(apiService.accounts.resetPassword, payload);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.auth.login-v2')
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller(
        clientLoginImages,
        tenantSettings,
        loginService,
        cdnUrl
    ) {
        var vm = this;

        // Data
        vm.cdnUrl = cdnUrl;
        vm.service = loginService;
        vm.copyright = (new Date()).getFullYear();
        vm.externalAuthenticator = tenantSettings.externalAuthenticator;
        vm.isAlloc8LoginSelected = false;
        vm.hasOnlyAlloc8Login = (vm.externalAuthenticator =='None' || vm.externalAuthenticator == undefined);

        // Methods
        vm.handleLogin = handleLogin;
        vm.getState = getAccessToken;
        vm.authenticate = authenticate;

        Math.seedrandom();
        vm.backgroundImage = clientLoginImages[Math.floor(Math.random() * clientLoginImages.length)];

        vm.imageLoadedEvents = {
            always: function () { },
            done: function (instance) {
                angular.element(instance.elements[0]).addClass('loaded');
                vm.loadedImage = vm.backgroundImage.url;
                vm.myClass = "hidden";
            },
            fail: function () { }
        };

        activate();

        function activate() {
            loginService.model.reset();
        }

        function handleLogin() {
            vm.service.model.isProcessing = 'fadeOut';
            vm.service.model.show = true;
            vm.service.onLogin();
        }

        function authenticate(provider) {
            vm.service.onAuthenticate(provider);
        }

        function getAccessToken(provider) {
            vm.service.getAccessToken(provider);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            title: 'Forgot Password Form',
            bodyClass: 'forgot-password',
            data: {
                shouldDisable: ['tenantSettings', function () {
                    return false;
                }]
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        //msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
        //    title : 'Forgot Password',
        //    state : 'app.pages_auth_forgot-password',
        //    weight: 5
        //});
    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(
        $http,
        apiService,
        _,
        $location,
        cdnUrl
    ) {
        var vm = this;
        vm.error_message = "";
        vm.sent = false;
        vm.error = false;
        vm.forgotPasswordBg = cdnUrl + '/backgrounds/web_bg.jpg';

        vm.handleForgotPassword = handleForgotPassword;

        function handleForgotPassword() {
            vm.isProcessing = 'fadeOut';
            vm.show = true;

            let host = $location.host();
            let tenantKey = (host.indexOf('.') < 0) ? null : host.split('.')[0];
            let webAppUrl = host.includes("localhost") ? 'http://localhost:3000/' : `https://${tenantKey}.alloc8global.com/`

            let url = constructURL(vm.form.email, webAppUrl);

            handle(url).then(function() {
                vm.isProcessing = 'fadeIn';
                vm.show = false;
                vm.sent = true;
                vm.error = false;
            }).catch(function(err) {
                vm.error_message = "";
                angular.forEach(err.data.ModelState, function(e) {
                    angular.forEach(e, function(val) {
                        vm.error_message += _.includes(val, ".") ? (val + " ") : (val + ". ");
                    });
                });
                vm.isProcessing = 'fadeIn';
                vm.show = false;
                vm.error = true;
            });
        }

        function handle(url) {
            return $http.get(url);
        }

        function constructURL(email, webAppUrl) {
            return apiService.accounts.forgotPassword + '?email=' + email + '&redirectUrl=' + webAppUrl + 'update-password';
        }
    }
})();

/**
* Message Status Component
*/
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .directive('messageStatusComponent', messageStatusComponent);

    /** @ngInject */
    function messageStatusComponent(messageStatusService) {
        var directive = {
            restrict: 'E',
            scope: {
            },
            templateUrl: 'app/main/messaging/jobMessaging/sidenav/message-status.html',
            controller: MessageStatusController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function MessageStatusController() {
            var vm = this;
            vm.states = [];

            activate();

            ///////
            function activate() {
                vm.states = messageStatusService.getMessageStatuses();
            }
        }

    }
})();
/**
 * Send Job Message Service
 *
 * Rcnet 6.26.2018
 */
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .service('sendJobMessageService', sendJobMessageService);

    /** @ngInject */
    function sendJobMessageService(
        $q,
        _,
        jobMessagingApi
    ) {

        var service = {
            sendMessage: sendMessage,
            acceptShifts: acceptShifts
        };

        activate();

        return service;
        ////////

        function activate() { }

        /**
         * Sending of multiple Emails
         * @param {*} contentApi 
         */
        function sendMessage(ariIds) {
            var deferred = $q.defer();

            jobMessagingApi.sendJobMessages(ariIds)
                            .then(function(resp) {
                                deferred.resolve(resp);
                            }).catch(function(ex) {
                                deferred.reject(ex);
                            });

            return deferred.promise;
        }

        function acceptShifts(shiftsToAccept) {
            var deferred = $q.defer();
            var payload = [];
            
            angular.forEach(shiftsToAccept, function(o) {
                payload.push({ContactId:o.contactId, AllocatedResourceItemId: o.ariId});
            },this);

            jobMessagingApi.acceptShifts(payload)
                            .then(function(resp) {
                                deferred.resolve(resp);
                            }).catch(function(ex) {
                                deferred.reject(ex);
                            });

            return deferred.promise;
        }
    }
})();
/**
 * Job messaging utils
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.messaging.job')
        .factory('jobMessagingUtilsService', jobMessagingUtilsService);

    /** @ngInject */
    function jobMessagingUtilsService(
        moment
    ) {
        var service = {
            getStartOfWeek: getStartOfWeek,
            getEndOfWeek: getEndOfWeek
        };

        activate();

        return service;
        //////

        function activate() {}

        function getStartOfWeek(startOfPeriod, fromTicketBilling) {
            let start = moment(startOfPeriod);
            let isoWeekStart = start.startOf('isoWeek');
            let lastWeek = isoWeekStart.weekday(-7);
            let result = null;
            if(fromTicketBilling){
              result = lastWeek.add(7, 'd').format('YYYY-MM-DD');
            }else{
              result = lastWeek.format('YYYY-MM-DD');
            }
            return new Date(result);
        }

        function getEndOfWeek(startOfPeriod, fromTicketBilling) {
            let start = moment(startOfPeriod);
            let isoWeekStart = start.startOf('isoWeek');
            let lastWeek = isoWeekStart.weekday(-7);
            let result = null;
            if(fromTicketBilling){
              result = lastWeek.add(13, 'd').format('YYYY-MM-DD');
            }else{
              result = lastWeek.add(6, 'd').format('YYYY-MM-DD');
            }
            return new Date(result);
        }

    }
})();
/**
 * Job Messaging Parameters
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.messaging.job')
        .factory('jobMessagingParameterService', jobMessagingParameterService);

    /** @ngInject */
    function jobMessagingParameterService(
        sideNavJobMessagingModel,
        moment
    ) {
        var service = {
            saveParams: saveParams,
            reloadParams: reloadParams,
            isPerformReload: isPerformReload
        };

        var sideNavModel = new sideNavJobMessagingModel()
        var timeStampAccess = null;

        activate();

        return service;
        //////

        function activate() { }

        function saveParams(parameters) {
            sideNavModel.map(parameters);
            sideNavModel.disableProcessingState();
            timeStampAccess = moment();
        }

        function isPerformReload() {
            if (timeStampAccess == null) {
                return false;
            } else if (moment.duration(moment().diff(timeStampAccess)).asMinutes() >= 60) {
                return false;
            } else {
                return true;
            }
        }

        function reloadParams(model) {
            //model.map(sideNavModel);
            return angular.copy(sideNavModel);
        }
    }
})();
(function() {
   'use strict'; 
   angular.module('app.corelib', []); 
})();
/**
 * SignalR service Message Listener
 *
 * Rcnet 6.26.2018
 */
(function () {
    'use strict';

    angular.module('app.corelib')
        .service('jobMessagingHubService', jobMessagingHubService);

    /** @ngInject */
    function jobMessagingHubService($mdToast,
                                    $state,
                                    signalRService,
                                    $rootScope
    ) {

        const TOASTR_DELAY = 5000;

        var service = {
            register: register
        };

        var isInitialized = false;

        return service;

        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function () {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }
        }

        function regs() {
            signalRService.messageHub.on('messagingStatusChanged', function (data) {
                $rootScope.$broadcast('urn:updateMessagingStatus', data);
            });
        }

    };
})();

/**
 * Search engine
 * by Rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.messaging.job')
        .factory('jobMessagingGridSearchService', jobMessagingGridSearchService);

    /** @ngInject */
    function jobMessagingGridSearchService(_, alasql, utils) {
        var service = {
            search: search
        };

        return service;
        ///////

        // TODO: provide search columns parameter to override extractSearchFields
        function search(collection, searchText) {
            var out = [];

            // Iterate in every search properties
            if (collection.length > 0) {

                if (!searchText || searchText == 'undefined' || searchText == 'null') {
                    return collection;
                }

                var searchKeywords = decodeURIComponent(searchText).split(" "); //(/(\s+)/);
                var tmpCollection = collection;
                var allNumeric = isAllNumericKeyword(searchKeywords);

                if (!allNumeric) {
                    searchKeywords.forEach(function(keyword) {
                        if (keyword) {
                            var sql = "select * from ?";
                            sql += keyword != null ? " where IsHeader = true or Id like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or TicketNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or CompanyName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or CompanyCode like '" + keyword + "%'" : '';
                            sql += keyword != null ? " or BranchDivision like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or StartDate like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or Names like '%" + keyword + "%'" : '';
                            //sql += keyword != null ? " or projectName like '%" + keyword + "%'" : '';
                            //sql += keyword != null ? " or relatedTicketNumber like '%" + keyword + "%'" : '';
                            var result = alasql(sql, [tmpCollection]);

                            tmpCollection = [];
                            result.forEach(function(itm) {
                                tmpCollection.push(itm);
                            });
                        }
                    });

                    tmpCollection.forEach(function(itm) {
                        out.push(itm);
                    });

                    out = _.uniqBy(out, function(o) {
                        return o.Id;
                    });
                } else {
                    // For numeric
                    searchKeywords.forEach(function(keyword) {
                        if (keyword) {
                            var sql = "select * from ?";
                            sql += keyword != null ? " where IsHeader = true or Id like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or TicketNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or CompanyName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or CompanyCode like '" + keyword + "%'" : '';
                            sql += keyword != null ? " or BranchDivision like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or StartDate like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or Names like '%" + keyword + "%'" : '';

                            var result = alasql(sql, [collection]);

                            result.forEach(function(itm) {
                                out.push(itm);
                            });
                        }
                    });
                    out = _.uniqBy(out, function(o) {
                        return o.Id;
                    });
                }
            }

            function isAllNumericKeyword(keywords) {
                var f = _.filter(keywords, function(o) {
                    return !isFinite(o);
                }).length;

                return f <= 0;
            }

            return out;
        }



        //     function search(collection, stext) {
        //         //Holy!
        //         if (collection.length <= 0 || stext == null || stext == undefined || stext == '' || stext == 'undefined') return null;

        //         let props = extractSearchFields(collection[1]);
        //         let qryPredicate = createQueryPredicate(props, stext);

        //         let results = alasql("SELECT * FROM ? WHERE IsHeader=true OR " + qryPredicate, [collection]);

        //         return results;
        //     }

        //     function createQueryPredicate(propsColl, stext) {
        //         let pred = '';
        //         angular.forEach(propsColl, function(p) {
        //             pred += p + ' LIKE "%' + stext + '%" OR ';
        //         });

        //         return pred.substring(0, pred.length - 4);
        //     }

        //     function extractSearchFields(obj) {
        //         let objSanitized = utils.objectSanitize(obj);
        //         let propsArr = [];
        //         for(var p in objSanitized) {
        //             if (!angular.isFunction(propsArr))
        //                 propsArr.push(p);
        //         }
        //         return propsArr;
        //     }
        // }


    }
})();
/**
 * Job messaging adapter service
 * Input Source for Alloc8 Grid
 *
 * Rcnet 7.2.2018
 */
(function() {
    'use strict';

    angular.module('app.messaging.job')
        .service('jobMessagingGridAdapterService', jobMessagingGridAdapterService);

    /** @ngInject */
    function jobMessagingGridAdapterService(
        a8WebApiNoChunkDataProvider,
        jobMessagingApi,
        utils,
        $q,
        messageStatusService
    ) {

        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            stopDownload: stopDownload // inbound event (called by grid client)
        };

        // Create data provider
        var dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;
        ///////

        function activate() {
            // Db hub
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData(params) {
            let dataFilters = params || getDefaultFilterParams();
            return dbSource.fetch(function() {
                let dataPromise = jobMessagingApi.getMessagingViewData(dataFilters.filters);
                return formatData(dataPromise);
            });
        }

        function formatData(deferred) {
            let resultFmtDeferred = $q.defer();

            let dataSrc = [];

            deferred.then(function(resp) {
                angular.forEach(resp.data, function(itm) {

                    if (itm.JobMessagingTickets.length > 0) {
                        // Child sequence purpose is to arrange and group the related child and parent header.
                        var formattedStartDate = moment(new Date(itm.Date)).format('YYYY-MM-DD');
                        dataSrc.push({ Id: utils.newGuid(), IsHeader: true, Title: itm.Title, StartDate: formattedStartDate, Seq: 0 }); // Create header

                        let childSeq = 1;
                        itm.JobMessagingTickets.map(function(m) {
                            var isProcessing = false;
                            var fmtStartDate = moment(new Date(m.StartDate)).format('YYYY-MM-DD');
                            var names = '';

                            m['Seq'] = childSeq;
                            m['Selected'] = false;
                            m['OrigStartDate'] = m.StartDate;
                            m['StartDate'] = fmtStartDate;
                            m.Contacts.forEach(function(o) {
                                //o['StatusColor'] = getStatusColor(o.StatusCode);
                                messageStatusService.toggleStatus(o.StatusCode, o);
                                names += o.Name + ' ';
                            });

                            m['Names'] = names;

                            // Less important
                            m['ProcessStatus'] = ''; //isProcessing ? invoiceStatusService.getSpinnerStatusMessage('queueing').desc : '';
                            m['IsProcessing'] = isProcessing;

                            dataSrc.push(m);
                            childSeq++;
                        });
                    }
                });

                resultFmtDeferred.resolve(dataSrc);
            });

            return resultFmtDeferred.promise;
        }

        // function getStatusColor(status) {
        //     return messageStatusService.getStatusByCssFormat(status);

        //     //let randomIndex = utils.random(9 - 1);
        //     // return colors[randomIndex];
        // }

        /**
         * Todo: Put this to separate service or model !!!!
         */
        function getDefaultFilterParams() {
            let filterModel = {
                Branches: [],
                Companies: [],
                StartDate: null,
                EndDate: null
            };
            return { filters: filterModel };
        }

        /**
         * it's not working yet
         * research for SignalR cancellation
         */
        function stopDownload(initiator) {
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.messaging.job')
        .service('jobMessagingGridService', jobMessagingGridService);

    /** @ngInject */
    function jobMessagingGridService(
        _,
        exceptionService,
        jobMessagingGridSearchService,
        jobMessagingGridAdapterService,
        claimsUtilService
    ) {
        var service = {
            grid: {},
            gridInfo: {
                totalItems: 0,
                rawTotalItemCount: 0,
                inProgress: false,
                isFiltered: false
            },
            contentLoading: true,
            filterData: null,
            defaultSorting: {
                sortBy: 'StartDate, Seq',
                sortDir: 'asc'
            },
            setFilterData: setFilterData,
            setClientSideFilter: setClientSideFilter,
            componentEvent: angular.noop,
            customGridSearchService: jobMessagingGridSearchService,
            isSmsEnabled: claimsUtilService.isSmsEnabled()
        };

        service.grid.api = {};
        service.grid.data = []; // View model for grid data
        service.searchText;
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;
        service.grid.onSearch = onSearch;
        service.grid.allowCustomClientSideFiltering = true;
        service.grid.onCustomClientSideFiltering = onCustomClientSideFiltering;
        service.grid.onPreloadGridInfo = onPreloadGridInfo;

        var clientSideFilter;

        activate();

        return service;

        function activate() {}

        function onInit() {
            service.grid.data.length = 0;
            service.grid.api.setHubSourceAdapter(jobMessagingGridAdapterService);
        }

        /**
         * Loading of partial data
         * Binding to Actual grid view model
         * Always fire when binding data to view model (client side searching, loading triggers this)
         * Perform view model data shaping here
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            var filterIds = getFilterIds();

            // This will speed up the loading of data, we only sanitize or strip off the excess Header Date part when we have search text supplied
            if ((!_.isEmpty(service.grid.searchText) && !_.isNil(service.grid.searchText)) || filterIds.length > 0)
                sanitizeData(data);

            angular.forEach(data, function(itm) {
                // Perform extra filtering of ARIs contact by Message Status selected
                if (!itm.IsHeader) {
                    if (filterIds.length > 0) {
                        filterByMessageStatus(itm, filterIds);
                    }

                    itm.canSendJobNotificationToAtLeastOnePerson = itm.Contacts.some(c => {
                        let canSendSms = service.isSmsEnabled && !c.HasDevices;
                        let canSendPushNotification = c.HasPushNotificationToken;
                        let hasPendingNotification = !c.isJobAccepted && !c.isJobRejected;

                        return hasPendingNotification && (canSendSms || canSendPushNotification);
                    });

                    itm.contactsThatCannotBeNotified = itm.Contacts.filter(c => {
                            let hasPendingNotification = !c.isJobAccepted && !c.isJobRejected;
                            let canSendSms = service.isSmsEnabled && !c.HasDevices;
                            let canSendPushNotification = c.HasPushNotificationToken;

                            return hasPendingNotification && (!canSendSms && !canSendPushNotification);
                        })
                        .map(x => x.Name);
                }

                itm.Selected = false;
                service.grid.data.push(itm);
            });
        }

        /**
         * This will remove the header part
         */
        function sanitizeData(data) {
            var forRemoval = [];
            // Count the number of items inside a startDate
            var resultAggregate = _.countBy(data, 'StartDate');
            // Get StartDate having 1 item
            for (var p in resultAggregate) {
                if (resultAggregate[p] <= 1)
                    forRemoval.push(p);
            }

            // Then remove it
            angular.forEach(forRemoval, function(r) {
                _.remove(data, function(o) {
                    return o.StartDate == r;
                });
            });
        }

        function filterByMessageStatus(itm, filterIds) {
            itm.Contacts = _.filter(itm.Contacts, function(c) {
                var isIncluded = _.includes(filterIds, c.StatusCode);
                return isIncluded;
            });
        }

        /**
         * Fires when grid needs to refresh data from the server (Requery)
         */
        function onDataFilter() {
            return service.filterData;
        }

        function setFilterData(filter) {
            service.filterData = filter;
        }

        function onDataLoading(extraData) {
            populateGridInfo();
            service.componentEvent({
                e: 'onGridInfoPopulated',
                data: service.gridInfo
            });
        }

        /**
         * Expose Grid info to customised external grid info
         */
        function populateGridInfo() {
            let data = service.grid.api.getGridInfo();
            service.gridInfo.totalItems = data.totalItems;
            service.gridInfo.rawTotalItemCount = data.rawTotalItemCount;
            service.gridInfo.inProgress = data.inProgress;
            service.gridInfo.isFiltered = data.isFiltered;
        }

        function onSearch(value) {
            service.componentEvent({
                e: 'onSearch'
            });
            service.grid.api.search(value);
        }

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {
            populateGridInfo();
            service.componentEvent({
                e: 'loadcompleted'
            });
            service.componentEvent({
                e: 'onGridInfoPopulated',
                data: service.gridInfo
            });
        }

        function onError(ex) {
            exceptionService.resolve(ex);
        }

        function getFilterIds() {
            var ids = [];
            if (clientSideFilter == null) return [];
            clientSideFilter.map(function(o) {
                ids.push(o.id);
            });
            return ids;
        }

        /**
         * Note: If you want to intercept and to do additional Searching via client side this is the way to go.
         * @param {*} data
         */
        function onCustomClientSideFiltering(data) {
            var filterIds = getFilterIds();

            if (clientSideFilter == null || filterIds.length <= 0) // || clientSideFilter.viewType == -1
                return data;

            // Custom logic
            var result = _.filter(data, function(itm) {
                var isIncluded = false;
                //var isIncludeRow = false;

                if (itm.Contacts) {
                    for (var i = 0; i < itm.Contacts.length; i++) {
                        isIncluded = _.includes(filterIds, itm.Contacts[i].StatusCode);
                        if (isIncluded) // If truthy then break
                            break;
                    }
                } else if (itm.IsHeader) {
                    isIncluded = true;
                }

                return isIncluded;
            });

            return result;
        }

        function setClientSideFilter(filter) {
            clientSideFilter = filter;
        }

        /**
         * Provide custom logic for counting the total items
         * @param {} data
         */
        function onPreloadGridInfo(data) {
            if (!data.items) return;

            let searchedItems = _.filter(data.items, function(o) {
                return o.IsHeader == true;
            });

            return {
                totalItems: data.totalItems - searchedItems.length,
                rawTotalItemCount: data.rawTotalItemCount > 0 ? (data.rawTotalItemCount - searchedItems.length) : data.rawTotalItemCount
            };
        }

    }
})();

/**
 * Job Messaging filter hash service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.messaging.job')
        .factory('jobMessagingFilterHasherService', jobMessagingFilterHasherService);

    /** @ngInject */
    function jobMessagingFilterHasherService(appConfigService,
        exceptionService,
        $log,
        _
    ) {

        var service = {
            hash: hash,
            IsHashEqual: IsHashEqual
        };

        activate();

        return service;
        ///////

        function activate() {}

        function hash(cfg) {
            let fieldValues;

            if (cfg) {
                fieldValues = cfg.StartDate + ',' + cfg.EndDate + ',' + getClientIdsToString(cfg.CompanyIds) + ',' + getBranchesToString(cfg.BranchIds);
                return fieldValues.hashCode();
            }
        }

        /**
         * Hash equality checker
         */
        function IsHashEqual(cfg, hashvalue) {
            let h = hash(cfg);
            return (parseInt(h) === parseInt(hashvalue));
        }

        function getClientIdsToString(clients) {
            let str = '';
            if (angular.isArray(clients)) {
                clients.map(function(itm) {
                    //str = str + "'" + itm.Id + "',";
                    str = str + "'" + itm + "',";
                });

                return str.substring(0, str.length - 1);
            }
            return '';
        }

        function getBranchesToString(branches) {
            let branchStr = '';
            if (angular.isArray(branches)) {
                branches.map(function(itm) {
                    //branchStr = branchStr + "'" + itm.Id + "',";
                    branchStr = branchStr + "'" + itm + "',";
                });

                return branchStr.substring(0, branchStr.length - 1);
            }
            return '';
        }
    }

})();
/**
 * Status checker bitwise
 *
 * Rcnet 6.26.2018
 */
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .service('jobMessageStatusService', jobMessageStatusService);

    /** @ngInject */
    function jobMessageStatusService($log,
        $q,
        exceptionService,
        utils
    ) {
        var service = {
            getOverallStatus: getOverallStatus,
            checkStatusIfProcessing: checkStatusIfProcessing,
            getSpinnerStatusMessage: getSpinnerStatusMessage
        };

        const UNSENT = 1;
        const QUEUEING = 2;
        const SENT = 4;
        const BOUNCE = 8;
        const ERROR = 16;
        const READ = 32;

        activate();

        return service;
        ////////

        function activate() { }

        /**
         * Overall Status
         *  SentSuccess = 1,
         *  Unsent = 2,
         *  Failed = 3,
         *  Skipped = 4
         * @param {*} emailRecipients 
         * @param {*} isEmailInvoice 
         */
        function getOverallStatus(emailRecipients, isEmailInvoice) {
            var andResult = null;
            emailRecipients.forEach(function (itm) {
                if (andResult == null)
                    andResult = itm.Status;
                else
                    andResult = itm.Status | andResult;
            });

            if (((andResult & BOUNCE) != 0) || (andResult & ERROR) != 0) {
                return 3;
            } else if (((andResult & UNSENT) != 0) || (andResult & QUEUEING) != 0) {
               
                return isEmailInvoice ? 2 : 4;
            } else {
                return 1;
            }
        }

        /**
         * Perform bitwise logic here (checking for queue status)
         * @param {list of recipients} emailRecipients 
         */
        function checkStatusIfProcessing(emailRecipients) {
            var andResult = null;
            emailRecipients.forEach(function (itm) {
                if (andResult == null)
                    andResult = itm.Status;
                else
                    andResult = itm.Status | andResult;
            });

            return ((andResult & QUEUEING) != 0);
        }

        function getSpinnerStatusMessage(status) {
            if (status == 'queueing') 
                 return { code: 2, desc: 'SENDING' };
            // switch (status) {
            //     case 'queueing': return { code: 2, desc: 'QUEUEING' };
            //     //case 'unsent': return {code: 1, desc: 'UNSENT'};
            //     case 'sent': return { code: 4, desc: 'SENT' };
            //     case 'bounce': return { code: 8, desc: 'BOUNCE' };
            //     case 'error': return { code: 16, desc: 'ERROR' };
            //     default: return { code: -1, desc: 'UNKNOWN' };
            // }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.messaging.job')
        .service('jobMessageSenderMainService', jobMessageSenderMainService);

    /** @ngInject */
    function jobMessageSenderMainService(
        $q,
        $timeout,
        $mdDialog,
        messageLookupService,
        jobMessagingGridService,
        sideNavJobMessagingModel,
        sendJobMessageService,
        invoiceStatusService,
        virtualRepeatFixService,
        notifierService
    ) {
        var service = {
            branchLookups: messageLookupService.data.branchLookups,
            clientLookups: messageLookupService.data.clientLookups,
            sideNavModel: new sideNavJobMessagingModel(),
            generatePreview: generatePreview,
            dataGrid: jobMessagingGridService,
            jobSenderContentApi: {},
            customGridSearchComponent: {},
            checkToggle: checkToggle,
            downloadInvoice: downloadInvoice,
            sendMessage: sendMessage,
            openIssue: openIssue,
            sort: sort,
            checkSingleItem: checkSingleItem,
            setStatusSent: setStatusSent,
            setProcessStatus: setProcessStatus,
            selectViewType: selectViewType,
            stopGridFetchingData: stopGridFetchingData
        };

        activate();

        return service;

        function activate() {
            sendJobMessageService.getInvoice = getInvoice;
            sendJobMessageService.setProcessStatusToSingleItem = setProcessStatusToSingleItem;
            sendJobMessageService.getCheckedItemsInvDist = getCheckedItems;
            sendJobMessageService.setProcessStatus = setProcessStatus;
            sendJobMessageService.removeCheckedItems = removeCheckedItems;
            sendJobMessageService.clearIssues = clearIssues;
        }

        function generatePreview() {
            virtualRepeatFixService.fixBlankSpace();
            $timeout(function() {
                service.dataGrid.grid.api.clearAll();
                service.sideNavModel.setToProcessingState('Loading Tickets...', false);
                service.jobSenderContentApi.refresh();
                service.jobSenderContentApi.setBusy(true);

                jobMessagingGridService.componentEvent = gridComponentEvent;
                service.dataGrid.setFilterData(service.sideNavModel.toBackendModel());
                service.dataGrid.grid.api.refresh();
            });
        }

        function gridComponentEvent(eventObj) {
            switch (eventObj.e) {
                case 'loadcompleted':
                    notifierService.notify({
                        command: 'clear_checkeditems'
                    });
                    service.sideNavModel.disableProcessingState();
                    service.jobSenderContentApi.setBusy(false);
                    break;
                case 'onGridInfoPopulated':
                    service.jobSenderContentApi.populateGridInfo(eventObj.data);
                    break;
                case 'onSearch':
                    service.jobSenderContentApi.refresh();
                    break;
            }
        }

        function checkToggle(toggleFlag) {
            var checkedItems = performCheckItems(service.dataGrid.grid.data, toggleFlag);
            service.jobSenderContentApi.setNumberOfCheckedItems(checkedItems.checkedItemCount);

            return checkedItems.items;
        }

        function performCheckItems(data, flag) {
            var checkedItems = [];
            data.forEach(function(o) {
                if (!o.IsHeader) {
                    o.Selected = flag;
                    if (flag) {
                        o.Contacts.forEach(function(c) {
                            checkedItems.push({
                                ticketId: o.Id,
                                ariId: c.Id
                            });
                        });
                    }
                }
            });

            return {
                items: checkedItems,
                checkedItemCount: checkedItems.length
            };
        }

        function getCheckedItems() {
            var deferredForCaller = $q.defer();
            var deferred = $q.defer();
            notifierService.notify({
                command: 'get_checkedItems',
                promise: deferred
            });

            deferred.then(function(resp) {
                deferredForCaller.resolve(resp);
            });

            return deferredForCaller.promise;
        }

        function getInvoice(id) {
            var inv = _.find(service.dataGrid.grid.data, function(o) {
                return o.Id == id;
            });

            return inv;
        }

        function removeCheckedItems() {
            service.jobSenderContentApi.refresh();
            var checkedItems = _.filter(service.dataGrid.grid.data, function(o) {
                return o.Selected === true;
            });

            checkedItems.forEach(function(o) {
                o.Selected = false;
            });
        }

        function checkSingleItem(id, checkedItems) {
            var chkItems = angular.copy(checkedItems);

            var itemToModify = _.find(service.dataGrid.grid.data, function(o) {
                return o.Id == id;
            });

            _.remove(chkItems, function(o) {
                return o.ticketId == id;
            });

            if (itemToModify.Selected) {
                itemToModify.Contacts.forEach(function(c) {
                    chkItems.push({
                        ticketId: id,
                        ariId: c.Id
                    });
                });
            }

            service.jobSenderContentApi.setNumberOfCheckedItems(chkItems.length);

            return {
                hasItemsChecked: chkItems.length > 0,
                itemsChecked: chkItems,
                itemsCheckedCount: chkItems.length
            };
        }

        function downloadInvoice() {}

        function sendMessage() {
            sendJobMessageService.updateSideNav = function(flag, msg) {
                flag ? service.sideNavModel.setToProcessingState(msg, true) : service.sideNavModel.disableProcessingState(msg);
            };

            sendJobMessageService.updateContent = function(flag) {
                service.emailSenderContentApi.setBusy(flag);
            };

            sendJobMessageService.updateEmailIssues = function(issues, message, isShowProceed) {
                service.emailSenderContentApi.setInvoiceIssue(issues);
                return showIssues(issues, message, isShowProceed);
            };

            clearIssues();
        }

        function clearIssues() {
            service.emailSenderContentApi.clearIssues();
        }

        function openIssue(issues) {
            return showIssues(issues);
        }

        function sort(sortDir) {
            service.dataGrid.grid.api.sort('StartDate ' + sortDir + ', Seq asc', null);
            notifierService.notify({
                command: 'clear_checkeditems'
            });
            service.jobSenderContentApi.refresh();
        }

        function showIssues(issues, message, isShowProceed) {
            var deferred = $q.defer();

            $mdDialog.show({
                templateUrl: 'app/main/invoice/emailSender/dialogs/issue-dialog/issue-dialog.html',
                controller: 'IssueDialogController',
                controllerAs: 'vm',
                locals: {
                    issues: issues,
                    message: message,
                    isShowProceed: isShowProceed
                },
                multiple: true
            }).then(function(resp) {
                deferred.resolve(resp);
            }, function() {
                deferred.resolve('oks!');
            });

            return deferred.promise;
        }

        function setProcessStatus(invoices, status) {
            invoices.forEach(function(invoiceItem) {
                var item = _.find(service.dataGrid.grid.data, function(o) {
                    return o.Id === invoiceItem.InvoiceId;
                });

                var statusResult = invoiceStatusService.getSpinnerStatusMessage(status);
                item.EmailRecipients.forEach(function(i) {
                    i.Status = statusResult.code;
                });
                item.ProcessStatus = statusResult.desc;
                item.IsProcessing = status == 'sent' ? false : true;
            });
        }

        function setProcessStatusToSingleItem(invoices, status) {
            var item = _.find(service.dataGrid.grid.data, function(o) {
                return o.Id === invoices[0].InvoiceId;
            });

            var statusResult = invoiceStatusService.getSpinnerStatusMessage(status);
            var recipient = _.find(item.EmailRecipients, function(o) {
                return o.Id == invoices[0].EmailRecipients[0].Id;
            });

            recipient.Status = statusResult.code;
            item.ProcessStatus = statusResult.desc;
            item.IsProcessing = status == 'sent' ? false : true;
        }

        function setStatusSent(id, overallStatus, emailId, recipientMailStatus) {

            $timeout(function() {
                service.dataGrid.grid.api.invokeUpdateState(function(o) {
                    return o.Id === id;
                }, function(items) {
                    let item = items[0];
                    if (item.EmailRecipients == null) return;

                    item.EmailRecipients.forEach(function(obj) {
                        if (obj.Id == emailId) {
                            obj.Status = recipientMailStatus;
                        }
                    });

                    if (item.EmailRecipients.length > 1) {
                        item.EmailDeliveryStatus = invoiceStatusService.getOverallStatus(item.EmailRecipients, item.EmailInvoices)
                    } else {
                        item.EmailDeliveryStatus = overallStatus;
                    }

                    if (item.EmailDeliveryStatus === 1 || item.EmailDeliveryStatus === 3) {
                        item.ProcessStatus = '';
                        item.IsProcessing = false;
                        service.emailSenderContentApi.reselectViewType();
                    }

                }, false);
            });
        }

        function selectViewType(viewType) {
            service.dataGrid.setClientSideFilter(viewType);
            service.customGridSearchComponent.forceTriggerSearch();
        }

        function stopGridFetchingData() {
            service.dataGrid.grid.api.stop();
            service.sideNavModel.reset();
            service.emailSenderContentApi.refresh();
            service.emailSenderContentApi.setBusy(false);
        }
    }
})();

/**
 * Virtual Repeat Blank Space Fix for Job Messaging
 *
 * Rcnet 10.4.2017
 */
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .service('jmVirtualRepeatFixService', jmVirtualRepeatFixService);

    /** @ngInject */
    function jmVirtualRepeatFixService() {

        var service = {
            fixBlankSpace: fixBlankSpace
        };

        activate();

        return service;
        ////////

        function activate() { }

        /**
        * A workaround to fix issue with filtering or searching which cause a blank space when the previous result was scrolled
        */
        function fixBlankSpace() {
            var container = document.getElementsByClassName('md-virtual-repeat-scroller')
            var wrappedResult = angular.element(container);
            if (wrappedResult[0] && wrappedResult[0].scrollTop != 0)
                wrappedResult[0].scrollTop = 0;
        }
    }
})();
/**
 * Message status log grid service
 *
 * Rcnet 1.26.2017
 */
(function() {
    'use strict';

    angular.module('app.messaging.job')
        .service('gridMessageStatusLogsService', gridMessageStatusLogsService);

    /** @ngInject */
    function gridMessageStatusLogsService(
        exceptionService,
        gridMessageStatusDataAdapterService) {

        var service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        activate();

        return service;

        ///////
        function activate() {}

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(gridMessageStatusDataAdapterService);
        }

        /**
         * Loading of partial data
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }

    }
})();
/**
 * Message status adapter service
 *
 * Rcnet 9.17.2018
 */
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .service('gridMessageStatusDataAdapterService', gridMessageStatusDataAdapterService);

    /** @ngInject */
    function gridMessageStatusDataAdapterService($log,
        $q,
        a8WebApiNoChunkDataProvider,
        jobMessagingApi,
        messageLogModel,
        exceptionService) {

        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData // inbound event (called by grid client)
        };

        // Create data provider
        var dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;
        ///////

        function activate() {
            // Db hub
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData(params) {
            // let dataFilters = params || getDefaultFilterParams();
            // return ceReportDbHubService.downloadInvoice(dataFilters.filters);
            return dbSource.fetch(function () {
                return getMessageLogs(params.filters);
            });
        }

        function getMessageLogs(filters) {
            let deferred = $q.defer();
            jobMessagingApi.getMessageLogs(filters)
                .then(function (resp) {
                    if (resp.data) {
                        let data = mapData(resp.data);
                        deferred.resolve(data);
                    } else {
                        resp.data = [];
                        deferred.resolve(resp.data);
                    }
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function mapData(data) {
            let mappedData = [];
            data.map(function (itm) {
                let logModel = new messageLogModel();
                mappedData.push(logModel.map(itm));
            });
            return mappedData;
        }
    }
})();
/**
 * Download Job Message Service
 *
 * Rcnet 6.25.2018
 */
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .service('downloadJobMessageService', downloadJobMessageService);

    /** @ngInject */
    function downloadJobMessageService($log,
        $q,
        exceptionService,
        jobMessagingApi,
        utils,
        $mdToast,
        $mdDialog,
        blockUI,
        $timeout
    ) {

        var service = {
            download: download,
            currentRequestToken: null,
            getCheckedItemsInvDist: angular.noop // parent callback
        };

        activate();

        return service;
        ////////

        function activate() { }

        function download() {
            $mdDialog.show({
                templateUrl: 'app/main/messaging/jobMessaging/dialogs/download/download-invoice.html',
                controller: 'DownloadJobMessageDialogController',
                controllerAs: 'vm',
                multiple: true
            }).then(function (zipSize) {
                if (zipSize == null) return;
                blockUI.start('Downloading invoices...');

                proceedDownloading(zipSize)
                    .then(function (resp) {
                        blockUI.stop();

                        $timeout(function () {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Download completed.')
                                    .position('bottom right')
                                    .hideDelay(4000)
                            );
                        }, 2000);

                    }).catch(function (ex) {
                        blockUI.stop();
                    });

            }, function (resp) {
                blockUI.stop();
            });
        }

        function proceedDownloading(zipSize) {
            var deferred = $q.defer();
            var invoices = service.getCheckedItemsInvDist(true);
            var ids = [];
            
            invoices.checkedItems.forEach(function (o) {
                ids.push(o.Id);
            });

            service.currentRequestToken = utils.newGuid();

            var payload = {
                Ids: ids,
                ZipSize: zipSize, // 5242880
                RequestToken: service.currentRequestToken
            };

            jobMessagingApi.download(payload)
                .then(function (resp) {
                    downloadPdf(resp.data);
                    deferred.resolve(resp.data);
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function downloadPdf(data) {
            var now = moment().format("YYYY-MM-DD HH.mm.ss");
            var blob = utils.b64toBlob(data, 'application/zip');
            saveAs(blob, 'invoice-' + now + '.zip')
        }
    }
})();
/**
 * Invoice cache model
 */
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .service('sideNavJobMessagingModel', sideNavJobMessagingModel)

    function sideNavJobMessagingModel(jobMessagingUtilsService, jobMessagingFilterHasherService, utils) {
        return function () {
           // var this = this,
                defaults = {
                    selectedBranches: [],
                    selectedCompanies: [],
                    startDate: jobMessagingUtilsService.getStartOfWeek(new Date()),
                    endDate: jobMessagingUtilsService.getEndOfWeek(new Date()),
                    progressMessage: null,
                    isLocked: false,
                    processingEmailDist: false,  // Fetching data for sending
                    isSending: false  // Actual sending
                };

            angular.extend(this, defaults);

            this.map = mapper;
            this.reset = reset;
            this.toBackendModel = transformToModel;
            this.getFilterHash = getFilterHash;
            this.setToProcessingState = setToProcessingState;
            this.disableProcessingState = disableProcessingState;
            this.defaultValues = defaultValues;
            this.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(this, mapValue);

                return this;
            }

            function reset() {
                this.map(null);
                this.selectedBranches.length = 0;
                this.selectedCompanies = 0;
            }

            function setToProcessingState(msg, isSending) {
                this.isLocked = true;
                this.processingEmailDist = true;
                this.isSending = isSending;
                this.progressMessage = msg;
            }

            function disableProcessingState() {
                this.isLocked = false;
                this.processingEmailDist = false;
                this.isSending = false;
                this.progressMessage = null;
            }

            function defaultValues(branchLookups, clientLookups) {
                var self = this;
                this.startDate = new Date();
                this.endDate =  moment(this.startDate).add(1, 'd');
                this.isLocked = false;
                this.selectedBranches.length = 0;
                this.selectedCompanies.length = 0;

                angular.forEach(branchLookups, function(o) {
                    self.selectedBranches.push(o);
                });

                angular.forEach(clientLookups,function(o){
                    self.selectedCompanies.push(0);
                });
            }

            function transformToModel() {
                let filterModel = {
                    BranchIds: [],
                    CompanyIds: [],
                    DivisionIds: [],
                    StartDate: null,
                    EndDate: null
                };

                var self = this;
                // Get branches with Mixed States
                if (angular.isArray(this.selectedBranches)) {
                    // Get selected state first

                    var selectedStates = _.filter(self.selectedBranches, function (o) {
                        return o.State == null && o.IsDivision == false;
                    });

                    var selBranches = _.filter(self.selectedBranches, function (o) {
                        return o.State != null && o.IsDivision == false;
                    });

                    // Get associated branches inside state
                    selectedStates.forEach(function (p) {
                        p.StateBranches.map(function (o) {
                            filterModel.BranchIds.push(o);
                        });
                    });

                    // Get branches
                    selBranches.map(function (o) {
                        filterModel.BranchIds.push(o.Id);
                    });

                    filterModel.BranchIds = _.uniq(filterModel.BranchIds);
                }

                // Get Branch Divisions
                if (angular.isArray(this.selectedBranches)) {
                    // Get selected divisions first
                    var selectedDivisions = _.filter(self.selectedBranches, function (o) {
                        return o.IsDivision == true;
                    });

                    // Get associated branches inside state
                    selectedDivisions.forEach(function (d) {
                        filterModel.DivisionIds.push(d.Id);
                    });

                    filterModel.DivisionIds = _.uniq(filterModel.DivisionIds);
                }

                if(angular.isArray(this.selectedCompanies)){
                   
                    self.selectedCompanies.forEach(function(o){
                        filterModel.CompanyIds.push(o.Id);
                    })

                    filterModel.CompanyIds = _.uniq(filterModel.CompanyIds);
                }

                filterModel.StartDate = utils.jsDateTime(this.startDate);
                filterModel.EndDate = utils.jsDateTime(this.endDate);

                return filterModel;
            }

            /**
             * Returns filter token hash
             */
            function getFilterHash() {
                let cfg = transformToModel();
                return jobMessagingFilterHasherService.hash(cfg);
            }

        }

    }
})();

/**
 * Cost Estimate data table view model
 * by rcnet
 */
(function () {
    'use strict';

    angular.module('app.messaging.job')
        .service('messageLogModel', messageLogModel)

    function messageLogModel(utils) {
        return function () {
            var self = this,
                defaults = {
                    MessageType: null,
                    Platform: null,
                    DateTimeSent: null,
                    SuccessfullySent: null,
                    Read: null
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                let mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                    self.DateTimeSent = utils.jsDateTime(self.DateTimeSent);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.messaging')
        .factory('sendMessageService', sendMessageService);

    /** @ngInject */
    function sendMessageService(_, messagingApi, exceptionService, claimsUtilService, msgboxService, blockUI, $mdDialog) {

        //The employee lookup the dialog is opened with. Only read in here - the dialog gets
        //its own copy through the Employees local - so it stays off the service surface.
        var employees = [];

        //The Quick Fill group keys. The caller that builds the groups and the directive that
        //renders the options both key off this, so the two sides cannot drift apart.
        var QUICK_FILL_GROUPS = {
            ALLOCATED: 'allocated',
            ACCEPTED: 'accepted'
        };

        var service = {
            contacts: [],
            contactNamesWithoutDevices: [],
            message: "",
            isSmsEnabled: claimsUtilService.isSmsEnabled(),
            message_chars_limit: 160,
            quickFill: {
                groups: null,
                selected: null,
                autoAddedIds: []
            },
            QUICK_FILL_GROUPS: QUICK_FILL_GROUPS,

            send: send,
            open: open,
            reset: reset,
            isSendButtonDisabled: isSendButtonDisabled,
            onAddOrRemovePerson: onAddOrRemovePerson,
            hasQuickFill: hasQuickFill,
            selectQuickFill: selectQuickFill,
            resetQuickFill: resetQuickFill
        }

        return service;

        function send() {
            var ui = blockUI.instances.get('sendMessageUI');
            ui.start("Sending ...");

            let pay_load = {
                Message: service.message,
                ContactIds: _.filter(service.contacts, function (c) {
                    if (service.isSmsEnabled) {
                        return true;
                    } else {
                        return c.HasDevices;
                    }
                }).map(function (c) {
                    return c.Id;
                })
            }

            messagingApi.send(pay_load).then(function () {
                ui.stop();
                service.reset();
                msgboxService.show("Message Sent!", "Messaging");
            }).catch(function (err) {
                ui.stop();
                exceptionService.resolve(err);
            });
        }

        function open(contacts, quickFillGroups) {
            blockUI.start('Loading Message Dialog');
            messagingApi.getEmployeesAndLabourHire().then(function (resp) {
                blockUI.stop();

                //Quick Fill resolves its groups against this array so the chips it adds are the
                //same objects md-autocomplete offers - md-chips rejects a duplicate by reference.
                employees = resp.data;
                service.quickFill.groups = quickFillGroups;

                $mdDialog.show({
                    templateUrl: 'app/main/messaging/generalMessaging/sendMessageAsService/message.html',
                    controller: 'sendMessageAsAServiceController as vm',
                    locals: {
                        Employees: resp.data,
                        Contacts: _.isNil(contacts) ? [] : contacts.map(function (c) {
                            return c.ContactId;
                        })
                    }
                }).finally(function () {
                    //Dialog-scoped state, torn down on every exit path - hide, ESC and outside
                    //click. Reassign rather than empty in place: this array is resp.data, which
                    //the dialog also holds as its Employees local.
                    employees = [];
                    service.quickFill.groups = null;
                    resetQuickFill();
                });
                if (!_.isNil(contacts)) {
                    service.contacts = contacts;
                    onAddOrRemovePerson();
                }
            }).catch(function (err) {
                blockUI.stop();
                exceptionService.resolve(err);
            });
        }

        function reset() {
            service.contacts.length = 0;
            service.contactNamesWithoutDevices.length = 0;
            service.message = "";
            resetQuickFill();
        }

        function isSendButtonDisabled() {
            return service.message.length === 0 || service.contacts.length === 0 ||
                (!service.isSmsEnabled && service.contactNamesWithoutDevices.length === service.contacts.length);
        }

        function onAddOrRemovePerson() {
            //A recipient the user takes out by hand stops being Quick Fill's to take back later.
            service.quickFill.autoAddedIds = _.filter(service.quickFill.autoAddedIds, function (contactId) {
                return _.some(service.contacts, { Id: contactId });
            });

            service.contactNamesWithoutDevices = _.map(getContactsWithoutDevices(), 'Name');
        }

        function getContactsWithoutDevices() {
            return _.filter(service.contacts, function (c) {
                return !c.HasDevices;
            });
        }

        function hasQuickFill() {
            return !_.isNil(service.quickFill.groups);
        }

        function resetQuickFill() {
            service.quickFill.selected = null;
            service.quickFill.autoAddedIds = [];
        }

        function selectQuickFill(option) {
            if (!hasQuickFill()) {
                return;
            }

            if (service.quickFill.selected === option) {
                clearQuickFill();
                return;
            }

            removeAutoAddedContacts();
            service.quickFill.autoAddedIds = addGroupToContacts(option);
            service.quickFill.selected = option;
            onAddOrRemovePerson();
        }

        function clearQuickFill() {
            removeAutoAddedContacts();
            service.quickFill.selected = null;
            onAddOrRemovePerson();
        }

        function addGroupToContacts(option) {
            let added = [];

            _.forEach(_.get(service.quickFill.groups, option, []), function (contactId) {
                //An allocated contact can be absent from the lookup - inactive, or a type the
                //lookup excludes - so skip rather than invent a recipient we cannot send to.
                let employee = _.find(employees, { Id: contactId });

                if (_.isNil(employee) || _.some(service.contacts, { Id: contactId })) {
                    return;
                }

                service.contacts.push(employee);
                added.push(contactId);
            });

            return added;
        }

        function removeAutoAddedContacts() {
            if (service.quickFill.autoAddedIds.length === 0) {
                return;
            }

            _.remove(service.contacts, function (contact) {
                return _.includes(service.quickFill.autoAddedIds, contact.Id);
            });

            service.quickFill.autoAddedIds = [];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.messaging')
        .controller('sendMessageAsAServiceController', sendMessageAsAServiceController);

    function sendMessageAsAServiceController($mdDialog, Employees, sendMessageService, Contacts) {
        var vm = this;
        vm.employees = Employees;
        vm.service = sendMessageService;
        vm.pre_selected_contacts = [];
        vm.close = close;

        function close(){
            $mdDialog.hide();
        }

        function activate(){
            vm.service.message = "";
            vm.service.resetQuickFill();
            vm.service.contacts = Contacts.length > 0 ? parse(Contacts) : []
        }

        function parse(contacts){
            return _.filter(vm.employees, function(employee) {
                return _.includes(contacts, employee.Id);
            });
        }

        activate();
    }
})();

(function () {
  'use strict';

  angular.module('app.jobs')
    .directive('tagFilter', tagFilter);

  /** @ngInject */
  function tagFilter() {

    var directive = {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/main/jobs/widget/TagFilter/tag-filter.html',
      scope: {
        label: '@',
        selectableTags: '=', // Collection of Tags to select from.
        selectedTags: '=', // Collection of Tags to output the selection to.
        filterTagIds: '=' // Collection of Tags to output the selection id to for the filter.
      },
      controller: 'TagFilterController',
      controllerAs: 'vm',
      bindToController: true
  };
    return directive;
  }
})();

(function () {
  'use strict';

  angular.module('app.jobs')
    .controller('TagFilterController', TagFilterController);

  /** @ngInject */
  function TagFilterController($q) {

    var vm = this;

    vm.selectedItem = null;
    vm.searchText = null;

    function createFilterFor(query) {
      var lowercaseQuery = query.toLowerCase();

      return function filterFn(tag) {
        return tag.Name.toLowerCase().indexOf(lowercaseQuery) === 0;
      };
    }

    vm.querySearchTag = function (query) {
      let results = query ? vm.selectableTags.filter(createFilterFor(query)) : vm.selectableTags;
      let deferred = $q.defer();
      deferred.resolve(results);
      return deferred.promise;
    };

    vm.filterSelected = function () {
      if (!_.isNil(vm.selectedItem)) {
        vm.selectedTags.push(vm.selectedItem);
        vm.selectableTags = _.filter(vm.selectableTags, (tag) => tag.Id !== vm.selectedItem.Id);
        vm.filterTagIds.push(vm.selectedItem.Id);
        vm.searchText = "";
      }
    };

    vm.removeTagFilter = function (removeTag) {
      vm.selectedTags = _.filter(vm.selectedTags, (tag) => tag.Id !== removeTag.Id);
      vm.selectableTags.push(removeTag);
      vm.filterTagIds = _.filter(vm.filterTagIds, (id) => id !== removeTag.Id);  
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.jobs')
    .directive('jobDuration', jobDuration);

  /** @ngInject */
  function jobDuration($mdDialog) {
    var directive = {
      restrict: 'E'
      , replace: true
      , template: '<input type="text" ng-click="spawnAddressDialog()" placeholder="Job Duration">'
      , link: linkFunc
      , require: 'ngModel'
      , scope: {
        ngModel: '='
      }
    };

    return directive;

    function linkFunc(scope, element, attr) {
      var controller = 'JobDurationController as vm';
      var title = "Job Duration";
      scope.spawnAddressDialog = spawnAddressDialog;

      function spawnAddressDialog() {
        $mdDialog.show({
          parent: angular.element(document.body)
          , locals: { title: title }
          , templateUrl: 'app/main/jobs/widget/JobDuration/job-duration.html'
          , controller: controller
        }).then(function(value){
          scope.ngModel = value;
        });
      }
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs')
        .controller('JobDurationController', JobDurationController);

    /** @ngInject */
    function JobDurationController(
        title,
        $mdDialog,
        utils,
        moment
    ) {
        var vm = this;
        vm.title = title;
        vm.jobDurationVisible = true;
        vm.jobEndDateVisible = false;
        vm.dateFormat = utils.setDateFormat();
        vm.minDate = new Date();

        vm.onCancel = onCancel;
        vm.showOtherOption = showOtherOption;
        vm.onDone = onDone;

        function onCancel() {
            $mdDialog.cancel();
        }

        function showOtherOption() {
            vm.jobDurationVisible = !vm.jobDurationVisible;
            vm.jobEndDateVisible = !vm.jobEndDateVisible;
            vm.title = vm.jobDurationVisible ? 'Job Duration' : 'Job End Date';
        }

        function onDone() {
            $mdDialog.hide(vm.jobDurationVisible ? vm.JobDuration : moment(vm.JobEndDate).format(vm.dateFormat));
        }
    }
})();

{
    angular.module('app.jobs')
        .service('droppedAssetComponentService', droppedAssetComponentService);

    function droppedAssetComponentService(
        jobService,
        $mdDialog,
        $timeout) {
        var service = {
            showDialog: showDialog,
            remove: remove,
            jobService: jobService,
            showChooseOptionalItemDialog: showChooseOptionalItemDialog
        }

        return service;

        function showChooseOptionalItemDialog(item, optionalItems) {
            return $mdDialog.show({
                templateUrl: 'app/main/jobs/widget/DroppedAssetComponent/OptionalItemsSelector/optional-items-dialog.html',
                controller: 'droppedAssetOptionalItemsDialogController as dialogVm',
                locals: {
                    item: item,
                    optionalItems: optionalItems
                }
            });
        }

        function showDialog(id, ngModel, ngService, toDelete, editMode) {
            var locals = {};
            if (id) {
                var toEdit = _.filter(ngModel, function(o) {
                    return o.Id == id;
                })[0];
                if (toEdit.IsDeleted) {
                    toEdit.ItemQuantity = 1;
                }
                locals.dataToEdit = toEdit;
                if (!ngService.isEditMode && !editMode) {
                    locals.dataToEdit.ItemBillingPeriod = ngService.jobModel.ItemBillingPeriod;
                }
            }
            locals.toDelete = toDelete;
            locals.editMode = editMode;
            locals.quantityOldValue = toEdit.ItemQuantity;
            $mdDialog.show({
                onComplete: function(scope, element) {
                    var qty_el = document.querySelector('input[name="qty"]');
                    if (qty_el) {
                        qty_el.focus();
                        $timeout(function() {
                            qty_el.select();
                        }, 0);
                    }
                },

                onRemoving: function() {
                    if (locals.dataToEdit && locals.dataToEdit.IsNew && !locals.dataToEdit.IsProperlyConfirmed) {
                        remove(locals.dataToEdit.Id, true);
                    }
                },

                templateUrl: 'app/main/jobs/widget/DroppedAssetComponent/DroppedAssetManage/dropped-asset-dialog.html',
                controller: 'droppedAssetDialogController as droppedAssetDialogVm',
                locals: locals
            }).then(function(result) {
                if (result) {
                    angular.forEach(ngModel, function(value) {
                        if (value.Id == result.Id) {
                            value.ItemQuantity = result.assetQty;
                            value.billingPeriod = result.billingPeriod;
                            value.IsItemBillable = result.Billable;
                            value.isBillable = result.Billable;
                            value.IsDeleted = result.toDelete || false; // NOTE: set to false since user updated it
                            value.IsNew = result.IsNew;
                            value.ItemBillingPeriod = isNaN(result.ItemBillingPeriod) ? 1 : result.ItemBillingPeriod;
                            value.BillingPeriod = isNaN(result.BillingPeriod) ? 1 : result.BillingPeriod;
                            value.UpdateTransaction = result.UpdateTransaction;
                            value.ApplyOnStartDate = result.ApplyOnStartDate;
                            value.ApplyOnEndDate = result.ApplyOnEndDate;
                        }
                    });

                    var ItemWithPrerequisite = _.find(jobService.assetsLookup, function(o) {
                        return o.ItemPrerequisites.length != 0 && o.id == result.Id;
                    });
                    if (ItemWithPrerequisite) {
                        angular.forEach(ItemWithPrerequisite.ItemPrerequisites, function(value) {
                            var item = _.find(jobService.jobModel.Resource, function(o) {
                                return o.Id == value.id;
                            });
                            if (item) {
                                item.ItemQuantity = result.assetQty * value.Quantity;
                                item.IsProperlyConfirmed = true; // Mark as true for future editting
                                item.isBillable = result.Billable;
                                // Update items that have same prerequisite
                                angular.forEach(jobService.jobModel.Resource, function(res, ii) {
                                    if (
                                        res.Id != result.Id &&
                                        res.Id != item.Id
                                    ) {
                                        var thisOtherLineItemHasItemPrerequisite = _.find(jobService.assetsLookup, function(oo, ooi) {
                                            return _.find(oo.ItemPrerequisites && oo.ItemPrerequisites.length !== 0 ? oo.ItemPrerequisites : [], {
                                                id: item.Id
                                            }) && oo.id == res.Id;
                                        });
                                        if (thisOtherLineItemHasItemPrerequisite) {
                                            item.ItemQuantity = item.ItemQuantity + (res.ItemQuantity);
                                        }
                                    }
                                });
                            }
                        });
                    }
                    if (result.toDelete) {
                        remove(result.Id);
                    }
                    if(result.assetQty < result.quantityOldValue) {
                        jobService.resourcesToRemove.push({itemId: result.Id, quantity: (result.quantityOldValue - result.assetQty)});
                    }
                }
            }, function(cancelData) {
                if (cancelData && cancelData.IsNew) {
                    remove(cancelData.Id, true);
                }
            });
        }

        function remove(id, forced) {
            var ItemWithPrerequisite = _.find(jobService.assetsLookup, function(o) {
                return o.ItemPrerequisites.length != 0 && o.id == id;
            });

            if (ItemWithPrerequisite) {
                if (ItemWithPrerequisite.ItemPrerequisites.length > 0) {
                    var ItemWithPrerequisiteQuantity = null;
                    var _itemWithPrerequisite = _.find(jobService.jobModel.Resource, function(o) {
                        return o.Id == id;
                    });

                    if (_itemWithPrerequisite.ItemQuantity) {
                        ItemWithPrerequisiteQuantity = _itemWithPrerequisite.ItemQuantity;
                    }

                    angular.forEach(ItemWithPrerequisite.ItemPrerequisites, function(value) {
                        var quantityToRemoved = ItemWithPrerequisiteQuantity * value.Quantity || 0;
                        removeItem(value.id, quantityToRemoved, forced);
                    });

                    removeItem(id, false, forced);
                }
                return false;
            }

            removeItem(id, false, forced);
        }

        function removeItem(id, qtyToRemoved, forced) {
            jobService.resourcesToRemove.push({itemId:id});

            var ItemPrerequisiteQty = null
            var _itemPrerequisite = _.find(jobService.jobModel.Resource, function(o) {
                return o.Id == id;
            });

            if (_itemPrerequisite) {
                ItemPrerequisiteQty = _itemPrerequisite.ItemQuantity;
            }

            if ((ItemPrerequisiteQty > 1 && qtyToRemoved > 0) && ItemPrerequisiteQty != qtyToRemoved) {
                angular.forEach(jobService.jobModel.Resource, function(resource) {
                    if (resource.Id === id) {
                        resource.ItemQuantity = resource.ItemQuantity - qtyToRemoved;
                    }
                });
                return;
            }

            if (forced) {
                jobService.jobModel.Resource = alasql("select * from ? where Id !=?", [jobService.jobModel.Resource, id]);
                return;
            }

            angular.forEach(jobService.jobModel.Resource, function(resource) {
                if (resource.Id === id || resource.id === id) {
                    resource.IsDeleted = true;
                }
            });
        }
    }
}

/**
 * Created by Ben Rei on 8/17/2016.
 */
// (function () {
//   'use strict';
{
    angular
        .module('app.jobs.droppedAsset')
        .controller('droppedAssetComponentController', droppedAssetComponentController);

    /** @ngInject */
    function droppedAssetComponentController (droppedAssetComponentService, claimsUtilService) {
        //
        var vm = this;
        vm.removed = remove;
        vm.edit = showDialog;
        vm.containerHeightStyle = { height: vm.ngStyleHeight };
        vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();

        function showDialog (id, editMode) {
            if (vm.ngService.jobModel && !vm.ngService.jobModel.IsLocked && !(vm.ngService.jobModel.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled) && !vm.ngService.jobModel.IsCancelled) {
                droppedAssetComponentService.showDialog(id, vm.ngModel, vm.ngService, false, editMode);
            }
        }

        function remove (id, event, IsNew) {
            event.stopPropagation();
            event.preventDefault();

            if (vm.ngService.jobModel && !IsNew && vm.ngService.jobModel.TicketType == 1 && !vm.ngService.isCloning) {
                if (!vm.ngService.jobModel.IsLocked && !(vm.ngService.jobModel.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled) && !vm.ngService.jobModel.IsCancelled) {
                    droppedAssetComponentService.showDialog(id, vm.ngModel, vm.ngService, true);
                }
            } else {
                droppedAssetComponentService.remove(id, true);

                if(!_.isNil(vm.ngService.Tickets)){
                    vm.ngService.Tickets[vm.ticketIndex].ResourceItems = droppedAssetComponentService.jobService.jobModel.Resource;
                    vm.ngService.isClonedTicketUpdated = true;
                }
            }
        }
    }

    //})();
}

/**
 * Created by Ben Rei on 8/17/2016.
 */
(function () {
  'use strict';

  angular.module('app.jobs.droppedAsset')
    .directive('droppedAssetComponent', droppedAssetComponent);

  /** @ngInject */
  function droppedAssetComponent() {
    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/widget/DroppedAssetComponent/Dropped-Asset.html'
      , scope: {
          ngModel : '=',
          ngService : '=',
          ticketIndex : '=',
          ngStyleHeight : '@',
          ngType : '@'
        }
      , controller: 'droppedAssetComponentController as droppedAssetComponentVm'
      , bindToController: true
    };

    return directive;
  }
})();

/**
 * Created by Ben Rei on 8/19/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.jobs.draggable', [])
    .run(runConfig);

  function runConfig($cacheFactory,$rootScope){
    $rootScope.kitCache = $cacheFactory('loadedKits');
    $rootScope.kitCache.removeAll();
  }
})();

(function () {
  'use strict';
  //
  angular
    .module('app.jobs.draggable')
    .controller('draggableResourceController', draggableResourceController);

    /** @ngInject */
    function draggableResourceController(resourceComponentService, $rootScope, claimsUtilService) {
      var vm = this;
      vm.service = resourceComponentService;
      vm.searchTextChange = searchTextChange;
      vm.removeClass = removeClass;
      vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();

      function removeClass(_model){
        angular.forEach(_model, function(item){
          if(item.ripple='elementToFadeInAndOut'){
            item.ripple='';
          }
        });
      }


      function searchTextChange(value) {
        // var originalKitLookup = angular.copy(vm.ngService.kitsLookup);
        // var localKitsLookUp = angular.copy(vm.ngService.kitsLookup);
        // vm.ngService.kitsLookup = [];
        //
        // if(value){
        //   var test = isMatched(localKitsLookUp, value)
        //   var test2 =  localKitsLookUp.filter(isMatched(localKitsLookUp, value));
        //   vm.ngService.kitsLookup = localKitsLookUp.filter(isMatched(localKitsLookUp, value));
        // }
        // else{
        //   vm.ngService.kitsLookup = originalKitLookup;
        // }
        // // vm.ngService.kitsLookup = vm.ngService.kitsLookup.reduce(function(value){
        // //   var index = vm.ngService.kitsLookup.indexOf(value) > -1;
        // //   return vm.ngService.kitsLookup[index];
        // // });

        vm.ngService.kitsLookup = $rootScope.kitCache.get('_kitsLookup');

        if (value) {
          var items = [];
          angular.forEach(vm.ngService.kitsLookup, function (item) {
            if (item.KitName.toLowerCase().indexOf(value) > -1) {
              items.push(item);
            }
          });
          vm.ngService.kitsLookup = items;
        }
      }

      // function isMatched (array, value) {
      //   var test = array.indexOf(value) > -1
      //   return array.KitName.indexOf(value) > -1;
      // }

      function activate()
      {
        if(vm.fetchData){
          resourceComponentService.activate(vm.branchId,vm.ticketType);
        }
      }

      activate();
    }
})();

(function () {
  'use strict';
  ///
  angular.module('app.jobs.draggable')
    .directive('draggableResourceComponent', draggableResourceComponent);
  /** @ngInject */
  function draggableResourceComponent() {
    var directive = {
      restrict: 'E'
      , replace: true
      , templateUrl: 'app/main/jobs/widget/DraggableComponent/Draggable-Resource.html'
      , scope: {
         ngModel: '=',
         ngService:'=',
         ngAuxmodel:'=',
         name: '@',
         fetchData:'=',
         branchId:'=',
         ticketType:'='
       }
      , bindToController: true
      , controller: 'draggableResourceController as draggableResourcevm'
    };

    return directive;
  }
})();

(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('whiteboardLookupService', whiteboardLookupService);

    /** @ngInject */
    function whiteboardLookupService(
        branchApi,
        stateApi,
        tagsApi,
        lookupApi) {

        var service = {
            fetchBranchLookup: fetchBranchLookup,
            fetchStatesLookup: fetchStatesLookup,
            fetchTagsLookup: fetchTagsLookup,
            ticketTypesLookup: [],
            getTicketType: getTicketType
        };

        activate();

        return service;

        function activate() {
            lookupApi.getTicketTypes().then(function(resp) {
                service.ticketTypesLookup = resp.data;
            });
        }

        function fetchBranchLookup() {
            return branchApi.getBranches();
        }

        function fetchStatesLookup() {
            return stateApi.getStates();
        }

        function fetchTagsLookup() {
            return tagsApi.getActiveTags();
        }

        function getTicketType(id) {
            return service.ticketTypesLookup.find(o => o.Id === id);
        }
    }
})();

/**
 * SignalR service
 *
 * Rcnet 6.22.2016
 */
(function () {
    'use strict';

    angular.module('app.corelib')
        .service('whiteboardHubService', whiteboardHubService);

    /** @ngInject */
    function whiteboardHubService($mdToast, $log, signalRService, $rootScope, whiteboardCacheService, ticketPdfService) {
        var service = {
            register: register
        };

        return service;

        ///////
        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function () {
                    regs();
                });
            }
        }

        function regs() {
            signalRService.messageHub.on('syncWhiteboard', function (data) {
                $log.log('Message Hub: Whiteboard synchronization triggered.');
                whiteboardCacheService.invalidateCache(data);
            });
        }

    };
})();

/**
 * Whiteboard filter service
 *
 * Rcnet 7.26.2018
 */
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .service('whiteboardFilterService', whiteboardFilterService);

    /** @ngInject */
    function whiteboardFilterService() {

        var service = {
            filter: filter
        };

        return service;

        ///////
        function filter(collection, searchText) {
            var out = [];

            // Iterate in every search properties
            if (collection.length > 0) {

                if (!searchText) {
                    return collection;
                }

                var searchKeywords = searchText.split(" "); //(/(\s+)/);
                var tmpCollection = collection;
                var allNumeric = isAllNumericKeyword(searchKeywords);

                if (!allNumeric) {
                    searchKeywords.forEach(function (keyword) {
                        if (keyword) {
                            var sql = "select * from ?";
                            sql += keyword != null ? " where BranchName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or CompanyName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or BranchState like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or TicketNumber like '" + keyword + "%'" : '';
                            sql += keyword != null ? " or JobLocationAddress like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or StartDate like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or ProjectName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or RelatedTicketNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or ParentTicketNumber like '%" + keyword + "%'" : '';
                            var result = alasql(sql, [tmpCollection]);

                            tmpCollection = [];
                            result.forEach(function (itm) {
                                tmpCollection.push(itm);
                            });
                        }
                    });

                    tmpCollection.forEach(function (itm) {
                        out.push(itm);
                    });

                    out = _.uniqBy(out, function (o) {
                        return o.id || o;
                    });
                } else {
                    // For numeric
                    searchKeywords.forEach(function (keyword) {
                        if (keyword) {
                            var sql = "select * from ?";
                            sql += keyword != null ? " where BranchName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or CompanyName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or BranchState like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or TicketNumber like '" + keyword + "%'" : '';
                            sql += keyword != null ? " or JobLocationAddress like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or StartDate like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or ProjectName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or RelatedTicketNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or ParentTicketNumber like '%" + keyword + "%'" : '';
                            var result = alasql(sql, [collection]);

                            result.forEach(function (itm) {
                                out.push(itm);
                            });
                        }
                    });
                    out = _.uniqBy(out, function (o) {
                        return o.Id || o;
                    });
                }
            }

            return out;
        }

        function isAllNumericKeyword(keywords) {
            var f = _.filter(keywords, function (o) {
                return !isFinite(o);
            }).length;

            return f <= 0;
        }

    };
})();


/**
 * Whiteboard Custom Routing
 */
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('whiteboardCustomRouteService', whiteboardCustomRouteService);

    /** @ngInject */
    function whiteboardCustomRouteService(
        $log,
        $rootScope,
        whiteboardCurrentRouteService
    ) {

        var service = {
            registerRouteLogic: registerRouteLogic
        };

        activate();

        return service;

        ///////
        function activate() { }

        function registerRouteLogic() {
            $rootScope.$on('$customRouteLogic', function (event, args) {
                if (args.toState.name == 'app.jobs_whiteboard') {
                    if (whiteboardCurrentRouteService.lastVisitedWhiteboardType == 2)
                        args.promise.resolve('app.jobs_whiteboard_eq');
                    else
                        args.promise.resolve(null);
                } else {
                    args.promise.resolve(null);
                }
            });
        }

    }
})();
/**
 * Whiteboard Custom Routing
 */
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('whiteboardCurrentRouteService', whiteboardCurrentRouteService);

    /** @ngInject */
    function whiteboardCurrentRouteService(
        $log,
        $rootScope
        ) {

        var service = {
            lastVisitedWhiteboardType: null
        };

        return service;
    }
})();
(function() {
    'use strict';

    angular.module('app.payroll', [
            'app.api',
            'app.corelib',
            'app.widgets',
            'app.shared.models',
            'app.payroll.timesheet',
            'app.payroll.update-payroll-contacts',
            'app.payroll.allowances',
            'app.payroll.payrates'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config(msNavigationServiceProvider) {};

    function runConfig(
        msNavigationService,
        claimsUtilService,
        payrollClaimsService,
        payrollTimesheetService) {

        msNavigationService.saveItem('apps.payroll', {
            title: 'Payroll',
            icon: 'icon-account-multiple',
            weight: 7,
            hidden: function() {
                return !payrollClaimsService.hasPayrollMenuAccess;
            }
        });

        msNavigationService.saveItem('apps.payroll.awards_interpreter', {
            title: 'Run Payroll',
            state: 'app.awards_interpreter',
            weight: 8,
            hidden: function() {
                return  !payrollClaimsService.hasRunPayrollAccess;
            }
        });

        msNavigationService.saveItem('apps.payroll.timesheet', {
            title: 'Timesheets',
            state: 'app.payroll_timesheet',
            weight: 10
        });

        payrollTimesheetService.registerSignalRCallback();

        msNavigationService.saveItem('apps.payroll.update_payroll_contacts', {
            title: 'Update Payroll Contacts',
            state: 'app.update_payroll_contacts',
            weight: 11,
            hidden: function() {
                return !payrollClaimsService.hasUpdatePayrollContactsAccess;
            }
        });

        msNavigationService.saveItem('apps.payroll.allowances', {
            title: 'Allowances',
            state: 'app.allowances',
            weight: 12,
            hidden: function() {
                return !payrollClaimsService.hasModifyAllowancesAccess || !claimsUtilService.isPayrollEnabled();
            }
        });

    

        msNavigationService.saveItem('apps.payroll.payrates', {
            title: 'Pay Rates',
            state: 'app.payrates',
            weight: 12,
            hidden: function() {
                return !claimsUtilService.isPayrollEnabled() || !payrollClaimsService.hasModifyPayRatesAccess;;
            }
        });
    }
})();
(function() {
    'use strict';

    angular.module('app.payroll')
        .factory('whiteboardClaimsService', whiteboardClaimsService);

    /** @ngInject */
    function whiteboardClaimsService($rootScope, $log, identityService, claimsUtilService) {
        var service = {
            disableBillingPref: false
        };

        activate();

        return service;

        function activate() {
            $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                applyClaimsRules();
            });

            applyClaimsRules();
        }

        function applyClaimsRules() {
            service.disableBillingPref = !claimsUtilService.checkAccessByRole('Ticket Billing Preferences');
        }
    }
})();

(function() {
   'use strict'; 
   angular.module('app.api', []); 
})();
(function() {
    'use strict';

    angular.module('app.api')
        .factory('whiteboardCacheService', whiteboardCacheService);

    /** @ngInject */
    function whiteboardCacheService(
        $q,
        $rootScope,
        utils,
        jobsWhiteboardApi2,
        dataCacheService2,
        dateNavigationService) {

        var cacheObj = dataCacheService2.getInstance();

        const MAX_CACHE_ITEMS = 2;
        const WEEK_VIEW_PAGE_SIZE = 5000;
        const DAY_VIEW_PAGE_SIZE = 5000;

        var service = {
            getTicketsPerWeek: getTicketsPerWeek,
            getTicketsPerDay: getTicketsPerDay,
            deleteCacheItems: deleteCacheItems,
            updateTicketsPerWeekCache: updateTicketsPerWeekCache,
            getTicketsPerMonth: getTicketsPerMonth,
            isValidFilter: isValidFilter,
            getStatus: getStatus,
            getStatusByArray: getStatusByArray,
            invalidateCache: invalidateCache
        };

        activate();

        return service;

        function activate() {
            cacheObj.group('whiteboardData', {
                capacity: MAX_CACHE_ITEMS,
                maxAge: 25 * 1000,
                deleteOnExpire: 'aggressive'
            });
        }

        function checkValidFilter(cacheName, filter) {
            let cacheData = cacheObj.getCache(cacheName);

            if (!cacheData) {
                return false;
            }

            if (cacheData) {
                return (filter.filterHash === cacheData.filterHash);
            }

            return true;
        }

        function isValidFilter(cacheName, type, filter, wboardType) {
            let urnPrefix = wboardType == 1 ? 'urn:whiteboardData' : 'urn:whiteboardData:eq';
            let urn = type === 'weekview' ? urnPrefix + ':weekview:' :
                type === 'dayview' ? urnPrefix + ':dayview:' :
                type === 'monthview' ? urnPrefix + ':monthview:' :
                '-notfound-';

            let key = generateCacheKey(cacheName);
            return checkValidFilter(urn + key, filter);
        }

        function getTicketsPerWeek(name, start, end, filter, pageToken, pageNo, destroyCache, requery, wboardType) {
            var key = generateCacheKey(name);
            var promiseObj;
            var weekViewCacheKey = (wboardType == 1 ? 'urn:whiteboardData:weekview:' : 'urn:whiteboardData:eq:weekview:') + key;

            if (!destroyCache) {
                let validFilter = checkValidFilter(weekViewCacheKey, filter);
                destroyCache = !validFilter;
            }

            if (destroyCache) {
                cacheObj.remove(weekViewCacheKey);
            }

            if (requery) {
                let deferred = $q.defer();

                if (filter.allowGroupByClient) {
                    jobsWhiteboardApi2.getTicketsPerWeekGroupByClient(start, end, filter, WEEK_VIEW_PAGE_SIZE, pageToken, pageNo, wboardType, filter.WhiteboardTimeOfShift)
                        .then(function(resp) {
                            deferred.resolve({
                                data: resp,
                                filterHash: filter.filterHash
                            });
                        });
                } else {
                    jobsWhiteboardApi2.getTicketsPerWeek(start, end, filter, WEEK_VIEW_PAGE_SIZE, pageToken, pageNo, wboardType, filter.WhiteboardTimeOfShift)
                        .then(function(resp) {
                            deferred.resolve({
                                data: resp,
                                filterHash: filter.filterHash
                            });
                        })
                        .catch(function(ex) {
                            deferred.reject(ex);
                        });
                }

                return deferred.promise;

            } else {
                promiseObj = cacheObj
                    .load(weekViewCacheKey, function() {
                        let deferred = $q.defer();

                        if (filter.allowGroupByClient) {
                            jobsWhiteboardApi2.getTicketsPerWeekGroupByClient(start, end, filter, WEEK_VIEW_PAGE_SIZE, pageToken, pageNo, wboardType, filter.WhiteboardTimeOfShift)
                                .then(function(resp) {
                                    deferred.resolve({
                                        data: resp,
                                        filterHash: filter.filterHash
                                    });
                                });
                        } else {
                            jobsWhiteboardApi2.getTicketsPerWeek(start, end, filter, WEEK_VIEW_PAGE_SIZE, pageToken, pageNo, wboardType, filter.WhiteboardTimeOfShift)
                                .then(function(resp) {
                                    deferred.resolve({
                                        data: resp,
                                        filterHash: filter.filterHash
                                    });
                                })
                                .catch(function(ex) {
                                    deferred.reject(ex);
                                });
                        }

                        return deferred.promise;
                    });

                return promiseObj;
            }
        }

        function getTicketsPerDay(name, start, filter, pageToken, destroyCache, requery, pageNo, wboardType) {
            let key = generateCacheKey(name);
            let promiseObj;
            let dayViewCacheKey = (wboardType == 1 ? 'urn:whiteboardData:dayview:' : 'urn:whiteboardData:eq:dayview:') + key;

            if (!destroyCache) {
                let validFilter = checkValidFilter(dayViewCacheKey, filter);
                destroyCache = !validFilter;
            } else {
                cacheObj.remove(dayViewCacheKey);
            }

            if (requery) {
                let deferred = $q.defer();

                if (filter.allowGroupByClient) {
                    jobsWhiteboardApi2.getTicketsPerDayGroupByClient(start, filter, DAY_VIEW_PAGE_SIZE, pageToken, pageNo, wboardType, filter.WhiteboardTimeOfShift)
                        .then(function(resp) {
                            deferred.resolve({
                                data: resp.data,
                                filterHash: filter.filterHash
                            });
                        })
                        .catch(function(ex) {
                            deferred.reject(ex);
                        });
                } else {
                    jobsWhiteboardApi2.getTicketsPerDay(start, filter, DAY_VIEW_PAGE_SIZE, pageToken, pageNo, wboardType, filter.WhiteboardTimeOfShift)
                        .then(function(resp) {
                            deferred.resolve({
                                data: resp.data,
                                filterHash: filter.filterHash
                            });
                        })
                        .catch(function(ex) {
                            deferred.reject(ex);
                        });
                }

                return deferred.promise;
            } else {
                promiseObj = cacheObj
                    .load(dayViewCacheKey, function() {
                        let deferred = $q.defer();

                        if (filter.allowGroupByClient) {
                            jobsWhiteboardApi2.getTicketsPerDayGroupByClient(start, filter, DAY_VIEW_PAGE_SIZE, pageToken, pageNo, wboardType, filter.WhiteboardTimeOfShift)
                                .then(function(resp) {
                                    deferred.resolve({
                                        data: resp.data,
                                        filterHash: filter.filterHash
                                    });
                                })
                                .catch(function(ex) {
                                    deferred.reject(ex);
                                });
                        } else {
                            jobsWhiteboardApi2.getTicketsPerDay(start, filter, DAY_VIEW_PAGE_SIZE, pageToken, pageNo, wboardType, filter.WhiteboardTimeOfShift)
                                .then(function(resp) {
                                    deferred.resolve({
                                        data: resp.data,
                                        filterHash: filter.filterHash
                                    });
                                })
                                .catch(function(ex) {
                                    deferred.reject(ex);
                                });
                        }

                        return deferred.promise;
                    });

                return promiseObj;
            }
        }

        function getTicketsPerMonth(name, start, end, filter, destroyCache, requery, wboardType) {
            let deferred = $q.defer();

            var isoDateStart = utils.jsDateTime2(start, 'MMM DD YYYY');
            var isoDatEnd = utils.jsDateTime2(end, 'MMM DD YYYY');

            jobsWhiteboardApi2.getTicketsPerMonth(isoDateStart, isoDatEnd, filter, wboardType)
                .then(function(resp) {
                    deferred.resolve({
                        data: resp.data,
                        filterHash: filter.filterHash
                    });
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function updateTicketsPerWeekCache(name, wboardType, dataSrc) {
            var cacheRootKey = (wboardType == 1 ? 'urn:whiteboardData:weekview:' : 'urn:whiteboardData:eq:weekview:');
            var key = generateCacheKey(name),
                cacheData = cacheObj.getCache(cacheRootKey + key),
                dayOfWeekIndex = 0;

            angular.forEach(cacheData.data.lists, function(cacheItem) {
                var currentRec = dataSrc.data.lists[dayOfWeekIndex];

                angular.forEach(currentRec.idCards, function(itm) {
                    cacheItem.idCards.push(itm);
                }, this);

                ++dayOfWeekIndex;
            }, this);
        }

        function generateCacheKey(name) {
            return name.replace(/\s/g, '');
        }

        function deleteCacheItems() {
            cacheObj.removeAll();
        }

        function getStatus(id) {
            return jobsWhiteboardApi2.getStatusInfo(id);
        }

        function getStatusByArray(arr) {
            return jobsWhiteboardApi2.getStatusInfoByArray(arr);
        }

        function invalidateCache(datesToInvalidate) {
            var screenRefresh = false;

            angular.forEach(datesToInvalidate.DatesToSync, function(itm) {
                let momentDate = moment(itm, 'DD/MM/YYYY');
                let startDate = momentDate.weekday(0)
                    .format('MMM') + momentDate.weekday(0)
                    .format('DD');
                let endDt = angular.copy(momentDate)
                    .weekday(6);
                let endDateTmp = _.padStart(endDt.format('DD')
                    .toString(), 2, '0');
                let endDate = endDt.format('MMM') + endDateTmp;

                let weekCacheKey = startDate + '-' + endDate + ',' + momentDate.weekday(0)
                    .format('YYYY');
                cacheObj.remove('urn:whiteboardData:weekview:' + weekCacheKey);
                cacheObj.remove('urn:whiteboardData:eq:weekview' + weekCacheKey);

                let dt = moment(itm, 'DD/MM/YYYY');
                let dayCacheKey = dt.format('dddd')
                    .toUpperCase() + ' ' + dt.format('MM') + ' ' + dt.format('DD') + ' ' + dt.format('YYYY');
                cacheObj.remove('urn:whiteboardData:dayview:' + generateCacheKey(dayCacheKey));
                cacheObj.remove('urn:whiteboardData:eq:dayview:' + generateCacheKey(dayCacheKey));

                let monthDate = moment(new Date(itm));
                let monthCacheKey = generateCacheKey(monthDate.format('MMM') + ' ' + monthDate.format('YYYY'));
                cacheObj.remove('urn:whiteboardData:monthview:' + monthCacheKey);
                cacheObj.remove('urn:whiteboardData:eq:monthview:' + monthCacheKey);

                if ($rootScope.state.current.name === 'app.jobs_whiteboard' && screenRefresh == false) {
                    let dtInRange = false;

                    if (dateNavigationService.isWeekly) {
                        let startDt = dateNavigationService.getCurrentStartWeek()
                            .format('DD/MM/YYYY');
                        let endDt = dateNavigationService.getCurrentEndWeek()
                            .format('DD/MM/YYYY');
                        dtInRange = dateInRange(momentDate.format('DD/MM/YYYY'),
                            startDt,
                            endDt);
                    } else if (dateNavigationService.isDaily) {
                        let startDt = dateNavigationService.data.format('DD/MM/YYYY');
                        if (itm === startDt) {
                            dtInRange = true;
                        }
                    } else if (dateNavigationService.isMonthly) {
                        let baseDt = dateNavigationService.data;
                        let startDt = new Date(baseDt.year(), baseDt.month(), 1);
                        let endDt = getLastDayOfMonth(baseDt);
                        dtInRange = dateInRange(monthDate.format('DD/MM/YYYY'),
                            startDt,
                            endDt);
                    }

                    if (dtInRange) {
                        screenRefresh = true;
                    }
                }
            });

            if (screenRefresh) {
                $rootScope.$broadcast('wboard:jobBoardMain:refreshActiveScreen');
            }
        }

        function dateInRange(d, start, end) {
            return (
                isFinite(d = convert(d)
                    .valueOf()) &&
                isFinite(start = convert(start)
                    .valueOf()) &&
                isFinite(end = convert(end)
                    .valueOf()) ?
                start <= d && d <= end :
                NaN
            );
        }

        function getLastDayOfMonth(dt) {
            return new Date(dt.year(), dt.month() + 1, 0, 23, 59, 59);
        }

        function convert(d) {
            return (
                d.constructor === Date ? d :
                d.constructor === Array ? new Date(d[0], d[1], d[2]) :
                d.constructor === Number ? new Date(d) :
                d.constructor === String ? new Date(d) :
                typeof d === "object" ? new Date(d.year, d.month, d.date) :
                NaN
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .factory('whiteboardResizeService', whiteboardResizeService);

    /** @ngInject */
    function whiteboardResizeService($timeout) {
        var service = {
            setDefaultContentSizeForDayView: setDefaultContentSizeForDayView,
            adjustContentSizeForDayView: adjustContentSizeForDayView,
            adjustElementTicketHeaderSize: adjustElementTicketHeaderSize,
        };

        activate();

        return service;
        ///////

        function activate() { }


        function adjustContentSizeForDayView() {
            $timeout(function () {
                var boardEl = angular.element('#dailyboard');
                var boardElHeight = boardEl.height();

                var result = document.getElementsByClassName('ticket-container');
                var wrappedResult = angular.element(result);

                angular.forEach(wrappedResult, function (elem) {
                    $(elem).css("min-height", boardElHeight + 'px');
                }, this);

                // TODO: CHKMEM!!!
            });
        }

        function setDefaultContentSizeForDayView() {
            $timeout(function () {
                
                var boardEl = angular.element('#dailyboard');
                var boardElHeight = boardEl.height();
                var boardElWidth = boardEl.width();

                var cardContainerElem = angular.element('#day-view-cards-container');
                $(cardContainerElem).css('height', (boardElHeight-70) + 'px');

                var dayViewVirtualContainerElem = angular.element('#dayview-vertical-container');
                $(dayViewVirtualContainerElem).css('height', (boardElHeight-90) + 'px');


                // var result = document.getElementsByClassName('ticket-container');
                // var wrappedResult = angular.element(result);

                // angular.forEach(wrappedResult, function (elem) {
                //     $(elem).css("min-height", '100px');
                // }, this);

            });
        }

         /**
         * Adjust ticket container height
         * For Week View and Day view
         */
        function adjustElementTicketHeaderSize() {
            $timeout(function () {

                // var wbEl = angular.element('#board');
                // var wbElHeight = wbEl.height();

                // var boardEl = angular.element('#board');
                // $(boardEl).css('min-height', wbElHeight + 'px');

                //var boardElHeight = boardEl.height();

                // Adjust columns per week
                var result = document.getElementsByClassName('ticket-container');
                var wrappedResult = angular.element(result);

                angular.forEach(wrappedResult, function (elem) {
                    $(elem).css("min-height", '100%'); //boardElHeight + 'px');
                }, this);

                // Adjust virtual scroll container
                var computedHeightVirtualRepeat = angular.element(wrappedResult[0]).height();
                var verticalContainerElem = angular.element('#vertical-container');
                $(verticalContainerElem).css("height", (computedHeightVirtualRepeat-80) + 'px'); //221

                //var dropzone = document.getElementsByClassName('ticket-dropzone');
                // React element DropZoneArea-dropping
                // var dropzone = document.getElementsByClassName('DropZoneArea-dropping');
                // var dropzoneResult = angular.element(dropzone);
                // angular.forEach(dropzoneResult, function (elem) {
                //     $(elem).css("min-height", (boardElHeight - 100) + 'px');
                // }, this);

            });
        }
    }
})();



(function() {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .factory('weekViewService', weekViewService);

    /** @ngInject */
    function weekViewService(
        _,
        ticketItemModel,
        utils,
        jobBoardWeeklyService,
        whiteboardCacheService,
        CardFilters,
        alasql,
        $q,
        localisationService,
        moment
    ) {
        var service = {
            settings: {
                bgcolor: 'bg-whiteboard2'
            },
            loadWeeklyData: loadWeeklyData,
            applyWeekFilter: applyWeekFilter,
            convertToVirtualRepeatModel: convertToVirtualRepeatModel,
            getEmptyVirtualRepeatModel: getEmptyVirtualRepeatModel,
            loadWeeklyRawData: loadWeeklyRawData
        };

        var localeSettings = {};

        activate();

        return service;

        function activate() {
            localeSettings = localisationService.getLocaleFormatSettings();
        }

        function loadWeeklyData(options, wboardType) {
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                weekDateText: '',
                invokedBy: null
            }, opts);

            let isRerenderUI = true;
            if (options.destroyCache && options.invokedBy === 'filter')
                isRerenderUI = !whiteboardCacheService.isValidFilter(settings.weekDateText, 'weekview', CardFilters.getFilterOptions(), service.whiteboardType);

            if (!isRerenderUI) {
                return $q.when('suppress ui rendering');
            }

            var weeklyData = new ticketItemModel();
            let ticketHeaders = jobBoardWeeklyService.prepareTicketListHeader(settings.momentDate);

            angular.forEach(ticketHeaders, function(o) {
                weeklyData.lists.push(o);
            }, this);

            var start = utils.jsDateTime(weeklyData.lists[0].headerDate, 'MM/DD/YYYY');
            var end = utils.jsDateTime(weeklyData.lists[6].headerDate, 'MM/DD/YYYY');

            return enrichData(start,
                end,
                settings.destroyCache,
                settings.weekDateText,
                null,
                0,
                true,
                wboardType);
        }

        function loadWeeklyRawData(options, wboardType) {
            let deferred = $q.defer();
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                weekDateText: '',
                invokedBy: null
            }, opts);

            let isRerenderUI = true;
            if (options.destroyCache && options.invokedBy === 'filter')
                isRerenderUI = !whiteboardCacheService.isValidFilter(settings.weekDateText, 'weekview', CardFilters.getFilterOptions(), service.whiteboardType);

            if (!isRerenderUI) {
                return $q.when('suppress ui rendering');
            }

            var weeklyData = new ticketItemModel();
            let ticketHeaders = jobBoardWeeklyService.prepareTicketListHeader(settings.momentDate);

            angular.forEach(ticketHeaders, function(o) {
                weeklyData.lists.push(o);
            }, this);

            var start = utils.jsDateTime(weeklyData.lists[0].headerDate, 'MM/DD/YYYY');
            var end = utils.jsDateTime(weeklyData.lists[6].headerDate, 'MM/DD/YYYY');

            let ticketPromise = whiteboardCacheService.getTicketsPerWeek(settings.weekDateText,
                start,
                end,
                CardFilters.getFilterOptions(),
                null,
                0,
                settings.destroyCache,
                true,
                wboardType
            );

            ticketPromise.then(function(resp) {
                deferred.resolve(resp.data.data.m_Item1);
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function applyWeekFilter(momentDate, weekDateText, wboardType, skipMappingToVirtualRepeatModel) {
            if (!skipMappingToVirtualRepeatModel)
                return loadWeeklyData({
                    momentDate: momentDate,
                    destroyCache: true,
                    weekDateText: weekDateText,
                    invokedBy: 'filter'
                }, wboardType);
            else
                return loadWeeklyRawData({
                    momentDate: momentDate,
                    destroyCache: true,
                    weekDateText: weekDateText,
                    invokedBy: 'filter'
                }, wboardType);
        }

        function enrichData(start, end, destroyCache, weekDateText, pageToken, pageNo, requery, wboardType) {
            let deferred = $q.defer();

            let ticketPromise = whiteboardCacheService.getTicketsPerWeek(weekDateText,
                start,
                end,
                CardFilters.getFilterOptions(),
                pageToken,
                pageNo,
                destroyCache,
                requery,
                wboardType
            );

            ticketPromise.then(function(resp) {
                if (utils.isUndefinedOrNull(resp.data)) {
                    deferred.resolve({
                        data: null,
                        count: 0
                    });
                    return;
                }

                let weeklyData = buildWeeklyRawData(resp.data.data.m_Item1, start, CardFilters.allowGroupByClient)
                let headerDates = constructWeekHeaderDates(weeklyData);
                let weekViewSource = buildVirtualRepeatViewModel(weeklyData);

                deferred.resolve({
                    headerDates: headerDates,
                    data: weekViewSource,
                    rawData: resp.data.data.m_Item1,
                    count: resp.data.data.m_Item1.length
                });

            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function constructWeekHeaderDates(weeklyData) {
            var headerDates = [];

            for (var i = 0; i < weeklyData.lists.length; i++) {
                headerDates.push({
                    "name": weeklyData.lists[i].name,
                    "headerDate": weeklyData.lists[i].headerDate
                });
            }

            return headerDates;
        }

        function buildWeeklyRawData(dataSrc, startDate, isGroupByClient) {

            let weeklyData = new ticketItemModel();
            let ticketHeadrs = jobBoardWeeklyService.prepareTicketListHeader(moment(new Date(startDate)));
            angular.forEach(ticketHeadrs, function(o) {
                weeklyData.lists.push(o);
            }, this);

            angular.forEach(weeklyData.lists, function(ticketHeader) {

                var results = [];
                let qry = "SELECT * FROM ? WHERE formatDate2(StartDate, 'MM/DD/YYYY') = ?";
                results = alasql(qry, [dataSrc, ticketHeader.headerDate]);

                if (isGroupByClient) {
                    angular.forEach(results, function(itm) {
                        if (results.length > 0) {
                            let ticketCard = {
                                id: utils.newGuid(),
                                name: itm.CompanyName,
                                companyCode: itm.CompanyId,
                                ticketCount: itm.TicketCount,
                                hasPeople: itm.ContainsEquipment,
                                hasEquipment: itm.ContainsPeople,
                                status: whiteboardCacheService.getStatusByArray(itm.StatusList),
                                IsUnconfirmedDate: itm.IsUnconfirmedDate,
                                IsLocked: itm.IsLocked,
                                IsLockedByPreSchedule: itm.IsLockedByPreSchedule,
                                startDate: itm.StartDate,
                                endDate: itm.EndDate
                            };

                            ticketHeader.idCards.push(ticketCard);
                        }
                    });
                } else {
                    angular.forEach(results, function(itm2) {
                        if (results.length > 0) {
                            var statInfo = whiteboardCacheService.getStatusByArray(itm2.StatusList);

                            let ticketCard = {
                                id: itm2.Id,
                                ticketNo: itm2.TicketNumber,
                                relatedNumber: itm2.ParentTicketNumber != null ? itm2.ParentTicketNumber : itm2.RelatedTicketNumber != null ? itm2.RelatedTicketNumber : null,
                                parentTicketId: itm2.ParentTicketId,
                                parentTicketNumber: itm2.ParentTicketNumber,
                                relatedTicketId: itm2.RelatedTicketId,
                                relatedTicketNumber: itm2.RelatedTicketNumber,
                                ticketCount: itm2.TicketCount,
                                name: itm2.CompanyName,
                                companyCode: itm2.CompanyId,
                                jobAddress: itm2.JobLocationAddress,
                                jobLocationAddress: itm2.JobLocationAddressObject,
                                projectId: itm2.ProjectId,
                                projectName: itm2.ProjectName,
                                startDate: formatDateDDMMYYYYwithTime(itm2.StartDate),
                                endDate: formatDateDDMMYYYY(itm2.EndDate),
                                branch: itm2.BranchName,
                                hasPeople: true,
                                hasEquipment: itm2.ContainsEquipment,
                                state: itm2.BranchState,
                                status: statInfo,
                                IsUnconfirmedDate: itm2.IsUnconfirmedDate,
                                IsLocked: itm2.IsLocked,
                                IsLockedByPreSchedule: itm2.IsLockedByPreSchedule,
                                showShiftAllocationIcon: !itm2.AllShiftsConfirmed,
                                showEquipmentAllocationIcon: !itm2.AllEquipmentsAssigned,
                                showRequireAllocationIcon: !itm2.AllResourcesAllocated,
                                ticketType: itm2.TicketType,
                                IsDayShift: itm2.IsDayShift,
                                sortOrder: statInfo[0].sortOrder,
                                hasGeneratedPaperworkPdf: itm2.HasGeneratedPaperworkPdf,
                                isEmailSent: itm2.IsEmailSent,
                                etag: itm2.Etag ? JSON.parse(itm2.Etag) : null,
                                isRequiredAttachmentsCompleted: itm2.IsRequiredAttachmentsCompleted,
                                hasRequiredAttachments: itm2.HasRequiredAttachments
                            };

                            ticketHeader.idCards.push(ticketCard);
                        }
                    });

                    let sortedList = alasql('SELECT * FROM ? ORDER BY sortOrder, startTime  asc', [ticketHeader.idCards]);
                    ticketHeader.idCards = [];
                    ticketHeader.idCards = sortedList;
                }
            });

            return weeklyData;
        }

        function buildVirtualRepeatViewModel(weeklyData) {
            let weeklyViewRepeatSource = [];
            let listOfLength = [];

            for (var i = 0; i < 7; i++) {
                let len = weeklyData.lists[i].idCards.length;
                listOfLength.push(len);
            }

            var maxItemCount = _.maxBy(listOfLength, function(o) {
                return o;
            });

            for (var rowCount = 0; rowCount < maxItemCount; rowCount++) {
                var row = {};

                for (var headerCount = 0; headerCount < 7; headerCount++) {
                    if (rowCount < weeklyData.lists[headerCount].idCards.length) {
                        row['day' + headerCount] = weeklyData.lists[headerCount].idCards[rowCount];
                        row['day' + headerCount]['headerDate'] = weeklyData.lists[headerCount].headerDate;
                    }
                }

                weeklyViewRepeatSource.push(row);
            }

            return weeklyViewRepeatSource;
        }

        function convertToVirtualRepeatModel(rawData, startDate) {
            let weeklyData = buildWeeklyRawData(rawData, startDate, CardFilters.allowGroupByClient)
            let headerDates = constructWeekHeaderDates(weeklyData);
            let weekViewSource = buildVirtualRepeatViewModel(weeklyData);

            return $q.when({
                headerDates: headerDates,
                data: weekViewSource,
                rawData: rawData,
                count: rawData.length
            });
        }

        function getEmptyVirtualRepeatModel() {
            return {
                headerDates: [],
                data: [],
                rawData: [],
                count: 0
            };
        }

        function formatDateDDMMYYYY(date, fmt) {
            var format = fmt || 'YYYY-MM-DD';
            return moment(date, format).format(localeSettings.displayDateFormat);
        }

        function formatDateDDMMYYYYwithTime(date, fmt) {
            var timeformat = localeSettings.timeFormat2;
            var format = fmt || 'YYYY-MM-DD ' + timeformat;

            return moment(date, format).format(localeSettings.displayDateFormat + ' ' + timeformat);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('ticketPdfService', ticketPdfService);

    /** @ngInject */
    function ticketPdfService(identityService,
                              blockUI,
                              $q,
                              utils,
                              $timeout,
                              msgboxService,
                              jobsWhiteboardApi2,
                              signalRService,
                              exceptionService) {
        var service = {
            getTicketPDF: getTicketPDF,
            getPaperworkPDF: getPaperworkPDF,
            getTimesheetPDF: getTimesheetPDF,
            downloadPaperwork: downloadPaperwork
        };

        identityService.userDataCallback(init);
        return service;

        function init() {
            $timeout(function () {
            signalRService.isConnected ? registerDownloadPaperCallback() : createConnection();
            }, 3000);
        }

        function createConnection() {
            signalRService.connect();
            registerDownloadPaperCallback();
        }

        function registerDownloadPaperCallback() {
            signalRService.messageHub.on('downloadPaperworkCallback', function (resp) {
                $timeout(function () {
                    if(!!resp.Success) {
                        downloadPaperwork(resp, utils.newGuid());
                    }
                    else {
                        exceptionService.resolve("Failed to download file.");
                    }
                }, 1000);
            });
        }

        function getTicketPDF(id, ticketNo) {
            var deferred = $q.defer();
            blockUI.start('Creating Ticket PDF, please wait...');
            angular.element('#wb-content1').attr('ticketDownload', true);

            var token = utils.newGuid();
            jobsWhiteboardApi2.downloadTicketPdf(id, ticketNo, token)
                .then(function(resp) {
                    if (!resp.data.hasCallback) {
                        downloadPaperwork(resp.data, token);
                    }

                    deferred.resolve(resp);
                    blockUI.stop();
                }).catch(function(ex) {
                    deferred.reject(ex);
                    blockUI.stop();
                });

            return deferred.promise;
        }

        function getPaperworkPDF(id, ticketNo) {
            var deferred = $q.defer();
            blockUI.start('Creating Paperwork PDF, please wait...');

            var token = utils.newGuid();
            jobsWhiteboardApi2.downloadPaperworkPdf(id, ticketNo, token)
                .then(function (resp) {
                    blockUI.stop();
                    downloadPaperwork(resp.data, token);
                    deferred.resolve(resp);
                }).catch(function (ex) {
                    deferred.reject(ex);
                    blockUI.stop();
                });

            return deferred.promise;
        }

        function getTimesheetPDF(id, ticketNo) {
            var deferred = $q.defer();
            blockUI.start('Creating Timesheet PDF, please wait...');

            var token = utils.newGuid();
            jobsWhiteboardApi2.downloadTimesheetPdf(id, ticketNo, token)
                .then(function (resp) {
                    if (!resp.data.hasCallback) {
                        downloadPaperwork(resp.data, token);
                    }

                    deferred.resolve(resp);
                    blockUI.stop();
                }).catch(function (ex) {
                    deferred.reject(ex);
                    blockUI.stop();
                });

            return deferred.promise;
        }

        function downloadPaperwork(resp, originalToken) {
            if (resp != null && resp.FileUri.length === 0) {
                msgboxService.show('Unable to download pdf. Details: ' + resp.ErrorDescription, 'Download Error');
                return;
            }

            var anchor = angular.element('<a/>');

            var filenameParts = resp.FileUri.split('/');
            var cacheInvalidationQueryString = `?time=${new Date().getTime()}`;
            var updatedUri = encodeURI(resp.FileUri) + cacheInvalidationQueryString;

            anchor.attr({
                href: updatedUri,
                target: '_blank',
                download: filenameParts[filenameParts.length - 1] //'invoice-' + now + '.pdf'
            })[0].click();        }

    }
})();

/**
 * Ticket Details Service
 */
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('ticketInfoService', ticketInfoService);

    /** @ngInject */
    function ticketInfoService($q,
        _,
        exceptionService,
        jobsWhiteboardApi2,
        ticketInfoModel,
        lookupApi) {

        var service = {
            data: new ticketInfoModel(),
            getCardTicketInformation: getCardTicketInformation,
            getHirePeriodName: getHirePeriodName,
            getBillingPeriodName: getBillingPeriodName,
            getItemTypes: getItemTypes,
            reset: reset,
            getData: getData
        };

        var hirePeriodLookups = [],
            billingPeriodLookups = [],
            itemTypeLookups = [];

        activate();

        return service;

        ///////
        function activate() {

            // Pre-load internal lookups

            // Hire periods
            lookupApi.getHirePeriod()
                .then(function(resp) {
                    hirePeriodLookups = resp.data;
                });

            // Billing period
            lookupApi.getBillingPeriod()
                .then(function(resp) {
                    billingPeriodLookups = resp.data;
                });

            // Item type lookups
            lookupApi.getItemTypes()
                .then(function(resp) {
                    itemTypeLookups = resp.data;
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function getData() {
            return angular.copy(service.data);
        }

        function getCardTicketInformation(ticketId) {
            let deferred = $q.defer();

            jobsWhiteboardApi2.getSingleTicketInformation(ticketId)
                .then(function(resp) {
                    service.data.map(resp.data);
                    service.data.id = ticketId;
                    deferred.resolve(service.data);
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function getHirePeriodName(id) {
            return hirePeriodLookups.find(function(o) {
                if (id.hasOwnProperty('id'))
                    return o.Id === o.id;
                else
                    return o.Id === id;
            });
        }

        function getBillingPeriodName(id) {
            return billingPeriodLookups.find(function(o) {
                if (id.hasOwnProperty('id'))
                    return o.Id === o.id;
                else
                    return o.Id === id;
            });
        }

        function getItemTypes(data) {
            let itemTypes = extractItemTypeObj(data);
            let items = [];
            angular.forEach(itemTypes, function(itm) {
                items.push(itm.Name);
            }, this);

            return items.join(', ');
        }

        function extractItemTypeObj(itemTypesId) {
            let items = [];
            angular.forEach(itemTypesId, function(id) {

                let itemType = _.filter(itemTypeLookups, function(o) {
                    return o.Id == id;
                })[0];

                if (itemType)
                    items.push(itemType);
            }, this);

            return items;
        }

        function reset() {
            service.data.reset();
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.corelib')
        .service('moveTicketService', moveTicketService);

    /** @ngInject */
    function moveTicketService(
        $log,
        $q,
        ticketsApi,
        allocationApi,
        utils,
        blockUI,
        allocationConflictModel) {

        var service = {
            data: new allocationConflictModel(),
            move: move
        };

        activate();

        return service;

        function activate() {}

        function move(id, targetDate, ticketNo, companyName, startTime, finishTime) {
            let deferred = $q.defer();

            let payload = {
                TicketId: id,
                StartDate: utils.jsDateTime(targetDate + ' 00:00:00'),
                EndDate: utils.jsDateTime(targetDate + ' 23:59:59'),
                OriginalStartDate: utils.jsDateTime(targetDate + ' ' + startTime),
                OriginalFinishDate: utils.jsDateTime(targetDate + ' ' + finishTime)
            };

            $log.debug(angular.toJson(payload, true));

            allocationApi.checkConflicts(payload)
                .then(function(resp) {
                    if(resp.data) {
                        blockUI.start({ message: 'Processing moved ticket...' });
                        ticketsApi.moveTicketToNewStartDate(payload.TicketId, payload.OriginalStartDate).then(function(r) {
                            blockUI.stop();
                            deferred.resolve('Ok');
                        }).catch(function(err) {
                            blockUI.stop();
                            deferred.reject(err);
                        });
                    }
                    else {
                        deferred.reject("Please unallocate all resources from this ticket before you move the job to another day.");
                    }
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .factory('monthViewService', monthViewService);

    /** @ngInject */
    function monthViewService(
        _,
        utils,
        whiteboardCacheService,
        CardFilters,
        $q,
        moment,
        jobBoardMonthlyService
    ) {
        var service = {
            settings: {
                bgcolor: 'bg-whiteboard1'
            },
            loadMonthlyData: loadMonthlyData,
            applyMonthlyFilter: applyMonthlyFilter
        };

        return service;

        function loadMonthlyData(options, wboardType) {

            let settings = angular.extend({
                momentDate: null,
                destroyCache: false
            }, options);

            // Prepare start and end month properties
            let year = settings.momentDate.year(),
                month = settings.momentDate.month() + 1;
            let monthProps = jobBoardMonthlyService.getMonthDateRange(year, month);

            return getMonthlyBoardData(null,
                monthProps,
                settings.destroyCache,
                true,
                wboardType);
        }

        function applyMonthlyFilter(momentDate, wboardType) {
            return loadMonthlyData({
                momentDate: momentDate,
                destroyCache: true,
                invokedBy: 'filter'
            }, wboardType);
        }

        function getMonthlyBoardData(cacheName, momentProps, destroyCache, requery, wboardType) {
            let deferred = $q.defer();
            let monthPromise = whiteboardCacheService.getTicketsPerMonth(cacheName,
                momentProps.start,
                momentProps.end,
                CardFilters.getFilterOptions(),
                destroyCache,
                requery,
                wboardType
            );

            monthPromise.then(function(resp) {
                let results = buildDataForMonthView(resp.data);
                let totalTickets = 0;

                angular.forEach(results, function(o) {
                    totalTickets += o.ticketCount;
                });

                deferred.resolve({
                    data: results,
                    count: totalTickets
                });
            }).catch(function(ex) {
                if (ex.status == 404) {
                    deferred.resolve({
                        data: [],
                        count: 0
                    });
                } else {
                    deferred.reject(ex);
                }
            });

            return deferred.promise;
        }

        function buildDataForMonthView(results) {
            let resultArr = [];

            if (results.length > 0) {
                angular.forEach(results, function(itm) {

                    angular.forEach(itm.Items, function(ticket) {
                        resultArr.push({
                            id: utils.newGuid(),
                            title: '[' + ticket.Count + '] ' + ticket.ItemName,
                            titleName: ticket.ItemName,
                            ticketCount: ticket.Count,
                            start: formatDateMMDDYYYY(itm.Date),
                            end: formatDateMMDDYYYY(itm.Date),
                            tickets: ticket.TicketIds
                        });
                    }, this);

                }, this);
            }

            return resultArr;
        }

        function formatDateMMDDYYYY(date) {
            return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
        }
    }
})();

/**
 * Week view service
 * rcnet
 */
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('jobBoardWeeklyService', jobBoardWeeklyService);

    /** @ngInject */
    function jobBoardWeeklyService($q,
        ticketHeaderModel,
        utils
    ) {
        var service = {
            getCurrentWeekDates: getCurrentWeekDates,
            prepareTicketListHeader: prepareTicketListHeader
        };

        activate();

        return service;

        function activate() {
        }

        function getListDays(momentDate) {
            let arr = [];
            for (var i = 0; i < 7; i++) {
                arr.push(momentDate.weekday(i).format('ddd').toUpperCase());
            }
            return arr;
        }

        function getCurrentWeekDates(momentDate) {
            let weekDatesTmpl = getListDays(momentDate);

            let weekDates = [];

            let wIndex = 0;
            // Get Week Days and also extract the relative date for each week day created.
            let relativeDate = angular.copy(momentDate).weekday(0);

            for (var i = 0; i < weekDatesTmpl.length; i++) {
                weekDates.push({
                    day: weekDatesTmpl[wIndex] + ' ' + relativeDate.format('DD'),
                    date: angular.copy(relativeDate).format('MM/DD/YYYY')
                });
                relativeDate.add('days', 1);
                wIndex++;
            }

            return weekDates;
        }

        /**
         * Creates Ticket List Header in the Whiteboard
         */
        function prepareTicketListHeader(momentDate) {
            let ticketList = [];
            let weekDates = getCurrentWeekDates(momentDate);

            angular.forEach(weekDates, function(itm) {
                var ticket = new ticketHeaderModel();
                ticket.map({
                    id: utils.newGuid(),
                    name: itm.day,
                    headerDate: itm.date
                });
                ticketList.push(ticket);
            }, this);

            return ticketList;
        }
    }
})();
/**
 * Monthly view service 
 * rcnet
 */
(function () {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('jobBoardMonthlyService', jobBoardMonthlyService);

    /** @ngInject */
    function jobBoardMonthlyService($q,
        $log,
        _,
        exceptionService,
        moment,
        jobMonthlyModel) {
        var service = {
            data: new jobMonthlyModel(),
            getMonthDateRange: getMonthDateRange,
            generateDate: generateDate,
            getFriendlyMonthName: getFriendlyMonthName
        };

        activate();

        return service;

        //////
        function activate() {
        }

        /**
         * Returns month date range
         */
        function getMonthDateRange(year, month) {
            // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
            // array is 'year', 'month', 'day', etc
            var startDate = new Date(year, month - 1, 1);
            var endDate = new Date(year, month, 0);

            //var startDate = moment([year, month]).add(-1, "month");

            // Clone the value before .endOf()
            //var endDate = moment(startDate).endOf('month');

            // just for demonstration:
            // $log.debug(startDate.toDate());
            // $log.debug(endDate.toDate());

            // make sure to call toDate() for plain JavaScript date type
            return {
                start: startDate,
                end: endDate,
                monthIndex: month, //startDate.format('MM'),
                yearIndex: year //startDate.format('YYYY')
            };
        }

        function generateDate(mIndex, day, yIndex) {
            return new Date(yIndex, (parseInt(mIndex)-1), parseInt(day));
        }

        function getFriendlyMonthName(dt) {
            return dt.format('MMM') + ' ' + dt.format('YYYY');
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('jobBoardMainService', jobBoardMainService);

    /** @ngInject */
    function jobBoardMainService(
        $q,
        $timeout,
        _,
        ticketItemModel,
        ticketItemDayViewModel,
        utils,
        jobBoardWeeklyService,
        jobBoardMonthlyService,
        whiteboardCacheService,
        CardFilters,
        localisationService,
        alasql) {

        var service = {
            weeklyViewRepeatSource: [],
            weekViewHeaderDates: [],

            monthlyData: [],
            weeklyData: new ticketItemModel(),
            dailyData: new ticketItemDayViewModel(),
            dataCount: 0,

            settings: {
                bgcolor: 'bg-whiteboard1'
            },
            loadWeeklyData: loadWeeklyData,
            loadMonthlyData: loadMonthlyData,
            loadDailyData: loadDailyData,
            applyWeekFilter: applyWeekFilter,
            applyDailyFilter: applyDailyFilter,
            applyMonthlyFilter: applyMonthlyFilter,
            lazyLoadWeekView: lazyLoadWeekView,
            lazyLoadDayView: lazyLoadDayView,
            whiteboardType: null,
            cleanup: cleanup
        };

        var localeSettings = [];

        activate();

        return service;

        function activate() {
            localeSettings = localisationService.getLocaleFormatSettings();
        }

        function cleanup() {
            service.monthlyData.length = 0;
            service.weeklyData.reset();
            service.dailyData.reset();
            cleanupWeekView();
        }

        function cleanupWeekView() {
            service.weekViewHeaderDates.length = 0;
            service.weeklyViewRepeatSource.length = 0;
        }

        function applyMonthlyFilter(momentDate) {
            return loadMonthlyData({
                momentDate: momentDate,
                destroyCache: true,
                invokedBy: 'filter'
            });
        }

        function loadMonthlyData(options) {
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false
            }, options);

            service.settings.bgcolor = 'bg-whiteboard1';

            let monthProps = jobBoardMonthlyService.getMonthDateRange(year, month);

            service.monthlyData.length = 0;

            return getMonthlyBoardData2(cacheName,
                monthProps,
                settings.destroyCache,
                false);
        }

        function getMonthlyBoardData2(cacheName, momentProps, destroyCache, requery) {
            let deferred = $q.defer();
            let promise1 = whiteboardCacheService.getTicketsPerMonth(cacheName,
                momentProps.start,
                momentProps.end,
                CardFilters.getFilterOptions(),
                destroyCache,
                requery,
                service.whiteboardType
            );

            $timeout(function() {
                promise1.then(function(resp) {

                    buildDataForMonthView3(resp.data);
                    deferred.resolve(resp);

                }).catch(function(ex) {
                    deferred.reject(ex);
                });
            }, 10);

            return deferred.promise;
        }

        function buildDataForMonthView3(results) {
            let resultArr = [];

            if (results.length > 0) {
                angular.forEach(results, function(itm) {

                    angular.forEach(itm.Items, function(ticket) {
                        resultArr.push({
                            id: utils.newGuid(),
                            title: '[' + ticket.Count + '] ' + ticket.ItemName,
                            titleName: ticket.ItemName,
                            ticketCount: ticket.Count,
                            start: formatDateMMDDYYYY(itm.Date),
                            end: formatDateMMDDYYYY(itm.Date),
                            tickets: ticket.TicketIds
                        });
                    }, this);

                }, this);
            }

            service.monthlyData.push(resultArr);
        }

        function applyWeekFilter(momentDate, weekDateText) {
            return loadWeeklyData({
                momentDate: momentDate,
                destroyCache: true,
                weekDateText: weekDateText,
                invokedBy: 'filter'
            });
        }

        function loadWeeklyData(options) {
            cleanup();

            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                weekDateText: '',
                invokedBy: null
            }, opts);

            service.settings.bgcolor = 'bg-whiteboard2';

            let isRerenderUI = true;
            if (options.destroyCache && options.invokedBy === 'filter')
                isRerenderUI = !whiteboardCacheService.isValidFilter(settings.weekDateText, 'weekview', CardFilters.getFilterOptions(), service.whiteboardType);

            if (!isRerenderUI) {
                return $q.when('suppress ui rendering');
            }

            service.weeklyData.reset();
            jobBoardWeeklyService.prepareTicketListHeader(settings.momentDate, service.weeklyData.lists);

            var start = utils.jsDateTime(service.weeklyData.lists[0].headerDate, 'MM/DD/YYYY');
            var end = utils.jsDateTime(service.weeklyData.lists[6].headerDate, 'MM/DD/YYYY');

            return getWeeklyBoardData2(start,
                end,
                settings.destroyCache,
                settings.weekDateText,
                null,
                0,
                false);
        }

        function lazyLoadWeekView(options) {
            var opts = options || {};
            var settings = angular.extend({
                destroyCache: false,
                weekDateText: '',
                requery: true
            }, opts);

            var start = utils.jsDateTime(service.weeklyData.lists[0].headerDate);
            var end = utils.jsDateTime(service.weeklyData.lists[6].headerDate);

            return getWeeklyBoardData2(start,
                end,
                settings.destroyCache,
                settings.weekDateText,
                service.weeklyData.pageToken,
                service.weeklyData.pageNo,
                settings.requery
            );
        }

        function getWeeklyBoardData2(start, end, destroyCache, weekDateText, pageToken, pageNo, requery) {
            cleanupWeekView();

            let deferred = $q.defer();

            let promise1 = whiteboardCacheService.getTicketsPerWeek(weekDateText,
                start,
                end,
                CardFilters.getFilterOptions(),
                pageToken,
                pageNo,
                destroyCache,
                requery,
                service.whiteboardType
            );

            promise1.then(function(resp) {
                if (utils.isUndefinedOrNull(resp.data)) {
                    deferred.resolve(null);
                    return;
                }

                service.dataCount = resp.data.data.m_Item1.length;
                buildWeeklyRawData(resp.data.data.m_Item1, start, CardFilters.allowGroupByClient);
                constructWeekHeaderDates();
                buildVirtualRepeatViewModel();

                deferred.resolve('Success loading data to viewmodel');

            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function constructWeekHeaderDates() {
            for (var i = 0; i < service.weeklyData.lists.length; i++) {
                service.weekViewHeaderDates.push({
                    "name": service.weeklyData.lists[i].name,
                    "headerDate": service.weeklyData.lists[i].headerDate
                });
            }
        }

        function buildVirtualRepeatViewModel() {
            let listOfLength = [];
            for (var i = 0; i < 7; i++) {
                let len = service.weeklyData.lists[i].idCards.length;
                listOfLength.push(len);
            }

            var maxItemCount = _.maxBy(listOfLength, function(o) {
                return o;
            });

            $timeout(function() {
                for (var rowCount = 0; rowCount < maxItemCount; rowCount++) {
                    var row = {};

                    for (var headerCount = 0; headerCount < 7; headerCount++) {
                        if (rowCount < service.weeklyData.lists[headerCount].idCards.length) {
                            row['day' + headerCount] = service.weeklyData.lists[headerCount].idCards[rowCount];
                            row['day' + headerCount]['headerDate'] = service.weeklyData.lists[headerCount].headerDate;
                        }
                    }

                    service.weeklyViewRepeatSource.push(row);
                }
            }, 80);
        }

        function buildWeeklyRawData(dataSrc, startDate, isGroupByClient) {
            jobBoardWeeklyService.prepareTicketListHeader(moment(new Date(startDate)), service.weeklyData.lists);

            angular.forEach(service.weeklyData.lists, function(ticketHeader) {

                var results = [];
                let qry = "SELECT * FROM ? WHERE formatDate2(StartDate, 'MM/DD/YYYY') = ?";
                results = alasql(qry, [dataSrc, ticketHeader.headerDate]);

                if (isGroupByClient) {
                    angular.forEach(results, function(itm) {
                        if (results.length > 0) {
                            let ticketCard = {
                                id: utils.newGuid(),
                                name: itm.CompanyName,
                                companyCode: itm.CompanyId,
                                ticketCount: itm.TicketCount,
                                hasPeople: itm.ContainsEquipment,
                                hasEquipment: itm.ContainsPeople,
                                status: whiteboardCacheService.getStatusByArray(itm.StatusList),
                                IsUnconfirmedDate: itm.IsUnconfirmedDate,
                                IsLocked: itm.IsLocked,
                                IsLockedByPreSchedule: itm.IsLockedByPreSchedule
                            };

                            ticketHeader.idCards.push(ticketCard);
                        }
                    });
                } else {
                    angular.forEach(results, function(itm2) {
                        if (results.length > 0) {
                            var statInfo = whiteboardCacheService.getStatusByArray(itm2.StatusList);

                            let ticketCard = {
                                id: itm2.Id,
                                ticketNo: itm2.TicketNumber,
                                relatedNumber: itm2.ParentTicketNumber != null ? itm2.ParentTicketNumber : itm2.RelatedTicketNumber != null ? itm2.RelatedTicketNumber : null,
                                parentTicketId: itm2.ParentTicketId,
                                parentTicketNumber: itm2.ParentTicketNumber,
                                relatedTicketId: itm2.RelatedTicketId,
                                relatedTicketNumber: itm2.RelatedTicketNumber,
                                ticketCount: itm2.TicketCount,
                                name: itm2.CompanyName,
                                companyCode: itm2.CompanyId,
                                jobAddress: itm2.JobLocationAddress,
                                projectId: itm2.ProjectId,
                                projectName: itm2.ProjectName,
                                startDate: formatDateDDMMYYYYwithTime(itm2.StartDate),
                                endDate: formatDateDDMMYYYY(itm2.EndDate),
                                branch: itm2.BranchName,
                                hasPeople: true,
                                hasEquipment: itm2.ContainsEquipment,
                                state: itm2.BranchState,
                                status: statInfo,
                                IsUnconfirmedDate: itm2.IsUnconfirmedDate,
                                IsLocked: itm2.IsLocked,
                                IsLockedByPreSchedule: itm2.IsLockedByPreSchedule,
                                showShiftAllocationIcon: !itm2.AllShiftsConfirmed,
                                showEquipmentAllocationIcon: !itm2.AllEquipmentsAssigned,
                                showRequireAllocationIcon: !itm2.AllResourcesAllocated,
                                isEmailSent: itm2.IsEmailSent,
                                ticketType: itm2.TicketType,
                                IsDayShift: itm2.IsDayShift,
                                sortOrder: statInfo[0].sortOrder,
                            };

                            ticketHeader.idCards.push(ticketCard);
                        }
                    });

                    let sortedList = alasql('SELECT * FROM ? ORDER BY sortOrder, startTime  asc', [ticketHeader.idCards]);
                    ticketHeader.idCards = sortedList;
                }
            });
        }


        function applyDailyFilter(momentDate) {
            return loadDailyData({
                momentDate: momentDate,
                destroyCache: true,
                invokedBy: 'filter',
                wboardType: service.whiteboardType
            });
        }

        function lazyLoadDayView(options) {
            var opts = options || {};
            var settings = angular.extend({
                destroyCache: false,
                requery: true
            }, opts);

            service.dailyData.pageNo = parseInt(service.dailyData.pageNo) + 1;

            return getDailyBoardData(utils.jsDateTime(service.dailyData.date, 'DD/MM/YYYY'),
                settings.destroyCache,
                getCacheNameForDayView(service.dailyData.date),
                service.dailyData.pageToken,
                service.dailyData.pageNo,
                settings.requery
            );
        }

        function loadDailyData(options) {
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false
            }, opts);

            service.settings.bgcolor = 'bg-whiteboard2';
            let queryDateFormat = localeSettings.displayDateFormat;
            let cacheName = getCacheNameForDayView(settings.momentDate.format(queryDateFormat));

            let isRerenderUI = true;
            if (options.destroyCache && options.invokedBy === 'filter')
                isRerenderUI = !whiteboardCacheService.isValidFilter(cacheName, 'dayview', CardFilters.getFilterOptions(), service.whiteboardType);

            if (!isRerenderUI) {
                return $q.when('suppress ui rendering');
            }

            service.dailyData.reset();
            service.dailyData.day = getDayViewDisplayName(settings.momentDate.format(queryDateFormat));
            service.dailyData.date = settings.momentDate.format(queryDateFormat);

            return getDailyBoardData(utils.jsDateTime(settings.momentDate, 'DD/MM/YYYY'),
                settings.destroyCache,
                cacheName,
                null,
                0,
                false);
        }

        function getCacheNameForDayView(date) {
            let dt = moment(date, localeSettings.displayDateFormat);
            return dt.format('dddd').toUpperCase() + ' ' + dt.format('MM') + ' ' + dt.format('DD') + ' ' + dt.format('YYYY');
        }

        function getDayViewDisplayName(date) {
            let dt = moment(date, localeSettings.displayDateFormat);
            return dt.format('dddd').toUpperCase() + ' ' + dt.format('DD');
        }

        function getDailyBoardData(start, destroyCache, name, pageToken, pageNo, requery) {
            let deferred = $q.defer();
            let promise1 = whiteboardCacheService.getTicketsPerDay(name,
                start,
                CardFilters.getFilterOptions(),
                pageToken,
                destroyCache,
                requery,
                pageNo,
                service.whiteboardType
            );

            $timeout(function() {
                promise1.then(function(resp) {
                    if (utils.isUndefinedOrNull(resp.data)) {
                        deferred.resolve(null);
                        return;
                    }

                    buildDataForDayView(resp, CardFilters.allowGroupByClient, name);
                    if (resp.data.m_Item2 !== null) {
                        deferred.resolve(resp);
                    } else {
                        deferred.resolve(null);
                    }

                }).catch(function(ex) {
                    deferred.reject(ex);
                });
            }, 10);

            return deferred.promise;
        }

        function buildDataForDayView(dataSrc, isGroupByClient, name) {
            if (isGroupByClient) {
                angular.forEach(dataSrc.data.m_Item1, function(itm) {
                    let ticketCard = {
                        id: utils.newGuid(),
                        name: itm.CompanyName,
                        companyCode: itm.CompanyId,
                        ticketCount: itm.TicketCount,
                        hasPeople: itm.ContainsPeople,
                        hasEquipment: itm.ContainsEquipment,
                        status: whiteboardCacheService.getStatusByArray(itm.StatusList),
                        IsUnconfirmedDate: itm.IsUnconfirmedDate,
                        IsLocked: itm.IsLocked,
                        IsLockedByPreSchedule: itm.IsLockedByPreSchedule
                    };

                    service.dailyData.ticketCards.push(ticketCard);
                }, this);

            } else {

                angular.forEach(dataSrc.data.m_Item1, function(itm) {
                    var statInfo = whiteboardCacheService.getStatusByArray(itm.StatusList);
                    let ticketCard = {
                        id: itm.Id,
                        ticketNo: itm.TicketNumber,
                        ticketCount: itm.TicketCount,
                        relatedNumber: itm.ParentTicketNumber != null ? itm.ParentTicketNumber : itm.RelatedTicketNumber != null ? itm.RelatedTicketNumber : null,
                        parentTicketId: itm.ParentTicketId,
                        parentTicketNumber: itm.ParentTicketNumber,
                        relatedTicketId: itm.RelatedTicketId,
                        relatedTicketNumber: itm.RelatedTicketNumber,
                        name: itm.CompanyName,
                        companyCode: itm.CompanyId,
                        jobAddress: itm.JobLocationAddress,
                        startDate: formatDateDDMMYYYYwithTime(itm.StartDate),
                        endDate: formatDateDDMMYYYY(itm.EndDate),
                        startTime: utils.jsTime(itm.StartDate),
                        endTime: utils.jsTime(itm.EndDate),
                        branch: itm.BranchName,
                        projectId: itm.ProjectId,
                        projectName: itm.ProjectName,
                        hasPeople: itm.ContainsPeople,
                        hasEquipment: itm.ContainsEquipment,
                        state: itm.BranchState,
                        status: statInfo,
                        sortOrder: statInfo[0].sortOrder,
                        tickets: [],
                        isCancelled: itm.isCancelled,
                        IsUnconfirmedDate: itm.IsUnconfirmedDate,
                        IsLocked: itm.IsLocked,
                        IsLockedByPreSchedule: itm.IsLockedByPreSchedule,
                        showShiftAllocationIcon: !itm.AllShiftsConfirmed,
                        showEquipmentAllocationIcon: !itm.AllEquipmentsAssigned,
                        showRequireAllocationIcon: !itm.AllResourcesAllocated,
                        ticketType: itm.TicketType,
                        IsDayShift: itm.IsDayShift,
                        isEmailSent: itm.IsEmailSent
                    };
                    service.dailyData.ticketCards.push(ticketCard);
                }, this);

                var sortedList = alasql('SELECT * FROM ? ORDER BY sortOrder, startTime  asc', [service.dailyData.ticketCards]);
                service.dailyData.ticketCards = sortedList;
            }

            service.dailyData.pageToken = dataSrc.data.m_Item2;
        }

        function formatDateDDMMYYYY(date, fmt) {
            var format = fmt || 'YYYY-MM-DD';
            return moment(date, format).format(localeSettings.displayDateFormat);
        }

        function formatDateDDMMYYYYwithTime(date, fmt) {
            var timeformat = localeSettings.timeFormat2;
            var format = fmt || 'YYYY-MM-DD ' + timeformat;

            return moment(date, format).format(localeSettings.displayDateFormat + ' ' + timeformat);
        }

        function formatDateMMDDYYYY(date) {
            return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .factory('inMemoryTicketService', inMemoryTicketService);

    /** @ngInject */
    function inMemoryTicketService(
        _
    ) {
        var service = {
            cancelTickets: cancelTickets
        };

        return service;
        ///////

        function cancelTickets(ticketsToCancelSource, source) {
            
            angular.forEach(ticketsToCancelSource, function (ticketToCancel) {
                // angular.forEach(source, function (n) {
                _.remove(source, function (t) {
                    return t.ticketNo === ticketToCancel;
                });
                // });
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService(
        $mdDialog,
        $document,
        blockUI,
        CardFilters,
        cardTicketDetailService,
        ticketInfoService
    ) {
        var service = {
            openCardTicketDialog: openCardTicketDialog,
            openMonthViewCardTicketDialog: openMonthViewCardTicketDialog,
            openTicketDetailDialog: openTicketDetailDialog,
            openTicketDialog: openTicketDialog
        };

        return service;

        /**
         * For Daily or Weekly
         */
        function openCardTicketDialog(ev, options) {
            options = options || {};
            var opts = angular.extend({
                ticketId: null,
                ticketCount: 0,
                tickets: [],
                type: null,
                companyCode: null,
                date: null,
                mode: null
            }, options);

            blockUI.start({
                message: 'Loading Ticket Details...'
            });

            if (opts.type === 'dayview' || opts.type === 'weekview') {
                let dialogTitle = 'Company Name';
                cardTicketDetailService.getCardTicketDetails(opts.tickets,
                        opts.ticketId,
                        CardFilters.allowGroupByClient,
                        opts.type,
                        opts.companyCode,
                        opts.date)
                    .then(function(resp) {
                        blockUI.stop();
                        displayCardTicketDialog(dialogTitle);
                    }).catch(function(ex) {
                        blockUI.stop();
                    });
            }
        }

        /**
         * For Monthly
         */
        function openMonthViewCardTicketDialog(ev, dialogParameters) {
            let dialogTitle = 'Ticket Owner';
            blockUI.start({
                message: 'Loading Ticket Details...'
            });

            cardTicketDetailService.getCardTicketDetailsForMonthly(dialogParameters.ticketCount,
                dialogParameters.tickets,
                dialogParameters.title
                //type
            ).then(function(resp) {
                blockUI.stop();
                displayCardTicketDialog(dialogTitle);
            }).catch(function(ex) {
                blockUI.stop();
            });
        }

        /**
         * Show weekview and daiyview dialog
         */
        function displayCardTicketDialog(title) {
            $mdDialog.show({
                templateUrl: 'app/main/jobs/whiteBoard/jobBoard/dialogs/cardTicketDialog/card-ticket-dialog.html',
                controller: 'CardTicketDialogController',
                controllerAs: 'vm',
                parent: $document.find('#mainBody'), //jobBoardComponent
                clickOutsideToClose: true,
                skipHide: true,
                escapeToClose: true,
                locals: {
                    title: title
                }
            }).then(function(resp) {
                if (resp && resp.action === 'view_ticket') {
                    openTicketDetailDialog(resp.ticketId, !!cardTicketDetailService.previousState);
                }
            });
        }

        /**
         * Display ticket information
         */
        function openTicketDetailDialog(ticketId, showBack, hideButtons) {
            blockUI.start({ message: 'Loading Ticket Information...' });
            ticketInfoService.getCardTicketInformation(ticketId)
                .then(function(resp) {
                    blockUI.stop();
                    displayTicketDetailDialog(showBack, hideButtons);
                }).catch(function(ex) {
                    blockUI.stop();
                });
        }

        function displayTicketDetailDialog(showBack, hideButtons) {
            $mdDialog.show({
                controllerAs: 'vm',
                controller: 'TicketDetailDialogController',
                parent: $document.find('#mainBody'),
                multiple: true,
                templateUrl: 'app/main/jobs/whiteBoard/jobBoard/dialogs/ticketDetailDialog/ticket-detail-dialog.html',
                locals: {
                    showBack: showBack,
                    hideButtons: hideButtons
                }
            }).then(function(resp) {
                if (resp && resp.action === 'back') {
                    if (!cardTicketDetailService.previousState) {
                        return;
                    }

                    if (cardTicketDetailService.previousState.type === 'monthview') {
                        openMonthViewCardTicketDialog(null, {
                            ticketCount: cardTicketDetailService.previousState.ticketCount,
                            tickets: cardTicketDetailService.previousState.tickets
                        }, 'monthview');
                    } else {
                        openCardTicketDialog(null, cardTicketDetailService.previousState);
                    }
                }
            });
        }

        /**
         * Detect if ticketCount is greater than 1 then show only ticket info dialog
         */
        function openTicketDialog(objectParam) {
            if (!objectParam) return;

            let isMonthView = objectParam.type === 'monthview';

            if (objectParam.ticketCount > 1) {
                if (isMonthView) {
                    openMonthViewCardTicketDialog(null, objectParam);
                } else {
                    openCardTicketDialog(null, objectParam);
                }
            } else {
                let ticketNo = '';
                let tickets = objectParam.tickets;
                let isArray = Array.isArray(tickets);
                let hasTickets = isArray && tickets.length > 0;
                let isGroupedByClient = CardFilters.allowGroupByClient;

                if (isMonthView) {
                    ticketNo = (hasTickets) ? objectParam.tickets[0] : null;
                } else {
                    ticketNo = (isGroupedByClient && hasTickets) ? objectParam.tickets[0] : objectParam.id;
                }

                if ((ticketNo === objectParam.id && !isGroupedByClient) || (isMonthView && tickets.length === 1) || (!isMonthView && !isGroupedByClient)) {
                    openTicketDetailDialog(ticketNo, false);
                } else {
                    openCardTicketDialog(null, objectParam);
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .factory('dayViewService', dayViewService);

    /** @ngInject */
    function dayViewService(
        _,
        utils,
        whiteboardCacheService,
        CardFilters,
        alasql,
        $q,
        localisationService,
        moment
    ) {
        var service = {
            settings: {
                bgcolor: 'bg-whiteboard2'
            },
            loadDailyViewData: loadDailyData,
            applyDayFilter: applyDayFilter,
            convertToVirtualRepeatModel: convertToVirtualRepeatModel,
            getEmptyVirtualRepeatModel: getEmptyVirtualRepeatModel,
            loadDailyRawData: loadDailyRawData
        };

        var CHUNK_SIZE = 6;
        var localeSettings = [];

        activate();

        return service;

        function activate() {
            localeSettings = localisationService.getLocaleFormatSettings();
        }

        function loadDailyData(options, wboardType) {
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                invokedBy: null,
                contentSize: 0
            }, opts);

            computeChunkSize(settings.contentSize);

            let queryDateFormat = localeSettings.displayDateFormat;
            let cacheName = getCacheNameForDayView(settings.momentDate.format(queryDateFormat));

            let isRerenderUI = true;
            if (options.destroyCache && options.invokedBy === 'filter')
                isRerenderUI = !whiteboardCacheService.isValidFilter(cacheName, 'dayview', CardFilters.getFilterOptions(), service.whiteboardType);

            if (!isRerenderUI) {
                return $q.when('suppress ui rendering');
            }

            let actualViewModel = {
                date: settings.momentDate.format(queryDateFormat),
                day: getDayViewDisplayName(settings.momentDate.format(queryDateFormat))
            };

            let start = utils.jsDateTime(settings.momentDate, 'DD/MM/YYYY');

            return enrichData(start,
                settings.destroyCache,
                cacheName,
                true,
                wboardType,
                actualViewModel
            );
        }

        function computeChunkSize(whiteboardContainerSize) {
            if (whiteboardContainerSize <= 0) return;
            CHUNK_SIZE = Math.floor(((whiteboardContainerSize - 80) / 250));
        }

        function loadDailyRawData(options, wboardType) {
            let deferred = $q.defer();
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                invokedBy: null,
                contentSize: 0
            }, opts);

            computeChunkSize(settings.contentSize);

            let queryDateFormat = localeSettings.displayDateFormat;
            let cacheName = getCacheNameForDayView(settings.momentDate.format(queryDateFormat));

            let isRerenderUI = true;
            if (options.destroyCache && options.invokedBy === 'filter') {
                isRerenderUI = !whiteboardCacheService.isValidFilter(cacheName, 'dayview', CardFilters.getFilterOptions(), service.whiteboardType);
            }

            if (!isRerenderUI) {
                return $q.when('suppress ui rendering');
            }

            let start = utils.jsDateTime(settings.momentDate, 'DD/MM/YYYY');
            let ticketPromise = whiteboardCacheService.getTicketsPerDay(cacheName,
                start,
                CardFilters.getFilterOptions(),
                null,
                false,
                true,
                0,
                wboardType
            );

            ticketPromise.then(function(resp) {
                    deferred.resolve(resp.data.m_Item1);
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function applyDayFilter(momentDate, wboardType) {
            return loadDailyRawData({
                momentDate: momentDate,
                destroyCache: true,
                invokedBy: 'filter'
            }, wboardType);
        }

        function enrichData(start, destroyCache, cacheName, requery, wboardType, actualViewModel) {
            let deferred = $q.defer();

            let ticketPromise = whiteboardCacheService.getTicketsPerDay(cacheName,
                start,
                CardFilters.getFilterOptions(),
                null,
                destroyCache,
                requery,
                0,
                wboardType
            );

            ticketPromise.then(function(resp) {

                    if (utils.isUndefinedOrNull(resp.data)) {
                        deferred.resolve({
                            data: null,
                            count: 0
                        });
                        return;
                    }

                    let dailyData = buildDailyRawData(resp.data.m_Item1, CardFilters.allowGroupByClient)
                    let dayViewSource = buildVirtualRepeatViewModel(dailyData);

                    actualViewModel['data'] = dayViewSource;
                    actualViewModel['rawData'] = resp.data.m_Item1;
                    actualViewModel['count'] = resp.data.m_Item1.length;
                    deferred.resolve(actualViewModel);

                })
                .catch(function(ex) {
                    if (ex.status == 404) {
                        actualViewModel['count'] = 0;
                        deferred.resolve(actualViewModel);
                    } else {
                        deferred.reject(ex);
                    }
                });

            return deferred.promise;
        }

        function buildDailyRawData(dataSrc, isGroupByClient) {
            let ticketCards = [];

            if (isGroupByClient) {
                angular.forEach(dataSrc, function(itm) {
                    let ticketCard = {
                        id: utils.newGuid(),
                        name: itm.CompanyName,
                        companyCode: itm.CompanyId,
                        ticketCount: itm.TicketCount,
                        hasPeople: itm.ContainsPeople,
                        hasEquipment: itm.ContainsEquipment,
                        status: whiteboardCacheService.getStatusByArray(itm.StatusList),
                        IsUnconfirmedDate: itm.IsUnconfirmedDate,
                        isEmailSent: itm.IsEmailSent,
                        IsLocked: itm.IsLocked,
                        IsLockedByPreSchedule: itm.IsLockedByPreSchedule,
                        startDate: itm.StartDate,
                        endDate: itm.EndDate
                    };

                    ticketCards.push(ticketCard);
                }, this);
            } else {
                angular.forEach(dataSrc, function(itm) {
                    
                    var statInfo = whiteboardCacheService.getStatusByArray(itm.StatusList);
                    let ticketCard = {
                        id: itm.Id,
                        ticketNo: itm.TicketNumber,
                        ticketCount: itm.TicketCount,
                        relatedNumber: itm.ParentTicketNumber != null ? itm.ParentTicketNumber : itm.RelatedTicketNumber != null ? itm.RelatedTicketNumber : null,
                        parentTicketId: itm.ParentTicketId,
                        parentTicketNumber: itm.ParentTicketNumber,
                        relatedTicketId: itm.RelatedTicketId,
                        relatedTicketNumber: itm.RelatedTicketNumber,
                        name: itm.CompanyName,
                        companyCode: itm.CompanyId,
                        jobAddress: itm.JobLocationAddress,
                        jobLocationAddress: itm.JobLocationAddressObject,
                        startDate: formatDateDDMMYYYYwithTime(itm.StartDate),
                        endDate: formatDateDDMMYYYY(itm.EndDate),
                        startTime: utils.jsTime(itm.StartDate),
                        endTime: utils.jsTime(itm.EndDate),
                        branch: itm.BranchName,
                        projectId: itm.ProjectId,
                        projectName: itm.ProjectName,
                        hasPeople: itm.ContainsPeople,
                        hasEquipment: itm.ContainsEquipment,
                        state: itm.BranchState,
                        status: statInfo,
                        sortOrder: statInfo[0].sortOrder,
                        tickets: [],
                        isCancelled: itm.isCancelled,
                        IsUnconfirmedDate: itm.IsUnconfirmedDate,
                        IsLocked: itm.IsLocked,
                        IsLockedByPreSchedule: itm.IsLockedByPreSchedule,
                        showShiftAllocationIcon: !itm.AllShiftsConfirmed,
                        showEquipmentAllocationIcon: !itm.AllEquipmentsAssigned,
                        showRequireAllocationIcon: !itm.AllResourcesAllocated,
                        ticketType: itm.TicketType,
                        IsDayShift: itm.IsDayShift,
                        isEmailSent: itm.IsEmailSent,
                        hasGeneratedPaperworkPdf: itm.HasGeneratedPaperworkPdf,
                        etag: itm.Etag ? JSON.parse(itm.Etag) : null,
                        isRequiredAttachmentsCompleted: itm.IsRequiredAttachmentsCompleted,
                        hasRequiredAttachments: itm.HasRequiredAttachments
                    };
                    ticketCards.push(ticketCard);
                }, this);

                var sortedList = alasql('SELECT * FROM ? ORDER BY sortOrder, startTime  asc', [ticketCards]);
                ticketCards = sortedList;
            }

            return ticketCards;
        }

        function buildVirtualRepeatViewModel(dailyData) {
            let chunkData = _.chunk(dailyData, CHUNK_SIZE);
            return chunkData;
        }

        function convertToVirtualRepeatModel(rawData, startDate) {
            let dailyData = buildDailyRawData(rawData, CardFilters.allowGroupByClient)
            let dayViewSource = buildVirtualRepeatViewModel(dailyData);

            let dt = startDate.format(localeSettings.displayDateFormat);
            let actualViewModel = {
                date: dt,
                day: getDayViewDisplayName(dt),
                data: dayViewSource,
                rawData: rawData,
                count: rawData.length
            };

            return $q.when(actualViewModel);
        }

        function getEmptyVirtualRepeatModel() {
            return {
                day: '',
                date: null,
                data: [],
                rawData: [],
                count: 0
            };
        }

        function formatDateDDMMYYYY(date, fmt) {
            var format = fmt || 'YYYY-MM-DD';
            return moment(date, format)
                .format(localeSettings.displayDateFormat);
        }

        function formatDateDDMMYYYYwithTime(date, fmt) {
            var timeformat = localeSettings.timeFormat2;
            var format = fmt || 'YYYY-MM-DD ' + timeformat;

            return moment(date, format)
                .format(localeSettings.displayDateFormat + ' ' + timeformat);
        }

        function getCacheNameForDayView(date) {
            let dt = moment(date, localeSettings.displayDateFormat);
            return dt.format('dddd')
                .toUpperCase() + ' ' + dt.format('MM') + ' ' + dt.format('DD') + ' ' + dt.format('YYYY');
        }

        function getDayViewDisplayName(date) {
            let dt = moment(date, localeSettings.displayDateFormat);
            return dt.format('dddd')
                .toUpperCase() + ' ' + dt.format('DD');
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('dateNavigationService', dateNavigationService);

    /** @ngInject */
    function dateNavigationService(
        _,
        moment
    ) {
        var service = {
            data: moment(), // '9/28/2016'
            getWeeklyDate: getWeeklyDate,
            getDailyDate: getDailyDate,
            getNewJobDate: getNewJobDate,
            currentMode: 'Daily', // Weekly, Monthly, Daily
            next: next,
            prev: prev,
            setToday: setToday,
            setViewMode: setViewMode,
            isMonthly: false,
            isWeekly: false,
            isDaily: true,
            whiteboardType: null,
            navigate: navigate,
            getCurrentEndWeek: getCurrentEndWeek,
            getCurrentStartWeek: getCurrentStartWeek,
            updateDate: updateDate,
            getDateData: getDateData,
            getWhiteboardTypeText: getWhiteboardTypeText
        };

        activate();

        return service;

        function activate() {
            clearActiveMode();
            setViewMode('Daily');
            setToday();
        }

        function updateDate(date) {
            service.data = angular.copy(date);
        }

        function getDateData() {
            return angular.copy(service.data);
        }

        function clearActiveMode() {
            service.isMonthly = false;
            service.isDaily = false;
            service.isWeekly = false;
        }

        function getWeeklyDate() {
            let startWeek = getCurrentStartWeek();
            let endWeek = getCurrentEndWeek();
            return startWeek.format('MMM DD') + ' - ' + endWeek.format('MMM DD, YYYY');
        }

        function getDailyDate() {
            return service.data.format('MMM DD, YYYY');
        }

        function getNewJobDate() {
            if (service.isDaily) {
                return service.data.format('YYYY-MM-DD');
            } else {
                return moment().format('YYYY-MM-DD');
            }
        }

        function next() {
            if (service.currentMode === 'Daily') {
                goToNextDay();
            } else if (service.currentMode === 'Weekly') {
                goToNextStartWeek();
            }
        }

        function prev() {
            if (service.currentMode === 'Daily')
                goToPrevDay();
            else if (service.currentMode === 'Weekly')
                goToPrevStartWeek();
        }

        function setToday() {
            service.data = moment();
        }

        function setViewMode(mode) {
            var wasWeekly = service.isWeekly;

            service.currentMode = mode;
            service.isMonthly = mode === 'Monthly';
            service.isWeekly = mode === 'Weekly';
            service.isDaily = mode === 'Daily';

            service.whiteboardType = service.isMonthly ? 'Month View' :
                service.isWeekly ? 'Week View' :
                'Day View';

            if (service.isWeekly) {
                gotoCurrentStartWeek();
            }

            // When switching from Weekly to Daily, show the first day of the week
            if (service.isDaily && wasWeekly) {
                gotoCurrentStartWeek();
            }
        }

        function getWhiteboardTypeText() {
            return service.whiteboardType;
        }

        function navigate(date) {
            service.data = angular.copy(date);
        }

        /**
         * It doesnt modify the service.data
         */
        function getCurrentStartWeek() {
            let dt = angular.copy(service.data);
            return dt.weekday(0);
        }

        /**
         * It doesnt modify the service.data
         */
        function getCurrentEndWeek() {
            let dt = angular.copy(service.data);
            return dt.weekday(6);
        }

        function gotoCurrentStartWeek() {
            return service.data.weekday(0);
        }

        function gotoCurrentEndWeek() {
            return service.data.weekday(6);
        }

        function gotoNextEndWeek() {
            service.data.weekday(13);
        }

        function gotoPrevEndWeek() {
            service.data.weekday(-1);
        }

        function goToNextStartWeek() {
            service.data.weekday(7);
        }

        function goToPrevStartWeek() {
            service.data.weekday(-7);
        }

        function goToNextDay() {
            service.data = service.data.add('days', 1);
        }

        function goToPrevDay() {
            service.data = service.data.subtract('days', 1);
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.jobs.whiteBoard')
        .factory('cardTicketDetailService', cardTicketDetailService);

    /** @ngInject */
    function cardTicketDetailService(
        $q,
        _,
        exceptionService,
        jobsWhiteboardApi2,
        CardFilters,
        TicketCardDetailModel,
        localisationService,
        whiteboardLookupService,
        utils
    ) {
        var service = {
            data: new TicketCardDetailModel(),
            getCardTicketDetails: getCardTicketDetails,
            getCardTicketDetailsForMonthly: getCardTicketDetailsForMonthly,
            reset: reset,
            convertToJsDate: convertToJsDate,
            getTicketTypeName: getTicketTypeName,
            previousState: {}
        };

        return service;
        /**
         * Get ticket details
         */
        function getCardTicketDetails(source, ticketId, isGroupByClient, type, companyCode, date) {
            let deferred = $q.defer();

            service.reset();

            // Store weekly or daily state to enable wizard style of loading
            service.previousState = {
                tickets: source,
                ticketId: ticketId,
                type: type,
                companyCode: companyCode,
                date: date
            };

            if (isGroupByClient) {
                switch (type) {
                    case "weekview":
                    case 'dayview':
                        var filters = CardFilters.getFilterOptions();

                        jobsWhiteboardApi2.getTicketDetailsGroupedByClientId(companyCode, date, filters)
                            .then(function(resp) {
                                // TODO: Ito yung dapat baguhin ni LUIS walang array dapat!!!
                                service.data.map(resp.data);

                                // Get associated status object
                                angular.forEach(resp.data.Tickets, function(itm) {
                                    itm.StatusInfo = getStatus(itm.StatusList[0]);
                                });

                                deferred.resolve(resp.data);
                            }).catch(function(ex) {
                                exceptionService.resolve(ex);
                                deferred.reject(ex);
                            });
                        break;
                }
            }

            return deferred.promise;
        }

        /**
         * For month view
         */
        function getCardTicketDetailsForMonthly(ticketCount, tickets, title) {
            let deferred = $q.defer();

            service.previousState = {
                ticketCount: ticketCount,
                tickets: tickets,
                type: 'monthview'
            };

            let ticketDetail = {
                CompanyName: title,
                TicketCount: ticketCount,
                Tickets: []
            };

            jobsWhiteboardApi2.getTicketPerIds(tickets)
                .then(function(resp) {
                    let arrItems = performWorkAroundMapping(resp.data);
                    ticketDetail.Tickets = arrItems;
                    service.data.map(ticketDetail);
                    deferred.resolve(ticketDetail);

                }).catch(function(ex) {
                    deferred.reject(ex);
                    exceptionService.resolve(ex);
                });

            return deferred.promise;
        }

        /**
         * Workaround for Monthly view
         * Reason: API returned model does not match the expected model
         */
        function performWorkAroundMapping(data) {
            let mappedResult = [];
            angular.forEach(data, function(itm) {
                let ticketData = itm.Tickets[0];
                let ticket = {
                    Id: ticketData.Id,
                    TicketNumber: ticketData.TicketNumber,
                    TicketType: ticketData.TicketType,
                    StartDate: ticketData.StartDate,
                    EndDate: ticketData.EndDate,
                    Status: ticketData.StatusList[0],
                    StatusInfo: getStatus(ticketData.StatusList[0]),
                    BranchName: ticketData.BranchName,
                    JobAddress: ticketData.JobLocationAddress,
                    State: ticketData.BranchState
                };
                mappedResult.push(ticket);
            });

            return mappedResult;
        }

        function reset() {
            service.data.reset();
        }

        function convertToJsDate(dt) {
            var localeSettings = localisationService.getLocaleFormatSettings();
            return utils.epochToJsDateTime(dt, localeSettings.shortdateFormatWithSlash);
        }

        function getStatus(id) {
            return jobsWhiteboardApi2.getStatusInfo(id);
        }

        function getTicketTypeName(id) {
            return whiteboardLookupService.getTicketType(id).Name;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .factory('CardFilters', CardFiltersService);

    /** @ngInject */
    function CardFiltersService(
        whiteboardLookupService,
        exceptionService,
        claimsUtilService,
        $q
    ) {
        var service = {
            /**
             * Look ups
             */
            branches: [],
            states: [],
            tags: [],
            filterGrouping: [],
            filterFields: [],
            filterTimeOfDay: [],
            timesheetSubmissionTypes: [],
            ticketTypes: [],
            ticketStatus: [],

            /**
             * Selected values
             */
            searchText: '',
            showProject: false,
            showRelatedTicketNumber: false,
            showWorkOrderNumber: false,
            showResources: false,
            showNightShift: false,
            showDayShift: false,
            allowGroupByClient: false,
            getSelectedTicketTypes: getSelectedTicketTypes,
            getSelectedTimesheetSubmissionTypes: getSelectedTimesheetSubmissionTypes,
            getSelectedBranches: getSelectedBranches,
            hasSelectedBranches: hasSelectedBranches,
            getSelectedBranchesToString: getSelectedBranchesToString,
            getSelectedBranchesById: getSelectedBranchIds,
            getSelectedStates: getSelectedStates,
            hasSelectedStates: hasSelectedStates,
            getSelectedStatesToString: getSelectedStatesToString,
            getSelectedStatesToRawString: getSelectedStatesToRawString,
            getSelectedTags: getIncludedTags,
            hasSelectedTags: hasIncludedTags,
            getSelectedTagsToString: getIncludedTagsToString,
            getSelectedTagsById: getIncludedTagIds,
            getExcludedTags: getExcludedTags,
            hasExcludedTags: hasExcludedTags,
            getExcludedTagsToString: getExcludedTagsToString,
            getExcludedTagsById: getExcludedTagIds,
            getSelectedTicketStatus: getSelectedTicketStatus,

            /**
             * Filter Specific
             */
            filterMode: false,
            filterIsOpen: false,
            hashWithoutFilter: null,
            areLookupsLoaded: false,
            resetFilterHash: resetFilterHash,
            loadLookups: loadLookups,
            onUpdateFilterValues: onUpdateFilterValues,
            getFilterHash: getFilterHash,
            getFilterOptions: getFilterOptions,
            hasFilterToApply: false
        };

        activate();

        return service;

        function activate() {
            resetFilterHash();
        }

        function onUpdateFilterValues() {
            service.filterMode = service.hashWithoutFilter !== getFilterHash();
        }

        function resetFilterHash() {
            service.hashWithoutFilter = getFilterHash();
            service.filterMode = false;
        }

        function loadLookups(forceReload) {
            if (forceReload) {
                service.areLookupsLoaded = false;
            }

            if (service.areLookupsLoaded) {
                return;
            }

            service.filterGrouping = [{
                Id: "groupByClient",
                Text: "Group by Client"
            }];

            service.filterFields = [{
                Id: "showProject",
                Text: "Show Project"
            }, {
                Id: "showRelatedTicketNumber",
                Text: "Show Related Ticket Number"
            }, {
                Id: "showWorkOrderNumber",
                Text: "Show Work Order Number"
            }, {
                Id: "showResources",
                Text: "Show Resources"
            }];

            service.filterTimeOfDay = [{
                Id: "showDayShift",
                Text: "Day Shifts"
            }, {
                Id: "showNightShift",
                Text: "Night Shifts"
            }];

            service.timesheetSubmissionTypes = [{
                Id: "MissingTimesheets",
                Text: "Missing Timesheets",
                selected: false
            }, {
                Id: "PartiallySubmitted",
                Text: "Partially Submitted Timesheets",
                selected: false
            }, {
                Id: "Completed",
                Text: "Completed Timesheets",
                selected: false
            }];

            service.ticketTypes = [{
                Id: "EquipmentOnly",
                Text: "Equipment Only",
                selected: false
            }, {
                Id: "FullService",
                Text: "Full Service",
                selected: false
            }, {
                Id: "PlanOnly",
                Text: "Plan Only",
                selected: false
            }, {
                Id: "Internal",
                Text: "Internal",
                selected: false
            }, {
                Id: "TravelOnly",
                Text: "Travel Only",
                selected: false
            }];

            service.ticketStatus = [{
                Id: "LessThan24hrs",
                Text: "Not Ready < 24 hrs",
                selected: false,
                show: true
            }, {
                Id: "MoreThan24hrs",
                Text: "Not Ready > 24 hrs",
                selected: false,
                show: true
            }, {
                Id: "SchedulingCopilotIsInProgress",
                Text: "Scheduling Copilot is in progress",
                selected: false,
                show: claimsUtilService.isSmartSchedulingEnabled()
            }, {
                Id: "SchedulingCopilotIsComplete",
                Text: "Scheduling Copilot is complete",
                selected: false,
                show: claimsUtilService.isSmartSchedulingEnabled()
            }, {
                Id: "ReadyToGo",
                Text: "Ready to Go",
                selected: false,
                show: true
            }, {
                Id: "Done",
                Text: "Done",
                selected: false,
                show: true
            }, {
                Id: "ExternalJobsPendingForApproval",
                Text: "External Jobs Pending For Approval",
                selected: false,
                show: true
            }];

            service.branches = [];
            service.states = [];
            service.tags = [];

            var branchPromise = whiteboardLookupService.fetchBranchLookup();
            var statePromise = whiteboardLookupService.fetchStatesLookup();
            var tagPromise = whiteboardLookupService.fetchTagsLookup();

            $q.all([branchPromise, statePromise, tagPromise])
                .then(function(resp) {
                    resp[0].data.forEach(itm => {
                        itm['selected'] = false;
                        service.branches.push(itm);
                    });

                    resp[1].data.forEach(itm => {
                        itm['selected'] = false;
                        service.states.push(itm);
                    });

                    resp[2].data.forEach(itm => {
                        itm['included'] = false;
                        itm['excluded'] = false;
                        service.tags.push(itm);
                    });

                    service.areLookupsLoaded = true;
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function hasSelectedBranches() {
            let arr = getSelectedBranches();
            return arr.length > 0;
        }

        function getSelectedBranches() {
            let selectedArr = [];
            angular.forEach(service.branches, function(branch) {
                if (branch.selected)
                    selectedArr.push({
                        id: branch.Id,
                        name: branch.Name
                    });
            }, this);

            return selectedArr;
        }

        function getSelectedBranchIds() {
            var source = getSelectedBranches();
            return _.map(source, 'id');
        }

        function getSelectedBranchesNames() {
            var source = getSelectedBranches();
            return _.map(source, 'name');
        }

        function getSelectedBranchesToString() {
            return toConcatenatedString(getSelectedBranchesNames());
        }

        function hasSelectedStates() {
            let arr = getSelectedStates();
            return arr.length > 0;
        }

        function hasSelectedTicketStatus() {
            let arr = getSelectedTicketStatus();
            return arr.length > 0;
        }

        function getSelectedStates() {
            let selectedArr = [];
            angular.forEach(service.states, function(state) {
                if (state.selected) {
                    selectedArr.push(state.value);
                }
            }, this);

            return selectedArr;
        }

        function getSelectedTicketStatus() {
            let selectedArr = [];
            angular.forEach(service.ticketStatus, function(item) {
                if (item.selected) {
                    selectedArr.push(item.Id);
                }
            }, this);

            return selectedArr;
        }

        function getSelectedStatesToString() {
            return toConcatenatedString(getSelectedStates());
        }

        function getSelectectedTicketStatusToString(){
            return toConcatenatedString(getSelectedTicketStatus());
        }

        function getSelectedStatesToRawString() {
            let arrList = getSelectedStates();
            let stateStr = '';

            angular.forEach(arrList, function(itm) {
                stateStr = stateStr + itm + ", ";
            }, this);

            return stateStr.substring(0, stateStr.length - 2);
        }

        function hasIncludedTags() {
            let arr = _.some(service.tags, tag => tag.included);
            return arr.length > 0;
        }

        function getIncludedTags() {
            return service.tags
                .filter(tag => tag.included)
                .map(tag => {
                    return {
                        Id: tag.Id,
                        name: tag.Name
                    }
                });
        }

        function getIncludedTagIds() {
            var source = getIncludedTags();
            return _.map(source, 'Id');
        }

        function getIncludedTagNames() {
            var source = getIncludedTags();
            return _.map(source, 'name');
        }

        function getIncludedTagsToString() {
            return toConcatenatedString(getIncludedTagNames());
        }

        function hasExcludedTags() {
            let arr = _.some(service.tags, tag => tag.excluded);
            return arr.length > 0;
        }

        function getExcludedTags() {
            return service.tags
                .filter(tag => tag.excluded)
                .map(tag => {
                    return {
                        Id: tag.Id,
                        name: tag.Name
                    }
                });
        }

        function getExcludedTagIds() {
            var source = getExcludedTags();
            return _.map(source, 'Id');
        }

        function getExcludedTagNames() {
            var source = getExcludedTags();
            return _.map(source, 'name');
        }

        function getExcludedTagsToString() {
            return toConcatenatedString(getExcludedTagNames());
        }

        function getSelectedTicketTypes() {
            let selectedArr = [];
            angular.forEach(service.ticketTypes, function(p) {
                if (p.selected) {
                    selectedArr.push(p.Id);
                }
            }, this);

            return selectedArr;
        }

        function getSelectedTicketTypesToString() {
            return toConcatenatedString(getSelectedTicketTypes());
        }

        function getSelectedTimesheetSubmissionTypes() {
            let selectedArr = [];
            angular.forEach(service.timesheetSubmissionTypes, function(p) {
                if (p.selected) {
                    selectedArr.push(p.Id);
                }
            }, this);

            return selectedArr;
        }

        function getSelectedTimesheetSubmissionTypesToString() {
            return toConcatenatedString(getSelectedTimesheetSubmissionTypes());
        }

        function getFilterHash() {
            let hash = (
                getSelectedBranchesToString() +
                getSelectedStatesToString() +
                getIncludedTagsToString() +
                getExcludedTagsToString() +
                service.allowGroupByClient.toString() +
                getTimeOfDay() +
                getSelectedTicketTypesToString() +
                getSelectedTimesheetSubmissionTypesToString() +
                service.searchText +
                getShowHideFiltersToString() +
                getSelectectedTicketStatusToString()
            ).hashCode();

            return hash;
        }

        function getShowHideFiltersToString() {
            let showHideFilters = '';

            showHideFilters += service.showProject ? "showProject" : "hideProject";
            showHideFilters += service.showResources ? "showResources" : "hideResources";
            showHideFilters += service.showRelatedTicketNumber ? "showRelatedTicketNumber" : "hideRelatedTicketNumber";
            showHideFilters += service.showWorkOrderNumber ? "showWorkOrderNumber" : "hideWorkOrderNumber";

            return showHideFilters;
        }

        function getTimeOfDay() {
            if ((service.showNightShift && service.showDayShift) ||
                (!service.showNightShift && !service.showDayShift)) {
                return 3;
            }

            if (service.showDayShift) {
                return 1;
            }

            return 2;
        }

        function getFilterOptions() {
            return {
                filterHash: getFilterHash(),

                branches: angular.copy(service.branches),
                selectedBranches: getSelectedBranches(),
                hasSelectedBranches: hasSelectedBranches(),
                branchesString: getSelectedBranchesToString(),

                states: angular.copy(service.states),
                selectedStates: getSelectedStates(),
                hasSelectedStates: hasSelectedStates(),
                statesString: getSelectedStatesToString(),
                hasSelectedTicketStatus: hasSelectedTicketStatus(),

                ticketStatus: angular.copy(service.ticketStatus),
                selectedTicketStatus: getSelectedTicketStatus(),
                hasSelectedTicketStatus: hasSelectedTicketStatus(),
                ticketStatusString: getSelectectedTicketStatusToString(),
                hasSelectedTicketStatus: hasSelectedTicketStatus(),

                WhiteboardTimeOfShift: getTimeOfDay(),
                showResources: service.showResources,
                allowGroupByClient: service.allowGroupByClient,

                tags: angular.copy(service.tags),
                selectedTags: getIncludedTags(),
                hasSelectedTags: hasIncludedTags(),
                tagsString: getIncludedTagsToString(),

                excludedTags: getExcludedTags(),
                hasExcludedTags: hasExcludedTags(),
                excludedTagsString: getExcludedTagsToString(),

                selectedTicketTypes: getSelectedTicketTypes(),
                selectedTimesheetSubmissionTypes: getSelectedTimesheetSubmissionTypes()
            };
        }

        function toConcatenatedString(arrList) {
            let concatenatedString = '';

            arrList.forEach(item => {
                concatenatedString = concatenatedString + "'" + item + "',";
            });

            return concatenatedString.substring(0, concatenatedString.length - 1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService(
        ticketItemModel
    ) {
        var service = {
            data: new ticketItemModel()
        };

        return service;
    }
})();

/**
 * Main View Model for whiteboard WEEK VIEW
 * Lookups and other related data are included here
 */
(function () {
    'use strict';

    angular.module('app.jobs')
        .service('ticketItemDayViewModel', ticketItemDayViewModel)

    function ticketItemDayViewModel() {
        return function () {
            var self = this,
                defaults = {
                    day: '',
                    members: [], // Note: Structure type list of String
                    labels: [],
                    ticketCards: [],  // Ticket cards are grouped by CompanyName and Date
                    pageToken: 0,
                    pageNo: 0
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                    , opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
                self.members.length = 0;
                self.labels.length = 0;
                self.ticketCards.length = 0;
            }
        }
    };

})();
/**
 * Main View Model for whiteboard WEEK VIEW
 * Lookups and other related data are included here
 */
(function () {
    'use strict';

    angular.module('app.jobs')
        .service('ticketItemModel', ticketItemModel)

    function ticketItemModel() {
        return function () {
            var self = this,
                defaults = {
                    id: '32gfhaf2',
                    name: 'Jobs Application',
                    uri: "jobs-frontend-application",
                    settings: {
                        color: "",
                        subscribed: false,
                        cardCoverImages: true
                        //bgcolor: 'bg-whiteboard1' // obsolete
                    },
                    cards: [],  // Source tickets
                    lists: [],  // Days of Week (Sun, Mon etc.)
                    members: [], // Note: Structure type list of String
                    labels: [],
                    ticketCards: [],  // Ticket cards are grouped by CompanyName and Date
                    pageToken: 0,
                    pageNo: 0
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.isEndOfRecord = isEndOfRecord; 
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                    , opts = angular.extend(self, mapValue);
            }

            function isEndOfRecord() {
                
                // Check day of week from Sun - Sat
                return (self.lists[0].idCards.length <= 0) 
                        && (self.lists[1].idCards.length <= 0) 
                        && (self.lists[2].idCards.length <= 0)
                        && (self.lists[3].idCards.length <= 0)
                        && (self.lists[4].idCards.length <= 0)
                        && (self.lists[5].idCards.length <= 0)
                        && (self.lists[6].idCards.length <= 0);
            }

            function reset() {
                self.map(null);
                self.cards.length = 0;
                self.lists.length = 0;
                self.members.length = 0;
                self.labels.length = 0;
                self.ticketCards.length = 0;
            }
        }
    };

})();
(function() {
    'use strict';

    angular.module('app.jobs')
        .service('ticketInfoModel', ticketInfoModel)

    function ticketInfoModel(utils, 
                        _, 
                        alasql) {
        return function() {
            var self = this,
                defaults = {
                    id: null,
                    TicketNumber: null,
                    CompanyName: null,
                    TicketType: null,
                    StartDate: null,
                    EndDate: null,
                    JobLocationAddress: null,
                    ClientName: null,
                    ClientPhone: null,
                    ClientEmail: null,
                    SiteContactName: null,
                    SiteContactEmail: null,
                    SiteContactPhone: null,
                    BillingPeriod: null,
                    ResourceItems: [],
                    AllocatedResourceItems: [],
                    TicketResources: []
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                // Perform some formatting
                self.StartDate = utils.displayDate(self.StartDate); //moment(self.StartDate).format('DD/MM/YYYY');
                self.EndDate =  utils.displayDate(self.EndDate);//moment(self.EndDate).format('DD/MM/YYYY');

                // Transform allocated resource to expected model
                buildResourceItems();
            }

            function buildResourceItems() {
                let allocatedResources = [];

                self.TicketResources.filter(tr => tr.IsAllocatable).map(function(itm) {
                    let allocatedResource = {
                        Resource: itm.Resource,
                        AllocatedCode: itm.AllocatedCode,
                        Allocation: itm.Allocation,
                        StartTime: itm.StartTime, 
                        EndTime: itm.EndTime, 
                        EquipmentOrOperator: itm.EquipmentOperator
                    };

                    allocatedResources.push(allocatedResource);
                });

                // Group and put sequence numbers in each resource
                let uniqueResources = alasql("SELECT DISTINCT Resource FROM ? ", [allocatedResources]);

                uniqueResources.map(function(itm) {
                    let coll = _.filter(allocatedResources, function(o) {
                        return o.Resource == itm.Resource;
                    });

                    let ctr = 1;
                    coll.map(function(itm) {
                        itm.Resource = itm.Resource + ' #' + ctr;
                        ctr++;
                    });
                })
                
                // Populate final transformation
                self.AllocatedResourceItems.length = 0;

                allocatedResources.map(function(itm) {
                    self.AllocatedResourceItems.push(itm);
                });
            }

            function reset() {
                self.map(null);
                self.ResourceItems.length = 0;
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();

/**
 * Ticket Header Pane
 * it contains (Sun, Mon, Tue etc...)
 */
(function(){
   'use strict';

  angular.module('app.jobs')
          .service('ticketHeaderModel', ticketHeaderModel)

    function ticketHeaderModel() {
        return function () {
            var self = this,
            defaults = {
                 id: null,
                 name: null,
                 idCards: []  // Array of string ID (Ticket ids)
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
                self.idCards.length = 0;
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();
(function(){
   'use strict';

  angular.module('app.jobs')
          .service('ticketCardItemModel', ticketCardItemModel)

    function ticketCardItemModel() {
        return function () {
            var self = this,
            defaults = {
                TicketNo: null,
                TicketType: null,
                StartDate: null,
                EndDate: null,
                Status: null,
                Branch: null,
                JobAddress: null,
                State: null,
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();
(function(){
   'use strict';

  angular.module('app.jobs')
          .service('TicketCardDetailModel', TicketCardDetailModel)

    function TicketCardDetailModel() {
        return function () {
            var self = this,
            defaults = {
                CompanyName: null,
                TicketCount: null,
                Tickets: [] // Type of ticketCardItemModel
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
                self.Tickets.length = 0;
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();
(function(){
   'use strict';

  angular.module('app.jobs')
          .service('jobMonthlyModel', jobMonthlyModel)

    function jobMonthlyModel() {
        return function () {
            var self = this,
            defaults = {
                Events: [],
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
                self.Events.length = 0;
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();
(function() {
    'use strict';

    angular.module('app.jobs')
        .service('allocationConflictModel', allocationConflictModel)

    function allocationConflictModel(utils) {
        return function() {
            var self = this,
                defaults = {
                    TicketNumber: null,
                    CompanyName: null,
                    Conflicts: []
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                self.Conflicts.map(function(itm) {
                    itm.StartTime = utils.datePickerFormatDate2(itm.StartTime, true);
                    itm.FinishTime = utils.datePickerFormatDate2(itm.FinishTime, true);
                });
            }

            function reset() {
                self.map(null);
                self.Conflicts.length = 0;
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.jobs.whiteBoard')
        .controller('JobBoardController', JobBoardController);

    /** @ngInject */
    function JobBoardController(
        $log,
        $scope,
        $mdToast,
        $stateParams,
        $q,
        weekViewService,
        dayViewService,
        dateNavigationService,
        whiteboardResizeService,
        blockUI,
        $timeout,
        $rootScope,
        exceptionService,
        $state,
        CardFilters,
        whiteboardCurrentRouteService,
        monthViewService,
        whiteboardFilterService,
        JobTagsSignalRService
    ) {
        var vm = this;
        vm.filter = null;
        vm.ticketParam = null;
        vm.calendarMoBehavior = {};
        vm.currentMonthShort = null;
        vm.dateNavigationBehavior = {};
        vm.filters = CardFilters;
        vm.whiteboardTypes = [{
            name: 'Job Whiteboard',
            icon: 'icon-calendar-today'
        }, {
            name: 'Equipment Whiteboard',
            icon: 'icon-truck'
        }];
        vm.whiteboardIcon = 0;
        vm.redirectFromCreateJob = false;
        vm.isNavigating = false;
        vm.showRefreshButton = false;

        vm.weekViewComponentData = [];
        vm.weekViewHeaderDates = [];
        vm.dayViewComponentData = [];
        vm.dayViewHeaderText = null;
        vm.monthViewComponentData = [];

        vm.sourceProperties = {
            weekViewSourceOfTruth: [],
            dayViewSourceOfTruth: [],
            cleanup: function() {
                this.weekViewSourceOfTruth = [];
                this.dayViewSourceOfTruth = [];
            }
        };
        vm.dataCount = 0;
        vm.whiteboardType = 0;
        vm.navWhiteboardTypeText = null;
        vm.isMonthly = false;
        vm.isWeekly = false;
        vm.isDaily = false;
        vm.filterSearchText = null;
        vm.allowGroupByClient = false;
        vm.showProject = false;
        vm.showRelatedTicketNumber = false;
        vm.showNightShift = false;
        vm.showDayShift = false;
        vm.whiteboardContainerSize = null;
        vm.showFilters = false;

        vm.addTicket = addTicket;
        vm.next = next;
        vm.prev = prev;
        vm.onRender = onRender;
        vm.setToDailyView = setToDailyView;
        vm.setToWeeklyView = setToWeeklyView;
        vm.setToMonthlyView = setToMonthlyView;
        vm.setToday = setToday;
        vm.toggleFilters = toggleFilters;
        vm.applyFilter = applyFilter;
        vm.onChangeCalendar = onChangeCalendar;
        vm.onChangeView = onChangeView;
        vm.refreshData = refreshData;
        vm.openMenu = openMenu;
        vm.whiteboardTypeClick = whiteboardTypeClick;
        vm.searchTextChange = searchTextChange;
        vm.onDayViewCancelTicket = onDayViewCancelTicket;
        vm.onWeekViewCancelTicket = onWeekViewCancelTicket;

        activate();

        function activate() {
            vm.redirectFromCreateJob = $stateParams.redirectFromCreateJob;

            setWhiteboardCurrentView();

            const isEquipmentWhiteboard = $stateParams.whiteboardType == 2;
            if (isEquipmentWhiteboard) {
                CardFilters.showRelatedTicketNumber = true;
            }

            if ($stateParams.view !== null) {
                if ($stateParams.view === "week") {
                    setToWeeklyView();
                } else if ($stateParams.view === "day") {
                    setToDailyView();
                }
            } else {

                if (dateNavigationService.isMonthly) {
                    setToMonthlyView();
                } else if (dateNavigationService.isWeekly) {
                    setToWeeklyView();
                } else if (dateNavigationService.isDaily) {
                    setToDailyView();
                }
            }

            JobTagsSignalRService.register();
        }

        function setWhiteboardCurrentView() {
            whiteboardCurrentRouteService.lastVisitedWhiteboardType = $stateParams.whiteboardType;
            vm.whiteboardType = $stateParams.whiteboardType;
            vm.whiteboardIcon = $stateParams.whiteboardType == 1 ? 0 : $stateParams.whiteboardType == 2 ?
                1 : 2;
        }

        function searchTextChange() {
            if (dateNavigationService.isWeekly) {
                var filteredItems = whiteboardFilterService.filter(vm.sourceProperties.weekViewSourceOfTruth, vm.filterSearchText);
                if (filteredItems != null && filteredItems.length > 0) {
                    weekViewService.convertToVirtualRepeatModel(filteredItems, dateNavigationService.getDateData())
                        .then(function(resp) {
                            populateWeekViewData(resp);
                        });
                } else {
                    populateWeekViewData(weekViewService.getEmptyVirtualRepeatModel());
                }
            } else if (dateNavigationService.isDaily) {
                var filteredItems = whiteboardFilterService.filter(vm.sourceProperties.dayViewSourceOfTruth, vm.filterSearchText);
                if (filteredItems != null && filteredItems.length > 0) {
                    dayViewService.convertToVirtualRepeatModel(filteredItems, dateNavigationService.getDateData())
                        .then(function(resp) {
                            populateDayViewData(resp);
                        });
                } else {
                    populateDayViewData(dayViewService.getEmptyVirtualRepeatModel());
                }
            } else if (dateNavigationService.isMonthly) {}
        }

        var refreshActiveScreenHandler = $rootScope.$on('wboard:jobBoardMain:refreshActiveScreen', function() {
            if (vm.redirectFromCreateJob) return;

            var toast = $mdToast.simple()
                .textContent('New whiteboard data received. ')
                .action('SYNC')
                .highlightAction(true)
                .highlightClass('md-accent')
                .position('top right');

            $mdToast.show(toast)
                .then(function(response) {
                    if (response == 'ok') {
                        refreshData();
                    }
                });

            $timeout(function() {
                vm.showRefreshButton = true;
            }, 0);
        });

        $scope.$on('$destroy', function() {
            refreshActiveScreenHandler();

            vm.weekViewHeaderDates.splice(0, vm.weekViewHeaderDates.length);
            vm.weekViewComponentData.splice(0, vm.weekViewComponentData.length);
            vm.dayViewComponentData.splice(0, vm.dayViewComponentData.length);
            vm.monthViewComponentData.splice(0, vm.monthViewComponentData.length);
            vm.sourceProperties.cleanup();
            vm.dataCount = 0;

            vm.filter = null
            vm.ticketParam = null;
            vm.calendarMoBehavior = null;
            vm.currentMonthShort = null;
            vm.dateNavigationBehavior = null;
            vm.scrollHandler = null;
            vm.filters = null;
            vm.whiteboardTypes = null;
            vm.whiteboardIcon = null;
            vm.redirectFromCreateJob = null;
            vm.isNavigating = null;
        });

        function next() {
            vm.showRefreshButton = false;

            if (dateNavigationService.isMonthly) {
                let dt = vm.calendarMoBehavior.next();
                dateNavigationService.navigate(dt);
                loadData(dt);
            } else {
                loadData(dateNavigationService.getDateData());
            }
        }

        function prev() {
            vm.showRefreshButton = false;

            if (dateNavigationService.isMonthly) {
                let dt = vm.calendarMoBehavior.prev();
                dateNavigationService.navigate(dt);
                loadData(dt);
            } else {
                loadData(dateNavigationService.getDateData());
            }
        }

        function onChangeCalendar() {
            if (dateNavigationService.isMonthly) {
                vm.calendarMoBehavior.setDate(dateNavigationService.getDateData());
                loadData(dateNavigationService.getDateData());
            } else {
                loadData(dateNavigationService.getDateData());
            }
        }

        function onChangeView(e) {
            setToDailyView(e);
        }

        function loadData(date) {
            if (dateNavigationService.isWeekly) {
                reloadWeeklyData(date);
            } else if (dateNavigationService.isDaily) {
                reloadDailyData(date)
            } else {
                reloadMonthlyData(date);
            }
        }

        function reloadDailyData(date) {
            getScreenSize()
                .then(function(resp) {
                    _reloadDailyData(date)
                });
        }

        function _reloadDailyData(date) {
            vm.isNavigating = false;
            forceResetDailyComponentData();
            blockUI.start({
                message: 'Loading Daily View...'
            });

            if (vm.filterSearchText) {
                dayViewService.loadDailyRawData({
                        momentDate: date,
                        contentSize: vm.whiteboardContainerSize
                    }, vm.whiteboardType)
                    .then(function(resp) {
                        if (resp) {
                            $timeout(function() {
                                populateSourceProperties('daily', {
                                    rawData: resp
                                });
                                searchTextChange();
                            });
                        }

                        vm.isNavigating = true;
                        blockUI.stop();
                    })
                    .catch(function(ex) {
                        vm.isNavigating = true;
                        blockUI.stop();
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Day view: ' + ex.errorInfo);
                                return {};
                            }
                        });
                    });
            } else {
                dayViewService.loadDailyViewData({
                        momentDate: date,
                        contentSize: vm.whiteboardContainerSize
                    }, vm.whiteboardType)
                    .then(function(resp) {
                        if (resp) {
                            $timeout(function() {
                                populateSourceProperties('daily', resp);
                                populateDayViewData(resp);
                            });
                        }

                        vm.isNavigating = true;
                        blockUI.stop();
                    })
                    .catch(function(ex) {
                        vm.isNavigating = true;
                        blockUI.stop();
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Day view: ' + ex.errorInfo);
                                return {};
                            }
                        });
                    });
            }
        }

        function reloadWeeklyData(date) {
            vm.isNavigating = false;

            forceResetWeekComponentData();
            blockUI.start({
                message: 'Loading Week View Data...'
            });

            if (vm.filterSearchText) {
                weekViewService.loadWeeklyRawData({
                        momentDate: date,
                        weekDateText: dateNavigationService.getWeeklyDate()
                    }, vm.whiteboardType)
                    .then(function(resp) {
                        if (resp) {
                            $timeout(function() {
                                populateSourceProperties('weekly', {
                                    rawData: resp
                                });
                                searchTextChange();
                            })
                        }

                        vm.isNavigating = true;
                        blockUI.stop();
                        angular.element(window)
                            .triggerHandler('resize');
                    })
                    .catch(function(ex) {
                        vm.isNavigating = true;
                        blockUI.stop();
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Week view: ' + ex.errorInfo);
                                return {};
                            }
                        });
                    });
            } else {
                weekViewService.loadWeeklyData({
                        momentDate: date,
                        weekDateText: dateNavigationService.getWeeklyDate()
                    }, vm.whiteboardType)
                    .then(function(resp) {
                        if (resp) {
                            $timeout(function() {
                                populateSourceProperties('weekly', resp);
                                populateWeekViewData(resp);
                                angular.element(window)
                                    .triggerHandler('resize');
                            });
                        }

                        vm.isNavigating = true;
                        blockUI.stop();
                    })
                    .catch(function(ex) {
                        vm.isNavigating = true;
                        blockUI.stop();
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Week view: ' + ex.errorInfo);
                                return {};
                            }
                        });
                    });
            }
        }

        function reloadMonthlyData(date) {
            vm.isNavigating = false;

            blockUI.start({
                message: 'Loading Whiteboard Data...'
            });

            monthViewService.loadMonthlyData({
                    momentDate: date
                }, vm.whiteboardType)
                .then(function(resp) {
                    $timeout(function() {
                        populateMonthViewData(resp);

                        if (angular.isFunction(vm.calendarMoBehavior.setToMonthlyView)) {
                            vm.calendarMoBehavior.setDate(date);
                            vm.calendarMoBehavior.setToMonthlyView();
                        }

                        angular.element(window)
                            .triggerHandler('resize');
                        blockUI.stop();
                    })

                    vm.isNavigating = true;
                })
                .catch(function(ex) {
                    vm.isNavigating = true;
                    blockUI.stop();
                    exceptionService.resolve(ex, {
                        intercept404: function(ex) {
                            $log.warn('Month view: ' + ex.errorInfo);
                            return {};
                        }
                    });
                });
        }

        function refreshData() {
            if (dateNavigationService.isMonthly) {
                setToMonthlyView();
            } else if (dateNavigationService.isWeekly) {
                setToWeeklyView();
            } else if (dateNavigationService.isDaily) {
                setToDailyView();
            }
            vm.showRefreshButton = false;
        }

        /**
         * Component onRender refresh
         * Note: Specific to Monthly view only
         */
        function onRender(calViewObj) {
            vm.dateNavigationBehavior.setTitle(calViewObj.title);
        }

        function setToday() {
            dateNavigationService.setToday();
            if (dateNavigationService.isMonthly) {
                vm.calendarMoBehavior.setToday();
                loadData(dateNavigationService.getDateData());
            } else {
                vm.dateNavigationBehavior.refresh();
                loadData(dateNavigationService.getDateData());
            }
        }

        function setToMonthlyView() {
            vm.isMonthly = true;
            dateNavigationService.setViewMode('Monthly');
            reloadMonthlyData(dateNavigationService.getDateData());
        }

        function setToDailyView() {
            dateNavigationService.setViewMode('Daily');
            (vm.dateNavigationBehavior.refresh || angular.noop)();
            reloadDailyData(dateNavigationService.getDateData());
        }

        function setToWeeklyView() {
            dateNavigationService.setViewMode('Weekly');
            (vm.dateNavigationBehavior.refresh || angular.noop)();
            reloadWeeklyData(dateNavigationService.getDateData());
        }

        function forceResetWeekComponentData() {
            $timeout(function() {
                vm.sourceProperties.weekViewSourceOfTruth.splice(0, vm.sourceProperties.weekViewSourceOfTruth.length);
                vm.weekViewHeaderDates.splice(0, vm.weekViewHeaderDates.length);
                vm.weekViewComponentData.splice(0, vm.weekViewComponentData.length);
                vm.dataCount = 0;
            });
        }

        function forceResetDailyComponentData() {
            $timeout(function() {
                vm.sourceProperties.dayViewSourceOfTruth.splice(0, vm.sourceProperties.dayViewSourceOfTruth.length);
                vm.dayViewComponentData.splice(0, vm.dayViewComponentData.length);
                vm.dataCount = 0;
            });
        }

        function resetCommonFlags() {
            vm.isDaily = false;
            vm.isMonthly = false;
            vm.isWeekly = false;
        }

        function populateSourceProperties(wbType, data) {
            if (wbType == 'weekly') {
                vm.sourceProperties.weekViewSourceOfTruth.splice(0, vm.sourceProperties.weekViewSourceOfTruth.length);
                angular.forEach(data.rawData, function(o) {
                    vm.sourceProperties.weekViewSourceOfTruth.push(o);
                }, this);
            } else if (wbType == 'daily') {
                vm.sourceProperties.dayViewSourceOfTruth.splice(0, vm.sourceProperties.dayViewSourceOfTruth.length);
                angular.forEach(data.rawData, function(o) {
                    vm.sourceProperties.dayViewSourceOfTruth.push(o);
                }, this);
            }
        }

        // New way of binding
        function populateWeekViewData(data) {
            resetCommonFlags();
            vm.weekViewHeaderDates.splice(0, vm.weekViewHeaderDates.length);
            vm.weekViewComponentData.splice(0, vm.weekViewComponentData.length);
            vm.dataCount = data.count;
            vm.navWhiteboardTypeText = dateNavigationService.getWhiteboardTypeText();
            vm.isWeekly = true;
            vm.allowGroupByClient = (CardFilters.allowGroupByClient == true);
            vm.showProject = (CardFilters.showProject == true);
            vm.showRelatedTicketNumber = (CardFilters.showRelatedTicketNumber == true);

            angular.forEach(data.headerDates, function(o) {
                vm.weekViewHeaderDates.push(o);
            }, this);

            angular.forEach(data.data, function(o) {
                vm.weekViewComponentData.push(o);
            }, this);

            whiteboardResizeService.adjustElementTicketHeaderSize();
        }

        function populateDayViewData(data) {
            resetCommonFlags();
            vm.dayViewComponentData.splice(0, vm.dayViewComponentData.length);
            vm.dataCount = data.count;
            vm.navWhiteboardTypeText = dateNavigationService.getWhiteboardTypeText();
            vm.dayViewHeaderText = data.day;
            vm.dayCurrentDate = data.date;
            vm.isDaily = true;
            vm.allowGroupByClient = (CardFilters.allowGroupByClient == true);
            vm.showProject = (CardFilters.showProject == true);
            vm.showRelatedTicketNumber = (CardFilters.showRelatedTicketNumber == true);

            angular.forEach(data.data, function(o) {
                vm.dayViewComponentData.push(o);
            }, this);

            whiteboardResizeService.setDefaultContentSizeForDayView();
        }

        function populateMonthViewData(data) {
            resetCommonFlags();
            vm.monthViewComponentData.splice(0, vm.monthViewComponentData.length);
            vm.dataCount = data.count;
            vm.navWhiteboardTypeText = dateNavigationService.getWhiteboardTypeText();
            vm.isMonthly = true;
            vm.allowGroupByClient = (CardFilters.allowGroupByClient == true);
            vm.showProject = (CardFilters.showProject == true);
            vm.showRelatedTicketNumber = (CardFilters.showRelatedTicketNumber == true);

            vm.monthViewComponentData.push(data.data);
        }

        function toggleFilters() {
            vm.filters.filterIsOpen = !vm.filters.filterIsOpen;
        }

        /**
         * Apply filtering this will trigger a server side fetch
         */
        function applyFilter() {

            if (dateNavigationService.isWeekly) {
                blockUI.start({
                    message: 'Filtering Week View data...'
                });

                weekViewService.applyWeekFilter(dateNavigationService.getDateData(), dateNavigationService.getWeeklyDate(), vm.whiteboardType, true)
                    .then(function(resp) {
                        blockUI.stop();
                        if (resp) {
                            populateSourceProperties('weekly', {
                                rawData: resp
                            });
                            searchTextChange();
                            whiteboardResizeService.adjustElementTicketHeaderSize();
                        }
                    })
                    .catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Week view: ' + ex.errorInfo);
                            }
                        });
                    });

            } else if (dateNavigationService.isDaily) {
                blockUI.start({
                    message: 'Filtering Day View Data...'
                });
                whiteboardResizeService.setDefaultContentSizeForDayView();

                dayViewService.applyDayFilter(dateNavigationService.getDateData(), vm.whiteboardType)
                    .then(function(resp) {
                        blockUI.stop();
                        if (resp) {
                            populateSourceProperties('daily', {
                                rawData: resp
                            });
                            searchTextChange();
                            whiteboardResizeService.setDefaultContentSizeForDayView();
                        }
                    })
                    .catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Day view: ' + ex.errorInfo);
                            }
                        });
                    });
            } else if (dateNavigationService.isMonthly) {
                blockUI.start({
                    message: 'Filtering Month View Data...'
                });
                monthViewService.applyMonthlyFilter(dateNavigationService.getDateData(), vm.whiteboardType)
                    .then(function(resp) {
                        blockUI.stop();
                        populateMonthViewData(resp);
                    })
                    .catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Month view: ' + ex.errorInfo);
                            }
                        });
                    });
            }

        }

        function addTicket() {
            $state.go('app.jobs_manage', {
                dt: dateNavigationService.getNewJobDate()
            });
        }

        function openMenu($mdMenu, ev) {
            $mdMenu.open(ev);
        }

        function onDayViewCancelTicket(cancelledTickets) {
            setToDailyView();
        }

        function onWeekViewCancelTicket(cancelledTickets) {
            setToWeeklyView();
        }

        function whiteboardTypeClick(index) {
            whiteboardCurrentRouteService.lastVisitedWhiteboardType = index == 0 ? 1 : index == 1 ? 2 : 3;
            if (index == 0)
                $state.go("app.jobs_whiteboard", {
                    location: true,
                    notify: false,
                    reload: false
                });
            else if (index == 1)
                $state.go("app.jobs_whiteboard_eq", {
                    location: true,
                    notify: false,
                    reload: false
                });
            else if (index == 2)
                $state.go("app.jobs_whiteboard_resource");
        }

        // Resizing of window only affects the Day View
        // It computes the how many ticket items to display in virtual repeat row
        function getScreenSize() {
            var deferred = $q.defer();
            if (!vm.whiteboardContainerSize) {
                $timeout(function() {
                    var contentEl = angular.element('#wb-content');
                    vm.whiteboardContainerSize = contentEl.width();

                    deferred.resolve();
                })
            } else {
                $timeout(function() {
                    deferred.resolve();
                });
            }

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.jobs')
        .factory('jobsViewService', jobsViewService);

    /** @ngInject */
    function jobsViewService(
        branchApi,
        lookupApi,
        tagsApi,
        timesheetApi,
        $state,
        utils,
        exceptionService,
        jobTicketDownloaderAdapterService,
        $q,
        JobsViewFilterModel,
        blockUI,
        moment
    ) {
        var service = {
            cleanup: cleanup,

            /**
             * Lookup Fields
             */
            ticketTypes: [],
            branchesLookUps: [],
            tags: [],

            /**
             * Filter &  Button Actions
             */
            data: new JobsViewFilterModel(),
            includedTags: [],
            excludedTags: [],
            filterTickets: filterTickets,
            resetFilter: resetFilter,

            /**
             * Grid & Button Actions
             */
            grid: {},
            allocateResource: allocateResource,
            fillTimeSheet: fillTimeSheet,
            goToRelatedTicketBilling: goToRelatedTicketBilling,
            goToFormsAndAttachment: goToFormsAndAttachment,
            checkIfTimesheetExported:checkIfTimesheetExported
        };

        activate();

        return service;

        function activate() {
            setupFilterDataDefaults();
            setupGrid();
            loadBranches();
            loadTags();
            loadTicketTypes();
        }

        function setupFilterDataDefaults() {
            service.data.ticketNo = '';
            service.data.isQuotesOnly = false;
            service.data.jobType = null;
            service.data.branches = [];
            service.data.isIncludeRelated = false;
            service.data.filterType = 1;
            service.data.startDate = moment().weekday(-7);
            service.data.endDate = moment().weekday(6);
            service.data.IsCancelled = false;
            service.data.tagIds = [];
            service.data.excludedTagIds = [];
            service.data.ticketStatus = [];
        }

        function cleanup() {
            jobTicketDownloaderAdapterService.cleanup();
        }

        function setupGrid() {
            service.grid.behavior = {};
            service.grid.data = [];
            service.grid.onCompleted = onCompleted;
            service.grid.onError = onError;
            service.grid.onInit = onInit;
            service.grid.onDataFilter = onDataFilter;

            function onInit() {
                if (service.grid.data) {
                    service.grid.data.length = 0;
                }

                service.grid.behavior.setHubSourceAdapter(jobTicketDownloaderAdapterService);
            }

            function onCompleted(data) {
                service.grid.data = data;
            }

            function onDataFilter() {
                let filterData = formFilterData();
                return filterData;
            }

            function onError(ex) {
                exceptionService.resolve(ex, {
                    interceptNativeError: function (e) {
                      exceptionService.showError(e.errorInfo.message);
                    }
                  }
                  );
            }
        }

        function loadTags() {
            tagsApi.getAllTags().then(function(resp) {
                service.tags = resp.data;
            });
        }

        function loadBranches() {
            var deferred = $q.defer();
            branchApi.getBranchesAndStates().then(function(resp) {
                angular.forEach(resp.data, function(itm) {
                    if (itm.State == null) {
                        itm.StateBranches = itm.Id.split(',');
                        itm.Id = utils.newGuid();
                    }
                    service.branchesLookUps.push(itm);
                }, this);
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        function loadTicketTypes() {
            var deferred = $q.defer();
            lookupApi.getTicketTypes().then(function(resp) {
                service.ticketTypes = resp.data;
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        function filterTickets() {
            fixUpFilterDates();
            service.grid.behavior.refresh();
        }

        function fixUpFilterDates() {
            if (service.data.startDate && service.data.endDate) {
                return;
            }

            if (!service.data.startDate && !service.data.endDate) {
                service.data.startDate = moment().weekday(-7);
                service.data.endDate = moment().weekday(6);
                return;
            }

            if (!service.data.startDate) {
                let endDate = angular.copy(service.data.endDate);
                service.data.startDate = endDate.weekday(-7);
            }

            if (!service.data.endDate) {
                let startDate = angular.copy(service.data.startDate);
                service.data.endDate = startDate.weekday(13);
            }
        }

        function formFilterData() {
            var model = service.data.tranformToServerModel();
            model.JobType = assignID(model.JobType);
            model.Branches = getBranches(model.Branches);

            return model;
        }

        function assignID(jobType) {
            if (jobType) {
                return jobType.Id;
            } else {
                return null;
            }
        }

        function getBranches(branches) {
            var filteredBranches = [];
            angular.forEach(branches, function(val, i) {
                if (val.StateBranches) { // is a State value with multiple branch Ids
                    val.StateBranches.forEach(function(id) {
                        filteredBranches.push(id);
                    });
                } else {
                    filteredBranches.push(val.Id);
                }
            });
            filteredBranches = Array.from(new Set(filteredBranches)); // Cleaned branches
            return filteredBranches;
        }

        function goToRelatedTicketBilling(id, dt) {
            let year = dt.substring(0, 4).trim();
            let month = dt.substring(5, 7).trim();
            $state.go('app.related-ticket-billing', {
                Id: id,
                Month: month,
                Year: year
            });
        }

        function goToFormsAndAttachment(id, ticketNo) {
            blockUI.start({
                message: 'Loading Forms & Attachments...'
            });
            $state.go('app.formsattachments', {
                TicketId: id,
                TicketNo: ticketNo
            });
        }

        function allocateResource(id, ticketNo, parentOrRelated) {
            blockUI.start({
                message: 'Loading Allocate Resource...'
            });
            $state.go('app.allocate', {
                id: id,
                ticketNo: ticketNo,
                parentTicketNo: parentOrRelated
            });
        }

        function fillTimeSheet(data) {
            $state.go('app.timesheet', {
                id: data.id || data.Id,
                isLocked: data.isLocked || data.IsLocked,
                TicketNo: data.TicketNumber
            });
        }

        function resetFilter() {
            setupFilterDataDefaults();

            service.includedTags = [];
            service.excludedTags = [];
           
            service.grid.behavior.refresh();
        }

        async function checkIfTimesheetExported(ticketId){
            return (await timesheetApi.checkIfTimesheetExported(ticketId)).data;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.corelib')
        .service('jobTicketDownloaderDbFilterHub', jobTicketDownloaderDbFilterHub);

    /** @ngInject */
    function jobTicketDownloaderDbFilterHub(
        $log,
        $q,
        signalRService,
        $interval
    ) {
        var service = {
            register: register,
            downloadTickets: downloadTickets,
            stopDownload: stopDownload,
            data: [],
            bufferSize: 2000,
            onDownloadCompleted: angular.noop,
            onChunkReceived: angular.noop,
            onErrorDownloading: angular.noop,
            cleanup: cleanup
        };
        var stop, hasStop = false;

        activate();

        return service;

        function activate() {
            stop = undefined;
        }

        function cleanup() {
            service.data = [];
        }

        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {}

        function downloadTickets(filters) {
            let deferred = $q.defer();
            stop = undefined;
            hasStop = false;
            service.data.length = 0; // Remove this one!!!

            // Initial download doesnt require to pass continuation token and page size
            filters.ContinuationToken = null;
            filters.PageSize = service.bufferSize;

            signalRService.safeSend(function() {
                signalRService.messageHub.invoke('DownloadTicketsByFilterAsync', filters)
                    .done(function(resp) {
                        $log.debug('Chunk Count: ' + resp.Item1.length + ' Token: ' + resp.Item2);

                        angular.forEach(resp.Item1, function(itm) {
                            service.data.push(itm);
                        });

                        if (!hasStop) {
                            // Fire event to subscriber
                            service.onChunkReceived({
                                chunkData: resp.Item1,
                                totalChunks: -1, // Undetermined
                                totalItems: -1,
                                hasFilters: filters != null
                            }, 'dbHubFilter');
                        }

                        // Continue fetching the next chunk data
                        if (resp.Item2 != null) {
                            continueDl(resp.Item2, filters);
                        } else {
                            // Trigger event download completed
                            service.onDownloadCompleted(service.data);
                        }

                        return resp;
                    }).fail(function(error) {
                        deferred.reject(error);
                    });
            });

            return deferred.promise;;
        }

        function continueDl(contToken, filters) {
            if (angular.isDefined(stop))
                return;

            let isContinue = true;

            stop = $interval(function() {
                if (isContinue) {
                    isContinue = false;

                    if (contToken === null) {
                        stopDl();
                        // Trigger event download completed
                        service.onDownloadCompleted(service.data);
                        return;
                    }

                    filters.ContinuationToken = contToken;
                    filters.PageSize = service.bufferSize;
                    continueDownloading(filters)
                        .then(function(respData) {

                            // If record exist then continue to next chunk
                            $log.debug('Chunk Count: ' + respData.Item1.length + ' Token: ' + respData.Item2);

                            if (respData) {
                                // Bind data here
                                angular.forEach(respData.Item1, function(itm) {
                                    service.data.push(itm);
                                });

                                if (!hasStop) {
                                    // Fire event to subscriber
                                    service.onChunkReceived({
                                        chunkData: respData.Item1,
                                        totalChunks: -1, // Undetermined
                                        totalItems: -1,
                                        hasFilters: filters != null
                                    }, 'dbHubFilter');
                                }
                            }

                            // Control stop
                            if (!hasStop) {
                                isContinue = true;
                                contToken = respData.Item2;
                            }
                        }).catch(function(ex) {
                            // Terminate process if something went wrong
                            if (ex.message !== 'Connection was disconnected before invocation result was received.') {
                                stopDl();
                            }
                        });
                }
            }, 100);
        }

        /**
         * Stop downloading
         */
        function stopDl() {
            if (angular.isDefined(stop)) {
                $interval.cancel(stop);
                stop = undefined;
            }
        }

        function stopDownload() {
            stopDl();
            service.data.length = 0;
            hasStop = true;
        }

        /**
         * Continue downloading
         */
        function continueDownloading(filters) {
            let deferred = $q.defer();
            signalRService.safeSend(function() {
                signalRService.messageHub
                    .invoke('downloadTicketsByFilterAsync', filters)
                    .done(function(resp) {
                        deferred.resolve(resp);
                    }).fail(function(error) {
                        deferred.reject(error);
                    });
            });

            return deferred.promise;
        }
    };
})();

(function() {
    'use strict';

    angular.module('app.corelib')
        .service('jobTicketDownloaderAdapterService', jobTicketDownloaderAdapterService);

    /** @ngInject */
    function jobTicketDownloaderAdapterService(
        $log,
        $q,
        jobTicketDownloaderDbFilterHub
    ) {
        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            stopDownload: stopDownload, // inbound event (called by grid client)
            cleanup: cleanup
        };

        activate();

        return service;
        ///////

        function activate() {
            // Filter hub
            jobTicketDownloaderDbFilterHub.onDownloadCompleted = onDownloadCompleted;
            jobTicketDownloaderDbFilterHub.onChunkReceived = onChunkReceived;
            jobTicketDownloaderDbFilterHub.onErrorDownloading = onErrorDownloading;
        }

        function cleanup() {
            jobTicketDownloaderDbFilterHub.cleanup();
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData(params) {
            var deferred = $q.defer();

            if (params != null) {
                jobTicketDownloaderDbFilterHub.downloadTickets(params.filters)
                    .then(function(resp) {
                        deferred.resolve(resp);
                    }).catch(function(ex) {
                        deferred.reject(ex);
                    });
            }

            return deferred.promise;
        }

        /**
         * it's not working yet
         * research for SignalR cancellation
         */
        function stopDownload(initiator) {
            $log.debug('Stop downloading...');
            jobTicketDownloaderDbFilterHub.stopDownload();
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.jobs.timesheet")
        .factory("timeSheetService", timeSheetService);

    /** @ngInject */
    function timeSheetService(
        timesheetApi,
        $q,
        oldAwardAPI,
        hubService,
        $mdDialog,
        $timeout,
        $state,
        _,
        $http,
        msgboxService,
        exceptionService,
        historyLogService,
        adminClaimsService,
        claimsUtilService,
        auditApi,
        ticketsApi,
        blockUI,
        TimeLibrary,
        allocationApi,
        ticketType
    ) {
        var service = {
            timeSheet: null,
            ticketId: null,
            shiftRoles: [],
            awards: [],
            isLocked: false,
            isTicketLocked: false,
            classifications: [],
            saveBtnDisabled: true,
            currentOption: null,
            columnValues: [],
            timeOptions: [],
            travelOptions: [],
            awardOptions: [],
            editMode: false,
            adminClaimsService: adminClaimsService,
            changeRoleCaption: adminClaimsService.hasManageTimesheetPayroll ? "Change Role, Award or Classification" : "Change Role",
            validateTimesheet: validateTimesheet,
            getTimesheet: getTimesheet,
            save: save,
            editTicket: editTicket,
            triggerOption: triggerOption,
            validateLine: validateLine,
            changeColumnOption: changeColumnOption,
            openMenu: openMenu,
            viewHistory: viewHistory,
            showRoleDialog: showRoleDialog,
            saveTimesheet: saveTimesheet,
            lockUnlockTimesheet: lockUnlockTimesheet,
            onFocus: onFocus,
            getActiveTimesheetDetail: getActiveTimesheetDetail,
            isFieldValid: isFieldValid,
            isSaveButtonDisabled: isSaveButtonDisabled,
            onTextChange: onTextChange,
            showValidationMessages: showValidationMessages,
            hasSignatures: false,
            fieldOriginalValue: "",
            operatorComments: null,
            timesheetEdits: null,
            ticketTimesheetsDetailsCopy: null,
            isMobileAppEnabled: claimsUtilService.isMobileAppEnabled(),
            checkIncompleteRequiredForms: checkIncompleteRequiredForms,
            checkIncompleteRequiredFormsBeforeSave: checkIncompleteRequiredFormsBeforeSave,
            hasGeneratedPaperworkPdf: false,
            claimsUtilService: claimsUtilService,
            isCustomFormsEnabled: claimsUtilService.isCustomFormsEnabled(),
            checkIfJobHasTimesheet: checkIfJobHasTimesheet,
            allocatedResourceItems: [],
            ticketType:null
        };

        return service;

        async function viewHistory() {
            var resp = await auditApi
                .getAuditEntries(service.timeSheet.TicketId);

            historyLogService.showHistory(
                "Ticket",
                resp.data,
                "#" +
                (service.timeSheet.ticketNumber ||
                    service.timeSheet.TicketNumber)
            );
        }

        function triggerOption(sourceColumn, prop, index, val) {
            if (_.isNil(sourceColumn)) {
                return;
            }

            angular.forEach(
                service.timeSheet.TicketTimesheetsDetails,
                function(detail, key) {
                    var opt = _.find(service.columnValues, {
                        Id: sourceColumn
                    }).OptionValue;

                    if (opt) {
                        if (opt == 1 || opt == 3) {
                            if (key != index) {
                                detail[prop] = val;
                            }
                        }

                        if (opt == 2) {
                            if (key != index &&
                                (detail[prop] == null || detail[prop] == "")) {
                                detail[prop] = val;
                            }
                        }

                        validateLine(detail);
                    }
                }
            );
        }

        function changeColumnOption(id, value) {
            var isReplaceAllValues = value == 4;

            if (isReplaceAllValues) {
                var column = _.find(service.columnValues, {
                    Id: id
                }).Column;

                msgboxService
                    .yepNo(
                        "Are you sure you want to reset all values in column: " + column + "?",
                        "Confirm Reset", "Yes", "Cancel"
                    )
                    .then(function() {
                        var model = _.find(service.columnValues, {
                                Id: id
                            })
                            .Model;

                        angular.forEach(
                            service.timeSheet.TicketTimesheetsDetails,
                            function(detail) {
                                detail[model] = null;
                            }
                        );
                    });

                return;
            }

            angular.forEach(service.columnValues, function(column) {
                if (column.Id == id) {
                    if (value == 1) {
                        if (column.Id <= 6) {
                            for (let x = 0; x <= 6; x++) {
                                service.columnValues[x].OptionValue = 1;
                            }
                        } else {
                            for (let x = 7; x <= 8; x++) {
                                service.columnValues[x].OptionValue = 1;
                            }
                        }
                    } else {
                        column.OptionValue = value;
                    }
                }
            });
        }

        function openMenu($mdMenu, ev, id) {
            service.currentOption = _.find(service.columnValues, {
                    Id: id
                })
                .OptionValue;
            $mdMenu.open(ev);
        }

        function clearTimesheetData() {
            service.timeSheet = null;
            service.timesheetEdits = null;
            service.operatorComments = null;
            service.hasSignatures = false;
            service.ticketId = null;
            service.isLocked = false;
            service.hasGeneratedPaperworkPdf = false;
        }

        function getTimesheet(id) {
            blockUI.start("Loading Timesheet...");

            clearTimesheetData();

            $q.all([
                    timesheetApi.getTimesheet(id),
                    oldAwardAPI.getShiftRoles(),
                    oldAwardAPI.getAwards(),
                    oldAwardAPI.getClassificationsLookup(),
                    $http.get("app/main/jobs/timeSheet/service/timesheet-file.json"),
                    allocationApi.fetchTicket(id)
                ])
                .then(function(resp) {
                    blockUI.stop();

                    if (service.isLocked === "true") {
                        showMessage("Ticket is locked. You may no longer edit the time sheet");
                    }

                    if (resp[0].data !== null) {
                        if (resp[0].data.TicketTimesheetsDetails.length == 0) {
                            showMessage("There is/are no allocated resource(s) for this timesheet");
                            return;
                        }

                        let timesheetFile = resp[4];
                        service.columnValues = timesheetFile.data.columnValues;
                        service.timeOptions = timesheetFile.data.timeOptions;
                        service.hourOptions = timesheetFile.data.hourOptions;
                        service.travelOptions = timesheetFile.data.travelOptions;
                        service.awardOptions = timesheetFile.data.awardOptions;

                        let timesheetResult = resp[0].data;
                        service.ticketId = timesheetResult.TicketId;
                        service.isLocked = timesheetResult.IsLocked;
                        service.isTicketLocked = timesheetResult.IsTicketLocked;
                        service.timeSheet = timesheetResult;
                        service.hasSignatures = timesheetResult.HasSignatures;
                        service.operatorComments = timesheetResult.OperatorComments;
                        service.operatorName = timesheetResult.OperatorName;
                        service.operatorSignatureImageUrl = timesheetResult.OperatorSignatureImageUrl;
                        service.clientName = timesheetResult.ClientName;
                        service.clientSignatureImageUrl = timesheetResult.ClientSignatureImageUrl;
                        service.isClientOnSite = !!service.clientSignatureImageUrl;
                        service.hasGeneratedPaperworkPdf = timesheetResult.HasGeneratedPaperworkPdf;
                        service.jobLatitude = timesheetResult.JobLatitude;
                        service.jobLongitude = timesheetResult.JobLongitude;
                        service.hasGPSLocation =  timesheetResult.JobLatitude != 0;
                        service.hideGPSLocation =  timesheetResult.JobLatitude != null;
                        service.ticketType = timesheetResult.TicketType;

                        service.shiftRoles = resp[1].data;
                        service.awards = resp[2].data;
                        service.classifications = resp[3].data;
                        service.allocatedResourceItems = resp[5].data;
                        service.isPendingClientSignature = resp[0].data.IsPendingClientSignature;

                        angular.forEach(
                            service.timeSheet.TicketTimesheetsDetails,
                            function(detail, index) {
                                detail.TravelStartTime = TimeLibrary.convertTime(detail.TravelStartTime);
                                detail.JobStartTime = TimeLibrary.convertTime(detail.JobStartTime);
                                detail.BreakStartTime = TimeLibrary.convertTime(detail.BreakStartTime);
                                detail.BreakEndTime = TimeLibrary.convertTime(detail.BreakEndTime);
                                detail.JobEndTime = TimeLibrary.convertTime(detail.JobEndTime);
                                detail.TravelEndTime = TimeLibrary.convertTime(detail.TravelEndTime);
                                detail.InclementWeatherHours = detail.InclementWeatherHours;
                                detail.TravelDuringDistance = detail.TravelDuringDistance;
                                detail.TravelFromDistance = detail.TravelFromDistance;
                                detail.TravelToDistance = detail.TravelToDistance;
                                detail.SetupTimeHours = detail.SetupTimeHours;
                                detail.PackupTimeHours = detail.PackupTimeHours;
                                detail.ShopStartTime = detail.ShopStartTime;
                                detail.ShopEndTime = detail.ShopEndTime;
                                detail.LoadStartTime = detail.LoadStartTime;
                                detail.LoadEndTime = detail.LoadEndTime;
                                detail.ChargeableTravelHours = detail.ChargeableTravelHours;

                                detail["Errors"] = "";
                                detail["ErrorCount"] = 0;
                                detail["WarningCount"] = 0;
                                detail = validateLine(detail, undefined, undefined, index);
                            }
                        );

                        if (timesheetResult.TimesheetEdits &&
                            timesheetResult.TimesheetEdits.length > 0
                        ) {
                            service.timesheetEdits = timesheetResult.TimesheetEdits.map(function(te) {
                                return {
                                    EditDate: moment(te.EditDate).format("DD/MM/YYYY HH:mm"),
                                    EditReason: te.EditReason
                                };
                            });
                        }
                        service.ticketTimesheetsDetailsCopy = angular.copy(service.timeSheet.TicketTimesheetsDetails);
                    } else {
                        showMessage("There is/are no allocated resource(s) for this timesheet");
                    }
                })
                .catch(function(err) {
                    blockUI.stop();
                    exceptionService.resolve(err);
                });
        }

        function onTextChange(index) {
            var rowId = "#row-".concat(index);
            var editedRow = angular.element(rowId);

            editedRow
                .find("td input:text")
                .removeClass("has-validation");
        }

        function showValidationMessages(line) {
            var timesheetDetails = service.timeSheet.TicketTimesheetsDetails;

            line.isCollapsed = !line.isCollapsed;

            timesheetDetails.forEach(function(lineItem) {
                lineItem.isCollapsed =
                    line.ContactId === lineItem.ContactId ?
                    line.isCollapsed :
                    false;
            });
        }

        function validateLine(
            line,
            sourceColumn,
            prop,
            index,
            val
        ) {
            let hasFieldValueChanged = service.fieldOriginalValue != val;

            if (!hasFieldValueChanged) {
                return;
            }

            $timeout(function() {
                var clonedTimesheet = JSON.parse(JSON.stringify(service.timeSheet));
                var timeSheetDetail = clonedTimesheet.TicketTimesheetsDetails;
                timeSheetDetail = service.getActiveTimesheetDetail(timeSheetDetail, line);

                timesheetApi
                    .validate(clonedTimesheet)
                    .then(function(resp) {
                        var validationErrors = resp.data;
                        var validationMessages = [];

                        line.ErrorCount = 0;
                        line.WarningCount = validationErrors.length;
                        line.validationMessages = validationMessages;

                        let hasValidationErrors = validationErrors.length > 0;

                        if (hasValidationErrors) {
                            line.ErrorCount = validationErrors.length;

                            validationErrors.forEach(function(details) {
                                validationMessages.push(details.Message);

                                if (details.Type !== 1) {
                                    details.FieldsValidated.forEach(function(field) {
                                        var fieldValidatedId = generateId(field, index);
                                        angular
                                            .element(fieldValidatedId)
                                            .addClass("has-validation");
                                    });
                                }
                            });

                            line.validationMessages = validationMessages;
                        }

                        triggerOption(sourceColumn, prop, index, val);

                        return line;
                    })
                    .catch(function(err) {
                        exceptionService.resolve(err);
                    });
            }, 0);
        }

        function getActiveTimesheetDetail(
            ticketTimesheetDetails,
            validatedTimesheetDetail
        ) {
            let activeDetail = null;

            ticketTimesheetDetails.splice(0, ticketTimesheetDetails.length);
            activeDetail = ticketTimesheetDetails.push(
                validatedTimesheetDetail
            );

            return activeDetail;
        }

        function isFieldValid(line, modelToValidate) {
            var hasError = false;

            var hasTimesheetValues =
                line.TravelStartTime ||
                line.TravelEndTime ||
                line.BreakStartTime ||
                line.BreakEndTime ||
                line.InclementWeatherHours ||
                line.TravelToDistance ||
                line.TravelDuringDistance ||
                line.TravelFromDistance ||
                line.SetupTimeHours ||
                line.PackupTimeHours || 
                line.ShopStartTime ||
                line.ShopEndTime || 
                line.LoadStartTime ||
                line.LoadEndTime;

            switch (modelToValidate) {
                case "JobStartTime":
                    hasError = (hasTimesheetValues && !line.JobStartTime) || (!line.JobStartTime && line.JobEndTime);
                    break;

                case "BreakStartTime":
                    hasError = !line.BreakStartTime && line.BreakEndTime;
                    break;

                case "BreakEndTime":
                    hasError = line.BreakStartTime && !line.BreakEndTime;
                    break;

                case "JobEndTime":
                    hasError = (hasTimesheetValues && !line.JobEndTime) || (line.JobStartTime && !line.JobEndTime);
                    break;
            }

            return !hasError;
        }

        function isSaveButtonDisabled() {
            var disableSaveButton = !service.timeSheet ||
                service.isLocked ||
                service.isTicketLocked ||
                hasClass("input[type=text]", "has-error") ||
                !hasTimesheetBeenEdited(service);

            return disableSaveButton;
        }

        function generateId(model, index) {
            var newId = "#".concat(model, "-", index);
            return newId;
        }

        function hasClass(selector, className) {
            return angular.element(selector)
                .hasClass(className);
        }

        function editTicket() {
            $state.go("app.jobs_update", {
                id: service.ticketId,
                ticketNumber: service.timeSheet.TicketNumber
            });
        }

        function showMessage(message) {
            hubService.showToast(message);
        }

        function validateTimesheet(sourceColumn, prop, index, val) {
            var hasAnInvalidTimesheet = false;

            angular.forEach(service.timeSheet.TicketTimesheetsDetails, function(sheet) {
                let isMissingShiftRoles = sheet.ShiftRoles == null || sheet.ShiftRoles == undefined || !angular.isArray(sheet.ShiftRoles) || sheet.ShiftRoles.length == 0;
                let isMissingAward = sheet.Award == null || sheet.Award == undefined;
                let isMissingAwardClassification = sheet.AwardClassification == null || sheet.AwardClassification == undefined;
                let isMissingJobStart = sheet.JobStartTime == null || sheet.JobStartTime == undefined;
                let isMissingJobEnd = sheet.JobEndTime == null || sheet.JobEndTime == undefined;

                let isCurrentTimesheetInvalid =
                    isMissingShiftRoles ||
                    isMissingAward ||
                    isMissingAwardClassification ||
                    isMissingJobStart ||
                    isMissingJobEnd;

                hasAnInvalidTimesheet = hasAnInvalidTimesheet || isCurrentTimesheetInvalid;
            });

            service.saveBtnDisabled = hasAnInvalidTimesheet;

            if (sourceColumn) {
                service.triggerOption(sourceColumn, prop, index, val);
            }
        }

        function save() {
            var inputSelector = "input[type=text]";
            var withException = hasClass(inputSelector, "has-validation");

            if (!withException) {
                confirmSaveTimesheet();
                return;
            }

            const dialogTitle = "Confirm timesheet exceptions?";
            const dialogContent = "One or more employees have times entered that may result in excessive hours.";

            let confirm = $mdDialog
                .confirm()
                .title(dialogTitle)
                .htmlContent(dialogContent)
                .ok("CONFIRM AND PROCEED")
                .cancel("CANCEL");

            $mdDialog.show(confirm)
                .then(confirmSaveTimesheet, function() {
                    if (
                        service.clientSignatureImageUrl != null ||
                        service.operatorSignatureImageUrl != null
                    ) {
                        service.hasSignatures = true;
                    }
                });
        }

        function confirmSaveTimesheet() {
            blockUI.start("Saving...");

            let timesheet = angular.copy(service.timeSheet);

            angular.forEach(timesheet.TicketTimesheetsDetails, function(
                timesheetDetail
            ) {
                timesheetDetail.BreakEndTime = !_.isNil(timesheetDetail.BreakEndTime) ? TimeLibrary.convertTo24(timesheetDetail.BreakEndTime) : null;
                timesheetDetail.BreakStartTime = !_.isNil(timesheetDetail.BreakStartTime) ? TimeLibrary.convertTo24(timesheetDetail.BreakStartTime) : null;
                timesheetDetail.JobEndTime = !_.isNil(timesheetDetail.JobEndTime) ? TimeLibrary.convertTo24(timesheetDetail.JobEndTime) : null;
                timesheetDetail.JobStartTime = !_.isNil(timesheetDetail.JobStartTime) ? TimeLibrary.convertTo24(timesheetDetail.JobStartTime) : null;
                timesheetDetail.TravelEndTime = !_.isNil(timesheetDetail.TravelEndTime) ? TimeLibrary.convertTo24(timesheetDetail.TravelEndTime) : null;
                timesheetDetail.TravelStartTime = !_.isNil(timesheetDetail.TravelStartTime) ? TimeLibrary.convertTo24(timesheetDetail.TravelStartTime) : null;
                timesheetDetail.ShopStartTime = !_.isNil(timesheetDetail.ShopStartTime) ? TimeLibrary.convertTo24(timesheetDetail.ShopStartTime) : null;
                timesheetDetail.ShopEndTime = !_.isNil(timesheetDetail.ShopEndTime) ? TimeLibrary.convertTo24(timesheetDetail.ShopEndTime) : null;
                timesheetDetail.LoadStartTime = !_.isNil(timesheetDetail.LoadStartTime) ? TimeLibrary.convertTo24(timesheetDetail.LoadStartTime) : null;
                timesheetDetail.LoadEndTime = !_.isNil(timesheetDetail.LoadEndTime) ? TimeLibrary.convertTo24(timesheetDetail.LoadEndTime) : null;
            });

            timesheet.EditReason = service.reasonForEditing;
            timesheet.RequiresNewSignatures = service.isSignatureRequired;
            timesheet.IsLocked = !service.isSignatureRequired;

            timesheetApi
                .saveTimesheet(timesheet)
                .then(function(resp) {
                    if (resp && resp.data) {
                        service.timesheetEdits = [];
                        service.hasSignatures = service.isSignatureRequired ? false : service.hasSignatures;

                        let savedTimesheet = resp.data;

                        (savedTimesheet.TimesheetEdits || [])
                        .forEach(timesheetEdit => {
                            service.timesheetEdits.push({
                                EditDate: moment(timesheetEdit.EditDate).format("DD/MM/YYYY HH:mm"),
                                EditReason: timesheetEdit.EditReason
                            });
                        });

                        service.timeSheet = savedTimesheet;
                        service.isLocked = savedTimesheet.IsLocked;
                        service.ticketTimesheetsDetailsCopy = angular.copy(service.timeSheet.TicketTimesheetsDetails);
                    }
                    blockUI.stop();
                })
                .catch(function(err) {
                    blockUI.stop();
                    exceptionService.resolve(err);
                });
        }

        function showRoleDialog(line) {
            $mdDialog.show({
                templateUrl: "app/main/jobs/timeSheet/service/dialog/dialog.html",
                controller: "TimesheetDialogController as vm",
                locals: {
                    service: service,
                    line: line,
                    locked: service.isLocked
                }
            });
        }

        function checkIncompleteRequiredFormsBeforeSave() {
            if (!service.isCustomFormsEnabled) {
                $mdDialog.hide();
                service.save();
                return;
            }

            service.checkIncompleteRequiredForms(service.ticketId)
                .then(function(resp) {
                    var hasIncompleteRequiredForms = resp.data;
                    if (!hasIncompleteRequiredForms) {
                        $mdDialog.hide();
                        service.save();
                        return;
                    }

                    const dialogTitle = "Skip incomplete forms?";
                    const dialogContent = "There are incomplete forms on this job which will not be included in paperwork if you proceed.<br />Do you want to proceed?";
                    let confirm = $mdDialog
                        .confirm()
                        .title(dialogTitle)
                        .htmlContent(dialogContent)
                        .ok("Yes")
                        .cancel("No");

                    $mdDialog.show(confirm)
                        .then(function() {
                            service.save();
                        });
                }, function(err) {
                    $mdDialog.hide();
                    exceptionService.resolve(err);
                });
        }

        function saveTimesheet($event) {
            var isFirstTimeSubmit = service.ticketTimesheetsDetailsCopy.every(x => !(x.JobStartTime && x.JobEndTime));
            if (isFirstTimeSubmit && !service.isMobileAppEnabled) {
                service.checkIncompleteRequiredFormsBeforeSave();
                return;
            }

            $mdDialog
                .show({
                    targetEvent: $event,
                    templateUrl: "app/main/jobs/timeSheet/service/submitTimesheetDialog/submitTimesheetDialog.html",
                    controller: "SubmitTimesheetDialogController",
                    controllerAs: 'vm',
                    locals: {
                        service: service
                    }
                });
        }

        function hasTimesheetBeenEdited(service) {
            var originalTimesheetDetails = service.ticketTimesheetsDetailsCopy;
            var originalTimesheet = originalTimesheetDetails.map(function(data) {
                var timesheetDetails = [
                    data.ShopStartTime,
                    data.ShopEndTime,
                    data.LoadStartTime,
                    data.LoadEndTime,
                    data.TravelStartTime,
                    data.TravelEndTime,
                    data.JobStartTime,
                    data.JobEndTime,
                    data.BreakStartTime,
                    data.BreakEndTime,
                    data.InclementWeatherHours,
                    data.TravelFromDistance,
                    data.TravelDuringDistance,
                    data.TravelToDistance,
                    data.NoMinimumShift,
                    data.ShiftRoles,
                    data.Award,
                    data.AwardClassification,
                    data.SetupTimeHours,
                    data.PackupTimeHours
                ];
                return timesheetDetails;
            });

            var updatedTimesheetDetails = service.timeSheet.TicketTimesheetsDetails;
            var updatedTimesheet = updatedTimesheetDetails.map(function(data) {
                var timesheetDetails = [
                    data.TravelStartTime,
                    data.TravelEndTime,
                    data.JobStartTime,
                    data.JobEndTime,
                    data.BreakStartTime,
                    data.BreakEndTime,
                    data.InclementWeatherHours,
                    data.TravelFromDistance,
                    data.TravelDuringDistance,
                    data.TravelToDistance,
                    data.NoMinimumShift,
                    data.ShiftRoles,
                    data.Award,
                    data.AwardClassification,
                    data.SetupTimeHours,
                    data.PackupTimeHours,
                    data.LoadEndTime,
                    data.ShopEndTime,
                    data.LoadStartTime,
                    data.ShopStartTime
                ];
                return timesheetDetails;
            });

            return !angular.equals(updatedTimesheet, originalTimesheet);
        }

        function onFocus(current) {
            service.fieldOriginalValue = current;
        }

        function lockUnlockTimesheet() {
            msgboxService
                .yepNo(
                    "Are you sure you want to " + (service.isLocked ? "Unlock" : "Lock") + " this timesheet?",
                    (service.isLocked ? "Unlock" : "Lock") + " Timesheet",
                    "Yes",
                    "Cancel"
                )
                .then(function() {
                    blockUI.start(
                        (service.isLocked ? "Unlocking" : "Locking") +
                        " timesheet..."
                    );
                    timesheetApi
                        .lockUnlockTimesheet(
                            service.timeSheet.id,
                            service.isLocked
                        )
                        .then(function() {
                            blockUI.stop();
                            service.isLocked = !service.isLocked;
                            showMessage(
                                "Timesheet " +
                                (service.isLocked ? "locked." : "unlocked.")
                            );
                        })
                        .catch(function(err) {
                            blockUI.stop();
                            exceptionService.resolve(err);
                        });
                });
        }

        function checkIncompleteRequiredForms(ticketId) {
            let deferred = $q.defer();

            ticketsApi.hasIncompleteRequiredForms(ticketId)
                .then(function(resp) {
                    deferred.resolve({
                        data: resp.data
                    });
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        async function checkIfJobHasTimesheet(ticketId) {
            return (await timesheetApi.hasSubmittedTimesheets(ticketId)).data;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.ticketBilling', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.ticket_billing', {
            url: '/jobs/ticket-billing-preference',
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/ticketBilling/ticket-billing.html',
                    controller: 'TicketBillingController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['jobsClaimsService', function(jobsClaimsService) {
                    return jobsClaimsService.hasTicketBillingPreferenceMenu;
                }]
            },
            title: 'Ticket Billing Preference',
            titleBar: 'Alloc8 - Ticket Billing Preference'
        });
        $translatePartialLoaderProvider.addPart('app/main/jobs/ticketBilling');
    }
})();

(function() {
    'use strict';

    angular.module('app.jobs.ticketBilling')
        .factory('ticketBillingService', ticketBillingService);

    /** @ngInject */
    function ticketBillingService($q,
        branchApi,
        ticketsApi,
        jobsApi,
        $mdDialog,
        lookupApi,
        TimeLibrary,
        _,
        utils,
        invoiceUtilsService) {
        var service = {
            branches: [],
            loading: false,
            loadingClients: false,
            selectedItem: null,
            searchText: null,
            clients: [],
            filterText: null,
            tickets: [],
            billingPeriods: [],
            groupedTickets: [],
            params: {
                BranchId: null,
                CompanyId: null,
                StartDate: invoiceUtilsService.getStartOfWeek(new Date(), true),
                EndDate: invoiceUtilsService.getEndOfWeek(new Date(), true)
            },
            loadLookups: loadLookups,
            loadBranches: loadBranches,
            loadTickets: loadTickets,
            selectedItemChange: selectedItemChange,
            querySearch: querySearch,
            ticketbillingpreferences: ticketbillingpreferences,
            loadClients: loadClients,
            getBillingPeriod: getBillingPeriod,
            translate: translate,
        };
        return service;

        function querySearch(query) {
            let results = alasql("select * from ? where Name like '" + query + "%'", [service.clients]);
            return results;
        }

        function translate(text) {
            var result = utils.translate(text);
            return result;
        }

        function loadLookups() {
            let promise1 = loadBranches();
            let promise2 = getBillingPeriod();
            service.loading = true;
            $q.all([promise1, promise2])
                .then(function(resp) {
                    service.branches = resp[0].data;
                    service.billingPeriods = resp[1].data;
                    service.loading = false;
                });
        }

        function loadBranches() {
            return branchApi.getBranches();
        }

        function loadClients() {
            service.clients = [];
            service.loadingClients = true;
            service.selectedItem = null;
            service.searchText = null;

            let payLoad = {
                BranchId: service.params.BranchId,
                DivisionId: null
            }

            jobsApi.getCompanyLookupsByBranch(payLoad)
                .then(function(resp) {
                    service.clients = alasql('select * from ? order by Name asc', [resp.data]);
                    service.loadingClients = false;
                })
                .catch(function() {
                    service.loadingClients = false;
                });
        }

        function selectedItemChange(item) {
            if (item != null || item != "") {
                service.selectedItem = item;
            } else {
                service.selectedItem = null;
            }
        }

        function ticketbillingpreferences(billingPriod, line) {
            let chosenPeriod = _.find(service.billingPeriods, {
                ItemId: parseInt(billingPriod)
            });
            let payLoad = {
                Id: line.Id,
                BillingPeriod: chosenPeriod.Id,
                IsNotBillable: chosenPeriod.IsNotBillable
            }
            ticketsApi.ticketbillingpreferences(payLoad);
        }

        function getBillingPeriod() {
            return lookupApi.getNewBillingPeriodValues2();
        }

        function loadTickets() {
            service.loading = true;
            let deferred = $q.defer();
            service.groupedTickets = [];
            service.params.StartDate = moment(service.params.StartDate).format("MM-DD-YYYY");
            service.params.EndDate = moment(service.params.EndDate).format("MM-DD-YYYY");
            service.params.CompanyId = service.selectedItem ? service.selectedItem.Id : null;
            const billingPeriod = {
                notBillable: 0,
                hourly: 1
            }

            ticketsApi.search(service.params).then(function(resp) {
                service.tickets = resp.data;
                if (service.tickets.length > 0) {
                    let grouped = _.groupBy(service.tickets, 'TicketNumber');

                    angular.forEach(grouped, function(itm) {
                        angular.forEach(itm, function(item) {
                            if ((item.BillingPeriod == null) || (item.BillingPeriod == 1 && !item.IsNotBillable)) {
                                item.BillingPeriod = billingPeriod.hourly;
                            } else {
                                var itemBillingPeriod = _.find(service.billingPeriods, {
                                    IsNotBillable: item.IsNotBillable,
                                    Id: item.BillingPeriod
                                });

                                item.BillingPeriod = itemBillingPeriod ? itemBillingPeriod.ItemId : billingPeriod.notBillable;
                            }

                            //Convert Times
                            item.ShiftEndTime = TimeLibrary.convertTime(item.ShiftEndTime);
                            item.ShiftStartTime = TimeLibrary.convertTime(item.ShiftStartTime);
                        });

                        service.groupedTickets.push({
                            TicketNumber: itm[0].TicketNumber,
                            Company: itm[0].CompanyName,
                            StartDate: itm[0].TicketStartDate,
                            Location: itm[0].JobAddress,
                            IsAllocatable: itm[0].IsAllocatable,
                            Items: itm,
                            Id: itm[0].TicketId
                        });

                        service.groupedTickets = _.orderBy(service.groupedTickets, ['StartDate'], ['asc']);
                    })
                } else {
                    var confirm = $mdDialog.confirm()
                        .title('Ticket Billing Preference')
                        .textContent("No tickets found.")
                        .ok('Return')
                    $mdDialog.show(confirm).then(function() {
                        // window.history.back();
                    });
                    service.groupedTickets = [];
                }
                service.loading = false;
                deferred.resolve(service.tickets);
            }).catch(function(ex) {
                service.loading = false;
                deferred.reject(ex);
            });
        }
    }
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TicketBillingContent = function (_React$Component) {
  _inherits(TicketBillingContent, _React$Component);

  function TicketBillingContent() {
    _classCallCheck(this, TicketBillingContent);

    var _this = _possibleConstructorReturn(this, (TicketBillingContent.__proto__ || Object.getPrototypeOf(TicketBillingContent)).call(this));

    _this.showDetails = _this.showDetails.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.translate = _this.translate.bind(_this);
    return _this;
  }

  _createClass(TicketBillingContent, [{
    key: "formatDate",
    value: function formatDate(date) {
      return moment(date).format('dddd, MMMM D, YYYY');
    }
  }, {
    key: "showDetails",
    value: function showDetails(id) {
      this.props.onshowdetails(id);
    }
  }, {
    key: "translate",
    value: function translate(text) {
      return this.props.ontranslate(text);
    }
  }, {
    key: "handleChange",
    value: function handleChange(item, event) {
      item.BillingPeriod = parseInt(event.target.value);
      this.props.changeperiod(event.target.value, item);
    }
  }, {
    key: "render",
    value: function render() {

      var self = this;

      var createLineItem = function createLineItem(item) {
        var classname = "";
        var disablecontrol = "";
        if (!item.IsAllocatable) {
          classname = "grey-text";
          disablecontrol = "disabled";
        }

        return React.createElement(
          "tr",
          null,
          React.createElement(
            "td",
            { width: "25%", className: classname },
            item.ItemName
          ),
          React.createElement(
            "td",
            { width: "25%", className: classname },
            item.AllocatedItemName
          ),
          React.createElement(
            "td",
            { width: "15%", className: classname },
            item.ShiftStartTime,
            " - ",
            item.ShiftEndTime
          ),
          React.createElement(
            "td",
            { width: "35%" },
            React.createElement(
              "select",
              { disabled: disablecontrol, value: item.BillingPeriod, onChange: self.handleChange.bind(this, item) },
              self.props.billingperiods.map(function (itm) {
                return React.createElement(
                  "option",
                  { value: itm.ItemId },
                  itm.Name
                );
              })
            ),
            !item.IsAllocatable && React.createElement(
              "div",
              { className: classname },
              self.translate('TICKETBILLING.GO_TO_WHITEBOARD_TO_CHANGE_BILLING_PERIOD')
            )
          )
        );
      };

      var createTicketItem = function createTicketItem(ticket) {
        return React.createElement(
          "md-card",
          { className: "fade" },
          React.createElement(
            "md-card-header",
            null,
            React.createElement(
              "md-card-avatar",
              null,
              React.createElement(
                "md-button",
                { className: "md-icon-button md-primary action-button", "aria-label": "Settings" },
                React.createElement("i", { className: "icon icon-ticket teal-500-fg s15" })
              )
            ),
            React.createElement(
              "md-card-header-text",
              null,
              React.createElement(
                "span",
                { className: "md-title" },
                "Ticket #",
                ticket.TicketNumber
              ),
              React.createElement(
                "span",
                { className: "md-subhead" },
                ticket.Location
              ),
              React.createElement(
                "span",
                { className: "md-subhead" },
                ticket.Company
              ),
              React.createElement(
                "span",
                { className: "md-subhead" },
                self.formatDate(ticket.StartDate)
              )
            )
          ),
          React.createElement(
            "md-card-content",
            null,
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(
              "table",
              { className: "simple hover row-border" },
              React.createElement(
                "thead",
                null,
                React.createElement(
                  "tr",
                  null,
                  React.createElement(
                    "th",
                    null,
                    "Item Name"
                  ),
                  React.createElement(
                    "th",
                    null,
                    "Allocated"
                  ),
                  React.createElement(
                    "th",
                    null,
                    "Shift Times"
                  ),
                  React.createElement(
                    "th",
                    null,
                    "Billing Period"
                  )
                )
              ),
              React.createElement(
                "tbody",
                null,
                ticket.Items.map(createLineItem)
              )
            )
          ),
          React.createElement(
            "md-card-actions",
            { layout: "row", align: "end center" },
            React.createElement(
              "md-button",
              { className: "md-icon-button md-primary action-button",
                onClick: self.showDetails.bind(this, ticket.Id),
                "aria-label": "Settings" },
              React.createElement("i", { className: "icon icon-view-list cyan-500-fg s25" })
            )
          )
        );
      };

      return React.createElement(
        "div",
        null,
        React.createElement(
          "h4",
          { className: "padleft5" },
          self.translate('TICKETBILLING.HEADER_GO_TO_WHITEBOARD_TO_CHANGE_BILLING_PERIOD')
        ),
        this.props.ticketslist.map(createTicketItem)
      );
    }
  }]);

  return TicketBillingContent;
}(React.Component);

TicketBillingContent.propTypes = {
  ticketslist: React.PropTypes.array.isRequired,
  billingperiods: React.PropTypes.array.isRequired,
  onshowdetails: React.PropTypes.func.isRequired,
  changeperiod: React.PropTypes.func.isRequired,
  ontranslate: React.PropTypes.func.isRequired
};
TicketBillingContent.defaultProps = {
  ticketslist: [],
  billingperiods: [],
  onshowdetails: function onshowdetails() {},
  changeperiod: function changeperiod() {},
  ontranslate: function ontranslate() {}
};


angular.module('app.jobs.ticketBilling').value('TicketBillingContent', TicketBillingContent);
(function() {
    'use strict';

    angular.module('app.jobs.ticketBilling')
        .directive('ticketBillingMainComponent', ticketBillingMainComponent);

    /** @ngInject */
    function ticketBillingMainComponent(ticketBillingService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/ticketBilling/main/ticket-billing-main.html',
            scope: true,
            controller: TicketBillingViewController,
            controllerAs: 'ticketBillingVm',
            bindToController: true,
            locals: {
                service: ticketBillingService
            }
        };

        return directive;

        function TicketBillingViewController(ticketBillingService, DialogService, $mdSidenav, utils) {
            var vm = this;
            vm.showDetails = showDetails;
            vm.handleChange = handleChange;
            vm.service = ticketBillingService;
            vm.toggleSidenav = toggleSidenav;
            vm.showFiltersText = utils.translate('TICKETBILLING.SHOW_FILTERS');

            vm.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                Width: 1000
            };

            function showDetails(id) {
                DialogService.openTicketDetailDialog(id, false, true);
            }

            function handleChange() {

            }

            function toggleSidenav(sidenavId) {
                $mdSidenav(sidenavId).toggle();
            }
        }
        }

})();

(function () {
  'use strict';

  angular.module('app.jobs.ticketBilling')
    .directive('ticketBillingContentComponent', ticketBillingContentComponent);

  /** @ngInject */
  function ticketBillingContentComponent(reactDirective, TicketBillingContent) {
    return reactDirective(TicketBillingContent);
  }

})();

(function() {
    'use strict';

    angular
        .module('app.jobs.view', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.jobs_view', {
            url: '/jobs/view-jobs',
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/view/jobs-view.html',
                    controller: 'JobsViewController as vm'
                }
            },
            data: {
                requireLogin: true
            },
            title: 'Manage Tickets',
            titleBar: 'Alloc8 - View Jobs'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.view')
        .controller('UpdateShiftTimesController', UpdateShiftTimesController);

    function UpdateShiftTimesController($mdDialog, ticket) {
        var vm = this;
        vm.onYes = onYes;
        vm.onNo = onNo;

        vm.message = ticket.HasConfirmedResources ?
        `If you already have confirmed resources they will need to reaccept the new shift time. If you do not
            wish to update the shift times, click 'No'.` : `If you do not wish to update the shift times, click 'No'.`;

        function onYes() {
            $mdDialog.hide({
                result: true
            });
        }

        function onNo() {
            $mdDialog.hide({
                result: false
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.view')
        .controller('UnconfirmJobDialogController', UnconfirmJobDialogController);

    function UnconfirmJobDialogController($mdDialog) {
        var vm = this;
        vm.onYes = onYes;
        vm.onNo = onNo;

        function onYes() {
            $mdDialog.hide({
                result: true
            });
        }

        function onNo() {
            $mdDialog.hide({
                result: false
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.view')
        .controller('cloneJobAllocationDialogController', cloneJobAllocationDialogController);

    /** @ngInject */
    function cloneJobAllocationDialogController(
        $mdDialog,
        jobsApi,
        data,
        claimsUtilService,
        $q,
        $timeout
    ) {

        const TICKET_TYPE_PLAN_ONLY = 4;

        let vm = this;
        vm.isCloningInProgress = false;
        vm.shouldCloneResources = data.hasAllocatedResources;
        vm.shouldCloneShiftTimes = false;
        vm.shouldCloneForms = data.hasForms;
        vm.shouldCloneAttachments = claimsUtilService.isCloningOfAttachmentsEnabled() && data.hasAttachments;
        vm.canCloneShiftTimes = !data.hasOnlyEquipment;
        vm.canCloneAllocatedResources = data.hasAllocatedResources;
        vm.showCloneFormsAndAttachments = vm.shouldCloneForms || vm.shouldCloneAttachments;
        vm.canCloneAttachments = claimsUtilService.isCloningOfAttachmentsEnabled() && data.hasAttachments;
        vm.showAllocateResourceBySmartScheduling = claimsUtilService.hasSmartSchedulingAccess() && data.ticketType != TICKET_TYPE_PLAN_ONLY
        vm.shouldAllocateResourceBySmartScheduling = false;
        vm.proceed = proceed;

        function proceed() {
            if (!vm.shouldCloneResources && !vm.shouldCloneShiftTimes && !vm.shouldCloneForms && !vm.shouldCloneAttachments && !vm.shouldAllocateResourceBySmartScheduling) {
                closeDialog();
                return;
            }

            vm.isCloningInProgress = true;

            data.multiple ? cloneMultiDayTicket(data) : cloneSingleDayTicket(data);
        }

        function closeDialog() {
            $mdDialog.hide(vm);
        }

        async function cloneSingleDayTicket(data) {
            const payload = {
                TicketId: data.SourceTicketId,
                CloneTicketId: data.CloneTicketId,
                CloneTicketNumber: data.CloneTicketNumber,
                ShouldCloneResources: vm.shouldCloneResources,
                ShouldCloneShiftTimes: vm.shouldCloneShiftTimes,
                ShouldCloneForms: vm.shouldCloneForms,
                ShouldCloneAttachments: vm.shouldCloneAttachments
            };

            try {
                const resp = await validateAllocations(payload);

                const hasAllocationIssue = resp.response.data.ResourceItemCloningResults
                    .some(result => result.AllocationIssues.length > 0);

                if (!hasAllocationIssue || resp.canBeAllocated) {
                    await jobsApi.cloneAllocations(payload);
                    closeDialog();
                    return;
                }

                const { canBeOverridden, isUserConfirmed } = await handleSingleDayAllocationIssue(
                    resp.response,
                    resp.canBeOverridden
                );

                if (canBeOverridden && isUserConfirmed) {
                    const overrideResp = await showOverrideDialog();

                    if (overrideResp) {
                        payload.OverrideReason = overrideResp.Reason;
                        await jobsApi.cloneAllocations(payload);
                    }
                } else if (isUserConfirmed) {
                    await jobsApi.cloneAllocations(payload);
                }

                closeDialog();
            } catch (error) {
                closeDialog();
            }
        }

        function handleSingleDayAllocationIssue(resp, canBeOverridden) {
            if (resp.data) {
                return showCloningErrorMessages([resp.data], canBeOverridden);
            }

            closeDialog();
        }

        async function cloneMultiDayTicket(data) {
            var payload = {
                ShouldCloneResources: vm.shouldCloneResources,
                ShouldCloneShiftTimes: vm.shouldCloneShiftTimes,
                ShouldCloneForms: vm.shouldCloneForms,
                ShouldCloneAttachments: vm.shouldCloneAttachments,
                Tickets: data.Tickets
            };

            payload.Tickets.forEach(t => {
                t.ShouldCloneResources = vm.shouldCloneResources;
            });

            let response = await validateMultipleTicketAllocations(payload);

            if (response.canOverrideTickets.length == 0 && response.partialAllocatedTickets.length == 0)
            {
                await jobsApi.cloneMultipleTicketsAllocation(payload);
                closeDialog();
                return;
            }

            if (response.partialAllocatedTickets.length > 0)
            {
                await handleMultiDayInvalidToAllocate(response.partialAllocatedTickets);
            }

            if (response.unCloneableTickets.length > 0)
            {
                payload.Tickets
                    .filter(t => response.unCloneableTickets.some(r => r.TicketNumber == t.NewTicketNumber))
                    .forEach(t => {
                        t.ShouldCloneResources = false;
                    });
            }

            if (response.canOverrideTickets.length > 0)
            {
                let overrideReason = await handleMultiDayOverride(response.canOverrideTickets);

                payload.Tickets
                .filter(t => response.canOverrideTickets.some(r => r.TicketNumber == t.NewTicketNumber))
                .forEach(t => {
                    t.OverrideReason = overrideReason;
                    t.ShouldCloneResources = vm.shouldCloneResources && overrideReason ? true : false;
                });
            }

            await jobsApi.cloneMultipleTicketsAllocation(payload);

            $timeout(() => $mdDialog.hide(vm));

            return;
        }

        async function handleMultiDayOverride(data) {
           if (data) {
                let response = await showMultiDayJobCloningErrorMessages([data], true);
                if (response)
                {
                    let overrideResponse = await showOverrideDialog()
                    if (overrideResponse)
                    {
                        return overrideResponse.Reason;
                    }
                }

                return response;
            }
            return false;
        }

        async function handleMultiDayInvalidToAllocate(data) {
           if (data) {
                let canBeOverriden = false;
                await showMultiDayJobCloningErrorMessages([data], canBeOverriden);
            }
        }

        function closeAndReturnFalse() {
            $mdDialog.hide(false);
        }

        function showCloningErrorMessages(cloningResults, canBeOverridden) {
            if (!cloningResults) {
                closeDialog();
                return;
            }

            let messages = "";
            let defer = $q.defer();

            cloningResults.forEach((cloningResult) => {
                let resourceItemCloningResults = cloningResult.ResourceItemCloningResults;
                let ticketNumber = cloningResult.TicketNumber;
                let attachmentErrors = cloningResult.AttachmentCloningErrors;

                if ((!resourceItemCloningResults || resourceItemCloningResults.length == 0) &&
                    (!attachmentErrors || attachmentErrors.length == 0)) {
                    return;
                }

                messages += `<ul class="allocation-errors"><li><strong>Ticket #${ticketNumber}</strong></li>`;

                if (resourceItemCloningResults && resourceItemCloningResults.length > 0) {

                    const groupBy = (array, fn) => {
                        var groups = {};
                        array.forEach(function (obj) {
                            var group = JSON.stringify(fn(obj));
                            (groups[group] = groups[group] || []).push(obj);
                        });

                        return groups;
                    };

                    var groupedAllocationIssues = groupBy(resourceItemCloningResults, function (item) {
                        return [item.AllocationIssues];
                    });

                    messages += Object.keys(groupedAllocationIssues).map(function (key) {
                        let allocationIssues = JSON.parse(key);
                        let shiftsByIssue = groupedAllocationIssues[key];
                        let message = "";

                        if (allocationIssues && allocationIssues.length > 0 && allocationIssues.some(x => x.length > 0)) {
                            message += `<ul class="allocation-errors">` + shiftsByIssue.map(x => `<li class="primary-error">${x.ShiftName} - ${x.ResourceItemName}</li>`).join("");
                            message += '<ul class="allocation-errors">' + allocationIssues.flat().map(x => `<li>${x.Message}</li>`).join("") + '</ul>';
                            message += '</ul>';
                        }


                        return message;
                    }).join("");
                }
                if (attachmentErrors && attachmentErrors.length > 0) {
                    messages += '<ul class="allocation-errors"><li class="primary-error">Attachments</li>';
                    messages += '<ul class="allocation-errors">' + attachmentErrors.map(x => `<li>${x}</li>`).join("") + '</ul>';
                    messages += '</ul>';
                }
                messages += '</ul></br>';
            });

            if (!messages) {
                defer.resolve(false);
            }

            var notif = $mdDialog.confirm()
                .parent(angular.element(document.body))
                .clickOutsideToClose(false)
                .title('Unable to clone')
                .htmlContent(messages)
                .ariaLabel('Unable to clone')
                .multiple(true)
                .ok('Ok');

            if (canBeOverridden) {
                notif.ok('Override').cancel('Cancel');
            }


            $mdDialog.show(notif)
                .then(function () {
                    defer.resolve({ canBeOverridden: canBeOverridden, isUserConfirmed: true });
                })
                .catch(function () {
                    closeDialog();
                    defer.resolve({ canBeOverridden: canBeOverridden, isUserConfirmed: false });
                });

            return defer.promise;
        }

        function showMultiDayJobCloningErrorMessages(cloningResults, canBeOverriden) {
            let messages = "";

            cloningResults.forEach((result) => {
                result.forEach((cloningResult) => {

                let resourceItemCloningResults = cloningResult.ResourceItemCloningResults;
                let ticketNumber = cloningResult.TicketNumber;
                let attachmentErrors = cloningResult.AttachmentCloningErrors;

                if ((!resourceItemCloningResults || resourceItemCloningResults.length == 0) &&
                    (!attachmentErrors || attachmentErrors.length == 0)) {
                    return;
                }

                messages += `<ul class="allocation-errors"><li><strong>Ticket #${ticketNumber}</strong></li>`;

                if (resourceItemCloningResults && resourceItemCloningResults.length > 0) {

                    const groupBy = (array, fn) => {
                        var groups = {};
                        array.forEach(function (obj) {
                            var group = JSON.stringify(fn(obj));
                            (groups[group] = groups[group] || []).push(obj);
                        });

                        return groups;
                    };

                    var groupedAllocationIssues = groupBy(resourceItemCloningResults, function (item) {
                        return [item.AllocationIssues];
                    });

                    messages += Object.keys(groupedAllocationIssues).map(function (key) {
                        let allocationIssues = JSON.parse(key);
                        let shiftsByIssue = groupedAllocationIssues[key];
                        let message = "";

                        message += `<ul class="allocation-errors">` + shiftsByIssue.map(x => `<li class="primary-error">${x.ShiftName} - ${x.ResourceItemName}</li>`).join("");

                        if (allocationIssues && allocationIssues.length > 0) {
                            message += '<ul class="allocation-errors">' + allocationIssues.flat().map(x => `<li>${x.Message}</li>`).join("") + '</ul>';
                        }

                        message += '</ul>';

                        return message;
                    }).join("");
                }
                if (attachmentErrors && attachmentErrors.length > 0) {
                    messages += '<ul class="allocation-errors"><li class="primary-error">Attachments</li>';
                    messages += '<ul class="allocation-errors">' + attachmentErrors.map(x => `<li>${x}</li>`).join("") + '</ul>';
                    messages += '</ul>';
                }
                messages += '</ul></br>';

                })
            });

            var notif = $mdDialog.confirm()
            .parent(angular.element(document.body))
            .clickOutsideToClose(false)
            .title('Unable to clone')
            .htmlContent(messages)
            .ariaLabel('Unable to clone')
            .multiple(true);

            notif = canBeOverriden
                ? notif.ok('Override').cancel('Cancel')
                : notif.ok('Ok');

            let defer = $q.defer();

            $mdDialog.show(notif).then(function (result) {
                if (result) {
                    defer.resolve(true);
                }
            })
            .catch(function () {
                defer.resolve(false);
            });

            return defer.promise;
        }

        function showOverrideDialog() {
            var defer = $q.defer();

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                controller: 'overrideReasonDialogController as vm',
                locals: {
                    data: data
                }
            }).then(function (resp) {
                defer.resolve(resp);
            })
            .catch(function () {
                defer.resolve(false);
            });

            return defer.promise;
        }

        function validateAllocations(payload) {
            var defer = $q.defer();

            jobsApi.validateAllocations(payload).then(function (resp) {

                let cloningResults = resp.data
                && resp.data.ResourceItemCloningResults
                && resp.data.ResourceItemCloningResults.filter(x => x.AllocationIssues && x.AllocationIssues.length > 0);

                const canBeOverridden = cloningResults.some(result =>
                    result.AllocationIssues.every(issue => issue.CanBeOverriden === true)
                );

                const canBeAllocated = cloningResults.some(result =>
                    result.AllocationIssues.every(issue => issue.IsValidToAllocate === true)
                );

                defer.resolve({response: resp,canBeOverridden: canBeOverridden, canBeAllocated: canBeAllocated});
            });

            return defer.promise;
        }

        async function validateMultipleTicketAllocations(payload) {

            let resp = await jobsApi.validateMultipleTicketAllocations(payload)

            let canOverrideTickets = resp.data.filter(d=>d.ResourceItemCloningResults.some(result =>
            {
                if (result.AllocationIssues.length == 0) {
                    return false;
                }

                if (result.AllocationIssues.some(issue => !issue.IsValidToAllocate && !issue.CanBeOverriden)) {
                    return false;
                }

                if (result.AllocationIssues.every(issue => !issue.CanBeOverriden)) {
                    return false;
                }

                return true;
            }));

            let partialAllocatedTickets = resp.data.filter(d=>d.ResourceItemCloningResults.some(result =>
                result.AllocationIssues.some(issue => !issue.IsValidToAllocate
                    && !issue.CanBeOverriden)
                ));

            let unCloneableTickets = resp.data.filter(d=>d.ResourceItemCloningResults.every(result =>
                result.AllocationIssues.some(issue => !issue.IsValidToAllocate
                    && !issue.CanBeOverriden)
                ));

            return {
                canOverrideTickets: canOverrideTickets,
                partialAllocatedTickets: partialAllocatedTickets,
                unCloneableTickets: unCloneableTickets
            };
        }
}
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.manage', [
            'app.jobs.components.resource',
            'app.jobs.components.orderedBy',
            'app.jobs.components.jobDetails',
            'app.jobs.components.customFields',
            'app.widgets',
            'duScroll'
        ])
        .config(config)
        .run(runConfig);

    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.jobs_manage', {
            url: '/jobs/create-a-job/:dt',
            params: {
                related: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/manage/jobs-manage.html',
                    controller: 'JobsCreateController as vm'
                }
            },
            title: 'Create Job',
            titleBar: 'Alloc8 - Create Job',
            data: {
                requireLogin: true
            }
        });

        $stateProvider.state('app.jobs_update', {
            url: '/jobs/update-a-job/:id?/:ticketNumber?/:isLocked',
            params: {
                parentTicketNo: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/manage/jobs-manage.html',
                    controller: 'JobsCreateController as vm'
                }
            },
            title: 'Update Ticket',
            titleBar: 'Alloc8 - Ticket Update',
            data: {
                requireLogin: true
            }
        });
        $stateProvider.state('app.jobs_clone', {
            url: '/jobs/clone-a-job/:cloneId',
            params: {
                related: null,
                costEstimateGroupId: null,
                costEstimateId: null,
                ticketCount: 1,
                transformModelType: 'clone-a-job/:cloneId'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/manage/jobs-manage.html',
                    controller: 'JobsCreateController as vm'
                }
            },
            title: 'Create Job',
            titleBar: 'Alloc8 - Create Job',
            data: {
                requireLogin: true
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/jobs/manage');
    }

    function runConfig($cacheFactory, $rootScope, translationService) {
        $rootScope.cache = $cacheFactory('selectedClientCACHE');
        $rootScope.cache.removeAll();
        translationService.translate();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.manage')
        .controller('ChargeMinimumHoursController', ChargeMinimumHoursController);

    /** @ngInject */
    function ChargeMinimumHoursController($mdDialog, ticket) {

        var vm = this;
        vm.ticket = ticket;
        vm.chargeMinHours = ticket.ChargeMinimumHours || false;
        vm.closeDialog = closeDialog;
        vm.save = save;

        function closeDialog() {
            $mdDialog.hide(false);
        }

        function save() {
            $mdDialog.hide({
                ticket: vm.ticket,
                chargeMinHours: vm.chargeMinHours
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.view')
        .controller('CancelReasonController', CancelReasonController);

    /** @ngInject */
    function CancelReasonController($mdDialog, ticket, claimsUtilService, ticketType) {

        var vm = this;
        vm.ticket = ticket;
        vm.reason = claimsUtilService.isCustomerOnboardingEnabled() ? 'Test Data used for Customer Onboarding' : null;
        vm.chargeMinHours = false;
        vm.isChargeMinHoursEnabled = (vm.ticket.TicketType !== ticketType.FULL_SERVICE &&
            vm.ticket.TicketType !== ticketType.TRAVEL_ONLY
        );
        vm.closeDialog = closeDialog;
        vm.cancelTicket = cancelTicket;

        function closeDialog() {
            $mdDialog.hide(false);
        }

        function cancelTicket() {
            $mdDialog.hide({
                ticket: vm.ticket,
                reason: vm.reason,
                chargeMinHours: vm.chargeMinHours
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.resourceWhiteboard')
        .controller('ResourceWhiteBoardController', ResourceWhiteBoardController);

    /** @ngInject */
    function ResourceWhiteBoardController(
        _,
        $log,
        $scope,
        $rootScope,
        $stateParams,
        $q,
        weekViewServiceRw,
        dayViewServiceRw,
        dateNavigationService,
        whiteboardResizeServiceRw,
        blockUI,
        $timeout,
        exceptionService,
        $state,
        CardFilters,
        whiteboardFilterServiceRw,
        whiteboardSyncService,
        JobTagsSignalRService,
        localStorageService,
        claimsUtilService,
    ) {
        const VIEW_SETTINGS_KEY = 'urn:settings:resourceWhiteboardViewSettings';
        var vm = this;

        vm.dateNavigationService = dateNavigationService;
        vm.filter = null;
        vm.ticketParam = null;
        vm.calendarMoBehavior = {};
        vm.currentMonthShort = null;
        vm.dateNavigationBehavior = {};
        vm.filters = CardFilters;
        vm.whiteboardIcon = 0;
        vm.isNavigating = false;
        vm.showRefreshButton = false;

        vm.weekViewComponentData = [];
        vm.weekViewHeaderDates = [];
        vm.dayViewComponentData = [];
        vm.viewSettings = [];
        vm.dayViewHeaderText = null;

        vm.sourceProperties = {
            weekViewSourceOfTruth: [],
            dayViewSourceOfTruth: [],
            cleanup: function() {
                this.weekViewSourceOfTruth = [];
                this.dayViewSourceOfTruth = [];
            }
        };

        vm.viewSettingOptions = [];

        vm.dataCount = 0;
        vm.totalCount = null;
        vm.isLoadingCount = false;
        vm.whiteboardType = 3;
        vm.pagination = dayViewServiceRw.getPaginationState();
        vm.statusLegends = [{
            name: 'Not Ready < 24 hrs',
            description: 'Job starts in < 24 hours with unrostered or unconfirmed resources',
            color: 'status-legend-red'
        }, {
            name: 'Not Ready > 24 hrs',
            description: 'Job starts in > 24 hours with unrostered or unconfirmed resources',
            color: 'status-legend-orange'
        },{
            name: 'Scheduling Copilot is in progress',
            description: 'Scheduling Copilot of resources is in progress',
            color: 'status-legend-pink',
            show: claimsUtilService.isSmartSchedulingEnabled()
        },{
            name: 'Scheduling Copilot is complete',
            description: 'Resources were allocated via Scheduling Copilot',
            color: 'status-legend-violet',
            show: claimsUtilService.isSmartSchedulingEnabled()
        }, {
            name: 'Ready to Go',
            description: 'All resources are rostered and confirmed',
            color: 'status-legend-green'
        }, {
            name: 'Done',
            description: 'Job started more than 24 hours ago, all resources rostered & confirmed',
            color: 'status-legend-blue'
        }, {
            name: 'External Jobs Pending for Approval',
            description: 'A request to create the job from the external system is waiting for approval',
            color: 'status-legend-yellow'
        }];
        vm.navWhiteboardTypeText = null;
        vm.isMonthly = false;
        vm.isWeekly = false;
        vm.isDaily = false;
        vm.filterSearchText = null;
        vm.allowGroupByClient = false;
        vm.showProject = false;
        vm.showResources = false;
        vm.showRelatedTicketNumber = false;
        vm.showWorkOrderNumber = false;
        vm.showNightShift = false;
        vm.showDayShift = false;
        vm.whiteboardContainerSize = null;
        vm.showFilters = false;
        vm.next = next;
        vm.prev = prev;
        vm.addTicket = addTicket;
        vm.onRender = onRender;
        vm.setToDailyView = setToDailyView;
        vm.setToWeeklyView = setToWeeklyView;
        vm.setToday = setToday;
        vm.toggleFilters = toggleFilters;
        vm.applyFilter = applyFilter;
        vm.onChangeCalendar = onChangeCalendar;
        vm.onChangeView = onChangeView;
        vm.refreshData = refreshData;
        vm.openMenu = openMenu;
        vm.searchTextChange = searchTextChange;
        vm.onDayViewCancelTicket = onDayViewCancelTicket;
        vm.onWeekViewCancelTicket = onWeekViewCancelTicket;
        vm.isToday = isToday;
        vm.getFilterPlaceholder = getFilterPlaceholder;
        vm.updateResourceWhiteViewSettings = updateResourceWhiteViewSettings;
        vm.defaultResourceWhiteViewSettings = ["showResources"];
        vm.loadMoreDailyTickets = loadMoreDailyTickets;
        vm.getPaginationState = getPaginationState;
        vm.attachDayViewScrollHandler = attachDayViewScrollHandler;
        var allocChangedPubSubs, messageStatusPubSubs, preScheduleStatusChangedPubSubs;

        function activate() {
            loadBrowserSetting();
            populateViewSettings();
            applyFilterViewSetting();

            // Setup infinite scroll handler
            setupInfiniteScroll();

            if (($stateParams.view !== null && $stateParams.view === "week") || dateNavigationService.isWeekly) {
                setToWeeklyView();
            } else if (($stateParams.view !== null && $stateParams.view === "day") || dateNavigationService.isDaily) {
                setToDailyView();
            }

            setupPubSubs();
            JobTagsSignalRService.register();
        }

        function loadBrowserSetting() {
            let resourceWhiteViewSettings = localStorageService.get(VIEW_SETTINGS_KEY);
            if (!resourceWhiteViewSettings) {
                initialiseResourceWhiteViewSettings();
                return;
            }
            vm.viewSettings = resourceWhiteViewSettings;
        }

        function populateViewSettings() {
            vm.filterSearchText = CardFilters.searchText;
            vm.viewSettingOptions = CardFilters.filterFields;

            vm.viewSettingOptions.forEach(option => {
                option.selected = _.includes(vm.viewSettings, option.Id);
            });
        }

        function initialiseResourceWhiteViewSettings() {
            vm.viewSettings = vm.defaultResourceWhiteViewSettings;
            localStorageService.set(VIEW_SETTINGS_KEY, vm.viewSettings);
        }

        function updateResourceWhiteViewSettings() {
            localStorageService.set(VIEW_SETTINGS_KEY, vm.viewSettings);
            applyFilterViewSetting();
        }

        function applyFilterViewSetting() {
            vm.filters.showProject = _.includes(vm.viewSettings, "showProject");
            vm.filters.showResources = _.includes(vm.viewSettings, "showResources");
            vm.filters.showRelatedTicketNumber = _.includes(vm.viewSettings, "showRelatedTicketNumber");
            vm.filters.showWorkOrderNumber = _.includes(vm.viewSettings, "showWorkOrderNumber");

            vm.applyFilter();
            vm.filters.hasFilterToApply = false;
        }

        function isToday() {
            const todayDate = moment();
            const selectedDate = dateNavigationService.data;

            if (dateNavigationService.isDaily) {
                return todayDate.diff(selectedDate, 'days') == 0;
            }

            if (dateNavigationService.isWeekly) {
                const firstDayOfWeek = angular.copy(selectedDate).weekday(0);
                const lastDayOfWeek = angular.copy(selectedDate).weekday(6);
                return todayDate.isBetween(firstDayOfWeek, lastDayOfWeek)
            }

            return false;
        }

        function setupPubSubs() {
            allocChangedPubSubs = $rootScope.$on('whiteboard:resource:allocationChanged', function(e, updatedModel) {
                whiteboardSyncService.syncAll(updatedModel, vm.dayViewComponentData, vm.weekViewComponentData, vm.sourceProperties);
            });

            preScheduleStatusChangedPubSubs = $rootScope.$on('whiteboard:resource:preScheduleStatusChanged', function(e, data) {
                data.Tickets.forEach(updatedModel => {
                    whiteboardSyncService.syncAll(updatedModel, vm.dayViewComponentData, vm.weekViewComponentData, vm.sourceProperties);
                })
            });

            messageStatusPubSubs = $rootScope.$on('urn:updateMessagingStatus', function(e, data) {
                whiteboardSyncService.syncMessageStatus(data.AllocatedResourceItemId, data.Status, vm.dayViewComponentData, vm.weekViewComponentData, vm.sourceProperties);
            });
        }

        function searchTextChange() {
            if (dateNavigationService.isWeekly) {
                // Note:
                // 1. When searching we need to pass the 'source of truth data' to filter service
                // 2. We convert it to expected virtual repeat model.
                var filteredItems = whiteboardFilterServiceRw.filter(vm.sourceProperties.weekViewSourceOfTruth, vm.filterSearchText);
                if (filteredItems != null && filteredItems.length > 0) {
                    weekViewServiceRw.convertToVirtualRepeatModel(filteredItems, dateNavigationService.getDateData()).then(function(resp) {
                        populateWeekViewData(resp);
                    });
                } else {
                    populateWeekViewData(weekViewServiceRw.getEmptyVirtualRepeatModel());
                }
            } else if (dateNavigationService.isDaily) {
                // Server-side search for day view
                searchTicketViaApi();
            }
        }

        function searchTicketViaApi() {
            var date = dateNavigationService.getDateData();
            var start = date.format();

            // If no search text, reload all data
            if (!vm.filterSearchText || vm.filterSearchText.trim() === '') {
                blockUI.start({
                    message: 'Loading...'
                });

                dayViewServiceRw.resetPagination();
                dayViewServiceRw.loadInitialTickets(start)
                    .then(function(tickets) {
                        dayViewServiceRw.computeChunkSize(vm.whiteboardContainerSize);
                        return dayViewServiceRw.convertToVirtualRepeatModel(tickets, date)
                            .then(function(viewModel) {
                                if (viewModel) {
                                    populateSourceProperties('daily', {
                                        rawData: tickets
                                    });
                                    populateDayViewData(viewModel);
                                }
                            });
                    })
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                        populateDayViewData(dayViewServiceRw.getEmptyVirtualRepeatModel());
                    })
                    .finally(function() {
                        blockUI.stop();
                    });
                return;
            }

            blockUI.start({
                message: 'Searching...'
            });

            dayViewServiceRw.searchTicket(vm.filterSearchText, start)
                .then(function(result) {
                    if (result && result.tickets && result.tickets.length > 0) {
                        // Add all results to source of truth
                        populateSourceProperties('daily', {
                            rawData: result.tickets
                        });

                        // Use server results directly — server already searched all fields including
                        // ItemName (shift/equipment type). A second client-side filter would discard
                        // results that matched only on ItemName.
                        dayViewServiceRw.convertToVirtualRepeatModel(result.tickets, date)
                            .then(function(resp) {
                                populateDayViewData(resp);
                            });
                    } else {
                        // Not found
                        populateDayViewData(dayViewServiceRw.getEmptyVirtualRepeatModel());
                    }
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                    populateDayViewData(dayViewServiceRw.getEmptyVirtualRepeatModel());
                })
                .finally(function() {
                    blockUI.stop();
                });
        }

        $scope.$on('$destroy', function() {
            vm.weekViewHeaderDates = [];
            vm.weekViewComponentData = [];
            vm.dayViewComponentData = [];
            vm.sourceProperties.cleanup();
            vm.dataCount = 0;

            vm.filter = null
            vm.ticketParam = null;
            vm.calendarMoBehavior = null;
            vm.currentMonthShort = null;
            vm.dateNavigationBehavior = null;
            vm.scrollHandler = null;
            vm.filters = null;
            vm.whiteboardIcon = null;
            vm.isNavigating = null;

            allocChangedPubSubs();
            messageStatusPubSubs();
            preScheduleStatusChangedPubSubs();
        });

        function next() {
            vm.showRefreshButton = false;
            loadTickets();
        }

        function prev() {
            vm.showRefreshButton = false;
            loadTickets();
        }

        function onChangeCalendar() {
            loadTickets();
        }

        function onChangeView(e) {
            setToDailyView(e);
        }

        function loadTickets() {
            if (dateNavigationService.isWeekly) {
                loadTicketsByWeek();
            } else if (dateNavigationService.isDaily) {
                loadTicketsByDay()
            }
        }

        function loadTicketsByDay() {
            let date = dateNavigationService.getDateData();

            getScreenSize().then(function(_) {
                vm.isNavigating = false;

                forceResetDailyComponentData();

                // If there's an active search, use server-side search on the new day
                if (vm.filterSearchText && vm.filterSearchText.trim() !== '') {
                    searchTicketViaApi();
                    vm.isNavigating = true;
                    return;
                }

                blockUI.start({
                    message: 'Loading Daily View...'
                });

                // Phase 1.4: Use new pagination-aware loadInitialTickets
                var start = date.format();
                dayViewServiceRw.loadInitialTickets(start)
                    .then(function(tickets) {
                        dayViewServiceRw.computeChunkSize(vm.whiteboardContainerSize);
                        // Build the view model from tickets
                        return dayViewServiceRw.convertToVirtualRepeatModel(tickets, date)
                            .then(function(viewModel) {
                                if (viewModel) {
                                    $timeout(function() {
                                        // Populate source of truth with raw tickets
                                        populateSourceProperties('daily', {
                                            rawData: tickets
                                        });
                                        populateDayViewData(viewModel);
                                        vm.isNavigating = true;
                                        blockUI.stop();
                                    });
                                } else {
                                    vm.isNavigating = true;
                                    blockUI.stop();
                                }
                            });
                    }).catch(function(ex) {
                        vm.isNavigating = true;
                        blockUI.stop();
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Day view: ' + ex.errorInfo);
                                return {};
                            }
                        });
                    });
            });
        }

        function loadTicketsByWeek() {
            let date = dateNavigationService.getDateData();

            vm.isNavigating = false;

            forceResetWeekComponentData();

            blockUI.start({
                message: 'Loading Weekly View...'
            });

            if (vm.filterSearchText) {
                weekViewServiceRw.loadWeeklyRawData({
                        momentDate: date,
                        weekDateText: dateNavigationService.getWeeklyDate()
                    }, vm.whiteboardType)
                    .then(function(resp) {
                        if (resp) {
                            $timeout(function() {
                                populateSourceProperties('weekly', {
                                    rawData: resp
                                });
                                searchTextChange();
                            })
                        }
                        // This will refresh the virtual repeat
                        angular.element(window).triggerHandler('resize');
                    }).catch(function(ex) {
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Week view: ' + ex.errorInfo);
                                return {};
                            }
                        });
                    }).finally(function() {
                        vm.isNavigating = true;
                        blockUI.stop();
                    });
            } else {
                weekViewServiceRw.loadWeeklyData({
                        momentDate: date,
                        weekDateText: dateNavigationService.getWeeklyDate()
                    }, vm.whiteboardType)
                    .then(function(resp) {
                        // If no data dont resize
                        if (resp) {
                            // Populate source of truth
                            $timeout(function() {
                                populateSourceProperties('weekly', resp);
                                populateWeekViewData(resp);

                                // This will refresh the virtual repeat
                                angular.element(window).triggerHandler('resize');
                            });
                        }
                    }).catch(function(ex) {
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Week view: ' + ex.errorInfo);
                                return {};
                            }
                        });
                    }).finally(function() {
                        vm.isNavigating = true;
                        blockUI.stop();
                    });
            }
        }

        function refreshData() {
            if (dateNavigationService.isWeekly) {
                setToWeeklyView();
            } else if (dateNavigationService.isDaily) {
                setToDailyView();
            }
            vm.showRefreshButton = false;
        }

        /**
         * Component onRender refresh
         * Note: Specific to Monthly view only
         */
        function onRender(calViewObj) {
            vm.dateNavigationBehavior.setTitle(calViewObj.title);
        }

        function setToday() {
            dateNavigationService.setToday();
            vm.dateNavigationBehavior.refresh();
            loadTickets();
        }

        function setToDailyView() {
            dateNavigationService.setViewMode('Daily');
            (vm.dateNavigationBehavior.refresh || angular.noop)();
            loadTicketsByDay();
        }

        function setToWeeklyView() {
            dateNavigationService.setViewMode('Weekly');
            (vm.dateNavigationBehavior.refresh || angular.noop)();
            loadTicketsByWeek();
        }

        function forceResetWeekComponentData() {
            $timeout(function() {
                vm.sourceProperties.weekViewSourceOfTruth = [];
                vm.weekViewHeaderDates = [];
                vm.weekViewComponentData = [];
                vm.dataCount = 0;
            });
        }

        function forceResetDailyComponentData() {
            $timeout(function() {
                vm.sourceProperties.dayViewSourceOfTruth = [];
                vm.dayViewComponentData = [];
                vm.dataCount = 0;
                vm.totalCount = null;
                vm.isLoadingCount = false;
            });
        }

        function fetchTotalCountAsync(start) {
            vm.isLoadingCount = true;

            dayViewServiceRw.fetchTotalCount(start)
                .then(function(count) {
                    $timeout(function() {
                        vm.totalCount = count;
                        vm.isLoadingCount = false;
                    });
                })
                .catch(function() {
                    $timeout(function() {
                        vm.isLoadingCount = false;
                    });
                });
        }

        function resetCommonFlags() {
            vm.isDaily = false;
            vm.isWeekly = false;
        }

        function populateSourceProperties(wbType, data) {
            if (wbType == 'weekly') {
                vm.sourceProperties.weekViewSourceOfTruth = [];
                angular.forEach(data.rawData, function(o) {
                    vm.sourceProperties.weekViewSourceOfTruth.push(o);
                }, this);
            } else if (wbType == 'daily') {
                vm.sourceProperties.dayViewSourceOfTruth = [];
                angular.forEach(data.rawData, function(o) {
                    vm.sourceProperties.dayViewSourceOfTruth.push(o);
                }, this);
            }
        }

        // New way of binding
        function populateWeekViewData(data) {
            resetCommonFlags();
            vm.weekViewHeaderDates = [];
            vm.weekViewComponentData = [];
            vm.dataCount = data.count;
            vm.navWhiteboardTypeText = dateNavigationService.getWhiteboardTypeText();
            vm.isWeekly = true;
            vm.allowGroupByClient = vm.filters.allowGroupByClient;
            vm.showProject = vm.filters.showProject;
            vm.showResources = vm.filters.showResources;
            vm.showRelatedTicketNumber = vm.filters.showRelatedTicketNumber;
            vm.showWorkOrderNumber = vm.filters.showWorkOrderNumber;

            if (data.headerDates) {
                data.headerDates.forEach(o => {
                    vm.weekViewHeaderDates.push(o);
                });
            }

            if (data.data) {
                data.data.forEach(o => {
                    vm.weekViewComponentData.push(o);
                });
            }

            whiteboardResizeServiceRw.adjustElementTicketHeaderSize();
        }

        function populateDayViewData(data) {
            resetCommonFlags();
            vm.dayViewComponentData = [];
            vm.isDaily = true;
            vm.allowGroupByClient = vm.filters.allowGroupByClient;
            vm.showProject = vm.filters.showProject;
            vm.showResources = vm.filters.showResources;
            vm.showRelatedTicketNumber = vm.filters.showRelatedTicketNumber;
            vm.showWorkOrderNumber = vm.filters.showWorkOrderNumber;
            vm.navWhiteboardTypeText = dateNavigationService.getWhiteboardTypeText();

            vm.dayViewHeaderText = data.day;
            vm.dayCurrentDate = data.date;
            vm.dataCount = data.count;
            vm.totalCount = data.totalCount;

            if (data.data) {
                data.data.forEach(o => {
                    vm.dayViewComponentData.push(o);
                });
            }

            whiteboardResizeServiceRw.setDefaultContentSizeForDayView();
        }

        function toggleFilters() {
            vm.filters.filterIsOpen = !vm.filters.filterIsOpen;
        }

        /**
         * Apply filtering this will trigger a server side fetch
         */
        function applyFilter() {
            if (dateNavigationService.isWeekly) {
                blockUI.start({
                    message: 'Filtering Week View data...'
                });

                weekViewServiceRw.applyWeekFilter(dateNavigationService.getDateData(), dateNavigationService.getWeeklyDate(), vm.whiteboardType, true)
                    .then(function(resp) {
                        blockUI.stop();
                        if (resp) {
                            populateSourceProperties('weekly', {
                                rawData: resp
                            });
                            searchTextChange();
                            whiteboardResizeServiceRw.adjustElementTicketHeaderSize();
                        }
                    }).catch(function(ex) {
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Week view: ' + ex.errorInfo);
                            }
                        });
                    }).finally(function() {
                        blockUI.stop();
                    });

            } else if (dateNavigationService.isDaily) {
                blockUI.start({
                    message: 'Filtering Day View Data...'
                });

                whiteboardResizeServiceRw.setDefaultContentSizeForDayView();

                // Phase 1.4: Reset pagination and use loadInitialTickets when filters change
                dayViewServiceRw.resetPagination();

                var date = dateNavigationService.getDateData();
                var start = date.format();

                dayViewServiceRw.loadInitialTickets(start)
                    .then(function(tickets) {
                        dayViewServiceRw.computeChunkSize(vm.whiteboardContainerSize);
                        // Build the view model from tickets
                        return dayViewServiceRw.convertToVirtualRepeatModel(tickets, date)
                            .then(function(viewModel) {
                                if (viewModel) {
                                    populateSourceProperties('daily', {
                                        rawData: tickets
                                    });
                                    // If there's search text, apply it
                                    if (vm.filterSearchText) {
                                        searchTextChange();
                                    } else {
                                        populateDayViewData(viewModel);
                                    }
                                    whiteboardResizeServiceRw.setDefaultContentSizeForDayView();

                                    // Re-attach scroll handler after view is rendered
                                    $timeout(function() {
                                        vm.attachDayViewScrollHandler();
                                    }, 200);
                                }
                            });
                    }).catch(function(ex) {
                        exceptionService.resolve(ex, {
                            intercept404: function(ex) {
                                $log.warn('Day view: ' + ex.errorInfo);
                            }
                        });
                    }).finally(function() {
                        blockUI.stop();
                    });
            }
        }

        function getFilterPlaceholder(text, model) {
            return "<div class='filter-placeholder'>" + text + " <span class='filter-counter'>" + _.size(model) + "</span></div>";
        };

        // Phase 1.4: Load more tickets (pagination)
        function loadMoreDailyTickets() {
            if (!dateNavigationService.isDaily) {
                return;
            }

            var paginationState = dayViewServiceRw.getPaginationState();
            if (!paginationState.hasMore || paginationState.isLoading) {
                return;
            }

            blockUI.start({
                message: 'Loading more tickets...'
            });

            var date = dateNavigationService.getDateData();
            var start = date.format();

            dayViewServiceRw.loadMoreTickets(start)
                .then(function(newTickets) {
                    if (newTickets && newTickets.length > 0) {
                        // Append new tickets to source of truth
                        var currentRawData = vm.sourceProperties.dayViewSourceOfTruth;
                        var updatedRawData = currentRawData.concat(newTickets);

                        // Update source of truth
                        vm.sourceProperties.dayViewSourceOfTruth = updatedRawData;

                        // Convert all tickets to view model
                        return dayViewServiceRw.convertToVirtualRepeatModel(updatedRawData, date)
                            .then(function(viewModel) {
                                if (viewModel) {
                                    // If there's search text, reapply the filter
                                    if (vm.filterSearchText) {
                                        searchTextChange();
                                    } else {
                                        populateDayViewData(viewModel);
                                    }
                                }
                            });
                    } else {
                        // Return resolved promise to continue chain
                        return Promise.resolve();
                    }
                }).catch(function(ex) {
                    exceptionService.resolve(ex, {
                        intercept404: function(ex) {
                            $log.warn('Day view load more: ' + ex.errorInfo);
                        }
                    });
                }).finally(function() {
                    // Use $timeout to ensure it runs in digest cycle
                    $timeout(function() {
                        blockUI.stop();
                    }, 0);
                });
        }

        // Phase 1.4: Get pagination state for UI
        function getPaginationState() {
            return dayViewServiceRw.getPaginationState();
        }

        // Function to attach scroll handler to day view container
        function attachDayViewScrollHandler() {
            // md-virtual-repeat-container creates an internal scroller
            var dayViewContainer = document.querySelector('#dayview-vertical-container');
            var scroller = dayViewContainer ? dayViewContainer.querySelector('.md-virtual-repeat-scroller') : null;

            // Use the internal scroller if it exists, otherwise fall back to container
            var scrollElement = scroller || dayViewContainer;

            if (scrollElement && vm.scrollHandler) {
                // Remove existing listener first to avoid duplicates
                scrollElement.removeEventListener('scroll', vm.scrollHandler);
                scrollElement.addEventListener('scroll', vm.scrollHandler);
            }
        }

        // Setup infinite scroll handler
        function setupInfiniteScroll() {
            // Remove existing handler if any
            if (vm.scrollHandler) {
                var content = document.querySelector('.content.md-default-theme');
                if (content) {
                    content.removeEventListener('scroll', vm.scrollHandler);
                }
            }

            var scrollDebounceTimer;
            var lastScrollTop = 0;

            // Create new scroll handler with debounce
            vm.scrollHandler = function() {
                // Use day view container for daily view, otherwise use main content
                var content;
                if (dateNavigationService.isDaily) {
                    var container = document.querySelector('#dayview-vertical-container');
                    // Look for internal scroller first
                    content = container ? container.querySelector('.md-virtual-repeat-scroller') : null;
                    // Fall back to container if no internal scroller
                    if (!content) content = container;
                } else {
                    content = document.querySelector('.content.md-default-theme');
                }

                if (!content) return;

                var scrollTop = content.scrollTop;

                // Only trigger if scrolling down
                if (scrollTop <= lastScrollTop) {
                    lastScrollTop = scrollTop;
                    return;
                }
                lastScrollTop = scrollTop;

                // Clear existing timer
                if (scrollDebounceTimer) {
                    clearTimeout(scrollDebounceTimer);
                }

                // Debounce scroll events (wait 150ms after scrolling stops)
                scrollDebounceTimer = setTimeout(function() {
                    var scrollHeight = content.scrollHeight;
                    var clientHeight = content.clientHeight;
                    var scrollThreshold = 200; // Trigger when 200px from bottom
                    var distanceFromBottom = scrollHeight - scrollTop - clientHeight;

                    // Check if near bottom and should load more
                    if (distanceFromBottom < scrollThreshold) {
                        var paginationState = dayViewServiceRw.getPaginationState();

                        if (paginationState.hasMore && !paginationState.isLoading && vm.isDaily) {
                            loadMoreDailyTickets();
                        }
                    }
                }, 150);
            };

            // Initial attachment
            $timeout(function() {
                attachDayViewScrollHandler();

                // Also attach to main content for week view
                var content = document.querySelector('.content.md-default-theme');
                if (content) {
                    content.addEventListener('scroll', vm.scrollHandler);
                }
            }, 100);
        }

        function addTicket() {
            $state.go('app.jobs_manage', {
                dt: dateNavigationService.getNewJobDate()
            });
        }

        function openMenu($mdMenu, ev) {
            $mdMenu.open(ev);
        }

        function onDayViewCancelTicket(cancelledTickets) {
            setToDailyView();
        }

        function onWeekViewCancelTicket(cancelledTickets) {
            setToWeeklyView();
        }

        // Resizing of window only affects the Day View
        // It computes the how many ticket items to display in virtual repeat row
        function getScreenSize() {
            var deferred = $q.defer();
            if (!vm.whiteboardContainerSize) {
                $timeout(function() {
                    var contentEl = angular.element('#wb-content1');
                    vm.whiteboardContainerSize = contentEl.width();
                    deferred.resolve();
                })
            } else {
                $timeout(function() {
                    deferred.resolve();
                });
            }

            return deferred.promise;
        }

        activate();
    }
})();

/**
 * SignalR service
 *
 * Rcnet 12.18.2018
 */
(function () {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .service('whiteboardSyncService', whiteboardSyncService);

    /** @ngInject */
    function whiteboardSyncService($timeout, jobsWhiteboardApi2, $rootScope, _, ToastService) {
        var service = {
            syncAll: syncAll,
            syncMessageStatus: syncMessageStatus,
            syncMessages : syncMessages
        };

        var shown = false;

        return service;

        ///////
        /**
         * Mutate object, Note: Mutation is a bad thing, instead of doing it, should rather follow immutable objects like Redux Style of coding.
         * For this project we just do what it takes to meet user requirements. Enough talking :) lol
         */
        function syncAll(updatedModel, dayViewComponentData, weekViewComponentData, sourceProps) {
            // Update actual view models
            updateDayViewData(updatedModel, dayViewComponentData);
            updateWeekViewData(updatedModel, weekViewComponentData);

            // Update cached data
            updateSourceOfTruthData(updatedModel, sourceProps);

            shown = false;
        }

        function syncMessageStatus(ariId, status, dayViewComponentData, weekViewComponentData, sourceProps) {
            updateStatusDayViewData(ariId, status, dayViewComponentData);
            updateStatusWeekViewData(ariId, status, weekViewComponentData);
            updateStatusSourceOfTruthData(ariId, status, sourceProps);
        }

        // ====================================
        //  Update Resource Allocation Data
        // ====================================
        function syncMessages(payLoad, dayViewComponentData, weekViewComponentData, sourceProps) {

            let ticket_id = null;
            let ticket_status = null;
            let items = [];

            let data = angular.copy(dayViewComponentData);

            //Temp - to get ticket number
            angular.forEach(data, function(source) {
                angular.forEach(source, function(ticket) {
                    angular.forEach(ticket.allocatedResourceItems, function(itm) {
                        if(itm.id === payLoad.AllocatedResourceItemId){
                            ticket_id = ticket.id;
                            ticket_status = ticket.status[0].id
                        }
                    });
                });
            });

            //To get items
            angular.forEach(data, function(source) {
                angular.forEach(source, function(tickets) {
                    angular.forEach(tickets.allocatedResourceItems, function(itm) {
                        if(itm.id === payLoad.AllocatedResourceItemId){
                            itm.messageStatus = payLoad.Status;
                        }
                    });
                });
            });

            data.forEach(function(itm) {
                itm.forEach(function(ticket) {
                    if(ticket.id === ticket_id){
                        items = ticket.allocatedResourceItems;
                    }
                });
            });

            let finalData = {
                AllocatedResourceItems : items,
                Status : ticket_status,
                TicketId : ticket_id
            }

            updateDayViewData(finalData, dayViewComponentData);
            updateWeekViewData(finalData, weekViewComponentData);
            //updateSourceOfTruthData(finalData, sourceProps);

            shown = false;
        }

        function updateDayViewData(updatedModel, dayViewData) {
            $timeout(function () {
                if (dayViewData.length <= 0) return;

                _.forEach(dayViewData, function(dayViewDataRow, key) {
                    dayViewDataRow.map(function (o) {
                        if (updatedModel.TicketId == o.id) {
                            toastDisplay();
                            var statInfo = [updatedModel.Status];
                            o.status = getStatusByArray(statInfo);
                            o.IsLockedByPreSchedule = updatedModel.IsLockedByPreSchedule;
                            o.allocatedResourceItems = sanitizeMapValues(updatedModel.AllocatedResourceItems)
                        }
                    });
                });
            });
        }

        function updateWeekViewData(updatedModel, weekViewData) {
            $timeout(function () {
                weekViewData.map(function (o) {
                    var statInfo = [updatedModel.Status];
                    for (var i = 0; i <= 6; i++) {
                        if (_.isNil(o['day' + i])) continue;
                        if (o['day' + i].id == updatedModel.TicketId) {
                            toastDisplay();
                            o['day' + i].status = getStatusByArray(statInfo);
                            o['day' + i].IsLockedByPreSchedule = updatedModel.IsLockedByPreSchedule;
                            o['day' + i].allocatedResourceItems = sanitizeMapValues(updatedModel.AllocatedResourceItems)
                        }
                    }
                });
            });
        }

        function updateSourceOfTruthData(updatedModel, sourceProps) {
            var sources = ['dayViewSourceOfTruth', 'weekViewSourceOfTruth'];
            sources.map(function (key) {
                sourceProps[key].map(function (o) {
                    if (updatedModel.TicketId == o.Id) {
                        toastDisplay();
                        var statInfo = [updatedModel.Status];
                        o.Status = getStatusByArray(statInfo);
                        o.IsLockedByPreSchedule = updatedModel.IsLockedByPreSchedule;
                        o.allocatedResourceItems = Object.assign({}, o.AllocatedResourceItems, updatedModel.AllocatedResourceItems);
                        angular.forEach(o.allocatedResourceItems, function(line){
                            line['ResourceType'] = line.ItemType === 4 ? 0 : 1;
                        })
                    }
                });
            });
        }


        // =============================
        //   Update Message Status
        // =============================
        function updateStatusDayViewData(ariId, status, dayViewData) {
            $timeout(function () {
                if (dayViewData.length <= 0) return;
                dayViewData[0].map(function (o) {
                    o.allocatedResourceItems.map(function (resourceItem) {
                        // Note: Need to verify if this is the correct status!!!
                        var resItem = _.includes(resourceItem, ariId);
                        if (resItem) {
                            resourceItem.messageStatus = status;
                        }
                    });
                });
            });
        }

        function updateStatusWeekViewData(ariId, status, weekViewData) {
            $timeout(function () {
                weekViewData.map(function (o) {
                    for (var i = 0; i <= 6; i++) {
                        if (_.isNil(o['day' + i])) continue;

                        o['day' + i].allocatedResourceItems.map(function (resourceItem) {
                            var resItem = _.includes(resourceItem, ariId);
                            if (resItem) {
                                resourceItem.messageStatus = status;
                            }
                        });
                    }
                });
            });
        }

        function updateStatusSourceOfTruthData(ariId, status, sourceProps) {
            var sources = ['dayViewSourceOfTruth', 'weekViewSourceOfTruth'];
            sources.map(function (key) {
                sourceProps[key].map(function (resourceItem) {
                    resourceItem.AllocatedResourceItems.map(function(allocResource) {
                        var resItem = _.includes(allocResource, ariId);
                        if (resItem) {
                            allocResource.MessageStatus = status;
                        }
                    });
                });
            });
        }

        // ==================
        //  Helpers
        // ==================
        function getStatusByArray(arr) {
            return jobsWhiteboardApi2.getStatusInfoByArray(arr);
        }

        function sanitizeMapValues(resourceItems) {
            var results = [];
            resourceItems.map(function (res) {
                let obj = {};
                for (var p in res) {
                    obj[_.camelCase(p)] = res[p];
                }
                results.push(obj);
            });

            return results;
        }

        function toastDisplay() {
            if (shown) return;
            shown = true;
            ToastService.toast('Synchronising data...');
        }
    };
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.resourceWhiteboard')
        .factory('whiteboardResizeServiceRw', whiteboardResizeServiceRw);

    /** @ngInject */
    function whiteboardResizeServiceRw($timeout) {
        var service = {
            setDefaultContentSizeForDayView: setDefaultContentSizeForDayView,
            adjustContentSizeForDayView: adjustContentSizeForDayView,
            adjustElementTicketHeaderSize: adjustElementTicketHeaderSize,
        };

        activate();

        return service;
        ///////

        function activate() { }


        function adjustContentSizeForDayView() {
            $timeout(function () {
                var boardEl = angular.element('#rwDailyboard');
                var boardElHeight = boardEl.height();

                var result = document.getElementsByClassName('ticket-container');
                var wrappedResult = angular.element(result);

                angular.forEach(wrappedResult, function (elem) {
                    $(elem).css("min-height", boardElHeight + 'px');
                }, this);
            });
        }

        function setDefaultContentSizeForDayView() {
            $timeout(function () {
                var boardEl = angular.element('#rwDailyboard');
                var boardElHeight = boardEl.height();
                var boardElWidth = boardEl.width();

                var cardContainerElem = angular.element('#day-view-cards-container');
                $(cardContainerElem).css('height', (boardElHeight-70) + 'px');

                var dayViewVirtualContainerElem = angular.element('#dayview-vertical-container');
                $(dayViewVirtualContainerElem).css('height', (boardElHeight-90) + 'px');
            });
        }

         /**
         * Adjust ticket container height
         * For Week View and Day view
         */
        function adjustElementTicketHeaderSize() {
            $timeout(function () {

                // var wbEl = angular.element('#board');
                // var wbElHeight = wbEl.height();

                // var boardEl = angular.element('#board');
                // $(boardEl).css('min-height', wbElHeight + 'px');

                //var boardElHeight = boardEl.height();

                // Adjust columns per week
                var result = document.getElementsByClassName('ticket-container');
                var wrappedResult = angular.element(result);

                angular.forEach(wrappedResult, function (elem) {
                    $(elem).css("min-height", '100%'); //boardElHeight + 'px');
                }, this);

                // Adjust virtual scroll container
                var computedHeightVirtualRepeat = angular.element(wrappedResult[0]).height();
                var verticalContainerElem = angular.element('#vertical-container');
                $(verticalContainerElem).css("height", (computedHeightVirtualRepeat-80) + 'px'); //221

                //var dropzone = document.getElementsByClassName('ticket-dropzone');
                // React element DropZoneArea-dropping
                // var dropzone = document.getElementsByClassName('DropZoneArea-dropping');
                // var dropzoneResult = angular.element(dropzone);
                // angular.forEach(dropzoneResult, function (elem) {
                //     $(elem).css("min-height", (boardElHeight - 100) + 'px');
                // }, this);

            });
        }
    }
})();



/**
 * SignalR service
 *
 * Rcnet 12.10.2018
 */
(function () {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .service('whiteboardHubServiceRw', whiteboardHubServiceRw);

    /** @ngInject */
    function whiteboardHubServiceRw($log, signalRService, $rootScope, msgboxService) {
        var service = {
            register: register
        };

        var isInitialized = false; // To prevent double subscription to event

        return service;

        ///////
        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function () {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }
        }

        function regs() {
            signalRService.messageHub.on('allocationChanged', function (data) {
                $log.log('Message Hub: Resource Whiteboard synchronization triggered.');
                $rootScope.$broadcast('whiteboard:resource:allocationChanged', data);
            });

            signalRService.messageHub.on('preScheduleStatusChanged', function (data) {
                $log.log('Message Hub: Resource Whiteboard - Pre Schedule Status changed.');
                $rootScope.$broadcast('whiteboard:resource:preScheduleStatusChanged', data);
            });

            signalRService.messageHub.on('messagingStatusChanged', function (data) {
                $log.log('Message Hub: Resource Whiteboard - Message Status Changed.');
                $rootScope.$broadcast('whiteboard:resource:message', data);
            });
        }
    };
})();


/**
 * Whiteboard filter service
 *
 * Rcnet 7.26.2018
 */
(function () {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .service('whiteboardFilterServiceRw', whiteboardFilterServiceRw);

    /** @ngInject */
    function whiteboardFilterServiceRw() {

        var service = {
            filter: filter
        };

        // Searchable props for names

        return service;

        ///////
        function filter(collection, searchText) {
            var out = [];

            // Iterate in every search properties
            if (collection.length > 0) {

                if (!searchText) {
                    return collection;
                }

                var searchKeywords = [searchText];
                var tmpCollection = collection;
                var allNumeric = isAllNumericKeyword(searchKeywords);
                var maxSearchableNameProps = Math.max.apply(null, tmpCollection.map(t => t.AllocatedResourceItems.length));

                if (!allNumeric) {
                    searchKeywords.forEach(function (keyword) {
                        if (keyword) {
                            var sql = "select * from ?";
                            sql += keyword != null ? " where BranchName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or CompanyName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or BranchState like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or TicketNumber like '" + keyword + "%'" : '';
                            sql += keyword != null ? " or JobLocationAddress like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or StartDate like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or ProjectName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or RelatedTicketNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or ParentTicketNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or PurchaseOrderNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or WorkOrderNumber like '%" + keyword + "%'" : '';
                            sql += createNameQuery(keyword, maxSearchableNameProps);
                            sql += createShiftNameQuery(keyword, maxSearchableNameProps);

                            var result = alasql(sql, [tmpCollection]);

                            tmpCollection = [];
                            result.forEach(function (itm) {
                                tmpCollection.push(itm);
                            });
                        }
                    });

                    tmpCollection.forEach(function (itm) {
                        out.push(itm);
                    });

                    out = _.uniqBy(out, function (o) {
                        return o.Id;
                    });
                } else {
                    // For numeric
                    searchKeywords.forEach(function (keyword) {
                        if (keyword) {
                            var sql = "select * from ?";
                            sql += keyword != null ? " where BranchName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or CompanyName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or BranchState like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or TicketNumber like '" + keyword + "%'" : '';
                            sql += keyword != null ? " or JobLocationAddress like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or StartDate like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or ProjectName like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or RelatedTicketNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or ParentTicketNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or PurchaseOrderNumber like '%" + keyword + "%'" : '';
                            sql += keyword != null ? " or WorkOrderNumber like '%" + keyword + "%'" : '';
                            sql += createNameQuery(keyword, maxSearchableNameProps);
                            sql += createShiftNameQuery(keyword, maxSearchableNameProps);

                            var result = alasql(sql, [collection]);

                            result.forEach(function (itm) {
                                out.push(itm);
                            });
                        }
                    });
                    out = _.uniqBy(out, function (o) {
                        return o.Id;
                    });
                }
            }

            return out;
        }

        function createNameQuery(keyword, maxSearchableNameProps) {
            var sql = '';
            for (var i = 1; i <= maxSearchableNameProps; i++) {
                sql += " or n" + i + " like '%" + keyword + "%'";
            }
            return sql;
        }

        function createShiftNameQuery(keyword, maxSearchableNameProps) {
            var sql = '';
            for (var i = 1; i <= maxSearchableNameProps; i++) {
                sql += " or sn" + i + " like '%" + keyword + "%'";
            }
            return sql;
        }

        function isAllNumericKeyword(keywords) {
            var f = _.filter(keywords, function (o) {
                return !isFinite(o);
            }).length;

            return f <= 0;
        }

    };
})();

(function() {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .factory('whiteboardClaimsServiceRw', whiteboardClaimsServiceRw);

    /** @ngInject */
    function whiteboardClaimsServiceRw($rootScope, claimsUtilService) {
        var service = {
            disableBillingPref: false
        };

        activate();

        return service;

        function activate() {
            $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                applyClaimsRules();
            });

            applyClaimsRules();
        }

        function applyClaimsRules() {
            service.disableBillingPref = !claimsUtilService.checkAccessByRole('Ticket Billing Preferences');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.resourceWhiteboard')
        .factory('weekViewServiceRw', weekViewServiceRw);

    /** @ngInject */
    function weekViewServiceRw(
        _,
        ticketItemModelRw,
        utils,
        jobBoardWeeklyService,
        CardFilters,
        alasql,
        $q,
        localisationService,
        resourceWhiteboardApi,
        jobsWhiteboardApi2,
        moment,
        claimsUtilService,
        exceptionService,
        preScheduleApi
    ) {
        var service = {
            settings: {
                bgcolor: 'bg-whiteboard2'
            },
            loadWeeklyData: loadWeeklyData,
            applyWeekFilter: applyWeekFilter,
            convertToVirtualRepeatModel: convertToVirtualRepeatModel,
            getEmptyVirtualRepeatModel: getEmptyVirtualRepeatModel,
            loadWeeklyRawData: loadWeeklyRawData,
            getGeneratedPreScheduleJobStatus: getGeneratedPreScheduleJobStatus,
            getPreScheduleJobStatusInfo: getPreScheduleJobStatusInfo
        };

        var localeSettings = [];
        const SMART_SCHEDULE_IN_PROGRESS = [7];
        const SMART_SCHEDULE_IS_DONE = [8];
        const SMART_SCHEDULE_IS_DONE_AND_READY_TO_GO = [9];
        const SMART_SCHEDULE_IS_DONE_AND_COMPLETED = [10];

        const READY_TO_GO = 2;
        const COMPLETED = 1;

        const PREALLOCATE_CALLBACK_FAILED = 4;

        activate();

        return service;

        function activate() {
            localeSettings = localisationService.getLocaleFormatSettings();
        }

        function loadWeeklyData(options, wboardType) {
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                weekDateText: '',
                invokedBy: null
            }, opts);

            var weeklyData = new ticketItemModelRw();
            let ticketHeaders = jobBoardWeeklyService.prepareTicketListHeader(settings.momentDate);

            angular.forEach(ticketHeaders, function(o) {
                weeklyData.lists.push(o);
            }, this);

            var start = utils.jsDateTime(weeklyData.lists[0].headerDate, 'MM/DD/YYYY');
            var end = utils.jsDateTime(weeklyData.lists[6].headerDate, 'MM/DD/YYYY');

            return enrichData(start, end, wboardType);
        }

        function loadWeeklyRawData(options, wboardType) {
            let deferred = $q.defer();
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                weekDateText: '',
                invokedBy: null
            }, opts);

            var weeklyData = new ticketItemModelRw();
            let ticketHeaders = jobBoardWeeklyService.prepareTicketListHeader(settings.momentDate);

            angular.forEach(ticketHeaders, function(o) {
                weeklyData.lists.push(o);
            }, this);

            var start = utils.jsDateTime(weeklyData.lists[0].headerDate, 'MM/DD/YYYY');
            var end = utils.jsDateTime(weeklyData.lists[6].headerDate, 'MM/DD/YYYY');

            // Force resources so AllocatedResourceItems are available for client-side search indexing
            let ticketPromise = getTicketsPerWeek(start, end, wboardType, true);

            ticketPromise.then(async function(resp) {
                let preScheduleJobIds = resp.data.map(ticket => {
                    if(ticket.PreScheduleJobId){
                        return ticket.PreScheduleJobId;
                    }
                }).filter(Boolean);

                if (preScheduleJobIds.length > 0)
                {
                    let preScheduleJobStatuses = await preScheduleApi.getGeneratedPreScheduleJobStatus(preScheduleJobIds);

                    resp.data.forEach(itm => {
                        if (itm.PreScheduleJobId && !itm.AllResourceAllocationsConfirmed || (itm.TicketType == 1 && itm.StatusList == READY_TO_GO)) {
                            itm.StatusList = itm.IsLockedByPreSchedule ? SMART_SCHEDULE_IN_PROGRESS : SMART_SCHEDULE_IS_DONE;
                        }
                        else if(itm.PreScheduleJobId && itm.StatusList == READY_TO_GO) {
                            itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_READY_TO_GO;
                        }
                        else if(itm.PreScheduleJobId && itm.StatusList == COMPLETED) {
                            itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_COMPLETED;
                        }

                        let preScheduleJobStatus = getPreScheduleJobStatusInfo(preScheduleJobStatuses, itm.PreScheduleJobId);
                        itm.isSmartSchedulingFailed = preScheduleJobStatus == PREALLOCATE_CALLBACK_FAILED;
                    })
                }
                deferred.resolve(!CardFilters.allowGroupByClient ? attachNameIndex(resp.data) : resp.data);
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function applyWeekFilter(momentDate, weekDateText, wboardType, skipMappingToVirtualRepeatModel) {
            if (!skipMappingToVirtualRepeatModel)
                return loadWeeklyData({
                    momentDate: momentDate,
                    destroyCache: true,
                    weekDateText: weekDateText,
                    invokedBy: 'filter'
                }, wboardType);
            else
                return loadWeeklyRawData({
                    momentDate: momentDate,
                    destroyCache: true,
                    weekDateText: weekDateText,
                    invokedBy: 'filter'
                }, wboardType);
        }

        function enrichData(start, end, wboardType) {
            let deferred = $q.defer();

            let ticketPromise = getTicketsPerWeek(start, end, wboardType);

            ticketPromise.then(async function(resp) {
                if (utils.isUndefinedOrNull(resp.data)) {
                    deferred.resolve({
                        data: null,
                        count: 0
                    });
                    return;
                }

                if(claimsUtilService.isSmartSchedulingEnabled()){
                    let preScheduleJobIds = resp.data.map(ticket => {
                        if(ticket.PreScheduleJobId){
                            return ticket.PreScheduleJobId;
                        }
                    }).filter(Boolean);

                    if (preScheduleJobIds.length > 0)
                    {
                        let preScheduleJobStatuses = await preScheduleApi.getGeneratedPreScheduleJobStatus(preScheduleJobIds);
                    
                        resp.data.forEach(itm => {
                            if (itm.PreScheduleJobId && !itm.AllResourceAllocationsConfirmed || (itm.TicketType == 1 && itm.StatusList == READY_TO_GO)) {
                                itm.StatusList = itm.IsLockedByPreSchedule ? SMART_SCHEDULE_IN_PROGRESS : SMART_SCHEDULE_IS_DONE;
                            }
                            else if(itm.PreScheduleJobId && itm.StatusList == READY_TO_GO) {
                                itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_READY_TO_GO;
                            }
                            else if(itm.PreScheduleJobId && itm.StatusList == COMPLETED) {
                                itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_COMPLETED;
                            }

                            let preScheduleJobStatus = getPreScheduleJobStatusInfo(preScheduleJobStatuses, itm.PreScheduleJobId);
                            itm.isSmartSchedulingFailed = preScheduleJobStatus == PREALLOCATE_CALLBACK_FAILED;
                        })
                    }
                }

                let weeklyData = await buildWeeklyRawData(resp.data, start, CardFilters.allowGroupByClient)
                let headerDates = constructWeekHeaderDates(weeklyData);
                let weekViewSource = buildVirtualRepeatViewModel(weeklyData);

                deferred.resolve({
                    headerDates: headerDates,
                    data: weekViewSource,
                    rawData: !CardFilters.allowGroupByClient ? attachNameIndex(resp.data) : resp.data,
                    count: resp.data.length
                });

            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function getTicketsPerWeek(start, end, wboardType, forceIncludeResources) {
            var filters = CardFilters.getFilterOptions();

            var payload = {
                StartDate: start,
                EndDate: end,
                BranchFilters: _.map(filters.selectedBranches, 'id'),
                StateFilters: filters.selectedStates,
                TagIdsToFilter: _.map(filters.selectedTags, 'Id'),
                TagIdsToExclude: _.map(filters.excludedTags, 'Id'),
                WhiteboardTimeOfShift: filters.WhiteboardTimeOfShift,
                IncludeResources: forceIncludeResources || filters.showResources,
                TicketTypes: filters.selectedTicketTypes,
                TimesheetSubmissionTypes: filters.selectedTimesheetSubmissionTypes,
                TicketStatuses: filters.selectedTicketStatus
            };

            return (!filters.allowGroupByClient) ?
                resourceWhiteboardApi.getTicketsPerWeek(payload) :
                resourceWhiteboardApi.getTicketsPerWeekGroupByClient(payload);
        }

        function constructWeekHeaderDates(weeklyData) {
            var headerDates = [];

            for (var i = 0; i < weeklyData.lists.length; i++) {
                headerDates.push({
                    "name": weeklyData.lists[i].name,
                    "headerDate": weeklyData.lists[i].headerDate
                });
            }

            return headerDates;
        }

        async function buildWeeklyRawData(dataSrc, startDate, isGroupByClient) {
            let weeklyData = new ticketItemModelRw();
            let ticketHeadrs = jobBoardWeeklyService.prepareTicketListHeader(moment(new Date(startDate)));
            angular.forEach(ticketHeadrs, function(o) {
                weeklyData.lists.push(o);
            }, this);

            let preScheduleJobIds = [];

            if(claimsUtilService.isSmartSchedulingEnabled()){
                preScheduleJobIds = dataSrc.map(itm => itm.PreScheduleJobId)
            }

            angular.forEach(weeklyData.lists, function(ticketHeader) {

                var results = [];
                let qry = "SELECT * FROM ? WHERE formatDate2(StartDate, 'MM/DD/YYYY') = ?";
                results = alasql(qry, [dataSrc, ticketHeader.headerDate]);

                if (isGroupByClient) {
                    angular.forEach(results, function(itm) {
                        if (results.length > 0) {
                            let ticketCard = {
                                id: utils.newGuid(),
                                name: itm.CompanyName,
                                companyCode: itm.CompanyId,
                                ticketCount: itm.TicketCount,
                                hasPeople: itm.ContainsEquipment,
                                hasEquipment: itm.ContainsPeople,
                                status: getStatusByArray(itm.StatusList),
                                IsUnconfirmedDate: itm.IsUnconfirmedDate,
                                IsLocked: itm.IsLocked,
                                IsLockedByPreSchedule: itm.IsLockedByPreSchedule,
                                startDate: itm.StartDate,
                                endDate: itm.EndDate
                            };

                            ticketHeader.idCards.push(ticketCard);
                        }
                    });
                } else {
                    angular.forEach(results, function(itm2) {
                        if (results.length > 0) {
                            var statInfo = getStatusByArray(itm2.StatusList);

                            let ticketCard = {
                                id: itm2.Id,
                                ticketNo: itm2.TicketNumber,
                                purchaseOrderNumber: itm2.PurchaseOrderNumber,
                                workOrderNumber: itm2.WorkOrderNumber,
                                relatedNumber: itm2.ParentTicketNumber != null ? itm2.ParentTicketNumber : itm2.RelatedTicketNumber != null ? itm2.RelatedTicketNumber : null,
                                parentTicketId: itm2.ParentTicketId,
                                parentTicketNumber: itm2.ParentTicketNumber,
                                relatedTicketId: itm2.RelatedTicketId,
                                relatedTicketNumber: itm2.RelatedTicketNumber,
                                ticketCount: itm2.TicketCount,
                                name: itm2.CompanyName,
                                companyCode: itm2.CompanyId,
                                jobAddress: itm2.JobLocationAddress,
                                jobLocationAddress: itm2.JobLocationAddressObject,
                                projectId: itm2.ProjectId,
                                projectName: itm2.ProjectName,
                                startDate: formatDateDDMMYYYYwithTime(itm2.StartDate),
                                endDate: formatDateDDMMYYYY(itm2.EndDate),
                                branch: itm2.BranchName,
                                branchId: itm2.BranchId,
                                divisionId: itm2.DivisionId,
                                hasPeople: true,
                                hasEquipment: itm2.ContainsEquipment,
                                state: itm2.BranchState,
                                status: statInfo,
                                IsUnconfirmedDate: itm2.IsUnconfirmedDate,
                                IsLocked: itm2.IsLocked,
                                IsLockedByPreSchedule: itm2.IsLockedByPreSchedule,
                                showShiftAllocationIcon: !itm2.AllShiftsConfirmed,
                                showEquipmentAllocationIcon: !itm2.AllEquipmentsAssigned,
                                showRequireAllocationIcon: !itm2.AllResourcesAllocated,
                                ticketType: itm2.TicketType,
                                IsDayShift: itm2.IsDayShift,
                                sortOrder: statInfo[0].sortOrder,
                                allocatedResourceItems: sanitizeMapValues(itm2.AllocatedResourceItems),
                                isEmailSent: itm2.IsEmailSent,
                                purchaseOrderNumber: itm2.PurchaseOrderNumber,
                                workOrderNumber: itm2.WorkOrderNumber,
                                hasGeneratedPaperworkPdf: itm2.HasGeneratedPaperworkPdf,
                                siteContactId: itm2.SiteContactId,
                                etag: itm2.Etag ? JSON.parse(itm2.Etag) : null,
                                isRequiredAttachmentsCompleted: itm2.IsRequiredAttachmentsCompleted,
                                hasRequiredAttachments: itm2.HasRequiredAttachments

                            };

                            ticketHeader.idCards.push(ticketCard);
                        }
                    });

                    let sortedList = alasql('SELECT * FROM ? ORDER BY sortOrder, startTime  asc', [ticketHeader.idCards]);
                    ticketHeader.idCards = [];
                    ticketHeader.idCards = sortedList;
                }
            });

            return weeklyData;
        }

        function buildVirtualRepeatViewModel(weeklyData) {
            let weeklyViewRepeatSource = [];
            let listOfLength = [];

            for (var i = 0; i < 7; i++) {
                let len = weeklyData.lists[i].idCards.length;
                listOfLength.push(len);
            }

            var maxItemCount = _.maxBy(listOfLength, function(o) {
                return o;
            });

            for (var rowCount = 0; rowCount < maxItemCount; rowCount++) {
                var row = {};

                for (var headerCount = 0; headerCount < 7; headerCount++) {
                    if (rowCount < weeklyData.lists[headerCount].idCards.length) {
                        row['day' + headerCount] = weeklyData.lists[headerCount].idCards[rowCount];
                        row['day' + headerCount]['headerDate'] = weeklyData.lists[headerCount].headerDate;
                    }
                }

                weeklyViewRepeatSource.push(row);
            }

            return weeklyViewRepeatSource;
        }

        async function convertToVirtualRepeatModel(rawData, startDate) {
            let weeklyData = await buildWeeklyRawData(rawData, startDate, CardFilters.allowGroupByClient)
            let headerDates = constructWeekHeaderDates(weeklyData);
            let weekViewSource = buildVirtualRepeatViewModel(weeklyData);

            return $q.when({
                headerDates: headerDates,
                data: weekViewSource,
                rawData: rawData,
                count: rawData.length
            });
        }

        function getEmptyVirtualRepeatModel() {
            return {
                headerDates: [],
                data: [],
                rawData: [],
                count: 0
            };
        }

        function formatDateDDMMYYYY(date, fmt) {
            var format = fmt || 'YYYY-MM-DD';
            return moment(date, format).format(localeSettings.displayDateFormat);
        }

        function formatDateDDMMYYYYwithTime(date, fmt) {
            var timeformat = localeSettings.timeFormat2;
            var format = fmt || 'YYYY-MM-DD ' + timeformat;

            return moment(date, format).format(localeSettings.displayDateFormat + ' ' + timeformat);
        }

        function getStatusByArray(arr) {
            return jobsWhiteboardApi2.getStatusInfoByArray(arr);
        }

        function sanitizeMapValues(resourceItems) {
            var results = [];
            resourceItems.map(function(res) {
                let obj = {};
                for (var p in res) {
                    obj[_.camelCase(p)] = res[p];
                }
                obj['isProcessing'] = false;
                results.push(obj);
            });

            return results;
        }

        function attachNameIndex(tickets) {
            var ticketsSource = angular.copy(tickets);

            if (ticketsSource) {
                ticketsSource.map(function(ticket) {
                    var ctr = 1;
                    var shiftCtr = 1;
                    var items = angular.copy(ticket.AllocatedResourceItems);
                    items.map(function(o) {
                        // Index AllocatedItemName for all resource types (people + equipment)
                        if (!_.isNil(o.ResourceType) && !_.isNil(o.AllocatedItemName)) {
                            ticket['n' + ctr] = o.AllocatedItemName;
                            ctr++;
                        }
                        // Index ItemName (shift/equipment type) for type-based search
                        if (!_.isNil(o.ItemName)) {
                            ticket['sn' + shiftCtr] = o.ItemName;
                            shiftCtr++;
                        }
                    });
                });
            }

            return ticketsSource;
        }

        async function getGeneratedPreScheduleJobStatus(preScheduleJobIds) {
            if ((claimsUtilService.isSmartSchedulingEnabled()) && preScheduleJobIds.length > 0) {
                try {
                    var generatedPreSchedule = await preScheduleApi.getGeneratedPreScheduleJobStatus(preScheduleJobIds);

                    if(generatedPreSchedule.data != null){
                        return generatedPreSchedule.data;
                    }
                } catch (ex) {
                    exceptionService.resolve(ex);
                }
            }

            return [];;
        }

        function getPreScheduleJobStatusInfo(preScheduleJobs, preScheduleJobId){
            if(!(preScheduleJobs && preScheduleJobs.length > 0)){
                return;
            }
            
            let preScheduleJob =  preScheduleJobs.find(x => x.Id == preScheduleJobId);
            return !preScheduleJob ? null : preScheduleJob.Status;
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('app.jobs.resourceWhiteboard')
        .factory('dayViewServiceRw', dayViewServiceRw);

    /** @ngInject */
    function dayViewServiceRw(
        _,
        utils,
        CardFilters,
        alasql,
        $q,
        localisationService,
        moment,
        resourceWhiteboardApi,
        jobsWhiteboardApi2,
        claimsUtilService,
        exceptionService,
        preScheduleApi
    ) {
        var service = {
            settings: {
                bgcolor: 'bg-whiteboard2'
            },
            loadDailyViewData: loadDailyData,
            applyDayFilter: applyDayFilter,
            convertToVirtualRepeatModel: convertToVirtualRepeatModel,
            getEmptyVirtualRepeatModel: getEmptyVirtualRepeatModel,
            loadDailyRawData: loadDailyRawData,
            getGeneratedPreScheduleJobStatus: getGeneratedPreScheduleJobStatus,
            getPreScheduleJobStatusInfo: getPreScheduleJobStatusInfo,
            // Pagination functions
            loadInitialTickets: loadInitialTickets,
            loadMoreTickets: loadMoreTickets,
            resetPagination: resetPagination,
            getPaginationState: getPaginationState,
            buildDailyRawData: buildDailyRawData,
            buildVirtualRepeatViewModel: buildVirtualRepeatViewModel,
            // Count functions
            fetchTotalCount: fetchTotalCount,
            getTotalCount: getTotalCount,
            // Search function
            searchTicket: searchTicket,
            computeChunkSize: computeChunkSize
        };

        var CHUNK_SIZE = 6;
        var localeSettings = [];
        const SMART_SCHEDULE_IN_PROGRESS = [7];
        const SMART_SCHEDULE_IS_DONE = [8];
        const SMART_SCHEDULE_IS_DONE_AND_READY_TO_GO = [9];
        const SMART_SCHEDULE_IS_DONE_AND_COMPLETED = [10];

        const READY_TO_GO = 2;
        const COMPLETED = 1;

        const PREALLOCATE_CALLBACK_FAILED = 4;

        // Pagination state
        var paginationState = {
            currentToken: null,
            nextPageNumber: 1,
            isLoading: false,
            hasMore: true,
            pageSize: 50,  // 50 items per page
            totalCount: null,      // null = not yet loaded
            isLoadingCount: false  // prevents duplicate count requests
        };

        activate();

        return service;

        function activate() {
            localeSettings = localisationService.getLocaleFormatSettings();
        }

        function loadDailyData(options) {
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                invokedBy: null,
                contentSize: 0
            }, opts);

            computeChunkSize(settings.contentSize);

            let queryDateFormat = localeSettings.displayDateFormat;
            let actualViewModel = {
                date: settings.momentDate.format(queryDateFormat),
                day: getDayViewDisplayName(settings.momentDate.format(queryDateFormat))
            };
            let start = utils.jsDateTime(settings.momentDate, 'DD/MM/YYYY');

            return enrichData(start, actualViewModel);
        }

        function computeChunkSize(whiteboardContainerSize) {
            if (whiteboardContainerSize <= 0) return;
            CHUNK_SIZE = Math.floor(((whiteboardContainerSize - 80) / 250));
        }

        function loadDailyRawData(options) {
            let deferred = $q.defer();
            let opts = options || {};
            let settings = angular.extend({
                momentDate: null,
                destroyCache: false,
                invokedBy: null,
                contentSize: 0
            }, opts);

            computeChunkSize(settings.contentSize);

            let start = utils.jsDateTime(settings.momentDate, 'DD/MM/YYYY');
            let ticketPromise = getTicketsPerDay(start);

            ticketPromise.then(async function(resp) {
                if((claimsUtilService.isSmartSchedulingEnabled())){
                    let preScheduleJobIds = resp.data.map(ticket => {
                        if(ticket.PreScheduleJobId){
                            return ticket.PreScheduleJobId;
                        }
                    }).filter(Boolean);
                    
                    if (preScheduleJobIds.length > 0)
                    {
                        let preScheduleJobStatuses = await preScheduleApi.getGeneratedPreScheduleJobStatus(preScheduleJobIds);
                        
                        resp.data.forEach(itm => {
                            if (itm.PreScheduleJobId && !itm.AllResourceAllocationsConfirmed 
                                || (itm.TicketType == 1 && itm.StatusList == READY_TO_GO)) {
                                itm.StatusList = itm.IsLockedByPreSchedule ? SMART_SCHEDULE_IN_PROGRESS : SMART_SCHEDULE_IS_DONE;
                            }
                            else if(itm.PreScheduleJobId && itm.StatusList == READY_TO_GO) {
                                itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_READY_TO_GO;
                            }
                            else if(itm.PreScheduleJobId && itm.StatusList == COMPLETED) {
                                itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_COMPLETED;
                            }

                            let preScheduleJobStatus = getPreScheduleJobStatusInfo(preScheduleJobStatuses, itm.PreScheduleJobId);
                            itm.isSmartSchedulingFailed = preScheduleJobStatus == PREALLOCATE_CALLBACK_FAILED;
                        })
                    }
                }
                
                deferred.resolve(!CardFilters.allowGroupByClient ? attachNameIndex(resp.data) : resp.data);
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function applyDayFilter(momentDate, wboardType) {
            return loadDailyRawData({
                momentDate: momentDate,
                destroyCache: true,
                invokedBy: 'filter'
            }, wboardType);
        }

        function enrichData(start, actualViewModel) {
            let deferred = $q.defer();

            let ticketPromise = getTicketsPerDay(start);

            ticketPromise.then(async function(resp) {
                if (utils.isUndefinedOrNull(resp.data)) {
                    deferred.resolve({
                        data: null,
                        count: 0
                    });
                    return;
                }

                if(claimsUtilService.isSmartSchedulingEnabled()){
                    let preScheduleJobIds = resp.data.map(ticket => {
                        if(ticket.PreScheduleJobId){
                            return ticket.PreScheduleJobId;
                        }
                    }).filter(Boolean);
                    
                    if (preScheduleJobIds.length > 0)
                    {
                        let preScheduleJobStatuses = await preScheduleApi.getGeneratedPreScheduleJobStatus(preScheduleJobIds);
                    
                        resp.data.forEach(itm => {
                            if (itm.PreScheduleJobId && !itm.AllResourceAllocationsConfirmed
                                || (itm.TicketType == 1 && itm.StatusList == READY_TO_GO)
                            ) {
                                itm.StatusList = itm.IsLockedByPreSchedule ? SMART_SCHEDULE_IN_PROGRESS : SMART_SCHEDULE_IS_DONE;
                            }
                            else if(itm.PreScheduleJobId && itm.StatusList == READY_TO_GO) {
                                itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_READY_TO_GO;
                            }
                            else if(itm.PreScheduleJobId && itm.StatusList == COMPLETED) {
                                itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_COMPLETED;
                            }

                            let preScheduleJobStatus = getPreScheduleJobStatusInfo(preScheduleJobStatuses, itm.PreScheduleJobId);
                            itm.isSmartSchedulingFailed = preScheduleJobStatus == PREALLOCATE_CALLBACK_FAILED;
                        })
                    }
                }

                let dailyData = buildDailyRawData(resp.data, CardFilters.allowGroupByClient)
                let dayViewSource = buildVirtualRepeatViewModel(dailyData);

                actualViewModel['data'] = dayViewSource;
                actualViewModel['rawData'] = !CardFilters.allowGroupByClient ? attachNameIndex(resp.data) : resp.data;
                actualViewModel['count'] = resp.data.length;
                deferred.resolve(actualViewModel);

            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }
        
        function getTicketsPerDay(start, pageSize, pageNumber) {
            var filters = CardFilters.getFilterOptions();

            // Use provided pageNumber or default to 1
            var page = pageNumber || 1;

            var payload = {
                IncludeResources: filters.showResources,
                Filters: {
                    StartDate: start,
                    BranchFilters: _.map(filters.selectedBranches, 'id'),
                    StateFilters: filters.selectedStates,
                    TagIdsToFilter: _.map(filters.selectedTags, 'Id'),
                    TagIdsToExclude: _.map(filters.excludedTags, 'Id'),
                    TicketStatuses: filters.selectedTicketStatus,
                    TimesheetSubmissionTypes: filters.selectedTimesheetSubmissionTypes,
                    WhiteboardTimeOfShift: filters.WhiteboardTimeOfShift,
                    TicketTypes: filters.selectedTicketTypes,
                    PageSize: pageSize || paginationState.pageSize,
                    PageNumber: page
                }
            };

            return CardFilters.allowGroupByClient ? resourceWhiteboardApi.getTicketsPerDayGroupByClient(payload) : resourceWhiteboardApi.getTicketsPerDay(payload)
        }

        function buildDailyRawData(dataSrc, isGroupByClient) {
            let ticketCards = [];
            if (isGroupByClient) {
                angular.forEach(dataSrc, function(itm) {
                    let ticketCard = {
                        id: utils.newGuid(),
                        name: itm.CompanyName,
                        companyCode: itm.CompanyId,
                        ticketCount: itm.TicketCount,
                        hasPeople: itm.ContainsPeople,
                        hasEquipment: itm.ContainsEquipment,
                        status: getStatusByArray(itm.StatusList),
                        IsUnconfirmedDate: itm.IsUnconfirmedDate,
                        IsLocked: itm.IsLocked,
                        IsLockedByPreSchedule: itm.IsLockedByPreSchedule,
                        startDate: itm.StartDate,
                        endDate: itm.EndDate
                    };

                    ticketCards.push(ticketCard);
                }, this);
            } else {
                angular.forEach(dataSrc, function(itm) {

                    var statInfo = getStatusByArray(itm.StatusList);
                
                    let ticketCard = {
                        id: itm.Id,
                        ticketNo: itm.TicketNumber,
                        purchaseOrderNumber: itm.PurchaseOrderNumber,
                        workOrderNumber: itm.WorkOrderNumber,
                        ticketCount: itm.TicketCount,
                        relatedNumber: itm.ParentTicketNumber != null ? itm.ParentTicketNumber : itm.RelatedTicketNumber != null ? itm.RelatedTicketNumber : null,
                        parentTicketId: itm.ParentTicketId,
                        parentTicketNumber: itm.ParentTicketNumber,
                        relatedTicketId: itm.RelatedTicketId,
                        relatedTicketNumber: itm.RelatedTicketNumber,
                        name: itm.CompanyName,
                        companyCode: itm.CompanyId,
                        jobAddress: itm.JobLocationAddress,
                        jobLocationAddress: itm.JobLocationAddressObject,
                        jobLatitude: itm.JobLatitude,
                        jobLongitude: itm.JobLongitude,
                        startDate: formatDateDDMMYYYYwithTime(itm.StartDate),
                        endDate: formatDateDDMMYYYY(itm.EndDate),
                        startTime: utils.jsTime(itm.StartDate),
                        endTime: utils.jsTime(itm.EndDate),
                        branch: itm.BranchName,
                        projectId: itm.ProjectId,
                        projectName: itm.ProjectName,
                        hasPeople: itm.ContainsPeople,
                        hasEquipment: itm.ContainsEquipment,
                        divisionId: itm.DivisionId,
                        branchId: itm.BranchId,
                        state: itm.BranchState,
                        status: statInfo,
                        sortOrder: statInfo[0].sortOrder,
                        tickets: [],
                        isCancelled: itm.isCancelled,
                        IsUnconfirmedDate: itm.IsUnconfirmedDate,
                        IsLocked: itm.IsLocked,
                        IsLockedByPreSchedule: itm.IsLockedByPreSchedule,
                        showShiftAllocationIcon: !itm.AllShiftsConfirmed,
                        showEquipmentAllocationIcon: !itm.AllEquipmentsAssigned,
                        showRequireAllocationIcon: !itm.AllResourcesAllocated,
                        ticketType: itm.TicketType,
                        IsDayShift: itm.IsDayShift,
                        allocatedResourceItems: sanitizeMapValues(itm.AllocatedResourceItems),
                        isEmailSent: itm.IsEmailSent,
                        purchaseOrderNumber: itm.PurchaseOrderNumber,
                        workOrderNumber: itm.WorkOrderNumber,
                        hasGeneratedPaperworkPdf: itm.HasGeneratedPaperworkPdf,
                        siteContactId: itm.SiteContactId,
                        etag: itm.Etag ? JSON.parse(itm.Etag) : null,
                        isRequiredAttachmentsCompleted: itm.IsRequiredAttachmentsCompleted,
                        hasRequiredAttachments: itm.HasRequiredAttachments
                    };

                    ticketCards.push(ticketCard);
                }, this);
            }

            return ticketCards;
        }

        function attachNameIndex(tickets) {
            var ticketsSource = angular.copy(tickets);

            if (ticketsSource) {
                ticketsSource.map(function(ticket) {
                    var ctr = 1;
                    var items = angular.copy(ticket.AllocatedResourceItems);
                    items.map(function(o) {
                        if (!_.isNil(o.ResourceType) && !_.isNil(o.AllocatedItemName)) {
                            ticket['n' + ctr] = o.AllocatedItemName;
                            ctr++;
                        }
                    });
                });
            }

            return ticketsSource;
        }

        function sanitizeMapValues(resourceItems) {
            var results = [];
            resourceItems.map(function(res) {
                let obj = {};
                for (var p in res) {
                    obj[_.camelCase(p)] = res[p];
                }
                obj['isProcessing'] = false;
                results.push(obj);
            });

            return results;
        }

        function buildVirtualRepeatViewModel(dailyData) {
            let chunkData = _.chunk(dailyData, CHUNK_SIZE);
            return chunkData;
        }

        function convertToVirtualRepeatModel(rawData, startDate) {

            let dailyData = buildDailyRawData(rawData, CardFilters.allowGroupByClient)
            let dayViewSource = buildVirtualRepeatViewModel(dailyData);

            let dt = startDate.format(localeSettings.displayDateFormat);
            let actualViewModel = {
                date: dt,
                day: getDayViewDisplayName(dt),
                data: dayViewSource,
                rawData: rawData,
                count: rawData.length,
                totalCount: paginationState.totalCount
            };

            return $q.when(actualViewModel);
        }

        function getEmptyVirtualRepeatModel() {
            return {
                day: '',
                date: null,
                data: [],
                rawData: [],
                count: 0
            };
        }

        function formatDateDDMMYYYY(date, fmt) {
            var format = fmt || 'YYYY-MM-DD';
            return moment(date, format).format(localeSettings.displayDateFormat);
        }

        function formatDateDDMMYYYYwithTime(date, fmt) {
            var timeformat = localeSettings.timeFormat2;
            var format = fmt || 'YYYY-MM-DD ' + timeformat;

            return moment(date, format).format(localeSettings.displayDateFormat + ' ' + timeformat);
        }

        function getDayViewDisplayName(date) {
            let dt = moment(date, localeSettings.displayDateFormat);
            return dt.format('dddd').toUpperCase() + ' ' + dt.format('DD');
        }

        function getStatusByArray(arr) {
            return jobsWhiteboardApi2.getStatusInfoByArray(arr);
        }

        async function getGeneratedPreScheduleJobStatus(preScheduleJobIds) {
            if ((claimsUtilService.isSmartSchedulingEnabled()) && preScheduleJobIds.length > 0) {
                try {
                    var generatedPreSchedule = await preScheduleApi.getGeneratedPreScheduleJobStatus(preScheduleJobIds);

                    if(generatedPreSchedule.data != null){
                        return generatedPreSchedule.data;
                    }
                } catch (ex) {
                    exceptionService.resolve(ex);
                }
            }

            return [];
        }

        function getPreScheduleJobStatusInfo(preScheduleJobs, preScheduleJobId){
            if(!(preScheduleJobs && preScheduleJobs.length > 0)){
                return;
            }

            let preScheduleJob =  preScheduleJobs.find(x => x.Id == preScheduleJobId);
            return !preScheduleJob ? null : preScheduleJob.Status;
        }

        // Pagination helper functions
        async function loadInitialTickets(start) {
            // Reset pagination state for initial load
            paginationState.nextPageNumber = 1;
            paginationState.hasMore = true;
            paginationState.isLoading = true;
            paginationState.totalCount = null;
            paginationState.isLoadingCount = false;

            try {
                var result = await getTicketsPerDay(start, paginationState.pageSize, 1);

                var tickets = result.data.Tickets;

                // Update pagination state
                paginationState.nextPageNumber = result.data.NextPageNumber;
                paginationState.hasMore = result.data.HasMore;
                paginationState.isLoading = false;
                paginationState.totalCount = result.data.TotalCount;

                if (tickets && claimsUtilService.isSmartSchedulingEnabled()) {
                    tickets = await enrichTicketsWithPreSchedule(tickets);
                }

                return tickets || [];
            } catch (error) {
                paginationState.isLoading = false;
                throw error;
            }
        }

        async function loadMoreTickets(start) {
            if (!paginationState.hasMore || paginationState.isLoading) {
                return [];
            }

            paginationState.isLoading = true;

            try {
                // Backend handles multi-page fetching, so just make one call
                var result = await getTicketsPerDay(start, paginationState.pageSize, paginationState.nextPageNumber);

                // Backend returns: { data: { Tickets: [...], NextPageNumber: N, HasMore: bool } }
                var tickets = result.data.Tickets || [];

                // Update pagination state
                paginationState.nextPageNumber = result.data.NextPageNumber;
                paginationState.hasMore = result.data.HasMore;

                // Apply PreSchedule enrichment if enabled
                if (tickets.length > 0 && claimsUtilService.isSmartSchedulingEnabled()) {
                    tickets = await enrichTicketsWithPreSchedule(tickets);
                }

                paginationState.isLoading = false;
                return tickets;
            } catch (error) {
                paginationState.isLoading = false;
                throw error;
            }
        }

        // Search for tickets via API using multi-field search
        async function searchTicket(searchText, start) {
            if (!searchText || searchText.trim() === '') {
                return null;
            }

            try {
                var filters = CardFilters.getFilterOptions();

                var payload = {
                    StartDate: start,
                    IncludeResources: filters.showResources,
                    Filters: {
                        StartDate: start,
                        BranchFilters: _.map(filters.selectedBranches, 'id'),
                        StateFilters: filters.selectedStates,
                        TagIdsToFilter: _.map(filters.selectedTags, 'Id'),
                        TicketStatuses: filters.selectedTicketStatus,
                        TimesheetSubmissionTypes: filters.selectedTimesheetSubmissionTypes,
                        TagIdsToExclude: _.map(filters.excludedTags, 'Id'),
                        WhiteboardTimeOfShift: filters.WhiteboardTimeOfShift,
                        TicketTypes: filters.selectedTicketTypes,
                        SearchText: searchText  // Multi-field search (no pagination needed)
                    }
                };

                var ticketPerDayResult = await resourceWhiteboardApi.getTicketsPerDay(payload);

                // Search returns all results - disable pagination/infinite scroll
                paginationState.hasMore = false;
                paginationState.isLoading = false;

                var tickets = ticketPerDayResult.data.Tickets;

                if (tickets && tickets.length > 0) {
                    // Apply PreSchedule enrichment if enabled
                    if (claimsUtilService.isSmartSchedulingEnabled()) {
                        tickets = await enrichTicketsWithPreSchedule(tickets);
                    }

                    tickets = attachNameIndex(tickets);

                    return {
                        tickets: tickets,
                        source: 'api'
                    };
                }

                // Not found
                return null;
            } catch (error) {
                console.error('Error searching for ticket:', error);
                return null;
            }
        }

        async function enrichTicketsWithPreSchedule(tickets) {
            if (!claimsUtilService.isSmartSchedulingEnabled()) {
                return tickets;
            }

            let preScheduleJobIds = tickets.map(ticket => {
                if (ticket.PreScheduleJobId) {
                    return ticket.PreScheduleJobId;
                }
            }).filter(Boolean);

            if (preScheduleJobIds.length === 0) {
                return tickets;
            }

            try {
                let preScheduleJobStatuses = await preScheduleApi.getGeneratedPreScheduleJobStatus(preScheduleJobIds);

                tickets.forEach(itm => {
                    if (itm.PreScheduleJobId && !itm.AllResourceAllocationsConfirmed
                        || (itm.TicketType == 1 && itm.StatusList == READY_TO_GO)
                    ) {
                        itm.StatusList = itm.IsLockedByPreSchedule ? SMART_SCHEDULE_IN_PROGRESS : SMART_SCHEDULE_IS_DONE;
                    }
                    else if (itm.PreScheduleJobId && itm.StatusList == READY_TO_GO) {
                        itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_READY_TO_GO;
                    }
                    else if (itm.PreScheduleJobId && itm.StatusList == COMPLETED) {
                        itm.StatusList = SMART_SCHEDULE_IS_DONE_AND_COMPLETED;
                    }

                    let preScheduleJobStatus = getPreScheduleJobStatusInfo(preScheduleJobStatuses, itm.PreScheduleJobId);
                    itm.isSmartSchedulingFailed = preScheduleJobStatus == PREALLOCATE_CALLBACK_FAILED;
                });
            } catch (ex) {
                exceptionService.resolve(ex);
            }

            return tickets;
        }

        function resetPagination() {
            paginationState.currentToken = null;
            paginationState.nextPageNumber = 1;
            paginationState.isLoading = false;
            paginationState.hasMore = true;
            paginationState.totalCount = null;
            paginationState.isLoadingCount = false;
        }

        function getPaginationState() {
            return paginationState;
        }

        /**
         * Fetches total count asynchronously (lazy load).
         * Called after initial page load completes.
         */
        async function fetchTotalCount(start) {
            if (paginationState.isLoadingCount || paginationState.totalCount !== null) {
                return paginationState.totalCount;
            }

            paginationState.isLoadingCount = true;

            try {
                var filters = CardFilters.getFilterOptions();
                var payload = {
                    IncludeResources: filters.showResources,
                    Filters: {
                        StartDate: start,
                        BranchFilters: _.map(filters.selectedBranches, 'id'),
                        StateFilters: filters.selectedStates,
                        TagIdsToFilter: _.map(filters.selectedTags, 'Id'),
                        TagIdsToExclude: _.map(filters.excludedTags, 'Id'),
                        TicketStatuses: filters.selectedTicketStatus,
                        TimesheetSubmissionTypes: filters.selectedTimesheetSubmissionTypes,
                        WhiteboardTimeOfShift: filters.WhiteboardTimeOfShift,
                        TicketTypes: filters.selectedTicketTypes,
                        SearchText: filters.searchText || null
                    }
                };

                paginationState.totalCount = result.data.TotalCount;
                paginationState.isLoadingCount = false;

                return paginationState.totalCount;
            } catch (error) {
                paginationState.isLoadingCount = false;
                console.error('Failed to fetch total count:', error);
                return null;
            }
        }

        function getTotalCount() {
            return paginationState.totalCount;
        }
    }
})();


/**
 * Main View Model for whiteboard WEEK VIEW
 * Lookups and other related data are included here
 */
(function () {
    'use strict';

    angular.module('app.jobs.resourceWhiteboard')
        .service('ticketItemModelRw', ticketItemModelRw)

    function ticketItemModelRw() {
        return function () {
            var self = this,
                defaults = {
                    id: '32gfhaf2',
                    name: 'Jobs Application',
                    uri: "jobs-frontend-application",
                    settings: {
                        color: "",
                        subscribed: false,
                        cardCoverImages: true
                    },
                    cards: [],  // Source tickets
                    lists: [],  // Days of Week (Sun, Mon etc.)
                    members: [], // Note: Structure type list of String
                    labels: [],
                    ticketCards: [],  // Ticket cards are grouped by CompanyName and Date
                    pageToken: 0,
                    pageNo: 0
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.isEndOfRecord = isEndOfRecord; 
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                    , opts = angular.extend(self, mapValue);
            }

            function isEndOfRecord() {
                
                // Check day of week from Sun - Sat
                return (self.lists[0].idCards.length <= 0) 
                        && (self.lists[1].idCards.length <= 0) 
                        && (self.lists[2].idCards.length <= 0)
                        && (self.lists[3].idCards.length <= 0)
                        && (self.lists[4].idCards.length <= 0)
                        && (self.lists[5].idCards.length <= 0)
                        && (self.lists[6].idCards.length <= 0);
            }

            function reset() {
                self.map(null);
                self.cards.length = 0;
                self.lists.length = 0;
                self.members.length = 0;
                self.labels.length = 0;
                self.ticketCards.length = 0;
            }
        }
    };

})();
(function() {
    'use strict';

    angular
        .module('app.resourceSidenav')
        .controller('ResourceAdvanceOptionsDialogController', ResourceAdvanceOptionsDialogController);

    function ResourceAdvanceOptionsDialogController($mdDialog, locals) {
        var vm = this;
        vm.options = {};
        vm.activate = activate;
        vm.close = close;
        vm.employmentStatusChange = employmentStatusChange;
        vm.suburbDistanceChange = suburbDistanceChange;
        vm.save = save;

        function suburbDistanceChange(source){
            if(source == 'suburb'){
                vm.options.showOption.disable = false;
                vm.options.showOption.distance = !vm.options.showOption.suburb;
            }

            if(source == 'distance'){
                vm.options.showOption.disable = false;
                vm.options.showOption.suburb = !vm.options.showOption.distance;
            }

            if(source == 'disable') {
                vm.options.showOption.suburb = false;
                vm.options.showOption.distance = false;
                vm.options.sortOption = 0;
            }
        }

        function employmentStatusChange(){
            if(!vm.options.showOption.employmentStatus){
                vm.options.filterOption = null;
            }
        }

        function close() {
            $mdDialog.hide();
        }

        function activate() {
            vm.options = locals.Options;
        }

        function save(){
            return $mdDialog.hide(vm.options);
        }

        vm.activate();
    }
})();

(function () {
  'use strict';

  angular.module('app.related-ticket-billing-preferences')
    .factory('weekService', weekService);

  /** @ngInject */
  function weekService(moment) {

    var service = {
      buildWeeks : buildWeeks,
      lastday : lastday,
      firstday : firstday,
      sundayFirst : false
    };

    return service;

    function getWeeksInMonth(month, year) {
      var weeks = [],
        firstDate = new Date(year, month, 1),
        lastDate = new Date(year, month + 1, 0),
        numDays = lastDate.getDate();

      var start = 1;
      var end = 7 - firstDate.getDay();
      while (start <= numDays) {
        weeks.push({start: start, end: end});
        start = end + 1;
        end = end + 7;
        if (end > numDays)
          end = numDays;
      }

      return service.sundayFirst ? weeks : formatWeeksMonday(weeks, month, year);
    }

    function formatWeeksMonday(weeks, month, year){
      var len = weeks.length;
      for(var w = 0; w < len; w++){
        if(w === 0){
          weeks[w].end++;
          let current_month = month + 1;
          let first_day_of_first_week = moment(year + "-" + current_month + "-" + 1).format("d");
          if(first_day_of_first_week === "0"){
            weeks[0].start++;
          }
        }else if(w === (len - 1)){
          weeks[w].start++;
        }else{
          weeks[w].end++;
          weeks[w].start++;
        }
      }
      return weeks;
    }

    function getWeeks(current_month, current_year) {
      return getWeeksInMonth(current_month, current_year);
    }

    function buildWeeks(current_month, current_year) {
      var weeks = getWeeks(current_month, current_year);
      var month_weeks = [];
      weeks.forEach(function (week) {
        var weeks_days = [];
        for (var d = week.start; d <= week.end; d++) {
          var date_str = new Date((current_month + 1) + "/" + d + "/" + current_year);
          var date_obj = {
            Date: moment(date_str)
          }
          weeks_days.push(date_obj);
        }

        var week_obj = {
          WeekDays: weeks_days
        }

        month_weeks.push(week_obj);
      });
      month_weeks = polishFirstWeek(month_weeks[0], month_weeks);
      month_weeks = polishDates(month_weeks, current_month);
      return month_weeks;
    }

    function polishDates(weeks, current_month) {
      weeks.forEach(function (week) {
        week.WeekDays.forEach(function (day) {
          day['DateString'] = moment(day.Date).format('dddd, MMM Do');
          day['Class'] = current_month === day.Date.month() ? "list md-whiteframe-2dp ticket-container layout-column week_container_style" : "list md-whiteframe-2dp ticket-container layout-column week_container_style blur";
          day['Data'] = [];
        });
      });
      return weeks;
    }

    function lastday(y, m) {
      return new Date(y, m + 1, 0).getDate();
    }

    function firstday(y, m) {
      return new Date(y, m, 1).getDate();
    }

    function polishFirstWeek(first_week, month_weeks) {
      var days_lacking = 7 - first_week.WeekDays.length;
      if (days_lacking > 0) {
        var day = first_week.WeekDays[0].Date;
        for (var d = 0; d < days_lacking; d++) {
          var day_to_be_added = moment(day).subtract((d + 1), 'days');
          var date_obj = {
            Date: moment(day_to_be_added)
          }
          first_week.WeekDays.unshift(date_obj);
        }
      }

      if(!service.sundayFirst && days_lacking === 0){
        let first_day = moment(first_week.WeekDays[0].Date);
        let week = [];
        for(var d = 0; d < 7; d++){
          first_day = first_day.subtract(1, 'days');
          week.unshift({Date :moment(first_day)});
        }
        let weekdays = {
          WeekDays : week
        }
        month_weeks.unshift(weekdays)
      }
      return month_weeks;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.related-ticket-billing-preferences')
    .factory('relatedTicketBillingService', relatedTicketBillingService);

  /** @ngInject */
  function relatedTicketBillingService(hubService, $stateParams, utils, blockUI, _, classService, weekService, relatedTicketBillingPreferencesApi, $mdDialog, jobsApi, claimsUtilService) {

    var service = {
      Id: null,
      dataList: [],
      data_list: [],
      weeks: [],
      billing_periods: [],
      transformed_list: [],
      initial_weeks: [],
      billingPeriods: [],
      unique_items: [],
      activate: activate,
      transform: transform,
      reset: reset,
      build: build,
      showDialog: showDialog,
      polishUI: polishUI,
      showMultipleDialog: showMultipleDialog,
      adjustMonth: adjustMonth
    };

    return service;

    function activate() {
      let year = parseInt($stateParams.Year);
      let month = parseInt($stateParams.Month) - 1;
      service.current_date = moment().year(year).month(month).date(1);
      service.current_month = service.current_date.format("MMMM, YYYY");
      navigate(service.current_date.month(), service.current_date.year());
    }

    function adjustMonth(action) {
      if (action === 1) {
        service.current_date = service.current_date.add(1, 'month');
        service.current_month = service.current_date.format("MMMM, YYYY");
        navigate(service.current_date.month(), service.current_date.year());
      } else {
        service.current_date = service.current_date.subtract(1, 'month');
        service.current_month = service.current_date.format("MMMM, YYYY");
        navigate(service.current_date.month(), service.current_date.year());
      }
    }

    function navigate(month, year) {
      service.reset();
      blockUI.start("Loading...");
      let start_date = year + "-" + (month + 1) + "-1";
      let end_date = year + "-" + (month + 1) + "-" + weekService.lastday(year, month);
      service.Id = angular.copy($stateParams.Id);
      relatedTicketBillingPreferencesApi.initialize(service.Id, start_date, end_date).then(function (resp) {
        service.unique_items = getAllItems(resp[0].data.Items);
        service.dataList = resp[0].data.Results;
        service.billing_periods = resp[1].data;
        service.trimmed_billing_periods = angular.copy(service.billing_periods);
        service.polishUI(angular.copy(service.dataList));
        blockUI.stop();
      });
    }

    function getAllItems(data) {
      let items = utils.removeDuplicates(data, "Id");
      return _.map(items, function (item) {
        return {
          Id: item.Id,
          Name: item.Name
        }
      });
    }

    function polishUI(data) {
      service.initial_weeks = weekService.buildWeeks(service.current_date.month(), service.current_date.year());
      service.transformed_list = service.transform(data);
      service.weeks = service.build(service.initial_weeks, data);
    }

    function reset() {
      service.Id = null;
      service.dataList = [];
      service.data_list = [];
      service.weeks = [];
      service.transformed_list = [];
      service.initial_weeks = [];
      service.billing_periods = [];
      service.billingPeriods = []
    }

    function build(weeks, list) {
      weeks.forEach(function (week) {
        week.WeekDays.forEach(function (day) {
          let day_string = day.Date.format("MM/DD/YYYY");
          let result = _.find(list, {
            DateString: day_string
          });
          if (result) {
            delete result.DateString;
            delete result.Date;
            _.forEach(result.Items, function (item) {
              item.Items = alasql('select * from ? order by ItemName', [item.Items]);
            });
            day.Data.push(result);
          }
        });
      });
      return weeks;
    }

    function showDialog(item) {
      jobsApi.getTicketWithCustomFieldsByTicketId(item.Id).then(function(resp){
          if(resp.data.m_Item1.IsLocked || (resp.data.m_Item1.IsLockedByPreSchedule && claimsUtilService.isSmartSchedulingEnabled())) {
              hubService.showToast("Ticket is locked. Changing of quantity and billing period is not allowed.")
          }else{
              $mdDialog.show({
                  templateUrl: 'app/main/jobs/relatedTicketBillingPreferences/services/dialogs/singleDay/single-day.html',
                  locals: {
                      item: item,
                      data_list : service.dataList,
                      billing_periods: service.billing_periods
                  },
                  controller: 'SingleDayController as vm'
              }).then(function(data){
                  if(data){
                      navigate(service.current_date.month(), service.current_date.year());
                  }
              });
          }
      });
    }

    function showMultipleDialog() {
      $mdDialog.show({
        templateUrl: 'app/main/jobs/relatedTicketBillingPreferences/services/dialogs/multiDay/multi-day.html',
        locals: {
          parent : service.Id,
          current_date: service.current_date,
          periods: service.billing_periods,
          unique_items: service.unique_items
        },
        controller: 'MultiDayController as vm'
      }).then(function(data){
        if(data){
          blockUI.start("Saving...");
          relatedTicketBillingPreferencesApi
            .updateMultipleItems(data)
            .then(function(){
              blockUI.stop();
              navigate(service.current_date.month(), service.current_date.year());
            });
        }
      })
    }

    function transform(list) {
      angular.forEach(list, function (item) {
        item.StartDate = moment(item.StartDate);
        item.DateString = moment(item.StartDate).format("MM/DD/YYYY");

        _.forEach(item.ResourceItems, function (item) {
          let billing = _.find(service.billing_periods, {
            Id: item.BillingPeriod,
            IsNotBillable: !item.IsItemBillable
          });
          if (billing) {
            item['BillingPeriod_ItemId'] = billing.ItemId;
            item['BillingPeriod_Name'] = billing.Name;
          } else {
            let billing = _.find(service.billing_periods, {
              ItemId: 1
            });
            item['BillingPeriod_ItemId'] = billing.ItemId;
            item['BillingPeriod_Name'] = billing.Name;
            item.BillingPeriod = 1;
          }
        });

        item.ResourceItems = _.groupBy(item.ResourceItems, 'BillingPeriod_Name');

        var holder = [];
        angular.forEach(item.ResourceItems, function (members, key) {
          var match = _.find(holder, {Name: key});
          if (!match) {
            var section = {
              Name: key,
              Id: item.Id,
              Items: members.map(function (member) {
                return {
                  BillingPeriod_ItemId: member.BillingPeriod_ItemId,
                  BillingPeriod_Name: member.BillingPeriod_Name,
                  BillingPeriod: member.BillingPeriod,
                  Id: member.Id,
                  IsAllocatable: member.IsAllocatable,
                  IsItemBillable: member.IsItemBillable,
                  ItemName: member.ItemName,
                  ItemQuantity: member.ItemQuantity
                }
              }),
              BadgeClass: classService.getBadgeClass(key)
            }
            let temp_holder_of_items = angular.copy(section.Items);
            section.Items = alasql('Select ItemName, sum(ItemQuantity) as ItemQuantity FROM ? GROUP BY ItemName', [section.Items]);
            section.Items = section.Items.map(function(item){
              let item_holder = _.find(temp_holder_of_items, {
                ItemName : item.ItemName
              });
              return {
                ItemName : item.ItemName,
                ItemQuantity : item.ItemQuantity,
                ItemId : item_holder.Id
              }
            });
            holder.push(section)
          }
        });
        item.Items = alasql('select * from ? order by Name', [holder]);
      });

      _.forEach(list, function (list_item) {
        _.forEach(list_item.Items, function (item) {
          let billing = item.Name;
          _.forEach(item.Items, function (i) {
            i['Class'] = classService.getListItemColor(billing);
          });
        });
      });

      return list;
    }
  }
})();

{
    angular.module('app.api')
        .factory('relatedTicketBillingPreferencesApi', relatedTicketBillingPreferencesApi);

    /** @ngInject */
    function relatedTicketBillingPreferencesApi(
        $http,
        tenantSettings,
        $q,
        lookupApi
    ) {
        var api_const = tenantSettings.coreApiUrl + 'api/tickets/';

        return {
            initialize: initialize,
            updateMultipleItems: updateMultipleItems,
            deleteItem: deleteItem,
            updateQty: updateQty,
            updateSingle: updateSingle
        };

        function initialize(id, start, end) {
            return $q.all([getData(id, start, end), getBillings()]);
        }

        function getBillings() {
            return lookupApi.getNewBillingPeriodValues2()
        }

        function updateMultipleItems(payload) {
            return $http.post(api_const + "all/updatebillingpreferences", payload);
        }

        function deleteItem(payload) {
            return $http.post(api_const + "relatedticketbilling/delete", payload);
        }

        function updateQty(payload) {
            return $http.post(api_const + "relatedticketbilling/edit", payload);
        }

        function updateSingle(id, payload) {
            let data = {
                ResourceItems: payload
            }
            return $http.post(api_const + id + "/updatebillingpreferences", data);
        }

        function getData(id, start, end) {
            let payload = {
                TicketId: id,
                StartDate: start,
                EndDate: end
            }
            return $http.post(api_const + "relatedticketbilling", payload);
        }
    }
}

(function() {
  'use strict';

  angular.module('app.related-ticket-billing-preferences')
    .factory('classService', classService);

  /** @ngInject */
  function classService() {

    var service = {
      getListItemColor : getListItemColor,
      getBadgeClass : getBadgeClass,
      getOptionItemColor : getOptionItemColor,
      getMultiDayItemColor : getMultiDayItemColor
    };

    return service;

    function getBadgeClass(key){
      if(key === "Weekly"){
        return "side flex-5 green-700-bg layout-row layout-align-start-center"
      }

      if(key === "Daily"){
        return "side flex-5 red-700-bg  layout-row layout-align-start-center"
      }

      if(key === "Hourly"){
        return "side flex-5 deep-orange-700-bg layout-row layout-align-start-center"
      }

      if(key === "Monthly"){
        return "side flex-5 yellow-700-bg layout-row layout-align-start-center"
      }

      if(key === "Not Billable - Not Charged"){
        return "side flex-5 teal-700-bg layout-row layout-align-start-center"
      }

      if(key === "Not Billable - Weekly"){
        return "side flex-5 indigo-700-bg layout-row layout-align-start-center"
      }

      if(key === "Not Billable - Monthly"){
        return "side flex-5 purple-700-bg layout-row layout-align-start-center"
      }

      if(key === "Daily (5 Day Week Rate)"){
        return "side flex-5 cyan-700-bg layout-row layout-align-start-center"
      }

      if(key === "Daily (7 Day Week Rate)"){
        return "side flex-5 brown-700-bg layout-row layout-align-start-center"
      }

      if(key === "Daily (Month Rate)"){
        return "side flex-5 blue-grey-700-bg layout-row layout-align-start-center"
      }
    }


    function getListItemColor(key){
      if(key === "Weekly"){
        return "green-700-fg icon-pointer icon-label s16 bill-table-item0"
      }
      if(key === "Daily"){
        return "red-700-fg icon-pointer icon-label s16 bill-table-item0"
      }

      if(key === "Hourly"){
        return "deep-orange-700-fg icon-pointer icon-label s16 bill-table-item0"
      }

      if(key === "Monthly"){
        return "yellow-700-fg icon-pointer icon-label s16 bill-table-item0"
      }

      if(key === "Not Billable - Not Charged"){
        return "teal-700-fg icon-pointer icon-label s16 bill-table-item0"
      }

      if(key === "Not Billable - Weekly"){
        return "indigo-700-fg icon-pointer icon-label s16 bill-table-item0"
      }

      if(key === "Not Billable - Monthly"){
        return "purple-700-fg icon-pointer icon-label s16 bill-table-item0"
      }

      if(key === "Daily (5 Day Week Rate)"){
        return "cyan-700-fg icon-pointer icon-label s16 bill-table-item0"
      }

      if(key === "Daily (7 Day Week Rate)"){
        return "brown-700-fg icon-pointer icon-label s16 bill-table-item0"
      }

      if(key === "Daily (Month Rate)"){
        return "blue-grey-700-fg icon-pointer icon-label s16 bill-table-item0"
      }
    }

    function getMultiDayItemColor(key){
      if(key === "Weekly"){
        return "green-700-fg icon-briefcase-checked"
      }
      if(key === "Daily"){
        return "red-700-fg icon-briefcase-checked"
      }

      if(key === "Hourly"){
        return "deep-orange-700-fg icon-briefcase-checked"
      }

      if(key === "Monthly"){
        return "yellow-700-fg icon-briefcase-checked"
      }

      if(key === "Not Billable - Not Charged"){
        return "teal-700-fg icon-briefcase-checked"
      }

      if(key === "Not Billable - Weekly"){
        return "indigo-700-fg icon-briefcase-checked"
      }

      if(key === "Not Billable - Monthly"){
        return "purple-700-fg icon-briefcase-checked"
      }

      if(key === "Daily (5 Day Week Rate)"){
        return "cyan-700-fg icon-briefcase-checked"
      }

      if(key === "Daily (7 Day Week Rate)"){
        return "brown-700-fg icon-briefcase-checked"
      }

      if(key === "Daily (Month Rate)"){
        return "blue-grey-700-fg icon-briefcase-checked"
      }
    }

    function getOptionItemColor(key){
      if(key === "Weekly"){
        return "green-700-fg icon-checkbox-marked s20"
      }
      if(key === "Daily"){
        return "red-700-fg icon-checkbox-marked s20"
      }

      if(key === "Hourly"){
        return "deep-orange-700-fg icon-checkbox-marked s20"
      }

      if(key === "Monthly"){
        return "yellow-700-fg icon-checkbox-marked s20"
      }

      if(key === "Not Billable - Not Charged"){
        return "teal-700-fg icon-checkbox-marked s20"
      }

      if(key === "Not Billable - Weekly"){
        return "indigo-700-fg icon-checkbox-marked s20"
      }

      if(key === "Not Billable - Monthly"){
        return "purple-700-fg icon-checkbox-marked s20"
      }

      if(key === "Daily (5 Day Week Rate)"){
        return "cyan-700-fg icon-checkbox-marked s20"
      }

      if(key === "Daily (7 Day Week Rate)"){
        return "brown-700-fg icon-checkbox-marked s20"
      }

      if(key === "Daily (Month Rate)"){
        return "blue-grey-700-fg icon-checkbox-marked s20"
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.formsattachments',
      ['app.jobs.components.jobTags']).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state('app.formsattachments', {
        url: '/jobs/forms-and-attachments/:TicketId?/:TicketNo',
        views: {
          'content@app': {
            templateUrl: 'app/main/jobs/formsAndAttachments/forms-attachments.html',
            controller: 'FormsAndAttachmentsController as vm'
          }
        }
        , params: {linkedFormTemplates: null, unlinkedFormTemplates: null, overriddenFormTemplates : null}
        , data: {requireLogin : true}
        , title: 'Forms & Attachments'
        , titleBar: 'Alloc8 - Forms & Attachments'
    });
    $translatePartialLoaderProvider.addPart('app/main/jobs/formsAndAttachments');
  }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.formsattachments')
        .factory('formsAttachmentsService', formsAttachmentsService);

    /** @ngInject */
    function formsAttachmentsService($q,
        blockUI,
        exceptionService,
        jobsApi,
        branchApi,
        companyApi,
        attachmentTypesApi,
        claimsUtilService) {

        let service = {
            params: [],
            ticketData: [],
            requiredAttachmentTypes: [],
            init: init,
            getFormTemplates: getFormTemplates,
            saveForms: saveForms,
            saveTags: saveTags
        };

        function init() {
            let deferred = $q.defer();
            jobsApi.getTicketByTicketId(service.params.TicketId)
                .then(function (resp) {
                    service.ticketData = resp.data;
                    fetchRequiredAttachmentTypes();
                    deferred.resolve(resp.data);
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });
            return deferred.promise;
        }

        function fetchRequiredAttachmentTypes() {
            if (!claimsUtilService.isConfigurableRequiredAttachmentsEnabled()) {
                service.requiredAttachmentTypes = [];
                return;
            }

            var branchId = service.ticketData.BranchId;
            var companyId = service.ticketData.CompanyId;

            var promises = [];
            if (branchId) promises.push(branchApi.getBranch(branchId));
            if (companyId) promises.push(companyApi.getCompany(companyId));

            if (promises.length === 0) return;

            $q.all(promises).then(function (results) {
                var merged = {};
                results.forEach(function (resp) {
                    var types = (resp.data && resp.data.RequiredAttachmentTypes) || [];
                    types.forEach(function (type) {
                        var id = type.AttachmentTypeId;
                        if (merged[id]) {
                            merged[id].Quantity += type.Quantity;
                        } else {
                            merged[id] = { AttachmentTypeId: id, Quantity: type.Quantity };
                        }
                    });
                });

                var mergedList = Object.keys(merged).map(function (key) { return merged[key]; });

                // Resolve type names
                attachmentTypesApi.getAttachmentTypes().then(function (resp) {
                    var allTypes = resp.data || [];
                    mergedList.forEach(function (req) {
                        var type = _.find(allTypes, function (t) { return t.Id === req.AttachmentTypeId; });
                        req.AttachmentTypeName = type ? type.Name : 'Unknown';
                    });
                    service.requiredAttachmentTypes = mergedList;
                }).catch(function () {
                    // Use IDs without names if attachment types fetch fails
                    service.requiredAttachmentTypes = mergedList;
                });
            }).catch(function () {
                // Silently fail — the warning just won't show
                service.requiredAttachmentTypes = [];
            });
        }

        function getFormTemplates() {
            let deferred = $q.defer();
            jobsApi.getFormTemplatesByJobId(service.params.TicketId)
                .then(function (resp) {
                    deferred.resolve(resp.data);
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });
            return deferred.promise;
        }

        function saveForms(ticketId,
            ticketLinkedFormTemplates,
            ticketUnlinkedFormTemplates,
            ticketOverriddenFormTemplates) {
            let deferred = $q.defer();
            blockUI.start("Saving forms and attachments...");
            jobsApi.updateTicketFormTemplates(ticketId,
                ticketLinkedFormTemplates,
                ticketUnlinkedFormTemplates,
                ticketOverriddenFormTemplates)
                .then(function (resp) {
                    blockUI.stop();
                    deferred.resolve(resp);
                })
                .catch(function (ex) {
                    blockUI.stop();
                    deferred.reject(ex);
                    exceptionService.resolve(ex);
                });
            return deferred.promise;
        }

        function saveTags(ticketId, tags) {
            let deferred = $q.defer();
            blockUI.start("Saving tags...");

            jobsApi.updateTicketTags(ticketId, tags).then(function (resp) {
                blockUI.stop();
                deferred.resolve(resp);
            })
                .catch(function (ex) {
                    blockUI.stop();
                    deferred.reject(ex);
                    exceptionService.resolve(ex);
                });
            return deferred.promise;
        }

        return service;
    }
})();

(function() {
    'use strict';

    angular.module('app.jobs.allocate')
        .factory('resourceAllocateService', resourceAllocateService);

    /** @ngInject */
    function resourceAllocateService(
        allocationApi,
        branchApi,
        identityService,
        contactService,
        hubService,
        lookupApi,
        utils,
        blockUI,
        $mdSidenav,
        TimeLibrary,
        msgboxService,
        mediaQueryService,
        claimsUtilService,
        exceptionService,
        resourceLikeService,
        ticketBillingService,
        jobsApi,
        auditApi,
        timesheetApi,
        historyLogService,
        _,
        $q,
        sendMessageService,
        $timeout,
        $mdDialog,
        costEstimateApi,
        tenantSettings,
        preScheduleApi,
        $state,
        smartSchedulingService,
        tagsApi,
        ticketType,
        resourceSearchFilterService
    ) {
        var measurementPostfix = null;

        var service = {
            previous_ticket_no: null,
            checkAccessService: claimsUtilService,
            mediaQueryService: mediaQueryService,
            showAdvancedOptions: false,
            isFilterActive: false,
            droppables: [],
            divisions: [],
            divisionId: null,
            lookUps: [],
            SkillsList: [],
            lookUps2: [],
            hasCheckedCreditStatus: false,
            canAllocateResources: false,
            EquipmentTypes: [],
            peopleTypes: [],
            BranchName: null,
            type: null,
            selectedRow: null,
            clickSource: null,
            PastResourceLike: [],
            is_equipment: false,
            allocation_option: null,
            JobDisplayDate: null,
            showOption: {
                vehicle: false,
                distance: false,
                suburb: false,
                employmentStatus: false,
                showPrevAndNextShiftDetails: false
            },
            IsMultiDayEquipmentJob: false,
            TicketType: null,
            Equipment_StartDate: null,
            Equipment_EndDate: null,
            sortOption: null,
            filterOption: null,
            FutureResourceLike: [],
            hasVehicleFilter: false,
            showDroppableLoader: false,
            showDraggableLoader: false,
            showDraggables: false,
            fetchingAvailableResources: false,
            ticketGUID: null,
            ticketNo: null,
            costEstimate: null,
            projectedPayrollTotal: 0,
            projectedPayBreakdown: [],
            isBalancePositive: false,
            loadingCostProjection: false,
            selectedItem: null,
            peopleResource: 0,
            noAvailableItem: false,
            nullMessage: null,
            time: null,
            operators: [],
            fetch_called: 0,
            ParentTicketNumber: null,
            viewAll: false,
            ticketInfo: null,
            BranchId: null,
            settings: null,
            media: mediaQueryService,
            credit_type: null,
            chosen_division: null,
            employees_labour_hires: [],
            resource_like_has_been_called: false,
            isSmartSchedulingFailed: false,
            suggestedResources: [],
            tagsLookup: [],
            searchText: null,
            hasLoadedOnce: false,
            setMeasurementPostfix: setMeasurementPostfix,
            bindData: bindData,
            getDataModel: getDataModel,
            getActualIndex: getActualIndex,
            fetchTicket: fetchTicket,
            getStatus: getAllocationStatus,
            allocateResource: allocateResource,
            resetDraggables: resetDraggables,
            saveTimesheetManager: saveTimesheetManager,
            formatTime: formatTime,
            assignOperator: assignOperator,
            unAllocateResource: unAllocateResource,
            fetchOperators: fetchOperators,
            pushV2: pushV2,
            unassignOperator: unassignOperator,
            showNote: showNote,
            fetchTicket2: fetchTicket2,
            resetFilter: resetFilter,
            showFilter: showFilter,
            openMenu: openMenu,
            confirmGenerator: confirmGenerator,
            editItem: editItem,
            updateAriTags: updateAriTags,
            showResourceDialog: showResourceDialog,
            showLinkItemModal: showLinkItemModal,
            viewHistory: viewHistory,
            isBlueAllocatable: isBlueAllocatable,
            isOverrideAllocatable: isOverrideAllocatable,
            linkedItemsOf: linkedItemsOf,
            isLinkedItem: isLinkedItem,
            toggleViewAll: toggleViewAll,
            executeResourceLikeProcedure: executeResourceLikeProcedure,
            showResourceLikeDialog: showResourceLikeDialog,
            editBillingPreference: editBillingPreference,
            editBillingType: editBillingType,
            round: round,
            allocateToggle: allocateToggle,
            selectWithDivision: selectWithDivision,
            closeSideNav: closeSideNav,
            assignTimeDialog: assignTimeDialog,
            assignOperatorDialog: assignOperatorDialog,
            allocate2: allocate2,
            allocateResourceOverride: allocateResourceOverride,
            allocateOverride: allocateOverride,
            showDetails: showDetails,
            getBillTypeDisplay: getBillTypeDisplay,
            filterList: filterList,
            showResourceLikeMessages: showResourceLikeMessages,
            showResourceLikeMessages2: showResourceLikeMessages2,
            clean: clean,
            showMessageDialog: showMessageDialog,
            showJobAllocationDialog: showJobAllocationDialog,
            closeSideNavIfOpen: closeSideNavIfOpen,
            openSideNav: openSideNav,
            refreshFromSignalR: refreshFromSignalR,
            hasASubmittedTimesheet: hasASubmittedTimesheet,
            checkTimeIfValid: checkTimeIfValid,
            loadResourcesForShift: loadResourcesForShift,
            saveLinkedItems: saveLinkedItems,
            unlinkItems: unlinkItems,
            setRequirements: setRequirements,
            generatePreSchedule : generatePreSchedule,
            isSmartSchedulingCallbackFailed: isSmartSchedulingCallbackFailed,
            setPeopleEquipmentColor: setPeopleEquipmentColor,
            assignDisplayName: setRequirements,
            cancelScheduling: cancelScheduling,
            retryScheduling: retryScheduling,
            showShiftTags: showShiftTags,
            getShiftTags: getShiftTags,
            performSearch: performSearch,
            resourceType: {
                People: 0,
                Equipment: 1
            },
            lockoutType: {
                NoLockout: 0,
                SoftLockout: 1,
                MediumLockout: 2,
                HardLockout: 3
            }
        };

        const PREALLOCATE_CALLBACK_FAILED = 4;
        const ITEM_TYPE_PEOPLE = 4;
        const ALLOCATION_STATUS_CONFIRMED = 3;
        const ALLOCATION_STATUS_REJECTED = 4;

        return service;

        function toggleViewAll() {
            filterList();
        }

        function setMeasurementPostfix() {
            measurementPostfix = utils.translate('RESOURCEALLOCATION.MEASUREMENT_POSTFIX_KILOMETERS');

            if (tenantSettings.measurementForDistance != null && tenantSettings.measurementForDistance.toLowerCase() == 'miles') {
                measurementPostfix = utils.translate('RESOURCEALLOCATION.MEASUREMENT_POSTFIX_MILES');
            }
        }

        function refreshFromSignalR(items) {
            //SignaR refresher without calling extra APIs
            $timeout(function() {
                clearDefaultsOnRefresh();
                setRequirements(items);
                setPeopleResource(items);
            });
        }

        function getParentTicketNumber(ticket) {
            return ticket != null ? cleanTicketNumber(ticket) : service.ticketNo = cleanTicketNumber(service.ticketNo);
        }

        function cleanTicketNumber(ticket) {
            //Remove the version number from the url adn get only the ticket number
            if (ticket != null) {
                let index_of_question_mark = ticket.toString().indexOf("?");
                return index_of_question_mark > 0 ? ticket.toString().substring(0, index_of_question_mark).trim() : ticket.toString().trim();
            }
        }

        function clean() {
            service.previous_ticket_no = null;
            service.showAdvancedOptions = false;
            service.isFilterActive = false;
            service.droppables.length = 0;
            service.divisions.length = 0;
            service.divisionId = null;
            service.lookUps = [];
            service.lookUps2 = [];
            service.EquipmentTypes.length = 0;
            service.peopleTypes.length = 0;
            service.BranchName = null;
            service.selectedRow = null;
            service.clickSource = null;
            service.PastResourceLike.length = 0;
            service.is_equipment = false;
            service.allocation_option = null;
            service.JobDisplayDate = null;
            service.IsMultiDayEquipmentJob = false;
            service.TicketType = null;
            service.Equipment_StartDate = null;
            service.Equipment_EndDate = null;
            service.FutureResourceLike.length = 0;
            service.showDroppableLoader = false;
            service.showDraggableLoader = false;
            service.showDraggables = false;
            service.fetchingAvailableResources = false;
            service.ticketGUID = null;
            service.ticketNo = null;
            service.costEstimate = null;
            service.projectedPayrollTotal = 0;
            service.projectedPayBreakdown = [];
            service.isBalancePositive = false;
            service.loadingCostProjection = false;
            service.selectedItem = null;
            service.peopleResource = 0;
            service.noAvailableItem = false;
            service.nullMessage = null;
            service.time = null;
            service.operators.length = 0;
            service.fetch_called = 0;
            service.ParentTicketNumber = null;
            service.viewAll = false;
            service.ticketInfo = null;
            service.BranchId = null;
            service.settings = null;
            service.media = null;
            service.credit_type = null;
            service.chosen_division = null;
            service.employees_labour_hires.length = 0;
            service.isSmartSchedulingFailed = false;
            service.searchText = null;
            service.hasLoadedOnce = false;
        }

        function getBillTypeDisplay(itm) {
            //Equipment section - get billing type for display
            let prefix = utils.translate('RESOURCEALLOCATION.BILL_AS');
            return ((itm.InvoiceAsItemId != null || itm.InvoiceAsItemName != null) || itm.BillingPeriod != 1) ? getBillingTypeOnly(itm, prefix) : getBillingAndEquipmentType(itm, prefix);
        }

        function getBillingTypeOnly(itm, prefix) {
            return getBillingPeriodValue(itm) != null ? (prefix + getBillingPeriodValue(itm)) : null;
        }

        function getBillingAndEquipmentType(itm, prefix) {
            let equipment = _.find(service.EquipmentTypes, {
                Id: itm.InvoiceAsItemId
            });
            return equipment ? (prefix + " " + equipment.Name + getBillingPeriodValue(itm)) : "";
        }

        function getBillingPeriodValue(itm) {
            //Returns billing period value
            let billing_period = _.find(service.BillingTypes, {
                Id: itm.BillingPeriod,
                IsNotBillable: itm.IsNotBillable
            });
            return billing_period ? (itm.ItemId == itm.InvoiceAsItemId ? null : " (" + billing_period.Name + ")") : null;
        }

        function showDetails(lookup, $event) {
            //Show resource/contact details from the available resources
            contactService.showContactDetails(lookup.Id, true);
            $event.stopPropagation();
        }

        function openMenu($mdMenu, ev) {
            //Opens side nav
            $mdMenu.open(ev);
        }

        function closeSideNav() {
            $mdSidenav("right").toggle();
        }

        function assignOperatorDialog(line, operators) {
            //Show Assign Operator Dialog
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/assignOperator/assign-operator-dialog.html',
                controller: 'assignOperatorDialogController as vm',
                locals: {
                    line: line,
                    operators: operators
                }
            });
        }

        function assignTimeDialog(line) {
            //Show Assign Time Dialog
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/timeDialog/time-dialog.html',
                controller: 'timeDialogController as vm',
                locals: {
                    line: line
                }
            });
        }

        async function showShiftTags(shift) {
            var deferred = $q.defer();

            var activeTags = await getShiftTags();

            $mdDialog.show({
                controllerAs: "vm",
                controller: "shiftTagsDialogController",
                templateUrl: "app/main/jobs/allocateResource/components/droppableComponent/shiftTagsDialog/shift-tags-dialog.html",
                locals: {
                    currentTags: shift.Tags,
                    availableTags: activeTags
                },
            }).then(async function(data) {
                if (data.noChangesInTags) {
                    return;
                }

                blockUI.start(utils.translate('RESOURCEALLOCATION.SAVING_TAGS'));

                await updateAriTags(shift.Id, data.selectedTags);

                blockUI.stop();

                deferred.resolve(true);
            });

            return deferred.promise;
        }

        function getShiftTags() {
            var deferred = $q.defer();

            tagsApi.getActiveTags()
                .then(function (resp) {
                    deferred.resolve(resp.data);
                })
                .catch(function (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return deferred.promise;
        }

        async function showShiftTags(shift) {
            var deferred = $q.defer();

            var activeTags = await getShiftTags();

            $mdDialog.show({
                controllerAs: "vm",
                controller: "shiftTagsDialogController",
                templateUrl: "app/main/jobs/allocateResource/components/droppableComponent/shiftTagsDialog/shift-tags-dialog.html",
                locals: {
                    currentTags: shift.Tags,
                    availableTags: activeTags
                },
            }).then(async function(data) {
                if (data.noChangesInTags) {
                    return;
                }

                blockUI.start(utils.translate('RESOURCEALLOCATION.SAVING_TAGS'));

                await updateAriTags(shift.Id, data.selectedTags);

                blockUI.stop();

                deferred.resolve(true);
            });

            return deferred.promise;
        }

        function getShiftTags() {
            var deferred = $q.defer();

            tagsApi.getActiveTags()
                .then(function (resp) {
                    deferred.resolve(resp.data);
                })
                .catch(function (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return deferred.promise;
        }

        function selectWithDivision() {
            filterList();
        }

        function allocateToggle(data) {
            if (service.allocation_option === "3" && (service.Equipment_StartDate == null || service.Equipment_EndDate == null)) {
                hubService.showToast(utils.translate('RESOURCEALLOCATION.FILL_DATES'));
            } else {
                if (service.selectedItem.AllocatedItemName) {
                    let msg = utils.translate('RESOURCEALLOCATION.REPLACE_RESOURCE') + ' ' + service.selectedItem.AllocatedItemName + '?';
                    let confirm = service.confirmGenerator(utils.translate('RESOURCEALLOCATION.CONFIRMATION'),
                        msg,
                        utils.translate('RESOURCEALLOCATION.CONFIRMATION'),
                        utils.translate('RESOURCEALLOCATION.YES'),
                        utils.translate('RESOURCEALLOCATION.NO'));

                    $mdDialog.show(confirm).then(function() {
                        service.allocateResource(service.getDataModel(data), service.getActualIndex(), service.selectedItem.ItemType);
                        $mdSidenav("right").toggle();
                    });
                } else {
                    service.allocateResource(service.getDataModel(data), service.getActualIndex(), service.selectedItem.ItemType);
                    $mdSidenav("right").toggle();
                }
            }
        }

        function allocateOverride(data) {
            //Allocate Resource function
            //Also asks for override reason
            if (service.selectedItem.AllocatedItemName != null) {
                let msg = utils.translate('RESOURCEALLOCATION.REPLACE_RESOURCE') + ' ' + service.selectedItem.AllocatedItemName + '?';
                let confirm = service.confirmGenerator(utils.translate('RESOURCEALLOCATION.CONFIRMATION'), msg, utils.translate('RESOURCEALLOCATION.CONFIRMATION'), utils.translate('RESOURCEALLOCATION.YES'), utils.translate('RESOURCEALLOCATION.NO'));
                $mdDialog.show(confirm).then(function() {
                    service.allocate2(service.getDataModel(data));
                    $mdSidenav("right").toggle();
                });
            } else {
                service.allocate2(service.getDataModel(data));
                $mdSidenav("right").toggle();
            }
        }

        function round(distance) {
            //Format distance - Available Resources Panel
            return distance == null ? null : Math.round(distance) + measurementPostfix;
        }

        function showResourceLikeDialog() {
            //Resource Like Dialog
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/resourceLike/dialog/resource-like.dialog.html',
                controller: 'ResourceLikeController as vm',
                multiple: true,
                locals: {
                    TicketData: angular.copy(service.PastResourceLike),
                    FutureResourceLike: angular.copy(service.FutureResourceLike),
                    Droppables: angular.copy(service.droppables),
                    TicketNumber: service.ticketNo,
                    TicketId: service.ticketGUID
                }
            }).then(executeResourceLikeProcedure);
        }

        function executeResourceLikeProcedure(data) {
            //Being called/triggered when user chooses to execute resource like
            if (data) {
                blockUI.start(utils.translate('RESOURCEALLOCATION.ALLOCATING'));
                allocationApi.postResourceLike(data).then(function(resp) {
                    fetchTicket2();
                    let result = resp.data.SuggestedResources;
                    let errors = _.filter(result, {
                        WasResourced: false
                    });
                    errors.length > 0 ? showResourceLikeMessages(errors) : hubService.showToast(utils.translate('RESOURCEALLOCATION.ALLOCATION_SUCCESSFUL'));
                    blockUI.stop();
                }).catch(function() {
                    msgboxService.show(utils.translate('RESOURCEALLOCATION.RESOURCE_LIKE_ALLOCATION_FAILED')).then(function() {
                        blockUI.stop();
                    });
                });
            }
        }

        function showResourceLikeMessages(errorlist) {
            //Will be shown if there are errors encountered during resource like execution
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/resourceLike/errorDialog/resource-like.error-dialog.html',
                controller: 'ResourceLikeErrorController as vm',
                multiple: true,
                locals: {
                    errorlist: angular.copy(errorlist)
                }
            });
        }

        function showResourceLikeMessages2(errorlist) {
            //Will be shown if there are errors encountered during resource like execution
            //This is for create jobs
            return $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/resourceLike/errorDialog/resource-like.error-dialog.html',
                controller: 'ResourceLikeErrorController as vm',
                multiple: true,
                locals: {
                    errorlist: angular.copy(errorlist)
                }
            });
        }

        async function viewHistory() {
            //For viewing allocation history
            var resp = await auditApi.getAuditEntries(service.ticketGUID);
            historyLogService.showHistory("Ticket", resp.data, "#" + service.ticketNo);
        }

        function showFilter() {
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/draggableComponent/advancedOptions/advanced-options.html',
                controller: 'AdvancedOptionsController as vm',
                locals: {
                    showOption: service.settings.showOption,
                    sortOption: service.settings.sortOption,
                    filterOption: service.settings.filterOption,
                    hasVehicleFilter: service.settings.hasVehicleFilter,
                    isVehicleFilterActive: service.settings.isVehicleFilterActive
                }
            }).then(function(settings) {
                if (settings != null) {
                    saveFilter(settings);
                    filterList();
                }
            });
        }

        async function loadFilterSettings() {
            let defaultSettings = getDefaultSettings();
            let savedSettings = identityService.getAllocationSettings();

            if (savedSettings == null) {
                savedSettings = {};

                const settingsResp = await allocationApi.getAllocationSettings()
                    .catch(function(err) {
                        exceptionService.resolve(err);
                    });
                settingsResp && settingsResp.data ? angular.extend(savedSettings, defaultSettings, settingsResp.data) : angular.extend(savedSettings, defaultSettings);
                allocationApi.saveAllocationSettings(identityService.userData.UserId, savedSettings);

                service.isFilterActive = false;
                service.settings = savedSettings;
                return;
            }

            service.isFilterActive = JsonStringifyOrder(savedSettings) !== JsonStringifyOrder(defaultSettings);
            service.settings = savedSettings;
        }

        function JsonStringifyOrder(obj, space) {
            const allKeys = new Set();
            JSON.stringify(obj, (key, value) => (allKeys.add(key), value));
            return JSON.stringify(obj, Array.from(allKeys).sort(), space);
        }

        function saveFilter(settings) {
            let defaultSettings = getDefaultSettings();
            const defaultSettingsJsonString = JsonStringifyOrder(defaultSettings);
            const currentSettingsJsonString = JsonStringifyOrder(service.settings);

            let shouldSaveSettings = false;

            if (settings == null) {
                shouldSaveSettings = currentSettingsJsonString !== defaultSettingsJsonString;

                service.lookUps2 = [];
                service.settings = defaultSettings;
                service.isFilterActive = false;
            } else {
                const newSettingsJsonString = JsonStringifyOrder(settings);
                shouldSaveSettings = currentSettingsJsonString !== newSettingsJsonString;

                service.isFilterActive = newSettingsJsonString !== defaultSettingsJsonString
                service.settings = settings;
            }

            if (shouldSaveSettings) {
                allocationApi.saveAllocationSettings(identityService.userData.UserId, service.settings);
                identityService.setAllocationSettings(service.settings);
            }
        }

        function getDefaultSettings() {
            return {
                reset: false,
                showOption: {
                    vehicle: true,
                    distance: false,
                    suburb: true,
                    employmentStatus: true,
                    disable: false,
                    showPrevAndNextShiftDetails: true
                },
                sortOption: null,
                filterOption: null,
                hasVehicleFilter: false,
                isVehicleFilterActive: false
            };
        }

        function sortBySortOption(list, settings) {
            if (list.length < 1) {
                return list;
            }

            if (settings.sortOption == null) {
                return orderListByResourceName(list);
            }

            if (settings.sortOption == 0) {
                return orderListByResourceName(list);
            }

            if (settings.sortOption == 2) {
                return orderByDistanceToJob(list);
            }

            return orderListBySuburbName(list);
        }

        function orderListByResourceName(list) {
            return _.orderBy(list, ['Name'], ['asc']);
        }

        function orderListBySuburbName(list) {
            let itemsWithSuburb = list.filter(itm => itm.Suburb != null);
            let with_suburb = _.orderBy(itemsWithSuburb, ['Suburb'], ['asc']);

            let itemsWithoutSuburb = list.filter(itm => itm.Suburb == null);
            let without_suburb = _.orderBy(itemsWithoutSuburb, ['Name'], ['asc']);

            return with_suburb.concat(without_suburb)
        }

        function orderByDistanceToJob(list) {
            let itemsWithDistance = list.filter(itm => itm.DistanceToJob != null);
            let with_distance = _.orderBy(itemsWithDistance, ['DistanceToJob'], ['asc']);

            let itemsWithoutDistance = list.filter(itm => itm.DistanceToJob == null);
            let without_distance = _.orderBy(itemsWithoutDistance, ['Name'], ['asc']);

            return with_distance.concat(without_distance);
        }

        function filterByEmploymentStatus(list, settings) {
            if (list.length < 1) {
                return list;
            }

            if (!settings.filterOption) {
                return list;
            }

            if (settings.filterOption == 0) {
                return list.filter(p => p.EmploymentStatus == 'Casual');
            }

            if (settings.filterOption == 1) {
                return list.filter(p => p.EmploymentStatus == 'Permanent Parttime');
            }

            if (settings.filterOption == 2) {
                return list.filter(p => p.EmploymentStatus == 'Permanent Fulltime');
            }

            if (settings.filterOption == 3) {
                return list.filter(p => p.EmploymentStatus == 'Labour Hire');
            }

            return list;
        }

        function filterByVehicleOwnership(list, settings) {
            if (list.length < 1) {
                return list;
            }

            if (!settings.isVehicleFilterActive || service.clickSource !== 'People') {
                return list;
            }

            return list.filter(p => !!p.HasVehicle === !!settings.hasVehicleFilter);
        }

        function filterByDivision(list) {
            if (list.length < 1) {
                return list;
            }

            const isDivisionSelected = service.chosen_division != null;
            if (!isDivisionSelected) {
                const hasTicketDivision = service.ticketInfo.DivisionId != null;
                if (!hasTicketDivision) {
                    // Select All Item
                    service.chosen_division = -1;
                    service.divisionId = null;
                    return list;
                }

                // Select Items With Ticket Division
                service.chosen_division = angular.copy(service.ticketInfo.DivisionId);
                service.divisionId = angular.copy(service.ticketInfo.DivisionId);
                return list.filter(p => p.DivisionIds.includes(service.divisionId));
            }

            const isAllDivisionsSelected = service.chosen_division == -1;
            if (isAllDivisionsSelected) {
                // Select All Items
                service.divisionId = null;
                return list;
            }

            const isNoDivisionSelected = service.chosen_division == 0;
            if (isNoDivisionSelected) {
                // Select Items Without Any Division
                service.divisionId = null;
                return list.filter(p => p.DivisionIds.length < 1);
            }

            // Select Items With Chosen Division
            service.divisionId = angular.copy(service.chosen_division);
            return list.filter(p => p.DivisionIds.includes(service.divisionId));
        }

        function filterBySearchText(list) {
            return resourceSearchFilterService.filterBySearchText(list, service.searchText);
        }

        function filterList() {
            service.lookUps2 = [];

            // Default ("view without issues") list. When allocating a person (slot ItemType 4), a
            // worker whose only block is an equipment-typed operator-skill gap is still blue-
            // allocatable, so include it here (raw IsValidToAllocate is false) — kept in lock-step
            // with the + colour via isBlueAllocatable. Equipment keeps the raw gate.
            let isAllocatingAPerson = service.selectedItem && service.selectedItem.ItemType == 4;
            let list = service.viewAll ?
                angular.copy(service.lookUps) :
                service.lookUps.filter(p => isAllocatingAPerson ? isBlueAllocatable(p) : p.IsValidToAllocate);

            list = filterByDivision(list);
            list = filterBySearchText(list);
            list = filterByVehicleOwnership(list, service.settings);
            list = sortBySortOption(list, service.settings);

            service.lookUps2 = list;
        }

        function isBlueAllocatable(person) {
            // Blue + : the worker can be allocated without an override reason. Equipment-typed
            // operator-skill gaps are resolved at allocation (auto-assign via reveal-and-prompt), so
            // a worker whose only block is equipment-typed still counts blue; Soft/NoLockout non-
            // equipment issues stay allocatable, Medium/Hard worker-side issues fall to the red +.
            if (person.IsValidToAllocate) return true;

            let hasNonSkillLockoutIssues = person.AllocationIssues.some(x => x.ResourceType == service.resourceType.People
                && x.LockoutType == service.lockoutType.NoLockout);

            let nonEquipmentAllocationIssues = person.AllocationIssues.filter(x => x.ResourceType != service.resourceType.Equipment);

            let hasSoftAndNoLockoutIssuesOnly = nonEquipmentAllocationIssues.every(x => x.LockoutType == service.lockoutType.SoftLockout || x.LockoutType == service.lockoutType.NoLockout);

            return !hasNonSkillLockoutIssues && hasSoftAndNoLockoutIssuesOnly && !isOverrideAllocatable(person);
        }

        function isOverrideAllocatable(person) {
            // Red override + : the only blocking issues are overridable worker-side
            // (non-equipment) lockouts. Equipment-typed operator gaps are excluded — they
            // surface via the reveal-and-prompt at allocation, not the + colour.
            let nonEquipmentAllocationIssues = person.AllocationIssues.filter(x => x.ResourceType != service.resourceType.Equipment);
            let isInvalidToAllocate = nonEquipmentAllocationIssues.length > 0 && nonEquipmentAllocationIssues.some(x => !x.IsValidToAllocate && !x.CanBeOverriden);

            if (isInvalidToAllocate) return false;

            let invalidNonEquipmentAllocationIssues = nonEquipmentAllocationIssues.filter(x => !x.IsValidToAllocate);
            return invalidNonEquipmentAllocationIssues.length > 0 && invalidNonEquipmentAllocationIssues.every(x => x.CanBeOverriden);
        }

        // Single source of truth for "what is linked to this item" — returns nothing while the
        // feature is disabled, which also drops the connector rail and the parent/child markers
        // that are keyed off the count.
        function linkedItemsOf(itemId) {
            if (!claimsUtilService.isLinkedItemsEnabled()) {
                return [];
            }

            return (service.droppables || []).filter(x => x.ParentAllocatedResourceId === itemId);
        }

        // A line is linked when it hangs off a parent or has children hanging off it. Swapping the
        // item behind either side would leave the link pointing at something the user never linked,
        // so the resource-type change is withheld until the link is removed.
        function isLinkedItem(line) {
            if (!line || !claimsUtilService.isLinkedItemsEnabled()) {
                return false;
            }

            return !!line.ParentAllocatedResourceId || linkedItemsOf(line.Id).length > 0;
        }

        function escapeHtml(value) {
            // The auto-allocation-failure popup builds trusted HTML for $mdDialog.htmlContent,
            // so any user-editable name (equipment/shift/linked-item names, issue messages) must
            // be escaped before interpolation to avoid markup injection.
            if (value === null || value === undefined) return '';
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function resetFilter() {
            var confirm = $mdDialog.confirm()
                .title(utils.translate('RESOURCEALLOCATION.RESET_CONFIRMATION'))
                .textContent(utils.translate('RESOURCEALLOCATION.RESET_CONFIRMATION_MESSAGE'))
                .ok(utils.translate('RESOURCEALLOCATION.YES'))
                .cancel(utils.translate('RESOURCEALLOCATION.CANCEL'));

            $mdDialog.show(confirm)
                .then(function() {
                    service.viewAll = false;
                    service.searchText = null;
                    service.chosen_division = null;
                    saveFilter(null);
                    filterList();
                });
        }

        function showResourceDialog(locals) {
            //Shows tabbed dialog to change a line item
            //Changing item's shift allowance
            //Changing item's required skills
            //Changing item's shift classification
            //Changing item's resource type
            //Changing item's billing type
            //Changing item's billing preference
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/ResourceDialog/resource-dialog.html',
                controller: 'resourceDialogController as vm',
                locals: locals,
                multiple: true
            }).then(function(payload) {
                if (payload != null) {
                    if (payload.Transaction === 0) {
                        changeResourceTypeAction(payload)
                    } else if (payload.Transaction === 1) {
                        changeBillingTypeAction(payload);
                    } else if (payload.Transaction === 2) {
                        changeBillingPreferenceAction(payload)
                    } else if (payload.Transaction === 4) {
                        saveManageShiftAwardsAction(payload);
                    } else if (payload.Transaction === 5) {
                        saveRequiredSkillsAction(payload);
                    }
                }
            });
        }

        function showLinkItemModal(data, equipmentLists) {
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/linkItems/link-items-dialog.html',
                controller: 'linkItemsDialogController as vm',
                data: data,
                equipmentLists: equipmentLists
            }).then(function(items) {
                if(items.Data) {
                    saveLinkedItems(items.Data);
                }
            }).catch(function(ex) {
                exceptionService.resolve(ex);
            });
        }

        function saveLinkedItems(items) {
            blockUI.start("Saving...");
            allocationApi.saveLinkedResourceItems(items)
            .then(function() {
                blockUI.stop();
                // Reload the ticket's resources so the (un)link is reflected locally without
                // depending on a SignalR push — otherwise reopening the dialog shows stale state
                // (e.g. a removed linked item still appearing). Mirrors the post-save refresh used
                // by the other mutating actions in this service.
                refresh();
            })
            .catch(function(ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }

        async function unlinkItems(items) {
            await allocationApi.unlinkResourceItems(items)
            .catch(function(ex) {
                exceptionService.resolve(ex);
            });
        }

        function changeBillingPreferenceAction(payload) {
            //Changing item's billing preference
            payload.Data['StartDate'] = utils.jsDateTime(service.Equipment_StartDate);
            payload.Data['EndDate'] = utils.jsDateTime(service.Equipment_EndDate);
            payload.Data['Process'] = service.allocation_option;
            service.editBillingPreference(payload.Data);
        }

        function changeBillingTypeAction(payload) {
            //Changing item's billing type
            if (service.allocation_option === "3" && (service.Equipment_StartDate == null || service.Equipment_EndDate == null)) {
                hubService.showToast(utils.translate('RESOURCEALLOCATION.FILL_DATES'));
            } else {
                payload.Data['StartDate'] = utils.jsDateTime(service.Equipment_StartDate);
                payload.Data['EndDate'] = utils.jsDateTime(service.Equipment_EndDate);
                payload.Data['Process'] = service.TicketType === ticketType.FULL_SERVICE || service.TicketType == ticketType.TRAVEL_ONLY ? null : service.allocation_option;
                service.editBillingType(payload.Data);
            }
        }

        function changeResourceTypeAction(payload) {
            //Changing item's resource type
            payload.Data['StartDate'] = utils.jsDateTime(service.Equipment_StartDate);
            payload.Data['EndDate'] = utils.jsDateTime(service.Equipment_EndDate);
            service.editItem(payload.Data);
        }

        async function updateAriTags(allocatedResourceId, tags) {
            try {
                return await allocationApi.updateAriTags(
                    allocatedResourceId,
                    tags
                );
            } catch (ex) {
                exceptionService.resolve(ex);
            }
        }

        function saveManageShiftAwardsAction(payload) {
            blockUI.start(utils.translate('RESOURCEALLOCATION.SAVING_SHIFT_AWARDS'));
            let ariId = payload.Id;
            let params = {
                Award: payload.Data.Award,
                AwardClassification: payload.Data.AwardClassification,
                ShiftRoles: payload.Data.ShiftRoles,
                NoMinimumShift: payload.Data.NoMinimumShift
            };
            allocationApi.saveManageShiftAwards(ariId, params).then(function() {
                service.droppables.forEach(function(droppable) {
                    if (droppable.Id === payload.Data.Id) {
                        droppable.Award = angular.copy(payload.Data.Award);
                        droppable.AwardClassification = angular.copy(payload.Data.AwardClassification);
                        droppable.ShiftRoles = angular.copy(payload.Data.ShiftRoles);
                        droppable.NoMinimumShift = angular.copy(payload.Data.NoMinimumShift);
                    }
                });
                blockUI.stop();
            }).catch(function(err) {
                exceptionService.resolve(err);
                blockUI.stop();
            });
        }

        function saveRequiredSkillsAction(pay_load) {
            //Changing item's required skills
            allocationApi.saveAdditionalSkills(pay_load.Data.Id, pay_load.Data.Skills).then(function(resp) {
                service.droppables.forEach(function(droppable) {
                    if (droppable.Id === pay_load.Data.Id) {
                        droppable.AdditionalSkillIds = angular.copy(pay_load.Data.Skills);
                    }
                });
            }).catch(function(err) {
                exceptionService.resolve(err);
            });
        }

        function showNote(lineItem) {
            //Shows item's shift note (People Section)
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/ResourceNote/resource-note.html',
                controller: 'ResourceNoteController as vm',
                locals: {
                    id: lineItem.Id,
                    notes: lineItem.Notes
                }
            }).then(function(data) {
                if (data) {
                    blockUI.start(utils.translate('RESOURCEALLOCATION.SAVING_NOTE'));
                    allocationApi
                        .saveNotes(data)
                        .then(function() {
                            lineItem.Notes = data.Notes;
                            blockUI.stop();
                        })
                        .catch(function() {
                            blockUI.stop();
                        });
                }
            });
        }

        function pushV2(lineId, TicketId, Items, UserId, onCompletionFn) {
            //Triggers signalR function to notify other users that the current ticket has been modified :
            //Resource has been allocated
            //An operator has been assigned to an equipment
            //Resource has been de-allocated
            var items = [];
            items.push(Items);
            allocationApi.pushV2({
                Id: lineId,
                TicketId: TicketId,
                Items: items,
                UserId: UserId
            }).then(function() {
                if (onCompletionFn) {
                    onCompletionFn();
                }
            });
        }

        function unassignOperator(itm) {
            //Un-assign operator

            let confirm = confirmGenerator(utils.translate('RESOURCEALLOCATION.CONFIRMATION'), utils.translate('RESOURCEALLOCATION.UNASSIGN_OPERATOR_MESSAGE'), utils.translate('RESOURCEALLOCATION.CONFIRMATION'), utils.translate('RESOURCEALLOCATION.YES'), utils.translate('RESOURCEALLOCATION.NO'));
            $mdDialog.show(confirm).then(function() {
                blockUI.start("Removing Operator...");
                itm.AssignedOperatorId = null;
                allocationApi.assignOperator({
                    Id: itm.Id,
                    OperatorId: null,
                    StartDateTime: itm.StartDateTime,
                    FinishDateTime: itm.FinishDateTime,
                    TicketId: itm.TicketId,
                    ItemId: itm.ItemId
                }).then(function() {
                    service.pushV2(itm.Id, service.ticketGUID, itm, identityService.userData.UserId, function() {
                        blockUI.stop();
                    });

                }).catch(function() {
                    blockUI.stop();
                    msgboxService.show(utils.translate('RESOURCEALLOCATION.UNASSIGN_OPERATOR_ERROR')).then(function() {
                        service.reloader = true;
                        fetchTicket2();
                    });
                })
            });
        }

        function assignOperator(itm) {
            //Assign operator to an equipment
            //Payload preparation
            let operator_count = _.filter(itm.AvailableOperators, {
                AllocatedId: itm.AssignedOperatorId
            });
            let operator_in_droppable_count = _.filter(service.droppables, {
                AssignedOperatorId: itm.AssignedOperatorId
            });
            if (operator_in_droppable_count.length > operator_count.length) {
                fetchTicket2();
            }
            let operator = _.find(service.droppables, {
                AllocatedId: itm.AssignedOperatorId
            });

            assignOperatorAction({
                Id: itm.Id,
                OperatorId: itm.AssignedOperatorId,
                OperatorName: operator != null ? operator.AllocatedItemName : null,
                StartDateTime: itm.StartDateTime,
                FinishDateTime: itm.FinishDateTime,
                TicketId: itm.TicketId,
                ItemId: itm.ItemId
            }, itm)
        }

        function assignOperatorAction(pay_load, itm) {
            //Actual assignment of operator to an equipment
            //Calling api to asssignoperator
            blockUI.start("Assigning operator...");
            allocationApi.assignOperator(pay_load).then(function(resp) {
                if (resp.data.OperatedResourceItem == null) {
                    // Not assigned: if the backend returned operator-skill issues it is enforcing the
                    // lockout server-side (a blocking gap, or an overridable Medium gap awaiting a
                    // reason). No issues => the pre-existing update/concurrency failure.
                    var allocationIssues = resp.data.AllocationIssues || [];

                    // Reveal-and-prompt: overridable-only issues (no Hard) -> capture an override
                    // reason and retry with it, mirroring the drag/drop allocate path.
                    var canPromptOverride = !pay_load.OverrideReason
                        && allocationIssues.length > 0
                        && allocationIssues.some(function(x) { return x.CanBeOverriden; })
                        && allocationIssues.every(function(x) { return x.LockoutType !== service.lockoutType.HardLockout; });

                    if (canPromptOverride) {
                        blockUI.stop();
                        $mdDialog.show({
                            templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                            controller: 'overrideReasonDialogController as vm',
                            locals: { data: pay_load }
                        }).then(function(overrideResult) {
                            if (overrideResult && overrideResult.Reason) {
                                pay_load.OverrideReason = overrideResult.Reason;
                                assignOperatorAction(pay_load, itm);
                            } else {
                                // Cancelled: revert the pending dropdown selection.
                                service.reloader = true;
                                fetchTicket2();
                            }
                        });
                        return;
                    }

                    blockUI.stop();

                    if (allocationIssues.length > 0) {
                        // Blocking gap (Hard, or Medium without the override claim): show the reason(s).
                        var messages = '<ul>' + allocationIssues.map(function(x) {
                            return '<li style="color:' + (!x.CanBeOverriden && !x.IsValidToAllocate ? '#d50000' : '#FF7800') + '">' + x.Message + '</li>';
                        }).join("") + '</ul>';

                        var notif = $mdDialog.alert()
                            .parent(angular.element(document.body))
                            .clickOutsideToClose(false)
                            .title('Assign Operator')
                            .htmlContent(messages)
                            .ariaLabel('Assign Operator')
                            .ok('Ok');

                        $mdDialog.show(notif).then(function() {
                            service.reloader = true;
                            fetchTicket2();
                        });
                    } else {
                        msgboxService.show(utils.translate('RESOURCEALLOCATION.ASSIGN_OPERATOR_ERROR')).then(function() {
                            service.reloader = true;
                            fetchTicket2();
                        });
                    }
                } else {
                    service.pushV2(itm.Id, service.ticketGUID, itm, identityService.userData.UserId);
                    fetchTicket2();
                }
            }).catch(function() {
                blockUI.stop();
                msgboxService.show(utils.translate('RESOURCEALLOCATION.ASSIGN_OPERATOR_ERROR2')).then(function() {
                    service.reloader = true;
                    fetchTicket2();
                });
            });
        }

        function saveTimesheetManager(itm) {
            // Update model and prevent deselection of a ticked checkbox
            itm.IsTimesheetManager = true;

            // Check if the selection has changed before saving
            let changed = false;
            angular.forEach(service.droppables, function(droppable) {
                if (itm !== droppable) {
                    if (droppable.IsTimesheetManager) {
                        changed = true;
                    }
                    droppable.IsTimesheetManager = false;
                }
            });

            if (changed) {
                hubService.showToast(utils.translate('RESOURCEALLOCATION.SAVING_TIMESHEET_MANAGER'));
                service.reloader = true;
                service.fetchingAvailableResources = true;
                allocationApi
                    .saveTimesheetManager(itm)
                    .then(function() {
                        service.reloader = false;
                        service.fetchingAvailableResources = false;
                    })
                    .catch(function() {
                        msgboxService.show(utils.translate('RESOURCEALLOCATION.TIMESHEET_MANAGER_ERROR')).then(function() {
                            refresh();
                        });
                    });
            }
        }

        async function unAllocateResource(pay_load) {
            service.droppables = service.fetchOperators(service.droppables);
            service.IsMultiDayEquipmentJob ? (isOptionIncludesDateRange() ? showFillDatesIssue() : unallocateMultipleDay(pay_load)) : await unallocateRegular(pay_load);

            await smartSchedulingService.updatePreScheduleJobStatus(service.ticketInfo.PreScheduleJobIds);

            let ticketData = await jobsApi.getTicketWithCustomFieldsByTicketId(service.ticketGUID);
            setTicketData(ticketData);
        }

        function isOptionIncludesDateRange() {
            //if a ticket is multiday adn equipment-only
            //and includes date range
            return service.allocation_option === "3" && (service.Equipment_StartDate == null || service.Equipment_EndDate == null);
        }

        function unallocateMultipleDay(pay_load) {
            isOptionIncludesDateRange() ?
                hubService.showToast(utils.translate('RESOURCEALLOCATION.FILL_DATES')) :
                unallocateMultipleDayAction(pay_load);
        }

        function setDates(pay_load) {
            //Set Dates before allocation
            pay_load['StartDate'] = utils.jsDateTime(service.Equipment_StartDate);
            pay_load['EndDate'] = utils.jsDateTime(service.Equipment_EndDate);
            return pay_load;
        }

        function unallocateMultipleDayAction(pay_load) {
            allocationApi
                .unAllocateResourceMultiDay(setDates(pay_load))
                .then(function() {
                    fetchTicket2();
                    service.pushV2(pay_load.Id, service.ticketGUID, pay_load, identityService.userData.UserId);
                }).catch(unallocateFailCallback);
        }

        async function unallocateRegular(pay_load) {
            try{
                await allocationApi.unAllocateResourceRegular(pay_load);

                fetchTicket2();
                service.pushV2(pay_load.Id, service.ticketGUID, pay_load, identityService.userData.UserId);
            }
            catch(ex){
                exceptionService.resolve(ex);
            }
        }

        function unallocateFailCallback() {
            msgboxService.show(utils.translate('RESOURCEALLOCATION.UNALLOCATION_ERROR')).then(function() {
                service.reloader = true;
                fetchTicket2();
            });
        }

        function formatStartTime(time_line) {
            time_line.StartTime = TimeLibrary.convertTime(time_line.StartTime);
            time_line['TimesAreValid'] = checkTimeIfValid(time_line);
        }

        function formatFinishTime(time_line) {
            time_line.FinishTime = TimeLibrary.convertTime(time_line.FinishTime);
            time_line['TimesAreValid'] = checkTimeIfValid(time_line);
        }

        function formatTime(time_line, type) {
            type == 'start' ? formatStartTime(time_line) : formatFinishTime(time_line);
        }

        function getBranchDivisions() {
            branchApi.getBranchDivisions(service.BranchId).then(function(resp) {
                service.divisions = _.orderBy(resp.data, ['Name'], ['asc']);
            });
        }

        function getAllocationOption() {
            return (service.allocation_option == null || service.previous_ticket_no == null) ?
                2 :
                ((service.previous_ticket_no === service.ticketNo) ? service.allocation_option : 2);
        }

        function closeSideNavIfOpen() {
            if ($mdSidenav("right").isOpen()) {
                $mdSidenav("right").toggle();
            }
        }

        function openSideNav() {
            if (!$mdSidenav("right").isOpen()) {
                $mdSidenav("right").toggle();
            }
        }

        async function actionsBeforeFetchTicket() {
            //To be executed before fetching ticket line items/requirements
            //Initializes variables
            service.allocation_option = getAllocationOption();
            service.Equipment_StartDate = null;
            service.Equipment_EndDate = null;
            service.divisionId = null;
            service.divisions = [];

            await loadFilterSettings();

            $mdDialog.hide();
            service.closeSideNavIfOpen();
            setMeasurementPostfix();
        }

        function fetchTicketInitalLoad() {
            //Returns list of APIs before fetching line items
            //This function is being called on initial load of resource allocation page
            //Calls resource like data (preload)
            return $q.all(
                [
                    allocationApi.fetchTicket(service.ticketGUID),
                    jobsApi.getTicketWithCustomFieldsByTicketId(service.ticketGUID),
                    ticketBillingService.getBillingPeriod(),
                    allocationApi.preload(service.ticketGUID)
                ]);
        }

        function clearDefaultvalues() {
            service.lookUps2 = [];
            service.lookUps = [];
            service.showDraggables = false;
            service.operators = [];
            service.selectedRow = [];
        }

        function setIsEquipment() {
            service.is_equipment = service.TicketType == ticketType.EQUIPMENT_ONLY ? true : false;
        }

        function setTicketData(pay_load) {
            let data = pay_load.data.m_Item1;
            service.ticketInfo = data;
            service.BranchId = data.BranchId;
            service.BranchName = data.BranchName;
            service.divisionId = data.DivisionId;
            service.ParentTicketNumber = getParentTicketNumber((data.ParentTicketNumber == "" || data.ParentTicketNumber == null) ? null : data.ParentTicketNumber);

            if (claimsUtilService.isCostProjectionEnabled()) {
                loadCostEstimate(data.CostEstimateNumber);
            }
        }

        function getPreloadData(pay_load) {
            let data = pay_load.data;
            service.TicketType = data.TicketType;
            setIsEquipment();
            service.JobDisplayDate = data.JobDisplayDate;
            service.IsMultiDayEquipmentJob = service.TicketType === ticketType.FULL_SERVICE || service.TicketType === ticketType.TRAVEL_ONLY ? false : data.IsMultiDayEquipmentJob;
        }

        function setBillingType(pay_load) {
            service.BillingTypes = pay_load.data;
        }

        function setPeopleResource(requirements) {
            service.peopleResource = requirements.filter(p => p.ItemType == 4).length;
        }
        function setAllocatedResource(data) {
            service.allocatedResource = data
        }

        function setRequirements(requirements) {
            if (requirements.length > 0) {
                service.droppables = processRequirements(requirements);
                stopProcessors();
            }
        }

        function processRequirements(requirements) {
            //This function gets possible operators of each equipment, if there are allocated people
            //Sets numbering
            //Formats start and finish time of each line item
            return setItemNumbering(service.fetchOperators(formatTimeOnFetch(requirements)));
        }

        function setItemNumbering(requirements) {
            //Sets numbering for display
            var result = [];
            _.forEach(requirements, function(item) {
                var item_name_count = _.filter(result, {
                    ItemName: item.ItemName
                }).length;
                item['ItemNameDisplay'] = item.ItemName + " #" + (item_name_count + 1);
                result.push(item);
            });
            return result;
        }

        function formatTimeOnFetch(requirements) {
            //Formats time according to preference
            _.forEach(requirements, function(item) {
                item.StartTime = TimeLibrary.convertTime(item.StartTime);
                item['PreviousStartTime'] = angular.copy(item.StartTime);
                item.FinishTime = TimeLibrary.convertTime(item.FinishTime);
                item['PreviousFinishTime'] = angular.copy(item.FinishTime);

                item['TimesAreValid'] = checkTimeIfValid(item);
            });
            return requirements;
        }

        function checkTimeIfValid(item) {
            let start_time_valid = item.StartTime != null && item.StartTime != "" && item.StartTime != '';
            let finish_time_valid = item.FinishTime != null && item.FinishTime != "" && item.FinishTime != '';
            return start_time_valid && finish_time_valid;
        }

        function stopProcessors() {
            //Stops animators/processors
            service.showDroppableLoader = false;
            service.reloader = false;
        }

        function setFetchedResources(resp) {
            //After calling api to fetch ticket's line items/requirements
            //Execute the following sub functions to properly set service and local variables
            $timeout(async function() {
                clearDefaultvalues();
                service.isSmartSchedulingFailed = await isSmartSchedulingCallbackFailed(resp[1].data.m_Item1.LatestPreScheduleJobId);
                setTicketData(resp[1]);
                setBillingType(resp[2]);
                getPreloadData(resp[3]);
                getBranchDivisions();
                setRequirements(resp[0].data);
                setPeopleResource(resp[0].data);
                setAllocatedResource(resp[0].data);
                stopProcessors();
                fetchSuggestedResources(resp[1])
                blockUI.stop();
                $q.all(getMinifiedEquipment(resp[1].data.m_Item1.BranchId)).then(setMinifiedEquipment);
            });

            fetchTicketPostProcess();
        }

        function fetchTicketPostProcess() {
            service.previous_ticket_no = service.ticketNo;
            service.fetch_called++;
        }

        function setMinifiedEquipment(resp) {
            service.EquipmentTypes = resp[0].data;
            service.peopleTypes = resp[1].data.sort(function(a, b) {
                return b.Name - a.Name
            });
        }

        function getMinifiedEquipment(branchId) {
            return [
                lookupApi.getMinifiedEquipmentTypes(),
                lookupApi.getMinifiedPeopleTypesByBranch(branchId)
            ];
        }

        function getResourceLikeandSkillRequirements() {
            //Fetches resource like data
            service.resource_like_has_been_called = true;
            $q.all([allocationApi.getResourceLike(service.ticketGUID), allocationApi.getSkills()]).then(function(response) {
                service.PastResourceLike = response[0].data.PastResourceLikeTickets;
                service.FutureResourceLike = response[0].data.FutureResourceLikeTickets;
                service.resource_like_data = resourceLikeService.formatResourceLikeData(service.PastResourceLike, service.droppables);
                service.resource_like_flag = _.filter(service.resource_like_data);
                service.SkillsList = response[1].data;
            }).catch(function(err) {
                exceptionService.resolve(err);
            });
        }

        function fetchTicket() {
            if (service.fetch_called !== 0) {
                return;
            }

            service.fetch_called++;

            actionsBeforeFetchTicket().then(function(){
                fetchTicketInitalLoad()
                    .then(setFetchedResources)
                    .finally(getResourceLikeandSkillRequirements);
            }).catch(function(err) {
                exceptionService.resolve(err);
            });
        }

        function formatOperator(operator, resources) {
            let isAllocatedToEquipment = resources.some(x => x.AssignedOperatorId === operator.AllocatedId);

            return {
                AllocatedId: operator.AllocatedId,
                AllocatedCode: operator.AllocatedCode,
                AllocatedItemName: operator.AllocatedItemName,
                ItemId: operator.ItemId,
                IsAllocatedToEquipment: isAllocatedToEquipment
            };
        }

        function editItem(data) {
            //Change line item's resource type
            hubService.showToast(utils.translate('RESOURCEALLOCATION.CHANGING_RESOURCE_TYPE'));
            service.reloader = true;
            service.fetchingAvailableResources = true;
            data['Process'] = service.IsMultiDayEquipmentJob ? service.allocation_option : null;
            allocationApi.editItem(data).then(function(resp) {
                if (resp.data && resp.data.m_Item2) {
                    service.reloader = false;
                    service.fetchingAvailableResources = false;
                    msgboxService.show(resp.data.m_Item2).then(function() {
                        refresh();
                    });
                } else {
                    refresh();
                }
            }).catch(function() {
                msgboxService.show(utils.translate('RESOURCEALLOCATION.ERROR_CHANGING_RESOURCE_TYPE')).then(function() {
                    refresh();
                });
            });
        }

        function editBillingType(data) {
            //Change line item's billing type
            hubService.showToast(utils.translate('RESOURCEALLOCATION.CHANGING_BILLING_TYPE'));
            service.reloader = true;
            service.fetchingAvailableResources = true;
            allocationApi.editBillingType(data).then(function(resp) {
                if (!resp.data) {
                    msgboxService.show(utils.translate('RESOURCEALLOCATION.ERROR_CHANGING_BILLING_TYPE')).then(function() {
                        refresh();
                    });
                } else {
                    refresh();
                }
            }).catch(function() {
                msgboxService.show(utils.translate('RESOURCEALLOCATION.ERROR_CHANGING_BILLING_TYPE')).then(function() {
                    refresh();
                });
            });
        }

        function refresh() {
            //To refresh ticket's line items without calling resource like
            //Being called after allocation, de-allocation, assigning perator
            service.fetchingAvailableResources = false;
            service.reloader = false;
            fetchTicket2();
        }

        function editBillingPreference(data) {
            //Function to edit line item's billing preference
            stopProcessors();
            let billing = _.find(service.BillingTypes, {
                ItemId: parseInt(data.BillingPreference)
            });
            allocationApi.editBillingPreference({
                Id: data.Id,
                BillingPreference: billing.Id,
                IsNotBillable: billing.IsNotBillable,
                Process: service.IsMultiDayEquipmentJob ? data.Process : null,
                ReferenceId: data.ReferenceId,
                StartDate: data.StartDate,
                EndDate: data.EndDate,
                TicketId: service.ticketGUID
            }).then(function(resp) {
                resp.data ? refresh() : showEditBillingPreferenceError();
            }).catch(showEditBillingPreferenceError);
        }

        function showEditBillingPreferenceError() {
            //Will be shown if editing billing preference encounters an error during saving
            msgboxService.show(utils.translate('RESOURCEALLOCATION.ERROR_CHANGING_BILLING_PREFERENCE')).then(function() {
                refresh();
            });
        }

        function actionBeforeTicketRefresh() {
            //Before refreshing line items, it's necessary to set service variables to its default values
            service.allocation_option = getAllocationOption();
            service.Equipment_StartDate = null;
            service.Equipment_EndDate = null;
            service.fetchingAvailableResources = false;
            service.reloader = false;
            service.hasCheckedCreditStatus = false;
            service.closeSideNavIfOpen();
        }

        function clearDefaultsOnRefresh() {
            service.showDraggables = false;
            service.operators = [];
        }

        function refreshAllocationScreen(resp) {
            //To set variables on refresh screen
            $timeout(function() {
                clearDefaultsOnRefresh();
                getPreloadData(resp[1]);
                setIsEquipment();
                setRequirements(resp[0].data);
                setPeopleResource(resp[0].data);
                setAllocatedResource(resp[0].data);
                stopProcessors();
                blockUI.stop();
            });
        }

        function fetchTicket2() {
            //Refresh Line Items
            actionBeforeTicketRefresh();

            $q.all(
                [
                    allocationApi.fetchTicket(service.ticketGUID),
                    allocationApi.preload(service.ticketGUID)
                ]
            ).then(refreshAllocationScreen);

            service.previous_ticket_no = service.ticketNo;
        }

        function loadPeopleIntoMasterList() {
            orderResourceByProp('Name');
        }

        function loadEquipmentIntoMasterList(itm) {
            itm.DisplayUniqueItemId != null ? orderResourceByProp('Code') : orderResourceByProp('Name');
        }

        function orderResourceByProp(prop) {
            service.lookUps = _.orderBy(service.lookUps, [prop], ['asc']);
        }

        function onResourcesFound(itm) {
            itm.ItemType == 4 ?
                loadPeopleIntoMasterList() :
                loadEquipmentIntoMasterList(itm);

            service.noAvailableItem = false;
            service.showDraggableLoader = false;
            service.showDraggables = true;
            service.fetchingAvailableResources = false;
            service.hasLoadedOnce = true;
            blockUI.stop();

            filterList();

            service.openSideNav();
        }

        function noResourcesFound(itm) {
            service.fetchingAvailableResources = false;
            service.showDraggableLoader = false;
            service.noAvailableItem = true;
            service.hasLoadedOnce = true;
            service.nullMessage = itm.ItemType == 4 ?
                utils.translate('RESOURCEALLOCATION.NO_PEOPLE_AVAILABLE') :
                utils.translate('RESOURCEALLOCATION.NO_EQUIPMENT_AVAILABLE');
            blockUI.stop();

            service.openSideNav();
        }

        function getResourcesNow(itm) {
            service.displayUniqueId = itm.DisplayUniqueItemId;

            allocationApi.getAvailableResources(
                itm.Id,
                itm.TicketId,
                itm.TicketNumber,
                itm.ItemId,
                itm.ItemType == 4 ? 0 : 1,
                itm.StartDateTime,
                itm.FinishDateTime,
                service.ticketInfo.JobLocationAddress.Location.Longitude,
                service.ticketInfo.JobLocationAddress.Location.Latitude,
                service.ticketInfo.BranchId,
                service.ticketInfo.CompanyId,
                service.ticketInfo.DivisionId,
                service.ticketInfo.ProjectId,
                service.ticketInfo.SiteContactId
            ).then(function(resp) {
                var responseData = resp.data;
                var resources = responseData.Resources || responseData || [];

                service.lookUps = resources;

                if (resources.length > 0) {
                    onResourcesFound(itm);
                } else {
                    noResourcesFound(itm);
                }
            }).catch(function(err) {
                service.fetchingAvailableResources = false;
                blockUI.stop();
                exceptionService.resolve(err);
            });
        }

        function showFetchResourcesError() {
            blockUI.stop();

            $mdDialog.show(
                $mdDialog.alert()
                .title(utils.translate('RESOURCEALLOCATION.RESOURCE-ALLOCATION'))
                .textContent(utils.translate('RESOURCEALLOCATION.CREDIT_HOLD_MESSAGE'))
                .ariaLabel(utils.translate('RESOURCEALLOCATION.RESOURCE-ALLOCATION'))
                .ok(utils.translate('RESOURCEALLOCATION.OKAY'))
            );
        }

        function loadResourcesForShift(itm, index, source) {
            if (service.fetchingAvailableResources) {
                return;
            }

            if (service.ticketInfo.IsLockedByPreSchedule) {
                return;
            }

            jobsApi.getTicketByTicketId(itm.TicketId).then(function(response) {
                const ticket = response.data;
                if (ticket && ticket.IsCancelled) {
                    msgboxService.alert('Cancelled Ticket', 'Ticket #' + ticket.TicketNumber + ' has been cancelled by another user. Please refresh the page', 'Refresh');
                    return;
                }

                blockUI.start("Loading Resources...");

                service.selectedRow = index;
                service.clickSource = source;
                service.selectedItem = itm;
                service.searchText = null;
                service.fetchingAvailableResources = true;
                service.noAvailableItem = false;

                if (!service.hasCheckedCreditStatus) {
                    allocationApi.getCompanyCreditType(service.ticketGUID)
                        .then(function(resp) {
                            service.hasCheckedCreditStatus = true;
                            service.canAllocateResources = resp.data.CanAllocateResources;
                            service.canAllocateResources ? getResourcesNow(itm) : showFetchResourcesError();
                        });

                    return;
                }

                service.canAllocateResources ? getResourcesNow(itm) : showFetchResourcesError();

            });
        }

        function allocateResource(pay_load) {
            pay_load = preparePayLoadForAllocation(pay_load, false, null);
            let isPersonResource = pay_load.ResourceType === 0;

            if (isPersonResource) {
                let deferred = $q.defer();

                timesheetApi.getTimesheet(pay_load.TicketId).then(function(response) {
                    let timesheet = response.data;
                    let hasATimesheetSubmitted = false;
                    deferred.resolve(response.data);

                    if (timesheet) {
                        let timesheetDetails = Object.values(timesheet.TicketTimesheetsDetails);
                        hasATimesheetSubmitted = timesheetDetails.some(function(data) {
                            return data.JobStartTime && data.JobEndTime
                        });
                    }

                    if (timesheet && timesheet.IsLocked) {
                        showTimesheetLockedAndSubmittedAlert(pay_load, timesheet.id);
                    } else if (hasATimesheetSubmitted) {
                        showTimesheetSubmittedAlert(pay_load);
                    } else {
                        updateAllocatedResource(pay_load);
                    }

                }, function(err) {
                    exceptionService.resolve(err);
                    deferred.reject(err);
                });

                return;
            }

            updateAllocatedResource(pay_load);
        }

        function showTimesheetSubmittedAlert(pay_load) {
            $mdDialog.show(
                $mdDialog.alert()
                .title(utils.translate('RESOURCEALLOCATION.RESOURCE-ALLOCATION'))
                .clickOutsideToClose(false)
                .textContent(utils.translate('RESOURCEALLOCATION.ADD_RESOURCE_WITH_SUBMITTED_TIMESHEET'))
                .ok('Okay')
            ).then(function(res) {
                if (res) {
                    updateAllocatedResource(pay_load);
                }
            });
        }

        function showTimesheetLockedAndSubmittedAlert(pay_load, timesheetId) {
            let confirm = $mdDialog
                .confirm()
                .title(utils.translate('RESOURCEALLOCATION.RESOURCE-ALLOCATION'))
                .htmlContent(utils.translate('RESOURCEALLOCATION.ADD_RESOURCE_WITH_LOCKED_AND_SUBMITTED_TIMESHEET'))
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm).then(function() {
                blockUI.start(
                    "Unlocking timesheet..."
                );
                timesheetApi.lockUnlockTimesheet(
                        timesheetId,
                        true
                    )
                    .then(function() {
                        blockUI.stop();
                    })
                    .catch(function(err) {
                        blockUI.stop();
                        exceptionService.resolve(err);
                    });

                updateAllocatedResource(pay_load);
            });
        }

        function updateAllocatedResource(pay_load) {
            updateDroppablesView(pay_load);
            (service.is_equipment && service.IsMultiDayEquipmentJob) ? allocateEquipment(pay_load): allocateFullService(pay_load);
        }

        function preparePayLoadForAllocation(pay_load, is_overriden, override_reason) {
            //Prepare payload before allocating a resource
            pay_load['PreviousAllocatedId'] = angular.copy(service.selectedItem.AllocatedId);
            pay_load['IsOverridden'] = is_overriden;
            pay_load['OverrideReason'] = override_reason;
            pay_load['ReferenceId'] = service.selectedItem.ReferenceId;

            if (service.displayUniqueId && service.clickSource === "Equipment") {
                pay_load.AllocatedItemName = pay_load.AllocatedCode + (pay_load.AllocatedItemName ? " - ".concat(pay_load.AllocatedItemName) : "");
            }

            if (service.is_equipment && service.IsMultiDayEquipmentJob) {
                pay_load.StartDate = service.allocation_option === "3" ? moment(pay_load.StartDate).format('YYYY-MM-DD') : null;
                pay_load.EndDate = service.allocation_option === "3" ? moment(pay_load.EndDate).format('YYYY-MM-DD') : null;
            }

            return pay_load;
        }

        function updateDroppablesView(pay_load) {
            //To update line items after allocation without calling refresh/fetchTicket2
            service.selectedItem.AllocatedId = pay_load.AllocatedId;
            angular.forEach(service.droppables, function(droppable) {
                if (droppable.Id === pay_load.Id) {
                    droppable.AllocatedId = pay_load.AllocatedId;
                    droppable.Status = 2;
                    droppable.AllocatedItemName = pay_load.AllocatedItemName;
                    service.showDraggables = false;
                }
            });
            service.droppables = service.fetchOperators(service.droppables);
        }

        function allocateFullService(payLoad) {
            blockUI.start(utils.translate('RESOURCEALLOCATION.ALLOCATING') + '....');
            allocationApi.allocateResource(payLoad).then(function(resp) {
                if (resp.data) {
                    let messages = "";
                    let autoAllocationResults = resp.data.RelatedResourceAutoAllocationResults;

                    const groupBy = (array, fn) => {
                        var groups = {};
                        array.forEach(function(obj) {
                            var group = JSON.stringify(fn(obj));
                            (groups[group] = groups[group] || []).push(obj);
                        });

                        return groups;
                    };

                    if (autoAllocationResults && autoAllocationResults.length > 0) {
                        let relatedResourceName = resp.data.RelatedResourceName;
                        let relationToMainResource = resp.data.RelatedResourceRelationToMainResource;

                        messages = `Unable to allocate ${escapeHtml(relationToMainResource)} <strong>${escapeHtml(relatedResourceName)}</strong><br/><br/>`;

                        var groupedAllocationIssues = groupBy(autoAllocationResults, function(item) {
                            return [item.AllocationIssues];
                        });

                        let renderIssueList = function(issues) {
                            return '<ul>' + issues.map(x => `<li style="color:${!x.CanBeOverriden && !x.IsValidToAllocate ? '#d50000' : '#FF7800'}">${escapeHtml(x.Message)}</li>`).join("") + '</ul>';
                        };

                        messages += Object.keys(groupedAllocationIssues).map(function(key) {
                            let shiftsByIssue = groupedAllocationIssues[key];
                            // Issues are identical within a group (part of the group key); read them
                            // off the first item so we keep the objects (incl. SourceItemName).
                            let allocationIssues = (shiftsByIssue[0].AllocationIssues || []).flat();
                            let message = "";

                            // #51715: dedup repeated headings within a group — a ticket with
                            // multiple slots of the same shift (or equipment) produces one
                            // result per slot with the same name, which would otherwise print
                            // the heading more than once. Mirrors the backend per-equipment
                            // dedup done for #51720.
                            let seenHeadings = new Set();
                            shiftsByIssue.forEach(x => {
                                let heading = x.EquipmentName || x.ShiftName;
                                if (heading && !seenHeadings.has(heading))
                                {
                                    seenHeadings.add(heading);
                                    message += `<strong>${escapeHtml(heading)}</strong><br/>`
                                }
                            })

                            // Parent and linked-item warnings each get their own heading.
                            // Issues with no SourceItemName belong to the result's own item (the
                            // heading above); issues with one are grouped under that linked item's
                            // name, and the redundant "(required by ...)" clause is stripped since the
                            // heading now conveys the source.
                            let ownIssues = allocationIssues.filter(x => !x.SourceItemName);
                            if (ownIssues.length > 0) {
                                message += renderIssueList(ownIssues);
                            }

                            let bySource = {};
                            let sourceOrder = [];
                            allocationIssues.filter(x => x.SourceItemName).forEach(x => {
                                if (!bySource[x.SourceItemName]) {
                                    bySource[x.SourceItemName] = [];
                                    sourceOrder.push(x.SourceItemName);
                                }
                                let cleaned = angular.extend({}, x, {
                                    Message: x.Message.replace(/\s*\(required by (?:trailer|equipment) "[^"]*"\)\s*$/i, '')
                                });
                                bySource[x.SourceItemName].push(cleaned);
                            });

                            sourceOrder.forEach(function(src) {
                                message += `<strong>${escapeHtml(src)}</strong><br/>` + renderIssueList(bySource[src]);
                            });

                            return message;
                        }).join("");
                    }

                    let allocationIssues = resp.data.AllocationIssues;
                    if (allocationIssues && allocationIssues.length > 0) {
                        messages += '<ul>' + allocationIssues.map(x => `<li style="color:${!x.CanBeOverriden && !x.IsValidToAllocate ? '#d50000' : '#FF7800'}">${escapeHtml(x.Message)}</li>`).join("") + '</ul>';
                    }

                    // Reveal-and-prompt: if the backend returned overridable operator issues
                    // (and nothing was allocated yet), capture an override reason and re-post
                    // instead of showing a blocking error. Mirrors draggable-equipment canOverride.
                    let canPromptOverride = !payLoad.IsOverridden
                        && allocationIssues
                        && allocationIssues.some(x => x.CanBeOverriden)
                        && allocationIssues.every(x => x.LockoutType !== service.lockoutType.HardLockout);

                    if (canPromptOverride) {
                        blockUI.stop();
                        $mdDialog.show({
                            templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                            controller: 'overrideReasonDialogController as vm',
                            locals: { data: payLoad }
                        }).then(function(overrideResult) {
                            if (overrideResult) {
                                payLoad.IsOverridden = true;
                                payLoad.OverrideReason = overrideResult.Reason;
                                allocateFullService(payLoad);
                            }
                        });

                        return;
                    }

                    if (messages) {
                        var notif = $mdDialog.alert()
                            .parent(angular.element(document.body))
                            .clickOutsideToClose(false)
                            .title('Resource Allocation')
                            .htmlContent(messages)
                            .ariaLabel('Resource Allocation')
                            .ok('Ok')

                        $mdDialog.show(notif);
                    }
                }
                else {
                    msgboxService.alert('Resource Allocation', 'This ticket has been updated by another user. Please refresh the page', 'Okay').then(function(res) {
                        if(res){
                            refreshFromSignalR([])
                            $state.reload();
                        }
                    });
                }

                fetchTicket2();
                service.pushV2(payLoad.Id, service.ticketGUID, payLoad, identityService.userData.UserId);
            }).catch(function(error) {
                var msg = utils.translate('RESOURCEALLOCATION.ALLOCATION_ERROR');
                if (error.data.Message) {
                    msg = error.data.Message;
                }

                exceptionService.showError(msg, function() {
                    service.reloader = true;
                    fetchTicket2();
                }, "Unable to allocate resource");
            });
        }

        function checkForErrors(data) {
            if (data.Results != null) {
                validateErrors(data.Results);
            }
        }

        function validateErrors(message_array) {
            if (message_array.length > 0) {
                let errors = message_array.filter(p => !p.WasResourced);
                if (errors.length > 0) {
                    showResourceLikeMessages(errors);
                }
            }
        }

        function allocateEquipment(payLoad) {
            blockUI.start(utils.translate('RESOURCEALLOCATION.ALLOCATING') + '....');
            allocationApi.allocateEquipment(payLoad).then(function(resp) {
                fetchTicket2();
                service.pushV2(payLoad.Id, service.ticketGUID, payLoad, identityService.userData.UserId);
                checkForErrors(resp.data);
            }).catch(function(error) {
                var msg = utils.translate('RESOURCEALLOCATION.ALLOCATION_ERROR');
                if (error.data.Message) {
                    msg = error.data.Message;
                }

                exceptionService.showError(msg, function() {
                    service.reloader = true;
                    fetchTicket2();
                }, "Unable to allocate equipment");

            });
        }

        function allocateResourceOverride(pay_load, override_reason) {
            pay_load = preparePayLoadForAllocation(pay_load, true, override_reason);
            updateAllocatedResource(pay_load);
        }

        function bindData(data) {
            service.operators = [];
            service.peopleResource = _.filter(data, {
                ItemType: 4
            }).length;
            service.droppables = service.fetchOperators(setDataForBinding(data));
        }

        function setDataForBinding(data) {
            var result = [];

            angular.forEach(data, function(item) {
                item['PossibleOperators'] = item.ItemType == "4" ? false : [];

                item.StartTime = TimeLibrary.convertTime(item.StartTime);
                item.FinishTime = TimeLibrary.convertTime(item.FinishTime);

                var item_name_count = _.filter(result, {
                    ItemName: item.ItemName
                }).length;
                item['ItemNameDisplay'] = item.ItemName + " #" + (item_name_count + 1);

                result.push(item);
            });

            return result;
        }

        function getDataModel(data) {
            //Model for allocating a resource
            return {
                AllocatedResourceItemId: service.selectedItem.Id,
                AllocatedId: data.Id,
                AllocatedItemName: data.Name,
                AllocatedCode: data.Code,
                ResourceType: service.selectedItem.ItemType == 4 ? 0 : 1,
                TicketId: service.selectedItem.TicketId,
                ItemId: service.selectedItem.ItemId,
                Id: service.selectedItem.Id,
                Process: service.is_equipment ? service.allocation_option : null,
                StartDate: service.Equipment_StartDate,
                EndDate: service.Equipment_EndDate
            }
        }

        function getActualIndex() {
            //returns the actual index from the line items
            return service.droppables.map(function(e) {
                return e.Id;
            }).indexOf(service.selectedItem.Id);
        }

        function fetchOperators(requirements) {
            //Fetch operators main function
            angular.forEach(requirements, function(requirement) {
                requirement['AvailableOperators'] = requirement.ItemType == "4" ? false : getOperatorsForEquipment(requirement, requirements);
            });

            return requirements;
        }

        function getOperatorsForEquipment(requirement, requirements) {
            //To return eligible operators for each equipment
            let people = requirements.filter(p => p.ItemType == 4);
            let equipments = requirements.filter(p => p.ItemType !== 4);
            let skill_requirements = requirement.SkillIds;
            let available_operators = [];

            //Filter Operator by Skills
            angular.forEach(people, function(people_item) {
                //#51073 (Fix B): exclude an operator the current user cannot select for THIS
                //vehicle because they have a blocking, non-overridable operator-skill issue
                //for it. requirement.BlockedOperatorIds is computed per-vehicle on the
                //backend (each vehicle assessed against its OWN required operator skills),
                //so a Medium operator skill on a DIFFERENT vehicle no longer suppresses this
                //operator. Medium + override stays selectable; Hard operator skills are
                //excluded via the SkillIds skill-presence match below.
                if ((requirement.BlockedOperatorIds || []).indexOf(people_item.AllocatedId) !== -1) {
                    return;
                }
                //@NOTE: different equipment types will not match the shift requirement with the people's itemID
                if (skillHasNoRequirements(people_item, skill_requirements, available_operators)) {
                    available_operators.push(formatOperator(people_item, equipments));
                } else {
                    let isSameOperator = people_item.AllocatedId == null || people_item.AllocatedId == undefined ? false : requirement.AssignedOperatorId === people_item.AllocatedId;
                    //if it requires skills
                    if (skillMatchesRequirements(skill_requirements, people_item, available_operators) || isSameOperator) {
                        available_operators.push(formatOperator(people_item, equipments));
                    }
                }
            });

            return _.orderBy(available_operators, ['AllocatedItemName'], ['asc']);
        }

        function skillHasNoRequirements(people_item, skill_requirements, available_operators) {
            //If item has no skills being required, then return all allocated people as eligible operators
            return skill_requirements.length === 0 && people_item.AllocatedId != null && !checkSameShiftOperatorIfExists(available_operators, people_item)
        }

        function skillMatchesRequirements(skill_requirements, people_item, available_operators) {
            //If item has skills being required, then return all allocated people with skills being required
            let match = countMatch(skill_requirements, people_item);
            return people_item.AllocatedId != null && match == skill_requirements.length && !checkOperatorIfExists(available_operators, people_item)
        }

        function countMatch(skill_requirements, people_item) {
            //Counts skills match from equipment and from person's acquired skills
            let match = 0;
            angular.forEach(skill_requirements, function(skill_req) {
                if (people_item.SkillIds.includes(skill_req) && !people_item.ExpiredSkillIds.includes(skill_req)) {
                    match++;
                }
            });
            return match;
        }

        function checkOperatorIfExists(collection, operator) {
            return _.find(collection, {
                AllocatedId: operator.AllocatedId
            });
        }

        function checkSameShiftOperatorIfExists(operators, requirement) {
            return _.find(operators, function(operator) {
                return operator.AllocatedId === requirement.AllocatedId && operator.ItemId === requirement.ItemId;
            });
        }

        function allocate2(data) {
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html',
                controller: 'overrideReasonDialogController as vm',
                locals: {
                    data: data
                }
            }).then(function(resp) {
                if (resp) {
                    allocateResourceOverride(resp.Data, resp.Reason);
                }
            });
        }

        function showJobAllocationDialog() {
            $mdDialog.show({
                templateUrl: 'app/main/jobs/allocateResource/components/droppableComponent/jobAllocation/message.html',
                controller: 'resourceMessagingController as vm',
                locals: {
                    ticketGUID: service.ticketGUID
                }
            });
        }

        function showMessageDialog() {
            sendMessageService.open(null, getJobRecipientGroups());
        }

        function getJobRecipientGroups() {
            //Quick Fill groups for the Send a Message dialog. People assigned as equipment operators
            //are already people line items on this job, so scanning people covers them; one person can
            //hold several shifts, hence the de-duplication by contact.
            let allocated = [];
            let accepted = [];

            _.forEach(service.droppables, function(item) {
                if (item.ItemType !== ITEM_TYPE_PEOPLE || !item.AllocatedId) {
                    return;
                }

                //A shift the person turned down is not one they are working, so it does not make them
                //a recipient. A shift they have not confirmed yet still does.
                if (item.Status === ALLOCATION_STATUS_REJECTED) {
                    return;
                }

                if (!_.includes(allocated, item.AllocatedId)) {
                    allocated.push(item.AllocatedId);
                }

                //Confirmed on any one shift is enough - the group is a person, not a shift.
                if (item.Status === ALLOCATION_STATUS_CONFIRMED && !_.includes(accepted, item.AllocatedId)) {
                    accepted.push(item.AllocatedId);
                }
            });

            //Keyed off the shared constant so renaming a group cannot leave the dialog's
            //options pointing at a key nothing produces.
            let groups = {};
            groups[sendMessageService.QUICK_FILL_GROUPS.ALLOCATED] = allocated;
            groups[sendMessageService.QUICK_FILL_GROUPS.ACCEPTED] = accepted;

            return groups;
        }

        function resetDraggables() {
            service.selectedRow = null;
            service.clickSource = null;
            service.lookUps = [];
            service.lookUps2 = [];
            service.selectedItem = null;
            service.showDraggables = false;
        }

        function confirmGenerator(title, content, ariaLabel, okMessage, cancelMessage) {
            return $mdDialog.confirm()
                .title(title)
                .textContent(content)
                .ariaLabel(ariaLabel)
                .ok(okMessage)
                .cancel(cancelMessage);
        }

        function getAllocationStatus(status) {
            if (status == 1) {
                return utils.translate('RESOURCEALLOCATION.STATUS_TENTATIVELY_ALLOCATED');
            }

            if (status == 2) {
                return utils.translate('RESOURCEALLOCATION.STATUS_ALLOCATED_WAITING_CONFIRMATION');
            }

            if (status == 3) {
                return utils.translate('RESOURCEALLOCATION.STATUS_CONFIRMED');
            }

            if (status == 4) {
                return utils.translate('RESOURCEALLOCATION.STATUS_REJECTED');
            }

            if (status == 5) {
                return "";
            }
        }

        function hasASubmittedTimesheet(allocatedResourceItem, isAllocatingResource) {
            var deferred = $q.defer();

            timesheetApi.getTimesheet(allocatedResourceItem.TicketId).then(function(response) {
                var timesheet = response.data;

                if (timesheet) {
                    var timesheetDetails = Object.values(timesheet.TicketTimesheetsDetails);

                    if (!isAllocatingResource) {
                        var timesheetRecord = timesheetDetails.find(x => x.ContactId === allocatedResourceItem.AllocatedId);
                        deferred.resolve(timesheetRecord && (timesheetRecord.JobStartTime || timesheetRecord.JobEndTime))
                    } else {
                        var hasSubmittedTimesheet = timesheetDetails.some(function(data) {
                            return data.JobStartTime && data.JobEndTime
                        });

                        deferred.resolve(hasSubmittedTimesheet);
                    }
                } else {
                    deferred.resolve(false);
                }
            });

            return deferred.promise;
        }

        function loadCostEstimate(costEstimateNumber) {
            costEstimateApi.getCostEstimate(costEstimateNumber).then(function(resp) {
                service.costEstimate = resp.data;
            })
        }

        async function generatePreSchedule(){
            var unallocatedPeople = service.allocatedResource.filter(x => x.ItemType == 4 && !x.AllocatedId);
            var unallocatedAssets = service.allocatedResource.filter(x => x.ItemType == 1 && (!x.AllocatedId && !x.AssignedOperatorId));

            var deferred = $q.defer();

            smartSchedulingService.showAllocationDialog(unallocatedPeople, unallocatedAssets)
                .then(async function (data) {
                    if (!data) {
                        return;
                    }

                    blockUI.start("Initiating Scheduling Copilot...");

                    let result = await smartSchedulingService.generateSchedule(service.ticketGUID, data);

                    blockUI.stop();

                    if (result && result.data && result.data.ErrorMessage) {
                            await msgboxService.alert(
                                utils.translate(
                                    "RESOURCEALLOCATION.SMART_SCHEDULING_FAILED_TITLE_DIALOG"
                                ),
                                result.data.ErrorMessage,
                                utils.translate(
                                    "RESOURCEALLOCATION.CLOSE"
                                )
                            );

                            deferred.resolve(false);
                            return deferred.promise;
                    }

                    deferred.resolve(true);
                });

            return deferred.promise;
        }

        async function isSmartSchedulingCallbackFailed(preScheduleJobId) {
            if (claimsUtilService.isSmartSchedulingEnabled() && preScheduleJobId) {
                try {
                    var generatedPreSchedule = await smartSchedulingService.getGeneratedPreSchedule(preScheduleJobId);

                    if(generatedPreSchedule.data != null){
                        return generatedPreSchedule.data.Status == PREALLOCATE_CALLBACK_FAILED;
                    }
                } catch (ex) {
                    exceptionService.resolve(ex);
                    return true;
                }
            }

            return false;
        }

        async function fetchSuggestedResources(ticket) {
            if (ticket.data.m_Item1.PreScheduleJobId)
            {
                let preschedule = await preScheduleApi.getGeneratedPreSchedule(ticket.data.m_Item1.PreScheduleJobId);
                service.suggestedResources = preschedule.data.Tickets[0].SuggestedResources;
            }
        }

        async function cancelScheduling() {
            blockUI.start('Cancelling Scheduling Copilot...');

            let result = await smartSchedulingService.cancelScheduling(service.ticketInfo.LatestPreScheduleJobId);

            if (result)
            {
              service.ticketInfo.IsLockedByPreSchedule = false;
              $state.reload();
            }

            blockUI.stop();
        }

        async function retryScheduling() {
            blockUI.start("Initiating Scheduling Copilot...");

            let retryResult = await smartSchedulingService.retrySchedulingCopilot(service.ticketInfo.LatestPreScheduleJobId);

            if (retryResult)
            {
              $state.reload();
            }

            blockUI.stop();
        }

        function setPeopleEquipmentColor(itm) {
            if(!(itm.IsOperatorRequired && itm.AssignedOperatorId)){
                return '';
            }

            let allocatedPerson = service.allocatedResource.find(x => x.ItemType == 4 && itm.AssignedOperatorId == x.AllocatedId)

            return allocatedPerson.IsAllocatedBySmartScheduling ? 'deep-purple-label' : '';
        }

        function performSearch(searchText) {
            // Client-side search - instant filtering, no API call needed
            service.searchText = searchText;
            filterList();
        }
    }
})();

/**
 * Purchase Order
 *
 * Rcnet 3.27.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice.reports.view')
        .service('purchaseOrderService', purchaseOrderService);

    /** @ngInject */
    function purchaseOrderService($q,
        exceptionService,
        $mdDialog,
        invoiceApi,
        blockUI,
        $mdToast,
        invoiceReportGridService
    ) {

        var service = {
            changePurchaseOrderNumber: changePurchaseOrderNumber
        };

        return service;

        function changePurchaseOrderNumber(invoiceId, purchaseOrder) {
            let deferred = $q.defer();

            $mdDialog.show({
                templateUrl: 'app/main/invoice/view/purchaseOrder/purchase-order-dialog.html',
                controller: 'PurchaseOrderDialogController',
                controllerAs: 'vm',
                locals: { poNumber: purchaseOrder.PurchaseOrderNumber },
                multiple: true
            }).then(function (purchaseOrderNum) {
                let confirm = $mdDialog.confirm()
                .title('Change Purchase Order Number?')
                .htmlContent('From <b>' + (_.isNil(purchaseOrder.PurchaseOrderNumber) ? 'No Entry' : purchaseOrder.PurchaseOrderNumber) + '</b> To <b>' + purchaseOrderNum + '</b>')
                .ariaLabel('Purchase Order')
                .ok('Yes')
                .cancel('No');

                $mdDialog.show(confirm).then(function () {
                    blockUI.start('Updating Purchase Order Number...');

                    if (!purchaseOrderNum) {
                        blockUI.stop();
                        return;
                    }

                    invoiceApi.updatePurchaseOrderNumber(invoiceId, purchaseOrderNum).then(function (resp) {
                        if (resp) {
                            // Refresh grid item
                            invoiceReportGridService.grid.behavior.refresh();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Purchase Order Number successfully changed.')
                                    .position('bottom right')
                                    .hideDelay(3000)
                            );
                        }

                        blockUI.stop();
                        deferred.resolve('Update successful');
                    }).catch(function (ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                        deferred.reject(ex);
                    });
                });

            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports.view')
        .service('invoiceReportListingAdapterService', invoiceReportListingAdapterService);

    /** @ngInject */
    function invoiceReportListingAdapterService(invoiceReportDbHubService) {
        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            stopDownload: stopDownload, // inbound event (called by grid client)
            currentBranch: null
        };

        activate();

        return service;

        function activate() {
            invoiceReportDbHubService.register();

            invoiceReportDbHubService.onDownloadCompleted = onDownloadCompleted;
            invoiceReportDbHubService.onChunkReceived = onChunkReceived;
            invoiceReportDbHubService.onErrorDownloading = onErrorDownloading;
            invoiceReportDbHubService.onCreditInvoiceReceived = onCreditInvoiceReceived;
        }

        function onCreditInvoiceReceived(data) {
            service.onCreditInvoiceReceived(data);
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        function onGetData(params) {
            let dataFilters = params || getDefaultFilterParams();
            return invoiceReportDbHubService.downloadInvoice(dataFilters.filters);
        }

        function getDefaultFilterParams() {
            let filterModel = {
                startDate: null,
                endDate: null,
                invoiceStartDate: null,
                invoiceEndDate: null,
                ticketInvoiceNumber: null,
                branches: []
            };
            return {
                filters: filterModel
            };
        }

        function stopDownload(initiator) {}
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports.view')
        .service('invoiceReportGridService', invoiceReportGridService);

    /** @ngInject */
    function invoiceReportGridService(
        exceptionService,
        invoiceReportListingAdapterService) {

        var service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = [];
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        return service;

        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(invoiceReportListingAdapterService);
            invoiceReportListingAdapterService.onCreditInvoiceReceived = onCreditInvoiceReceived;
        }

        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(invoice) {
                service.grid.data.push(invoice);
            });
        }

        function onCreditInvoiceReceived(data) {
            if(data.IsGenerated){
                service.grid.behavior.refresh();
            }
        }

        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports.view')
        .service('invoiceReportDbHubService', invoiceReportDbHubService);

    /** @ngInject */
    function invoiceReportDbHubService(
        $log,
        $q,
        $rootScope,
        signalRService,
        invoiceReportDataModel,
        $interval) {

        var service = {
            register: register,
            downloadInvoice: downloadInvoice,
            stopDownload: stopDownload,
            data: [],
            bufferSize: 2000,
            onDownloadCompleted: angular.noop,
            onChunkReceived: angular.noop,
            onErrorDownloading: angular.noop,
            onCreditInvoiceReceived: angular.noop
        };

        var stop;
        var isInitialized = false;

        activate();

        return service;

        function activate() {
            stop = undefined;
        }

        function register() {
            if (signalRService.isConnected) {
                registerEvent();
            }

            $rootScope.$on('signalR_OnConnected', function() {
                if (!isInitialized) {
                    registerEvent();
                    isInitialized = true;
                }
            });
        }

        function registerEvent() {
            signalRService.messageHub.on('creditInvoiceGenerationUpdate', function(data) {
                service.onCreditInvoiceReceived(data);
            });
        }

        function downloadInvoice(filterParams) {
            stop = undefined;
            service.data.length = 0;
            let deferred = $q.defer();

            signalRService.safeSend(function() {
                signalRService.messageHub.invoke('GetInvoiceViewList',
                        filterParams.startDate,
                        filterParams.endDate,
                        filterParams.invoiceStartDate,
                        filterParams.invoiceEndDate,
                        filterParams.ticketInvoiceNumber,
                        filterParams.branches,
                        null,
                        service.bufferSize
                    )
                    .done(function(resp) {
                        $log.debug('Chunk Count: ' + resp.Item1.length + ' Token: ' + resp.Item2);

                        let mappedResult = mapData(resp.Item1);

                        angular.forEach(mappedResult, function(itm) {
                            service.data.push(itm);
                        });

                        // Fire event to subscriber
                        service.onChunkReceived({
                            chunkData: mappedResult, //resp.Item1,
                            totalChunks: -1, // Undetermined
                            totalItems: -1
                        }, 'dbHub');

                        // Continue fetching the next chunk data pass cont-token
                        if (resp.Item2 != null) {
                            continueDl(resp.Item2, filterParams);
                        } else {
                            // Trigger event download completed
                            service.onDownloadCompleted(service.data);
                        }

                        deferred.resolve(resp);
                    })
                    .fail(function(error) {
                        deferred.reject(error);
                    });
            });

            return deferred.promise;
        }

        function continueDl(contToken, filterParams) {
            if (angular.isDefined(stop)) {
                return;
            }

            let isContinue = true;

            stop = $interval(function() {
                if (isContinue) {
                    isContinue = false;

                    if (contToken === null) {
                        stopDl();
                        service.onDownloadCompleted(service.data);
                        return;
                    }

                    continueDownloading(filterParams.startDate,
                            filterParams.endDate,
                            filterParams.invoiceStartDate,
                            filterParams.invoiceEndDate,
                            filterParams.ticketInvoiceNumber,
                            filterParams.branches,
                            contToken,
                            service.bufferSize
                        )
                        .then(function(respData) {
                            // If record exist then continue to next chunk
                            $log.debug('Chunk Count: ' + respData.Item1.length + ' Token: ' + respData.Item2);

                            let mappedResult = mapData(respData.Item1);

                            if (respData) {
                                // Bind data here
                                angular.forEach(mappedResult, function(itm) {
                                    service.data.push(itm);
                                });

                                // Fire event to subscriber
                                service.onChunkReceived({
                                    chunkData: mappedResult, //respData.Item1,
                                    totalChunks: -1, // Undetermined
                                    totalItems: -1
                                }, 'dbHub');
                            }

                            isContinue = true;
                            contToken = respData.Item2;
                        })
                        .catch(function(ex) {
                            if (ex.message !== 'Connection was disconnected before invocation result was received.') {
                                stopDl();
                            }
                        });
                }
            }, 100);
        }

        function mapData(data) {
            let mappedData = [];
            data.map(function(itm) {
                let invData = new invoiceReportDataModel();
                mappedData.push(invData.map(itm));
            });

            return mappedData;
        }

        function stopDl() {
            if (angular.isDefined(stop)) {
                $interval.cancel(stop);
                stop = undefined;
            }
        }

        function stopDownload() {
            stopDl();
            service.data.length = 0;
        }

        function continueDownloading(startDate,
            endDate,
            invoiceStartDate,
            invoiceEndDate,
            ticketInvoiceNumber,
            branches,
            contToken,
            bufferSize
        ) {
            let deferred = $q.defer();

            signalRService.safeSend(function() {
                signalRService.messageHub
                    .invoke('GetInvoiceViewList',
                        startDate,
                        endDate,
                        invoiceStartDate,
                        invoiceEndDate,
                        ticketInvoiceNumber,
                        branches,
                        contToken,
                        bufferSize
                    )
                    .done(function(resp) {
                        deferred.resolve(resp);
                    })
                    .fail(function(error) {
                        deferred.reject(error);
                    });
            });

            return deferred.promise;
        }
    };
})();

/**
 * Invoiew view service
 *
 * Rcnet 1.26.2017
 */
(function() {
    'use strict';

    angular.module('app.invoice.reports.view')
        .service('invoiceFilterService', invoiceFilterService);

    /** @ngInject */
    function invoiceFilterService($q,
        utils,
        branchApi,
        invoiceReportGridService,
        invoiceViewFilterModel) {

        var service = {
            data: new invoiceViewFilterModel(),
            branchLookups: [],
            applyFilter: applyFilter,
            loadLookups: loadLookups,
            reset: reset
        };

        return service;

        function applyFilter() {
            invoiceReportGridService.filterData = service.data.toBackendModel();
            invoiceReportGridService.grid.behavior.refresh();
        }

        function loadLookups() {
            let promise1 = loadBranches();

            return $q.all([promise1]);
        }

        function loadBranches() {
            let deferred = $q.defer();

            service.branchLookups.length = 0;
            branchApi.getBranchesAndStates()
                .then(function(resp) {
                    angular.forEach(resp.data, function(itm) {
                        itm['selected'] = false;
                        itm.StateBranches = [];
                        if (itm.State == null) {
                            itm.StateBranches = itm.Id.split(',');
                            itm.Id = utils.newGuid();
                        }
                        service.branchLookups.push(itm);
                    }, this);

                    deferred.resolve(service.branchLookups);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function reset() {
            service.data.reset();
            applyFilter();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.invoice.reports.view')
        .service('creditReinvoiceService', creditReinvoiceService);

    /** @ngInject */
    function creditReinvoiceService($q,
        exceptionService,
        utils,
        $mdDialog,
        invoiceApi,
        blockUI,
        $mdToast
    ) {

        var service = {
            processCredit: processCredit
        };

        return service;

        function processCredit(id, invoiceNumber, reinvoice) {
            let deferred = $q.defer();
            let confirm = $mdDialog.confirm()
                .title('Credit')
                .textContent('Are you sure you want to perform Credit for Invoice# ' + invoiceNumber + '?')
                .ariaLabel('Credit')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $mdDialog.show({
                    templateUrl: 'app/main/invoice/view/credit-reinvoice/credit-reinvoice-dialog.html',
                    controller: 'CreditReinvoiceDialogController',
                    controllerAs: 'vm',
                    locals: { invoiceNumber: invoiceNumber },
                    multiple: true
                }).then(function (creditInvoiceDate) {

                    if (!creditInvoiceDate) {
                        return;
                    }

                    blockUI.start('Processing Credit Invoice');

                    let hashCode = JSON.stringify({
                        id,
                        creditInvoiceDate
                    }).hashCode();

                    invoiceApi.credit({
                        HashCode: hashCode,
                        Id: id,
                        InvoiceDate: utils.jsDateTime(creditInvoiceDate),
                        Reinvoice: reinvoice
                    }).then(function() {
                        blockUI.stop();

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Credit Invoice will be available in a moment...')
                                .position('bottom right')
                                .hideDelay(3000)
                        );
                        
                        deferred.resolve();
                    }).catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                        deferred.reject(ex);
                    });

                }, function() {
                    deferred.reject();
                });
            });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.invoice.reports.view')
        .controller('PurchaseOrderDialogController', PurchaseOrderDialogController);

    function PurchaseOrderDialogController($mdDialog,
        utils,
        poNumber,
        _) {

        var vm = this;
        
        // Data
        vm.purchaseOrderNumber = poNumber;

        // Event
        vm.save = save;
        vm.onCancel = onCancel;

        function save() {
            $mdDialog.hide(vm.purchaseOrderNumber);
        }

        function onCancel() {
             $mdDialog.cancel();
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .service('invoiceViewFilterModel', invoiceViewFilterModel)

    function invoiceViewFilterModel(alasql, utils) {
        return function() {
            var self = this,
                defaults = {
                    ticketNoInvoiceNo: null,
                    filterType: null,
                    startDate: null,
                    endDate: null,
                    selectedBranches: [],

                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.selectedBranches.length = 0;
            }

            function transformToModel() {
                // Collect item types
                let prm = {
                    startDate: null,
                    endDate: null,
                    invoiceStartDate: null,
                    invoiceEndDate: null,
                    ticketInvoiceNumber: null,
                    branches: []
                };

                prm.ticketInvoiceNumber = self.ticketNoInvoiceNo;

                if (self.filterType == '1') {
                    prm.startDate = self.startDate ? utils.jsDateTime(self.startDate) : self.startDate;
                    prm.endDate = self.endDate ? utils.jsDateTime(self.endDate) : self.endDate;
                } else if (self.filterType == '2') {
                    prm.invoiceStartDate = self.startDate ? utils.jsDateTime(self.startDate) : self.startDate;
                    prm.invoiceEndDate = self.endDate ? utils.jsDateTime(self.endDate) : self.endDate;
                }

                // Get selected state first
                var selectedStates = _.filter(self.selectedBranches, function (o) {
                    return o.State == null;
                });

                var selBranches = _.filter(self.selectedBranches, function (o) {
                    return o.State != null;
                });

                // Get associated branches inside state
                selectedStates.forEach(function (p) {
                    p.StateBranches.map(function (o) {
                        prm.branches.push(o);
                    });
                });

                // Get branches
                selBranches.map(function (o) {
                    prm.branches.push(o.Id);
                });

                prm.branches = _.uniq(prm.branches);

                //self.selectedBranches.map(function(itm) {
                //    prm.branches.push(itm.Id);
                //});

                return prm;
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .service('invoiceReportDataModel', invoiceReportDataModel)

    function invoiceReportDataModel(alasql, utils, localisationService) {
        return function() {
            var self = this,
                defaults = {
                    Id: null,
                    InvoiceNumber: null,
                    InvoiceDate: null,
                    CompanyId: null,
                    CompanyName: null,
                    CompanyCode: null,
                    Tickets: [],
                    Branches: [],
                    PurchaseOrderNumbers: [],
                    TicketNumbers: [],
                    TicketsHtml: null,
                    BranchesHtml: null,
                    PurchaseOrderHtml: null,
                    JobDates: [],
                    JobDatesHtml: null,
                    IsReInvoiced: false,
                    CreditType: null,
                    CreditTypeColor: null,
                    RelatedInvoiceNumber: null,
                    RelatedInvoiceId: null,
                    HasInvoiceForCredit: false
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults;
                angular.extend(self, mapValue);

                self.InvoiceDate = utils.datePickerFormatDate2(self.InvoiceDate);

                // Extract all information
                self.PurchaseOrderNumbers = alasql("SELECT DISTINCT PurchaseOrderNumber FROM ? ", [self.Tickets]); //ORDER BY TicketNumber asc
                self.Branches = alasql("SELECT DISTINCT BranchName FROM ? ", [self.Tickets]);
                self.TicketNumbers = alasql("SELECT DISTINCT TicketNumber FROM ? ", [self.Tickets]); // ORDER BY TicketNumber asc

                const localeSettings = localisationService.getLocaleFormatSettings();
                let fmt = localeSettings.displayDateFormat;
                self.JobDates = alasql("SELECT DISTINCT formatDate(StartDate, '" + fmt + "') FROM ? ", [self.Tickets]); //DD/MM/YYYY

                // Build html UL list
                self.PurchaseOrderHtml = buildULMarkup(self.PurchaseOrderNumbers);
                self.BranchesHtml = buildULMarkup(self.Branches);
                self.TicketsHtml = buildULMarkup(checkNegativeTicketNumber(self.TicketNumbers));
                self.JobDatesHtml = buildULMarkup(self.JobDates);
                self.CreditTypeStatus = getCreditTypeStatus(self.CreditType);

                return self;
            }

            function checkNegativeTicketNumber(tickets) {
                if (tickets && tickets.length == 1) {
                    return self.TicketNumbers[0].TicketNumber == '-1' ? [] : self.TicketNumbers;
                }
                return tickets;
            }

            function getCreditTypeStatus(type) {
                switch (type) {
                    case 0:
                        return {
                            color: 'invoice', text: 'Invoice'
                        };
                    case 1:
                        return {
                            color: 'credit', text: 'Credit'
                        };
                    default:
                        return {
                            color: 'invoice', text: 'Invoice'
                        };
                }
            }

            function buildULMarkup(list) {
                if (!!list && list.length <= 0) {
                    return;
                }

                let markup;

                if (list.length > 1) {
                    markup = '<ul class="list-none">';
                    list.map(function(itm) {
                        for (var prop in itm) {
                            if (itm[prop] != null) {
                                markup += '<li>' + itm[prop] + '</li>';
                            }
                        }
                    });

                    markup += '</ul>';
                } else {
                    for (var prop in list[0]) {
                        markup = list[0][prop];
                    }
                }

                return markup;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                return null;
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.invoice.reports.view')
        .controller('InvoiceDateChooserController', InvoiceDateChooserController);

    function InvoiceDateChooserController(
        $mdDialog,
        invoiceFilterService,
        utils,
        $mdDateLocale,
        $mdToast
    ) {
        var vm = this;
        vm.model = invoiceFilterService;
        vm.dateFormat = utils.setDateFormat();

        vm.onCancel = onCancel;
        vm.applyFilter = applyFilter;

        vm.onChange = onChange;
        vm.filterEndDate = filterEndDate;

        $mdDateLocale.formatDate = function(date) {
            return utils.formatToLocaleDate(date, vm.dateFormat);
        }

        $mdDateLocale.parseDate = function(dateString) {
            return utils.parseToLocaleDate(dateString, vm.dateFormat);
        };

        function onChange(date) {
            vm.model.data.endDate = utils.validateDateOnChange(vm.model.data.startDate, vm.model.data.endDate, null);
        }

        function filterEndDate(date) {
            return utils.filterEndDate(date, -2, vm.model.data.startDate);
        }

        function onCancel() {
            $mdDialog.hide('cancel');
        }

        function applyFilter() {
            if (moment(vm.model.data.startDate).isAfter(moment(vm.model.data.endDate))) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('start date cannot be after end date')
                    .position('bottom right')
                );
                vm.model.data.startDate = null;
                return;
            }

            if (moment(vm.model.data.endDate).isBefore(moment(vm.model.data.startDate))) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('start date cannot be after end date')
                    .position('bottom right')
                );
                vm.model.data.endDate = null;
                return;
            }
            $mdDialog.hide(1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.invoice.reports.view')
        .controller('CreditReinvoiceDialogController', CreditReinvoiceDialogController);

    function CreditReinvoiceDialogController($mdDialog) {

        var vm = this;
        vm.creditInvoiceDate = null;
        vm.save = save;
        vm.onCancel = onCancel;

        function save() {
            $mdDialog.hide(vm.creditInvoiceDate);
        }

        function onCancel() {
             $mdDialog.hide(null);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('reportSideNavService', reportSideNavService);

    /** @ngInject */
    function reportSideNavService(
        $timeout,
        invoiceUtilsService,
        invoiceFilterModel,
        invoiceLookupService
    ) {
        var service = {
            branchLookups: invoiceLookupService.data.branchLookups,
            clientLookups: invoiceLookupService.data.clientLookups,
            data: new invoiceFilterModel(),
            isLocked: false,
            isOverrideInvoiceDate: false,
            loadSingleInvoicePreview: loadSingleInvoicePreview,
            unlockUserInputIfMultipleInvoicePreviews: unlockUserInputIfMultipleInvoicePreviews,
            clearFilter: clearFilter,
            lockUserInput: lockUserInput,
            unlockUserInput: unlockUserInput,
            resetOverriderInvoiceDate: resetOverriderInvoiceDate,
        };

        activate();

        return service;

        function activate() {
            service.data.startDate = invoiceUtilsService.getStartOfWeek(new Date());
            service.data.endDate = invoiceUtilsService.getEndOfWeek(new Date());
        }

        function clearFilter() {
            $timeout(function() {
                service.data.reset();
            });
        }

        function loadSingleInvoicePreview(id) {
            service.data.setSingleInvoicePreview(id);
        }

        function lockUserInput() {
            $timeout(function() {
                service.isLocked = true;
            });
        }

        function unlockUserInput() {
            $timeout(function() {
                service.isLocked = false;
            });
        }

        function unlockUserInputIfMultipleInvoicePreviews() {
            $timeout(function() {
                if (service.data.singlePreviewInvoiceId != null) {
                    service.isLocked = false;
                }
            });
        }

        function resetOverriderInvoiceDate() {
            service.data.resetOverriderInvoiceDate();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('reportManagerService', reportManagerService);

    /** @ngInject */
    function reportManagerService(
        exceptionService,
        invoiceDataAdapterService,
        $timeout,
        reportSideNavService,
        invoiceEditTicketService,
        invoiceDownloadInvoiceService,
        invoiceTaggingService,
        invoiceLineItemService,
        invoiceEditTimesheetService,
        $rootScope,
        msgboxService,
        $mdDialog,
        utils,
        claimsUtilService,
        signalRService,
        invoiceLoaderService
    ) {
        const INVOICE_GENERATION_QUEUED = 0;
        const INVOICE_GENERATION_IN_PROGRESS = 1;
        const INVOICE_GENERATION_FAILED = 2;
        const INVOICE_GENERATION_VALIDATION = 3;

        var service = {
            grid: {},
            gridInfo: {
                totalItems: 0,
                rawTotalItemCount: 0,
                inProgress: false,
                isFiltered: false,
                canFinaliseInvoice: false
            },
            contentLoading: false,
            showDetails: false,
            showTags: false,
            clearPreview: clearPreview,
            editTicket: editTicket,
            editTimesheet: editTimesheet,
            markAsReviewed: markAsReviewed,
            deleteInvoice: deleteInvoice,
            onReady: angular.noop,
            setClientSideFilter: setClientSideFilter,
            customGridSearchComponentApi: {},

            invoicingCompanies: [],
            invoiceGenerationProgress: {
                totalNumberOfCompanies: -1,
                canViewInvoices: false,
                hasMoreCompaniesToProcess: true,
                totalNumberOfInvoices: 0
            },

            isViewingInvoices: false,
            isGeneratingInvoices: false,
            showInvoiceGenerationStatusPage: showInvoiceGenerationStatusPage,
            showGeneratedInvoicesPage: showGeneratedInvoicesPage,
            generateInvoices: generateInvoices,
            showTags: false,
            refreshInvoicesGrid: refreshInvoicesGrid,
            enableRefresh: false,
            showincludedtags: false
        };

        var clientSideFilterText = null;

        activate();

        return service;

        function activate() {
            setupGrid();
            setupPubSubs();
        }

        function setupPubSubs() {
            // For single DELETE invoice
            $rootScope.$on('invoice:deleteSingleCompleted', function(e, id) {
                _.remove(service.grid.data, function(o) {
                    return o.Id === id;
                });
                service.gridInfo.totalItems--;
                service.gridInfo.rawTotalItemCount--;
                if (service.gridInfo.totalItems === 0) {
                    reportSideNavService.isLocked = false;
                }
            });
        }

        function setupGrid() {
            service.grid.api = {};
            service.grid.data = [];
            service.searchText;
            service.grid.onCompleted = onCompleted;
            service.grid.onError = onError;
            service.grid.onInit = onInit;
            service.grid.onDataFilter = onDataFilter;
            service.grid.onDataLoading = onDataLoading;
            service.grid.onDataLoadingCompleted = onDataLoadingCompleted;
            service.grid.onSearch = onSearch;
            service.grid.onReady = onReady;
            service.grid.editInvoice = editInvoiceLineItem;
            service.grid.downloadInvoice = downloadInvoice;
            service.grid.allowCustomClientSideFiltering = true;
            service.grid.onCustomClientSideFiltering = onCustomClientSideFiltering;

            function onInit() {
                service.grid.data = [];
                service.grid.api.setHubSourceAdapter(invoiceDataAdapterService);
            }

            /**
             * Triggers only when Grid component is done initializing
             * This is the safe entry point to issue API commands to Alloc8 Grid
             */
            function onReady() {
                service.onReady();
            }

            /**
             * Loading of partial data
             */
            function onCompleted(data) {
                let hasOldInvoiceData = service.grid.data && service.grid.data.length > 0;
                if (!hasOldInvoiceData) {
                    showMissingGlCodes(data);
                }

                service.showDetails = reportSideNavService.data.showDetails;
                service.showTags = reportSideNavService.data.showTags;

                service.grid.data = [];

                var continueLoop = true;

                angular.forEach(data, function(itm) {
                    invoiceLineItemService.flattenLineItems(itm.LineItems);
                    service.grid.data.push(itm);

                    if (continueLoop) {
                        service.gridInfo.canFinaliseInvoice = itm.GeneratedInvoicePdfExists;
                        continueLoop = itm.GeneratedInvoicePdfExists;
                    }
                });
            }

            function showMissingGlCodes(data) {
                let isAltusSpecialEnabled = claimsUtilService.isAltusSpecialEnabled();

                if (!isAltusSpecialEnabled && data.length) {
                    let dialogMessage = utils.translate('INVOICE_REPORT.MISSING_GL_CODE_DIALOG_MESSAGE');
                    let dialogTitle = utils.translate('INVOICE_REPORT.MISSING_GL_CODE_DIALOG_TITLE');

                    var ticketNumbersWithMissingGLCodes = [];

                    data.forEach(getTicketNumbersWithoutGLCode, ticketNumbersWithMissingGLCodes);

                    if (ticketNumbersWithMissingGLCodes.length) {
                        dialogMessage += ticketNumbersWithMissingGLCodes
                            .sort()
                            .map(ticketNumber => ` #${ticketNumber}`)
                            .join(',');

                        var confirm = $mdDialog.alert()
                            .title(dialogTitle)
                            .htmlContent(dialogMessage)
                            .ariaLabel(dialogTitle)
                            .ok('Okay');

                        $mdDialog.show(confirm);
                    }
                }
            }

            function getTicketNumbersWithoutGLCode(invoice) {
                if (!invoice) {
                    return;
                }

                var ticketNumbersWithMissingGLCodes = invoice.LineItems.filter(lineItem => lineItem.TicketNumber > 0
                    && (!lineItem.CostCode || lineItem.CostCode.Length == 0)
                    && lineItem.IsHistorical == false
                    && lineItem.Quantity > 0)
                .map(lineItem => lineItem.TicketNumber);

                if(ticketNumbersWithMissingGLCodes.length){
                    let uniqueTicketNumbers = ticketNumbersWithMissingGLCodes.filter((item, itemIndex, arr) => arr.indexOf(item) == itemIndex);
                    this.push(...uniqueTicketNumbers);
                }
            }

            /**
             * Fires when grid needs to refresh data
             */
            function onDataFilter() {
                let filterData = reportSideNavService.data.toBackendModel();
                return filterData;
            }

            function onDataLoading() {
                populateGridInfo();
            }

            /**
             * Fires when downloading or loading of full dataset is finish
             */
            function onDataLoadingCompleted() {
                $timeout(function() {
                    service.contentLoading = false;
                });

                reportSideNavService.unlockUserInputIfMultipleInvoicePreviews();

                populateGridInfo();
            }

            function populateGridInfo() {
                let data = service.grid.api.getGridInfo();
                service.gridInfo.totalItems = data.totalItems;
                service.gridInfo.rawTotalItemCount = data.rawTotalItemCount;
                service.gridInfo.inProgress = data.inProgress;
                service.gridInfo.isFiltered = data.isFiltered;
            }

            function onSearch(value) {
                (service.grid.api.search || angular.noop)(value);
            }

            function onError(ex) {
                msgboxService.show('Preview Invoices', 'Something went wrong while retrieving invoices. If the problem persist please contact support.');
                service.grid.api.stop();

                service.clearPreview(false);

                $timeout(function() {
                    invoiceLoaderService.reset();
                    reportSideNavService.loadSingleInvoicePreview(null);
                });
            }

            function editInvoiceLineItem(id) {
                let invoiceItem = _.find(service.grid.data, function(o) {
                    return o.Id === id;
                });

                // Update TOTAL Summary here!!!!
                invoiceLineItemService.showEditor(id, invoiceItem)
                    .then(function(resp) {
                        invoiceItem.TotalExcludingTax = parseFloat(resp.SubTotal)
                            .toFixed(2);
                        invoiceItem.TotalIncludingTax = parseFloat(resp.GrandTotal)
                            .toFixed(2);
                        invoiceItem.TotalTax = parseFloat(resp.TotalTax)
                            .toFixed(2);
                        invoiceItem.InvoiceTaxes = resp.Taxes;
                        invoiceItem.TaxableAmount = resp.TaxableAmount;
                        invoiceItem.SurchargeLineItems = resp.SurchargeLineItems;
                    })
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function downloadInvoice(invoiceId, includePaperwork) {
                invoiceDownloadInvoiceService.downloadInvoiceFromStorage(invoiceId, true, includePaperwork)
            }
        }

        function clearPreview(shouldClearFilter = true) {
            if (shouldClearFilter) {
                reportSideNavService.clearFilter();
            }

            $timeout(function() {
                service.grid.api.clearAll();

                service.contentLoading = false;
                service.invoicingCompanies = [];
                service.invoiceGenerationProgress = {
                    totalNumberOfCompanies: -1,
                    canViewInvoices: false,
                    hasMoreCompaniesToProcess: true,
                    totalNumberOfInvoices: 0
                };
                service.isGeneratingInvoices = false;
                service.isViewingInvoices = false;
                service.enableRefresh = false;
            });

            reportSideNavService.unlockUserInput();
        }

        function editTicket(id, ticketNo, invId) {
            invoiceEditTicketService.editTicket(id, ticketNo, invId);
        }

        function deleteInvoice(id) {
            let deleteInvoice = _.filter(service.grid.data, function(o) {
                return o.Id === id;
            });
            $rootScope.$broadcast('invoice:deleteSingle', deleteInvoice);
        }

        function markAsReviewed(id, toggleValue) {
            setInvoiceToBusy(id, true);
            invoiceTaggingService.toggleTag(id, service.grid.data, toggleValue)
                .then(function(resp) {
                    setInvoiceToBusy(id, false);
                    (service.customGridSearchComponentApi.forceTriggerSearch || angular.noop)();
                })
                .catch(function(ex) {
                    setInvoiceToBusy(id, false);
                    exceptionService.resolve(ex);
                });
        }

        function setInvoiceToBusy(id, flag) {
            let invoice = _.find(service.grid.data, function(o) {
                return o.Id == id;
            });

            invoice.IsBusy = flag;
        }

        function editTimesheet(id, invId) {
            invoiceEditTimesheetService.editTimesheet(id, invId);
        }

        function setClientSideFilter(filter) {
            $timeout(function() {
                clientSideFilterText = filter;
                (service.customGridSearchComponentApi.forceTriggerSearch || angular.noop)();
            });
        }

        function onCustomClientSideFiltering(data) {
            if (clientSideFilterText == null || clientSideFilterText == 'all') {
                return data;
            }

            // Custom logic
            var result = _.filter(data, function(itm) {
                return itm.IsReviewed == (clientSideFilterText == 'byReviewed');
            });

            return result;
        }

        function showInvoiceGenerationStatusPage() {
            $timeout(function() {
                service.isGeneratingInvoices = true;
                service.isViewingInvoices = false;
            });
        }

        function showGeneratedInvoicesPage() {
            $timeout(function() {
                service.isGeneratingInvoices = false;
                service.isViewingInvoices = true;
            });

            if (service.contentLoading) {
                $timeout(function() {
                    service.gridInfo.canFinaliseInvoice = false;
                    service.grid.api.refresh();
                });
            }
        }

        function generateInvoices(isRetry) {
            reportSideNavService.lockUserInput();

            let params = reportSideNavService.data.toBackendModel();

            params.IsRetry = isRetry;

            if (params.CompanyIds.length <= 0) {
                params.CompanyIds = reportSideNavService.clientLookups.map(p => p.Id);
            }

            $timeout(function() {
                service.contentLoading = true;

                service.invoicingCompanies = reportSideNavService.clientLookups
                    .filter(p => params.CompanyIds.includes(p.Id))
                    .map(p => {
                        return {
                            CompanyId: p.Id,
                            CompanyName: p.Name,
                            IsQueued: true,
                            IsGenerated: false,
                            NumberOfInvoices: -1,
                            Notes: null
                        };
                    });
            });

            service.showInvoiceGenerationStatusPage();

            safeSend(function() {
                signalRService.messageHub
                    .invoke('GenerateInvoicePreviewAsync',
                        reportSideNavService.data.getFilterHash(),
                        params.BranchIds,
                        params.CompanyIds,
                        params.StartDate,
                        params.EndDate,
                        params.ShowDetails,
                        params.OverrideInvoiceDate,
                        params.IsRetry)
                    .done(function(resp) {
                        switch (resp.Status) {
                            case INVOICE_GENERATION_IN_PROGRESS: {
                                $mdDialog.show(
                                    $mdDialog.alert()
                                    .title('Preview Invoices')
                                    .textContent('A request with the same filters is already in progress. You can follow the live update of the progress however, you won\'t be able to see the past history.')
                                    .ok('Okay'));

                                break;
                            }
                            case INVOICE_GENERATION_FAILED: {
                                $mdDialog.show(
                                    $mdDialog.alert()
                                    .title('Preview Invoices')
                                    .textContent('Something went wrong when generating invoices. If the problem persist please contact support.')
                                    .ok('Okay'));

                                service.clearPreview(false);

                                break;
                            }
                            case INVOICE_GENERATION_VALIDATION: {
                                $mdDialog.show(
                                    $mdDialog.alert()
                                    .title('Preview Invoices')
                                    .textContent(resp.ErrorMessage || 'Please enter a duration that is not more than 90 days')
                                    .ok('Okay'));

                                service.clearPreview(false);

                                break;
                            }
                        }
                    }).fail(function(ex) {
                        exceptionService.resolve(ex);
                        service.clearPreview(false);
                    });;
            });
        }

        function safeSend(fn) {
            signalRService.ping()
                .then(function(resp) {
                    (fn || angular.noop)();
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function refreshInvoicesGrid(){
            service.enableRefresh = false;

            service.grid.api.clearAll();
            service.grid.api.refresh();
            service.gridInfo.canFinaliseInvoice = false;
        }
    }
})();

/**
 * Invoice Preview Configuration
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceUtilsService', invoiceUtilsService);

    /** @ngInject */
    function invoiceUtilsService($q,
        exceptionService,
        moment
    ) {
        var service = {
            getStartOfWeek: getStartOfWeek,
            getEndOfWeek: getEndOfWeek,
            convertDateToPlain:convertDateToPlain
        };

        activate();

        return service;
        //////

        function activate() {}

        function getStartOfWeek(startOfPeriod, fromTicketBilling) {
            let start = moment(startOfPeriod);
            let isoWeekStart = start.startOf('isoWeek');
            let lastWeek = isoWeekStart.weekday(-7);
            let result = null;
            if(fromTicketBilling){
              result = lastWeek.add(7, 'd').format('YYYY-MM-DD');
            }else{
              result = lastWeek.format('YYYY-MM-DD');
            }
            return new Date(result);
        }

        function getEndOfWeek(startOfPeriod, fromTicketBilling) {
            let start = moment(startOfPeriod);
            let isoWeekStart = start.startOf('isoWeek');
            let lastWeek = isoWeekStart.weekday(-7);
            let result = null;
            if(fromTicketBilling){
              result = lastWeek.add(13, 'd').format('YYYY-MM-DD');
            }else{
              result = lastWeek.add(6, 'd').format('YYYY-MM-DD');
            }
            return new Date(result);
        }

        function convertDateToPlain(date)
        {
          if(Object.prototype.toString.call(date) === '[object Date]'){
            return date.getFullYear() + '-' + (date.getMonth() + 1) +  '-' + date.getDate();
          }

          return date;
        }


    }
})();

/**
 * Invoice Tax rate service
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceTaxRateService', invoiceTaxRateService);

    /** @ngInject */
    function invoiceTaxRateService($q,
        exceptionService,
        ticketsApi,
        $mdDialog,
        blockUI,
        invoiceApi,
        invoiceRulesService,
        utils
    ) {

        var service = {
            showTaxRate: showTaxRate,
            showTaxRateAndApplyAll: showTaxRateAndApplyAll
        };

        activate();

        return service;
        //////

        function activate() { }

        /**
         * Show Tax rate dialog
         */
        function showTaxRate(data) {
            let deferred = $q.defer();
            let locals = angular.copy(data);

            $mdDialog.show({
                templateUrl: 'app/main/invoice/reports/dialogs/tax-rate-dialog/tax-rate-dialog.html',
                controller: 'TaxRateDialogController',
                controllerAs: 'vm',
                multiple: true,
                locals: locals,
                escapeToClose: false
            }).then(function (response) {

                // This will call react global func (workaround here! tsk)
                window.updateTaxRate(response);
                deferred.resolve('ok');

            }, function (resp) {
                //alert('Cancel');
            });
            return deferred.promise;
        }

        /**
         * Show Tax rate and apply all (use global tax rate)
         */
        function showTaxRateAndApplyAll(data) {
            let deferred = $q.defer();
            let locals = angular.copy(data);

            $mdDialog.show({
                templateUrl: 'app/main/invoice/reports/dialogs/tax-rate-dialog/tax-rate-dialog.html',
                controller: 'TaxRateDialogController',
                controllerAs: 'vm',
                multiple: true,
                locals: locals,
                escapeToClose: false
            }).then(function (response) {
                
                // Re-compute using the Global tax rate for all the selected items
                _.forEach(locals.ItemsToApply, function (itm) {
                    itm.TaxRate = response.CombinedTaxRate;
                    itm.CityTaxRate = response.CityTaxRate;
                    itm.CountyTaxRate = response.CountyTaxRate;
                    itm.StateSalesTaxRate = response.StateSalesTaxRate;
                    itm.SpecialTaxRate = response.SpecialTaxRate;
                    invoiceRulesService.computeLineItem(itm)
                });

                // Contact react to update all selected items
                window.updateTaxRateForAllSelectedItems(locals.ItemsToApply);
                deferred.resolve('ok');

            }, function (resp) {
                //alert('Cancel');
            });
            return deferred.promise;
        }

    }
})();
/**
 * Invoice Mark as Reviewed or Not Reviewed service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceTaggingService', invoiceTaggingService);

    /** @ngInject */
    function invoiceTaggingService($q,
        exceptionService,
        invoiceApi,
        $state,
        $mdToast
    ) {

        var service = {
            toggleTag: toggleTag,
            peekAfterToggleState: peekAfterToggleState
        };

        activate();

        return service;
        //////

        function activate() {}

        function toggleTag(id, invoiceList, toggleValue) {
            let deferred = $q.defer();
            let invData = findInvoice(id, invoiceList);

            // Toggle
            //invData.IsReviewed = !invData.IsReviewed;
            invData.IsReviewed = toggleValue;

            invoiceApi.markAsReviewed(id, invData.IsReviewed)
                .then(function(resp) {
                    let msg = invData.IsReviewed ? 'Marked as reviewed' : 'Invoice Unreviewed';

                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(msg)
                        .position('bottom right')
                        .hideDelay(3000)
                    );

                    return deferred.resolve('Tagging successfull');
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

                return deferred.promise;
        }

        function peekAfterToggleState(id, invoiceList) {
            let invData = findInvoice(id, invoiceList);

            // Toggle
            return !invData.IsReviewed;
        }

        function findInvoice(id, invoiceList) {
            let invData = _.find(invoiceList, function(o) {
                return o.Id === id;
            });

            return invData;
        }

    }
})();

/**
 * Invoice rules service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceRulesService', invoiceRulesService);

    /** @ngInject */
    function invoiceRulesService(
        localisationService,
        tenantSettings,
    ) {
        var service = {
            computeLineItem: computeLineItem,
            computeTotalFigures: computeTotalFigures,
            getCombinedTaxRate: getCombinedTaxRate,
            round: round,
            compute: compute
        };

        const DEFAULT_FRACTION_DIGITS = 2;

        activate();

        return service;

        function activate() {}

        function computeLineItem(itm, taxRoundingRule) {
            compute(itm, taxRoundingRule);
        }

        function compute(itm, taxRoundingRule) {
            if (_.isFinite(parseFloat(itm.UnitPriceExcludingTax)) && _.isFinite(parseFloat(itm.Quantity))) {
                var taxAmt, taxRate, unitTax;

                if (parseFloat(itm.Quantity) < 0) {
                    itm.UnitPriceExcludingTax = Math.abs(itm.UnitPriceExcludingTax);
                }

                taxRate = (itm.TaxRate / 100);
                unitTax = parseFloat(itm.UnitPriceExcludingTax) * taxRate;
                taxAmt = (parseFloat(itm.Quantity) * parseFloat(itm.UnitPriceExcludingTax)) * taxRate;

                let fractionDigits = DEFAULT_FRACTION_DIGITS;
                if (taxRoundingRule === "TotalInvoiceRule") {
                    fractionDigits = 4;
                }
                itm.UnitTax = round(unitTax, fractionDigits);
                itm.TotalTax = round(taxAmt, fractionDigits);
                itm.Amount = round(parseFloat(itm.Quantity) * parseFloat(itm.UnitPriceExcludingTax), fractionDigits);
            } else {
                itm.UnitTax = 0;
                itm.TotalTax = 0;
                itm.Amount = 0;
            }
        }

        function computeTotalFigures(itm, totalObj, taxRoundingRule) {

            let fractionDigits = DEFAULT_FRACTION_DIGITS;

            if (taxRoundingRule === "TotalInvoiceRule") {
                fractionDigits = 4;
            }

            totalObj.SubTotal = parseFloat(totalObj.SubTotal) + round(itm.Amount, 2);
            totalObj.TotalTax = parseFloat(totalObj.TotalTax) + round(itm.TotalTax, fractionDigits);
            totalObj.GrandTotal = round(totalObj.SubTotal, 2) + round(totalObj.TotalTax, 2);
        }

        /**
         * For US client
         * @param {*} city
         * @param {*} county
         * @param {*} state
         * @param {*} special
         */
        function getCombinedTaxRate(city, county, state, special) {
            return parseFloat(city) + parseFloat(county) + parseFloat(state) + parseFloat(special);
        }

        function round(value, decimals) {
            var numberOfDecimalPlaces = 1;

            switch (decimals) {
                case 2:
                    numberOfDecimalPlaces = 100;
                    break;
                case 3:
                    numberOfDecimalPlaces = 1000;
                    break;
                case 4:
                    numberOfDecimalPlaces = 10000
                    break;
                default:
                    numberOfDecimalPlaces = 1;
                    break;
            }

            return Number(Math.round(value * numberOfDecimalPlaces) / numberOfDecimalPlaces);
        }
    }
})();

/**
 * OBSOLETE!!!
 * Invoice Preview Configuration
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoicePreviewConfigService', invoicePreviewConfigService);

    /** @ngInject */
    function invoicePreviewConfigService($q,
        exceptionService,
        localStorageService,
        invoicePreviewCfgModel,
        invoiceFilterHasherService
    ) {
        var service = {
            addInvoiceList: addInvoiceList,
            getInvoiceList: getInvoiceList,
            addFilters: addFilters,
            getStatus: getStatus,
            getFilters: getFilters,
            setStatus: setStatus,
            reset: reset,
            getFilterHash: getFilterHash,
            getFilterFormData: getFilterFormData,
            resetCacheData: resetCacheData
        };

        const InvoiceListKey = 'urn:invoice:reportPreview';
        const InvoiceCfgKey = 'urn:invoice:cfgPreview';

        activate();

        return service;
        //////

        function activate() {
            initCfgModel();
        }

        function initCfgModel() {
            let cfg = localStorageService.get(InvoiceCfgKey);

            if (!cfg) {
                createModel();
            }
        }

        function reset() {
            createModel();
        }

        function resetCacheData() {
            localStorageService.remove(InvoiceListKey);
        }

        function createModel() {
            let model = new invoicePreviewCfgModel();
            localStorageService.set(InvoiceCfgKey, model);
        }

        function addInvoiceList(data) {
            localStorageService.set(InvoiceListKey, data);
        }

        function getInvoiceList() {
            initCfgModel();
            return localStorageService.get(InvoiceListKey);
        }

        function addFilters(data) {
            let cfg = localStorageService.get(InvoiceCfgKey);
            cfg.filters = data;
            localStorageService.set(InvoiceCfgKey, cfg);
        }

        function getStatus() {
            initCfgModel();
            let cfg = localStorageService.get(InvoiceCfgKey);
            return !!cfg.status ? cfg.status : 'ready';
        }

        function setStatus(status) {
            let cfg = localStorageService.get(InvoiceCfgKey);
            cfg.status = status;
            localStorageService.set(InvoiceCfgKey, cfg);
        }

        function getFilters() {
            initCfgModel();
            let cfg = localStorageService.get(InvoiceCfgKey);
            return !!cfg.filters ? cfg.filters : null;
        }

        /**
         * Returns filter token hash
         */
        function getFilterHash() {
            let cfg = localStorageService.get(InvoiceCfgKey);
            return invoiceFilterHasherService.hash(cfg.filters);
        }

        function getFilterFormData() {
            let filterModel = {
                BranchIds: [],
                CompanyIds: [],
                StartDate: null,
                EndDate: null
            };

            let filtersParams = getFilters();

            // Branches
            if (angular.isArray(filtersParams.branches)) {
                filtersParams.branches.map(function(itm) {
                    filterModel.BranchIds.push(itm.Id);
                });
            }

            // Client
            if (angular.isArray(filtersParams.clients)) {
                filtersParams.clients.map(function(itm) {
                    filterModel.CompanyIds.push(itm.Id);
                });
            }

            filterModel.StartDate = filtersParams.startDate;
            filterModel.EndDate = filtersParams.endDate;

            return filterModel;
        }

    }

})();
/**
 * Invoice Finalise service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceLoaderService', invoiceLoaderService);

    /** @ngInject */
    function invoiceLoaderService() {
        var service = {
            isLoadSingleInvoice: false,
            invoiceId: null,
            loadSingleInvoice: loadSingleInvoice,
            reset: reset
        };

        return service;

        function reset() {
            service.isLoadSingleInvoice = false;
            service.invoiceId = null;
        }

        function loadSingleInvoice(id) {
            service.isLoadSingleInvoice = !!id;
            service.invoiceId = id;
        }
    }
})();
/**
 * Invoice Line-Item service
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceLineItemService', invoiceLineItemService);

    /** @ngInject */
    function invoiceLineItemService($q,
        $mdDialog,
        editInvoiceReportService,
        blockUI,
        invoiceApi,
        invoiceRulesService,
        taxService,
        branchService,
        manualInvoiceEntryFormService) {

        var service = {
            showEditor: showEditor,
            showEditorForManualInvoice: showEditorForManualInvoice,
            flattenLineItems: flattenLineItems,
        };

        const DEFAULT_FRACTION_DIGITS = 2;
        const TAX_APPLY_TO_BRANCH = 2;

        return service;

        function addTaxToSummary(tax, totalSummary, lineItems, taxRoundingRule) {
            let fractionDigits = DEFAULT_FRACTION_DIGITS;

            if (taxRoundingRule === "TotalInvoiceRule") {
                fractionDigits = 4;
            }

            if (tax.TaxApplyTo == TAX_APPLY_TO_BRANCH) {

                let lineItemsTotalTax = lineItems.flatMap(x => x.LineItemTaxes)
                    .filter(x => x.Id == tax.Id)
                    .map(x => x.TotalTaxApplied).reduce((a,b) => a + b,0);

                totalSummary.Taxes.push({
                    Name: tax.Name,
                    Rate: tax.Rate,
                    TotalTaxApplied: invoiceRulesService.round(parseFloat(lineItemsTotalTax), fractionDigits),
                    IsLineItemTax: true
                });
                return;
            }

            let taxRateAmount = invoiceRulesService.round(parseFloat(totalSummary.SubTotal * (tax.Rate / 100)), fractionDigits);
            totalSummary.Taxes.push({
                Name: tax.Name,
                Rate: tax.Rate,
                TotalTaxApplied: parseFloat(taxRateAmount),
                IsLineItemTax: false
            });
        }

        function isTaxApplicable(tax, companyId, branch) {
            const isApplicableToAll = tax.IsAppliedToAllStates || tax.IsAppliedToAllCompanies;
            const isApplicableToCompany = !tax.IsAppliedToAllCompanies && companyId && tax.Companies.includes(companyId);
            const isApplicableToState = !tax.IsAppliedToAllStates && branch.data.State && tax.States.includes(branch.data.State);
            return isApplicableToAll || isApplicableToCompany || isApplicableToState;
        }

        async function applyTaxes(companyId, branchId, branch, totalSummary, lineItems, taxRoundingRule) {
            const inventoryLineItems = lineItems.filter(lineItem => ['Asset', 'Inventory', 'Rental', 'Vehicle'].includes(lineItem.ItemType));
            const shiftLineItems = lineItems.filter(lineItem => lineItem.ItemType === 'People');
            const packageLineItems = lineItems.filter(lineItem => lineItem.ItemType === 'Package');
            const otherItems = lineItems.filter(lineItem => lineItem.ItemType == '' || lineItem.ItemType == 'Allowance' || lineItem.ItemType == null || lineItem.ItemType == undefined);

            var taxes = await taxService.getAllTax(false);
            for (let tax of taxes) {
                switch (tax.TaxApplyTo) {
                    case TAX_APPLY_TO_BRANCH:
                        const isBranchTaxApplicable = tax.IsAppliedToAllBranches || (branchId && tax.Branches.includes(branchId));

                        if (!isBranchTaxApplicable) {
                            continue;
                        }

                        if (inventoryLineItems.length > 0) {
                            addTaxLineItems(tax, inventoryLineItems, 'Items', tax.IsAppliedToAllItems);
                        }

                        if (shiftLineItems.length > 0) {
                            addTaxLineItems(tax, shiftLineItems, 'Shifts', tax.IsAppliedToAllShifts);
                        }

                        if (packageLineItems.length > 0) {
                            addTaxLineItems(tax, packageLineItems, 'Packages', tax.IsAppliedToAllPackages);
                        }

                        if (otherItems.length > 0) {
                            addTaxLineItems(tax, otherItems, 'Others', tax.IsAppliedToAllPackages && tax.IsAppliedToAllItems && tax.IsAppliedToAllShifts);
                        }

                        addTaxToSummary(tax, totalSummary, lineItems, taxRoundingRule);

                        break;
                    default:
                        if (isTaxApplicable(tax, companyId, branch)) {
                            addTaxToSummary(tax, totalSummary, null, taxRoundingRule);
                        }
                        break;
                }
            }
        }

        function addTaxLineItems(tax, lineItems, taxProperty, isAppliedToAll) {

            let isTaxAdded = false;
            if (isAppliedToAll) {
                for (let lineItem of lineItems) {
                    lineItem.LineItemTaxes.push({
                        Id: tax.Id,
                        Name: tax.Name,
                        Rate: tax.Rate,
                        IsLineItemTax: true,
                        TotalTaxApplied: (lineItem.Amount * tax.Rate / 100)
                    })

                    lineItem.TaxRate += lineItem.LineItemTaxes.map(x => x.Rate).reduce((a, b) => a + b, 0);

                    if (!isLineComment(lineItem)) { 
                        invoiceRulesService.compute(lineItem); 
                    }
                    isTaxAdded = true;
                }
                return isTaxAdded;
            }
            
            if (tax[taxProperty] && tax[taxProperty].length > 0) {
                for (let lineItem of lineItems) {   
                    if (tax[taxProperty].includes(lineItem.ItemId)) {
                        lineItem.LineItemTaxes.push({
                            Id: tax.Id,
                            Name: tax.Name,
                            Rate: tax.Rate,
                            IsLineItemTax: true,
                            TotalTaxApplied: (lineItem.Amount * tax.Rate / 100)
                        })
                        lineItem.TaxRate += tax.Rate;

                        if (!isLineComment(lineItem)) { 
                            invoiceRulesService.compute(lineItem); 
                        }
                        isTaxAdded = true;
                    }
                }
                return isTaxAdded;
            }
        }

        /**
         * For Manual Invoice
         * @param {id} id Invoice id
         * @param {invoiceItem} invoiceItem object
         */
        function showEditorForManualInvoice(invoiceItem, clientId, taxRoundingRule) {
            let deferred = $q.defer();

            editInvoiceReportService.load(invoiceItem, clientId, taxRoundingRule).then(function (resp) {
                $mdDialog.show({
                    templateUrl: 'app/main/invoice/reports/dialogs/edit-invoice/edit-invoice-item-dialog.html',
                    controller: 'EditInvoiceLineDialogController',
                    controllerAs: 'vm',
                    skipHide: true,
                    escapeToClose: false
                }).then(async function (response) {
                    //blockUI.start({ message: 'Updating invoice details...' });
                    let lineItems = [],
                        totalSummary = { Taxes:[], LineItemTaxes:[], SubTotal: 0, TotalTax: 0, GrandTotal: 0 }; // TODO: Put this code to invoice-rules service
                    response.map(function (itm) {
                        itm.TaxRate = 0;
                        itm.UnitTax = 0;
                        itm.TotalTax = 0;

                        lineItems.push({
                            Id: itm.Id,
                            ItemId: itm.ItemId,
                            ItemType: itm.ItemType,
                            AddOnType: itm.AddOnType,
                            TicketId: itm.TicketId,
                            TicketNumber: itm.TicketNumber,
                            Description: itm.Description,
                            CostCode: itm.CostCode,
                            ItemCode: itm.ItemCode,
                            Quantity: itm.Quantity,
                            UnitPriceExcludingTax: itm.UnitPriceExcludingTax,
                            UnitTax: itm.UnitTax,
                            TaxRate: itm.TaxRate,
                            SequenceNo: itm.SequenceNo,
                            IsHistorical: itm.IsHistorical,
                            CreatingUserId: itm.CreatingUserId,
                            Amount: itm.Amount,
                            CityTaxRate: itm.CityTaxRate,
                            CountyTaxRate: itm.CountyTaxRate,
                            StateSalesTaxRate: itm.StateSalesTaxRate,
                            SpecialTaxRate: itm.SpecialTaxRate,
                            LineItemTaxes: [],
                        });
                    });
                    
                    var invoice = manualInvoiceEntryFormService.data;
                    var companyId = invoice.selectedClient.Id;
                    var branchId = invoice.selectedBranch;         
                    var branch = await branchService.getBranchById(branchId);
                    
                    totalSummary.SubTotal = lineItems.map(x => x.Quantity * x.UnitPriceExcludingTax).reduce((a, b) => a + b, 0);

                    if (!invoice.selectedClient.IsTaxExempt) {
                        await applyTaxes(companyId, branchId, branch, totalSummary, lineItems, taxRoundingRule);
                    }

                    totalSummary.TotalTax = totalSummary.Taxes.map(x => x.TotalTaxApplied).reduce((a, b) => a + b, 0);
                    totalSummary.GrandTotal = totalSummary.SubTotal + totalSummary.TotalTax

                    deferred.resolve({ lines: lineItems, totalSummary: totalSummary });
                });
            });

            return deferred.promise;
        }

        /**
         * For Invoice Preview
         * @param {id} id invoice id
         * @param {invoiceItem} invoiceItem object 
         */
        function showEditor(id, invoiceItem) {
            let deferred = $q.defer();

            editInvoiceReportService.load(invoiceItem, null).then(function (resp) {
                $mdDialog.show({
                    templateUrl: 'app/main/invoice/reports/dialogs/edit-invoice/edit-invoice-item-dialog.html',
                    controller: 'EditInvoiceLineDialogController',
                    controllerAs: 'vm',
                    skipHide: true,
                    escapeToClose: false
                }).then(function (response) {
                    blockUI.start({ message: 'Updating invoice details...' });

                    let lineItems = [],
                        totalSummary = { SubTotal: 0, TotalTax: 0, GrandTotal: 0 }; // TODO: Put this code to invoice-rules service

                    // Create server model
                    // Note: Breakdown is only needed in US client
                    response.map(function (itm) {
                        lineItems.push({
                            Id: _.startsWith(itm.Id, 'new') ? null : itm.Id,  // Identify NEW record here (new record has a prefix of "new-<guid>")
                            TicketId: itm.TicketId,
                            TicketNumber: itm.TicketNumber,
                            Description: itm.Description,
                            CostCode: itm.CostCode,
                            ItemId: itm.ItemId,
                            ItemType: itm.ItemType,
                            AddOnType: itm.AddOnType,
                            ItemCode: itm.ItemCode,
                            Quantity: itm.Quantity,
                            UnitPriceExcludingTax: itm.UnitPriceExcludingTax,
                            UnitTax: itm.UnitTax,
                            TaxRate: itm.TaxRate,
                            TotalTax:itm.TotalTax,
                            SequenceNo: itm.SequenceNo,
                            IsHistorical: itm.IsHistorical,
                            CreatingUserId: itm.CreatingUserId,
                            Amount: itm.Amount,
                            LineItemTaxes: itm.Taxes,
                            Breakdown: {
                                CityTaxRate: itm.CityTaxRate,
                                CountyTaxRate: itm.CountyTaxRate,
                                StateSalesTaxRate: itm.StateSalesTaxRate,
                                SpecialTaxRate: itm.SpecialTaxRate
                            }
                        });
                    });

                    invoiceApi.addLineItem(id, lineItems)
                        .then(function (resp) {
                            // Re-map updated line items
                            invoiceItem.LineItems.length = 0;
                            response.map(function (itm) {
                                invoiceItem.LineItems.push(itm);
                            });

                            deferred.resolve(resp.data);
                            blockUI.stop();
                        }).catch(function (ex) {
                            deferred.reject(ex);
                            blockUI.stop();
                        });

                });
            });

            return deferred.promise;
        }

        function isLineComment(item) {
            return (item.Description == null || ((item.Description.toUpperCase() == 'SUPPLY OF TRAFFIC CONTROLLERS AT') || (item.Quantity == 0 && item.UnitPriceExcludingTax <= 0)));
        }

        function flattenLineItems(lineItems) {
            _.forEach(lineItems, function (itm) {
                flattenModel(itm);
            });
        }

        // Flatten model
        function flattenModel(lineItem) {
            lineItem.CityTaxRate = lineItem.Breakdown == null ? 0 : lineItem.Breakdown.CityTaxRate;
            lineItem.CountyTaxRate = lineItem.Breakdown == null ? 0 : lineItem.Breakdown.CountyTaxRate;
            lineItem.StateSalesTaxRate = lineItem.Breakdown == null ? 0 : lineItem.Breakdown.StateSalesTaxRate;
            lineItem.SpecialTaxRate = lineItem.Breakdown == null ? 0 : lineItem.Breakdown.SpecialTaxRate;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.corelib')
        .service('invoiceHubService', invoiceHubService);

    /** @ngInject */
    function invoiceHubService(
        signalRService,
        $rootScope,
        reportManagerService,
        reportSideNavService,
        invoiceFilterHasherService,
        tenantSettings,
        $timeout,
        identityService
    ) {
        var service = {
            register: register
        };

        var isInitialized = false;

        return service;

        function register() {
            if (signalRService.isConnected) {
                registerForEvents();
                return;
            }

            $rootScope.$on('signalR_OnConnected', function() {
                if (!isInitialized) {
                    registerForEvents();
                    isInitialized = true;
                }
            });
        }

        function registerForEvents() {
            signalRService.messageHub.on('invoiceGenerationUpdate', function(data) {
                let filters = reportSideNavService.data.toBackendModel();

                if (!invoiceFilterHasherService.IsHashEqual(filters, data.RequestHashCode)) {
                    return;
                }

                $timeout(function() {
                    let invoicingCompany = reportManagerService.invoicingCompanies.find(p => p.CompanyId == data.CompanyId);
                    if (invoicingCompany) {
                        invoicingCompany.NumberOfInvoices = data.NumberOfInvoices;
                        invoicingCompany.IsQueued = false;
                        invoicingCompany.IsGenerated = data.IsGenerated;
                        invoicingCompany.Notes = data.Notes;
                    }

                    let hasAtLeastOneCompanyWithInvoices =
                        reportManagerService.invoiceGenerationProgress.canViewInvoices ||
                        data.NumberOfInvoices > 0 ||
                        reportManagerService.invoicingCompanies.some(p => p.NumberOfInvoices > 0);
                    let areAllInvoiceGenerated = reportManagerService.invoicingCompanies.every(x => x.IsGenerated || (!!x.Notes && x.Notes != ""));
                    let canViewInvoices = reportManagerService.invoicingCompanies.every(x => x.IsGenerated);

                    if(tenantSettings && (!tenantSettings.viewInvoiceAfterAllCompanySucceeded || tenantSettings.viewInvoiceAfterAllCompanySucceeded.toLowerCase() === 'false')){
                        canViewInvoices = hasAtLeastOneCompanyWithInvoices;
                    }

                    reportManagerService.invoiceGenerationProgress.totalNumberOfCompanies = data.TotalNumberOfCompanies;
                    reportManagerService.invoiceGenerationProgress.canViewInvoices = canViewInvoices;
                    reportManagerService.invoiceGenerationProgress.hasMoreCompaniesToProcess = !areAllInvoiceGenerated;

                    if (invoicingCompany) {
                        reportManagerService.invoiceGenerationProgress.totalNumberOfInvoices += invoicingCompany.NumberOfInvoices;
                    }
                });
            });

            signalRService.messageHub.on('generateInvoicePdfCompleted', function(data){
                var invoicesData = reportManagerService.grid.data;
                var invoicePdfGenerated = data;

                var invoice = invoicesData.filter(i => i.Id === invoicePdfGenerated.InvoiceId)[0];

                if (invoice && invoice.Id) {
                    $timeout(function(){
                        invoice.GeneratedInvoicePdfExists = invoicePdfGenerated.IsGenerated;
                        reportManagerService.gridInfo.canFinaliseInvoice = invoicePdfGenerated.IsGenerated;
                        if (!!invoicePdfGenerated.ContactIdOfRequestUser) {
                                reportManagerService.enableRefresh = !(identityService.userData.ContactId.toLowerCase() === invoicePdfGenerated.ContactIdOfRequestUser.toLowerCase());
                        }
                    });
                }
            });
        }
    };
})();

(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceFinaliseService', invoiceFinaliseService);

    /** @ngInject */
    function invoiceFinaliseService(
        $q,
        invoiceApi,
        invoiceLoaderService
    ) {
        var service = {
            finalise: finalise
        };

        activate();

        return service;

        function activate() {}

        function finalise(ids) {
            let deferred = $q.defer();

            if (!angular.isArray(ids)) {
                deferred.reject('Error in finalise parameter ids.');
            }

            let idColl = [];

            ids.map(function(itm) {
                idColl.push(itm.Id);
            });

            invoiceApi.finalise(idColl)
                .then(function(resp) {
                    invoiceLoaderService.reset();
                    deferred.resolve('ok');
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }
    }
})();

/**
 * Invoice Filter State service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceFilterStateService', invoiceFilterStateService);

    /** @ngInject */
    function invoiceFilterStateService($q,
        exceptionService,
        dataCacheService2
    ) {
        var service = {
            getFilter: getFilter,
            addFilter: addFilter,
            clear: clear
        };

        var cacheObj = dataCacheService2.getInstance();

        activate();


        return service;
        //////

        function activate() {
            cacheObj.group('invoice');
        }

        function getFilter() {
            let cacheData = cacheObj.getCache('urn:invoice:filter');
            return $q.when(cacheData);
        }

        function addFilter(obj) {
            cacheObj.updateCache('urn:invoice:filter', obj);
        }

        function clear() {
            cacheObj.remove('urn:invoice:filter');
        }
    }
})();
/**
 * Invoice filter hash service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceFilterHasherService', invoiceFilterHasherService);

    /** @ngInject */
    function invoiceFilterHasherService(appConfigService,
        exceptionService,
        $log,
        _
    ) {

        var service = {
            hash: hash,
            IsHashEqual: IsHashEqual
        };

        activate();

        return service;
        ///////

        function activate() {}

        function hash(cfg) {
            let fieldValues;

            if (cfg) {
                fieldValues = cfg.StartDate + ',' + cfg.EndDate + ',' + getClientIdsToString(cfg.CompanyIds) + ',' + getBranchesToString(cfg.BranchIds);
                return fieldValues.hashCode();
            }
        }

        /**
         * Hash equality checker
         */
        function IsHashEqual(cfg, hashvalue) {
            let h = hash(cfg);
            return (parseInt(h) === parseInt(hashvalue));
        }

        function getClientIdsToString(clients) {
            let str = '';
            if (angular.isArray(clients)) {
                clients.map(function(itm) {
                    //str = str + "'" + itm.Id + "',";
                    str = str + "'" + itm + "',";
                });

                return str.substring(0, str.length - 1);
            }
            return '';
        }

        function getBranchesToString(branches) {
            let branchStr = '';
            if (angular.isArray(branches)) {
                branches.map(function(itm) {
                    //branchStr = branchStr + "'" + itm.Id + "',";
                    branchStr = branchStr + "'" + itm + "',";
                });

                return branchStr.substring(0, branchStr.length - 1);
            }
            return '';
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.corelib')
        .service('invoiceExportHubService', invoiceExportHubService);

    /** @ngInject */
    function invoiceExportHubService(
        signalRService,
        $rootScope,
        $timeout,
        invoiceExportService2,
        invoicingErrorCodes
    ) {
        var service = {
            register: register
        };

        var isInitialized = false;

        return service;

        function register() {
            if (signalRService.isConnected) {
                registerForEvents();
                return;
            }

            $rootScope.$on('signalR_OnConnected', function() {
                if (!isInitialized) {
                    registerForEvents();
                    isInitialized = true;
                }
            });
        }

        function registerForEvents() {
            signalRService.messageHub.on('exportInvoiceUpdate', function(resp) {
                let invoice = invoiceExportService2.dataGrid.grid.data
                    .filter(invoice => invoice.Id == resp.InvoiceId)[0];

                if (!invoice) {
                    return;
                }

                $timeout(function() {
                    invoice.isExporting = false;
                    invoice.isSelected = false;

                    if (resp.IsSuccessful) {
                        invoice.InvoicingErrors.push({
                            Code: invoicingErrorCodes.InvoiceAlreadyExistsInMyob,
                            LineItemsErrors: []
                        });
                    } else {
                        invoice.isExportFailed = true;
                        invoice.InvoicingErrors.push({
                            Code: resp.ErrorMessage,
                            LineItemsErrors: []
                        });
                    }

                    invoiceExportService2.recheckInvoiceRecords();
                });
            });

            signalRService.messageHub.on('exportInvoicesCompleted', function() {
                $timeout(function() {
                    invoiceExportService2.isProcessing = false;
                    invoiceExportService2.progressBarMessage = 'Exporting completed.';
                    invoiceExportService2.progressBarErrorMessage = null;
                    invoiceExportService2.checkAllItemsOnCurrentPageSelected();
                });
            });
        }
    };
})();

(function () {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceEditTimesheetService', invoiceEditTimesheetService);

    /** @ngInject */
    function invoiceEditTimesheetService(
        exceptionService,
        $state,
        blockUI,
        invoiceApi
    ) {
        var service = {
            editTimesheet: editTimesheet
        };

        activate();

        return service;

        function activate() {}

        function editTimesheet(ticketId, invoiceId) {
            blockUI.start('Preparing timesheet...');

            invoiceApi.deleteInvoiceAndUnlockTicketAndTimesheet(invoiceId)
                .then(function (resp) {
                    tryRedirectToTimesheet(true, ticketId);
                    blockUI.stop();
                }).catch(exceptionHandler);
        }

        function exceptionHandler(ex) {
            exceptionService.resolve(ex);
            blockUI.stop();
        }

        function tryRedirectToTimesheet(okToRedirect, ticketId) {
            if (okToRedirect === true) {
                $state.go('app.timesheet', {
                    id: ticketId
                });
            } else {
                exceptionService.resolve('Unable to unlock timesheet.');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceEditTicketService', invoiceEditTicketService);

    /** @ngInject */
    function invoiceEditTicketService(
        exceptionService,
        $state,
        blockUI,
        invoiceApi
    ) {
        var service = {
            editTicket: editTicket
        };

        activate();

        return service;

        function activate() {}

        function editTicket(ticketId, ticketNumber, invoiceId) {
            blockUI.start('Preparing ticket...');

            invoiceApi.deleteInvoiceAndUnlockTicketAndTimesheet(invoiceId)
                .then(function (resp) {
                    tryRedirectToJobs(true, ticketId, ticketNumber);
                    blockUI.stop();
                }).catch(exceptionHandler);
        }

        function exceptionHandler(ex) {
            exceptionService.resolve(ex);
            blockUI.stop();
        }

        function tryRedirectToJobs(okToRedirect, ticketId, ticketNumber) {
            if (okToRedirect === true) {
                $state.go('app.jobs_update', {
                    id: ticketId,
                    ticketNumber: ticketNumber
                });
            } else {
                exceptionService.resolve('Unable to unlock ticket #' + ticketNumber);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceDownloadInvoiceService', invoiceDownloadInvoiceService);

    /** @ngInject */
    function invoiceDownloadInvoiceService (
        exceptionService,
        msgboxService,
        blockUI,
        invoiceApi
    ) {
        var service = {
            downloadInvoice: downloadInvoice,
            downloadInvoiceFromStorage: downloadInvoiceFromStorage
        };

        activate();

        return service;

        function activate () { }

        function downloadInvoice(invoiceId) {
            blockUI.start('Preparing invoice for download...');
            invoiceApi.downloadInvoice(invoiceId).then(function (resp) {
                downloadPdf(resp.data, false);

                blockUI.stop();
            }).catch(exceptionHandler);
        }

        // Called by 'download invoice' button in 'view invoice' screens
        function downloadInvoiceFromStorage(invoiceId, isPreview, includePaperwork) {
            blockUI.start('Preparing to download...');
            invoiceApi.downloadReportLink(invoiceId, isPreview, includePaperwork).then(function (resp) {
                if (resp.data.m_Item1 == 'actual') {
                    let data = encodeURI(resp.data.m_Item2);
                    downloadPdf(data, false);
                } else if (resp.data.m_Item1 == 'preview') {
                    let data = `data:application/pdf;base64,${resp.data.m_Item2}`;
                    downloadPdf(data, true);
                }
                blockUI.stop();
            }).catch(function (ex) {
                blockUI.stop();
                exceptionService.resolve(ex);
            });
        }

        function downloadPdf(data, isPreview) {
            let now = moment().format("YY-MM-DD-HH-mm-ss");
            let fileName = isPreview ? 'invoice-' + now + '-preview.pdf' : 'invoice-' + now + '.pdf';

            var anchor = angular.element('<a/>');
            anchor.attr({
                href: data,
                target: '_blank',
                download: fileName
            })[0].click();
        }

        function exceptionHandler (ex) {
            console.error(ex);
            msgboxService.show('[' + ex.status + ']' + ' Unable to download report.', 'Report Error');
            blockUI.stop();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceDeletePreviewService', invoiceDeletePreviewService);

    /** @ngInject */
    function invoiceDeletePreviewService(
        $q,
        exceptionService,
        invoiceApi,
        alasql,
        $mdDialog,
        reportManagerService,
        $mdToast,
        blockUI,
        reportSideNavService,
        _,
        $rootScope
    ) {
        var service = {
            deletePreview: deletePreview
        };

        activate();

        return service;

        function activate() {
            // Delete Pub/Subs
            $rootScope.$on('invoice:deleteSingle', function (e, data) {
                deletePreview(data, true);
            });
        }

        function deletePreview(data, isSingle) {
            let deferred = $q.defer();

            if (!angular.isArray(data))
                deferred.reject('Error in delete preview parameter ids.');

            var itms = [];

            data.forEach(function (itm) {
                let inputItem = {
                    Id: itm.Id,
                    InvoiceNumber: itm.InvoiceNumber,
                    TicketIds: []
                };

                let invoiceIds = alasql('SELECT TicketId FROM ?', [itm.Tickets]);
                invoiceIds.forEach(function (obj) {
                    inputItem.TicketIds.push(obj.TicketId);
                });

                itms.push(inputItem);
            });


            let pluralize = data.length > 1;
            let invWord = pluralize ? 'invoices' : 'invoice';

            let confirm = $mdDialog.confirm()
                .title('Delete invoice preview')
                .textContent('Are you sure you want to delete ' + invWord + '?')
                .ariaLabel('Delete invoice preview')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                blockUI.start('Deleting preview ' + invWord + '...');

                var navModel = reportSideNavService.data.toBackendModel();

                var invToDelete = {
                    StartDate: navModel.StartDate,
                    EndDate: navModel.EndDate,
                    Invoices: itms
                };
                invoiceApi.deleteInvoicePreview(invToDelete)
                    .then(function (resp) {

                        blockUI.stop();

                        if (!isSingle) {
                            reportManagerService.clearPreview(false);
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Delete invoice preview successfully completed.')
                                .position('bottom right')
                                .hideDelay(4000)
                        );

                        if (isSingle) {
                            $rootScope.$broadcast('invoice:deleteSingleCompleted', data[0].Id);
                        }

                        deferred.resolve(resp.data);
                    })
                    .catch(function (ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                        deferred.reject(ex);
                    });

            }, function () {
                // cancel
                deferred.resolve('ok');
            });

            return deferred.promise;
        }
    }
})();

/**
 * Document DB data downloader hub
 *
 * Rcnet 11.18.2016
 */
(function () {
    'use strict';

    angular.module('app.invoice.reports')
        .service('invoiceDbSourceService', invoiceDbSourceService);

    /** @ngInject */
    function invoiceDbSourceService(
        $log,
        $q,
        utils,
        signalRService,
        $rootScope,
        $interval) {
        var service = {
            register: register,
            downloadTickets: downloadTickets,
            stopDownload: stopDownload,
            data: [],
            bufferSize: 2000,
            onDownloadCompleted: angular.noop,
            onChunkReceived: angular.noop,
            onErrorDownloading: angular.noop
        };
        var stop;

        activate();

        return service;

        ///////
        function activate() {
            stop = undefined;
        }

        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function () {
                    regs();
                });
            }
        }

        function regs() {
        }

        function addExtraData(data) {
            data.Item1.forEach(function (invoice) {
                invoice.LineItems.forEach(function (line) {
                    line['InvId'] = invoice.Id;
                    line['LineTotal'] = utils.moneyFormat(line.UnitPriceExcludingTax * line.Quantity, 2);
                });
                invoice['IsBusy'] = false;
            });
        }

        function downloadTickets(params) {
            stop = undefined;

            service.data = [];
            
            let deferred = $q.defer();

            signalRService.safeSend(function () {
                signalRService.messageHub.invoke('DownloadInvoiceDataAsync',
                    params.StartDate,
                    params.EndDate,
                    params.BranchIds,
                    params.CompanyIds,
                    params.SingleInvoicePreview,
                    null,
                    service.bufferSize)
                    .done(function (resp) {
                        addExtraData(resp);
                        $log.debug('Chunk Count: ' + resp.Item1.length + ' Token: ' + resp.Item2);

                        angular.forEach(resp.Item1, function (itm) {
                            service.data.push(itm);
                        });

                        // Fire event to subscriber
                        service.onChunkReceived({
                            chunkData: resp.Item1,
                            totalChunks: -1, // Undetermined
                            totalItems: -1
                        }, 'dbHub');

                        // Continue fetching the next chunk data
                        if (resp.Item2 != null) {
                            continueDl(resp.Item2, params);
                        } else {

                            // Trigger event download completed
                            service.onDownloadCompleted(service.data);
                        }
                        
                        deferred.resolve(resp);
                    }).fail(function (error) {
                        service.onErrorDownloading(error);
                        //deferred.reject(error);
                    });
            });

            return deferred.promise;
        }

        function continueDl(contToken, params) {
            if (angular.isDefined(stop))
                return;

            let isContinue = true;

            stop = $interval(function () {
                if (isContinue) {
                    isContinue = false;

                    if (contToken === null) {
                        stopDl();

                        // Trigger event download completed
                        service.onDownloadCompleted(service.data);
                        return;
                    }

                    continueDownloading(
                        params.StartDate,
                        params.EndDate,
                        params.BranchIds,
                        params.CompanyIds,
                        params.SingleInvoicePreview,
                        contToken,
                        service.bufferSize)
                        .then(function (respData) {
                            addExtraData(respData);

                            // If record exist then continue to next chunk
                            $log.debug('Chunk Count: ' + respData.Item1.length + ' Token: ' + respData.Item2);

                            if (respData) {
                                // Bind data here
                                angular.forEach(respData.Item1, function (itm) {
                                    service.data.push(itm);
                                });

                                // Fire event to subscriber
                                service.onChunkReceived({
                                    chunkData: respData.Item1,
                                    totalChunks: -1, // Undetermined
                                    totalItems: -1
                                }, 'dbHub');
                            }

                            isContinue = true;
                            contToken = respData.Item2;
                        }).catch(function (ex) {
                            // Terminate process if something went wrong
                            if (ex.message !== 'Connection was disconnected before invocation result was received.') {
                                stopDl();
                            }
                        });
                }
            }, 100);
        }

        /**
         * Stop downloading
         */
        function stopDl() {
            if (angular.isDefined(stop)) {
                $interval.cancel(stop);
                stop = undefined;
            }
        }

        function stopDownload() {
            stopDl();
            service.data.length = 0;
        }

        /**
         * Continue downloading
         */
        function continueDownloading(startDate, endDate, branchIds, companyIds, singleInvoice, contToken, bufferSize) {
            let deferred = $q.defer();
            signalRService.safeSend(function () {
                signalRService.messageHub
                    .invoke('DownloadInvoiceDataAsync', startDate, endDate, branchIds, companyIds, singleInvoice, contToken, bufferSize)
                    .done(function (resp) {
                        deferred.resolve(resp);
                    }).fail(function (error) {
                        deferred.reject(error);
                    });
            });

            return deferred.promise;
        }

    };
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .service('invoiceDataAdapterService', invoiceDataAdapterService);

    /** @ngInject */
    function invoiceDataAdapterService(
        invoiceDbSourceService,
    ) {
        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            stopDownload: angular.noop // inbound event (called by grid client)
        };

        activate();

        return service;

        function activate() {
            invoiceDbSourceService.onDownloadCompleted = onDownloadCompleted;
            invoiceDbSourceService.onChunkReceived = onChunkReceived;
            invoiceDbSourceService.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        function onGetData(params) {
            let dataFilters = params || getDefaultFilterParams();
            return invoiceDbSourceService.downloadTickets(dataFilters.filters);
        }

        function getDefaultFilterParams() {
            let filterModel = {
                BranchIds: [],
                CompanyIds: [],
                StartDate: null,
                EndDate: null
            };
            return {
                filters: filterModel
            };
        }
    }
})();

/**
 * Custom Grid Search engine
 * Todo: Perform multi keyword search here
 * by Rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.invoice')
        .factory('invoiceCustomGridSearchService', invoiceCustomGridSearchService);

    /** @ngInject */
    function invoiceCustomGridSearchService(_, alasql, utils) {
        var service = {
            search: search
        };

        return service;
        ///////

        // TODO: provide search columns parameter to override extractSearchFields
        function search(collection, stext) {
            if (collection.length <= 0 || stext == null || stext == undefined || stext == '' || stext == 'undefined') return null;

            let props = extractSearchFields(collection[0]);
            let qryPredicate = createQueryPredicate(props, stext);

            var results = alasql("SELECT * FROM ? WHERE " + qryPredicate, [collection]);
            var results2 = [];
            _.forEach(collection, function(o) {
                //, ROUND((UnitPriceExcludingTax * Quantity),2) AS TotalAmt
                //let res = alasql('SELECT * FROM ? WHERE Quantity > 0 GROUP BY Id HAVING ROUND((UnitPriceExcludingTax * Quantity),2) = ' + stext, [o.LineItems]);
                let res = alasql('SELECT * FROM ? WHERE Description LIKE "%' + stext + '%" OR (LineTotal = "' + stext + '" AND Quantity > 0)', [o.LineItems]);
                if (res.length > 0) 
                    results2.push(o);
            });

            var mergedResults = _.concat(results, results2);
            var finalResult = _.uniqBy(mergedResults, function(o) {
                return o.Id;
            });
            
            return finalResult;
        }

        function createQueryPredicate(propsColl, stext) {
            let pred = '';
            angular.forEach(propsColl, function(p) {
                pred += p + ' LIKE "%' + stext + '%" OR ';
            });

            return pred.substring(0, pred.length - 4);
        }

        function extractSearchFields(obj) {
            let objSanitized = utils.objectSanitize(obj);
            let propsArr = [];
            for(var p in objSanitized) {
                if (!angular.isFunction(propsArr))
                    propsArr.push(p);
            }
            return propsArr;
        }

    }
})();

/**
 * Invoice Current Request Service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('invoiceCurrentRequestService', invoiceCurrentRequestService);

    /** @ngInject */
    function invoiceCurrentRequestService($q,
        exceptionService,
        moment,
        signalRService
    ) {
        var service = {
            get: get
        };

        activate();

        return service;
        //////

        function activate() {}

        function get() {
            let deferred = $q.defer();

            signalRService.safeSend(function() {
                signalRService.messageHub
                    .invoke('GetInvoiceRequestParams')
                    .done(function(resp) {
                        deferred.resolve(resp);
                    }).fail(function(ex) {
                        exceptionService.resolve(ex);
                        deferred.reject(ex);
                    });
            });

            return deferred.promise;
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .factory('editInvoiceReportService', editInvoiceReportService);

    /** @ngInject */
    function editInvoiceReportService(
        exceptionService,
        lookupApi,
        $timeout,
        $q,
        $mdDialog,
        invoiceRulesService,
        invoiceApi,
        editableLineItemService,
        blockUI,
        tenantSettings,
        invoiceTaxRateService,
        utils,
        claimsUtilService,
        localisationService
    ) {
        var service = {
            data: {
                invId: null,
                invoiceNo: null,
                lineItems: [],
                noRateCardItems: false
            },
            fieldDef: [],
            costCodesLookup: [],
            itemCodes: [],
            rateCardItems: [],
            rawRateCardItems: null,
            disableSave: false,
            locale: tenantSettings.countryCode,
            isAltusSpecialEnabled: false,
            taxRoundingRule: null,
            defaultTaxRate: 0,

            load: load,
            loadLookups: loadLookups,
            onAddRow: onAddRow,
            onColumnChange: onColumnChange,
            onRemoveRow: onRemoveRow,
            onEditDone: onEditDone,
            onEdit: onEdit,
            onToggleEdit: onToggleEdit,
            onDeleteSelected: onDeleteSelected,
            onRefreshRateCard: onRefreshRateCard,
            onCheckDescriptionControlType: onCheckDescriptionControlType,
            onEditTaxRate: onEditTaxRate,
            onEditAllTaxRate: onEditAllTaxRate,
            onChangeItemCode: onChangeItemCode,
        };

        activate();

        return service;
        //////

        function activate() {
        }

        // Obsolete!!!
        function onAddRow() {
            alert('Adding Row!');
        }

        /**
         * Triggered when editable-line-item component fired onToggleEvent.
         * @param {*} value
         */
        function onToggleEdit(value) {
            service.disableSave = value;
        }

        /**
         * Load invoice items
         */
        function load(invoiceItem, clientId, taxRoundingRule) {
            var deferred = $q.defer();

            blockUI.start({
                message: 'Loading Client Rate Card...'
            });

            service.isAltusSpecialEnabled = claimsUtilService.isAltusSpecialEnabled();
            service.taxRoundingRule = taxRoundingRule;

            if (!_.isNil(invoiceItem)) {
                // Load rate card items
                var companyId = !_.isNil(invoiceItem.CompanyId) ? invoiceItem.CompanyId : clientId;

                loadRateCardItems(companyId).then(function(resp) {
                    service.data.invId = invoiceItem.Id;
                    service.data.invoiceNo = invoiceItem.InvoiceNumber;
                    service.data.lineItems.length = 0;
                    let lineItemsCloned = angular.copy(invoiceItem);

                    lineItemsCloned.LineItems.map(function(itm) {
                        // Add grid specific props (mutate object)
                        editableLineItemService.addExtendedProperties(itm);

                        // Set default value for property
                        itm.IEdit = false;

                        // Map item code to Id of lookup
                        if (itm.ItemCode) {
                            itm.ItemCodeObj = _.find(service.itemCodes, function(o) {
                                return o.id === itm.ItemCode;
                            });
                        }

                        let ItemId = '';
                        let ItemType = '';
                        let rateCardItemCode = onCheckDescriptionControlType(itm.Description);
                        for (let item of service.rateCardItems) {
                            if(item.hasOwnProperty('itemId') && item.id == rateCardItemCode.id){
                                ItemId = item.itemId;
                                ItemType = item.itemType;
                                break;
                            }

                            if(item.hasOwnProperty('children')){
                                for (let i of item.children) {
                                    if(i.id == rateCardItemCode.id){
                                        ItemId = i.itemId;
                                        ItemType = i.itemType;
                                        break;
                                    }
                                }
                            }
                        }

                        itm.ItemId = ItemId;
                        itm.ItemType = ItemType;
                        itm.ItemCodeDesc = itm.ItemCodeObj != null ? itm.ItemCodeObj.text : null;
                        invoiceRulesService.computeLineItem(itm, taxRoundingRule);
                        service.data.lineItems.push(itm);
                    });

                    blockUI.stop();
                    deferred.resolve('loaded');
                }).catch(function(ex) {
                    blockUI.stop();
                    deferred.reject(ex);
                });
            } else {
                loadRateCardItems(clientId).then(function(resp) {
                    service.data.invId = null;
                    service.data.invoiceNo = null;
                    service.data.lineItems.length = 0;

                    blockUI.stop();
                    deferred.resolve('loaded');
                }).catch(function(ex) {
                    blockUI.stop();
                    deferred.reject(ex);
                });
            }

            return deferred.promise;
        }

        function onEditDone() {
            service.disableSave = false;
        }

        function onEdit() {
            service.disableSave = true;
        }

        /**
         * Remove row item in grid
         * Used by React grid editor
         */
        function onRemoveRow(id, desc) {
            let deferred = $q.defer();

            $mdDialog.show({
                templateUrl: 'app/main/invoice/reports/dialogs/inv-confirm-dialog/inv-confirm-dialog.html',
                controller: 'InvoiceConfirmDialogController',
                controllerAs: 'vm',
                locals: {
                    desc: desc
                },
                multiple: true
                //skipHide: true
            }).then(function(resp) {

                // Call React method here
                window.callReactDeleteLineItem(id);
                deferred.resolve('ok delete');
            }, function(resp) {
                deferred.reject();
            });

            return deferred.promise;
        }

        function onDeleteSelected(rowCount) {
            var deferred = $q.defer();
            var additionalMsg = rowCount > 1 ? rowCount + ' items' : rowCount + ' item';

            $mdDialog.show({
                templateUrl: 'app/main/invoice/reports/dialogs/confirm-delete-checked-items/confirm-delete-cheked-items-dialog.html',
                controller: 'ConfirmDeleteCheckedItemsDialogController',
                controllerAs: 'vm',
                locals: {
                    desc: additionalMsg
                },
                multiple: true
            }).then(function(resp) {
                // Call React method here
                window.callReactDeleteLineItems();
                deferred.resolve('ok delete');
            }, function(resp) {
                deferred.reject();
            });

            return deferred.promise;
        }

        function loadLookups() {
            let promise1 = loadCostCodes();
            let promise2 = loadItemCodes();
            //let promise3 = loadRateCardItems();
            return $q.all([promise1, promise2]);
        }

        function loadCostCodes() {
            let promise1 = lookupApi.getCostCodes()
                .then(function(resp) {
                    service.costCodesLookup.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        service.costCodesLookup.push({
                            Id: itm.Id,
                            Description: itm.Name
                        });
                    });
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return promise1;
        }

        function loadItemCodes() {
            let promise = invoiceApi.getItemCodes()
                .then(function(resp) {
                    service.itemCodes.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        service.itemCodes.push({
                            id: itm.Id,
                            text: itm.Name
                        });
                    });
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return promise;
        }

        function loadRateCardItems(clientId) {
            var deferred = $q.defer();

            invoiceApi.getRateCardItems(clientId) //'00375ba2-c57e-469e-a072-028e04ad2c7d'
                .then(function(resp) {

                    if (_.isNil(resp.data)) {
                        service.data.noRateCardItems = true;
                        service.rawRateCardItems = null;
                        service.rateCardItems.length = 0;
                        deferred.resolve('No Rate card items found for this company');
                        return;
                    }

                    // Store raw rate card items lookup
                    service.data.noRateCardItems = false;

                    service.rawRateCardItems = {
                        Allowances: [],
                        Items: [],
                        LabourItems: [],
                        PackageItems: [],
                        RateCard: resp.data.RateCard
                    };

                    if (resp.data && resp.data.Allowances) {
                        service.rawRateCardItems['Allowances'] = resp.data.Allowances.map(function(o) {
                            return Object.assign({}, o, {
                                id: o.LineItem.replace(/\s/g, '-') + '-' + utils.newGuid()
                            });
                        });
                    }
                    if (resp.data && resp.data.Items) {
                        service.rawRateCardItems['Items'] = resp.data.Items.map(function(o) {
                            return Object.assign({}, o, {
                                id: o.LineItem.replace(/\s/g, '-') + '-' + utils.newGuid()
                            });
                        });
                    }
                    if (resp.data && resp.data.LabourItems) {
                        service.rawRateCardItems['LabourItems'] = resp.data.LabourItems.map(function(o) {
                            return Object.assign({}, o, {
                                id: o.LineItem.replace(/\s/g, '-') + '-' + utils.newGuid()
                            });
                        });
                    }
                    if (resp.data && resp.data.PackageItems) {
                        service.rawRateCardItems['PackageItems'] = resp.data.PackageItems.map(function(o) {
                            return Object.assign({}, o, {
                                id: o.LineItem.replace(/\s/g, '-') + '-' + utils.newGuid()
                            });
                        });
                    }

                    mapRawRateCardToViewModel(service.rawRateCardItems);
                    deferred.resolve('Rate card items found for this company');
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function mapRawRateCardToViewModel(data) {
            service.rateCardItems.length = 0;

            // Get unique groups
            let items = _.uniqBy(data.Items, 'GroupName');
            let labourItems = _.uniqBy(data.LabourItems, 'GroupName');
            let packageItems = _.uniqBy(data.PackageItems, 'GroupName');
            let allowances = _.uniqBy(data.Allowances, 'GroupName');

            // Build the parent/group child relationship
            _.forEach(items, function(o) {
                let children = _.filter(data.Items, function(i) {
                    return i.GroupName === o.GroupName;
                });

                // dont include null (without parent/group)
                if (o.GroupName != null) {
                    service.rateCardItems.push({
                        text: o.GroupName,
                        children: mapChildrenToViewModel(children)
                    });
                } else {
                    mapNullGroupToParentViewModel(service.rateCardItems, children);
                }
            });

            _.forEach(labourItems, function(o) {
                let children = _.filter(data.LabourItems, function(i) {
                    return i.GroupName === o.GroupName;
                });

                // dont include null (without parent/group)
                if (o.GroupName != null) {
                    service.rateCardItems.push({
                        text: o.GroupName,
                        children: mapChildrenToViewModel(children)
                    });
                } else {
                    mapNullGroupToParentViewModel(service.rateCardItems, children);
                }
            });

            _.forEach(packageItems, function(o) {
                let children = _.filter(data.PackageItems, function(i) {
                    return i.GroupName === o.GroupName;
                });

                // dont include null (without parent/group)
                if (o.GroupName != null) {
                    service.rateCardItems.push({
                        text: o.GroupName,
                        children: mapChildrenToViewModel(children)
                    });
                } else {
                    mapNullGroupToParentViewModel(service.rateCardItems, children);
                }
            });


            _.forEach(allowances, function(o) {
                let children = _.filter(data.Allowances, function(i) {
                    return i.GroupName === o.GroupName;
                });

                // dont include null (without parent/group)
                if (o.GroupName != null) {
                    service.rateCardItems.push({
                        text: o.GroupName,
                        children: mapChildrenToViewModel(children)
                    });
                } else {
                    mapNullGroupToParentViewModel(service.rateCardItems, children);
                }
            });
        }

        function mapNullGroupToParentViewModel(vm, children) {
            children.map(function(c) {
                vm.push({
                    id: c.id,
                    itemId: c.ItemId,
                    itemType: c.ItemType,
                    text: c.ItemName,
                    groupName: c.GroupName,
                    lineItem: c.LineItem,
                    unitPrice: c.UnitPrice,
                    glAccountCode: c.GeneralLedgerAccountCode,
                    glItemCode: c.GeneralLedgerItemCode
                });
            });
        }

        function mapChildrenToViewModel(children) {
            var mappedVm = [];
            children.map(function(c) {
                mappedVm.push({
                    id: c.id,
                    itemId: c.ItemId,
                    itemType: c.ItemType,
                    text: c.ItemName,
                    groupName: c.GroupName,
                    lineItem: c.LineItem,
                    unitPrice: c.UnitPrice,
                    glAccountCode: c.GeneralLedgerAccountCode,
                    glItemCode: c.GeneralLedgerItemCode
                });
            });

            return mappedVm;
        }

        function getBundledRateCardItemRaw() {
            var arr = (service.rawRateCardItems.Allowances || [])
                .concat((service.rawRateCardItems.Items || []))
                .concat((service.rawRateCardItems.LabourItems || []))
                .concat((service.rawRateCardItems.PackageItems || []));

            return _.remove(arr, function(o) {
                return o != null
            });
        }

        function onRefreshRateCard(id) {

            if (_.isEmpty(id))
                return null;

            var arr = getBundledRateCardItemRaw();
            var item = _.find(arr, function(o) {
                return o.id === id;
            });

            return {
                id: id,
                itemId: item.ItemId,
                itemType: item.ItemType,
                text: item.ItemName,
                groupName: item.GroupName,
                lineItem: item.LineItem,
                unitPrice: item.UnitPrice,
                glAccountCode: item.GeneralLedgerAccountCode,
                glItemCode: item.GeneralLedgerItemCode
            };
        }

        function onCheckDescriptionControlType(data) {
            var id = data.replace(/\s/g, '-');
            var arr = getBundledRateCardItemRaw();
            var isDescItemCode = true;
            var findResult = _.find(arr, function(o) {
                if (o.id === id) {
                    isDescItemCode = false;
                    return true;
                }
                
                if (o.LineItem === data) {
                    id = o.id;
                    isDescItemCode = false;
                    return true;
                }

                id = null;
                return false;
            });

            return !_.isNil(findResult) && !isDescItemCode ? {
                type: 'rate-card-item-control',
                id: id
            } : {
                type: 'desc-item-code-control',
                id: id
            };
        }

        function onColumnChange(columnName, id) {
            $timeout(function() {
                let rowItem = _.find(service.data.lineItems, function(o) {
                    return o.Id === id;
                });

                invoiceRulesService.computeLineItem(rowItem);
            }, 0);
        }

        function onEditTaxRate(data) {
            invoiceTaxRateService.showTaxRate(data);
        }

        function onEditAllTaxRate(data) {
            invoiceTaxRateService.showTaxRateAndApplyAll(data);
        }

        function onChangeItemCode(data) {
            if(_.isNil(data) || _.isEmpty(data)){
                return null;
            }

            var arr = getBundledRateCardItemRaw();
            var item = _.find(arr, function(o) {
                return o.GeneralLedgerItemCode === data;
            });

            if(!item) {
                return null;
            }

            return item.GeneralLedgerAccountCode;
        }
    }
})();

(function(){
   'use strict';

  angular.module('app.invoice.reports')
          .service('ReportProcessResultModel', ReportProcessResultModel)

    function ReportProcessResultModel() {
        return function () {
            var self = this,
            defaults = {
                Status: null,
                Branches: [],
                BranchesHtml: null,
                StartDate: null, 
                EndDate: null,
                Client: null,
                IncludeDetails: false
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();
/**
 * Invoice cache model
 */
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .service('invoicePreviewCfgModel', invoicePreviewCfgModel)

    function invoicePreviewCfgModel(invoiceUtilsService) {
        return function() {
            var self = this,
                defaults = {
                    status: 'ready', // status composed of: (ready, processing, cached)
                    filters: {
                        branches: [],
                        startDate: invoiceUtilsService.getStartOfWeek(new Date()),
                        endDate: invoiceUtilsService.getEndOfWeek(new Date()),
                        clients: [],
                        showDetails: false,
                        showTags: false
                    }
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.filters.branches.length = 0;
                self.filters.clients.length = 0;
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .service('invoiceLineItemModel', invoiceLineItemModel)

    function invoiceLineItemModel() {
        return function() {
            var self = this,
                defaults = {
                    Id: null,
                    TicketId: null,
                    TicketNumber: null,
                    Description: null,
                    CostCode: null,
                    Quantity: 0,
                    UnitPriceExcludingTax: 0,
                    UnitTax: 0,
                    TaxRate: 0,
                    SequenceNo: 0,
                    IsHistorical: false,
                    CreatingUserId: null
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
/**
 * Invoice cache model
 */
(function () {
    'use strict';

    angular.module('app.invoice.reports')
        .service('invoiceFilterModel', invoiceFilterModel)

    function invoiceFilterModel(_, invoiceUtilsService, invoiceFilterHasherService, utils, invoiceLookupService) {
        return function () {
            var self = this,
                defaults = {
                    selectedBranches: [],
                    selectedClients: [],
                    startDate: invoiceUtilsService.convertDateToPlain(invoiceUtilsService.getStartOfWeek(new Date())),
                    endDate: invoiceUtilsService.convertDateToPlain(invoiceUtilsService.getEndOfWeek(new Date())),
                    showDetails: false,
                    overrideInvoiceDate: undefined,
                    singlePreviewInvoiceId: null,
                    showTags:false,
                    clientLookup: invoiceLookupService.data.clientLookups
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.getFilterHash = getFilterHash;
            self.resetOverriderInvoiceDate = resetOverriderInvoiceDate;
            self.setSingleInvoicePreview = setSingleInvoicePreview;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.selectedBranches.length = 0;
                self.selectedClients.length = 0;
            }

            function resetOverriderInvoiceDate() {
                self.overrideInvoiceDate = undefined;
            }

            function setSingleInvoicePreview(id) {
                self.singlePreviewInvoiceId = id;
            }

            function transformToModel() {
                let filterModel = {
                    BranchIds: [],
                    CompanyIds: [],
                    StartDate: null,
                    EndDate: null,
                    ShowDetails: false,
                    OverrideInvoiceDate: undefined,
                    SingleInvoicePreview: null,
                    IsRetry: false,
                    ShowTags: false
                };

                // Branches
                if (angular.isArray(self.selectedBranches)) {
                    // Get selected state first
                    var selectedStates = _.filter(self.selectedBranches, function (o) {
                        return o.State == null;
                    });

                    var selBranches = _.filter(self.selectedBranches, function (o) {
                        return o.State != null;
                    });

                    // Get associated branches inside state
                    selectedStates.forEach(function (p) {
                        p.StateBranches.map(function (o) {
                            filterModel.BranchIds.push(o);
                        });
                    });

                    // Get branches
                    selBranches.map(function(o) {
                        filterModel.BranchIds.push(o.Id);
                    });

                    filterModel.BranchIds = _.uniq(filterModel.BranchIds);
                }

                 // Client
                 if (angular.isArray(self.selectedClients) && self.selectedClients.length > 0) {
                    self.selectedClients.map(function(itm) {
                        filterModel.CompanyIds.push(itm.Id);
                    });
                } else {
                    defaults.clientLookup.forEach(function(client){
                        let clientBranches = client.Branches.map(x => x.Id);
                        let doesCompanyBelongToBranches = clientBranches.some(x => filterModel.BranchIds.includes(x));
                        
                        if(doesCompanyBelongToBranches)
                        {
                            filterModel.CompanyIds.push(client.Id);
                        }
                    });
                }
                
                filterModel.StartDate = invoiceUtilsService.convertDateToPlain(self.startDate);
                filterModel.EndDate = invoiceUtilsService.convertDateToPlain(self.endDate);
                filterModel.ShowDetails = self.showDetails;
                filterModel.OverrideInvoiceDate = utils.jsDateTime(self.overrideInvoiceDate);
                filterModel.SingleInvoicePreview = self.singlePreviewInvoiceId;
                filterModel.ShowTags = self.showTags;

                return filterModel;
            }

            /**
             * Returns filter token hash
             */
            function getFilterHash() {
                let cfg = transformToModel();
                return invoiceFilterHasherService.hash(cfg);
            }
          
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.reports')
        .service('invoiceDataModel', invoiceDataModel)

    function invoiceDataModel() {
        return function() {
            var self = this,
                defaults = {
                    Id: null,
                    CompanyName: [],
                    Project: null,
                    InvoiceNo: null,
                    InvoiceDate: null,
                    PurchaseOrderNo: null,
                    Terms: 0,
                    Status: 'Preview',
                    TotalExcludingTax: 0,
                    TotalTax: 0,
                    TotalIncludingTax: 0,
                    LineItems: []
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .directive('dateRangeValidator', dateRangeValidator);

    /** @ngInject */
    function dateRangeValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: false,
            link: function(scope, element, attrs, ngModelCtrl) {
                var maxDays = parseInt(attrs.dateRangeMaxDays, 10) || 90;
                // md-datepicker owns the isolate scope on this element; $parent resolves to the controller scope
                var parentScope = scope.$parent;

                ngModelCtrl.$validators.dateRange = function(modelValue) {
                    var compareToDate = parentScope.$eval(attrs.dateRangeCompareTo);

                    if (!angular.isDate(compareToDate) || !angular.isDate(modelValue)) {
                        return true;
                    }

                    var diffInDays = Math.round(
                        (Date.UTC(modelValue.getFullYear(), modelValue.getMonth(), modelValue.getDate()) -
                         Date.UTC(compareToDate.getFullYear(), compareToDate.getMonth(), compareToDate.getDate())) / 86400000);
                    return diffInDays >= 0 && diffInDays <= maxDays;
                };

                parentScope.$watch(attrs.dateRangeCompareTo, function() {
                    ngModelCtrl.$validate();
                    if (ngModelCtrl.$error.dateRange) {
                        ngModelCtrl.$setTouched();
                    }
                });
            }
        };
    }
})();

/**
 * Manual Invoice Controller
 * Created date: 3.13.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice.forms.manualInvoice')
        .controller('ManualInvoiceController', ManualInvoiceController);

    /** @ngInject */
    function ManualInvoiceController($q,
        blockUI,
        utils,
        manualInvoiceEntryFormService,
        lineItemManualInvoiceService,
        editableLineItemService,
        invoiceApi,
        exceptionService,
        $mdToast,
        $scope,
        msgboxService
    ) {

        var vm = this;

        // Data
        vm.lineItemsModel = lineItemManualInvoiceService;
        vm.formModel = manualInvoiceEntryFormService;

        // Methods
        vm.saveInvoice = saveInvoice;
        vm.onClientSelected = onClientSelected;

        activate();

        //////////
        function activate() {
            manualInvoiceEntryFormService.data.reset();
            lineItemManualInvoiceService.reset();
            lineItemManualInvoiceService.summary.reset();
        }

        function saveInvoice() {
            let invoiceFormData = manualInvoiceEntryFormService.data.toBackendModel();
            let data = angular.copy(lineItemManualInvoiceService.data);
            sanitizeValues(data);
            invoiceFormData.LineItems = data;
            invoiceFormData.InvoiceTotalSummary = lineItemManualInvoiceService.summary;
            blockUI.start({ message: 'Saving Invoice...' });

            invoiceApi.saveManualInvoice(invoiceFormData)
                .then(function (resp) {
                    blockUI.stop();

                    manualInvoiceEntryFormService.data.reset();
                    lineItemManualInvoiceService.reset();
                    lineItemManualInvoiceService.summary.reset();
                    $scope.itemForm.$setUntouched();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Invoice successfully saved.')
                            .position('bottom right')
                            .hideDelay(3000)
                    );

                }).catch(function (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        /**
         * This only fires when there's a different selection in the Client dropdown.
         * @param {*} data
         */
        function onClientSelected(data) {
            var deferred = $q.defer();
            if (vm.lineItemsModel.data.length > 0) {
                msgboxService.yepNo('Changing a Client from <b>' + data.oldValue + '</b> to <b>' + data.newValue + '</b> will affect the entered line items, this is due to different rate card items.<br/> Continuing will remove the entered line items. Do you want to continue?',
                    'Change Client')
                    .then(function () {
                        lineItemManualInvoiceService.reset();
                        lineItemManualInvoiceService.summary.reset();
                        deferred.resolve('yes');
                    }, function () {
                        // cancel
                        deferred.resolve('no');
                    });
            }

            return deferred.promise;
        }

        function sanitizeValues(dataArr) {
            dataArr.map(function (resp) {
                resp.Id = editableLineItemService.fixId(resp.Id);
                resp.Quantity = resp.Quantity == null ? 0 : resp.Quantity;
                resp.UnitPriceExcludingTax = resp.UnitPriceExcludingTax == null ? 0 : resp.UnitPriceExcludingTax;
                resp.UnitTax = resp.UnitTax == null ? 0 : resp.UnitTax;
                resp.TaxRate = resp.TaxRate == null ? 0 : resp.TaxRate;
                resp.Amount = resp.Amount == null ? 0 : resp.Amount;
                resp.BreakDown = {
                    CityAmount: resp.CityAmount,
                    CityTaxRate: resp.CityTaxRate,
                    CountyAmount: resp.CountyAmount,
                    CountyTaxRate: resp.CountyTaxRate,
                    StateAmount: resp.StateAmount,
                    StateSalesTaxRate: resp.StateSalesTaxRate,
                    SpecialDistrictAmount: resp.SpecialDistrictAmount,
                    SpecialTaxRate: resp.SpecialTaxRate
                };
                delete resp.CityAmount;
                delete resp.CityTaxRate;
                delete resp.CountyAmount;
                delete resp.CountyTaxRate;
                delete resp.StateAmount;
                delete resp.StateSalesTaxRate;
                delete resp.SpecialDistrictAmount;
                delete resp.SpecialTaxRate;
            });

            utils.objectSanitize(dataArr);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports.export', [])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.invoice_export_viewer', {
            url: '/invoice/reports/export_invoices',
            views: {
                'content@app': {
                    templateUrl: 'app/main/invoice/exportViewer/invoice-export-viewer.html',
                    controller: 'InvoiceExportViewerController as invExportViewVm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['invoiceClaimsService', function(invoiceClaimsService) {
                    return invoiceClaimsService.hasExportInvoiceMenu;
                }]
            },
            title: 'Export Invoices',
            titleBar: 'Alloc8 - Export Invoices',
            resolve: {
                lookups: lookupResolver
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/invoice');
    };

    /** @ngInject */
    function lookupResolver(invoiceLookupService) {
        return invoiceLookupService.loadAll();
    }

    function runConfig(invoiceExportHubService) {
        invoiceExportHubService.register();
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports.export')
        .service('invoiceExportService2', invoiceExportService2);

    /** @ngInject */
    function invoiceExportService2(
        signalRService,
        invoiceExportGridService,
        $mdDialog,
        utils,
        integrationsService,
        exceptionService,
        invoicingErrorCodes,
        invoiceApi
    ) {
        var service = {
            isProcessing: false,
            progressBarMessage: null,
            progressBarErrorMessage: null,
            dataGrid: invoiceExportGridService,
            exportInvoicesToProvider: exportInvoicesToProvider,
            allItemsOnCurrentPageSelected: false,
            checkAllItemsOnCurrentPageSelected: checkAllItemsOnCurrentPageSelected,
            widgets: [{
                    id: "1",
                    displayName: "Total invoices",
                    type: "Number",
                    cssClasses: "",
                    value: 0
                },
                {
                    id: "2",
                    displayName: "Invoices ready to export",
                    type: "Number",
                    cssClasses: "md-light-blue-800-bg white-fg",
                    value: 0
                },
                {
                    id: "3",
                    displayName: "Invoices with errors",
                    type: "Number",
                    cssClasses: "deep-orange-bg white-fg",
                    value: 0
                },
                {
                    id: "4",
                    displayName: "Invoices exported",
                    type: "Number",
                    cssClasses: "green-bg white-fg",
                    value: 0
                }
            ],
            recheckInvoiceRecords: recheckInvoiceRecords,
            resetWidgets: resetWidgets
        };

        return service;

        function checkAllItemsOnCurrentPageSelected() {
            service.allItemsOnCurrentPageSelected = service.dataGrid.grid.data
                .filter(inv => inv.InvoicingErrors.length === 0)
                .every(function(invoice) {
                    return invoice.isSelected;
                });
        }

        async function exportInvoicesToProvider(providerType, filterParams) {
            let selectedInvoices = Array.from(service.dataGrid.grid.data).filter(invoice => invoice.isSelected);

            if (providerType === integrationsService.providerTypes.xero) {
                await exportInvoicesToXero(selectedInvoices);
                return;
            }

            service.isProcessing = true;
            service.progressBarMessage = 'Exporting invoices...';
            service.progressBarErrorMessage = null;

            try {
                let invoiceExportSettings = {
                    InvoiceNumbers: selectedInvoices.map(i => i.InvoiceNumber),
                    InvoicingConnectorType: providerType,
                    InvoiceStartDate: filterParams.StartDate,
                    InvoiceEndDate: filterParams.EndDate
                };

                await signalRService.messageHub.invoke('ExportInvoices', invoiceExportSettings)
                    .fail(err => {
                        service.isProcessing = false;
                        exceptionService.resolve(err);
                    });
            } catch (ex) {
                service.isProcessing = false;
                exceptionService.resolve(ex);
            }
        }

        async function exportInvoicesToXero(selectedInvoices) {
            service.isProcessing = true;

            for (const [_, invoice] of selectedInvoices.entries()) {

                invoice.isExporting = true;

                try {
                    await invoiceApi.exportInvoiceToProvider(invoice.InvoiceNumber, integrationsService.providerTypes.xero);
                    await invoiceApi.exportInvoicePaperworkToProvider(invoice.InvoiceNumber, integrationsService.providerTypes.xero);

                    invoice.InvoicingErrors.push({
                        Code: invoicingErrorCodes.InvoiceAlreadyExistsInMyob,
                        LineItemsErrors: []
                    });
                } catch (error) {
                    invoice.isExportFailed = true;

                    if (error.data) {
                        let ErrorMessage = error.data.ExceptionMessage;

                        if(ErrorMessage == null) {
                            ErrorMessage = error.data.Message || ErrorMessage

                            if(error.data.InnerException != null && error.data.InnerException.ErrorContent != null){
                                let ErrorContent = JSON.parse(error.data.InnerException.ErrorContent);

                                if(ErrorContent.Elements != null && ErrorContent.Elements.length > 0){
                                    if(ErrorContent.Elements[0].ValidationErrors != null && ErrorContent.Elements[0].ValidationErrors.length > 0){
                                        ErrorMessage = ErrorContent.Elements[0].ValidationErrors[0].Message || ErrorMessage;
                                    }
                                }
                            }
                        }

                        invoice.InvoicingErrors.push({
                            Code: ErrorMessage,
                            LineItemsErrors: []
                        });
                    }
                }

                invoice.isExporting = false;
                invoice.isSelected = false;
                service.recheckInvoiceRecords();
            }

            let titleMessage = utils.translate("INVOICE_EXPORT.EXPORT_TO_XERO_TITLE");
            let alertMessage = utils.translate("INVOICE_EXPORT.INVOICES_EXPORTED_SUCCESSFUL_MESSAGE");

            const hasFailedInvoices = selectedInvoices.some(invoice => invoice.isExportFailed);
            if (hasFailedInvoices) {
                alertMessage = utils.translate("INVOICE_EXPORT.INVOICES_EXPORTED_FAILED_MESSAGE");
            }

            service.isProcessing = false;
            service.checkAllItemsOnCurrentPageSelected();

            let alert = $mdDialog.alert({
                title: titleMessage,
                htmlContent: alertMessage,
                ok: utils.translate("INVOICE_EXPORT.OK")
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        }

        function resetWidgets() {
            service.widgets[0].value = 0;
            service.widgets[1].value = 0;
            service.widgets[2].value = 0;
            service.widgets[3].value = 0;
        }

        function recheckInvoiceRecords() {
            var supersetCollection = service.dataGrid.grid.behavior.getSupersetCollection();
            var erroredRecords = getErroredRecords(supersetCollection);
            var readyToExportRecords = getRecordsReadyToExport(supersetCollection);
            var exportedRecords = getExportedRecords(supersetCollection);

            service.widgets[0].value = supersetCollection.length;
            service.widgets[1].value = readyToExportRecords.length;
            service.widgets[2].value = erroredRecords.length;
            service.widgets[3].value = exportedRecords.length;
        }

        function getErroredRecords(supersetCollection) {
            var records = supersetCollection.filter(p =>
                p.InvoicingErrors &&
                p.InvoicingErrors.length > 0 &&
                !(
                    p.InvoicingErrors.find(invError => invError.Code == invoicingErrorCodes.InvoiceAlreadyExistsInXero) !== undefined ||
                    p.InvoicingErrors.find(invError => invError.Code == invoicingErrorCodes.InvoiceAlreadyExistsInMyob) !== undefined
                ));

            return records;
        }

        function getRecordsReadyToExport(supersetCollection) {
            var records = supersetCollection.filter(p =>
                !p.InvoicingErrors ||
                p.InvoicingErrors.length == 0
            );

            return records;
        }

        function getExportedRecords(supersetCollection) {
            var records = supersetCollection.filter(p =>
                p.InvoicingErrors &&
                p.InvoicingErrors.length > 0 &&
                (
                    p.InvoicingErrors.find(invError => invError.Code == invoicingErrorCodes.InvoiceAlreadyExistsInXero) !== undefined ||
                    p.InvoicingErrors.find(invError => invError.Code == invoicingErrorCodes.InvoiceAlreadyExistsInMyob) !== undefined
                )
            );

            return records;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports.view')
        .service('invoiceExportListingAdapterService', invoiceExportListingAdapterService);

    /** @ngInject */
    function invoiceExportListingAdapterService(
        $q,
        invoiceApi,
        a8WebApiNoChunkDataProvider,
        exceptionService,
        exportDataModel
    ) {
        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            stopDownload: stopDownload, // inbound event (called by grid client)
        };

        let dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData(params) {
            return dbSource.fetch(function() {
                return getExportViewList(params);
            });
        }

        function getExportViewList(params) {
            if (!params) {
                return Promise.resolve([]);
            }

            let dataFilters = params || getDefaultFilterParams();

            let deferred = $q.defer();

            invoiceApi.getExportViewList(dataFilters.filters)
                .then(function(resp) {
                    let exportDataModels = mapData(resp.data);

                    deferred.resolve(exportDataModels);
                })
                .catch(function(err) {
                    exceptionService.resolve(err);
                    deferred.resolve([]);
                });

            return deferred.promise;
        }

        function mapData(data) {
            let mappedData = [];
            data.forEach(function(itm) {
                let invData = new exportDataModel();
                mappedData.push(invData.map(itm));
            });

            return mappedData;
        }

        function getDefaultFilterParams() {
            let filterModel = {
                startDate: null,
                endDate: null,
                invoiceStartDate: null,
                invoiceEndDate: null,
                ticketInvoiceNumber: null,
                branches: []
            };
            return {
                filters: filterModel
            };
        }

        function stopDownload() {}
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports.export')
        .service('invoiceExportGridService', invoiceExportGridService);

    /** @ngInject */
    function invoiceExportGridService(
        exceptionService,
        invoiceExportListingAdapterService
    ) {
        var service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = [];
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;

        activate();

        return service;

        ///////
        function activate() {}

        // Set data provider here
        function onInit() {
            service.grid.data = [];
            service.grid.behavior.setHubSourceAdapter(invoiceExportListingAdapterService);
        }

        /**
         * Loading of page data
         */
        function onCompleted(data) {
            service.grid.data = [];
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice.reports.export')
        .service('exportFilterService', exportFilterService);

    /** @ngInject */
    function exportFilterService(exportFilterModel) {

        var service = {
            data: new exportFilterModel()
        };

        activate();

        return service;

        ///////
        function activate() {}

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.reports.export')
        .service('exportFilterModel', exportFilterModel)

    function exportFilterModel(utils) {
        return function() {
            var self = this,
                defaults = {
                    startDate: utils.getStartOfWeek(new Date()),
                    endDate: utils.getEndOfWeek(new Date()),
                    selectedBranches: [],
                    selectedClients: [],
                    includeNotExportedOnly: false
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.selectedBranches.length = 0;
                self.selectedClients.length = 0;
            }

            function transformToModel() {
                let filterModel = {
                    BranchIds: [],
                    CompanyIds: [],
                    StartDate: null,
                    EndDate: null,
                    ShowDetails: false,
                    IncludeNotExportedOnly: false
                };

                // Branches
                // if (angular.isArray(self.selectedBranches)) {
                //     self.selectedBranches.map(function(itm) {
                //         filterModel.BranchIds.push(itm.Id);
                //     });
                // }

                // Get branches with Mixed States 
                if (angular.isArray(self.selectedBranches)) {
                    // Get selected state first
                    var selectedStates = _.filter(self.selectedBranches, function (o) {
                        return o.State == null;
                    });

                    var selBranches = _.filter(self.selectedBranches, function (o) {
                        return o.State != null;
                    });

                    // Get associated branches inside state
                    selectedStates.forEach(function (p) {
                        p.StateBranches.map(function (o) {
                            filterModel.BranchIds.push(o);
                        });
                    });

                    // Get branches
                    selBranches.map(function(o) {
                        filterModel.BranchIds.push(o.Id);
                    });

                    filterModel.BranchIds = _.uniq(filterModel.BranchIds);
                }

                // Client
                if (angular.isArray(self.selectedClients)) {
                    self.selectedClients.map(function(itm) {
                        filterModel.CompanyIds.push(itm.Id);
                    });
                }

                filterModel.StartDate = utils.jsDateTime(self.startDate);
                filterModel.EndDate = utils.jsDateTime(self.endDate);
                filterModel.ShowDetails = self.showDetails;
                filterModel.IncludeNotExportedOnly = self.includeNotExportedOnly;

                return filterModel;
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.reports.export')
        .service('exportDataModel', exportDataModel)

    function exportDataModel(alasql, utils) {
        return function() {
            var self = this,
                defaults = {
                    Id: null,
                    InvoiceNumber: null,
                    InvoiceDate: null,
                    CompanyId: null,
                    CompanyName: null,
                    Branches: [],
                    ExportToTenantName: null,
                    JobNumberHtml: null,
                    PurchaseOrderNumbers: [],
                    Tickets: [],
                    BranchesHtml: null,
                    PurchaseOrderHtml: null,
                    TotalIncludingTax: 0
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                self.InvoiceDate = utils.datePickerFormatDate2(self.InvoiceDate);

                // Extract all information
                self.PurchaseOrderNumbers = alasql("SELECT DISTINCT PurchaseOrderNumber FROM ? ", [self.Tickets]); //ORDER BY TicketNumber asc
                self.Branches = alasql("SELECT DISTINCT BranchName FROM ? ", [self.Tickets]);
                self.JobNumbers = alasql("SELECT DISTINCT JobNumber FROM ? ", [self.Tickets]);

                // Build html UL list
                self.PurchaseOrderHtml = buildULMarkup(self.PurchaseOrderNumbers);
                self.BranchesHtml = buildULMarkup(self.Branches);
                self.JobNumberHtml = buildULMarkup(self.JobNumbers);

                self.TotalIncludingTax = utils.moneyFormat(parseFloat(self.TotalIncludingTax), 2);

                return self;
            }

            function buildULMarkup(list) {
                //const MAX_ITEMS = 2;
                if (!!list && list.length <= 0)
                    return;

                let markup;

                if (list.length > 1) {
                    //let ctr = 1;
                    markup = '<ul class="list-none">';
                    list.map(function(itm) {

                        //if (ctr <= MAX_ITEMS) {
                        for (var prop in itm) {
                            if (itm[prop] != null) {
                                markup += '<li>' + itm[prop] + '</li>';
                            }
                        }
                        //}
                        //ctr++;
                    });

                    markup += '</ul>';
                } else {
                    for (var prop in list[0]) {
                        markup = list[0][prop];
                    }
                }

                return markup;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
'use strict';

(function() {
    'use strict';

    angular.module('app.invoice')
        .directive('invoiceErrorDetails', ['invoicingErrorCodes', 'utils', '_', function(invoicingErrorCodes, utils, _) {
            return {
                restrict: 'E',
                templateUrl: 'app/main/invoice/exportViewer/directives/invoice-error-details.html',
                scope: {
                    errors: '=',
                    invoice: '=',
                    deleteAction: '&',
                    redirectToCompanyPage: '&',
                    exportInvoicePaperworkCallback: '&'
                },
                link: function link(scope) {
                    scope.errorDescriptions = [];

                    scope.getErrorCodeDescription = function(errorCode) {
                        switch (errorCode) {
                            case invoicingErrorCodes.CompanyNotFoundInXero:
                                return utils.translate('INVOICE_EXPORT.COMPANY_NOT_FOUND_IN_XERO');
                            case invoicingErrorCodes.InvoiceAlreadyExistsInXero:
                                return utils.translate('INVOICE_EXPORT.INVOICE_ALREADY_EXISTS_IN_XERO');
                            case invoicingErrorCodes.PaperworkExportFailed:
                                return utils.translate("INVOICE_EXPORT.PAPERWORK_EXPORT_FAILED");
                            case invoicingErrorCodes.AccountCodeNotValid:
                                return utils.translate('INVOICE_EXPORT.ACCOUNT_CODE_NOT_VALID_FORMAT_UPDATETEXT');
                            case invoicingErrorCodes.BranchDoesNotHaveInvoicingCompany:
                                return utils.translate('INVOICE_EXPORT.BRANCH_DOES_NOT_HAVE_INVOICING_COMPANY');
                            case invoicingErrorCodes.UserDoesNotHaveAccessToInvoicingCompany:
                                return utils.translate('INVOICE_EXPORT.USER_DOES_NOT_HAVE_ACCESS_TO_INVOICING_COMPANY');
                            case invoicingErrorCodes.CustomerNotFoundInMyob:
                                return utils.translate('INVOICE_EXPORT.CUSTOMER_NOT_FOUND_IN_MYOB');
                            case invoicingErrorCodes.InvoiceAlreadyExistsInMyob:
                                return utils.translate('INVOICE_EXPORT.INVOICE_ALREADY_EXISTS_IN_MYOB');
                            case invoicingErrorCodes.GstTaxCodeNotFoundInMyob:
                                return utils.translate('INVOICE_EXPORT.GST_TAX_CODE_NOT_FOUND_IN_MYOB');
                            case invoicingErrorCodes.PurchaseOrderNumberTooLong:
                                return utils.translate('INVOICE_EXPORT.PURCHASE_ORDER_NUMBER_TOO_LONG');
                            case invoicingErrorCodes.JobNumberDoesNotExist:
                                return utils.translate('INVOICE_EXPORT.JOB_NUMBER_DOES_NOT_EXIST');
                            case invoicingErrorCodes.InvoicePaperworkNotFound:
                                return utils.translate('INVOICE_EXPORT.INVOICE_PAPERWORK_NOT_FOUND');
                            default:
                                return errorCode;
                        }
                    }

                    scope.getErrorDescription = function(error, textId) {
                        let errorCodeDescription = textId ? utils.translate(textId) : scope.getErrorCodeDescription(error.Code);

                        switch (error.Code) {
                            case invoicingErrorCodes.AccountCodeNotValid:
                                return error.LineItemsErrors.map(lineItemError =>
                                    errorCodeDescription
                                    .replace('{0}', lineItemError.CostCode)
                                    .replace('{1}', lineItemError.ItemCode)
                                    .replace('{2}', error.RateCardName || utils.translate("INVOICE_EXPORT.RATE_CARD_NOT_FOUND"))).join('<br/>');
                            case invoicingErrorCodes.UserDoesNotHaveAccessToInvoicingCompany:
                                return errorCodeDescription.replace('{0}', scope.invoice.ExportToTenantName);
                        }

                        return errorCodeDescription;
                    }

                    if (scope.errors.some(error => error.Code === invoicingErrorCodes.InvoiceAlreadyExistsInXero)) {
                        scope.errorDescriptions.push({
                            code: invoicingErrorCodes.InvoiceAlreadyExistsInXero,
                            text: `${scope.getErrorCodeDescription(invoicingErrorCodes.InvoiceAlreadyExistsInXero)}`
                        });

                        if (scope.errors.some(error => error.Code === invoicingErrorCodes.PaperworkExportFailed)) {
                            scope.errorDescriptions.push({
                                code: invoicingErrorCodes.PaperworkExportFailed,
                                action: scope.exportInvoicePaperworkCallback,
                                text: `${scope.getErrorCodeDescription(invoicingErrorCodes.PaperworkExportFailed)}`,
                                actionText: utils.translate('INVOICE_EXPORT.CLICK_HERE_TO_RETRY')
                            });
                        }
                        if (scope.errors.some(error => error.Code === invoicingErrorCodes.InvoicePaperworkNotFound)) {
                            scope.errorDescriptions.push({
                                code: invoicingErrorCodes.InvoicePaperworkNotFound,
                                text: `${scope.getErrorCodeDescription(invoicingErrorCodes.InvoicePaperworkNotFound)}`
                            });
                        }
                    } else if (scope.errors.some(error => error.Code === invoicingErrorCodes.JobNumberDoesNotExist)) {
                        var ticket = scope.invoice.Tickets[0];
                        var errorText = scope.getErrorCodeDescription(invoicingErrorCodes.JobNumberDoesNotExist).replace('{0}', ticket.JobNumber);
                        scope.errorDescriptions.push({
                            code: invoicingErrorCodes.JobNumberDoesNotExist,
                            text: errorText,
                            action: scope.redirectToCompanyPage,
                            actionText: utils.translate('INVOICE_EXPORT.JOB_NUMBER_DOES_NOT_EXIST_UPDATE_JOB_NUMBER'),
                            postText: utils.translate('INVOICE_EXPORT.JOB_NUMBER_DOES_NOT_EXIST_UPDATE_JOB_NUMBER_TRY_AGAIN')
                        });
                    } else if (scope.errors && _.some(scope.errors, err => err.LineItemsErrors.length > 0)) {
                        scope.errorDescriptions.push({
                            code: invoicingErrorCodes.AccountCodeNotValid,
                            action: scope.deleteAction,
                            text: `${scope.getErrorCodeDescription(invoicingErrorCodes.AccountCodeNotValid)}`,
                            preText: `${scope.getErrorDescription(scope.errors[0], 'INVOICE_EXPORT.ACCOUNT_CODE_NOT_VALID_FORMAT')}`,
                            actionText: utils.translate('INVOICE_EXPORT.ACCOUNT_CODE_NOT_VALID_FORMAT_DELETE_INVOICE')
                        });
                    } else {
                        scope.errors.forEach(error => scope.errorDescriptions.push({
                            code: error.Code,
                            text: `${scope.getErrorDescription(error)}`
                        }))
                    }
                }
            };
        }]);
})();

(function() {
    'use strict';

    angular.module('app.invoice')
        .directive('invoiceErrorColumn', ['invoicingErrorCodes', function(invoicingErrorCodes) {
            return {
                restrict: 'E',
                templateUrl: 'app/main/invoice/exportViewer/directives/invoice-error-column.html',
                scope: {
                    invoice: '='
                },
                link: function link(scope) {
                    var rightArrowIcon = 'arrow_right';
                    var dropdownArrowIcon = 'arrow_drop_down';

                    scope.toggleStateIcon = rightArrowIcon;

                    scope.$watch('invoice', function(newValue, oldValue) {
                        var success = scope.invoice.InvoicingErrors.map(i => i.Code)
                            .every(i => i === invoicingErrorCodes.InvoiceAlreadyExistsInXero || i === invoicingErrorCodes.InvoiceAlreadyExistsInMyob
                                || i === invoicingErrorCodes.InvoicePaperworkNotFound);

                        var statusIcon = success ? 'checkmark-circle-success.svg' : 'warning.svg';

                        var assetBasePath = '/assets/icons/';
                        scope.statusIcon = assetBasePath + statusIcon;
                    });

                    scope.$watch('invoice.showErrors', function(newValue, oldValue) {
                        scope.toggleStateIcon = scope.invoice.showErrors ? dropdownArrowIcon : rightArrowIcon;
                    });

                    scope.toggleColumn = function() {
                        scope.invoice.showErrors = !scope.invoice.showErrors;
                    };
                }
            };
        }]);
})();

"use strict";

angular.module("app.invoice").constant("invoicingErrorCodes", {
    CompanyNotFoundInXero: 0,
    InvoiceAlreadyExistsInXero: 1,
    AccountCodeNotValid: 2,
    PaperworkExportFailed: 3,
    BranchDoesNotHaveInvoicingCompany: 4,
    UserDoesNotHaveAccessToInvoicingCompany: 5,
    CustomerNotFoundInMyob: 6,
    InvoiceAlreadyExistsInMyob: 7,
    GstTaxCodeNotFoundInMyob: 8,
    PurchaseOrderNumberTooLong: 9,
    JobNumberDoesNotExist: 10,
    InvoicePaperworkNotFound : 11
});

/**
 * Virtual Repeat Blank Space Fix
 *
 * Rcnet 10.4.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('virtualRepeatFixService', virtualRepeatFixService);

    /** @ngInject */
    function virtualRepeatFixService() {

        var service = {
            fixBlankSpace: fixBlankSpace
        };

        activate();

        return service;
        ////////

        function activate() { }

        /**
        * A workaround to fix issue with filtering or searching which cause a blank space when the previous result was scrolled
        */
        function fixBlankSpace() {
            var container = document.getElementsByClassName('md-virtual-repeat-scroller')
            var wrappedResult = angular.element(container);
            if (wrappedResult[0].scrollTop != 0)
                wrappedResult[0].scrollTop = 0;
        }
    }
})();
/**
 * Download Invoice Service
 *
 * Rcnet 9.7.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('sendMailService', sendMailService);

    /** @ngInject */
    function sendMailService($log,
        $q,
        $timeout,
        exceptionService,
        invoiceDistributionApi,
        utils,
        $mdToast,
        $mdDialog,
        blockUI,
        msgboxService,
        _
    ) {

        var service = {
            sendMail: sendMail,
            sendSingleMail: sendSingleMail,
            updateSideNav: angular.noop,  // parent callback
            updateContent: angular.noop,  // parent callback
            updateEmailIssues: angular.noop, // parent callback
            getCheckedItemsInvDist: angular.noop, // parent callback
            getInvoice: angular.noop, // parent callback
            fixInvoiceEmail: angular.noop, // parent callback
            setProcessStatus: angular.noop, // parent callback
            setProcessStatusToSingleItem: angular.noop, // parent callback
            applySendResult: angular.noop, // parent callback
            revertSendResult: angular.noop, // parent callback
            reselectViewTypeAndRefresh: angular.noop,
            removeCheckedItems: angular.noop,
            clearIssues: angular.noop
        };

        const TOASTR_DELAY = 4000;
        const SKIPPED_VIEWTYPE = 4;

        activate();

        return service;
        ////////

        function activate() {}

        /**
         * Sending of multiple Emails
         * @param {*} contentApi 
         */
        function sendMail(contentApi) {
            var checkedItemResult = service.getCheckedItemsInvDist();
            if (checkedItemResult.checkedItems.length > 0) {
                checkForSkippedItemSending(checkedItemResult, (checkedItemResult.checkedItems.length > 1), contentApi);
            }
        }

        function checkForSkippedItemSending(checkedItemResult, hasManyItems, contentApi) {
            if (checkedItemResult.currentViewType == SKIPPED_VIEWTYPE) {
                var msg1 = hasManyItems ? 'these emails' : 'this email';
                var msg2 = hasManyItems ? 'they have' : 'it has';
                msgboxService.yepNo('Are you sure you would like to send ' + msg1 + ' as ' + msg2 + ' been marked to be skipped?', 'Sending Confirmation')
                             .then(function(resp) {
                                checkForInvoiceWithoutEmail(checkedItemResult.checkedItems, contentApi);
                             }, function() {});
            } else {
                checkForInvoiceWithoutEmail(checkedItemResult.checkedItems, contentApi);
            }
        }

        function sendSingleMail(invoiceId, recipient) {
            var inv = service.getInvoice(invoiceId);
            if (inv == null) return $q.when('no data');

            var invCloned = {};
            angular.copy(inv, invCloned);
            invCloned.EmailRecipients = [recipient];

            return sendNow([invCloned], 'individual-sending');
        }

        function checkForInvoiceWithoutEmail(invoices, contentApi) {
            var invoiceWithoutEmails = _.filter(invoices, function (o) {
                return o.EmailRecipients.length <= 0;
            });

            var result = getRecipientsPayload(invoices);

            if (result.hasIssue && !result.hasOkList) {
                service.updateEmailIssues(result.issues, 'No recipients found.', false);
            } else if (result.hasIssue && result.hasOkList) {
                var promise1 = service.updateEmailIssues(result.issues, 'Missing recipients in some of the selected invoice(s). Do you want to continue anyway?', true);
                promise1.then(function (resp) {
                    if (resp == 'continue') {
                        sendNow(result.okList, 'normal');
                    }
                });
            } else {
                sendNow(result.okList, 'normal');
            }
        }

        function getRecipientsPayload(invoices) {
            var invoiceListOk = getInvoicesForSending(invoices);
            var invoiceListWithIssues = getInvoicesWithNoRecipients(invoices);

            return {
                okList: invoiceListOk,
                issues: invoiceListWithIssues,
                hasIssue: invoiceListWithIssues.length > 0,
                hasOkList: invoiceListOk.length > 0
            };
        }

        function getInvoicesForSending(invoices) {
            var invoicesForSending = _.filter(invoices, function (o) {
                return o.EmailRecipients.length > 0;
            });

            return invoicesForSending;
        }

        function getInvoicesWithNoRecipients(invoices) {
            var invClones = _.cloneDeep(invoices);
            var noRecipients = _.filter(invClones, function (o) {
                return (o.EmailRecipients == null || o.EmailRecipients.length == 0);
            });

            noRecipients.forEach(function (itm) {
                itm['Reason'] = 'No Email';
            });

            return noRecipients;
        }

        function sendNow(invoices, mode) {
            var deferred = $q.defer();
            var invoicesToSend = [];

            _.forEach(invoices, function (o) {
                invoicesToSend.push({
                    InvoiceId: o.Id,
                    // A copy, not the grid row's own array: setProcessStatus below stamps an
                    // optimistic Queueing on those objects, which must never travel to the server as
                    // if it were the recipient's real state. This list decides who is emailed.
                    // See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#the-rule-the-posted-list-decides
                    EmailRecipients: _.cloneDeep(o.EmailRecipients)
                });
            });

            service.updateContent(true);
            service.updateSideNav(true, 'Sending ' + invoices.length + ' invoice(s)');
            (mode == 'normal' ? service.setProcessStatus : service.setProcessStatusToSingleItem)(invoicesToSend, 'queueing');

            invoiceDistributionApi.sendMail(invoicesToSend)
                .then(function (resp) {
                    service.updateContent(false);
                    service.updateSideNav(false);

                    // Replace the optimistic guess with what the send actually did. Only some of the
                    // recipients are queued now — the ones held back for a personal invoice PDF are
                    // emailed later from the generation callback — so assuming a status update is
                    // coming for every recipient leaves the row waiting forever.
                    service.applySendResult(resp && resp.data, invoicesToSend);

                    service.reselectViewTypeAndRefresh();
                    service.removeCheckedItems();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Successfully sent invoice(s) for queueing.')
                            .position('bottom right')
                            .hideDelay(TOASTR_DELAY)
                    );

                    deferred.resolve('done');
                }).catch(function (ex) {
                    service.updateContent(false);
                    service.updateSideNav(false);

                    // invoicesToSend was snapshotted before the optimistic queueing state was applied,
                    // so it restores the rows to what they were rather than leaving them mid-send.
                    service.revertSendResult(invoicesToSend);

                    service.reselectViewTypeAndRefresh();
                    service.removeCheckedItems();
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }
    }
})();
/**
 * Status checker bitwise
 *
 * Rcnet 9.25.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('invoiceStatusService', invoiceStatusService);

    /** @ngInject */
    function invoiceStatusService($log,
        $q,
        exceptionService,
        utils
    ) {
        var service = {
            getOverallStatus: getOverallStatus,
            checkStatusIfProcessing: checkStatusIfProcessing,
            hasPendingDelivery: hasPendingDelivery,
            getSpinnerStatusMessage: getSpinnerStatusMessage
        };

        const UNSENT = 1;
        const QUEUEING = 2;
        const SENT = 4;
        const BOUNCE = 8;
        const ERROR = 16;
        const READ = 32;

        activate();

        return service;
        ////////

        function activate() { }

        /**
         * Overall Status
         *  SentSuccess = 1,
         *  Unsent = 2,
         *  Failed = 3,
         *  Skipped = 4
         * @param {*} emailRecipients 
         * @param {*} isEmailInvoice 
         */
        function getOverallStatus(emailRecipients, isEmailInvoice) {
            var andResult = null;
            emailRecipients.forEach(function (itm) {
                if (andResult == null)
                    andResult = itm.Status;
                else
                    andResult = itm.Status | andResult;
            });

            if (((andResult & BOUNCE) != 0) || (andResult & ERROR) != 0) {
                return 3;
            } else if (((andResult & UNSENT) != 0) || (andResult & QUEUEING) != 0) {
               
                return isEmailInvoice ? 2 : 4;
            } else {
                return 1;
            }
        }

        /**
         * Perform bitwise logic here (checking for queue status)
         * @param {list of recipients} emailRecipients 
         */
        function checkStatusIfProcessing(emailRecipients) {
            var andResult = null;
            emailRecipients.forEach(function (itm) {
                if (andResult == null)
                    andResult = itm.Status;
                else
                    andResult = itm.Status | andResult;
            });

            return ((andResult & QUEUEING) != 0);
        }

        /**
         * Is anything on this invoice still on its way?
         *
         * Broader than checkStatusIfProcessing, which asks only about the queueing bit and is what the
         * grid uses when it loads a page. After a send, a recipient held back for a personal invoice
         * PDF is still unsent — it is emailed later from the generation callback — so the row is
         * genuinely mid-delivery even though nothing is queued yet.
         *
         * @param {list of recipients} emailRecipients
         */
        function hasPendingDelivery(emailRecipients) {
            var andResult = null;
            (emailRecipients || []).forEach(function (itm) {
                if (andResult == null)
                    andResult = itm.Status;
                else
                    andResult = itm.Status | andResult;
            });

            return andResult != null && (((andResult & UNSENT) != 0) || ((andResult & QUEUEING) != 0));
        }

        function getSpinnerStatusMessage(status) {
            if (status == 'queueing') 
                 return { code: 2, desc: 'SENDING' };
            // switch (status) {
            //     case 'queueing': return { code: 2, desc: 'QUEUEING' };
            //     //case 'unsent': return {code: 1, desc: 'UNSENT'};
            //     case 'sent': return { code: 4, desc: 'SENT' };
            //     case 'bounce': return { code: 8, desc: 'BOUNCE' };
            //     case 'error': return { code: 16, desc: 'ERROR' };
            //     default: return { code: -1, desc: 'UNKNOWN' };
            // }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('invoiceDistributionGridService', invoiceDistributionGridService);

    /** @ngInject */
    function invoiceDistributionGridService(
        exceptionService,
        invoiceDistDataAdapterService,
        invoiceStatusService
    ) {
        const SENT_SUCCESS_STATUS = 1;
        const FAILED_STATUS = 3;

        var service = {
            grid: {},
            gridInfo: {
                totalItems: 0,
                rawTotalItemCount: 0,
                inProgress: false,
                isFiltered: false
            },
            contentLoading: true,
            filterData: null,
            setFilterData: setFilterData,
            setClientSideFilter: setClientSideFilter,
            componentEvent: angular.noop
        };

        service.grid.api = {};
        service.grid.data = []; // View model for grid data
        service.searchText;
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;
        service.grid.onSearch = onSearch;
        service.grid.allowCustomClientSideFiltering = true;
        service.grid.onCustomClientSideFiltering = onCustomClientSideFiltering;

        var clientSideFilter;

        activate();

        return service;

        ///////
        function activate() {}

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.api.setHubSourceAdapter(invoiceDistDataAdapterService);
        }

        /**
         * Loading of partial data
         * Perform view model data shaping here
         */
        function onCompleted(data) {
            service.grid.data.length = 0;

            angular.forEach(data, function(itm) {
                // Runs on every view-type reselect, not only a fresh load, so these rows can be the
                // in-session ones still carrying the Queueing value stamped on before the post. A
                // terminal EmailDeliveryStatus settles it; FAILED counts as finished, as in setStatusSent.
                // See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#portal-notes
                var hasFinishedSending = itm.EmailDeliveryStatus === SENT_SUCCESS_STATUS
                                      || itm.EmailDeliveryStatus === FAILED_STATUS;

                var isProcessing = !hasFinishedSending
                                && invoiceStatusService.checkStatusIfProcessing(itm.EmailRecipients);
                itm['Selected'] = false;
                itm['ProcessStatus'] = isProcessing ? invoiceStatusService.getSpinnerStatusMessage('queueing').desc : '';
                itm['IsProcessing'] = isProcessing;
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function setFilterData(filter) {
            service.filterData = filter;
        }

        function onDataLoading(extraData) {
            populateGridInfo();
            service.componentEvent({
                e: 'onGridInfoPopulated',
                data: service.gridInfo
            });
        }

        /**
         * Expose Grid info to customised external grid info
         */
        function populateGridInfo() {
            let data = service.grid.api.getGridInfo();
            service.gridInfo.totalItems = data.totalItems;
            service.gridInfo.rawTotalItemCount = data.rawTotalItemCount;
            service.gridInfo.inProgress = data.inProgress;
            service.gridInfo.isFiltered = data.isFiltered;
        }

        function onSearch(value) {
            service.componentEvent({
                e: 'onSearch'
            });
            service.grid.api.search(value);
        }

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {
            populateGridInfo();
            service.componentEvent({
                e: 'loadcompleted'
            });
            service.componentEvent({
                e: 'onGridInfoPopulated',
                data: service.gridInfo
            });
        }

        function onError(ex) {
            exceptionService.resolve(ex);
        }

        function onCustomClientSideFiltering(data) {
            if (clientSideFilter == null || clientSideFilter.viewType == null) {
                return data;
            }

            var result = _.filter(data, function(itm) {
                if (clientSideFilter.viewType != -1 && !clientSideFilter.showCreditNotes) {
                    return itm.EmailDeliveryStatus == clientSideFilter.viewType && itm.TotalIncludingTax > 0;
                }

                if (clientSideFilter.viewType == -1 && !clientSideFilter.showCreditNotes) {
                    return itm.TotalIncludingTax > 0;
                }

                if (clientSideFilter.showCreditNotes) {
                    if (clientSideFilter.viewType != -1) {
                        return itm.EmailDeliveryStatus == clientSideFilter.viewType;
                    }

                    return true;
                }
            });

            return result;
        }

        function setClientSideFilter(filter) {
            clientSideFilter = filter;
        }
    }
})();

/**
 * SignalR service Message Listener
 *
 * Rcnet 1.16.2017
 */
(function() {
    'use strict';

    angular.module('app.corelib')
        .service('invoiceDistHubService', invoiceDistHubService);

    /** @ngInject */
    function invoiceDistHubService($mdToast,
        $log,
        signalRService,
        $rootScope,
        $timeout,
        blockUI,
        exceptionService,
        emailSenderMainService,
        downloadInvoiceService) {

        const TOASTR_DELAY = 5000;

        var service = {
            register: register
        };

        var isInitialized = false; // To prevent double subscription to event

        return service;

        ///////
        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function() {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }
        }

        function regs() {

            // Download feedback
            signalRService.messageHub.on('invoiceDistDownloadNotify', function(data) {
                if (data.RequestToken == downloadInvoiceService.currentRequestToken) {

                    if (data.IsError) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.Message)
                            .position('bottom right')
                            .hideDelay(false)
                            .action('CLOSE')
                        );
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.Message)
                            .position('bottom right')
                            .hideDelay(3000)
                        );
                    }
                }
            });

            // ApiSubmitter callback
            signalRService.messageHub.on('invoiceDistStatus', function(data) {
                emailSenderMainService.setStatusSent(data.Id, data.Status, data.EmailId, data.RecipientEmailStatus);
            });

            // Note: Not yet use - nothing in CoreAPI broadcasts setInvoiceDistStatusToQueued today.
            // Kept as the placeholder it is, but corrected so it works when something does: the
            // handler reads invoiceItem.InvoiceId off each entry, and 'queued' is not a status
            // getSpinnerStatusMessage answers for.
            signalRService.messageHub.on('setInvoiceDistStatusToQueued', function(data) {
                emailSenderMainService.setProcessStatus([{ InvoiceId: data.InvoiceId }], 'queueing');
            });
        }

    };
})();
/**
 * Invoice Distribution data adapter service
 *
 * Rcnet 4.20.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('invoiceDistDataAdapterService', invoiceDistDataAdapterService);

    /** @ngInject */
    function invoiceDistDataAdapterService($log,
        $q,
        exceptionService,
        signalrDataProvider
    ) {

        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            stopDownload: stopDownload // inbound event (called by grid client)
        };

        // Create data provider
        var dbSource = signalrDataProvider.getInstance({ hub: 'invoiceDistributionHub', 
                                                         endpoint: 'GetInvoicesToEmail' });

        activate();

        return service;
        ///////

        function activate() {
            // Db hub
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData(params) {
            let dataFilters = params || getDefaultFilterParams();
            return dbSource.downloadTickets(dataFilters.filters);
        }

        /**
         * Todo: Put this to separate service or model !!!!
         */
        function getDefaultFilterParams() {
            let filterModel = {
                Branches: [],
                Companies: [],
                StartDate: null,
                EndDate: null
            };
            return { filters: filterModel };
        }

        /**
         * it's not working yet
         * research for SignalR cancellation 
         */
        function stopDownload(initiator) {
            $log.debug('Stop downloading...');
            dbSource.stopDownload();
        }
    }
})();
/**
 * Download Invoice Service
 *
 * Rcnet 9.7.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('fixInvoiceService', fixInvoiceService);

    /** @ngInject */
    function fixInvoiceService($log,
        $q,
        exceptionService,
        utils,
        blockUI
    ) {

        var service = {
            fixInvoiceEmail: fixInvoiceEmail
        };

        activate();

        return service;
        ////////

        function activate () { }

        function fixInvoiceEmail(emails, gridData) {
            _.filter(emails, function (x) {
                var invoice = _.find(gridData, function (o) {
                    return o.Id == x.m_Item1;
                });

                if (invoice) {
                    x.m_Item2.forEach(function (i) {
                        invoice.EmailRecipients = invoice.recipients || [];
                        invoice.EmailRecipients.push(i);
                    });
                }
            });
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('emailSenderMainService', emailSenderMainService);

    /** @ngInject */
    function emailSenderMainService(
        $q,
        $timeout,
        $mdDialog,
        invoiceLookupService,
        invoiceDistributionGridService,
        sideNavEmailSenderModel,
        downloadInvoiceService,
        sendMailService,
        fixInvoiceService,
        invoiceStatusService,
        virtualRepeatFixService
    ) {
        var service = {
            branchLookups: invoiceLookupService.data.branchLookups,
            clientLookups: invoiceLookupService.data.clientLookups,
            sideNavModel: new sideNavEmailSenderModel(),
            generatePreview: generatePreview,
            dataGrid: invoiceDistributionGridService,
            emailSenderContentApi: {},
            customGridSearchComponent: {},
            checkToggle: checkToggle,
            downloadInvoice: downloadInvoice,
            sendEmail: sendEmail,
            openIssue: openIssue,
            checkSingleItem: checkSingleItem,
            setStatusSent: setStatusSent,
            setProcessStatus: setProcessStatus,
            selectViewType: selectViewType,
            stopGridFetchingData: stopGridFetchingData,
            checkPaymentClaim: checkPaymentClaim,
            showSingleClientSelection: false,
            clientSelectionStatus: false,
        };

        const ALL_VIEWTYPE = -1;
        const SKIPPED_VIEWTYPE = 4;
        const SKIPPED_INVOICE = 4;
        const SENT_SUCCESS_STATUS = 1;
        const FAILED_STATUS = 3;
        const UNSENT_RECIPIENT_STATUS = 1;
        const QUEUEING_RECIPIENT_STATUS = 2;
        const SENT_RECIPIENT_STATUS = 4;
        var currentViewType = ALL_VIEWTYPE;

        activate();

        return service;

        function activate() {
            downloadInvoiceService.getCheckedItemsInvDist = getCheckedItems;
            sendMailService.getInvoice = getInvoice;
            sendMailService.setProcessStatusToSingleItem = setProcessStatusToSingleItem;
            sendMailService.getCheckedItemsInvDist = getCheckedItems;
            sendMailService.fixInvoiceEmail = fixInvoiceEmail;
            sendMailService.setProcessStatus = setProcessStatus;
            sendMailService.applySendResult = applySendResult;
            sendMailService.revertSendResult = revertSendResult;
            sendMailService.reselectViewTypeAndRefresh = reselectViewTypeAndRefresh;
            sendMailService.removeCheckedItems = removeCheckedItems;
            sendMailService.clearIssues = clearIssues;
        }

        function generatePreview() {
            virtualRepeatFixService.fixBlankSpace();
            $timeout(function() {

                service.dataGrid.grid.api.clearAll();
                service.sideNavModel.setToProcessingState('Retrieving Invoice Data', false);
                service.emailSenderContentApi.refresh();
                service.emailSenderContentApi.setBusy(true);
                service.clientSelectionStatus = service.showSingleClientSelection;

                if(service.clientSelectionStatus){
                    service.sideNavModel.selectedClients = Array(service.sideNavModel.selectedClient);
                }

                invoiceDistributionGridService.componentEvent = gridComponentEvent;
                service.dataGrid.setFilterData(service.sideNavModel.toBackendModel());
                service.dataGrid.grid.api.refresh();
            });
        }

        function gridComponentEvent(eventObj) {
            switch (eventObj.e) {
                case 'loadcompleted':
                    service.sideNavModel.disableProcessingState();
                    service.emailSenderContentApi.setBusy(false);
                    break;
                case 'onGridInfoPopulated':
                    service.emailSenderContentApi.populateGridInfo(eventObj.data);
                    break;
                case 'onSearch':
                    service.emailSenderContentApi.refresh();
                    break;
            }
        }

        function checkToggle(toggleFlag) {
            var checkedItems = performCheckItems(service.dataGrid.grid.data, toggleFlag);
            service.emailSenderContentApi.setNumberOfCheckedItems(checkedItems);
        }

        function performCheckItems(data, flag) {
            data.forEach(function(o) {
                o.Selected = flag;
            });

            var itemsChecked = countCheckedItems(data);

            return itemsChecked;
        }

        function getCheckedItems(isRequestedByDownloader) {
            var checkedItems = _.filter(service.dataGrid.grid.data, function(o) {

                if (isRequestedByDownloader) {
                    return o.Selected === true;
                } else if (o.EmailInvoices == false && o.EmailDeliveryStatus == SKIPPED_INVOICE && currentViewType == SKIPPED_VIEWTYPE) {
                    return o.Selected === true;
                } else if (o.EmailInvoices || o.EmailInvoices == false && o.EmailDeliveryStatus != SKIPPED_INVOICE) {
                    return o.Selected === true;
                }

                return false;
            });

            return {
                currentViewType: currentViewType,
                checkedItems: checkedItems
            };
        }

        function getInvoice(id) {
            var inv = _.find(service.dataGrid.grid.data, function(o) {
                return o.Id == id;
            });

            return inv;
        }

        function removeCheckedItems() {
            service.emailSenderContentApi.refresh();
            var checkedItems = _.filter(service.dataGrid.grid.data, function(o) {
                return o.Selected === true;
            });

            checkedItems.forEach(function(o) {
                o.Selected = false;
            });
        }

        function countCheckedItems(invoiceList) {
            var checkedItems = _.filter(invoiceList, function(itm) {
                return itm.Selected == true;
            });

            return checkedItems.length;
        }

        function checkSingleItem(id) {
            var itemsChecked = countCheckedItems(service.dataGrid.grid.data);
            var hasItemsChecked = hasCheckedItems(service.dataGrid.grid.data);

            return {
                hasItemsChecked: hasItemsChecked,
                itemsChecked: itemsChecked
            };
        }

        function hasCheckedItems(data) {
            var result = _.filter(data, function(o) {
                return o.Selected == true;
            });
            return result.length > 0;
        }

        function downloadInvoice(includePaperwork, isPaperworkOnly, isPaymentClaim, paymentClaimRequestType) {
            downloadInvoiceService.download(includePaperwork, isPaperworkOnly, isPaymentClaim, paymentClaimRequestType);
        }

        function sendEmail() {
            sendMailService.updateSideNav = function(flag, msg) {
                flag ? service.sideNavModel.setToProcessingState(msg, true) : service.sideNavModel.disableProcessingState(msg);
            };

            sendMailService.updateContent = function(flag) {
                service.emailSenderContentApi.setBusy(flag);
            };

            sendMailService.updateEmailIssues = function(issues, message, isShowProceed) {
                service.emailSenderContentApi.setInvoiceIssue(issues);
                return showIssues(issues, message, isShowProceed);
            };

            clearIssues();
            sendMailService.sendMail();
        }

        function clearIssues() {
            service.emailSenderContentApi.clearIssues();
        }

        function openIssue(issues) {
            return showIssues(issues);
        }

        function showIssues(issues, message, isShowProceed) {
            var deferred = $q.defer();

            $mdDialog.show({
                templateUrl: 'app/main/invoice/emailSender/dialogs/issue-dialog/issue-dialog.html',
                controller: 'IssueDialogController',
                controllerAs: 'vm',
                locals: {
                    issues: issues,
                    message: message,
                    isShowProceed: isShowProceed
                },
                multiple: true
            }).then(function(resp) {
                deferred.resolve(resp);
            }, function() {
                deferred.resolve('oks!');
            });

            return deferred.promise;
        }

        function fixInvoiceEmail(emails) {
            fixInvoiceService.fixInvoiceEmail(emails, service.dataGrid.grid.data);
        }

        function setProcessStatus(invoices, status) {
            // getSpinnerStatusMessage only answers for 'queueing' and returns undefined otherwise -
            // invoiceDistHub still calls this with 'queued'. Reading .code off that throws.
            var statusResult = invoiceStatusService.getSpinnerStatusMessage(status);

            if (statusResult == null) {
                return;
            }

            invoices.forEach(function(invoiceItem) {
                var item = _.find(service.dataGrid.grid.data, function(o) {
                    return o.Id === invoiceItem.InvoiceId;
                });

                // The grid need not be holding the invoice: a filter or view change can drop it
                // between the post and this call.
                if (item == null) {
                    return;
                }

                (item.EmailRecipients || []).forEach(function(i) {
                    i.Status = statusResult.code;
                });

                item.ProcessStatus = statusResult.desc;
                item.IsProcessing = status == 'sent' ? false : true;
            });
        }

        function setProcessStatusToSingleItem(invoices, status) {
            var item = _.find(service.dataGrid.grid.data, function(o) {
                return o.Id === invoices[0].InvoiceId;
            });

            var statusResult = invoiceStatusService.getSpinnerStatusMessage(status);

            if (item == null || statusResult == null) {
                return;
            }

            var recipient = _.find(item.EmailRecipients, function(o) {
                return o.Id == invoices[0].EmailRecipients[0].Id;
            });

            // A resend names one row. If the grid is not holding that row there is nothing to stamp,
            // but the send still happened, so the invoice's own progress state is still set.
            if (recipient != null) {
                recipient.Status = statusResult.code;
            }

            item.ProcessStatus = statusResult.desc;
            item.IsProcessing = status == 'sent' ? false : true;
        }

        /**
         * Reconciles the rows with what the send actually acted on, by taking the server's recipient
         * list over the optimistic one — see
         * architecture.md#attachment-preference-document-contract.
         *
         * @param {array} results one entry per invoice: { InvoiceId, EmailRecipients }
         */
        function applySendResult(results, requested) {
            applyRecipients(results, true);

            // An invoice the server did not report back on was not acted upon at all — email
            // notifications are disabled for the tenant, or it is no longer finalised. Without this
            // it spins for a status update that is never coming.
            var acknowledged = (angular.isArray(results) ? results : []).map(function(result) {
                return result == null ? null : result.InvoiceId;
            });

            var unacknowledged = (angular.isArray(requested) ? requested : []).filter(function(item) {
                return acknowledged.indexOf(item.InvoiceId) < 0;
            });

            applyRecipients(unacknowledged, false);
        }

        /**
         * Puts the rows back the way they were when a send fails. The caller passes the payload it
         * built, which was snapshotted before the optimistic state was applied — otherwise a failed
         * send leaves every recipient showing as queueing and the row spinning until a page reload.
         *
         * @param {array} results one entry per invoice: { InvoiceId, EmailRecipients }
         */
        function revertSendResult(results) {
            applyRecipients(results, false);
        }

        /**
         * @param {boolean} unsentIsPending after a send an unsent recipient is still on its way (it is
         *        emailed from the personal-PDF generation callback); on a restore it is simply unsent.
         */
        function applyRecipients(results, unsentIsPending) {
            if (!angular.isArray(results)) return;

            results.forEach(function(result) {
                if (result == null || result.InvoiceId == null) return;

                service.dataGrid.grid.api.invokeUpdateState(function(o) {
                    return o.Id === result.InvoiceId;
                }, function(items) {

                    var item = items[0];

                    item.EmailRecipients = applyRecipientRows(item.EmailRecipients, result.EmailRecipients || []);
                    item.EmailDeliveryStatus = invoiceStatusService.getOverallStatus(item.EmailRecipients, item.EmailInvoices);
                    item.IsProcessing = unsentIsPending
                        ? invoiceStatusService.hasPendingDelivery(item.EmailRecipients)
                        : invoiceStatusService.checkStatusIfProcessing(item.EmailRecipients);
                    item.ProcessStatus = item.IsProcessing
                        ? invoiceStatusService.getSpinnerStatusMessage('queueing').desc
                        : '';

                }, false);
            });
        }

        /**
         * Refills the array in place. The grid row shares it by reference with the Recipient Logs
         * dialog, which is where a resend is raised from, so swapping it strands the open dialog.
         * See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#portal-notes
         */
        function applyRecipientRows(current, incoming) {
            var rows = keepDeliveredRows(current, incoming);

            if (!angular.isArray(current)) {
                return rows;
            }

            // splice, not length/push: it is one mutation of the array the dialog is bound to.
            Array.prototype.splice.apply(current, [0, current.length].concat(rows));

            return current;
        }

        /**
         * The send result is a pre-delivery snapshot, so it must not walk back a status the hub has
         * already settled - that revert leaves a row on SENDING with no callback still to come.
         * See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#portal-notes
         */
        function keepDeliveredRows(current, incoming) {
            var deliveredById = {};

            (current || []).forEach(function(row) {
                if (row && row.Id != null && !invoiceStatusService.hasPendingDelivery([row])) {
                    deliveredById[row.Id] = row.Status;
                }
            });

            incoming.forEach(function(row) {
                if (row && deliveredById[row.Id] != null && invoiceStatusService.hasPendingDelivery([row])) {
                    row.Status = deliveredById[row.Id];
                }
            });

            return incoming;
        }

        /**
         * Re-applies the current view type so a row that has just changed state moves to (or out of)
         * the tab being viewed. Declared on sendMailService, which called it after every send but
         * never had it assigned — so nothing happened.
         */
        function reselectViewTypeAndRefresh() {
            service.emailSenderContentApi.reselectViewType();
        }

        function setStatusSent(id, overallStatus, emailId, recipientMailStatus) {

            $timeout(function() {
                service.dataGrid.grid.api.invokeUpdateState(function(o) {
                    return o.Id === id;
                }, function(items) {

                    let item = items[0];
                    if (item.EmailRecipients == null) {
                        return;
                    }

                    item.EmailRecipients.forEach(function(obj) {
                        if (obj.Id == emailId) {
                            obj.Status = recipientMailStatus;
                        }
                    });

                    // SentSuccess means every stored row is terminal, so a row still reading Queueing
                    // or Unsent is the value stamped on before the post, on a row whose callback the
                    // grid could not match by Id. Correcting it is not inventing a status.
                    // See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#portal-notes
                    if (overallStatus === SENT_SUCCESS_STATUS) {
                        item.EmailRecipients.forEach(function(obj) {
                            if (obj.Status === QUEUEING_RECIPIENT_STATUS
                             || obj.Status === UNSENT_RECIPIENT_STATUS) {
                                obj.Status = SENT_RECIPIENT_STATUS;
                            }
                        });
                    }

                    // A terminal overallStatus is the server's own rollup over the stored list, so it
                    // needs no local rollup - rolling up locally leaves the badge stuck on any row the
                    // grid could not match. The local rollup stays for non-terminal values.
                    // See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#portal-notes
                    var serverReportedTerminal = overallStatus === SENT_SUCCESS_STATUS
                                              || overallStatus === FAILED_STATUS;

                    if (serverReportedTerminal || item.EmailRecipients.length <= 1) {
                        item.EmailDeliveryStatus = overallStatus;
                    } else {
                        item.EmailDeliveryStatus = invoiceStatusService.getOverallStatus(item.EmailRecipients, item.EmailInvoices)
                    }

                    // Cleared once nothing is still on its way, rather than only on a terminal
                    // EmailDeliveryStatus: a row can settle with some recipients delivered and others
                    // never queued in the first place, and waiting for a terminal overall status left
                    // it spinning until the page was reloaded.
                    if (!invoiceStatusService.hasPendingDelivery(item.EmailRecipients)) {
                        item.ProcessStatus = '';
                        item.IsProcessing = false;
                        service.emailSenderContentApi.reselectViewType();
                    }

                }, false);
            });
        }

        function selectViewType(viewType) {
            currentViewType = viewType.viewType;
            service.dataGrid.setClientSideFilter(viewType);
            service.customGridSearchComponent.forceTriggerSearch();
        }

        function stopGridFetchingData() {
            service.dataGrid.grid.api.stop();
            service.sideNavModel.reset();
            service.emailSenderContentApi.refresh();
            service.emailSenderContentApi.setBusy(false);
        }

        function checkPaymentClaim(status){
            service.showSingleClientSelection = status;
            service.sideNavModel.selectedClient = [];
            service.sideNavModel.selectedClients = [];
        }
    }
})();

/**
 * Email Sender Main Service
 *
 * Rcnet 6.27.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('emailRecipientService', emailRecipientService);

    /** @ngInject */
    function emailRecipientService($log,
        $q,
        exceptionService,
        invoiceDistributionApi
    ) {

        var service = {
          canAddRecipient: canAddRecipient,
          addRecipient: addRecipient,
          removeRecipient: removeRecipient,
          getDefaultRecipients: getDefaultRecipients,
          addBatchRecipient: addBatchRecipient
        };

        activate();

        return service;
        ////////

        function activate() {}

        function canAddRecipient(data, currentRecipients) {
            var result = _.filter(currentRecipients, function(f) {
                return f.Email.toLowerCase() == data.email;
            });

            if (result.length > 0) {
               return 'Email already exist.';
            }

            return null;
        }

        function addRecipient(id, payload) {
            var deferred = $q.defer();
           
            payload['InvoiceId'] = id;
            invoiceDistributionApi.addRecipient(payload)
                        .then(function(resp) {
                            deferred.resolve(resp);
                        }).catch(function(ex) {
                            deferred.reject(ex);
                        });

            return deferred.promise;
        }

        function addBatchRecipient(payload) {
            return invoiceDistributionApi.addBatchRecipient(payload);
        }

        function removeRecipient(id, data, isUpdateCompany) {
            var deferred = $q.defer();
            var payload = {
                InvoiceId: id,
                EmailId: data.Id,
                Email: data.Email,
                // The server matches the fallback address clause on address AND type. Without the
                // type, removing one row of an Accounts/Paperwork pair took both, along with the
                // attachment preference on the row the user never asked to remove.
                // See: alloc8-engineering-standards/skills/shared-references/invoice-email-recipients.md#removing-a-recipient
                Type: data.EmailType,
                IsUpdateCompany: isUpdateCompany
            };
          
            invoiceDistributionApi.removeRecipient(payload)
            .then(function(resp) {
                deferred.resolve(resp);
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function getDefaultRecipients(companyId) {
            var deferred = $q.defer();
            
            invoiceDistributionApi.getDefaultRecipients(companyId)
            .then(function(resp) {
                deferred.resolve(resp);
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('downloadInvoiceService', downloadInvoiceService);

    /** @ngInject */
    function downloadInvoiceService(
        $mdDialog,
        utils
    ) {

        var service = {
            download: download,
            currentRequestToken: null,
            getCheckedItemsInvDist: angular.noop // parent callback
        };

        activate();

        return service;
        ////////

        function activate() {}

        function download(includePaperwork, isPaperworkOnly, isPaymentClaim, paymentClaimRequestType) {
            service.currentRequestToken = utils.newGuid();

            $mdDialog.show({
                templateUrl: 'app/main/invoice/emailSender/dialogs/download/download-invoice.html',
                controller: 'DownloadInvoiceDialogController',
                controllerAs: 'vm',
                multiple: true,
                locals: {
                    invoices: service.getCheckedItemsInvDist(true),
                    currentRequestToken: service.currentRequestToken,
                    includePaperwork: includePaperwork,
                    isPaperworkOnly: isPaperworkOnly,
                    isPaymentClaim: isPaymentClaim,
                    paymentClaimRequestType: paymentClaimRequestType
                }
            });
        }
    }
})();

/**
 * Invoice cache model
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('sideNavEmailSenderModel', sideNavEmailSenderModel)

    function sideNavEmailSenderModel(invoiceUtilsService, invoiceFilterHasherService, utils) {
        return function () {
            var self = this,
                defaults = {
                    selectedBranches: [],
                    selectedClients: [],
                    startDate: invoiceUtilsService.getStartOfWeek(new Date()),
                    endDate: invoiceUtilsService.getEndOfWeek(new Date()),
                    progressMessage: null,
                    isLocked: false,
                    processingEmailDist: false,  // Fetching data for sending
                    isSending: false  // Actual sending
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.getFilterHash = getFilterHash;
            self.setToProcessingState = setToProcessingState;
            self.disableProcessingState = disableProcessingState;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.selectedBranches.length = 0;
                self.selectedClients.length = 0;
            }
            
            function setToProcessingState(msg, isSending) {
                self.isLocked = true;
                self.processingEmailDist = true;
                self.isSending = isSending;
                self.progressMessage = msg;
            }

            function disableProcessingState() {
                self.isLocked = false;
                self.processingEmailDist = false;
                self.isSending = false;
                self.progressMessage = null;
            }

            function transformToModel() {
                let filterModel = {
                    Branches: [],
                    Companies: [],
                    StartDate: null,
                    EndDate: null
                };

                // Get branches with Mixed States 
                if (angular.isArray(self.selectedBranches)) {
                    // Get selected state first
                    var selectedStates = _.filter(self.selectedBranches, function (o) {
                        return o.State == null;
                    });

                    var selBranches = _.filter(self.selectedBranches, function (o) {
                        return o.State != null;
                    });

                    // Get associated branches inside state
                    selectedStates.forEach(function (p) {
                        p.StateBranches.map(function (o) {
                            filterModel.Branches.push(o);
                        });
                    });

                    // Get branches
                    selBranches.map(function(o) {
                        filterModel.Branches.push(o.Id);
                    });

                    filterModel.Branches = _.uniq(filterModel.Branches);
                }

                // Client
                if (angular.isArray(self.selectedClients)) {
                    self.selectedClients.map(function (itm) {
                        filterModel.Companies.push(itm.Id);
                    });
                }

                filterModel.StartDate = utils.jsDateTime(self.startDate);
                filterModel.EndDate = utils.jsDateTime(self.endDate);

                return filterModel;
            }

            /**
             * Returns filter token hash
             */
            function getFilterHash() {
                let cfg = transformToModel();
                return invoiceFilterHasherService.hash(cfg);
            }

        }

    }
})();
/**
 * Invoice cache model
 */
(function () {
    'use strict';

    angular.module('app.invoice.emailsender')
        .service('emailRecipientModel', emailRecipientModel)

    function emailRecipientModel() {
        return function () {
            var self = this,
                defaults = {
                    id: null,
                    email: null,
                    emailType: 0,
                    isPrimary: false,
                    isUpdateCompany: true,
                    isSelected: false
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            //self.toBackendModel2 = transformToModel2;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.selectedBranches.length = 0;
                self.selectedClients.length = 0;
            }
           
            function transformToModel() {
                return {
                    Id: self.id,
                    Email: self.email,
                    Type: 3,//self.emailType,
                    IsPrimary: false,//self.isPrimary,
                    IsUpdateCompany: self.isUpdateCompany
                };
            }

            // For delete recipient requirement
            // function transformToModel2() {
            //     return {
            //         EmailId: self.id,
            //         Email: self.email,
            //         IsUpdateCompany: self.isUpdateCompany
            //     };
            // }

        }

    }
})();
/**
 * a8SimplePaginationGrid service
 * Handles streamed data coming from docDb or Redis Cache
 * Instantiable service
 * by Rcnet 11.14.2016
 */
(function () {
    'use strict';

    angular
        .module('app.invoice')
        .factory('invoiceGridService', invoiceGridService);

    /** @ngInject */
    function invoiceGridService(_,
        $timeout,
        invoiceGridModelBuilderService,
        utils,
        invoiceGridSearchEngineService,
        $rootScope,
        a8SlickSortService
    ) {

        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        //////
        function activate() { }

        /**
         * Create new instance
         */
        function getInstance() {
            var paginationContext = function () {
                var self = this;

                // Props
                self.supersetCollection = [];
                self.filteredSupersetCollection = [];
                self.data = {
                    // HasNextPage: false,
                    // HasPreviousPage: false,
                    TotalItemCount: 0,
                    // FirstItemOnPage: 0,
                    // LastItemOnPage: 0,

                    DownloadCtr: 0,
                    TotalChunks: 0,

                    isFiltered: false,
                    RawTotalItemCount: 0,  // Total item count without filtering used only when displaying filtering info 

                    // Client callback
                    // onPagerClickCallback: null,

                    onDataFilter: angular.noop,
                    onFetchData: angular.noop,
                    onCompleted: angular.noop,
                    onPreRender: angular.noop,
                    onError: angular.noop,
                    onSearch: angular.noop,
                    onApplyCustomClientSideFiltering: angular.noop
                };

                self.currentPageSize = 10;
                self.currentPageNumber = 1;   // Page number is a base 0 index
                // self.moveNext = moveNext;
                // self.movePrev = movePrev;
                self.refreshPager = refreshPager2;
                self.sortParams = null;

                self.onChunkReceived = onChunkReceived;
                self.onDownloadCompleted = onDownloadCompleted;

                self.search = search;
                self.searchText = null;

                self.sort = sort;
                self.sortBy = null;
                self.sortDir = null;

                //self.changePageSize = changePageSize;
                self.busy = false;
                self.isDownloading = false;
                self.setToDownloadingState = setToDownloadingState;
                self.inProgress = angular.noop;

                self.clearData = clearData;
                self.initiator = null;  // cacheHub or dbHub
                self.distinctBy = null; // Temporary only
                self.invokeUpdateState = invokeUpdateState;  // Perform client side update of data set 
                self.allowCustomClientSideFiltering = false;
                self.customGridSearchService = null;  // Custom grid search service this will override the default

                activate();

                function activate() 
                {
                    setupPubSubs();
                }

                /**
                 * On receive chunk data
                */
                function onChunkReceived(data, initiator) {
                    if (data) {
                        // Provide chunk properties
                        // If totalChunks and totalItemCount = -1 then downloding time is undetermine
                        // view will adjust to this by displaying estimate count
                        self.data.TotalChunks = data.totalChunks;
                        self.data.TotalItemCount = data.totalItems;
                        self.data.DownloadCtr = self.data.DownloadCtr++;
                        self.initiator = initiator;

                        angular.forEach(data.chunkData, function (itm) {
                            self.supersetCollection.push(itm);
                        });

                        refreshPager2(self.currentPageNumber);

                        // Db propagated or cache
                        if (initiator === 'dbHub' || initiator === 'dbHubFilter') {
                            // doc db we dont know the count size ahead so no computation of progress
                            return -1;
                        } else {
                            return calculateDataReceivedProgress(data.totalItems);
                        }
                    }
                }

                function clearData() {
                    self.supersetCollection.length = 0;
                    self.filteredSupersetCollection.length = 0;
                    self.currentPageNumber = 1;
                    self.data.RawTotalItemCount = 0;
                    self.data.TotalItemCount = 0;
                }

                /**
               * Todo: Replace this code !!!
               * @param {distinctBy} Temporary code
               */
                function applyDistinctBy(distinctBy, superset) {
                    let qry = 'SELECT DISTINCT ' + distinctBy + ', * FROM ?';
                    return alasql(qry, [superset]);
                }

                /**
                 * Compute download percentage
                 */
                function calculateDataReceivedProgress(totalItems) {
                    let currentProgress = Math.ceil((self.supersetCollection.length / parseInt(totalItems)) * 100);
                    return currentProgress;
                }

                /**
                 * Filter pipeline (sorting and searching)
                 * Mutates collection
                 */
                function applyCollectionPipelineCriteria(page) {
                    // Apply sorting and searching here
                    let filteredColl = [];
                    let totalFilteredCount = 0;

                    if (self.distinctBy) {
                        self.supersetCollection = applyDistinctBy(self.distinctBy, getActiveSuperset());
                    }

                    let activeSuperset = getActiveSuperset();

                    // NOTE: Enable this one!!!
                    // Avoid running apply search when the same search text is used when navigating this will speed up things :-)
                    if (self.filteredSupersetCollection.length == 0) {
                        filteredColl = applySearching(activeSuperset);

                        // Todo: Refactor this, it should search internally
                        if (self.allowCustomClientSideFiltering) {
                            var clientSideFilteringResult = self.data.onApplyCustomClientSideFiltering(filteredColl); // New: 9.25.2017
                            filteredColl = clientSideFilteringResult ? clientSideFilteringResult : [];
                        }
                    } else {
                        filteredColl = activeSuperset;
                    }

                    // Sort
                    filteredColl = applySorting(filteredColl);

                    // Perform optimization by caching the search result
                    optimizeSearchingByCaching(filteredColl);

                    totalFilteredCount = filteredColl.length;


                    // Check out of bounds here
                    if (filteredColl != null && filteredColl.length > 0) {
                        // Disable paging here
                        return { collection: filteredColl, totalItems: totalFilteredCount };
                    }

                    return { collection: filteredColl, totalItems: totalFilteredCount };
                }

                function optimizeSearchingByCaching(filteredColl) {
                    // If there's a search text then buffer it for faster navigation
                    if (self.searchText != null && !self.isDownloading) {
                        if (self.filteredSupersetCollection.length == 0) {
                            for (var i = 0; i < filteredColl.length; i++) {
                                self.filteredSupersetCollection.push(filteredColl[i]);
                            }
                        }
                    }
                }

                function setupPubSubs() {
                    $rootScope.$on('invoice:deleteSingleCompleted', function(e, id) {
                        _.remove(self.filteredSupersetCollection, function(o) {
                            return o.Id === id;
                        });
                        _.remove(self.supersetCollection, function(o) {
                            return o.Id === id;
                        });
                    });
                }

                function getActiveSuperset() {
                    if (self.searchText != null) {
                        if ((self.searchText.length > 0) && self.filteredSupersetCollection.length > 0 && !self.isDownloading) {
                            return self.filteredSupersetCollection;
                        } else {
                            return self.supersetCollection;
                        }
                    }
                    return self.supersetCollection;
                }

                function sort(sortBy, sortDir) {
                    self.sortBy = sortBy;
                    self.sortDir = sortDir;
                    refreshPager2(self.currentPageNumber);
                }

                function applySorting(collection) {
                    return a8SlickSortService.sort(collection, self.sortBy, self.sortDir);
                }

                /**
                 * Relative to base 0 index for accessing the array superset collection
                 * Call this if you want to access the collection superset
                 */
                function getRelativePageNo(page) {
                    let pageNum = page - 1;
                    return pageNum < 0 ? 1 : pageNum;
                }

                /**
                 * Complete data received
                 */
                function onDownloadCompleted(data, sender) {
                    self.inProgress(false);
                    self.isDownloading = false;

                    // For server side filtering then update raw total count
                    self.data.RawTotalItemCount = self.supersetCollection.length;
                }

                function applySearching(collection) {
                    let result = null;
                    if (!self.customGridSearchService) {
                        result = invoiceGridSearchEngineService.search(collection, self.searchText);
                    } else {
                        result = self.customGridSearchService.search(collection, self.searchText);
                    }

                    let activeSuperset = getActiveSuperset();

                    return (result == null ? activeSuperset : result);
                }

                function search(text) {
                    self.searchText = text;
                    self.currentPageNumber = 1;
                    self.filteredSupersetCollection.length = 0;
                    self.data.isFiltered = !utils.isNullOrEmpty(text);
                    self.data.RawTotalItemCount = self.supersetCollection.length;
                    refreshPager2(1);
                    self.data.onSearch();
                }


                /**
                 * Refresh page
                 * @args page - 0 based index
                 */
                function refreshPager2(page) {
                    try {
                        let pageNo = getRelativePageNo(page);
                        let result = applyCollectionPipelineCriteria(pageNo);

                        // Before rendering the results fire this event, any pre init operation can be perform here in this event 
                        let isCancelRendering = (self.data.onPreRender || angular.noop)({ data: result.collection });
                        if (isCancelRendering == false) return;

                        // Build pager model
                        let pagerModel = invoiceGridModelBuilderService.createModel(result.totalItems,
                            page,
                            self.currentPageSize
                        );

                        buildPager(pagerModel);

                        // Notify client to build grid data
                        $timeout(function () {
                            (self.data.onCompleted || angular.noop)({ data: result.collection });
                        }, 0);
                    } catch (ex) {
                        (self.data.onError || angular.noop)({ msg: 'Invoice Grid: Unable to load data from server.' });
                    }
                }

                /**
                 * Required view model for basic paging
                 */
                function buildPager(model) {
                    // self.data.HasNextPage = model.HasNextPage;
                    // self.data.HasPreviousPage = model.HasPreviousPage;
                    self.data.TotalItemCount = model.TotalItemCount;
                    // self.data.FirstItemOnPage = model.FirstItemOnPage;
                    // self.data.LastItemOnPage = model.LastItemOnPage;
                    //service.data.PageNumber = model.PageNumber;
                }

                function setToDownloadingState() {
                    self.isDownloading = true;
                }

                /**
                 * Updates the SupersetCollection and the FilteredsetColection
                 * Note: Use with caution, this will alter the internal state of grid data.
                 * As much as possible avoid using this.
                 * @param {query expression} predicate 
                 * @param {action function to perform mutation} action 
                 */
                function invokeUpdateState(predicate, action, forceRefresh) {
                    // Todo: Fix double firing of action func due to double resolve (supersetColl and filteredSupersetColl)
                    var result = [];
                    if (self.supersetCollection) {
                        result = _.filter(self.supersetCollection, predicate);
                        if (result.length > 0) {
                            (action || angular.noop)(result);  // Reference type so auto update entity inside collection
                        }
                    }
                    if (self.filteredSupersetCollection) {
                        result = _.filter(self.filteredSupersetCollection, predicate);
                        if (result.length > 0) {
                            (action || angular.noop)(result);  // Reference type so auto update entity inside collection
                        }
                    }

                    if (forceRefresh)
                        refreshPager2(1);
                }

            };

            return new paginationContext();
        }

    }
})();
/**
 * Model coming from DB
 * Obsolete
 */
(function(){
   'use strict';

  angular.module('app.invoice')
          .service('invoiceGridModel', invoiceGridModel)

    function invoiceGridModel() {
        return function () {
            var self = this,
            defaults = {
                FirstItemOnPage: null,
                HasNextPage: false,
                HasPreviousPage: false,
                IsFirstPage: false,
                IsLastPage: false,
                LastItemOnPage: null,
                PageCount: 0,
                PageNumber: 0,
                PageSize: 0,
                TotalItemCount: 0
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();
/**
 * Pagination Component Client Side
 * Client side paging
 * by Rcnet
 */
(function() {
    'use strict';

    angular.module('app.invoice')
        .directive('invoiceGridComponent', invoiceGridComponent);

    /** @ngInject */
    function invoiceGridComponent() {
        var directive = {
            restrict: 'E',
            scope: {
                configuration: '='
            },
            controller: invoiceGridComponentController,
            controllerAs: 'vm',
            bindToController: true
        };

        ///////
        function invoiceGridComponentController() {
            var vm = this;

            vm.handlers = {
                searchDelegates: [],
                sortResetDelegates: [],
                sortDelegates: [],
                statusDelegates: [],
                infoDelegates: []
            }
        }

        invoiceGridComponentController.prototype.goSearch = function(text) {
            this.handlers.searchDelegates.forEach(function(handler) {
                handler(text);
            });
        }

        invoiceGridComponentController.prototype.onGoSearch = function(handler) {
            this.handlers.searchDelegates.push(handler);
        }

        invoiceGridComponentController.prototype.sortReset = function() {
            this.handlers.sortResetDelegates.forEach(function(handler) {
                handler();
            });
        }

        invoiceGridComponentController.prototype.onSortReset = function(handler) {
            this.handlers.sortResetDelegates.push(handler);
        }

        invoiceGridComponentController.prototype.sort = function(sortParams) {
            this.handlers.sortDelegates.forEach(function(handler) {
                handler(sortParams);
            });
        }

        invoiceGridComponentController.prototype.onSort = function(handler) {
            this.handlers.sortDelegates.push(handler);
        }

        invoiceGridComponentController.prototype.setStatus = function(value) {
            this.handlers.statusDelegates.forEach(function(handler) {
                handler(value);
            });
        }

        invoiceGridComponentController.prototype.onSetStatus = function(handler) {
            this.handlers.statusDelegates.push(handler);
        }

        invoiceGridComponentController.prototype.setGridInfo = function(value) {
            this.handlers.infoDelegates.forEach(function(handler) {
                handler(value);
            });
        }

        invoiceGridComponentController.prototype.onSetGridInfo = function(handler) {
            this.handlers.infoDelegates.push(handler);
        }

        return directive;
    }

})();
/**
 * Pagination Component for Alloc8 grid
 * Grid for ala streaming datasource
 * Client side paging
 * author: Rcnet
 * 12.14.2016
 * v1.0
 */
(function () {
    'use strict';

    angular.module('app.invoice')
        .directive('invoiceGridPaginationComponent', invoiceGridPaginationComponent);

    /** @ngInject */
    function invoiceGridPaginationComponent($http, $timeout, $log, invoiceGridService) {
        var directive = {
            restrict: 'E',
            scope: {
                behavior: '=',
                onInit: '&',
                onDataFilter: '&',
                onFetchData: '&',
                onCompleted: '&',
                onPreRender: '&',
                onDataLoading: '&',
                onDataLoadingCompleted: '&',
                onReady: '&',
                onError: '&',
                onApplyCustomClientSideFiltering: '&',
                onPreLoadGridInfo: '&',
                allowCustomClientSideFiltering: '=',
                showNav: '=',
                showTotalRecords: '&',
                autoFetch: '@',
                distinctBy: '@',
                customGridSearchService: '=',
                defaultSort: '='
            },
            require: '^invoiceGridComponent',
            templateUrl: 'app/main/invoice/directives/invoiceGrid/invoice-grid-pagination.html',
            controller: InvoiceGridHandlerController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        ///////
        function InvoiceGridHandlerController($scope) { }

        function link($scope, el, attrs, controller) {
            var vm = $scope.vm;
            vm.autoFetch = vm.autoFetch || 'true';
            vm.basicService = invoiceGridService.getInstance();
            vm.showTotalRecords = vm.showTotalRecords == null ? true : vm.showTotalRecords;
            vm.hubAdapter = null;

            activate();

            controller.onGoSearch(function (val) {
                vm.basicService.search(val);
            });

            controller.onSort(function (s) {
                vm.basicService.sort(s.sortParams.sortBy, s.sortParams.sortDir);
            });


            function activate() {

                initializePublicApis();

                // Fire on-Init event
                (vm.onInit || angular.noop)();

                controller.setStatus('Downloading data...');
                postUpdatedGridInfo();
                (vm.onDataLoading || angular.noop)();

                initBasicPagination();

                // Fire when the control is ready or completed initialization
                (vm.onReady || angular.noop)();
            }

            /**
             * Exposed APIs to grid consumer
             * Note: behavior methods are accessible and invokeable by the consumer
             */
            function initializePublicApis() {
                if (vm.behavior) {
                    // To track progress
                    vm.behavior.busy = false;
                    vm.behavior.search = search;
                    vm.behavior.sort = sort;

                    // Refresh pagination
                    vm.behavior.refresh = refresh;
                    vm.behavior.refreshClientSide = refreshClientSide;
                    vm.behavior.clearAll = clearAll;
                    vm.behavior.stop = stop;

                    // Set data hub source
                    vm.behavior.setHubSourceAdapter = setHubSourceAdapter;

                    // Returns grid information
                    vm.behavior.getGridInfo = getGridInfo;

                    // Force update of data set
                    vm.behavior.invokeUpdateState = vm.basicService.invokeUpdateState;
                }
            }

            function postUpdatedGridInfo(inProgress) {
                let inprogress = inProgress != null ? inProgress : vm.basicService.isDownloading;

                let customInfoObject = _getPreloadGridInfo();

                controller.setGridInfo({
                    totalItems: (customInfoObject && customInfoObject.totalItems) ? customInfoObject.totalItems : vm.basicService.data.TotalItemCount,
                    rawTotalItemCount: (customInfoObject && customInfoObject.rawTotalItemCount) ? customInfoObject.rawTotalItemCount : vm.basicService.data.RawTotalItemCount,
                    inProgress: inprogress,
                    isFiltered: vm.basicService.data.isFiltered
                });
            }

            function _getPreloadGridInfo() {
                // Execute hookup handler for pre-loading grid info
                let customInfoObject = (vm.onPreLoadGridInfo || angular.noop)({
                    data: {
                        totalItems: vm.basicService.data.TotalItemCount
                        , rawTotalItemCount: vm.basicService.data.RawTotalItemCount
                        , items: !vm.basicService.data.isFiltered ? angular.copy(vm.basicService.supersetCollection) : angular.copy(vm.basicService.filteredSupersetCollection)
                        , isFiltered: vm.basicService.data.isFiltered
                    }
                });

                return customInfoObject;
            }

            function search(searchText) {
                vm.basicService.search(searchText);
            }

            function sort(sortBy, sortDir) {
                vm.basicService.sort(sortBy, sortDir);
            }

            /**
             * Performs server side refresh (with roundtrip to server)
             */
            function refresh() {
                controller.setStatus('Downloading data...');
                postUpdatedGridInfo();
                (vm.onDataLoading || angular.noop)();
                vm.behavior.busy = true;

                let filters = (vm.onDataFilter || angular.noop)();
                let filterObj = filters != null ? { filters: filters } : null;

                // Detect if refresh is executed many times while current downloading is in progress.
                // This may overlap existing DL process, to mitigate this just stop the current download then proceed to the new one.
                if (vm.basicService.isDownloading) {
                    // TODO: Need to handle stopping of signalr promise request in the adapter !!!!
                    $log.debug('Stop Downloading... Multiple execution!!!');
                    vm.hubAdapter.stopDownload(vm.basicService.initiator);
                }

                vm.basicService.clearData();
                startDownload(filterObj);
            }

            /**
             * This will affect the client side searching so no server side refresh or server side roundtrip
             */
            function refreshClientSide() {
                vm.basicService.search(null);
            }

            /**
             * Clear clear :)
             */
            function clearAll() {
                vm.basicService.clearData();
                postUpdatedGridInfo();
                (vm.onCompleted || angular.noop)({ data: [] });
            }

            /**
             * Stop fetching data
             */
            function stop() {
                vm.hubAdapter.stopDownload(vm.basicService.initiator);
                vm.behavior.busy = false;
                controller.setStatus('');
            }

            /**
             * Hook hub data source adapter instance and events
             */
            function setHubSourceAdapter(adapter) {
                vm.hubAdapter = adapter;
                vm.hubAdapter.onChunkReceived = onChunkReceived;
                vm.hubAdapter.onDownloadCompleted = onDownloadCompleted;
                vm.hubAdapter.onErrorDownloading = onErrorDownloading;
            }

            function onChunkReceived(data, sender) {
                // Return extra information/data to caller. Extra data is coming from the backend (Tuple->Item3)
                //(vm.onDataLoading || angular.noop)(data.extraData); // Not supported
                (vm.onDataLoading || angular.noop)();

                let progressPercentage = vm.basicService.onChunkReceived(data, sender);
                if (progressPercentage > 0) {
                    controller.setStatus(progressPercentage.toString() + '%');
                    postUpdatedGridInfo();
                    (vm.onDataLoading || angular.noop)();
                }
            }

            function onDownloadCompleted(data, sender) {
                vm.behavior.busy = false;
                controller.setStatus('');
                postUpdatedGridInfo(false);

                vm.basicService.onDownloadCompleted(data, sender);
                (vm.onDataLoadingCompleted || angular.noop)();
            }

            function onErrorDownloading(data, sender) {
                (vm.onError || angular.noop)({ ex: data });
                //vm.basicService.onErrorDownloading
                //alert(data);
            }

            function startDownload(filters) {
                // Fetch data
                vm.behavior.busy = true;
                vm.hubAdapter
                    .onGetData(filters)
                    .catch(function (ex) {
                        vm.behavior.busy = false;
                        controller.setStatus('Error downloading');
                        (vm.onError || angular.noop)({ ex: ex });
                    });

                vm.basicService.setToDownloadingState();
            }

            function getGridInfo() {
                let customInfoObject = _getPreloadGridInfo();
                return {
                    totalItems: (customInfoObject && customInfoObject.totalItems) ? customInfoObject.totalItems : vm.basicService.data.TotalItemCount,
                    rawTotalItemCount: (customInfoObject && customInfoObject.rawTotalItemCount) ? customInfoObject.rawTotalItemCount : vm.basicService.data.RawTotalItemCount,
                    inProgress: vm.basicService.isDownloading,
                    isFiltered: vm.basicService.data.isFiltered
                };
            }

            /**
             * Communication events for basicService grid
             */
            function initBasicPagination() {

                vm.basicService.data.isCustomDataFetch = vm.manualDataFetch;
                vm.basicService.sourceType = vm.sourceType;
                vm.basicService.distinctBy = vm.distinctBy;   // TODO: Remove this feature(just a temporary approach)!!!
                vm.basicService.allowCustomClientSideFiltering = !!vm.allowCustomClientSideFiltering;
                vm.basicService.customGridSearchService = vm.customGridSearchService;
                vm.basicService.sortBy = (vm.defaultSort && vm.defaultSort.sortBy) ? vm.defaultSort.sortBy : null;
                vm.basicService.sortDir = (vm.defaultSort && vm.defaultSort.sortDir) ? vm.defaultSort.sortDir : null;

                vm.basicService.data.customDataFetch = function (params) {
                    return (vm.onCustomDataFetch || angular.noop)({ params: params });
                }

                vm.basicService.data.onDataFilter = function () {
                    // not supported in basic
                }

                vm.basicService.data.onFetchData = function () {
                    // not supported in basic
                }

                vm.basicService.data.onSearch = function () {
                    // Fire event to consumer
                    postUpdatedGridInfo();
                    (vm.onDataLoadingCompleted || angular.noop)();
                }

                vm.basicService.data.onCompleted = function (data) {
                    (vm.onCompleted || angular.noop)({ data: data.data });
                }

                vm.basicService.data.onPreRender = function (data) {
                    (vm.onPreRender || angular.noop)({ data: data });
                }

                vm.basicService.data.onError = function (ex) {
                    (vm.onError || angular.noop)({ ex: ex });
                }

                vm.basicService.inProgress = function (show) {
                    vm.behavior.busy = show;
                }

                // Todo: Revisit this method it needs thorough thinking on the architecture adjustments
                vm.basicService.data.onApplyCustomClientSideFiltering = function (collection) {
                    return (vm.onApplyCustomClientSideFiltering || angular.noop)({ data: collection });
                }

                $timeout(function () {
                    if (vm.autoFetch === 'true') startDownload();
                }, 0);
            }

        }
    }
})();

/**
 * invoiceGridModelBuilderService
 * by Rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.invoice')
        .factory('invoiceGridModelBuilderService', invoiceGridModelBuilderService);

    /** @ngInject */
    function invoiceGridModelBuilderService(_, invoiceGridModel) {
        var service = {
            createModel: createModel
        };

        return service;

        //////////
        function createModel(totalItemCount, pageNumber, pageSize) {
            let pageNum = pageNumber === 0 ? 1 : pageNumber;
            let pagerModel = new invoiceGridModel();
            
            pagerModel.TotalItemCount = totalItemCount;
            pagerModel.PageSize = pageSize;
            pagerModel.PageNumber = pageNum;
            pagerModel.PageCount = totalItemCount > 0
                ? parseInt(Math.ceil(parseInt(totalItemCount) / parseInt(pagerModel.PageSize)))
                : 1;
           
            pagerModel.PageCount = totalItemCount > 0
                ? parseInt(Math.ceil(parseInt(totalItemCount) / parseInt(pagerModel.PageSize)))
                : 0;
            pagerModel.HasNextPage = pageNum < pagerModel.PageCount;
            pagerModel.HasPreviousPage = parseInt(pageNum) > 1;
            pagerModel.IsFirstPage = pagerModel.PageNumber === 1;
            pagerModel.IsLastPage = pagerModel.PageNumber >= pagerModel.PageCount;
            pagerModel.FirstItemOnPage = (pagerModel.PageNumber - 1) * pagerModel.PageSize + 1;
            var numberOfLastItemOnPage = pagerModel.FirstItemOnPage + pagerModel.PageSize - 1;
            pagerModel.LastItemOnPage = numberOfLastItemOnPage > pagerModel.TotalItemCount
                ? pagerModel.TotalItemCount
                : numberOfLastItemOnPage;

            return pagerModel;
        }
    }
})();
(function() {
    'use strict';
    angular.module('app.widgets')
        .directive('invoiceCustomGridSearchComponent', invoiceCustomGridSearchComponent);

    /** @ngInject */
    function invoiceCustomGridSearchComponent() {
        var directive = {
            restrict: 'E',
            scope: {
                srcData: '=',
                onSearch: '&',
                api: '='
            },
            templateUrl: 'app/main/invoice/directives/customGridSearch/invoice-custom-grid-search.html',
            controller: InvoiceCustomGridSearchController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function InvoiceCustomGridSearchController() {}

        function link($scope) {
            var vm = $scope.vm;

            if (vm.api) {
                vm.api.forceTriggerSearch = forceTriggerSearch;
            }

            $scope.$watch('vm.srcData', function(newVal) {
                if (newVal != null) {
                    (vm.onSearch || angular.noop)({
                        value: encodeURIComponent(newVal)
                    });
                }
            });

            function forceTriggerSearch() {
                (vm.onSearch || angular.noop)({
                    value: encodeURIComponent(vm.srcData)
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.integrations', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.integrations', {
            url: '/integrations',
            views: {
                'content@app': {
                    templateUrl: 'app/main/integrations/integrations.html',
                    controller: 'integrationsViewController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasIntegrationsAccess;
                }] 
            },
            title: 'Integrations',
            titleBar: 'Alloc8 - Integrations'
        });

        $translatePartialLoaderProvider.addPart('app/main/integrations');
    }

})();

(function () {
    'use strict';

    angular.module('app.integrations')
        .directive('integrationsTabs', integrationsTabsComponent);

    /** @ngInject */
    function integrationsTabsComponent() {
        let directive = {
            restrict: 'E',
            scope: {
                onTabSelected: '&'
            },
            templateUrl: 'app/main/integrations/directives/tabs/tabs.html',
            controller: integrationsTabsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function integrationsTabsController(tabNames) {
            var vm = this;
            vm.tabNames = tabNames;
            vm.selectedTabName = vm.tabNames.settings;

            vm.selectTab = function(selectedTabName) {
                vm.selectedTabName = selectedTabName;
                vm.onTabSelected({ selectedTabName: selectedTabName });
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.integrations')
        .directive('integrationsSettings', integrationsSettingsComponent);

    /** @ngInject */
    function integrationsSettingsComponent() {
        let directive = {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/main/integrations/directives/settings/settings.html',
            controller: integrationsSettingsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function integrationsSettingsController(
            claimsUtilService,
            integrationsService,
            utils,
            $mdDialog) {

            var vm = this;
            vm.isMyobEnabled = claimsUtilService.isMyobEnabled();
            vm.isXeroEnabled = claimsUtilService.isXeroEnabled();

            init();

            function init() {
                integrationsService.getProviders()
                    .then(resp => {
                        vm.isConnectedToMyob = resp.isConnectedToMyob;
                        vm.isConnectedToXero = resp.isConnectedToXero;
                    });
            }

            vm.connect = function(providerTypeName) {
                let providerType = integrationsService.providerTypes[providerTypeName];

                integrationsService.redirectToProvider(providerType);
            }

            vm.disconnect = function(providerTypeName) {
                let providerType = integrationsService.providerTypes[providerTypeName];

                let ifYouDisconnectMsg = utils.translate('INTEGRATION.IF_YOU_DISCONNECT');

                let confirm = $mdDialog.confirm()
                    .title(utils.translate('INTEGRATION.DISCONNECT_FROM') + providerType + '?')
                    .textContent(ifYouDisconnectMsg.replace('{providerType}', providerType))
                    .ok(utils.translate('INTEGRATION.DISCONNECT'))
                    .cancel(utils.translate('INTEGRATION.CANCEL'));

                $mdDialog.show(confirm)
                    .then(() => {
                        return integrationsService.disconnect(providerType)
                    })
                    .then(() => {
                        switch (providerType) {
                            case integrationsService.providerTypes.myob:
                                vm.isConnectedToMyob = false;
                                break;
                            case integrationsService.providerTypes.xero:
                                vm.isConnectedToXero = false;
                                break;
                        }
                    });
            }
        }
    }
})();
(function () {
  'use strict';

  angular.module('app.holidays', [
    'app.api',
    'app.corelib',
    'app.holidays.view'
  ])
    .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('app/main/holidays');
  };

})();

(function () {
  'use strict';

  angular
    .module('app.holidays')
    .controller('HolidayDialogController', HolidayDialogController);

  function HolidayDialogController($mdDialog,
                                   utils,
                                   locals,
                                   holidayService) {
    //Data
    var vm = this;
    vm.utilService = utils;
    vm.Branches = angular.copy(locals.branches);
    vm.Divisions = [];
    vm.model = locals.holidayModel;

    //Methods
    vm.onClose = onClose;
    vm.onSave = onSave;
    vm.activate = activate;
    vm.formatDivisions = formatDivisions;


    function onClose(){
      $mdDialog.hide();
    }

    function formatDivisions(branches){
      let tempBranches = [];
      angular.forEach(branches, function(branch){
        let branchHolder =  _.find(locals.branches, {Id : branch.Id});
        tempBranches.push(branchHolder);
      });

      vm.Divisions = holidayService.formatDivisions(tempBranches);
    }

    function onSave(){
      let model = transformModel(vm.model);
      $mdDialog.hide(model);
    }

    function transformModel(model){
      if(model.IsNationalHoliday){
        model.Branches = [];
      }else{
        angular.forEach(model.Branches, function(branch){
          let divisions = alasql('select * from ? where BranchId = ?', [model.Divisions, branch.Id])
          angular.forEach(divisions, function(division){
            delete division.BranchId;
            delete division.BranchName;
          });
          delete branch.Division;
          branch['Divisions'] = divisions;
        });
      }
      delete model.Branch;
      delete model.Divisions;
      return model;
    }

    function cleanDivisions(){
      angular.forEach(vm.Branches, function(branch){
        branch.Division = [];
      });
    }

    function activate(){
      if(locals.editMode){
        vm.model = angular.copy(holidayService.holidays[locals.data]);
        vm.model.HolidayDate = new Date(vm.model.HolidayDate);
        formatDivisions(vm.model.Branches);
        vm.model['Divisions'] = [];
        angular.forEach(vm.model.Branches, function(branch){
          angular.forEach(branch.Divisions, function(division){
            let div = alasql('select * from ? where Id = ?', [vm.Divisions, division.Id]);
            if(div.length > 0){
              vm.model['Divisions'].push(div[0]);
            }
          });
        });
      }
      else{
         vm.model = locals.holidayModel;
         cleanDivisions();
      }
    }

    vm.activate();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.equipment.view', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.equipment_view', {
      url: '/equipment/view-equipment'
      , params: {
        new: false,
        edit: false,
        equipmentid: null
      }
      , views: {
        'content@app': {
          templateUrl: 'app/main/equipment/view/equipments-view.html'
          , controller: 'EquipmentsViewController as vm'
        }
      }
      , data: {
        requireLogin: true
      }
      , title: 'View Equipment'
      , titleBar: 'Alloc8 - View Equipment'
    });

    $translatePartialLoaderProvider.addPart('app/main/equipment/view');
  }

})();

"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewEquipmentComponent = function (_React$Component) {
  _inherits(ViewEquipmentComponent, _React$Component);

  function ViewEquipmentComponent(props) {
    _classCallCheck(this, ViewEquipmentComponent);

    var _this = _possibleConstructorReturn(this, (ViewEquipmentComponent.__proto__ || Object.getPrototypeOf(ViewEquipmentComponent)).call(this, props));

    _this.edit = _this.edit.bind(_this);
    _this.translate = _this.translate.bind(_this);
    return _this;
  }

  _createClass(ViewEquipmentComponent, [{
    key: "edit",
    value: function edit(equipment) {
      this.props.edit(equipment);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      $('#view-equipment').dataTable({
        "bAutoWidth": false,
        "responsive": false,
        "bDestroy": true,
        "sDom": 'rt<"bottom"lip><"clear">'
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      $('#view-equipment').dataTable({
        "bAutoWidth": false,
        "responsive": false,
        "bDestroy": true,
        "sDom": 'rt<"bottom"lip><"clear">'
      });
    }
  }, {
    key: "translate",
    value: function translate() {
      return this.props.translate();
    }
  }, {
    key: "render",
    value: function render() {
      var self = this;

      function formatDivision(divisions) {
        var result = divisions.map(function (division) {
          return division.Name;
        });
        return result.join(", ");
      }

      function createItem(item) {
        return React.createElement(
          "tr",
          null,
          React.createElement(
            "td",
            null,
            item.UniqueId
          ),
          React.createElement(
            "td",
            null,
            item.ItemName
          ),
          React.createElement(
            "td",
            null,
            item.Description
          ),
          React.createElement(
            "td",
            null,
            item.User != null ? item.User.FirstName : null,
            " ",
            item.User != null ? item.User.LastName : null
          ),
          React.createElement(
            "td",
            null,
            item.Branch.Name
          ),
          React.createElement(
            "td",
            null,
            formatDivision(item.Branch.Division)
          ),
          React.createElement(
            "td",
            null,
            item.ItemStatus === 1 ? 'Active' : 'Not in service'
          ),
          React.createElement(
            "td",
            null,
            React.createElement(
              "md-button",
              { className: "md-icon-button",
                onClick: self.edit.bind(this, item) },
              React.createElement("i", { className: "icon icon-pencil teal-500-fg s15" })
            )
          )
        );
      }

      return React.createElement(
        "table",
        { className: "dataTable row-border hover", id: "view-equipment" },
        React.createElement(
          "thead",
          null,
          React.createElement(
            "tr",
            null,
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_ID')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_ITEM_NAME')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_DESCRIPTION')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_USER')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_BRANCH')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_DIVISIONS')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_STATUS')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_ACTIONS')
                )
              )
            )
          )
        ),
        React.createElement(
          "tbody",
          null,
          this.props.equipment.map(createItem)
        )
      );
    }
  }]);

  return ViewEquipmentComponent;
}(React.Component);

ViewEquipmentComponent.propTypes = {
  equipment: React.PropTypes.array.isRequired,
  edit: React.PropTypes.func.isRequired,
  translate: React.PropTypes.func.isRequired
};
ViewEquipmentComponent.defaultProps = {
  equipment: [],
  edit: function edit() {},
  translate: function translate() {}
};


angular.module('app.equipment.view').value('ViewEquipmentComponent', ViewEquipmentComponent);
(function () {
  'use strict';

  angular.module('app.equipment.view')
    .directive('viewEquipmentComponent', viewEquipmentComponent);

  /** @ngInject */
  function viewEquipmentComponent(reactDirective, ViewEquipmentComponent) {
    return reactDirective(ViewEquipmentComponent);
  }

})();


(function() {
    'use strict';

    angular
        .module('app.custom-validations-create')
        .controller('customValidationsTester', a8EmailsDialogController);

    function a8EmailsDialogController($mdDialog, lookup, models, rules) {
        var vm = this;

        vm.ContactTypes = [];

        vm.fields = angular.copy(models);
        vm.lookup = angular.copy(lookup);
        vm.rules = angular.copy(rules);
        vm.onCancel = onCancel;

        function onCancel(){
            $mdDialog.hide();
        }

        function activate(){
            vm.fields.forEach(function(field){
                if(field.FieldRuleName == "ContactTypes"){
                    field.LookupModel = "lookup.ContactTypes";
                    field.Model = "ContactTypes";
                }
            })
        }

        activate()
    }
})();

(function() {
    'use strict';

    angular.module('app.customForms', ['app.api'])
        .config(config)
        .run(runConfig);

    function runConfig(msNavigationService, claimsUtilService, adminClaimsService) {
        msNavigationService.saveItem('apps.customForms', {
            title: 'Forms',
            state: 'app.customForms',
            icon: 'icon-library-books',
            weight: 8,
            hidden: function() {
                return !adminClaimsService.hasAccessFormPermission;
            }
        });
    }

    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.customForms', {
                url: '/forms',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/customForms/view/formTemplates-view.html',
                        controller: 'FormTemplatesViewController as vm'
                    }
                },
                title: 'Form Templates',
                titleBar: 'Alloc8 - Form Templates',
                data: {
                    requireLogin: true,
                    validateAccess: ['adminClaimsService', function (adminClaimsService) {
                        return adminClaimsService.hasAccessFormPermission;
                    }]
                }
            })
            .state('app.customForms.edit', {
                url: '/edit/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/customForms/edit/formTemplates-edit.html',
                        controller: 'FormTemplatesEditController as vm'
                    }
                },
                title: 'Form Templates',
                titleBar: 'Alloc8 - Form Templates'
            });

        $translatePartialLoaderProvider.addPart('app/main/customForms');
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customForms')
        .controller('MoveToPositionController', MoveToPositionController);

    /** @ngInject */
    function MoveToPositionController($mdDialog, locals) {

        var vm = this;
        vm.noOfRecords = locals.noOfRecords;
        vm.CurrentPosition = locals.CurrentPosition;
        vm.closeDialog = closeDialog;
        vm.moveToPosition = moveToPosition;

        function closeDialog() {
            $mdDialog.hide(false);
        }

        function moveToPosition() {
            if (vm.positionToMove == vm.CurrentPosition) {

                let notification = $mdDialog.confirm()
                    .title('Move To Position')
                    .textContent('Please enter a different position.')
                    .ariaLabel('Move to Position')
                    .ok('Ok')

                $mdDialog.show(notification);
            }
            $mdDialog.hide({
                positionToMove: vm.positionToMove
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.custom-fields.binder')
        .directive('modelWatcher', modelWatcher)

    function modelWatcher(){
        var directive = {
            restrict : 'E',
            templateUrl : 'app/main/customFieldsManager/binder/modelWatcherDirective/modelWatcher.html',
            scope : {
                enabled : '@',
                values : '=',
                model : '=',
            },
            controller : controller,
            controllerAs : 'vm',
            bindToController : true
        };
        return directive;

        function controller(){
            var vm = this;
        }
    }

})();

'use strict';

  angular.module('app.corelib')
    .controller('ContactDatesController', ContactDatesController);

  function ContactDatesController($mdDialog,
                           utils,
                           contactService,
                           contactViewService,
                           $mdToast) {

    //Variables
    var vm = this;
    vm.service = contactViewService; // contactService;

    //Methods
    vm.onCancel = onCancel;
    vm.applyFilter = applyFilter;

    function onCancel(){
      $mdDialog.hide();
    }

    vm.service.filterModel.filterType = 1;

    function applyFilter(){
      if(moment(vm.service.filterModel.startDate).isAfter(moment(vm.service.filterModel.endDate))){
        $mdToast.show(
          $mdToast.simple()
            .textContent(utils.translate('VIEWCONTACTS.DATE_RANGE_ERROR'))
            .position('bottom right')
        );
        vm.service.filterModel.startDate = null;
        return;
      }

      if(moment(vm.service.filterModel.endDate).isBefore(moment(vm.service.filterModel.startDate))){
        $mdToast.show(
          $mdToast.simple()
            .textContent(utils.translate('VIEWCONTACTS.DATE_RANGE_ERROR'))
            .position('bottom right')
        );
        vm.service.filterModel.endDate = null;
        return;
      }
      $mdDialog.hide(1);
    }
  }






(function () {
  'use strict';

  angular
    .module('app.contact.view', [])
    .config(config)
    .run(runConfig);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.contact_view', {
      url: '/contacts/view-contacts'
      , views: {
        'content@app': {
          templateUrl: 'app/main/contact/view/contact-view.html'
          , controller: 'ContactViewController as vm'
        }
      }
      , data: {
        requireLogin: true
      }
      , title: 'View Contacts'
      , titleBar: 'Alloc8 - View Contacts'
    });

    $translatePartialLoaderProvider.addPart('app/main/contact/view');
  }

  /** @ngInject */
  function runConfig(contactViewSignalrHubService) {
    contactViewSignalrHubService.register();
  }
})();

"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewContactsComponent = function (_React$Component) {
  _inherits(ViewContactsComponent, _React$Component);

  function ViewContactsComponent() {
    _classCallCheck(this, ViewContactsComponent);

    var _this = _possibleConstructorReturn(this, (ViewContactsComponent.__proto__ || Object.getPrototypeOf(ViewContactsComponent)).call(this));

    _this.viewCard = _this.viewCard.bind(_this);
    _this.editcontact = _this.editcontact.bind(_this);
    _this.viewCalendar = _this.viewCalendar.bind(_this);
    _this.translate = _this.translate.bind(_this);
    return _this;
  }

  _createClass(ViewContactsComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $('#view-contacts').dataTable({
        "responsive": false,
        "bAutoWidth": false,
        "bDestroy": true,
        "sDom": 'rt<"bottom"lip>'
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      $('#view-contacts').dataTable({
        "responsive": false,
        "bAutoWidth": false,
        "bDestroy": true,
        "sDom": 'rt<"bottom"lip>'
      });
    }
  }, {
    key: "viewCard",
    value: function viewCard(id) {
      this.props.viewcontactcard(id);
    }
  }, {
    key: "editcontact",
    value: function editcontact(id, fname, lname) {
      this.props.editcontact(id, fname, lname);
    }
  }, {
    key: "viewCalendar",
    value: function viewCalendar(item) {
      this.props.viewcalendar(item);
    }
  }, {
    key: "translate",
    value: function translate() {
      return this.props.translate();
    }
  }, {
    key: "render",
    value: function render() {
      var self = this;
      var style = {
        margin: '5px'
      };
      function createItem(item) {
        var actionPartial = void 0;
        var isEmployee = _.find(item.ContactTypes, function (o) {
          return o === 'Employee';
        });
        if (isEmployee) {
          actionPartial = React.createElement(
            "div",
            null,
            React.createElement(
              "md-button",
              { className: "md-icon-button",
                style: style,
                onClick: self.editcontact.bind(this, item.Id, item.FirstName, item.LastName) },
              React.createElement("i", { className: "icon icon-pencil teal-500-fg s15" })
            ),
            React.createElement(
              "md-button",
              { className: "md-icon-button",
                style: style,
                onClick: self.viewCalendar.bind(this, item) },
              React.createElement("i", { className: "icon icon-calendar blue-500-fg s15" })
            )
          );
        } else {
          actionPartial = React.createElement(
            "div",
            null,
            React.createElement(
              "md-button",
              { className: "md-icon-button",
                onClick: self.editcontact.bind(this, item.Id, item.FirstName, item.LastName) },
              React.createElement("i", { className: "icon icon-pencil teal-500-fg s15" })
            )
          );
        }
        return React.createElement(
          "tr",
          null,
          React.createElement(
            "td",
            null,
            React.createElement(
              "md-button",
              { className: "md-icon-button md-primary action-button",
                onClick: self.viewCard.bind(this, item.Id),
                "aria-label": "Settings" },
              React.createElement("i", { className: "icon icon-account light-blue-500-fg s15" })
            )
          ),
          React.createElement(
            "td",
            null,
            item.FirstName,
            " ",
            item.LastName
          ),
          React.createElement(
            "td",
            null,
            item.ContactTypes.join(", ")
          ),
          React.createElement(
            "td",
            null,
            item.Position
          ),
          React.createElement(
            "td",
            null,
            item.Email
          ),
          React.createElement(
            "td",
            null,
            item.EmployeeCode
          ),
          React.createElement(
            "td",
            null,
            item.Phone
          ),
          React.createElement(
            "td",
            null,
            item.Branches.join(", ")
          ),
          React.createElement(
            "td",
            null,
            item.Divisions.join(", ")
          ),
          React.createElement(
            "td",
            null,
            item.IsActive === true ? 'Yes' : 'No'
          ),
          React.createElement(
            "td",
            null,
            actionPartial
          )
        );
      }

      return React.createElement(
        "table",
        { className: "dataTable row-border hover", id: "view-contacts" },
        React.createElement(
          "thead",
          null,
          React.createElement(
            "tr",
            null,
            React.createElement("th", null),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_NAME')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_TYPE')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_POSITION')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_EMAIL')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_CODE')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_MOBILE')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_BRANCHES')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_DIVISIONS')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCONTACTS.COLUMN_ACTIVE')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              this.props.translate('VIEWCONTACTS.COLUMN_ACTIONS')
            )
          )
        ),
        React.createElement(
          "tbody",
          null,
          this.props.contacts.map(createItem)
        )
      );
    }
  }]);

  return ViewContactsComponent;
}(React.Component);

ViewContactsComponent.propTypes = {
  search: React.PropTypes.string,
  contacts: React.PropTypes.array.isRequired,
  viewcontactcard: React.PropTypes.func.isRequired,
  editcontact: React.PropTypes.func.isRequired,
  viewcalendar: React.PropTypes.func.isRequired,
  translate: React.PropTypes.func.isRequired
};
ViewContactsComponent.defaultProps = {
  search: null,
  contacts: [],
  viewcontactcard: function viewcontactcard() {},
  translate: function translate() {}
};


angular.module('app.contact.view').value('ViewContactsComponent', ViewContactsComponent);
(function () {
  'use strict';

  angular.module('app.contact.view')
    .directive('viewContactsComponent', viewContactsComponent);

  /** @ngInject */
  function viewContactsComponent(reactDirective, ViewContactsComponent) {
    return reactDirective(ViewContactsComponent);
  }

})();

(function() {
    'use strict';
    angular
        .module('app.contact.create')
        .controller('ContactsCreateWorkController', ContactsCreateWorkController);

    /** @ngInject */
    function ContactsCreateWorkController(mediaQueryService,
        $mdDialog,
        contactService,
        contactLookupsService,
        _,
        claimsUtilService,
        payrollClaimsService,
        contactBranchModel,
        allowanceAPI,
        $timeout) {

        var vm = this;

        //// Data
        vm.mediaQueryService = mediaQueryService;
        vm.service = contactService;
        vm.checkAccessService = claimsUtilService;
        vm.model = contactService.contactData;
        vm.ContactTypes = contactLookupsService.contactLookupsObj.ContactTypes;
        vm.isEditMode = contactService.isEditMode;
        vm.contactData = contactService.contactData;
        vm.isArchive = contactService.contactData.IsArchived;
        vm.addressTypes = contactLookupsService.contactLookupsObj.AddressTypes;
        vm.commMethods = contactLookupsService.contactLookupsObj.CommunicationMethods;
        vm.PhoneTypes = contactLookupsService.contactLookupsObj.PhoneTypes;
        vm.companies = contactLookupsService.contactLookupsObj.Companies;
        vm.skillsGroups = contactLookupsService.contactLookupsObj.SkillsLookUp;
        vm.companyDialog = {};
        vm.dtOptions = {
            pagingType: 'simple',
            pageLength: 25,
            autoWidth: false,
            responsive: true,
            sort: false
        };

        //// Method
        vm.editCompany = editCompany;
        vm.removeCompany = removeCompany;
        vm.removeEmail = removeEmail;
        vm.removePhone = removePhone;
        vm.removeSkill = removeSkill;
        vm.removeAddress = removeAddress;
        vm.showCompanyDialog = showCompanyDialog;

        function showCompanyDialog() {
            $mdDialog.show({
                locals: {
                    selectedCompany: null,
                    editMode: false,
                    index: null,
                    quickOption: false
                },
                templateUrl: 'app/main/contact/create/work/company/workInfo-company.html',
                controller: 'ContactCreateCompanyController as vm'
            }).then(function(answer) {});
        }

        function removeAddress(index) {
            vm.model.Addresses.splice(index, 1)
        }

        function removeSkill(skill) {
            angular.forEach(contactService.contactData.PersonalSkills, function(skl) {
                skl.Skills = _.reject(skl.Skills, {
                    UniqueId: skill.UniqueId
                })
            });
            contactService.formatData();
        }

        function activate() {

            vm.isAllowanceVisible = claimsUtilService.isPayrollEnabled() &&
                (payrollClaimsService.hasModifyAllowancesAccess || payrollClaimsService.hasRunPayrollAccess);

            if (vm.isAllowanceVisible) {
                allowanceAPI.getAllowances().then(function(resp) {
                    vm.allowancesList = resp.data;
                });
            }

            // Create copy of branches from lookup service but with extra property (Selected)
            if (!contactService.isEditMode) {
                contactService.contactData.Branches.length = 0;
                angular.forEach(contactLookupsService.contactLookupsObj.Branches, function(itm) {
                    contactService.contactData.Branches.push(new contactBranchModel({
                        Id: itm.id,
                        Name: itm.Name,
                        CreatedDate: itm.CreatedDate,
                        LastUpdatedDate: itm.LastUpdatedDate,
                        IsActive: itm.IsActive,
                        IsArchived: itm.IsArchived,
                        Selected: false
                    }))
                }, this);
            }            
        }

        function removeEmail(email) {
            angular.forEach(vm.model.Emails, function(item, key) {
                if (item == email) {
                    vm.model.Emails.splice(key, 1);
                }
            });

            vm.model.Emails[0].IsPrimary = true;
        }

        function removePhone(phone) {

            angular.forEach(vm.model.Phones, function(item, key) {
                if (item == phone) {
                    vm.model.Phones.splice(key, 1);
                }
            });

            vm.model.Phones[0].IsPrimary = true;
        }


        function editCompany(data, editMode, index) {
            vm.companyDialog.showDialog(data, editMode, index);
        }

        function removeCompany(index) {
            contactService.contactData.Companies.splice(index, 1);
        }

        $timeout(function() {
            activate();
        }, 500);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.contact.calendarEntry.manage')
        .factory('manageCalendarEntryService', manageCalendarEntryService);

    /** @ngInject */
    function manageCalendarEntryService($q, contactApi, exceptionService, utils, calendarEntryStatus, calendarEntryType, moment) {
        var service = {
            unavailableEntriesResult: {
                [calendarEntryStatus.ALL]: {
                    entries: [],
                    continuationToken: null,
                    count: 0
                },
                [calendarEntryStatus.PENDING]: {
                    entries: [],
                    continuationToken: null,
                    count: 0
                },
                [calendarEntryStatus.APPROVED]: {
                    entries: [],
                    continuationToken: null,
                    count: 0
                },
                [calendarEntryStatus.REJECTED]: {
                    entries: [],
                    continuationToken: null,
                    count: 0
                }
            },
            employees: [],
            filteredRequests: [],
            branches: [],
            pageSize: 100,
            filters: {
                startDate: moment().startOf('week').toDate(),
                endDate: moment().endOf('week').toDate(),
                selectedBranch: null,
                searchText: '',
                selectedFilter: calendarEntryStatus.ALL,
                selectedEmployees: []
            },
            entryTypeSettings: [],
            reasonTypes: [],
            isLoadingMessage: 'Loading calendar entries...',
            isLoading: false,

            loadBranches: loadBranches,
            loadEntryTypeSettings: loadEntryTypeSettings,
            saveEntryTypeSettings: saveEntryTypeSettings,
            loadUnavailableCalendarEntries: loadUnavailableCalendarEntries,
            filterRequests: filterRequests,
            approveRequest: approveRequest,
            approveRequestWithConflicts: approveRequestWithConflicts,
            rejectRequest: rejectRequest,
            bulkApprove: bulkApprove,
            bulkReject: bulkReject,
            toggleSelectAll: toggleSelectAll,
            getStatusClass: getStatusClass,
            getPendingCount: getPendingCount,
            getApprovedCount: getApprovedCount,
            getRejectedCount: getRejectedCount,
            getAllCount: getAllCount,
            getSelectedRequests: getSelectedRequests,
            resetFilters: resetFilters,
            fetchUnavailableCalendarEntriesCount: fetchUnavailableCalendarEntriesCount,
            hasMoreItems: hasMoreItems,
            resetData: resetData,
            selectBranchFilter: selectBranchFilter,
            getEmployeesbyBranchOrDivision: getEmployeesbyBranchOrDivision
        };

        return service;

        function loadBranches() {
            var deferred = $q.defer();

            contactApi.getBranches()
                .then(function (resp) {
                    service.branches = resp.data;
                    deferred.resolve(service.branches);
                })
                .catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function selectBranchFilter() {
            service.filters.selectedEmployees = [];
            service.resetData();

            service.isLoading = true;
            service.employees = [];
            service.getEmployeesbyBranchOrDivision().then(function () {
                service.fetchUnavailableCalendarEntriesCount().then(function () {
                    service.loadUnavailableCalendarEntries().then(c=> {
                        service.isLoading = false;
                    });
                });
            })
        }

        function getEmployeesbyBranchOrDivision() {
            var payload = {
                m_Item1: service.filters.selectedBranch && service.filters.selectedBranch.length > 0 ? service.filters.selectedBranch : service.branches.map(b => b.Id),
                m_Item2: []
            }

            var defer = $q.defer();
            
            contactApi.getEmployeesByBranchOrDivision(payload)
            .then(function (resp) {
                service.employees = resp.data;
                defer.resolve(service.employees);
            }).catch(function (ex) {
                exceptionService.resolve(ex);
                defer.reject(ex);
            });

            return defer.promise;
        }

        function fetchUnavailableCalendarEntriesCount() {
            var deferred = $q.defer();

            const startDate = utils.jsDate(service.filters.startDate);
            const endDate = utils.jsDate(service.filters.endDate);

            const data = {
                startDate: startDate,
                endDate: endDate,
                branchIds: service.filters.selectedBranch && service.filters.selectedBranch.length > 0 ? service.filters.selectedBranch : service.branches.map(b => b.Id),
                calendarEntryType: calendarEntryType.UNAVAILABLE,
                searchKeyword: service.filters.searchText,
                contactIds: service.filters.selectedEmployees ? service.filters.selectedEmployees.map(c => c.Id) : []
            }

            contactApi.getPagedCalendarEntriesCount(data)
                .then(function (resp) {

                    service.unavailableEntriesResult[calendarEntryStatus.ALL].count = resp.data.TotalCount;
                    service.unavailableEntriesResult[calendarEntryStatus.APPROVED].count = resp.data.ApprovedCount;
                    service.unavailableEntriesResult[calendarEntryStatus.REJECTED].count = resp.data.RejectedCount;
                    service.unavailableEntriesResult[calendarEntryStatus.PENDING].count = resp.data.PendingCount;
                    
                    deferred.resolve(service.unavailableEntriesResult);
                })
                .catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadUnavailableCalendarEntries() {
            var deferred = $q.defer();

            const unavailableEntriesResultData = service.unavailableEntriesResult[service.filters.selectedFilter];

            if (unavailableEntriesResultData.entries.length === unavailableEntriesResultData.count) {
                unavailableEntriesResultData.continuationToken = null;
                filterRequests();

                deferred.resolve(service.unavailableEntriesResult);
                return deferred.promise;
            }

            const startDate = utils.jsDate(service.filters.startDate);
            const endDate = utils.jsDate(service.filters.endDate);

            const data = {
                pageSize: service.pageSize,
                continuationToken: unavailableEntriesResultData.continuationToken,
                startDate: startDate,
                endDate: endDate,
                branchIds: service.filters.selectedBranch && service.filters.selectedBranch.length > 0 ? service.filters.selectedBranch : service.branches.map(b => b.Id),
                contactIds: service.filters.selectedEmployees ? service.filters.selectedEmployees.map(c => c.Id) : [],
                status: service.filters.selectedFilter,
                calendarEntryType: calendarEntryType.UNAVAILABLE,
                searchKeyword: service.filters.searchText
            }

            contactApi.getPagedCalendarEntries(data)
                .then(function (resp) {
                    const existingIds = new Set(
                        unavailableEntriesResultData.entries.map(e => e.Id)
                    );

                    const newUniqueEntries = resp.data.Entries.filter(
                        e => !existingIds.has(e.Id)
                    );

                    unavailableEntriesResultData.entries = unavailableEntriesResultData.entries.concat(newUniqueEntries);
                    unavailableEntriesResultData.continuationToken = resp.data.ContinuationToken;
                    
                    filterRequests();
                    deferred.resolve(service.unavailableEntriesResult);
                })
                .catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function filterRequests() {
            service.filteredRequests = service.unavailableEntriesResult[service.filters.selectedFilter].entries.filter(function (request) {
                var matchesFilter = true;

                if (service.filters.searchText) {
                    var searchLower = service.filters.searchText.toLowerCase();
                    matchesFilter = matchesFilter &&
                        (request.FullName.toLowerCase().includes(searchLower) ||
                            request.Branch.toLowerCase().includes(searchLower));
                }

                return matchesFilter;
            });

            return service.filteredRequests;
        }

        function approveRequest(request) {
            var deferred = $q.defer();

            contactApi.approveCalendarEntry(request.Id)
                .then(function (resp) {
                    var result = resp.data;

                    if (result.HasConflicts) {
                        deferred.resolve({ hasConflicts: true, conflictingAllocations: result.ConflictingAllocations, request: request });
                    } else {
                        request.Status = calendarEntryStatus.APPROVED;
                        request.selected = false;
                        updateCountsAfterAction(calendarEntryStatus.APPROVED);
                        deferred.resolve({ hasConflicts: false, request: request });
                    }
                })
                .catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function approveRequestWithConflicts(request) {
            var deferred = $q.defer();

            contactApi.approveCalendarEntry(request.Id, { resolveConflicts: true })
                .then(function (resp) {
                    request.Status = calendarEntryStatus.APPROVED;
                    request.selected = false;
                    updateCountsAfterAction(calendarEntryStatus.APPROVED);
                    deferred.resolve({ request: request });
                })
                .catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function rejectRequest(request) {
            var deferred = $q.defer();

            contactApi.rejectCalendarEntry(request.Id)
                .then(function (resp) {
                    request.Status = calendarEntryStatus.REJECTED;
                    request.selected = false;
                    updateCountsAfterAction(calendarEntryStatus.REJECTED);
                    deferred.resolve({ request: request });
                })
                .catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function updateCountsAfterAction(newStatus) {
            service.unavailableEntriesResult[calendarEntryStatus.PENDING].count--;
            service.unavailableEntriesResult[newStatus].count++;
        }

        function bulkApprove() {
            var deferred = $q.defer();
            var selectedRequests = getSelectedRequests();
            var promises = [];

            angular.forEach(selectedRequests, function (request) {
                promises.push(approveRequest(request));
            });

            $q.all(promises)
                .then(function (results) {
                    deferred.resolve(results);
                })
                .catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function bulkReject() {
            var deferred = $q.defer();
            var selectedRequests = getSelectedRequests();
            var promises = [];

            angular.forEach(selectedRequests, function (request) {
                promises.push(rejectRequest(request));
            });

            $q.all(promises)
                .then(function (results) {
                    deferred.resolve(results);
                })
                .catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function toggleSelectAll() {
            angular.forEach(service.filteredRequests, function (request) {
                if (request.Status === calendarEntryStatus.PENDING) {
                    request.selected = service.selectAll;
                    return;
                }
            });
        }

        function getSelectedRequests() {
            return service.filteredRequests.filter(function (request) {
                return request.selected === true;
            });
        }

        function getStatusClass(status) {
            var statusClasses = {
                [calendarEntryStatus.PENDING]: 'status-pending',
                [calendarEntryStatus.APPROVED]: 'status-approved',
                [calendarEntryStatus.REJECTED]: 'status-rejected'
            };
            return statusClasses[status] || '';
        }

        function getPendingCount() {
            return service.unavailableEntriesResult[calendarEntryStatus.PENDING].count;
        }

        function getApprovedCount() {
            return service.unavailableEntriesResult[calendarEntryStatus.APPROVED].count;
        }

        function getRejectedCount() {
            return service.unavailableEntriesResult[calendarEntryStatus.REJECTED].count;
        }

        function getAllCount() {
            return service.unavailableEntriesResult[calendarEntryStatus.ALL].count;
        }

        function resetFilters() {
            service.filters = {
                startDate: moment().startOf('week').toDate(),
                endDate: moment().endOf('week').toDate(),
                selectedBranch: null,
                searchText: '',
                selectedFilter: calendarEntryStatus.ALL,
                selectedEmployees: []
            };
            filterRequests();
        }

        function hasMoreItems() {
            var unavailableEntriesResultData = service.unavailableEntriesResult[service.filters.selectedFilter];
            return unavailableEntriesResultData.count != unavailableEntriesResultData.entries.length && unavailableEntriesResultData.continuationToken;
        }

        function resetData() {
            service.unavailableEntriesResult ={
                [calendarEntryStatus.ALL]: {
                    entries: [],
                    continuationToken: null,
                    count: 0
                },
                [calendarEntryStatus.PENDING]: {
                    entries: [],
                    continuationToken: null,
                    count: 0
                },
                [calendarEntryStatus.APPROVED]: {
                    entries: [],
                    continuationToken: null,
                    count: 0
                },
                [calendarEntryStatus.REJECTED]: {
                    entries: [],
                    continuationToken: null,
                    count: 0
                }
            }
        }

                function saveEntryTypeSettings(settings) {
            let deferred = $q.defer();

            contactApi.saveCalendarEntryTypeConfiguration(settings)
                .then(function (resp) {
                    service.entryTypeSettings = settings;
                    deferred.resolve(settings);
                })
                .catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadEntryTypeSettings() {
            let deferred = $q.defer();
            contactApi.getCalendarEntryTypeConfigurations()
                .then(function (response) {
                    service.entryTypeSettings = response.data;
                    deferred.resolve(service.entryTypeSettings);
                })
                .catch(function (ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

    }
})();

/**
 * Created by Ben Rei on 8/25/2016.
 */
(function () {
  'use strict';

  angular.module('app.jobs')
    .service('ToastService', ToastService);

  /** @ngInject */
  function ToastService($mdToast) {
    var self = this;

    self.last = {
      bottom: true,
      top: false,
      left: false,
      right: true
    };

    self.toastPosition = angular.extend({},self.last);

    var service = {
      toast: toastMe
    };

    return service;

    function toastMe(message){
      var pinTo = getToastPosition();
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position(pinTo )
          .hideDelay(3000)
      );
    }

    function getToastPosition() {
      sanitizePosition();
      return Object.keys(self.toastPosition)
        .filter(function(pos) { return self.toastPosition[pos]; })
        .join(' ');
    };

    function sanitizePosition() {
      var current = self.toastPosition;
      if (current.bottom && self.last.top) current.top = false;
      if (current.top && self.last.bottom) current.bottom = false;
      if (current.right && self.last.left) current.left = false;
      if (current.left && self.last.right) current.right = false;
      self.last = angular.extend({}, current);
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.contact.calendar')
        .constant('calendarEntryType', {
            UNAVAILABLE: 0,
            REJECTED_SHIFT: 1,
            TOOLBOX_MEETING: 2
        })
        .constant('calendarEntryStatus', {
            ALL: 0,
            PENDING: 1,
            APPROVED: 2,
            REJECTED: 3
        });
})();
(function() {
    'use strict';

    angular.module('app.contact.calendar')
        .service('contactCalendarModel', contactCalendarModel);

    function contactCalendarModel(identityService, localisationService, _) {
        return function() {
            var self = this,
                defaults = {
                    Id: null,
                    CalendarEntryType: null,
                    CalendarEntryTypeDetails: null,
                    title: null,
                    color: null,
                    ContactId: [],
                    Repeats: null,
                    StartDate: null,
                    start: null,
                    EndDate: null,
                    end: null,
                    Rejected: [],
                    Remarks: null,
                    
                };

            self.map = mapper;
            self.transformToServerModel = transformToServerModel;
            self.transformToModel = transformToModel;
            self.transformData = transformData;
            self.reset = reset;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults;
                var opts = angular.extend(this, defaults, mapValue);

                if (opts.StartDate) {
                    this.start = moment(opts.StartDate).toDate();
                }

                if (opts.EndDate) {
                    this.end = moment(opts.EndDate).toDate();
                }

                if (opts.Title) {
                    this.title = opts.Title;
                }

                if (opts.Color) {
                    this.color = opts.Color;
                }
            }

            function reset() {
                self.map(null);
                self.Repeat.length = 0;
            }

            function transformToServerModel() {
                var startDate = null,
                    endDate = null,
                    timeformat = null,
                    repeat = {},
                    isoDate = null;

                var localeSettings = localisationService.getLocaleFormatSettings();
                timeformat = localeSettings.timeFormat;
                isoDate = localeSettings.isoDateTime;

                if (self.startTime) {
                    self.StartDate = moment(self.start).format('MM/DD/YYYY') + ' ' +
                        moment(moment(self.startTime, timeformat)).format('HH:mm:ss');
                }

                if (self.endTime) {
                    self.end = _.isNil(self.end) ? self.start : self.end;
                    self.EndDate = moment(self.end).format('MM/DD/YYYY') + ' ' +
                        moment(moment(self.endTime, timeformat)).format('HH:mm:ss');
                }

                if (self.StartDate) {
                    startDate = moment(self.StartDate, localeSettings.serverDefaultDateFormat).format(isoDate);
                    repeat.StartsOn = startDate;
                }

                if (self.EndDate) {
                    endDate = moment(self.EndDate, localeSettings.serverDefaultDateFormat).format(isoDate);
                }

                if (self.IsAllDayEvent) {
                    self.StartDate = moment(self.start).format('MM/DD/YYYY') + ' ' +
                        moment(moment(self.startTime, timeformat)).format('HH:mm:ss');
                    startDate = moment(self.StartDate, localeSettings.serverDefaultDateFormat).format(isoDate);

                    self.EndDate = moment(self.end).format('MM/DD/YYYY') + ' ' +
                        moment(moment(self.endTime, timeformat)).format('HH:mm:ss');
                    endDate = moment(self.EndDate, localeSettings.serverDefaultDateFormat).format(isoDate);

                    if (self.start === self.end) {
                        endDate = moment(moment(endDate).add(1, "days")).format(isoDate);
                    }
                }
                if (self.repeat) {
                    if (self.repeat.EndsOn) {
                        var _endTime = "00:00:00";
                        var _endDate = moment(moment(self.repeat.EndsOn).format('MM/DD/YYYY') + ' ' + _endTime);
                        self.repeat.EndsOn = moment(_endDate, localeSettings.serverDefaultDateFormat).format(isoDate);
                    }
                } else {
                    self.repeat = null;
                }

                var serverModel = {
                    Id: !self.Id ? null : self.Id,
                    CalendarEntryType: self.EntryType,
                    CalendarEntryTypeDetails: self.EntryReason,
                    ContactId: self.contactId,
                    Repeats: self.repeat,
                    StartDate: startDate,
                    EndDate: endDate,
                    IsAllDayEvent: self.IsAllDayEvent,
                    Rejected: self.Rejected,
                    Remarks: self.Remarks,
                }
                return serverModel;
            }

            function transformData(data, settings) {
                var repeat = _.find(settings, function(o) {
                    return o.Id === data.CalendarEntryId
                }).Repeats;
                var IsAllDayEvent = _.find(settings, function(o) {
                    return o.Id === data.CalendarEntryId
                }).IsAllDayEvent;
                var CalendarEntryTypeDetails = _.find(settings, function(o) {
                    return o.Id === data.CalendarEntryId
                }).CalendarEntryTypeDetails;
                var Remarks = _.find(settings, function(o) { 
                    return o.Id === data.CalendarEntryId 
                }).Remarks;

                var event = {
                    id: data.Id,
                    title: data.Title,
                    start: data.start,
                    end: data.end,
                    color: data.color,
                    IsAllDayEvent: IsAllDayEvent,
                    StartDate: data.StartDate,
                    EndDate: data.EndDate === "Invalid Date" ? null : data.EndDate,
                    CalendarEntryType: data.CalendarEntryType,
                    CalendarEntryTypeDetails: CalendarEntryTypeDetails,
                    ParentId: data.CalendarEntryId,
                    Repeats: repeat,
                    Remarks: Remarks,
                }

                return event;
            }

            function transformToModel(data, yearDiff) {
                var localeSettings = localisationService.getLocaleFormatSettings();
                var timeformat = localeSettings.timeFormat;

                var transformModels = {
                    calendarSettingEntry: [],
                    transformedDataCollection: [],
                    dataCollection: []
                };
                var transformedData = []
                var calendarSettingEntry = [];
                calendarSettingEntry = data;
                transformModels.calendarSettingEntry.push(calendarSettingEntry);


                // RepeatType 0 = daily; 1= weekly; 2 = monthly; 3 = yearly
                angular.forEach(data, function(item) {
                    //TODO:Handle long event per week, month and year
                    //initialize start and end
                    var _startdate = moment(item.StartDate).toDate();
                    var _enddate = moment(moment(item.StartDate).format('YYYY-MM-DD') + ' ' + moment(item.EndDate).format(timeformat)).toDate();


                    if (moment(item.EndDate).hour() <= moment(item.StartDate).hour()) {
                        _enddate = moment(moment(_enddate).add(1, 'days').format()).toDate();
                    }

                    var _color = null;
                    if (item.CalendarEntryType === 0) {
                        _color = '#1e514e';
                    }
                    if (item.CalendarEntryType === 1) {
                        ;
                        _color = '#6493a9'
                    }
                    if (item.CalendarEntryType === 2) {
                        _color = '#146c7c';
                    }
                    if (item.Repeats) {
                        var _endsOn = angular.copy(item.Repeats.EndsOn);
                        //generate intial data until end of the current year
                        if (!item.Repeats.EndsOn) {
                            if (yearDiff) {
                                _endsOn = moment(moment().endOf("year")).add(yearDiff, 'years');
                            } else {
                                _endsOn = moment().endOf("year");
                            }
                        } else {
                            var formattedEndons = moment(_endsOn).format('YYYY-MM-DD') + ' ' + moment().endOf("year").format('HH:mm:ss');
                            _endsOn = moment(formattedEndons).toDate();
                        }

                        if (item.Repeats.RepeatType === 0) {
                            while (_enddate <= moment(_endsOn).toDate()) {
                                var transformModel = {};
                                transformModel.id = _.uniqueId();
                                transformModel.ParentId = item.Id;
                                transformModel.CalendarEntryType = item.CalendarEntryType;
                                transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                                transformModel.title = item.title;
                                transformModel.StartDate = item.StartDate;
                                transformModel.EndDate = item.EndDate;
                                transformModel.EndsOn = item.Repeats.EndsOn;
                                transformModel.start = _startdate;
                                transformModel.end = _enddate;
                                transformModel.color = _color;
                                transformModel.Repeats = item.Repeats;
                                transformModel.Remarks = item.Remarks;
                                transformedData.push(transformModel);
                                transformModels.dataCollection.push(transformModel);

                                _startdate = moment(moment(_startdate).add(item.Repeats.RepeatEvery, 'days').format()).toDate();
                                _enddate = moment(moment(_enddate).add(item.Repeats.RepeatEvery, 'days').format()).toDate();
                            }
                        }

                        if (item.Repeats.RepeatType === 1) {
                            var transformModel = {};
                            transformModel.id = _.uniqueId();
                            transformModel.ParentId = item.Id;
                            transformModel.CalendarEntryType = item.CalendarEntryType;
                            transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                            transformModel.title = item.title;
                            transformModel.dow = item.Repeats.RepeatsOn;
                            transformModel.StartDate = item.StartDate;
                            transformModel.EndDate = item.EndDate;
                            transformModel.EndsOn = item.Repeats.EndsOn;
                            transformModel.start = moment(item.StartDate).format(timeformat);
                            transformModel.end = computeOverNight(item.StartDate, item.EndDate, timeformat);
                            transformModel.color = _color;
                            transformModel.Repeats = item.Repeats;
                            transformModel.Remarks = item.Remarks;

                            if (item.Repeats.RepeatEvery < 2) {
                                transformModel.ranges = [{
                                    start: moment(item.StartDate).toDate(),
                                    end: moment(_endsOn).toDate()
                                }]
                            }

                            if (item.Repeats.RepeatEvery > 1) {
                                transformModel.ranges = [];
                                _enddate = moment(_enddate).add(7 - moment(_startdate).diff(moment(_startdate).startOf('week'), 'days'), 'days').toDate();
                                while (_enddate <= moment(_endsOn).toDate()) {
                                    var _range = {};
                                    _range.start = _startdate;
                                    _range.end = _enddate;
                                    transformModel.ranges.push(_range);
                                    _startdate = moment(_startdate).add(item.Repeats.RepeatEvery * 1, 'weeks').toDate();
                                    _enddate = moment(_startdate).add(7 - moment(_startdate).diff(moment(_startdate).startOf('week'), 'days'), 'days').toDate();
                                }
                            }
                            transformedData.push(transformModel);
                            transformModels.dataCollection.push(transformModel);
                        }

                        if (item.Repeats.RepeatType === 2) {
                            while (_enddate <= moment(_endsOn).toDate()) {
                                var transformModel = {};
                                transformModel.id = _.uniqueId();
                                transformModel.ParentId = item.Id;
                                transformModel.CalendarEntryType = item.CalendarEntryType;
                                transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                                transformModel.title = item.title;
                                transformModel.StartDate = _startdate;
                                transformModel.EndDate = _enddate;
                                transformModel.EndsOn = item.Repeats.EndsOn;
                                transformModel.start = _startdate;
                                transformModel.end = _enddate;
                                transformModel.color = _color;
                                transformModel.Repeats = item.Repeats;
                                transformModel.Remarks = item.Remarks;
                                transformedData.push(transformModel);
                                transformModels.dataCollection.push(transformModel);

                                _startdate = moment(moment(_startdate).add(item.Repeats.RepeatEvery * 1, 'months').format()).toDate();
                                _enddate = moment(moment(_enddate).add(item.Repeats.RepeatEvery * 1, 'months').format()).toDate();
                            }
                        }

                        if (item.Repeats.RepeatType === 3) {

                            while (_enddate <= moment(_endsOn).toDate()) {
                                var transformModel = {};
                                transformModel.id = _.uniqueId();
                                transformModel.ParentId = item.Id;
                                transformModel.CalendarEntryType = item.CalendarEntryType;
                                transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                                transformModel.title = item.title;
                                transformModel.StartDate = item.StartDate;
                                transformModel.EndDate = item.EndDate;
                                transformModel.EndsOn = item.Repeats.EndsOn;
                                transformModel.start = _startdate;
                                transformModel.end = _enddate;
                                transformModel.color = _color;
                                transformModel.Repeats = item.Repeats;
                                transformModel.Remarks = item.Remarks;
                                transformedData.push(transformModel);
                                transformModels.dataCollection.push(transformModel);

                                _startdate = moment(moment(_startdate).add(item.Repeats.RepeatEvery * 1, 'years').format()).toDate();
                                _enddate = moment(moment(_enddate).add(item.Repeats.RepeatEvery * 1, 'years').format()).toDate();
                            }
                        }
                    } else {
                        var transformModel = {};
                        transformModel.id = _.uniqueId();
                        transformModel.ParentId = item.Id;
                        transformModel.CalendarEntryType = item.CalendarEntryType;
                        transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                        transformModel.title = item.title;
                        //transformModel.dow = item.Repeats.RepeatsOn;
                        transformModel.StartDate = item.StartDate;
                        transformModel.EndDate = item.EndDate;
                        //transformModel.EndsOn = item.Repeats.EndsOn;
                        transformModel.start = moment(item.StartDate).toDate();
                        transformModel.end = moment(item.EndDate).toDate();
                        transformModel.color = _color;
                        transformModel.Repeats = item.Repeats;
                        transformModel.Remarks = item.Remarks;

                        transformModels.dataCollection.push(transformModel);
                    }
                });
                transformModels.transformedDataCollection.push(transformedData);
                return transformModels;
            }

            function computeOverNight(start, end, timeformat) {
                if (moment(end).hour() <= moment(start).hour()) {
                    var time = 24 + (((moment(end).hour() / 60) + moment(end).minutes()) * 60);
                    return time + ':00';
                }
                return moment(end).format(timeformat);
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.contact.calendarEntry', [
            'app.contact.calendarEntry.add',
            'app.contact.calendarEntry.manage'

        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.calendar_entry', {
            url: '/contacts/calendar-entry',
            views: {
                'content@app': {
                    templateUrl: 'app/main/contact/calendar/calendar-entry/calendar-entry.html',
                    controller: 'CalendarEntryController as vm'
                }
            },
            data: { requireLogin: true },
            title: 'Calendar Entry',
            titleBar: 'Alloc8 - Calendar Entry'
        });

        // Child state: Add Calendar Entry (default)
        $stateProvider.state('app.calendar_entry.add', {
            url: '/add',
            views: {
                'tab-content': {
                    templateUrl: 'app/main/contact/calendar/calendar-entry/add/add-contact-calendar.html',
                    controller: 'addContactCalendarController as addVm'
                }
            },
            data: { requireLogin: true },
            title: 'Add Calendar Entry',
            titleBar: 'Alloc8 - Add Calendar Entry'
        });

        // Child state: Manage Calendar Entry Requests
        $stateProvider.state('app.calendar_entry.manage', {
            url: '/manage',
            views: {
                'tab-content': {
                    templateUrl: 'app/main/contact/calendar/calendar-entry/manage/manage-calendar-entry.html',
                    controller: 'manageCalendarEntryController as manageVm'
                }
            },
            data: { requireLogin: true },
            title: 'Manage Calendar Entry Requests',
            titleBar: 'Alloc8 - Manage Calendar Entry Requests'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.contact.calendarEntry')
        .controller('CalendarEntryController', CalendarEntryController);

    /** @ngInject */
    function CalendarEntryController($state, adminClaimsService) {
        var vm = this;

        vm.tabs = [
            { label: 'ADD NEW CALENDAR ENTRY', state: 'app.calendar_entry.add' },
            { label: 'MANAGE CALENDAR ENTRY REQUESTS', state: 'app.calendar_entry.manage' }
        ];

        vm.selectedTabIndex = 0;
        vm.hasApproveCalendarEntries = adminClaimsService.hasApproveCalendarEntries;
        vm.goToTab = goToTab;
        vm.activate = activate;

        function activate() {
            // Set selected tab based on current state
            updateSelectedTab();
        }

        function updateSelectedTab() {
            var currentState = $state.current.name;
            for (var i = 0; i < vm.tabs.length; i++) {
                if (currentState === vm.tabs[i].state) {
                    vm.goToTab(i);
                    break;
                }
            }
        }

        function goToTab(index) {
            vm.selectedTabIndex = index;
            $state.go(vm.tabs[index].state);
        }

        vm.activate();
    }
})();

/**
 * Invoice downloader adapter service
 *
 * Rcnet 1.26.2017
 */
(function () {
    'use strict';

    angular.module('app.costEstimate.view')
        .service('ceReportListingAdapterService', ceReportListingAdapterService);

    /** @ngInject */
    function ceReportListingAdapterService($log,
        $q,
        a8WebApiNoChunkDataProvider,
        costEstimateApi,
        ceReportDataModel,
        exceptionService) {

        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData // inbound event (called by grid client)
        };

        // Create data provider
        var dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }
        
        function onGetData(params) {
            return dbSource.fetch(function () {
                return getCostEstimates(params.filters);
            });
        }

        function getCostEstimates(filters) {
            let deferred = $q.defer();

             costEstimateApi.getCostEstimateGroups(filters)
                            .then(function(resp) {
                                let data = mapData(resp.data);
                                deferred.resolve(data);
                            }).catch(function(ex) {
                                deferred.reject(ex);
                            });

            return deferred.promise;
        }

        function mapData(data) {
            let mappedData = [];
            data.map(function (itm) {
                let invData = new ceReportDataModel();
                mappedData.push(invData.map(itm));
            });
            return mappedData;
        }
    }
})();
/**
 * Invoiew view service
 *
 * Rcnet 1.26.2017
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.view')
        .service('ceReportGridService', ceReportGridService);

    /** @ngInject */
    function ceReportGridService($log,
        $q,
        $rootScope,
        exceptionService,
        ceReportListingAdapterService) {

        var service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        activate();

        return service;

        ///////
        function activate() {}

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(ceReportListingAdapterService);
        }

        /**
         * Loading of partial data
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }

    }
})();
/**
 * Cost Estimate view service
 *
 * Rcnet 1.26.2017
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.view')
        .service('ceFilterService', ceFilterService);

    /** @ngInject */
    function ceFilterService($log,
        $q,
        utils,
        $rootScope,
        exceptionService,
        moment,
        $mdToast,
        branchApi,
        ceReportGridService,
        ceViewFilterModel) {

        var service = {
            data: new ceViewFilterModel(),
            branchLookups: [],
            applyFilter: applyFilter,
            loadLookups: loadLookups,
            reset: reset
        };

        activate();

        return service;
        
        function activate() {}

        function applyFilter() {
            ceReportGridService.filterData = service.data.toBackendModel();
            ceReportGridService.grid.behavior.refresh();
        }

        function loadLookups() {
            let promise1 = loadBranches();

            return $q.all([promise1]);
        }

        function loadBranches() {
            let deferred = $q.defer();

            // Load branches
            service.branchLookups.length = 0;
            branchApi.getBranchesAndStates()
                .then(function(resp) {
                    angular.forEach(resp.data, function(itm) {
                        itm['selected'] = false;
                        itm.StateBranches = [];
                        if (itm.State == null) {
                            itm.StateBranches = itm.Id.split(',');
                            itm.Id = utils.newGuid();
                        }
                        service.branchLookups.push(itm);
                    }, this);

                    deferred.resolve(service.branchLookups);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function reset() {
            service.data.reset();
            applyFilter();
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.costEstimate.view')
        .service('ceViewFilterModel', ceViewFilterModel)

    function ceViewFilterModel(alasql, utils) {
        return function() {
            var self = this,
                defaults = {
                    //ticketNoInvoiceNo: null,
                    //filterType: null,
                    //startDate: null,
                    //endDate: null,
                    selectedBranches: [],
                    cancelledCostEstimate: false
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.selectedBranches.length = 0;
            }

            function transformToModel() {
                // Collect item types
                let prm = {
                    // startDate: null,
                    // endDate: null,
                    //invoiceStartDate: null,
                    //invoiceEndDate: null,
                    //ticketInvoiceNumber: null,
                    Branches: [],
                    ShowCancelled: false
                };

                //prm.ticketInvoiceNumber = self.ticketNoInvoiceNo;

                // if (self.filterType == '1') {
                //     prm.startDate = self.startDate ? utils.jsDateTime(self.startDate) : self.startDate;
                //     prm.endDate = self.endDate ? utils.jsDateTime(self.endDate) : self.endDate;
                // } else if (self.filterType == '2') {
                //     prm.invoiceStartDate = self.startDate ? utils.jsDateTime(self.startDate) : self.startDate;
                //     prm.invoiceEndDate = self.endDate ? utils.jsDateTime(self.endDate) : self.endDate;
                // }

                prm.ShowCancelled = self.cancelledCostEstimate;

                // Get selected state first
                var selectedStates = _.filter(self.selectedBranches, function (o) {
                    return o.State == null;
                });

                var selBranches = _.filter(self.selectedBranches, function (o) {
                    return o.State != null;
                });

                // Get associated branches inside state
                selectedStates.forEach(function (p) {
                    p.StateBranches.map(function (o) {
                        prm.Branches.push(o);
                    });
                });

                // Get branches
                selBranches.map(function (o) {
                    prm.Branches.push(o.Id);
                });

                prm.Branches = _.uniq(prm.Branches);

                //self.selectedBranches.map(function(itm) {
                //    prm.branches.push(itm.Id);
                //});

                return prm;
            }
        }

    }
})();
/**
 * Cost Estimate data table view model
 * by rcnet
 */
(function () {
    'use strict';

    angular.module('app.costEstimate.view')
        .service('ceReportDataModel', ceReportDataModel)

    function ceReportDataModel(utils) {
        return function () {
            var self = this,
                defaults = {
                    CompanyName: null,
                    CompanyId: null,
                    BranchId: null,
                    BranchName: null,
                    BookedTicketIds: [],
                    CostEstimateStatus: 1,
                    CostEstimateStatusText: null,
                    WonLostCompanyId: null,
                    LostReason: null,
                    WinningCompetitorCompanyId: null,
                    WinningCompetitorCompanyName: null,
                    WinningAmount: 0,
                    Status: null,
                    HasBeenCancelled: false,
                    IsPdfGenerating: false,
                    CreatedDate: null,
                    CurrentCENumber: null,
                    CurrentCECreatedDate: null,
                    CurrentCEAmount: 0
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                let mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                self.CurrentCENumber = opts.CurrentCENumber === 0 ? '' : opts.CurrentCENumber;
                self.CurrentCEAmount = opts.CurrentCENumber === '' ? '' : utils.moneyFormat(parseFloat(self.CurrentCEAmount), 2);
                self.CurrentCECreatedDate = utils.datePickerFormatDate2(self.CurrentCECreatedDate);
                
                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.costEstimate.view')
        .controller('CeDateChooserController', CeDateChooserController);

    function CeDateChooserController(
        $mdDialog,
        ceFilterService,
        utils,
        $mdDateLocale,
        $mdToast
    ) {
        var vm = this;
        vm.model = ceFilterService;
        vm.dateFormat = utils.setDateFormat();

        vm.onCancel = onCancel;
        vm.applyFilter = applyFilter;

        vm.onChange = onChange;
        vm.filterEndDate = filterEndDate;

        $mdDateLocale.formatDate = function(date) {
            return utils.formatToLocaleDate(date, vm.dateFormat);
        }

        $mdDateLocale.parseDate = function(dateString) {
            return utils.parseToLocaleDate(dateString, vm.dateFormat);
        };

        function onChange(date) {
            vm.model.data.endDate = utils.validateDateOnChange(vm.model.data.startDate, vm.model.data.endDate, null);
        }

        function filterEndDate(date) {
            return utils.filterEndDate(date, -2, vm.model.data.startDate);
        }

        function onCancel() {
            $mdDialog.hide('cancel');
        }

        function applyFilter() {
            if (moment(vm.model.data.startDate).isAfter(moment(vm.model.data.endDate))) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('start date cannot be after end date')
                    .position('bottom right')
                );
                vm.model.data.startDate = null;
                return;
            }

            if (moment(vm.model.data.endDate).isBefore(moment(vm.model.data.startDate))) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('start date cannot be after end date')
                    .position('bottom right')
                );
                vm.model.data.endDate = null;
                return;
            }
            $mdDialog.hide(1);
        }
    }
})();

/**
 * by Rcnet
 * 4.30.2018
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .controller('WinlostDialogController', WinlostDialogController);

    /** @ngInject */
    function WinlostDialogController(
        $mdDialog,
        $q,
        $translate,
        winLostLookupService,
        winlostModel,
        ceLookupService,
        $stateParams,
        costEstimateApi,
        exceptionService,
        //competitorService,
        blockUI,
        locals) {
        var vm = this;
        // Data
        vm.winningCompaniesLookup = [];
        vm.competitorsLookup = [];
        vm.lostStates = [];
        vm.inputModel = new winlostModel();
        vm.winningCompetitorLabel = null;
        vm.winningCompanyLabel = null;
        vm.selectedCompetitor = null;
        vm.winningCompetitor = null;

        // Events
        vm.onCancel = onCancel;
        vm.onSelectCompany = onSelectCompany;
        vm.onSelectCompetitor = onSelectCompetitor;
        vm.onUpdate = onUpdate;
        vm.lostStatusChanged = lostStatusChanged;
        vm.onCreateCompetitor = onCreateCompetitor;

        activate();

        ///////
        function activate() {
            if (locals == null) alert('Locals should be set.');

            vm.inputModel.costEstimateGroupId = $stateParams.ceGrpId;

            //Populate lookups
            angular.forEach(locals.winningCompanies, function (item) {
                vm.winningCompaniesLookup.push(item);
            });

            angular.forEach(locals.competitors, function (item) {
                vm.competitorsLookup.push(item);
            });

            angular.forEach(locals.lostStates, function (item) {
                vm.lostStates.push(item);
            });

            vm.winningCompetitorLabel = 'Winning Competitor';
            vm.winningCompanyLabel = 'Winning Company';
        }

        function onCancel() {
            //branchSimpleLookups
            $mdDialog.hide('cancel');
        }

        function onSelectCompany(item) {
            vm.inputModel.winningCompany = item;
        }

        function onSelectCompetitor(item) {
            vm.inputModel.winningCompetitor = item;
        }

        function onUpdate() {
            blockUI.start('Updating Cost Estimate...');
            let payload = vm.inputModel.toBackendModel();
            costEstimateApi.markAsLost(payload)
                .then(function (resp) {
                    blockUI.stop();
                    $mdDialog.hide('ok');
                }).catch(function (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                    $mdDialog.hide('error');
                });
        }

        function lostStatusChanged() {
            vm.inputModel.recomputeModel();
        }

        function onCreateCompetitor() {
            showCompetitorDialog().then(function (resp) {
                var result = resp;
                if (_.isObject(result)) {
                    // Reloading lookups
                    blockUI.start('Refreshing data...');
                    locals.reloadWinningCompetitorLookups()
                        .then(function (data) {
                            repopulateWinningCompetitors(data);
                            
                            vm.selectedCompetitor = { Id: result.id, Name: result.Name, IsProjectMandatory: result.IsProjectMandatory };
                            blockUI.stop();
                        }).catch(function (e) {
                            console.error('Unable to refresh data for winning competitor.');
                            blockUI.stop();
                        });
                }
            }).catch(function (ex) {
                exceptionService.resolve(ex);
            });
        }

        function repopulateWinningCompetitors(data) {
            vm.competitorsLookup.length = 0;
            angular.forEach(data, function (item) {
                vm.competitorsLookup.push(item);
            });
        }

        function showCompetitorDialog() {
            let deferred = $q.defer();
            ceLookupService.loadBranchesSimple()
                .then(function (resp) {
                    $mdDialog.show({
                        templateUrl: 'app/main/costEstimate/preview/winlost/create-competitor/create-competitor-dialog.html',
                        controller: 'CreateCompetitorDialogController',
                        controllerAs: 'vm',
                        locals: {
                            branches: resp
                        },
                        multiple: true
                    }).then(function (resp) {
                        deferred.resolve(resp);
                    }, function () {
                        deferred.resolve('cancel');
                    });
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('editCeReportService', editCeReportService);

    /** @ngInject */
    function editCeReportService(
        exceptionService,
        lookupApi,
        $timeout,
        $q,
        $mdDialog,
        ceRulesService,
        costEstimateApi,
        ceEditableLineItemService,
        blockUI,
        tenantSettings,
        ceTaxRateService,
        claimsUtilService,
        localisationService,
    ) {
        var service = {
            data: {
                invId: null,
                invoiceNo: null,
                lineItems: [],
                noRateCardItems: false
            },
            fieldDef: [],
            costCodesLookup: [],
            itemCodes: [],
            rateCardItems: [],
            rawRateCardItems: null,
            disableSave: false,
            locale: tenantSettings.countryCode,
            defaultTaxRate: 0,
            isAltusSpecialEnabled: false,

            load: load,
            loadLookups: loadLookups,
            onAddRow: onAddRow,
            onColumnChange: onColumnChange,
            onRemoveRow: onRemoveRow,
            onEditDone: onEditDone,
            onEdit: onEdit,
            onToggleEdit: onToggleEdit,
            onDeleteSelected: onDeleteSelected,
            onRefreshRateCard: onRefreshRateCard,
            onCheckDescriptionControlType: onCheckDescriptionControlType,
            onEditTaxRate: onEditTaxRate,
            onEditAllTaxRate: onEditAllTaxRate,
            onChangeItemCode: onChangeItemCode
        };

        activate();

        return service;

        function activate() {
        }

        function onAddRow() {}

        /**
         * Triggered when editable-line-item component fired onToggleEvent.
         * @param {*} value
         */
        function onToggleEdit(value) {
            service.disableSave = value;
        }

        /**
         * Load invoice items
         */
        function load(invoiceItem, clientId) {
            var deferred = $q.defer();

            blockUI.start({
                message: 'Loading Client Rate Card...'
            });

            service.isAltusSpecialEnabled = claimsUtilService.isAltusSpecialEnabled();

            if (!_.isNil(invoiceItem)) {
                // Load rate card items
                var companyId = !_.isNil(invoiceItem.CompanyId) ? invoiceItem.CompanyId : clientId;

                loadRateCardItems(companyId).then(function(resp) {
                    service.data.invId = invoiceItem.Id;
                    service.data.invoiceNo = invoiceItem.InvoiceNumber;
                    service.data.lineItems.length = 0;
                    let lineItemsCloned = angular.copy(invoiceItem);

                    lineItemsCloned.LineItems.map(function(itm) {
                        itm.TicketId = itm.TicketId;
                        // Add grid specific props (mutate object)
                        ceEditableLineItemService.addExtendedProperties(itm);

                        // Set default value for property
                        itm.IEdit = false;

                        // Map item code to Id of lookup
                        if (itm.ItemCode) {
                            itm.ItemCodeObj = _.find(service.itemCodes, function(o) {
                                return o.id === itm.ItemCode;
                            });
                        }

                        let ItemId = '';
                        let ItemType = '';
                        let rateCardItemCode = onCheckDescriptionControlType(itm.Description);

                        for (let item of service.rateCardItems) {
                            if(item.hasOwnProperty('itemId') && item.id == rateCardItemCode.id){
                                ItemId = item.itemId;
                                ItemType = item.itemType;
                                break;
                            }

                            if(item.hasOwnProperty('children')){
                                for (let i of item.children) {
                                    if(i.id == rateCardItemCode.id){
                                        ItemId = i.itemId;
                                        ItemType = i.itemType;
                                        break;
                                    }
                                }
                            }
                        }

                        itm.ItemId = ItemId;
                        itm.ItemType = ItemType;

                        itm.ItemCodeDesc = itm.ItemCodeObj != null ? itm.ItemCodeObj.text : null;
                        ceRulesService.computeLineItem(itm);
                        service.data.lineItems.push(itm);
                    });

                    blockUI.stop();
                    deferred.resolve('loaded');
                }).catch(function(ex) {
                    blockUI.stop();
                    deferred.reject(ex);
                });
            } else {
                loadRateCardItems(clientId).then(function(resp) {
                    service.data.invId = null;
                    service.data.invoiceNo = null;
                    service.data.lineItems.length = 0;

                    blockUI.stop();
                    deferred.resolve('loaded');
                }).catch(function(ex) {
                    blockUI.stop();
                    deferred.reject(ex);
                });
            }

            return deferred.promise;
        }

        function onEditDone() {
            service.disableSave = false;
        }

        function onEdit() {
            service.disableSave = true;
        }

        /**
         * Remove row item in grid
         * Used by React grid editor
         */
        function onRemoveRow(id, desc) {
            let deferred = $q.defer();

            $mdDialog.show({
                templateUrl: 'app/main/costEstimate/preview/dialogs/ce-confirm-dialog/ce-confirm-dialog.html',
                controller: 'CeConfirmDialogController',
                controllerAs: 'vm',
                locals: {
                    desc: desc
                },
                multiple: true
                //skipHide: true
            }).then(function(resp) {

                // Call React method here
                window.ceCallReactDeleteLineItem(id);
                deferred.resolve('ok delete');
            }, function(resp) {
                deferred.reject();
            });

            return deferred.promise;
        }

        function onDeleteSelected(rowCount) {
            var deferred = $q.defer();
            var additionalMsg = rowCount > 1 ? rowCount + ' items' : rowCount + ' item';

            $mdDialog.show({
                templateUrl: 'app/main/costEstimate/preview/dialogs/confirm-delete-checked-items/confirm-delete-cheked-items-dialog.html',
                controller: 'ConfirmDeleteCheckedItemsDialogController',
                controllerAs: 'vm',
                locals: {
                    desc: additionalMsg
                },
                multiple: true
            }).then(function(resp) {
                // Call React method here
                window.ceCallReactDeleteLineItems();
                deferred.resolve('ok delete');
            }, function(resp) {
                deferred.reject();
            });

            return deferred.promise;
        }

        function loadLookups() {
            let promise1 = loadCostCodes();
            let promise2 = loadItemCodes();
            return $q.all([promise1, promise2]);
        }

        function loadCostCodes() {
            let promise1 = lookupApi.getCostCodes()
                .then(function(resp) {
                    service.costCodesLookup.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        service.costCodesLookup.push({
                            Id: itm.Id,
                            Description: itm.Name
                        });
                    });
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return promise1;
        }

        function loadItemCodes() {
            let promise = costEstimateApi.getItemCodes()
                .then(function(resp) {
                    service.itemCodes.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        service.itemCodes.push({
                            id: itm.Id,
                            text: itm.Name
                        });
                    });
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return promise;
        }

        function loadRateCardItems(clientId) {
            var deferred = $q.defer();

            costEstimateApi.getRateCardItems(clientId)
                .then(function(resp) {
                    if (_.isNil(resp.data)) {
                        service.data.noRateCardItems = true;
                        service.rawRateCardItems = null;
                        service.rateCardItems.length = 0;
                        deferred.resolve('No Rate card items found for this company');
                        return;
                    }
                    // Store raw rate card items lookup
                    service.data.noRateCardItems = false;
                    service.rawRateCardItems = angular.copy(resp.data);
                    mapRawRateCardToViewModel(resp.data);
                    deferred.resolve('Rate card items found for this company');
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function mapRawRateCardToViewModel(data) {
            service.rateCardItems.length = 0;

            // Get unique groups
            let items = _.uniqBy(data.Items, 'GroupName');
            let labourItems = _.uniqBy(data.LabourItems, 'GroupName');
            let packageItems = _.uniqBy(data.PackageItems, 'GroupName');
            let allowances = _.uniqBy(data.Allowances, 'GroupName');

            // Build the parent/group child relationship
            _.forEach(items, function(o) {
                let children = _.filter(data.Items, function(i) {
                    return i.GroupName === o.GroupName;
                });

                // dont include null (without parent/group)
                if (o.GroupName != null) {
                    service.rateCardItems.push({
                        text: o.GroupName,
                        children: mapChildrenToViewModel(children)
                    });
                } else {
                    mapNullGroupToParentViewModel(service.rateCardItems, children);
                }
            });

            _.forEach(labourItems, function(o) {
                let children = _.filter(data.LabourItems, function(i) {
                    return i.GroupName === o.GroupName;
                });

                // dont include null (without parent/group)
                if (o.GroupName != null) {
                    service.rateCardItems.push({
                        text: o.GroupName,
                        children: mapChildrenToViewModel(children)
                    });
                } else {
                    mapNullGroupToParentViewModel(service.rateCardItems, children);
                }
            });

            _.forEach(packageItems, function(o) {
                let children = _.filter(data.PackageItems, function(i) {
                    return i.GroupName === o.GroupName;
                });

                // dont include null (without parent/group)
                if (o.GroupName != null) {
                    service.rateCardItems.push({
                        text: o.GroupName,
                        children: mapChildrenToViewModel(children)
                    });
                } else {
                    mapNullGroupToParentViewModel(service.rateCardItems, children);
                }
            });


            _.forEach(allowances, function(o) {
                let children = _.filter(data.Allowances, function(i) {
                    return i.GroupName === o.GroupName;
                });

                // dont include null (without parent/group)
                if (o.GroupName != null) {
                    service.rateCardItems.push({
                        text: o.GroupName,
                        children: mapChildrenToViewModel(children)
                    });
                } else {
                    mapNullGroupToParentViewModel(service.rateCardItems, children);
                }
            });
        }

        function mapNullGroupToParentViewModel(vm, children) {
            children.map(function(c) {
                vm.push({
                    id: c.LineItem.replace(/\s/g, '-'),
                    itemId: c.ItemId,
                    itemType: c.ItemType,
                    text: c.ItemName,
                    groupName: c.GroupName,
                    lineItem: c.LineItem,
                    unitPrice: c.UnitPrice,
                    glAccountCode: c.GeneralLedgerAccountCode,
                    glItemCode: c.GeneralLedgerItemCode
                });
            });
        }

        function mapChildrenToViewModel(children) {
            var mappedVm = [];
            children.map(function(c) {
                mappedVm.push({
                    id: c.LineItem.replace(/\s/g, '-'),
                    itemId: c.ItemId,
                    itemType: c.ItemType,
                    text: c.ItemName,
                    groupName: c.GroupName,
                    lineItem: c.LineItem,
                    unitPrice: c.UnitPrice,
                    glAccountCode: c.GeneralLedgerAccountCode,
                    glItemCode: c.GeneralLedgerItemCode
                });
            });

            return mappedVm;
        }

        function getBundledRateCardItemRaw() {
            var arr = (service.rawRateCardItems.Allowances || [])
                .concat((service.rawRateCardItems.Items || []))
                .concat((service.rawRateCardItems.LabourItems || []))
                .concat((service.rawRateCardItems.PackageItems || []));

            return _.remove(arr, function(o) {
                return o != null
            });
        }

        /**
         * Find and Return rate card item details to grid control
         * @param {*} id
         */
        function onRefreshRateCard(id) {
            if (_.isEmpty(id))
                return null;

            var arr = getBundledRateCardItemRaw();
            var item = _.find(arr, function(o) {
                return o.LineItem.replace(/\s/g, '-') === id;
            });

            return {
                id: item.LineItem.replace(/\s/g, '-'),
                text: item.ItemName,
                itemId: item.ItemId,
                itemType: item.ItemType,
                groupName: item.GroupName,
                lineItem: item.LineItem,
                unitPrice: item.UnitPrice,
                glAccountCode: item.GeneralLedgerAccountCode,
                glItemCode: item.GeneralLedgerItemCode
            };
        }

        function onCheckDescriptionControlType(data) {
            var id = data.replace(/\s/g, '-');
            var arr = getBundledRateCardItemRaw();

            var result = service.rateCardItems.find(function (item) {
                return item.id === id || (item.children && item.children.some(child => child.id === id));
            })

            if(result){

                if (result.hasOwnProperty('children')) {
                    var rc = arr.find(function (c) {
                        return c.LineItem === data;
                    });


                    if (rc) {
                        var resultRC = result.children.find(function (c) {
                            return c.id === id;
                        });
                        
                        return {
                            type: 'rate-card-item-control',
                            id: resultRC.id 
                        }
                    }
                }

                return {
                    type: 'rate-card-item-control',
                    id: result.id
                }
            }

            var isDescItemCode = true;
            var findResult = _.find(arr, function(o) {
                if (o.id === id) {
                    isDescItemCode = false;
                    return true;
                }
           

                if (o.LineItem === data) {
                    id = o.id;
                    isDescItemCode = false;
                    return true;
                }

                id = null;
                return false;
            });

            return !_.isNil(findResult) && !isDescItemCode ? {
                type: 'rate-card-item-control',
                id: id
            } : {
                type: 'desc-item-code-control',
                id: null
            };
        }

        function onColumnChange(columnName, id) {
            $timeout(function() {
                let rowItem = _.find(service.data.lineItems, function(o) {
                    return o.Id === id;
                });

                ceRulesService.computeLineItem(rowItem);
            }, 0);
        }

        function onEditTaxRate(data) {
            ceTaxRateService.showTaxRate(data);
        }

        /**
         * Apply tax rate to all selected items
         * @param {*} data
         */
        function onEditAllTaxRate(data) {
            ceTaxRateService.showTaxRateAndApplyAll(data);
        }

        function onChangeItemCode(data) {
            if(_.isNil(data) || _.isEmpty(data)){
                return null;
            }
            var arr = getBundledRateCardItemRaw();
            var item = _.find(arr, function(o) {
                return o.GeneralLedgerItemCode === data;
            });
            if(!item) {
                return null;
            }
            return item.GeneralLedgerAccountCode;
        }
    }
})();

/**
 * Invoice Preview Configuration
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceUtilsService', ceUtilsService);

    /** @ngInject */
    function ceUtilsService($q,
        exceptionService,
        moment
    ) {
        var service = {
            getStartOfWeek: getStartOfWeek,
            getEndOfWeek: getEndOfWeek
        };

        activate();

        return service;
        //////

        function activate() {}

        function getStartOfWeek(startOfPeriod, fromTicketBilling) {
            let start = moment(startOfPeriod);
            let isoWeekStart = start.startOf('isoWeek');
            let lastWeek = isoWeekStart.weekday(-7);
            let result = null;
            if(fromTicketBilling){
              result = lastWeek.add(7, 'd').format('YYYY-MM-DD');
            }else{
              result = lastWeek.format('YYYY-MM-DD');
            }
            return new Date(result);
        }

        function getEndOfWeek(startOfPeriod, fromTicketBilling) {
            let start = moment(startOfPeriod);
            let isoWeekStart = start.startOf('isoWeek');
            let lastWeek = isoWeekStart.weekday(-7);
            let result = null;
            if(fromTicketBilling){
              result = lastWeek.add(13, 'd').format('YYYY-MM-DD');
            }else{
              result = lastWeek.add(6, 'd').format('YYYY-MM-DD');
            }
            return new Date(result);
        }

    }
})();

/**
 * Invoice Tax rate service
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceTaxRateService', ceTaxRateService);

    /** @ngInject */
    function ceTaxRateService($q,
        exceptionService,
        ticketsApi,
        $mdDialog,
        blockUI,
        invoiceApi,
        ceRulesService,
        utils
    ) {

        var service = {
            showTaxRate: showTaxRate,
            showTaxRateAndApplyAll: showTaxRateAndApplyAll
        };

        activate();

        return service;
        //////

        function activate() { }

        /**
         * Show Tax rate dialog
         */
        function showTaxRate(data) {
            let deferred = $q.defer();
            let locals = angular.copy(data);

            $mdDialog.show({
                templateUrl: 'app/main/costEstimate/preview/dialogs/tax-rate-dialog/tax-rate-dialog.html',
                controller: 'TaxRateDialogController',
                controllerAs: 'vm',
                multiple: true,
                locals: locals,
                escapeToClose: false
            }).then(function (response) {

                // This will call react global func (workaround here! tsk)
                window.updateTaxRate(response);
                deferred.resolve('ok');

            }, function (resp) {
                //alert('Cancel');
            });
            return deferred.promise;
        }

        /**
         * Show Tax rate and apply all (use global tax rate)
         */
        function showTaxRateAndApplyAll(data) {
            let deferred = $q.defer();
            let locals = angular.copy(data);

            $mdDialog.show({
                templateUrl: 'app/main/costEstimate/preview/dialogs/tax-rate-dialog/tax-rate-dialog.html',
                controller: 'TaxRateDialogController',
                controllerAs: 'vm',
                multiple: true,
                locals: locals,
                escapeToClose: false
            }).then(function (response) {
                
                // Re-compute using the Global tax rate for all the selected items
                _.forEach(locals.ItemsToApply, function (itm) {
                    itm.TaxRate = response.CombinedTaxRate;
                    itm.CityTaxRate = response.CityTaxRate;
                    itm.CountyTaxRate = response.CountyTaxRate;
                    itm.StateSalesTaxRate = response.StateSalesTaxRate;
                    itm.SpecialTaxRate = response.SpecialTaxRate;
                    ceRulesService.computeLineItem(itm)
                });

                // Contact react to update all selected items
                window.updateTaxRateForAllSelectedItems(locals.ItemsToApply);
                deferred.resolve('ok');

            }, function (resp) {
                //alert('Cancel');
            });
            return deferred.promise;
        }

    }
})();
/**
 * Invoice Mark as Reviewed or Not Reviewed service
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceTaggingService', ceTaggingService);

    /** @ngInject */
    function ceTaggingService($q,
        exceptionService,
        costEstimateApi,
        $state,
        $mdToast
    ) {

        var service = {
            toggleTag: toggleTag,
            tagAsPrimary: tagAsPrimary
        };

        activate();

        return service;
        //////

        function activate() { }

        function toggleTag(id, ceList) {
            let deferred = $q.defer();
            let invData = findInvoice(id, ceList);

            costEstimateApi.toggleReview(id) //, invData.IsReviewed)
                .then(function (resp) {
                    let msg = resp.data ? 'Mark as reviewed' : 'Cost Estimate Unreviewed';
                    invData.IsReviewed = resp.data;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msg)
                            .position('bottom right')
                            .hideDelay(4000)
                    );

                    return deferred.resolve('Tagging successfull');
                }).catch(exceptionService.resolve);

            return deferred.promise;
        }

        function findInvoice(id, invoiceList) {
            let invData = _.find(invoiceList, function (o) {
                return o.Id === id;
            });

            return invData;
        }

        function tagAsPrimary(id, costEstimates) {
            let deferred = $q.defer();

            costEstimateApi.setPrimary(id)
                .then(function (resp) {
                    let costEstimateNumber;
                    angular.forEach(costEstimates, function (ce) {
                        if (ce.Id == id) {
                            ce.IsPrimary = true;
                            costEstimateNumber = ce.InvoiceNumber;
                        } else {
                            ce.IsPrimary = false;
                        }
                    });

                    deferred.resolve(costEstimateNumber);

                }).catch(exceptionService.resolve);

            return deferred.promise;
        }
    }
})();

/**
 * State service
 * Note: Deprecated for now
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceStateService', ceStateService);

    /** @ngInject */
    function ceStateService() {
        //const FINALISE = 2;

        var service = {
            getStatusColor: getStatusColor
        };

        activate();

        return service;
        //////

        function activate() { }

        ///////
        function getStatusColor(status) {
            // switch (status) {
            //     case 1: // Active
            //         return {'md-green-400-bg': (false), 'md-red-500-bg': (false),  'md-blue-500-bg': (true), 'grey-50-fg': (true) };
            //     case 2:  // Won
            //     case 4:
            //         return {'md-green-400-bg': (true), 'md-red-500-bg': (false),  'md-blue-500-bg': (false),  'grey-50-fg': (true) };
            //     case 3: // Lost
            //     case 5:
            //     case 6:
            //         return { 'md-green-400-bg': (false), 'md-red-500-bg': (true),  'md-blue-500-bg': (false),'grey-A100-fg': (true) }; // md-blue-grey-400-bg
            // }

            return status;
        }
    }
})();
/**
 * Report Sidenav service
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceSideNavService', ceSideNavService);

    /** @ngInject */
    function ceSideNavService($q,
        $timeout,
        utils,
        exceptionService,
        branchApi,
        signalRService,
        $mdDialog,
        invoiceApi,
        costEstimateApi,
        ceFilterModel,
        ceLookupService,
        ceLoaderService,
        ceGroupInfoService,
        $log) {

        var service = {
            branchLookups: ceLookupService.data.branchLookups, // For removal
            clientLookups: ceLookupService.data.clientLookups, // For removal
            rateCardLookups: ceLookupService.data.rateCardLookups,
            data: new ceFilterModel(),
            hasRateCard: true,
            showRateCardItems: showRateCardItems,
            processingInvoice: false,
            generationMessage: null,
            isLocked: false, // Temp only
            setMessageTo: setMessageTo,
            onRefreshContent: angular.noop, // output event
            clearPreview: clearPreview,
            setToNormalState: setToNormalState, // inbound event
            isOverrideInvoiceDate: false,
            isGenerationOccured: false,
            loadSingleInvoicePreview: loadSingleInvoicePreview,
            resetOnError: resetOnError,
            regenerateCostEstimate: regenerateCostEstimate,
            refreshUI: angular.noop, // output event
            lock: lock,
            setup: setup
        };
        var progressMessages = [
            'Generating cost estimate preview...',
            'Fetching cost estimate preview...',
            'Loading cost estimate preview...',
            'Loading parameters...'
        ];

        const FINALIZED = 2;

        activate();

        return service;
        //////

        function activate() { }

        /**
         * Setup the navigation service based on the data config
         * @param {} data
         */
        function setup(data) {
            if (ceGroupInfoService.data.Status === FINALIZED || ceGroupInfoService.data.HasBeenCancelled) {
                lock(true);
            }
            service.data.selectedRate = null;
        }

        function lock(flag) {
            $timeout(function () {
                service.isLocked = flag;
            }, 100);
        }

        function resetOnError() {
            clearPreview();
            ceLoaderService.reset();
            loadSingleInvoicePreview(null);
        }

        /**
         * Temp only
         */
        function clearPreview() {
            let deferred = $q.defer();

            $q.when(function () {
                $timeout(function () {
                    //setToNormalStateAndUnlock();
                    setToNormalState();
                    service.isGenerationOccured = false;
                    service.data.reset();
                }, 0);

                deferred.resolve('clearOk');
            }());

            return deferred.promise;
        }

        function loadSingleInvoicePreview(id) {
            service.data.setSingleInvoicePreview(id);
        }

        function regenerateCostEstimate(id) {
            let deferred = $q.defer();
            setActionToGenerating();
            let params = service.data.toBackendModel();
            return costEstimateApi.regenerate(id, params.RateCardId)
                .then(function (resp) {
                    setActionToLoadingCE();
                    deferred.resolve(resp);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function setActionToReady() {
            $timeout(function () {
                service.processingInvoice = false;
            }, 0);
        }

        function setActionToLoadingCE() {
            $timeout(function () {
                setMessageTo('loadingCostEstimate');
            }, 0);
        }

        function setActionToDownload() {
            $timeout(function () {
                setMessageTo('downloading');
            }, 0);
        }

        function setActionToGenerating() {
            $timeout(function () {
                setMessageTo('generating');
                service.isLocked = true;
            }, 50);
        }

        function setToNormalState() {
            // Force angular digest
            $timeout(function () {
                //service.isLocked = false;
                if (ceGroupInfoService.data.Status == 1 && !ceGroupInfoService.data.HasBeenCancelled) lock(false);
                service.processingInvoice = false;
            });
        }

        function setMessageTo(mode) {
            service.processingInvoice = true;
            switch (mode) {
                case 'downloading':
                    service.generationMessage = progressMessages[1];
                    break;
                case 'loadingCostEstimate':
                    service.generationMessage = progressMessages[2];
                    break;
                case 'generating':
                    service.generationMessage = progressMessages[0];
                    break;
            }
        }

        function safeSend(fn) {
            signalRService.ping()
                .then(function (resp) {
                    (fn || angular.noop)();
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                });
        }

        function showRateCardItems() {
            return service.hasRateCard && ceGroupInfoService.data.Status === 1;
        }

    }
})();

/**
 * Invoice rules service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceRulesService', ceRulesService);

    /** @ngInject */
    function ceRulesService(
        localisationService,
        tenantSettings
    ) {
        var service = {
            computeLineItem: computeLineItem,
            computeTotalFigures: computeTotalFigures,
            getCombinedTaxRate: getCombinedTaxRate
        };

        activate();

        return service;

        function activate() {}

        /**
         * Compute line items
         */
        function computeLineItem(itm) {
            //sanitize(itm);
            compute(itm);
        }

        function sanitize(itm) {
            // Clean invoice line items
            itm.Quantity = parseFloat(itm.Quantity) === -0 ? 0 : parseFloat(itm.Quantity);
            itm.UnitPriceExcludingTax = parseFloat(itm.UnitPriceExcludingTax) === -0 ? 0 : parseFloat(itm.UnitPriceExcludingTax);
            itm.UnitTax = parseFloat(itm.UnitTax) > 0 ? parseFloat(itm.UnitTax).toFixed(2) : null;
        }

        function compute(itm) {
            // Get tax rate to use
            if (_.isFinite(parseFloat(itm.UnitPriceExcludingTax)) && _.isFinite(parseFloat(itm.Quantity))) {
                var taxAmt, taxRate, unitTax;


                if (parseFloat(itm.Quantity) < 0) {
                    itm.UnitPriceExcludingTax = Math.abs(itm.UnitPriceExcludingTax);
                }

                taxRate = (itm.TaxRate / 100);
                unitTax = parseFloat(itm.UnitPriceExcludingTax) * taxRate;
                taxAmt = (parseFloat(itm.Quantity) * parseFloat(itm.UnitPriceExcludingTax)) * taxRate;


                itm.UnitTax = unitTax.toFixed(2); //taxAmt.toFixed(2);
                itm.TotalTax = taxAmt.toFixed(2);
                itm.Amount = parseFloat((parseFloat(itm.Quantity) * parseFloat(itm.UnitPriceExcludingTax))).toFixed(2);

            } else {
                itm.Amount = parseFloat(0).toFixed(2);
                itm.UnitTax = parseFloat(0).toFixed(2);
                itm.TotalTax = parseFloat(0).toFixed(2);
            }
        }

        function computeTotalFigures(itm, totalObj) {
            totalObj.SubTotal = parseFloat(totalObj.SubTotal) + parseFloat(itm.Amount);
            //totalObj.TotalTax = parseFloat(totalObj.TotalTax) + parseFloat(itm.UnitTax);
            totalObj.TotalTax = parseFloat(totalObj.TotalTax) + parseFloat(itm.TotalTax);
            totalObj.GrandTotal = parseFloat(totalObj.SubTotal) + parseFloat(totalObj.TotalTax);
        }

        /**
         * For US client
         * @param {*} city
         * @param {*} county
         * @param {*} state
         * @param {*} special
         */
        function getCombinedTaxRate(city, county, state, special) {
            return parseFloat(city) + parseFloat(county) + parseFloat(state) + parseFloat(special);
        }
    }
})();

/**
 * OBSOLETE!!!
 * Invoice Preview Configuration
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('cePreviewConfigService', cePreviewConfigService);

    /** @ngInject */
    function cePreviewConfigService($q,
        exceptionService,
        localStorageService,
        cePreviewCfgModel,
        ceFilterHasherService
    ) {
        var service = {
            addInvoiceList: addInvoiceList,
            getInvoiceList: getInvoiceList,
            addFilters: addFilters,
            getStatus: getStatus,
            getFilters: getFilters,
            setStatus: setStatus,
            reset: reset,
            getFilterHash: getFilterHash,
            getFilterFormData: getFilterFormData,
            resetCacheData: resetCacheData
        };

        const InvoiceListKey = 'urn:invoice:reportPreview';
        const InvoiceCfgKey = 'urn:invoice:cfgPreview';

        activate();

        return service;
        //////

        function activate() {
            initCfgModel();
        }

        function initCfgModel() {
            let cfg = localStorageService.get(InvoiceCfgKey);

            if (!cfg) {
                createModel();
            }
        }

        function reset() {
            createModel();
        }

        function resetCacheData() {
            localStorageService.remove(InvoiceListKey);
        }

        function createModel() {
            let model = new cePreviewCfgModel();
            localStorageService.set(InvoiceCfgKey, model);
        }

        function addInvoiceList(data) {
            localStorageService.set(InvoiceListKey, data);
        }

        function getInvoiceList() {
            initCfgModel();
            return localStorageService.get(InvoiceListKey);
        }

        function addFilters(data) {
            let cfg = localStorageService.get(InvoiceCfgKey);
            cfg.filters = data;
            localStorageService.set(InvoiceCfgKey, cfg);
        }

        function getStatus() {
            initCfgModel();
            let cfg = localStorageService.get(InvoiceCfgKey);
            return !!cfg.status ? cfg.status : 'ready';
        }

        function setStatus(status) {
            let cfg = localStorageService.get(InvoiceCfgKey);
            cfg.status = status;
            localStorageService.set(InvoiceCfgKey, cfg);
        }

        function getFilters() {
            initCfgModel();
            let cfg = localStorageService.get(InvoiceCfgKey);
            return !!cfg.filters ? cfg.filters : null;
        }

        /**
         * Returns filter token hash
         */
        function getFilterHash() {
            let cfg = localStorageService.get(InvoiceCfgKey);
            return ceFilterHasherService.hash(cfg.filters);
        }

        function getFilterFormData() {
            let filterModel = {
                BranchIds: [],
                CompanyIds: [],
                StartDate: null,
                EndDate: null
            };

            let filtersParams = getFilters();

            // Branches
            if (angular.isArray(filtersParams.branches)) {
                filtersParams.branches.map(function(itm) {
                    filterModel.BranchIds.push(itm.Id);
                });
            }

            // Client
            if (angular.isArray(filtersParams.clients)) {
                filtersParams.clients.map(function(itm) {
                    filterModel.CompanyIds.push(itm.Id);
                });
            }

            filterModel.StartDate = filtersParams.startDate;
            filterModel.EndDate = filtersParams.endDate;

            return filterModel;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceManagerService', ceManagerService);

    /** @ngInject */
    function ceManagerService(
        exceptionService,
        ceDataAdapterService,
        _,
        $timeout,
        ceSideNavService,
        ceEditTicketService,
        costEstimateApi,
        ceTaggingService,
        ceEditTimesheetService,
        ceLineItemService,
        msgboxService,
        ToastService,
        ceDeletePreviewService,
        blockUI
    ) {
        var service = {
            grid: {},
            gridInfo: {
                totalItems: 0,
                rawTotalItemCount: 0,
                inProgress: false,
                isFiltered: false
            },
            contentLoading: true,
            showDetails: false,
            isInPreviewCancelled: false,
            clearContent: clearContent,
            editTicket: editTicket,
            editTimesheet: editTimesheet,
            markAsReviewed: markAsReviewed,
            deleteInvoice: deleteInvoice,
            setAsPrimary: setAsPrimary,
            onReady: angular.noop,
            onDownloadComplete: angular.noop,
            setClientSideFilter: setClientSideFilter,
            customGridSearchComponentApi: {},
            refreshGrid: refreshGrid,
            getPrimaryCe: getPrimaryCe,
            IsPdfGenerating: false
        };

        var clientSideFilterText = null;
        const TOAST_DELAY = 6000;

        activate();

        return service;

        function activate() {
            setupGrid();
        }

        function setupGrid() {
            service.grid.api = {};
            service.grid.data = []; // Reference to grid Data
            service.searchText;
            service.grid.onCompleted = onCompleted;
            service.grid.onError = onError;
            service.grid.onInit = onInit;
            service.grid.onDataFilter = onDataFilter;
            service.grid.onDataLoading = onDataLoading;
            service.grid.onDataLoadingCompleted = onDataLoadingCompleted;
            service.grid.onSearch = onSearch;
            service.grid.onReady = onReady;
            service.grid.editInvoice = editInvoiceLineItem;
            service.grid.generateCostEstimatePdf = generateCostEstimatePdf;
            service.grid.allowCustomClientSideFiltering = true;
            service.grid.onCustomClientSideFiltering = onCustomClientSideFiltering;

            function onInit() {
                service.grid.data.length = 0;
                service.grid.api.setHubSourceAdapter(ceDataAdapterService);
            }

            /**
             * Triggers only when Grid component is done initializing
             * This is the safe entry point to issue API commands to Alloc8 Grid
             */
            function onReady() {
                service.onReady();
            }

            /**
             * Loading of partial data
             * Note: Line items for tax breakdown if US client
             * Then line item editor will ignore the breakdown property
             */
            function onCompleted(data) {
                data.sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate));

                ceSideNavService.hasRateCard = _.isEmpty(data);
                prepareDataForSorting(data);
                service.showDetails = ceSideNavService.data.showDetails;
                service.grid.data.length = 0;
                angular.forEach(data, function(itm) {
                    itm['RateCardName'] = itm.RateCard && itm.RateCard.Name ? itm.RateCard.Name : null;
                    ceLineItemService.flattenLineItems(itm.LineItems);
                    if (!_.isNil(itm['RateCardName'])) {
                        ceSideNavService.hasRateCard = true;
                    }
                    service.grid.data.push(itm);
                });
                service.onDownloadComplete();
            }

            /**
             * Fires when grid needs to refresh data
             */
            function onDataFilter() {
                let filterData = ceSideNavService.data.toBackendModel();
                filterData['showOnlyCancelled'] = parseInt(service.isInPreviewCancelled) == 1; // 0 means show only active
                return filterData;
            }

            function onDataLoading() {
                populateGridInfo();
            }

            /**
             * Fires when downloading or loading of full dataset is finish
             */
            function onDataLoadingCompleted() {
                service.contentLoading = false;
                ceSideNavService.setToNormalState();
                populateGridInfo();
            }

            function populateGridInfo() {
                let data = service.grid.api.getGridInfo();
                service.gridInfo.totalItems = data.totalItems;
                service.gridInfo.rawTotalItemCount = data.rawTotalItemCount;
                service.gridInfo.inProgress = data.inProgress;
                service.gridInfo.isFiltered = data.isFiltered;
            }

            function onSearch(value) {
                (service.grid.api.search || angular.noop)(value);
            }

            function onError(ex) {
                msgboxService.show('Oops something happened', 'Server Error');
                service.grid.api.stop();
                ceSideNavService.resetOnError();
            }

            function editInvoiceLineItem(id) {
                let invoiceItem = _.find(service.grid.data, function(o) {
                    return o.Id === id;
                });

                // Update TOTAL Summary here!!!!
                ceLineItemService.showEditor(id, invoiceItem)
                    .then(function(resp) {
                        // Refresh grid
                        service.grid.api.refresh();
                    }).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function generateCostEstimatePdf(costEstimateId) {
                try {
                    var previewCostEstimateItem = service.grid.data.filter((ce) => ce.Id === costEstimateId);

                    if (previewCostEstimateItem.length > 0) {
                        previewCostEstimateItem[0].IsPdfGenerating = true;
                    }
                } catch (ex) {
                    exceptionService.resolve(ex);
                }

                blockUI.start('Preparing cost estimate for download...');
                costEstimateApi.generateCostEstimatePdf(costEstimateId).then(function(resp) {
                    blockUI.stop();
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                    blockUI.stop();
                });
            }
        }

        function prepareDataForSorting(data) {
            if (angular.isArray(data) && data.length > 0) {

                // Tweak the InvoiceDate of the primary
                _.forEach(data, function(o) {
                    o['sortValue'] = new Date(o.CreatedDate);
                });

                let primaryCE = _.find(data, function(o) {
                    return o.IsPrimary == true;
                });

                if (primaryCE) {
                    let year = (new Date()).getFullYear() + 5;
                    primaryCE.sortValue = new Date(year, 1, 1);
                }
            }
        }

        function clearContent() {
            $timeout(function() {
                service.grid.api.clearAll();
            });
        }

        function editTicket(id, ticketNo, invId) {
            ceEditTicketService.editTicket(id, ticketNo, invId);
        }

        function deleteInvoice(id) {
            let deleteInvoice = _.find(service.grid.data, function(o) {
                return o.Id === id;
            });
            ceDeletePreviewService.deletePreview(deleteInvoice)
                .then(function(resp) {
                    service.grid.api.refresh();
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function markAsReviewed(id, toggleValue) {
            setInvoiceToBusy(id, true);
            ceTaggingService.toggleTag(id, service.grid.data, toggleValue)
                .then(function(resp) {
                    setInvoiceToBusy(id, false);
                    (service.customGridSearchComponentApi.forceTriggerSearch || angular.noop)();
                });
        }

        function setAsPrimary(id) {
            setInvoiceToBusy(id, true);
            ceTaggingService.tagAsPrimary(id, service.grid.data)
                .then(function(resp) {

                    setInvoiceToBusy(id, false);
                    prepareDataForSorting(service.grid.data);
                    ToastService.toast('Cost Estimate # ' + resp + ' was set to Primary.', TOAST_DELAY);
                });
        }

        function setInvoiceToBusy(id, flag) {
            let invoice = _.find(service.grid.data, function(o) {
                return o.Id == id;
            });

            invoice.IsBusy = flag;
        }

        function editTimesheet(id, invId) {
            ceEditTimesheetService.editTimesheet(id, invId);
        }

        function setClientSideFilter(filter) {
            $timeout(function() {
                clientSideFilterText = filter;
                (service.customGridSearchComponentApi.forceTriggerSearch || angular.noop)();
            });
        }

        function onCustomClientSideFiltering(data) {
            if (clientSideFilterText == null || clientSideFilterText == 'all')
                return data;

            var result = _.filter(data, function(itm) {
                return itm.IsReviewed == (clientSideFilterText == 'byReviewed');
            });

            return result;
        }

        function refreshGrid() {
            service.grid.api.refresh();
        }

        function getPrimaryCe() {
            let costEstimate = _.find(service.grid.data, function(o) {
                return o.IsPrimary == true;
            });
            return costEstimate;
        }
    }
})();
/**
 * Invoice Finalise service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceLoaderService', ceLoaderService);

    /** @ngInject */
    function ceLoaderService($q,
        exceptionService
    ) {
        var service = {
            isLoadSingleInvoice: false,
            invoiceId: null,
            loadSingleInvoice: loadSingleInvoice,
            reset: reset
        };

        activate();

        return service;
        //////

        function activate() {}

        function reset() {
            service.isLoadSingleInvoice = false;
            service.invoiceId = null;
        }

        function loadSingleInvoice(id) {
            service.isLoadSingleInvoice = !!id;
            service.invoiceId = id;
        }
    }
})();
/**
 * Invoice Line-Item service
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceLineItemService', ceLineItemService);

    /** @ngInject */
    function ceLineItemService($q,
        $mdDialog,
        editCeReportService,
        blockUI,
        costEstimateApi,
        ceRulesService
    ) {

        var service = {
            showEditor: showEditor,
            flattenLineItems: flattenLineItems
        };

        activate();

        return service;
        //////

        function activate() { 
        }

        /**
         * For Cost Estimate Preview
         * @param {id} id invoice id
         * @param {invoiceItem} invoiceItem object 
         */
        function showEditor(id, invoiceItem) {
            let deferred = $q.defer();
            editCeReportService.load(invoiceItem, null).then(function (resp) {
                $mdDialog.show({
                    templateUrl: 'app/main/costEstimate/preview/dialogs/edit-ce/ce-edit-line-item-dialog.html',
                    controller: 'CeEditLineItemDialogController',
                    controllerAs: 'vm',
                    skipHide: true,
                    escapeToClose: false
                }).then(function (response) {
                    blockUI.start({ message: 'Updating cost estimate...' });

                    let lineItems = [],
                        totalSummary = { Taxes:[], SubTotal: 0, TotalTax: 0, GrandTotal: 0 }; // TODO: Put this code to invoice-rules service

                    // Create server model
                    // Note: Breakdown is only needed in US client
                    response.map(function (itm) {
                        lineItems.push({
                            Id: _.startsWith(itm.Id, 'new') ? null : itm.Id,  // Identify NEW record here (new record has a prefix of "new-<guid>")
                            TicketId: itm.TicketId,
                            TicketNumber: itm.TicketNumber,
                            Description: itm.Description,
                            CostCode: itm.CostCode,
                            ItemCode: itm.ItemCode,
                            ItemId: itm.ItemId,
                            ItemType: itm.ItemType,
                            AddOnType: itm.AddOnType,
                            Quantity: itm.Quantity,
                            UnitPriceExcludingTax: itm.UnitPriceExcludingTax,
                            UnitTax: itm.UnitTax,
                            TaxRate: itm.TaxRate,
                            SequenceNo: itm.SequenceNo,
                            IsHistorical: itm.IsHistorical,
                            CreatingUserId: itm.CreatingUserId,
                            Amount: itm.Amount,
                            Breakdown: {
                                CityTaxRate: itm.CityTaxRate,
                                CountyTaxRate: itm.CountyTaxRate,
                                StateSalesTaxRate: itm.StateSalesTaxRate,
                                SpecialTaxRate: itm.SpecialTaxRate
                            }
                        });

                        // if (itm.Description != null && itm.Quantity != null && itm.UnitPriceExcludingTax != null && itm.UnitTax != null)
                        //     invoiceRulesService.computeTotalFigures(itm, totalSummary);
                        if (!isLineComment(itm))
                            ceRulesService.computeTotalFigures(itm, totalSummary);
                    });

                    costEstimateApi.addLineItem(id, lineItems)
                        .then(function (resp) {
                            // Re-map updated line items
                            invoiceItem.LineItems.length = 0;
                            response.map(function (itm) {
                                //flattenModel(itm);
                                invoiceItem.LineItems.push(itm)
                            });

                            deferred.resolve(totalSummary);
                            blockUI.stop();
                        }).catch(function (ex) {
                            deferred.reject(ex);
                            blockUI.stop();
                        });

                }, function (resp) {
                    //alert('Cancel');
                });
            });

            return deferred.promise;
        }

        function isLineComment(item) {
            return (item.Description == null || ((item.Description.toUpperCase() == 'SUPPLY OF TRAFFIC CONTROLLERS AT') || (item.Quantity == 0 && item.UnitPriceExcludingTax <= 0)));
        }

        function flattenLineItems(lineItems) {
            _.forEach(lineItems, function (itm) {
                flattenModel(itm);
            });
        }

        // Flatten model
        function flattenModel(lineItem) {
            lineItem.CityTaxRate = lineItem.Breakdown == null ? 0 : lineItem.Breakdown.CityTaxRate;
            lineItem.CountyTaxRate = lineItem.Breakdown == null ? 0 : lineItem.Breakdown.CountyTaxRate;
            lineItem.StateSalesTaxRate = lineItem.Breakdown == null ? 0 : lineItem.Breakdown.StateSalesTaxRate;
            lineItem.SpecialTaxRate = lineItem.Breakdown == null ? 0 : lineItem.Breakdown.SpecialTaxRate;
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('ceHubService', ceHubService);

    /** @ngInject */
    function ceHubService(
        $mdToast,
        $log,
        signalRService,
        $rootScope,
        exceptionService,
        ceManagerService,
        ceSideNavService,
        ceFilterHasherService
    ) {
        const TOASTR_DELAY = 5000;

        var service = {
            registerSignalRCallback: registerSignalRCallback
        };

        var isInitialized = false;

        return service;

        function registerSignalRCallback() {
            if (signalRService.isConnected) {
                registerClientHubMethods();
            } else {
                $rootScope.$on('signalR_OnConnected', function() {
                    if (!isInitialized) {
                        registerClientHubMethods();
                        isInitialized = true;
                    }
                });
            }
        }

        function registerClientHubMethods() {
            signalRService.messageHub.on('syncUpdateInvoicePreview', function(data) {
                $log.log('Message Hub: Invoice Preview synchronization triggered.');
                ceManagerService.grid.api.refresh();
            });

            signalRService.messageHub.on('invoiceGeneratorError', function(data) {

                if (data.status === 'QueueError') {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Unable to proceed, Queue server error.')
                        .position('bottom right')
                        .hideDelay(TOASTR_DELAY)
                    );
                    exceptionService.resolve(data.error);
                    ceSideNavService.setToNormalStateAndUnlock();
                } else {
                    let filters = ceSideNavService.data.toBackendModel();

                    if (ceFilterHasherService.IsHashEqual(filters, data.hash)) {
                        exceptionService.resolve(data.error);
                        ceSideNavService.setToNormalStateAndUnlock();
                    }
                }
            });

            /**
             * Fires when processing of invoice from server is done
             */
            signalRService.messageHub.on('syncInvoiceDownloadData', function(data) {
                $log.log('Message Hub: Invoice Preview downloading data.');

                // Check if hash broadcasted by server is the same as the hash filter we have now
                // if true then download resource :)
                let filters = ceSideNavService.data.toBackendModel();
                $log.debug('Invoice: Server requested to refresh invoice');

                if (ceFilterHasherService.IsHashEqual(filters, data.hash) && data.status === 'HasData') {
                    $log.debug('Invoice: Proceeding to download invoice data.');

                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Checking Invoice/s For PDF Generation...')
                        .position('bottom right')
                        .hideDelay(TOASTR_DELAY)
                    );

                    ceSideNavService.setMessageTo('downloading');

                    if (ceManagerService.grid.api.refresh) {
                        ceManagerService.grid.api.refresh();
                    }
                } else if (ceFilterHasherService.IsHashEqual(filters, data.hash)) {
                    ceSideNavService.setToNormalStateAndUnlock();
                }
            });

            signalRService.messageHub.on('invoiceReportStatus', function(data) {
                let filters = ceSideNavService.data.toBackendModel();

                if (ceFilterHasherService.IsHashEqual(filters, data.args.Hash)) {
                    if (data.args.Status === 'PdfCompleted') {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('PDF successfully generated.')
                            .position('bottom right')
                            .hideDelay(TOASTR_DELAY)
                        );
                    } else if (data.args.Status === 'PdfGenError') {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Error generating invoice PDF.')
                            .position('bottom right')
                            .hideDelay(TOASTR_DELAY)
                        );
                    } else if (data.args.Status === 'ProgressReport') {
                        $log.info(data.args.StatusMessage);
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.args.StatusMessage)
                            .position('bottom right')
                            .hideDelay(TOASTR_DELAY)
                        );
                    }
                }
            });
        }

    };
})();

(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceGroupInfoService', ceGroupInfoService);

    /** @ngInject */
    function ceGroupInfoService(
        $q,
        _,
        costEstimateApi,
        ceGroupInfoModel
    ) {
        var service = {
            data: new ceGroupInfoModel(),
            fetchData: fetchData
        };

        activate();

        return service;

        function activate() {}

        function fetchData(groupId) {
            let deferred = $q.defer();
            return costEstimateApi.getGroupDetail(groupId)
                .then(function(resp) {
                    service.data.map(resp.data);
                    deferred.resolve(service.data);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });
        }
    }
})();

/**
 * Invoice Finalise service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceFinaliseService', ceFinaliseService);

    /** @ngInject */
    function ceFinaliseService($q,
        exceptionService,
        costEstimateApi,
        ceLoaderService
    ) {
        //const FINALISE = 2;

        var service = {
            finalise: finalise
        };

        activate();

        return service;
        //////

        function activate() {}

        function finalise(groupId) {
            let deferred = $q.defer();

            if (!groupId)
                deferred.reject('Error in finalise parameter id.');

            costEstimateApi.finalise(groupId)
                .then(function(resp) {
                    ceLoaderService.reset();
                    deferred.resolve('ok');
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

    }
})();
/**
 * Invoice Filter State service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceFilterStateService', ceFilterStateService);

    /** @ngInject */
    function ceFilterStateService($q,
        exceptionService,
        dataCacheService2
    ) {
        var service = {
            getFilter: getFilter,
            addFilter: addFilter,
            clear: clear
        };

        var cacheObj = dataCacheService2.getInstance();

        activate();


        return service;
        //////

        function activate() {
            cacheObj.group('invoice');
        }

        function getFilter() {
            let cacheData = cacheObj.getCache('urn:invoice:filter');
            return $q.when(cacheData);
        }

        function addFilter(obj) {
            cacheObj.updateCache('urn:invoice:filter', obj);
        }

        function clear() {
            cacheObj.remove('urn:invoice:filter');
        }
    }
})();
/**
 * Invoice filter hash service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceFilterHasherService', ceFilterHasherService);

    /** @ngInject */
    function ceFilterHasherService(
        exceptionService,
        $log,
        _
    ) {

        var service = {
            hash: hash,
            IsHashEqual: IsHashEqual
        };

        activate();

        return service;
        ///////

        function activate() {}

        function hash(cfg) {
            let fieldValues;

            if (cfg) {
                fieldValues = cfg.StartDate + ',' + cfg.EndDate + ',' + getClientIdsToString(cfg.CompanyIds) + ',' + getBranchesToString(cfg.BranchIds);
                return fieldValues.hashCode();
            }
        }

        /**
         * Hash equality checker
         */
        function IsHashEqual(cfg, hashvalue) {
            let h = hash(cfg);
            return (parseInt(h) === parseInt(hashvalue));
        }

        function getClientIdsToString(clients) {
            let str = '';
            if (angular.isArray(clients)) {
                clients.map(function(itm) {
                    //str = str + "'" + itm.Id + "',";
                    str = str + "'" + itm + "',";
                });

                return str.substring(0, str.length - 1);
            }
            return '';
        }

        function getBranchesToString(branches) {
            let branchStr = '';
            if (angular.isArray(branches)) {
                branches.map(function(itm) {
                    //branchStr = branchStr + "'" + itm.Id + "',";
                    branchStr = branchStr + "'" + itm + "',";
                });

                return branchStr.substring(0, branchStr.length - 1);
            }
            return '';
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceEditTimesheetService', ceEditTimesheetService);

    /** @ngInject */
    function ceEditTimesheetService(
        exceptionService,
        $state,
        blockUI,
        invoiceApi
    ) {
        var service = {
            editTimesheet: editTimesheet
        };

        activate();

        return service;

        function activate() {}

        function editTimesheet(ticketId, invoiceId) {
            blockUI.start('Preparing timesheet...');

            invoiceApi.deleteInvoiceAndUnlockTicketAndTimesheet(invoiceId)
                .then(function (resp) {
                    tryRedirectToTimesheet(true, ticketId);
                    blockUI.stop();
                }).catch(exceptionHandler);
        }

        function exceptionHandler(ex) {
            exceptionService.resolve(ex);
            blockUI.stop();
        }

        function tryRedirectToTimesheet(okToRedirect, ticketId) {
            if (okToRedirect === true) {
                $state.go('app.timesheet', {
                    id: ticketId
                });
            } else {
                exceptionService.resolve('Unable to unlock timesheet.');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceEditTicketService', ceEditTicketService);

    /** @ngInject */
    function ceEditTicketService(
        exceptionService,
        $state,
        blockUI,
        invoiceApi
    ) {

        var service = {
            editTicket: editTicket
        };

        activate();

        return service;

        function activate() {}

        function editTicket(ticketId, ticketNumber, invoiceId) {
            blockUI.start('Preparing ticket...');

            invoiceApi.deleteInvoiceAndUnlockTicketAndTimesheet(invoiceId)
                .then(function (resp) {
                    tryRedirectToJobs(true, ticketId, ticketNumber);
                    blockUI.stop();
                }).catch(exceptionHandler);
        }

        function exceptionHandler(ex) {
            exceptionService.resolve(ex);
            blockUI.stop();
        }

        function tryRedirectToJobs(okToRedirect, ticketId, ticketNumber) {
            if (okToRedirect === true) {
                $state.go('app.jobs_update', {
                    id: ticketId,
                    ticketNumber: ticketNumber
                });
            } else {
                exceptionService.resolve('Unable to unlock ticket #' + ticketNumber);
            }
        }
    }
})();

/**
 * Invoice Download service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceDownloadService', ceDownloadService);

    /** @ngInject */
    function ceDownloadService(
        exceptionService,
        blockUI,
        signalRService,
        $rootScope,
        ceReportGridService,
        ceManagerService
    ) {

        var service = {
            registerSignalRCallback: registerSignalRCallback
        };

        return service;

        var isInitialized = false;

        function registerSignalRCallback() {
            if (signalRService.isConnected) {
                costEstimateCallback();
            } else {
                $rootScope.$on('signalR_OnConnected', function() {
                    if (!isInitialized) {
                        costEstimateCallback();
                        isInitialized = true;
                    }
                });
            }
        }

        function costEstimateCallback() {
            signalRService.messageHub.on('costEstimateCallback', function(resp) {
                if (resp.ResultData.Success) {
                    try {
                        downloadPdf(resp.ResultData.FileUri);

                        var costEstimateItem = ceReportGridService.grid.data.filter((ce) => ce.CurrentCENumber === resp.ResultData.InvoiceNumber);

                        if (costEstimateItem.length > 0) {
                            costEstimateItem[0].IsPdfGenerating = false;
                        }

                        var previewCostEstimateItem = ceManagerService.grid.data.filter((ce) => ce.InvoiceNumber === resp.ResultData.InvoiceNumber);

                        if (previewCostEstimateItem.length > 0) {
                            previewCostEstimateItem[0].IsPdfGenerating = false;
                        }

                    } catch (ex) {
                        exceptionHandler(ex);
                    }
                }
            });
        }

        function downloadPdf(url) {
            var anchor = angular.element('<a/>');

            var filenameParts = url.split('/');
            var cacheInvalidationQueryString = `?time=${new Date().getTime()}`;
            var updatedUri = encodeURI(url) + cacheInvalidationQueryString;

            anchor.attr({
                href: updatedUri,
                target: '_blank',
                download: filenameParts[filenameParts.length - 1]
            })[0].click();
        }

        function exceptionHandler(ex) {
            exceptionService.resolve(ex);
            blockUI.stop();
        }
    }
})();
/**
 * Invoice Finalise service
 * rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceDeletePreviewService', ceDeletePreviewService);

    /** @ngInject */
    function ceDeletePreviewService($q,
        exceptionService,
        costEstimateApi,
        alasql,
        $mdDialog,
        $mdToast,
        blockUI,
        _,
        $rootScope
    ) {
        const FINALISE = 2;

        var service = {
            deletePreview: performDeletePreview
        };

        activate();

        return service;
        //////

        function activate() { 
        }

        function performDeletePreview(data) {
            let deferred = $q.defer();

            let confirm = $mdDialog.confirm()
                .title('Delete cost estimate preview')
                .textContent('Are you sure you want to delete this cost estimate?')
                .ariaLabel('Delete cost estimate preview')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                blockUI.start('Deleting preview cost estimate...');
                
                costEstimateApi.cancel(data.Id)
                    .then(function (resp) {
                        blockUI.stop();
                        deferred.resolve(data);
                    }).catch(function (ex) {
                        blockUI.stop();
                        deferred.reject(ex);
                    });

            });

            return deferred.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('ceDataAdapterService', ceDataAdapterService);

    /** @ngInject */
    function ceDataAdapterService(
        a8WebApiNoChunkDataProvider,
        costEstimateApi
    ) {
        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            stopDownload: stopDownload, // inbound event (called by grid client)
        };

        var dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        function onGetData(params) {
            return dbSource.fetch(function() {
                return costEstimateApi.getCostEstimates(params.filters.GroupId, (params.filters.showOnlyCancelled == 1));
            });
        }

        function stopDownload(initiator) {}
    }
})();

/**
 * Custom Grid Search engine
 * Todo: Perform multi keyword search here
 * by Rcnet
 */
(function () {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceCustomGridSearchService', ceCustomGridSearchService);

    /** @ngInject */
    function ceCustomGridSearchService(_, alasql, utils) {
        var service = {
            search: search
        };

        return service;
        ///////

        // TODO: provide search columns parameter to override extractSearchFields
        function search(collection, stext) {
            if (collection.length <= 0 || stext == null || stext == undefined || stext == '' || stext == 'undefined') return null;

            let props = extractSearchFields(collection[0]);
            let qryPredicate = createQueryPredicate(props, stext);

            var results = alasql("SELECT * FROM ? WHERE " + qryPredicate, [collection]);
            var results2 = [];
            _.forEach(collection, function (o) {
                let res = alasql('SELECT * FROM ? WHERE Description LIKE "%' + stext + '%" OR (LineTotal = "' + stext + '" AND Quantity > 0)', [o.LineItems]);
                if (res.length > 0)
                    results2.push(o);
            });

            var mergedResults = _.concat(results, results2);
            var finalResult = _.uniqBy(mergedResults, function (o) {
                return o.Id;
            });

            return finalResult;
        }

        function createQueryPredicate(propsColl, stext) {
            let pred = '';
            angular.forEach(propsColl, function (p) {
                if (p != 'State')
                    pred += p + ' LIKE "%' +  decodeURI(stext) + '%" OR ';
            });

            return pred.substring(0, pred.length - 4);
        }

        function extractSearchFields(obj) {
            let objSanitized = utils.objectSanitize(obj);
            let propsArr = [];
            for (var p in objSanitized) {
                if (!angular.isFunction(propsArr))
                    propsArr.push(p);
            }
            return propsArr;
        }

    }
})();

/**
 * Invoice Current Request Service
 * rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .factory('ceCurrentRequestService', ceCurrentRequestService);

    /** @ngInject */
    function ceCurrentRequestService($q,
        exceptionService,
        moment,
        signalRService
    ) {
        var service = {
            get: get
        };

        activate();

        return service;
        //////

        function activate() {}

        function get() {
            let deferred = $q.defer();

            signalRService.safeSend(function() {
                signalRService.messageHub
                    .invoke('GetInvoiceRequestParams')
                    .done(function(resp) {
                        deferred.resolve(resp);
                    }).fail(function(ex) {
                        exceptionService.resolve(ex);
                        deferred.reject(ex);
                    });
            });

            return deferred.promise;
        }

    }
})();
(function(){
   'use strict';

  angular.module('app.costEstimate.preview')
          .service('CeReportProcessResultModel', CeReportProcessResultModel)

    function CeReportProcessResultModel() {
        return function () {
            var self = this,
            defaults = {
                Status: null,
                Branches: [],
                BranchesHtml: null,
                StartDate: null, 
                EndDate: null,
                Client: null,
                IncludeDetails: false
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();
/**
 * Invoice cache model
 */
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('cePreviewCfgModel', cePreviewCfgModel)

    function cePreviewCfgModel(ceUtilsService) {
        return function() {
            var self = this,
                defaults = {
                    status: 'ready', // status composed of: (ready, processing, cached)
                    filters: {
                        branches: [],
                        startDate: ceUtilsService.getStartOfWeek(new Date()),
                        endDate: ceUtilsService.getEndOfWeek(new Date()),
                        clients: [],
                        showDetails: false
                    }
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.filters.branches.length = 0;
                self.filters.clients.length = 0;
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('ceLineItemModel', ceLineItemModel)

    function ceLineItemModel() {
        return function() {
            var self = this,
                defaults = {
                    Id: null,
                    TicketId: null,
                    TicketNumber: null,
                    Description: null,
                    CostCode: null,
                    Quantity: 0,
                    UnitPriceExcludingTax: 0,
                    UnitTax: 0,
                    TaxRate: 0,
                    SequenceNo: 0,
                    IsHistorical: false,
                    CreatingUserId: null
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('ceGroupInfoModel', ceGroupInfoModel)

    function ceGroupInfoModel() {
        return function() {
            var self = this,
                defaults = {
                    CompanyName: null,
                    CompanyId: null,
                    BranchId: null,
                    BranchName: null,
                    BookedTicketIds: [],
                    CostEstimateStatus: null,
                    CostEstimateStatusText: null,
                    WonLostCompanyId: null,
                    LostReason: null,
                    WinningCompetitorCompanyId: null,
                    WinningCompetitorCompanyName: null,
                    WinningAmount: 0,
                    ClosedComments: null,
                    Status: null,
                    HasBeenCancelled: false,
                    IsPdfGenerating: false
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
/**
 * Invoice cache model
 */
(function () {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('ceFilterModel', ceFilterModel)

    function ceFilterModel(_, ceUtilsService, ceFilterHasherService, utils) {
        return function () {
            var self = this,
                defaults = {
                    selectedBranches: [], //Todo: For removal
                    selectedClients: [], //Todo: For removal
                    startDate: ceUtilsService.getStartOfWeek(new Date()),
                    endDate: ceUtilsService.getEndOfWeek(new Date()),
                    showDetails: false,
                    overrideInvoiceDate: undefined,

                    singlePreviewInvoiceId: null,
                    selectedRate: null
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.getFilterHash = getFilterHash;
            self.resetOverriderInvoiceDate = resetOverriderInvoiceDate;
            self.setSingleInvoicePreview = setSingleInvoicePreview;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
                self.selectedBranches.length = 0;
                self.selectedClients.length = 0;
            }

            function resetOverriderInvoiceDate() {
                self.overrideInvoiceDate = undefined;
            }

            function setSingleInvoicePreview(id) {
                self.singlePreviewInvoiceId = id;
            }

            function transformToModel(branchSource) {
                let filterModel = {
                    BranchIds: [],
                    CompanyIds: [],
                    StartDate: null,
                    EndDate: null,
                    ShowDetails: false,
                    OverrideInvoiceDate: undefined,

                    GroupId: null,
                    RateCardId: null
                };

                // Branches
                if (angular.isArray(self.selectedBranches)) {
                    // Get selected state first
                    var selectedStates = _.filter(self.selectedBranches, function (o) {
                        return o.State == null;
                    });

                    var selBranches = _.filter(self.selectedBranches, function (o) {
                        return o.State != null;
                    });

                    // Get associated branches inside state
                    selectedStates.forEach(function (p) {
                        p.StateBranches.map(function (o) {
                            filterModel.BranchIds.push(o);
                        });
                    });

                    // Get branches
                    selBranches.map(function(o) {
                        filterModel.BranchIds.push(o.Id);
                    });

                    filterModel.BranchIds = _.uniq(filterModel.BranchIds);
                }

                // Client
                if (angular.isArray(self.selectedClients)) {
                    self.selectedClients.map(function (itm) {
                        filterModel.CompanyIds.push(itm.Id);
                    });
                }

                filterModel.StartDate = self.startDate;
                filterModel.EndDate = self.endDate;
                filterModel.ShowDetails = self.showDetails;
                filterModel.OverrideInvoiceDate = utils.jsDateTime(self.overrideInvoiceDate);
                filterModel.GroupId = self.singlePreviewInvoiceId;
                filterModel.RateCardId = (self.selectedRate != null ? self.selectedRate.Id : null);

                return filterModel;
            }

            /**
             * Returns filter token hash
             */
            function getFilterHash() {
                let cfg = transformToModel();
                return ceFilterHasherService.hash(cfg);
            }

        }

    }
})();
(function() {
    'use strict';

    angular.module('app.costEstimate.preview')
        .service('ceDataModel', ceDataModel)

    function ceDataModel() {
        return function() {
            var self = this,
                defaults = {
                    Id: null,
                    CompanyName: [],
                    Project: null,
                    InvoiceNo: null,
                    InvoiceDate: null,
                    PurchaseOrderNo: null,
                    Terms: 0,
                    Status: 'Preview',
                    TotalExcludingTax: 0,
                    TotalTax: 0,
                    TotalIncludingTax: 0,
                    LineItems: []
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);

                return self;
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
/**
 * a8SimplePaginationGrid service
 * Handles streamed data coming from docDb or Redis Cache
 * Instantiable service
 * by Rcnet 11.14.2016
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate')
        .factory('ceGridService', ceGridService);

    /** @ngInject */
    function ceGridService(_,
        $timeout,
        invoiceGridModelBuilderService,
        utils,
        invoiceGridSearchEngineService
        //a8SortService) {
    ) {

        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        //////
        function activate() {}

        /**
         * Create new instance
         */
        function getInstance() {
            var paginationContext = function() {
                var self = this;

                // Props
                self.supersetCollection = [];
                self.filteredSupersetCollection = [];
                self.data = {
                    TotalItemCount: 0,

                    DownloadCtr: 0,
                    TotalChunks: 0,

                    isFiltered: false,
                    RawTotalItemCount: 0, // Total item count without filtering used only when displaying filtering info 

                    onDataFilter: angular.noop,
                    onFetchData: angular.noop,
                    onCompleted: angular.noop,
                    onPreRender: angular.noop,
                    onError: angular.noop,
                    onSearch: angular.noop,
                    onApplyCustomClientSideFiltering: angular.noop
                };

                self.currentPageSize = 10;
                self.currentPageNumber = 1; // Page number is a base 0 index

                self.refreshPager = refreshPager2;
                self.sortParams = null;

                self.onChunkReceived = onChunkReceived;
                self.onDownloadCompleted = onDownloadCompleted;

                self.search = search;
                self.searchText = null;

                // self.sort = sort;
                // self.sortBy = null;
                // self.sortDir = null;

                //self.changePageSize = changePageSize;
                self.busy = false;
                self.isDownloading = false;
                self.setToDownloadingState = setToDownloadingState;
                self.inProgress = angular.noop;

                self.clearData = clearData;
                self.initiator = null; // cacheHub or dbHub
                self.distinctBy = null; // Temporary only
                self.invokeUpdateState = invokeUpdateState; // Perform client side update of data set 
                self.allowCustomClientSideFiltering = false;
                self.customGridSearchService = null; // Custom grid search service this will override the default

                activate();

                function activate() {}

                /**
                 * On receive chunk data
                 */
                function onChunkReceived(data, initiator) {
                    if (data) {
                        // Provide chunk properties
                        // If totalChunks and totalItemCount = -1 then downloding time is undetermine
                        // view will adjust to this by displaying estimate count
                        self.data.TotalChunks = data.totalChunks;
                        self.data.TotalItemCount = data.totalItems;
                        self.data.DownloadCtr = self.data.DownloadCtr++;
                        self.initiator = initiator;

                        angular.forEach(data.chunkData, function(itm) {
                            self.supersetCollection.push(itm);
                        });

                        refreshPager2(self.currentPageNumber);

                        // Db propagated or cache
                        if (initiator === 'dbHub' || initiator === 'dbHubFilter') {
                            // doc db we dont know the count size ahead so no computation of progress
                            return -1;
                        } else {
                            return calculateDataReceivedProgress(data.totalItems);
                        }
                    }
                }

                function clearData() {
                    self.supersetCollection.length = 0;
                    self.filteredSupersetCollection.length = 0;
                    self.currentPageNumber = 1;
                    self.data.RawTotalItemCount = 0;
                    self.data.TotalItemCount = 0;
                }

                /**
                 * Todo: Replace this code !!!
                 * @param {distinctBy} Temporary code
                 */
                function applyDistinctBy(distinctBy, superset) {
                    let qry = 'SELECT DISTINCT ' + distinctBy + ', * FROM ?';
                    return alasql(qry, [superset]);
                }

                /**
                 * Compute download percentage
                 */
                function calculateDataReceivedProgress(totalItems) {
                    let currentProgress = Math.ceil((self.supersetCollection.length / parseInt(totalItems)) * 100);
                    return currentProgress;
                }

                /**
                 * Filter pipeline (sorting and searching)
                 * Mutates collection
                 */
                function applyCollectionPipelineCriteria(page) {
                    // Apply sorting and searching here
                    let filteredColl = [];
                    let totalFilteredCount = 0;

                    if (self.distinctBy) {
                        self.supersetCollection = applyDistinctBy(self.distinctBy, getActiveSuperset());
                    }

                    let activeSuperset = getActiveSuperset();

                    // NOTE: Enable this one!!!
                    // Avoid running apply search when the same search text is used when navigating this will speed up things :-)
                    if (self.filteredSupersetCollection.length == 0) {
                        filteredColl = applySearching(activeSuperset);

                        // Todo: Refactor this, it should search internally
                        if (self.allowCustomClientSideFiltering) {
                            var clientSideFilteringResult = self.data.onApplyCustomClientSideFiltering(filteredColl); // New: 9.25.2017
                            filteredColl = clientSideFilteringResult ? clientSideFilteringResult : [];
                        }
                    } else {
                        filteredColl = activeSuperset;
                    }

                    // Perform optimization by caching the search result
                    optimizeSearchingByCaching(filteredColl);

                    totalFilteredCount = filteredColl.length;


                    // Check out of bounds here
                    if (filteredColl != null && filteredColl.length > 0) {
                        // Disable paging here
                        return { collection: filteredColl, totalItems: totalFilteredCount };
                    }

                    return { collection: filteredColl, totalItems: totalFilteredCount };
                }

                function optimizeSearchingByCaching(filteredColl) {
                    // If there's a search text then buffer it for faster navigation
                    if (self.searchText != null && !self.isDownloading) {
                        if (self.filteredSupersetCollection.length == 0) {
                            for (var i = 0; i < filteredColl.length; i++) {
                                self.filteredSupersetCollection.push(filteredColl[i]);
                            }
                        }
                    }
                }

                function getActiveSuperset() {
                    if (self.searchText != null) {
                        if ((self.searchText.length > 0) && self.filteredSupersetCollection.length > 0 && !self.isDownloading) {
                            return self.filteredSupersetCollection;
                        } else {
                            return self.supersetCollection;
                        }
                    }
                    return self.supersetCollection;
                }

                /**
                 * Relative to base 0 index for accessing the array superset collection
                 * Call this if you want to access the collection superset
                 */
                function getRelativePageNo(page) {
                    let pageNum = page - 1;
                    return pageNum < 0 ? 1 : pageNum;
                }

                /**
                 * Complete data received
                 */
                function onDownloadCompleted(data, sender) {
                    self.inProgress(false);
                    self.isDownloading = false;

                    // For server side filtering then update raw total count
                    self.data.RawTotalItemCount = self.supersetCollection.length;
                }

                function applySearching(collection) {
                    let result = null;
                    if (!self.customGridSearchService) {
                        result = invoiceGridSearchEngineService.search(collection, self.searchText);
                    } else {
                        result = self.customGridSearchService.search(collection, self.searchText);
                    }

                    let activeSuperset = getActiveSuperset();

                    return (result == null ? activeSuperset : result);
                }

                function search(text) {
                    
                    self.searchText = text;
                    self.currentPageNumber = 1;
                    self.filteredSupersetCollection.length = 0;
                    self.data.isFiltered = !utils.isNullOrEmpty(text);
                    self.data.RawTotalItemCount = self.supersetCollection.length;
                    refreshPager2(1);
                    self.data.onSearch();
                }


                /**
                 * Refresh page
                 * @args page - 0 based index
                 */
                function refreshPager2(page) {
                    try {
                        let pageNo = getRelativePageNo(page);
                        let result = applyCollectionPipelineCriteria(pageNo);

                        // Before rendering the results fire this event, any pre init operation can be perform here in this event 
                        let isCancelRendering = (self.data.onPreRender || angular.noop)({ data: result.collection });
                        if (isCancelRendering == false) return;

                        // Build pager model
                        let pagerModel = invoiceGridModelBuilderService.createModel(result.totalItems,
                            page,
                            self.currentPageSize
                        );

                        buildPager(pagerModel);

                        // Notify client to build grid data
                        $timeout(function() {
                            (self.data.onCompleted || angular.noop)({ data: result.collection });
                        }, 0);
                    } catch (ex) {
                        (self.data.onError || angular.noop)({ msg: 'Invoice Grid: Unable to load data from server.' });
                    }
                }

                /**
                 * Required view model for basic paging
                 */
                function buildPager(model) {
                    // self.data.HasNextPage = model.HasNextPage;
                    // self.data.HasPreviousPage = model.HasPreviousPage;
                    self.data.TotalItemCount = model.TotalItemCount;
                    // self.data.FirstItemOnPage = model.FirstItemOnPage;
                    // self.data.LastItemOnPage = model.LastItemOnPage;
                    //service.data.PageNumber = model.PageNumber;
                }

                function setToDownloadingState() {
                    self.isDownloading = true;
                }

                /**
                 * Updates the SupersetCollection and the FilteredsetColection
                 * Note: Use with caution, this will alter the internal state of grid data.
                 * As much as possible avoid using this.
                 * @param {query expression} predicate 
                 * @param {action function to perform mutation} action 
                 */
                function invokeUpdateState(predicate, action, forceRefresh) {
                    // Todo: Fix double firing of action func due to double resolve (supersetColl and filteredSupersetColl)
                    var result = [];
                    if (self.supersetCollection) {
                        result = _.filter(self.supersetCollection, predicate);
                        if (result.length > 0) {
                            (action || angular.noop)(result); // Reference type so auto update entity inside collection
                        }
                    }
                    if (self.filteredSupersetCollection) {
                        result = _.filter(self.filteredSupersetCollection, predicate);
                        if (result.length > 0) {
                            (action || angular.noop)(result); // Reference type so auto update entity inside collection
                        }
                    }

                    if (forceRefresh)
                        refreshPager2(1);
                }

            };

            return new paginationContext();
        }

    }
})();
/**
 * Model coming from DB
 * Obsolete
 */
(function() {
    'use strict';

    angular.module('app.costEstimate')
        .service('ceGridModel', ceGridModel)

    function ceGridModel() {
        return function() {
            var self = this,
                defaults = {
                    FirstItemOnPage: null,
                    HasNextPage: false,
                    HasPreviousPage: false,
                    IsFirstPage: false,
                    IsLastPage: false,
                    LastItemOnPage: null,
                    PageCount: 0,
                    PageNumber: 0,
                    PageSize: 0,
                    TotalItemCount: 0
                };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults,
                    opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }

    }
})();
/**
 * Pagination Component Client Side
 * Client side paging
 * by Rcnet
 */
(function() {
    'use strict';

    angular.module('app.costEstimate')
        .directive('ceGridComponent', ceGridComponent);

    /** @ngInject */
    function ceGridComponent() {
        var directive = {
            restrict: 'E',
            scope: {
                configuration: '='
            },
            controller: ceGridComponentController,
            controllerAs: 'vm',
            bindToController: true
        };

        ///////
        function ceGridComponentController() {
            var vm = this;

            vm.handlers = {
                searchDelegates: [],
                sortResetDelegates: [],
                sortDelegates: [],
                statusDelegates: [],
                infoDelegates: []
            }
        }

        ceGridComponentController.prototype.goSearch = function(text) {
            this.handlers.searchDelegates.forEach(function(handler) {
                handler(text);
            });
        }

        ceGridComponentController.prototype.onGoSearch = function(handler) {
            this.handlers.searchDelegates.push(handler);
        }

        ceGridComponentController.prototype.sortReset = function() {
            this.handlers.sortResetDelegates.forEach(function(handler) {
                handler();
            });
        }

        ceGridComponentController.prototype.onSortReset = function(handler) {
            this.handlers.sortResetDelegates.push(handler);
        }

        ceGridComponentController.prototype.sort = function(sortParams) {
            this.handlers.sortDelegates.forEach(function(handler) {
                handler(sortParams);
            });
        }

        ceGridComponentController.prototype.onSort = function(handler) {
            this.handlers.sortDelegates.push(handler);
        }

        ceGridComponentController.prototype.setStatus = function(value) {
            this.handlers.statusDelegates.forEach(function(handler) {
                handler(value);
            });
        }

        ceGridComponentController.prototype.onSetStatus = function(handler) {
            this.handlers.statusDelegates.push(handler);
        }

        ceGridComponentController.prototype.setGridInfo = function(value) {
            this.handlers.infoDelegates.forEach(function(handler) {
                handler(value);
            });
        }

        ceGridComponentController.prototype.onSetGridInfo = function(handler) {
            this.handlers.infoDelegates.push(handler);
        }

        return directive;
    }

})();
/**
 * Pagination Component for Alloc8 grid
 * Grid for ala streaming datasource 
 * Client side paging
 * author: Rcnet
 * 12.14.2016
 * v1.0
 */
(function() {
    'use strict';

    angular.module('app.costEstimate')
        .directive('ceGridPaginationComponent', ceGridPaginationComponent);

    /** @ngInject */
    function ceGridPaginationComponent($http, $timeout, $log, invoiceGridService) {
        var directive = {
            restrict: 'E',
            scope: {
                behavior: '=',
                onInit: '&',
                onDataFilter: '&',
                onFetchData: '&',
                onCompleted: '&',
                onPreRender: '&',
                onDataLoading: '&',
                onDataLoadingCompleted: '&',
                onReady: '&',
                onError: '&',
                onApplyCustomClientSideFiltering: '&',
                allowCustomClientSideFiltering: '=',
                showNav: '=',
                showTotalRecords: '&',
                autoFetch: '@',
                distinctBy: '@',
                customGridSearchService: '='
            },
            require: '^ceGridComponent',
            templateUrl: 'app/main/costEstimate/directives/grid/ce-grid-pagination.html',
            controller: CeGridHandlerController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        ///////
        function CeGridHandlerController($scope) {}

        function link($scope, el, attrs, controller) {
            var vm = $scope.vm;
            vm.autoFetch = vm.autoFetch || 'true';
            vm.basicService = invoiceGridService.getInstance();
            vm.showTotalRecords = vm.showTotalRecords == null ? true : vm.showTotalRecords;
            vm.hubAdapter = null;

            activate();

            controller.onGoSearch(function(val) {
                vm.basicService.search(val);
            });

            controller.onSort(function(s) {
                vm.basicService.sort(s.sortParams.sortBy, s.sortParams.sortDir);
            });


            function activate() {

                initializePublicApis();

                // Fire on-Init event
                (vm.onInit || angular.noop)();

                controller.setStatus('Downloading data...');
                postUpdatedGridInfo();
                (vm.onDataLoading || angular.noop)();

                initBasicPagination();

                // Fire when the control is ready or completed initialization
                (vm.onReady || angular.noop)();
            }

            /**
             * Exposed APIs to grid consumer
             * Note: behavior methods are accessible and invokeable by the consumer
             */
            function initializePublicApis() {
                if (vm.behavior) {
                    // To track progress
                    vm.behavior.busy = false;
                    vm.behavior.search = search;

                    // Refresh pagination
                    vm.behavior.refresh = refresh;
                    vm.behavior.refreshClientSide = refreshClientSide;
                    vm.behavior.clearAll = clearAll;
                    vm.behavior.stop = stop;

                    // Set data hub source
                    vm.behavior.setHubSourceAdapter = setHubSourceAdapter;

                    // Returns grid information
                    vm.behavior.getGridInfo = getGridInfo;

                    // Force update of data set
                    vm.behavior.invokeUpdateState = vm.basicService.invokeUpdateState;
                }
            }

            function postUpdatedGridInfo(inProgress) {
                let inprogress = inProgress != null ? inProgress : vm.basicService.isDownloading;

                controller.setGridInfo({
                    totalItems: vm.basicService.data.TotalItemCount,
                    rawTotalItemCount: vm.basicService.data.RawTotalItemCount,
                    inProgress: inprogress,
                    isFiltered: vm.basicService.data.isFiltered
                });
            }

            function search(searchText) {
                vm.basicService.search(searchText);
            }

            /**
             * Performs server side refresh (with roundtrip to server)
             */
            function refresh() {
                controller.setStatus('Downloading data...');
                postUpdatedGridInfo();
                (vm.onDataLoading || angular.noop)();
                vm.behavior.busy = true;

                let filters = (vm.onDataFilter || angular.noop)();
                let filterObj = filters != null ? { filters: filters } : null;

                // Detect if refresh is executed many times while current downloading is in progress.
                // This may overlap existing DL process, to mitigate this just stop the current download then proceed to the new one.
                if (vm.basicService.isDownloading) {
                    // TODO: Need to handle stopping of signalr promise request in the adapter !!!! 
                    $log.debug('Stop Downloading... Multiple execution!!!');
                    vm.hubAdapter.stopDownload(vm.basicService.initiator);
                }

                vm.basicService.clearData();
                startDownload(filterObj);
            }

            /**
             * This will affect the client side searching so no server side refresh or server side roundtrip
             */
            function refreshClientSide() {
                vm.basicService.search(null);
            }

            /**
             * Clear clear :)
             */
            function clearAll() {
                vm.basicService.clearData();
                postUpdatedGridInfo();
                (vm.onCompleted || angular.noop)({ data: [] });
                (vm.onDataLoadingCompleted || angular.noop)();
            }

            /**
             * Stop fetching data
             */
            function stop() {
                vm.hubAdapter.stopDownload(vm.basicService.initiator);
                vm.behavior.busy = false;
                controller.setStatus('');
            }

            /**
             * Hook hub data source adapter instance and events
             */
            function setHubSourceAdapter(adapter) {
                vm.hubAdapter = adapter;
                vm.hubAdapter.onChunkReceived = onChunkReceived;
                vm.hubAdapter.onDownloadCompleted = onDownloadCompleted;
                vm.hubAdapter.onErrorDownloading = onErrorDownloading;
            }

            function onChunkReceived(data, sender) {
                // Return extra information/data to caller. Extra data is coming from the backend (Tuple->Item3)
                //(vm.onDataLoading || angular.noop)(data.extraData); // Not supported
                (vm.onDataLoading || angular.noop)();

                let progressPercentage = vm.basicService.onChunkReceived(data, sender);
                if (progressPercentage > 0) {
                    controller.setStatus(progressPercentage.toString() + '%');
                    postUpdatedGridInfo();
                    (vm.onDataLoading || angular.noop)();
                }
            }

            function onDownloadCompleted(data, sender) {
                vm.behavior.busy = false;
                controller.setStatus('');
                postUpdatedGridInfo(false);

                vm.basicService.onDownloadCompleted(data, sender);
                (vm.onDataLoadingCompleted || angular.noop)();
            }

            function onErrorDownloading(data, sender) {
                (vm.onError || angular.noop)({ ex: data });
                //vm.basicService.onErrorDownloading
                //alert(data);
            }

            function startDownload(filters) {
                // Fetch data
                vm.behavior.busy = true;
                vm.hubAdapter
                    .onGetData(filters)
                    .catch(function(ex) {
                        vm.behavior.busy = false;
                        controller.setStatus('Error downloading');
                        (vm.onError || angular.noop)({ ex: ex });
                    });

                vm.basicService.setToDownloadingState();
            }

            function getGridInfo() {
                return {
                    totalItems: vm.basicService.data.TotalItemCount,
                    rawTotalItemCount: vm.basicService.data.RawTotalItemCount,
                    inProgress: vm.basicService.isDownloading,
                    isFiltered: vm.basicService.data.isFiltered
                };
            }

            /**
             * Communication events for basicService grid
             */
            function initBasicPagination() {
                vm.basicService.data.isCustomDataFetch = vm.manualDataFetch;
                vm.basicService.sourceType = vm.sourceType;
                vm.basicService.distinctBy = vm.distinctBy; // TODO: Remove this feature(just a temporary approach)!!!
                vm.basicService.allowCustomClientSideFiltering = !!vm.allowCustomClientSideFiltering;
                vm.basicService.customGridSearchService = vm.customGridSearchService;

                vm.basicService.data.customDataFetch = function(params) {
                    return (vm.onCustomDataFetch || angular.noop)({ params: params });
                }

                vm.basicService.data.onDataFilter = function() {
                    // not supported in basic
                }

                vm.basicService.data.onFetchData = function() {
                    // not supported in basic
                }

                vm.basicService.data.onSearch = function() {
                    // Fire event to consumer
                    postUpdatedGridInfo();
                    (vm.onDataLoadingCompleted || angular.noop)();
                }

                vm.basicService.data.onCompleted = function(data) {
                    (vm.onCompleted || angular.noop)({ data: data.data });
                }

                vm.basicService.data.onPreRender = function(data) {
                    (vm.onPreRender || angular.noop)({ data: data });
                }

                vm.basicService.data.onError = function(ex) {
                    (vm.onError || angular.noop)({ ex: ex });
                }

                vm.basicService.inProgress = function(show) {
                    vm.behavior.busy = show;
                }

                // Todo: Revisit this method it needs thorough thinking on the architecture adjustments
                vm.basicService.data.onApplyCustomClientSideFiltering = function(collection) {
                    return (vm.onApplyCustomClientSideFiltering || angular.noop)({ data: collection });
                }

                $timeout(function() {
                    if (vm.autoFetch === 'true') startDownload();
                }, 0);
            }

        }
    }
})();
/**
 * invoiceGridModelBuilderService
 * by Rcnet
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate')
        .factory('ceGridModelBuilderService', ceGridModelBuilderService);

    /** @ngInject */
    function ceGridModelBuilderService(_, invoiceGridModel) {
        var service = {
            createModel: createModel
        };

        return service;

        //////////
        function createModel(totalItemCount, pageNumber, pageSize) {
            let pageNum = pageNumber === 0 ? 1 : pageNumber;
            let pagerModel = new invoiceGridModel();

            pagerModel.TotalItemCount = totalItemCount;
            pagerModel.PageSize = pageSize;
            pagerModel.PageNumber = pageNum;
            pagerModel.PageCount = totalItemCount > 0 ?
                parseInt(Math.ceil(parseInt(totalItemCount) / parseInt(pagerModel.PageSize))) :
                1;

            pagerModel.PageCount = totalItemCount > 0 ?
                parseInt(Math.ceil(parseInt(totalItemCount) / parseInt(pagerModel.PageSize))) :
                0;
            pagerModel.HasNextPage = pageNum < pagerModel.PageCount;
            pagerModel.HasPreviousPage = parseInt(pageNum) > 1;
            pagerModel.IsFirstPage = pagerModel.PageNumber === 1;
            pagerModel.IsLastPage = pagerModel.PageNumber >= pagerModel.PageCount;
            pagerModel.FirstItemOnPage = (pagerModel.PageNumber - 1) * pagerModel.PageSize + 1;
            var numberOfLastItemOnPage = pagerModel.FirstItemOnPage + pagerModel.PageSize - 1;
            pagerModel.LastItemOnPage = numberOfLastItemOnPage > pagerModel.TotalItemCount ?
                pagerModel.TotalItemCount :
                numberOfLastItemOnPage;

            return pagerModel;
        }
    }
})();
(function() {
    'use strict';
    angular.module('app.costEstimate')
        .directive('ceCustomGridSearchComponent', ceCustomGridSearchComponent);

    /** @ngInject */
    function ceCustomGridSearchComponent() {
        var directive = {
            restrict: 'E',
            scope: {
                srcData: '=',
                onSearch: '&',
                api: '='
            },
            templateUrl: 'app/main/costEstimate/directives/customGridSearch/ce-custom-grid-search.html',
            controller: CostEstimateCustomGridSearchController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function CostEstimateCustomGridSearchController() {}

        function link($scope) {
            var vm = $scope.vm;

            if (vm.api) {
                vm.api.forceTriggerSearch = forceTriggerSearch;
            }

            $scope.$watch('vm.srcData', function(newVal) {
                if (newVal != null) {
                    (vm.onSearch || angular.noop)({
                        value: encodeURIComponent(newVal)
                    });
                }
            });

            function forceTriggerSearch() {
                (vm.onSearch || angular.noop)({
                    value: encodeURIComponent(vm.srcData)
                });
            }
        }
    }
})();

'use strict';

  angular.module('app.corelib')
    .controller('CompanyDatesController', DatesController);

  function DatesController($mdDialog,
                           companyViewService,
                           $mdToast) {

    //Variables
    var vm = this;
    vm.service = companyViewService;

    //Methods
    vm.onCancel = onCancel;
    vm.applyFilter = applyFilter;

    function onCancel(){
      $mdDialog.hide();
    }

    vm.service.filterType = 1;

    function applyFilter(){
      if(moment(vm.service.filterModel.startDate).isAfter(moment(vm.service.filterModel.endDate))){
        $mdToast.show(
          $mdToast.simple()
            .textContent('start date cannot be after end date')
            .position('bottom right')
        );
        vm.service.filterModel.startDate = null;
        return;
      }

      if(moment(vm.service.filterModel.endDate).isBefore(moment(vm.service.filterModel.startDate))){
        $mdToast.show(
          $mdToast.simple()
            .textContent('start date cannot be after end date')
            .position('bottom right')
        );
        vm.service.filterModel.endDate = null;
        return;
      }

      $mdDialog.hide(1);
    }
  }






(function () {
  'use strict';

  angular.module('app.company.view', [])
    .config(config)
    .run(runConfig);

  /** @ngInject */

  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.company_view', {
      url: '/company/view'
      , views: {
        'content@app': {
          templateUrl: 'app/main/company/view/company-view.html'
          , controller: 'CompanyViewController as vmCompanyView'
        }
      }
      , data: {
        requireLogin: true
      }
      ,title : 'View Companies'
      ,titleBar : 'Alloc8 - View Companies'
    });

    $translatePartialLoaderProvider.addPart('app/main/company/view');
  }

  /** @ngInject */
  function runConfig(companyViewSignalrHubService) {
    companyViewSignalrHubService.register();
  }
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewCompaniesComponent = function (_React$Component) {
  _inherits(ViewCompaniesComponent, _React$Component);

  function ViewCompaniesComponent(props) {
    _classCallCheck(this, ViewCompaniesComponent);

    var _this = _possibleConstructorReturn(this, (ViewCompaniesComponent.__proto__ || Object.getPrototypeOf(ViewCompaniesComponent)).call(this, props));

    _this.viewCard = _this.viewCard.bind(_this);
    _this.editCompany = _this.editCompany.bind(_this);
    _this.addContact = _this.addContact.bind(_this);
    _this.translate = _this.translate.bind(_this);
    return _this;
  }

  _createClass(ViewCompaniesComponent, [{
    key: "viewCard",
    value: function viewCard(id) {
      this.props.viewcompanycard(id);
    }
  }, {
    key: "addContact",
    value: function addContact(company) {
      this.props.addcontact(company);
    }
  }, {
    key: "editCompany",
    value: function editCompany(id) {
      this.props.editcompany(id);
    }
  }, {
    key: "translate",
    value: function translate() {
      return this.props.translate();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      $('#view-companies').dataTable({
        "bAutoWidth": false,
        "responsive": false,
        "bDestroy": true,
        "sDom": 'rt<"bottom"lip><"clear">'
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      $('#view-companies').dataTable({
        "bAutoWidth": false,
        "responsive": false,
        "bDestroy": true,
        "sDom": 'rt<"bottom"lip><"clear">'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var self = this;

      function createItem(item) {
        return React.createElement(
          "tr",
          null,
          React.createElement(
            "td",
            null,
            React.createElement(
              "md-button",
              { className: "md-icon-button md-primary action-button",
                onClick: self.viewCard.bind(this, item.Id),
                "aria-label": "Settings" },
              React.createElement("i", { className: "icon icon-city light-blue-500-fg s15" })
            )
          ),
          React.createElement(
            "td",
            null,
            React.createElement(
              "b",
              null,
              item.Name
            )
          ),
          React.createElement(
            "td",
            null,
            item.CompanyTypes.join(", ")
          ),
          React.createElement(
            "td",
            null,
            item.Branches.join(", ")
          ),
          React.createElement(
            "td",
            null,
            item.Divisions.join(", ")
          ),
          React.createElement(
            "td",
            null,
            item.CompanyCode
          ),
          React.createElement(
            "td",
            null,
            item.IsActive ? "Yes" : "No"
          ),
          React.createElement(
            "td",
            null,
            React.createElement(
              "md-button",
              { className: "md-icon-button",
                onClick: self.editCompany.bind(this, item.Id, item.Name),
                "aria-label": "Archive",
                translate: true,
                "translate-attr-aria-label": "MAIL.ARCHIVE" },
              React.createElement("i", { className: "icon-pencil teal-500-fg" })
            )
          ),
          React.createElement(
            "td",
            null,
            React.createElement(
              "md-button",
              { className: "md-icon-button",
                onClick: self.addContact.bind(this, item),
                "aria-label": "Archive",
                "show-gt-sm": true },
              React.createElement("i", { className: "icon-account-plus blue-500-fg" })
            )
          )
        );
      }

      return React.createElement(
        "table",
        { className: "dataTable row-border hover", id: "view-companies" },
        React.createElement(
          "thead",
          null,
          React.createElement(
            "tr",
            null,
            React.createElement("th", null),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCOMPANIES.COLUMN_NAME')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCOMPANIES.COLUMN_TYPE')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCOMPANIES.COLUMN_BRANCHES')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCOMPANIES.COLUMN_DIVISIONS')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCOMPANIES.COLUMN_CODE')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCOMPANIES.COLUMN_ACTIVE')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCOMPANIES.COLUMN_EDIT')
                )
              )
            ),
            React.createElement(
              "th",
              { className: "secondary-text" },
              React.createElement(
                "div",
                { className: "table-header" },
                React.createElement(
                  "span",
                  { className: "column-title" },
                  this.props.translate('VIEWCOMPANIES.COLUMN_CREATE')
                )
              )
            )
          )
        ),
        React.createElement(
          "tbody",
          null,
          this.props.companies.map(createItem)
        )
      );
    }
  }]);

  return ViewCompaniesComponent;
}(React.Component);

ViewCompaniesComponent.propTypes = {
  companies: React.PropTypes.array.isRequired,
  viewcompanycard: React.PropTypes.func.isRequired,
  editcompany: React.PropTypes.func.isRequired,
  addcontact: React.PropTypes.func.isRequired,
  translate: React.PropTypes.func.isRequired
};
ViewCompaniesComponent.defaultProps = {
  companies: [],
  viewcompanycard: function viewcompanycard() {},
  editcompany: function editcompany() {},
  addcontact: function addcontact() {},
  translate: function translate() {}
};


angular.module('app.company.view').value('ViewCompaniesComponent', ViewCompaniesComponent);
(function () {
  'use strict';

  angular.module('app.company.view')
    .directive('viewCompaniesComponent', viewCompaniesComponent);

  /** @ngInject */
  function viewCompaniesComponent(reactDirective, ViewCompaniesComponent) {
    return reactDirective(ViewCompaniesComponent);
  }

})();


(function() {
    'use strict';

    angular.module('app.company.create')
        .directive('companyInfoComponent', companyInfoComponent);

    /** @ngInject */
    function companyInfoComponent(
        companyService,
        companyLookupService,
        tenantSettings,
        exceptionService
    ) {
        return {
            restrict: 'E',
            templateUrl: 'app/main/company/create/companyInfo/companyInfo.html',
            controller: companyController,
            controllerAs: 'companyInfoVm',
            bindToController: true
        };

        function companyController($scope, utils) {
            var companyInfoVm = this;

            companyInfoVm.onUploadCompleted = onUploadCompleted;
            companyInfoVm.onUploadError = onUploadError;
            companyInfoVm.onUploadStart = onUploadStart;
            companyInfoVm.onUploadValidate = onUploadValidate;
            companyInfoVm.changeFields = changeFields;

            companyInfoVm.utilService = utils;
            companyInfoVm.companyInfo = companyService.companyInfoData;
            companyInfoVm.uploadUrl = tenantSettings.coreApiUrl + "api/companies/uploadimage";
            companyInfoVm.companyTypes = companyLookupService.companyLookups.CompanyTypes;
            companyInfoVm.addressTypes = companyLookupService.companyLookups.AddressTypes;
            companyInfoVm.showProgress = false;
            companyInfoVm.service = companyService;
            companyInfoVm.dateFormat = utils.setDateFormat();
            companyInfoVm.utilService = utils;
            companyInfoVm.companyCodePattern = /^[A-Za-z0-9]{3,4}\d{3,4}$/; //Default of Altus.
            companyInfoVm.alphanumericFormat = 'Alphanumeric';

            activate();

            function activate() {

                // PubSubs
                $scope.$on('company:uiValidation', function(e, data) {
                    onTriggerValidation();
                });

                $scope.$on('company:uiReset', function(e, data) {
                    onUIReset();
                });

                companyService.getGeneralSettings().then(function() {
                    if (companyService.generalSettings.CompanyCodeFormat === companyInfoVm.alphanumericFormat){
                        companyInfoVm.companyCodePattern = /^[A-Za-z0-9]{4,16}$/;
                    }
                });
            }

            function changeFields() {
                companyInfoVm.service.is_employer = companyInfoVm.service.checkEmployerType();
                companyInfoVm.service.is_client = companyInfoVm.service.checkClientType();
                companyInfoVm.service.show_archive_button = companyInfoVm.service.showArchiveButton();
                companyInfoVm.service.isClient = _.find(companyInfoVm.service.companyInfoData.CompanyType, {
                    TypeName: 'Client'
                });
            }

            function onUIReset() {
                $scope.companyForm.$setUntouched();
            }

            function onUploadCompleted(data) {
                companyService.setImageUrl(data);
                companyInfoVm.showProgress = false;
                companyService.disableSaving = false;
                companyService.savePhoto();
            }

            function onUploadError(ex) {
                exceptionService.resolve(ex);
            }

            function onUploadStart() {
                companyInfoVm.showProgress = true;
                companyService.disableSaving = true;
            }

            function onUploadValidate(fileObj) {
                var ext = utils.getFileExtension(fileObj.name);
                var isValid = true;

                if (ext != '.jpeg' && ext != '.jpg' && ext != '.png' && ext != '.gif') {
                    isValid = false;
                    var notif = $mdDialog.alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(false)
                        .title('Invalid File')
                        .content('Import file only supports *.xls, *.xlsx, *.csv and *.ods file extensions.')
                        .ariaLabel('Invalid File')
                        .ok('Ok')

                    $mdDialog.show(notif);
                }

                return isValid;
            }

            function onTriggerValidation() {
                if ($scope.companyForm.$invalid) {
                    $scope.companyForm.$submitted = true;
                    return;
                }
            }
        }
    };
})();

(function() {
    'use strict';

    angular.module('app.company', [
            'app.company.create',
            'app.company.view',
            'app.api',
            'app.corelib',
            'app.widgets',
            'app.shared.models'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config(msNavigationServiceProvider) {};

    function runConfig(
        msNavigationService,
        companyClaimsService
    ) {
        msNavigationService.saveItem('apps.contact.createcompany', {
            title: 'Create New Company',
            state: 'app.company_create',
            weight: 4,
            hidden: function() {
                return !companyClaimsService.hasCreateNewCompanyMenu;
            }
        });

        msNavigationService.saveItem('apps.contact.viewcompany', {
            title: 'View Companies',
            state: 'app.company_view',
            weight: 2
        });
    }
})();

(function(){
  'use strict';

  angular.module('app.company')
    .factory('InvoiceTermDialogService', InvoiceTermDialogService);

  /** @ngInject */
  function InvoiceTermDialogService(termsApi) {

    var service = {
      saveTerm : saveTerm
    };

    return service;

    function saveTerm(name){
      return termsApi.saveTerm(name);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.company.create')
    .controller('InvoiceTermDialogController', InvoiceTermDialogController);

  /** @ngInject */

  function InvoiceTermDialogController(InvoiceTermDialogService, $mdDialog, blockUI, utils) {
    var vm = this;

    vm.invoiceTermPattern = /^[0-9][a-zA-Z\d ]+$/;
    vm.onClose = onClose;
    vm.onSave = onSave;

    function onClose(){
      $mdDialog.cancel();
    }

    function onSave(){
      blockUI.start(utils.translate('COMPANYMODULE.SAVING_TERM'));
      InvoiceTermDialogService.saveTerm(vm.Name).then(function(resp){
        blockUI.stop();
        $mdDialog.hide(resp.data);
      }).catch(function(){
        blockUI.stop();
      })
    }
  }

})();


(function() {
    'use strict';

    angular.module('app.company.create')
        .directive('companyDetailsComponent', companyDetailsComponent);

    /** @ngInject */
    function companyDetailsComponent(
        companyService,
        claimsUtilService,
        adminClaimsService,
        companyLookupService,
        companyBranchModel,
        utils,
        $mdDialog,
        $stateParams,
        $rootScope,
        contactApi) {

        return {
            restrict: 'E',
            templateUrl: 'app/main/company/create/companyDetails/company-details.html',
            controller: companyDetailsController,
            controllerAs: 'detailsVm',
            bindToController: true
        };

        function companyDetailsController($scope) {
            var detailsVm = this;
            detailsVm.null = null;
            detailsVm.model = companyService.companyInfoData;
            detailsVm.formTypes = [0, 2]; // Job and Worker type
            detailsVm.service = companyService;
            detailsVm.companyLookups = companyLookupService.companyLookups;
            detailsVm.skillsLookUps = companyLookupService.skillsLookUps;
            detailsVm.rateCards = companyLookupService.rateCards;
            detailsVm.termDays = companyLookupService.termDays;
            detailsVm.checkAccessService = claimsUtilService;
            detailsVm.adminClaimsService = adminClaimsService;
            detailsVm.utilService = utils;

            detailsVm.getLockOut = getLockOut;
            detailsVm.onArchive = onArchive;
            detailsVm.removeSkill = removeSkill;
            detailsVm.addInvoiceTerm = addInvoiceTerm;
            detailsVm.changeCreditType = changeCreditType;
            detailsVm.redirectToIntegrationsPage = redirectToIntegrationsPage;
            detailsVm.redirectToBranchPage = redirectToBranchPage;
            detailsVm.changeBranch = changeBranch;
            detailsVm.removeRequiredAttachmentType = removeRequiredAttachmentType;

            detailsVm.isMyobEnabled = detailsVm.checkAccessService.isMyobEnabled();
            detailsVm.isXeroEnabled = detailsVm.checkAccessService.isXeroEnabled();
            detailsVm.isBillingEnabled = detailsVm.checkAccessService.isBillingEnabled();
            detailsVm.isPayrollEnabled = detailsVm.checkAccessService.isPayrollEnabled();
            detailsVm.isContactlessSignatureEnabled = detailsVm.checkAccessService.isContactlessSignatureEnabled();
            detailsVm.isConfigurableRequiredAttachmentsEnabled = detailsVm.checkAccessService.isConfigurableRequiredAttachmentsEnabled();
            detailsVm.isEmailAttachmentPreferencesEnabled = detailsVm.checkAccessService.isEmailAttachmentPreferencesEnabled();

            $scope.$watch(function () {
                return detailsVm.service.isClient &&
                    detailsVm.checkAccessService.isSiteContactEmailNotificationEnabled() &&
                    detailsVm.checkAccessService.isPaperworkEmailEnabled();
            }, function (newValue) {
                detailsVm.isSendPaperworkToSiteContactCheckboxVisible = newValue;
            });

            detailsVm.companyId = $stateParams.cid;

            activate();

            function changeBranch() {
                detailsVm.service.changeBranch();
            }

            function removeRequiredAttachmentType(index) {
                detailsVm.model.RequiredAttachmentTypes.splice(index, 1);
            }

            function redirectToIntegrationsPage() {
                $rootScope.state.go('app.integrations');
            }

            function redirectToBranchPage() {
                let firstCompanyBranch = companyService.companyInfoData.Branches2[0];
                if (!firstCompanyBranch) return;

                $rootScope.state.go('app.branch_update', {
                    id: firstCompanyBranch.Id
                });
            }

            function changeCreditType(credit_type) {
                if (credit_type === 0 && !detailsVm.model.IsInactive) {
                    var confirm = $mdDialog.confirm()
                        .title(utils.translate('COMPANYMODULE.COMPANIES'))
                        .textContent(utils.translate('COMPANYMODULE.COMPANY_INACTIVE'))
                        .ariaLabel(utils.translate('COMPANYMODULE.COMPANIES'))
                        .ok(utils.translate('COMPANYMODULE.COMPANY_YES'))
                        .cancel(utils.translate('COMPANYMODULE.COMPANY_NO'));
                    $mdDialog.show(confirm)
                        .then(function() {
                            detailsVm.model.IsInactive = true;
                        });
                }
            }

            function addInvoiceTerm() {
                $mdDialog.show({
                        templateUrl: 'app/main/company/create/companyDetails/invoice-term-dialog.html',
                        controller: 'InvoiceTermDialogController as vm'
                    })
                    .then(function(data) {
                        if (data) {
                            companyLookupService.getTerms()
                                .then(function(resp) {
                                    detailsVm.termDays = alasql('select * from ? order by Name asc', [resp.data]);
                                });
                        }
                    });
            }

            function getLockOut(lockoutType) {
                if (lockoutType == 0) {
                    return utils.translate('COMPANYMODULE.COMPANY_SKILL_NO_LOCKOUT');
                }
                if (lockoutType == 1) {
                    return utils.translate('COMPANYMODULE.COMPANY_SKILL_SOFT_LOCKOUT');
                }
                if (lockoutType == 2) {
                    return utils.translate('COMPANYMODULE.COMPANY_SKILL_MEDIUM_LOCKOUT');
                }
                if (lockoutType == 3) {
                    return utils.translate('COMPANYMODULE.COMPANY_SKILL_HARD_LOCKOUT');
                }
            }

            function removeSkill(skill) {
                angular.forEach(companyService.companyInfoData.CompanyRequiredSkills, function(itmSkill) {
                    if (itmSkill.id == skill.id) {
                        angular.forEach(itmSkill.Skills, function(skl, key) {
                            if (skl.id == skill.Id) {
                                itmSkill.Skills.splice(key, 1);
                            }
                        })
                    }
                });
                companyService.formatData();
            }

            function activate() {
                companyService.getMinifiedContacts();

                detailsVm.filtered_divisions = companyLookupService.companyLookups.DivisionsLookUp;
                if (!companyService.isEditMode) {
                    companyService.companyInfoData.Branches.length = 0;
                    angular.forEach(companyLookupService.companyLookups.Branches, function(itm) {
                        companyService.companyInfoData.Branches.push(new companyBranchModel({
                            id: itm.id,
                            Name: itm.Name,
                            CreatedDate: itm.CreatedDate,
                            LastUpdatedDate: itm.LastUpdatedDate,
                            IsActive: itm.IsActive,
                            Division: itm.Division,
                            IsArchived: itm.IsArchived,
                            Selected: false
                        }))
                    }, this);
                }
            }

            function onArchive() {
                companyService.archive(!companyService.companyInfoData.IsArchived);
            }
        };
    };
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.view')
        .controller('AwardsViewController', AwardsViewController);

    function AwardsViewController(
        AwardsViewService,
        $mdDialog,
        $state
    ) {
        var vm = this;

        vm.service = AwardsViewService;
        vm.addAward = addAward;
        vm.editAward = editAward;
        vm.viewRates = viewRates;
        vm.viewClassifications = viewClassifications;
        vm.viewAllowances = viewAllowances;
        vm.viewRules = viewRules;
        vm.viewAddOns = viewAddOns;

        activate(true);

        async function activate(refetchData) {
            await AwardsViewService.loadAwards(refetchData);
        }

        function addAward() {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/view/dialog/award-dialog.html',
                controller: 'ManageAwardDialogController as vm',
                locals: {
                    award: null
                }
            }).then(function() {
                activate(false);
            });
        }

        function editAward(award) {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/view/dialog/award-dialog.html',
                controller: 'ManageAwardDialogController as vm',
                locals: {
                    award: award
                }
            }).then(function() {
                activate(false);
            });
        }

        function viewRates(award) {
            $state.go('app.manage_awardrates', {
                awardId: award.Id
            });
        }

        function viewClassifications(award) {
            $state.go('app.manage_awardclassifications', {
                awardId: award.Id
            });
        }

        function viewAllowances(award) {
            $state.go('app.manage_awardallowances', {
                awardId: award.Id
            });
        }

        function viewRules(award) {
            $state.go('app.manage_awardrules', {
                awardId: award.Id
            });
        }

        function viewAddOns(award) {
            $state.go('app.manage_awardaddons', {
                awardId: award.Id
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards', [
            'app.manage-awards.view',
            'app.manage-awards.classifications',
            'app.manage-awards.classificationrates',
            'app.manage-awards.rates',
            'app.manage-awards.allowances',
            'app.manage-awards.allowance-rates',
            'app.manage-awards.rules',
            'app.manage-awards.addons',
        ])
        .config(config);

    /** @ngInject */
    function config() {}
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards')
        .factory('AwardsViewService', AwardsViewService);

    /** @ngInject */
    function AwardsViewService(
        awardsApi,
        branchApi
    ) {
        var service = {
            isAwardsLoaded: false,
            awards: [],
            loadAwards: loadAwards,

            isBranchesLoaded: false,
            branchesLookup: [],
            loadBranchesLookup: loadBranchesLookup
        };

        return service;

        async function loadAwards(forceReload) {
            if (forceReload) {
                service.isAwardsLoaded = false;
            }

            if (service.isAwardsLoaded) {
                return;
            }

            service.awards = [];

            var resp = await awardsApi.getAwards();
            resp.data.forEach(award => {
                award.PayRates = [];

                if (award && award.Classifications && award.Classifications.length > 0) {
                    award.Classifications[0].Rules.forEach(rule => {
                        award.PayRates.push({
                            Order: rule.RuleOrder,
                            Name: rule.RuleName
                        });
                    });
                }

                service.awards.push(award);
            });

            service.isAwardsLoaded = true;
        }

        async function loadBranchesLookup(forceReload) {
            if (forceReload) {
                service.isBranchesLoaded = false;
            }

            if (service.isBranchesLoaded) {
                return;
            }

            service.branchesLookup = [];

            var resp = await branchApi.getBranchLookUp();
            service.branchesLookup = resp.data;

            service.isBranchesLoaded = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.rules', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.manage_awardrules', {
            url: '/manage-awards/:awardId/rules',
            views: {
                'content@app': {
                    templateUrl: 'app/main/awards/manage/rules/award-rules.html',
                    controller: 'AwardRulesController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasManageAwardsMenu;
                }]
            },
            title: 'Manage Rules',
            titleBar: 'Alloc8 - Manage Rules'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.rules')
        .controller('AwardRulesController', AwardRulesController);

    /** @ngInject */
    function AwardRulesController(
        $stateParams,
        AwardsViewService,
        searchDelay,
        $mdDialog,
        CONDITION_OPERATORS,
        CONDITION_VALUE_TYPES
    ) {
        var vm = this;

        const CONDITION_TYPE_FIXED = 0;

        const PREPROCESS_METHOD_MIN_SHIFT_LENGTHS_AT_CURRENT_RATE = 1;
        const PREPROCESS_METHOD_MIN_SHIFT_LENGTHS_AFTER_TRAVEL_HOURS_AT_CURRENT_RATE = 3;
        const PREPROCESS_METHOD_MIN_SHIFT_LENGTHS_AFTER_TRAVEL_HOURS_IF_ALLOWANCE_IS_HOURLY_AT_CURRENT_RATE = 4;
        const PREPROCESS_METHOD_COMBINE_CONTINUING_TIMESHEET = 2;
        const PREPROCESS_METHOD_MIN_SHIFT_LENGTHS_AT_CURRENT_RATE_AND_DO_NOT_REDUCE_TRAVEL_HOURS = 5;
        const PREPROCESS_METHOD_MIN_SHIFT_THEN_PAY_COMBINED_TRAVEL = 6;

        vm.service = AwardsViewService;
        vm.award = null;
        vm.settings = [];

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            sort: false,
            initComplete: function() {
                searchTable();
            }
        };
        vm.searchText = null;
        vm.searchTable = searchTable;

        vm.viewConditions = viewConditions;

        activate();

        async function activate() {
            await AwardsViewService.loadAwards();

            vm.award = AwardsViewService.awards.find(p => p.Id == $stateParams.awardId);

            if (vm.award) {
                vm.award.RequiredMinHoursWorkedForSubsequentRules = 1;

                vm.settings.push({
                    SettingName: "Total Shifts Hours Settings",
                    SettingDescription: "",
                    IsEnabled: true,
                    Conditions: [{
                            ConditionOrder: 1,
                            ConditionTypeId: CONDITION_TYPE_FIXED,
                            ConditionOperatorId: null,
                            ConditionName: "Add Past Job Hours Worked To Total Shift Hours",
                            ConditionValue: vm.award.AddPastJobHoursWorkedToTotalShiftHours,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN
                        },
                        {
                            ConditionOrder: 2,
                            ConditionTypeId: CONDITION_TYPE_FIXED,
                            ConditionOperatorId: CONDITION_OPERATORS.AND,
                            ConditionName: "Reset Total Shift Hours After Break Between Shifts Hours",
                            ConditionValue: vm.award.ResetTotalShiftHoursAfterBreakBetweenShiftsHours,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                        }, {
                            ConditionOrder: 3,
                            ConditionTypeId: CONDITION_TYPE_FIXED,
                            ConditionOperatorId: CONDITION_OPERATORS.AND,
                            ConditionName: "Reset Total Shift Hours At Shift Start, If Shift Crosses Midnight",
                            ConditionValue: vm.award.ResetTotalShiftHoursAtShiftStartIfShiftCrossesMidnight,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN
                        }
                    ]
                });

                vm.settings.push({
                    SettingName: "Night Shift Settings",
                    SettingDescription: "",
                    IsEnabled: !!vm.award.NightShiftEndTime || !!vm.award.NightShiftStartTime,
                    Conditions: [{
                            ConditionOrder: 1,
                            ConditionTypeId: CONDITION_TYPE_FIXED,
                            ConditionOperatorId: null,
                            ConditionName: "Start Time",
                            ConditionValue: vm.award.NightShiftEndTime,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT
                        },
                        {
                            ConditionOrder: 2,
                            ConditionTypeId: CONDITION_TYPE_FIXED,
                            ConditionOperatorId: CONDITION_OPERATORS.AND,
                            ConditionName: "End Time",
                            ConditionValue: vm.award.NightShiftStartTime,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT
                        }
                    ]
                });

                vm.settings.push({
                    SettingName: "Subsequent Rules Settings",
                    SettingDescription: "",
                    IsEnabled: !!vm.award.RequiredMinHoursWorkedForSubsequentRules,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Required Min. Hours Worked",
                        ConditionValue: vm.award.RequiredMinHoursWorkedForSubsequentRules,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }]
                });

                vm.settings.push({
                    SettingName: "Apply a fixed loading on hourly pay",
                    SettingDescription: "",
                    IsEnabled: !!vm.award.ApplyLoadingOnLoading,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Loading Percentage",
                        ConditionValue: vm.award.ApplyLoadingOnLoading,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER
                    }]
                });

                vm.settings.push({
                    SettingName: "Round hourly pay to nearest hundredth decimal",
                    SettingDescription: "",
                    IsEnabled: vm.award.RoundCasualRateDecimalValueToNearestHundredth,
                    Conditions: []
                });

                vm.settings.push({
                    SettingName: "Apply Weekend Minimum Shift Hours",
                    SettingDescription: "",
                    IsEnabled: !!vm.award.WeekendMinimumShiftHours,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Min. Shift Hours",
                        ConditionValue: vm.award.WeekendMinimumShiftHours,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }, {
                        ConditionOrder: 2,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Weekend Start Day",
                        ConditionValue: vm.award.WeekendStartDayOfWeek,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.DAY
                    }, {
                        ConditionOrder: 3,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Weekend Start Time",
                        ConditionValue: vm.award.WeekendStartTime,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT
                    }, {
                        ConditionOrder: 4,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Weekend Finish Day",
                        ConditionValue: vm.award.WeekendFinishDayOfWeek,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.DAY
                    }, {
                        ConditionOrder: 5,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Weekend Finish Time",
                        ConditionValue: vm.award.WeekendFinishTime,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT
                    }, {
                        ConditionOrder: 6,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Consdier Each Day in the Weekend Separately",
                        ConditionValue: vm.award.IsWeekendIndividualDays,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN
                    }]
                });

                vm.settings.push({
                    SettingName: "Split Shift",
                    SettingDescription: "",
                    IsEnabled: !!vm.award.EnableSplitShift,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Max. Interval In Minutes",
                        ConditionValue: vm.award.SplitShiftMaximumIntervalInMinutes,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER
                    }, {
                        ConditionOrder: 2,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Max. Hours Worked Per Shift",
                        ConditionValue: vm.award.SplitShiftMaximumHoursWorkedPerShift,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }]
                });

                let applyContinousShift = false;
                if (vm.award.PreProcesses) {
                    applyContinousShift = vm.award.PreProcesses.findIndex(p => p.PreProcessMethod == PREPROCESS_METHOD_COMBINE_CONTINUING_TIMESHEET) > -1;
                }

                vm.settings.push({
                    SettingName: "Combine Continuous Shifts",
                    SettingDescription: "",
                    IsEnabled: applyContinousShift,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Pay Continuous Shift Interval",
                        ConditionValue: vm.award.IsContinuousShiftIntervalPaid,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN
                    }, {
                        ConditionOrder: 2,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Continuous Shift Interval In Minutes",
                        ConditionValue: vm.award.ContinuousShiftInterval,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER
                    }, {
                        ConditionOrder: 3,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Pay Travel Inbetween Continuous Shift",
                        ConditionValue: vm.award.IsTravelInBetweenContinuousShiftPaid,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN
                    }, {
                        ConditionOrder: 4,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Ignore Travel In Continuous Shift",
                        ConditionValue: vm.award.IgnoreTravelInContinuousShift,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN
                    }]
                });

                vm.settings.push({
                    SettingName: "Count Travel Hours as Work Hours for Rates & Allowances",
                    SettingDescription: "",
                    IsEnabled: !!vm.award.IsTravelCountedTowardsHoursWorked,
                    Conditions: []
                });

                vm.settings.push({
                    SettingName: "Pay Min. Shift Hours on Public Holiday",
                    SettingDescription: "",
                    IsEnabled: !!vm.award.PublicHolidayMinimumShiftHours,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        ConditionName: "Min. Shift Hours",
                        ConditionValue: vm.award.PublicHolidayMinimumShiftHours,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }]
                });

                let minShiftOption1 = null;
                if (vm.award.PreProcesses) {
                    minShiftOption1 = vm.award.PreProcesses.find(p => p.PreProcessMethod == PREPROCESS_METHOD_MIN_SHIFT_LENGTHS_AT_CURRENT_RATE);
                }

                vm.settings.push({
                    SettingName: "Pay Min. Shift Hours and Do Not Pay Travel Hours",
                    SettingDescription: "",
                    IsEnabled: minShiftOption1 != null,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Min. Shift Hours",
                        ConditionValue: minShiftOption1 != null ? minShiftOption1.MinimumShiftHours : null,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }]
                });

                let minShiftOption5 = null;
                if (vm.award.PreProcesses) {
                    minShiftOption5 = vm.award.PreProcesses.find(p => p.PreProcessMethod == PREPROCESS_METHOD_MIN_SHIFT_LENGTHS_AT_CURRENT_RATE_AND_DO_NOT_REDUCE_TRAVEL_HOURS);
                }

                vm.settings.push({
                    SettingName: "Pay Min. Shift Hours And Pay Travel Hours On Top",
                    SettingDescription: "",
                    IsEnabled: minShiftOption5 != null,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Min. Shift Hours",
                        ConditionValue: minShiftOption5 != null ? minShiftOption5.MinimumShiftHours : null,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }]
                });

                let minShiftOption4 = null;
                if (vm.award.PreProcesses) {
                    minShiftOption4 = vm.award.PreProcesses.find(p => p.PreProcessMethod == PREPROCESS_METHOD_MIN_SHIFT_LENGTHS_AFTER_TRAVEL_HOURS_IF_ALLOWANCE_IS_HOURLY_AT_CURRENT_RATE);
                }

                vm.settings.push({
                    SettingName: "Pay Min. Shift Hours excl. Travel Hours, If Travel is Paid As Hourly Allowance",
                    SettingDescription: "",
                    IsEnabled: minShiftOption4 != null,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Min. Shift Hours",
                        ConditionValue: minShiftOption4 != null ? minShiftOption4.MinimumShiftHours : null,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }]
                });

                let minShiftOption3 = null;
                if (vm.award.PreProcesses) {
                    minShiftOption3 = vm.award.PreProcesses.find(p => p.PreProcessMethod == PREPROCESS_METHOD_MIN_SHIFT_LENGTHS_AFTER_TRAVEL_HOURS_AT_CURRENT_RATE);
                }

                vm.settings.push({
                    SettingName: "Pay Min. Shift Hours on Total Shift Hours",
                    SettingDescription: "",
                    IsEnabled: minShiftOption3 != null,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Min. Shift Hours",
                        ConditionValue: minShiftOption3 != null ? minShiftOption3.MinimumShiftHours : null,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }]
                });


                let minShiftOption6 = null;
                if (vm.award.PreProcesses) {
                    minShiftOption6 = vm.award.PreProcesses.find(p => p.PreProcessMethod == PREPROCESS_METHOD_MIN_SHIFT_THEN_PAY_COMBINED_TRAVEL);
                }

                vm.settings.push({
                    SettingName: "Pay Min. Shift Hours incl Travel Hours",
                    SettingDescription: "",
                    IsEnabled: minShiftOption6 != null,
                    Conditions: [{
                        ConditionOrder: 1,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        ConditionName: "Min. Shift Hours",
                        ConditionValue: minShiftOption6 != null ? minShiftOption6.MinimumShiftHours : null,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS
                    }]
                });
            }
        }

        function searchTable() {
            setTimeout(function() {
                if (!_.isNil(vm.searchText)) {
                    vm.dtInstance.DataTable.search(vm.searchText);
                    vm.dtInstance.DataTable.search(vm.searchText).draw();
                }
            }, searchDelay);
        }

        function viewConditions(setting) {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/dialogs/award-conditions-dialog.html',
                controller: 'AwardConditionsDialogController as vm',
                locals: {
                    dialogTitle: setting.SettingName,
                    conditions: setting.Conditions,
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.rates', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.manage_awardrates', {
            url: '/manage-awards/:awardId/rates',
            views: {
                'content@app': {
                    templateUrl: 'app/main/awards/manage/rates/award-rates.html',
                    controller: 'AwardRatesController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasManageAwardsMenu;
                }]
            },
            title: 'Manage Rates',
            titleBar: 'Alloc8 - Manage Rates'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.rates')
        .controller('AwardRatesController', AwardRatesController);

    /** @ngInject */
    function AwardRatesController(
        $stateParams,
        AwardsViewService,
        searchDelay,
        $mdDialog,
        CONDITION_OPERATORS,
        CONDITION_VALUE_TYPES
    ) {
        const CONDITION_TYPE_FIXED = 0;
        const CONDITION_TYPE_DAY_OF_WEEK = 1;
        const CONDITION_TYPE_TIME_OF_DAY = 2;
        const CONDITION_TYPE_ORDINARY_HOURS = 3;
        const CONDITION_TYPE_TOTAL_SHIFT_HOURS_FOR_TODAY = 4;
        const CONDITION_TYPE_TOTAL_BREAK_BETWEEN_SHIFT_HOURS = 5;
        const CONDITION_TYPE_IS_LAST_RULE_LOADING_LOWER = 6;
        const CONDITION_TYPE_IS_PUBLIC_HOLIDAY = 7;
        const CONDITION_TYPE_NUMBER_OF_SHIFTS_PREDOMINANTLY_IN_THIS_TIME_OF_DAY = 8;
        const CONDITION_TYPE_CUSTOM_PROPERTY_VALUE = 9;
        const CONDITION_TYPE_LAST_SHIFT_TOTAL_HOURS_WORKED = 10;
        const CONDITION_TYPE_JOB_START_TIME = 11;
        const CONDITION_TYPE_EMPLOYMENT_STATUS = 12;
        const CONDITION_TYPE_IS_COMPLETE_NIGHT_SHIFT = 13;
        const CONDITION_TYPE_TOTAL_HOURS_WORKED_DURING_WEEK = 14;
        const CONDITION_TYPE_HAS_WORKED_WITHIN_INTERVAL = 15;

        var vm = this;

        vm.service = AwardsViewService;
        vm.award = null;
        vm.rates = [];

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            sort: false,
            initComplete: function() {
                searchTable();
            }
        };
        vm.searchText = null;
        vm.searchTable = searchTable;

        vm.sortableOptions = {
            handle: '> .drag-handle'
        };
        vm.viewConditions = viewConditions;

        activate();

        async function activate() {
            await AwardsViewService.loadAwards();

            vm.award = AwardsViewService.awards.find(p => p.Id == $stateParams.awardId);

            if (vm.award && vm.award.Classifications && vm.award.Classifications.length > 0) {
                vm.award.Classifications[0].Rules.forEach(rule => {
                    let conditions = [];
                    let fixedConditions = getFixedConditions(rule);

                    rule.Conditions.forEach(condition => {
                        var appliedCondition = getAppliedConditions(condition);
                        if (appliedCondition && appliedCondition.ConditionValue) {
                            appliedCondition.CanReOrder = true;
                            conditions.push(appliedCondition);
                        }
                    });

                    if (conditions.length > 0 && fixedConditions.length > 0) {
                        conditions.sort((a, b) => a.ConditionOrder - b.ConditionOrder);
                        conditions[0].ConditionOperatorId = CONDITION_OPERATORS.AND;
                    }

                    conditions.forEach(condition => {
                        condition.ConditionCompareTypeName = getConditionCompareTypeName(condition);
                    });

                    vm.rates.push({
                        RateId: rule.Id,
                        RateOrder: rule.RuleOrder,
                        RateName: rule.RuleName,
                        RateDescription: rule.Description,
                        Conditions: fixedConditions.concat(conditions),
                        IsActive: !rule.DoNotPayThisRule
                    });
                });
            }
        }

        function getFixedConditions(rule) {
            let rateConditions = [];

            if (rule.IsOrdinaryHours) {
                rateConditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Is Ordinary Hours Rate",
                    ConditionValue: rule.IsOrdinaryHours,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                    ConditionCompareTypeId: null
                });
            }

            if (rule.MaxPayableHoursForRule) {
                rateConditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Max. Payable Hours",
                    ConditionValue: rule.MaxPayableHoursForRule,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                    ConditionCompareTypeId: null
                });
            }

            if (rule.MaxTimesRuleCanBeAppliedInAWeek) {
                rateConditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Max. Times Rule Can Be Applied In A Week",
                    ConditionValue: rule.MaxTimesRuleCanBeAppliedInAWeek,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER,
                    ConditionCompareTypeId: null
                });
            }

            if (rateConditions.length > 0) {
                rateConditions[0].ConditionOperatorId = null;
            }

            return rateConditions;
        }

        function getAppliedConditions(condition) {
            switch (condition.ConditionType) {
                case CONDITION_TYPE_ORDINARY_HOURS:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Total Ordinary Hours",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_TOTAL_SHIFT_HOURS_FOR_TODAY:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Total Shift Hours For Today",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_TOTAL_BREAK_BETWEEN_SHIFT_HOURS:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Total Break Between Shift Hours",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_NUMBER_OF_SHIFTS_PREDOMINANTLY_IN_THIS_TIME_OF_DAY:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "# of Shifts Predominantly in this Time of Day",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_LAST_SHIFT_TOTAL_HOURS_WORKED:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Total Hours Worked in Previous Shift",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_TOTAL_HOURS_WORKED_DURING_WEEK:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Total Hours Worked During Week",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_JOB_START_TIME:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Job Start Time",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_DAY_OF_WEEK:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Day of Week",
                            ConditionValue: condition.ConditionDays,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.DAYS,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_TIME_OF_DAY:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Time of Day",
                            ConditionValue: condition.ConditionStartTime + ' - ' + condition.ConditionEndTime,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_HAS_WORKED_WITHIN_INTERVAL:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Has Worked Within Interval",
                            ConditionValue: condition.ConditionStartTime + ' - ' + condition.ConditionEndTime,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_CUSTOM_PROPERTY_VALUE:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Custom Condition",
                            ConditionValue: condition.ConditionCustomPropertyField,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                            ConditionCompareTypeId: condition.ConditionCustomPropertyValidValues
                    };
                case CONDITION_TYPE_EMPLOYMENT_STATUS:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Employment Status",
                            ConditionValue: condition.ConditionEmploymentStatuses,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.EMPLOYMENT_STATUSES,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_IS_PUBLIC_HOLIDAY:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Public Holiday",
                            ConditionValue: true,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_IS_COMPLETE_NIGHT_SHIFT:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Complete Night Shift",
                            ConditionValue: true,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_IS_LAST_RULE_LOADING_LOWER:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.ConditionType,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Do not pay lower amount if previous rule pays higher",
                            ConditionValue: true,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                            ConditionCompareTypeId: null
                    };
            }
        }

        function searchTable() {
            setTimeout(function() {
                if (!_.isNil(vm.searchText)) {
                    vm.dtInstance.DataTable.search(vm.searchText);
                    vm.dtInstance.DataTable.search(vm.searchText).draw();
                }
            }, searchDelay);
        }

        function viewConditions(rate) {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/dialogs/award-conditions-dialog.html',
                controller: 'AwardConditionsDialogController as vm',
                locals: {
                    dialogTitle: rate.RateName,
                    conditions: rate.Conditions,
                }
            });
        }

        function getConditionCompareTypeName(condition) {
            if (!condition.ConditionCompareTypeId) {
                return "";
            }

            const isNumericCompareType =
                condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.NUMBER ||
                condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.HOURS ||
                condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.KMS;

            if (isNumericCompareType) {
                switch (condition.ConditionCompareTypeId) {
                    case 1:
                        return "Less Than";
                    case 2:
                        return "Less Than Or Equal To";
                    case 3:
                        return "Greater Than";
                    case 4:
                        return "Greater Than Or Equal To";
                }

                return "Unknown Numeric Compare Type: " + condition.ConditionCompareTypeId;
            }

            return condition.ConditionCompareTypeId;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards')
        .controller('AwardConditionsDialogController', AwardConditionsDialogController);

    function AwardConditionsDialogController(
        locals,
        $mdDialog,
        $filter,
        CONDITION_OPERATORS,
        CONDITION_VALUE_TYPES
    ) {
        var vm = this;

        vm.dialogTitle = locals.dialogTitle;
        vm.conditions = locals.conditions;

        vm.sortableOptions = {
            handle: '.drag-handle',
        };

        activate();

        vm.onClose = onClose;

        function onClose() {
            $mdDialog.hide();
        }

        function activate() {
            if (!locals.conditions) {
                return;
            }

            locals.conditions.forEach(condition => {
                condition.ConditionOperatorName = getConditionOperatorName(condition);
                condition.ConditionValueDisplayText = getConditionValueDisplayText(condition);
            });
        }

        function getConditionOperatorName(condition) {
            if (condition.ConditionOperatorId == CONDITION_OPERATORS.OR) {
                return "OR";
            }

            if (condition.ConditionOperatorId == CONDITION_OPERATORS.AND) {
                return "AND";
            }

            return condition.ConditionOperatorId;
        }

        function getConditionValueDisplayText(condition) {
            if (!condition.ConditionValue ||
                (Array.isArray(condition.ConditionValue) && condition.ConditionValue.length < 1)) {
                return "";
            }
            if (condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.NUMBER) {
                return $filter('number')(condition.ConditionValue, 0);
            }

            if (condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.HOURS) {
                return $filter('number')(condition.ConditionValue, 2) + " hr";
            }

            if (condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.KMS) {
                return $filter('number')(condition.ConditionValue, 2) + " km";
            }

            if (condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.DAY) {
                return getDayTextFromDayId(condition.ConditionValue);
            }

            if (condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.DAYS) {
                var days = condition.ConditionValue.map(dayId => {
                    return getDayTextFromDayId(dayId);
                });
                return days.join(", ");
            }

            if (condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.EMPLOYMENT_STATUSES) {
                var employmentStatuses = condition.ConditionValue.map(statusId => {
                    switch (statusId) {
                        case 1:
                            return "Casual";
                        case 2:
                            return "Labour Hire";
                        case 3:
                            return "Permanent Full Time";
                        case 4:
                            return "Permanent Part Time";
                        case 5:
                            return "Salary";
                        default:
                            return "None";
                    }
                });

                return employmentStatuses.join(", ");
            }

            return condition.ConditionValueDisplayText || condition.ConditionValue;
        }

        function getDayTextFromDayId(dayId) {
            switch (dayId) {
                case 0:
                    return "Sunday";
                case 1:
                    return "Monday";
                case 2:
                    return "Tuesday";
                case 3:
                    return "Wednesday";
                case 4:
                    return "Thursday";
                case 5:
                    return "Friday";
                case 6:
                    return "Saturday";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.classifications')
        .controller('AwardClassificationsController', AwardClassificationsController);

    /** @ngInject */
    function AwardClassificationsController(
        $state,
        $stateParams,
        AwardsViewService,
        searchDelay,
        $mdDialog
    ) {
        var vm = this;

        vm.service = AwardsViewService;
        vm.award = null;
        vm.classifications = [];

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            sort: false,
            initComplete: function() {
                searchTable();
            }
        };
        vm.searchText = null;
        vm.searchTable = searchTable;

        vm.addClassification = addClassification;
        vm.editClassification = editClassification;
        vm.viewRates = viewRates;

        activate(true);

        async function activate(refetchData) {
            await AwardsViewService.loadAwards(refetchData);
            await AwardsViewService.loadBranchesLookup(refetchData);

            vm.award = vm.service.awards.find(p => p.Id == $stateParams.awardId);

            if (vm.award && vm.award.Classifications) {
                vm.classifications = [];
                vm.award.Classifications.forEach(classification => {
                    vm.classifications.push({
                        Name: classification.ClassificationName,
                        Description: classification.Description,
                        BaseRateOfPay: classification.BaseRateOfPay,
                        IsArchived: classification.IsArchived,
                        BranchNames: getBranchNamesFromIds(classification.BranchIds)
                    });
                });
            }
        }

        function searchTable() {
            setTimeout(function() {
                if (!_.isNil(vm.searchText)) {
                    vm.dtInstance.DataTable.search(vm.searchText);
                    vm.dtInstance.DataTable.search(vm.searchText).draw();
                }
            }, searchDelay);
        }

        function addClassification() {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/classifications/dialog/classification-dialog.html',
                controller: 'ManageClassificationDialogController as vm',
                locals: {
                    isEditMode: false,
                    award: vm.award,
                    classificationName: null
                }
            }).then(function() {
                activate(false);
            });
        }

        function editClassification(classificationName) {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/classifications/dialog/classification-dialog.html',
                controller: 'ManageClassificationDialogController as vm',
                locals: {
                    isEditMode: true,
                    award: vm.award,
                    classificationName: classificationName
                }
            }).then(function() {
                activate(false);
            });
        }

        function viewRates(classificationName) {
            $state.go('app.manage_awardclassificationrates', {
                awardId: vm.award.Id,
                classificationName: classificationName
            });
        }

        function getBranchNamesFromIds(branchIds) {
            if (!branchIds) {
                return;
            }

            let branchNames = branchIds.map(branchId => {
                const branch = AwardsViewService.branchesLookup.find(b => b.Id == branchId);
                return !!branch ? branch.Name : branchId;
            });

            return branchNames;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.classificationrates')
        .controller('AwardClassificationRatesController', AwardClassificationRatesController);

    /** @ngInject */
    function AwardClassificationRatesController(
        $stateParams,
        AwardsViewService,
        searchDelay,
        $mdDialog
    ) {
        const RATE_TYPE_STANDARD = 1;
        const RATE_TYPE_CASUAL = 2;

        var vm = this;

        vm.service = AwardsViewService;
        vm.award = null;
        vm.classification = null;
        vm.classificationRates = [];

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            sort: false,
            initComplete: function() {
                searchTable();
            }
        };
        vm.searchText = null;
        vm.searchTable = searchTable;

        vm.editRate = editRate;

        activate(true);

        async function activate(refetchData) {
            await AwardsViewService.loadAwards(refetchData);

            vm.award = vm.service.awards.find(p => p.Id == $stateParams.awardId);

            if (vm.award && vm.award.Classifications) {
                vm.classification = vm.award.Classifications.find(p => p.ClassificationName == $stateParams.classificationName);

                if (vm.classification && vm.classification.Rules) {
                    vm.classificationRates = [];
                    vm.classification.Rules.forEach(rule => {
                        if (rule.RuleCode) {
                            vm.classificationRates.push({
                                BaseRate: vm.classification.BaseRateOfPay,
                                RateId: rule.Id,
                                RateOrder: rule.RuleOrder,
                                RateName: rule.RuleName,
                                RateDescription: rule.Description,
                                RateType: RATE_TYPE_STANDARD,
                                RateTypeDisplayName: 'Standard',
                                PayCode: rule.RuleCode,
                                PayRate: (vm.classification.BaseRateOfPay * rule.RuleLoading) / 100
                            });
                        } else {
                            vm.classificationRates.push({
                                BaseRate: vm.classification.BaseRateOfPay,
                                RateId: rule.Id,
                                RateOrder: rule.RuleOrder,
                                RateName: rule.RuleName,
                                RateDescription: rule.Description,
                                RateType: RATE_TYPE_STANDARD,
                                RateTypeDisplayName: 'Standard',
                                PayCode: null,
                                PayRate: null
                            });
                        }

                        if (rule.CasualCode) {
                            vm.classificationRates.push({
                                BaseRate: vm.classification.BaseRateOfPay,
                                RateId: rule.Id,
                                RateOrder: rule.RuleOrder,
                                RateName: rule.RuleName,
                                RateDescription: rule.Description,
                                RateType: RATE_TYPE_CASUAL,
                                RateTypeDisplayName: 'Casual',
                                PayCode: rule.CasualCode,
                                PayRate: (vm.classification.BaseRateOfPay * rule.CasualLoading) / 100
                            });
                        } else {
                            vm.classificationRates.push({
                                BaseRate: vm.classification.BaseRateOfPay,
                                RateId: rule.Id,
                                RateOrder: rule.RuleOrder,
                                RateName: rule.RuleName,
                                RateDescription: rule.Description,
                                RateType: RATE_TYPE_CASUAL,
                                RateTypeDisplayName: 'Casual',
                                PayCode: null,
                                PayRate: null
                            });
                        }
                    });
                }
            }
        }

        function searchTable() {
            setTimeout(function() {
                if (!_.isNil(vm.searchText)) {
                    vm.dtInstance.DataTable.search(vm.searchText);
                    vm.dtInstance.DataTable.search(vm.searchText).draw();
                }
            }, searchDelay);
        }

        function editRate(classificationRate) {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/classification-rates/dialog/classification-rate-dialog.html',
                controller: 'ManageClassificationRateDialogController as vm',
                locals: {
                    award: vm.award,
                    classificationName: $stateParams.classificationName,
                    rateId: classificationRate.RateId,
                    rateType: classificationRate.RateType
                }
            }).then(function() {
                activate(false);
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.awards.view')
    .controller('OldAwardsViewController', OldAwardsViewController);

  function OldAwardsViewController(OldAwardsViewService, searchDelay, _) {

    var vm = this;
    vm.service = OldAwardsViewService;
    vm.dtInstance1 = {};
    vm.dtInstance2 = {};
    vm.dtInstance3 = {};
    vm.dtOptions = {
      dom: 'rt<"bottom"lip><"clear">',
      pagingType: 'simple',
      autoWidth: false,
      searchDelay : searchDelay,
      responsive: true,
      sort: false,
      initComplete : function(){
        searchTable(1);
        searchTable(2);
        searchTable(3);
      }
    };

    vm.activate = activate;
    vm.searchTable = searchTable;
    vm._ = _;
    vm.activate();

    function activate(){
      vm.service.getAll();
    }

    function searchTable(table) {
      setTimeout(function () {
        if(table == 1){
          if(!_.isNil(vm.service.query1)){
            vm.dtInstance1.DataTable.search(vm.service.query1);
            vm.dtInstance1.DataTable.search(vm.service.query1).draw();
          }
        }

        if(table == 2){
          if(!_.isNil(vm.service.query2)){
            vm.dtInstance2.DataTable.search(vm.service.query2);
            vm.dtInstance2.DataTable.search(vm.service.query2).draw();
          }

        }

        if(table == 3){
          if(!_.isNil(vm.service.query3)){
            vm.dtInstance3.DataTable.search(vm.service.query3);
            vm.dtInstance3.DataTable.search(vm.service.query3).draw();
          }
        }

      }, searchDelay);
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.allowances', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.manage_awardallowances', {
            url: '/manage-awards/:awardId/allowances',
            views: {
                'content@app': {
                    templateUrl: 'app/main/awards/manage/allowances/award-allowances.html',
                    controller: 'AwardAllowancesController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasManageAwardsMenu;
                }]
            },
            title: 'Manage Allowances',
            titleBar: 'Alloc8 - Manage Allowances'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.allowances')
        .controller('AwardAllowancesController', AwardAllowancesController);

    /** @ngInject */
    function AwardAllowancesController(
        $stateParams,
        AwardsViewService,
        searchDelay,
        $mdDialog,
        $state,
        CONDITION_OPERATORS,
        CONDITION_VALUE_TYPES
    ) {
        const ALLOWANCE_CATEGORY_SHIFT_ALLOWANCE = 0;
        const ALLOWANCE_CATEGORY_AUTOMATIC_ALLOWANCE = 1;

        const ALLOWANCE_HOURLY_MULTIPLIER_TOTAL_TRAVEL_HOURS = 1;
        const ALLOWANCE_HOURLY_MULTIPLIER_TOTAL_SHIFT_HOURS = 2;
        const ALLOWANCE_HOURLY_MULTIPLIER_TRAVEL_HOURS_FROM_JOB = 4;
        const ALLOWANCE_HOURLY_MULTIPLIER_TRAVEL_HOURS_TO_JOB = 5;

        const CONDITION_TYPE_FIXED = 0;
        const CONDITION_TYPE_TOTAL_WORKED_HOURS = 1;
        const CONDITION_TYPE_TOTAL_TRAVEL_DISTANCE = 2;
        const CONDITION_TYPE_TRAVEL_DISTANCE_TO_JOB = 3;
        const CONDITION_TYPE_TRAVEL_DURING_DISTANCE = 4;
        const CONDITION_TYPE_TRAVEL_DISTANCE_FROM_JOB = 5;
        const CONDITION_TYPE_EMPLOYEE_CODE = 6;
        const CONDITION_TYPE_TOTAL_TRAVEL_HOURS = 7;
        const CONDITION_TYPE_INTERPRETER_OUTPUT_COUNT = 8;
        const CONDITION_TYPE_DAY_OF_WEEK = 9;
        const CONDITION_TYPE_TIME_OF_DAY = 10;
        const CONDITION_TYPE_CLIENT_COMPANY_SITE_ALLOWANCE = 11;
        const CONDITION_TYPE_OPERATED_VEHICLE_TYPE = 12;
        const CONDITION_TYPE_TRAVEL_HOURS_TO_JOB = 13;
        const CONDITION_TYPE_TRAVEL_HOURS_FROM_JOB = 14;
        const CONDITION_TYPE_PUBLIC_HOLIDAY = 15;
        const CONDITION_TYPE_SHIFT_OVERLAPS_INTERVAL = 16;

        var vm = this;

        vm.service = AwardsViewService;
        vm.award = null;
        vm.allowances = [];
        vm.allowanceCategories = [{
            Id: ALLOWANCE_CATEGORY_SHIFT_ALLOWANCE,
            Name: "Shift Allowance"
        }, {
            Id: ALLOWANCE_CATEGORY_AUTOMATIC_ALLOWANCE,
            Name: "Automatic Allowance"
        }]
        vm.getAllowanceCategoryName = getAllowanceCategoryName;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            sort: false,
            initComplete: function() {
                searchTable();
            }
        };
        vm.searchText = null;
        vm.searchTable = searchTable;

        vm.viewConditions = viewConditions;
        vm.viewRates = viewRates;

        activate();

        async function activate() {
            await AwardsViewService.loadAwards();

            vm.award = vm.service.awards.find(p => p.Id == $stateParams.awardId);

            if (!vm.award || !vm.award.Allowances) {
                return;
            }

            vm.award.Allowances.forEach(allowance => {
                let conditions = [];
                let fixedConditions = getFixedConditions(allowance);

                allowance.Conditions.forEach(condition => {
                    var appliedCondition = getAppliedConditions(condition);
                    if (appliedCondition && appliedCondition.ConditionValue) {
                        appliedCondition.CanReOrder = true;
                        conditions.push(appliedCondition);
                    }
                });

                if (conditions.length > 0 && fixedConditions.length > 0) {
                    conditions.sort((a, b) => a.ConditionOrder - b.ConditionOrder);
                    conditions[0].ConditionOperatorId = CONDITION_OPERATORS.AND;
                }

                conditions = fixedConditions.concat(conditions)

                conditions.forEach(condition => {
                    condition.ConditionCompareTypeName = getConditionCompareTypeName(condition);
                    condition.ConditionValueDisplayText = getConditionValueDisplayText(condition);
                });

                let classificationNames = [...new Set(allowance.ClassificationRates.map(p => p.ClassificationName))];

                vm.allowances.push({
                    AllowanceId: allowance.Id,
                    AllowanceName: allowance.AllowanceName,
                    AllowanceDescription: allowance.Description,
                    AllowanceCategoryId: allowance.AllowanceCategory,
                    AllowanceCategoryName: getAllowanceCategoryName(allowance.AllowanceCategory),
                    ClassificationRates: allowance.ClassificationRates,
                    ClassificationNames: classificationNames,
                    Conditions: conditions
                });
            });
        }

        function getFixedConditions(allowance) {
            let conditions = [];

            if (allowance.AllowanceType) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Allowance Type",
                    ConditionValue: allowance.AllowanceType,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                    ConditionCompareTypeId: null
                });
            }

            if (allowance.AllowanceHourlyMultiplierVariable) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Hourly Type",
                    ConditionValue: allowance.AllowanceHourlyMultiplierVariable,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                    ConditionCompareTypeId: null
                });

                if (allowance.AllowanceHourlyMultiplierVariable == ALLOWANCE_HOURLY_MULTIPLIER_TOTAL_SHIFT_HOURS) {
                    conditions.push({
                        ConditionOrder: 0,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: CONDITION_OPERATORS.AND,
                        CanReOrder: false,
                        ConditionName: "Reduce Hourly Total By",
                        ConditionValue: allowance.ReduceHourlyTotalByNumberOfHours,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                        ConditionCompareTypeId: null
                    });
                }
            }

            if (allowance.AllowanceDistanceMultiplierVariable) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Distance Type",
                    ConditionValue: allowance.AllowanceHourlyMultiplierVariable,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                    ConditionCompareTypeId: null
                });
            }

            if (allowance.MaxQuantityPerShift) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Max. Quantity Per Shift",
                    ConditionValue: allowance.MaxQuantityPerShift,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER,
                    ConditionCompareTypeId: null
                });
            }

            if (allowance.MinQuantityPerShift) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Min. Quantity Per Shift",
                    ConditionValue: allowance.MinQuantityPerShift,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER,
                    ConditionCompareTypeId: null
                });
            }

            if (allowance.MaxQuantityPerWeek) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Max. Quantity Per Week",
                    ConditionValue: allowance.MaxQuantityPerWeek,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER,
                    ConditionCompareTypeId: null
                });
            }

            if (allowance.OverridesOtherAwardAllowances || allowance.OverridesOtherAwardAllowanceIds) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Overrides Other Award Allowances",
                    ConditionValue: allowance.OverridesOtherAwardAllowances || allowance.OverridesOtherAwardAllowanceIds,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                    ConditionCompareTypeId: null
                });
            }

            if (allowance.CountPaidBreakTowardsHoursWorked) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Count Paid Break Towards Hours Worked",
                    ConditionValue: allowance.CountPaidBreakTowardsHoursWorked,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                    ConditionCompareTypeId: null
                });
            }

            if (allowance.IsTravelAllowance) {
                conditions.push({
                    ConditionOrder: 0,
                    ConditionTypeId: CONDITION_TYPE_FIXED,
                    ConditionOperatorId: CONDITION_OPERATORS.AND,
                    CanReOrder: false,
                    ConditionName: "Travel Allowance",
                    ConditionValue: allowance.IsTravelAllowance,
                    ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                    ConditionCompareTypeId: null
                });
            }

            if (conditions.length > 0) {
                conditions[0].ConditionOperatorId = null;
            }

            return conditions;
        }

        function getAppliedConditions(condition) {
            switch (condition.InputVariable) {
                case CONDITION_TYPE_TOTAL_WORKED_HOURS:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Total Work Hours",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_TOTAL_TRAVEL_DISTANCE:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Total Travel Distance",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.KMS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_TRAVEL_DISTANCE_TO_JOB:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Travel Distance To Job",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.KMS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_TRAVEL_DURING_DISTANCE:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Travel During Distance",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.KMS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_TRAVEL_DISTANCE_FROM_JOB:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Travel Distance From Job",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.KMS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_EMPLOYEE_CODE:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Employee Code",
                            ConditionValue: condition.ConditionStringValues,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                            ConditionCompareTypeId: condition.ConditionStringCompareType
                    };
                case CONDITION_TYPE_TOTAL_TRAVEL_HOURS:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Total Travel Hours",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_INTERPRETER_OUTPUT_COUNT:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Interpreter Output Count",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_DAY_OF_WEEK:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Day of Week",
                            ConditionValue: condition.ConditionDays,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.DAYS,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_TIME_OF_DAY:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Time of Day",
                            ConditionValue: condition.ConditionStartTime + ' - ' + condition.ConditionEndTime,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_CLIENT_COMPANY_SITE_ALLOWANCE:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Client Company Site Allowance",
                            ConditionValue: true,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_OPERATED_VEHICLE_TYPE:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Operated Vehicle Type",
                            ConditionValue: condition.ConditionOperatedVehicleTypeValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                            ConditionCompareTypeId: null
                    };
                case CONDITION_TYPE_TRAVEL_HOURS_TO_JOB:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Travel Hours To Job",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_TRAVEL_HOURS_FROM_JOB:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Travel Hours From Job",
                            ConditionValue: condition.ConditionDecimalValue,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.HOURS,
                            ConditionCompareTypeId: condition.ConditionDecimalCompareType
                    };
                case CONDITION_TYPE_PUBLIC_HOLIDAY:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Public Holiday",
                            ConditionValue: !!condition.ConditionStringCompareType,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                            ConditionCompareTypeId: null,
                    };
                case CONDITION_TYPE_SHIFT_OVERLAPS_INTERVAL:
                    return {
                        ConditionOrder: condition.ConditionOrder,
                            ConditionTypeId: condition.InputVariable,
                            ConditionOperatorId: condition.ConditionOperator,
                            ConditionName: "Shift Overlaps Interval",
                            ConditionValue: condition.ConditionStartTime + ' - ' + condition.ConditionEndTime,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                            ConditionCompareTypeId: null
                    };
            }
        }

        function getConditionValueDisplayText(condition) {
            if (!condition.ConditionValue ||
                (Array.isArray(condition.ConditionValue) && condition.ConditionValue.length < 1)) {
                return "";
            }

            if (condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.TEXT) {
                switch (condition.ConditionTypeId) {
                    case CONDITION_TYPE_FIXED: {
                        if (condition.ConditionName == "Allowance Type") {
                            switch (condition.ConditionValueTypeId) {
                                case 1:
                                    return "Hourly";
                                case 2:
                                    return "Per Shift";
                                case 3:
                                    return "Per Day";
                                case 4:
                                    return "Per Shift Per Day";
                                case 5:
                                    return "Weekly";
                                case 6:
                                    return "Distance";
                                case 7:
                                    return "Distance Over Condition";
                                case 8:
                                    return "Per Hour Per Client";
                                case 9:
                                    return "Inclement Weather";
                            }
                        } else if (condition.ConditionName == "Hourly Type") {
                            switch (condition.ConditionValueTypeId) {
                                case 1:
                                    return "Total Travel Hours";
                                case 2:
                                    return "Total Worked Hours";
                                case 3:
                                    return "Travel Hours From Job";
                                case 4:
                                    return "Travel Hours To Job";
                            }
                        } else if (condition.ConditionName == "Distance Type") {
                            switch (condition.ConditionValueTypeId) {
                                case 1:
                                    return "Total Travel To & From Distance";
                                case 2:
                                    return "Total Travel To, During & From Distance";
                                case 3:
                                    return "Travel Distance To Job";
                                case 4:
                                    return "Travel During Distance";
                                case 5:
                                    return "Travel Distance From Job";
                            }
                        } else if (condition.ConditionName == "Automatic Allowance Type") {
                            switch (condition.ConditionValueTypeId) {
                                case 1:
                                    return "Permanent Part-Time Top-up";
                                case 2:
                                    return "Permanent PartTime Top-up incl. Travel Hours";
                                case 3:
                                    return "Toolbox";
                                case 4:
                                    return "Permanent Part-Time Public Holiday Top-up";
                                case 5:
                                    return "Permanent Part-Time Top-up Mon to Fri Only";
                                case 6:
                                    return "Permanent Part-Time Top-up incl. Travel Hours Mon to Fri Only";
                                case 7:
                                    return "Permanent Fulltime Top-up";
                                case 8:
                                    return "Permanent Fulltime Public Holiday Top-up";
                            }
                        }
                        return condition.ConditionValue;
                    }
                }
            }

            return condition.ConditionValue;
        }

        function getConditionCompareTypeName(condition) {
            if (!condition.ConditionCompareTypeId) {
                return "";
            }

            const isNumericCompareType =
                condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.NUMBER ||
                condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.HOURS ||
                condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.KMS;

            if (isNumericCompareType) {
                switch (condition.ConditionCompareTypeId) {
                    case 1:
                        return "Less Than";
                    case 2:
                        return "Less Than Or Equal To";
                    case 3:
                        return "Greater Than";
                    case 4:
                        return "Greater Than Or Equal To";
                }

                return "Unknown Numeric Compare Type: " + condition.ConditionCompareTypeId;
            }

            if (condition.ConditionValueTypeId == CONDITION_VALUE_TYPES.TEXT) {
                if (condition.ConditionTypeId == CONDITION_TYPE_EMPLOYEE_CODE) {
                    switch (condition.ConditionCompareTypeId) {
                        case 1:
                            return "In List";
                        case 2:
                            return "Not In List";
                    }

                    return "Unknown Text Compare Type: " + condition.ConditionCompareTypeId;
                }
            }

            return condition.ConditionCompareTypeId;
        }

        function searchTable() {
            setTimeout(function() {
                if (!_.isNil(vm.searchText)) {
                    vm.dtInstance.DataTable.search(vm.searchText);
                    vm.dtInstance.DataTable.search(vm.searchText).draw();
                }
            }, searchDelay);
        }

        function getAllowanceCategoryName(allowanceCategoryId) {
            return vm.allowanceCategories.find(p => p.Id == allowanceCategoryId).Name
        }

        function viewConditions(allowance) {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/dialogs/award-conditions-dialog.html',
                controller: 'AwardConditionsDialogController as vm',
                locals: {
                    dialogTitle: allowance.AllowanceName,
                    conditions: allowance.Conditions
                }
            });
        }

        function viewRates(allowanceId) {
            $state.go('app.manage_awardallowancerates', {
                awardId: vm.award.Id,
                allowanceId: allowanceId
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.allowance-rates', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.manage_awardallowancerates', {
            url: '/manage-awards/:awardId/allowances/:allowanceId',
            views: {
                'content@app': {
                    templateUrl: 'app/main/awards/manage/allowance-rates/award-allowance-rates.html',
                    controller: 'AwardAllowanceRatesController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasManageAwardsMenu;
                }]
            },
            title: 'Manage Allowance Rates',
            titleBar: 'Alloc8 - Manage Allowance Rates'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.allowance-rates')
        .controller('AwardAllowanceRatesController', AwardAllowanceRatesController);

    /** @ngInject */
    function AwardAllowanceRatesController(
        $stateParams,
        AwardsViewService,
        searchDelay
    ) {
        var vm = this;

        vm.service = AwardsViewService;
        vm.award = null;
        vm.classificationRates = [];

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            sort: false,
            initComplete: function() {
                searchTable();
            }
        };
        vm.searchText = null;
        vm.searchTable = searchTable;

        activate();

        async function activate() {
            await AwardsViewService.loadAwards();

            vm.award = vm.service.awards.find(p => p.Id == $stateParams.awardId);

            if (!vm.award || !vm.award.Allowances) {
                return;
            }

            let allowance = vm.award.Allowances.find(p => p.Id == $stateParams.allowanceId);
            vm.classificationRates = allowance.ClassificationRates;
        }

        function searchTable() {
            setTimeout(function() {
                if (!_.isNil(vm.searchText)) {
                    vm.dtInstance.DataTable.search(vm.searchText);
                    vm.dtInstance.DataTable.search(vm.searchText).draw();
                }
            }, searchDelay);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.addons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.manage_awardaddons', {
            url: '/manage-awards/:awardId/addons',
            views: {
                'content@app': {
                    templateUrl: 'app/main/awards/manage/addons/award-addons.html',
                    controller: 'AwardAddonsController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasManageAwardsMenu;
                }]
            },
            title: 'Manage Addons',
            titleBar: 'Alloc8 - Manage Addons'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.manage-awards.addons')
        .controller('AwardAddonsController', AwardAddonsController);

    /** @ngInject */
    function AwardAddonsController(
        $stateParams,
        AwardsViewService,
        searchDelay,
        $mdDialog,
        CONDITION_OPERATORS,
        CONDITION_VALUE_TYPES
    ) {
        const CONDITION_TYPE_FIXED = 0;

        const POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP = 1;
        const POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_INCLUDE_TRAVEL_HOURS = 2;
        const POST_PROCESS_ALLOWANCE_TYPE_TOOLBOX = 3;
        const POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_PUBLIC_HOLIDAY_TOPUP = 4;
        const POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_MON_FRI_ONLY = 5;
        const POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_INCLUDE_TRAVEL_HOURS_MON_FRI_ONLY = 6;
        const POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_FULLTIME_TOPUP = 7;
        const POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_FULLTIME_PUBLIC_HOLIDAY_TOPUP = 8;

        var vm = this;

        vm.service = AwardsViewService;
        vm.award = null;
        vm.allowanceRates = [];
        vm.postProcessTypes = [{
            Id: POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP,
            Name: "Permanent Part-Time Top-up",
        }, {
            Id: POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_INCLUDE_TRAVEL_HOURS,
            Name: "Permanent PartTime Top-up incl. Travel Hours",
        }, {
            Id: POST_PROCESS_ALLOWANCE_TYPE_TOOLBOX,
            Name: "Toolbox",
        }, {
            Id: POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_PUBLIC_HOLIDAY_TOPUP,
            Name: "Permanent Part-Time Public Holiday Top-up",
        }, {
            Id: POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_MON_FRI_ONLY,
            Name: "Permanent Part-Time Top-up Mon to Fri Only",
        }, {
            Id: POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_INCLUDE_TRAVEL_HOURS_MON_FRI_ONLY,
            Name: "Permanent Part-Time Top-up incl. Travel Hours Mon to Fri Only",
        }, {
            Id: POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_FULLTIME_TOPUP,
            Name: "Permanent Fulltime Top-up",
        }, {
            Id: POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_FULLTIME_PUBLIC_HOLIDAY_TOPUP,
            Name: "Permanent Fulltime Public Holiday Top-up",
        }];
        vm.getPostProcessTypeName = getPostProcessTypeName;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'simple',
            autoWidth: false,
            searchDelay: searchDelay,
            responsive: true,
            sort: false,
            initComplete: function() {
                searchTable();
            }
        };
        vm.searchText = null;
        vm.searchTable = searchTable;

        vm.viewConditions = viewConditions;

        activate();

        async function activate() {
            await AwardsViewService.loadAwards();

            vm.award = vm.service.awards.find(p => p.Id == $stateParams.awardId);

            if (!vm.award || !vm.award.Classifications || !vm.award.PostProcesses) {
                return;
            }

            vm.award.Classifications.forEach(classification => {
                // award.PostProcesses are allowances that applied automatically and do not have any conditions attached.
                // They do not need to be assigned at the shift level.
                vm.award.PostProcesses.forEach(postProcess => {
                    var payCode = postProcess.ClassificationCodes[classification.ClassificationName];
                    if (!payCode) {
                        return;
                    }

                    var payRate = postProcess.ClassificationUnitRate[classification.ClassificationName];
                    let conditions = [];

                    conditions.push({
                        ConditionOrder: 0,
                        ConditionTypeId: CONDITION_TYPE_FIXED,
                        ConditionOperatorId: null,
                        CanReOrder: false,
                        ConditionName: "Allowance Type",
                        ConditionValue: postProcess.PostProcessMethod,
                        ConditionValueTypeId: CONDITION_VALUE_TYPES.TEXT,
                        ConditionValueDisplayText: getPostProcessTypeName(postProcess.PostProcessMethod),
                        ConditionCompareTypeId: null
                    });

                    if (postProcess.PostProcessMethod == POST_PROCESS_ALLOWANCE_TYPE_TOOLBOX) {
                        conditions.push({
                            ConditionOrder: 0,
                            ConditionTypeId: CONDITION_TYPE_FIXED,
                            ConditionOperatorId: CONDITION_OPERATORS.AND,
                            CanReOrder: false,
                            ConditionName: "Quantity",
                            ConditionValue: postProcess.Quantity,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.NUMBER,
                            ConditionValueDisplayText: postProcess.Quantity,
                            ConditionCompareTypeId: null
                        });
                    }

                    if (postProcess.PostProcessMethod == POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_INCLUDE_TRAVEL_HOURS ||
                        postProcess.PostProcessMethod == POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_INCLUDE_TRAVEL_HOURS_MON_FRI_ONLY) {
                        conditions.push({
                            ConditionOrder: 0,
                            ConditionTypeId: CONDITION_TYPE_FIXED,
                            ConditionOperatorId: CONDITION_OPERATORS.AND,
                            CanReOrder: false,
                            ConditionName: "Include Travel Hours",
                            ConditionValue: postProcess.IncludeTravelHours,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                            ConditionValueDisplayText: postProcess.IncludeTravelHours,
                            ConditionCompareTypeId: null
                        });
                    }

                    if (postProcess.PostProcessMethod == POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_MON_FRI_ONLY ||
                        postProcess.PostProcessMethod == POST_PROCESS_ALLOWANCE_TYPE_PERMANENT_PARTTIME_TOPUP_INCLUDE_TRAVEL_HOURS_MON_FRI_ONLY) {
                        conditions.push({
                            ConditionOrder: 0,
                            ConditionTypeId: CONDITION_TYPE_FIXED,
                            ConditionOperatorId: CONDITION_OPERATORS.AND,
                            CanReOrder: false,
                            ConditionName: "Mon to Friday Only",
                            ConditionValue: postProcess.MondayToFridayOnly,
                            ConditionValueTypeId: CONDITION_VALUE_TYPES.BOOLEAN,
                            ConditionValueDisplayText: postProcess.MondayToFridayOnly,
                            ConditionCompareTypeId: null
                        });
                    }

                    vm.allowanceRates.push({
                        ClassificationName: classification.ClassificationName,
                        AllowanceName: postProcess.RuleName,
                        PayCode: payCode,
                        PayRate: payRate,
                        Conditions: conditions
                    });
                });
            });
        }

        function searchTable() {
            setTimeout(function() {
                if (!_.isNil(vm.searchText)) {
                    vm.dtInstance.DataTable.search(vm.searchText);
                    vm.dtInstance.DataTable.search(vm.searchText).draw();
                }
            }, searchDelay);
        }

        function getPostProcessTypeName(postProcessTypeId) {
            return vm.postProcessTypes.find(p => p.Id == postProcessTypeId).Name
        }

        function viewConditions(allowanceRate) {
            $mdDialog.show({
                templateUrl: 'app/main/awards/manage/dialogs/award-conditions-dialog.html',
                controller: 'AwardConditionsDialogController as vm',
                locals: {
                    dialogTitle: allowanceRate.AllowanceName,
                    conditions: allowanceRate.Conditions
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.equipment.view')
        .service('awardInterpreterGridService', awardInterpreterGridService);

    /** @ngInject */
    function awardInterpreterGridService(
        exceptionService,
        awardInterpreterListAdapterService
    ) {
        let service = {
            grid: {}
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.resetWithCollection = resetWithCollection;
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.concatenateToCollection = concatenateToCollection;
        service.insertPayrollData = insertPayrollData;

        return service;

        // Set data provider here
        function onInit() {
            service.grid.data = [];
            service.grid.behavior.setHubSourceAdapter(awardInterpreterListAdapterService);
        }

        function concatenateToCollection(recordsToAdd) {
            service.grid.behavior.concatenateToCollection(recordsToAdd);
        }

        function resetWithCollection(collection) {
            service.grid.behavior.resetWithCollection(collection);
        }

        function insertPayrollData(data) {
            (service.grid.behavior.pushItemsToState || angular.noop)(data);
        }

        /**
         * Loading of paged data
         */
        function onCompleted(data) {
            service.grid.data = [];
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        function onError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.equipment.view')
        .service('awardInterpreterListAdapterService', awardInterpreterListAdapterService);

    /** @ngInject */
    function awardInterpreterListAdapterService(
        a8WebApiNoChunkDataProvider,
        $q
    ) {
        let service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client),
            counter: 0
        };

        let dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData() {
            return dbSource.fetch(function() {
                let deferred = $q.defer();
                deferred.resolve([]);
                return deferred.promise;
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.awards.interpreter', [])
    .config(config)
    .run(runConfig);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.awards_interpreter', {
      url: '/awards/interpreter'
      , views: {
        'content@app': {
          templateUrl: 'app/main/awards/interpreter/awards-interpreter.html',
          controller: 'AwardInterpreterController as vm'
        }
      }
      , data: {
        requireLogin: true,
        validateAccess: ['payrollClaimsService', function (payrollClaimsService) {
          return payrollClaimsService.hasRunPayrollAccess;
        }]
      }
      , title: 'Run Payroll'
      , titleBar:'Alloc8 - Run Payroll'
    });

    $translatePartialLoaderProvider.addPart('app/main/awards/interpreter');
  }

  /** @ngInject */
  function runConfig(awardInterpreterSignalRService) {
    awardInterpreterSignalRService.register();
  }

})();

(function() {
    'use strict';

    angular.module('app.awards.interpreter')
        .service('awardInterpreterSignalRService', awardInterpreterSignalRService);

    /** @ngInject */
    function awardInterpreterSignalRService(signalRService,
        $rootScope) {

        var isInitialized = false;

        function register() {

            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function() {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }

            function regs() {
                signalRService.messageHub.on('payrollInterpretationStarted', (data) => {
                    $rootScope.$broadcast("payrollInterpretationStarted", data);
                });

                signalRService.messageHub.on('payrollInterpretationInProgress', (data) => {
                    $rootScope.$broadcast("payrollInterpretationInProgress", data);
                });

                signalRService.messageHub.on('payrollInterpretationCompleted', (data) => {
                    $rootScope.$broadcast("payrollInterpretationCompleted", data);
                });


                signalRService.messageHub.on('payrollValidationStarted', (data) => {
                    $rootScope.$broadcast("payrollValidationStarted", data);
                });

                signalRService.messageHub.on('payrollValidationInProgress', (data) => {
                    $rootScope.$broadcast("payrollValidationInProgress", data);
                });

                signalRService.messageHub.on('payrollValidationCompleted', (data) => {
                    $rootScope.$broadcast("payrollValidationCompleted", data);
                });


                signalRService.messageHub.on('payrollExportStarted', (data) => {
                    $rootScope.$broadcast("payrollExportStarted", data);
                });

                signalRService.messageHub.on('payrollExportInProgress', (data) => {
                    $rootScope.$broadcast("payrollExportInProgress", data);
                });

                signalRService.messageHub.on('payrollExportCompleted', (data) => {
                    $rootScope.$broadcast("payrollExportCompleted", data);
                });
            }
        }

        var service = {
            register: register
        };

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('app.awards.interpreter')
        .directive('awardInterpreterOutputItemErrorDetails', ['payrollErrorCodes', 'utils', function(payrollErrorCodes, utils) {
            return {
                restrict: 'E',
                templateUrl: 'app/main/awards/interpreter/directives/award-interpreter-output-item-error-details.html',
                scope: {
                    errors: '=',
                    redirectToCompanyAction: '&'
                },
                link: function(scope) {
                    scope.displayErrors = function() {
                        if (scope.errors.includes(payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain)) {
                            return '<strong>' + scope.getErrorDescription(payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain) + '</strong>'
                        }

                        if (scope.errors.includes(payrollErrorCodes.JobNumberNotFound)) {
                            scope.jobNumberNotFound = true;
                            return '';
                        }

                        return scope
                            .errors
                            .map(function(error) {
                                return '<strong>' + scope.getErrorDescription(error) + '</strong>';
                            }).join("<br/><br/>");
                    }

                    scope.getErrorDescription = function(errorCode) {
                        switch (errorCode) {
                            case payrollErrorCodes.EmployeeNotFound:
                                return utils.translate('RUN_PAYROLL.EMPLOYEE_NOT_FOUND');
                            case payrollErrorCodes.EmployeePayrollCalendarNotConfigured:
                                return utils.translate('RUN_PAYROLL.EMPLOYEE_PAY_CALENDAR_NOT_CONFIGURED');
                            case payrollErrorCodes.EmployeePayrollCategoryNotAssigned:
                                return utils.translate('RUN_PAYROLL.EMPLOYEE_PAYROLL_CATEGORY_NOT_ASSIGNED');
                            case payrollErrorCodes.EmployeeOrdinaryEarningRateNotConfigured:
                                return utils.translate('RUN_PAYROLL.EMPLOYEE_ORDINARY_EARNING_RATE_NOT_CONFIGURED');
                            case payrollErrorCodes.EmployeeShiftDateNotWithinPayPeriod:
                                return utils.translate('RUN_PAYROLL.EMPLOYEE_SHIFT_DATE_NOT_WITHIN_PAY_PERIOD');
                            case payrollErrorCodes.PayCodeNotConfigured:
                                return utils.translate('RUN_PAYROLL.PAY_CODE_NOT_CONFIGURED');
                            case payrollErrorCodes.PayRunInDraftMode:
                                return utils.translate('RUN_PAYROLL.PAY_RUN_IN_DRAFT_MODE');
                            case payrollErrorCodes.PayRunAlreadyProcessed:
                                return utils.translate('RUN_PAYROLL.PAY_RUN_ALREADY_PROCESSED');
                            case payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain:
                                return utils.translate('RUN_PAYROLL.EMPLOYEE_TIMESHEET_ALREADY_EXISTS_IT_WILL_NOT_BE_EXPORTED_AGAIN');
                            case payrollErrorCodes.TimesheetAlreadyExistsItWillBeOverwritten:
                                return utils.translate('RUN_PAYROLL.EMPLOYEE_TIMESHEET_ALREADY_EXISTS_IT_WILL_BE_OVERWRITTEN');
                            case payrollErrorCodes.EmployeeNotActive:
                                return utils.translate('RUN_PAYROLL.EMPLOYEE_NOT_ACTIVE');
                            case payrollErrorCodes.FailedToFetchEmployeeTimesheets:
                                return utils.translate('RUN_PAYROLL.FAILED_TO_FETCH_EMPLOYEE_TIMESHEETS');
                            case payrollErrorCodes.FailedToFetchEmployee:
                                return utils.translate('RUN_PAYROLL.FAILED_TO_FETCH_EMPLOYEE');
                            case payrollErrorCodes.PayCodeDuplicated:
                                return utils.translate('RUN_PAYROLL.PAY_CODE_DUPLICATED');
                            default:
                                return errorCode;
                        }
                    }
                }
            };
        }]);
})();

(function () {
    'use strict';

    angular
        .module('app.awards.interpreter')
        .directive('awardInterpreterOutputItemErrorColumn', ['payrollErrorCodes', function (payrollErrorCodes) {
            return {
                restrict: 'E',
                templateUrl: 'app/main/awards/interpreter/directives/award-interpreter-output-item-error-column.html',
                scope: {
                    interpreterOutputItem: '='
                },
                link: function (scope) {
                    let rightArrowIcon = 'arrow_right';
                    let dropdownArrowIcon = 'arrow_drop_down';

                    scope.columnStateIcon = rightArrowIcon;

                    scope.$on('app.awards.interpreter.awardInterpreterOutputItemErrorColumn.refresh', function () {
                        setErrorStatusIcon();
                    });

                    scope.$watch('interpreterOutputItem', function (newValue, oldValue) {
                        setErrorStatusIcon();
                    });

                    scope.$watch('interpreterOutputItem.showErrors', function (newValue, oldValue) {
                        scope.columnStateIcon = scope.interpreterOutputItem.showErrors ? dropdownArrowIcon : rightArrowIcon;
                    });

                    scope.toggleColumn = function () {
                        scope.interpreterOutputItem.showErrors = !scope.interpreterOutputItem.showErrors;
                    }

                    function setErrorStatusIcon() {
                        let itemIndexForExistingTimesheetWarning = scope.interpreterOutputItem.PayrollErrors.find(function (error) {
                            return error === payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain;
                        });

                        let assetBasePath = '/assets/icons/';
                        let errorStatusIcon = itemIndexForExistingTimesheetWarning >= 0 ? 'checkmark-circle-success.svg' : 'warning.svg';
                        scope.errorStatusIcon = assetBasePath + errorStatusIcon;
                    }
                }
            };
        }]);
})();

'use strict'

angular
    .module('app.awards.interpreter')
    .constant("payrollErrorCodes", {
        EmployeeNotFound: 0,
        EmployeePayrollCalendarNotConfigured: 1,
        EmployeePayrollCategoryNotAssigned: 2,
        EmployeeOrdinaryEarningRateNotConfigured: 3,
        EmployeeShiftDateNotWithinPayPeriod: 4,
        PayCodeNotConfigured: 5,
        PayRunAlreadyProcessed: 6,
        PayRunInDraftMode: 7,
        TimesheetAlreadyExistsItWillNotBeExportedAgain: 8,
        TimesheetAlreadyExistsItWillBeOverwritten: 9,
        JobNumberNotFound: 10,
        PayCodeQuantityMoreThan24: 11,
        EmployeeNotActive: 12,
        FailedToFetchEmployeeTimesheets: 13,
        FailedToFetchEmployee: 14,
        PayCodeDuplicated: 15,
    });

(function() {
    'use strict';

    angular.module('app.assets', [
            'app.assets.manage.costcodes',
            'app.assets.manage.item',
            'app.assets.manage.kit',
            'app.assets.manage.category',
            'app.api',
            'app.corelib',
            'app.widgets'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config(ivhTreeviewOptionsProvider) {

        // Configure Tree View
        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: 0,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right icon s25"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-down icon s25"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });
    };

    function runConfig(
        msNavigationService,
        assetsClaimService
    ) {
        msNavigationService.saveItem('apps.assets', {
            title: 'Assets & Inventory',
            icon: 'icon-city',
            weight: 2
        });

        msNavigationService.saveItem('apps.assets.item_view', {
            title: 'View Items',
            state: 'app.view_items',
            weight: 1,
            hidden: function() {
                return !assetsClaimService.hasViewItemsMenu;
            }
        });

        msNavigationService.saveItem('apps.assets.kit_view', {
            title: 'View Kits',
            state: 'app.kit_view_items',
            weight: 2,
            hidden: function() {
                return !assetsClaimService.hasViewKitsMenu;
            }
        });

        msNavigationService.saveItem('apps.assets.equipment_view', {
            title: 'View Equipment',
            state: 'app.equipment_view',
            weight: 2
        });

        msNavigationService.saveItem('apps.assets.item', {
            title: 'Create a New Item',
            state: 'app.manage_item',
            weight: 3,
            hidden: function() {
                return !assetsClaimService.hasCreateNewItemMenu;
            }
        });

        msNavigationService.saveItem('apps.assets.kit', {
            title: 'Create a New Kit',
            state: 'app.manage_kit',
            weight: 4,
            hidden: function() {
                return !assetsClaimService.hasCreateNewKit;
            }
        });
    };
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .factory('kitManagerService', kitManagerService);

    /** @ngInject */
    function kitManagerService($q,
        $log,
        $injector,
        $location,
        blockUI,
        assetsLookupService,
        exceptionService,
        a8TreeMdBoxService,
        assetsApi,
        branchApi,
        $mdToast,
        lookupApi,
        basicKitInfoService,
        kitHirePriceService,
        stockCategoryConverterService
    ) {
        var service = {
            loadLookups: loadLookups,
            itemCategoryLookup: null,
            hireRateData: [],
            itemList: [],
            hirePeriodsLookup: [],
            isEditMode: false,
            save: save,
            update: update,
            load: load,
            loadCategoryTree: loadCategoryTree,
            resetData: resetData,
            viewItems: viewItems,
            branchesLookup: []
        };

        activate();

        return service;

        function activate() {}

        function save(allowRedirect) {
            blockUI.start({
                message: 'Saving Kit Item...'
            });

            var apiPromise = null;
            var basicData = basicKitInfoService.data.toBackendModel();
            var categories = {
                'Categories': stockCategoryToBackendModel(a8TreeMdBoxService.getSelectedItems())
            };
            var priceDetails = kitHirePriceService.data.toBackendModel();

            var data = angular.extend({}, basicData);
            angular.extend(data, categories);
            angular.extend(data, priceDetails);

            apiPromise = assetsApi.postKitItem(data)
                .then(function(resp) {
                    $log.debug(resp);
                    blockUI.stop();

                    if (allowRedirect) {
                        redirectToViewKit();
                        service.isEditMode = false;
                    } else {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Kit successfully saved.')
                                .position('bottom right')
                                .hideDelay(3000)
                            )
                            .then(function() {
                                $location.url('/assets/manage/kit/update/' + resp.data.id);
                            });
                    }

                    return resp;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function update(allowRedirect) {
            blockUI.start({
                message: 'Updating Kit Item...'
            });

            var apiPromise = null;
            var basicData = basicKitInfoService.data.toBackendModel();
            var categories = {
                'Categories': stockCategoryToBackendModel(a8TreeMdBoxService.getSelectedItems())
            };
            var priceDetails = kitHirePriceService.data.toBackendModel();

            var data = angular.extend({}, basicData);
            angular.extend(data, categories);
            angular.extend(data, priceDetails);

            apiPromise = assetsApi.updateKitItem(data)
                .then(function(resp) {
                    blockUI.stop();

                    if (allowRedirect) {
                        redirectToViewKit();
                        service.isEditMode = false;
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Kit successfully updated.')
                            .position('bottom right')
                            .hideDelay(3000)
                        );
                    }

                    return resp;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function load(id) {
            service.isEditMode = true;

            blockUI.start({
                message: 'Loading Kit Item...'
            });

            var apiPromise = assetsApi.getKitItem(id)
                .then(loadDataCompleted)
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function loadDataCompleted(response) {
            var resp = response.data;

            basicKitInfoService.data.map({
                id: resp.id,
                ItemName: resp.KitName,
                Description: resp.Description,
                Categories: resp.Categories,
                Branches: resp.Branches,
            });

            basicKitInfoService.data.KitItems.length = 0;
            basicKitInfoService.data.KitItems = resp.Items;
            loadCategoryTree();

            kitHirePriceService.data.map({
                BaseSalePrice: resp.BaseSalePrice
            });

            kitHirePriceService.data.HireRateData.length = 0;
            angular.forEach(resp.BaseHirePrices, function(itm) {
                var period = _.filter(service.hirePeriodsLookup.data, function(o) {
                    return o.Id === parseInt(itm.HirePeriod);
                })[0];

                kitHirePriceService.data.HireRateData.push({
                    id: itm.HirePeriod,
                    periodName: (period.Name ? period.Name : ''),
                    hireCost: itm.HireCost
                });
            }, this);

            blockUI.stop();

            return resp;
        }

        function loadCategoryTree() {
            var catTree = null;
            if (!service.isEditMode) {
                catTree = stockCategoryConverterService.toUITree(service.itemCategoryLookup, []);
            } else {
                catTree = stockCategoryConverterService.toUITree(service.itemCategoryLookup, basicKitInfoService.data.Categories);
            }

            a8TreeMdBoxService.source.length = 0;
            angular.forEach(catTree.tree, function(itm) {
                a8TreeMdBoxService.source.push(itm);
            }, this);

            if (basicKitInfoService.data.Categories) {
                a8TreeMdBoxService.expandTo(basicKitInfoService.data.Categories);
            }
        }

        function resetData() {
            service.isEditMode = false;
            basicKitInfoService.data.reset();
            kitHirePriceService.data.reset();
        }

        function viewItems() {
            redirectToViewKit();
        }

        function redirectToViewKit() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.kit_view_items');
        }

        function loadLookups() {

            var promise1 = assetsLookupService.fetchItemCategoriesLookup()
                .then(function(resp) {
                    service.itemCategoryLookup = resp;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise2 = assetsApi.getItems()
                .then(function(resp) {
                    service.itemList = resp.data;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise3 = lookupApi.getHirePeriod()
                .then(function(resp) {
                    service.hirePeriodsLookup = resp;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise4 = branchApi.getBranches()
                .then(function(resp) {
                    service.branchesLookup = resp.data;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return $q.all([promise1, promise2, promise3, promise4]);
        }

        function stockCategoryToBackendModel(dataArr) {
            var arr = [];
            angular.forEach(dataArr, function(itm) {
                arr.push({
                    Id: itm.primaryId,
                    ParentId: itm.parentId,
                    Name: itm.label,
                    CategoryKey: itm.id
                });
            }, this);
            return arr;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .factory('kitItemGridService', kitItemGridService);

    /** @ngInject */
    function kitItemGridService(
        $injector,
        assetsApi,
        exceptionService,
        kitItemGridModel,
        _) {

        var service = {
            data: [],
            query: null,
            loadGridData: loadGridData,
            createKitItem: createKitItem,
            editKitItem: editKitItem
        };

        return service;

        function loadGridData() {
            var apiPromise = assetsApi.getKitItems()
                .then(function(resp) {
                    service.data.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        var model = new kitItemGridModel();
                        var items = extractItems(itm);

                        model.map(itm);
                        model.Items = items;
                        service.data.push(model);

                    }, this);

                    return service.data;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function createKitItem() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.manage_kit');
        };

        function editKitItem(id) {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.manage_kit_update', {
                kid: id
            });
        };

        function extractItems(data) {
            var items = [];
            angular.forEach(data.Items, function(itm) {
                var str = itm.Items.ItemName + ' (' + itm.Quantity + ')';
                items.push(str);
            }, this);

            return items;
        };
    }
})();

/***
 * Kit Hire Price Service
 * UI logic
 */
(function(){
    'use strict';

    angular.module('app.assets')
           .factory('kitHirePriceService', kitHirePriceService);
    
    /** @ngInject */
    function kitHirePriceService(lookupApi, _, exceptionService, kitPriceDetailModel) {
        var service = {
            data: new kitPriceDetailModel()
        };

        var hirePeriods = [];

        activate();

        return service;

        ////////
        function activate() {
            lookupApi.getHirePeriod()
                     .then(function(resp) {
                         hirePeriods = resp;
                     }).catch(function(ex) {
                         exceptionService.resolve(ex);
                     });
        };

    }
})();
(function() {
    'use strict';

    angular.module('app.assets')
        .factory('kitItemGridService', itemGridService);

    /** @ngInject */
    function itemGridService(
        $injector,
        assetsApi,
        kitItemGridModel,
        exceptionService,
        $mdDialog,
        blockUI,
    ) {
        var service = {
            data: [],
            loadGridData: loadGridData,
            createKitItem: createKitItem,
            editKitItem: editKitItem,
            removeKitItem: removeKitItem
        };

        return service;

        function loadGridData() {
            var apiPromise = assetsApi.getKitItems()
                .then(function(resp) {
                    service.data.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        var model = new kitItemGridModel();
                        var items = extractItems(itm);

                        model.map(itm);
                        model.Items = items;
                        service.data.push(model);

                    }, this);

                    return service.data;
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function createKitItem() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.manage_kit');
        };

        function editKitItem(id) {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.manage_kit_update', {
                kid: id
            });
        };

        function extractItems(data) {
            var items = [];
            angular.forEach(data.Items, function(itm) {
                var str = itm.Items.ItemName + ' (' + itm.Quantity + ')';
                items.push(str);
            }, this);

            return items;
        };

        function removeKitItem(kitId, kitName) {
            let confirm = $mdDialog.confirm({
                title: "Delete Kit",
                textContent: "Are you sure you want to delete the kit '" + kitName + "'?",
                ok: "OK",
                cancel: "Cancel"
            });

            $mdDialog
                .show(confirm)
                .then(function() {
                    deleteKit(kitId, kitName);
                })
                .finally(function() {
                    confirm = undefined;
                });
        }

        function deleteKit(kitId, kitName) {
            blockUI.start({
                message: "Deleting Kit..."
            });

            let alertMessage = "Kit '" + kitName + "' has been deleted."

            assetsApi.deleteKitItem(kitId)
                .catch(error => {
                    alertMessage = "Error occured while deleting kit '" + kitName + "'.";
                })
                .finally(() => {
                    blockUI.stop();

                    let alert = $mdDialog.alert({
                        title: "Delete Kit",
                        textContent: alertMessage,
                        ok: "OK"
                    });

                    $mdDialog.show(alert)
                        .finally(function() {
                            alert = undefined;
                        });

                    loadGridData()
                });
        }
    }
})();

/***
 * Basic Info Service
 * UI logic
 */
(function(){
    'use strict';

    angular.module('app.assets')
           .factory('basicKitInfoService', basicKitInfoService);

    /** @ngInject */
    function basicKitInfoService(kitBasicInfoModel) {
        var service = {
            data: new kitBasicInfoModel(),
            addKitItem: addKitItem
        };

        return service;

        ////////
        function addKitItem(item, isEdit) {
             var isFound = false;

            // If exists then just update it
            //var clonedData = angular.copy(service.data.KitItems);
            // angular.forEach(service.data.KitItems, function(itm) {
               
            //     if (itm.Items.id == item.Items.id) {
            //         isFound = true;

            //        itm.Quantity = !isEdit ? parseInt(itm.Quantity) + parseInt(item.Quantity)
            //                          : item.Quantity;
            //     } else if (item.Items.hasOwnProperty('oldId') && isEdit && itm.Items.id != item.Items.id) {
            //         _.remove(service.data.KitItems, function(n) {
            //            return n.Items.id == item.Items.oldId;
            //         });
            //     }
            // }, this);

            for(var i=0; i < service.data.KitItems.length; i++) {
                  let curr = service.data.KitItems[i];

                if (curr.Items.id == item.Items.id) {
                    isFound = true;

                   curr.Quantity = !isEdit ? parseInt(curr.Quantity) + parseInt(item.Quantity)
                                     : item.Quantity;
                    break;
                } else if (item.Items.hasOwnProperty('oldId') && isEdit && curr.Items.id != item.Items.id) {
                    _.remove(service.data.KitItems, function(n) {
                       return n.Items.id == item.Items.oldId;
                    });
                }
            }


            if (!isFound) {
                service.data.KitItems.push(item);
            }
            // var isFound = false;

            // // If exists then just update it
            // angular.forEach(service.data.KitItems, function(itm) {
            //     if (itm.Items.id == item.Items.id) {
            //         isFound = true;

            //        itm.Quantity = !isEdit ? parseInt(itm.Quantity) + parseInt(item.Quantity)
            //                          : item.Quantity;
            //     }
            // }, this);

            // if (!isFound) {
            //     service.data.KitItems.push(item);
            // }
        };

    }
})();

/***
 * Stock Level Service
 * UI logic
 */
(function () {
    'use strict';

    angular.module('app.assets')
        .factory('stockLevelService', stockLevelService);

    /** @ngInject */
    function stockLevelService(stockLevelModel, $injector, _, $mdDialog, assetsApi, blockUI, exceptionService, basicInfoService) {
        var service = {
            data: new stockLevelModel(),
            isStockLevelCountsVisible: false,
            isStockLevelCountsByBranchVisible: false,
            isLowStockNotifVisible: false,
            changeStockLevelTracking: changeStockLevelTracking,
            changeLowStockNotif: changeLowStockNotif,
            updateStockLevelCountByBranchVisibility: updateStockLevelCountByBranchVisibility,
            populateStockLevelModelBoundToRules: populateStockLevelModelBoundToRules,

            isTrackIndividualDisabled: false, // Track by IndividualTrackingType accessibility
            isStockLevelTrackingDisabled: false, // Stock Level Tracking accessibility

            isAssetSLCbyBranchVisible: false, // Stock Level count by Branch Asset
            isInventorySLCbyBranchVisible: false, // Stock Level count by Branch Inventory
            isPeopleSLCbyBranchVisible: false, // Stock Level count by Branch People

            isAssetSLCVisible: false, // Stock Level by Asset
            isInventorySLCVisible: false, // Stock Level by Inventory
            isPeopleSLCVisible: false,  // Stock Level by People

            changeIndividualTrackingType: changeIndividualTrackingType,
            isStockButtonsVisible: false,

            addStock: addStock,
            removeStock: removeStock,
            convertStock: convertStock,
            isStockManagementVisible: true,
            disableConvertStock: false,

            setBranchLookup: setBranchLookup,
            branchesLookup: [],
            stockLevelTrackingLookup: [],
            reset: reset,
            refreshStockLevelCounts: refreshStockLevelCounts,

            onTrackIndividualItemChanged: angular.noop
        };

        // Enum value source check: assetsApi.getIndividualTrackingTypes
        var YES_TRACK_INDIVIDUAL_ITEM = 1,
            NO_DONT_TRACK_INDIVIDUAL_ITEM = 2;

        activate();

        return service;

        ////////
        function activate() {
        };

        function reset() {
            service.data.reset();
            service.isStockLevelCountsVisible = false;
            service.isStockLevelCountsByBranchVisible = false;
            service.isStockButtonsVisible = false;
            service.isLowStockNotifVisible = false;
            checkControlsAccessibilityRules();
        };

        function setBranchLookup(branches) {
            service.branches = branches;

            // Load Stock Level by Branch (Record is dynamic based on the number of altus branches)
            service.data.StockLevelByBranches.length = 0;
            angular.forEach(branches, function (itm) {
                service.data.StockLevelByBranches.push({ Branch: itm.Name, BranchObj: itm, Assets: 0, Inventory: 0, People: 0 });
            }, this);
        };

        // Event
        function changeStockLevelTracking() {
            if (!service.data.StockLevelTracking)
                return;

            service.isStockLevelCountsVisible = false;
            service.isStockLevelCountsByBranchVisible = false;

            // Find it based on Name
            if (service.data.StockLevelTracking.Id == 2) {
                performStockLevelCountUIRules();
                service.isStockLevelCountsVisible = true;
            } else if (service.data.StockLevelTracking.Id == 3) {
                service.isStockLevelCountsByBranchVisible = true;
            }

            performStockButtonUIRules();
        };

        // Event
        function changeLowStockNotif() {
            if (!basicInfoService.data.LowStockNotification)
                return;

            if (basicInfoService.data.LowStockNotification.toLowerCase() === 'yes')
                service.isLowStockNotifVisible = true;
            else if (basicInfoService.data.LowStockNotification.toLowerCase() === 'no')
                service.isLowStockNotifVisible = false;
        };

        function updateStockLevelCountByBranchVisibility(itemTypesSelectedArr) {
            if (!itemTypesSelectedArr)
                return;

            // ===========================================
            // Display or not the Stock Level by Branch
            // ===========================================
            service.isAssetSLCbyBranchVisible = false
            service.isInventorySLCbyBranchVisible = false;
            service.isPeopleSLCbyBranchVisible = false;

            angular.forEach(itemTypesSelectedArr, function (item) {

                if (parseInt(item.Id) === 1)
                    service.isAssetSLCbyBranchVisible = true;
                if (parseInt(item.Id) === 2)
                    service.isInventorySLCbyBranchVisible = true;
                if (parseInt(item.Id) === 4)
                    service.isPeopleSLCbyBranchVisible = true;

            }, this);

            // =======================================
            //  Display or not the Stock Level Counts
            // =======================================
            performStockLevelCountUIRules();
            performStockButtonUIRules();
        };

        // Event
        function changeIndividualTrackingType() {
            performStockButtonUIRules();
            service.onTrackIndividualItemChanged();
        };

        function performStockButtonUIRules() {
            service.isStockButtonsVisible = false;

            if (!service.data.StockLevelTracking) return;

            if ((service.data.StockLevelTracking.Name.toLowerCase() === 'stock level counts' ||
                service.data.StockLevelTracking.Name.toLowerCase() === 'stock level counts by branch')
                && basicInfoService.data.IndividualTrackingType.id == NO_DONT_TRACK_INDIVIDUAL_ITEM) {

                // TODO: Check for isEditMode = true
                service.isStockButtonsVisible = isItemTypeSelectedExceptForRental();

                // Check Convert Stock Button
                //var basicInfoServ = $injector.get('basicInfoService');
                service.disableConvertStock = basicInfoService.data.ItemTypes.length <= 1;
            }
        };

        function checkControlsAccessibilityRules() {
            var hasActive = hasActiveStockLevelCount();

            service.isTrackIndividualDisabled = hasActive;
            service.isStockLevelTrackingDisabled = hasActive;
            basicInfoService.setItemTypeToDisabled(hasActive);
        };

        function performStockLevelCountUIRules() {
            // Asset
            service.isAssetSLCVisible = isItemTypeSelected(1);
            // Inventory
            service.isInventorySLCVisible = isItemTypeSelected(2)
            // People
            service.isPeopleSLCVisible = isItemTypeSelected(4);
        };

        function addStock(itemTypesLookup, isInitialStock) {
            // Remove itemType: Rental
            _.remove(itemTypesLookup, function (n) { return n.Id == 3; });

            // Show branch dropdown if Stock Level Tracking is equal to by Branch - 3
            var showBranch = service.data.StockLevelTracking.Id == 3;

            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/assets/manage/item/stockLevel/add-stock.html',
                controller: 'AddStockController as addStockVm',
                locals: { itemTypes: itemTypesLookup, branches: service.branches, showBranch: showBranch }
            }).then(function (resp) {
                if (resp) {
                    insertNewStock(resp, isInitialStock);
                }
            }, function () {
                // Cancel
            });
        };

        function removeStock(itemTypesLookup, isInitialStock) {
            // Remove itemType: Rental
            _.remove(itemTypesLookup, function (n) { return n.Id == 3; });

            // Show branch dropdown if Stock Level Tracking is equal to by Branch - 3
            var showBranch = service.data.StockLevelTracking.Id == 3;

            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/assets/manage/item/stockLevel/remove-stock.html',
                controller: 'RemoveStockController as removeStockVm',
                locals: { itemTypes: itemTypesLookup, branches: service.branches, showBranch: showBranch }
            }).then(function (resp) {


                if (resp)
                    removeStockLevelFromDb(resp);

            }, function () {
                // Cancel
            });
        };

        function convertStock(itemTypesLookup) {
            // Remove itemType: Rental
            _.remove(itemTypesLookup, function (n) { return n.Id == 3; });

            // Show branch dropdown if Stock Level Tracking is equal to by Branch - 3
            var showBranch = service.data.StockLevelTracking.Id == 3;

            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/assets/manage/item/stockLevel/convert-stock.html',
                controller: 'ConvertStockController as convertStockVm',
                locals: { itemTypes: itemTypesLookup, branches: service.branches, showBranch: showBranch }
            }).then(function (resp) {

                if (resp)
                    convertStockLevelFromDb(resp);

            }, function () {
                // Cancel
            });
        };

        function insertNewStock(data, isInitialStock) {

            if (!isInitialStock) {

                // For edit (add Stock, remove stock, convert stock)
                blockUI.start({ message: 'Adding new stock...' });

                if (data.showBranch) {
                    assetsApi.putStockLevelItemByBranch(service.data.id, data.branch.id, data.itemType.Id, data.qty)
                        .then(function (resp) {

                            //var basicInfoServ = $injector.get('basicInfoService');
                            populateStockLevelModelBoundToRules(resp.data, basicInfoService.data.ItemTypes);
                            blockUI.stop();
                        }).catch(function (ex) {
                            blockUI.stop();
                            exceptionService.resolve(ex);
                        });
                } else {
                    assetsApi.putStockLevelItem(service.data.id, data.itemType.Id, data.qty)
                        .then(function (resp) {
                            populateStockLevelModelBoundToRules(resp.data);
                            blockUI.stop();
                        }).catch(function (ex) {
                            exceptionService.resolve(ex);
                            blockUI.stop();
                        });
                }

            } else {

                // Initial Stock happens when creating NEW Item

                // Check Rules First!!!
                // 2 - No Dont track individual items
                if (basicInfoService.data.IndividualTrackingType.id == 2) {

                    if (service.data.StockLevelTracking.Id == 2) {   // 2 - No stock level counts

                        service.data.StockLevelByCount = service.data.StockLevelByCount || {};

                        // Assets
                        if (data.itemType.Id == 1)
                            service.data.StockLevelByCount.Assets = parseInt(sanitizeIntValue(service.data.StockLevelByCount.Assets)) + parseInt(data.qty);
                        // Inventory
                        else if (data.itemType.Id == 2)
                            service.data.StockLevelByCount.Inventory = parseInt(sanitizeIntValue(service.data.StockLevelByCount.Inventory)) + parseInt(data.qty);
                        // People
                        else if (data.itemType.Id == 4)
                            service.data.StockLevelByCount.People = parseInt(sanitizeIntValue(service.data.StockLevelByCount.People)) + parseInt(data.qty);

                    } else if (service.data.StockLevelTracking.Id == 3) {  // 3 - Stock level counts by branch
                        angular.forEach(service.data.StockLevelByBranches, function (stockByBranch) {
                            if (stockByBranch.BranchObj.Id == data.branch.Id) {
                                // Assets
                                if (data.itemType.Id == 1)
                                    stockByBranch.Assets = parseInt(stockByBranch.Assets) + parseInt(data.qty);
                                // Inventory
                                else if (data.itemType.Id == 2)
                                    stockByBranch.Inventory = parseInt(stockByBranch.Inventory) + parseInt(data.qty);
                                // People
                                else if (data.itemType.Id == 4)
                                    stockByBranch.People = parseInt(stockByBranch.People) + parseInt(data.qty);
                            }

                        }, this);

                    }
                }
            }

        };

        function removeStockLevelFromDb(data) {
            blockUI.start({ message: 'Removing stock item...' });

            if (data.showBranch) {

                assetsApi.removeStockLevelItemByBranch(service.data.id, data.branch.id, data.itemType.Id, data.qty)
                    .then(function (resp) {
                        populateStockLevelModelBoundToRules(resp.data, basicInfoService.data.ItemTypes);
                        blockUI.stop();
                    }).catch(function (ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            } else {
                assetsApi.removeStockLevelItem(service.data.id, data.itemType.Id, data.qty)
                    .then(function (resp) {
                        populateStockLevelModelBoundToRules(resp.data);
                        blockUI.stop();
                    }).catch(function (ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            }
        }

        function convertStockLevelFromDb(data) {
            blockUI.start({ message: 'Converting stock item...' });

            if (data.showBranch) {
                assetsApi.putConvertStockLevelItemByBranch(service.data.id, data.branch.id, data.fromItemType.Id, data.toItemType.Id, data.qty)
                    .then(function (resp) {
                        populateStockLevelModelBoundToRules(resp.data, basicInfoService.data.ItemTypes);
                        blockUI.stop();
                    }).catch(function (ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            } else {
                assetsApi.putConvertStockLevelItem(service.data.id, data.fromItemType.Id, data.toItemType.Id, data.qty)
                    .then(function (resp) {
                        populateStockLevelModelBoundToRules(resp.data);
                        blockUI.stop();
                    }).catch(function (ex) {
                        exceptionService.resolve(ex);
                        blockUI.stop();
                    });
            }
        };

        function refreshStockLevelCounts(itemId) {
            assetsApi.getStockLevelCounts(itemId)
                .then(function (resp) {
                    populateStockLevelModelBoundToRules(resp.data[0], basicInfoService.data.ItemTypes);
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                });
        };

        /**
         * We can not use service.data.map(), because we need to align it to ui business rules
         */
        function populateStockLevelModelBoundToRules(serverData, itemTypes) {
            if (!serverData) return;

            service.data.map({
                id: serverData.id,
                StockLevelTracking: getStockLevelTrackingEnum(serverData.StockLevelTracking),
            });

            if (serverData.StockLevelTracking == 2) {   // 2 - No stock level counts
                service.data.StockLevelByCount = service.data.StockLevelByCount || {};

                if (serverData.StockItems.length > 0) {
                    // Assets
                    service.data.StockLevelByCount.Assets = parseInt(sanitizeIntValue(serverData.StockItems[0].Stock.Assets));
                    // Inventory
                    service.data.StockLevelByCount.Inventory = parseInt(sanitizeIntValue(serverData.StockItems[0].Stock.Inventory));
                    // People
                    service.data.StockLevelByCount.People = parseInt(sanitizeIntValue(serverData.StockItems[0].Stock.People));
                }

            } else if (serverData.StockLevelTracking == 3) {  // 3 - Stock level counts by branch

                // Populate by Branch
                service.data.StockLevelByBranches.length = 0;
                angular.forEach(serverData.StockItems, function (serverItm) {
                    service.data.StockLevelByBranches.push({
                        Branch: (serverItm.Branch) ? serverItm.Branch.Name : null,
                        BranchObj: serverItm.Branch,
                        Assets: serverItm.Stock.Assets,
                        Inventory: serverItm.Stock.Inventory,
                        People: serverItm.Stock.People
                    });
                }, this);

                showStockLevelBranchFields(itemTypes);
            }

            changeStockLevelTracking();
            changeLowStockNotif();
            checkControlsAccessibilityRules();
        };

        // TODO: REFACTOR this one!!!
        // For load only
        // Stock Level Count by Branch
        function showStockLevelBranchFields(itemTypes) {
            service.isAssetSLCbyBranchVisible = false
            service.isInventorySLCbyBranchVisible = false;
            service.isPeopleSLCbyBranchVisible = false;

            angular.forEach(itemTypes, function (item) {

                if (angular.isObject(item)) {
                    if (parseInt(item.Id) === 1)
                        service.isAssetSLCbyBranchVisible = true;
                    if (parseInt(item.Id) === 2)
                        service.isInventorySLCbyBranchVisible = true;
                    if (parseInt(item.Id) === 4)
                        service.isPeopleSLCbyBranchVisible = true;
                } else {
                    if (parseInt(item) === 1)
                        service.isAssetSLCbyBranchVisible = true;
                    if (parseInt(item) === 2)
                        service.isInventorySLCbyBranchVisible = true;
                    if (parseInt(item) === 4)
                        service.isPeopleSLCbyBranchVisible = true;
                }

            }, this);

        };

        function sanitizeIntValue(value) {
            return isNaN(value) ? 0 : value;
        };

        function getStockLevelTrackingEnum(id) {
            var stockLevelTrackingType = _.filter(service.stockLevelTrackingLookup, function (o) {
                return o.Id === parseInt(id);
            })[0];
            return stockLevelTrackingType;
        };

        /**
         * Check if there's a valid stock level count
         * Scan stock levels
         */
        function hasActiveStockLevelCount() {
            var hasActiveStock = false;

            if (!service.data.StockLevelTracking) return false;

            if (service.data.StockLevelTracking.Id == 2) { // By Count
                hasActiveStock = (parseInt(service.data.StockLevelByCount.Assets) > 0)
                    || (parseInt(service.data.StockLevelByCount.Inventory) > 0)
                    || (parseInt(service.data.StockLevelByCount.People) > 0);

            } else if (service.data.StockLevelTracking.Id == 3) { // By Branch
                for (var i = 0; i < service.data.StockLevelByBranches.length; i++) {
                    var curr = service.data.StockLevelByBranches[i];

                    if (parseInt(curr.Assets) > 0 || parseInt(curr.Inventory) > 0 || parseInt(curr.People) > 0) { // Assets
                        hasActiveStock = true;
                        break;
                    }
                }

            }

            return hasActiveStock;
        };

        function isItemTypeSelected(id) {
            var itemType = _.filter(basicInfoService.data.ItemTypes, function (o) {
                return o.Id === parseInt(id);
            })[0];

            return !!itemType;
        };

        /**
         * Check if item type is valid (Asset, Inventory and People) this is used for Stock Level Tracking
         */
        function isItemTypeSelectedExceptForRental() {
            var RENTAL_TYPE = 3;

            if (basicInfoService.data.ItemTypes.length > 0) {
                if (basicInfoService.data.ItemTypes.length == 1) {
                    var itemType = _.filter(basicInfoService.data.ItemTypes, function (o) {
                        return o.Id === parseInt(RENTAL_TYPE);
                    })[0];

                    return !(!!itemType);
                }

                return true;
            }
            return false;
        };

    }
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .factory('itemManagerService', itemManagerService);

    /** @ngInject */
    function itemManagerService($q,
        $log,
        $mdToast,
        $injector,
        $location,
        utils,
        blockUI,
        costCodeEntryService,
        assetsLookupService,
        stockLevelService,
        exceptionService,
        basicInfoService,
        a8TreeMdBoxService,
        individualItemService,
        individualItemGridService,
        assetsApi,
        oldAwardAPI,
        lookupApi,
        branchApi,
        skillsMatrixApi,
        customFieldsUtils,
        stockCategoryConverterService,
        customizedFieldService, _
    ) {
        var service = {
            itemTypesLookup: [],
            stockLevelTrackingLookup: [],
            costCodesLookup: [],
            taxTypesLookup: [],
            vehicleOwnershipTypesLookup: [],
            skillGroupsLookUp: [],
            lowStockNotificationsLookup: ['Yes', 'No'],
            individualItemStatusLookup: [],
            depreciationModelLookup: [],
            employeeContactLookup: [],
            branchesLookup: [],
            loadLookups: loadLookups,
            loadEmployeeContactLookup: loadEmployeeContactLookup,
            itemCategoryLookup: null,
            individualTrackingTypesLookup: [],
            hirePeriodsLookup: [],
            shiftRoles: [],
            awardsLookup: [],
            awardClassificationsLookup: [],
            changeItemType: changeItemType,
            hireRateData: [],
            isEditMode: false,
            getBasicInfoData: getBasicInfoData,
            loadCategoryTree: loadCategoryTree,
            isSaving: false,
            save: save,
            update: update,
            resetData: resetData,
            load: load,
            showIndividualItemsSection: false,
            viewItems: viewItems,
            linkedFormTemplates: null,
            unlinkedFormTemplates: null,
            overriddenFormTemplates: null,
            formTemplatesListApi: {},
            isDirty: false
        };

        activate();

        return service;

        function activate() {
            individualItemService.refreshIndividualItemGridCallback = refreshIndividualItemGridCallback;
            stockLevelService.onTrackIndividualItemChanged = onTrackIndividualItemChanged;
        }

        function save(allowRedirect) {
            var apiPromise = null;
            basicInfoService.data.CustomFields = customFieldsUtils.bindData(basicInfoService.customisedFields, customizedFieldService.values);
            basicInfoService.data.CustomFieldsValues = customFieldsUtils.bindData2(basicInfoService.customisedFields, customizedFieldService.values);
            var basicData = basicInfoService.data.toBackendModel();
            var categories = {
                'Categories': stockCategoryToBackendModel(a8TreeMdBoxService.getSelectedItems())
            };
            var baseSaleAndCostCode = costCodeEntryService.data.toBackendModel();
            var priceDetails = {
                'BaseHirePrices': hireRateDataToBackendModel(service.hireRateData)
            };
            var payload = angular.extend({}, basicData);
            if (basicInfoService.source == 'people') {
                payload.ItemTypes = [4]
            }
            angular.extend(payload, categories);
            angular.extend(payload, baseSaleAndCostCode);
            angular.extend(payload, priceDetails);
            payload.StockLevel = stockLevelService.data.StockLevelTracking;

            payload.LinkedFormTemplates = Array.isArray(service.linkedFormTemplates) ? Array.from(service.linkedFormTemplates) : service.linkedFormTemplates;
            payload.UnlinkedFormTemplates = Array.isArray(service.unlinkedFormTemplates) ? Array.from(service.unlinkedFormTemplates) : service.unlinkedFormTemplates;
            payload.OverriddenFormTemplates = Object.keys(service.formTemplatesListApi)
                .length > 0 ? Array.from(service.formTemplatesListApi.getOverriddenTemplatesToSave()) : {};

            apiPromise = assetsApi.postItem(payload)
                .then(function(resp) {
                    service.isSaving = false;

                    // Save stock
                    var promise2 = saveInitialStock(resp.data.id)
                        .then(function(resp2) {
                            blockUI.stop();

                            // Stay in current screen or leave it
                            if (allowRedirect) {
                                redirectToItemView();
                                service.isEditMode = false;
                                var notif = $mdToast.simple()
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    .textContent('Saved');
                                $mdToast.show(notif);
                            } else {
                                var notif = $mdToast.simple()
                                    .position('bottom right')
                                    .hideDelay(3000)
                                    .textContent('Saved')

                                $mdToast.show(notif)
                                    .then(function() {
                                        if (basicInfoService.source == 'item') {
                                            $location.url('/assets/manage/item/update/' + resp.data.id);
                                        } else {
                                            $location.url('/assets/manage/shift/update/' + resp.data.id);
                                        }
                                    }, function() {
                                        if (basicInfoService.source == 'item') {
                                            $location.url('/assets/manage/item/update/' + resp.data.id);
                                        } else {
                                            $location.url('/assets/manage/shift/update/' + resp.data.id);
                                        }
                                    });
                            }
                            return resp2;
                        })
                        .catch(function(ex) {
                            throw ex;
                        });

                    return promise2;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function saveInitialStock(itemId) {
            var trackIndividualItemDetails = _.isUndefined(basicInfoService.data.IndividualTrackingType) ? null : basicInfoService.data.IndividualTrackingType.id;
            var stockLevelTracking = _.isNull(stockLevelService.data.StockLevelTracking) ? null : stockLevelService.data.StockLevelTracking.Id;
            var stockItems = [];
            var stockItem = {};

            if (stockLevelTracking == 2) { // Generate STOCK LEVEL COUNTS
                stockItem = {
                    'Branch': null,
                    'Stock': {
                        'Assets': stockLevelService.data.StockLevelByCount.Assets ? stockLevelService.data.StockLevelByCount.Assets : 0,
                        'Inventory': stockLevelService.data.StockLevelByCount.Inventory ? stockLevelService.data.StockLevelByCount.Inventory : 0,
                        'People': stockLevelService.data.StockLevelByCount.People ? stockLevelService.data.StockLevelByCount.People : 0
                    }
                };

                stockItems.push(stockItem);
            } else if (stockLevelTracking == 3) { // Generate STOCK LEVEL COUNTS BY BRANCH

                angular.forEach(stockLevelService.data.StockLevelByBranches, function(itm) {
                    stockItem = {
                        'Branch': itm.BranchObj,
                        'Stock': {
                            'Assets': itm.Assets ? itm.Assets : 0,
                            'Inventory': itm.Inventory ? itm.Inventory : 0,
                            'People': itm.People ? itm.People : 0
                        }
                    };

                    stockItems.push(stockItem);

                }, this);
            }

            var data = {
                ItemId: itemId,
                TrackIndividualItemDetails: trackIndividualItemDetails,
                StockLevelTracking: stockLevelTracking,
                StockItems: stockItems
            };

            var apiPromise = assetsApi.saveInitialStock(data)
                .then(function(resp) {
                    return resp;
                });

            return apiPromise;
        }

        function update(allowRedirect) {
            var apiPromise = null;
            basicInfoService.data.CustomFields = customFieldsUtils.bindData(basicInfoService.customisedFields, customizedFieldService.values);
            basicInfoService.data.CustomFieldsValues = customFieldsUtils.bindData2(basicInfoService.customisedFields, customizedFieldService.values);
            var basicData = basicInfoService.data.toBackendModel();
            var categories = {
                'Categories': stockCategoryToBackendModel(a8TreeMdBoxService.getSelectedItems())
            };
            var baseSaleAndCostCode = costCodeEntryService.data.toBackendModel();
            var priceDetails = {
                'BaseHirePrices': hireRateDataToBackendModel(service.hireRateData)
            };

            var payload = angular.extend({}, basicData);
            angular.extend(payload, categories);
            angular.extend(payload, baseSaleAndCostCode);
            angular.extend(payload, priceDetails);
            payload.StockLevel = stockLevelService.data.StockLevelTracking;
            payload.LinkedFormTemplates = Array.isArray(service.linkedFormTemplates) ? Array.from(service.linkedFormTemplates) : service.linkedFormTemplates;
            payload.UnlinkedFormTemplates = Array.isArray(service.unlinkedFormTemplates) ? Array.from(service.unlinkedFormTemplates) : service.unlinkedFormTemplates;
            payload.OverriddenFormTemplates = Object.keys(service.formTemplatesListApi)
                .length > 0 ? Array.from(service.formTemplatesListApi.getOverriddenTemplatesToSave()) : {};

            apiPromise = assetsApi.updateItem(payload)
                .then(function(resp) {
                    $log.debug(resp);
                    blockUI.stop();

                    service.isSaving = false;

                    var notif = $mdToast.simple()
                        .textContent('Updated')
                        .position('bottom right')
                        .hideDelay(3000);
                    $mdToast.show(notif);

                    if (allowRedirect) {
                        redirectToItemView();
                        service.isEditMode = false;
                    }

                    return resp;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        };

        function load(id) {
            service.isEditMode = true;
            blockUI.start({
                message: 'Loading Item...'
            });

            var itemPromise = assetsApi.getItem(id);
            var stockItemPromise = assetsApi.getStockLevelItem(id);

            var promises = $q.all([itemPromise, stockItemPromise])
                .then(function(result) {

                    // Load Item Info
                    loadDataCompleted(result[0].data);

                    service.linkedFormTemplates = result[0].data.LinkedFormTemplates;
                    service.unlinkedFormTemplates = result[0].data.UnlinkedFormTemplates;
                    service.overriddenFormTemplates = result[0].data.OverriddenFormTemplates;

                    // Load Stock Items
                    if (result[1].data.length > 0) {
                        var stockLevelArr = angular.isArray(result[1].data) ?
                            result[1].data[0] :
                            result[1].data;

                        if (basicInfoService.data.StockLevel) {
                            if (basicInfoService.data.StockLevel.Id) {
                                stockLevelArr.StockLevelTracking = basicInfoService.data.StockLevel.Id;
                            } else {
                                stockLevelArr.StockLevelTracking;
                            }
                        } else {
                            stockLevelArr.StockLevelTracking = null;
                        }

                        stockLevelService.populateStockLevelModelBoundToRules(stockLevelArr, result[0].data.ItemTypes);
                    }

                    basicInfoService.hasPeopleType = alasql('select * from ? where Name = ?', [basicInfoService.data.ItemTypes, 'People'])
                        .length;

                    // Show Individual Items
                    if (angular.isDefined(basicInfoService.data.IndividualTrackingType)) {
                        service.showIndividualItemsSection = (basicInfoService.data.IndividualTrackingType.id == 1) && service.isEditMode;
                    }

                    if (service.showIndividualItemsSection) {
                        individualItemGridService.loadGridData(basicInfoService.data.id);
                    }

                    refreshClassificationLookups();

                    blockUI.stop();

                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return promises;
        };

        function loadDataCompleted(resp) {

            //Format Related Data
            var requisites = [];
            angular.forEach(resp.ItemPrerequisites, function(item) {
                var itm = {
                    id: item.id,
                    ItemName: item.ItemName,
                    Qty: item.Quantity,
                    ItemTypes: item.ItemTypes,
                    IsOptional: item.IsOptional
                }
                requisites.push(itm);
            });

            // Re-map existing data
            basicInfoService.data.map({
                id: resp.id,
                ItemName: resp.ItemName,
                Description: resp.Description,
                Categories: resp.Categories,
                ShiftRole: resp.ShiftRole,
                CustomFields: resp.CustomFields,
                ItemPrerequisites: requisites,
                ItemRequiredSkills: resp.ItemRequiredSkills,
                RequiresOperator: resp.RequiresOperator,
                RequireToBeLinked: resp.RequireToBeLinked,
                DisplayUniqueId: resp.DisplayUniqueId,
                IsAllocatable: resp.IsAllocatable,
                Branches: resp.Branches,
                InvoiceGroupName: resp.InvoiceGroupName,
                ItemTaxType: resp.ItemTaxType,
                DefaultBillingPeriod: resp.DefaultBillingPeriod,
                UtilisationDays: resp.UtilisationDays,
                UtilisationTarget: resp.UtilisationTarget,
                Award: resp.Award,
                AwardClassification: resp.AwardClassification
            });

            basicInfoService.formatSkills();

            // Low Stock Notif
            basicInfoService.data.IndividualTrackingType = getTrackIndividualItemEnum(resp.TrackIndividualItemDetails);
            basicInfoService.data.LowStockNotification = getLowNotifServerToUIValue(resp.LowStockNotification);
            basicInfoService.data.StockLevel = resp.StockLevel;


            if (resp.LowStock) {
                basicInfoService.data.LowAssetWarning = resp.LowStock.Assets;
                basicInfoService.data.LowInventoryWarning = resp.LowStock.Inventory;
                basicInfoService.data.LowPeopleWarning = resp.LowStock.People;
            }

            // Load Items
            basicInfoService.data.ItemTypes = resp.ItemTypes.map(function(id) {
                return utils.objectSanitize(getItemTypeObject(id))
            }).filter(function (itemType) {
                return !!itemType;
            });

            // Load Categories
            loadCategoryTree();

            // Load Cost Code
            costCodeEntryService.data.map({
                BaseSalePrice: resp.BaseSalePrice,
                CostCode: resp.CostCode
            });

            // Hire Rate
            service.hireRateData.length = 0;
            angular.forEach(resp.BaseHirePrices, function(itm) {
                var period = _.filter(service.hirePeriodsLookup.data, function(o) {
                    return o.Id === parseInt(itm.HirePeriod);
                })[0];

                service.hireRateData.push({
                    id: itm.HirePeriod,
                    periodName: (period.Name ? period.Name : ''),
                    hireCost: itm.HireCost
                });
            }, this);

            stockLevelService.data.StockLevelTracking = basicInfoService.data.StockLevel;

            return resp;
        };

        function onTrackIndividualItemChanged() {

            // Show Individual Items
            if (angular.isDefined(basicInfoService.data.IndividualTrackingType))
                service.showIndividualItemsSection = (basicInfoService.data.IndividualTrackingType.id == 1) && service.isEditMode;

            if (service.showIndividualItemsSection)
                individualItemGridService.loadGridData(basicInfoService.data.id);
        }

        function resetData() {
            basicInfoService.data.reset();
            costCodeEntryService.data.reset();
            stockLevelService.reset();
            service.hireRateData.length = 0;
            stockLevelService.setBranchLookup(service.branchesLookup);
            service.isEditMode = false;
            service.showIndividualItemsSection = false;
            a8TreeMdBoxService.reset();
        };

        function getItemTypeObject(id) {
            var itemType = _.filter(service.itemTypesLookup, function(o) {
                return o.Id === parseInt(id);
            })[0];

            return itemType;
        }

        function refreshIndividualItemGridCallback() {
            if (service.showIndividualItemsSection) {
                individualItemGridService.loadGridData(basicInfoService.data.id);
            }
        }

        function hireRateDataToBackendModel() {
            var hireRates = [];
            angular.forEach(service.hireRateData, function(itm) {
                hireRates.push({
                    HirePeriod: itm.id,
                    HireCost: itm.hireCost
                });
            }, this);

            return hireRates;
        }

        function redirectToItemView() {
            var stateProvider = $injector.get('$state');
            if (basicInfoService.source == 'item') {
                stateProvider.go('app.view_items');
            } else {
                stateProvider.go('app.shift_view_items');
            }
        }

        function loadLookups() {

            // Item types lookup
            service.itemTypesLookup.length = 0;
            var promise1 = assetsLookupService.fetchItemTypesLookup()
                .then(function(resp) {

                    angular.forEach(resp.data, function(itm) {
                        service.itemTypesLookup.push(itm);
                    }, this);

                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            // Stock level tracking
            service.stockLevelTrackingLookup.length = 0;
            var promise2 = assetsLookupService.fetchStockLevelTrackingLookup()
                .then(function(resp) {

                    angular.forEach(resp.data, function(itm) {
                        service.stockLevelTrackingLookup.push(itm);
                    }, this);

                    stockLevelService.stockLevelTrackingLookup = service.stockLevelTrackingLookup;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            service.costCodesLookup.length = 0;
            var promise3 = assetsApi.getCostCodes2()
                .then(function(resp) {
                    angular.forEach(resp.data, function(itm) {
                        service.costCodesLookup.push(itm);
                    }, this);
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise4 = branchApi.getBranches()
                .then(function(resp) {
                    stockLevelService.setBranchLookup(resp.data);
                    service.branchesLookup = resp.data;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });


            service.individualItemStatusLookup.length = 0;
            var promise5 = assetsApi.getIndividualItemStatus()
                .then(function(resp) {

                    angular.forEach(resp.data, function(itm) {
                        service.individualItemStatusLookup.push(itm);
                    }, this);

                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            service.depreciationModelLookup.length = 0;
            var promise6 = assetsApi.getDepreciationModelList()
                .then(function(resp) {

                    angular.forEach(resp.data, function(itm) {
                        service.depreciationModelLookup.push(itm);
                    }, this);

                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise7 = assetsLookupService.fetchItemCategoriesLookup()
                .then(function(resp) {

                    service.itemCategoryLookup = resp;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise8 = assetsApi.getIndividualTrackingTypes()
                .then(function(resp) {
                    service.individualTrackingTypesLookup = resp.data;
                    stockLevelService.trackIndividualItemDetailsLookup = resp.data;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise9 = lookupApi.getHirePeriod()
                .then(function(resp) {
                    service.hirePeriodsLookup = resp;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise10 = skillsMatrixApi.getSkillsGroups()
                .then(function(resp) {
                    service.skillGroupsLookUp = resp;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise11 = oldAwardAPI.getShiftRoles()
                .then(function(resp) {
                    service.shiftRoles = resp.data;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise12 = lookupApi.getTaxTypes()
                .then(function(dataTaxTypes) {
                    service.taxTypesLookup = dataTaxTypes;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise13 = oldAwardAPI.getAwards()
                .then(function(resp) {
                    service.awardsLookup = resp.data;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise14 = oldAwardAPI.getClassificationsLookup()
                .then(function(resp) {
                    service.awardClassificationsLookup = resp.data;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            var promise15 = lookupApi.getVehicleOwnershipTypes()
            .then(function(resp) {
                service.vehicleOwnershipTypesLookup = resp.data;
            })
            .catch(function(ex) {
                exceptionService.resolve(ex);
            });

            return $q.all([promise1, promise2, promise3, promise4, promise5, promise6, promise7, promise8, promise9, promise10, promise11, promise12, promise13, promise14, promise15]);
        };

        function viewItems(source) {
            redirectToViewKit(source);
        };

        function redirectToViewKit(source) {
            var stateProvider = $injector.get('$state');
            if (basicInfoService.source == 'item') {
                stateProvider.go('app.view_items');
            } else {
                stateProvider.go('app.shift_view_items');
            }
        };

        function loadEmployeeContactLookup() {
            // Item types lookup
            service.employeeContactLookup.length = 0;
            var promise = assetsLookupService.fetchEmployeeContactLookups()
                .then(function(resp) {
                    angular.forEach(resp.data, function(itm) {
                        itm.FullName = itm.FirstName + ' ' + itm.LastName;
                        service.employeeContactLookup.push(itm);
                    }, this);

                    return service.employeeContactLookup;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });
            return promise;
        };

        function changeItemType() {
            stockLevelService.updateStockLevelCountByBranchVisibility(basicInfoService.data.ItemTypes);
        };

        function getBasicInfoData() {
            return basicInfoService.data;
        };

        function loadCategoryTree() {
            var catTree = null;
            if (!service.isEditMode) {
                catTree = stockCategoryConverterService.toUITree(service.itemCategoryLookup, []);
            } else {
                catTree = stockCategoryConverterService.toUITree(service.itemCategoryLookup, basicInfoService.data.Categories);
                stockCategoryConverterService.nodeHasSelectedChild(service.itemCategoryLookup, '97ab2ca3-60e6-46bc-8a78-bcaa64391274', basicInfoService.data.Categories);
            }

            a8TreeMdBoxService.source.length = 0;
            angular.forEach(catTree.tree, function(itm) {
                a8TreeMdBoxService.source.push(itm);
            }, this);

            if (basicInfoService.data.Categories) {
                a8TreeMdBoxService.expandTo(basicInfoService.data.Categories);
            }
        }

        function getTrackIndividualItemEnum(id) {
            var trackIndividualItemDetails = _.filter(service.individualTrackingTypesLookup, function(o) {
                return o.id === parseInt(id);
            })[0];
            return trackIndividualItemDetails;
        };

        function getLowNotifServerToUIValue(value) {
            return value == true ? 'Yes' : 'No';
        }

        function stockCategoryToBackendModel(dataArr) {
            var arr = [];
            angular.forEach(dataArr, function(itm) {

                arr.push({
                    Id: itm.primaryId,
                    ParentId: itm.parentId,
                    Name: itm.label,
                    CategoryKey: itm.id
                });
            }, this);
            return arr;
        };

        function refreshClassificationLookups() {
            let selectedBranches = basicInfoService.data.Branches;
            let award = basicInfoService.data.Award;

            angular.forEach(service.awardClassificationsLookup, function(classification) {
                classification.isDisabled = true;
            });

            if (!_.isNil(award) && !_.isEmpty(award)) {

                if (!_.isNil(selectedBranches)) {
                    let deferred = $q.defer();

                    angular.forEach(selectedBranches, function(branch) {
                        oldAwardAPI.getClassificationsByAwardAndBranch(award.Id, branch.Id)
                            .then(function(resp) {
                                let classificationsByBranchAndAward = [];
                                classificationsByBranchAndAward = resp.data;
                                deferred.resolve(resp.data);

                                angular.forEach(service.awardClassificationsLookup, function(classification) {

                                    if (!_.isNil(classificationsByBranchAndAward)) {

                                        var itemIndex = _.findIndex(classificationsByBranchAndAward, function(o) {
                                            return o.Id === classification.Id;
                                        })

                                        if (itemIndex !== -1) {
                                            classification.isDisabled = false;
                                        }
                                    }
                                });

                            })
                            .catch(function(ex) {
                                deferred.reject(ex);
                            });
                    });
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .factory('itemGridService', itemGridService);

    /** @ngInject */
    function itemGridService(
        $injector,
        assetsApi,
        exceptionService,
        itemGridModel,
        assetsLookupService,
        _,
        $mdDialog,
        blockUI,
    ) {
        var service = {
            data: [],
            query: null,
            loadGridData: loadGridData,
            createItem: createItem,
            editItem: editItem,
            createShiftType: createShiftType,
            editShiftType: editShiftType,
            itemTypesLookup: [],
            removeItem: removeItem
        };

        activate();

        return service;

        ///////
        function activate() {
            // Item types lookup
            service.itemTypesLookup.length = 0;
            assetsLookupService.fetchItemTypesLookup()
                .then(function(resp) {

                    angular.forEach(resp.data, function(itm) {
                        service.itemTypesLookup.push(itm);
                    }, this);

                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        };

        function loadGridData() {
            var apiPromise = assetsApi.getItems()
                .then(function(resp) {
                    service.data.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        var model = new itemGridModel();
                        var items = extractItemTypes(itm.ItemTypes);

                        model.map(itm);
                        model.ItemTypes = items;
                        service.data.push(model);

                    }, this);

                    return service.data;
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function createItem() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.manage_item');
        };

        function createShiftType() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.manage_shift');
        };

        function editItem(id, itemName) {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.manage_item_update', {
                id: id,
                itemName: itemName
            });
        };

        function removeItem(itemId, itemName) {
            let confirm = $mdDialog.confirm({
                title: "Delete Item",
                textContent: "Are you sure you want to delete the item '" + itemName + "'?",
                ok: "OK",
                cancel: "Cancel"
            });

            $mdDialog
                .show(confirm)
                .then(function() {
                    deleteItem(itemId, itemName);
                })
                .finally(function() {
                    confirm = undefined;
                });
        }

        function editShiftType(id) {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.manage_shift_update', {
                id: id
            });
        }

        function extractItemTypes(data) {
            var itemTypes = extractItemTypeObj(data);
            var items = [];
            angular.forEach(itemTypes, function(itm) {
                items.push(itm.Name);
            }, this);

            return items.join(', ');
        };

        function extractItemTypeObj(itemTypesId) {
            var items = [];
            angular.forEach(itemTypesId, function(id) {

                var itemType = _.filter(service.itemTypesLookup, function(o) {
                    return o.Id == id;
                })[0];


                if (itemType)
                    items.push(itemType);
            }, this);

            return items;
        };

        function deleteItem(itemId, itemName) {
            blockUI.start({
                message: "Deleting Item..."
            });

            let alertMessage = "Item '" + itemName + "' has been deleted."

            assetsApi.deleteItem(itemId)
                .catch(error => {
                    alertMessage = "Error occured while deleting item '" + itemName + "'.";
                })
                .finally(() => {
                    blockUI.stop();

                    let alert = $mdDialog.alert({
                        title: "Delete Item",
                        textContent: alertMessage,
                        ok: "OK"
                    });

                    $mdDialog.show(alert)
                        .finally(function() {
                            alert = undefined;
                        });

                    loadGridData();
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .factory('individualItemGridService', individualItemGridService);

    /** @ngInject */
    function individualItemGridService(
        $mdDialog,
        exceptionService,
        assetsApi,
        individualItemGridModel,
        blockUI,
        _
    ) {
        var service = {
            data: [],
            loadGridData: loadGridData,
            remove: remove,
            showApprovals: showApprovals
        };
        var itemStates = [];

        activate();

        return service;

        function activate() {
            assetsApi.getIndividualItemStatus()
                .then(function(resp) {
                    itemStates = resp.data;
                });
        }

        function showApprovals(id) {
            $mdDialog.show({
                templateUrl: 'app/main/assets/manage/item/individualItem/individual-item-approvals-dialog.html',
                controller: 'individualItemApprovalDialogController as vmApprovalChain',
            }).then(function(result) {
                // noop
            });
        }

        function loadGridData(itemId) {
            blockUI.start({
                message: 'Loading Individual Item List...'
            });

            var apiPromise = assetsApi.getIndividualItems(itemId)
                .then(function(resp) {

                    service.data.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        var model = new individualItemGridModel();
                        var status = getItemStatesEnum(itm.ItemStatus);

                        model.map(itm);
                        model.BranchNames = itm.Branches.map(b => b.Name);
                        model.ItemStatusName = status.Name;
                        service.data.push(model);
                    }, this);

                    blockUI.stop();
                    return service.data;
                }).catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function getItemStatesEnum(id) {
            var itemState = _.filter(itemStates, function(o) {
                return o.Id === parseInt(id);
            })[0];
            return itemState;
        }

        function remove(id) {}
    };
})();

(function () {
    'use strict';

    angular.module('app.assets')
        .factory('individualItemService', individualItemService);

    /** @ngInject */
    function individualItemService(individualItemModel,
        contactApi,
        utils,
        $mdDialog,
        $injector,
        blockUI,
        $log,
        assetsApi,
        branchApi,
        exceptionService,
        stockLevelService,
        assetsLookupService,
        $q,
        _) {
            
        var service = {
            data: new individualItemModel(),
            users: [],
            addDepreciation: addDepreciation,
            showDepreciationDialog: showDepreciationDialog,
            hideDialog: hideDialog,
            save: save,
            update: update,
            remove: remove,
            resetData: resetData,
            refreshIndividualItemGridCallback: angular.noop,
            isEditMode: false,
            load: load,
            load2: load2,
            hasChangesEvent: angular.noop,
            getDivisionsAndUsers: getDivisionsAndUsers,
            refreshTotalSummary: refreshTotalSummary,
            divisionsLookup: [],
            branchesLookup: [],
            disableAddDepreciation: false,
            getUsersPerBranch: getUsersPerBranch
        };

        var itemTypesLookup = [],
            TOTAL_PERCENTAGE = 100;

        activate();

        return service;

        ///////
        function activate() {
            loadLookups();
            applyUIAccessRules();
        };

        function getDivisionsAndUsers() {
            let individualItemBranches = service.data.Branches;

            loadDivisionsLookup(individualItemBranches);
            preSelectDivisions();
            getEmployeesBelongToAllByBranches(individualItemBranches);
        }

        function preSelectDivisions() {
            let divisionsLookup = service.divisionsLookup;
            let selectedDivisions = service.data.Divisions;

            if (_.isArray(selectedDivisions) && selectedDivisions.length > 0) {
                service.data.Divisions = [];

                angular.forEach(selectedDivisions, function (division) {
                    var existingDivision = divisionsLookup.find(function (lookup) {
                        return lookup.id === division.id;
                    });

                    if (existingDivision) {
                        service.data.Divisions.push(existingDivision);
                    }
                });
            }
        }

        function loadDivisionsLookup(individualItemBranches) {
            service.divisionsLookup = [];

            if (!_.isArray(individualItemBranches) || individualItemBranches.length === 0) {
                return;
            }

            let divisionsLookup = [];
            let branchesLookup = service.branchesLookup;

            angular.forEach(individualItemBranches, function (branch) {
                let lookupBranchItem = branchesLookup.find(function (lookupItem) {
                    return lookupItem.Id === branch.Id;
                });

                if (lookupBranchItem) {
                    angular.forEach(lookupBranchItem.Division, function (division) {
                        division.BranchId = branch.Id;
                        division.BranchName = branch.Name;
                        divisionsLookup.push(division);
                    });
                }
            });

            service.divisionsLookup = _.sortBy(divisionsLookup, 'Name');
        }

        function getUsersPerBranch(branchId) {
            blockUI.start('Getting users...');
            contactApi.getUsersPerBranch(branchId).then(function (resp) {
                angular.forEach(service.users, function (user) {
                    user['FullName'] = user.FirstName + " " + user.LastName;
                });
                service.users = resp.data;
                blockUI.stop();
            });
        }

        function getEmployeesBelongToAllByBranches(individualItemBranches) {
            let selectedUser = service.data.User;

            service.users = [];
            service.data.User = null;

            if (!_.isArray(individualItemBranches) || individualItemBranches.length === 0) {
                return;
            }

            blockUI.start('Getting employees...');

            let branchIds = individualItemBranches.map(b => b.Id);

            contactApi.getEmployeesBelongToAllByBranches(branchIds).then(function (resp) {
                let users = resp.data;
                angular.forEach(users, function (user) {
                    user['FullName'] = user.FirstName + " " + user.LastName;
                });
                service.users = _.sortBy(users, 'FullName');

                if (selectedUser) {
                    let existingSelectedUser = users.find(function (user) {
                        return user.Id === selectedUser.id;
                    })

                    if (existingSelectedUser) {
                        service.data.User = selectedUser;
                    }
                }

                blockUI.stop();
            }).catch(function (ex) {
                blockUI.stop();
                exceptionService.resolve(ex);
            });;
        }

        function loadLookups() {
            assetsLookupService.fetchItemTypesLookup()
                .then(function (resp) {
                    itemTypesLookup = resp.data;
                });
        };

        function applyUIAccessRules() {
            service.disableAddDepreciation = ((service.data.DepreciationTotalSummary <= 0) && (service.data.Depreciation.length > 0));
        };

        function save(itemId) {
            blockUI.start({
                message: 'Saving Individual Item...'
            });

            var payload = service.data.toBackendModel(itemId);

            var promise = assetsApi.postIndividualItem(payload)
                .then(function (resp) {
                    blockUI.stop();
                    $log.debug(resp);

                    // Perform stock level refresh via ItemManager
                    var basicInfoServ = $injector.get('basicInfoService');
                    stockLevelService.populateStockLevelModelBoundToRules(resp.data[0], basicInfoServ.data.ItemTypes);
                    service.refreshIndividualItemGridCallback();
                    $mdDialog.hide();

                    return resp;
                }).catch(function (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
            return promise;
        };

        function update() {
            blockUI.start({
                message: 'Updating Individual Item...'
            });

            var payload = service.data.toBackendModel();

            var promise = assetsApi.putIndividualItem(service.data.id, payload)
                .then(function (resp) {
                    blockUI.stop();
                    // Perform stock level refresh via ItemManager
                    service.refreshIndividualItemGridCallback();
                    $mdDialog.hide();

                    return resp;
                }).catch(function (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
            return promise;
        };

        function remove() {
            refreshTotalSummary();

            // Notify client that we have changes
            service.hasChangesEvent();
        };

        function load(id) {
            service.isEditMode = true;

            blockUI.start({
                message: 'Loading Individual Item...'
            });

            var deferred = $q.defer();

            assetsApi.getIndividualItem(id)
                .then(loadCompleted)
                .then(function(data){
                    deferred.resolve(data);
                })
                .catch(function (ex) {
                    blockUI.stop();
                    deferred.reject(ex);
                });

            return deferred.promise;
        };

        function load2(id) {
            service.isEditMode = true;
            blockUI.start({
                message: 'Loading Individual Item...'
            });

            return $q.all([assetsApi.getIndividualItem(id), branchApi.getBranches()]);
        };

        function loadCompleted(resp) {
            blockUI.stop();

            let individualItem = resp.data;

            service.data.map(individualItem);
            service.data.ItemType = getItemTypeEnum(individualItem.ItemType);

            angular.forEach(service.data.Depreciation, function (itm) {
                itm.id = utils.newGuid();
                itm.YearText = utils.getGetOrdinal(itm.Year);
            }, this);

            recalculateSummary(0, 0);

            if (_.isArray(individualItem.Branches) && individualItem.Branches.length > 0) {
                service.data.Divisions = individualItem.Branches.flatMap(b => b.Division);
            }

            if (individualItem.User) {
                service.data.User.FullName = service.data.User.FirstName + ' ' + service.data.User.LastName;
            }

            getDivisionsAndUsers();

            return individualItem;
        };

        function addDepreciation(depreciationObj) {
            depreciationObj.id = utils.newGuid();
            service.data.Depreciation.push(depreciationObj);

            service.hasChangesEvent();
        };

        function showDepreciationDialog(idToEdit) {
            showDialog(idToEdit);
        };

        function showDialog(id) {
            var locals = {};

            if (id) {
                var toEdit = _.filter(service.data.Depreciation, function (o) {
                    return o.id == id;
                })[0];

                locals.dataToEdit = toEdit;
            } else {
                var yearIndex = (service.data.Depreciation.length <= 0) ?
                    1 :
                    (service.data.Depreciation.length + 1);

                locals.dataToEdit = {
                    YearText: utils.getGetOrdinal(yearIndex),
                    Year: yearIndex,
                    PercentPerYear: null
                };
            }

            $mdDialog.show({
                controllerAs: 'deprecVm',
                controller: 'depreciationDialogController',
                //skipHide: true,
                multiple: true,
                templateUrl: 'app/main/assets/manage/item/individualItem/depreciation-dialog.html',
                locals: locals
            }).then(function (result) {
                if (result) {
                    var depreciation = _.filter(service.data.Depreciation, function (o) {
                        return o.Year == result.data.Year;
                    })[0];

                    if (!depreciation) {
                        addDepreciation(result.data);
                    } else {
                        depreciation.PercentPerYear = result.data.PercentPerYear;
                    }
                    recalculateSummary(result.data.PercentPerYear, result.data.Year);
                }
            }, function () {
                // Cancel
            });
        };

        function refreshTotalSummary() {
            recalculateSummary(0, 0);
        };

        function hideDialog() {
            $mdDialog.hide();
        };

        function resetData() {
            service.data.reset();
            service.isEditMode = false;
        };

        function recalculateSummary(valueToAdd, excludeYear) {
            var depreciationTotal = getDepreciationTotal(excludeYear);
            var remaining = TOTAL_PERCENTAGE - depreciationTotal;
            var actual = depreciationTotal + parseFloat(valueToAdd);

            if (actual > TOTAL_PERCENTAGE) {
                alert('The value will exceed the total depreciation percentage. Total exceeds of ' + (actual - TOTAL_PERCENTAGE) + '%');
                _.remove(service.data.Depreciation, function (n) {
                    return n.Year == excludeYear;
                });

                return;
            }

            service.data.DepreciationTotalSummary = remaining - parseFloat(valueToAdd);
        };

        function getDepreciationTotal(excludeYear) {
            var depreciationClone = angular.copy(service.data.Depreciation);
            if (excludeYear) {
                _.remove(depreciationClone, function (n) {
                    return n.Year == excludeYear;
                });
            }

            var total = 0;
            angular.forEach(depreciationClone, function (n) {
                total = parseFloat(total) + parseFloat(n.PercentPerYear);
            }, this);

            return total;
        };

        function getItemTypeEnum(id) {
            var itemType = _.filter(itemTypesLookup, function (o) {
                return o.Id === parseInt(id);
            })[0];
            return itemType;
        };

    };
})();

/***
 * Basic Info Service
 * UI logic
 */
(function(){
  'use strict';

  angular.module('app.assets')
    .factory('importFileService', importFileService);

  /** @ngInject */
  function importFileService($mdDialog,
                             $q,
                             blockUI,
                             utils,
                             basicInfoService,
                             itemManagerService,
                             individualItemService,
                             assetsLookupService,
                             exceptionService,
                             hubService) {
    var service = {
      displayListOfImportIssues: displayListOfImportIssues,
      onImport: onImport,
      showDialog: showDialog
    };

    return service;

    ////////
    function onImport() {
      var deferred = $q.defer();

      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: 'app/main/assets/manage/item/individualItem/import-dialog.html',
        controller: 'importDialogController as vm',
        locals: { itemId: basicInfoService.data.id }
      }).then(function (result) {
        blockUI.start({ message: 'Processing Import File...' });

        if (!result) {
          blockUI.stop();
          return;
        }

        if (!result.hasOwnProperty('status') && angular.isObject(result)) {
          // Call signalR endpoint
          var promise = hubService.bulkImport(result);

          promise.then(function(resp) {
            deferred.resolve(resp);
          }, function(error) {
            deferred.reject(error);
          });

          $mdDialog.hide();
        } else {
          exceptionService.resolve(result, {
            intercept400: function (e) {
              // Display list of errors here using service
              displayListOfImportIssues(e);
            }
          });
        }

        blockUI.stop();
      });

      return deferred.promise;
    }

    function displayListOfImportIssues(issues) {
      var msgs = formatImportIssues(issues);

      $mdDialog.show({
        controllerAs: 'vm',
        controller: 'importErrorDialogController',
        skipHide: true,
        templateUrl: 'app/main/assets/manage/item/individualItem/import-error-dialog.html',
        locals: { issues: msgs }
      }).then(function (result) {

      }, function () {
        // Cancel
      });
    }

    function showDialog(id) {
        $mdDialog.show({
          parent: angular.element(document.body),
          templateUrl: 'app/main/assets/manage/item/individualItem/individual-item-dialog.html',
          controller: 'individualItemDialogController as indvVm',
          locals: {
            itemStates: itemManagerService.individualItemStatusLookup,
            vehicleOwnershipTypes: itemManagerService.vehicleOwnershipTypesLookup,
            depreciationTypes: itemManagerService.depreciationModelLookup,
            itemBranches: basicInfoService.data.Branches,
            branches: itemManagerService.branchesLookup,
            costCodes: itemManagerService.costCodesLookup,
            itemTypes: basicInfoService.data.ItemTypes,
            itemId: itemManagerService.getBasicInfoData().id,
            editData: id
          }
      });
    }

    function formatImportIssues(issue) {
      var msg;
      if (angular.isObject(issue.errorInfo)) {
        var fmt = [];
        fmt.push('<ul>');

        for (var prop in issue.errorInfo) {

          fmt.push('<li><strong>' + utils.pascalCaseToSentence(prop) + '</strong></li>');
          fmt.push('<ul style="margin-bottom:5px;">')
          for(var errorItm in issue.errorInfo[prop]) {
            fmt.push('<li>' + issue.errorInfo[prop][errorItm] + '</li>');
          }
          fmt.push('</ul>');
        }

        fmt.push('</ul>');
        msg = fmt.join('\n');
      } else {
        msg = issue.errorInfo;
      }

      return msg;
    }

  }
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .factory('costCodeEntryService', costCodeEntryService);

    /** @ngInject */
    function costCodeEntryService(
        $mdDialog,
        hireRateModel,
        costCodeEntryModel
    ) {
        var service = {
            data: new costCodeEntryModel(),
            hireRateData: [],
            addHireRate: addHireRate,
            hideEntryForm: hideEntryForm,
            load: load
        };

        activate();

        return service;

        function activate() {}

        function load(data) {
            angular.forEach(data.hireRates, function(item) {
                var hireRate = new hireRateModel();
                var mappedObj = hireRate.map(item);
                service.hireRateData.push(mappedObj);
            }, this);
        }

        function addHireRate() {
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/assets/manage/item/costCode/hire-rate-dialog.html',
                controller: 'HireRateDialogController as vm'
            });
        }

        function hideEntryForm() {
            $mdDialog.hide();
        }
    }
})();

/***
 * Basic Info Service
 * UI logic
 */
(function(){
    'use strict';

    angular.module('app.assets')
           .factory('basicInfoService', basicInfoService);

    /** @ngInject */
    function basicInfoService(basicInfoModel,
                              _) {
        var service = {
            data: new basicInfoModel(),
            source: null,
            customisedFields: [],
            hasPeopleType: null,
            setItemTypeToDisabled: setItemTypeToDisabled,
            formatSkills: formatSkills
        };

        return service;

        ////////
        function setItemTypeToDisabled(flag) {
            service.data.itemTypeDisabled = flag;
        }

        function formatSkills(){
          service.data.ItemRequiredSkillsFormatted = [];
          angular.forEach(service.data.ItemRequiredSkills, function(grp)
          {
            angular.forEach(grp.Skills, function(skl){
              var skill = {};
              skill['GroupName'] = grp.GroupName;
              skill['GroupId'] = grp.id;
              skill['id'] = skl.id;
              skill['Branches'] = skl.Branches;
              if(skl.Branches){
                if(skl.Branches.length > 0){
                  skill['BranchesJoined'] = skl.Branches.map(function(a) {return a.Name;}).join(", ");
                }else{
                  skill['BranchesJoined'] = null;
                }
              }else{
                skill['BranchesJoined'] = null;
              }
              skill.SkillName = skl.SkillName;
              skill.LockoutType = skl.LockoutType;
              service.data.ItemRequiredSkillsFormatted.push(skill);
            });
          });
        }
    }

})();

(function() {
    'use strict';

    angular.module('app.assets')
        .factory('costCodeGridService', costCodeGridService);

    /** @ngInject */
    function costCodeGridService(
        $q,
        assetsApi,
        costCodeGridModel,
        assetsLookupService,
        _) {
        var service = {
            data: [],
            loadGridData: loadGridData
        };

        return service;

        function loadGridData(allowcache) {
            var deferred = $q.defer();
            var lookupPromise = assetsLookupService.fetchCostCodeCategoriesLookup();

            lookupPromise.then(function(catLookup) {
                service.data.length = 0;

                return assetsApi.getCostCodes(allowcache)
                    .then(function(resp) {

                        angular.forEach(resp.data, function(itm) {
                            var model = new costCodeGridModel();
                            model.map(itm);
                            model.CategoryName = model.CostCodeType.TypeName;
                            service.data.push(model);
                        }, this);

                        deferred.resolve(service.data);
                    })
                    .catch(function(ex) {
                        deferred.reject(ex);
                    });
            });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .factory('costCodeService', costCodeService);

    /** @ngInject */
    function costCodeService($mdDialog,
        $q,
        costCodeModel,
        blockUI,
        $mdToast,
        assetsApi,
        assetsLookupService,
        exceptionService,
        costCodeGridService) {

        var service = {
            data: new costCodeModel(),
            categoriesLookup: [],
            query: null,
            addNew: addNew,
            save: save,
            edit: edit,
            load: load,
            remove: remove,
            hideEntryForm: hideEntryForm,
            loadLookups: loadLookups,
            isEditMode: false
        };

        return service;

        function addNew() {
            service.isEditMode = false;
            service.data.reset();

            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/assets/manage/costCodes/cost-code-entry.html',
                controller: 'CostCodeEntryController as vm',
                locals: {}
            });
        }

        function edit(id) {
            service.isEditMode = true;
            service.data.reset();

            $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/main/assets/manage/costCodes/cost-code-entry.html',
                    controller: 'CostCodeEntryController as vm',
                    locals: {
                        id: id,
                        isEdit: true
                    }
                })
                .then(function(resp) {

                })
        }

        function hideEntryForm() {
            $mdDialog.hide();
        }

        function save() {
            var data = service.data.tranformToServerModel();

            var apiMethod = service.isEditMode ? assetsApi.updateCostCode : assetsApi.postCostCode;
            var promise = apiMethod(data)
                .then(function(resp) {
                    reloadData();
                    $mdDialog.hide();
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Cost code successfully saved.')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                })
                .catch(function(ex) {
                    $mdDialog.hide();
                    exceptionService.resolve(ex);
                });
            return promise;
        }

        function loadLookups() {
            var promise = assetsLookupService.fetchCostCodeCategoriesLookup()
                .then(function(resp) {
                    service.categoriesLookup.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        service.categoriesLookup.push(itm);
                    }, this);
                });

            return promise;
        }

        function load(id) {
            var promise = assetsApi.getCostCode(id)
                .then(function(resp) {
                    service.data.map(resp.data);
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });
            return promise;
        }

        function remove(id) {
            var deferred = $q.defer();
            var confirm = $mdDialog.confirm()
                .title('Delete Cost Code')
                .textContent('Delete this Cost Code item?')
                .ariaLabel('Delete this Cost Code item')
                .cancel('Cancel')
                .ok('Delete');

            $mdDialog.show(confirm)
                .then(function() {
                    blockUI.start({
                        message: 'Re-loading Cost Code Listing...'
                    });
                    var promise = assetsApi.removeCostCode(id)
                        .then(function(resp) {
                            reloadData;
                            blockUI.stop();
                            deferred.resolve('deleted');
                        })
                        .catch(function(ex) {
                            deferred.reject(ex);
                            exceptionService.resolve(ex);
                        });
                    return promise;
                }, function() {

                });

            return deferred.promise;
        }

        function reloadData() {
            blockUI.start({
                message: 'Re-loading Cost Code Listing...'
            });
            var deferred = $q.defer();
            costCodeGridService.loadGridData(false)
                .then(function(resp) {
                    deferred.resolve(resp);
                    blockUI.stop();
                });
            return deferred.promise;
        }
    };
})();

/**
 * Manage Category Tree Service
 * by rcnet 8.5.2016
 */
(function () {
    'use strict';

    angular.module('app.assets')
        .factory('manageCategoryTreeService', manageCategoryTreeService);

    /** @ngInject */
    function manageCategoryTreeService(_) {
        var idsToExpand = [];
        var service = {
            toUITree: toUITree,
            toBackendModel: toBackendModel,
            findRelatedIDs: findRelatedIDs
        };

        var source = null,
            selectedItems = null;
            
        activate();

        return service;

        //////
        function activate() {
        }

        function toBackendModel(data) {
            var tree = [],
                changedItems = [],
                depth = 0;
                
            buildBackendModel(data, null, changedItems, depth);

            return changedItems;
        }

        /**
        * Perform transformation of UI specific model to document model
        */
        function buildBackendModel(data, previousParent, changedItems, depth) {
            for (var i = 0; i < data.length; i++) {
                // Handle Leaf
                if (angular.isArray(data[i].nodes) && data[i].nodes.length == 0) {
                    var itm = {
                        Id: angular.isUndefined(data[i].primaryId) ? null : data[i].primaryId,
                        CategoryKey: data[i].id,
                        ParentId: previousParent ? previousParent.id : null,
                        Name: data[i].title
                    };

                    changedItems.push(itm);
                } else if (angular.isArray(data[i].nodes) && data[i].nodes.length > 0) { // Handle Node
                    var itm = {
                        Id: angular.isUndefined(data[i].primaryId) ? null : data[i].primaryId,
                        CategoryKey: data[i].id,
                        ParentId: previousParent ? previousParent.id : null,
                        Name: data[i].title
                    };
                    changedItems.push(itm);

                    depth++;
                    buildBackendModel(data[i].nodes, data[i], changedItems, depth);
                    depth--;
                }
            }
        }

        /**
         * Traverse from parent to child nodes get all related IDs
         */
        function findRelatedIDs(node) {
            var depth = 0,
                relatedIds = [];

            traverseRelatedIds(node, null, relatedIds, depth);

            return relatedIds;
        }

        function traverseRelatedIds(data, previousParent, relatedIds, depth) {
            for (var i = 0; i < data.length; i++) {
                if (angular.isArray(data[i].nodes)) {

                    // Collect ids
                    
                    if (data[i].primaryId)
                        relatedIds.push(data[i].primaryId);

                    // Check leaf nodes
                    if (angular.isArray(data[i].nodes) && data[i].nodes.length > 0) {
                        depth++;
                        traverseRelatedIds(data[i].nodes, data[i], relatedIds, depth);
                        depth--;
                    }
                }
            }
        }

        function toUITree(data, selItems) {
            var tree = [],
                depth = 0;

            source = data;
            selectedItems = selItems;
            var rootItems = getItems(null);
            buildUITree(rootItems, {}, tree, depth);
            source = null;

            return tree;
        }

        function getItems(id) {
            var items = _.filter(source, function (o) {
                return o.ParentId == id;
            });
            return items;
        }

        function buildUITree(data, treeItem, tree, depth) {
            for (var i = 0; i < data.length; i++) {
                var childItems = getItems(data[i].CategoryKey);

                if (childItems.length > 0) {
                    var treeFolder = null;
                    
                    if (angular.isArray(treeItem)) {
                        var item = {};
                        item['id'] = data[i].CategoryKey;
                        item['title'] = data[i].Name;
                        item['nodes'] = [];
                        item['primaryId'] = data[i].Id;

                        treeItem.push(item);
                        treeFolder = treeItem[treeItem.length - 1]['nodes'];
                    } else {
                        // Create initial root folder
                        treeItem['id'] = data[i].CategoryKey;
                        treeItem['title'] = data[i].Name;
                        treeItem['nodes'] = [];
                        treeItem['primaryId'] = data[i].Id;
                        treeFolder = treeItem['nodes'];
                    }

                    depth++;
                    buildUITree(childItems, treeFolder, tree, depth);
                    depth--;
                } else {
                    var leaf = {
                        id: data[i].CategoryKey,
                        title: data[i].Name,
                        primaryId: data[i].Id,
                        nodes: []
                    };

                    if (angular.isArray(treeItem))
                        treeItem.push(leaf);
                    else 
                        treeItem = leaf;
                }

                if (depth === 0) {
                    tree.push(treeItem);
                    treeItem = {};
                }
            }
        }

    }
})();
/***
 * Basic Info Service
 * UI logic
 */
(function () {
    'use strict';

    angular.module('app.assets')
        .factory('assetCategoryService', assetCategoryService);

    /** @ngInject */
    function assetCategoryService($q, $log, manageCategoryTreeService, _, assetsLookupService, stockCategoryApi, exceptionService) {
        var service = {
            data: [],
            deletedItems: [],
            itemCategoryLookup: [],
            isEdited: false,
            save: save,
            addRemovedItem: addRemovedItem,
            loadLookups: loadLookups,
            hasChanges: hasChanges,
            resetData: resetData,
            getCategories: getCategories
        };

        activate();

        return service;

        ////////
        function activate() {
        }

        function hasChanges() {
            service.isEdited = true;
        }

        function resetData() {
            service.data.length = 0;
            service.deletedItems.length = 0;
        }

        function save() {
            var promises = [];

            if (!service.isEdited) return;

            // Transform model and send to server
            var categoryModel = manageCategoryTreeService.toBackendModel(service.data);
            $log.debug('Add items for Manage Asset Category');
            $log.debug(categoryModel);

            var promise1 = stockCategoryApi.updateCategories(categoryModel);
            promises.push(promise1);

            // Get deleted items
            $log.debug('Deleted items for Manage Asset Category');
            $log.debug(service.deletedItems);

            if (service.deletedItems.length > 0) {
                var promise2 = stockCategoryApi.deleteCategories(service.deletedItems);
                promises.push(promise2);
            }

            return $q.all(promises).then(function (resp) {
                // After succesfull save, Remove cache item
                assetsLookupService.invalidateLookup('_itemCategories');
                return resp;
            });
        }

      function getCategories() {
        return assetsLookupService.fetchItemCategoriesLookup();
      }

        /**
         * Add removed/deleted item in a collection
         */
        function addRemovedItem(node) {
            var dataNode = !angular.isArray(node) ? [node] : node;
            var relatedIds = manageCategoryTreeService.findRelatedIDs(dataNode);

            angular.forEach(relatedIds, function (itm) {
                service.deletedItems.push(itm);
            }, this);
        }

        /**
         * Setup the required lookups
         */
        function loadLookups() {
            var promise1 = assetsLookupService.fetchItemCategoriesLookup()
                .then(function (resp) {
                    var treeItems = manageCategoryTreeService.toUITree(resp);

                    service.data.length = 0;
                    angular.forEach(treeItems, function (itm) {
                        service.data.push(itm);
                    }, this);

                });

            return $q.all([promise1]);
        }

        // function populateTreeData() {
        //     service.data = [{
        //         'id': 1,
        //         'title': 'node1',
        //         'nodes': [
        //             {
        //                 'id': 11,
        //                 'title': 'node1.1',
        //                 'nodes': [
        //                     {
        //                         'id': 111,
        //                         'title': 'node1.1.1',
        //                         'nodes': []
        //                     }
        //                 ]
        //             },
        //             {
        //                 'id': 12,
        //                 'title': 'node1.2',
        //                 'nodes': []
        //             }
        //         ]
        //     }, {
        //             'id': 2,
        //             'title': 'node2',
        //             'nodrop': true, // An arbitrary property to check in custom template for nodrop-enabled
        //             'nodes': [
        //                 {
        //                     'id': 21,
        //                     'title': 'node2.1',
        //                     'nodes': []
        //                 },
        //                 {
        //                     'id': 22,
        //                     'title': 'node2.2',
        //                     'nodes': []
        //                 }
        //             ]
        //         }, {
        //             'id': 3,
        //             'title': 'node3',
        //             'nodes': [
        //                 {
        //                     'id': 31,
        //                     'title': 'node3.1',
        //                     'nodes': []
        //                 }
        //             ]
        //         }];
        // }
    }

})();

/**
 * Kit Controller
 * Created date: 7.4.2016
 */
(function () {
    'use strict';

    angular
        .module('app.assets.manage.kit')
        .controller('KitController', KitController);

    /** @ngInject */
    function KitController($scope, kitManagerService, $stateParams) {
        var vm = this;

        vm.model = kitManagerService;
        vm.headerTitle = null;
        vm.buttonSaveCaption = null;

        vm.onSaveAndClose = onSaveAndClose;
        vm.onSave = onSave;
        vm.onViewItems = onViewItems;

        activate();

        function activate() {
            kitManagerService.resetData();

            // Create/Edit mode
            if (angular.isDefined($stateParams.kid)) {
                vm.headerTitle = 'ASSETSMODULE.MANAGE_ASSET_KIT_TITLE_UPDATE';
                vm.buttonSaveCaption = 'ASSETSMODULE.MANAGE_KIT_UPDATE';
                kitManagerService.load($stateParams.kid);
            } else {
                vm.headerTitle = 'ASSETSMODULE.MANAGE_ASSET_KIT_TITLE';
                vm.buttonSaveCaption = 'ASSETSMODULE.MANAGE_KIT_SAVE';
            }
        }

        function onSave() {
            $scope.isSaving = true;

            // Perform validation
            if ($scope.kitItemForm.$invalid) {
                $scope.kitItemForm.$submitted = true;
                return;
            }

            if (!kitManagerService.isEditMode) {
                kitManagerService.save(false);
            } else {
                kitManagerService.update(false);
            }
            
            $scope.currentForm.$setPristine();
        }

        function onSaveAndClose() {
            $scope.isSaving = true;
            
            // Perform validation
            if ($scope.kitItemForm.$invalid) {
                $scope.kitItemForm.$submitted = true;
                return;
            }

            if (!kitManagerService.isEditMode) {
                kitManagerService.save(true);
            }
            
            $scope.currentForm.$setPristine();
        }

        function onViewItems() {
            $scope.isSaving = false;
            kitManagerService.viewItems();
        }
    }

})();

/**
 * Create Cost Codes Controller
 * Created date: 6.22.2016
 */
(function() {
    'use strict';

    angular
        .module('app.assets.manage.item')
        .controller('ItemController', ItemController);

    /** @ngInject */
    function ItemController($rootScope,
        _,
        utils,
        $scope,
        $state,
        $timeout,
        $stateParams,
        itemManagerService,
        basicInfoService,
        customizedFieldService,
        claimsUtilService) {
        var vm = this;
        vm.model = itemManagerService;
        vm.formTypes = [1, 3]; // Vehicle and asset type
        vm.isItemForms = true;
        vm.BillingPeriods = [];
        vm.customizedFieldService = customizedFieldService;
        vm.editMode = undefined;
        vm.basicInfo = basicInfoService;
        vm.basicInfo.source = $state.current.data.source;
        vm.checkAccessService = claimsUtilService;

        vm.onSave = onSave;
        vm.onSaveAndClose = onSaveAndClose;
        vm.onViewItems = onViewItems;
        vm.onViewShifts = onViewShifts;

        vm.model.linkedFormTemplates = null;
        vm.model.unlinkedFormTemplates = null;
        vm.model.overriddenFormTemplates = null;
        vm.model.formTemplatesListApi = {};
        vm.model.vehicles = null;
        vm.model.assets = null;

        $timeout(function() {
            activate();
        });

        vm.shouldDisableSaveButton = function () {
            return !vm.model.isDirty || vm.model.isSaving || $scope.itemForm.$invalid || vm.customizedFieldService.manageCustomizedFields || $scope.CustomForm.$invalid;
        }

        function activate() {
            itemManagerService.resetData();
            customizedFieldService.manageCustomizedFields = false;
            if (!_.isNil($stateParams.id)) {
                vm.buttonSaveCaption = 'ASSETSMODULE.MANAGE_ASSET_UPDATE';
                vm.editMode = true;
                vm.basicInfo.source == "People" ? vm.headerTitle = utils.translate('ASSETSMODULE.SHIFT_HEADER_UPDATE') : vm.headerTitle = utils.translate('ASSETSMODULE.ITEM_HEADER_UPDATE');
                itemManagerService.load($stateParams.id).then(function() {
                    $scope.itemForm.$setPristine();
                });
            } else {
                vm.buttonSaveCaption = 'ASSETSMODULE.MANAGE_ASSET_SAVE';
                vm.editMode = false;
                vm.basicInfo.source == "People" ? vm.headerTitle = utils.translate('ASSETSMODULE.SHIFT_HEADER_ADD') : vm.headerTitle = utils.translate('ASSETSMODULE.ITEM_HEADER_ADD');
                $scope.itemForm.$setPristine();
            }

            vm.onFormsChange = function (data) {
                itemManagerService.isDirty = true;
            }
        }

        function onSave() {
            vm.model.isSaving = true;
            if ($scope.itemForm.$invalid) {
                $scope.itemForm.$submitted = true;
                $rootScope.$broadcast('asset:performValidation');
                return;
            }
            $scope.itemForm.$setPristine();
            if (!itemManagerService.isEditMode) {
                itemManagerService.save(false);
            } else {
                itemManagerService.update(false);
            }
        }

        function onSaveAndClose() {
            vm.model.isSaving = true;
            if ($scope.itemForm.$invalid) {
                $scope.itemForm.$submitted = true;
                return;
            }

            if (!itemManagerService.isEditMode) {
                $scope.itemForm.$setPristine();
                itemManagerService.save(true);
            } else {
                $scope.itemForm.$setPristine();
                itemManagerService.update(true);
            }
        }

        function onViewItems() {
            itemManagerService.viewItems('item');
        }

        function onViewShifts() {
            itemManagerService.viewItems('people');
        }
    }

})();
/**
 * Create Cost Codes Controller
 * Created date: 6.22.2016
 */
(function () {
  'use strict';

  angular
    .module('app.assets.manage.costcodes')
    .controller('CostCodesCreateController', CostCodesCreateController);

  /** @ngInject */
  function CostCodesCreateController($q,
                                     blockUI,
                                     searchDelay,
                                     costCodeService,
                                     gridCostCodeData) {
    var costCodesVm = this;

    costCodesVm.dtInstance = {};
    costCodesVm.searchQuery = null;
    costCodesVm.searchTable = searchTable;
    costCodesVm.model = costCodeService;
    costCodesVm.categories = [];
    costCodesVm.gridModel = gridCostCodeData;
    costCodesVm.dtOptions = {
      dom: 'rt<"bottom"lip><"clear">',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      sort: false,
      initComplete : function(){
        searchTable();
      }
    };

    costCodesVm.onEdit = onEdit;
    costCodesVm.onRemove = onRemove;

    activate();

    function searchTable() {
      if(!_.isNil(costCodesVm.model.query)){
        setTimeout(function () {
          costCodesVm.dtInstance.DataTable.search(costCodesVm.model.query);
          costCodesVm.dtInstance.DataTable.search(costCodesVm.model.query).draw();
        }, searchDelay);
      }
    }

    function activate() {
      blockUI.start({message: 'Loading Manage Cost Code...'});
      var qAll = $q.all([costCodeService.loadLookups()]); // costCodeGridService.loadGridData()
      qAll.then(function (resp) {
        blockUI.stop();
      }).catch(function (ex) {
        blockUI.stop();
      });
    }

    function onEdit(id) {
      costCodeService.edit(id);
    }

    function onRemove(id) {
      costCodeService.remove(id);
    }
  }

})();

/**
 * Cost Codes Entry Controller
 * Created date: 6.23.2016
 */
(function() {
  'use strict';

  angular
    .module('app.assets.manage.costcodes')
    .controller('CostCodeEntryController', CostCodeEntryController);

  /** @ngInject */
  function CostCodeEntryController(costCodeService, blockUI, locals) {
    var vm = this;

    // Data
    vm.model = costCodeService;
    // Methods
    vm.onCancel = onCancel;
    vm.onSubmit = onSubmit;

    activate();

    ///////

    function activate() {
      if (locals && locals.id) {
        blockUI.start({message: 'Loading Cost Code Item...'});
        costCodeService.load(locals.id)
          .then(function(resp) {
            blockUI.stop();
          }).catch(function(ex) {
          blockUI.stop();
        });
      }
    }

    function onCancel() {
      costCodeService.hideEntryForm();
    }

    function onSubmit() {
      if (costCodeService.isEditMode)
        blockUI.start({message: 'Updating Cost Code...'});
      else
        blockUI.start({message: 'Saving Cost Code...'});

      costCodeService.save()
        .then(function(resp) {
          blockUI.stop();
        }).catch(function(ex) {
        blockUI.stop();
      });
    }
  }
})();

/**
 * Asset Category Module
 * Created date: 8.03.2016
 */
(function () {
    'use strict';

    angular
        .module('app.assets.manage.category', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.manage_categories', {
            url: '/assets/manage/category',
            views: {
                'content@app': {
                    templateUrl: 'app/main/assets/manage/category/asset-category.default.html',
                    controller: 'AssetCategoryController as manageCategoryVm'
                }
            },
            title: 'Manage Asset Category',
            titleBar: 'Alloc8 - Asset Category',
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManageItemCategoriesMenu;
                }] 
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/assets');
    };

})();

/**
 * Asset Category Controller
 * Created date: 8.03.2016
 */
(function () {
    'use strict';

    angular
        .module('app.assets.manage.category')
        .controller('AssetCategoryController', AssetCategoryController);

    /** @ngInject */
    function AssetCategoryController($log, $q, $mdDialog, blockUI, assetCategoryService, exceptionService) {
        var vm = this;
        vm.model = assetCategoryService;
        vm.onSave = onSave;
        vm.removeItem = removeItem;


        activate();

        //////////
        function activate() {
            
            assetCategoryService.resetData();
            blockUI.start({ message: 'Loading Category Items...' });
            assetCategoryService.loadLookups()
                .then(function (resp) {
                    blockUI.stop();
                }).catch(function (ex) {
                    exceptionService.resolve(ex);
                    blockUI.stop();
                });
        }

        function onSave() {
            blockUI.start({ message: 'Saving Category Items...' });

            var promise = assetCategoryService.save();
            if (!promise) 
                blockUI.stop();
            
            promise.then(function (resp) {
                blockUI.stop();

                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title('Category Items')
                    .content('Category items successfully saved.')
                    .ariaLabel('Category items successfully saved.')
                    .ok('Ok')

                $mdDialog.show(notif);

            }).catch(function (ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }

        function removeItem(node) {
            assetCategoryService.addRemovedItem(node);
        }

    }
})();

/**
 * Basic
 * Created date: 6.27.2016
 */
(function () {
    'use strict';

    angular.module('app.assets.manage.category')
        .directive('assetCategoryComponent', assetCategoryComponent);

    /** @ngInject */
    function assetCategoryComponent($mdDialog, utils) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/manage/category/asset-category-tree.html',
            controller: assetCategoryComponentController,
            controllerAs: 'vm',
            scope: {
                source: '=',
                removeItem: '&',
                hasChanges: '&'
            },
            bindToController: true
        };

        return directive;

        //////
        function assetCategoryComponentController() {
            var vm = this;

            vm.remove = remove;
            vm.toggle = toggle;
            vm.moveLastToTheBeginning = moveLastToTheBeginning;
            vm.newSubItem = newSubItem;
            vm.onAddRootCategory = onAddRootCategory;
            vm.editItem = editItem;
            vm.treeOptions;
            //vm.collapseAll = collapseAll;
            //vm.expandAll = expandAll;

            activate();

            function activate() {
                vm.treeOptions = {
                    beforeDrop: function(e) {
                        (vm.hasChanges || angular.noop)();
                        return true;
                    }
                };
            }

            function remove(scope) {
                var confirm = $mdDialog.confirm()
                    .title('Delete category')
                    .textContent('Do you really want to delete this category?')
                    .ariaLabel('Delete Category')
                    .ok('Delete')
                    .cancel('Cancel');

                $mdDialog.show(confirm).then(function () {
                    scope.remove();

                    (vm.removeItem || angular.noop)({ node: scope.$modelValue });
                    (vm.hasChanges || angular.noop)();
                }, function () {
                    // cancel
                });
            }

            function toggle(scope) {
                scope.toggle();
            }

            function moveLastToTheBeginning() {
                var a = vm.source.pop();
                vm.source.splice(0, 0, a);
            }

            function newSubItem(scope) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/main/assets/manage/category/asset-category-dialog.html',
                    controller: 'AssetCategoryDialogController as vm',
                    locals: {}
                }).then(function (result) {
                    if (result) {
                        var nodeData = scope.$modelValue;
                        nodeData.nodes.push({
                            id: utils.newGuid(),
                            title: result,
                            nodes: []
                        });

                        (vm.hasChanges || angular.noop)();
                    }

                }, function () {
                    // cancel
                });
            }

            function editItem(scope) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/main/assets/manage/category/asset-category-dialog.html',
                    controller: 'AssetCategoryDialogController as vm',
                    locals: { editedItem: scope.$modelValue.title }
                }).then(function (result) {
                    if (result) {
                        var nodeData = scope.$modelValue;
                        nodeData.title = result;
                        (vm.hasChanges || angular.noop)();
                    }

                }, function () {
                    // cancel
                });
            }

            function onAddRootCategory() {
                 $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/main/assets/manage/category/asset-category-dialog.html',
                    controller: 'AssetCategoryDialogController as vm',
                    locals: {}
                }).then(function (result) {
                    if (result) {
                        vm.source.push({
                            id: utils.newGuid(),
                            title: result,
                            nodes: []
                        });

                        (vm.hasChanges || angular.noop)();
                    }

                }, function () {
                    // cancel
                });
            }

            // function collapseAll() {
            //     vm.$broadcast('angular-ui-tree:collapse-all');
            // }

            // function expandAll() {
            //     vm.$broadcast('angular-ui-tree:expand-all');
            // }
        }

    }
})();
/**
 * Asset Category Controller
 * Created date: 8.03.2016
 */
(function () {
    'use strict';

    angular
        .module('app.assets.manage.category')
        .controller('AssetCategoryDialogController', AssetCategoryDialogController);

    /** @ngInject */
    function AssetCategoryDialogController($log, $q, $mdDialog, locals) {
        var vm = this;

        vm.categoryName;
        vm.onAdd = onAdd;
        vm.onCancel = onCancel;

        activate();

        //////////

        function activate() {
            if (locals.editedItem) {
                vm.categoryName = locals.editedItem;
            }
        }

        function onAdd() {
            $mdDialog.hide(vm.categoryName);
        }

        function onCancel() {
            $mdDialog.hide();
        }
        
    }
})();

(function(){
  'use strict';

  angular.module('app.assets')
    .factory('customizedFieldService', customizedFieldService);

  /** @ngInject */
  function customizedFieldService() {

    var service = {
      manageCustomizedFields : false,
      values : null,
      itemTypeChange : false
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular.module('app.assets')
    .directive('customizedField', customizedField);

  /** @ngInject */
  function customizedField() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/assets/directives/CustomizedFields/customized-fields.html',
      controller: customFieldsController,
      controllerAs: 'vm'
    };

    return directive;

    function customFieldsController(customizedFieldService,
                                    customFieldsService,
                                    customisedFieldsFactory,
                                    $mdDialog,
                                    basicInfoService,
                                    a8TreeMdBoxService,
                                    stockCategoryConverterService,
                                    assetsLookupService,
                                    blockUI,
                                    $document,
                                    $scope,
                                    $compile){

      //Data
      var vm = this;
      vm.CustomisedFieldsBackUp = [];
      vm.customizedFieldService = customizedFieldService;
      vm.showFields = true;
      vm.customizedFieldService.values = vm;
      vm.basicInfoService = basicInfoService;
      vm.a8TreeMdBoxService = a8TreeMdBoxService;
      vm.doneMarker = 0;
      vm.stockCategoryConverterService = stockCategoryConverterService;

      //Methods
      vm.onDone = onDone;
      vm.showCustomizedFieldsDialog = showCustomizedFieldsDialog;
      vm.getCustomFields = getCustomFields;
      vm.editField = editField;
      vm.deleteField = deleteField;
      vm.activate = activate;

      vm.activate();

      //Implementations
      function onDone(){
        vm.customizedFieldService.manageCustomizedFields = !vm.customizedFieldService.manageCustomizedFields;
        if(vm.customizedFieldService.manageCustomizedFields){
          changeFields(true);
        }
        else{
          changeFields();
        }
      }

      //get that Parent ID/Key of the selected nodes
      function getCategoryInt(strParam){
        var periodFirstOccurrence = strParam.indexOf(".");
        var rawString = strParam.substring(0, periodFirstOccurrence);
        return rawString;
      }

      //get the actual (int) parent ID
      function getLabel(str){
        str = str.slice(0, - 1);
        str = str.slice(1);
        return parseInt(str);
      }

      //get the distinct values in array
      function getDistinctValues(value, index, self) {
        return self.indexOf(value) === index;
      }

      //If item or category type have changed
      function changeFields(all){
        var savedFields = [];

        if(!all){
          vm.showFields = true;
          var items = [];
          angular.forEach(vm.basicInfoService.data.ItemTypes, function(itm){
            var i = {};
            i['id'] = itm.Id;
            i['TypeName'] = itm.Name;
            items.push(i);
          });
          var categories = [];
          var flattenCategories = JSON.flatten(a8TreeMdBoxService.source);

          //get that Parent ID/Key of the selected nodes
          angular.forEach(flattenCategories, function(value, key){
            if(value == true){
              if(key.indexOf("__ivhTreeviewExpanded") < 0)
              {
                var categoryInt = getCategoryInt(key);
                var labelInt = getLabel(categoryInt);
                categories.push(labelInt);
              }
            }
          });

          //Filter fields based on chosen Item and Category Types
          angular.forEach(basicInfoService.customisedFields, function(value){
            angular.forEach(value.LookupTypes, function(lookup){
              var result = alasql('select * from ? where TypeName = ?', [items, lookup.TypeName]);
              if(result.length > 0){
                if(value.CategoryTypes.length == 0){
                  var field = alasql('select * from ? where id = ?',[savedFields ,value.id]);
                  if(field.length == 0){
                    savedFields.push(value);
                  }
                }
                else{
                  var parentCategories = [];
                  angular.forEach(assetsLookupService.categoriesLookup.data, function(cat){
                    if(cat.ParentId === null){
                      parentCategories.push(cat);
                    }
                  });
                  categories = categories.filter(getDistinctValues);
                  angular.forEach(parentCategories, function(pCategory, pKey){
                    angular.forEach(categories, function(category){
                        if(category == pKey){
                            angular.forEach(value.CategoryTypes, function(val){
                              if(val.Name == pCategory.Name){
                                var field = alasql('select * from ? where id = ?',[savedFields ,value.id]);
                                if(field.length == 0){
                                  savedFields.push(value);
                                }
                              }
                            });
                        }
                    });
                  });
                }
              }
            });
          });
        }
        else{
          if(vm.customizedFieldService.manageCustomizedFields){
            vm.showFields = false;
            savedFields = basicInfoService.customisedFields;
          }
          else{
            vm.showFields = true;
          }
        }

        var elements = customisedFieldsFactory.constructUIForm(savedFields, 'vm');
        $document.find('#customisedFields').empty();
        $document.find('#customisedFields').append($compile(elements)($scope));
      }

      function activate(){
        vm.getCustomFields('vm', false, false);
      }

      //Shows Customized Fields Dialog
      function showCustomizedFieldsDialog(){
        $mdDialog.show({
          parent: angular.element(document.body),
          templateUrl: 'app/main/customisedFields/templates/dialog.html',
          controller: 'CustomisedFieldsController as vm',
          locals:{
            EditMode : false,
            Id : null,
            Module : 4
          }
        }).then(function(resp){
          vm.getCustomFields('vm', true, true);
        });
      }

      //Get all custom fields
      function getCustomFields(model, visible , allFields){
        blockUI.start('Fetching Fields...');
        customFieldsService.getCustomFields().then(function(resp){
          basicInfoService.customisedFields = [];
          angular.forEach(resp.data, function(element){
            if(element.ModulePages[0] == 4){
              basicInfoService.customisedFields.push(element);
            }
          });

          vm.CustomisedFieldsBackUp = basicInfoService.customisedFields;
          var elements = customisedFieldsFactory.constructUIForm(basicInfoService.customisedFields, model, visible);
          $document.find('#customisedFields').empty();
          $document.find('#customisedFields').append($compile(elements)($scope));
          changeFields(allFields);
          blockUI.stop();
        });
      }

      //Edit Field
      function editField(id){
        $mdDialog.show({
          parent: angular.element(document.body),
          templateUrl: 'app/main/customisedFields/templates/dialog.html',
          controller: 'CustomisedFieldsController as vm',
          locals: {
            EditMode : true,
            Id : id,
            Module : 4
          }
        }).then(function(resp){
          vm.getCustomFields('vm', true, true);
        })
      }

      //Delete Field
      function deleteField(id){
        blockUI.start('Deleting Field...');
        customFieldsService.deleteField(id).then(function(resp){
          vm.getCustomFields('vm', true, true);
          blockUI.stop();
        });
      }

      $scope.$watch('vm.customizedFieldService.manageCustomizedFields', function() {
        if(vm.customizedFieldService.manageCustomizedFields){
          changeFields(true);
        }
        else{
          changeFields();
        }
      });

      $scope.$watch('vm.basicInfoService.data.ItemTypes', function() {
        changeFields();
      });

      $scope.$watch('vm.customizedFieldService.itemTypeChange', function() {
        changeFields();
      });

      $scope.$watch('vm.basicInfoService.data.CustomFields', function() {
        angular.forEach(basicInfoService.data.CustomFields, function(value){
          vm[value.Id] = value.FieldValue;
          if(value.Type == null){
            vm['Other' + value.Id] = value.FieldValue;
            let doubleSlashExist = (angular.isUndefined(value.FieldValue) || _.isBoolean(value.FieldValue) || _.isNull(value.FieldValue)) ? false : value.FieldValue.includes('||');
              if(doubleSlashExist){
                vm[value.Id] = value.FieldValue.substring(0, value.FieldValue.indexOf("|")) === "true" ? true : false;
                vm[value.Id + "Specify"] = value.FieldValue.substring(value.FieldValue.lastIndexOf("|") + 1)
              }
          }
        });
        changeFields();
      });

      //Flattens the category source
      JSON.flatten = function (data) {
        var result = {};

        function recurse(cur, prop) {
          if (Object(cur) !== cur) {
            result[prop] = cur;
          } else if (Array.isArray(cur)) {
            for (var i = 0, l = cur.length; i < l; i++)
              recurse(cur[i], prop + "[" + i + "]");
            if (l == 0) result[prop] = [];
          } else {
            var isEmpty = true;
            for (var p in cur) {
              isEmpty = false;
              recurse(cur[p], prop ? prop + "." + p : p);
            }
            if (isEmpty && prop) result[prop] = {};
          }
        }
        recurse(data, "");
        return result;
      };

    }
  }
})();

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('toolbarLoader', toolbarLoader);

  function toolbarLoader() {
    var directive = {
      restrict : 'E',
      templateUrl : 'app/shared/widgets/toolbarLoader/toolbar-loader.html',
      scope : {
        show : '=',
        message : '=',
      },
      controller : toolbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function toolbarController(){

    }
  }
})();

(function () {
  'use strict';

  angular.module('app.corelib')
    .directive('tableSearch', tableSearch);

  /** @ngInject */
  function tableSearch(searchDelay) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/shared/widgets/tableSearchDirective/table-search.html',
      scope : {
        selector: '@',
        query : '=',
        data : '='
      },
      controller : controller,
      controllerAs: 'vm',
      bindToController: true
    };

    function controller(){
      var vm = this
      vm.options = {
        debounce: {
          'default': searchDelay
        }
      }

      vm.search = search;

      function search(){
        $(vm.selector)
          .DataTable()
          .search(vm.query)
          .draw();
      }
    }

    return directive;
  }

})();


/**
* startFrom filter for ngRepeat
* jbpbelen - 05/23/2018
*
* Used for paging ngRepeat.
*
* Usage:
* Markup:
*  <md-list-item ng-repeat="msg in vm.filtered| startFrom: (vm.currentPage - 1) * vm.pageSize| limitTo: vm.pageSize| filter: vm.search"></md-list-item>
*
*/
(function () {
    'use strict';

    angular.module('app.widgets')
        .filter('startFrom', startFrom);

    function startFrom () {
        return function (input, start) {
            if (input) {
                start = +start;
                return input.slice(start);
            }
            return [];
        };
    }

})();
(function () {
    'use strict';
    angular.module('app.widgets')
        .directive('singleAddress', singleAddressDirective);

    function singleAddressDirective(claimsUtilService) {

        var directive = {
            restrict: 'E',
            scope: {
                ngModel: '=',
                placeholder: '@',
                country: '@',
                isEdit: '=',
                usedBy: '@',
                isLocked: '=',
                isLockedByPreSchedule: '=',
                lastJobLocation: '='
            },
            templateUrl: 'app/shared/widgets/singleAddress/single-address.html',
            bindToController: true,
            controller: singleAddressController,
            controllerAs: 'singleAddressvm'
        };

        return directive;

        function singleAddressController(addressUtils) {
            var vm = this;
            vm.showDialog = showDialog;
            vm.isSmartSchedulingEnabled = claimsUtilService.isSmartSchedulingEnabled();
            vm.isTicketLockedByPreSchedule = vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled;

            function showDialog() {
                if (vm.usedBy === 'JobBooking') {
                    if (!vm.isLocked && !(vm.isTicketLockedByPreSchedule)) {
                        addressUtils.addressDialog(vm.usedBy, vm.lastJobLocation, vm.isEdit).then(function (resp) {
                            if (resp) {
                                resp.FullAddress = addressUtils.buildAddress(resp);
                                vm.ngModel = resp;
                            }
                        })
                    }
                }
                else if (vm.usedBy === 'Business') {
                    if (!vm.isLocked && !(vm.isTicketLockedByPreSchedule)) {
                        addressUtils.editAddressDialog(vm.ngModel, vm.usedBy).then(function (resp) {
                            if (resp) {
                                resp.FullAddress = addressUtils.buildAddress(resp);
                                vm.ngModel = resp;
                            }
                        })
                    }
                }
                else {
                    addressUtils.addressDialog().then(function (resp) {
                        if (resp) {
                            //resp.FullAddress = addressUtils.buildAddress(resp);
                            vm.ngModel = resp;
                        }
                    })
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.corelib')
        .controller('jobLatitudeLongitudeDialogController', jobLatitudeLongitudeDialogController);

    function jobLatitudeLongitudeDialogController($mdDialog,
        jobCoordinates,
        $http,
        $q,
        localisationService) {

        var vm = this;
        vm.showMap = false;
        vm.initAddress = null;

        vm.localSettings = [];

        //Methods
        vm.onCancel = onCancel;
        vm.activate = activate;

        function activate() {
            vm.localSettings = localisationService.getLocaleFormatSettings();

            vm.initAddress = {
                geometry: {
                    location: {
                        A: jobCoordinates.Latitude,
                        F: jobCoordinates.Longitude
                    }
                },
                zoom: 15
            };

            var urls = [
                $http.get('app/shared/widgets/singleAddress/countries.json'),
                $http.get('app/shared/widgets/singleAddress/address-types.json')
            ];
            $q.all(urls).then(function(resp) {
                vm.showMap = true;
            });
        }

        function onCancel() {
            $mdDialog.hide();
        }

        activate();
    }
})();

(function() {
    'use strict';

    angular.module('app.corelib')
        .controller('inputAddressDialogController', inputAddressDialogController);

    function inputAddressDialogController($mdDialog,
        addressUtils,
        $scope,
        jobService,
        currentAddress,
        editMode,
        $http,
        $q,
        localisationService) {

        var vm = this;
        var geocoder = new google.maps.Geocoder;
        vm.usedBy = addressUtils.usedBy;
        vm.last10Addresses = addressUtils.last10Addresses;
        vm.address = {};
        vm.addressDetailsSection = false;
        vm.customAddress = true;
        vm.showText = true;
        vm.showMap = false;
        vm.initAddress = null;
        vm.showPinButton = true;
        vm.pinAddress = null;
        vm.addressChaged = false;
        vm.localSettings = [];

        //Methods
        vm.onCancel = onCancel;
        vm.onDone = onDone;
        vm.callBack = callBack;
        vm.showCustomAddress = showCustomAddress;
        vm.activate = activate;
        vm.dropPin = dropPin;
        vm.customCallbackFunction = customCallbackFunction;
        vm.applyPinAddress = applyPinAddress;
        vm.onChange = onChange;

        function activate() {
            vm.localSettings = localisationService.getLocaleFormatSettings();

            if (jobService.jobModel.JobLocation) {
                vm.location = jobService.jobModel.JobLocation.FullAddress;
                if (vm.usedBy == "JobBooking") {
                    if (jobService.jobModel.JobLocation.Location != null) {
                        vm.pinAddress = jobService.jobModel.JobLocation;
                        vm.initAddress = {
                            geometry: {
                                location: {
                                    A: vm.pinAddress.Location['Latitude'] || null,
                                    F: vm.pinAddress.Location['Longitude'] || null
                                }
                            },
                            zoom: 15
                        };
                    }
                }
            } else {
                navigator.geolocation.getCurrentPosition(function(result) {
                    vm.initAddress = {
                        geometry: {
                            location: {
                                A: result.coords.latitude,
                                F: result.coords.longitude
                            }
                        },
                        zoom: 15
                    };
                });
            }

            var urls = [
                $http.get('app/shared/widgets/singleAddress/countries.json'),
                $http.get('app/shared/widgets/singleAddress/address-types.json')
            ];
            $q.all(urls).then(function(resp) {
                vm.countries = resp[0].data;
                vm.addressTypes = resp[1].data;

                if (!editMode) {
                    if (vm.usedBy != "JobBooking") {
                        vm.location = null;
                    }
                    return;
                }

                if (vm.usedBy == "Business" && !currentAddress.State) {
                    return;
                }

                vm.showCustomAddress();
                vm.address.addressType = currentAddress.addressType || currentAddress.AddressType;
                vm.address.State = currentAddress.State;
                vm.address.PostCode = currentAddress.PostCode;
                vm.address.Suburb = currentAddress.Suburb;
                vm.address.StreetNumber = currentAddress.StreetNumber;
                vm.address.StreetName = currentAddress.StreetName;
                vm.address.UnitNumber = currentAddress.UnitNumber;
                vm.address.BldgName = currentAddress.BldgName;
                vm.address.Country = currentAddress.Country;
                vm.address.AddressPrefix = currentAddress.AddressPrefix;
                vm.address.Location = {};
                vm.address.Location['Type'] = "point";
                vm.address.Location['Longitude'] = currentAddress.Location.Longitude;
                vm.address.Location['Latitude'] = currentAddress.Location.Latitude;

                vm.pinAddress = vm.address;
                vm.initAddress = {
                    geometry: {
                        location: {
                            A: vm.address.Location['Latitude'],
                            F: vm.address.Location['Longitude']
                        }
                    },
                    zoom: 15
                };
            });
        }

        function onChange() {
            if (vm.jobLocation) {
                if (vm.jobLocation.FullAddress) {
                    vm.location = vm.jobLocation.FullAddress;
                }
            }
            showCustomAddress();
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function showLocation() {
            vm.showMap = true;
            vm.customAddress = true;
            vm.addressDetailsSection = false;
            vm.showText = false;
            vm.showPinButton = false;
        }

        function dropPin() {
            showLocation();
        }

        function customCallbackFunction(place) {
            vm.pinAddress = place;
            vm.addressChaged = true;
            $scope.$apply();
        }

        function applyPinAddress() {
            vm.locationBackUp = vm.pinAddress;
            callBack(vm.pinAddress, true);
            vm.showMap = false;
            vm.pinAddress = null;
            vm.customAddress = false;
            vm.addressDetailsSection = true;
            vm.showText = false;
            vm.showPinButton = true;
            vm.addressChaged = false;
        }

        function showCustomAddress() {
            vm.customAddress = false;
            vm.addressDetailsSection = true;
            vm.showText = false;
            vm.showMap = false;
            vm.showPinButton = true;
            vm.address.Location = {};
            vm.address.Location['Type'] = "point";
            vm.address.Location['Latitude'] = vm.pinAddress ? vm.pinAddress.Lat : null;
            vm.address.Location['Longitude'] = vm.pinAddress ? vm.pinAddress.Lng : null;

            if (vm.usedBy != "JobBooking") {
                return;
            }

            if(vm.jobLocation || jobService.jobModel.JobLocation) {
                vm.address.State = vm.jobLocation == null ? jobService.jobModel.JobLocation.State : vm.jobLocation.State;
                vm.address.PostCode = vm.jobLocation == null ? jobService.jobModel.JobLocation.PostCode : vm.jobLocation.PostCode;
                vm.address.Suburb = vm.jobLocation == null ? jobService.jobModel.JobLocation.Suburb : vm.jobLocation.Suburb;
                vm.address.StreetNumber = vm.jobLocation == null ? jobService.jobModel.JobLocation.StreetNumber : vm.jobLocation.StreetNumber;
                vm.address.StreetName = vm.jobLocation == null ? jobService.jobModel.JobLocation.StreetName : vm.jobLocation.StreetName;
                vm.address.UnitNumber = vm.jobLocation == null ? jobService.jobModel.JobLocation.UnitNumber : vm.jobLocation.UnitNumber;
                vm.address.BldgName = vm.jobLocation == null ? jobService.jobModel.JobLocation.BldgName : vm.jobLocation.BldgName;
                vm.address.Country = vm.jobLocation == null ? jobService.jobModel.JobLocation.Country : vm.jobLocation.Country;
                vm.address.AddressPrefix = vm.jobLocation == null ? jobService.jobModel.JobLocation.AddressPrefix : vm.jobLocation.AddressPrefix;

                vm.address.Location['Longitude'] = vm.jobLocation == null ? jobService.jobModel.JobLocation.Location.Longitude : vm.jobLocation.Location.Longitude;
                vm.address.Location['Latitude'] = vm.jobLocation == null ? jobService.jobModel.JobLocation.Location.Latitude : vm.jobLocation.Location.Latitude;
            }

            vm.pinAddress = vm.address;
            vm.initAddress = {
                geometry: {
                    location: {
                        A: vm.address.Location['Latitude'],
                        F: vm.address.Location['Longitude']
                    }
                },
                zoom: 15
            };
        }

        function callBack(result, isFromMap) {
            vm.addressDetailsSection = true;
            vm.customAddress = false;
            vm.showText = false;
            if (result.address_components) {
                vm.address.Country = addressUtils.getAddressComponent(result.address_components, 'country') === null ? null : addressUtils.getAddressComponent(result.address_components, 'country').long_name;
                vm.address.addressType = null;
                vm.address.State = addressUtils.getAddressComponent(result.address_components, 'administrative_area_level_1') === null ? null : addressUtils.getAddressComponent(result.address_components, 'administrative_area_level_1').short_name;
                vm.address.PostCode = addressUtils.getAddressComponent(result.address_components, 'postal_code') === null ? null : addressUtils.getAddressComponent(result.address_components, 'postal_code').short_name;
                
                var sublocality = addressUtils.getAddressComponent(result.address_components, 'sublocality_level_1');
                var locality = addressUtils.getAddressComponent(result.address_components, 'locality');
                var finalLocality =  sublocality || locality;

                vm.address.Suburb =finalLocality ?  finalLocality.long_name || finalLocality.short_name : "";

                vm.address.StreetNumber = addressUtils.getAddressComponent(result.address_components, 'street_number') === null ? null : addressUtils.getAddressComponent(result.address_components, 'street_number').long_name || addressUtils.getAddressComponent(result.address_components, 'street_number').short_name;
                vm.address.StreetName = addressUtils.getAddressComponent(result.address_components, 'route') === null ? null : addressUtils.getAddressComponent(result.address_components, 'route').long_name || addressUtils.getAddressComponent(result.address_components, 'route').short_name;
                vm.address.UnitNumber = null;
                vm.address.BldgName = null;
                vm.address.AddressPrefix = null;
                vm.address.Location = {};

                if (isFromMap) {
                    vm.address.Location['Type'] = "point";
                    vm.address.Location['Longitude'] = result.Lng || vm.locationBackUp.Location.Longitude || result.geometry.location.lng();
                    vm.address.Location['Latitude'] = result.Lat || vm.locationBackUp.Location.Latitude || result.geometry.location.lat();
                } else {
                    vm.address.Location['Type'] = "point";
                    vm.address.Location['Longitude'] = result.geometry.location.lng();
                    vm.address.Location['Latitude'] = result.geometry.location.lat();
                }
            }

            var latlng = new google.maps.LatLng(vm.address.Location['Latitude'], vm.address.Location['Longitude']);
            geocoder.geocode({
                'location': latlng
            }, function(result, status) {
                vm.pinAddress = result[0];
                vm.initAddress = {
                    geometry: {
                        location: {
                            A: vm.address.Location['Latitude'],
                            F: vm.address.Location['Longitude']
                        }
                    },
                    zoom: 15
                };
            });
        }

        function onDone() {
            $mdDialog.hide(vm.address);
        }

        activate();
    }
})();

(function () {
  'use strict';

  angular.module('app.corelib')
    .service('addressUtils', addressUtils);

  function addressUtils($mdDialog) {

    this.addressDialog = addressDialog;
    this.editAddressDialog = editAddressDialog;
    this.getAddressComponent = getAddressComponent;
    this.buildAddress = buildAddress;
    this.usedBy = usedBy;
    this.last10Addresses = last10Addresses;

    function getAddressComponent(addressComponents, component){
      var comp = _.find(addressComponents, function(a) { 
        return a.types.find(x => x == component); 
      });
      var result = comp === undefined ? null : comp;
      return result;
    }

    function addressDialog(usedBy,last10Addresses, isEdit){
      this.usedBy = usedBy;
      this.last10Addresses = last10Addresses;
      var dialog = {
        templateUrl: 'app/shared/widgets/singleAddress/input-address-dialog.html',
        controller: 'inputAddressDialogController as vm',
        currentAddress: null,
        locals: {
            edit: isEdit
        },
        editMode: false
      }
      return $mdDialog.show(dialog);
    }

    function editAddressDialog(address, usedBy){
      this.usedBy = usedBy;
      var dialog = {
        templateUrl: 'app/shared/widgets/singleAddress/input-address-dialog.html',
        controller: 'inputAddressDialogController as vm',
        currentAddress: address,
        editMode: true
      }
      return $mdDialog.show(dialog);
    }

    function buildAddress(addressComponents){
      var addressArray = "";
      var unitNumberPresent = false;

      if(addressComponents.AddressPrefix != null || addressComponents.AddressPrefix != undefined){
        if(addressComponents.AddressPrefix.length > 0)
          addressArray = addressArray + addressComponents.AddressPrefix + " ";
      }

      if(addressComponents.BldgName != null || addressComponents.BldgName != undefined){
        if(addressComponents.BldgName.length > 0)
        addressArray = addressArray + addressComponents.BldgName + " ";
      }

      if(addressComponents.UnitNumber != null || addressComponents.UnitNumber != undefined){
        if(addressComponents.UnitNumber.length > 0){
          addressArray = addressArray + addressComponents.UnitNumber;
          unitNumberPresent = true;
        }else{
          unitNumberPresent = false;
        }
      }else{
        unitNumberPresent = false;
      }

      if(addressComponents.StreetNumber != null || addressComponents.StreetNumber != undefined){
        if(addressComponents.StreetNumber.length > 0)
          if(unitNumberPresent){
            addressArray =  addressArray + "/" + addressComponents.StreetNumber + " ";
          }
          else{
            addressArray =  addressArray + " " + addressComponents.StreetNumber + " ";
          }

      }
      if(addressComponents.StreetName != null || addressComponents.StreetName != undefined){
        if(addressComponents.StreetName.length > 0)
          addressArray = addressArray + addressComponents.StreetName + ", ";
      }

      if(addressComponents.Suburb != null || addressComponents.Suburb != undefined){
        if(addressComponents.Suburb.length > 0)
          addressArray = addressArray + addressComponents.Suburb + " ";
      }

      if(addressComponents.State != null || addressComponents.State != undefined){
        if(addressComponents.State.length > 0)
          addressArray = addressArray + addressComponents.State + " ";
      }

      if(addressComponents.PostCode != null || addressComponents.PostCode != undefined){
        if(addressComponents.PostCode.length > 0)
          addressArray = addressArray + addressComponents.PostCode + " ";
      }

      if(addressComponents.Country != null || addressComponents.Country != undefined){
        if(addressComponents.Country.length > 0)
          addressArray = addressArray + addressComponents.Country;
      }

      return addressArray;
    }

    function usedBy(usedBy){
      return usedBy;
    }

    function last10Addresses(last10Addresses){
      return last10Addresses;
    }
  }
})();

(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('sidenavFilterSmallScreen', sidenavFilterSmallScreen)

    function sidenavFilterSmallScreen() {
        var directive = {
            restrict: 'E',
            scope: {
                toggleSidenav: '&',
                name: '@',
                additionalClass: '@'
            },

            templateUrl: 'app/shared/widgets/sidenavFilterSmallScreenTemplate/sidenav-filter-small-screen.html',
            bindToController: true,
            controller: sidenavFilterSmallScreenTemplateController,
            controllerAs: 'sidenavFilterSmallScreenevm'
        };

        return directive;

        function sidenavFilterSmallScreenTemplateController() {}
    }

})();

(function() {
    'use strict';

    angular
        .module('app.widgets')
        .directive('requiredAttachmentTypes', requiredAttachmentTypes);

    function requiredAttachmentTypes() {
        return {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/requiredAttachmentTypes/required-attachment-types.html',
            scope: {
                attachmentTypes: '=',
                removeCallback: '&',
                entityName: '@'
            },
            controller: requiredAttachmentTypesController,
            bindToController: true,
            controllerAs: 'vm'
        };

        function requiredAttachmentTypesController($mdDialog, attachmentTypesApi) {
            var vm = this;

            vm.allAttachmentTypes = [];

            vm.dtOptions = {
                order: [],
                paging: true,
                searching: false,
                lengthChange: false,
                fixedColumns: true
            };

            vm.spawnDialog = spawnDialog;
            vm.remove = remove;
            vm.getTypeName = getTypeName;
            vm.getTypeDescription = getTypeDescription;

            init();

            function init() {
                attachmentTypesApi.getAttachmentTypes().then(function(resp) {
                    vm.allAttachmentTypes = resp.data || [];
                }).catch(function() {
                    vm.allAttachmentTypes = [];
                });
            }

            function findType(attachmentTypeId) {
                for (var i = 0; i < vm.allAttachmentTypes.length; i++) {
                    if (vm.allAttachmentTypes[i].Id === attachmentTypeId) {
                        return vm.allAttachmentTypes[i];
                    }
                }
                return null;
            }

            function getTypeName(attachmentTypeId) {
                var type = findType(attachmentTypeId);
                return type ? type.Name : '';
            }

            function getTypeDescription(attachmentTypeId) {
                var type = findType(attachmentTypeId);
                return type ? type.Description : '';
            }

            function spawnDialog() {
                $mdDialog.show({
                    templateUrl: 'app/shared/widgets/requiredAttachmentTypes/add-required-attachment-type.html',
                    controller: 'AddRequiredAttachmentTypeController as vm',
                    locals: {
                        currentAttachmentTypes: vm.attachmentTypes || []
                    }
                }).then(function(result) {
                    if (result) {
                        if (!vm.attachmentTypes) {
                            vm.attachmentTypes = [];
                        }
                        vm.attachmentTypes.push(result);
                    }
                });
            }

            function remove(index) {
                (vm.removeCallback() || angular.noop)(index);
            }
        }
    }
}());

(function() {
    'use strict';

    angular
        .module('app.widgets')
        .controller('AddRequiredAttachmentTypeController', AddRequiredAttachmentTypeController);

    function AddRequiredAttachmentTypeController(
        $mdDialog,
        attachmentTypesApi,
        currentAttachmentTypes
    ) {
        var vm = this;
        vm.availableTypes = [];
        vm.selectedType = null;
        vm.description = '';
        vm.quantity = 1;
        vm.isLoading = true;

        vm.onClose = onClose;
        vm.onAdd = onAdd;
        vm.onTypeChange = onTypeChange;

        init();

        function init() {
            attachmentTypesApi.getAttachmentTypes().then(function(resp) {
                var allTypes = resp.data || [];
                var linkedIds = (currentAttachmentTypes || []).map(function(t) {
                    return t.AttachmentTypeId;
                });

                vm.availableTypes = allTypes.filter(function(type) {
                    return type.IsActive && linkedIds.indexOf(type.Id) === -1;
                });
                vm.isLoading = false;
            }).catch(function() {
                vm.availableTypes = [];
                vm.isLoading = false;
            });
        }

        function onTypeChange() {
            vm.description = vm.selectedType ? vm.selectedType.Description : '';
        }

        function onClose() {
            $mdDialog.hide();
        }

        function onAdd() {
            if (!vm.selectedType) return;

            $mdDialog.hide({
                AttachmentTypeId: vm.selectedType.Id,
                Quantity: vm.quantity || 1
            });
        }
    }
}());

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('processorLoader', processorLoader);

  function processorLoader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/shared/widgets/processorLoader/processorLoader.html',
      scope: {
        message : '=',
        show : '=',
      },
      controller: controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function controller() {
      var vm = this;
    }
  }
})();

angular.module('app.widgets')
    .directive('numberOnly', function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, ctrl) {
                ctrl.$parsers.push(function (input) {
                    if (input == undefined) return ''
                    var inputNumber = input.toString().replace(/[^0-9]/g, '');
                    if (inputNumber != input) {
                        ctrl.$setViewValue(inputNumber);
                        ctrl.$render();
                    }
                    return inputNumber;
                });
            }
        };
    });

/**
* New Line to Break filter
* jbpbelen - 04/11/2018
*
* Transforms '/n' to '<br>'.
*
* Usage:
* Markup:
*  <p ng-bind-html="text | nl2br"></p>
*
* JS:
*  var text = $filter('nl2br')(text, true)
*
* Params: 
*  text: raw text with /n on it
*  asHTML: True: Text being passed is HTML, False: Text is just text <- Applies to JS approach only
*
*/
(function () {
    'use strict';

    angular.module('app.widgets')
        .filter('nl2br', ['$sce', nl2br]);

    function nl2br ($sce) {
        return function (text, asHTML) {
            if (asHTML)
                return text ? text.replace(/\n/g, '<br/>') : ''; // typeof = string
            return text ? $sce.trustAsHtml(text.replace(/\n/g, '<br/>')) : ''; // typeof = object
        };
    }

})();
(function(){
    'use strict';
  
    angular.module('app.widgets')
      .directive('multiAddressCompany', multiAddressCompany);
  
    function multiAddressCompany() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/shared/widgets/multiAddressCompany/multi-address-company.html',
        scope:{
          ngModel: '='
        },
        controller: multiAddressCompanyController,
        controllerAs: 'vm',
        bindToController: true
      };
  
      return directive;
  
      function multiAddressCompanyController($mdDialog, addressUtils) {
          var vm = this;
          vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            sort: false
          };
  
          vm.openDialog = openDialog;
          vm.editAddress = editAddress;
          vm.remove = remove;
  
          function remove(index){
            vm.ngModel.splice(index, 1)
          }
  
          function openDialog(){
            addressUtils.addressDialog().then(function(resp){
              if(resp){
                resp.FullAddress = addressUtils.buildAddress(resp);
                vm.ngModel.push(resp);
              }
            });
          }
  
          function editAddress(address, index){
            addressUtils.editAddressDialog(address).then(function(resp){
              if(resp){
                resp.FullAddress = addressUtils.buildAddress(resp);
                vm.ngModel[index] = resp;
              }
            });
          }
      }
    }
  })();
  
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('multiAddress2', multiAddress);

    function multiAddress() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/multiAddress2/multi-address.html',
            scope: {
                ngModel: '='
            },
            controller: multiAddressController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function multiAddressController($mdDialog, addressUtils) {
            var vm = this;
            vm.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                sort: false
            };

            vm.openDialog = openDialog;
            vm.editAddress = editAddress;
            vm.remove = remove;

            function remove(index) {
                vm.ngModel.splice(index, 1)
            }

            function openDialog() {
                addressUtils.addressDialog().then(function (resp) {
                    if (resp) {
                        resp.FullAddress = addressUtils.buildAddress(resp);
                        vm.ngModel.push(resp);
                    }
                });
            }

            function editAddress(address, index) {
                addressUtils.editAddressDialog(address).then(function (resp) {
                    if (resp) {
                        resp.FullAddress = addressUtils.buildAddress(resp);
                        vm.ngModel[index] = resp;
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('multiAddress', multiAddress);

    function multiAddress() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/multiAddress/multi-address.html',
            scope: {
                ngModel: '='
            },
            controller: multiAddressController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function multiAddressController(blockUI, addressUtils) {
            var vm = this;
            vm.dtOptions = {
                dom: '',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                sort: false,
                initComplete: function() {
                    blockUI.stop();
                }
            };

            vm.openDialog = openDialog;
            vm.editAddress = editAddress;
            vm.remove = remove;

            function remove(index) {
                vm.ngModel.splice(index, 1)
            }

            function openDialog() {
                addressUtils.addressDialog().then(function(resp) {
                    if (resp) {
                        resp.FullAddress = addressUtils.buildAddress(resp);
                        vm.ngModel.push(resp);
                    }
                });
            }

            function editAddress(address, index) {
                addressUtils.editAddressDialog(address).then(function(resp) {
                    if (resp) {
                        resp.FullAddress = addressUtils.buildAddress(resp);
                        vm.ngModel[index] = resp;
                    }
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.widgets').directive('jobFormsList', jobFormsList);

    function jobFormsList() {
        let directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/jobForms/jobForms-list.html',
            scope: {
                formsIds: '=',
                enableDelete: '='
            },
            controller: jobFormsListController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function jobFormsListController(
            _,
            $compile,
            $scope,
            $timeout,
            $mdDialog,
            DTColumnBuilder,
            DTOptionsBuilder,
            customFormsApiUrl,
            exceptionService,
            hubService,
            blockUI,
            customFormsApi,
            claimsUtilService
        ) {
            let vm = this;

            var tenantKey = claimsUtilService.getTenantKey();

            vm.dtInstance = {};
            vm.searchDataInstance = {};

            vm.deleteForm = deleteForm;
            vm.downloadForm = downloadForm;
            vm.openGoogleMaps = openGoogleMaps;

            const dtHeaders = {
                pageNumber: 1,
                resultLimit: 10,
                sortByField: 'name',
                sortByType: 'desc'
            };

            initDataTable();

            $scope.$watchGroup(['vm.formsIds'], function(newValue, oldValue) {
                // This initialises datatable with the latest values
                if (newValue !== oldValue) {
                    vm.dtInstance.DataTable.ajax.reload(null, false);
                }
            });

            function initDataTable() {
                vm.dtColumns = [
                    DTColumnBuilder.newColumn('formTemplateName').withTitle('Form Template Name').notSortable(),
                    DTColumnBuilder.newColumn('name').withTitle('Name').notSortable(),
                    DTColumnBuilder.newColumn('isCompleted').withTitle('Completed?').notSortable().renderWith(function (data, type, full) {
                        return full.isCompleted ? 'Yes' : 'No';
                    }),
                    DTColumnBuilder.newColumn('submittedBy').withTitle('Submitted By').notSortable(),
                    DTColumnBuilder.newColumn('lastUpdated').withTitle('Last Updated').notSortable().renderWith(function (data, type, full) {
                        return moment.utc(full.lastUpdated).local().format('DD/MM/YYYY LTS');
                    }),
                    DTColumnBuilder.newColumn('submittedAtLocation').withTitle('Submitted At Location').notSortable().renderWith(function (data, type, full) {
                        let googleMapsLink = `<a class="submittedAtLocation" href="#" ng-click="vm.openGoogleMaps(${full.latitude},${full.longitude})">
                                                ${full.latitude},${full.longitude}
                                              </a>`

                        return full.latitude == null || full.latitude == 0.000000 ? 'GPS Coordinates Not Found' : googleMapsLink;
                    }),
                    DTColumnBuilder.newColumn('actions').withTitle('Manage').notSortable().renderWith(function (data, type, full) {
                        let downloadFormElement = `<md-button class="md-icon-button md-primary action-button"
                                                                ng-click="vm.downloadForm('${full.pdfUrl}')"
                                                                ng-disabled="!${full.pdfUrl}">
                                                        <md-icon md-font-icon="icon-folder-download"></md-icon>
                                                    </md-button>`

                        let deleteFormElement = `<md-button class="md-icon-button md-primary action-button"
                                                            ng-click="vm.deleteForm('${full.id}')"
                                                            ng-disabled="!vm.enableDelete">
                                                    <md-icon md-font-icon="icon-delete"></md-icon>
                                                </md-button>`;
                        return downloadFormElement + deleteFormElement;
                    })
                ];

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withOption('pageLength', 10)
                    .withOption('lengthChange', false)
                    .withOption('searching', false)
                    .withOption('ajax', {
                        type: 'GET',
                        url: customFormsApiUrl + 'api/forms',
                        data: function (data) {
                            dtHeaders.pageNumber = data.start / data.length + 1;
                            dtHeaders.resultLimit = data.length;
                            dtHeaders.sortByField = 'lastUpdated';
                            dtHeaders.sortByType = 'desc';
                        },
                        processData: false,
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('X-TenantKey', tenantKey);
                            xhr.setRequestHeader('X-PageNumber', dtHeaders.pageNumber);
                            xhr.setRequestHeader('X-ResultLimit', dtHeaders.resultLimit);
                            xhr.setRequestHeader('X-SortByField', dtHeaders.sortByField);
                            xhr.setRequestHeader('X-SortByType', dtHeaders.sortByType);
                            xhr.setRequestHeader('X-ViewType', 'Basic');
                            xhr.setRequestHeader('X-Filter-FormIds', JSON.stringify(vm.formsIds));
                        },
                        dataFilter: function (responseJson) {
                            let response = JSON.parse(responseJson);

                            response.recordsTotal = response.totalResults;
                            response.recordsFiltered = response.totalResults;
                            return JSON.stringify(response);
                        },
                        error: function (ex) {
                            exceptionService.resolve(ex);
                        }
                    })
                    .withDataProp('results')
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withPaginationType('simple_numbers')
                    .withOption('createdRow', createdRow);
            }

            function createdRow(row, data) {
                if (data && !data.isCompleted) {
                    $(row).addClass('form-incomplete');
                }
                $compile(angular.element(row).contents())($scope);
            }

            function deleteForm(id) {
                let confirm = $mdDialog.confirm()
                    .title('Delete Form')
                    .textContent('Are you sure you want to delete this form?')
                    .ok('Yes')
                    .cancel('Cancel')
                    .multiple(true);
                $mdDialog.show(confirm).then(function () {
                    blockUI.start({
                        message: 'Deleting form'
                    });
                    customFormsApi.deleteForm(id).then(
                        function () {
                            if (vm.dtInstance && vm.dtInstance.DataTable) {
                                vm.dtInstance.DataTable.ajax.reload(null, true);
                                hubService.showToast('Form has been deleted');
                            } else {
                                exceptionService.resolve('Error reloading datatable');
                            }
                            blockUI.stop();
                        },
                        function (ex) {
                            blockUI.stop();
                            exceptionService.resolve(ex);
                        }
                    );
                });
            }

            function downloadForm(pdfUrl) {
                blockUI.start('Downloading Form PDF, please wait...');
                var anchor = angular.element('<a/>');

                $timeout(function () {
                    anchor.attr({
                        href: encodeURI(pdfUrl) + `?time=${new Date().getTime()}`
                    })[0].click();

                    blockUI.stop();
                }, 500);

            }

            function openGoogleMaps(jobLatitude, jobLongitude) {
                var dialog = {
                    templateUrl: 'app/shared/widgets/singleAddress/job-latitude-longitude-dialog.html',
                    controller: 'jobLatitudeLongitudeDialogController as vm',
                    jobCoordinates: {
                        Latitude: jobLatitude,
                        Longitude: jobLongitude
                    },
                    editMode: true
                  }
                  return $mdDialog.show(dialog);
            }

            initDataTable();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.widgets')
        .controller('historyLogV2Controller', historyLogV2Controller);

    function historyLogV2Controller(
        $mdDialog,
        searchDelay,
        data,
        headerTitle
    ) {
        var vm = this;
        vm.data = data.data;
        vm.getLogData = getLogData;
        vm.getValuesByField = getValuesByField;
        vm.headerTitle = headerTitle;

        vm.dtOptions = {
            dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'full_numbers',
            searchDelay: searchDelay,
            autoWidth: true,
            responsive: false,
            sort: false,
        };

        vm.onClose = onClose;

        function onClose() {
            $mdDialog.hide();
        }

        function activate() {
           
        }

        function getValuesByField(list, fieldName) {
            var res = list[fieldName];

            return res;
        }

        function getLogData(logData){
            return JSON.parse(logData);
        }

        activate();
    }
})();

(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('historyLogPage', historyLogPage);

    /** @ngInject */
    function historyLogPage() {
        let directive = {
            restrict: 'E',
            scope: {
                getLogs: "&",
            },
            templateUrl: 'app/shared/widgets/historyLogPage/history-log-page.html',
            controller: historyLogPageController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function historyLogPageController(TimeLibrary) {
            var vm = this;

            vm.dtOptions = {
                dom: 'ft<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                sort: false,
                deferRender: true,
                processing: true,
                lengthMenu: [
                    [10, 15, 20, -1],
                    [10, 15, 20, "All"]
                ]
            };

            activate();

            function activate() {
                vm.getLogs()
                    .then(resp => {
                        vm.logs = formatTime(resp.data);
                    });
            }

            function formatTime(logs) {
                logs.forEach(log => {
                    log.Log = TimeLibrary.covertTimesInString(log.Log);
                    log.LogDateUtc = moment(log.LogDateUtc).format('DD MMMM, YYYY, ') + TimeLibrary.convertTime(moment(log.LogDateUtc).format('HH:mm'));
                });

                return logs;
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.widgets')
        .factory('historyLogService', historyLogService);

    /** @ngInject */
    function historyLogService($mdDialog, _, TimeLibrary, auditApi) {

        var service = {
            showHistory: showHistory,
            showHistoryLogV2: showHistoryLogV2
        }

        return service;

        async function showHistoryLogV2(ids,headerTitle) {
            var result = await auditApi.getAuditEntriesV2(ids);

            await $mdDialog.show({
                templateUrl: 'app/shared/widgets/historyLogV2/history-logV2.html',
                controller: 'historyLogV2Controller as vm',
                multiple: true,
                locals: {
                  data: result,
                  headerTitle: headerTitle
                }
              });
        }

        function showHistory(module, data, detail, logDataComponent) {
            $mdDialog.show({
                templateUrl: 'app/shared/widgets/historyLog/history-log.html',
                controller: 'historyLogController as vm',
                multiple: true,
                locals: {
                    module: module,
                    data: formatTime(data),
                    detail: detail,
                    logDataComponent: logDataComponent
                }
            });

            function formatTime(data) {
                _.forEach(data, function (item) {
                    item.Log = TimeLibrary.covertTimesInString(item.Log);
                    item.LogDateUtc = moment(item.LogDateUtc).format('DD MMMM, YYYY, ') + TimeLibrary.convertTime(moment(item.LogDateUtc).format('HH:mm'));
                });

                return data;
            }

        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.widgets')
        .controller('historyLogController', historyLogController);

    function historyLogController(
        $scope,
        $compile,
        $mdDialog,
        module,
        _,
        DTColumnBuilder,
        DTOptionsBuilder,
        searchDelay,
        detail,
        data,
        logDataComponent
    ) {
        var vm = this;

        initDataTable();

        function initDataTable() {

            vm.dtColumns = [
                DTColumnBuilder.newColumn('logDate').withTitle('Date').renderWith(function(data, type, full) {
                    return full.LogDateUtc;
                }),
                DTColumnBuilder.newColumn('log').withTitle('Log').renderWith(function(data, type, full) {
                    return `<div>${full.Log}</div>` +
                            (full.LogData ? `<${logDataComponent} data="log.LogData"></${logDataComponent}>` : '') +
                            ``;
                }),
            ];

            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption('dom', '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                .withOption('data', data)
                .withOption('searchDelay', searchDelay)
                .withOption('pagingType', 'simple')
                .withOption('sort', false)
                .withOption('autoWidth', false)
                .withOption('createdRow', createdRow)
                .withOption('pageLength', 5)
                .withOption('lengthMenu', [[5, 10, 15, 20, -1],[5, 10, 15, 20, "All"]]);

        }

        vm.onClose = onClose;

        function createdRow(row, data, dataIndex) {
            var $newScope = $scope.$new(true);
            $newScope.logDataComponent = logDataComponent;
            $newScope.log = data;
            $compile(angular.element(row).contents())($newScope);
        }

        function onClose() {
            $mdDialog.hide();
        }

        function activate() {
            vm.module = module;

            if(module != "Ticket"){
                vm.detail = "- " + detail;
            }
            else{
                vm.detail = detail;
            }
        }

        activate();
    }
})();

(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('formTemplatesList', formTemplatesList);

    function formTemplatesList() {
        let directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/formTemplatesList/formTemplates-list.html',
            scope: {
                // One-way string binding. Use the following JSON array to filter by ANY one of: '["AllCompanies","AllBranches","AllVehicles","AllAssets"]'
                appliedTo: '@',

                // Two-way variable binding
                formTypes: "=",
                hideIncludeInPaperwork: "=",
                linkedFormTemplates: '=',
                unlinkedFormTemplates: '=',
                actualLinkedFormTemplates: '=', // If linkedFormTemplates is inherited, use this to save for the current level instead.
                actualUnlinkedFormTemplates: '=',
                vehicles: '=',
                assets: '=',
                disableAdd: '=',
                disableUnlink: '=',
                disableCheckbox: '=',
                alwaysRefreshFormsList: '=',
                overriddenFormTemplates: '=',
                actualOverriddenFormTemplates: '=', // If overriddenFormTemplates is inherited, use this to save for the current level instead.
                api: '=',
                onChange: '&'
            },
            controller: formTemplatesListController,
            controllerAs: 'vm',
            bindToController: true
        }

        return directive;

        function formTemplatesListController(_,
            $compile,
            $scope,
            $mdDialog,
            DTColumnBuilder,
            DTOptionsBuilder,
            notificationService,
            customFormsApiUrl,
            claimsUtilService) {
            let vm = this;

            var tenantKey = claimsUtilService.getTenantKey();

            vm.listDtInstance = {};
            vm.searchDtInstance = {};

            vm.firstListDataTableLoad = true;
            vm.firstSearchDataTableLoad = true;
            vm.isDTSearchInitialized = false;
            vm.formTemplateNameSearch = '';

            // This is to store the retrieved form templates, *after* applying inherited overridden settings,
            // *before* applying overridden settings at the current level
            vm.formTemplatesWithInheritedOverrides = [];

            // This is the model used to bind to the form templates list, which will track the state of the checkboxes
            vm.formTemplatesBoundList = [];

            let formTemplatesBoundListWatcher;
            
            let overriddenFormTemplates;
            let actualOverriddenFormTemplates;

            // Default datatable request headers
            let pageNumber = 1;
            let resultLimit = 10;
            vm.sortByField = 'displayOrder';
            vm.sortByFieldSearchDT = 'name';
            vm.sortByType = 'asc';
            vm.sortByTypeSearchDT = 'asc';

            let firstApplicationOfOverriddenTemplates = false;

            // Public functions
            vm.unlinkFormTemplate = unlinkFormTemplate;
            vm.addFormTemplateClick = addFormTemplateClick;
            vm.searchFormTemplateClick = searchFormTemplateClick;

            vm.api.getOverriddenTemplatesToSave = getOverriddenTemplatesToSave;

            initSearchDataTable();

            $scope.$watchGroup(['vm.linkedFormTemplates', 'vm.unlinkedFormTemplates', 'vm.vehicles', 'vm.assets', 'vm.overriddenFormTemplates'],
                function(newValue, oldValue) {
                    let newLinkedFormTemplates = newValue[0];
                    let newVehicles = newValue[2];
                    let oldLinkedFormTemplates = oldValue[0];
                    let newOverriddenFormTemplates = newValue[4];

                    let alwaysRefreshFormsList = vm.alwaysRefreshFormsList !== undefined && !vm.alwaysRefreshFormsList;
                    let hasVehicles = newVehicles !== undefined;
                    let hasLinkedFormTemplates = newLinkedFormTemplates || oldLinkedFormTemplates;
                    let shouldLoadListDataTable = alwaysRefreshFormsList || (hasVehicles && hasLinkedFormTemplates);

                    if (!shouldLoadListDataTable) {
                        return;
                    }

                    initOverriddenFormTemplates(newOverriddenFormTemplates);
                    loadListDataTable();
                }
            );

            function watchFormTemplatesBoundList() {
                if (formTemplatesBoundListWatcher) {
                    return;
                }
                
                formTemplatesBoundListWatcher = $scope.$watch('vm.formTemplatesBoundList', function(newValue, oldValue) {
                    if (vm.onChange && newValue != oldValue) {
                        vm.onChange(newValue, oldValue);
                    }
                }, true);
            }

            function initOverriddenFormTemplates(newOverriddenFormTemplates) {
                vm.overriddenFormTemplates = vm.overriddenFormTemplates || [];

                if (!newOverriddenFormTemplates) {
                    return;
                }

                firstApplicationOfOverriddenTemplates = true;

                overriddenFormTemplates = vm.overriddenFormTemplates.map(oft => {
                    return {
                        id: oft.Id,
                        originId: oft.OriginId,
                        relatedEntityId: oft.RelatedEntityId,
                        isRequired: oft.IsRequired,
                        includeInPaperwork: oft.IncludeInPaperwork
                    };
                });

                if (vm.actualOverriddenFormTemplates) {
                    actualOverriddenFormTemplates = vm.actualOverriddenFormTemplates.map(aoft => {
                        return {
                            id: aoft.Id,
                            originId: aoft.OriginId,
                            relatedEntityId: aoft.RelatedEntityId,
                            isRequired: aoft.IsRequired,
                            includeInPaperwork: aoft.IncludeInPaperwork
                        };
                    });
                }
            }

            function loadListDataTable() {
                vm.linkedFormTemplates = vm.linkedFormTemplates || [];
                vm.unlinkedFormTemplates = vm.unlinkedFormTemplates || [];

                if (vm.firstListDataTableLoad) {
                    initDataTable();
                    return;
                }

                vm.listDtInstance.DataTable.ajax.reload(null, false);
            }

            function initSearchDataTable() {
                vm.searchDataColumns = [                    
                    DTColumnBuilder.newColumn('name').notSortable(),
                    DTColumnBuilder.newColumn('').notSortable().renderWith(function(data, type, full) {
                        return `<div layout='row' layout-align='end'>
                                    <md-button id='${full.id}'
                                               class='md-accent md-raised md-button md-default-theme md-ink-ripple btn-add-form'
                                               ng-click='vm.addFormTemplateClick("${full.id}","${full.originId}","${escape(full.name)}","${full.formType}")')'>Add
                                    </md-button>
                                </div>`;
                    })
                ];

                
                vm.searchDataOptions = DTOptionsBuilder
                    .newOptions()
                    .withOption('pageLength', 5)
                    .withOption('searching', false)
                    .withOption('lengthChange', false)
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withOption('createdRow', createdRow)
                    .withOption('infoCallback', infoCallback)
                    .withOption('deferRender', true)
                    .withOption('ajax', {
                        type: 'GET',
                        url: customFormsApiUrl + 'api/form-templates',
                        data: function(data) {
                            pageNumber = (data.start / data.length) + 1;
                            resultLimit = data.length;

                            let sortColumnIndex = data.order[0].column;
                            vm.sortByFieldSearchDT = data.columns[sortColumnIndex].data;
                            vm.sortByTypeSearchDT = data.order[0].dir;
                        },
                        processData: false,
                        beforeSend: function(xhr) {
                            if (vm.firstSearchDataTableLoad) {
                                vm.firstSearchDataTableLoad = false;
                                xhr.abort();
                                vm.linkedFormTemplates = vm.linkedFormTemplates || [];
                                vm.unlinkedFormTemplates = vm.unlinkedFormTemplates || [];
                                return;
                            }
                            xhr.setRequestHeader('X-TenantKey', tenantKey);
                            xhr.setRequestHeader('X-PageNumber', pageNumber);
                            xhr.setRequestHeader('X-ResultLimit', resultLimit);
                            xhr.setRequestHeader('X-SortByField', vm.sortByFieldSearchDT);
                            xhr.setRequestHeader('X-SortByType', vm.sortByTypeSearchDT);
                            xhr.setRequestHeader('X-Filter-IsPublished', true);
                            xhr.setRequestHeader('X-Filter-FormName', vm.formTemplateNameSearch);
                            xhr.setRequestHeader('X-Version', '2.0');
                            let formTemplatesToExclude = vm.linkedFormTemplates.filter(lt => !lt.RelatedEntityId);
                            let linkedVehicleAssetTemplates = vm.linkedFormTemplates.filter(lt => lt.RelatedEntityId);
                            linkedVehicleAssetTemplates.forEach(t => {
                                let linkedTemplatesWithSameId = linkedVehicleAssetTemplates.filter(innerT => innerT.OriginId === t.OriginId);
                                if (t.FormType === 'Vehicle') {
                                    if (linkedTemplatesWithSameId.length === vm.vehicles.length) {
                                        formTemplatesToExclude.push(t);
                                    }
                                } else { // Asset
                                    if (linkedTemplatesWithSameId.length === vm.assets.length) {
                                        formTemplatesToExclude.push(t);
                                    }
                                }
                            });
                            xhr.setRequestHeader('X-Filter-Exclude-FormTemplateOriginIds', JSON.stringify(formTemplatesToExclude.map(t => t.OriginId)));
                            xhr.setRequestHeader('X-Filter-Include-FormTemplateOriginIds', JSON.stringify(vm.unlinkedFormTemplates.map(t => t.OriginId)));
                            xhr.setRequestHeader('X-Filter-Except-ConsumerFields', `{'key': 'AppliedTo', 'values': ${vm.appliedTo}, 'matchType': 'Any' }`);
                            if (vm.formTypes) { // Branch and Company requires only Job/Worker forms, Items page require only Vehicle/Asset forms.
                                xhr.setRequestHeader('X-Filter-FormTypes', JSON.stringify(vm.formTypes));
                            }
                        },
                        dataFilter: function(responseJson) {
                            let response = JSON.parse(responseJson);
                            response.recordsTotal = response.totalResults;
                            response.recordsFiltered = response.totalResults;
                            return JSON.stringify(response);
                        },
                        error: function() {
                            $mdDialog.show($mdDialog.alert()
                                .title('Error')
                                .textContent('An error occured when contacting the server.')
                                .ok('Close'));
                        }
                    })
                    .withDataProp('results')
                    .withPaginationType('simple')
            }

            function initDataTable() {
                // dtColumns is necessary if using serverSide pagination
                vm.dtColumns = [
                    DTColumnBuilder.newColumn('displayOrder').withTitle('').notSortable().withClass('hiddencol').renderWith(function(data, type, full) {
                        return "";
                    }),
                    DTColumnBuilder.newColumn('name').withTitle('Name').withClass('name').notSortable().renderWith(function(data, type, full) {
                        if (full.isDeleted) {
                            return `<div>
                                        <div>${full.name}
                                        <div class="error-note">This form template has been deleted.</div>
                                    </div>`;
                        }

                        return full.name;
                    }),
                    DTColumnBuilder.newColumn('formType').withTitle('Type').notSortable().renderWith(function(data, type, full) {
                        return full.vehicleOrAssetName || full.formType;
                    }),
                    DTColumnBuilder.newColumn('isRequired').withTitle('Required form').notSortable().renderWith(function(data, type, full) {
                        let listIndex = vm.formTemplatesBoundList.findIndex(ft => ft.id === full.id && ft.relatedEntityId === full.relatedEntityId);
                        return `<md-checkbox class="margin-bottom-0"
                                             ng-model="vm.formTemplatesBoundList[${listIndex}].isRequired"
                                             ng-disabled="vm.disableUnlink || ${full.isDeleted}">
                                </md-checkbox>`;
                    }),
                    DTColumnBuilder.newColumn('includeInPaperwork').withTitle('Included in Paperwork').withOption('visible', !vm.hideIncludeInPaperwork).notSortable().renderWith(function(data, type, full) {
                        let listIndex = vm.formTemplatesBoundList.findIndex(ft => ft.id === full.id && ft.relatedEntityId === full.relatedEntityId);
                        return `<md-checkbox class="margin-bottom-0"
                                                ng-model="vm.formTemplatesBoundList[${listIndex}].includeInPaperwork"
                                                ng-disabled="vm.disableCheckbox || ${full.isDeleted}">
                                    </md-checkbox>`;
                    }),
                    DTColumnBuilder.newColumn('').withTitle('Unlink').withClass('unlink').notSortable().renderWith(function(data, type, full) {
                        return `<md-button class='md-icon-button md-primary action-button'
                                           ng-click='vm.unlinkFormTemplate("${full.id}", "${full.originId}", "${escape(full.name)}", "${full.formType}", "${full.relatedEntityId}", "${full.appliedTo}")'
                                           ng-disabled='vm.disableUnlink'>
                                    <i class='icon icon-link-off s15' ng-class="{'red-500-fg': !vm.disableUnlink, 'grey-500-fg': vm.disableUnlink}"></i>
                                </md-button>`;
                    })
                ];

                
                vm.dtOptions = DTOptionsBuilder
                    .newOptions()
                    .withOption('pageLength', 5)
                    .withOption('ordering', false)
                    .withOption('lengthChange', false) // Disable changing number of records per page
                    .withOption('searching', false) // Disable search
                    .withOption('deferRender', true)
                    .withOption('ajax', {
                        type: 'GET',
                        url: customFormsApiUrl + 'api/form-templates',
                        processData: false, // This avoids appending a long stringified "data" querystring to the URL
                        beforeSend: function(xhr) {
                            // This fixes an issue where datatables inits twice because the table isn't initialised immediately on page load
                            if (vm.firstListDataTableLoad) {
                                vm.firstListDataTableLoad = false;
                                xhr.abort();
                                return;
                            }
                            xhr.setRequestHeader('X-TenantKey', tenantKey);
                            xhr.setRequestHeader('X-PageNumber', pageNumber);
                            xhr.setRequestHeader('X-ResultLimit', 1000);
                            xhr.setRequestHeader('X-SortByField', vm.sortByField);
                            xhr.setRequestHeader('X-SortByType', vm.sortByType);
                            xhr.setRequestHeader('X-Filter-IsPublished', true);
                            xhr.setRequestHeader('X-Filter-Has-ConsumerFields', `{'key': 'AppliedTo', 'values': ${vm.appliedTo}, 'matchType': 'Any' }`);
                            let formTemplatesToExclude = vm.unlinkedFormTemplates.filter(ut => !ut.RelatedEntityId);
                            xhr.setRequestHeader('X-Filter-Exclude-FormTemplateOriginIds', JSON.stringify(formTemplatesToExclude.map(t => t.OriginId)));
                            xhr.setRequestHeader('X-Filter-Include-FormTemplateOriginIds', JSON.stringify(vm.linkedFormTemplates.map(t => t.OriginId)));
                            xhr.setRequestHeader('X-Version', '2.0');

                        },
                        dataFilter: function(responseJson) {
                            let response = JSON.parse(responseJson);
                            if (response.results[0] && vm.vehicles && vm.assets) {
                                for (let i = 0; i < response.results.length; i++) {
                                    let firstParse = true;
                                    let result = response.results[i];

                                    let isVehicleOrAssetNameMissing = !result.vehicleOrAssetName;
                                    let isVehicleForm = result.formType === 'Vehicle';
                                    let isAssetForm = result.formType === 'Asset';
                                    let shouldPopulateVehicleOrAssetName = isVehicleOrAssetNameMissing && (isVehicleForm || isAssetForm);

                                    if (shouldPopulateVehicleOrAssetName) {
                                        let vehiclesOrAssets = [];
                                        if (result.formType === 'Vehicle') {
                                            vehiclesOrAssets = vm.vehicles;
                                        } else {
                                            if(vm.assets.length == 0 && vm.vehicles.find(x => x.Type.some(type => type === 1))) {
                                                vehiclesOrAssets = vm.vehicles;
                                            } else {
                                                vehiclesOrAssets = vm.assets;
                                            }
                                        }

                                        let resultIsShown = false;
                                        vehiclesOrAssets.forEach(vehicleOrAsset => {
                                            let manuallyUnlinked = vm.unlinkedFormTemplates.some(ut => ut.OriginId === result.originId
                                                                                                       && ut.RelatedEntityId === vehicleOrAsset.Id);
                                            if (manuallyUnlinked) {
                                                return;
                                            }

                                            let appliedTo = JSON.parse(vm.appliedTo);
                                            let notIncludedByDefault = appliedTo.every(appliedTo => appliedTo !== result.consumerFields.AppliedTo);
                                            let unlinkedByDefault = vm.unlinkedFormTemplates.some(ut => ut.OriginId === result.originId && !ut.RelatedEntityId);
                                            if (notIncludedByDefault || unlinkedByDefault) {
                                                let matchedLinkedTemplates = vm.linkedFormTemplates.filter(lt => lt.OriginId === result.originId);
                                                if (matchedLinkedTemplates.length > 0) {
                                                    let linkedForAll = matchedLinkedTemplates.some(lt => !lt.RelatedEntityId);
                                                    if (!linkedForAll) {
                                                        let noRelatedEntityInMatchedTemplate = matchedLinkedTemplates.every(lt => lt.RelatedEntityId !== vehicleOrAsset.Id);
                                                        if (noRelatedEntityInMatchedTemplate) {
                                                            return;
                                                        }
                                                    }
                                                }
                                            }

                                            resultIsShown = true;

                                            if (firstParse) {
                                                firstParse = false;
                                                response.results[i].vehicleOrAssetName = vehicleOrAsset.Name;
                                                response.results[i].relatedEntityId = vehicleOrAsset.Id;
                                            } else {
                                                let resultJson = JSON.stringify(result);
                                                let clonedResult = JSON.parse(resultJson);
                                                clonedResult.vehicleOrAssetName = vehicleOrAsset.Name;
                                                clonedResult.relatedEntityId = vehicleOrAsset.Id;
                                                response.results.splice(i, 0, clonedResult);
                                            }
                                        });

                                        if (!resultIsShown) {
                                            response.results.splice(i, 1);
                                            i--;
                                        }
                                    }
                                }
                            }

                            response.results.forEach(result => {
                                result.includeInPaperwork = (result.consumerFields.IncludeInPaperwork === 'true') ? true : false;
                                result.appliedTo = result.consumerFields.AppliedTo;
                                result.isDeleted = result.isDeleted;
                            });

                            // Store the baseline list which is:
                            // - the list returned from Forms API
                            // - (at the job level) combined with the inherited overridden settings from branch/company/item
                            // This baseline list is used as comparison from the saved (or user-updated) list for the current level, to determine the differences to save
                            if (vm.actualOverriddenFormTemplates) {
                                vm.formTemplatesWithInheritedOverrides = updateFlagsOnFormTemplatesList(response.results, overriddenFormTemplates, true, false);
                            } else {
                                vm.formTemplatesWithInheritedOverrides = response.results;
                            }

                            let templatesToOverrideWith;
                            let isForActualOverriddenFormTemplates = false;
                            if (firstApplicationOfOverriddenTemplates) {
                                // First datatable load.
                                // Get templates from vm.overriddenFormTemplates (or vm.actualOverriddenFormTemplates at the Job level)
                                // which is the initial saved overridden values for that entity.
                                if (vm.actualOverriddenFormTemplates) {
                                    templatesToOverrideWith = actualOverriddenFormTemplates;
                                    isForActualOverriddenFormTemplates = true;
                                } else {
                                    templatesToOverrideWith = overriddenFormTemplates;
                                }
                            } else {
                                // Second and subsequent datatable loads where there is a list bound to the table (which is potentially user-updated)
                                templatesToOverrideWith = vm.formTemplatesBoundList;
                            }

                            // Update the form templates list used to bind to ng-model for each table row
                            vm.formTemplatesBoundList = updateFlagsOnFormTemplatesList(vm.formTemplatesWithInheritedOverrides,
                                                                                       templatesToOverrideWith,
                                                                                       firstApplicationOfOverriddenTemplates,
                                                                                       isForActualOverriddenFormTemplates);

                            watchFormTemplatesBoundList();

                            firstApplicationOfOverriddenTemplates = false;
                            
                            // Datatable uses these properties for pagination
                            response.recordsTotal = response.results.length;
                            response.recordsFiltered = response.results.length;
                            return JSON.stringify(response);
                        }
                    })
                    .withDataProp('results') // Tell Datatable to use the results property of the response object to populate records
                    .withOption('processing', true) // Displays 'Processing...' text while loading records
                    .withPaginationType('simple_numbers')
                    // This is a callback function executed after each row is rendered. It enables proper rendering of the "Action" column which uses AngularJS directives.
                    .withOption('createdRow', createdRow);
            }

            // If isLoadingSavedOverriddenFlags is true, it means overriddenTemplates are saved settings, not current angular datatable bound settings.
            function updateFlagsOnFormTemplatesList(baseTemplates, overriddenTemplates, isLoadingSavedOverriddenFlags, isForActualOverriddenFormTemplates) {
                let appliedOverriddenTemplates = overriddenTemplates;

                // Apply saved overridden settings only if they have not been manually linked at the job level
                if (isLoadingSavedOverriddenFlags && vm.actualLinkedFormTemplates && !isForActualOverriddenFormTemplates) {
                    appliedOverriddenTemplates = overriddenTemplates.filter(ot =>
                        !vm.actualLinkedFormTemplates.some(alft => alft.OriginId === ot.originId && alft.RelatedEntityId == ot.relatedEntityId)
                    );
                }

                let returnTemplates = baseTemplates.map(baseTemplate => {
                    // Updated result to return and set in vm.formTemplatesBoundList.
                    // isRequired and includeInPaperwork flags are set after this after factoring in saved/user-updated settings
                    let updatedTemplate = {
                        id: baseTemplate.id,
                        originId: baseTemplate.originId,
                        formType: baseTemplate.formType,
                        vehicleOrAssetName: baseTemplate.vehicleOrAssetName,
                        relatedEntityId: baseTemplate.relatedEntityId,
                        name: baseTemplate.name,
                        appliedTo: baseTemplate.appliedTo,
                        isDeleted: baseTemplate.isDeleted
                    };

                    // Check if the base template has any overridden version. If yes, use the flags from the overridden version instead.
                    let matchedOverriddenTemplate = appliedOverriddenTemplates.find(oft =>
                        oft.originId === baseTemplate.originId && oft.relatedEntityId == baseTemplate.relatedEntityId // Intentionally '==' so that null == undefined is true
                    );

                    let isRequiredUpdated = false;
                    let includeInPaperworkUpdated = false;

                    if (matchedOverriddenTemplate) {
                        if (isLoadingSavedOverriddenFlags) {
                            // Update flags with non-null saved settings
                            isRequiredUpdated = (matchedOverriddenTemplate.isRequired !== null);
                            includeInPaperworkUpdated = (matchedOverriddenTemplate.includeInPaperwork !== null);
                        } else {
                            // This is for when vm.formTemplatesBoundList is the overridden list. In this case, always set the flags since it's user-updated.
                            isRequiredUpdated = true;
                            includeInPaperworkUpdated = true;
                        }
                    } else {
                        if (baseTemplate.formType  === 'Vehicle' || baseTemplate.formType  === 'Asset') {
                            // matchedOverriddenTemplate for all items at company/branch level
                            matchedOverriddenTemplate = appliedOverriddenTemplates.find(oft =>
                                oft.originId === baseTemplate.originId && !oft.relatedEntityId
                            );
                            if (matchedOverriddenTemplate) {
                                let itemHasLinkedTemplate = vm.linkedFormTemplates.some(lft =>
                                    lft.originId === baseTemplate.originId && lft.relatedEntityId === baseTemplate.relatedEntityId
                                );
                                // matchedOverriddenTemplate for all items at company/branch level only applies if there is no specific item linked template
                                if (!itemHasLinkedTemplate) {
                                    isRequiredUpdated = (matchedOverriddenTemplate.isRequired !== null);
                                    includeInPaperworkUpdated = (matchedOverriddenTemplate.includeInPaperwork !== null);
                                }
                            }
                        }
                    }

                    updatedTemplate.isRequired =
                        (isRequiredUpdated ? matchedOverriddenTemplate.isRequired : baseTemplate.isRequired);
                    updatedTemplate.includeInPaperwork =
                        (includeInPaperworkUpdated ? matchedOverriddenTemplate.includeInPaperwork : baseTemplate.includeInPaperwork);

                    return updatedTemplate;
                });

                return returnTemplates;
            }

            function createdRow(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the datatable
                $compile(angular.element(row).contents())($scope);
            }

            function infoCallback(settings, start, end, max, total, pre) {
                return '';
            }

            function searchFormTemplateClick() {
                if (!vm.formTemplateNameSearch) {
                    vm.isDTSearchInitialized = false;
                } else {
                    let dataTableInstance = vm.searchDtInstance.DataTable
                    if ($.fn.DataTable.isDataTable('#searchDataTable')) {
                        dataTableInstance.ajax.reload(null, true); // true/false for reset paging.
                    }
                    vm.isDTSearchInitialized = true;
                }
            }"Saving will update this form everywhere it is applied to. <br/>Already submitted form PDFs will not be affected."

            function unlinkFormTemplate(formTemplateId, originId, formTemplateName, formType, relatedEntityId, appliedTo) {
                let confirmDialog = $mdDialog.confirm({
                    title: 'Unlink Form',
                    textContent: `Are you sure you want to unlink ${unescape(formTemplateName)}?`,
                    ok: 'ok',
                    cancel: 'cancel'
                });

                $mdDialog.show(confirmDialog)
                    .then(function() {
                        unlinkRelevantTemplates(formTemplateId, originId, relatedEntityId, formType, appliedTo, vm.linkedFormTemplates, vm.unlinkedFormTemplates);
                        if (vm.actualLinkedFormTemplates) {
                            unlinkRelevantTemplates(formTemplateId, originId, relatedEntityId, formType, appliedTo, vm.actualLinkedFormTemplates, vm.actualUnlinkedFormTemplates);
                        }
                        redrawTableAndShowNotification(formTemplateName, false);
                    });
            }

            function unlinkRelevantTemplates(formTemplateId, originId, relatedEntityId, formType, templateAppliedTo, linkedFormTemplates, unlinkedFormTemplates) {
                let hasLinkedTemplate = false;

                if (relatedEntityId !== 'undefined') {
                    let matchedTemplate = linkedFormTemplates.find(lt => lt.OriginId === originId && lt.RelatedEntityId === relatedEntityId);
                    if (matchedTemplate) {
                        let appliedTo = JSON.parse(vm.appliedTo);
                        let notIncludedByDefault = appliedTo.every(appliedTo => appliedTo !== templateAppliedTo);
                        if (notIncludedByDefault) {
                            hasLinkedTemplate = true;
                        }
                        let templates = linkedFormTemplates.filter(lt => !(lt.OriginId === originId && lt.RelatedEntityId === relatedEntityId));
                        linkedFormTemplates.length = 0;
                        linkedFormTemplates.push(...templates);
                    }
                } else {
                    let matchedTemplate = linkedFormTemplates.find(lt => lt.OriginId === originId);
                    if (matchedTemplate) {
                        hasLinkedTemplate = true;
                        let templates = linkedFormTemplates.filter(lt => !(lt.OriginId === originId));
                        linkedFormTemplates.length = 0;
                        linkedFormTemplates.push(...templates);
                    }
                }

                if (!hasLinkedTemplate) {
                    unlinkedFormTemplates.push(
                        {
                            Id: formTemplateId,
                            OriginId: originId,
                            FormType: formType,
                            RelatedEntityId: (relatedEntityId === 'undefined' ? undefined : relatedEntityId)
                        }
                    );
                }
            }

            function addFormTemplateClick(formTemplateId, originId, formTemplateName, formType) {
                linkRelevantTemplates(formTemplateId, originId, formType, vm.linkedFormTemplates, vm.unlinkedFormTemplates);
                if (vm.actualLinkedFormTemplates) {
                    linkRelevantTemplates(formTemplateId, originId, formType, vm.actualLinkedFormTemplates, vm.actualUnlinkedFormTemplates);
                }
                redrawTableAndShowNotification(formTemplateName, true);
                angular.element(`#${formTemplateId}`).prop('disabled', true);
            }

            function linkRelevantTemplates(formTemplateId, originId, formType, linkedFormTemplates, unlinkedFormTemplates) {
                let hasUnlinkedTemplates = unlinkedFormTemplates.find(ut => ut.OriginId === originId);
                if (hasUnlinkedTemplates) {
                    let templates = unlinkedFormTemplates.filter(ut => ut.OriginId !== originId);
                    unlinkedFormTemplates.length = 0;
                    unlinkedFormTemplates.push(...templates);
                    if ((vm.vehicles && vm.vehicles.length > 0) || (vm.assets && vm.assets.length > 0)) {
                        let linkedTemplatesLength = linkedFormTemplates.filter(lt => lt.OriginId === originId).length;
                        let vehiclesOrAssets = [];
                        if (formType === 'Vehicle') {
                            vehiclesOrAssets = vm.vehicles;
                        } else {
                            vehiclesOrAssets = vm.assets;
                        }
                        if (linkedTemplatesLength > 0 && linkedTemplatesLength < vehiclesOrAssets.length) {
                            vehiclesOrAssets.forEach(vehicleOrAsset => {
                                if (!linkedFormTemplates.some(lt => lt.OriginId === originId && lt.RelatedEntityId === vehicleOrAsset.Id)) {
                                    linkedFormTemplates.push(
                                        {
                                            Id: formTemplateId,
                                            OriginId: originId,
                                            FormType: formType,
                                            RelatedEntityId: vehicleOrAsset.Id
                                        }
                                    );
                                }
                            });
                        }
                    }
                } else {
                    // Jobs page passes in vehicles/assets on the job
                    if ((vm.vehicles && vm.vehicles.length > 0) || (vm.assets && vm.assets.length > 0)) {
                        if (formType === 'Job' || formType === 'Worker') {
                            linkedFormTemplates.push(
                                {
                                    Id: formTemplateId,
                                    OriginId: originId,
                                    FormType: formType
                                }
                            );
                        } else {
                            let vehiclesOrAssets = [];
                            if (formType === 'Vehicle') {
                                vehiclesOrAssets = vm.vehicles;
                            } else {
                                if(vm.assets.length == 0 && vm.vehicles.find(x => x.Type.some(type => type === 1))) {
                                    vehiclesOrAssets = vm.vehicles;
                                } else {
                                    vehiclesOrAssets = vm.assets;
                                }
                            }
                            vehiclesOrAssets.forEach(vehicleOrAsset => {
                                if (!linkedFormTemplates.some(lt => lt.OriginId === originId && lt.RelatedEntityId === vehicleOrAsset.Id)) {
                                    linkedFormTemplates.push(
                                        {
                                            Id: formTemplateId,
                                            OriginId: originId,
                                            FormType: formType,
                                            RelatedEntityId: vehicleOrAsset.Id
                                        }
                                    );
                                }
                            });
                        }
                    } else {
                        // Branch/Company/Items pages do not pass in vehicles/assets
                        linkedFormTemplates.push(
                            {
                                Id: formTemplateId,
                                OriginId: originId,
                                FormType: formType
                            }
                        );
                    }
                }
            }

            function redrawTableAndShowNotification(formTemplateName, isLinked) {
                vm.listDtInstance.DataTable.ajax.reload(null, true);

                let notificationMessage = isLinked ? " linked." : " unlinked.";
                notificationService.showToast(unescape(formTemplateName + notificationMessage));
            }

            function getOverriddenTemplatesToSave() {
                // Get differences from vm.formTemplatesWithInheritedOverrides (the baseline) to vm.formTemplatesBoundList
                let differences = vm.formTemplatesBoundList.reduce((differences, ftBoundItem) => {
                    let baselineFormTemplate =
                        vm.formTemplatesWithInheritedOverrides.find(ftBaseline => ftBaseline.originId === ftBoundItem.originId && ftBaseline.relatedEntityId === ftBoundItem.relatedEntityId);

                    if (baselineFormTemplate) {
                        let isRequiredChanged = (baselineFormTemplate.isRequired !== ftBoundItem.isRequired);
                        let includeInPaperworkChanged = (baselineFormTemplate.includeInPaperwork !== ftBoundItem.includeInPaperwork);

                        if (isRequiredChanged || includeInPaperworkChanged) {
                            differences.push({
                                id: ftBoundItem.id,
                                originId: ftBoundItem.originId,
                                formType: ftBoundItem.formType,
                                relatedEntityId: ftBoundItem.relatedEntityId,
                                isRequired: (isRequiredChanged ? ftBoundItem.isRequired : undefined),
                                includeInPaperwork: (includeInPaperworkChanged ? ftBoundItem.includeInPaperwork : undefined)
                            });
                        }
                    }

                    return differences;
                }, []);

                return differences;
            }
        }
    }
})();

/**
 * Created by Ben Rei on 8/12/2016.
 */
(function() {
  'use strict';
  angular.module('app.widgets')
    .directive('droppable', droppable);

  /** @ngInject */
  function droppable() {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };
    return directive;

    function linkFunc(scope, element, attrs) {
      element.bind('dragover',function (e) {
        e.preventDefault(); // Necessary. Allows us to drop.
        e.dataTransfer.dropEffect = 'copy';  // See the section on the DataTransfer object.

        var test = attrs;
        return false;
      });

      element.bind('drop',function (e) {
        e.preventDefault();
        e.stopPropagation();
        var func = scope.$eval(attrs.droppableFunction);
        var dataText = e.dataTransfer.getData('text/plain');
        func(dataText);
      });
    }
  }
})();

/**
 * Created by Ben Rei on 8/12/2016.
 */
(function() {
  'use strict';
//
  angular.module('app.widgets')
    .directive('draggable', draggable);

  /** @ngInject */
  function draggable() {
    var directive = {
      restrict: 'A',
      // scope: {
      //   //busyText: '@',
      //   model: '='//,
      //   //busyName: '@'
      // },
      link: linkFunc
    };

    return directive;

    ///////

    function linkFunc(scope, element, attrs) {
      //
      //element[0].addEventListener('dragstart', scope.handleDragStart, false);
      //element[0].addEventListener('dragend', scope.handleDragEnd, false);

      //scope.handleDragStart = function(e){
      element.bind('dragstart',function (e) {
        var draggableData = attrs.draggableData;
        this.style.opacity = '0.8';
        e.dataTransfer.setData('text', draggableData);
        //e.dataTransfer.setData('text/plain', this.innerText);
      });

      //scope.handleDragEnd = function(e){
      element.bind('dragend',function (e) {
        this.style.opacity = '1.0';
      });
    }
  }

})();

/**
 * Created by queeniejgm on 08/13/2018.
 */
(function () {
    'use strict';

    angular.module('app.widgets')
        .factory('documentService', documentService);

    /** @ngInject */
    function documentService(
        $q,
        documentsApi,
        dataCacheService2,
        jobsApi
    ) {
        const imageMimeType = ["image/png", "image/jpg", "image/jpeg"];
        const urlMimeType = ["application/url"];

        let self = this;
        self.cacheObj = dataCacheService2.getInstance();
        self.service = {};

        self.service.getAllDocumentsForResource = function (moduleId, resourceId) {
            let deferred = $q.defer();
            documentsApi.getAllDocumentsForResource(moduleId, resourceId).then(function (resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowedDocumentContentTypes = function (resourceId) {
            let deferred = $q.defer();
            documentsApi.getAllowedDocumentContentTypes().then(function (resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.removeDocument = function (documentId) {
            let deferred = $q.defer();
            documentsApi.removeDocumentById(documentId).then(function (resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.unlinkDocument = function (ticketId, documentId) {
            let deferred = $q.defer();
            jobsApi.unlinkDocumentById(ticketId, documentId).then(function (resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateDocument = function (id, name, attachmentTypeId) {
            let deferred = $q.defer();
            documentsApi.putDocument(id, name, attachmentTypeId).then(function () {
                deferred.resolve({
                    data: true
                });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateIncludePaperworkFlag = function(documentId, relatedResourceId, includeInPaperwork, isInheritedDocument){
            let deferred = $q.defer();

            documentsApi.updateIncludePaperworkFlag(documentId, relatedResourceId, includeInPaperwork, isInheritedDocument).then(function(){
                deferred.resolve({
                    data: true
                });
            });

            return deferred.promise;
        }

        self.service.getModuleList = function () {
            let deferred = $q.defer();
            documentsApi.getModuleList().then(function (resp) {
                self.service.modules = resp.data;
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.convertBytes = function (bytes) {
            if (bytes === 0) {
                return '-'
            }

            return Humanize.fileSize(bytes);
        }

        self.service.getFileType = function (fileName, mimeType) {
            return urlMimeType.includes(mimeType) ? "Link" : fileName.split('.').pop().toUpperCase();
        }

        function generateCacheKey(name) {
            return name.replace(/\s/g, '');
        }

        function checkValidFilter(cacheName) {
            let cacheData = cacheObj.getCache(cacheName);

            return cacheData;
        }

        function isDataExist(key) {
            return !_.isNil(self.cacheObj) && !_.isNil(self.cacheObj.getCache(key));
        }

        function addCache(data, key) {
            self.cacheObj.updateCache(key, {
                data: data
            });
        }

        return self.service;
    }
})();

(function() {
    'use strict';
    angular.module('app.widgets')
        .directive('documentManager', documentManager);

    /** @ngInject */
    function documentManager() {
        let directive = {
            restrict: 'E',
            scope: {
                modal: '@',
                enableUpload: '@',
                showLevel: '=',
                hideList: '@',
                moduleId: '@',
                moduleName: '@',
                relatedResourceId: '@',
                excludedDocuments: '=',
                disableAdd: '=',
                disableEdit: '=',
                disableDelete: '=',
                disableUnlink: '=',
                disableCheckbox: '=',
                hideIncludePaperworkColumn: '=',
                requiredAttachmentTypes: '='
            },
            templateUrl: 'app/shared/widgets/documentManager/documentManager.directive.html',
            controller: DocumentManagerController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function DocumentManagerController(
            $q,
            $scope,
            $http,
            blockUI,
            tenantSettings,
            hubService,
            utils,
            $mdDialog,
            exceptionService,
            identityService,
            claimsUtilService,
            documentService,
            attachmentTypesApi,
            googleApiKey,
            googleApiClientId,
            googleDriveScope,
            googleDriveApiUrl,
            oneDriveEndpointHint,
            oneDriveRedirectPath
        ) {
            let self = this;

            var fileTypeToMimeMap = {};
            var linkFileTypeId = null;
            var URL_TAB_INDEX = 2;

            self.dtOptions = {
                order: [],
                paging: true,
                searching: false,
                lengthChange: false,
                fixedColumns: true
            };
            self.formData = [];
            self.documentService = documentService;
            self.isUploadDocumentHidden = true;
            self.hasAccessInDocumentJobs = claimsUtilService.checkAccessByRole("DocumentsManager-Jobs");
            self.isLoading = true;
            self.selectedAttachmentType = null;
            self.selectedUploadTab = 0;
            self.isAttachmentTypesEnabled = claimsUtilService.isConfigurableRequiredAttachmentsEnabled();
            self.attachmentTypes = [];
            self.selectableAttachmentTypes = [];
            self.pickerApiLoaded = false;
            self.oauthToken;
            self.moduleInfos = [{
                    sortOrder: 3,
                    moduleId: '5',
                    moduleName: 'Branch'
                },
                {
                    sortOrder: 2,
                    moduleId: '2',
                    moduleName: 'Company'
                },
                {
                    sortOrder: 1,
                    moduleId: '3',
                    moduleName: 'Equipment'
                },
                {
                    sortOrder: 0,
                    moduleId: '4',
                    moduleName: 'Job',
                }
            ];
            $scope.form = {};

            const FILENAME_LENGTH_LIMIT = 248;
            const DOCUMENT_ORIGIN = {
                Web: 'Alloc8Portal',
                App: 'Alloc8App'
             };

            $scope.onDragOver = function(element) {
                if (element != null) {
                    element.preventDefault();
                }
            }

            $scope.onDragEnter = function(element) {
                if (element != null) {
                    element.preventDefault();
                }
            }

            $scope.onDrop = function(element) {
                if (element != null) {
                    element.preventDefault();
                }

                var formData = new FormData();
                var validFileCount = 0;
                angular.forEach(element.dataTransfer.files, function(file, key) {
                    if (self.onUploadValidate(file)) {
                        formData.append('file', file);
                        validFileCount++;
                    }
                });

                if (validFileCount <= 0) return;

                self.onUploadStart();

                var request = $http({
                    method: 'POST',
                    url: self.getUploadUrl(),
                    data: formData,
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    }
                });

                request.then(function(response) {
                    self.onUploadCompleted(response);
                }, function(ex) {
                    self.onUploadError(ex);
                });
            }

            self.canEdit = function(file) {
                return file.DocumentModule === self.moduleId;
            };

            self.canRemove = function(file) {
                return file.DocumentModule === self.moduleId;
            };

            self.canUnlink = function(file) {
                return self.moduleId === '4' && file.DocumentModule !== self.moduleId;
            }

            self.getAllowedExtensions = function() {
                return self.allowedDocumentContentTypes.map(function(a) {
                    return a.FileExtension;
                }).join(',');
            }

            self.getAllowedMimeTypes = function() {
                return self.allowedDocumentContentTypes.map(function(a) {
                    return a.MimeType;
                }).join(',');
            }

            function getSelectedTypeAllowedMimes() {
                if (!self.selectedAttachmentType || !self.selectedAttachmentType.SupportedFileTypes) {
                    return null; // null = allow all
                }
                var mimes = [];
                self.selectedAttachmentType.SupportedFileTypes.forEach(function(fileTypeId) {
                    var mapping = fileTypeToMimeMap[fileTypeId];
                    if (mapping) {
                        mimes = mimes.concat(mapping.mimes);
                    }
                });
                return mimes.length > 0 ? mimes : null;
            }

            function getSelectedTypeAllowedExtensions() {
                if (!self.selectedAttachmentType || !self.selectedAttachmentType.SupportedFileTypes) {
                    return null; // null = allow all
                }
                var exts = [];
                self.selectedAttachmentType.SupportedFileTypes.forEach(function(fileTypeId) {
                    var mapping = fileTypeToMimeMap[fileTypeId];
                    if (mapping) {
                        exts = exts.concat(mapping.exts);
                    }
                });
                return exts.length > 0 ? exts : null;
            }

            // A link has no extension to match on — a URL is accepted only by a type that
            // declares Link. The dropdown is already filtered, so this guards a stale list.
            self.validateLinkFileType = function() {
                if (!self.selectedAttachmentType || !self.selectedAttachmentType.SupportedFileTypes) return true;
                if (acceptsLink(self.selectedAttachmentType)) return true;

                hubService.showToast('File type not allowed. ' + self.selectedAttachmentType.Name + ' does not accept links.');
                return false;
            };

            self.getEffectiveAllowedExtensions = function() {
                var typeExts = getSelectedTypeAllowedExtensions();
                if (typeExts) return typeExts.join(',');
                return self.getAllowedExtensions(); // fallback to global
            };

            self.getCurrentModule = function() {
                let deferred = $q.defer();
                self.documentService.getModuleList()
                    .then(function(resp) {
                        self.model = resp.data;
                        self.moduleData = _.find(self.model, function(mode) {
                            return _.parseInt(self.moduleId) === _.parseInt(mode.Module.Id);
                        });
                        deferred.resolve(resp.data);
                    }, function(err) {
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                        deferred.reject(err);
                    });
            };

            self.getAllowedDocumentContentTypes = function() {
                let deferred = $q.defer();
                self.documentService.getAllowedDocumentContentTypes()
                    .then(function(resp) {
                        self.allowedDocumentContentTypes = resp.data;
                        deferred.resolve(resp.data);
                    }, function(err) {
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                        deferred.reject(err);
                    });

                return deferred.promise;
            };

            self.loadFileTypeMappings = function() {
                let deferred = $q.defer();
                attachmentTypesApi.getSupportedFileTypes()
                    .then(function(resp) {
                        var fileTypes = resp.data || [];
                        fileTypes.forEach(function(ft) {
                            fileTypeToMimeMap[ft.Id] = { mimes: ft.MimeTypes || [], exts: ft.Extensions || [] };
                            if ((ft.Value || '').toLowerCase() === 'link') {
                                linkFileTypeId = ft.Id;
                            }
                        });
                        self.refreshSelectableAttachmentTypes();
                        deferred.resolve(fileTypeToMimeMap);
                    }, function(err) {
                        deferred.resolve(fileTypeToMimeMap);
                    });
                return deferred.promise;
            };

            self.getAttachmentTypes = function() {
                let deferred = $q.defer();
                attachmentTypesApi.getAttachmentTypes()
                    .then(function(resp) {
                        self.attachmentTypes = (resp.data || []).filter(function(type) {
                            return type.IsActive;
                        });
                        self.refreshSelectableAttachmentTypes();
                        deferred.resolve(self.attachmentTypes);
                    }, function(err) {
                        self.attachmentTypes = [];
                        self.refreshSelectableAttachmentTypes();
                        deferred.resolve([]);
                    });
                return deferred.promise;
            };

            function acceptsLink(type) {
                if (!type.SupportedFileTypes || !type.SupportedFileTypes.length) return true;
                return linkFileTypeId !== null &&
                    type.SupportedFileTypes.indexOf(linkFileTypeId) !== -1;
            }

            function acceptsFiles(type) {
                if (!type.SupportedFileTypes || !type.SupportedFileTypes.length) return true;
                return type.SupportedFileTypes.some(function(id) {
                    return id !== linkFileTypeId;
                });
            }

            // Held as an array rather than computed in ng-repeat: returning a new array
            // each digest triggers an infinite $digest loop.
            self.refreshSelectableAttachmentTypes = function() {
                var predicate = self.selectedUploadTab === URL_TAB_INDEX ? acceptsLink : acceptsFiles;
                self.selectableAttachmentTypes = self.attachmentTypes.filter(predicate);
            };

            self.getDocuments = function() {
                let deferred = $q.defer();
                self.documentService.getAllDocumentsForResource(self.moduleId, self.relatedResourceId)
                    .then(function(response) {
                        _.each(response.data, function(data) {
                            data.SortOrder = self.getDocumentModuleInfo(data.DocumentModule.toString()).sortOrder;
                        });
                        var documentList = _.reverse(_.sortBy(response.data, ['SortOrder', 'CreatedDate']));

                        angular.forEach(documentList, function(document, index) {
                            document.DocumentModule = document.DocumentModule.toString();
                            document.DocumentModuleName = document.RelatedResourceDescription;
                            document.DocumentType = documentService.getFileType(document.Name, document.MimeType);
                            document.DocumentFileSize = documentService.convertBytes(document.FileSize);
                            document.UploadOrigin = Object.keys(DOCUMENT_ORIGIN).find(key => DOCUMENT_ORIGIN[key] === document.Origin);
                        });

                        self.documentsList = documentList;
                        self.computeMissingAttachments();

                        deferred.resolve(self.documentsList);
                    }, function(err) {
                        self.hasError = true;
                        self.errorMessage = err.data.ErrorMessage;
                        deferred.reject(err);
                    });

                return deferred.promise;
            };

            self.includePaperworkFlagChange = function(document) {
                let isInheritedDocument = document.DocumentModule !== self.moduleId;
                self.documentService.updateIncludePaperworkFlag(document.Id, self.relatedResourceId, document.IncludeInPaperwork, isInheritedDocument);
            }

            self.getDocumentModuleInfo = function(moduleId) {
                let module = _.find(self.moduleInfos, function(module) {
                    return module.moduleId === moduleId;
                });

                return module || {};
            }

            self.getAttachmentTypeParams = function() {
                if (!self.isAttachmentTypesEnabled) return '';
                if (self.selectedAttachmentType) {
                    return "&attachmentTypeId=" + self.selectedAttachmentType.Id;
                }
                return '';
            };

            self.getAttachmentTypeName = function(attachmentTypeId) {
                if (!attachmentTypeId) return 'Others';
                var type = _.find(self.attachmentTypes, { Id: attachmentTypeId });
                return type ? type.Name : 'Others';
            };

            self.getUploadUrl = function() {
                let docName = !_.isNil(self.formData.documentName) ? self.formData.documentName : '';
                return tenantSettings.coreApiUrl + "api/documents/upload?" +
                    "moduleId=" + self.moduleId +
                    "&documentName=" + docName +
                    "&relatedResourceId=" + self.relatedResourceId +
                    "&origin=" + DOCUMENT_ORIGIN.Web +
                    self.getAttachmentTypeParams();
            };

            self.getUploadLinkUrl = function() {
                return tenantSettings.coreApiUrl + "api/documents/uploadlink?" +
                    "moduleId=" + self.moduleId +
                    "&documentName=" + self.formData.documentName +
                    "&documentUrl=" + self.formData.documentUrl +
                    "&relatedResourceId=" + self.relatedResourceId+
                    "&origin=" + DOCUMENT_ORIGIN.Web +
                    self.getAttachmentTypeParams();
            };

            self.getUploadGoogleDriveUrl = function(module, documentName, relatedResourceId, fileUrl, mimeType, accessToken) {
                return tenantSettings.coreApiUrl + "api/documents/uploadfromgoogledrive?" +
                    "moduleId=" + module +
                    "&documentName=" + documentName +
                    "&relatedResourceId=" + relatedResourceId +
                    "&fileUrl=" + fileUrl +
                    "&mimeType=" + mimeType +
                    "&accessToken=" + accessToken +
                    "&origin=" + DOCUMENT_ORIGIN.Web +
                    self.getAttachmentTypeParams();
            };

            self.getUploadOneDriveUrl = function(module, documentName, relatedResourceId, fileUrl, mimeType) {
                return tenantSettings.coreApiUrl + "api/documents/uploadfromonedrive?" +
                    "moduleId=" + module +
                    "&documentName=" + documentName +
                    "&relatedResourceId=" + relatedResourceId +
                    "&fileUrl=" + fileUrl +
                    "&mimeType=" + mimeType +
                    "&origin=" + DOCUMENT_ORIGIN.Web +
                    self.getAttachmentTypeParams();
            };

            self.onUploadStart = function(fileObj) {
                self.showUploadProgress = true;
            };

            self.onUploadValidate = function(file) {
                if (!self.isAttachmentTypesEnabled) return true;
                var allowedMimes = getSelectedTypeAllowedMimes();
                if (!allowedMimes) return true; // "Others" or no restriction

                var fileName = (file.name || '').toLowerCase();
                var fileType = (file.type || '').toLowerCase();

                // Check MIME type
                if (fileType && allowedMimes.indexOf(fileType) !== -1) return true;

                // Fallback: check file extension
                var allowedExts = getSelectedTypeAllowedExtensions();
                if (allowedExts) {
                    for (var i = 0; i < allowedExts.length; i++) {
                        if (fileName.indexOf(allowedExts[i]) === fileName.length - allowedExts[i].length) return true;
                    }
                }

                // Show error
                var typeNames = self.selectedAttachmentType.SupportedFileTypes.map(function(id) {
                    var mapping = fileTypeToMimeMap[id];
                    return mapping && mapping.exts.length ? mapping.exts[0].replace('.', '').toUpperCase() : '';
                }).filter(Boolean).join(', ');

                hubService.showToast('File type not allowed. ' + self.selectedAttachmentType.Name + ' only supports: ' + typeNames);
                return false;
            };

            self.onUploadCompleted = function(ex) {
                self.showUploadProgress = false;
                self.isUploadDocumentHidden = false;
                self.formData = [];
                self.selectedAttachmentType = null;
                self.selectedUploadTab = 0;

                let hasError = !_.isNil(ex.data) && !_.isNil(ex.data.Message) && !_.isEmpty(ex.data.Message);
                if (hasError) {
                    self.onUploadError(ex);
                }

                if ($scope.form.uploadDocumentsForm) {
                    $scope.form.uploadDocumentsForm.$setPristine();
                    $scope.form.uploadDocumentsForm.$setUntouched();
                }

                blockUI.start();
                $q.all(self.getDocuments())
                    .then(
                        function(results) {
                            blockUI.stop();
                            if (!hasError)
                                hubService.showToast(utils.translate('WIDGETS_LOC.DOCUMENT_MANAGER.UPLOAD_SUCCESSFUL_MESSAGE'));
                        },
                        function(errors) {
                            blockUI.stop();
                        },
                        function(updates) {

                        });
            };

            self.onUploadError = function(ex) {
                exceptionService.resolve(ex);
            };

            self.removeDocument = function(documentId) {
                blockUI.start();
                self.documentService.removeDocument(documentId)
                    .then(function(resp) {
                        hubService.showToast(utils.translate('WIDGETS_LOC.DOCUMENT_MANAGER.DELETE_SUCCESSFUL_MESSAGE'));
                        self.getDocuments();
                        blockUI.stop();
                    }, function(err) {
                        exceptionService.resolve(err);
                        blockUI.stop();
                    });
            };

            self.unlinkDocument = function(ticketId, documentId) {
                blockUI.start();
                self.documentService.unlinkDocument(ticketId, documentId)
                    .then(function(resp) {
                        self.excludedDocuments.add(documentId);
                        hubService.showToast(utils.translate('DOCUMENT_MANAGER.UNLINK_SUCCESSFUL_MESSAGE'));
                        self.getDocuments();
                        blockUI.stop();
                    }, function(err) {
                        exceptionService.resolve(err);
                        blockUI.stop();
                    });
            };

            self.editDocument = function(documentId, documentName, attachmentTypeId) {
                self.documentToEdit = documentId;
                self.formData.EditName = documentName;
                self.editAttachmentTypeId = attachmentTypeId || null;
                self.fileNameError = '';
            };

            self.isEdit = function(documentId) {
                return self.documentToEdit === documentId;
            };

            self.saveAttachmentType = function(file) {
                if ((self.editAttachmentTypeId || null) === (file.AttachmentTypeId || null)) {
                    return;
                }

                file.AttachmentTypeId = self.editAttachmentTypeId;

                self.documentService.updateDocument(file.Id, file.Name, self.editAttachmentTypeId)
                    .then(function() {
                        self.documentToEdit = undefined;
                        self.formData.EditName = '';
                        self.getDocuments();
                    }, function(err) {
                        self.onUploadError(err);
                    });
            };

            self.onAuthApiLoad = function() {
                gapi.auth2.init({
                    client_id: googleApiClientId
                }).then(function(googleAuth) {
                    googleAuth.signIn({
                        scope: googleDriveScope
                    }).then(function(result) {
                        self.handleAuthResult(result.getAuthResponse());
                    })
                })
            }

            self.onPickerApiLoad = function() {
                self.pickerApiLoaded = true;
            }

            self.handleAuthResult = function(authResult) {
                if (authResult && !authResult.error) {
                    self.oauthToken = authResult.access_token;
                    self.createPicker();
                }
            }

            // Create and render a Picker object for picking from Google Photos.
            self.createPicker = function() {
                if (self.pickerApiLoaded && self.oauthToken) {
                    self.picker = new google.picker.PickerBuilder().
                    addView(new google.picker.View(google.picker.ViewId.DOCS)).
                    setOAuthToken(self.oauthToken).
                    setDeveloperKey(googleApiKey).
                    setCallback(self.googlePickerCallback).
                    build();
                    self.picker.setVisible(true);
                }
            }

            // A simple callback implementation.
            self.googlePickerCallback = function(data) {
                if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
                    self.picker.setVisible(false);
                    let document = data[google.picker.Response.DOCUMENTS][0];
                    let accessToken = gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().access_token;

                    let fileUrl = `${googleDriveApiUrl}files/${document.id}?alt=media&source=downloadUrl`;

                    let request = $http({
                        method: 'POST',
                        url: self.getUploadGoogleDriveUrl(self.moduleId, document.name, self.relatedResourceId, encodeURIComponent(fileUrl), document.mimeType, accessToken),
                    });

                    self.showUploadProgress = true;

                    request.then(function(response) {
                        if (response.data.ErrorMessages && response.data.ErrorMessages.length > 0) {
                            var ex = {
                                data: {}
                            };

                            ex.data.Message = _.join(response.data.ErrorMessages, "<br/>");
                            self.onUploadError(ex);
                        }

                        self.getDocuments();
                        self.showUploadProgress = false;
                    }, function(ex) {
                        self.onUploadError(ex);
                        self.showUploadProgress = false;
                    });
                }
            }

            self.saveGoogleDriveDocument = function() {
                gapi.load('auth2', self.onAuthApiLoad);
                gapi.load('picker', self.onPickerApiLoad);
            }

            self.saveOneDriveDocument = function() {
                var redirectUri = window.location.origin + oneDriveRedirectPath;
                var odOptions = {
                    clientId: claimsUtilService.getOneDriveClientId(),
                    action: 'download',
                    multiSelect: true,
                    advanced: {
                        queryParameters: 'select=id,name,size,file,webUrl,@content.downloadUrl',
                        redirectUri: redirectUri,
                        endpointHint: oneDriveEndpointHint
                    },
                    success: self.oneDrivePickerCallback
                }
                OneDrive.open(odOptions);
            }

            self.oneDrivePickerCallback = function(result) {
                console.log(result);
                if (result.value.length === 0)
                    return;

                let file = result.value[0];
                let fileUrl = file['@content.downloadUrl'];
                let fileMetadata = file.file;

                let request = $http({
                    method: 'POST',
                    url: self.getUploadOneDriveUrl(self.moduleId, file.name, self.relatedResourceId, encodeURIComponent(fileUrl), fileMetadata.mimeType),
                });

                self.showOneDriveUploadProgress = true;

                request.then(function(response) {
                    if (response.data.ErrorMessages && response.data.ErrorMessages.length > 0) {
                        var ex = {
                            data: {}
                        };

                        ex.data.Message = _.join(response.data.ErrorMessages, "<br/>");
                        self.onUploadError(ex);
                    }

                    self.getDocuments();
                    self.showOneDriveUploadProgress = false;
                }, function(ex) {
                    self.onUploadError(ex);
                    self.showOneDriveUploadProgress = false;
                });
            }

            self.saveDocumentLink = function() {
                if (!self.validateLinkFileType()) return;

                var request = $http({
                    method: 'POST',
                    url: self.getUploadLinkUrl(),
                });

                self.fileNameError = '';
                self.showUploadProgress = true;

                request.then(function (response) {
                    if (response.data.ErrorMessages) {
                        var ex = {
                            data: {}
                        };

                        ex.data.Message = _.join(response.data.ErrorMessages, "<br/>");
                        self.onUploadError(ex);
                    }

                    self.getDocuments();
                    self.showUploadProgress = false;
                }, function (ex) {
                    self.onUploadError(ex);
                    self.showUploadProgress = false;
                });
            }

            self.saveDocument = function(originalName) {
                if (self._keepEditMode) {
                    self._keepEditMode = false;
                    return;
                }

                if (originalName === self.formData.EditName) {
                    self.documentToEdit = undefined;
                    self.formData.EditName = '';
                    self.updatingDocument = false;
                    return;
                }

                if (!self.formData.EditName || self.formData.EditName.length > FILENAME_LENGTH_LIMIT) {
                    self.fileNameError = `Enter a filename less than ${FILENAME_LENGTH_LIMIT} characters and must not contain any of the following \ / : * ? " < > |`;
                    self.updatingDocument = false;
                    return;
                }

                self.updatingDocument = true;
                self.documentService.updateDocument(self.documentToEdit, self.formData.EditName, self.editAttachmentTypeId)
                    .then(function(resp) {
                        self.documentToEdit = undefined;
                        self.formData.EditName = '';
                        self.getDocuments();
                        self.updatingDocument = false;
                    }, function(err) {
                        self.updatingDocument = false;
                        self.onUploadError(err);
                    });
            };

            self.isOwner = function(createdBy) {
                return createdBy === identityService.userData.ContactId;
            };

            self.closeModal = function() {
                $mdDialog.hide();
            };

            self.documentPointsToUrl = function(mimeType) {
                return mimeType === 'application/url';
            }

            self.displayDocument = function(url, mimeType) {
                let embed = self.isImage(mimeType) ? '<img src="' + url + '">' : '<iframe src="http://docs.google.com/gview?url=' + url + '&embedded=true"></iframe>';

                if (!self.documentPointsToUrl(mimeType)) {
                    let popup = window.open();
                    popup.document.write(embed);
                } else {
                    window.open(url);
                }
            };

            self.onUploadButtonClicked = function() {
                angular.element('#uploadDocument').trigger('click');
            }

            self.addAttachment = function() {
                $mdDialog.show({
                    scope: $scope,
                    preserveScope: true,
                    template: '<document-manager class="document-manager"' +
                        ' module-id=' + self.moduleId +
                        ' module-name=' + self.moduleName +
                        ' related-resource-id=' + self.relatedResourceId +
                        ' modal=true></document-manager>',
                    multiple: true
                }).then(function(result) {
                    self.getDocuments();
                });
            }

            self.missingAttachmentsMessage = '';

            self.computeMissingAttachments = function() {
                if (!self.isAttachmentTypesEnabled || !self.requiredAttachmentTypes || !self.requiredAttachmentTypes.length || !self.documentsList) {
                    self.missingAttachmentsMessage = '';
                    return;
                }

                var missing = [];
                self.requiredAttachmentTypes.forEach(function(req) {
                    var uploaded = self.documentsList.filter(function(doc) {
                        return doc.AttachmentTypeId === req.AttachmentTypeId;
                    }).length;
                    var deficit = req.Quantity - uploaded;
                    if (deficit > 0) {
                        var name = req.AttachmentTypeName || self.getAttachmentTypeName(req.AttachmentTypeId);
                        missing.push(deficit + ' ' + name);
                    }
                });

                self.missingAttachmentsMessage = missing.length > 0 ? 'Missing ' + missing.join(', ') : '';
            };

            self.init = function() {
                let uris = [self.getAllowedDocumentContentTypes(), self.getDocuments(), self.getCurrentModule()];
                if (self.isAttachmentTypesEnabled) {
                    uris.push(self.getAttachmentTypes(), self.loadFileTypeMappings());
                }
                $q.all(uris)
                    .then(
                        function(results) {
                            self.isLoading = false;
                            self.computeMissingAttachments();
                        },
                        function(errors) {
                            self.isLoading = false;
                        },
                        function(updates) {});
            }

            self.isImage = function(type) {
                return _.startsWith(type, 'image');
            }

            self.hasFileNameError = function () {
                return self.fileNameError;
            }

            $scope.$watchCollection('vm.requiredAttachmentTypes', function(newVal) {
                if (newVal && newVal.length) {
                    self.computeMissingAttachments();
                }
            });

            $scope.$watch('vm.selectedUploadTab', function(newVal, oldVal) {
                if (newVal === oldVal) return;

                // A type valid on the previous tab may not be offered on this one, and a
                // stale selection would post an attachmentTypeId the API rejects.
                self.selectedAttachmentType = null;
                self.refreshSelectableAttachmentTypes();
            });

            self.init();
        }

        function link(scope, element, attrs, component) {
            element.bind('dragover', scope.onDragOver);
            element.bind('dragenter', scope.onDragEnter);
            element.bind('drop', scope.onDrop);
        }
    }
})();

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('dimmer', dimmer);

  function dimmer() {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs){
        scope.$watch(attrs.ngModel, function(value){
          if(value){
            element.css({"opacity" : "0.5"});
          }else{
            element.css({"opacity" : "1"});
          }
        });
      }
    };

    return directive;
  }
})();

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('deleteComponent', deleteComponent);

  function deleteComponent($mdDialog, utils) {
    var directive = {
      restrict: 'E',
      // templateUrl: 'app/shared/widgets/deleteComponent/delete.component.html',
      templateUrl : function(elem, attr) {
        if(attr.for == 'ratecard'){
          return 'app/main/ratecard/builder/directives/DeleteComponent/delete.component.html';
        }
        else{
          return 'app/shared/widgets/deleteComponent/delete.component.html';
        }
      },
      scope:{
        index : '=',
        section : '@',
        message : '@',
        toolTip : '@',
        callback : '&',
        candelete :'='
      },
      link: linkFunc
    };

    return directive;

    function linkFunc(scope){
      scope.removeItem = removeItem;
      function removeItem(){
        var confirm = $mdDialog.confirm()
          .title(scope.section)
          .multiple(true)
          .textContent(scope.message)
          .ok(utils.translate('WIDGETS_LOC.DELETE_YES'))
          .cancel(utils.translate('WIDGETS_LOC.DELETE_NO'));
        $mdDialog.show(confirm).then(function() {
          (scope.callback() || angular.noop)(scope.index);
        });
      }
    }
  }
})();

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('customMultiSelect', customMultiSelect);

  function customMultiSelect(_) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/shared/widgets/customMultiselect/customMultiselect.html',
      scope: {
        ngModel : '=',
        label : '@', //label
        name : '@',
        options : '=',
        disabled :'@',
        display : '@',
        required : '@',
        limit : '@',
        data : '@' // 'full' to return entire object, '<Specific_Property>' to return specific property value
      },
      controller : controller,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function controller($scope, $timeout){
        var vm = this;
        vm.isFullObject = vm.data === "full" ? true : false;
        vm.isRequired = vm.required === "true" ? true : false;
        vm.isDisabled = vm.disabled === "true" ? true : false;
        vm.selectAll = false;
        vm.limitDisplay = !_.isNaN(parseInt(vm.limit)) ? parseInt(vm.limit) : null;

        vm.changeSelectOption = changeSelectOption;
        vm.formatDisplay = formatDisplay;

        function formatDisplay(){
            if(!_.isNil(vm.ngModel)){
                return (vm.ngModel.length > 0) ? format() : vm.label;
            }
            return vm.label;
        }

        function format(){
            return vm.isFullObject ? formatFullObject(vm.ngModel, vm.display) : formatObjectProp(vm.options, vm.ngModel, vm.display, vm.data);
        }

        function formatFullObject(model, display){
            return limit(model.map(function(model){
                return model[display];
            }).sort());
        }

        function formatObjectProp(options, model, display, data){
            return limit(_.filter(options, function(option){
                return _.find(model, function(m){
                    return m === option[data];
                });
            }).map(function(opt){
                return opt[display];
            }).sort());
        }

        function limit(model){
            //Limits number of items to be displayed if 'limit' attribute is present
            if(!_.isNil(vm.limitDisplay)){
                return limitDisplayNow(model);
            }else{
                return doNotLimitDisplay(model);
            }
        }

        function limitDisplayNow(model){
            if(model.length < vm.limitDisplay){
                return doNotLimitDisplay(model);
            }else{
                let partial = model.slice(0, vm.limitDisplay);
                let remaining = model.length - vm.limitDisplay;
                return remaining === 0 ? partial.join(", ") : partial.join(", ") + " + " + remaining + " more";
            }
        }

        function doNotLimitDisplay(model){
            return model.join(", ");
        }

        function changeSelectOption(){
            vm.selectAll = !vm.selectAll;
            vm.ngModel = (vm.selectAll) ? (vm.isFullObject) ? vm.options : mapObj(vm.options, vm.data) : []
        }

        function mapObj(options, data){
            return options.map(function(model){
                return model[data];
            });
        }

        $timeout(function(){
            $scope.$watch('vm.ngModel', watch);
        });

        function watch(){
            //if model is same as options in terms of length, the selectAll must be true
            vm.selectAll = (vm.ngModel.length === vm.options.length) ? true : false;
        }
    }
  }
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .directive('contactPreferenceComponent2', contactPreferenceComponent);

    /** @ngInject */
    function contactPreferenceComponent(
        $mdDialog,
        $timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/contactPreference2/contact-preference.html',
            scope: {
                ngModel: '=',
                contactList: '=',
                name: '@',
                companyId: '@'
            },
            controller: contactPreferenceComponentController,
            controllerAs: 'contactPreferenceVm',
            bindToController: true
        };

        return directive;

        function contactPreferenceComponentController(contactService) {
            var vm = this;
            vm.sortType = 'id';
            vm.contactService = contactService;
            vm.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                sort: false
            };

            vm.onAddContact = addPreferedContact;
            vm.onEdit = onEdit;
            vm.remove = remove;

            function remove(index) {
                vm.ngModel.splice(index, 1);
            }

            function addPreferedContact() {
                let data = formatContacts(vm.contactList, null);
                showDialog(data, null);
            }

            function formatContacts(dataLookup, exceptForId) {
                angular.forEach(vm.ngModel, function(itmSelected) {
                    _.remove(dataLookup, function(item) {
                        if (exceptForId && item.Id == exceptForId) {
                            return false;
                        } else {
                            return item.id == itmSelected.ContactBasic.id;
                        }
                    });
                }, this);

                dataLookup = _.map(dataLookup, function(itm) {
                    return {
                        FullName: itm.FirstName + ' ' + itm.LastName,
                        FirstName: itm.FirstName,
                        ImageUrl: itm.ImageUrl,
                        LastName: itm.LastName,
                        MiddleName: itm.MiddleName,
                        id: itm.id,
                    }
                });

                return dataLookup;
            }

            function onEdit(id) {
                let data = formatContacts(vm.contactList, id);
                showDialog(data, id);
            }

            function showDialog(data, id) {
                $timeout(function() {
                    var locals = {};
                    if (id) {
                        var toEdit = _.filter(vm.ngModel, function(o) {
                            return o.ContactBasic.id == id;
                        })[0];

                        locals.contactList = data;
                        locals.dataToEdit = toEdit;
                    } else {
                        locals.contactList = data;
                    }

                    $mdDialog.show({
                            parent: angular.element(document.body),
                            templateUrl: 'app/shared/widgets/contactPreference/contact-preference-dialog.html',
                            controller: 'ContactPreferenceDialogController as contactPreferenceDialogVm',
                            locals: locals
                        })
                        .then(function(result) {
                            if (result) {
                                if (result.oldValue) {
                                    _.remove(vm.ngModel, function(item) {
                                        return item.ContactBasic.id == result.oldValue;
                                    });
                                }

                                vm.ngModel.push(result);
                            }
                        }, function() {
                            // cancel
                        });
                });
            }

        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.assets')
        .controller('ContactPreferenceDialogController', ContactPreferenceDialogController);

    /** @ngInject */
    function ContactPreferenceDialogController($mdDialog, locals, _, utils, msgboxService) {

        var vm = this;
        vm.selectedContact = null;
        vm.IsPreferred = false;
        vm.buttonText = utils.translate('WIDGETS_LOC.CONTACT_PREFERENCE_DIALOG_HEADER_ADD');
        vm.searchText = null;
        vm.contactList = [];
        vm.isEditMode = false;

        vm.contactList = angular.copy(locals.contactList);

        vm.onAdd = onAdd;
        vm.onCancel = onCancel;
        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.contactNotAvailableDialog = contactNotAvailableDialog;

        activate();

        function activate() {
            if (locals.dataToEdit) {
                vm.isEditMode = true;
                vm.buttonText = utils.translate('WIDGETS_LOC.CONTACT_PREFERENCE_DIALOG_HEADER_EDIT');
                vm.selectedContact = locals.dataToEdit.FullName;
                vm.IsPreferred = locals.dataToEdit.IsPreferred ? "true" : "false";
            }
        }

        function onAdd() {
            if(_.isNil(vm.selectedContact)){
                vm.contactNotAvailableDialog();
            }else{
                if (!vm.isEditMode) {
                    $mdDialog.hide({
                        ContactBasic: vm.selectedContact,
                        IsPreferred: vm.IsPreferred === "true" ? true : false,
                        FullName: vm.selectedContact.FirstName + ' ' + vm.selectedContact.LastName
                    });
                } else {
                    $mdDialog.hide({
                        ContactBasic: locals.dataToEdit.ContactBasic,
                        IsPreferred: vm.IsPreferred === "true" ? true : false,
                        FullName: locals.dataToEdit.FullName,
                        oldValue: locals.dataToEdit.ContactBasic.id
                    });
                }
            }
        }

        function contactNotAvailableDialog(){
            return msgboxService.alert("Contact Preference", "Contact does not exist", "Okay").then(function(){
                vm.selectedContact = null;
                vm.searchText = null;
                return;
            });
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function querySearch(query) {
            if(!_.isNil(query)){
                var results = query ? vm.contactList.filter(createFilterFor(query)) : vm.contactList;
                return results;
            }
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(emp) {
                return (_.lowerCase(emp.FullName).indexOf(lowercaseQuery) > -1);
            };
        }

        function selectedItemChange(item) {
            var id = item ? item.id : null;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.assets')
        .directive('contactPreferenceComponent', contactPreferenceComponent);

    /** @ngInject */
    function contactPreferenceComponent(
        $mdDialog,
        $timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/contactPreference/contact-preference.html',
            scope: {
                ngModel: '=',
                contactList: '=',
                name: '@',
                companyId: '@'
            },
            controller: contactPreferenceComponentController,
            controllerAs: 'contactPreferenceVm',
            bindToController: true
        };

        return directive;

        function contactPreferenceComponentController(contactService) {
            var vm = this;
            vm.sortType = 'id';
            vm.contactService = contactService;
            vm.dtOptions = {
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                sort: false
            };

            vm.onAddContact = addPreferedContact;
            vm.onEdit = onEdit;
            vm.remove = remove;

            function remove(index) {
                vm.ngModel.splice(index, 1);
            }

            function addPreferedContact() {
                let data = formatContacts(vm.contactList, null);
                showDialog(data, null);
            }

            function formatContacts(dataLookup, exceptForId) {
                angular.forEach(vm.ngModel, function(itmSelected) {
                    _.remove(dataLookup, function(item) {
                        if (exceptForId && item.Id == exceptForId) {
                            return false;
                        } else {
                            return item.id == itmSelected.ContactBasic.id;
                        }
                    });
                }, this);

                dataLookup = _.map(dataLookup, function(itm) {
                    return {
                        FullName: itm.FirstName + ' ' + itm.LastName,
                        FirstName: itm.FirstName,
                        ImageUrl: itm.ImageUrl,
                        LastName: itm.LastName,
                        MiddleName: itm.MiddleName,
                        id: itm.id,
                    }
                });

                return dataLookup;
            }

            function onEdit(id) {
                let data = formatContacts(vm.contactList, id);
                showDialog(data, id);
            }

            function showDialog(data, id) {
                $timeout(function() {
                    var locals = {};
                    if (id) {
                        var toEdit = _.filter(vm.ngModel, function(o) {
                            return o.ContactBasic.id == id;
                        })[0];

                        locals.contactList = data;
                        locals.dataToEdit = toEdit;
                    } else {
                        locals.contactList = data;
                    }

                    $mdDialog.show({
                            parent: angular.element(document.body),
                            templateUrl: 'app/shared/widgets/contactPreference/contact-preference-dialog.html',
                            controller: 'ContactPreferenceDialogController as contactPreferenceDialogVm',
                            locals: locals
                        })
                        .then(function(result) {

                            if (result) {
                                if (result.oldValue) {
                                    _.remove(vm.ngModel, function(item) {
                                        return item.ContactBasic.id == result.oldValue;
                                    });
                                }

                                vm.ngModel.push(result);
                            }
                        }, function() {
                            // cancel
                        });
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.assets')
        .controller('ContactPreferenceDialogController', ContactPreferenceDialogController);

    /** @ngInject */
    function ContactPreferenceDialogController($mdDialog, locals, _, utils, msgboxService) {

        var vm = this;
        vm.selectedContact = null;
        vm.IsPreferred = false;
        vm.buttonText = "Save";
        vm.searchText = null;
        vm.contactList = [];
        vm.isEditMode = false;

        vm.contactList = angular.copy(locals.contactList);

        vm.onAdd = onAdd;
        vm.onCancel = onCancel;
        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.contactNotAvailableDialog = contactNotAvailableDialog;

        activate();

        function activate() {
            if (locals.dataToEdit) {
                vm.isEditMode = true;
                vm.buttonText = "Save";
                vm.selectedContact = locals.dataToEdit.FullName;
                vm.IsPreferred = locals.dataToEdit.IsPreferred ? "true" : "false";
            }
        }

        function onAdd() {
            if (_.isNil(vm.selectedContact)) {
                vm.contactNotAvailableDialog();
            } else {
                if (!vm.isEditMode) {
                    $mdDialog.hide({
                        ContactBasic: vm.selectedContact,
                        IsPreferred: vm.IsPreferred === "true" ? true : false,
                        FullName: vm.selectedContact.FirstName + ' ' + vm.selectedContact.LastName
                    });
                } else {
                    $mdDialog.hide({
                        ContactBasic: locals.dataToEdit.ContactBasic,
                        IsPreferred: vm.IsPreferred === "true" ? true : false,
                        FullName: locals.dataToEdit.FullName,
                        oldValue: locals.dataToEdit.ContactBasic.id
                    });
                }
            }
        }

        function contactNotAvailableDialog() {
            return msgboxService.alert("Contact Preference", "Contact does not exist", "Okay").then(function () {
                vm.selectedContact = null;
                vm.searchText = null;
                return;
            });
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function querySearch(query) {
            if (!_.isNil(query)) {
                var results = query ? vm.contactList.filter(createFilterFor(query)) : vm.contactList;
                return results;
            }
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(emp) {
                return (_.lowerCase(emp.FullName).indexOf(lowercaseQuery) > -1);
            };
        }

        function selectedItemChange(item) {
            var id = item ? item.id : null;
        }
    }
})();

/**
 * Created by queeniejgm on 05/25/2018.
 */
(function () {
    'use strict';
    angular.module('app.widgets')
        .directive('conditionContentComponent', conditionContentComponent);

    /** @ngInject */
    function conditionContentComponent(identityService) {
        let directive = {
            restrict: 'E',
            scope: {
                datasrc: '=',
                datacount: '@',
                allowanceType: '='
            },
            templateUrl: 'app/shared/widgets/conditionComponent/conditionContentComponent.directive.html',
            controller: ConditionContentComponentController,
            controllerAs: 'conditionContentComponent',
            bindToController: true,
            link: link
        };

        return directive;

        function ConditionContentComponentController($rootScope, $scope, $element, $attrs, inputVariables, allowanceTypes) {
            let self = this;

            $scope.init = function() {
                self.lookups = $scope.$parent.conditionComponent.conditionLookups;

                self.lookupsOperator = $scope.$parent.conditionComponent.conditionOperators;
                self.conditionSubLookup = [];

                if (_.isNil($scope.conditionContentComponent.datasrc)) {
                    $scope.conditionContentComponent.datasrc = [];
                }

                self.cnt = parseInt($attrs.datacount);
                if (_.isNil($scope.conditionContentComponent.datasrc[self.cnt])) {
                    $scope.conditionContentComponent.datasrc[self.cnt] = {};
                    $scope.conditionContentComponent.datasrc[self.cnt].dayOfWeekSelection = [];
                } else {
                    self.datasrc[self.cnt].dayOfWeekSelection = $scope.conditionContentComponent.datasrc[self.cnt].ConditionDays;
                    self.onChangeConditionType($scope.conditionContentComponent.datasrc[self.cnt].ConditionType, true);
                }
                $scope.conditionContentComponent.datasrc[self.cnt].ConditionOrder = self.cnt;
            };

            self.filterInputVariables = function(inputVariable) {
                let allowedInputVariables = [];
                if ($scope.conditionContentComponent.allowanceType == allowanceTypes.PerShift)
                {
                    allowedInputVariables = [
                        inputVariables.TotalShiftHours,
                        inputVariables.TravelToDistance,
                        inputVariables.TravelDuringDistance,
                        inputVariables.TravelFromDistance,
                        inputVariables.TravelToDuringFromDistance
                    ]
                    return allowedInputVariables.includes(parseInt(inputVariable.Id));
                }

                if ($scope.conditionContentComponent.allowanceType == allowanceTypes.PerHour)
                {
                    allowedInputVariables = [inputVariables.TotalShiftHours]
                    return allowedInputVariables.includes(parseInt(inputVariable.Id));
                }
                
                return true;
            }

            self.getFormName = function(inputName, index) {
                return inputName + "-" + index;
            };

            self.onChangeConditionType = function(conditionTypeId, isExplicit){
                if (!isExplicit) {
                    initValue();
                }

                let condType = (_.find(self.lookups, function(lookup) {
                    return parseInt(lookup.ConditionType.Tag) === parseInt(conditionTypeId);
                }));

                conditionTypeId = condType.ConditionType.Id;

                self.conditionSubLookup = _.find(self.lookups, function(lookup){
                    return parseInt(lookup.ConditionType.Id) === parseInt(conditionTypeId);
                });
                resetValue();

                conditionTypeId = parseInt(conditionTypeId);
                switch (conditionTypeId) {
                    case 1:
                        self.showDayOfWeek = true;
                        break;
                    case 2:
                        self.showJobStartTime = true;
                        break;
                    case 3:
                        self.showShiftHoursWorked = true;
                        break;
                    case 4:
                        self.showDecimalValue = true;
                        break;
                    case 5:
                        self.showStringValue = true;
                        break;
                    case 6:
                        self.showTimeOfDay = true;
                        break;
                    default:
                }
            };

            self.isLookupEmpty = function(lookup) {
              return _.isEmpty(lookup) || _.isNil(lookup);
            };

            self.isDecimalValue = function() {
                return self.showDecimalValue;
            };

            self.isStringValue = function() {
                return self.showStringValue;
            };

            self.isDayOfWeek = function() {
                return self.showDayOfWeek;
            };

            self.isTimeOfDay = function() {
                return self.showTimeOfDay;
            };

            self.isShiftHoursWorked = function() {
                return self.showShiftHoursWorked;
            };

            self.isJobStartTime = function() {
                return self.showJobStartTime;
            };

            self.hasOperator = function() {
                return self.cnt >= 1;
            };

            self.displayMoved = function(e) {
                if (self.cnt > parseInt($scope.$parent.conditionComponent.lastPosition)) {
                    self.datasrc.splice((self.cnt + 1), 1);
                } else {
                    self.datasrc.splice(self.cnt, 1);
                }
                $rootScope.$broadcast("conditionReordered");
            };

            self.toggleDayOfWeekSelection = function(dayId) {
                let idx = self.datasrc[self.datacount].dayOfWeekSelection.indexOf(dayId);

                if (idx > -1) {
                    self.datasrc[self.datacount].dayOfWeekSelection.splice(idx, 1);
                }
                else {
                    self.datasrc[self.datacount].dayOfWeekSelection.push(dayId);
                }
            };

            self.selectAllDayOfWeek = function() {
                if (!self.checkedAllDayOfWeek()) {
                    self.datasrc[self.datacount].dayOfWeekSelection = [];
                    _.map(self.conditionSubLookup.ConditionDays, function (day) {
                        self.datasrc[self.datacount].dayOfWeekSelection.push(day.Id);
                    });
                } else if (!_.isEmpty(self.datasrc[self.datacount].dayOfWeekSelection)) {
                    self.datasrc[self.datacount].dayOfWeekSelection = [];
                }
            };

            self.checkedAllDayOfWeek = function() {
                return _.size(self.datasrc[self.datacount].dayOfWeekSelection) === _.size(self.conditionSubLookup.ConditionDays);
            };

            self.isDayOfWeekChecked = function(dayId) {
                return !_.isNil(_.find(self.datasrc[self.datacount].dayOfWeekSelection, function(day) { return parseInt(day) === parseInt(dayId) }));
            };

            self.hasDayOfWeekChecked = function() {
                return !_.isNil(self.datasrc[self.datacount].dayOfWeekSelection) && !_.isEmpty(self.datasrc[self.datacount].dayOfWeekSelection);
            };

            self.isConditionNameHidden = function() {
              return $scope.$parent.conditionComponent.conditionNameHidden;
            };

            $scope.$on("conditionReordered",function () {
                self.datasrc[self.datacount].ConditionOrder = parseInt(self.datacount);
                self.onChangeConditionType(self.datasrc[self.datacount].ConditionType, true);
            });

            $scope.collapseAll = function(data) {
                data.expanded = !data.expanded;
            };

            function resetValue() {
                self.showDecimalValue = false;
                self.showStringValue = false;
                self.showDayOfWeek = false;
                self.showTimeOfDay = false;
                self.showShiftHoursWorked = false;
                self.showJobStartTime = false;
            }

            function initValue() {
                self.datasrc[self.datacount].ConditionDays = [];
                self.datasrc[self.datacount].ConditionDecimalValue = null;
                self.datasrc[self.datacount].ConditionJobEndTime = null;
                self.datasrc[self.datacount].ConditionJobStartTime = null;
                self.datasrc[self.datacount].dayOfWeekSelection = [];
            }
        }

        function link(scope, element, attrs, component) {
            scope.init();
        }
    }
})();

/**
 * Created by queeniejgm on 05/25/2018.
 */
(function () {
    'use strict';
    angular.module('app.widgets')
        .directive('conditionComponent', conditionComponent);

    /** @ngInject */
    function conditionComponent($compile) {
        let directive = {
            restrict: 'E',
            scope: {
                conditionSrc: '=',
                conditionLookups: '=',
                conditionOperators: '=',
                conditionNameHidden: '=',
                allowanceType: '='
            },
            templateUrl: 'app/shared/widgets/conditionComponent/conditionComponent.directive.html',
            controller: ConditionComponentController,
            controllerAs: 'conditionComponent',
            bindToController: true,
            link: link
        };

        return directive;

        function ConditionComponentController($scope, $element) {
            let self = this;
            let tempCounter = 0;
            $scope.selected = [];

            $scope.addTemplate = function () {
                let divElement = angular.element(document.querySelector('#condition-component-div'));

                 let appendElement = `
                    <condition-content-component 
                        layout-margin 
                        flex 
                        allowance-type="conditionComponent.allowanceType" 
                        datasrc="conditionSrc" 
                        datacount="${tempCounter}">
                    </condition-content-component>`;
                    
                let appendHtml = $compile(appendElement)($scope);

                divElement.append(appendHtml);
                tempCounter++;
            };

            self.hasCondition = function() {
                return !_.isEmpty($scope.conditionComponent.conditionSrc) && !_.isNil($scope.conditionComponent.conditionSrc);
            };

            $scope.dragoverCallback = function(index, external, type, callback) {
                self.lastPosition = index;
                return index < 10;
            };
        }

        function link(scope, element, attrs, component) {
            scope.conditionSrc = scope.$parent.conditionsArray;
            scope.$watch('conditionSrc', function(newValue, oldValue) {
                scope.$parent.conditionsArray = newValue;
            });

            _.forEach(scope.conditionSrc, function() {
                scope.addTemplate();
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.widgets')
        .controller('composedEmailTemplateDialogController', composedEmailTemplateDialogController);

    function composedEmailTemplateDialogController(relatedIds, jobsApi, $mdDialog, blockUI) {
        var vm = this;
        vm.template = null;
        vm.relatedIds = relatedIds
        vm.onSendClick = onSendClick;
        vm.onDeleteClick = onDeleteClick;

        composeEmail();

        function composeEmail() {
            jobsApi.composeEmail(vm.relatedIds)
                .then(function(resp) {
                    vm.template = resp.data;
                    vm.template.EmailTo = resp.data.To.join();
                }, function(resp) {
                    let confirm = $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .htmlContent(resp.data.ExceptionMessage)
                        .title('Unable to get Business details')
                        .ok('Close');

                    $mdDialog.show(confirm);
                });
        };

        function onSendClick() {
            if (vm.template.To) {
                vm.template.To = vm.template.EmailTo.replace(' ', '').split(',');
            }

            if (vm.template.Cc) {
                vm.template.Cc = vm.template.Cc.replace(' ', '').split(',');
            }

            vm.template.Content = angular.element('#emailContent').html();

            jobsApi.sendEmail(vm.template, vm.relatedIds)
                .then(function() {
                    $mdDialog.hide(true);
                }, function() {
                    $mdDialog.hide(false);
                });
        }

        function onDeleteClick() {
            $mdDialog.hide(false);
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('commentComponent', commentComponent);

    function commentComponent ($mdDialog, utils) {
        var directive = {
            restrict: 'E',
            templateUrl: function (elem, attr) {
                return 'app/shared/widgets/commentComponent/comment.component.html';
            },
            scope: {
                index: '=',
                section: '@',
                message: '@',
                toolTip: '@',
                callback: '&'
            },
            link: linkFunc
        };

        function linkFunc (scope) {
            scope.removeItem = removeItem;
            function removeItem () {
                var confirm = $mdDialog.confirm()
                    .title(scope.section)
                    .multiple(true)
                    .textContent(scope.message)
                    .ok(utils.translate('WIDGETS_LOC.DELETE_YES'))
                    .cancel(utils.translate('WIDGETS_LOC.DELETE_NO'));
                $mdDialog.show(confirm).then(function () {
                    (scope.callback() || angular.noop)(scope.index);
                });
            }
        }

        return directive;
    }
})();

/**
 * Created by jbpb on 03/27/2018.
 */
(function () {
    'use strict';

    angular.module('app.widgets')
        .factory('commentService', commentService);

    /** @ngInject */
    function commentService (
        $mdDialog,
        $q,
        commentApi,
        commentModel,
        identityService
    ) {

        var service = {
            viewComments: viewComments,
            getAllComments: getAllComments,
            addComment: addComment,
            editComment: editComment,
            deleteComment: deleteComment,
            getRestrictionTypes: getRestrictionTypes,
            model: new commentModel()
        };

        return service;

        function viewComments (module, RelatedId, detail) {
            $mdDialog.show({
                templateUrl: 'app/shared/widgets/comment/comment.html',
                controller: 'commentController as vm',
                multiple: true,
                locals: {
                    module: module,
                    RelatedId: RelatedId,
                    detail: detail
                }
            });
        }

        function getAllComments (Id) {
            var deferred = $q.defer();
            commentApi.getAllComments(Id).then(function (resp) {
                var comments = resp.data || [];
                comments.forEach(function (comment) {
                    comment.isUnlocked = true; // by default its unlocked
                    var _date = moment(comment.CreatedDateUtc);
                    var now = moment();
                    var diff = now.diff(_date, 'minutes');
                    if (diff - 480 > 15) {
                        comment.isUnlocked = false;
                    }
                });
                deferred.resolve(comments);
            }, function (ex) {
                deferred.reject(ex);
            });
            return deferred.promise;
        }

        function addComment (data) {
            var deferred = $q.defer();
            if (!service.model.Message) {
                deferred.reject();
            } else {
                commentApi.addComment(service.model).then(function (resp) {
                    deferred.resolve({ data: resp.data });
                }, function (ex) {
                    deferred.reject(ex);
                });
            }
            return deferred.promise;
        }

        function editComment (model) {
            var deferred = $q.defer();
            commentApi.editComment(service.model).then(function (resp) {
                deferred.resolve({ data: resp.data });
            }, function (ex) {
                deferred.reject(ex);
            });
            return deferred.promise;
        }

        function deleteComment (Id) {
            var deferred = $q.defer();
            commentApi.deleteComment(Id).then(function (resp) {
                deferred.resolve({ data: resp.data });
            }, function (ex) {
                deferred.reject(ex);
            });
            return deferred.promise;
        }

        function getRestrictionTypes () {
            var deferred = $q.defer();
            var UserId = identityService.userData.ContactId;
            commentApi.getRestrictionTypes(UserId).then(function (resp) {
                deferred.resolve(resp.data);
            }, function (ex) {
                deferred.reject(ex);
            });
            return deferred.promise;
        }
    }
})();


/**
 * Created by jbpb on 04/06/2018.
 */
angular.module('app.widgets')
    .service('commentModel', commentModel);

function commentModel () {
    return function (options) {
        var self = this
            , defaults = {
                Id: null,
                RelatedId: null,
                RelatedResourceType: null,
                Attachment: null,
                DocumentTypes: null,
                ContactId: null,
                User: null,
                Message: null,
                CreatedDate: null,
                CreatedDateUtc: null,
                UpdatedDate: null,
                UpdatedDateUtc: null,
                DeletedDate: null,
                DeletedDateUtc: null,
                IsRestricted: false,
                CommentRestrictionType: null,
                isUnlocked: false
            };

        self.map = mapper;
        self.transformToModel = transformToModel;
        self.reset = reset;

        self.map(options);

        function mapper (opts) {
            var mapValue = opts || {}
                , opts = angular.extend(this, defaults, mapValue);
        }

        function reset () {
            this.map(null);
        }

        function transformToModel () {
            var serverModel = {
                Id: self.Id,
                RelatedId: self.RelatedId,
                RelatedResourceType: self.RelatedResourceType,
                Attachment: self.Attachment,
                DocumentTypes: self.DocumentTypes,
                ContactId: self.ContactId,
                User: self.User,
                Message: self.Message,
                CreatedDate: self.CreatedDate,
                CreatedDateUtc: self.CreatedDateUtc,
                UpdatedDate: self.UpdatedDate,
                UpdatedDateUtc: self.UpdatedDateUtc,
                DeletedDate: self.DeletedDate,
                DeletedDateUtc: self.DeletedDateUtc,
                IsRestricted: self.IsRestricted,
                CommentRestrictionType: self.CommentRestrictionType,
                isUnlocked: self.isUnlocked
            }
            return serverModel;
        }

    };
}

(function() {
    'use strict';

    angular
        .module('app.widgets')
        .controller('commentController', commentController);

    function commentController(
        $mdDialog,
        commentService,
        module,
        RelatedId,
        detail,
        blockUI,
        hubService,
        timeFactory,
        filterFilter,
        $scope) {

        var vm = this;

        vm.activate = activate;
        vm.getAllComments = getAllComments;
        vm.getRestrictionTypes = getRestrictionTypes;
        vm.saveComment = saveComment;
        vm.addComment = addComment;
        vm.editComment = editComment;
        vm.deleteComment = deleteComment;
        vm.cancelEntry = cancelEntry;
        vm.service = commentService;
        vm.restrictionsChanged = restrictionsChanged;
        vm.displayDateStamp = displayDateStamp;
        vm.onClose = onClose;

        vm.messages = [];
        vm.filteredMessages = [];
        vm.search = {};
        vm.pageSize = 10;

        $scope.$watch('vm.search', function(newVal, oldVal) {
            pager(newVal);
        }, true);

        function pager(search) {
            vm.currentPage = 1;
            vm.filteredMessages = search ? filterFilter(vm.messages, search) : vm.messages;
            vm.totalItems = vm.filteredMessages.length;
            vm.noOfPages = Math.ceil(vm.totalItems / vm.pageSize);
        }

        function restrictionsChanged() {}

        function onClose() {
            $mdDialog.hide();
        }

        function getAllComments() {
            vm.blocker.start({
                message: 'Loading comments...'
            });
            vm.service.getAllComments(vm.RelatedId).then(function(data) {
                vm.messages = data;
                pager(vm.search);
                vm.blocker.stop();
            }, function(ex) {
                vm.blocker.stop();
                hubService.showToast('Failed to load comments.');
            });
        }

        function getRestrictionTypes() {
            vm.service.getRestrictionTypes().then(function(data) {
                const mappedModuleName = getModuleGroupName(module);
                const moduleRestrictionType = data.filter(function(restrictionType) {
                    return restrictionType.GroupName === mappedModuleName;
                });

                vm.RestrictionTypes = moduleRestrictionType;
            }, function(ex) {});
        }

        function getModuleGroupName(moduleName) {
            switch (moduleName) {
                case 'Company':
                    return 'Companies';
                case 'Ticket':
                    return 'Jobs';
                case 'Contact':
                    return 'Contacts';
            }
            return '';
        }

        function saveComment() {
            if (!vm.service.model.Message) {
                return;
            }
            vm.blocker.start({
                message: 'Saving comment...'
            });
            if (!vm.isEditing) {
                vm.service.addComment().then(function() {
                    vm.isAdding = false;
                    vm.blocker.stop();
                    vm.getAllComments();
                }, function(ex) {
                    vm.blocker.stop();
                    hubService.showToast('Failed to add comment.');
                });
            } else if (vm.isEditing) {
                vm.service.editComment().then(function() {
                    vm.isEditing = false;
                    vm.blocker.stop();
                    vm.getAllComments();
                }, function(ex) {
                    vm.blocker.stop();
                    hubService.showToast('Failed to edit comment.');
                });
            }
        }

        function deleteComment(Id) {
            vm.blocker.start({
                message: 'Deleting comment...'
            });
            vm.service.deleteComment(Id).then(function() {
                vm.blocker.stop();
                hubService.showToast('Comment deleted.');
                vm.getAllComments();
            }, function(ex) {
                vm.blocker.stop();
                hubService.showToast('Failed to delete comment.');
            });
        }

        function addComment() {
            vm.service.model.reset();
            vm.service.model.RelatedId = vm.RelatedId;
            if (vm.module == 'Ticket') {
                vm.service.model.RelatedResourceType = 0;
            } else if (vm.module == 'Contact') {
                vm.service.model.RelatedResourceType = 1;
            } else if (vm.module == 'Company') {
                vm.service.model.RelatedResourceType = 2;
            }
            vm.isAdding = true;
        }

        function editComment(comment) {
            vm.service.model.map(comment);
            vm.isEditing = true;
        }

        function cancelEntry() {
            vm.isAdding = false;
            vm.isEditing = false;
        }

        function displayDateStamp(datetime) {
            var myDate = new Date(datetime * 1000);
            if (myDate.toLocaleString() !== "Invalid Date") {
                return myDate.toLocaleString();
            }
            myDate = timeFactory.timeParser(datetime);
            if (myDate !== "Invalid date") {
                return myDate;
            }
            myDate = moment.utc(datetime).toDate();
            if (myDate !== "Invalid date") {
                myDate = moment(myDate).format('YYYY-MM-DD HH:mm:ss');
                return myDate;
            }
            return datetime;
        }

        function activate() {
            vm.module = module;
            vm.RelatedId = RelatedId;
            vm.detail = detail;

            vm.blocker = blockUI.instances.get('block-comment-component');
            vm.getRestrictionTypes();
            vm.getAllComments();
        }

        vm.activate();
    }
})();

/**
 * Created by jbpb on 04/26/2018.
 */
(function () {
    'use strict';

    angular.module('app.widgets')
        .factory('commentClaimsService', commentClaimsService);

    /** @ngInject */
    function commentClaimsService ($rootScope, $log, identityService, claimsUtilService) {
        var service = {
            hasCommentsAccess: false,
        };

        activate();

        return service;

        function activate () {
            // Triggered by SignalR
            $rootScope.$on('identityService:applyClaimsRules', function (e, promise) {
                applyClaimsRules();
            });
            applyClaimsRules();
        }

        function applyClaimsRules () {
            service.hasCommentsAccess = claimsUtilService.checkAccessByRole('Administration') || claimsUtilService.checkAccessByRole('ManageComments');
        }
    }
})();


/**
 * Back to Top Component
 */
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('a8BackToTop', a8BackToTop);

    /** @ngInject */
    function a8BackToTop() {
        var directive = {
            restrict: 'A',
            scope: {
                btspeed: '=',
                btstyle: '@'
            },
            template: '<div>' +
                ' <button class = "{{vm.btstyle}}" ' +
                ' ng-class="vm.startedScrolling" type="button" ng-click="vm.goToTop()">' +
                '   <i id = "arrowIcon" class="material-icons">keyboard_arrow_up</i>' +
                '</button>' +
                '</div>',
            controller: backToTopController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function backToTopController() {
            var vm = this;

            vm.interval = $interval;
            vm.window = $window;
            vm.scope = $scope;
            vm.pixelsScrolledToTop = 0;
            vm.count = 0;
            vm.goToTop = goToTop;

            configDefaults.call(vm);

            vm.startedScrolling = 'hideBackToTop';

            vm.window.addEventListener("scroll", function (event) {
                vm.pixelsScrolledToTop = angular.element(vm.window).scrollTop();
                vm.scope.$apply(function () {
                    vm.startedScrolling = (vm.pixelsScrolledToTop > 0 ? 'showBackToTop' : 'hideBackToTop');
                });
            });


            function goToTop() {
                vm.count = 0;
                (function scrollToTop() {
                    vm.count++;

                    if (didIReachTheTop.call(vm)) {
                        stopScrolling.call(vm, scroll);
                    }
                    else {
                        vm.pixelsScrolledToTop -= returnVelocity.call(vm);
                        window.scrollTo(0, vm.pixelsScrolledToTop)
                        setTimeout(scrollToTop, 10);
                    }
                })();
            }

            function didIReachTheTop() {
                return (vm.pixelsScrolledToTop <= 0);
            }
        
            function returnVelocity() {
                var inc = Math.PI / (vm.btspeed / 10);
                var velocity = vm.pixelsScrolledToTop * (0.5 - 0.5 * Math.cos(vm.count * inc));
        
                return velocity;
            }
        
            function stopScrolling(scrollFn) {
                vm.window.scrollTo(0, 0)
                vm.interval.cancel(scrollFn);
            }
        
            function configDefaults() {
                vm.btstyle = vm.btstyle || "md-fab md-fab-bottom-right md-button md-ink-ripple docs-scroll-fab";
                this.btspeed = this.btspeed || 500;
            }

        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.audit', []);
})();

(function () {
  'use strict';

  angular.module('app.audit')
    .factory('AuditLogService', AuditLogService);

  /** @ngInject */
  function AuditLogService($mdDialog) {

    var service = {
      viewAuditLogs : viewAuditLogs
    };

    return service;

    function viewAuditLogs(module){
      $mdDialog.show({
        templateUrl: 'app/shared/widgets/auditLog/audit-log.html',
        controller: 'AuditLogController as vm'
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.audit')
    .controller('AuditLogController', AddProjectController);

  function AddProjectController($mdDialog) {

    //Data
    var vm = this;

    //Methods
    vm.onClose = onClose;

    function onClose(){
      $mdDialog.hide();
    }

  }
})();

(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('addButton', addButton);

    function addButton($mdDialog) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/addButton/addButton.html',
            scope: {
                title: '@'
            },
            controller: a8NumbersController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function a8NumbersController() {
            var vm = this;
        }
    }
})();

/***
 * a8 TreeMdBox Service
 * UI logic
 */
(function () {
    'use strict';

    angular.module('app.assets')
        .factory('a8TreeMdBoxService', a8TreeMdBoxService);

    /** @ngInject */
    function a8TreeMdBoxService($rootScope, ivhTreeviewMgr, ivhTreeviewBfs) {
        var service = {
            source: [],
            expandTo: expandTo,
            reset: reset,
            getSelectedItems: getSelectedItems,
            onSelected: null
        };

        return service;

        ////////
        function expandTo(ids) {
            angular.forEach(ids, function (itm) {
                ivhTreeviewMgr.expandTo(service.source, itm.CategoryKey);
            }, this);
        }

        function reset() {
            service.source.length = 0;
        };

        function getSelectedItems() {
            var selectedItems = [];
            ivhTreeviewBfs(service.source, function (node) {

                if (node.selected == true && !node.hasOwnProperty('children')) {
                    selectedItems.push(node);
                };
            });

            return selectedItems;
        };

    }
})();

/**
 * Tree MdBox extension for ivh-treeview control
 * rlc 7.5.2016
 *
 */
(function(){
    'use strict';

    angular.module('app.widgets')
           .directive('a8TreeMdBox', a8TreeMdBox);

    /** @ngInject */
    function a8TreeMdBox(ivhTreeviewMgr, a8TreeMdBoxService, customizedFieldService) {
        var directive = {
            restrict: 'E',
            template: [
                        '<span class="ascii-box">',
                            '<span ng-show="node.selected" class="x"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="true"></md-checkbox></span>',
                            '<span ng-show="node.__ivhTreeviewIndeterminate" class="y"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="false"></md-checkbox></span>',
                            '<span ng-hide="node.selected || node.__ivhTreeviewIndeterminate"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="false"></md-checkbox></span>',
                        '</span>',
                      ].join(''),
            link: linkFunc
        }; // End directive

        return directive;

      function linkFunc(scope, element, attrs) {
          element.on('click', function() {
            //var sourceArr = (angular.noop || scope.$eval(attrs['getSource']))();
            // var source = scope.$eval(attrs['src']);
            // a8TreeMdBoxService.source
            customizedFieldService.itemTypeChange = !customizedFieldService.itemTypeChange;
            ivhTreeviewMgr.select(a8TreeMdBoxService.source, scope.node, !scope.node.selected);
            (a8TreeMdBoxService.onSelected || angular.noop)(a8TreeMdBoxService.source);
            scope.$apply();
          });
        }
    }
})();

(function() {
    'use strict';
  
    angular
      .module('app.widgets')
      .controller('a8PhoneNumbersCompanyDialogController', a8PhoneNumbersCompanyDialogController);
  
    function a8PhoneNumbersCompanyDialogController($mdDialog,
                                            editMode,
                                            utils,
                                            phoneTypes,
                                            existingNumber) {
  
      var vm = this;
      vm.phoneTypes = phoneTypes;
  
      //Methods
      vm.activate = activate;
      vm.onCancel = onCancel;
      vm.formData = formData;
      vm.onDone = onDone;
  
      vm.activate();
  
      //Implementations
      function activate(){
        if(editMode){
          vm.caption = utils.translate('WIDGETS_LOC.PHONE_NUMBER_EDIT');
          vm.isPrimary = existingNumber.IsPrimary;
          vm.number = existingNumber.Number;
          resetTypes();
          setType(existingNumber.PhoneType);
        }else{
          vm.caption = utils.translate('WIDGETS_LOC.PHONE_NUMBER_ADD');
          vm.isPrimary = false;
        }
      }
  
      function onCancel(){
        $mdDialog.hide();
      }
  
      function onDone(){
         var payLoad = formData();
         $mdDialog.hide(payLoad);
      }
  
      function formData(){
        var phoneNumberModel = {};
        if(editMode) {
          phoneNumberModel['IsPrimary'] = vm.isPrimary;
          phoneNumberModel['Number'] = vm.number;
          phoneNumberModel['PhoneId'] = existingNumber.numberType;
          phoneNumberModel['PhoneType'] = vm.numberType;
        }
        else{
          phoneNumberModel['IsPrimary'] = vm.isPrimary;
          phoneNumberModel['Number'] = vm.number;
          phoneNumberModel['PhoneType'] = vm.numberType;
        }
        return phoneNumberModel;
      }
  
      function resetTypes(){
        angular.forEach(vm.phoneTypes, function(type){
          type['Selected'] = false;
        });
      }
  
      function setType(type){
        angular.forEach(vm.phoneTypes, function(itm){
          if(type.TypeName == itm.TypeName) {
            itm['Selected'] = true;
          }
        });
      }
  
    }
  })();
  
(function(){
    'use strict';
  
    angular.module('app.widgets')
      .directive('a8PhoneNumbersCompany', a8Numbers);
  
    function a8Numbers($mdDialog) {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/shared/widgets/a8PhoneNumbersCompany/a8PhoneNumbersCompany-view.html',
        scope: {
          ngModel : '=',
          phoneTypes : '=',
          validateDuplicate: '&'
        },
        controller: a8PhoneNumbersCompanyController,
        controllerAs: 'vm',
        bindToController: true
      };
  
      return directive;
  
      function a8PhoneNumbersCompanyController() {
          var vm = this;
          vm.dtOptions = {
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            sort: false
          };
  
          //methods
          vm.addNumber = addNumber;
          vm.editNumber = editNumber;
          vm.remove = remove;
  
          //Implementations
          function addNumber(){
            $mdDialog.show({
              templateUrl: 'app/shared/widgets/a8PhoneNumbersCompany/a8PhoneNumbersCompanyDialog.html',
              controller: 'a8PhoneNumbersCompanyDialogController as vm',
              locals: {
                editMode : false,
                phoneTypes : vm.phoneTypes,
                existingNumber : null
              }
            }).then(function(resp){
              appendNumber(resp)
            });
          }
  
          function editNumber(number, index){
            $mdDialog.show({
              templateUrl: 'app/shared/widgets/a8PhoneNumbersCompany/a8PhoneNumbersCompanyDialog.html',
              controller: 'a8PhoneNumbersCompanyDialogController as vm',
              locals: {
                editMode : true,
                phoneTypes : vm.phoneTypes,
                existingNumber : number
              }
            }).then(function(resp){
              if(resp){
                if(resp.IsPrimary){
                  resetPhoneNumbersPrimary();
                  vm.ngModel[index] = resp;
                  vm.ngModel = orderByPrimary(vm.ngModel);
                }
                else{
                  vm.ngModel[index] = resp;
                  if(alasql('select * from ? where IsPrimary = ?', [vm.ngModel, true]).length == 0)
                  {
                    vm.ngModel[0].IsPrimary = true;
                    vm.ngModel = orderByPrimary(vm.ngModel);
                  }
                }
              }
            })
          }
  
          function remove(index){
            if(vm.ngModel.length == 1){
              vm.ngModel = [];
            }
            else{
              vm.ngModel.splice(index, 1);
              if(alasql('select * from ? where IsPrimary = ?', [vm.ngModel, true]).length == 0)
              {
                vm.ngModel[0].IsPrimary = true;
                vm.ngModel = orderByPrimary(vm.ngModel);
              }
            }
          }
  
          function appendNumber(resp){
            if(resp)
              if(resp.IsPrimary){
                if(vm.ngModel.length > 0){
                  resetPhoneNumbersPrimary();
                  vm.ngModel.push(resp);
                  vm.ngModel = orderByPrimary(vm.ngModel);
                }else{
                  resp.IsPrimary = true;
                  vm.ngModel.push(resp);
                }
              }
              else{
                if(vm.ngModel.length == 0){
                  resp.IsPrimary = true;
                }
                vm.ngModel.push(resp);
                vm.ngModel = orderByPrimary(vm.ngModel);
              }
              vm.validateDuplicate();
          }
  
          function resetPhoneNumbersPrimary(){
            angular.forEach(vm.ngModel, function(itm){
              if(itm.IsPrimary){
                itm.IsPrimary = false;
              }
            })
          }
  
          function orderByPrimary(data){
            return alasql('select * from ? order by IsPrimary desc', [data]);
          }
        }
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .controller('a8PhoneNumbersDialogController', a8PhoneNumbersDialogController);

    function a8PhoneNumbersDialogController($mdDialog,
        editMode,
        utils,
        phoneTypes,
        existingNumber) {

        var vm = this;
        vm.phoneTypes = phoneTypes;

        //Methods
        vm.activate = activate;
        vm.onCancel = onCancel;
        vm.formData = formData;
        vm.onDone = onDone;

        vm.activate();

        //Implementations
        function activate() {
            if (editMode) {
                vm.caption = utils.translate('WIDGETS_LOC.PHONE_NUMBER_EDIT');
                vm.isPrimary = existingNumber.IsPrimary;
                vm.number = existingNumber.Number;
                resetTypes();
                setType(existingNumber.PhoneType);
            } else {
                vm.caption = utils.translate('WIDGETS_LOC.PHONE_NUMBER_ADD');
                vm.isPrimary = false;
            }
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function onDone() {
            var payLoad = formData();
            $mdDialog.hide(payLoad);
        }

        function formData() {
            var phoneNumberModel = {};
            if (editMode) {
                phoneNumberModel['IsPrimary'] = vm.isPrimary;
                phoneNumberModel['Number'] = vm.number;
                phoneNumberModel['PhoneId'] = existingNumber.numberType;
                phoneNumberModel['PhoneType'] = vm.numberType;
            } else {
                phoneNumberModel['IsPrimary'] = vm.isPrimary;
                phoneNumberModel['Number'] = vm.number;
                phoneNumberModel['PhoneType'] = vm.numberType;
            }
            return phoneNumberModel;
        }

        function resetTypes() {
            angular.forEach(vm.phoneTypes, function (type) {
                type['Selected'] = false;
            });
        }

        function setType(type) {
            angular.forEach(vm.phoneTypes, function (itm) {
                if (type.TypeName == itm.TypeName) {
                    itm['Selected'] = true;
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('a8PhoneNumbers2', a8Numbers);

    function a8Numbers($mdDialog) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/a8PhoneNumbers2/a8PhoneNumbers-view.html',
            scope: {
                ngModel: '=',
                phoneTypes: '=',
                validateDuplicate: '&'
            },
            controller: a8PhoneNumbersController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function a8PhoneNumbersController() {
            var vm = this;
            vm.dtOptions = {
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                sort: false
            };

            //methods
            vm.addNumber = addNumber;
            vm.editNumber = editNumber;
            vm.remove = remove;

            //Implementations
            function addNumber() {
                $mdDialog.show({
                    templateUrl: 'app/shared/widgets/a8PhoneNumbers/a8PhoneNumbersDialog.html',
                    controller: 'a8PhoneNumbersDialogController as vm',
                    locals: {
                        editMode: false,
                        phoneTypes: vm.phoneTypes,
                        existingNumber: null
                    }
                }).then(function (resp) {
                    appendNumber(resp)
                });
            }

            function editNumber(number, index) {
                $mdDialog.show({
                    templateUrl: 'app/shared/widgets/a8PhoneNumbers/a8PhoneNumbersDialog.html',
                    controller: 'a8PhoneNumbersDialogController as vm',
                    locals: {
                        editMode: true,
                        phoneTypes: vm.phoneTypes,
                        existingNumber: number
                    }
                }).then(function (resp) {
                    if (resp) {
                        if (resp.IsPrimary) {
                            resetPhoneNumbersPrimary();
                            vm.ngModel[index] = resp;
                            vm.ngModel = orderByPrimary(vm.ngModel);
                        } else {
                            vm.ngModel[index] = resp;
                            if (alasql('select * from ? where IsPrimary = ?', [vm.ngModel, true]).length == 0) {
                                vm.ngModel[0].IsPrimary = true;
                                vm.ngModel = orderByPrimary(vm.ngModel);
                            }
                        }
                    }
                })
            }

            function remove(index) {
                if (vm.ngModel.length == 1) {
                    vm.ngModel = [];
                } else {
                    vm.ngModel.splice(index, 1);
                    if (alasql('select * from ? where IsPrimary = ?', [vm.ngModel, true]).length == 0) {
                        vm.ngModel[0].IsPrimary = true;
                        vm.ngModel = orderByPrimary(vm.ngModel);
                    }
                }
            }

            function appendNumber(resp) {
                if (resp)
                    if (resp.IsPrimary) {
                        if (vm.ngModel.length > 0) {
                            resetPhoneNumbersPrimary();
                            vm.ngModel.push(resp);
                            vm.ngModel = orderByPrimary(vm.ngModel);
                        } else {
                            resp.IsPrimary = true;
                            vm.ngModel.push(resp);
                        }
                    }
                else {
                    if (vm.ngModel.length == 0) {
                        resp.IsPrimary = true;
                    }
                    vm.ngModel.push(resp);
                    vm.ngModel = orderByPrimary(vm.ngModel);
                }
                vm.validateDuplicate();
            }

            function resetPhoneNumbersPrimary() {
                angular.forEach(vm.ngModel, function (itm) {
                    if (itm.IsPrimary) {
                        itm.IsPrimary = false;
                    }
                })
            }

            function orderByPrimary(data) {
                return alasql('select * from ? order by IsPrimary desc', [data]);
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('app.widgets')
    .controller('a8PhoneNumbersDialogController', a8PhoneNumbersDialogController);

  function a8PhoneNumbersDialogController($mdDialog,
                                          editMode,
                                          utils,
                                          phoneTypes,
                                          existingNumber) {

    var vm = this;
    vm.phoneTypes = phoneTypes;

    //Methods
    vm.activate = activate;
    vm.onCancel = onCancel;
    vm.formData = formData;
    vm.onDone = onDone;

    vm.activate();

    //Implementations
    function activate(){
      if(editMode){
        vm.caption = utils.translate('WIDGETS_LOC.PHONE_NUMBER_EDIT');
        vm.isPrimary = existingNumber.IsPrimary;
        vm.number = existingNumber.Number;
        resetTypes();
        setType(existingNumber.PhoneType);
      }else{
        vm.caption = utils.translate('WIDGETS_LOC.PHONE_NUMBER_ADD');
        vm.isPrimary = false;
      }
    }

    function onCancel(){
      $mdDialog.hide();
    }

    function onDone(){
       var payLoad = formData();
       $mdDialog.hide(payLoad);
    }

    function formData(){
      var phoneNumberModel = {};
      if(editMode) {
        phoneNumberModel['IsPrimary'] = vm.isPrimary;
        phoneNumberModel['Number'] = vm.number;
        phoneNumberModel['PhoneId'] = existingNumber.numberType;
        phoneNumberModel['PhoneType'] = vm.numberType;
      }
      else{
        phoneNumberModel['IsPrimary'] = vm.isPrimary;
        phoneNumberModel['Number'] = vm.number;
        phoneNumberModel['PhoneType'] = vm.numberType;
      }
      return phoneNumberModel;
    }

    function resetTypes(){
      angular.forEach(vm.phoneTypes, function(type){
        type['Selected'] = false;
      });
    }

    function setType(type){
      angular.forEach(vm.phoneTypes, function(itm){
        if(type.TypeName == itm.TypeName) {
          itm['Selected'] = true;
        }
      });
    }

  }
})();

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('a8PhoneNumbers', a8Numbers);

  function a8Numbers($mdDialog) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/shared/widgets/a8PhoneNumbers/a8PhoneNumbers-view.html',
      scope: {
        ngModel : '=',
        phoneTypes : '=',
        validateDuplicate: '&'
      },
      controller: a8PhoneNumbersController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function a8PhoneNumbersController() {
        var vm = this;
        vm.dtOptions = {
          pagingType: 'simple',
          autoWidth: false,
          responsive: true,
          sort: false
        };

        //methods
        vm.addNumber = addNumber;
        vm.editNumber = editNumber;
        vm.remove = remove;

        //Implementations
        function addNumber(){
          $mdDialog.show({
            templateUrl: 'app/shared/widgets/a8PhoneNumbers/a8PhoneNumbersDialog.html',
            controller: 'a8PhoneNumbersDialogController as vm',
            locals: {
              editMode : false,
              phoneTypes : vm.phoneTypes,
              existingNumber : null
            }
          }).then(function(resp){
            appendNumber(resp)
          });
        }

        function editNumber(number, index){
          $mdDialog.show({
            templateUrl: 'app/shared/widgets/a8PhoneNumbers/a8PhoneNumbersDialog.html',
            controller: 'a8PhoneNumbersDialogController as vm',
            locals: {
              editMode : true,
              phoneTypes : vm.phoneTypes,
              existingNumber : number
            }
          }).then(function(resp){
            if(resp){
              if(resp.IsPrimary){
                resetPhoneNumbersPrimary();
                vm.ngModel[index] = resp;
                vm.ngModel = orderByPrimary(vm.ngModel);
              }
              else{
                vm.ngModel[index] = resp;
                if(alasql('select * from ? where IsPrimary = ?', [vm.ngModel, true]).length == 0)
                {
                  vm.ngModel[0].IsPrimary = true;
                  vm.ngModel = orderByPrimary(vm.ngModel);
                }
              }
            }
          })
        }

        function remove(index){
          if(vm.ngModel.length == 1){
            vm.ngModel = [];
          }
          else{
            vm.ngModel.splice(index, 1);
            if(alasql('select * from ? where IsPrimary = ?', [vm.ngModel, true]).length == 0)
            {
              vm.ngModel[0].IsPrimary = true;
              vm.ngModel = orderByPrimary(vm.ngModel);
            }
          }
        }

        function appendNumber(resp){
          if(resp)
            if(resp.IsPrimary){
              if(vm.ngModel.length > 0){
                resetPhoneNumbersPrimary();
                vm.ngModel.push(resp);
                vm.ngModel = orderByPrimary(vm.ngModel);
              }else{
                resp.IsPrimary = true;
                vm.ngModel.push(resp);
              }
            }
            else{
              if(vm.ngModel.length == 0){
                resp.IsPrimary = true;
              }
              vm.ngModel.push(resp);
              vm.ngModel = orderByPrimary(vm.ngModel);
            }
            vm.validateDuplicate();
        }

        function resetPhoneNumbersPrimary(){
          angular.forEach(vm.ngModel, function(itm){
            if(itm.IsPrimary){
              itm.IsPrimary = false;
            }
          })
        }

        function orderByPrimary(data){
          return alasql('select * from ? order by IsPrimary desc', [data]);
        }
      }
  }
})();

/**
 * a8SimplePaginationGrid service
 * Handles streamed data coming from docDb or Redis Cache
 * Instantiable service
 * by Rcnet 11.14.2016
 */
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .factory('a8SimplePaginationGridService', a8SimplePaginationGridService);

    /** @ngInject */
    function a8SimplePaginationGridService(_,
        $log,
        $timeout,
        a8PagerGridModel,
        a8PagerGridModelBuilderService,
        utils,
        a8GridSearchEngineService,
        a8SortService) {

        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        //////
        function activate() { }

        /**
         * Create new instance
         */
        function getInstance() {
            var paginationContext = function () {
                var self = this;

                // Props
                self.supersetCollection = [];
                self.filteredSupersetCollection = [];
                self.data = {
                    HasNextPage: false,
                    HasPreviousPage: false,
                    TotalItemCount: 0,
                    FirstItemOnPage: 0,
                    LastItemOnPage: 0,

                    DownloadCtr: 0,
                    TotalChunks: 0,

                    isFiltered: false,
                    RawTotalItemCount: 0,  // Total item count without filtering used only when displaying filtering info 

                    // Client callback
                    onPagerClickCallback: null,

                    onDataFilter: angular.noop,
                    onFetchData: angular.noop,
                    onCompleted: angular.noop,
                    onPreRender: angular.noop,
                    onError: angular.noop,
                    onSearch: angular.noop
                };

                self.currentPageSize = 10;
                self.currentPageNumber = 1;   // Page number is a base 0 index
                self.moveNext = moveNext;
                self.movePrev = movePrev;
                self.refreshPager = refreshPager2;
                self.sortParams = null;

                self.onChunkReceived = onChunkReceived;
                self.onDownloadCompleted = onDownloadCompleted;

                self.search = search;
                self.searchText = null;

                self.sort = sort;
                self.setDefaultSort = setDefaultSort;
                self.sortBy = null;
                self.sortDir = null;

                self.changePageSize = changePageSize;
                self.busy = false;
                self.isDownloading = false;
                self.setToDownloadingState = setToDownloadingState;
                self.inProgress = angular.noop;

                self.clearData = clearData;
                self.initiator = null;  // cacheHub or dbHub
                self.distinctBy = null; // Temporary only
                self.updateState = updateState;  // Perform client side update of data set 
                self.resetWithCollection = resetWithCollection;  // Perform client side update of data set 
                self.concatenateToCollection = concatenateToCollection;  // Perform client side update of data set 
                self.pushToState = pushToState;  // Insert to current collection state
                self.pushItemsToState = pushItemsToState // Insert multiple items to collection state
                self.removeToState = removeToState; // Detach object from collection state
                self.getSupersetCollection = getSupersetCollection; // Get the collection containing all the fetched data

                activate();

                function activate() { }

                function getSupersetCollection() {
                    return self.supersetCollection;
                }

                /**
                 * On receive chunk data
                */
                function onChunkReceived(data, initiator) {
                    if (data) {
                        // Provide chunk properties
                        // If totalChunks and totalItemCount = -1 then downloding time is undetermine
                        // view will adjust to this by displaying estimate count
                        self.data.TotalChunks = data.totalChunks;
                        self.data.TotalItemCount = data.totalItems;
                        self.data.DownloadCtr = self.data.DownloadCtr++;
                        self.initiator = initiator;

                        angular.forEach(data.chunkData, function (itm) {
                            self.supersetCollection.push(itm);
                        });

                        if (self.distinctBy) {
                            self.supersetCollection = applyDistinctBy(self.distinctBy, self.supersetCollection);
                        }

                        refreshPager2(self.currentPageNumber);

                        // Db propagated or cache
                        if (initiator === 'dbHub' || initiator === 'dbHubFilter') {
                            // doc db we dont know the count size ahead so no computation of progress
                            return -1;
                        } else {
                            return calculateDataReceivedProgress(data.totalItems);
                        }
                    }
                }

                function clearData() {
                    self.supersetCollection.length = 0;
                    self.filteredSupersetCollection.length = 0;
                    self.currentPageNumber = 1;
                    self.data.RawTotalItemCount = 0;
                    self.data.TotalItemCount = 0;
                }

                /**
                 * Compute download percentage
                 */
                function calculateDataReceivedProgress(totalItems) {
                    let currentProgress = Math.ceil((self.supersetCollection.length / parseInt(totalItems)) * 100);
                    return currentProgress;
                }

                /**
                 * Todo: Replace this code !!!
                 * @param {distinctBy} Temporary code
                 */
                function applyDistinctBy(distinctBy, superset) {
                    let qry = 'SELECT DISTINCT ' + distinctBy + ', * FROM ?';
                    return alasql(qry, [superset]);
                }

                /**
                 * Filter pipeline (sorting and searching)
                 * Mutates collection
                 */
                function applyCollectionPipelineCriteria(page) {
                    // Apply sorting and searching here
                    let filteredColl = [];
                    let totalFilteredCount = 0;

                    // if (self.distinctBy) {
                    //     self.supersetCollection = applyDistinctBy(self.distinctBy, getActiveSuperset());
                    // }

                    let activeSuperset = getActiveSuperset();

                    // Avoid running apply search when the same search text is used when navigating this will speed up things :-)
                    if (self.filteredSupersetCollection.length == 0) {
                        filteredColl = applySearching(activeSuperset);
                    } else {
                        filteredColl = activeSuperset;
                    }

                    filteredColl = applySorting(filteredColl);

                    // Perform optimization by caching the search result
                    optimizeSearchingByCaching(filteredColl);

                    totalFilteredCount = filteredColl.length;
                    filteredColl = applyPageSize(filteredColl);

                    // Check out of bounds here
                    if (filteredColl != null && filteredColl.length > 0) {
                        return { collection: filteredColl[page], totalItems: totalFilteredCount };
                    }

                    return { collection: filteredColl[page], totalItems: totalFilteredCount };
                }

                function optimizeSearchingByCaching(filteredColl) {
                    // If there's a search text then buffer it for faster navigation
                    if (self.searchText != null && !self.isDownloading) {
                        if (self.filteredSupersetCollection.length == 0) {
                            for (var i = 0; i < filteredColl.length; i++) {
                                self.filteredSupersetCollection.push(filteredColl[i]);
                            }
                        }
                    }
                }

                function getActiveSuperset() {
                    if (self.searchText != null) {
                        if ((self.searchText.length > 0) && self.filteredSupersetCollection.length > 0 && !self.isDownloading) {
                            return self.filteredSupersetCollection;
                        } else {
                            return self.supersetCollection;
                        }
                    }
                    return self.supersetCollection;
                }

                /**
                 * Relative to base 0 index for accessing the array superset collection
                 * Call this if you want to access the collection superset
                 */
                function getRelativePageNo(page) {
                    let pageNum = page - 1;
                    return pageNum < 0 ? 1 : pageNum;
                }

                /**
                 * Complete data received
                 */
                function onDownloadCompleted(data, sender) {
                    self.inProgress(false);
                    self.isDownloading = false;

                    // For server side filtering then update raw total count
                    self.data.RawTotalItemCount = self.supersetCollection.length;
                }

                function applyPageSize(collection) {
                    let subsetCollection = _.chunk(collection, self.currentPageSize);
                    return subsetCollection;
                }

                function applySorting(collection) {
                    return a8SortService.sort(collection, self.sortBy, self.sortDir);
                }

                function applySearching(collection) {
                    //self.busy = true;
                    let result = a8GridSearchEngineService.search(collection, self.searchText);
                    let activeSuperset = getActiveSuperset();

                    //self.busy = false;
                    return (result == null ? activeSuperset : result);
                }

                function moveNext() {
                    self.currentPageNumber = ++self.currentPageNumber;
                    refreshPager2(self.currentPageNumber);
                }

                function movePrev() {
                    self.currentPageNumber = --self.currentPageNumber;
                    self.currentPageNumber = self.currentPageNumber <= 0 ? 1 : self.currentPageNumber;
                    refreshPager2(self.currentPageNumber);
                }

                // function search(text) {
                //     self.searchText = text;
                //     self.currentPageNumber = 1;
                //     self.filteredSupersetCollection.length = 0;
                //     self.data.isFiltered = !utils.isNullOrEmpty(text);
                //     self.data.RawTotalItemCount = self.supersetCollection.length;
                //     refreshPager2(1);
                // }

                function search(text) {
                    self.searchText = text;
                    self.currentPageNumber = 1;
                    self.filteredSupersetCollection.length = 0;
                    self.data.isFiltered = !utils.isNullOrEmpty(text);
                    self.data.RawTotalItemCount = self.supersetCollection.length;
                    refreshPager2(1);
                    self.data.onSearch();
                }

                function sort(sortBy, sortDir) {
                    self.sortBy = sortBy;
                    self.sortDir = sortDir;
                    refreshPager2(self.currentPageNumber);
                }

                function setDefaultSort(sortBy, sortDir) {
                    self.sortBy = sortBy;
                    self.sortDir = sortDir;
                }

                function changePageSize(value) {
                    self.currentPageSize = value;
                    self.currentPageNumber = 1;
                    refreshPager2(1);
                }

                /**
                 * Refresh page
                 * @args page - 0 based index
                 */
                function refreshPager2(page) {
                    try {
                        let pageNo = getRelativePageNo(page);
                        let result = applyCollectionPipelineCriteria(pageNo);

                        // Before rendering the results fire this event, any pre init operation can be perform here in this event 
                        let isCancelRendering = (self.data.onPreRender || angular.noop)({ data: result.collection });
                        if (isCancelRendering == false) return;

                        // Build pager model
                        let pagerModel = a8PagerGridModelBuilderService.createModel(result.totalItems,
                            page,
                            self.currentPageSize
                        );

                        // Notify client to build grid data
                        $timeout(function () {
                            buildPager(pagerModel);
                            (self.data.onCompleted || angular.noop)({ data: result.collection });
                        }, 0);
                    } catch (ex) {
                        (self.data.onError || angular.noop)({ msg: 'Unable to load data from server.' });
                    }
                }

                /**
                 * Required view model for basic paging
                 */
                function buildPager(model) {
                    self.data.HasNextPage = model.HasNextPage;
                    self.data.HasPreviousPage = model.HasPreviousPage;
                    self.data.TotalItemCount = model.TotalItemCount;
                    self.data.FirstItemOnPage = model.FirstItemOnPage;
                    self.data.LastItemOnPage = model.LastItemOnPage;
                    //service.data.PageNumber = model.PageNumber;
                }

                function setToDownloadingState() {
                    self.isDownloading = true;
                }

                /**
                * Updates the SupersetCollection and the FilteredsetColection
                * Note: Use with caution, this will alter the internal state of grid data.
                * As much as possible avoid using this.
                * @param {query expression} predicate 
                * @param {action function to perform mutation} action 
                */
                function updateState(predicate, action, forceRefresh) {
                    // Todo: Fix double firing of action func due to double resolve (supersetColl and filteredSupersetColl)
                    var result = [];
                    if (self.supersetCollection) {
                        result = _.filter(self.supersetCollection, predicate);
                        if (result.length > 0) {
                            (action || angular.noop)(result);  // Reference type so auto update entity inside collection
                        }
                    }
                    if (self.filteredSupersetCollection) {
                        result = _.filter(self.filteredSupersetCollection, predicate);
                        if (result.length > 0) {
                            (action || angular.noop)(result);  // Reference type so auto update entity inside collection
                        }
                    }

                    if (forceRefresh) {
                        // Dont allow the user to be irritated by refreshing his grid while his on the bottom of the page number.
                        if (self.currentPageNumber <= 1) {
                            self.currentPageNumber = 1;
                            self.filteredSupersetCollection.length = 0;
                            self.data.RawTotalItemCount = self.supersetCollection.length;
                            refreshPager2(1);
                        }
                    }
                }

                function resetWithCollection(collection) {
                    self.supersetCollection = collection;

                    if (self.currentPageNumber < 1) self.currentPageNumber = 1;

                    self.filteredSupersetCollection.length = 0;
                    self.data.RawTotalItemCount = self.supersetCollection.length;
                    refreshPager2(self.currentPageNumber);
                }

                function concatenateToCollection(recordsToAdd) {
                    self.supersetCollection = self.supersetCollection.concat(recordsToAdd);

                    if (self.currentPageNumber < 1) self.currentPageNumber = 1;

                    self.filteredSupersetCollection.length = 0;
                    self.data.RawTotalItemCount = self.supersetCollection.length;
                    refreshPager2(self.currentPageNumber);
                }   

                function pushToState(data) {
                    if (!data) return;

                    self.currentPageNumber = 1;
                    self.filteredSupersetCollection.length = 0;
                    self.data.RawTotalItemCount = self.supersetCollection.length;

                    self.onChunkReceived({
                        chunkData: [data],
                        totalChunks: -1, // Undetermined
                        totalItems: -1,
                        extraData: null
                    }, 'dbHub');

                    self.onDownloadCompleted(data);
                }

                function pushItemsToState(data) {
                    if (!data) {
                        return;
                    }

                    self.currentPageNumber = 1;
                    self.filteredSupersetCollection.length = 0;
                    self.data.RawTotalItemCount = self.supersetCollection.length;

                    self.onChunkReceived({
                        chunkData: data,
                        totalChunks: -1, // Undetermined
                        totalItems: -1,
                        extraData: null
                    }, 'dbHub');

                    self.onDownloadCompleted(data);
                }

                function removeToState(predicate) {
                    _.remove(self.supersetCollection, predicate);
                    _.remove(self.filteredSupersetCollection, predicate);
                    refreshPager2(self.currentPageNumber);
                }

            };

            return new paginationContext();
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('a8PaginationComponentGrid', a8PaginationComponentGrid);

    /** @ngInject */
    function a8PaginationComponentGrid(
        a8SimplePaginationGridService
    ) {
        var directive = {
            restrict: 'E',
            scope: {
                behavior: '=',
                onInit: '&',
                onDataFilter: '&',
                onFetchData: '&',
                onCompleted: '&',
                onPreRender: '&',
                onDataLoading: '&',
                onDataLoadingCompleted: '&',
                onError: '&',
                onReady: '&',
                showNav: '=',
                showTotalRecords: '&',
                distinctBy: '@'
            },
            require: '^a8GridComponent',
            templateUrl: 'app/shared/widgets/a8PaginationGrid/a8Pagination.html',
            controller: PaginationController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function PaginationController() {}

        function link($scope, el, attrs, controller) {
            var vm = $scope.vm;
            vm.basicService = a8SimplePaginationGridService.getInstance();
            vm.showTotalRecords = vm.showTotalRecords == null ? true : vm.showTotalRecords;
            vm.hubAdapter = null;

            activate();

            // Subscribe to other grid components like Search, Sort, PageSize components
            controller.onGoSearch(function(val) {
                vm.basicService.search(val);
            });

            controller.onSort(function(s) {
                vm.basicService.sort(s.sortParams.sortBy, s.sortParams.sortDir);
            });

            controller.onChangePageSize(function(pageSize) {
                vm.basicService.changePageSize(pageSize);
            });

            function activate() {
                initPaginationApis();

                // Assign default sort props if set
                var sortProps = controller.getSortProps();
                if (sortProps.hasDefaultSortColumn) {
                    vm.basicService.setDefaultSort(sortProps.defaultSortColumn, sortProps.initialDefaultDir);
                }

                // Fire on-Init event
                (vm.onInit || angular.noop)();
                controller.setStatus('Fetching data...');

                initBasicPagination();

                // Fire when the control is ready or completed initialization
                (vm.onReady || angular.noop)();
            }

            function initPaginationApis() {
                // --------------
                // Exposed APIs
                // --------------
                if (vm.behavior) {
                    // To track progress
                    vm.behavior.busy = false;

                    // Refresh pagination
                    vm.behavior.refresh = refresh;
                    vm.behavior.setHubSourceAdapter = setHubSourceAdapter;
                    vm.behavior.getInfo = getInfo;
                    vm.behavior.stop = stop;
                    vm.behavior.search = search;

                    // Force update of data set
                    vm.behavior.updateState = vm.basicService.updateState; // Perform client side update of data set
                    vm.behavior.resetWithCollection = vm.basicService.resetWithCollection; // Perform client side update of data set
                    vm.behavior.concatenateToCollection = vm.basicService.concatenateToCollection; // Perform client side update of data set
                    vm.behavior.pushToState = vm.basicService.pushToState; // Insert to current collection state
                    vm.behavior.pushItemsToState = vm.basicService.pushItemsToState // Insert multiple items to collection state

                    vm.behavior.removeToState = vm.basicService.removeToState; // Detach object from collection state
                    vm.behavior.getSupersetCollection = vm.basicService.getSupersetCollection; // fetch SuperSet collection containing all fetched records
                }
            }

            function search(searchText) {
                vm.basicService.search(searchText);
            }

            function stop() {
                vm.hubAdapter.stopDownload(vm.basicService.initiator);
                vm.behavior.busy = false;
                controller.setStatus('');
            }

            function getInfo() {
                return {
                    totalCount: vm.basicService.data.TotalItemCount, // vm.basicService.data.RawTotalItemCount,
                    totalChunks: vm.basicService.data.TotalChunks,
                    totalFilteredCount: vm.basicService.data.TotalItemCount
                };
            }

            function refresh() {
                controller.setStatus('Fetching data...');

                let filters = (vm.onDataFilter || angular.noop)();
                let filterObj = filters != null ? {
                    filters: filters
                } : null;

                vm.basicService.clearData();
                startDownload(filterObj);
            }

            /**
             * Hook to hubAdapter methods
             * @param {adapter} adapter is the main source of data for this control
             */
            function setHubSourceAdapter(adapter) {
                vm.hubAdapter = adapter;
                vm.hubAdapter.onChunkReceived = onChunkReceived;
                vm.hubAdapter.onDownloadCompleted = onDownloadCompleted;
                vm.hubAdapter.onErrorDownloading = onErrorDownloading;
            }

            function onChunkReceived(data, sender) {
                (vm.onDataLoading || angular.noop)();

                let progressPercentage = vm.basicService.onChunkReceived(data, sender);
                if (progressPercentage > 0)
                    controller.setStatus(progressPercentage.toString() + '%');
            }

            function onDownloadCompleted(data, sender) {
                vm.behavior.busy = false;
                controller.setStatus('');
                (vm.onDataLoadingCompleted || angular.noop)();
                vm.basicService.onDownloadCompleted(data, sender);
                (vm.hubAdapter.onCacheData || angular.noop)(data);
            }

            function onErrorDownloading(data, sender) {}

            function startDownload(filters) {
                vm.behavior.busy = true;
                vm.hubAdapter.onGetData(filters)
                    .catch(function(ex) {
                        vm.behavior.busy = false;
                        controller.setStatus('Error retrieving records.');
                        (vm.onError || angular.noop)({
                            ex: ex
                        });
                    });
                vm.basicService.setToDownloadingState();
            }

            function initBasicPagination() {
                vm.basicService.data.isCustomDataFetch = vm.manualDataFetch;
                vm.basicService.sourceType = vm.sourceType;
                vm.basicService.distinctBy = vm.distinctBy; // TODO: Remove this feature(just a temporary approach)!!!

                vm.basicService.data.customDataFetch = function(params) {
                    return (vm.onCustomDataFetch || angular.noop)({
                        params: params
                    });
                }

                vm.basicService.data.onDataFilter = function() {
                    // not supported in basic
                }

                vm.basicService.data.onFetchData = function() {
                    // not supported in basic
                }

                vm.basicService.data.onSearch = function() {
                    // Fire event to consumer
                    (vm.onDataLoadingCompleted || angular.noop)();
                }

                vm.basicService.data.onCompleted = function(data) {
                    (vm.onCompleted || angular.noop)({
                        data: data.data
                    });
                }

                vm.basicService.data.onPreRender = function(data) {
                    (vm.onPreRender || angular.noop)({
                        data: data
                    });
                }

                vm.basicService.data.onError = function(ex) {
                    (vm.onError || angular.noop)({
                        ex: ex
                    });
                }

                vm.basicService.inProgress = function(show) {
                    vm.behavior.busy = show;
                }

                refresh();
            }
        }
    }
})();

/**
 * a8PagerModelBuilderService
 */
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .factory('a8PagerGridModelBuilderService', a8PagerGridModelBuilderService);

    /** @ngInject */
    function a8PagerGridModelBuilderService(_, a8PagerGridModel) {
        var service = {
            createModel: createModel
        };

        return service;

        //////////
        function createModel(totalItemCount, pageNumber, pageSize) {
            let pageNum = pageNumber === 0 ? 1 : pageNumber;
            let pagerModel = new a8PagerGridModel();
            
            pagerModel.TotalItemCount = totalItemCount;
            pagerModel.PageSize = pageSize;
            pagerModel.PageNumber = pageNum;
            pagerModel.PageCount = totalItemCount > 0
                ? parseInt(Math.ceil(parseInt(totalItemCount) / parseInt(pagerModel.PageSize)))
                : 1;
           
            pagerModel.PageCount = totalItemCount > 0
                ? parseInt(Math.ceil(parseInt(totalItemCount) / parseInt(pagerModel.PageSize)))
                : 0;
            pagerModel.HasNextPage = pageNum < pagerModel.PageCount;
            pagerModel.HasPreviousPage = parseInt(pageNum) > 1;
            pagerModel.IsFirstPage = pagerModel.PageNumber === 1;
            pagerModel.IsLastPage = pagerModel.PageNumber >= pagerModel.PageCount;
            pagerModel.FirstItemOnPage = (pagerModel.PageNumber - 1) * pagerModel.PageSize + 1;
            var numberOfLastItemOnPage = pagerModel.FirstItemOnPage + pagerModel.PageSize - 1;
            pagerModel.LastItemOnPage = numberOfLastItemOnPage > pagerModel.TotalItemCount
                ? pagerModel.TotalItemCount
                : numberOfLastItemOnPage;

            return pagerModel;
        }
    }
})();
/**
 * Model coming from DB
 */
(function(){
   'use strict';

  angular.module('app.widgets')
          .service('a8PagerGridModel', a8PagerGridModel)

    function a8PagerGridModel() {
        return function () {
            var self = this,
            defaults = {
                FirstItemOnPage: null,
                HasNextPage: false,
                HasPreviousPage: false,
                IsFirstPage: false,
                IsLastPage: false,
                LastItemOnPage: null,
                PageCount: 0,
                PageNumber: 0,
                PageSize: 0,
                TotalItemCount: 0
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();
/**
* Pagination Component Client Side
* Main Component
* Client side paging
*/
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('a8GridComponent', a8GridComponent);

    /** @ngInject */
    function a8GridComponent() {
        var directive = {
            restrict: 'E',
            scope: {
                configuration: '='
            },
            controller: a8GridComponentController,
            controllerAs: 'vm',
            bindToController: true
        };

        ///////
        function a8GridComponentController() {
            var vm = this;

            vm.handlers = {
                searchDelegates: [],
                sortResetDelegates: [],
                sortDelegates: [],
                pageSizeDelegates: [],
                statusDelegates: []
                //infoDelegates: []
            }

            vm.sortProps = { defaultSortColumn: null, hasDefaultSortColumn: false };            
        }

        a8GridComponentController.prototype.goSearch = function (text) {
            this.handlers.searchDelegates.forEach(function (handler) {
                handler(text);
            });
        }

        a8GridComponentController.prototype.onGoSearch = function (handler) {
            this.handlers.searchDelegates.push(handler);
        }

        a8GridComponentController.prototype.sortReset = function () {
            this.handlers.sortResetDelegates.forEach(function (handler) {
                handler();
            });
        }

        a8GridComponentController.prototype.onSortReset = function (handler) {
            this.handlers.sortResetDelegates.push(handler);
        }

        a8GridComponentController.prototype.sort = function (sortParams) {
            this.handlers.sortDelegates.forEach(function (handler) {
                handler(sortParams);
            });
        }

        a8GridComponentController.prototype.onSort = function (handler) {
            this.handlers.sortDelegates.push(handler);
        }

        a8GridComponentController.prototype.setSortProps = function (props) {
            this.sortProps = props;
        }

        a8GridComponentController.prototype.getSortProps = function () {
            return this.sortProps;
        }

        a8GridComponentController.prototype.changePageSize = function (pageSize) {
            this.handlers.pageSizeDelegates.forEach(function (handler) {
                handler(pageSize);
            });
        }

        a8GridComponentController.prototype.onChangePageSize = function (handler) {
            this.handlers.pageSizeDelegates.push(handler);
        }

        a8GridComponentController.prototype.setStatus = function (value) {
            this.handlers.statusDelegates.forEach(function (handler) {
                handler(value);
            });
        }

        a8GridComponentController.prototype.onSetStatus = function (handler) {
            this.handlers.statusDelegates.push(handler);
        }

        // invoiceGridComponentController.prototype.setGridInfo = function(value) {
        //     this.handlers.infoDelegates.forEach(function(handler) {
        //         handler(value);
        //     });
        // }

        // invoiceGridComponentController.prototype.onSetGridInfo = function(handler) {
        //     this.handlers.infoDelegates.push(handler);
        // }

        return directive;
    }

})();
/**
 * a8SimplePagination service
 * by Rcnet 11.14.2016
 */
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .factory('a8SimplePaginationService', a8SimplePaginationService);

    /** @ngInject */
    function a8SimplePaginationService(a8PagerModel, a8PagerModelBuilderService, utils) {
        var service = {
            // Viewmodel
            data: {
                HasNextPage: false,
                HasPreviousPage: false,
                TotalItemCount: 0,
                FirstItemOnPage: 0,
                LastItemOnPage: 0,

                // Client callback
                onPagerClickCallback: null,

                isCustomDataFetch: false,
                customDataFetch: angular.noop,  // Promise

                onDataFilter: angular.noop,
                onFetchData: angular.noop,
                onCompleted: angular.noop,
                onPreRender: angular.noop,
                onError: angular.noop
            },
            currentPageSize: 10,
            currentPageNumber: 1,   // Page number is a base 1 index
            moveNext: moveNext,
            movePrev: movePrev,
            refreshPager: refreshPager,
            searchStr: null,
            sortParams: null,
            sourceType: 'ClientSide'
        };

        activate();

        return service;

        //////////
        function activate() {
        }

        function getSourceType() {
            switch(service.sourceType) {
                case 'ServerSide':
                    return 'serverside';
                case 'ClientSide':
                    return 'clientside';
                case 'TokenBased':
                    return 'tokenbased';
            } 
        }

        function moveNext(url) {
            let pageNo = ++service.currentPageNumber;
            refreshPager(url, pageNo);
        }

        function movePrev(url) {
            let pageNo = --service.currentPageNumber;
            pageNo = pageNo <= 0 ? 1 : pageNo;
            refreshPager(url, pageNo);
        }

        function refreshPager(url, page) {
            service.currentPageNumber = page;

            if (service.data.isCustomDataFetch) {
                let params = getAPIParameters(url, page);
                
                service.data.customDataFetch(params)
                    .then(function (resp) {
                        let retData = resp.data;
                        if (resp) {
                            // Before rendering the results fire this event, any pre init operation can be perform here in this event 
                            let isCancelRendering = (service.data.onPreRender || angular.noop)({ data: retData.Dataset });
                            if (isCancelRendering == false) return;

                            // Build pager model
                            let pagerModel = a8PagerModelBuilderService.createModel(retData.TotalItemCount, 
                                                                        page, 
                                                                        service.currentPageSize,
                                                                        retData.Token ? retData.Token : null
                                                                     );
                            buildPager(pagerModel);

                            // Notify client to build grid data
                            (service.data.onCompleted || angular.noop)({ data: retData.Dataset });
                        }
                        else {
                            (service.data.onError || angular.noop)({ msg: 'Unable to load data from server.' });
                        }
                    }).catch(function (ex) {
                        (service.data.onError || angular.noop)({ msg: 'Unable to load data from server.' });
                    });
            } else {
                // CREATE the API url on the fly
                // Trigger pre render
                // fetch data from api
                // Trigger render completed
            }
        }

        /**
         * For custom data fetch
         */
        function getAPIParameters(url, page) {
            let optPrms = {
                search: utils.isNull(service.searchStr, ''),
                sortDir: utils.isNull(service.sortParams.sortDir, ''),
                sortBy: utils.isNull(service.sortParams.sortBy, '')
            };

            // Construct optional parameters 
            let filters = '',
                requestUrl = '';

            for (var itm in optPrms) {
                filters += '&' + itm + '=' + encodeURIComponent(optPrms[itm]);
            }

            requestUrl += 'pageNo=' + encodeURIComponent(page) + '&pageSize=' + encodeURIComponent(service.currentPageSize) + filters;

            return {
                url: url,
                queryStringFullRequestUrl: url + '?' + requestUrl,
                queryStringParams: requestUrl,   // Appended url with parameters
                pageSize: parseInt(service.currentPageSize),
                pageNumber: parseInt(page),
                search: (service.searchStr ? service.searchStr : ''),
                sortDir: (service.sortParams ? service.sortParams.sortDir : ''),
                sortBy: (service.sortParams ? service.sortParams.sortBy : ''),
                token: (service.getSourceType() == 'tokenbased' ?   a8PagerModelBuilderService.getToken(page) : null)
            };
        }

        /**
         * Required view model for basic paging
         */
        function buildPager(model) {
            service.data.HasNextPage = model.HasNextPage;
            service.data.HasPreviousPage = model.HasPreviousPage;
            service.data.TotalItemCount = model.TotalItemCount;
            service.data.FirstItemOnPage = model.FirstItemOnPage;
            service.data.LastItemOnPage = model.LastItemOnPage;
            //service.data.PageNumber = model.PageNumber;
        }
    }
})();
/**
* Pagination Component
*/
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('a8PaginationComponent', a8PaginationComponent);

    /** @ngInject */
    function a8PaginationComponent($http, $timeout, a8SimplePaginationService) {
        var directive = {
            restrict: 'E',
            scope: {
                url: '=',
                //currentPageSize: '=',  // 1 time use only (need to review this one if we still need it)
                behavior: '=',
                onInit: '&',
                onDataFilter: '&',
                onFetchData: '&',
                onCompleted: '&',
                onPreRender: '&',
                onError: '&',
                showNav: '=',
                type: '@',
                manualDataFetch: '@',
                onCustomDataFetch: '&',
                showTotalRecords: '&',
                sourceType: '&'   //  types are (TokenBased, ServerSide, ClientSide)
                //tokenBasedApi: '@',
            },
            templateUrl: 'app/shared/widgets/a8Pagination/a8Pagination.html',
            controller: PaginationController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        ///////
        function PaginationController($scope) {
            var vm = this;
            vm.basicService = a8SimplePaginationService;
            vm.showTotalRecords = vm.showTotalRecords == null ? true : vm.showTotalRecords;

            // Methods
            vm.onPagerClick = onPagerClick;
            vm.onPagerClickCallback = onPagerClickCallback;

            activate();

            function activate() {
                // --------------
                // Exposed APIs
                // --------------
                if (vm.behavior) {
                    vm.behavior.changeUrl = function (url) {
                        vm.url = url;
                    };

                    // Refresh pagination
                    vm.behavior.refresh = function (page) {
                        // Perform Post Digest (Angular is too slow to reflect the changes in one of its dependents)
                        $timeout(function () {
                            a8SimplePaginationService.refreshPager(vm.url, page);
                        }, 0, false);
                    };

                    vm.behavior.setPageSize = function (pageSize, isRefresh) {
                        a8SimplePaginationService.currentPageSize = pageSize;
                        if (isRefresh)
                            a8SimplePaginationService.refreshPager(vm.url, 1);
                    };

                    vm.behavior.search = function (value) {
                        a8SimplePaginationService.searchStr = value;
                        vm.behavior.refresh(1);
                    };

                    vm.behavior.sort = function (s) {
                        a8SimplePaginationService.sortParams = s;
                        vm.behavior.refresh(1);
                    };

                    vm.behavior.setSortDefault = function (s) {
                        a8SimplePaginationService.sortParams = s;
                    };
                }

                // Fire on-Init event
                (vm.onInit || angular.noop)();

                initBasicPagination();
            }

            function initBasicPagination() {
                a8SimplePaginationService.data.isCustomDataFetch = vm.manualDataFetch;
                a8SimplePaginationService.sourceType = vm.sourceType;

                a8SimplePaginationService.data.customDataFetch = function (params) {
                    return (vm.onCustomDataFetch || angular.noop)({ params: params });
                }

                a8SimplePaginationService.data.onDataFilter = function () {
                    // not supported in basic
                }

                a8SimplePaginationService.data.onFetchData = function () {
                    // not supported in basic
                }

                a8SimplePaginationService.data.onCompleted = function (data) {
                    (vm.onCompleted || angular.noop)({ data: data.data });
                }

                a8SimplePaginationService.data.onPreRender = function (data) {
                    (vm.onPreRender || angular.noop)({ data: data });
                }

                a8SimplePaginationService.data.onError = function (ex) {
                    (vm.onError || angular.noop)({ ex: ex });
                }
                // Set default
                //vm.showNav = false;
                a8SimplePaginationService.refreshPager(vm.url, 1);
            }

            function initNumericPagination() {
                alert('Not implemented yet!');
            }

            function onPagerClick(prm) {
                if (prm === 'disabled')
                    return;

                // Notify grid or whatever client that we need to reload data
                if (vm.pagerVm.onPagerClickCallback != null)
                    vm.pagerVm.onPagerClickCallback(prm);
            }

            // --------------------
            // Pager Main Behavior
            // --------------------
            function onPagerClickCallback(url) {
                var targetUrl = getTargetUrl(url);
                if (targetUrl) {
                    populatePager(targetUrl);
                }
            }

        }
    }
})();

/**
 * a8PagerModelBuilderService
 */
(function () {
    'use strict';

    angular
        .module('app.widgets')
        .factory('a8PagerModelBuilderService', a8PagerModelBuilderService);

    /** @ngInject */
    function a8PagerModelBuilderService(_, a8PagerModel) {
        var service = {
            createModel: createModel,
            tokenHistoryList: [], 
            isTokenExist: isTokenExist,
            getToken: getToken
        };

        return service;

        //////////
        function createModel(totalItemCount, pageNumber, pageSize, token) {
            let pagerModel = new a8PagerModel();
            
            
            // If token mode is supported then handle it
            if (token) {
                let hastoken = hasToken(token);
                // Add page token
                let tokenHistory = _.find(service.tokenHistoryList, function (o) { return o.pageNo === pageNumber });
                if (!tokenHistory) {
                    if (pageNumber == 1) {
                        service.tokenHistoryList.push({ pageNo: 1, token: null });
                    }
                    // Advance the pageNumber pointer
                    service.tokenHistoryList.push({ pageNo: ++pageNumber, token: parsePageToken(token) });
                }
            }

            pagerModel.TotalItemCount = totalItemCount;
            pagerModel.PageSize = pageSize;
            pagerModel.PageNumber = pageNumber;
            pagerModel.PageCount = totalItemCount > 0
                ? parseInt(Math.ceil(parseInt(totalItemCount) / parseInt(pagerModel.PageSize)))
                : 0;
            pagerModel.HasNextPage = pageNumber < pagerModel.PageCount;;
            pagerModel.HasPreviousPage = parseInt(pageNumber) > 1;
            pagerModel.IsFirstPage = pagerModel.PageNumber === 1;
            pagerModel.IsLastPage = pagerModel.PageNumber >= pagerModel.PageCount;
            pagerModel.FirstItemOnPage = (pagerModel.PageNumber - 1) * pagerModel.PageSize + 1;
            var numberOfLastItemOnPage = pagerModel.FirstItemOnPage + pagerModel.PageSize - 1;
            pagerModel.LastItemOnPage = numberOfLastItemOnPage > pagerModel.TotalItemCount
                ? pagerModel.TotalItemCount
                : numberOfLastItemOnPage;

            return pagerModel;
        }

        function isTokenExist(pageNumber) {
            let tokenHistory = _.find(service.tokenHistoryList, function (o) { return o.pageNo === pageNumber });
            return !!tokenHistory;
        }

        function getToken(pageNumber) {
            let token = _.find(service.tokenHistoryList, function (o) { return o.pageNo === pageNumber });
            return token;
        }

        function parsePageToken(data) {
            if (data) {
                let tokenObj = angular.fromJson(data);
                return tokenObj.hasOwnProperty('token') ? tokenObj.token : null;
            }
            return null;
        }

        function hasToken(data) {
            let token = parsePageToken(data);
            return token != null;
        }

    }
})();
/**
 * Model coming from DB
 */
(function(){
   'use strict';

  angular.module('app.widgets')
          .service('a8PagerModel', a8PagerModel)

    function a8PagerModel() {
        return function () {
            var self = this,
            defaults = {
                FirstItemOnPage: null,
                HasNextPage: false,
                HasPreviousPage: false,
                IsFirstPage: false,
                IsLastPage: false,
                LastItemOnPage: null,
                PageCount: 0,
                PageNumber: 0,
                PageSize: 0,
                TotalItemCount: 0
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {
                // Collect item types
                return null;
            }
        }
        
    }
})();

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('a8Numbers', a8Numbers);

  function a8Numbers($mdDialog) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/shared/widgets/a8Numbers/a8Numbers-view.html',
      scope: {
        ngModel : '=',
        contactTypes : '=',
        module : '@'
      },
      controller: a8NumbersController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function a8NumbersController() {
        var vm = this;
        vm.module = vm.module;
        vm.dtOptions = {
          dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          autoWidth: false,
          responsive: true,
          sort: false
        };

        //methods
        vm.addNumber = addNumber;
        vm.editNumber = editNumber;
        vm.remove = remove;

        //Implementations
        function addNumber(){
          $mdDialog.show({
            templateUrl: 'app/shared/widgets/a8Numbers/a8NumbersDialog.html',
            controller: 'a8NumbersDialogController as vm',
            locals: {
              editMode : false,
              contactTypes : vm.contactTypes,
              existingNumber : null,
              module : vm.module
            }
          }).then(function(resp){
            if(resp)
              vm.ngModel.push(resp);
          });
        }

        function remove(index){
          vm.ngModel.splice(index, 1);
        }

      function editNumber(number, index){
        $mdDialog.show({
          templateUrl: 'app/shared/widgets/a8Numbers/a8NumbersDialog.html',
          controller: 'a8NumbersDialogController as vm',
          locals: {
            editMode : true,
            contactTypes : vm.contactTypes,
            existingNumber : number,
            module : vm.module
          }
        }).then(function(resp){
          if(resp)
            vm.ngModel[index] = resp;
        })
      }
    }
  }
})();

/**
* a8NumFormatter Component
* by Rcnet 5.16.2018
*/
(function () {
    'use strict';
    angular.module('app.widgets')
        .directive('a8NumFormatter', a8NumFormatter);

    /** @ngInject */
    function a8NumFormatter($filter, _) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                numCurrency: '@',
                decimalPlace: '@'
            },
            link: a8NumFormatterLink
        };

        return directive;

        ///////
        function a8NumFormatterLink(scope, element, attr, ngModel) {
            var formatter = function (num) {
                num = num || 0;
                num = _.isEmpty(num) ? 0 : num;
                num = num == 'NaN' ? 0 : num;
                return scope.numCurrency + $filter('number')(num, (scope.decimalPlace == null ? 2 : scope.decimalPlace));
            };

            var unformatter = function (str) {
                return parseFloat(str.replace(/[^0-9\.]/g, '')).toFixed(scope.decimalPlace);
            };

            ngModel.$formatters.unshift(formatter);
            ngModel.$parsers.unshift(unformatter);

            element.bind('blur', function () {
                element.val(formatter(ngModel.$modelValue))
            });

            element.bind('focus', function () {
                num = num || 0;
                num = _.isEmpty(num) ? 0 : num;
                element.val(ngModel.$modelValue);
            });
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('a8HeaderWithSearch', a8HeaderWithSearch);

    function a8HeaderWithSearch() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/a8HeaderWithSearch/a8-header-with-search.html',
            scope: {
                headerText: '@',
                headerVariable: '=',
                srcData: '=',
                onSearch: '&',
                api: '='
            },
            controller: a8HeaderWithSearchController,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        return directive;

        function a8HeaderWithSearchController() {}

        function link($scope) {
            var vm = $scope.vm;
            vm.headerVariable = vm.headerVariable;

            if (vm.api) {
                vm.api.forceTriggerSearch = forceTriggerSearch;
            }

            $scope.$watch('vm.srcData', function(newVal) {
                if (newVal != null) {
                    (vm.onSearch || angular.noop)({
                        value: newVal
                    });
                }
            });

            function forceTriggerSearch() {
                (vm.onSearch || angular.noop)({
                    value: vm.srcData
                });
            }
        }
    }
})();

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('a8Header', a8Header);

  function a8Header() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/shared/widgets/a8Header/a8Header.html',
      scope: {
        headerText : '@',
        headerVariable : '='
      },
      controller: a8HeaderController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function a8HeaderController(tenantSettings, $scope, mediaQueryService) {
      $scope.mediaQueryService = mediaQueryService;
      $scope.environmentName = tenantSettings.tenantKey;
      $scope.showEnvName = tenantSettings.shouldDisplayEnvironmentName;
    }
  }
})();

/**
 * Form extension
 * rlc 4.19.2016
 * 
 * Usage: $root.$broadcast('a8Form.nameOfTargetElem:submit);
 */
(function(){
    'use strict';
    
    angular.module('app.widgets')
           .directive('a8Form', a8Form);
    
    function a8Form($timeout) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };
        
        return directive;
        
        function linkFunc(scope, elem, attrs) {
            
            if (!attrs['a8Form'])
                   return;
                   
            var name = attrs['a8Form'];
            
            // PubSubs
            scope.$on('a8Form.' + name + ':submit', function(e, data){
                $timeout(function(){
                    (angular.element(elem) || angular.noop).trigger('submit');   
                },0);
                 
            });
        }
    }
})();
/**
 * File uploading
 * based/copied from shan's file-upload directive
 * Rcnet
 *
 * Enhancements:
 * - uploadUrl supported
 * - onUploadCompleted supported
 * - onUploadError supported
 * 7.28.2016 - onUploadProgress supported
 * 8.2.2016 - onValidate supported
 */
(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('a8FileUpload', a8FileUpload);

    /** @ngInject */
    function a8FileUpload(
        $parse,
        $http,
        $log,
        exceptionService
    ) {
        return {
            restrict: 'A',
            scope: {
                uploadUrl: '=',
                maxFiles: '=',
                behavior: '=',
                onUploadStart: '&',
                onUploadProgress: '&',
                onUploadCompleted: '&',
                onUploadError: '&',
                onUploadValidate: '&',
                settings: '='
            },
            link: linkFunc
        }

        function linkFunc(scope, element, attribute) {
            var defaults = {
                contentType: 'undefined'
            };

            var options = angular.extend(defaults, scope.settings);

            element.bind('change', function() {
                var countOfValidFile = 0;

                (scope.onUploadStart || angular.noop)();
                $parse(attribute.a8FileUpload).assign(scope, element[0].files);
                scope.$apply();

                if (_.parseInt(scope.maxFiles) < _.size(scope.files)) {
                    let ex = [];
                    ex.data = [];
                    ex.data.Message = "You have exceeded the maximum number of files allowed";
                    (scope.onUploadError || angular.noop)({
                        ex: ex
                    });
                    element.val(null);
                    return;
                }

                var fd = new FormData();
                angular.forEach(scope.files, function(file) {
                    var isValid = (scope.onUploadValidate || angular.noop)({
                        fileObj: file
                    });

                    if (isValid) {
                        fd.append('file', file);
                        countOfValidFile++;
                        (scope.onUploadProgress || angular.noop)({
                            filename: file.name
                        });
                    }
                });

                if (countOfValidFile <= 0)
                    return;

                $http({
                    method: 'POST',
                    url: scope.uploadUrl,
                    headers: {
                        'Content-Type': undefined
                    },
                    transformRequest: angular.identity,
                    data: fd
                }).then(function(response) {
                    $log.debug(response);
                    $log.debug(response.data[0]);
                    let data = [];

                    if (angular.isDefined(attribute.behavior)) {
                        data = response.data;
                    } else if (angular.isArray(response.data)) {
                        data = response.data[0];
                    } else {
                        data = response.data;
                    }

                    let errorCount = _.size(_.filter(response.data, function(err) {
                        return !_.isNil(err.IsUploadSuccessful) && !err.IsUploadSuccessful;
                    }));

                    if (errorCount > 0) {
                        let errMessages = _.map(response.data, function(err) {
                            return _.head(err.ErrorMessages);
                        });

                        data.data = [];
                        data.data.Message = _.join(errMessages, "<br/>");

                        exceptionService.resolve(errMessages);
                    }

                    (scope.onUploadCompleted || angular.noop)({
                        data: data
                    });
                    element.val(null);

                }).catch(function(ex) {
                    (scope.onUploadError || angular.noop)({
                        ex: ex
                    });
                    element.val(null);
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.widgets')
        .factory('attachmentPreferenceService', attachmentPreferenceService);

    // Helpers for wiring the attachment-preferences screen result into the company save.
    function attachmentPreferenceService() {
        return {
            isEmpty: isEmpty
        };

        // A preference is "empty" when nothing is chosen: no standard PDFs, neither "all" toggle, and
        // no individually chosen forms or attachments. An empty selection clears the preference to the
        // default (receive everything) rather than persisting an all-false object that paperwork/invoice
        // generation would read as "attach nothing".
        //
        // DocumentOrder is deliberately not consulted: an order is not a selection, so reordering
        // alone must still clear to default. The core api's resolver treats it the same way.
        //
        // IncludeInvoicePdf does count: on an Accounts address, the Invoice PDF ticked on its own is
        // the "invoice only" choice, not an empty one.
        function isEmpty(pref) {
            if (!pref) {
                return true;
            }

            // Forms travel as FormTemplates [{OriginId, RelatedEntityId}]; also tolerate the interim
            // flat FormTemplateIds shape so this wiring is correct either way.
            var forms = pref.FormTemplates || pref.FormTemplateIds || [];
            var attachments = pref.AttachmentDocumentFileIds || [];

            return !pref.IncludeInvoicePdf &&
                !pref.IncludeTicketPdf &&
                !pref.IncludeTimesheetPdf &&
                !pref.IncludeAllForms &&
                !pref.IncludeAllAttachments &&
                forms.length === 0 &&
                attachments.length === 0;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.widgets')
        .controller('a8EmailsWithTypeDialogController', a8EmailsDialogController);

    function a8EmailsDialogController($mdDialog, editMode, utils, model, emailPattern) {

        //Data
        var vm = this;
        var email = model.email;
        var ngModel = model.model;
        vm.hidePrimary = model.hidePrimary;
        vm.showSchedulingAlerts = model.showSchedulingAlerts;

        //Methods
        vm.activate = activate;
        vm.onCancel = onCancel;
        vm.formData = formData;
        vm.onDone = onDone;
        vm.onEmailTypeChange = onEmailTypeChange;

        vm.emailPattern = emailPattern;

        vm.activate();

        //Implementations
        function activate() {
            if (editMode) {
                vm.caption = utils.translate('WIDGETS_LOC.DIALOG_HEADER_EDIT');
                vm.emailAddress = email.EmailAddress;
                vm.isPrimary = email.IsPrimary;
                vm.type = email.EmailType;
            } else {
                vm.caption = utils.translate('WIDGETS_LOC.DIALOG_HEADER_ADD');
            }
        }

        function onCancel() {
            $mdDialog.hide();
        }

        function onDone() {
            var payLoad = formData();
            $mdDialog.hide(payLoad);
        }

        function onEmailTypeChange(email) {
          vm.IsDuplicate = false;

          if (vm.type == '5') {
              if (ngModel.map(x => x.EmailType).indexOf(parseInt(email.type)) != -1 || ngModel.map(x => x.EmailType).indexOf(email.type) != -1) {
                  vm.IsDuplicate = true;
              }
          }
      }

        function formData() {
            var emailModel = {};
            emailModel['EmailAddress'] = vm.emailAddress;
            emailModel['IsPrimary'] = vm.isPrimary;
            emailModel['EmailType'] = vm.type;
            // Preserve any attachment preference already set on this address; editing the email here
            // must not drop the choices made on the attachment-preferences screen. Only Accounts (3)
            // and Paperwork (4) addresses can hold a preference, so if the type was changed to anything
            // else we drop it rather than leave an orphaned preference the user can no longer see.
            var keepsPreference = vm.type == 3 || vm.type == 4;
            if (editMode && email && email.AttachmentPreference != null && keepsPreference) {
                emailModel['AttachmentPreference'] = email.AttachmentPreference;
            }
            return emailModel;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('a8EmailsWithType', a8EmailsWithType);

    function a8EmailsWithType($mdDialog, _, utils, attachmentPreferenceService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/shared/widgets/a8EmailsWithType/a8Emails-viewWithType.html',
            scope: {
                ngModel: '=',
                validateDuplicate: '&',
                hidePrimary: '@',
                showSchedulingAlerts: "@",
                // One-way rather than "@": the host passes the EnableEmailAttachmentPreferences flag,
                // and an interpolated attribute is not guaranteed to have resolved by the time the
                // controller body below runs — the button would then stay hidden for a tenant that
                // has the feature on.
                showAttachmentPreferences: "<"
            },
            controller: a8EmailsController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function a8EmailsController() {
            var vm = this;
            vm.dtOptions = {
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                sort: false
            };

            vm.hidePrimary = vm.hidePrimary === 'true';
            vm.showSchedulingAlerts = vm.showSchedulingAlerts === 'true';
            // Attachment preferences are a company-only feature; the host opts in, and only when
            // EnableEmailAttachmentPreferences is on for the tenant. Branch emails reuse this widget
            // but are out of scope, so they pass nothing and the button stays hidden.
            vm.showAttachmentPreferences = vm.showAttachmentPreferences === true;

            //methods
            vm.addEmail = addEmail;
            vm.editEmail = editEmail;
            vm.editAttachmentPreferences = editAttachmentPreferences;
            vm.remove = remove;
            vm.getEmailType = getEmailType;

            //Implementations
            function getEmailType(type) {
                if (type == 1) {
                    return utils.translate('WIDGETS_LOC.TYPE_BUSINESS');
                }

                if (type == 2) {
                    return utils.translate('WIDGETS_LOC.TYPE_PERSONAL');
                }

                if (type == 3) {
                    return utils.translate('WIDGETS_LOC.TYPE_ACCOUNTS');
                }

                if (type == 4) {
                    return utils.translate('WIDGETS_LOC.TYPE_PAPERWORK');
                }

                if (type == 5) {
                    return utils.translate('WIDGETS_LOC.TYPE_SCHEDULINGALERTS');
                }

                if (_.isNil(type)) {
                    return "";
                }
            }

            function remove(index) {
                if (vm.ngModel.length >= 1) {
                    vm.ngModel.splice(index, 1)
                    if (vm.ngModel.length == 1) {
                        vm.ngModel[0].IsPrimary = true;
                    }
                } else {
                    var alert = $mdDialog.alert()
                        .title(utils.translate('WIDGETS_LOC.SECTION'))
                        .textContent(utils.translate('WIDGETS_LOC.ACTION_CANCELLED'))
                        .ok(utils.translate('WIDGETS_LOC.CLOSE'));
                    $mdDialog
                        .show(alert);
                }
            }

            function addEmail() {
                $mdDialog.show({
                    templateUrl: 'app/shared/widgets/a8EmailsWithType/a8EmailsWithTypeDialog.html',
                    controller: 'a8EmailsWithTypeDialogController as vm',
                    locals: {
                        editMode: false,
                        model: {
                            email: null,
                            hidePrimary: vm.hidePrimary,
                            showSchedulingAlerts: vm.showSchedulingAlerts,
                            model: vm.ngModel
                        }
                    }
                }).then(function(resp) {
                    if (resp)
                        if (vm.ngModel.length == 0) {
                            resp.IsPrimary = true;
                            vm.ngModel.push(resp);
                        }
                    else {
                        if (resp.IsPrimary) {
                            angular.forEach(vm.ngModel, function(itm) {
                                itm.IsPrimary = false;
                            });
                            vm.ngModel.push(resp);
                            vm.ngModel = alasql('select * from ? order by IsPrimary desc', [vm.ngModel]);
                        } else {
                            vm.ngModel.push(resp);
                            vm.ngModel = alasql('select * from ? order by IsPrimary desc', [vm.ngModel]);
                        }
                    }
                    vm.validateDuplicate();
                });
            }

            // Opens the attachment-preferences screen for an Accounts/Paperwork address. The dialog
            // returns the chosen preference; we write it back onto the in-memory email. Persisting it
            // with the company save is handled separately.
            function editAttachmentPreferences(email) {
                $mdDialog.show({
                    templateUrl: 'app/shared/widgets/a8EmailsWithType/a8AttachmentPreferences.html',
                    controller: 'a8AttachmentPreferencesController as vm',
                    clickOutsideToClose: true,
                    locals: {
                        attachmentPreference: email.AttachmentPreference,
                        initialEmailType: email.EmailType
                    }
                }).then(function(resp) {
                    // resp is undefined only on explicit Cancel (Done resolves the preference);
                    // clear an empty selection to the default (null) instead of an all-false object.
                    if (angular.isUndefined(resp)) {
                        return;
                    }
                    email.AttachmentPreference = attachmentPreferenceService.isEmpty(resp) ? null : resp;
                });
            }

            function editEmail(email, index) {
                $mdDialog.show({
                    templateUrl: 'app/shared/widgets/a8EmailsWithType/a8EmailsWithTypeDialog.html',
                    controller: 'a8EmailsWithTypeDialogController as vm',
                    locals: {
                        editMode: true,
                        model: {
                            email: email,
                            hidePrimary: vm.hidePrimary,
                            showSchedulingAlerts: vm.showSchedulingAlerts,
                            model: vm.ngModel
                        }
                    }
                }).then(function(resp) {
                    if (resp)
                        if (resp.IsPrimary) {
                            angular.forEach(vm.ngModel, function(itm) {
                                itm.IsPrimary = false;
                            });
                            vm.ngModel[index] = resp;
                        }
                    else {
                        vm.ngModel[index] = resp;
                        if (vm.ngModel.length == 1) {
                            vm.ngModel[0].IsPrimary = true;
                        }
                    }
                })
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.widgets')
        .controller('a8AttachmentPreferencesController', a8AttachmentPreferencesController);

    /** @ngInject */
    function a8AttachmentPreferencesController($mdDialog, $q, _, companyService, documentService, companyApi, attachmentPreference, initialEmailType) {

        // Document module ids the core api uses to scope documents to a resource.
        var COMPANY_MODULE_ID = '2';
        var BRANCH_MODULE_ID = '5';

        // Email type ids, matching the core api's EmailType. Only an Accounts address sends an
        // invoice, so only it gets the Invoice row.
        var EMAIL_TYPE_ACCOUNTS = 3;

        // The orderable documents, in the order they were merged in before the order was
        // configurable. These strings are the core api's DocumentOrder tokens — see
        // architecture.md#attachment-preference-document-contract.
        var ORDERABLE_ROWS = [
            { key: 'Ticket', labelKey: 'WIDGETS_LOC.ATTACHMENT_PREFERENCES.TICKET_PDF', prefKey: 'IncludeTicketPdf' },
            { key: 'Timesheet', labelKey: 'WIDGETS_LOC.ATTACHMENT_PREFERENCES.TIMESHEET_PDF', prefKey: 'IncludeTimesheetPdf' }
        ];

        // Always ordered on an Accounts address, even where the tenant emails the invoice separately
        // and the position never reaches the recipient. Ticking it alone is what saves "invoice only";
        // with nothing ticked at all the address receives everything.
        var INVOICE_ROW = {
            key: 'Invoice',
            labelKey: 'WIDGETS_LOC.ATTACHMENT_PREFERENCES.INVOICE_PDF',
            prefKey: 'IncludeInvoicePdf'
        };

        // Only these can end up in a paperwork or invoice PDF. Mirrors the core api's supported set —
        // see architecture.md#attachment-preference-document-contract.
        var SUPPORTED_ATTACHMENT_MIME_TYPES = ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png'];

        // Document ids a fetch returned and rejected as unattachable. Only ever populated from a
        // successful fetch, so a load that failed or has not finished prunes nothing — pruning against
        // the loaded list instead would wipe a saved selection if Done were clicked while still loading.
        var unsupportedDocIds = {};

        var GROUP_COMPANY = 'WIDGETS_LOC.ATTACHMENT_PREFERENCES.GROUP_COMPANY';

        var vm = this;

        // The two "all normally-included" toggles. Hydrated from the saved preference, or left at
        // their defaults (everything off) when no preference is set.
        vm.pref = {
            IncludeAllForms: !!(attachmentPreference && attachmentPreference.IncludeAllForms),
            IncludeAllAttachments: !!(attachmentPreference && attachmentPreference.IncludeAllAttachments)
        };

        var invoiceIsOrderable = Number(initialEmailType) === EMAIL_TYPE_ACCOUNTS;

        // The orderable documents — the order of this array is the merge order, and is what Done
        // saves as DocumentOrder.
        vm.documentRows = buildDocumentRows(attachmentPreference, invoiceIsOrderable);

        // Per-item tick state. Individually chosen items are forced in even when they are not
        // normally included, independent of the "all" toggles. Forms are keyed by their origin
        // id + linked entity (a form's OriginId can be linked to several branches, so OriginId
        // alone can't pick out one branch's copy); documents are keyed by their file id.
        vm.selectedForms = buildFormSelectionMap(attachmentPreference && attachmentPreference.FormTemplates);
        vm.selectedDocIds = buildSelectionMap(attachmentPreference && attachmentPreference.AttachmentDocumentFileIds);

        vm.formGroups = [];
        vm.attachmentGroups = [];
        vm.loadingForms = true;
        vm.loadingAttachments = true;

        // Collapsible-section state. Sections start expanded so existing content stays visible;
        // the user can collapse any of them to keep the modal compact.
        vm.sections = {
            documents: true,
            forms: true,
            attachments: true
        };

        vm.onCancel = onCancel;
        vm.onDone = onDone;
        vm.toggleSection = toggleSection;
        vm.onRowMoved = onRowMoved;
        vm.moveRowUp = moveRowUp;
        vm.moveRowDown = moveRowDown;
        vm.isFirstRow = isFirstRow;
        vm.isLastRow = isLastRow;
        vm.isRowLocked = isRowLocked;
        vm.onSelectionChanged = onSelectionChanged;

        activate();

        function activate() {
            // A preference saved before the invoice could be unticked shows it ticked whenever
            // anything else is, because that is what the recipient is sent.
            onSelectionChanged();
            buildFormGroups();
            loadAttachmentGroups();
        }

        function buildSelectionMap(ids) {
            var map = {};
            _.forEach(ids || [], function(id) {
                map[id] = true;
            });
            return map;
        }

        function buildFormSelectionMap(formTemplates) {
            var map = {};
            _.forEach(formTemplates || [], function(ref) {
                map[formRefKey(ref.OriginId, ref.RelatedEntityId)] = true;
            });
            return map;
        }

        function getBranches() {
            var info = companyService.companyInfoData || {};
            return info.Branches2 || [];
        }

        function getCompanyId() {
            return (companyService.companyInfoData || {}).id;
        }

        // The core api returns the forms already grouped (company group + one group per branch,
        // branch links read from the branch documents) with the display name and effective
        // "normally included" flag resolved server-side, mirroring the paperwork run's precedence.
        function buildFormGroups() {
            vm.loadingForms = true;
            return companyApi.getCompanyFormTemplates(getCompanyId())
                .then(function(resp) {
                    vm.formGroups = groupForms(resp.data || {});
                })
                .catch(function() {
                    // Without the endpoint the names can't be resolved; show the structure from the
                    // company links already loaded rather than dropping the forms entirely.
                    vm.formGroups = buildFallbackGroups();
                })
                .finally(function() {
                    vm.loadingForms = false;

                    // A chosen form only counts once it is known to be still linked, so the invoice
                    // lock is worked out again now the forms are in.
                    onSelectionChanged();
                });
        }

        function groupForms(data) {
            var groups = [];

            if ((data.CompanyForms || []).length) {
                groups.push({ name: GROUP_COMPANY, translate: true, items: _.map(data.CompanyForms, toFormItem) });
            }

            _.forEach(data.BranchGroups || [], function(branchGroup) {
                if ((branchGroup.Forms || []).length) {
                    groups.push({ name: branchGroup.BranchName, translate: false, items: _.map(branchGroup.Forms, toFormItem) });
                }
            });

            return groups;
        }

        function toFormItem(form) {
            return {
                key: formRefKey(form.OriginId, form.RelatedEntityId),
                originId: form.OriginId,
                relatedEntityId: form.RelatedEntityId || null,
                name: form.Name,
                normallyIncluded: !!form.NormallyIncluded
            };
        }

        // Degraded shape when the endpoint is unavailable: the company-document links are already
        // loaded with the company, so group those (names and flags unresolved). Vehicle/asset links
        // (RelatedEntityId that is not a branch) stay out of scope.
        function buildFallbackGroups() {
            var branches = getBranches();
            var branchById = {};
            _.forEach(branches, function(branch) {
                branchById[branch.Id] = branch;
            });

            var companyForms = [];
            var branchForms = {};

            _.forEach(companyService.linkedFormTemplates || [], function(form) {
                var item = toFormItem({ OriginId: form.OriginId, RelatedEntityId: form.RelatedEntityId });
                if (_.isNil(form.RelatedEntityId)) {
                    companyForms.push(item);
                } else if (branchById[form.RelatedEntityId]) {
                    (branchForms[form.RelatedEntityId] = branchForms[form.RelatedEntityId] || []).push(item);
                }
            });

            var groups = [];
            if (companyForms.length) {
                groups.push({ name: GROUP_COMPANY, translate: true, items: companyForms });
            }
            _.forEach(branches, function(branch) {
                if (branchForms[branch.Id] && branchForms[branch.Id].length) {
                    groups.push({ name: branch.Name, translate: false, items: branchForms[branch.Id] });
                }
            });

            return groups;
        }

        // Forms are identified by origin id, scoped to the entity they're linked under (company-level
        // links have no RelatedEntityId, branch links carry the branch id) — this matches the
        // FormTemplateRef identity the core api stores the selection against.
        function formRefKey(originId, relatedEntityId) {
            return originId + '|' + (relatedEntityId || '');
        }

        function toDocItem(doc) {
            return {
                id: doc.Id,
                name: doc.Name || doc.name,
                normallyIncluded: !!doc.IncludeInPaperwork
            };
        }

        // Compared exactly, not case-insensitively: the core api matches the mime type as-is, so
        // normalising case here would offer a document the paperwork run then refuses to attach —
        // the silent drop this filter exists to prevent.
        function isSupportedAttachment(doc) {
            return _.includes(SUPPORTED_ATTACHMENT_MIME_TYPES, doc.MimeType);
        }

        // Only the documents the paperwork run can actually attach are offered, so a ticked item is
        // never dropped without the user knowing. Anything rejected is remembered so a selection saved
        // before this filter existed can be dropped on the next save — otherwise it would stay ticked
        // in storage while invisible here, and the preference could never be cleared back to default.
        function toSupportedDocItems(resp) {
            var docs = resp.data || [];

            _.forEach(_.reject(docs, isSupportedAttachment), function(doc) {
                unsupportedDocIds[doc.Id] = true;
            });

            return _.map(_.filter(docs, isSupportedAttachment), toDocItem);
        }

        // Attachments are the company and branch document files; these are not pre-loaded with the
        // company, so fetch the company set plus each branch set in parallel.
        function loadAttachmentGroups() {
            var companyId = getCompanyId();
            var branches = getBranches();
            var groups = [];

            var requests = [];

            if (companyId) {
                requests.push(
                    documentService.getAllDocumentsForResource(COMPANY_MODULE_ID, companyId).then(function(resp) {
                        var items = toSupportedDocItems(resp);
                        if (items.length) {
                            groups.push({ name: 'WIDGETS_LOC.ATTACHMENT_PREFERENCES.GROUP_COMPANY', translate: true, items: items, order: -1 });
                        }
                    }).catch(angular.noop) // a failed fetch must not drop the other resources' attachments
                );
            }

            _.forEach(branches, function(branch, index) {
                requests.push(
                    documentService.getAllDocumentsForResource(BRANCH_MODULE_ID, branch.Id).then(function(resp) {
                        var items = toSupportedDocItems(resp);
                        if (items.length) {
                            groups.push({ name: branch.Name, translate: false, items: items, order: index });
                        }
                    }).catch(angular.noop) // a failed fetch must not drop the other resources' attachments
                );
            });

            $q.all(requests).finally(function() {
                vm.attachmentGroups = _.sortBy(groups, 'order');
                vm.loadingAttachments = false;
            });
        }

        function collectSelectedIds(map) {
            var ids = [];
            _.forEach(map, function(selected, id) {
                if (selected && !unsupportedDocIds[id]) {
                    ids.push(id);
                }
            });
            return ids;
        }

        // The selected forms as the core api's FormTemplateRef shape (OriginId + linked entity).
        // Walks the loaded items so only forms still linked to the company are returned.
        function collectSelectedForms() {
            var refs = [];
            _.forEach(vm.formGroups, function(group) {
                _.forEach(group.items, function(item) {
                    if (vm.selectedForms[item.key]) {
                        refs.push({ OriginId: item.originId, RelatedEntityId: item.relatedEntityId });
                    }
                });
            });
            return refs;
        }

        // The orderable documents in the saved order, with any row the order does not mention
        // restored to its default position rather than dropped. PreferenceDocumentOrder.Normalize
        // restores it the same way, so the position shown here is the position the send delivers —
        // see architecture.md#attachment-preference-document-contract.
        function buildDocumentRows(preference, includeInvoice) {
            var candidates = [INVOICE_ROW].concat(ORDERABLE_ROWS);
            var byKey = _.keyBy(candidates, 'key');
            var ordered = [];

            _.forEach((preference && preference.DocumentOrder) || [], function(key) {
                if (byKey[key] && !_.includes(ordered, byKey[key])) {
                    ordered.push(byKey[key]);
                }
            });

            _.forEach(candidates, function(row) {
                if (!_.includes(ordered, row)) {
                    ordered.splice(defaultPositionFor(candidates, ordered, row), 0, row);
                }
            });

            // Positioned before it is filtered out: the invoice is the anchor the other rows are
            // placed against, on both sides.
            var shown = _.filter(ordered, function(row) {
                return includeInvoice || row !== INVOICE_ROW;
            });

            return _.map(shown, function(row) {
                return {
                    key: row.key,
                    labelKey: row.labelKey,
                    selected: !!(preference && preference[row.prefKey])
                };
            });
        }

        // Where a row the saved order never mentioned belongs: after every present row it follows in
        // the default order, and otherwise before the earliest present row it precedes. Mirrors
        // PreferenceDocumentOrder.Normalize on the core api.
        function defaultPositionFor(candidates, ordered, row) {
            var defaultIndex = _.indexOf(candidates, row);
            var afterPredecessors = 0;
            var beforeSuccessors = ordered.length;

            _.forEach(candidates.slice(0, defaultIndex), function(predecessor) {
                var at = _.indexOf(ordered, predecessor);

                if (at !== -1 && at + 1 > afterPredecessors) {
                    afterPredecessors = at + 1;
                }
            });

            _.forEach(candidates.slice(defaultIndex + 1), function(successor) {
                var at = _.indexOf(ordered, successor);

                if (at !== -1 && at < beforeSuccessors) {
                    beforeSuccessors = at;
                }
            });

            return Math.max(afterPredecessors, beforeSuccessors);
        }

        // dnd-list has already inserted the copy at its new index, so the source row is spliced out.
        function onRowMoved(index) {
            vm.documentRows.splice(index, 1);
        }

        // The move actions take the row itself rather than an $index: they are invoked from inside an
        // md-menu, whose content is detached from the row it was opened on.
        function moveRowUp(row) {
            swapRows(vm.documentRows.indexOf(row), -1);
        }

        function moveRowDown(row) {
            swapRows(vm.documentRows.indexOf(row), 1);
        }

        function swapRows(from, offset) {
            var to = from + offset;

            if (from < 0 || to < 0 || to >= vm.documentRows.length) {
                return;
            }

            var moved = vm.documentRows.splice(from, 1)[0];
            vm.documentRows.splice(to, 0, moved);
        }

        function isFirstRow(row) {
            return vm.documentRows.indexOf(row) === 0;
        }

        function isLastRow(row) {
            return vm.documentRows.indexOf(row) === vm.documentRows.length - 1;
        }

        // The invoice is always sent alongside anything else chosen, so while anything else is ticked
        // its box is ticked and cannot be unticked. It is only free when it would be the only choice.
        function isRowLocked(row) {
            return row.key === INVOICE_ROW.key && hasOtherSelection();
        }

        function onSelectionChanged() {
            var invoiceRow = _.find(vm.documentRows, { key: INVOICE_ROW.key });

            if (invoiceRow && hasOtherSelection()) {
                invoiceRow.selected = true;
            }
        }

        // Forms are counted the way Done saves them: a form no longer linked to the company is not
        // shown and not saved, so it must not lock the invoice either.
        function hasOtherSelection() {
            return isDocumentSelected('Ticket') ||
                isDocumentSelected('Timesheet') ||
                vm.pref.IncludeAllForms ||
                vm.pref.IncludeAllAttachments ||
                collectSelectedForms().length > 0 ||
                collectSelectedIds(vm.selectedDocIds).length > 0;
        }

        function isDocumentSelected(key) {
            var row = _.find(vm.documentRows, { key: key });

            return !!(row && row.selected);
        }

        function toggleSection(name) {
            vm.sections[name] = !vm.sections[name];
        }

        function onCancel() {
            $mdDialog.hide();
        }

        // Returns the preference in the same shape the core api exposes on the email view model so it
        // round-trips through the existing company save. DocumentOrder carries every row whether or
        // not it is ticked, so a position set today still applies to a document ticked tomorrow.
        function onDone() {
            var preference = {
                IncludeTicketPdf: isDocumentSelected('Ticket'),
                IncludeTimesheetPdf: isDocumentSelected('Timesheet'),
                IncludeAllForms: vm.pref.IncludeAllForms,
                IncludeAllAttachments: vm.pref.IncludeAllAttachments,
                FormTemplates: collectSelectedForms(),
                AttachmentDocumentFileIds: collectSelectedIds(vm.selectedDocIds),
                DocumentOrder: _.map(vm.documentRows, 'key')
            };

            // Accounts only: a Paperwork address has no invoice to choose.
            if (invoiceIsOrderable) {
                preference.IncludeInvoicePdf = isDocumentSelected('Invoice');
            }

            $mdDialog.hide(preference);
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('app.widgets')
    .controller('a8EmailsDialogController', a8EmailsDialogController);

  function a8EmailsDialogController($mdDialog
                                    , utils
                                    , editMode
                                    , email
                                    , emailPattern) {

    //Data
    var vm = this;

    //Methods
    vm.activate = activate;
    vm.onCancel = onCancel;
    vm.formData = formData;
    vm.onDone = onDone;

    vm.emailPattern = emailPattern;

    vm.activate();

    //Implementations
    function activate(){
      if(editMode){
        vm.caption = utils.translate('WIDGETS_LOC.DIALOG_HEADER_EDIT');
        vm.emailAddress = email.EmailAddress;
        vm.isPrimary = email.IsPrimary;

      }else{
        vm.caption = utils.translate('WIDGETS_LOC.DIALOG_HEADER_ADD');
      }
    }

    function onCancel(){
      $mdDialog.hide();
    }

    function onDone(){
       var payLoad = formData();
       $mdDialog.hide(payLoad);
    }

    function formData(){
      var emailModel = {};
      emailModel['EmailAddress'] = vm.emailAddress;
      emailModel['IsPrimary'] = vm.isPrimary;
      return emailModel;
    }
  }
})();

(function(){
  'use strict';

  angular.module('app.widgets')
    .directive('a8Emails', a8Numbers);

  function a8Numbers($mdDialog, utils) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/shared/widgets/a8Emails/a8Emails-view.html',
      scope: {
        ngModel : '=',
        validateDuplicate: '&'
      },
      controller: a8EmailsController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function a8EmailsController() {
        var vm = this;
        vm.dtOptions = {
          pagingType: 'simple',
          autoWidth: false,
          responsive: true,
          sort: false
        };

        //methods
        vm.addEmail = addEmail;
        vm.editEmail = editEmail;
        vm.remove = remove;

        //Implementations
        function remove(index){
          if(vm.ngModel.length > 1){
            vm.ngModel.splice(index, 1)
            if(vm.ngModel.length == 1){
              vm.ngModel[0].IsPrimary = true;
            }
          }else {
            var alert = $mdDialog.alert()
              .title(utils.translate('WIDGETS_LOC.SECTION'))
              .textContent(utils.translate('WIDGETS_LOC.ACTION_CANCELLED'))
              .ok(utils.translate('WIDGETS_LOC.CLOSE'));
            $mdDialog
              .show(alert);
          }
        }

        function addEmail(){
          $mdDialog.show({
            templateUrl: 'app/shared/widgets/a8Emails/a8EmailsDialog.html',
            controller: 'a8EmailsDialogController as vm',
            locals: {
              editMode : false,
              email : null
            }
          }).then(function(resp){
            if(resp)
              if(vm.ngModel.length == 0){
                resp.IsPrimary = true;
                vm.ngModel.push(resp);
              }
              else{
                if(resp.IsPrimary){
                  angular.forEach(vm.ngModel, function(itm){
                    itm.IsPrimary = false;
                  });
                  vm.ngModel.push(resp);
                  vm.ngModel = alasql('select * from ? order by IsPrimary desc', [vm.ngModel]);
                }
                else{
                  vm.ngModel.push(resp);
                  vm.ngModel = alasql('select * from ? order by IsPrimary desc', [vm.ngModel]);
                }
              }
              //vm.validateDuplicate();
          });
        }

      function editEmail(email, index){
        $mdDialog.show({
          templateUrl: 'app/shared/widgets/a8Emails/a8EmailsDialog.html',
          controller: 'a8EmailsDialogController as vm',
          locals: {
            editMode : true,
            email : email
          }
        }).then(function(resp){
          if(resp)
            if(resp.IsPrimary){
              angular.forEach(vm.ngModel, function(itm){
                itm.IsPrimary = false;
              });
              vm.ngModel[index] = resp;
            }
            else{
              vm.ngModel[index] = resp;
              if(vm.ngModel.length == 1){
                vm.ngModel[0].IsPrimary = true;
              }
            }
        })
      }
    }
  }
})();

(function(){
    'use strict';

    angular.module('app.widgets')
        .directive('a8DirtyFormConfirmation', a8DirtyFormConfirmation);

    function a8DirtyFormConfirmation($stateParams) {

        let directive = {
            controller: DirtyFormConfirmationController,
            bindToController: true,
            link: DirtyFormConfirmationLink
        };

        return directive;

        function DirtyFormConfirmationController($mdDialog, $state, $scope){
            let vm = this;

            $scope.currentForm = null;
            $scope.isSaving = false;

            $scope.stateChangeStart = function(event, toState) {
                let currentScope = event.currentScope;
                let currentForm = currentScope.currentForm;

                if(!currentScope.isSaving && currentForm.$dirty)
                {
                    vm.showDialog(event, toState, currentForm);
                }
            }

            vm.showDialog = function(event, toState, currentForm){
                let confirm = $mdDialog.confirm()
                    .title('Are you sure?')
                    .textContent('You are about to navigate away from this page. All your unsaved changes will be lost.')
                    .ok('Yes')
                    .cancel('No');

                event.preventDefault();
                return $mdDialog.show(confirm).then(function(){
                    if(!_.isNil(currentForm)){
                        currentForm.$setPristine();
                    }
                    
                    $state.go(toState);
                }, function(){
                });
            }
        }

        function DirtyFormConfirmationLink(rootScope, scope, element){
            let elementName = element.name || element.ngForm;
            
            rootScope.$on('$stateChangeStart', rootScope.stateChangeStart);
            rootScope.currentForm = rootScope[elementName];
        }
    }
})();

//  https://cdn.gitcdn.link/cdn/angular/bower-material/v1.1.0-rc1/angular-material.js
//  https://github.com/angular/material/blob/master/src/components/datepicker/datePicker.js

(function() {
  'use strict';

  // POST RELEASE
  // TODO(jelbourn): Demo that uses moment.js
  // TODO(jelbourn): make sure this plays well with validation and ngMessages.
  // TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
  // TODO(jelbourn): input behavior (masking? auto-complete?)
  // TODO(jelbourn): UTC mode
  // TODO(jelbourn): RTL


  angular.module('app.widgets')
    .directive('mdDatepickerCustom', datePickerDirective);

  /**
   * @ngdoc directive
   * @name mdDatepickerCustom
   * @module material.components.datepicker
   *
   * @param {Date} ng-model The component's model. Expects a JavaScript Date object.
   * @param {expression=} ng-change Expression evaluated when the model value changes.
   * @param {Date=} md-min-date Expression representing a min date (inclusive).
   * @param {Date=} md-max-date Expression representing a max date (inclusive).
   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
   * @param {String=} md-placeholder The date input placeholder value.
   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
   * @param {boolean=} ng-required Whether a value is required for the datepicker.
   *
   * @description
   * `<md-datepicker>` is a component used to select a single date.
   * For information on how to configure internationalization for the date picker,
   * see `$mdDateLocaleProvider`.
   *
   * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
   * Supported attributes are:
   * * `required`: whether a required date is not set.
   * * `mindate`: whether the selected date is before the minimum allowed date.
   * * `maxdate`: whether the selected date is after the maximum allowed date.
   *
   * @usage
   * <hljs lang="html">
   *   <md-datepicker ng-model="birthday"></md-datepicker>
   * </hljs>
   *
   */
  function datePickerDirective() {
    return {
      template:
      // Buttons are not in the tab order because users can open the calendar via keyboard
      // interaction on the text input, and multiple tab stops for one component (picker)
      // may be confusing.
      '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
      'tabindex="-1" aria-hidden="true" ' +
      'ng-click="ctrl.openCalendarPane($event)">' +
      '<md-icon class="md-datepicker-calendar-icon" md-svg-icon="md-calendar"></md-icon>' +
      '</md-button>' +
      '<div class="md-datepicker-input-container" ' +
      'ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
      '<input class="md-datepicker-input" aria-haspopup="true" ' +
      'ng-focus="ctrl.setFocused(true)" ng-blur="ctrl.setFocused(false)" ng-model="ctrl.defaultDate" mask="{{::ctrl.mask}}" mask-clean="{{::ctrl.cleanMask}}" mask-restrict="{{::ctrl.restrict}}">' +
      '<md-button type="button" md-no-ink ' +
      'class="md-datepicker-triangle-button md-icon-button" ' +
      'ng-click="ctrl.openCalendarPane($event)" ' +
      'aria-label="{{::ctrl.dateLocale.msgOpenCalendar}}">' +
      '<div class="md-datepicker-expand-triangle"></div>' +
      '</md-button>' +
      '</div>' +

      // This pane will be detached from here and re-attached to the document body.
      '<div class="md-datepicker-calendar-pane md-whiteframe-z1">' +
      '<div class="md-datepicker-input-mask">' +
      '<div class="md-datepicker-input-mask-opaque"></div>' +
      '</div>' +
      '<div class="md-datepicker-calendar">' +
      '<md-calendar role="dialog" aria-label="{{::ctrl.dateLocale.msgCalendar}}" ' +
      'md-min-date="ctrl.minDate" md-max-date="ctrl.maxDate"' +
      'md-date-filter="ctrl.dateFilter"' +
      'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
      '</md-calendar>' +
      '</div>' +
      '</div>',
      require: ['ngModel', 'mdDatepickerCustom', '?^mdInputContainer'],
      scope: {
        minDate: '=mdMinDate',
        maxDate: '=mdMaxDate',
        placeholder: '@mdPlaceholder',
        dateFilter: '=mdDateFilter',
        //  Custom attributes added
        defaultDate: '@mdCustomDefaultDate',
        dateFormat: '@mdDateFormat',
        mask: '@mdCustomMask',
        cleanMask: '@mdCustomCleanMask',
        restrict: '@mdCustomRestrict',
        required: '@mdCustomRequired'
      },
      controller: DatePickerCtrl,
      controllerAs: 'ctrl',
      bindToController: true,
      link: function(scope, element, attr, controllers) {
        var ngModelCtrl = controllers[0];
        var mdDatePickerCtrl = controllers[1];

        var mdInputContainer = controllers[2];
        if (mdInputContainer) {
          throw Error('md-datepicker should not be placed inside md-input-container.');
        }

        mdDatePickerCtrl.configureNgModel(ngModelCtrl);
      }
    };
  }

  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
  var EXTRA_INPUT_SIZE = 3;

  /** Class applied to the container if the date is invalid. */
  var INVALID_CLASS = 'md-datepicker-invalid';

  /** Default time in ms to debounce input event by. */
  var DEFAULT_DEBOUNCE_INTERVAL = 500;

  /**
   * Height of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_HEIGHT = 368;

  /**
   * Width of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_WIDTH = 360;

  /**
   * Controller for md-datepicker.
   *
   * @ngInject @constructor
   */
  function DatePickerCtrl($scope, $element, $attrs, $compile, $timeout, $window,
                          $mdConstant, $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF) {
    /** @final */
    this.$compile = $compile;

    /** @final */
    this.$timeout = $timeout;

    /** @final */
    this.$window = $window;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdConstant = $mdConstant;

    /* @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.$$rAF = $$rAF;

    /**
     * The root document element. This is used for attaching a top-level click handler to
     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
     * instead of body because, when scrolling is disabled, some browsers consider the body element
     * to be completely off the screen and propagate events directly to the html element.
     * @type {!angular.JQLite}
     */
    this.documentElement = angular.element(document.documentElement);

    /** @type {!angular.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {HTMLInputElement} */
    this.inputElement = $element[0].querySelector('input');

    /** @final {!angular.JQLite} */
    this.ngInputElement = angular.element(this.inputElement);

    /** @type {HTMLElement} */
    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');

    /** @type {HTMLElement} Floating calendar pane. */
    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');

    /** @type {HTMLElement} Calendar icon button. */
    this.calendarButton = $element[0].querySelector('.md-datepicker-button');

    /**
     * Element covering everything but the input in the top of the floating calendar pane.
     * @type {HTMLElement}
     */
    this.inputMask = $element[0].querySelector('.md-datepicker-input-mask-opaque');

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Attributes} */
    this.$attrs = $attrs;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @type {Date} */
    this.date = null;

    /** @type {boolean} */
    this.isFocused = false;

    /** @type {boolean} */
    this.isDisabled;
    this.setDisabled($element[0].disabled || angular.isString($attrs['disabled']));

    /** @type {boolean} Whether the date-picker's calendar pane is open. */
    this.isCalendarOpen = false;

    /**
     * Element from which the calendar pane was opened. Keep track of this so that we can return
     * focus to it when the pane is closed.
     * @type {HTMLElement}
     */
    this.calendarPaneOpenedFrom = null;

    this.calendarPane.id = 'md-date-pane' + $mdUtil.nextUid();

    $mdTheming($element);

    /** Pre-bound click handler is saved so that the event listener can be removed. */
    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);

    /** Pre-bound resize handler so that the event listener can be removed. */
    this.windowResizeHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

    // Unless the user specifies so, the datepicker should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if (!$attrs['tabindex']) {
      $element.attr('tabindex', '-1');
    }

    this.installPropertyInterceptors();
    this.attachChangeListeners();
    this.attachInteractionListeners();

    var self = this;
    $scope.$on('$destroy', function() {
      self.detachCalendarPane();
    });
  }

  /**
   * Sets up the controller's reference to ngModelController.
   * @param {!angular.NgModelController} ngModelCtrl
   */
  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl) {
    this.ngModelCtrl = ngModelCtrl;

    var self = this;
    ngModelCtrl.$render = function() {
      var value = self.ngModelCtrl.$viewValue;

      if (value && !(value instanceof Date)) {
        throw Error('The ng-model for md-datepicker must be a Date instance. ' +
          'Currently the model is a: ' + (typeof value));
      }

      self.date = value;
      self.inputElement.value = self.dateLocale.formatDate(value);
      self.resizeInputElement();
      self.updateErrorState();
    };
  };

  /**
   * Attach event listeners for both the text input and the md-calendar.
   * Events are used instead of ng-model so that updates don't infinitely update the other
   * on a change. This should also be more performant than using a $watch.
   */
  DatePickerCtrl.prototype.attachChangeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-change', function(event, date) {
      self.ngModelCtrl.$setViewValue(date);
      self.date = date;
      if((self.dateFormat == "") || (self.dateFormat == '') || (self.dateFormat == null)){
        self.inputElement.value = moment(date).format("MM/DD/YYYY");
      }
      else{
        self.inputElement.value = moment(date).format(self.dateFormat);
      }
      
      self.closeCalendarPane();
      self.resizeInputElement();
      self.updateErrorState();
    });

    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
    // TODO(chenmike): Add ability for users to specify this interval.
    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
      DEFAULT_DEBOUNCE_INTERVAL, self));
  };

  /** Attach event listeners for user interaction. */
  DatePickerCtrl.prototype.attachInteractionListeners = function() {
    var self = this;
    var $scope = this.$scope;
    var keyCodes = this.$mdConstant.KEY_CODE;

    // Add event listener through angular so that we can triggerHandler in unit tests.
    self.ngInputElement.on('keydown', function(event) {
      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
        self.openCalendarPane(event);
        $scope.$digest();
      }
    });

    $scope.$on('md-calendar-close', function() {
      self.closeCalendarPane();
    });
  };

  /**
   * Capture properties set to the date-picker and imperitively handle internal changes.
   * This is done to avoid setting up additional $watches.
   */
  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
    var self = this;

    if (this.$attrs['ngDisabled']) {
      // The expression is to be evaluated against the directive element's scope and not
      // the directive's isolate scope.
      var scope = this.$scope.$parent;

      if (scope) {
        scope.$watch(this.$attrs['ngDisabled'], function(isDisabled) {
          self.setDisabled(isDisabled);
        });
      }
    }

    Object.defineProperty(this, 'placeholder', {
      get: function() { return self.inputElement.placeholder; },
      set: function(value) { self.inputElement.placeholder = value || ''; }
    });
  };

  /**
   * Sets whether the date-picker is disabled.
   * @param {boolean} isDisabled
   */
  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
    this.isDisabled = isDisabled;
    this.inputElement.disabled = isDisabled;
    this.calendarButton.disabled = isDisabled;
  };

  /**
   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
   *   - mindate: whether the selected date is before the minimum date.
   *   - maxdate: whether the selected flag is after the maximum date.
   *   - filtered: whether the selected date is allowed by the custom filtering function.
   *   - valid: whether the entered text input is a valid date
   *
   * The 'required' flag is handled automatically by ngModel.
   *
   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
   */
  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
    var date = opt_date || this.date;

    // Clear any existing errors to get rid of anything that's no longer relevant.
    this.clearErrorState();

    if (this.dateUtil.isValidDate(date)) {
      // Force all dates to midnight in order to ignore the time portion.
      date = this.dateUtil.createDateAtMidnight(date);

      if (this.dateUtil.isValidDate(this.minDate)) {
        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
      }

      if (this.dateUtil.isValidDate(this.maxDate)) {
        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
      }

      if (angular.isFunction(this.dateFilter)) {
        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
      }
    } else {
      // The date is seen as "not a valid date" if there is *something* set
      // (i.e.., not null or undefined), but that something isn't a valid date.
      //  this.ngModelCtrl.$setValidity('valid', date == null);
      this.ngModelCtrl.$setValidity('valid', !isNaN(date));
      this.ngModelCtrl.$setValidity('required', this.required !== "true" || date !== null);
    }

    // TODO(jelbourn): Change this to classList.toggle when we stop using PhantomJS in unit tests
    // because it doesn't conform to the DOMTokenList spec.
    // See https://github.com/ariya/phantomjs/issues/12782.
    if (!this.ngModelCtrl.$valid) {
      this.inputContainer.classList.add(INVALID_CLASS);
    }
  };

  /** Clears any error flags set by `updateErrorState`. */
  DatePickerCtrl.prototype.clearErrorState = function() {
    this.inputContainer.classList.remove(INVALID_CLASS);
    ['mindate', 'maxdate', 'filtered', 'valid', 'required'].forEach(function(field) {
      this.ngModelCtrl.$setValidity(field, true);
    }, this);
  };

  /** Resizes the input element based on the size of its content. */
  DatePickerCtrl.prototype.resizeInputElement = function() {
    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
  };

  /**
   * Sets the model value if the user input is a valid date.
   * Adds an invalid class to the input element if not.
   */
  DatePickerCtrl.prototype.handleInputEvent = function() {
    var inputString = this.inputElement.value;
    var parsedDate = inputString ? this.dateLocale.parseDate(inputString) : null;
    this.dateUtil.setDateTimeToMidnight(parsedDate);

    // An input string is valid if it is either empty (representing no date)
    // or if it parses to a valid date that the user is allowed to select.
    var isValidInput = inputString == '' || (
        this.dateUtil.isValidDate(parsedDate) &&
        this.dateLocale.isDateComplete(inputString) &&
        this.isDateEnabled(parsedDate)
      );

    // The datepicker's model is only updated when there is a valid input.
    if (isValidInput) {
      this.ngModelCtrl.$setViewValue(parsedDate);
      this.date = parsedDate;
    }

    this.updateErrorState(parsedDate);
  };

  /**
   * Check whether date is in range and enabled
   * @param {Date=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
      (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
  };

  /** Position and attach the floating calendar to the document. */
  DatePickerCtrl.prototype.attachCalendarPane = function() {
    var calendarPane = this.calendarPane;
    calendarPane.style.transform = '';
    this.$element.addClass('md-datepicker-open');

    var elementRect = this.inputContainer.getBoundingClientRect();
    var bodyRect = document.body.getBoundingClientRect();

    // Check to see if the calendar pane would go off the screen. If so, adjust position
    // accordingly to keep it within the viewport.
    var paneTop = elementRect.top - bodyRect.top;
    var paneLeft = elementRect.left - bodyRect.left;

    // If ng-material has disabled body scrolling (for example, if a dialog is open),
    // then it's possible that the already-scrolled body has a negative top/left. In this case,
    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
    // though, the top of the viewport should just be the body's scroll position.
    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
      -bodyRect.top :
      document.body.scrollTop;

    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
      -bodyRect.left :
      document.body.scrollLeft;

    var viewportBottom = viewportTop + this.$window.innerHeight;
    var viewportRight = viewportLeft + this.$window.innerWidth;

    // If the right edge of the pane would be off the screen and shifting it left by the
    // difference would not go past the left edge of the screen. If the calendar pane is too
    // big to fit on the screen at all, move it to the left of the screen and scale the entire
    // element down to fit.
    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
      } else {
        paneLeft = viewportLeft;
        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
        calendarPane.style.transform = 'scale(' + scale + ')';
      }

      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    // If the bottom edge of the pane would be off the screen and shifting it up by the
    // difference would not go past the top edge of the screen.
    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
      viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    calendarPane.style.left = paneLeft + 'px';
    calendarPane.style.top = paneTop + 'px';
    document.body.appendChild(calendarPane);

    // The top of the calendar pane is a transparent box that shows the text input underneath.
    // Since the pane is floating, though, the page underneath the pane *adjacent* to the input is
    // also shown unless we cover it up. The inputMask does this by filling up the remaining space
    // based on the width of the input.
    this.inputMask.style.left = elementRect.width + 'px';

    // Add CSS class after one frame to trigger open animation.
    this.$$rAF(function() {
      calendarPane.classList.add('md-pane-open');
    });
  };

  /** Detach the floating calendar pane from the document. */
  DatePickerCtrl.prototype.detachCalendarPane = function() {
    this.$element.removeClass('md-datepicker-open');
    this.calendarPane.classList.remove('md-pane-open');
    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');

    if (this.isCalendarOpen) {
      this.$mdUtil.enableScrolling();
    }

    if (this.calendarPane.parentNode) {
      // Use native DOM removal because we do not want any of the angular state of this element
      // to be disposed.
      this.calendarPane.parentNode.removeChild(this.calendarPane);
    }
  };

  /**
   * Open the floating calendar pane.
   * @param {Event} event
   */
  DatePickerCtrl.prototype.openCalendarPane = function(event) {
    if (!this.isCalendarOpen && !this.isDisabled) {
      this.isCalendarOpen = true;
      this.calendarPaneOpenedFrom = event.target;

      // Because the calendar pane is attached directly to the body, it is possible that the
      // rest of the component (input, etc) is in a different scrolling container, such as
      // an md-content. This means that, if the container is scrolled, the pane would remain
      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
      // also matches the native behavior for things like `<select>` on Mac and Windows.
      this.$mdUtil.disableScrollAround(this.calendarPane);

      this.attachCalendarPane();
      this.focusCalendar();

      // Attach click listener inside of a timeout because, if this open call was triggered by a
      // click, we don't want it to be immediately propogated up to the body and handled.
      var self = this;
      this.$mdUtil.nextTick(function() {
        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
        // events aren't propogated under most circumstances.
        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        self.documentElement.on('click touchstart', self.bodyClickHandler);
      }, false);

      window.addEventListener('resize', this.windowResizeHandler);
    }
  };

  /** Close the floating calendar pane. */
  DatePickerCtrl.prototype.closeCalendarPane = function() {
    if (this.isCalendarOpen) {
      this.detachCalendarPane();
      this.isCalendarOpen = false;
      this.calendarPaneOpenedFrom.focus();
      this.calendarPaneOpenedFrom = null;

      this.ngModelCtrl.$setTouched();

      this.documentElement.off('click touchstart', this.bodyClickHandler);
      window.removeEventListener('resize', this.windowResizeHandler);
    }
  };

  /** Gets the controller instance for the calendar in the floating pane. */
  DatePickerCtrl.prototype.getCalendarCtrl = function() {
    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
  };

  /** Focus the calendar in the floating pane. */
  DatePickerCtrl.prototype.focusCalendar = function() {
    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
    var self = this;
    this.$mdUtil.nextTick(function() {
      self.getCalendarCtrl().focus();
    }, false);
  };

  /**
   * Sets whether the input is currently focused.
   * @param {boolean} isFocused
   */
  DatePickerCtrl.prototype.setFocused = function(isFocused) {
    if (!isFocused) {
      this.ngModelCtrl.$setTouched();
    }
    this.isFocused = isFocused;
  };

  /**
   * Handles a click on the document body when the floating calendar pane is open.
   * Closes the floating calendar pane if the click is not inside of it.
   * @param {MouseEvent} event
   */
  DatePickerCtrl.prototype.handleBodyClick = function(event) {
    if (this.isCalendarOpen) {
      // TODO(jelbourn): way want to also include the md-datepicker itself in this check.
      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
      if (!isInCalendar) {
        this.closeCalendarPane();
      }

      this.$scope.$digest();
    }
  };
})();


/**
 * http://www.alloc8pro.com/
 * Copyright (c) 2016
 * Created on 5/10/2016
 * sangracetiu@gmail.com
 */

(function () {
  'use strict';

  angular.module('app.widgets')
    .directive('a8AddressDialog', a8AddressDialog);

  /** @ngInject */
  function a8AddressDialog($mdDialog, addressModel, _) {
    var directive = {
      restrict: 'E'
      , replace: true
      , template: '<input type="text" class="md-block" name="address" ng-model="value" placeholder="Address"' +
      ' ng-click="spawnAddressDialog()">'
      , require: 'ngModel'
      , scope: {
          value: '='
        , onShowDialog: '&'
        , 'a8Val': '='
        , title: '@'
        , model: '='
        , types: '='
      }
      , link: linkFunc
    };

    return directive;

    //////////

    function linkFunc(scope, element, attr) {
      scope.alert = '';
      var controller = 'AddressController as vm';
      scope.spawnAddressDialog = spawnAddressDialog;

      activate();

      function activate() {

        // Fix issues in lodash
        if( typeof _.contains === 'undefined' ) {
          _.contains = _.includes;
        }

        scope.$watch('scope.model.FullAddress', function() {
          scope.value = scope.model.FullAddress;
        });

      }

      function spawnAddressDialog() {
        $mdDialog.show({
          parent: angular.element(document.body)
          , locals: { title: scope.title, loadedData: scope.model, addressTypes: scope.types }
          , templateUrl: 'app/shared/widgets/a8Component_company_address/address.html'
          , controller: controller
        }).then(function (data) {
          //if (answer.Value) {
          if (data) {
            scope.model.BldgName = data.BldgName;
            scope.model.City = data.City;
            scope.model.FullAddress = data.FullAddress;
            scope.model.PostCode = data.PostCode;
            scope.model.State = data.State;
            scope.model.StreetName = data.StreetName;
            scope.model.StreetNumber = data.StreetNumber;
            scope.value = data.FullAddress;
          }
        }, function () {
          scope.alert = 'You cancelled the dialog.';
        });
      }

    }

  }
})();

(function() {
    'use strict';

    angular
        .module('app.widgets')
        .controller('AddressController', AddressController);

    /** @ngInject */
    function AddressController($log,
        $scope,
        $mdDialog,
        utils,
        uiGmapGoogleMapApi,
        locals) {

        var vm = this;

        vm.title = locals.title;
        vm.address = {};
        vm.addressTypes = [];
        vm.usedGoogleMaps = false;

        vm.onDone = onDone;
        vm.onCancel = onCancel;
        vm.onShowExtraFields = onShowExtraFields;

        activate();

        function activate() {
            angular.extend(vm.address, locals.loadedData);
            vm.menu = checkIfObjectIsPopulated(locals.loadedData);
            vm.addressTypes = locals.addressTypes;
        }

        function onDone(answer) {
            var addrObj = {
                BldgName: answer.BldgName,
                StreetName: answer.StreetName,
                StreetNumber: answer.StreetNumber,
                City: answer.City,
                State: answer.State,
                PostCode: answer.PostCode,
                FullAddress: answer.FullAddress
            };

            if (!answer.FullAddress || !vm.usedGoogleMaps) {
                addrObj.FullAddress = utils.isNull(addrObj.BldgName, '') + appendSeparator(addrObj.BldgName) +
                    utils.isNull(addrObj.StreetNumber, '') + appendSeparator(addrObj.StreetNumber) +
                    utils.isNull(addrObj.StreetName, '') + appendSeparator(addrObj.StreetName) +
                    utils.isNull(addrObj.City, '');
            }

            $mdDialog.hide(addrObj);
        }

        function onCancel() {
            $mdDialog.cancel();
        }

        function onShowExtraFields() {
            vm.menu = !vm.menu;
        }

        function checkIfObjectIsPopulated(data) {
            if (!data) return false;

            return (data.PostCode ||
                data.BldgName ||
                data.StreetNumber ||
                data.StreetName ||
                data.City ||
                data.State);
        }

        function appendSeparator(value) {
            return value ? ', ' : '';
        }

        angular.extend($scope, {
            map: {
                center: {
                    latitude: 40.1451,
                    longitude: -99.6680
                },
                zoom: 4
            },
            searchbox: {
                template: 'app/shared/widgets/a8Component_company_address/address-searchbox.html',
                events: {
                    places_changed: function(searchBox) {
                        var place = searchBox.getPlaces(),
                            tempAddress = {};

                        place = place[0];
                        tempAddress.FullAddress = place.formatted_address;
                        $log.debug(place);

                        if (place !== undefined) {
                            vm.menu = true;
                            vm.usedGoogleMaps = true;

                            var componentForm = {
                                premise: 'long_name',
                                street_number: 'short_name',
                                route: 'long_name',
                                locality: 'long_name',
                                administrative_area_level_1: 'short_name',
                                postal_code: 'short_name'
                            };

                            for (var i = 0; i < place.address_components.length; i++) {
                                var addressType = place.address_components[i].types[0];

                                if (componentForm[addressType]) {
                                    if (addressType === 'premise')
                                        tempAddress.BldgName = place.address_components[i][componentForm[addressType]];
                                    if (addressType === 'route')
                                        tempAddress.StreetName = place.address_components[i][componentForm[addressType]];
                                    if (addressType === 'street_number')
                                        tempAddress.StreetNumber = place.address_components[i][componentForm[addressType]];
                                    if (addressType === 'locality')
                                        tempAddress.City = place.address_components[i][componentForm[addressType]];
                                    if (addressType === 'administrative_area_level_1')
                                        tempAddress.State = place.address_components[i][componentForm[addressType]];
                                    if (addressType === 'postal_code')
                                        tempAddress.PostCode = place.address_components[i][componentForm[addressType]];
                                }
                            }

                            angular.extend(vm.address, tempAddress);
                        }
                    }
                }
            },
            options: {
                scrollwheel: false
            }
        });

        uiGmapGoogleMapApi.then(function(maps) {
            maps.visualRefresh = true;
        });
    }
})();

/**
 * http://www.alloc8pro.com/
 * Copyright (c) 2016
 * Created on 5/10/2016
 * sangracetiu@gmail.com
 */

(function () {
  'use strict';

  angular.module('app.widgets')
    .directive('a8ArchiveDialog', a8ArchiveDialog);

  /** @ngInject */
  function a8ArchiveDialog($mdDialog, contactService) {
    var directive = {
      restrict: 'A'
      , scope: {
        'a8Title': '@'
        , 'a8Content': '@'
        , 'a8Label': '@'
        , 'a8Ok': '@'
        , 'a8OnArchive': '&'
      }
      , link: linkFunc
    };

    return directive;

    //////////

    function linkFunc(scope, element, attr, controller) {
      
      // var title = attr.a8Title
      //   , content = scope.a8Content
      //   , label = scope.a8Label
      //   , ok = scope.a8Ok
      var cancel = "Cancel";

      element.bind('click', function () {
        var confirm = $mdDialog.confirm()
          .title(scope.a8Title)
          .textContent(scope.a8Content)
          .ariaLabel(scope.label)
          //.targetEvent(ev)
          .ok(scope.a8Ok)
          .cancel(cancel);

        $mdDialog.show(confirm).then(function () {
          (scope.a8OnArchive || angular.noop)();
        }, function () {

        });
      });
    }
  }
})();

(function() {
    'use strict';

    angular.module('app.widgets')
        .directive('a8Claims', a8Claims);

    /** @ngInject */
    function a8Claims(identityService, claimsService) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, elem, attrs) {
            var hasGrantAccess = false;

            var claimsAccess = scope.$eval(attrs['claimsAccess']),
                claimsDenyAction = attrs['claimsDenyAction'] || 'disable',
                claimsOnValidate = scope.$eval(attrs['claimsOnValidate']);

            evaluateClaimsAccess();


            scope.$on('a8Claims:refresh', function(e, data) {
                evaluateClaimsAccess();
            });

            function evaluateClaimsAccess() {
                if (claimsAccess) {
                    hasGrantAccess = identityService.checkAccess(claimsAccess);
                } else if (claimsOnValidate || typeof claimsOnValidate === 'function') {
                    hasGrantAccess = (claimsOnValidate || angular.noop)(identityService, claimsService);
                }

                if (!hasGrantAccess) {
                    claimsDenyAction === 'disable' ? disableElement(!hasGrantAccess) : hideElement(!hasGrantAccess);
                }
            }

            function disableElement(isDisable) {
                elem[0].disabled = isDisable;
            }

            function hideElement(isHidden) {
                elem[0].style.display = isHidden ? 'none' : '';
            }
        }
    }
})();

/**
* Busy button directive
* rlc/rcnet 4.29.2016
*
* Usage:
* Markup -
*  <!-- Busy button broadcast syntax -->
*  <button type="submit" class="btn btn-primary"  busy-button busy-name="saveButton" busy-text="saving...">Save</button>
*  <button type="button" class="btn btn-primary" busy-button busy-name="updateButton" busy-text="updating..." ng-click="onUpdate()">Update</button>
*
*  To make Busy Button:  $scope.$broadcast('saveButton:busyAll');
*  To free all:  $scope.$broadcast('busyButton:freeAll');
*/

(function() {
    'use strict';
    
     angular.module('app.widgets')
           .directive('a8BusyButton', a8BusyButton);
   
    /** @ngInject */ 
    function a8BusyButton($rootScope) {
        var directive = {
            restrict: 'A',
            scope: {
                busyText: '@',
                busyShow: '=',
                busyName: '@'
            },
            link: linkFunc 
        };
        
        return directive;
        
        ///////
        
        function linkFunc() {
            
            var origText = elem[0].innerHTML;

            // Template for busy button
            var tmpl = ['<i class="fa fa-spinner fa-spin"></i>',
                        '&nbsp;',
                        scope.busyText
            ].join('\n');

            // Private func
            function setBusyItem(value) {
                if (elem[0] && value == true) {
                    elem[0].innerHTML = tmpl;
                    elem[0].disabled = true;
                } else {
                    // Revert to original value
                    elem[0].innerHTML = origText;
                    elem[0].disabled = false;
                }
            };
            
            // ------
            // APIs
            // ------
            scope.$watch('busyShow', function (value) {
                setBusyItem(value);
            });
            
            // name:busyAll
            scope.$on(scope.busyName + ':busyAll', function (evt, args) {
                setBusyItem(true);
                $rootScope.$broadcast('busyButton:disableAllExceptFor', scope.busyName);
            });

            // busyButton:freeAll
            scope.$on('busyButton:freeAll', function (evt, args) {
                setBusyItem(false);
            });

            // Callable only by busyAll event
            // Disable all busyButton controls except for the Parent trigger
            $rootScope.$on('busyButton:disableAllExceptFor', function (evt, args) {
                if (scope.busyName !== args)
                    elem[0].disabled = true;
            });
        }
    }
    
})();
// Back to top Directive
// Not working yet!!!
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('a8BackToTop', a8BackToTop);

    function a8BackToTop($) {

        var service = {
            restrict: 'E',
            replace: true,
            template: '<div class="back-to-top"><md-icon md-font-icon="icon-android" class="icon s16"></md-icon></div>',
            link: linkFunc
        };

        return service;

        function linkFunc($scope, element, attrs) {

            $(window).scroll(function () {

                if ($(window).scrollTop() <= 0) {
                    $(element).fadeOut();
                }
                else {
                    $(element).fadeIn();
                }

            });

            $(element).on('click', function () {
                $('html, body').animate({ scrollTop: 0 }, 'fast');
            });
        }

    }
})();
(function() {
    'use strict';
    
     angular.module('app.widgets')
           .directive('a8ActionPanel', a8ActionPanel);
           
      /** @ngInject */   
     function a8ActionPanel ($parse, $log) {
            var directive =  {
                restrict: 'E',
                transclude: true,
                templateUrl: '/app/shared/widgets/a8ActionPanel/a8ActionPanel.html',
                scope: {
                  behavior: '='
                },
                controller: actionPanelController,
                controllerAs: 'actionPanelVm',
                bindToController: true
            };
            
          return directive;
            
           ///////
            
           function actionPanelController($scope) {
               var actionPanelVm = this,
                    defaults = {
                        isBusy: false,
                        message: '',
                        showTransclude: true
                    };
             
               actionPanelVm.model = angular.extend({}, defaults);
                
               activate();
               
               function activate() {
                   
                 $scope.$watch('actionPanelVm.model.isBusy', function(val) {
                     actionPanelVm.model.showTransclude = !val;
                 });  
                   
                 // Attach behavior methods
                 if (actionPanelVm.behavior && typeof actionPanelVm.behavior === 'object') {
                   actionPanelVm.behavior.setBusy = setBusy;
                 }    
               }
               
              /**
               * busyObj compose of: {isBusy, message}
               */
              function setBusy(busyObj) {
                 actionPanelVm.model = angular.extend({}, defaults, busyObj);
              }
           }
     }      
     
})();
/**
 * http://www.alloc8pro.com/
 * Copyright (c) 2016
 * Created on 5/10/2016
 * sangracetiu@gmail.com
 */

(function () {
  'use strict';

  angular.module('app.corelib')
    .directive('contactPreference', contactPreference);

  /** @ngInject */
  function contactPreference($mdDialog) {
    var directive = {
      restrict: 'E'
      , replace: true
      , template: '<a href="#" ng-click="spawnContactPreferenceDialog()">Contact Preference</a>'
      , link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attr) {
      var controller = 'ContactPreferenceController as vm';
      scope.spawnContactPreferenceDialog = spawnContactPreferenceDialog;

      function spawnContactPreferenceDialog() {
        $mdDialog.show({
          parent: angular.element(document.body)
          , templateUrl: 'app/shared/corelib/preference/contact-preference.html'
          , controller: controller
        });
      }

    }

  }
})();

(function () {
  'use strict';

  angular.module('app.corelib')
    .controller('ContactPreferenceController', ContactPreferenceController);

  /** @ngInject */
  function ContactPreferenceController($scope,
                                       blockUI,
                                       $mdDialog) {
    //Data
    var vm = this;
    vm.title = "Contact Preference";

    //Methods
    vm.onCancel = onCancel;

    //Implementations
    function onCancel(){
      $mdDialog.hide();
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.corelib')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll2', msScrollDirective)


    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 0.5,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll2');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Update the scrollbar on element click
                    iElement.on('click', init);
                    // iElement.on('mouseout', destroy);
                    iElement.on('mouseleave', destroy);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    function init() {
                        iElement.addClass('ms-color');
                        PerfectScrollbar.initialize(iElement[0], options);
                    }

                    function destroy() {
                        iElement.removeClass('ms-color');
                        iElement[0].scrollTop = 0;
                        PerfectScrollbar.update(iElement[0])
                        PerfectScrollbar.destroy(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        PerfectScrollbar.destroy(iElement[0]);
                    });

                };
            }
        };
    }

})();

(function() {
    'use strict';

    angular.module('app.corelib')
        .service('userDataModel', userDataModel);

    /** @ngInject */
    function userDataModel() {
        return function() {
            var self = this;
            var defaults = {
                Email: null,
                FullName: null,
                PhotoUrl: null,
                ContactId: null,
                UserId: null,
                Username: null,
                Claims: [],
                AccessToken: null,
                RefreshToken: null
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults;
                var opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
                self.Claims.length = 0;
            }
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.corelib')
    .service('addressModel', function (validateFactory) {
      return function () {
        var self = this
          , defaults = {
            AddressType: null
          , BldgName: null
          , StreetName: null
          , StreetNumber: null
          , City: null
          , State: null
          , PostCode: null
          , FullAddress: null // formatted based on Google
        };

        self.map = mapper;
        self.getFormattedAddress = getFormattedAddress;
        self.map();

        function mapper(options) {
          var mapValue = options || defaults
              , opts = angular.extend(this, defaults, mapValue);
           return this;
        }

        function getFormattedAddress() {
          var address = validateFactory.isNotEmpty(this.BldgName) + ', '
            + validateFactory.isNotEmpty(this.StreetNumber) + ', '
            + validateFactory.isNotEmpty(this.StreetName) + ', '
            + validateFactory.isNotEmpty(this.AddressStateId) + ', '
            + validateFactory.isNotEmpty(this.City) + ', '
            + validateFactory.isNotEmpty(this.State);

          return address;
        };
      };
    });
})();


(function() {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('TodoTabController', TodoTabController);

    /** @ngInject */
    function TodoTabController(todoNotificationService, $timeout, timeFactory, $injector, $mdSidenav, blockUI) {
        var vm = this;

        vm.notifications = todoNotificationService.unReadNotifications;
        vm.readNotifications = todoNotificationService.readNotifications;
        vm.hasUnreadData = todoNotificationService.hasUnreadNotification;
        vm.model = todoNotificationService;
        vm.openNotification = openNotification;
        vm.routeNotification = routeNotification;
        vm.getTimeAgo = getTimeAgo;
        vm.dismissAll = dismissAll;

        load();

        function load() {
            // Get Read and Unread notifications
            todoNotificationService.onNotificationReceived = notificationReceived;
            todoNotificationService.refreshNotifications();
        }

        function notificationReceived() {
            vm.hasUnreadData = todoNotificationService.hasUnreadNotification;
        }

        function openNotification(notification) {
            todoNotificationService.openNotification(notification).then(function(resp) {
                routeNotification(notification);
            }, function(ex) {

            });
        }

        function routeNotification(notification) {
            var routeId = notification.PageRouting.PageRoute;
            var resourceId = notification.PageRouting.ResourceId;
            var subResourceId = notification.PageRouting.SubResourceId || null;

            var route = _.find(todoNotificationService.PageRoutes, {
                Id: routeId
            });

            var params = {
                // main ids
                cid: resourceId,
                Id: resourceId,
                id: resourceId,
                kid: resourceId,

                // sub ids
                skillid: subResourceId,
                trainingid: subResourceId,
                itemid: subResourceId,
                equipmentid: subResourceId,

                // equipment route
                new: routeId === 15,
                edit: routeId === 16,

                // boards
                view: routeId === 21 || routeId === 23 ? "day" : (routeId === 22 || routeId === 24 ? "week" : "")
            };

            // Go!
            if (route) {
                blockUI.start({
                    message: 'Loading page...'
                });
                var stateProvider = $injector.get('$state');
                stateProvider.go(route.state, params, {
                    location: true,
                    inherit: false
                }).then(function() {
                    blockUI.stop();
                    $mdSidenav('quick-panel').close();
                });
            }
        }

        function getTimeAgo(time) {
            var myDate = new Date(time * 1000);
            if (myDate.toLocaleString() !== "Invalid Date") {
                return myDate.toLocaleString(); // myDate.toGMTString()
            }
            myDate = timeFactory.timeParser(time);
            if (myDate !== "Invalid date") {
                return myDate;
            }
            return time;
        }

        function dismissAll() {
            todoNotificationService.dismissAll();
        }
    }

})();

//////////
//function scrollToBottomOfChat(speed) {
//  var chatDialog = angular.element('#chat-dialog');
//
//  $timeout(function () {
//    chatDialog.animate({
//      scrollTop: chatDialog[0].scrollHeight
//    }, speed);
//  }, 0);
//
//}

(function () {
  'use strict';

  angular.module('app.workforce')
    .factory('WorkforceViewService', WorkforceViewService);

  /** @ngInject */
  function WorkforceViewService($mdDialog, workforceApi, utils) {

    var service = {
      workforce : [],
      loader : false,
      operationMessage : null,
      get : get,
      showDialog : showDialog,
      remove : remove
    };

    function showDialog(data, isEdit){
      $mdDialog.show({
        templateUrl : 'app/main/workForceParticipation/view/dialog/work-force-participation-dialog.html',
        controller : 'WorkforceDialogController as vm',
        locals : {
          isEdit : isEdit,
          data : data
        }
      }).then(function(data){
        if(data){
          service.get();
        }
      })
    }

    function get(){
      service.loader = true;
      service.operationMessage = utils.translate('WORKFORCE.LOAD_MESSAGE');
      workforceApi.get().then(function(resp){
        service.loader = false;
        service.workforce = resp.data;
        service.workforce = service.skills_level.sort(function(a, b){
          return a.Name - b.Name;
        });
      });
    }

    function remove(Id){
      service.loader = true;
      service.operationMessage = utils.translate('WORKFORCE.DELETE_ITEM_MESSAGE');
      workforceApi.remove(Id).then(function(){
        service.loader = false;
        service.get();
      });
    }

    return service;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.workforce')
    .controller('WorkforceViewController', WorkforceViewController);

  function WorkforceViewController(searchDelay, WorkforceViewService) {
    var vm = this;
    vm.dtInstance = {};
    vm.query = null;
    vm.service = WorkforceViewService;

    vm.searchTable = searchTable;

    vm.dtOptions = {
      dom: 'rt<"bottom"lip><"clear">',
      pagingType: 'full_numbers',
      searchDelay: searchDelay,
      autoWidth: true,
      responsive: false
    };

    function searchTable() {
      setTimeout(function () {
        vm.dtInstance.DataTable.search(vm.query);
        vm.dtInstance.DataTable.search(vm.query).draw();
      }, searchDelay);
    }

    function activate(){
      vm.service.workforce = [];
      vm.service.get();
    }

    activate();
  }
})();

(function() {
    'use strict';

    angular.module('app.vehicle')
        .factory('vehicleService', vehicleService);

    /** @ngInject */
    function vehicleService(
        utils,
        $mdToast,
        vehicleApi,
        blockUI
    ) {
        var service = {
            vehicleMakes: [],
            vehicleModels: [],
            getVehiclesMakesAndModels: getVehiclesMakesAndModels,
            getVehiclesMakes: getVehiclesMakes,
            getVehiclesModels: getVehiclesModels,
            addItem: addItem,
            editItem: editItem,
            deleteItem: deleteItem
        }

        return service;

        function getVehiclesMakesAndModels() {
            vehicleApi.getVehiclesMakesAndModels().then(function(resp) {
                service.vehicleMakes = resp.data.VehicleMake;
                service.vehicleModels = resp.data.VehicleModel;
            });
        }

        function getVehiclesMakes() {
            vehicleApi.getVehiclesMakes().then(function(resp) {
                service.vehicleMakes = resp.data;
            });
        }

        function getVehiclesModels() {
            vehicleApi.getVehiclesModels().then(function(resp) {
                service.vehicleModels = resp.data;
            });
        }

        function addItem(mode, data) {
            blockUI.start(utils.translate('VEHICLES.MAIN_SERVICE_SAVING_VEHICLE_' + mode.toUpperCase()));
            vehicleApi.addItem(mode, data).then(function() {
                blockUI.stop();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('VEHICLES.MAIN_SERVICE_VEHICLE_' + mode.toUpperCase() + '_SAVED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            }, function(err) {
                blockUI.stop();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('VEHICLES.MAIN_SERVICE_VEHICLE_' + mode.toUpperCase() + '_SAVE_FAIL') + ' ' + err.data.Message)
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function editItem(mode, data) {
            blockUI.start(utils.translate('VEHICLES.MAIN_SERVICE_SAVING_VEHICLE_' + mode.toUpperCase()));
            vehicleApi.editItem(mode, data).then(function() {
                blockUI.stop();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('VEHICLES.MAIN_SERVICE_VEHICLE_' + mode.toUpperCase() + '_UPDATED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            }, function(err) {
                blockUI.stop();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('VEHICLES.MAIN_SERVICE_VEHICLE_' + mode.toUpperCase() + '_UPDATE_FAIL') + ' ' + err.data.Message)
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function deleteItem(mode, Id) {
            blockUI.start(utils.translate('VEHICLES.MAIN_SERVICE_DELETING_VEHICLE_' + mode.toUpperCase()));
            vehicleApi.deleteItem(mode, Id).then(function(resp) {
                blockUI.stop();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('VEHICLES.MAIN_SERVICE_VEHICLE_' + mode.toUpperCase() + '_DELETED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }
    }
})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular.module('app.vehicle')
        .service('vehicleModel', vehicleModel);

    /** @ngInject */
    function vehicleModel () {
        return function () {
            var self = this
                , defaults = {
                    Id: null
                    , Value: null
                };

            self.map = mapper;
            self.map();

            function mapper (options) {
                var mapValue = options || defaults
                    , opts = angular.extend({}, defaults, mapValue);

                self.Id = opts.Id;
                self.Value = opts.Value;
            }
        }
    }
})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.vehicle.manage')
        .controller('vehicleController', vehicleController);

    /** @ngInject */
    function vehicleController (
        vehicleService
        , utils
        , vehiclesFactory
        , searchDelay) {
        //Data
        var vm = this;
        vm.Title = "Manage Vehicles";
        vm.utilService = utils;
        vm.service = vehicleService;
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            searchDelay: searchDelay,
            autoWidth: false,
            responsive: true,
            sort: true
        };

        //Methods
        vm.getVehiclesMakesAndModels = getVehiclesMakesAndModels;
        vm.getVehicleMake = getVehicleMake;
        vm.getVehicleModel = getVehicleModel;
        vm.removeVehicle = removeVehicle;
        vm.addItem = addItem;
        vm.editVehicle = editVehicle;
        vm.activate = activate;

        //Initialization
        vm.activate();

        //Implementations
        function activate () {
            vm.getVehiclesMakesAndModels();
            //vm.getVehicleMake();
            //vm.getVehicleModel();
        }

        function getVehiclesMakesAndModels () {
            vm.service.getVehiclesMakesAndModels();
        }

        function getVehicleMake () {
            vm.service.getVehiclesMakes();
        }

        function getVehicleModel () {
            vm.service.getVehiclesModels();
        }

        function removeVehicle (mode, Id) {
            vehiclesFactory.removeVehicle(mode, Id);
        }

        function addItem (mode) {
            vehiclesFactory.saveVehicle(mode, null, 0);
        }

        function editVehicle (mode, data) {
            vehiclesFactory.saveVehicle(mode, data, 1);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.useraccess')
    .controller('UserAccessViewController', UserAccessViewController);

  function UserAccessViewController($scope, userAccessViewService, searchDelay, $mdDialog, hubService) {
    var vm = this;
    vm.service = userAccessViewService;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"lip><"clear">',
      pagingType: 'full_numbers',
      searchDelay: searchDelay,
      autoWidth: true,
      responsive: false};
    vm.dtInstance = {};

    vm.querySearch = querySearch;
    vm.addUser = addUser;
    vm.removeUser = removeUser;

    function activate(){
      vm.service.loader = true;
      vm.service.getAccessList();
      vm.service.accessType = null;
    }

    $scope.$on('$destroy', function(){
        vm.service.reset();
    });

    function addUser(){
      let tab = vm.service.currentTab.Id;
      angular.forEach(vm.service.accessTypeItems, function(access){
        if(tab == access.Id){
          let contactExists = _.find(access.ContactIds, function(o){ return o == vm.selectedItem.Id});
          if(contactExists){
            hubService.showToast('User Already Exists');
          }else{
            access.ContactIds.push(vm.selectedItem.Id);
            vm.service.contactsWithChanges.push(vm.selectedItem.Id);
          }
        }
      });
      vm.service.accessList = _.groupBy(vm.service.rawAccessList, function(item) {
        return item.GroupName;
      });
      //vm.service.formList();
      vm.selectedItem = null;
      vm.searchText = null;
    }

    function removeUser(Id){
      let confirm = $mdDialog.confirm()
        .title('Remove User')
        .textContent('Are you sure you want to remove this user?')
        .ok('Yes')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        let tab = vm.service.currentTab.Id;
        angular.forEach(vm.service.accessTypeItems, function(access){
          if(tab == access.Id){
            angular.forEach(access.ContactIds, function(contact, index){
              if(contact == Id){
                vm.service.contactsWithChanges.push(Id);
                access.ContactIds.splice(index, 1);
              }
            });
          }
        });
        vm.service.accessList = _.groupBy(vm.service.rawAccessList, function(item) {
          return item.GroupName;
        });
      });

    }

    function querySearch(query){
      let results = alasql("select * from ? where FullName like '%" + query + "%'", [vm.service.contacts]);
      return alasql('select * from ? order by FullName', [results]);
    }

    activate();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tax', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.tax', {
      url: '/tax',
      views: {
        'content@app': {
          templateUrl: 'app/main/tax/tax.html', 
          controller: 'TaxController as vm'
        }
      }, 
      data: {
        requireLogin: true,
        validateAccess: ['adminClaimsService', function (adminClaimsService) {
          return adminClaimsService.hasAdminOnly;
        }] 
      },
      title: 'Manage Tax Rates',
      titleBar: 'Alloc8 - Tax Rates',
    });
    $translatePartialLoaderProvider.addPart('app/main/tax');
  }
})();

(function () {
    'use strict';
  
    angular.module('app.tax')
      .service('taxModel', taxModel);
  
    /** @ngInject */
    function taxModel() {
      return function () {
        var self = this;
  
        var defaults = {
            id: null,
            TaxApplyTo: null,
            IsAppliedToAllBranches: false,
            IsAppliedToAllCompanies: false,
            IsAppliedToAllStates: false,
            IsAppliedToAllItems: true,
            IsAppliedToAllShifts: true,
            Rate: null,
            Name: null,
            Companies: [],
            Branches: [],
            States: [],
            Items: [],
            Shifts: [],
            Packages: []
        };

        self.mapTaxData = mapper;
        self.reset = reset;
        self.mapTaxData();

        function reset() {
          self.id = defaults.id;
          self.TaxApplyTo = defaults.TaxApplyTo;
          self.IsAppliedToAllBranches = defaults.IsAppliedToAllBranches;
          self.IsAppliedToAllCompanies = defaults.IsAppliedToAllCompanies;
          self.IsAppliedToAllStates = defaults.IsAppliedToAllStates;
          self.IsAppliedToAllItems = defaults.IsAppliedToAllItems;
          self.IsAppliedToAllShifts = defaults.IsAppliedToAllShifts;
          self.IsAppliedToAllPackages = defaults.IsAppliedToAllPackages;
          self.Rate = defaults.Rate;
          self.Name = defaults.Name;
          self.Companies = defaults.Companies;
          self.Branches = defaults.Branches;
          self.States = defaults.States;
          self.Items = defaults.Items;
          self.Shifts = defaults.Shifts;
          self.Packages = defaults.Packages;
        }
  
        function mapper(options) {
          var mapValue = options || defaults
            , opts = angular.extend({}, defaults, mapValue);
          
          self.id = opts.Id;
          self.TaxApplyTo = opts.TaxApplyTo;
          self.IsAppliedToAllBranches = opts.IsAppliedToAllBranches;
          self.IsAppliedToAllCompanies = opts.IsAppliedToAllCompanies;
          self.IsAppliedToAllStates = opts.IsAppliedToAllStates;
          self.IsAppliedToAllItems = opts.IsAppliedToAllItems;
          self.IsAppliedToAllShifts = opts.IsAppliedToAllShifts;
          self.IsAppliedToAllPackages = opts.IsAppliedToAllPackages;
          self.Rate = opts.Rate;
          self.Name = opts.Name;
          self.Companies = opts.Companies;
          self.Branches = opts.Branches;
          self.States = opts.States;
          self.Items = opts.Items;
          self.Shifts = opts.Shifts;
          self.Packages = opts.Packages;
        }
      }
    }
  })();
  
(function () {
  'use strict';

  angular
    .module('app.tax.create', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
    .state('app.tax.create', {
      url: '/create',
      views: {
        'content@app': {
          templateUrl: 'app/main/tax/create-tax/create-tax.html', 
          controller: 'CreateTaxController as vm'
        }
      }, 
      data: {
        requireLogin: true,
        validateAccess: ['adminClaimsService', function (adminClaimsService) {
          return adminClaimsService.hasAdminOnly;
        }] 
      },
      title: 'Create Tax Rate',
      titleBar: 'Alloc8 - Create Tax Rate',
    })
    .state('app.tax.update', {
      url: '/update/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/tax/create-tax/create-tax.html', 
          controller: 'CreateTaxController as vm'
        }
      }, 
      data: {
        requireLogin: true,
        validateAccess: ['adminClaimsService', function (adminClaimsService) {
          return adminClaimsService.hasAdminOnly;
        }] 
      },
      title: 'Update Tax Rate',
      titleBar: 'Alloc8 - Update Tax Rate',
    });
    $translatePartialLoaderProvider.addPart('app/main/tax');
  }
})();

(function () {
  'use strict';

  angular.module('app.tax.create')
    .factory('createTaxService', createTaxService);

  /** @ngInject */
  function createTaxService($q,$mdToast,$state, blockUI,utils,exceptionService, taxApi, taxModel) {

    var service = {
      save: save,
      create: create,
      update: update,
      taxDataModel: new taxModel(),
    };

    return service;

    async function save(id, lookups)
    {
      let isUpdate = id ? true : false;

      service.taxDataModel.Branches = service.taxDataModel.IsAppliedToAllBranches ? [] : lookups.Branches.filter(x => x.IsChecked).map(x => x.Id);
      service.taxDataModel.Companies = service.taxDataModel.IsAppliedToAllCompanies ? [] : lookups.Companies.filter(x => x.IsChecked).map(x => x.Id);
      service.taxDataModel.States = service.taxDataModel.IsAppliedToAllStates ? [] : lookups.States.filter(x => x.IsChecked).map(x => x.Name);
      service.taxDataModel.Items = service.taxDataModel.IsAppliedToAllItems ? [] : lookups.Items.filter(x => x.IsChecked).map(x => x.Id);
      service.taxDataModel.Shifts = service.taxDataModel.IsAppliedToAllShifts ? [] : lookups.ShiftTypes.filter(x => x.IsChecked).map(x => x.Id);
      service.taxDataModel.Packages = service.taxDataModel.IsAppliedToAllPackages ? [] : lookups.Packages.filter(x => x.IsChecked).map(x => x.Id);

      if (isUpdate)
      {
        await update(id, service.taxDataModel);
        return;
      }

      await create(service.taxDataModel);
      return;
    }

    function create(params) {
      blockUI.start(utils.translate('Adding tax, please wait...'));

      let deferred = $q.defer();
      taxApi.add(params)
        .then(function (resp) {

          blockUI.stop();

          deferred.resolve(resp);

          $mdToast.show(
              $mdToast.simple()
              .textContent(utils.translate('TAXRATES.TAX_ADD_SUCCESS'))
              .position('bottom right')
              .hideDelay(1500)
          ).then(x => {
            $state.go('app.tax');
          });
        }).catch(function (ex) {

          blockUI.stop();

          exceptionService.resolve(ex);
          deferred.reject(ex);
        });
      return deferred.promise;
    }

    function update(id, params) {

      blockUI.start(utils.translate('Updating tax, please wait...'));

      let deferred = $q.defer();
      taxApi.update(id, params)
        .then(function (resp) {

          blockUI.stop();

          $mdToast.show(
              $mdToast.simple()
              .textContent(utils.translate('TAXRATES.TAX_UPDATE_SUCCESS'))
              .position('bottom right')
              .hideDelay(1500)
          );

          deferred.resolve(resp);
        }).catch(function (ex) {
          blockUI.stop();
          exceptionService.resolve(ex);
          deferred.reject(ex);
        });
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tax.create')
    .controller('CreateTaxController', CreateTaxController);

  function CreateTaxController(searchDelay,
    $stateParams,
    $q,
    utils,
    createTaxService,
    taxService,
    blockUI) {

    const TAX_APPLY_TO_BRANCH = 2;

    var vm = this;

    vm.service = createTaxService;
    vm.utilService = utils;
    vm.dtInstance = {};
    vm.query = null;
    vm.searchTable = searchTable;
    vm.showTaxApplyTo = showTaxApplyTo;
    vm.getTaxLookups = getTaxLookups;
    vm.toggleCheckAllItems = toggleCheckAllItems;
    vm.toggleCheckAllShifts = toggleCheckAllShifts;
    vm.toggleCheckAllPackages = toggleCheckAllPackages;
    vm.toggleAllBranches = toggleAllBranches;
    vm.toggleAllCompanies = toggleAllCompanies;
    vm.toggleAllStates = toggleAllStates;
    vm.toggleIsAppliedToAllItems = toggleIsAppliedToAllItems;
    vm.toggleIsAppliedToAllShifts = toggleIsAppliedToAllShifts;
    vm.toggleIsAppliedToAllPackages = toggleIsAppliedToAllPackages;
    vm.toggleBranchItem = toggleBranchItem;
    vm.toggleCompanyItem = toggleCompanyItem;
    vm.toggleStateItem = toggleStateItem;
    vm.toggleItem = toggleItem;
    vm.toggleShiftItem = toggleShiftItem;
    vm.togglePackageItem = togglePackageItem;
    vm.resetSelections = resetSelections;
    vm.onTaxApplyToChange = onTaxApplyToChange;
    vm.showAllItemsList = showAllItemsList;
    vm.showAllShiftsList = showAllShiftsList;
    vm.showAllPackagesList = showAllPackagesList;
    vm.allItemsChecked = false;
    vm.allShiftsChecked = false;
    vm.save = save;
    vm.isDisabled = isDisabled;
    vm.searchCompanies = searchCompanies;
    vm.searchBranches = searchBranches;
    vm.searchItems = searchItems;
    vm.searchShiftTypes = searchShiftTypes;
    vm.searchPackages = searchPackages;
    vm.searchStates = searchStates;

    vm.lookups = {
      Companies: [],
      Branches: [],
      Items: [],
      ShiftTypes: [],
      Packages: [],
      States: [],
      ApplyToResources: [],
      ItemTypes: [],
    }

    vm.dtOptions = {
        dom: 'rt<"bottom"lip><"clear">',
        pagingType: 'full_numbers',
        searchDelay: 5000,
        autoWidth: true,
        responsive: false
      }

    function searchTable() {
      setTimeout(function () {

      }, searchDelay);
    }

    async function activate() {
      createTaxService.taxDataModel.reset();
      blockUI.start('Loading...');
      $q.all([getTaxLookups(), getTax($stateParams.id)])
      .then(response => {
        if (response[1])
        {
          createTaxService.taxDataModel.mapTaxData(response[1].data)
          vm.allItemsChecked = createTaxService.taxDataModel.IsAppliedToAllItems;
          vm.allShiftsChecked = createTaxService.taxDataModel.IsAppliedToAllShifts;
          vm.allPackagesChecked = createTaxService.taxDataModel.IsAppliedToAllPackages;

        }
        mapLookups(response[0], createTaxService.taxDataModel);
        blockUI.stop();
      });
    }

    activate();

    function getTaxLookups() {
      return taxService.getTaxLookups()
    }

    function getTax(id)
    {
      var deferred = $q.defer();
      if (!id)
      {
        deferred.resolve(null);
        return deferred.promise;
      }

      return taxService.getTax(id);
    }

    function toggleBranchItem(item)
    {
      vm.lookups.Branches.find(x => x.Id == item.Id).IsChecked = item.IsChecked;

      vm.service.taxDataModel.IsAppliedToAllBranches = vm.lookups.Branches.every(x => x.IsChecked);

      let selectedBranch = vm.lookups.Branches.filter(x => x.IsChecked).map(x => x.Id);

      vm.filteredItems = angular.copy( selectedBranch.length > 0 ? vm.lookups.Items.filter(x => selectedBranch.includes(x.Branch)) : vm.lookups.Items);
      vm.filteredShiftTypes = angular.copy( selectedBranch.length > 0 ? vm.lookups.ShiftTypes.filter(x => selectedBranch.includes(x.Branch)) : vm.lookups.ShiftTypes);
    }

    function toggleCompanyItem(item)
    {
      vm.lookups.Companies.find(x => x.Id == item.Id).IsChecked = item.IsChecked;

      vm.service.taxDataModel.IsAppliedToAllCompanies = vm.lookups.Companies.every(x => x.IsChecked);
    }

    function toggleStateItem(item)
    {
      vm.lookups.States.find(x => x.Name == item.Name).IsChecked = item.IsChecked;

      vm.service.taxDataModel.IsAppliedToAllStates = vm.lookups.States.every(x => x.IsChecked);
    }

    function toggleItem(item)
    {
      vm.lookups.Items.find(x => x.Id == item.Id).IsChecked = item.IsChecked;

      vm.allItemsChecked = vm.lookups.Items.every(x => x.IsChecked);
      vm.service.taxDataModel.IsAppliedToAllItems = vm.allItemsChecked;
    }

    function toggleShiftItem(item)
    {
      vm.lookups.ShiftTypes.find(x => x.Id == item.Id).IsChecked = item.IsChecked;

      vm.allShiftsChecked = vm.lookups.ShiftTypes.every(x => x.IsChecked);
      vm.service.taxDataModel.IsAppliedToAllShifts = vm.allShiftsChecked;
    }

    function togglePackageItem(item)
    {
      vm.lookups.Packages.find(x => x.Id == item.Id).IsChecked = item.IsChecked;

      vm.allPackagesChecked = vm.lookups.Packages.every(x => x.IsChecked);
      vm.service.taxDataModel.IsAppliedToAllPackages = vm.allPackagesChecked;
    }

    function toggleCheckAllShifts(check)
    {
      vm.service.taxDataModel.IsAppliedToAllShifts = check;
      vm.filteredShiftTypes.forEach(function (shift) {
        shift.IsChecked = check;
      });

      vm.lookups.ShiftTypes.forEach(function (shift) {
        shift.IsChecked = check;
      });
    }

    function toggleCheckAllPackages(check)
    {
      vm.service.taxDataModel.IsAppliedToAllPackages = check;
      vm.filteredPackages.forEach(function (packageItem) {
        packageItem.IsChecked = check;
      });

      vm.lookups.Packages.forEach(function (packageItem) {
        packageItem.IsChecked = check;
      });
    }

    function toggleCheckAllItems(check)
    {
      vm.service.taxDataModel.IsAppliedToAllItems = check;
      vm.filteredItems.forEach(function (item) {
        item.IsChecked = check;
      });

      vm.lookups.Items.forEach(function (item) {
        item.IsChecked = check;
      });
    }

    function toggleIsAppliedToAllItems(check)
    {
      vm.allItemsChecked = check;
      vm.toggleCheckAllItems(check);
    }

    function toggleIsAppliedToAllShifts(check)
    {
      vm.allShiftsChecked = check;
      vm.toggleCheckAllShifts(check);
    }

    function toggleIsAppliedToAllPackages(check)
    {
      vm.allPackagesChecked = check;
      vm.toggleCheckAllPackages(check);
    }

    function toggleAllBranches(check)
    {
      vm.filteredBranches.forEach(function (branch) {
        branch.IsChecked = check;
      });

      vm.lookups.Branches.forEach(function (branch) {
        branch.IsChecked = check;
      });

    }

    function toggleAllCompanies(check)
    {
      vm.filteredCompanies.forEach(function (company) {
        company.IsChecked = check;
      });

      vm.lookups.Companies.forEach(function (company) {
        company.IsChecked = check;
      });

    }

    function toggleAllStates(check)
    {
      vm.filteredStates.forEach(function (state) {
        state.IsChecked = check;
      })

      vm.lookups.States.forEach(function (state) {
        state.IsChecked = check;
      });
    }

    function showTaxApplyTo()
    {
      return vm.service.taxDataModel.TaxApplyTo == TAX_APPLY_TO_BRANCH;
    }

    function onTaxApplyToChange()
    {
      vm.resetSelections();
    }

    function resetSelections()
    {
      vm.lookups.Branches.forEach(x => x.IsChecked = false);
      vm.lookups.Companies.forEach(x => x.IsChecked = false);
      vm.lookups.States.forEach(x => x.IsChecked = false);
      vm.lookups.Items.forEach(x => x.IsChecked = false);
      vm.lookups.ShiftTypes.forEach(x => x.IsChecked = false);
      vm.lookups.Packages.forEach(x => x.IsChecked = false);

      vm.service.taxDataModel.IsAppliedToAllBranches = false;
      vm.service.taxDataModel.IsAppliedToAllCompanies = false;
      vm.service.taxDataModel.IsAppliedToAllStates = false;
      vm.service.taxDataModel.IsAppliedToAllItems = true;
      vm.service.taxDataModel.IsAppliedToAllShifts = true;
      vm.service.taxDataModel.IsAppliedToAllPackages = true;
    }

    function showAllItemsList()
    {
      return !vm.service.taxDataModel.IsAppliedToAllItems && vm.service.taxDataModel.TaxApplyTo == TAX_APPLY_TO_BRANCH;
    }

    function showAllShiftsList()
    {
      return !vm.service.taxDataModel.IsAppliedToAllShifts && vm.service.taxDataModel.TaxApplyTo == TAX_APPLY_TO_BRANCH;
    }

    function showAllPackagesList()
    {
      return !vm.service.taxDataModel.IsAppliedToAllPackages && vm.service.taxDataModel.TaxApplyTo == TAX_APPLY_TO_BRANCH;
    }

    function isDisabled() {

      let applyToListsAreEmpty = (!vm.lookups.Branches.some(x => x.IsChecked)
        && !vm.lookups.Companies.some(x => x.IsChecked)
        && !vm.lookups.States.some(x => x.IsChecked));

      let itemsAreEmpty = !vm.service.taxDataModel.IsAppliedToAllItems && !vm.lookups.Items.some(x => x.IsChecked);
      let shiftsAreEmpty = !vm.service.taxDataModel.IsAppliedToAllShifts && !vm.lookups.ShiftTypes.some(x => x.IsChecked);
      let packagesAreEmpty = !vm.service.taxDataModel.IsAppliedToAllPackages && !vm.lookups.Packages.some(x => x.IsChecked);

      return applyToListsAreEmpty || (itemsAreEmpty && shiftsAreEmpty && packagesAreEmpty);
    }

    async function save() {
      vm.service.save($stateParams.id, vm.lookups);
    }

    function mapLookups(response, taxModel) {
      vm.lookups = {
        Companies: response.Companies.map(x => {
          let isChecked = taxModel.IsAppliedToAllCompanies || (!taxModel.IsAppliedToAllCompanies && taxModel.Companies.some(c => c == x.id));
          return {
            Id: x.id,
            Name: x.Name,
            CompanyCode: x.CompanyCode,
            IsChecked: isChecked
          }
        }),
        Branches: response.Branches.map(x => {
          let isChecked = taxModel.IsAppliedToAllBranches || (!taxModel.IsAppliedToAllBranches && taxModel.Branches.some(c => c == x.Id));
          return {
            Id: x.Id,
            Name: x.Name,
            IsChecked: isChecked
          }
        }),
        Items: response.Items.map(x => {
          let isChecked = taxModel.IsAppliedToAllItems || (!taxModel.IsAppliedToAllItems && taxModel.Items.some(c => c == x.Id));

          return {
            Id: x.Id,
            Name: x.Name,
            Tag: x.Tag,
            IsChecked: isChecked,
            Branch: x.Branch,
          }
        }),
        ShiftTypes: response.ShiftTypes.map(x => {
          let isChecked = taxModel.IsAppliedToAllShifts || (!taxModel.IsAppliedToAllShifts && taxModel.Shifts.some(c => c == x.Id));
          return {
            Id: x.Id,
            Name: x.Name,
            Tag: x.Tag,
            IsChecked: isChecked,
            Branch: x.Branch,
          }
        }),
        Packages: response.Packages.map(x => {
          let isChecked = taxModel.IsAppliedToAllPackages || (!taxModel.IsAppliedToAllPackages && taxModel.Packages.some(c => c == x.Id));
          return {
            Id: x.Id,
            Name: x.Name,
            Tag: x.Tag,
            IsChecked: isChecked
          }
        }),
        States: response.States.map(x => {
          let isChecked = taxModel.IsAppliedToAllStates || (!taxModel.IsAppliedToAllStates && taxModel.States.some(c => c == x.Name));
          return {
            Name: x.Name,
            IsChecked: isChecked
          }
        }),
        ApplyToResources: response.ApplyToResources.map(x => {
          return {
            Id: parseInt(x.Id),
            Name: x.Name
          }
        }),
        ItemTypes: response.ItemTypes.map(x => {
         return {
          Name: x.Name
         }
        })
      }

      vm.filteredCompanies = angular.copy(vm.lookups.Companies);
      vm.filteredBranches = angular.copy(vm.lookups.Branches);
      vm.filteredStates = angular.copy(vm.lookups.States);
      vm.filteredItems = angular.copy(vm.lookups.Items);
      vm.filteredShiftTypes = angular.copy(vm.lookups.ShiftTypes);
      vm.filteredPackages = angular.copy(vm.lookups.Packages);
    }

  function searchCompanies(search) {
    vm.filteredCompanies = angular.copy(vm.lookups.Companies.filter(x => x.Name.toUpperCase().includes(search.toUpperCase())));
  }

  function searchBranches(search) {
    vm.filteredBranches  = angular.copy(vm.lookups.Branches.filter(x => x.Name.toUpperCase().includes(search.toUpperCase())));
  }
  function searchItems(name, tag) {
    
    if(vm.lookups.Branches.filter(x => x.IsChecked).length == 0)  {
      vm.filteredItems = angular.copy(vm.lookups.Items);
    }
  
    if (name)
    {
      vm.filteredItems = vm.filteredItems.filter(x => x.Name.toUpperCase().includes(name.toUpperCase()));
    }
    
    if (tag)
    {
      vm.filteredItems = vm.filteredItems.filter(x => x.Tag.toUpperCase().includes(tag.toUpperCase()));
    }
  }

  function searchShiftTypes(search) {
    if(vm.lookups.Branches.filter(x => x.IsChecked).length == 0)  {
      vm.filteredItems =angular.copy(vm.lookups.ShiftTypes);
    }
  
    vm.filteredShiftTypes = vm.filteredShiftTypes.filter(x => x.Name.toUpperCase().includes(search.toUpperCase()));
  }
  function searchPackages(search) {
    vm.filteredPackages = angular.copy(vm.lookups.Packages.filter(x => x.Name.toUpperCase().includes(search.toUpperCase())));
  }
  function searchStates(search) {
    vm.filteredStates = angular.copy(vm.lookups.States.filter(x => x.Name.toUpperCase().includes(search.toUpperCase())));
  }
  
}
})();

(function() {
    'use strict';

    angular.module('app.training')
        .factory('trainingService', trainingService);

    /** @ngInject */
    function trainingService(
        utils,
        $mdToast,
        trainingApi,
        blockUI
    ) {
        var service = {
            trainingGroups: [],
            getTrainingsGroups: getTrainingsGroups,
            addTrainingGroup: addTrainingGroup,
            editTrainingGroupHeader: editTrainingGroupHeader,
            editTrainingGroup: editTrainingGroup,
            deleteTrainingGroup: deleteTrainingGroup,
            addTrainingGroupItem: addTrainingGroupItem,
            editTrainingGroupItem: editTrainingGroupItem,
            deleteTrainingGroupItem: deleteTrainingGroupItem
        }

        return service;

        function getTrainingsGroups() {
            trainingApi.getTrainingsGroups().then(function(resp) {
                service.trainingGroups = resp.data;
            });
        }

        function addTrainingGroup(trainingGroup) {
            blockUI.start(utils.translate('TRAININGS.MAIN_SERVICE_SAVING_TRAINING_GROUP'));
            trainingApi.addTrainingGroup(trainingGroup).then(function() {
                blockUI.stop();
                service.getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAININGS_GROUP_SAVED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            }, function(err) {
                blockUI.stop();
                service.getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAININGS_GROUP_SAVE_FAIL') + ' ' + err.data.Message)
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function editTrainingGroup(trainingGroup) {
            blockUI.start(utils.translate('TRAININGS.MAIN_SERVICE_SAVING_TRAINING_GROUP'));
            trainingApi.editTrainingGroup(trainingGroup).then(function() {
                blockUI.stop();
                getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAININGS_GROUP_UPDATED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            }, function(err) {
                blockUI.stop();
                getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAININGS_GROUP_UPDATE_FAIL') + ' ' + err.data.Message)
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function addTrainingGroupItem(trainingGroup, item) {
            blockUI.start(utils.translate('TRAININGS.MAIN_SERVICE_SAVING_TRAINING'));
            trainingApi.addTrainingGroupItem(trainingGroup, item).then(function() {
                blockUI.stop();
                service.getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAINING_SAVED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            }, function(err) {
                blockUI.stop();
                service.getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAINING_SAVE_FAIL') + ' ' + err.data.Message)
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function editTrainingGroupItem(trainingGroup, item) {
            blockUI.start(utils.translate('TRAININGS.MAIN_SERVICE_SAVING_TRAINING'));
            trainingApi.editTrainingGroupItem(trainingGroup, item).then(function() {
                blockUI.stop();
                getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAINING_UPDATED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            }, function(err) {
                blockUI.stop();
                service.getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAINING_UPDATE_FAIL') + ' ' + err.data.Message)
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function deleteTrainingGroupItem(Id, ItemId) {
            blockUI.start(utils.translate('TRAININGS.MAIN_SERVICE_DELETING_TRAINING'));
            trainingApi.deleteTrainingGroupItem(Id, ItemId).then(function(resp) {
                blockUI.stop();
                getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAINING_DELETED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function editTrainingGroupHeader(trainingGroup) {
            blockUI.start(utils.translate('TRAININGS.MAIN_SERVICE_SAVING_TRAINING_GROUP'));
            trainingApi.editTrainingGroup(trainingGroup).then(function(resp) {
                blockUI.stop();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAININGS_GROUP_UPDATED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            }, function(err) {
                blockUI.stop();
                getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAININGS_GROUP_UPDATE_FAIL') + ' ' + err.data.Message)
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function deleteTrainingGroup(Id) {
            blockUI.start(utils.translate('TRAININGS.MAIN_SERVICE_DELETING_TRAINING_GROUP'));
            trainingApi.deleteTrainingGroup(Id).then(function(resp) {
                blockUI.stop();
                getTrainingsGroups();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('TRAININGS.MAIN_SERVICE_TRAININGS_GROUP_DELETED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }
    }
})();

/**
 * Created by ALTUS on 5/27/2016.
 */
(function () {
  'use strict';

  angular.module('app.training')
    .service('trainingModel', trainingModel);

  /** @ngInject */
  function trainingModel() {
    return function () {
      var self = this
        , defaults = {
          id: null
        , Name: null
      };

      self.map = mapper;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend({}, defaults, mapValue);

        self.id = opts.id;
        self.Name = opts.Name;
      }
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('app.training.manage')
		.controller('trainingController', trainingController);

	/** @ngInject */
	function trainingController (
		trainingService
		, utils
		, trainingsFactory
		, searchDelay) {
		//Data
		var vm = this;
		vm.Title = "Manage Training";
		vm.utilService = utils;
		vm.service = trainingService;
		vm.dtOptions = {
			pagingType: 'simple',
			searchDelay: searchDelay,
			autoWidth: false,
			responsive: true,
			sort: false
		};

		//Methods
		vm.removeTraining = removeTraining;
		vm.addTraining = addTraining;
		vm.addTrainingGroup = addTrainingGroup;
		vm.editTraining = editTraining;
		vm.getTrainingGroups = getTrainingGroups;
		vm.editTrainingGroupHeader = editTrainingGroupHeader;
		vm.getLockOutTye = getLockOutTye;


		//Implementations
		function removeTraining (trainingGUID, trainingGroup) {
			trainingsFactory.removeTraining(trainingGUID, trainingGroup);
		}

		function getLockOutTye (type) {
			if (type == 0) {
				return vm.utilService.translate('TRAININGS.MAIN_VIEW_NO_LOCKOUT');
			}
			if (type == 1) {
				return vm.utilService.translate('TRAININGS.MAIN_VIEW_SOFT_LOCKOUT');
			}
			if (type == 2) {
				return vm.utilService.translate('TRAININGS.MAIN_VIEW_MEDIUM_LOCKOUT');
			}
			if (type == 3) {
				return vm.utilService.translate('TRAININGS.MAIN_VIEW_HARD_LOCKOUT');
			}
		}

		//Initialization
		vm.getTrainingGroups();

		function getTrainingGroups () {
			vm.service.getTrainingsGroups();
		}

		function addTraining (trainingGroupID, trainingID) {
			trainingsFactory.saveTraining(trainingGroupID, trainingID, 0);
		}

		function addTrainingGroup () {
			trainingsFactory.addTrainingGroup();
		}

		function editTrainingGroup (trainingGroup) {
			vm.service.editTrainingGroup(trainingGroup);
		}

		function editTrainingGroupHeader (newValue, trainingGroup) {
			trainingGroup.GroupName = newValue;
			vm.service.editTrainingGroupHeader(trainingGroup);
		}

		function editTraining (trainingGroupID, trainingID) {

			trainingsFactory.saveTraining(trainingGroupID, trainingID, 1);
		}
	}
})();

 (function() {
    'use strict';

    angular
        .module('app.tags')
        .factory('tagsService', tagsService);

    /** @ngInject */
    function tagsService($q,
                         exceptionService,
                         tagsApi) {

        let self = this;
        self.tags = [];

        self.init = function() {
            let deferred = $q.defer();
            tagsApi.getAllTags()
                .then(function(resp) {
                    self.tags = resp.data;
                    deferred.resolve(resp.data);
                }).catch(function(ex) {
                exceptionService.resolve(ex);
                deferred.reject(ex);
            });
            return deferred.promise;
        };

        self.addTag = function(params) {
            let deferred = $q.defer();
            tagsApi.add(params)
                .then(function(resp) {
                    self.init();
                    deferred.resolve(resp);
                }).catch(function(ex) {
                deferred.reject(ex);
            });
            return deferred.promise;
        };

        self.updateTag = function(params, index, tag) {
            let deferred = $q.defer();
            tagsApi.update(params)
                .then(function(resp) {
                    self.tags[index] = tag;
                    deferred.resolve(resp);
                }).catch(function(ex) {
                exceptionService.resolve(ex);
                deferred.reject(ex);
            });
            return deferred.promise;
        };

        return self;
    }

})();

(function() {
    'use strict';

    angular.module('app.skillsmatrix')
        .factory('skillsMatrixService', skillsMatrixService);

    /** @ngInject */
    function skillsMatrixService(
        utils,
        _,
        $mdToast,
        skillsMatrixApi
    ) {
        var service = {
            saving: false,
            skillsMatrixGroups: [],
            getSkillsGroups: getSkillsGroups,
            addSkillGroup: addSkillGroup,
            editSkillGroupHeader: editSkillGroupHeader,
            editSkillGroup: editSkillGroup,
            deleteSkillGroup: deleteSkillGroup,
            preview: preview,
            add: add
        }

        return service;

        function preview(url) {
            window.open(url, "_blank");
        }

        function getSkillsGroups() {
            service.saving = true;
            skillsMatrixApi.getSkillsGroups().then(function(resp) {
                service.skillsMatrixGroups = arrangeSkills(resp.data);
                service.saving = false;
            });
        }

        function arrangeSkills(skills) {
            skills = _.orderBy(skills, ['GroupName'], ['asc']);
            skills.forEach(function(group) {
                group.Skills = _.orderBy(group.Skills, ['SkillName'], ['asc']);
            });
            return skills;
        }

        function addSkillGroup(skillGroup) {
            skillsMatrixApi.addSkillGroup(skillGroup).then(function(resp) {
                service.skillsMatrixGroups.push(resp.data);
                service.skillsMatrixGroups = arrangeSkills(service.skillsMatrixGroups);
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('SKILLS.MAIN_SERVICE_SKILLS_GROUP_SAVED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function add(skill, group) {
            service.skillsMatrixGroups.forEach(function(gr) {
                if (gr.id === group.id) {
                    if (!gr.Skills.find(function(s) {
                            return s.id === skill.id
                        })) {
                        gr.Skills.push(skill);
                    }
                }
            });
            service.skillsMatrixGroups = arrangeSkills(service.skillsMatrixGroups);
            editSkillGroup(skill.Id, group);
        }

        function editSkillGroup(skillId, skillGroup) {
            service.saving = true;
            skillsMatrixApi.editSkillGroup(skillId, skillGroup).then(function() {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('SKILLS.MAIN_SERVICE_SKILLS_GROUP_UPDATED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
                service.saving = false;
            });
        }

        function editSkillGroupHeader(skillGroup) {
            skillsMatrixApi.editSkillGroup(skillGroup.id, skillGroup).then(function() {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('SKILLS.MAIN_SERVICE_SKILLS_GROUP_UPDATED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
            });
        }

        function deleteSkillGroup(Id) {
            service.saving = true;
            skillsMatrixApi.deleteSkillGroup(Id).then(function(resp) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('SKILLS.MAIN_SERVICE_SKILLS_GROUP_DELETED'))
                    .position('bottom right')
                    .hideDelay(2000)
                );
                service.saving = false;
            });
        }
    }
})();

/**
 * Created by ALTUS on 5/27/2016.
 */
(function () {
  'use strict';

  angular.module('app.skillsmatrix')
    .service('SkillsMatrixModel', SkillsMatrixModel);

  /** @ngInject */
  function SkillsMatrixModel() {
    return function () {
      var self = this
        , defaults = {
          id: null
        , Name: null
      };

      self.map = mapper;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend({}, defaults, mapValue);

        self.id = opts.id;
        self.Name = opts.Name;
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.skillsmatrix.manage')
        .controller('SkillsMatrixController', SkillsMatrixController);

    /** @ngInject */
    function SkillsMatrixController(
        skillsMatrixService
      , utils
      , $scope
      , skillsFactory
      , searchDelay
      , $mdDialog) {
        //Data
        var vm = this;
        vm.Title = "Manage Skills Matrix";
        vm.utilService = utils;
        vm.service = skillsMatrixService;
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            searchDelay: searchDelay,
            autoWidth: false,
            sort: false
        };

        //Methods
        vm.removeSkill = removeSkill;
        vm.addSkill = addSkill;
        vm.addSkillGroup = addSkillGroup;
        vm.editSkill = editSkill;
        vm.getSkillGroups = getSkillGroups;
        vm.editSkillGroupHeader = editSkillGroupHeader;
        vm.deleteGroup = deleteGroup;

        $scope.$on('$destroy', function() {
            vm.service.skillsMatrixGroups.length = 0;
        });

        //Implementations
        function removeSkill(skillGUID, skillGroup) {
            let confirm = $mdDialog.confirm()
                .title(utils.translate("SKILLS.MAIN_VIEW_MANAGE_SKILLS"))
                .textContent(utils.translate("SKILLS.DIRECTIVE_ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_SKILL?"))
                .ok(utils.translate("SKILLS.DIRECTIVE_YES"))
                .cancel(utils.translate("SKILLS.DIRECTIVE_NO"));

        $mdDialog.show(confirm).then(function() {
            if(skillGroup.Skills.length > 1){
                skillGroup.Skills = skillGroup.Skills.filter(function(skill){
                    return skill.id != skillGUID;
                });
                skillsMatrixService.editSkillGroup(skillGUID, skillGroup);
            }else{
                skillsMatrixService.deleteSkillGroup(skillGroup.id);
                vm.service.skillsMatrixGroups = vm.service.skillsMatrixGroups.filter(function(group){
                    return group.id != skillGroup.id;
                });
            }
        });
    }

        function deleteGroup(group) {
            skillsMatrixService.deleteSkillGroup(group.id);
        }

        //Initialization
        vm.getSkillGroups();

        function getSkillGroups() {
            vm.service.getSkillsGroups();
        }

        function addSkill(skillGroupID, skillID) {
            skillsFactory.saveSkill(skillGroupID, skillID, 0);
        }

        function addSkillGroup() {
            skillsFactory.addSkillGroup();
        }

        function editSkillGroup(skillGroup) {
            vm.service.editSkillGroup(skillGroup);
        }

        function editSkillGroupHeader(newValue, skillGroup) {
            skillGroup.GroupName = newValue;
            vm.service.editSkillGroupHeader(skillGroup);
        }

        function editSkill(skillGroupID, skillID) {
            skillsFactory.saveSkill(skillGroupID, skillID, 1);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.skilllevel.view')
    .controller('SkillsLevelViewController', SkillsLevelViewController);

  function SkillsLevelViewController(searchDelay, addSkillsViewService) {
    var vm = this;
    vm.dtInstance = {};
    vm.query = null;
    vm.service = addSkillsViewService;

    vm.searchTable = searchTable;

    vm.dtOptions = {
      dom: 'rt<"bottom"lip><"clear">',
      pagingType: 'full_numbers',
      searchDelay: searchDelay,
      autoWidth: true,
      responsive: false
    };

    function searchTable() {
      setTimeout(function () {
        vm.dtInstance.DataTable.search(vm.query);
        vm.dtInstance.DataTable.search(vm.query).draw();
      }, searchDelay);
    }

    function activate(){
      vm.service.skills_level = [];
      vm.service.getSkillsLevel();
    }

    activate();
  }
})();

(function () {
  'use strict';

  angular.module('app.skilllevel.view')
    .factory('addSkillsViewService', addSkillsViewService);

  /** @ngInject */
  function addSkillsViewService($mdDialog, skillLevelApi, utils) {

    var service = {
      skills_level : [],
      loader : false,
      operationMessage : null,
      getSkillsLevel : getSkillsLevel,
      showDialog : showDialog,
      deleteSkillsLevel : deleteSkillsLevel
    };

    function showDialog(data, isEdit){
      $mdDialog.show({
        templateUrl : 'app/main/skilllevel/view/dialog/add-skill-level-dialog.html',
        controller : 'addSkillLevelDialogController as vm',
        locals : {
          isEdit : isEdit,
          data : data
        }
      }).then(function(data){
        if(data){
          service.getSkillsLevel();
        }
      })
    }

    function getSkillsLevel(){
      service.loader = true;
      service.operationMessage = utils.translate('SKILLSLEVEL.LOAD_SKILLS_MESSAGE');
      skillLevelApi.getSkillsLevel().then(function(resp){
        service.loader = false;
        service.skills_level = resp.data;
        service.skills_level = service.skills_level.sort(function(a, b){
          return a.Name - b.Name;
        });
      });
    }

    function deleteSkillsLevel(Id){
      service.loader = true;
      service.operationMessage = utils.translate('SKILLSLEVEL.DELETE_SKILLS_MESSAGE');
      skillLevelApi.deleteSkillsLevel(Id).then(function(){
        service.loader = false;
        service.getSkillsLevel();
      });
    }

    return service;

  }
})();

(function() {
    'use strict';

    angular.module('app.ratecards')
    .service('rateCardSignalRService', rateCardSignalRService);

    /** @ngInject */
    function rateCardSignalRService(
        $rootScope,
        signalRService) {

        var service = {
            register: register,
            bufferSize: 2000,
        };

        var stop;
        var isInitialized = false;

        activate();

        return service;

        function activate() {
            stop = undefined;
        }

        function register() {
            if (signalRService.isConnected) {
                registerEvent();
            }

            $rootScope.$on('signalR_OnConnected', function() {
                if (!isInitialized) {
                    registerEvent();
                    isInitialized = true;
                }
            });
        }

        function registerEvent() {
            signalRService.messageHub.on('rateCardRuleSyncUpdate', function(data) {
                $rootScope.$emit('rateCardRuleSyncUpdate', data);
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.payroll-settings.manage')
        .factory('ratecardService', ratecardService);

    function ratecardService(
        $q,
        rateCardsApi,
        packagesApi,
        _,
        exceptionService,
        rateCardSignalRService,
        $rootScope
    ) {
        let self = this;
        self.service = {};

        self.service.packageGroups = [];
        self.service.lastPackageGroupCounter = 0;
        self.service.isRateCardSyncing = false;

        self.service.currentRateCardId = null;

        self.service.getRatecard = function(ratecardId) {
            let deferred = $q.defer();

            rateCardsApi.getRatecard(ratecardId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowancesAll = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowancesAll().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTimesheetAdjustmentsAll = function() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetAdjustmentsAll().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTimesheetAll = function() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetAll().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getPackagesAll = function() {
            let deferred = $q.defer();

            packagesApi.getPackageTemplates().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getFormats = function() {
            let deferred = $q.defer();

            rateCardsApi.getFormats().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getPackages = function() {
            let deferred = $q.defer();

            rateCardsApi.getPackages().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTravelTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getTravelTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTravelOnlyChargeTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getTravelOnlyChargeTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };
        self.service.getEstablishmentFeeTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getEstablishmentFeeTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };  
        self.service.getVehicleChargeTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getVehicleChargeTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getVehicleChargeTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getVehicleChargeTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getRatecardsLookup = function() {
            let deferred = $q.defer();

            rateCardsApi.getRatecardAll().then(function(resp) {
                self.service.ratecards = resp.data;
                deferred.resolve({
                    data: resp.data
                });

            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.initializeRatecardPricing = function(ratecardId) {
            let deferred = $q.defer();

            rateCardsApi.getRatecardPricingSpreadsheetData(ratecardId).then(function(resp) {
                self.service.pricingSpreadsheetData = resp.data;
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.saveRatecardPricing = function(id, worksheet) {
            let deferred = $q.defer();

            let param = {
                Worksheets: worksheet
            };

            rateCardsApi.saveRatecardPricingData(id, param).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.computeBulkPrice = function(id, percentage, worksheet, worksheetTypeQuery) {
            let deferred = $q.defer();

            let param = {
                Worksheets: worksheet
            };

            rateCardsApi.postBulkPricingUpdate(id, param, percentage, worksheetTypeQuery).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.createRatecard = function(params, isClone) {
            let deferred = $q.defer();

            let rateCardParams = {
                "Name": params.Name,
                "RateCardFormat": params.SelectedRateCardFormat,
                "Allowances": params.SelectedAllowances,
                "Packages": params.SelectedPackages,
                "TimesheetAdjustments": params.SelectedTimesheet,
                "AverageEmployeeBreakHours": !_.isNil(params.AverageEmployeeBreakHours) ? params.AverageEmployeeBreakHours : false,
                "FormPackagesForShiftsWithSameTime": !_.isNil(params.FormPackagesForShiftsWithSameTime) ? params.FormPackagesForShiftsWithSameTime : false,
                "ChargeEmployeeBreaks": !_.isNil(params.ChargeEmployeeBreaks) ? params.ChargeEmployeeBreaks : false,
                "ChargeEquipmentBreaks": !_.isNil(params.ChargeEquipmentBreaks) ? params.ChargeEquipmentBreaks : false,
                "RoundAllHoursToNeareast15Minutes": !_.isNil(params.RoundAllHoursToNeareast15Minutes) ? params.RoundAllHoursToNeareast15Minutes : false,
                "InvoiceShiftsOnSeparateInvoice": !_.isNil(params.InvoiceShiftsOnSeparateInvoice) ? params.InvoiceShiftsOnSeparateInvoice : false,
                "TravelHoursDoNotCountTowardsShiftHours": !_.isNil(params.TravelHoursDoNotCountTowardsShiftHours) ? params.TravelHoursDoNotCountTowardsShiftHours : false,
                "MinimumBillingHours": !_.isNil(params.MinimumBillingHours) ? parseFloat(params.MinimumBillingHours) : null,
                "TrimJobStartByMinutes": !_.isNil(params.TrimJobStartByMinutes) ? _.toInteger(params.TrimJobStartByMinutes) : null,
                "TrimJobEndByMinutes": !_.isNil(params.TrimJobEndByMinutes) ? _.toInteger(params.TrimJobEndByMinutes) : null,
                "TravelType": params.TravelType,
                "TravelOnlyChargeType": params.TravelOnlyChargeType,
                "VehicleChargeType": params.VehicleChargeType,
                "VehicleRateCardFormat": params.VehicleChargeType == 31 ? null : params.SelectedVehicleRateCardFormat,
                "MaximumBillingTravelTotalHours": !_.isNil(params.MaximumBillingTravelTotalHours) ? _.toInteger(params.MaximumBillingTravelTotalHours) : null,
                "MaximumBillingTravelToHours": !_.isNil(params.MaximumBillingTravelToHours) ? _.toInteger(params.MaximumBillingTravelToHours) : null,
                "MaximumBillingTravelFromHours": !_.isNil(params.MaximumBillingTravelFromHours) ? _.toInteger(params.MaximumBillingTravelFromHours) : null,
                "ExcludeSetupPackupHours": !_.isNil(params.ExcludeSetupPackupHours) ? _.toInteger(params.ExcludeSetupPackupHours) : null,
                "VehicleTravelNotCharge": !_.isNil(params.VehicleTravelNotCharge) ? _.toInteger(params.VehicleTravelNotCharge) : null,
                "EstablishmentFeeType": params.EstablishmentFeeType.Key,
                "Surcharges": params.Surcharges || []
            };

            if (isClone) {
                rateCardParams.ClonedRatecardId = params.Id;
            }

            rateCardsApi.postNewRatecard(rateCardParams).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateRatecard = function(params) {
            let deferred = $q.defer();
            let rateCardParams = {
                "Name": params.Name,
                "Allowances": params.SelectedAllowances,
                "Packages": params.SelectedPackages,
                "TimesheetAdjustments": params.SelectedTimesheet,
                "AverageEmployeeBreakHours": !_.isNil(params.AverageEmployeeBreakHours) ? params.AverageEmployeeBreakHours : false,
                "FormPackagesForShiftsWithSameTime": !_.isNil(params.FormPackagesForShiftsWithSameTime) ? params.FormPackagesForShiftsWithSameTime : false,
                "ChargeEmployeeBreaks": !_.isNil(params.ChargeEmployeeBreaks) ? params.ChargeEmployeeBreaks : false,
                "ChargeEquipmentBreaks": !_.isNil(params.ChargeEquipmentBreaks) ? params.ChargeEquipmentBreaks : false,
                "RoundAllHoursToNeareast15Minutes": !_.isNil(params.RoundAllHoursToNeareast15Minutes) ? params.RoundAllHoursToNeareast15Minutes : false,
                "InvoiceShiftsOnSeparateInvoice": !_.isNil(params.InvoiceShiftsOnSeparateInvoice) ? params.InvoiceShiftsOnSeparateInvoice : false,
                "TravelHoursDoNotCountTowardsShiftHours": !_.isNil(params.TravelHoursDoNotCountTowardsShiftHours) ? params.TravelHoursDoNotCountTowardsShiftHours : false,
                "MinimumBillingHours": !_.isNil(params.MinimumBillingHours) ? parseFloat(params.MinimumBillingHours) : null,
                "TrimJobStartByMinutes": !_.isNil(params.TrimJobStartByMinutes) ? _.toInteger(params.TrimJobStartByMinutes) : null,
                "TrimJobEndByMinutes": !_.isNil(params.TrimJobEndByMinutes) ? _.toInteger(params.TrimJobEndByMinutes) : null,
                "TravelType": params.TravelType,
                "TravelOnlyChargeType": params.TravelOnlyChargeType,
                "RateCardFormat": params.SelectedRateCardFormat,
                "VehicleChargeType": params.VehicleChargeType,
                "VehicleRateCardFormat": params.SelectedVehicleRateCardFormat,
                "MaximumBillingTravelTotalHours": !_.isNil(params.MaximumBillingTravelTotalHours) ? _.toNumber(params.MaximumBillingTravelTotalHours) : null,
                "MaximumBillingTravelToHours": !_.isNil(params.MaximumBillingTravelToHours) ? _.toNumber(params.MaximumBillingTravelToHours) : null,
                "MaximumBillingTravelFromHours": !_.isNil(params.MaximumBillingTravelFromHours) ? _.toNumber(params.MaximumBillingTravelFromHours) : null,
                "ExcludeSetupPackupHours": !_.isNil(params.ExcludeSetupPackupHours) ? _.toInteger(params.ExcludeSetupPackupHours) : null,
                "VehicleTravelNotCharge": !_.isNil(params.VehicleTravelNotCharge) ? _.toInteger(params.VehicleTravelNotCharge) : null,
                "EstablishmentFeeType": params.EstablishmentFeeType.Key,
                "Surcharges": params.Surcharges || []
            };

            rateCardsApi.putRatecard(params.Id, rateCardParams).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.archiveRatecard = function(ratecardId, isArchive) {
            let deferred = $q.defer();

            rateCardsApi.archiveRatecard(ratecardId, isArchive).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowanceTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowanceTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowanceHourlyMultipliers = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowanceHourlyMultipliers().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowanceDistanceMultipliers = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowanceDistanceMultipliers().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getConditionTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getConditionTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getConditionInputVariables = function() {
            let deferred = $q.defer();

            rateCardsApi.getConditionInputVariables().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getConditionCompareTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getConditionCompareTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getConditions = function() {
            let deferred = $q.defer();

            rateCardsApi.getConditions().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowancesTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowancesTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.createRatecardAllowance = function(params) {
            let deferred = $q.defer();

            rateCardsApi.postRatecardAllowance(params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getRatecardAllowance = function(allowanceId) {
            let deferred = $q.defer();

            rateCardsApi.getAllowance(allowanceId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateRatecardAllowance = function(allowanceId, params) {
            let deferred = $q.defer();

            rateCardsApi.putRatecardAllowance(allowanceId, params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.removeRatecardAllowance = function(allowanceId) {
            let deferred = $q.defer();

            rateCardsApi.deleteRatecardAllowance(allowanceId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTimesheetTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTimesheetConditions = function() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetConditions().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.createRatecardTimesheet = function(params) {
            let deferred = $q.defer();

            rateCardsApi.postRatecardTimesheet(params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.removeRatecardTimesheet = function(timesheetId) {
            let deferred = $q.defer();

            rateCardsApi.deleteRatecardTimesheet(timesheetId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getRatecardTimesheet = function(timesheetId) {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetAdjustment(timesheetId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateRatecardTimesheet = function(timesheetId, params) {
            let deferred = $q.defer();

            rateCardsApi.putRatecardTimesheet(timesheetId, params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getInvoiceGroups = function() {
            let deferred = $q.defer();

            rateCardsApi.getInvoiceGroups().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.setAllPackageGroup = function(value) {
            self.service.packageGroups = value;
        };

        self.service.setPackageGroup = function(itemCount, value) {
            self.service.packageGroups[itemCount] = value;
        };

        self.service.getPackageGroup = function() {
            return self.service.packageGroups;
        };

        self.service.removeItem = function(groupCounter, itemCounter, subItemCounter) {
            self.service.packageGroups[groupCounter][itemCounter].PackageItems = _.remove(self.service.packageGroups[groupCounter][itemCounter].PackageItems, function(items, key) {
                return key !== subItemCounter;
            });

            if (_.isEmpty(self.service.packageGroups[groupCounter][itemCounter].PackageItems)) {
                self.service.removePackageGroup(groupCounter, itemCounter, true);
            }
        };

        self.service.createRatecardPackage = function(params) {
            let deferred = $q.defer();

            rateCardsApi.postRatecardPackage(params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getRatecardPackage = function(packageId) {
            let deferred = $q.defer();

            packagesApi.getPackageTemplate(packageId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.removeRatecardPackage = function(packageId) {
            let deferred = $q.defer();

            rateCardsApi.deleteRatecardPackage(packageId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.setLastRatecard = function(rateCardId) {
            self.service.lastRatecard = rateCardId;
        };

        self.service.removePackageGroup = function(groupCounter, itemCounter, fromRemoveItems) {
            if (!fromRemoveItems) {
                self.service.lastPackageGroupCounter = groupCounter;
            }

            if (!_.isNil(itemCounter)) {
                _.remove(self.service.packageGroups[groupCounter], function(items, key) {
                    return key === itemCounter;
                });
            } else {
                _.remove(self.service.packageGroups, function(items, key) {
                    return key === groupCounter;
                });
            }
        };

        self.service.sync = function(id) {
            let deferred = $q.defer();
            self.service.isRateCardSyncing = true;

            rateCardsApi.updateRateCardRules(id).then(function(){
                deferred.resolve(true);
            }).catch(function(ex){
                self.service.isRateCardSyncing = false;
                exceptionService.resolve(ex);
            });

            return deferred.promise;
        }

        $rootScope.$on('rateCardRuleSyncUpdate', function(event, data) {
            $rootScope.$applyAsync(function() {
                if (data && data.rateCardId && self.service.currentRateCardId === data.rateCardId) {
                    self.service.isRateCardSyncing = data.isSyncing;
                }
            });
        });

        rateCardSignalRService.register();

        return self.service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.ratecards')
        .controller('RateCardPricingController', RateCardPricingController);

    function RateCardPricingController(
        utils,
        blockUI,
        $mdDialog,
        hubService,
        exceptionService,
        ratecardService
    ) {
        let self = this;
        self.service = ratecardService;
        self.Title = "Manage Rate Card - Pricing";
        self.utilService = utils;
        self.hey = false;
        self.isBulkChangeView = false;
        self.selectedRatecard = "";
        self.showSpreadsheet = false;
        self.bulkChangePercentage = 1;
        self.selection = [];

        self.$onInit = function() {
            if (self.isBulkChangeView) {
                return;
            }

            self.service.getRatecardsLookup()
                .then(function(resp) {
                    self.ratecards = resp.data;

                    if (!_.isNil(self.service.lastRatecard)) {
                        self.selectedRatecard = self.service.lastRatecard;
                        self.updateSpreadsheet(self.service.lastRatecard);
                    }

                    blockUI.stop();
                }, function(err) {
                    self.service.setLastRatecard();
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.updateSpreadsheet = function(ratecardId) {
            blockUI.start();
            self.isBulkChangeView = false;
            self.flexSheet.sheets.clear();
            refreshSpreadsheetData(ratecardId);
        };

        self.computeBulkPrice = function() {
            blockUI.start();
            self.showSpreadsheet = false;
            self.isBulkChangeView = false;
            self.flexSheet.sheets.clear();

            $mdDialog.cancel();

            self.worksheetTypeQuery = "";
            self.selectedWorksheetsUpdate = _.filter(self.rateCardPricingSheet, function(data, index) {
                if (_.includes(self.selection, data.WorksheetType)) {
                    self.worksheetTypeQuery = self.worksheetTypeQuery + "&worksheetTypes=" + data.WorksheetType;
                }
                return _.includes(self.selection, data.WorksheetType);
            });

            self.service.computeBulkPrice(self.selectedRatecard, self.bulkChangePercentage, self.selectedWorksheetsUpdate, self.worksheetTypeQuery)
                .then(function(response) {
                    let worksheets = _.concat([], response.data.Worksheets, _.filter(self.rateCardPricingSheet, function(data) {
                        return !_.includes(self.selection, data.WorksheetType);
                    }));

                    worksheets = _.sortBy(worksheets, ['WorksheetType']);
                    resetSpreadsheetData(worksheets);
                    self.selection = [];
                    blockUI.stop();
                    hubService.showToast(utils.translate('RATECARDS.MAIN_PRICING_UPDATE_MESSAGE'));
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.initFlexsheet = function(s) {
            self.flexSheet = s;
            self.flexSheet.allowDelete = true;
            self.flexSheet.autoGenerateColumns = false;
            self.flexSheet.allowAddNew = false;
            self.flexSheet.allowResizing = 1;
            self.flexSheet.allowDragging = 0;
            self.flexSheet.headersVisibility = 3;
            self.flexSheet.allowSorting = false;
            self.flexSheet.showFilterIcons = false;
            self.flexSheet.filter.defaultFilterType = 0;
            self.flexSheet.hostElement.addEventListener('contextmenu', function(e) {
                e.preventDefault();
            }, true);

            self.flexSheet.updatedView.addHandler(function() {
                if (!_.isNil(self.flexSheet.rows[0])) {
                    self.flexSheet.rows[0].visible = false;
                }
            });

            self.flexSheet.selectedSheetChanged.addHandler(function(s) {
                if (!_.isNil(self.flexSheet.rows[0])) {
                    self.flexSheet.autoSizeColumns();
                }
            });
        };

        self.launchPricingModal = function() {
            self.isBulkChangeView = true;
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/ratecards/partials/_ratecard-pricing-bulkchange.html',
                controller: function() {
                    return self;
                },
                controllerAs: 'rateCardPricing',
            });
        };

        self.saveRatecardPricing = function onCancel() {
            blockUI.start();
            self.rateCardPricingSheet = _.map(self.rateCardPricingSheet, function(data, index) {
                let currentSheet = _.find(self.flexSheet.sheets, function(s) {
                    return s.name === data.WorksheetName;
                });

                data.Rows = (_.isNil(currentSheet)) ? [] : currentSheet.itemsSource;
                return data;
            });

            self.service.saveRatecardPricing(self.selectedRatecard, self.rateCardPricingSheet)
                .then(function(response) {
                    if (response.data) {
                        exceptionService.resolve(response.data);
                    }
                    self.updateSpreadsheet(self.selectedRatecard);
                    self.selection = [];
                    blockUI.stop();
                    hubService.showToast(utils.translate('RATECARDS.MAIN_PRICING_SAVE_MESSAGE'));
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.closePricingModal = function onCancel() {
            self.selection = [];
            $mdDialog.cancel();
        };

        self.hasSelectedRatecard = function() {
            return !_.isNil(self.selectedRatecard) && self.selectedRatecard && self.showSpreadsheet;
        };

        self.getAvailableSheets = function() {
            return _.filter(self.rateCardPricingSheet, function(data) {
                return !_.isEmpty(data.Rows);
            });
        };

        self.toggleSheetSelection = function(sheetType) {
            let idx = self.selection.indexOf(sheetType);

            if (idx > -1) {
                self.selection.splice(idx, 1);
            } else {
                self.selection.push(sheetType);
            }
        };

        self.hasSelectedSheet = function() {
            return !_.isNil(self.selection) && !_.isEmpty(self.selection);
        };

        function refreshSpreadsheetData(ratecardId) {
            self.service.initializeRatecardPricing(ratecardId)
                .then(function(response) {
                    resetSpreadsheetData(response.data.Worksheets);
                    blockUI.stop();
                }, function(err) {
                    self.showSpreadsheet = false;
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function resetSpreadsheetData(spreadsheetData) {
            self.showSpreadsheet = true;
            _.map(spreadsheetData, function(data, index) {
                if (!_.isEmpty(data.Rows)) {
                    self.flexSheet.addBoundSheet(data.WorksheetName, data.Rows, data.WorksheetType);
                    _.map(data.Columns, function(col, indexCol) {
                        let currentSheetIndex = _.findIndex(self.flexSheet.sheets, function(s) {
                            return s.name === data.WorksheetName;
                        });

                        if (!_.isNil(self.flexSheet.sheets[currentSheetIndex]) && !_.isNil(self.flexSheet.sheets[currentSheetIndex].grid.columnHeaders.columns[indexCol])) {
                            self.flexSheet.sheets[currentSheetIndex].grid.columnHeaders.columns[indexCol].header = col.Heading;
                            self.flexSheet.sheets[currentSheetIndex].grid.columnHeaders.columns[indexCol].isReadOnly = col.IsReadOnly;
                            self.flexSheet.sheets[currentSheetIndex].grid.columnHeaders.columns[indexCol].visible = (col.ColumnType) == 0 ? false : true;
                            self.flexSheet.sheets[currentSheetIndex].grid.columnHeaders.wordWrap = true;

                            if (col.ColumnType === 2) {
                                self.flexSheet.sheets[currentSheetIndex].grid.columnHeaders.columns[indexCol].format = "c2";
                            }
                        }
                    });
                }
            });

            self.rateCardPricingSheet = spreadsheetData;
            self.flexSheet.selectedSheetIndex = 0;
            self.flexSheet.frozenColumns = 1;

            setTimeout(function() {
                self.flexSheet.autoSizeColumns();
            }, 1000);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.ratecards')
        .service('ratecardManageGridService', ratecardManageGridService);

    /** @ngInject */
    function ratecardManageGridService(
        exceptionService,
        ratecardManageListAdapterService
    ) {
        let service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        return service;

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(ratecardManageListAdapterService);
        }

        /**
         * Loading of partial data
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.ratecards')
        .controller('RateCardManageController', RateCardManageController);

    function RateCardManageController(
        $scope,
        $timeout,
        $rootScope,
        $q,
        $mdDialog,
        utils,
        searchDelay,
        blockUI,
        exceptionService,
        hubService,
        ratecardManageGridService,
        ratecardService,
        claimsUtilService,
        auditApi,
        historyLogService,
        surchargeCalculationMethods
    ) {
        let self = this;
        self.Title = "Manage Rate Card";
        self.utilService = utils;
        self.delay = {
            debounce: searchDelay
        };
        self.dataGrid = ratecardManageGridService;
        self.isCreateRatecardActive = false;
        self.isEditRatecardActive = false;
        self.isCloneRatecardActive = false;
        self.TravelTypes = {
            DoNotCharge: 0,
            ChargeTravelAsHours: 1,
            ChargeEstablishmentPerShiftPerDay: 11,
            ChargeTravelAsHoursAndFixedCostPerShift: 25,
            ChargeTravelHoursSeparately: 26,
            ChargeTravelAtFixedRate: 27,
            ChargeFullServiceBasedOnRateCardFormat: 28,
            ChargeTravelOnlyAtFixedRate: 29,
            ChargeTravelOnlyBasedOnRateCardFormat: 30,
            ChargedSeparatelyAtHourlyRateIfOverLimitOrFixedCostPerShift:35
        };
        self.VehicleChargeTypes = {
            ChargeVehicleBasedOnBillingPeriods: 31,
            ChargeVehicleAsWorkedHoursBasedOnRateCardFormat: 32
        };

        self.EstablishmentFeeTypes = {
            DoNotChargeEstablishmentFee:0,
            ChargePerVehiclePerShift:33,
            ChargePerVehiclePerHour:34
        };
        
        self.currentRatecard = 
        {
            formData: {
                TravelOnlyChargeType: self.TravelTypes.ChargeTravelOnlyAtFixedRate,
                EstablishmentFeeType: self.EstablishmentFeeTypes.DoNotChargeEstablishmentFee,
                VehicleChargeType: self.VehicleChargeTypes.ChargeVehicleBasedOnBillingPeriods.toString()
            }
        };
        self.packagesUpdated = false;
        self.service = ratecardService;
        self.isSetupPackupInTimesheetEnabled = claimsUtilService.isSetupPackupInTimesheetEnabled();
        self.isAltusSpecialEnabled = claimsUtilService.isAltusSpecialEnabled();
        self.isSelectedPackage = false;

        $scope.$watch(function() {
            return !self.isPackagesEmpty();
        }, function(newValue) {
            self.currentRatecard.formData.AverageEmployeeBreakHours = newValue;
        });

        // --- Invoice Surcharges (rate-card-owned) ---
        // Surcharges are managed inline and persist with the rate card via getRatecardFormdata().
        self.surchargesEnabled = claimsUtilService.isSurchargesEnabled();
        self.surchargeCalculationMethods = surchargeCalculationMethods;

        self.getSurcharges = function() {
            if (_.isNil(self.currentRatecard) || _.isNil(self.currentRatecard.formData)) {
                return [];
            }
            if (_.isNil(self.currentRatecard.formData.Surcharges)) {
                self.currentRatecard.formData.Surcharges = [];
            }
            return self.currentRatecard.formData.Surcharges;
        };

        self.openAddSurcharge = function() {
            showSurchargeDialog(null, false, -1);
        };

        self.openEditSurcharge = function(surcharge) {
            var index = self.getSurcharges().indexOf(surcharge);
            showSurchargeDialog(angular.copy(surcharge), true, index);
        };

        self.removeSurcharge = function(surcharge) {
            var list = self.getSurcharges();
            var index = list.indexOf(surcharge);
            if (index > -1) {
                list.splice(index, 1);
            }
        };

        self.openSurchargeHistory = function(surcharge) {
            if (_.isNil(surcharge) || _.isNil(surcharge.Id)) {
                return;
            }
            auditApi.getAuditEntries(surcharge.Id).then(function(response) {
                historyLogService.showHistory(
                    'Surcharges',
                    response.data,
                    surcharge.Name,
                    'surcharge-history-log-data'
                );
            }, function(err) {
                exceptionService.resolve(err);
            });
        };

        self.formatSurchargeRate = function(surcharge) {
            if (!surcharge) return '';
            if (surcharge.CalculationMethod === surchargeCalculationMethods.FixedVehicle) {
                return utils.translate('RATECARD_V2.SURCHARGES.RATE_VARIES');
            }
            if (surcharge.RatePercentage == null) return '';
            return Number(surcharge.RatePercentage).toFixed(2) + '%';
        };

        self.formatSurchargeMethod = function(surcharge) {
            if (!surcharge) return '';
            switch (surcharge.CalculationMethod) {
                case surchargeCalculationMethods.PercentageInvoice:
                    return utils.translate('RATECARD_V2.SURCHARGES.METHOD_PERCENTAGE_INVOICE');
                case surchargeCalculationMethods.PercentageVehicle:
                    return utils.translate('RATECARD_V2.SURCHARGES.METHOD_PERCENTAGE_VEHICLE');
                case surchargeCalculationMethods.FixedVehicle:
                    return utils.translate('RATECARD_V2.SURCHARGES.METHOD_FIXED_VEHICLE');
                default:
                    return '';
            }
        };

        function showSurchargeDialog(surcharge, isEdit, index) {
            $mdDialog.show({
                controller: 'AddSurchargeController as addSurcharge',
                templateUrl: 'app/main/rateCardSettings/surcharges/addSurcharge/addSurcharge.html',
                clickOutsideToClose: false,
                escapeToClose: true,
                locals: {
                    surcharge: surcharge,
                    isEdit: isEdit,
                    embedded: true
                }
            }).then(function(result) {
                if (!result) {
                    return;
                }
                var list = self.getSurcharges();
                if (isEdit && index > -1) {
                    // Merge onto the original so server-populated fields (ETag, etc.)
                    // not carried by the dialog payload survive the round-trip.
                    list[index] = angular.extend({}, list[index], result);
                } else {
                    list.push(result);
                }
            }, angular.noop);
        }

        self.toggleRatecardCreate = function(isReset) {
            self.currentRatecard = [];
            self.currentRatecard.formData = [];
            self.isCreateRatecardActive = isReset ? false : !self.isCreateRatecardActive;
            self.isEditRatecardActive = isReset ? false : !self.isEditRatecardActive;
            self.isCloneRatecardActive = isReset ? false : !self.isEditRatecardActive;

            if (!self.isCreateRatecardActive) {
                self.service.setLastRatecard();
            }
        };

        self.showCreateRateCard = function(ratecard, isClone) {
            blockUI.start();
            self.isCreateRatecardActive = true;
            if (!_.isNil(ratecard)) {
                self.service.setLastRatecard(ratecard.Id);
                self.service.currentRateCardId = ratecard.Id;
            }

            $timeout(function () {
                $scope.createRatecardForm.rateCardTravelOnlyChargeType = self.TravelTypes.ChargeTravelOnlyAtFixedRate
            });

            let uris = [getAllowanceLookup(), getTimesheetLookup(), getFormatsLookup(), getPackagesLookup(), getTravelTypesLookup(), getTravelOnlyChargeTypesLookup(),getVehicleChargeTypesLookup(),getEstablishmentFeeTypesLookup()];
            $q.all(uris).then(function() {
                if (!ratecard) {
                    blockUI.stop();
                    return;
                }

                self.isCloneRatecardActive = isClone;
                self.isEditRatecardActive = true;

                self.service.getRatecard(ratecard.Id)
                    .then(function(resp) {
                        self.currentRatecard.formData = resp.data;
                        self.oldVehicleRateRardFormat = resp.data.VehicleRateCardFormat;
                        blockUI.stop();
                    }, function(err) {
                        exceptionService.resolve(err);
                        blockUI.stop();
                    });
            }).catch(function() {
                exceptionService.resolve(err);
                blockUI.stop();
            });
        };

        self.disableVehicleRateCardFormat = function() {
            if (!self.isEditRatecardActive) return false;

            return self.oldVehicleRateRardFormat != null
        }

        self.isAllowanceSelected = function(allowanceId) {
            if (_.isEmpty(self.currentRatecard.formData) && !_.isNil($scope.createRatecardForm)) {
                $scope.createRatecardForm.rateCardAllowances.$setPristine();
                return;
            }

            if (_.isNil(self.currentRatecard.formData.Allowances)) {
                return false;
            }

            return !_.isEmpty(_.filter(self.currentRatecard.formData.Allowances, function(allowance) {
                return allowanceId === allowance.Id;
            }));
        };

        self.isTimesheetSelected = function(timesheetId) {
            if (_.isEmpty(self.currentRatecard.formData) && !_.isNil($scope.createRatecardForm)) {
                $scope.createRatecardForm.rateCardTimesheets.$setPristine();
                return;
            }

            if (_.isNil(self.currentRatecard.formData.TimesheetAdjustments)) {
                return false;
            }

            return !_.isEmpty(_.filter(self.currentRatecard.formData.TimesheetAdjustments, function(timesheet) {
                return timesheetId === timesheet.Id;
            }));
        };

        self.isPackageSelected = function(packageId) {
            if (_.isEmpty(self.currentRatecard.formData) && !_.isNil($scope.createRatecardForm)) {
                $scope.createRatecardForm.rateCardPackages.$setPristine();
                return;
            }

            if (_.isNil(self.currentRatecard.formData.Packages)) {
                return false;
            }

            return !_.isEmpty(_.filter(self.currentRatecard.formData.Packages, function(packageItem) {
                return packageId === packageItem.Id;
            }));
        };

        self.toggleSheetSelection = function(sheetType) {
            let idx = self.selection.indexOf(sheetType);

            if (idx > -1) {
                self.selection.splice(idx, 1);
            } else {
                self.selection.push(sheetType);
            }
        };

        self.getAnswer = function() {
            alert(self.currentRatecard.formData.AverageEmployeeBreakHours);
        };

        self.createNewRatecard = function() {
            blockUI.start();
            self.service.createRatecard(getRatecardFormdata(), self.isCloneRatecardActive)
                .then(function(resp) {
                    blockUI.stop();
                    hubService.showToast(utils.translate('RATECARDS.MAIN_CREATE_MESSAGE'));
                    self.dataGrid.grid.behavior.refresh();

                    self.service.setLastRatecard(resp.data.Id);
                    $rootScope.$broadcast("switchToPricingTab");
                }, function(err) {
                    exceptionService.resolve(_.isNil(err.data) ? err : err.data.Message);
                    blockUI.stop();
                });
        };

        self.saveRatecard = function() {
            blockUI.start();
            getRatecardFormdata();

            self.service.updateRatecard(self.currentRatecard.formData)
                .then(function(resp) {
                    self.service.setLastRatecard(self.currentRatecard.formData.Id);
                    blockUI.stop();
                    hubService.showToast(utils.translate('RATECARDS.MAIN_EDIT_SAVED_MESSAGE'));
                    self.dataGrid.grid.behavior.refresh();
                    $rootScope.$broadcast("switchToPricingTab");
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.hasRatecard = function() {
            return !_.isNil(self.currentRatecard.formData.Id) || !_.isEmpty(self.currentRatecard.formData.Id);
        };

        self.updatePackages = function() {
            self.packagesUpdated = true;

            if (self.currentRatecard.formData.SelectedPackages) {
                self.packagesLookup.forEach(p => {
                    let packageMatch = _.find(self.currentRatecard.formData.SelectedPackages, {
                        Id: p.Id
                    });
                    if (packageMatch) {
                        p.Tag = packageMatch.Tag;
                    }
                });
            }

            let selectedPackagesIds = [];
            let noMatchPackages = [];

            let hasSelectedPackages = self.currentRatecard.formData.SelectedPackages != undefined && self.currentRatecard.formData.SelectedPackages.length > 0;
            if (hasSelectedPackages) {
                selectedPackagesIds = self.currentRatecard.formData.SelectedPackages.map(x => x.Id);
                noMatchPackages = self.currentRatecard.formData.PackagesHolder.filter(x => !selectedPackagesIds.includes(x));
            }

            self.currentRatecard.formData.SelectedPackages = _.map(self.currentRatecard.formData.PackagesHolder, function(packageItem) {

                if (self.currentRatecard.formData.Packages) {
                    let existingPackage = self.currentRatecard.formData.Packages.filter(x => x.Id == packageItem)

                    if (existingPackage) {
                        return _.head(existingPackage);
                    }
                }
                return _.head(_.filter(self.packagesLookup, function(packageResource) {

                    return packageItem === packageResource.Id;
                }));
            });

            let counter = 1;
            if (self.isSelectedPackage) {
                if (hasSelectedPackages && noMatchPackages.length > 0) {
                    noMatchPackages.forEach((e) => {
                        self.currentRatecard.formData.SelectedPackages.find(x => x.Id == e).Tag = null;
                    });

                    self.currentRatecard.formData.SelectedPackages.sort((a, b) => a.Tag - b.Tag).forEach((e) => {
                        e.Tag = counter++;
                    });
                } else {
                    self.currentRatecard.formData.SelectedPackages.sort((a, b) => a.Tag - b.Tag).forEach((e) => {
                        e.Tag = counter++;
                    });
                }
            }
        };

        self.isPackagesEmpty = function() {
            return _.isEmpty(self.currentRatecard.formData.PackagesHolder) && self.packagesUpdated;
        };

        self.isTotalLimitSet = function() {
            return self.currentRatecard.formData.MaximumBillingTravelTotalHours > 0;
        };

        self.isToAndFromLimitSet = function() {
            return self.currentRatecard.formData.MaximumBillingTravelToHours > 0 || self.currentRatecard.formData.MaximumBillingTravelFromHours > 0;
        };

        self.archiveRatecard = function(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            let confirm = $mdDialog.confirm()
                .title('Archive Rate Card')
                .textContent('Are you sure you want to archive this rate card?')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('ARCHIVE')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function() {
                self.service.archiveRatecard(self.currentRatecard.formData.Id, true)
                    .then(function() {
                        hubService.showToast(utils.translate('RATECARDS.MAIN_ARCHIVED_MESSAGE'));
                        self.dataGrid.grid.behavior.refresh();
                        self.toggleRatecardCreate(true);
                    }, function(err) {
                        exceptionService.resolve(_.isNil(err.data) ? err : err.data.Message);
                    });
            }, function() {

            });
        };

        function getRatecardFormdata() {
            self.currentRatecard.formData.SelectedRateCardFormat = _.head(_.filter(self.formatsLookup, function(format) {
                const rateCardFormat = self.currentRatecard.formData.RateCardFormat;
                if (!rateCardFormat || rateCardFormat.Id == undefined) {
                    return rateCardFormat === format.Id;
                } else {
                    return rateCardFormat.Id === format.Id;
                }
            }));

            self.currentRatecard.formData.SelectedVehicleRateCardFormat = _.head(_.filter(self.vehicleformatsLookup, function(format) {
                const rateCardFormat = self.currentRatecard.formData.VehicleRateCardFormat;
                if (!rateCardFormat || rateCardFormat.Id == undefined) {
                    return rateCardFormat === format.Id;
                } else {
                    return rateCardFormat.Id === format.Id;
                }
            }));

            self.currentRatecard.formData.SelectedAllowances = _.map(self.currentRatecard.formData.AllowancesHolder, function(allowanceItem) {
                return _.head(_.filter(self.allowancesLookup, function(allowanceResource) {
                    return allowanceItem === allowanceResource.Id;
                }));
            });

            self.currentRatecard.formData.SelectedTimesheet = _.map(self.currentRatecard.formData.TimesheetAdjustmentsHolder, function(timesheetItem) {
                return _.head(_.filter(self.timesheetLookup, function(timesheetResource) {
                    return timesheetItem === timesheetResource.Id;
                }));
            });

            if (self.isPackagesEmpty()) {
                self.currentRatecard.formData.AverageEmployeeBreakHours = false;
                self.currentRatecard.formData.FormPackagesForShiftsWithSameTime = false;
            }

            if (self.currentRatecard.formData.SelectedPackages) {
                self.packagesLookup.forEach(p => {
                    let packageMatch = _.find(self.currentRatecard.formData.SelectedPackages, {
                        Id: p.Id
                    });
                    if (packageMatch) {
                        p.Tag = packageMatch.Tag;
                    }
                });
            }

            self.currentRatecard.formData.SelectedPackages = _.map(self.currentRatecard.formData.PackagesHolder, function(packageItem) {
                return _.head(_.filter(self.packagesLookup, function(packageResource) {
                    return packageItem === packageResource.Id;
                }));
            });
              // Ensure EstablishmentFeeType is included in the form data
              if (self.establishmentFeeTypesLookup) {
                let selectedEstablishmentFeeType = self.establishmentFeeTypesLookup.find(type => type.Key == self.currentRatecard.formData.EstablishmentFeeType);
                if (selectedEstablishmentFeeType) {
                    self.currentRatecard.formData.EstablishmentFeeType = selectedEstablishmentFeeType;
                }
            }


            return self.currentRatecard.formData;
        }
    

        function getAllowanceLookup() {
            self.service.getAllowancesAll()
                .then(function(resp) {
                    self.allowancesLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getTimesheetLookup() {
            self.service.getTimesheetAdjustmentsAll()
                .then(function(resp) {
                    self.timesheetLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getFormatsLookup() {
            self.service.getFormats()
                .then(function(resp) {
                    self.formatsLookup = resp.data;
                    self.vehicleformatsLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getPackagesLookup() {
            self.service.getPackages()
                .then(function(resp) {
                    self.packagesLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getTravelTypesLookup() {
            self.service.getTravelTypes()
                .then(function(resp) {
                    self.travelTypesLookup = resp.data
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getVehicleChargeTypesLookup() {
            self.service.getVehicleChargeTypes()
                .then(function(resp) {
                    self.vehicleChargeTypesLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }
        
        function getEstablishmentFeeTypesLookup() {
            self.service.getEstablishmentFeeTypes()
                .then(function(resp) {
                    self.establishmentFeeTypesLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getTravelOnlyChargeTypesLookup() {
            self.service.getTravelOnlyChargeTypes()
                .then(function(resp) {
                    self.travelOnlyChargeTypesLookup = resp.data
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        self.onTravelTypeChange = function() {
            self.currentRatecard.formData.TravelHoursDoNotCountTowardsShiftHours = self.isTravelChargedOnSeparateLine();
        };

        self.onTravelOnlyChargeTypeChange = function() {
            self.currentRatecard.formData.TravelHoursDoNotCountTowardsShiftHours = true;
        };

        self.isTravelChargedOnSeparateLine = function() {
            if (!self.travelTypesLookup) {
                return false;
            }

            let travelType = self.travelTypesLookup.find(type => type.Key == self.currentRatecard.formData.TravelType);

            let isTravelTypeOnSeparateLine = travelType &&
                (
                    travelType.Key == self.TravelTypes.ChargeTravelHoursSeparately ||
                    travelType.Key == self.TravelTypes.ChargedSeparatelyAtHourlyRateIfOverLimitOrFixedCostPerShift ||
                    travelType.Key == self.TravelTypes.DoNotCharge ||
                    travelType.Key == self.TravelTypes.ChargeFullServiceBasedOnRateCardFormat
                );

            if (travelType) {
                self.isTravelHoursFieldsDisabled = (travelType.Key == self.TravelTypes.DoNotCharge ||
                    travelType.Key == self.TravelTypes.ChargeEstablishmentPerShiftPerDay ||
                    travelType.Key == self.TravelTypes.ChargeTravelAsHoursAndFixedCostPerShift ||
                    travelType.Key == self.TravelTypes.ChargeTravelAtFixedRate);

                if (self.isTravelHoursFieldsDisabled && (this.isToAndFromLimitSet() || this.isTotalLimitSet())) {
                    self.currentRatecard.formData.MaximumBillingTravelTotalHours = null;
                    self.currentRatecard.formData.MaximumBillingTravelToHours = null;
                    self.currentRatecard.formData.MaximumBillingTravelFromHours = null;
                }
            }

            return isTravelTypeOnSeparateLine;
        }

        self.isTravelHoursCheckboxHidden = function() {
            if (!self.travelTypesLookup) {
                return false;
            }

            let isTravelHoursCheckboxHidden = false;
            let travelType = self.travelTypesLookup.find(type => type.Key == self.currentRatecard.formData.TravelType);

            if (travelType && (travelType.Key == self.TravelTypes.DoNotCharge || travelType.Key == self.TravelTypes.ChargeTravelHoursSeparately || travelType.Key == self.TravelTypes.ChargedSeparatelyAtHourlyRateIfOverLimitOrFixedCostPerShift || travelType.Key == self.TravelTypes.ChargeTravelAtFixedRate
                || travelType.Key == self.TravelTypes.ChargeFullServiceBasedOnRateCardFormat
            )) {
                isTravelHoursCheckboxHidden = true;
                self.currentRatecard.formData.TravelHoursDoNotCountTowardsShiftHours = true;

            } else if (travelType && travelType.Key == self.TravelTypes.ChargeTravelAsHours) {
                isTravelHoursCheckboxHidden = true;
                self.currentRatecard.formData.TravelHoursDoNotCountTowardsShiftHours = false;
            }

            return isTravelHoursCheckboxHidden;
        }

        self.openPackagesDialog = function openPackagesDialog() {
            let hasNullTag = self.currentRatecard.formData.SelectedPackages.find(x => x.Tag == null);

            if (hasNullTag) {
                var sortingArr = _.map(_.orderBy(self.currentRatecard.formData.Packages, 'Tag'), 'Id');
                self.currentRatecard.formData.PackagesHolder.sort((a, b) => (sortingArr.indexOf(a) !== -1 ? sortingArr.indexOf(a) : Infinity) - (sortingArr.indexOf(b) !== -1 ? sortingArr.indexOf(b) : Infinity));

                self.currentRatecard.formData.SelectedPackages = _.map(self.currentRatecard.formData.PackagesHolder, function(packageItem) {
                    return _.head(_.filter(self.packagesLookup, function(packageResource) {
                        return packageItem === packageResource.Id;
                    }));
                });
            }

            $mdDialog.show({
                templateUrl: 'app/main/ratecards/manage/dialog/ratecard-manage-packages.html',
                controller: 'RatecardPackagesController as vm',
                styleUrls: ['app/main/ratecards/manage/dialog/ratecard-manage-packages.scss'],
                locals: {
                    rateCardManage: self
                }
            }).then(function(resp) {

            });
        }

        self.isPackageClicked = function(packageId) {
            if (packageId) {
                self.isSelectedPackage = true;
            }
        }

        self.sync = function() {
            ratecardService.sync(self.currentRatecard.formData.Id);
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.ratecards')
        .service('ratecardManageListAdapterService', ratecardManageListAdapterService);

    /** @ngInject */
    function ratecardManageListAdapterService(
        $q,
        a8WebApiNoChunkDataProvider,
        rateCardsApi,
    ) {
        let service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData // inbound event (called by grid client)
        };

        let dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData() {
            return dbSource.fetch(function() {
                return getRatecards();
            });
        }

        function getRatecards() {
            let deferred = $q.defer();

            rateCardsApi.getRatecardAll()
                .then(function(resp) {
                    deferred.resolve(resp);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.view_reports')
        .controller('ViewReportsController', ViewReportsController);

    /** @ngInject */
    function ViewReportsController(
        $scope,
        reportService,
        _,
        $mdDialog,
        utils,
        DialogService
    ) {
        var vm = this;

        vm.service = reportService;
        vm.service.initialize();

        vm.utilService = utils;
        vm.copyContent = copyContent;
        vm.exportToExcelFile = exportToExcelFile;
        vm.print = print;
        vm.showDetails = showDetails;

        activate();

        function activate() {
            vm.service.refreshUI = refreshUI;
        }

        function refreshUI() {
            $scope.$apply();
        }

        function copyContent() {
            let table = $('#view-reports').DataTable();
            table.button(0).trigger();
        }
        
        function exportToExcelFile() {
            let table = $('#view-reports').DataTable();
            table.button(1).trigger();
        }

        function print() {
            let table = $('#view-reports').DataTable();
            table.button(2).trigger();
        }

        function showMessage(message) {
            $mdDialog.show(
                $mdDialog.alert()
                .title(utils.translate('REPORTING.REPORTS'))
                .textContent(message)
                .ok(utils.translate('REPORTING.Okay'))
            );
        }

        function showDetails(ticketNo) {
            let ticket = _.find(vm.service.selectedReportJob.ReportData.Rows, {
                TicketNumber: ticketNo
            });
            ticket ? DialogService.openTicketDetailDialog(ticket.TicketId) : showMessage(utils.translate('REPORTING.NO_TICKETID'));
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.view_reports')
        .controller('ViewReportsDialogController', ViewReportsDialogController);

    /** @ngInject */
    function ViewReportsDialogController(
        $mdDialog,
        lookups,
        utils,
        searchCriteria,
        projectApi,
        contactApi,
        skillsMatrixApi,
        ReportTagsSignalRService,
        $rootScope,
        $q
    ) {
        //Variables
        var vm = this;

        vm.searchCriteria = searchCriteria;
        vm.lookups = lookups;
        vm.companies = lookups.companies;
        vm.employees = [];
        vm.selectedItem = null;
        vm.selectedEmployee = null;
        vm.searchText = null;
        vm.searchEmployeeText = null;
        vm.selectedCompanies = [];
        vm.utilService = utils;
        vm.projectList = [];
        vm.requiredSkills = [];
        vm.parentSkills = [];
        vm.payrollDataOptions = [];
        vm.showPayrollDataOptions = false;
        vm.dateRangeRequired = false;
        vm.canSelectEmployee = false;
        vm.showRequiredSkills = false;
        vm.showClient = !vm.showRequiredSkills;
        vm.itemTypeList = lookups.itemTypes;

        //Functions
        vm.cancelDialog = cancelDialog;
        vm.querySearch = querySearch;
        vm.transformChip = transformChip;
        vm.getSelectedText = getSelectedText;
        vm.buildReport = buildReport;
        vm.queryTagSearch = queryTagSearch;
        vm.getEmployeeName = getEmployeeName;
        vm.reportOptions = reportOptions;

        //Events
        vm.onDone = onDone;
        vm.onCompanyChange = onCompanyChange;
        vm.onCompanyRemove = onCompanyRemove;
        vm.onEmployeeChange = onEmployeeChange;
        vm.onEmployeeRemove = onEmployeeRemove;
        vm.onReportStartDateChange = onReportStartDateChange;
        vm.onReportEndDateChange = onReportEndDateChange;
        vm.onReportTypeChange = onReportTypeChange;
        vm.onBranchChange = onBranchChange;

        vm.maxEmployeeLimit = 1;
        vm.reportType = {
            incomeVsCost: 5,
            incomeVsCostWithPayDetail: 6,
            vehicleUtilisation: 8,
            hoursWorked: 13,
            incomeVsCostPreviewInvoices: 14,
            availableEmployeesByDate: 17,
            hoursWorkedByPayCodes: 20,
            exportedTimeSheets: 22,
            jobShiftsTimesheet: 24,
            financeMargin: 26,
            ticketTagged: 37,
            billOfQuantities: 38,
            employeeContactTracing: 40,
            employeeSkills: 18
        };

        vm.tags = lookups.tags;

        vm.selectedTagItem = null;
        vm.searchTagText = '';

        vm.selectedExcludeTagItem = null;
        vm.searchTagExcludeText = '';

        vm.removeTagChip = function($chip) {
            vm.tags.push($chip);
            vm.tags = vm.tags.sort((a, b) => a.Name.localeCompare(b.Name));
        };

        vm.appendTagChip = function($chip) {
            vm.tags = vm.tags.filter(tag => tag.Id !== $chip.Id);
            vm.tags = vm.tags.sort((a, b) => a.Name.localeCompare(b.Name));

            vm.searchTagText = '';
            vm.selectedTagItem = null;

            vm.searchTagExcludeText = '';
            vm.selectedExcludeTagItem = null;
        };

        activate();

        function activate() {

            if (vm.searchCriteria.ReportType != null) {
                onReportTypeChange();
                onBranchChange();
                //ngModel.$validate();
            }

            ReportTagsSignalRService.register();
        }

        function cancelDialog() {
            $mdDialog.hide();
        }

        function onDone() {
            $mdDialog.hide(vm.searchCriteria);
        }

        function transformChip(chip) {
            if (vm.canSelectEmployee && vm.reachedMaxLimit) {
                return;
            }

            if (angular.isObject(chip)) {
                return chip;
            }

            return {
                Name: chip
            }
        }

        function onBranchChange() {
            var branchIds = getBranchIds();

            if (vm.searchCriteria.ReportType !== vm.reportType.employeeContactTracing.toString()) {
                onCompanyChange();

                contactApi.getActiveEmployees(branchIds)
                    .then(function(resp) {
                        vm.employees = resp.data;
                    });
            } else {
                contactApi.getAllEmployeesByBranchIds(branchIds)
                    .then(function(resp) {
                        vm.employees = resp.data;
                    });
            }
        }

        function getBranchIds() {
            var branches = [];

            vm.searchCriteria.Branches.forEach(function(branchId) {
                if (branchId.indexOf('-state') !== -1) {
                    var _ids = branchId.substr(0, branchId.indexOf("-state"));
                    _ids.split(',')
                        .forEach(function(id) {
                            branches.push(id);
                        });
                } else {
                    branches.push(branchId);
                }
            });

            return Array.from(new Set(angular.copy(branches)));
        }

        function onReportStartDateChange() {
            if (vm.searchCriteria.ReportType == vm.reportType.employeeContactTracing.toString()) {
                var dt = new Date(vm.searchCriteria.StartDate);
                vm.searchCriteria.MaxEndDate = new Date(dt.setDate(dt.getDate() + 28));
            }
        }

        function onReportEndDateChange() {
            if (vm.searchCriteria.ReportType == vm.reportType.employeeContactTracing.toString()) {
                var dt = new Date(vm.searchCriteria.EndDate);
                vm.searchCriteria.MinStartDate = new Date(dt.setDate(dt.getDate() - 28));
            }
        }

        function onCompanyChange() {
            vm.projectList.length = 0;

            var companies = parseIds(vm.searchCriteria.Companies);
            if (companies.length == 0)
                return;

            projectApi.getProjectsByCompanies(companies)
                .then(function(resp) {
                    resp.data.forEach(function(itm) {
                        vm.projectList.push(itm);
                    });
                });

            vm.searchText = null;
        }

        /**
         * This will handle removing of Projects on the fly when removing the associated Client/Company
         * Todo: Needs Refactoring (Slow perf due to server roundtrip)
         * @param {*} e
         */
        function onCompanyRemove(e) {
            if (e == null) return;

            // Remove Projects selection based on the logic below
            vm.searchCriteria.Projects.forEach(function(itm) {
                let projectCompanyIds = itm.Tag.split(';');
                if (projectCompanyIds.length > 1) {
                    let isFound = projectCompanyIds.find(function(id) {
                        return id == e.Id;
                    });

                    if (isFound == null) {
                        return;
                    }

                    let checkOtherCompaniesThisProjectHolds = projectCompanyIds.filter(function(id) {
                        return id != e.Id;
                    });

                    var isProjectFoundInOtherSelectedCompany = false;
                    for (var i = 0; i < checkOtherCompaniesThisProjectHolds.length; i++) {
                        let currentCompany = checkOtherCompaniesThisProjectHolds[i];
                        let filterResult = vm.searchCriteria.Companies.filter(function(c) {
                            return c.Id == currentCompany;
                        });

                        if (filterResult.length > 0) {
                            isProjectFoundInOtherSelectedCompany = true;
                            break;
                        }
                    }

                    if (!isProjectFoundInOtherSelectedCompany) {
                        itm['forDeletion'] = true;
                    }

                } else if (projectCompanyIds == e.Id) {
                    itm['forDeletion'] = true;
                }
            });

            vm.searchCriteria.Projects = vm.searchCriteria.Projects.filter(function(p) {
                return p.forDeletion != true;
            });

            onCompanyChange();
        }

        function onEmployeeChange() {
            vm.projectList.length = 0;
            var employees = parseIds(vm.searchCriteria.Employees);
            vm.reachedMaxLimit = employees.length == vm.maxEmployeeLimit;

            if (employees.length == 0) {
                return;
            }

            projectApi.getProjectsByEmployees(employees)
                .then(function(resp) {
                    resp.data.forEach(function(itm) {
                        vm.projectList.push(itm);
                    });
                });

            vm.searchEmployeeText = null;
            vm.selectedEmployee = null;
        }

        function onEmployeeRemove(e) {
            if (e == null) {
                return;
            }

            vm.searchCriteria.Projects.forEach(function(itm) {
                let projectEmployeeIds = itm.Tag.split(';');
                if (projectEmployeeIds.length > 1) {
                    let isFound = projectEmployeeIds.find(function(id) {
                        return id == e.Id;
                    });

                    if (isFound == null) {
                        return;
                    }

                    let checkOtherEmployeesInvolved = projectEmployeeIds.filter(function(id) {
                        return id != e.Id;
                    });

                    var isProjectFoundForOtherSelectedEmployee = false;
                    for (var i = 0; i < checkOtherEmployeesInvolved.length; i++) {
                        let currentEmployee = checkOtherEmployeesInvolved[i];
                        let filterResult = vm.searchCriteria.Employees.filter(function(c) {
                            return c.Id == currentEmployee;
                        });

                        if (filterResult.length > 0) {
                            isProjectFoundForOtherSelectedEmployee = true;
                            break;
                        }
                    }

                    if (!isProjectFoundForOtherSelectedEmployee) {
                        itm['forDeletion'] = true;
                    }

                } else if (projectEmployeeIds == e.Id) {
                    itm['forDeletion'] = true;
                }
            });

            vm.searchCriteria.Projects = vm.searchCriteria.Projects.filter(function(p) {
                return p.forDeletion != true;
            });

            onEmployeeChange();
        }

        function getEmployeeName(employee) {
            if (!employee) {
                return;
            }

            return employee.FirstName + ' ' + employee.LastName;
        };

        function querySearch(query) {
            var results = [];

            if (vm.searchCriteria.ReportType == vm.reportType.employeeContactTracing.toString()) {
                var results = vm.employees.filter(function(employee) {
                    return employee.FirstName.toLowerCase().includes(query.toLowerCase()) ||
                        employee.LastName.toLowerCase().includes(query.toLowerCase());
                });
                return results;
            } else {
                var results = vm.companies.filter(function(company) {
                    return company.Name.toLowerCase().includes(query.toLowerCase());
                });
                return results;
            }
        }

        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(tag) {
                return tag.Name.toLowerCase().includes(lowercaseQuery) &&
                    !vm.searchCriteria.Tags.some(_ => _.Id === tag.Id) && !vm.searchCriteria.ExcludeTags.some(_ => _.Id === tag.Id);
            };
        }

        function queryTagSearch(query) {
            let results = query ? vm.tags.filter(createFilterFor(query)) : vm.tags;
            let deferred = $q.defer();
            deferred.resolve(results);
            return deferred.promise;
        };

        $rootScope.$on('refreshTagLookup', function(ev, tag) {
            let tagId = tag.id || tag.Id;
            if (!vm.tags.some(f => f.Id === tagId) && !vm.searchCriteria.Tags.some(f => f.Id === tagId) && !vm.searchCriteria.ExcludeTags.some(f => f.Id === tagId)) {
                vm.tags.push({
                    Id: tagId,
                    Name: tag.Name,
                    IsActive: tag.IsActive
                });
            }
            vm.tags = vm.tags.sort((a, b) => a.Name.localeCompare(b.Name));
        });

        function buildReport() {
            $mdDialog.hide(vm.searchCriteria);
        }

        function parseIds(list) {
            var listOfIds = [];
            list.forEach(function(obj) {
                var id = obj.id || obj.Id;
                listOfIds.push(id);
            });
            return listOfIds;
        }

        function getSelectedText(selected, title) {
            if (selected !== undefined) {
                if (selected.length === 0) {
                    return title;
                } else {
                    var selectedItems = selected;
                    var displayText = "";

                    for (var i = 0; i < selectedItems.length; i++) {
                        var match;
                        if (selectedItems[i].indexOf('-state') !== -1) {
                            var _id = selectedItems[i].substr(0, selectedItems[i].indexOf("-state"));
                            match = alasql('SELECT Name FROM ? WHERE Id = ? AND State IS NULL', [vm.lookups.branches, _id]);
                        } else {
                            match = alasql('SELECT Name FROM ? WHERE Id = ? AND State IS NOT NULL', [vm.lookups.branches, selectedItems[i]]);
                        }
                        if (match[0])
                            displayText += (displayText != "" ? ", " : "") + match[0].Name;
                    }
                    return displayText;
                }
            } else {
                return title;
            }
        };

        function onReportTypeChange() {
            vm.searchCriteria.RequiredSkills = [];
            vm.showClient = true;
            vm.showRequiredSkills = false;

            const reportTypeId = vm.searchCriteria.ReportType;

            let filteredReportType = vm.lookups.ReportTypes.find((reportType) => reportType.Id == reportTypeId);

            vm.dateRangeRequired = (filteredReportType.Tag == "DateRangeRequired");
            vm.canSelectEmployee = (vm.searchCriteria.ReportType == vm.reportType.employeeContactTracing.toString());

            if (reportTypeId == vm.reportType.availableEmployeesByDate) {
                vm.showClient = false;
                vm.showRequiredSkills = true;

                populateSkills();
            }

            vm.showPayrollDataOptions = isPayrollReport(reportTypeId);
            populatePayrollOptions();
        }

        function populateSkills() {
            var otherOption = "Other";
            vm.requiredSkills = [];

            skillsMatrixApi.getSkillsandChildren().then(function(resp) {
                resp.data.forEach(function(skillItem) {
                    if (skillItem.ChildSkills.length > 0) {
                        skillItem.ChildSkills.forEach(function(childSkill) {
                            childSkill.ParentName = skillItem.SkillName;
                            vm.requiredSkills.push(childSkill);

                            addParentSkill(childSkill.ParentName);
                        })
                    } else {
                        skillItem.ParentName = otherOption;
                        vm.requiredSkills.push(skillItem);

                        addParentSkill(skillItem.ParentName);
                    }
                })

                var checkOtherOption = vm.parentSkills.indexOf(otherOption);

                if (checkOtherOption > -1) {
                    vm.parentSkills.splice(checkOtherOption, 1);
                    vm.parentSkills.push(otherOption);
                }
            });
        }

        function addParentSkill(requiredSkill) {
            if (vm.parentSkills.indexOf(requiredSkill) === -1) {
                vm.parentSkills.push(requiredSkill)
            }
        }

        function populatePayrollOptions() {
            vm.payrollDataOptions = [];

            vm.payrollDataOptions.push({
                Id: 0,
                Name: utils.translate("REPORTING.EXPORTED_DATA"),
                IsDefault: vm.searchCriteria.ShouldUseTemporaryInterpretedShift == 0 ? true : false,
            });

            vm.payrollDataOptions.push({
                Id: 1,
                Name: utils.translate("REPORTING.INTERPRETED_DATA"),
                IsDefault: vm.searchCriteria.ShouldUseTemporaryInterpretedShift == 1 ? true : false,
            })

            return vm.payrollDataOptions;
        }

        function isPayrollReport(reportTypeId) {
            if (reportTypeId == vm.reportType.incomeVsCost ||
                reportTypeId == vm.reportType.incomeVsCostWithPayDetail ||
                reportTypeId == vm.reportType.incomeVsCostPreviewInvoices ||
                reportTypeId == vm.reportType.hoursWorkedByPayCodes ||
                reportTypeId == vm.reportType.financeMargin ||
                reportTypeId == vm.reportType.exportedTimeSheets) {
                return true;
            }

            return false;
        }

        function reportOptions() {
            let reportType = Number(vm.searchCriteria.ReportType);

            let includeTravel = [vm.reportType.hoursWorked].includes(reportType);
            let includeInactiveEmployees = [vm.reportType.hoursWorked].includes(reportType) || [vm.reportType.employeeSkills].includes(reportType);
            let includeBreakInShiftTotal = [vm.reportType.billOfQuantities, vm.reportType.jobShiftsTimesheet].includes(reportType);
            
            return {
                showIncludeTravel: includeTravel,
                showIncludeInactiveEmployees: includeInactiveEmployees,
                showIncludeBreakInShiftTotal: includeBreakInShiftTotal
            };
        }
    }
})();

(function () {
	'use strict';
	
    angular.module('app.view_reports')
		.service('ReportTagsSignalRService', ReportTagsSignalRService);

	/** @ngInject */
	function ReportTagsSignalRService(signalRService,
		$rootScope) {

        var isInitialized = false;

		function register () {
			if (signalRService.isConnected) {
				regs();
			} else {
				$rootScope.$on('signalR_OnConnected', function () {
					if (!isInitialized) {
						regs();
						isInitialized = true;
					}
				});
			}

			function regs () {
				signalRService.messageHub.on('refreshTagLookup', function (data) {
					$rootScope.$broadcast('refreshTagLookup', data);
				});
			}
		}

		var service = {
			register: register
		};

		return service;
	}

})();

/**
 * View Exquipment Grid
 * Created by queeniejgm on 07/18/2018.
 */
(function() {
    'use strict';

    angular.module('app.view_reports')
        .service('viewReportsGridService', viewReportsGridService);

    /** @ngInject */
    function viewReportsGridService($log,
                                       $q,
                                       $rootScope,
                                       exceptionService,
                                       viewReportsListAdapterService) {

        let service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        return service;

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(viewReportsListAdapterService);
        }

        /**
         * Loading of partial data
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }

    }
})();

/**
 * View Exquipment List Adapter
 * Created by queeniejgm on 07/18/2018.
 */
(function () {
    'use strict';

    angular.module('app.view_reports')
        .service('viewReportsListAdapterService', viewReportsListAdapterService);

    /** @ngInject */
    function viewReportsListAdapterService($log,
                                              $q,
                                              a8WebApiNoChunkDataProvider,
                                              rateCardsApi,
                                              exceptionService,
                                           reportService) {

        let service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            awardCounter: 0
        };

        let dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData() {
            return dbSource.fetch(function () {
                return getReportsData();
            });
        }

        function getReportsData() {
            if (service.awardCounter === 0) {
                let deferred = $q.defer();
                deferred.resolve([]);
                service.awardCounter++;
                return deferred.promise;
            }

            let deferred = $q.defer();
            deferred.resolve(reportService.selectedReportJob.ReportData.Rows);
            service.awardCounter++;
            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.reporting', [
        'app.api',
        'app.corelib',
        'app.widgets',
        'app.shared.models',
        'app.view_reports'
    ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/reporting');
    };

    /** @ngInject */
    function runConfig(msNavigationService, reportService, claimsUtilService, adminClaimsService) {

        // Navigation
        msNavigationService.saveItem('apps.reporting', {
            title: 'Reporting',
            icon: 'icon-poll-box',
            weight: 8
        });

        msNavigationService.saveItem('apps.reporting.view', {
            title: 'View Reports',
            state: 'app.view_reports',
            weight: 1
        });

        msNavigationService.saveItem('apps.reporting.paperwork-exceptions', {
            title: 'Timesheet Warnings',
            state: 'app.paperwork-exceptions',
            weight: 2,
            hidden: function () {
                return !claimsUtilService.isMobileAppEnabled() || !adminClaimsService.hasPaperworkExceptionAccess;
            }
        });

        msNavigationService.saveItem('apps.reporting.skill_status_report', {
            title: 'Skill Status Report',
            state: 'app.skill_status_report',
            weight: 3,
            hidden: function() {
                return !adminClaimsService.hasEmployeeReportsAccess;
            }
        });

        reportService.register();
    }

})();

(function() {
    'use strict';

    angular.module('app.reporting')
        .factory('reportService', reportService);

    /** @ngInject */
    function reportService(
        $q,
        $rootScope,
        $log,
        branchService,
        invoiceApi,
        claimsUtilService,
        $mdDialog,
        searchDelay,
        reportsApi,
        signalRService,
        utils,
        tagsApi,
        localisationService,
        $http,
        exceptionService,
        msgboxService,
        lookupApi,
        reportType
    ) {
        var service = {
            lookups: [],
            initialize: initialize,
            showFilters: showFilters,
            checkIfValidForLink: checkIfValidForLink,
            searchTable: searchTable,
            searchQuery: null,
            initializing: false,
            isLoaded: false,
            toolbarText: null,
            hasLink: false,
            register: registerForEvents,
            refreshUI: angular.noop,
            reportJobs: [],
            loadReportInGrid: loadReportInGrid,
            requeueReportJob: requeueReportJob,
            deleteReportJob: deleteReportJob,
            selectedReportJob: null
        };

        let isInitialized = false; // To prevent double subscription to event
        let localeSettings = [];

        const headingColors = [
            'deep-purple-fg', // : key == 0,
            'indigo-fg', // : key == 1,
            'blue-fg', // : key == 2,
            'light-blue-fg', // : key == 3,
            'cyan-fg', // : key == 4,
            'teal-fg', // : key == 5,
            'green-fg', // : key == 6,
            'light-green-fg', // : key == 7,
            'lime-fg', // : key == 8,
            'yellow-fg', // : key == 9,
            'amber-fg', // : key == 10,
            'orange-fg', // : key == 11,
            'deep-orange-fg', // : key == 12,
            'brown-fg', // : key == 13,
            'grey-fg', // : key == 14,
            'blue-gray-fg', // : key == 15,
            'red-fg', // : key == 16,
            'pink-fg', // : key == 17,
            'purple-fg', // : key == 18,
        ];
        const billingReportTypeIds = [
            4, 5, 6, 10, 14, 15, 21, 26, 28, 35, 36
        ];

        activate();

        return service;

        function activate() {
            localeSettings = localisationService.getLocaleFormatSettings();
        }

        function registerForEvents() {
            if (signalRService.isConnected) {
                registerReportStatusEvent();
                return;
            }

            $rootScope.$on('signalR_OnConnected', function() {
                if (!isInitialized) {
                    registerReportStatusEvent();
                    isInitialized = true;
                }
            });
        }

        function registerReportStatusEvent() {
            signalRService.messageHub.on('reportRequestCallback', function(response) {
                $log.log('Message Hub: Generate Report callback triggered.');
                reportStatusCallback(response)
            });
        }

        function reportStatusCallback(response) {
            var reportJob = service.reportJobs.find((element) => element.Id === response.Id)
            if (!reportJob) {
                return;
            }

            reportJob.ReportDataUrl = response.ReportDataUrl;
            reportJob.ReportExcelUrl = response.ReportExcelUrl;
            reportJob.JobStatus = response.JobStatus;
            reportJob.StatusUpdatedOn = moment(response.StatusUpdatedOn).format(localeSettings.dateTimeFormatWithSlash);
            reportJob.ErrorMessage = response.ErrorMessage;

            service.refreshUI();
        }

        function deleteReportJob(reportJobId) {
            var reportJob = service.reportJobs.find((element) => element.Id === reportJobId);
            if (!reportJob) {
                exceptionService.showError("There was an error deleting the report. Please refresh the page and try again. If the problem persist please contact support.");
                return;
            }

            msgboxService
                .yepNo("Are you sure you want to delete this report?", 'Delete ' + reportJob.ReportName + ' Report', 'Yes', 'No')
                .then(function() {
                    reportsApi.deleteReportJob(reportJobId)
                        .then(function() {
                            const indexToDelete = service.reportJobs.indexOf(reportJob)
                            if (indexToDelete > -1) {
                                service.reportJobs.splice(indexToDelete, 1);
                            }
                        })
                        .catch(function() {
                            service.toolbarText = null;
                            service.initializing = false;

                            exceptionService.showError("There was an error deleting the " + reportJob.ReportName + " report.");
                        });
                })
        }

        function requeueReportJob(reportJobId) {
            var reportJob = service.reportJobs.find((element) => element.Id === reportJobId);
            if (!reportJob) {
                exceptionService.showError("There was an error loading the filters for the selected report. Please refresh the page and try again. If the problem persist please contact support.");
                return;
            }

            var startDate = reportJob.Filters.StartDate ? moment(reportJob.Filters.StartDate, localeSettings.displayDateFormat).toDate() : null;
            var endDate = reportJob.Filters.EndDate ? moment(reportJob.Filters.EndDate, localeSettings.displayDateFormat).toDate() : null;

            showFilters({
                ReportType: reportJob.ReportType.toString(),
                Companies: reportJob.Filters.Companies,
                Employees: reportJob.Filters.Employees,
                Branches: reportJob.Filters.Branches,
                Projects: reportJob.Filters.Projects,
                StartDate: startDate,
                EndDate: endDate,
                Tags: reportJob.Filters.Tags,
                ExcludeTags: reportJob.Filters.ExcludeTags,
                ShouldUseTemporaryInterpretedShift: reportJob.Filters.ShouldUseTemporaryInterpretedShift ? 1 : 0,
                RequiredSkills: reportJob.Filters.RequiredSkills
            });
        }

        function loadReportInGrid(reportJobId) {
            $.fn.dataTable.moment(localeSettings.shortdateFormatWithSlash);

            service.toolbarText = null;
            service.selectedReportJob = null;

            var reportJob = service.reportJobs.find((element) => element.Id === reportJobId);
            if (!reportJob) {
                exceptionService.showError("There was an error loading the data for the selected report. Please refresh the page and try again. If the problem persist please contact support.");
                return;
            }

            service.initializing = true;
            service.selectedReportJob = reportJob;

            if (reportJob.ReportData) {
                displaySelectedReport();

                service.initializing = false;

                return;
            }

            service.toolbarText = "Downloading data for " + reportJob.ReportName + " report ...";

            $http({
                    method: 'GET',
                    url: reportJob.ReportDataUrl,
                    responseType: 'json',
                    skipInterceptor: true
                })
                .then(function(response) {
                    reportJob.ReportData = response.data;

                    displaySelectedReport();

                    service.initializing = false;
                })
                .catch(function() {
                    service.toolbarText = null;
                    service.initializing = false;

                    exceptionService.showError("There was an error downloading data for the " + reportJob.ReportName + " report.");
                });
        }

        function displaySelectedReport() {
            service.toolbarText = "Loading " + service.selectedReportJob.ReportName + " report ...";

            let isReportEmpty = service.selectedReportJob.ReportData.Rows.length == 0;
            if (isReportEmpty) {
                service.selectedReportJob.ReportData.Headers = [{
                    ModelName: "Result",
                    DisplayName: "Result"
                }]
                service.selectedReportJob.ReportData.Rows = [{
                    "Result": "This report does not have any records to display."
                }];
                service.selectedReportJob.showWidgets = false;
            }

            prepareSelectedReportForDisplay();

            if (service.searchQuery != null) {
                service.searchTable();
            }

            service.toolbarText = "Viewing " + service.selectedReportJob.ReportName + " Report";
        }

        function prepareSelectedReportForDisplay() {
            let reportData = service.selectedReportJob.ReportData;

            angular.forEach(reportData.Rows, function(value) {
                angular.forEach(reportData.Headers, function(model) {
                    if (3 === model["Type"] || 4 === model["Type"]) {
                        let dateValue = value[model["ModelName"]];

                        if (!isNaN(Date.parse(dateValue))) {
                            if (!isFormattedDate(dateValue)) {
                                value.DateSorter = Date.parse(dateValue);
                                
                                let dateFormat = 3 === model["Type"] ? localeSettings.displayDateFormat : localeSettings.dateTimeFormatWithSlash;
                                value[model["ModelName"]] = moment(dateValue)
                                    .format(dateFormat);
                            }
                        }
                    }

                });
            });

        function isFormattedDate(inputDate) {
            var dateFormatRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            return dateFormatRegex.test(inputDate);
        }

            if (reportData.Rows.length > 0 && (service.selectedReportJob.Id === 5 || service.selectedReportJob.ReportType === 5)) {
                //format negative rows to currency on export to excel
                var str = "($";

                angular.forEach(reportData.Rows, function(data) {
                    if (data.Income && data.Income.startsWith(str))
                        data.Income = data.Income.replace("(", "-")
                        .replace(")", "");

                    if (data.LabourCost && data.LabourCost.startsWith(str))
                        data.LabourCost = data.LabourCost.replace("(", "-")
                        .replace(")", "");

                    if (data.LabourHireCost && data.LabourHireCost.startsWith(str))
                        data.LabourHireCost = data.LabourHireCost.replace("(", "-")
                        .replace(")", "");

                    if (data.TotalLabourCost && data.TotalLabourCost.startsWith(str))
                        data.TotalLabourCost = data.TotalLabourCost.replace("(", "-")
                        .replace(")", "");
                })
            }

            if (reportData.Headings != undefined) {
                var index = 0;
                angular.forEach(reportData.Headings, function(heading) {
                    if (index > 18) {
                        index = 0;
                    }
                    heading.headingColor = headingColors[index];
                    index = index + 1;
                });
            }

            service.hasLink = service.checkIfValidForLink(reportData.Headers);
            reportData.gridMetadata = {};

            if (reportData.hasOwnProperty('Formatting') && reportData.Formatting.length > 0) {
                reportData.gridMetadata = angular.copy(reportData.Formatting[0]); // For grid formatting
                delete reportData.Formatting;
            }
        }

        function searchTable() {
            setTimeout(function() {
                $('#view-reports')
                    .DataTable()
                    .search(service.searchQuery)
                    .draw();
            }, searchDelay);
        }

        function checkIfValidForLink(headers) {
            let match = headers.find(header => header.ModelName === "TicketNumber" && header.Type === 5);

            return !!match;
        }

        function initialize() {
            service.initializing = true;

            if (service.isLoaded) {
                service.initializing = false;
                return;
            }

            loadReportJobs();
            loadLookups();
        }

        function loadReportJobs() {
            reportsApi.getAllReportJobs().then(resp => {
                service.reportJobs = resp.data.sort((a, b) => a - b);

                service.reportJobs.forEach((reportJob) => {
                    mapReportJobFields(reportJob);
                });
            });
        }

        function loadLookups() {
            var invoicePromise = invoiceApi.getClients(),
                branchPromise = branchService.getBranchesAndStates(),
                reportTypesPromise = reportsApi.getReportType(),
                tagsPromise = tagsApi.getAllTags(),
                itemTypesPromise = lookupApi.getItemTypes3();

            $q.all([invoicePromise, branchPromise, reportTypesPromise, tagsPromise, itemTypesPromise])
                .then(function(resp) {
                    service.lookups.Companies = resp[0].data;
                    service.lookups.Branches = resp[1];
                    service.lookups.ReportTypes = resp[2].data;

                    if (!claimsUtilService.isPayrollEnabled()) {
                        service.lookups.ReportTypes = service.lookups.ReportTypes.filter(a => a.Id != 20);
                    }

                    if (!claimsUtilService.isBillingEnabled()) {
                        service.lookups.ReportTypes = service.lookups.ReportTypes.filter(a => billingReportTypeIds.indexOf(parseInt(a.Id)) == -1);
                    }

                    service.lookups.Tags = resp[3].data;
                    service.lookups.ItemTypes = resp[4].data.filter(x=> x.TypeName == "Asset" || x.TypeName == "Rental" || x.TypeName == "Vehicle");
                    service.initializing = false;
                    service.isLoaded = true;
                });
        }

        function showFilters(searchFilters) {
            $mdDialog.show({
                    templateUrl: 'app/main/reporting/view/view-reports-filter-dialog.html',
                    controller: 'ViewReportsDialogController as vm',
                    locals: {
                        lookups: {
                            branches: service.lookups.Branches,
                            companies: service.lookups.Companies,
                            ReportTypes: service.lookups.ReportTypes,
                            tags: service.lookups.Tags,
                            employees: service.lookups.Employees,
                            itemTypes: service.lookups.ItemTypes
                        },
                        searchCriteria: searchFilters == null ? {
                            ReportType: null,
                            Companies: [],
                            Employees: [],
                            Branches: [],
                            Projects: [],
                            StartDate: null,
                            EndDate: null,
                            Tags: [],
                            ExcludeTags: [],
                            ShouldUseTemporaryInterpretedShift: 0,
                            IncludeBreakInShiftTotal: false,
                            IncludeTravel: false,
                            IncludeInactiveEmployee: false,
                            ItemTypes:[],
                        } : searchFilters
                    }
                })
                .then(function(data) {
                    if (data) {
                        data.Companies = parseIds(data.Companies);
                        data.Employees = parseIds(data.Employees);

                        data.StartDate = data.StartDate ? utils.jsDate(data.StartDate) : data.StartDate;
                        data.EndDate = data.EndDate ? utils.jsDate(data.EndDate) : data.EndDate;

                        data.Tags = parseIds(data.Tags);
                        data.ExcludeTags = parseIds(data.ExcludeTags);

                        var branches = [];
                        if (data.Branches.length === 0) {
                            angular.forEach(service.lookups.Branches, function(branch) {
                                if (branch.State === null) {
                                    branch.Id.split(',')
                                        .forEach(function(id) {
                                            branches.push(id);
                                        });
                                } else {
                                    branches.push(branch.Id);
                                }
                            });
                        } else {
                            data.Branches.forEach(function(branchId) {
                                if (branchId.indexOf('-state') !== -1) {
                                    var _ids = branchId.substr(0, branchId.indexOf("-state"));
                                    _ids.split(',')
                                        .forEach(function(id) {
                                            branches.push(id);
                                        });
                                } else {
                                    branches.push(branchId);
                                }
                            });
                        }
                        data.Branches = Array.from(new Set(angular.copy(branches))) // Cleaned branches

                        data.TokenId = utils.newGuid();

                        reportsApi.generateReport(data)
                            .then(function() {
                                reportsApi.getReportJob(data.TokenId)
                                    .then(function(response) {
                                        let reportJob = response.data;
                                        mapReportJobFields(reportJob);
                                        service.reportJobs.unshift(reportJob);
                                    })
                                    .catch(function(ex) {
                                        exceptionService.showError("There was an error while retrieving the queued report.");
                                    });
                            })
                            .catch(function(ex) {
                                exceptionService.showError("There was an error while queueing the report to run.");
                            });
                    }
                })
        }

        function parseIds(list) {
            var listOfIds = [];

            angular.forEach(list, function(obj) {
                var id = obj.id || obj.Id;
                listOfIds.push(id);
            });

            return listOfIds;
        }

        function mapReportJobFields(reportJob) {
            reportJob.hasStartDate = reportJob.Filters.StartDate != null;
            if (reportJob.hasStartDate) {
                reportJob.Filters.StartDate = moment(reportJob.Filters.StartDate).format(localeSettings.displayDateFormat);
            }

            reportJob.hasEndDate = reportJob.Filters.EndDate != null;
            if (reportJob.hasEndDate) {
                reportJob.Filters.EndDate = moment(reportJob.Filters.EndDate).format(localeSettings.displayDateFormat);
            }

            reportJob.StatusUpdatedOn = moment(reportJob.StatusUpdatedOn).format(localeSettings.dateTimeFormatWithSlash);
            reportJob.ReportData = null;
            reportJob.showWidgets = true;

            reportJob.hasTravelIncluded = reportJob.Filters.IncludeTravel? "Yes": "No";
            reportJob.hasInactiveEmployeeIncluded = reportJob.Filters.IncludeInactiveEmployee? "Yes": "No";
            reportJob.isHoursWorkedReport = reportJob.ReportType == reportType.HOURS_WORKED;

            reportJob.includeBreakInShiftTotal = reportJob.Filters.IncludeBreakInShiftTotal? "Yes": "No";
            reportJob.showIncludeBreakInShiftTotal  = [reportType.BILL_OF_QUANTITIES, reportType.JOB_SHIFTS_TIMESHEET].includes(Number(reportJob.ReportType));

        }
    }
})();

(function() {
    'use strict';

    angular.module('app.rateCardSettings')
        .service('rateCardTimesheetsGridService', rateCardTimesheetsGridService);

    /** @ngInject */
    function rateCardTimesheetsGridService(
        exceptionService,
        rateCardSettingsTimesheetsListAdapterService
    ) {
        let service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        return service;

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(rateCardSettingsTimesheetsListAdapterService);
        }

        /**
         * Loading of partial data
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.rateCardSettings')
        .controller('RateCardSettingsTimesheetsController', RateCardSettingsTimesheetsController);

    function RateCardSettingsTimesheetsController(
        $scope,
        $q,
        utils,
        blockUI,
        searchDelay,
        hubService,
        exceptionService,
        rateCardTimesheetsGridService,
        rateCardSettingsService
    ) {
        let self = this;
        self.delay = {
            debounce: searchDelay
        };
        self.dataGrid = rateCardTimesheetsGridService;
        self.service = rateCardSettingsService;
        self.Title = "Manage Break Adjustments";
        self.formData = [];
        $scope.conditionsArray = [];
        self.isCreateRatecardTimesheetActive = false;
        self.isEditRatecardTimesheetActive = false;

        self.toggleTimesheetCreate = function() {
            self.formData = [];
            $scope.conditionsArray = [];
            self.isCreateRatecardTimesheetActive = false;
            self.isEditRatecardTimesheetActive = false;
        };

        self.showCreateRateCardTimesheet = function(timesheet) {
            blockUI.start();
            let uris = [getTimesheetTypesLookup(), getTimesheetConditionsLookup()];
            $q.all(uris).then(function() {
                if (!timesheet) {
                    self.isCreateRatecardTimesheetActive = true;
                    blockUI.stop();
                    return;
                }

                self.service.getRatecardTimesheet(timesheet.Id)
                    .then(function(resp) {
                        self.formData = resp.data;
                        $scope.conditionsArray = resp.data.Conditions;
                        self.isEditRatecardTimesheetActive = true;
                        self.isCreateRatecardTimesheetActive = true;
                        blockUI.stop();
                    }, function(err) {
                        exceptionService.resolve(err);
                        blockUI.stop();
                    });
            }).catch(function() {
                exceptionService.resolve(err);
                blockUI.stop();
            });
        };

        self.createTimesheet = function() {
            blockUI.start();

            let params = buildRatecardTimesheetParams();

            self.service.createRatecardTimesheet(params)
                .then(function(resp) {
                    hubService.showToast(utils.translate('RATECARD_V2.MAIN_TIMESHEETS_CREATE_MESSAGE'));
                    self.dataGrid.grid.behavior.refresh();
                    self.toggleTimesheetCreate();
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.removeTimesheet = function(timesheet) {
            blockUI.start();
            self.service.removeRatecardTimesheet(timesheet.Id)
                .then(function(resp) {
                    hubService.showToast(utils.translate('RATECARD_V2.MAIN_TIMESHEETS_DELETE_MESSAGE'));
                    self.dataGrid.grid.behavior.refresh();
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.updateTimesheet = function() {
            blockUI.start();

            let params = buildRatecardTimesheetParams();

            self.service.updateRatecardTimesheet(self.formData.Id, params)
                .then(function(resp) {
                    hubService.showToast(utils.translate('RATECARD_V2.MAIN_TIMESHEET_UPDATE_MESSAGE'));
                    self.dataGrid.grid.behavior.refresh();
                    self.toggleTimesheetCreate();
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        function getTimesheetTypesLookup() {
            self.service.getTimesheetTypes()
                .then(function(resp) {
                    self.timesheetTypesLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getTimesheetConditionsLookup() {
            self.service.getTimesheetConditions()
                .then(function(resp) {
                    self.timesheetConditionsLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function buildRatecardTimesheetParams() {
            $scope.conditionsArray = _.map(_.values($scope.conditionsArray), function(condition) {
                if (_.isNil(condition.ConditionType)) {
                    self.formError = true;
                    return;
                }

                return {
                    "ConditionOrder": condition.ConditionOrder,
                    "ConditionType": parseInt(condition.ConditionType),
                    "InputVariable": parseInt(condition.InputVariable),
                    "ConditionOperator": parseInt(condition.ConditionOperator),
                    "ConditionDecimalCompareType": parseInt(condition.ConditionDecimalCompareType),
                    "ConditionDecimalValue": parseFloat(condition.ConditionDecimalValue),
                    "ConditionStringValues": _.isNil(condition.ConditionStringValues) ? [] : (!_.isNil(self.formData.Id) ? condition.ConditionStringValues : [condition.ConditionStringValues]),
                    "ConditionDays": condition.dayOfWeekSelection,
                    "ConditionJobStartTime": _.isNil(condition.ConditionJobStartTime) ? null : moment(condition.ConditionJobStartTime, 'HH:mm a').format('HH:mm:ss'),
                    "ConditionJobEndTime": _.isNil(condition.ConditionJobEndTime) ? null : moment(condition.ConditionJobEndTime, 'HH:mm a').format('HH:mm:ss')
                };
            });

            return {
                "Name": self.formData.Name,
                "AdjustmentType": self.formData.AdjustmentType,
                "AdjustmentDecimalValue": self.formData.AdjustmentDecimalValue,
                "Conditions": $scope.conditionsArray
            };
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.rateCardSettings')
        .service('rateCardSettingsTimesheetsListAdapterService', rateCardSettingsTimesheetsListAdapterService);

    /** @ngInject */
    function rateCardSettingsTimesheetsListAdapterService(
        $q,
        a8WebApiNoChunkDataProvider,
        rateCardsApi
    ) {
        let service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData // inbound event (called by grid client)
        };

        let dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData() {
            return dbSource.fetch(function() {
                return getRatecardTimesheets();
            });
        }

        function getRatecardTimesheets() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetAll()
                .then(function(resp) {
                    deferred.resolve(resp);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.payroll-settings.manage')
        .factory('rateCardSettingsService', rateCardSettingsService);

    function rateCardSettingsService(
        $q,
        rateCardsApi,
        packagesApi,
        _
    ) {
        let self = this;
        self.service = {};

        self.service.packageGroups = [];
        self.service.lastPackageGroupCounter = 0;

        self.service.getRatecard = function(ratecardId) {
            let deferred = $q.defer();

            rateCardsApi.getRatecard(ratecardId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowancesAll = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowancesAll().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTimesheetAdjustmentsAll = function() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetAdjustmentsAll().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTimesheetAll = function() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetAll().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getPackageTemplates = function() {
            let deferred = $q.defer();

            packagesApi.getPackageTemplates().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getFormats = function() {
            let deferred = $q.defer();

            rateCardsApi.getFormats().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getPackages = function() {
            let deferred = $q.defer();

            rateCardsApi.getPackages().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTravelTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getTravelTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getRatecardsLookup = function() {
            let deferred = $q.defer();

            rateCardsApi.getRatecardAll().then(function(resp) {
                self.service.ratecards = resp.data;
                deferred.resolve({
                    data: resp.data
                });

            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.initializeRatecardPricing = function(ratecardId) {
            let deferred = $q.defer();

            rateCardsApi.getRatecardPricingSpreadsheetData(ratecardId).then(function(resp) {
                self.service.pricingSpreadsheetData = resp.data;
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.saveRatecardPricing = function(id, worksheet) {
            let deferred = $q.defer();

            let param = {
                Worksheets: worksheet
            };

            rateCardsApi.saveRatecardPricingData(id, param).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.computeBulkPrice = function(id, percentage, worksheet, worksheetTypeQuery) {
            let deferred = $q.defer();

            let param = {
                Worksheets: worksheet
            };

            rateCardsApi.postBulkPricingUpdate(id, param, percentage, worksheetTypeQuery).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.createRatecard = function(params, isClone) {
            let deferred = $q.defer();

            let rateCardParams = {
                "Name": params.Name,
                "RateCardFormat": params.SelectedRateCardFormat,
                "Allowances": params.SelectedAllowances,
                "Packages": params.SelectedPackages,
                "TimesheetAdjustments": params.SelectedTimesheet,
                "AverageEmployeeBreakHours": !_.isNil(params.AverageEmployeeBreakHours) ? params.AverageEmployeeBreakHours : false,
                "FormPackagesForShiftsWithSameTime": !_.isNil(params.FormPackagesForShiftsWithSameTime) ? params.FormPackagesForShiftsWithSameTime : false,
                "ChargeEmployeeBreaks": !_.isNil(params.ChargeEmployeeBreaks) ? params.ChargeEmployeeBreaks : false,
                "ChargeEquipmentBreaks": !_.isNil(params.ChargeEquipmentBreaks) ? params.ChargeEquipmentBreaks : false,
                "RoundAllHoursToNeareast15Minutes": !_.isNil(params.RoundAllHoursToNeareast15Minutes) ? params.RoundAllHoursToNeareast15Minutes : false,
                "InvoiceShiftsOnSeparateInvoice": !_.isNil(params.InvoiceShiftsOnSeparateInvoice) ? params.InvoiceShiftsOnSeparateInvoice : false,
                "TravelHoursDoNotCountTowardsShiftHours": !_.isNil(params.TravelHoursDoNotCountTowardsShiftHours) ? params.TravelHoursDoNotCountTowardsShiftHours : false,
                "MinimumBillingHours": !_.isNil(params.MinimumBillingHours) ? parseFloat(params.MinimumBillingHours) : null,
                "TrimJobStartByMinutes": !_.isNil(params.TrimJobStartByMinutes) ? _.toInteger(params.TrimJobStartByMinutes) : null,
                "TrimJobEndByMinutes": !_.isNil(params.TrimJobEndByMinutes) ? _.toInteger(params.TrimJobEndByMinutes) : null,
                "TravelType": params.TravelType,
                "MaximumBillingTravelTotalHours": !_.isNil(params.MaximumBillingTravelTotalHours) ? _.toInteger(params.MaximumBillingTravelTotalHours) : null,
                "MaximumBillingTravelToHours": !_.isNil(params.MaximumBillingTravelToHours) ? _.toInteger(params.MaximumBillingTravelToHours) : null,
                "MaximumBillingTravelFromHours": !_.isNil(params.MaximumBillingTravelFromHours) ? _.toInteger(params.MaximumBillingTravelFromHours) : null
            };

            if (isClone) {
                rateCardParams.ClonedRatecardId = params.Id;
            }

            rateCardsApi.postNewRatecard(rateCardParams).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateRatecard = function(params) {
            let deferred = $q.defer();

            let rateCardParams = {
                "Name": params.Name,
                "Allowances": params.SelectedAllowances,
                "Packages": params.SelectedPackages,
                "TimesheetAdjustments": params.SelectedTimesheet,
                "AverageEmployeeBreakHours": !_.isNil(params.AverageEmployeeBreakHours) ? params.AverageEmployeeBreakHours : false,
                "FormPackagesForShiftsWithSameTime": !_.isNil(params.FormPackagesForShiftsWithSameTime) ? params.FormPackagesForShiftsWithSameTime : false,
                "ChargeEmployeeBreaks": !_.isNil(params.ChargeEmployeeBreaks) ? params.ChargeEmployeeBreaks : false,
                "ChargeEquipmentBreaks": !_.isNil(params.ChargeEquipmentBreaks) ? params.ChargeEquipmentBreaks : false,
                "RoundAllHoursToNeareast15Minutes": !_.isNil(params.RoundAllHoursToNeareast15Minutes) ? params.RoundAllHoursToNeareast15Minutes : false,
                "InvoiceShiftsOnSeparateInvoice": !_.isNil(params.InvoiceShiftsOnSeparateInvoice) ? params.InvoiceShiftsOnSeparateInvoice : false,
                "TravelHoursDoNotCountTowardsShiftHours": !_.isNil(params.TravelHoursDoNotCountTowardsShiftHours) ? params.TravelHoursDoNotCountTowardsShiftHours : false,
                "MinimumBillingHours": !_.isNil(params.MinimumBillingHours) ? parseFloat(params.MinimumBillingHours) : null,
                "TrimJobStartByMinutes": !_.isNil(params.TrimJobStartByMinutes) ? _.toInteger(params.TrimJobStartByMinutes) : null,
                "TrimJobEndByMinutes": !_.isNil(params.TrimJobEndByMinutes) ? _.toInteger(params.TrimJobEndByMinutes) : null,
                "TravelType": params.TravelType,
                "MaximumBillingTravelTotalHours": !_.isNil(params.MaximumBillingTravelTotalHours) ? _.toNumber(params.MaximumBillingTravelTotalHours) : null,
                "MaximumBillingTravelToHours": !_.isNil(params.MaximumBillingTravelToHours) ? _.toNumber(params.MaximumBillingTravelToHours) : null,
                "MaximumBillingTravelFromHours": !_.isNil(params.MaximumBillingTravelFromHours) ? _.toNumber(params.MaximumBillingTravelFromHours) : null
            };

            rateCardsApi.putRatecard(params.Id, rateCardParams).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.archiveRatecard = function(ratecardId, isArchive) {
            let deferred = $q.defer();

            rateCardsApi.archiveRatecard(ratecardId, isArchive).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowanceTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowanceTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowanceHourlyMultipliers = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowanceHourlyMultipliers().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowanceDistanceMultipliers = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowanceDistanceMultipliers().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getConditionTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getConditionTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getConditionInputVariables = function() {
            let deferred = $q.defer();

            rateCardsApi.getConditionInputVariables().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getConditionCompareTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getConditionCompareTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getConditions = function() {
            let deferred = $q.defer();

            rateCardsApi.getConditions().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getAllowancesTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getAllowancesTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.createRatecardAllowance = function(params) {
            let deferred = $q.defer();

            rateCardsApi.postRatecardAllowance(params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getRatecardAllowance = function(allowanceId) {
            let deferred = $q.defer();

            rateCardsApi.getAllowance(allowanceId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateRatecardAllowance = function(allowanceId, params) {
            let deferred = $q.defer();

            rateCardsApi.putRatecardAllowance(allowanceId, params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.removeRatecardAllowance = function(allowanceId) {
            let deferred = $q.defer();

            rateCardsApi.deleteRatecardAllowance(allowanceId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTimesheetTypes = function() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetTypes().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getTimesheetConditions = function() {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetConditions().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.createRatecardTimesheet = function(params) {
            let deferred = $q.defer();

            rateCardsApi.postRatecardTimesheet(params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.removeRatecardTimesheet = function(timesheetId) {
            let deferred = $q.defer();

            rateCardsApi.deleteRatecardTimesheet(timesheetId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getRatecardTimesheet = function(timesheetId) {
            let deferred = $q.defer();

            rateCardsApi.getTimesheetAdjustment(timesheetId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateRatecardTimesheet = function(timesheetId, params) {
            let deferred = $q.defer();

            rateCardsApi.putRatecardTimesheet(timesheetId, params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getInvoiceGroups = function() {
            let deferred = $q.defer();

            rateCardsApi.getInvoiceGroups().then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.setAllPackageGroup = function(value) {
            self.service.packageGroups = value;
        };

        self.service.setPackageGroup = function(itemCount, value) {
            self.service.packageGroups[itemCount] = value;
        };

        self.service.getPackageGroup = function() {
            return self.service.packageGroups;
        };

        self.service.removeItem = function(groupCounter, itemCounter, subItemCounter) {
            self.service.packageGroups[groupCounter][itemCounter].PackageItems = _.remove(self.service.packageGroups[groupCounter][itemCounter].PackageItems, function(items, key) {
                return key !== subItemCounter;
            });

            if (_.isEmpty(self.service.packageGroups[groupCounter][itemCounter].PackageItems)) {
                self.service.removePackageGroup(groupCounter, itemCounter, true);
            }
        };

        self.service.createPackageTemplate = function(params) {
            let deferred = $q.defer();

            packagesApi.createPackageTemplate(params).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getRatecardPackage = function(packageId) {
            let deferred = $q.defer();

            packagesApi.getPackageTemplate(packageId).then(function(resp) {
                deferred.resolve({
                    data: resp.data
                });
            }).catch(function(ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.removeRateCardsPackage = function(packageId) {
            return rateCardsApi.deleteRateCardsPackage(packageId);
        };

        self.service.removePackageTemplate = function(packageId) {
            return packagesApi.deletePackageTemplate(packageId);
        };

        self.service.updatePackageTemplate = function(packageId, params) {
            return packagesApi.updatePackageTemplate(packageId, params);
        };

        self.service.updateRatecardsPackage = function(packageId) {
            return rateCardsApi.updateRatecardsPackage(packageId);
        };

        self.service.setLastRatecard = function(rateCardId) {
            self.service.lastRatecard = rateCardId;
        };

        self.service.removePackageGroup = function(groupCounter, itemCounter, fromRemoveItems) {
            if (!fromRemoveItems) {
                self.service.lastPackageGroupCounter = groupCounter;
            }

            if (!_.isNil(itemCounter)) {
                _.remove(self.service.packageGroups[groupCounter], function(items, key) {
                    return key === itemCounter;
                });
            } else {
                _.remove(self.service.packageGroups, function(items, key) {
                    return key === groupCounter;
                });
            }
        };

        return self.service;
    }
})();

(function() {
    'use strict';

    angular.module('app.rateCardSettings')
        .service('rateCardSettingsPackagesGridService', rateCardSettingsPackagesGridService);

    /** @ngInject */
    function rateCardSettingsPackagesGridService(
        exceptionService,
        rateCardSettingsPackagesListAdapterService
    ) {
        let service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        return service;

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(rateCardSettingsPackagesListAdapterService);
        }

        /**
         * Loading of partial data
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.rateCardSettings')
        .controller('RateCardSettingsPackagesController', RateCardSettingsPackagesController);

    function RateCardSettingsPackagesController(
        $scope,
        $compile,
        utils,
        blockUI,
        $mdDialog,
        searchDelay,
        hubService,
        exceptionService,
        rateCardSettingsPackagesGridService,
        rateCardSettingsService
    ) {
        let self = this;
        let tempCounter = 0;
        self.delay = {
            debounce: searchDelay
        };
        self.dataGrid = rateCardSettingsPackagesGridService;
        self.service = rateCardSettingsService;
        self.Title = "Manage Packages";
        self.formData = [];
        self.formData.packageGroups = [];
        self.isCreateRatecardPackageActive = false;
        self.isEditRatecardPackageActive = false;

        self.togglePackageCreate = function() {
            self.formData = [];
            self.formData.packageGroups = [];
            self.isCreateRatecardPackageActive = false;
            self.isEditRatecardPackageActive = false;
        };

        self.showCreateRateCardPackage = function(ratecardPackage) {
            blockUI.start();
            getInvoiceGroupsLookup();
            self.service.setAllPackageGroup([]);
            tempCounter = 0;

            if (!ratecardPackage) {
                self.isCreateRatecardPackageActive = true;
                blockUI.stop();
                return;
            }

            self.isCreateRatecardPackageActive = true;
            self.isEditRatecardPackageActive = true;
            self.service.getRatecardPackage(ratecardPackage.Id)
                .then(function(resp) {
                    self.formData = resp.data;
                    _.map(resp.data.PackageParentGroups, function(groups, key) {
                        self.service.setPackageGroup(key, groups.PackageGroups);
                    });

                    _.forEach(self.service.getPackageGroup(), function() {
                        self.addPackageGroupTemplate();
                    });

                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.addPackageGroupTemplate = function() {
            let divElement = angular.element(document.querySelector('#package-group-wrap'));

            let appendElement = "<add-package-group-component datacount='" + tempCounter + "'></add-package-group-component>";

            let appendHtml = $compile(appendElement)($scope);

            divElement.append(appendHtml);
            tempCounter++;
        };

        self.submitPackage = function() {
            $mdDialog.show(confirm).then(function() {
                self.service.archiveRatecard(self.currentRatecard.formData.Id, true)
                    .then(function() {
                        hubService.showToast(utils.translate('RATECARD_V2.MAIN_ARCHIVED_MESSAGE'));
                        self.dataGrid.grid.behavior.refresh();
                        self.toggleRatecardCreate(true);
                    }, function(err) {
                        exceptionService.resolve(err);
                    });
            }, function() {

            });
        };

        self.createPackage = function() {
            let params = buildRatecardPackageParams();

            let packageGroupsMsg = addPackageGroupIfGroupIsNotAdded(params);

            let confirm = $mdDialog.confirm()
                .title(utils.translate('RATECARD_V2.MAIN_PACKAGES_DIALOG_ADD_TITLE'))
                .htmlContent("<div>".concat(packageGroupsMsg, "</div><br/>", "<div>", utils.translate('RATECARD_V2.MAIN_PACKAGES_DIALOG_ADD_MSG'), "</div>"))
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                blockUI.start();

                params = buildRatecardPackageParams();

                self.service.createPackageTemplate(params)
                    .then(function(resp) {
                        self.togglePackageCreate();
                        hubService.showToast(utils.translate('RATECARD_V2.MAIN_PACKAGES_CREATE_MESSAGE'));
                        blockUI.stop();
                        self.dataGrid.grid.behavior.refresh();
                    }, function(err) {
                        exceptionService.resolve(err);
                        blockUI.stop();
                    });
            }, function() {

            });
        };

        self.updatePackage = function() {
            try {
                let params = buildRatecardPackageParams();
                let packageId = self.formData.Id;

                let packageGroupsMsg = addPackageGroupIfGroupIsNotAdded(params);

                $mdDialog.show({
                    controller: 'PackageDialogController as vm',
                    templateUrl: 'app/main/rateCardSettings/packages/dialogs/package-dialog.html',
                    locals: {
                        packageGroupsMsg: packageGroupsMsg
                    }
                }).then(async function(hasUserAccepted) {
                    blockUI.start();

                    params = buildRatecardPackageParams();

                    if (hasUserAccepted) {
                        var hasPackageTemplateUpdated = await updatePackageTemplate(packageId, params);

                        if(hasPackageTemplateUpdated) {
                            await updateRateCardsPackage(packageId);
                        }
                    } else {
                        await updatePackageTemplate(packageId, params);
                    }
                });
            }
            catch(err) {
                exceptionService.resolve(err);
                blockUI.stop();
            }
        };

        async function updatePackageTemplate(packageId, params) {
            var response = await self.service.updatePackageTemplate(packageId, params);

            self.togglePackageCreate();
            hubService.showToast(utils.translate('RATECARD_V2.MAIN_PACKAGES_UPDATE_MESSAGE'));
            blockUI.stop();
            self.dataGrid.grid.behavior.refresh();

            return response.data;
        };

        async function updateRateCardsPackage(id) {
            await self.service.updateRatecardsPackage(id);
        };

        self.removePackage = async function(packageId) {
            try {
                blockUI.start();

                var hasPackageTemplateRemoved = await removePackageTemplate(packageId);

                if(hasPackageTemplateRemoved) {
                    await removeRateCardsPackage(packageId);
                }
            }
            catch(err) {
                exceptionService.resolve(err);
                blockUI.stop();
            }
        };

        async function removeRateCardsPackage(packageId) {
            return await self.service.removeRateCardsPackage(packageId);
        };

        async function removePackageTemplate(packageId) {
            var response = await self.service.removePackageTemplate(packageId);

            hubService.showToast(utils.translate('RATECARD_V2.MAIN_PACKAGES_DELETE_MESSAGE'));
            self.dataGrid.grid.behavior.refresh();
            blockUI.stop();

            return response.data;
        };

        function getInvoiceGroupsLookup() {
            self.service.getInvoiceGroups()
                .then(function(resp) {
                    self.invoiceGroupsLookup = resp.data;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function buildRatecardPackageParams() {

            let formPackageGroup = self.service.getPackageGroup();

            let finalPackageGroups = _.map(formPackageGroup, function(group) {
                return {
                    "PackageGroups": group
                };
            });

            return {
                "PackageName": self.formData.PackageName,
                "PackageParentGroups": finalPackageGroups
            };
        }

        function addPackageGroupIfGroupIsNotAdded(params)
        {
            if(params.PackageParentGroups.length == 0)
            {
                self.addPackageGroupTemplate();
            }

            let packageGroupsMsg = (params.PackageParentGroups.length == 0) ? utils.translate('RATECARD_V2.MAIN_PACKAGES_DIALOG_ADD_EMPTY_GROUP_MSG') : "";

            return packageGroupsMsg;
        }

        $scope.$on("removePackageGroup", function() {
            tempCounter--;
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.rateCardSettings')
        .service('rateCardSettingsPackagesListAdapterService', rateCardSettingsPackagesListAdapterService);

    /** @ngInject */
    function rateCardSettingsPackagesListAdapterService(
        $q,
        a8WebApiNoChunkDataProvider,
        packagesApi
    ) {

        let service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData // inbound event (called by grid client)
        };

        let dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData() {
            return dbSource.fetch(function() {
                return getRatecardPackages();
            });
        }

        function getRatecardPackages() {
            let deferred = $q.defer();

            packagesApi.getPackageTemplates()
                .then(function(resp) {
                    deferred.resolve(resp);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.rateCardSettings')
        .service('rateCardSettingsAllowancesGridService', rateCardSettingsAllowancesGridService);

    /** @ngInject */
    function rateCardSettingsAllowancesGridService(
        exceptionService,
        rateCardSettingsAllowancesListAdapterService
    ) {
        let service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        return service;

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(rateCardSettingsAllowancesListAdapterService);
        }

        /**
         * Loading of partial data
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.rateCardSettings')
        .constant('inputVariables', {
            TotalShiftHours: 1,
            TravelToDistance: 3,
            TravelDuringDistance: 4,
            TravelFromDistance: 5,
            TravelToDuringFromDistance: 7
        })
        .constant('allowanceTypes', {
            PerHour: 1,
            PerShift: 4,
            PerTravelDistance: 5
        })
        .controller('RateCardSettingsAllowancesController', RateCardSettingsAllowancesController);

    function RateCardSettingsAllowancesController(
        $scope,
        $q,
        utils,
        blockUI,
        hubService,
        searchDelay,
        exceptionService,
        rateCardSettingsAllowancesGridService,
        rateCardSettingsService,
        allowanceTypes
    ) {
        let self = this;
        self.delay = {
            debounce: searchDelay
        };
        self.dataGrid = rateCardSettingsAllowancesGridService;
        self.service = rateCardSettingsService;
        self.Title = "Manage Allowances";
        self.allowanceMultipliersLookup = [];
        self.formData = [];
        $scope.conditionsArray = [];
        self.isCreateRatecardAllowanceActive = false;
        self.isEditRatecardAllowanceActive = false;

        self.toggleAllowanceCreate = function() {
            self.formData = [];
            $scope.conditionsArray = [];
            self.isCreateRatecardAllowanceActive = false;
            self.isEditRatecardAllowanceActive = false;
        };

        self.showCreateRateCardAllowance = function(allowance) {
            blockUI.start();

            let uris = [getAllowancesLookup(), getConditionsLookup()];
            $q.all(uris).then(function() {
                if (!allowance) {
                    self.isCreateRatecardAllowanceActive = true;
                    blockUI.stop();
                    return;
                }

                self.service.getRatecardAllowance(allowance.Id)
                    .then(function(resp) {
                        $scope.conditionsArray = resp.data.Conditions;
                        self.formData = resp.data;
                        self.onChangeAllowanceType(self.formData.RateCardAllowanceType);
                        self.isEditRatecardAllowanceActive = true;
                        self.isCreateRatecardAllowanceActive = true;
                        blockUI.stop();
                    }, function(err) {
                        exceptionService.resolve(err);
                        blockUI.stop();
                    });
            }).catch(function() {
                exceptionService.resolve(err);
                blockUI.stop();
            });
        };

        self.onChangeAllowanceType = function(allowanceTypeId) {
            self.allowanceMultipliersLookup = _.find(self.allowancesLookup, function(lookup) {
                return parseInt(lookup.Allowance.Id) === parseInt(allowanceTypeId)
            });
        };

        self.isVehicleOwnershipTypeRequired = function() {
            return self.isDistanceSelected();
        }

        self.isLookupEmpty = function(lookup) {
            return _.isEmpty(lookup) || _.isNil(lookup);
        };

        self.createAllowance = function() {
            blockUI.start();

            let params = buildRatecardAllowanceParams();

            self.service.createRatecardAllowance(params)
                .then(function(resp) {
                    blockUI.stop();
                    hubService.showToast(utils.translate('RATECARD_V2.MAIN_ALLOWANCES_CREATE_MESSAGE'));
                    self.dataGrid.grid.behavior.refresh();
                    self.toggleAllowanceCreate();
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.updateAllowance = function() {
            blockUI.start();

            let params = buildRatecardAllowanceParams();

            self.service.updateRatecardAllowance(self.formData.Id, params)
                .then(function(resp) {
                    blockUI.stop();
                    hubService.showToast(utils.translate('RATECARD_V2.MAIN_ALLOWANCES_UPDATE_MESSAGE'));
                    self.dataGrid.grid.behavior.refresh();
                    self.toggleAllowanceCreate();
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.removeAllowance = function(allowance) {
            blockUI.start();
            self.service.removeRatecardAllowance(allowance.Id)
                .then(function(resp) {
                    blockUI.stop();
                    hubService.showToast(utils.translate('RATECARD_V2.MAIN_ALLOWANCES_DELETE_MESSAGE'));
                    self.dataGrid.grid.behavior.refresh();
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        };

        self.isDistanceSelected = function() {
            return _.includes([allowanceTypes.PerTravelDistance], parseInt(self.formData.RateCardAllowanceType));
        };

        self.isHourlySelected = function() {
            return _.includes([allowanceTypes.PerHour], parseInt(self.formData.RateCardAllowanceType));
        };

        function buildRatecardAllowanceParams() {
            let updatedConditions = _.filter(_.values($scope.conditionsArray), function(cond) {
                return !_.isNil(cond.ConditionType);
            });
            $scope.conditionsArray = _.map(updatedConditions, function(condition) {
                return {
                    "ConditionName": condition.ConditionName,
                    "ConditionOrder": condition.ConditionOrder,
                    "ConditionType": parseInt(condition.ConditionType),
                    "InputVariable": parseInt(condition.InputVariable),
                    "ConditionOperator": parseInt(condition.ConditionOperator),
                    "ConditionDecimalCompareType": parseInt(condition.ConditionDecimalCompareType),
                    "ConditionDecimalValue": parseFloat(condition.ConditionDecimalValue),
                    "ConditionStringValues": _.isNil(condition.ConditionStringValues) ? [] : (!_.isNil(self.formData.Id) ? condition.ConditionStringValues : [condition.ConditionStringValues])
                };
            });

            return {
                "AllowanceName": self.formData.AllowanceName,
                "RateCardAllowanceType": self.formData.RateCardAllowanceType,
                "RateCardAllowanceHourlyMultiplierVariable": self.formData.RateCardAllowanceHourlyMultiplierVariable,
                "RateCardAllowanceDistanceMultiplierVariable": self.formData.RateCardAllowanceDistanceMultiplierVariable,
                "AppliesToFullTime": self.formData.AppliesToFullTime,
                "VehicleOwnershipType": self.formData.VehicleOwnershipType,
                "AppliesToCasual": self.formData.AppliesToCasual,
                "Conditions": $scope.conditionsArray
            };
        }

        function getConditionsLookup() {
            self.service.getConditions()
                .then(function(resp) {
                    self.allowanceConditionsLookup = resp.data;
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getAllowancesLookup() {
            self.service.getAllowancesTypes()
                .then(function(resp) {
                    self.allowancesLookup = resp.data;
                    self.onChangeAllowanceType(self.formData.RateCardAllowanceType);
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.rateCardSettings')
        .service('rateCardSettingsAllowancesListAdapterService', rateCardSettingsAllowancesListAdapterService);

    /** @ngInject */
    function rateCardSettingsAllowancesListAdapterService(
        $q,
        a8WebApiNoChunkDataProvider,
        rateCardsApi
    ) {

        let service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData // inbound event (called by grid client)
        };

        let dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData() {
            return dbSource.fetch(function() {
                return getRatecardAllowances();
            });
        }

        function getRatecardAllowances() {
            let deferred = $q.defer();

            rateCardsApi.getAllowancesAll()
                .then(function(resp) {
                    deferred.resolve(resp);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.projects.view', [])
        .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.projects_view', {
      url: '/project/view-project', 
      views: {
        'content@app': {
          templateUrl: 'app/main/projects/view/project-view.html', 
          controller: 'ProjectsViewController as vm'
        }
      }, 
      data: {
        requireLogin: true,
        validateAccess: ['adminClaimsService', function (adminClaimsService) {
          return adminClaimsService.hasManageProjectsMenu;
        }] 
      }, 
      title : 'Manage Projects', 
      titleBar : 'Alloc8 - Projects'
    });

    $translatePartialLoaderProvider.addPart('app/main/projects/view');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.projects.view')
    .controller('ProjectsViewController', ProjectsViewController);

  function ProjectsViewController(projectService,
                                  _,
                                  utils,
                                  $scope,
                                  searchDelay) {
    var vm = this;

    vm.dtOptions = {
      dom: 'rt<"bottom"lip><"clear">',
      pagingType: 'simple',
      autoWidth: false,
      searchDelay : searchDelay,
      responsive: true,
      sort: false,
      initComplete : function(){
        searchTable();
      }
    };

    $scope.$on('$destroy', function(){
        projectService.resetVars();
    });

    vm.projectService = projectService;
    vm.dtInstance = {};
    vm.searchQuery = null;
    vm.searchTable = searchTable;
    vm.activate = activate;
    vm.activate();

    function searchTable() {
      if(!_.isNil(vm.projectService.query)){
        setTimeout(function () {
          vm.dtInstance.DataTable.search(vm.projectService.query);
          vm.dtInstance.DataTable.search(vm.projectService.query).draw();
        }, searchDelay);
      }
    }

    function activate(){
      vm.projectService.isLoading = true;
      vm.projectService.isLoadingMessage = utils.translate('PROJECTS_VIEW.LOADING');
      vm.projectService.getProjects();
    }

  }
})();

(function() {
    'use strict';

    angular.module('app.projects')
        .factory('projectService', projectService);

    /** @ngInject */
    function projectService(
        projectApi,
        _,
        $state,
        utils,
        hubService,
        skillsMatrixApi,
        lookupApi,
        alasql,
        msgboxService,
        $q
    ) {
        var service = {
            projects: [],
            rateCards: [],
            branches: [],
            awards: [],
            clients: [],
            initialSkills: [],
            isLoading: false,
            isLoadingMessage: null,
            isEditMode: false,
            skills: [],
            model: null,
            query: null,
            getProjects: getProjects,
            addProject: addProject,
            editProject: editProject,
            initializeData: initializeData,
            getProjectById: getProjectById,
            save: save,
            viewProjects: viewProjects,
            reset: reset,
            getSkillsByBranch: getSkillsByBranch,
            initializeAll: initializeAll,
            checkBranches: checkBranches,
            verifySkills: verifySkills,
            resetVars: resetVars
        };

        return service;

        function reset() {
            service.model = {
                id: null,
                Name: null,
                Award: null,
                Branches: [],
                RateCard: [],
                Companies: [],
                ProjectSkills: [],
                IsArchived: false
            }
        }

        function resetVars() {
            service.projects = [];
            service.branches = [];
            service.awards = [];
            service.rateCards = [];
            service.clients = [];
            service.skills = [];
        }

        function verifySkills() {
            angular.forEach(service.model.ProjectSkills, function(skill, index) {
                let result = alasql('select * from ? where Name = ?', [service.skills, skill.Name]);
                if (result.length === 0) {
                    service.model.ProjectSkills.splice(index, 1);
                }
            });
        }

        function cleanBranches(branches) {
            let cleanedBranches = [];
            angular.forEach(branches, function(branch) {
                cleanedBranches.push({
                    Id: branch.Id,
                    Name: branch.Name
                })
            });
            return cleanedBranches;
        }

        function getProjectById(id) {
            return projectApi.getProjectById(id).then(function(resp) {
                service.model = angular.copy(resp.data);
            });
        }

        function getSkillsByBranch(branches) {
            branches = cleanBranches(branches);
            skillsMatrixApi.getSkillsByBranch(branches).then(function(resp) {
                service.skills = resp.data;
                service.verifySkills();
            })
        }

        function getProjects() {
            projectApi.getProjects().then(function(resp) {
                service.projects = formatData(resp.data);
                service.isLoading = false;
            });
        }

        function viewProjects() {
            $state.go('app.projects_view');
        }

        function initializeData() {
            service.isLoading = true;
            service.isLoadingMessage = utils.translate('PROJECTS_CREATE.LOADING');
            var uris = [lookupApi.getContactLookups(), projectApi.getProjects(), skillsMatrixApi.getSkillsandChildren()];

            $q.all(uris).then(function(resp) {
                service.projects = formatData(resp[1].data);
                service.branches = resp[0].data.Branches;
                service.awards = resp[0].data.Award;
                service.rateCards = resp[0].data.RateCards;
                service.clients = filterClients(resp[0].data.Companies);
                service.skills = resp[2].data;

                if (service.awards && !_.find(service.awards, {
                        Name: utils.translate('PROJECTS_CREATE.USE_DEFAULT_AWARD')
                    })) {
                    service.awards.unshift({
                        Id: null,
                        Name: utils.translate('PROJECTS_CREATE.USE_DEFAULT_AWARD')
                    });
                }
                if (service.rateCards && !_.find(service.rateCards, {
                        Name: utils.translate('PROJECTS_CREATE.USE_DEFAULT_RATE_CARD')
                    })) {
                    service.rateCards.unshift({
                        Id: null,
                        Name: utils.translate('PROJECTS_CREATE.USE_DEFAULT_RATE_CARD')
                    });
                }

                let branches2 = [];

                angular.forEach(service.branches, function(branch) {
                    let branchHolder = {
                        Id: branch.id,
                        Name: branch.Name
                    }

                    branches2.push(branchHolder);
                });

                service.branches = [];
                service.branches = alasql('select * from ? order by Name', [branches2]);
                service.isLoading = false;
            });
        }

        function initializeAll(id) {
            service.isLoading = true;
            service.isLoadingMessage = utils.translate('PROJECTS_CREATE.LOADING');
            var uris = [lookupApi.getContactLookups(), projectApi.getProjectById(id), skillsMatrixApi.getSkillsandChildren()];

            $q.all(uris).then(function(resp) {
                service.branches = resp[0].data.Branches;
                service.awards = resp[0].data.Award;
                service.rateCards = resp[0].data.RateCards;
                service.clients = filterClients(resp[0].data.Companies);
                service.model = resp[1].data;
                service.skills = resp[2].data;

                if (service.awards && !_.find(service.awards, {
                        Name: utils.translate('PROJECTS_CREATE.USE_DEFAULT_AWARD')
                    })) {
                    service.awards.unshift({
                        Id: null,
                        Name: utils.translate('PROJECTS_CREATE.USE_DEFAULT_AWARD')
                    });
                }
                if (service.rateCards && !_.find(service.rateCards, {
                        Name: utils.translate('PROJECTS_CREATE.USE_DEFAULT_RATE_CARD')
                    })) {
                    service.rateCards.unshift({
                        Id: null,
                        Name: utils.translate('PROJECTS_CREATE.USE_DEFAULT_RATE_CARD')
                    });
                }

                service.branches = service.branches.map(function(branch) {
                    return {
                        Id: branch.id,
                        Name: branch.Name
                    }
                });

                service.isLoading = false;
            });
        }

        function checkBranches() {
            angular.forEach(service.branches, function(branch) {
                branch['Selected'] = false;
            });

            angular.forEach(service.model.Branches, function(itm) {
                angular.forEach(service.branches, function(branch) {
                    if (branch.Name == itm.Name) {
                        branch['Selected'] = true;
                    }
                });
            });

            service.branches = alasql('select * from ? order by Selected desc, Name', [service.branches]);
        }

        function formatData(projects) {
            angular.forEach(projects, function(project) {
                project['BranchesArray'] = [];
                angular.forEach(project.Branches, function(branch) {
                    project['BranchesArray'].push(branch.Name);
                });
                project['FormattedBranches'] = project['BranchesArray'].join(", ");

                let companies = alasql("SELECT DISTINCT Name FROM ? ", [project.Companies]); //ORDER BY TicketNumber asc
                project['CompaniesFormattedHtml'] = buildULMarkup(companies);

            });
            return projects;
        }

        function buildULMarkup(list) {
            if (!!list && list.length <= 0)
                return;

            let markup;

            if (list.length > 1) {
                markup = '<ul class="list-none">';
                list.map(function(itm) {
                    for (var prop in itm) {
                        if (itm[prop] != null) {
                            markup += '<li>' + itm[prop] + '</li>';
                        }
                    }
                });

                markup += '</ul>';
            } else {
                for (var prop in list[0]) {
                    markup = list[0][prop];
                }
            }

            return markup;
        }

        function filterClients(companies) {
            var result = [];
            angular.forEach(companies, function(company) {
                angular.forEach(company.CompanyTypes, function(type) {
                    if (type.TypeName == "Client") {
                        result.push(company);
                    }
                });
            });
            return result;
        }

        function addProject() {
            service.isEditMode = false;
            $state.go('app.project_create');
        }

        function editProject(project) {
            service.isEditMode = true;
            $state.go('app.project_update', {
                id: project.id
            });
        }

        function save() {
            if (service.model.IsArchived) {
                msgboxService.yepNo(utils.translate('PROJECTS_CREATE.CONFIRM_ARCHIVING'), 'Archive confirmation')
                    .then(function() {
                        _save();
                    });
            } else {
                _save();
            }
        }

        function _save() {
            service.isLoading = true;
            if (service.isEditMode) {
                service.isLoadingMessage = utils.translate('PROJECTS_CREATE.SAVING');
                projectApi.putProject(service.model).then(function() {
                    hubService.showToast(utils.translate('PROJECTS_CREATE.SAVED'));
                    service.isLoading = false;
                }).catch(function() {
                    hubService.showToast(utils.translate('PROJECTS_CREATE.ERROR_SAVING'));
                    service.isLoading = false;
                });
            } else {
                service.isLoadingMessage = utils.translate('PROJECTS_CREATE.SAVING');
                projectApi.postProject(service.model).then(function() {
                    hubService.showToast(utils.translate('PROJECTS_CREATE.SAVED'));
                    service.isLoading = false;
                    $state.go('app.projects_view');
                }).catch(function() {
                    hubService.showToast(utils.translate('PROJECTS_CREATE.ERROR_SAVING'));
                    service.isLoading = false;
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.project.create')
        .controller('ProjectCreateController', ProjectCreateController);

    function ProjectCreateController(projectService,
        $scope,
        $stateParams,
        _,
        claimsUtilService,
        utils) {

        var vm = this;
        vm.utilService = utils;
        vm.claimsUtilService = claimsUtilService;
        vm.service = projectService;
        vm.readonly = false;
        vm.selectedItem = null;
        vm.searchText = null;

        $scope.$on('$destroy', function () {
            projectService.resetVars();
        });

        vm.querySearch = querySearch;
        vm.transformChip = transformChip;
        vm.activate = activate;

        function querySearch(query) {
            var results = alasql("SELECT * FROM ? WHERE Name LIKE '%" + query + "%' LIMIT 24", [vm.service.clients]);
            return results;
        }

        function transformChip(company) {
            if (angular.isObject(company)) {
                return company;
            }
            return {
                Name: company
            }
        }

        function activate() {
            let id = $stateParams.id;
            vm.service.reset();
            if (!_.isNil(id)) {
                vm.service.initializeAll(id);
                vm.service.isEditMode = true;
                vm.caption = utils.translate('PROJECTS_CREATE.HEADER_EDIT');
            } else {
                vm.service.initializeData();
                vm.service.isEditMode = false;
                vm.caption = utils.translate('PROJECTS_CREATE.HEADER_ADD');
            }
        }

        vm.activate();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.payroll-group', ['wj', 'ui.ace'])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {

        $stateProvider.state('app.payroll-group', {
            url: '/payroll-group',
            views: {
                'content@app': {
                    templateUrl: 'app/main/payrollGroups/payroll-group.html',
                    controller: 'PayrollGroupController as vm'
                },
                'content@dialogs': {
                    templateUrl: 'app/main/payrollGroups/dialogs/payroll-group-dialog.html',
                    controller: 'PayrollGroupsDialogController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManagePayrollGroupsPermission;
                }]
            },
            title: 'Manage Payroll Groups',
            titleBar: 'Alloc8 - Manage Payroll Groups'
        });

        $translatePartialLoaderProvider.addPart('app/main/payrollGroups');
    }
})();

(function () {
    'use strict';

    angular.module('app.payroll-group')
        .factory('payrollGroupService', payrollGroupService);

    /** @ngInject */
    function payrollGroupService($q,
        payrollGroupsApi,
        auditApi,
        historyLogService) {

        var service = {
            init: init,
            getPayrollGroupHistory: getPayrollGroupHistory,
            payrollGroups: []
        }

        return service;

        function init() {
            let deferred = $q.defer();

            payrollGroupsApi.getAll()
                .then(function (resp) {
                    service.payrollGroups = resp.data;
                    deferred.resolve();
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        };

        function getPayrollGroupHistory(id, name) {
            let deferred = $q.defer();

            auditApi.getAuditEntries(id).then(function(resp){
                historyLogService.showHistory("Payroll Group", resp.data, name, 'payroll-group-audit-log');
                deferred.resolve();
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.payroll-group')
        .controller('PayrollGroupsDialogController', PayrollGroupsDialogController);

    /** @ngInject */
    function PayrollGroupsDialogController(
        $q,
        utils,
        $mdDialog,
        locals,
        payrollGroupsApi,
        contactService) {

        var vm = this;

        vm.cancel = cancel;
        vm.save = save;
        vm.keyPressAlphaNumeric = keyPressAlphaNumeric;
        vm.pasteAlphaNumeric = pasteAlphaNumeric;

        vm.archive = archive;

        vm.isProcessing = false;

        vm.isUpdate = locals.payrollGroup ? true : false;

        activate();

        function activate() {
            if (vm.isUpdate) {
                vm.model = angular.copy(locals.payrollGroup);
            }
        }

        function cancel() {
            $mdDialog.hide();
        }

        function save() {
            vm.isProcessing = true;

            if (vm.isUpdate) {
                updatePayrollGroup();
                return;
            }

            createPayrollGroup();
        }

        function keyPressAlphaNumeric(event) {
            var inp = String.fromCharCode(event.keyCode);
            if (/[a-zA-Z0-9]/.test(inp)) {
                return true;
            }

            event.preventDefault();
            return false;
        }


        function pasteAlphaNumeric(event) {
            var regex = /^[a-zA-Z0-9\d ]+$/;
            var pastedData = event.originalEvent.clipboardData.getData('text/plain')
            if (!regex.test(pastedData)) {
                event.preventDefault();
                return false;
            }
        };

        function createPayrollGroup() {
            let deferred = $q.defer();

            payrollGroupsApi
                .add(vm.model)
                .then(function (resp) {
                    if (resp.data.Item2) {
                        vm.errorMessage = resp.data.Item2;
                        vm.isProcessing = false;
                        return;
                    } 
                    deferred.resolve();
                    $mdDialog.hide();
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function updatePayrollGroup() {
            let deferred = $q.defer();

            payrollGroupsApi
                .update(vm.model)
                .then(function (resp) {
                    $mdDialog.hide(resp);
                })
                .catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }
        
        function archive() {
            vm.isProcessing = true;
            contactService.getContactsByPayrollGroupId(vm.model.Id)
            .then(function (result){
                if(result && result.length > 0){
                    vm.errorMessage = "This Payroll Group is currently assigned to employee(s). Please unassign it before archiving.";
                    vm.isProcessing = false;
                    return;
                }

                let confirm = $mdDialog
                    .confirm()
                        .title(utils.translate('PAYROLL_GROUPS.ARCHIVE_TITLE'))
                        .textContent(utils.translate('PAYROLL_GROUPS.ARCHIVE_MESSAGE'))
                        .ok(utils.translate('PAYROLL_GROUPS.MAIN_ARCHIVE'))
                        .cancel(utils.translate('PAYROLL_GROUPS.MAIN_CANCEL'))
                        .multiple(true);

                $mdDialog.show(confirm).then(function(){
                    archivePayrollGroup();
                    $mdDialog.hide();
                });

            });
        }

        function archivePayrollGroup(){
            let deferred = $q.defer();

            payrollGroupsApi
                .archive(vm.model.Id)
                .then(function (resp) {
                    $mdDialog.hide(resp);
                    locals.self.service.init();
                })
                .catch(function (ex) {
                    if (ex.data.Message) {
                        let alert = $mdDialog
                            .alert()
                                .title(utils.translate('PAYROLL_GROUPS.ARCHIVE_TITLE_ERROR'))
                                .htmlContent(ex.data.Message)
                                .ok('Ok');
                        $mdDialog.show(alert);
                    }
                    deferred.reject(ex);
                });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.payroll-group')
        .controller('payrollGroupAuditLogController', payrollGroupAuditLogController);

    /** @ngInject */
    function payrollGroupAuditLogController() {
        var vm = this;
        var logData = JSON.parse(vm.data);

        vm.fieldLabel = Object.keys(logData)[0];
        vm.fieldValue = Object.values(logData)[0];
    }
})();

(function() {
    'use strict';
    angular.module('app.payroll-group')
        .directive('payrollGroupAuditLog', payrollGroupAuditLogComponent);

    /** @ngInject */
    function payrollGroupAuditLogComponent() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/payrollGroups/auditLog/payroll-group-audit-log.html',
            scope: {
              data: '='
            },
            controller: 'payrollGroupAuditLogController',
            controllerAs: 'vm',
            bindToController: true,
        };

        return directive;
    }
  })();

(function () {
    'use strict';

    angular.module('app.payroll-settings.manage')
        .factory('payrollSettingsService', payrollSettingsService);

    /** @ngInject */
    function payrollSettingsService(
        blockUI,
        utils,
        $q,
        hubService,
        payrollSettingsApi,
        _) {
        var self = this;
        var service = {
            initializePayrollSettings: initializePayrollSettings,
            getPayrollExportFields: getPayrollExportFields,
            getPayrollSettings: getPayrollSettings,
            updateExportFileHeading: updateExportFileHeading,
            updateExportFileExtension: updateExportFileExtension,
            updatePayrollTaxCodes: updatePayrollTaxCodes,
            updatePayrollExportFormat: updatePayrollExportFormat,
            updatePayrollCompensationCodes: updatePayrollCompensationCodes,
            updatePayrollExportCodes: updatePayrollExportCodes,
            updatePayrollSuperannuationCodes: updatePayrollSuperannuationCodes,
            addPayrollTaxRate: addPayrollTaxRate,
            addPayrollCompensationRate: addPayrollCompensationRate,
            addPayrollSuperannuationRate: addPayrollSuperannuationRate,
            updatePayrollTaxRates: updatePayrollTaxRates,
            updatePayrollCompensationRates: updatePayrollCompensationRates,
            updatePayrollSuperannuationRates: updatePayrollSuperannuationRates,
            removeTaxRate: removeTaxRate,
            removeCompensationRate: removeCompensationRate,
            removeSuperannuationRate: removeSuperannuationRate,
            removeTimesheetHeadingDetails: removeTimesheetHeadingDetails,
            addTimesheetDetails: addTimesheetDetails,
            updateTimesheetDetails: updateTimesheetDetails,
            downloadAwardCodesAndRates: downloadAwardCodesAndRates
        };

        function initializePayrollSettings() {
            var deferred = $q.defer();
            self.payrollSettings = [];
            payrollSettingsApi.getAll().then(function (resp) {
                self.payrollSettings = !_.isNil(resp.data) ? resp.data : [];
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function getPayrollExportFields() {
            var deferred = $q.defer();

            payrollSettingsApi.getExportFields().then(function (resp) {
                self.payrollSettings.ExportFields = resp.data;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updateExportFileHeading(params) {
            var deferred = $q.defer();
            payrollSettingsApi.updatePayrollSettingsExportFileHeading(params).then(function (resp) {
                self.payrollSettings.ExportHeader = params.fileHeading;
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_EXPORT_FILE_HEADING_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updateExportFileExtension(params) {
            var deferred = $q.defer();
            payrollSettingsApi.updatePayrollSettingsExportFileExtension(params).then(function (resp) {
                self.payrollSettings.ExportFileExtension = params.fileExtension;
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_EXPORT_FILE_EXT_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updatePayrollExportFormat(params) {
            var deferred = $q.defer();
            payrollSettingsApi.updatePayrollSettingsExportFormat(params).then(function (resp) {
                self.payrollSettings.ExportFormat = params.ExportFormat;
                self.payrollSettings.ConditionalScript = params.ConditionalScript;
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_EXPORT_FORMAT_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updatePayrollTaxCodes(params) {
            var deferred = $q.defer();
            payrollSettingsApi.updatePayrollSettingsTaxCodes(params).then(function (resp) {
                self.payrollSettings.PayrollTaxCodes = params.taxCodes;
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_CODES_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updatePayrollCompensationCodes(params) {
            var deferred = $q.defer();
            payrollSettingsApi.updatePayrollSettingsCompensationCodes(params).then(function (resp) {
                self.payrollSettings.WorkerCompensationCodes = params.workerCompensationCodes;
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_CODES_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updatePayrollSuperannuationCodes(params) {
            var deferred = $q.defer();
            payrollSettingsApi.updatePayrollSettingsSuperannuationCodes(params).then(function (resp) {
                self.payrollSettings.SuperannuationCodes = params.superannuationCodes;
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_CODES_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updatePayrollExportCodes(params) {
            var deferred = $q.defer();
            payrollSettingsApi.updatePayrollSettingsExportCodes(params).then(function (resp) {
                self.payrollSettings.PayrollExportCodes = params.payrollExportCodes;
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_EXPORT_CODES_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function addPayrollTaxRate(year, rate, params) {
            var deferred = $q.defer();
            payrollSettingsApi.addPayrollSettingsTaxRates(year, rate, params).then(function (resp) {
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_RATE_SAVED'));
                self.payrollSettings.BranchPayrollTaxRates = resp.data;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function addPayrollCompensationRate(year, rate, params) {
            var deferred = $q.defer();
            payrollSettingsApi.addPayrollSettingsCompensationRates(year, rate, params).then(function (resp) {
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE_SAVED'));
                self.payrollSettings.BranchWorkerCompensationRates = resp.data;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function addPayrollSuperannuationRate(year, rate, params) {
            var deferred = $q.defer();
            payrollSettingsApi.addPayrollSettingsSuperannuationRates(year, rate, params).then(function (resp) {
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE_SAVED'));
                self.payrollSettings.BranchSuperannuationRates = resp.data;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updatePayrollTaxRates(params, index) {
            var deferred = $q.defer();
            var branchId = params.BranchId;
            _.unset(params, 'BranchId');
            payrollSettingsApi.updatePayrollSettingsTaxRates(branchId, params).then(function (resp) {
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_RATE_SAVED'));
                self.payrollSettings.BranchPayrollTaxRates[index].TaxRate = params.Rate;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updatePayrollCompensationRates(params, index) {
            let deferred = $q.defer();
            let branchId = params.BranchId;
            _.unset(params, 'BranchId');
            payrollSettingsApi.updatePayrollSettingsCompensationRates(branchId, params).then(function (resp) {
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE_SAVED'));
                self.payrollSettings.BranchWorkerCompensationRates[index].CompensationRate = params.Rate;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updatePayrollSuperannuationRates(params, index) {
            let deferred = $q.defer();
            let branchId = params.BranchId;
            _.unset(params, 'BranchId');
            payrollSettingsApi.updatePayrollSettingsSuperannuationRates(branchId, params).then(function (resp) {
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE_SAVED'));
                self.payrollSettings.BranchSuperannuationRates[index].SuperannuationRate = params.Rate;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function removeTaxRate(params) {
            let deferred = $q.defer();
            payrollSettingsApi.deletePayrollSettingsTaxRate(params).then(function (resp) {
                _.remove(self.payrollSettings.BranchPayrollTaxRates, function(settings) {
                    return settings.BranchId == params.BranchId && settings.Year == params.Year;
                });
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_RATE_DELETED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function removeCompensationRate(params) {
            let deferred = $q.defer();
            payrollSettingsApi.deletePayrollSettingsCompensationRate(params).then(function (resp) {
                _.remove(self.payrollSettings.BranchWorkerCompensationRates, function(settings) {
                    return settings.BranchId == params.BranchId && settings.Year == params.Year;
                });
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE_DELETED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function removeSuperannuationRate(params) {
            let deferred = $q.defer();
            payrollSettingsApi.deletePayrollSettingsSuperannuationRate(params).then(function (resp) {
                _.remove(self.payrollSettings.BranchSuperannuationRates, function(settings) {
                    return settings.BranchId == params.BranchId && settings.Year == params.Year;
                });
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE_DELETED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function removeTimesheetHeadingDetails(params) {
            let deferred = $q.defer();
            payrollSettingsApi.deletePayrollSettingsTimesheetDetails(params).then(function (resp) {
                _.remove(self.payrollSettings.TimesheetHeadersAndCodes, function(settings) {
                    return settings.Name == params.Name;
                });
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TIMESHEET_HEADINGS_DELETED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function addTimesheetDetails(params) {
            var deferred = $q.defer();
            payrollSettingsApi.addPayrollSettingsTimesheetDetails(params).then(function (resp) {
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TIMESHEET_HEADINGS_SAVED'));
                self.payrollSettings.TimesheetHeadersAndCodes = _.concat(self.payrollSettings.TimesheetHeadersAndCodes, resp.data);
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updateTimesheetDetails(headingName, params, index) {
            var deferred = $q.defer();
            payrollSettingsApi.updatePayrollSettingsTimesheetDetails(headingName, params).then(function (resp) {
                hubService.showToast(utils.translate('PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TIMESHEET_HEADINGS_SAVED'));
                self.payrollSettings.TimesheetHeadersAndCodes[index].HeaderCodes = params.HeaderCodes;
                self.payrollSettings.TimesheetHeadersAndCodes[index].DisplayOrder = params.DisplayOrder;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function downloadAwardCodesAndRates(headingName, params, index) {
            var deferred = $q.defer();
            payrollSettingsApi.downloadPayrollSettingsAwardCodesAndRates().then(function (resp) {
                deferred.resolve(resp);
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function getPayrollSettings() {
            return self.payrollSettings;
        }

        return service;

    }
})();

/**
 * Created by queeniejgm on 04/06/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.payroll-settings.manage')
        .controller('PayrollSettingsController', PayrollSettingsController);

    /** @ngInject */
    function PayrollSettingsController ( $scope,
                                         utils,
                                         blockUI,
                                         exceptionService,
                                         payrollSettingsService,
                                         payrollSettingsFactory) {

        var self = this;
        self.service = payrollSettingsService;
        self.Title = "Manage Payroll Settings";
        self.utilService = utils;
        self.showSuccessDialog = false;

        self.launchTaxRateByBranch = launchTaxRateByBranch;
        self.removeTaxRateByBranch = removeTaxRateByBranch;
        self.launchCompensationRateByBranch = launchCompensationRateByBranch;
        self.removeCompensationRateByBranch = removeCompensationRateByBranch;
        self.launchSuperannuationRateByBranch = launchSuperannuationRateByBranch;
        self.removeSuperannuationRateByBranch = removeSuperannuationRateByBranch;
        self.launchSuperannuationRatesByBranch = launchSuperannuationRatesByBranch;
        self.closeSuccessDialog = closeSuccessDialog;
        self.addExportFormatField = addExportFormatField;
        self.editExportFormat = editExportFormat;
        self.editExportFileHeading = editExportFileHeading;

        self.editExportFileExtension = editExportFileExtension;
        self.editPayrollTaxCodes = editPayrollTaxCodes;
        self.editPayrollCompensationCodes = editPayrollCompensationCodes;
        self.editPayrollSuperannuationCodes = editPayrollSuperannuationCodes;
        self.getNumRows = getNumRows;
        self.initializedFlexsheet = initializedFlexsheet;
        self.editPayrollExportCodes = editPayrollExportCodes;
        self.downloadAwardCodes = downloadAwardCodes;
        self.flexSheet = null;

        initialize();

        function launchTaxRateByBranch(branch, index) {
            payrollSettingsFactory.addTaxRates(branch, index);
        }

        function removeTaxRateByBranch(branch) {
            blockUI.start();
            self.service.removeTaxRate(branch)
            .then(function(){
                getPayrollSettings();
                self.showSuccessDialog = true;
                blockUI.stop();
            }, function(err){
                exceptionService.resolve(err);
                blockUI.stop();
            });
        }

        function launchCompensationRateByBranch(branch, index) {
            payrollSettingsFactory.addCompensationRates(branch, index);
        }

        function launchSuperannuationRateByBranch(branch, index) {
            payrollSettingsFactory.addSuperannuationRates(branch, index);
        }

        function removeCompensationRateByBranch(branch) {
            blockUI.start();
            self.service.removeCompensationRate(branch)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err) {
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function removeSuperannuationRateByBranch(branch) {
            blockUI.start();
            self.service.removeSuperannuationRate(branch)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function launchSuperannuationRatesByBranch(branch) {
            payrollSettingsFactory.addSuperannuationRates(branch);
        }

        function editExportFileHeading() {
            blockUI.start();
            let params = { fileHeading: self.payrollSettings.ExportHeader };
            self.service.updateExportFileHeading(params)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function editExportFileExtension() {
            blockUI.start();
            let params = { fileExtension: self.payrollSettings.ExportFileExtension };
            self.service.updateExportFileExtension(params)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function editPayrollTaxCodes() {
            blockUI.start();
            let params = { taxCodes: _.split(self.payrollSettings.PayrollTaxCodesHolder, "\n") };
            self.service.updatePayrollTaxCodes(params)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });

        }

        function editExportFormat() {
            blockUI.start();
            let params = { ExportFormat: self.payrollSettings.ExportFormat, ConditionalScript: self.payrollSettings.ConditionalScript };
            self.service.updatePayrollExportFormat(params)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });

        }

        function editPayrollCompensationCodes() {
            blockUI.start();
            let params = { workerCompensationCodes: _.split(self.payrollSettings.PayrollCompensationCodesHolder, "\n") };
            self.service.updatePayrollCompensationCodes(params)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function editPayrollSuperannuationCodes() {
            blockUI.start();
            let params = { superannuationCodes: _.split(self.payrollSettings.PayrollSuperannuationCodesHolder, "\n") };
            self.service.updatePayrollSuperannuationCodes(params)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                },function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });

        }

        function getPayrollSettings() {
            self.payrollSettings = self.service.getPayrollSettings();
            self.payrollSettings.PayrollTaxCodesHolder = _.join(self.payrollSettings.PayrollTaxCodes, "\n");
            self.payrollSettings.PayrollCompensationCodesHolder = _.join(self.payrollSettings.WorkerCompensationCodes, "\n");
            self.payrollSettings.PayrollSuperannuationCodesHolder = _.join(self.payrollSettings.SuperannuationCodes, "\n");
            self.payrollCodes = new wijmo.collections.CollectionView(self.payrollSettings.PayrollExportCodes);
        }

        function getNumRows() {
            return !_.isNil(self.payrollSettings) ? _.size(self.payrollSettings.PayrollExportCodes) : 0;
        }

        function initialize() {
            blockUI.start();
            self.service.initializePayrollSettings()
                .then(function(response){
                    $scope.sheets = [{ name: "Sheet1"}];
                    getPayrollSettings();
                    setExportFields();
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function setExportFields() {
            self.service.getPayrollExportFields()
                .then(function(response){
                    self.payrollSettings.ExportFields = response.data;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function closeSuccessDialog() {
            self.showSuccessDialog = false;
        }

        function addExportFormatField(field) {
            let position = _.first(angular.element("#ExportFormat")).selectionStart;
            let str = self.payrollSettings.ExportFormat;
            field = "{"+ field +"}";

            if (_.isNil(str)) {
                self.payrollSettings.ExportFormat = field;
            } else {
                self.payrollSettings.ExportFormat = str.substr(0, position) + field + str.substr(position);
            }
        }

        function initializedFlexsheet(s) {
            self.flexSheet = s;
            self.flexSheet.allowAddNew = true;
            self.flexSheet.allowScroll = false;
            self.flexSheet.autoScroll = false;
            self.flexSheet.allowResizing = 0;
            self.flexSheet.allowDragging = 0;
            self.flexSheet.isTabHolderVisible = false;
            self.flexSheet.filter.defaultFilterType = 0;
            self.flexSheet.headersVisibility = 2;
            self.flexSheet.frozenRows = 1;
            self.flexSheet.hostElement.addEventListener('contextmenu',function(e){
                e.preventDefault();
            },true);
            self.flexSheet.loadedRows.addHandler(function (s, e) {
                self.flexSheet.frozenRows = 1;
            });
        }

        function editPayrollExportCodes() {
            blockUI.start();
            let params = { payrollExportCodes: self.flexSheet.sheets[0].itemsSource.items };
            self.service.updatePayrollExportCodes(params)
                .then(function(){
                    getPayrollSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function downloadAwardCodes() {
            blockUI.start();
            self.service.downloadAwardCodesAndRates()
                .then(function(resp){
                    blockUI.stop();

                    let blob = new Blob([resp.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                    let blobURL = URL.createObjectURL(blob);

                    let anchor = angular.element('<a/>');
                    anchor.attr({
                        href: blobURL,
                        target: '_blank',
                        download:  resp.headers('Filename')
                    })[0].click();


                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.payroll-settings.manage')

        .factory('payrollSettingsFactory', function ($mdDialog, lookupApi) {
            return {
                addTaxRates: function (branch, index) {
                    if (!_.isNil(branch) || !_.isEmpty(branch)) {
                        launchModal(branch, true);
                    } else {
                        lookupApi.getMinifiedBranches().then(function(resp){
                            launchModal(resp);
                        });
                    }

                    function launchModal(resp, isEdit) {
                        let params = isEdit ? { formData : resp,  rateIndex: index } : { branches : resp.data };
                        $mdDialog.show({
                            parent: angular.element(document.body)
                            , templateUrl: 'app/main/payrollSettings/directives/addTaxRates/add-tax-rates.html'
                            , locals: {
                                variables: params
                            }
                            , controller: 'PayrollSettingsAddTaxRateController as vm'
                        });
                    }
                },
                addCompensationRates: function (branch, index) {
                    if (!_.isNil(branch) || !_.isEmpty(branch)) {
                            launchModal(branch, true);
                    } else {
                        lookupApi.getMinifiedBranches().then(function(resp){
                            launchModal(resp);
                        });
                    }

                    function launchModal(resp, isEdit) {
                        let params = isEdit ? { formData : resp,  rateIndex: index } : { branches : resp.data };
                        $mdDialog.show({
                            parent: angular.element(document.body)
                            , templateUrl: 'app/main/payrollSettings/directives/addCompensationRates/add-compensation-rates.html'
                            , locals: {
                                variables: params
                            }
                            , controller: 'PayrollSettingsAddCompensationRateController as vm'
                        });
                    }
                },
                addSuperannuationRates: function (branch, index) {
                    if (!_.isNil(branch) || !_.isEmpty(branch)) {
                        launchModal(branch, true);
                    } else {
                        lookupApi.getMinifiedBranches().then(function(resp){
                            launchModal(resp);
                        });
                    }

                    function launchModal(resp, isEdit) {
                        let params = isEdit ? { formData : resp,  rateIndex: index } : { branches : resp.data };
                        $mdDialog.show({
                            parent: angular.element(document.body)
                            , templateUrl: 'app/main/payrollSettings/directives/addSuperannuationRates/add-superannuation-rates.html'
                            , locals: {
                                variables: params
                            }
                            , controller: 'PayrollSettingsAddSuperannuationRateController as vm'
                        });
                    }
                },
                addTimesheetHeadings: function (timesheet, index) {
                    if (!_.isNil(timesheet) || !_.isEmpty(timesheet)) {
                        launchModal(timesheet, true);
                    } else {
                        launchModal(timesheet);
                    }

                    function launchModal(resp, isEdit) {
                        let params = isEdit ? { formData : resp,  rateIndex: index } : {};
                        $mdDialog.show({
                            parent: angular.element(document.body)
                            , templateUrl: 'app/main/payrollSettings/directives/addTimesheetHeadings/add-timesheet-headings.html'
                            , locals: {
                                variables: params
                            }
                            , controller: 'PayrollSettingsAddTimesheetHeadingsController as vm'
                        });
                    }
                }
            }
        });
})();

(function() {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .service('filterModel', filterModel)

    function filterModel(_) {
        return function() {

            var defaults = {
                ReportTypes: [],
                StartDate: null,
                EndDate: null,
                BranchIds: [],
                Clients: [],
                IncludeExportedTickets: false
            };

            angular.extend(this, defaults);

            this.transformToServerModel = transformToServerModel;

            function transformToServerModel() {
                return {
                    StartDate: copy(setDate(this.StartDate)),
                    EndDate: copy(setDate(this.EndDate)),
                    BranchIds: copy(setBranches(this.BranchIds)),
                    ClientIds: copy(this.Clients.map(c => c.Id)),
                    ExceptionReportTypes: copy(this.ReportTypes.map(setReportTypes)),
                    IncludeExportedTickets: copy(this.IncludeExportedTickets)
                }
            }

            function setReportTypes(type) {
                return type.Id;
            }

            function setBranches(branch_list) {
                let branches = collectBranches(_.filter(branch_list, function(branch) {
                    return !_.isNil(branch.State)
                }));
                let states = collectBranchesFromStates(_.filter(branch_list, {
                    State: null
                }));
                return _.union(branches, states)
            }

            function collectBranches(branches) {
                return _.map(branches, function(branch) {
                    return branch.Id;
                })
            }

            function collectBranchesFromStates(states) {
                let collection = [];
                _.forEach(states, function(state) {
                    let branches = state.Id.split(",");
                    _.forEach(branches, function(branch) {
                        collection.push(branch);
                    });
                });
                return collection;
            }

            function copy(data) {
                return angular.copy(data);
            }

            function setDate(date) {
                //Return YYYY-MM-DD (2018-05-25)
                return moment(date).format("YYYY-MM-DD")
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.paperwork.exceptions')
        .controller('paperWorkDialogController', paperWorkDialogController);

    function paperWorkDialogController($mdDialog, $scope, mediaQueryService, locals, utils) {
        var vm = this;
        vm.media = mediaQueryService;
        vm.filterModel = null;
        vm.branches = [];
        vm.report_types = [];
        vm.clients = [];

        vm.onCancel = onCancel;
        vm.activate = activate;
        vm.limit = limit;
        vm.sendParams = sendParams;

        function onCancel(){
            $mdDialog.hide();
        }

        function activate(){
            vm.filterModel = locals.model;
            vm.branches = locals.branches;
            vm.report_types = locals.report_types;
            vm.clients = locals.clients;
        }

        function limit(arr, title) {
            return (_.isNil(arr) || arr.length === 0) ? utils.translate(title) : limitDisplay(arr);
        }

        function limitDisplay(arr) {
            arr = flatToNamesOnly(arr);
            return arr.length > 3 ? (arr.slice(0, 3).join(", ")) + " + " + (arr.length - 3) + " " + utils.translate("MESSAGING.MORE") : arr.join(", ");
        }

        function flatToNamesOnly(arr) {
            return _.map(arr, function (itm) {
                return itm.Name || itm.Value;
            });
        }

        function sendParams(){
            $mdDialog.hide(vm.filterModel);
        }

        $scope.$watch('vm.media.showFilter()', function(){
            let show = vm.media.showFilter();
            if(!show){
                vm.onCancel();
            }
        });

        vm.activate();
    }
})();

(function () {
  'use strict';

  angular
    .module('app.payroll.update-payroll-contacts', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.update_payroll_contacts', {
      url: '/payroll/update-payroll-contacts', 
      views: {
        'content@app': {
          templateUrl: 'app/main/payroll/update-payroll-contacts/update-payroll-contacts.html',
          controller: 'UpdatePayrollContactsController as vm'
        }
      }, 
      data: {
        requireLogin: true,
        validateAccess: ['payrollClaimsService', function (payrollClaimsService) {
          return payrollClaimsService.hasUpdatePayrollContactsAccess;
        }]
      }, 
      title: 'Update Payroll Contacts', 
      titleBar: 'Alloc8 - Update Payroll Contacts'
    });

    $translatePartialLoaderProvider.addPart('app/main/payroll/update-payroll-contacts')
  }
})();

(function() {
    'use strict';

    angular.module('app.payroll.update-payroll-contacts')
        .factory('updatePayrollContactsService', updatePayrollContactsService);

    /** @ngInject */
    function updatePayrollContactsService(contactApi) {
        var service = {
            updateContactProviderEmployees: updateContactProviderEmployees
        };

        return service;

        function updateContactProviderEmployees(contacts) {
            return contactApi.updateContactProviderEmployees(contacts);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.update-payroll-contacts')
        .controller('UpdatePayrollContactsController', UpdatePayrollContactsController);

    /** @ngInject */
    function UpdatePayrollContactsController(
        claimsUtilService,
        adminClaimsService,
        integrationsService,
        exceptionService,
        myobService,
        xeroService,
        $rootScope,
        updatePayrollContactsService,
        blockUI,
        notificationService,
        contactViewService,
        DTColumnDefBuilder) {

        var vm = this;

        vm.claimsUtilService = claimsUtilService;
        vm.adminClaimsService = adminClaimsService;
        vm.contactViewService = contactViewService;

        vm.searchEmployeeByName = searchEmployeeByName;
        vm.formatEmployeeName = formatEmployeeName;
        vm.redirectToIntegrationsPage = redirectToIntegrationsPage;
        vm.redirectToBusinessesPage = redirectToBusinessesPage;
        vm.autoMatch = autoMatch;
        vm.save = save;

        vm.isMyobEmployeeDisabled = true;
        vm.isXeroEmployeeDisabled = true;

        vm.isMyobEnabled = claimsUtilService.isMyobEnabled();
        vm.isXeroEnabled = claimsUtilService.isXeroEnabled();
        vm.isIntegrationsEnabled = vm.isMyobEnabled || vm.isXeroEnabled;

        vm.dtInstance = {};
        vm.dtInstance.DataTable = null;

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(7).notSortable(), // Employee
        ];

        vm.dtOptions = {
            order: [0, "asc"],
            paging: true,
            searching: false,
            lengthChange: true,
            displayLength: 10,
            dom: 'tlip'
        }

        vm.contacts = [];

        activate();

        function activate() {
            vm.contactViewService.getEmployees().then(function(data) {
                vm.contacts = data.data;
            });

            if (vm.isIntegrationsEnabled && vm.adminClaimsService.hasRunPayrollPermission) {
                integrationsService.getProviders()
                    .then(resp => {
                        vm.isConnectedToMyob = resp.isConnectedToMyob;
                        vm.isConnectedToXero = resp.isConnectedToXero;

                        if(vm.isConnectedToMyob || vm.isConnectedToXero){
                            populateMyobEmployeesDropdown();
                            populateXeroEmployeesDropdown();
                        }
                    }).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }
        }

        function autoMatch() {
            if (vm.isConnectedToMyob) {
                vm.contacts.forEach(contact => {
                    let matchingMyobEmployee = vm.myobEmployees.find(myobEmp => {
                        let matchingFirstName = (myobEmp.EmployeeFirstName.toLowerCase() === contact.FirstName.toLowerCase());
                        let matchingLastName = (myobEmp.EmployeeLastName.toLowerCase() === contact.LastName.toLowerCase());
                        return (matchingFirstName && matchingLastName);
                    });

                    if (matchingMyobEmployee) {
                        contact.MyobEmployee = matchingMyobEmployee;
                    }
                });
            }

            if (vm.isConnectedToXero) {
                vm.contacts.forEach(contact => {
                    let matchingXeroEmployee = vm.xeroEmployees.find(xeroEmp => {
                        let matchingFirstName = (xeroEmp.EmployeeFirstName.toLowerCase() === contact.FirstName.toLowerCase());
                        let matchingLastName = (xeroEmp.EmployeeLastName.toLowerCase() === contact.LastName.toLowerCase());
                        return (matchingFirstName && matchingLastName);
                    });

                    if (matchingXeroEmployee) {
                        contact.XeroEmployee = matchingXeroEmployee;
                    }
                });
            }
        }

        function save() {
            blockUI.start({
                message: 'Saving Contacts...'
            });

            updatePayrollContactsService.updateContactProviderEmployees(vm.contacts)
                .then(resp => {
                    blockUI.stop();

                    notificationService.showToast('Contacts saved.');
                });
        }

        function searchEmployeeByName(query, employees) {
            if (!query) return employees;

            query = query.toLowerCase();
            let filteredEmployees = employees.filter(e => e.EmployeeFirstName.toLowerCase().includes(query.toLowerCase()) ||
                e.EmployeeLastName.toLowerCase().includes(query.toLowerCase()));
            return filteredEmployees;
        }

        function populateMyobEmployeesDropdown() {
            if (!vm.isConnectedToMyob) return;

            myobService.getMyobEmployees()
                .then(resp => {
                    vm.myobEmployees = resp.data;

                    vm.isMyobEmployeeDisabled = false;
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function populateXeroEmployeesDropdown() {
            if (!vm.isConnectedToXero) return;

            xeroService.getXeroEmployees()
                .then(resp => {
                    vm.xeroEmployees = resp.data;

                    vm.isXeroEmployeeDisabled = false;
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function formatEmployeeName(employee) {
            if (!employee) return;

            let employeeName = `${employee.EmployeeFirstName} ${employee.EmployeeLastName}`;

            if (employee.ProviderType === 'Myob') {
                employeeName += ` (${employee.EmployeeDisplayId})`;
            }

            return employeeName;
        }

        function redirectToIntegrationsPage() {
            $rootScope.state.go('app.integrations');
        }

        function redirectToBusinessesPage() {
            $rootScope.state.go('app.businesses');
        }
    }
})();



(function () {
  'use strict';

  angular
    .module('app.payroll.timesheet', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.payroll_timesheet', {
      url: '/payroll/timesheets'
      , views: {
        'content@app': {
          templateUrl: 'app/main/payroll/timesheet/payroll-timesheet.html',
          controller: 'PayrollTimesheetController as vm'
        }
      }
      , data: {
        requireLogin: true
      }
      , title: 'Timesheets'
      , titleBar: 'Alloc8 - Timesheets'
    });

    $translatePartialLoaderProvider.addPart('app/main/payroll/timesheet')
  }
})();

(function() {
    'use strict';

    angular.module('app.payroll.timesheet')
        .factory('payrollTimesheetService', payrollTimesheetService);

    /** @ngInject */
    function payrollTimesheetService(
        branchApi,
        contactApi,
        $http,
        $rootScope,
        utils,
        tenantSettings,
        hubService,
        signalRService,
        $window
    ) {
        var service = {
            loading: false,
            loadingMessage: null,
            branches: [],
            divisions: [],
            employees: [],
            model: defaultModel(),
            selectedItem: null,
            searchText: null,
            loadBranches: loadBranches,
            changeBranch: changeBranch,
            generatePDF: generatePDF,
            reset: reset,
            querySearch: querySearch,
            selectedItemChange: selectedItemChange,
            registerSignalRCallback: registerSignalRCallback
        };

        var isInitialized = false;

        function registerSignalRCallback() {
            if (signalRService.isConnected) {
                timesheetSummaryCallback();
                return;
            }

            $rootScope.$on('signalR_OnConnected', function() {
                if (!isInitialized) {
                    timesheetSummaryCallback();
                    isInitialized = true;
                }
            });
        }

        function timesheetSummaryCallback() {
            signalRService.messageHub.on('timesheetSummaryCallback', function(resp) {

                const fileUri = resp;
                if (!fileUri) {
                    service.loading = false;
                    hubService.showToast(utils.translate('PAYROLL_TIMESHEETS.NO_DATA_FOUND'));
                }

                $window.open(fileUri, '_blank');
                service.loading = false;
                service.reset();
                hubService.showToast(utils.translate('PAYROLL_TIMESHEETS.EXPORT_SUCCESS'));
            });
        }

        function querySearch(query) {
            let results = alasql("select * from ? where FullName like '" + query + "%' OR EmployeeCode like '" + query + "%'", [service.employees]);
            return results;
        }

        function selectedItemChange(item) {
            if (item != null || item != "") {
                service.selectedItem = item;
            } else {
                service.selectedItem = null;
            }
        }

        function defaultModel() {
            return {
                BranchId: null,
                DivisionId: null,
                ContactId: null,
                StartDate: null,
                EndDate: null,
                ShouldUseTemporaryInterpretedShift: 0,
            }
        }

        function loadBranches() {
            service.reset();
            branchApi.getBranches().then(function(resp) {
                service.branches = resp.data;
            });
        }

        function generatePDF(model) {
            service.loading = true;
            service.loadingMessage = service.selectedItem === null ? utils.translate('PAYROLL_TIMESHEETS.GENERATE') : utils.translate('PAYROLL_TIMESHEETS.GENERATE_FOR') + service.selectedItem.FullName + " ...";
            model.StartDate = moment(model.StartDate).format("YYYY-MM-D");
            model.EndDate = moment(model.EndDate).format("YYYY-MM-D");
            model.ContactId = service.selectedItem === null ? null : service.selectedItem.Id;
            model.ShouldUseTemporaryInterpretedShift = parseInt(model.ShouldUseTemporaryInterpretedShift);
            let url = tenantSettings.coreApiUrl + 'api/timesheets/pdf/payroll';

            $http({
                url: url,
                method: "POST",
                data: model
            }).catch(function() {
                service.loading = false;
                hubService.showToast(utils.translate('PAYROLL_TIMESHEETS.NO_DATA_FOUND'));
            });
        }

        function reset() {
            service.model = defaultModel();
            service.divisions = [];
            service.employees = [];
            service.selectedItem = null;
            service.searchText
        }

        function changeBranch(branch) {
            service.loading = true;
            service.loadingMessage = utils.translate('PAYROLL_TIMESHEETS.LOADING');
            let divisions = alasql('select * from ? where Id = ?', [service.branches, branch]);
            if (divisions.length > 0) {
                service.divisions = divisions[0].Division;
            }
            contactApi.getUsersPerBranch(branch).then(function(resp) {
                service.selectedItem = null;
                service.searchText = null;
                service.loading = false;
                service.employees = resp.data
            }).catch(function() {
                service.loading = false;
            });
        }

        return service;
    }
})();

(function () {
  'use strict';

  angular
    .module('app.payroll.timesheet')
    .controller('PayrollTimesheetController', PayrollTimesheetController);

  function PayrollTimesheetController(payrollTimesheetService) {
      var vm = this;
      vm.service = payrollTimesheetService;

      function activate(){
        vm.service.branches = [];
        vm.service.divisions = [];
        vm.service.employees = [];
        vm.service.loadBranches();
      }

      vm.getEmployeeName = function(fullName, employeeCode){
          return fullName + " (" + employeeCode + ")";
      };

      activate();
  }
})();

(function() {
    'use strict';

    angular.module('app.payroll')
        .factory('payrollClaimsService', payrollClaimsService);

    /** @ngInject */
    function payrollClaimsService($rootScope, claimsUtilService) {

        var service = {
            hasPayrollMenuAccess: false,
            hasRunPayrollAccess: false,
            hasModifyAllowancesAccess: false,
            hasUpdatePayrollContactsAccess: false,
            hasModifyPayRatesAccess: false
        };

        activate();

        return service;

        function activate() {
            $rootScope.$on('identityService:applyClaimsRules', function() {
                applyClaimsRules();
            });

            applyClaimsRules();
        }

        function applyClaimsRules() {
            if (claimsUtilService.isPayrollEnabled()) {
                service.hasPayrollMenuAccess = claimsUtilService.checkAccessByRole('Payroll');
                service.hasRunPayrollAccess = claimsUtilService.checkAccessByRole('Run Payroll');
                service.hasModifyAllowancesAccess = claimsUtilService.checkAccessByRole('ALLOWANCES');
                service.hasUpdatePayrollContactsAccess = (claimsUtilService.isMyobEnabled() || claimsUtilService.isXeroEnabled()) && service.hasRunPayrollAccess;
                service.hasModifyPayRatesAccess = claimsUtilService.checkAccessByRole('Edit Pay Rates');
            }
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.payroll.payrates', ['app.api'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
      .state('app.payrates', {
        url: '/payrates',
        views: {
          'content@app': {
            templateUrl: 'app/main/payroll/payrates/payrates.html',
            controller: 'PayratesController as vm'
          }
        },
        bodyClass: 'payrates',
        pageTitle: 'Alloc8 - Pay Rates',
        pageDesc: 'Manage pay rates',
        pageKeywords: 'payrates, pay rates, payroll',
        titleBar: 'Alloc8 - Pay Rates'
      })
      .state('app.payrates.detail', {
        url: '/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/payroll/payrates/payrates.detail.html',
            controller: 'PayratesDetailController as vm'
          }
        },
        bodyClass: 'payrates-detail',
        pageTitle: 'Alloc8 - Award Details',
        pageDesc: 'Manage award details',
        pageKeywords: 'payrates, pay rates, awards, payroll',
        titleBar: 'Alloc8 - Award Details'
      });

    $translatePartialLoaderProvider.addPart('app/main/payroll/payrates');
  }
})();

(function() {
    'use strict';

    angular.module('app.payroll.payrates')
        .factory('payratesService', payratesService);

    /** @ngInject */
    function payratesService(oldAwardAPI) {
        var service = {
            getAwards: getAwards,
            getPayrates: getPayrates,
            updatePayrates: updatePayrates
        };

        return service;
        
        function getAwards() {
            return oldAwardAPI.getAwardsSummary();
        }
        function getPayrates(awardId) {
            return oldAwardAPI.getPayrates(awardId);
        }

        function updatePayrates(awardId,payRateBundle) 
        {
            return oldAwardAPI.updatePayrates(awardId,payRateBundle);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.payroll.payrates')
        .controller('payratesDialogController', payratesDialogController);

    /** @ngInject */
    function payratesDialogController(
        $mdDialog,
        blockUI,
        utils,
        payratesAPI,
        UpdateMode,
        Payrates,
        Data
    ) {
        var vm = this;

        vm.updateMode = UpdateMode;
        vm.payrates = Payrates;
        vm.payrate = {};
        vm.title = vm.updateMode ? 'PAYRATES.DIALOG.EDIT_TITLE' : 'PAYRATES.DIALOG.ADD_TITLE';
        vm.payrateTypes = [
            { id: 'Hourly', name: 'PAYRATES.DIALOG.TYPE_HOURLY' },
            { id: 'Daily', name: 'PAYRATES.DIALOG.TYPE_DAILY' },
            { id: 'Fixed', name: 'PAYRATES.DIALOG.TYPE_FIXED' }
        ];

        vm.cancel = cancel;
        vm.save = save;

        activate();

        function activate() {
            if (vm.updateMode) {
                vm.payrate = angular.copy(Data);
            } else {
                vm.payrate = {
                    Name: '',
                    Description: '',
                    Rate: 0,
                    Type: 'Hourly'
                };
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function save() {
            blockUI.start();

            if (vm.updateMode) {
                payratesAPI.updatePayrate(vm.payrate).then(function(resp) {
                    blockUI.stop();
                    utils.showToast(utils.translate('PAYRATES.DIALOG.UPDATED_SUCCESS'));
                    $mdDialog.hide(resp);
                }, function(err) {
                    blockUI.stop();
                    utils.showToast(utils.translate('PAYRATES.DIALOG.ERROR_UPDATING'));
                });
            } else {
                payratesAPI.createPayrate(vm.payrate).then(function(resp) {
                    blockUI.stop();
                    utils.showToast(utils.translate('PAYRATES.DIALOG.ADDED_SUCCESS'));
                    $mdDialog.hide(resp);
                }, function(err) {
                    blockUI.stop();
                    utils.showToast(utils.translate('PAYRATES.DIALOG.ERROR_ADDING'));
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.payroll.payrates')
        .controller('PayratesDetailController', PayratesDetailController);

    /** @ngInject */
    function PayratesDetailController(
        $state,
        $stateParams,
        blockUI,
        utils,
        $mdToast,
        DTColumnDefBuilder,
        payratesService
    ) {
        var vm = this;
        
        // Properties
        vm.awardId = $stateParams.id;
        vm.awardName = '';
        vm.baseRates = [];
        vm.payRates = [];
        vm.paginatedPayRates = [];
        vm.dateFormat = utils.setDateFormat();
        
        // Pagination configuration
        vm.currentPage = 1;
        vm.itemsPerPage = 10;
        vm.totalPages = 1;
        vm.startIndex = 0;
        vm.endIndex = 0;
        
        // Methods
        vm.formatDateTime = formatDateTime;
        vm.recalculateRates = recalculateRates;
        vm.goBack = goBack;
        vm.payRateChanged = payRateChanged;
        vm.saveChanges = saveChanges;
        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.updatePagination = updatePagination;
        vm.changeItemsPerPage = changeItemsPerPage;
        
        activate();
        
        function activate() {
            blockUI.start('Loading award details...');
            
            var awardId = $stateParams.id;
            payratesService.getPayrates(awardId)
                .then(function(response) {
                    vm.bundle = response.data;
                    vm.baseRates = vm.bundle.Classifications;
                    vm.payRates = vm.bundle.PayRates;
                    
                    // Initialize pagination
                    updatePagination();
                    
                    blockUI.stop();
                })
                .catch(function(error) {
                    console.error('Error loading award details:', error);
                    blockUI.stop();
                });
        }
        
        function formatDateTime(dateTime) {
            return utils.formatToLocaleDate(dateTime, vm.dateFormat);
        }
        
        function recalculateRates() {
            blockUI.start('Recalculating rates...');
            
            // Iterate over each baseRate
            Object.entries(vm.baseRates).forEach(function([classificationName, baseRate]) {
                // Find payRates with category 0 that should be calculated from this baseRate
                var relatedPayRates = vm.payRates.filter(function(payRate) {
                    return payRate.Category === 0 &&  payRate.Classifications.includes(classificationName);
                });
                
                // Recalculate each related payRate based on the loading
                relatedPayRates.forEach(function(payRate) {
                    // Store the current rate for comparison
                    var currentRate = payRate.Rate;
                    
                    // Calculate the new rate using the formula: baseRate * (payRate.Loading / 100)
                    var newRate = baseRate * (payRate.Loading / 100);
                    
                    // Round to 4 decimal places for currency precision
                    var newRateRounded = parseFloat(newRate.toFixed(4));
                    
                    // Only update and mark as modified if the value actually changed
                    if (currentRate !== newRateRounded) {
                        payRate.Rate = newRateRounded;
                        payRate.isModified = true;
                    }
                });
            });
            
            // Update the pagination to reflect changes
            updatePagination();
            
            // Show success message
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Pay rates recalculated successfully')
                    .position('top right')
                    .hideDelay(3000)
            );
            
            blockUI.stop();
        }
        
        function goBack() {
            $state.go('app.payrates');
        }
        
       
      
        
        function payRateChanged(payRate) {
          if(payRate.Category===0)
            {
             let baseRate=vm.baseRates[payRate.Classifications[0]];
             payRate.Loading=(payRate.Rate/baseRate)*100;
            }

            // Mark as modified
            payRate.isModified = true;
        }
        
        function saveChanges() {
            blockUI.start('Saving changes...');
            vm.bundle.PayRates = vm.payRates;
            vm.bundle.Classifications = vm.baseRates;
            
            payratesService.updatePayrates(vm.awardId, vm.bundle)
                .then(function(response) {
                    // Reset modified flags on success
                    vm.payRates.forEach(function(rate) {
                        rate.isModified = false;
                    });
                    
                    // Show success message
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Changes saved successfully')
                            .position('top right')
                            .hideDelay(3000)
                    );
                })
                .catch(function(error) {
                    // Show error message
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error saving changes: ' + ((error.data && error.data.message) || 'Unknown error'))
                            .position('top right')
                            .hideDelay(5000)
                            .theme('error-toast')
                    );
                })
                .finally(function() {
                    blockUI.stop();
                });
        }
        
        // Pagination methods
        function updatePagination() {
            // Calculate total pages
            vm.totalPages = Math.ceil(vm.payRates.length / vm.itemsPerPage);
            
            // If current page is beyond total pages, set to last page
            if (vm.currentPage > vm.totalPages) {
                vm.currentPage = vm.totalPages || 1;
            }
            
            // Calculate start and end indices
            vm.startIndex = (vm.currentPage - 1) * vm.itemsPerPage;
            vm.endIndex = Math.min(vm.startIndex + vm.itemsPerPage, vm.payRates.length);
            
            // Get current page items
            vm.paginatedPayRates = vm.payRates.slice(vm.startIndex, vm.endIndex);
        }
        
        function nextPage() {
            if (vm.currentPage < vm.totalPages) {
                vm.currentPage++;
                updatePagination();
            }
        }
        
        function prevPage() {
            if (vm.currentPage > 1) {
                vm.currentPage--;
                updatePagination();
            }
        }
        
        function changeItemsPerPage() {
            // Reset to first page when changing items per page
            vm.currentPage = 1;
            updatePagination();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.payroll.payrates')
        .controller('PayratesController', PayratesController);

    /** @ngInject */
    function PayratesController(
        blockUI,
        msgboxService,
        utils,
        DTColumnDefBuilder,
        payratesService,
        payrollClaimsService,
        $state
    ) {
        var vm = this;

        vm.payratesService = payratesService;
        vm.dateFormat = utils.setDateFormat();
        vm.dtInstance = {};
        vm.dtInstance.DataTable = null;
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable() // Action column (index 1)
        ];
        vm.editPayrate = editPayrate;
        vm.formatDateTime = formatDateTime;
        vm.hasModifyPayratesAccess = false;
        vm.dtOptions = {
            order: [0, "asc"],
            paging: true,
            searching: false,
            lengthChange: true,
            displayLength: 10,
            dom: 'tlip'
        }

        activate();

        function activate() {
            vm.hasModifyPayratesAccess = payrollClaimsService.hasModifyPayratesAccess;
            loadGrid();
        }

        function loadGrid() {
            payratesService.getAwards().then(function(resp) {
                vm.awards = resp.data;
            });
        }

       

        function formatDateTime(createdDateTime) {
            return utils.formatToLocaleDate(createdDateTime, vm.dateFormat);
        }

        function editPayrate(id) {
            // Navigate to the detail view instead of opening a modal
            $state.go('app.payrates.detail', { id:id});
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.payroll.allowances', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.allowances', {
      url: '/payroll/allowances'
      , views: {
        'content@app': {
          templateUrl: 'app/main/payroll/allowances/allowances.html',
          controller: 'AllowancesController as vm'
        }
      }
      , data: {
        requireLogin: true
      }
      , title: 'Allowances'
      , titleBar: 'Alloc8 - Allowances'
    });

    $translatePartialLoaderProvider.addPart('app/main/payroll/allowances')
  }
})();

(function() {
    'use strict';

    angular.module('app.payroll.allowances')
        .factory('allowancesService', allowancesService);

    /** @ngInject */
    function allowancesService() {
        var service = {
        };

        return service;

    }
})();
    (function() {
        'use strict';

        angular
            .module('app.payroll.allowances')
            .controller('allowancesDialogController', allowancesDialogController);

        function allowancesDialogController(
            $mdToast,
            $mdDialog,
            blockUI,
            utils,
            locals,
            allowanceAPI,
            $scope,
            exceptionService) {

            var vm = this;

            vm.onCancel = onCancel;
            vm.onDone = onDone;
            vm.onInputNameKeyUp = onInputNameKeyUp;
            vm.onInputPayCodeKeyUp = onInputPayCodeKeyUp;
            vm.updateMode = locals.UpdateMode;

            function activate() {
                vm.caption = locals.UpdateMode ? utils.translate('ALLOWANCES.DIALOG.UPDATE_ALLOWANCE') : utils.translate('ALLOWANCES.DIALOG.ADD_ALLOWANCE');

                if (locals.UpdateMode && locals.Data) {
                    vm.name = locals.Data.Name;
                    vm.type = locals.Data.Type;
                    vm.amount = locals.Data.Amount;
                    vm.paycode = locals.Data.PayCode;
                    vm.deactivate = !locals.Data.Active;
                } else {
                    vm.type = 1; // per hour
                }

                vm.allowances = locals.Allowances;
            }

            function onInputNameKeyUp() {
                var isNameExist = false;
                var result = alasql('select * from ? where Name = ?', [vm.allowances, vm.name]);

                if (locals.UpdateMode) {
                    result = alasql('select * from ? where Name = ? and Name <> ?', [vm.allowances, vm.name, locals.Data.Name]);
                }

                if (result.length > 0) {
                    isNameExist = true;
                }

                $scope.allowanceForm.name.$setValidity('valid', !isNameExist);
            }

            function onInputPayCodeKeyUp() {
                var isPayCodeExist = false;
                var result = alasql('select * from ? where PayCode = ?', [vm.allowances, vm.paycode]);

                if (locals.UpdateMode) {
                    result = alasql('select * from ? where PayCode = ? and PayCode <> ?', [vm.allowances, vm.paycode, locals.Data.PayCode]);
                }

                if (result.length > 0) {
                    isPayCodeExist = true;
                }

                $scope.allowanceForm.paycode.$setValidity('valid', !isPayCodeExist);
            }

            function onCancel() {
                $mdDialog.hide();
            }

            activate();

            function onDone() {
                let model = {
                    Name: vm.name,
                    Type: vm.type,
                    Paycode: vm.paycode,
                    Amount: vm.amount,
                    Active: !vm.deactivate
                }

                if (!locals.UpdateMode) {
                    blockUI.start({
                        message: utils.translate('ALLOWANCES.DIALOG.SAVING')
                    });

                    allowanceAPI.addAllowance(model)
                        .then(SaveCompleted)
                        .catch(function(ex) {
                            blockUI.stop();
                            exceptionService.resolve(ex);
                        });
                } else {
                    blockUI.start({
                        message: utils.translate('ALLOWANCES.DIALOG.UPDATING')
                    });

                    model.Id = locals.Data.Id;

                    allowanceAPI.updateAllowance(model)
                        .then(UpdateCompleted)
                        .catch(function(ex) {
                            blockUI.stop();
                            exceptionService.resolve(ex);
                        });
                }
            }

            function UpdateCompleted(resp) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('ALLOWANCES.DIALOG.UPDATE_SUCCESSFUL'))
                    .position('bottom right')
                )

                blockUI.stop();
                $mdDialog.hide(resp);
            }

            function SaveCompleted(resp) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('ALLOWANCES.DIALOG.SAVE_SUCCESFUL'))
                    .position('bottom right')
                )

                blockUI.stop();
                $mdDialog.hide(resp);
            }
        }
    })();
(function() {
    'use strict';

    angular
        .module('app.payroll.allowances')
        .controller('AllowancesController', AllowancesController);

    /** @ngInject */
    function AllowancesController(
        blockUI,
        msgboxService,
        allowanceAPI,
        utils,
        DTColumnDefBuilder,
        allowancesService,
        payrollClaimsService
    ) {
        var vm = this;

        vm.allowancesService = allowancesService;
        vm.dateFormat = utils.setDateFormat();
        vm.dtInstance = {};
        vm.dtInstance.DataTable = null;
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(6).notSortable(), // Action
        ];
        vm.addAllowance = addAllowance;
        vm.editAllowance = editAllowance;
        vm.formatDateTime = formatDateTime;
        vm.hasModifyAllowancesAccess = false;
        vm.dtOptions = {
            order: [0, "asc"],
            paging: true,
            searching: false,
            lengthChange: true,
            displayLength: 10,
            dom: 'tlip'
        }

        activate();

        function activate() {
            vm.hasModifyAllowancesAccess = payrollClaimsService.hasModifyAllowancesAccess;
            loadGrid();
        }

        function loadGrid() {
            allowanceAPI.getAllowances().then(function(resp) {
                vm.allowances = resp.data;
            });
        }

        function addAllowance() {
            let locals = {
                UpdateMode: false,
                Allowances: vm.allowances
            }

            msgboxService.showCustomDialog('app/main/payroll/allowances/allowances.dialog.html',
                    'allowancesDialogController as vm', locals)
                .then(function(resp) {
                    loadGrid();
                });
        }

        function formatDateTime(createdDateTime) {
            return utils.formatToLocaleDate(createdDateTime, vm.dateFormat);
        }

        function editAllowance(data) {
            blockUI.start(utils.translate('ALLOWANCES.DIALOG.LOADING_EDIT'));
            let locals = {
                UpdateMode: true,
                Allowances: vm.allowances,
                Data: data
            }
            blockUI.stop();

            msgboxService.showCustomDialog('app/main/payroll/allowances/allowances.dialog.html',
                    'allowancesDialogController as vm', locals)
                .then(function(resp) {
                    loadGrid();
                });
        }
    }

})();

(function() {
    'use strict';

    angular.module('app.paperwork.manage-paperwork')
        .factory('managePaperworkService', managePaperworkService);

    function managePaperworkService(branchService,
        companyViewService,
        projectApi,
        claimsUtilService,
        ticketsApi,
        tagsApi,
        $q,
        signalRService,
        $rootScope,
        downloadPaperworkService,
        $mdToast) {

        var service = {
            getAllLookupsPromise: getAllLookupsPromise,
            getTicketsWithFilters: getTicketsWithFilters,
            regeneratePaperwork: regeneratePaperwork,
            isBillingEnabled: isBillingEnabled,
            register: register,
            // Filters need to be cached between page navigations, so it is in the service because the service lifetime is per application,
            // whereas the controller is re-instantiated per page load.
            filters: {
                filteredTicketNumber: '',
                selectedBranchIds: [],
                selectedCompanyIds: [],
                selectedProjectIds: [],
                selectedTagIds: [],
                startDate: null,
                endDate: null,
                includeInvoicedJobs: false
            }
        };

        var isInitialized = false; // To prevent double subscription to event

        return service;

        ///////
        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function() {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }
        }

        function regs() {

            // Download feedback
            signalRService.messageHub.on('paperworkDownloadNotify', function(data) {
                if (data.RequestToken == downloadPaperworkService.currentRequestToken) {

                    if (data.IsError) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.Message)
                            .position('bottom right')
                            .hideDelay(false)
                            .action('CLOSE')
                        );
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.Message)
                            .position('bottom right')
                            .hideDelay(3000)
                        );
                    }
                }
            });
        }

        function getAllLookupsPromise() {
            var deferred = $q.defer();
            var branches = branchService.getAllBranches();
            var clients = companyViewService.getCompanies();
            var projects = projectApi.getProjects();
            var tags = tagsApi.getActiveTags();
            var promises = [branches, clients, projects, tags];

            $q.all(promises).then(function(response) {
                deferred.resolve(response);
            });

            return deferred.promise;
        }

        function getTicketsWithFilters(filters) {
            var deferred = $q.defer();

            ticketsApi.getTicketsWithFiltersForPaperwork(filters).then(function(response) {
                var tickets = response.data;
                deferred.resolve(tickets);
            });

            return deferred.promise;
        }

        function regeneratePaperwork(selectedTicketIds) {
            var deferred = $q.defer();

            ticketsApi.regeneratePaperworkPdfForTicketIds(selectedTicketIds).then(function() {
                deferred.resolve(true);
            });

            return deferred.promise;
        }

        function isBillingEnabled() {
            return claimsUtilService.isBillingEnabled();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.paperwork.manage-paperwork')
        .controller('ManagePaperworkController', ManagePaperworkController);

    function ManagePaperworkController(managePaperworkService,
        DTColumnDefBuilder,
        signalRService,
        blockUI,
        $scope,
        $timeout,
        $state,
        $mdDialog,
        $window,
        $mdSidenav,
        utils,
        downloadPaperworkService) {

        var vm = this;
        vm.service = managePaperworkService;
        vm.filters = vm.service.filters;
        vm.showResults = showResults;
        vm.enableShowResultsButton = enableShowResultsButton;
        vm.regeneratePaperwork = regeneratePaperwork;
        vm.downloadSelected = downloadSelected;
        vm.onTicketSelectionChange = onTicketSelectionChange;
        vm.downloadPaperworkPdf = downloadPaperworkPdf;
        vm.editTimesheet = editTimesheet;
        vm.editTicket = editTicket;
        vm.editFormsAndAttachment = editFormsAndAttachment;
        vm.clearFilters = clearFilters;
        vm.displayFormattedTags = displayFormattedTags;
        vm.isClearFiltersButtonEnabled = isClearFiltersButtonEnabled;
        vm.isTicketNoFieldDisabled = isTicketNoFieldDisabled;
        vm.areFilterFieldsExceptTicketNoDisabled = areFilterFieldsExceptTicketNoDisabled;
        vm.areFilterFieldsRequired = areFilterFieldsRequired;
        vm.toggleAllTicketSelections = toggleAllTicketSelections;
        vm.isTicketSelected = isTicketSelected;
        vm.isIndeterminate = isIndeterminate;
        vm.areAllTicketsSelected = areAllTicketsSelected;
        vm.searchTableResults = searchTableResults;
        vm.tableHasResults = false;

        vm.isBillingEnabled = false;

        vm.branches = [];
        vm.states = [];
        vm.selectedTicketIds = [];
        vm.tickets = [];

        vm.displayLength = 15;

        vm.dtInstance = {};
        vm.dtInstance.DataTable = null;
        vm.areDataTableEventsInitialised = false;
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable().withOption('searchable', false), // Id
            DTColumnDefBuilder.newColumnDef(7).notSortable(), // Tags
            DTColumnDefBuilder.newColumnDef(8).notSortable(), // Purchase Order
            DTColumnDefBuilder.newColumnDef(11).notSortable().withOption('searchable', false) // Actions
        ];
        vm.dtOptions = {
            order: [1, "desc"],
            paging: true,
            searching: true,
            lengthChange: false,
            scrollY: "590px",
            scrollCollapse:true,
            displayLength: vm.displayLength
        }
        vm.dtLoading = false;

        vm.paperworkPdfGenerationStatus = [{
                Id: 0,
                Description: 'Not Generated'
            },
            {
                Id: 1,
                Description: 'Queued'
            },
            {
                Id: 2,
                Description: 'Regenerating'
            },
            {
                Id: 3,
                Description: 'Failed'
            },
            {
                Id: 4,
                Description: 'Generated'
            }
        ];

        vm.toggleSidenav = toggleSidenav;

        init();

        function init() {
            initDataTableEvents();

            vm.isBillingEnabled = vm.service.isBillingEnabled();

            vm.service.getAllLookupsPromise().then(function(response) {
                vm.branches = response[0];
                vm.companies = response[1].data;
                vm.projects = response[2].data;
                vm.tags = response[3].data;
            });

            if (!signalRService.isConnected) {
                signalRService.connect();
            }

            registerGeneratePaperworkCallback();

            downloadPaperworkService.getCheckedItems = getCheckedItems;
        }

        function clearFilters() {
            vm.filters = {
                filteredTicketNumber: '',
                selectedBranches: [],
                selectedBranchIds: [],
                selectedCompanyIds: [],
                selectedProjectIds: [],
                selectedTagIds: [],
                startDate: null,
                endDate: null,
                includeInvoicedJobs: false
            };
        }

        function initDataTableEvents() {
            $scope.$watch("vm.dtInstance.DataTable", function() {
                if (!vm.areDataTableEventsInitialised && vm.dtInstance.DataTable) {
                    vm.dtInstance.DataTable.on('page.dt order.dt', function() {
                        // Clear selected tickets on paging and sorting
                        vm.selectedTicketIds = [];
                        applyModelChanges();
                    });
                    vm.dtInstance.DataTable.on('draw.dt', dataTableDrawEventHandler);
                    angular.element(`.dataTables_paginate`).addClass('display-none');
                    vm.areDataTableEventsInitialised = true;
                }
            }, false);
        }

        function dataTableDrawEventHandler() {
            let moreThanOnePageOfDisplayedResults = false;
            let pageInfo = vm.dtInstance.DataTable.search(vm.searchText).page.info();

            // This check is due to a bug in datatables where pageInfo is not updated when a new search is performed.
            var numberOfTickets = 0;
            if (vm.tickets) {
                numberOfTickets = vm.tickets.length;
            }

            let newSearchPerformed = (numberOfTickets !== pageInfo.recordsTotal);
            if (newSearchPerformed) {
                // Use vm.tickets as the actual result set since pageInfo is not updated yet.
                vm.tableHasResults = numberOfTickets > 0;

                moreThanOnePageOfDisplayedResults = numberOfTickets > vm.displayLength;

                let startRecordNum = (numberOfTickets > 0) ? 1 : 0;
                let pageInfoEnd = (numberOfTickets >= pageInfo.length) ? pageInfo.length : numberOfTickets;
                setJobResultsText(startRecordNum, pageInfoEnd, numberOfTickets, numberOfTickets);
            } else {
                // Datatable is updated, use pageInfo for results.
                vm.tableHasResults = pageInfo.recordsDisplay > 0;

                moreThanOnePageOfDisplayedResults = pageInfo.recordsDisplay > vm.displayLength;

                let startRecordNum = (pageInfo.end === 0) ? 0 : pageInfo.start + 1;
                setJobResultsText(startRecordNum, pageInfo.end, pageInfo.recordsDisplay, pageInfo.recordsTotal);
            }

            if (moreThanOnePageOfDisplayedResults) {
                angular.element(`.dataTables_paginate`).removeClass('display-none');
            } else {
                angular.element(`.dataTables_paginate`).addClass('display-none');
            }
        }

        function enableShowResultsButton() {
            let hasSelectedBranch = vm.filters.selectedBranchIds && vm.filters.selectedBranchIds.length > 0;
            let hasStartDateAndEndDate = vm.filters.startDate && vm.filters.endDate;

            return (vm.filters.filteredTicketNumber.length > 0) || (hasSelectedBranch && hasStartDateAndEndDate);
        }

        function showResults() {
            vm.dtLoading = true;
            vm.service.getTicketsWithFilters(vm.filters).then(function(tickets) {
                vm.tickets = tickets;

                angular.forEach(vm.tickets, function(ticket) {
                    mapPaperworkPdfGenerationStatus(ticket, ticket.PaperworkPdfGenerationStatus);
                });

                vm.selectedTicketIds = [];
                vm.searchText = '';
                vm.dtLoading = false;
            });
        }

        function downloadSelected() {
            downloadPaperworkService.download();
        }

        function getCheckedItems() {
            return vm.selectedTicketIds;
        }

        function regeneratePaperwork() {
            let jobText = (vm.selectedTicketIds.length > 1) ? 'jobs' : 'job';

            let confirm = $mdDialog.confirm({
                title: utils.translate(`Regenerate Paperwork for ${vm.selectedTicketIds.length} ${jobText}?`),
                textContent: utils.translate('PAPERWORK.MANAGE_PAPERWORK.THISMAYTAKESOMETIME'),
                ok: utils.translate('PAPERWORK.MANAGE_PAPERWORK.PROCEED'),
                cancel: utils.translate('PAPERWORK.MANAGE_PAPERWORK.CANCEL')
            });

            $mdDialog
                .show(confirm)
                .then(function() {
                    blockUI.start('Queuing tickets for paperwork pdf generation, please wait...');

                    vm.service.regeneratePaperwork(vm.selectedTicketIds).then(function(response) {
                        if (response) {
                            blockUI.stop();
                            angular.forEach(vm.selectedTicketIds, function(selectedTicketId) {
                                let ticket = vm.tickets.find(t => t.id == selectedTicketId);

                                if (ticket) {
                                    ticket.PaperworkPdfGenerationStatus = 1;
                                    mapPaperworkPdfGenerationStatus(ticket, ticket.PaperworkPdfGenerationStatus);
                                }
                            });
                        }
                    });
                }).finally(function() {
                    confirm = undefined;
                });
        }

        function isTicketSelected(ticketId) {
            return vm.selectedTicketIds.some(tId => tId === ticketId);
        }

        function onTicketSelectionChange(selectedTicketId, isChecked) {
            let selectedTicketIdIndex = vm.selectedTicketIds.indexOf(selectedTicketId);

            if (!isChecked && selectedTicketIdIndex >= 0) {
                vm.selectedTicketIds.splice(selectedTicketIdIndex, 1);
            } else if (isChecked && selectedTicketIdIndex === -1) {
                vm.selectedTicketIds.push(selectedTicketId);
            }
        }

        function toggleAllTicketSelections(isChecked) {
            if (isChecked && vm.selectedTicketIds.length >= 0) {
                vm.selectedTicketIds = getCurrentPageTicketIds();
            } else if (!isChecked && vm.selectedTicketIds.length === getCurrentPageTicketIds().length) {
                vm.selectedTicketIds = [];
            }
        }

        function getCurrentPageTicketIds() {
            if (!vm.dtInstance.DataTable) {
                return [];
            }

            let currentPageRowData = vm.dtInstance.DataTable.rows({
                page: 'current'
            }).data();
            return currentPageRowData.reduce((ticketIds, rowData) => {
                let ticketId = rowData[0];
                ticketIds.push(ticketId);
                return ticketIds;
            }, []);
        }

        function isIndeterminate() {
            return vm.selectedTicketIds.length > 0 && vm.selectedTicketIds.length !== getCurrentPageTicketIds().length;
        }

        function areAllTicketsSelected() {
            return vm.selectedTicketIds.length > 0 && vm.selectedTicketIds.length === getCurrentPageTicketIds().length;
        }

        function registerGeneratePaperworkCallback() {
            signalRService.messageHub.on('generatePaperworkCallback', function(resp) {
                let ticketWithUpdatedPaperworkStatus = vm.tickets.find(ticket => ticket.id == resp.TicketId);

                if (ticketWithUpdatedPaperworkStatus) {
                    ticketWithUpdatedPaperworkStatus.PaperworkPdfLastGeneratedDate = resp.PaperworkPdfLastGeneratedDate;
                    mapPaperworkPdfGenerationStatus(ticketWithUpdatedPaperworkStatus, resp.PaperworkPdfGenerationStatus);
                }
            });
        }

        function mapPaperworkPdfGenerationStatus(ticket, updatedGenerationStatus) {
            let generationStatus = vm.paperworkPdfGenerationStatus.find(x => x.Id == updatedGenerationStatus);

            ticket.showGenerateStatus = generationStatus.Description != 'Generated';
            ticket.PaperworkPdfGenerateStatusDescription = generationStatus.Description;
            ticket.PaperworkPdfGenerateStatusClass = generationStatus.Description.toLowerCase().replace(/\s+/g, '-');
            applyModelChanges()
        }

        function displayFormattedTags(tags) {
            return tags.map(t => t.Name).join(', ') || '-';
        }

        function isClearFiltersButtonEnabled() {
            return (vm.filters.filteredTicketNumber.length > 0) || isAnyFilterExceptTicketNoSelected();
        }

        function areFilterFieldsRequired() {
            return vm.filters.filteredTicketNumber.length === 0;
        }

        function isTicketNoFieldDisabled() {
            return isAnyFilterExceptTicketNoSelected();
        }

        function isAnyFilterExceptTicketNoSelected() {
            return (vm.filters.selectedBranchIds && vm.filters.selectedBranchIds.length > 0) ||
                (vm.filters.selectedCompanyIds.length > 0) ||
                (vm.filters.selectedProjectIds.length > 0) ||
                (vm.filters.selectedTagIds.length > 0) ||
                (vm.filters.startDate) ||
                (vm.filters.endDate) ||
                (vm.filters.includeInvoicedJobs);
        }

        function areFilterFieldsExceptTicketNoDisabled() {
            return vm.filters.filteredTicketNumber.length > 0;
        }

        function searchTableResults() {
            vm.dtInstance.DataTable.search(vm.searchText).draw();
        }

        function setJobResultsText(startRecordNum, pageInfoEnd, pageInfoRecordsDisplay, pageInfoRecordsTotal) {
            let jobsResultsText = `Showing ${startRecordNum} to ${pageInfoEnd} of ${pageInfoRecordsDisplay} jobs`;
            if (vm.searchText) {
                jobsResultsText += ` (filtered from ${pageInfoRecordsTotal} total jobs)`;
            }
            vm.jobsResultsText = jobsResultsText;
        }

        function applyModelChanges() {
            $timeout(function() {
                $scope.$apply();
            });
        }

        function editTicket(ticket) {
            $state.go('app.jobs_update', {
                id: ticket.id,
                ticketNumber: ticket.TicketNumber,
                isLocked: ticket.IsLocked
            });
        }

        function editFormsAndAttachment(ticket) {
            $state.go('app.formsattachments', {
                TicketId: ticket.id,
                TicketNo: ticket.TicketNumber
            })
        }

        function editTimesheet(ticket) {
            $state.go('app.timesheet', {
                id: ticket.id,
                TicketNo: ticket.TicketNumber,
                isLocked: ticket.IsLocked
            });
        }

        function downloadPaperworkPdf(fileUri) {
            let cacheInvalidationQuerystring = `?time=${new Date().getTime()}`;
            let updatedUri = encodeURI(fileUri) + cacheInvalidationQuerystring;

            $window.open(updatedUri, '_blank');
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.paperwork.manage-paperwork')
        .service('downloadPaperworkService', downloadPaperworkService);

    /** @ngInject */
    function downloadPaperworkService(
        $mdDialog,
        utils
    ) {

        var service = {
            download: download,
            currentRequestToken: null,
            getCheckedItems: angular.noop // parent callback
        };

        activate();

        return service;
        ////////

        function activate() {}

        function download() {
            service.currentRequestToken = utils.newGuid();

            $mdDialog.show({
                templateUrl: 'app/main/paperwork/manage-paperwork/download/download-paperwork.html',
                controller: 'DownloadPaperworkDialogController',
                controllerAs: 'vm',
                multiple: true,
                locals: {
                    ticketIds: service.getCheckedItems(),
                    currentRequestToken: service.currentRequestToken
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        // State
        $stateProvider.state('app.pages_profile', {
            url: '/my-profile',
            views: {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller: 'ProfileController as vm'
                }
            },
            data: {
                requireLogin: true
            },
            resolve: {
                lookupService: lookupServiceResolver
            },
            bodyClass: 'profile',
            title: 'My Profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        function lookupServiceResolver(contactLookupsService) {
            return contactLookupsService.fetchLookups();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(
        utils,
        identityService,
        contactService,
        tenantSettings,
        lookupService,
        blockUI,
        profileService,
        passwordService,
        exceptionService
    ) {
        var vm = this;

        // Data
        vm.regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$");
        vm.PhoneTypes = lookupService.PhoneTypes;
        vm.dateFormat = null;
        vm.timeFormat = null;
        vm.phoneType = null;
        vm.profileData = profileService.profileData;
        vm.passwordData = passwordService.passwordData;
        vm.Formats = {
            DateFormats: ['MM/DD/YYYY', 'DD/MM/YYYY'],
            TimeFormats: [12, 24]
        };
        vm.uploadUrl = tenantSettings.coreApiUrl + "api/contacts/uploadimage";

        //Methods
        vm.onUploadSuccess = onUploadSuccess;
        vm.onUploadError = onUploadError;
        vm.onUploadStart = onUploadStart;
        vm.updateProfile = updateProfile;
        vm.updatePassword = updatePassword;
        vm.onUploadValidate = onUploadValidate;

        blockUI.start({
            message: 'Loading......'
        });

        if (identityService.isAuthenticated()) {
            identityService.fetchUserData()
                .then(loadUserData);
        }

        function loadUserData(resp) {
            contactService.getContactDetails(resp.ContactId).then(function(resp) {
                vm.profileData = angular.copy(resp.data);
                vm.primaryEmail = fetchEmail(vm.profileData.Emails);
                vm.primaryPhone = fetchPhone(vm.profileData.Phones);
                if (localStorage.getItem("dateFormat") != null) {
                    vm.dateFormat = localStorage.getItem("dateFormat");
                }
                blockUI.stop();
            });
        }

        function updateProfile() {
            setEmail();
            setPhone();
            profileService.updateProfile(vm.profileData);
        }

        function fetchEmail(emails) {
            var email = alasql('select * from ? where IsPrimary = ?', [emails, true]);
            if (email.length > 0) {
                email = email[0].EmailAddress;
            } else {
                email = null;
            }
            return email;
        }

        function fetchPhone(phones) {
            var phone = alasql('select * from ? where IsPrimary = ?', [phones, true]);
            if (phone.length > 0) {
                vm.phoneType = phone[0].PhoneType;
                phone = phone[0].Number;
            } else {
                phone = null;
            }
            return phone;
        }

        function onUploadValidate(fileObj) {
            var ext = utils.getFileExtension(fileObj.name);
            var isValid = true;

            if (ext != '.jpeg' && ext != '.jpg' && ext != '.png' && ext != '.gif') {
                isValid = false;
                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title('Invalid File')
                    .content('Import file only supports *.xls, *.xlsx, *.csv and *.ods file extensions.')
                    .ariaLabel('Invalid File')
                    .ok('Ok')

                $mdDialog.show(notif);
            }

            return isValid;
        }

        function setEmail() {
            var primaryEmails = alasql('select * from ? where IsPrimary = ?', [vm.profileData.Emails, true]);
            if (primaryEmails.length > 0) {
                angular.forEach(vm.profileData.Emails, function(email) {
                    if (email.IsPrimary) {
                        email.EmailAddress = vm.primaryEmail;
                    }
                })
                return;
            }

            var email = {
                IsPrimary: true,
                EmailAddress: vm.primaryEmail
            }

            vm.profileData.Emails.push(email);
        }

        function setPhone() {
            var primaryPhoneNumbers = alasql('select * from ? where IsPrimary = ?', [vm.profileData.Phones, true]);
            if (primaryPhoneNumbers.length > 0) {
                angular.forEach(vm.profileData.Phones, function(phone) {
                    if (phone.IsPrimary) {
                        phone.Number = vm.primaryPhone;
                        phone.PhoneType = {
                            Id: vm.phoneType.Id,
                            TypeName: vm.phoneType.TypeName
                        }
                    }
                })

                return;
            }

            var phone = {
                IsPrimary: true,
                Number: vm.primaryPhone,
                PhoneType: {
                    Id: vm.phoneType.Id,
                    TypeName: vm.phoneType.TypeName
                },
            }

            vm.profileData.Phones.push(phone);
        }

        function updatePassword() {
            passwordService.updatePassword();
        }

        function onUploadStart() {
            vm.showProgress = true;
            contactService.disableSaving = true;
        }

        function onUploadSuccess(url) {
            vm.profileData.ImageUrl = url;
            vm.showProgress = false;
            contactService.disableSaving = false;
        }

        function onUploadError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.messaging')
      .factory('messagingClaimsService', messagingClaimsService);

      /** @ngInject */
      function messagingClaimsService($rootScope, $log, claimsUtilService) {
          var service = {
            isSmsEnabled: false
          };

          activate();

          return service;

          ///////

          function activate() {
              // Triggered by SignalR
              $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                  applyClaimsRules();
              });

              applyClaimsRules();
          }

          function applyClaimsRules() {
              service.isSmsEnabled =  claimsUtilService.isSmsEnabled();
          }
      }
  })();

(function () {
    'use strict';

    angular.module('app.messaging')
        .service('messageStatusService', messageStatusService);

    /** @ngInject */
    function messageStatusService(_, claimsUtilService) {

        var service = {
            getMessageStatuses: getMessageStatuses,
            getStatusColor: getStatusColor,
            getStatusByCssFormat: getStatusByCssFormat,
            toggleStatus: toggleStatus,
            getId: getId,
            getStatusName : getStatusName
        };

        var messageStates = [
            {id: 0, name: 'Notification Not Sent', color: 'notification-not-sent', orderSeq: 1},
            {id: 1, name: 'Queued to Send', color: 'notification-queued', orderSeq: 2},
            {id: 2, name: 'Failed to Send', color: 'notification-failed', orderSeq: 3},
            {id: 3, name: 'Notification Sent (Awaiting Response)', color: 'notification-viewed', orderSeq: 5},
            {id: 4, name: 'Notification Sent (Not Viewed)', color: 'notification-not-viewed', orderSeq: 4},
            {id: 6, name: 'Job Rejected', color: 'notification-rejected', orderSeq: 7},
            {id: 7, name: 'Job Accepted', color: 'notification-accepted', orderSeq: 8},
            {id: 9, name: 'Unavailable', color: 'notification-rejected', orderSeq: 9}
        ];

        if (claimsUtilService.isSmsEnabled()) {
            messageStates.push({id: 5, name: 'SMS Waiting for Reply', color: 'notification-waiting-for-reply', orderSeq: 6});
        }

        activate();

        return service;

        function activate() {
        }

        function getStatusName(id) {
            return _.find(messageStates, function (o) {
                return o.id == id;
            }).name;
        }

        function getMessageStatuses() {
            return angular.copy(messageStates);
        }

        function getStatusColor(id) {
            return _.find(messageStates, function (o) {
                return o.id == id;
            });
        }

        function getStatusByCssFormat(id) {
            return "{'" + getStatusColor(id).color + "': true }";
        }

        function getId(statusText) {
            let messageStatus = _.find(messageStates, function(o) {
                return o.name === statusText;
            });

            return messageStatus.id;
        }

        function toggleStatus(newStatus, obj) {
            obj['isJobAccepted'] = newStatus == 7;
            obj['isJobRejected'] = newStatus == 6;
            obj['smsWaiting'] = newStatus == 5;
            obj['isNotifSentViewed'] = newStatus == 3;;
            obj['isNotifSentNotViewed'] = newStatus == 4;
            obj['isFailedToSend'] = newStatus == 2;
            obj['isSmsQueued'] = (newStatus == 1 || newStatus == 8);
            obj['isNotifNotYetSent'] = newStatus == 0;
            obj['applyAnimation']  = obj['applyAnimation'] ? '' : 'status-show-hide';
        }
    }
})();


(function() {
    'use strict';

    angular.module('app.messaging')
        .service('messageLookupService', messageLookupService);

    /** @ngInject */
    function messageLookupService(
        $q,
        utils,
        termsApi,
        branchApi,
        jobMessagingApi,
        messageStatusService,
        invoiceApi
    ) {
        var service = {
            data: {
                branchLookups: [],
                clientLookups: [],
                termLookups: [],
                emailTypes: [],
                messageStatus: []
            },
            loadBranches: loadBranches,
            loadClients: loadClients,
            loadAll: loadAll,
            findBranches: findBranches,
            findClient: findClient,
            loadTerms: loadTerms,
            isLoaded: false
        };

        activate();

        return service;

        function activate() {}

        function loadAll() {
            if (!service.isLoaded) {

                let promise1 = loadBranches();
                let promise2 = loadClients();
                let promise3 = loadTerms();
                let promise4 = loadEmailTypes();
                let promise5 = loadMessageStatus();

                service.isLoaded = true;
                return $q.all([promise1, promise2, promise3, promise4, promise5]);
            } else {
                return $q.when("Lookup already loaded");
            }
        }

        function loadMessageStatus() {
            service.data.messageStatus.length = 0;
            service.data.messageStatus = angular.copy(messageStatusService.getMessageStatuses());
            return $q.when(messageStatusService.getMessageStatuses());
        }

        function loadEmailTypes() {
            let deferred = $q.defer();

            jobMessagingApi.getEmailTypes()
                .then(function(resp) {
                    service.data.emailTypes.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        service.data.emailTypes.push(itm);
                    }, this);

                    deferred.resolve(service.data.emailTypes);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadBranches() {
            let deferred = $q.defer();

            // Load branches
            branchApi.getBranchesAndStates()
                .then(function(resp) {
                    service.data.branchLookups.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        itm['selected'] = false;
                        itm['IsDivision'] = false;
                        itm.StateBranches = [];
                        if (itm.State == null) {
                            itm.StateBranches = itm.Id.split(',');
                            itm.Id = utils.newGuid();
                        }
                        service.data.branchLookups.push(itm);

                        // Convert division in to branch for presentation only
                        if (itm.Division && itm.Division.length > 0) {
                            angular.forEach(itm.Division, function(division) {
                                let branch = {
                                    Id: division.id,
                                    Name: itm.Name + ' (' + division.Name + ')',
                                    State: itm.State,
                                    Suburb: itm.Suburb,
                                    IsDivision: true
                                };
                                service.data.branchLookups.push(branch);
                            });
                        }
                    }, this);

                    deferred.resolve(service.data.branchLookups);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadTerms() {
            let deferred = $q.defer();

            // Load branches
            termsApi.getTerms()
                .then(function(resp) {
                    service.data.termLookups = resp.data;
                    deferred.resolve(service.data.termLookups);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadClients() {
            let deferred = $q.defer();

            invoiceApi.getClients()
                .then(function(resp) {
                    service.data.clientLookups.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        service.data.clientLookups.push(itm);
                    }, this);

                    deferred.resolve(service.data.clientLookups);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function findBranches(branches) {
            let branchStr = getSelectedBranchesToString(branches);
            let qry = "SELECT * FROM ? WHERE Id IN " + "(?)".replace('?', branchStr);

            let results = alasql(qry, [service.data.branchLookups]);
            return results;
        }

        function getSelectedBranchesToString(branches) {
            let branchStr = '';
            angular.forEach(branches, function(itm) {
                branchStr = branchStr + "'" + itm + "',";
            }, this);

            return branchStr.substring(0, branchStr.length - 1);
        }

        function findClient(clients) {
            let clientStr = getSelectedClientToString(clients);
            let qry = "SELECT * FROM ? WHERE Id IN " + "(?)".replace('?', clientStr);

            let results = alasql(qry, [service.data.clientLookups]);
            return results;
        }

        function getSelectedClientToString(clients) {
            let clientStr = '';
            angular.forEach(clients, function(itm) {
                clientStr = clientStr + "'" + itm + "',";
            }, this);

            return clientStr.substring(0, clientStr.length - 1);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.messaging.job')
        .controller('JobMessagingController', JobMessagingController);

    /** @ngInject */
    function JobMessagingController(
        exceptionService,
        sendJobMessageService,
        notifierService,
        sideNavJobMessagingModel,
        jmVirtualRepeatFixService,
        jobMessagingGridService,
        utils,
        $timeout,
        $scope,
        $mdSidenav,
        $mdDialog,
        messageStatusService,
        jobMessagingParameterService,
        messageLookupService,
        claimsUtilService,
        smartSchedulingService
    ) {
        var vm = this;

        // Data
        vm.checkedItems = [];
        vm.shiftsToAccept = [];
        vm.branchLookups = [];
        vm.clientLookups = [];
        vm.sideNavModel = new sideNavJobMessagingModel();
        vm.dataGrid = jobMessagingGridService;
        vm.jobSenderContentApi = {};
        vm.customGridSearchComponent = {};

        // Methods
        vm.utilService = utils;
        vm.generatePreview = generatePreview;
        vm.checkToggle = checkToggle;
        vm.downloadInvoice = downloadInvoice;
        vm.sendMessage = sendMessage;
        vm.openIssue = openIssue;
        vm.checkSingleItem = checkSingleItem;
        vm.selectViewType = selectViewType;
        vm.sort = sort;
        vm.clearPreview = clearPreview;
        vm.onContextMenuClick = onContextMenuClick;
        vm.toggleSidenav = toggleSidenav;
        vm.acceptShifts = acceptShifts;

        // View type constants (based on viewtype controller located in emailsenderContentView component)
        const ALL_STATUS = -1;

        var currentViewType = ALL_STATUS;
        var signalrUpdater;


        activate();

        //////////
        function activate() {
            populateData();

            //Todo: Remove this code!!!!
            notifierService.subscribe($scope, function commandHandler(e, data) {});

            // Pub/Subs
            signalrUpdater = $scope.$on('urn:updateMessagingStatus', function (e, data) {
                updateStatus(data.AllocatedResourceItemId, data.Status);
            });

            if (jobMessagingParameterService.isPerformReload()) {
                vm.sideNavModel = jobMessagingParameterService.reloadParams();
                generatePreview();
            } else {
                // Default
                vm.sideNavModel.defaultValues();
            }
        }

        function populateData() {
            vm.branchLookups = messageLookupService.data.branchLookups;
            vm.clientLookups = angular.copy(messageLookupService.data.clientLookups);
        }

        function sendMessage() {
            vm.jobSenderContentApi.setBusy(true);
            vm.sideNavModel.setToProcessingState('Sending job notification(s)...', true);

            var ariIds = vm.checkedItems.map(x => x.ariId);
            
            sendJobMessageService.sendMessage(ariIds)
                .then(function (resp) {
                    
                    if(claimsUtilService.isSmartSchedulingEnabled())
                    {
                        let ticketIds = vm.checkedItems.map(x => x.ticketId);
                        smartSchedulingService.confirmPreScheduleJobByTicketIds(ticketIds);
                    }
                    
                    clearCheckedItems();
                    vm.jobSenderContentApi.refresh();

                    // Mark status based on the returned status
                    angular.forEach(resp.data, function (o) {
                        updateStatus(o.Key, o.Value);
                    });

                    vm.jobSenderContentApi.setBusy(false);
                    vm.sideNavModel.disableProcessingState();

                }).catch(function (ex) {
                    vm.jobSenderContentApi.setBusy(false);
                    vm.sideNavModel.disableProcessingState();
                    exceptionService.resolve(ex);
                });
        }

        function onContextMenuClick(contextParam) {
            vm.checkedItems = [{
                ariId: contextParam.ariId
            }];

            sendMessage();
        }

        function acceptShifts(){
            $mdDialog.show({
                templateUrl: 'app/main/messaging/jobMessaging/directives/jobMessagingContent/accept-shifts-dialog.html',
                controller: 'AcceptShiftsDialogController',
                controllerAs: 'vm',
                locals: {
                    shiftsToAcceptCount: vm.shiftsToAccept.length
                },
                multiple: true
            }).then(function (res) {

                if(!res){
                    return;
                }

                vm.jobSenderContentApi.setBusy(true);
                vm.sideNavModel.setToProcessingState('Accepting Shift(s)...', true);

                sendJobMessageService.acceptShifts(vm.shiftsToAccept)
                    .then(function (resp) {
                        clearCheckedItems();
                        generatePreview();

                        vm.jobSenderContentApi.setBusy(false);
                        vm.sideNavModel.disableProcessingState();
                    }).catch(function (ex) {
                        vm.jobSenderContentApi.setBusy(false);
                        vm.sideNavModel.disableProcessingState();
                        exceptionService.resolve(ex);
                    });

            }, function (res) {

            });
        }

        function generatePreview() {
            jmVirtualRepeatFixService.fixBlankSpace();
            $timeout(function () {
                vm.dataGrid.grid.api.clearAll();
                vm.sideNavModel.setToProcessingState('Loading Tickets...', false);
                vm.jobSenderContentApi.refresh();
                vm.jobSenderContentApi.setBusy(true);

                vm.dataGrid.componentEvent = gridComponentEvent;
                vm.dataGrid.setFilterData(vm.sideNavModel.toBackendModel());
                vm.dataGrid.grid.api.refresh();

                // Save parameter
                jobMessagingParameterService.saveParams(vm.sideNavModel);
            });
        }

        function clearPreview() {
            stopGridFetchingData();
        }

        function stopGridFetchingData() {
            vm.dataGrid.grid.api.stop();
            vm.sideNavModel.reset();
            vm.jobSenderContentApi.refresh();
            vm.jobSenderContentApi.setBusy(false);
        }

        /**
         * Toggling of check box ALL
         * @param {*} toggleFlag
         */
        function checkToggle(toggleFlag) {
            var checkedItems = performCheckItems(vm.dataGrid.grid.data, toggleFlag);
            vm.jobSenderContentApi.setNumberOfCheckedItems(checkedItems.checkedItemCount);
            vm.checkedItems = checkedItems.items;
        }

        function checkSingleItem(id) {
            var result = (doCheckSingleItem(id, vm.checkedItems));
            vm.checkedItems = result.itemsChecked;

            return result;
        }

        function clearCheckedItems() {
            vm.checkedItems.length = 0;
            vm.shiftsToAccept.length = 0;
            vm.jobSenderContentApi.setShiftToAccept(vm.shiftsToAccept,false);
        }

        function downloadInvoice() {
            alert('Not supported!');
        }

        function sort(sortDir) {
            // Custom sort
            vm.dataGrid.grid.api.sort('StartDate ' + sortDir + ', Seq asc', null);
            clearCheckedItems();
            vm.jobSenderContentApi.refresh();
        }

        function selectViewType(type) {
            currentViewType = type.selectedStatus;
            vm.dataGrid.setClientSideFilter(currentViewType);
            vm.customGridSearchComponent.forceTriggerSearch();
        }

        /**
         * ==============================
         * Show Issues
         * ==============================
         */

        function openIssue(issues) {
            // return showIssues(issues);
        }



        /**
         * ===================
         * Private Methods
         * ===================
         */
        function gridComponentEvent(eventObj) {
            switch (eventObj.e) {
                case 'loadcompleted':
                    clearCheckedItems();
                    vm.sideNavModel.disableProcessingState();
                    vm.jobSenderContentApi.setBusy(false);
                    break;
                case 'onGridInfoPopulated':
                    vm.jobSenderContentApi.populateGridInfo(eventObj.data);
                    break;
                case 'onSearch':
                    vm.jobSenderContentApi.refresh();
                    break;
            }
        }

        // Note: Put to separate service
        function performCheckItems(gridData, toggleFlag) {
            var checkedItems = [];
            vm.shiftsToAccept = [];

            gridData.forEach(function (gridData) {
                if (gridData.IsHeader) {
                    return;
                }

                if (!gridData.canSendJobNotificationToAtLeastOnePerson) {
                    return;
                }

                gridData.Selected = toggleFlag;
                if (toggleFlag) {
                    gridData.Contacts.forEach(function (contact) {
                        let canSendSms = vm.dataGrid.isSmsEnabled && !contact.HasDevices;
                        let canSendPushNotification = contact.HasPushNotificationToken;

                        if (canSendSms || canSendPushNotification) {
                            checkedItems.push({
                                ticketId: gridData.Id,
                                ariId: contact.Id
                            });
                        }

                        if(contact.isNotifNotYetSent){
                            vm.canAcceptShift = true;
                            vm.shiftsToAccept.push({
                                ticketId: gridData.Id,
                                ariId: contact.Id,
                                contactId: contact.ContactId
                            });
                        }
                    });
                }
            });

            vm.jobSenderContentApi.setShiftToAccept(vm.shiftsToAccept, vm.canAcceptShift);

            return {
                items: checkedItems,
                checkedItemCount: checkedItems.length
            };
        }

        /**
         * Checking of Single item checkbox
         */
        function doCheckSingleItem(id, checkedItems) {
            var chkItems = angular.copy(checkedItems);

            var itemToModify = _.find(vm.dataGrid.grid.data, function (o) {
                return o.Id == id;
            });

            // Remove first existing
            _.remove(chkItems, function (o) {
                return o.ticketId == id;
            });

             _.remove(vm.shiftsToAccept, function (o) {
                return o.ticketId == id;
            });

            if (itemToModify.Selected) {
                itemToModify.Contacts.forEach(function (contact) {
                    let canSendSms = vm.dataGrid.isSmsEnabled && !contact.HasDevices;
                    let canSendPushNotification = contact.HasPushNotificationToken;

                    if (canSendSms || canSendPushNotification) {
                        chkItems.push({
                            ticketId: id,
                            ariId: contact.Id
                        });
                    }

                    if(contact.isNotifNotYetSent){
                        vm.canAcceptShift = true;
                        vm.shiftsToAccept.push({
                            ticketId: id,
                            ariId: contact.Id,
                            contactId: contact.ContactId
                        });
                    }
                });
            }

            vm.jobSenderContentApi.setNumberOfCheckedItems(chkItems.length);
            vm.jobSenderContentApi.setShiftToAccept(vm.shiftsToAccept, vm.canAcceptShift);

            return {
                hasItemsChecked: chkItems.length > 0,
                itemsChecked: chkItems,
                itemsCheckedCount: chkItems.length
            };
        }

        /**
         * SignalR Listening to  status
         */
        function updateStatus(id, status) {
            $timeout(function () {
                vm.dataGrid.grid.api.invokeUpdateState(function (o) {
                    // Find ARI contact by examining the Contacts inside ticket
                    var ids = [];
                    angular.forEach(o.Contacts, function (c) {
                        ids.push(c.Id);
                    });

                    var isIncluded = _.includes(ids, id);
                    return isIncluded;
                }, function (items) {
                    var itm = items[0];
                    var ariContact = _.find(itm.Contacts, function (ci) {
                        return ci.Id == id;
                    });

                    if (ariContact) {
                        // Check if not yet sent and incoming status equals QUEUED to SEND then
                        if (status == 1 && ariContact.StatusCode == 0)
                            ariContact.StatusCode = status;
                        else if (status != 1)
                            ariContact.StatusCode = status;
                    }
                    messageStatusService.toggleStatus(status, ariContact);
                }, true);
            });
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();


(function () {
    'use strict';

    angular.module('app.messaging')
        .factory('messagingService', messagingService);

    /** @ngInject */
    function messagingService($timeout,
                              $q,
                              $mdDialog,
                              utils,
                              mediaQueryService,
                              exceptionService,
                              claimsUtilService,
                              messagingApi,
                              skillLevelApi,
                              companyApi) {

        var service = {
            is_loading : false,
            is_sending : false,
            Employees : [],
            branches : [],
            divisions : [],
            EmploymentStatus : [],
            SkillsLevel : [],
            contacts_ready : [],
            contacts_available : [],
            contactNamesWithoutDevices: [],
            Companies : [],
            Skills : [],
            message : "",
            message_chars_limit : 320,
            rows : 15,
            isSmsEnabled: claimsUtilService.isSmsEnabled(),
            query : null,
            mediaQueryService : mediaQueryService,
            reset : reset,
            send : send,
            getLookups : getLookups,
            onAddPerson : onAddPerson,
            filter : filter,
            searchByTicketNumber : searchByTicketNumber,
            showDialog : showDialog,
            separateSelected : separateSelected,
            onRemovePerson : onRemovePerson,
            addAll : addAll,
            removeAll : removeAll,
            isSendButtonDisabled: isSendButtonDisabled
        };

        return service;

        function filter(params){
            return messagingApi.filter(params);
        }

        function searchByTicketNumber(ticket_no){
            return messagingApi.searchByTicketNumber(ticket_no);
        }

        function reset(){
            service.contacts_ready.length = 0;
            service.contacts_available.length = 0;
            service.contactNamesWithoutDevices.length = 0;
            service.message = "";
        }

        function onRemovePerson(contact){
            if(contact.Selected){
                angular.forEach(service.contacts_ready, function(c, index){
                    if(c.Id == contact.Id){
                        service.contacts_ready.splice(index, 1);
                    }
                });

                angular.forEach(service.contacts_available, function(c){
                    if(c.Id == contact.Id){
                        c.Selected = false;
                    }
                });
            }

            service.contactNamesWithoutDevices = _.map(getContactsWithoutDevices(), 'Name');
        }

        function separateSelected(){
            $timeout(function(){
                angular.forEach(service.contacts_available, function(c){
                    if(_.find(service.contacts_ready, {Id : c.Id})){
                        c['Selected'] = true;
                    }else{
                        c['Selected'] = false;
                    }
                });
            });
        }

        function onAddPerson(contact) {
            var contactExists = _.find(service.contacts_ready, function(c) {
                return contact.Id === c.Id;
            });

            if (!contactExists) {
                contact.Selected = true;
                service.contacts_ready.push(contact);
                service.contacts_ready = _.orderBy(service.contacts_ready,['Name'], ['asc']);
                service.separateSelected();
            }

            service.contactNamesWithoutDevices = _.map(getContactsWithoutDevices(), 'Name');
        }

        function addAll(){
            service.contacts_available.forEach(function(contact){
                onAddPerson(contact);
            });
        }

        // Called by contacts area on the right panel after filtering employees
        function removeAll(){
            service.contacts_ready = [];
            service.contactNamesWithoutDevices = [];
            service.separateSelected();
        }

        function getLookups(){
            service.is_loading = true;
            service.is_sending = true;
            $q.all([messagingApi.getBranches(),
                    skillLevelApi.getSkillsLevel(),
                    companyApi.getCompanies(),
                    messagingApi.getSkills(),
                    messagingApi.getEmployeesAndLabourHire()]).then(function(resp){
                let raw_branches = angular.copy(resp[0].data);
                service.SkillsLevel = resp[1].data;
                service.Companies = resp[2].data;
                service.Skills = resp[3].data;
                service.branches = getBranchesMap(raw_branches);
                service.divisions = getDivisionsMap(raw_branches);
                service.Employees = resp[4].data;
                service.EmploymentStatus = [
                    {
                        Id: 0,
                        Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_NONE")
                    },
                    {
                        Id: 1,
                        Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_CASUAL")
                    },
                    {
                        Id: 2,
                        Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_LABOUR_HIRE")
                    },
                    {
                        Id: 3,
                        Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_PERMANENT_FULL_TIME")
                    },
                    {
                        Id: 4,
                        Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_PERMANENT_PART_TIME")
                    },
                    {
                        Id: 5,
                        Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_SALARY")
                    }
                ];
                $timeout(function(){
                    service.is_loading = false;
                    service.is_sending = false;
                })
            }).catch(function(err){
                exceptionService.resolve(err);
                service.is_loading = false;
                service.is_sending = false;
            });
        }

        function getBranchesMap(branches){
            return branches.map(function(branch){
                return {
                    Id : branch.Id,
                    Name : branch.Name
                }
            });
        }

        function getDivisionsMap(branches){
            let divisions = [];
            branches.forEach(function(branch){
                branch.Division.forEach(function(division){
                    divisions.push({
                        Id : division.id,
                        Name : division.Name,
                        BranchId : branch.Id,
                        BranchName : branch.Name
                    })
                });
            });
            return divisions;
        }

        function send(){
            service.is_sending = true;
            let title = utils.translate("MESSAGING.TITLE");
            let message = utils.translate("MESSAGING.MESSAGE_SENT");
            let close_button = utils.translate("MESSAGING.CLOSE");

            let params = {
                Message : service.message,
                ContactIds : service.contacts_ready.map(function(contact){
                    return contact.Id;
                })
            }

            messagingApi.send(params).then(function(){
                service.message = null;
                service.contacts_ready = [];
                service.contactNamesWithoutDevices = [];
                service.contacts_available = [];
                service.is_sending = false;
                service.showDialog(title, message, close_button)
            }).catch(function(err){
                service.is_sending = false;
                exceptionService.resolve(err);
            });
        }

        function showDialog(title, message, button_message){
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .multiple(true)
                    .textContent(message)
                    .ariaLabel(title)
                    .ok(button_message)
            );
        }

        function isSendButtonDisabled() {
            return service.message.length === 0 || service.contacts_ready.length === 0 ||
                (!service.isSmsEnabled && service.contactNamesWithoutDevices.length === service.contacts_ready.length);
        }

        function getContactsWithoutDevices() {
            return _.filter(service.contacts_ready, function(c) {
                return c.HasDevices == false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.messaging')
        .service('messagingModel', messagingModel);

    function messagingModel() {
        return function (options) {
            var self = this;

            var defaults = {

            };

            self.map = mapper;
            self.transformToModel = transformToModel;
            self.reset = reset;

            self.map(options);

            function mapper(opts) {
                var mapValue = opts || {}
                    , opts = angular.extend(this, defaults, mapValue);
            }

            function reset() {

            }

            function transformToModel() {
                var serverModel = {
                }
                return serverModel;
            }

        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.messaging')
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.generalMessaging', {
            url: '/messaging/general'
            , views: {
                    'content@app': {
                    templateUrl: 'app/main/messaging/generalMessaging/messaging.html'
                    , controller: 'messagingController as vm'
                }
            },
            title: 'Send A Message',
            titleBar: 'Alloc8 - Send A Message',
            data: {
                requireLogin: true
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/messaging/generalMessaging');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.messaging')
        .controller('messagingController', messagingController);

    function messagingController(messagingService, mediaQueryService) {

        var vm = this;

        vm.service = messagingService;
        vm.mediaService = mediaQueryService;

        vm.activate = activate;
        vm.reset = reset;

        function activate(){
            vm.reset();
            vm.service.getLookups();
        }

        function reset(){
            vm.service.contacts_ready.length = 0;
            vm.service.contacts_available.length = 0;
            vm.service.contactNamesWithoutDevices.length = 0;
        }

        vm.activate();
    }
})();

{
    angular.module('app.messaging')
        .factory('messagingApi', messagingApi);

    /** @ngInject */
    function messagingApi(
        $http,
        tenantSettings
    ) {
        let branch_api = tenantSettings.coreApiUrl + "/api/branches";
        let messaging_api = tenantSettings.coreApiUrl + "/api/generalmessaging/";

        return {
            getBranches: getBranches,
            getEmployeesAndLabourHire: getEmployeesAndLabourHire,
            filter: filter,
            searchByTicketNumber: searchByTicketNumber,
            send: send,
            getSkills: getSkills,
            getCompanies: getCompanies
        };

        function getBranches() {
            return $http.get(branch_api);
        }

        function getCompanies(payLoad, BranchId) {
            return $http.post(tenantSettings.coreApiUrl + "/api/companies/search/" + BranchId, payLoad);
        }

        function getEmployeesAndLabourHire() {
            return $http.get(messaging_api + "lookup/employees");
        }

        function filter(param_obj) {
            return $http.post(messaging_api + (param_obj.FilterByTicket ? "get/ticket" : "get/filter"), param_obj.Data);
        }

        function searchByTicketNumber(ticket_no) {
            return $http.get(messaging_api + "lookup/ticket/" + ticket_no);
        }

        function send(params) {
            return $http.post(messaging_api + "send", params);
        }

        function getSkills() {
            return $http.get(tenantSettings.coreApiUrl + 'api/Skills');
        }
    }
}

(function() {
    "use strict";

    angular
        .module("app.lockout-settings.view")
        .factory("lockoutSettingsService", lockoutSettingsService);

    /** @ngInject */
    function lockoutSettingsService(
        utils,
        ruleModelComponent,
        lookupApi,
        $mdDialog,
        mediaQueryService,
        lockoutRulesApi,
        claimsUtilService,
        $q
    ) {
        var service = {
            loader: false,
            loaderMessage: null,
            rules: [],
            editMode: false,
            shiftTypes: [],
            selectedRule: null,
            isDeviceXS: mediaQueryService.isDeviceXS,
            isDeviceSM: mediaQueryService.isDeviceSM,
            isDeviceMD: mediaQueryService.isDeviceMD,
            isDeviceLG: mediaQueryService.isDeviceLG,
            isDeviceXL: mediaQueryService.isDeviceXL,
            isDeviceBig: mediaQueryService.isDeviceBig,
            isDeviceSmall: mediaQueryService.isDeviceSmall,
            saving: false,
            select: select,
            setLoader: setLoader,
            resetLoader: resetLoader,
            save: save,
            cancel: cancel,
            remove: remove,
            load: load,
            step: 0.5,
            getMaxValueForStandardShiftGap: getMaxValueForStandardShiftGap,
            getMinValueForOverrideShiftGap: getMinValueForOverrideShiftGap,
            getMaxValueForOverrideShiftGap: getMaxValueForOverrideShiftGap,
            updateLockoutSettings: updateLockoutSettings
        };

        function load() {
            service.shiftTypes = [];
            service.rules = [];
            service.selectedRule = null;

            service.setLoader(
                utils.translate("LOCKOUTSETTINGS.VIEW_LOADING_DATA")
            );

            $q.all([
                lockoutRulesApi.getRules(),
                lookupApi.getMinifiedPeopleTypes(),
            ]).then(function(resp) {
                service.rules = angular.copy(resp[0].data);
                service.shiftTypes = resp[1].data;
                service.resetLoader();
            });
        }

        function resetLoader() {
            service.loader = false;
            service.loaderMessage = null;
        }

        function setLoader(message) {
            service.loader = true;
            service.loaderMessage = message;
        }

        function save() {
            service.saving = true;
            service.selectedRule = cleanData(service.selectedRule);
            service.setLoader(utils.translate("LOCKOUTSETTINGS.SAVING"));

            if (service.editMode) {
                lockoutRulesApi
                    .editRule(service.selectedRule)
                    .then(function() {
                        service.resetLoader();
                        service.saving = false;
                        service.load();
                        service.editMode = false;
                        service.selectedRule = null;
                    });

                return;
            }

            lockoutRulesApi.addRule(service.selectedRule).then(function() {
                service.resetLoader();
                service.saving = false;
                service.load();
                service.editMode = false;
                service.selectedRule = null;
            });
        }

        function cancel() {
            service.selectedRule = null;
        }

        function cleanData(data) {
            data.ShiftTypes = cleanShiftTye(data.ShiftTypes);

            data.StandardSettings.MaxShiftLength = parseFloat(data.StandardSettings.MaxShiftLength);
            data.StandardSettings.MaxHoursIn24HourPeriod = parseFloat(data.StandardSettings.MaxHoursIn24HourPeriod);
            data.StandardSettings.MaxHoursIn7DayPeriod = parseFloat(data.StandardSettings.MaxHoursIn7DayPeriod);
            data.StandardSettings.BreakHoursBetweenToReset = parseFloat(data.StandardSettings.BreakHoursBetweenToReset);
            data.StandardSettings.MinBreakHoursBetweenShifts = parseFloat(data.StandardSettings.MinBreakHoursBetweenShifts);
            data.StandardSettings.MaxContinuousShiftGap = parseFloat(data.StandardSettings.MaxContinuousShiftGap);


            data.StandardSettings.WarningMaxShiftLength = parseFloat(data.StandardSettings.WarningMaxShiftLength);
            data.StandardSettings.WarningMaxHoursIn24HourPeriod = parseFloat(data.StandardSettings.WarningMaxHoursIn24HourPeriod);
            data.StandardSettings.WarningMaxHoursIn7DayPeriod = parseFloat(data.StandardSettings.WarningMaxHoursIn7DayPeriod);

            data.OverrideSettings.MaxShiftLength = parseFloat(data.OverrideSettings.MaxShiftLength);
            data.OverrideSettings.MaxHoursIn24HourPeriod = parseFloat(data.OverrideSettings.MaxHoursIn24HourPeriod);
            data.OverrideSettings.MaxHoursIn7DayPeriod = parseFloat(data.OverrideSettings.MaxHoursIn7DayPeriod);
            data.OverrideSettings.MinBreakHoursBetweenShifts = parseFloat(data.OverrideSettings.MinBreakHoursBetweenShifts);
            data.OverrideSettings.MaxContinuousShiftGap = parseFloat(data.OverrideSettings.MaxContinuousShiftGap);

            return data;
        }

        function cleanShiftTye(shifts) {
            let shift_types = [];

            angular.forEach(shifts, function(type) {
                shift_types.push(type.Id);
            });

            return shift_types;
        }

        function constructShiftTypes(shifts) {
            let shift_types = [];

            angular.forEach(shifts, function(shift) {
                let type = _.find(service.shiftTypes, {
                    Id: shift,
                });

                if (!_.isNil(type)) {
                    shift_types.push(type);
                }
            });

            return shift_types;
        }

        function remove() {
            let confirm = $mdDialog
                .confirm()
                .title(utils.translate("LOCKOUTSETTINGS.DELETE_TITLE"))
                .textContent(utils.translate("LOCKOUTSETTINGS.DELETE_CONTENT"))
                .ok(utils.translate("LOCKOUTSETTINGS.DELETE_YES"))
                .cancel(utils.translate("LOCKOUTSETTINGS.DELETE_CANCEL"));

            $mdDialog.show(confirm).then(function() {
                service.saving = true;
                service.setLoader(utils.translate("LOCKOUTSETTINGS.DELETING"));
                lockoutRulesApi
                    .deleteRule(service.selectedRule.Id)
                    .then(function() {
                        service.resetLoader();
                        service.saving = false;
                        service.load();
                        service.editMode = false;
                        service.selectedRule = null;
                    });
            });
        }

        function select(isEdit, rule) {
            service.selectedRule = null;
            service.editMode = isEdit;

            if (isEdit) {
                service.selectedRule = angular.copy(rule);
                service.selectedRule.ShiftTypes = constructShiftTypes(service.selectedRule.ShiftTypes);

                service.selectedRule.StandardSettings.MaxShiftLength = parseFloat(service.selectedRule.StandardSettings.MaxShiftLength);
                service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod = parseFloat(service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod);
                service.selectedRule.StandardSettings.MaxHoursIn7DayPeriod = parseFloat(service.selectedRule.StandardSettings.MaxHoursIn7DayPeriod);
                service.selectedRule.StandardSettings.BreakHoursBetweenToReset = parseFloat(service.selectedRule.StandardSettings.BreakHoursBetweenToReset);
                service.selectedRule.StandardSettings.MinBreakHoursBetweenShifts = parseFloat(service.selectedRule.StandardSettings.MinBreakHoursBetweenShifts);
                service.selectedRule.StandardSettings.MaxContinuousShiftGap = parseFloat(service.selectedRule.StandardSettings.MaxContinuousShiftGap);

                service.selectedRule.StandardSettings.WarningMaxShiftLength = parseFloat(service.selectedRule.StandardSettings.WarningMaxShiftLength);
                service.selectedRule.StandardSettings.WarningMaxHoursIn24HourPeriod = parseFloat(service.selectedRule.StandardSettings.WarningMaxHoursIn24HourPeriod);
                service.selectedRule.StandardSettings.WarningMaxHoursIn7DayPeriod = parseFloat(service.selectedRule.StandardSettings.WarningMaxHoursIn7DayPeriod);

                service.selectedRule.OverrideSettings.MaxShiftLength = parseFloat(service.selectedRule.OverrideSettings.MaxShiftLength);
                service.selectedRule.OverrideSettings.MaxHoursIn24HourPeriod = parseFloat(service.selectedRule.OverrideSettings.MaxHoursIn24HourPeriod);
                service.selectedRule.OverrideSettings.MaxHoursIn7DayPeriod = parseFloat(service.selectedRule.OverrideSettings.MaxHoursIn7DayPeriod);
                service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts = parseFloat(service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts);
                service.selectedRule.OverrideSettings.MaxContinuousShiftGap = parseFloat(service.selectedRule.OverrideSettings.MaxContinuousShiftGap);

                service.shopTimeOrLoadTimeEnabled = claimsUtilService.isShopTimeEnabled() || claimsUtilService.isLoadTimeEnabled();
                return;
            }

            service.selectedRule = angular.copy(ruleModelComponent);
            service.selectedRule.Name = utils.translate("LOCKOUTSETTINGS.VIEW_NEW_RULE_NAME");
        }

        function getMaxValueForStandardShiftGap() {
            return service.selectedRule.StandardSettings.MinBreakHoursBetweenShifts ? service.selectedRule.StandardSettings.MinBreakHoursBetweenShifts : 24;
        }
        function getMinValueForOverrideShiftGap() {
            if (service.selectedRule.StandardSettings.MaxContinuousShiftGap >= service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts){
                return service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts;
            }
            else {
                return service.selectedRule.StandardSettings.MaxContinuousShiftGap;
            }
        }
        function getMaxValueForOverrideShiftGap() {
            if (service.selectedRule.StandardSettings.MaxContinuousShiftGap >= service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts) {
                return service.selectedRule.StandardSettings.MaxContinuousShiftGap;
            }
            else {
                return service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts;
            }
        }

        

        function updateLockoutSettings(enabledFeatures){
            var shopOrLoad = ["EnableLoadTimeInTimesheets", "EnableShopTimeInTimesheets"];

            if (enabledFeatures.some(enabledFeature => shopOrLoad.some(sl => sl == enabledFeature))) {

                lockoutRulesApi.getRules().then(lockoutSettings => {

                    lockoutSettings.data.map(c => {
                        c.CountTravelHours = true;
                        lockoutRulesApi.editRule(c);
                    });

                });

            }
        }

        return service;
    }
})();

(function () {
  'use strict';

  angular
    .module('app.lockout-settings.view')
    .controller('LockoutSettingsViewController', LockoutSettingsViewController);

  function LockoutSettingsViewController(lockoutSettingsService, mediaQueryService) {
    var vm = this;
    vm.service = lockoutSettingsService;
    vm.mediaQueryService = mediaQueryService;
    vm.showList = showList;
    vm.showDetails = showDetails;

    function activate(){
      vm.service.rules = [];
      vm.service.selectedRule = null;
      vm.service.load();
    }

    function showList(){
      return !!vm.service.isDeviceBig()|| null==vm.service.selectedRule
    }

    function showDetails(){
      return !!vm.service.isDeviceBig()|| null!=vm.service.selectedRule
    }

    activate();
  }

})();

(function() {
    'use strict';

    angular
        .module('app.jobs.view')
        .controller('JobsViewController', JobsViewController);

    /** @ngInject */
    function JobsViewController(
        $scope,
        $rootScope,
        jobsViewService,
        historyLogService,
        utils,
        searchDelay,
        msgboxService,
        $state,
        jobService,
        DialogService,
        TimeLibrary,
        auditApi,
        blockUI,
        ticketsApi,
        timesheetApi,
        exceptionService,
        whiteboardClaimsService,
        claimsUtilService,
        jobsClaimsService,
        ticketPdfService,
        $mdDialog,
        JobTagsSignalRService,
        CardFilters,
        ticketStatus
    ) {
        var vm = this;
        vm.service = jobsViewService;
        vm.dateFormat = utils.setDateFormat();
        vm.cardFilters = CardFilters;
        vm.ticketStatus = [];
        vm.delay = {
            debounce: searchDelay
        }
        
        vm.menuItems = [{
                name: 'Add Related Item',
                icon: 'icon-plus',
                show: true
            },
            {
                name: 'Related Ticket Billing Preferences',
                icon: 'icon-credit-card-multiple',
                show: true,
                disabled: whiteboardClaimsService.disableBillingPref,
                hidden: function() {
                    return !claimsUtilService.isBillingEnabled();
                }
            },
            {
                name: 'Download Ticket PDF',
                icon: 'icon-file-pdf-box',
                show: true
            },
            {
                name: 'Download Timesheet PDF',
                icon: 'icon-calendar',
                show: true,
                hidden: function() {
                    return !claimsUtilService.isMobileAppEnabled();
                }
            },
            {
                name: 'Download Paperwork PDF',
                icon: 'icon-file-document',
                show: true,
                hidden: function() {
                    return !claimsUtilService.isMobileAppEnabled();
                }
            }
        ];
        vm.selectedItem = null;
        vm.searchText = null;
        vm.activate = activate;
        vm.fetchDate = fetchDate;
        vm.edit = edit;
        vm.clone = clone;
        vm.cancelTicket = cancelTicket;
        vm.getTicketPDF = getTicketPDF;
        vm.viewHistory = viewHistory;
        vm.showTicketInfo = showTicketInfo;
        vm.menuItemClick = menuItemClick;
        vm.openMenu = openMenu;
        vm.getMenuItems = getMenuItems;
        vm.claimsUtilService = claimsUtilService;
        vm.jobsClaims = jobsClaimsService;
        vm.getTicketGridData = getTicketGridData;
        vm.toggleViewFilters = toggleViewFilters;
        vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
        vm.isCustomFormsEnabled = claimsUtilService.isCustomFormsEnabled();
        vm.viewFilters = false;
        vm.isTicketLockedByPreSchedule = isTicketLockedByPreSchedule;
        vm.isButtonDisabled = isButtonDisabled;
        vm.isPendingApproval = isPendingApproval;

        function activate() {
            vm.ticketTypesLookUp = jobService.getTicketType();

            CardFilters.loadLookups(true);
            vm.ticketStatus = CardFilters.ticketStatus.filter((e) => e.show);
            $scope.$on('$destroy', function() {
                jobsViewService.cleanup();
            });

            JobTagsSignalRService.register();
        }

        $rootScope.$on('refreshTagLookup', function(ev, tag) {
            if (tag && !vm.service.tags.some(f => f.Id === tag.id)) {
     
                vm.service.tags.push({
                    Id: tag.id,
                    Name: tag.Name,
                    IsActive: tag.IsActive,
                    NumberOfUsages: 0,
                    selected: false
                });
                vm.service.tags = _.orderBy(vm.service.tags, ['Name'], ['asc']);
            }
        });

        function isPendingApproval(ticket)
        {
            return ticket.Status == ticketStatus.PENDING_UPLOADS || ticket.Status == ticketStatus.PENDING_CLIENT_CONFIRMATION;
        }

        function getMenuItems(job_type, hasGeneratedPaperworkPdf) {
            vm.menuItems.forEach(function(menu) {
                if (job_type != "Equipment Only" && menu.name == "Related Ticket Billing Preferences") {
                    menu.show = false;
                } else {
                    menu.show = true;
                }
                if (menu.name == "Download Timesheet PDF" || menu.name == "Download Paperwork PDF") {
                    menu.disabled = !hasGeneratedPaperworkPdf;
                }
            });

            return vm.menuItems;
        }

        async function viewHistory(ticket, id) {
            var resp = await auditApi.getAuditEntries(id);
            historyLogService.showHistory("Ticket", resp.data, "#" + ticket);
        }

        function isTicketLockedByPreSchedule(ticket)
        {
            return ticket.IsLockedByPreSchedule && claimsUtilService.isSmartSchedulingEnabled();
        }

        function fetchDate(ticketStartDate) {
            let formatted_date = moment(ticketStartDate).format(vm.dateFormat);
            let formatted_time = TimeLibrary.convertTime(moment(ticketStartDate).format("HH:mm"));
            return formatted_date + " - " + formatted_time;
        }

        function edit(ticket) {
            blockUI.start({
                message: 'Loading Ticket...'
            });

            $state.go('app.jobs_update', {
                id: ticket.Id,
                ticketNumber: ticket.TicketNumber,
                isLocked: ticket.IsLocked === false ? ticket.IsCancelled : ticket.IsLocked
            });
        }

        function clone(ticket) {
            blockUI.start({
                message: 'Checking related ticket...'
            });

            ticketsApi.getRelatedTicket(ticket.Id).then(function(resp) {
                blockUI.stop();
                var related = {
                    ticketId: resp.data.Id,
                    ticketNumber: resp.data.TicketNumber
                };
                $state.go('app.jobs_clone', {
                    cloneId: ticket.Id,
                    related: related
                });
            }).catch(function(ex) {
                blockUI.stop();
                exceptionService.resolve(ex);
            });
        }

        async function cancelTicket(ticket) {

            const hasExportedTimesheets = (await timesheetApi.checkIfTimesheetExported(ticket.Id)).data;

            if (hasExportedTimesheets) {
                msgboxService.alert(
                    utils.translate('SB.CANCEL_TICKET_TITLE'),
                    utils.translate('SB.CANCEL_TICKET_MESSAGE'),
                    utils.translate('SB.CANCEL_TICKET_OKAY'));
                return;
            } else {
                let dialog = jobService.showCancelTicketDialog(ticket);
                $mdDialog.show(dialog).then(function(res) {
                    if (res) {
                        blockUI.start('Cancelling Ticket...')

                        jobService.cancelTicket(ticket.Id, res.reason, res.chargeMinHours).then(function() {
                            blockUI.stop();
                            vm.service.grid.behavior.refresh();
                        }).catch(function(error) {
                            blockUI.stop();
                            msgboxService.alert("Cancel Job", error.data.Message, "Okay");
                        });
                    }
                });
            }
        }

        function getTicketPDF(id) {
            jobService.getTicketPDF(id);
        }

        function showTicketInfo(ticketId) {
            DialogService.openTicketDetailDialog(ticketId, false, true);
        }

        function menuItemClick(index, ticketId, dt, ticketNo) {
            switch (index) {
                case 0:
                    addRelatedTicket(ticketId);
                    break;
                case 1:
                    vm.service.goToRelatedTicketBilling(ticketId, dt);
                    break;
                case 2:
                    ticketPdfService.getTicketPDF(ticketId, ticketNo);
                    break;
                case 3:
                    ticketPdfService.getTimesheetPDF(ticketId, ticketNo);
                    break;
                case 4:
                    ticketPdfService.getPaperworkPDF(ticketId, ticketNo);
                    break;
            }
        }

        function addRelatedTicket(ticketId) {
            blockUI.start({
                message: 'Checking related ticket...'
            });
            ticketsApi.getRelatedTicket(ticketId)
                .then(function(resp) {
                    blockUI.stop();
                    var related = {
                        ticketId: resp.data.Id,
                        ticketNumber: resp.data.TicketNumber
                    };
                    $state.go('app.jobs_manage', {
                        related: related
                    });
                }).catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function openMenu($mdMenu, ev) {
            $mdMenu.open(ev);
        }

        function toggleViewFilters() {
            vm.viewFilters = !vm.viewFilters;
        }

        function getTicketGridData() {
            if (jobsViewService.grid.data) {
                return jobsViewService.grid.data.map((ticket) => {
                    ticket.TagsForView = ticket.Tags ? Array.from(ticket.Tags).join(', ') : '';
                    ticket.StartDateForView = fetchDate(ticket.StartDate);
                    ticket.ConfirmedForView = ticket.IsUnconfirmedDate === true ? 'No' : 'Yes';
                    return ticket;
                });
            }

            return jobsViewService.grid.data;
        }

        function isButtonDisabled(item, ticket)
        {
            if (vm.isPendingApproval(ticket)) {
                if (item.name == "Related Ticket Billing Preferences" ||
                    item.name == "Add Related Item"
                ) {
                    return true;
                }
            }

            return item.disabled;
        }

        vm.activate();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs.timesheet')
        .controller('TimesheetController', TimesheetController);

    /** @ngInject */
    function TimesheetController(timeSheetService,
        DialogService,
        claimsUtilService,
        TimeLibrary,
        ticketPdfService,
        exceptionService,
        jobService,
        $state,
        _,
        $stateParams,
        tenantSettings,
        $mdDialog,
        localisationService,
        ticketType) {

        const KILOMETERS = "Kilometers";
        const KM = "km";
        const MI = "mi.";

        var vm = this;
        vm.service = timeSheetService;
        vm.showTicketDetails = showTicketDetails;
        vm.activate = activate;
        vm.edit = edit;
        vm.convertTime = convertTime;
        vm.canUnlockTimesheet = claimsUtilService.checkAccessByRole("Unlock Timesheets");
        vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
        vm.isCustomFormsEnabled = claimsUtilService.isCustomFormsEnabled();
        vm.measurementForDistance = tenantSettings.measurementForDistance;
        vm.enableContactlessSignature = tenantSettings.enabledFeatures.includes("EnableContactlessSignature");
        vm.localSettings = localisationService.getLocaleFormatSettings();
        vm.applyPinAddress = applyPinAddress;
        vm.claimsUtilService = claimsUtilService;
        vm.checkIfTicketTypeIsTravelOnly = checkIfTicketTypeIsTravelOnly;
        vm.chargeableTravelAllowed = claimsUtilService.checkAccessByRole("Manage Chargeable Travel in Timesheets");

        function edit() {
            if (vm.service.timeSheet)
                $state.go('app.jobs_update', {
                    id: vm.service.timeSheet.TicketId,
                    ticketNumber: vm.service.timeSheet.TicketNumber,
                    isLocked: vm.service.isLocked
                });
            else
                $state.go('app.jobs_update', {
                    id: $stateParams.id,
                    ticketNumber: $stateParams.TicketNo,
                    isLocked: $stateParams.isLocked
                });
        }

        function activate() {
            vm.service.getTimesheet($stateParams.id);
            vm.service.isLocked = $stateParams.isLocked === "true" ? true : false;
            vm.measurementForDistance = vm.measurementForDistance  != null ? (tenantSettings.measurementForDistance == KILOMETERS ? KM : MI) : KM;
        }

        function showTicketDetails() {
            DialogService.openTicketDetailDialog(vm.service.ticketId, false, true);
        }

        function convertTime(time) {
            if (!_.isNil(time)) {
                let converted_time = moment(time).format("HH:mm");
                return TimeLibrary.convertTime(converted_time);
            }
        }

        function applyPinAddress() {
            var dialog = {
                templateUrl: 'app/shared/widgets/singleAddress/job-latitude-longitude-dialog.html',
                controller: 'jobLatitudeLongitudeDialogController as vm',
                jobCoordinates: {
                    Latitude: vm.service.jobLatitude,
                    Longitude: vm.service.jobLongitude
                },
                editMode: true
              }
              return $mdDialog.show(dialog);
        }

        vm.goToAllocateResource = function () {
            $state.go('app.allocate', {
                id: $stateParams.id || jobService.jobModel.id,
                ticketNo: $stateParams.ticketNumber || jobService.jobModel.TicketNumber,
            });
        }

        vm.goToFormsAndAttachment = function () {
            $state.go('app.formsattachments', {
                TicketId: $stateParams.id,
                TicketNo: $stateParams.TicketNo
            });
        };

        vm.downloadTimesheetPdf = function () {
            ticketPdfService
                .getTimesheetPDF($stateParams.id, $stateParams.TicketNo)
                .catch(function (err) {
                    exceptionService.resolve(err);
                });
        };

        vm.showClientConfirmation = function () {
            return (vm.service.isClientOnSite && !_.isNil(vm.service.clientSignatureImageUrl) && vm.service.clientSignatureImageUrl !== "")
                && ((!_.isNil(vm.service.operatorComments) && vm.service.operatorComments !== "")
                    || (!_.isNil(vm.service.timeSheet)
                        && !_.isEmpty(_.filter(vm.service.timeSheet.TicketTimesheetsDetails, function (itm) { return !_.isEmpty(itm.validationMessages); }))
                    )
                );
        };

        
        function checkIfTicketTypeIsTravelOnly() {
        return vm.service.ticketType === ticketType.TRAVEL_ONLY;
        }

        vm.activate();
    }
})();

(function () {
  'use strict';

  angular
    .module('app.jobs.ticketBilling')
    .controller('TicketBillingController', TicketBillingController);

  /** @ngInject */
  function TicketBillingController(ticketBillingService, invoiceUtilsService) {

    var vm = this;
    vm.service = ticketBillingService;

    function activate(){
      vm.service.branches = [];
      vm.service.loading = false;
      vm.service.tickets = [];
      vm.service.clients = [];
      vm.service.billingPeriods = [];
      vm.service.groupedTickets = [];
      vm.service.selectedItem = null;
      vm.service.searchText = null;
      vm.service.params = {
        BranchId : null,
        CompanyId : null,
        StartDate : invoiceUtilsService.getStartOfWeek(new Date(), true),
        EndDate: invoiceUtilsService.getEndOfWeek(new Date(), true)
      },
      vm.service.loadLookups();
    }

    activate();
  }
})();

(function() {
    angular.module('app.jobs')
        .factory('translationService', translationService);

    function translationService($translate, $state) {
        var service = {
            orderby: "",
            jobdetails: "",
            resources: "",
            formsAndAttachments: "",
            translate: translate,
            title: ""
        };

        return service;

        function translate() {
            $translate(['MANAGE.ORDERBY', 'MANAGE.JOBDETAILS', 'MANAGE.RESOURCES', 'MANAGE.CREATEJOB', 'WIDGETS_LOC.FORMS_AND_ATTACHMENTS']).then(function(translations) {
                service.orderby = translations['MANAGE.ORDERBY'];
                service.jobdetails = translations['MANAGE.JOBDETAILS'];
                service.resources = translations['MANAGE.RESOURCES'];
                service.title = translations['MANAGE.CREATEJOB'];
                service.formsAndAttachments = translations['WIDGETS_LOC.FORMS_AND_ATTACHMENTS'];
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.resourceSearchFilter', []);
})();

(function() {
    'use strict';

    angular.module('app.resourceSearchFilter')
        .factory('resourceSearchFilterService', resourceSearchFilterService);

    function resourceSearchFilterService() {
        return {
            filterBySearchText: filterBySearchText
        };

        function filterBySearchText(list, searchText) {
            if (!searchText || searchText.trim() === '') {
                return list;
            }

            const searchLower = searchText.toLowerCase().trim();

            return list.filter(resource => {
                // Match against Name (primary search field)
                if (resource.Name && resource.Name.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against EmployeeCode
                if (resource.EmployeeCode && resource.EmployeeCode.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against UniqueItemId (e.g., employee ID, equipment ID)
                if (resource.UniqueItemId && resource.UniqueItemId.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against Code (equipment ID)
                if (resource.Code && resource.Code.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against Suburb
                if (resource.Suburb && resource.Suburb.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against ResourceNotes
                if (resource.ResourceNotes && resource.ResourceNotes.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against OperatorName (for equipment)
                if (resource.OperatorName && resource.OperatorName.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against SkillNames
                if (resource.SkillNames && resource.SkillNames.some(skill => skill.toLowerCase().includes(searchLower))) {
                    return true;
                }
                // Match against AllocationIssues messages
                if (resource.AllocationIssues && resource.AllocationIssues.some(issue => issue.Message && issue.Message.toLowerCase().includes(searchLower))) {
                    return true;
                }
                // Match against EmploymentStatus
                if (resource.EmploymentStatus && resource.EmploymentStatus.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against LockoutMessage
                if (resource.LockoutMessage && resource.LockoutMessage.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against LastShift
                if (resource.LastShift && resource.LastShift.toLowerCase().includes(searchLower)) {
                    return true;
                }
                // Match against NextShift
                if (resource.NextShift && resource.NextShift.toLowerCase().includes(searchLower)) {
                    return true;
                }
                return false;
            });
        }
    }
})();

(function () {
    'use strict';
  
    angular.module('app.jobs')
      .factory('jobsClaimsService', jobsClaimsService);
      
      /** @ngInject */
      function jobsClaimsService($rootScope, $log, identityService, claimsUtilService) {
          var service = {
            hasTicketBillingPreferenceMenu: false,
            hasManagePaperworkMenu: false
          };

          Object.defineProperty(service, 'hasCloneJobsPermission', {
              enumerable: true,
              get: function() {
                  return !claimsUtilService.isCloneJobsUserAccessEnabled() ||
                         claimsUtilService.checkAccessByRole('CloneJobs');
              }
          });

          activate();
          
          return service;
          
          /////// 
          
          function activate() {
              // Triggered by SignalR
              $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                  applyClaimsRules();
              });
  
              applyClaimsRules();   
          }
  
          function applyClaimsRules() {
              if (claimsUtilService.isBillingEnabled()) {
                service.hasTicketBillingPreferenceMenu =  claimsUtilService.checkAccessByRole('Ticket Billing Preferences');
              }
              service.hasManagePaperworkMenu = claimsUtilService.isDocumentManagementEnabled() || claimsUtilService.isCustomFormsEnabled();
          }
       
      }
  })();
(function () {
	'use strict';
	
    angular.module('app.jobs')
		.service('JobTagsSignalRService', JobTagsSignalRService);

	/** @ngInject */
	function JobTagsSignalRService (signalRService,
		$rootScope) {

        var isInitialized = false;

		function register () {

			if (signalRService.isConnected) {
				regs();
			} else {
				$rootScope.$on('signalR_OnConnected', function () {
					if (!isInitialized) {
						regs();
						isInitialized = true;
					}
				});
			}

			function regs () {
				signalRService.messageHub.on('refreshTagLookup', function (data) {
					$rootScope.$broadcast('refreshTagLookup', data);
				});
			}
		}

		var service = {
			register: register
		};

		return service;
	}

})();

(function () {
    'use strict';

    angular.module('app.jobs')
        .factory('jobTagService', jobTagService);

    /** @ngInject */
    function jobTagService($injector,
        $rootScope,
        blockUI,
        exceptionService,
        tagsApi,
        jobsApi,
        JobTagsSignalRService
    ) {

        var service = {
            tagsLookup: [],
            ticketTags: [],
            getTicketTags: getTicketTags,
            getTagsByJobId: getTagsByJobId,
            pushTagToArrayModel: pushTagToArrayModel
        };

        $rootScope.$on('refreshTagLookup', function(ev, tag) {
            if (tag) {
                if (tag.IsActive) {
                    pushTagToArrayModel({
                        Id: tag.id,
                        Name: tag.Name,
                        IsActive: tag.IsActive
                    }, service.tagsLookup);
                } else {
                    service.tagsLookup = _.filter(service.tagsLookup, function(f) {
                        return f.Id !== tag.id;
                    });
                }
            }
        });

        JobTagsSignalRService.register();

        return service;

        function getTagsByJobId(jobId) {
            return jobsApi.getTagsByJobId(jobId)
                .then(function (resp) {
                    service.ticketTags = resp.data;
                }).catch(function (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getTicketTags() {
            return tagsApi.getActiveTags()
                .then(function (resp) {
                    service.tagsLookup = resp.data;
                })
                .catch(function (ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function pushTagToArrayModel(tag, tagArray) {
            if (!tagArray.some(f => f.Id === tag.Id) && tag.IsActive) {
                tagArray.push({
                    Id: tag.Id,
                    Name: tag.Name,
                    IsActive: tag.IsActive
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.jobs')
        .factory('jobService', jobService);

    /** @ngInject */
    function jobService($injector,
        blockUI,
        auditApi,
        $stateParams,
        historyLogService,
        jobsApi,
        lookupApi,
        allocationApi,
        $mdDialog,
        jobDataModel,
        ticketDataModel,
        exceptionService,
        commentService,
        msgboxService,
        jobToastService,
        customFieldsUtils,
        $timeout,
        $state,
        $rootScope,
        localStorageService,
        resourceAllocateService,
        claimsUtilService,
        ticketsApi,
        $q,
        documentsApi,
        utils,
        smartSchedulingService,
        ticketType
    ) {

        var service = {
            jobModel: new jobDataModel,
            RelatedTicketId: null,
            cloneJobModel: null,
            classifiedAssetLookup: null,
            customFormBinder: null,
            Resources: [],
            branchLookup: [],
            divisionLookup: [],
            companyTypeLookup: [],
            companyLookup: [],
            contactLookup: [],
            clientLookup: [],
            contactTypeLookup: [],
            assetsLookup: [],
            customisedFields: [],
            kitsLookup: [],
            saveMonitor: false,
            values: null,
            projectLookup: [],
            ticketTypeLookup: [],
            last10JobLocation: [],
            billingPeriodLookup: [],
            unlinkedFormTemplates: null,
            linkedFormTemplates: null,
            overriddenFormTemplates: null,
            excludedDocuments: null,
            overriddenDocuments: null,
            formTemplatesListApi: {},
            ticketId: null,
            isEditMode: false,
            dateParam: null,
            isCloning: false,
            isSaving: false,
            isInit: false,
            isLoadingAsset: true,
            isFormValid: false,
            isLoadingKit: true,
            resourceNow: false,
            customFieldsValid: false,
            showForm: true,
            showResourceNow: false,
            isMultidayJob: false,
            costEstimateGroupId: null,
            updateShiftTimes: false,
            showHistory: showHistory,
            getContactTypeLookup: getContactTypeLookup,
            showCancelTicketDialog: showCancelTicketDialog,
            showChargeMinimumHoursDialog: showChargeMinimumHoursDialog,
            showUpdateShiftTimesDialog: showUpdateShiftTimesDialog,
            getBranchLookup: getBranchLookup,
            splitAssetLookup: splitAssetLookup,
            getCompanyTypeLookup: getCompanyTypeLookup,
            getCompanyByBranchLookup: getCompanyByBranchLookup,
            getProjectByBranchAndCompanyLookup: getProjectByBranchAndCompanyLookup,
            getContactByBranchLookup: getContactByBranchLookup,
            getContactClientByBranchAndCompanyLookup: getContactClientByBranchAndCompanyLookup,
            getNewBillingPeriodValues2: getNewBillingPeriodValues2,
            getTicketType: getTicketType,
            getAsset: getAsset,
            getKit: getKit,
            rememberThis: rememberThis,
            saveJob: saveJob,
            loadTicket: loadTicket,
            cancelTicket: cancelTicket,
            getLatestJobLocations: getLatestJobLocations,
            getTicketPDF: getTicketPDF,
            lockUnlockTicket: lockUnlockTicket,
            toggleUpdateChargeMinimumHours: toggleUpdateChargeMinimumHours,
            clean: clean,
            checkProject: checkProject,
            viewComments: viewComments,
            canNavigateToAllocateResource: canNavigateToAllocateResource,
            canNavigateToTimesheets: canNavigateToTimesheets,
            canShowEmailDialog: canShowEmailDialog,
            isMobileAppEnabled: claimsUtilService.isMobileAppEnabled(),
            showJobHasTimesheetDialog: showJobHasTimesheetDialog,
            unlinkedRelatedTicket: unlinkedRelatedTicket,
            isJobDetailsChangeConfirmed: false,
            costEstimateId: null,
            showUnconfirmJobDialog:showUnconfirmJobDialog,
            shouldUnallocateResources: false,
            isContactFieldValid: false,
            resourcesToRemove: [],
            generatePreSchedule: generatePreSchedule,
            isTicketLockedByPreSchedule: isTicketLockedByPreSchedule,
            shouldAllocateResourceBySmartScheduling : false,
            isSmartSchedulingCallbackFailed : isSmartSchedulingCallbackFailed,
            isSmartSchedulingFailed : false,
            isSmartSchedulingSuccess: false,
            loadAllocatedResources: loadAllocatedResources,
            allocatedResources: [],
            cancelScheduling: cancelScheduling,
            retryScheduling: retryScheduling
        };


        return service;

        function canNavigateToAllocateResource() {
            return !(service.jobModel.isThisAQuote || service.jobModel.TicketType === ticketType.PLAN_ONLY || service.jobModel.IsUnconfirmedDate || ((service.jobModel.IsLocked || service.jobModel.IsCancelled) && !service.isCloning) || service.isSaving);
        }

        function canNavigateToTimesheets() {
            return !(service.jobModel.isThisAQuote || service.jobModel.TicketType === ticketType.PLAN_ONLY || service.jobModel.TicketType === ticketType.EQUIPMENT_ONLY || service.jobModel.IsUnconfirmedDate || ((service.jobModel.IsLocked || (isTicketLockedByPreSchedule()) || service.jobModel.IsCancelled) && !service.isCloning) || service.isSaving);
        }

        function canShowEmailDialog() {
            return !(service.jobModel.isThisAQuote || service.jobModel.TicketType === ticketType.PLAN_ONLY || service.jobModel.IsUnconfirmedDate || ((service.jobModel.IsLocked || (isTicketLockedByPreSchedule()) || service.jobModel.IsCancelled) && !service.isCloning) || service.isSaving);
        }

        function viewComments() {
            commentService.viewComments("Ticket", service.ticketId, "#" + ($stateParams.ticketNumber || service.jobModel.TicketNumber));
        }

        function clean() {
            service.jobModel = new jobDataModel;
            service.RelatedTicketId = null;
            service.cloneJobModel = null;
            service.classifiedAssetLookup = null;
            service.customFormBinder = null;
            service.Resources.length = 0;
            service.branchLookup.length = 0;
            service.divisionLookup.length = 0;
            service.companyTypeLookup.length = 0;
            service.companyLookup.length = 0;
            service.contactLookup.length = 0;
            service.clientLookup.length = 0;
            service.contactTypeLookup.length = 0;
            service.assetsLookup.length = 0;
            service.customisedFields.length = 0;
            service.kitsLookup.length = 0;
            service.saveMonitor = false;
            service.values = null;
            service.projectLookup.length = 0;
            service.ticketTypeLookup.length = 0;
            service.last10JobLocation.length = 0;
            service.billingPeriodLookup.length = 0;
            service.ticketId = null;
            service.isEditMode = false;
            service.dateParam = null;
            service.isCloning = false;
            service.isSaving = false;
            service.isInit = false;
            service.isLoadingAsset = true;
            service.isFormValid = false;
            service.isLoadingKit = true;
            service.resourceNow = false;
            service.customFieldsValid = false;
            service.showForm = true;
            service.showResourceNow = false;
            service.isMultidayJob = false;
            service.costEstimateGroupId = null;
            service.linkedFormTemplates = null;
            service.unlinkedFormTemplates = null;
            service.overriddenFormTemplates = null;
            service.excludedDocuments = null;
            service.overriddenDocuments = null;
            service.formTemplatesListApi = {};
            service.isJobDetailsChangeConfirmed = false;
            service.costEstimateId = null;
            service.shouldUnallocateResources = false;
            service.isContactFieldValid = false;
            service.isSmartSchedulingFailed = false;
            service.isSmartSchedulingSuccess = false;
            service.resourcesToRemove = [];
        }

        function getBranchLookup() {
            return jobsApi.getBranches()
                .then(function(resp) {
                    service.branchLookup = [];
                    service.branchLookup = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getCompanyTypeLookup() {
            return lookupApi.getCompanyTypes()
                .then(function(resp) {
                    service.companyTypeLookup = [];
                    service.companyTypeLookup = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getCompanyByBranchLookup(id) {
            return jobsApi.getCompanyLookupsByBranch(id)
                .then(function(resp) {
                    service.companyLookup = [];
                    service.companyLookup = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getContactByBranchLookup(id) {
            return jobsApi.getContactLookupsByBranch(id)
                .then(function(resp) {
                    service.contactLookup = [];
                    service.contactLookup = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getContactClientByBranchAndCompanyLookup(company, branch) {
            service.isLoading = true;
            return jobsApi.getContactClientByBranchAndCompanyLookup(company, branch)
                .then(function(resp) {
                    service.clientLookup = [];
                    angular.forEach(resp.data, function(value) {
                        value.FullName = value.FirstName + ' ' + value.LastName;

                    });
                    service.clientLookup = resp.data;
                    service.isLoading = false;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getContactTypeLookup() {
            return lookupApi.getContactTypes()
                .then(function(resp) {
                    service.contactTypeLookup = [];
                    service.contactTypeLookup = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getProjectByBranchAndCompanyLookup(branchId, companyId) {
            return jobsApi.getProjectByBranchAndCompanyLookup(branchId, companyId)
                .then(function(resp) {
                    service.projectLookup = [];
                    service.projectLookup = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function checkProject(companyId, ProjectId) {
            return jobsApi.checkProject(companyId, ProjectId);
        }

        function getAsset() {
            return jobsApi.getAssets(service.jobModel.Branch.Id)
                .then(function(resp) {
                    service.assetsLookup = [];
                    service.assetsLookup = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getKit() {
            return jobsApi.getKitsbyBranch(service.jobModel.Branch.Id)
                .then(function(resp) {
                    service.kitsLookup = [];
                    service.kitsLookup = _.filter(resp.data, function(o) {
                        return o.Items.length > 0;
                    });

                    $rootScope.kitCache.put('_kitsLookup', service.kitsLookup);
                    service.isLoadingKit = false;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getTicketType() {
            return lookupApi.getTicketTypes()
                .then(function(resp) {
                    service.ticketTypeLookup = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getNewBillingPeriodValues2() {
            return lookupApi.getNewBillingPeriodValues2()
                .then(function(resp) {
                    service.billingPeriodLookup = [];
                    service.billingPeriodLookup = resp.data;
                    //return resp;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function rememberThis(key, value) {
            if (value) {
                localStorageService.set(key, value);
            }
        }

        async function saveJob() {
            service.saveMonitor = !service.saveMonitor;
            service.isSaving = true;

            if (service.isEditMode) {
                if(service.resourcesToRemove.length > 0) {
                    await showResourceLinkedItemRemovalDialog();
                }
                else {
                    await updateJob();
                }
            } else {
                await insertNewJob();
            }
        }

        async function showHistory() {
            var response = await auditApi.getAuditEntries(service.ticketId);
            historyLogService.showHistory("Ticket", response.data, "#" + ($stateParams.ticketNumber || service.jobModel.TicketNumber));
        }

        async function updateJob() {
            blockUI.start({
                message: 'Updating Ticket...'
            });

            var ticket = new ticketDataModel();
            ticket.map(service.jobModel);

            var transformTicket = ticket.transformToServerModel();
            transformTicket.CustomFields = customFieldsUtils.bindData(service.customisedFields, service.values);

            if (!_.isNil(service.jobModel.HasConfirmedDate)) {
                transformTicket['HasConfirmedDate'] = true;
            }

            transformTicket['UpdateShiftTimes'] = service.updateShiftTimes;
            transformTicket['IsJobDetailsChangeConfirmed'] = service.isJobDetailsChangeConfirmed;
            transformTicket['ShouldUnallocateResources'] = service.shouldUnallocateResources;

            let updateTicketsResult = await jobsApi.updateTickets(transformTicket)
                .catch((err) => {
                    blockUI.stop();

                    service.jobModel = service.cloneJobModel;
                    service.isSaving = false;

                    exceptionService.resolve(err);
                });

            if(updateTicketsResult) {
                $timeout(async function() {
                    blockUI.stop();
                    loadAllocatedResources(service.ticketId);

                    if (!updateTicketsResult.data.explanation && (!updateTicketsResult.data.message || 0 === updateTicketsResult.data.message.length)) {
                        await jobToastService.toast('The ticket has been updated.');
                        await checkResourceLike(updateTicketsResult);
                        return;
                    }

                    if (updateTicketsResult.data.explanation && updateTicketsResult.data.explanation.ExplanationNumber === 181003) {
                        msgboxService.alert("Manage Tickets", updateTicketsResult.data.explanation.ExplanationString, "Okay");
                    } else if (updateTicketsResult.data.message) {
                        jobToastService.toast(updateTicketsResult.data.message);
                    }

                    await checkResourceLike(updateTicketsResult);
                });
            }
        }

        async function checkResourceLike(resp) {
            if (!_.isUndefined(resp.data.resourcelike)) {

                let errors = resp.data.resourcelike.filter(function(d) {
                    return !d.WasResourced;
                });

                if (errors.length > 0) {
                    resourceAllocateService.showResourceLikeMessages2(errors);
                }

                service.isSaving = false;
                return;
            }

            if (resp.data.isUpdated) {
                service.isSaving = false;
                return;
            }

            var errorMessage = resp.data.message ? resp.data.message : resp.data.explanation.ExplanationString;

            msgboxService.show(errorMessage, "Update Ticket");

            service.isSaving = false;
        }

        async function insertNewJob() {
            blockUI.start({
                message: 'Saving Ticket...'
            });

            var transformTicket = service.jobModel.transformToModel();
            transformTicket.RelatedTicketId = service.RelatedTicketId;
            transformTicket.CustomFields = customFieldsUtils.bindData(service.customisedFields, service.values);

            if (!_.isNil(service.jobModel.HasConfirmedDate)) {
                transformTicket['HasConfirmedDate'] = true;
            }

            // Note: If cloning mode and requestor comes from Cost Estimate screen then attach groupId.
            // This will be handled differently in the BE.
            if (service.isCloning) {
                transformTicket['costEstimateGroupId'] = service.costEstimateGroupId;

                transformTicket['UnlinkedFormTemplates'] = [];
                transformTicket['LinkedFormTemplates'] = [];
                transformTicket['OverriddenFormTemplates'] = [];

                transformTicket['ExcludedDocuments'] = [];
                transformTicket['OverriddenDocuments'] = [];
            }

            let saveJobResponse = await jobsApi.saveJob(transformTicket)
                .catch((err) => {
                    service.isSaving = !service.isSaving;
                    blockUI.stop();
                    exceptionService.resolve(err);
                });

            blockUI.stop();

            if (!saveJobResponse) {
                service.isSaving = !service.isSaving;
                jobToastService.toast('Unable to save ticket.');
                return;
            }

            let savedJob = saveJobResponse.data;

            var isQuote = service.jobModel.isThisAQuote;
            var startDate = angular.copy(new Date(moment(service.jobModel.JobStartDate).format('MM/DD/YYYY')));
            var endDate = angular.copy(new Date(moment(service.jobModel.JobEndDate).format('MM/DD/YYYY')));
            var duration = angular.copy(service.jobModel.JobDuration);
            var is24Hours = angular.copy(service.jobModel.Is24HourRotation);
            var ticketType = angular.copy(service.jobModel.TicketType);

            angular.forEach(service.customisedFields, function(itm) {
                service.values['cs' + itm.Variable] = null;
                if (itm.FieldType == 2) {
                    angular.forEach(itm.Option, function(opt) {
                        service.values['ChkRegcs' + itm.Variable + opt.Name] = false;
                    });
                }
            });

            if (service.customFieldsValid) {
                service.customFieldsValid.$setPristine();
                service.customFieldsValid.$setUntouched();
            }

            // For Quotation or Cost Estimate only
            if (isQuote) {
                service.jobModel.reset();
                var ceGroupId = savedJob.CostEstimateGroupId;
                if (_.isNil(ceGroupId)) {
                    alert('Unable to save cost estimate.');
                    return;
                }

                jobToastService.toast('The cost estimate has been successfully created.');
                service.isSaving = !service.isSaving;

                $state.go('app.cost_estimate_preview', {
                    ceGrpId: ceGroupId
                });

                return;
            }

            // For normal job saving
            let jobId = savedJob.JobTicket.JobId;

            if ((is24Hours || duration > 1 || (endDate - startDate) > 1) && ticketType !== ticketType.EQUIPMENT_ONLY) {
                service.isSaving = !service.isSaving;

                let isCloning = service.isCloning && service.costEstimateGroupId ? false : service.isCloning;
                var createdJob = {
                    id: jobId,
                    isCloning: isCloning,
                    ticketIds: savedJob.TicketIds,
                    jobModel: service.jobModel,
                    referenceTicketId: service.ticketId
                };

                sessionStorage.setItem('confirmBooking_ticketIds_' + jobId, JSON.stringify(savedJob.TicketIds));
                sessionStorage.setItem('confirmBooking_jobModel_' + jobId, JSON.stringify(service.jobModel));
                sessionStorage.setItem('confirmBooking_isCloning_' + jobId, JSON.stringify(isCloning));
                sessionStorage.setItem('confirmBooking_referenceTicketId_' + jobId, JSON.stringify(service.ticketId));
                redirectToConfirmBooking(createdJob);
                return;
            }

            service.jobModel.reset();

            if (!service.isCloning) {

                await actionAfterCreate(saveJobResponse);

                return;
            }

            let getJobTicketsResp = await jobsApi.getTicketsByJobId(jobId);

            if (!getJobTicketsResp) {
                await actionAfterCreate(saveJobResponse);
                return;
            }

            let newTicket = getJobTicketsResp.data[0];
            let isMultiple = getJobTicketsResp.data.length > 1;

            let getSrcTicketResp = null;
            let srcTicket = null;

            if (service.costEstimateGroupId) {
                getSrcTicketResp = await jobsApi.getTicketInCostEstimate(service.costEstimateId);
                let hasTicketResponse = getSrcTicketResp && getSrcTicketResp.data;
                if (!hasTicketResponse) {
                    await actionAfterCreate(saveJobResponse);
                    return;
                }
                srcTicket = getSrcTicketResp.data["m_Item1"];
            } else {
                getSrcTicketResp = await jobsApi.getTicketByTicketId(service.ticketId);
                let hasTicketResponse = getSrcTicketResp && getSrcTicketResp.data;
                if (!hasTicketResponse) {
                    await actionAfterCreate(saveJobResponse);
                    return;
                }
                srcTicket = getSrcTicketResp.data;
            }

            let getSrcTicketAllocationsResp = await allocationApi.fetchTicket(service.ticketId)
                .catch(() => actionAfterCreate(getJobTicketsResp));

            if (!getSrcTicketAllocationsResp) {
                await actionAfterCreate(getSrcTicketAllocationsResp);
                return;
            }

            const JOB_DOCUMENT_MODULE_ID = '5';
            const ITEM_TYPE_ASSET = 1;

            let srcTicketAllocatedResources = _.filter(getSrcTicketAllocationsResp.data, function(o) {
                return o.AllocatedId !== null;
            });

            let getSrcTicketDocumentsResp = await documentsApi.getAllDocumentsForResource(JOB_DOCUMENT_MODULE_ID, service.ticketId);
            let srcTicketDocuments = getSrcTicketDocumentsResp.data || [];

            let hasAllocatedResources = srcTicketAllocatedResources.length > 0;

            let hasForms = srcTicket.LinkedFormTemplates.length > 0 ||
                srcTicket.UnlinkedFormTemplates.length > 0 ||
                srcTicket.OverriddenFormTemplates.length > 0;

            let hasAttachments = srcTicketDocuments.length > 0 ||
                srcTicket.ExcludedDocuments.length > 0 ||
                srcTicket.OverriddenDocuments.length > 0;

            if (!hasAllocatedResources && !hasForms && !hasAttachments ) {
                await actionAfterCreate(getJobTicketsResp);
                return;
            }

            let numberOfEquipment = _.filter(srcTicketAllocatedResources, function(o) {
                return o.ItemType == ITEM_TYPE_ASSET;
            }).length;

            $mdDialog.show({
                    templateUrl: 'app/main/jobs/services/cloneAllocationDialog/clone-allocation.html',
                    controller: 'cloneJobAllocationDialogController as vm',
                    locals: {
                        data: {
                            multiple: isMultiple,
                            CloneTicketId: newTicket.id,
                            SourceTicketId: service.ticketId,
                            CloneTicketNumber: newTicket.TicketNumber,
                            Tickets: getJobTicketsResp.data.map(x => ({
                                NewTicketId: x.id,
                                NewTicketNumber: x.TicketNumber,
                                SourceTicketId: service.ticketId,
                            })),
                            hasOnlyEquipment: srcTicketAllocatedResources.length == numberOfEquipment,
                            hasAllocatedResources: srcTicketAllocatedResources.length > 0,
                            hasForms: hasForms,
                            hasAttachments: hasAttachments,
                            ticketType : newTicket.TicketType,
                        }
                    }
                }).then(async function(resp) {
                    service.shouldAllocateResourceBySmartScheduling = resp && resp.shouldAllocateResourceBySmartScheduling;

                    if(!claimsUtilService.isSmartSchedulingEnabled() && resp.shouldAllocateResourceBySmartScheduling){
                        smartSchedulingService.showScheduleBooking();
                    }

                    if (resp && resp.data && resp.data.length > 0) {
                        resourceAllocateService
                            .showResourceLikeMessages2(resp.data)
                            .then(async function() {
                              await actionAfterCreate(getJobTicketsResp);
                            });
                    } else {
                      await actionAfterCreate(getJobTicketsResp);
                    }
                })
                .catch(function(ex) {
                    service.isSaving = !service.isSaving;
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });

        }

        async function actionAfterCreate(response) {
            let result = (response.data && response.data.JobTicket) ? response.data.JobTicket : response;

            function getJobIdFromSuperComplexStructure() {
                let job_id = null;
                if (!_.isArray(result)) {
                    if (_.isArray(result.data) && result.data.length > 0) {
                        job_id = result.data[0].JobId;
                    } else if (result.data) {
                        job_id = result.data.JobId;
                    } else {
                        job_id = result.JobId;
                    }
                } else {
                    job_id = result[0].JobId;
                }
                return job_id;
            }

            var jobId = getJobIdFromSuperComplexStructure();

            var jobTickets = await jobsApi.getTicketsByJobId(jobId);

            let ticket = jobTickets.data[0];

            let isPlanOnlyTicket = ticket.TicketType == 4;

            let hasResourceItems = ticket.ResourceItems && ticket.ResourceItems.length > 0;

            service.jobModel.id = ticket.id;
            service.jobModel.Resource = ticket.ResourceItems;

            jobToastService.toast('The ticket has been successfully created.');

            service.isSaving = !service.isSaving;

            let isSmartSchedulingAllowed = claimsUtilService.hasSmartSchedulingAccess() && !isPlanOnlyTicket && hasResourceItems;
            if (isSmartSchedulingAllowed && !service.isCloning) {
                await showAllocationResourceDialog();
            }

            if(isSmartSchedulingAllowed && service.isCloning && service.shouldAllocateResourceBySmartScheduling && claimsUtilService.isSmartSchedulingEnabled()){
                await loadAllocatedResources(service.jobModel.id);
                await smartSchedulingService.generateSchedule(service.jobModel.id, service.allocatedResources);
            }

            $state.go('app.jobs_update', {
                id: ticket.id,
                ticketNumber: ticket.TicketNumber
            });
        }

        function showCancelTicketDialog(ticket) {
            let dialog = {
                locals: {
                    ticket: ticket
                },
                templateUrl: 'app/main/jobs/services/cancelReasonDialog/cancel-reason.html',
                controller: 'CancelReasonController as vm'
            }
            return dialog;
        }

        function showChargeMinimumHoursDialog(ticket) {
            let dialog = {
                locals: {
                    ticket: ticket
                },
                templateUrl: 'app/main/jobs/services/chargeMinimumHoursDialog/charge-minimum-hours.html',
                controller: 'ChargeMinimumHoursController as vm'
            }
            return dialog;
        }

        function showUpdateShiftTimesDialog(ticket) {
            let dialog = {
                locals: {
                    ticket: ticket
                },
                templateUrl: 'app/main/jobs/services/updateShiftTimesDialog/update-shift-times.html',
                controller: 'UpdateShiftTimesController as vm'
            }
            return dialog;
        }

        function showJobHasTimesheetDialog() {
            let dialog = {
                templateUrl: "app/main/jobs/services/CheckSubmittedTimesheetDialog/check-submitted-timesheet.html",
                controller: "CheckSubmittedTimesheetController as vm",
            };
            return dialog;
        }

        function showUnconfirmJobDialog() {
            let dialog = {
                templateUrl: 'app/main/jobs/services/unconfirmJobDialog/unconfirm-job-dialog.html',
                controller: 'UnconfirmJobDialogController as vm'
            }
            return dialog;
        }

        function redirectToConfirmBooking(createdJob) {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.confirmBooking', createdJob);
        }

        async function loadTicket() {
            service.isFormValid = false;
            // Check if what API to use cost estimate ticket or Ticket
            return (!service.costEstimateGroupId) ?
                jobsApi.getTicketWithCustomFieldsByTicketId(service.ticketId) :
                jobsApi.getTicketInCostEstimate(service.costEstimateId);
        }

        function cancelTicket(ticketId, reason, chargeMinHours) {
            return jobsApi.cancelTicket(ticketId, reason, chargeMinHours);
        }

        function getLatestJobLocations(id) {
            return jobsApi.getLatestJobLocations(id)
                .then(function(resp) {
                    service.last10JobLocation = [];
                    service.last10JobLocation = resp.data;
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function getTicketPDF(id) {
            blockUI.start('Creating PDF, please wait.');
            jobsApi.getTicketPDF(id).then(function(resp) {
                var _headers = resp.headers();
                var _filename = _headers.filename;
                var file = new Blob([resp.data], {
                    type: resp.headers('Content-Type')
                });

                var fileURL = URL.createObjectURL(file);
                var anchor = angular.element('<a/>');
                anchor.attr({
                    href: fileURL,
                    target: '_blank',
                    download: _filename
                })[0].click();
                blockUI.stop();
            }).catch(function() {
                blockUI.stop();
            });
        }

        function lockUnlockTicket(id, isLocked) {
            return jobsApi.lockUnlockTicket(id, isLocked);
        }

        function toggleUpdateChargeMinimumHours() {
            var toggleValue = !service.jobModel.ChargeMinimumHours;
            blockUI.start(toggleValue ? 'Charging minimum hours' : 'Remove charging of minimum hours');

            jobsApi.chargeMinHours(service.jobModel.id, toggleValue)
                .then(function(resp) {
                    service.jobModel.ChargeMinimumHours = toggleValue;
                    blockUI.stop();
                }).catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function splitAssetLookup() {
            service.classifiedAssetLookup = {
                peopleAssets: alasql('select id, ItemName,ItemTypes from ? ORDER BY ItemName', [_.filter(service.assetsLookup, function(o) {
                    return o.ItemTypes == 4
                })]),
                nonPeopleAssets: alasql('select id, ItemName,ItemTypes from ? ORDER BY ItemName', [_.filter(service.assetsLookup, function(o) {
                    return o.ItemTypes != 4
                })])
            }
        }

        function unlinkedRelatedTicket(ticketId, unlinkRelatedTicket) {
            blockUI.start("Unlinking related ticket ...");

            let deferred = $q.defer();

            ticketsApi
                .unlinkedRelatedTicket(ticketId, unlinkRelatedTicket)
                .then(function(resp) {
                    deferred.resolve({
                        data: resp.data,
                    });
                    blockUI.stop();
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                    blockUI.stop();
                });
        }

        async function cancelScheduling(){
            blockUI.start('Cancelling Scheduling Copilot...');

            let result = await smartSchedulingService.cancelScheduling(service.jobModel.LatestPreScheduleJobId);

            if (result)
            {
                service.jobModel.IsLockedByPreSchedule = false;
                $state.reload();
            }

            blockUI.stop();
        }

        async function retryScheduling(){
            blockUI.start("Initiating Scheduling Copilot...");

            let result = await smartSchedulingService.retrySchedulingCopilot(service.jobModel.LatestPreScheduleJobId);

            if (result)
            {
                service.isSaving = !service.isSaving;
                $state.reload();
            }

            blockUI.stop();
        }

        async function generatePreSchedule(){
            var unallocatedPeople = resourceAllocateService.allocatedResource.filter(x => x.ItemType == 4 && !x.AllocatedId);
            var unallocatedAssets = resourceAllocateService.allocatedResource.filter(x => x.ItemType == 1 && (!x.AllocatedId && !x.AssignedOperatorId));

            var deferred = $q.defer();

            smartSchedulingService.showAllocationDialog(unallocatedPeople, unallocatedAssets)
            .then(async function(data){
                if(!data){
                    return;
                }

                blockUI.start("Initiating Scheduling Copilot...");

                let result = await smartSchedulingService.generateSchedule(service.ticketId, data);

                blockUI.stop();

                if (result && result.data && result.data.ErrorMessage) {
                    service.isSaving = false;

                    await msgboxService.alert(
                        utils.translate(
                            "RESOURCEALLOCATION.SMART_SCHEDULING_FAILED_TITLE_DIALOG"
                        ),
                        result.data.ErrorMessage,
                        utils.translate(
                            "RESOURCEALLOCATION.CLOSE"
                        )
                    );

                    deferred.resolve(false);
                    return deferred.promise;
                }

                service.isSaving = true;

                deferred.resolve(true);
            });

            return deferred.promise;
        }

        async function showAllocationResourceDialog(){
            let dialog = $mdDialog
                    .confirm()
                    .title("Create Job")
                    .htmlContent(
                        "Do you want to schedule resources with Scheduling Copilot now?"
                    )
                    .ok("Allocate with Scheduling Copilot")
                    .cancel("NO");

            return $mdDialog.show(dialog).then(async function(){

                if (!claimsUtilService.isSmartSchedulingEnabled()) {
                    smartSchedulingService.showScheduleBooking();
                    return;
                }

                blockUI.start("Initiating Scheduling Copilot...");

                await loadAllocatedResources(service.jobModel.id);
                let result = await smartSchedulingService.generateSchedule(service.jobModel.id, resourceAllocateService.allocatedResource);

                blockUI.stop();

                if(result && result.data && result.data.ErrorMessage){
                    await msgboxService.alert(
                        utils.translate("RESOURCEALLOCATION.SMART_SCHEDULING_FAILED_TITLE_DIALOG"),
                        result.data.ErrorMessage,
                        utils.translate("RESOURCEALLOCATION.CLOSE")
                    );
                }
            }, function(){
                blockUI.stop();
            }).catch(function(ex){
                blockUI.stop();
                exceptionService.resolve(ex);
            });
        }

        function isTicketLockedByPreSchedule(){
            return (claimsUtilService.isSmartSchedulingEnabled() && service.jobModel.IsLockedByPreSchedule && service.isEditMode)
        }

        async function isSmartSchedulingCallbackFailed(preScheduleJobIds) {
            return await resourceAllocateService.isSmartSchedulingCallbackFailed(preScheduleJobIds);
        }

        async function loadAllocatedResources(ticketId) {
            var allocatedResources = await allocationApi.fetchTicket(ticketId);
            resourceAllocateService.assignDisplayName(allocatedResources.data);
            resourceAllocateService.allocatedResource = allocatedResources.data;
            service.allocatedResources = resourceAllocateService.allocatedResource;
        }

        async function showResourceLinkedItemRemovalDialog() {
            blockUI.start({
                message: 'Checking resources...'
            });

            var resourceItems = await getAllocatedResourceWithLinkedItems(service.ticketId,service.resourcesToRemove);

            var hasLinkedItems = resourceItems.linkedItems.length > 0;

            // The prompt explains which related items are about to be unlinked, which means
            // nothing while linking is disabled — there is no link icon or connector for the
            // user to reason about. The unlink itself still has to run either way, otherwise the
            // removed allocation leaves its children pointing at a resource that no longer
            // exists and the grouping is broken if the feature is switched back on.
            var needsUnlinkConfirmation = hasLinkedItems && claimsUtilService.isLinkedItemsEnabled();

            if(needsUnlinkConfirmation) {
                blockUI.stop();
                $mdDialog.show({
                    templateUrl: 'app/main/jobs/widget/DroppedAssetComponent/DroppedAssetUnlinkItems/asset-unlink-items-dialog.html',
                    controller: 'assetUnlinkItemsDialogController as dialogUnlinkVm',
                    items: resourceItems
                }).then(async function(confirm) {
                    await resourceAllocateService.unlinkItems(resourceItems.linkItemsToUpdate);
                    await updateJob();
                }, function(cancel) {
                    service.isSaving = false;
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
            }
            else {
                blockUI.stop();

                if(hasLinkedItems) {
                    await resourceAllocateService.unlinkItems(resourceItems.linkItemsToUpdate);
                }

                await updateJob();
            }
            service.resourcesToRemove = [];
        }

        async function getAllocatedResourceWithLinkedItems(jobId,resourceItemIdsToRemove) {
            const EQUIPMENT_TYPE = 1;
            let ticketAllocatedResources;
            let linkedParentItemIds = [];
            let resourcesToRemove = [];

            await allocationApi.fetchTicket(jobId).then(function(response) {
                ticketAllocatedResources = response.data;
                resourceAllocateService.setRequirements(ticketAllocatedResources);
            });

            resourceItemIdsToRemove.forEach(function(item) {
                var resourceItems = ticketAllocatedResources.filter(x => x.ItemType === EQUIPMENT_TYPE && x.ItemId === item.itemId);
                resourcesToRemove.push(...resourceItems.slice(0,item.quantity));
            });

            var parentItemIds = resourcesToRemove.filter(i => i.ParentAllocatedResourceId == null).map(x => x.Id);

            var currentLinkedItems = ticketAllocatedResources.filter(item => parentItemIds.some(parentId => parentId == item.ParentAllocatedResourceId));

            linkedParentItemIds = currentLinkedItems.map(x => x.ParentAllocatedResourceId);

            var affectedItemsWithLinked = currentLinkedItems;
            var linkItemsToUpdate = currentLinkedItems;

            ///////---------When child removal-------///
            var parentIdOfLinkedItems = resourcesToRemove.filter(i => i.ParentAllocatedResourceId != null).map(x => x.ParentAllocatedResourceId);

            if(parentIdOfLinkedItems.length > 0) {
                var parentOfLinkedItems = ticketAllocatedResources.filter(function(item) {
                    return parentIdOfLinkedItems.includes(item.Id)
                });

                if(parentOfLinkedItems.length > 0) {
                    var linkedItemsOfParent = resourcesToRemove.filter(i => parentOfLinkedItems.some(parent => parent.Id == i.ParentAllocatedResourceId));
                    affectedItemsWithLinked.push(...linkedItemsOfParent);
                    linkItemsToUpdate.push(...parentOfLinkedItems);
                    linkedParentItemIds.push(...linkedItemsOfParent.map(x => x.Id));
                }
            }

            if(linkedParentItemIds.length > 0) {
                resourcesToRemove = resourcesToRemove.filter(x => linkedParentItemIds.includes(x.Id));
            }

            var resourcesWithLinkItems = {
                resourcesToRemove: resourcesToRemove,
                linkedItems: affectedItemsWithLinked,
                linkItemsToUpdate: linkItemsToUpdate
            };

            return resourcesWithLinkItems;

        }
    }
})();

/**
 * Created by Ben Rei on 8/25/2016.
 */
(function () {
  'use strict';

  angular.module('app.jobs')
    .service('jobToastService', jobToastService);

  /** @ngInject */
  function jobToastService($mdToast) {
    var self = this;

    self.last = {
      bottom: true,
      top: false,
      left: false,
      right: true
    };

    self.toastPosition = angular.extend({},self.last);

    var service = {
      toast: toastMe
    };

    return service;

    function toastMe(message){
      var pinTo = getToastPosition();
      return $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position(pinTo )
          .hideDelay(1500)
      );
    }

    function getToastPosition() {
      sanitizePosition();
      return Object.keys(self.toastPosition)
        .filter(function(pos) { return self.toastPosition[pos]; })
        .join(' ');
    };

    function sanitizePosition() {
      var current = self.toastPosition;
      if (current.bottom && self.last.top) current.top = false;
      if (current.top && self.last.bottom) current.bottom = false;
      if (current.right && self.last.left) current.left = false;
      if (current.left && self.last.right) current.right = false;
      self.last = angular.extend({}, current);
    };
  }
})();

(function() {
    'use strict';

    angular.module('app.resourceSidenav')
        .service('resourceSidenavService', resourceSidenavService);

    function resourceSidenavService(
        $mdSidenav,
        blockUI,
        exceptionService,
        advanceFilterService,
        allocationApi,
        branchApi,
        $mdDialog,
        utils,
        identityService,
        $timeout,
        $filter,
        resourceSearchFilterService
    ) {
        var service = {
            isLoading: false,
            resourceType: {
                People: 0,
                Equipment: 1
            },
            lockoutType: {
                NoLockout: 0,
                SoftLockout: 1,
                MediumLockout: 2,
                HardLockout: 3
            },
            allResources: [],
            resources: [],
            searchText: null,
            viewAll: false,
            advanceOptions: null,
            itm: null,
            ticket: null,
            divisions: null,
            chosen_division: null,
            isFilterActive: false,
            summary: null,
            hasLoadedOnce: false,
            fetchError: false,
            lastFetchArgs: null,
            openSideNav: openSideNav,
            isAllocatingAPerson: isAllocatingAPerson,
            isAllocatingAnEquipment: isAllocatingAnEquipment,
            isBlueAllocatable: isBlueAllocatable,
            isOverrideAllocatable: isOverrideAllocatable,
            toggleViewAll: toggleViewAll,
            close: close,
            changeDivision: changeDivision,
            resetFilter: resetFilter,
            openFilterOptionsDialog: openFilterOptionsDialog,
            performSearch: performSearch,
            retryFetch: retryFetch
        }

        async function openSideNav(ticket, itm) {
            resetVariables();

            service.ticket = ticket;
            service.itm = itm;
            service.lastFetchArgs = { ticket: ticket, itm: itm };

            showLoader();
            try {
                await fetchResources(ticket, itm);
                service.fetchError = false;
                filterList();
            } catch (err) {
                service.fetchError = true;
                exceptionService.resolve(err);
            } finally {
                hideLoader();
            }

            return $mdSidenav("resource-sidenav").toggle();
        }

        async function retryFetch() {
            // #50996 EC-02 — re-fire the original fetch; preserve searchText and other UI state.
            // Re-entrancy guard: ignore if another fetch is already in flight.
            if (!service.lastFetchArgs || service.isLoading) {
                return;
            }

            showLoader();
            try {
                await fetchResources(service.lastFetchArgs.ticket, service.lastFetchArgs.itm);
                service.fetchError = false;
                filterList();
            } catch (err) {
                service.fetchError = true;
                exceptionService.resolve(err);
            } finally {
                hideLoader();
            }
        }

        function changeDivision() {
            filterList();
        }

        function toggleViewAll() {
            filterList();
        }

        function filterList() {
            service.resources = [];

            // Default ("view without issues") list. For people, a worker whose only block is an
            // equipment-typed operator-skill gap is still blue-allocatable, so include it here (raw
            // IsValidToAllocate is false) — kept in lock-step with the + via isBlueAllocatable.
            // Equipment keeps the raw IsValidToAllocate gate.
            let list = service.viewAll ?
                angular.copy(service.allResources) :
                service.allResources.filter(p => service.isAllocatingAPerson() ? isBlueAllocatable(p) : p.IsValidToAllocate);

            list = filterByDivision(list);
            list = filterBySearchText(list);

            service.resources = advanceFilterService.applyOptions(list, service.advanceOptions);
        }

        function isBlueAllocatable(person) {
            // Blue + : the worker can be allocated without an override reason. Equipment-typed
            // operator-skill gaps are resolved at allocation (auto-assign via reveal-and-prompt), so
            // a worker whose only block is equipment-typed still counts blue; Soft/NoLockout non-
            // equipment issues stay allocatable, Medium/Hard worker-side issues fall to the red +.
            if (person.IsValidToAllocate) return true;

            let hasNonSkillLockoutIssues = person.AllocationIssues.some(x => x.ResourceType == service.resourceType.People
                && x.LockoutType == service.lockoutType.NoLockout);

            let nonEquipmentAllocationIssues = person.AllocationIssues.filter(x => x.ResourceType != service.resourceType.Equipment);

            let hasSoftAndNoLockoutIssuesOnly = nonEquipmentAllocationIssues.every(x => x.LockoutType == service.lockoutType.SoftLockout || x.LockoutType == service.lockoutType.NoLockout);

            return !hasNonSkillLockoutIssues && hasSoftAndNoLockoutIssuesOnly && !isOverrideAllocatable(person);
        }

        function isOverrideAllocatable(person) {
            // Red override + : the only blocking issues are overridable worker-side
            // (non-equipment) lockouts. Equipment-typed operator gaps are excluded — they
            // surface via the reveal-and-prompt at allocation, not the + colour.
            let nonEquipmentAllocationIssues = person.AllocationIssues.filter(x => x.ResourceType != service.resourceType.Equipment);
            let isInvalidToAllocate = nonEquipmentAllocationIssues.length > 0 && nonEquipmentAllocationIssues.some(x => !x.IsValidToAllocate && !x.CanBeOverriden);

            if (isInvalidToAllocate) return false;

            let invalidNonEquipmentAllocationIssues = nonEquipmentAllocationIssues.filter(x => !x.IsValidToAllocate);
            return invalidNonEquipmentAllocationIssues.length > 0 && invalidNonEquipmentAllocationIssues.every(x => x.CanBeOverriden);
        }

        function filterByDivision(list) {
            if (list.length < 1) {
                return list;
            }

            const isDivisionSelected = service.chosen_division != null && service.chosen_division !== '';

            if (!isDivisionSelected) {
                const hasTicketDivision = service.ticket.divisionId != null && service.ticket.divisionId !== '';

                if (!hasTicketDivision) {
                    service.chosen_division = -1;
                    return list;
                }

                // Select Items With Ticket Division
                service.chosen_division = angular.copy(service.ticket.divisionId);
                return list.filter(p => p.DivisionIds && p.DivisionIds.includes(service.chosen_division));
            }

            const isAllDivisionsSelected = service.chosen_division == -1;
            if (isAllDivisionsSelected) {
                return list;
            }

            const isNoDivisionSelected = service.chosen_division == 0;
            if (isNoDivisionSelected) {
                return list.filter(p => p.DivisionIds.length < 1);
            }

            // Select Items With Chosen Division
            return list.filter(p => p.DivisionIds && p.DivisionIds.includes(service.chosen_division));
        }

        function filterBySearchText(list) {
            return resourceSearchFilterService.filterBySearchText(list, service.searchText);
        }

        async function fetchResources(ticket, itm) {
            const availableResourcesResp = await allocationApi.getAvailableResources(
                itm.id,
                itm.ticketId,
                itm.ticketNumber,
                itm.itemId,
                itm.resourceType,
                itm.startDateTime,
                itm.finishDateTime,
                ticket.jobLongitude,
                ticket.jobLatitude,
                ticket.branchId,
                ticket.companyCode,
                ticket.divisionId,
                ticket.projectId,
                ticket.siteContactId
            );

            const responseData = availableResourcesResp.data;
            service.allResources = responseData.Resources || responseData || [];
            service.summary = responseData.Summary || null;
            service.hasLoadedOnce = true;

            const divisionsResp = await branchApi.getBranchDivisions(ticket.branchId);
            service.divisions = divisionsResp.data;

            await loadFilterSettings();
        }

        function performSearch(searchText) {
            // Client-side search - instant filtering, no API call needed
            service.searchText = searchText;
            filterList();
        }

        function close() {
            $mdSidenav("resource-sidenav").close();
        }

        function fetchFailed(err) {
            // #50996 EC-02 — surface inline error and preserve panel state (searchText,
            // ticket, lastFetchArgs) so the user can hit Retry without re-opening the panel.
            service.fetchError = true;
            hideLoader();
            exceptionService.resolve(err);
        }

        function isAllocatingAPerson() {
            return !!service.itm && service.itm.resourceType === 0 ? true : false;
        }

        function isAllocatingAnEquipment() {
            return !!service.itm && service.itm.resourceType === 1 ? true : false;
        }

        function resetVariables() {
            service.ticket = null;
            service.itm = null;
            service.allResources = [];
            service.divisions = [];
            service.resources = [];
            service.viewAll = false;
            service.searchText = null;
            service.chosen_division = null;
            service.advanceOptions = getDefaultSettings();
            service.isFilterActive = false;
            service.summary = null;
            service.hasLoadedOnce = false;
            service.fetchError = false;
            service.lastFetchArgs = null;
        }

        function showLoader() {
            // Ensure any previous loader is stopped before starting new one
            blockUI.stop();
            blockUI.start("Loading Resources...");
            service.isLoading = true;
        }

        function hideLoader() {
            service.isLoading = false;
            
            $timeout(function() {
                try {
                    blockUI.stop();
                    blockUI.reset();
                } catch (e) {
                    // Ignore
                }
            }, 100);
        }

        function resetFilter() {
            var confirm = $mdDialog.confirm()
                .title(utils.translate('RESOURCEALLOCATION.RESET_CONFIRMATION'))
                .textContent(utils.translate('RESOURCEALLOCATION.RESET_CONFIRMATION_MESSAGE'))
                .ok(utils.translate('RESOURCEALLOCATION.YES'))
                .cancel(utils.translate('RESOURCEALLOCATION.CANCEL'));

            $mdDialog.show(confirm)
                .then(function() {
                    saveFilter(null);
                    filterList();
                });
        }

        async function loadFilterSettings() {
            let defaultSettings = getDefaultSettings();
            let savedSettings = identityService.getAllocationSettings();

            if (savedSettings == null) {
                savedSettings = {};
                
                const settingsResp = await allocationApi.getAllocationSettings().catch(fetchFailed);
                settingsResp && settingsResp.data ? angular.extend(savedSettings, defaultSettings, settingsResp.data) : angular.extend(savedSettings, defaultSettings);
                allocationApi.saveAllocationSettings(identityService.userData.UserId, savedSettings);

                service.isFilterActive = false;
                service.advanceOptions = savedSettings;
                return;
            }

            service.isFilterActive = JsonStringifyOrder(savedSettings) !== JsonStringifyOrder(defaultSettings);
            service.advanceOptions = savedSettings;
        }

        function saveFilter(settings) {
            let defaultSettings = getDefaultSettings();
            const defaultSettingsJsonString = JsonStringifyOrder(defaultSettings);
            const currentSettingsJsonString = JsonStringifyOrder(service.advanceOptions);

            let shouldSaveSettings = false;

            if (settings == null) {
                shouldSaveSettings = currentSettingsJsonString !== defaultSettingsJsonString;

                service.viewAll = false;
                service.searchText = null;
                service.chosen_division = null;
                service.isFilterActive = false;
                service.advanceOptions = defaultSettings;
            } else {
                const newSettingsJsonString = JsonStringifyOrder(settings);
                shouldSaveSettings = currentSettingsJsonString !== newSettingsJsonString;

                service.isFilterActive = newSettingsJsonString !== defaultSettingsJsonString
                service.advanceOptions = settings;
            }

            if (shouldSaveSettings) {
                allocationApi.saveAllocationSettings(identityService.userData.UserId, service.advanceOptions);
                identityService.setAllocationSettings(service.advanceOptions);
            }
        }

        function getDefaultSettings() {
            return {
                reset: false,
                showOption: {
                    vehicle: true,
                    distance: false,
                    suburb: true,
                    employmentStatus: true,
                    disable: false,
                    showPrevAndNextShiftDetails: true
                },
                sortOption: null,
                filterOption: null,
                hasVehicleFilter: false,
                isVehicleFilterActive: false
            };
        }

        function JsonStringifyOrder(obj, space) {
            const allKeys = new Set();
            JSON.stringify(obj, (key, value) => (allKeys.add(key), value));
            return JSON.stringify(obj, Array.from(allKeys).sort(), space);
        }

        function openFilterOptionsDialog() {
            $mdDialog.show({
                templateUrl: 'app/main/jobs/resourceSidenav/advanceOptions/advanceOptions.dialog.html',
                controller: 'ResourceAdvanceOptionsDialogController as vm',
                locals: {
                    Options: angular.copy(service.advanceOptions)
                }
            }).then(function(settings) {
                if (settings != null) {
                    saveFilter(settings);
                    filterList();
                }
            })
        }

        return service;
    }
})();

(function(){
    'use strict';

    angular.module('app.resourceSidenav')
        .directive('resourceSidenav', resourceSidenav);

    function resourceSidenav() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/jobs/resourceSidenav/resourceSidenav.html',
            scope: {},
            controller: controller,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function controller(resourceSidenavService) {
            var vm = this;
            vm.service = resourceSidenavService;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.resourceSidenav')
        .service('advanceFilterService', advanceFilterService);

    function advanceFilterService(
        _
    ) {
        let service = {
            applyOptions: applyOptions
        }
        let self = service;

        function applyOptions(resources, opts) {
            resources = filterByEmploymentStatus(resources, opts.filterOption);
            resources = filterByVehicleOwnership(resources, opts);

            resources = sortBySortOption(resources, opts.sortOption);

            return resources;
        }

        function filterByVehicleOwnership(resources, opts) {
            if (resources.length < 1) {
                return resources;
            }

            if (!opts.isVehicleFilterActive) {
                self.hasVehicleFilter = false;
                return resources;
            }

            self.hasVehicleFilter = !!opts.hasVehicleFilter;
            resources.forEach(itm => itm.Show = itm.Show && (!!itm.HasVehicle === !!opts.hasVehicleFilter));
            return resources;
        }

        function filterByEmploymentStatus(resources, option) {
            if (resources.length < 1) {
                return resources;
            }

            if (!option) {
                self.sortOption = null;
                resources.forEach(itm => itm['Show'] = true);
                return resources;
            }

            self.sortOption = option;

            if (option == 0) {
                return filterFunc(resources, 'Casual');
            }

            if (option == 1) {
                return filterFunc(resources, 'Permanent Parttime');
            }

            if (option == 2) {
                return filterFunc(resources, 'Permanent Fulltime');
            }

            if (option == 3) {
                return filterFunc(resources, 'Labour Hire');
            }

            return resources;
        }

        function filterFunc(resources, term) {
            resources.forEach(function(itm) {
                if (itm.EmploymentStatus === term) {
                    itm['Show'] = true;
                } else {
                    itm['Show'] = false;
                }
            });
            return resources;
        }

        function sortBySortOption(resources, option) {
            if (resources.length < 1) {
                return resources;
            }

            if (option == null) {
                self.sortOption = null;
                return orderListByResourceName(resources)

            }

            self.sortOption = option;

            if (option == 0) {
                return orderListByResourceName(resources);
            }

            if (option == 2) {
                return orderByDistanceToJob(resources);
            }

            return orderListBySuburbName(resources);
        }

        function orderListByResourceName(list) {
            return _.orderBy(list, ['Name'], ['asc']);
        }

        function orderListBySuburbName(list) {
            let with_suburb = _.orderBy(list.filter(p => p.Suburb != null), ['Suburb'], ['asc']);
            let without_suburb = _.orderBy(list.filter(p => p.Suburb == null), ['Name'], ['asc']);

            return with_suburb.concat(without_suburb)
        }

        function orderByDistanceToJob(list) {
            let with_distance = _.orderBy(list.filter(p => p.DistanceToJob != null), ['DistanceToJob'], ['asc']);
            let without_distance = _.orderBy(list.filter(p => p.DistanceToJob == null), ['Name'], ['asc']);

            return with_distance.concat(without_distance);
        }

        return service;
    }
})();

(function () {
  'use strict';

  angular
    .module('app.related-ticket-billing-preferences')
    .controller('RelatedTicketBillingController', RelatedTicketBillingController);

  /** @ngInject */
  function RelatedTicketBillingController(relatedTicketBillingService) {
    var vm = this;
    vm.service = relatedTicketBillingService;
    vm.service.activate();
  }
})();

(function () {
    'use strict';

    angular
        .module('app.jobs')
        .constant('ticketType', {
            EQUIPMENT_ONLY: 1,
            FULL_SERVICE: 3,
            INTERNAL: 6,
            TRAVEL_ONLY: 7,
            PLAN_ONLY: 4
        });
})();
(function () {
    'use strict';

    angular
        .module('app.jobs')
        .constant('ticketStatus', {
            COMPLETED: 1,
            READY_TO_GO: 2,
            AWAITING_DETAILS: 3,
            AWAITING_RESOURCING: 4,
            QUOTE: 5,
            UNCONFIRMED_DATE: 6,
            SMART_SCHEDULING_IS_IN_PROGRESS: 7,
            SMART_SCHEDULING_IS_DONE: 8,
            PENDING_UPLOADS: 12,
            PENDING_CLIENT_CONFIRMATION: 13,
            REJECTED: 14,
            CANCELLED: 15
        });
})();
(function(){
  'use strict';

  angular.module('app.jobs')
    .service('orderbyModel', orderbyModel)

  function orderbyModel() {
    return function () {
      var self = this,
        defaults = {
          TicketType: null,
          Branch: null,
          Description: null,
          CreatedDate: null,
          LastUpdatedDate:null,
          CostCodeType: null
          //SelectedCategory: null
          //CategoryName: null // Custom desc for grid
        };

      angular.extend(self, defaults);

      self.map = mapper;
      self.reset = reset;
      self.tranformToServerModel = transformToModel;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend(self, mapValue);
      }

      function reset() {
        self.map(null);
      }

      function transformToModel() {

        return {
          id: self.id,
          CodeNo: self.CodeNo,
          Description: self.Description,
          CreatedDate: self.CreatedDate,
          LastUpdatedDate: self.LastUpdatedDate,
          CostCodeType: self.CostCodeType
        };
      }
    }
  };

})();

/**
 * Created by Ben Rei on 9/6/2016.
 * Updated by Ben Rei on 4/6/2016
 */
{
    angular.module('app.jobs')
        .service('ticketDataModel', ticketDataModel);

    function ticketDataModel(utils, TimeLibrary) {
        return function(options) {
            var self = this,
                defaults = {
                    id: null,
                    JobId: null,
                    TicketNumber: null,
                    TicketType: null,
                    Branch: null,
                    BranchName: null,
                    Division: null,
                    DivisionName: null,
                    Project: null,
                    ProjectName: null,
                    Client: null,
                    ClientName: null,
                    PersonOrdering: null,
                    IsQuote: null,
                    JobLocation: null,
                    IsParent: null,
                    ParentTicketId: null,
                    ParentTicketNumber: null,
                    RelatedTicketId: null,
                    RelatedTicketNumber: null,
                    SiteContact: null,
                    JobStartDateDisplay: null,
                    JobStartDate: null,
                    JobEndDate: null,
                    JobStartTime: null,
                    JobEndTime: null,
                    JobDetails: null,
                    BillingPeriod: 1,
                    IsUnconfirmedDate: false,
                    PurchaseOrderNumber: null,
                    WorkOrderNumber: null,
                    ResourceItems: [],
                    Edited: null,
                    CustomFields: [],
                    CustomFieldsValues: [],
                    IsLocked: false,
                    isLockedByPreSchedule: false,
                    BillAfterDate: null,
                    HasBeenCompleted: false,
                    UnlinkTicket: false,
                    HasResourcesAllocated: false,
                    JobDisplayDate: null,
                    UnlinkedFormTemplates: [],
                    LinkedFormTemplates: [],
                    OverriddenFormTemplates: [],
                    ExcludedDocuments: [],
                    OverriddenDocuments: [],
                    Tags: [],
                    IsEmailSent: null,
                    HasGeneratedPaperworkPdf: false,
                    CostEstimateNumber: null,
                    IsLongRunningJob: false
                };

            self.map = mapper;
            self.transformToModel = transformToModel;
            self.transformToServerModel = transformToServerModel;
            self.reset = reset;

            self.map(options);

            function mapper(opts) {

                var mapValue = opts || {};
                var opts = angular.extend(this, defaults, mapValue);
                var timeformat = timeFormat();

                if (opts.JobStartTime) {
                    let start_time = TimeLibrary.convertToServerTime(opts.JobStartTime);
                    this.StartDate = moment(opts.JobStartDate).format('MM/DD/YYYY') + ' ' + start_time;
                }

                if (opts.JobEndTime) {
                    let end_time = TimeLibrary.convertToServerTime(opts.JobEndTime);
                    this.EndDate = moment(opts.JobEndDate)
                        .format('MM/DD/YYYY') + ' ' + end_time;

                    if (this.EndDate <= this.StartDate) {
                        this.EndDate = moment(this.EndDate).add(1, 'days');
                    }

                    if (moment.duration(moment(this.EndDate).diff(moment(this.StartDate))).asHours() > 24) {
                        if (moment.duration(moment(this.EndDate).subtract(1, 'days').diff(moment(this.StartDate))).asHours() < 24) {
                            this.EndDate = moment(this.EndDate).subtract(1, 'days');
                        } else {
                            this.EndDate = moment(this.EndDate).add(1, 'days');
                        }
                    }
                }

                if (opts.StartDate) {
                    this.JobStartDateDisplay = moment(opts.StartDate).format('dddd, MMMM Do YYYY');
                    this.StartDate = opts.StartDate;
                    this.JobStartTime = moment(opts.StartDate).format(timeformat);
                }

                if (opts.EndDate) {
                    this.EndDate = opts.EndDate;
                    this.JobEndTime = moment(opts.EndDate).format(timeformat);
                }
            }

            function reset() {
                this.map(null);
                this.Resource.length = 0;
            }

            function transformToServerModel() {
                var startDate = null;
                var endDate = null;
                var applyOnStartDate = null;
                var applyOnEndDate = null;
                var billAfterDate = null;
                var branchId = null;
                var branchName = null;
                var divisionId = null;
                var divisionName = null;
                var projectId = null;
                var projectName = null;
                var clientId = null;
                var clientName = null;
                var PersonOrderingId = null;
                var PersonOrderingFirstName = null;
                var PersonOrderingLastName = null;
                var siteContactId = null;
                var siteContactFirstName = null;
                var siteContactLastName = null;
                var timeformat = null;

                if (self.Branch) {
                    branchId = self.Branch.Id;
                    branchName = self.Branch.BranchName
                }

                if (self.Division) {
                    divisionId = self.Division.Id != undefined ? self.Division.Id : self.Division.id;
                    divisionName = angular.isUndefined(self.Division.DivisionName) ? self.Division.Name : self.Division.DivisionName
                }

                if (self.Project) {
                    projectId = self.Project.Id != undefined ? self.Project.Id : self.Project.id;
                    projectName = angular.isUndefined(self.Project.ProjectName) ? self.Project.Name : self.Project.ProjectName
                }

                if (self.Client) {
                    clientId = self.Client.Id;
                    clientName = angular.isUndefined(self.Client.ClientName) ? self.Client.Name : self.Client.ClientName
                }

                if (self.PersonOrdering) {
                    PersonOrderingId = self.PersonOrdering.Id;
                    PersonOrderingFirstName = self.PersonOrdering.FirstName
                    PersonOrderingLastName = self.PersonOrdering.LastName
                }

                if (self.SiteContact) {
                    siteContactId = self.SiteContact.Id == null ? self.SiteContact.id : self.SiteContact.Id;
                    siteContactFirstName = self.SiteContact.FirstName
                    siteContactLastName = self.SiteContact.LastName
                }

                timeformat = 'HH:mm:ss';

                if (self.Resource) {
                    if (self.Resource.length > 0) {
                        self.Resource = self.Resource.filter(function(item) {
                            if (item.Id != null) {
                                return item;
                            }
                        });

                        angular.forEach(self.Resource, function(item) {
                            if (item.ApplyOnStartDate) {
                                item._ApplyOnStartDate = item.ApplyOnStartDate;
                                applyOnStartDate = moment(item._ApplyOnStartDate)
                                                    .format('MM/DD/YYYY') + ' ' + moment(moment(item._ApplyOnStartDate, timeformat))
                                                    .format('HH:mm:ss');
                                item.ApplyOnStartDate = moment(applyOnStartDate, 'MM/DD/YYYY' + ' ' + 'HH:mm:ss')
                                                            .format('YYYY-MM-DD HH:mm:ss');
                            }
                            if (item.ApplyOnEndDate) {
                                item._ApplyOnEndDate = item.ApplyOnEndDate;
                                applyOnEndDate = moment(item._ApplyOnEndDate)
                                                    .format('MM/DD/YYYY') + ' ' + moment(moment(item._ApplyOnEndDate, timeformat))
                                                    .format('HH:mm:ss');
                                item.ApplyOnEndDate = moment(applyOnEndDate, 'MM/DD/YYYY' + ' ' + 'HH:mm:ss')
                                                            .format('YYYY-MM-DD HH:mm:ss');
                            }

                            delete(item.billingPeriod);
                            delete(item.ripple);
                        });
                    }
                }
                if (self.ResourceItems) {
                    if (self.ResourceItems.length > 0) {
                        self.ResourceItems = self.ResourceItems.filter(function(item) {
                            if (item.Id != null) {
                                return item;
                            }
                        });
                        angular.forEach(self.ResourceItems, function(item) {
                            delete(item.billingPeriod);
                            delete(item.ripple);
                        });
                    }
                }

                if (self.JobStartTime) {
                    self.StartDate = moment(self.StartDate).format('MM/DD/YYYY') + ' ' +
                                        moment(moment(self.JobStartTime, timeformat)).format('HH:mm:ss');
                }

                if (typeof self.EndDate === 'object' && self.EndDate._i) {
                    self.EndDate = self.EndDate._i;
                }

                if (self.JobEndTime) {
                    self.EndDate = moment(self.EndDate).format('MM/DD/YYYY') + ' ' +
                                    moment(moment(self.JobEndTime, timeformat)).format('HH:mm:ss');
                }

                if (self.StartDate) {
                    startDate = moment(self.StartDate, 'MM/DD/YYYY' + ' ' + 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                }

                if (self.EndDate) {
                    endDate = moment(self.EndDate, 'MM/DD/YYYY' + ' ' + 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                }

                if (self.BillAfterDate) {
                    self.BillAfterDate = moment(self.BillAfterDate).format('MM/DD/YYYY');
                    billAfterDate = moment(self.BillAfterDate, 'MM/DD/YYYY').format('YYYY-MM-DD HH:mm:ss');
                }

                var serverModel = {
                    id: self.id,
                    JobId: self.JobId,
                    TicketNumber: self.TicketNumber,
                    TicketType: self.TicketType,
                    JobDetails: self.JobDetails,
                    Status: self.Status,
                    BranchId: branchId == null ? self.BranchId == undefined ? null : self.BranchId : branchId,
                    BranchName: branchName == null ? self.BranchId == undefined ? null : self.BranchName : branchName,
                    BranchState: self.BranchState,
                    BranchTimezone: self.BranchTimezone,
                    DivisionId: divisionId == null ? self.DivisionId == undefined ? null : self.DivisionId : divisionId,
                    DivisionName: divisionName == null ? self.DivisionId == undefined ? null : self.DivisionName : divisionName,
                    ProjectId: projectId == null ? self.ProjectId == undefined ? null : self.ProjectId : projectId,
                    ProjectName: projectName == null ? self.ProjectId == undefined ? null : self.ProjectName : projectName,
                    CompanyId: clientId == null ? self.CompanyId == undefined ? null : self.CompanyId : clientId,
                    CompanyName: clientName == null ? self.CompanyId == undefined ? null : self.CompanyName : clientName,
                    OrderedByContactId: PersonOrderingId == null ? self.OrderedByContactId == undefined ? null : self.OrderedByContactId : PersonOrderingId,
                    OrderedByContactFirstName: PersonOrderingFirstName == null ? self.OrderedByContactId == undefined ? null : self.OrderedByContactFirstName : PersonOrderingFirstName,
                    OrderedByContactLastName: PersonOrderingLastName == null ? self.OrderedByContactId == undefined ? null : self.OrderedByContactLastName : PersonOrderingLastName,
                    IsQuote: self.IsQuote,
                    HasBeenCompleted: self.HasBeenCompleted,
                    CompanyCode: self.CompanyCode,
                    IsParent: self.IsParent,
                    ParentTicketId: self.ParentTicketId,
                    ParentTicketNumber: self.ParentTicketNumber,
                    RelatedTicketId: self.RelatedTicketId,
                    RelatedTicketNumber: self.RelatedTicketNumber,
                    SiteContactEmail: self.SiteContactEmail,
                    SiteContactMobile: self.SiteContactMobile,
                    OrderedByContactEmail: self.OrderedByContactEmail,
                    OrderedByContactMobile: self.OrderedByContactMobile,
                    JobLocationAddress: self.JobLocation == null ? self.JobLocationAddress : self.JobLocation,
                    SiteContactId: siteContactId == null ? self.SiteContactId == undefined ? null : self.SiteContactId : siteContactId,
                    SiteContactFirstName: siteContactFirstName == null ? self.SiteContactId == undefined ? null : self.SiteContactFirstName : siteContactFirstName,
                    SiteContactLastName: siteContactLastName == null ? self.SiteContactId == undefined ? null : self.SiteContactLastName : siteContactLastName,
                    StartDate: startDate,
                    EndDate: endDate,
                    IsUnconfirmedDate: self.IsUnconfirmedDate,
                    BillingPeriod: self.BillingPeriod,
                    PurchaseOrderNumber: self.PurchaseOrderNumber,
                    WorkOrderNumber: self.WorkOrderNumber,
                    IsCancelled: self.IsCancelled,
                    ResourceItems: self.ResourceItems.length > 0 ? self.ResourceItems : self.Resource,
                    CustomFields: self.CustomFields,
                    CustomFieldsValues: self.CustomFieldsValues,
                    IsLocked: self.IsLocked,
                    IsLockedByPreSchedule: self.IsLockedByPreSchedule,
                    BillAfterDate: billAfterDate,
                    RelockTime: self.RelockTime,
                    UnlockByContactId: self.UnlockByContactId,
                    UnlinkTicket: self.UnlinkTicket,
                    HasResourcesAllocated: self.HasResourcesAllocated,
                    AllResourceAllocationsConfirmed: self.AllResourceAllocationsConfirmed,
                    AllShiftsConfirmed: self.AllShiftsConfirmed,
                    AllEquipmentsAssigned: self.AllEquipmentsAssigned,
                    AllResourcesAllocated: self.AllResourcesAllocated,
                    UnlinkedFormTemplates: self.UnlinkedFormTemplates,
                    LinkedFormTemplates: self.LinkedFormTemplates,
                    OverriddenFormTemplates: self.OverriddenFormTemplates,
                    ExcludedDocuments: self.ExcludedDocuments,
                    OverriddenDocuments: self.OverriddenDocuments,
                    Tags: self.Tags || [],
                    IsEmailSent: self.IsEmailSent,
                    HasGeneratedPaperworkPdf: self.HasGeneratedPaperworkPdf,
                    CostEstimateNumber: self.CostEstimateNumber,
                    UpdateShiftTimes: self.UpdateShiftTimes,
                    IsJobDetailsChangeConfirmed:self.IsJobDetailsChangeConfirmed,
                    ShouldUnallocateResources:self.ShouldUnallocateResources,
                    IsLongRunningJob: self.IsLongRunningJob,
                    PreScheduleJobIds: self.PreScheduleJobIds,
                    LatestPreScheduleJobId: self.LatestPreScheduleJobId
                }
                return serverModel;
            }

            function transformToModel(modelToTransform, transformType) {
                modelToTransform = modelToTransform.m_Item1;
                var billafterdateYear = moment(modelToTransform.BillAfterDate).year();
                var billafterDate = billafterdateYear == 1901 ? null : modelToTransform.BillAfterDate
                var ClonedModel = angular.copy(modelToTransform);
                var UIModel = {};

                if (transformType != 'Cloning') {

                    UIModel = {
                        id: modelToTransform.id,
                        JobId: modelToTransform.JobId,
                        TicketNumber: modelToTransform.TicketNumber,
                        TicketType: modelToTransform.TicketType,
                        Status: modelToTransform.Status,
                        JobDetails: modelToTransform.JobDetails,
                        Branch: {
                            Id: modelToTransform.BranchId,
                            BranchName: modelToTransform.BranchName
                        },
                        BranchState: modelToTransform.BranchState,
                        BranchTimezone: modelToTransform.BranchTimezone,
                        Division: modelToTransform.DivisionId != null && modelToTransform.DivisionName != null ? {
                            id: modelToTransform.DivisionId,
                            Name: modelToTransform.DivisionName
                        } : null,
                        Project: modelToTransform.ProjectId != null && modelToTransform.ProjectName != null ? {
                            Id: modelToTransform.ProjectId,
                            Name: modelToTransform.ProjectName
                        } : null,
                        Client: {
                            Id: modelToTransform.CompanyId,
                            ClientName: modelToTransform.CompanyName
                        },
                        IsQuote: modelToTransform.IsQuote,
                        HasBeenCompleted: modelToTransform.HasBeenCompleted,
                        CompanyCode: modelToTransform.CompanyCode,
                        IsParent: modelToTransform.IsParent,
                        ParentTicketId: modelToTransform.ParentTicketId,
                        ParentTicketNumber: modelToTransform.ParentTicketNumber,
                        RelatedTicketId: modelToTransform.RelatedTicketId,
                        RelatedTicketNumber: modelToTransform.RelatedTicketNumber,
                        SiteContactEmail: modelToTransform.SiteContactEmail,
                        SiteContactMobile: modelToTransform.SiteContactMobile,
                        OrderedByContactEmail: modelToTransform.OrderedByContactEmail,
                        OrderedByContactMobile: modelToTransform.OrderedByContactMobile,
                        JobLocation: modelToTransform.JobLocationAddress,
                        SiteContact: {
                            Id: modelToTransform.SiteContactId,
                            FirstName: modelToTransform.SiteContactFirstName,
                            LastName: modelToTransform.SiteContactLastName,
                            FullName: modelToTransform.SiteContactFirstName + ' ' + modelToTransform.SiteContactLastName
                        },
                        SiteContactName: modelToTransform.SiteContactFirstName + ' ' + modelToTransform.SiteContactLastName,
                        PersonOrdering: {
                            Id: modelToTransform.OrderedByContactId,
                            FirstName: modelToTransform.OrderedByContactFirstName,
                            LastName: modelToTransform.OrderedByContactLastName,
                            FullName: modelToTransform.OrderedByContactFirstName + ' ' + modelToTransform.OrderedByContactLastName
                        },
                        JobStartDate: modelToTransform.StartDate,
                        JobEndDate: modelToTransform.EndDate,
                        JobStartTime: moment(ClonedModel.StartDate)
                            .format(timeFormat()),
                        LengthOfShift: parseInt(utils.computeLengthofShift(ClonedModel.StartDate, ClonedModel.EndDate)),
                        BillingPeriod: modelToTransform.BillingPeriod,
                        IsUnconfirmedDate: modelToTransform.IsUnconfirmedDate,
                        PurchaseOrderNumber: modelToTransform.PurchaseOrderNumber,
                        WorkOrderNumber: modelToTransform.WorkOrderNumber,
                        IsCancelled: modelToTransform.IsCancelled,
                        Resource: modelToTransform.ResourceItems,
                        CustomFields: modelToTransform.CustomFields,
                        InvoiceStatus: modelToTransform.InvoiceStatus,
                        IsLocked: modelToTransform.IsLocked,
                        IsLockedByPreSchedule: modelToTransform.IsLockedByPreSchedule,
                        BillAfterDate: billafterDate,
                        RelockTime: modelToTransform.RelockTime,
                        UnlockByContactId: modelToTransform.UnlockByContactId,
                        HasResourcesAllocated: modelToTransform.HasResourcesAllocated,
                        AllResourceAllocationsConfirmed: modelToTransform.AllResourceAllocationsConfirmed,
                        AllShiftsConfirmed: modelToTransform.AllShiftsConfirmed,
                        AllEquipmentsAssigned: modelToTransform.AllEquipmentsAssigned,
                        AllResourcesAllocated: modelToTransform.AllResourcesAllocated,
                        UnlinkTicket: modelToTransform.UnlinkTicket,
                        ChargeMinimumHours: modelToTransform.ChargeMinimumHours,
                        JobDisplayDate: modelToTransform.JobDisplayDate,
                        UnlinkedFormTemplates: modelToTransform.UnlinkedFormTemplates,
                        LinkedFormTemplates: modelToTransform.LinkedFormTemplates,
                        OverriddenFormTemplates: modelToTransform.OverriddenFormTemplates,
                        ExcludedDocuments: modelToTransform.ExcludedDocuments,
                        OverriddenDocuments: modelToTransform.OverriddenDocuments,
                        Tags: modelToTransform.Tags,
                        IsEmailSent: modelToTransform.IsEmailSent,
                        HasGeneratedPaperworkPdf: modelToTransform.HasGeneratedPaperworkPdf,
                        CostEstimateNumber: modelToTransform.CostEstimateNumber,
                        IsLongRunningJob: modelToTransform.IsLongRunningJob,
                        PreScheduleJobIds: modelToTransform.PreScheduleJobIds,
                        LatestPreScheduleJobId: modelToTransform.LatestPreScheduleJobId
                    }
                } else {
                    UIModel = {
                        id: null,
                        JobId: null,
                        TicketNumber: null,
                        TicketType: modelToTransform.TicketType,
                        Status: modelToTransform.Status,
                        JobDetails: modelToTransform.JobDetails,
                        Branch: {
                            Id: modelToTransform.BranchId,
                            BranchName: modelToTransform.BranchName
                        },
                        BranchState: modelToTransform.BranchState,
                        BranchTimezone: modelToTransform.BranchTimezone,
                        Division: modelToTransform.DivisionId != null && modelToTransform.DivisionName != null ? {
                            id: modelToTransform.DivisionId,
                            Name: modelToTransform.DivisionName
                        } : null,
                        Project: modelToTransform.ProjectId != null && modelToTransform.ProjectName != null ? {
                            Id: modelToTransform.ProjectId,
                            Name: modelToTransform.ProjectName
                        } : null,
                        Client: {
                            Id: modelToTransform.CompanyId,
                            Name: modelToTransform.CompanyName
                        },
                        IsQuote: modelToTransform.IsQuote,
                        HasBeenCompleted: false,
                        CompanyCode: modelToTransform.CompanyCode,
                        IsParent: modelToTransform.IsParent,
                        ParentTicketId: modelToTransform.ParentTicketId,
                        ParentTicketNumber: modelToTransform.ParentTicketNumber,
                        RelatedTicketId: modelToTransform.RelatedTicketId,
                        RelatedTicketNumber: modelToTransform.RelatedTicketNumber,
                        SiteContactEmail: modelToTransform.SiteContactEmail,
                        SiteContactMobile: modelToTransform.SiteContactMobile,
                        OrderedByContactEmail: modelToTransform.OrderedByContactEmail,
                        OrderedByContactMobile: modelToTransform.OrderedByContactMobile,
                        JobLocation: modelToTransform.JobLocationAddress,
                        SiteContact: {
                            Id: modelToTransform.SiteContactId,
                            FirstName: modelToTransform.SiteContactFirstName,
                            LastName: modelToTransform.SiteContactLastName,
                            FullName: modelToTransform.SiteContactFirstName + ' ' + modelToTransform.SiteContactLastName
                        },
                        SiteContactName: modelToTransform.SiteContactFirstName + ' ' + modelToTransform.SiteContactLastName,
                        PersonOrdering: {
                            Id: modelToTransform.OrderedByContactId,
                            FirstName: modelToTransform.OrderedByContactFirstName,
                            LastName: modelToTransform.OrderedByContactLastName,
                            FullName: modelToTransform.OrderedByContactFirstName + ' ' + modelToTransform.OrderedByContactLastName
                        },
                        JobStartDate: null,
                        JobEndDate: modelToTransform.EndDate,
                        JobStartTime: moment(ClonedModel.StartDate).format(timeFormat()),
                        LengthOfShift: parseInt(utils.computeLengthofShift(ClonedModel.StartDate, ClonedModel.EndDate)),
                        BillingPeriod: modelToTransform.BillingPeriod,
                        IsUnconfirmedDate: modelToTransform.IsUnconfirmedDate,
                        PurchaseOrderNumber: modelToTransform.PurchaseOrderNumber,
                        WorkOrderNumber: modelToTransform.WorkOrderNumber,
                        IsCancelled: false,
                        Resource: modelToTransform.ResourceItems,
                        CustomFields: modelToTransform.CustomFields,
                        InvoiceStatus: null,
                        IsLocked: false,
                        IsLockedByPreSchedule: false,
                        BillAfterDate: null,
                        RelockTime: null,
                        UnlockByContactId: null,
                        HasResourcesAllocated: false,
                        AllResourceAllocationsConfirmed: false,
                        AllShiftsConfirmed: false,
                        AllEquipmentsAssigned: false,
                        AllResourcesAllocated: false,
                        UnlinkTicket: modelToTransform.UnlinkTicket,
                        ChargeMinimumHours: modelToTransform.ChargeMinimumHours,
                        JobDisplayDate: modelToTransform.JobDisplayDate,
                        UnlinkedFormTemplates: modelToTransform.UnlinkedFormTemplates,
                        LinkedFormTemplates: modelToTransform.LinkedFormTemplates,
                        ExcludedDocuments: modelToTransform.ExcludedDocuments,
                        OverriddenDocuments: modelToTransform.OverriddenDocuments,
                        Tags: [],
                        IsEmailSent: modelToTransform.IsEmailSent,
                        HasGeneratedPaperworkPdf: modelToTransform.HasGeneratedPaperworkPdf,
                        CostEstimateNumber: modelToTransform.CostEstimateNumber,
                        IsLongRunningJob: modelToTransform.IsLongRunningJob
                    }
                }

                return UIModel;
            }

            function timeFormat() {
                return 'HH:mm';
            }
        };
    }
}

(function () {
  'use strict';

  angular.module('app.jobs')
    .service('JobsViewFilterModel', JobsViewFilterModel)

  function JobsViewFilterModel(moment, utils) {
    return function () {
      var self = this,
        defaults = {
          ticketNo: '',
          isQuotesOnly: false,
          jobType: null,
          branches: [],
          isIncludeRelated: false,
          filterType: null,
          startDate: null,
          endDate: null,
          IsCancelled: false,
          tagIds: [], //include
          excludedTagIds: [], //exclude
          ticketStatus: []
        };

      angular.extend(self, defaults);

      self.map = mapper;
      self.reset = reset;
      self.tranformToServerModel = transformToModel;
      self.isEmpty = isEmpty;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend(self, mapValue);
      }

      function reset() {
          self.map(null);
      }

      function isEmpty() {
        let result = utils.isNullOrEmpty(self.ticketNo) &&
           self.isQuotesOnly == false &&
           self.IsCancelled == false &&
           utils.isNullOrEmpty(self.jobType) &&
           (self.branches.length == 0) &&
           self.isIncludeRelated == false &&
           utils.isNullOrEmpty(self.filterType) &&
           utils.isNullOrEmpty(self.startDate) &&
           utils.isNullOrEmpty(self.endDate) &&
           utils.isNullOrEmpty(self.tagIds) &&
           utils.isNullOrEmpty(self.excludedTagIds) &&
           utils.isNullOrEmpty(self.ticketStatus);

        return result;
      }

      function transformToModel() {
        return {
          TicketNo: self.ticketNo,
          IsQuotes: self.isQuotesOnly,
          JobType: self.jobType,
          Branches: self.branches,
          IsIncludeRelated: self.isIncludeRelated,
          FilterType: self.filterType,
          StartDate: self.startDate != null ? moment(self.startDate).format('YYYY/MM/DD') : null,
          EndDate: self.endDate != null ? moment(self.endDate).format('YYYY/MM/DD') : null,
          IsCancelled : self.IsCancelled,
          tagIds : self.tagIds,
          excludedTagIds : self.excludedTagIds,
          TicketStatus : self.ticketStatus
        };
      }
    }
  }
})();

{
    angular.module('app.jobs')
        .service('jobDataModel', jobDataModel);

    function jobDataModel(AssetDataModel, localisationService, TimeLibrary) {
        return function(options) {
            var self = this,
                defaults = {
                    id: null,
                    TicketType: null,
                    Branch: null,
                    BranchName: null,
                    Division: null,
                    DivisionName: null,
                    Project: null,
                    ProjectName: null,
                    Client: null,
                    ClientName: null,
                    PersonOrdering: null,
                    IsQuote: null,
                    JobLocation: null,
                    SiteContact: null,
                    JobStartDate: null,
                    JobDuration: 1,
                    JobEndDate: null,
                    JobStartTime: null,
                    JobEndTime: null,
                    LengthOfShift: null,
                    Is24HourRotation: null,
                    IsParent: null,
                    ParentTicketId: null,
                    ParentTicketNumber: null,
                    RelatedTicketId: null,
                    RelatedTicketNumber: null,
                    JobDetails: null,
                    BillingPeriod: 1,
                    IsUnconfirmedDate: false,
                    PurchaseOrderNumber: null,
                    WorkOrderNumber: null,
                    Resource: [],
                    CustomFields: [],
                    IsLocked: false,
                    IsLockedByPreSchedule: false,
                    BillAfterDate: null,
                    HasBeenCompleted: false,
                    HasResourcesAllocated: false,
                    IsCancelled: false,
                    UnlinkTicket: false,
                    ChargeMinimumHours: false,
                    isThisAQuote: false,
                    JobDisplayDate: null,
                    UnlinkedFormTemplates: [],
                    LinkedFormTemplates: [],
                    OverriddenFormTemplates: [],
                    ExcludedDocuments: [],
                    OverriddenDocuments: [],
                    Tags: [],
                    HasGeneratedPaperworkPdf: false,
                    IsLongRunningJob: false
                };

            self.map = mapper;
            self.transformToModel = transformToModel;
            self.reset = reset;

            self.map(options);

            function mapper(opts) {
                var mapValue = opts || {},
                    opts = angular.extend(this, defaults, mapValue);

                var localeSettings = localisationService.getLocaleFormatSettings();
                var timeformat = localeSettings.timeFormat;

                if (opts.JobStartDate) {
                    var startDate = angular.copy(opts.JobStartDate);
                    this.JobStartDate = new Date(moment(startDate, 'YYYY-MM-DD').format('MM/DD/YYYY'));
                    this.JobStartTime = moment(startDate).format(timeformat);
                }

                if (opts.JobEndDate) {
                    var endDate = angular.copy(opts.JobEndDate);
                    this.JobEndDate = new Date(moment(endDate, 'YYYY-MM-DD').format('MM/DD/YYYY'));
                    this.JobEndTime = moment(endDate).format(timeformat);
                }

                if (opts.BillAfterDate) {
                    var billAfterDate = angular.copy(opts.BillAfterDate);
                    this.BillAfterDate = new Date(moment(billAfterDate, 'YYYY-MM-DD').format('MM/DD/YYYY'));
                }

                if (opts.JobLocation) {
                    this.JobLocation = opts.JobLocation;
                }

                if (opts.Resource.length > 0) {
                    var cloneResource = angular.copy(opts.Resource);
                    opts.Resource = [];
                    angular.forEach(cloneResource, function(item) {
                        var asset = new AssetDataModel();
                        asset.map(item);
                        opts.Resource.push(asset);
                    });
                    this.Resource = opts.Resource;
                }
            }

            function reset() {
                this.map(null);
                this.Resource.length = 0;
            }

            function transformToModel() {

                var DivisionId = null,
                    DivisionName = null,
                    ProjectId = null,
                    ProjectName = null,
                    startDate = null,
                    endDate = null,
                    isoDate = null;

                var localisationSettings = localisationService.getLocaleFormatSettings();
                isoDate = localisationSettings.isoDateTime;

                if (self.JobStartDate) {
                    let start_time = TimeLibrary.convertToServerTime(self.JobStartTime);
                    startDate = moment(self.JobStartDate).format('MM/DD/YYYY') + ' ' + start_time;
                }

                if (self.JobEndDate && self.JobEndTime) {
                    let end_time = TimeLibrary.convertToServerTime(self.JobEndTime);
                    endDate = moment(self.JobEndDate).format('MM/DD/YYYY') + ' ' + end_time;
                }

                if (!self.JobEndDate && self.JobEndTime) {
                    let end_time = TimeLibrary.convertToServerTime(self.JobEndTime);
                    endDate = moment(self.JobStartDate).format('MM/DD/YYYY') + ' ' + end_time;
                }

                if (self.JobEndDate && !self.JobEndTime) {
                    endDate = moment(self.JobEndDate).format('MM/DD/YYYY');
                }

                if (self.BillAfterDate) {
                    BillAfterDate = moment(self.BillAfterDate).format('MM/DD/YYYY');
                }

                if (self.Project) {
                    ProjectId = angular.isUndefined(self.Project.Id) ? self.Project.id : self.Project.Id;
                    ProjectName = self.Project.Name;
                }
                if (self.Division) {
                    DivisionId = angular.isUndefined(self.Division.Id) ? self.Division.id : self.Division.Id;
                    DivisionName = self.Division.Name;
                }

                if (self.Resource) {
                    if (self.Resource.length > 0) {
                        self.Resource = self.Resource.filter(function(item) {
                            if (item.Id != null) {
                                return item;
                            }
                        });
                        angular.forEach(self.Resource, function(item) {
                            delete(item.billingPeriod);
                            delete(item.ripple);
                        });
                    }
                }

                var serverModel = {
                    id: self.id,
                    TicketType: self.TicketType,
                    BranchId: self.Branch.Id,
                    BranchName: self.Branch.Name,
                    DivisionId: DivisionId,
                    DivisionName: DivisionName,
                    ProjectId: ProjectId,
                    ProjectName: ProjectName,
                    CompanyId: self.Client.Id,
                    CompanyName: self.Client.Name,
                    Tags: self.Tags,
                    IsQuote: self.isThisAQuote,
                    IsBillable: self.IsBillable,
                    OrderedByContactId: self.PersonOrdering.Id,
                    OrderedByContactFirstName: self.PersonOrdering.FirstName,
                    OrderedByContactLastName: self.PersonOrdering.LastName,
                    JobLocation: self.JobLocation,
                    SiteContactId: self.SiteContact.Id,
                    SiteContactFirstName: self.SiteContact.FirstName,
                    SiteContactLastName: self.SiteContact.LastName,
                    JobStartDate: moment(startDate, 'MM/DD/YYYY HH:mm:ss').format(isoDate),
                    JobDuration: self.JobDuration,
                    JobEndDate: endDate != null ? moment(endDate, 'MM/DD/YYYY HH:mm:ss').format(isoDate) : endDate,
                    LengthOfShift: self.LengthOfShift,
                    Is24HourRotation: self.Is24HourRotation,
                    IsParent: self.IsParent,
                    ParentTicketId: self.ParentTicketId,
                    ParentTicketNumber: self.ParentTicketNumber,
                    RelatedTicketId: self.RelatedTicketId,
                    RelatedTicketNumber: self.RelatedTicketNumber,
                    JobDetails: self.JobDetails,
                    BillingPeriod: self.BillingPeriod ? self.BillingPeriod.Id : null,
                    IsUnconfirmedDate: self.IsUnconfirmedDate,
                    PurchaseOrderNumber: self.PurchaseOrderNumber,
                    WorkOrderNumber: self.WorkOrderNumber,
                    ResourceItems: self.Resource,
                    BillAfterDate: self.BillAfterDate,
                    CustomFields: self.CustomFields,
                    IsLocked: self.IsLocked,
                    IsLockedByPreSchedule: self.IsLockedByPreSchedule,
                    UnlinkedFormTemplates: self.UnlinkedFormTemplates,
                    LinkedFormTemplates: self.LinkedFormTemplates,
                    OverriddenFormTemplates: self.OverriddenFormTemplates,
                    ExcludedDocuments: self.ExcludedDocuments,
                    OverriddenDocuments: self.OverriddenDocuments,
                    IsLongRunningJob:  self.IsLongRunningJob
                }

                return serverModel;
            }
        };
    }
}

/**
 * Created by Ben Rei on 8/23/2016.
 */
(function() {
  'use strict';

  angular.module('app.jobs')
    .service('ItemTypesViewModel', ItemTypesViewModel)
  function ItemTypesViewModel() {
      return function (){
        function ItemType(){
          this.Asset = 1;
          this.Inventory = 2;
          this.Rental = 3;
          this.People = 4;
        }
      }
  }
})();

/**
 * Created by Ben Rei on 8/18/2016.
 */
(function() {
  'use strict';

  angular.module('app.jobs')
    .service('AssetDataModel', AssetDataModel)

  function AssetDataModel() {
    return function () {
      var self = this,
        defaults = {
          id : null,
          assetName : null,
          assetQty : null,
          assetType : null,
        };
      angular.extend(self, defaults);

      self.map = mapper;
      self.reset = reset;
      self.tranformToServerModel = transformToModel;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend(self, mapValue);
      }

      function reset() {
        self.map(null);
      }

      function transformToModel() {

        return {
          id: self.id,
          assetName : self.assetName,
          assetQty : self.assetQty,
          assetType : self.assetType
        };
      }
    }
  };
})();

/**
 * Created by Ben Rei on 8/18/2016.
 */
(function() {
  'use strict';

  angular.module('app.jobs')
    .service('AssetDataModel', AssetDataModel)

  function AssetDataModel() {
    return function () {
      var self = this,
        defaults = {
          Id : null,
          assetName : null,
          assetQty : null,
          assetType : null,
          billingPeriod : null,
          ItemBillingPeriod: null,
          BillingPeriod : null,

          IsDeleted: null,
          IsNew: null,
          UpdateTransaction: null,
          ApplyOnStartDate: null,
          ApplyOnEndDate: null,

          isBillable : null,
          IsAllocatable : null,
          InvoiceGroupName : null
        };
          angular.extend(self, defaults);

      self.map = mapper;
      self.reset = reset;
      self.tranformToServerModel = transformToModel;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend(self, mapValue);

        if(opts.BillingPeriod != null) {
          this.billingPeriod = opts.BillingPeriod;
        }
        if(opts.IsItemBillable){
          this.isBillable = opts.IsItemBillable;
        }

      }

      function reset() {
        self.map(null);
      }

      function transformToModel() {
        var serverModel = {
          Id: self.id,
          ItemName : self.assetName,
          ItemQuantity : self.assetQty,
          ItemTypes : self.assetType,
          billingPeriod : self.billingPeriod,
          ItemBillingPeriod: isNaN(self.ItemBillingPeriod) ? 1 : self.ItemBillingPeriod,
          BillingPeriod : isNaN(self.BillingPeriod) ? 1 : self.BillingPeriod,

          IsDeleted: self.IsDeleted,
          IsNew: self.IsNew,
          UpdateTransaction: self.UpdateTransaction,
          ApplyOnStartDate: self.ApplyOnStartDate,
          ApplyOnEndDate: self.ApplyOnEndDate,

          IsItemBillable : self.isBillable,
          isBillable : self.isBillable,
          IsAllocatable : self.IsAllocatable,
          InvoiceGroupName : self.InvoiceGroupName,
          ItemPrerequisites:[]
        };
        return serverModel;
      }
    }
  };
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.mapView', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.jobs_map_view', {
            url: '/jobs/map',
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/mapView/jobs-map-view.html',
                    controller: 'JobMapController as vm'
                }
            },
            data: {
                requireLogin: true
            },
            title: 'Map View',
            titleBar: 'Map View',
        });

        $translatePartialLoaderProvider.addPart('app/main/jobs/mapView');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.mapView')
        .controller('JobMapController', JobMapController);

    /** @ngInject */
    function JobMapController(
        $q,
        branchService,
        companyViewService,
        projectApi,
        tagsApi,
        ticketsApi
    ) {
        let vm = this;
        vm.gMap = null;
        vm.tickets = [];

        vm.branches = [];
        vm.companies = []
        vm.projects = [];
        vm.tags = [];
        vm.filters = {
            selectedBranchIds: ['11af2c2b-6146-4e7e-b4be-b1ad8231e6c3'],
            selectedCompanyIds: [],
            selectedProjectIds: [],
            selectedTagIds: [],
            startDate: '2021-08-28T00:00:00',
            endDate: '2021-09-01T00:00:00',
        };

        vm.loadTickets = loadTickets;

        activate();

        async function activate() {
            let lookupResponse = await getAllLookups();
            vm.branches = lookupResponse[0];
            vm.companies = lookupResponse[1].data;
            vm.projects = lookupResponse[2].data;
            vm.tags = lookupResponse[3].data;
        }

        async function loadTickets() {
            let ticketsResponse = await ticketsApi.getTicketsWithFilters(vm.filters);
            vm.tickets = ticketsResponse.data;

            var bounds = new google.maps.LatLngBounds();

            vm.gMap = new google.maps.Map(document.getElementById('googleMap'), {
                zoom: 4,
                center: new google.maps.LatLng(25.2744, 133.7751),
                mapTypeId: google.maps.MapTypeId.TERRAIN
            });

            var winInfo = new google.maps.InfoWindow();

            var oms = new OverlappingMarkerSpiderfier(vm.gMap, {
                markersWontMove: true,
                markersWontHide: true,
                basicFormatEvents: true
            });

            var markers = [];

            vm.tickets.forEach(function(ticket) {
                (function() {
                    var marker = new google.maps.Marker({
                        // map: vm.gMap,
                        position: new google.maps.LatLng(ticket.JobLocationAddress.Location.Latitude, ticket.JobLocationAddress.Location.Longitude),
                        title: `${ticket.TicketNumber}`
                    });
                    marker.content = '<div>' + ticket.id + '</div>';

                    bounds.extend(marker.position);

                    google.maps.event.addListener(marker, 'spider_click', function() {
                        winInfo.setContent('<h1>' + marker.title + '</h1>' + marker.content);
                        winInfo.open(vm.gMap, marker);
                    });

                    markers.push(marker);

                    oms.addMarker(marker);
                })();
            });

            new MarkerClusterer(vm.gMap, markers, {
                maxZoom: 13,
                imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
            });

            vm.gMap.fitBounds(bounds);
        }

        function getAllLookups() {
            var deferred = $q.defer();

            var branches = branchService.getAllBranches();
            var clients = companyViewService.getCompanies();
            var projects = projectApi.getProjects();
            var tags = tagsApi.getActiveTags();
            var promises = [branches, clients, projects, tags];

            $q.all(promises).then(function(response) {
                deferred.resolve(response);
            });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.jobs.manage')
        .controller('JobsCreateController', JobsCreateController);

    function JobsCreateController(
        historyLogService,
        auditApi,
        commentService,
        jobService,
        claimsUtilService,
        adminClaimsService,
        jobsClaimsService,
        $state,
        $stateParams,
        $location,
        $mdDialog,
        customFieldsService,
        customFieldsUtils,
        $compile,
        $scope,
        customisedFieldsFactory,
        $document,
        $timeout,
        $translate,
        blockUI,
        utils,
        hubService,
        translationService,
        timeSheetService,
        TimeLibrary,
        msgboxService,
        allocationApi,
        smartSchedulingService,
        ticketType,
        jobsApi
    ) {

        var vm = this;
        vm.service = jobService;
        vm.translationService = translationService;
        vm.showFields2 = false;
        vm.showFields = false;
        vm.CustomisedFieldsBackUp = vm.service.customisedFields;
        vm.isCustomizedFIeldsInvalid = null;
        vm.checkAccessService = claimsUtilService;
        vm.showHistory = showHistory;
        vm.viewComments = viewComments;
        vm.openMenu = openMenu;
        vm.chargeMinimum = chargeMinimum;
        vm.unlinkTicket = unlinkTicket;
        vm.adminClaimsService = adminClaimsService;
        vm.saveJob = saveJob;
        vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
        vm.isCustomFormsEnabled = claimsUtilService.isCustomFormsEnabled();
        vm.showSubmitError = false;
        vm.disableSaveButton = disableSaveButton;

        //For Customized Fields
        vm.editField = editField;
        vm.showCustomisedFieldsModal = showCustomisedFieldsModal;
        vm.showCustomisedFields = showCustomisedFields;
        vm.getCustomFields = getCustomFields;
        vm.changeFields = changeFields;
        vm.deleteField = deleteField;
        vm.lockUnlockTicket = lockUnlockTicket;
        vm.generatePreSchedule = generatePreSchedule;
        vm.showAllocateResourceBySmartScheduling = showAllocateResourceBySmartScheduling;
        vm.cancelScheduling = cancelScheduling;
        vm.retrySchedulingCopilot = retrySchedulingCopilot;
        vm.hasSmartSchedulingAccess = claimsUtilService.hasSmartSchedulingAccess();
        vm.showChargeMinimumHoursButton = showChargeMinimumHoursButton;
        vm.openChargeMinimumHoursDialog = openChargeMinimumHoursDialog;

        activate();

        function activate() {
            $translate(['MANAGE.VIEWTICKET', 'MANAGE.EDITTICKET']).then(async function(translations) {
                vm.title = translationService.title;
                jobService.isEditMode = false;
                jobService.isCloning = false;
                jobService.ticketId = null;
                jobService.costEstimateGroupId = null;
                jobService.isContactFieldValid = jobService.jobModel.SiteContact && jobService.jobModel.PersonOrdering ? true : false;

                if ($stateParams.id) {
                    jobService.isEditMode = true;
                    jobService.ticketId = $stateParams.id;
                    setJobDisplayDate();
                    jobService.loadAllocatedResources(jobService.ticketId);
                } else if ($stateParams.cloneId) {
                    // Booking from a cost estimate travels through the clone route and stays open to
                    // everyone. Those params are transition-only, so a pasted URL never carries them.
                    var isCostEstimateBooking = !!($stateParams.costEstimateGroupId || $stateParams.costEstimateId);

                    if (!isCostEstimateBooking && !jobsClaimsService.hasCloneJobsPermission) {
                        $state.go('app.pages_errors_error-403', {
                            returnUrl: encodeURIComponent($location.path())
                        });
                        return;
                    }

                    jobService.isCloning = true;
                    jobService.ticketId = $stateParams.cloneId;
                    jobService.costEstimateGroupId = $stateParams.hasOwnProperty('costEstimateGroupId') ? $stateParams.costEstimateGroupId : null;
                    jobService.costEstimateId = $stateParams.hasOwnProperty('costEstimateId') ? $stateParams.costEstimateId : null;
                    jobService.JobDuration = (jobService.costEstimateId != null || jobService.costEstimateGroupId != null) ? $stateParams.ticketCount : 1;
                } else {
                    jobService.dateParam = null;
                    jobService.jobModel.reset();

                    if ($stateParams.dt) {
                        jobService.dateParam = new Date(moment($stateParams.dt, 'YYYY-MM-DD').format('MM/DD/YYYY'));
                    }
                }
            });

            setupWatcherForMultidayJobFlag();
        }

        async function confirmShiftTimesUpdate() {
            let dialog = jobService.showUpdateShiftTimesDialog(jobService.jobModel);
            await $mdDialog.show(dialog).then(function(res) {
                jobService.updateShiftTimes = res.result;
            });
        }

        async function confirmUnallocateResources() {
            let dialog = jobService.showUnconfirmJobDialog();
            await $mdDialog.show(dialog).then(function(res) {
                jobService.shouldUnallocateResources = res.result;
                jobService.jobModel.HasResourcesAllocated = !res.result;
            });
        }

        function requiresShiftUpdates() {
            var isNewTimeSet = false;

            if (jobService.currentJobStartTime) {
                var originalJobStartTime = TimeLibrary.convertTime(
                    jobService.currentJobStartTime
                );
                var originalJobEndTime = TimeLibrary.convertTime(
                    jobService.currentJobEndTime
                );

                var currentJobStartTime = TimeLibrary.convertTime(
                    jobService.jobModel.JobStartTime
                );
                var currentJobEndTime = TimeLibrary.convertTime(
                    jobService.jobModel.JobEndTime
                );

                if (originalJobStartTime && originalJobEndTime) {
                    isNewTimeSet =
                        originalJobStartTime !== currentJobStartTime ||
                        originalJobEndTime !== currentJobEndTime;
                }
            }

            return (
                (jobService.jobModel.TicketType === ticketType.FULL_SERVICE
                    || jobService.jobModel.TicketType === ticketType.INTERNAL
                    || jobService.jobModel.TicketType === ticketType.TRAVEL_ONLY) &&
                isNewTimeSet &&
                jobService.isEditMode
            );
        }

        async function isConfirmedOrAllocatedShiftTimeEqualJobTime(data){
            let isTimeEqual = true;

            let currentJobStartTime = TimeLibrary.convertTime(
                jobService.jobModel.JobStartTime
            );
            let currentJobEndTime = TimeLibrary.convertTime(
                jobService.jobModel.JobEndTime
            );

            if(data.length){
                for(let item of data){
                    const isResourceConfirmedOrAllocated = item.Status === 3 || item.Status === 2;
                    let shiftStartTime = TimeLibrary.convertTime(item.StartTime);
                    let shiftEndTime = TimeLibrary.convertTime(item.FinishTime);

                    if((item.AllocatedId !== null && isResourceConfirmedOrAllocated) && (shiftStartTime !== currentJobStartTime || shiftEndTime !== currentJobEndTime)){
                        isTimeEqual = false;
                        break;
                    }
                }
            }

            return isTimeEqual;
        }

        function isJobDateChange() {
            var isNewDateSet = false;
            if (jobService.currentJobStartDate) {
                isNewDateSet =
                    jobService.currentJobStartDate.valueOf() !==
                    jobService.jobModel.JobStartDate.valueOf();
            }

            return (
                (jobService.jobModel.TicketType === ticketType.FULL_SERVICE
                    || jobService.jobModel.TicketType === ticketType.INTERNAL
                    || jobService.jobModel.TicketType === ticketType.TRAVEL_ONLY) &&
                isNewDateSet &&
                jobService.isEditMode
            );
        }

        function isOrderByDetailChange() {
            var isClientUpdated = false;
            var isDivisionUpdated = false;
            var isProjectUpdated = false;

            if (jobService.selectedClient && jobService.jobModel.Client != null) {
                isClientUpdated = jobService.selectedClient.Id.valueOf() !== jobService.jobModel.Client.Id.valueOf();
            }

            if (jobService.selectedDivision && jobService.jobModel.Divison == null || !jobService.selectedDivision == null && jobService.jobModel.Division != null) {
                isDivisionUpdated = true;
            } else if (jobService.selectedDivision && jobService.jobModel.Division != null) {
                var hasExisingDivision = !angular.isUndefined(jobService.selectedDivision.Id);

                if (hasExisingDivision) {
                    isDivisionUpdated = jobService.selectedDivision.Id.valueOf() !== jobService.jobModel.Division.id.valueOf();
                } else {
                    isDivisionUpdated = true;
                    jobService.selectedDivision = null
                }
            }

            if (jobService.selectedProject && jobService.jobModel.Project == null || !jobService.selectedProject == null && jobService.jobModel.Project != null) {
                isProjectUpdated = true;
            } else if (jobService.selectedProject && jobService.jobModel.Project != null) {
                var hasExistingProject = !angular.isUndefined(jobService.selectedProject.Id);
                var originalProjectId = angular.isUndefined(jobService.jobModel.Project.Id) ? jobService.jobModel.Project.id.valueOf() : jobService.jobModel.Project.Id.valueOf();

                if (hasExistingProject) {
                    isProjectUpdated = jobService.selectedProject.Id.valueOf() !== originalProjectId;
                } else {
                    isProjectUpdated = true;
                    jobService.selectedProject = null
                }
            }

            var isUpdated = isClientUpdated || isDivisionUpdated || isProjectUpdated;

            return (
                (jobService.jobModel.TicketType === ticketType.FULL_SERVICE ||
                jobService.jobModel.TicketType === ticketType.TRAVEL_ONLY
                ) &&
                isUpdated &&
                jobService.isEditMode
            );
        }


        async function saveJob(currentForm) {
            vm.service.isSaving = true;

            if ($scope.stepper.$invalid) {
                angular.forEach($scope.stepper.$error, function(field) {
                    angular.forEach(field, function(errorField) {
                        errorField.$setTouched();
                    })
                });
            }

            if(!jobService.customFieldsValid.$valid){
                angular.forEach(jobService.customFieldsValid.$error, function(field) {
                    angular.forEach(field, function(errorField) {
                        errorField.$setTouched();
                    })
                });
            }

            if (!currentForm.$valid || (!angular.isUndefined(jobService.customFieldsValid.$valid) && !jobService.customFieldsValid.$valid)) {
                vm.showSubmitError = true;
                $timeout(function() {
                    scrollToInvalidInput();
                }, 0);

                return;
            }

            if (!jobService.isContactFieldValid) {
                $timeout(function() {
                    scrollToInvalidInput();
                }, 0);

                return;
            }

            vm.showSubmitError = false;
            jobService.shouldUnallocateResources = false;
            currentForm.$setPristine();
            jobService.saveMonitor = !jobService.saveMonitor;
            jobService.jobModel.CustomFields = customFieldsUtils.bindData(
                vm.service.customisedFields,
                jobService.values
            );
            jobService.jobModel.ExcludedDocuments = Array.from(
                vm.service.excludedDocuments
            );
            jobService.jobModel.LinkedFormTemplates = vm.service.linkedFormTemplates;
            jobService.jobModel.UnlinkedFormTemplates = vm.service.unlinkedFormTemplates;
            jobService.jobModel.OverriddenFormTemplates = vm.service.overriddenFormTemplates;

            let hasShiftUpdates = requiresShiftUpdates();
            let hasJobDateUpdates = isJobDateChange();
            let hasOrderByChanged = isOrderByDetailChange();

            if (jobService.ticketId) {
                const hasSubmittedTimesheets = await timeSheetService.checkIfJobHasTimesheet(jobService.ticketId);
                let allocatedResource = await allocationApi.fetchTicket(jobService.ticketId);
                let isJobTimeAndShiftTimeEqual = await isConfirmedOrAllocatedShiftTimeEqualJobTime(allocatedResource.data);
                jobService.jobModel.HasConfirmedResources = allocatedResource.data.some(x => x.Status === 3)

                if(hasSubmittedTimesheets && jobService.jobModel.TicketType === ticketType.PLAN_ONLY){
                    var dialog = $mdDialog
                            .confirm()
                            .htmlContent(utils.translate('RESOURCEALLOCATION.REMOVE_RESOURCE_WITH_SUBMITTED_TIMESHEET'))
                            .ok("GO TO TIMESHEET")
                            .cancel("CANCEL");

                    $mdDialog.show(dialog)
                        .then(function() {
                            $state.go('app.timesheet', {
                                id: jobService.ticketId,
                                TicketNo: jobService.jobModel.TicketNumber
                            });
                    });

                    return;
                }

                if (hasShiftUpdates == true || hasJobDateUpdates == true) {
                    if (hasSubmittedTimesheets == true) {
                        msgboxService.alert(
                            "Submitted timesheet exists",
                            "A submitted timesheet already exists for this job. The date or shift times will not be updated.",
                            "OK");

                        vm.service.isSaving = false;
                        return;
                    }
                }

                if(jobService.jobModel.IsUnconfirmedDate && jobService.jobModel.HasResourcesAllocated){
                    await confirmUnallocateResources()
                }

                jobService.updateShiftTimes = jobService.jobModel.id && (hasShiftUpdates || hasJobDateUpdates);

                if(jobService.updateShiftTimes && isJobTimeAndShiftTimeEqual == false){
                    await confirmShiftTimesUpdate();
                }

                if (hasOrderByChanged == false || hasSubmittedTimesheets == false || hasJobDateUpdates == true) {
                    await jobService.saveJob();
                    setJobDisplayDate();
                    return;
                }

                try {
                    await msgboxService
                        .yepNo(
                            utils.translate("MANAGE.CHANGECONFIRMATIONCONTENT"),
                            utils.translate("MANAGE.CHANGECONFIRMATIONTITLE"),
                            utils.translate("MANAGE.CONFIRMCHANGE"),
                            utils.translate("MANAGE.NO")
                        );

                    jobService.isJobDetailsChangeConfirmed = true;
                    await jobService.saveJob();
                    setJobDisplayDate();
                } catch (e) {
                    vm.service.isSaving = false;
                 }

            } else {
                await jobService.saveJob();
                setJobDisplayDate();
                vm.service.isSaving = false;
            }
        }

        function scrollToInvalidInput() {
            vm.service.isSaving = false;
            const formEl = document.querySelector('#create-job-form');

            const invalidInputs = angular.element(document.getElementsByClassName('md-input-invalid'));
            const smallestOffsetTop = Math.min.apply(null, invalidInputs.map(
                (index, input) => formEl.scrollTop + input.getBoundingClientRect().top));

            const buttonsToolbarEl = document.querySelector('#create-job .toolbar');
            const buttonsToolbarTop = buttonsToolbarEl.getBoundingClientRect().y;
            const buttonsToolbarHeight = buttonsToolbarEl.getBoundingClientRect().height;

            angular.element(formEl).duScrollTop(smallestOffsetTop - (buttonsToolbarTop + buttonsToolbarHeight + 50), 500);
        }

        function setupWatcherForMultidayJobFlag() {
            // Perform deep watch
            $scope.$watch('vm.service.jobModel.Is24HourRotation', function() {
                setupIsMultidayJobFlag();
            }, true);
            $scope.$watch('vm.service.jobModel.JobDuration', function() {
                setupIsMultidayJobFlag();
            }, true);
            $scope.$watch('vm.service.jobModel.JobEndDate', function() {
                setupIsMultidayJobFlag();
            }, true);
            $scope.$watch('vm.service.jobModel.JobStartDate', function() {
                setupIsMultidayJobFlag();
            }, true);
        }

        function setupIsMultidayJobFlag() {
            // Setup multiday job observer
            jobService.isMultidayJob = (jobService.jobModel.Is24HourRotation ||
                    jobService.jobModel.JobDuration > 1 ||
                    (new Date(moment(jobService.jobModel.JobEndDate).format('MM/DD/YYYY')) - new Date(moment(jobService.jobModel.JobStartDate).format('MM/DD/YYYY'))) > 1) &&
                jobService.jobModel.TicketType !== ticketType.EQUIPMENT_ONLY;
        }

        function setJobDisplayDate() {
            if (!jobService.jobModel.id || $stateParams.id !== jobService.jobModel.id) {
                $timeout(function() {
                    setJobDisplayDate();
                }, 100, true);
            } else {
                $scope.state.current.ticketStartDate = jobService.jobModel.JobStartDate;
                jobService.currentJobStartTime = angular.copy(jobService.jobModel.JobStartTime);
                jobService.currentJobEndTime = angular.copy(jobService.jobModel.JobEndTime);
            }
        }

        function getCustomFields(model, visible) {
            jobService.loadTicket().then(function(resp) {
                vm.service.customisedFields = resp.data.m_Item2;
                vm.CustomisedFieldsBackUp = vm.service.customisedFields;
                bindElement(customisedFieldsFactory.constructUIForm(vm.service.customisedFields, model, visible, true));
            });
        }

        function bindElement(elements) {
            $document.find('#customisedFields').empty();
            $document.find('#customisedFields').append($compile(elements)($scope));
        }

        function showCustomisedFields() {
            vm.showFields2 = !vm.showFields2;
            if (!vm.showFields2) {
                vm.changeFields();
            } else {
                vm.CustomisedFieldsBackUp = vm.service.customisedFields;
                var elements = customisedFieldsFactory.constructUIForm(vm.service.customisedFields, 'vm', true, true);
                $document.find('#customisedFields').empty();
                $document.find('#customisedFields').append($compile(elements)($scope));
            }
        }

        async function showHistory() {
            var resp = await auditApi.getAuditEntries(jobService.ticketId);
            historyLogService.showHistory("Ticket", resp.data, "#" + ($stateParams.ticketNumber || jobService.jobModel.TicketNumber));
        }

        function viewComments() {
            commentService.viewComments("Ticket", jobService.ticketId, "#" + ($stateParams.ticketNumber || jobService.jobModel.TicketNumber));
        }

        function editField(id) {
            $mdDialog.show({
                templateUrl: 'app/main/customisedFields/templates/dialog.html',
                controller: 'CustomisedFieldsController as vm',
                locals: {
                    EditMode: true,
                    Id: id,
                    Module: 5
                }
            }).then(function() {
                vm.getCustomFields('vm', false);
            })
        }

        function deleteField(id) {
            blockUI.start('Deleting Field...');
            customFieldsService.deleteField(id).then(function(resp) {
                vm.getCustomFields('vm', false);
                blockUI.stop();
            });
        }

        function openMenu($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        }

        function changeFields() {
            if (vm.showFields2) {
                return;
            } else {
                vm.service.customisedFields = vm.CustomisedFieldsBackUp;
                var elements = customisedFieldsFactory.constructUIForm(vm.service.customisedFields, 'vm', true);
                $document.find('#customisedFields').empty();
                $document.find('#customisedFields').append($compile(elements)($scope));
            }
        }

        function showCustomisedFieldsModal() {
            $mdDialog.show({
                templateUrl: 'app/main/customisedFields/templates/dialog.html',
                controller: 'CustomisedFieldsController as vm',
                locals: {
                    EditMode: false,
                    Id: null,
                    Module: 5
                }
            }).then(function() {
                vm.getCustomFields('vm', false);
            });
        }

        function chargeMinimum() {
            jobService.toggleUpdateChargeMinimumHours();
        }

        function unlinkTicket() {
            var confirm = $mdDialog.confirm()
                .title(utils.translate('MANAGE.UNLINK_TICKET_TITLE'))
                .textContent(utils.translate('MANAGE.UNLINK_TICKET_CONFIRM'))
                .ariaLabel(utils.translate('MANAGE.UNLINK_TICKET_TITLE'))
                .ok(utils.translate('MANAGE.YES'))
                .cancel(utils.translate('MANAGE.NO'));
            $mdDialog.show(confirm).then(function() {
                jobService.unlinkedRelatedTicket(vm.service.jobModel.id, vm.service.jobModel.RelatedTicketId);
                vm.service.jobModel.RelatedTicketId = null;
                vm.service.jobModel.RelatedTicketNumber = null;
            });
        }

        function lockUnlockTicket() {
            var confirm = $mdDialog.confirm()
                .title((vm.service.jobModel.IsLocked ? "Unlock" : "Lock") + ' Ticket')
                .textContent('Are you sure you want to ' + (vm.service.jobModel.IsLocked ? "Unlock" : "Lock") + ' this ticket?')
                .ok('Yes')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                blockUI.start((vm.service.jobModel.IsLocked ? "Unlocking" : "Locking") + ' ticket...');
                jobService.lockUnlockTicket(vm.service.jobModel.id, vm.service.jobModel.IsLocked).then(function(resp) {
                    blockUI.stop();
                    vm.service.jobModel.IsLocked = !vm.service.jobModel.IsLocked;
                    hubService.showToast('Ticket ' + (vm.service.jobModel.IsLocked ? "locked." : "unlocked."));
                }, function(err) {
                    blockUI.stop();
                    hubService.showToast('An error occurred');
                });
            });
        }

        function disableSaveButton()
        {
            return ((vm.service.jobModel.IsLocked || vm.service.isTicketLockedByPreSchedule() || vm.service.jobModel.IsCancelled) && !vm.service.isCloning) || vm.service.isSaving;
        }

        vm.showEmailDialog = function() {
            $mdDialog.show({
                templateUrl: "app/shared/widgets/composedEmailTemplateDialog/composedEmailTemplateDialog.html",
                controller: 'composedEmailTemplateDialogController',
                controllerAs: 'vm',
                locals: {
                    relatedIds: [$stateParams.id || jobService.jobModel.id]
                }
            }).then(function(isEmailSent) {
                if (isEmailSent) {
                    hubService.showToast("The email has been queued to send.");
                } else {
                    hubService.showToast("Failed to queue the email to send.");
                }
            });
        }

        vm.goToAllocateResourcePage = function() {
            $state.go('app.allocate', {
                id: $stateParams.id || jobService.jobModel.id,
                ticketNo: $stateParams.ticketNumber || jobService.jobModel.TicketNumber,
            });
        }

        vm.goToTimesheetsPage = function() {
            $state.go('app.timesheet', {
                id: $stateParams.id || jobService.jobModel.id
            });
        }

        vm.goToFormsAndAttachment = function() {
            $state.go('app.formsattachments', {
                TicketId: $stateParams.id || jobService.jobModel.id,
                TicketNo: $stateParams.ticketNumber || jobService.jobModel.TicketNumber,
                linkedFormTemplates: vm.service.linkedFormTemplates,
                unlinkedFormTemplates: vm.service.unlinkedFormTemplates,
                overriddenFormTemplates: vm.service.overriddenFormTemplates
            });
        };

        vm.hideProgressBar = function() {
            $document.find('.smart-scheduling-success').hide();
        }

        $scope.$on('$destroy', function() {
            vm.service.clean();
        })

        async function generatePreSchedule(){
            if (!claimsUtilService.isSmartSchedulingEnabled()) {
                smartSchedulingService.showScheduleBooking();
                return;
            }

            let isSuccess = await vm.service.generatePreSchedule();

            if(isSuccess) {
                $state.reload();
            }
        }

        async function retrySchedulingCopilot(){
            await vm.service.retryScheduling();
        }

        function showAllocateResourceBySmartScheduling() {
            return (
                claimsUtilService.hasSmartSchedulingAccess() &&
                !vm.service.jobModel.IsLockedByPreSchedule &&
                vm.service.jobModel.TicketType != ticketType.PLAN_ONLY &&
                vm.service.isEditMode &&
                vm.service.jobModel.Resource.length > 0 &&
                vm.service.allocatedResources.some(x => !x.AllocatedId)
            );
        }

        async function cancelScheduling() {
            await vm.service.cancelScheduling();
        }

        function showChargeMinimumHoursButton() {
            return (
                vm.service.isEditMode &&
                vm.service.jobModel.IsCancelled &&
                vm.service.jobModel.TicketType !== ticketType.INTERNAL
            );
        }

        function openChargeMinimumHoursDialog() {
            let dialog = jobService.showChargeMinimumHoursDialog(vm.service.jobModel);
            $mdDialog.show(dialog).then(function(res) {
                if (res) {
                    blockUI.start(res.chargeMinHours ? 'Charging minimum hours...' : 'Removing minimum hours charge...');
                     vm.service.jobModel.ChargeMinimumHours = res.chargeMinHours;
                    jobsApi.chargeMinHours(vm.service.jobModel.id, res.chargeMinHours)
                        .then(function() {
                            blockUI.stop();
                            hubService.showToast(res.chargeMinHours ? 'Minimum hours charge applied.' : 'Minimum hours charge removed.');
                        })
                        .catch(function(error) {
                            blockUI.stop();
                            jobService.jobModel.ChargeMinimumHours = !res.chargeMinHours;
                            hubService.showToast( "An error occurred " + error.data.Message);
                        });
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.jobs.formsattachments')
        .controller('FormsAndAttachmentsController', FormsAndAttachmentsController);

    /** @ngInject */
    function FormsAndAttachmentsController(
        utils,
        $state,
        $stateParams,
        $mdDialog,
        hubService,
        claimsUtilService,
        formsAttachmentsService,
        DialogService,
        blockUI,
        ticketStatus
    ) {
        var vm = this;

        vm.checkAccessService = claimsUtilService;
        vm.service = formsAttachmentsService;
        vm.service.params = $stateParams;
        vm.ticketNo = $stateParams.TicketNo;
        vm.ticketId = $stateParams.TicketId;
        vm.excludedDocuments = [];
        vm.createdFormIds = $stateParams.createdFormIds || [];
        vm.isTimesheetSubmitted = false;
        vm.isLocked = false;
        vm.formTemplatesListApi = {};
        vm.canNavigateToAllocateResource   = false;
        vm.canNavigateToTimesheets  = false;
        vm.isReady = false;

        vm.service.init()
            .then(function(resp) {
                vm.excludedDocuments = new Set(vm.service.ticketData.ExcludedDocuments) || new Set($stateParams.excludedDocuments || []);
                vm.createdFormIds = (vm.service.ticketData.CreatedForms).map(a => a.FormId);

                vm.isTimesheetSubmitted = vm.service.ticketData.IsTimesheetSubmitted;
                vm.isLocked = vm.service.ticketData.IsLocked;
                vm.isPendingApproval = vm.service.ticketData.Status === ticketStatus.PENDING_CLIENT_CONFIRMATION;

                if (vm.service.ticketData.ResourceItems) {
                    let vehicles = vm.service.ticketData.ResourceItems.filter(ri => ri.ItemTypes.some(type => type === 5));
                    vm.vehicles = vehicles.map(v => {
                        return {
                            Id: v.Id,
                            Name: v.ItemName,
                            Type: v.ItemTypes
                        }
                    });
                    let assets = vm.service.ticketData.ResourceItems.filter(ri => ri.ItemTypes.every(type => type !== 4 && type !== 5));
                    vm.assets = assets.map(a => {
                        return {
                            Id: a.Id,
                            Name: a.ItemName,
                            Type: a.ItemTypes
                        }
                    });
                }

                vm.canNavigateToAllocateResource   = !(vm.service.ticketData.IsQuote || vm.service.ticketData.TicketType === 4 || vm.service.ticketData.IsUnconfirmedDate || (vm.service.ticketData.IsLocked || vm.service.ticketData.IsCancelled));
                vm.canNavigateToTimesheets  = !(vm.service.ticketData.IsQuote || vm.service.ticketData.TicketType === 1  || vm.service.ticketData.TicketType === 4 || vm.service.ticketData.IsUnconfirmedDate || (vm.service.ticketData.IsLocked || vm.service.ticketData.IsCancelled));
            });

        vm.service.getFormTemplates()
            .then(function(resp) {
                blockUI.stop();
                if (vm.isLocked && !vm.isPendingApproval) {
                    displayRegeneratePaperworkDialog();
                }
                vm.linkedFormTemplates = resp.linkedFormTemplates;
                vm.unlinkedFormTemplates = resp.unlinkedFormTemplates;
                vm.ticketLinkedFormTemplates = resp.ticketLinkedFormTemplates || [];
                vm.ticketUnlinkedFormTemplates = resp.ticketUnlinkedFormTemplates || [];
                vm.overriddenFormTemplates = resp.overriddenFormTemplates;
                vm.ticketOverriddenFormTemplates = resp.ticketOverriddenFormTemplates || [];
            });

        vm.saveForms = function() {
            vm.service.saveTags(vm.ticketId, vm.service.ticketData.Tags).then(() => {
                hubService.showToast(utils.translate('FORMSATTACHMENTS.TAG_CHANGES_SAVED'));

                if (vm.formTemplatesListApi.getOverriddenTemplatesToSave) {
                    vm.service.saveForms(vm.ticketId,
                            vm.ticketLinkedFormTemplates,
                            vm.ticketUnlinkedFormTemplates,
                            vm.formTemplatesListApi.getOverriddenTemplatesToSave())
                        .then(() => {
                            if (vm.isLocked && !vm.isPendingApproval) {
                                displayRegeneratePaperworkDialog();
                            }
                            hubService.showToast(utils.translate('FORMSATTACHMENTS.FORM_CHANGES_SAVED'));
                        }, function(err) {
                            exceptionService.resolve(err);
                        });
                }
            });
        };

        vm.hasCreatedForms = function() {
            return !_.isNil(vm.createdFormIds) && !_.isEmpty(vm.createdFormIds);
        };

        vm.showTicketDetails = function() {
            DialogService.openTicketDetailDialog(vm.service.ticketData.id, false, true);
        };

        vm.goToTimesheet = function() {
            $state.go('app.timesheet', {
                id: vm.service.ticketData.id,
                TicketNo: (vm.ticketNo || vm.service.ticketData.ticketNumber)
            });
        };

        vm.goToEditTicket = function() {
            $state.go('app.jobs_update', {
                id: vm.service.ticketData.id,
                ticketNumber: (vm.ticketNo || vm.service.ticketData.ticketNumber)
            });
        };

        vm.goToAllocateResourcePage = function() {
            $state.go('app.allocate', {
                id: vm.service.ticketData.id,
                ticketNo: (vm.ticketNo || vm.service.ticketData.ticketNumber),
            });
        };

        function displayRegeneratePaperworkDialog() {
            let alert = $mdDialog.alert({
                title: utils.translate("FORMSATTACHMENTS.INVOICED_JOB"),
                htmlContent: utils.translate("FORMSATTACHMENTS.CHANGES_NOT_UPDATED_IN_PAPERWORK_REGENERATE"),
                ok: 'Okay'
            });
            $mdDialog.show(alert);
        }
    }
})();

/**
 * Created by Ben Rei on 9/26/2016.
 */
{
  angular
    .module('app.jobs.confirmBooking',['app.jobs.confirmTicket','app.jobs.components.droppableConfirmTicket'])
    .config(config)

  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state('app.confirmBooking', {
        url: '/confirm-booking/:id',
        params:{
          code: null,
          ticketIds: null,
          jobModel: null,
          referenceTicketId: null,
          isCloning: false
        },
        views: {
          'content@app': {
            templateUrl: 'app/main/jobs/confirmBooking/confirm-booking.html',
            controller: 'confirmBookingController as vm'
          }
        }
        , title: 'Confirm Ticket'
        , titleBar: 'Alloc8 - Confirm Ticket'
        , data: {requireLogin: true}
      });

    // Navigation
    msNavigationServiceProvider.saveItem('apps', {
      title: '',
      group: true,
      weight: 1
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/jobs/confirmBooking');
  }


}

(function() {
    'use strict';

    angular.module('app.jobs.confirmBooking')
        .factory('confirmBookingService', confirmBookingService);

    function confirmBookingService(
        jobsApi,
        ticketDataModel,
        jobToastService,
        $q,
        blockUI,
        $state,
        $timeout,
        $mdDialog,
        exceptionService,
        TimeLibrary,
        documentsApi,
        allocationApi,
        jobService,
        smartSchedulingService,
        ticketType) {

        var service = {
            whereTo: null,
            Tickets: [],
            billingPeriodLookup: [],
            activate: activate,
            deleteTicket: deleteTicket,
            showDroppableLoader: true,
            showDraggables: false,
            currentIndex: null,
            currentLabel: "",
            disabledSaveButton: true,
            confirmTickets: confirmTickets,
            isEmailRequired: false,
            OriginalTickets: [],
            saveUpdatedTicket: saveUpdatedTicket,
            isClonedTicketUpdated: false,
            shouldAllocateResourceBySmartScheduling: false
        };

        return service;

        function activate(ids) {

            service.Tickets.length = 0;
            blockUI.start({
                message: 'Loading Created Tickets...'
            });

            return jobsApi.getTicketsForConfirmation(ids)
                .then(function(resp) {
                    var tickets = resp.data;
                    service.Tickets = [];

                    angular.forEach(tickets, function(item) {
                        let ticket = new ticketDataModel();
                        ticket.map(item);
                        service.Tickets.push(ticket);
                    });
                    
                    service.OriginalTickets = angular.copy(service.Tickets);
                    service.showDroppableLoader = false;
                    blockUI.stop();
                }).catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function deleteTicket(index, id) {
            blockUI.start({
                message: 'Deleting Ticket ' + service.Tickets[0].TicketNumber + '.'
            });
            return jobsApi.deleteTicket(id)
                .then(function(resp) {
                    if (resp.data) {
                        service.Tickets.splice(index, 1);
                        blockUI.stop();
                        jobToastService.toast('Ticket ' + service.Tickets[0].TicketNumber + ' has been deleted.')
                    } else {
                        jobToastService.toast('An error occurred while deleting the ticket. Please try again.');
                        blockUI.stop();
                    }
                });
        }

        function confirmNow(ticketsToSave) {
            if (ticketsToSave.length > 0) {
                blockUI.start({
                    message: 'Updating Ticket...'
                });
                var urls = [];

                angular.forEach(ticketsToSave, function(ticket) {
                    urls.push(jobsApi.updateTickets(ticket.transformToServerModel()));
                });

                $q.all(urls).then(function(resp) {
                    $timeout(function() {
                        blockUI.stop();
                        jobToastService.toast('The ticket has been updated.');

                        if (service.isEmailRequired) {
                            showEmailDialog();
                        } else {
                            whereTo();
                        }

                    }, 2000);

                }).catch(function(err) {
                    blockUI.stop();
                    jobToastService.toast('An error occurred while updating the ticket, please try again.');
                });
            } else {
                if (service.isEmailRequired) {
                    showEmailDialog();
                } else {
                    whereTo();
                }
            }

        }

        function showEmailDialog() {
            var ticketIds = [];

            angular.forEach(service.Tickets, function(ticket) {
                ticketIds.push(ticket.id);
            });

            $mdDialog.show({
                templateUrl: "app/shared/widgets/composedEmailTemplateDialog/composedEmailTemplateDialog.html",
                controller: 'composedEmailTemplateDialogController',
                controllerAs: 'vm',
                locals: {
                    relatedIds: ticketIds
                }
            }).then(function(isEmailSent) {
                if (isEmailSent) {
                    if(service.shouldAllocateResourceBySmartScheduling){
                        allocateResourceBySmartScheduling();
                    }

                    if (service.whereTo === "srn") {
                        $state.go("app.allocate", {
                            id: service.Tickets[0].id,
                            ticketNo: service.Tickets[0].TicketNumber,
                        });
                    } else {
                        $state.go("app.jobs_whiteboard", {
                            redirectFromCreateJob: true,
                        });
                    }
                }
            });
        }

        function requiresShiftUpdates(ticket) {
            var isNewTimeSet = false;

            var originalTicket = service.OriginalTickets.find(
                (x) => x.TicketNumber === ticket.TicketNumber
            );
            
            var originalJobStartTime = TimeLibrary.convertTime(
                originalTicket.JobStartTime
            );
            var originalJobEndTime = TimeLibrary.convertTime(
                originalTicket.JobEndTime
            );
            var currentJobStartTime = TimeLibrary.convertTime(
                ticket.JobStartTime
            );
            var currentJobEndTime = TimeLibrary.convertTime(ticket.JobEndTime);

            if (currentJobStartTime && currentJobEndTime) {
                isNewTimeSet =
                    originalJobStartTime !== currentJobStartTime ||
                    originalJobEndTime !== currentJobEndTime;
            }

            return (
                (ticket.TicketType === ticketType.FULL_SERVICE || ticket.TicketType === ticketType.TRAVEL_ONLY) &&
                isNewTimeSet &&
                ticket.Edited
            );
        }

        async function confirmTickets(confirmBookingParams) {

            var ticketsToSave = _.filter(service.Tickets, function(ticket) {
                ticket.Edited == true;
                let isShiftUpdated = requiresShiftUpdates(ticket);

                if (isShiftUpdated == true) {
                    ticket.UpdateShiftTimes = true;
                }
                
                return ticket;
            });

            if (service.Tickets.length > 0) {
                if (confirmBookingParams.isCloning && service.Tickets[0].TicketType !== ticketType.PLAN_ONLY) {
                    let sourceTicketId = confirmBookingParams.referenceTicketId;

                    let ticketResponse = await jobsApi.getTicketByTicketId(sourceTicketId)
                        .catch(() => {
                            confirmNow(ticketsToSave);
                            return;
                        });

                    if (ticketResponse) {
                        const JOB_DOCUMENT_MODULE_ID = '5';

                        let srcTicket = ticketResponse.data;
                        let getSrcTicketAllocationsResp = await allocationApi.fetchTicket(sourceTicketId);

                        let srcTicketAllocatedResources = _.filter(getSrcTicketAllocationsResp.data, function(obj) {
                            return obj.AllocatedId !== null;
                        });

                        let getSrcTicketDocumentsResp = await documentsApi.getAllDocumentsForResource(JOB_DOCUMENT_MODULE_ID, sourceTicketId);
                        let srcTicketDocuments = getSrcTicketDocumentsResp.data || [];

                        let hasAllocatedResources = srcTicketAllocatedResources.length > 0;

                        let hasForms = srcTicket.LinkedFormTemplates.length > 0 ||
                            srcTicket.UnlinkedFormTemplates.length > 0 ||
                            srcTicket.OverriddenFormTemplates.length > 0;

                        let hasAttachments = srcTicketDocuments.length > 0 ||
                            srcTicket.ExcludedDocuments.length > 0 ||
                            srcTicket.OverriddenDocuments.length > 0;

                        if (!hasAllocatedResources && !hasForms && !hasAttachments) {
                            confirmNow(ticketsToSave);
                            return;
                        }

                        $mdDialog.show({
                                templateUrl: "app/main/jobs/services/cloneAllocationDialog/clone-allocation.html",
                                controller: "cloneJobAllocationDialogController as vm",
                                locals: {
                                    data: {
                                        multiple: true,
                                        CloneTicketId: null,
                                        TicketId: confirmBookingParams.referenceTicketId,
                                        CloneTicketNumber: null,
                                        Tickets: service.Tickets.map(x => ({
                                            NewTicketId: x.id,
                                            NewTicketNumber: x.TicketNumber,
                                            SourceTicketId: confirmBookingParams.referenceTicketId
                                        })),
                                        hasAllocatedResources: srcTicketAllocatedResources.length > 0,
                                        hasForms: hasForms,
                                        hasAttachments: hasAttachments
                                    },
                                },
                            })
                            .then(function(resp) {
                                service.shouldAllocateResourceBySmartScheduling = resp && resp.shouldAllocateResourceBySmartScheduling;
                                confirmNow([]);
                            })
                            .catch(function() {
                                confirmNow(ticketsToSave);
                            });
                    }
                } else {
                    confirmNow(ticketsToSave);
                }
            }
        }

        function whereTo() {
            if(service.shouldAllocateResourceBySmartScheduling){
                allocateResourceBySmartScheduling();
            }

            blockUI.start({
                message: 'Loading Ticket...'
            });

            let parentRelatedTicket = service.Tickets[0];
            $state.go('app.jobs_update', {
                id: parentRelatedTicket.id,
                ticketNumber: parentRelatedTicket.TicketNumber
            });
        }

        function saveUpdatedTicket() {
            service.isClonedTicketUpdated = false;

            var ticketsToSave = service.Tickets.filter(function(ticket) {
                let isShiftUpdated = requiresShiftUpdates(ticket);

                if (isShiftUpdated) {
                    ticket.UpdateShiftTimes = true;
                }

                return ticket;
            });

            if (ticketsToSave.length > 0) {
                blockUI.start({
                    message: 'Updating Tickets...'
                });
                var urls = [];
                angular.forEach(ticketsToSave, function(ticket) {
                    urls.push(jobsApi.updateTickets(ticket.transformToServerModel()));
                });

                $q.all(urls).then(function(resp) {
                    $timeout(function() {
                        blockUI.stop();
                        jobToastService.toast('The tickets have been updated.');

                    }, 2000);

                }).catch(function(err) {
                    service.isClonedTicketUpdated = true;
                    blockUI.stop();
                    jobToastService.toast('An error occurred while updating the tickets, please try again.');
                });
            }
        }

        function allocateResourceBySmartScheduling(){
            let ticketIds = service.Tickets.map(x => x.id);

            ticketIds.forEach(async ticketId => {
                await jobService.loadAllocatedResources(ticketId);
                await smartSchedulingService.generateSchedule(ticketId, jobService.allocatedResources)
            });
        }
    }
})();

/**
 * Created by Ben Rei on 9/26/2016.
 */
{
  angular
    .module('app.jobs.confirmBooking')
    .controller('confirmBookingController', confirmBookingController);

  /** @ngInject */
  function confirmBookingController($stateParams, confirmBookingService, jobService) {
    var vm = this;

    vm.confirmBookingService = confirmBookingService;
    vm.jobService = jobService;
    if ($stateParams.jobModel) {
      vm.jobService.jobModel = $stateParams.jobModel;
    }
    var storedJobModel = !$stateParams.jobModel && sessionStorage.getItem('confirmBooking_jobModel_' + $stateParams.id);
    if (storedJobModel) {
      vm.jobService.jobModel.map(JSON.parse(storedJobModel));
    }
    confirmBookingService.whereTo = $stateParams.code;

    vm.confirmTickets = confirmTickets;
    vm.saveUpdatedTicket = saveUpdatedTicket;
    vm.isCloning = $stateParams.isCloning || JSON.parse(sessionStorage.getItem('confirmBooking_isCloning_' + $stateParams.id) || 'false');
    var referenceTicketId = $stateParams.referenceTicketId || JSON.parse(sessionStorage.getItem('confirmBooking_referenceTicketId_' + $stateParams.id));

    function activate() {
      var ids = $stateParams.ticketIds
        || JSON.parse(sessionStorage.getItem('confirmBooking_ticketIds_' + $stateParams.id));
      confirmBookingService.activate(ids);
    }

    function confirmTickets(isEmailRequired) {
      confirmBookingService.isEmailRequired = isEmailRequired;
      confirmBookingService.confirmTickets({ isCloning: vm.isCloning, referenceTicketId: referenceTicketId });
    }

    function saveUpdatedTicket(){
        confirmBookingService.saveUpdatedTicket();
    }

    activate();
  }
}

(function () {
  'use strict';

  angular
    .module('app.jobs.allocate')
    .controller('AllocateResourceController', AllocateResourceController);

  /** @ngInject */
  function AllocateResourceController(resourceAllocateService,
                                      DialogService,
                                      $state,
                                      $scope,
                                      utils,
                                      mediaQueryService,
                                      $stateParams,
                                      claimsUtilService,
                                      $timeout,
                                      smartSchedulingService) {

    const TICKET_TYPE_PLANONLY = 4;

    var vm = this;
    vm.service = resourceAllocateService;
    vm.service.ticketGUID = $stateParams.id;
    vm.service.showDraggables = false;
    vm.service.ticketNo = $stateParams.ticketNo;
    vm.service.lookUps = [];
    vm.mediaService = mediaQueryService;
    vm.utilService = utils;

    vm.viewJobs = viewJobs;
    vm.editTicket = editTicket;
    vm.goToTimesheetsPage = goToTimesheetsPage;
    vm.showTicketDetails = showTicketDetails;
    vm.refresh = refresh;
    vm.showJobMessageAllocationButton = showJobMessageAllocationButton;
    vm.showJobAllocationButton = showJobAllocationButton;
    vm.isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
    vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
    vm.isCustomFormsEnabled = claimsUtilService.isCustomFormsEnabled();
    vm.showAllocateResourceBySmartScheduling = showAllocateResourceBySmartScheduling;
    vm.isTicketLockedByPreSchedule = isTicketLockedByPreSchedule;
    vm.isTicketAllocatedBySmartScheduling = isTicketAllocatedBySmartScheduling;
    vm.generatePreSchedule = generatePreSchedule;
    vm.cancelScheduling = cancelScheduling;
    vm.retrySchedulingCopilot = retrySchedulingCopilot;
    vm.hasSmartSchedulingAccess = claimsUtilService.hasSmartSchedulingAccess();

    function showJobAllocationButton(){
        return !vm.service.showDroppableLoader && !vm.service.is_equipment && vm.showJobMessageAllocationButton()
    }

    function viewJobs(){
      $state.go('app.jobs_view');
    }

    $scope.$on("$destroy", function() {
        vm.service.clean();
    });

    function refresh(){
      resourceAllocateService.showDroppableLoader = true;
      resourceAllocateService.fetchTicket2();
    }

    function editTicket(){
      $state.go('app.jobs_update', {id: vm.service.ticketGUID, ticketNumber: vm.service.ticketNo});
    }

    function goToTimesheetsPage(){
      $state.go('app.timesheet', {id: vm.service.ticketGUID, TicketNo : vm.service.ticketNo});
    }

    function showTicketDetails(){
      DialogService.openTicketDetailDialog(vm.service.ticketGUID, false, true);
    }

    function activate(){
        vm.service.fetch_called = 0;
        setJobDisplayDate();
    }

    function setJobDisplayDate() {
      if (!vm.service.JobDisplayDate) {
          $timeout(function () {
              setJobDisplayDate();
          }, 100, true);
      } else {
          $scope.state.current.ticketStartDate = vm.service.JobDisplayDate;
      }
    }

    function showJobMessageAllocationButton() {
      // This function is used to determine when to show the job notification button as well
      // If the people line items have at least one allocation
      let people_items_with_allocations = vm.service.droppables.filter(function(itm) {
        return itm.ItemType === 4 && itm.AllocatedId !== undefined;
      }).length;
      return people_items_with_allocations > 0;
    }

    function showAllocateResourceBySmartScheduling() {
      var ticketInfo = vm.service.ticketInfo;
      var allocatedResource = vm.service.allocatedResource;
      
      return ticketInfo
            && claimsUtilService.hasSmartSchedulingAccess()
            && !ticketInfo.IsLockedByPreSchedule
            && !ticketInfo.TicketType != TICKET_TYPE_PLANONLY
            && (ticketInfo.ResourceItems && ticketInfo.ResourceItems.length > 0)
            && (allocatedResource && allocatedResource.some(x => !x.AllocatedId ));
    }

    function isTicketLockedByPreSchedule() {
      var ticketInfo = vm.service.ticketInfo;
      return claimsUtilService.isSmartSchedulingEnabled() && ticketInfo && ticketInfo.IsLockedByPreSchedule
    }

    function isTicketAllocatedBySmartScheduling() {
        var ticketInfo = vm.service.ticketInfo;
        return (
            claimsUtilService.isSmartSchedulingEnabled() &&
            ticketInfo &&
            !ticketInfo.IsLockedByPreSchedule &&
            ticketInfo.PreScheduleJobIds &&
            ticketInfo.PreScheduleJobIds.length > 0
        );
    }

    async function generatePreSchedule() {
      if (!claimsUtilService.isSmartSchedulingEnabled()) {
          smartSchedulingService.showScheduleBooking();
          return;
      }

      var isPreScheduleGenerated = await vm.service.generatePreSchedule();

      if(isPreScheduleGenerated){
          $state.reload();
      }
    }

    vm.goToFormsAndAttachment = function(){
      $state.go('app.formsattachments', {
          TicketId: vm.service.ticketGUID,
          TicketNo : vm.service.ticketNo
      });
    };

    async function cancelScheduling() {
      await vm.service.cancelScheduling();
    }

    async function retrySchedulingCopilot() {
      await vm.service.retryScheduling();
    }


    activate();
  }
})();

/**
 * Created by queeniejgm on 04/06/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.invoice-export.manage', ['ui.ace'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.invoice-export', {
            url: '/invoice-export/manage'
            , views: {
                'content@app': {
                    templateUrl: 'app/main/invoiceExport/manage/invoice-export-manage.html'
                    , controller: 'InvoiceExportController as vm'
                }
            }
            , data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManageInvoiceSettings;
                }] 
            }
            , title: 'Manage Invoice Settings'
            , titleBar: 'Alloc8 - Manage Invoice Export Format'
        });

        $translatePartialLoaderProvider.addPart('app/main/invoiceExport');
    }
})();

(function () {
    'use strict';

    angular.module('app.invoice-export.manage')
        .factory('invoiceExportService', invoiceExportService);

    /** @ngInject */
    function invoiceExportService(
        blockUI,
        utils,
        $q,
        hubService,
        invoiceSettingsApi,
        _) {
        var self = this;
        var service = {
            initializeInvoiceExportFormat: initializeInvoiceExportFormat,
            getInvoiceExportSettings: getInvoiceExportSettings,
            updateInvoiceExportFormat: updateInvoiceExportFormat,
            updateInvoiceExportFileExtension: updateInvoiceExportFileExtension,
            updateInvoiceExportFileHeading: updateInvoiceExportFileHeading,
            getInvoiceExportFields: getInvoiceExportFields
        };

        function initializeInvoiceExportFormat() {
            var deferred = $q.defer();
            self.invoiceExportSettings = [];
            invoiceSettingsApi.getAll().then(function (resp) {
                self.invoiceExportSettings = !_.isNil(resp.data) ? resp.data : [];
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function getInvoiceExportSettings() {
            return self.invoiceExportSettings;
        }

        function updateInvoiceExportFormat(params) {
            var deferred = $q.defer();
            invoiceSettingsApi.updateInvoiceSettingsExportFormat(params).then(function (resp) {
                self.invoiceExportSettings.ExportFormat = params.ExportFormat;
                self.invoiceExportSettings.ConditionalScript = params.ConditionalScript;
                hubService.showToast(utils.translate('INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_FORMAT_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updateInvoiceExportFileExtension(params) {
            var deferred = $q.defer();
            invoiceSettingsApi.updateInvoiceSettingsExportFileExtension(params).then(function (resp) {
                self.invoiceExportSettings.ExportFileExtension = params.fileExtension;
                hubService.showToast(utils.translate('INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_FILE_EXT_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function updateInvoiceExportFileHeading(params) {
            var deferred = $q.defer();
            invoiceSettingsApi.updateInvoiceSettingsExportFileHeading(params).then(function (resp) {
                self.invoiceExportSettings.ExportHeader = params.fileHeading;
                hubService.showToast(utils.translate('INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_FILE_HEADING_SAVED'));
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function getInvoiceExportFields() {
            let deferred = $q.defer();

            invoiceSettingsApi.getExportFields().then(function (resp) {
                self.invoiceExportSettings.ExportFields = resp.data;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        return service;
    }
})();

/**
 * Created by queeniejgm on 04/06/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.invoice-export.manage')
        .controller('InvoiceExportController', InvoiceExportController);

    /** @ngInject */
    function InvoiceExportController ( $scope,
                                         utils,
                                         blockUI,
                                         exceptionService,
                                         invoiceExportService) {

        var self = this;
        self.service = invoiceExportService;
        self.Title = "Manage Invoice Export Format";
        self.utilService = utils;

        self.addInvoiceExportFormatField = addInvoiceExportFormatField;
        self.editInvoiceExportFormat = editInvoiceExportFormat
        self.editInvoiceExportFileExtension = editInvoiceExportFileExtension;
        self.editInvoiceExportFileHeading = editInvoiceExportFileHeading;

        initialize();

        function initialize() {
            blockUI.start();
            self.service.initializeInvoiceExportFormat()
                .then(function(response){
                    getInvoiceExportSettings();
                    setExportFields();
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getInvoiceExportSettings() {
            self.invoiceExportSettings = self.service.getInvoiceExportSettings();
        }

        function addInvoiceExportFormatField(field) {
            let position = _.first(angular.element("#ExportFormat")).selectionStart;
            let str = self.invoiceExportSettings.ExportFormat;
            field = "{"+ field +"}";

            if (_.isNil(str)) {
                self.invoiceExportSettings.ExportFormat = field;
            } else {
                self.invoiceExportSettings.ExportFormat = str.substr(0, position) + field + str.substr(position);
            }
        }

        function editInvoiceExportFormat() {
            blockUI.start();
            let params = { ExportFormat: self.invoiceExportSettings.ExportFormat, ConditionalScript: self.invoiceExportSettings.ConditionalScript };
            self.service.updateInvoiceExportFormat(params)
                .then(function(){
                    getInvoiceExportSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });

        }

        function editInvoiceExportFileExtension() {
            blockUI.start();
            let params = { fileExtension: self.invoiceExportSettings.ExportFileExtension };
            self.service.updateInvoiceExportFileExtension(params)
                .then(function(){
                    getInvoiceExportSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function editInvoiceExportFileHeading() {
            blockUI.start();
            let params = { fileHeading: self.invoiceExportSettings.ExportHeader };
            self.service.updateInvoiceExportFileHeading(params)
                .then(function(){
                    getInvoiceExportSettings();
                    self.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function setExportFields() {
            self.service.getInvoiceExportFields()
                .then(function(response){
                    self.invoiceExportSettings.ExportFields = response.data;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.invoice.reports.view')
        .controller('InvoiceListViewController', InvoiceListViewController);

    /** @ngInject */
    function InvoiceListViewController(
        invoiceFilterService,
        $state,
        searchDelay,
        invoiceReportGridService,
        creditReinvoiceService,
        invoiceLoaderService,
        claimsUtilService,
        purchaseOrderService,
        $window,
        $mdDialog,
        utils,
        blockUI,
        invoiceApi
    ) {
        var vm = this;
        vm.model = invoiceFilterService;
        vm.dataGrid = invoiceReportGridService;
        vm.delay = {
            debounce: searchDelay
        };
        vm.noAccess = false;
        vm.noPOAccess = false;
        vm.previewInvoice = previewInvoice;
        vm.credit = credit;
        vm.changePurchaseOrderNumber = changePurchaseOrderNumber;
        vm.downloadInvoicePdf = downloadInvoicePdf;

        vm.openMenu = openMenu;
        vm.getMenuItems = getMenuItems;
        vm.menuItemClick = menuItemClick;

        vm.menuItems = [{
                name: 'Download Invoice and Paperwork PDF',
                icon: 'icon-file-pdf'
            },
            {
                name: 'Download Invoice only PDF',
                icon: 'icon-file-pdf'
            },
            {
                name: 'Download Paperwork only PDF',
                icon: 'icon-file-pdf'
            }
        ];

        vm.canDeleteInvoice = claimsUtilService.isCustomerOnboardingEnabled();
        vm.confirmDeleteInvoice = confirmDeleteInvoice;

        function getMenuItems(invoice) {
            let isCreditInvoice = invoice.CreditType === 1;
            vm.menuItems.forEach(function(menu) {
                if (menu.name == "Download Invoice and Paperwork PDF") {
                    menu.disabled = isCreditInvoice || !invoice.InvoiceAndPaperworkPdfUri;
                } else if (menu.name == "Download Invoice only PDF") {
                    menu.disabled = !invoice.InvoiceOnlyPdfUri;
                } else if (menu.name == "Download Paperwork only PDF") {
                    menu.disabled = isCreditInvoice || !invoice.PaperworkOnlyPdfUri;
                }
            });
            return vm.menuItems;
        }

        function menuItemClick(index, invoiceAndPaperworkPdfUri, invoiceOnlyPdfUri, paperworkOnlyPdfUri) {
            switch (index) {
                case 0:
                    vm.downloadInvoicePdf(invoiceAndPaperworkPdfUri);
                    break;
                case 1:
                    vm.downloadInvoicePdf(invoiceOnlyPdfUri);
                    break;
                case 2:
                    vm.downloadInvoicePdf(paperworkOnlyPdfUri);
                    break;
            }
        }

        activate();

        function activate() {
            vm.noAccess = !(claimsUtilService.checkAccessByRole('Invoice View'));
            vm.noPOAccess = !(claimsUtilService.checkAccessByRole('PO Button'));
            vm.dataGrid.filterData = invoiceFilterService.data.toBackendModel();
        }

        function credit(id, invoiceNumber, reinvoice) {
            creditReinvoiceService.processCredit(id, invoiceNumber, reinvoice)
                .then(function() {
                    vm.dataGrid.grid.behavior.refresh();
                });
        }

        function previewInvoice(id) {
            invoiceLoaderService.loadSingleInvoice(id);
            $state.go('app.invoice_report');
        }

        function changePurchaseOrderNumber(id, purchaseOrderNum) {
            purchaseOrderService.changePurchaseOrderNumber(id, purchaseOrderNum);
        }

        function downloadInvoicePdf(fileUri) {
            let cacheInvalidationQuerystring = `?time=${new Date().getTime()}`;
            let updatedUri = encodeURI(fileUri) + cacheInvalidationQuerystring;

            $window.open(updatedUri, '_blank');
        }

        function openMenu($mdMenu, ev) {
            $mdMenu.open(ev);
        }

        function confirmDeleteInvoice(invoiceId, invoiceNumber) {
            let confirm = $mdDialog.confirm({
                title: utils.translate("INVOICE_EXPORT.DELETE_INVOICE_TITLE"),
                textContent: "Are you sure you want to delete the invoice #" + invoiceNumber + "?",
                ok: utils.translate("INVOICE_EXPORT.OK"),
                cancel: utils.translate("INVOICE_EXPORT.CANCEL")
            });

            $mdDialog
                .show(confirm)
                .then(function() {
                    deleteInvoice(invoiceId, invoiceNumber);
                })
                .finally(function() {
                    confirm = undefined;
                });
        }

        function deleteInvoice(invoiceId, invoiceNumber) {
            blockUI.start({
                message: utils.translate("INVOICE_EXPORT.DELETE_INVOICE_PROGRESS_MESSAGE")
            });

            let alertMessage = "Invoice #" + invoiceNumber + " has been deleted."

            invoiceApi.deleteInvoiceAndUnlockTicketAndTimesheet(invoiceId, true)
                .catch(error => {
                    alertMessage = "Error occured while deleting invoice #" + invoiceNumber + ".";
                })
                .finally(() => {
                    blockUI.stop();

                    let alert = $mdDialog.alert({
                        title: utils.translate("INVOICE_EXPORT.DELETE_INVOICE_TITLE"),
                        textContent: alertMessage,
                        ok: utils.translate("INVOICE_EXPORT.OK")
                    });

                    $mdDialog.show(alert)
                        .finally(function() {
                            alert = undefined;
                        });

                    vm.dataGrid.grid.behavior.refresh();
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.invoice')
        .factory('invoiceClaimsService', invoiceClaimsService);

    /** @ngInject */
    function invoiceClaimsService($rootScope, $log, identityService, claimsUtilService) {
        var service = {
            hasInvoicingMenu: false,
            hasCreateInvoiceMenu: false,
            hasExportInvoiceMenu: false,
            hasViewInvoiceMenu: false,
            hasManageRateCardsMenu: false,
            hasPreviewInvoiceMenu: false,
        };

        activate();

        return service;

        function activate() {
            $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                applyClaimsRules();
            });

            applyClaimsRules();
        }

        function applyClaimsRules() {
            if (claimsUtilService.isBillingEnabled()) {
                service.hasInvoicingMenu = claimsUtilService.checkAccessByRole('Invoicing');
                service.hasCreateInvoiceMenu = claimsUtilService.checkAccessByRole('Create an Invoice');
                service.hasExportInvoiceMenu = claimsUtilService.checkAccessByRole('Export Viewer');
                service.hasViewInvoiceMenu = claimsUtilService.checkAccessByRole('Invoice View');
                service.hasManageRateCardsMenu = claimsUtilService.checkAccessByRole('Manage Rate Cards');
                service.hasPreviewInvoiceMenu = claimsUtilService.checkAccessByRole('Preview Invoice');
            }
        }
    }
})();

/**
 * Invoice lookup service
 *
 * Rcnet 2.20.2017
 */
(function () {
    'use strict';

    angular.module('app.invoice')
        .service('invoiceLookupService', invoiceLookupService);

    /** @ngInject */
    function invoiceLookupService($log,
        $q,
        utils,
        exceptionService,
        termsApi,
        branchApi,
        invoiceDistributionApi,
        invoiceApi) {

        var service = {
            data: {
                branchLookups: [],
                clientLookups: [],
                termLookups: [],
                emailTypes: []
            },
            loadBranches: loadBranches,
            loadClients: loadClients,
            loadAll: loadAll,
            findBranches: findBranches,
            findClient: findClient,
            loadTerms: loadTerms,
            isLoaded: false
        };

        activate();

        return service;

        ///////
        function activate() { }

        function loadAll() {
            if (!service.isLoaded) {
                
                let promise1 = loadBranches();
                let promise2 = loadClients();
                let promise3 = loadTerms();
                let promise4 = loadEmailTypes();

                service.isLoaded = true;
                return $q.all([promise1, promise2, promise3, promise4]);
            }
            else {
                return $q.when("Lookup already loaded");
            }
        }
        
        function loadEmailTypes() {
            let deferred = $q.defer();

            invoiceDistributionApi.getEmailTypes()
                .then(function (resp) {
                    service.data.emailTypes.length = 0;
                    angular.forEach(resp.data, function (itm) {
                        service.data.emailTypes.push(itm);
                    }, this);

                    deferred.resolve(service.data.emailTypes);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadBranches() {
            let deferred = $q.defer();

            // Load branches
            branchApi.getBranchesAndStates()
                .then(function (resp) {
                    service.data.branchLookups.length = 0;
                    angular.forEach(resp.data, function (itm) {
                        itm['selected'] = false;
                        itm.StateBranches = [];
                        if (itm.State==null) {
                            itm.StateBranches = itm.Id.split(',');
                            itm.Id = utils.newGuid();
                        }
                        service.data.branchLookups.push(itm);
                    }, this);

                    deferred.resolve(service.data.branchLookups);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadTerms() {
            let deferred = $q.defer();

            // Load branches
            termsApi.getTerms()
                .then(function (resp) {
                    service.data.termLookups = resp.data;
                    deferred.resolve(service.data.termLookups);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadClients() {
            let deferred = $q.defer();

            invoiceApi.getClients()
                .then(function (resp) {
                    service.data.clientLookups.length = 0;
                    angular.forEach(resp.data, function (itm) {
                        service.data.clientLookups.push(itm);
                    }, this);

                    deferred.resolve(service.data.clientLookups);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function findBranches(branches) {
            let branchStr = getSelectedBranchesToString(branches);
            let qry = "SELECT * FROM ? WHERE Id IN " + "(?)".replace('?', branchStr);

            let results = alasql(qry, [service.data.branchLookups]);
            return results;
        }

        function getSelectedBranchesToString(branches) {
            let branchStr = '';
            angular.forEach(branches, function (itm) {
                branchStr = branchStr + "'" + itm + "',";
            }, this);

            return branchStr.substring(0, branchStr.length - 1);
        }

        function findClient(clients) {
            let clientStr = getSelectedClientToString(clients);
            let qry = "SELECT * FROM ? WHERE Id IN " + "(?)".replace('?', clientStr);

            let results = alasql(qry, [service.data.clientLookups]);
            return results;
        }

        function getSelectedClientToString(clients) {
            let clientStr = '';
            angular.forEach(clients, function (itm) {
                clientStr = clientStr + "'" + itm + "',";
            }, this);

            return clientStr.substring(0, clientStr.length - 1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.invoice.reports')
        .controller('InvoiceReportManagerController', InvoiceReportManagerController);

    /** @ngInject */
    function InvoiceReportManagerController(
        invoiceLoaderService,
        reportManagerService,
        reportSideNavService,
        invoiceDeletePreviewService,
        searchDelay,
        $mdSidenav,
        msgboxService,
        $timeout,
        $mdDialog,
        utils
    ) {
        var vm = this;

        vm.model = reportManagerService;
        vm.sidenavModel = reportSideNavService;
        vm.isDeleteDisabled = false;
        vm.delay = {
            debounce: searchDelay
        };

        vm.generatePreview = generatePreview;
        vm.showDetails = showDetails;
        vm.clearPreview = clearPreview;
        vm.deletePreview = deletePreview;
        vm.setInvoiceDate = setInvoiceDate;
        vm.toggleSidenav = toggleSidenav;
        vm.viewInvoices = viewInvoices;
        vm.viewInvoiceStatus = viewInvoiceStatus;
        vm.regenerate = regenerate;
        vm.showTags = showTags;
        vm.hideCompanies = false;
        vm.showIncludedTags = showIncludedTags;

        vm.showFiltersText = utils.translate('PREVIEW_INVOICE.SHOW_FILTERS');

        activate();

        function activate() {
            reportManagerService.onReady = function() {
                reportSideNavService.loadSingleInvoicePreview(null);
                reportSideNavService.isOverrideInvoiceDate = false;
                reportSideNavService.onRefreshContent = onRefreshContent;

                if (invoiceLoaderService.isLoadSingleInvoice) {
                    generatePreview(invoiceLoaderService.invoiceId, false);
                } else {
                    reportManagerService.clearPreview(false);
                }
            }
        }

        function generatePreview(id, isRetry) {
            if (id) {
                reportSideNavService.loadSingleInvoicePreview(id);
                reportManagerService.grid.api.refresh();
                vm.viewInvoices();
                return;
            }

            invoiceLoaderService.reset();
            reportSideNavService.loadSingleInvoicePreview(null);
            reportManagerService.clearPreview(false);

            if (reportSideNavService.isOverrideInvoiceDate && angular.isDate(reportSideNavService.data.overrideInvoiceDate)) {
                let confirm = $mdDialog.confirm()
                    .title('Override invoice date')
                    .textContent('Are you sure you want to override Invoice Date?')
                    .ariaLabel('Override invoice date')
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function() {
                    reportManagerService.generateInvoices(isRetry);
                });

                return;
            }

            if (!reportSideNavService.isOverrideInvoiceDate) {
                reportSideNavService.resetOverriderInvoiceDate();
            }

            reportManagerService.generateInvoices(isRetry);
        }

        function viewInvoices() {
            reportManagerService.showGeneratedInvoicesPage();
        }

        function viewInvoiceStatus() {
            reportManagerService.showInvoiceGenerationStatusPage();
        }

        function onRefreshContent() {
            $timeout(function() {
                reportManagerService.grid.api.refresh();
            }, 100);
        }

        function showDetails() {
            reportManagerService.showDetails = reportSideNavService.data.showDetails;
        }

        function showTags(){
            reportManagerService.showTags = reportSideNavService.data.showTags;
            reportSideNavService.data.showIncludedTags = false;
        }

        function showIncludedTags(){
            reportManagerService.showIncludedTags = reportSideNavService.data.showIncludedTags;
        }

        function clearPreview() {
            reportManagerService.clearPreview();
        }

        function deletePreview() {
            vm.isDeleteDisabled = true;
            invoiceDeletePreviewService.deletePreview(reportManagerService.grid.data)
                .then(function(resp) {
                    vm.isDeleteDisabled = false;

                    // Show issues when deleting invoice/s
                    if (resp && angular.isArray(resp) && resp.length > 0) {
                        msgboxService.show(formatFailedDeletedInvoices(resp), 'Failed deleting the following invoices');
                    }
                }).catch(function(ex) {
                    vm.isDeleteDisabled = false;
                });
        }

        function formatFailedDeletedInvoices(invoiceIds) {
            var fmt = 'Invoices below has already been finalised.<br/>';
            invoiceIds.forEach(function(id) {
                fmt += id + '<br/>';
            });
            return fmt;
        }

        function setInvoiceDate() {
            reportSideNavService.isOverrideInvoiceDate = true;
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function regenerate() {
            vm.generatePreview(null, true);
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.invoice.reports.export")
        .controller("InvoiceExportViewerController",
            InvoiceExportViewerController);

    function InvoiceExportViewerController(
        blockUI,
        utils,
        searchDelay,
        invoiceExportGridService,
        exportFilterService,
        invoiceApi,
        exceptionService,
        claimsUtilService,
        invoicingErrorCodes,
        $mdDialog,
        integrationsService,
        $rootScope,
        invoiceLookupService,
        invoiceExportService2
    ) {
        var vm = this;

        vm.exportService = invoiceExportService2;
        vm.dataGrid = invoiceExportGridService;
        vm.delay = {
            debounce: searchDelay
        };
        vm.delay = {
            debounce: searchDelay
        };

        vm.viewInvoice = loadInvoices;
        vm.export = exportInvoicesToFile;
        vm.onInvoicesLoaded = onInvoicesLoaded;
        vm.toggleSelectAllItems = toggleSelectAllItems;
        vm.integrationsService = integrationsService;
        vm.exportFilterService = exportFilterService;
        vm.lookups = invoiceLookupService.data;

        vm.isLoadingInvoices = false;
        vm.isExportingInvoices = false;
        vm.isBillingEnabled = claimsUtilService.isBillingEnabled();
        vm.isXeroEnabled = claimsUtilService.isXeroEnabled();
        vm.isMyobEnabled = claimsUtilService.isMyobEnabled();
        vm.isConnectedToXero = false;
        vm.isConnectedToMyob = false;
        vm.isIntegrationsEnabled = vm.isMyobEnabled || vm.isXeroEnabled;
        vm.isConnectedToAProvider = false;
        vm.invoicingConnectorType = null;

        vm.hasSelectedInvoices = hasSelectedInvoices;
        vm.exportInvoicesToProvider = exportInvoicesToProvider;
        vm.exportInvoicePaperwork = exportInvoicePaperwork;

        vm.hasAnyInvoiceWithErrors = hasAnyInvoiceWithErrors;
        vm.hasAnyInvoiceWithoutErrors = hasAnyInvoiceWithoutErrors;
        vm.doesInvoiceHaveErrors = doesInvoiceHaveErrors;

        vm.confirmDeleteInvoice = confirmDeleteInvoice;
        vm.redirectToCompanyPage = redirectToCompanyPage;
        vm.redirectToIntegrationsPage = redirectToIntegrationsPage;
        vm.redirectToBusinessesPage = redirectToBusinessesPage;
        vm.displayMyobJobNumberColumn = vm.isBillingEnabled && vm.isMyobEnabled;

        activate();

        function getFilterParams() {
            let filterParams = exportFilterService.data.toBackendModel();
            filterParams.InvoicingConnectorType = vm.invoicingConnectorType;
            return filterParams;
        }

        async function activate() {
            vm.dataGrid.filterData = null;

            await checkProviderConnection();
        }

        async function checkProviderConnection() {
            if (!vm.isIntegrationsEnabled) {
                return;
            }

            const providersResponse = await integrationsService.getProviders();
            vm.isConnectedToMyob = providersResponse.isConnectedToMyob;
            vm.isConnectedToXero = providersResponse.isConnectedToXero;
            vm.isConnectedToAProvider = vm.isConnectedToMyob || vm.isConnectedToXero;

            if (vm.isConnectedToXero) {
                vm.invoicingConnectorType = integrationsService.providerTypes.xero;
            } else if (vm.isConnectedToMyob) {
                vm.invoicingConnectorType = integrationsService.providerTypes.myob;
            }
        }

        function hasSelectedInvoices() {
            return vm.dataGrid.grid.data.some(invoice => invoice.isSelected);
        }

        function doesInvoiceHaveErrors(invoice) {
            return invoice.InvoicingErrors.length > 0;
        }

        async function exportInvoicesToProvider(providerType) {
            var invoices = vm.dataGrid.grid.data;

            let errors = invoices.map(invoice =>
                invoice.InvoicingErrors.filter(
                    error => (error.Code !== invoicingErrorCodes.InvoiceAlreadyExistsInXero && error.Code !== invoicingErrorCodes.InvoiceAlreadyExistsInMyob)
                )
            );

            const filterParams = getFilterParams();

            if (errors.every(e => e.length === 0)) {
                await vm.exportService.exportInvoicesToProvider(providerType, filterParams);
                return;
            }

            let confirm = $mdDialog.confirm({
                title: utils.translate(
                    "INVOICE_EXPORT.IGNORE_AND_PROCEED_TITLE"
                ),
                textContent: utils.translate(
                    "INVOICE_EXPORT.IGNORE_AND_PROCEED_MESSAGE"
                ),
                ok: utils.translate("INVOICE_EXPORT.CONFIRM_AND_EXPORT"),
                cancel: utils.translate("INVOICE_EXPORT.CANCEL")
            });

            $mdDialog
                .show(confirm)
                .then(async function() {
                    await vm.exportService.exportInvoicesToProvider(providerType, filterParams);
                })
                .finally(function() {
                    confirm = undefined;
                });
        }

        function exportInvoicePaperwork(invoice, providerType) {
            blockUI.start({
                message: utils.translate("INVOICE_EXPORT.INVOICE_PAPERWORK_EXPORT_IN_PROGRESS_MESSAGE")
            });

            let alertMessage = utils.translate("INVOICE_EXPORT.INVOICE_PAPERWORK_EXPORTED_SUCCESSFUL_MESSAGE");

            invoiceApi.exportInvoicePaperworkToProvider(invoice.InvoiceNumber, providerType)
                .catch(error => {
                    alertMessage = utils.translate("INVOICE_EXPORT.INVOICE_PAPERWORK_EXPORTED_FAILED_MESSAGE");
                })
                .finally(() => {
                    blockUI.stop();

                    let alert = $mdDialog.alert({
                        title: utils.translate(
                            "INVOICE_EXPORT.EXPORT_INVOICE_PAPERWORK_TO_XERO_TITLE"
                        ),
                        textContent: alertMessage,
                        ok: utils.translate("INVOICE_EXPORT.OK")
                    });

                    $mdDialog.show(alert)
                        .finally(function() {
                            alert = undefined;
                        });
                });
        }

        function confirmDeleteInvoice(invoice) {
            let confirm = $mdDialog.confirm({
                title: utils.translate("INVOICE_EXPORT.DELETE_INVOICE_TITLE"),
                textContent: utils.translate("INVOICE_EXPORT.DELETE_INVOICE_CONTENT_MESSAGE"),
                ok: utils.translate("INVOICE_EXPORT.OK"),
                cancel: utils.translate("INVOICE_EXPORT.CANCEL")
            });

            $mdDialog
                .show(confirm)
                .then(function() {
                    deleteInvoice(invoice);
                })
                .finally(function() {
                    confirm = undefined;
                });
        }

        function redirectToCompanyPage(invoice) {
            $rootScope.state.go('app.company_update', {
                cid: invoice.CompanyId,
                cname: invoice.CompanyName
            });
        }

        function deleteInvoice(invoice) {
            blockUI.start({
                message: utils.translate("INVOICE_EXPORT.DELETE_INVOICE_PROGRESS_MESSAGE")
            });

            let alertMessage = utils.translate("INVOICE_EXPORT.DELETE_INVOICE_SUCCESS_MESSAGE");

            invoiceApi.deleteInvoiceAndUnlockTicketAndTimesheet(invoice.Id, true)
                .catch(error => {
                    alertMessage = utils.translate("INVOICE_EXPORT.DELETE_INVOICE_FAILED_MESSAGE");
                })
                .finally(() => {
                    blockUI.stop();

                    let alert = $mdDialog.alert({
                        title: utils.translate("INVOICE_EXPORT.DELETE_INVOICE_TITLE"),
                        textContent: alertMessage,
                        ok: utils.translate("INVOICE_EXPORT.OK")
                    });

                    $mdDialog.show(alert)
                        .finally(function() {
                            alert = undefined;
                        });

                    vm.viewInvoice();
                });
        }

        function hasAnyInvoiceWithoutErrors() {
            return vm.dataGrid.grid.data
                .some(invoice => invoice.InvoicingErrors.length === 0);
        }

        function hasAnyInvoiceWithErrors() {
            return vm.dataGrid.grid.data
                .some(invoice => invoice.InvoicingErrors.length > 0);
        }

        function onInvoicesLoaded(data) {
            if (data) {
                data.forEach(function(invoice) {
                    invoice.isSelected = false;
                    invoice.isExporting = false;
                    invoice.isExportFailed = false;

                    if (!invoice.InvoicingErrors) {
                        invoice.InvoicingErrors = [];
                    }
                });
            } else {
                if (vm.dataGrid.filterData) {
                    vm.exportService.progressBarErrorMessage = "No invoices found.";
                }
            }

            vm.dataGrid.grid.onCompleted(data);

            vm.isExportingInvoices = false;
            vm.exportService.allItemsOnCurrentPageSelected = false;
            vm.isLoadingInvoices = false;
            vm.exportService.recheckInvoiceRecords();
        }

        function toggleSelectAllItems() {
            vm.dataGrid.grid.data
                .filter(inv => inv.InvoicingErrors.length === 0)
                .forEach(invoice => invoice.isSelected = vm.exportService.allItemsOnCurrentPageSelected);
        }

        async function loadInvoices() {
            vm.isLoadingInvoices = true;
            vm.dataGrid.grid.data = [];
            vm.exportService.isProcessing = false;
            vm.exportService.progressBarMessage = null;
            vm.exportService.progressBarErrorMessage = null;
            vm.exportService.resetWidgets();

            await checkProviderConnection();
            vm.dataGrid.filterData = getFilterParams();

            vm.dataGrid.grid.behavior.refresh();
        }

        function exportInvoicesToFile() {
            blockUI.start({
                message: "Exporting Invoice..."
            });

            var fp = getFilterParams();

            invoiceApi
                .exportInvoice(
                    fp.StartDate,
                    fp.EndDate,
                    fp.BranchIds,
                    fp.CompanyIds,
                    fp.IncludeNotExportedOnly
                )
                .success(function(data, status, headers, config) {
                    var blob = new Blob([data], {
                        type: "text/plain"
                    });
                    var blobURL = window.URL.createObjectURL(blob);
                    var anchor = angular.element("<a/>");
                    anchor
                        .attr({
                            href: blobURL, //hrefContent,
                            target: "_blank",
                            download: headers("Filename")
                        })[0]
                        .click();

                    blockUI.stop();
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function redirectToIntegrationsPage() {
            $rootScope.state.go('app.integrations');
        }

        function redirectToBusinessesPage() {
            $rootScope.state.go('app.businesses');
        }
    }
})();

/**
 * Invoice Email Sender
 * Created date: 4.5.2017
 */
(function() {
    'use strict';

    angular
        .module('app.invoice.emailsender')
        .controller('EmailSenderController', EmailSenderController);

    /** @ngInject */
    function EmailSenderController(
        $mdSidenav,
        emailSenderMainService,
        tenantsApi
    ) {
        var vm = this;

        // Data
        vm.model = emailSenderMainService;

        // Method
        vm.generatePreview = generatePreview;
        vm.checkToggle = vm.model.checkToggle;
        vm.downloadInvoice = vm.model.downloadInvoice;
        vm.sendEmail = vm.model.sendEmail;
        vm.openIssue = vm.model.openIssue;
        vm.checkSingleItem = vm.model.checkSingleItem;
        vm.selectViewType = vm.model.selectViewType;
        vm.checkPaymentClaim = vm.model.checkPaymentClaim;
        vm.clearPreview = clearPreview;
        vm.isPaymentClaimEnabled = false;

        activate();

        //////////
        function activate() {
            getGeneralSettings();
        }

        function generatePreview() {
            vm.model.generatePreview();
        }

        function clearPreview() {
            vm.model.stopGridFetchingData();
        }

        function getGeneralSettings(){
            return tenantsApi.getGeneralSettings().then(function(resp) {
                var data = resp.data;
                vm.isPaymentClaimEnabled = data.EnablePaymentClaim == null? false : data.EnablePaymentClaim === 'true'
            });
        }

        vm.toggleSidenav = function(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.holidays.view', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.holidays_view', {
            url: '/holidays',
            views: {
                'content@app': {
                    templateUrl: 'app/main/holidays/view/holidays-view.html',
                    controller: 'HolidaysViewController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasPublicHolidays;
                }] 
            },
            title: 'Manage Public Holidays',
            titleBar: 'Alloc8 - Public Holidays'
        });
    }

})();

(function () {
  'use strict';

  angular
    .module('app.holidays.view')
    .controller('HolidaysViewController', HolidaysViewController);

  function HolidaysViewController(holidayService,
                                  _,
                                  searchDelay,
                                  utils,
                                  DTColumnDefBuilder) {
    var vm = this;
    vm.dtInstance = {};
    vm.service = holidayService;
    vm.dtOptions = {
      dom: 'rt<"bottom"lip><"clear">',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      order: [3, 'asc'],
      initComplete : function(){
        searchTable();
      }
    };

    vm.activate = activate;
    vm.parseDate = parseDate;
    vm.displayBranch = displayBranch;
    vm.searchTable = searchTable;
    vm.remove = remove;
    vm.formatDate = formatDate;

    vm.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef([1]).withOption('type', 'date')
    ]; 

    function activate(){
      vm.service.initialize();
    }

    function searchTable() {
      if(!_.isNil(vm.service.query)){
        setTimeout(function () {
          vm.dtInstance.DataTable.search(vm.service.query);
          vm.dtInstance.DataTable.search(vm.service.query).draw();
        }, searchDelay);
      }
    }

    function displayBranch(holiday){
      if(holiday.IsNationalHoliday){
        return 'National';
      }else{
        let branches =  holiday.Branches.map(function(a) {
          return a.Name;
        });

        return branches.join(", ");
      }
    }

    function parseDate(date){
      return new Date(date);
    }

    function remove(id){
      vm.service.delete(id);
    }

    function formatDate(dt) {
      const [year, month, day] = dt.split("T")[0].split("-");
      return `${month}/${day}/${year}`;
    }

    vm.activate();
  }
})();

(function () {
  'use strict';

  angular.module('app.holidays')
    .factory('holidayService', holidayService);

  /** @ngInject */
  function holidayService($mdDialog,
                          jobsApi,
                          utils,
                          publicHolidayApi,
                          $q,
                          blockUI) {

    var service = {
      branches : [],
      divisionsLookup : [],
      holidays : [],
      query : null,
      showHolidayDialog : showHolidayDialog,
      initialize : initialize,
      getHolidays : getHolidays,
      delete : deleteHoliday,
      formatDivisions : formatDivisions
    }

    return service;

    function showHolidayDialog(data, editMode){
      $mdDialog.show({
        templateUrl : 'app/main/holidays/services/dialog/holiday-dialog.html',
        controller :'HolidayDialogController as vm',
        locals :{
          branches : service.branches,
          Divisions : service.divisionsLookup,
          editMode : editMode,
          data : data,
          holidayModel : new holidayModel()
        }
      }).then(function(data){
        if(data){
         delete data.Branch;
         data.HolidayDate = utils.jsDateTime(data.HolidayDate);
         if(editMode){
           blockUI.start(utils.translate('HOLIDAYS.MAIN_EDITING_HOLIDAY'));
           data.IsNationalHoliday ? data.Branches = [] : data.Branch = data.Branches;
           publicHolidayApi.putHoliday(data.Id, data).then(function(){
             blockUI.stop();
             service.getHolidays();
           });
         }else{
           blockUI.start(utils.translate('HOLIDAYS.MAIN_ADDING_HOLIDAY'));
           publicHolidayApi.postHoliday(data).then(function(){
             blockUI.stop();
             service.getHolidays();
           });
         }
        }
      });
    }

    function holidayModel(){
      return {
        Id: null,
        HolidayName : null,
        HolidayDate : null,
        IsNationalHoliday : false,
        Branches : [],
        Divisions : []
      }
    }

    function initialize(){
      blockUI.start(utils.translate('HOLIDAYS.MAIN_LOADING_HOLIDAYS'));
      $q.all([jobsApi.getBranches(), publicHolidayApi.getHolidays()]).then(function(resp){
        service.branches = resp[0].data;
        service.holidays = resp[1].data;
        blockUI.stop();
      })
    }

    function formatDivisions(branches){
      let divisions  = [];
      angular.forEach(branches, function(branch){
        angular.forEach(branch.Division, function(division){
          let div = divisionModel();
          div.Id = division.id;
          div.Name = division.Name;
          div.BranchId = branch.Id;
          div.BranchName = branch.Name;
          divisions.push(div);
        });
      });
      return alasql('select * from ? order by Name', [divisions]);
    }

    function divisionModel(){
      return {
        Id : null,
        Name : null,
        BranchId : null,
        BranchName : null
      }
    }

    function getHolidays(){
      blockUI.start(utils.translate('HOLIDAYS.MAIN_LOADING_HOLIDAYS'));
      publicHolidayApi.getHolidays().then(function(resp){
        service.holidays = resp.data;
        blockUI.stop();
      })
    }

    function deleteHoliday(id){
      blockUI.start(utils.translate('HOLIDAYS.MAIN_DELETING_HOLIDAY'));
      publicHolidayApi.deleteHoliday(id).then(function(){
        blockUI.stop();
        service.getHolidays();
      })
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('app.dashboard', ['ngPlacesMap'])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider,
        msNavigationServiceProvider
    ) {
        // State
        $stateProvider
            .state('app.dashboard', {
                url: '/dashboard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller: 'DashboardController as vm'
                    }
                },
                title: 'Dashboard',
                titleBar: 'Alloc8 - Dashboard',
                data: {
                    requireLogin: true
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard');

        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title: '',
            group: true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboard', {
            title: 'Dashboard',
            icon: 'icon-tile-four',
            state: 'app.dashboard',
            weight: 1
        });
    }
})();

angular
  .module('app.dashboard')
  .controller('DashboardManageController', DashboardManageController);

/** @ngInject */
function DashboardManageController($mdDialog, widgetTypes, datasets, utils, userWidgets, dashboardApi) {
  var vm = this;
  vm.model = {
    ReportSource: null,
    Datasets: []
  }
  vm.datasets = datasets;
  vm.widgetTypes = widgetTypes;
  vm.showInputFields = false;
  vm.utilService = utils;
  vm.isSaving = false;
  vm.dtOptions = {
    dom: 'rt<"bottom"lip>',
    pagingType: 'simple',
    autoWidth: true,
    responsive: false
  }

  vm.getTypeDetail = getTypeDetail;
  vm.onClose = onClose;
  vm.showFields = showFields;
  vm.save = save;
  vm.deleteWidget = deleteWidget;

  function showFields(show, isEdit, data) {
    vm.showInputFields = true;
    vm.data = angular.copy(vm.model);
    vm.isEdit = isEdit;
    if (show) {
      if(isEdit){
        vm.Id = data.Id;
        vm.data.ReportSource = data;
        vm.data.ReportSource['tempGUID'] = _.find(vm.widgetTypes, {DisplayName : data.Name}).tempGUID;
        vm.data.Datasets = data.DataSets;
      }
    } else {
      vm.showInputFields = false;
    }
  }

  function onClose() {
    $mdDialog.hide();
  }

  function cleanType(type) {
    delete type.Icon;
    delete type.Class;
    delete type.Alias;
    type['Name'] = type.Type;
    return type;
  }

  function transformData(data) {
    let type = angular.copy(data.ReportSource.WidgetType);
    return {
      Name: data.ReportSource.DisplayName,
      DataSets: type.RequiresDatasets ? data.Datasets : [],
      Type: cleanType(type)
    }
  }

  function save() {
    vm.loaderMessage = utils.translate('DASHBOARD.SAVING');
    vm.isSaving = true;
    let payload = transformData(vm.data);

    if(vm.isEdit){
      payload['Id'] = vm.Id;
      dashboardApi.edit(payload, vm.Id).then(getWidgets).catch(function () {
        vm.isSaving = false;
        showErrorMessage();
      });
    }else{
      dashboardApi.add(payload).then(getWidgets).catch(function () {
        vm.isSaving = false;
        showErrorMessage();
      });
    }

  }

  function getWidgets() {
    dashboardApi.getWidgets().then(function (resp) {
      vm.loaderMessage = utils.translate('DASHBOARD.LOADING');
      vm.isSaving = false;
      vm.data = angular.copy(vm.model);
      vm.showInputFields = false;
      vm.user_widgets = resp.data;
    });
  }

  function getTypeDetail(Id) {
    let type = {};
    if (Id == 0) {
      type.Alias = "Number";
      type.Icon = "number";
      type.Class = "green-500-fg";
    }
    if (Id == 1) {
      type.Alias = "Bar";
      type.Icon = "bar";
      type.Class = "light-blue-500-fg";
    }
    if (Id == 2) {
      type.Alias = "Pie";
      type.Icon = "pie";
      type.Class = "red-500-fg";
    }
    if (Id == 3) {
      type.Alias = "Line";
      type.Icon = "line";
      type.Class = "orange-500-fg";
    }
    return type;
  }

  function deleteWidget(data){
    vm.loaderMessage = utils.translate('DASHBOARD.SAVING');
    vm.isSaving = true;
    dashboardApi.deleteWidget(data.Id).then(getWidgets).catch(function(){
      showErrorMessage();
      vm.isSaving = false;
    });
  }

  function showErrorMessage(){
    $mdDialog.show(
      $mdDialog.alert()
        .title(utils.translate('DASHBOARD.WIDGET_ERROR_HEADER'))
        .multiple(true)
        .textContent(utils.translate('DASHBOARD.WIDGET_ERROR_MESSAGE'))
        .ok(utils.translate('DASHBOARD.WIDGET_CLOSE'))
    );
  }

  function activate() {
    angular.forEach(vm.widgetTypes, function (widget) {
      let type = getTypeDetail(widget.WidgetType.Id);
      widget.WidgetType['Icon'] = type.Icon;
      widget.WidgetType['Class'] = type.Class;
      widget['tempGUID'] = utils.newGuid();
    });
    vm.data = angular.copy(vm.model);
    vm.user_widgets = userWidgets;
  }

  activate();
}

(function() {
    'use strict';

    angular
        .module('app.equipment.view')
        .controller('EquipmentsViewController', EquipmentsViewController);

    function EquipmentsViewController(
        equipmentsService,
        claimsUtilService,
        searchDelay,
        equipmentsViewGridService,
        utils,
        $mdDialog,
        $scope,
        blockUI
    ) {
        var vm = this;
        vm.dtInstance = null;
        vm.equipmentsService = equipmentsService;
        vm.utilService = utils;
        vm.delay = {
            debounce: searchDelay
        };
        vm.dataGrid = equipmentsViewGridService;

        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'full_numbers',
            searchDelay: searchDelay,
            autoWidth: true,
            responsive: false,
        };

        vm.activate = activate;
        vm.formatDivision = formatDivision;
        vm.addEquipmentDialog = addEquipmentDialog;
        vm.editEquipmentDialog = editEquipmentDialog;
        vm.viewDocuments = viewDocuments;
        vm.assetId = null;

        vm.isDocumentManagementEnabled = claimsUtilService.isDocumentManagementEnabled();
        vm.canEditIndividualEquipmentItem = claimsUtilService.checkAccessByRole("Edit Individual Equipment Item");
        vm.canDeleteEquipment = claimsUtilService.isCustomerOnboardingEnabled() && vm.canEditIndividualEquipmentItem;
        vm.canManageDocumentAssets = claimsUtilService.checkAccessByRole("DocumentsManager-Assets");
        vm.confirmDeleteEquipment = confirmDeleteEquipment;
        vm.hasUserBranchConflict = hasUserBranchConflict;

        vm.activate();

        function activate() {
            vm.equipmentsService.equipment = [];
        }

        function formatDivision(divisions) {
            let result = divisions.map(function(division) {
                return division.Name;
            });
            return result.join(", ");
        }

        function addEquipmentDialog() {
            vm.equipmentsService.addEquipmentDialog()
                .then(function () {
                    vm.dataGrid.grid.behavior.refresh();
                });
        }

        function editEquipmentDialog(item) {
            vm.equipmentsService.editEquipmentDialog(item)
                .then(function() {
                    vm.dataGrid.grid.behavior.refresh();
                });
        }

        function viewDocuments(assetId, itemName, itemType, parentItemTypes) {
            vm.assetId = assetId;

            $mdDialog.show({
                scope: $scope,
                preserveScope: true,
                templateUrl: 'app/main/equipment/view/equipments-view-documents.html',
                multiple: true
            }).then(function(result) {});
        }

        function confirmDeleteEquipment(equipment) {
            let equipmentId = equipment.IndividualItemId;
            let equipmentName = equipment.UniqueId;

            let confirm = $mdDialog.confirm({
                title: "Delete Equipment",
                textContent: "Are you sure you want to delete the equipment '" + equipmentName + "'?",
                ok: "OK",
                cancel: "CANCEL"
            });

            $mdDialog
                .show(confirm)
                .then(function() {
                    deleteEquipment(equipmentId, equipmentName);
                })
                .finally(function() {
                    confirm = undefined;
                });
        }

        function deleteEquipment(equipmentId, equipmentName) {
            blockUI.start({
                message: "Deleting Equipment..."
            });

            let alertMessage = "Equipment '" + equipmentName + "' has been deleted."

            equipmentsService
                .deleteEquipment(equipmentId)
                .catch(error => {
                    alertMessage = "Error occured while deleting equipment '" + equipmentName + "'.";
                })
                .finally(() => {
                    blockUI.stop();

                    let alert = $mdDialog.alert({
                        title: "Delete Equipment",
                        textContent: alertMessage,
                        ok: "OK"
                    });

                    $mdDialog.show(alert)
                        .finally(function() {
                            alert = undefined;
                        });

                    equipmentsViewGridService.grid.behavior.refresh();
                });
        }

        function hasUserBranchConflict(vehicle){

            let hasConflicts = false;

            if (vehicle) {
                hasConflicts = vehicle.HasUserBranchConflict;
            }
            else {
                hasConflicts = vm.dataGrid.grid.data.some(function (vehicle) {
                    return vehicle.HasUserBranchConflict;
                });
            }

            return hasConflicts;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.equipment.view')
        .service('equipmentsViewGridService', equipmentsViewGridService);

    /** @ngInject */
    function equipmentsViewGridService(
        exceptionService,
        equipmentsViewListAdapterService
    ) {
        let service = {
            grid: {},
            filterData: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // Reference to grid Data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;

        return service;

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(equipmentsViewListAdapterService);
        }

        /**
         * Loading of partial data
         */
        function onCompleted(data) {
            service.grid.data.length = 0;
            angular.forEach(data, function(itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function onDataLoading() {}

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {}

        function onError(ex) {
            exceptionService.resolve(ex);
        }
    }
})();

/**
 * View Exquipment List Adapter
 * Created by queeniejgm on 07/18/2018.
 */
(function () {
    'use strict';

    angular.module('app.equipment.view')
        .service('equipmentsViewListAdapterService', equipmentsViewListAdapterService);

    /** @ngInject */
    function equipmentsViewListAdapterService($log,
                                              $q,
                                              a8WebApiNoChunkDataProvider,
                                              rateCardsApi,
                                              exceptionService,
                                              equipmentsService) {

        let service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData // inbound event (called by grid client)
        };

        let dbSource = a8WebApiNoChunkDataProvider.getInstance();

        activate();

        return service;

        function activate() {
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from source
         */
        function onGetData() {
            return dbSource.fetch(function () {
                return getEquipmentData();
            });
        }

        function getEquipmentData() {
            equipmentsService.equipment = [];
            return equipmentsService.initializeData()
                .then(function(resp){
                    equipmentsService.equipment = angular.forEach(equipmentsService.equipment, function(itm) {
                        
                        itm.BranchNames = formatBranches(itm.Branches);
                        itm.DivisionNames = formatDivisions(itm.Branches);
                        itm.FullName = formatName(itm.User);
                        itm.ItemStatus = formatStatus(itm.ItemStatus);

                        return itm;
                    });

                    let deferred = $q.defer();
                    deferred.resolve(equipmentsService.equipment);
                    return deferred.promise;
                });
        }

        function formatBranches(branches){
            return branches.map(d => d.Name).join(", ");
        }

        function formatDivisions(branches) {
            let divisions = branches.flatMap(b => b.Division);
            return divisions.map(d => d.Name).join(", ");
        }

        function formatName(user){
            return user != null ? user.FirstName + " " + user.LastName : null ;
        }

        function formatStatus(status){
            return status === 1 ? 'Active' : 'Not in service';
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.equipment')
        .factory('equipmentsService', equipmentsService);

    /** @ngInject */
    function equipmentsService(
        $state,
        assetsApi,
        exceptionService,
        $mdDialog,
        branchApi,
        $q,
        equipmentBranchModel,
        lookupApi,
        utils
    ) {
        var service = {
            equipment: [],
            branches: [],
            query: null,
            States: [],
            item_types: [],
            items: [],
            loader: false,
            loaderMessage: null,
            editEquipmentDialog: editEquipmentDialog,
            initializeData: initializeData,
            addEquipmentDialog: addEquipmentDialog,
            viewCalendar: viewCalendar,
            deleteEquipment: deleteEquipment
        };

        return service;

        function viewCalendar(equipment) {
            $state.go("app.equipment_calendar", {
                Id: equipment.ItemId,
                Name: equipment.ItemName,
                Unique: equipment.UniqueId
            });
        }

        function initializeData() {
            service.loader = true;
            service.loaderMessage = utils.translate('EQUIPMENT_VIEW.LOADING');
            service.branches = [];

            var uris = [
                branchApi.getBranches(),
                assetsApi.getIndividualItemsEquipmentOnly(),
                assetsApi.getIndividualItemStatus(),
                lookupApi.getItemTypes(),
                lookupApi.getEquipmentTypes(),
                lookupApi.getVehicleOwnershipTypes()
            ];

            return $q
                .all(uris)
                .then(function(resp) {
                    angular.forEach(resp[0].data, function(branch) {
                        var branchModel = new equipmentBranchModel();
                        branchModel.map(branch);
                        service.branches.push(branchModel.toBackendModel())
                    });
                    service.branches = alasql('select * from ? order by Name', [service.branches]);
                    service.equipment = resp[1].data;
                    service.States = resp[2].data;
                    service.item_types = resp[3].data;
                    service.items = resp[4].data;
                    service.ownershipTypes = resp[5].data;
                    service.loader = false;
                    service.loaderMessage = null;
                })
                .catch(function(ex) {
                    service.loader = false;
                    service.loaderMessage = null;
                    exceptionService.resolve(ex);
                });
        }

        function addEquipmentDialog() {
            return $mdDialog.show({
                templateUrl: 'app/main/equipment/services/dialogs/manageEquipment/manage-equipment-dialog.html',
                controller: 'manageEquipmentController as vm',
                locals: {
                    editData: null,
                    itemStates: service.States,
                    branches: service.branches,
                    itemTypes: service.item_types,
                    items: service.items,
                    ownershipTypes: service.ownershipTypes
                }
            }).then(function(resp) {
                if (resp) {
                    service.loader = true;
                    service.loaderMessage = utils.translate('EQUIPMENT_VIEW.SAVING');
                    assetsApi.postMinifiedEquipment(resp)
                        .then(function() {
                            service.loader = false;
                            service.loaderMessage = null;
                            service.initializeData();
                            service.query = null;
                        })
                        .catch(function(ex) {
                            service.loader = false;
                            service.loaderMessage = null;
                            exceptionService.resolve(ex);
                        });
                }
            });
        }

        function editEquipmentDialog(equipment) {
            return $mdDialog.show({
                templateUrl: 'app/main/equipment/services/dialogs/manageEquipment/manage-equipment-dialog.html',
                controller: 'manageEquipmentController as vm',
                locals: {
                    editData: equipment,
                    itemStates: service.States,
                    branches: service.branches,
                    itemTypes: service.item_types,
                    items: service.items,
                    ownershipTypes: service.ownershipTypes
                }
            }).then(function(resp) {
                if (resp) {
                    service.initializeData();
                }
            });
        }

        function deleteEquipment(equipmentId){
            return assetsApi.deleteIndividualItem(equipmentId);
        }
    }
})();

(function(){
   'use strict';

  angular.module('app.equipment')
          .service('equipmentBranchModel', equipmentBranchModel)

    function equipmentBranchModel(utils) {
        return function () {
            var self = this,
            defaults = {
               id: null,
               FirstName: null,   // Enum found in assetsApi
               ImageUrl: null,
               LastName: null,  // Branch object
               MiddleName: null,  // Contact Employee type (Object)
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                return {
                  id: self.id,
                  FirstName: self.FirstName,
                  ImageUrl: self.ImageUrl,   // Enum found in assetsApi
                  LastName: self.LastName,  // Branch object
                  MiddleName: self.MiddleName,  // Contact Employee type (Object)
                };
            }
        }
    };

})();

(function(){
   'use strict';

  angular.module('app.equipment')
          .service('equipmentModel', equipmentModel)

    function equipmentModel(utils) {
        return function () {
            var self = this,
            defaults = {
               IndividualItemId: null,
               ItemStatus: null,
               Branches: null,
               ItemType : null,
               User: null,
               UniqueItemId : null,
               Description : null,
               ItemId : null,
               StatusEffectiveDate: null,
               VehicleOwnershipType: null
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                return {
                  IndividualItemId: self.IndividualItemId,
                  ItemStatus: self.ItemStatus,
                  Branches: self.Branches,
                  User: self.User,
                  ItemType: self.ItemType,
                  UniqueItemId : self.UniqueItemId,
                  Description : self.Description,
                  ItemId : self.ItemId,
                  StatusEffectiveDate : self.StatusEffectiveDate,
                  VehicleOwnershipType: self.VehicleOwnershipType
                };
            }
        }
    };

})();

(function(){
   'use strict';

  angular.module('app.equipment')
          .service('equipmentBranchModel', equipmentBranchModel)

    function equipmentBranchModel(utils) {
        return function () {
            var self = this,
            defaults = {
               Id: null,
               Name: null,
               State: null,
               Division: []
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
            }

            function transformToModel() {
                var model = {
                  Id: self.Id,
                  Name: self.Name,
                  State: self.State,
                  Division: self.Division,
                };

                return model;
            }
        }
    };

})();

(function ()
{
    'use strict';

    angular
        .module('app.equipment.calendar', [
            'ui.calendar'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.equipment_calendar', {
            url: '/equipment/calendar/:Id?/:Name?/:Unique',
            views: {
                'content@app': {
                    templateUrl: 'app/main/equipment/calendar/equipment-calendar.html',
                    controller: 'equipmentCalendarController as vm'
                }
            },
            data: { requireLogin: true },
            title: 'Equipment Calendar',
            titleBar: 'Alloc8 - Equipment Calendar',
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/contact/calendar');

        // Navigation
        // msNavigationServiceProvider.saveItem('apps.calendar', {
        //     title : 'Calendar',
        //     icon  : 'icon-calendar-today',
        //     state : 'app.calendar',
        //     weight: 2
        // });
    }
})();

(function() {
    'use strict';

    angular.module('app.equipment.calendar')
        .service('equipmentCalendarModel', equipmentCalendarModel);

    function equipmentCalendarModel(localisationService) {
        return function() {
            var self = this,
                defaults = {
                    Id: null,
                    CalendarEntryType: null,
                    CalendarEntryTypeDetails: null,
                    title: null,
                    color: null,
                    ItemId: null,
                    Repeats: null,
                    StartDate: null,
                    start: null,
                    EndDate: null,
                    end: null,
                    Rejected: []
                };

            self.map = mapper;
            self.transformToServerModel = transformToServerModel;
            self.transformToModel = transformToModel;
            self.transformData = transformData;
            self.reset = reset;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults;
                var opts = angular.extend(this, defaults, mapValue);

                if (opts.StartDate) {
                    this.start = moment(opts.StartDate).toDate();
                }

                if (opts.EndDate) {
                    this.end = moment(opts.EndDate).toDate();
                }

                if (opts.Title) {
                    this.title = opts.Title;
                }

                if (opts.Color) {
                    this.color = opts.Color;
                }
            }

            function reset() {
                self.map(null);
                self.Repeat.length = 0;
            }

            function transformToServerModel() {
                var startDate = null,
                    endDate = null,
                    timeformat = null,
                    repeat = {},
                    isoDate = null;

                var localeSettings = localisationService.getLocaleFormatSettings();
                timeformat = localeSettings.timeFormat;
                isoDate = localeSettings.isoDateTime;

                if (self.startTime) {
                    self.StartDate = moment(self.start).format('MM/DD/YYYY') + ' ' +
                        moment(moment(self.startTime, timeformat)).format('HH:mm:ss');
                }

                if (self.endTime) {
                    self.end = _.isNil(self.end) ? self.start : self.end;
                    self.EndDate = moment(self.end).format('MM/DD/YYYY') + ' ' +
                        moment(moment(self.endTime, timeformat)).format('HH:mm:ss');
                }

                if (self.StartDate) {
                    startDate = moment(self.StartDate, localeSettings.serverDefaultDateFormat).format(isoDate);
                    repeat.StartsOn = startDate;
                }

                if (self.EndDate) {
                    endDate = moment(self.EndDate, localeSettings.serverDefaultDateFormat).format(isoDate);
                }

                if (self.IsAllDayEvent) {
                    self.StartDate = moment(self.start).format('MM/DD/YYYY') + ' ' +
                        moment(moment(self.startTime, timeformat)).format('HH:mm:ss');
                    startDate = moment(self.StartDate, localeSettings.serverDefaultDateFormat).format(isoDate);

                    self.EndDate = moment(self.end).format('MM/DD/YYYY') + ' ' +
                        moment(moment(self.endTime, timeformat)).format('HH:mm:ss');
                    endDate = moment(self.EndDate, localeSettings.serverDefaultDateFormat).format(isoDate);

                    if (self.start === self.end) {
                        endDate = moment(moment(endDate).add(1, "days")).format(isoDate);
                    }
                }
                if (self.repeat) {
                    if (self.repeat.EndsOn) {
                        var _endTime = "00:00:00";
                        var _endDate = moment(moment(self.repeat.EndsOn).format('MM/DD/YYYY') + ' ' + _endTime);
                        self.repeat.EndsOn = moment(_endDate, localeSettings.serverDefaultDateFormat).format(isoDate);
                    }
                } else {
                    self.repeat = null;
                }

                var serverModel = {
                    Id: !self.Id ? null : self.Id,
                    CalendarEntryType: self.EntryType,
                    CalendarEntryTypeDetails: self.EntryReason,
                    ItemId: self.ItemId,
                    Repeats: self.repeat,
                    StartDate: startDate,
                    EndDate: endDate,
                    IsAllDayEvent: self.IsAllDayEvent,
                    Rejected: self.Rejected,
                    Remarks: self.Remarks
                }
                return serverModel;
            }

            function transformData(data, settings) {
                var repeat = _.find(settings, function(o) {
                    return o.Id === data.CalendarEntryId
                }).Repeats;
                var IsAllDayEvent = _.find(settings, function(o) {
                    return o.Id === data.CalendarEntryId
                }).IsAllDayEvent;
                var CalendarEntryTypeDetails = _.find(settings, function(o) {
                    return o.Id === data.CalendarEntryId
                }).CalendarEntryTypeDetails;

                 var Remarks = _.find(settings, function(o) { 
                    return o.Id === data.CalendarEntryId 
                }).Remarks;

                var event = {
                    id: data.Id,
                    title: data.Title,
                    start: data.start,
                    end: data.end,
                    color: data.color,
                    IsAllDayEvent: IsAllDayEvent,
                    StartDate: data.StartDate,
                    EndDate: data.EndDate,
                    CalendarEntryType: data.CalendarEntryType,
                    CalendarEntryTypeDetails: CalendarEntryTypeDetails,
                    ParentId: data.CalendarEntryId,
                    Repeats: repeat,
                    Remarks: Remarks
                }

                return event;
            }

            function transformToModel(data, yearDiff) {
                var localeSettings = localisationService.getLocaleFormatSettings();
                var timeformat = localeSettings.timeFormat;

                var transformModels = {
                    calendarSettingEntry: [],
                    transformedDataCollection: [],
                    dataCollection: []
                };
                var transformedData = []
                var calendarSettingEntry = [];
                calendarSettingEntry = data;
                transformModels.calendarSettingEntry.push(calendarSettingEntry);


                // RepeatType 0 = daily; 1= weekly; 2 = monthly; 3 = yearly
                angular.forEach(data, function(item) {
                    //TODO:Handle long event per week, month and year
                    //initialize start and end
                    var _startdate = moment(item.StartDate).toDate();
                    var _enddate = moment(moment(item.StartDate).format('YYYY-MM-DD') + ' ' + moment(item.EndDate).format(timeformat)).toDate();


                    if (moment(item.EndDate).hour() <= moment(item.StartDate).hour()) {
                        _enddate = moment(moment(_enddate).add(1, 'days').format()).toDate();
                    }

                    var _color = null;
                    if (item.CalendarEntryType === 0) {
                        _color = '#1e514e';
                    }
                    if (item.CalendarEntryType === 1) {
                        _color = '#6493a9';
                    }
                    if (item.CalendarEntryType === 2) {
                        _color = '#146c7c';
                    }
                    if (item.Repeats) {
                        var _endsOn = angular.copy(item.Repeats.EndsOn);
                        //generate intial data until end of the current year
                        if (!item.Repeats.EndsOn) {
                            if (yearDiff) {
                                _endsOn = moment(moment().endOf("year")).add(yearDiff, 'years');
                            } else {
                                _endsOn = moment().endOf("year");
                            }
                        } else {
                            var formattedEndons = moment(_endsOn).format('YYYY-MM-DD') + ' ' + moment().endOf("year").format('HH:mm:ss');
                            _endsOn = moment(formattedEndons).toDate();
                        }

                        if (item.Repeats.RepeatType === 0) {
                            while (_enddate <= moment(_endsOn).toDate()) {
                                var transformModel = {};
                                transformModel.id = _.uniqueId();
                                transformModel.ParentId = item.Id;
                                transformModel.CalendarEntryType = item.CalendarEntryType;
                                transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                                transformModel.title = item.title;
                                transformModel.StartDate = item.StartDate;
                                transformModel.EndDate = item.EndDate;
                                transformModel.EndsOn = item.Repeats.EndsOn;
                                transformModel.start = _startdate;
                                transformModel.end = _enddate;
                                transformModel.color = _color;
                                transformModel.Repeats = item.Repeats;
                                transformedData.push(transformModel);
                                transformModels.dataCollection.push(transformModel);

                                _startdate = moment(moment(_startdate).add(item.Repeats.RepeatEvery, 'days').format()).toDate();
                                _enddate = moment(moment(_enddate).add(item.Repeats.RepeatEvery, 'days').format()).toDate();
                            }
                        }

                        if (item.Repeats.RepeatType === 1) {
                            var transformModel = {};
                            transformModel.id = _.uniqueId();
                            transformModel.ParentId = item.Id;
                            transformModel.CalendarEntryType = item.CalendarEntryType;
                            transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                            transformModel.title = item.title;
                            transformModel.dow = item.Repeats.RepeatsOn;
                            transformModel.StartDate = item.StartDate;
                            transformModel.EndDate = item.EndDate;
                            transformModel.EndsOn = item.Repeats.EndsOn;
                            transformModel.start = moment(item.StartDate).format(timeformat);
                            transformModel.end = computeOverNight(item.StartDate, item.EndDate, timeformat);
                            transformModel.color = _color;
                            transformModel.Repeats = item.Repeats;

                            if (item.Repeats.RepeatEvery < 2) {
                                transformModel.ranges = [{
                                    start: moment(item.StartDate).toDate(),
                                    end: moment(_endsOn).toDate()
                                }]
                            }

                            if (item.Repeats.RepeatEvery > 1) {
                                transformModel.ranges = [];
                                _enddate = moment(_enddate).add(7 - moment(_startdate).diff(moment(_startdate).startOf('week'), 'days'), 'days').toDate();
                                while (_enddate <= moment(_endsOn).toDate()) {
                                    var _range = {};
                                    _range.start = _startdate;
                                    _range.end = _enddate;
                                    transformModel.ranges.push(_range);
                                    _startdate = moment(_startdate).add(item.Repeats.RepeatEvery * 1, 'weeks').toDate();
                                    _enddate = moment(_startdate).add(7 - moment(_startdate).diff(moment(_startdate).startOf('week'), 'days'), 'days').toDate();
                                }
                            }
                            transformedData.push(transformModel);
                            transformModels.dataCollection.push(transformModel);
                        }

                        if (item.Repeats.RepeatType === 2) {
                            while (_enddate <= moment(_endsOn).toDate()) {
                                var transformModel = {};
                                transformModel.id = _.uniqueId();
                                transformModel.ParentId = item.Id;
                                transformModel.CalendarEntryType = item.CalendarEntryType;
                                transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                                transformModel.title = item.title;
                                transformModel.StartDate = _startdate;
                                transformModel.EndDate = _enddate;
                                transformModel.EndsOn = item.Repeats.EndsOn;
                                transformModel.start = _startdate;
                                transformModel.end = _enddate;
                                transformModel.color = _color;
                                transformModel.Repeats = item.Repeats;
                                transformedData.push(transformModel);
                                transformModels.dataCollection.push(transformModel);

                                _startdate = moment(moment(_startdate).add(item.Repeats.RepeatEvery * 1, 'months').format()).toDate();
                                _enddate = moment(moment(_enddate).add(item.Repeats.RepeatEvery * 1, 'months').format()).toDate();
                            }
                        }

                        if (item.Repeats.RepeatType === 3) {

                            while (_enddate <= moment(_endsOn).toDate()) {
                                var transformModel = {};
                                transformModel.id = _.uniqueId();
                                transformModel.ParentId = item.Id;
                                transformModel.CalendarEntryType = item.CalendarEntryType;
                                transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                                transformModel.title = item.title;
                                transformModel.StartDate = item.StartDate;
                                transformModel.EndDate = item.EndDate;
                                transformModel.EndsOn = item.Repeats.EndsOn;
                                transformModel.start = _startdate;
                                transformModel.end = _enddate;
                                transformModel.color = _color;
                                transformModel.Repeats = item.Repeats;
                                transformedData.push(transformModel);
                                transformModels.dataCollection.push(transformModel);

                                _startdate = moment(moment(_startdate).add(item.Repeats.RepeatEvery * 1, 'years').format()).toDate();
                                _enddate = moment(moment(_enddate).add(item.Repeats.RepeatEvery * 1, 'years').format()).toDate();
                            }
                        }
                    } else {
                        var transformModel = {};
                        transformModel.id = _.uniqueId();
                        transformModel.ParentId = item.Id;
                        transformModel.CalendarEntryType = item.CalendarEntryType;
                        transformModel.CalendarEntryTypeDetails = item.CalendarEntryTypeDetails;
                        transformModel.title = item.title;
                        //transformModel.dow = item.Repeats.RepeatsOn;
                        transformModel.StartDate = item.StartDate;
                        transformModel.EndDate = item.EndDate;
                        //transformModel.EndsOn = item.Repeats.EndsOn;
                        transformModel.start = moment(item.StartDate).toDate();
                        transformModel.end = moment(item.EndDate).toDate();
                        transformModel.color = _color;
                        transformModel.Repeats = item.Repeats;
                        transformModels.dataCollection.push(transformModel);
                    }
                });
                transformModels.transformedDataCollection.push(transformedData);
                return transformModels;
            }

            function computeOverNight(start, end, timeformat) {
                if (moment(end).hour() <= moment(start).hour()) {
                    var time = 24 + (((moment(end).hour() / 60) + moment(end).minutes()) * 60);
                    return time + ':00';
                }
                return moment(end).format(timeformat);
            }

        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.equipment.calendar')
        .controller('equipmentCalendarController', equipmentCalendarController);

    /** @ngInject */
    function equipmentCalendarController(equipmentCalendarModel, $q, $state, _, $mdDialog, $document, assetsApi, blockUI, $stateParams, localisationService, exceptionService, ToastService, contactCalendarModel, uiCalendarConfig) {
        var vm = this;
        vm.next = next;
        vm.prev = prev;
        vm.gotoDate = gotoDate;
        vm.addEvent = addEvent;

        // Data
        vm.EntryType = [];
        let api = assetsApi;
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        vm.events = [];
        vm.calendarSettingEntry = null;
        vm.contactId = [];

        function addEvent(e) {
            showEventFormDialog('add', false, null, null, e);
        }

        function eventDetail(calendarEvent, e) {
            showEventDetailDialog(calendarEvent, e);
        }

        function showEventDetailDialog(calendarEvent, e) {
            $mdDialog.show({
                controller: 'EventDetailDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/contact/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    calendarEvent: calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event: e
                }
            });
        }

        function select(start, end, e) {
            showEventFormDialog('add', false, start, end, e);
        }

        function showEventFormDialog(type, calendarEvent, start, end, e) {
            var dialogData = {
                type: type,
                calendarEvent: calendarEvent,
                start: start,
                end: end
            };

            var dialogLookUp = {
                EntryType: vm.EntryType,
                RepeatType: vm.RepeatType
            }

            $mdDialog.show({
                controller: 'EventFormDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/contact/calendar/dialogs/event-form/event-form-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dialogLookUp: dialogLookUp
                }
            }).then(function(response) {

                if (response.type === 'add') {
                    // Add new
                    blockUI.start();
                    let equipment_calendar = new equipmentCalendarModel();
                    var equipment_calendar_entry = {
                        EntryType: response.calendarEvent.EntryType,
                        EntryReason: response.calendarEvent.EntryReason,
                        start: response.calendarEvent.start,
                        startTime: response.calendarEvent.startTime,
                        end: response.calendarEvent.end,
                        endTime: response.calendarEvent.endTime,
                        repeat: response.calendarEvent.Repeats,
                        IsAllDayEvent: response.IsAllDayEvent,
                        ItemId: vm.ItemId,
                        Remarks: response.calendarEvent.Remarks,
                    }

                    equipment_calendar.map(equipment_calendar_entry);
                    let transformed_equipment_calendar = equipment_calendar.transformToServerModel();

                    assetsApi.saveEquipmentCalendar(transformed_equipment_calendar).then(function() {
                        ToastService.toast("Calendar Event Created");
                        getEquipmentCalendar();
                    }).catch(function(e) {
                        blockUI.stop();
                        exceptionService.resolve(e);
                    });
                } else if (response.type === 'delete') {
                    blockUI.start();
                    assetsApi.deleteEquipmentCalendar(response.calendarEvent.ParentId).then(function() {
                        ToastService.toast("Event Deleted");
                        getEquipmentCalendar();
                    }).catch(function(e) {
                        blockUI.stop();
                        exceptionService.resolve(e);
                    });
                } else {
                    updateEvent(response);
                }
            });
        }

        function updateEvent(response) {
            let equipment_calendar = new equipmentCalendarModel();
            let equipment_calendar_entry = {
                EntryType: response.calendarEvent.EntryType,
                EntryReason: response.calendarEvent.EntryReason,
                start: response.calendarEvent.start,
                startTime: response.calendarEvent.startTime,
                end: response.calendarEvent.end,
                endTime: response.calendarEvent.endTime,
                repeat: response.calendarEvent.Repeats,
                ItemId: vm.ItemId,
                Id: response.calendarEvent.ParentId,
                IsAllDayEvent: response.IsAllDayEvent,
                Remarks: response.calendarEvent.Remarks
            };

            equipment_calendar.map(equipment_calendar_entry);
            let transformed_equipment_calendar = equipment_calendar.transformToServerModel();

            return assetsApi.updateEquipmentCalendar(transformed_equipment_calendar).then(function() {
                ToastService.toast("Event Updated");
                getEquipmentCalendar();
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
            });
        }

        function next() {
            vm.calendarView.calendar.next();
            vm.currentViewYear = vm.calendar.getDate().format('YYYY');
            var currentYear = moment(moment().endOf("year")).format('YYYY');
            if (parseInt(currentYear) < parseInt(vm.currentViewYear)) {
                getEquipmentCalendar();
            }
        }

        function prev() {
            vm.calendarView.calendar.prev();
            vm.currentViewYear = vm.calendar.getDate().format('YYYY');
            var currentYear = moment(moment().endOf("year")).format('YYYY');
            if (parseInt(currentYear) > parseInt(vm.currentViewYear)) {
                getEquipmentCalendar();
            }
        }

        function gotoDate(_date) {
            vm.calendarView.calendar.gotoDate(_date);
            vm.currentViewYear = vm.calendar.getDate().format('YYYY');
            var currentYear = moment(moment().endOf("year")).format('YYYY');
            getEquipmentCalendar();
        }

        function onViewRender(view) {
            vm.calendarView = view;
            vm.calendar = vm.calendarView.calendar;
            vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        }

        function activate() {
            var localeFormatSettings = localisationService.getLocaleFormatSettings();
            vm.calendarUiConfig = {
                calendar: {
                    editable: false,
                    eventLimit: true,
                    header: '',
                    handleWindowResize: false,
                    aspectRatio: 1,
                    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    viewRender: onViewRender,
                    timezone: "local",
                    nextDayThreshold: "00:00:00",
                    eventRender: function(event, element, view) {
                        if (event._recurring) {
                            return (event.ranges.filter(function(range) {
                                return (moment(event.start).isBefore(range.end) &&
                                    moment(event.end).isAfter(range.start));
                            }).length) > 0;
                        }
                    },
                    columnFormat: {
                        month: 'ddd',
                        week: 'ddd D',
                        day: 'ddd M'
                    },
                    selectable: true,
                    selectHelper: true,
                    select: select,
                    eventClick: eventDetail,
                    firstDay: localeFormatSettings.firstDayOfWeek
                }
            };

            if ($stateParams.Id === "" || _.isNil($stateParams.Id)) {
                $state.go('app.equipment_view');
            } else {
                vm.ItemId = $stateParams.Id;
                vm.Name = $stateParams.Unique + " (" + $stateParams.Name + ") ";
                $q.all([assetsApi.getEntryType(), assetsApi.getRepeatType()]).then(function(resp) {
                    vm.EntryType = resp[0].data;
                    vm.RepeatType = resp[1].data;
                    getEquipmentCalendar();
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                    blockUI.stop();
                });
            }
        }

        function getEquipmentCalendar() {
            return assetsApi.getEquipmentCalendarById(vm.ItemId, vm.currentViewYear).then(function(resp) {
                // if(resp.data.length > 0){
                var response = angular.copy(resp.data);

                angular.forEach(response, function(item) {
                    item.title = getValuebyId(item.CalendarEntryType);
                });

                var equipment_calendar = new equipmentCalendarModel();

                var eventData = [];

                var badData = _.filter(response.CalendarEntries, function(e) {
                    if (e.Repeats) {
                        return e.Repeats.RepeatType != 1 && e.Repeats.RepeatEvery === 0;
                    }

                    if (e.IsAllDayEvent) {
                        return e.Repeats != null;
                    }
                });

                angular.forEach(response.Events, function(e) {
                    equipment_calendar.map(e);
                    var event = equipment_calendar.transformData(equipment_calendar, response.CalendarEntries);
                    eventData.push(event);
                });

                if (badData.length > 0) {
                    _.forEach(badData, function(bData) {
                        _.remove(eventData, function(eData) {
                            return bData.Id === eData.ParentId;
                        });
                    });
                }

                vm.events.splice(0);
                vm.events.push(eventData);
                // }
                blockUI.stop();
            }).catch(function(ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }

        function getValuebyId(id) {
            var entryType = _.find(vm.EntryType, function(o) {
                return o.Id == id
            });
            if (entryType) {
                return entryType.Value;
            }
        }

        activate();
    }

})();
(function () {
    'use strict';

    angular.module('app.custom-validations-create')
        .service('ruleModel', ruleModel);

    function ruleModel() {
        return function (options){
            var self = this;
            var defaults = {
                Id: null,
                IsEnabled: true,
                Module: 0,
                RuleName: null,
                OrderPriority: 0,
                IfConditions: [],
                ThenStatements: []
            }

            self.map = mapper;
            self.reset = reset;

            self.map(options);

            function mapper(opts) {
                var mapValue = opts || {}
                    , opts = angular.extend(this, defaults, mapValue);
            }

            function reset() {
                this.map(null);
                this.Id = null;
                this.IsEnabled = true;
                this.Module = 0;
                this.RuleName = null;
                this.OrderPriority = 0;
                this.IfConditions.length = 0;
                this.ThenStatements.length = 0;
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.custom-validations-create')
        .factory('customValidationCreateService', customValidationCreateService);

    /** @ngInject */
    function customValidationCreateService($mdDialog, mediaQueryService, $stateParams, $state, customValidationsApi, hubService, blockUI, contactRulesModel, lookupApi, $q, $timeout, exceptionService, utils, ruleModel) {

        let service = {
            loading : false,
            loading_message : null,
            contacts_models : contactRulesModel,
            rule_model : new ruleModel(),
            mediaService : mediaQueryService,
            all_lookup : [],
            activate : activate,
            saveRule : saveRule,
            viewRules : viewRules,
            test : test
        }

        return service;

        function test(){
            $mdDialog.show({
                templateUrl : 'app/main/customValidations/create/tester/tester.html',
                controller : 'customValidationsTester as vm',
                locals : {
                    lookup : service.all_lookup,
                    models : service.contacts_models,
                    rules : [map(service.rule_model)]
                }
            });
        }

        function saveRule(rule){
            let defer = $q.defer();
            blockUI.start("Saving rule");
            let pay_load = cleanModel(rule);
            customValidationsApi.saveRule(pay_load).then(function(resp){
                blockUI.stop();
                if(_.isNil($stateParams.Id)){
                    service.rule_model.reset();
                    hubService.showToast("Rule has been saved successfully");
                }else{
                    service.rule_model = map(new ruleModel(rule));
                    hubService.showToast("Rule has been updated successfully");
                }
                defer.resolve(resp.data);
            }).catch(function(err){
                blockUI.stop();
                defer.reject(err);
                exceptionService.resolve(err);
            })
        }

        function viewRules(){
            $state.go('app.custom_rules_view');
        }

        function cleanModel(model){
            model.IfConditions = removeAlias(model.IfConditions);
            model.ThenStatements = removeAlias(model.ThenStatements);
            return model;
        }

        function removeAlias(collection){
            collection.forEach(function(prop){
                delete prop['Alias'];
            });
            return collection;
        }

        function activate(){
            //Load contact lookup
            blockUI.start("Loading");
            $q.all([lookupApi.getContactLookups(true), customValidationsApi.getCustomRuleById($stateParams.Id)])
                .then(function(resp){

                    let obj = resp[0].data;
                    let rule = resp[1].data;
                    service.all_lookup = angular.copy(obj);

                    _.forEach(service.contacts_models, function(model){
                        if(model.FieldName == "Award"){
                            model.Lookup = obj.Award;
                        }

                        if(model.FieldName == "Classifications"){
                            model.Lookup = obj.AwardClassification;
                        }

                        if(model.FieldName == "Contact Types"){
                            model.Lookup = obj.ContactTypes;
                        }

                        if(model.FieldName == "Employment Status"){
                            model.Lookup = [
                                {
                                    Id: 0,
                                    Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_NONE")
                                },
                                {
                                    Id: 1,
                                    Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_CASUAL")
                                },
                                {
                                    Id: 2,
                                    Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_LABOUR_HIRE")
                                },
                                {
                                    Id: 3,
                                    Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_PERMANENT_FULL_TIME")
                                },
                                {
                                    Id: 4,
                                    Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_PERMANENT_PART_TIME")
                                },
                                {
                                    Id: 5,
                                    Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_SALARY")
                                }
                            ];
                        }
                    });
                    service.rule_model = map(new ruleModel(rule));
                    blockUI.stop();
                }).catch(function(err){
                    blockUI.stop();
                    exceptionService.resolve(err);
                });
        }

        function map(data){
            if(data){
                data.IfConditions = getAlias(data.IfConditions);
                data.ThenStatements = getAlias(data.ThenStatements);
                return data;
            }
        }

        function getAlias(collection){
            collection.forEach(function(prop){
                let field = _.find(service.contacts_models, {FieldRuleName : prop.Field});
                prop['Alias'] = field.FieldName;
            });
            return collection;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.custom-validations-create')
        .controller('customValidationsCreateController', customValidationsCreateController);

    function customValidationsCreateController(customValidationCreateService) {
        var vm = this;
        vm.service = customValidationCreateService;
        vm.service.activate();
    }

})();

(function () {
  'use strict';
  angular
    .module('app.customFields', [])
    .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('app/main/customisedFields');
  }
})();

(function () {
  'use strict';

  angular.module('app.customFields')
    .factory('customFieldsUtils', customFieldsUtils);

  /** @ngInject */
  function customFieldsUtils(_) {

    function bindData(fields, data){
      var customFieldsData = [];
      angular.forEach(fields, function(element, key){
        if(element.FieldType == 2 || element.FieldType == 12){
          angular.forEach(element.Option, function(option){

            if(option.Type == 'Regular'){

              let value = null;

              if(element.FieldType == 2){
                value = data['ChkRegcs' + element.Variable + option.Name];
              }else{
                value = data['ChkRegcs' + element.Variable + option.Name] ? data['ChkRegcs' + element.Variable + option.Name] + "||" + data['ChkRegcs' + element.Variable + option.Name + "Specify"] : "false"
              }

              var CustomModel = {
                Id : 'ChkRegcs' + element.Variable + option.Name,
                Title : element.FieldTitle,
                FieldValue : value,
                // Value : data['ChkRegcs' + element.Variable + option.Name],
                // Type : element.FieldType
              }
              customFieldsData.push(CustomModel)
            }
            else{

              var CustomModel =
                {
                  Id : 'ChkOthercs' + element.Variable,
                  FieldValue : data['ChkOthercs' + element.Variable],
                  // Value : data['ChkOthercs' + element.Variable],
                  Title : element.FieldTitle,
                  //Type : element.FieldType
                }

              customFieldsData.push(CustomModel);

              if(CustomModel.FieldValue == true)
              {
                var CustomModel =
                  {
                    Id : 'ChkOthercsinput' + element.Variable,
                    FieldValue : data['ChkOthercsinput' + element.Variable],
                    //Value : data['ChkOthercsinput' + element.Variable],
                    Title : element.FieldTitle,
                    //Type : element.FieldType
                  }

                customFieldsData.push(CustomModel);
              }
              else
              {
                var CustomModel =
                  {
                    Id : 'ChkOthercsinput' + element.Variable,
                    FieldValue : null,
                    //Value : null,
                    Title : element.FieldTitle,
                    //Type : element.FieldType
                  }

                customFieldsData.push(CustomModel);
              }
            }
          });
        }
        else if(element.FieldType == 1)
        {
          var CustomModel = {
            Id : 'cs' + element.Variable,
            FieldValue : data['cs' + element.Variable],
            //Value : data['cs' + element.Variable],
            Title : element.FieldTitle,
            //Type : element.FieldType
          }

          angular.forEach(element.Option, function(value){
            if(value.Value == CustomModel.FieldValue){
              CustomModel['Type'] = value.Type;
            }
          });

          customFieldsData.push(CustomModel);
        }
        else{
          var CustomModel = {
            Id : 'cs' + element.Variable,
            FieldValue : data['cs' + element.Variable],
            //Value :  data['cs' + element.Variable],
            Title : element.FieldTitle,
            //Type : element.FieldType
          }

          customFieldsData.push(CustomModel);
        }
      });

      return sanitizeCustomValues(customFieldsData);
    }

    function bindData2(fields, data){
      var customFieldsData = [];
      angular.forEach(fields, function(element, key){
        if(element.FieldType == 2 || element.FieldType == 12){
          angular.forEach(element.Option, function(option){
            if(option.Type == 'Regular'){

              let value = null;

              if(element.FieldType == 2){
                value = data['ChkRegcs' + element.Variable + option.Name];
              }else{
                value = data['ChkRegcs' + element.Variable + option.Name] ? data['ChkRegcs' + element.Variable + option.Name] + "||" + data['ChkRegcs' + element.Variable + option.Name + "Specify"] : "false"
              }

              var CustomModel = {
                Id : 'ChkRegcs' + element.Variable + option.Name,
                Title : element.FieldTitle,
                Value : value,
                Type : element.FieldType
              }
              customFieldsData.push(CustomModel)
            }
            else{

              var CustomModel =
                {
                  Id : 'ChkOthercs' + element.Variable,
                  Value : data['ChkOthercs' + element.Variable],
                  Title : element.FieldTitle,
                  Type : element.FieldType
                }

              customFieldsData.push(CustomModel);

              if(CustomModel.FieldValue == true)
              {
                var CustomModel =
                  {
                    Id : 'ChkOthercsinput' + element.Variable,
                    Value : data['ChkOthercsinput' + element.Variable],
                    Title : element.FieldTitle,
                    Type : element.FieldType
                  }

                customFieldsData.push(CustomModel);
              }
              else
              {
                var CustomModel =
                  {
                    Id : 'ChkOthercsinput' + element.Variable,
                    Value : null,
                    Title : element.FieldTitle,
                    Type : element.FieldType
                  }

                customFieldsData.push(CustomModel);
              }
            }
          });
        }
        else if(element.FieldType == 1)
        {
          var CustomModel = {
            Id : 'cs' + element.Variable,
            Value : data['cs' + element.Variable],
            Title : element.FieldTitle,
            Type : element.FieldType
          }

          customFieldsData.push(CustomModel);
        }
        else{
          var CustomModel = {
            Id : 'cs' + element.Variable,
            Value :  data['cs' + element.Variable],
            Title : element.FieldTitle,
            Type : element.FieldType
          }

          customFieldsData.push(CustomModel);
        }
      });

      return formatObject(customFieldsData);
    }

    function formatObject(data){
      angular.forEach(data, function(itm){
        let currentValue = itm.Value;
        let doubleSlashExist = (angular.isUndefined(currentValue) || _.isBoolean(currentValue) || _.isNull(currentValue)) ? false : currentValue.includes('||');
        let formattedData = null;

        if(doubleSlashExist){
          formattedData = [
            {
              m_Item1 : {
                Value : currentValue.substring(0, currentValue.indexOf("|")) === "true" ? true : false
              },
              m_Item2 : {
                Value : currentValue.substring(currentValue.lastIndexOf("|") + 1)
              }
            }
          ];
        }else{
          formattedData = [
            {
              m_Item1 : {
                Value : currentValue
              }
            }
          ];
        }

        itm.Value = formattedData;
      });
      return data;
    }

    //Removes all undefined values
    function sanitizeCustomValues(data){
      var santizedValues = [];
      angular.forEach(data, function(value){
        if(angular.isDefined(value.FieldValue)){
          santizedValues.push(value);
        };
      });
      return santizedValues;
    }

    var service = {
      bindData2 : bindData2,
      bindData : bindData
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular.module('app.customFields')
    .factory('customFieldsService', customFieldsService);

  /** @ngInject */
  function customFieldsService(
      customFieldsApi
    , itemManagerService
    , lookupApi
    , utils
    , _
    , contactLookupsService
    , companyLookupService
    , customFieldsListService
    , assetCategoryService) {

    function getLookUps(module){
      if(module == 1){
        contactLookupsService.fetchLookups().then(function(resp){
          service.LookupTypes = resp.ContactTypes;
        });
      }
      if(module == 2){
        companyLookupService.fetchCompanyTypes().then(function(resp){
          service.LookupTypes = resp;
        });
      }
      if(module == 4){
        service.LookupTypes = [];
        lookupApi.getItemTypes2().then(function(resp){
          service.LookupTypes = resp.data;
        });

        assetCategoryService.getCategories().then(function(resp){
          //service.CategoryTypes = alasql('select * from ? where ParentId = ?',[resp, null]);
          service.CategoryTypes = [];
          angular.forEach(resp, function(category){
            if(category.ParentId === null){
              service.CategoryTypes.push(category);
            }
          });
        });
      }

      if(module == 5){
        lookupApi.getTicketTypes().then(function(resp){
          service.LookupTypes = [];
          angular.forEach(resp.data, function(item){
            var obj = {
              id : item.Id,
              TypeName : item.Name
            }
            service.LookupTypes.push(obj);
          });
        });
      }
    }

    function getCustomFields(){
      return customFieldsApi.getCustomFields();
    }

    function deleteField(id) {
      return customFieldsApi.deleteField(id);
    }

    function getField(id){
      return customFieldsApi.getField(id);
    }

    //Save/Edit Custom Fields
    function saveCustomFields(data, module, editMode){
        
        var Elements = [];

          var items = [];
          var LookUps = [];
          var Categories = [];

          if(angular.isDefined(data.Items)){
            angular.forEach(data.Items, function(value, key){
              var item = {
                id : value.id,
                Name : value.Name,
                Value : value.Value,
                Type : value.Type
              }
              items.push(item);
            });
          }

          if(angular.isDefined(data.LookUps)){
            angular.forEach(data.LookUps, function(value){
              if(module == 4){
                var lookup = {
                  Id : value.id,
                  TypeName : value.TypeName || value.Name
                }
              }
              else{
                var lookup = {
                  Id : value.id,
                  TypeName : value.TypeName || value.Name
                }
              }
              LookUps.push(lookup);
            });
          }

          if(angular.isDefined(data.Categories)){
            angular.forEach(data.Categories, function(value){
              var category = {
                Id : value.Id,
                Name : value.Name,
              }
              Categories.push(category);
            });
          }



          var customFieldsModel = {
            id: data.Id,
            ModulePages: [module],
            LookupTypes: LookUps,
            CategoryTypes: Categories,
            FieldTitle: data.Field,
            FieldType: data.FieldValue,
            Description: data.Description,
            Option: items,
            IsRequired: data.Required,
            ValidationType: "",
            ValidationRegexPattern: data.ValidationType,
            MinValue: data.MinValue,
            MaxValue: data.MaxValue,
            CustomErrorText: null,
            Variable : data.Variable,
            IsVisible : data.IsVisible,
            CreatedDate: utils.jsDateTimeToEpoch(new Date()),
            UpdatedDate: utils.jsDateTimeToEpoch(new Date())
          }

          Elements.push(customFieldsModel);

      if(editMode){
        return customFieldsApi.editCustomField(Elements[0], data.Id || data.id);
      }
      else{
        return customFieldsApi.saveCustomFields(Elements);
      }
    }

      function saveCustomFields2(data, module, editMode){
          if(data.FieldType  === 0 || data.FieldType  === 3 || data.FieldType  === 5 || data.FieldType  === 6 || data.FieldType  === 7 || data.FieldType  === 8 || data.FieldType  === 13){
              data.Option = [];
          }else{
              if(data.Option){
                  data.Option = data.Option.map(function(value){
                      return {
                          id : value.id || value.Id,
                          Name : value.Name,
                          Value : value.Value,
                          Type : value.Type
                      }
                  });
              }
          }

          if(angular.isDefined(data.LookupTypes)){
              data.LookupTypes = data.LookupTypes.map(function(lookup){
                  return {
                      Id : lookup.id,
                      TypeName : lookup.TypeName
                  }
              });
          }

          if(angular.isDefined(data.CategoryTypes)){
              data.CategoryTypes = data.CategoryTypes.map(function(category){
                  return {
                      Id : category.Id,
                      Name : category.Name,
                  }
              });
          }

          var customFieldsModel = {
              id: data.Id || data.id,
              ModulePages: [module],
              LookupTypes: data.LookupTypes,
              CategoryTypes: data.CategoryTypes,
              FieldTitle: data.FieldTitle,
              FieldType: data.FieldType,
              Description: data.Description,
              Option: data.Option,
              IsRequired: data.IsRequired,
              ValidationType: "",
              ValidationRegexPattern: data.ValidationRegexPattern,
              MinValue: data.MinValue,
              MaxValue: data.MaxValue,
              CustomErrorText: null,
              Variable : data.Variable,
              IsVisible : data.IsVisible,
              CreatedDate: utils.jsDateTimeToEpoch(new Date()),
              UpdatedDate: utils.jsDateTimeToEpoch(new Date())
          }

          if(editMode){
              return customFieldsApi.editCustomField(customFieldsModel, data.Id || data.id);
          }
          else{
              return customFieldsApi.saveCustomFields([customFieldsModel]);
          }
      }

    var api = customFieldsApi
      , service = {
      getLookUps : getLookUps,
      getCustomFields : getCustomFields,
      saveCustomFields : saveCustomFields,
      deleteField : deleteField,
      getField : getField,
      saveCustomFields2 : saveCustomFields2,
      FieldTypes : customFieldsListService.FieldTypes,
      LookupTypes : []
    };

    return service;

  }
})();

(function () {
  'use strict';

  angular.module('app.customFields')
    .factory('customFieldsListService', customFieldsListService);

  /** @ngInject */
  function customFieldsListService() {

    //Data
    var FieldTypes = [
      {
        Id : null,
        FieldValue : 0,
        FieldName : 'Short Answer',
        Field: null,
        Description : null,
        Icon : 'menu',
        DataType : 'string',
        CanBeValidated : true,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Items : [],
        Variable: null,
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Time'
        ]
      },
      {
        Id : null,
        FieldValue : 1,
        FieldName : 'Multiple Choice',
        Field: null,
        Description : null,
        Icon : 'checkbox-marked-circle',
        DataType : 'string',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Variable: null,
        Items : [
          {
            Id : 1,
            Value : 'Option',
            Name : 'Option1',
            Type : 'Regular'
          },
          {
            Id : 2,
            Value : 'Option',
            Name : 'Option2',
            Type : 'Regular'
          }
        ],
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Checkboxes',
          'Checkbox With Entry'
        ]
      },
      {
        Id : null,
        FieldValue : 2,
        FieldName : 'Checkboxes',
        Field: null,
        Description : null,
        Icon : 'checkbox-marked',
        DataType : '',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Variable: null,
        Items : [
          {
            Id : 1,
            Value : 'Option',
            Name : 'Option1',
            Type : 'Regular'
          },
          {
            Id : 2,
            Value : 'Option',
            Name : 'Option2',
            Type : 'Regular'
          }
        ],
        Related : [
        'Short Answer',
        'Paragraph',
        'Whole Number',
        'URL',
        'Multiple Choice',
        'Dropdown',
        'Decimal',
        'Checkboxes',
        'Checkbox With Entry'
        ]
      },
      {
        Id : null,
        FieldValue : 3,
        FieldName : 'Whole Number',
        FieldActualValue : null,
        FieldActualModel : null,
        Icon : 'numeric-1-box-multiple-outline',
        DataType : '',
        CanBeValidated : true,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        LookUps : [],
        Categories : [],
        Items : [],
        Variable: null,
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Time'
        ]
      },
      {
        Id : null,
        FieldValue : 4,
        FieldName : 'Dropdown',
        Field: null,
        Description : null,
        Icon : 'arrow-down-drop-circle',
        DataType : '',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Items : [
          {
            Id : 1,
            Value : 'Option',
            Name : 'Option1',
            Type : 'Regular'
          },
          {
            Id : 2,
            Value : 'Option',
            Name : 'Option2',
            Type : 'Regular'
          }
        ],
        Variable: null,
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Checkboxes',
          'Checkbox With Entry'
        ]
      },
      {
        Id : null,
        FieldValue : 5,
        FieldName : 'Paragraph',
        Field: null,
        Description : null,
        Icon : 'menu',
        DataType : 'string',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Items : [],
        Variable: null,
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Time'
        ]
      },
      {
        Id : null,
        FieldValue : 6,
        FieldName : 'Email',
        Field: null,
        Description : null,
        Icon : 'email',
        DataType : 'string',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Items : [],
        Variable: null,
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Time'
        ]
      },
      {
        Id : null,
        FieldValue : 7,
        FieldName : 'Decimal',
        Field: null,
        Description : null,
        Icon : 'decimal-increase',
        DataType : 'string',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Items : [],
        Variable: null,
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Time'
        ]
      },
      {
        Id : null,
        FieldValue : 8,
        FieldName : 'URL',
        Field: null,
        Description : null,
        Icon : 'web',
        DataType : 'string',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Items : [],
        Variable: null,
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Time'
        ]
      }
      ,
      {
        Id : null,
        FieldValue : 12,
        FieldName : 'Checkbox With Entry',
        Field: null,
        Description : null,
        Icon : 'code-tags-check',
        DataType : '',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Variable: null,
        Items : [
          {
            Id : 1,
            Value : 'Option',
            Name : 'Option1',
            Type : 'Regular'
          },
          {
            Id : 2,
            Value : 'Option',
            Name : 'Option2',
            Type : 'Regular'
          }
        ],
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Checkboxes',
          'Checkbox With Entry'
        ]
      },
      {
        Id : null,
        FieldValue : 13,
        FieldName : 'Time',
        Field: null,
        Description : null,
        Icon : 'time',
        DataType : '',
        CanBeValidated : false,
        ValidationType : null,
        MinValue : null,
        MaxValue : null,
        Required : false,
        LookUps : [],
        Categories : [],
        Variable: null,
        Items : [],
        Related : [
          'Short Answer',
          'Paragraph',
          'Whole Number',
          'URL',
          'Multiple Choice',
          'Dropdown',
          'Decimal',
          'Time'
        ]
      }
    ];

    var service = {
      FieldTypes : FieldTypes
    };

    return service;

  }
})();

(function () {
  'use strict';
  angular
    .module('app.customFields')

    .factory('customisedFieldsFactory', function ($mdDialog) {
      return {
        //constructUIForm -  is a function that collects all custom field elements in a module
        //This method transforms the array of custom field elements into html tags with attributes
        //and error messages.
        //element - form elements
        //vm - $scope
        //visible - true/false
        constructUIForm: function (elements, vm, visible, jobs) {
          var ElementsTagsCollection = "";
          if (jobs) {
            ElementsTagsCollection = "<form name='" + vm + ".CustomForm' flex='100'>";
          } else {
            ElementsTagsCollection = "<form name='CustomForm' flex='100'>";
          }

          angular.forEach(elements, function (element, key) {
            //Short Text
            if (element.FieldType == 0) {
              if (jobs) {
                ElementsTagsCollection +=
                  "<div layout='row' flex style='margin-bottom: 15px;'>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input ng-pattern='" + element.ValidationRegexPattern + "' type='text' name='" + element.FieldTitle + "' placeholder='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' ng-required='" + element.IsRequired + "'>" +
                  "<div ng-messages='vm.CustomForm.cs" + element.Variable + ".$error' ng-if='vm.CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "<div ng-message='pattern'>" +
                  element.FieldTitle + " value has wrong pattern" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  // "<md-icon md-svg-icon='brush' style='position : relative; top : 20px; left: -800px;'  ng-if='!" + vm + ".showFields' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></md-icon>" +
                  // "<md-icon md-svg-icon='delete' style='position : relative; top : 20px; left: -790px;' ng-if='!" + vm + ".showFields' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></md-icon>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>{{'CUSTOMFIELDS.EDITFIELD' | translate}}</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>{{'CUSTOMFIELDS.REMOVEFIELD' | translate}}</md-tooltip></i>";

              } else {
                ElementsTagsCollection +=
                  "<div layout='row' flex style='margin-bottom: 15px;'>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input ng-pattern='" + element.ValidationRegexPattern + "' type='text' name='" + element.FieldTitle + "' placeholder='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' ng-required='" + element.IsRequired + "'>" +
                  "<div ng-messages='CustomForm.cs" + element.Variable + ".$error' ng-if='CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "<div ng-message='pattern'>" +
                  element.FieldTitle + " value has wrong pattern" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  // "<md-icon md-svg-icon='brush' style='position : relative; top : 20px; left: -800px;'  ng-if='!" + vm + ".showFields' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></md-icon>" +
                  // "<md-icon md-svg-icon='delete' style='position : relative; top : 20px; left: -790px;' ng-if='!" + vm + ".showFields' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></md-icon>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>{{'CUSTOMFIELDS.EDITFIELD' | translate}}</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>{{'CUSTOMFIELDS.REMOVEFIELD' | translate}}</md-tooltip></i>";
              }
            }

            //Time
            if (element.FieldType == 13) {
              if (jobs) {
                ElementsTagsCollection +=
                  "<div layout='row' flex style='margin-bottom: 15px;'>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input ng-pattern='" + element.ValidationRegexPattern + "' type='text' name='" + element.FieldTitle + "' placeholder='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' ng-required='" + element.IsRequired + "' time-picker>" +
                  "<div ng-messages='vm.CustomForm.cs" + element.Variable + ".$error' ng-if='vm.CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "<div ng-message='pattern'>" +
                  element.FieldTitle + " value has wrong pattern" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  // "<md-icon md-svg-icon='brush' style='position : relative; top : 20px; left: -800px;'  ng-if='!" + vm + ".showFields' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></md-icon>" +
                  // "<md-icon md-svg-icon='delete' style='position : relative; top : 20px; left: -790px;' ng-if='!" + vm + ".showFields' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></md-icon>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              } else {
                ElementsTagsCollection +=
                  "<div layout='row' flex style='margin-bottom: 15px;'>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input ng-pattern='" + element.ValidationRegexPattern + "' type='text' name='" + element.FieldTitle + "' placeholder='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' ng-required='" + element.IsRequired + "' time-picker>" +
                  "<div ng-messages='CustomForm.cs" + element.Variable + ".$error' ng-if='CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "<div ng-message='pattern'>" +
                  element.FieldTitle + " value has wrong pattern" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  // "<md-icon md-svg-icon='brush' style='position : relative; top : 20px; left: -800px;'  ng-if='!" + vm + ".showFields' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></md-icon>" +
                  // "<md-icon md-svg-icon='delete' style='position : relative; top : 20px; left: -790px;' ng-if='!" + vm + ".showFields' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></md-icon>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              }

            }

            //Email
            if (element.FieldType == 6) {
              if(jobs){
                ElementsTagsCollection +=
                  "<div layout='row' flex>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input type='text' ng-pattern='/^.+@.+\..+$/' placeholder='" + element.FieldTitle + "' name='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' ng-required='" + element.IsRequired + "'>" +
                  "<div ng-messages='vm.CustomForm.cs" + element.Variable + ".$error' ng-if='vm.CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='pattern'>" +
                  "Invalid Email" +
                  "</div>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              }else{
                ElementsTagsCollection +=
                  "<div layout='row' flex>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input type='text' ng-pattern='/^.+@.+\..+$/' placeholder='" + element.FieldTitle + "' name='" + "" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' ng-required='" + element.IsRequired + "'>" +
                  "<div ng-messages='CustomForm.cs" + element.Variable + ".$error' ng-if='CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='pattern'>" +
                  "Invalid Email" +
                  "</div>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              }
             }

            //Decimal
            if (element.FieldType == 7) {
              if(jobs){
                ElementsTagsCollection +=
                  "<div layout='row' flex>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input numeric decimals='3' type='text'  placeholder='" + element.FieldTitle + "' name='" + "" + element.FieldTitle + "' ng-model='" + vm + ".cs" + element.Variable + "' ng-required='" + element.IsRequired + "'>" +
                  "<div ng-messages='vm.CustomForm.cs" + element.Variable + ".$error' ng-if='vm.CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              }else{
                ElementsTagsCollection +=
                  "<div layout='row' flex>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input numeric decimals='3' type='text'  placeholder='" + element.FieldTitle + "' name='" + "" + element.FieldTitle + "' ng-model='" + vm + ".cs" + element.Variable + "' ng-required='" + element.IsRequired + "'>" +
                  "<div ng-messages='CustomForm.cs" + element.Variable + ".$error' ng-if='CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              }
            }

            //URL
            if (element.FieldType == 8) {
              if(jobs){
                ElementsTagsCollection +=
                  "<div layout='row' flex>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input type='url' placeholder='" + element.FieldTitle + "' name='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' ng-required='" + element.IsRequired + "'>" +
                  "<div ng-messages='vm.CustomForm.cs" + element.Variable + ".$error' ng-if='vm.CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='url'>" +
                  "Invalid URL" +
                  "</div>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              }else{
                ElementsTagsCollection +=
                  "<div layout='row' flex>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input type='url' placeholder='" + element.FieldTitle + "' name='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' ng-required='" + element.IsRequired + "'>" +
                  "<div ng-messages='CustomForm.cs" + element.Variable + ".$error' ng-if='CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='url'>" +
                  "Invalid URL" +
                  "</div>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              }
             }

            //Dropdown
            if (element.FieldType == 4) {
              var selectOption = "<md-select name='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' placeholder='" + element.FieldTitle + "' flex ng-required='" + element.IsRequired + "'><md-option value=''></md-option>";
              angular.forEach(element.Option, function (item) {
                selectOption +=
                  "<md-option value='" + item.Value + "'> " + item.Value + "</md-option>";
              });
              selectOption += "</md-select>";
              ElementsTagsCollection +=
                "<div layout='row' flex>" +
                "<md-input-container flex><label>" + element.FieldTitle + "</label>" +
                selectOption +
                "</md-input-container>" +
                "</div><br>" +
                "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>"
              "<br>";
            }

            //Textarea
            if (element.FieldType == 5) {
              ElementsTagsCollection +=
                "<div layout='row' flex>" +
                "<md-input-container class='md-block' flex>" +
                // "<label>" + element.Description + "</label>" +
                "<textarea name='" + element.FieldTitle + "' ng-model='" + vm + '.cs' + element.Variable + "' md-maxlength='150' rows='5' md-select-on-focus placeholder='" + element.FieldTitle + "'></textarea>" +
                "</md-input-container>" +
                "</div>" +
                "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";
            }

            //Whole Number
            if (element.FieldType == 3) {
              if(jobs){
                ElementsTagsCollection +=
                  "<div layout='row' flex>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input type='number' ng-required='" + element.IsRequired + "' ng-model='" + vm + '.cs' + element.Variable + "' name='" + element.FieldTitle + "' min='" + element.MinValue + "' max='" + element.MaxValue + "' placeholder='" + element.FieldTitle + "'>" +
                  "<div ng-messages='vm.CustomForm.cs" + element.Variable + ".$error' ng-if='CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "<div ng-message='min'>" +
                  "Minimum : " + element.MinValue +
                  "</div>" +
                  "<div ng-message='max'>" +
                  "Maximum : " + element.MaxValue +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";

              }else{
                ElementsTagsCollection +=
                  "<div layout='row' flex>" +
                  "<md-input-container class='md-block' flex>" +
                  "<input type='number' ng-required='" + element.IsRequired + "' ng-model='" + vm + '.cs' + element.Variable + "' name='" + element.FieldTitle + "' min='" + element.MinValue + "' max='" + element.MaxValue + "' placeholder='" + element.FieldTitle + "'>" +
                  "<div ng-messages='CustomForm.cs" + element.Variable + ".$error' ng-if='CustomForm.cs" + element.Variable + ".$touched' role='alert'>" +
                  "<div ng-message='required'>" +
                  element.FieldTitle + " is required" +
                  "</div>" +
                  "<div ng-message='min'>" +
                  "Minimum : " + element.MinValue +
                  "</div>" +
                  "<div ng-message='max'>" +
                  "Maximum : " + element.MaxValue +
                  "</div>" +
                  "</div>" +
                  "</md-input-container>" +
                  "</div>" +
                  "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                  "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>";
              }
             }

            //Checkbox Group
            if (element.FieldType == 2) {
              var checkBoxes = "";
              element.Option = alasql('select * from ? order by Type desc', [element.Option]);
              angular.forEach(element.Option, function (item) {
                if (item.Type == 'Regular') {
                  checkBoxes +=
                    "<div layout='row' flex>" +
                    "<md-checkbox class='md-primary' ng-model='" + vm + '.ChkRegcs' + element.Variable + item.Name + "' ng-change='" + vm + '.onCheckBoxSelected(' + vm + ", + "  +  element.Variable +")'> " + item.Value + "</md-checkbox><br>" +
                    "</div>";
                }
                else {
                  checkBoxes +=
                    "<div layout='row' flex>" +
                    "<md-checkbox ng-model='" + vm + '.ChkOthercs' + element.Variable + "' class='md-primary' value='" + item.Model + "' aria-label='" + item.Model + "'>Other : " +
                    "</md-checkbox>" +
                    "</div>" +
                    "<md-input-container style='position:relative;left:90px;top:-70px;'>" +
                    "<input ng-model='" + vm + '.ChkOthercsinput' + element.Variable + "' type='text'>" +
                    "</md-input-container>";
                }
              });

              ElementsTagsCollection +=
                "<span class='md-body-2' required>" + element.FieldTitle + "</span>" + "<span ng-if='" + element.IsRequired + "' style='color : red'> *</span>" + "<br><br><br>" +
                checkBoxes + "</div><br>" +
                "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>" +
                "<br>";
            }

            //Checkbox Group
            if (element.FieldType == 12) {
              var checkBoxes = "";
              element.Option = alasql('select * from ? order by Type desc', [element.Option]);
              angular.forEach(element.Option, function (item) {
                if (item.Type == 'Regular') {
                  checkBoxes +=
                    "<div flex='100'>" +
                      "<div layout='column' flex>" +
                        "<md-checkbox flex='30' class='md-primary' ng-model='" + vm + '.ChkRegcs' + element.Variable + item.Name + "'> " + item.Value + "" +
                        "</md-checkbox>" +
                        "<md-input-container flex='70' ng-if='" + vm + '.ChkRegcs' + element.Variable + item.Name + "'>" +
                          "<input type='text' ng-model='" + vm + '.ChkRegcs' + element.Variable + item.Name + "Specify'>" +
                        "</md-input-container>"
                      "</div>" +
                    "</div>";
                }
              });

              ElementsTagsCollection +=
                "<span class='md-body-2'>" + element.FieldTitle + "</span>" + "<br/><br/><br/>" +
                checkBoxes + "</div><br>" +
                "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>" +
                "<br>";
            }

            //Multiple Choice
            if (element.FieldType == 1) {
              var radioOptions = "<md-radio-group name='" + element.FieldTitle + "' ng-required='" + element.IsRequired + "' ng-model='" + vm + '.cs' + element.Variable + "'>";
              element.Option = alasql('select * from ? order by Type desc', [element.Option]);
              angular.forEach(element.Option, function (item) {
                if (item.Type == 'Regular') {
                  radioOptions +=
                    "<md-radio-button class='md-primary' value='" + item.Value + "'> " + item.Value + "</md-radio-button>";
                }
                else {
                  radioOptions +=
                    "<md-radio-button class='md-primary' value='{{" + vm + '.Othercs' + element.Variable + "}}'> Other : " +
                    "</md-radio-button>" +
                    "<md-input-container style='position:relative;left:90px;top:-70px;margin-bottom:-70px;'>" +
                    "<input type='text' ng-model='" + vm + '.Othercs' + element.Variable + "'>" +
                    "</md-input-container>";
                }
              });

              radioOptions += "</md-radio-group>";

              ElementsTagsCollection +=
                "<br><span class='md-body-2'>" + element.FieldTitle + "</span>" + "<span ng-if='" + element.IsRequired + "' style='color : red'> *</span>" + "<br><br>" +
                "<div layout='row' flex>" +
                radioOptions +
                "</div><br>" +
                "<i class='icon-checkbox-marked-circle green-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "editField('" + element.id + "')" + "><md-tooltip>Edit Field</md-tooltip></i>" +
                "<i class='icon-cancel red-500-fg' ng-if='!" + vm + ".showFields' style='position:relative;top:-30px;' ng-click=" + vm + "." + "deleteField('" + element.id + "')" + "><md-tooltip>Delete Field</md-tooltip></i>" +
                "<br><br>";
            }
          });

          return ElementsTagsCollection + "</form>";
        }
      }
    });
})();

(function() {
    'use strict';

    angular.module('app.customForms')
        .controller('FormTemplatesViewController', FormTemplatesViewController);

    function FormTemplatesViewController(_,
        $mdDialog,
        $state,
        $compile,
        $scope,
        utils,
        DTColumnBuilder,
        DTOptionsBuilder,
        customFormsApiUrl,
        customFormsApi,
        formTemplatesViewService,
        notificationService,
        adminClaimsService,
        claimsUtilService,
        msgboxService,
        exceptionService,
        blockUI) {

        var vm = this;

        var tenantKey = claimsUtilService.getTenantKey();

        // Datatable property which exposes an API to reload/rerender
        vm.dtInstance = {};

        // Public functions
        vm.createFormTemplate = createFormTemplate;
        vm.editFormTemplate = editFormTemplate;
        vm.deleteFormTemplate = deleteFormTemplate;
        vm.cloneFormTemplate = cloneFormTemplate;
        vm.menuItemClick = menuItemClick;
        vm.openMenu = openMenu;
        vm.moveToPosition = moveToPosition;
        vm.MoveToPositionFailed = MoveToPositionFailed;
        vm.MoveToPositionSuccess = MoveToPositionSuccess;
        vm.performMoveToPosition = performMoveToPosition;

        //Claims
        vm.hasCreateEditPermission = adminClaimsService.hasCreateEditFormPermission;
        vm.hasDeletePermission = adminClaimsService.hasDeleteFormPermission;

        vm.menuItems = [{
                name: utils.translate("CUSTOMFORMSMODULE.MOVETOTOP"),
                icon: 'icon-arrow-up',
                show: true,
                disabled: !vm.hasCreateEditPermission
            },
            {
                name: 'CUSTOMFORMSMODULE.MOVETOBOTTOM',
                icon: 'icon-arrow-down',
                show: true,
                disabled: !vm.hasCreateEditPermission
            },
            {
                name: 'CUSTOMFORMSMODULE.MOVETOPOSITION',
                icon: 'icon-arrow-right',
                show: true,
                disabled: !vm.hasCreateEditPermission
            },
            {
                name: 'CUSTOMFORMSMODULE.DELETE',
                icon: 'icon-delete',
                show: true,
                disabled: !vm.hasDeletePermission
            }
        ];

        initDataTable();

        function initDataTable() {

            // dtColumns is necessary if using serverSide pagination
            vm.dtColumns = [
                DTColumnBuilder.newColumn('displayOrder').withTitle('Order'),
                DTColumnBuilder.newColumn('name').withTitle('Name'),
                DTColumnBuilder.newColumn('formType').withTitle('Type'),
                DTColumnBuilder.newColumn('consumerFields.AppliedTo').withTitle('Applied To').notSortable().renderWith(function(data, type, full) {
                    // Splits 'AllBranches,AllCompanies' into 'All Branches, All Companies'
                    let appliedToArray = full.consumerFields.AppliedTo.split(/(?=[A-Z])/);
                    return appliedToArray.join(' ');
                }),
                DTColumnBuilder.newColumn('consumerFields.IncludeInPaperwork').withTitle('Include in Paperwork?').notSortable().renderWith(function(data, type, full) {
                    return full.consumerFields.IncludeInPaperwork === 'true' ? 'Yes' : 'No';
                }),
                DTColumnBuilder.newColumn('lastUpdated').withTitle('Last Updated').renderWith(function(data, type, full) {
                    return utils.displayUtcInLocalDateTimeFormat(full.lastUpdated);
                }),
                DTColumnBuilder.newColumn('isPublished').withTitle('Status').renderWith(function(data, type, full) {
                    return full.isPublished ? 'Published' : 'Draft';
                }),
                DTColumnBuilder.newColumn('').withTitle('Actions').notSortable().renderWith(function(data, type, full) {
                    let disabledIconColor = 'grey-400-fg';
                    let editIconColor = vm.hasCreateEditPermission ? 'teal-500-fg' : disabledIconColor;
                    let deleteIconColor = vm.hasDeletePermission ? 'red-500-fg' : disabledIconColor;
                    let cloneIconColor = vm.hasCreateEditPermission ? 'teal-500-fg' : disabledIconColor;

                    return `<md-button class="md-icon-button md-primary action-button" ng-click="vm.editFormTemplate('${full.id}')" ng-disabled="!vm.hasCreateEditPermission">
                                <i class="icon icon-pencil ${editIconColor} s15">
                                    <md-tooltip>Edit Form</md-tooltip>
                                </i>
                            </md-button>
                            <md-button class="md-icon-button md-primary action-button" ng-click="vm.cloneFormTemplate('${full.id}')" ng-disabled="!vm.hasCreateEditPermission">
                                <i class="icon icon-content-copy ${cloneIconColor} s15">
                                    <md-tooltip>Clone Form</md-tooltip>
                                </i>
                            </md-button>
                            <md-menu md-offset="0 -5">
                                                    <md-button aria-label="Open demo menu" class="md-icon-button"
                                                        ng-click="vm.openMenu($mdMenu, $event)">
                                                        <md-icon md-font-icon="icon-dots-vertical" class="grey-500-fg">
                                                        </md-icon>
                                                    </md-button>
                                                    <md-menu-content width="4">
                                                        <md-menu-item ng-repeat="item in vm.menuItems track by $index">
                                                            <md-button 
                                                                ng-click="vm.menuItemClick($index,'${full.id}','${full.displayOrder}','${full.name}')"
                                                                ng-disabled="item.disabled">
                                                                <md-icon md-font-icon={{item.icon}} ng-class="{'${deleteIconColor}': item.name =='CUSTOMFORMSMODULE.DELETE', 'grey': item.name !='Delete'}" ></md-icon>
                                                                <span translate="{{item.name}}"></span>
                                                            </md-button>
                                                        </md-menu-item>
                                                    </md-menu-content>
                                                </md-menu>`;
                })
            ];

            // These variables are not used, just containers to store values in the "data" ajax event, to be used in the "beforeSend" event.
            let pageNumber = 1;
            let resultLimit = 10;
            let sortByField = 'displayOrder';
            let sortByType = 'asc';

            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withOption('order', [0, 'asc']) // Set default order column index = 4 (lastUpdated) descending
                .withOption('lengthChange', false) // Disable changing number of records per page
                .withOption('searching', false) // Disable search
                .withOption('ajax', {
                    type: 'GET',
                    url: customFormsApiUrl + 'api/form-templates',
                    data: function(data) {
                        // Set pagination settings based on the "data" variable passed in by datatables.
                        pageNumber = (data.start / data.length) + 1;
                        resultLimit = data.length;
                        // This gets the default order column on table init, then subsequently the user-selected column for sorting
                        let sortColumnIndex = data.order[0].column;
                        sortByField = data.columns[sortColumnIndex].data;
                        sortByType = data.order[0].dir;
                    },
                    processData: false, // This avoids appending a long stringified "data" querystring to the URL
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader('X-PageNumber', pageNumber);
                        xhr.setRequestHeader('X-ResultLimit', resultLimit);
                        xhr.setRequestHeader('X-SortByField', sortByField);
                        xhr.setRequestHeader('X-SortByType', sortByType);
                        xhr.setRequestHeader('X-TenantKey', tenantKey);
                        xhr.setRequestHeader('X-Version', '2.0');
                    },
                    dataFilter: function(responseJson) {
                        // Sanitise response data
                        let response = JSON.parse(responseJson);

                        response.results.forEach(function(result) {
                            if (result.consumerFields.AppliedTo === undefined) {
                                result.consumerFields.AppliedTo = '';
                            }
                            if (result.consumerFields.AttachedTo === undefined) {
                                result.consumerFields.AttachedTo = '';
                            }
                        })

                        // Datatable uses recordsTotal/recordsFiltered properties for pagination
                        response.recordsTotal = response.totalResults;
                        response.recordsFiltered = response.totalResults;
                        vm.noOfRecords = response.totalResults;
                        return JSON.stringify(response);
                    },
                    error: function() {
                        $mdDialog.show($mdDialog.alert()
                            .title('Error')
                            .textContent('An error occured when contacting the server.')
                            .ok('Close'));
                    }
                })
                .withDataProp('results') // Tell Datatable to use the results property of the response object to populate records
                .withOption('processing', true) // Displays 'Processing...' text while loading records
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                // This is a callback function executed after each row is rendered. It enables proper rendering of the "Action" column which uses AngularJS directives.
                .withOption('createdRow', createdRow)
                .withOption('headerCallback', function(thead) {
                    // Programatically insert HTML into table headers for the sort arrows
                    for (let i = 0; i < thead.cells.length; i++) {
                        let columnTitle = thead.cells[i].innerText;
                        thead.cells[i].innerHTML = '<div class="table-header">' +
                            '<span class="column-title">' + columnTitle + '</span>' +
                            '</div>';
                    }
                });
        }

        function menuItemClick(index, id, displayOrder, name) {

            switch (index) {
                case 0:
                    if (displayOrder == 1) {
                        return;
                    }
                    vm.performMoveToPosition(id, 1);
                    break;
                case 1:
                    if (displayOrder == vm.noOfRecords) {
                        return;
                    }
                    vm.performMoveToPosition(id, vm.noOfRecords);
                    break;
                case 2:
                    vm.moveToPosition(id, displayOrder);
                    break;
                case 3:
                    vm.deleteFormTemplate(id, name);
                    break;
            }
        }

        function openMenu($mdMenu, ev) {
            $mdMenu.open(ev);
        }

        function createFormTemplate() {
            $mdDialog.show({
                templateUrl: 'app/main/customForms/components/formTemplates-formSettings.html',
                controller: 'FormTemplatesFormSettingsController as vm',
                locals: {}
            });
        }

        function moveToPosition(id, currentPosition) {
            let dialog = showMoveToPositionDialog({
                noOfRecords: vm.noOfRecords,
                CurrentPosition: currentPosition
            });

            $mdDialog.show(dialog).then(function(res) {
                if (res) {
                    blockUI.start('Moving to Position...')
                    performMoveToPosition(id, res.positionToMove);
                }
            });
        }

        function performMoveToPosition(id, positionToMove) {
            return customFormsApi.moveToPosition(id, parseInt(positionToMove)).then(MoveToPositionSuccess).catch(MoveToPositionFailed);
        }

        function MoveToPositionSuccess() {
            blockUI.stop();
            vm.dtInstance.DataTable.ajax.reload(null, false);
        }

        function MoveToPositionFailed(ex) {
            blockUI.stop();
            exceptionService.resolve(ex);
        }

        function showMoveToPositionDialog(data) {
            let dialog = {
                locals: data,
                templateUrl: 'app/main/customForms/view/dialog/moveToPosition-dialog.html',
                controller: 'MoveToPositionController as vm'
            }
            return dialog;
        }

        function editFormTemplate(formTemplateId) {
            $state.go('app.customForms.edit', {
                id: formTemplateId
            });
        }

        function deleteFormTemplate(formTemplateId, formTemplateName) {
            let confirmDialog = $mdDialog.confirm({
                title: 'Delete Form',
                htmlContent: utils.translate('CUSTOMFORMSMODULE.DELETE_CONFIRMATION_MESSAGE'),
                ok: 'delete',
                cancel: 'cancel'
            });

            $mdDialog.show(confirmDialog)
                .then(function() {
                    formTemplatesViewService.deleteFormTemplate(formTemplateId).then(function() {
                        notificationService.showToast(`${formTemplateName} successfully deleted.`);
                        vm.dtInstance.DataTable.ajax.reload(null, false);
                    }, function() {
                        notificationService.showToast(`Error deleting ${formTemplateName}.`);
                    });
                })
                .finally(function() {
                    confirmDialog = undefined;
                });
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the datatable
            $compile(angular.element(row).contents())($scope);
        }

        async function cloneFormTemplate(formTemplateToCloneId) {
            var formTemplateViewModel = await formTemplatesViewService
                .getFormTemplate(formTemplateToCloneId)
                .catch(err => {
                    var errorMessage = (err.data) ? err.data : 'Unable to clone, form template has been deleted.';
                    msgboxService.alert('Clone form', errorMessage, 'Okay');
                });

            if (formTemplateViewModel) {
                $mdDialog.show({
                    templateUrl: 'app/main/customForms/components/formTemplates-formSettings.html',
                    controller: 'FormTemplatesFormSettingsController as vm',
                    locals: {
                        formTemplateToClone: formTemplateViewModel
                    }
                });
            }
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.customForms')
        .factory('formTemplatesViewService', formTemplatesViewService);

    function formTemplatesViewService(customFormsApi) {
        var service = {
            getFormTemplate: getFormTemplate,
            getFormTemplates: getFormTemplates,
            deleteFormTemplate: deleteFormTemplate
        };

        return service;

        async function getFormTemplate(id) {
            var response = await customFormsApi.getFormTemplate(id);
            let formTemplateViewModel = null;

            if (response.data) {
                let formTemplate = response.data;
                formTemplateViewModel = formTemplate;

                formTemplateViewModel.appliedTo = formTemplate.consumerFields.AppliedTo;
                formTemplateViewModel.includeInPaperwork = _.isEmpty(formTemplate.consumerFields) ?
                    false :
                    JSON.parse(formTemplate.consumerFields.IncludeInPaperwork.toLowerCase());
            }

            return formTemplateViewModel;
        }

        function getFormTemplates() {
            return customFormsApi.getFormTemplates(0 + 1, 10, 'DisplayOrder', 'Asc').then(function(response) {
                return mapResponseToFormTemplateViewModels(response.data.results);
            });
        }

        function deleteFormTemplate(id) {
            return customFormsApi.deleteFormTemplate(id);
        }

        function mapResponseToFormTemplateViewModels(results) {
            let formTemplateViewModels = [];

            results.forEach(function(result) {
                let formTemplateViewModel = {
                    id: result.id,
                    name: result.name,
                    formType: result.formType,
                    lastUpdated: result.lastUpdated,
                    status: result.isPublished ? 'Published' : 'Draft',
                    consumerFields: result.consumerFields
                };

                formTemplateViewModels.push(formTemplateViewModel);
            });

            return formTemplateViewModels;
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.customForms')
           .factory('formTemplatesEditService', formTemplatesEditService);

    function formTemplatesEditService(customFormsApi) {
        return {
            getFormTemplate: getFormTemplate,
            createFormTemplate: createFormTemplate,
            updateFormTemplate: updateFormTemplate,
            cloneFormTemplate : cloneFormTemplate,
            publishFormTemplate: publishFormTemplate,            
            updateFormSections: updateFormSections,
            getLatestFormTemplate : getLatestFormTemplate,
            data : {}            
        };

        function getFormTemplate(id) {
            return customFormsApi.getFormTemplate(id).then(function(response) {
                let formTemplateViewModel = mapResponseToFormTemplateViewModel(response.data);
                return formTemplateViewModel;
            });
        }

        function getLatestFormTemplate(id) {
            return customFormsApi.getLatestFormTemplate(id).then(function(response){
                let formTemplateViewModel = mapResponseToFormTemplateViewModel(response.data);
                return formTemplateViewModel;
            })
        }

        function createFormTemplate(formTemplateViewModel) {
            let formTemplateRequest = mapFormTemplateViewModelToRequest(formTemplateViewModel);
            return customFormsApi.createFormTemplate(formTemplateRequest);
        }

        function updateFormTemplate(formTemplateViewModel) {
            let formTemplateRequest = mapFormTemplateViewModelToRequest(formTemplateViewModel);
            return customFormsApi.updateFormTemplate(formTemplateViewModel.id, formTemplateRequest);
        }

        function cloneFormTemplate(formTemplateToCloneId, formTemplateViewModel) {
            let formTemplateRequest = mapFormTemplateViewModelToRequest(formTemplateViewModel);
            return customFormsApi.cloneFormTemplate(formTemplateToCloneId, formTemplateRequest);
        }

        function publishFormTemplate(formTemplateId) {
            return customFormsApi.publishFormTemplate(formTemplateId);
        }

        function updateFormSections(formSectionsViewModel){
            let data = mapSectionTemplateViewModel(formSectionsViewModel);
            return customFormsApi.updateFormSections(data);
        }

        function mapResponseToFormTemplateViewModel(response) {
            let formTemplateViewModel = response;
            
            formTemplateViewModel.appliedTo = response.consumerFields.AppliedTo;
            formTemplateViewModel.includeInPaperwork = _.isEmpty(response.consumerFields) ?
                false :
                JSON.parse(response.consumerFields.IncludeInPaperwork.toLowerCase());

            return formTemplateViewModel;
        }

        function mapFormTemplateViewModelToRequest(formTemplateViewModel) {
            let formTemplateRequest = {
                id: formTemplateViewModel.id,
                originId: formTemplateViewModel.originId,
                name: formTemplateViewModel.name,
                formType: formTemplateViewModel.formType,
                isRequired: formTemplateViewModel.isRequired,
                isPublished: formTemplateViewModel.isPublished,
                allowMultipleSubmissions: formTemplateViewModel.allowMultipleSubmissions,
                lastUpdated : formTemplateViewModel.lastUpdated,
                isPrivate: formTemplateViewModel.isPrivate,
                isTimesheetManagersOnly: formTemplateViewModel.isTimesheetManagersOnly,
                consumerFields: {
                    AppliedTo: formTemplateViewModel.appliedTo,
                    IncludeInPaperwork: `${formTemplateViewModel.includeInPaperwork}`
                }
            };

            return formTemplateRequest;
        }

        function mapSectionTemplateViewModel(formSectionViewModel){
            let data = {
                formTemplateId: formSectionViewModel.formTemplateId,
                templateJson: formSectionViewModel.templateJson,
                templateHtml: formSectionViewModel.templateHtml,
                sectionTemplates: formSectionViewModel.sectionTemplates
            };

            return data;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customForms')
        .factory('formBuilderService', formBuilderService);

    /** @ngInject */
    function formBuilderService(
        customFormsApi,
        claimsUtilService,
        $q
    ) {
        var controlOptions = {};
        var formeoOptions = {};
        var elements = [];

        function saveFormBuilderData(data) {}

        function publishFormTemplate(template) {}

        function generateFormTemplatePdf(id, data) {
            let tenantKey = claimsUtilService.getTenantKey();
            return customFormsApi.generateFormTemplatePdf(id, data, tenantKey);
        }

        function downloadFormTemplatePdfInBase64(id) {
            return customFormsApi.downloadFormTemplatePdfInBase64(id);
        }

        const commonFieldsGroup = {
            id: 'common',
            label: 'Form Fields',
            formType: 'Common',
            elementOrder: ['single_line_text', 'paragraph', 'header', 'read_only', 'checkbox', 'radio', 'multi_select', 'number', 'date_picker', 'time_select', 'draw_sign', 'vehicle_canvas', 'upload']
        };

        const layoutFieldsGroup = {
            id: 'layout',
            label: 'Layout',
            formType: 'Layout',
            elementOrder: []
        };

        const jobFieldsGroup = {
            id: 'jobFieldGroup',
            label: 'Job Fields',
            formType: 'Job',
            elementOrder: ['jobField_ticketNumber', 'jobField_branch', 'jobField_jobLocation', 'jobField_jobStartDate', 'jobField_clientCompany', 'jobField_siteContact', 'jobField_timesheetManager', 'jobField_submittedBy', 'jobField_submissionEmail', 'jobField_submissionPhone']
        };

        const workerFieldsGroup = {
            id: 'workerFieldGroup',
            label: 'Worker Fields',
            formType: 'Worker',
            elementOrder: ['workerField_fullName', 'workerField_shiftRole', 'workerField_skills']
        };

        const vehicleFieldsGroup = {
            id: 'vehicleFieldGroup',
            label: 'Vehicle Fields',
            formType: 'Vehicle',
            elementOrder: ['vehicleField_registrationNumber', 'vehicleField_description', 'vehicleField_operatorName']
        };

        const assetFieldsGroup = {
            id: 'assetFieldGroup',
            label: 'Asset Fields',
            formType: 'Asset',
            elementOrder: ['assetField_uniqueItemIdentifier', 'assetField_description']
        };

        const commonElements = [{
                tag: "input",
                attrs: {
                    required: false
                },
                config: {
                    label: "Single line text",
                    disabledAttrs: [],
                    lockedAttrs: [],
                    inputType: "SingleLineText"
                },
                meta: {
                    group: 'common',
                    icon: 'text-input',
                    id: 'single_line_text'
                },
                conditions: false
            },
            {
                tag: 'input',
                attrs: {
                    type: 'date',
                    required: false
                },
                config: {
                    label: 'Date Picker',
                    inputType: "DateOnly"
                },
                meta: {
                    group: 'common',
                    icon: 'calendar',
                    id: 'date_picker'
                },
                conditions: false
            },
            {
                tag: 'input',
                attrs: {
                    type: 'file',
                    required: false,
                },
                config: {
                    label: 'Upload file',
                    inputType: 'FileUpload'
                },
                meta: {
                    group: 'common',
                    icon: 'upload',
                    id: 'upload'
                },
                conditions: false
            },
            {
                tag: 'textarea',
                config: {
                    label: 'Paragraph Text',
                    inputType: "MultiLineText"
                },
                meta: {
                    group: 'common',
                    icon: 'rich-text',
                    id: 'paragraph',
                },
                attrs: {
                    required: false,
                },
                conditions: false
            },
            {
                tag: 'input',
                attrs: {
                    type: 'number',
                    required: false
                },
                config: {
                    label: 'Number',
                    inputType: "Number"
                },
                meta: {
                    group: 'common',
                    icon: '#123',
                    id: 'number',
                },
                conditions: false
            },
            {
                tag: 'h1',
                config: {
                    label: "Header",
                    hideLabel: true,
                    inputType: "Header"
                },
                attrs: {
                    contenteditable: true
                },
                meta: {
                    group: 'common',
                    icon: 'header',
                    id: 'header',
                },
                conditions: false,
                content: "Header"
            },
            {
                tag: "p",
                config: {
                    label: "Read only Text",
                    hideLabel: true,
                    inputType: "ReadOnlyText"
                },
                attrs: {
                    contenteditable: true,
                },
                meta: {
                    group: 'common',
                    icon: 'textarea',
                    id: 'read_only',
                },
                conditions: false,
                content: "Enter your read-only or instructional text here. This is not editable by the user."
            },
            {
                tag: "select",
                config: {
                    label: "Drop-down list",
                    inputType: "SingleSelectList"
                },
                attrs: {
                    required: false
                },
                meta: {
                    group: 'common',
                    icon: 'select',
                    id: 'multi_select',
                },
                conditions: false,
                options: [1, 2, 3].map(function(i) {
                    return {
                        label: "Option " + i,
                        value: i,
                        selected: false
                    };
                })
            },
            {
                tag: "input",
                config: {
                    label: "Checkbox Group",
                    disabledAttrs: ["type"],
                    inputType: "MultiSelect"
                },
                attrs: {
                    type: 'checkbox',
                    required: false
                },
                meta: {
                    group: 'common',
                    icon: 'checkbox',
                    id: 'checkbox'
                },
                conditions: false,
                options: [1, 2, 3].map(function(i) {
                    return {
                        label: "Checkbox " + i,
                        value: i,
                        checked: false
                    };
                })
            },
            {
                tag: "input",
                config: {
                    label: "Radio Group",
                    inputType: "SingleSelectOptions"
                },
                attrs: {
                    type: 'radio',
                    required: false
                },
                meta: {
                    group: 'common',
                    icon: 'radio-group',
                    id: 'radio'
                },
                conditions: false,
                options: [1, 2, 3].map(function(i) {
                    return {
                        label: "Radio " + i,
                        value: i,
                        selected: false
                    };
                })
            },
            {
                tag: "input",
                attrs: {
                    type: 'time',
                    required: false
                },
                config: {
                    label: "Time Select",
                    inputType: "TimeOnly"
                },
                meta: {
                    group: 'common',
                    icon: '&#x1F550', //HTML Entity (Decimal), or HTML Entity (Hexadecimal)
                    id: 'time_select'
                },
                conditions: false
            },
            {
                tag: "div",
                attrs: {
                    style: 'height: 12.5vw;background: url("../../../../../assets/images/backgrounds/draw_pad.jpg") no-repeat;background-size: 22vw;',
                    required: false
                },
                config: {
                    label: "Draw or Sign",
                    inputType: "DrawPad"
                },
                meta: {
                    group: 'common',
                    icon: 'edit',
                    id: 'draw_sign'
                },
                conditions: false
            },
            {
                tag: "div",
                attrs: {
                    style: 'height: 12.5vw;background: url("../../../../../assets/images/backgrounds/vehicle_damage_canvas.jpg") no-repeat;background-size: 22vw;',
                    required: false
                },
                config: {
                    label: "Vehicle Canvas",
                    disabledAttrs: ["type"],
                    inputType: "VehicleCanvas"
                },
                meta: {
                    group: 'common',
                    icon: 'autocomplete',
                    id: 'vehicle_canvas',
                    class: 'vehicle_canvas'
                },
                conditions: false
            },
        ]

        const jobFieldElements = [{
                tag: "p",
                config: {
                    label: "Ticket #",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_ticketNumber',
                },
                conditions: false,
                content: "{JOB_TICKETNUMBER}"
            },
            {
                tag: "p",
                config: {
                    label: "Branch",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_branch',
                },
                conditions: false,
                content: "{JOB_BRANCH}"
            },
            {
                tag: "p",
                config: {
                    label: "Job Location",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_jobLocation',
                },
                conditions: false,
                content: "{JOB_LOCATION}"
            },
            {
                tag: "p",
                config: {
                    label: "Job Start Date",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_jobStartDate',
                },
                conditions: false,
                content: "{JOB_STARTDATE}"
            },
            {
                tag: "p",
                config: {
                    label: "Client Company",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_clientCompany',
                },
                conditions: false,
                content: "{JOB_CLIENTCOMPANY}"
            },
            {
                tag: "p",
                config: {
                    label: "Site Contact",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_siteContact',
                },
                conditions: false,
                content: "{JOB_SITECONTACT}"
            },
            {
                tag: "p",
                config: {
                    label: "Timesheet Manager",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_timesheetManager',
                },
                conditions: false,
                content: "{JOB_TIMESHEETMANAGER}"
            },
            {
                tag: "p",
                config: {
                    label: "Submitted By",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_submittedBy',
                },
                conditions: false,
                content: "{JOB_SUBMITTEDBY}"
            },
            {
                tag: "p",
                config: {
                    label: "Submission Email",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_submissionEmail',
                },
                conditions: false,
                content: "{JOB_SUBMISSIONEMAIL}"
            },
            {
                tag: "p",
                config: {
                    label: "Submission Phone",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'jobFieldGroup',
                    id: 'jobField_submissionPhone',
                },
                conditions: false,
                content: "{JOB_SUBMISSIONPHONE}"
            },
        ];

        const workerFieldElements = [{
                tag: "p",
                config: {
                    label: "Worker Name",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false
                },
                meta: {
                    group: 'workerFieldGroup',
                    id: 'workerField_fullName',
                },
                conditions: false,
                content: "{WORKER_FULLNAME}"
            },
            {
                tag: "p",
                config: {
                    label: "Shift Type",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'workerFieldGroup',
                    id: 'workerField_shiftType',
                },
                conditions: false,
                content: "{WORKER_SHIFTTYPE}"
            }
        ];

        const vehicleFieldElements = [{
                tag: "p",
                config: {
                    label: "Registration Number",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false
                },
                meta: {
                    group: 'vehicleFieldGroup',
                    id: 'vehicleField_registrationNumber',
                },
                conditions: false,
                content: "{VEHICLE_REGISTRATIONNUMBER}"
            },
            {
                tag: "p",
                config: {
                    label: "Description",
                    hideLabel: true,
                    inputType: "PrePopulated",
                    fieldLabel: "Vehicle Description"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'vehicleFieldGroup',
                    id: 'vehicleField_description',
                },
                conditions: false,
                content: "{VEHICLE_DESCRIPTION}"
            },
            {
                tag: "p",
                config: {
                    label: "Operator Name",
                    hideLabel: true,
                    inputType: "PrePopulated"
                },
                attrs: {
                    contenteditable: false,
                },
                meta: {
                    group: 'vehicleFieldGroup',
                    id: 'vehicleField_operatorName',
                },
                conditions: false,
                content: "{VEHICLE_OPERATORNAME}"
            }
        ];

        const assetFieldElements = [{
            tag: "p",
            config: {
                label: "Description",
                hideLabel: true,
                inputType: "PrePopulated",
                fieldLabel: "Item Description"
            },
            attrs: {
                contenteditable: false,
            },
            meta: {
                group: 'assetFieldGroup',
                id: 'assetField_description',
            },
            conditions: false,
            content: "{ASSET_DESCRIPTION}"
        }];

        const formData = '{"id":"b935178c-436e-42b7-aeb5-4e3aa89ce448","stages":{"44666b41-6504-4e71-88f9-c1d864f05675":{"children":[],"id":"44666b41-6504-4e71-88f9-c1d864f05675"}},"rows":{},"columns":{},"fields":{}}';

        const disable = {
            elements: ['divider', 'hidden', 'button', 'date-input', 'textarea', 'text-input'],
            groups: ['html']
        };

        let service = {
            options: fnBuildFormeoOptions,
            formData: formData,
            saveFormBuilderData: saveFormBuilderData,
            publishFormTemplate: publishFormTemplate,
            generateFormTemplatePdf: generateFormTemplatePdf,
            downloadFormTemplatePdfInBase64: downloadFormTemplatePdfInBase64,
            formId: ""
        };

        let observerCallbacks = [];

        service.registerObserverCallback = function(callback) {
            observerCallbacks.push(callback);
        };

        let notifyObservers = function() {
            angular.forEach(observerCallbacks, function(callback) {
                callback();
            });
        };

        return service;

        function fnBuildFormeoOptions(formId) {
            var deferred = $q.defer();

            setTimeout(function() {

                customFormsApi.getFormTemplate(formId).then(function(reco) {
                    elements = commonElements.concat(jobFieldElements, workerFieldElements, vehicleFieldElements, assetFieldElements);

                    let list_groups = [
                        commonFieldsGroup,
                        layoutFieldsGroup,
                        jobFieldsGroup,
                        workerFieldsGroup,
                        vehicleFieldsGroup,
                        assetFieldsGroup
                    ];
                    let groups = [];
                    angular.forEach(list_groups, function(group) {
                        if (group.formType == 'Common' || group.formType == 'Layout' || group.formType == 'Job' || group.formType == reco.data.formType) {
                            groups.push(group);
                        }
                    });

                    controlOptions = {
                        groupOrder: ['common', 'jobFieldGroup', 'workerFieldGroup', 'vehicleFieldGroup', 'assetFieldGroup'],
                        elements: elements,
                        disable: disable,
                        groups: groups,
                        sortable: false // allow controls to be reordered by users
                    }

                    formeoOptions = {
                        editorContainer: '#formeo-editor',
                        svgSprite: 'https://draggable.github.io/formeo/assets/img/formeo-sprite.svg',
                        controls: controlOptions,
                        sessionStorage: true,
                        events: {
                            onUpdate: function() {
                                notifyObservers();
                            },
                            confirmClearAll: function() {
                                notifyObservers();
                            }
                        },
                        debug: false //enable Debug mode
                    }

                    deferred.resolve(formeoOptions);
                });

            }, 100);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.customForms')
        .controller('FormTemplatesEditController', FormTemplatesEditController);

    /** @ngInject */
    function FormTemplatesEditController($mdDialog,
        $stateParams,
        $state,
        blockUI,
        exceptionService,
        formTemplatesEditService,
        notificationService,
        msgboxService,
        utils) {

        let vm = this;
        let formTemplateId = $stateParams.id;

        // Form being edited

        vm.formTemplate = {};

        vm.isFormInTestMode = false;
        vm.isFormInPrintPreviewMode = false;
        vm.toggleFormPreview = toggleFormPreview;
        vm.togglePrintPreview = togglePrintPreview;

        vm.formBuilderApi = {};

        // Public functions
        vm.updateSettings = updateSettings;
        vm.publish = publish;
        vm.saveFormData = saveFormData;        
        vm.formatUtcDateToLocalFormat = formatUtcDateToLocalFormat;

        // Reg exp to split strings from 'TitleCase' to 'Title Case'
        vm.regExp = /(?=[A-Z])/;

        getFormTemplate(true);

        function toggleFormPreview() {
            vm.isFormInTestMode = vm.formBuilderApi.toggleFormPreview();
        }

        function togglePrintPreview() {
            vm.isFormInPrintPreviewMode = vm.formBuilderApi.togglePrintPreview();
        }

        function getFormTemplate(reloadFormBuilder) {
            if (formTemplateId) {
                formTemplatesEditService.getFormTemplate(formTemplateId).then(function(formTemplateViewModel) {
                    vm.formTemplate = formTemplateViewModel;
                    formTemplatesEditService.data = Object.assign({}, formTemplateViewModel);

                    if (reloadFormBuilder) {
                        vm.formBuilderApi.renderForm(vm.formTemplate.formType, vm.formTemplate.templateJson);
                    }
                });
            }
        }

        function updateSettings() {
            $mdDialog.show({
                templateUrl: 'app/main/customForms/components/formTemplates-formSettings.html',
                controller: 'FormTemplatesFormSettingsController as vm',
                locals: {
                    formTemplate: vm.formTemplate
                }
            });
        }

        function publish() {
            var formBuilderData = vm.formBuilderApi.getFormData();
            save(formBuilderData).then(function(formData) {
                blockUI.start('Publishing ' + vm.formTemplate.name + '...');
                return new Promise(function(resolve) {
                    formTemplatesEditService.publishFormTemplate(formTemplateId)
                        .then(function(publishData) {
                            resolve({
                                saveData: formData,
                                publishData: publishData,
                            })
                        })
                })
            }).then(function(combined) {
                notificationService.showToast(vm.formTemplate.name + ' successfully published.');
                getFormTemplate(false);
            }).catch(function(error) {
                exceptionService.resolve('Error publishing ' + vm.formTemplate.name);
            }).finally(function() {
                blockUI.stop();
            });
        }

        function saveFormData() {
            var formBuilderData = vm.formBuilderApi.getFormData();
            const isFormBuilderDirty = !_.isEqual(formBuilderData.templateJson, vm.formTemplate.templateJson);
            if (vm.formTemplate.isPublished && isFormBuilderDirty) {
                const title = utils.translate('CUSTOMFORMSMODULE.PUBLISHED_FORM_SAVE_CONFIRMATION_TITLE');
                const msg = utils.translate('CUSTOMFORMSMODULE.PUBLISHED_FORM_SAVE_CONFIRMATION_MESSAGE');
                msgboxService.yepNo(msg, title, utils.translate('CUSTOMFORMSMODULE.UPDATE'), utils.translate('CUSTOMFORMSMODULE.CANCEL')).then(function() {
                    save(formBuilderData);
                })
            } else {
                save(formBuilderData);
            }
        }

        function save(formBuilderData) {
            blockUI.start('Saving ' + vm.formTemplate.name + '...');

            return formTemplatesEditService.updateFormSections(formBuilderData)
                .then(function() {
                    formTemplatesEditService.getLatestFormTemplate(formTemplateId).then(function(formTemplateViewModel) {
                        vm.formTemplate = formTemplateViewModel;
                        formTemplatesEditService.data = Object.assign({}, formTemplateViewModel);

                        $state.go('app.customForms.edit', {
                            id: vm.formTemplate.id
                        });
                    });

                    notificationService.showToast(vm.formTemplate.name + ' sections successfully saved.');
                }).catch(function(error) {
                    exceptionService.resolve(error);
                }).finally(function() {
                    blockUI.stop();
                });
        }

        function formatUtcDateToLocalFormat(date) {
            return utils.displayUtcInLocalDateTimeFormat(date);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customForms')
        .directive('formBuilder', formBuilder);

    /** @ngInject */
    function formBuilder(
        exceptionService
    ) {
        return {
            scope: {
                api: '='
            },
            bindToController: true,
            templateUrl: "app/main/customForms/directives/form-builder.html",
            controllerAs: "fb",
            controller: function(_,
                $scope,
                blockUI,
                formBuilderService,
                $stateParams,
                $timeout,
                $sce,
                $mdDialog
            ) {
                let fb = this;
                fb.api.renderForm = renderForm;
                fb.api.getFormData = getFormData;
                fb.api.toggleFormPreview = toggleFormPreview;
                fb.api.togglePrintPreview = togglePrintPreview;

                fb.formBuilder = new FormBuilder();
                fb.formTemplateId = $stateParams.id;
                formBuilderService.formId = fb.formTemplateId;

                fb.pdfUrl = '';
                fb.isFormDirty = false;

                fb.isFormMode = true;
                fb.isFormInTestMode = false;
                fb.isFormInPrintPreviewMode = false;

                let updateFormDirty = function() {
                    fb.isFormDirty = true;
                    $scope.$apply();
                };

                angular.element(document).ready(function() {
                    let formBuilderDiv = document.getElementById('form-builder');
                    if (formBuilderDiv !== null) {
                        formBuilderDiv.addEventListener('cfEditComponentEvent', event => focusIntoComponentTitle());

                        formBuilderDiv.addEventListener('cfConfirmDeleteRowEvent', event => showConfirmDeleteRowModal());
                    }

                });

                function showConfirmDeleteRowModal() {
                    var confirm = $mdDialog.confirm()
                        .title('Delete form row')
                        .textContent('Are you sure you want to delete this row and all of its elements?')
                        .ariaLabel('Delete form row')
                        .ok('Delete')
                        .cancel('Cancel');

                    $mdDialog.show(confirm).then(function() {
                        fb.formBuilder.handleShowConfirmDeleteModal();
                    });
                }

                function renderForm(formType, templateJson) {
                    formBuilderService.options(fb.formTemplateId).then(function(opts) {
                        fb.formBuilder.render(document.getElementById(fb.formTemplateId), JSON.parse(templateJson), {
                            formType: formType
                        }, null, false, true);

                        $timeout(function() {
                            formBuilderService.registerObserverCallback(updateFormDirty);
                            initializePerfectScrollbarByTag('md-tab-content');
                        }, 1000);
                    });
                }

                function focusIntoComponentTitle() {
                    angular.element("[name='componentTitle']").focus();
                }

                function toggleFormPreview() {
                    fb.isFormMode = true;
                    fb.isFormInTestMode = !fb.isFormInTestMode;
                    fb.isFormInTestMode ? fb.formBuilder.openPreview() : fb.formBuilder.closePreview();
                    return fb.isFormInTestMode;
                }

                function togglePrintPreview() {
                    fb.isFormInPrintPreviewMode = !fb.isFormInPrintPreviewMode;
                    fb.isFormMode = !fb.isFormInPrintPreviewMode;

                    if (!fb.isFormInPrintPreviewMode) {
                        return;
                    }

                    blockUI.start({
                        message: 'Generating Preview PDF, please wait...'
                    });

                    formBuilderService.generateFormTemplatePdf(fb.formTemplateId, fb.formBuilder.data).then(function(response) {
                        formBuilderService.downloadFormTemplatePdfInBase64(fb.formTemplateId).then(function(response) {
                            fb.pdfUrl = $sce.trustAsResourceUrl("data:application/pdf;base64," + response.data);
                            blockUI.stop();
                        }, function(error) {
                            blockUI.stop();
                            exceptionService.resolve(error);
                        });
                    }, function(error) {
                        blockUI.stop();
                        exceptionService.resolve(error);
                    });

                    return fb.isFormInPrintPreviewMode;
                }

                function clearFormData(form) {
                    FormBuilderUtils.getAllComponents(form).forEach(component => component.currentValues = []);
                }

                function getFormData() {
                    fb.isFormDirty = false;

                    let sectionTemplates = [];
                    let form = JSON.parse(JSON.stringify(fb.formBuilder.data)); // easy way to deep clone
                    clearFormData(form); // Clear off before saving to database

                    const show = 0,
                        hide = 1;

                    let headerSectionTemplate = {
                        id: form.header.id,
                        name: `Row-0`,
                        displayOrder: 0,
                        fieldTemplates: [],
                        isHeaderSection: true
                    };

                    form.header.components.forEach((component, componentIndex) => {
                        let fieldTemplate = {
                            label: component.title,
                            defaultValue: component.content,
                            inputType: component.typeId,
                            isRequired: component.required || false,
                            displayOrder: componentIndex,
                            htmlElementReferenceId: component.id,
                            valueItems: (component.options || []).map((option, optionIndex) => {
                                return {
                                    name: option.value,
                                    displayOrder: optionIndex
                                }
                            }),
                            conditions: [],
                            isHeaderField: true
                        };

                        headerSectionTemplate.fieldTemplates.push(fieldTemplate);
                    });

                    sectionTemplates.push(headerSectionTemplate);

                    form.sections.forEach((section, sectionIndex) => {
                        let sectionTemplate = {
                            id: section.id,
                            name: `Row-${sectionIndex}`,
                            displayOrder: sectionIndex,
                            fieldTemplates: [],
                            isHeaderSection: false
                        }

                        section.components.forEach((component, componentIndex) => {
                            let fieldTemplate = {
                                label: component.title,
                                defaultValue: component.content,
                                inputType: component.typeId,
                                isRequired: component.required || false,
                                hideFieldOnPdf: component.hideFieldOnPdf,
                                hideUnselectedOptionsOnPdf: component.hideUnselectedOptionsOnPdf,
                                displayOrder: componentIndex,
                                htmlElementReferenceId: component.id,
                                valueItems: (component.options || []).map((option, optionIndex) => {
                                    return {
                                        name: option.value,
                                        displayOrder: optionIndex
                                    }
                                }),
                                conditions: (component.conditions || []).map((condition) => {
                                    return {
                                        sourceValue: condition.ifRule.otherComponentValue,
                                        sourceHtmlReferenceId: condition.ifRule.otherComponentId,
                                        action: condition.thenRule.isHidden ? hide : show
                                    }
                                }),
                                isHeaderField: false
                            };

                            sectionTemplate.fieldTemplates.push(fieldTemplate);
                        });

                        sectionTemplates.push(sectionTemplate);
                    });

                    let formBuilderData = {
                        formTemplateId: fb.formTemplateId,
                        templateJson: JSON.stringify(form),
                        templateHtml: fb.formBuilder.html,
                        sectionTemplates: sectionTemplates
                    };

                    return formBuilderData;
                }

                function initializePerfectScrollbarByTag(tag) {
                    angular.element(document)
                        .find(tag)
                        .each(function() {
                            PerfectScrollbar.initialize(this)
                        });
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.customForms')
        .controller('FormTemplatesFormSettingsController', FormTemplatesFormSettingsController);

    function FormTemplatesFormSettingsController(_,
        $mdDialog,
        $state,
        blockUI,
        formTemplatesEditService,
        notificationService,
        exceptionService,
        locals,
        $scope,
        msgboxService,
        utils) {
        var vm = this;

        // Public functions
        vm.closeDialog = closeDialog;
        vm.createFormTemplate = createFormTemplate;
        vm.updateFormTemplate = updateFormTemplate;
        vm.cloneFormTemplate = cloneFormTemplate;
        vm.onFormTypeChange = onFormTypeChange;
        vm.isFormTypeJobOrWorker = isFormTypeJobOrWorker;
        vm.isFormTypeVehicleOrAsset = isFormTypeVehicleOrAsset;
        vm.isFormNameChanged = false;
        vm.dialogTitle = '';
        vm.dialogPrimaryButtonText = '';

        initFormSettings();

        function initFormSettings() {
            if (locals.formTemplate) {
                vm.isEditMode = true;
                vm.dialogTitle = utils.translate('CUSTOMFORMSMODULE.SETTINGS.UPDATE_SETTINGS');
                vm.dialogPrimaryButtonText = utils.translate('CUSTOMFORMSMODULE.SETTINGS.UPDATE_SETTINGS');

                vm.formTemplate = locals.formTemplate;

                _.extend(vm.formTemplate, {
                    appliedTo: ''
                });
            } else if (locals.formTemplateToClone) {
                vm.isCloneMode = true;
                vm.dialogTitle = utils.translate('CUSTOMFORMSMODULE.LABEL_CLONEFORM');
                vm.dialogPrimaryButtonText = utils.translate('CUSTOMFORMSMODULE.LABEL_CLONEFORM');

                vm.formTemplate = {
                    formType: locals.formTemplateToClone.formType,
                    isRequired: false,
                    allowMultipleSubmissions: false,
                    includeInPaperwork: false,
                    appliedTo: '',
                    templateHtml: '',
                    templateJson: '',
                    lastUpdated: ''
                }
            } else {                   
                vm.dialogTitle = utils.translate('CUSTOMFORMSMODULE.LABEL_CREATEFORM');
                vm.dialogPrimaryButtonText = utils.translate('CUSTOMFORMSMODULE.LABEL_CREATEFORM');

                vm.formTemplate = {
                    isRequired: false,
                    allowMultipleSubmissions: false,
                    includeInPaperwork: false,
                    appliedTo: '',
                    templateHtml: '',
                    templateJson: '',
                    lastUpdated: ''
                }
            };

            if (vm.isEditMode) {
                mapConsumerFieldsToViewModel();
            }
        }

        function createFormTemplate() {
            blockUI.start('Creating Form Template...')
            formTemplatesEditService.createFormTemplate(vm.formTemplate).then(function(response) {
                notificationService.showToast('Form template successfully created.');
                closeDialog();
                let createdFormTemplateId = response.data;
                $state.go('app.customForms.edit', {
                    id: createdFormTemplateId
                });

            }, function(error) {
                var errorMessage = (error.data) ? error.data : 'Failed to create a form template.';
                exceptionService.showError(errorMessage);

            }).finally(function() {
                blockUI.stop();
            });
        }

        function updateFormTemplate() {
            if (vm.formTemplate.isPublished && vm.isFormNameChanged) {
                const title = utils.translate('CUSTOMFORMSMODULE.PUBLISHED_FORM_SAVE_CONFIRMATION_TITLE');
                const msg = utils.translate('CUSTOMFORMSMODULE.PUBLISHED_FORM_SAVE_CONFIRMATION_MESSAGE');
                msgboxService.yepNo(msg, title, utils.translate('CUSTOMFORMSMODULE.UPDATE'), utils.translate('CUSTOMFORMSMODULE.CANCEL'))
                    .then(function() {
                        update();
                    }, function() {
                        vm.formTemplate.name = formTemplatesEditService.data.name;
                    })
            } else {
                update();
            }
        }

       async function cloneFormTemplate() {
           blockUI.start('Cloning Form Template...');

           try {
               var cloneFormTemplateResponse = await formTemplatesEditService
                   .cloneFormTemplate(locals.formTemplateToClone.id, vm.formTemplate);

               if (cloneFormTemplateResponse.data) {
                   notificationService.showToast('Form template successfully cloned.');

                   let createdFormTemplateId = cloneFormTemplateResponse.data;

                   closeDialog();

                   $state.go('app.customForms.edit', {
                       id: createdFormTemplateId
                   });
               }
           } catch (ex) {
               var errorMessage = (ex.data) ? ex.data : 'Failed to clone a form template.';
               exceptionService.showError(errorMessage);
           }

           blockUI.stop();
       }

        $scope.$watch('vm.formTemplate.name', function(modelAfterChange, modelBeforeChange) {
            vm.isFormNameChanged = modelAfterChange !== modelBeforeChange;
        });

        function update() {
            blockUI.start('Updating form template...')
            formTemplatesEditService.updateFormTemplate(vm.formTemplate)
                .then(function() {
                    vm.formTemplate.consumerFields.IncludeInPaperwork = vm.formTemplate.includeInPaperwork;
                    vm.formTemplate.consumerFields.AppliedTo = vm.formTemplate.appliedTo;

                    formTemplatesEditService.getLatestFormTemplate(vm.formTemplate.id)
                        .then(function(formTemplateViewModel) {
                            formTemplatesEditService.data = Object.assign({}, formTemplateViewModel);
                            closeDialog();
                            notificationService.showToast('Form template successfully saved.');
                        });

                }, function(error) {
                    var errorMessage = (error.data) ? error.data : 'Failed to update a form template.';
                    exceptionService.showError(errorMessage);
                    restoreFormTemplateSettings();

                }).finally(function() {
                    blockUI.stop();
                });
        }

        function restoreFormTemplateSettings() {
            let data = formTemplatesEditService.data;

            vm.formTemplate.allowMultipleSubmissions = data.allowMultipleSubmissions;
            vm.formTemplate.appliedTo = data.appliedTo;
            vm.formTemplate.consumerFields = data.consumerFields;
            vm.formTemplate.formType = data.formType;
            vm.formTemplate.includeInPaperwork = data.includeInPaperwork;
            vm.formTemplate.isPublished = data.isPublished;
            vm.formTemplate.isRequired = data.isRequired;
            vm.formTemplate.name = data.name;
            vm.formTemplate.lastUpdated = data.lastUpdated;
        }

        function closeDialog() {
            restoreFormTemplateSettings();
            $mdDialog.hide();
        }

        function mapConsumerFieldsToViewModel() {
            vm.formTemplate.appliedTo = vm.formTemplate.consumerFields.AppliedTo;
            vm.formTemplate.includeInPaperwork = JSON.parse(vm.formTemplate.consumerFields.IncludeInPaperwork);
        }

        function onFormTypeChange() {
            vm.formTemplate.appliedTo = '';
        }

        function isFormTypeJobOrWorker() {
            return ['Worker', 'Job'].includes(vm.formTemplate.formType);
        }

        function isFormTypeVehicleOrAsset() {
            return ['Vehicle', 'Asset'].includes(vm.formTemplate.formType);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core', [
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMessages',
            'ngResource',
            'ngSanitize',
            'ngMaterial',
            'pascalprecht.translate',
            'ui.router',
            'angular-chartist',
            'chart.js',
            'datatables',
            'gridshore.c3js.chart',
            'nvd3',
            'pascalprecht.translate',
            'timer',
            'uiGmapgoogle-maps',
            'textAngular',
            'ui.sortable',
            'ng-sortable',
            'xeditable',
            'moment-picker',
            'blockUI',
            'LocalStorageModule',
            'ivh.treeview',
            'ui.tree',
            'infinite-scroll',
            'angular-cache',
            'fiestah.money',
            'alloc8Constants'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('specialScroll', specialScroll);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }


    function specialScroll($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            scope : {
                scroll : '='
            },
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    scope.$watch(function ()
                    {
                        return scope.scroll;
                    }, function ()
                    {
                        iElement[0].scrollTop = 0;
                        PerfectScrollbar.update(iElement[0]);
                    });


                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('app.custom-fields.view')
        .factory('CustomFieldsManagerService', CustomFieldsManagerService);

    /** @ngInject */
    function CustomFieldsManagerService(
        assetCategoryService,
        customFieldsApi,
        _,
        $http,
        $timeout,
        contactLookupsService,
        $q,
        companyLookupService,
        lookupApi,
        utils
    ) {
        var service = {
            scroll_to_top: false,
            saving: false,
            loading: false,
            something_has_been_selected: false,
            is_for_edit: false,
            custom_fields_list: [],
            chosen_module: 1,
            lookup_types: [],
            modules: [{
                    Id: 1,
                    Name: "Contacts",
                },
                {
                    Id: 2,
                    Name: "Companies"
                },
                {
                    Id: 3,
                    Name: "Branches"
                },
                {
                    Id: 4,
                    Name: "Assets"
                },
                {
                    Id: 5,
                    Name: "Jobs"
                }
            ],
            field_types: [],
            chosen_fields: [],
            categories: [],
            initial_load: true,
            side_class: null,
            initial_field_value: null,
            deleteField: deleteField,
            getCustomFields: getCustomFields,
            activate: activate,
            prepareForUpdate: prepareForUpdate,
            closeForm: closeForm,
            prepareForAdd: prepareForAdd
        };

        return service;

        function deleteField(id) {
            service.loading = true;
            customFieldsApi.deleteField(id).then(function() {
                service.loading = false;
                _.forEach(service.chosen_fields, function(field, key) {
                    if (field.id === id) {
                        service.chosen_fields.splice(key, 1);
                    }
                });

                _.forEach(service.custom_fields_list, function(field, key) {
                    if (field.id === id) {
                        service.custom_fields_list.splice(key, 1);
                    }
                });
            });
        }

        function getCustomFields(module) {
            service.LookupTypes = [];
            service.something_has_been_selected = false;
            service.initial_load = true;
            service.loading = true;
            $q.all([
                customFieldsApi.getCustomFields()
            ]).then(function(resp) {
                service.custom_fields_list = groupFields(resp[0].data);
                service.chosen_fields = _.filter(service.custom_fields_list, {
                    AvailableFor: module || service.chosen_module
                });

                service.scroll_to_top = !service.scroll_to_top;

                if (module === 1) {
                    contactLookupsService.fetchLookups().then(function(resp) {
                        service.lookup_types = resp.ContactTypes;
                        service.lookup_types = utils.removeDuplicates(service.lookup_types, "TypeName");
                        service.loading = false;
                    });
                }

                if (module === 2) {
                    companyLookupService.fetchCompanyTypes().then(function(resp) {
                        service.lookup_types = resp;
                        service.lookup_types = utils.removeDuplicates(service.lookup_types, "TypeName");
                        service.loading = false;
                    });
                }

                if (module === 3) {
                    service.loading = false;
                }

                if (module === 4) {
                    $q.all([lookupApi.getItemTypes2(), assetCategoryService.getCategories()])
                        .then(function(resp) {
                            service.lookup_types = resp[0].data;
                            service.categories = resp[1].filter(function(category) {
                                return _.isNull(category.ParentId);
                            });
                            service.loading = false;
                        });
                }

                if (module === 5) {
                    lookupApi.getTicketTypes().then(function(resp) {
                        service.lookup_types = resp.data.map(function(l) {
                            return {
                                id: l.Id,
                                TypeName: l.Name
                            }
                        });
                        service.loading = false;
                        service.lookup_types = utils.removeDuplicates(service.lookup_types, "TypeName");
                    });
                }
            }).catch(function() {
                service.loading = false;
            })
        }

        function closeForm(item) {
            service.something_has_been_selected = false;
            service.initial_load = true;

            if (item.NewField) {
                service.chosen_fields = service.chosen_fields.filter(function(i) {
                    return !i.NewField;
                });
            } else {
                _.forEach(service.chosen_fields, function(field) {
                    if (field.id === item.id) {
                        field.Selected = false;
                    }
                });

                _.forEach(service.custom_fields_list, function(field) {
                    if (field.id === item.id) {
                        field.Selected = false;
                    }
                });
            }
        }

        function prepareForAdd() {
            _.forEach(service.chosen_fields, function(field, key) {
                field.Selected = false;
            });

            $http.get("app/main/customFieldsManager/views/initial-field.json").then(function(resp) {
                $timeout(function() {
                    service.scroll_to_top = !service.scroll_to_top;
                    service.initial_field_value = resp.data;
                    service.initial_field_value['AvailableFor'] = service.chosen_module;
                    service.something_has_been_selected = true;
                    service.initial_load = false;
                    service.is_for_edit = false;
                    $timeout(function() {
                        service.chosen_fields.unshift(service.initial_field_value);
                    });
                })
            });
        }

        function prepareForUpdate(id) {
            service.something_has_been_selected = true;
            service.initial_load = false;
            service.is_for_edit = true;
            _.forEach(service.chosen_fields, function(field, key) {
                if (field.id === id) {
                    field.Selected = true;
                } else {
                    field.Selected = false;
                }
            });

            _.forEach(service.custom_fields_list, function(field, key) {
                if (field.id === id) {
                    field.Selected = true;
                } else {
                    field.Selected = false;
                }
            });
        }

        function groupFields(list_of_fields) {
            let items = _.forEach(list_of_fields, function(field) {
                field['AvailableFor'] = field.ModulePages[0];
                field['AvailableForModule'] = getModule(field.ModulePages[0]);
                field['FieldTypeName'] = getFieldType(field.FieldType);
                field['Selected'] = false;
                field['NewField'] = false;
                field['Lookups'] = field.LookupTypes.map(function(l) {
                    return l.TypeName;
                });
            });
            return items;
        }

        function getFieldType(field_id) {
            let result = _.find(service.field_types, {
                Id: field_id
            });
            return result;
        }

        function getModule(module) {
            let result = _.find(service.modules, {
                Id: module
            });
            return result.Name;
        }

        function activate() {
            service.initial_field_value = null;
            service.something_has_been_selected = false;
            service.initial_load = true;
            service.custom_fields_list = [];
            service.chosen_fields = [];
            service.chosen_module = 1;
            service.loading = true;
            $http.get("app/main/customFieldsManager/views/custom-fields-list.json").then(function(resp) {
                service.field_types = resp.data.data;
                setTimeout(function() {
                    service.getCustomFields(service.chosen_module);
                }, 1000);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.custom-fields.view')
        .controller('CustomFieldsManagerController', CustomFieldsManagerController);

    function CustomFieldsManagerController(CustomFieldsManagerService, $mdDialog, mediaQueryService) {

        var vm = this;
        vm.mediaService = mediaQueryService;
        vm.scroll = false;
        vm.service = CustomFieldsManagerService;

        vm.remove = remove;

        function activate() {
            vm.service.activate();
        }

        function remove(id){
            var confirm = $mdDialog.confirm()
                .title('Custom Fields Manager')
                .textContent('Would you like to delete this field?')
                .ok('Yes')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                vm.service.deleteField(id);
            });
        }

        activate();
    }
})();

(function () {
  'use strict';

  angular
    .module('app.contact.view')
    .controller('ContactViewController', ContactViewController);

  /** @ngInject */
  function ContactViewController(contactService,
    utils,
    $scope,
    contactViewGridService,
    contactViewService,
    $mdDialog,
    contactViewGridAdapterService,
    searchDelay) {

    var vm = this;

    // Data
    vm.service = contactService;
    vm.contactViewService = contactViewService;
    vm.utilservice = utils;
    vm.dataGrid = contactViewGridService;
    vm.delay = { debounce: searchDelay };

    // Methods
    vm.viewCard = viewCard;
    vm.showContactHistory = showContactHistory;
    vm.onEdit = onEdit;
    vm.onOpenCalendar = onOpenCalendar;
    vm.filterContacts = filterContacts;
    vm.contactViewDatesFilter = contactViewDatesFilter;
    vm.resetFilter = resetFilter;

    $scope.$on('$destroy', function(){
        vm.dataGrid.grid.data.length = 0;
        vm.dataGrid.filterData = null;
    });

    function viewCard(id, link) {
      contactService.showContactDetails(id, link);
    }

    function showContactHistory(id, name) {
      contactService.showContactHistory(id, name);
    }

    function onEdit(cid, cfname, clname) {
      contactService.onEdit(cid, cfname, clname);
    }

    function onOpenCalendar(param) {
      contactService.onOpenCalendar(param);
    }

    function filterContacts() {
      //contactService.service.loader = true;
      //contactService.service.loaderMessage = utils.translate('CONTACTSMODULE.FILTERING_CONTACTS');
      repopulateGrid(false);
    }

    function contactViewDatesFilter(){
      $mdDialog.show({
        templateUrl: 'app/main/contact/view/templates/dates.html',
        controller: 'ContactDatesController as vm'
      }).then(function(resp){
        if(resp){
          repopulateGrid(false);
        }
      });
    }

    function resetFilter() {
      contactViewGridAdapterService.ignoreCaching();
      contactViewService.resetFilter();
      repopulateGrid(true);
    }

    function repopulateGrid(noFilter) {
      contactViewGridAdapterService.ignoreCaching();
      contactViewGridService.setFilterData(noFilter ? null : contactViewService.filterModel.toBackendModel());
      contactViewGridService.grid.behavior.refresh();
    }

  }
})();



(function() {
    'use strict';

    angular
        .module('app.contact')
        .controller('contactTimesheetController', contactTimesheetController);

    function contactTimesheetController($mdDialog, message, mediaQueryService, Id, utils) {
        var vm = this;
        vm.message = message;

        vm.choice = null;
        vm.start_date = null;
        vm.end_date = null;

        vm.media = mediaQueryService;

        vm.onCancel = close;
        vm.onDone = save;
        vm.filterEndDate = filterEndDate;
        vm.filterStartDate = filterStartDate;

        function close(){
            $mdDialog.hide();
        }

        function filterEndDate(date){
            if(vm.start_date){
                return moment(date).isAfter(moment(vm.start_date))
            }else{
                return date;
            }
        }

        function filterStartDate(date){
            if(vm.end_date){
                return moment(date).isBefore(moment(vm.end_date))
            }else{
                return date;
            }
        }

        function transform(Id, StartDate, EndDate){
            $mdDialog.hide({
                Id : Id,
                StartDate : StartDate,
                EndDate : EndDate
            });
        }

        function save(){
            if(vm.choice == 1){
                transform(Id, utils.jsDateTime(vm.start_date), utils.jsDateTime(vm.end_date));
            }else if(vm.choice == 0){
                transform(Id, null, null);
            }else{
                vm.onCancel();
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.contact')
        .service('contactViewSignalrHubService', contactViewSignalrHubService);

    /** @ngInject */
    function contactViewSignalrHubService(
        signalRService,
        $rootScope,
        contactViewGridService,
        contactViewCacheService,
        claimsUtilService,
        contactViewService
    ) {

        const TOASTR_DELAY = 5000;

        var service = {
            register: register
        };

        var isInitialized = false; // To prevent double subscription to event

        return service;

        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function () {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }
        }

        function regs() {

            // Download feedback
            signalRService.messageHub.on('syncContactView', function (data) {
                if (claimsUtilService.hasBranchAccess(data.BranchIds)) {
                    let dataFixed = contactViewService.fixData2(data.Data);
                    contactViewCacheService.updateCache(data.UpdateType,dataFixed);
                    contactViewGridService.updateGridData(data.UpdateType, dataFixed);
                }
            });
        }

    };
})();
(function () {
    'use strict';

    angular.module('app.contact')
        .service('contactViewGridAdapterService', contactViewGridAdapterService);

    /** @ngInject */
    function contactViewGridAdapterService(
        $q,
        a8WebApiNoChunkDataProvider,
        contactViewService,
        contactViewCacheService
    ) {

        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            onCacheData: onCacheData, // inbound event
            ignoreCaching: ignoreCaching
        };

        // Create data provider
        var dbSource = a8WebApiNoChunkDataProvider.getInstance();
        var ignoreCache = false;

        activate();

        return service;
        ///////

        function activate() {
            // Db hub
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from db source or client side cache
         */
        function onGetData(params) {
            var dataToCache = [];
            //let dataFilters = params || getDefaultFilterParams();
            //dataFilters.filters

            if (!params) {
                // No filtering
                if (!contactViewCacheService.isDataExist() || ignoreCache) {
                    ignoreCache = false;
                    return dbSource.fetch(function () {
                        return contactViewService.getContacts();
                    });
                } else {
                    return dbSource.fetch(function () {
                        return $q.when({ data: contactViewCacheService.getCache().data });
                    });
                }
            } else {
                if (ignoreCache) {
                    ignoreCache = false;
                    // Filter data from server
                    return dbSource.fetch(function () {
                        return contactViewService.filterContacts(params);
                    });
                } else {
                    // Return cache filtered data
                    return dbSource.fetch(function () {
                        return $q.when({ data: contactViewCacheService.getCache().data });
                    });
                }
            }
        }

        /**
         * Event for implementing Caching of data
         * @param {*} data 
         */
        function onCacheData(data) {
            if (data != null)
                contactViewCacheService.addCache(data);
        }

        function ignoreCaching() {
            ignoreCache = true;
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.contact')
        .service('contactViewGridService', contactViewGridService);

    /** @ngInject */
    function contactViewGridService(
        exceptionService,
        contactViewGridAdapterService,
        $timeout
    ) {
        var service = {
            grid: {},
            filterData: null,
            setFilterData: setFilterData,
            componentEvent: angular.noop,
            updateGridData: updateGridData,
            searchText: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // View model for grid data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;
        service.grid.onSearch = onSearch;

        activate();

        return service;

        ///////
        function activate() { }

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(contactViewGridAdapterService);
        }

        /**
         * Loading of partial data
         * Perform view model data shaping here
         */
        function onCompleted(data) {
            service.grid.data.length = 0;

            angular.forEach(data, function (itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function setFilterData(filter) {
            service.filterData = filter;
        }

        function onDataLoading(extraData) {
        }

        function onSearch(value) {
            service.grid.behavior.search(value);
        }

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {
        }

        function onError(ex) {
            exceptionService.resolve(ex);
        }


        /**
         * =====================================
         * Update Grid Data (Contact array)
         * =====================================
         */
        function updateGridData(updateType, data) {
            if (!service.grid) return;

            switch (updateType) {
                case 2:
                    updateContact(data);
                    break;
                case 1:
                    insertContact(data);
                    break;
                case 3:
                    archiveContact(data);
                    break;
            }
        }

        function updateContact(data) {
            var updatedData = data;
            if (!service.grid.behavior) return;

            var updateMethod = (service.grid.behavior.updateState || angular.noop);

            updateMethod(function (o) { return o.Id === data.Id; }, function (items) {
                if (items.length <= 0) return;
                var contact = items[0];

                updateContactEntity(contact, updatedData);
            }, true);
        }

        function updateContactEntity(contact, updatedData) {
            contact.FirstName = updatedData.FirstName;
            contact.MiddleName = updatedData.MiddleName;
            contact.LastName = updatedData.LastName;
            contact.Position = updatedData.Position;
            contact.IsActive = updatedData.IsActive;
            contact.Phone = updatedData.Phone;
            contact.Email = updatedData.Email;
            contact.Branches = updatedData.Branches;
            contact.ContactTypes = updatedData.ContactTypes;
            contact.EmployeeCode = updatedData.EmployeeCode;
        }

        function insertContact(data) {
            $timeout(function () {
                (service.grid.behavior.pushToState || angular.noop)(data);
            });
        }

        function archiveContact(data) {
            $timeout(function () {
                (service.grid.behavior.removeToState || angular.noop)(function (o) { return o.Id === data.Id; });
            });
        }

    }
})();


/**
 * Contact View Cache Service
 *
 * Rcnet 10.12.2017
 */
(function () {
    'use strict';

    angular.module('app.contact')
        .service('contactViewCacheService', contactViewCacheService);

    /** @ngInject */
    function contactViewCacheService($log,
        $q,
        _,
        exceptionService,
        dataCacheService2
    ) {

        var service = {
            isDataExist: isDataExist,
            addCache: addCache,
            getCache: getCache,
            updateCache: updateCache
        };

        var cacheObj = dataCacheService2.getInstance();

        const MAX_CACHE_ITEMS = 1;
        const CACHE_GROUP_KEY = 'contactViewData';
        const CACHE_KEY = 'urn:contactViewData:contactViewCache';

        activate();

        return service;
        ///////

        function activate() {
            // 15 MINUTES to evict/expire cache for contact view (fair enough huh?) lol
            cacheObj.group(CACHE_GROUP_KEY, { capacity: MAX_CACHE_ITEMS, maxAge: 900 * 1000, deleteOnExpire: 'aggressive' });
        }

        function isDataExist() {
            return cacheObj.getCache(CACHE_KEY) != null;
        }

        function addCache(data) {
            cacheObj.updateCache(CACHE_KEY, { data: data });
        }

        function getCache() {
            return cacheObj.getCache(CACHE_KEY);
        }

        function updateCache(updateType, data) {
            if (!isDataExist()) return;

            switch (updateType) {
                case 2:
                    updateContact(data);
                    break;
                case 1:
                    insertContact(data);
                    break;
                case 3:
                    archiveContact(data);
                    break;
            }
        }

        function updateContact(data) {
            var cache = getCache().data;

            _.remove(cache, function (o) {
                return o.Id === data.Id;
            });

            cache.push(data);
        }

        function insertContact(data) {
            var cache = getCache().data;
            cache.push(data);
        }

        function archiveContact(data) {
            var cache = getCache().data;

            _.remove(cache, function (o) {
                return o.Id === data.Id;
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.contact')
        .factory('contactViewService', contactViewService);

    /** @ngInject */
    function contactViewService(
        $q,
        contactApi,
        contactViewFilterModel,
        _) {

        var service = {
            filterModel: new contactViewFilterModel(),
            getContacts: getContacts,
            getEmployees: getEmployees,
            filterContacts: filterContacts,
            resetFilter: resetFilter,
            fixData2: fixData2
        };

        activate();

        return service;

        ///////
        function activate() { }

        function getContacts() {
            var deferred = $q.defer();

            contactApi.getAll().then(function (resp) {
                var transformedData = transformData(resp.data);
                deferred.resolve({ data: transformedData });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function getEmployees() {
            var deferred = $q.defer();

            contactApi.getAll().then(function (resp) {
                var transformedData = transformData(resp.data);
                deferred.resolve({ data: transformedData.filter(d => d.IsEmployee === 'Employee') });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        function isEmployee(contact) {
            let isEmployee = _.find(contact.ContactTypes, function (o) { return o === 'Employee' })
            return isEmployee;
        }

        function filterContacts(filterData) {
            var deferred = $q.defer();

            contactApi.filterContact(filterData.filters).then(function (resp) {
                var transformedData = transformData(resp.data);
                deferred.resolve({ data: transformedData });
            }).catch(function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function resetFilter() {
            service.filterModel.reset();
        }

        function transformData(data) {
            let ContactsList = data;

            angular.forEach(ContactsList, function (contact) {
                fixData(contact);
            });

            return ContactsList;
        }

        function fixData(contact) {
            let temporaryBranches = contact.Branches;
            contact.Branches = [];
            contact['Divisions'] = [];
            contact['IsEmployee'] = isEmployee(contact);

            angular.forEach(temporaryBranches, function (branch) {
                contact.Branches.push(branch.m_Item1);
                angular.forEach(branch.m_Item2, function (division) {
                    contact.Divisions.push(division);
                });
            });

            if (contact.Branches.length > 3) {
                contact.Branches = contact.Branches.slice(0, 3);
                contact.Branches.sort();
                contact.Branches[3] = "...";
            }

            if (contact.ContactTypes.length > 3) {
                contact.ContactTypes = contact.ContactTypes.slice(0, 3);
                contact.ContactTypes.sort();
                contact.ContactTypes[3] = "...";
            }

            if (contact.Divisions.length > 2) {
                contact.Divisions = contact.Divisions.slice(0, 2);
                contact.Divisions.sort();
                contact.Divisions[2] = "...";
            }

            return contact;
        }


        function fixData2(contact) {
            let temporaryBranches = contact.Branches;
            contact.Branches = [];
            contact['Divisions'] = [];
            contact['IsEmployee'] = isEmployee(contact);

            angular.forEach(temporaryBranches, function (branch) {
                contact.Branches.push(branch.Item1);
                angular.forEach(branch.Item2, function (division) {
                    contact.Divisions.push(division);
                });
            });

            if (contact.Branches.length > 3) {
                contact.Branches = contact.Branches.slice(0, 3);
                contact.Branches.sort();
                contact.Branches[3] = "...";
            }

            if (contact.ContactTypes.length > 3) {
                contact.ContactTypes = contact.ContactTypes.slice(0, 3);
                contact.ContactTypes.sort();
                contact.ContactTypes[3] = "...";
            }

            if (contact.Divisions.length > 2) {
                contact.Divisions = contact.Divisions.slice(0, 2);
                contact.Divisions.sort();
                contact.Divisions[2] = "...";
            }
            
            return contact;
        }

    }
})();

(function () {
  'use strict';

  angular.module('app.contact')
    .factory('contactCompanyService', contactCompanyService);

  /** @ngInject */
  function contactCompanyService(contactCompanyModel,
                                 contactBranchModel,
                                 contactLookupsService,
                                 $timeout,
                                 utils) {
    var service = {
      contactCompanyData: new contactCompanyModel(),
      companyList: [],
      branchList: [],
      selectedItem: null,
      loadedData: null,
      isEditMode: false,
      init: init,
      onSelectedItemChange: selectedItemChange,
      getData: getData,
      reset: reset
    };

    return service;

    function reset() {
      service.contactCompanyData.reset();
      service.selectedItem = null;
      service.branchList = [];
      service.companyList = [];
    }

    function init(loadedData) {

      service.loadedData = loadedData;
      service.isEditMode = !!loadedData;

      angular.forEach(contactLookupsService.contactLookupsObj.Companies, function (itm) {
        service.companyList.push({
          id: itm.id,
          Name: itm.Name,
        });
      }, this);

      if (service.isEditMode) {
        $timeout(function () {
          var selected = {
            id: loadedData.Company.Id,
            Name: loadedData.Company.Name,
          };

          service.selectedItem = selected;
        });
      }
    }

    function selectedItemChange(id) {
      if (!id) {
        service.branchList = [];
        return;
      }

      var companyFullObj = findFullCompanyObject(id);

      if (companyFullObj.length > 0) {
        if (service.isEditMode) {
          service.contactCompanyData.map({
            id: companyFullObj[0].id,
            Name: companyFullObj[0].Name,
            Company: companyFullObj,
            Logo: companyFullObj[0].Logo,
            ContactType: service.loadedData.ContactType,
            Position: service.loadedData.Position,
            StartDate: utils.epochToJsDateTime(service.loadedData.StartDate),
            EndDate: utils.epochToJsDateTime(service.loadedData.EndDate)
          });

          service.branchList.length = 0;
          angular.forEach(companyFullObj[0].Branches, function (itm) {

            var model = new contactBranchModel({
              id: itm.id,
              Name: itm.Name,
              CreatedDate: itm.CreatedDate,
              LastUpdatedDate: itm.LastUpdatedDate,
              IsActive: itm.IsActive,
              IsArchived: itm.IsArchived
            });
            service.branchList.push(model);
          }, this);


        } else {
          service.contactCompanyData.map({
            id: companyFullObj[0].id,
            Name: companyFullObj[0].Name,
            Company: companyFullObj,
            Logo: companyFullObj[0].Logo
          });

          angular.forEach(companyFullObj[0].Branches, function (itm) {
            itm.Selected = false;
          }, this);

          service.branchList = angular.copy(companyFullObj[0].Branches);
        }
      }
    }

    function getData(data, editMode) {
      var selectedCompany = null;
      angular.forEach(contactLookupsService.contactLookupsObj.Companies, function (itm) {
        if (editMode) {
          if (data.Company.id !== undefined) {
            if (itm.id === data.Company.id) {
              selectedCompany = angular.copy(itm);
            }
          }
          if (data.Company.Id !== undefined) {
            if (itm.id === data.Company.Id) {
              selectedCompany = angular.copy(itm);
            }
          }
        } else {
          if (itm.id === data.id) {
            selectedCompany = angular.copy(itm);
          }
        }

      }, this);

      selectedCompany.Branches = data.Branches;

      var companyModel = {
        Company: selectedCompany,
        ContactType: service.contactCompanyData.ContactType,
        StartDate: service.contactCompanyData.StartDate ? utils.jsDateTimeToEpoch(service.contactCompanyData.StartDate) : null,
        EndDate: service.contactCompanyData.EndDate ? utils.jsDateTimeToEpoch(service.contactCompanyData.EndDate) : null,
        Position: service.contactCompanyData.Position,
        IsArchived: false,
        IsArchivedBySystem: false,
        Name: data.Name,
        Logo: data.Logo
      };
      return companyModel;
    }

    function findFullCompanyObject(id) {
      var result = _.filter(contactLookupsService.contactLookupsObj.Companies, function (o) {
        return o.id === id;
      });
      return result;
    }

  }

})();

(function() {
    'use strict';

    angular.module('app.contact')
        .factory('contactService', contactService);

    /** @ngInject */
    function contactService(
        $state,
        lookupApi,
        $mdToast,
        $mdDialog,
        $injector,
        $timeout,
        utils,
        blockUI,
        $translate,
        $q,
        identityService,
        contactApi,
        contactLookupsService,
        contactDataModel,
        AuditLogService,
        exceptionService,
        historyLogService,
        commentService,
        contactRulesModel,
        contactTrainingService,
        _) {

        var service = {
            contactData: new contactDataModel(),
            behavior: null,
            fields: contactRulesModel,
            save_message: null,
            saveDisabled: false,
            FormattedSkills: [],
            saving: false,
            query: null,
            Divisions: [],
            SelectedBranches: [],
            contactTypes: [],
            contactType: null,
            filterType: null,
            startDate: null,
            endDate: null,
            isActive: true,
            isArchive: false,
            isEditMode: false,
            disableSaving: false,
            loaderMessage: null,
            loader: false,
            contacts: [],
            customisedFields: null,
            isInit: false,
            minified_contacts: [],
            duplicatedContact: null,
            hideAccount: false,
            show_password: false,
            saveTrigger: false,
            loadContacts: loadContacts,
            resetData: resetData,
            archive: archive,
            saveContact: saveContact,
            updateContact: updateContact,
            loadData: loadData,
            viewAuditLog: viewAuditLog,
            filterContact: filterContact,
            getContactDetails: getContactDetails,
            contactViewDatesFilter: contactViewDatesFilter,
            updateProfile: updateProfile,
            loadDataCompleted: loadDataCompleted,
            redirectToContactView: redirectToContactView,
            addContactCompany: addContactCompany,
            updateContactCompany: updateContactCompany,
            savePhoto: savePhoto,
            removeContactCompany: removeContactCompany,
            isContactCompanyExist: isContactCompanyExist,
            loadCustomFields: loadCustomFields,
            filterContacts: filterContacts,
            getContactTypes: getContactTypes,
            validateEmployeeCode: validateEmployeeCode,
            reset: reset,
            showDialog: showDialog,
            deletefile: deletefile,
            showContactDetails: showContactDetails,
            showContactHistory: showContactHistory,
            viewComments: viewComments,
            onEdit: onEdit,
            onCreate: onCreate,
            onOpenCalendar: onOpenCalendar,
            translate: translate,
            validateDuplicateContact: validateDuplicateContact,
            getContactBasicLookup: getContactBasicLookup,
            branchFunc: branchFunc,
            getDivisionsFunc: getDivisionsFunc,
            getPrimaryBranchesFunc: getPrimaryBranchesFunc,
            divisionsFunc: divisionsFunc,
            deleteUser: deleteUser,
            getContactsByPayrollGroupId: getContactsByPayrollGroupId
        };

        return service;

        function resetData() {
            service.saving = false;
            service.contactData.reset();
        }

        function deleteUser(first_name, last_name, Id) {
            var confirm = $mdDialog.confirm()
                .title(utils.translate('CONTACTSMODULE.HEADER'))
                .textContent(utils.translate('CONTACTSMODULE.REMOVE_ACCOUNT_MESSAGE') + " " + getQuoted(first_name, last_name) + " " + utils.translate('CONTACTSMODULE.ACCOUNT') + " ?")
                .ok(utils.translate('CONTACTSMODULE.YES'))
                .cancel(utils.translate('CONTACTSMODULE.NO'));

            $mdDialog.show(confirm)
                .then(function() {
                    blockUI.start(utils.translate('CONTACTSMODULE.REMOVING_ACCOUNT'));
                    contactApi.deleteUser(Id)
                        .then(function() {
                            service.hideAccount = false;
                            service.contactData.HasAccount = false;
                            blockUI.stop();
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(utils.translate('CONTACTSMODULE.REMOVE_ACCOUNT_SUCCESSFUL'))
                                .position('bottom right')
                                .hideDelay(1500)
                            );
                        })
                        .catch(function(ex) {
                            exceptionService.resolve(ex);
                        })
                });
        }

        function getQuoted(first_name, last_name) {
            return last_name.toLowerCase()
                .charAt(last_name.length - 1) === "s" ? first_name + " " + last_name + "'" : first_name + " " + last_name + "'s";
        }

        function branchFunc() {
            getDivisionsFunc();
            cleanDivisions();
            getPrimaryBranchesFunc();
            cleanPrimaryBranches();
        }

        function cleanDivisions() {
            if (!service.isInit) {
                let branches = service.contactData.Branches2;
                let divs = [];
                _.forEach(service.contactData.Division, function(division, key) {
                    if (division) {
                        let match = _.find(branches, {
                            id: division.BranchId
                        });
                        if (match) {
                            divs.push(division);
                        }
                    }
                });
                service.contactData.Division = angular.copy(divs);
            }
        }

        function cleanPrimaryBranches() {
            if (!service.isInit && service.contactData.PrimaryBranch) {
                let pb = service.contactData.PrimaryBranch;
                if (pb.DivisionId) {
                    let divisions = service.contactData.Division;
                    let match = _.filter(divisions, function(m) {
                        return (m.id === pb.DivisionId || m.Id === pb.DivisionId)
                    });

                    if (match.length === 0) {
                        service.contactData.PrimaryBranch = null;
                    }
                } else {
                    let branches = service.contactData.Branches2;

                    let match = _.filter(branches, function(m) {
                        return (m.id === pb.BranchId || m.Id === pb.BranchId)
                    });

                    if (match.length === 0) {
                        service.contactData.PrimaryBranch = null;
                    }
                }
            }
        }

        function divisionsFunc() {
            getPrimaryBranchesFunc();
            cleanPrimaryBranches();
        }

        function bindPrimaryBranch() {
            if (service.contactData.PrimaryBranch) {
                let primary_branch = service.contactData.PrimaryBranch;
                if (primary_branch.Division.length > 0) {
                    let div = primary_branch.Division[0].id;
                    let div_equiv = _.find(service.SelectedBranches, {
                        DivisionId: div
                    });
                    service.contactData.PrimaryBranch = angular.copy(div_equiv);
                } else {
                    let div_equiv = _.find(service.SelectedBranches, {
                        BranchId: primary_branch.Id || primary_branch.id
                    });
                    service.contactData.PrimaryBranch = angular.copy(div_equiv);
                }
            }
        }

        function getDivisionsFunc() {
            service.Divisions = [];
            let branches = service.contactData.Branches2;
            angular.forEach(branches, function(branch) {
                let branch_divisions = _.filter(contactLookupsService.contactLookupsObj.Divisions, {
                    BranchId: branch.id || branch.Id
                });
                angular.forEach(branch_divisions, function(division) {
                    service.Divisions.push(division);
                });

                if (service.isInit) {
                    angular.forEach(branch.Division, function(division) {
                        service.contactData.Division.push(division);
                    });
                }
            });
            service.Divisions = alasql('select * from ? order by BranchName, Name', [service.Divisions]);
        }

        function getPrimaryBranchesFunc() {
            service.SelectedBranches = [];
            let branches = service.contactData.Branches2;
            let divisions = service.contactData.Division;

            angular.forEach(branches, function(branch) {
                let obj = {
                    TempId: utils.newGuid(),
                    Name: branch.Name + " - (No Division)",
                    IsBranch: true,
                    BranchName: branch.Name,
                    DivisionName: null,
                    DivisionId: null,
                    Selected: false,
                    BranchId: branch.id || branch.Id
                }
                service.SelectedBranches.push(obj);
            });

            angular.forEach(divisions, function(division) {
                let div_origin = _.find(contactLookupsService.contactLookupsObj.Divisions, {
                    id: division.id || division.Id
                });

                let branch_exists = _.find(branches, {
                    Id: div_origin.BranchId
                });

                if (branch_exists) {
                    let obj = {
                        TempId: utils.newGuid(),
                        Name: div_origin.BranchName + " - (" + division.Name + ")",
                        IsBranch: false,
                        BranchName: div_origin.BranchName,
                        DivisionName: div_origin.Name,
                        DivisionId: division.id || division.Id,
                        Selected: false,
                        BranchId: div_origin.BranchId
                    }
                    service.SelectedBranches.push(obj);
                }
            });

            service.SelectedBranches = alasql('select * from ? order by BranchName', [service.SelectedBranches]);
        }

        function getContactBasicLookup() {
            lookupApi.getBasicContactLookupsforContact()
                .then(function(resp) {
                    service.minified_contacts = resp.data;
                });
        }

        function translate(word) {
            return $translate.instant(word);
        }

        function loadContacts() {
            service.loaderMessage = utils.translate("VIEWCONTACTS.LOADER");
            service.contacts = [];
            service.loader = true;

            contactApi.getAll()
                .then(function(resp) {
                    let ContactsList = resp.data;
                    angular.forEach(ContactsList, function(contact) {
                        let temporaryBranches = contact.Branches;
                        contact.Branches = [];
                        contact['Divisions'] = [];

                        angular.forEach(temporaryBranches, function(branch) {
                            contact.Branches.push(branch.m_Item1);
                            angular.forEach(branch.m_Item2, function(division) {
                                contact.Divisions.push(division);
                            });
                        });

                        if (contact.Branches.length > 3) {
                            contact.Branches = contact.Branches.slice(0, 3);
                            contact.Branches.sort();
                            contact.Branches[3] = "...";
                        }

                        if (contact.ContactTypes.length > 3) {
                            contact.ContactTypes = contact.ContactTypes.slice(0, 3);
                            contact.ContactTypes.sort();
                            contact.ContactTypes[3] = "...";
                        }

                        if (contact.Divisions.length > 2) {
                            contact.Divisions = contact.Divisions.slice(0, 2);
                            contact.Divisions.sort();
                            contact.Divisions[2] = "...";
                        }

                    });
                    service.contacts = ContactsList;
                    service.loader = false;
                })
                .catch(function() {
                    service.loader = false;
                });
        }

        function contactViewDatesFilter() {
            $mdDialog.show({
                    templateUrl: 'app/main/contact/view/templates/dates.html',
                    controller: 'ContactDatesController as vm'
                })
                .then(function(resp) {
                    if (resp) {
                        service.filterContacts();
                    }
                });
        }

        function showContactDetails(Id, showEditLink) {
            blockUI.start('Loading Details');
            contactApi.getMinifiedContactDetails(Id)
                .then(function(resp) {
                    blockUI.stop();
                    $mdDialog.show({
                            templateUrl: 'app/main/contact/details/contact-dialog.html',
                            controller: 'contactDialogController as vm',
                            locals: {
                                data: resp.data,
                                showEditLink: showEditLink
                            }
                        })
                        .catch(function() {
                            blockUI.stop();
                        });
                });
        }

        function viewComments(Id, Name) {
            commentService.viewComments("Contact", Id, Name);
        }

        function showContactHistory(id, name) {
            blockUI.start('Loading History');
            contactApi.getContactHistory(id)
                .then(function(resp) {
                    historyLogService.showHistory("Contacts", resp.data, name);
                    blockUI.stop();
                });
        }

        function onOpenCalendar(param) {
            $state.go("app.contact_calendar", {
                Id: param.Id,
                Name: param.FirstName + " " + param.LastName
            });
        }

        function deletefile(file) {
            return contactApi.deleteFile(file);
        }

        function reset() {
            service.contactType = null;
            service.isArchive = false;
            service.startDate = null;
            service.endDate = null;
            loadContacts();
        }

        function showDialog(title, message, btnMessage) {
            $mdDialog.show(
                $mdDialog.alert()
                .clickOutsideToClose(true)
                .title(title)
                .textContent(message)
                .ok(btnMessage)
            );
        }

        function filterContacts() {
            service.loader = true;
            service.loaderMessage = utils.translate('CONTACTSMODULE.FILTERING_CONTACTS');

            var filterData = {
                ContactTypeId: service.contactType,
                IsActive: service.isActive,
                IsArchived: service.isArchive,
                FilterType: service.filterType,
                StartDate: service.startDate,
                EndDate: service.endDate
            }

            contactApi.filterContact(filterData)
                .then(function(resp) {
                    let ContactsList = resp.data;
                    angular.forEach(ContactsList, function(contact) {
                        let temporaryBranches = contact.Branches;
                        contact.Branches = [];
                        contact['Divisions'] = [];

                        angular.forEach(temporaryBranches, function(branch) {
                            contact.Branches.push(branch.m_Item1);
                            angular.forEach(branch.m_Item2, function(division) {
                                contact.Divisions.push(division);
                            });
                        });

                        if (contact.Branches.length > 3) {
                            contact.Branches = contact.Branches.slice(0, 3);
                            contact.Branches.sort();
                            contact.Branches[3] = "...";
                        }

                        if (contact.ContactTypes.length > 3) {
                            contact.ContactTypes = contact.ContactTypes.slice(0, 3);
                            contact.ContactTypes.sort();
                            contact.ContactTypes[3] = "...";
                        }

                        if (contact.Divisions.length > 2) {
                            contact.Divisions = contact.Divisions.slice(0, 2);
                            contact.Divisions.sort();
                            contact.Divisions[2] = "...";
                        }

                    });
                    service.contacts = ContactsList;
                    service.loader = false;
                })
                .catch(function(err) {
                    service.loader = false;
                    service.showDialog(utils.translate('CONTACTSMODULE.FILTERING_ERROR_TITLE'), utils.translate('CONTACTSMODULE.FILTERING_ERROR'), utils.translate('CONTACTSMODULE.FILTERING_ERROR_RETURN'));
                });
        }

        function getContactTypes() {
            var deferred = $q.defer();
            contactLookupsService.fetchContactTypes()
                .then(function(resp) {
                    service.contactTypes = resp;
                    deferred.resolve(resp);
                });
            return deferred.promise;
        }

        function addContactCompany(company) {
            delete company.Name;
            delete company.Logo;
            service.contactData.Companies.push(utils.objectSanitize(company));
        }

        function viewAuditLog() {
            AuditLogService.viewAuditLogs();
        }

        function onEdit(cid, cfname, clname) {
            blockUI.start('Loading Contact...');
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.contact_update', {
                cid: cid,
                cname: cfname + ' ' + clname
            });
        }

        function onCreate() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.contact_create');
        }

        function updateContactCompany(company) {
            delete company.Name;
            delete company.Logo;
            var index;

            for (var i = 0; i < service.contactData.Companies.length; i++) {
                var curr = service.contactData.Companies[i];
                if (curr.Company.id === company.Company.id) {
                    index = i;
                    break;
                }
            }

            service.contactData.Companies.splice(index, 1);
            service.contactData.Companies.push(utils.objectSanitize(company));
        }

        function removeContactCompany(id) {
            var index = -1;

            for (var i = 0; i < service.contactData.Companies.length; i++) {
                var curr = service.contactData.Companies[i];
                if (curr.Company.id === id) {
                    index = i;
                    break;
                }
            }

            if (index > -1) {
                service.contactData.Companies.splice(index, 1);
            }
        }

        function isContactCompanyExist(id) {
            if (!id) {
                return;
            }

            for (var i = 0; i < service.contactData.Companies.length; i++) {
                var curr = service.contactData.Companies[i];
                if (curr.Company.Id === id) {
                    return true;
                }
            }

            return false;
        }

        function getContactDetails(cid) {
            return contactApi.getContact(cid);
        }

        function updateProfile(data) {
            return contactApi.putContact(data);
        }

        function archive(isArchive) {
            var block_msg = isArchive ? utils.translate('CONTACTSMODULE.ARCHIVING') : utils.translate('CONTACTSMODULE.UNARCHIVING');
            var toast_msg = isArchive ? utils.translate('CONTACTSMODULE.ARCHIVING_MESSAGE') : utils.translate('CONTACTSMODULE.UNARCHIVING_MESSAGE');
            blockUI.start(block_msg);

            contactApi.postArchive(service.contactData.id, isArchive)
                .then(function(resp) {
                    blockUI.stop();
                    $mdToast
                        .show($mdToast.simple()
                            .textContent(toast_msg)
                            .position('bottom right')
                            .hideDelay(3000))
                        .then(function() {
                            redirectToContactView();
                        });
                })
                .catch(function(ex) {
                    blockUI.stop();
                    exceptionService.resolve(ex);
                });
        }

        function redirectToContactView() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.contact_view');
        }

        function redirectToUpdateContact(cid, cfname, clname) {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.contact_update', {
                cid: cid,
                cname: cfname + ' ' + clname
            });
        }

        function filterContact(model) {
            return contactApi.filterContact(model);
        }

        function saveContact() {
            service.saving = true;
            service.contactData.HasAccount = hasWebOrMobileAppAccess() && !_.isNil(service.contactData.Password);

            var model = service.contactData.transformToModel();

            if (identityService.userData.ContactId === service.contactData.id) {
                $timeout(function() {
                    identityService.userData.map({
                        PhotoUrl: service.contactData.ImageUrl
                    });
                }, 1);
            }

            var apiPromise = contactApi.postContact(model)
                .then(function(resp) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent(utils.translate('CONTACTSMODULE.CONTACT_SAVE_MESSAGE'))
                            .position('bottom right')
                            .hideDelay(2000)
                        )
                        .then(function() {
                            service.hideAccount = !_.isNil(service.contactData.Password);
                            service.save_message = "Redirecting ...";

                            if (service.behavior == 0) {
                                redirectToUpdateContact(resp.data.id, resp.data.FirstName, resp.data.LastName);
                            } else {
                                redirectToContactView();
                                service.saving = false;
                            }
                        });
                })
                .catch(function(ex) {
                    blockUI.stop();
                    service.saving = false;
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function hasWebOrMobileAppAccess() {
            return service.contactData.AccessAlloc8WebApp || service.contactData.AccessAlloc8MobileApp;
        }

        function updateContact() {
            service.saving = true;

            if (service.contactData.HasAccount) {
                if (!hasWebOrMobileAppAccess()) {
                    service.contactData.Password = null;
                    service.contactData.HasAccount = false;
                }
            } else {
                service.contactData.HasAccount = hasWebOrMobileAppAccess() && !_.isNil(service.contactData.Password);
            }

            var model = service.contactData.transformToModel();
            contactApi.putContact(model)
                .then(function(resp) {
                    service.saving = false;
                    service.savedContactTypes = service.contactData.ContactTypes;

                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(utils.translate('CONTACTSMODULE.CONTACT_SAVE_MESSAGE'))
                        .position('bottom right')
                        .hideDelay(1500)
                    );

                    service.show_password = !service.contactData.HasAccount;
                    service.hideAccount = !_.isNil(service.contactData.Password)

                    checkAwardOrChalassificationChange(resp.data);
                })
                .catch(function(ex) {
                    service.saving = false;
                    exceptionService.resolve(ex);
                });
        }

        function checkAwardOrChalassificationChange(data) {
            if (!_.isNil(data.awardUpdatedError)) {
                $mdDialog.show({
                        templateUrl: 'app/main/contact/timesheetUpdate/contact-timesheets.html',
                        controller: 'contactTimesheetController as vm',
                        locals: {
                            message: data.awardUpdatedError,
                            Id: service.contactData.id
                        }
                    })
                    .then(function(resp) {
                        if (resp) {
                            service.saving = true;
                            contactApi.updateTimesheets(resp)
                                .then(function() {
                                    service.saving = false;
                                })
                                .catch(function(ex) {
                                    service.saving = false;
                                    exceptionService.resolve(ex);
                                });
                        }
                    });
            } else if(data.hasAwardOverrideUpdate) {
                service.saving = true;
                const resp = {
                    Id: service.contactData.id
                }
                contactApi.updateTimesheets(resp)
                    .then(function() {
                        service.saving = false;
                    })
                    .catch(function(ex) {
                        service.saving = false;
                        exceptionService.resolve(ex);
                    });
            }

        }

        function savePhoto() {
            if (!service.isEditMode) {
                return;
            }

            var model = service.contactData.transformToModel();

            if (identityService.userData.ContactId === service.contactData.id) {
                $timeout(function() {
                    identityService.userData.PhotoUrl = service.contactData.ImageUrl;
                }, 1);
            }

            var apiPromise = contactApi.putContact(model)
                .then(function(resp) {})
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });

            return apiPromise;
        }

        function loadCustomFields(cid) {
            return contactApi.getContact(cid);
        }

        function loadData(cid) {
            $timeout(function() {
                service.isEditMode = true;
                service.Divisions = [];
                service.contactData.Branches2 = [];
                service.contactData.Branches = [];
                service.contactData.Division = [];

                contactApi.getContact(cid)
                    .then(loadDataCompleted)
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            });
        }

        function loadDataCompleted(resp) {
            if (resp) {
                service.isEditMode = true;
                service.contactData.map({
                    id: resp.id,
                    Addresses: resp.Addresses,
                    CommunicationMethod: resp.CommunicationMethod,
                    Companies: resp.Companies,
                    ContactId: resp.ContactId,
                    ContactTitle: resp.ContactTitle,
                    PreferredName: resp.PreferredName,
                    DateOfBirth: resp.DateOfBirth,
                    FirstName: resp.FirstName,
                    ImageUrl: resp.ImageUrl,
                    IsInActive: !resp.IsActive,
                    IsArchived: resp.IsArchived,
                    MinimumHours: resp.MinimumHours,
                    HasAccount: resp.HasAccount,
                    EmploymentStatus: resp.EmploymentStatus,
                    LastName: resp.LastName,
                    EmployeeCode: resp.EmployeeCode,
                    MiddleName: resp.MiddleName,
                    ResourceNotes: resp.ResourceNotes,
                    Emails: resp.Emails,
                    Phones: resp.Phones,
                    Position: resp.Position,
                    PayrollGroupId: resp.PayrollGroupId,
                    PersonalSkills: resp.PersonalSkills,
                    PayrollAllowances: resp.PayrollAllowances,
                    CustomFields: resp.CustomFields,
                    ContactTypes: resp.ContactTypes,
                    ContactsPreferences: resp.ContactsPreferences,
                    AwardClassification: resp.AwardClassification,
                    Award: resp.Award,
                    IsAllocatable: resp.IsAllocatable,
                    PrimaryBranch: resp.PrimaryBranch,
                    Gender: resp.Gender,
                    SkillLevel: resp.SkillLevel,
                    WorkforceParticipations: resp.WorkforceParticipations,
                    StartDate: resp.StartDate,
                    IsClassificationCannotBeOverridden: resp.IsClassificationCannotBeOverridden,
                    IsAwardCannotBeOverridden: resp.IsAwardCannotBeOverridden,
                    AccessAlloc8WebApp: resp.AccessWebApp,
                    AccessAlloc8MobileApp: resp.AccessMobileApp,
                    AccessLoginWithAlloc8: resp.AccessLoginWithAlloc8,
                    AccessAlloc8CommApp: resp.AccessCommApp,
                    AccessAlloc8PaperworkApp: resp.AccessPaperworkApp,
                    EmergencyContactName: resp.EmergencyContactName,
                    EmergencyContactPhone: resp.EmergencyContactPhone,
                    EmergencyContactRelationship: resp.EmergencyContactRelationship,
                    MyobEmployee: resp.MyobEmployee,
                    XeroEmployee: resp.XeroEmployee
                });
            }
            if (!service.contactData.PayrollAllowances) {
                service.contactData.PayrollAllowances = [];
            }
            service.contactData.Division = [];
            service.isInit = true;
            service.contactData.Branches2 = resp.Branches;
            service.contactData.PersonalTrainings = [];
            service.savedContactTypes = resp.ContactTypes;

            angular.forEach(resp.PersonalTrainings, function(training) {
                training['Temp_Id'] = utils.newGuid();
                training.CompletedDate = moment.utc(training.CompletedDate).local().format()
                training.ExpiryDate = moment.utc(training.ExpiryDate).local().format()
            });
            angular.extend(service.contactData.PersonalTrainings, resp.PersonalTrainings);

            branchFunc();
            bindPrimaryBranch();
            service.isInit = false;

            angular.forEach(service.contactData.PersonalSkills, function(skill) {
                skill['UniqueId'] = utils.newGuid();
            });

            service.saving = false;

            var stateProvider = $injector.get('$state');

            if (angular.isDefined(stateProvider.params.skillid) && stateProvider.params.skillid !== null) {

                var _skill = _.find(service.contactData.PersonalSkills, function(skill) {
                    return stateProvider.params.skillid === skill.Id;
                });

                if (stateProvider.params.skillid !== null && _skill && typeof service.openSkillDialog === 'function') {
                    service.openSkillDialog(true, _skill, function() {
                        var elmnt = document.getElementById("contact-skills-dialog");
                        elmnt.scrollIntoView();
                    });
                }
            }

            if (angular.isDefined(stateProvider.params.trainingid) && stateProvider.params.trainingid !== null) {
                var _training = _.find(service.contactData.PersonalTrainings, function(training) {
                    return stateProvider.params.trainingid === training.Id;
                });

                if (stateProvider.params.trainingid !== null && _training && typeof contactTrainingService.openTrainingDialog === 'function') {
                    contactTrainingService.openTrainingDialog(true, _training, function() {
                        var elmnt = document.getElementById("contact-training-dialog");
                        elmnt.scrollIntoView();
                    });
                }
            }
        }

        function validateEmployeeCode(code) {
            if (code === undefined) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('CONTACTSMODULE.EMPLOYEE_CODE_VALIDATION_MESSAGE'))
                    .position('bottom right')
                    .hideDelay(5000)
                );
                service.contactData.EmployeeCode = null;
                service.saveDisabled = true;
                return;
            } else {
                var result = /^[A-Za-z]{3}\d{3,4}$/.test(code);
                if (!result) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(utils.translate('CONTACTSMODULE.EMPLOYEE_CODE_VALIDATION_MESSAGE'))
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                    service.contactData.EmployeeCode = null;
                    service.saveDisabled = true;
                } else {
                    contactApi.validateEmployeeCode(code)
                        .then(function(resp) {
                            if (resp.data === "") {

                            } else {
                                if (resp.data !== service.contactData.id) {
                                    $mdToast.show(
                                        $mdToast.simple()
                                        .textContent(utils.translate('CONTACTSMODULE.EMPLOYEE_CODE_EXISTS'))
                                        .position('top right')
                                        .hideDelay(5000)
                                    );
                                    service.contactData.EmployeeCode = null;
                                    service.saveDisabled = true;
                                }
                            }
                        });
                }
            }
        }

        function validateDuplicateContact() {
            service.duplicatedContact = null;
            var email = [];
            var phones = [];

            if (service.contactData.Emails.length > 0) {
                email = _.map(service.contactData.Emails, 'EmailAddress');
            }

            if (service.contactData.Phones.length > 0) {
                phones = _.map(service.contactData.Phones, 'Number');
            }

            var data = {
                FirstName: service.contactData.FirstName,
                LastName: service.contactData.LastName,
                Phones: phones,
                Emails: email
            }

            if (data) {
                if (data.FirstName && data.LastName) {
                    contactApi.validateDuplicateContact(data)
                        .then(function(resp) {
                            service.duplicatedContact = resp.data;
                        });
                }
            }
        }

        function getContactsByPayrollGroupId(payrollGroupId) {
            let deferred = $q.defer();
            
            contactApi.getContactsByPayrollGroupId(payrollGroupId).then(function(result){
                deferred.resolve(result.data);
            }).catch(function (ex){
                exceptionService.resolve(ex);
            });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.contact')
        .factory('contactLookupsService', contactLookupsService);

    function contactLookupsService(
        contactLookupsModel,
        skillsMatrixApi,
        claimsUtilService,
        lookupApi,
        utils,
        workforceApi,
        skillLevelApi,
        contactApi,
        trainingApi,
        exceptionService,
        payrollGroupsApi,
        $q) {

        var service = {
            contactLookupsObj: new contactLookupsModel(),
            lookupFetchCompletedCallback: null,
            defaultEmployer: null,
            fetchContactTypes: fetchContactTypes,
            fetchLookups: fetchLookups
        };

        return service;

        function fetchLookups(allowCache) {
            var deferred = $q.defer();

            $q.all([lookupApi.getContactLookups(allowCache),
                    contactApi.getDefaultEmployer(),
                    skillLevelApi.getSkillsLevel(),
                    workforceApi.get(),
                    trainingApi.getTrainingsGroups(),
                    skillsMatrixApi.getSkillsandChildren(),
                    contactApi.getRules(),
                    payrollGroupsApi.getAll()
                ])
                .then(function(resp) {
                    var obj = resp[0].data;
                    service.contactLookupsObj.map({
                        AddressTypes: obj.AddressTypes,
                        SkillsLookUp: resp[5].data,
                        Branches: obj.Branches,
                        CommunicationMethods: obj.CommunicationMethods,
                        Companies: obj.Companies,
                        ContactNumberTypes: obj.ContactNumberTypes,
                        ContactTitles: obj.ContactTitles,
                        ContactTypes: obj.ContactTypes,
                        PhoneTypes: obj.PhoneTypes,
                        Trainings: resp[4].data,
                        Rules: resp[6].data.filter(function(rule) {
                            return rule.IsEnabled
                        }),
                        PayrollGroups: resp[7].data
                    });

                    let isAltusSpecialEnabled = claimsUtilService.isAltusSpecialEnabled();

                    angular.forEach(angular.copy(service.contactLookupsObj.Branches), function(branch) {
                        angular.forEach(branch.Division, function(division) {
                            service.contactLookupsObj.Divisions.push({
                                id: division.id,
                                Name: division.Name,
                                BranchId: branch.id,
                                BranchName: branch.Name
                            })
                        });
                    });

                    service.contactLookupsObj.Branches2 = angular.copy(service.contactLookupsObj.Branches);

                    angular.forEach(service.contactLookupsObj.Branches, function(branch) {
                        branch['Id'] = branch.id;
                        delete branch.Division;
                    });

                    service.contactLookupsObj.Awards = obj.Award;
                    service.contactLookupsObj.AwardClassifications = obj.AwardClassification;
                    service.defaultEmployer = resp[1].data[0];
                    service.contactLookupsObj.SkillsLevel = resp[2].data;
                    service.contactLookupsObj.Workforce = resp[3].data.sort(function(a, b) {
                        return b.Name - a.Name
                    });

                    service.contactLookupsObj.Gender = [{
                            Value: 0,
                            Display: utils.translate("CONTACTSMODULE.GENDER_MALE")
                        },
                        {
                            Value: 1,
                            Display: utils.translate("CONTACTSMODULE.GENDER_FEMALE")
                        },
                        {
                            Value: 2,
                            Display: utils.translate("CONTACTSMODULE.GENDER_NOT_SPECIFIED")
                        }
                    ];

                    service.contactLookupsObj.EmploymentStatus = [{
                            Id: 0,
                            Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_NONE")
                        },
                        {
                            Id: 1,
                            Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_CASUAL")
                        },
                        {
                            Id: 3,
                            Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_PERMANENT_FULL_TIME")
                        },
                        {
                            Id: 4,
                            Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_PERMANENT_PART_TIME")
                        },
                        {
                            Id: 5,
                            Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_SALARY")
                        }
                    ];

                    if (isAltusSpecialEnabled) {
                        service.contactLookupsObj.EmploymentStatus.push({
                            Id: 2,
                            Name: utils.translate("CONTACTSMODULE.EMPLOYMENT_STATUS_LABOUR_HIRE")
                        })
                    }

                    deferred.resolve(service.contactLookupsObj);
                    (service.lookupFetchCompletedCallback || angular.noop)('contactLookupsObj');
                }, function(ex) {
                    deferred.reject(ex);
                    exceptionService.resolve(ex);
                });
            return deferred.promise;
        }

        function fetchContactTypes() {
            var deferred = $q.defer();

            lookupApi
                .getContactTypes()
                .then(function(resp) {
                    deferred.resolve(resp.data);
                })
                .catch(function() {
                    deferred.reject(ex);
                    exceptionService.resolve(ex);
                });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.contact')
        .factory('contactClaimsService', contactClaimsService);

    /** @ngInject */
    function contactClaimsService(
        $rootScope,
        identityService) {

        var service = {
            onSaveClaimsValidate: onSaveClaimsValidate
        };

        activate();

        return service;

        function activate() {
            $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                applyClaimsRules();
            });

            applyClaimsRules();
        }

        function applyClaimsRules() {
        }

        /**
         * @description For Save Button claims/rules
         */
        function onSaveClaimsValidate(ident, claimsServ) {
            return true;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.company.create')
        .service('contactRulesModel', contactRulesModel);

    function contactRulesModel() {
        return [
            {
                Id : 0,
                FieldName : "Award",
                FieldRuleName : "Award",
                FieldType : "single-select",
                IsRequired : false,
                Pattern : null,
                WrongPatternMessage : null,
                Model : "service.contactData.Award",
                LookupModel : "awards",
                Lookup : [],
                BackEndModel : "Award.Name"
            },
            {
                Id : 1,
                FieldName : "Classifications",
                FieldRuleName : "AwardClassification",
                FieldType : "single-select",
                IsRequired : false,
                Pattern : null,
                WrongPatternMessage : null,
                Model : "service.contactData.AwardClassification",
                LookupModel : "classifications",
                Lookup : [],
                BackEndModel : "AwardClassification.Name"
            },
            {
                Id : 2,
                FieldName : "Contact Types",
                FieldRuleName : "ContactTypes",
                FieldType : "multi-select",
                IsRequired : false,
                Pattern : null,
                WrongPatternMessage : null,
                Model : 'service.contactData.ContactTypes',
                LookupModel : "service.Contacts",
                Lookup : [],
                BackEndModel : "ContactTypes.TypeName"
            },
            {
                Id : 3,
                FieldName : "Employee Code",
                FieldRuleName : "EmployeeCode",
                FieldType : "text",
                IsRequired : false,
                Pattern : null,
                WrongPatternMessage : null,
                Model : "service.contactData.EmployeeCode",
                LookupModel : null,
                BackEndModel : "EmployeeCode"
            },
            {
                Id : 4,
                FieldName : "Employment Status",
                FieldRuleName : "EmploymentStatus",
                FieldType : "single-select",
                IsRequired : false,
                Pattern : null,
                WrongPatternMessage : null,
                Model : "service.contactData.EmploymentStatus",
                LookupModel : "employment_status_lookup",
                Lookup : [],
                BackEndModel : "EmploymentStatus"
            }
        ]
    }
})();

(function () {
    'use strict';

    angular.module('app.contact.create')
        .service('contactViewFilterModel', contactViewFilterModel);

    function contactViewFilterModel(utils) {
        return function () {
            var self = this,
                defaults = {
                    contactType: null,
                    isActive: null,
                    isArchive: null,
                    filterType: null,
                    startDate: null,
                    endDate: null
                };

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = toBackendModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults;
                var opts = angular.extend(this, defaults, mapValue);
            }

            function reset() {
                self.map(null);
            }

            function toBackendModel() {
                return {
                    ContactTypeId: self.contactType,
                    IsActive: self.isActive,
                    IsArchived: self.isArchive,
                    FilterType: self.filterType,
                    StartDate: self.startDate ? utils.jsDateTime(self.startDate) : self.startDate,
                    EndDate: self.endDate ? utils.jsDateTime(self.endDate) : self.endDate
                };
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.contact.create')
        .service('contactSkillModel', contactSkillModel);

    function contactSkillModel() {
        return function () {
            var self = this
                , defaults = {
                    Skills : null
                ,   id : null
                ,   GroupName : null
            };

            self.map = mapper;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                    , opts = angular.extend(this, defaults, mapValue);
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.contact.create')
        .service('contactLookupsModel', contactLookupsModel);

    /**
     *  Contact Lookups Model
     */
    function contactLookupsModel(_) {
        return function () {
            var self = this
                , defaults = {
                AddressStates: []
                , AddressTypes: []
                , AddressUnitTypes: []
                , Branches: []
                , CommunicationMethods: []
                , Companies: []
                , ContactNumberTypes: []
                , ContactTitles: []
                , ContactTypes: []
                , PhoneTypes: []
                , StreetTypes: []
                , SkillsLookUp: []
                , Awards: []
                , AwardClassifications: []
                , SkillsLevel: []
                , Gender: []
                , Workforce: []
                , Trainings: []
                , Divisions: []
                , Rules: []
                , PayrollGroups: []
            };

            self.map = mapper;
            self.reset = reset;
            self.map();

            function reset() {
                this.map(null);
                clearItem(this.AddressStates);
                clearItem(this.AddressTypes);
                clearItem(this.AddressUnitTypes);
                clearItem(this.Branches);
                clearItem(this.CommunicationMethods);
                clearItem(this.Companies);
                clearItem(this.ContactNumberTypes);
                clearItem(this.ContactTitles);
                clearItem(this.ContactTypes);
                clearItem(this.PhoneTypes);
                clearItem(this.StreetTypes);
                clearItem(this.SkillsLookUp);
                clearItem(this.Awards);
                clearItem(this.AwardClassifications);
                clearItem(this.SkillsLevel);
                clearItem(this.Gender);
                clearItem(this.Workforce);
                clearItem(this.Trainings);
                clearItem(this.Divisions);
                clearItem(this.Rules);
                clearItem(this.PayrollGroups);
            }

            function clearItem(item){
                if(!_.isNil(item)){
                   _.isArray(item) ? item.length = 0 : item = null;
                }
            }

            function mapper(options) {
                var mapValue = options || defaults
                    , opts = angular.extend({}, defaults, mapValue);

                self.AddressStates = opts.AddressStates;
                self.AddressTypes = opts.AddressTypes;
                self.AddressUnitTypes = opts.AddressUnitTypes;
                self.Branches = alasql('select * from ? order by Name', [opts.Branches]);
                self.CommunicationMethods = opts.CommunicationMethods;
                self.Companies = opts.Companies;
                self.ContactNumberTypes = opts.ContactNumberTypes;
                self.ContactTitles = opts.ContactTitles;
                self.ContactTypes = opts.ContactTypes;
                self.PhoneTypes = opts.PhoneTypes;
                self.StreetTypes = opts.StreetTypes;
                self.AwardClassifications = opts.AwardClassification,
                    self.SkillsLookUp = opts.SkillsLookUp;
                self.Awards = opts.Award;
                self.Trainings = opts.Trainings;
                self.Divisions = opts.Divisions;
                self.Rules = opts.Rules;
                self.PayrollGroups = opts.PayrollGroups;
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('app.contact.create')
        .service('contactDataModel', contactDataModel);

    function contactDataModel(utils, _, contactLookupsService) {
        return function(options) {
            var self = this,
                defaults = {
                    id: null,
                    Branches: [],
                    SelectedBranches: [],
                    CommunicationMethod: null,
                    EmployeeCode: null,
                    Companies: [],
                    PersonalSkills: [],
                    ContactTitle: null,
                    ContactTypes: [],
                    PreferredName: null,
                    DateOfBirth: null,
                    Emails: [],
                    Addresses: [],
                    HasAccount: false,
                    Password: null,
                    FirstName: '',
                    ImageUrl: '',
                    IsInActive: false,
                    IsAllocatable: false,
                    IsArchived: false,
                    EmploymentStatus: null,
                    LastName: '',
                    MiddleName: '',
                    Phones: [],
                    Position: '',
                    CustomFields: [],
                    CustomFieldsValues: [],
                    ContactsPreferences: [],
                    Award: null,
                    AwardClassification: null,
                    Branches2: [],
                    Division: [],
                    BranchesCopy: [],
                    PersonalTrainings: [],
                    MinimumHours: null,
                    ResourceNotes: null,
                    PrimaryBranch: null,
                    SkillLevel: null,
                    Gender: null,
                    WorkforceParticipation: null,
                    StartDate: null,
                    IsAwardCannotBeOverridden: false,
                    IsClassificationCannotBeOverridden: false,
                    WorkforceParticipations: [],
                    AccessAlloc8WebApp: false,
                    AccessLoginWithAlloc8: false,
                    AccessAlloc8CommApp: false,
                    AccessAlloc8PaperworkApp: false,
                    AccessAlloc8MobileApp: false,
                    EmergencyContactName: null,
                    EmergencyContactPhone: null,
                    EmergencyContactRelationship: null,
                    MyobEmployee: null,
                    XeroEmployee: null,
                    PayrollGroupId: null
                };
            self.map = mapper;
            self.transformToModel = transformToModel;
            self.reset = reset;

            self.map(options);

            function mapper(opts) {
                var mapValue = opts || {},
                    opts = angular.extend(this, defaults, mapValue);
            }

            function reset() {
                this.map(null);
                this.Emails = [];
                this.Numbers = [];
                this.Phones = [];
                this.Branches = [];
                this.Companies = [];
                this.Branches2 = [];
                this.Addresses = [];
                this.SkillLevel = null;
                this.PersonalTrainings = [];
                this.Division = [];
                this.WorkforceParticipations = [];
                this.ContactsPreferences = [];
                this.PayrollGroupId = null;
            }

            function transformToModel() {
                let branches_copy = angular.copy(self.Branches2);
                let divisions = angular.copy(self.Division);
                let primary_branch = null;

                angular.forEach(branches_copy, function(branch) {
                    branch['Division'] = _.filter(divisions, {
                        BranchId: branch.id || branch.Id
                    });
                });

                if (self.PrimaryBranch) {
                    primary_branch = _.find(contactLookupsService.contactLookupsObj.Branches, {
                        Id: self.PrimaryBranch.BranchId
                    });

                    if (self.PrimaryBranch.IsBranch) {
                        primary_branch['Division'] = [];
                    } else {
                        primary_branch['Division'] = [{
                            id: self.PrimaryBranch.DivisionId,
                            Name: self.PrimaryBranch.DivisionName
                        }];
                    }
                }


                var serverModel = {
                    id: self.id,
                    Addresses: utils.objectSanitize(self.Addresses),
                    Branches: branches_copy,
                    PrimaryBranch: primary_branch,
                    CommunicationMethod: utils.objectSanitize(self.CommunicationMethod),
                    Companies: self.Companies,
                    HasAccount: self.HasAccount,
                    Password: self.Password,
                    PreferredName: self.PreferredName,
                    EmployeeCode: self.EmployeeCode,
                    PersonalSkills: self.PersonalSkills,
                    PayrollAllowances: self.PayrollAllowances,
                    EmploymentStatus: self.EmploymentStatus,
                    ContactId: self.ContactId,
                    ContactTitle: self.ContactTitle,
                    ContactTypes: self.ContactTypes,
                    DateOfBirth: self.DateOfBirth ? utils.jsDateTime(self.DateOfBirth) : null,
                    Emails: angular.fromJson(angular.toJson(self.Emails)),
                    FirstName: self.FirstName,
                    ImageUrl: self.ImageUrl,
                    MinimumHours: self.MinimumHours,
                    IsActive: !self.IsInActive,
                    IsArchived: self.IsArchived,
                    LastName: self.LastName,
                    MiddleName: self.MiddleName,
                    Phones: utils.objectSanitize(self.Phones),
                    Numbers: utils.objectSanitize(self.Numbers),
                    Position: self.Position,
                    CustomFields: self.CustomFields,
                    CustomFieldsValues: self.CustomFieldsValues,
                    AwardClassification: self.AwardClassification,
                    Award: self.Award,
                    ContactsPreferences: self.ContactsPreferences,
                    IsAllocatable: self.IsAllocatable,
                    ResourceNotes: self.ResourceNotes,
                    SkillLevel: self.SkillLevel,
                    Gender: self.Gender,
                    WorkforceParticipation: self.WorkforceParticipation,
                    WorkforceParticipations: self.WorkforceParticipations,
                    StartDate: self.StartDate,
                    IsAwardCannotBeOverridden: self.Award == null ? true : self.IsAwardCannotBeOverridden,
                    IsClassificationCannotBeOverridden: self.IsClassificationCannotBeOverridden,
                    PersonalTrainings: self.PersonalTrainings,
                    AccessWebApp: self.AccessAlloc8WebApp,
                    AccessMobileApp: self.AccessAlloc8MobileApp,
                    AccessLoginWithAlloc8: self.AccessLoginWithAlloc8,
                    AccessCommApp: self.AccessAlloc8CommApp,
                    AccessPaperworkApp: self.AccessAlloc8PaperworkApp,
                    EmergencyContactName: self.EmergencyContactName,
                    EmergencyContactPhone: self.EmergencyContactPhone,
                    EmergencyContactRelationship: self.EmergencyContactRelationship,
                    MyobEmployee: self.MyobEmployee,
                    XeroEmployee: self.XeroEmployee,
                    PayrollGroupId: self.PayrollGroupId
                }
                return serverModel;
            }

        };
    }
})();

(function () {
  'use strict';

  angular.module('app.contact.create')
    .service('contactCompanyModel', contactCompanyModel);

  function contactCompanyModel() {
    return function () {
      var self = this,
        defaults = {
          id: null
          , Company: null
          , Name: null
          , Logo: null
          , ContactType: null
          , Position: null
          , StartDate: undefined
          , EndDate: undefined
          , Branches: []
          , SearchCompanyBranch: ''
        };

      self.map = mapper;
      self.reset = reset;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults;
        var opts = angular.extend(this, defaults, mapValue);
      }

      function reset() {
        self.map(null);
        self.StartDate = new Date();
        self.Branches.length = 0;
      }
    }
  }
})();

/**
 * http://www.alloc8pro.com/
 * Copyright (c) 2016
 * Created on 5/12/2016
 * sangracetiu@gmail.com
 */

(function () {
  'use strict';

  angular.module('app.company.create')
    .service('contactBranchModel', contactBranchModel);

  function contactBranchModel() {
    return function(options){
      defaults = {
        Id : null,
        Name: null,
        State : null,
        Division : [],
        Selected : false
      };

      this.map = mapper;
      this.map(options);

      ///////

      function mapper (optioBag) {
        var clonedDefaults = angular.copy(defaults);
        var optionSrc = optioBag || clonedDefaults;
        var mapValue = angular.extend({}, clonedDefaults, optionSrc);
        angular.extend(this, mapValue);
      }

    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.contact')
    .controller('contactDialogController', contactDialogController);

  /** @ngInject */
  function contactDialogController($mdDialog,
                                   $window,
                                   $location,
                                   data,
                                   showEditLink) {
    let vm = this;
    vm.contact = null;
    vm.showEditLink = showEditLink;

    vm.closeDialog = closeDialog;
    vm.openEditLink = openEditLink;

    function closeDialog(){
      $mdDialog.hide();
    }

    function activate(){
      vm.contact = format(data);
    }

    function openEditLink(){
      let base = $location.absUrl();
      let url  = base.substring(0, base.indexOf('allocate')).trim();
      let finalUrl = url + "contacts/update/" + vm.contact.Id;
      $window.open(finalUrl, '_self');
    }

    function format(data){
      return {
        Id: data.Id,
        Name : data.FirstName + " " + (data.PreferredName ? "(" + data.PreferredName + ") " : " ") + data.LastName,
        ImageUrl : data.ImageUrl,
        Birthday : data.DateOfBirth ? moment(data.DateOfBirth).format('MMMM DD, YYYY') : null,
        Addresses : data.Addresses,
        Phones : data.Phones,
        EmployeeCode : data.EmployeeCode,
        EmploymentStatus : data.EmploymentStatus,
        Branches : data.Branches,
        ContactTypes : data.ContactTypes,
        Emails : data.Emails,
        AwardClassification : data.AwardClassification,
        IsEmployee : data.IsEmployee,
        StartDate : data.StartDate
      }
    }

    activate();
  }
})();

(function () {
  'use strict';

  angular.module('app.contact.create')
    .service('contactLookupsService', function () {
      var obj = {};
      return {
        setLookups: function (param) {
          obj = param;
        },
        getContactTitle: function () {
          return obj.ContactTitles;
        }
        , getPhoneTypes: function () {
          return obj.PhoneTypes;
        }
        , getAddressTypes: function () {
          return obj.AddressTypes;
        }
        , getAddressUnitTypes: function () {
          return obj.AddressUnitTypes;
        }
        , getStreetTypes: function () {
          return obj.StreetTypes;
        }
        , getAddressStates: function () {
          return obj.AddressStates;
        }
        , getContactTypes: function () {
          return obj.ContactTypes;
        }
        , getCompanyList: function () {
          return obj.Companies;
        }
      }
    })
    .service('emailService', function () {
      var emailData = [];
      return {
        setEmailData: function (obj) {
          // to remove '$$hashKey' attribute which is automatically
          // added by angular, convert and parse
          if (obj.EmaiAddress)
            emailData = JSON.parse(angular.toJson(obj));
        }
        , getEmailData: function () {
          return emailData;
        }
      }
    })
    .service('contactService', function () {
      var contactData = {
        "Title": '',
        "FirstName": '',
        "MiddleName": '',
        "LastName": '',
        "ImageUrl": '',
        "DataOfBirth": '',
        "IsActive": false,
        "IsArchived": false,
        "Companies": '',
        "Branches": [],
        "Numbers": [],
        "CommMethod": ''
      };

      return {
        getContactData: function () {
          return contactData;
        }
        , setContactData: function (prop) {
          contactData = prop;
        }
        , setTitle: function (prop) {
          contactData.Title = prop;
        }
        , setFirstName: function (prop) {
          contactData.FirstName = prop;
        }
        , setMiddleName: function (prop) {
          contactData.MiddleName = prop;
        }
        , setLastName: function (prop) {
          contactData.LastName = prop;
        }
        , setDoB: function (prop) {
          contactData.DateOfBirth = prop;
        }
        , setCompanyData: function (prop) {
          contactData.Companies = prop;
        }
        , setIsActive: function (prop) {
          contactData.IsActive = prop;
        }
        , setImageUrl: function (prop) {
          contactData.ImageUrl = prop;
        }
        , getImageUrl: function () {
          return contactData.ImageUrl;
        }
        , setNumbers: function (prop) {
          contactData.Numbers = prop;
        }
        , getNumbers: function () {
          return contactData.Numbers;
        }
        , setCommMethod: function (prop) {
          contactData.CommMethod = prop;
        }
        , setBranches: function (prop) {
          contactData.Branches = prop;
        }
      }
    })
    .service('mobileService', function () {
      var mobileData = [];
      return {
        setMobileData: function (obj) {
          if (obj.Number)
            mobileData = JSON.parse(angular.toJson(obj));
        }
        , getMobileData: function () {
          return mobileData;
        }
      }
    })
    .service('addressService', function (validateFactory) {
      var addressString
        , address = [{}]
        , addressData = [];
      return {
        getAddress: function () {
          return address;
        }
        , getAddressObj: function () {
          return addressData;
        }
        , setAddressProperties: function (obj) {
          addressData = obj;
          if (!(obj === undefined)) {
            address = validateFactory.isNotEmpty(obj.UnitNumber) + ' '
              + validateFactory.isNotEmpty(obj.StreetNumber) + ' '
              + validateFactory.isNotEmpty(obj.StreetName) + ' '
              + validateFactory.isNotEmpty(obj.StreetTypeId);
          }
        }
      };
    });


})();

(function() {
    'use strict';

    angular.module('app.contact.create')
        .controller('ContactCreateController', ContactCreateController);

    /** @ngInject */
    function ContactCreateController(
        $stateParams,
        contactService,
        claimsUtilService,
        blockUI,
        contactApi,
        tenantsApi,
        identityService,
        contactClaimsService,
        $mdDialog,
        $scope,
        $rootScope,
        utils,
        $timeout,
        contactLookupsService,
        adminClaimsService,
        exceptionService,
        _,
        tenantSettings,
        integrationsService,
        businessesService,
        CONTACT_TYPES,
        CONTACT_ROLES) {

        //Data
        var vm = this;
        vm.service = contactService;
        vm.service.saveDisabled = true;
        vm.Contacts = contactLookupsService.contactLookupsObj.ContactTypes;
        vm.commMethods = contactLookupsService.contactLookupsObj.CommunicationMethods;
        vm.headerTitle = null;
        vm.isProcessing = false;
        vm.showFields = true;
        vm.customFields = [];
        vm.uploadUrl = tenantSettings.coreApiUrl + "api/contacts/uploadimage";
        vm.ContactTitles = contactLookupsService.contactLookupsObj.ContactTitles;
        vm.awards = contactLookupsService.contactLookupsObj.Awards;
        vm.classifications = contactLookupsService.contactLookupsObj.AwardClassifications;
        vm.skillsLevel = contactLookupsService.contactLookupsObj.SkillsLevel;
        vm.Gender = contactLookupsService.contactLookupsObj.Gender;
        vm.Workforce = contactLookupsService.contactLookupsObj.Workforce;
        vm.CustomisedFieldsBackUp = [];
        vm.service.Contacts = _.orderBy(contactLookupsService.contactLookupsObj.ContactTypes, ['TypeName'], ['asc']);
        vm.onSaveClaimsValidate = contactClaimsService.onSaveClaimsValidate;
        vm.showProgress = false;
        vm.userContactId = identityService.userData.ContactId;
        vm.utilService = utils;
        vm.fetchedSkills = contactLookupsService.contactLookupsObj.Skills;
        vm.contactLookupsService = contactLookupsService;
        vm.show_employee_fields = false;
        vm.claimsUtilService = claimsUtilService;
        vm.adminClaimsService = adminClaimsService;
        vm.hasArchiveEmployeesClaims = adminClaimsService.hasArchiveEmployees;
        vm.showPayrollGroupField = adminClaimsService.isPayrollGroupsEnabled;
        vm.enablePayrollGroupDropdown = adminClaimsService.hasManagePayrollGroupsPermission;
        vm.employment_status_lookup = contactLookupsService.contactLookupsObj.EmploymentStatus;
        vm.isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
        vm.classificationFilter = null;
        vm.isSalaryEmploymentStatus = false;
        vm.isConnectedToMyob = true;
        vm.myobPayrollCompanyEmployeesContainsSetEmployee = true;
        vm.xeroPayrollCompanyEmployeesContainsSetEmployee = true;
        vm.isMyobEmployeeDisabled = true;
        vm.isAltusSpecialEnabled = vm.claimsUtilService.isAltusSpecialEnabled();
        vm.isEmergencyContactFieldsEnabled = claimsUtilService.isEmergencyContactFieldsEnabled();
        vm.isMyobEmployeeAutomatched = true;
        vm.payrollBusinessExists = true;
        vm.isPermanentEmployee = false;
        vm.payrollGroups = contactLookupsService.contactLookupsObj.PayrollGroups;

        // Methods
        vm.onSave = onSave;
        vm.onArchive = onArchive;
        vm.onUploadStart = onUploadStart;
        vm.onUploadSuccess = onUploadSuccess;
        vm.onUploadValidate = onUploadValidate;
        vm.onUploadError = onUploadError;
        vm.activate = activate;
        vm.changeFields = changeFields;
        vm.onCreateLoginChanged = onCreateLoginChanged;
        vm.evaluate = evaluate;
        vm.disableContactType = disableContactType;
        vm.canSelectContactType = canSelectContactType;
        vm.showPayrollFields = roleValidator;
        vm.hasEmployeeLabourHireType = hasEmployeeLabourHireType;
        vm.validateAccountRelatedBoxes = validateAccountRelatedBoxes;
        vm.passwordPlaceholder = passwordPlaceholder;
        vm.isAwardAndClassificationSettingsEnabled = isAwardAndClassificationSettingsEnabled;
        vm.isCreateButtonEnabled = isCreateButtonEnabled;
        vm.employmentStatusChange = employmentStatusChange;
        vm.populateMyobPayrollEmployeesDropdown = populateMyobPayrollEmployeesDropdown;
        vm.populateXeroPayrollEmployeesDropdown = populateXeroPayrollEmployeesDropdown;
        vm.searchMyobEmployeeByName = searchMyobEmployeeByName;
        vm.selectMyobEmployee = selectMyobEmployee;
        vm.searchXeroEmployeeByName = searchXeroEmployeeByName;
        vm.selectXeroEmployee = selectXeroEmployee;
        vm.formatMyobEmployeeName = formatMyobEmployeeName;
        vm.formatXeroEmployeeName = formatXeroEmployeeName;
        vm.redirectToIntegrationsPage = redirectToIntegrationsPage;
        vm.redirectToBusinessesPage = redirectToBusinessesPage;

        vm.isMyobEnabled = claimsUtilService.isMyobEnabled();
        vm.isXeroEnabled = claimsUtilService.isXeroEnabled();
        vm.isIntegrationsEnabled = vm.isMyobEnabled || vm.isXeroEnabled;
        vm.isMyobEmployeeDisabled = true;
        vm.isXeroEmployeeDisabled = true;
        vm.isExternalAuthenticationEnabled = isExternalAuthenticationEnabled;
        vm.activate();

        function redirectToIntegrationsPage() {
            $rootScope.state.go('app.integrations');
        }

        function redirectToBusinessesPage() {
            $rootScope.state.go('app.businesses');
        }

        function searchMyobEmployeeByName(query) {
            if (!query) return vm.myobEmployees;

            query = query.toLowerCase();
            let filteredEmployees = vm.myobEmployees.filter(c =>
                c.EmployeeFirstName.toLowerCase().includes(query) ||
                c.EmployeeLastName.toLowerCase().includes(query) ||
                c.EmployeeId.toLowerCase().includes(query) ||
                `${c.EmployeeFirstName} ${c.EmployeeLastName} (${c.EmployeeDisplayId})`.toLowerCase().includes(query));
            return filteredEmployees;
        }

        function searchXeroEmployeeByName(query) {
            if (!query) return vm.xeroEmployees;

            query = query.toLowerCase();
            let filteredEmployees = vm.xeroEmployees.filter(c =>
                c.EmployeeFirstName.toLowerCase().includes(query) ||
                c.EmployeeLastName.toLowerCase().includes(query) ||
                c.EmployeeId.toLowerCase().includes(query) ||
                `${c.EmployeeFirstName} ${c.EmployeeLastName} (${c.EmployeeDisplayId})`.toLowerCase().includes(query));
            return filteredEmployees;
        }

        function selectMyobEmployee(item) {
            if (item) {
                if (item.EmployeeFirstName !== vm.service.contactData.FirstName ||
                    item.EmployeeLastName !== vm.service.contactData.LastName) {
                    vm.isMyobEmployeeAutomatched = false;
                }
                vm.service.contactData.MyobEmployee = item;
                vm.myobPayrollCompanyEmployeesContainsSetEmployee = true;
            } else {
                vm.service.contactData.MyobEmployee = null;
                vm.isMyobEmployeeAutomatched = false;
            }
        }

        function selectXeroEmployee(item) {
            if (item) {
                if (item.EmployeeFirstName !== vm.service.contactData.FirstName ||
                    item.EmployeeLastName !== vm.service.contactData.LastName) {
                    vm.isXeroEmployeeAutomatched = false;
                }
                vm.service.contactData.XeroEmployee = item;
                vm.xeroPayrollCompanyEmployeesContainsSetEmployee = true;
            } else {
                vm.service.contactData.XeroEmployee = null;
                vm.isXeroEmployeeAutomatched = false;
            }
        }

        function passwordPlaceholder() {
            if (vm.service.contactData.Emails.length === 0) {
                return "Password (Please add a primary email address)";
            } else {
                return "Password";
            }
        }

        function roleValidator() {
            let role_create_labour_hire = vm.isAltusSpecialEnabled && vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.CREATE_LABOUR_HIRE);
            let role_create_employee = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.CREATE_EMPLOYEE);
            let role_manage_employee = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.MANAGE_EMPLOYEE);
            let role_manage_payroll = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.PAYROLL) || vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.MANAGE_EMPLOYEE_PAYROLL);;

            if (vm.editMode) {
                if ((role_manage_payroll && role_manage_employee) && (vm.hasEmployeeType || vm.hasLabourType)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (vm.hasEmployeeType || vm.hasLabourType) {
                    if (role_create_labour_hire || role_create_employee) {
                        return true;
                    } else {
                        if (role_manage_payroll || role_manage_employee) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } else {
                    return false;
                }
            }
        }

        function manageEmployeevalidator() {
            let role_create_labour_hire = vm.isAltusSpecialEnabled && vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.CREATE_LABOUR_HIRE);
            let role_create_employee = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.CREATE_EMPLOYEE);
            let role_manage_employee = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.MANAGE_EMPLOYEE);
            vm.show_employee_fields = false;

            if (vm.editMode) {
                if (vm.hasEmployeeType || vm.hasLabourType) {
                    if (role_manage_employee) {
                        vm.show_employee_fields = true;
                    }
                }
            } else {
                if ((vm.hasEmployeeType || vm.hasLabourType) && (role_manage_employee || role_create_labour_hire || role_create_employee)) {
                    vm.show_employee_fields = true;
                }
            }
        }

        function clearPassword() {
            vm.service.contactData.Password = null;
        }

        function validateAccountRelatedBoxes() {
            //is one of the account boolean props 'true'
            return vm.service.contactData.AccessAlloc8WebApp || vm.service.contactData.AccessAlloc8MobileApp;
        }

        function onCreateLoginChanged() {
            clearPassword();

            if (vm.showPasswordField() && vm.service.contactData.Emails.length === 0) {
                vm.service.show_password = false;
                var alert = $mdDialog.alert()
                    .title(utils.translate('CONTACTSMODULE.ACCOUNT_EMAIL'))
                    .textContent(utils.translate('CONTACTSMODULE.ACCOUNT_MESSAGE_CONTENT'))
                    .ok(utils.translate('CONTACTSMODULE.ACCOUNT_CLOSE'));
                $mdDialog
                    .show(alert);
            } else {
                let primary_email = _.find(vm.service.contactData.Emails, {
                    IsPrimary: true
                });
                let email_add = primary_email.EmailAddress;
                let pattern = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
                let email_add_valid = pattern.test(email_add);
                if (!email_add_valid) {
                    vm.service.show_password = false;
                    var alert = $mdDialog.alert()
                        .title(utils.translate('CONTACTSMODULE.ACCOUNT_EMAIL'))
                        .textContent(utils.translate('CONTACTSMODULE.INVALID_EMAIL'))
                        .ok(utils.translate('CONTACTSMODULE.ACCOUNT_CLOSE'));
                    $mdDialog
                        .show(alert);
                }
            }
        }

        vm.showPasswordField = function() {
            return !vm.service.contactData.HasAccount && vm.validateAccountRelatedBoxes() && vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.MANAGE_LOGIN_ACCOUNT);
        };

        function evaluate() {
            if (vm.hasEmployeeType || vm.hasLabourType) {
                let existing_companies = vm.service.contactData.Companies;
                let default_employer_id = contactLookupsService.defaultEmployer.id;
                let default_employer_exists = false;

                angular.forEach(existing_companies, function(company) {
                    if (company.Company.Id == default_employer_id || company.Company.id == default_employer_id) {
                        default_employer_exists = true;
                    }
                });

                if (!default_employer_exists) {
                    let confirm = $mdDialog.confirm()
                        .title(utils.translate('CONTACTSMODULE.ADD_TO_EMPLOYER_TITLE'))
                        .textContent(utils.translate('CONTACTSMODULE.ADD_TO_EMPLOYER_CONTENT') + contactLookupsService.defaultEmployer.Name + '?')
                        .ok(utils.translate('CONTACTSMODULE.ADD_TO_EMPLOYER_OK'))
                        .cancel(utils.translate('CONTACTSMODULE.ADD_TO_EMPLOYER_CANCEL'));

                    $mdDialog.show(confirm).then(function() {
                        $mdDialog.show({
                            parent: angular.element(document.body),
                            locals: {
                                selectedCompany: contactLookupsService.defaultEmployer,
                                editMode: false,
                                index: null,
                                quickOption: true
                            },
                            templateUrl: 'app/main/contact/create/work/company/workInfo-company.html',
                            controller: 'ContactCreateCompanyController as vm'
                        }).then(function(company) {
                            if (company) {
                                if (company.Company.Branches.length > 0) {
                                    vm.service.SelectedBranches = company.Company.Branches;
                                    vm.service.contactData.Branches2 = company.Company.Branches;
                                    vm.service.contactData.Position = _.isNil(company.Position) ? null : company.Position;
                                    vm.service.branchFunc();
                                }
                            }
                        });
                    });
                }
            }
        }

        function hasEmployeeLabourHireType() {
            return vm.hasEmployeeType || vm.hasLabourType;
        }

        function changeFields() {
            vm.hasEmployeeType = _.find(vm.service.contactData.ContactTypes, {
                TypeName: "Employee"
            }) ? true : false;
            vm.hasLabourType = _.find(vm.service.contactData.ContactTypes, {
                TypeName: "Labour Hire"
            }) ? true : false;
            vm.hasClientType = _.find(vm.service.contactData.ContactTypes, {
                TypeName: "Client"
            }) ? true : false;
            vm.hasExternalType = _.find(vm.service.contactData.ContactTypes, {
                TypeName: "External"
            }) ? true : false;

            if (!vm.editMode && vm.hasEmployeeType && !vm.service.contactData.StartDate) {
                vm.service.contactData.StartDate = new Date();
            }
            roleValidator();
            manageEmployeevalidator();
        }

        function disableContactType(type) {
            let role_create_labour_hire = vm.isAltusSpecialEnabled && vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.CREATE_LABOUR_HIRE);
            let role_create_employee = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.CREATE_EMPLOYEE);
            let role_manage_employee = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.MANAGE_EMPLOYEE);
            let edit_mode = vm.editMode;
            let has_client = _.find(vm.service.contactData.ContactTypes, {
                TypeName: "Client"
            });
            let has_employee = _.find(vm.service.contactData.ContactTypes, {
                TypeName: "Employee"
            });
            let has_labour_hire = _.find(vm.service.contactData.ContactTypes, {
                TypeName: "Labour Hire"
            });

            if (type.id === 1) {
                if (has_client) {
                    return true;
                } else {
                    return !((!edit_mode && role_create_employee || (edit_mode && (role_create_employee || role_manage_employee))));
                }
            } else if (type.id === 3) {
                if (has_client) {
                    return true;
                } else {
                    return !(role_create_labour_hire);
                }
            } else if (type.id === 2) {
                if (has_employee || has_labour_hire) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }

        function canSelectContactType(type) {
            var { id } = type;
            if (id === CONTACT_TYPES.EMPLOYEE) {
                let role_create_employee = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.CREATE_EMPLOYEE);
                let role_manage_employee = vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.MANAGE_EMPLOYEE);
                let edit_mode = vm.editMode;
                return (!edit_mode && role_create_employee) || (edit_mode && role_manage_employee);
            } else if(id === CONTACT_TYPES.LABOURHIRE) {
                let role_create_labour_hire = vm.isAltusSpecialEnabled && vm.claimsUtilService.checkAccessByRole(CONTACT_ROLES.CREATE_LABOUR_HIRE);
                return role_create_labour_hire;
            }
            return true;
        }

        function activate() {
            //Company fetch
            contactService.show_password = false;
            contactService.resetData();

            tenantsApi.getGeneralSettings().then(function(resp) {
                tenantSettings = resp.data;
                vm.isAllowLoginWithAlloc8EnabledForAllUsers = tenantSettings.AllowLoginWithAlloc8ForAllUsers == null? 'false': tenantSettings.AllowLoginWithAlloc8ForAllUsers.toLowerCase();
            });

            $timeout(function() {
                if ($stateParams.company) {
                    let company = _.find(contactLookupsService.contactLookupsObj.Companies, {
                        id: $stateParams.company.Id
                    });
                    contactService.contactData.Companies.push({
                        Company: company
                    });
                }
                contactService.Divisions = [];
                contactService.SelectedBranches = [];
                contactService.getContactBasicLookup();
                if (angular.isDefined($stateParams.cid)) {
                    vm.headerTitle = 'CONTACTSMODULE.HEADER_TITLE_EDIT';
                    vm.btnSaveCaption = 'CONTACTSMODULE.BUTTON_EDIT';
                    vm.title = "Update A Contact - " + $stateParams.cname;
                    vm.editMode = true;
                    contactService.isEditMode = true;
                    blockUI.start('Loading Contact...');
                    contactService.reset();
                } else {
                    vm.headerTitle = 'CONTACTSMODULE.HEADER_TITLE';
                    vm.btnSaveCaption = 'CONTACTSMODULE.SAVE';
                    vm.title = "Create A New Contact";
                    contactService.isEditMode = false;
                    vm.editMode = false;
                }

                contactApi.getContactBundled($stateParams.cid || "").then(function(resp) {
                    blockUI.stop();
                    if ($stateParams.cid) {
                        vm.service.loadDataCompleted(resp.data.m_Item1);
                        if (vm.service.contactData.HasAccount && vm.editMode) {
                            vm.service.hideAccount = true;
                        }

                        vm.hasEmployeeType = _.find(vm.service.contactData.ContactTypes, {
                            TypeName: "Employee"
                        }) ? true : false;
                        vm.hasLabourType = _.find(vm.service.contactData.ContactTypes, {
                            TypeName: "Labour Hire"
                        }) ? true : false;
                        vm.hasClientType = _.find(vm.service.contactData.ContactTypes, {
                            TypeName: "Client"
                        }) ? true : false;
                        vm.hasExternalType = _.find(vm.service.contactData.ContactTypes, {
                            TypeName: "External"
                        }) ? true : false;

                        $timeout(function() {
                            manageEmployeevalidator();
                        });
                    }
                    vm.service.customisedFields = resp.data.m_Item2;
                    vm.employmentStatusChange();

                }).catch(function() {
                    blockUI.stop();
                });
            });

            if (vm.isIntegrationsEnabled && vm.adminClaimsService.hasRunPayrollPermission) {
                vm.myobEmployees = [vm.service.contactData.MyobEmployee];
                vm.xeroEmployees = [vm.service.contactData.XeroEmployee];

                integrationsService.getProviders()
                    .then(resp => {
                        vm.isConnectedToMyob = resp.isConnectedToMyob;
                        vm.isConnectedToXero = resp.isConnectedToXero;

                        if(vm.isConnectedToMyob  || vm.isConnectedToXero){
                            return integrationsService.getEmployees();
                        }
                    })
                    .then(resp => {

                        if(resp && resp.data){
                            populateMyobPayrollEmployeesDropdown(resp.data);
                            populateXeroPayrollEmployeesDropdown(resp.data);
                        }
                    }).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });

                businessesService.getPayrollCompany()
                    .then(resp => {
                        if (_.isEmpty(resp.data)) {
                            vm.payrollBusinessExists = false;
                        }
                    })
            }
        }

        function populateMyobPayrollEmployeesDropdown(employees) {
            vm.myobEmployees = employees.filter(e => e.ProviderType.toLowerCase() === 'myob');

            if (vm.myobEmployees.length === 0) {
                return;
            }

            vm.isMyobEmployeeDisabled = false;

            let myobEmployeeAlreadySet = vm.service.contactData.MyobEmployee && vm.service.contactData.MyobEmployee.EmployeeDisplayId;
            if (myobEmployeeAlreadySet) {
                vm.myobPayrollCompanyEmployeesContainsSetEmployee = vm.myobEmployees.some(e => e.EmployeeDisplayId === vm.service.contactData.MyobEmployee.EmployeeDisplayId);
                if (!vm.myobPayrollCompanyEmployeesContainsSetEmployee) {
                    vm.myobEmployees.push(vm.service.contactData.MyobEmployee);
                }
            } else {
                let matchingMyobEmployee = vm.myobEmployees.find(myobEmp => {
                    let matchingFirstName = (myobEmp.EmployeeFirstName.toLowerCase() === vm.service.contactData.FirstName.toLowerCase());
                    let matchingLastName = (myobEmp.EmployeeLastName.toLowerCase() === vm.service.contactData.LastName.toLowerCase());
                    return (matchingFirstName && matchingLastName);
                });

                if (matchingMyobEmployee) {
                    vm.service.contactData.MyobEmployee = matchingMyobEmployee;

                    vm.myobAutomatchMessage = utils.translate('CONTACTSMODULE.INSTRUCTIONS.EMPLOYEE_FOUND_VIA_AUTOMATCH')
                        .replace('{Employee}', formatMyobEmployeeName(matchingMyobEmployee));
                    vm.isMyobEmployeeAutomatched = true;
                }
            }
        }

        function populateXeroPayrollEmployeesDropdown(employees) {
            vm.xeroEmployees = employees.filter(e => e.ProviderType.toLowerCase() === 'xero');

            if (vm.xeroEmployees.length === 0) {
                return;
            }

            vm.isXeroEmployeeDisabled = false;

            let xeroEmployeeAlreadySet = vm.service.contactData.XeroEmployee && vm.service.contactData.XeroEmployee.EmployeeId;
            if (xeroEmployeeAlreadySet) {
                vm.xeroPayrollCompanyEmployeesContainsSetEmployee = vm.xeroEmployees.some(e => e.EmployeeId === vm.service.contactData.XeroEmployee.EmployeeId);
                if (!vm.xeroPayrollCompanyEmployeesContainsSetEmployee) {
                    vm.xeroEmployees.push(vm.service.contactData.XeroEmployee);
                }
            } else {
                let matchingXeroEmployee = vm.xeroEmployees.find(xeroEmp => {
                    let matchingFirstName = (xeroEmp.EmployeeFirstName.toLowerCase() === vm.service.contactData.FirstName.toLowerCase());
                    let matchingLastName = (xeroEmp.EmployeeLastName.toLowerCase() === vm.service.contactData.LastName.toLowerCase());
                    return (matchingFirstName && matchingLastName);
                });

                if (matchingXeroEmployee) {
                    vm.service.contactData.XeroEmployee = matchingXeroEmployee;

                    vm.xeroAutomatchMessage = utils.translate('CONTACTSMODULE.INSTRUCTIONS.EMPLOYEE_FOUND_VIA_AUTOMATCH')
                        .replace('{Employee}', formatXeroEmployeeName(matchingXeroEmployee));
                    vm.isXeroEmployeeAutomatched = true;
                }
            }
        }

        function formatMyobEmployeeName(employee) {
            if (!employee) return;

            return `${employee.EmployeeFirstName} ${employee.EmployeeLastName} (${employee.EmployeeDisplayId})`;
        }

        function formatXeroEmployeeName(employee) {
            if (!employee) return;

            return `${employee.EmployeeFirstName} ${employee.EmployeeLastName}`;
        }

        function onSave(behavior, currntForm) {
            contactService.save_message = "Saving ...";
            contactService.saveTrigger = !contactService.saveTrigger;
            $timeout(function() {
                currntForm.$setPristine();
                if (contactService.isEditMode) {
                    contactService.updateContact();
                } else {
                    contactService.behavior = behavior;
                    contactService.saveContact();
                }
            });
        }

        function onArchive() {
            vm.service.archive(!vm.service.contactData.IsArchived);
        }

        function onUploadStart() {
            vm.showProgress = true;
            contactService.disableSaving = true;
        }

        function onUploadSuccess(url) {
            contactService.contactData.ImageUrl = url;
            vm.showProgress = false;
            contactService.disableSaving = false;
            contactService.savePhoto();
        }

        function onUploadError(ex) {
            exceptionService.resolve(ex);
        }

        function onUploadValidate(fileObj) {
            var ext = utils.getFileExtension(fileObj.name);
            var isValid = true;

            if (ext != '.jpeg' && ext != '.jpg' && ext != '.png' && ext != '.gif') {
                isValid = false;
                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(utils.translate('CONTACTSMODULE.UPLOAD_INVALID_FILE_TITLE'))
                    .content(utils.translate('CONTACTSMODULE.UPLOAD_INVALID_FILE_CONTENT'))
                    .ok(utils.translate('CONTACTSMODULE.UPLOAD_INVALID_FILE_OK'))

                $mdDialog.show(notif);
            }
            return isValid;
        }

        function isAwardAndClassificationSettingsEnabled() {
            let isEnabledForSalaryEmployee = !vm.isSalaryEmploymentStatus || (vm.isSalaryEmploymentStatus && vm.isAltusSpecialEnabled);
            return vm.claimsUtilService.isPayrollEnabled() &&
                vm.hasEmployeeLabourHireType() &&
                isEnabledForSalaryEmployee;
        }

        function isCreateButtonEnabled() {
            return $scope.contactForm.$valid;
        }

        function employmentStatusChange() {
            vm.isPermanentEmployee = false;

            let salaryEmploymentStatus = vm.employment_status_lookup.find(status => status.Name === "Salary");
            vm.isSalaryEmploymentStatus = salaryEmploymentStatus && vm.service.contactData.EmploymentStatus === salaryEmploymentStatus.Id;

            let permanentEmploymentStatuses = vm.employment_status_lookup.filter(status => status.Name === "Permanent Full Time" || status.Name === "Permanent Part Time");
            var permanentEmploymentStatus = permanentEmploymentStatuses.find(status => vm.service.contactData.EmploymentStatus === status.Id);

            if (permanentEmploymentStatus) {
                vm.isPermanentEmployee = true;
            } else {
                vm.service.contactData.MinimumHours = 0;
            }
        }

        const DEFAULT_EXTERNAL_AUTHENTICATOR = 'none';

        function isExternalAuthenticationEnabled() {
            var isExternalAuthEnabled = !(tenantSettings.ExternalAuthenticator && tenantSettings.ExternalAuthenticator.toLowerCase() === DEFAULT_EXTERNAL_AUTHENTICATOR);
            return isExternalAuthEnabled;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.contact.calendar')
        .controller('contactCalendarController', contactCalendarController);

    /** @ngInject */
    function contactCalendarController($mdDialog, $document, contactApi, blockUI, $stateParams, localisationService, exceptionService, ToastService, contactCalendarModel, uiCalendarConfig, TimeLibrary, calendarEntryStatus, adminClaimsService, historyLogService) {
        var vm = this;

        // Data
        vm.EntryType = [];
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        vm.events = [];
        vm.calendarSettingEntry = null;
        vm.contactId = [];
        vm.adminClaimsService = adminClaimsService;

        // Methods
        function onViewRender(view) {
            vm.calendarView = view;
            vm.calendar = vm.calendarView.calendar;
            vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        }


        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;
        vm.gotoDate = gotoDate;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next() {
            vm.calendarView.calendar.next();
            vm.currentViewYear = vm.calendar.getDate().format('YYYY');
            var currentYear = moment(moment().endOf("year")).format('YYYY');
            if (parseInt(currentYear) < parseInt(vm.currentViewYear)) {
                getContactCalendar();
            }
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev() {
            vm.calendarView.calendar.prev();
            vm.currentViewYear = vm.calendar.getDate().format('YYYY');
            var currentYear = moment(moment().endOf("year")).format('YYYY');
            if (parseInt(currentYear) > parseInt(vm.currentViewYear)) {
                getContactCalendar();
            }
        }

        function gotoDate(_date) {
            vm.calendarView.calendar.gotoDate(_date);
            vm.currentViewYear = vm.calendar.getDate().format('YYYY');
            var currentYear = moment(moment().endOf("year")).format('YYYY');
            getContactCalendar();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e) {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e) {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e) {
            showEventFormDialog('add', false, null, null, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e) {
            $mdDialog.show({
                controller: 'EventDetailDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/contact/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    calendarEvent: calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event: e,
                    adminClaimsService: adminClaimsService,
                    historyLogService: historyLogService
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e) {
            var dialogData = {
                isContact: true,
                type: type,
                calendarEvent: calendarEvent,
                start: start,
                end: end
            };
            var dialogLookUp = {
                EntryType: vm.EntryType,
                RepeatType: vm.RepeatType
            }

            $mdDialog.show({
                controller: 'EventFormDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/contact/calendar/dialogs/event-form/event-form-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData,
                    dialogLookUp: dialogLookUp
                }
            }).then(function(response) {
                if (response.type === 'add') {
                    // Add new
                    blockUI.start();
                    var contactCalendar = new contactCalendarModel();
                    var calendarEntry = {
                        EntryType: response.calendarEvent.EntryType,
                        EntryReason: response.calendarEvent.EntryReason,
                        start: response.calendarEvent.start,
                        startTime: TimeLibrary.convertToServerTime(response.calendarEvent.startTime),
                        end: response.calendarEvent.end,
                        endTime: TimeLibrary.convertToServerTime(response.calendarEvent.endTime),
                        repeat: response.calendarEvent.Repeats,
                        IsAllDayEvent: response.IsAllDayEvent,
                        contactId: vm.contactId,
                        Remarks: response.calendarEvent.Remarks,
                    }
                    contactCalendar.map(calendarEntry);
                    var transformContactCalendar = contactCalendar.transformToServerModel();

                    contactApi.saveContactCalendar(transformContactCalendar).then(function() {
                        ToastService.toast("Calendar Event Created");
                        getContactCalendar();
                    }).catch(function(e) {
                        blockUI.stop();
                        exceptionService.resolve(e);
                        //ToastService.toast(e.message != undefined ? e.message : e.Message);
                    });
                } else if (response.type === 'delete') {
                    blockUI.start();
                    contactApi.deleteContactCalendar(response.calendarEvent.ParentId).then(function() {
                        ToastService.toast("Event Deleted");
                        getContactCalendar();
                    }).catch(function(e) {
                        blockUI.stop();
                        exceptionService.resolve(e);
                    });
                } else {
                    updateEvent(response);
                }
            });
        }

        function getValuebyId(id) {
            var entryType = _.find(vm.EntryType, function(o) {
                return o.Id == id
            });
            if (entryType) {
                return entryType.Value;
            }
        }

        function activate() {
            blockUI.start();
            var localeFormatSettings = localisationService.getLocaleFormatSettings();
            vm.calendarUiConfig = {
                calendar: {
                    editable: false,
                    eventLimit: true,
                    header: '',
                    handleWindowResize: false,
                    aspectRatio: 1,
                    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    viewRender: onViewRender,
                    timezone: "local",
                    nextDayThreshold: "00:00:00",
                    eventRender: function(event, element, view) {
                        if (event._recurring) {
                            return (event.ranges.filter(function(range) {
                                return (moment(event.start).isBefore(range.end) &&
                                    moment(event.end).isAfter(range.start));
                            }).length) > 0;
                        }
                    },
                    columnFormat: {
                        month: 'ddd',
                        week: 'ddd D',
                        day: 'ddd M'
                    },
                    eventClick: eventDetail,
                    selectable: true,
                    selectHelper: true,
                    select: select,
                    firstDay: localeFormatSettings.firstDayOfWeek
                }
            };

            vm.contactId.push($stateParams.Id);
            vm.Name = validateAndAddApostrophe($stateParams.Name);

            contactApi.getEntryType().then(function(resp) {
                vm.EntryType = resp.data;
                contactApi.getRepeatType().then(function(resp) {
                    vm.RepeatType = resp.data;
                    getContactCalendar();
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                    blockUI.stop();
                });
            }).catch(function(ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }

        function getContactCalendar() {
            return contactApi.getContactCalendarById(vm.contactId, vm.currentViewYear).then(function(resp) {

                var response = angular.copy(resp.data);

                angular.forEach(response, function(item) {
                    item.title = getValuebyId(item.CalendarEntryType);
                });

                var contactCalendar = new contactCalendarModel();
                var eventData = [];

                // Filter out pending and rejected unavailability entries
                var excludedEntryIds = _.filter(response.CalendarEntries, function(e) {
                    return e.Status === calendarEntryStatus.PENDING || e.Status === calendarEntryStatus.REJECTED;
                }).map(function(e) { return e.Id; });

                response.CalendarEntries = _.filter(response.CalendarEntries, function(e) {
                    return e.Status !== calendarEntryStatus.PENDING && e.Status !== calendarEntryStatus.REJECTED;
                });

                response.Events = _.filter(response.Events, function(e) {
                    return excludedEntryIds.indexOf(e.CalendarEntryId) === -1;
                });

                var badData = _.filter(response.CalendarEntries, function(e) {
                    if (e.Repeats) {
                        return e.Repeats.RepeatType != 1 && e.Repeats.RepeatEvery === 0;
                    }

                    if (e.IsAllDayEvent) {
                        return e.Repeats != null;
                    }
                });

                angular.forEach(response.Events, function(e) {
                    contactCalendar.map(e);
                    var event = contactCalendar.transformData(contactCalendar, response.CalendarEntries);
                    eventData.push(event);
                });

                if (badData.length > 0) {
                    _.forEach(badData, function(bData) {
                        _.remove(eventData, function(eData) {
                            return bData.Id === eData.ParentId;
                        });
                    });
                }

                vm.events.splice(0);
                vm.events.push(eventData);
                // }
                blockUI.stop();
            }).catch(function(ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }

        function validateAndAddApostrophe(Name) {
            var splitName = Name.split(" ");
            var LastName = splitName[1];
            if (LastName.endsWith("s")) {
                return Name + "' ";
            } else {
                return Name + "'s ";
            }
        }

        function updateEvent(response) {
            var contactCalendar = new contactCalendarModel();
            var calendarEntry = {
                EntryType: response.calendarEvent.EntryType,
                EntryReason: response.calendarEvent.EntryReason,
                start: response.calendarEvent.start,
                startTime: TimeLibrary.convertToServerTime(response.calendarEvent.startTime),
                end: response.calendarEvent.end,
                endTime: TimeLibrary.convertToServerTime(response.calendarEvent.endTime),
                repeat: response.calendarEvent.Repeats,
                contactId: vm.contactId,
                Id: response.calendarEvent.ParentId,
                IsAllDayEvent: response.IsAllDayEvent,
                Remarks: response.calendarEvent.Remarks
            }
            contactCalendar.map(calendarEntry);
            var transformContactCalendar = contactCalendar.transformToServerModel();

            return contactApi.updateContactCalendar(transformContactCalendar).then(function() {
                ToastService.toast("Event Updated");
                getContactCalendar();
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
            });
        }

        activate();
    }

})();
/**
 * Cost Estimate Viewer Controller
 * Created date: 12.12.2016
 */
(function() {
    'use strict';

    angular
        .module('app.costEstimate.view')
        .controller('CeListViewController', CeListViewController);

    /** @ngInject */
    function CeListViewController(
        $mdDialog,
        blockUI,
        ceFilterService,
        $state,
        searchDelay,
        ceReportGridService,
        costEstimateApi,
        exceptionService,
        historyLogService,
        auditApi,
        ceStateService
    ) {
        var vm = this;

        // Data
        vm.model = ceFilterService;
        vm.dataGrid = ceReportGridService;
        vm.delay = {
            debounce: searchDelay
        };
        vm.noAccess = false;
        vm.noPOAccess = false;

        // Methods
        vm.previewCostEstimates = previewCostEstimates;
        vm.downloadPdfLink = downloadPdfLink;
        vm.cancelCostEstimate = cancelCostEstimate;
        vm.viewHistory = viewHistory;
        vm.getStatus = getStatus;

        activate();

        function activate() {
            vm.dataGrid.filterData = ceFilterService.data.toBackendModel();
        }

        function previewCostEstimates(groupId) {
            $state.go('app.cost_estimate_preview', {
                ceGrpId: groupId,
                viewCancelled: ceFilterService.data.cancelledCostEstimate ? 1 : 0
            });
        }

        function downloadPdfLink(groupId, index) {
            ceReportGridService.grid.data[index].IsPdfGenerating = true;

            blockUI.start('Preparing to download...');

            costEstimateApi.generateCostEstimatePdfByGroupId(groupId).then(function(resp) {
                blockUI.stop();
            }).catch(function(ex) {
                exceptionService.resolve(ex);
                blockUI.stop();
            });
        }

        function cancelCostEstimate(groupId, companyName) {
            let confirm = $mdDialog.confirm()
                .title('Cancel Cost Estimate')
                .htmlContent('Are you sure you want to cancel cost estimate for <b>' + companyName + '</b>?')
                .ariaLabel('Cancel cost estimates')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                blockUI.start('Cancelling Cost Estimate for ' + companyName);
                costEstimateApi.cancelCostEstimateGroup(groupId)
                    .then(function(resp) {
                        blockUI.stop();
                        ceReportGridService.grid.behavior.refresh();
                    }).catch(function(ex) {
                        blockUI.stop();
                        exceptionService.resolve(ex);
                    });
            }, function() {
                // cancel
            });
        }

        async function viewHistory(id, companyName) {
            blockUI.start('Loading History Logs...');
            var resp = await auditApi.getAuditEntries(id);

            blockUI.stop();
            historyLogService.showHistory("Cost Estimate", resp.data, "(" + companyName + ")");
        }

        function getStatus(status) {
            return ceStateService.getStatusColor(status);
        }
    }
})();
(function () {
    'use strict';
  
    angular.module('app.costEstimate')
      .factory('ceClaimsService', ceClaimsService);
      
      /** @ngInject */
      function ceClaimsService($rootScope, $log, identityService, claimsUtilService) {
          var service = {
            hasPreviewMenu: false,
            hasCreateInvoiceMenu: false,
            hasExportInvoiceMenu: false
          };
          
          activate();
          
          return service;
          
          /////// 
          
          function activate() {
              // Triggered by SignalR
            //   $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
            //       applyClaimsRules();
            //   });
  
            //   applyClaimsRules();   
          }
  
          function applyClaimsRules() {
            //   service.hasPreviewMenu =  claimsUtilService.checkAccessByRole('Preview Invoice');
            //   service.hasCreateInvoiceMenu = claimsUtilService.checkAccessByRole('Create an Invoice');
            //   service.hasExportInvoiceMenu = claimsUtilService.checkAccessByRole('Export Viewer');
          }
       
      }
  })();
/**
 * Invoice lookup service
 *
 * Rcnet 2.20.2017
 */
(function () {
    'use strict';

    angular.module('app.costEstimate')
        .service('ceLookupService', ceLookupService);

    /** @ngInject */
    function ceLookupService($log,
        $q,
        utils,
        exceptionService,
        costEstimateApi,
        termsApi,
        branchApi,
        invoiceApi) {

        var service = {
            data: {
                branchLookups: [],
                branchSimpleLookups: [],
                clientLookups: [],
                termLookups: [],
                rateCardLookups: []
            },
            loadBranches: loadBranches,
            loadBranchesSimple: loadBranchesSimple,
            loadClients: loadClients,
            loadAll: loadAll,
            reloadRateCards: loadRateCards,
            findBranches: findBranches,
            findClient: findClient,
            loadTerms: loadTerms,
            isLoaded: false
        };

        activate();

        return service;

        ///////
        function activate() { }

        function loadAll() {
            if (!service.isLoaded) {

                let promise1 = loadBranches();
                let promise2 = loadClients();
                let promise3 = loadTerms();
                let promise4 = loadRateCards();
                //let promise5 = loadBranchesSimple();

                service.isLoaded = true;
                return $q.all([promise1, promise2, promise3, promise4]);
            }
            else {
                return $q.when("Lookup already loaded");
            }
        }

        function loadBranchesSimple() {
            let deferred = $q.defer();

            branchApi.getBranches()
                .then(function (resp) {
                    service.data.branchSimpleLookups.length = 0;
                    angular.forEach(resp.data, function(itm) {
                        service.data.branchSimpleLookups.push(itm);
                    });
                    deferred.resolve(service.data.branchSimpleLookups);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadRateCards() {
            let deferred = $q.defer();

            costEstimateApi.getRateCards()
                .then(function (resp) {
                    service.data.rateCardLookups.length = 0;
                    angular.forEach(resp.data, function (itm) {
                        service.data.rateCardLookups.push(itm);
                    }, this);

                    deferred.resolve(service.data.rateCardLookups);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadBranches() {
            let deferred = $q.defer();

            // Load branches
            branchApi.getBranchesAndStates()
                .then(function (resp) {
                    service.data.branchLookups.length = 0;
                    angular.forEach(resp.data, function (itm) {
                        itm['selected'] = false;
                        itm.StateBranches = [];
                        if (itm.State == null) {
                            itm.StateBranches = itm.Id.split(',');
                            itm.Id = utils.newGuid();
                        }
                        service.data.branchLookups.push(itm);
                    }, this);

                    deferred.resolve(service.data.branchLookups);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadTerms() {
            let deferred = $q.defer();

            // Load branches
            termsApi.getTerms()
                .then(function (resp) {
                    service.data.termLookups = resp.data;
                    deferred.resolve(service.data.termLookups);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function loadClients() {
            let deferred = $q.defer();

            invoiceApi.getClients()
                .then(function (resp) {
                    service.data.clientLookups.length = 0;
                    angular.forEach(resp.data, function (itm) {
                        service.data.clientLookups.push(itm);
                    }, this);

                    deferred.resolve(service.data.clientLookups);
                }).catch(function (ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function findBranches(branches) {
            let branchStr = getSelectedBranchesToString(branches);
            let qry = "SELECT * FROM ? WHERE Id IN " + "(?)".replace('?', branchStr);

            let results = alasql(qry, [service.data.branchLookups]);
            return results;
        }

        function getSelectedBranchesToString(branches) {
            let branchStr = '';
            angular.forEach(branches, function (itm) {
                branchStr = branchStr + "'" + itm + "',";
            }, this);

            return branchStr.substring(0, branchStr.length - 1);
        }

        function findClient(clients) {
            let clientStr = getSelectedClientToString(clients);
            let qry = "SELECT * FROM ? WHERE Id IN " + "(?)".replace('?', clientStr);

            let results = alasql(qry, [service.data.clientLookups]);
            return results;
        }

        function getSelectedClientToString(clients) {
            let clientStr = '';
            angular.forEach(clients, function (itm) {
                clientStr = clientStr + "'" + itm + "',";
            }, this);

            return clientStr.substring(0, clientStr.length - 1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.costEstimate.preview')
        .controller('CostEstimatePreviewController', CostEstimatePreviewController);

    /** @ngInject */
    function CostEstimatePreviewController(
        $scope,
        $stateParams,
        blockUI,
        ceManagerService,
        ceSideNavService,
        searchDelay,
        $timeout,
        $mdSidenav,
        ceLookupService,
        exceptionService
    ) {
        var vm = this;

        // Data
        vm.model = ceManagerService;
        vm.sidenavModel = ceSideNavService;
        vm.isDeleteDisabled = false;
        vm.delay = {
            debounce: searchDelay
        };

        // Methods
        vm.generatePreview = generatePreview;
        vm.showDetails = showDetails;
        vm.clearPreview = clearPreview;
        vm.deletePreview = deletePreview;
        vm.setInvoiceDate = setInvoiceDate;
        vm.toggleSidenav = toggleSidenav;

        activate();

        function activate() {
            // CE group id (parent CE)
            let costEstimateGroupId = $stateParams.ceGrpId;

            // When set to TRUE the preview mode is in cancel mode preview, meaning we are viewing a cancelled CE.
            // Note: cancelled CE is on readonly mode.
            ceManagerService.isInPreviewCancelled = $stateParams.viewCancelled;

            blockUI.start('Loading Cost Estimates');
            ceLookupService.reloadRateCards()
                .finally(function() {
                    blockUI.stop();
                });

            // Check costEstimateGroupId here if null then prompt error msg
            ceManagerService.onReady = function() {
                ceSideNavService.loadSingleInvoicePreview(null);
                ceSideNavService.isOverrideInvoiceDate = false;
                ceSideNavService.onRefreshContent = onRefreshContent;
                ceSideNavService.refreshUI = refreshUi;
                generatePreview(costEstimateGroupId);
                pageLoad();
            }
        }

        function pageLoad() {
            // Setup navigation service
            ceSideNavService.setup();
        }

        /**
         * Trigger report generation in the server
         */
        function generatePreview(id) {
            // If id is passed then its coming from Create Job screen
            if (id) {
                ceSideNavService.loadSingleInvoicePreview(id);
                ceSideNavService.setMessageTo('downloading');
                ceManagerService.grid.api.refresh();
            } else {
                // Will regenerate from the server based on the rate card selected.
                ceManagerService.clearContent();
                ceManagerService.contentLoading = true;
                ceSideNavService.regenerateCostEstimate($stateParams.ceGrpId).then(function(resp) {
                    onRefreshContent();
                }).catch(function(ex) {
                    exceptionService.resolve(ex, {
                        intercept500: function(e) {
                            return {
                                notifyVia: 'dialog'
                            };
                        }
                    });
                });
            }
        }

        function refreshUi() {
            $scope.$apply();
        }

        function onRefreshContent() {
            $timeout(function() {
                ceManagerService.refreshGrid();
            }, 100);
        }

        function showDetails() {
            ceManagerService.showDetails = ceSideNavService.data.showDetails;
        }

        function clearPreview() {
            ceSideNavService.clearPreview()
                .then(function(resp) {
                    ceManagerService.clearContent();
                });
        }

        function deletePreview() {}

        function setInvoiceDate() {
            ceSideNavService.isOverrideInvoiceDate = true;
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.company.view')
    .controller('CompanyViewController', CompanyViewController);

  /** @ngInject */
  function CompanyViewController($mdDialog,
                                 claimsUtilService,
                                 utils,
                                 $scope,
                                 companyService,
                                 companyViewService,
                                 companyViewGridService,
                                 companyViewGridAdapterService,
                                 searchDelay) {
    var vm = this;

    // Data
    vm.maxDate = new Date();
    vm.service = companyService;
    vm.companyViewService = companyViewService;
    vm.checkAccessService = claimsUtilService;
    vm.searchBox = null;
    vm.utilService = utils;
    vm.dataGrid = companyViewGridService;
    vm.delay = { debounce: searchDelay };

    // Methods
    vm.viewDatesFilter = viewDatesFilter;
    vm.filterCompanies = filterCompanies;
    vm.resetFilter = resetFilter;

    activate();

    $scope.$on('$destroy', function(){
        vm.dataGrid.grid.data.length = 0;
    });

    function activate(){
    }

    function filterCompanies() {
      repopulateGrid(false);
    }

    function viewDatesFilter() {
      $mdDialog.show({
        templateUrl: 'app/main/company/view/templates/dates.html',
        controller: 'CompanyDatesController as vm'
      }).then(function (resp) {
        if(resp){
          repopulateGrid(false);
        }
      });
    }

    function resetFilter() {
      companyViewGridAdapterService.ignoreCaching();
      companyViewService.resetFilter();
      repopulateGrid(true);
    }

    function repopulateGrid(noFilter) {
      companyViewGridAdapterService.ignoreCaching();
      companyViewGridService.setFilterData(noFilter ? null : companyViewService.filterModel.toBackendModel());
      companyViewGridService.grid.behavior.refresh();
    }

  }
})();

/**
 * Company View
 * SignalR service Message Listener
 *
 */
(function () {
    'use strict';

    angular.module('app.company')
        .service('companyViewSignalrHubService', companyViewSignalrHubService);

    /** @ngInject */
    function companyViewSignalrHubService($mdToast,
        $log,
        signalRService,
        $rootScope,
        $timeout,
        blockUI,
        exceptionService,
        companyViewGridService,
        companyViewCacheService,
        claimsUtilService,
        companyViewService
    ) {

        const TOASTR_DELAY = 5000;

        var service = {
            register: register
        };

        var isInitialized = false; // To prevent double subscription to event

        return service;

        ///////
        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register() {
            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function () {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }
        }

        function regs() {

            // Download feedback
            signalRService.messageHub.on('syncCompanyView', function (data) {
                if (claimsUtilService.hasBranchAccess(data.BranchIds)) {
                    let dataFixed = companyViewService.fixData(data.Data, true);
                    companyViewCacheService.updateCache(data.UpdateType,dataFixed);
                    companyViewGridService.updateGridData(data.UpdateType, dataFixed);
                }
            });
        }

    };
})();
/**
 * Company View data adapter service
 *
 * Rcnet 10.17.2017
 */
(function () {
    'use strict';

    angular.module('app.company')
        .service('companyViewGridAdapterService', companyViewGridAdapterService);

    /** @ngInject */
    function companyViewGridAdapterService($log,
        $q,
        exceptionService,
        a8WebApiNoChunkDataProvider,
        companyViewService,
        companyViewCacheService
    ) {

        var service = {
            onChunkReceived: angular.noop, // Client wiring outbound (callback to grid)
            onDownloadCompleted: angular.noop, // Client wiring outbound (callback to grid)
            onErrorDownloading: angular.noop, // (callback to grid)
            onGetData: onGetData, // inbound event (called by grid client)
            onCacheData: onCacheData, // inbound event
            ignoreCaching: ignoreCaching
        };

        // Create data provider
        var dbSource = a8WebApiNoChunkDataProvider.getInstance();
        var ignoreCache = false;

        activate();

        return service;
        ///////

        function activate() {
            // Db hub
            dbSource.onDownloadCompleted = onDownloadCompleted;
            dbSource.onChunkReceived = onChunkReceived;
            dbSource.onErrorDownloading = onErrorDownloading;
        }

        function onDownloadCompleted(data, sender) {
            service.onDownloadCompleted(data, sender);
        }

        function onChunkReceived(data, sender) {
            service.onChunkReceived(data, sender);
        }

        function onErrorDownloading(data, sender) {
            service.onErrorDownloading(data, sender);
        }

        /**
         * Generic interface for fetching data from db source or client side cache
         */
        function onGetData(params) {
            var dataToCache = [];

            if (!params) {
                // No filtering
                if (!companyViewCacheService.isDataExist() || ignoreCache) {
                    ignoreCache = false;
                    return dbSource.fetch(function () {
                        return companyViewService.getCompanies();
                    });
                } else {
                    return dbSource.fetch(function () {
                        return $q.when({ data: companyViewCacheService.getCache().data });
                    });
                }
            } else {
                if (ignoreCache) {
                    ignoreCache = false;
                    // Filter data from server
                    return dbSource.fetch(function () {
                        return companyViewService.filterCompanies(params);
                    });
                } else {
                    // Return cache filtered data
                    return dbSource.fetch(function () {
                        return $q.when({ data: companyViewCacheService.getCache().data });
                    });
                }
            }
        }

        /**
         * Event for implementing Caching of data
         * @param {*} data 
         */
        function onCacheData(data) {
            if (data != null)
            companyViewCacheService.addCache(data);
        }

        function ignoreCaching() {
            ignoreCache = true;
        }

    }
})();
/**
 * CompanyView Grid
 *
 * 10.17.2017
 */
(function () {
    'use strict';

    angular.module('app.company')
        .service('companyViewGridService', companyViewGridService);

    /** @ngInject */
    function companyViewGridService($log,
        $q,
        $rootScope,
        exceptionService,
        companyViewGridAdapterService,
        $timeout
    ) {
        var service = {
            grid: {},
            filterData: null,
            setFilterData: setFilterData,
            componentEvent: angular.noop,
            updateGridData: updateGridData,
            searchText: null
        };

        service.grid.behavior = {};
        service.grid.data = []; // View model for grid data
        service.grid.onCompleted = onCompleted;
        service.grid.onError = onError;
        service.grid.onInit = onInit;
        service.grid.onDataFilter = onDataFilter;
        service.grid.onDataLoading = onDataLoading;
        service.grid.onDataLoadingCompleted = onDataLoadingCompleted;
        service.grid.onSearch = onSearch;

        activate();

        return service;

        ///////
        function activate() { }

        // Set data provider here
        function onInit() {
            service.grid.data.length = 0;
            service.grid.behavior.setHubSourceAdapter(companyViewGridAdapterService);
        }

        /**
         * Loading of partial data
         * Perform view model data shaping here
         */
        function onCompleted(data) {
            service.grid.data.length = 0;

            angular.forEach(data, function (itm) {
                service.grid.data.push(itm);
            });
        }

        /**
         * Fires when grid needs to refresh data
         */
        function onDataFilter() {
            return service.filterData;
        }

        function setFilterData(filter) {
            service.filterData = filter;
        }

        function onDataLoading(extraData) {
            //service.componentEvent({ e: 'onGridInfoPopulated', data: service.gridInfo, extraData: extraData });
        }

        function onSearch(value) {
            //service.componentEvent({ e: 'onSearch' });
            service.grid.behavior.search(value);
        }

        /**
         * Fires when downloading or loading of full dataset is finish
         */
        function onDataLoadingCompleted() {
            // service.componentEvent({ e: 'loadcompleted' });
            // service.componentEvent({ e: 'onGridInfoPopulated', data: service.gridInfo });
        }

        function onError(ex) {
            exceptionService.resolve(ex);
        }

        /**
         * =====================================
         * Update Grid Data (Contact array)
         * =====================================
         */
        function updateGridData(updateType, data) {
            if (!service.grid) return;

            switch (updateType) {
                case 2:
                    updateCompany(data);
                    break;
                case 1:
                    insertCompany(data);
                    break;
                case 3:
                    archiveCompany(data);
                    break;
            }
        }

        function updateCompany(data) {
            var updatedData = data;
            if (!service.grid.behavior) return;
            if (!service.grid.behavior.hasOwnProperty('updateState')) return;

            service.grid.behavior.updateState(function (o) { return o.Id === data.Id; }, function (items) {
                if (items.length <= 0) return;
                var contact = items[0];

                updateCompanyEntity(contact, updatedData);
                // $timeout(function () {
                // });
            }, true);
        }

        function updateCompanyEntity(contact, updatedData) {
            contact.Name = updatedData.Name;
            contact.IsActive = updatedData.IsActive;
            contact.CompanyCode = updatedData.CompanyCode;
            contact.Branches = updatedData.Branches;
            contact.CompanyTypes = updatedData.CompanyTypes;
        }

        function insertCompany(data) {
            $timeout(function () {
                (service.grid.behavior.pushToState || angular.noop)(data);
            });
        }

        function archiveCompany(data) {
            $timeout(function () {
                (service.grid.behavior.removeToState || angular.noop)(function (o) { return o.Id === data.Id; });
            });
        }

    }
})();


/**
 * Company View Cache Service
 *
 * Rcnet 10.17.2017
 */
(function () {
    'use strict';

    angular.module('app.contact')
        .service('companyViewCacheService', companyViewCacheService);

    /** @ngInject */
    function companyViewCacheService($log,
        $q,
        _,
        exceptionService,
        dataCacheService2
    ) {

        var service = {
            isDataExist: isDataExist,
            addCache: addCache,
            getCache: getCache,
            updateCache: updateCache
        };

        var cacheObj = dataCacheService2.getInstance();

        const MAX_CACHE_ITEMS = 1;
        const CACHE_GROUP_KEY = 'companyViewData';
        const CACHE_KEY = 'urn:companyViewData:companyViewCache';

        activate();

        return service;
        ///////

        function activate() {
            // 15 MINUTES to evict/expire cache for company view (fair enough huh?)
            cacheObj.group(CACHE_GROUP_KEY, { capacity: MAX_CACHE_ITEMS, maxAge: 900 * 1000, deleteOnExpire: 'aggressive' });
        }

        function isDataExist() {
            return cacheObj.getCache(CACHE_KEY) != null;
        }

        function addCache(data) {
            cacheObj.updateCache(CACHE_KEY, { data: data });
        }

        function getCache() {
            return cacheObj.getCache(CACHE_KEY);
        }

        function updateCache(updateType, data) {
            if (!isDataExist()) return;

            switch (updateType) {
                case 2:
                    updateCompany(data);
                    break;
                case 1:
                    insertCompany(data);
                    break;
                case 3:
                    archiveCompany(data);
                    break;
            }
        }

        function updateCompany(data) {
            var cache = getCache().data;

            _.remove(cache, function (o) {
                return o.Id === data.Id;
            });

            cache.push(data);
        }

        function insertCompany(data) {
            var cache = getCache().data;
            cache.push(data);
        }

        function archiveCompany(data) {
            var cache = getCache().data;

            _.remove(cache, function (o) {
                return o.Id === data.Id;
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.company')
        .factory('companyViewService', companyViewService);

    /** @ngInject */
    function companyViewService(
        $log,
        $mdToast,
        $mdDialog,
        $timeout,
        utils,
        blockUI,
        $translate,
        $q,
        companyApi,
        AuditLogService,
        exceptionService,
        companyViewFilterModel,
        _) {

        var service = {
            filterModel: new companyViewFilterModel(),
            getCompanies: getCompanies,
            filterCompanies: filterCompanies,
            getDefaultFilterParamsBackend: getDefaultFilterParamsBackend,
            resetFilter: resetFilter,
            fixData: fixData
        };

        activate();

        return service;

        ///////
        function activate() { }

        function getCompanies() {
            var deferred = $q.defer();

            companyApi.getCompanies().then(function (resp) {
                var transformedData = transformData(resp.data);
                deferred.resolve({ data: transformedData });
            }).catch(function () {
                deferred.reject(ex);
            });

            return deferred.promise;
        }

        // Note: need to implement default sorting in the alloc8 grid
        function sortCompanies(companies) {
            return alasql('select * from ? order by Name', [companies]);
        }

        function getDefaultFilterParamsBackend() {
            var filterData = {
                CompanyTypeId: null,
                IsActive: null,
                IsArchived: null,
                FilterType: null,
                StartDate: null,
                EndDate: null
            }
        }

        function filterCompanies(filterData) {
            var deferred = $q.defer();

            companyApi.filterCompany(filterData.filters).then(function (resp) {
                var transformedData = transformData(resp.data);
                deferred.resolve({ data: transformedData });
            }).catch(function (err) {
                deferred.reject(err);
                //service.showDialog("Companies", "There was an error while filtering the companies");
            })

            return deferred.promise;
        }

        function resetFilter() {
            service.filterModel.reset();
        }

        function transformData(data) {
            let companies = data;
            angular.forEach(companies, function (company) {
                fixData(company, false);
            });

            //return sortCompanies(companies);
            return companies;
        }

        /**
         * Performs data transformation/formatting 
         * @param {*} company 
         * @param {*} fixTupleIssue - Pass TRUE if you want to fix Tuple issue (issue with tuple when backend pass List of Object with Tuple against Object with Tuple)
         * Difference in m_Item1 (wrapped in List) and Item1 (single object only)
         */
        function fixData(company, fixTupleIssue) {
            let temporaryBranches = company.Branches;
            company.Branches = [];
            company['Divisions'] = [];

            angular.forEach(temporaryBranches, function (branch) {
                company.Branches.push(fixTupleIssue ? branch.Item1 : branch.m_Item1);
                angular.forEach(fixTupleIssue ? branch.Item2 : branch.m_Item2, function (division) {
                    company.Divisions.push(division);
                });
            });

            if (company.Branches.length > 3) {
                company.Branches = company.Branches.slice(0, 3);
                company.Branches.sort();
                company.Branches[3] = "...";
            }

            if (company.Divisions.length > 2) {
                company.Divisions = company.Divisions.slice(0, 2);
                company.Divisions.sort();
                company.Divisions[2] = "...";
            }

            if (company.CompanyTypes.length > 3) {
                company.CompanyTypes = company.CompanyTypes.slice(0, 3);
                company.CompanyTypes.sort();
                company.CompanyTypes[3] = "...";
            }

            return company;
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.company')
        .factory('companyService', companyService);

    /** @ngInject */
    function companyService($q,
        $log,
        $rootScope,
        $mdToast,
        $injector,
        $mdDialog,
        exceptionService,
        utils,
        $state,
        companyApi,
        _,
        companyInfoModel,
        lookupApi,
        tenantsApi,
        claimsUtilService,
        dataCacheService,
        blockUI,
        companyLookupService,
        historyLogService,
        commentService) {

        var cacheObj = dataCacheService.getInstance();

        var service = {
            companyInfoData: new companyInfoModel(),
            behavior: null,
            query: null,
            companyTypeList: [],
            isEditMode: false,
            disableSaving: false,
            customisedFields: null,
            saveDisabled: false,
            isClient: false,
            formattedSkills: [],
            companyType: null,
            rateCards: companyLookupService.rateCards,
            filterTye: null,
            startDate: null,
            endDate: null,
            isActive: true,
            isArchive: false,
            loader: false,
            companies: [],
            companyTypes: [],
            loaderMessage: null,
            minified_contacts: [],
            duplicatedCompany: [],
            can_archive: claimsUtilService.checkAccessByRole("Archive Client Companies"),
            is_employer: false,
            is_client: false,
            show_archive_button: false,
            init: false,
            saveTrigger: false,
            resetData: resetData,
            archive: archive,
            linkedFormTemplates: null,
            unlinkedFormTemplates: null,
            overriddenFormTemplates: null,
            formTemplatesListApi: {},
            generalSettings: {},
            signalSubmitCompany: signalCompany,
            setImageUrl: setImageUrl,
            triggerUIValidation: triggerUIValidation,
            loadData: loadData,
            loadCustomFields: loadCustomFields,
            savePhoto: savePhoto,
            saveCompany: saveCompany,
            formatData: formatData,
            validateCode: validateCode,
            getDivisions: getDivisions,
            viewDatesFilter: viewDatesFilter,
            filterCompanies: filterCompanies,
            loadCompanyTypes: loadCompanyTypes,
            activate: activate,
            resetFilters: resetFilters,
            showDialog: showDialog,
            redirectToCompanyView: redirectToCompanyView,
            showCompanyDetails: showCompanyDetails,
            showCompanyHistory: showCompanyHistory,
            viewComments: viewComments,
            getCompanies: getCompanies,
            onCreate: onCreate,
            onEdit: onEdit,
            addContact: addContact,
            validateDuplicateCompany: validateDuplicateCompany,
            getMinifiedContacts: getMinifiedContacts,
            changeBranch: changeBranch,
            checkEmployerType: checkEmployerType,
            checkClientType: checkClientType,
            showArchiveButton: showArchiveButton,
            getGeneralSettings: getGeneralSettings
        };

        return service;

        function changeBranch() {
            companyLookupService.companyLookups.filtered_divisions = [];
            let divisions = companyLookupService.companyLookups.DivisionsLookUp;
            let branches = service.companyInfoData.Branches2;
            angular.forEach(branches, function(branch) {
                let matched_divisions = _.filter(divisions, {
                    BranchId: branch.Id
                });
                angular.forEach(matched_divisions, function(division) {
                    companyLookupService.companyLookups.filtered_divisions.push(division);
                });
            });
            cleanDivisions();
            companyLookupService.companyLookups.filtered_divisions = alasql('select * from ? order by BranchName, Name', [companyLookupService.companyLookups.filtered_divisions]);
        }

        function showArchiveButton() {
            if (service.isEditMode) {
                if (service.is_employer) {
                    return false;
                } else if (service.is_client) {
                    if (service.can_archive) {
                        return true;
                    }
                    return false;
                } else {
                    return true;
                }
            }
            return false;
        }

        function checkEmployerType() {
            if (_.find(service.companyInfoData.CompanyType, {
                    id: 5
                })) {
                return true;
            }
            return false;
        }

        function checkClientType() {
            if (_.find(service.companyInfoData.CompanyType, {
                    id: 1
                })) {
                return true;
            }
            return false;
        }

        function cleanDivisions() {
            if (service.init) return;

            if (!_.isNil(service.companyInfoData.Branches)) {
                let divs = [];
                angular.forEach(service.companyInfoData.Division, function(division) {
                    let result = _.find(service.companyInfoData.Branches, {
                        Id: division.BranchId
                    })
                    if (result) {
                        divs.push(division);
                    }
                });
                service.companyInfoData.Division = angular.copy(divs);
            } else {
                service.companyInfoData.Division = [];
            }
        }

        function getMinifiedContacts() {
            lookupApi.getBasicContactLookupsforCompany()
                .then(function(resp) {
                    service.minified_contacts = resp.data;
                });
        }

        function onCreate() {
            $state.go('app.company_create');
        }

        function onEdit(id, name) {
            blockUI.start('Loading Company...');
            $state.go('app.company_update', {
                cid: id,
                cname: name
            });
        }

        function addContact(company) {
            blockUI.start('Loading Create Contact...');
            $state.go('app.contact_create', {
                company: company
            });
        }

        function getDivisions() {
            service.validateDuplicateCompany();
        }

        function viewComments(Id, Name) {
            commentService.viewComments("Company", Id, Name);
        }

        function showCompanyDetails(id) {
            blockUI.start('Loading Details');
            companyApi.getCompanyMinifiedDetails(id)
                .then(function(resp) {
                    $mdDialog.show({
                        templateUrl: 'app/main/company/details/company-dialog.html',
                        controller: 'CompanyDialogController as vm',
                        locals: {
                            data: resp.data
                        }
                    });
                    blockUI.stop();
                });
        }

        async function showCompanyHistory(id, name) {
            blockUI.start('Loading History');
            var resp = await companyApi.getCompanyHistory(id);

            historyLogService.showHistory("Company", resp.data, name);
            blockUI.stop();
        }

        function activate() {
            cacheObj.group('viewCompanies', 1);
        }

        function loadCompanyTypes() {
            service.activate();
            var deferred = $q.defer();

            lookupApi.getCompanyTypes()
                .then(function(resp) {
                    service.companyTypes = resp.data;
                    deferred.resolve(resp.data);
                });
            return deferred.promise;
        }

        function viewDatesFilter() {
            $mdDialog.show({
                    templateUrl: 'app/main/company/view/templates/dates.html',
                    controller: 'CompanyDatesController as vm'
                })
                .then(function(resp) {
                    if (resp) {
                        service.filterCompanies();
                    }
                });
        }

        function filterCompanies() {
            service.loader = true;
            service.loaderMessage = "Filtering Companies ... ";

            var filterData = {
                CompanyTypeId: service.companyType,
                IsActive: service.isActive,
                IsArchived: service.isArchive,
                FilterType: service.filterType,
                StartDate: service.startDate,
                EndDate: service.endDate
            }

            companyApi.filterCompany(filterData)
                .then(function(resp) {
                    service.companies = sortCompanies(resp.data);
                    service.loader = false;
                })
                .catch(function() {
                    service.loader = false;
                    service.showDialog("Companies", "There was an error while filtering the companies");
                })
        }

        function showDialog(title, message, btnMessage) {
            $mdDialog.show(
                $mdDialog.alert()
                .clickOutsideToClose(true)
                .title(title)
                .textContent(message)
                .ok(btnMessage)
            );
        }

        function validateCode(code) {
            return companyApi.validateCode(code)
                .then(function(resp) {
                    if (resp.data == "") {

                    } else {
                        if (resp.data !== service.companyInfoData.id) {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent('Company Code ' + code + ' already exists')
                                .position('top right')
                                .hideDelay(3000)
                            );
                            service.companyInfoData.CompanyCode = null;
                            service.validate();
                        }
                    }
                });
        }

        function resetData() {
            service.companyInfoData.reset();
            service.companyTypeList = [];
        }

        function getCompanies() {
            service.companies = [];
            service.loader = true;
            service.loaderMessage = "Loading Companies ... ";
            companyApi.getCompanies()
                .then(function(resp) {
                    let companies = resp.data;
                    service.companies = formatCompanies(companies);
                    resetFilters();
                    service.loader = false;
                })
                .catch(function() {
                    service.loader = false;
                    service.showDialog("Companies", utils.translate("VIEWCOMPANIES.ERROR_LOADING_COMPANIES"));
                });
        }

        function formatCompanies(companies) {
            angular.forEach(companies, function(company) {
                let temporaryBranches = company.Branches;
                company.Branches = [];
                company['Divisions'] = [];

                angular.forEach(temporaryBranches, function(branch) {
                    company.Branches.push(branch.m_Item1);
                    angular.forEach(branch.m_Item2, function(division) {
                        company.Divisions.push(division);
                    });
                });

                if (company.Branches.length > 3) {
                    company.Branches = company.Branches.slice(0, 3);
                    company.Branches.sort();
                    company.Branches[3] = "...";
                }

                if (company.Divisions.length > 2) {
                    company.Divisions = company.Divisions.slice(0, 2);
                    company.Divisions.sort();
                    company.Divisions[2] = "...";
                }

                if (company.CompanyTypes.length > 3) {
                    company.CompanyTypes = company.CompanyTypes.slice(0, 3);
                    company.CompanyTypes.sort();
                    company.CompanyTypes[3] = "...";
                }
            });
            return sortCompanies(companies);
        }

        function sortCompanies(companies) {
            return alasql('select * from ? order by Name', [companies]);
        }

        function resetFilters() {
            service.companyType = null;
            service.isActive = true;
            service.isArchive = false;
            service.filterType = null;
            service.startDate = null;
            service.startDate = null;
        }

        function loadCustomFields(cid) {
            return companyApi.getCompany(cid);
        }

        function archive(isArchive) {
            $mdToast.show(
                $mdToast.simple()
                .textContent(isArchive ? 'Archiving' : 'Unarchiving' + ' please wait...')
                .position('top right')
                .hideDelay(3000)
            );

            companyApi.postArchive(service.companyInfoData.id, isArchive)
                .then(function(resp) {

                    var confirm = $mdDialog.confirm()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(false)
                        .title(isArchive ? 'Archive Status' : 'Unarchive Status')
                        .content((isArchive ? 'Archiving' : 'Unarchiving') + ' successfully completed.')
                        .ariaLabel(isArchive ? 'Archive Status' : 'Unarchive Status')
                        .ok('Ok')

                    $mdDialog.show(confirm)
                        .then(function() {
                            redirectToCompanyView();
                        });

                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function saveCompany(behavior) {
            service.behavior = behavior;
            service.isEditMode ? blockUI.start({
                message: 'Updating...'
            }) : blockUI.start({
                message: 'Saving...'
            });
            var model = service.companyInfoData.transformToServerModel();
            model.LinkedFormTemplates = service.linkedFormTemplates;
            model.UnlinkedFormTemplates = service.unlinkedFormTemplates;
            model.OverriddenFormTemplates = Object.keys(service.formTemplatesListApi)
                .length > 0 ? service.formTemplatesListApi.getOverriddenTemplatesToSave() : {};

            var apiPromise = null;

            if (!service.isEditMode) {
                apiPromise = companyApi.postCompany(model)
                    .then(SaveCompleted)
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            } else {
                apiPromise = companyApi.updateCompany(model)
                    .then(UpdateCompleted)
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            return apiPromise;
        }


        function UpdateCompleted(resp) {
            service.savedCompanyType = service.companyInfoData.CompanyType;
            $mdToast.show(
                $mdToast.simple()
                .textContent('Company successfully updated.')
                .position('bottom right')
                .hideDelay(3000)
            );
        }

        function SaveCompleted(resp) {

            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Company successfully created.')
                    .position('bottom right')
                    .hideDelay(3000)
                )
                .then(function() {
                    if (service.behavior == 0) {
                        redirectToUpdateCompany(resp.data.id);
                    } else {
                        redirectToCompanyView();
                    }
                });
        }

        function savePhoto() {
            if (!service.isEditMode) {
                return;
            }

            var model = service.companyInfoData.transformToServerModel();
            var apiPromise = companyApi.updateCompany(model);

            apiPromise.catch(function(ex) {
                exceptionService.resolve(ex);
            });

            return apiPromise;
        }

        function setImageUrl(url) {
            $log.debug('Setting new image url');
            service.companyInfoData.LogoUrl = url;
        }

        function loadData(cid) {
            service.isEditMode = true;
            companyApi.getCompany(cid)
                .then(loadDataCompleted)
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function loadDataCompleted(response) {
            let resp = response.data;
            service.init = true;
            service.isClient = _.find(resp.CompanyTypes, {
                TypeName: 'Client'
            }) ? true : false;

            if (utils.isUndefinedOrNull(resp)) {
                var stateProvider = $injector.get('$state');
                stateProvider.go('app.pages_errors_error-404');
                return;
            }

            service.linkedFormTemplates = resp.LinkedFormTemplates;
            service.unlinkedFormTemplates = resp.UnlinkedFormTemplates;
            service.overriddenFormTemplates = resp.OverriddenFormTemplates;

            service.companyInfoData.map({
                id: resp.id,
                CompanyName: resp.Name,
                LegalEntityName: resp.LegalEntityName,
                LogoUrl: resp.Logo,
                CompanyCode: resp.CompanyCode,
                Emails: resp.Emails,
                EmailInvoices: resp.EmailInvoices,
                SendPaperworkToSiteContact: resp.SendPaperworkToSiteContact,
                RequireSignatureInInvoicing: resp.RequireSignatureInInvoicing,
                IsProjectMandatory: resp.IsProjectMandatory,
                IsPurchaseOrderMandatory: resp.IsPurchaseOrderMandatory,
                SiteAllowance: resp.SiteAllowance == 0 ? null : resp.SiteAllowance,
                Website: resp.Website,
                RateCard: resp.RateCard,
                InvoiceTerm: resp.InvoiceTerm,
                Mobiles: resp.Mobiles,
                IsInactive: !resp.IsActive,
                IsArchived: resp.IsArchived,
                StartDate: resp.StartDate,
                TravelBillingPreference: resp.TravelBillingPreference == null ? 0 : resp.TravelBillingPreference,
                ChargeForEmployeeBreaks: resp.ChargeForEmployeeBreaks,
                ChargeForEquipmentBreaks: resp.ChargeForEquipmentBreaks,
                InvoiceTotallingPreference: resp.InvoiceTotallingPreference,
                EndDate: resp.EndDate,
                CompanyType: resp.CompanyTypes,
                Addresses: resp.Addresses,
                Branches2: [],
                CompanyRequiredSkills: resp.CompanyRequiredSkills,
                CustomFields: resp.CustomFields,
                ContactsPreferences: resp.ContactsPreferences,
                TravelBilling: resp.TravelBilling,
                BatchInvoices: resp.BatchInvoices,
                PdfInvoiceTemplate: resp.PdfInvoiceTemplate,
                LineItemTemplate: resp.LineItemTemplate,
                Awards: resp.Awards,
                CreditType: resp.CreditType,
                MyobCustomers: resp.MyobCustomers,
                XeroCustomers: resp.XeroCustomers,
                RequiredAttachmentTypes: resp.RequiredAttachmentTypes
            });

            service.companyInfoData.Branches2 = resp.Branches;
            service.savedCompanyType = resp.CompanyTypes;
            service.companyInfoData.Division = [];

            angular.forEach(service.companyInfoData.Branches2, function(branch) {
                angular.forEach(branch.Division, function(division) {
                    service.companyInfoData.Division.push(division);
                });
            });

            service.formatData();
            service.changeBranch();
            service.is_employer = service.checkEmployerType();
            service.is_client = service.checkClientType();
            service.show_archive_button = showArchiveButton();
            service.init = false;
            blockUI.stop();
        }

        function formatData() {
            service.companyInfoData.formattedSkills = [];
            angular.forEach(service.companyInfoData.CompanyRequiredSkills, function(itm) {
                angular.forEach(itm.Skills, function(skill) {
                    var itmSkill = {
                        Id: skill.id,
                        SkillName: skill.SkillName,
                        SkillType: skill.SkillType,
                        LockoutType: skill.LockoutType,
                        id: itm.id,
                        GroupName: itm.GroupName
                    }
                    service.companyInfoData.formattedSkills.push(itmSkill);
                });
            });
        }

        function redirectToCompanyView() {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.company_view');
        }

        function redirectToUpdateCompany(data) {
            var stateProvider = $injector.get('$state');
            stateProvider.go('app.company_update', {
                cid: data
            });
        }

        function triggerUIValidation() {
            $rootScope.$broadcast('company:uiValidation');
        }

        function signalCompany() {
            $rootScope.$broadcast('companyInfo:submitForm');
        }

        function validateDuplicateCompany() {
            service.duplicatedCompany = null;
            var branches = [],
                mobiles = [],
                emails = [];
            if (service.companyInfoData.Branches && service.companyInfoData.Branches.length > 0) {
                branches = _.map(service.companyInfoData, 'Branches');
            }

            if (service.companyInfoData.Mobiles.length > 0) {
                mobiles = _.map(service.companyInfoData, 'Mobiles');
            }

            if (service.companyInfoData.Emails.length > 0) {
                emails = _.map(service.companyInfoData, 'Emails');
            }

            // Clean up
            branches = _.compact(branches);
            mobiles = _.compact(mobiles);
            emails = _.compact(emails);

            var data = {
                Name: service.companyInfoData.CompanyName,
                Branches: branches,
                Mobiles: mobiles,
                Emails: emails
            }

            if (data && branches.length > 0) {
                companyApi.validateDuplicateCompany(data)
                    .then(function(resp) {
                        service.duplicatedCompany = resp.data
                    });
            }
        }

        function getGeneralSettings(){
            return tenantsApi.getGeneralSettings().then(function(resp) {
                var data = resp.data;
                service.generalSettings.CompanyCodeFormat = data.CompanyCodeFormat;
                service.generalSettings.RequiresCompanyCode = data.RequiresCompanyCode.toLowerCase() === 'true';
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.company')
        .factory('companyLookupService', companyLookupService);

    /** @ngInject */
    function companyLookupService(
        companyApi,
        $q,
        termsApi,
        skillsMatrixApi,
        rateCardsApi,
        lookupApi,
        companyLookupsModel,
        exceptionService) {

        var service = {
            companyLookups: new companyLookupsModel(),
            rateCards: [],
            skillsLookUps: [],
            termDays: [],
            getTerms: getTerms,
            fetchAndCacheAllLookups: fetchAndCacheAllLookups,
            lookupFetchCompletedCallback: null, // Use this if you don't want to load lookup data from route resolver
            fetchCompanyTypes: fetchCompanyTypes
        };

        return service;

        function getTerms() {
            return termsApi.getTerms();
        }

        function fetchAndCacheAllLookups() {

            var deferred = $q.defer();

            $q.all([lookupApi.getCompanyLookups(),
                    skillsMatrixApi.getSkillsGroups(),
                    rateCardsApi.getRatecardAll(),
                    termsApi.getTerms(),
                    companyApi.getCreditTypes()
                ])
                .then(function(resp) {
                    var obj = resp[0].data;
                    service.companyLookups.map({
                        PhoneTypes: obj.PhoneTypes,
                        AddressTypes: obj.AddressTypes,
                        Branches: obj.Branches,
                        CompanyTypes: obj.CompanyTypes,
                        CompanyNumberTypes: obj.CompanyNumberTypes,
                        TravelBilling: obj.TravelBilling,
                        BatchInvoices: obj.BatchInvoices,
                        PDFInvoiceTemplate: obj.PDFInvoiceTemplate,
                        LineItemTemplate: obj.LineItemTemplate,
                        CreditTypes: resp[4].data
                    });

                    angular.forEach(angular.copy(service.companyLookups.Branches), function(branch) {
                        angular.forEach(branch.Division, function(division) {
                            service.companyLookups.DivisionsLookUp.push({
                                id: division.id,
                                Name: division.Name,
                                BranchName: branch.Name,
                                BranchId: branch.id
                            });
                        });
                    });

                    angular.forEach(service.companyLookups.Branches, function(branch) {
                        branch['Id'] = branch.id;
                        delete branch.Division;
                        delete branch.id;
                    });

                    service.skillsLookUps = resp[1].data;
                    service.rateCards = resp[2].data;
                    service.termDays = alasql('select * from ? order by Name asc', [resp[3].data]);;
                    deferred.resolve(service.companyLookups);
                    (service.lookupFetchCompletedCallback || angular.noop)('companyLookups');

                })
                .catch(function(ex) {
                    deferred.reject(ex);
                    exceptionService.resolve(ex);
                });

            return deferred.promise;
        }

        function fetchCompanyTypes() {
            var deferred = $q.defer();

            lookupApi.getCompanyTypes()
                .then(function(resp) {
                    deferred.resolve(resp.data);
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                    exceptionService.resolve(ex);
                });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.company')
        .factory('companyClaimsService', companyClaimsService);

    /** @ngInject */
    function companyClaimsService($rootScope, $log, identityService, claimsUtilService) {
        var service = {
            hasCreateNewCompanyMenu: false
        };

        activate();

        return service;

        function activate() {
            $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                applyClaimsRules();
            });

            applyClaimsRules();
        }

        function applyClaimsRules() {
            service.hasCreateNewCompanyMenu = claimsUtilService.checkAccessByRole('Create a New Company');
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.company.create')
        .service('companyViewFilterModel', companyViewFilterModel);

    function companyViewFilterModel(utils) {
        return function () {
            var self = this,
                defaults = {
                    isActive: null,
                    isArchive: null,
                    companyType: null,
                    filterType: null,
                    startDate: null,
                    endDate: null
                };

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = toBackendModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults;
                var opts = angular.extend(this, defaults, mapValue);
            }

            function reset() {
                self.map(null);
            }

            function toBackendModel() {
                return {
                    CompanyTypeId: self.companyType,
                    IsActive: self.isActive,
                    IsArchived: self.isArchive,
                    FilterType: self.filterType,
                    StartDate: self.startDate ? utils.jsDateTime(self.startDate) : self.startDate,
                    EndDate: self.endDate ? utils.jsDateTime(self.endDate) : self.endDate
                };
            }
        }
    }
})();

/**
 * Company Lookups model
 */
(function(){
   'use strict';

   angular.module('app.company.create')
          .service('companyLookupsModel', companyLookupsModel)

   /**
    *  Company Lookups Model
    */
   function companyLookupsModel (){

     return function() {

        var self = this,
            defaults = {
              PhoneTypes: [],
              AddressTypes: [],
              AddressUnitTypes: [],
              AddressStates: [],
              StreetTypes: [],
              Branches: [],
              CompanyTypes: [],
              CompanyNumberTypes: [],
              TravelBilling: [],
              BatchInvoices: [],
              PDFInvoiceTemplate: [],
              LineItemTemplate: [],
              CreditTypes: [],
              DivisionsLookUp : [],
              filtered_divisions : []
            };

            self.map = mapper;
            self.reset = reset;
            self.map();

            function reset(){
                self.ContactTypes.length = 0;
                self.PhoneTypes.length = 0;
                self.AddressTypes.length = 0;
                self.AddressUnitTypes.length = 0;
                self.AddressStates.length = 0;
                self.StreetTypes.length = 0;
                self.Companies.length = 0;
                self.Branches.length = 0;
                self.CompanyTypes.length = 0;
                self.CompanyNumberTypes.length = 0;
                self.TravelBilling.length = 0;
                self.BatchInvoices.length = 0;
                self.PDFInvoiceTemplate.length = 0;
                self.LineItemTemplate.length = 0;
                self.CreditTypes.length = 0;
                self.DivisionsLookUp.length = 0;
                self.filtered_divisions.length = 0;
            }

            /**
            * Perform mapping and update model
            */
            function mapper (options) {
              var mapValue = options || defaults;
              var opts = angular.extend({}, defaults, mapValue);

              // Fields/Properties
              self.ContactTypes = opts.ContactTypes;
              self.PhoneTypes = opts.PhoneTypes;
              self.AddressTypes = opts.AddressTypes;
              self.AddressUnitTypes = opts.AddressUnitTypes;
              self.AddressStates = opts.AddressStates;
              self.StreetTypes = opts.StreetTypes;
              self.Companies = opts.Companies;
              self.Branches = opts.Branches;
              self.CompanyTypes = opts.CompanyTypes;
              self.CompanyNumberTypes = opts.CompanyNumberTypes;
              self.TravelBilling= opts.TravelBilling;
              self.BatchInvoices= opts.BatchInvoices;
              self.PDFInvoiceTemplate= opts.PDFInvoiceTemplate;
              self.LineItemTemplate= opts.LineItemTemplate;
              self.CreditTypes= opts.CreditTypes;
              self.DivisionsLookUp = opts.DivisionsLookUp;
              self.filtered_divisions = opts.filtered_divisions;
            }
       };
   }
})();

/**
 * Company Info model
 * Shared model
 */
(function() {
    'use strict';

    angular.module('app.company.create')
        .service('companyInfoModel', companyInfoModel)

    function companyInfoModel(utils) {

        return function(options) {

            var defaults = {
                id: null,
                CompanyName: null,
                CompanyCode: null,
                LegalEntityName: null,
                Website: '',
                Logo: '',
                CompanyType: [],
                Addresses: [],
                Branches: [],
                Branches2: [],
                Divisions: [],
                Division: [],
                CompanyRequiredSkills: [],
                StartDate: undefined,
                EndDate: undefined,
                IsInactive: false,
                IsArchived: false,
                IsProjectMandatory: false,
                IsPurchaseOrderMandatory: false,
                SiteAllowance: null,
                EmailInvoices: true,
                SendPaperworkToSiteContact: true,
                RequireSignatureInInvoicing: true,
                LogoUrl: '',
                Mobiles: [],
                TravelBillingPreference: 0,
                ChargeForEmployeeBreaks: null,
                ChargeForEquipmentBreaks: null,
                InvoiceTotallingPreference: null,
                Emails: [],
                InvoiceTerm: null,
                CustomFields: [],
                CustomFieldsValues: [],
                ContactsPreferences: [],
                Awards: [],
                TravelBilling: null,
                BatchInvoices: 1,
                PdfInvoiceTemplate: null,
                LineItemTemplate: null,
                RateCard: null,
                CreditType: null,
                MyobCustomers: [],
                XeroCustomers: [],
                RequiredAttachmentTypes: []
            };

            var self = this;
            this.map = mapper;
            this.transformToServerModel = transformToModel;
            this.reset = reset;
            this.map(options);

            /**
             * Perform mapping and update model
             */
            function mapper(opts) {
                var mapValue = opts || {};
                var opts = angular.extend(this, defaults, mapValue);

                if (opts.StartDate)
                    this.StartDate = utils.epochToJsDateTime(opts.StartDate);
                if (opts.EndDate)
                    this.EndDate = utils.epochToJsDateTime(opts.EndDate);

                return this;
            };

            function reset() {
                this.map(null);
                this.id = null;
                this.CompanyName = null;
                this.CompanyCode = null;
                this.LegalEntityName = null;
                this.Website = null;
                this.Logo = null;
                this.CompanyType.length = 0;
                this.Addresses.length = 0;
                this.Branches.length = 0;
                this.Branches2.length = 0;
                this.Divisions.length = 0;
                this.Division.length = 0;
                this.CompanyRequiredSkills.length = 0;
                this.StartDate = undefined;
                this.EndDate = undefined;
                this.IsInactive = false;
                this.IsArchived = false;
                this.IsProjectMandatory = false;
                this.IsPurchaseOrderMandatory = false;
                this.SiteAllowance = null;
                this.EmailInvoices = false;
                this.SendPaperworkToSiteContact = true;
                this.RequireSignatureInInvoicing = true;
                this.LogoUrl = null;
                this.Mobiles.length = 0;
                this.TravelBillingPreference = 0
                this.ChargeForEmployeeBreaks = null;
                this.ChargeForEquipmentBreaks = null;
                this.InvoiceTotallingPreference = null;
                this.Emails.length = 0;
                this.InvoiceTerm = null;
                this.CustomFields.length = 0;
                this.CustomFieldsValues.length = 0;
                this.ContactsPreferences.length = 0;
                this.Awards.length = 0;
                this.TravelBilling = null;
                this.BatchInvoices = 1;
                this.PdfInvoiceTemplate = null;
                this.LineItemTemplate = null;
                this.RateCard = null;
                this.CreditType = null;
                this.MyobCustomers.length = 0;
                this.XeroCustomers.length = 0;
                this.RequiredAttachmentTypes.length = 0;
            }

            function transformToModel() {
                var companyTypes = [];

                angular.forEach(this.CompanyType, function(companyType) {
                    companyTypes.push(companyType);
                });

                var Skills = this.CompanyRequiredSkills;

                // Skills
                angular.forEach(Skills, function(skill, key) {
                    if (skill.Skills.length == 0) {
                        Skills.splice(key, 1);
                    }
                });

                angular.forEach(this.Branches2, function(branch) {
                    branch['Division'] = [];
                });

                angular.forEach(this.Branches2, function(branch) {
                    angular.forEach(self.Division, function(division) {
                        if (division.BranchId === branch.Id) {
                            branch['Division'].push({
                                id: division.id,
                                Name: division.Name
                            })
                        }
                    })
                });

                var serverModel = {
                    id: this.id,
                    Name: this.CompanyName,
                    CompanyCode: this.CompanyCode,
                    LegalEntityName: this.LegalEntityName,
                    Logo: this.LogoUrl,
                    RateCard: this.RateCard,
                    Website: this.Website,
                    IsActive: !this.IsInactive,
                    IsArchived: this.IsArchived,
                    CustomFields: this.CustomFields,
                    CustomFieldsValues: this.CustomFieldsValues,
                    Branches: this.Branches2,
                    Addresses: utils.objectSanitize(this.Addresses),
                    Emails: this.Emails,
                    SiteAllowance: this.SiteAllowance,
                    Mobiles: this.Mobiles,
                    Numbers: this.Numbers,
                    CompanyTypes: utils.objectSanitize(companyTypes),
                    StartDate: this.StartDate ? utils.jsDateTimeToEpoch(this.StartDate) : null,
                    EndDate: this.EndDate ? utils.jsDateTimeToEpoch(this.EndDate) : null,
                    CompanyRequiredSkills: Skills,
                    ContactsPreferences: this.ContactsPreferences,
                    Awards: this.Awards,
                    IsProjectMandatory: this.IsProjectMandatory,
                    IsPurchaseOrderMandatory: this.IsPurchaseOrderMandatory,
                    EmailInvoices: this.EmailInvoices,
                    SendPaperworkToSiteContact: this.SendPaperworkToSiteContact,
                    RequireSignatureInInvoicing: this.RequireSignatureInInvoicing,
                    TravelBilling: this.TravelBilling,
                    InvoiceTerm: this.InvoiceTerm,
                    BatchInvoices: this.BatchInvoices,
                    PdfInvoiceTemplate: this.PdfInvoiceTemplate,
                    LineItemTemplate: this.LineItemTemplate,
                    TravelBillingPreference: this.TravelBillingPreference,
                    ChargeForEmployeeBreaks: this.ChargeForEmployeeBreaks,
                    ChargeForEquipmentBreaks: this.ChargeForEquipmentBreaks,
                    InvoiceTotallingPreference: this.InvoiceTotallingPreference,
                    CreditType: this.CreditType,
                    MyobCustomers: this.MyobCustomers,
                    XeroCustomers: this.XeroCustomers,
                    RequiredAttachmentTypes: this.RequiredAttachmentTypes
                };
                return serverModel;
            };
        }

    };
})();
  /**
   *  Company Number Model
   *  Instantiable model
  */
(function(){
   'use strict';

   angular.module('app.company.create')
          .service('companyBranchModel', companyBranchModel)

   function companyBranchModel (){

       return function(options){
          defaults = {
             id: null,
             Name: null,
             Award: null,
             Division: [],
             State: null,
             Selected: false  // ViewModel specific
          };

         this.map = mapper;
         this.map(options);

         function mapper(optionBag) {
           var clonedDefaults = angular.copy(defaults);
           var optionSrc = optionBag || clonedDefaults;
            var mapValue = angular.extend({}, clonedDefaults, optionSrc);
            angular.extend(this, mapValue);
         }

       };

   };

})();

(function() {
    'use strict';

    angular
        .module('app.company')
        .controller('CompanyDialogController', CompanyDialogController);

    /** @ngInject */
    function CompanyDialogController($mdDialog,
                                     _,
                                     data) {
        let vm = this;

        vm.closeDialog = closeDialog;
        vm.company = null;

        function closeDialog() {
            $mdDialog.hide();
        }

        function activate() {

            vm.company = format(data);
        }

        function sanitizeValues(values, fields) {
            let fieldValues = [];
            angular.forEach(values, function(value) {
                delete value.CustomField;
                delete value.Type;
                if (value.Id.substring(0, 2) == "cs") {
                    value.Id = parseInt(value.Id.substring(2));
                    value['Title'] = null;
                    value['IsCheckbox'] = false;
                    value['CheckBoxValues'] = [];
                    fieldValues.push(value);
                } else {
                    value['IsCheckbox'] = true;
                    if (value.Id.substring(0, 6) == "ChkReg") {
                        let indexOfS = value.Id.indexOf('s');
                        let indexOfO = value.Id.indexOf('O');
                        let variable = parseInt(value.Id.substring(indexOfS + 1, indexOfO));
                        let optionNumber = value.Id.substring(indexOfO);
                        value['Id'] = variable;
                        let field = alasql('select * from ? where Variable = ?', [fields, variable]);
                        if (field.length > 0) {
                            let valueMatched = alasql('select Value from ? where Name = ?', [field[0].Option, optionNumber]);
                            if (valueMatched.length > 0) {
                                let fieldExists = alasql('select * from ? where Id = ?', [fieldValues, value.Id]);
                                if (fieldExists.length > 0) {
                                    angular.forEach(fieldValues, function(val) {
                                        if (value.Id == val.Id) {
                                            if (value.FieldValue) {
                                                val.CheckBoxValues.push(valueMatched[0].Value);
                                            }
                                        }
                                    });
                                } else {
                                    value['CheckBoxValues'] = [];
                                    if (value.FieldValue) {
                                        value.CheckBoxValues.push(valueMatched[0].Value);
                                    }
                                    fieldValues.push(value);
                                }
                            }
                        }
                    } else {
                        if (value.Id.indexOf('input') > 0) {
                            let indexOfT = value.Id.lastIndexOf('t');
                            let variable = parseInt(value.Id.substring(indexOfT + 1));
                            value['Id'] = variable;
                            let field = alasql('select * from ? where Variable = ?', [fields, variable]);
                            if (field.length > 0) {
                                let fieldExists = alasql('select * from ? where Id = ?', [fieldValues, value.Id]);
                                if (fieldExists.length > 0) {
                                    angular.forEach(fieldValues, function(val) {
                                        if (value.Id == val.Id) {
                                            val.CheckBoxValues.push(value.FieldValue);
                                        }
                                    });
                                } else {
                                    value['CheckBoxValues'] = [];
                                    value.CheckBoxValues.push(value.FieldValue);
                                    fieldValues.push(value);
                                }
                            }
                        }
                    }
                }
            });
            return fieldValues;
        }

        function fillValues(values, fields) {
            angular.forEach(values, function(cf) {
                angular.forEach(fields, function(field) {
                    if (cf.Id == field.Variable) {
                        cf['Title'] = field.FieldTitle;
                        if (cf.IsCheckbox) {
                            cf.CheckBoxValues.sort();
                            cf['FieldValue'] = cf.CheckBoxValues.join(", ");
                        }
                    }


                })
            });
            values = _.reject(values, {
                Title: null
            });
            return _.orderBy(values, ['Title'], ['asc']);
        }

        function fomatCustomFieldsValues(values, fields) {
            let customFields = sanitizeValues(values, fields);
            customFields = fillValues(customFields, fields);
            customFields = _.reject(customFields, function(field){
                return _.isBoolean(field.FieldValue) || field.FieldValue.includes("|")
            });
            customFields.forEach(function(field){
                if(field.FieldValue.includes("|")){
                    let index_of_slash = field.FieldValue.indexOf("|");
                    field.FieldValue = field.FieldValue.substring(index_of_slash + 1);
                }
            });
            return customFields;
        }

        function format(company) {
            return {
                Name: company.m_Item1.Name,
                Image: company.m_Item1.Logo,
                Code: company.m_Item1.CompanyCode,
                Types: company.m_Item1.CompanyTypes,
                Branches: company.m_Item1.Branches,
                Website: company.m_Item1.Website,
                PostalAddress: company.m_Item1.PostalAddress,
                BusinessAddress: company.m_Item1.BusinessAddress,
                EmailAddress: company.m_Item1.PrimaryEmailAdddress,
                Number: company.m_Item1.PrimaryMobileNumber,
                CustomFieldsList: fomatCustomFieldsValues(company.m_Item1.CustomFields, company.m_Item2)
            }
        }

        activate();
    }
})();

/**
 * Create Company Controller
 * Created date: 4.8.2016
 */
(function() {
    'use strict';

    angular
        .module('app.company.create')
        .controller('CompanyCreateController', CompanyCreateController);

    /** @ngInject */

    function CompanyCreateController($scope,
        $stateParams,
        companyService,
        $timeout,
        companyLookupService,
        blockUI,
        $compile,
        customFieldsService,
        customisedFieldsFactory,
        claimsUtilService,
        msgboxService) {
        var companyVm = this;
        companyVm.headerTitle = null;
        companyVm.isProcessing = false;
        companyVm.mode = [];
        companyVm.actionPanelBehavior = {};
        companyVm.Id = $stateParams.cid;
        companyVm.editMode = false;
        companyVm.CustomisedFieldsBackUp = [];
        companyVm.showFields = true;
        companyVm.saveDisabled = false;
        companyVm.service = companyService;
        companyVm.lookUpService = companyLookupService;
        companyVm.model = companyService.companyInfoData;
        companyVm.checkAccessService = claimsUtilService;

        companyVm.onsave = onSaveCompany;
        companyVm.getCustomFields = getCustomFields;
        companyVm.onArchive = onArchive;
        companyVm.changeFields = changeFields;

        companyVm.service.linkedFormTemplates = null;
        companyVm.service.unlinkedFormTemplates = null;
        companyVm.service.overriddenFormTemplates = null;
        companyVm.service.formTemplatesListApi = {};
        companyVm.service.vehicles = null;
        companyVm.service.assets = null;

        activate();

        function getCustomFields() {
            customFieldsService.getCustomFields().then(function(resp) {
                companyVm.model.customisedFields = resp.data.filter(function(field) {
                    return field.ModulePages[0] === 2;
                });
            });
        }

        $scope.$on('$destroy', function() {
            companyService.companyInfoData.reset();
        });

        //Triggers every time the user changes the company type
        function changeFields() {
            alert('type change - controller');
            companyVm.service.is_employer = companyVm.service.checkEmployerType();
            companyVm.service.is_client = companyVm.service.checkClientType();
            companyVm.service.show_archive_button = companyVm.service.showArchiveButton();
            companyVm.service.isClient = _.find(companyVm.service.companyInfoData.CompanyType, {
                TypeName: 'Client'
            });
        }

        function activate() {
            companyService.resetData();
            companyVm.service.companyTypeList = angular.copy(companyLookupService.companyLookups.CompanyTypes);
            getCustomFields();

            // Create/Edit mode
            if (angular.isDefined($stateParams.cid)) {
                companyVm.headerTitle = 'Update Company';
                companyVm.buttonSaveCaption = 'COMPANYMODULE.EDIT_BUTTON';
                companyVm.editMode = true;
                companyService.loadData($stateParams.cid);
            } else {
                companyVm.headerTitle = 'Create A New Company';
                companyVm.buttonSaveCaption = 'COMPANYMODULE.SAVE';
                companyService.isEditMode = false;
                companyVm.editMode = false;
            }
        };

        function onSaveCompany(behavior, currentForm) {
            if (!_.isNil(companyVm.model.Awards)) {
                var changedAwards = _.filter(companyVm.model.Awards, function(a) {
                    return a.IsNew === true || a.IsDeleted === true;
                });

                if (companyVm.editMode && (!_.isEmpty(changedAwards))) {
                    msgboxService.showCustomDialog('app/main/company/create/award/component/company-update-award.dialog.html',
                            'companyUpdateAwardDialogController as vm', companyVm.model.Awards)
                        .then(function(resp) {
                            if (resp) {
                                companyVm.Awards = resp;
                                saveCompany(behavior, currentForm);
                            }
                        });
                } else {
                    saveCompany(behavior, currentForm);
                }
            }
        }

        function saveCompany(behavior, currentForm) {
            companyService.saveTrigger = !companyService.saveTrigger;
            $timeout(function() {
                currentForm.$setPristine();
                companyService
                    .saveCompany(behavior)
                    .then(function() {
                        blockUI.stop();
                    });
            });
        }

        function onArchive() {
            companyService.archive(!companyService.companyInfoData.IsArchived);
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.businesses', ['app.api'])
        .config(config)
        .run(runConfig);

    function runConfig(msNavigationService, adminClaimsService) {

    }

    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.businesses', {
                url: '/businesses',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/business/view/business-view.html',
                        controller: 'BusinessViewController as vm'
                    }
                },
                title: 'Businesses',
                titleBar: 'Alloc8 - Businesses',
                data: {
                    requireLogin: true,
                    validateAccess: ['adminClaimsService', function (adminClaimsService) {
                        return adminClaimsService.hasAdminMenu;
                    }] 
                }
            })
            .state('app.businesses.edit', {
                url: '/edit/:id',
                params: {
                    id:null,
                    payrollBusinessAlreadyExists: false
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/business/edit/business-edit.html',
                        controller: 'BusinessEditController as vm'
                    }
                },
                title: 'Edit Business',
                data: {
                    requireLogin: true
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/business');
    }
})();
(function() {
    'use strict';

    angular.module('app.businesses')
        .controller('BusinessViewController', BusinessViewController);

    function BusinessViewController(
        _,
        $state,
        $mdDialog,
        $compile,
        $scope,
        DTColumnBuilder,
        DTOptionsBuilder,
        searchDelay,
        claimsUtilService,
        tenantsApiUrl,
        auditApi,
        historyLogService,
    ) {
        let tenantKey = claimsUtilService.getTenantKey();

        var vm = this;
        vm.dtInstance = {};
        vm.searchTable = searchTable;
        vm.showDialog = showDialog;
        vm.editBusiness = editBusiness;
        vm.viewHistory = viewHistory;

        initDataTable();

        function initDataTable() {

            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('').renderWith(function(data, type, full) {
                    return full.id;
                }).notVisible(),
                DTColumnBuilder.newColumn('fields').withTitle('Business Name').renderWith(function(data, type, full) {
                    return full.fields['BusinessName'];
                }),
                DTColumnBuilder.newColumn('fields').withTitle('Payroll').renderWith(function(data, type, full) {
                    return full.fields['IsPayroll'] === 'true' ? 'Yes' : 'No';
                }),
                DTColumnBuilder.newColumn('fields').withTitle('Invoicing').renderWith(function(data, type, full) {
                    return full.fields['IsInvoicing'] === 'true' ? 'Yes' : 'No';
                }),
                DTColumnBuilder.newColumn('fields').withTitle('Active').renderWith(function(data, type, full) {
                    return full.fields['IsActive'] === 'true' ? 'Yes' : 'No';
                }),
                DTColumnBuilder.newColumn('').withTitle('Actions').notSortable().renderWith(function(data, type, full) {

                    let editIconColor = 'teal-500-fg';
                    return `<md-button class="md-icon-button md-primary action-button" ng-click="vm.editBusiness('${full.id}')">
                                <i class="icon icon-pencil ${editIconColor} s15">
                                    <md-tooltip>Edit Business</md-tooltip>
                                </i>
                            </md-button>
                            <md-button class="md-icon-button md-primary action-button" aria-label="Settings"
                                ng-click="vm.viewHistory('${full.fields['BusinessName']}', '${full.id}')">
                                <i class="icon icon-history orange-500-fg s15">
                                    <md-tooltip>View History</md-tooltip>
                                </i>
                            </md-button>`;
                })
            ];

            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withOption('lengthChange', false)
                .withOption('ajax', {
                    type: 'GET',
                    url: tenantsApiUrl + tenantKey + '/businesses',
                    processData: false,
                    dataFilter: function(responseJson) {
                        let response = JSON.parse(responseJson);
                        return JSON.stringify(response);
                    },
                    error: function() {
                        $mdDialog.show($mdDialog.alert()
                            .title('Error')
                            .textContent('An error occured when contacting the server.')
                            .ok('Close'));
                    }
                })
                .withDataProp('')
                .withOption('processing', true)
                .withOption('createdRow', createdRow)
                .withOption('rowCallback', rowCallback)
                .withOption('headerCallback', function(thead) {
                    for (let i = 0; i < thead.cells.length; i++) {
                        let columnTitle = thead.cells[i].innerText;
                        thead.cells[i].innerHTML = '<div class="table-header">' +
                            '<span class="column-title">' + columnTitle + '</span>' +
                            '</div>';
                    }
                });
        }

        function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }

        function rowCallback(row, data) {
            if (data.fields['IsActive'] !== 'true') {
                $(row).addClass('inactive');
            }

            if (data.fields['IsPayroll'] === 'true') {
                vm.payrollBusinessId = data.id;
            }
        }

        function searchTable() {
            setTimeout(function() {
                vm.dtInstance.DataTable.search(vm.query);
                vm.dtInstance.DataTable.search(vm.query).draw();
            }, searchDelay);
        }

        function showDialog() {
            var business = vm.dtInstance.DataTable.columns(1).data().eq(0);
            var payrollBusinessAlreadyExists = _.some(business, function(b) {
                return b.IsPayroll === 'true';
            });

            $mdDialog.show({
                controller: 'createBusinessDialogController as vm',
                templateUrl: 'app/main/business/view/business-create-dialog.html',
                locals: {
                    payrollBusinessAlreadyExists: payrollBusinessAlreadyExists
                }
            });
        }

        function editBusiness(id) {
            var payrollBusinessAlreadyExists = false;
            if (vm.payrollBusinessId && vm.payrollBusinessId !== id) {
                payrollBusinessAlreadyExists = true;
            }

            $state.go('app.businesses.edit', {
                id: id,
                payrollBusinessAlreadyExists: payrollBusinessAlreadyExists
            });
        }

        async function viewHistory(businessName, id) {
            var resp = await auditApi.getAuditEntries(id);
            historyLogService.showHistory("Businesses", resp.data, businessName, 'business-history-log-data');
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.businesses')
        .controller('createBusinessDialogController', createBusinessDialogController);

    /** @ngInject */
    function createBusinessDialogController($mdDialog, $state, locals, utils, businessApi, tenantsApi, claimsUtilService) {
        var vm = this;
        vm.payrollBusinessAlreadyExists = locals.payrollBusinessAlreadyExists;

        vm.model = {
            BusinessName: null,
            IsInvoicing: claimsUtilService.isBillingEnabled(),
            IsPayrollEnabled: claimsUtilService.isPayrollEnabled(),
            IsPayroll: claimsUtilService.isPayrollEnabled() && !vm.payrollBusinessAlreadyExists,
            IsActive: true
        };

        vm.loaderMessage = utils.translate('BUSINESSMODULE.SAVING');
        vm.isSaving = false;
        vm.onClose = onClose;
        vm.save = save;

        function onClose() {
            $mdDialog.hide();
        }

        function save() {
            vm.isSaving = true;

            var fields = new Map([
                ['BusinessName', vm.model.BusinessName.toString()],
                ['IsPayroll', vm.model.IsPayroll.toString()],
                ['IsInvoicing', vm.model.IsInvoicing.toString()],
                ['IsActive', 'true']
            ]);

            var fields = Object.fromEntries(fields)

            businessApi.createBusiness(fields).then(function(resp) {
                $state.go('app.businesses.edit', {
                    id: resp.data,
                    payrollBusinessAlreadyExists: vm.payrollBusinessAlreadyExists
                });

                $mdDialog.hide();
            });
        }
    }
})();
(function() {
  'use strict';

    angular.module('app.businesses')
        .controller('businessHistoryLogDataController', businessHistoryLogDataController);

    /** @ngInject */
    function businessHistoryLogDataController($scope, localisationService, addressUtils) {
        var vm = this;
        var logData = JSON.parse(vm.data);
        
        var newData = logData['New'];
        var oldData = logData['Old'];
        
        var changes = _.pickBy(newData, (value, key) => !oldData || (oldData[key] != value));

        if (logData.BusinessAddress) {
          vm.businessAddress = addressUtils.buildAddress(JSON.parse(vm.logData.BusinessAddress));
        }

        var businessFor = [];
        if (newData.IsPayroll == 'true') {
          businessFor.push('Payroll');
        }

        if (newData.IsInvoicing == 'true') {
          businessFor.push('Invoicing');
        }

        vm.businessFor = businessFor.join(', ');

        var localeFormatSettings = localisationService.getLocaleFormatSettings();
        vm.registeredBusinessNumberDisplayName = _.find(localeFormatSettings['registeredBusinessNumber'], function(o) {
            return o.settingKey === 'DisplayName';
        }).settingValue;
        
        vm.changes = changes;
        vm.newData = newData;
    }
})();
(function() {
  'use strict';
  angular.module('app.businesses')
      .directive('businessHistoryLogData', businessHistoryLogDataComponent);

  /** @ngInject */
  function businessHistoryLogDataComponent() {
      var directive = {
          restrict: 'E',
          templateUrl: 'app/main/business/history/business-history-log-data.html',
          scope: {
            data: '='
          },
          controller: 'businessHistoryLogDataController',
          controllerAs: 'vm',
          bindToController: true,
      };

      return directive;
  }
})();
(function() {
    'use strict';

    angular.module('app.businesses')
        .controller('BusinessEditController', BusinessEditController);

    function BusinessEditController(_,
        $mdDialog,
        $state,
        $stateParams,
        localisationService,
        claimsUtilService,
        integrationsService,
        historyLogService,
        ToastService,
        exceptionService,
        tenantsApi,
        businessApi,
        auditApi,
        invoiceApi,
        blockUI,
        utils,
        $rootScope
    ) {
        var vm = this;
        vm.payrollCompanies = [];
        vm.registeredBusinessNumberDisplayName = "ABN";
        vm.registeredBusinessNumberMaxCharLimit = 13;
        vm.bankAccountNumberMaxCharLimit = 8;
        vm.isBankBranchCodeVisible = true;
        vm.IsInvoicing = claimsUtilService.isBillingEnabled();
        vm.IsPayroll = claimsUtilService.isPayrollEnabled();
        vm.isMyobEnabled = claimsUtilService.isMyobEnabled();
        vm.isXeroEnabled = claimsUtilService.isXeroEnabled();
        vm.isIntegrationsEnabled = vm.isMyobEnabled || vm.isXeroEnabled;
        vm.isConnectedToIntegrationsProvider = isConnectedToIntegrationsProvider;
        vm.businessId = $stateParams.id;
        vm.BusinessAddress = {};
        vm.payrollBusinessAlreadyExists = $stateParams.payrollBusinessAlreadyExists;
        vm.onCancel = onCancel;
        vm.onSave = onSave;
        vm.onUploadValidate = onUploadValidate;
        vm.getPayrollCompanyName = getPayrollCompanyName;
        vm.redirectToIntegrationsPage = redirectToIntegrationsPage;
        vm.showDeactivateAlert = showDeactivateAlert;
        vm.taxRoundingRules = [];
        vm.viewHistory = viewHistory;

        init();

        async function init() {
            var isConnectedResponse = await integrationsService.getProviders();
            vm.isConnectedToMyob = isConnectedResponse.isConnectedToMyob;
            vm.isConnectedToXero = isConnectedResponse.isConnectedToXero;

            if (vm.isIntegrationsEnabled && (vm.isConnectedToMyob || vm.isConnectedToXero)) {
                vm.isPayrollCompanyDropdownDisabled = true;

                try {
                    const tenantResponse = await integrationsService.getTenants();
                    vm.payrollCompanies = tenantResponse.data;
                } catch (ex) {
                    exceptionService.resolve(ex);
                }
            }

            populateLocalisedSettings();
            populateTaxRoundingRulesDropdown();

            getBusiness();
        }

        function getBusiness() {
            blockUI.start(utils.translate('BUSINESSMODULE.LOADING'));

            return tenantsApi.getBusiness(vm.businessId).then(function(resp) {
                    vm.business = resp.data.fields;
                    blockUI.stop();

                    if (vm.business["LogoUrl"]) {
                        let cacheInvalidationQuerystring = `?time=${new Date().getTime()}`;
                        vm.updatedLogo = vm.business["LogoUrl"] + cacheInvalidationQuerystring;
                    }

                    if (vm.business["BusinessAddress"]) {
                        try {
                            vm.BusinessAddress = JSON.parse(vm.business['BusinessAddress']);
                        } catch (e) {}
                    }

                    if (vm.business["AccountId"] && vm.business["AccountName"] && vm.business["AccountProvider"]) {
                        vm.selectedPayrollCompany = {
                            CompanyId: vm.business["AccountId"],
                            CompanyName: vm.business["AccountName"],
                            ProviderType: vm.business["AccountProvider"]
                        };
                    }

                    if (vm.business["TaxRoundingRule"]) {
                        vm.taxRoundingRule = vm.business["TaxRoundingRule"];
                    }

                    let payrollCompanyAlreadySet = vm.selectedPayrollCompany;
                    if (payrollCompanyAlreadySet) {
                        vm.payrollCompanyContainsSetCompany = vm.payrollCompanies.some(e => e.CompanyId === vm.selectedPayrollCompany.CompanyId);
                        if (!vm.payrollCompanyContainsSetCompany) {
                            vm.payrollCompanies.push(vm.selectedPayrollCompany);
                        }
                    }

                    vm.isPayrollCompanyDropdownDisabled = false;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                    blockUI.stop();
                });
        }

        function onSave(isDeactivating) {
            var formData = new FormData();

            for (var key in vm.business) {
                formData.set(key, vm.business[key]);
            }

            if (vm.selectedPayrollCompany) {
                formData.set('AccountId', vm.selectedPayrollCompany.CompanyId);
                formData.set('AccountName', vm.selectedPayrollCompany.CompanyName);
                formData.set('AccountProvider', vm.selectedPayrollCompany.ProviderType);
            }

            if (vm.BusinessAddress) {
                formData.set('BusinessAddress', JSON.stringify(vm.BusinessAddress));
            }

            if (vm.file) {
                formData.set('LogoUrl', vm.file);
            }

            if (vm.taxRoundingRule) {
                formData.set('TaxRoundingRule', vm.taxRoundingRule);
            }

            businessApi.updateBusiness(vm.businessId, formData)
                .then(function(resp) {
                    var message;
                    if (resp.data) {
                        if (isDeactivating) {
                            message = isDeactivating === 'true' ? 'Deactivated the business successfully.' : 'Activated the business successfully.';
                        } else {
                            message = 'Business details are updated successfully.';
                        }
                    } else {
                        message = 'Failed to update Business details';
                    }

                    ToastService.toast(message);
                    $state.go('app.businesses');
                }).catch(function(e) {
                    blockUI.stop();
                    exceptionService.resolve(e);
                });
        }

        function onUploadValidate(fileObj) {
            const MAX_FILE_SIZE_IN_BYTES = 614400;

            var ext = utils.getFileExtension(fileObj.name);
            var isValid = true;

            if (ext != '.jpeg' && ext != '.jpg' && ext != '.png') {
                isValid = false;
                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(utils.translate('BUSINESSMODULE.FILE_TYPE_ERROR_TITLE'))
                    .content(utils.translate('BUSINESSMODULE.FILE_TYPE_ERROR'))
                    .ariaLabel(utils.translate('BUSINESSMODULE.FILE_TYPE_ERROR_TITLE'))
                    .ok('Ok');

                $mdDialog.show(notif);
                return;
            }

            if (fileObj.size > MAX_FILE_SIZE_IN_BYTES) {
                isValid = false;

                var notif = $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(utils.translate('BUSINESSMODULE.FILE_SIZE_ERROR_TITLE'))
                    .content(utils.translate('BUSINESSMODULE.FILE_SIZE_ERROR'))
                    .ariaLabel(utils.translate('BUSINESSMODULE.FILE_SIZE_ERROR_TITLE'))
                    .ok('Ok');

                $mdDialog.show(notif);
                return;
            }

            vm.file = fileObj;

            return isValid;
        }


        function onCancel() {
            $state.go('app.businesses');
        }

        function getPayrollCompanyName(payrollCompany) {
            if (payrollCompany.ProviderType && payrollCompany.CompanyName) {
                return `${payrollCompany.ProviderType} - ${payrollCompany.CompanyName}`;
            }
        }

        function redirectToIntegrationsPage() {
            $rootScope.state.go('app.integrations');
        }

        function showDeactivateAlert() {
            var isDeactivating = vm.business['IsActive'];

            var title = utils.translate('BUSINESSMODULE.ACTIVATE_TITLE');
            var content = utils.translate('BUSINESSMODULE.ACTIVATE_BUSINESS');
            var okText = utils.translate('BUSINESSMODULE.ACTIVATE_YES');

            if (isDeactivating === 'true') {
                title = utils.translate('BUSINESSMODULE.DEACTIVATE_TITLE');
                content = utils.translate('BUSINESSMODULE.DEACTIVATE_BUSINESS');
                okText = utils.translate('BUSINESSMODULE.DEACTIVATE_YES');
            }

            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(content)
                .ok(okText)
                .cancel(utils.translate('BUSINESSMODULE.DEACTIVATE_NO'));

            $mdDialog.show(confirm)
                .then(function() {
                    vm.business['IsActive'] = isDeactivating == 'true' ? false : true;
                    onSave(isDeactivating);
                });
        }

        function isConnectedToIntegrationsProvider() {
            return vm.isConnectedToMyob || vm.isConnectedToXero;
        }

        function populateTaxRoundingRulesDropdown() {
            return invoiceApi.getTaxRoundingRules().then(function(resp) {
                vm.taxRoundingRules = resp.data;

                if (!vm.taxRoundingRules) {
                    return;
                }

                var defaultRule = vm.taxRoundingRules.find(x => x.Tag === "Default");

                if (!vm.taxRoundingRule && defaultRule) {
                    vm.taxRoundingRule = defaultRule.Id;
                }
            })
        }

        function populateLocalisedSettings() {
            var localeFormatSettings = localisationService.getLocaleFormatSettings();
            vm.registeredBusinessNumberDisplayName = _.find(localeFormatSettings['registeredBusinessNumber'], function(o) {
                return o.settingKey === 'DisplayName';
            }).settingValue;

            vm.registeredBusinessNumberMaxCharLimit = _.find(localeFormatSettings['registeredBusinessNumber'], function(o) {
                return o.settingKey === 'MaxCharLimit';
            }).settingValue;

            vm.bankAccountNumberMaxCharLimit = _.find(localeFormatSettings['bankAccountNumber'], function(o) {
                return o.settingKey === 'MaxCharLimit';
            }).settingValue;

            vm.isBankBranchCodeVisible = _.find(localeFormatSettings['bankBranchCode'], function(o) {
                return o.settingKey === 'IsVisible';
            }).settingValue === 'true';
        }

        async function viewHistory() {
            var response = await auditApi.getAuditEntries(vm.businessId);
            historyLogService.showHistory("Businesses", response.data, vm.business.BusinessName, 'business-history-log-data');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.branch.view', [])
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider
    ) {
        $stateProvider.state('app.branch_view', {
            url: '/branch/view-branch',
            views: {
                'content@app': {
                    templateUrl: 'app/main/branch/view/branch-view.html',
                    controller: 'BranchViewController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasManageBranchesMenu;
                }] 
            },
            title: 'Manage Branches',
            titleBar: 'Alloc8 - Branches',
            resolve: {
                branchesList: function(apiResolver) {
                    return apiResolver.resolve('branches.list@query');
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/branch/view');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.branch.view')
        .controller('BranchViewController', BranchViewController);

    function BranchViewController(
        $state,
        branchesList,
        branchService,
        searchDelay
    ) {
        var vm = this;
        vm.service = branchService;
        vm.dtInstance = {};
        vm.onEdit = onEdit;
        vm.onCreate = onCreate;
        vm.activate = activate;
        vm.searchTable = searchTable;

        function activate() {
            vm.branches = branchesList;
        }

        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'full_numbers',
            searchDelay: searchDelay,
            autoWidth: true,
            responsive: false,
            initComplete: function() {
                searchTable();
            }
        };

        function onEdit(id, branch_name) {
            $state.go('app.branch_update', {
                id: id,
                branch: branch_name
            });
        }

        function searchTable() {
            setTimeout(function() {
                if (vm.service.query) {
                    vm.dtInstance.DataTable.search(vm.service.query);
                    vm.dtInstance.DataTable.search(vm.service.query).draw();
                }
            }, searchDelay);
        }

        function onCreate() {
            $state.go('app.branch_create');
        }

        vm.activate();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.branch', [
            'app.branch.view',
            'app.branch.create'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config(msNavigationServiceProvider) {}

    function runConfig(msNavigationService) {

    }

})();

(function() {
    'use strict';

    angular.module('app.branch')
        .factory('branchService', branchService);

    /** @ngInject */
    function branchService(
        $mdToast,
        branchApi,
        $q,
        utils,
        $state,
        branchDataModel,
        blockUI,
        exceptionService
    ) {
        var service = {
            saveBranch: saveBranch,
            getAllBranches: getAllBranches,
            getBranchesAndStates: getBranchesAndStates,
            getBranchById: getBranchById,
            getBranchBundled: getBranchBundled,
            putBranch: putBranch,
            putBranch2: putBranch2,
            remove: remove,
            removeRequiredAttachmentType: removeRequiredAttachmentType,
            query: null,
            saveTrigger: false,
            linkedFormTemplates: null,
            unlinkedFormTemplates: null,
            overriddenFormTemplates: null,
            formTemplatesListApi: null,
            branchData: new branchDataModel(),
        };

        return service;

        function getAllBranches() {
            var deferred = $q.defer();
            branchApi
                .getBranches()
                .then(function(resp) {
                    deferred.resolve(resp.data)
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                });
            return deferred.promise;
        }

        function getBranchesAndStates() {
            var deferred = $q.defer();
            branchApi
                .getBranchesAndStates()
                .then(function(resp) {
                    deferred.resolve(resp.data);
                }).catch(function(ex) {
                    deferred.reject(ex);
                });
            return deferred.promise;
        }

        function remove(index) {
            service.branchData.Division.splice(index, 1)
        }

        function removeRequiredAttachmentType(index) {
            service.branchData.RequiredAttachmentTypes.splice(index, 1);
        }

        function getBranchById(id) {
            return branchApi.getBranch(id);
        }

        function getBranchBundled(id) {
            return branchApi.getBranchBundled(id);
        }

        function saveBranch() {
            blockUI.start(utils.translate('BRANCH_CREATE.SAVING'));

            if (!service.branchData.Division) {
                service.branchData['Division'] = [];
            }

            service.branchData.CreatedDate = utils.jsDateTimeToEpoch(service.branchData.CreatedDate);
            branchApi.postBranch(service.branchData).then(function() {
                blockUI.stop();
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(utils.translate('BRANCH_CREATE.BRANCH_SAVED'))
                    .position('bottom right')
                    .hideDelay(1500)
                ).then(function() {
                    $state.go('app.branch_view');
                });
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
            });
        }

        function putBranch() {
            blockUI.start(utils.translate('BRANCH_CREATE.SAVING'));
            service.branchData.CreatedDate = utils.jsDateTimeToEpoch(service.branchData.CreatedDate);
            branchApi
                .putBranch(service.branchData.id, service.branchData)
                .then(function() {
                    blockUI.stop();

                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(utils.translate('BRANCH_CREATE.BRANCH_SAVED'))
                        .position('bottom right')
                        .hideDelay(1500)
                    );
                })
                .catch(function(e) {
                    blockUI.stop();
                    exceptionService.resolve(e);
                });;
        }

        function putBranch2() {
            service.branchData.CreatedDate = utils.jsDateTimeToEpoch(service.branchData.CreatedDate);
            return branchApi.putBranch(service.branchData.id, service.branchData);
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.branch')
    .service('LocationModel', LocationModel);

  /** @ngInject */
  function LocationModel() {
    return function () {
      var self = this
        , defaults = {
        Type : null,
        Latitude : null,
        Longitude : null
    };

      self.map = mapper;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend({}, defaults, mapValue);

        self.Type = opts.Type;
        self.Latitude = opts.Latitude;
        self.Longitude = opts.Longitude;
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.branch')
    .service('branchDataModel', branchDataModel);

  /** @ngInject */
  function branchDataModel() {
    return function () {
      var self = this;

      var defaults = {
        id: null,
        Name: null,
        EmployeeCodePrefix: null,
        Address: null,
        Suburb: null,
        State: null,
        Postcode: null,
        Phone: null,
        Fax: null,
        CreatedDate: null,
        CustomFields: [],
        CustomFieldsValues: [],
        Division: [],
        RequiredAttachmentTypes: [],
        Award: null,
        AddressPrefix: null,
        Timezone: null,
        CostCentre: null,
        Location: {},
        MyobCompany: null,
        Emails: [],
        SendPaperworkToSiteContact: true,
        AltusPaperworkForInvoiceEmail: false
      };

      self.mapBranchData = mapper;
      self.reset = reset;
      self.mapBranchData();

      function reset() {
        this.id = null;
        this.Name = null;
        this.EmployeeCodePrefix = null;
        this.Address = null;
        this.Suburb = null;
        this.State = null;
        this.Postcode = null;
        this.Phone = null;
        this.Fax = null;
        this.CreatedDate = null;
        this.CustomFields = [];
        this.CustomFieldsValues = [];
        this.Division = [];
        this.RequiredAttachmentTypes = [];
        this.Award = null;
        this.AddressPrefix = null;
        this.Timezone = null;
        this.CostCentre = null;
        this.Location = {};
        this.MyobCompany = null;
        this.Emails = [];
        this.SendPaperworkToSiteContact = true;
        this.AltusPaperworkForInvoiceEmail = false;
        this.IsActive = true;
        this.IsArchived = false;
        this.BuildingName = null;
        this.UnitNumber = null;
        this.StreetNumber = null;
        this.StreetName = null;
        this.Country = null;
        this.PublicHolidays = {};
        this.UnlinkedFormTemplates = [];
        this.LinkedFormTemplates = [];
        this.OverriddenFormTemplates = [];
        this.InvoicingBusiness = {};
      }

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend({}, defaults, mapValue);

        self.id = opts.id;
        self.Name = opts.Name;
        self.EmployeeCodePrefix = opts.EmployeeCodePrefix;
        self.Address = opts.Address;
        self.Suburb = opts.Suburb;
        self.State = opts.State;
        self.Postcode = opts.Postcode;
        self.Phone = opts.Phone;
        self.Fax = opts.Fax;
        self.CreatedDate = opts.CreatedDate;
        self.CustomFields = opts.CustomFields;
        self.CustomFieldsValues = opts.CustomFieldsValues;
        self.Division = opts.Division;
        self.RequiredAttachmentTypes = opts.RequiredAttachmentTypes;
        self.Award = opts.Award;
        self.AddressPrefix = opts.AddressPrefix;
        self.Timezone = opts.Timezone;
        self.CostCentre = opts.CostCentre;
        self.Location = opts.Location;
        self.MyobCompany = opts.MyobCompany;
        self.Emails = opts.Emails;
        self.SendPaperworkToSiteContact = opts.SendPaperworkToSiteContact;
        self.AltusPaperworkForInvoiceEmail = opts.AltusPaperworkForInvoiceEmail;
        self.IsActive = opts.IsActive;
        self.IsArchived = opts.IsArchived;
        self.BuildingName = opts.BuildingName;
        self.UnitNumber = opts.UnitNumber;
        self.StreetNumber = opts.StreetNumber;
        self.StreetName = opts.StreetName;
        self.Country = opts.Country;
        self.PublicHolidays = opts.PublicHolidays;
        self.UnlinkedFormTemplates = opts.UnlinkedFormTemplates;
        self.LinkedFormTemplates = opts.LinkedFormTemplates;
        self.OverriddenFormTemplates = opts.OverriddenFormTemplates;
        self.InvoicingBusiness = opts.InvoicingBusiness;
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.branch.create')
        .controller('BranchCreateController', BranchCreateController);

    function BranchCreateController(
        $scope,
        branchService,
        $stateParams,
        LocationModel,
        utils,
        blockUI,
        $mdDateLocale,
        $timeout,
        claimsUtilService,
        localisationService,
        businessesService,
        adminClaimsService
    ) {
        var vm = this;
        vm.disableForm = false;
        vm.branchData = branchService.branchData;
        vm.fields = [];
        vm.formTypes = [0, 2]; // Job and Worker type
        vm.service = branchService;
        vm.maxDate = new Date();
        vm.isEditMode = false;
        vm.showFields = true;
        vm.claimsUtilService = claimsUtilService;
        vm.isXeroEnabled = vm.claimsUtilService.isXeroEnabled();
        vm.isConfigurableRequiredAttachmentsEnabled = claimsUtilService.isConfigurableRequiredAttachmentsEnabled();
        vm.adminClaimsService = adminClaimsService;
        vm.dateFormat = utils.setDateFormat();
        vm.countryGmap = null;
        vm.branchId = $stateParams.id;
        vm.service.linkedFormTemplates = null;
        vm.service.unlinkedFormTemplates = null;
        vm.service.overriddenFormTemplates = null;
        vm.service.formTemplatesListApi = {};
        vm.service.vehicles = null;
        vm.service.assets = null;
        vm.hasDocumentsManagerBranches = adminClaimsService.hasDocumentsManagerBranches;
        vm.isBranchSettingsSectionVisible = (claimsUtilService.isPaperworkEmailEnabled() && claimsUtilService.isSiteContactEmailNotificationEnabled()) ||
            claimsUtilService.isAltusSpecialEnabled();

        vm.isSendPaperworkToSiteContactOptionVisible = claimsUtilService.isPaperworkEmailEnabled() &&
            claimsUtilService.isSiteContactEmailNotificationEnabled();

        $mdDateLocale.formatDate = function(date) {
            return utils.formatToLocaleDate(date, vm.dateFormat);
        }
        $mdDateLocale.parseDate = function(dateString) {
            return utils.parseToLocaleDate(dateString, vm.dateFormat);
        };

        //Methods
        vm.saveBranch = saveBranch;
        vm.callBack = callBack;
        vm.checkIfInvoicingBusinessIsNull = checkIfInvoicingBusinessIsNull;

        init();

        function callBack(result) {
            angular.forEach(result.address_components, function(component) {
                if (component.types[0] == "administrative_area_level_1") {
                    vm.service.branchData.State = component.short_name;
                }
                if (component.types[0] == "postal_code") {
                    vm.service.branchData.Postcode = component.long_name;
                }
                if (component.types[0] == "locality") {
                    vm.service.branchData.Suburb = component.long_name;
                }
            });
            vm.service.branchData.Location = new LocationModel();
            vm.service.branchData.Location.Type = "point";
            vm.service.branchData.Location.Latitude = result.geometry.location.lat();
            vm.service.branchData.Location.Longitude = result.geometry.location.lng();
        }

        function init() {
            var localeFormatSettings = localisationService.getLocaleFormatSettings();
            vm.countryGmap = localeFormatSettings.gmapCountry;

            vm.date = moment(new Date())
                .format(vm.format);

            if (angular.isDefined($stateParams.id)) {
                blockUI.start(utils.translate('BRANCH_CREATE.LOADING'));
                vm.isEditMode = true;

                branchService
                    .getBranchBundled($stateParams.id)
                    .then(function(resp) {
                        vm.service.branchData.mapBranchData(resp[0].data.m_Item1);
                        vm.fields = resp[0].data.m_Item2;
                        vm.awards = resp[0].data.m_Item3.filter(function(award) {
                            if (!award.IsArchived || award.Id == resp[0].data.m_Item1.Award.Id) {
                                return award;
                            }
                        });
                        vm.timezones = resp[1].data;

                        vm.service.branchData.CreatedDate = utils.epochToJsDateTime(vm.service.branchData.CreatedDate);
                        vm.service.linkedFormTemplates = vm.service.branchData.LinkedFormTemplates;
                        vm.service.unlinkedFormTemplates = vm.service.branchData.UnlinkedFormTemplates;
                        vm.service.overriddenFormTemplates = vm.service.branchData.OverriddenFormTemplates;

                        populateInvoicingBusinessesDropDown();

                        blockUI.stop();
                    });
            } else {
                vm.isEditMode = false;
                vm.service.branchData.reset();

                branchService
                    .getBranchBundled()
                    .then(function(resp) {
                        vm.awards = resp[0].data.m_Item3.filter(x=> !x.IsArchived);
                        vm.timezones = resp[1].data;
                        vm.fields = resp[0].data.m_Item2;

                        blockUI.stop();
                    });

                populateInvoicingBusinessesDropDown();
            }
        };

        function populateInvoicingBusinessesDropDown() {
            businessesService.getBusinesses()
                .then(resp => {
                    let allBusinesses = resp.data;

                    vm.invoicingBusinesses = allBusinesses.filter(b => b.fields["IsActive"] === 'true');
                    if (!vm.invoicingBusinesses) return;

                    vm.invoicingBusinesses = vm.invoicingBusinesses.map(b => ({
                        id: b.id,
                        fields: {
                            BusinessName: b.fields["BusinessName"]
                        }
                    }));

                    let invoicingBusinessAlreadySet = !!vm.service.branchData && !!vm.service.branchData.InvoicingBusiness;
                    if (!invoicingBusinessAlreadySet) {
                        checkIfInvoicingBusinessIsNull();
                        return;
                    }

                    let selectedInvoicingBusinessInListOfAllBusinesses = vm.invoicingBusinesses.some(business => business.id === vm.service.branchData.InvoicingBusiness.Id);
                    if (selectedInvoicingBusinessInListOfAllBusinesses) {
                        return;
                    }

                    vm.invoicingBusinesses.unshift({
                        id: vm.service.branchData.InvoicingBusiness.Id,
                        fields: {
                            BusinessName: vm.service.branchData.InvoicingBusiness.Fields["BusinessName"]
                        }
                    });
                });
        }

        function saveBranch() {
            $scope.isSaving = true;

            branchService.saveTrigger = !branchService.saveTrigger;

            branchService.branchData.OverriddenFormTemplates = Object.keys(vm.service.formTemplatesListApi).length > 0 ? Array.from(vm.service.formTemplatesListApi.getOverriddenTemplatesToSave()) : {};
            branchService.branchData.LinkedFormTemplates = Array.isArray(vm.service.linkedFormTemplates) ? Array.from(vm.service.linkedFormTemplates) : vm.service.linkedFormTemplates;
            branchService.branchData.UnlinkedFormTemplates = Array.isArray(vm.service.unlinkedFormTemplates) ? Array.from(vm.service.unlinkedFormTemplates) : vm.service.unlinkedFormTemplates;

            $timeout(function() {
                if (vm.isEditMode) {
                    branchService.putBranch();
                } else {
                    branchService.saveBranch();
                }
            });

            $scope.currentForm.$setPristine();
        }

        function checkIfInvoicingBusinessIsNull() {
            if (!vm.service.branchData.InvoicingBusiness) {
                $scope.currentForm.InvoicingBusiness.$setValidity("required", false);
            }
        };

        $scope.$watch("vm.service.branchData", function(modelAfterChange, modelBeforeChange, scope) {

            let isInEditModeButDataNotLoaded = !modelBeforeChange || modelBeforeChange.id === null;
            if (isInEditModeButDataNotLoaded) {
                modelBeforeChange = modelAfterChange;
                return;
            }

            let hasModelChanged = (modelBeforeChange !== modelAfterChange);
            if (!hasModelChanged) {
                return;
            }

            let beforeModelChangeAward = modelBeforeChange.Award;
            let afterModelChangeAward = modelAfterChange.Award;

            let hasAwardBeenSetOnBeforeAndAfter = beforeModelChangeAward && afterModelChangeAward;
            if (!hasAwardBeenSetOnBeforeAndAfter) {
                return;
            }

            let hasAwardBeenChanged = beforeModelChangeAward.Id !== afterModelChangeAward.Id;
            if (hasAwardBeenChanged) {
                return;
            }

            delete modelBeforeChange.Award;
            delete modelAfterChange.Award;
            let hasModelChangedExclAward = JSON.stringify(modelBeforeChange) !== JSON.stringify(modelAfterChange);

            if (hasModelChangedExclAward) {
                modelAfterChange.Award = afterModelChangeAward;
                modelBeforeChange.Award = beforeModelChangeAward;
                return;
            }

            // Look up has caused the model to be updated although the award and the fields are the same
            // The user did not make any changes to the form
            // Let's mark the form as pristine
            modelAfterChange.Award = afterModelChangeAward;
            modelBeforeChange = modelAfterChange;
            scope.currentForm.$setPristine();
        }, true);
    }
})();

(function() {
    'use strict';

    angular.module('app.attachmentTypes', ['app.api'])
        .config(config)
        .run(runConfig);

    function runConfig(msNavigationService, adminClaimsService) {

    }

    function config($stateProvider) {
        $stateProvider
            .state('app.attachment_types', {
                url: '/attachment-types',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/attachmentTypes/view/attachment-types-view.html',
                        controller: 'AttachmentTypesViewController as vm'
                    }
                },
                title: 'Manage Attachment Types',
                titleBar: 'Alloc8 - Manage Attachment Types',
                data: {
                    requireLogin: true,
                    validateAccess: ['adminClaimsService', 'claimsUtilService', function (adminClaimsService, claimsUtilService) {
                        return adminClaimsService.hasAdminMenu && claimsUtilService.isConfigurableRequiredAttachmentsEnabled();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular.module('app.attachmentTypes')
        .controller('manageAttachmentTypeDialogController', manageAttachmentTypeDialogController);

    /** @ngInject */
    function manageAttachmentTypeDialogController($mdDialog, attachmentTypesApi, exceptionService, attachmentType, fileTypeOptions) {
        var vm = this;

        var isEditMode = !!attachmentType;

        vm.dialogTitle = isEditMode ? 'Edit Attachment Type' : 'Add Attachment Type';
        vm.fileTypeOptions = fileTypeOptions || [];
        vm.isSaving = false;

        vm.model = isEditMode ? {
            Id: attachmentType.Id,
            Name: attachmentType.Name,
            Description: attachmentType.Description,
            SupportedFileTypes: attachmentType.SupportedFileTypes || [],
            IsActive: attachmentType.IsActive
        } : {
            Name: null,
            Description: null,
            SupportedFileTypes: [],
            IsActive: true
        };

        vm.onClose = onClose;
        vm.save = save;

        function onClose() {
            $mdDialog.hide();
        }

        function save() {
            var isDeactivating = isEditMode && attachmentType.IsActive && !vm.model.IsActive;

            if (isDeactivating) {
                var confirm = $mdDialog.confirm()
                    .title('Deactivate Attachment Type')
                    .textContent('Deactivating this attachment type will remove it from all branches and companies where it is currently required. Are you sure you want to continue?')
                    .ok('Deactivate')
                    .cancel('Cancel')
                    .multiple(true);

                $mdDialog.show(confirm).then(function() {
                    submitSave();
                });
            } else {
                submitSave();
            }
        }

        function submitSave() {
            vm.isSaving = true;
            var promise = isEditMode
                ? attachmentTypesApi.updateAttachmentType(vm.model.Id, vm.model)
                : attachmentTypesApi.createAttachmentType(vm.model);

            promise.then(function() {
                $mdDialog.hide(isEditMode ? 'updated' : 'created');
            }).catch(function(err) {
                vm.isSaving = false;
                exceptionService.resolve(err);
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.attachmentTypes')
        .factory('attachmentTypesViewService', attachmentTypesViewService);

    /** @ngInject */
    function attachmentTypesViewService(
        $mdDialog,
        attachmentTypesApi
    ) {
        var service = {
            attachmentTypes: [],
            fileTypeOptions: [],
            isLoading: true,
            loadError: false,
            load: load,
            getFileTypeNames: getFileTypeNames,
            showDialog: showDialog,
            editAttachmentType: editAttachmentType
        };

        return service;

        function load() {
            loadAttachmentTypes();
            loadSupportedFileTypes();
        }

        function loadAttachmentTypes() {
            service.isLoading = true;
            service.loadError = false;
            return attachmentTypesApi.getAttachmentTypes().then(function(resp) {
                service.attachmentTypes = resp.data || [];
                service.isLoading = false;
            }).catch(function() {
                service.attachmentTypes = [];
                service.isLoading = false;
                service.loadError = true;
            });
        }

        function loadSupportedFileTypes() {
            return attachmentTypesApi.getSupportedFileTypes().then(function(resp) {
                service.fileTypeOptions = resp.data || [];
            }).catch(function() {
                service.fileTypeOptions = [];
            });
        }

        function getFileTypeNames(fileTypeIds) {
            if (!fileTypeIds || !service.fileTypeOptions.length) return '';
            return fileTypeIds.map(function(id) {
                var match = service.fileTypeOptions.find(function(opt) { return opt.Id === id; });
                return match ? match.Value : id;
            }).join(', ');
        }

        function showDialog() {
            $mdDialog.show({
                templateUrl: 'app/main/attachmentTypes/view/manage-attachment-type-dialog.html',
                controller: 'manageAttachmentTypeDialogController as vm',
                locals: {
                    attachmentType: null,
                    fileTypeOptions: service.fileTypeOptions
                }
            }).then(function() {
                loadAttachmentTypes();
            });
        }

        function editAttachmentType(item) {
            $mdDialog.show({
                templateUrl: 'app/main/attachmentTypes/view/manage-attachment-type-dialog.html',
                controller: 'manageAttachmentTypeDialogController as vm',
                locals: {
                    attachmentType: item,
                    fileTypeOptions: service.fileTypeOptions
                }
            }).then(function() {
                loadAttachmentTypes();
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.attachmentTypes')
        .controller('AttachmentTypesViewController', AttachmentTypesViewController);

    function AttachmentTypesViewController(
        $scope,
        $timeout,
        searchDelay,
        attachmentTypesViewService
    ) {
        var vm = this;
        vm.service = attachmentTypesViewService;
        vm.dtInstance = {};
        vm.searchTable = searchTable;
        vm.showDialog = showDialog;
        vm.editAttachmentType = editAttachmentType;
        vm.getFileTypeNames = getFileTypeNames;

        vm.dtOptions = {
            dom: 'rt<"bottom"lip><"clear">',
            pagingType: 'full_numbers',
            autoWidth: false,
            responsive: true,
            order: [0, 'asc'],
            pageLength: 10,
            lengthChange: true
        };

        vm.service.load();

        var searchTimeout;

        $scope.$on('$destroy', function() {
            if (searchTimeout) $timeout.cancel(searchTimeout);
        });

        function searchTable() {
            searchTimeout = $timeout(function() {
                vm.dtInstance.DataTable.search(vm.query);
                vm.dtInstance.DataTable.search(vm.query).draw();
            }, searchDelay);
        }

        function showDialog() {
            vm.service.showDialog();
        }

        function editAttachmentType(item) {
            vm.service.editAttachmentType(item);
        }

        function getFileTypeNames(fileTypeIds) {
            return vm.service.getFileTypeNames(fileTypeIds);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.awards.interpreter')
        .factory('awardInterpreterService', awardInterpreterService);

    /** @ngInject */
    function awardInterpreterService(
        awardsApi,
        utils,
        branchApi,
        payrollSettingsApi,
        exceptionService,
        payrollErrorCodes,
        signalRService,
        awardInterpreterGridService,
        $rootScope,
        msgboxService
    ) {
        var service = {
            isPageInitialLoad: true,
            isProcessing: false,
            isPageLoaded: false,
            interpreterSettings: {},
            showPayruns: true,
            showPayrunSettings: false,
            query: null,
            payrollRecords: [],
            branches: [],
            fileExtension: "csv",
            hasPayrollErrors: false,
            revalidateAll: false,
            isFailedToInterpret: false,
            isFailedToExport: false,
            hasOtherPayrunInProgress: false,
            recordsHaveBeenValidated: false,
            interpretPayroll: interpretPayroll,
            validatePayroll: validatePayroll,
            initialize: initialize,
            exportToFile: exportToFile,
            exportToExternalProvider: exportToExternalProvider,
            reExport: reExport,
            handleGridLoadComplete: handleGridLoadComplete,
            widgets: [],
            progressBarCurrent: 0,
            progressBarMax: 0,
            progressBarMessage: null,
            currentInterpretJobId: null,
            exportSalaryCodes: false,
            exportPermanentParttimeTopups: false,
            exportPermanentParttimePublicHolidayTopups: false,
            exportPermanentFulltimeTopups: false,
            exportPermanentFulltimePublicHolidayTopups: false,
            exportCalendarEntryTopups: false,
            overwriteExistingTimesheetsWhenExporting: false,
            revalidateAllTimesheets: false,
            payrollInterpretJobs: [],
            namesOfEmployeesWithMoreThan30Lines: [],
            resetPayrollSettings: resetPayrollSettings,
            selectedBranches: [],
            selectedPayrollCompany: null,
            userHasAccessToPayrollCompany: false,
            onResultsFilterOptionChange: onResultsFilterOptionChange,
            filterOptions: ['All', 'Errored', 'Ready', 'Exported'],
            resultsFilterOption: 'All'
        };

        $rootScope.$on("payrollInterpretationStarted", onPayrollInterpretationStarted);
        $rootScope.$on("payrollInterpretationInProgress", onPayrollInterpretationInProgress);
        $rootScope.$on("payrollInterpretationCompleted", onPayrollInterpretationCompleted);

        $rootScope.$on("payrollValidationStarted", onPayrollValidationStarted);
        $rootScope.$on("payrollValidationInProgress", onPayrollValidationInProgress);
        $rootScope.$on("payrollValidationCompleted", onPayrollValidationCompleted);

        $rootScope.$on("payrollExportStarted", onPayrollExportStarted);
        $rootScope.$on("payrollExportInProgress", onPayrollExportInProgress);
        $rootScope.$on("payrollExportCompleted", onPayrollExportCompleted);

        return service;

        async function initialize() {
            service.isFailedToInterpret = false;
            service.isFailedToExport = false;
            service.isProcessing = true;
            service.progressBarMessage = utils.translate('RUN_PAYROLL.INITIALIZE');
            service.progressBarErrorMessage = null;
            service.hasPayrollErrors = false;
            service.hasOtherPayrunInProgress = false;
            service.recordsHaveBeenValidated = false;
            service.payrollRecords = [];
            service.showPayruns = true;
            service.showPayrunSettings = false;
            service.totalProcessedEmployees = 0;
            service.totalEmployees = 0;

            service.progressBarCurrent = 0;
            service.progressBarMax = 0;

            service.currentInterpretJobId = null;
            service.widgets = [{
                    id: "1",
                    displayName: "Employees in this Payrun",
                    type: "Number",
                    cssClasses: "",
                    value: 0
                },
                {
                    id: "2",
                    displayName: "Employees ready to export",
                    type: "Number",
                    cssClasses: "md-light-blue-800-bg white-fg",
                    value: 0
                },
                {
                    id: "3",
                    displayName: "Employees with payroll errors",
                    type: "Number",
                    cssClasses: "deep-orange-bg white-fg",
                    value: 0
                },
                {
                    id: "4",
                    displayName: "Employees exported in this Payrun",
                    type: "Number",
                    cssClasses: "green-bg white-fg",
                    value: 0
                }
            ];

            service.startDate = utils.getStartOfWeek(new Date());
            service.endDate = utils.getEndOfWeek(new Date());

            service.exportSalaryCodes = true;
            service.exportPermanentParttimeTopups = true;
            service.exportPermanentParttimePublicHolidayTopups = true;
            service.exportPermanentFulltimeTopups = true;
            service.exportPermanentFulltimePublicHolidayTopups = true;
            service.exportCalendarEntryTopups = true;
            service.overwriteExistingTimesheetsWhenExporting = false;
            service.revalidateAllTimesheets = false;

            service.payrollInterpretJobs = [];
            service.namesOfEmployeesWithMoreThan30Lines = [];

            if (service.isPageLoaded) {
                service.isProcessing = false;
                service.progressBarMessage = null;
                return;
            }

            const branchesResponse = await branchApi.getBranchesAndStates();
            service.branches = branchesResponse.data;

            const fileExtensionResponse = payrollSettingsApi.getFileExtension();
            service.fileExtension = fileExtensionResponse.data;

            if (!signalRService.isConnected) {
                signalRService.connect();
            }

            service.isProcessing = false;
            service.isPageLoaded = true;
            service.progressBarMessage = null;
        }

        async function interpretPayroll() {
            service.isProcessing = true;
            service.isFailedToInterpret = false;
            service.payrollRecords = [];

            service.progressBarMax = 0;
            service.progressBarCurrent = 0;

            service.progressBarMessage = utils.translate('RUN_PAYROLL.INTERPRETING');
            service.progressBarErrorMessage = null;

            try {
                await awardsApi.deleteTemporaryInterpretedShifts(service.interpreterSettings);

                await signalRService.messageHub.invoke('InterpretPayroll', service.interpreterSettings)
                    .fail(err => {
                        service.isProcessing = false;
                        service.isFailedToInterpret = true;
                        service.totalEmployees = 0;
                        service.totalProcessedEmployees = 0;

                        service.payrollRecords = [];

                        exceptionService.resolve(err);
                    });
            } catch (ex) {
                const exceptionMessage = exceptionService.getExceptionMessage(ex);

                $rootScope.$apply(() => {
                    service.isProcessing = false;
                    service.isFailedToInterpret = true;
                    service.payrollRecords = [];

                    service.progressBarMax = 0;
                    service.progressBarCurrent = 0;

                    service.progressBarMessage = 'Interpreting failed.';
                    service.progressBarErrorMessage = exceptionMessage;
                });
            }
        }

        async function validatePayroll() {
            service.isProcessing = true;

            service.progressBarMax = 0;
            service.progressBarCurrent = 0;

            service.progressBarMessage = utils.translate('RUN_PAYROLL.VALIDATING');
            service.progressBarErrorMessage = null;

            try {
                await signalRService.messageHub.invoke('ValidatePayroll', service.interpreterSettings);
            } catch (ex) {
                const exceptionMessage = exceptionService.getExceptionMessage(ex);

                $rootScope.$apply(() => {
                    recheckPayrollRecords();

                    service.isProcessing = false;

                    service.progressBarMax = 0;
                    service.progressBarCurrent = 0;

                    service.progressBarMessage = 'Validation failed.';
                    service.progressBarErrorMessage = exceptionMessage;
                });
            }
        }

        async function exportToExternalProvider() {
            service.isProcessing = true;

            service.progressBarMax = 0;
            service.progressBarCurrent = 0;

            service.progressBarMessage = utils.translate('RUN_PAYROLL.EXPORTING_TIMESHEETS');
            service.progressBarErrorMessage = null;

            try {
                await signalRService.messageHub.invoke('ExportPayroll', service.interpreterSettings);
            } catch (ex) {
                const exceptionMessage = exceptionService.getExceptionMessage(ex);
                const hasAnotherPayrunInProgress = exceptionMessage.indexOf("A payrun is in progress for these branches") != -1;

                $rootScope.$apply(() => {
                    recheckPayrollRecords();

                    service.isProcessing = false;
                    service.isFailedToExport = true;
                    service.hasOtherPayrunInProgress = hasAnotherPayrunInProgress;

                    service.progressBarMax = 0;
                    service.progressBarCurrent = 0;

                    service.progressBarMessage = 'Exporting failed. Please revalidate before exporting again.';
                    service.progressBarErrorMessage = exceptionMessage;
                });
            }
        }

        function handleGridLoadComplete(data) {
            const hasData = data != null && data.length > 0;

            if (hasData) {
                angular.forEach(data, function(p) {
                    service.payrollRecords.push(p);
                });

                recheckPayrollRecords();
            }
        }

        function recheckPayrollRecords() {
            var erroredRecords = getErroredPayrollRecords();
            var readyToExportRecords = getPayrollRecordsReadyToExport();
            var exportedRecords = getExportedPayrollRecords();

            service.hasPayrollErrors = erroredRecords.length > 0;

            if (service.isFailedToExport) {
                service.revalidateAllTimesheets = true;
            }

            const employeesReadyToExport = getEmployeeIdsFromPayrollRecords(readyToExportRecords);
            const employeesWithErrors = getEmployeeIdsFromPayrollRecords(erroredRecords);
            const employeesReadyToExportWithErrors = employeesReadyToExport.filter(p => employeesWithErrors.includes(p));

            service.widgets[0].value = getEmployeeIdsFromPayrollRecords(service.payrollRecords).length;
            service.widgets[1].value = employeesReadyToExport.length;
            service.widgets[1].secondaryText = `${employeesReadyToExportWithErrors.length} with payroll errors`;
            service.widgets[2].value = employeesWithErrors.length;
            service.widgets[3].value = getEmployeeIdsFromPayrollRecords(exportedRecords).length;
        }

        function getEmployeeIdsFromPayrollRecords(payrollRecords) {
            var employeeIds = payrollRecords
                .map(p => p.EmployeeId)
                .filter((element, index, array) => {
                    return array.indexOf(element) === index;
                });

            return employeeIds;
        }

        function exportToFile() {
            service.isProcessing = true;
            service.progressBarMessage = utils.translate('RUN_PAYROLL.EXPORTING');

            awardsApi._export(service.interpreterSettings).then(function(resp) {
                resp.data.forEach(file => {
                    let anchor = angular.element('<a/>');
                    let str = ".xls";
                    let contentType = file.MimeType;
                    let blob = new Blob([file.Content]);
                    let blobURL = window.URL.createObjectURL(blob);
                    let hrefContent = (str.indexOf(file.FileName) >= 0) ? blobURL : 'data:' + contentType + ';charset=utf-8,' + encodeURI(file.Content);

                    anchor.attr({
                        href: hrefContent,
                        target: '_blank',
                        download: file.FileName
                    })[0].click();
                });
                
                service.isProcessing = false;
                service.progressBarMessage = utils.translate('RUN_PAYROLL.EXPORT_COMPLETED');
            }).catch(function(ex) {
                service.isProcessing = false;
                exceptionService.resolve(ex);
            });
        }

        function reExport() {
            service.isProcessing = true;
            service.progressBarMessage = utils.translate('RUN_PAYROLL.REEXPORTING');

            awardsApi.reExport(service.interpreterSettings).then(function(resp) {
                resp.data.forEach(file => {
                    let anchor = angular.element('<a/>');
                    let str = ".xls";
                    let contentType = file.MimeType;
                    let blob = new Blob([file.Content]);
                    let blobURL = window.URL.createObjectURL(blob);
                    let hrefContent = (str.indexOf(file.FileName) >= 0) ? blobURL : 'data:' + contentType + ';charset=utf-8,' + encodeURI(file.Content);

                    anchor.attr({
                        href: hrefContent,
                        target: '_blank',
                        download: file.FileName
                    })[0].click();
                });

                service.isProcessing = false;
                service.progressBarMessage = utils.translate('RUN_PAYROLL.REEXPORT_COMPLETED');
            }).catch(function(ex) {
                service.isProcessing = false;
                exceptionService.resolve(ex);
            });
        }

        function resetPayrollSettings() {
            service.startDate = utils.getStartOfWeek(new Date());
            service.endDate = utils.getEndOfWeek(new Date());

            service.exportSalaryCodes = true;
            service.exportPermanentParttimeTopups = true;
            service.exportPermanentParttimePublicHolidayTopups = true;
            service.exportPermanentFulltimeTopups = true;
            service.exportPermanentFulltimePublicHolidayTopups = true;
            service.exportCalendarEntryTopups = true;
            service.overwriteExistingTimesheetsWhenExporting = false;
            service.revalidateAllTimesheets = false;
        }

        function onPayrollInterpretationStarted(evt, args) {
            let totalEmployees = args.EmployeeCount;
            let interpretJobId = args.InterpretJobId;

            $rootScope.$apply(() => {
                if (totalEmployees == 0) {
                    service.isProcessing = false;

                    service.totalProcessedEmployees = 0;
                    service.totalEmployees = 0;
                    service.progressBarCurrent = 0;
                    service.progressBarMax = 0;

                    msgboxService.alert(
                        utils.translate('RUN_PAYROLL.INTERPRET_PAYROLL_TITLE'),
                        utils.translate('RUN_PAYROLL.NO_TIMESHEET_FOUND'),
                        utils.translate('RUN_PAYROLL.OK'));

                    return;
                }

                service.isProcessing = true;
                service.progressBarMessage = 'Interpreting...';
                service.progressBarCurrent = 0;
                service.progressBarMax = totalEmployees;
                service.currentInterpretJobId = interpretJobId;
            });
        }

        function onPayrollInterpretationInProgress(evt, args) {
            let interpreterOutputs = args.InterpreterOutputs;

            service.progressBarCurrent = args.TotalEmployeeProcessed;
            service.progressBarMessage = `Interpreting payroll...`;

            if (interpreterOutputs) {
                awardInterpreterGridService.grid.concatenateToCollection(interpreterOutputs);
                service.payrollRecords = service.payrollRecords.concat(interpreterOutputs);
            }
        }

        function onPayrollInterpretationCompleted(evt, args) {
            let isSuccessful = args.IsSuccessful;

            $rootScope.$apply(() => {
                recheckPayrollRecords();

                service.isProcessing = false;
                service.isFailedToInterpret = !isSuccessful;

                if (isSuccessful) {
                    service.progressBarMessage = 'Interpretation completed.';
                } else {
                    service.progressBarMessage = 'Interpretation failed.';
                    service.progressBarErrorMessage = `${args.ErrorMessage}`;
                }
            });
        }

        function onPayrollValidationStarted(evt, args) {
            let totalEmployees = args.EmployeeCount;

            if (totalEmployees == 0) {
                service.isProcessing = false;

                service.progressBarCurrent = 0;
                service.progressBarMax = 0;

                msgboxService.alert(
                    utils.translate('RUN_PAYROLL.VALIDATE_PAYROLL_TITLE'),
                    utils.translate('RUN_PAYROLL.NO_TIMESHEET_FOUND'),
                    utils.translate('RUN_PAYROLL.OK'));

                return;
            }

            service.isProcessing = true;
            service.recordsHaveBeenValidated = false;
            service.progressBarMessage = 'Validating...';
            service.progressBarCurrent = 0;
            service.progressBarMax = totalEmployees;
        }

        function onPayrollValidationInProgress(evt, args) {
            let payrollValidateEntry = args.PayrollValidateResultEntry;

            if (payrollValidateEntry) {
                service.payrollRecords.forEach(payLine => {
                    if (payrollValidateEntry.EmployeeId !== payLine.EmployeeId) {
                        return;
                    }

                    let payrollErrors = payrollValidateEntry.OutputIdsPayrollErrors[payLine.Id];
                    payLine.PayrollErrors = payrollErrors;
                    payLine.IsValidated = true;
                });
            }

            onResultsFilterOptionChange();

            service.progressBarCurrent++;
            service.progressBarMessage = `Validating payroll for ${service.progressBarMax} employees...`;
        }

        function onPayrollValidationCompleted(evt, args) {
            let isSuccessful = args.IsSuccessful;

            $rootScope.$apply(() => {
                recheckPayrollRecords();

                service.isProcessing = false;
                service.recordsHaveBeenValidated = true;

                if (isSuccessful) {
                    service.progressBarMessage = `Validation completed.`;
                } else {
                    service.progressBarMessage = `Validation failed.`;
                    service.progressBarErrorMessage = `${args.ErrorMessage}`;
                }
            });
        }

        function onPayrollExportStarted(evt, args) {
            let totalEmployees = args.EmployeeCount;

            if (totalEmployees == 0) {
                service.isProcessing = false;

                service.progressBarCurrent = 0;
                service.progressBarMax = 0;

                msgboxService.alert(
                    utils.translate('RUN_PAYROLL.EXPORT_PAYROLL_TITLE'),
                    utils.translate('RUN_PAYROLL.NO_TIMESHEET_FOUND'),
                    utils.translate('RUN_PAYROLL.OK'));

                return;
            }

            service.isProcessing = true;
            service.progressBarMessage = 'Exporting...';
            service.progressBarCurrent = 0;
            service.progressBarMax = totalEmployees;
        }

        function onPayrollExportInProgress(evt, args) {
            let payrollExportEntry = args.PayrollExportResultEntry;

            if (payrollExportEntry) {
                service.payrollRecords.forEach(payLine => {
                    if (payrollExportEntry.EmployeeId !== payLine.EmployeeId) {
                        return;
                    }

                    var isExportedShift = payrollExportEntry.ShiftIds.includes(payLine.ShiftId);
                    if (!isExportedShift) {
                        return;
                    }

                    if (payrollExportEntry.ErrorMessage === null) {
                        payLine.PayrollErrors = [payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain];
                        return;
                    }

                    payLine.PayrollErrors = [payrollExportEntry.ErrorMessage];
                });
            }

            onResultsFilterOptionChange();

            service.progressBarCurrent++;
            service.progressBarMessage = `Exporting payroll for ${service.progressBarMax} employees...`;
        }

        function onPayrollExportCompleted(evt, args) {
            let isSuccessful = args.IsSuccessful;

            $rootScope.$apply(() => {
                recheckPayrollRecords();

                service.isProcessing = false;
                service.isFailedToExport = !isSuccessful;

                if (isSuccessful) {
                    service.progressBarMessage = `Export completed.`;
                } else {
                    service.progressBarMessage = 'Exporting failed. Please revalidate before exporting again.';
                    service.progressBarErrorMessage = `${args.ErrorMessage}`;
                }
            });
        }

        function getErroredPayrollRecords() {
            var records = service.payrollRecords.filter(p =>
                p.PayrollErrors &&
                p.PayrollErrors.length > 0 &&
                !(
                    p.PayrollErrors.includes(payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain) ||
                    p.PayrollErrors.includes(payrollErrorCodes.TimesheetAlreadyExistsItWillBeOverwritten)
                ));

            return records;
        }

        function getPayrollRecordsReadyToExport() {
            var records = service.payrollRecords.filter(p =>
                p.IsValidated &&
                (
                    !p.PayrollErrors ||
                    p.PayrollErrors.length == 0
                ));

            return records;
        }

        function getExportedPayrollRecords() {
            var records = service.payrollRecords.filter(p =>
                p.PayrollErrors &&
                p.PayrollErrors.length > 0 &&
                p.PayrollErrors.includes(payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain)
            );

            return records;
        }

        function onResultsFilterOptionChange() {
            if (service.resultsFilterOption === 'Errored') {
                var filteredData = getErroredPayrollRecords();
                awardInterpreterGridService.grid.resetWithCollection(filteredData);
                return;
            }

            if (service.resultsFilterOption === 'Ready') {
                var filteredData = getPayrollRecordsReadyToExport();
                awardInterpreterGridService.grid.resetWithCollection(filteredData);
                return;
            }

            if (service.resultsFilterOption === 'Exported') {
                var filteredData = getExportedPayrollRecords();
                awardInterpreterGridService.grid.resetWithCollection(filteredData);
                return;
            }

            awardInterpreterGridService.grid.resetWithCollection(service.payrollRecords);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.awards.interpreter')
        .controller('AwardInterpreterController', AwardInterpreterController)
        .directive('payrollWidget', function() {
            return {
                restrict: 'E',
                scope: {
                    widget: '=',
                },
                template: '<div ng-include="vm.getTemplateUrl()"></div>',
                controller: function() {
                    var vm = this;

                    vm.getTemplateUrl = function() {
                        return 'app/main/awards/interpreter/widgets/' + vm.widget.type + '.html';
                    };
                },
                controllerAs: 'vm',
                bindToController: true
            };
        });

    function AwardInterpreterController(
        $mdToast,
        _,
        utils,
        searchDelay,
        awardInterpreterGridService,
        awardInterpreterService,
        payrollErrorCodes,
        claimsUtilService,
        adminClaimsService,
        integrationsService,
        $rootScope,
        businessesService,
        exceptionService,
        tenantSettings,
        msgboxService,
        moment,
        $scope,
        $timeout
    ) {
        var vm = this;

        vm.service = awardInterpreterService;
        vm.dataGrid = awardInterpreterGridService;
        vm.claimsUtilService = claimsUtilService;
        vm.adminClaimsService = adminClaimsService;
        vm.utilService = utils;

        vm.delay = {
            debounce: searchDelay
        };

        vm.isAltusSpecialEnabled = claimsUtilService.isAltusSpecialEnabled();
        vm.isXeroEnabled = claimsUtilService.isXeroEnabled();
        vm.isMyobEnabled = claimsUtilService.isMyobEnabled();
        vm.isIntegrationsEnabled = vm.isMyobEnabled || vm.isXeroEnabled;
        vm.payrollErrorCodes = payrollErrorCodes;

        vm.isNewPayrun = false;
        vm.newPayrun = newPayrun;
        vm.interpret = interpret;
        vm.validate = validate;
        vm.exportToFile = exportToFile;
        vm.exportToExternalProvider = exportToExternalProvider;
        vm.reExportAll = reExportAll;

        vm.toLocalDate = toLocalDate;
        vm.openMenu = openMenu;
        vm.showStatusColumn = showStatusColumn;
        vm.shouldExportToProvider = shouldExportToProvider;
        vm.shouldValidateAgainstProvider = shouldValidateAgainstProvider;
        vm.redirectToIntegrationsPage = redirectToIntegrationsPage;
        vm.redirectToBusinessesPage = redirectToBusinessesPage;
        vm.getMyobJobNumber = getMyobJobNumber;

        vm.redirectToCompanyPage = redirectToCompanyPage;
        vm.dateErrorMessage = '';
        vm.validateDates = validateDates;
        vm.dateRangeLimit = 62;

        activate();

        async function newPayrun() {
            vm.isNewPayrun = true;
            vm.dateErrorMessage = '';
            vm.service.isPageInitialLoad = true;
            vm.service.resetPayrollSettings();

            await vm.service.initialize();

            vm.service.showPayruns = false;
            vm.service.showPayrunSettings = true;

            applyModelChanges();
        }

        function applyModelChanges() {
            $timeout(function() {
                $scope.$apply();
            });
        }

        function redirectToCompanyPage(item) {
            let companyIdProp = item.CustomProperties.find(p => p.CompanyId);

            $rootScope.state.go('app.company_update', {
                cid: companyIdProp.CompanyId,
                cname: invoice.CompanyName
            });
        }

        function toLocalDate(_date) {
            return (_date == "" || _.isNil(_date)) ? "" : moment(_date).format(utils.setDateFormat())
        }

        function shouldExportToProvider() {
            let interpreterOutputItems = vm.service.payrollRecords || [];

            if (interpreterOutputItems.length == 0) {
                return false;
            }

            let hasUnvalidatedInterpreterOutputItems = interpreterOutputItems.some(item => !item.IsValidated);

            if (hasUnvalidatedInterpreterOutputItems) {
                return false;
            }

            let exportedInterpreterOutputItems;
            if (vm.service.overwriteExistingTimesheetsWhenExporting) {
                exportedInterpreterOutputItems = interpreterOutputItems.filter(function(interpreterOutputItem) {
                    return interpreterOutputItem.PayrollErrors && interpreterOutputItem.PayrollErrors.length > 0 &&
                        interpreterOutputItem.PayrollErrors.includes(vm.payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain);
                });
            } else {
                exportedInterpreterOutputItems = interpreterOutputItems.filter(function(interpreterOutputItem) {
                    return interpreterOutputItem.PayrollErrors && interpreterOutputItem.PayrollErrors.length > 0 &&
                        (interpreterOutputItem.PayrollErrors.includes(vm.payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain) ||
                            interpreterOutputItem.PayrollErrors.includes(vm.payrollErrorCodes.TimesheetAlreadyExistsItWillBeOverwritten));
                });
            }

            let invalidInterpreterOutputItems;
            if (vm.service.overwriteExistingTimesheetsWhenExporting) {
                invalidInterpreterOutputItems = interpreterOutputItems.filter(function(interpreterOutputItem) {
                    return interpreterOutputItem.PayrollErrors && interpreterOutputItem.PayrollErrors.length > 0 &&
                        !(interpreterOutputItem.PayrollErrors.includes(vm.payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain) ||
                            interpreterOutputItem.PayrollErrors.includes(vm.payrollErrorCodes.TimesheetAlreadyExistsItWillBeOverwritten));
                });
            } else {
                invalidInterpreterOutputItems = interpreterOutputItems.filter(function(interpreterOutputItem) {
                    return interpreterOutputItem.PayrollErrors && interpreterOutputItem.PayrollErrors.length > 0 &&
                        !interpreterOutputItem.PayrollErrors.includes(vm.payrollErrorCodes.TimesheetAlreadyExistsItWillNotBeExportedAgain);
                });
            }

            // if all items are valid
            if (exportedInterpreterOutputItems.length === interpreterOutputItems.length) {
                return false;
            }

            // if all remaining items are invalid
            if (invalidInterpreterOutputItems.length === (interpreterOutputItems.length - exportedInterpreterOutputItems.length)) {
                return false;
            }

            return interpreterOutputItems.length > 0;
        }

        function shouldValidateAgainstProvider() {
            let interpreterOutputItems = vm.service.payrollRecords || [];
            let hasUnvalidatedInterpreterOutputItems = interpreterOutputItems.some(item => !item.IsValidated);

            return hasUnvalidatedInterpreterOutputItems || vm.service.hasPayrollErrors;
        }

        function showStatusColumn(item) {
            if (!vm.isIntegrationsEnabled) {
                return false;
            }

            if (item) {
                return item.PayrollErrors && item.PayrollErrors.length > 0;
            }

            if (vm.service.payrollRecords && vm.service.payrollRecords.length > 0) {
                return vm.service.payrollRecords.filter(function(d) {
                    return d.PayrollErrors && d.PayrollErrors.length > 0;
                }).length > 0;
            }

            return false;
        }

        function exportToFile() {
            preparePayload();
            vm.service.exportToFile();
        }

        async function exportToExternalProvider() {
            if (tenantSettings.countryCode === 'NZ') {
                await warnUserAboutXeroNZLimitation();
                return;
            }

            await checkForErrorsBeforePayrollExport();
        }

        async function warnUserAboutXeroNZLimitation() {
            // Stopgap until Xero fixes their NZ payroll export
            let lines = vm.service.payrollRecords.filter(line => line.PayrollErrors.length === 0);
            let linesByEmployeeId = lines.reduce(function(r, a) {
                r[a.EmployeeId] = r[a.EmployeeId] || [];
                r[a.EmployeeId].push(a);
                return r;
            }, Object.create(null));

            for (let employeeId in linesByEmployeeId) {
                let employeeLineCount = linesByEmployeeId[employeeId].length;
                if (employeeLineCount > 30) {
                    vm.service.namesOfEmployeesWithMoreThan30Lines.push(linesByEmployeeId[employeeId][0].EmployeeName);
                }
            }

            if (vm.service.namesOfEmployeesWithMoreThan30Lines.length > 0) {
                let content = "The following workers have pay items exceeding the allowed export limit to Xero. Please enter the weekly timesheets manually for these workers.<br>";
                content += "You can download this data by selecting 'interpreted data' when downloading their Timesheet Summary PDF (under Payroll > Timesheets):<br>";

                vm.service.namesOfEmployeesWithMoreThan30Lines.forEach(name => {
                    content += `<li>${name}</li>`;
                });

                msgboxService.yepNo(
                        content,
                        utils.translate('RUN_PAYROLL.EXPORT_TO_XERO'),
                        'Export remaining Timesheets',
                        'Cancel export')
                    .then(async function() {
                        await checkForErrorsBeforePayrollExport();
                    })

                vm.service.namesOfEmployeesWithMoreThan30Lines = [];
                return;
            } else {
                await checkForErrorsBeforePayrollExport();
                return;
            }
        }

        async function checkForErrorsBeforePayrollExport() {
            if (!vm.service.hasPayrollErrors) {
                await _exportToExternalProvider();
                return;
            }

            msgboxService.yepNo(
                    utils.translate('RUN_PAYROLL.EXPORTING_TIMESHEET_WITH_ERROR_CONTENT'),
                    utils.translate('RUN_PAYROLL.IGNORE_ERRORS_AND_PROCEED'),
                    utils.translate('RUN_PAYROLL.OK'),
                    utils.translate('RUN_PAYROLL.CANCEL'))
                .then(async function() {
                    await _exportToExternalProvider();
                })
        }

        function getMyobJobNumber(item) {
            let myobJobNumberProp = item.CustomProperties.find(p => p.MyobJobNumber);

            if (myobJobNumberProp) {
                return myobJobNumberProp.MyobJobNumber;
            }

            return '-';
        }

        async function _exportToExternalProvider() {
            preparePayload();

            await vm.service.exportToExternalProvider();
        }

        async function interpret() {
            vm.isNewPayrun = false;
            vm.exportingTimesheetsTimeoutError = false;
            vm.service.isPageInitialLoad = false;

            preparePayload()

            await vm.service.interpretPayroll();

            vm.service.resultsFilterOption = 'All';
        }

        async function validate() {
            vm.isNewPayrun = false;
            vm.exportingTimesheetsTimeoutError = false;

            preparePayload();

            await vm.service.validatePayroll();

            vm.service.resultsFilterOption = 'All';
        }

        function preparePayload() {
            vm.service.interpreterSettings = getInterpreterSettings(vm.service.startDate, vm.service.endDate);
        }

        function cleanBranches(branches) {
            let formattedBranches = [];
            angular.forEach(branches, function(branch) {
                if (branch.Id.indexOf(',') !== -1) { // is a State value with multiple branch Ids
                    branch.Id.split(',').forEach(function(id) {
                        formattedBranches.push(id);
                    });
                } else {
                    formattedBranches.push(branch.Id);
                }
                formattedBranches = Array.from(new Set(formattedBranches)); // Cleaned branches
            });
            return formattedBranches;
        }

        function validateDates()
        {
            vm.dateErrorMessage = '';
            if (vm.service.endDate && vm.service.startDate)
            {
                return isValidStartDate() && isValidDateRange();
            }
        }

        function isValidStartDate() {
            let formattedStartDate = moment(vm.service.startDate).format("YYYY-MM-DD");
            if (moment(formattedStartDate).isAfter(moment(vm.service.endDate))) {
                vm.dateErrorMessage = 'Start date cannot be after End date'
                vm.service.startDate = null;
                vm.service.endDate = null;
                return false;
            }
            return true;
        }

        function isValidDateRange() {
            var endDate = moment(new Date(vm.service.endDate));
            var duration = moment.duration(endDate.diff(vm.service.startDate));
            var days = duration.asDays();
            if (days > vm.dateRangeLimit) {
                vm.dateErrorMessage = `Please enter a date range that is not more than ${vm.dateRangeLimit} days`
                vm.service.startDate = null;
                vm.service.endDate = null;
                return false;
            }
            return true;
        }

        function openMenu($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        }

        function reExportAll() {
            preparePayload();
            vm.service.reExport();
        }

        function getInterpreterSettings(startDate, endDate) {
            let interpreterSettings = {
                StartDate: moment(startDate).format("YYYY-MM-DD"),
                EndDate: moment(endDate).format("YYYY-MM-DD"),
                Branches: _.isNil(vm.service.selectedBranches) ? [] : cleanBranches(vm.service.selectedBranches),
                CountryCode: tenantSettings.countryCode,
                ExportSalaryCodes: vm.service.exportSalaryCodes,
                ExportPermanentParttimeTopups: vm.service.exportPermanentParttimeTopups,
                ExportPermanentParttimePublicHolidayTopups: vm.service.exportPermanentParttimePublicHolidayTopups,
                ExportPermanentFulltimeTopups: vm.service.exportPermanentFulltimeTopups,
                ExportPermanentFulltimePublicHolidayTopups: vm.service.exportPermanentFulltimePublicHolidayTopups,
                ExportCalendarEntryTopups: vm.service.exportCalendarEntryTopups,
                OverwriteExistingTimesheetsWhenExporting: vm.service.overwriteExistingTimesheetsWhenExporting,
                InterpretJobId: vm.service.currentInterpretJobId,
                RevalidateTimesheets: vm.service.revalidateAllTimesheets
            };

            if (vm.isXeroEnabled) {
                interpreterSettings.payrollConnectorType = integrationsService.providerTypes.xero;
            } else if (vm.isMyobEnabled) {
                interpreterSettings.payrollConnectorType = integrationsService.providerTypes.myob;
            }

            return interpreterSettings;
        }

        async function activate() {
            const isConnectedResponse = await integrationsService.getProviders();
            vm.service.isConnectedToMyob = isConnectedResponse.isConnectedToMyob;
            vm.service.isConnectedToXero = isConnectedResponse.isConnectedToXero;

            if (vm.isIntegrationsEnabled) {
                if (vm.isXeroEnabled) {
                    vm.service.interpreterSettings.payrollConnectorType = integrationsService.providerTypes.xero;
                } else if (vm.isMyobEnabled) {
                    vm.service.interpreterSettings.payrollConnectorType = integrationsService.providerTypes.myob;
                }

                if (vm.service.isConnectedToMyob || vm.service.isConnectedToXero) {
                    checkIfUserHasAccessToPayrollCompany();
                }
            }

            if (!vm.service.isPageInitialLoad) {
                if (vm.service.payrollRecords) {
                    vm.dataGrid.grid.resetWithCollection(vm.service.payrollRecords);
                }

                return;
            }

            vm.service.isPageInitialLoad = false;
            vm.service.resetPayrollSettings();

            await vm.service.initialize();
        }

        function checkIfUserHasAccessToPayrollCompany() {
            businessesService.getPayrollCompany()
                .then(resp => {
                    if (!resp.data) return;

                    vm.service.selectedPayrollCompany = resp.data;

                    if (!vm.service.selectedPayrollCompany || !vm.service.selectedPayrollCompany.id) {
                        return;
                    }

                    return integrationsService.getTenants();
                })
                .then(resp => {
                    if (resp && resp.data) {
                        let allProviderTenants = resp.data;
                        vm.service.userHasAccessToPayrollCompany = allProviderTenants.some(company => company.CompanyId === vm.service.selectedPayrollCompany.id);
                    }
                }).catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function redirectToIntegrationsPage() {
            $rootScope.state.go('app.integrations');
        }

        function redirectToBusinessesPage() {
            $rootScope.state.go('app.businesses');
        }
    }
})();

/**
 * stockCategoryConverterService
 * by rcnet 7.22.2016
 */
(function () {
  'use strict';

  angular.module('app.assets')
    .factory('stockCategoryConverterService', stockCategoryConverterService);

  /** @ngInject */
  function stockCategoryConverterService(_) {
    var idsToExpand = [];
    var service = {
      toUITree: toUITree,
      nodeHasSelectedChild: nodeHasSelectedChild
    };

    var source = null,
      selectedItems = null,
      selectedChildForSpecificNodes  = [];

    activate();

    return service;

    //////
    function activate() {
    }

    function toUITree(data, selItems) {
      var tree = [],
        depth = 0;

      source = data;
      selectedItems = selItems;
      var rootItems = getItems(null);
      buildUITree2(rootItems, {}, tree, depth);
      source = null;

      return { tree: tree, idsToExpand: idsToExpand };
    }

    function getItems(id) {
      var items = _.filter(source, function (o) {
        return o.ParentId == id;
      });
      return items;
    }

    function buildUITree2(data, treeItem, tree, depth) {
      for (var i = 0; i < data.length; i++) {

        var childItems = getItems(data[i].CategoryKey);
        if (childItems.length > 0) {
          var treeFolder = null;

          if (angular.isArray(treeItem)) {
            var item = {};
            item['id'] = data[i].CategoryKey;
            item['label'] = data[i].Name;
            item['primaryId'] = data[i].Id;
            item['children'] = [];

            treeItem.push(item);
            treeFolder = treeItem[treeItem.length - 1]['children'];
          } else {
            // Create initial root folder
            treeItem['label'] = data[i].Name;
            treeItem['primaryId'] = data[i].Id;
            treeItem['children'] = [];
            treeFolder = treeItem['children'];
          }

          depth++;
          buildUITree2(childItems, treeFolder, tree, depth);
          depth--;
        } else {
          var leaf = {
            id: data[i].CategoryKey,
            label: data[i].Name,
            selected: checkSelected(data[i].Id),
            parentId: data[i].ParentId,
            primaryId: data[i].Id
          };

          if (angular.isArray(treeItem))
            treeItem.push(leaf);
          else
            treeItem = leaf;
        }

        if (depth === 0) {
          tree.push(treeItem);
          treeItem = {};
        }
      }
    }

    function checkSelected(id) {
      var items = _.filter(selectedItems, function (o) {
        return o.Id == id;
      });
      return items.length > 0;
    }

    function getItemsByCategoryKey(id) {
      var items = _.filter(source, function (o) {
        return o.CategoryKey == id;
      });
      return items;
    }

    function nodeHasSelectedChild(data, nodeCategoryKey, selItems) {
      var depth = 0;
      source = null;
      selectedChildForSpecificNodes = null;

      if (!source)
        source = data;


      selectedChildForSpecificNodes = [];
      selectedItems = selItems;
      var rootItems = getItemsByCategoryKey(nodeCategoryKey);
      checkDataTree(rootItems, depth);

      return selectedChildForSpecificNodes;
    }

    function checkDataTree(data, depth) {
      for (var i = 0; i < data.length; i++) {
        var childItems = getItems(data[i].CategoryKey);
        if (childItems.length > 0) {
          depth++;
          checkDataTree(childItems, depth);
          depth--;
        } else {
          if (checkSelected(data[i].Id)) {
            selectedChildForSpecificNodes.push(data[i].Id);
          }
        }
      }
    }

  }
})();

/**
 * OBSOLETE !!!!!
 * categoryConverterService
 * by rcnet 7.8.2016
 * Note: Old Implementation its using JSON object in documentdb
 */
(function(){
    'use strict';

    angular.module('app.assets')
           .factory('categoryConverterService', categoryConverterService);

    /** @ngInject */
    function categoryConverterService(_, utils) {
        var idsToExpand = [];
        var service = {
            toUITree: toUITree,
            toBackendModel: toBackendModel,
            getIdsToExpand: getIdsToExpand
        };

        activate();

        return service;

        //////
        function activate() {
        }

        function toUITree(data) {
            var tree = [], 
                depth = 0;
                
            buildUITree(data, {}, tree, depth);
      
            return { tree: tree, idsToExpand: idsToExpand };
        }

        /**
         * Perform UI specific model to document model
         */
        function toBackendModel(data) {
            var tree = [],
                depth = 0;

            buildBackendModel(data, {}, tree, depth);

            //var t = angular.toJson(tree, true);
            return tree;
        }

        /**
         * Perform transform of document model to UI specific model
         */
        function buildUITree(data, treeItem, tree, depth) {
            for(var i = 0; i < data.length; i++) {
                        
                // Handle Leaf
                var propName = getFirstPropertyName(data[i]);
                if (!angular.isArray(data[i][propName])) {

                    if (typeof data == 'object') {
                        var leaf = {
                            id: utils.newGuid(),
                            label: getFirstPropertyNameAndSanitize(propName),
                            selected: (data[i][propName].selected == 'true' || data[i][propName].selected == true ? true : false)
                        };

                        if (leaf.selected) 
                            idsToExpand.push(leaf.id);
                    }

                    treeItem.push(leaf);
                } else if (angular.isArray(data[i][propName])) { // Handle Node
                    var treeFolder = null;

                    if (angular.isArray(treeItem)) {
                        var item = {};
                        item['label'] = getFirstPropertyNameAndSanitize(propName);
                        item['children'] = []; 

                        treeItem.push(item);
                        treeFolder = treeItem[treeItem.length-1]['children'];

                    } else {
                        // Create initial root folder
                        treeItem['label'] = getFirstPropertyNameAndSanitize(propName);
                        treeItem['children'] = [];
                        treeFolder = treeItem['children'];
                    }
                    
                    depth++;
                    buildUITree(data[i][propName], treeFolder, tree, depth);
                    depth--;
                }

                if (depth === 0) {
                    tree.push(treeItem);
                    treeItem = {};
                }
            }
        }

        function getIdsToExpand() {
            return idsToExpand;
        }

        function getFirstPropertyName(obj) {
            for(var prop in obj) return prop;
        }

         /**
         * This will sanitize the property name
         * '_' underscore will be omitted
         */
        function getFirstPropertyNameAndSanitize(propName) {
            return replaceAll(propName, '_', ' ');
        }

        /**
         * Perform transformation of UI specific mode to document model
         */
        function buildBackendModel(data, treeItem, tree, depth) {
            for(var i = 0; i < data.length; i++) {
                    
                // Handle Leaf
                var propName = formatName(data[i].label);
                if (!angular.isArray(data[i].children)) {

                    if (typeof data == 'object') {
                        var leaf = {};
                        leaf[propName] = { 
                            selected: data[i].selected
                        };
                    }

                    treeItem.push(leaf);
                } else if (angular.isArray(data[i].children)) { // Handle Node
                    var treeFolder = null;

                    if (angular.isArray(treeItem)) {
                        var item = {};
                        item[propName] = [];

                        treeItem.push(item);
                        treeFolder = treeItem[treeItem.length-1];
                        treeFolder = treeFolder[propName];
                    } else {
                        // Create initial root folder
                        treeItem[propName] = [];
                        treeFolder = treeItem[propName];
                    }
                    
                    depth++;
                    buildBackendModel(data[i].children, treeFolder, tree, depth);
                    depth--;
                }

                if (depth === 0) {
                    tree.push(treeItem);
                    treeItem = {};
                }
            }
        }

        /**
         * Format name according to server requirements
         */
        function formatName(propName) {
            return replaceAll(propName, ' ', '_');
        }

        function replaceAll (target, search, replacement) {
            return target.split(search).join(replacement);
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.assets')
        .factory('assetsLookupService', assetsLookupService);

    /** @ngInject */
    function assetsLookupService(
        $q,
        lookupApi,
        assetsApi,
        exceptionService,
        $cacheFactory) {

        var cache = $cacheFactory('assetsCache');
        var service = {
            fetchCostCodeCategoriesLookup: fetchCostCodeCategoriesLookup,
            fetchItemTypesLookup: fetchItemTypesLookup,
            fetchStockLevelTrackingLookup: fetchStockLevelTrackingLookup,
            fetchEmployeeContactLookups: fetchEmployeeContactLookups,
            fetchItemCategoriesLookup: fetchItemCategoriesLookup,
            fetchActiveUsers: fetchActiveUsers,
            invalidateLookup: invalidateLookup,
            categoriesLookup: []
        };

        return service;

        function fetchCostCodeCategoriesLookup() {
            var deferred = $q.defer();

            if (!cache.get('_costCodeCategories')) {
                assetsAPI.getCostCodeCategories()
                    .then(function(resp) {
                        cache.put('_costCodeCategories', resp);
                        deferred.resolve(resp);
                    })
                    .catch(function(ex) {
                        deferred.reject(ex);
                        exceptionService.resolve(ex);
                    });
            } else {
                deferred.resolve(cache.get('_costCodeCategories'));
            }

            return deferred.promise;
        }

        function fetchItemTypesLookup() {
            var deferred = $q.defer();
            if (!cache.get('_itemTypes')) {
                lookupApi.getItemTypes()
                    .then(function(resp) {
                        cache.put('_itemTypes', resp);
                        deferred.resolve(resp);
                    })
                    .catch(function(ex) {
                        deferred.reject(ex);
                        exceptionService.resolve(ex);
                    });
            } else {
                deferred.resolve(cache.get('_itemTypes'));
            }

            return deferred.promise;
        }

        function fetchStockLevelTrackingLookup() {
            var deferred = $q.defer();

            if (!cache.get('_stockLevelTracking')) {
                lookupApi.getStockLevelTracking()
                    .then(function(resp) {

                        cache.put('_stockLevelTracking', resp);
                        deferred.resolve(resp);
                    })
                    .catch(function(ex) {
                        deferred.reject(ex);
                        exceptionService.resolve(ex);
                    });
            } else {
                deferred.resolve(cache.get('_stockLevelTracking'));
            }

            return deferred.promise;
        }

        function fetchEmployeeContactLookups() {
            var deferred = $q.defer();

            if (!cache.get('_employeeContactLookup')) {
                assetsApi.getEmployeeContacts()
                    .then(function(resp) {
                        cache.put('_employeeContactLookup', resp);
                        deferred.resolve(resp);

                    })
                    .catch(function(ex) {
                        deferred.reject(ex);
                        exceptionService.resolve(ex);
                    });
            } else {
                deferred.resolve(cache.get('_employeeContactLookup'));
            }

            return deferred.promise;
        }

        function fetchActiveUsers() {
            var deferred = $q.defer();

            if (!cache.get('_activeUsersLookup')) {
                assetsApi.getActiveUsers()
                    .then(function(resp) {

                        angular.forEach(resp.data, function(user) {
                            user.FullName = user.FirstName + ' ' + user.LastName;
                        }, this);

                        cache.put('_activeUsersLookup', resp.data);
                        deferred.resolve(resp.data);

                    })
                    .catch(function(ex) {
                        deferred.reject(ex);
                        exceptionService.resolve(ex);
                    });
            } else {
                deferred.resolve(cache.get('_activeUsersLookup'));
            }

            return deferred.promise;
        }

        function fetchItemCategoriesLookup() {
            var deferred = $q.defer();

            if (!cache.get('_itemCategories')) {
                var promise = assetsApi.getStockLevelCategories()
                    .then(function(resp) {
                        cache.put('_itemCategories', resp.data);
                        service.categoriesLookup = resp;
                        deferred.resolve(resp.data);
                    })
                    .catch(function(ex) {
                        deferred.reject(ex);
                        exceptionService.resolve(ex);
                    });
            } else {
                deferred.resolve(cache.get('_itemCategories'));
            }

            return deferred.promise;
        }

        function invalidateLookup(key) {
            cache.remove(key);
        }
    }
})();

(function () {
    'use strict';
  
    angular.module('app.assets')
      .factory('assetsClaimService', assetsClaimService);
      
      /** @ngInject */
      function assetsClaimService($rootScope, $log, identityService, claimsUtilService) {
          var service = {
              hasViewItemsMenu: false,
              hasViewKitsMenu: false,
              hasCreateNewItemMenu: false,
              hasCreateNewKit: false,
              hasEditIndividualItem: false,
              hasCreateNewIndividualItem: false
          };
          
          activate();
          
          return service;
          
          /////// 
          
          function activate() {
              // Triggered by SignalR
              $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                  applyClaimsRules();
              });
  
              applyClaimsRules();   
          }
  
          function applyClaimsRules() {
              service.hasViewItemsMenu = claimsUtilService.checkAccessByRole('View Items'); 
              service.hasViewKitsMenu = claimsUtilService.checkAccessByRole('View Kits');
              service.hasCreateNewItemMenu = claimsUtilService.checkAccessByRole('Create a New Item');
              service.hasCreateNewKit = claimsUtilService.checkAccessByRole('Create a New Kit');
              service.hasEditIndividualItem = claimsUtilService.checkAccessByRole("Edit Individual Equipment Item");
              service.hasCreateNewIndividualItem = claimsUtilService.checkAccessByRole("Create a New Asset Individual Item");
          }
       
      }
  })();
(function(){
   'use strict';

  angular.module('app.assets')
          .service('stockLevelModel', stockLevelModel)

    function stockLevelModel() {

        /**
         * StockLevel - structure can be one of the following:
         * 
         *   by Count:  { Assets: 0, Inventory: 0, People: 0 }
         *   by Branch:  [{ Branch: 'Adelaide', Assets: 0, Inventory: 0, People: 0 }]
         * 
         */
        return function () {
            var self = this,
            defaults = {
              id: null,
              StockLevelTracking: null, // Selected stock level tracking (no tracking, stock level counts and stock level counts by branch) 
              StockLevelByCount: {
                  Assets: 0,
                  Inventory: 0,
                  People: 0
              },  
              StockLevelByBranches: [],   // By branch
              StockQueueForServerDispatch: [] // For Server dispatch request (INTERNAL)
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.tranformToServerModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
                self.StockLevelByBranches.length = 0;
                self.StockLevelTracking = null;
                self.StockLevelByCount = {
                  Assets: 0,
                  Inventory: 0,
                  People: 0
                };
            }

            function transformToModel() {
                return {
                   IsIndividualItem: self.isIndividualItem,
                   StockLevelTracking: self.StockLevelTracking
                };
            }
        }
    };

})();
(function(){
   'use strict';

  angular.module('app.assets')
          .service('kitPriceDetailModel', kitPriceDetailModel)

    function kitPriceDetailModel() {
        return function () {
            var self = this,
            defaults = {
              BaseSalePrice: null, //0,
              HireRateData: []
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            };
            
            function reset() {
                self.map(null);
                self.HireRateData.length = 0;
            };

            function transformToModel() {
                var hirePrices = [];
           
                angular.forEach(self.HireRateData, function(itm) {
                    hirePrices.push({ HireCost: itm.hireCost, HirePeriod: itm.id });
                }, this);

                return {
                    BaseSalePrice: self.BaseSalePrice,
                    BaseHirePrices: hirePrices
                };
            };
             
        }
    };

})();
(function(){
   'use strict';

  angular.module('app.assets')
          .service('kitItemGridModel', kitItemGridModel)

    function kitItemGridModel() {
        return function () {
            var self = this,
            defaults = {
               id: null,
               KitName: null,
               Description: null,
               Items: [], // Note: Structure type list of String
               Categories: [] // Note: Structure type list of String
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }
        }
    };

})();
(function(){
   'use strict';

  angular.module('app.assets')
          .service('kitBasicInfoModel', kitBasicInfoModel)

    function kitBasicInfoModel() {
        return function () {
            var self = this,
            defaults = {
               id: null,
               ItemName: null,
               Description: null,
               KitItems: [],  // Expected Object Item structure example: {ItemName: 'sample', Qty: 1 }
               Categories: [],
               Branches:[]
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
              
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
                self.KitItems.length = 0;
            }

            function transformToModel() {
              
                var items = [];

                // Prepare Kit Items
                angular.forEach(self.KitItems, function(itm) {
                    var cloneItem = angular.copy(itm);
                    // Clean object to save
                    delete cloneItem.Qty;
                    var itemToAdd = {
                        Quantity: itm.Quantity,
                        Items: cloneItem.Items
                    };

                    items.push(itemToAdd);
                }, this);


                return {
                    id: self.id,
                    KitName: self.ItemName,
                    Description: self.Description,
                    Items: items,
                    Branches: self.Branches,
                };
            }
        }
    };

})();

(function(){
   'use strict';

  angular.module('app.assets')
          .service('itemGridModel', itemGridModel)

    function itemGridModel() {
        return function () {
            var self = this,
            defaults = {
               id: null,
               ItemName: null,
               Description: null,
               ItemTypes: [], // Note: Structure type list of String
               Categories: [] // Note: Structure type list of String
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }
        }
    };

})();
(function(){
   'use strict';

  angular.module('app.assets')
          .service('individualItemGridModel', individualItemGridModel)

    function individualItemGridModel() {
        return function () {
            var self = this,
            defaults = {
               id: null,
               UniqueItemId: null,
               Description: null,
               BranchNames: [],
               User: null,
               ItemStatus: null
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }
        }
    };

})();
(function(){
   'use strict';

  angular.module('app.assets')
          .service('individualItemModel', individualItemModel)

    function individualItemModel(utils) {
        return function () {
            var self = this,
            defaults = {
               id: null,
               UniqueItemId: null,
               Description: null,
               ItemType: null,
               VehicleOwnershipType: null,
               ItemId: null,
               ItemStatus: null,
               Branches: [],
               User: null,
               CostCode: null,
               PurchasePrice: null,
               Depreciation: [],
               DepreciationTotalSummary: 100,  // 100%
               MinStartDate: new Date(1970, 1, 1),
               MinEndDate: new Date(1970, 1, 1),
               Divisions: [],
               VehicleMake: null,
               VehicleModel: null,
               VehicleType: null,
               VehicleBody: null,
               VehicleVin: null,
               VehicleEngineNumber: null,
               VehicleBuildYear: null,
               StatusEffectiveDate: null
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
                self.Depreciation.length = 0;
            }

            function transformToModel(itemId) {

                // Sanitize model
                var depreciationArr = angular.copy(self.Depreciation);
                angular.forEach(depreciationArr, function(itm) {
                    delete depreciationArr.id;
                }, this);

                var depreciation = [];
                angular.forEach(depreciationArr, function(itm) {
                    depreciation.push({ Year: itm.Year, PercentPerYear: itm.PercentPerYear });
                }, this);

                let branches = angular.copy(self.Branches);
                let divisions = angular.copy(self.Divisions);

                angular.forEach(branches, function(branch) {
                    branch['Division'] = _.filter(divisions, {
                        BranchId: branch.Id
                    });
                });

                return {
                    id: self.id,
                    ItemId: itemId ? itemId : self.ItemId,
                    ItemType: self.ItemType.Id,
                    VehicleOwnershipType: self.VehicleOwnershipType  ? parseInt(self.VehicleOwnershipType) : null,
                    Description: self.Description,
                    UniqueItemId: self.UniqueItemId,
                    Branches: utils.objectSanitize(branches),
                    User: self.User,
                    ItemStatus: self.ItemStatus,
                    CostCode: utils.objectSanitize(self.CostCode),
                    PurchasePrice: self.PurchasePrice,
                    Depreciation: depreciation,
                    VehicleMake: self.VehicleMake,
                    VehicleModel: self.VehicleModel,
                    VehicleType: self.VehicleType,
                    VehicleBody: self.VehicleBody,
                    VehicleVin: self.VehicleVin,
                    VehicleEngineNumber: self.VehicleEngineNumber,
                    VehicleBuildYear: self.VehicleBuildYear,
                    VehicleOwnershipType: self.VehicleOwnershipType,
                    StatusEffectiveDate: self.StatusEffectiveDate
                };
            }
        }
    };

})();

/**
 * OBSOLETE !!!!
 */
(function(){
   'use strict';

  angular.module('app.assets')
          .service('hireRateModel', hireRateModel)

    function hireRateModel() {
        return function () {
            var self = this,
            defaults = {
               Id: null,
               HirePeriod: null,  // Selected hire period
               HireCost: 0 
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.tranformToServerModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {

                return {
                    Id: self.Id,
                    HirePeriod: self.HirePeriod,
                    HireCost: self.HireCost,
                };
            }
        }
    };

})();
(function(){
   'use strict';

  angular.module('app.assets')
          .service('depreciationModel', depreciationModel)

    function depreciationModel() {
        return function () {
            var self = this,
            defaults = {
                Year: null,
                PercentPerYear: null,
                YearText: null
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {
                return;
            }
        }
    };

})();
(function(){
   'use strict';

  angular.module('app.assets')
          .service('costCodeGridModel', costCodeGridModel)

    function costCodeGridModel() {
        return function () {
            var self = this,
            defaults = {
               Id: null,
               Code: null,
               Description: null,
               CategoryName: null // Custom desc for grid
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }
        }
    };

})();
/**
 * Used in Item Manager
 */
(function(){
   'use strict';

  angular.module('app.assets')
          .service('costCodeEntryModel', costCodeEntryModel)

    function costCodeEntryModel(utils) {
        return function () {
            var self = this,
            defaults = {
               CostCode: null, // Object
               BaseSalePrice: null
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }
            
            function reset() {
                self.map(null);
            }

            function transformToModel() {
                return {
                    CostCode: utils.objectSanitize(self.CostCode),
                    BaseSalePrice: self.BaseSalePrice
                };
            }
        }
    };

})();
(function(){
  'use strict';

  angular.module('app.assets')
    .service('costCodeModel', costCodeModel)

  function costCodeModel() {
    return function () {
      var self = this,
        defaults = {
          id: null,
          CodeNo: null,
          Description: null,
          CreatedDate: null,
          LastUpdatedDate:null,
          CostCodeType: null
          //SelectedCategory: null
          //CategoryName: null // Custom desc for grid
        };

      angular.extend(self, defaults);

      self.map = mapper;
      self.reset = reset;
      self.tranformToServerModel = transformToModel;
      self.map();

      function mapper(options) {
        var mapValue = options || defaults
          , opts = angular.extend(self, mapValue);
      }

      function reset() {
        self.map(null);
      }

      function transformToModel() {

        return {
          id: self.id,
          CodeNo: self.CodeNo,
          Description: self.Description,
          CreatedDate: self.CreatedDate,
          LastUpdatedDate: self.LastUpdatedDate,
          CostCodeType: self.CostCodeType
        };
      }
    }
  };

})();

(function(){
   'use strict';

  angular.module('app.assets')
          .service('basicInfoModel', basicInfoModel)

    function basicInfoModel(_) {
        return function () {
            var self = this,
            defaults = {
               id: null,
               ItemName: null,
               Description: null,
               ItemTypes: [],  // Selected Item type
               DefaultBillingPeriod : 1,
               ItemTaxType: null,
               CustomFields: [],
               CustomFieldsValues: [],
               ItemPrerequisites: [],
               ItemRequiredSkills: [],
               ItemRequiredSkillsFormatted: [],
               Categories: [],
               HasBeenArchived: false,
               IndividualTrackingType: undefined, // Track individual items (Yes, track individual item details or No don't track individual items)
               LowStockNotification: '', // Either Yes or No
               LowAssetWarning: null,
               LowInventoryWarning: null,
               StockLevel: null,
               RequiresOperator : false,
               RequireToBeLinked : false,
               DisplayUniqueId : false,
               IsAllocatable : false,
               LowPeopleWarning: null,
               itemTypeDisabled: false,
               ShiftRole: [],
               Branches:[],
               InvoiceGroupName:null,
               UtilisationTarget: 8,
               UtilisationDays: [],
               Award: null,
               AwardClassification: null
            };

            angular.extend(self, defaults);

            self.map = mapper;
            self.reset = reset;
            self.toBackendModel = transformToModel;
            self.map();

            function mapper(options) {
                var mapValue = options || defaults
                , opts = angular.extend(self, mapValue);
            }

            function reset() {
                self.map(null);
                self.ItemTypes.length = 0;
                self.Categories.length = 0;
                self.ItemPrerequisites.length = 0;
                self.ItemRequiredSkills = [];
            }

            function transformToModel() {

                // Collect item types
                var itemTypes = [];
                angular.forEach(self.ItemTypes, function(itm) {
                    itemTypes.push(itm.Id);
                }, this);

                var requisites = [];

                angular.forEach(self.ItemPrerequisites, function(item){
                  var requisite = {
                    id : item.id,
                    ItemName : item.ItemName,
                    Quantity : item.Qty,
                    ItemTypes : item.ItemTypes,
                    IsOptional: item.IsOptional,
                    InvoiceGroupName: item.InvoiceGroupName
                  }
                  requisites.push(requisite);
                });

                self.ItemRequiredSkills = _.filter(self.ItemRequiredSkills, function(skill) {
                  return skill.Skills.length > 0;
                });

                return {
                    id: self.id,
                    ItemRequiredSkills: self.ItemRequiredSkills,
                    ItemName: self.ItemName,
                    ShiftRole: self.ShiftRole,
                    Description: self.Description,
                    ItemTypes: itemTypes,
                    HasBeenArchived: self.HasBeenArchived,
                    TrackIndividualItemDetails: _.isUndefined(self.IndividualTrackingType) ? null : self.IndividualTrackingType.id,
                    LowStockNotification: self.LowStockNotification === 'Yes',
                    StockLevel: self.StockLevel,
                    CustomFields : self.CustomFields,
                    CustomFieldsValues : self.CustomFieldsValues,
                    ItemPrerequisites : requisites,
                    RequiresOperator : self.RequiresOperator,
                    RequireToBeLinked : self.RequireToBeLinked,
                    DisplayUniqueId : self.DisplayUniqueId,
                    IsAllocatable : self.IsAllocatable,
                    LowStock: {
                        Assets: self.LowAssetWarning,
                        Inventory: self.LowInventoryWarning,
                        People: self.LowPeopleWarning
                    },
                    Branches: self.Branches,
                    InvoiceGroupName: self.InvoiceGroupName,
                    ItemTaxType: self.ItemTaxType,
                    DefaultBillingPeriod : self.DefaultBillingPeriod,
                    UtilisationDays : self.UtilisationDays,
                    UtilisationTarget : self.UtilisationTarget,
                    Award : self.Award,
                    AwardClassification : self.AwardClassification
                };
            }
        }
    };

})();

(function() {
    'use strict';

    angular.module('app.assets')
        .directive('hireRateComponent', hireRateComponent);

    /** @ngInject */
    function hireRateComponent(
        $mdDialog,
        exceptionService,
        _,
        lookupApi
    ) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/assets/directives/hire-rate.html',
            scope: {
                ngModel: '=',
                name: '@'
            },
            controller: hireRateController,
            controllerAs: 'hireRateVm',
            bindToController: true
        };

        return directive;

        function hireRateController() {
            var vm = this;

            vm.sortType = 'id';
            vm.onAddHireRate = addHireRate;
            vm.onEdit = onEdit;
            vm.remove = remove;

            activate();

            function activate() {}

            function remove(index) {
                vm.ngModel.splice(index, 1)
            }

            function addHireRate() {
                lookupApi.getHirePeriod()
                    .then(function(resp) {
                        var data = removeAlreadyTakenHireRateSource(resp.data, null);
                        showDialog(data, null);
                    })
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function removeAlreadyTakenHireRateSource(dataLookup, exceptForId) {
                angular.forEach(vm.ngModel, function(itmSelected) {
                    _.remove(dataLookup, function(item) {
                        if (exceptForId && item.Id == exceptForId) {
                            return false;
                        } else {
                            return item.Id == itmSelected.id;
                        }
                    });
                }, this);

                return dataLookup;
            }

            function onEdit(id) {
                lookupApi.getHirePeriod()
                    .then(function(resp) {

                        var data = removeAlreadyTakenHireRateSource(resp.data, id);
                        showDialog(data, id);
                    })
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            function showDialog(data, id) {
                var locals = {};

                if (id) {
                    var toEdit = _.filter(vm.ngModel, function(o) {
                        return o.id == id;
                    })[0];

                    locals.hirePeriods = data;
                    locals.dataToEdit = toEdit;
                } else {
                    locals.hirePeriods = data;
                }

                $mdDialog.show({
                        parent: angular.element(document.body),
                        templateUrl: 'app/main/assets/directives/hire-rate-dialog.html',
                        controller: 'HireRateDialogController as hireRateVm',
                        locals: locals
                    })
                    .then(function(result) {
                        if (result) {
                            if (result.oldValue) {
                                _.remove(vm.ngModel, function(item) {
                                    return item.id == result.oldValue;
                                });
                            }

                            vm.ngModel.push(result);
                        }
                    });
            }
        };
    }
})();

/**
 * Create Hire Rate Controller
 * Created date: 6.27.2016
 */
(function() {
    'use strict';

    angular
    .module('app.assets')
    .controller('HireRateDialogController', HireRateDialogController);

   /** @ngInject */
   function HireRateDialogController($mdDialog, locals, _) {
        var vm = this;

        vm.hirePeriod;
        vm.cost;
        vm.periods = [];
        vm.onAdd = onAdd;
        vm.onCancel = onCancel;

        var periodsLookup;
        var isEditMode = false;

        activate();

        //////////

        function activate() {
            angular.forEach(locals.hirePeriods, function(itm) {
                vm.periods.push(itm);
            }, this);

            periodsLookup = locals.hirePeriods;

            // Check for editing
            if (locals.dataToEdit) {
                isEditMode = true;
                vm.hirePeriod = locals.dataToEdit.id;
                vm.cost = locals.dataToEdit.hireCost;
            }
        }

        function onAdd() {
           var period =  _.filter(periodsLookup, function(o) {
                            return o.Id === parseInt(vm.hirePeriod);
                        })[0];

           if (!isEditMode) {
                $mdDialog.hide({ id: vm.hirePeriod, periodName: period.Name, hireCost: vm.cost });
            } else {
                $mdDialog.hide({ id: vm.hirePeriod, periodName: period.Name, hireCost: vm.cost, oldValue: locals.dataToEdit.id });
            }
        }

        function onCancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.admin', [
            'app.api',
            'app.corelib',
            'app.widgets',
            'app.shared.models'
        ])
        .config(config)
        .run(runConfig);

    /** @ngInject */
    function config() {};

    function runConfig(
        msNavigationService,
        claimsUtilService,
        adminClaimsService,
        identityService
    ) {
        let isAppSupportUser = identityService.userData.Email == 'app-support@alloc8.io';

        // Parent
        msNavigationService.saveItem('apps.admin', {
            title: 'Administration',
            icon: 'icon-key-variant',
            weight: 99,
            hidden: function() {
                return !adminClaimsService.hasAdminMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.awards_view', {
            title: 'Awards (Old)',
            state: 'app.awards_view',
            weight: 100,
            hidden: function() {
                return !adminClaimsService.hasManageAwardsMenu || !claimsUtilService.isPayrollEnabled() || !isAppSupportUser;
            }
        });

        msNavigationService.saveItem('apps.admin.manage_awards', {
            title: 'Awards',
            state: 'app.manage_awards',
            weight: 100,
            hidden: function() {
                return !adminClaimsService.hasManageAwardsMenu || !claimsUtilService.isPayrollEnabled() || !isAppSupportUser;
            }
        });

        msNavigationService.saveItem('apps.admin.attachmentTypes', {
            title: 'Attachments',
            state: 'app.attachment_types',
            weight: 150,
            hidden: function() {
                return !adminClaimsService.hasAdminMenu || !claimsUtilService.isConfigurableRequiredAttachmentsEnabled();
            }
        });

        msNavigationService.saveItem('apps.admin.businesses', {
            title: 'Businesses',
            state: 'app.businesses',
            weight: 200,
            hidden: function() {
                return !adminClaimsService.hasAdminMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.branches', {
            title: 'Branches',
            state: 'app.branch_view',
            weight: 300,
            hidden: function() {
                return !adminClaimsService.hasManageBranchesMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.commentRestrictions', {
            title: 'Comment Restrictions',
            state: 'app.comment_restrictions',
            weight: 400,
            hidden: function() {
                return !adminClaimsService.hasCommentRestrictionsAccess;
            }
        });

        msNavigationService.saveItem('apps.admin.costcodes', {
            title: 'Cost Codes',
            state: 'app.manage_cost_codes',
            weight: 500,
            hidden: function() {
                return !adminClaimsService.hasManageCostCodesMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.customfieldsmanager', {
            title: 'Custom Fields',
            state: 'app.custom_fields_view',
            weight: 600,
            hidden: function() {
                return !adminClaimsService.hasCustomFieldsMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.customRules', {
            title: 'Custom Rules',
            state: 'app.custom_rules_view',
            weight: 700,
            hidden: function() {
                return !adminClaimsService.hasCustomRulesMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.generalSettings', {
            title: 'General Settings',
            state: 'app.generalSettings',
            weight: 800,
            hidden: function() {
                return !adminClaimsService.hasAdminMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.invoiceexport', {
            title: 'Invoicing Settings',
            state: 'app.invoice-export',
            weight: 900,
            hidden: function() {
                return !adminClaimsService.hasManageInvoiceSettings;
            }
        });

        msNavigationService.saveItem('apps.admin.integrations', {
            title: 'Integrations',
            state: 'app.integrations',
            weight: 1000,
            hidden: function() {
                return !adminClaimsService.hasIntegrationsAccess;
            }
        });

        msNavigationService.saveItem('apps.admin.manage_category', {
            title: 'Item Categories',
            state: 'app.manage_categories',
            weight: 1100,
            hidden: function() {
                return !adminClaimsService.hasManageItemCategoriesMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.lockout', {
            title: 'Lockout Settings',
            state: 'app.lockout-settings',
            weight: 1200,
            hidden: function() {
                return !adminClaimsService.hasLockoutMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.messagingformat', {
            title: 'Messaging Format',
            state: 'app.messaging-format',
            weight: 1300,
            hidden: function() {
                return !adminClaimsService.hasManageMessagingFormat;
            }
        });

        msNavigationService.saveItem('apps.admin.payrollgroups', {
            title: 'Payroll Groups',
            state: 'app.payroll-group',
            weight: 1400,
            hidden: function() {
                return !adminClaimsService.isPayrollGroupsEnabled;
            }
        });


        msNavigationService.saveItem('apps.admin.payroll', {
            title: 'Payroll Settings',
            state: 'app.payroll-settings',
            weight: 1500,
            hidden: function() {
                return !adminClaimsService.hasManagePayrollSettingsMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.projects', {
            title: 'Projects',
            state: 'app.projects_view',
            weight: 1600,
            hidden: function() {
                return !adminClaimsService.hasManageProjectsMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.holidays', {
            title: 'Public Holidays',
            state: 'app.holidays_view',
            weight: 1700,
            hidden: function() {
                return !adminClaimsService.hasPublicHolidays;
            }
        });

        msNavigationService.saveItem('apps.admin.rate_card', {
            title: 'Rate Card Settings',
            state: 'app.rateCardSettings',
            weight: 1800,
            hidden: function() {
                return !adminClaimsService.hasManageRateCardSettings;
            }
        });

        msNavigationService.saveItem('apps.admin.shift_view', {
            title: 'Shift Types',
            state: 'app.shift_view_items',
            weight: 1900,
            hidden: function() {
                return !adminClaimsService.hasManageShiftTypes;
            }
        });

        msNavigationService.saveItem('apps.admin.manage', {
            title: 'Skills',
            state: 'app.skillsmatrix_manage',
            weight: 2000,
            hidden: function() {
                return !adminClaimsService.hasManageSkillsMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.skilllevel', {
            title: 'Skill Levels',
            state: 'app.skilllevel_view',
            weight: 2100,
            hidden: function() {
                return !adminClaimsService.hasManageSkillsLevelMenu;
            }
        });

        msNavigationService.saveItem('apps.admin.tags', {
            title: 'Tags',
            state: 'app.tags',
            weight: 2200,
            hidden: function() {
                return !adminClaimsService.hasAdminOnly;
            }
        });

        msNavigationService.saveItem('apps.admin.taxes', {
            title: 'Taxes',
            state: 'app.tax',
            weight: 2300,
            hidden: function() {
                return !adminClaimsService.hasAdminOnly;
            }
        });

        msNavigationService.saveItem('apps.admin.paperworkConfiguration', {
            title: 'Timesheet Warning Rules',
            state: 'app.paperwork-exceptions-configuration',
            weight: 2400,
            hidden: function() {
                return !adminClaimsService.hasAdminOnly;
            }
        });

        msNavigationService.saveItem('apps.admin.training', {
            title: 'Training',
            state: 'app.training',
            weight: 2500,
            hidden: function() {
                return !adminClaimsService.hasManageTrainings;
            }
        });

        msNavigationService.saveItem('apps.admin.useraccess', {
            title: 'User Access',
            state: 'app.useraccess',
            weight: 2600,
            hidden: function() {
                return !adminClaimsService.hasManageUserAccess;
            }
        });

        msNavigationService.saveItem('apps.admin.vehicle', {
            title: 'Vehicle Models',
            state: 'app.vehicle',
            weight: 2700,
            hidden: function() {
                return !adminClaimsService.hasManageVehicles;
            }
        });

        msNavigationService.saveItem('apps.admin.webhooks', {
            title: 'Webhooks',
            state: 'app.webhooks',
            weight: 2800,
            hidden: function() {
                return !adminClaimsService.hasAdminOnly || !claimsUtilService.isWebhookEnabled();
            }
        });

        msNavigationService.saveItem('apps.admin.workforce', {
            title: 'Workforce Participation',
            state: 'app.workforce_view',
            weight: 2900,
            hidden: function() {
                return !adminClaimsService.hasWorkForceMenu;
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.admin')
        .factory('adminClaimsService', adminClaimsService);

    /** @ngInject */
    function adminClaimsService(
        $rootScope,
        claimsUtilService
    ) {
        var service = {
            hasAdminMenu: false,
            hasAdminOnly: false,
            hasManageSkillsMenu: false,
            hasManageBranchesMenu: false,
            hasCommentRestrictionsAccess: false,
            hasManageProjectsMenu: false,
            hasManageCostCodesMenu: false,
            hasCustomFieldsMenu: false,
            hasCustomRulesMenu: false,
            hasManageItemCategoriesMenu: false,
            hasManageAwardsMenu: false,
            hasManageShiftTypes: false,
            hasManageRateCard: false,
            hasManageRateCardBuilderMenu: false,
            hasManageSkillsLevelMenu: false,
            hasUserFeedbackMenu: false,
            hasWorkForceMenu: false,
            hasLockoutMenu: false,
            hasPublicHolidays: false,
            hasManageUserAccess: false,
            hasManageTrainings: false,
            hasArchiveEmployees: false,
            hasManageVehicles: false,
            hasUnlockTimesheets: false,
            hasManageTimesheetPayroll: false,
            hasConfirmInternalTickets: false,
            hasManagePayrollSettingsMenu: false,
            hasManageInvoiceSettings: false,
            hasIntegrationsAccess: false,
            hasPaperworkExceptionAccess: false,
            hasManageAppsAccess: false,
            isPayrollEnabled: false,
            hasAccessFormPermission: false,
            hasCreateEditFormPermission: false,
            hasDeleteFormPermission: false,
            hasEmployeeReportsAccess: false,
            isPayrollGroupsEnabled: false,
            hasTaxRateMenu: false,
            hasDocumentsManagerCompanies:false,
            hasApproveCalendarEntries: false
        };

        activate();

        return service;

        ///////
        function activate() {
            // Triggered by SignalR
            $rootScope.$on('identityService:applyClaimsRules', function(e, promise) {
                applyClaimsRules();
            });
            applyClaimsRules();
        }

        function applyClaimsRules() {
            let hasAdminAccess = claimsUtilService.checkAccessByRole('Administration');
            let isMobileAppEnabled = claimsUtilService.isMobileAppEnabled();
            let isBillingEnabled = claimsUtilService.isBillingEnabled();
            let isPayrollEnabled = claimsUtilService.isPayrollEnabled();
            let isAltusSpecialEnabled = claimsUtilService.isAltusSpecialEnabled();
            let isPayrollGroupsEnabled = claimsUtilService.isPayrollGroupsEnabled();

            service.hasAdminMenu = hasAdminAccess ||
                claimsUtilService.checkAccessByRole('Manage Public Holidays') ||
                claimsUtilService.checkAccessByRole('ManageProjects') ||
                claimsUtilService.checkAccessByRole('ManageInvoicingSettings') ||
                claimsUtilService.checkAccessByRole('ManagePayrollSettings');
            service.hasAdminOnly = hasAdminAccess;
            service.hasManageSkillsMenu = hasAdminAccess;
            service.hasManageBranchesMenu = hasAdminAccess;
            service.hasCommentRestrictionsAccess = service.hasAdminOnly;
            service.hasManageProjectsMenu = hasAdminAccess || claimsUtilService.checkAccessByRole('ManageProjects');
            service.hasManageCostCodesMenu = hasAdminAccess && claimsUtilService.isBillingEnabled();
            service.hasCustomFieldsMenu = hasAdminAccess && isAltusSpecialEnabled;
            service.hasCustomRulesMenu = hasAdminAccess && isAltusSpecialEnabled;
            service.hasManageItemCategoriesMenu = hasAdminAccess;
            service.hasManageAwardsMenu = hasAdminAccess;
            service.hasManageShiftTypes = hasAdminAccess;
            service.hasManageRateCard = hasAdminAccess;
            service.hasManageRateCardBuilderMenu = hasAdminAccess;
            service.hasManageSkillsLevelMenu = hasAdminAccess;
            service.hasUserFeedbackMenu = hasAdminAccess;
            service.hasWorkForceMenu = hasAdminAccess;
            service.hasLockoutMenu = hasAdminAccess;
            service.hasPublicHolidays = hasAdminAccess || claimsUtilService.checkAccessByRole('Manage Public Holidays');
            service.hasManageUserAccess = hasAdminAccess;
            service.hasManageTrainings = hasAdminAccess;
            service.hasArchiveEmployees = hasAdminAccess || claimsUtilService.checkAccessByRole('Archive Employees');
            service.hasMarkTicketTaxExempt = hasAdminAccess || claimsUtilService.checkAccessByRole('Mark Ticket Tax Exempt');
            service.hasManageVehicles = hasAdminAccess;
            service.hasUnlockTimesheets = hasAdminAccess || claimsUtilService.checkAccessByRole('Unlock Timesheets');
            service.hasManageTimesheetPayroll = hasAdminAccess || claimsUtilService.checkAccessByRole('Manage Timesheet Payroll');
            service.hasConfirmInternalTickets = hasAdminAccess || claimsUtilService.checkAccessByRole('Confirm Internal Tickets');
            service.hasManageMessagingFormat = isMobileAppEnabled && (hasAdminAccess || claimsUtilService.checkAccessByRole('Manage Message Formats'));

            service.hasManagePayrollSettingsMenu = isPayrollEnabled && claimsUtilService.checkAccessByRole('ManagePayrollSettings');
            service.hasRunPayrollPermission = claimsUtilService.checkAccessByRole('Run Payroll');
            service.isPayrollEnabled = isPayrollEnabled;
            service.isPayrollGroupsEnabled = isPayrollEnabled && isPayrollGroupsEnabled;

            service.hasManageInvoiceSettings = isBillingEnabled && claimsUtilService.checkAccessByRole('ManageInvoicingSettings');
            service.hasExportInvoicePermission = claimsUtilService.checkAccessByRole('Export Viewer');
            service.hasIntegrationsAccess = (claimsUtilService.isMyobEnabled() || claimsUtilService.isXeroEnabled()) && (service.hasExportInvoicePermission || service.hasRunPayrollPermission);

            service.hasPaperworkExceptionAccess = claimsUtilService.checkAccessByRole('AccessPaperworkExceptions');
            service.hasManageAppsAccess = hasAdminAccess || claimsUtilService.checkAccessByRole('Manage App Access');

            service.hasAccessFormPermission = claimsUtilService.isCustomFormsEnabled() && claimsUtilService.checkAccessByRole('AccessForms');
            service.hasCreateEditFormPermission = claimsUtilService.checkAccessByRole('CreateEditForms');
            service.hasDeleteFormPermission = claimsUtilService.checkAccessByRole('DeleteForms');

            service.hasManageRateCardSettings = claimsUtilService.checkAccessByRole('Manage Rate Cards');
            service.hasEmployeeReportsAccess  = claimsUtilService.checkAccessByRole('Employee Reports');

            service.hasManagePayrollGroupsPermission = claimsUtilService.checkAccessByRole("Manage Payroll Groups");

            service.hasDocumentsManagerBranches = claimsUtilService.checkAccessByRole("DocumentsManager-Branches");

            service.hasDocumentsManagerCompanies = claimsUtilService.checkAccessByRole("DocumentsManager-Companies");

            service.hasTaxRateMenu = hasAdminAccess;

            service.hasApproveCalendarEntries = claimsUtilService.checkAccessByRole('Approve Calendar Entries');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective)


    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.navigation', ['app.core'])
    .config(config);

  /** @ngInject */
  function config() {

  }

})();

(function(){
    'use strict';

    angular.module('app.navigation')
           .directive('pageHistoryNavigation', pageHistoryNavigation);

           /** @ngInject */
           function pageHistoryNavigation($timeout, utils, pageHistoryService, identityService) {
              var directive = {
                  restrict: 'E',
                  scope: {
                      historySize: '@',
                      historyList: '='
                  },
                  templateUrl: 'app/navigation/history/pageHistory.html',
                  controller: HistoryNavController,
                  controllerAs: 'histVm',
                  bindToController: true
              };

              return directive;

              ///////

              function HistoryNavController() {
                var histVm = this;

                //histVm.historyList = pageHistoryService.pageHistoryList;
                histVm.onNavigate = onNavigate;

                activate();

                function activate() {
                   pageHistoryService.setHistorySize(histVm.historySize);
                   identityService.userDataCallback(userLoadCompleted);
                }

                function onNavigate(id) {
                    pageHistoryService.navigate(id);
                }

                function userLoadCompleted() {
                    pageHistoryService.fetchPageHistory();
                }
              }
        }
})();

(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('xeroService', xeroService);

    /** @ngInject */
    function xeroService(
        integrationsApi
    ) {
        var service = {
            getXeroEmployees: getXeroEmployees,
            getXeroCompaniesByTenant: getXeroCompaniesByTenant
        };

        return service;

        function getXeroCompaniesByTenant(tenantId) {
            return integrationsApi.getCompaniesByProviderAndTenant(integrationsApi.providerTypes.xero, tenantId)
        }

        function getXeroEmployees() {
            return integrationsApi.getEmployeesByProvider(integrationsApi.providerTypes.xero);
        }
    }
})();
"no use strict";!function(e){function t(e,t){var n=e,r="";while(n){var i=t[n];if(typeof i=="string")return i+r;if(i)return i.location.replace(/\/*$/,"/")+(r||i.main||i.name);if(i===!1)return"";var s=n.lastIndexOf("/");if(s===-1)break;r=n.substr(s)+r,n=n.slice(0,s)}return e}if(typeof e.window!="undefined"&&e.document)return;if(e.require&&e.define)return;e.console||(e.console=function(){var e=Array.prototype.slice.call(arguments,0);postMessage({type:"log",data:e})},e.console.error=e.console.warn=e.console.log=e.console.trace=e.console),e.window=e,e.ace=e,e.onerror=function(e,t,n,r,i){postMessage({type:"error",data:{message:e,data:i.data,file:t,line:n,col:r,stack:i.stack}})},e.normalizeModule=function(t,n){if(n.indexOf("!")!==-1){var r=n.split("!");return e.normalizeModule(t,r[0])+"!"+e.normalizeModule(t,r[1])}if(n.charAt(0)=="."){var i=t.split("/").slice(0,-1).join("/");n=(i?i+"/":"")+n;while(n.indexOf(".")!==-1&&s!=n){var s=n;n=n.replace(/^\.\//,"").replace(/\/\.\//,"/").replace(/[^\/]+\/\.\.\//,"")}}return n},e.require=function(r,i){i||(i=r,r=null);if(!i.charAt)throw new Error("worker.js require() accepts only (parentId, id) as arguments");i=e.normalizeModule(r,i);var s=e.require.modules[i];if(s)return s.initialized||(s.initialized=!0,s.exports=s.factory().exports),s.exports;if(!e.require.tlns)return console.log("unable to load "+i);var o=t(i,e.require.tlns);return o.slice(-3)!=".js"&&(o+=".js"),e.require.id=i,e.require.modules[i]={},importScripts(o),e.require(r,i)},e.require.modules={},e.require.tlns={},e.define=function(t,n,r){arguments.length==2?(r=n,typeof t!="string"&&(n=t,t=e.require.id)):arguments.length==1&&(r=t,n=[],t=e.require.id);if(typeof r!="function"){e.require.modules[t]={exports:r,initialized:!0};return}n.length||(n=["require","exports","module"]);var i=function(n){return e.require(t,n)};e.require.modules[t]={exports:{},factory:function(){var e=this,t=r.apply(this,n.map(function(t){switch(t){case"require":return i;case"exports":return e.exports;case"module":return e;default:return i(t)}}));return t&&(e.exports=t),e}}},e.define.amd={},require.tlns={},e.initBaseUrls=function(t){for(var n in t)require.tlns[n]=t[n]},e.initSender=function(){var n=e.require("ace/lib/event_emitter").EventEmitter,r=e.require("ace/lib/oop"),i=function(){};return function(){r.implement(this,n),this.callback=function(e,t){postMessage({type:"call",id:t,data:e})},this.emit=function(e,t){postMessage({type:"event",name:e,data:t})}}.call(i.prototype),new i};var n=e.main=null,r=e.sender=null;e.onmessage=function(t){var i=t.data;if(i.event&&r)r._signal(i.event,i.data);else if(i.command)if(n[i.command])n[i.command].apply(n,i.args);else{if(!e[i.command])throw new Error("Unknown command:"+i.command);e[i.command].apply(e,i.args)}else if(i.init){e.initBaseUrls(i.tlns),require("ace/lib/es5-shim"),r=e.sender=e.initSender();var s=require(i.module)[i.classname];n=e.main=new s(r)}}}(this),ace.define("ace/lib/oop",["require","exports","module"],function(e,t,n){"use strict";t.inherits=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})},t.mixin=function(e,t){for(var n in t)e[n]=t[n];return e},t.implement=function(e,n){t.mixin(e,n)}}),ace.define("ace/range",["require","exports","module"],function(e,t,n){"use strict";var r=function(e,t){return e.row-t.row||e.column-t.column},i=function(e,t,n,r){this.start={row:e,column:t},this.end={row:n,column:r}};(function(){this.isEqual=function(e){return this.start.row===e.start.row&&this.end.row===e.end.row&&this.start.column===e.start.column&&this.end.column===e.end.column},this.toString=function(){return"Range: ["+this.start.row+"/"+this.start.column+"] -> ["+this.end.row+"/"+this.end.column+"]"},this.contains=function(e,t){return this.compare(e,t)==0},this.compareRange=function(e){var t,n=e.end,r=e.start;return t=this.compare(n.row,n.column),t==1?(t=this.compare(r.row,r.column),t==1?2:t==0?1:0):t==-1?-2:(t=this.compare(r.row,r.column),t==-1?-1:t==1?42:0)},this.comparePoint=function(e){return this.compare(e.row,e.column)},this.containsRange=function(e){return this.comparePoint(e.start)==0&&this.comparePoint(e.end)==0},this.intersects=function(e){var t=this.compareRange(e);return t==-1||t==0||t==1},this.isEnd=function(e,t){return this.end.row==e&&this.end.column==t},this.isStart=function(e,t){return this.start.row==e&&this.start.column==t},this.setStart=function(e,t){typeof e=="object"?(this.start.column=e.column,this.start.row=e.row):(this.start.row=e,this.start.column=t)},this.setEnd=function(e,t){typeof e=="object"?(this.end.column=e.column,this.end.row=e.row):(this.end.row=e,this.end.column=t)},this.inside=function(e,t){return this.compare(e,t)==0?this.isEnd(e,t)||this.isStart(e,t)?!1:!0:!1},this.insideStart=function(e,t){return this.compare(e,t)==0?this.isEnd(e,t)?!1:!0:!1},this.insideEnd=function(e,t){return this.compare(e,t)==0?this.isStart(e,t)?!1:!0:!1},this.compare=function(e,t){return!this.isMultiLine()&&e===this.start.row?t<this.start.column?-1:t>this.end.column?1:0:e<this.start.row?-1:e>this.end.row?1:this.start.row===e?t>=this.start.column?0:-1:this.end.row===e?t<=this.end.column?0:1:0},this.compareStart=function(e,t){return this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},this.compareEnd=function(e,t){return this.end.row==e&&this.end.column==t?1:this.compare(e,t)},this.compareInside=function(e,t){return this.end.row==e&&this.end.column==t?1:this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},this.clipRows=function(e,t){if(this.end.row>t)var n={row:t+1,column:0};else if(this.end.row<e)var n={row:e,column:0};if(this.start.row>t)var r={row:t+1,column:0};else if(this.start.row<e)var r={row:e,column:0};return i.fromPoints(r||this.start,n||this.end)},this.extend=function(e,t){var n=this.compare(e,t);if(n==0)return this;if(n==-1)var r={row:e,column:t};else var s={row:e,column:t};return i.fromPoints(r||this.start,s||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return i.fromPoints(this.start,this.end)},this.collapseRows=function(){return this.end.column==0?new i(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new i(this.start.row,0,this.end.row,0)},this.toScreenRange=function(e){var t=e.documentToScreenPosition(this.start),n=e.documentToScreenPosition(this.end);return new i(t.row,t.column,n.row,n.column)},this.moveBy=function(e,t){this.start.row+=e,this.start.column+=t,this.end.row+=e,this.end.column+=t}}).call(i.prototype),i.fromPoints=function(e,t){return new i(e.row,e.column,t.row,t.column)},i.comparePoints=r,i.comparePoints=function(e,t){return e.row-t.row||e.column-t.column},t.Range=i}),ace.define("ace/apply_delta",["require","exports","module"],function(e,t,n){"use strict";function r(e,t){throw console.log("Invalid Delta:",e),"Invalid Delta: "+t}function i(e,t){return t.row>=0&&t.row<e.length&&t.column>=0&&t.column<=e[t.row].length}function s(e,t){t.action!="insert"&&t.action!="remove"&&r(t,"delta.action must be 'insert' or 'remove'"),t.lines instanceof Array||r(t,"delta.lines must be an Array"),(!t.start||!t.end)&&r(t,"delta.start/end must be an present");var n=t.start;i(e,t.start)||r(t,"delta.start must be contained in document");var s=t.end;t.action=="remove"&&!i(e,s)&&r(t,"delta.end must contained in document for 'remove' actions");var o=s.row-n.row,u=s.column-(o==0?n.column:0);(o!=t.lines.length-1||t.lines[o].length!=u)&&r(t,"delta.range must match delta lines")}t.applyDelta=function(e,t,n){var r=t.start.row,i=t.start.column,s=e[r]||"";switch(t.action){case"insert":var o=t.lines;if(o.length===1)e[r]=s.substring(0,i)+t.lines[0]+s.substring(i);else{var u=[r,1].concat(t.lines);e.splice.apply(e,u),e[r]=s.substring(0,i)+e[r],e[r+t.lines.length-1]+=s.substring(i)}break;case"remove":var a=t.end.column,f=t.end.row;r===f?e[r]=s.substring(0,i)+s.substring(a):e.splice(r,f-r+1,s.substring(0,i)+e[f].substring(a))}}}),ace.define("ace/lib/event_emitter",["require","exports","module"],function(e,t,n){"use strict";var r={},i=function(){this.propagationStopped=!0},s=function(){this.defaultPrevented=!0};r._emit=r._dispatchEvent=function(e,t){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var n=this._eventRegistry[e]||[],r=this._defaultHandlers[e];if(!n.length&&!r)return;if(typeof t!="object"||!t)t={};t.type||(t.type=e),t.stopPropagation||(t.stopPropagation=i),t.preventDefault||(t.preventDefault=s),n=n.slice();for(var o=0;o<n.length;o++){n[o](t,this);if(t.propagationStopped)break}if(r&&!t.defaultPrevented)return r(t,this)},r._signal=function(e,t){var n=(this._eventRegistry||{})[e];if(!n)return;n=n.slice();for(var r=0;r<n.length;r++)n[r](t,this)},r.once=function(e,t){var n=this;t&&this.addEventListener(e,function r(){n.removeEventListener(e,r),t.apply(null,arguments)})},r.setDefaultHandler=function(e,t){var n=this._defaultHandlers;n||(n=this._defaultHandlers={_disabled_:{}});if(n[e]){var r=n[e],i=n._disabled_[e];i||(n._disabled_[e]=i=[]),i.push(r);var s=i.indexOf(t);s!=-1&&i.splice(s,1)}n[e]=t},r.removeDefaultHandler=function(e,t){var n=this._defaultHandlers;if(!n)return;var r=n._disabled_[e];if(n[e]==t){var i=n[e];r&&this.setDefaultHandler(e,r.pop())}else if(r){var s=r.indexOf(t);s!=-1&&r.splice(s,1)}},r.on=r.addEventListener=function(e,t,n){this._eventRegistry=this._eventRegistry||{};var r=this._eventRegistry[e];return r||(r=this._eventRegistry[e]=[]),r.indexOf(t)==-1&&r[n?"unshift":"push"](t),t},r.off=r.removeListener=r.removeEventListener=function(e,t){this._eventRegistry=this._eventRegistry||{};var n=this._eventRegistry[e];if(!n)return;var r=n.indexOf(t);r!==-1&&n.splice(r,1)},r.removeAllListeners=function(e){this._eventRegistry&&(this._eventRegistry[e]=[])},t.EventEmitter=r}),ace.define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/event_emitter").EventEmitter,s=t.Anchor=function(e,t,n){this.$onChange=this.onChange.bind(this),this.attach(e),typeof n=="undefined"?this.setPosition(t.row,t.column):this.setPosition(t,n)};(function(){function e(e,t,n){var r=n?e.column<=t.column:e.column<t.column;return e.row<t.row||e.row==t.row&&r}function t(t,n,r){var i=t.action=="insert",s=(i?1:-1)*(t.end.row-t.start.row),o=(i?1:-1)*(t.end.column-t.start.column),u=t.start,a=i?u:t.end;return e(n,u,r)?{row:n.row,column:n.column}:e(a,n,!r)?{row:n.row+s,column:n.column+(n.row==a.row?o:0)}:{row:u.row,column:u.column}}r.implement(this,i),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(e){if(e.start.row==e.end.row&&e.start.row!=this.row)return;if(e.start.row>this.row)return;var n=t(e,{row:this.row,column:this.column},this.$insertRight);this.setPosition(n.row,n.column,!0)},this.setPosition=function(e,t,n){var r;n?r={row:e,column:t}:r=this.$clipPositionToDocument(e,t);if(this.row==r.row&&this.column==r.column)return;var i={row:this.row,column:this.column};this.row=r.row,this.column=r.column,this._signal("change",{old:i,value:r})},this.detach=function(){this.document.removeEventListener("change",this.$onChange)},this.attach=function(e){this.document=e||this.document,this.document.on("change",this.$onChange)},this.$clipPositionToDocument=function(e,t){var n={};return e>=this.document.getLength()?(n.row=Math.max(0,this.document.getLength()-1),n.column=this.document.getLine(n.row).length):e<0?(n.row=0,n.column=0):(n.row=e,n.column=Math.min(this.document.getLine(n.row).length,Math.max(0,t))),t<0&&(n.column=0),n}}).call(s.prototype)}),ace.define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./apply_delta").applyDelta,s=e("./lib/event_emitter").EventEmitter,o=e("./range").Range,u=e("./anchor").Anchor,a=function(e){this.$lines=[""],e.length===0?this.$lines=[""]:Array.isArray(e)?this.insertMergedLines({row:0,column:0},e):this.insert({row:0,column:0},e)};(function(){r.implement(this,s),this.setValue=function(e){var t=this.getLength()-1;this.remove(new o(0,0,t,this.getLine(t).length)),this.insert({row:0,column:0},e)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(e,t){return new u(this,e,t)},"aaa".split(/a/).length===0?this.$split=function(e){return e.replace(/\r\n|\r/g,"\n").split("\n")}:this.$split=function(e){return e.split(/\r\n|\r|\n/)},this.$detectNewLine=function(e){var t=e.match(/^.*?(\r\n|\r|\n)/m);this.$autoNewLine=t?t[1]:"\n",this._signal("changeNewLineMode")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case"windows":return"\r\n";case"unix":return"\n";default:return this.$autoNewLine||"\n"}},this.$autoNewLine="",this.$newLineMode="auto",this.setNewLineMode=function(e){if(this.$newLineMode===e)return;this.$newLineMode=e,this._signal("changeNewLineMode")},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(e){return e=="\r\n"||e=="\r"||e=="\n"},this.getLine=function(e){return this.$lines[e]||""},this.getLines=function(e,t){return this.$lines.slice(e,t+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(e){return this.getLinesForRange(e).join(this.getNewLineCharacter())},this.getLinesForRange=function(e){var t;if(e.start.row===e.end.row)t=[this.getLine(e.start.row).substring(e.start.column,e.end.column)];else{t=this.getLines(e.start.row,e.end.row),t[0]=(t[0]||"").substring(e.start.column);var n=t.length-1;e.end.row-e.start.row==n&&(t[n]=t[n].substring(0,e.end.column))}return t},this.insertLines=function(e,t){return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."),this.insertFullLines(e,t)},this.removeLines=function(e,t){return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."),this.removeFullLines(e,t)},this.insertNewLine=function(e){return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."),this.insertMergedLines(e,["",""])},this.insert=function(e,t){return this.getLength()<=1&&this.$detectNewLine(t),this.insertMergedLines(e,this.$split(t))},this.insertInLine=function(e,t){var n=this.clippedPos(e.row,e.column),r=this.pos(e.row,e.column+t.length);return this.applyDelta({start:n,end:r,action:"insert",lines:[t]},!0),this.clonePos(r)},this.clippedPos=function(e,t){var n=this.getLength();e===undefined?e=n:e<0?e=0:e>=n&&(e=n-1,t=undefined);var r=this.getLine(e);return t==undefined&&(t=r.length),t=Math.min(Math.max(t,0),r.length),{row:e,column:t}},this.clonePos=function(e){return{row:e.row,column:e.column}},this.pos=function(e,t){return{row:e,column:t}},this.$clipPosition=function(e){var t=this.getLength();return e.row>=t?(e.row=Math.max(0,t-1),e.column=this.getLine(t-1).length):(e.row=Math.max(0,e.row),e.column=Math.min(Math.max(e.column,0),this.getLine(e.row).length)),e},this.insertFullLines=function(e,t){e=Math.min(Math.max(e,0),this.getLength());var n=0;e<this.getLength()?(t=t.concat([""]),n=0):(t=[""].concat(t),e--,n=this.$lines[e].length),this.insertMergedLines({row:e,column:n},t)},this.insertMergedLines=function(e,t){var n=this.clippedPos(e.row,e.column),r={row:n.row+t.length-1,column:(t.length==1?n.column:0)+t[t.length-1].length};return this.applyDelta({start:n,end:r,action:"insert",lines:t}),this.clonePos(r)},this.remove=function(e){var t=this.clippedPos(e.start.row,e.start.column),n=this.clippedPos(e.end.row,e.end.column);return this.applyDelta({start:t,end:n,action:"remove",lines:this.getLinesForRange({start:t,end:n})}),this.clonePos(t)},this.removeInLine=function(e,t,n){var r=this.clippedPos(e,t),i=this.clippedPos(e,n);return this.applyDelta({start:r,end:i,action:"remove",lines:this.getLinesForRange({start:r,end:i})},!0),this.clonePos(r)},this.removeFullLines=function(e,t){e=Math.min(Math.max(0,e),this.getLength()-1),t=Math.min(Math.max(0,t),this.getLength()-1);var n=t==this.getLength()-1&&e>0,r=t<this.getLength()-1,i=n?e-1:e,s=n?this.getLine(i).length:0,u=r?t+1:t,a=r?0:this.getLine(u).length,f=new o(i,s,u,a),l=this.$lines.slice(e,t+1);return this.applyDelta({start:f.start,end:f.end,action:"remove",lines:this.getLinesForRange(f)}),l},this.removeNewLine=function(e){e<this.getLength()-1&&e>=0&&this.applyDelta({start:this.pos(e,this.getLine(e).length),end:this.pos(e+1,0),action:"remove",lines:["",""]})},this.replace=function(e,t){e instanceof o||(e=o.fromPoints(e.start,e.end));if(t.length===0&&e.isEmpty())return e.start;if(t==this.getTextRange(e))return e.end;this.remove(e);var n;return t?n=this.insert(e.start,t):n=e.start,n},this.applyDeltas=function(e){for(var t=0;t<e.length;t++)this.applyDelta(e[t])},this.revertDeltas=function(e){for(var t=e.length-1;t>=0;t--)this.revertDelta(e[t])},this.applyDelta=function(e,t){var n=e.action=="insert";if(n?e.lines.length<=1&&!e.lines[0]:!o.comparePoints(e.start,e.end))return;n&&e.lines.length>2e4?this.$splitAndapplyLargeDelta(e,2e4):(i(this.$lines,e,t),this._signal("change",e))},this.$splitAndapplyLargeDelta=function(e,t){var n=e.lines,r=n.length-t+1,i=e.start.row,s=e.start.column;for(var o=0,u=0;o<r;o=u){u+=t-1;var a=n.slice(o,u);a.push(""),this.applyDelta({start:this.pos(i+o,s),end:this.pos(i+u,s=0),action:e.action,lines:a},!0)}e.lines=n.slice(o),e.start.row=i+o,e.start.column=s,this.applyDelta(e,!0)},this.revertDelta=function(e){this.applyDelta({start:this.clonePos(e.start),end:this.clonePos(e.end),action:e.action=="insert"?"remove":"insert",lines:e.lines.slice()})},this.indexToPosition=function(e,t){var n=this.$lines||this.getAllLines(),r=this.getNewLineCharacter().length;for(var i=t||0,s=n.length;i<s;i++){e-=n[i].length+r;if(e<0)return{row:i,column:e+n[i].length+r}}return{row:s-1,column:e+n[s-1].length+r}},this.positionToIndex=function(e,t){var n=this.$lines||this.getAllLines(),r=this.getNewLineCharacter().length,i=0,s=Math.min(e.row,n.length);for(var o=t||0;o<s;++o)i+=n[o].length+r;return i+e.column}}).call(a.prototype),t.Document=a}),ace.define("ace/lib/lang",["require","exports","module"],function(e,t,n){"use strict";t.last=function(e){return e[e.length-1]},t.stringReverse=function(e){return e.split("").reverse().join("")},t.stringRepeat=function(e,t){var n="";while(t>0){t&1&&(n+=e);if(t>>=1)e+=e}return n};var r=/^\s\s*/,i=/\s\s*$/;t.stringTrimLeft=function(e){return e.replace(r,"")},t.stringTrimRight=function(e){return e.replace(i,"")},t.copyObject=function(e){var t={};for(var n in e)t[n]=e[n];return t},t.copyArray=function(e){var t=[];for(var n=0,r=e.length;n<r;n++)e[n]&&typeof e[n]=="object"?t[n]=this.copyObject(e[n]):t[n]=e[n];return t},t.deepCopy=function s(e){if(typeof e!="object"||!e)return e;var t;if(Array.isArray(e)){t=[];for(var n=0;n<e.length;n++)t[n]=s(e[n]);return t}if(Object.prototype.toString.call(e)!=="[object Object]")return e;t={};for(var n in e)t[n]=s(e[n]);return t},t.arrayToMap=function(e){var t={};for(var n=0;n<e.length;n++)t[e[n]]=1;return t},t.createMap=function(e){var t=Object.create(null);for(var n in e)t[n]=e[n];return t},t.arrayRemove=function(e,t){for(var n=0;n<=e.length;n++)t===e[n]&&e.splice(n,1)},t.escapeRegExp=function(e){return e.replace(/([.*+?^${}()|[\]\/\\])/g,"\\$1")},t.escapeHTML=function(e){return e.replace(/&/g,"&#38;").replace(/"/g,"&#34;").replace(/'/g,"&#39;").replace(/</g,"&#60;")},t.getMatchOffsets=function(e,t){var n=[];return e.replace(t,function(e){n.push({offset:arguments[arguments.length-2],length:e.length})}),n},t.deferredCall=function(e){var t=null,n=function(){t=null,e()},r=function(e){return r.cancel(),t=setTimeout(n,e||0),r};return r.schedule=r,r.call=function(){return this.cancel(),e(),r},r.cancel=function(){return clearTimeout(t),t=null,r},r.isPending=function(){return t},r},t.delayedCall=function(e,t){var n=null,r=function(){n=null,e()},i=function(e){n==null&&(n=setTimeout(r,e||t))};return i.delay=function(e){n&&clearTimeout(n),n=setTimeout(r,e||t)},i.schedule=i,i.call=function(){this.cancel(),e()},i.cancel=function(){n&&clearTimeout(n),n=null},i.isPending=function(){return n},i}}),ace.define("ace/worker/mirror",["require","exports","module","ace/range","ace/document","ace/lib/lang"],function(e,t,n){"use strict";var r=e("../range").Range,i=e("../document").Document,s=e("../lib/lang"),o=t.Mirror=function(e){this.sender=e;var t=this.doc=new i(""),n=this.deferredUpdate=s.delayedCall(this.onUpdate.bind(this)),r=this;e.on("change",function(e){var i=e.data;if(i[0].start)t.applyDeltas(i);else for(var s=0;s<i.length;s+=2){if(Array.isArray(i[s+1]))var o={action:"insert",start:i[s],lines:i[s+1]};else var o={action:"remove",start:i[s],end:i[s+1]};t.applyDelta(o,!0)}if(r.$timeout)return n.schedule(r.$timeout);r.onUpdate()})};(function(){this.$timeout=500,this.setTimeout=function(e){this.$timeout=e},this.setValue=function(e){this.doc.setValue(e),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(e){this.sender.callback(this.doc.getValue(),e)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(o.prototype)}),ace.define("ace/mode/javascript/jshint",["require","exports","module"],function(e,t,n){n.exports=function r(t,n,i){function o(u,a){if(!n[u]){if(!t[u]){var f=typeof e=="function"&&e;if(!a&&f)return f(u,!0);if(s)return s(u,!0);var l=new Error("Cannot find module '"+u+"'");throw l.code="MODULE_NOT_FOUND",l}var c=n[u]={exports:{}};t[u][0].call(c.exports,function(e){var n=t[u][1][e];return o(n?n:e)},c,c.exports,r,t,n,i)}return n[u].exports}var s=typeof e=="function"&&e;for(var u=0;u<i.length;u++)o(i[u]);return o(i[0])}({"/node_modules/browserify/node_modules/events/events.js":[function(e,t,n){function r(){this._events=this._events||{},this._maxListeners=this._maxListeners||undefined}function i(e){return typeof e=="function"}function s(e){return typeof e=="number"}function o(e){return typeof e=="object"&&e!==null}function u(e){return e===void 0}t.exports=r,r.EventEmitter=r,r.prototype._events=undefined,r.prototype._maxListeners=undefined,r.defaultMaxListeners=10,r.prototype.setMaxListeners=function(e){if(!s(e)||e<0||isNaN(e))throw TypeError("n must be a positive number");return this._maxListeners=e,this},r.prototype.emit=function(e){var t,n,r,s,a,f;this._events||(this._events={});if(e==="error")if(!this._events.error||o(this._events.error)&&!this._events.error.length)throw t=arguments[1],t instanceof Error?t:TypeError('Uncaught, unspecified "error" event.');n=this._events[e];if(u(n))return!1;if(i(n))switch(arguments.length){case 1:n.call(this);break;case 2:n.call(this,arguments[1]);break;case 3:n.call(this,arguments[1],arguments[2]);break;default:r=arguments.length,s=new Array(r-1);for(a=1;a<r;a++)s[a-1]=arguments[a];n.apply(this,s)}else if(o(n)){r=arguments.length,s=new Array(r-1);for(a=1;a<r;a++)s[a-1]=arguments[a];f=n.slice(),r=f.length;for(a=0;a<r;a++)f[a].apply(this,s)}return!0},r.prototype.addListener=function(e,t){var n;if(!i(t))throw TypeError("listener must be a function");this._events||(this._events={}),this._events.newListener&&this.emit("newListener",e,i(t.listener)?t.listener:t),this._events[e]?o(this._events[e])?this._events[e].push(t):this._events[e]=[this._events[e],t]:this._events[e]=t;if(o(this._events[e])&&!this._events[e].warned){var n;u(this._maxListeners)?n=r.defaultMaxListeners:n=this._maxListeners,n&&n>0&&this._events[e].length>n&&(this._events[e].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[e].length),typeof console.trace=="function"&&console.trace())}return this},r.prototype.on=r.prototype.addListener,r.prototype.once=function(e,t){function r(){this.removeListener(e,r),n||(n=!0,t.apply(this,arguments))}if(!i(t))throw TypeError("listener must be a function");var n=!1;return r.listener=t,this.on(e,r),this},r.prototype.removeListener=function(e,t){var n,r,s,u;if(!i(t))throw TypeError("listener must be a function");if(!this._events||!this._events[e])return this;n=this._events[e],s=n.length,r=-1;if(n===t||i(n.listener)&&n.listener===t)delete this._events[e],this._events.removeListener&&this.emit("removeListener",e,t);else if(o(n)){for(u=s;u-->0;)if(n[u]===t||n[u].listener&&n[u].listener===t){r=u;break}if(r<0)return this;n.length===1?(n.length=0,delete this._events[e]):n.splice(r,1),this._events.removeListener&&this.emit("removeListener",e,t)}return this},r.prototype.removeAllListeners=function(e){var t,n;if(!this._events)return this;if(!this._events.removeListener)return arguments.length===0?this._events={}:this._events[e]&&delete this._events[e],this;if(arguments.length===0){for(t in this._events){if(t==="removeListener")continue;this.removeAllListeners(t)}return this.removeAllListeners("removeListener"),this._events={},this}n=this._events[e];if(i(n))this.removeListener(e,n);else while(n.length)this.removeListener(e,n[n.length-1]);return delete this._events[e],this},r.prototype.listeners=function(e){var t;return!this._events||!this._events[e]?t=[]:i(this._events[e])?t=[this._events[e]]:t=this._events[e].slice(),t},r.listenerCount=function(e,t){var n;return!e._events||!e._events[t]?n=0:i(e._events[t])?n=1:n=e._events[t].length,n}},{}],"/node_modules/jshint/data/ascii-identifier-data.js":[function(e,t,n){var r=[];for(var i=0;i<128;i++)r[i]=i===36||i>=65&&i<=90||i===95||i>=97&&i<=122;var s=[];for(var i=0;i<128;i++)s[i]=r[i]||i>=48&&i<=57;t.exports={asciiIdentifierStartTable:r,asciiIdentifierPartTable:s}},{}],"/node_modules/jshint/lodash.js":[function(e,t,n){(function(e){(function(){function $(e,t,n){var r=e.length,i=n?r:-1;while(n?i--:++i<r)if(t(e[i],i,e))return i;return-1}function J(e,t,n){if(t!==t)return G(e,n);var r=n-1,i=e.length;while(++r<i)if(e[r]===t)return r;return-1}function K(e){return typeof e=="function"||!1}function Q(e){return typeof e=="string"?e:e==null?"":e+""}function G(e,t,n){var r=e.length,i=t+(n?0:-1);while(n?i--:++i<r){var s=e[i];if(s!==s)return i}return-1}function Y(e){return!!e&&typeof e=="object"}function Ct(){}function Lt(e,t){var n=-1,r=e.length;t||(t=Array(r));while(++n<r)t[n]=e[n];return t}function At(e,t){var n=-1,r=e.length;while(++n<r)if(t(e[n],n,e)===!1)break;return e}function Ot(e,t){var n=-1,r=e.length,i=-1,s=[];while(++n<r){var o=e[n];t(o,n,e)&&(s[++i]=o)}return s}function Mt(e,t){var n=-1,r=e.length,i=Array(r);while(++n<r)i[n]=t(e[n],n,e);return i}function _t(e){var t=-1,n=e.length,r=wt;while(++t<n){var i=e[t];i>r&&(r=i)}return r}function Dt(e,t){var n=-1,r=e.length;while(++n<r)if(t(e[n],n,e))return!0;return!1}function Pt(e,t,n){var i=rr(t);lt.apply(i,bn(t));var s=-1,o=i.length;while(++s<o){var u=i[s],a=e[u],f=n(a,t[u],u,e,t);if((f===f?f!==a:a===a)||a===r&&!(u in e))e[u]=f}return e}function Bt(e,t,n){n||(n={});var r=-1,i=t.length;while(++r<i){var s=t[r];n[s]=e[s]}return n}function jt(e,t,n){var i=typeof e;return i=="function"?t===r?e:on(e,t,n):e==null?lr:i=="object"?Jt(e):t===r?cr(e):Kt(e,t)}function Ft(e,t,n,i,s,u,a){var f;n&&(f=s?n(e,i,s):n(e));if(f!==r)return f;if(!Jn(e))return e;var l=Xn(e);if(l){f=wn(e);if(!t)return Lt(e,f)}else{var h=rt.call(e),p=h==c;if(!(h==d||h==o||p&&!s))return F[h]?Sn(e,h,t):s?e:{};f=En(p?{}:e);if(!t)return Ht(f,e)}u||(u=[]),a||(a=[]);var v=u.length;while(v--)if(u[v]==e)return a[v];return u.push(e),a.push(f),(l?At:zt)(e,function(r,i){f[i]=Ft(r,t,n,i,e,u,a)}),f}function qt(e,t){var n=[];return It(e,function(e,r,i){t(e,r,i)&&n.push(e)}),n}function Ut(e,t){return Rt(e,t,ir)}function zt(e,t){return Rt(e,t,rr)}function Wt(e,t,n){if(e==null)return;n!==r&&n in On(e)&&(t=[n]);var i=-1,s=t.length;while(e!=null&&++i<s)var o=e=e[t[i]];return o}function Xt(e,t,n,r,i,s){if(e===t)return e!==0||1/e==1/t;var o=typeof e,u=typeof t;return o!="function"&&o!="object"&&u!="function"&&u!="object"||e==null||t==null?e!==e&&t!==t:Vt(e,t,Xt,n,r,i,s)}function Vt(e,t,n,r,i,s,a){var f=Xn(e),l=Xn(t),c=u,h=u;f||(c=rt.call(e),c==o?c=d:c!=d&&(f=Zn(e))),l||(h=rt.call(t),h==o?h=d:h!=d&&(l=Zn(t)));var p=c==d,v=h==d,m=c==h;if(m&&!f&&!p)return dn(e,t,c);if(!i){var g=p&&nt.call(e,"__wrapped__"),y=v&&nt.call(t,"__wrapped__");if(g||y)return n(g?e.value():e,y?t.value():t,r,i,s,a)}if(!m)return!1;s||(s=[]),a||(a=[]);var b=s.length;while(b--)if(s[b]==e)return a[b]==t;s.push(e),a.push(t);var w=(f?pn:vn)(e,t,n,r,i,s,a);return s.pop(),a.pop(),w}function $t(e,t,n,i,s){var o=-1,u=t.length,a=!s;while(++o<u)if(a&&i[o]?n[o]!==e[t[o]]:!(t[o]in e))return!1;o=-1;while(++o<u){var f=t[o],l=e[f],c=n[o];if(a&&i[o])var h=l!==r||f in e;else h=s?s(l,c,f):r,h===r&&(h=Xt(c,l,s,!0));if(!h)return!1}return!0}function Jt(e){var t=rr(e),n=t.length;if(!n)return fr(!0);if(n==1){var i=t[0],s=e[i];if(kn(s))return function(e){return e==null?!1:e[i]===s&&(s!==r||i in On(e))}}var o=Array(n),u=Array(n);while(n--)s=e[t[n]],o[n]=s,u[n]=kn(s);return function(e){return e!=null&&$t(On(e),t,o,u)}}function Kt(e,t){var n=Xn(e),i=Nn(e)&&kn(t),s=e+"";return e=Mn(e),function(o){if(o==null)return!1;var u=s;o=On(o);if((n||!i)&&!(u in o)){o=e.length==1?o:Wt(o,en(e,0,-1));if(o==null)return!1;u=Pn(e),o=On(o)}return o[u]===t?t!==r||u in o:Xt(t,o[u],null,!0)}}function Qt(e,t,n,i,s){if(!Jn(e))return e;var o=Cn(t.length)&&(Xn(t)||Zn(t));if(!o){var u=rr(t);lt.apply(u,bn(t))}return At(u||t,function(a,f){u&&(f=a,a=t[f]);if(Y(a))i||(i=[]),s||(s=[]),Gt(e,t,f,Qt,n,i,s);else{var l=e[f],c=n?n(l,a,f,e,t):r,h=c===r;h&&(c=a),(o||c!==r)&&(h||(c===c?c!==l:l===l))&&(e[f]=c)}}),e}function Gt(e,t,n,i,s,o,u){var a=o.length,f=t[n];while(a--)if(o[a]==f){e[n]=u[a];return}var l=e[n],c=s?s(l,f,n,e,t):r,h=c===r;h&&(c=f,Cn(f.length)&&(Xn(f)||Zn(f))?c=Xn(l)?l:yn(l)?Lt(l):[]:Gn(f)||Wn(f)?c=Wn(l)?er(l):Gn(l)?l:{}:h=!1),o.push(f),u.push(c);if(h)e[n]=i(c,f,s,o,u);else if(c===c?c!==l:l===l)e[n]=c}function Yt(e){return function(t){return t==null?r:t[e]}}function Zt(e){var t=e+"";return e=Mn(e),function(n){return Wt(n,e,t)}}function en(e,t,n){var i=-1,s=e.length;t=t==null?0:+t||0,t<0&&(t=-t>s?0:s+t),n=n===r||n>s?s:+n||0,n<0&&(n+=s),s=t>n?0:n-t>>>0,t>>>=0;var o=Array(s);while(++i<s)o[i]=e[i+t];return o}function tn(e,t){var n;return It(e,function(e,r,i){return n=t(e,r,i),!n}),!!n}function nn(e,t){var n=-1,r=t.length,i=Array(r);while(++n<r)i[n]=e[t[n]];return i}function rn(e,t,n){var r=0,i=e?e.length:r;if(typeof t=="number"&&t===t&&i<=xt){while(r<i){var s=r+i>>>1,o=e[s];(n?o<=t:o<t)?r=s+1:i=s}return i}return sn(e,t,lr,n)}function sn(e,t,n,i){t=n(t);var s=0,o=e?e.length:0,u=t!==t,a=t===r;while(s<o){var f=ut((s+o)/2),l=n(e[f]),c=l===l;if(u)var h=c||i;else a?h=c&&(i||l!==r):h=i?l<=t:l<t;h?s=f+1:o=f}return bt(o,St)}function on(e,t,n){if(typeof e!="function")return lr;if(t===r)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 3:return function(n,r,i){return e.call(t,n,r,i)};case 4:return function(n,r,i,s){return e.call(t,n,r,i,s)};case 5:return function(n,r,i,s,o){return e.call(t,n,r,i,s,o)}}return function(){return e.apply(t,arguments)}}function un(e){return ot.call(e,0)}function an(e){return Un(function(t,n){var r=-1,i=t==null?0:n.length,s=i>2&&n[i-2],o=i>2&&n[2],u=i>1&&n[i-1];typeof s=="function"?(s=on(s,u,5),i-=2):(s=typeof u=="function"?u:null,i-=s?1:0),o&&Tn(n[0],n[1],o)&&(s=i<3?null:s,i=1);while(++r<i){var a=n[r];a&&e(t,a,s)}return t})}function fn(e,t){return function(n,r){var i=n?yn(n):0;if(!Cn(i))return e(n,r);var s=t?i:-1,o=On(n);while(t?s--:++s<i)if(r(o[s],s,o)===!1)break;return n}}function ln(e){return function(t,n,r){var i=On(t),s=r(t),o=s.length,u=e?o:-1;while(e?u--:++u<o){var a=s[u];if(n(i[a],a,i)===!1)break}return t}}function cn(e){return function(t,n,r){return!t||!t.length?-1:(n=mn(n,r,3),$(t,n,e))}}function hn(e,t){return function(n,i,s){return typeof i=="function"&&s===r&&Xn(n)?e(n,i):t(n,on(i,s,3))}}function pn(e,t,n,i,s,o,u){var a=-1,f=e.length,l=t.length,c=!0;if(f!=l&&!(s&&l>f))return!1;while(c&&++a<f){var h=e[a],p=t[a];c=r,i&&(c=s?i(p,h,a):i(h,p,a));if(c===r)if(s){var d=l;while(d--){p=t[d],c=h&&h===p||n(h,p,i,s,o,u);if(c)break}}else c=h&&h===p||n(h,p,i,s,o,u)}return!!c}function dn(e,t,n){switch(n){case a:case f:return+e==+t;case l:return e.name==t.name&&e.message==t.message;case p:return e!=+e?t!=+t:e==0?1/e==1/t:e==+t;case v:case g:return e==t+""}return!1}function vn(e,t,n,i,s,o,u){var a=rr(e),f=a.length,l=rr(t),c=l.length;if(f!=c&&!s)return!1;var h=s,p=-1;while(++p<f){var d=a[p],v=s?d in t:nt.call(t,d);if(v){var m=e[d],g=t[d];v=r,i&&(v=s?i(g,m,d):i(m,g,d)),v===r&&(v=m&&m===g||n(m,g,i,s,o,u))}if(!v)return!1;h||(h=d=="constructor")}if(!h){var y=e.constructor,b=t.constructor;if(y!=b&&"constructor"in e&&"constructor"in t&&!(typeof y=="function"&&y instanceof y&&typeof b=="function"&&b instanceof b))return!1}return!0}function mn(e,t,n){var r=Ct.callback||ar;return r=r===ar?jt:r,n?r(e,t,n):r}function gn(e,t,n){var r=Ct.indexOf||Dn;return r=r===Dn?J:r,e?r(e,t,n):r}function wn(e){var t=e.length,n=new e.constructor(t);return t&&typeof e[0]=="string"&&nt.call(e,"index")&&(n.index=e.index,n.input=e.input),n}function En(e){var t=e.constructor;return typeof t=="function"&&t instanceof t||(t=Object),new t}function Sn(e,t,n){var r=e.constructor;switch(t){case b:return un(e);case a:case f:return new r(+e);case w:case E:case S:case x:case T:case N:case C:case k:case L:var i=e.buffer;return new r(n?un(i):i,e.byteOffset,e.length);case p:case g:return new r(e);case v:var s=new r(e.source,H.exec(e));s.lastIndex=e.lastIndex}return s}function xn(e,t){return e=+e,t=t==null?Nt:t,e>-1&&e%1==0&&e<t}function Tn(e,t,n){if(!Jn(n))return!1;var r=typeof t;if(r=="number")var i=yn(n),s=Cn(i)&&xn(t,i);else s=r=="string"&&t in n;if(s){var o=n[t];return e===e?e===o:o!==o}return!1}function Nn(e,t){var n=typeof e;if(n=="string"&&O.test(e)||n=="number")return!0;if(Xn(e))return!1;var r=!A.test(e);return r||t!=null&&e in On(t)}function Cn(e){return typeof e=="number"&&e>-1&&e%1==0&&e<=Nt}function kn(e){return e===e&&(e===0?1/e>0:!Jn(e))}function Ln(e){var t,n=Ct.support;if(!Y(e)||rt.call(e)!=d||!nt.call(e,"constructor")&&(t=e.constructor,typeof t=="function"&&!(t instanceof t)))return!1;var i;return Ut(e,function(e,t){i=t}),i===r||nt.call(e,i)}function An(e){var t=ir(e),n=t.length,r=n&&e.length,i=Ct.support,s=r&&Cn(r)&&(Xn(e)||i.nonEnumArgs&&Wn(e)),o=-1,u=[];while(++o<n){var a=t[o];(s&&xn(a,r)||nt.call(e,a))&&u.push(a)}return u}function On(e){return Jn(e)?e:Object(e)}function Mn(e){if(Xn(e))return e;var t=[];return Q(e).replace(M,function(e,n,r,i){t.push(r?i.replace(P,"$1"):n||e)}),t}function Dn(e,t,n){var r=e?e.length:0;if(!r)return-1;if(typeof n=="number")n=n<0?yt(r+n,0):n;else if(n){var i=rn(e,t),s=e[i];return(t===t?t===s:s!==s)?i:-1}return J(e,t,n||0)}function Pn(e){var t=e?e.length:0;return t?e[t-1]:r}function Hn(e,t,n){var r=e?e.length:0;return r?(n&&typeof n!="number"&&Tn(e,t,n)&&(t=0,n=r),en(e,t,n)):[]}function Bn(e){var t=-1,n=(e&&e.length&&_t(Mt(e,yn)))>>>0,r=Array(n);while(++t<n)r[t]=Mt(e,Yt(t));return r}function In(e,t,n,r){var i=e?yn(e):0;return Cn(i)||(e=or(e),i=e.length),i?(typeof n!="number"||r&&Tn(t,n,r)?n=0:n=n<0?yt(i+n,0):n||0,typeof e=="string"||!Xn(e)&&Yn(e)?n<i&&e.indexOf(t,n)>-1:gn(e,t,n)>-1):!1}function qn(e,t,n){var r=Xn(e)?Ot:qt;return t=mn(t,n,3),r(e,function(e,n,r){return!t(e,n,r)})}function Rn(e,t,n){var i=Xn(e)?Dt:tn;n&&Tn(e,t,n)&&(t=null);if(typeof t!="function"||n!==r)t=mn(t,n,3);return i(e,t)}function Un(e,t){if(typeof e!="function")throw new TypeError(s);return t=yt(t===r?e.length-1:+t||0,0),function(){var n=arguments,r=-1,i=yt(n.length-t,0),s=Array(i);while(++r<i)s[r]=n[t+r];switch(t){case 0:return e.call(this,s);case 1:return e.call(this,n[0],s);case 2:return e.call(this,n[0],n[1],s)}var o=Array(t+1);r=-1;while(++r<t)o[r]=n[r];return o[t]=s,e.apply(this,o)}}function zn(e,t,n,r){return t&&typeof t!="boolean"&&Tn(e,t,n)?t=!1:typeof t=="function"&&(r=n,n=t,t=!1),n=typeof n=="function"&&on(n,r,1),Ft(e,t,n)}function Wn(e){var t=Y(e)?e.length:r;return Cn(t)&&rt.call(e)==o}function Vn(e){if(e==null)return!0;var t=yn(e);return Cn(t)&&(Xn(e)||Yn(e)||Wn(e)||Y(e)&&$n(e.splice))?!t:!rr(e).length}function Jn(e){var t=typeof e;return t=="function"||!!e&&t=="object"}function Kn(e){return e==null?!1:rt.call(e)==c?it.test(tt.call(e)):Y(e)&&B.test(e)}function Qn(e){return typeof e=="number"||Y(e)&&rt.call(e)==p}function Yn(e){return typeof e=="string"||Y(e)&&rt.call(e)==g}function Zn(e){return Y(e)&&Cn(e.length)&&!!j[rt.call(e)]}function er(e){return Bt(e,ir(e))}function nr(e,t){if(e==null)return!1;var n=nt.call(e,t);return!n&&!Nn(t)&&(t=Mn(t),e=t.length==1?e:Wt(e,en(t,0,-1)),t=Pn(t),n=e!=null&&nt.call(e,t)),n}function ir(e){if(e==null)return[];Jn(e)||(e=Object(e));var t=e.length;t=t&&Cn(t)&&(Xn(e)||kt.nonEnumArgs&&Wn(e))&&t||0;var n=e.constructor,r=-1,i=typeof n=="function"&&n.prototype===e,s=Array(t),o=t>0;while(++r<t)s[r]=r+"";for(var u in e)(!o||!xn(u,t))&&(u!="constructor"||!i&&!!nt.call(e,u))&&s.push(u);return s}function or(e){return nn(e,rr(e))}function ur(e){return e=Q(e),e&&D.test(e)?e.replace(_,"\\$&"):e}function ar(e,t,n){return n&&Tn(e,t,n)&&(t=null),jt(e,t)}function fr(e){return function(){return e}}function lr(e){return e}function cr(e){return Nn(e)?Yt(e):Zt(e)}var r,i="3.7.0",s="Expected a function",o="[object Arguments]",u="[object Array]",a="[object Boolean]",f="[object Date]",l="[object Error]",c="[object Function]",h="[object Map]",p="[object Number]",d="[object Object]",v="[object RegExp]",m="[object Set]",g="[object String]",y="[object WeakMap]",b="[object ArrayBuffer]",w="[object Float32Array]",E="[object Float64Array]",S="[object Int8Array]",x="[object Int16Array]",T="[object Int32Array]",N="[object Uint8Array]",C="[object Uint8ClampedArray]",k="[object Uint16Array]",L="[object Uint32Array]",A=/\.|\[(?:[^[\]]+|(["'])(?:(?!\1)[^\n\\]|\\.)*?)\1\]/,O=/^\w*$/,M=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g,_=/[.*+?^${}()|[\]\/\\]/g,D=RegExp(_.source),P=/\\(\\)?/g,H=/\w*$/,B=/^\[object .+?Constructor\]$/,j={};j[w]=j[E]=j[S]=j[x]=j[T]=j[N]=j[C]=j[k]=j[L]=!0,j[o]=j[u]=j[b]=j[a]=j[f]=j[l]=j[c]=j[h]=j[p]=j[d]=j[v]=j[m]=j[g]=j[y]=!1;var F={};F[o]=F[u]=F[b]=F[a]=F[f]=F[w]=F[E]=F[S]=F[x]=F[T]=F[p]=F[d]=F[v]=F[g]=F[N]=F[C]=F[k]=F[L]=!0,F[l]=F[c]=F[h]=F[m]=F[y]=!1;var I={"function":!0,object:!0},q=I[typeof n]&&n&&!n.nodeType&&n,R=I[typeof t]&&t&&!t.nodeType&&t,U=q&&R&&typeof e=="object"&&e&&e.Object&&e,z=I[typeof self]&&self&&self.Object&&self,W=I[typeof window]&&window&&window.Object&&window,X=R&&R.exports===q&&q,V=U||W!==(this&&this.window)&&W||z||this,Z=Array.prototype,et=Object.prototype,tt=Function.prototype.toString,nt=et.hasOwnProperty,rt=et.toString,it=RegExp("^"+ur(rt).replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),st=Kn(st=V.ArrayBuffer)&&st,ot=Kn(ot=st&&(new st(0)).slice)&&ot,ut=Math.floor,at=Kn(at=Object.getOwnPropertySymbols)&&at,ft=Kn(ft=Object.getPrototypeOf)&&ft,lt=Z.push,ct=Kn(Object.preventExtensions=Object.preventExtensions)&&ct,ht=et.propertyIsEnumerable,pt=Kn(pt=V.Uint8Array)&&pt,dt=function(){try{var e=Kn(e=V.Float64Array)&&e,t=new e(new st(10),0,1)&&e}catch(n){}return t}(),vt=function(){var e={1:0},t=ct&&Kn(t=Object.assign)&&t;try{t(ct(e),"xo")}catch(n){}return!e[1]&&t}(),mt=Kn(mt=Array.isArray)&&mt,gt=Kn(gt=Object.keys)&&gt,yt=Math.max,bt=Math.min,wt=Number.NEGATIVE_INFINITY,Et=Math.pow(2,32)-1,St=Et-1,xt=Et>>>1,Tt=dt?dt.BYTES_PER_ELEMENT:0,Nt=Math.pow(2,53)-1,kt=Ct.support={};(function(e){var t=function(){this.x=e},n={0:e,length:e},r=[];t.prototype={valueOf:e,y:e};for(var i in new t)r.push(i);kt.funcDecomp=/\bthis\b/.test(function(){return this}),kt.funcNames=typeof Function.name=="string";try{kt.nonEnumArgs=!ht.call(arguments,1)}catch(s){kt.nonEnumArgs=!0}})(1,0);var Ht=vt||function(e,t){return t==null?e:Bt(t,bn(t),Bt(t,rr(t),e))},It=fn(zt),Rt=ln();ot||(un=!st||!pt?fr(null):function(e){var t=e.byteLength,n=dt?ut(t/Tt):0,r=n*Tt,i=new st(t);if(n){var s=new dt(i,0,n);s.set(new dt(e,0,n))}return t!=r&&(s=new pt(i,r),s.set(new pt(e,r))),i});var yn=Yt("length"),bn=at?function(e){return at(On(e))}:fr([]),_n=cn(!0),jn=Un(Bn),Fn=hn(At,It),Xn=mt||function(e){return Y(e)&&Cn(e.length)&&rt.call(e)==u},$n=K(/x/)||pt&&!K(pt)?function(e){return rt.call(e)==c}:K,Gn=ft?function(e){if(!e||rt.call(e)!=d)return!1;var t=e.valueOf,n=Kn(t)&&(n=ft(t))&&ft(n);return n?e==n||ft(e)==n:Ln(e)}:Ln,tr=an(function(e,t,n){return n?Pt(e,t,n):Ht(e,t)}),rr=gt?function(e){if(e)var t=e.constructor,n=e.length;return typeof t=="function"&&t.prototype===e||typeof e!="function"&&Cn(n)?An(e):Jn(e)?gt(e):[]}:An,sr=an(Qt);Ct.assign=tr,Ct.callback=ar,Ct.constant=fr,Ct.forEach=Fn,Ct.keys=rr,Ct.keysIn=ir,Ct.merge=sr,Ct.property=cr,Ct.reject=qn,Ct.restParam=Un,Ct.slice=Hn,Ct.toPlainObject=er,Ct.unzip=Bn,Ct.values=or,Ct.zip=jn,Ct.each=Fn,Ct.extend=tr,Ct.iteratee=ar,Ct.clone=zn,Ct.escapeRegExp=ur,Ct.findLastIndex=_n,Ct.has=nr,Ct.identity=lr,Ct.includes=In,Ct.indexOf=Dn,Ct.isArguments=Wn,Ct.isArray=Xn,Ct.isEmpty=Vn,Ct.isFunction=$n,Ct.isNative=Kn,Ct.isNumber=Qn,Ct.isObject=Jn,Ct.isPlainObject=Gn,Ct.isString=Yn,Ct.isTypedArray=Zn,Ct.last=Pn,Ct.some=Rn,Ct.any=Rn,Ct.contains=In,Ct.include=In,Ct.VERSION=i,q&&R?X?(R.exports=Ct)._=Ct:q._=Ct:V._=Ct}).call(this)}).call(this,typeof global!="undefined"?global:typeof self!="undefined"?self:typeof window!="undefined"?window:{})},{}],"/node_modules/jshint/src/jshint.js":[function(e,t,n){var r=e("../lodash"),i=e("events"),s=e("./vars.js"),o=e("./messages.js"),u=e("./lex.js").Lexer,a=e("./reg.js"),f=e("./state.js").state,l=e("./style.js"),c=e("./options.js"),h=e("./scope-manager.js"),p=function(){"use strict";function k(e,t){return e=e.trim(),/^[+-]W\d{3}$/g.test(e)?!0:c.validNames.indexOf(e)===-1&&t.type!=="jslint"&&!r.has(c.removed,e)?(q("E001",t,e),!1):!0}function L(e){return Object.prototype.toString.call(e)==="[object String]"}function A(e,t){return e?!e.identifier||e.value!==t?!1:!0:!1}function O(e){if(!e.reserved)return!1;var t=e.meta;if(t&&t.isFutureReservedWord&&f.inES5()){if(!t.es5)return!1;if(t.strictOnly&&!f.option.strict&&!f.isStrict())return!1;if(e.isProperty)return!1}return!0}function M(e,t){return e.replace(/\{([^{}]*)\}/g,function(e,n){var r=t[n];return typeof r=="string"||typeof r=="number"?r:e})}function D(e,t){Object.keys(t).forEach(function(n){if(r.has(p.blacklist,n))return;e[n]=t[n]})}function P(){if(f.option.enforceall){for(var e in c.bool.enforcing)f.option[e]===undefined&&!c.noenforceall[e]&&(f.option[e]=!0);for(var t in c.bool.relaxing)f.option[t]===undefined&&(f.option[t]=!1)}}function H(){P(),!f.option.esversion&&!f.option.moz&&(f.option.es3?f.option.esversion=3:f.option.esnext?f.option.esversion=6:f.option.esversion=5),f.inES5()&&D(S,s.ecmaIdentifiers[5]),f.inES6()&&D(S,s.ecmaIdentifiers[6]),f.option.module&&(f.option.strict===!0&&(f.option.strict="global"),f.inES6()||F("W134",f.tokens.next,"module",6)),f.option.couch&&D(S,s.couch),f.option.qunit&&D(S,s.qunit),f.option.rhino&&D(S,s.rhino),f.option.shelljs&&(D(S,s.shelljs),D(S,s.node)),f.option.typed&&D(S,s.typed),f.option.phantom&&(D(S,s.phantom),f.option.strict===!0&&(f.option.strict="global")),f.option.prototypejs&&D(S,s.prototypejs),f.option.node&&(D(S,s.node),D(S,s.typed),f.option.strict===!0&&(f.option.strict="global")),f.option.devel&&D(S,s.devel),f.option.dojo&&D(S,s.dojo),f.option.browser&&(D(S,s.browser),D(S,s.typed)),f.option.browserify&&(D(S,s.browser),D(S,s.typed),D(S,s.browserify),f.option.strict===!0&&(f.option.strict="global")),f.option.nonstandard&&D(S,s.nonstandard),f.option.jasmine&&D(S,s.jasmine),f.option.jquery&&D(S,s.jquery),f.option.mootools&&D(S,s.mootools),f.option.worker&&D(S,s.worker),f.option.wsh&&D(S,s.wsh),f.option.globalstrict&&f.option.strict!==!1&&(f.option.strict="global"),f.option.yui&&D(S,s.yui),f.option.mocha&&D(S,s.mocha)}function B(e,t,n){var r=Math.floor(t/f.lines.length*100),i=o.errors[e].desc;throw{name:"JSHintError",line:t,character:n,message:i+" ("+r+"% scanned).",raw:i,code:e}}function j(){var e=f.ignoredLines;if(r.isEmpty(e))return;p.errors=r.reject(p.errors,function(t){return e[t.line]})}function F(e,t,n,r,i,s){var u,a,l,c;if(/^W\d{3}$/.test(e)){if(f.ignored[e])return;c=o.warnings[e]}else/E\d{3}/.test(e)?c=o.errors[e]:/I\d{3}/.test(e)&&(c=o.info[e]);return t=t||f.tokens.next||{},t.id==="(end)"&&(t=f.tokens.curr),a=t.line||0,u=t.from||0,l={id:"(error)",raw:c.desc,code:c.code,evidence:f.lines[a-1]||"",line:a,character:u,scope:p.scope,a:n,b:r,c:i,d:s},l.reason=M(c.desc,l),p.errors.push(l),j(),p.errors.length>=f.option.maxerr&&B("E043",a,u),l}function I(e,t,n,r,i,s,o){return F(e,{line:t,from:n},r,i,s,o)}function q(e,t,n,r,i,s){F(e,t,n,r,i,s)}function R(e,t,n,r,i,s,o){return q(e,{line:t,from:n},r,i,s,o)}function U(e,t){var n;return n={id:"(internal)",elem:e,value:t},p.internals.push(n),n}function z(){var e=f.tokens.next,t=e.body.match(/(-\s+)?[^\s,:]+(?:\s*:\s*(-\s+)?[^\s,]+)?/g)||[],i={};if(e.type==="globals"){t.forEach(function(n,r){n=n.split(":");var s=(n[0]||"").trim(),o=(n[1]||"").trim();if(s==="-"||!s.length){if(r>0&&r===t.length-1)return;q("E002",e);return}s.charAt(0)==="-"?(s=s.slice(1),o=!1,p.blacklist[s]=s,delete S[s]):i[s]=o==="true"}),D(S,i);for(var s in i)r.has(i,s)&&(n[s]=e)}e.type==="exported"&&t.forEach(function(n,r){if(!n.length){if(r>0&&r===t.length-1)return;q("E002",e);return}f.funct["(scope)"].addExported(n)}),e.type==="members"&&(E=E||{},t.forEach(function(e){var t=e.charAt(0),n=e.charAt(e.length-1);t===n&&(t==='"'||t==="'")&&(e=e.substr(1,e.length-2).replace('\\"','"')),E[e]=!1}));var o=["maxstatements","maxparams","maxdepth","maxcomplexity","maxerr","maxlen","indent"];if(e.type==="jshint"||e.type==="jslint")t.forEach(function(t){t=t.split(":");var n=(t[0]||"").trim(),i=(t[1]||"").trim();if(!k(n,e))return;if(o.indexOf(n)>=0){if(i!=="false"){i=+i;if(typeof i!="number"||!isFinite(i)||i<=0||Math.floor(i)!==i){q("E032",e,t[1].trim());return}f.option[n]=i}else f.option[n]=n==="indent"?4:!1;return}if(n==="validthis"){if(f.funct["(global)"])return void q("E009");if(i!=="true"&&i!=="false")return void q("E002",e);f.option.validthis=i==="true";return}if(n==="quotmark"){switch(i){case"true":case"false":f.option.quotmark=i==="true";break;case"double":case"single":f.option.quotmark=i;break;default:q("E002",e)}return}if(n==="shadow"){switch(i){case"true":f.option.shadow=!0;break;case"outer":f.option.shadow="outer";break;case"false":case"inner":f.option.shadow="inner";break;default:q("E002",e)}return}if(n==="unused"){switch(i){case"true":f.option.unused=!0;break;case"false":f.option.unused=!1;break;case"vars":case"strict":f.option.unused=i;break;default:q("E002",e)}return}if(n==="latedef"){switch(i){case"true":f.option.latedef=!0;break;case"false":f.option.latedef=!1;break;case"nofunc":f.option.latedef="nofunc";break;default:q("E002",e)}return}if(n==="ignore"){switch(i){case"line":f.ignoredLines[e.line]=!0,j();break;default:q("E002",e)}return}if(n==="strict"){switch(i){case"true":f.option.strict=!0;break;case"false":f.option.strict=!1;break;case"func":case"global":case"implied":f.option.strict=i;break;default:q("E002",e)}return}n==="module"&&(zt(f.funct)||q("E055",f.tokens.next,"module"));var s={es3:3,es5:5,esnext:6};if(r.has(s,n)){switch(i){case"true":f.option.moz=!1,f.option.esversion=s[n];break;case"false":f.option.moz||(f.option.esversion=5);break;default:q("E002",e)}return}if(n==="esversion"){switch(i){case"5":f.inES5(!0)&&F("I003");case"3":case"6":f.option.moz=!1,f.option.esversion=+i;break;case"2015":f.option.moz=!1,f.option.esversion=6;break;default:q("E002",e)}zt(f.funct)||q("E055",f.tokens.next,"esversion");return}var u=/^([+-])(W\d{3})$/g.exec(n);if(u){f.ignored[u[2]]=u[1]==="-";return}var a;if(i==="true"||i==="false"){e.type==="jslint"?(a=c.renamed[n]||n,f.option[a]=i==="true",c.inverted[a]!==undefined&&(f.option[a]=!f.option[a])):f.option[n]=i==="true",n==="newcap"&&(f.option["(explicitNewcap)"]=!0);return}q("E002",e)}),H()}function W(e){var t=e||0,n=y.length,r;if(t<n)return y[t];while(n<=t)r=y[n],r||(r=y[n]=b.token()),n+=1;return!r&&f.tokens.next.id==="(end)"?f.tokens.next:r}function X(){var e=0,t;do t=W(e++);while(t.id==="(endline)");return t}function V(e,t){switch(f.tokens.curr.id){case"(number)":f.tokens.next.id==="."&&F("W005",f.tokens.curr);break;case"-":(f.tokens.next.id==="-"||f.tokens.next.id==="--")&&F("W006");break;case"+":(f.tokens.next.id==="+"||f.tokens.next.id==="++")&&F("W007")}e&&f.tokens.next.id!==e&&(t?f.tokens.next.id==="(end)"?q("E019",t,t.id):q("E020",f.tokens.next,e,t.id,t.line,f.tokens.next.value):(f.tokens.next.type!=="(identifier)"||f.tokens.next.value!==e)&&F("W116",f.tokens.next,e,f.tokens.next.value)),f.tokens.prev=f.tokens.curr,f.tokens.curr=f.tokens.next;for(;;){f.tokens.next=y.shift()||b.token(),f.tokens.next||B("E041",f.tokens.curr.line);if(f.tokens.next.id==="(end)"||f.tokens.next.id==="(error)")return;f.tokens.next.check&&f.tokens.next.check();if(f.tokens.next.isSpecial)f.tokens.next.type==="falls through"?f.tokens.curr.caseFallsThrough=!0:z();else if(f.tokens.next.id!=="(endline)")break}}function $(e){return e.infix||!e.identifier&&!e.template&&!!e.led}function J(){var e=f.tokens.curr,t=f.tokens.next;return t.id===";"||t.id==="}"||t.id===":"?!0:$(t)===$(e)||e.id==="yield"&&f.inMoz()?e.line!==G(t):!1}function K(e){return!e.left&&e.arity!=="unary"}function Q(e,t){var n,i=!1,s=!1,o=!1;f.nameStack.push(),!t&&f.tokens.next.value==="let"&&W(0).value==="("&&(f.inMoz()||F("W118",f.tokens.next,"let expressions"),o=!0,f.funct["(scope)"].stack(),V("let"),V("("),f.tokens.prev.fud(),V(")")),f.tokens.next.id==="(end)"&&q("E006",f.tokens.curr);var u=f.option.asi&&f.tokens.prev.line!==G(f.tokens.curr)&&r.contains(["]",")"],f.tokens.prev.id)&&r.contains(["[","("],f.tokens.curr.id);u&&F("W014",f.tokens.curr,f.tokens.curr.id),V(),t&&(f.funct["(verb)"]=f.tokens.curr.value,f.tokens.curr.beginsStmt=!0);if(t===!0&&f.tokens.curr.fud)n=f.tokens.curr.fud();else{f.tokens.curr.nud?n=f.tokens.curr.nud():q("E030",f.tokens.curr,f.tokens.curr.id);while((e<f.tokens.next.lbp||f.tokens.next.type==="(template)")&&!J())i=f.tokens.curr.value==="Array",s=f.tokens.curr.value==="Object",n&&(n.value||n.first&&n.first.value)&&(n.value!=="new"||n.first&&n.first.value&&n.first.value===".")&&(i=!1,n.value!==f.tokens.curr.value&&(s=!1)),V(),i&&f.tokens.curr.id==="("&&f.tokens.next.id===")"&&F("W009",f.tokens.curr),s&&f.tokens.curr.id==="("&&f.tokens.next.id===")"&&F("W010",f.tokens.curr),n&&f.tokens.curr.led?n=f.tokens.curr.led(n):q("E033",f.tokens.curr,f.tokens.curr.id)}return o&&f.funct["(scope)"].unstack(),f.nameStack.pop(),n}function G(e){return e.startLine||e.line}function Y(e,t){e=e||f.tokens.curr,t=t||f.tokens.next,!f.option.laxbreak&&e.line!==G(t)&&F("W014",t,t.value)}function Z(e){e=e||f.tokens.curr,e.line!==G(f.tokens.next)&&F("E022",e,e.value)}function et(e,t){e.line!==G(t)&&(f.option.laxcomma||(tt.first&&(F("I001"),tt.first=!1),F("W014",e,t.value)))}function tt(e){e=e||{},e.peek?et(f.tokens.prev,f.tokens.curr):(et(f.tokens.curr,f.tokens.next),V(","));if(f.tokens.next.identifier&&(!e.property||!f.inES5()))switch(f.tokens.next.value){case"break":case"case":case"catch":case"continue":case"default":case"do":case"else":case"finally":case"for":case"if":case"in":case"instanceof":case"return":case"switch":case"throw":case"try":case"var":case"let":case"while":case"with":return q("E024",f.tokens.next,f.tokens.next.value),!1}if(f.tokens.next.type==="(punctuator)")switch(f.tokens.next.value){case"}":case"]":case",":if(e.allowTrailing)return!0;case")":return q("E024",f.tokens.next,f.tokens.next.value),!1}return!0}function nt(e,t){var n=f.syntax[e];if(!n||typeof n!="object")f.syntax[e]=n={id:e,lbp:t,value:e};return n}function rt(e){var t=nt(e,0);return t.delim=!0,t}function it(e,t){var n=rt(e);return n.identifier=n.reserved=!0,n.fud=t,n}function st(e,t){var n=it(e,t);return n.block=!0,n}function ot(e){var t=e.id.charAt(0);if(t>="a"&&t<="z"||t>="A"&&t<="Z")e.identifier=e.reserved=!0;return e}function ut(e,t){var n=nt(e,150);return ot(n),n.nud=typeof t=="function"?t:function(){this.arity="unary",this.right=Q(150);if(this.id==="++"||this.id==="--")f.option.plusplus?F("W016",this,this.id):this.right&&(!this.right.identifier||O(this.right))&&this.right.id!=="."&&this.right.id!=="["&&F("W017",this),this.right&&this.right.isMetaProperty?q("E031",this):this.right&&this.right.identifier&&f.funct["(scope)"].block.modify(this.right.value,this);return this},n}function at(e,t){var n=rt(e);return n.type=e,n.nud=t,n}function ft(e,t){var n=at(e,t);return n.identifier=!0,n.reserved=!0,n}function lt(e,t){var n=at(e,t&&t.nud||function(){return this});return t=t||{},t.isFutureReservedWord=!0,n.value=e,n.identifier=!0,n.reserved=!0,n.meta=t,n}function ct(e,t){return ft(e,function(){return typeof t=="function"&&t(this),this})}function ht(e,t,n,r){var i=nt(e,n);return ot(i),i.infix=!0,i.led=function(i){return r||Y(f.tokens.prev,f.tokens.curr),(e==="in"||e==="instanceof")&&i.id==="!"&&F("W018",i,"!"),typeof t=="function"?t(i,this):(this.left=i,this.right=Q(n),this)},i}function pt(e){var t=nt(e,42);return t.led=function(e){return Y(f.tokens.prev,f.tokens.curr),this.left=e,this.right=Xt({type:"arrow",loneArg:e}),this},t}function dt(e,t){var n=nt(e,100);return n.led=function(e){Y(f.tokens.prev,f.tokens.curr),this.left=e;var n=this.right=Q(100);return A(e,"NaN")||A(n,"NaN")?F("W019",this):t&&t.apply(this,[e,n]),(!e||!n)&&B("E041",f.tokens.curr.line),e.id==="!"&&F("W018",e,"!"),n.id==="!"&&F("W018",n,"!"),this},n}function vt(e){return e&&(e.type==="(number)"&&+e.value===0||e.type==="(string)"&&e.value===""||e.type==="null"&&!f.option.eqnull||e.type==="true"||e.type==="false"||e.type==="undefined")}function gt(e,t,n){var i;return n.option.notypeof?!1:!e||!t?!1:(i=n.inES6()?mt.es6:mt.es3,t.type==="(identifier)"&&t.value==="typeof"&&e.type==="(string)"?!r.contains(i,e.value):!1)}function yt(e,t){var n=!1;return e.type==="this"&&t.funct["(context)"]===null?n=!0:e.type==="(identifier)"&&(t.option.node&&e.value==="global"?n=!0:t.option.browser&&(e.value==="window"||e.value==="document")&&(n=!0)),n}function bt(e){function n(e){if(typeof e!="object")return;return e.right==="prototype"?e:n(e.left)}function r(e){while(!e.identifier&&typeof e.left=="object")e=e.left;if(e.identifier&&t.indexOf(e.value)>=0)return e.value}var t=["Array","ArrayBuffer","Boolean","Collator","DataView","Date","DateTimeFormat","Error","EvalError","Float32Array","Float64Array","Function","Infinity","Intl","Int16Array","Int32Array","Int8Array","Iterator","Number","NumberFormat","Object","RangeError","ReferenceError","RegExp","StopIteration","String","SyntaxError","TypeError","Uint16Array","Uint32Array","Uint8Array","Uint8ClampedArray","URIError"],i=n(e);if(i)return r(i)}function wt(e,t,n){var r=n&&n.allowDestructuring;t=t||e;if(f.option.freeze){var i=bt(e);i&&F("W121",e,i)}return e.identifier&&!e.isMetaProperty&&f.funct["(scope)"].block.reassign(e.value,e),e.id==="."?((!e.left||e.left.value==="arguments"&&!f.isStrict())&&F("E031",t),f.nameStack.set(f.tokens.prev),!0):e.id==="{"||e.id==="["?(r&&f.tokens.curr.left.destructAssign?f.tokens.curr.left.destructAssign.forEach(function(e){e.id&&f.funct["(scope)"].block.modify(e.id,e.token)}):e.id==="{"||!e.left?F("E031",t):e.left.value==="arguments"&&!f.isStrict()&&F("E031",t),e.id==="["&&f.nameStack.set(e.right),!0):e.isMetaProperty?(q("E031",t),!0):e.identifier&&!O(e)?(f.funct["(scope)"].labeltype(e.value)==="exception"&&F("W022",e),f.nameStack.set(e),!0):(e===f.syntax["function"]&&F("W023",f.tokens.curr),!1)}function Et(e,t,n){var r=ht(e,typeof t=="function"?t:function(e,t){t.left=e;if(e&&wt(e,t,{allowDestructuring:!0}))return t.right=Q(10),t;q("E031",t)},n);return r.exps=!0,r.assign=!0,r}function St(e,t,n){var r=nt(e,n);return ot(r),r.led=typeof t=="function"?t:function(e){return f.option.bitwise&&F("W016",this,this.id),this.left=e,this.right=Q(n),this},r}function xt(e){return Et(e,function(e,t){f.option.bitwise&&F("W016",t,t.id);if(e&&wt(e,t))return t.right=Q(10),t;q("E031",t)},20)}function Tt(e){var t=nt(e,150);return t.led=function(e){return f.option.plusplus?F("W016",this,this.id):(!e.identifier||O(e))&&e.id!=="."&&e.id!=="["&&F("W017",this),e.isMetaProperty?q("E031",this):e&&e.identifier&&f.funct["(scope)"].block.modify(e.value,e),this.left=e,this},t}function Nt(e,t,n){if(!f.tokens.next.identifier)return;n||V();var r=f.tokens.curr,i=f.tokens.curr.value;return O(r)?t&&f.inES5()?i:e&&i==="undefined"?i:(F("W024",f.tokens.curr,f.tokens.curr.id),i):i}function Ct(e,t){var n=Nt(e,t,!1);if(n)return n;if(f.tokens.next.value==="..."){f.inES6(!0)||F("W119",f.tokens.next,"spread/rest operator","6"),V();if(pn(f.tokens.next,"...")){F("E024",f.tokens.next,"...");while(pn(f.tokens.next,"..."))V()}if(!f.tokens.next.identifier){F("E024",f.tokens.curr,"...");return}return Ct(e,t)}q("E030",f.tokens.next,f.tokens.next.value),f.tokens.next.id!==";"&&V()}function kt(e){var t=0,n;if(f.tokens.next.id!==";"||e.inBracelessBlock)return;for(;;){do n=W(t),t+=1;while(n.id!=="(end)"&&n.id==="(comment)");if(n.reach)return;if(n.id!=="(endline)"){if(n.id==="function"){f.option.latedef===!0&&F("W026",n);break}F("W027",n,n.value,e.value);break}}}function Lt(){if(f.tokens.next.id!==";"){if(f.tokens.next.isUnclosed)return V();var e=G(f.tokens.next)===f.tokens.curr.line&&f.tokens.next.id!=="(end)",t=pn(f.tokens.next,"}");e&&!t?R("E058",f.tokens.curr.line,f.tokens.curr.character):f.option.asi||(t&&!f.option.lastsemic||!e)&&I("W033",f.tokens.curr.line,f.tokens.curr.character)}else V(";")}function At(){var e=g,t,n=f.tokens.next,r=!1;if(n.id===";"){V(";");return}var i=O(n);i&&n.meta&&n.meta.isFutureReservedWord&&W().id===":"&&(F("W024",n,n.id),i=!1),n.identifier&&!i&&W().id===":"&&(V(),V(":"),r=!0,f.funct["(scope)"].stack(),f.funct["(scope)"].block.addBreakLabel(n.value,{token:f.tokens.curr}),!f.tokens.next.labelled&&f.tokens.next.value!=="{"&&F("W028",f.tokens.next,n.value,f.tokens.next.value),f.tokens.next.label=n.value,n=f.tokens.next);if(n.id==="{"){var s=f.funct["(verb)"]==="case"&&f.tokens.curr.value===":";_t(!0,!0,!1,!1,s);return}return t=Q(0,!0),t&&(!t.identifier||t.value!=="function")&&(t.type!=="(punctuator)"||!t.left||!t.left.identifier||t.left.value!=="function")&&!f.isStrict()&&f.option.strict==="global"&&F("E007"),n.block||(!f.option.expr&&(!t||!t.exps)?F("W030",f.tokens.curr):f.option.nonew&&t&&t.left&&t.id==="("&&t.left.id==="new"&&F("W031",n),Lt()),g=e,r&&f.funct["(scope)"].unstack(),t}function Ot(){var e=[],t;while(!f.tokens.next.reach&&f.tokens.next.id!=="(end)")f.tokens.next.id===";"?(t=W(),(!t||t.id!=="("&&t.id!=="[")&&F("W032"),V(";")):e.push(At());return e}function Mt(){var e,t,n;while(f.tokens.next.id==="(string)"){t=W(0);if(t.id==="(endline)"){e=1;do n=W(e++);while(n.id==="(endline)");if(n.id===";")t=n;else{if(n.value==="["||n.value===".")break;(!f.option.asi||n.value==="(")&&F("W033",f.tokens.next)}}else{if(t.id==="."||t.id==="[")break;t.id!==";"&&F("W033",t)}V();var r=f.tokens.curr.value;(f.directive[r]||r==="use strict"&&f.option.strict==="implied")&&F("W034",f.tokens.curr,r),f.directive[r]=!0,t.id===";"&&V(";")}f.isStrict()&&(f.option["(explicitNewcap)"]||(f.option.newcap=!0),f.option.undef=!0)}function _t(e,t,n,i,s){var o,u=m,a=g,l,c,h,p;m=e,c=f.tokens.next;var d=f.funct["(metrics)"];d.nestedBlockDepth+=1,d.verifyMaxNestedBlockDepthPerFunction();if(f.tokens.next.id==="{"){V("{"),f.funct["(scope)"].stack(),h=f.tokens.curr.line;if(f.tokens.next.id!=="}"){g+=f.option.indent;while(!e&&f.tokens.next.from>g)g+=f.option.indent;if(n){l={};for(p in f.directive)r.has(f.directive,p)&&(l[p]=f.directive[p]);Mt(),f.option.strict&&f.funct["(context)"]["(global)"]&&!l["use strict"]&&!f.isStrict()&&F("E007")}o=Ot(),d.statementCount+=o.length,g-=f.option.indent}V("}",c),n&&(f.funct["(scope)"].validateParams(),l&&(f.directive=l)),f.funct["(scope)"].unstack(),g=a}else if(!e)if(n){f.funct["(scope)"].stack(),l={},t&&!i&&!f.inMoz()&&q("W118",f.tokens.curr,"function closure expressions");if(!t)for(p in f.directive)r.has(f.directive,p)&&(l[p]=f.directive[p]);Q(10),f.option.strict&&f.funct["(context)"]["(global)"]&&!l["use strict"]&&!f.isStrict()&&F("E007"),f.funct["(scope)"].unstack()}else q("E021",f.tokens.next,"{",f.tokens.next.value);else f.funct["(noblockscopedvar)"]=f.tokens.next.id!=="for",f.funct["(scope)"].stack(),(!t||f.option.curly)&&F("W116",f.tokens.next,"{",f.tokens.next.value),f.tokens.next.inBracelessBlock=!0,g+=f.option.indent,o=[At()],g-=f.option.indent,f.funct["(scope)"].unstack(),delete f.funct["(noblockscopedvar)"];switch(f.funct["(verb)"]){case"break":case"continue":case"return":case"throw":if(s)break;default:f.funct["(verb)"]=null}return m=u,e&&f.option.noempty&&(!o||o.length===0)&&F("W035",f.tokens.prev),d.nestedBlockDepth-=1,o}function Dt(e){E&&typeof E[e]!="boolean"&&F("W036",f.tokens.curr,e),typeof w[e]=="number"?w[e]+=1:w[e]=1}function Bt(){var e={};e.exps=!0,f.funct["(comparray)"].stack();var t=!1;return f.tokens.next.value!=="for"&&(t=!0,f.inMoz()||F("W116",f.tokens.next,"for",f.tokens.next.value),f.funct["(comparray)"].setState("use"),e.right=Q(10)),V("for"),f.tokens.next.value==="each"&&(V("each"),f.inMoz()||F("W118",f.tokens.curr,"for each")),V("("),f.funct["(comparray)"].setState("define"),e.left=Q(130),r.contains(["in","of"],f.tokens.next.value)?V():q("E045",f.tokens.curr),f.funct["(comparray)"].setState("generate"),Q(10),V(")"),f.tokens.next.value==="if"&&(V("if"),V("("),f.funct["(comparray)"].setState("filter"),e.filter=Q(10),V(")")),t||(f.funct["(comparray)"].setState("use"),e.right=Q(10)),V("]"),f.funct["(comparray)"].unstack(),e}function jt(){return f.funct["(statement)"]&&f.funct["(statement)"].type==="class"||f.funct["(context)"]&&f.funct["(context)"]["(verb)"]==="class"}function Ft(e){return e.identifier||e.id==="(string)"||e.id==="(number)"}function It(e){var t,n=!0;return typeof e=="object"?t=e:(n=e,t=Nt(!1,!0,n)),t?typeof t=="object"&&(t.id==="(string)"||t.id==="(identifier)"?t=t.value:t.id==="(number)"&&(t=t.value.toString())):f.tokens.next.id==="(string)"?(t=f.tokens.next.value,n||V()):f.tokens.next.id==="(number)"&&(t=f.tokens.next.value.toString(),n||V()),t==="hasOwnProperty"&&F("W001"),t}function qt(e){function h(e){f.funct["(scope)"].addParam.apply(f.funct["(scope)"],e)}var t,n=[],i,s=[],o,u=!1,a=!1,l=0,c=e&&e.loneArg;if(c&&c.identifier===!0)return f.funct["(scope)"].addParam(c.value,c),{arity:1,params:[c.value]};t=f.tokens.next,(!e||!e.parsedOpening)&&V("(");if(f.tokens.next.id===")"){V(")");return}for(;;){l++;var p=[];if(r.contains(["{","["],f.tokens.next.id)){s=Gt();for(o in s)o=s[o],o.id&&(n.push(o.id),p.push([o.id,o.token]))}else{pn(f.tokens.next,"...")&&(a=!0),i=Ct(!0);if(i)n.push(i),p.push([i,f.tokens.curr]);else while(!hn(f.tokens.next,[",",")"]))V()}u&&f.tokens.next.id!=="="&&q("W138",f.tokens.current),f.tokens.next.id==="="&&(f.inES6()||F("W119",f.tokens.next,"default parameters","6"),V("="),u=!0,Q(10)),p.forEach(h);if(f.tokens.next.id!==",")return V(")",t),{arity:l,params:n};a&&F("W131",f.tokens.next),tt()}}function Rt(e,t,n){var i={"(name)":e,"(breakage)":0,"(loopage)":0,"(tokens)":{},"(properties)":{},"(catch)":!1,"(global)":!1,"(line)":null,"(character)":null,"(metrics)":null,"(statement)":null,"(context)":null,"(scope)":null,"(comparray)":null,"(generator)":null,"(arrow)":null,"(params)":null};return t&&r.extend(i,{"(line)":t.line,"(character)":t.character,"(metrics)":Vt(t)}),r.extend(i,n),i["(context)"]&&(i["(scope)"]=i["(context)"]["(scope)"],i["(comparray)"]=i["(context)"]["(comparray)"]),i}function Ut(e){return"(scope)"in e}function zt(e){return e["(global)"]&&!e["(verb)"]}function Wt(e){function i(){if(f.tokens.curr.template&&f.tokens.curr.tail&&f.tokens.curr.context===t)return!0;var e=f.tokens.next.template&&f.tokens.next.tail&&f.tokens.next.context===t;return e&&V(),e||f.tokens.next.isUnclosed}var t=this.context,n=this.noSubst,r=this.depth;if(!n)while(!i())!f.tokens.next.template||f.tokens.next.depth>r?Q(0):V();return{id:"(template)",type:"(template)",tag:e}}function Xt(e){var t,n,r,i,s,o,u,a,l=f.option,c=f.ignored;e&&(r=e.name,i=e.statement,s=e.classExprBinding,o=e.type==="generator",u=e.type==="arrow",a=e.ignoreLoopFunc),f.option=Object.create(f.option),f.ignored=Object.create(f.ignored),f.funct=Rt(r||f.nameStack.infer(),f.tokens.next,{"(statement)":i,"(context)":f.funct,"(arrow)":u,"(generator)":o}),t=f.funct,n=f.tokens.curr,n.funct=f.funct,v.push(f.funct),f.funct["(scope)"].stack("functionouter");var h=r||s;h&&f.funct["(scope)"].block.add(h,s?"class":"function",f.tokens.curr,!1),f.funct["(scope)"].stack("functionparams");var p=qt(e);return p?(f.funct["(params)"]=p.params,f.funct["(metrics)"].arity=p.arity,f.funct["(metrics)"].verifyMaxParametersPerFunction()):f.funct["(metrics)"].arity=0,u&&(f.inES6(!0)||F("W119",f.tokens.curr,"arrow function syntax (=>)","6"),e.loneArg||V("=>")),_t(!1,!0,!0,u),!f.option.noyield&&o&&f.funct["(generator)"]!=="yielded"&&F("W124",f.tokens.curr),f.funct["(metrics)"].verifyMaxStatementsPerFunction(),f.funct["(metrics)"].verifyMaxComplexityPerFunction(),f.funct["(unusedOption)"]=f.option.unused,f.option=l,f.ignored=c,f.funct["(last)"]=f.tokens.curr.line,f.funct["(lastcharacter)"]=f.tokens.curr.character,f.funct["(scope)"].unstack(),f.funct["(scope)"].unstack(),f.funct=f.funct["(context)"],!a&&!f.option.loopfunc&&f.funct["(loopage)"]&&t["(isCapturing)"]&&F("W083",n),t}function Vt(e){return{statementCount:0,nestedBlockDepth:-1,ComplexityCount:1,arity:0,verifyMaxStatementsPerFunction:function(){f.option.maxstatements&&this.statementCount>f.option.maxstatements&&F("W071",e,this.statementCount)},verifyMaxParametersPerFunction:function(){r.isNumber(f.option.maxparams)&&this.arity>f.option.maxparams&&F("W072",e,this.arity)},verifyMaxNestedBlockDepthPerFunction:function(){f.option.maxdepth&&this.nestedBlockDepth>0&&this.nestedBlockDepth===f.option.maxdepth+1&&F("W073",null,this.nestedBlockDepth)},verifyMaxComplexityPerFunction:function(){var t=f.option.maxcomplexity,n=this.ComplexityCount;t&&n>t&&F("W074",e,n)}}}function $t(){f.funct["(metrics)"].ComplexityCount+=1}function Jt(e){var t,n;e&&(t=e.id,n=e.paren,t===","&&(e=e.exprs[e.exprs.length-1])&&(t=e.id,n=n||e.paren));switch(t){case"=":case"+=":case"-=":case"*=":case"%=":case"&=":case"|=":case"^=":case"/=":!n&&!f.option.boss&&F("W084")}}function Kt(e){if(f.inES5())for(var t in e)e[t]&&e[t].setterToken&&!e[t].getterToken&&F("W078",e[t].setterToken)}function Qt(e,t){if(pn(f.tokens.next,".")){var n=f.tokens.curr.id;V(".");var r=Ct();return f.tokens.curr.isMetaProperty=!0,e!==r?q("E057",f.tokens.prev,n,r):t(),f.tokens.curr}}function Gt(e){var t=e&&e.assignment;return f.inES6()||F("W104",f.tokens.curr,t?"destructuring assignment":"destructuring binding","6"),Yt(e)}function Yt(e){var t,n=[],r=e&&e.openingParsed,i=e&&e.assignment,s=i?{assignment:i}:null,o=r?f.tokens.curr:f.tokens.next,u=function(){var e;if(hn(f.tokens.next,["[","{"])){t=Yt(s);for(var r in t)r=t[r],n.push({id:r.id,token:r.token})}else if(pn(f.tokens.next,","))n.push({id:null,token:f.tokens.curr});else{if(!pn(f.tokens.next,"(")){var o=pn(f.tokens.next,"...");if(i){var a=o?W(0):f.tokens.next;a.identifier||F("E030",a,a.value);var l=Q(155);l&&(wt(l),l.identifier&&(e=l.value))}else e=Ct();return e&&n.push({id:e,token:f.tokens.curr}),o}V("("),u(),V(")")}return!1},a=function(){var e;pn(f.tokens.next,"[")?(V("["),Q(10),V("]"),V(":"),u()):f.tokens.next.id==="(string)"||f.tokens.next.id==="(number)"?(V(),V(":"),u()):(e=Ct(),pn(f.tokens.next,":")?(V(":"),u()):e&&(i&&wt(f.tokens.curr),n.push({id:e,token:f.tokens.curr})))};if(pn(o,"[")){r||V("["),pn(f.tokens.next,"]")&&F("W137",f.tokens.curr);var l=!1;while(!pn(f.tokens.next,"]"))u()&&!l&&pn(f.tokens.next,",")&&(F("W130",f.tokens.next),l=!0),pn(f.tokens.next,"=")&&(pn(f.tokens.prev,"...")?V("]"):V("="),f.tokens.next.id==="undefined"&&F("W080",f.tokens.prev,f.tokens.prev.value),Q(10)),pn(f.tokens.next,"]")||V(",");V("]")}else if(pn(o,"{")){r||V("{"),pn(f.tokens.next,"}")&&F("W137",f.tokens.curr);while(!pn(f.tokens.next,"}")){a(),pn(f.tokens.next,"=")&&(V("="),f.tokens.next.id==="undefined"&&F("W080",f.tokens.prev,f.tokens.prev.value),Q(10));if(!pn(f.tokens.next,"}")){V(",");if(pn(f.tokens.next,"}"))break}}V("}")}return n}function Zt(e,t){var n=t.first;if(!n)return;r.zip(e,Array.isArray(n)?n:[n]).forEach(function(e){var t=e[0],n=e[1];t&&n?t.first=n:t&&t.first&&!n&&F("W080",t.first,t.first.value)})}function en(e,t,n){var i=n&&n.prefix,s=n&&n.inexport,o=e==="let",u=e==="const",a,l,c,h;f.inES6()||F("W104",f.tokens.curr,e,"6"),o&&f.tokens.next.value==="("?(f.inMoz()||F("W118",f.tokens.next,"let block"),V("("),f.funct["(scope)"].stack(),h=!0):f.funct["(noblockscopedvar)"]&&q("E048",f.tokens.curr,u?"Const":"Let"),t.first=[];for(;;){var p=[];r.contains(["{","["],f.tokens.next.value)?(a=Gt(),l=!1):(a=[{id:Ct(),token:f.tokens.curr}],l=!0),!i&&u&&f.tokens.next.id!=="="&&F("E012",f.tokens.curr,f.tokens.curr.value);for(var d in a)a.hasOwnProperty(d)&&(d=a[d],f.funct["(scope)"].block.isGlobal()&&S[d.id]===!1&&F("W079",d.token,d.id),d.id&&!f.funct["(noblockscopedvar)"]&&(f.funct["(scope)"].addlabel(d.id,{type:e,token:d.token}),p.push(d.token),l&&s&&f.funct["(scope)"].setExported(d.token.value,d.token)));f.tokens.next.id==="="&&(V("="),!i&&f.tokens.next.id==="undefined"&&F("W080",f.tokens.prev,f.tokens.prev.value),!i&&W(0).id==="="&&f.tokens.next.identifier&&F("W120",f.tokens.next,f.tokens.next.value),c=Q(i?120:10),l?a[0].first=c:Zt(p,c)),t.first=t.first.concat(p);if(f.tokens.next.id!==",")break;tt()}return h&&(V(")"),_t(!0,!0),t.block=!0,f.funct["(scope)"].unstack()),t}function sn(e){return f.inES6()||F("W104",f.tokens.curr,"class","6"),e?(this.name=Ct(),f.funct["(scope)"].addlabel(this.name,{type:"class",token:f.tokens.curr})):f.tokens.next.identifier&&f.tokens.next.value!=="extends"?(this.name=Ct(),this.namedExpr=!0):this.name=f.nameStack.infer(),on(this),this}function on(e){var t=f.inClassBody;f.tokens.next.value==="extends"&&(V("extends"),e.heritage=Q(10)),f.inClassBody=!0,V("{"),e.body=un(e),V("}"),f.inClassBody=t}function un(e){var t,n,r,i,s=Object.create(null),o=Object.create(null),u;for(var a=0;f.tokens.next.id!=="}";++a){t=f.tokens.next,n=!1,r=!1,i=null;if(t.id===";"){F("W032"),V(";");continue}t.id==="*"&&(r=!0,V("*"),t=f.tokens.next);if(t.id==="[")t=cn(),u=!0;else{if(!Ft(t)){F("W052",f.tokens.next,f.tokens.next.value||f.tokens.next.type),V();continue}V(),u=!1;if(t.identifier&&t.value==="static"){pn(f.tokens.next,"*")&&(r=!0,V("*"));if(Ft(f.tokens.next)||f.tokens.next.id==="[")u=f.tokens.next.id==="[",n=!0,t=f.tokens.next,f.tokens.next.id==="["?t=cn():V()}t.identifier&&(t.value==="get"||t.value==="set")&&(Ft(f.tokens.next)||f.tokens.next.id==="[")&&(u=f.tokens.next.id==="[",i=t,t=f.tokens.next,f.tokens.next.id==="["?t=cn():V())}if(!pn(f.tokens.next,"(")){q("E054",f.tokens.next,f.tokens.next.value);while(f.tokens.next.id!=="}"&&!pn(f.tokens.next,"("))V();f.tokens.next.value!=="("&&Xt({statement:e})}u||(i?ln(i.value,n?o:s,t.value,t,!0,n):(t.value==="constructor"?f.nameStack.set(e):f.nameStack.set(t),fn(n?o:s,t.value,t,!0,n)));if(i&&t.value==="constructor"){var l=i.value==="get"?"class getter method":"class setter method";q("E049",t,l,"constructor")}else t.value==="prototype"&&q("E049",t,"class method","prototype");It(t),Xt({statement:e,type:r?"generator":null,classExprBinding:e.namedExpr?e.name:null})}Kt(s)}function fn(e,t,n,r,i){var s=["key","class method","static class method"];s=s[(r||!1)+(i||!1)],n.identifier&&(t=n.value),e[t]&&t!=="__proto__"?F("W075",f.tokens.next,s,t):e[t]=Object.create(null),e[t].basic=!0,e[t].basictkn=n}function ln(e,t,n,r,i,s){var o=e==="get"?"getterToken":"setterToken",u="";i?(s&&(u+="static "),u+=e+"ter method"):u="key",f.tokens.curr.accessorType=e,f.nameStack.set(r),t[n]?(t[n].basic||t[n][o])&&n!=="__proto__"&&F("W075",f.tokens.next,u,n):t[n]=Object.create(null),t[n][o]=r}function cn(){V("["),f.inES6()||F("W119",f.tokens.curr,"computed property names","6");var e=Q(10);return V("]"),e}function hn(e,t){return e.type==="(punctuator)"?r.contains(t,e.value):!1}function pn(e,t){return e.type==="(punctuator)"&&e.value===t}function dn(){var e=an();e.notJson?(!f.inES6()&&e.isDestAssign&&F("W104",f.tokens.curr,"destructuring assignment","6"),Ot()):(f.option.laxbreak=!0,f.jsonMode=!0,mn())}function mn(){function e(){var e={},t=f.tokens.next;V("{");if(f.tokens.next.id!=="}")for(;;){if(f.tokens.next.id==="(end)")q("E026",f.tokens.next,t.line);else{if(f.tokens.next.id==="}"){F("W094",f.tokens.curr);break}f.tokens.next.id===","?q("E028",f.tokens.next):f.tokens.next.id!=="(string)"&&F("W095",f.tokens.next,f.tokens.next.value)}e[f.tokens.next.value]===!0?F("W075",f.tokens.next,"key",f.tokens.next.value):f.tokens.next.value==="__proto__"&&!f.option.proto||f.tokens.next.value==="__iterator__"&&!f.option.iterator?F("W096",f.tokens.next,f.tokens.next.value):e[f.tokens.next.value]=!0,V(),V(":"),mn();if(f.tokens.next.id!==",")break;V(",")}V("}")}function t(){var e=f.tokens.next;V("[");if(f.tokens.next.id!=="]")for(;;){if(f.tokens.next.id==="(end)")q("E027",f.tokens.next,e.line);else{if(f.tokens.next.id==="]"){F("W094",f.tokens.curr);break}f.tokens.next.id===","&&q("E028",f.tokens.next)}mn();if(f.tokens.next.id!==",")break;V(",")}V("]")}switch(f.tokens.next.id){case"{":e();break;case"[":t();break;case"true":case"false":case"null":case"(number)":case"(string)":V();break;case"-":V("-"),V("(number)");break;default:q("E003",f.tokens.next)}}var e,t={"<":!0,"<=":!0,"==":!0,"===":!0,"!==":!0,"!=":!0,">":!0,">=":!0,"+":!0,"-":!0,"*":!0,"/":!0,"%":!0},n,d=["closure","exception","global","label","outer","unused","var"],v,m,g,y,b,w,E,S,x,T,N=[],C=new i.EventEmitter,mt={};mt.legacy=["xml","unknown"],mt.es3=["undefined","boolean","number","string","function","object"],mt.es3=mt.es3.concat(mt.legacy),mt.es6=mt.es3.concat("symbol"),at("(number)",function(){return this}),at("(string)",function(){return this}),f.syntax["(identifier)"]={type:"(identifier)",lbp:0,identifier:!0,nud:function(){var e=this.value;return f.tokens.next.id==="=>"?this:(f.funct["(comparray)"].check(e)||f.funct["(scope)"].block.use(e,f.tokens.curr),this)},led:function(){q("E033",f.tokens.next,f.tokens.next.value)}};var Pt={lbp:0,identifier:!1,template:!0};f.syntax["(template)"]=r.extend({type:"(template)",nud:Wt,led:Wt,noSubst:!1},Pt),f.syntax["(template middle)"]=r.extend({type:"(template middle)",middle:!0,noSubst:!1},Pt),f.syntax["(template tail)"]=r.extend({type:"(template tail)",tail:!0,noSubst:!1},Pt),f.syntax["(no subst template)"]=r.extend({type:"(template)",nud:Wt,led:Wt,noSubst:!0,tail:!0},Pt),at("(regexp)",function(){return this}),rt("(endline)"),rt("(begin)"),rt("(end)").reach=!0,rt("(error)").reach=!0,rt("}").reach=!0,rt(")"),rt("]"),rt('"').reach=!0,rt("'").reach=!0,rt(";"),rt(":").reach=!0,rt("#"),ft("else"),ft("case").reach=!0,ft("catch"),ft("default").reach=!0,ft("finally"),ct("arguments",function(e){f.isStrict()&&f.funct["(global)"]&&F("E008",e)}),ct("eval"),ct("false"),ct("Infinity"),ct("null"),ct("this",function(e){f.isStrict()&&!jt()&&!f.option.validthis&&(f.funct["(statement)"]&&f.funct["(name)"].charAt(0)>"Z"||f.funct["(global)"])&&F("W040",e)}),ct("true"),ct("undefined"),Et("=","assign",20),Et("+=","assignadd",20),Et("-=","assignsub",20),Et("*=","assignmult",20),Et("/=","assigndiv",20).nud=function(){q("E014")},Et("%=","assignmod",20),xt("&="),xt("|="),xt("^="),xt("<<="),xt(">>="),xt(">>>="),ht(",",function(e,t){var n;t.exprs=[e],f.option.nocomma&&F("W127");if(!tt({peek:!0}))return t;for(;;){if(!(n=Q(10)))break;t.exprs.push(n);if(f.tokens.next.value!==","||!tt())break}return t},10,!0),ht("?",function(e,t){return $t(),t.left=e,t.right=Q(10),V(":"),t["else"]=Q(10),t},30);var Ht=40;ht("||",function(e,t){return $t(),t.left=e,t.right=Q(Ht),t},Ht),ht("&&","and",50),St("|","bitor",70),St("^","bitxor",80),St("&","bitand",90),dt("==",function(e,t){var n=f.option.eqnull&&((e&&e.value)==="null"||(t&&t.value)==="null");switch(!0){case!n&&f.option.eqeqeq:this.from=this.character,F("W116",this,"===","==");break;case vt(e):F("W041",this,"===",e.value);break;case vt(t):F("W041",this,"===",t.value);break;case gt(t,e,f):F("W122",this,t.value);break;case gt(e,t,f):F("W122",this,e.value)}return this}),dt("===",function(e,t){return gt(t,e,f)?F("W122",this,t.value):gt(e,t,f)&&F("W122",this,e.value),this}),dt("!=",function(e,t){var n=f.option.eqnull&&((e&&e.value)==="null"||(t&&t.value)==="null");return!n&&f.option.eqeqeq?(this.from=this.character,F("W116",this,"!==","!=")):vt(e)?F("W041",this,"!==",e.value):vt(t)?F("W041",this,"!==",t.value):gt(t,e,f)?F("W122",this,t.value):gt(e,t,f)&&F("W122",this,e.value),this}),dt("!==",function(e,t){return gt(t,e,f)?F("W122",this,t.value):gt(e,t,f)&&F("W122",this,e.value),this}),dt("<"),dt(">"),dt("<="),dt(">="),St("<<","shiftleft",120),St(">>","shiftright",120),St(">>>","shiftrightunsigned",120),ht("in","in",120),ht("instanceof","instanceof",120),ht("+",function(e,t){var n;return t.left=e,t.right=n=Q(130),e&&n&&e.id==="(string)"&&n.id==="(string)"?(e.value+=n.value,e.character=n.character,!f.option.scripturl&&a.javascriptURL.test(e.value)&&F("W050",e),e):t},130),ut("+","num"),ut("+++",function(){return F("W007"),this.arity="unary",this.right=Q(150),this}),ht("+++",function(e){return F("W007"),this.left=e,this.right=Q(130),this},130),ht("-","sub",130),ut("-","neg"),ut("---",function(){return F("W006"),this.arity="unary",this.right=Q(150),this}),ht("---",function(e){return F("W006"),this.left=e,this.right=Q(130),this},130),ht("*","mult",140),ht("/","div",140),ht("%","mod",140),Tt("++"),ut("++","preinc"),f.syntax["++"].exps=!0,Tt("--"),ut("--","predec"),f.syntax["--"].exps=!0,ut("delete",function(){var e=Q(10);return e?(e.id!=="."&&e.id!=="["&&F("W051"),this.first=e,e.identifier&&!f.isStrict()&&(e.forgiveUndef=!0),this):this}).exps=!0,ut("~",function(){return f.option.bitwise&&F("W016",this,"~"),this.arity="unary",this.right=Q(150),this}),ut("...",function(){return f.inES6(!0)||F("W119",this,"spread/rest operator","6"),!f.tokens.next.identifier&&f.tokens.next.type!=="(string)"&&!hn(f.tokens.next,["[","("])&&q("E030",f.tokens.next,f.tokens.next.value),Q(150),this}),ut("!",function(){return this.arity="unary",this.right=Q(150),this.right||B("E041",this.line||0),t[this.right.id]===!0&&F("W018",this,"!"),this}),ut("typeof",function(){var e=Q(150);return this.first=this.right=e,e||B("E041",this.line||0,this.character||0),e.identifier&&(e.forgiveUndef=!0),this}),ut("new",function(){var e=Qt("target",function(){f.inES6(!0)||F("W119",f.tokens.prev,"new.target","6");var e,t=f.funct;while(t){e=!t["(global)"];if(!t["(arrow)"])break;t=t["(context)"]}e||F("W136",f.tokens.prev,"new.target")});if(e)return e;var t=Q(155),n;if(t&&t.id!=="function")if(t.identifier){t["new"]=!0;switch(t.value){case"Number":case"String":case"Boolean":case"Math":case"JSON":F("W053",f.tokens.prev,t.value);break;case"Symbol":f.inES6()&&F("W053",f.tokens.prev,t.value);break;case"Function":f.option.evil||F("W054");break;case"Date":case"RegExp":case"this":break;default:t.id!=="function"&&(n=t.value.substr(0,1),f.option.newcap&&(n<"A"||n>"Z")&&!f.funct["(scope)"].isPredefined(t.value)&&F("W055",f.tokens.curr))}}else t.id!=="."&&t.id!=="["&&t.id!=="("&&F("W056",f.tokens.curr);else f.option.supernew||F("W057",this);return f.tokens.next.id!=="("&&!f.option.supernew&&F("W058",f.tokens.curr,f.tokens.curr.value),this.first=this.right=t,this}),f.syntax["new"].exps=!0,ut("void").exps=!0,ht(".",function(e,t){var n=Ct(!1,!0);return typeof n=="string"&&Dt(n),t.left=e,t.right=n,n&&n==="hasOwnProperty"&&f.tokens.next.value==="="&&F("W001"),!e||e.value!=="arguments"||n!=="callee"&&n!=="caller"?!f.option.evil&&e&&e.value==="document"&&(n==="write"||n==="writeln")&&F("W060",e):f.option.noarg?F("W059",e,n):f.isStrict()&&q("E008"),!f.option.evil&&(n==="eval"||n==="execScript")&&yt(e,f)&&F("W061"),t},160,!0),ht("(",function(e,t){f.option.immed&&e&&!e.immed&&e.id==="function"&&F("W062");var n=0,r=[];e&&e.type==="(identifier)"&&e.value.match(/^[A-Z]([A-Z0-9_$]*[a-z][A-Za-z0-9_$]*)?$/)&&"Array Number String Boolean Date Object Error Symbol".indexOf(e.value)===-1&&(e.value==="Math"?F("W063",e):f.option.newcap&&F("W064",e));if(f.tokens.next.id!==")")for(;;){r[r.length]=Q(10),n+=1;if(f.tokens.next.id!==",")break;tt()}return V(")"),typeof e=="object"&&(!f.inES5()&&e.value==="parseInt"&&n===1&&F("W065",f.tokens.curr),f.option.evil||(e.value==="eval"||e.value==="Function"||e.value==="execScript"?(F("W061",e),r[0]&&[0].id==="(string)"&&U(e,r[0].value)):!r[0]||r[0].id!=="(string)"||e.value!=="setTimeout"&&e.value!=="setInterval"?r[0]&&r[0].id==="(string)"&&e.value==="."&&e.left.value==="window"&&(e.right==="setTimeout"||e.right==="setInterval")&&(F("W066",e),U(e,r[0].value)):(F("W066",e),U(e,r[0].value))),!e.identifier&&e.id!=="."&&e.id!=="["&&e.id!=="=>"&&e.id!=="("&&e.id!=="&&"&&e.id!=="||"&&e.id!=="?"&&(!f.inES6()||!e["(name)"])&&F("W067",t)),t.left=e,t},155,!0).exps=!0,ut("(",function(){var e=f.tokens.next,t,n=-1,r,i,s,o,u=1,a=f.tokens.curr,l=f.tokens.prev,c=!f.option.singleGroups;do e.value==="("?u+=1:e.value===")"&&(u-=1),n+=1,t=e,e=W(n);while((u!==0||t.value!==")")&&e.value!==";"&&e.type!=="(end)");f.tokens.next.id==="function"&&(i=f.tokens.next.immed=!0);if(e.value==="=>")return Xt({type:"arrow",parsedOpening:!0});var h=[];if(f.tokens.next.id!==")")for(;;){h.push(Q(10));if(f.tokens.next.id!==",")break;f.option.nocomma&&F("W127"),tt()}V(")",this),f.option.immed&&h[0]&&h[0].id==="function"&&f.tokens.next.id!=="("&&f.tokens.next.id!=="."&&f.tokens.next.id!=="["&&F("W068",this);if(!h.length)return;return h.length>1?(r=Object.create(f.syntax[","]),r.exprs=h,s=h[0],o=h[h.length-1],c||(c=l.assign||l.delim)):(r=s=o=h[0],c||(c=a.beginsStmt&&(r.id==="{"||i||Ut(r))||i&&(!J()||f.tokens.prev.id!=="}")||Ut(r)&&!J()||r.id==="{"&&l.id==="=>"||r.type==="(number)"&&pn(e,".")&&/^\d+$/.test(r.value))),r&&(!c&&(s.left||s.right||r.exprs)&&(c=!K(l)&&s.lbp<=l.lbp||!J()&&o.lbp<f.tokens.next.lbp),c||F("W126",a),r.paren=!0),r}),pt("=>"),ht("[",function(e,t){var n=Q(10),r;return n&&n.type==="(string)"&&(!f.option.evil&&(n.value==="eval"||n.value==="execScript")&&yt(e,f)&&F("W061"),Dt(n.value),!f.option.sub&&a.identifier.test(n.value)&&(r=f.syntax[n.value],(!r||!O(r))&&F("W069",f.tokens.prev,n.value))),V("]",t),n&&n.value==="hasOwnProperty"&&f.tokens.next.value==="="&&F("W001"),t.left=e,t.right=n,t},160,!0),ut("[",function(){var e=an();if(e.isCompArray)return!f.option.esnext&&!f.inMoz()&&F("W118",f.tokens.curr,"array comprehension"),Bt();if(e.isDestAssign)return this.destructAssign=Gt({openingParsed:!0,assignment:!0}),this;var t=f.tokens.curr.line!==G(f.tokens.next);this.first=[],t&&(g+=f.option.indent,f.tokens.next.from===g+f.option.indent&&(g+=f.option.indent));while(f.tokens.next.id!=="(end)"){while(f.tokens.next.id===","){if(!f.option.elision){if(!!f.inES5()){F("W128");do V(",");while(f.tokens.next.id===",");continue}F("W070")}V(",")}if(f.tokens.next.id==="]")break;this.first.push(Q(10));if(f.tokens.next.id!==",")break;tt({allowTrailing:!0});if(f.tokens.next.id==="]"&&!f.inES5()){F("W070",f.tokens.curr);break}}return t&&(g-=f.option.indent),V("]",this),this}),function(e){e.nud=function(){var e,t,n,r,i,s=!1,o,u=Object.create(null);e=f.tokens.curr.line!==G(f.tokens.next),e&&(g+=f.option.indent,f.tokens.next.from===g+f.option.indent&&(g+=f.option.indent));var a=an();if(a.isDestAssign)return this.destructAssign=Gt({openingParsed:!0,assignment:!0}),this;for(;;){if(f.tokens.next.id==="}")break;o=f.tokens.next.value;if(!f.tokens.next.identifier||X().id!==","&&X().id!=="}")if(W().id===":"||o!=="get"&&o!=="set"){f.tokens.next.value==="*"&&f.tokens.next.type==="(punctuator)"?(f.inES6()||F("W104",f.tokens.next,"generator functions","6"),V("*"),s=!0):s=!1;if(f.tokens.next.id==="[")n=cn(),f.nameStack.set(n);else{f.nameStack.set(f.tokens.next),n=It(),fn(u,n,f.tokens.next);if(typeof n!="string")break}f.tokens.next.value==="("?(f.inES6()||F("W104",f.tokens.curr,"concise methods","6"),Xt({type:s?"generator":null})):(V(":"),Q(10))}else V(o),f.inES5()||q("E034"),n=It(),!n&&!f.inES6()&&q("E035"),n&&ln(o,u,n,f.tokens.curr),i=f.tokens.next,t=Xt(),r=t["(params)"],o==="get"&&n&&r?F("W076",i,r[0],n):o==="set"&&n&&(!r||r.length!==1)&&F("W077",i,n);else f.inES6()||F("W104",f.tokens.next,"object short notation","6"),n=It(!0),fn(u,n,f.tokens.next),Q(10);Dt(n);if(f.tokens.next.id!==",")break;tt({allowTrailing:!0,property:!0}),f.tokens.next.id===","?F("W070",f.tokens.curr):f.tokens.next.id==="}"&&!f.inES5()&&F("W070",f.tokens.curr)}return e&&(g-=f.option.indent),V("}",this),Kt(u),this},e.fud=function(){q("E036",f.tokens.curr)}}(rt("{"));var tn=it("const",function(e){return en("const",this,e)});tn.exps=!0;var nn=it("let",function(e){return en("let",this,e)});nn.exps=!0;var rn=it("var",function(e){var t=e&&e.prefix,n=e&&e.inexport,i,o,u,a=e&&e.implied,l=!e||!e.ignore;this.first=[];for(;;){var c=[];r.contains(["{","["],f.tokens.next.value)?(i=Gt(),o=!1):(i=[{id:Ct(),token:f.tokens.curr}],o=!0),(!t||!a)&&l&&f.option.varstmt&&F("W132",this),this.first=this.first.concat(c);for(var h in i)i.hasOwnProperty(h)&&(h=i[h],!a&&f.funct["(global)"]&&(S[h.id]===!1?F("W079",h.token,h.id):f.option.futurehostile===!1&&(!f.inES5()&&s.ecmaIdentifiers[5][h.id]===!1||!f.inES6()&&s.ecmaIdentifiers[6][h.id]===!1)&&F("W129",h.token,h.id)),h.id&&(a==="for"?(f.funct["(scope)"].has(h.id)||l&&F("W088",h.token,h.id),f.funct["(scope)"].block.use(h.id,h.token)):(f.funct["(scope)"].addlabel(h.id,{type:"var",token:h.token}),o&&n&&f.funct["(scope)"].setExported(h.id,h.token)),c.push(h.token)));f.tokens.next.id==="="&&(f.nameStack.set(f.tokens.curr),V("="),!t&&l&&!f.funct["(loopage)"]&&f.tokens.next.id==="undefined"&&F("W080",f.tokens.prev,f.tokens.prev.value),W(0).id==="="&&f.tokens.next.identifier&&(!t&&l&&!f.funct["(params)"]||f.funct["(params)"].indexOf(f.tokens.next.value)===-1)&&F("W120",f.tokens.next,f.tokens.next.value),u=Q(t?120:10),o?i[0].first=u:Zt(c,u));if(f.tokens.next.id!==",")break;tt()}return this});rn.exps=!0,st("class",function(){return sn.call(this,!0)}),st("function",function(e){var t=e&&e.inexport,n=!1;f.tokens.next.value==="*"&&(V("*"),f.inES6({strict:!0})?n=!0:F("W119",f.tokens.curr,"function*","6")),m&&F("W082",f.tokens.curr);var r=Nt();return f.funct["(scope)"].addlabel(r,{type:"function",token:f.tokens.curr}),r===undefined?F("W025"):t&&f.funct["(scope)"].setExported(r,f.tokens.prev),Xt({name:r,statement:this,type:n?"generator":null,ignoreLoopFunc:m}),f.tokens.next.id==="("&&f.tokens.next.line===f.tokens.curr.line&&q("E039"),this}),ut("function",function(){var e=!1;f.tokens.next.value==="*"&&(f.inES6()||F("W119",f.tokens.curr,"function*","6"),V("*"),e=!0);var t=Nt();return Xt({name:t,type:e?"generator":null}),this}),st("if",function(){var e=f.tokens.next;$t(),f.condition=!0,V("(");var t=Q(0);Jt(t);var n=null;f.option.forin&&f.forinifcheckneeded&&(f.forinifcheckneeded=!1,n=f.forinifchecks[f.forinifchecks.length-1],t.type==="(punctuator)"&&t.value==="!"?n.type="(negative)":n.type="(positive)"),V(")",e),f.condition=!1;var r=_t(!0,!0);return n&&n.type==="(negative)"&&r&&r[0]&&r[0].type==="(identifier)"&&r[0].value==="continue"&&(n.type="(negative-with-continue)"),f.tokens.next.id==="else"&&(V("else"),f.tokens.next.id==="if"||f.tokens.next.id==="switch"?At():_t(!0,!0)),this}),st("try",function(){function t(){V("catch"),V("("),f.funct["(scope)"].stack("catchparams");if(hn(f.tokens.next,["[","{"])){var e=Gt();r.each(e,function(e){e.id&&f.funct["(scope)"].addParam(e.id,e,"exception")})}else f.tokens.next.type!=="(identifier)"?F("E030",f.tokens.next,f.tokens.next.value):f.funct["(scope)"].addParam(Ct(),f.tokens.curr,"exception");f.tokens.next.value==="if"&&(f.inMoz()||F("W118",f.tokens.curr,"catch filter"),V("if"),Q(0)),V(")"),_t(!1),f.funct["(scope)"].unstack()}var e;_t(!0);while(f.tokens.next.id==="catch")$t(),e&&!f.inMoz()&&F("W118",f.tokens.next,"multiple catch blocks"),t(),e=!0;if(f.tokens.next.id==="finally"){V("finally"),_t(!0);return}return e||q("E021",f.tokens.next,"catch",f.tokens.next.value),this}),st("while",function(){var e=f.tokens.next;return f.funct["(breakage)"]+=1,f.funct["(loopage)"]+=1,$t(),V("("),Jt(Q(0)),V(")",e),_t(!0,!0),f.funct["(breakage)"]-=1,f.funct["(loopage)"]-=1,this}).labelled=!0,st("with",function(){var e=f.tokens.next;return f.isStrict()?q("E010",f.tokens.curr):f.option.withstmt||F("W085",f.tokens.curr),V("("),Q(0),V(")",e),_t(!0,!0),this}),st("switch",function(){var e=f.tokens.next,t=!1,n=!1;f.funct["(breakage)"]+=1,V("("),Jt(Q(0)),V(")",e),e=f.tokens.next,V("{"),f.tokens.next.from===g&&(n=!0),n||(g+=f.option.indent),this.cases=[];for(;;)switch(f.tokens.next.id){case"case":switch(f.funct["(verb)"]){case"yield":case"break":case"case":case"continue":case"return":case"switch":case"throw":break;default:f.tokens.curr.caseFallsThrough||F("W086",f.tokens.curr,"case")}V("case"),this.cases.push(Q(0)),$t(),t=!0,V(":"),f.funct["(verb)"]="case";break;case"default":switch(f.funct["(verb)"]){case"yield":case"break":case"continue":case"return":case"throw":break;default:this.cases.length&&(f.tokens.curr.caseFallsThrough||F("W086",f.tokens.curr,"default"))}V("default"),t=!0,V(":");break;case"}":n||(g-=f.option.indent),V("}",e),f.funct["(breakage)"]-=1,f.funct["(verb)"]=undefined;return;case"(end)":q("E023",f.tokens.next,"}");return;default:g+=f.option.indent;if(t)switch(f.tokens.curr.id){case",":q("E040");return;case":":t=!1,Ot();break;default:q("E025",f.tokens.curr);return}else{if(f.tokens.curr.id!==":"){q("E021",f.tokens.next,"case",f.tokens.next.value);return}V(":"),q("E024",f.tokens.curr,":"),Ot()}g-=f.option.indent}return this}).labelled=!0,it("debugger",function(){return f.option.debug||F("W087",this),this}).exps=!0,function(){var e=it("do",function(){f.funct["(breakage)"]+=1,f.funct["(loopage)"]+=1,$t(),this.first=_t(!0,!0),V("while");var e=f.tokens.next;return V("("),Jt(Q(0)),V(")",e),f.funct["(breakage)"]-=1,f.funct["(loopage)"]-=1,this});e.labelled=!0,e.exps=!0}(),st("for",function(){var e,t=f.tokens.next,n=!1,i=null;t.value==="each"&&(i=t,V("each"),f.inMoz()||F("W118",f.tokens.curr,"for each")),$t(),V("(");var s,o=0,u=["in","of"],a=0,l,c;hn(f.tokens.next,["{","["])&&++a;do{s=W(o),++o,hn(s,["{","["])?++a:hn(s,["}","]"])&&--a;if(a<0)break;a===0&&(!l&&pn(s,",")?l=s:!c&&pn(s,"=")&&(c=s))}while(a>0||!r.contains(u,s.value)&&s.value!==";"&&s.type!=="(end)");if(r.contains(u,s.value)){!f.inES6()&&s.value==="of"&&F("W104",s,"for of","6");var h=!c&&!l;c&&q("W133",l,s.value,"initializer is forbidden"),l&&q("W133",l,s.value,"more than one ForBinding"),f.tokens.next.id==="var"?(V("var"),f.tokens.curr.fud({prefix:!0})):f.tokens.next.id==="let"||f.tokens.next.id==="const"?(V(f.tokens.next.id),n=!0,f.funct["(scope)"].stack(),f.tokens.curr.fud({prefix:!0})):Object.create(rn).fud({prefix:!0,implied:"for",ignore:!h}),V(s.value),Q(20),V(")",t),s.value==="in"&&f.option.forin&&(f.forinifcheckneeded=!0,f.forinifchecks===undefined&&(f.forinifchecks=[]),f.forinifchecks.push({type:"(none)"})),f.funct["(breakage)"]+=1,f.funct["(loopage)"]+=1,e=_t(!0,!0);if(s.value==="in"&&f.option.forin){if(f.forinifchecks&&f.forinifchecks.length>0){var p=f.forinifchecks.pop();(e&&e.length>0&&(typeof e[0]!="object"||e[0].value!=="if")||p.type==="(positive)"&&e.length>1||p.type==="(negative)")&&F("W089",this)}f.forinifcheckneeded=!1}f.funct["(breakage)"]-=1,f.funct["(loopage)"]-=1}else{i&&q("E045",i);if(f.tokens.next.id!==";")if(f.tokens.next.id==="var")V("var"),f.tokens.curr.fud();else if(f.tokens.next.id==="let")V("let"),n=!0,f.funct["(scope)"].stack(),f.tokens.curr.fud();else for(;;){Q(0,"for");if(f.tokens.next.id!==",")break;l()}Z(f.tokens.curr),V(";"),f.funct["(loopage)"]+=1,f.tokens.next.id!==";"&&Jt(Q(0)),Z(f.tokens.curr),V(";"),f.tokens.next.id===";"&&q("E021",f.tokens.next,")",";");if(f.tokens.next.id!==")")for(;;){Q(0,"for");if(f.tokens.next.id!==",")break;l()}V(")",t),f.funct["(breakage)"]+=1,_t(!0,!0),f.funct["(breakage)"]-=1,f.funct["(loopage)"]-=1}return n&&f.funct["(scope)"].unstack(),this}).labelled=!0,it("break",function(){var e=f.tokens.next.value;return f.option.asi||Z(this),f.tokens.next.id!==";"&&!f.tokens.next.reach&&f.tokens.curr.line===G(f.tokens.next)?(f.funct["(scope)"].funct.hasBreakLabel(e)||F("W090",f.tokens.next,e),this.first=f.tokens.next,V()):f.funct["(breakage)"]===0&&F("W052",f.tokens.next,this.value),kt(this),this}).exps=!0,it("continue",function(){var e=f.tokens.next.value;return f.funct["(breakage)"]===0&&F("W052",f.tokens.next,this.value),f.funct["(loopage)"]||F("W052",f.tokens.next,this.value),f.option.asi||Z(this),f.tokens.next.id!==";"&&!f.tokens.next.reach&&f.tokens.curr.line===G(f.tokens.next)&&(f.funct["(scope)"].funct.hasBreakLabel(e)||F("W090",f.tokens.next,e),this.first=f.tokens.next,V()),kt(this),this}).exps=!0,it("return",function(){return this.line===G(f.tokens.next)?f.tokens.next.id!==";"&&!f.tokens.next.reach&&(this.first=Q(0),this.first&&this.first.type==="(punctuator)"&&this.first.value==="="&&!this.first.paren&&!f.option.boss&&I("W093",this.first.line,this.first.character)):f.tokens.next.type==="(punctuator)"&&["[","{","+","-"].indexOf(f.tokens.next.value)>-1&&Z(this),kt(this),this}).exps=!0,function(e){e.exps=!0,e.lbp=25}(ut("yield",function(){var e=f.tokens.prev;f.inES6(!0)&&!f.funct["(generator)"]?("(catch)"!==f.funct["(name)"]||!f.funct["(context)"]["(generator)"])&&q("E046",f.tokens.curr,"yield"):f.inES6()||F("W104",f.tokens.curr,"yield","6"),f.funct["(generator)"]="yielded";var t=!1;f.tokens.next.value==="*"&&(t=!0,V("*"));if(this.line===G(f.tokens.next)||!f.inMoz()){if(t||f.tokens.next.id!==";"&&!f.option.asi&&!f.tokens.next.reach&&f.tokens.next.nud)Y(f.tokens.curr,f.tokens.next),this.first=Q(10),this.first.type==="(punctuator)"&&this.first.value==="="&&!this.first.paren&&!f.option.boss&&I("W093",this.first.line,this.first.character);f.inMoz()&&f.tokens.next.id!==")"&&(e.lbp>30||!e.assign&&!J()||e.id==="yield")&&q("E050",this)}else f.option.asi||Z(this);return this})),it("throw",function(){return Z(this),this.first=Q(20),kt(this),this}).exps=!0,it("import",function(){f.inES6()||F("W119",f.tokens.curr,"import","6");if(f.tokens.next.type==="(string)")return V("(string)"),this;if(f.tokens.next.identifier){this.name=Ct(),f.funct["(scope)"].addlabel(this.name,{type:"const",token:f.tokens.curr});if(f.tokens.next.value!==",")return V("from"),V("(string)"),this;V(",")}if(f.tokens.next.id==="*")V("*"),V("as"),f.tokens.next.identifier&&(this.name=Ct(),f.funct["(scope)"].addlabel(this.name,{type:"const",token:f.tokens.curr}));else{V("{");for(;;){if(f.tokens.next.value==="}"){V("}");break}var e;f.tokens.next.type==="default"?(e="default",V("default")):e=Ct(),f.tokens.next.value==="as"&&(V("as"),e=Ct()),f.funct["(scope)"].addlabel(e,{type:"const",token:f.tokens.curr});if(f.tokens.next.value!==","){if(f.tokens.next.value==="}"){V("}");break}q("E024",f.tokens.next,f.tokens.next.value);break}V(",")}}return V("from"),V("(string)"),this}).exps=!0,it("export",function(){var e=!0,t,n;f.inES6()||(F("W119",f.tokens.curr,"export","6"),e=!1),f.funct["(scope)"].block.isGlobal()||(q("E053",f.tokens.curr),e=!1);if(f.tokens.next.value==="*")return V("*"),V("from"),V("(string)"),this;if(f.tokens.next.type==="default"){f.nameStack.set(f.tokens.next),V("default");var r=f.tokens.next.id;if(r==="function"||r==="class")this.block=!0;return t=W(),Q(10),n=t.value,this.block&&(f.funct["(scope)"].addlabel(n,{type:r,token:t}),f.funct["(scope)"].setExported(n,t)),this}if(f.tokens.next.value==="{"){V("{");var i=[];for(;;){f.tokens.next.identifier||q("E030",f.tokens.next,f.tokens.next.value),V(),i.push(f.tokens.curr),f.tokens.next.value==="as"&&(V("as"),f.tokens.next.identifier||q("E030",f.tokens.next,f.tokens.next.value),V());if(f.tokens.next.value!==","){if(f.tokens.next.value==="}"){V("}");break}q("E024",f.tokens.next,f.tokens.next.value);break}V(",")}return f.tokens.next.value==="from"?(V("from"),V("(string)")):e&&i.forEach(function(e){f.funct["(scope)"].setExported(e.value,e)}),this}if(f.tokens.next.id==="var")V("var"),f.tokens.curr.fud({inexport:!0});else if(f.tokens.next.id==="let")V("let"),f.tokens.curr.fud({inexport:!0});else if(f.tokens.next.id==="const")V("const"),f.tokens.curr.fud({inexport:!0});else if(f.tokens.next.id==="function")this.block=!0,V("function"),f.syntax["function"].fud({inexport:!0});else if(f.tokens.next.id==="class"){this.block=!0,V("class");var s=f.tokens.next;f.syntax["class"].fud(),f.funct["(scope)"].setExported(s.value,s)}else q("E024",f.tokens.next,f.tokens.next.value);return this}).exps=!0,lt("abstract"),lt("boolean"),lt("byte"),lt("char"),lt("class",{es5:!0,nud:sn}),lt("double"),lt("enum",{es5:!0}),lt("export",{es5:!0}),lt("extends",{es5:!0}),lt("final"),lt("float"),lt("goto"),lt("implements",{es5:!0,strictOnly:!0}),lt("import",{es5:!0}),lt("int"),lt("interface",{es5:!0,strictOnly:!0}),lt("long"),lt("native"),lt("package",{es5:!0,strictOnly:!0}),lt("private",{es5:!0,strictOnly:!0}),lt("protected",{es5:!0,strictOnly:!0}),lt("public",{es5:!0,strictOnly:!0}),lt("short"),lt("static",{es5:!0,strictOnly:!0}),lt("super",{es5:!0}),lt("synchronized"),lt("transient"),lt("volatile");var an=function(){var e,t,n,r=-1,i=0,s={};hn(f.tokens.curr,["[","{"])&&(i+=1);do{n=r===-1?f.tokens.curr:e,e=r===-1?f.tokens.next:W(r),t=W(r+1),r+=1,hn(e,["[","{"])?i+=1:hn(e,["]","}"])&&(i-=1);if(i===1&&e.identifier&&e.value==="for"&&!pn(n,".")){s.isCompArray=!0,s.notJson=!0;break}if(i===0&&hn(e,["}","]"])){if(t.value==="="){s.isDestAssign=!0,s.notJson=!0;break}if(t.value==="."){s.notJson=!0;break}}pn(e,";")&&(s.isBlock=!0,s.notJson=!0)}while(i>0&&e.id!=="(end)");return s},vn=function(){function i(e){var t=n.variables.filter(function(t){if(t.value===e)return t.undef=!1,e}).length;return t!==0}function s(e){var t=n.variables.filter(function(t){if(t.value===e&&!t.undef)return t.unused===!0&&(t.unused=!1),e}).length;return t===0}var e=function(){this.mode="use",this.variables=[]},t=[],n;return{stack:function(){n=new e,t.push(n)},unstack:function(){n.variables.filter(function(e){e.unused&&F("W098",e.token,e.raw_text||e.value),e.undef&&f.funct["(scope)"].block.use(e.value,e.token)}),t.splice(-1,1),n=t[t.length-1]},setState:function(e){r.contains(["use","define","generate","filter"],e)&&(n.mode=e)},check:function(e){if(!n)return;return n&&n.mode==="use"?(s(e)&&n.variables.push({funct:f.funct,token:f.tokens.curr,value:e,undef:!0,unused:!1}),!0):n&&n.mode==="define"?(i(e)||n.variables.push({funct:f.funct,token:f.tokens.curr,value:e,undef:!1,unused:!0}),!0):n&&n.mode==="generate"?(f.funct["(scope)"].block.use(e,f.tokens.curr),!0):n&&n.mode==="filter"?(s(e)&&f.funct["(scope)"].block.use(e,f.tokens.curr),!0):!1}}},gn=function(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")},yn=function(t,i,o){function U(e,t){if(!e)return;!Array.isArray(e)&&typeof e=="object"&&(e=Object.keys(e)),e.forEach(t)}var a,l,c,d,A,O,M={},P={};i=r.clone(i),f.reset(),i&&i.scope?p.scope=i.scope:(p.errors=[],p.undefs=[],p.internals=[],p.blacklist={},p.scope="(main)"),S=Object.create(null),D(S,s.ecmaIdentifiers[3]),D(S,s.reservedVars),D(S,o||{}),n=Object.create(null);var j=Object.create(null);if(i){U(i.predef||null,function(e){var t,n;e[0]==="-"?(t=e.slice(1),p.blacklist[t]=t,delete S[t]):(n=Object.getOwnPropertyDescriptor(i.predef,e),S[e]=n?n.value:!1)}),U(i.exported||null,function(e){j[e]=!0}),delete i.predef,delete i.exported,O=Object.keys(i);for(c=0;c<O.length;c++)if(/^-W\d{3}$/g.test(O[c]))P[O[c].slice(1)]=!0;else{var z=O[c];M[z]=i[z],(z==="esversion"&&i[z]===5||z==="es5"&&i[z])&&F("I003"),O[c]==="newcap"&&i[z]===!1&&(M["(explicitNewcap)"]=!0)}}f.option=M,f.ignored=P,f.option.indent=f.option.indent||4,f.option.maxerr=f.option.maxerr||50,g=1;var W=h(f,S,j,n);W.on("warning",function(e){F.apply(null,[e.code,e.token].concat(e.data))}),W.on("error",function(e){q.apply(null,[e.code,e.token].concat(e.data))}),f.funct=Rt("(global)",null,{"(global)":!0,"(scope)":W,"(comparray)":vn(),"(metrics)":Vt(f.tokens.next)}),v=[f.funct],T=[],x=null,w={},E=null,m=!1,y=[];if(!L(t)&&!Array.isArray(t))return R("E004",0),!1;e={get isJSON(){return f.jsonMode},getOption:function(e){return f.option[e]||null},getCache:function(e){return f.cache[e]},setCache:function(e,t){f.cache[e]=t},warn:function(e,t){I.apply(null,[e,t.line,t.char].concat(t.data))},on:function(e,t){e.split(" ").forEach(function(e){C.on(e,t)}.bind(this))}},C.removeAllListeners(),(N||[]).forEach(function(t){t(e)}),f.tokens.prev=f.tokens.curr=f.tokens.next=f.syntax["(begin)"],i&&i.ignoreDelimiters&&(Array.isArray(i.ignoreDelimiters)||(i.ignoreDelimiters=[i.ignoreDelimiters]),i.ignoreDelimiters.forEach(function(e){if(!e.start||!e.end)return;d=gn(e.start)+"[\\s\\S]*?"+gn(e.end),A=new RegExp(d,"ig"),t=t.replace(A,function(e){return e.replace(/./g," ")})})),b=new u(t),b.on("warning",function(e){I.apply(null,[e.code,e.line,e.character].concat(e.data))}),b.on("error",function(e){R.apply(null,[e.code,e.line,e.character].concat(e.data))}),b.on("fatal",function(e){B("E041",e.line,e.from)}),b.on("Identifier",function(e){C.emit("Identifier",e)}),b.on("String",function(e){C.emit("String",e)}),b.on("Number",function(e){C.emit("Number",e)}),b.start();for(var X in i)r.has(i,X)&&k(X,f.tokens.curr);H(),D(S,o||{}),tt.first=!0;try{V();switch(f.tokens.next.id){case"{":case"[":dn();break;default:Mt(),f.directive["use strict"]&&f.option.strict!=="global"&&F("W097",f.tokens.prev),Ot()}f.tokens.next.id!=="(end)"&&B("E041",f.tokens.curr.line),f.funct["(scope)"].unstack()}catch($){if(!$||$.name!=="JSHintError")throw $;var J=f.tokens.next||{};p.errors.push({scope:"(main)",raw:$.raw,code:$.code,reason:$.message,line:$.line||J.line,character:$.character||J.from},null)}if(p.scope==="(main)"){i=i||{};for(a=0;a<p.internals.length;a+=1)l=p.internals[a],i.scope=l.elem,yn(l.value,i,o)}return p.errors.length===0};return yn.addModule=function(e){N.push(e)},yn.addModule(l.register),yn.data=function(){var e={functions:[],options:f.option},t,n,r,i,s,o;yn.errors.length&&(e.errors=yn.errors),f.jsonMode&&(e.json=!0);var u=f.funct["(scope)"].getImpliedGlobals();u.length>0&&(e.implieds=u),T.length>0&&(e.urls=T),o=f.funct["(scope)"].getUsedOrDefinedGlobals(),o.length>0&&(e.globals=o);for(r=1;r<v.length;r+=1){n=v[r],t={};for(i=0;i<d.length;i+=1)t[d[i]]=[];for(i=0;i<d.length;i+=1)t[d[i]].length===0&&delete t[d[i]];t.name=n["(name)"],t.param=n["(params)"],t.line=n["(line)"],t.character=n["(character)"],t.last=n["(last)"],t.lastcharacter=n["(lastcharacter)"],t.metrics={complexity:n["(metrics)"].ComplexityCount,parameters:n["(metrics)"].arity,statements:n["(metrics)"].statementCount},e.functions.push(t)}var a=f.funct["(scope)"].getUnuseds();a.length>0&&(e.unused=a);for(s in w)if(typeof w[s]=="number"){e.member=w;break}return e},yn.jshint=yn,yn}();typeof n=="object"&&n&&(n.JSHINT=p)},{"../lodash":"/node_modules/jshint/lodash.js","./lex.js":"/node_modules/jshint/src/lex.js","./messages.js":"/node_modules/jshint/src/messages.js","./options.js":"/node_modules/jshint/src/options.js","./reg.js":"/node_modules/jshint/src/reg.js","./scope-manager.js":"/node_modules/jshint/src/scope-manager.js","./state.js":"/node_modules/jshint/src/state.js","./style.js":"/node_modules/jshint/src/style.js","./vars.js":"/node_modules/jshint/src/vars.js",events:"/node_modules/browserify/node_modules/events/events.js"}],"/node_modules/jshint/src/lex.js":[function(e,t,n){"use strict";function h(){var e=[];return{push:function(t){e.push(t)},check:function(){for(var t=0;t<e.length;++t)e[t]();e.splice(0,e.length)}}}function p(e){var t=e;typeof t=="string"&&(t=t.replace(/\r\n/g,"\n").replace(/\r/g,"\n").split("\n")),t[0]&&t[0].substr(0,2)==="#!"&&(t[0].indexOf("node")!==-1&&(o.option.node=!0),t[0]=""),this.emitter=new i.EventEmitter,this.source=e,this.setLines(t),this.prereg=!0,this.line=0,this.char=1,this.from=1,this.input="",this.inComment=!1,this.context=[],this.templateStarts=[];for(var n=0;n<o.option.indent;n+=1)o.tab+=" ";this.ignoreLinterErrors=!1}var r=e("../lodash"),i=e("events"),s=e("./reg.js"),o=e("./state.js").state,u=e("../data/ascii-identifier-data.js"),a=u.asciiIdentifierStartTable,f=u.asciiIdentifierPartTable,l={Identifier:1,Punctuator:2,NumericLiteral:3,StringLiteral:4,Comment:5,Keyword:6,NullLiteral:7,BooleanLiteral:8,RegExp:9,TemplateHead:10,TemplateMiddle:11,TemplateTail:12,NoSubstTemplate:13},c={Block:1,Template:2};p.prototype={_lines:[],inContext:function(e){return this.context.length>0&&this.context[this.context.length-1].type===e},pushContext:function(e){this.context.push({type:e})},popContext:function(){return this.context.pop()},isContext:function(e){return this.context.length>0&&this.context[this.context.length-1]===e},currentContext:function(){return this.context.length>0&&this.context[this.context.length-1]},getLines:function(){return this._lines=o.lines,this._lines},setLines:function(e){this._lines=e,o.lines=this._lines},peek:function(e){return this.input.charAt(e||0)},skip:function(e){e=e||1,this.char+=e,this.input=this.input.slice(e)},on:function(e,t){e.split(" ").forEach(function(e){this.emitter.on(e,t)}.bind(this))},trigger:function(){this.emitter.emit.apply(this.emitter,Array.prototype.slice.call(arguments))},triggerAsync:function(e,t,n,r){n.push(function(){r()&&this.trigger(e,t)}.bind(this))},scanPunctuator:function(){var e=this.peek(),t,n,r;switch(e){case".":if(/^[0-9]$/.test(this.peek(1)))return null;if(this.peek(1)==="."&&this.peek(2)===".")return{type:l.Punctuator,value:"..."};case"(":case")":case";":case",":case"[":case"]":case":":case"~":case"?":return{type:l.Punctuator,value:e};case"{":return this.pushContext(c.Block),{type:l.Punctuator,value:e};case"}":return this.inContext(c.Block)&&this.popContext(),{type:l.Punctuator,value:e};case"#":return{type:l.Punctuator,value:e};case"":return null}return t=this.peek(1),n=this.peek(2),r=this.peek(3),e===">"&&t===">"&&n===">"&&r==="="?{type:l.Punctuator,value:">>>="}:e==="="&&t==="="&&n==="="?{type:l.Punctuator,value:"==="}:e==="!"&&t==="="&&n==="="?{type:l.Punctuator,value:"!=="}:e===">"&&t===">"&&n===">"?{type:l.Punctuator,value:">>>"}:e==="<"&&t==="<"&&n==="="?{type:l.Punctuator,value:"<<="}:e===">"&&t===">"&&n==="="?{type:l.Punctuator,value:">>="}:e==="="&&t===">"?{type:l.Punctuator,value:e+t}:e===t&&"+-<>&|".indexOf(e)>=0?{type:l.Punctuator,value:e+t}:"<>=!+-*%&|^".indexOf(e)>=0?t==="="?{type:l.Punctuator,value:e+t}:{type:l.Punctuator,value:e}:e==="/"?t==="="?{type:l.Punctuator,value:"/="}:{type:l.Punctuator,value:"/"}:null},scanComments:function(){function u(e,t,n){var r=["jshint","jslint","members","member","globals","global","exported"],i=!1,u=e+t,a="plain";return n=n||{},n.isMultiline&&(u+="*/"),t=t.replace(/\n/g," "),e==="/*"&&s.fallsThrough.test(t)&&(i=!0,a="falls through"),r.forEach(function(n){if(i)return;if(e==="//"&&n!=="jshint")return;t.charAt(n.length)===" "&&t.substr(0,n.length)===n&&(i=!0,e+=n,t=t.substr(n.length)),!i&&t.charAt(0)===" "&&t.charAt(n.length+1)===" "&&t.substr(1,n.length)===n&&(i=!0,e=e+" "+n,t=t.substr(n.length+1));if(!i)return;switch(n){case"member":a="members";break;case"global":a="globals";break;default:var r=t.split(":").map(function(e){return e.replace(/^\s+/,"").replace(/\s+$/,"")});if(r.length===2)switch(r[0]){case"ignore":switch(r[1]){case"start":o.ignoringLinterErrors=!0,i=!1;break;case"end":o.ignoringLinterErrors=!1,i=!1}}a=n}}),{type:l.Comment,commentType:a,value:u,body:t,isSpecial:i,isMultiline:n.isMultiline||!1,isMalformed:n.isMalformed||!1}}var e=this.peek(),t=this.peek(1),n=this.input.substr(2),r=this.line,i=this.char,o=this;if(e==="*"&&t==="/")return this.trigger("error",{code:"E018",line:r,character:i}),this.skip(2),null;if(e!=="/"||t!=="*"&&t!=="/")return null;if(t==="/")return this.skip(this.input.length),u("//",n);var a="";if(t==="*"){this.inComment=!0,this.skip(2);while(this.peek()!=="*"||this.peek(1)!=="/")if(this.peek()===""){a+="\n";if(!this.nextLine())return this.trigger("error",{code:"E017",line:r,character:i}),this.inComment=!1,u("/*",a,{isMultiline:!0,isMalformed:!0})}else a+=this.peek(),this.skip();return this.skip(2),this.inComment=!1,u("/*",a,{isMultiline:!0})}},scanKeyword:function(){var e=/^[a-zA-Z_$][a-zA-Z0-9_$]*/.exec(this.input),t=["if","in","do","var","for","new","try","let","this","else","case","void","with","enum","while","break","catch","throw","const","yield","class","super","return","typeof","delete","switch","export","import","default","finally","extends","function","continue","debugger","instanceof"];return e&&t.indexOf(e[0])>=0?{type:l.Keyword,value:e[0]}:null},scanIdentifier:function(){function i(e){return e>256}function s(e){return e>256}function o(e){return/^[0-9a-fA-F]$/.test(e)}function p(e){return e.replace(/\\u([0-9a-fA-F]{4})/g,function(e,t){return String.fromCharCode(parseInt(t,16))})}var e="",t=0,n,r,u=function(){t+=1;if(this.peek(t)!=="u")return null;var e=this.peek(t+1),n=this.peek(t+2),r=this.peek(t+3),i=this.peek(t+4),u;return o(e)&&o(n)&&o(r)&&o(i)?(u=parseInt(e+n+r+i,16),f[u]||s(u)?(t+=5,"\\u"+e+n+r+i):null):null}.bind(this),c=function(){var e=this.peek(t),n=e.charCodeAt(0);return n===92?u():n<128?a[n]?(t+=1,e):null:i(n)?(t+=1,e):null}.bind(this),h=function(){var e=this.peek(t),n=e.charCodeAt(0);return n===92?u():n<128?f[n]?(t+=1,e):null:s(n)?(t+=1,e):null}.bind(this);r=c();if(r===null)return null;e=r;for(;;){r=h();if(r===null)break;e+=r}switch(e){case"true":case"false":n=l.BooleanLiteral;break;case"null":n=l.NullLiteral;break;default:n=l.Identifier}return{type:n,value:p(e),text:e,tokenLength:e.length}},scanNumericLiteral:function(){function f(e){return/^[0-9]$/.test(e)}function c(e){return/^[0-7]$/.test(e)}function h(e){return/^[01]$/.test(e)}function p(e){return/^[0-9a-fA-F]$/.test(e)}function d(e){return e==="$"||e==="_"||e==="\\"||e>="a"&&e<="z"||e>="A"&&e<="Z"}var e=0,t="",n=this.input.length,r=this.peek(e),i,s=f,u=10,a=!1;if(r!=="."&&!f(r))return null;if(r!=="."){t=this.peek(e),e+=1,r=this.peek(e);if(t==="0"){if(r==="x"||r==="X")s=p,u=16,e+=1,t+=r;if(r==="o"||r==="O")s=c,u=8,o.inES6(!0)||this.trigger("warning",{code:"W119",line:this.line,character:this.char,data:["Octal integer literal","6"]}),e+=1,t+=r;if(r==="b"||r==="B")s=h,u=2,o.inES6(!0)||this.trigger("warning",{code:"W119",line:this.line,character:this.char,data:["Binary integer literal","6"]}),e+=1,t+=r;c(r)&&(s=c,u=8,a=!0,i=!1,e+=1,t+=r),!c(r)&&f(r)&&(e+=1,t+=r)}while(e<n){r=this.peek(e);if(a&&f(r))i=!0;else if(!s(r))break;t+=r,e+=1}if(s!==f){if(!a&&t.length<=2)return{type:l.NumericLiteral,value:t,isMalformed:!0};if(e<n){r=this.peek(e);if(d(r))return null}return{type:l.NumericLiteral,value:t,base:u,isLegacy:a,isMalformed:!1}}}if(r==="."){t+=r,e+=1;while(e<n){r=this.peek(e);if(!f(r))break;t+=r,e+=1}}if(r==="e"||r==="E"){t+=r,e+=1,r=this.peek(e);if(r==="+"||r==="-")t+=this.peek(e),e+=1;r=this.peek(e);if(!f(r))return null;t+=r,e+=1;while(e<n){r=this.peek(e);if(!f(r))break;t+=r,e+=1}}if(e<n){r=this.peek(e);if(d(r))return null}return{type:l.NumericLiteral,value:t,base:u,isMalformed:!isFinite(t)}},scanEscapeSequence:function(e){var t=!1,n=1;this.skip();var r=this.peek();switch(r){case"'":this.triggerAsync("warning",{code:"W114",line:this.line,character:this.char,data:["\\'"]},e,function(){return o.jsonMode});break;case"b":r="\\b";break;case"f":r="\\f";break;case"n":r="\\n";break;case"r":r="\\r";break;case"t":r="\\t";break;case"0":r="\\0";var i=parseInt(this.peek(1),10);this.triggerAsync("warning",{code:"W115",line:this.line,character:this.char},e,function(){return i>=0&&i<=7&&o.isStrict()});break;case"u":var s=this.input.substr(1,4),u=parseInt(s,16);isNaN(u)&&this.trigger("warning",{code:"W052",line:this.line,character:this.char,data:["u"+s]}),r=String.fromCharCode(u),n=5;break;case"v":this.triggerAsync("warning",{code:"W114",line:this.line,character:this.char,data:["\\v"]},e,function(){return o.jsonMode}),r="\x0b";break;case"x":var a=parseInt(this.input.substr(1,2),16);this.triggerAsync("warning",{code:"W114",line:this.line,character:this.char,data:["\\x-"]},e,function(){return o.jsonMode}),r=String.fromCharCode(a),n=3;break;case"\\":r="\\\\";break;case'"':r='\\"';break;case"/":break;case"":t=!0,r=""}return{"char":r,jump:n,allowNewLine:t}},scanTemplateLiteral:function(e){var t,n="",r,i=this.line,s=this.char,u=this.templateStarts.length;if(!o.inES6(!0))return null;if(this.peek()==="`")t=l.TemplateHead,this.templateStarts.push({line:this.line,"char":this.char}),u=this.templateStarts.length,this.skip(1),this.pushContext(c.Template);else{if(!this.inContext(c.Template)||this.peek()!=="}")return null;t=l.TemplateMiddle}while(this.peek()!=="`"){while((r=this.peek())===""){n+="\n";if(!this.nextLine()){var a=this.templateStarts.pop();return this.trigger("error",{code:"E052",line:a.line,character:a.char}),{type:t,value:n,startLine:i,startChar:s,isUnclosed:!0,depth:u,context:this.popContext()}}}if(r==="$"&&this.peek(1)==="{")return n+="${",this.skip(2),{type:t,value:n,startLine:i,startChar:s,isUnclosed:!1,depth:u,context:this.currentContext()};if(r==="\\"){var f=this.scanEscapeSequence(e);n+=f.char,this.skip(f.jump)}else r!=="`"&&(n+=r,this.skip(1))}return t=t===l.TemplateHead?l.NoSubstTemplate:l.TemplateTail,this.skip(1),this.templateStarts.pop(),{type:t,value:n,startLine:i,startChar:s,isUnclosed:!1,depth:u,context:this.popContext()}},scanStringLiteral:function(e){var t=this.peek();if(t!=='"'&&t!=="'")return null;this.triggerAsync("warning",{code:"W108",line:this.line,character:this.char},e,function(){return o.jsonMode&&t!=='"'});var n="",r=this.line,i=this.char,s=!1;this.skip();while(this.peek()!==t)if(this.peek()===""){s?(s=!1,this.triggerAsync("warning",{code:"W043",line:this.line,character:this.char},e,function(){return!o.option.multistr}),this.triggerAsync("warning",{code:"W042",line:this.line,character:this.char},e,function(){return o.jsonMode&&o.option.multistr})):this.trigger("warning",{code:"W112",line:this.line,character:this.char});if(!this.nextLine())return this.trigger("error",{code:"E029",line:r,character:i}),{type:l.StringLiteral,value:n,startLine:r,startChar:i,isUnclosed:!0,quote:t}}else{s=!1;var u=this.peek(),a=1;u<" "&&this.trigger("warning",{code:"W113",line:this.line,character:this.char,data:["<non-printable>"]});if(u==="\\"){var f=this.scanEscapeSequence(e);u=f.char,a=f.jump,s=f.allowNewLine}n+=u,this.skip(a)}return this.skip(),{type:l.StringLiteral,value:n,startLine:r,startChar:i,isUnclosed:!1,quote:t}},scanRegExp:function(){var e=0,t=this.input.length,n=this.peek(),r=n,i="",s=[],o=!1,u=!1,a,f=function(){n<" "&&(o=!0,this.trigger("warning",{code:"W048",line:this.line,character:this.char})),n==="<"&&(o=!0,this.trigger("warning",{code:"W049",line:this.line,character:this.char,data:[n]}))}.bind(this);if(!this.prereg||n!=="/")return null;e+=1,a=!1;while(e<t){n=this.peek(e),r+=n,i+=n;if(u){n==="]"&&(this.peek(e-1)!=="\\"||this.peek(e-2)==="\\")&&(u=!1),n==="\\"&&(e+=1,n=this.peek(e),i+=n,r+=n,f()),e+=1;continue}if(n==="\\"){e+=1,n=this.peek(e),i+=n,r+=n,f();if(n==="/"){e+=1;continue}if(n==="["){e+=1;continue}}if(n==="["){u=!0,e+=1;continue}if(n==="/"){i=i.substr(0,i.length-1),a=!0,e+=1;break}e+=1}if(!a)return this.trigger("error",{code:"E015",line:this.line,character:this.from}),void this.trigger("fatal",{line:this.line,from:this.from});while(e<t){n=this.peek(e);if(!/[gim]/.test(n))break;s.push(n),r+=n,e+=1}try{new RegExp(i,s.join(""))}catch(c){o=!0,this.trigger("error",{code:"E016",line:this.line,character:this.char,data:[c.message]})}return{type:l.RegExp,value:r,flags:s,isMalformed:o}},scanNonBreakingSpaces:function(){return o.option.nonbsp?this.input.search(/(\u00A0)/):-1},scanUnsafeChars:function(){return this.input.search(s.unsafeChars)},next:function(e){this.from=this.char;var t;if(/\s/.test(this.peek())){t=this.char;while(/\s/.test(this.peek()))this.from+=1,this.skip()}var n=this.scanComments()||this.scanStringLiteral(e)||this.scanTemplateLiteral(e);return n?n:(n=this.scanRegExp()||this.scanPunctuator()||this.scanKeyword()||this.scanIdentifier()||this.scanNumericLiteral(),n?(this.skip(n.tokenLength||n.value.length),n):null)},nextLine:function(){var e;if(this.line>=this.getLines().length)return!1;this.input=this.getLines()[this.line],this.line+=1,this.char=1,this.from=1;var t=this.input.trim(),n=function(){return r.some(arguments,function(e){return t.indexOf(e)===0})},i=function(){return r.some(arguments,function(e){return t.indexOf(e,t.length-e.length)!==-1})};this.ignoringLinterErrors===!0&&!n("/*","//")&&(!this.inComment||!i("*/"))&&(this.input=""),e=this.scanNonBreakingSpaces(),e>=0&&this.trigger("warning",{code:"W125",line:this.line,character:e+1}),this.input=this.input.replace(/\t/g,o.tab),e=this.scanUnsafeChars(),e>=0&&this.trigger("warning",{code:"W100",line:this.line,character:e});if(!this.ignoringLinterErrors&&o.option.maxlen&&o.option.maxlen<this.input.length){var u=this.inComment||n.call(t,"//")||n.call(t,"/*"),a=!u||!s.maxlenException.test(t);a&&this.trigger("warning",{code:"W101",line:this.line,character:this.input.length})}return!0},start:function(){this.nextLine()},token:function(){function n(e,t){if(!e.reserved)return!1;var n=e.meta;if(n&&n.isFutureReservedWord&&o.inES5()){if(!n.es5)return!1;if(n.strictOnly&&!o.option.strict&&!o.isStrict())return!1;if(t)return!1}return!0}var e=h(),t,i=function(t,i,s,u){var a;t!=="(endline)"&&t!=="(end)"&&(this.prereg=!1);if(t==="(punctuator)"){switch(i){case".":case")":case"~":case"#":case"]":case"++":case"--":this.prereg=!1;break;default:this.prereg=!0}a=Object.create(o.syntax[i]||o.syntax["(error)"])}if(t==="(identifier)"){if(i==="return"||i==="case"||i==="typeof")this.prereg=!0;r.has(o.syntax,i)&&(a=Object.create(o.syntax[i]||o.syntax["(error)"]),n(a,s&&t==="(identifier)")||(a=null))}return a||(a=Object.create(o.syntax[t])),a.identifier=t==="(identifier)",a.type=a.type||t,a.value=i,a.line=this.line,a.character=this.char,a.from=this.from,a.identifier&&u&&(a.raw_text=u.text||u.value),u&&u.startLine&&u.startLine!==this.line&&(a.startLine=u.startLine),u&&u.context&&(a.context=u.context),u&&u.depth&&(a.depth=u.depth),u&&u.isUnclosed&&(a.isUnclosed=u.isUnclosed),s&&a.identifier&&(a.isProperty=s),a.check=e.check,a}.bind(this);for(;;){if(!this.input.length)return this.nextLine()?i("(endline)",""):this.exhausted?null:(this.exhausted=!0,i("(end)",""));t=this.next(e);if(!t){this.input.length&&(this.trigger("error",{code:"E024",line:this.line,character:this.char,data:[this.peek()]}),this.input="");continue}switch(t.type){case l.StringLiteral:return this.triggerAsync("String",{line:this.line,"char":this.char,from:this.from,startLine:t.startLine,startChar:t.startChar,value:t.value,quote:t.quote},e,function(){return!0}),i("(string)",t.value,null,t);case l.TemplateHead:return this.trigger("TemplateHead",{line:this.line,"char":this.char,from:this.from,startLine:t.startLine,startChar:t.startChar,value:t.value}),i("(template)",t.value,null,t);case l.TemplateMiddle:return this.trigger("TemplateMiddle",{line:this.line,"char":this.char,from:this.from,startLine:t.startLine,startChar:t.startChar,value:t.value}),i("(template middle)",t.value,null,t);case l.TemplateTail:return this.trigger("TemplateTail",{line:this.line,"char":this.char,from:this.from,startLine:t.startLine,startChar:t.startChar,value:t.value}),i("(template tail)",t.value,null,t);case l.NoSubstTemplate:return this.trigger("NoSubstTemplate",{line:this.line,"char":this.char,from:this.from,startLine:t.startLine,startChar:t.startChar,value:t.value}),i("(no subst template)",t.value,null,t);case l.Identifier:this.triggerAsync("Identifier",{line:this.line,"char":this.char,from:this.form,name:t.value,raw_name:t.text,isProperty:o.tokens.curr.id==="."},e,function(){return!0});case l.Keyword:case l.NullLiteral:case l.BooleanLiteral:return i("(identifier)",t.value,o.tokens.curr.id===".",t);case l.NumericLiteral:return t.isMalformed&&this.trigger("warning",{code:"W045",line:this.line,character:this.char,data:[t.value]}),this.triggerAsync("warning",{code:"W114",line:this.line,character:this.char,data:["0x-"]},e,function(){return t.base===16&&o.jsonMode}),this.triggerAsync("warning",{code:"W115",line:this.line,character:this.char},e,function(){return o.isStrict()&&t.base===8&&t.isLegacy}),this.trigger("Number",{line:this.line,"char":this.char,from:this.from,value:t.value,base:t.base,isMalformed:t.malformed}),i("(number)",t.value);case l.RegExp:return i("(regexp)",t.value);case l.Comment:o.tokens.curr.comment=!0;if(t.isSpecial)return{id:"(comment)",value:t.value,body:t.body,type:t.commentType,isSpecial:t.isSpecial,line:this.line,character:this.char,from:this.from};break;case"":break;default:return i("(punctuator)",t.value)}}}},n.Lexer=p,n.Context=c},{"../data/ascii-identifier-data.js":"/node_modules/jshint/data/ascii-identifier-data.js","../lodash":"/node_modules/jshint/lodash.js","./reg.js":"/node_modules/jshint/src/reg.js","./state.js":"/node_modules/jshint/src/state.js",events:"/node_modules/browserify/node_modules/events/events.js"}],"/node_modules/jshint/src/messages.js":[function(e,t,n){"use strict";var r=e("../lodash"),i={E001:"Bad option: '{a}'.",E002:"Bad option value.",E003:"Expected a JSON value.",E004:"Input is neither a string nor an array of strings.",E005:"Input is empty.",E006:"Unexpected early end of program.",E007:'Missing "use strict" statement.',E008:"Strict violation.",E009:"Option 'validthis' can't be used in a global scope.",E010:"'with' is not allowed in strict mode.",E011:"'{a}' has already been declared.",E012:"const '{a}' is initialized to 'undefined'.",E013:"Attempting to override '{a}' which is a constant.",E014:"A regular expression literal can be confused with '/='.",E015:"Unclosed regular expression.",E016:"Invalid regular expression.",E017:"Unclosed comment.",E018:"Unbegun comment.",E019:"Unmatched '{a}'.",E020:"Expected '{a}' to match '{b}' from line {c} and instead saw '{d}'.",E021:"Expected '{a}' and instead saw '{b}'.",E022:"Line breaking error '{a}'.",E023:"Missing '{a}'.",E024:"Unexpected '{a}'.",E025:"Missing ':' on a case clause.",E026:"Missing '}' to match '{' from line {a}.",E027:"Missing ']' to match '[' from line {a}.",E028:"Illegal comma.",E029:"Unclosed string.",E030:"Expected an identifier and instead saw '{a}'.",E031:"Bad assignment.",E032:"Expected a small integer or 'false' and instead saw '{a}'.",E033:"Expected an operator and instead saw '{a}'.",E034:"get/set are ES5 features.",E035:"Missing property name.",E036:"Expected to see a statement and instead saw a block.",E037:null,E038:null,E039:"Function declarations are not invocable. Wrap the whole function invocation in parens.",E040:"Each value should have its own case label.",E041:"Unrecoverable syntax error.",E042:"Stopping.",E043:"Too many errors.",E044:null,E045:"Invalid for each loop.",E046:"A yield statement shall be within a generator function (with syntax: `function*`)",E047:null,E048:"{a} declaration not directly within block.",E049:"A {a} cannot be named '{b}'.",E050:"Mozilla requires the yield expression to be parenthesized here.",E051:null,E052:"Unclosed template literal.",E053:"Export declaration must be in global scope.",E054:"Class properties must be methods. Expected '(' but instead saw '{a}'.",E055:"The '{a}' option cannot be set after any executable code.",E056:"'{a}' was used before it was declared, which is illegal for '{b}' variables.",E057:"Invalid meta property: '{a}.{b}'.",E058:"Missing semicolon."},s={W001:"'hasOwnProperty' is a really bad name.",W002:"Value of '{a}' may be overwritten in IE 8 and earlier.",W003:"'{a}' was used before it was defined.",W004:"'{a}' is already defined.",W005:"A dot following a number can be confused with a decimal point.",W006:"Confusing minuses.",W007:"Confusing plusses.",W008:"A leading decimal point can be confused with a dot: '{a}'.",W009:"The array literal notation [] is preferable.",W010:"The object literal notation {} is preferable.",W011:null,W012:null,W013:null,W014:"Bad line breaking before '{a}'.",W015:null,W016:"Unexpected use of '{a}'.",W017:"Bad operand.",W018:"Confusing use of '{a}'.",W019:"Use the isNaN function to compare with NaN.",W020:"Read only.",W021:"Reassignment of '{a}', which is is a {b}. Use 'var' or 'let' to declare bindings that may change.",W022:"Do not assign to the exception parameter.",W023:"Expected an identifier in an assignment and instead saw a function invocation.",W024:"Expected an identifier and instead saw '{a}' (a reserved word).",W025:"Missing name in function declaration.",W026:"Inner functions should be listed at the top of the outer function.",W027:"Unreachable '{a}' after '{b}'.",W028:"Label '{a}' on {b} statement.",W030:"Expected an assignment or function call and instead saw an expression.",W031:"Do not use 'new' for side effects.",W032:"Unnecessary semicolon.",W033:"Missing semicolon.",W034:'Unnecessary directive "{a}".',W035:"Empty block.",W036:"Unexpected /*member '{a}'.",W037:"'{a}' is a statement label.",W038:"'{a}' used out of scope.",W039:"'{a}' is not allowed.",W040:"Possible strict violation.",W041:"Use '{a}' to compare with '{b}'.",W042:"Avoid EOL escaping.",W043:"Bad escaping of EOL. Use option multistr if needed.",W044:"Bad or unnecessary escaping.",W045:"Bad number '{a}'.",W046:"Don't use extra leading zeros '{a}'.",W047:"A trailing decimal point can be confused with a dot: '{a}'.",W048:"Unexpected control character in regular expression.",W049:"Unexpected escaped character '{a}' in regular expression.",W050:"JavaScript URL.",W051:"Variables should not be deleted.",W052:"Unexpected '{a}'.",W053:"Do not use {a} as a constructor.",W054:"The Function constructor is a form of eval.",W055:"A constructor name should start with an uppercase letter.",W056:"Bad constructor.",W057:"Weird construction. Is 'new' necessary?",W058:"Missing '()' invoking a constructor.",W059:"Avoid arguments.{a}.",W060:"document.write can be a form of eval.",W061:"eval can be harmful.",W062:"Wrap an immediate function invocation in parens to assist the reader in understanding that the expression is the result of a function, and not the function itself.",W063:"Math is not a function.",W064:"Missing 'new' prefix when invoking a constructor.",W065:"Missing radix parameter.",W066:"Implied eval. Consider passing a function instead of a string.",W067:"Bad invocation.",W068:"Wrapping non-IIFE function literals in parens is unnecessary.",W069:"['{a}'] is better written in dot notation.",W070:"Extra comma. (it breaks older versions of IE)",W071:"This function has too many statements. ({a})",W072:"This function has too many parameters. ({a})",W073:"Blocks are nested too deeply. ({a})",W074:"This function's cyclomatic complexity is too high. ({a})",W075:"Duplicate {a} '{b}'.",W076:"Unexpected parameter '{a}' in get {b} function.",W077:"Expected a single parameter in set {a} function.",W078:"Setter is defined without getter.",W079:"Redefinition of '{a}'.",W080:"It's not necessary to initialize '{a}' to 'undefined'.",W081:null,W082:"Function declarations should not be placed in blocks. Use a function expression or move the statement to the top of the outer function.",W083:"Don't make functions within a loop.",W084:"Assignment in conditional expression",W085:"Don't use 'with'.",W086:"Expected a 'break' statement before '{a}'.",W087:"Forgotten 'debugger' statement?",W088:"Creating global 'for' variable. Should be 'for (var {a} ...'.",W089:"The body of a for in should be wrapped in an if statement to filter unwanted properties from the prototype.",W090:"'{a}' is not a statement label.",W091:null,W093:"Did you mean to return a conditional instead of an assignment?",W094:"Unexpected comma.",W095:"Expected a string and instead saw {a}.",W096:"The '{a}' key may produce unexpected results.",W097:'Use the function form of "use strict".',W098:"'{a}' is defined but never used.",W099:null,W100:"This character may get silently deleted by one or more browsers.",W101:"Line is too long.",W102:null,W103:"The '{a}' property is deprecated.",W104:"'{a}' is available in ES{b} (use 'esversion: {b}') or Mozilla JS extensions (use moz).",W105:"Unexpected {a} in '{b}'.",W106:"Identifier '{a}' is not in camel case.",W107:"Script URL.",W108:"Strings must use doublequote.",W109:"Strings must use singlequote.",W110:"Mixed double and single quotes.",W112:"Unclosed string.",W113:"Control character in string: {a}.",W114:"Avoid {a}.",W115:"Octal literals are not allowed in strict mode.",W116:"Expected '{a}' and instead saw '{b}'.",W117:"'{a}' is not defined.",W118:"'{a}' is only available in Mozilla JavaScript extensions (use moz option).",W119:"'{a}' is only available in ES{b} (use 'esversion: {b}').",W120:"You might be leaking a variable ({a}) here.",W121:"Extending prototype of native object: '{a}'.",W122:"Invalid typeof value '{a}'",W123:"'{a}' is already defined in outer scope.",W124:"A generator function shall contain a yield statement.",W125:"This line contains non-breaking spaces: http://jshint.com/doc/options/#nonbsp",W126:"Unnecessary grouping operator.",W127:"Unexpected use of a comma operator.",W128:"Empty array elements require elision=true.",W129:"'{a}' is defined in a future version of JavaScript. Use a different variable name to avoid migration issues.",W130:"Invalid element after rest element.",W131:"Invalid parameter after rest parameter.",W132:"`var` declarations are forbidden. Use `let` or `const` instead.",W133:"Invalid for-{a} loop left-hand-side: {b}.",W134:"The '{a}' option is only available when linting ECMAScript {b} code.",W135:"{a} may not be supported by non-browser environments.",W136:"'{a}' must be in function scope.",W137:"Empty destructuring.",W138:"Regular parameters should not come after default parameters."},o={I001:"Comma warnings can be turned off with 'laxcomma'.",I002:null,I003:"ES5 option is now set per default"};n.errors={},n.warnings={},n.info={},r.each(i,function(e,t){n.errors[t]={code:t,desc:e}}),r.each(s,function(e,t){n.warnings[t]={code:t,desc:e}}),r.each(o,function(e,t){n.info[t]={code:t,desc:e}})},{"../lodash":"/node_modules/jshint/lodash.js"}],"/node_modules/jshint/src/name-stack.js":[function(e,t,n){"use strict";function r(){this._stack=[]}Object.defineProperty(r.prototype,"length",{get:function(){return this._stack.length}}),r.prototype.push=function(){this._stack.push(null)},r.prototype.pop=function(){this._stack.pop()},r.prototype.set=function(e){this._stack[this.length-1]=e},r.prototype.infer=function(){var e=this._stack[this.length-1],t="",n;if(!e||e.type==="class")e=this._stack[this.length-2];return e?(n=e.type,n!=="(string)"&&n!=="(number)"&&n!=="(identifier)"&&n!=="default"?"(expression)":(e.accessorType&&(t=e.accessorType+" "),t+e.value)):"(empty)"},t.exports=r},{}],"/node_modules/jshint/src/options.js":[function(e,t,n){"use strict";n.bool={enforcing:{bitwise:!0,freeze:!0,camelcase:!0,curly:!0,eqeqeq:!0,futurehostile:!0,notypeof:!0,es3:!0,es5:!0,forin:!0,funcscope:!0,immed:!0,iterator:!0,newcap:!0,noarg:!0,nocomma:!0,noempty:!0,nonbsp:!0,nonew:!0,undef:!0,singleGroups:!1,varstmt:!1,enforceall:!1},relaxing:{asi:!0,multistr:!0,debug:!0,boss:!0,evil:!0,globalstrict:!0,plusplus:!0,proto:!0,scripturl:!0,sub:!0,supernew:!0,laxbreak:!0,laxcomma:!0,validthis:!0,withstmt:!0,moz:!0,noyield:!0,eqnull:!0,lastsemic:!0,loopfunc:!0,expr:!0,esnext:!0,elision:!0},environments:{mootools:!0,couch:!0,jasmine:!0,jquery:!0,node:!0,qunit:!0,rhino:!0,shelljs:!0,prototypejs:!0,yui:!0,mocha:!0,module:!0,wsh:!0,worker:!0,nonstandard:!0,browser:!0,browserify:!0,devel:!0,dojo:!0,typed:!0,phantom:!0},obsolete:{onecase:!0,regexp:!0,regexdash:!0}},n.val={maxlen:!1,indent:!1,maxerr:!1,predef:!1,globals:!1,quotmark:!1,scope:!1,maxstatements:!1,maxdepth:!1,maxparams:!1,maxcomplexity:!1,shadow:!1,strict:!0,unused:!0,latedef:!1,ignore:!1,ignoreDelimiters:!1,esversion:5},n.inverted={bitwise:!0,forin:!0,newcap:!0,plusplus:!0,regexp:!0,undef:!0,eqeqeq:!0,strict:!0},n.validNames=Object.keys(n.val).concat(Object.keys(n.bool.relaxing)).concat(Object.keys(n.bool.enforcing)).concat(Object.keys(n.bool.obsolete)).concat(Object.keys(n.bool.environments)),n.renamed={eqeq:"eqeqeq",windows:"wsh",sloppy:"strict"},n.removed={nomen:!0,onevar:!0,passfail:!0,white:!0,gcl:!0,smarttabs:!0,trailing:!0},n.noenforceall={varstmt:!0,strict:!0}},{}],"/node_modules/jshint/src/reg.js":[function(e,t,n){"use strict";n.unsafeString=/@cc|<\/?|script|\]\s*\]|<\s*!|&lt/i,n.unsafeChars=/[\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/,n.needEsc=/[\u0000-\u001f&<"\/\\\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/,n.needEscGlobal=/[\u0000-\u001f&<"\/\\\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,n.starSlash=/\*\//,n.identifier=/^([a-zA-Z_$][a-zA-Z0-9_$]*)$/,n.javascriptURL=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\s*:/i,n.fallsThrough=/^\s*falls?\sthrough\s*$/,n.maxlenException=/^(?:(?:\/\/|\/\*|\*) ?)?[^ ]+$/},{}],"/node_modules/jshint/src/scope-manager.js":[function(e,t,n){"use strict";var r=e("../lodash"),i=e("events"),s={},o=function(e,t,n,o){function f(e){u={"(labels)":Object.create(null),"(usages)":Object.create(null),"(breakLabels)":Object.create(null),"(parent)":u,"(type)":e,"(params)":e==="functionparams"||e==="catchparams"?[]:null},a.push(u)}function v(e,t){d.emit("warning",{code:e,token:t,data:r.slice(arguments,2)})}function m(e,t){d.emit("warning",{code:e,token:t,data:r.slice(arguments,2)})}function g(e){u["(usages)"][e]||(u["(usages)"][e]={"(modified)":[],"(reassigned)":[],"(tokens)":[]})}function w(){if(u["(type)"]==="functionparams"){E();return}var e=u["(labels)"];for(var t in e)e[t]&&e[t]["(type)"]!=="exception"&&e[t]["(unused)"]&&b(t,e[t]["(token)"],"var")}function E(){var t=u["(params)"];if(!t)return;var n=t.pop(),r;while(n){var i=u["(labels)"][n];r=y(e.funct["(unusedOption)"]);if(n==="undefined")return;if(i["(unused)"])b(n,i["(token)"],"param",e.funct["(unusedOption)"]);else if(r==="last-param")return;n=t.pop()}}function S(e){for(var t=a.length-1;t>=0;--t){var n=a[t]["(labels)"];if(n[e])return n}}function x(e){for(var t=a.length-1;t>=0;t--){var n=a[t];if(n["(usages)"][e])return n["(usages)"][e];if(n===l)break}return!1}function T(t,n){if(e.option.shadow!=="outer")return;var r=l["(type)"]==="global",i=u["(type)"]==="functionparams",s=!r;for(var o=0;o<a.length;o++){var f=a[o];!i&&a[o+1]===l&&(s=!1),s&&f["(labels)"][t]&&v("W123",n,t),f["(breakLabels)"][t]&&v("W123",n,t)}}function N(t,n,r){e.option.latedef&&(e.option.latedef===!0&&t==="function"||t!=="function")&&v("W003",r,n)}var u,a=[];f("global"),u["(predefined)"]=t;var l=u,c=Object.create(null),h=Object.create(null),p=[],d=new i.EventEmitter,y=function(t){return t===undefined&&(t=e.option.unused),t===!0&&(t="last-param"),t},b=function(e,t,n,r){var i=t.line,s=t.from,o=t.raw_text||e;r=y(r);var u={vars:["var"],"last-param":["var","param"],strict:["var","param","last-param"]};r&&u[r]&&u[r].indexOf(n)!==-1&&v("W098",{line:i,from:s},o),(r||n==="var")&&p.push({name:e,line:i,character:s})},C={on:function(e,t){e.split(" ").forEach(function(e){d.on(e,t)})},isPredefined:function(e){return!this.has(e)&&r.has(a[0]["(predefined)"],e)},stack:function(e){var t=u;f(e),!e&&t["(type)"]==="functionparams"&&(u["(isFuncBody)"]=!0,u["(context)"]=l,l=u)},unstack:function(){var t=a.length>1?a[a.length-2]:null,n=u===l,i=u["(type)"]==="functionparams",f=u["(type)"]==="functionouter",p,d,g=u["(usages)"],y=u["(labels)"],E=Object.keys(g);g.__proto__&&E.indexOf("__proto__")===-1&&E.push("__proto__");for(p=0;p<E.length;p++){var S=E[p],x=g[S],T=y[S];if(T){var N=T["(type)"];if(T["(useOutsideOfScope)"]&&!e.option.funcscope){var C=x["(tokens)"];if(C)for(d=0;d<C.length;d++)T["(function)"]===C[d]["(function)"]&&m("W038",C[d],S)}u["(labels)"][S]["(unused)"]=!1;if(N==="const"&&x["(modified)"])for(d=0;d<x["(modified)"].length;d++)m("E013",x["(modified)"][d],S);if((N==="function"||N==="class")&&x["(reassigned)"])for(d=0;d<x["(reassigned)"].length;d++)m("W021",x["(reassigned)"][d],S,N);continue}f&&(e.funct["(isCapturing)"]=!0);if(t)if(!t["(usages)"][S])t["(usages)"][S]=x,n&&(t["(usages)"][S]["(onlyUsedSubFunction)"]=!0);else{var k=t["(usages)"][S];k["(modified)"]=k["(modified)"].concat(x["(modified)"]),k["(tokens)"]=k["(tokens)"].concat(x["(tokens)"]),k["(reassigned)"]=k["(reassigned)"].concat(x["(reassigned)"]),k["(onlyUsedSubFunction)"]=!1}else if(typeof u["(predefined)"][S]=="boolean"){delete o[S],c[S]=s;if(u["(predefined)"][S]===!1&&x["(reassigned)"])for(d=0;d<x["(reassigned)"].length;d++)v("W020",x["(reassigned)"][d])}else if(x["(tokens)"])for(d=0;d<x["(tokens)"].length;d++){var L=x["(tokens)"][d];L.forgiveUndef||(e.option.undef&&!L.ignoreUndef&&v("W117",L,S),h[S]?h[S].line.push(L.line):h[S]={name:S,line:[L.line]})}}t||Object.keys(o).forEach(function(e){b(e,o[e],"var")});if(t&&!n&&!i&&!f){var A=Object.keys(y);for(p=0;p<A.length;p++){var O=A[p];!y[O]["(blockscoped)"]&&y[O]["(type)"]!=="exception"&&!this.funct.has(O,{excludeCurrent:!0})&&(t["(labels)"][O]=y[O],l["(type)"]!=="global"&&(t["(labels)"][O]["(useOutsideOfScope)"]=!0),delete y[O])}}w(),a.pop(),n&&(l=a[r.findLastIndex(a,function(e){return e["(isFuncBody)"]||e["(type)"]==="global"})]),u=t},addParam:function(t,n,i){i=i||"param";if(i==="exception"){var s=this.funct.labeltype(t);s&&s!=="exception"&&(e.option.node||v("W002",e.tokens.next,t))}r.has(u["(labels)"],t)?u["(labels)"][t].duplicated=!0:(T(t,n,i),u["(labels)"][t]={"(type)":i,"(token)":n,"(unused)":!0},u["(params)"].push(t));if(r.has(u["(usages)"],t)){var o=u["(usages)"][t];o["(onlyUsedSubFunction)"]?N(i,t,n):v("E056",n,t,i)}},validateParams:function(){if(l["(type)"]==="global")return;var t=e.isStrict(),n=l["(parent)"];if(!n["(params)"])return;n["(params)"].forEach(function(r){var i=n["(labels)"][r];i&&i.duplicated&&(t?v("E011",i["(token)"],r):e.option.shadow!==!0&&v("W004",i["(token)"],r))})},getUsedOrDefinedGlobals:function(){var e=Object.keys(c);return c.__proto__===s&&e.indexOf("__proto__")===-1&&e.push("__proto__"),e},getImpliedGlobals:function(){var e=r.values(h),t=!1;return h.__proto__&&(t=e.some(function(e){return e.name==="__proto__"}),t||e.push(h.__proto__)),e},getUnuseds:function(){return p},has:function(e){return Boolean(S(e))},labeltype:function(e){var t=S(e);return t?t[e]["(type)"]:null},addExported:function(e){var t=a[0]["(labels)"];if(r.has(o,e))delete o[e];else if(r.has(t,e))t[e]["(unused)"]=!1;else{for(var i=1;i<a.length;i++){var s=a[i];if(!!s["(type)"])break;if(r.has(s["(labels)"],e)&&!s["(labels)"][e]["(blockscoped)"]){s["(labels)"][e]["(unused)"]=!1;return}}n[e]=!0}},setExported:function(e,t){this.block.use(e,t)},addlabel:function(t,i){var o=i.type,a=i.token,f=o==="let"||o==="const"||o==="class",h=(f?u:l)["(type)"]==="global"&&r.has(n,t);T(t,a,o);if(f){var p=u["(labels)"][t];!p&&u===l&&u["(type)"]!=="global"&&(p=!!l["(parent)"]["(labels)"][t]);if(!p&&u["(usages)"][t]){var d=u["(usages)"][t];d["(onlyUsedSubFunction)"]?N(o,t,a):v("E056",a,t,o)}p?v("E011",a,t):e.option.shadow==="outer"&&C.funct.has(t)&&v("W004",a,t),C.block.add(t,o,a,!h)}else{var m=C.funct.has(t);!m&&x(t)&&N(o,t,a),C.funct.has(t,{onlyBlockscoped:!0})?v("E011",a,t):e.option.shadow!==!0&&m&&t!=="__proto__"&&l["(type)"]!=="global"&&v("W004",a,t),C.funct.add(t,o,a,!h),l["(type)"]==="global"&&(c[t]=s)}},funct:{labeltype:function(e,t){var n=t&&t.onlyBlockscoped,r=t&&t.excludeParams,i=a.length-(t&&t.excludeCurrent?2:1);for(var s=i;s>=0;s--){var o=a[s];if(o["(labels)"][e]&&(!n||o["(labels)"][e]["(blockscoped)"]))return o["(labels)"][e]["(type)"];var u=r?a[s-1]:o;if(u&&u["(type)"]==="functionparams")return null}return null},hasBreakLabel:function(e){for(var t=a.length-1;t>=0;t--){var n=a[t];if(n["(breakLabels)"][e])return!0;if(n["(type)"]==="functionparams")return!1}return!1},has:function(e,t){return Boolean(this.labeltype(e,t))},add:function(e,t,n,r){u["(labels)"][e]={"(type)":t,"(token)":n,"(blockscoped)":!1,"(function)":l,"(unused)":r}}},block:{isGlobal:function(){return u["(type)"]==="global"},use:function(t,n){var r=l["(parent)"];r&&r["(labels)"][t]&&r["(labels)"][t]["(type)"]==="param"&&(C.funct.has(t,{excludeParams:!0,onlyBlockscoped:!0})||(r["(labels)"][t]["(unused)"]=!1)),n&&(e.ignored.W117||e.option.undef===!1)&&(n.ignoreUndef=!0),g(t),n&&(n["(function)"]=l,u["(usages)"][t]["(tokens)"].push(n))},reassign:function(e,t){this.modify(e,t),u["(usages)"][e]["(reassigned)"].push(t)},modify:function(e,t){g(e),u["(usages)"][e]["(modified)"].push(t)},add:function(e,t,n,r){u["(labels)"][e]={"(type)":t,"(token)":n,"(blockscoped)":!0,"(unused)":r}},addBreakLabel:function(t,n){var r=n.token;C.funct.hasBreakLabel(t)?v("E011",r,t):e.option.shadow==="outer"&&(C.funct.has(t)?v("W004",r,t):T(t,r)),u["(breakLabels)"][t]=r}}};return C};t.exports=o},{"../lodash":"/node_modules/jshint/lodash.js",events:"/node_modules/browserify/node_modules/events/events.js"}],"/node_modules/jshint/src/state.js":[function(e,t,n){"use strict";var r=e("./name-stack.js"),i={syntax:{},isStrict:function(){return this.directive["use strict"]||this.inClassBody||this.option.module||this.option.strict==="implied"},inMoz:function(){return this.option.moz},inES6:function(){return this.option.moz||this.option.esversion>=6},inES5:function(e){return e?(!this.option.esversion||this.option.esversion===5)&&!this.option.moz:!this.option.esversion||this.option.esversion>=5||this.option.moz},reset:function(){this.tokens={prev:null,next:null,curr:null},this.option={},this.funct=null,this.ignored={},this.directive={},this.jsonMode=!1,this.jsonWarnings=[],this.lines=[],this.tab="",this.cache={},this.ignoredLines={},this.forinifcheckneeded=!1,this.nameStack=new r,this.inClassBody=!1}};n.state=i},{"./name-stack.js":"/node_modules/jshint/src/name-stack.js"}],"/node_modules/jshint/src/style.js":[function(e,t,n){"use strict";n.register=function(e){e.on("Identifier",function(n){if(e.getOption("proto"))return;n.name==="__proto__"&&e.warn("W103",{line:n.line,"char":n.char,data:[n.name,"6"]})}),e.on("Identifier",function(n){if(e.getOption("iterator"))return;n.name==="__iterator__"&&e.warn("W103",{line:n.line,"char":n.char,data:[n.name]})}),e.on("Identifier",function(n){if(!e.getOption("camelcase"))return;n.name.replace(/^_+|_+$/g,"").indexOf("_")>-1&&!n.name.match(/^[A-Z0-9_]*$/)&&e.warn("W106",{line:n.line,"char":n.from,data:[n.name]})}),e.on("String",function(n){var r=e.getOption("quotmark"),i;if(!r)return;r==="single"&&n.quote!=="'"&&(i="W109"),r==="double"&&n.quote!=='"'&&(i="W108"),r===!0&&(e.getCache("quotmark")||e.setCache("quotmark",n.quote),e.getCache("quotmark")!==n.quote&&(i="W110")),i&&e.warn(i,{line:n.line,"char":n.char})}),e.on("Number",function(n){n.value.charAt(0)==="."&&e.warn("W008",{line:n.line,"char":n.char,data:[n.value]}),n.value.substr(n.value.length-1)==="."&&e.warn("W047",{line:n.line,"char":n.char,data:[n.value]}),/^00+/.test(n.value)&&e.warn("W046",{line:n.line,"char":n.char,data:[n.value]})}),e.on("String",function(n){var r=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\s*:/i;if(e.getOption("scripturl"))return;r.test(n.value)&&e.warn("W107",{line:n.line,"char":n.char})})}},{}],"/node_modules/jshint/src/vars.js":[function(e,t,n){"use strict";n.reservedVars={arguments:!1,NaN:!1},n.ecmaIdentifiers={3:{Array:!1,Boolean:!1,Date:!1,decodeURI:!1,decodeURIComponent:!1,encodeURI:!1,encodeURIComponent:!1,Error:!1,eval:!1,EvalError:!1,Function:!1,hasOwnProperty:!1,isFinite:!1,isNaN:!1,Math:!1,Number:!1,Object:!1,parseInt:!1,parseFloat:!1,RangeError:!1,ReferenceError:!1,RegExp:!1,String:!1,SyntaxError:!1,TypeError:!1,URIError:!1},5:{JSON:!1},6:{Map:!1,Promise:!1,Proxy:!1,Reflect:!1,Set:!1,Symbol:!1,WeakMap:!1,WeakSet:!1}},n.browser={Audio:!1,Blob:!1,addEventListener:!1,applicationCache:!1,atob:!1,blur:!1,btoa:!1,cancelAnimationFrame:!1,CanvasGradient:!1,CanvasPattern:!1,CanvasRenderingContext2D:!1,CSS:!1,clearInterval:!1,clearTimeout:!1,close:!1,closed:!1,Comment:!1,CustomEvent:!1,DOMParser:!1,defaultStatus:!1,Document:!1,document:!1,DocumentFragment:!1,Element:!1,ElementTimeControl:!1,Event:!1,event:!1,fetch:!1,FileReader:!1,FormData:!1,focus:!1,frames:!1,getComputedStyle:!1,HTMLElement:!1,HTMLAnchorElement:!1,HTMLBaseElement:!1,HTMLBlockquoteElement:!1,HTMLBodyElement:!1,HTMLBRElement:!1,HTMLButtonElement:!1,HTMLCanvasElement:!1,HTMLCollection:!1,HTMLDirectoryElement:!1,HTMLDivElement:!1,HTMLDListElement:!1,HTMLFieldSetElement:!1,HTMLFontElement:!1,HTMLFormElement:!1,HTMLFrameElement:!1,HTMLFrameSetElement:!1,HTMLHeadElement:!1,HTMLHeadingElement:!1,HTMLHRElement:!1,HTMLHtmlElement:!1,HTMLIFrameElement:!1,HTMLImageElement:!1,HTMLInputElement:!1,HTMLIsIndexElement:!1,HTMLLabelElement:!1,HTMLLayerElement:!1,HTMLLegendElement:!1,HTMLLIElement:!1,HTMLLinkElement:!1,HTMLMapElement:!1,HTMLMenuElement:!1,HTMLMetaElement:!1,HTMLModElement:!1,HTMLObjectElement:!1,HTMLOListElement:!1,HTMLOptGroupElement:!1,HTMLOptionElement:!1,HTMLParagraphElement:!1,HTMLParamElement:!1,HTMLPreElement:!1,HTMLQuoteElement:!1,HTMLScriptElement:!1,HTMLSelectElement:!1,HTMLStyleElement:!1,HTMLTableCaptionElement:!1,HTMLTableCellElement:!1,HTMLTableColElement:!1,HTMLTableElement:!1,HTMLTableRowElement:!1,HTMLTableSectionElement:!1,HTMLTemplateElement:!1,HTMLTextAreaElement:!1,HTMLTitleElement:!1,HTMLUListElement:!1,HTMLVideoElement:!1,history:!1,Image:!1,Intl:!1,length:!1,localStorage:!1,location:!1,matchMedia:!1,MessageChannel:!1,MessageEvent:!1,MessagePort:!1,MouseEvent:!1,moveBy:!1,moveTo:!1,MutationObserver:!1,name:!1,Node:!1,NodeFilter:!1,NodeList:!1,Notification:!1,navigator:!1,onbeforeunload:!0,onblur:!0,onerror:!0,onfocus:!0,onload:!0,onresize:!0,onunload:!0,open:!1,openDatabase:!1,opener:!1,Option:!1,parent:!1,performance:!1,print:!1,Range:!1,requestAnimationFrame:!1,removeEventListener:!1,resizeBy:!1,resizeTo:!1,screen:!1,scroll:!1,scrollBy:!1,scrollTo:!1,sessionStorage:!1,setInterval:!1,setTimeout:!1,SharedWorker:!1,status:!1,SVGAElement:!1,SVGAltGlyphDefElement:!1,SVGAltGlyphElement:!1,SVGAltGlyphItemElement:!1,SVGAngle:!1,SVGAnimateColorElement:!1,SVGAnimateElement:!1,SVGAnimateMotionElement:!1,SVGAnimateTransformElement:!1,SVGAnimatedAngle:!1,SVGAnimatedBoolean:!1,SVGAnimatedEnumeration:!1,SVGAnimatedInteger:!1,SVGAnimatedLength:!1,SVGAnimatedLengthList:!1,SVGAnimatedNumber:!1,SVGAnimatedNumberList:!1,SVGAnimatedPathData:!1,SVGAnimatedPoints:!1,SVGAnimatedPreserveAspectRatio:!1,SVGAnimatedRect:!1,SVGAnimatedString:!1,SVGAnimatedTransformList:!1,SVGAnimationElement:!1,SVGCSSRule:!1,SVGCircleElement:!1,SVGClipPathElement:!1,SVGColor:!1,SVGColorProfileElement:!1,SVGColorProfileRule:!1,SVGComponentTransferFunctionElement:!1,SVGCursorElement:!1,SVGDefsElement:!1,SVGDescElement:!1,SVGDocument:!1,SVGElement:!1,SVGElementInstance:!1,SVGElementInstanceList:!1,SVGEllipseElement:!1,SVGExternalResourcesRequired:!1,SVGFEBlendElement:!1,SVGFEColorMatrixElement:!1,SVGFEComponentTransferElement:!1,SVGFECompositeElement:!1,SVGFEConvolveMatrixElement:!1,SVGFEDiffuseLightingElement:!1,SVGFEDisplacementMapElement:!1,SVGFEDistantLightElement:!1,SVGFEFloodElement:!1,SVGFEFuncAElement:!1,SVGFEFuncBElement:!1,SVGFEFuncGElement:!1,SVGFEFuncRElement:!1,SVGFEGaussianBlurElement:!1,SVGFEImageElement:!1,SVGFEMergeElement:!1,SVGFEMergeNodeElement:!1,SVGFEMorphologyElement:!1,SVGFEOffsetElement:!1,SVGFEPointLightElement:!1,SVGFESpecularLightingElement:!1,SVGFESpotLightElement:!1,SVGFETileElement:!1,SVGFETurbulenceElement:!1,SVGFilterElement:!1,SVGFilterPrimitiveStandardAttributes:!1,SVGFitToViewBox:!1,SVGFontElement:!1,SVGFontFaceElement:!1,SVGFontFaceFormatElement:!1,SVGFontFaceNameElement:!1,SVGFontFaceSrcElement:!1,SVGFontFaceUriElement:!1,SVGForeignObjectElement:!1,SVGGElement:!1,SVGGlyphElement:!1,SVGGlyphRefElement:!1,SVGGradientElement:!1,SVGHKernElement:!1,SVGICCColor:!1,SVGImageElement:!1,SVGLangSpace:!1,SVGLength:!1,SVGLengthList:!1,SVGLineElement:!1,SVGLinearGradientElement:!1,SVGLocatable:!1,SVGMPathElement:!1,SVGMarkerElement:!1,SVGMaskElement:!1,SVGMatrix:!1,SVGMetadataElement:!1,SVGMissingGlyphElement:!1,SVGNumber:!1,SVGNumberList:!1,SVGPaint:!1,SVGPathElement:!1,SVGPathSeg:!1,SVGPathSegArcAbs:!1,SVGPathSegArcRel:!1,SVGPathSegClosePath:!1,SVGPathSegCurvetoCubicAbs:!1,SVGPathSegCurvetoCubicRel:!1,SVGPathSegCurvetoCubicSmoothAbs:!1,SVGPathSegCurvetoCubicSmoothRel:!1,SVGPathSegCurvetoQuadraticAbs:!1,SVGPathSegCurvetoQuadraticRel:!1,SVGPathSegCurvetoQuadraticSmoothAbs:!1,SVGPathSegCurvetoQuadraticSmoothRel:!1,SVGPathSegLinetoAbs:!1,SVGPathSegLinetoHorizontalAbs:!1,SVGPathSegLinetoHorizontalRel:!1,SVGPathSegLinetoRel:!1,SVGPathSegLinetoVerticalAbs:!1,SVGPathSegLinetoVerticalRel:!1,SVGPathSegList:!1,SVGPathSegMovetoAbs:!1,SVGPathSegMovetoRel:!1,SVGPatternElement:!1,SVGPoint:!1,SVGPointList:!1,SVGPolygonElement:!1,SVGPolylineElement:!1,SVGPreserveAspectRatio:!1,SVGRadialGradientElement:!1,SVGRect:!1,SVGRectElement:!1,SVGRenderingIntent:!1,SVGSVGElement:!1,SVGScriptElement:!1,SVGSetElement:!1,SVGStopElement:!1,SVGStringList:!1,SVGStylable:!1,SVGStyleElement:!1,SVGSwitchElement:!1,SVGSymbolElement:!1,SVGTRefElement:!1,SVGTSpanElement:!1,SVGTests:!1,SVGTextContentElement:!1,SVGTextElement:!1,SVGTextPathElement:!1,SVGTextPositioningElement:!1,SVGTitleElement:!1,SVGTransform:!1,SVGTransformList:!1,SVGTransformable:!1,SVGURIReference:!1,SVGUnitTypes:!1,SVGUseElement:!1,SVGVKernElement:!1,SVGViewElement:!1,SVGViewSpec:!1,SVGZoomAndPan:!1,Text:!1,TextDecoder:!1,TextEncoder:!1,TimeEvent:!1,top:!1,URL:!1,WebGLActiveInfo:!1,WebGLBuffer:!1,WebGLContextEvent:!1,WebGLFramebuffer:!1,WebGLProgram:!1,WebGLRenderbuffer:!1,WebGLRenderingContext:!1,WebGLShader:!1,WebGLShaderPrecisionFormat:!1,WebGLTexture:!1,WebGLUniformLocation:!1,WebSocket:!1,window:!1,Window:!1,Worker:!1,XDomainRequest:!1,XMLHttpRequest:!1,XMLSerializer:!1,XPathEvaluator:!1,XPathException:!1,XPathExpression:!1,XPathNamespace:!1,XPathNSResolver:!1,XPathResult:!1},n.devel={alert:!1,confirm:!1,console:!1,Debug:!1,opera:!1,prompt:!1},n.worker={importScripts:!0,postMessage:!0,self:!0,FileReaderSync:!0},n.nonstandard={escape:!1,unescape:!1},n.couch={require:!1,respond:!1,getRow:!1,emit:!1,send:!1,start:!1,sum:!1,log:!1,exports:!1,module:!1,provides:!1},n.node={__filename:!1,__dirname:!1,GLOBAL:!1,global:!1,module:!1,require:!1,Buffer:!0,console:!0,exports:!0,process:!0,setTimeout:!0,clearTimeout:!0,setInterval:!0,clearInterval:!0,setImmediate:!0,clearImmediate:!0},n.browserify={__filename:!1,__dirname:!1,global:!1,module:!1,require:!1,Buffer:!0,exports:!0,process:!0},n.phantom={phantom:!0,require:!0,WebPage:!0,console:!0,exports:!0},n.qunit={asyncTest:!1,deepEqual:!1,equal:!1,expect:!1,module:!1,notDeepEqual:!1,notEqual:!1,notPropEqual:!1,notStrictEqual:!1,ok:!1,propEqual:!1,QUnit:!1,raises:!1,start:!1,stop:!1,strictEqual:!1,test:!1,"throws":!1},n.rhino={defineClass:!1,deserialize:!1,gc:!1,help:!1,importClass:!1,importPackage:!1,java:!1,load:!1,loadClass:!1,Packages:!1,print:!1,quit:!1,readFile:!1,readUrl:!1,runCommand:!1,seal:!1,serialize:!1,spawn:!1,sync:!1,toint32:!1,version:!1},n.shelljs={target:!1,echo:!1,exit:!1,cd:!1,pwd:!1,ls:!1,find:!1,cp:!1,rm:!1,mv:!1,mkdir:!1,test:!1,cat:!1,sed:!1,grep:!1,which:!1,dirs:!1,pushd:!1,popd:!1,env:!1,exec:!1,chmod:!1,config:!1,error:!1,tempdir:!1},n.typed={ArrayBuffer:!1,ArrayBufferView:!1,DataView:!1,Float32Array:!1,Float64Array:!1,Int16Array:!1,Int32Array:!1,Int8Array:!1,Uint16Array:!1,Uint32Array:!1,Uint8Array:!1,Uint8ClampedArray:!1},n.wsh={ActiveXObject:!0,Enumerator:!0,GetObject:!0,ScriptEngine:!0,ScriptEngineBuildVersion:!0,ScriptEngineMajorVersion:!0,ScriptEngineMinorVersion:!0,VBArray:!0,WSH:!0,WScript:!0,XDomainRequest:!0},n.dojo={dojo:!1,dijit:!1,dojox:!1,define:!1,require:!1},n.jquery={$:!1,jQuery:!1},n.mootools={$:!1,$$:!1,Asset:!1,Browser:!1,Chain:!1,Class:!1,Color:!1,Cookie:!1,Core:!1,Document:!1,DomReady:!1,DOMEvent:!1,DOMReady:!1,Drag:!1,Element:!1,Elements:!1,Event:!1,Events:!1,Fx:!1,Group:!1,Hash:!1,HtmlTable:!1,IFrame:!1,IframeShim:!1,InputValidator:!1,instanceOf:!1,Keyboard:!1,Locale:!1,Mask:!1,MooTools:!1,Native:!1,Options:!1,OverText:!1,Request:!1,Scroller:!1,Slick:!1,Slider:!1,Sortables:!1,Spinner:!1,Swiff:!1,Tips:!1,Type:!1,typeOf:!1,URI:!1,Window:!1},n.prototypejs={$:!1,$$:!1,$A:!1,$F:!1,$H:!1,$R:!1,$break:!1,$continue:!1,$w:!1,Abstract:!1,Ajax:!1,Class:!1,Enumerable:!1,Element:!1,Event:!1,Field:!1,Form:!1,Hash:!1,Insertion:!1,ObjectRange:!1,PeriodicalExecuter:!1,Position:!1,Prototype:!1,Selector:!1,Template:!1,Toggle:!1,Try:!1,Autocompleter:!1,Builder:!1,Control:!1,Draggable:!1,Draggables:!1,Droppables:!1,Effect:!1,Sortable:!1,SortableObserver:!1,Sound:!1,Scriptaculous:!1},n.yui={YUI:!1,Y:!1,YUI_config:!1},n.mocha={mocha:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,context:!1,xcontext:!1,before:!1,after:!1,beforeEach:!1,afterEach:!1,suite:!1,test:!1,setup:!1,teardown:!1,suiteSetup:!1,suiteTeardown:!1},n.jasmine={jasmine:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,beforeEach:!1,afterEach:!1,setFixtures:!1,loadFixtures:!1,spyOn:!1,expect:!1,runs:!1,waitsFor:!1,waits:!1,beforeAll:!1,afterAll:!1,fail:!1,fdescribe:!1,fit:!1,pending:!1}},{}]},{},["/node_modules/jshint/src/jshint.js"])}),ace.define("ace/mode/javascript_worker",["require","exports","module","ace/lib/oop","ace/worker/mirror","ace/mode/javascript/jshint"],function(require,exports,module){"use strict";function startRegex(e){return RegExp("^("+e.join("|")+")")}var oop=require("../lib/oop"),Mirror=require("../worker/mirror").Mirror,lint=require("./javascript/jshint").JSHINT,disabledWarningsRe=startRegex(["Bad for in variable '(.+)'.",'Missing "use strict"']),errorsRe=startRegex(["Unexpected","Expected ","Confusing (plus|minus)","\\{a\\} unterminated regular expression","Unclosed ","Unmatched ","Unbegun comment","Bad invocation","Missing space after","Missing operator at"]),infoRe=startRegex(["Expected an assignment","Bad escapement of EOL","Unexpected comma","Unexpected space","Missing radix parameter.","A leading decimal point can","\\['{a}'\\] is better written in dot notation.","'{a}' used out of scope"]),JavaScriptWorker=exports.JavaScriptWorker=function(e){Mirror.call(this,e),this.setTimeout(500),this.setOptions()};oop.inherits(JavaScriptWorker,Mirror),function(){this.setOptions=function(e){this.options=e||{esnext:!0,moz:!0,devel:!0,browser:!0,node:!0,laxcomma:!0,laxbreak:!0,lastsemic:!0,onevar:!1,passfail:!1,maxerr:100,expr:!0,multistr:!0,globalstrict:!0},this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.changeOptions=function(e){oop.mixin(this.options,e),this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.isValidJS=function(str){try{eval("throw 0;"+str)}catch(e){if(e===0)return!0}return!1},this.onUpdate=function(){var e=this.doc.getValue();e=e.replace(/^#!.*\n/,"\n");if(!e)return this.sender.emit("annotate",[]);var t=[],n=this.isValidJS(e)?"warning":"error";lint(e,this.options,this.options.globals);var r=lint.errors,i=!1;for(var s=0;s<r.length;s++){var o=r[s];if(!o)continue;var u=o.raw,a="warning";if(u=="Missing semicolon."){var f=o.evidence.substr(o.character);f=f.charAt(f.search(/\S/)),n=="error"&&f&&/[\w\d{(['"]/.test(f)?(o.reason='Missing ";" before statement',a="error"):a="info"}else{if(disabledWarningsRe.test(u))continue;infoRe.test(u)?a="info":errorsRe.test(u)?(i=!0,a=n):u=="'{a}' is not defined."?a="warning":u=="'{a}' is defined but never used."&&(a="info")}t.push({row:o.line-1,column:o.character-1,text:o.reason,type:a,raw:u}),i}this.sender.emit("annotate",t)}}.call(JavaScriptWorker.prototype)}),ace.define("ace/lib/es5-shim",["require","exports","module"],function(e,t,n){function r(){}function w(e){try{return Object.defineProperty(e,"sentinel",{}),"sentinel"in e}catch(t){}}function H(e){return e=+e,e!==e?e=0:e!==0&&e!==1/0&&e!==-1/0&&(e=(e>0||-1)*Math.floor(Math.abs(e))),e}function B(e){var t=typeof e;return e===null||t==="undefined"||t==="boolean"||t==="number"||t==="string"}function j(e){var t,n,r;if(B(e))return e;n=e.valueOf;if(typeof n=="function"){t=n.call(e);if(B(t))return t}r=e.toString;if(typeof r=="function"){t=r.call(e);if(B(t))return t}throw new TypeError}Function.prototype.bind||(Function.prototype.bind=function(t){var n=this;if(typeof n!="function")throw new TypeError("Function.prototype.bind called on incompatible "+n);var i=u.call(arguments,1),s=function(){if(this instanceof s){var e=n.apply(this,i.concat(u.call(arguments)));return Object(e)===e?e:this}return n.apply(t,i.concat(u.call(arguments)))};return n.prototype&&(r.prototype=n.prototype,s.prototype=new r,r.prototype=null),s});var i=Function.prototype.call,s=Array.prototype,o=Object.prototype,u=s.slice,a=i.bind(o.toString),f=i.bind(o.hasOwnProperty),l,c,h,p,d;if(d=f(o,"__defineGetter__"))l=i.bind(o.__defineGetter__),c=i.bind(o.__defineSetter__),h=i.bind(o.__lookupGetter__),p=i.bind(o.__lookupSetter__);if([1,2].splice(0).length!=2)if(!function(){function e(e){var t=new Array(e+2);return t[0]=t[1]=0,t}var t=[],n;t.splice.apply(t,e(20)),t.splice.apply(t,e(26)),n=t.length,t.splice(5,0,"XXX"),n+1==t.length;if(n+1==t.length)return!0}())Array.prototype.splice=function(e,t){var n=this.length;e>0?e>n&&(e=n):e==void 0?e=0:e<0&&(e=Math.max(n+e,0)),e+t<n||(t=n-e);var r=this.slice(e,e+t),i=u.call(arguments,2),s=i.length;if(e===n)s&&this.push.apply(this,i);else{var o=Math.min(t,n-e),a=e+o,f=a+s-o,l=n-a,c=n-o;if(f<a)for(var h=0;h<l;++h)this[f+h]=this[a+h];else if(f>a)for(h=l;h--;)this[f+h]=this[a+h];if(s&&e===c)this.length=c,this.push.apply(this,i);else{this.length=c+s;for(h=0;h<s;++h)this[e+h]=i[h]}}return r};else{var v=Array.prototype.splice;Array.prototype.splice=function(e,t){return arguments.length?v.apply(this,[e===void 0?0:e,t===void 0?this.length-e:t].concat(u.call(arguments,2))):[]}}Array.isArray||(Array.isArray=function(t){return a(t)=="[object Array]"});var m=Object("a"),g=m[0]!="a"||!(0 in m);Array.prototype.forEach||(Array.prototype.forEach=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=arguments[1],s=-1,o=r.length>>>0;if(a(t)!="[object Function]")throw new TypeError;while(++s<o)s in r&&t.call(i,r[s],s,n)}),Array.prototype.map||(Array.prototype.map=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0,s=Array(i),o=arguments[1];if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");for(var u=0;u<i;u++)u in r&&(s[u]=t.call(o,r[u],u,n));return s}),Array.prototype.filter||(Array.prototype.filter=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0,s=[],o,u=arguments[1];if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");for(var f=0;f<i;f++)f in r&&(o=r[f],t.call(u,o,f,n)&&s.push(o));return s}),Array.prototype.every||(Array.prototype.every=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0,s=arguments[1];if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");for(var o=0;o<i;o++)if(o in r&&!t.call(s,r[o],o,n))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0,s=arguments[1];if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");for(var o=0;o<i;o++)if(o in r&&t.call(s,r[o],o,n))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0;if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");if(!i&&arguments.length==1)throw new TypeError("reduce of empty array with no initial value");var s=0,o;if(arguments.length>=2)o=arguments[1];else do{if(s in r){o=r[s++];break}if(++s>=i)throw new TypeError("reduce of empty array with no initial value")}while(!0);for(;s<i;s++)s in r&&(o=t.call(void 0,o,r[s],s,n));return o}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0;if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");if(!i&&arguments.length==1)throw new TypeError("reduceRight of empty array with no initial value");var s,o=i-1;if(arguments.length>=2)s=arguments[1];else do{if(o in r){s=r[o--];break}if(--o<0)throw new TypeError("reduceRight of empty array with no initial value")}while(!0);do o in this&&(s=t.call(void 0,s,r[o],o,n));while(o--);return s});if(!Array.prototype.indexOf||[0,1].indexOf(1,2)!=-1)Array.prototype.indexOf=function(t){var n=g&&a(this)=="[object String]"?this.split(""):F(this),r=n.length>>>0;if(!r)return-1;var i=0;arguments.length>1&&(i=H(arguments[1])),i=i>=0?i:Math.max(0,r+i);for(;i<r;i++)if(i in n&&n[i]===t)return i;return-1};if(!Array.prototype.lastIndexOf||[0,1].lastIndexOf(0,-3)!=-1)Array.prototype.lastIndexOf=function(t){var n=g&&a(this)=="[object String]"?this.split(""):F(this),r=n.length>>>0;if(!r)return-1;var i=r-1;arguments.length>1&&(i=Math.min(i,H(arguments[1]))),i=i>=0?i:r-Math.abs(i);for(;i>=0;i--)if(i in n&&t===n[i])return i;return-1};Object.getPrototypeOf||(Object.getPrototypeOf=function(t){return t.__proto__||(t.constructor?t.constructor.prototype:o)});if(!Object.getOwnPropertyDescriptor){var y="Object.getOwnPropertyDescriptor called on a non-object: ";Object.getOwnPropertyDescriptor=function(t,n){if(typeof t!="object"&&typeof t!="function"||t===null)throw new TypeError(y+t);if(!f(t,n))return;var r,i,s;r={enumerable:!0,configurable:!0};if(d){var u=t.__proto__;t.__proto__=o;var i=h(t,n),s=p(t,n);t.__proto__=u;if(i||s)return i&&(r.get=i),s&&(r.set=s),r}return r.value=t[n],r}}Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(t){return Object.keys(t)});if(!Object.create){var b;Object.prototype.__proto__===null?b=function(){return{__proto__:null}}:b=function(){var e={};for(var t in e)e[t]=null;return e.constructor=e.hasOwnProperty=e.propertyIsEnumerable=e.isPrototypeOf=e.toLocaleString=e.toString=e.valueOf=e.__proto__=null,e},Object.create=function(t,n){var r;if(t===null)r=b();else{if(typeof t!="object")throw new TypeError("typeof prototype["+typeof t+"] != 'object'");var i=function(){};i.prototype=t,r=new i,r.__proto__=t}return n!==void 0&&Object.defineProperties(r,n),r}}if(Object.defineProperty){var E=w({}),S=typeof document=="undefined"||w(document.createElement("div"));if(!E||!S)var x=Object.defineProperty}if(!Object.defineProperty||x){var T="Property description must be an object: ",N="Object.defineProperty called on non-object: ",C="getters & setters can not be defined on this javascript engine";Object.defineProperty=function(t,n,r){if(typeof t!="object"&&typeof t!="function"||t===null)throw new TypeError(N+t);if(typeof r!="object"&&typeof r!="function"||r===null)throw new TypeError(T+r);if(x)try{return x.call(Object,t,n,r)}catch(i){}if(f(r,"value"))if(d&&(h(t,n)||p(t,n))){var s=t.__proto__;t.__proto__=o,delete t[n],t[n]=r.value,t.__proto__=s}else t[n]=r.value;else{if(!d)throw new TypeError(C);f(r,"get")&&l(t,n,r.get),f(r,"set")&&c(t,n,r.set)}return t}}Object.defineProperties||(Object.defineProperties=function(t,n){for(var r in n)f(n,r)&&Object.defineProperty(t,r,n[r]);return t}),Object.seal||(Object.seal=function(t){return t}),Object.freeze||(Object.freeze=function(t){return t});try{Object.freeze(function(){})}catch(k){Object.freeze=function(t){return function(n){return typeof n=="function"?n:t(n)}}(Object.freeze)}Object.preventExtensions||(Object.preventExtensions=function(t){return t}),Object.isSealed||(Object.isSealed=function(t){return!1}),Object.isFrozen||(Object.isFrozen=function(t){return!1}),Object.isExtensible||(Object.isExtensible=function(t){if(Object(t)===t)throw new TypeError;var n="";while(f(t,n))n+="?";t[n]=!0;var r=f(t,n);return delete t[n],r});if(!Object.keys){var L=!0,A=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],O=A.length;for(var M in{toString:null})L=!1;Object.keys=function I(e){if(typeof e!="object"&&typeof e!="function"||e===null)throw new TypeError("Object.keys called on a non-object");var I=[];for(var t in e)f(e,t)&&I.push(t);if(L)for(var n=0,r=O;n<r;n++){var i=A[n];f(e,i)&&I.push(i)}return I}}Date.now||(Date.now=function(){return(new Date).getTime()});var _="	\n\x0b\f\r \u00a0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff";if(!String.prototype.trim||_.trim()){_="["+_+"]";var D=new RegExp("^"+_+_+"*"),P=new RegExp(_+_+"*$");String.prototype.trim=function(){return String(this).replace(D,"").replace(P,"")}}var F=function(e){if(e==null)throw new TypeError("can't convert "+e+" to object");return Object(e)}})
// (function () {
//     'use strict';

//     angular
//         .module('app.widgets')
//         .service('workItemsService', workItemsService);

//     function workItemsService($mdDialog) {
//         var service = {
//             addEmail: addEmail,
//             addCompany: addCompany
//         }

//         return service;

//         function addCompany() {
//             $mdDialog.show({
//                 locals: {
//                     selectedCompany: null,
//                     editMode: false,
//                     index: null,
//                     quickOption: false
//                 },
//                 templateUrl: 'app/main/contact/create/work/company/workInfo-company.html',
//                 controller: 'ContactCreateCompanyController as vm'
//             });
//         }

//         function addEmail(emails) {
//             $mdDialog.show({
//                 templateUrl: 'app/shared/widgets/a8Emails/a8EmailsDialog.html',
//                 controller: 'a8EmailsDialogController as vm',
//                 locals: {
//                     editMode: false,
//                     email: null
//                 }
//             }).then(function (resp) {
//                 if (resp)
//                     if (emails.length == 0) {
//                         resp.IsPrimary = true;
//                         emails.push(resp);
//                     }
//                 else {
//                     if (resp.IsPrimary) {
//                         angular.forEach(emails, function (itm) {
//                             itm.IsPrimary = false;
//                         });
//                         emails.push(resp);
//                         emails = alasql('select * from ? order by IsPrimary desc', [emails]);
//                     } else {
//                         emails.push(resp);
//                         emails = alasql('select * from ? order by IsPrimary desc', [emails]);
//                     }
//                 }
//             });
//         }

//     }
// })();

/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var wijmo;!function(t){"use strict";function e(t,e){return null==t?null:n(e)?s(t.implementsInterface)&&t.implementsInterface(e)?t:null:t instanceof e?t:null}function n(t){return"string"==typeof t}function r(t){return"number"==typeof t}function i(t){return r(t)&&t==Math.round(t)}function o(t){return"boolean"==typeof t}function s(t){return"function"==typeof t}function a(t){return(t instanceof Date||"[object Date]"===Object.prototype.toString.call(t))&&!isNaN(t.getTime())}function u(t){return t instanceof Array||Array.isArray(t)||"[object Array]"===Object.prototype.toString.call(t)}function c(t){return null!=t&&"object"==typeof t&&!a(t)&&!u(t)}function l(e,r,i){if(null!=e){if(n(e))switch(r){case T.Number:var o=t.Globalize.parseFloat(e,i);return isNaN(o)?e:o;case T.Date:var s=t.Globalize.parseDate(e,i);return s||i||!e||(s=new Date(e)),s&&isFinite(s.getTime())?s:e;case T.Boolean:switch(e.toLowerCase()){case"true":return!0;case"false":return!1}return e}if(r==T.String)return t.Globalize.format(e,i)}return e}function h(e,n){if(n)for(var r in n)if("_"!=r[0]){p(r in e,'Unknown property "'+r+'".');var i=n[r];e._copy&&e._copy(r,i)||(e[r]instanceof t.Event?s(i)&&e[r].addHandler(i):!c(i)||i instanceof Element||!e[r]||"itemsSource"==r?e[r]=i:h(e[r],i))}}function p(t,e){if(!t)throw e="** Assertion failed in Wijmo: "+e,console.error(e),e}function f(t,e){return void 0===e&&(e=!0),p(e&&null==t||n(t),"String expected."),t}function d(t,e,n){if(void 0===e&&(e=!1),void 0===n&&(n=!1),p(e&&null==t||r(t),"Number expected."),n&&t&&t<0)throw"Positive number expected.";return t}function g(t,e){return void 0===e&&(e=!1),p(e&&null==t||o(t),"Boolean expected."),t}function m(t,e){return void 0===e&&(e=!0),p(e&&null==t||s(t),"Function expected."),t}function _(t,e){if(t&&t.getAttribute){var n=new RegExp("(\\s|^)"+e+"(\\s|$)");return t&&n.test(t.getAttribute("class"))}return!1}function v(t,e){if(t&&e&&t.setAttribute)for(var n=e.split(" "),r=0;r<n.length;r++){var i=n[r];if(_(t,i)){var o=new RegExp("((\\s|^)"+i+"(\\s|$))","g"),s=t.getAttribute("class");(s=s.replace(o," ").replace(/ +/g," ").trim())?t.setAttribute("class",s):t.removeAttribute("class")}}}function y(t,e){if(t&&e&&t.setAttribute)for(var n=e.split(" "),r=0;r<n.length;r++){var i=n[r];if(!_(t,i)){var o=t.getAttribute("class");t.setAttribute("class",o?o+" "+i:i)}}}function b(t,e,n){null==n&&(n=!_(t,e)),n?y(t,e):v(t,e)}function C(t,e,n,r){t&&(null!=n?r&&t.getAttribute(e)||t.setAttribute(e,n.toString()):t.removeAttribute(e))}function w(){var t=document.activeElement;if(t){var e=t.shadowRoot;e&&e.activeElement&&(t=e.activeElement)}return t}function E(e){for(var n=[],r=e.querySelectorAll("input,select,textarea,button,a,div"),i=0;i<r.length;i++){var o=r[i];if(o.offsetHeight>0&&o.tabIndex>-1&&!o.disabled&&!x(o,"[disabled],.wj-state-disabled")){if(o instanceof HTMLAnchorElement&&!o.hasAttribute("href"))continue;if(t.isIE()&&!o.hasAttribute("tabindex")){if(o instanceof HTMLDivElement)continue;var s=t.Control.getControl(x(o,".wj-flexgrid"));if(s&&0==s.keyActionTab)continue}!t.Control.getControl(o)&&E(o).length||n.push(o)}}return n}function A(t,e){for(var n=e;n&&t;){if(n===t)return!0;n=n.parentNode||n.host}return!1}function x(t,e){var n=t?t.matches||t.webkitMatchesSelector||t.mozMatchesSelector||t.msMatchesSelector:null;if(n)for(;t;t=t.parentNode)if(t instanceof Element&&n.call(t,e))return t;return null}function S(t,e){if(p(c(e),"css parameter should be an object"),t instanceof Array)for(var n=0;n<t.length;n++)S(t[n],e);else if(t&&t.style){var r=t.style;for(var i in e){var o=e[i];"number"==typeof o&&i.match(/width|height|left|top|right|bottom|size|padding|margin'/i)&&(o+="px"),r[i]!==o&&(r[i]=o.toString())}}}var O="5.20181.436";t.getVersion=function(){return O},t.setLicenseKey=function(e){t.Control._licKey=e};!function(t){t[t.Back=8]="Back",t[t.Tab=9]="Tab",t[t.Enter=13]="Enter",t[t.Escape=27]="Escape",t[t.Space=32]="Space",t[t.PageUp=33]="PageUp",t[t.PageDown=34]="PageDown",t[t.End=35]="End",t[t.Home=36]="Home",t[t.Left=37]="Left",t[t.Up=38]="Up",t[t.Right=39]="Right",t[t.Down=40]="Down",t[t.Delete=46]="Delete",t[t.F1=112]="F1",t[t.F2=113]="F2",t[t.F3=114]="F3",t[t.F4=115]="F4",t[t.F5=116]="F5",t[t.F6=117]="F6",t[t.F7=118]="F7",t[t.F8=119]="F8",t[t.F9=120]="F9",t[t.F10=121]="F10",t[t.F11=122]="F11",t[t.F12=123]="F12"}(t.Key||(t.Key={}));var T;!function(t){t[t.Object=0]="Object",t[t.String=1]="String",t[t.Number=2]="Number",t[t.Boolean=3]="Boolean",t[t.Date=4]="Date",t[t.Array=5]="Array"}(T=t.DataType||(t.DataType={})),t.tryCast=e,t.isPrimitive=function(t){return n(t)||r(t)||o(t)||a(t)},t.isString=n,t.isNullOrWhiteSpace=function(t){return null==t||t.replace(/\s/g,"").length<1},t.isNumber=r,t.isInt=i,t.isBoolean=o,t.isFunction=s,t.isUndefined=function(t){return void 0===t},t.isDate=a,t.isArray=u,t.isObject=c,t.isEmpty=function(t){for(var e in t)return!1;return!0},t.getUniqueId=function(t){for(var e=t,n=0;null!=document.getElementById(e);n++)e=t+n;return e},t.mouseToPage=function(t){if(t instanceof P)return t;if(t.touches&&t.touches.length>0&&(t=t.touches[0]),r(t.clientX)&&r(t.clientY))return new P(t.clientX+pageXOffset,t.clientY+pageYOffset);throw"Mouse or touch event expected."},t.getType=function(t){return r(t)?T.Number:o(t)?T.Boolean:a(t)?T.Date:n(t)?T.String:u(t)?T.Array:T.Object},t.changeType=l,t.toFixed=function(t,e,n){if(n){var r=(i=t.toString()).indexOf(".");i.indexOf("e")<0&&r>-1&&(i=i.substr(0,r+1+e),t=parseFloat(i))}else{var i=t.toFixed(e);t=parseFloat(i)}return t},t.format=function(e,i,o){if((e=f(e)).match(/\{.*"count".*:.*"when".*:.*\}/))try{var s=JSON.parse(e);if(n(s.count)){var a=i[s.count],u=s.when;if(r(a)&&c(u)){var l=u[a]||u.other;n(l)&&(e=l)}}}catch(t){}return e.replace(/\{(.*?)(:(.*?))?\}/g,function(e,n,r,s){var a=e;return n&&"{"!=n[0]&&i&&(a=i[n],s&&(a=t.Globalize.format(a,s)),o&&(a=o(i,n,s,a))),null==a?"":a})},t.clamp=function(t,e,n){return null!=t&&(null!=n&&t>n&&(t=n),null!=e&&t<e&&(t=e)),t},t.copy=h,t.assert=p,t._deprecated=function(t,e){console.error('** WARNING: "'+t+'" has been deprecated; please use "'+e+'" instead.')},t.asString=f,t.asNumber=d,t.asInt=function(t,e,n){if(void 0===e&&(e=!1),void 0===n&&(n=!1),p(e&&null==t||i(t),"Integer expected."),n&&t&&t<0)throw"Positive integer expected.";return t},t.asBoolean=g,t.asDate=function(t,e){if(void 0===e&&(e=!1),n(t)){var r=l(t,T.Date,"r");a(r)&&(t=r)}return p(e&&null==t||a(t),"Date expected."),t},t.asFunction=m,t.asArray=function(t,e){return void 0===e&&(e=!0),p(e&&null==t||u(t),"Array expected."),t},t.asType=function(t,n,r){return void 0===r&&(r=!1),t=e(t,n),p(r||null!=t,n+" expected."),t},t.asEnum=function(t,e,n){if(void 0===n&&(n=!1),null==t&&n)return null;var i=e[t];return p(null!=i,"Invalid enum value."),r(i)?i:t},t.asCollectionView=function(n,r){if(void 0===r&&(r=!0),null==n&&r)return null;var i=e(n,"ICollectionView");return null!=i?i:(u(n)||p(!1,"Array or ICollectionView expected."),new t.collections.CollectionView(n))},t.hasItems=function(t){return null!=t&&null!=t.items&&t.items.length>0},t.toHeaderCase=function(t){return t&&t.length?t[0].toUpperCase()+t.substr(1).replace(/([a-z])([A-Z])/g,"$1 $2"):""},t.escapeHtml=function(t){return n(t)&&(t=t.replace(/[&<>"'\/]/g,function(t){return M[t]})),t};var M={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;"};t.hasClass=_,t.removeClass=v,t.addClass=y,t.toggleClass=b,t.setAttribute=C,t.setSelectionRange=function(e,n,r){if(void 0===r&&(r=n),p(e instanceof HTMLInputElement||e instanceof HTMLTextAreaElement,"INPUT or TEXTAREA element expected"),A(document.body,e)&&!e.disabled&&"none"!=e.style.display)try{return e.setSelectionRange(d(n),d(r),t.isIE()?null:"backward"),e.focus(),!0}catch(t){}return!1},t.disableAutoComplete=function(t){"autocomplete,autocorrect,autocapitalize,spellcheck".split(",").forEach(function(e){t.setAttribute(e,"spellcheck"==e?"false":"off")})},t.removeChild=function(t){return t&&t.parentNode?t.parentNode.removeChild(t):null},t.getActiveElement=w,t.moveFocus=function(t,e){var n=E(t),r=0;if(e){var i=n.indexOf(w());i>-1&&(r=(i+e+n.length)%n.length)}if(r<n.length){var o=n[r];o.focus(),o instanceof HTMLInputElement&&o.select()}},t.getElement=function(t){return t instanceof Element?t:n(t)?document.querySelector(t):t&&t.jquery?t[0]:null},t.createElement=function(t,e){var n=document.createElement("div");return n.innerHTML=t,1==n.children.length&&(n=n.children[0]),e&&e.appendChild(n),n},t.setText=function(t,e){t.textContent=e||""},t.contains=A,t.closest=x,t.closestClass=function(t,e){return x(t,"."+e)},t.enable=function(t,e){var n=!e;b(t,"wj-state-disabled",n),C(t,"disabled",n?"true":null);for(var r=t.querySelectorAll("input"),i=0;i<r.length;i++){var o=r[i];e?o.removeAttribute("disabled"):o.setAttribute("disabled","true")}},t.getElementRect=function(t){var e=t.getBoundingClientRect();return new I(e.left+pageXOffset,e.top+pageYOffset,e.width,e.height)},t.setCss=S,t.animate=function(e,n,r){void 0===n&&(n=t.Control._ANIM_DEF_DURATION),void 0===r&&(r=t.Control._ANIM_DEF_STEP),e=m(e),n=d(n,!1,!0),r=d(r,!1,!0);var i=Date.now(),o=setInterval(function(){var t=Math.min(1,(Date.now()-i)/n);t=Math.sin(t*Math.PI/2),t*=t,requestAnimationFrame(function(){e(t)}),t>=1&&clearInterval(o)},r);return o};var P=function(){function t(t,e){void 0===t&&(t=0),void 0===e&&(e=0),this.x=d(t),this.y=d(e)}return t.prototype.equals=function(e){return e instanceof t&&this.x==e.x&&this.y==e.y},t.prototype.clone=function(){return new t(this.x,this.y)},t}();t.Point=P;var F=function(){function t(t,e){void 0===t&&(t=0),void 0===e&&(e=0),this.width=d(t),this.height=d(e)}return t.prototype.equals=function(e){return e instanceof t&&this.width==e.width&&this.height==e.height},t.prototype.clone=function(){return new t(this.width,this.height)},t}();t.Size=F;var I=function(){function t(t,e,n,r){this.left=d(t),this.top=d(e),this.width=d(n),this.height=d(r)}return Object.defineProperty(t.prototype,"right",{get:function(){return this.left+this.width},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bottom",{get:function(){return this.top+this.height},enumerable:!0,configurable:!0}),t.prototype.equals=function(e){return e instanceof t&&this.left==e.left&&this.top==e.top&&this.width==e.width&&this.height==e.height},t.prototype.clone=function(){return new t(this.left,this.top,this.width,this.height)},t.fromBoundingRect=function(e){return null!=e.left?new t(e.left,e.top,e.width,e.height):null!=e.x?new t(e.x,e.y,e.width,e.height):void p(!1,"Invalid source rectangle.")},t.union=function(e,n){var r=Math.min(e.left,n.left),i=Math.min(e.top,n.top);return new t(r,i,Math.max(e.right,n.right)-r,Math.max(e.bottom,n.bottom)-i)},t.intersection=function(e,n){var r=Math.max(e.left,n.left),i=Math.max(e.top,n.top);return new t(r,i,Math.min(e.right,n.right)-r,Math.min(e.bottom,n.bottom)-i)},t.prototype.contains=function(e){if(e instanceof P)return e.x>=this.left&&e.x<=this.right&&e.y>=this.top&&e.y<=this.bottom;if(e instanceof t){var n=e;return n.left>=this.left&&n.right<=this.right&&n.top>=this.top&&n.bottom<=this.bottom}p(!1,"Point or Rect expected.")},t.prototype.inflate=function(e,n){return new t(this.left-e,this.top-n,this.width+2*e,this.height+2*n)},t}();t.Rect=I;var D=function(){function e(){}return e.addDays=function(t,n){return e.newDate(t.getFullYear(),t.getMonth(),t.getDate()+n)},e.addMonths=function(t,n){return e.newDate(t.getFullYear(),t.getMonth()+n,t.getDate())},e.addYears=function(t,n){return e.newDate(t.getFullYear()+n,t.getMonth(),t.getDate())},e.addHours=function(t,n){return e.newDate(t.getFullYear(),t.getMonth(),t.getDate(),t.getHours()+n)},e.addMinutes=function(t,n){return e.newDate(t.getFullYear(),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes()+n)},e.addSeconds=function(t,n){return e.newDate(t.getFullYear(),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds()+n)},e.sameDate=function(t,e){return a(t)&&a(e)&&t.getFullYear()==e.getFullYear()&&t.getMonth()==e.getMonth()&&t.getDate()==e.getDate()},e.sameTime=function(t,e){return a(t)&&a(e)&&t.getHours()==e.getHours()&&t.getMinutes()==e.getMinutes()&&t.getSeconds()==e.getSeconds()},e.equals=function(t,e){return a(t)&&a(e)&&t.getTime()==e.getTime()},e.fromDateTime=function(t,n){return t||n?(t||(t=n),n||(n=t),e.newDate(t.getFullYear(),t.getMonth(),t.getDate(),n.getHours(),n.getMinutes(),n.getSeconds(),n.getMilliseconds())):null},e.toFiscal=function(n,r){var i=t.culture.Globalize.calendar;return u(i.fiscalYearOffsets)?e.addMonths(n,-i.fiscalYearOffsets[r?0:1]):n},e.fromFiscal=function(n,r){var i=t.culture.Globalize.calendar;return u(i.fiscalYearOffsets)?e.addMonths(n,+i.fiscalYearOffsets[r?0:1]):n},e.newDate=function(t,e,n,r,i,o,s){if(null==t||null==e||null==n){var a=new Date;null==t&&(t=a.getFullYear()),null==e&&(e=a.getMonth()),null==n&&(n=a.getDate())}null==r&&(r=0),null==i&&(i=0),null==o&&(o=0),null==s&&(s=0);var u=new Date(t,e,n,r,i,o,s),c=u.getFullYear();return t<100&&c>=1900&&u.setFullYear(u.getFullYear()-1900),u},e.clone=function(t){return e.fromDateTime(t,t)},e}();t.DateTime=D,t.httpRequest=function(t,e){e||(e={});var i=e.method?f(e.method).toUpperCase():"GET",o=null==e.async||g(e.async),u=e.data;if(null!=u&&"GET"==i){var l=[];for(var h in u){var p=u[h];a(p)&&(p=p.toJSON()),l.push(h+"="+p)}l.length&&(t+=(t.indexOf("?")<0?"?":"&")+l.join("&")),u=null}var d=new XMLHttpRequest;d.URL_DEBUG=t;var _=!1;if(null==u||n(u)||(_=c(u),u=JSON.stringify(u)),d.onload=function(){4==d.readyState&&(d.status<300?e.success&&m(e.success)(d):e.error&&m(e.error)(d),e.complete&&m(e.complete)(d))},d.onerror=function(){if(!s(e.error))throw"HttpRequest Error: "+d.status+" "+d.statusText;e.error(d)},d.open(i,t,o,e.user,e.password),e.user&&e.password&&d.setRequestHeader("Authorization","Basic "+btoa(e.user+":"+e.password)),_&&d.setRequestHeader("Content-Type","application/json"),e.requestHeaders)for(var v in e.requestHeaders)d.setRequestHeader(v,e.requestHeaders[v]);return r(e.timeout)&&(d.timeout=e.timeout),s(e.beforeSend)&&e.beforeSend(d),d.send(u),d}}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";t.culture=window.wijmo.culture||{Globalize:{numberFormat:{".":".",",":",","-":"-","+":"+","%":"%",percent:{pattern:["-n %","n %"]},currency:{decimals:2,symbol:"$",pattern:["($n)","$n"]}},calendar:{"/":"/",":":":",firstDay:0,days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysAbbr:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsAbbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],am:["AM","A"],pm:["PM","P"],eras:["A.D.","B.C."],patterns:{d:"M/d/yyyy",D:"dddd, MMMM dd, yyyy",f:"dddd, MMMM dd, yyyy h:mm tt",F:"dddd, MMMM dd, yyyy h:mm:ss tt",t:"h:mm tt",T:"h:mm:ss tt",M:"MMMM d",m:"MMMM d",Y:"MMMM, yyyy",y:"MMMM, yyyy",g:"M/d/yyyy h:mm tt",G:"M/d/yyyy h:mm:ss tt",s:'yyyy"-"MM"-"dd"T"HH":"mm":"ss',o:'yyyy"-"MM"-"dd"T"HH":"mm":"ss"."fffffffK',O:'yyyy"-"MM"-"dd"T"HH":"mm":"ss"."fffffffK',U:"dddd, MMMM dd, yyyy h:mm:ss tt"},fiscalYearOffsets:[-3,-3]}}};var e=function(){function e(){}return e.format=function(n,r,i,o){return t.isString(n)?n:t.isNumber(n)?(r=r||(n==Math.round(n)?"n0":"n2"),e.formatNumber(n,r,i,o)):t.isDate(n)?(r=r||"d",e.formatDate(n,r)):null!=n?n.toString():""},e.formatNumber=function(n,r,i,o){n=t.asNumber(n),r=t.asString(r);var s,a=t.culture.Globalize.numberFormat,u=r?r.match(/([a-z])(\d*)(,*)(.*)/i):null,c=u?u[1].toLowerCase():"n",l=u&&u[2]?parseInt(u[2]):"c"==c?a.currency.decimals:n==Math.round(n)?0:2,h=u&&u[3]?3*u[3].length:0,p=a["."]||".",f=a[","]||",",d=a["-"]||"-";if(h&&(n/=Math.pow(10,h)),"d"==c||"x"==c){for(s=Math.round(Math.abs(n)).toString("d"==c?10:16);s.length<l;)s="0"+s;return n<0&&(s=d+s),r&&"X"==r[0]&&(s=s.toUpperCase()),s}if("p"==c&&(n=e._mul100(n),n=t.toFixed(n,l,o)),o&&"p"!=c&&(n=t.toFixed(n,l,!0)),s=e._toFixedStr("c"==c||"p"==c?Math.abs(n):n,l),(i||"g"==c)&&s.indexOf(".")>-1&&(s=(s=s.replace(/(\.[0-9]*?)0+$/g,"$1")).replace(/\.$/,"")),"."!=p&&(s=s.replace(".",p)),"-"!=d&&(s=s.replace("-",d)),f&&("n"==c||"c"==c||"p"==c)){var g=s.indexOf(p),m=/\B(?=(\d\d\d)+(?!\d))/g;s=g>-1?s.substr(0,g).replace(m,f)+s.substr(g):s.replace(m,f)}if("c"==c){var _=a.currency.pattern[n<0?0:1],v=u&&u[4]?u[4]:a.currency.symbol;"​"==v&&(v=""),s=_.replace("n",s).replace("$",v)}if("p"==c){var _=a.percent.pattern[n<0?0:1],y=a["%"]||"%";s=_.replace("n",s),"%"!=y&&(s=s.replace("%",y)),"-"!=d&&n<0&&(s=s.replace("-",d))}return s},e.formatDate=function(n,r){switch(n=t.asDate(n),r){case"r":case"R":return n.toUTCString();case"u":return n.toISOString().replace(/\.\d{3}/,"")}r=e._expandFormat(r);for(var i=e._parseDateFormat(r),o="",s=0;s<i.length;s++)o+=e._formatDatePart(n,r,i[s]);return o},e.parseInt=function(t,n){return Math.round(e.parseFloat(t,n))},e.parseFloat=function(e,n){var r=t.culture.Globalize.numberFormat,i=r["-"]||"-",o=r["%"]||"%",s=e.indexOf(i)>-1||e.indexOf("(")>-1&&e.indexOf(")")>-1?-1:1,a=e.indexOf(o)>-1?.01:1,u=n?n.match(/,+/):null,c=u?3*u[0].length:0,l=0;if(!n||"x"!=n[0]&&"X"!=n[0]){var h=r["."]||".",p=new RegExp("[^\\d\\"+h+"]","g");e=e.replace(p,"").replace(h,"."),l=parseFloat(e)}else e=e.replace(/[^0-9a-f]+.*$/gi,""),l=parseInt(e,16);return l*s*a*Math.pow(10,c)},e.parseDate=function(n,r){if(!(n=t.asString(n)))return null;if("u"==r)return new Date(n);var i;if("R"==r||"r"==r){var o=/(([0-9]+)\-([0-9]+)\-([0-9]+))?\s?(([0-9]+):([0-9]+)(:([0-9]+))?)?/,s=n.match(o);return s[1]||s[5]?(i=s[1]?new Date(parseInt(s[2]),parseInt(s[3])-1,parseInt(s[4])):new Date,s[5]&&(i.setHours(parseInt(s[6])),i.setMinutes(parseInt(s[7])),i.setSeconds(s[8]?parseInt(s[9]):0))):i=new Date(n),isNaN(i.getTime())?null:i}r=e._expandFormat(r||"d");var a,u,c,l,h,p,f=t.culture.Globalize.calendar,d=e._CJK,g=new RegExp("(\\"+f["/"]+")|(\\"+f[":"]+")|(\\d+)|(["+d+"\\.]{2,})|(["+d+"]+)","gi"),m=n.match(g),_=e._parseDateFormat(r),v=0,y=-1,b=0,C=1,w=0,E=0,A=0,x=0,S=-1;if(!(m&&m.length&&_&&_.length))return null;for(var O=0;O<_.length&&m;O++){var T=O-v,M=T>-1&&T<m.length?m[T]:"",P=_[O].length;switch(_[O]){case"EEEE":case"EEE":case"EE":case"E":case"eeee":case"eee":case"ee":case"e":p=_[O];case"yyyy":case"yyy":case"yy":case"y":P>1&&M.length>P&&(m[T]=M.substr(P),M=M.substr(0,P),v++),y=parseInt(M),h=4==M.length;break;case"MMMM":case"MMM":l=!0;var F=M.toLowerCase();b=-1;for(var I=0;I<12;I++)if(0==f.months[I].toLowerCase().indexOf(F)){b=I;break}if(b>-1)break;case"MM":case"M":l=!0,P>1&&M.length>P&&(m[T]=M.substr(P),M=M.substr(0,P),v++),b=parseInt(M)-1;break;case"dddd":case"ddd":a=!0;break;case"dd":case"d":P>1&&M.length>P&&(m[T]=M.substr(P),M=M.substr(0,P),v++),C=parseInt(M),u=!0;break;case"hh":case"h":P>1&&M.length>P&&(m[T]=M.substr(P),M=M.substr(0,P),v++),w=12==(w=parseInt(M))?0:w;break;case"HH":P>1&&M.length>P&&(m[T]=M.substr(P),M=M.substr(0,P),v++),w=parseInt(M);break;case"H":w=parseInt(M);break;case"mm":case"m":P>1&&M.length>P&&(m[T]=M.substr(P),M=M.substr(0,P),v++),E=parseInt(M);break;case"ss":case"s":P>1&&M.length>P&&(m[T]=M.substr(P),M=M.substr(0,P),v++),A=parseInt(M);break;case"fffffff":case"FFFFFFF":case"ffffff":case"FFFFFF":case"fffff":case"FFFFF":case"ffff":case"FFFF":case"fff":case"FFF":case"ff":case"FF":case"f":case"F":x=parseInt(M)/Math.pow(10,P-3);break;case"tt":case"t":M=M.toUpperCase(),w<12&&f.pm.indexOf(M)>-1&&(w+=12);break;case"q":case"Q":case"u":case"U":c=!0;break;case"ggg":case"gg":case"g":S=f.eras.length>1?e._getEra(M,f):-1;break;case f["/"]:case f[":"]:if(M&&M!=_[O])return null;break;case"K":break;default:e._unquote(_[O]).trim()!=M.trim()&&v++}}if(l&&u&&(isNaN(w)&&(w=0),isNaN(E)&&(E=0),isNaN(A)&&(A=0)),b<0||b>11||isNaN(b)||C<1||C>31||isNaN(C)||w<0||w>24||isNaN(w)||E<0||E>60||isNaN(E)||A<0||A>60||isNaN(A))return null;if(p){if(!l)return null;var D=t.culture.Globalize.calendar;if(t.isArray(D.fiscalYearOffsets)){var j="E"==p[0],L=b-D.fiscalYearOffsets[j?0:1];y+=L>11?-1:L<0?1:0}}return a&&!u?null:c&&!l?null:(y<0&&(y=(new Date).getFullYear()),S>-1?y=y+f.eras[S].start.getFullYear()-1:y<100&&!h&&(y+=y+2e3<(t.isNumber(f.twoDigitYearMax)?f.twoDigitYearMax:2029)?2e3:1900),C>new Date(y,b+1,0).getDate()?null:(i=t.DateTime.newDate(y,b,C,w,E+0,A,x),isNaN(i.getTime())?null:i))},e.getFirstDayOfWeek=function(){var e=t.culture.Globalize.calendar.firstDay;return e||0},e.getNumberDecimalSeparator=function(){var e=t.culture.Globalize.numberFormat["."];return e||"."},e._toFixedStr=function(t,e){var n=t.toString(),r=n.indexOf("."),i=e-(n.length-r)+1;return n.indexOf("e")<0&&r>-1&&i>=0?n+Array(i+1).join("0"):t.toFixed(e)},e._unquote=function(t){return t.length>1&&t[0]==t[t.length-1]&&("'"==t[0]||'"'==t[0])?t.substr(1,t.length-2):t},e._parseDateFormat=function(t){if(t in e._dateFormatParts)return e._dateFormatParts[t];var n,r,i=[];if(t)for(n=0;n>-1&&n<t.length;n++){var o=t[n];if(("'"==o||'"'==o)&&(r=t.indexOf(o,n+1))>-1)i.push(t.substring(n,r+1)),n=r;else if("\\"==o&&n<t.length-1)n++,i.push('"'+t[n]+'"');else{for(r=n+1;r<t.length&&t[r]==o;r++);i.push(t.substring(n,r)),n=r-1}}return e._dateFormatParts[t]=i,i},e._formatDatePart=function(n,r,i){var o,s=t.culture.Globalize.calendar,a=0,u=0,c=0,l=i.length;switch(i){case"yyyy":case"yyy":case"yy":case"y":case"EEEE":case"EEE":case"EE":case"E":case"eeee":case"eee":case"ee":case"e":u=(o="E"==i[0]?t.DateTime.toFiscal(n,!0):"e"==i[0]?t.DateTime.toFiscal(n,!1):n).getFullYear(),s.eras.length>1&&r.indexOf("g")>-1&&(a=e._getEra(n,s))>-1&&(u=u-s.eras[a].start.getFullYear()+1);var h=i.length<3?u%100:3==i.length?u%1e3:u;return e._zeroPad(h,i.length);case"MMMMM":return s.monthsAbbr[n.getMonth()][0];case"MMMM":return s.months[n.getMonth()];case"MMM":return s.monthsAbbr[n.getMonth()];case"MM":case"M":return e._zeroPad(n.getMonth()+1,l);case"dddd":return s.days[n.getDay()];case"ddd":return s.daysAbbr[n.getDay()];case"dd":return e._zeroPad(n.getDate(),2);case"d":return n.getDate().toString();case"hh":case"h":return e._zeroPad(e._h12(n),l);case"HH":case"H":return e._zeroPad(n.getHours(),l);case"mm":case"m":return e._zeroPad(n.getMinutes(),l);case"ss":case"s":return e._zeroPad(n.getSeconds(),l);case"fffffff":case"FFFFFFF":case"ffffff":case"FFFFFF":case"fffff":case"FFFFF":case"ffff":case"FFFF":case"fff":case"FFF":case"ff":case"FF":case"f":case"F":return c=n.getMilliseconds()*Math.pow(10,l-3),"f"==i[0]?e._zeroPad(c,l):c.toFixed(0);case"tt":return n.getHours()<12?s.am[0]:s.pm[0];case"t":return n.getHours()<12?s.am[1]:s.pm[1];case"q":case"Q":return(Math.floor(n.getMonth()/3)+1).toString();case"u":case"U":return o=t.DateTime.toFiscal(n,"U"==i),(Math.floor(o.getMonth()/3)+1).toString();case"ggg":case"gg":case"g":return s.eras.length>1&&(a=e._getEra(n,s))>-1?"ggg"==i?s.eras[a].name:"gg"==i?s.eras[a].name[0]:s.eras[a].symbol:s.eras[0];case":":case"/":return s[i];case"K":var p=n.toString().match(/(\+|\-)(\d{2})(\d{2})/);return p?p[1]+p[2]+p[3]:"";case"zzz":case"zz":case"z":var f=-n.getTimezoneOffset(),d=void 0;switch(i){case"zzz":d=e.format(f/60,"d2",!1,!0)+s[":"]+e.format(f%60,"d2",!1,!0);break;case"zz":d=e.format(f/60,"d2",!1,!0);break;case"z":d=e.format(f/60,"d",!1,!0)}return f>=0?"+"+d:d}return l>1&&i[0]==i[l-1]&&('"'==i[0]||"'"==i[0])?i.substr(1,l-2):i},e._getEra=function(e,n){if(t.isDate(e)){for(r=0;r<n.eras.length;r++)if(e>=n.eras[r].start)return r}else if(t.isString(e))for(var r=0;r<n.eras.length;r++)if(n.eras[r].name&&(0==n.eras[r].name.indexOf(e)||0==n.eras[r].symbol.indexOf(e)))return r;return-1},e._expandFormat=function(e){var n=t.culture.Globalize.calendar.patterns[e];return n||e},e._zeroPad=function(t,e){var n=t.toFixed(0),r=e-n.length+1;return r>0?Array(r).join("0")+n:n},e._h12=function(e){var n=t.culture.Globalize.calendar,r=e.getHours();return n.am&&n.am[0]&&0==(r%=12)&&(r=12),r},e._mul100=function(t){var e=t.toString(),n=e.indexOf(".");return e.indexOf("e")>-1?100*t:(n<0?e+="00":(n+=2,e=(e=e.replace(".","")+"00").substr(0,n)+"."+e.substr(n)),parseFloat(e))},e._CJK="a-z"+"u00c0-u017fu3000-u30ffu4e00-u9faf".replace(/u/g,"\\u")+"u1100-u11ffu3130-u318fua960-ua97fuac00-ud7afud7b0-ud7ff".replace(/u/g,"\\u"),e._dateFormatParts={},e}();t.Globalize=e,t._updateCulture=function(){t.culture=window.wijmo.culture}}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";var e=function(){function t(t){this.path=t}return Object.defineProperty(t.prototype,"path",{get:function(){return this._path},set:function(t){this._path=t,this._parts=t?t.split("."):[];for(var e=0;e<this._parts.length;e++){var n=this._parts[e],r=n.indexOf("[");r>-1&&(this._parts[e]=n.substr(0,r),this._parts.splice(++e,0,parseInt(n.substr(r+1))))}this._key=1==this._parts.length?this._parts[0]:null},enumerable:!0,configurable:!0}),t.prototype.getValue=function(t){if(t){if(this._key)return t[this._key];if(this._path&&this._path in t)return t[this._path];for(var e=0;e<this._parts.length&&t;e++)t=t[this._parts[e]]}return t},t.prototype.setValue=function(t,e){if(t){if(this._path in t)return void(t[this._path]=e);for(var n=0;n<this._parts.length-1;n++)if(null==(t=t[this._parts[n]]))return;t[this._parts[this._parts.length-1]]=e}},t}();t.Binding=e}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),wijmo;!function(t){"use strict";var e=function(){return function(t,e){this.handler=t,this.self=e}}(),n=function(){function n(){this._handlers=[]}return n.prototype.addHandler=function(n,r){n=t.asFunction(n),this._handlers.push(new e(n,r))},n.prototype.removeHandler=function(e,n){e=t.asFunction(e);for(var r=0;r<this._handlers.length;r++){var i=this._handlers[r];if((i.handler==e||null==e)&&(i.self==n||null==n)&&(this._handlers.splice(r,1),e&&n))break}},n.prototype.removeAllHandlers=function(){this._handlers.length=0},n.prototype.raise=function(t,e){void 0===e&&(e=r.empty);for(var n=0;n<this._handlers.length;n++){var i=this._handlers[n];i.handler.call(i.self,t,e)}},Object.defineProperty(n.prototype,"hasHandlers",{get:function(){return this._handlers.length>0},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"handlerCount",{get:function(){return this._handlers.length},enumerable:!0,configurable:!0}),n}();t.Event=n;var r=function(){function t(){}return t.empty=new t,t}();t.EventArgs=r;var i=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.cancel=!1,e}return __extends(e,t),e}(r);t.CancelEventArgs=i;var o=function(t){function e(e,n,r){var i=t.call(this)||this;return i._name=e,i._oldVal=n,i._newVal=r,i}return __extends(e,t),Object.defineProperty(e.prototype,"propertyName",{get:function(){return this._name},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"oldValue",{get:function(){return this._oldVal},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"newValue",{get:function(){return this._newVal},enumerable:!0,configurable:!0}),e}(r);t.PropertyChangedEventArgs=o;var s=function(t){function e(e,n){var r=t.call(this)||this;return r._xhr=e,r._msg=n,r}return __extends(e,t),Object.defineProperty(e.prototype,"request",{get:function(){return this._xhr},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"message",{get:function(){return this._msg},set:function(t){this._msg=t},enumerable:!0,configurable:!0}),e}(i);t.RequestErrorEventArgs=s}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";var e=function(){function e(n,r,i){void 0===r&&(r=null),void 0===i&&(i=!1);var o=this;this._pristine=!0,this._focus=!1,this._updating=0,this._fullUpdate=!1,this.gotFocus=new t.Event,this.lostFocus=new t.Event,this.refreshing=new t.Event,this.refreshed=new t.Event,this._updateWme(),t.assert(null==e.getControl(n),"Element is already hosting a control.");var s=t.getElement(n);if(t.assert(null!=s,"Cannot find the host element."),this._orgOuter=s.outerHTML,this._orgTag=s.tagName,this._orgAtts=s.attributes,"INPUT"!=s.tagName&&"SELECT"!=s.tagName||(s=this._replaceWithDiv(s)),this._e=s,s[e._CTRL_KEY]=this,1==i){this._szCtl=new t.Size(s.offsetWidth,s.offsetHeight);var a=this._handleResize.bind(this);this.addEventListener(window,"resize",a)}var u;this.addEventListener(s,"focus",function(t){u&&clearTimeout(u),u=setTimeout(function(){u=null,o._updateFocusState()},e._FOCUS_INTERVAL)},!0),this.addEventListener(s,"blur",function(t){u&&clearTimeout(u),u=setTimeout(function(){u=null,o._updateFocusState()},e._FOCUS_INTERVAL)},!0);var c=this._handleDisabled.bind(this);if(this.addEventListener(s,"mousedown",c,!0),this.addEventListener(s,"mouseup",c,!0),this.addEventListener(s,"click",c,!0),this.addEventListener(s,"dblclick",c,!0),this.addEventListener(s,"keydown",c,!0),this.addEventListener(s,"wheel",c,t.getEventOptions(!0,!0)),null==e._touching&&(e._touching=!1,"ontouchstart"in window||"onpointerdown"in window)){var l=document.body,h=this._handleTouchStart,p=this._handleTouchEnd,f=t.getEventOptions(!0,!0);"ontouchstart"in window?(l.addEventListener("touchstart",h,f),l.addEventListener("touchend",p,f),l.addEventListener("touchcancel",p,f),l.addEventListener("touchleave",p,f)):"onpointerdown"in window&&(l.addEventListener("pointerdown",h,f),l.addEventListener("pointerup",p,f),l.addEventListener("pointerout",p,f),l.addEventListener("pointercancel",p,f),l.addEventListener("pointerleave",p,f))}}return e.prototype.getTemplate=function(){for(var t=Object.getPrototypeOf(this);t;t=Object.getPrototypeOf(t)){var e=t.constructor.controlTemplate;if(e)return e}return null},e.prototype.applyTemplate=function(n,r,i,o){var s=this,a=this._e;n&&t.addClass(a,n);var u=null;r&&(u=t.createElement(r,a));for(var c=a.querySelectorAll("a.wj-btn"),l=0;l<c.length;l++){var h=c[l];t.setAttribute(h,"role","button",!0),t.setAttribute(h,"href","",!0),t.setAttribute(h,"draggable",!1,!0)}var p=a.querySelectorAll("input"),f=1==p.length?p[0]:null;if(f&&(this._copyAttributes(f,a.attributes,e._rxInputAtts),this._copyAttributes(f,this._orgAtts,e._rxInputAtts)),f&&a.id){for(var d=a;d.parentElement;)d=d.parentElement;var g=d.querySelector('label[for="'+a.id+'"]');if(g instanceof HTMLLabelElement){var m=t.getUniqueId(a.id+"_input");f.id=m,g.htmlFor=m}}if(f){var _=document.createEvent("HTMLEvents"),v=f.value;_.initEvent("change",!0,!1),this.addEventListener(f,"input",function(){s._pristine=!1,v=f.value},!0),this.gotFocus.addHandler(function(){v=f.value}),this.lostFocus.addHandler(function(){s._pristine&&(s._pristine=!1,s._updateState()),v!=f.value&&f.dispatchEvent(_)})}if(f?a.tabIndex=-1:a.getAttribute("tabindex")||(a.tabIndex=0),this._updateState(),i)for(var y in i){var b=i[y];if(this[y]=u.querySelector('[wj-part="'+b+'"]'),null==this[y]&&u.getAttribute("wj-part")==b&&(this[y]=u),null==this[y])throw'Missing template part: "'+b+'"';if(b==o){var C="name",w=a.attributes[C];w&&w.value&&this[y].setAttribute(C,w.value),C="accesskey",(w=a.attributes[C])&&w.value&&(this[y].setAttribute(C,w.value),a.removeAttribute(C))}}return u},e.prototype.dispose=function(){for(var n=this._e.querySelectorAll(".wj-control"),r=0;r<n.length;r++){var i=e.getControl(n[r]);i&&i.dispose()}this._toInv&&(clearTimeout(this._toInv),this._toInv=null),this.removeEventListener();for(var o in this)o.length>2&&0==o.indexOf("on")&&(a=this[o[2].toLowerCase()+o.substr(3)])instanceof t.Event&&a.removeAllHandlers();var s=this.collectionView;if(s instanceof t.collections.CollectionView)for(var o in s){var a=s[o];a instanceof t.Event&&a.removeHandler(null,this)}this._e.parentNode&&(this._e.outerHTML=this._orgOuter),this._e[e._CTRL_KEY]=null,this._e=this._orgOuter=this._orgTag=null},e.getControl=function(n){var r=t.getElement(n);return r?t.asType(r[e._CTRL_KEY],e,!0):null},Object.defineProperty(e.prototype,"hostElement",{get:function(){return this._e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"rightToLeft",{get:function(){return null==this._rtlDir&&(this._rtlDir=!!this._e&&"rtl"==getComputedStyle(this._e).direction),this._rtlDir},enumerable:!0,configurable:!0}),e.prototype.focus=function(){this._e&&this._e.focus()},e.prototype.containsFocus=function(){var n=this._e,r=t.getActiveElement();if(!n)return!1;for(var i=r;i;){if(i==n)return!0;i=i[e._OWNR_KEY]||i.parentElement}return!1},e.prototype.invalidate=function(t){var n=this;void 0===t&&(t=!0),this._rtlDir=null,this._fullUpdate=this._fullUpdate||t,this._toInv&&(clearTimeout(this._toInv),this._toInv=null),this.isUpdating||(this._toInv=setTimeout(function(){n.refresh(n._fullUpdate),n._toInv=null},e._REFRESH_INTERVAL))},e.prototype.refresh=function(e){var n=this;void 0===e&&(e=!0);var r=this.hostElement;r&&(this._rtlDir="rtl"==getComputedStyle(r).direction,t.toggleClass(r,"wj-rtl",this._rtlDir)),this.isUpdating||(this.onRefreshing(),setTimeout(function(){n.onRefreshed()})),!this.isUpdating&&this._toInv&&(clearTimeout(this._toInv),this._toInv=null,this._fullUpdate=!1,this._updateWme())},e.invalidateAll=function(t){if(t||(t=document.body),t.children)for(var n=0;n<t.children.length;n++)e.invalidateAll(t.children[n]);var r=e.getControl(t);r&&r.invalidate()},e.refreshAll=function(t){if(t||(t=document.body),t.children)for(var n=0;n<t.children.length;n++)e.refreshAll(t.children[n]);var r=e.getControl(t);r&&r.refresh()},e.disposeAll=function(t){var n=e.getControl(t);if(n)n.dispose();else if(t.children)for(var r=0;r<t.children.length;r++)e.disposeAll(t.children[r])},e.prototype.beginUpdate=function(){this._updating++},e.prototype.endUpdate=function(){this._updating--,this._updating<=0&&this.invalidate()},Object.defineProperty(e.prototype,"isUpdating",{get:function(){return this._updating>0},enumerable:!0,configurable:!0}),e.prototype.deferUpdate=function(t){try{this.beginUpdate(),t()}finally{this.endUpdate()}},Object.defineProperty(e.prototype,"isTouching",{get:function(){return e._touching},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isDisabled",{get:function(){return this._e&&null!=this._e.getAttribute("disabled")},set:function(e){(e=t.asBoolean(e,!0))!=this.isDisabled&&t.enable(this._e,!e)},enumerable:!0,configurable:!0}),e.prototype.initialize=function(e){e&&t.copy(this,e)},e.prototype.addEventListener=function(t,e,n,r){void 0===r&&(r=!1),t&&(t.addEventListener(e,n,r),null==this._listeners&&(this._listeners=[]),this._listeners.push({target:t,type:e,fn:n,capture:r}))},e.prototype.removeEventListener=function(t,e,n,r){var i=0;if(this._listeners)for(var o=0;o<this._listeners.length;o++){var s=this._listeners[o];null!=t&&t!=s.target||null!=e&&e!=s.type||(null==n||n==s.fn||n&&s.fn&&n.toString()==s.fn.toString())&&(null!=r&&r!=s.capture||(s.target.removeEventListener(s.type,s.fn,s.capture),this._listeners.splice(o,1),o--,i++))}return i},e.prototype.onGotFocus=function(t){this.gotFocus.raise(this,t)},e.prototype.onLostFocus=function(t){this.lostFocus.raise(this,t)},e.prototype.onRefreshing=function(t){this.refreshing.raise(this,t)},e.prototype.onRefreshed=function(t){this.refreshed.raise(this,t)},e.prototype._getProductInfo=function(){return"B0C3,Control"},e.prototype._updateWme=function(){var n=window.wijmo._updateWme;t.isFunction(n)&&n(this,e._licKey)},e.prototype._hasPendingUpdates=function(){return null!=this._toInv},e.prototype._handleResize=function(){if(this._e.parentElement){var e=new t.Size(this._e.offsetWidth,this._e.offsetHeight);e.equals(this._szCtl)||(this._szCtl=e,this.invalidate())}},e.prototype._updateFocusState=function(){setTimeout(function(){for(var n=t.EventArgs.empty,r=document.body.querySelectorAll(".wj-state-focused"),i=0;i<r.length;i++)(a=e.getControl(r[i]))&&a._focus&&!a.containsFocus()&&(a._focus=!1,a._updateState(),a.onLostFocus(n));var o=t.getActiveElement();if(o)for(var s=o;s;){var a=e.getControl(s);a&&!a._focus&&a.containsFocus()&&(a._focus=!0,a._updateState(),a.onGotFocus(n)),s=s[e._OWNR_KEY]||s.parentElement}})},e.prototype._updateState=function(){var e=this.hostElement;if(e){t.toggleClass(e,"wj-state-focused",this._focus);var n=e.querySelector("input");if(n instanceof HTMLInputElement){t.toggleClass(e,"wj-state-empty",0==n.value.length),t.toggleClass(e,"wj-state-readonly",n.readOnly);var r=n.validationMessage;t.toggleClass(e,"wj-state-invalid",!this._pristine&&null!=r&&r.length>0)}}},e.prototype._handleTouchStart=function(t){null!=t.pointerType&&"touch"!=t.pointerType||(e._touching=!0)},e.prototype._handleTouchEnd=function(t){null!=t.pointerType&&"touch"!=t.pointerType||setTimeout(function(){e._touching=!1},800)},e.prototype._handleDisabled=function(t){this.isDisabled&&(t.preventDefault(),t.stopPropagation(),t.stopImmediatePropagation())},e.prototype._replaceWithDiv=function(t){var e=document.createElement("div");return t.parentElement.replaceChild(e,t),e.innerHTML=t.innerHTML,this._copyAttributes(e,t.attributes,/id|style|class/i),e},e.prototype._copyAttributes=function(t,e,n){if(t)for(var r=0;r<e.length;r++){var i=e[r].name;i.match(n)&&t.setAttribute(i,e[r].value)}},e._REFRESH_INTERVAL=10,e._FOCUS_INTERVAL=20,e._ANIM_DEF_DURATION=400,e._ANIM_DEF_STEP=35,e._CLICK_DELAY=800,e._CLICK_REPEAT=75,e._CLIPBOARD_DELAY=100,e._DRAG_SCROLL_EDGE=15,e._DRAG_SCROLL_STEP=10,e._CTRL_KEY="$WJ-CTRL",e._OWNR_KEY="$WJ-OWNR",e._SCRL_KEY="$WJ-SCRL",e._rxInputAtts=/name|tabindex|placeholder|autofocus|autocomplete|autocorrect|autocapitalize|spellcheck|readonly|minlength|maxlength|pattern|type/i,e}();t.Control=e}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";var e;!function(t){t[t.None=0]="None",t[t.Sum=1]="Sum",t[t.Cnt=2]="Cnt",t[t.Avg=3]="Avg",t[t.Max=4]="Max",t[t.Min=5]="Min",t[t.Rng=6]="Rng",t[t.Std=7]="Std",t[t.Var=8]="Var",t[t.StdPop=9]="StdPop",t[t.VarPop=10]="VarPop",t[t.CntAll=11]="CntAll",t[t.First=12]="First",t[t.Last=13]="Last"}(e=t.Aggregate||(t.Aggregate={})),t.getAggregate=function(n,r,i){var o=0,s=0,a=0,u=0,c=null,l=null,h=null,p=i?new t.Binding(i):null;if((n=t.asEnum(n,e))==e.CntAll)return r.length;for(var f=0;f<r.length;f++){var d=r[f];if(p&&(d=p.getValue(d)),n==e.First)return d;null!=d&&(o++,(null==c||d<c)&&(c=d),(null==l||d>l)&&(l=d),h=d,t.isNumber(d)&&!isNaN(d)?(s++,a+=d,u+=d*d):t.isBoolean(d)&&(s++,1==d&&(a++,u++)))}var g=0==s?0:a/s;switch(n){case e.Avg:return g;case e.Cnt:return o;case e.Max:return l;case e.Min:return c;case e.Rng:return l-c;case e.Sum:return a;case e.VarPop:return s<=1?0:u/s-g*g;case e.StdPop:return s<=1?0:Math.sqrt(u/s-g*g);case e.Var:return s<=1?0:(u/s-g*g)*s/(s-1);case e.Std:return s<=1?0:Math.sqrt((u/s-g*g)*s/(s-1));case e.Last:return h}throw"Invalid aggregate type."}}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),wijmo;!function(t){!function(e){"use strict";var n;!function(t){t[t.Add=0]="Add",t[t.Remove=1]="Remove",t[t.Change=2]="Change",t[t.Reset=3]="Reset"}(n=e.NotifyCollectionChangedAction||(e.NotifyCollectionChangedAction={}));var r=function(t){function e(e,r,i){void 0===e&&(e=n.Reset),void 0===r&&(r=null),void 0===i&&(i=-1);var o=t.call(this)||this;return o.action=e,o.item=r,o.index=i,o}return __extends(e,t),e.reset=new e(n.Reset),e}(t.EventArgs);e.NotifyCollectionChangedEventArgs=r;var i=function(){function e(e,n){this._bnd=new t.Binding(e),this._asc=n}return Object.defineProperty(e.prototype,"property",{get:function(){return this._bnd.path},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"ascending",{get:function(){return this._asc},enumerable:!0,configurable:!0}),e}();e.SortDescription=i;var o=function(t){function e(e){var n=t.call(this)||this;return n.newPageIndex=e,n}return __extends(e,t),e}(t.CancelEventArgs);e.PageChangingEventArgs=o;var s=function(){function t(){}return t.prototype.groupNameFromItem=function(t,e){return""},t.prototype.namesMatch=function(t,e){return t===e},t}();e.GroupDescription=s;var a=function(e){function n(n,r){var i=e.call(this)||this;return i._bnd=new t.Binding(n),i._converter=r,i}return __extends(n,e),Object.defineProperty(n.prototype,"propertyName",{get:function(){return this._bnd.path},enumerable:!0,configurable:!0}),n.prototype.groupNameFromItem=function(t,e){return this._converter?this._converter(t,this.propertyName):this._bnd.getValue(t)},n.prototype.namesMatch=function(t,e){return t===e},n}(s);e.PropertyGroupDescription=a}(t.collections||(t.collections={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),wijmo;!function(t){!function(e){"use strict";var n=function(t){function e(){var e=this;return r?e.length=0:e=t.call(this)||this,e}return __extends(e,t),e}(Array);e.ArrayBase=n;var r=!0;try{n.prototype=Array.prototype,r=n.prototype===Array.prototype}catch(t){r=!1}var i=window.Symbol;!r&&i&&i.species&&Object.defineProperty(n,i.species,{get:function(){return Array},enumerable:!1,configurable:!1});var o=function(n){function r(e){var r=n.call(this)||this;if(r._updating=0,r.collectionChanged=new t.Event,e){e=t.asArray(e),r._updating++;for(var i=0;i<e.length;i++)r.push(e[i]);r._updating--}return r}return __extends(r,n),r.prototype.push=function(){for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];for(var i=this.length,o=0;t&&o<t.length;o++)i=n.prototype.push.call(this,t[o]),this._updating||this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Add,t[o],i-1);return i},r.prototype.pop=function(){var t=n.prototype.pop.call(this);return this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Remove,t,this.length),t},r.prototype.splice=function(t,r,i){var o;return r&&i?(o=n.prototype.splice.call(this,t,r,i),1==r?this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Change,i,t):this._raiseCollectionChanged(),o):i?(o=n.prototype.splice.call(this,t,0,i),this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Add,i,t),o):(o=n.prototype.splice.call(this,t,r),1==r?this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Remove,o[0],t):this._raiseCollectionChanged(),o)},r.prototype.slice=function(t,e){return n.prototype.slice.call(this,t,e)},r.prototype.indexOf=function(t,e){return n.prototype.indexOf.call(this,t,e)},r.prototype.sort=function(t){var e=n.prototype.sort.call(this,t);return this._raiseCollectionChanged(),e},r.prototype.insert=function(t,e){this.splice(t,0,e)},r.prototype.remove=function(t){var e=this.indexOf(t);return e>-1&&(this.removeAt(e),!0)},r.prototype.removeAt=function(t){this.splice(t,1)},r.prototype.setAt=function(t,e){t>this.length&&(this.length=t),this.splice(t,1,e)},r.prototype.clear=function(){0!==this.length&&(this.splice(0,this.length),this._raiseCollectionChanged())},r.prototype.beginUpdate=function(){this._updating++},r.prototype.endUpdate=function(){this._updating>0&&(this._updating--,0==this._updating&&this._raiseCollectionChanged())},Object.defineProperty(r.prototype,"isUpdating",{get:function(){return this._updating>0},enumerable:!0,configurable:!0}),r.prototype.deferUpdate=function(t){try{this.beginUpdate(),t()}finally{this.endUpdate()}},r.prototype.implementsInterface=function(t){return"INotifyCollectionChanged"==t},r.prototype.onCollectionChanged=function(t){void 0===t&&(t=e.NotifyCollectionChangedEventArgs.reset),this.isUpdating||this.collectionChanged.raise(this,t)},r.prototype._raiseCollectionChanged=function(t,n,r){if(void 0===t&&(t=e.NotifyCollectionChangedAction.Reset),!this.isUpdating){var i=new e.NotifyCollectionChangedEventArgs(t,n,r);this.onCollectionChanged(i)}},r}(n);e.ObservableArray=o}(t.collections||(t.collections={}))}(wijmo||(wijmo={}));var wijmo;!function(t){!function(e){"use strict";var n=function(){function n(n,r){var i=this;this._idx=-1,this._srtDsc=new e.ObservableArray,this._grpDesc=new e.ObservableArray,this._newItem=null,this._edtItem=null,this._pgSz=0,this._pgIdx=0,this._updating=0,this._stableSort=!1,this._canFilter=!0,this._canGroup=!0,this._canSort=!0,this._canAddNew=!0,this._canCancelEdit=!0,this._canRemove=!0,this._canChangePage=!0,this._trackChanges=!1,this._chgAdded=new e.ObservableArray,this._chgRemoved=new e.ObservableArray,this._chgEdited=new e.ObservableArray,this.collectionChanged=new t.Event,this.sourceCollectionChanging=new t.Event,this.sourceCollectionChanged=new t.Event,this.currentChanged=new t.Event,this.currentChanging=new t.Event,this.pageChanged=new t.Event,this.pageChanging=new t.Event,this._srtDsc.collectionChanged.addHandler(function(){for(var n=i._srtDsc,r=0;r<n.length;r++)t.assert(n[r]instanceof e.SortDescription,"sortDescriptions array must contain SortDescription objects.");i.canSort&&i.refresh()}),this._grpDesc.collectionChanged.addHandler(function(){for(var n=i._grpDesc,r=0;r<n.length;r++)t.assert(n[r]instanceof e.GroupDescription,"groupDescriptions array must contain GroupDescription objects.");i.canGroup&&i.refresh()}),this.sourceCollection=n||new e.ObservableArray,r&&(this.beginUpdate(),t.copy(this,r),this.endUpdate())}return n.prototype._copy=function(n,r){if("sortDescriptions"==n){this.sortDescriptions.clear();for(var i=t.asArray(r),o=0;o<i.length;o++){s=i[o];t.isString(s)&&(s=new e.SortDescription(s,!0)),this.sortDescriptions.push(s)}return!0}if("groupDescriptions"==n){this.groupDescriptions.clear();for(var i=t.asArray(r),o=0;o<i.length;o++){var s=i[o];t.isString(s)&&(s=new e.PropertyGroupDescription(s)),this.groupDescriptions.push(s)}return!0}return!1},Object.defineProperty(n.prototype,"newItemCreator",{get:function(){return this._itemCreator},set:function(e){this._itemCreator=t.asFunction(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"sortConverter",{get:function(){return this._srtCvt},set:function(e){e!=this._srtCvt&&(this._srtCvt=t.asFunction(e,!0))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"sortComparer",{get:function(){return this._srtCmp},set:function(e){e!=this._srtCmp&&(this._srtCmp=t.asFunction(e,!0))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"useStableSort",{get:function(){return this._stableSort},set:function(e){this._stableSort=t.asBoolean(e)},enumerable:!0,configurable:!0}),n.prototype.getAggregate=function(e,n,r){var i=r?this._pgView:this._view;return t.getAggregate(e,i,n)},Object.defineProperty(n.prototype,"trackChanges",{get:function(){return this._trackChanges},set:function(e){this._trackChanges=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemsAdded",{get:function(){return this._chgAdded},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemsRemoved",{get:function(){return this._chgRemoved},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemsEdited",{get:function(){return this._chgEdited},enumerable:!0,configurable:!0}),n.prototype.clearChanges=function(){this._chgAdded.clear(),this._chgRemoved.clear(),this._chgEdited.clear()},n.prototype.implementsInterface=function(t){switch(t){case"ICollectionView":case"IEditableCollectionView":case"IPagedCollectionView":case"INotifyCollectionChanged":return!0}return!1},Object.defineProperty(n.prototype,"getError",{get:function(){return this._getError},set:function(e){this._getError=t.asFunction(e)},enumerable:!0,configurable:!0}),n.prototype.onCollectionChanged=function(t){void 0===t&&(t=e.NotifyCollectionChangedEventArgs.reset),t.action!=e.NotifyCollectionChangedAction.Change||this._committing||this._canceling||t.item==this.currentEditItem||t.item==this.currentAddItem||this._trackItemChanged(t.item),this.collectionChanged.raise(this,t)},n.prototype._raiseCollectionChanged=function(t,n,r){void 0===t&&(t=e.NotifyCollectionChangedAction.Reset);var i=new e.NotifyCollectionChangedEventArgs(t,n,r);this.onCollectionChanged(i)},n.prototype._notifyItemChanged=function(t){var n=new e.NotifyCollectionChangedEventArgs(e.NotifyCollectionChangedAction.Change,t,this.items.indexOf(t));this.onCollectionChanged(n)},n.prototype.onSourceCollectionChanging=function(t){return this.sourceCollectionChanging.raise(this,t),!t.cancel},n.prototype.onSourceCollectionChanged=function(t){this.sourceCollectionChanged.raise(this,t)},Object.defineProperty(n.prototype,"canFilter",{get:function(){return this._canFilter},set:function(e){this._canFilter=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"canGroup",{get:function(){return this._canGroup},set:function(e){this._canGroup=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"canSort",{get:function(){return this._canSort},set:function(e){this._canSort=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"currentItem",{get:function(){return this._pgView&&this._idx>-1&&this._idx<this._pgView.length?this._pgView[this._idx]:null},set:function(t){this.moveCurrentTo(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"currentPosition",{get:function(){return this._idx},set:function(e){this.moveCurrentToPosition(t.asNumber(e))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"filter",{get:function(){return this._filter},set:function(e){this._filter!=e&&(this._filter=t.asFunction(e),this.canFilter&&this.refresh())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"groupDescriptions",{get:function(){return this._grpDesc},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"groups",{get:function(){return this._groups},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isEmpty",{get:function(){return!this._pgView||!this._pgView.length},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"sortDescriptions",{get:function(){return this._srtDsc},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"sourceCollection",{get:function(){return this._src},set:function(e){if(e!=this._src){if(!this.onSourceCollectionChanging(new t.CancelEventArgs))return;var n=this.currentPosition;this.commitEdit(),this.commitNew(),null!=this._ncc&&this._ncc.collectionChanged.removeHandler(this._sourceChanged),this._src=t.asArray(e,!1),this._ncc=t.tryCast(this._src,"INotifyCollectionChanged"),this._ncc&&this._ncc.collectionChanged.addHandler(this._sourceChanged,this),this.clearChanges(),this.refresh(),this.moveCurrentToFirst(),this.onSourceCollectionChanged(),this.currentPosition<0&&n>-1&&this.onCurrentChanged()}},enumerable:!0,configurable:!0}),n.prototype._sourceChanged=function(t,e){this._updating<=0&&this.refresh()},n.prototype.contains=function(t){return this._pgView.indexOf(t)>-1},n.prototype.moveCurrentTo=function(t){return this.moveCurrentToPosition(this._pgView.indexOf(t))},n.prototype.moveCurrentToFirst=function(){return this.moveCurrentToPosition(0)},n.prototype.moveCurrentToLast=function(){return this.moveCurrentToPosition(this._pgView.length-1)},n.prototype.moveCurrentToPrevious=function(){return this._idx>0&&this.moveCurrentToPosition(this._idx-1)},n.prototype.moveCurrentToNext=function(){return this.moveCurrentToPosition(this._idx+1)},n.prototype.moveCurrentToPosition=function(e){if(e>=-1&&e<this._pgView.length&&e!=this._idx){var n=new t.CancelEventArgs;if(this.onCurrentChanging(n)){var r=this._pgView[e];this._edtItem&&r!=this._edtItem&&this.commitEdit(),this._newItem&&r!=this._newItem&&this.commitNew(),this._idx=e,this.onCurrentChanged()}}return this._idx==e},n.prototype.refresh=function(){this._newItem||this._edtItem?this._pendingRefresh=!0:this._updating<=0&&(this._performRefresh(),this.onCollectionChanged())},n.prototype._performRefresh=function(){if(!(this._updating>0)){this._pendingRefresh=!1;var e=this.currentItem;this._view=this._src?this._performFilter(this._src):[],this.canSort&&this._srtDsc.length>0&&(this._view==this._src&&(this._view=this._src.slice()),this._performSort(this._view)),this._groups=this.canGroup?this._createGroups(this._view):null,this._fullGroups=this._groups,this._groups&&(this._view=this._mergeGroupItems(this._groups)),this._pgIdx=t.clamp(this._pgIdx,0,this.pageCount-1),this._pgView=this._getPageView(),this._groups&&this.pageCount>1&&(this._groups=this._createGroups(this._pgView),this._mergeGroupItems(this._groups));var n=this._pgView.indexOf(e);n<0&&(n=Math.min(this._idx,this._pgView.length-1)),this._idx=n,this._digest=this._getGroupsDigest(this.groups),this.currentItem!==e&&this.onCurrentChanged()}},n.prototype._performSort=function(t){if(this._stableSort){var e=t.map(function(t,e){return{item:t,index:e}}),n=this._compareItems();e.sort(function(t,e){var r=n(t.item,e.item);return 0==r?t.index-e.index:r});for(var r=0;r<t.length;r++)t[r]=e[r].item}else t.sort(this._compareItems())},n.prototype._compareItems=function(){var t=this._srtDsc,e=this._srtCvt,n=this._srtCmp,r=!0,i=0;return function(o,s){for(var a=0;a<t.length;a++){var u=t[a],c=u._bnd.getValue(o),l=u._bnd.getValue(s);if(e&&(c=e(u,o,c,r),l=e(u,s,l,!1),r=!1),n&&null!=(i=n(c,l)))return u.ascending?+i:-i;if(c!==c&&(c=null),l!==l&&(l=null),"string"==typeof c&&"string"==typeof l){var h=c.toLowerCase(),p=l.toLowerCase();h!=p&&(c=h,l=p)}if(null!=c&&null==l)return-1;if(null==c&&null!=l)return 1;if(0!=(i=c<l?-1:c>l?1:0))return u.ascending?+i:-i}return 0}},n.prototype._performFilter=function(t){return this.canFilter&&this._filter?t.filter(this._filter,this):t},n.prototype.onCurrentChanged=function(e){void 0===e&&(e=t.EventArgs.empty),this.currentChanged.raise(this,e)},n.prototype.onCurrentChanging=function(t){return this.currentChanging.raise(this,t),!t.cancel},Object.defineProperty(n.prototype,"items",{get:function(){return this._pgView},enumerable:!0,configurable:!0}),n.prototype.beginUpdate=function(){this._updating++},n.prototype.endUpdate=function(){this._updating--,this._updating<=0&&this.refresh()},Object.defineProperty(n.prototype,"isUpdating",{get:function(){return this._updating>0},enumerable:!0,configurable:!0}),n.prototype.deferUpdate=function(t){try{this.beginUpdate(),t()}finally{this.endUpdate()}},Object.defineProperty(n.prototype,"canAddNew",{get:function(){return this._canAddNew},set:function(e){this._canAddNew=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"canCancelEdit",{get:function(){return this._canCancelEdit},set:function(e){this._canCancelEdit=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"canRemove",{get:function(){return this._canRemove},set:function(e){this._canRemove=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"currentAddItem",{get:function(){return this._newItem},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"currentEditItem",{get:function(){return this._edtItem},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isAddingNew",{get:function(){return null!=this._newItem},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isEditingItem",{get:function(){return null!=this._edtItem},enumerable:!0,configurable:!0}),n.prototype.editItem=function(t){t!=this._edtItem&&this.moveCurrentTo(t)&&(this.commitEdit(),this._edtItem=t,this._edtClone={},this._extend(this._edtClone,this._edtItem))},n.prototype.commitEdit=function(){var t=this._edtItem;if(null!=t){this._committing=!0;var n=this._sameContent(t,this._edtClone),r=this._pendingRefresh;this._edtItem=null,this._edtClone=null;var i=this._pgView.indexOf(t),o=this._digest;this._performRefresh(),n||this._trackItemChanged(t),this._pgView.indexOf(t)!=i||o!=this._digest||r?this._raiseCollectionChanged():this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Change,t,i),this._committing=!1}},n.prototype.cancelEdit=function(){var n=this._edtItem;if(null!=n){if(this._edtItem=null,!this.canCancelEdit)return void t.assert(!1,"cannot cancel edits (canCancelEdit == false).");var r=this._src.indexOf(n);r>=0&&this._edtClone&&(this._extend(this._src[r],this._edtClone),this._edtClone=null,this._canceling=!0,this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Change,n,r),this._canceling=!1,this._pendingRefresh&&(this._performRefresh(),this._raiseCollectionChanged()))}},n.prototype.addNew=function(){if(arguments.length>0&&t.assert(!1,"addNew does not take any parameters, it creates the new items."),this.commitEdit(),this.commitNew(),!this.canAddNew)return t.assert(!1,"cannot add items (canAddNew == false)."),null;var n=null,r=this.sourceCollection;if(null!=(n=this.newItemCreator?this.newItemCreator():r&&r.length?new r[0].constructor:{})){if(this._newItem=n,this._updating++,this._src.push(n),this._updating--,this._pgView!=this._src&&this._pgView.push(n),this.groups&&this.groups.length){var i=this.groups[this.groups.length-1];for(i.items.push(n);i.groups&&i.groups.length;)(i=i.groups[i.groups.length-1]).items.push(n)}this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Add,n,this._pgView.length-1),this.moveCurrentTo(n)}return this._newItem},n.prototype.commitNew=function(){var t=this._newItem;if(null!=t){this._newItem=null;var n=this._pgView.indexOf(t),r=this._digest;if(this._performRefresh(),this._trackChanges){var i=this._chgEdited.indexOf(t);i>-1&&this._chgEdited.removeAt(i),this._chgAdded.indexOf(t)<0&&this._chgAdded.push(t)}this._pgView.indexOf(t)==n&&r==this._digest?this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Change,t,n):this._raiseCollectionChanged()}},n.prototype.cancelNew=function(){var t=this._newItem;null!=t&&this.remove(t)},n.prototype.remove=function(n){var r=n==this._newItem;if(r&&(this._newItem=null),n==this._edtItem&&this.cancelEdit(),this.canRemove){var i=this._src.indexOf(n);if(i>-1){var o=this.currentItem;this._updating++,this._src.splice(i,1),this._updating--;var s=this._digest;if(this._performRefresh(),this._trackChanges){var a=this._chgAdded.indexOf(n);a>-1&&this._chgAdded.removeAt(a);var u=this._chgEdited.indexOf(n);u>-1&&this._chgEdited.removeAt(u),this._chgRemoved.indexOf(n)<0&&!r&&a<0&&this._chgRemoved.push(n)}var c=this.sortDescriptions.length>0,l=this.pageSize>0&&this._pgIdx>-1;c||l||s!=this._getGroupsDigest(this.groups)?this._raiseCollectionChanged():this._raiseCollectionChanged(e.NotifyCollectionChangedAction.Remove,n,i),this.currentItem!==o&&this.onCurrentChanged()}}else t.assert(!1,"cannot remove items (canRemove == false).")},n.prototype.removeAt=function(e){e=t.asInt(e),this.remove(this._pgView[e])},n.prototype._trackItemChanged=function(t){if(this._trackChanges){var n=this.sourceCollection;if(n&&n.indexOf(t)>-1){var r=this._chgEdited.indexOf(t),i=e.NotifyCollectionChangedAction.Change;if(r<0&&this._chgAdded.indexOf(t)<0)this._chgEdited.push(t);else if(r>-1){o=new e.NotifyCollectionChangedEventArgs(i,t,r);this._chgEdited.onCollectionChanged(o)}else if((r=this._chgAdded.indexOf(t))>-1){var o=new e.NotifyCollectionChangedEventArgs(i,t,r);this._chgAdded.onCollectionChanged(o)}}}},n.prototype._extend=function(t,e){for(var n in e)t[n]=e[n]},n.prototype._sameContent=function(t,e){for(var n in e)if(!this._sameValue(t[n],e[n]))return!1;for(var n in t)if(!this._sameValue(t[n],e[n]))return!1;return!0},n.prototype._sameValue=function(e,n){return e===n||t.DateTime.equals(e,n)},Object.defineProperty(n.prototype,"canChangePage",{get:function(){return this._canChangePage},set:function(e){this._canChangePage=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isPageChanging",{get:function(){return!1},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemCount",{get:function(){return this._pgView.length},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"pageIndex",{get:function(){return this._pgIdx},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"pageSize",{get:function(){return this._pgSz},set:function(e){e!=this._pgSz&&(this._pgSz=t.asInt(e),this.refresh())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"totalItemCount",{get:function(){return this._view.length},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"pageCount",{get:function(){return this.pageSize?Math.ceil(this.totalItemCount/this.pageSize):1},enumerable:!0,configurable:!0}),n.prototype.moveToFirstPage=function(){return this.moveToPage(0)},n.prototype.moveToLastPage=function(){return this.moveToPage(this.pageCount-1)},n.prototype.moveToPreviousPage=function(){return this.moveToPage(this.pageIndex-1)},n.prototype.moveToNextPage=function(){return this.moveToPage(this.pageIndex+1)},n.prototype.moveToPage=function(n){var r=t.clamp(n,0,this.pageCount-1);if(r!=this._pgIdx){this.canChangePage||t.assert(!1,"cannot change pages (canChangePage == false).");var i=new e.PageChangingEventArgs(r);this.onPageChanging(i)&&(this._pgIdx=r,this._pgView=this._getPageView(),this._idx=0,this.groupDescriptions&&0!=this.groupDescriptions.length?this.refresh():this.onCollectionChanged(),this.onPageChanged())}return this._pgIdx==n},n.prototype.onPageChanged=function(e){void 0===e&&(e=t.EventArgs.empty),this.pageChanged.raise(this,e)},n.prototype.onPageChanging=function(t){return this.pageChanging.raise(this,t),!t.cancel},n.prototype._getFullGroup=function(t){var e=this._getGroupByPath(this._fullGroups,t.level,t._path);return null!=e&&(t=e),t},n.prototype._getGroupByPath=function(t,e,n){for(var r=0;r<t.length;r++){var i=t[r];if(i.level==e&&i._path==n)return i;if(i.level<e&&0==n.indexOf(i._path)&&null!=(i=this._getGroupByPath(i.groups,e,n)))return i}return null},n.prototype._getPageView=function(){if(this.pageSize<=0||this._pgIdx<0)return this._view;var t=this._pgSz*this._pgIdx,e=Math.min(t+this._pgSz,this._view.length);return this._view.slice(t,e)},n.prototype._createGroups=function(e){if(!this._grpDesc||!this._grpDesc.length)return null;for(var n=[],r={},i=null,o=0;o<e.length;o++)for(var s=e[o],a=n,u=this._grpDesc.length,c="",l=0;l<u;l++){var h=this._grpDesc[l],p=h.groupNameFromItem(s,l),f=l==u-1;!(i=r[c])&&t.isPrimitive(p)&&(i={},r[c]=i);var d=this._getGroup(h,a,i,p,l,f);c+="/"+p,d._path=c,f&&d.items.push(s),a=d.groups}return n},n.prototype._getGroupsDigest=function(t){for(var e="",n=0;null!=t&&n<t.length;n++){var r=t[n];e+="{"+r.name+":"+(r.items?r.items.length:"*"),r.groups.length>0&&(e+=",",e+=this._getGroupsDigest(r.groups)),e+="}"}return e},n.prototype._mergeGroupItems=function(t){for(var e=[],n=0;n<t.length;n++){var r=t[n];if(!r._isBottomLevel)for(var i=this._mergeGroupItems(r.groups),o=0,s=i.length;o<s;o++)r._items.push(i[o]);for(var o=0,s=r._items.length;o<s;o++)e.push(r._items[o])}return e},n.prototype._getGroup=function(e,n,i,o,s,a){var u;if(i&&t.isPrimitive(o)){if(u=i[o])return u}else for(var c=0;c<n.length;c++)if(e.namesMatch(n[c].name,o))return n[c];var l=new r(e,o,s,a);return n.push(l),i&&(i[o]=l),l},n}();e.CollectionView=n;var r=function(){function e(t,e,n,r){this._gd=t,this._name=e,this._level=n,this._isBottomLevel=r,this._groups=[],this._items=[]}return Object.defineProperty(e.prototype,"name",{get:function(){return this._name},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"level",{get:function(){return this._level},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isBottomLevel",{get:function(){return this._isBottomLevel},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"items",{get:function(){return this._items},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"groups",{get:function(){return this._groups},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"groupDescription",{get:function(){return this._gd},enumerable:!0,configurable:!0}),e.prototype.getAggregate=function(e,r,i){var o=t.tryCast(i,n),s=o?o._getFullGroup(this):this;return t.getAggregate(e,s.items,r)},e}();e.CollectionViewGroup=r}(t.collections||(t.collections={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),wijmo;!function(t){"use strict";var e=function(){function e(e){this._showAutoTipBnd=this._showAutoTip.bind(this),this._hideAutoTipBnd=this._hideAutoTip.bind(this),this._html=!0,this._gap=6,this._showAtMouse=!1,this._showDelay=500,this._hideDelay=0,this._tips=[],this.popup=new t.Event,t.copy(this,e)}return e.prototype.setTooltip=function(e,n){e=t.getElement(e),n=this._getContent(n);var r=this._indexOf(e);r>-1&&(this._detach(e),this._tips.splice(r,1)),n&&(this._attach(e),this._tips.push({element:e,content:n}))},e.prototype.getTooltip=function(e){e=t.getElement(e);for(var n=this._tips,r=0;r<n.length;r++)if(n[r].element==e)return n[r].content;return null},e.prototype.show=function(r,i,o){r=t.getElement(r),i=this._getContent(i),o||(o=t.Rect.fromBoundingRect(r.getBoundingClientRect()));var s=e._eTip;s||(s=e._eTip=document.createElement("div"),t.addClass(s,"wj-tooltip"),s.style.visibility="none"),this._setContent(i);var a=new n(i);this.onPopup(a),a.content&&!a.cancel&&(document.body.appendChild(s),this._setContent(a.content),s.style.minWidth="",o=new t.Rect(o.left-(s.offsetWidth-o.width)/2,o.top-this.gap,s.offsetWidth,o.height+2*this.gap),t.showPopup(s,o,!0),document.addEventListener("mousedown",this._hideAutoTipBnd))},e.prototype.hide=function(){var n=e._eTip;n&&(t.removeChild(n),n.innerHTML=""),document.removeEventListener("mousedown",this._hideAutoTipBnd)},e.prototype.dispose=function(){var t=this;this._tips.forEach(function(e){t._detach(e.element)}),this._tips.splice(0,this._tips.length)},Object.defineProperty(e.prototype,"isVisible",{get:function(){var t=e._eTip;return null!=t&&null!=t.parentElement&&t.offsetWidth>0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isContentHtml",{get:function(){return this._html},set:function(e){this._html=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"gap",{get:function(){return this._gap},set:function(e){this._gap=t.asNumber(e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"showAtMouse",{get:function(){return this._showAtMouse},set:function(e){this._showAtMouse=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"showDelay",{get:function(){return this._showDelay},set:function(e){this._showDelay=t.asInt(e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"hideDelay",{get:function(){return this._hideDelay},set:function(e){this._hideDelay=t.asInt(e)},enumerable:!0,configurable:!0}),e.prototype.onPopup=function(t){return this.popup&&this.popup.raise(this,t),!t.cancel},e.prototype._indexOf=function(t){for(var e=0;e<this._tips.length;e++)if(this._tips[e].element==t)return e;return-1},e.prototype._attach=function(t){t.addEventListener("mouseenter",this._showAutoTipBnd),t.addEventListener("mouseleave",this._hideAutoTipBnd),t.addEventListener("click",this._showAutoTipBnd)},e.prototype._detach=function(t){t.removeEventListener("mouseenter",this._showAutoTipBnd),t.removeEventListener("mouseleave",this._hideAutoTipBnd),t.removeEventListener("click",this._showAutoTipBnd)},e.prototype._showAutoTip=function(e){var n=this;if(!e.defaultPrevented)if("click"!=e.type||t.Control._touching){var r="mouseenter"==e.type?this._showDelay:0;this._clearTimeouts(),this._toShow=setTimeout(function(){var r=n._indexOf(e.target);if(r>-1){var i=n._tips[r],o=n._showAtMouse?new t.Rect(e.clientX,e.clientY,0,0):null;n.show(i.element,i.content,o),n._hideDelay>0&&(n._toHide=setTimeout(function(){n.hide()},n._hideDelay))}},r)}else this._hideAutoTip()},e.prototype._hideAutoTip=function(){this._clearTimeouts(),this.hide()},e.prototype._clearTimeouts=function(){this._toShow&&(clearTimeout(this._toShow),this._toShow=null),this._toHide&&(clearTimeout(this._toHide),this._toHide=null)},e.prototype._getContent=function(e){if((e=t.asString(e))&&"#"==e[0]){var n=t.getElement(e);n&&(e=n.innerHTML)}return e},e.prototype._setContent=function(t){var n=e._eTip;n&&(this.isContentHtml?n.innerHTML=t:n.textContent=t)},e}();t.Tooltip=e;var n=function(e){function n(n){var r=e.call(this)||this;return r._content=t.asString(n),r}return __extends(n,e),Object.defineProperty(n.prototype,"content",{get:function(){return this._content},set:function(e){this._content=t.asString(e)},enumerable:!0,configurable:!0}),n}(t.CancelEventArgs);t.TooltipEventArgs=n}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";var e=function(){function e(t){this._r=0,this._g=0,this._b=0,this._a=1,t&&this._parse(t)}return Object.defineProperty(e.prototype,"r",{get:function(){return this._r},set:function(e){this._r=t.clamp(t.asNumber(e),0,255)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"g",{get:function(){return this._g},set:function(e){this._g=t.clamp(t.asNumber(e),0,255)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"b",{get:function(){return this._b},set:function(e){this._b=t.clamp(t.asNumber(e),0,255)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"a",{get:function(){return this._a},set:function(e){this._a=t.clamp(t.asNumber(e),0,1)},enumerable:!0,configurable:!0}),e.prototype.equals=function(t){return t instanceof e&&this.r==t.r&&this.g==t.g&&this.b==t.b&&this.a==t.a},e.prototype.toString=function(){var t=Math.round(100*this.a);return t>99?"#"+((1<<24)+(this.r<<16)+(this.g<<8)+this.b).toString(16).slice(1):"rgba("+this.r+","+this.g+","+this.b+","+t/100+")"},e.fromRgba=function(n,r,i,o){void 0===o&&(o=1);var s=new e(null);return s.r=Math.round(t.clamp(t.asNumber(n),0,255)),s.g=Math.round(t.clamp(t.asNumber(r),0,255)),s.b=Math.round(t.clamp(t.asNumber(i),0,255)),s.a=t.clamp(t.asNumber(o),0,1),s},e.fromHsb=function(n,r,i,o){void 0===o&&(o=1);var s=e._hsbToRgb(t.clamp(t.asNumber(n),0,1),t.clamp(t.asNumber(r),0,1),t.clamp(t.asNumber(i),0,1));return e.fromRgba(s[0],s[1],s[2],o)},e.fromHsl=function(n,r,i,o){void 0===o&&(o=1);var s=e._hslToRgb(t.clamp(t.asNumber(n),0,1),t.clamp(t.asNumber(r),0,1),t.clamp(t.asNumber(i),0,1));return e.fromRgba(s[0],s[1],s[2],o)},e.fromString=function(n){var r=new e(null);return r._parse(t.asString(n))?r:null},e.prototype.getHsb=function(){return e._rgbToHsb(this.r,this.g,this.b)},e.prototype.getHsl=function(){return e._rgbToHsl(this.r,this.g,this.b)},e.interpolate=function(n,r,i){i=t.clamp(t.asNumber(i),0,1);var o=e._rgbToHsl(n.r,n.g,n.b),s=e._rgbToHsl(r.r,r.g,r.b),a=1-i,u=n.a*a+r.a*i,c=[o[0]*a+s[0]*i,o[1]*a+s[1]*i,o[2]*a+s[2]*i],l=e._hslToRgb(c[0],c[1],c[2]);return e.fromRgba(l[0],l[1],l[2],u)},e.toOpaque=function(n,r){if(1==(n=t.isString(n)?e.fromString(n):t.asType(n,e)).a)return n;r=null==r?e.fromRgba(255,255,255,1):t.isString(r)?e.fromString(r):t.asType(r,e);var i=n.a,o=1-i;return e.fromRgba(n.r*i+r.r*o,n.g*i+r.g*o,n.b*i+r.b*o)},e.prototype._parse=function(n){if("transparent"==(n=n.toLowerCase()))return this._r=this._g=this._b=this._a=0,!0;if(n&&0!=n.indexOf("#")&&0!=n.indexOf("rgb")&&0!=n.indexOf("hsl")){var r=document.createElement("div");r.style.color=n;var i=r.style.color;i==n&&((i=window.getComputedStyle(r).color)||(document.body.appendChild(r),i=window.getComputedStyle(r).color,t.removeChild(r))),n=i.toLowerCase()}if(0==n.indexOf("#"))return 4==n.length?(this.r=parseInt(n[1]+n[1],16),this.g=parseInt(n[2]+n[2],16),this.b=parseInt(n[3]+n[3],16),this.a=1,!0):7==n.length&&(this.r=parseInt(n.substr(1,2),16),this.g=parseInt(n.substr(3,2),16),this.b=parseInt(n.substr(5,2),16),this.a=1,!0);if(0==n.indexOf("rgb")){var o=n.indexOf("("),s=n.indexOf(")");if(o>-1&&s>-1&&(a=n.substr(o+1,s-(o+1)).split(",")).length>2)return this.r=parseInt(a[0]),this.g=parseInt(a[1]),this.b=parseInt(a[2]),this.a=a.length>3?parseFloat(a[3]):1,!0}if(0==n.indexOf("hsl")){var o=n.indexOf("("),s=n.indexOf(")");if(o>-1&&s>-1){var a=n.substr(o+1,s-(o+1)).split(",");if(a.length>2){var u=parseInt(a[0])/360,c=parseInt(a[1]),l=parseInt(a[2]);a[1].indexOf("%")>-1&&(c/=100),a[2].indexOf("%")>-1&&(l/=100);var h=e._hslToRgb(u,c,l);return this.r=h[0],this.g=h[1],this.b=h[2],this.a=a.length>3?parseFloat(a[3]):1,!0}}}return!1},e._hslToRgb=function(n,r,i){t.assert(n>=0&&n<=1&&r>=0&&r<=1&&i>=0&&i<=1,"bad HSL values");var o,s,a;if(0==r)o=s=a=i;else{var u=i<.5?i*(1+r):i+r-i*r,c=2*i-u;o=e._hue2rgb(c,u,n+1/3),s=e._hue2rgb(c,u,n),a=e._hue2rgb(c,u,n-1/3)}return[Math.round(255*o),Math.round(255*s),Math.round(255*a)]},e._hue2rgb=function(t,e,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?t+6*(e-t)*n:n<.5?e:n<2/3?t+(e-t)*(2/3-n)*6:t},e._rgbToHsl=function(e,n,r){t.assert(e>=0&&e<=255&&n>=0&&n<=255&&r>=0&&r<=255,"bad RGB values"),e/=255,n/=255,r/=255;var i,o,s=Math.max(e,n,r),a=Math.min(e,n,r),u=(s+a)/2;if(s==a)i=o=0;else{var c=s-a;switch(o=u>.5?c/(2-s-a):c/(s+a),s){case e:i=(n-r)/c+(n<r?6:0);break;case n:i=(r-e)/c+2;break;case r:i=(e-n)/c+4}i/=6}return[i,o,u]},e._rgbToHsb=function(n,r,i){t.assert(n>=0&&n<=255&&r>=0&&r<=255&&i>=0&&i<=255,"bad RGB values");var o=e._rgbToHsl(n,r,i);return e._hslToHsb(o[0],o[1],o[2])},e._hsbToRgb=function(t,n,r){var i=e._hsbToHsl(t,n,r);return e._hslToRgb(i[0],i[1],i[2])},e._hsbToHsl=function(e,n,r){t.assert(e>=0&&e<=1&&n>=0&&n<=1&&r>=0&&r<=1,"bad HSB values");var i=t.clamp(r*(2-n)/2,0,1),o=1-Math.abs(2*i-1),s=t.clamp(o>0?r*n/o:n,0,1);return t.assert(!isNaN(i)&&!isNaN(s),"bad conversion to HSL"),[e,s,i]},e._hslToHsb=function(e,n,r){t.assert(e>=0&&e<=1&&n>=0&&n<=1&&r>=0&&r<=1,"bad HSL values");var i=t.clamp(1==r?1:(2*r+n*(1-Math.abs(2*r-1)))/2,0,1),o=t.clamp(i>0?2*(i-r)/i:n,0,1);return t.assert(!isNaN(i)&&!isNaN(o),"bad conversion to HSB"),[e,o,i]},e}();t.Color=e}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";var e=function(){function e(){}return e.copy=function(n){e._copyPaste(t.asString(n),null)},e.paste=function(n){e._copyPaste(null,t.asFunction(n))},e._copyPaste=function(e,n){for(var r=t.getActiveElement(),i=t.closest(r,".wj-control");i&&t.Control.getControl(i);)i=i.parentElement;if(i=i||document.body){var o=t.createElement('<textarea class="wj-clipboard" style="position:fixed;opacity:0"/>',i);t.isString(e)&&(o.value=e),o.select(),o.onkeydown=function(t){t.preventDefault()},setTimeout(function(){r.focus(),t.removeChild(o),t.isFunction(n)&&n(o.value)},t.Control._CLIPBOARD_DELAY)}},e}();t.Clipboard=e}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";function e(e,n){e.style.display="none",n&&e.parentElement&&setTimeout(function(){"none"==e.style.display&&(t.removeChild(e),t.isFunction(n)&&n())},2*t.Control._FOCUS_INTERVAL);var r=e[t.Control._SCRL_KEY];r instanceof t.Control&&r.dispose(),delete e[t.Control._SCRL_KEY],delete e[t.Control._OWNR_KEY]}function n(e){var n=window.jQuery,r=t.isFunction(n)?n(e):null;return r&&t.isFunction(r.dialog)&&null!=r.dialog("instance")}t.showPopup=function(r,i,o,s,a){void 0===a&&(a=!0);var u=document.body;if(i instanceof HTMLElement){if(!t.contains(document.body,i))return;for(var c=i;c;c=c.parentElement)if(n(c)||"fixed"==getComputedStyle(c).position){u=c;break}}t.setCss(r,{display:"none",left:"",top:""}),r.offsetHeight&&r.offsetWidth&&t.contains(u,r)||u.lastChild!=r&&u.appendChild(r);var l=document.body,h=new t.Point(l.scrollLeft||pageXOffset,l.scrollTop||pageYOffset),p=document.documentElement,f=p.clientWidth/window.innerWidth;if(u!=l||f>1.005){var d=u==l?p:r.offsetParent||u;if(n(u)&&u.offsetParent&&(d=u.offsetParent),d){var g=d.getBoundingClientRect();h=new t.Point(d.scrollLeft-g.left,d.scrollTop-g.top)}}if(t.setCss(r,{position:"fixed",display:"",left:0,top:0}),r.offsetHeight&&r.offsetWidth&&t.contains(u,r)||u.lastChild!=r&&u.appendChild(r),i instanceof HTMLElement&&a){var m=getComputedStyle(i);new t.Color(m.backgroundColor).a&&t.setCss(r,{color:m.color,backgroundColor:m.backgroundColor,fontFamily:m.fontFamily,fontSize:m.fontSize,fontWeight:m.fontWeight,fontStyle:m.fontStyle})}t.setCss(r,{position:"fixed",display:""}),t.Control.refreshAll(r);var _=getComputedStyle(r),v=parseFloat(_.marginTop)+parseFloat(_.marginBottom),y=parseFloat(_.marginLeft)+parseFloat(_.marginRight),b=new t.Size(r.offsetWidth+y,r.offsetHeight+v),C=new t.Point,w=null,E=p.clientWidth,A=p.clientHeight;if(i&&null!=i.clientX&&null!=i.clientY&&null!=i.pageX&&null!=i.pageY)i.clientX<=0&&i.clientY<=0&&i.target?w=i.target.getBoundingClientRect():(C.x=Math.max(0,i.pageX-pageXOffset),C.y=Math.max(0,i.pageY-pageYOffset));else if(i instanceof t.Point)C=i;else if(i instanceof HTMLElement)w=i.getBoundingClientRect();else if(i&&null!=i.top&&null!=i.left)w=i;else{if(null!=i)throw"Invalid ref parameter.";C.x=Math.max(0,(E-b.width)/2),C.y=Math.max(0,Math.round((A-b.height)/2*.7))}var x=parseFloat(_.minWidth);if(w){var S=w.top,O=A-w.bottom,T="rtl"==getComputedStyle(r).direction;C.x=T?Math.max(0,w.right-b.width):Math.max(0,Math.min(w.left,E-b.width)),C.y=o?S>b.height||S>O?Math.max(0,w.top-b.height):w.bottom:O>b.height||O>S?w.bottom:Math.max(0,w.top-b.height),x=Math.max(x,w.width),t.isIE()&&(x-=r.offsetWidth-(r.clientWidth+parseInt(_.borderLeftWidth)+parseInt(_.borderRightWidth)))}else C.y+b.height>A-20&&(C.y=Math.max(0,A-20-b.height)),C.x+b.width>E-20&&(C.x=Math.max(0,E-20-b.width));var M={position:"absolute",left:C.x+h.x,top:C.y+h.y,minWidth:x,zIndex:1500},P=null;s&&(r.style.opacity="0",P=t.animate(function(t){r.style.opacity=t<1?t.toString():""})),i instanceof HTMLElement&&(r[t.Control._OWNR_KEY]=i),t.setCss(r,M);var F=i instanceof MouseEvent?i.target:i;if(F instanceof HTMLElement&&F.parentElement!=document.body){var I=Date.now(),D=F.getBoundingClientRect(),j=new t.Control(document.createElement("div"));r[t.Control._SCRL_KEY]=j,j.addEventListener(document,"scroll",function(n){if(Date.now()-I>100&&t.contains(document,F)&&!t.contains(r,n.target)&&(n.target!=document||null!=i&&"fixed"==r.style.position)){var o=F.getBoundingClientRect(),s=Math.abs(o.left-D.left),a=Math.abs(o.top-D.top);(s>1||a>1)&&e(r,!0)}},!0)}return P},t.hidePopup=function(n,r,i){void 0===r&&(r=!0),void 0===i&&(i=!1);var o=null;return i?o=t.animate(function(t){n.style.opacity=(1-t).toString(),1==t&&(e(n,r),n.style.opacity="")}):e(n,r),o}}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";var e=function(){function e(e){this._copyCss=!0,null!=e&&t.copy(this,e)}return Object.defineProperty(e.prototype,"title",{get:function(){return this._title},set:function(e){this._title=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"copyCss",{get:function(){return this._copyCss},set:function(e){this._copyCss=t.asBoolean(e)},enumerable:!0,configurable:!0}),e.prototype.addCSS=function(t){this._css||(this._css=[]),this._css.push(t)},e.prototype.append=function(e){var n=this._getDocument(),r=n.body,i=!1;if(r)if(t.isString(e))r.appendChild(t.createElement(e));else if(e instanceof Node){o=this._cloneNode(e);r.appendChild(o)}else i=!0;else if(t.isString(e))n.write(e);else if(e instanceof HTMLElement){var o=this._cloneNode(e);n.write(o.outerHTML)}else i=!0;i&&t.assert(!1,"child parameter should be an HTML node or an HTML string.")},e.prototype.print=function(){var e=this;this._iframe&&(this._close(),setTimeout(function(){var n=e._iframe.contentWindow,r="onafterprint"in n&&!t.isFirefox();r&&(n.onafterprint=function(){t.removeChild(e._iframe),e._iframe=null}),document.queryCommandSupported("print")?n.document.execCommand("print",!1,null):(n.focus(),n.print()),r||(t.removeChild(e._iframe),e._iframe=null)},100))},e.prototype._cloneNode=function(t){var e=t.cloneNode(!0);return t instanceof HTMLElement&&e instanceof HTMLElement&&["select","textarea"].forEach(function(n){for(var r=t.querySelectorAll(n),i=e.querySelectorAll(n),o=0;o<r.length;o++)i[o].value=r[o].value}),e},e.prototype._getDocument=function(){return this._iframe||(this._iframe=document.createElement("iframe"),t.addClass(this._iframe,"wj-printdocument"),t.setCss(this._iframe,{position:"fixed",left:1e4,top:1e4}),document.body.appendChild(this._iframe),this._iframe.contentDocument.write('<body style="position:static"/>')),this._iframe.contentDocument},e.prototype._close=function(){var e=this._getDocument();if(e.close(),e.title=null!=this.title?this.title:document.title,e.title&&e.title.trim()||(e.title=" "),this._copyCss){for(var n=document.head.querySelectorAll("link"),r=0;r<n.length;r++){var i=n[r];if(i.href.match(/\.css$/i)&&i.rel.match(/stylesheet/i)){a=t.httpRequest(i.href,{async:!1});this._addStyle(a.responseText)}}for(var o=document.head.querySelectorAll("STYLE"),r=0;r<o.length;r++)this._addStyle(o[r].textContent)}if(this._css)for(r=0;r<this._css.length;r++){var s=e.createElement("style"),a=t.httpRequest(this._css[r],{async:!1});s.textContent=a.responseText,e.head.appendChild(s)}},e.prototype._addStyle=function(t){var e=this._getDocument(),n=e.createElement("style");n.textContent=t,e.head.appendChild(n)},e}();t.PrintDocument=e}(wijmo||(wijmo={}));var theLic="The Wijmo license in this application ";wijmo.culture.Licensing=window.wijmo.culture.Licensing||{evl:"Wijmo Evaluation Version ({version})",prd:theLic+"is not valid for the <b>{control}</b> control.",ver:theLic+"is not valid for the version in use. The license version is <b>{licVer}</b>; the product version is <b>{version}</b>.",dmn:theLic+"is not valid for the current domain. The license domain is <b>{licDomain}</b>; the current domain is <b>{domain}</b>.",exp:theLic+"has expired. The license expiration date is <b>{expDate:d}</b>.",lic:theLic+"is invalid.",mss:theLic+"is not set.",ctc:'Please <a target="_blank" href="https://www.grapecity.com/en/licensing/wijmo">create a license</a> or contact GrapeCity: <a href="mailto:us.sales@grapecity.com">us.sales@grapecity.com</a>.',hdr:"Wijmo License",cls:"CLOSE"};var wijmo;!function(t){"use strict";function e(t){return t._getProductInfo().split(",")[0]}function n(t){return t._getProductInfo().split(",")[1]}function r(e,n,r){var c=t.culture.Licensing||M,h=null;r?o(e,r)?s(e,r)?a(e,r)?i(e,r)?u(e,r)&&(h=c.evl):h=c.prd:h=c.dmn:h=c.ver:h=c.exp:h=n?c.lic:c.mss,h&&l(e,h+="<br/><br/>"+c.ctc,r)}function i(t,n){var r=e(t);if(r&&r.length>=4)for(var i=0;i<n.Prd.length;i++)if(n.Prd[i].C.indexOf(r)>-1)return!0;return!1}function o(t,e){if(e.Exp){var n=e.Exp,r=new Date(parseInt(n.substr(0,4))||0,parseInt(n.substr(4,2))-1||0,parseInt(n.substr(6,2))||0);if(Math.ceil((r.valueOf()-Date.now())/864e5)<=0)return!1}return!0}function s(e,n){var r=n.Anl?n.Anl.ver:null,i=t.getVersion();return!r||!i||parseInt(r.replace("v",""))+10>=parseInt(i.split(".")[1])}function a(t,e){if(c()||!e.Dms)return!0;for(var n=location.hostname,r=e.Dms.split(","),i=!1,o=0;o<r.length;o++){var s=r[o];if(i=s&&0==s.lastIndexOf("*.",0),(s=i?s.slice(2):s)==n)return!0;if(i){var a=n.indexOf("."+s);if(a>0&&a==n.length-s.length-1)return!0}}return!1}function u(t,e){return!!e&&e.Evl}function c(){var t=atob("Xih8bG9jYWxob3N0fGZpZGRsZS5qc2hlbGwubmV0fHJ1bi5wbG5rci5jb3xzLmNvZGVwZW4uaW98bnVsbC5qc2Jpbi5jb218MTI3LjAuMC4xKSQ="),e=new RegExp(t,"i");return location.hostname.match(e)}function l(e,n,r){if(n=p(e,n,r),!P[" "]&&!c()&&!u(e,r)){P[" "]=!0;var i=t.culture.Licensing,o='<div style="position:fixed;background:rgba(0,0,0,0.3);left:0;top:0;width:100%;height:100%;font-family: sans-serif;z-index:10000;"><div style="position:relative;background:white;width:450px;padding:36pt;left:50%;top:50%;transform:translate(-50%,-50%)"><div><p style="font-size:150%;font-weight:bold">'+i.hdr+"</p><p>"+n+'</p></div><div style="text-align:right;margin-top:24pt"><button style="border:none;background:rgba(158,158,158,.2);padding:8px 16px">'+i.cls+"</button></div></div></div>",s=t.createElement(o,document.body);s.addEventListener("click",function(e){e.target instanceof HTMLButtonElement&&t.removeChild(s)})}if(!t.Control._wme){var o='<div><a href="'+h()+'" target="_blank">'+p(e)+"</a></div>",a=t.createElement(o),l={position:"fixed",display:"block",visibility:"visible",background:"rgba(240,240,240,.75)",padding:"8px 12px",margin:"6px",fontFamily:"sans-serif",fontSize:"14pt",fontWeight:"bold",zIndex:1e4,opacity:.8,height:"auto",width:"auto",transform:"none"};switch(Math.round(100*Math.random())%3){case 0:l.right=l.bottom=0;break;case 1:l.left=l.bottom=0;break;case 2:l.right=l.top=0}t.setCss(a,l),document.body.appendChild(a),t.Control._wme=a,(new t.Tooltip).setTooltip(a,n)}}function h(){return"ja"==t.culture.Globalize.name?"https://www.grapecity.co.jp/developer/support/wijmo-license":"https://www.grapecity.com/en/licensing/wijmo"}function p(e,r,i){(!r||r.trim().length<15)&&(r=(t.culture.Licensing||M).evl),(!r||r.trim().length<15)&&(r=atob("V2lqbW8gRXZhbHVhdGlvbiBWZXJzaW9uICh7dmVyc2lvbn0p"));var o=null;if(i&&i.Exp){var s=i.Exp;o=new Date(parseInt(s.substr(0,4))||0,parseInt(s.substr(4,2))-1||0,parseInt(s.substr(6,2))||0)}return r=t.format(r,{version:t.getVersion(),domain:location.hostname,control:n(e),licVer:i&&i.Anl?"5."+i.Anl.ver.replace("v","")+".*":null,licDomain:i?i.Dms:null,expDate:o})}function f(t,e,n,r){var i=d(t,e.algorithmCode);if(!i)return r();var o=i.licData,s=i.prefix+"#"+e.algorithmCode;if(O(s+JSON.stringify(o.D))!=o.H)return r();var a=window.msCrypto||window.crypto,u=a?a.subtle:null;if(!u)return n(o.D);var c={name:"RSASSA-PKCS1-v1_5",hash:{name:"SHA-256"}},l={alg:"RS256",e:"AQAB",kty:"RSA",n:x(e.publicKey)};l=window.msCrypto?S(JSON.stringify(l)):l;try{T(u.importKey("jwk",l,c,!1,["verify"])).then(function(t){var e=s+w(E(A(JSON.stringify(o.D))));T(u.verify(c,t,E(o.S),S(e))).then(function(t){return t?n(o.D):r()})},function(){return r()})}catch(t){return n(o.D)}}function d(t,e){try{e="#"+e;var n=t.indexOf(e);if(n>-1)return{prefix:t.substring(0,n),licData:JSON.parse(g(t.substr(n+e.length)))}}catch(t){}return null}function g(t){if(!t)return"";var e=m(t);e=b(e);var n=Math.ceil(e.length/2);return e=e.substr(n)+e.substr(0,n),e=e.replace("#","="),e=e.replace("&","=="),C(e)}function m(t){for(var e=t.split(""),n=e.length-5;n>=0;n--)_(e,n+1,n+3,y),_(e,n,n+2,y);return e.join("")}function _(t,e,n,r){t.length>1&&t.splice(n,1,r(t.splice(e,1,r(t[n]))[0]))}function v(t,e){var n=t.charCodeAt(0);return n>=65&&n<=90?t.toLowerCase():n>=97&&n<=122?t.toUpperCase():n>=48&&n<=57?String.fromCharCode(48+(n-48+10+e)%10):t}function y(t){return v(t,-1)}function b(t){return t.split("").reverse().join("")}function C(t){return decodeURIComponent(Array.prototype.map.call(atob(t),function(t){return"%"+("00"+t.charCodeAt(0).toString(16)).slice(-2)}).join(""))}function w(t){return String.fromCharCode.apply(null,new F(t))}function E(t){for(var e=atob(t),n=e.length,r=new F(n),i=0;i<n;i++)r[i]=e.charCodeAt(i);return r.buffer}function A(t){return btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,function(t,e){return String.fromCharCode(parseInt(e,16))}))}function x(t){return t.replace(/\+/g,"-").replace(/\//g,"_").replace(/\=+$/,"")}function S(t){for(var e=new ArrayBuffer(t.length),n=new F(e),r=0,i=t.length;r<i;r++)n[r]=t.charCodeAt(r);return e}function O(t){for(var e=0,n=5381,r=0,i=t.length-1;i>=0;i--){var o=t.charCodeAt(i);e=o+(e<<6)+(e<<16)-e,n=o+((n<<5)+n),r=o+((r<<5)-r),r&=r}var s=e^n^r;return s<0&&(s=~s),s.toString(16).toUpperCase()}function T(t){return"oncomplete"in t&&(t.then=function(e,n){t.resolve=e,t.reject=n},t.oncomplete=function(e){t.resolve(t.result)},t.onerror=function(e){t.reject()}),t}var M=t.culture.Licensing,P={};t._updateWme=function(n,i){var o=t.Control._wme;if(!(o&&t.contains(document.body,o)&&o.offsetWidth&&o.offsetHeight))if(i){var s=e(n);P[s]||(P[s]=!0,f(i,{algorithmCode:"B0",publicKey:"l6/zrbWoSbcLFwEetFh38rH3ErBZE9H+Cqix3R+wTlfA1wD5B+lUcCQn+EJ60I4RGrm0x1sFjkiLWwB0jAn6BWZv0W4WbqAKriOdeoivxDp1Wmjs3qkEDhvbsjPtfvwx2BHil6o+/tDrdMJQSGs18WZm2PoQLQuL+9VhZ4FNRHUQU3Jtioke/OZEGHJOdYVwvCGalzBad6QFOiVbDBQPePpS3++GJzOxN8SN/7lyS5/IdKiy3WJRaVGkB370+HbN6hKraDfUgReLX26yxRaKC/5aWnGAJ2NnWLoGyAGRcwT9dVjo4bcAZNrrA0U9JVKQxaSskhdv2p49XzJkltXx5w=="},function(t){r(n,i,t)},function(){r(n,i,null)}),setTimeout(function(){delete P[s]},50))}else r(n,null,null)};var F=window.Uint8Array||TypedArray}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";var e=function(){function e(e,n,r){void 0===n&&(n=null),void 0===r&&(r="_"),this._promptChar="_",this._mskArr=[],this._full=!0,this._hbInput=this._input.bind(this),this._hbKeyDown=this._keydown.bind(this),this._hbKeyPress=this._keypress.bind(this),this._hbCompositionStart=this._compositionstart.bind(this),this._hbCompositionEnd=this._compositionend.bind(this),this.mask=t.asString(n),this.input=e,this.promptChar=t.asString(r,!1),this._connect(!0),this._evtInput=document.createEvent("HTMLEvents"),this._evtInput.initEvent("input",!0,!1)}return Object.defineProperty(e.prototype,"input",{get:function(){return this._tbx},set:function(t){this._connect(!1),this._tbx=t,this._connect(!0)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"mask",{get:function(){return this._msk},set:function(e){e!=this._msk&&(this._msk=t.asString(e,!0),this._parseMask(),this._valueChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"promptChar",{get:function(){return this._promptChar},set:function(e){e!=this._promptChar&&(this._promptChar=t.asString(e,!1),t.assert(1==this._promptChar.length,"promptChar must be a string with length 1."),this._valueChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"maskFull",{get:function(){return this._full},enumerable:!0,configurable:!0}),e.prototype.getMaskRange=function(){return this._mskArr.length?[this._firstPos,this._lastPos]:[0,this._tbx.value.length-1]},e.prototype.getRawValue=function(){var t=this._tbx.value,e="";if(!this.mask)return t;for(var n=0;n<this._mskArr.length&&n<t.length;n++)this._mskArr[n].literal||t[n]==this._promptChar||(e+=t[n]);return e},e.prototype.refresh=function(){this._parseMask(),this._valueChanged()},e.prototype._input=function(t){var e=this;this._composing?t.stopImmediatePropagation():setTimeout(function(){e._valueChanged()})},e.prototype._keydown=function(e){if(e.keyCode==t.Key.Back){var n=this._tbx.selectionStart,r=this._tbx.selectionEnd;if(n<=this._firstPos&&r==n)return e.preventDefault(),void(this._backSpace=!1)}this._backSpace=e.keyCode==t.Key.Back},e.prototype._keypress=function(t){t.ctrlKey||t.metaKey||t.altKey||this._composing||!this._preventKey(t.charCode)||t.preventDefault()},e.prototype._compositionstart=function(t){this._composing=!0},e.prototype._compositionend=function(t){var e=this;this._composing&&(this._composing=!1,setTimeout(function(){e._valueChanged()&&e._tbx.dispatchEvent(e._evtInput)}))},e.prototype._preventKey=function(e){if(e&&this._mskArr.length){var n=this._tbx,r=n.selectionStart,i=String.fromCharCode(e);if(r<this._firstPos&&(r=this._firstPos,t.setSelectionRange(n,r)),r>=this._mskArr.length)return!0;var o=this._mskArr[r];if(o.literal)this._validatePosition(r);else if(o.wildCard!=i&&!this._isCharValid(o.wildCard,i))return!0}return!1},e.prototype._connect=function(e){var n=this._tbx;n&&(t.assert(n instanceof HTMLInputElement||n instanceof HTMLTextAreaElement,"INPUT or TEXTAREA element expected."),e?(this._autoComplete=n.autocomplete,this._spellCheck=n.spellcheck,n.autocomplete="off",n.spellcheck=!1,n.addEventListener("input",this._hbInput),n.addEventListener("keydown",this._hbKeyDown,!0),n.addEventListener("keypress",this._hbKeyPress,!0),n.addEventListener("compositionstart",this._hbCompositionStart,!0),n.addEventListener("compositionend",this._hbCompositionEnd,!0),n.addEventListener("blur",this._hbCompositionEnd,!0),this._valueChanged()):(n.autocomplete=this._autoComplete,n.spellcheck=this._spellCheck,n.removeEventListener("input",this._hbInput),n.removeEventListener("keydown",this._hbKeyDown,!0),n.removeEventListener("keypress",this._hbKeyPress,!0),n.removeEventListener("compositionstart",this._hbCompositionStart,!0),n.removeEventListener("compositionend",this._hbCompositionEnd,!0),n.removeEventListener("blur",this._hbCompositionEnd,!0)))},e.prototype._valueChanged=function(){if(!this._tbx||!this._msk)return!1;var t=this._tbx,e=t.value.length<2,n=t.selectionStart,r=n>0?t.value[n-1]:"",i=t.value;t.value=this._applyMask(),e&&(n=this._firstPos+1);var o=n>0?t.value[n-1]:"";return n>0&&o==this._promptChar&&r!=this.promptChar&&n--,n==i.length&&(n=this._matchEnd),this._validatePosition(n),i!=t.value},e.prototype._applyMask=function(){this._full=!0,this._matchEnd=0;var t=this._tbx.value;if(!this._msk)return t;if(!t&&!this._tbx.required)return t;var e="",n=0,r=this._promptChar;t=this._handleVagueLiterals(t);for(var i=0;i<this._mskArr.length;i++){var o=this._mskArr[i],s=o.literal;if(s&&s==t[n]&&n++,o.wildCard){if(s=r,t){for(var a=n;a<t.length;a++)if(this._isCharValid(o.wildCard,t[a])){switch(s=t[a],o.charCase){case">":s=s.toUpperCase();break;case"<":s=s.toLowerCase()}s!=r&&(this._matchEnd=e.length+1);break}n=a+1}s==r&&(this._full=!1)}e+=s}return e},e.prototype._handleVagueLiterals=function(t){if(t.length>this._mskArr.length+1)return t;var e=t.length-this._mskArr.length;if(0!=e&&t.length>1){for(var n=-1,r=Math.max(0,this._tbx.selectionStart-e);r<this._mskArr.length;r++)if(this._mskArr[r].vague){n=r;break}if(n>-1)if(e<0){var i=Array(1-e).join(this._promptChar),o=n+e;o>-1&&(t=t.substr(0,o)+i+t.substr(o))}else{for(;n>0&&this._mskArr[n-1].literal;)n--;t=t.substr(0,n)+t.substr(n+e)}}return t},e.prototype._isCharValid=function(t,n){var r=this._promptChar;switch(t){case"0":return n>="0"&&n<="9"||n==r;case"9":return n>="0"&&n<="9"||" "==n||n==r;case"#":return n>="0"&&n<="9"||" "==n||"+"==n||"-"==n||n==r;case"L":return n>="a"&&n<="z"||n>="A"&&n<="Z"||n==r;case"l":return n>="a"&&n<="z"||n>="A"&&n<="Z"||" "==n||n==r;case"A":return n>="0"&&n<="9"||n>="a"&&n<="z"||n>="A"&&n<="Z"||n==r;case"a":return n>="0"&&n<="9"||n>="a"&&n<="z"||n>="A"&&n<="Z"||" "==n||n==r;case"９":return n>="０"&&n<="９"||n==r;case"Ｊ":case"Ｇ":return!("Ｇ"==t&&e._X_DBCS_BIG_HIRA.indexOf(n)>-1)&&(n>="ぁ"&&n<="ゖ"||n==r);case"Ｋ":case"Ｎ":return!("Ｎ"==t&&e._X_DBCS_BIG_KATA.indexOf(n)>-1)&&(n>="ァ"&&n<="ヺ"||n==r);case"Ｚ":return n<="!"||n>="ÿ"||n==r;case"H":return n>="!"&&n<="ÿ"||n==r;case"K":case"N":return!("N"==t&&e._X_SBCS_BIG_KATA.indexOf(n)>-1)&&(n>="ｦ"&&n<="ﾟ"||n==r)}return!1},e.prototype._validatePosition=function(e){var n=this._mskArr;if(this._backSpace)for(;e>0&&e<n.length&&n[e-1].literal;)e--;if(0==e||!this._backSpace)for(;e<n.length&&n[e].literal;)e++;t.getActiveElement()==this._tbx&&t.setSelectionRange(this._tbx,e),this._backSpace=!1},e.prototype._parseMask=function(){this._mskArr=[],this._firstPos=-1,this._lastPos=-1;for(var e,r=this._msk,i="|",o=0;r&&o<r.length;o++)switch(r[o]){case"0":case"9":case"#":case"A":case"a":case"L":case"l":case"９":case"Ｊ":case"Ｇ":case"Ｋ":case"Ｎ":case"Ｚ":case"K":case"N":case"H":this._firstPos<0&&(this._firstPos=this._mskArr.length),this._lastPos=this._mskArr.length,this._mskArr.push(new n(r[o],i));break;case".":case",":case":":case"/":case"$":switch(r[o]){case".":case",":e=t.culture.Globalize.numberFormat[r[o]];break;case":":case"/":e=t.culture.Globalize.calendar[r[o]];break;case"$":e=t.culture.Globalize.numberFormat.currency.symbol}for(a=0;a<e.length;a++)this._mskArr.push(new n(e[a]));break;case"<":case">":case"|":i=r[o];break;case"\\":o<r.length-1&&o++,this._mskArr.push(new n(r[o]));break;default:this._mskArr.push(new n(r[o]))}for(o=0;o<this._mskArr.length;o++){var s=this._mskArr[o];if(s.literal)for(var a=0;a<o;a++){var u=this._mskArr[a];if(u.wildCard&&this._isCharValid(u.wildCard,s.literal)){s.vague=!0;break}}}},e._X_DBCS_BIG_HIRA="ぁぃぅぇぉっゃゅょゎゕゖ",e._X_DBCS_BIG_KATA="ァィゥェォッャュョヮヵヶ",e._X_SBCS_BIG_KATA="ｧｨｩｪｫｬｭｮｯ",e}();t._MaskProvider=e;var n=function(){return function(t,e){e?(this.wildCard=t,this.charCase=e):this.literal=t}}();t._MaskElement=n}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";var e=function(){function e(t){this._isDown=!1,this._mousedownBnd=this._mousedown.bind(this),this._mouseupBnd=this._mouseup.bind(this),this._onClickBnd=this._onClick.bind(this),this.element=t,this._connect(!0)}return Object.defineProperty(e.prototype,"element",{get:function(){return this._e},set:function(e){this._connect(!1),this._e=t.asType(e,HTMLElement,!0),this._connect(!0)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"disabled",{get:function(){return this._disabled},set:function(e){this._disabled=t.asBoolean(e)},enumerable:!0,configurable:!0}),e.prototype._connect=function(t){if(this._e){t?this._e.addEventListener("mousedown",this._mousedownBnd):this._e.removeEventListener("mousedown",this._mousedownBnd)}},e.prototype._clearTimeouts=function(){this._toRepeat&&(clearInterval(this._toRepeat),this._toRepeat=null),this._toDelay&&(clearInterval(this._toDelay),this._toDelay=null)},e.prototype._mousedown=function(n){var r=this;this._isDown&&this._mouseup(null),this._disabled||(this._isDown=!0,e._stopEvents.forEach(function(t){document.addEventListener(t,r._mouseupBnd)}),this._clearTimeouts(),this._toDelay=setTimeout(function(){r._isDown&&(r._onClick(),r._toRepeat=setTimeout(r._onClickBnd,t.Control._CLICK_REPEAT))},t.Control._CLICK_DELAY))},e.prototype._mouseup=function(t){var n=this;this._isDown&&t&&"mouseup"==t.type&&t.preventDefault(),e._stopEvents.forEach(function(t){document.removeEventListener(t,n._mouseupBnd)}),this._clearTimeouts(),this._isDown=!1},e.prototype._onClick=function(){this._clearTimeouts(),this._e&&(this._e.click(),this._isDown&&(this._toRepeat=setTimeout(this._onClickBnd,t.Control._CLICK_REPEAT)))},e._stopEvents=["mouseup","mouseout","keydown"],e}();t._ClickRepeater=e}(wijmo||(wijmo={}));var wijmo;!function(t){"use strict";function e(){return r}var n=null!=navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i);t.isMobile=function(){return n};var r=null!=navigator.userAgent.match(/Firefox\//);t.isFirefox=e;var i=null!=navigator.userAgent.match(/^((?!chrome|android).)*safari/i);t.isSafari=function(){return i};var o=null!=navigator.userAgent.match(/Edge\//);t.isEdge=function(){return o};var s=null!=navigator.userAgent.match(/MSIE |Trident\/|Edge\//);t.isIE=function(){return s};var a=!1;t.isIE9=function(){return a};var u=!1;document.addEventListener("test",function(t){},{get passive(){return u=!0,!0}}),t.getEventOptions=function(t,e){return u?{capture:t,passive:e}:t};var c=!1;document.createElement("div").focus({get preventScroll(){return c=!0,!0}}),t.supportsFocusOptions=function(){return c},t._startDrag=function(t,n){t.effectAllowed=n,e()&&t.setData("text","")},document.doctype&&navigator.appVersion.indexOf("MSIE 9")>-1&&(a=!0,document.addEventListener("mousemove",function(e){if(1==e.which){var n=t.closest(e.target,".wj-control");if(n&&!n.style.cursor)for(var r=e.target;r;r=r.parentNode)if(r.attributes&&r.attributes.draggable)return r.dragDrop(),!1}}));var l="requestAnimationFrame";if(!window[l]){var h=0;window[l]=function(t){var e=Date.now(),n=16-(e-h),r=n>0?n:0;return h=e+r,setTimeout(function(){t(h)},r)},window.cancelAnimationFrame=clearTimeout}if(!window.atob){var p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",f=new RegExp("[^"+p+"]");window.atob=function(t){var e,n,r,i,o=[],s=0,a=t.length;if(f.test(t)||/=/.test(t)&&(/=[^=]/.test(t)||/={3}/.test(t)))throw new Error("Invalid base64 data");for(a%4>0&&(a=(t+=Array(4-a%4+1).join("=")).length);s<a;){for(n=[],i=s;s<i+4;)n.push(p.indexOf(t.charAt(s++)));for(r=[((e=(n[0]<<18)+(n[1]<<12)+((63&n[2])<<6)+(63&n[3]))&255<<16)>>16,64===n[2]?-1:(65280&e)>>8,64===n[3]?-1:255&e],i=0;i<3;++i)(r[i]>=0||0===i)&&o.push(String.fromCharCode(r[i]))}return o.join("")},window.btoa=function(t){for(var e,n,r=[],i=0,o=t.length;i<o;)e=((n=[t.charCodeAt(i++),t.charCodeAt(i++),t.charCodeAt(i++)])[0]<<16)+((n[1]||0)<<8)+(n[2]||0),r.push(p.charAt((e&63<<18)>>18),p.charAt((258048&e)>>12),p.charAt(isNaN(n[1])?64:(4032&e)>>6),p.charAt(isNaN(n[2])?64:63&e));return r.join("")}}}(wijmo||(wijmo={}));
/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i,null,!0)||this;o._showBtn=!0,o._autoExpand=!0,o._animate=!1,o.textChanged=new t.Event,o.isDroppedDownChanging=new t.Event,o.isDroppedDownChanged=new t.Event;var s=o.getTemplate();o.applyTemplate("wj-control wj-content wj-dropdown",s,{_tbx:"input",_btn:"btn",_dropDown:"dropdown"},"input");var r=o._tbx;o._elRef=r,t.disableAutoComplete(r),o._createDropDown(),o._updateBtn(),t.removeChild(o._dropDown),t.addClass(o.hostElement,"wj-state-collapsed");var a=o._updateFocusState.bind(o);o.addEventListener(o.dropDown,"blur",a,!0),o.addEventListener(o.dropDown,"focus",a);var l=o._keydown.bind(o);return o.addEventListener(o.hostElement,"keydown",l),o.addEventListener(o.dropDown,"keydown",l),o.addEventListener(r,"keypress",function(t){9787==t.keyCode&&o._altDown&&t.preventDefault()}),o.addEventListener(r,"input",function(){o._setText(o.text,!1)}),o.addEventListener(r,"click",function(){o._autoExpand&&o._expandSelection()}),t.isIE9()&&o.addEventListener(r,"keyup",function(){o._setText(o.text,!1)}),o.addEventListener(o._btn,"mousedown",function(t){t.defaultPrevented||0!=t.button||setTimeout(function(){o._btnclick(t)})}),o.addEventListener(o._dropDown,"click",function(t){t.stopPropagation()}),o}return __extends(i,e),Object.defineProperty(i.prototype,"text",{get:function(){return this._tbx.value},set:function(t){t!=this.text&&this._setText(t,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isReadOnly",{get:function(){return this._tbx.readOnly},set:function(e){this._tbx.readOnly=t.asBoolean(e),t.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isRequired",{get:function(){return this._tbx.required},set:function(e){this._tbx.required=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"placeholder",{get:function(){return this._tbx.placeholder},set:function(t){this._tbx.placeholder=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isDroppedDown",{get:function(){var t=this._dropDown;return t&&"none"!=t.style.display},set:function(e){if((e=t.asBoolean(e)&&!this.isDisabled&&!this.isReadOnly)!=this.isDroppedDown&&this.onIsDroppedDownChanging(new t.CancelEventArgs)){var i=this.hostElement,n=this._dropDown;if(e)n.style.minWidth||(n.style.minWidth=i.getBoundingClientRect().width+"px"),n.style.display="block",this._updateDropDown();else{var o=this.containsFocus();t.hidePopup(n),o&&(this.isTouching&&this.showDropDownButton?this.focus():this.selectAll())}this._updateFocusState(),t.toggleClass(i,"wj-state-collapsed",!this.isDroppedDown),this.onIsDroppedDownChanged()}},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"dropDown",{get:function(){return this._dropDown},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"dropDownCssClass",{get:function(){return this._cssClass},set:function(e){e!=this._cssClass&&(t.removeClass(this._dropDown,this._cssClass),this._cssClass=t.asString(e),t.addClass(this._dropDown,this._cssClass))},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"showDropDownButton",{get:function(){return this._showBtn},set:function(e){this._showBtn=t.asBoolean(e),this._updateBtn()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"autoExpandSelection",{get:function(){return this._autoExpand},set:function(e){this._autoExpand=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isAnimated",{get:function(){return this._animate},set:function(e){this._animate=t.asBoolean(e)},enumerable:!0,configurable:!0}),i.prototype.selectAll=function(){this._elRef==this._tbx?t.setSelectionRange(this._tbx,0,this.text.length):this.containsFocus()||this.focus()},i.prototype.onTextChanged=function(t){this.textChanged.raise(this,t),this._updateState()},i.prototype.onIsDroppedDownChanging=function(t){return this.isDroppedDownChanging.raise(this,t),!t.cancel},i.prototype.onIsDroppedDownChanged=function(t){this.isDroppedDownChanged.raise(this,t)},i.prototype.onGotFocus=function(i){this.isTouching||t.contains(this._dropDown,t.getActiveElement())||this.selectAll(),e.prototype.onGotFocus.call(this,i)},i.prototype.onLostFocus=function(t){this._commitText(),this.containsFocus()||(this.isDroppedDown=!1),e.prototype.onLostFocus.call(this,t)},i.prototype.containsFocus=function(){return e.prototype.containsFocus.call(this)||this.isDroppedDown&&t.contains(this._dropDown,t.getActiveElement())},i.prototype.dispose=function(){this.isDroppedDown=!1;var i=this.dropDown;if(i){var n=t.Control.getControl(i);n&&n.dispose(),t.removeChild(i)}e.prototype.dispose.call(this)},i.prototype.refresh=function(i){if(void 0===i&&(i=!0),e.prototype.refresh.call(this,i),this.isDroppedDown&&"none"!=getComputedStyle(this.hostElement).display){var n=t.getActiveElement();t.showPopup(this._dropDown,this.hostElement,!1,!1,null==this.dropDownCssClass),n instanceof HTMLElement&&n!=t.getActiveElement()&&n.focus()}},i.prototype._handleResize=function(){this.isDroppedDown&&this.refresh()},i.prototype._expandSelection=function(){var e=this._tbx,i=e.value,n=e.selectionStart,o=e.selectionEnd;if(i&&n==o){var s=this._getCharType(i,n);if(s>-1){for(;o<i.length&&this._getCharType(i,o)==s;o++);for(;n>0&&this._getCharType(i,n-1)==s;n--);n!=o&&t.setSelectionRange(e,n,o)}}},i.prototype._getCharType=function(t,e){var i=t[e];return i>="0"&&i<="9"?0:i>="a"&&i<="z"||i>="A"&&i<="Z"?1:-1},i.prototype._keydown=function(e){if(this._altDown=e.altKey,!e.defaultPrevented)switch(e.keyCode){case t.Key.Tab:case t.Key.Escape:case t.Key.Enter:this.isDroppedDown&&(this.isDroppedDown=!1,e.keyCode==t.Key.Tab||this.containsFocus()||this.focus(),e.preventDefault());break;case t.Key.F4:case t.Key.Up:case t.Key.Down:if((e.keyCode==t.Key.F4||e.altKey)&&t.contains(document.body,this.hostElement)){var i=this.isDroppedDown;this.isDroppedDown=!i,this.isDroppedDown==!i&&e.preventDefault()}}},i.prototype._btnclick=function(t){t.defaultPrevented||0!=t.button||(this.isDroppedDown=!this.isDroppedDown)},i.prototype._setText=function(t,e){null==t&&(t=""),(t=t.toString())!=this._tbx.value&&(this._tbx.value=t),t!=this._oldText&&(this._oldText=t,this.onTextChanged())},i.prototype._updateBtn=function(){this._btn.tabIndex=-1,this._btn.style.display=this._showBtn?"":"none"},i.prototype._createDropDown=function(){},i.prototype._commitText=function(){},i.prototype._updateDropDown=function(){this.isDroppedDown&&(this._commitText(),t.showPopup(this._dropDown,this.hostElement,!1,this._animate,null==this.dropDownCssClass))},i.controlTemplate='<div style="position:relative" class="wj-template"><div class="wj-input"><div class="wj-input-group wj-input-btn-visible"><input wj-part="input" type="text" class="wj-form-control" /><span wj-part="btn" class="wj-input-group-btn" tabindex="-1"><button class="wj-btn wj-btn-default" type="button" tabindex="-1"><span class="wj-glyph-down"></span></button></span></div></div><div wj-part="dropdown" class="wj-content wj-dropdown-panel" style="display:none"></div></div>',i}(t.Control);e.DropDown=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i;!function(t){t[t.None=0]="None",t[t.Day=1]="Day",t[t.Month=2]="Month"}(i=e.DateSelectionMode||(e.DateSelectionMode={}));var n=function(n){function o(e,o){var s=n.call(this,e)||this;return s._readOnly=!1,s._selMode=i.Day,s._fmtYrMo="y",s._fmtYr="yyyy",s._fmtDayHdr="ddd",s._fmtDay="d ",s._fmtMonths="MMM",s.valueChanged=new t.Event,s.displayMonthChanged=new t.Event,s.formatItem=new t.Event,s._value=t.DateTime.newDate(),s._currMonth=s._getMonth(s._value),s._createChildren(),s.addEventListener(s.hostElement,"mouseup",s._click.bind(s)),s.addEventListener(s.hostElement,"keydown",s._keydown.bind(s)),s.initialize(o),s.refresh(!0),s}return __extends(o,n),Object.defineProperty(o.prototype,"value",{get:function(){return this._value},set:function(e){e=t.asDate(e,!0),e=this._clamp(e),(this._valid(e)||null==e)&&(this.displayMonth=this._getMonth(e),t.DateTime.equals(this._value,e)||(this._value=e,this.invalidate(!1),this.onValueChanged()))},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"min",{get:function(){return this._min},set:function(e){e!=this.min&&(this._min=t.asDate(e,!0),this.refresh())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"max",{get:function(){return this._max},set:function(e){e!=this.max&&(this._max=t.asDate(e,!0),this.refresh())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"selectionMode",{get:function(){return this._selMode},set:function(e){if((e=t.asEnum(e,i))!=this._selMode){this._selMode=e;var n=this._monthMode();n&&(this.monthView=!1);var o=this._btnMth.querySelector(".wj-glyph-down");o&&(o.style.display=n?"none":""),this.refresh()}},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"isReadOnly",{get:function(){return this._readOnly},set:function(e){this._readOnly=t.asBoolean(e),t.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"firstDayOfWeek",{get:function(){return this._fdw},set:function(e){if(e!=this._fdw){if((e=t.asNumber(e,!0))&&(e>6||e<0))throw"firstDayOfWeek must be between 0 and 6 (Sunday to Saturday).";this._fdw=e,this.refresh()}},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"displayMonth",{get:function(){return this._currMonth},set:function(e){t.DateTime.equals(this.displayMonth,e)||(e=t.asDate(e),(this.monthView?this._monthInValidRange(e):this._yearInValidRange(e))&&(this._currMonth=this._getMonth(this._clamp(e)),this.invalidate(!0),this.onDisplayMonthChanged()))},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"formatYearMonth",{get:function(){return this._fmtYrMo},set:function(e){e!=this._fmtYrMo&&(this._fmtYrMo=t.asString(e),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"formatDayHeaders",{get:function(){return this._fmtDayHdr},set:function(e){e!=this._fmtDayHdr&&(this._fmtDayHdr=t.asString(e),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"formatDays",{get:function(){return this._fmtDay},set:function(e){e!=this._fmtDay&&(this._fmtDay=t.asString(e),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"formatYear",{get:function(){return this._fmtYr},set:function(e){e!=this._fmtYr&&(this._fmtYr=t.asString(e),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"formatMonths",{get:function(){return this._fmtMonths},set:function(e){e!=this._fmtMonths&&(this._fmtMonths=t.asString(e),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"showHeader",{get:function(){return"none"!=this._tbHdr.style.display},set:function(e){this._tbHdr.style.display=t.asBoolean(e)?"":"none"},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"monthView",{get:function(){return"none"!=this._tbMth.style.display},set:function(t){t!=this.monthView&&(this._tbMth.style.display=t?"":"none",this._tbYr.style.display=t?"none":"")},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"itemFormatter",{get:function(){return this._itemFormatter},set:function(e){e!=this._itemFormatter&&(this._itemFormatter=t.asFunction(e),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"itemValidator",{get:function(){return this._itemValidator},set:function(e){e!=this._itemValidator&&(this._itemValidator=t.asFunction(e),this.invalidate())},enumerable:!0,configurable:!0}),o.prototype.onValueChanged=function(t){this.valueChanged.raise(this,t)},o.prototype.onDisplayMonthChanged=function(t){this.displayMonthChanged.raise(this,t)},o.prototype.onFormatItem=function(t){this.formatItem.raise(this,t)},o.prototype.refresh=function(i){void 0===i&&(i=!0);var o,s,r,a=this.displayMonth,l=null!=this.firstDayOfWeek?this.firstDayOfWeek:t.Globalize.getFirstDayOfWeek();n.prototype.refresh.call(this,i),this._firstDay=t.DateTime.addDays(a,-(a.getDay()-l+7)%7),t.setText(this._spMth,t.Globalize.format(a,this._fmtYrMo)),o=this._tbMth.querySelectorAll("td");for(p=0;p<7&&p<o.length;p++)r=t.DateTime.addDays(this._firstDay,p),t.setText(o[p],t.Globalize.format(r,this._fmtDayHdr));for(p=7;p<o.length;p++){s=o[p],r=t.DateTime.addDays(this._firstDay,p-7),t.setText(s,t.Globalize.format(r,this._fmtDay));var h=!this._valid(r);if(t.toggleClass(s,"wj-state-invalid",h),t.toggleClass(s,"wj-state-selected",this._selMode&&t.DateTime.sameDate(r,this.value)),t.toggleClass(s,"wj-day-today",t.DateTime.sameDate(r,t.DateTime.newDate())),t.toggleClass(s,"wj-day-othermonth",h||r.getMonth()!=a.getMonth()||!this._inValidRange(r)),this.itemFormatter&&this.itemFormatter(r,s),this.formatItem.hasHandlers){var c=new e.FormatItemEventArgs(p,r,s);this.onFormatItem(c)}}var u=this._tbMth.querySelectorAll("tr");u.length&&(r=t.DateTime.addDays(this._firstDay,28),u[u.length-2].style.display=r.getMonth()==a.getMonth()?"":"none",r=t.DateTime.addDays(this._firstDay,35),u[u.length-1].style.display=r.getMonth()==a.getMonth()?"":"none"),(o=this._tbYr.querySelectorAll("td")).length&&t.setText(o[0],t.Globalize.format(a,this._fmtYr));for(var p=1;p<o.length;p++)s=o[p],r=t.DateTime.newDate(a.getFullYear(),p-1,1),t.setText(s,t.Globalize.format(r,this._fmtMonths)),s.className="",t.toggleClass(s,"wj-state-disabled",!this._monthInValidRange(r)),t.toggleClass(s,"wj-state-selected",this._sameMonth(r,this.value))},o.prototype._canChangeValue=function(){return!this._readOnly&&this._selMode!=i.None},o.prototype._valid=function(e){return!!t.isDate(e)&&(!!t.DateTime.sameDate(e,this._clamp(e))&&(!t.isFunction(this.itemValidator)||this.itemValidator(e)))},o.prototype._inValidRange=function(e){return!(this.min&&e<t.DateTime.fromDateTime(this.min,e))&&!(this.max&&e>t.DateTime.fromDateTime(this.max,e))},o.prototype._monthInValidRange=function(e){if(this.min||this.max){var i=e.getFullYear(),n=e.getMonth(),o=t.DateTime.newDate(i,n,1),s=t.DateTime.newDate(i,n+1,0);if(this.min&&this.min>s)return!1;if(this.max&&this.max<o)return!1}return!0},o.prototype._yearInValidRange=function(e){if(this.min||this.max){var i=e.getFullYear(),n=t.DateTime.newDate(i,0),o=t.DateTime.newDate(i,11,31);if(this.min&&this.min>o)return!1;if(this.max&&this.max<n)return!1}return!0},o.prototype._sameMonth=function(e,i){return t.isDate(e)&&t.isDate(i)&&e.getMonth()==i.getMonth()&&e.getFullYear()==i.getFullYear()},o.prototype._getValidDate=function(e,i){if(t.isDate(e))for(var n=e.getFullYear(),o=e.getMonth()+(i?0:1),s=i?1:0,r=t.DateTime.newDate(n,o,s),a=i?1:-1,l=0;l<31;l++){if(this._valid(r))return r;r=t.DateTime.addDays(r,a)}return null},o.prototype._clamp=function(e){if(e){if(this.min){var i=t.DateTime.fromDateTime(this.min,e);e<i&&(e=i)}if(this.max){var n=t.DateTime.fromDateTime(this.max,e);e>n&&(e=n)}}return e},o.prototype._createChildren=function(){var t=this.getTemplate();this.applyTemplate("wj-control wj-calendar",t,{_tbHdr:"tbl-header",_btnMth:"btn-month",_spMth:"span-month",_btnPrv:"btn-prev",_btnTdy:"btn-today",_btnNxt:"btn-next",_tbMth:"tbl-month",_tbYr:"tbl-year"});for(var e=this._createElement("tr",this._tbMth,"wj-header"),i=0;i<7;i++)this._createElement("td",e);for(var n=0;n<6;n++){e=this._createElement("tr",this._tbMth);for(i=0;i<7;i++)this._createElement("td",e)}e=this._createElement("tr",this._tbYr,"wj-header"),this._createElement("td",e).setAttribute("colspan","4");for(var o=0;o<3;o++){e=this._createElement("tr",this._tbYr);for(var s=0;s<4;s++)this._createElement("td",e)}},o.prototype._createElement=function(e,i,n){var o=document.createElement(e);return i&&i.appendChild(o),n&&t.addClass(o,n),o},o.prototype._click=function(e){if(!e.defaultPrevented&&0==e.button){var i=!1,n=e.target;if(t.contains(this._btnMth,n)&&!this._monthMode()?(this.monthView=!this.monthView,i=!0):t.contains(this._btnPrv,n)?(this._navigate(-1),i=!0):t.contains(this._btnNxt,n)?(this._navigate(1),i=!0):t.contains(this._btnTdy,n)&&(this._navigate(0),i=!0),n&&!i&&(n=t.closest(n,"TD")))if(this.monthView){if((o=this._getCellIndex(this._tbMth,n))>6&&this._canChangeValue()){s=t.DateTime.fromDateTime(t.DateTime.addDays(this._firstDay,o-7),this.value);this._inValidRange(s)&&this._valid(s)&&(this.value=s),i=!0}}else{var o=this._getCellIndex(this._tbYr,n);if(o>0){if(this.displayMonth=t.DateTime.newDate(this.displayMonth.getFullYear(),o-1,1),this._monthMode()){if(this._canChangeValue()){var s=t.DateTime.fromDateTime(this.displayMonth,this.value);this._inValidRange(s)&&(this.value=s)}}else this.monthView=!0;i=!0}}i&&(e.preventDefault(),this.focus())}},o.prototype._getCellIndex=function(t,e){for(var i=t.querySelectorAll("TD"),n=0;n<i.length;n++)if(i[n]==e)return n;return-1},o.prototype._keydown=function(e){if(!e.defaultPrevented){if(e.altKey)switch(e.keyCode){case t.Key.Up:case t.Key.Down:return;case t.Key.End:return this._navigate(0),void e.preventDefault()}if(!(e.ctrlKey||e.metaKey||e.shiftKey)){var i=0,n=0,o=!0;if(this.monthView)switch(e.keyCode){case t.Key.Left:i=-1;break;case t.Key.Right:i=1;break;case t.Key.Up:i=-7;break;case t.Key.Down:i=7;break;case t.Key.PageDown:n=e.altKey?12:1;break;case t.Key.PageUp:n=e.altKey?-12:-1;break;case t.Key.Home:this._canChangeValue()&&(s=this._getValidDate(this.value,!0))&&(this.value=t.DateTime.fromDateTime(s,this.value));break;case t.Key.End:this._canChangeValue()&&(s=this._getValidDate(this.value,!1))&&(this.value=t.DateTime.fromDateTime(s,this.value));break;default:o=!1}else switch(e.keyCode){case t.Key.Left:n=-1;break;case t.Key.Right:n=1;break;case t.Key.Up:n=-4;break;case t.Key.Down:n=4;break;case t.Key.PageDown:n=e.altKey?120:12;break;case t.Key.PageUp:n=e.altKey?-120:-12;break;case t.Key.Home:n=this.value?-this.value.getMonth():0;break;case t.Key.End:n=this.value?11-this.value.getMonth():0;break;case t.Key.Enter:this._monthMode()?o=!1:this.monthView=!0;break;default:o=!1}if(this.value&&this._canChangeValue()&&(i||n)){var s=this.value;if(s=t.DateTime.addDays(s,i),s=t.DateTime.addMonths(s,n),n&&!this._valid(s))for(var r=s.getMonth(),a=1;a<31&&!this._valid(s);a++){var l=t.DateTime.addDays(s,+a),h=t.DateTime.addDays(s,-a);this._valid(l)&&l.getMonth()==r?s=l:this._valid(h)&&h.getMonth()==r&&(s=h)}for(a=0;a<31&&!this._valid(s);a++)s=t.DateTime.addDays(s,i>0||n>0?1:-1);this.value=s}o&&e.preventDefault()}}},o.prototype._getMonth=function(e){return e||(e=t.DateTime.newDate()),t.DateTime.newDate(e.getFullYear(),e.getMonth(),1)},o.prototype._monthMode=function(){return this.selectionMode==i.Month},o.prototype._navigate=function(e){var i=this.monthView,n=this.displayMonth;switch(e){case 0:var o=t.DateTime.newDate();this._canChangeValue()&&(this.value=i?t.DateTime.fromDateTime(o,this.value):this._getMonth(o)),n=this._getMonth(o);break;case 1:n=t.DateTime.addMonths(n,i?1:12);break;case-1:n=t.DateTime.addMonths(n,i?-1:-12)}this.displayMonth=n},o.controlTemplate='<div class="wj-content wj-calendar-outer"><div wj-part="tbl-header" class="wj-calendar-header"><div wj-part="btn-month" class="wj-month-select"><span wj-part="span-month"></span> <span class="wj-glyph-down"></span></div><div class="wj-btn-group"><button type="button" tabindex="-1" wj-part="btn-prev" class="wj-btn wj-btn-default"><span class="wj-glyph-left"></span></button><button type="button" tabindex="-1" wj-part="btn-today" class="wj-btn wj-btn-default"><span class="wj-glyph-circle"></span></button><button type="button" tabindex="-1" wj-part="btn-next" class="wj-btn wj-btn-default"><span class="wj-glyph-right"></span></button></div></div><table wj-part="tbl-month" class="wj-calendar-month"></table><table wj-part="tbl-year" class="wj-calendar-year" style="display:none"></table></div>',o}(t.Control);e.Calendar=n}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(n,o){var s=e.call(this,n)||this;s._hsb=[.5,1,1],s._alpha=1,s.valueChanged=new t.Event;var r=s.getTemplate();s.applyTemplate("wj-control wj-content wj-colorpicker",r,{_eSB:"div-sb",_eHue:"div-hue",_eAlpha:"div-alpha",_ePreview:"div-pv",_ePal:"div-pal",_eText:"div-text"}),s._palette="#FFF,#000, #F00,#FFC000,#FFFF00,#92D050,#00B050,#00B0F0,#0070C0,#7030A0".split(","),s._updatePalette(),s._eHue.style.backgroundImage="url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAD4CAIAAACi6hsPAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuM4zml1AAAAGvSURBVDhPXdBPaM9xHMfxz4pWaxcmtoOhpdXSVpiyHWxqmVpDjaU5rK34XfypjTJ/p+ZPay6jhsOsRrKwaJElf9IQq03WIkv4FeMwMq221tfje1ByeFzfvd7PEKWGEKWTQRZLySWfVRRTQjmVbKWGOhLsZT+HaeY0bbTTQSfdXOcWffTzmAFeMcwoYyT5ygS/mA5hNgphip98J8kHRnnNSwZ4yH1uc4OrdHGR87RximYO0cgedlLLdqqoYAPrWMtKVrCcJSxiPmnMJUQp/Bsyk2xyyKOAQooopYwKtlDNDur5G7SBJo7RQiv/B+2hl3s84CkvGGKEOOYnxolj/mYmhBmDJ5ngCx95xxsGecYj4pB3iENeoZMO2mmlhaMcpIE4ZII6aqhmM3HMMkooopB88sghm0wySCeVlCjMCVFIYx4LWUwOeRSwhmLWU84mqqihll3sppEmjnOSs5zjEl1c4yZ99POE5wwxwns+840fTDFLFKaZZIJxkozxlmEGGSC+GF++Sy89dHOZC8Rr4lVnOMERDrCPBPXEX22jko2UEn+/mnxyWUYWC0gnNUQh/AEc0HJs6cex0gAAAABJRU5ErkJggg==)",s._eHue.style.backgroundSize="contain",navigator.appVersion.indexOf("MSIE 9")>-1&&(s._eSB.children[0].style.filter="progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffffff,endColorstr=#00ffffff,GradientType=1)",s._eSB.children[1].style.filter="progid:DXImageTransform.Microsoft.gradient(startColorstr=#00000000,endColorstr=#ff000000,GradientType=0)"),r=i._tplCursor,s._cSB=t.createElement(r),s._cHue=t.createElement(r),s._cHue.style.width="100%",s._cAlpha=t.createElement(r),s._cAlpha.style.height="100%",s._eSB.appendChild(s._cSB),s._eHue.appendChild(s._cHue),s._eAlpha.appendChild(s._cAlpha),s.addEventListener(s.hostElement,"mousedown",function(t){document.addEventListener("mousemove",a),document.addEventListener("mouseup",l),s._mouseDown(t)});var a=function(t){s._mouseMove(t)},l=function(t){document.removeEventListener("mousemove",a),document.removeEventListener("mouseup",l),s._mouseUp(t)};return s.addEventListener(s.hostElement,"click",function(e){var i=e.target;if(i&&"DIV"==i.tagName&&t.contains(s._ePal,i)){var n=i.style.backgroundColor;n&&(s.value=new t.Color(n).toString())}}),s.value="#ffffff",s.initialize(o),s._updatePanels(),s}return __extends(i,e),Object.defineProperty(i.prototype,"showAlphaChannel",{get:function(){return"none"!=this._eAlpha.parentElement.style.display},set:function(e){this._eAlpha.parentElement.style.display=t.asBoolean(e)?"":"none"},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"showColorString",{get:function(){return"none"!=this._eText.style.display},set:function(e){this._eText.style.display=t.asBoolean(e)?"":"none"},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"value",{get:function(){return this._value},set:function(e){if(e!=this.value){this._value=t.asString(e),this._eText.innerText=this._value;var i=new t.Color(this._value),n=i.getHsb();this._hsb[0]==n[0]&&this._hsb[1]==n[1]&&this._hsb[2]==n[2]&&this._alpha==i.a||(0==n[2]?(n[0]=this._hsb[0],n[1]=this._hsb[1]):0==n[1]&&(n[0]=this._hsb[0]),this._hsb=n,this._alpha=i.a,this.onValueChanged())}},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"palette",{get:function(){return this._palette},set:function(e){e=t.asArray(e);for(var i=0;i<e.length&&i<this._palette.length;i++){var n=t.asString(e[i]);this._palette[i]=n}this._updatePalette()},enumerable:!0,configurable:!0}),i.prototype.onValueChanged=function(t){this._updatePanels(),this.valueChanged.raise(this,t)},i.prototype._mouseDown=function(t){this._htDown=this._getTargetPanel(t),this._htDown&&(t.preventDefault(),this.focus(),this._mouseMove(t))},i.prototype._mouseMove=function(e){if(this._htDown){var i=this._htDown.getBoundingClientRect();this._htDown==this._eHue?(this._hsb[0]=t.clamp((e.clientY-i.top)/i.height,0,.99),this._updateColor()):this._htDown==this._eSB?(this._hsb[1]=t.clamp((e.clientX-i.left)/i.width,0,1),this._hsb[2]=t.clamp(1-(e.clientY-i.top)/i.height,0,1),this._updateColor()):this._htDown==this._eAlpha&&(this._alpha=t.clamp((e.clientX-i.left)/i.width,0,1),this._updateColor())}},i.prototype._mouseUp=function(t){this._htDown=null},i.prototype._updateColor=function(){var e=t.Color.fromHsb(this._hsb[0],this._hsb[1],this._hsb[2],this._alpha);this.value=e.toString(),this._updatePanels()},i.prototype._updatePalette=function(){var e=new t.Color("#fff"),i=new t.Color("#000");this._ePal.innerHTML="";for(var n=0;n<this._palette.length;n++){var o=t.createElement('<div style="float:left;width:10%;box-sizing:border-box;padding:1px">'),s=new t.Color(this._palette[n]),r=s.getHsb();o.appendChild(this._makePalEntry(s,4));for(var a=0;a<5;a++){if(0==r[1]){var l=.1*a+(r[2]>.5?.05:.55);s=t.Color.interpolate(e,i,l)}else s=t.Color.fromHsb(r[0],.1+.2*a,1-.1*a);o.appendChild(this._makePalEntry(s,0))}this._ePal.appendChild(o)}},i.prototype._makePalEntry=function(e,i){var n=document.createElement("div");return t.setCss(n,{cursor:"pointer",backgroundColor:e.toString(),marginBottom:i||""}),n.innerHTML="&nbsp",n},i.prototype._updatePanels=function(){var e=t.Color.fromHsb(this._hsb[0],1,1,1),i=t.Color.fromHsb(this._hsb[0],this._hsb[1],this._hsb[2],1);this._eSB.style.backgroundColor=e.toString(),this._eAlpha.style.background="linear-gradient(to right, transparent 0%, "+i.toString()+" 100%)",navigator.appVersion.indexOf("MSIE 9")>-1&&(this._eAlpha.style.filter="progid:DXImageTransform.Microsoft.gradient(startColorstr=#00000000,endColorstr="+i.toString()+", GradientType = 1)"),this._ePreview.style.backgroundColor=this.value,this._cHue.style.top=(100*this._hsb[0]).toFixed(0)+"%",this._cSB.style.left=(100*this._hsb[1]).toFixed(0)+"%",this._cSB.style.top=(100-100*this._hsb[2]).toFixed(0)+"%",this._cAlpha.style.left=(100*this._alpha).toFixed(0)+"%"},i.prototype._getTargetPanel=function(e){var i=e.target;return t.contains(this._eSB,i)?this._eSB:t.contains(this._eHue,i)?this._eHue:t.contains(this._eAlpha,i)?this._eAlpha:null},i.controlTemplate='<div style="position:relative;width:100%;height:100%"><div style="float:left;width:50%;height:100%;box-sizing:border-box;padding:2px"><div wj-part="div-pal"><div style="float:left;width:10%;box-sizing:border-box;padding:2px"><div style="background-color:black;width:100%">&nbsp;</div><div style="height:6px"></div></div></div><div wj-part="div-text" style="position:absolute;bottom:0px;display:none"></div></div><div style="float:left;width:50%;height:100%;box-sizing:border-box;padding:2px"><div wj-part="div-sb" class="wj-colorbox" style="float:left;width:89%;height:89%"><div style="position:absolute;width:100%;height:100%;background:linear-gradient(to right, white 0%,transparent 100%)"></div><div style="position:absolute;width:100%;height:100%;background:linear-gradient(to top, black 0%,transparent 100%)"></div></div><div style="float:left;width:1%;height:89%"></div><div style="float:left;width:10%;height:89%"><div wj-part="div-hue" class="wj-colorbox"></div></div><div style="float:left;width:89%;height:1%"></div><div style="float:left;width:89%;height:10%"><div style="width:100%;height:100%;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuM4zml1AAAAAcSURBVBhXY/iPBBYgAWpKQGkwgMqDAdUk/v8HAM7Mm6GatDUYAAAAAElFTkSuQmCC)"><div wj-part="div-alpha" class="wj-colorbox"></div></div></div><div style="float:left;width:1%;height:10%"></div><div style="float:left;width:10%;height:10%"><div wj-part="div-pv" class="wj-colorbox" style="position:static"></div></div></div></div>',i._tplCursor='<div style="position:absolute;left:50%;top:50%;width:7px;height:7px;transform:translate(-50%,-50%);border:2px solid #f0f0f0;border-radius:50px;box-shadow:0px 0px 4px 2px #0f0f0f"></div>',i}(t.Control);e.ColorPicker=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i)||this;o._pathDisplay=new t.Binding(null),o._pathValue=new t.Binding(null),o._pathChecked=new t.Binding(null),o._html=!1,o._checkedItems=[],o._itemRole="option",o._search="",o.selectedIndexChanged=new t.Event,o.itemsChanged=new t.Event,o.loadingItems=new t.Event,o.loadedItems=new t.Event,o.itemChecked=new t.Event,o.checkedItemsChanged=new t.Event,o.formatItem=new t.Event,o.applyTemplate("wj-control wj-content wj-listbox",null,null);var s=o.hostElement;return t.setAttribute(s,"role","listbox",!0),"SELECT"==o._orgTag&&o._initFromSelect(o.hostElement),o.addEventListener(s,"click",o._click.bind(o)),o.addEventListener(s,"keydown",o._keydown.bind(o)),o.addEventListener(s,"keypress",o._keypress.bind(o)),o.addEventListener(s,"wheel",function(t){s.scrollHeight>s.offsetHeight&&(t.deltaY<0&&0==s.scrollTop||t.deltaY>0&&s.scrollTop+s.offsetHeight>=s.scrollHeight)&&(t.preventDefault(),t.stopPropagation())}),o._tabIndex=s.tabIndex,o.initialize(n),o}return __extends(i,e),i.prototype.refresh=function(t){void 0===t&&(t=!0),e.prototype.refresh.call(this,t),!this.displayMemberPath&&this.checkedMemberPath||this._populateList()},Object.defineProperty(i.prototype,"itemsSource",{get:function(){return this._items},set:function(e){this._items!=e&&(this._cv&&(this._cv.currentChanged.removeHandler(this._cvCurrentChanged,this),this._cv.collectionChanged.removeHandler(this._cvCollectionChanged,this),this._cv=null),this._items=e,this._cv=t.asCollectionView(e),null!=this._cv&&(this._cv.currentChanged.addHandler(this._cvCurrentChanged,this),this._cv.collectionChanged.addHandler(this._cvCollectionChanged,this)),this._populateList(),this.onItemsChanged(),this.onSelectedIndexChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"collectionView",{get:function(){return this._cv},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isContentHtml",{get:function(){return this._html},set:function(e){e!=this._html&&(this._html=t.asBoolean(e),this._populateList())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"itemFormatter",{get:function(){return this._itemFormatter},set:function(e){e!=this._itemFormatter&&(this._itemFormatter=t.asFunction(e),this._populateList())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"displayMemberPath",{get:function(){return this._pathDisplay.path},set:function(e){e!=this.displayMemberPath&&(this._pathDisplay.path=t.asString(e),this._populateList())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectedValuePath",{get:function(){return this._pathValue.path},set:function(e){this._pathValue.path=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"checkedMemberPath",{get:function(){return this._pathChecked.path},set:function(e){e!=this.checkedMemberPath&&(this._pathChecked.path=t.asString(e),this._populateList())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"itemRole",{get:function(){return this._itemRole},set:function(e){e!=this.itemRole&&(this._itemRole=t.asString(e),this._populateList())},enumerable:!0,configurable:!0}),i.prototype.getDisplayValue=function(e){var i=null;e>-1&&t.hasItems(this._cv)&&(i=this._cv.items[e],this.displayMemberPath&&(i=this._pathDisplay.getValue(i)));var n=null!=i?i.toString():"";return this.itemFormatter&&(n=this.itemFormatter(e,n)),n},i.prototype.getDisplayText=function(t){var e=this.hostElement.children,i=t>-1&&t<e.length?e[t]:null;return null!=i?i.textContent:""},i.prototype.isItemEnabled=function(e){if(!this.getDisplayText(e))return!1;var i=this.hostElement.children[e];return!(!i||i.hasAttribute("disabled")||t.hasClass(i,"wj-state-disabled"))},Object.defineProperty(i.prototype,"selectedIndex",{get:function(){return this._cv?this._cv.currentPosition:-1},set:function(e){this._cv&&this._cv.moveCurrentToPosition(t.asNumber(e))},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectedItem",{get:function(){return this._cv?this._cv.currentItem:null},set:function(t){this._cv&&this._cv.moveCurrentTo(t)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectedValue",{get:function(){var t=this.selectedItem;return t&&this.selectedValuePath&&(t=this._pathValue.getValue(t)),t},set:function(e){var i=this.selectedValuePath,n=-1;if(this._cv){for(var o=0;o<this._cv.items.length;o++){var s=this._cv.items[o],r=i?this._pathValue.getValue(s):s;if(r===e||t.DateTime.equals(r,e)){n=o;break}}this.selectedIndex=n}},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"maxHeight",{get:function(){var t=this.hostElement;return t?parseFloat(t.style.maxHeight):null},set:function(e){var i=this.hostElement;i&&(i.style.maxHeight=t.asNumber(e)+"px")},enumerable:!0,configurable:!0}),i.prototype.showSelection=function(){for(var e,i=this.selectedIndex,n=this.hostElement,o=n.children,s=0;s<o.length;s++)e=o[s],t.toggleClass(e,"wj-state-selected",s==i),t.setAttribute(e,"tabindex",s==i?this._tabIndex:-1);if(i>-1&&i<o.length){var r=(e=o[i]).getBoundingClientRect(),a=n.getBoundingClientRect();r.bottom>a.bottom?n.scrollTop+=r.bottom-a.bottom:r.top<a.top&&(n.scrollTop-=a.top-r.top)}i>-1&&this.containsFocus()&&(e=o[i])instanceof HTMLElement&&!t.contains(e,t.getActiveElement())&&e.focus(),t.setAttribute(n,"tabindex",i<0?this._tabIndex:-1)},i.prototype.getItemChecked=function(e){var i=this._cv.items[e];if(t.isObject(i)&&this.checkedMemberPath)return this._pathChecked.getValue(i);var n=this._getCheckbox(e);return!!n&&n.checked},i.prototype.setItemChecked=function(t,e){this._setItemChecked(t,e,!0)},i.prototype.toggleItemChecked=function(t){this.setItemChecked(t,!this.getItemChecked(t))},Object.defineProperty(i.prototype,"checkedItems",{get:function(){if(this._checkedItems.splice(0,this._checkedItems.length),this._cv)for(var t=0;t<this._cv.items.length;t++)this.getItemChecked(t)&&this._checkedItems.push(this._cv.items[t]);return this._checkedItems},set:function(e){var i=this._cv,n=this.hostElement,o=t.asArray(e,!1);if(i&&o){for(var s=i.currentPosition,r=n.scrollTop,a=0;a<i.items.length;a++){var l=i.items[a];this._setItemChecked(a,o.indexOf(l)>-1,!1)}i.moveCurrentToPosition(s),n.scrollTop=r,this.onCheckedItemsChanged()}},enumerable:!0,configurable:!0}),i.prototype.onSelectedIndexChanged=function(t){this.selectedIndexChanged.raise(this,t)},i.prototype.onItemsChanged=function(t){this.itemsChanged.raise(this,t)},i.prototype.onLoadingItems=function(t){this.loadingItems.raise(this,t)},i.prototype.onLoadedItems=function(t){this.loadedItems.raise(this,t)},i.prototype.onItemChecked=function(t){this.itemChecked.raise(this,t)},i.prototype.onCheckedItemsChanged=function(t){this.checkedItemsChanged.raise(this,t)},i.prototype.onFormatItem=function(t){this.formatItem.raise(this,t)},i.prototype._setItemChecked=function(e,i,n){void 0===n&&(n=!0);var o=this._cv.items[e];if(t.isObject(o)){var s=t.tryCast(this._cv,"IEditableCollectionView");this._pathChecked.getValue(o)!=i&&(this._checking=!0,s?(s.editItem(o),this._pathChecked.setValue(o,i),s.commitEdit()):(this._pathChecked.setValue(o,i),this._cv.refresh()),this._checking=!1)}var r=this._getCheckbox(e);if(r){r.checked=i;var a=t.closest(r,".wj-listbox-item");a&&t.toggleClass(a,"wj-state-checked",i)}n&&(this.onItemChecked(),this.onCheckedItemsChanged())},i.prototype._cvCollectionChanged=function(t,e){this._checking||(this._populateList(),this.onItemsChanged())},i.prototype._cvCurrentChanged=function(t,e){this._checking||(this.showSelection(),this.onSelectedIndexChanged())},i.prototype._populateList=function(){var e=this.hostElement;if(e){var i=this.containsFocus();if(this.onLoadingItems(),e.innerHTML="",this._cv){for(var o=document.createDocumentFragment(),s=0;s<this._cv.items.length;s++){var r=this.getDisplayValue(s);1!=this._html&&(r=t.escapeHtml(r));var a=!1;this.checkedMemberPath&&(r='<label><input tabindex="-1" type="checkbox"'+((a=this._pathChecked.getValue(this._cv.items[s]))?" checked":"")+"> "+r+"</label>");var l=document.createElement("div"),h="wj-listbox-item";if(l.innerHTML=r,t.hasClass(l.firstChild,"wj-separator")&&(h+=" wj-separator"),a&&(h+=" wj-state-checked"),l.className=h,t.setAttribute(l,"role",this.itemRole?this.itemRole:null),this.formatItem.hasHandlers){var c=new n(s,this._cv.items[s],l);this.onFormatItem(c)}o.appendChild(l)}e.appendChild(o)}0==e.children.length&&e.appendChild(document.createElement("div")),i&&!this.containsFocus()&&this.focus(),this.showSelection(),this.onLoadedItems()}},i.prototype._click=function(e){if(!e.defaultPrevented){for(var i=this.hostElement.children,n=0;n<i.length;n++)if(t.contains(i[n],e.target)){this.selectedIndex=n;break}var o=this.selectedIndex;if(this.checkedMemberPath&&o>-1){var s=this._getCheckbox(o);s==e.target&&(i[o].focus(),this.setItemChecked(o,s.checked))}}},i.prototype._keydown=function(e){var i=this.selectedIndex;this.hostElement.children;if(!e.defaultPrevented){if(65==e.keyCode&&(e.ctrlKey||e.metaKey)&&this.checkedMemberPath&&t.hasItems(this.collectionView))return this.checkedItems=this.getItemChecked(0)?[]:this.collectionView.items,void e.preventDefault();if(!(e.ctrlKey||e.shiftKey||e.altKey||e.metaKey))switch(e.keyCode){case t.Key.Down:e.preventDefault(),this._selectNext();break;case t.Key.Up:e.preventDefault(),this._selectPrev();break;case t.Key.Home:e.preventDefault(),this._selectFirst();break;case t.Key.End:e.preventDefault(),this._selectLast();break;case t.Key.PageDown:e.preventDefault(),this._selectNextPage();break;case t.Key.PageUp:e.preventDefault(),this._selectPrevPage();break;case t.Key.Space:if(this.checkedMemberPath&&i>-1){var n=this._getCheckbox(i);n&&this.isItemEnabled(i)&&(this.setItemChecked(i,!n.checked),e.preventDefault())}}}},i.prototype._keypress=function(t){var e=this;if(!t.defaultPrevented&&!(t.target instanceof HTMLInputElement)&&(t.charCode>32||32==t.charCode&&this._search)){t.preventDefault(),this._search+=String.fromCharCode(t.charCode).toLowerCase(),this._toSearch&&clearTimeout(this._toSearch),this._toSearch=setTimeout(function(){e._toSearch=null,e._search=""},i._AUTOSEARCH_DELAY);var n=this._findNext();n<0&&this._search.length>1&&(this._search=this._search[this._search.length-1],n=this._findNext()),n>-1&&(this.selectedIndex=n)}},i.prototype._selectNext=function(){for(var t=this.hostElement.children.length,e=this.selectedIndex+1;e<t;e++)if(this.isItemEnabled(e))return this.selectedIndex=e,!0;return!1},i.prototype._selectPrev=function(){for(var t=this.selectedIndex-1;t>=0;t--)if(this.isItemEnabled(t))return this.selectedIndex=t,!0;return!1},i.prototype._selectFirst=function(){for(var t=this.hostElement.children.length,e=0;e<t;e++)if(this.isItemEnabled(e))return this.selectedIndex=e,!0;return!1},i.prototype._selectLast=function(){for(var t=this.hostElement.children.length-1;t>=0;t--)if(this.isItemEnabled(t))return this.selectedIndex=t,!0;return!1},i.prototype._selectNextPage=function(){for(var t=this.hostElement,e=t.offsetHeight,i=t.children,n=0,o=this.selectedIndex+1;o<this._cv.items.length;o++){var s=i[o].scrollHeight;if(n+s>e&&this.isItemEnabled(o))return this.selectedIndex=o,!0;n+=s}return this._selectLast()},i.prototype._selectPrevPage=function(){for(var t=this.hostElement,e=t.offsetHeight,i=t.children,n=0,o=this.selectedIndex-1;o>0;o--){var s=i[o].scrollHeight;if(n+s>e&&this.isItemEnabled(o))return this.selectedIndex=o,!0;n+=s}return this._selectFirst()},i.prototype._findNext=function(){if(this.hostElement){var t=this.hostElement.childElementCount,e=this.selectedIndex;(e<0||1==this._search.length)&&e++;for(var i=0;i<t;i++){var n=(e+i)%t;if(0==this.getDisplayText(n).trim().toLowerCase().indexOf(this._search)&&this.isItemEnabled(n))return n}}return-1},i.prototype._getCheckbox=function(t){var e=this.hostElement;return e&&t>-1&&t<e.children.length?e.children[t].querySelector("input[type=checkbox]"):null},i.prototype._initFromSelect=function(t){for(var e=t.children,i=[],n=-1,o=0;o<e.length;o++){var s=e[o];"OPTION"==s.tagName&&(s.hasAttribute("selected")&&(n=i.length),s.innerHTML?i.push({hdr:s.innerHTML,val:s.getAttribute("value"),cmdParam:s.getAttribute("cmd-param")}):i.push({hdr:'<div class="wj-separator"/>'}),t.removeChild(s),o--)}i&&(this.displayMemberPath="hdr",this.selectedValuePath="val",this.itemsSource=i,this.selectedIndex=n)},i._AUTOSEARCH_DELAY=600,i}(t.Control);e.ListBox=i;var n=function(e){function i(i,n,o){var s=e.call(this)||this;return s._index=t.asNumber(i),s._data=n,s._item=t.asType(o,HTMLElement),s}return __extends(i,e),Object.defineProperty(i.prototype,"index",{get:function(){return this._index},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"data",{get:function(){return this._data},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"item",{get:function(){return this._item},enumerable:!0,configurable:!0}),i}(t.EventArgs);e.FormatItemEventArgs=n}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(i){function n(e,n){var o=i.call(this,e)||this;o._editable=!1,o._delKey=0,o._composing=!1,o._pathHdr=new t.Binding(null),o._bsCollapse=!0,o.itemsSourceChanged=new t.Event,o.selectedIndexChanged=new t.Event;var s=o.hostElement;t.addClass(s,"wj-combobox");var r=o._tbx,a=t.getUniqueId(s.id+"_dropdown");return o.dropDown.id=a,t.setAttribute(r,"role","combobox"),t.setAttribute(r,"aria-autocomplete","both"),t.setAttribute(r,"aria-owns",a),t.setAttribute(o._btn,"aria-controls",a),t.setAttribute(o.dropDown,"aria-expanded",!1),o.autoExpandSelection=!1,o.addEventListener(o._tbx,"compositionstart",function(){o._composing=!0}),o.addEventListener(o._tbx,"compositionend",function(){o._composing=!1,setTimeout(function(){o._setText(o.text,!0)})}),o.addEventListener(s,"wheel",function(e){if(!e.defaultPrevented&&!o.isDroppedDown&&!o.isReadOnly&&o.containsFocus()&&o.selectedIndex>-1){var i=t.clamp(-e.deltaY,-1,1);o.selectedIndex=t.clamp(o.selectedIndex-i,0,o.collectionView.items.length-1),e.preventDefault()}}),"SELECT"==o._orgTag&&o._lbx._initFromSelect(s),o._lbx.loadedItems.addHandler(function(){o.selectedIndex>-1&&(o.selectedIndex=o._lbx.selectedIndex)}),o.isRequired=!0,o.initialize(n),o}return __extends(n,i),Object.defineProperty(n.prototype,"itemsSource",{get:function(){return this._lbx.itemsSource},set:function(t){this._lbx.itemsSource!=t&&(this._lbx.itemsSource=t,this.onItemsSourceChanged()),this._updateBtn()},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"collectionView",{get:function(){return this._lbx.collectionView},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"displayMemberPath",{get:function(){return this._lbx.displayMemberPath},set:function(t){this._lbx.displayMemberPath=t;var e=this.getDisplayText();this.text!=e&&this._setText(e,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"headerPath",{get:function(){return this._pathHdr.path},set:function(e){this._pathHdr.path=t.asString(e);var i=this.getDisplayText();this.text!=i&&this._setText(i,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectedValuePath",{get:function(){return this._lbx.selectedValuePath},set:function(t){this._lbx.selectedValuePath=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isContentHtml",{get:function(){return this._lbx.isContentHtml},set:function(e){if(e!=this.isContentHtml){this._lbx.isContentHtml=t.asBoolean(e);var i=this.getDisplayText();this.text!=i&&this._setText(i,!0)}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemFormatter",{get:function(){return this._lbx.itemFormatter},set:function(e){this._lbx.itemFormatter=t.asFunction(e),this.selectedIndex=this._lbx.selectedIndex},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"formatItem",{get:function(){return this.listBox.formatItem},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectedIndex",{get:function(){return this._lbx.selectedIndex},set:function(t){t!=this.selectedIndex&&(this._lbx.selectedIndex=t),t=this.selectedIndex;var e=this.getDisplayText(t);this.text!=e&&this._setText(e,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectedItem",{get:function(){return this._lbx.selectedItem},set:function(t){this._lbx.selectedItem=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectedValue",{get:function(){return this._lbx.selectedValue},set:function(t){this._lbx.selectedValue=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isEditable",{get:function(){return this._editable},set:function(e){this._editable=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"maxDropDownHeight",{get:function(){return this._lbx.maxHeight},set:function(e){this._lbx.maxHeight=t.asNumber(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"maxDropDownWidth",{get:function(){var t=this._dropDown;return parseInt(t.style.maxWidth)},set:function(e){this._dropDown.style.maxWidth=t.asNumber(e)+"px"},enumerable:!0,configurable:!0}),n.prototype.getDisplayText=function(e){if(void 0===e&&(e=this.selectedIndex),this.headerPath&&e>-1&&t.hasItems(this.collectionView)){var i=this.collectionView.items[e],n=i?this._pathHdr.getValue(i):null;return n=null!=n?n.toString():"",this.isContentHtml&&(this._cvt||(this._cvt=document.createElement("div")),this._cvt.innerHTML=n,n=this._cvt.textContent),n.trim()}return this._lbx.getDisplayText(e).trim()},n.prototype.indexOf=function(e,i){var n=this.collectionView;if(t.hasItems(n)&&null!=e){var o=this.selectedIndex;if(i&&e==this.getDisplayText(o))return o;e=e.toString().toLowerCase();for(var s=0;s<n.items.length;s++)if(this.listBox.isItemEnabled(s)){var r=this.getDisplayText(s).toLowerCase();if(i){if(r==e)return s}else if(e&&0==r.indexOf(e))return s}}return-1},Object.defineProperty(n.prototype,"listBox",{get:function(){return this._lbx},enumerable:!0,configurable:!0}),n.prototype.onItemsSourceChanged=function(t){this.itemsSourceChanged.raise(this,t)},n.prototype.onSelectedIndexChanged=function(t){this._updateBtn(),this.selectedIndexChanged.raise(this,t)},n.prototype.refresh=function(e){void 0===e&&(e=!0),i.prototype.refresh.call(this,e),t.hasItems(this.collectionView)&&(this._lbx.refresh(),this.selectedIndex>-1&&(this.selectedIndex=this._lbx.selectedIndex))},n.prototype.onLostFocus=function(e){this._composing&&(this._composing=!1,this._setText(this.text,!0)),this.isEditable&&this.isRequired&&!this.text&&t.hasItems(this.collectionView)&&(this.selectedIndex=0),i.prototype.onLostFocus.call(this,e)},n.prototype.onIsDroppedDownChanging=function(e){return this.isDroppedDown||t.hasItems(this.collectionView)?i.prototype.onIsDroppedDownChanging.call(this,e):(e.cancel=!0,!1)},n.prototype.onIsDroppedDownChanged=function(e){i.prototype.onIsDroppedDownChanged.call(this,e),this.isDroppedDown&&(this._lbx.showSelection(),this.isTouching||this.selectAll()),t.setAttribute(this.dropDown,"aria-expanded",this.isDroppedDown)},n.prototype._updateBtn=function(){var e=this.collectionView;this._btn.style.display=this._showBtn&&null!=e?"":"none",t.enable(this._btn,t.hasItems(e))},n.prototype._btnclick=function(t){i.prototype._btnclick.call(this,t),this.isTouching||this._elRef!=this._tbx||this.selectAll()},n.prototype._createDropDown=function(){var i=this;this._lbx||(this._lbx=new e.ListBox(this._dropDown)),this._lbx.maxHeight=200,this._lbx.selectedIndexChanged.addHandler(function(){i._updateBtn();var e=i._lbx.selectedIndex,n=i._lbx.hostElement.children,o=e>-1&&e<n.length?n[e].id:null;t.setAttribute(i._tbx,"aria-activedescendant",o&&o.length?o:null),i.selectedIndex=e,i.onSelectedIndexChanged()}),this._lbx.itemsChanged.addHandler(function(){i._updateBtn()}),this.addEventListener(this._dropDown,"click",this._dropDownClick.bind(this))},n.prototype._dropDownClick=function(t){t.defaultPrevented||t.target!=this._dropDown&&(this.isDroppedDown=!1)},n.prototype._setText=function(e,n){if(!this._composing&&!this._settingText){this._settingText=!0,null==e&&(e=""),e=e.toString();var o=this.selectedIndex,s=this.collectionView,r=this._getSelStart(),a=-1,l=!0;if(this._delKey&&this.isEditable&&(n=!0,l=!1),o=this.indexOf(e,n),l&&(o<0&&n&&(o=this.indexOf(e,!1)),o<0&&r>0&&(o=this.indexOf(e.substr(0,r),!1))),o<0&&!this.isEditable&&t.hasItems(s)&&(this.isRequired||e)){var h=this._oldText||"";o=Math.max(0,this.indexOf(h,!1));for(var c=0;c<e.length&&c<h.length;c++)if(e[c]!=h[c]){r=c;break}}o>-1&&(a=r,e=this.getDisplayText(o)),e!=this._tbx.value&&(this._tbx.value=e),a>-1&&this.containsFocus()&&!this.isTouching&&this._updateInputSelection(a),s&&s.moveCurrentToPosition(o),i.prototype._setText.call(this,e,n),this._delKey=0,this._settingText=!1}},n.prototype._findNext=function(t,e){if(this.collectionView){t=t.toLowerCase();for(var i=this.collectionView.items.length,n=void 0,o=void 0,s=1;s<=i;s++)if(n=(this.selectedIndex+s*e+i)%i,(o=this.getDisplayText(n).toLowerCase())&&0==o.indexOf(t)&&(!this.dropDown.children[n]||this.listBox.isItemEnabled(n)))return n}return this.selectedIndex},n.prototype._keydown=function(e){if(i.prototype._keydown.call(this,e),!e.defaultPrevented&&!this.isReadOnly&&!e.altKey&&t.hasItems(this.collectionView)&&this._elRef==this._tbx){this._delKey=0;var n=this._getSelStart();switch(e.keyCode){case t.Key.Back:if(this._bsCollapse&&!this.isEditable){var o=this._getSelEnd();n>0&&o==this._tbx.value.length&&t.hasItems(this.collectionView)&&this._setSelRange(n-1,o)}this._delKey=e.keyCode;break;case t.Key.Delete:this._delKey=e.keyCode;break;case t.Key.Up:case t.Key.Down:n==this.text.length&&(n=0),this.selectedIndex=this._findNext(this.text.substr(0,n),e.keyCode==t.Key.Up?-1:1),this._setSelRange(n,this.text.length),e.preventDefault()}}},n.prototype._updateInputSelection=function(t){this._elRef==this._tbx&&this._setSelRange(t,this._tbx.value.length)},n.prototype._getSelStart=function(){return this._tbx&&this._tbx.value?this._tbx.selectionStart:0},n.prototype._getSelEnd=function(){return this._tbx&&this._tbx.value?this._tbx.selectionEnd:0},n.prototype._setSelRange=function(e,i){var n=this._tbx;this._elRef==n&&t.setSelectionRange(n,e,i)},n}(e.DropDown);e.ComboBox=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i)||this;return o._cssMatch="wj-autocomplete-match",o._minLength=2,o._maxItems=6,o._itemCount=0,o._delay=500,o._query="",o._inCallback=!1,o._srchProps=[],t.addClass(o.hostElement,"wj-autocomplete"),o._bsCollapse=!1,o.isEditable=!0,o.isRequired=!1,o.isContentHtml=!0,o.listBox.formatItem.addHandler(o._formatListItem,o),o._itemsSourceFnCallBackBnd=o._itemSourceFunctionCallback.bind(o),o.initialize(n),o}return __extends(i,e),Object.defineProperty(i.prototype,"minLength",{get:function(){return this._minLength},set:function(e){this._minLength=t.asNumber(e,!1,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"maxItems",{get:function(){return this._maxItems},set:function(e){this._maxItems=t.asNumber(e,!1,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"delay",{get:function(){return this._delay},set:function(e){this._delay=t.asNumber(e,!1,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"searchMemberPath",{get:function(){return this._srchProp},set:function(e){this._srchProp=t.asString(e),this._srchProps=e?e.trim().split(/\s*,\s*/):[]},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"itemsSourceFunction",{get:function(){return this._itemsSourceFn},set:function(e){this._itemsSourceFn=t.asFunction(e),t.isFunction(this._itemsSourceFn)&&this.itemsSourceFunction(this.text,this.maxItems,this._itemsSourceFnCallBackBnd)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"cssMatch",{get:function(){return this._cssMatch},set:function(e){this._cssMatch=t.asString(e)},enumerable:!0,configurable:!0}),i.prototype._keydown=function(i){if(!i.defaultPrevented&&this.isDroppedDown)switch(i.keyCode){case t.Key.Up:case t.Key.Down:this.selectAll()}e.prototype._keydown.call(this,i)},i.prototype._setText=function(e){var i=this;if(!this._inCallback){if(!e&&this.selectedIndex>-1&&(this.selectedIndex=-1),e!=this._oldText&&(this._tbx.value!=e&&(this._tbx.value=e),this._oldText=e,this.onTextChanged(),!e&&this.collectionView))return this._rxHighlight=null,this.collectionView.filter=this._query=null,void(this.isDroppedDown=!1);this._toSearch&&clearTimeout(this._toSearch),e!=this.getDisplayText()&&(this._toSearch=setTimeout(function(){i._toSearch=null;var e=i.text.trim().toLowerCase();if(e.length>=i._minLength&&e!=i._query){i._query=e,e=e.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1");var n=t.escapeHtml(e);i._rxMatch=new RegExp("(?=.*"+e.replace(/ /g,")(?=.*")+")","ig"),i._rxHighlight=i.isContentHtml?new RegExp("("+n.replace(/ /g,"|")+")(?![^<]*>|[^<>]* </)","ig"):new RegExp("("+n.replace(/ /g,"|")+")","ig"),i.itemsSourceFunction?i.itemsSourceFunction(e,i.maxItems,i._itemsSourceFnCallBackBnd):i._updateItems()}},this._delay))}},i.prototype._itemSourceFunctionCallback=function(e){this._inCallback=!0;var i=t.asCollectionView(e);i&&i.moveCurrentToPosition(-1),this.itemsSource=i,this._inCallback=!1,this.containsFocus()&&(this.isDroppedDown=!0,this.refresh())},i.prototype.onIsDroppedDownChanged=function(e){if(this.isDroppedDownChanged.raise(this,e),this.containsFocus()&&!this.isDroppedDown&&!this.isTouching&&null==this.selectedItem){var i=this.text.length;t.setSelectionRange(this._tbx,i)}this._query=""},i.prototype._updateItems=function(){var t=this.collectionView;if(t){this._inCallback=!0,t.beginUpdate(),this._itemCount=0,t.filter=this._filter.bind(this),t.moveCurrentToPosition(-1),t.endUpdate(),this._inCallback=!1;var e=t.items.length;this.isDroppedDown=e>0&&this.containsFocus(),0!=e||this.isEditable||(this.selectedIndex=-1),this.refresh()}},i.prototype._filter=function(t){if(this._itemCount>=this._maxItems)return!1;var e=this._getItemText(t,!1);if(this._srchProps)for(var i=0;i<this._srchProps.length;i++)e+="\0"+t[this._srchProps[i]];return this.isContentHtml&&(e=e.replace(/<[^>]*>/g,"")),!!e.match(this._rxMatch)&&(this._itemCount++,!0)},i.prototype._getItemText=function(t,e){var i=t?t.toString():"",n=e&&this.headerPath?this._pathHdr:this._lbx._pathDisplay;return n&&(i=null!=(i=n.getValue(t))?i.toString():""),i},i.prototype._formatListItem=function(t,e){if(this._cssMatch&&this._rxHighlight){var i='<span class="'+this._cssMatch+'">$1</span>';e.item.innerHTML=e.item.innerHTML.replace(this._rxHighlight,i)}},i}(e.ComboBox);e.AutoComplete=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i)||this;o.itemClicked=new t.Event;var s=o.hostElement,r=o._tbx;t.addClass(s,"wj-menu"),r.style.display="none";o._hdr=o._elRef=t.createElement('<div wj-part="header" class="wj-form-control" style="cursor:default"/>'),r.parentElement.insertBefore(o._hdr,o._tbx);var a=o._orgOuter.match(/tabindex="?(-?\d+)"?/i);return a&&(s.tabIndex=parseInt(a[1])),o.isRequired=!1,t.setAttribute(s,"role","menubar",!0),t.setAttribute(r,"role",null),t.setAttribute(r,"aria-autocomplete",null),t.setAttribute(r,"aria-owns",null),t.setAttribute(o.dropDown,"role","menu"),o.listBox.itemRole="menuitem","SELECT"==o._orgTag&&(o.header=s.getAttribute("header"),o._lbx.itemsSource&&(o.commandParameterPath="cmdParam")),o.isContentHtml=!0,o.maxDropDownHeight=500,o.addEventListener(o._hdr,"click",function(t){t.defaultPrevented||(o._isButton?(o.isDroppedDown=!1,o._raiseCommand()):o.isDroppedDown=!o.isDroppedDown)}),o.listBox.lostFocus.addHandler(function(){o.containsFocus()||(o.isDroppedDown=!1)}),o.initialize(n),o}return __extends(i,e),Object.defineProperty(i.prototype,"header",{get:function(){return this._hdr.innerHTML},set:function(e){this._hdr.innerHTML=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"command",{get:function(){return this._command},set:function(t){this._command=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"commandPath",{get:function(){return this._cmdPath},set:function(e){this._cmdPath=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"commandParameterPath",{get:function(){return this._cmdParamPath},set:function(e){this._cmdParamPath=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isButton",{get:function(){return this._isButton},set:function(e){this._isButton=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"owner",{get:function(){return this._owner},set:function(e){this._owner=t.asType(e,HTMLElement,!0),this._enableDisableItems()},enumerable:!0,configurable:!0}),i.prototype.show=function(e){if(!this.isDroppedDown){var i=this.dropDown;this.selectedIndex=-1,this.onIsDroppedDownChanging(new t.CancelEventArgs)&&(this.owner&&(i[t.Control._OWNR_KEY]=this.owner),t.showPopup(i,e),this.onIsDroppedDownChanged(),i.focus())}},i.prototype.hide=function(){this.isDroppedDown&&this.onIsDroppedDownChanging(new t.CancelEventArgs)&&(t.hidePopup(this.dropDown),this.onIsDroppedDownChanged())},i.prototype.onItemClicked=function(t){this.itemClicked.raise(this,t)},i.prototype.refresh=function(t){void 0===t&&(t=!0),e.prototype.refresh.call(this,t),this._enableDisableItems()},i.prototype.onIsDroppedDownChanged=function(t){e.prototype.onIsDroppedDownChanged.call(this,t),this.isDroppedDown?(this._closing=!0,this._defaultItem=this.selectedItem,this.isRequired=!1,this.selectedIndex=-1,this._enableDisableItems(),this._closing=!1,this.dropDown.focus()):this.selectedItem||(this.selectedItem=this._defaultItem)},i.prototype._keydown=function(i){i.defaultPrevented||i.keyCode==t.Key.Enter&&(this.isDroppedDown?this.getDisplayText(this.selectedIndex)&&this._raiseCommand():(this.isDroppedDown=!0,i.preventDefault())),e.prototype._keydown.call(this,i)},i.prototype._dropDownClick=function(t){t.defaultPrevented||t.target==this.dropDown||this.getDisplayText(this.selectedIndex)&&this._raiseCommand(),e.prototype._dropDownClick.call(this,t)},i.prototype._raiseCommand=function(t){var e=this.selectedItem,i=this._getCommand(e);if(i){var n=this._cmdParamPath?e[this._cmdParamPath]:null;if(!this._canExecuteCommand(i,n))return;this._executeCommand(i,n)}this.onItemClicked(t)},i.prototype._getCommand=function(t){var e=t&&this.commandPath?t[this.commandPath]:null;return e||this.command},i.prototype._executeCommand=function(e,i){e&&!t.isFunction(e)&&(e=e.executeCommand),t.isFunction(e)&&e(i)},i.prototype._canExecuteCommand=function(e,i){if(e){var n=e.canExecuteCommand;if(t.isFunction(n))return n(i)}return!0},i.prototype._enableDisableItems=function(){if(this.collectionView&&(this.command||this.commandPath))for(var e=this.collectionView.items,i=0;i<e.length;i++){var n=this._getCommand(e[i]),o=this.commandParameterPath?e[i][this.commandParameterPath]:null;if(n){var s=this._lbx.hostElement.children[i];t.toggleClass(s,"wj-state-disabled",!this._canExecuteCommand(n,o))}}},i}(e.ComboBox);e.Menu=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();wijmo.culture.MultiSelect=window.wijmo.culture.MultiSelect||{itemsSelected:"{count:n0} items selected",selectAll:"Select All"};var wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i)||this;return o._maxHdrItems=2,o._readOnly=!1,o._hdrFmt=t.culture.MultiSelect.itemsSelected,o.checkedItemsChanged=new t.Event,t.addClass(o.hostElement,"wj-multiselect"),o._tbx.readOnly=!0,o.checkedMemberPath=null,o.addEventListener(o.inputElement,"click",function(){o.isDroppedDown=!o.isDroppedDown}),o.addEventListener(o._selectAll,"click",function(e){t.hasItems(o.collectionView)&&e.target==o._selectAllCheckbox&&(o.checkedItems=e.target.checked?o.collectionView.items:[])}),o.removeEventListener(o.dropDown,"click"),o._updateHeader(),o.listBox.itemsChanged.addHandler(function(){o._updateHeader()}),o.listBox.checkedItemsChanged.addHandler(function(){o._updateHeader(),o.onCheckedItemsChanged()}),o.initialize(n),o}return __extends(i,e),Object.defineProperty(i.prototype,"showSelectAllCheckbox",{get:function(){return""==this._selectAll.style.display},set:function(e){this._selectAll.style.display=t.asBoolean(e)?"":"none"},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectAllLabel",{get:function(){return this._selectAllLabel},set:function(e){e!=this._selectAllLabel&&(this._selectAllLabel=t.asString(e),this.refresh())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"checkedMemberPath",{get:function(){var t=this.listBox.checkedMemberPath;return t!=i._DEF_CHECKED_PATH?t:null},set:function(e){e=t.asString(e),this.listBox.checkedMemberPath=e||i._DEF_CHECKED_PATH},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"maxHeaderItems",{get:function(){return this._maxHdrItems},set:function(e){this._maxHdrItems!=e&&(this._maxHdrItems=t.asNumber(e),this._updateHeader())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"headerFormat",{get:function(){return this._hdrFmt},set:function(e){e!=this._hdrFmt&&(this._hdrFmt=t.asString(e),this._updateHeader())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"headerFormatter",{get:function(){return this._hdrFormatter},set:function(e){e!=this._hdrFormatter&&(this._hdrFormatter=t.asFunction(e),this._updateHeader())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"checkedItems",{get:function(){return this.listBox.checkedItems},set:function(e){this.listBox.checkedItems=t.asArray(e)},enumerable:!0,configurable:!0}),i.prototype.onCheckedItemsChanged=function(t){this.checkedItemsChanged.raise(this,t)},i.prototype._createDropDown=function(){this._selectAll=t.createElement('<div class="wj-listbox-item wj-header wj-select-all" tabindex="0" style="display:none"><label><input type="checkbox"> <span></span></label></div>',this._dropDown),this._selectAllCheckbox=this._selectAll.querySelector("input[type=checkbox]"),this._selectAllSpan=this._selectAll.querySelector("label>span"),t.setText(this._selectAllSpan,t.culture.MultiSelect.selectAll);var i=t.createElement('<div style="width:100%;border:none"></div>',this._dropDown);this._lbx=new t.input.ListBox(i),e.prototype._createDropDown.call(this)},Object.defineProperty(i.prototype,"isReadOnly",{get:function(){return this._readOnly},set:function(e){this._readOnly=t.asBoolean(e),t.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0}),i.prototype.refresh=function(i){void 0===i&&(i=!0),e.prototype.refresh.call(this,i),this._updateHeader(),this._selectAllSpan&&t.setText(this._selectAllSpan,this._selectAllLabel||t.culture.MultiSelect.selectAll)},i.prototype.onIsDroppedDownChanged=function(t){var i=this;e.prototype.onIsDroppedDownChanged.call(this,t),this.isDroppedDown&&this.containsFocus()&&setTimeout(function(){i.listBox.focus()},200)},i.prototype._setText=function(t,e){},i.prototype._keydown=function(i){e.prototype._keydown.call(this,i),!i.defaultPrevented&&t.hasItems(this.collectionView)&&i.keyCode>32&&(this.isDroppedDown=!0)},i.prototype._updateHeader=function(){var e=this.checkedItems;if(t.isFunction(this._hdrFormatter))this.inputElement.value=this._hdrFormatter();else{var i="";if(e.length>0)if(e.length<=this._maxHdrItems){if(this.displayMemberPath){var n=new t.Binding(this.displayMemberPath);e=e.map(function(t){return n.getValue(t)})}i=e.join(", ")}else i=t.format(this.headerFormat,{count:e.length});this.inputElement.value=i}var o=null,s=this.collectionView;t.hasItems(s)&&(0==e.length?o=!1:e.length==s.items.length&&(o=!0)),this._selectAllCheckbox.indeterminate=null==o,null!=o&&(this._selectAllCheckbox.checked=o),this._updateState()},i._DEF_CHECKED_PATH="$checked",i}(e.ComboBox);e.MultiSelect=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i)||this;return o._selItems=[],o._lastInputValue="",o._selPath=new t.Binding(null),o._notAddItm=!1,o.selectedItemsChanged=new t.Event,t.addClass(o.hostElement,"wj-multi-autocomplete"),o.showDropDownButton=!1,o.initialize(n),o._wjTpl=o.hostElement.querySelector(".wj-template"),o._wjInput=o.hostElement.querySelector(".wj-input"),o.addEventListener(o.hostElement,"keyup",o._keyup.bind(o),!0),o.addEventListener(window,"resize",o._adjustInputWidth.bind(o)),o.addEventListener(o._tbx,"focus",function(){o._itemOff()}),o._addHelperInput(),o._initSeltems(),o.listBox.itemsChanged.addHandler(function(){return o.selectedIndex=-1}),o._refreshHeader(),o}return __extends(i,e),Object.defineProperty(i.prototype,"showDropDownButton",{set:function(t){this._showBtn=!1},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"maxSelectedItems",{get:function(){return this._maxtems},set:function(e){this._maxtems!=e&&(this._maxtems=t.asNumber(e,!0),this._updateMaxItems(),this._refreshHeader(),this._clearSelIndex())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectedMemberPath",{get:function(){return this._selPath.path},set:function(e){(e=t.asString(e))!==this.selectedMemberPath&&(this._selPath.path=e,this._initSeltems(),this._refreshHeader(),this.onSelectedItemsChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectedItems",{get:function(){return this._selItems},set:function(e){if(this._selItems=t.asArray(e),this.selectedMemberPath&&""!==this.selectedMemberPath&&this._selItems)for(var i=0;i<this._selItems.length;i++){var n=this._selItems[i];this._setSelItem(n,!1)}this._updateMaxItems(),this.onSelectedItemsChanged(),this._refreshHeader(),this._clearSelIndex()},enumerable:!0,configurable:!0}),i.prototype.onSelectedItemsChanged=function(t){this.selectedItemsChanged.raise(this,t)},i.prototype.onIsDroppedDownChanged=function(t){!this.isDroppedDown&&this.selectedIndex>-1&&!this._notAddItm&&this._addItem(!0),this._notAddItm=!1,e.prototype.onIsDroppedDownChanged.call(this,t)},i.prototype.refresh=function(t){void 0===t&&(t=!0),e.prototype.refresh.call(this,t),this._initSeltems(),this.isDroppedDown||this._refreshHeader()},i.prototype._keydown=function(i){if(!this.isReadOnly){if(!i.defaultPrevented)switch(i.keyCode){case t.Key.Back:this._lastInputValue=this._tbx.value;break;case t.Key.Enter:this._itemOff(),this._addItem(!0),t.isIE&&t.setSelectionRange(this._tbx,0,0);break;case t.Key.Tab:this.isDroppedDown?(this._addItem(!1),this._tbx.value="",this._lbx.selectedIndex=-1,i.preventDefault()):this._updateFocus();break;case t.Key.Space:if(""!==this._tbx.value)return;this.isDroppedDown||this._tbx.disabled||(this.isDroppedDown=!0,this._clearSelIndex());break;case t.Key.Escape:this.isDroppedDown&&(this._notAddItm=!0);break;case t.Key.Left:this._itemOn(!this.rightToLeft);break;case t.Key.Right:this._itemOn(!!this.rightToLeft);break;case t.Key.Up:case t.Key.Down:var n=t.getActiveElement();if(i.altKey){if(this._tbx==n)return this.isDroppedDown=!this.isDroppedDown,this.isDroppedDown||this._tbx.focus(),void i.preventDefault()}else if(this._tbx!==n)return;default:if(i.keyCode===t.Key.Back||i.keyCode===t.Key.Delete)return;this._itemOff(),null!=this._maxtems&&this._selItems.length>=this._maxtems&&i.preventDefault()}this._tbx.disabled||e.prototype._keydown.call(this,i)}},i.prototype._updateState=function(){e.prototype._updateState.call(this),this._wjTpl&&(t.hasClass(this.hostElement,"wj-state-focused")||this._itemOff())},i.prototype._keyup=function(e){if(!this.isReadOnly&&!e.defaultPrevented)switch(e.keyCode){case t.Key.Back:0===this._tbx.value.length&&0===this._lastInputValue.length&&this._delItem(!1);break;case t.Key.Delete:this._delItem(!0)}},i.prototype._addHelperInput=function(){var t=document.createElement("input");t.type="text",t.tabIndex=-1,t.className="wj-token-helper",t.readOnly=!0,this._wjTpl.insertBefore(t,this._wjInput),this._helperInput=t},i.prototype._refreshHeader=function(){for(var t=this.hostElement.querySelectorAll(".wj-token"),e=0;e<t.length;e++)this._wjTpl.removeChild(t[e]);var i=this.selectedItems;if(i&&0!==i.length){for(e=0;e<i.length;e++)this._insertToken(i[e]);this._wjInput.style.cssFloat=this.rightToLeft?"right":"left",this._adjustInputWidth()}},i.prototype._insertToken=function(e){var i=this._getItemText(e,!0);this.isContentHtml?(this._cvt||(this._cvt=document.createElement("div")),this._cvt.innerHTML=i,i=this._cvt.textContent.trim()):i=t.escapeHtml(i),this._wjTpl.insertBefore(this._createItem(i),this._wjInput)},i.prototype._updateMaxItems=function(){null!=this._maxtems&&this._selItems&&this._selItems.length>this._maxtems&&(this._selItems=this._selItems.slice(0,this._maxtems))},i.prototype._updateFocus=function(){var e=this,n=this._wjTpl.querySelector("."+i._clsActive);n?(t.removeClass(n,i._clsActive),setTimeout(function(){e._tbx.focus()})):(this._clearSelIndex(),t.removeClass(this.hostElement,"wj-state-focused"))},i.prototype._addItem=function(t){this.selectedItems.indexOf(this.selectedItem)>-1?this._clearSelIndex():this.selectedIndex>-1&&(this._updateSelItems(this.selectedItem,!0),this._refreshHeader(),t&&this._clearSelIndex(),this._disableInput(!0))},i.prototype._delItem=function(t){var e,n,o=this._wjTpl.querySelector("."+i._clsActive),s=!1;t&&!o||(o?(n=this._getItemIndex(o))>-1&&(e=this._selItems[n],s=!0):this._selItems.length>0&&(e=this._selItems[this._selItems.length-1],s=!0),s&&(this._updateSelItems(e,!1),this._refreshHeader(),this._clearSelIndex(),this._disableInput(!1)),this._tbx.focus())},i.prototype._updateSelItems=function(t,e){if(e){if(this._selItems&&0!==this._selItems.length||(this._selItems=[]),null!=this._maxtems&&this._selItems.length>=this._maxtems)return;this._selItems.push(t)}else{var i=this._selItems.indexOf(t);this._selItems.splice(i,1)}this._hasSelectedMemeberPath()&&this._setSelItem(t,e),this.onSelectedItemsChanged()},i.prototype._createItem=function(e){var n=this,o=document.createElement("div"),s=document.createElement("span"),r=document.createElement("a");return o.appendChild(s),o.appendChild(r),o.className="wj-token",s.className="wj-token-label",s.innerHTML=e,r.className="wj-token-close",r.href="#",r.tabIndex=-1,r.text="×",o.style.cssFloat=this.rightToLeft?"right":"left",this.addEventListener(o,"click",function(e){n._helperInput.focus();var s=n._wjTpl.querySelector("."+i._clsActive);s&&t.removeClass(s,i._clsActive),t.addClass(o,i._clsActive),e.stopPropagation(),e.preventDefault()}),this.addEventListener(r,"click",function(t){if(!n.isReadOnly){var e=n._getItemIndex(o);if(e>-1){var i=n._selItems[e];n._updateSelItems(i,!1)}n._wjTpl.removeChild(o),n._adjustInputWidth(),n._disableInput(!1),n._tbx.focus(),t.stopPropagation(),t.preventDefault()}}),o},i.prototype._itemOn=function(e){var n,o,s,r=t.getActiveElement();if((this._tbx!=r||0===this._tbx.value.length)&&0!==(n=this._wjTpl.querySelectorAll(".wj-token")).length)if(o=this._wjTpl.querySelector("."+i._clsActive),s=this._getItemIndex(o),e){if(0===s)return;-1===s?(t.addClass(n[n.length-1],i._clsActive),this._helperInput.focus()):(t.removeClass(o,i._clsActive),t.addClass(n[s-1],i._clsActive),this._helperInput.focus())}else if(!e){if(-1===s)return;s!==n.length-1?(t.removeClass(o,i._clsActive),t.addClass(n[s+1],i._clsActive),this._helperInput.focus()):(t.removeClass(o,i._clsActive),this._tbx.focus())}},i.prototype._itemOff=function(){var e=this._wjTpl.querySelector("."+i._clsActive);e&&t.removeClass(e,i._clsActive)},i.prototype._initSeltems=function(){if(this.selectedMemberPath&&""!==this.selectedMemberPath){var t=this.itemsSource;if(this._selItems.splice(0,this._selItems.length),t)for(var e=0;e<t.sourceCollection.length;e++)this._getSelItem(e)&&this._selItems.push(t.sourceCollection[e])}},i.prototype._getSelItem=function(e){var i=this.itemsSource.sourceCollection[e];return!(!t.isObject(i)||!this.selectedMemberPath)&&this._selPath.getValue(i)},i.prototype._setSelItem=function(e,i){this.itemsSource;t.isObject(e)&&this._selPath.getValue(e)!=i&&this._selPath.setValue(e,i)},i.prototype._clearSelIndex=function(){this.selectedIndex=-1},i.prototype._hasSelectedMemeberPath=function(){return this.selectedMemberPath&&""!==this.selectedMemberPath},i.prototype._disableInput=function(t){null!=this._maxtems&&(this._selItems.length<this._maxtems?(this._tbx.disabled=!1,this._tbx.focus()):(this._tbx.disabled=!0,this.hostElement.focus()))},i.prototype._adjustInputWidth=function(){this._tbx.style.width="60px";var e,i=t.getElementRect(this.hostElement),n=t.getElementRect(this._tbx),o=getComputedStyle(this._tbx),s=parseInt(o.paddingLeft,10),r=parseInt(o.paddingRight,10);e=this.rightToLeft?n.left+n.width-i.left-s-r-8:i.left+i.width-n.left-s-r-8,this._tbx.style.width=e+"px"},i.prototype._getItemIndex=function(t){for(var e=this.hostElement.querySelectorAll(".wj-token"),i=0;i<e.length;i++)if(t===e[i])return i;return-1},i._clsActive="wj-token-active",i}(e.AutoComplete);e.MultiAutoComplete=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i;!function(t){t[t.None=0]="None",t[t.Click=1]="Click",t[t.Blur=2]="Blur",t[t.ClickOrBlur=3]="ClickOrBlur"}(i=e.PopupTrigger||(e.PopupTrigger={}));var n=function(n){function o(e,o){var s=n.call(this,e,null,!0)||this;s._showTrigger=i.Click,s._hideTrigger=i.Blur,s._fadeIn=!0,s._fadeOut=!0,s._removeOnHide=!0,s._visible=!1,s._ownerClickBnd=s._ownerClick.bind(s),s._ownerMousedownBnd=s._ownerMouseDown.bind(s),s.showing=new t.Event,s.shown=new t.Event,s.hiding=new t.Event,s.hidden=new t.Event;var r=s.hostElement;return t.addClass(r,"wj-control wj-content wj-popup"),r.getAttribute("tabindex")||(r.tabIndex=0),t.hidePopup(r,!1),s.addEventListener(r,"compositionstart",function(t){s._composing=!0}),s.addEventListener(r,"compositionend",function(t){s._composing=!1}),s.addEventListener(r,"keydown",function(e){if(!e.defaultPrevented){if(e.keyCode!=t.Key.Escape||s._composing||(e.preventDefault(),s.hide()),e.keyCode==t.Key.Enter){var i=s.dialogResultEnter;i&&(e.preventDefault(),s._validateAndHide(i))}e.keyCode==t.Key.Tab&&s.modal&&(e.preventDefault(),t.moveFocus(r,e.shiftKey?-1:1))}}),s.addEventListener(r,"click",function(t){if(t.target instanceof HTMLElement){var e=t.target.className.match(/\bwj-hide[\S]*\b/);e&&e.length>0&&(t.preventDefault(),t.stopPropagation(),s.hide(e[0]))}}),s.addEventListener(document,"wheel",function(t){if(s.isVisible&&s._modal){for(var e=t.target;e&&e!=document.body;e=e.parentElement)if(e.scrollHeight>e.clientHeight)return;t.preventDefault(),t.stopPropagation()}}),s.initialize(o),s}return __extends(o,n),Object.defineProperty(o.prototype,"owner",{get:function(){return this._owner},set:function(e){var i=this._owner;i&&(this.removeEventListener(i,"mousedown"),this.removeEventListener(i,"click")),(i=this._owner=null!=e?t.getElement(e):null)&&(this.addEventListener(i,"mousedown",this._ownerMousedownBnd,!0),this.addEventListener(i,"click",this._ownerClickBnd,!0))},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"content",{get:function(){return this.hostElement.firstElementChild},set:function(t){t!=this.content&&(this.hostElement.innerHTML="",t instanceof HTMLElement&&this.hostElement.appendChild(t))},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"showTrigger",{get:function(){return this._showTrigger},set:function(e){this._showTrigger=t.asEnum(e,i)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"hideTrigger",{get:function(){return this._hideTrigger},set:function(e){this._hideTrigger=t.asEnum(e,i)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"fadeIn",{get:function(){return this._fadeIn},set:function(e){this._fadeIn=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"fadeOut",{get:function(){return this._fadeOut},set:function(e){this._fadeOut=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"removeOnHide",{get:function(){return this._removeOnHide},set:function(e){this._removeOnHide=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"modal",{get:function(){return this._modal},set:function(e){this._modal=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"isDraggable",{get:function(){return this._draggable},set:function(e){this._draggable=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"dialogResult",{get:function(){return this._result},set:function(t){this._result=t},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"dialogResultEnter",{get:function(){return this._resultEnter},set:function(t){this._resultEnter=t},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"isVisible",{get:function(){var t=this.hostElement;return this._visible&&null!=t&&t.offsetHeight>0},enumerable:!0,configurable:!0}),o.prototype.show=function(e,i){var n=this;if(!this.isVisible){var o=this.hostElement;this.dialogResult=null,this._callback=null,this._hideAnim&&(clearInterval(this._hideAnim),this._hideAnim=null);var s=new t.CancelEventArgs;this.onShowing(s)&&(null!=e&&(this.modal=t.asBoolean(e)),null!=i&&(this._callback=t.asFunction(i)),t.showPopup(o,this._owner,!1,this._fadeIn,!1),this._modal&&this._showBackdrop(),this._composing=!1,this._visible=!0,this.onShown(s),this.modal&&this.addEventListener(window,"focus",function(){n.containsFocus()||t.moveFocus(o,0)}),this._makeDraggable(this._draggable),setTimeout(function(){if(!n.isTouching){var e=o.querySelector("input[autofocus]");e&&e.clientHeight>0&&!e.disabled&&e.tabIndex>-1&&!t.closest(e,"[disabled],.wj-state-disabled")?(e.focus(),e.select()):t.moveFocus(o,0)}n.containsFocus()||(o.tabIndex=0,o.focus())},200))}},o.prototype.hide=function(i){var n=this;if(this._makeDraggable(!1),this.isVisible){t.isUndefined(i)||(this.dialogResult=i);var o=new t.CancelEventArgs;if(this.onHiding(o)){for(var s=this.hostElement.querySelectorAll(".wj-control.wj-dropdown"),r=0;r<s.length;r++){var a=t.Control.getControl(s[r]);a instanceof e.DropDown&&(a.isDroppedDown=!1)}this._bkdrop&&t.hidePopup(this._bkdrop,this.removeOnHide,this.fadeOut),this._hideAnim=t.hidePopup(this.hostElement,this.removeOnHide,this.fadeOut),this._visible=!1,this.removeEventListener(window,"focus"),this.containsFocus()&&t.getActiveElement().blur(),setTimeout(function(){n._updateState(),n.onHidden(o),n._callback&&n._callback(n)})}}},o.prototype.onShowing=function(t){return this.showing.raise(this,t),!t.cancel},o.prototype.onShown=function(t){this.shown.raise(this,t)},o.prototype.onHiding=function(t){return this.hiding.raise(this,t),!t.cancel},o.prototype.onHidden=function(t){this.hidden.raise(this,t)},o.prototype.dispose=function(){this.owner=null,n.prototype.dispose.call(this)},o.prototype.onLostFocus=function(t){this.isVisible&&this._hideTrigger&i.Blur&&(this.containsFocus()||this.hide()),n.prototype.onLostFocus.call(this,t)},o.prototype.refresh=function(e){if(void 0===e&&(e=!0),n.prototype.refresh.call(this,e),this.isVisible&&!this._refreshing){this._refreshing=!0;var i=t.getActiveElement(),o=this._owner?this._owner.getBoundingClientRect():null;t.showPopup(this.hostElement,o),this._modal&&i instanceof HTMLElement&&i!=t.getActiveElement()&&i.focus(),this._refreshing=!1}},o.prototype._makeDraggable=function(e){var i,n,o=this,s=this.hostElement,r=s?s.querySelector(".wj-dialog-header"):null,a=document,l="mouseup",h="touchend",c=function(e){s&&t.contains(r,e.target)&&(i=new t.Point(s.offsetLeft,s.offsetTop),n=t.mouseToPage(e),["mousemove",l,"touchmove",h].forEach(function(t){o.removeEventListener(a,t)}),["mousemove","touchmove"].forEach(function(t){o.addEventListener(a,t,u)}),[l,h].forEach(function(t){o.addEventListener(a,t,p)}))},u=function(e){var r=t.mouseToPage(e);t.setCss(s,{left:Math.max(i.x+(r.x-n.x),50-s.offsetWidth),top:Math.max(i.y+(r.y-n.y),0)}),o._dragged=!0},p=function(t){["mousemove",l,"touchmove",h].forEach(function(t){o.removeEventListener(a,t)})};["mousedown","touchstart"].forEach(function(t){o.removeEventListener(a,t)}),this._dragged=!1,r&&(t.setCss(r,{touchAction:e?"none":""}),e&&["mousedown","touchstart"].forEach(function(t){o.addEventListener(a,t,c)}))},o.prototype._handleResize=function(){this.isVisible&&!this._dragged&&this.refresh()},o.prototype._ownerClick=function(t){this.isVisible?this._hideTrigger&i.Click&&this.hide():this._showTrigger&i.Click&&(this._wasVisible||this.show())},o.prototype._ownerMouseDown=function(t){this._wasVisible=this.isVisible},o.prototype._showBackdrop=function(){var e=this;this._bkdrop||(this._bkdrop=document.createElement("div"),this._bkdrop.tabIndex=-1,t.addClass(this._bkdrop,"wj-popup-backdrop"),this.addEventListener(this._bkdrop,"mousedown",function(t){t.preventDefault(),t.stopPropagation(),e.hostElement.focus(),e.hideTrigger&i.Blur&&e.hide()})),this._bkdrop.style.display="";var n=this.hostElement;n.parentElement.insertBefore(this._bkdrop,n)},o.prototype._validateAndHide=function(t){var e=this.hostElement.querySelector(":invalid");e?e.focus():this.hide(t)},o}(t.Control);e.Popup=n}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(i){function n(n,o){var s=i.call(this,n)||this;if(s._format="d",s.valueChanged=new t.Event,t.addClass(s.hostElement,"wj-inputdate"),s._msk=new t._MaskProvider(s._tbx),t.isIE9()||(s.inputType="tel"),s._tbx.type.match(/date/i)&&(s.inputType=""),s.addEventListener(s.hostElement,"wheel",function(i){if(!i.defaultPrevented&&!s.isDroppedDown&&s.containsFocus()&&null!=s.value&&s._canChangeValue()){var n=t.clamp(-i.deltaY,-1,1);s.value=s.selectionMode==e.DateSelectionMode.Month?t.DateTime.addMonths(s.value,n):t.DateTime.addDays(s.value,n),s.selectAll(),i.preventDefault()}}),s.value=t.DateTime.newDate(),"INPUT"==s._orgTag){var r=s._tbx.getAttribute("value");r&&(s.value=t.Globalize.parseDate(r,"yyyy-MM-dd"))}return s.isRequired=!0,s.initialize(o),s}return __extends(n,i),Object.defineProperty(n.prototype,"value",{get:function(){return this._value},set:function(e){if(t.DateTime.equals(this._value,e))this._tbx.value=t.Globalize.format(e,this.format);else{var i=!this.isRequired||null==e&&null==this.value;e=t.asDate(e,i),e=this._clamp(e),this._isValidDate(e)?(this._tbx.value=e?t.Globalize.format(e,this.format):"",e==this._value||t.DateTime.equals(this._value,e)||(this._value=e,this.onValueChanged())):this._tbx.value=e?t.Globalize.format(this.value,this.format):"",this.text!=this._oldText&&(this._oldText=this.text,this.onTextChanged())}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"text",{get:function(){return this._tbx.value},set:function(t){t!=this.text&&(this._setText(t,!0),this._commitText())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectionMode",{get:function(){return this.calendar.selectionMode},set:function(t){this.calendar.selectionMode=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"min",{get:function(){return this._calendar.min},set:function(e){this._calendar.min=t.asDate(e,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"max",{get:function(){return this._calendar.max},set:function(e){this._calendar.max=t.asDate(e,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"format",{get:function(){return this._format},set:function(e){e!=this.format&&(this._format=t.asString(e),this._tbx.value=t.Globalize.format(this.value,this.format))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"mask",{get:function(){return this._msk.mask},set:function(e){this._msk.mask=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"calendar",{get:function(){return this._calendar},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"inputType",{get:function(){return this._tbx.type},set:function(e){this._tbx.type=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemValidator",{get:function(){return this._calendar.itemValidator},set:function(e){e!=this.itemValidator&&(this._calendar.itemValidator=t.asFunction(e),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemFormatter",{get:function(){return this.calendar.itemFormatter},set:function(e){e!=this.itemFormatter&&(this.calendar.itemFormatter=t.asFunction(e))},enumerable:!0,configurable:!0}),n.prototype.onValueChanged=function(t){this.valueChanged.raise(this,t)},n.prototype.refresh=function(e){void 0===e&&(e=!0),i.prototype.refresh.call(this,e),this.isDroppedDown=!1,this._msk&&this._msk.refresh(),this._calendar&&this._calendar.refresh(),this._tbx.value=t.Globalize.format(this.value,this.format)},n.prototype.onIsDroppedDownChanged=function(t){i.prototype.onIsDroppedDownChanged.call(this,t),this.isDroppedDown&&(this._calChanged=!1,this.dropDown.focus())},n.prototype._createDropDown=function(){var i=this;this._calendar=new e.Calendar(this._dropDown),this._calendar.valueChanged.addHandler(function(){i.value=t.DateTime.fromDateTime(i._calendar.value,i.value),i._calChanged=!0}),this.addEventListener(this._dropDown,"mouseup",function(e){i._calChanged&&!t.closest(e.target,".wj-calendar-header")?i.isDroppedDown=!1:"btn-today"==e.target.getAttribute("wj-part")&&(i.isDroppedDown=!1)})},n.prototype._updateDropDown=function(){this._commitText();var t=this._calendar;t.value=this.value,t.min=this.min,t.max=this.max,this.selectionMode!=e.DateSelectionMode.Month&&(t.monthView=!0);var n=getComputedStyle(this.hostElement);this._dropDown.style.minWidth=18*parseFloat(n.fontSize)+"px",this._calendar.refresh(),i.prototype._updateDropDown.call(this)},n.prototype._keydown=function(n){if(!(n.defaultPrevented||n.altKey||n.ctrlKey||n.metaKey))switch(n.keyCode){case t.Key.Enter:this._commitText(),this.selectAll();break;case t.Key.Escape:this.text=t.Globalize.format(this.value,this.format),this.selectAll();break;case t.Key.Up:case t.Key.Down:if(!this.isDroppedDown&&this.value&&this._canChangeValue()){var o=n.keyCode==t.Key.Up?1:-1,s=this.selectionMode==e.DateSelectionMode.Month?t.DateTime.addMonths(this.value,o):t.DateTime.addDays(this.value,o);this.value=t.DateTime.fromDateTime(s,this.value),this.selectAll(),n.preventDefault()}}i.prototype._keydown.call(this,n)},n.prototype._canChangeValue=function(){return!this.isReadOnly&&this.selectionMode!=e.DateSelectionMode.None},n.prototype._clamp=function(t){return this.calendar._clamp(t)},n.prototype._commitText=function(){var e=this._tbx.value;if(e||this.isRequired){var i=t.Globalize.parseDate(e,this.format);i?this.value=t.DateTime.fromDateTime(i,this.value):this._tbx.value=t.Globalize.format(this.value,this.format)}else this.value=null},n.prototype._isValidDate=function(t){if(t){if(this._clamp(t)!=t)return!1;if(this.itemValidator&&!this.itemValidator(t))return!1}return!0},n}(e.DropDown);e.InputDate=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i)||this;if(o._format="t",o.valueChanged=new t.Event,t.addClass(o.hostElement,"wj-inputtime"),o._value=t.DateTime.newDate(),o._msk=new t._MaskProvider(o._tbx),t.isIE9()||(o._tbx.type="tel"),"INPUT"==o._orgTag){var s=o._tbx.getAttribute("value");s&&(o.value=t.Globalize.parseDate(s,"HH:mm:ss"))}return o.step=15,o.autoExpandSelection=!0,o.initialize(n),o}return __extends(i,e),Object.defineProperty(i.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"inputType",{get:function(){return this._tbx.type},set:function(e){this._tbx.type=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"value",{get:function(){return this._value},set:function(e){(e=t.asDate(e,!this.isRequired))&&(null!=this._min&&this._getTime(e)<this._getTime(this._min)&&(e=t.DateTime.fromDateTime(e,this._min)),null!=this._max&&this._getTime(e)>this._getTime(this._max)&&(e=t.DateTime.fromDateTime(e,this._max))),this._setText(e?t.Globalize.format(e,this.format):"",!0),this.selectedItem&&this.selectedItem.value&&(e=t.DateTime.fromDateTime(e,this.selectedItem.value)),e==this._value||t.DateTime.equals(e,this._value)||(this._value=e,this.onValueChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"text",{get:function(){return this._tbx.value},set:function(t){t!=this.text&&(this._setText(t,!0),this._commitText())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"min",{get:function(){return this._min},set:function(e){this._min=t.asDate(e,!0),this.isDroppedDown=!1,this._updateItems()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"max",{get:function(){return this._max},set:function(e){this._max=t.asDate(e,!0),this.isDroppedDown=!1,this._updateItems()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"step",{get:function(){return this._step},set:function(e){this._step=t.asNumber(e,!0),this.isDroppedDown=!1,this._updateItems()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"format",{get:function(){return this._format},set:function(e){e!=this.format&&(this._format=t.asString(e),this._tbx.value=t.Globalize.format(this.value,this.format),t.hasItems(this.collectionView)&&this._updateItems())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"mask",{get:function(){return this._msk.mask},set:function(e){this._msk.mask=t.asString(e)},enumerable:!0,configurable:!0}),i.prototype.onValueChanged=function(t){this.valueChanged.raise(this,t)},i.prototype.onItemsSourceChanged=function(t){e.prototype.onItemsSourceChanged.call(this,t),this._hasCustomItems=null!=this.itemsSource},i.prototype._updateInputSelection=function(i){if(this._delKey)e.prototype._updateInputSelection.call(this,i);else{for(var n=this._tbx.value;i<n.length&&!n[i].match(/[a-z0-9]/i);)i++;t.setSelectionRange(this._tbx,i,this._tbx.value.length)}},i.prototype.refresh=function(i){void 0===i&&(i=!0),e.prototype.refresh.call(this,i),this.isDroppedDown=!1,this._msk.refresh(),this._tbx.value=t.Globalize.format(this.value,this.format),this._updateItems()},i.prototype.onSelectedIndexChanged=function(i){if(this.selectedIndex>-1&&!this._settingText){var n=this.value?this.value:t.DateTime.newDate(),o=null!=this.selectedItem.value?this.selectedItem.value:t.Globalize.parseDate(this.text,this.format);this.value=t.DateTime.fromDateTime(n,o)}e.prototype.onSelectedIndexChanged.call(this,i)},i.prototype._updateItems=function(){if(!this._hasCustomItems){var e=[],i=t.DateTime.newDate(0,0,0,0,0),n=t.DateTime.newDate(0,0,0,23,59,59);if(this.min&&i.setHours(this.min.getHours(),this.min.getMinutes(),this.min.getSeconds()),this.max&&n.setHours(this.max.getHours(),this.max.getMinutes(),this.max.getSeconds()),t.isNumber(this.step)&&this.step>0)for(var o=i;o<=n;o=t.DateTime.addMinutes(o,this.step))e.push({value:o,text:t.Globalize.format(o,this.format)});var s=this.value;this._settingText=!0,this.displayMemberPath="text",this.selectedValuePath="text",this.itemsSource=e,this._hasCustomItems=!1,this._settingText=!1,this.value=s}},i.prototype._getTime=function(t){return 3600*t.getHours()+60*t.getMinutes()+t.getSeconds()},i.prototype._keydown=function(i){if(e.prototype._keydown.call(this,i),!i.defaultPrevented)switch(i.keyCode){case t.Key.Enter:this.isDroppedDown||(this._commitText(),this.selectAll());break;case t.Key.Escape:this.text=t.Globalize.format(this.value,this.format),this.selectAll()}},i.prototype._commitText=function(){if(this.text||this.isRequired){var e=this.value?t.Globalize.format(this.value,this.format):null;if(this.text!=e){var i=this.selectedItem&&this.selectedItem.value?this.selectedItem.value:t.Globalize.parseDate(this.text,this.format);i?this.value=t.DateTime.fromDateTime(this.value,i):this._tbx.value=e}}else this.value=null},i}(e.ComboBox);e.InputTime=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(i){function n(n,o){var s=i.call(this,n)||this;t.addClass(s.hostElement,"wj-inputdatetime"),s._btnTm=s.hostElement.querySelector('[wj-part="btn-tm"]'),s._format="g",s._inputTime=new e.InputTime(document.createElement("div")),s._inputTime.valueChanged.addHandler(function(){s.value=t.DateTime.fromDateTime(s.value,s._inputTime.value)});var r=s._inputTime.dropDown,a=s._keydown.bind(s);return s.addEventListener(r,"keydown",a,!0),s.addEventListener(r,"blur",function(){s._updateFocusState()},!0),s.addEventListener(s._btn,"mousedown",function(t){s._setDropdown(s.calendar.hostElement)}),s.addEventListener(s._btnTm,"mousedown",function(t){s._inputTime.dropDownCssClass=s.dropDownCssClass,s._setDropdown(r),setTimeout(function(){s._btnclick(t)})}),s.initialize(o),s}return __extends(n,i),Object.defineProperty(n.prototype,"timeMin",{get:function(){return this._inputTime.min},set:function(t){this._inputTime.min=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"timeMax",{get:function(){return this._inputTime.max},set:function(t){this._inputTime.max=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"timeFormat",{get:function(){return this._inputTime.format},set:function(t){this._inputTime.format=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"timeStep",{get:function(){return this._inputTime.step},set:function(t){this._inputTime.step=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"inputTime",{get:function(){return this._inputTime},enumerable:!0,configurable:!0}),n.prototype.dispose=function(){this._setDropdown(this.calendar.hostElement),i.prototype.dispose.call(this),this._inputTime.dispose()},n.prototype.refresh=function(t){void 0===t&&(t=!0),this._setDropdown(this.calendar.hostElement),this._inputTime.refresh(),i.prototype.refresh.call(this,t)},n.prototype._updateBtn=function(){i.prototype._updateBtn.call(this),this._btnTm&&(this._btnTm.tabIndex=this._btn.tabIndex,this._btnTm.parentElement.style.display=this._btn.style.display)},n.prototype._clamp=function(t){return t&&(this.min&&t<this.min&&(t=this.min),this.max&&t>this.max&&(t=this.max)),t},n.prototype._commitText=function(){var e=this._tbx.value;if(e||this.isRequired){var i=t.Globalize.parseDate(e,this.format);i?this.value=i:this._tbx.value=t.Globalize.format(this.value,this.format)}else this.value=null},n.prototype._setDropdown=function(t){this._dropDown!=t&&(this.isDroppedDown&&(this.isDroppedDown=!1),this._dropDown=t)},n.prototype._updateDropDown=function(){var t=this._inputTime;this._dropDown==t.dropDown?(this._commitText(),i.prototype._updateDropDown.call(this),t.isRequired=this.isRequired,t.value=this.value,this.isDroppedDown&&t.listBox.showSelection()):i.prototype._updateDropDown.call(this)},n.controlTemplate='<div style="position:relative" class="wj-template"><div class="wj-input"><div class="wj-input-group wj-input-btn-visible"><input wj-part="input" type="text" class="wj-form-control" /><span class="wj-input-group-btn" tabindex="-1"><button wj-part="btn" class="wj-btn wj-btn-default" type="button" tabindex="-1"><span class="wj-glyph-calendar"></span></button><button wj-part="btn-tm" class="wj-btn wj-btn-default" type="button" tabindex="-1"><span class="wj-glyph-clock"></span></button></span></div></div><div wj-part="dropdown" class="wj-content wj-dropdown-panel" style="display:none;position:absolute;z-index:100;width:auto"></div></div>',n}(e.InputDate);e.InputDateTime=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i)||this;o._showBtn=!0,o._readOnly=!1,o.textChanged=new t.Event,o.valueChanged=new t.Event;var s=o.hostElement;t.setAttribute(s,"role","spinbutton",!0);var r=o.getTemplate();o.applyTemplate("wj-control wj-content wj-inputnumber",r,{_tbx:"input",_btnUp:"btn-inc",_btnDn:"btn-dec"},"input"),o._tbx.type.match(/number/i)&&(o.inputType="");var a=o._tbx;a.autocomplete="off",a.spellcheck=!1,o._updateSymbols(),o.addEventListener(o._tbx,"compositionstart",function(){o._composing=!0}),o.addEventListener(o._tbx,"compositionend",function(){o._composing=!1,setTimeout(function(){var t=o.text;o._oldText.indexOf(o._chrPct)>-1&&t.indexOf(o._chrPct)<0&&(t+=o._chrPct),o._setText(t)})}),o.addEventListener(a,"keypress",o._keypress.bind(o)),o.addEventListener(a,"keydown",o._keydown.bind(o)),o.addEventListener(a,"input",o._input.bind(o));var l=o._clickSpinner.bind(o);return o.addEventListener(o._btnUp,"click",l),o.addEventListener(o._btnDn,"click",l),o._rptUp=new t._ClickRepeater(o._btnUp.querySelector("button")),o._rptDn=new t._ClickRepeater(o._btnDn.querySelector("button")),o.addEventListener(s,"wheel",function(e){if(!e.defaultPrevented&&!o.isReadOnly&&o.containsFocus()){var i=t.clamp(-e.deltaY,-1,1);o._increment((o.step||1)*i),setTimeout(function(){return o.selectAll()}),e.preventDefault()}}),o.value=0,o.isRequired=!0,o.initialize(n),o}return __extends(i,e),Object.defineProperty(i.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"inputType",{get:function(){return this._tbx.type},set:function(e){this._tbx.type=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"value",{get:function(){return this._value},set:function(e){if(e!=this._value)if(null==(e=t.asNumber(e,!this.isRequired||null==e&&null==this._value)))this._setText("");else if(!isNaN(e)){var i=t.Globalize.format(e,this.format);this._setText(i)}},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isRequired",{get:function(){return this._tbx.required},set:function(e){this._tbx.required=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isReadOnly",{get:function(){return this._readOnly},set:function(e){this._readOnly=t.asBoolean(e),this.inputElement.readOnly=this._readOnly,t.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"min",{get:function(){return this._min},set:function(e){this._min=t.asNumber(e,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"max",{get:function(){return this._max},set:function(e){this._max=t.asNumber(e,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"step",{get:function(){return this._step},set:function(e){this._step=t.asNumber(e,!0),this._updateBtn()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"format",{get:function(){return this._format},set:function(e){e!=this.format&&(this._format=t.asString(e),this.refresh())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"text",{get:function(){return this._tbx.value},set:function(t){t!=this.text&&(this._oldText=null,this._setText(t))},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"placeholder",{get:function(){return this._tbx.placeholder},set:function(t){this._tbx.placeholder=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"showSpinner",{get:function(){return this._showBtn},set:function(e){this._showBtn=t.asBoolean(e),this._updateBtn()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"repeatButtons",{get:function(){return!this._rptUp.disabled},set:function(e){this._rptUp.disabled=this._rptDn.disabled=!t.asBoolean(e)},enumerable:!0,configurable:!0}),i.prototype.selectAll=function(){var e=this._tbx;t.setSelectionRange(e,0,e.value.length)},i.prototype.onTextChanged=function(t){this.textChanged.raise(this,t),this._updateState()},i.prototype.onValueChanged=function(t){this._updateAria(),this.valueChanged.raise(this,t)},i.prototype.dispose=function(){this._rptUp.element=null,this._rptDn.element=null,e.prototype.dispose.call(this)},i.prototype.onGotFocus=function(t){this.isTouching||(this._tbx.focus(),this.selectAll()),e.prototype.onGotFocus.call(this,t)},i.prototype.onLostFocus=function(i){this._composing&&(this._composing=!1,this._setText(this.text));var n=this._clamp(this.value),o=t.Globalize.format(n,this.format);this._setText(o),e.prototype.onLostFocus.call(this,i)},i.prototype.refresh=function(i){void 0===i&&(i=!0),e.prototype.refresh.call(this,i),this._updateSymbols();var n=t.Globalize.format(this.value,this.format);this._setText(n)},i.prototype._updateSymbols=function(){var e=t.culture.Globalize.numberFormat,i=this.format?this.format.match(/([a-z])(\d*)(,*)(.*)/i):null;this._chrDec=e["."]||".",this._chrNeg=e["-"]||"-",this._chrPls=e["+"]||"+",this._chrPct=e["%"]||"%",this._chrCur=i&&i[4]?i[4]:e.currency.symbol||"$",this._fmtSpc=i&&i[1]?i[1].toLowerCase():"n",this._fmtPrc=i&&i[2]?parseInt(i[2]):null,this._rxSym=new RegExp("^[%+\\-() \\"+this._chrDec+"\\"+this._chrCur+"\\"+this._chrNeg+"\\"+this._chrPls+"\\"+this._chrPct+"]*$"),this._rxNeg=new RegExp("(\\-|\\(|\\"+this._chrNeg+")")},i.prototype._clamp=function(e){return t.clamp(e,this.min,this.max)},i.prototype._isNumeric=function(t,e){var i=t==this._chrDec||t>="0"&&t<="9",n="x"==this._fmtSpc;return!i&&n&&(i=t>="a"&&t<="f"||t>="A"&&t<="F"),i||e||n||(i=t==this._chrPls||t==this._chrNeg||"("==t||")"==t),i},i.prototype._getInputRange=function(t){for(var e=[0,0],i=this.text,n=!1,o=0;o<i.length;o++)this._isNumeric(i[o],t)&&(n||(e[0]=o,n=!0),e[1]=o+1);return e},i.prototype._flipSign=function(){var t=this._getSelStartDigits();this.value*=-1,this._setSelStartDigits(t)},i.prototype._getSelStartDigits=function(){for(var t=0,e=this._tbx.selectionStart,i=this._tbx.value,n=0;n<i.length&&n<e;n++)this._isNumeric(i[n],!0)&&t++;return t},i.prototype._setSelStartDigits=function(e){for(var i=this._tbx.value,n=0;n<i.length&&e>=0;n++)if(this._isNumeric(i[n],!0)){if(!e){t.setSelectionRange(this._tbx,n);break}e--}else if(!e){t.setSelectionRange(this._tbx,n);break}},i.prototype._increment=function(e){if(e){var i=this._clamp(t.isNumber(this.value)?this.value+e:0),n=t.Globalize.format(i,this.format,!1,!1);this._setText(n)}},i.prototype._updateBtn=function(){var e=this.showSpinner&&!!this.step,i=e;t.setCss([this._btnUp,this._btnDn],{display:e?"":"none"}),t.toggleClass(this.hostElement,"wj-input-show-spinner",e),t.enable(this._btnUp,i),t.enable(this._btnDn,i),this._updateAria()},i.prototype._setText=function(e){if(!this._composing){var i=this._tbx,n=this._rxNeg.test(e),o=this._delKey;if(e&&this._rxSym.test(e)&&(e=this.isRequired||!o?"0":""),this._delKey=!1,o&&0==this.value&&!this.isRequired&&(e=""),!e){if(!this.isRequired)return i.value="",null!=this._value&&(this._value=null,this.onValueChanged()),this._oldText&&(this._oldText=e,this.onTextChanged()),void this._updateBtn();e="0"}var s=this._format||(e.indexOf(this._chrDec)>-1?"n2":"n0"),r=t.Globalize.parseFloat(e,s);if(isNaN(r))i.value=this._oldText;else{var a=t.Globalize.format(r,s,!1);n&&r>=0&&!o&&(a=this._chrNeg+a),null!=this._fmtPrc&&"g"!=this._fmtSpc||!o&&i.value.match(/\.0?$/)&&(a=e+("0"==e?this._chrDec:"")),i.value!=a&&(i.value=a,r=t.Globalize.parseFloat(a,this.format)),r!=this._value&&(this._value=r,this.onValueChanged()),this.text!=this._oldText&&(this._oldText=this.text,this.onTextChanged()),this._updateBtn()}}},i.prototype._keypress=function(e){if(!(e.defaultPrevented||this._composing||this.isReadOnly)&&e.charCode&&!e.ctrlKey&&!e.metaKey){var i=this._tbx,n=String.fromCharCode(e.charCode);if(this._isNumeric(n,!1)){var o=this._getInputRange(!0),s=i.selectionStart,r=i.selectionEnd;if(s<o[0]&&r<i.value.length&&(r=Math.max(r,o[0]),t.setSelectionRange(i,o[0],r)),s>=o[1]){var a=null!=this._fmtPrc?this._fmtPrc:2,l=i.value.indexOf(this._chrDec);l>-1&&s-l>a&&e.preventDefault()}}else e.preventDefault();switch(n){case"-":case this._chrNeg:this.min>=0?this.value<0&&this._flipSign():this.value&&i.selectionStart==i.selectionEnd?this._flipSign():this._clamp(-1)<0&&(i.value=this._chrNeg,t.setSelectionRange(i,1)),e.preventDefault();break;case"+":case this._chrPls:this.value<0&&this._flipSign(),e.preventDefault();break;case this._chrDec:if(0==this._fmtPrc)e.preventDefault();else{var h=i.value.indexOf(n);h>-1&&(i.selectionStart<=h&&h++,t.setSelectionRange(i,h),e.preventDefault())}}}},i.prototype._keydown=function(e){var i=this;if(this._delKey=!1,!e.defaultPrevented&&!this._composing){var n=this._tbx,o=n.value,s=n.selectionStart,r=n.selectionEnd;switch(e.keyCode){case 65:e.ctrlKey&&(setTimeout(function(){i.selectAll()}),e.preventDefault());break;case t.Key.Up:case t.Key.Down:this.step&&!this.isReadOnly&&(this._increment(this.step*(e.keyCode==t.Key.Up?1:-1)),setTimeout(function(){i.selectAll()}),e.preventDefault());break;case t.Key.Back:if(this._delKey=!0,r-s<2&&!this.isReadOnly){var a=o[r-1];a!=this._chrDec&&a!=this._chrPct&&")"!=a||(setTimeout(function(){r=a==i._chrPct?i._getInputRange(!0)[1]:r-1,t.setSelectionRange(n,r)}),e.preventDefault())}break;case t.Key.Delete:if(this._delKey=!0,r-s<2&&!this.isReadOnly)if("0"==o&&1==s)t.setSelectionRange(n,0);else{var l=o[s];l!=this._chrDec&&l!=this._chrPct||(setTimeout(function(){t.setSelectionRange(n,s+1)}),e.preventDefault())}}}},i.prototype._input=function(e){var i=this;this._composing||setTimeout(function(){var e=i._tbx,n=e.value,o=n.indexOf(i._chrDec),s=e.selectionStart,r=i._getSelStartDigits();if("p"==i._fmtSpc&&n.length&&n.indexOf(i._chrPct)<0&&(n+=i._chrPct),i._setText(n),i.containsFocus()){var a=e.value,l=a.indexOf(i._chrDec),h=i._getInputRange(!0);if(n==i._chrNeg+i._chrDec&&l>-1)return void t.setSelectionRange(e,l+1);if(n[0]==i._chrNeg&&a[0]!=i._chrNeg)return void(1==a.length?t.setSelectionRange(e,1):i._setSelStartDigits(r));n?n==i._chrDec&&l>-1?s=l+1:s<=o&&l>-1||o<0&&l<0?s+=a.length-n.length:o<0&&l>-1&&(s=l):s=l>-1?l:h[1],s=t.clamp(s,h[0],h[1]),t.setSelectionRange(e,s)}})},i.prototype._clickSpinner=function(e){var i=this;e.defaultPrevented||this.isReadOnly||!this.step||(this._increment(this.step*(t.contains(this._btnUp,e.target)?1:-1)),this.isTouching||setTimeout(function(){return i.selectAll()}))},i.prototype._updateAria=function(){var e=this.hostElement;e&&(t.setAttribute(e,"aria-valuemin",this.min),t.setAttribute(e,"aria-valuemax",this.max),t.setAttribute(e,"aria-valuenow",this.value))},i.controlTemplate='<div class="wj-input"><div class="wj-input-group"><span wj-part="btn-dec" class="wj-input-group-btn" tabindex="-1"><button class="wj-btn wj-btn-default" type="button" tabindex="-1">-</button></span><input type="tel" wj-part="input" class="wj-form-control wj-numeric"/><span wj-part="btn-inc" class="wj-input-group-btn" tabindex="-1"><button class="wj-btn wj-btn-default" type="button" tabindex="-1">+</button></span></div></div>',i}(t.Control);e.InputNumber=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(e){function i(i,n){var o=e.call(this,i)||this;o.valueChanged=new t.Event;var s=o.getTemplate();if(o.applyTemplate("wj-control wj-content wj-inputmask",s,{_tbx:"input"},"input"),"INPUT"==o._orgTag){var r=o._tbx.getAttribute("value");r&&(o.value=r)}return o._msk=new t._MaskProvider(o._tbx),o.isRequired=!0,o.initialize(n),o.addEventListener(o._tbx,"input",function(){setTimeout(function(){o.onValueChanged()})}),o}return __extends(i,e),Object.defineProperty(i.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"value",{get:function(){return this._tbx.value},set:function(e){if(e!=this.value){this._tbx.value=t.asString(e);var i=t.getActiveElement();this._tbx.selectionStart=this._tbx.value.length,i&&i!=t.getActiveElement()&&i.focus(),e=this._msk._applyMask(),this._tbx.value=e,this.onValueChanged()}},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"rawValue",{get:function(){return this._msk.getRawValue()},set:function(e){e!=this.rawValue&&(this.value=t.asString(e))},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"mask",{get:function(){return this._msk.mask},set:function(e){var i=this.value;this._msk.mask=t.asString(e),this.value!=i&&this.onValueChanged()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"promptChar",{get:function(){return this._msk.promptChar},set:function(t){var e=this.value;this._msk.promptChar=t,this.value!=e&&this.onValueChanged()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"placeholder",{get:function(){return this._tbx.placeholder},set:function(t){this._tbx.placeholder=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"maskFull",{get:function(){return this._msk.maskFull},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isRequired",{get:function(){return this._tbx.required},set:function(e){this._tbx.required=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isReadOnly",{get:function(){return this._tbx.readOnly},set:function(e){this._tbx.readOnly=t.asBoolean(e),t.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0}),i.prototype.selectAll=function(){var e=this._msk.getMaskRange();t.setSelectionRange(this._tbx,e[0],e[1]+1)},i.prototype.onValueChanged=function(t){this.value!=this._oldValue&&(this._oldValue=this.value,this.valueChanged.raise(this,t)),this._updateState()},i.prototype._updateState=function(){e.prototype._updateState.call(this);var i=!this._pristine&&this._tbx.value&&!this.maskFull;t.toggleClass(this.hostElement,"wj-state-invalid",i)},i.prototype.dispose=function(){this._msk.input=null,e.prototype.dispose.call(this)},i.prototype.refresh=function(t){void 0===t&&(t=!0),e.prototype.refresh.call(this,t),this._msk.refresh()},i.prototype.onGotFocus=function(t){e.prototype.onGotFocus.call(this,t),this.selectAll()},i.controlTemplate='<div class="wj-input"><div class="wj-input-group"><input wj-part="input" class="wj-form-control"/></div></div>',i}(t.Control);e.InputMask=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){"use strict";var i=function(i){function n(e,n){var o=i.call(this,e)||this;o.valueChanged=new t.Event,t.addClass(o.hostElement,"wj-inputcolor"),o._tbx.style.paddingLeft="24px";return o._ePreview=t.createElement('<div class="wj-inputcolorbox" style="position:absolute;left:6px;top:6px;width:12px;bottom:6px;border:1px solid black"></div>',o.hostElement.firstElementChild),"INPUT"==o._orgTag&&(o._tbx.type="",o._commitText()),o.value="#ffffff",o.isRequired=!0,o.initialize(n),o.addEventListener(o._colorPicker.hostElement,"click",function(e){var i=e.target;i&&"DIV"==i.tagName&&(t.closest(i,'[wj-part="div-pal"]')||t.closest(i,'[wj-part="div-pv"]'))&&i.style.backgroundColor&&(o.isDroppedDown=!1)}),o}return __extends(n,i),Object.defineProperty(n.prototype,"value",{get:function(){return this._value},set:function(e){e!=this.value&&(!e&&this.isRequired||(this.text=t.asString(e)))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"text",{get:function(){return this._tbx.value},set:function(e){e!=this.text&&(this._setText(t.asString(e),!0),this._commitText())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showAlphaChannel",{get:function(){return this._colorPicker.showAlphaChannel},set:function(t){this._colorPicker.showAlphaChannel=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"palette",{get:function(){return this._colorPicker.palette},set:function(t){this._colorPicker.palette=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"colorPicker",{get:function(){return this._colorPicker},enumerable:!0,configurable:!0}),n.prototype.onValueChanged=function(t){this.valueChanged.raise(this,t)},n.prototype._createDropDown=function(){var i=this;this._colorPicker=new e.ColorPicker(this._dropDown),t.setCss(this._dropDown,{minWidth:420,minHeight:200}),this._colorPicker.valueChanged.addHandler(function(){i.value=i._colorPicker.value})},n.prototype._keydown=function(e){if(!e.defaultPrevented)switch(e.keyCode){case t.Key.Enter:this._commitText(),this.selectAll();break;case t.Key.Escape:this.text=this.value,this.selectAll()}i.prototype._keydown.call(this,e)},n.prototype._commitText=function(){if(this.value!=this.text){if(!this.isRequired&&!this.text)return this._value=this.text,void(this._ePreview.style.backgroundColor="");t.Color.fromString(this.text)?(this._colorPicker.value=this.text,this._value=this._colorPicker.value,this._ePreview.style.backgroundColor=this.value,this.onValueChanged()):this.text=this._value?this._value:""}},n}(e.DropDown);e.InputColor=i}(t.input||(t.input={}))}(wijmo||(wijmo={}));
/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])};return function(t,i){function o(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(o.prototype=i.prototype,new o)}}();wijmo.culture.FlexGrid=window.wijmo.culture.FlexGrid||{groupHeaderFormat:"{name}: <b>{value}</b> ({count:n0} items)"};var wijmo;!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None",e[e.Column=1]="Column",e[e.Row=2]="Row",e[e.All=3]="All"}(i=t.HeadersVisibility||(t.HeadersVisibility={}));var o=function(o){function n(n,r){var s=o.call(this,n,null,!0)||this;s._szClient=new e.Size(0,0),s._ptScrl=new e.Point(0,0),s._cellPadding=3,s._clipToScreen=!1,s._autoGenCols=!0,s._autoClipboard=!0,s._autoScroll=!0,s._readOnly=!1,s._indent=14,s._autoSizeMode=t.AutoSizeMode.Both,s._hdrVis=i.All,s._alSorting=!0,s._alAddNew=!1,s._alDelete=!1,s._alResizing=t.AllowResizing.Columns,s._alDragging=t.AllowDragging.Columns,s._alMerging=t.AllowMerging.None,s._ssHdr=i.None,s._shSort=!0,s._shGroups=!0,s._shAlt=!0,s._shErr=!0,s._shDropDown=!0,s._valEdt=!0,s._deferResizing=!1,s._pSel=!0,s._pOutline=!0,s._vt=0,s.itemsSourceChanging=new e.Event,s.itemsSourceChanged=new e.Event,s.scrollPositionChanged=new e.Event,s.selectionChanging=new e.Event,s.selectionChanged=new e.Event,s.loadingRows=new e.Event,s.loadedRows=new e.Event,s.updatingLayout=new e.Event,s.updatedLayout=new e.Event,s.resizingColumn=new e.Event,s.resizedColumn=new e.Event,s.autoSizingColumn=new e.Event,s.autoSizedColumn=new e.Event,s.draggingColumn=new e.Event,s.draggingColumnOver=new e.Event,s.draggedColumn=new e.Event,s.resizingRow=new e.Event,s.resizedRow=new e.Event,s.autoSizingRow=new e.Event,s.autoSizedRow=new e.Event,s.draggingRow=new e.Event,s.draggingRowOver=new e.Event,s.draggedRow=new e.Event,s.groupCollapsedChanging=new e.Event,s.groupCollapsedChanged=new e.Event,s.sortingColumn=new e.Event,s.sortedColumn=new e.Event,s.beginningEdit=new e.Event,s.prepareCellForEdit=new e.Event,s.cellEditEnding=new e.Event,s.cellEditEnded=new e.Event,s.rowEditStarting=new e.Event,s.rowEditStarted=new e.Event,s.rowEditEnding=new e.Event,s.rowEditEnded=new e.Event,s.rowAdded=new e.Event,s.deletingRow=new e.Event,s.deletedRow=new e.Event,s.copying=new e.Event,s.copied=new e.Event,s.pasting=new e.Event,s.pasted=new e.Event,s.pastingCell=new e.Event,s.pastedCell=new e.Event,s.formatItem=new e.Event,s.updatingView=new e.Event,s.updatedView=new e.Event,s._mappedColumns=null;var l=s.hostElement;e.isIE()&&(l.style.borderRadius="0px");var a=s.getTemplate();s.applyTemplate("wj-control wj-content wj-flexgrid",a,{_root:"root",_eSz:"sz",_eCt:"cells",_fCt:"fcells",_eTL:"tl",_eBL:"bl",_eCHdr:"ch",_eRHdr:"rh",_eCFtr:"cf",_eTLCt:"tlcells",_eBLCt:"blcells",_eCHdrCt:"chcells",_eCFtrCt:"cfcells",_eRHdrCt:"rhcells",_eMarquee:"marquee",_eFocus:"focus"}),s._tabIndex=l.tabIndex,l.tabIndex=-1;var c=s._getDefaultRowHeight();return s.deferUpdate(function(){s._rows=new t.RowCollection(s,c),s._cols=new t.ColumnCollection(s,4*c),s._hdrRows=new t.RowCollection(s,c),s._hdrCols=new t.ColumnCollection(s,Math.round(1.25*c)),s._ftrRows=new t.RowCollection(s,c),s._gpTL=new t.GridPanel(s,t.CellType.TopLeft,s._hdrRows,s._hdrCols,s._eTLCt),s._gpCHdr=new t.GridPanel(s,t.CellType.ColumnHeader,s._hdrRows,s._cols,s._eCHdrCt),s._gpRHdr=new t.GridPanel(s,t.CellType.RowHeader,s._rows,s._hdrCols,s._eRHdrCt),s._gpCells=new t.GridPanel(s,t.CellType.Cell,s._rows,s._cols,s._eCt),s._gpBL=new t.GridPanel(s,t.CellType.BottomLeft,s._ftrRows,s._hdrCols,s._eBLCt),s._gpCFtr=new t.GridPanel(s,t.CellType.ColumnFooter,s._ftrRows,s._cols,s._eCFtrCt),s._hdrRows.push(new t.Row),s._hdrCols.push(new t.Column),s._hdrCols[0].align="center",s._cf=new t.CellFactory,s._keyHdl=new t._KeyboardHandler(s),s._mouseHdl=new t._MouseHandler(s),s._edtHdl=new t._EditHandler(s),s._selHdl=new t._SelectionHandler(s),s._addHdl=new t._AddNewHandler(s),s._mrgMgr=new t.MergeManager(s),s._bndSortConverter=s._sortConverter.bind(s),s._bndScroll=s._scroll.bind(s),e.setAttribute(s.cells.hostElement,"role","grid"),s.selectionMode=t.SelectionMode.CellRange,s.initialize(r)}),s.addEventListener(s._root,"scroll",function(e){s._updateScrollPosition()&&(s.finishEditing(),s._updateContent(!0))}),s.addEventListener(l,"focus",function(e){if(l.tabIndex>-1){var t=e.target;if(t instanceof HTMLElement&&t.tabIndex<0)return void s._setFocus(!0)}},!0),s}return __extends(n,o),n.prototype._handleResize=function(){this._rcBounds=null,o.prototype._handleResize.call(this)},Object.defineProperty(n.prototype,"headersVisibility",{get:function(){return this._hdrVis},set:function(t){(t=e.asEnum(t,i))!=this._hdrVis&&(this._hdrVis=t,this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"stickyHeaders",{get:function(){return this._stickyHdr},set:function(t){t!=this._stickyHdr&&(this._stickyHdr=e.asBoolean(t),this._updateStickyHeaders(),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"preserveSelectedState",{get:function(){return this._pSel},set:function(t){this._pSel=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"preserveOutlineState",{get:function(){return this._pOutline},set:function(t){this._pOutline=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"virtualizationThreshold",{get:function(){return this._vt},set:function(t){this._vt=e.asNumber(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"autoGenerateColumns",{get:function(){return this._autoGenCols},set:function(t){this._autoGenCols=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"autoClipboard",{get:function(){return this._autoClipboard},set:function(t){this._autoClipboard=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"autoScroll",{get:function(){return this._autoScroll},set:function(t){this._autoScroll=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"columnLayout",{get:function(){for(var i=n._getSerializableProperties(t.Column),o=new t.Column,r=[],s=0;s<this.columns.length;s++){for(var l=this.columns[s],a={},c=0;c<i.length;c++){var h=i[c],u=l[h];u!=o[h]&&e.isPrimitive(u)&&"size"!=h&&(a[h]=u)}r.push(a)}return JSON.stringify({columns:r})},set:function(t){var i=JSON.parse(e.asString(t));if(!i||null==i.columns)throw"Invalid columnLayout data.";this.columns.clear(),this.initialize(i)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isReadOnly",{get:function(){return this._readOnly},set:function(t){t!=this._readOnly&&(this._readOnly=e.asBoolean(t),this.finishEditing(),this.invalidate(!0),this._addHdl.updateNewRowTemplate(),e.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly),this._setAria("readonly",this.isReadOnly?"true":null))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"imeEnabled",{get:function(){return null!=this._imeHdl},set:function(i){e.asBoolean(i)!=this.imeEnabled&&this.finishEditing()&&(this._imeHdl&&(this._imeHdl.dispose(),this._imeHdl=null),i&&(this._imeHdl=new t._ImeHandler(this)))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"allowResizing",{get:function(){return this._alResizing},set:function(i){this._alResizing=e.asEnum(i,t.AllowResizing)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"deferResizing",{get:function(){return this._deferResizing},set:function(t){this._deferResizing=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"autoSizeMode",{get:function(){return this._autoSizeMode},set:function(i){this._autoSizeMode=e.asEnum(i,t.AutoSizeMode)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"quickAutoSize",{get:function(){return this._quickSize},set:function(t){this._quickSize=e.asBoolean(t,!0)},enumerable:!0,configurable:!0}),n.prototype._getQuickAutoSize=function(){return e.isBoolean(this._quickSize)?this._quickSize:!this.formatItem.hasHandlers&&null==this.itemFormatter},Object.defineProperty(n.prototype,"allowSorting",{get:function(){return this._alSorting},set:function(t){this._alSorting=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"allowAddNew",{get:function(){return this._alAddNew},set:function(t){t!=this._alAddNew&&(this._alAddNew=e.asBoolean(t),this._addHdl.updateNewRowTemplate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"newRowAtTop",{get:function(){return this._addHdl.newRowAtTop},set:function(t){this._addHdl.newRowAtTop=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"allowDelete",{get:function(){return this._alDelete},set:function(t){t!=this._alDelete&&(this._alDelete=e.asBoolean(t))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"allowMerging",{get:function(){return this._alMerging},set:function(i){(i=e.asEnum(i,t.AllowMerging))!=this._alMerging&&(this._alMerging=i,this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showSelectedHeaders",{get:function(){return this._ssHdr},set:function(t){(t=e.asEnum(t,i))!=this._ssHdr&&(this._ssHdr=t,this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showMarquee",{get:function(){return!this._eMarquee.style.display},set:function(t){if(t!=this.showMarquee){var i=this._eMarquee.style;i.visibility="collapse",i.display=e.asBoolean(t)?"":"none",this.invalidate()}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showSort",{get:function(){return this._shSort},set:function(t){t!=this._shSort&&(this._shSort=e.asBoolean(t),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showGroups",{get:function(){return this._shGroups},set:function(t){t!=this._shGroups&&(this._shGroups=e.asBoolean(t),this._bindGrid(!1))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showAlternatingRows",{get:function(){return this._shAlt},set:function(t){t!=this._shAlt&&(this._shAlt=e.asBoolean(t),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showErrors",{get:function(){return this._shErr},set:function(t){t!=this._shErr&&(this._clearCells(),this._shErr=e.asBoolean(t))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemValidator",{get:function(){return this._itemValidator},set:function(t){t!=this.itemValidator&&(this._itemValidator=e.asFunction(t),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"validateEdits",{get:function(){return this._valEdt},set:function(t){this._valEdt=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"groupHeaderFormat",{get:function(){return this._gHdrFmt},set:function(t){t!=this._gHdrFmt&&(this._gHdrFmt=e.asString(t),this._bindGrid(!1))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"allowDragging",{get:function(){return this._alDragging},set:function(i){(i=e.asEnum(i,t.AllowDragging))!=this._alDragging&&(this._alDragging=i,this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemsSource",{get:function(){return this._items},set:function(i){if(i!=this._items){var o=new e.CancelEventArgs;if(this.onItemsSourceChanging(o)){if(this._cv&&((n=e.tryCast(this._cv,e.collections.CollectionView))&&n.sortConverter==this._bndSortConverter&&(n.sortConverter=null),this._cv.currentChanged.removeHandler(this._cvCurrentChanged,this),this._cv.collectionChanged.removeHandler(this._cvCollectionChanged,this),this._cv=null),this._items=i,this._cv=this._getCollectionView(i),this._lastCount=0,this._cv){this._cv.currentChanged.addHandler(this._cvCurrentChanged,this),this._cv.collectionChanged.addHandler(this._cvCollectionChanged,this);var n=e.tryCast(this._cv,e.collections.CollectionView);n&&!n.sortConverter&&(n.sortConverter=this._bndSortConverter)}this._bindGrid(!0);var r=t.SelectionMode;this.selectionMode==r.ListBox&&(this.selectionMode=r.CellRange,this.selectionMode=r.ListBox),this.onItemsSourceChanged(o)}}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"collectionView",{get:function(){return this._cv},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"editableCollectionView",{get:function(){return e.tryCast(this._cv,"IEditableCollectionView")},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"childItemsPath",{get:function(){return this._childItemsPath},set:function(t){t!=this._childItemsPath&&(e.assert(null==t||e.isArray(t)||e.isString(t),"childItemsPath should be an array or a string."),this._childItemsPath=t,this._bindGrid(!0))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"rowHeaderPath",{get:function(){return this._rowHdrPath?this._rowHdrPath.path:null},set:function(t){t!=this.rowHeaderPath&&(t=e.asString(t),this._rowHdrPath=t?new e.Binding(t):null,this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"cells",{get:function(){return this._gpCells},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"columnHeaders",{get:function(){return this._gpCHdr},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"columnFooters",{get:function(){return this._gpCFtr},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"rowHeaders",{get:function(){return this._gpRHdr},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"topLeftCells",{get:function(){return this._gpTL},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"bottomLeftCells",{get:function(){return this._gpBL},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"rows",{get:function(){return this._rows},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"columns",{get:function(){return this._cols},enumerable:!0,configurable:!0}),n.prototype.getColumn=function(e){return this.columns.getColumn(e)},Object.defineProperty(n.prototype,"frozenRows",{get:function(){return this.rows.frozen},set:function(e){this.rows.frozen=e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"frozenColumns",{get:function(){return this.columns.frozen},set:function(e){this.columns.frozen=e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"cloneFrozenCells",{get:function(){return this._fzClone},set:function(t){t!=this.cloneFrozenCells&&(this._fzClone=e.asBoolean(t,!0),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"sortRowIndex",{get:function(){return this._sortRowIndex},set:function(t){t!=this._sortRowIndex&&(this._sortRowIndex=e.asNumber(t,!0),this.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"scrollPosition",{get:function(){return this._ptScrl.clone()},set:function(e){var t=this._root,i=-e.x;if(this.rightToLeft)switch(n._getRtlMode()){case"rev":i=t.scrollWidth-t.clientWidth+e.x;break;case"neg":i=e.x;break;default:i=-e.x}t.scrollLeft=i,t.scrollTop=-e.y},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"clientSize",{get:function(){return this._szClient},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"controlRect",{get:function(){return this._rcBounds||(this._rcBounds=e.getElementRect(this._root)),this._rcBounds},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"scrollSize",{get:function(){return new e.Size(this._gpCells.width,this._heightBrowser)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"viewRange",{get:function(){return this._gpCells.viewRange},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"cellFactory",{get:function(){return this._cf},set:function(i){i!=this._cf&&(this._clearCells(),this._cf=e.asType(i,t.CellFactory,!1))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemFormatter",{get:function(){return this._itemFormatter},set:function(t){t!=this._itemFormatter&&(this._clearCells(),this._itemFormatter=e.asFunction(t))},enumerable:!0,configurable:!0}),n.prototype.canEditCell=function(e,t){return this._edtHdl._allowEditing(e,t)},n.prototype.getCellData=function(e,t,i){return this.cells.getCellData(e,t,i)},n.prototype.getCellBoundingRect=function(e,t,i){return this.cells.getCellBoundingRect(e,t,i)},n.prototype.setCellData=function(e,t,i,o,n){return void 0===o&&(o=!0),void 0===n&&(n=!0),this.cells.setCellData(e,t,i,o,n)},n.prototype.hitTest=function(i,o){return e.isNumber(i)&&e.isNumber(o)&&(i=new e.Point(i,o)),e.isBoolean(o)&&o&&(this._rcBounds=null),new t.HitTestInfo(this,i)},n.prototype.getClipString=function(e){return this._edtHdl.getClipString(e)},n.prototype.setClipString=function(e,t){this._edtHdl.setClipString(e,t)},n.prototype.focus=function(){this._setFocus(!1)},n.prototype.dispose=function(){this.finishEditing(!0),this.itemsSource=null,o.prototype.dispose.call(this)},n.prototype.refresh=function(e){void 0===e&&(e=!0),o.prototype.refresh.call(this,e),this.finishEditing(),e&&(this._updateColumnTypes(),this.scrollPosition=this._ptScrl),this.refreshCells(e)},n.prototype.refreshCells=function(e,t,i){this.isUpdating||(e?this._updateLayout():this._updateContent(t,i))},n.prototype.autoSizeColumn=function(e,t,i){void 0===t&&(t=!1),void 0===i&&(i=4),this.autoSizeColumns(e,e,t,i)},n.prototype.autoSizeColumns=function(i,o,r,s){var l=this;void 0===r&&(r=!1),void 0===s&&(s=4);var a=0,c=r?this.topLeftCells:this.columnHeaders,h=r?this.bottomLeftCells:this.columnFooters,u=r?this.rowHeaders:this.cells,d=this.viewRange;i=null==i?0:e.asInt(i),o=null==o?u.columns.length-1:e.asInt(o),d.row=Math.max(0,d.row-1e3),d.row2=Math.min(d.row2+1e3,this.rows.length-1),this.finishEditing()&&this.columns.deferUpdate(function(){e.setCss(l._eCt,{width:l._gpCells.width});var r=document.createElement("div");r.setAttribute(n._WJS_MEASURE,"true"),r.style.visibility="hidden",u.hostElement.parentElement.appendChild(r);for(var g=l._getCanvasContext(),p=i;p<=o&&p>-1&&p<u.columns.length;p++){var f=u.columns[p];if(f.isVisible){if(a=0,l.autoSizeMode&t.AutoSizeMode.Headers){for(_=0;_<c.rows.length;_++)if(c.rows[_].isVisible){w=l._getDesiredWidth(c,_,p,r);a=Math.max(a,w)}for(_=0;_<h.rows.length;_++)if(h.rows[_].isVisible){w=l._getDesiredWidth(h,_,p,r);a=Math.max(a,w)}}if(l.autoSizeMode&t.AutoSizeMode.Cells&&d.isValid)if(f._getQuickAutoSize()){var _=l._getWidestRow(u,d,p,g),w=l._getDesiredWidth(u,_,p,r);a=Math.max(a,w)}else for(_=d.row;_<=d.row2&&_<u.rows.length;_++)if(u.rows[_].isVisible){w=l._getDesiredWidth(u,_,p,r);a=Math.max(a,w)}f.width=a+s+2}}l.cellFactory.disposeCell(r),e.removeChild(r)})},n.prototype.autoSizeRow=function(e,t,i){void 0===t&&(t=!1),void 0===i&&(i=0),this.autoSizeRows(e,e,t,i)},n.prototype.autoSizeRows=function(i,o,r,s){var l=this;void 0===r&&(r=!1),void 0===s&&(s=0);var a=0,c=r?this.topLeftCells:this.rowHeaders,h=r?this.columnHeaders:this.cells;r=e.asBoolean(r),s=e.asNumber(s),i=null==i?0:e.asInt(i),o=null==o?h.rows.length-1:e.asInt(o),this.finishEditing()&&this.rows.deferUpdate(function(){e.setCss(l._eCt,{width:l._gpCells.width});var r=document.createElement("div");r.setAttribute(n._WJS_MEASURE,"true"),r.style.visibility="hidden",h.hostElement.appendChild(r);for(var u={},d=i;d<=o&&d>-1&&d<h.rows.length;d++)if(h.rows[d].isVisible){if(a=0,l.autoSizeMode&t.AutoSizeMode.Headers)for(p=0;p<c.columns.length;p++)if(c.columns[p].isVisible>0){w=l._getDesiredHeight(c,d,p,r);a=Math.max(a,w)}if(l.autoSizeMode&t.AutoSizeMode.Cells)for(var g=!0,p=0;p<h.columns.length;p++){var f=h.columns[p],_=f._getQuickAutoSize();if(f.isVisible&&(g||f.wordWrap||f.cssClass||f.dataType==e.DataType.Boolean||!_)){var w=void 0;if(_){var m={col:p,content:f.dataType==e.DataType.Number?"1":h.getCellData(d,p,!0)},y=JSON.stringify(m);null==(w=u[y])&&(w=l._getDesiredHeight(h,d,p,r),u[y]=w)}else w=l._getDesiredHeight(h,d,p,r);a=Math.max(a,w),g=!1}}h.rows[d].height=a+s}l.cellFactory.disposeCell(r),e.removeChild(r)})},Object.defineProperty(n.prototype,"treeIndent",{get:function(){return this._indent},set:function(t){t!=this._indent&&(this._indent=e.asNumber(t,!1,!0),this.columns.onCollectionChanged())},enumerable:!0,configurable:!0}),n.prototype.collapseGroupsToLevel=function(e){var i=this;this.finishEditing()&&this.deferUpdate(function(){var o=i.rows;o.deferUpdate(function(){for(var i=0;i<o.length;i++){var n=o[i];n instanceof t.GroupRow&&(n.isCollapsed=n.level>=e)}})})},Object.defineProperty(n.prototype,"selectionMode",{get:function(){return this._selHdl.selectionMode},set:function(i){(i=e.asEnum(i,t.SelectionMode))!=this.selectionMode&&(this._clearCells(),this._selHdl.selectionMode=i)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selection",{get:function(){return this._selHdl.selection.clone()},set:function(e){this._selHdl.selection=e},enumerable:!0,configurable:!0}),n.prototype.select=function(e,t){void 0===t&&(t=!0),this._selHdl.select(e,t)},n.prototype.getSelectedState=function(e,t){return this.cells.getSelectedState(e,t,null)},Object.defineProperty(n.prototype,"selectedRows",{get:function(){var e=[];if(this.selectionMode==t.SelectionMode.ListBox)for(o=0;o<this.rows.length;o++)this.rows[o].isSelected&&e.push(this.rows[o]);else if(this.rows.length)for(var i=this.selection,o=i.topRow;o>-1&&o<=i.bottomRow;o++)e.push(this.rows[o]);return e},set:function(i){var o=this;e.assert(this.selectionMode==t.SelectionMode.ListBox,"This property can be set only in ListBox mode."),i=e.asArray(i),this.deferUpdate(function(){for(var e=0,t=!0;e<o.rows.length;e++){var n=o.rows[e],r=i&&i.indexOf(n)>-1;r&&t&&(t=!1,o.select(e,o.selection.col)),n.isSelected=r}})},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectedItems",{get:function(){for(var e=this.selectedRows,t=0;t<e.length;t++)e[t]=e[t].dataItem;return e},set:function(i){var o=this;e.assert(this.selectionMode==t.SelectionMode.ListBox,"This property can be set only in ListBox mode."),i=e.asArray(i),this.deferUpdate(function(){for(var e=0,t=!0;e<o.rows.length;e++){var n=o.rows[e],r=i&&i.indexOf(n.dataItem)>-1;r&&t&&(t=!1,o.select(e,o.selection.col)),n.isSelected=r}})},enumerable:!0,configurable:!0}),n.prototype.scrollIntoView=function(t,i,o){null==this._maxOffsetY&&this._updateLayout();var n=this.scrollPosition,r=this._szClient.width,s=this._szClient.height-this._gpCFtr.rows.getTotalSize(),l=this.cells._getFrozenPos();if((t=e.asInt(t))>-1&&t<this._rows.length&&t>=this._rows.frozen){var a=this._rows[t],c=this.cells.height>s?Math.round(a.pos/(this.cells.height-s)*100)/100:0,h=Math.round(this._maxOffsetY*c),u=a.pos-h,d=u+a.renderSize;d>s-n.y&&(n.y=Math.max(-u,s-d)),u-l.y<-n.y&&(n.y=-(u-l.y))}if((i=e.asInt(i))>-1&&i<this._cols.length&&i>=this._cols.frozen){var g=this._cols[i],p=g.pos+g.renderSize;p>-n.x+r&&(n.x=Math.max(-g.pos,r-p)),g.pos-l.x<-n.x&&(n.x=-(g.pos-l.x))}return!n.equals(this._ptScrl)&&(this.scrollPosition=n,o&&(this._updateScrollPosition(),this.refresh()),!0)},n.prototype.isRangeValid=function(e){return e.isValid&&e.bottomRow<this.rows.length&&e.rightCol<this.columns.length},n.prototype.startEditing=function(e,t,i,o){return void 0===e&&(e=!0),this._edtHdl.startEditing(e,t,i,o)},n.prototype.finishEditing=function(e){return this._edtHdl.finishEditing(e)},Object.defineProperty(n.prototype,"activeEditor",{get:function(){return this._edtHdl.activeEditor},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"editRange",{get:function(){return this._edtHdl.editRange},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"mergeManager",{get:function(){return this._mrgMgr},set:function(i){i!=this._mrgMgr&&(this._mrgMgr=e.asType(i,t.MergeManager,!0),this.invalidate())},enumerable:!0,configurable:!0}),n.prototype.getMergedRange=function(e,t,i,o){return void 0===o&&(o=!0),this._mrgMgr?this._mrgMgr.getMergedRange(e,t,i,o):null},Object.defineProperty(n.prototype,"keyActionTab",{get:function(){return this._keyHdl._kaTab},set:function(i){this._keyHdl._kaTab=e.asEnum(i,t.KeyAction)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"keyActionEnter",{get:function(){return this._keyHdl._kaEnter},set:function(i){this._keyHdl._kaEnter=e.asEnum(i,t.KeyAction)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showDropDown",{get:function(){return this._shDropDown},set:function(t){t!=this._shDropDown&&(this._shDropDown=e.asBoolean(t,!0),this.invalidate())},enumerable:!0,configurable:!0}),n.prototype.toggleDropDownList=function(){this._tglDropDown||(this._tglDropDown=!0,this._edtHdl._toggleListBox(null),this._tglDropDown=!1)},n.prototype.onItemsSourceChanging=function(e){return this.itemsSourceChanging.raise(this,e),!e.cancel},n.prototype.onItemsSourceChanged=function(e){this.itemsSourceChanged.raise(this,e)},n.prototype.onScrollPositionChanged=function(e){this.scrollPositionChanged.raise(this,e)},n.prototype.onSelectionChanging=function(e){return this.selectionChanging.raise(this,e),!e.cancel},n.prototype.onSelectionChanged=function(e){this.selectionChanged.raise(this,e)},n.prototype.onLoadingRows=function(e){return this.loadingRows.raise(this,e),!e.cancel},n.prototype.onLoadedRows=function(e){this.loadedRows.raise(this,e)},n.prototype.onUpdatingLayout=function(e){return this.updatingLayout.raise(this,e),!e.cancel},n.prototype.onUpdatedLayout=function(e){this.updatedLayout.raise(this,e)},n.prototype.onResizingColumn=function(e){return this.resizingColumn.raise(this,e),!e.cancel},n.prototype.onResizedColumn=function(e){this.resizedColumn.raise(this,e)},n.prototype.onAutoSizingColumn=function(e){return this.autoSizingColumn.raise(this,e),!e.cancel},n.prototype.onAutoSizedColumn=function(e){this.autoSizedColumn.raise(this,e)},n.prototype.onDraggingColumn=function(e){return this.draggingColumn.raise(this,e),!e.cancel},n.prototype.onDraggingColumnOver=function(e){return this.draggingColumnOver.raise(this,e),!e.cancel},n.prototype.onDraggedColumn=function(e){this.draggedColumn.raise(this,e)},n.prototype.onResizingRow=function(e){return this.resizingRow.raise(this,e),!e.cancel},n.prototype.onResizedRow=function(e){this.resizedRow.raise(this,e)},n.prototype.onAutoSizingRow=function(e){return this.autoSizingRow.raise(this,e),!e.cancel},n.prototype.onAutoSizedRow=function(e){this.autoSizedRow.raise(this,e)},n.prototype.onDraggingRow=function(e){return this.draggingRow.raise(this,e),!e.cancel},n.prototype.onDraggingRowOver=function(e){return this.draggingRowOver.raise(this,e),!e.cancel},n.prototype.onDraggedRow=function(e){this.draggedRow.raise(this,e)},n.prototype.onGroupCollapsedChanging=function(e){return this.groupCollapsedChanging.raise(this,e),!e.cancel},n.prototype.onGroupCollapsedChanged=function(e){this.groupCollapsedChanged.raise(this,e)},n.prototype.onSortingColumn=function(e){return this.sortingColumn.raise(this,e),!e.cancel},n.prototype.onSortedColumn=function(e){this.sortedColumn.raise(this,e)},n.prototype.onBeginningEdit=function(e){return this.beginningEdit.raise(this,e),!e.cancel},n.prototype.onPrepareCellForEdit=function(e){this.prepareCellForEdit.raise(this,e)},n.prototype.onCellEditEnding=function(e){return this.cellEditEnding.raise(this,e),!e.cancel&&!e.stayInEditMode},n.prototype.onCellEditEnded=function(e){this.cellEditEnded.raise(this,e)},n.prototype.onRowEditStarting=function(e){this.rowEditStarting.raise(this,e)},n.prototype.onRowEditStarted=function(e){this.rowEditStarted.raise(this,e)},n.prototype.onRowEditEnding=function(e){this.rowEditEnding.raise(this,e)},n.prototype.onRowEditEnded=function(e){this.rowEditEnded.raise(this,e)},n.prototype.onRowAdded=function(e){return this.rowAdded.raise(this,e),!e.cancel},n.prototype.onDeletingRow=function(e){return this.deletingRow.raise(this,e),!e.cancel},n.prototype.onDeletedRow=function(e){this.deletedRow.raise(this,e)},n.prototype.onCopying=function(e){return this.copying.raise(this,e),!e.cancel},n.prototype.onCopied=function(e){this.copied.raise(this,e)},n.prototype.onPasting=function(e){return this.pasting.raise(this,e),!e.cancel},n.prototype.onPasted=function(e){this.pasted.raise(this,e)},n.prototype.onPastingCell=function(e){return this.pastingCell.raise(this,e),!e.cancel},n.prototype.onPastedCell=function(e){this.pastedCell.raise(this,e)},n.prototype.onFormatItem=function(e){this.formatItem.raise(this,e)},n.prototype.onUpdatingView=function(e){return this.updatingView.raise(this,e),!e.cancel},n.prototype.onUpdatedView=function(e){this.updatedView.raise(this,e)},n.prototype._getShowErrors=function(){return this.showErrors&&this._hasValidation},n.prototype._getHasValidation=function(){return this._hasValidation},n.prototype._getError=function(t,i,o){if(e.isFunction(this.itemValidator)){if(t==this.cells)return this.itemValidator(i,o);if(t==this.rowHeaders)for(o=0;o<this.columns.length;o++)if(h=this.itemValidator(i,o))return h}var n=this._cv,r=n?n.getError:null;if(e.isFunction(r)){var s=t.rows,l=this.columns,a=s[i].dataItem;if(a)for(;i<s.length&&s[i].dataItem==a;i++){if(t==this.cells)return r(a,(c=this._getBindingColumn(this.cells,i,l[o])).binding);if(t==this.rowHeaders)for(o=0;o<l.length;o++){var c=this._getBindingColumn(this.cells,i,l[o]),h=r(a,c.binding);if(h)return h}}}return null},n.prototype._setAria=function(t,i){e.setAttribute(this.cells.hostElement,"aria-"+t,i)},n.prototype._setFocus=function(t){if(this.hostElement&&(t||!this.containsFocus())){var i=e.getActiveElement(),o=this.activeEditor,n=this._activeCell,r=this._eFocus,s="tabindex";if(o)e.contains(o,i)||(o.focus(),r.removeAttribute(s));else if(n){if(!e.contains(n,i)&&i!=this._root){var l=!1;if(e.isIE()){var a=n.getBoundingClientRect(),c=this._root.getBoundingClientRect();a.right>c.right&&(this._setFocusNoScroll(n),l=!0)}l||n.focus(),r.removeAttribute(s)}}else e.contains(r,i)||(r.tabIndex=this._tabIndex,r.focus());this.containsFocus()||(r.tabIndex=this._tabIndex,r.focus())}},n.prototype._setFocusNoScroll=function(t){if(t.tabIndex=this._tabIndex,e.supportsFocusOptions())t.focus({preventScroll:!0});else{var i=this.scrollPosition,o=t.style,n=o.position;o.position="fixed",t.focus(),o.position=n,this.scrollPosition=i}this._fixScroll()},n.prototype._getDefaultRowHeight=function(){var t=this.hostElement,i=document.body,o=null;if(i&&!e.contains(i,t)){for(var n=t;n;n=n.parentElement)o=n;o&&i.appendChild(o)}var r=this._eFocus.scrollHeight+2;return(r<=6||isNaN(r))&&(r=28),o&&e.removeChild(o),r},n.prototype._getDefaultCellPadding=function(){var e=getComputedStyle(this._eFocus);return parseInt(this.rightToLeft?e.paddingRight:e.paddingLeft)},n.prototype._getCollectionView=function(t){return e.asCollectionView(t)},n.prototype._getCanvasContext=function(){var e=document.createElement("canvas").getContext("2d"),t=getComputedStyle(this.hostElement);return e.font=t.fontSize+" "+t.fontFamily.split(",")[0],e},n.prototype._getWidestRow=function(t,i,o,n){for(var r=0,s=0,l=t.columns[o].dataType==e.DataType.Boolean,a=i.row;a<=i.row2;a++)if(t.rows[a].isVisible){var c=t.getCellData(a,o,!0),h=n.measureText(c).width;if(h>s&&(s=h,r=a),l)break}return r},n.prototype._getDesiredWidth=function(e,t,i,o){var n=this.getMergedRange(e,t,i),r=o.style;return this.cellFactory.updateCell(e,t,i,o,n),r.width=r.top=r.left="",o.offsetWidth/(n&&n.columnSpan>1?n.columnSpan:1)},n.prototype._getDesiredHeight=function(e,t,i,o){var n=this.getMergedRange(e,t,i),r=o.style;return this.cellFactory.updateCell(e,t,i,o,n),r.height=r.top=r.left="",o.offsetHeight/(n&&n.rowSpan>1?n.rowSpan:1)},n.prototype._getSortRowIndex=function(){return null!=this._sortRowIndex?this._sortRowIndex:this.columnHeaders.rows.length-1},n.prototype._sortConverter=function(e,t,i,o){var n;if(o){if(this._mappedColumns=null,this._cv)for(var r=this._cv.sortDescriptions,s=0;s<r.length;s++)(n=this.getColumn(r[s].property))&&n.dataMap&&(this._mappedColumns||(this._mappedColumns={}),this._mappedColumns[n.binding]=n.dataMap);this._mouseHdl._htDown&&this._mouseHdl._htDown.col>-1&&(n=this.columns[this._mouseHdl._htDown.col],this._mappedColumns&&n.dataMap&&(this._mappedColumns[n.binding]=n.dataMap))}if(this._mappedColumns){var l=this._mappedColumns[e.property];l&&l.sortByDisplayValues&&(i=l.getDisplayValue(i))}return i},n.prototype._bindGrid=function(i){var o=this;if(this.deferUpdate(function(){0==o._lastCount&&e.hasItems(o._cv)&&(i=!0);var n,r=o.selectionMode==t.SelectionMode.ListBox;o.preserveSelectedState&&r&&!o.childItemsPath&&(n=o.selectedItems);var s;if(o.preserveOutlineState&&e.isFunction(window.Map)&&o.rows.maxGroupLevel>-1){s=new Map;for(d=0;d<o.rows.length;d++){var l=o.rows[d];if(l instanceof t.GroupRow&&l.isCollapsed&&l.dataItem){var a=l.dataItem;a instanceof e.collections.CollectionViewGroup&&(a=a._path),s.set(a,!0)}}}i&&o.columns.deferUpdate(function(){o._bindColumns()});var c=new e.CancelEventArgs;o.onLoadingRows(c)&&(o.rows.deferUpdate(function(){o._bindRows()}),o.onLoadedRows(c));var h=0;if(n&&n.length)for(d=0;d<o.rows.length&&h<n.length;d++)n.indexOf(o.rows[d].dataItem)>-1&&(o.rows[d].isSelected=!0,h++);if(r&&0==h&&o._lastCount>0)for(var u=o.selection,d=u.topRow;d<=u.bottomRow&&d>-1&&d<o.rows.length;d++)o.rows[d].isSelected=!0;s&&o.rows.deferUpdate(function(){for(var i=0;i<o.rows.length;i++){var n=o.rows[i];if(n instanceof t.GroupRow){var r=n.dataItem;r instanceof e.collections.CollectionViewGroup&&(r=r._path),s.get(r)&&(n.isCollapsed=!0)}}}),!o._lastCount&&o._cv&&o._cv.items&&(o._lastCount=o._cv.items.length)}),!this.rows.length){var n=this._selHdl.selection;n.row=n.row2=-1}this._cv&&this._syncSelection(i)},n.prototype._cvCollectionChanged=function(i,o){if(this.autoGenerateColumns&&0==this.columns.length)this._bindGrid(!0);else if(this.childItemsPath&&o.action!=e.collections.NotifyCollectionChangedAction.Change)this._bindGrid(!1);else{switch(o.action){case e.collections.NotifyCollectionChangedAction.Change:return void this.invalidate();case e.collections.NotifyCollectionChangedAction.Add:if(o.index==this._cv.items.length-1){var n=this.rows.length;return this.rows[n-1]instanceof t._NewRowTemplate&&n--,void this.rows.insert(n,new t.Row(o.item))}e.assert(!1,"added item should be the last one.");break;case e.collections.NotifyCollectionChangedAction.Remove:var r=this._findRow(o.item);if(r>-1)return this.rows.removeAt(r),void this._syncSelection(!1);e.assert(!1,"removed item not found on grid.")}this._bindGrid(!1)}},n.prototype._cvCurrentChanged=function(e,t){this._syncSelection(!1)},n.prototype._syncSelection=function(i){if(this._cv&&this.selectionMode!=t.SelectionMode.None){var o=this.selection,n=o.row>-1&&o.row<this.rows.length?this.rows[o.row].dataItem:null;if(n instanceof e.collections.CollectionViewGroup&&(n=null),(n!=this._cv.currentItem||i)&&(!this.childItemsPath||!this.editableCollectionView||!this.editableCollectionView.currentAddItem)){var r=this._getRowIndex(this._cv.currentPosition);r==o.row&&this.childItemsPath||(o.row=o.row2=r,this.select(o,!1),this.selectionMode&&this.scrollIntoView(o.row,-1))}}},n.prototype._getRowIndex=function(e){if(this._cv){if(e>-1){for(var i=this._cv.items[e];e<this.rows.length;e++)if(this.rows[e].dataItem===i)return e;return-1}if(1==this.rows.length&&this.rows[0]instanceof t._NewRowTemplate)return 0;var o=this.selection.row,n=o>-1?this.rows[o]:null;return n&&(n instanceof t.GroupRow||null==n.dataItem)?o:-1}return this.selection.row},n.prototype._getCvIndex=function(e){if(this._cv&&e>-1&&e<this.rows.length){var t=this._cv.items,i=this.rows[e].dataItem;for(e=Math.min(e,t.length-1);e>-1;e--)if(t[e]===i)return e}return-1},n.prototype._findRow=function(e){for(var t=0;t<this.rows.length;t++)if(this.rows[t].dataItem==e)return t;return-1},n.prototype._updateLayout=function(){var t=new e.CancelEventArgs;if(this.onUpdatingLayout(t)){this._hasValidation=e.isFunction(this._itemValidator)||this._cv&&e.isFunction(this._cv.getError);var o=this._hdrVis&i.Row?this._hdrCols.getTotalSize():0,r=this._hdrVis&i.Column?this._hdrRows.getTotalSize():0,s=this._ftrRows.getTotalSize(),l=this._rows.getTotalSize()+s;l<1&&(l=1),this._heightBrowser=Math.min(l,n._getMaxSupportedCssHeight()),this._maxOffsetY=Math.max(0,l-this._heightBrowser),this._cellPadding=this._getDefaultCellPadding();var a=this._heightBrowser+r-s,c=this._gpCells.width,h=this._heightBrowser;!c&&this.rows.length&&(c=.1),!h&&this.columns.length&&(h=.1),this.rightToLeft?(e.setCss(this._eTL,{right:0,top:0,width:o,height:r}),e.setCss(this._eCHdr,{right:o,top:0,height:r}),e.setCss(this._eRHdr,{right:0,top:r,width:o}),e.setCss(this._eCt,{right:o,top:r,width:c,height:h}),e.setCss(this._fCt,{right:o,top:r}),e.setCss(this._eBL,{right:0,top:a,width:o,height:s}),e.setCss(this._eCFtr,{right:o,top:a,height:s})):(e.setCss(this._eTL,{left:0,top:0,width:o,height:r}),e.setCss(this._eCHdr,{left:o,top:0,height:r}),e.setCss(this._eRHdr,{left:0,top:r,width:o}),e.setCss(this._eCt,{left:o,top:r,width:c,height:h}),e.setCss(this._fCt,{left:o,top:r}),e.setCss(this._eBL,{left:0,top:a,width:o,height:s}),e.setCss(this._eCFtr,{left:o,top:a,height:s})),this._stickyHdr&&this._updateStickyHeaders();var u=this.frozenRows||this.frozenColumns?"3":"";e.setCss([this._eTL,this._eBL,this._eCHdr,this._eCFtr,this._eRHdr,this._eMarquee],{zIndex:u});var d=this._root,g=d.offsetWidth-d.clientWidth,p=d.offsetHeight-d.clientHeight;e.setCss(this._eSz,{width:o+g+this._gpCells.width,height:r+p+this._heightBrowser});var f=null;this.columns._updateStarSizes(d.clientWidth-o)&&(f=d.clientWidth,e.setCss(this._eCt,{width:this._gpCells.width})),this._szClient=new e.Size(d.clientWidth-o,d.clientHeight-r),this._rcBounds=null,this._updateScrollHandler(),this._updateContent(!1),g=d.offsetWidth-d.clientWidth,p=d.offsetHeight-d.clientHeight,e.setCss(this._eSz,{width:o+g+this._gpCells.width,height:r+p+this._heightBrowser}),this._szClient=new e.Size(d.clientWidth-o,d.clientHeight-r),f&&f!=d.clientWidth&&this.columns._updateStarSizes(d.clientWidth-o)&&(e.setCss(this._eCt,{width:this._gpCells.width}),this._updateContent(!1)),e.setCss([this._eCHdr,this._eCFtr,this._fCt],{width:this._szClient.width}),e.setCss([this._eRHdr,this._fCt],{height:this._szClient.height}),s&&(a=Math.min(a,this._szClient.height+r-s),e.setCss([this._eBL,this._eCFtr],{top:a})),this.onUpdatedLayout(t)}},n.prototype._updateStickyHeaders=function(){var t=!1,i=0;if(this._stickyHdr){for(var o=0,r=null,s=this.hostElement;s;s=s.parentElement){var l=s.getBoundingClientRect();null==r&&(r=l.top),o=Math.max(o,l.top)}i=-(r=Math.max(0,o-r-1)),t=r>0,this._rcBounds=null}this._eTL.style.top=this._eCHdr.style.top=t?-i+"px":"",e.toggleClass(this._eTL,n._WJS_STICKY,t),e.toggleClass(this._eCHdr,n._WJS_STICKY,t)},n.prototype._updateScrollHandler=function(){this._clipToScreen=this._getClipToScreen();var e=this._stickyHdr||this._clipToScreen;e!=this._scrollHandlerAttached&&(this._scrollHandlerAttached=e,e?this.addEventListener(window,"scroll",this._bndScroll,!0):this.removeEventListener(window,"scroll",this._bndScroll,!0))},n.prototype._getClipToScreen=function(){if(this.rows.length<=n._MIN_VIRT_ROWS)return!1;if(this._root.clientHeight!=this._root.scrollHeight)return!1;for(var e=this.hostElement;e&&e!=document.documentElement;e=e.parentElement)if("auto"==getComputedStyle(e).overflow)return!1;return!0},n.prototype._scroll=function(t){var i=this;e.contains(t.target,this.hostElement)&&(this._clipToScreen&&(this._afScrl&&cancelAnimationFrame(this._afScrl),this._afScrl=requestAnimationFrame(function(){i._afScrl=null,i.finishEditing(),i._updateContent(!0)})),this._stickyHdr&&(this._afSticky&&cancelAnimationFrame(this._afSticky),this._afSticky=requestAnimationFrame(function(){i._afSticky=null;var t=new e.CancelEventArgs;i.onUpdatingLayout(t)&&(i._updateStickyHeaders(),i.onUpdatedLayout(t))})))},n.prototype._updateScrollPosition=function(){var t=this._root,i=t.scrollTop,o=t.scrollLeft;this.rightToLeft&&"rev"==n._getRtlMode()&&(o=t.scrollWidth-t.clientWidth-o);var r=new e.Point(-Math.abs(o),-i);return!this._ptScrl.equals(r)&&(this._ptScrl=r,this.onScrollPositionChanged(),!0)},n.prototype._updateContent=function(t,o){var n=this._root,r=this.hostElement,s=this.cells.hostElement,l=e.getActiveElement(),a=e.contains(r,l)?l:null,c=this._activeCell,h=new e.CancelEventArgs;if(this.onUpdatingView(h)){if(e.setAttribute(s,"role",this.rows.maxGroupLevel<0?"grid":"treegrid"),this._offsetY=0,this._heightBrowser>this._szClient.height){var u=Math.round(-this._ptScrl.y/(this._heightBrowser-this._szClient.height)*100)/100;this._offsetY=Math.round(this._maxOffsetY*u)}this._updateScrollPosition();var d=this._gpCells._updateContent(t,o,this._offsetY);if(this._hdrVis&i.Column&&(!o||this._ssHdr&i.Column)&&this._gpCHdr._updateContent(t,o,0),this._hdrVis&i.Row&&(!o||this._ssHdr&i.Row)&&this._gpRHdr._updateContent(t,o,this._offsetY),this._hdrVis&&!o&&this._gpTL._updateContent(t,o,0),this._gpCFtr.rows.length&&(this._gpBL._updateContent(t,o,0),this._gpCFtr._updateContent(t,o,0)),this.showMarquee){var g=this._selHdl.selection,p=this._eMarquee;if(this.isRangeValid(g)){var f=this._getMarqueeRect(g),_=p.firstChild,w=p.offsetWidth-_.offsetWidth,m=p.offsetHeight-_.offsetHeight;e.setCss(p,{left:f.left+s.offsetLeft-w/2,top:f.top+s.offsetTop-m/2,width:f.width+w,height:f.height+m,visibility:f.width>0&&f.height>0?"":"collapse"})}else e.setCss(p,{left:0,top:0,width:0,height:0,visibility:"collapse"})}if(this._useFrozenDiv()&&(this._updateFrozenCells(o),d&&e.hasClass(d,"wj-frozen")&&(d=null)),this._activeCell=d,a)if(a!=n&&a!=this._eFocus&&e.contains(r,a)&&!e.contains(s,a)){if(e.getActiveElement()!=a&&a.focus(),e.isIE()&&a instanceof HTMLInputElement&&!a.type.match(/checkbox|radio|range/i)){var y=a.selectionStart,v=a.selectionEnd;a.setSelectionRange(y,v)}}else{var C=d!=c;this._setFocus(C)}!a&&d&&(d.tabIndex=this._tabIndex),c&&c!=d&&c.removeAttribute("tabindex"),this._fixScroll(),this._rcBounds=null,this.onUpdatedView(h)}},n.prototype._fixScroll=function(){[this.hostElement,this._root?this._root.parentElement:null].forEach(function(e){e&&e.scrollTop&&(e.scrollTop=0)})},n.prototype._clearCells=function(){for(var e in this)if("_"==e[0]){var i=this[e];i instanceof t.GridPanel&&i._clearCells()}this.invalidate()},n.prototype._useFrozenDiv=function(){return e.isBoolean(this._fzClone)?this._fzClone:e.isIE()||e.isFirefox()||e.isSafari()||e.isMobile()},n.prototype._updateFrozenCells=function(t){if(this.frozenRows||this.frozenColumns){var i=this._eCt.querySelectorAll(".wj-frozen");if(t&&this._fCt.children.length==i.length){for(o=0;o<i.length;o++)this._fCt.children[o].className=i[o].className;return}if(e.setText(this._fCt,null),!this.activeEditor)for(var o=0;o<i.length;o++){var n=i[o].cloneNode(!0);n.style.pointerEvents="auto",this._fCt.appendChild(n)}}else e.setText(this._fCt,null)},n.prototype._getMarqueeRect=function(i){var o=this.getMergedRange(this.cells,i.topRow,i.leftCol)||new t.CellRange(i.topRow,i.leftCol),n=this.getMergedRange(this.cells,i.bottomRow,i.rightCol)||new t.CellRange(i.bottomRow,i.rightCol),r=this.cells.getCellBoundingRect(o.topRow,o.leftCol,!0),s=this.cells.getCellBoundingRect(n.bottomRow,n.rightCol,!0);if(this.rows.frozen){var l=Math.min(this.rows.length,this.rows.frozen),a=this.cells.getCellBoundingRect(l-1,0,!0);i.topRow>=l&&r.top<a.bottom&&(r.top=a.bottom),i.bottomRow>=l&&s.bottom<a.bottom&&(s.height=a.bottom-s.top)}if(this.columns.frozen){var c=Math.min(this.columns.length,this.columns.frozen),a=this.cells.getCellBoundingRect(0,c-1,!0);this.rightToLeft?(i.leftCol>=c&&r.right>a.left&&(r.left=a.left-r.width),i.rightCol>=c&&s.left>a.left&&(s.left=a.left)):(i.leftCol>=c&&r.left<a.right&&(r.left=a.right),i.rightCol>=c&&s.right<a.right&&(s.width=a.right-s.left))}return this.rightToLeft?new e.Rect(s.left,r.top,r.right-s.left,s.bottom-r.top):new e.Rect(r.left,r.top,s.right-r.left,s.bottom-r.top)},n.prototype._bindColumns=function(){for(var i=0;i<this.columns.length;i++)(c=this.columns[i])._getFlag(t.RowColFlags.AutoGenerated)&&(this.columns.removeAt(i),i--);var o=this._cv,n=o?o.sourceCollection:null,r=n&&n.length?n[0]:null;if(r&&this.autoGenerateColumns)for(var s in r)for(var l=null,a=0;a<n.length&&a<1e3&&null==l;a++)if(l=n[a][s],e.isPrimitive(l)){var c=new t.Column;c._setFlag(t.RowColFlags.AutoGenerated,!0),c.binding=c.name=s,c.header=e.toHeaderCase(s),c.dataType=e.getType(l),c.dataType==e.DataType.Number&&(c.width=80);var h=Object.getOwnPropertyDescriptor(r,s);!h||h.writable||e.isFunction(h.set)||c._setFlag(t.RowColFlags.ReadOnly,!0),this.columns.push(c)}this._updateColumnTypes()},n.prototype._updateColumnTypes=function(){var t=this._cv;if(e.hasItems(t))for(var i=t.items[0],o=this.columns,n=0;n<o.length;n++){var r=o[n];null==r.dataType&&r._binding&&(r.dataType=e.getType(r._binding.getValue(i)))}},n.prototype._getBindingColumn=function(e,t,i){return i},n.prototype._getRowHeaderPath=function(){return this._rowHdrPath},n.prototype._bindRows=function(){this.rows.clear();var e=this._cv;if(e&&e.items){var t=e.items,i=e.groups;if(this.childItemsPath)for(o=0;o<t.length;o++)this._addNode(t,o,0);else if(null!=i&&i.length>0&&this.showGroups)for(o=0;o<i.length;o++)this._addGroup(i[o]);else for(var o=0;o<t.length;o++)this._addBoundRow(t,o)}},n.prototype._addBoundRow=function(e,i){this.rows.push(new t.Row(e[i]))},n.prototype._addNode=function(i,o,n){var r=new t.GroupRow,s=this.childItemsPath,l=e.isArray(s)?s[n]:s,a=i[o],c=a[l];if(r.dataItem=a,r.level=n,this.rows.push(r),e.isArray(c))for(var h=0;h<c.length;h++)this._addNode(c,h,n+1)},n.prototype._addGroup=function(e){var i=new t.GroupRow;if(i.level=e.level,i.dataItem=e,this.rows.push(i),e.isBottomLevel)for(var o=e.items,n=0;n<o.length;n++)this._addBoundRow(o,n);else for(n=0;n<e.groups.length;n++)this._addGroup(e.groups[n])},n._getSerializableProperties=function(e){var t=[];for(e=e.prototype;e!=Object.prototype;e=Object.getPrototypeOf(e))for(var i=Object.getOwnPropertyNames(e),o=0;o<i.length;o++){var n=i[o],r=Object.getOwnPropertyDescriptor(e,n);r&&r.set&&r.get&&"_"!=n[0]&&!n.match(/disabled|required/)&&t.push(n)}return t},n.prototype._copy=function(i,o){if("columns"==i){this.columns.clear();for(var n=e.asArray(o),r=0;r<n.length;r++){var s=new t.Column;e.copy(s,n[r]),this.columns.push(s)}return!0}return!1},n.prototype._isInputElement=function(e){if(e instanceof HTMLElement){if("true"==e.contentEditable)return!0;var t=e.tagName.match(/^(BUTTON|A|INPUT|TEXTAREA|SELECT|OPTION)$/i);return t&&t.length>0}return!1},n.prototype._wantsInput=function(t){return this._isInputElement(t)&&!this.activeEditor&&!this._edtHdl._isNativeCheckbox(t)&&!e.hasClass(t,"wj-grid-ime")&&e.contains(document.body,t)},n._getMaxSupportedCssHeight=function(){if(!n._maxCssHeight){var t=335e5;e.isIE()?t=15e5:e.isFirefox()&&(t=175e5),n._maxCssHeight=t}return n._maxCssHeight},n._getRtlMode=function(){if(!n._rtlMode){var t=e.createElement('<div dir="rtl" style="visibility:hidden;width:100px;height:100px;overflow:auto"><div style="width:2000px;height:2000px"></div></div>');document.body.appendChild(t);var i=t.scrollLeft;t.scrollLeft=-1e3;var o=t.scrollLeft;e.removeChild(t),n._rtlMode=o<0?"neg":i>0?"rev":"std"}return n._rtlMode},n._WJS_STICKY="wj-state-sticky",n._WJS_MEASURE="wj-state-measuring",n._WJS_UPDATING="wj-state-updating",n._MIN_VIRT_ROWS=200,n.controlTemplate='<div style="position:relative;width:100%;height:100%;overflow:hidden;max-width:inherit;max-height:inherit"><div wj-part="focus" aria-hidden="true" class="wj-cell" style="position:fixed;opacity:0;pointer-events:none;left:-10px;top:-10px">0</div><div wj-part="root" style="position:absolute;width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch;max-width:inherit;max-height:inherit"><div wj-part="cells" class="wj-cells" style="position:absolute"></div><div wj-part="marquee" aria-hidden="true" class="wj-marquee" style="display:none;pointer-events:none;"><div style="width:100%;height:100%"></div></div></div><div wj-part="fcells" aria-hidden="true" class="wj-cells" style="position:absolute;pointer-events:none;overflow:hidden"></div><div wj-part="rh" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none"><div wj-part="rhcells" class="wj-rowheaders" style="position:relative"></div></div><div wj-part="cf" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none"><div wj-part="cfcells" class="wj-colfooters" style="position:relative"></div></div><div wj-part="ch" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none"><div wj-part="chcells" class="wj-colheaders" style="position:relative"></div></div><div wj-part="bl" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none"><div wj-part="blcells" class="wj-bottomleft" style="position:relative"></div></div><div wj-part="tl" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none"><div wj-part="tlcells" class="wj-topleft" style="position:relative"></div></div><div wj-part="sz" aria-hidden="true" style="position:relative;visibility:hidden"></div></div>',n}(e.Control);t.FlexGrid=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])};return function(t,i){function o(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(o.prototype=i.prototype,new o)}}(),wijmo;!function(e){!function(t){"use strict";var i=function(i){function o(o,n,r){var s=i.call(this)||this;return s._p=e.asType(o,t.GridPanel),s._rng=e.asType(n,t.CellRange),s._data=r,s}return __extends(o,i),Object.defineProperty(o.prototype,"panel",{get:function(){return this._p},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"range",{get:function(){return this._rng.clone()},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"row",{get:function(){return this._rng.row},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"col",{get:function(){return this._rng.col},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"data",{get:function(){return this._data},set:function(e){this._data=e},enumerable:!0,configurable:!0}),o}(e.CancelEventArgs);t.CellRangeEventArgs=i;var o=function(t){function i(i,o,n){var r=t.call(this,i,o)||this;return r._cell=e.asType(n,HTMLElement),r}return __extends(i,t),Object.defineProperty(i.prototype,"cell",{get:function(){return this._cell},enumerable:!0,configurable:!0}),i}(i);t.FormatItemEventArgs=o;var n=function(t){function i(){var e=null!==t&&t.apply(this,arguments)||this;return e._stayInEditMode=!1,e._refresh=!0,e}return __extends(i,t),Object.defineProperty(i.prototype,"stayInEditMode",{get:function(){return this._stayInEditMode},set:function(t){this._stayInEditMode=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"refresh",{get:function(){return this._refresh},set:function(t){this._refresh=e.asBoolean(t)},enumerable:!0,configurable:!0}),i}(i);t.CellEditEndingEventArgs=n}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None",e[e.Cell=1]="Cell",e[e.ColumnHeader=2]="ColumnHeader",e[e.RowHeader=3]="RowHeader",e[e.TopLeft=4]="TopLeft",e[e.ColumnFooter=5]="ColumnFooter",e[e.BottomLeft=6]="BottomLeft"}(i=t.CellType||(t.CellType={}));var o=function(){function o(i,o,n,r,s){this._offsetY=0,this._g=e.asType(i,t.FlexGrid),this._ct=e.asInt(o),this._rows=e.asType(n,t.RowCollection),this._cols=e.asType(r,t.ColumnCollection),this._e=e.asType(s,HTMLElement),this._vrb=new t.CellRange}return Object.defineProperty(o.prototype,"grid",{get:function(){return this._g},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"cellType",{get:function(){return this._ct},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"viewRange",{get:function(){return this._getViewRange()},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"width",{get:function(){return this._cols.getTotalSize()},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"height",{get:function(){return this._rows.getTotalSize()},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"rows",{get:function(){return this._rows},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"columns",{get:function(){return this._cols},enumerable:!0,configurable:!0}),o.prototype.getCellData=function(o,n,r){var s,l=this._rows[e.asNumber(o,!1,!0)],a=null;if(e.isString(n)&&(n=this._cols.indexOf(n))<0)throw"Invalid column name or binding.";s=this._cols[e.asNumber(n,!1,!0)];var c=this._g?this._g._getBindingColumn(this,o,s):s;if(!c.binding||!l.dataItem||l.dataItem instanceof e.collections.CollectionViewGroup?l._ubv&&(a=l._ubv[s._hash]):a=c._binding.getValue(l.dataItem),null==a)switch(this._ct){case i.ColumnHeader:o!=this._rows.length-1&&c==s||(a=c.header);break;case i.ColumnFooter:if(c.aggregate!=e.Aggregate.None&&l instanceof t.GroupRow){var h=this._g.collectionView;if(h){var u=e.tryCast(h,e.collections.CollectionView);a=u?u.getAggregate(c.aggregate,c.binding):e.getAggregate(c.aggregate,h.items,c.binding)}}break;case i.Cell:if(c.aggregate!=e.Aggregate.None&&l instanceof t.GroupRow){var d=e.tryCast(l.dataItem,e.collections.CollectionViewGroup);d&&(a=d.getAggregate(c.aggregate,c.binding,this._g.collectionView))}}return r&&(this.cellType==i.Cell&&c.dataMap&&(a=c.dataMap.getDisplayValue(a)),a=null!=a?e.Globalize.format(a,c.format):""),a},o.prototype.setCellData=function(t,o,n,r,s){void 0===r&&(r=!0),void 0===s&&(s=!0);var l,a=this._rows[e.asNumber(t,!1,!0)];if(e.isString(o)&&(o=this._cols.indexOf(o))<0)throw"Invalid column name or binding.";l=this._cols[e.asNumber(o,!1,!0)];var c=this._g?this._g._getBindingColumn(this,t,l):l;if(this._ct==i.Cell){if(c.dataMap&&null!=n&&(c.isRequired||""!=n)){var h=c.dataMap,u=h.getKeyValue(n);if(null==u&&null==h.getDisplayValue(null)){if(null==h.getDisplayValue(n)&&(!h.isEditable||h.displayMemberPath!=h.selectedValuePath))return!1}else n=u}var d=e.DataType.Object;if(c.dataType)d=c.dataType;else{var g=this.getCellData(t,o,!1);d=e.getType(g)}if(e.isBoolean(c.isRequired))if(c.isRequired||""!==n&&null!==n){if(c.isRequired&&(""===n||null===n))return!1}else n=null,r=!1;if(r&&(n=e.changeType(n,d,c.format),d!=e.DataType.Object&&e.getType(n)!=d))return!1}if(a.dataItem&&c.binding){var p=c._binding,f=a.dataItem,_=p.getValue(f);if(n!==_&&!e.DateTime.equals(n,_)){p.setValue(f,n);var w=this._g.collectionView;if(w instanceof e.collections.CollectionView&&f!=w.currentEditItem){var m=new e.collections.NotifyCollectionChangedEventArgs(e.collections.NotifyCollectionChangedAction.Change,f,w.items.indexOf(f));w.onCollectionChanged(m)}}}else a._ubv||(a._ubv={}),a._ubv[l._hash]=n;return s&&this._g&&this._g.invalidate(),!0},o.prototype.getCellBoundingRect=function(t,i,o){var n=this.rows[t],r=this.columns[i],s=new e.Rect(r.pos,n.pos,r.renderSize,n.renderSize);if(this._g.rightToLeft&&(s.left=this.hostElement.clientWidth-s.right,!e.isIE()&&!e.isFirefox())){var l=this.hostElement.parentElement;s.left-=l.offsetWidth-l.clientWidth}if(!o){var a=this.hostElement.getBoundingClientRect();s.left+=a.left,s.top+=a.top-this._offsetY}return t<this.rows.frozen&&(s.top-=this._g.scrollPosition.y),i<this.columns.frozen&&(s.left-=this._g.scrollPosition.x*(this._g.rightToLeft?-1:1)),s},o.prototype.getCellElement=function(e,t){for(var i=this.hostElement.children,n=Math.min(e+2,i.length),r=0;r<n;r++)for(var s=i[r].children,l=Math.min(t+2,s.length),a=0;a<l;a++){var c=s[a],h=c[o._INDEX_KEY];if(h&&(h.row==e&&h.col==t||h.rng&&h.rng.contains(e,t)))return c}return null},o.prototype.getSelectedState=function(e,o,n){var r=this._g,s=r.selectionMode,l=r._selHdl.selection,a=t.SelectionMode,c=t.SelectedState;if(s!=a.None)switch(this._ct){case i.Cell:if(n||(n=r.getMergedRange(this,e,o)),n){if(n.contains(l.row,l.col))return r.showMarquee?c.None:c.Cursor;if(n.intersects(l))return c.Selected}if(l.row==e&&l.col==o)return r.showMarquee?c.Active:c.Cursor;if(r.rows[e].isSelected||r.columns[o].isSelected)return c.Selected;if(n)switch(s){case a.Row:case a.RowRange:case a.ListBox:if(n.containsRow(l.row))return c.Selected}return l=r._selHdl._adjustSelection(l),s==t.SelectionMode.ListBox?c.None:l.containsRow(e)&&l.containsColumn(o)?c.Selected:c.None;case i.ColumnHeader:if(r.showSelectedHeaders&t.HeadersVisibility.Column&&(r.columns[o].isSelected||l.containsColumn(o)||l.intersectsColumn(n))&&(n&&(e=n.bottomRow),e==this.rows.length-1))return c.Selected;break;case i.RowHeader:if(r.showSelectedHeaders&t.HeadersVisibility.Row&&(r.rows[e].isSelected||l.containsRow(e)||l.intersectsRow(n))&&(n&&(o=n.rightCol),o==this.columns.length-1))return c.Selected}return c.None},Object.defineProperty(o.prototype,"hostElement",{get:function(){return this._e},enumerable:!0,configurable:!0}),o.prototype._getOffsetY=function(){return this._offsetY},o.prototype._updateContent=function(e,o,n){var r=this._g,s=this._e,l=this._rows,a=this._cols,c=this._ct;if(c==i.ColumnHeader||c==i.ColumnFooter||c==i.RowHeader){var h=r._ptScrl,u=s.style;c==i.RowHeader?u.top=h.y+"px":r.rightToLeft?u.right=h.x+"px":u.left=h.x+"px"}this._offsetY!=n&&(e=!1,this._offsetY=n);var d=this._getViewRange(),g=d;if(l.length<=r.virtualizationThreshold)g=new t.CellRange(0,0,l.length-1,a.length-1);else if(g.isValid&&r.isTouching){g=new t.CellRange(Math.max(d.row-6,l.frozen),Math.max(d.col-1,a.frozen),Math.min(d.row2+6,l.length-1),Math.min(d.col2+1,a.length-1))}if(e&&!o&&this._vrb.contains(d)&&!l.frozen&&!a.frozen)return this._activeCell;e&&g.equals(this._vrb)||(o=!1),e&&!o&&this._ct!=i.TopLeft&&this._reorderCells(g,this._vrb),this._activeCell=null,this._vru=d,this._vrb=g,this._cf=r.cellFactory;var p=0;this._ct==i.Cell&&(p=this._renderColHdrRow(g,o));for(f=0;f<l.frozen&&f<l.length;f++)p=this._renderRow(f,g,o,p);for(var f=g.topRow;f<=g.bottomRow&&f>-1;f++)p=this._renderRow(f,g,o,p);for(;s.childElementCount>p;){var _=s.lastElementChild;s.removeChild(_),this._removeExtraCells(_,0)}return this._activeCell},o.prototype._updateScrollPosition=function(){var e=this._g,t=e._ptScrl,o=this.hostElement.style;this.cellType==i.RowHeader?o.top=t.y+"px":e.rightToLeft?o.right=t.x+"px":o.left=t.x+"px"},o.prototype._clearCells=function(){for(var e=this.hostElement,t=e.childElementCount-1;t>=0;t--){var i=e.children[t];e.removeChild(i);for(var o=i.childElementCount-1;o>=0;o--)this._cf.disposeCell(i.children[o])}},o.prototype._reorderCells=function(e,t){if(!(this._rows.frozen>0||this._cols.frozen>0||e.columnSpan!=t.columnSpan||e.rowSpan!=t.rowSpan)&&t.isValid&&e.isValid&&e.intersects(t)&&e.row!=t.row){var o=e.row-t.row,n=Math.max(1,e.rowSpan-1),r=this._e;if(0!=o&&Math.abs(o)<n){var s=this._ct==i.Cell?1:0,l=r.childElementCount;if(o>0){var a=s,c=Math.min(s+o,l-1);(h=this._createRange(a,c))&&c<l-1&&r.appendChild(h.extractContents())}if(o<0){var c=l,a=Math.max(s,c+o),h=this._createRange(a,c);if(h&&a>s){var u=r.children[s];r.insertBefore(h.extractContents(),u)}}}}},o.prototype._createRange=function(e,t){var i,o=this._e.childElementCount;return t>e&&t<=o&&e>-1&&((i=document.createRange()).setStart(this._e,e),i.setEnd(this._e,t)),i},o.prototype._renderColHdrRow=function(t,i){var o=this._e.children[0];o||(o=e.createElement('<div class="wj-row" tabindex="-1" role="row"></div>',this._e)),e.setAttribute(o,"aria-selected",null);var n=0,r=this._g._getRowHeaderPath();r&&(n=this._renderRowHdrCell(o,-1,r.path));for(s=0;s<this.columns.frozen&&s<this.columns.length;s++)n=this._renderColHdrCell(o,s,t,i,n);for(var s=t.leftCol;s<=t.rightCol&&s>-1;s++)n=this._renderColHdrCell(o,s,t,i,n);return this._removeExtraCells(o,n),1},o.prototype._renderColHdrCell=function(t,i,n,r,s){var l=this.columns[i];if(l.renderSize<=0)return s;var a=t.children[s];a||(a=e.createElement('<div class="wj-cell" tabindex="-1" role="columnheader"></div>',t)),r||(a.textContent=this.columns[i].header,e.setCss(a,{position:"fixed",top:-32e3,height:.1,left:l.pos,width:l.renderWidth,overflow:"hidden",opacity:"0",pointerEvents:"none"}));var c=this.grid;if(c.allowSorting){var h="none";switch(c._getBindingColumn(this,0,l).currentSort){case"+":h="ascending";break;case"-":h="descending"}e.setAttribute(a,"aria-sort",h)}return c.isReadOnly||(e.setAttribute(a,"aria-readonly",l.isReadOnly),e.setAttribute(a,"aria-required",l.getIsRequired())),a[o._INDEX_KEY]={row:-1,col:i,panel:this},s+1},o.prototype._renderRowHdrCell=function(t,i,n){var r=t.children[0];return r||(r=e.createElement('<div class="wj-cell" tabindex="-1"></div>',t)),r.setAttribute("role",i<0?"columnheader":"rowheader"),r.textContent=n?n.toString():"",e.setCss(r,{position:"fixed",left:-32e3,top:-32e3,width:.1,height:.1,overflow:"hidden",opacity:"0"}),r[o._INDEX_KEY]={row:i,col:-1,panel:this},1},o.prototype._renderRow=function(o,n,r,s){var l=this._g,a=this.rows[o];if(a.renderSize<=0)return s;var c=this._e.children[s];if(c||(c=e.createElement('<div class="wj-row" tabindex="-1"></div>',this._e),this._ct==i.Cell&&c.setAttribute("role","row")),this._ct==i.Cell){var h=t.SelectionMode;switch(l.selectionMode){case h.Row:case h.RowRange:case h.ListBox:var u=a.isSelected||this._g._selHdl.selection.containsRow(o);e.setAttribute(c,"aria-selected",!!u)}e.setAttribute(c,"aria-level",a instanceof t.GroupRow?a.level+1:null),e.setAttribute(c,"aria-expanded",a instanceof t.GroupRow?!a.isCollapsed:null)}var d=0;if(this._ct==i.Cell){var g=this._g._getRowHeaderPath();g&&(d=this._renderRowHdrCell(c,o,g.getValue(a.dataItem)))}for(p=0;p<this.columns.frozen&&p<this.columns.length;p++)d=this._renderCell(c,o,p,n,r,d);for(var p=n.leftCol;p<=n.rightCol&&p>-1;p++)d=this._renderCell(c,o,p,n,r,d);return this._removeExtraCells(c,d),s+1},o.prototype._renderCell=function(n,r,s,l,a,c){var h=this._g,u=h.getMergedRange(this,r,s);if(u){for(d=Math.max(l.row,u.row);d<r;d++)if(this.rows[d].isVisible)return c;for(var d=Math.max(l.col,u.col);d<s;d++)if(this.columns[d].isVisible)return c}var g=this.columns[s];if(g.renderSize<=0&&(!u||u.getRenderSize(this).width<=0))return c;var p=n.children[c],f=t.SelectedState,_=this.getSelectedState(r,s,u),w=_==f.Cursor||_==f.Active;return p&&a?(e.toggleClass(p,"wj-state-active",w),e.toggleClass(p,"wj-state-selected",_==f.Cursor),e.toggleClass(p,"wj-state-multi-selected",_==f.Selected),w&&(this._activeCell=p),c+1):(p||((p=document.createElement("div")).tabIndex=-1,this._ct==i.Cell&&p.setAttribute("role","gridcell"),n.appendChild(p)),w&&(this._activeCell=p),h.cellFactory.updateCell(this,r,s,p,u),p[o._INDEX_KEY]={row:r,col:s,rng:u,panel:this},this._ct==i.Cell&&(e.setAttribute(p,"aria-selected",_!=f.None),e.setAttribute(p,"aria-readonly",!h.canEditCell(r,s)||null),e.setAttribute(p,"aria-required",g.getIsRequired())),c+1)},o.prototype._removeExtraCells=function(e,t){for(;e.childElementCount>t;){var i=e.lastElementChild;e.removeChild(i),this._cf.disposeCell(i)}},o.prototype._getViewRange=function(){var e=this._g,o=e._ptScrl,n=this._rows,r=this._cols,s=new t.CellRange(0,0,n.length-1,r.length-1);if(this._ct==i.Cell||this._ct==i.RowHeader){var l=-o.y+this._offsetY,a=e._szClient.height;if((d=Math.min(n.frozen,n.length-1))>0&&(l+=g=n[d-1].pos,a-=g),s.row=Math.min(n.length-1,Math.max(n.frozen,n.getItemAt(l+1))),s.row2=n.getItemAt(l+a+1),e._clipToScreen){var c=e.hostElement.getBoundingClientRect();c.top<0&&(s.row=Math.max(s.row,n.getItemAt(-c.top-e._ptScrl.y)-1)),c.bottom>innerHeight&&(s.row2=Math.min(s.row2,n.getItemAt(-c.top-e._ptScrl.y+innerHeight)+1))}}if(this._ct==i.Cell||this._ct==i.ColumnHeader){var h=-o.x,u=e._szClient.width,d=Math.min(r.frozen,r.length-1);if(d>0){var g=r[d-1].pos;h+=g,u-=g}s.col=Math.min(r.length-1,Math.max(r.frozen,r.getItemAt(h+1))),s.col2=r.getItemAt(h+u+1)}return n.length<=n.frozen&&(s.row=s.row2=-1),r.length<=r.frozen&&(s.col=s.col2=-1),s},o.prototype._getFrozenPos=function(){var t=this._rows.frozen,i=this._cols.frozen,o=t>0?this._rows[t-1]:null,n=i>0?this._cols[i-1]:null,r=o?o.pos+o.renderSize:0,s=n?n.pos+n.renderSize:0;return new e.Point(s,r)},o._INDEX_KEY="wj-cell-index",o}();t.GridPanel=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i=function(){function i(){}return i.prototype.updateCell=function(o,n,r,s,l,a){var c=o.grid,h=c.rightToLeft,u=t.CellType,d=o.rows,g=o.columns,p=d[n],f=g[r],_=n,w=r,m=p instanceof t.GroupRow?p:null,y=p instanceof t._NewRowTemplate?p:null,v=f.renderWidth,C=p.renderHeight,b=o.cellType,R="wj-cell",E={display:""};if(0!=a&&s.firstElementChild&&(1==s.childNodes.length&&"checkbox"==s.firstElementChild.type||(s.textContent="")),l&&!l.isSingleCell){n=l.row,r=l.col,_=l.row2,w=l.col2,p=d[n],f=g[r],m=p instanceof t.GroupRow?p:null;var S=l.getRenderSize(o);C=S.height,v=S.width}var x=c._getBindingColumn(o,n,f),z=x.dataType==e.DataType.Boolean&&!x.dataMap,T=f.pos,H=p.pos;if(c._useFrozenDiv()&&b==u.Cell&&!c.editRange?(n<d.frozen&&r>=g.frozen&&(T+=c._ptScrl.x),r<g.frozen&&n>=d.frozen&&(H+=c._ptScrl.y)):(n<d.frozen&&(H-=c._ptScrl.y),r<g.frozen&&(T-=c._ptScrl.x)),h?E.right=T+"px":E.left=T+"px",E.top=H-o._getOffsetY()+"px",E.width=v+"px",E.height=C+"px",E.zIndex="",(n<d.frozen||r<g.frozen)&&(E.zIndex=n<d.frozen&&r<g.frozen?2:1),b==u.Cell?(m&&(R+=" wj-group"),c.showAlternatingRows&&p.visibleIndex%2!=0&&(l&&l.row!=l.row2||(R+=" wj-alt")),(n<d.frozen||r<g.frozen)&&(R+=" wj-frozen"),y&&(R+=" wj-new"),p.cssClass&&(R+=" "+p.cssClass),x.cssClass&&(R+=" "+x.cssClass)):(R+=" wj-header",c.showAlternatingRows&&n%2!=0&&(R+=" wj-header-alt")),(b==u.Cell||b==u.RowHeader)&&c._getShowErrors()){var P=c._getError(o,n,r);e.setAttribute(s,"title",P),P&&(R+=" wj-state-invalid")}var M=t.SelectedState,j=o.getSelectedState(n,r,l);switch(j!=M.None&&b==u.Cell&&!z&&c.editRange&&c.editRange.contains(n,r)&&(j=M.None),j){case M.Active:R+=" wj-state-active";break;case M.Cursor:R+=" wj-state-selected wj-state-active";break;case M.Selected:R+=" wj-state-multi-selected"}if(_==d.frozen-1&&(R+=" wj-frozen-row"),w==g.frozen-1&&(R+=" wj-frozen-col"),(x.wordWrap||p.wordWrap)&&(R+=" wj-wrap"),(x.multiLine||p.multiLine)&&(R+=" wj-multiline"),E.textAlign=x.getAlignment(),E.textAlignLast=E.textJustify="","justify-all"==E.textAlign&&(E.textAlign=E.textAlignLast="justify",E.textJustify="distribute"),E.paddingLeft=E.paddingRight=E.paddingTop=E.paddingBottom="",b==u.Cell&&c.rows.maxGroupLevel>-1&&r==c.columns.firstVisibleIndex&&c.treeIndent){var A=m?Math.max(0,m.level):c.rows.maxGroupLevel+1,D=c.treeIndent*A+c._cellPadding;h?E.paddingRight=D+"px":E.paddingLeft=D+"px"}if(0!=a){var O=o.getCellData(n,r,!1),L=o.getCellData(n,r,!0);if(b==u.Cell&&r==c.columns.firstVisibleIndex&&m&&m.hasChildren&&!this._isEditingCell(c,n,r))L||(L=m.getGroupHeader()),s.innerHTML=this._getTreeIcon(m)+" "+L,E.textAlign="";else if(b==u.ColumnHeader&&x.currentSort&&c.showSort&&(_==c._getSortRowIndex()||x!=f))R+=" wj-sort-"+("+"==x.currentSort?"asc":"desc"),s.innerHTML=e.escapeHtml(L)+"&nbsp;"+this._getSortIcon(x);else if(b!=u.RowHeader||r!=c.rowHeaders.columns.length-1||L)if(b!=u.Cell||x.dataType!=e.DataType.Boolean||x.dataMap||m&&!e.isBoolean(O))if(b==u.Cell&&this._isEditingCell(c,n,r)){var I=x.inputType;if(x.inputType||(I=x.dataType!=e.DataType.Number||x.dataMap?"text":"tel"),!x.dataMap&&!x.mask){var N=o.getCellData(n,r,!1);if(e.isNumber(N)){var B=N.toString(),k=x.format;if(k&&N!=Math.round(N)){var F=B.match(/\.(\d+)/)[1].length;k=k.replace(/([a-z])(\d*)(.*)/gi,"$01"+F+"$3")}L=e.Globalize.formatNumber(N,k,!0)}}s.innerHTML=(x.multiLine||p.multiLine)&&"checkbox"!=I?"<textarea></textarea>":'<input type="'+I+'"/>';var V=s.children[0];e.addClass(V,"wj-grid-editor wj-form-control"),e.disableAutoComplete(V),V.value=L,V.required=x.getIsRequired(),x.maxLength&&(V.maxLength=x.maxLength),V.style.textAlign=x.getAlignment(),E.paddingTop=E.paddingBottom="0px",x.mask&&new e._MaskProvider(V,x.mask),c._edtHdl._edt=V}else b==u.Cell&&(p.isContentHtml||x.isContentHtml)?s.innerHTML=L:s.textContent=L||"";else{var G=s.firstChild;G instanceof HTMLInputElement&&"checkbox"==G.type||(s.innerHTML='<input type="checkbox" class="wj-cell-check" tabindex="-1"/>',G=s.firstChild),G.checked=1==O,G.indeterminate=null==O,G.disabled=!c.canEditCell(n,r),G.disabled&&(G.style.cursor="default"),c.editRange&&c.editRange.contains(n,r)&&(c._edtHdl._edt=G)}else{var K=c.editableCollectionView,W=K?K.currentEditItem:null;W&&p.dataItem==W?s.innerHTML='<span class="wj-glyph-pencil"></span>':p instanceof t._NewRowTemplate&&(s.innerHTML='<span class="wj-glyph-asterisk"></span>')}if(b==u.Cell&&e.input&&x.dataMap&&c.showDropDown&&0!=x.showDropDown&&c.canEditCell(n,r)){i._ddIcon||(i._ddIcon=e.createElement('<div role="button" class="'+i._WJC_DROPDOWN+'"><span class="wj-glyph-down"></span></div>'));var q=i._ddIcon.cloneNode(!0);s.appendChild(q)}}var U=!1;switch(b){case u.RowHeader:U=!m&&!y&&p.allowDragging&&0!=(c.allowDragging&t.AllowDragging.Rows),e.setAttribute(s,"draggable",U?"true":null);break;case u.ColumnHeader:U=f.allowDragging&&0!=(c.allowDragging&t.AllowDragging.Columns),e.setAttribute(s,"draggable",U?"true":null)}s.className!=R&&(s.className=R);var Y=s.style;for(var J in E)Y[J]=E[J];if(c._edtHdl._edt&&c._edtHdl._edt.parentElement==s){var X=c._root,Z=X.getBoundingClientRect(),Q=s.getBoundingClientRect(),$=Z.top+X.clientHeight-Q.top,ee=Z.left+X.clientWidth-Q.left;Q.height>$&&(s.style.height=$+"px"),Q.width>ee&&(s.style.width=ee+"px")}if(c.itemFormatter&&c.itemFormatter(o,n,r,s),c.formatItem.hasHandlers){var te=i._fmtRng;te?te.setRange(n,r,_,w):te=i._fmtRng=new t.CellRange(n,r,_,w);var ie=new t.FormatItemEventArgs(o,te,s);c.onFormatItem(ie)}},i.prototype.disposeCell=function(e){},i.prototype.getEditorValue=function(t){var i=t._edtHdl._edt;if(i instanceof HTMLInputElement&&"checkbox"==i.type)return i.checked;if(i instanceof HTMLInputElement||i instanceof HTMLTextAreaElement){var o=i.maxLength;return e.isNumber(o)&&o>-1&&i.value.length>o?i.value.substr(0,o):i.value}return null},i.prototype._isEditingCell=function(e,t,i){return e.editRange&&e.editRange.contains(t,i)},i.prototype._getTreeIcon=function(e){var t="wj-glyph-"+(e.isCollapsed?"":"down-")+(e.grid.rightToLeft?"left":"right");return'<span class="'+i._WJC_COLLAPSE+" "+t+'"></span>'},i.prototype._getSortIcon=function(e){return'<span class="wj-glyph-'+("+"==e.currentSort?"up":"down")+'"></span>'},i._WJC_COLLAPSE="wj-elem-collapse",i._WJC_DROPDOWN="wj-elem-dropdown",i}();t.CellFactory=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i=function(){function t(e,t,i,o){void 0===e&&(e=-1),void 0===t&&(t=-1),void 0===i&&(i=e),void 0===o&&(o=t),this.setRange(e,t,i,o)}return t.prototype.setRange=function(t,i,o,n){void 0===t&&(t=-1),void 0===i&&(i=-1),void 0===o&&(o=t),void 0===n&&(n=i),this._row=e.asInt(t),this._col=e.asInt(i),this._row2=e.asInt(o),this._col2=e.asInt(n)},Object.defineProperty(t.prototype,"row",{get:function(){return this._row},set:function(t){this._row=e.asInt(t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"col",{get:function(){return this._col},set:function(t){this._col=e.asInt(t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"row2",{get:function(){return this._row2},set:function(t){this._row2=e.asInt(t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"col2",{get:function(){return this._col2},set:function(t){this._col2=e.asInt(t)},enumerable:!0,configurable:!0}),t.prototype.clone=function(){return new t(this._row,this._col,this._row2,this._col2)},Object.defineProperty(t.prototype,"rowSpan",{get:function(){return Math.abs(this._row2-this._row)+1},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"columnSpan",{get:function(){return Math.abs(this._col2-this._col)+1},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"topRow",{get:function(){return Math.min(this._row,this._row2)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bottomRow",{get:function(){return Math.max(this._row,this._row2)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"leftCol",{get:function(){return Math.min(this._col,this._col2)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"rightCol",{get:function(){return Math.max(this._col,this._col2)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isValid",{get:function(){return this._row>-1&&this._col>-1&&this._row2>-1&&this._col2>-1},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSingleCell",{get:function(){return this._row==this._row2&&this._col==this._col2},enumerable:!0,configurable:!0}),t.prototype.contains=function(i,o){var n=e.tryCast(i,t);if(n)return n.topRow>=this.topRow&&n.bottomRow<=this.bottomRow&&n.leftCol>=this.leftCol&&n.rightCol<=this.rightCol;if(e.isInt(i)&&e.isInt(o))return i>=this.topRow&&i<=this.bottomRow&&o>=this.leftCol&&o<=this.rightCol;throw"contains expects a CellRange or row/column indices."},t.prototype.containsRow=function(t){return e.asInt(t)>=this.topRow&&t<=this.bottomRow},t.prototype.containsColumn=function(t){return e.asInt(t)>=this.leftCol&&t<=this.rightCol},t.prototype.intersects=function(e){return this.intersectsRow(e)&&this.intersectsColumn(e)},t.prototype.intersectsRow=function(e){return e&&!(this.bottomRow<e.topRow||this.topRow>e.bottomRow)},t.prototype.intersectsColumn=function(e){return e&&!(this.rightCol<e.leftCol||this.leftCol>e.rightCol)},t.prototype.getRenderSize=function(t){var i=new e.Size(0,0);if(this.isValid){for(var o=this.topRow;o<=this.bottomRow;o++)i.height+=t.rows[o].renderSize;for(var n=this.leftCol;n<=this.rightCol;n++)i.width+=t.columns[n].renderSize}return i},t.prototype.equals=function(e){return e instanceof t&&this._row==e._row&&this._col==e._col&&this._row2==e._row2&&this._col2==e._col2},t}();t.CellRange=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])};return function(t,i){function o(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(o.prototype=i.prototype,new o)}}(),wijmo;!function(e){!function(t){"use strict";var i;!function(e){e[e.Visible=1]="Visible",e[e.AllowResizing=2]="AllowResizing",e[e.AllowDragging=4]="AllowDragging",e[e.AllowMerging=8]="AllowMerging",e[e.AllowSorting=16]="AllowSorting",e[e.AutoGenerated=32]="AutoGenerated",e[e.Collapsed=64]="Collapsed",e[e.ParentCollapsed=128]="ParentCollapsed",e[e.Selected=256]="Selected",e[e.ReadOnly=512]="ReadOnly",e[e.HtmlContent=1024]="HtmlContent",e[e.WordWrap=2048]="WordWrap",e[e.MultiLine=4096]="MultiLine",e[e.HasTemplate=8192]="HasTemplate",e[e.RowDefault=3]="RowDefault",e[e.ColumnDefault=23]="ColumnDefault"}(i=t.RowColFlags||(t.RowColFlags={}));var o=function(){function o(){this._list=null,this._pos=0,this._idx=-1,this._vidx=-1}return Object.defineProperty(o.prototype,"visible",{get:function(){return this._getFlag(i.Visible)},set:function(e){this._setFlag(i.Visible,e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"isVisible",{get:function(){return!!this._getFlag(i.Visible)&&(!this._getFlag(i.ParentCollapsed)||this instanceof t._NewRowTemplate)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"pos",{get:function(){return this._list&&this._list._dirty&&this._list._update(),this._pos},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"index",{get:function(){return this._list&&this._list._dirty&&this._list._update(),this._idx},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"visibleIndex",{get:function(){return this._list&&this._list._dirty&&this._list._update(),this.isVisible?this._vidx:-1},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"size",{get:function(){return this._sz},set:function(t){t!=this._sz&&(this._sz=e.asNumber(t,!0),this.onPropertyChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"renderSize",{get:function(){if(!this.isVisible)return 0;var e=this._sz,t=this._list;return t&&((null==e||e<0)&&(e=Math.round(t.defaultSize)),null!=t.minSize&&e<t.minSize&&(e=t.minSize),null!=t.maxSize&&e>t.maxSize&&(e=t.maxSize)),null!=this._szMin&&e<this._szMin&&(e=this._szMin),null!=this._szMax&&e>this._szMax&&(e=this._szMax),Math.round(e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"allowResizing",{get:function(){return this._getFlag(i.AllowResizing)},set:function(e){this._setFlag(i.AllowResizing,e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"allowDragging",{get:function(){return this._getFlag(i.AllowDragging)},set:function(e){this._setFlag(i.AllowDragging,e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"allowMerging",{get:function(){return this._getFlag(i.AllowMerging)},set:function(e){this._setFlag(i.AllowMerging,e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"isSelected",{get:function(){return this._getFlag(i.Selected)},set:function(e){if(this._setFlag(i.Selected,e,!0)){var t=this.grid;t&&t.refreshCells(!1,!0,!0)}},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"isReadOnly",{get:function(){return this._getFlag(i.ReadOnly)},set:function(e){this._setFlag(i.ReadOnly,e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"isContentHtml",{get:function(){return this._getFlag(i.HtmlContent)},set:function(e){this.isContentHtml!=e&&(this._setFlag(i.HtmlContent,e),this.grid&&this.grid.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"wordWrap",{get:function(){return this._getFlag(i.WordWrap)},set:function(e){this._setFlag(i.WordWrap,e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"multiLine",{get:function(){return this._getFlag(i.MultiLine)},set:function(e){this._setFlag(i.MultiLine,e)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"cssClass",{get:function(){return this._cssClass},set:function(t){t!=this._cssClass&&(this._cssClass=e.asString(t),this.grid&&this.grid.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"grid",{get:function(){return this._list?this._list._g:null},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"collectionView",{get:function(){return this.grid?this.grid.collectionView:null},enumerable:!0,configurable:!0}),o.prototype.onPropertyChanged=function(){this._list&&(this._list._dirty=!0,this.grid.invalidate())},o.prototype._getFlag=function(e){return 0!=(this._f&e)},o.prototype._setFlag=function(e,t,i){return t!=this._getFlag(e)&&(this._f=t?this._f|e:this._f&~e,i||this.onPropertyChanged(),!0)},o}();t.RowCol=o;var n=function(o){function n(t){var r=o.call(this)||this;return r._f=i.ColumnDefault,r._hash=n._ctr.toString(36),n._ctr++,t&&e.copy(r,t),r}return __extends(n,o),Object.defineProperty(n.prototype,"name",{get:function(){return this._name},set:function(e){this._name=e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"dataType",{get:function(){return this._type},set:function(t){t=e.asEnum(t,e.DataType),this._type!=t&&(this._type=t,this.grid&&this.grid.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isRequired",{get:function(){return this._required},set:function(t){this._required=e.asBoolean(t,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showDropDown",{get:function(){return this._showDropDown},set:function(t){t!=this._showDropDown&&(this._showDropDown=e.asBoolean(t,!0),this.grid&&this.grid.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"dropDownCssClass",{get:function(){return this._ddCssClass},set:function(t){this._ddCssClass=e.asString(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"inputType",{get:function(){return this._inpType},set:function(t){this._inpType=e.asString(t,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"mask",{get:function(){return this._mask},set:function(t){this._mask=e.asString(t,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"maxLength",{get:function(){return this._maxLen},set:function(t){this._maxLen=e.asNumber(t,!0,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"binding",{get:function(){return this._binding?this._binding.path:null},set:function(t){if(t!=this.binding){var i=e.asString(t);if(this._binding=i?new e.Binding(i):null,!this._type&&this.grid&&this._binding){var o=this.grid.collectionView;if(o&&o.sourceCollection&&o.sourceCollection.length){var n=o.sourceCollection[0];this._type=e.getType(this._binding.getValue(n))}}this.onPropertyChanged()}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"sortMemberPath",{get:function(){return this._bindingSort?this._bindingSort.path:null},set:function(t){if(t!=this.sortMemberPath){var i=e.asString(t);this._bindingSort=i?new e.Binding(i):null,this.onPropertyChanged()}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"width",{get:function(){return null!=this._szStar?this._szStar:this.size},set:function(t){null!=n._parseStarSize(t)?(this._szStar=t,this.onPropertyChanged()):(this._szStar=null,this.size=e.asNumber(t,!0))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"minWidth",{get:function(){return this._szMin},set:function(t){t!=this._szMin&&(this._szMin=e.asNumber(t,!0,!0),this.onPropertyChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"maxWidth",{get:function(){return this._szMax},set:function(t){t!=this._szMax&&(this._szMax=e.asNumber(t,!0,!0),this.onPropertyChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"quickAutoSize",{get:function(){return this._quickSize},set:function(t){this._quickSize=e.asBoolean(t,!0)},enumerable:!0,configurable:!0}),n.prototype._getQuickAutoSize=function(){return!!this.grid._getQuickAutoSize()&&(e.isBoolean(this._quickSize)?this._quickSize:!(this.isContentHtml||this.wordWrap||this.multiLine||this._getFlag(i.HasTemplate)))},Object.defineProperty(n.prototype,"renderWidth",{get:function(){return this.renderSize},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"align",{get:function(){return this._align},set:function(e){this._align!=e&&(this._align=e,this.onPropertyChanged())},enumerable:!0,configurable:!0}),n.prototype.getAlignment=function(){var t=this._align;if(null==t&&(t="",!this._map))switch(this._type){case e.DataType.Boolean:t="center";break;case e.DataType.Number:t="right"}return t},n.prototype.getIsRequired=function(){return null!=this._required?this._required:this.dataType!=e.DataType.String||(null!=this.dataMap||null!=this._mask&&this._mask.length>0)},Object.defineProperty(n.prototype,"header",{get:function(){return this._hdr?this._hdr:this.binding},set:function(e){this._hdr!=e&&(this._hdr=e,this.onPropertyChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"dataMap",{get:function(){return this._map},set:function(i){this._map!=i&&(this._map&&this._map.mapChanged.removeHandler(this.onPropertyChanged,this),e.isArray(i)&&(i=new t.DataMap(i,null,null)),this._map=e.asType(i,t.DataMap,!0),this._map&&this._map.mapChanged.addHandler(this.onPropertyChanged,this),this.onPropertyChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"format",{get:function(){return this._fmt},set:function(e){this._fmt!=e&&(this._fmt=e,this.onPropertyChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"allowSorting",{get:function(){return this._getFlag(i.AllowSorting)},set:function(e){this._setFlag(i.AllowSorting,e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"currentSort",{get:function(){var e=this.grid?this.grid.collectionView:null,t=e?e.sortDescriptions:null,i=t&&t.length?this._getBindingSort():null;if(i)for(var o=0;o<t.length;o++)if(t[o].property==i)return t[o].ascending?"+":"-";return null},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"aggregate",{get:function(){return null!=this._agg?this._agg:e.Aggregate.None},set:function(t){(t=e.asEnum(t,e.Aggregate))!=this._agg&&(this._agg=t,this.onPropertyChanged())},enumerable:!0,configurable:!0}),n.prototype._getBindingSort=function(){return this.sortMemberPath?this.sortMemberPath:this.binding?this.binding:null},n._parseStarSize=function(t){if(e.isString(t)&&t.length>0&&"*"==t[t.length-1]){var i=1==t.length?1:1*t.substr(0,t.length-1);if(i>0&&!isNaN(i))return i}return null},n._ctr=0,n}(o);t.Column=n;var r=function(e){function t(t){var o=e.call(this)||this;return o._f=i.ColumnDefault,o._data=t,o}return __extends(t,e),Object.defineProperty(t.prototype,"dataItem",{get:function(){return this._data},set:function(e){this._data=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"height",{get:function(){return this.size},set:function(e){this.size=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"renderHeight",{get:function(){return this.renderSize},enumerable:!0,configurable:!0}),t}(o);t.Row=r;var s=function(o){function n(){var e=o.call(this)||this;return e._level=-1,e.isReadOnly=!0,e}return __extends(n,o),Object.defineProperty(n.prototype,"level",{get:function(){return this._level},set:function(t){e.asInt(t),t!=this._level&&(this._level=t,this.onPropertyChanged())},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"hasChildren",{get:function(){if(null!=this.grid&&null!=this._list){this._list._update();var i=this.index<this._list.length-1?this._list[this.index+1]:null,o=e.tryCast(i,n),r=e.tryCast(i,t._NewRowTemplate);return null!=i&&null==r&&(null==o||o.level>this.level)}return!0},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isCollapsed",{get:function(){return this._getFlag(i.Collapsed)},set:function(t){e.asBoolean(t),t!=this.isCollapsed&&null!=this._list&&this._setCollapsed(t)},enumerable:!0,configurable:!0}),n.prototype.getGroupHeader=function(){var t=this.grid,i=t.groupHeaderFormat?t.groupHeaderFormat:e.culture.FlexGrid.groupHeaderFormat,o=e.tryCast(this.dataItem,e.collections.CollectionViewGroup);if(o&&i){var n=o.groupDescription.propertyName,r=o.name,s=t.getColumn(n),l=this.isContentHtml;s&&(l=l||s.isContentHtml,s.header&&(n=s.header),s.dataMap?r=s.dataMap.getDisplayValue(r):s.format&&(r=e.Globalize.format(r,s.format)));var a=o.getAggregate(e.Aggregate.CntAll,null,t.collectionView);return e.format(i,{name:e.escapeHtml(n),value:l?r:e.escapeHtml(r),level:o.level,count:a})}return""},n.prototype._setCollapsed=function(e){var o=this,r=this.grid,s=r.rows,l=this.getCellRange(),a=new t.CellRangeEventArgs(r.cells,new t.CellRange(this.index,-1));r.onGroupCollapsedChanging(a)&&(r.deferUpdate(function(){s.deferUpdate(function(){o._setFlag(i.Collapsed,e,!0);for(var t=l.topRow+1;t<=l.bottomRow&&t>-1&&t<s.length;t++){s[t]._setFlag(i.ParentCollapsed,e,!0);var r=s[t];r instanceof n&&r.isCollapsed&&(t=r.getCellRange().bottomRow)}})}),r.onGroupCollapsedChanged(a))},n.prototype.getCellRange=function(){for(var i=this._list,o=this.index,r=i.length-1,s=o+1;s<=r;s++){var l=e.tryCast(i[s],n);if(null!=l&&l.level<=this.level){r=s-1;break}}return new t.CellRange(o,0,r,this.grid.columns.length-1)},n}(r);t.GroupRow=s;var l=function(i){function o(o,n){var r=i.call(this)||this;return r._frozen=0,r._vlen=0,r._szDef=28,r._szTot=0,r._dirty=!1,r._g=e.asType(o,t.FlexGrid),r._szDef=e.asNumber(n,!1,!0),r}return __extends(o,i),Object.defineProperty(o.prototype,"defaultSize",{get:function(){return this._szDef},set:function(t){this._szDef!=t&&(this._szDef=e.asNumber(t,!1,!0),this._dirty=!0,this._g.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"frozen",{get:function(){return this._frozen},set:function(t){t!=this._frozen&&(this._frozen=e.asNumber(t,!1,!0),this._dirty=!0,this._g.invalidate())},enumerable:!0,configurable:!0}),o.prototype.isFrozen=function(e){return e<this.frozen},Object.defineProperty(o.prototype,"minSize",{get:function(){return this._szMin},set:function(t){t!=this._szMin&&(this._szMin=e.asNumber(t,!0,!0),this._dirty=!0,this._g.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"maxSize",{get:function(){return this._szMax},set:function(t){t!=this._szMax&&(this._szMax=e.asNumber(t,!0,!0),this._dirty=!0,this._g.invalidate())},enumerable:!0,configurable:!0}),o.prototype.getTotalSize=function(){return this._dirty&&this._update(),this._szTot},Object.defineProperty(o.prototype,"visibleLength",{get:function(){return this._dirty&&this._update(),this._vlen},enumerable:!0,configurable:!0}),o.prototype.getItemAt=function(e){if(this._dirty&&this._update(),e<=0&&this.length>0)return 0;e=Math.round(e);for(var t,i,o=this.length,n=0,r=o-1;n<=r;)if(t=n+r>>>1,(i=this[t])._pos>e&&t>0)r=t-1;else{if(!(i._pos+i.renderSize<=e&&t<o-1)){for(;t>0&&!this[t].visible;)t--;for(;t<o-1&&!this[t].visible;)t++;return t}n=t+1}return r},o.prototype.getNextCell=function(e,i,o){var n;switch(i){case t.SelMove.Next:for(n=e+1;n<this.length;n++)if(this[n].renderSize>0)return n;break;case t.SelMove.Prev:for(n=e-1;n>=0;n--)if(this[n].renderSize>0)return n;break;case t.SelMove.End:for(n=this.length-1;n>=0;n--)if(this[n].renderSize>0)return n;break;case t.SelMove.Home:for(n=0;n<this.length;n++)if(this[n].renderSize>0)return n;break;case t.SelMove.NextPage:return(n=this.getItemAt(this[e].pos+o))<0?this.getNextCell(e,t.SelMove.End,o):n==e&&n<this.length-1?n+1:n;case t.SelMove.PrevPage:return(n=this.getItemAt(this[e].pos-o))<0?this.getNextCell(e,t.SelMove.Home,o):n==e&&n>0?n-1:n}return e},o.prototype.canMoveElement=function(e,i){if(i==e)return!1;if(e<0||e>=this.length||i>=this.length)return!1;i<0&&(i=this.length-1);for(var o=Math.min(e,i),n=Math.max(e,i),r=o;r<=n;r++)if(!this[r].allowDragging)return!1;return!(this[i]instanceof t._NewRowTemplate)},o.prototype.moveElement=function(e,t){if(this.canMoveElement(e,t)){var i=this[e];this.removeAt(e),t<0&&(t=this.length),this.insert(t,i)}},o.prototype.onCollectionChanged=function(t){void 0===t&&(t=e.collections.NotifyCollectionChangedEventArgs.reset),this._dirty=!0,this._g.invalidate(),i.prototype.onCollectionChanged.call(this,t)},o.prototype.push=function(e){return e._list=this,i.prototype.push.call(this,e)},o.prototype.splice=function(e,t,o){return o&&(o._list=this),i.prototype.splice.call(this,e,t,o)},o.prototype.beginUpdate=function(){this._update(),i.prototype.beginUpdate.call(this)},o.prototype._update=function(){if(this._dirty&&!this.isUpdating){this._dirty=!1;for(var e=0,t=0,i=void 0,o=void 0,n=0;n<this.length;n++)(o=this[n])._idx=n,o._vidx=e,o._list=this,o._pos=t,(i=o.renderSize)>0&&(t+=i,e++);return this._vlen=e,this._szTot=t,!0}return!1},o}(e.collections.ObservableArray);t.RowColCollection=l;var a=function(t){function i(){var e=null!==t&&t.apply(this,arguments)||this;return e._firstVisible=-1,e}return __extends(i,t),i.prototype.getColumn=function(t){var i=e.isNumber(t)?t:this.indexOf(t);return i>-1?this[i]:null},i.prototype.indexOf=function(e){if(e instanceof n)return t.prototype.indexOf.call(this,e);for(i=0;i<this.length;i++)if(this[i].name==e)return i;for(var i=0;i<this.length;i++)if(this[i].binding==e)return i;return-1},Object.defineProperty(i.prototype,"firstVisibleIndex",{get:function(){return this._dirty&&this._update(),this._firstVisible},enumerable:!0,configurable:!0}),i.prototype._update=function(){if(t.prototype._update.call(this)){this._firstVisible=-1;for(var e=0;e<this.length;e++)if(this[e].visible){this._firstVisible=e;break}return!0}return!1},i.prototype._updateStarSizes=function(e){for(var t,i=0,o=0;o<this.length;o++)(s=this[o]).isVisible&&(s._szStar?(i+=n._parseStarSize(s._szStar),t=s):e-=s.renderWidth);if(t){for(var r=e,o=0;o<this.length;o++){var s=this[o];s.isVisible&&s._szStar&&(s==t&&r>0?s._sz=r:(s._sz=Math.max(0,Math.round(n._parseStarSize(s._szStar)/i*e)),r-=s.renderWidth))}return this._dirty=!0,this._update(),!0}return!1},i}(l);t.ColumnCollection=a;var c=function(t){function i(){var e=null!==t&&t.apply(this,arguments)||this;return e._maxLevel=-1,e}return __extends(i,t),Object.defineProperty(i.prototype,"maxGroupLevel",{get:function(){return this._dirty&&this._update(),this._maxLevel},enumerable:!0,configurable:!0}),i.prototype._update=function(){if(t.prototype._update.call(this)){this._maxLevel=-1;for(var i=0;i<this.length;i++){var o=e.tryCast(this[i],s);o&&o.level>this._maxLevel&&(this._maxLevel=o.level)}return!0}return!1},i}(l);t.RowCollection=c}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){var t;!function(i){"use strict";var o=function(){function o(t,n){this._row=-1,this._col=-1,this._edge=0;var r;if(t instanceof Element)(H=(T=e.closest(t,".wj-cell"))?T[i.GridPanel._INDEX_KEY]:null)&&(this._row=H.row,this._col=H.col,this._rng=H.rng,this._p=H.panel,this._g=H.panel.grid);else{if(t instanceof i.FlexGrid)r=this._g=t;else{if(!(t instanceof i.GridPanel))throw"First parameter should be a FlexGrid or GridPanel.";this._p=t,r=this._g=this._p.grid}var s;n instanceof MouseEvent&&(s=n,"mousedown"==n.type&&(r._rcBounds=null)),n=e.mouseToPage(n),this._pt=n.clone();var l=r.controlRect,a=r._szClient,c=r.topLeftCells,h=r._eTL,u=r.headersVisibility,d=i.HeadersVisibility,g=u&d.Row?c.columns.getTotalSize():0,p=u&d.Column?c.rows.getTotalSize():0,f=u&d.Column?p+h.offsetTop:0,_=r._eBL,w=_.offsetHeight;if(n.x-=l.left,n.y-=l.top,this._g.rightToLeft&&(n.x=l.width-n.x),!this._p&&n.x>=0&&n.y>=h.offsetTop&&a&&n.x<=a.width+g&&n.y<=a.height+f&&(n.y<f?this._p=n.x<g?r.topLeftCells:r.columnHeaders:n.y<_.offsetTop?this._p=n.x<g?r.rowHeaders:r.cells:this._p=n.x<g?r.bottomLeftCells:r.columnFooters),null!=this._p){var m=this._p.rows,y=this._p.columns,v=this._p.cellType,C=i.CellType,b=this._p._getFrozenPos(),R=v==C.TopLeft||v==C.ColumnHeader?p:v==C.BottomLeft||v==C.ColumnFooter?w:m.getTotalSize(),E=v==C.TopLeft||v==C.BottomLeft||v==C.RowHeader?g:y.getTotalSize();v==C.RowHeader||v==C.Cell?(n.y-=p,(n.y>b.y||b.y<=0)&&(n.y-=r._ptScrl.y,n.y+=this._p._getOffsetY())):v!=C.BottomLeft&&v!=C.ColumnFooter||(n.y-=_.offsetTop),v!=C.ColumnHeader&&v!=C.Cell&&v!=C.ColumnFooter||(n.x-=g,(n.x>b.x||b.x<=0)&&(n.x-=r._ptScrl.x)),v!=C.ColumnHeader&&v!=C.TopLeft||(n.y-=f-p),this._edge=0;var S=o._SZEDGE[this._g.isTouching?1:0];if(this._g.isTouching&&(S=o._SZEDGE[1],n.x-=S/2),this._row=n.y>R?-1:m.getItemAt(n.y),this._col=n.x>E?-1:y.getItemAt(n.x),this._row<0||this._col<0)return void(this._p=null);if(this._col>-1){var x=y[this._col];n.x-x.pos<=S&&(this._edge|=1),x.pos+x.renderSize-n.x<=S&&(this._edge|=4)}if(this._row>-1){var z=m[this._row];n.y-z.pos<=S&&(this._edge|=2),z.pos+z.renderSize-n.y<=S&&(this._edge|=8)}}if(!(8&this._edge)&&s instanceof MouseEvent){var T=e.closest(s.target,".wj-cell"),H=T?T[i.GridPanel._INDEX_KEY]:null;H&&!H.rng&&H.panel==this._p&&this._row!=H.row&&(this._row=H.row)}}}return Object.defineProperty(o.prototype,"point",{get:function(){return this._pt},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"cellType",{get:function(){return this._p?this._p.cellType:t.CellType.None},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"panel",{get:function(){return this._p},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"grid",{get:function(){return this._p?this._p.grid:null},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"row",{get:function(){return this._row},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"col",{get:function(){return this._col},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"range",{get:function(){return this._rng||(this._rng=new i.CellRange(this._row,this._col)),this._rng},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"edgeLeft",{get:function(){return 0!=(1&this._edge)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"edgeTop",{get:function(){return 0!=(2&this._edge)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"edgeRight",{get:function(){return 0!=(4&this._edge)},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"edgeBottom",{get:function(){return 0!=(8&this._edge)},enumerable:!0,configurable:!0}),o._SZEDGE=[5,30],o}();i.HitTestInfo=o}(t=e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None",e[e.Cells=1]="Cells",e[e.ColumnHeaders=2]="ColumnHeaders",e[e.RowHeaders=4]="RowHeaders",e[e.AllHeaders=6]="AllHeaders",e[e.All=7]="All"}(i=t.AllowMerging||(t.AllowMerging={}));var o=function(){function o(e){this._g=e}return o.prototype.getMergedRange=function(o,n,r,s){void 0===s&&(s=!0);var l,a,c=o.cellType,h=o.columns,u=o.rows,d=u[n],g=h[r];if(d instanceof t._NewRowTemplate)return null;if(d instanceof t.GroupRow&&d.dataItem instanceof e.collections.CollectionViewGroup){if(l=new t.CellRange(n,r),g.aggregate==e.Aggregate.None){for(;l.col>0&&h[l.col-1].aggregate==e.Aggregate.None&&l.col!=h.frozen;)l.col--;for(;l.col2<h.length-1&&h[l.col2+1].aggregate==e.Aggregate.None&&l.col2+1!=h.frozen;)l.col2++}for(;l.col<r&&!h[l.col].visible;)l.col++;return l.isSingleCell?null:l}var p=!1;switch(this._g.allowMerging){case i.None:p=!0;break;case i.Cells:p=c!=t.CellType.Cell;break;case i.ColumnHeaders:p=c!=t.CellType.ColumnHeader&&c!=t.CellType.TopLeft;break;case i.RowHeaders:p=c!=t.CellType.RowHeader&&c!=t.CellType.TopLeft;break;case i.AllHeaders:p=c==t.CellType.Cell}if(p)return null;if(h[r].allowMerging){l=new t.CellRange(n,r);var f=0,_=u.length-1;n>=u.frozen?!s||c!=t.CellType.Cell&&c!=t.CellType.RowHeader||(f=(a=o._getViewRange()).topRow,_=a.bottomRow):_=u.frozen-1;for(var w=n-1;w>=f&&this._mergeCell(o,w,r,n,r);w--)l.row=w;for(var m=n+1;m<=_&&this._mergeCell(o,n,r,m,r);m++)l.row2=m;for(;l.row<n&&!u[l.row].visible;)l.row++;if(!l.isSingleCell)return l}if(u[n].allowMerging){l=new t.CellRange(n,r);var y=0,v=h.length-1;r>=h.frozen?!s||c!=t.CellType.Cell&&c!=t.CellType.ColumnHeader||(y=(a=o._getViewRange()).leftCol,v=a.rightCol):v=h.frozen-1;for(var C=r-1;C>=y&&this._mergeCell(o,n,C,n,r);C--)l.col=C;for(var b=r+1;b<=v&&this._mergeCell(o,n,r,n,b);b++)l.col2=b;for(;l.col<r&&!h[l.col].visible;)l.col++;if(!l.isSingleCell)return l}return null},o.prototype._mergeCell=function(e,i,o,n,r){var s=e.rows[i],l=e.rows[n];if(s instanceof t.GroupRow||s instanceof t._NewRowTemplate||l instanceof t.GroupRow||l instanceof t._NewRowTemplate)return!1;if(i!=n&&e.rows.isFrozen(i)!=e.rows.isFrozen(n))return!1;if(o!=r&&e.columns.isFrozen(o)!=e.columns.isFrozen(r))return!1;if(i!=n){if(o>0&&(s.allowMerging&&this._mergeCell(e,i,o-1,i,o)||l.allowMerging&&this._mergeCell(e,n,o-1,n,o)))return!1;if(r<e.columns.length-1&&(s.allowMerging&&this._mergeCell(e,i,r,i,r+1)||l.allowMerging&&this._mergeCell(e,n,r,n,r+1)))return!1}return e.getCellData(i,o,!0)==e.getCellData(n,r,!0)},o}();t.MergeManager=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i=function(){function t(t,i,o){if(this.mapChanged=new e.Event,e.isArray(t)&&!i&&!o){for(var n=[],r=0;r<t.length;r++)n.push({value:t[r]});t=n,i=o="value"}this._cv=e.asCollectionView(t),this._keyPath=e.asString(i,!1),this._displayPath=e.asString(o,!1),this._cv.collectionChanged.addHandler(this.onMapChanged,this)}return Object.defineProperty(t.prototype,"sortByDisplayValues",{get:function(){return 1!=this._sortByKey},set:function(t){this._sortByKey=!e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"collectionView",{get:function(){return this._cv},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"selectedValuePath",{get:function(){return this._keyPath},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"displayMemberPath",{get:function(){return this._displayPath},enumerable:!0,configurable:!0}),t.prototype.getKeyValue=function(e){var t=this._displayPath,i=this._indexOf(e,t,!0);return i<0&&(i=this._indexOf(e,t,!1)),i>-1?this._cv.sourceCollection[i][this._keyPath]:null},t.prototype.getDisplayValue=function(e){if(!this._hash){this._hash={};var t=this._cv.sourceCollection;if(t&&this._keyPath&&this._displayPath)for(var i=t.length-1;i>=0;i--){var o=t[i],n=o[this._keyPath],r=o[this._displayPath];this._hash[n]=r}}var s=this._hash[e];return null!=s?s:e},t.prototype.getDisplayValues=function(e){var t=[];if(this._cv&&this._displayPath)for(var i=this._cv.items,o=0;o<i.length;o++)t.push(i[o][this._displayPath]);return t},t.prototype.getKeyValues=function(){var e=[];if(this._cv&&this._keyPath)for(var t=this._cv.items,i=0;i<t.length;i++)e.push(t[i][this._keyPath]);return e},Object.defineProperty(t.prototype,"isEditable",{get:function(){return this._editable},set:function(t){this._editable=e.asBoolean(t)},enumerable:!0,configurable:!0}),t.prototype.onMapChanged=function(e){this._hash=null,this.mapChanged.raise(this,e)},t.prototype._indexOf=function(e,t,i){var o=-1,n=-1;if(this._cv&&t)for(var r=null!=e?e.toString():"",s=i?r:r.toLowerCase(),l=this._cv.sourceCollection,a=0;a<l.length;a++){var c=l[a],h=c[t];if(h==e?o=a:i||h.length!=s.length||h.toLowerCase()!=s?null!=h&&h.toString()==r&&(o=a):o=a,o==a){if(!this._cv.filter||this._cv.filter(c))return o;n<0&&(n=o)}}return n},t}();t.DataMap=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None",e[e.Cell=1]="Cell",e[e.CellRange=2]="CellRange",e[e.Row=3]="Row",e[e.RowRange=4]="RowRange",e[e.ListBox=5]="ListBox"}(i=t.SelectionMode||(t.SelectionMode={}));!function(e){e[e.None=0]="None",e[e.Selected=1]="Selected",e[e.Cursor=2]="Cursor",e[e.Active=3]="Active"}(t.SelectedState||(t.SelectedState={}));var o;!function(e){e[e.None=0]="None",e[e.Next=1]="Next",e[e.Prev=2]="Prev",e[e.NextPage=3]="NextPage",e[e.PrevPage=4]="PrevPage",e[e.Home=5]="Home",e[e.End=6]="End",e[e.NextCell=7]="NextCell",e[e.PrevCell=8]="PrevCell"}(o=t.SelMove||(t.SelMove={}));var n=function(){function n(e){this._sel=new t.CellRange(0,0),this._mode=i.CellRange,this._g=e}return Object.defineProperty(n.prototype,"selectionMode",{get:function(){return this._mode},set:function(e){if(e!=this._mode){var o=i;if(e==o.ListBox||this._mode==o.ListBox)for(var n=this._g.rows,r=0;r<n.length;r++){var s=n[r],l=e==i.ListBox&&this._sel.containsRow(r);s._setFlag(t.RowColFlags.Selected,l,!0)}switch(e){case o.None:this._sel.setRange(-1,-1);break;case o.Cell:this._sel.row2=this._sel.row,this._sel.col2=this._sel.col;break;case o.Row:this._sel.row2=this._sel.row}this._mode=e,this._g.invalidate()}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selection",{get:function(){return this._sel},set:function(e){this.select(e)},enumerable:!0,configurable:!0}),n.prototype.select=function(o,n){void 0===n&&(n=!0),e.isNumber(o)&&e.isNumber(n)&&(o=new t.CellRange(o,n),n=!0),o=e.asType(o,t.CellRange);var r=this._g,s=this._sel,l=o,a=!1,c=i;switch(r.selectionMode){case c.Cell:o.row2=o.row,o.col2=o.col;break;case c.Row:o.row2=o.row;break;case c.ListBox:a=!0}var h=l.equals(s);if(a&&l.row>-1&&!r.rows[l.row].isSelected&&(h=!1),h)n&&r.scrollIntoView(l.row,l.col);else{var u=new t.CellRangeEventArgs(r.cells,l);if(r.onSelectionChanging(u)){if(a&&(l.row!=s.row||l.rowSpan>1||s.rowSpan>1)){for(var d=0;d<r.rows.length;d++)r.rows[d]._setFlag(t.RowColFlags.Selected,l.containsRow(d),!0);r.refreshCells(!1,!0,!0)}if(l.row=Math.min(l.row,r.rows.length-1),l.row2=Math.min(l.row2,r.rows.length-1),this._sel=l,r.refreshCells(!1,!0,!0),n&&r.scrollIntoView(l.row,l.col),r.collectionView){var g=r._getCvIndex(l.row);r.collectionView.moveCurrentToPosition(g)}r.onSelectionChanged(u)}}},n.prototype.moveSelection=function(e,i,n){var r,s,l=this._g,a=l.rows,c=l.columns,h=this._getReferenceCell(e,i,n),u=Math.max(0,l._szClient.height-l.columnHeaders.height);if(i==o.NextCell)s=c.getNextCell(h.col,o.Next,u),r=h.row,s==h.col&&(r=a.getNextCell(r,o.Next,u))>h.row&&(s=c.getNextCell(0,o.Next,u),s=c.getNextCell(s,o.Prev,u)),l.select(r,s);else if(i==o.PrevCell)s=c.getNextCell(h.col,o.Prev,u),r=h.row,s==h.col&&(r=a.getNextCell(r,o.Prev,u))<h.row&&(s=c.getNextCell(c.length-1,o.Prev,u),s=c.getNextCell(s,o.Next,u)),l.select(r,s);else if(r=a.getNextCell(h.row,e,u),s=c.getNextCell(h.col,i,u),n){var d=l._selHdl._sel;l.select(new t.CellRange(r,s,d.row2,d.col2))}else l.select(r,s)},n.prototype._getReferenceCell=function(e,t,i){var n=this._g,r=n._selHdl._sel,s=n.getMergedRange(n.cells,r.row,r.col);if(!s||s.isSingleCell)return r;switch(s=s.clone(),e){case o.Next:case o.NextCell:s.row=s.bottomRow;break;case o.None:s.row=r.row}switch(t){case o.Next:case o.NextCell:s.col=s.rightCol;break;case o.None:s.col=r.col}return s},n.prototype._adjustSelection=function(e){switch(this._mode){case i.Cell:return new t.CellRange(e.row,e.col,e.row,e.col);case i.Row:return new t.CellRange(e.row,0,e.row,this._g.columns.length-1);case i.RowRange:case i.ListBox:return new t.CellRange(e.row,0,e.row2,this._g.columns.length-1)}return e},n}();t._SelectionHandler=n}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None",e[e.MoveDown=1]="MoveDown",e[e.MoveAcross=2]="MoveAcross",e[e.Cycle=3]="Cycle",e[e.CycleOut=4]="CycleOut"}(i=t.KeyAction||(t.KeyAction={}));var o=function(){function o(e){this._kaTab=i.None,this._kaEnter=i.MoveDown,this._g=e;var t=e.hostElement;e.addEventListener(t,"keypress",this._keypress.bind(this)),e.addEventListener(t,"keydown",this._keydown.bind(this))}return o.prototype._keydown=function(i){var o=this._g,n=o.selection,r=i.ctrlKey||i.metaKey,s=i.shiftKey,l=(i.target,!0);if(this._altDown=!1,!o._wantsInput(i.target)){var a=i.defaultPrevented&&!(i.target instanceof HTMLInputElement);if(o.isRangeValid(n)&&!a&&(!o.activeEditor||!o._edtHdl._keydown(i))){var c=e.tryCast(o.rows[n.row],t.GroupRow),h=o.editableCollectionView,u=i.keyCode;if(o.autoClipboard){if(r&&(67==u||45==u)){var d=new t.CellRangeEventArgs(o.cells,n);if(o.onCopying(d)){var g=o.getClipString()+"\r\n";e.Clipboard.copy(g),o.onCopied(d)}return void i.stopPropagation()}if(r&&86==u||s&&45==u){if(!o.isReadOnly){var p=new t.CellRangeEventArgs(o.cells,n);o.onPasting(p)&&e.Clipboard.paste(function(e){o.setClipString(e),o.onPasted(p)})}return void i.stopPropagation()}}if(o.rightToLeft)switch(u){case e.Key.Left:u=e.Key.Right;break;case e.Key.Right:u=e.Key.Left}var f=t.SelMove,_=t.SelectionMode;switch(u){case e.Key.Space:if(s&&n.isValid)switch(o.selectionMode){case _.CellRange:case _.Row:case _.RowRange:case _.ListBox:o.select(new t.CellRange(n.row,0,n.row,o.columns.length-1))}else if(r&&n.isValid)switch(o.selectionMode){case _.CellRange:o.select(new t.CellRange(0,n.col,o.rows.length-1,n.col))}else(l=this._startEditing(!0,i))&&setTimeout(function(){var t=o.activeEditor;t&&(t.disabled||t.readOnly?o.finishEditing():"checkbox"==t.type?(t.checked=!t.checked,o.finishEditing()):e.setSelectionRange(t,t.value.length))});break;case 65:if(r)switch(o.selectionMode){case _.CellRange:case _.Row:case _.RowRange:case _.ListBox:o.select(new t.CellRange(0,0,o.rows.length-1,o.columns.length-1))}else l=!1;break;case e.Key.Left:r||i.altKey?l=!1:n.isValid&&0==n.col&&null!=c&&!c.isCollapsed&&c.hasChildren?c.isCollapsed=!0:this._moveSel(f.None,r?f.Home:f.Prev,s);break;case e.Key.Right:r||i.altKey?l=!1:n.isValid&&0==n.col&&null!=c&&c.isCollapsed?c.isCollapsed=!1:this._moveSel(f.None,r?f.End:f.Next,s);break;case e.Key.Up:r?l=!1:(this._altDown=i.altKey,i.altKey?l=o._edtHdl._toggleListBox(i):this._moveSel(f.Prev,f.None,s));break;case e.Key.Down:r?l=!1:(this._altDown=i.altKey,i.altKey?l=o._edtHdl._toggleListBox(i):this._moveSel(f.Next,f.None,s));break;case e.Key.PageUp:this._altDown=i.altKey,this._moveSel(i.altKey?f.Home:f.PrevPage,f.None,s);break;case e.Key.PageDown:this._altDown=i.altKey,this._moveSel(i.altKey?f.End:f.NextPage,f.None,s);break;case e.Key.Home:this._moveSel(r?f.Home:f.None,f.Home,s);break;case e.Key.End:this._moveSel(r?f.End:f.None,f.End,s);break;case e.Key.Tab:l=this._performKeyAction(o.keyActionTab,s);break;case e.Key.Enter:l=this._performKeyAction(o.keyActionEnter,s),!s&&h&&null!=h.currentEditItem&&o._edtHdl._commitRowEdits();break;case e.Key.Escape:if(l=!1,h&&(h.currentAddItem||h.currentEditItem)){var w=new t.CellRangeEventArgs(o.cells,o.selection);w.cancel=!0,o.onRowEditEnding(w),h.currentAddItem&&h.cancelNew(),h.currentEditItem&&h.cancelEdit(),o.onRowEditEnded(w),l=!0}o._mouseHdl.resetMouseState();break;case e.Key.Delete:case e.Key.Back:l=this._deleteSel(i);break;case e.Key.F2:l=this._startEditing(!0,i);break;case e.Key.F4:l=o._edtHdl._toggleListBox(i);break;default:l=!1}l&&(o.containsFocus()||o.focus(),i.preventDefault(),i.stopPropagation())}}},o.prototype._performKeyAction=function(e,o){var n=i,r=t.SelMove;switch(e){case n.MoveDown:return this._moveSel(o?r.Prev:r.Next,r.None,!1),!0;case n.MoveAcross:return this._moveSel(r.None,o?r.Prev:r.Next,!1),!0;case n.Cycle:return this._moveSel(r.None,o?r.PrevCell:r.NextCell,!1),!0;case n.CycleOut:var s=this._g.selection;return this._moveSel(r.None,o?r.PrevCell:r.NextCell,!1),!s.equals(this._g.selection)}return!1},o.prototype._keypress=function(t){var i=this._g;if(!i._wantsInput(t.target)&&!t.defaultPrevented)if(this._altDown)t.preventDefault();else if(i.activeEditor)i._edtHdl._keypress(t);else if(t.charCode>e.Key.Space&&this._startEditing(!1,t)&&i.activeEditor){var o=e.getActiveElement();if(o instanceof HTMLInputElement&&"checkbox"!=o.type){var n=i._selHdl.selection,r=i.getCellData(n.row,n.col,!0),s=i.getCellData(n.row,n.col,!1);o.value=String.fromCharCode(t.charCode),e.isNumber(s)&&r.indexOf("%")>-1&&(o.value+="%"),e.setSelectionRange(o,1),o.dispatchEvent(i._edtHdl._evtInput),i._edtHdl._keypress(t),t.preventDefault()}}},o.prototype._moveSel=function(e,i,o){this._g.selectionMode!=t.SelectionMode.None&&this._g._selHdl.moveSelection(e,i,o)},o.prototype._deleteSel=function(e){var i=this._g,o=i.editableCollectionView,n=i.selection,r=i.rows,s=[],l=new t.CellRange,a=new t.CellEditEndingEventArgs(i.cells,l,e),c=t.SelectionMode;if(i.allowDelete&&!i.isReadOnly&&(null==o||o.canRemove&&!o.isAddingNew&&!o.isEditingItem))switch(i.selectionMode){case c.CellRange:if(0==n.leftCol&&n.rightCol==i.columns.length-1)for(h=n.topRow;h>-1&&h<=n.bottomRow;h++)s.push(r[h]);break;case c.ListBox:for(h=0;h<r.length;h++)r[h].isSelected&&s.push(r[h]);break;case c.Row:n.topRow>-1&&s.push(r[n.topRow]);break;case c.RowRange:for(var h=n.topRow;h>-1&&h<=n.bottomRow;h++)s.push(r[h])}if(s.length>0){if(i.deferUpdate(function(){o&&o.beginUpdate();for(var e=s.length-1;e>=0;e--){var t=s[e];l.setRange(t.index,-1),i.onDeletingRow(a)&&(o&&t.dataItem?o.remove(t.dataItem):i.rows.removeAt(t.index),i.onDeletedRow(a))}o&&o.endUpdate()}),i.selectionMode==c.ListBox){var u=i.selection.row;u>-1&&u<i.rows.length&&(i.rows[u].isSelected=!0)}return i.childItemsPath&&i.collectionView&&i.collectionView.refresh(),!0}if(!i.isReadOnly&&0==s.length){var d=!1,g=i.scrollPosition;return i.deferUpdate(function(){for(var e=n.topRow;e<=n.bottomRow;e++){var t=i.rows[e];if(!t.isReadOnly)for(var r=n.leftCol;r<=n.rightCol;r++){var s=i._getBindingColumn(i.cells,e,i.columns[r]);s.getIsRequired()||s.isReadOnly||i.getCellData(e,r,!0)&&(l.setRange(e,r),a.cancel=!1,i.onBeginningEdit(a)&&(o&&(d||(d=!0,o.beginUpdate()),o.editItem(t.dataItem),i._edtHdl._edItem=o.currentEditItem),i.setCellData(e,r,"",!0,!1),i.onCellEditEnding(a),i.onCellEditEnded(a)))}}i.selection=n,i.scrollPosition=g,d&&o.endUpdate()}),!0}return!1},o.prototype._startEditing=function(e,t,i,o){return this._g._edtHdl.startEditing(e,i,o,!0,t)},o}();t._KeyboardHandler=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None",e[e.Columns=1]="Columns",e[e.Rows=2]="Rows",e[e.Both=3]="Both",e[e.ColumnsAllCells=4|e.Columns]="ColumnsAllCells",e[e.RowsAllCells=4|e.Rows]="RowsAllCells",e[e.BothAllCells=4|e.Both]="BothAllCells"}(i=t.AllowResizing||(t.AllowResizing={}));!function(e){e[e.None=0]="None",e[e.Headers=1]="Headers",e[e.Cells=2]="Cells",e[e.Both=3]="Both"}(t.AutoSizeMode||(t.AutoSizeMode={}));var o;!function(e){e[e.None=0]="None",e[e.Columns=1]="Columns",e[e.Rows=2]="Rows",e[e.Both=3]="Both"}(o=t.AllowDragging||(t.AllowDragging={}));var n=function(){function n(i){var o=this;this._tsLast=0;var n=i.hostElement;this._g=i,this._dvMarker=e.createElement('<div class="wj-marker">&nbsp;</div>'),i.addEventListener(n,"mousedown",function(n){if(i._rcBounds=null,!n.defaultPrevented&&0==n.button){var l=n.target;if(!i.containsFocus()){var a=l instanceof HTMLElement&&l.tabIndex>-1?l:i._eFocus;i._setFocusNoScroll(a)}if(setTimeout(function(){n.defaultPrevented||i.focus()}),e.closest(n.target,".wj-flexgrid")!=i.hostElement||!i.activeEditor&&i._isInputElement(l)){var c=i.hitTest(n);switch(c.cellType){case t.CellType.Cell:i.select(c.range);break;case t.CellType.ColumnHeader:case t.CellType.ColumnFooter:i.scrollIntoView(-1,c.col);break;case t.CellType.RowHeader:i.scrollIntoView(c.row,-1)}return}var h=document;i.removeEventListener(h,"mousemove"),i.removeEventListener(h,"mouseup"),i.addEventListener(h,"mousemove",r),i.addEventListener(h,"mouseup",s),o._isDown=!0,o._mousedown(n)}});var r=function(e){o._mousemove(e)},s=function(e){o._isDown=!1,i.removeEventListener(document,"mousemove"),i.removeEventListener(document,"mouseup"),o._mouseup(e)};i.addEventListener(n,"mouseup",function(e){o._tsLast=Date.now()}),i.addEventListener(n,"mouseenter",function(e){i._rcBounds=null}),i.addEventListener(n,"mousemove",this._hover.bind(this)),i.addEventListener(n,"dblclick",this._dblclick.bind(this)),i.addEventListener(n,"click",this._click.bind(this)),i.addEventListener(n,"selectstart",function(e){i._isInputElement(e.target)||e.preventDefault()}),i.addEventListener(n,"wheel",function(t){var o=i.cells.hostElement.parentElement,n=t.deltaY;if(n&&!t.ctrlKey&&!t.metaKey&&o.scrollHeight>o.offsetHeight&&e.closest(t.target,".wj-flexgrid")==i.hostElement){switch(t.deltaMode){case 1:o.scrollTop+=i.rows.defaultSize*(n<0?-1:1);break;case 2:o.scrollTop+=o.clientHeight*(n<0?-1:1);break;case 0:default:e.isSafari()&&(n=e.clamp(n,-150,150)),o.scrollTop+=n}t.preventDefault(),t.stopImmediatePropagation()}}),i.addEventListener(n,"dragstart",this._dragstart.bind(this)),i.addEventListener(n,"dragover",this._dragover.bind(this)),i.addEventListener(n,"dragleave",this._dragover.bind(this)),i.addEventListener(n,"drop",this._drop.bind(this)),i.addEventListener(n,"dragend",this._dragend.bind(this)),this._enableTouchResizing()}return n.prototype.resetMouseState=function(){this._dragSource&&e.removeClass(this._dragSource,"wj-state-dragsrc"),this._showDragMarker(null);var t=this._g.hostElement;t&&(t.style.cursor="");var i=this._g;i.removeEventListener(document,"mousemove"),i.removeEventListener(document,"mouseup"),this._tsLast=Date.now(),this._eMouse=null,this._isDown=null,this._htDown=null,this._lbSelRows=null,this._szRowCol=null,this._szArgs=null,this._dragSource=null},n.prototype._enableTouchResizing=function(){var t=this,i=this._g,o=i.hostElement,n="ontouchstart"in window?["touchstart","touchmove","touchend"]:"onpointerdown"in window?["pointerdown","pointermove","pointerup"]:null;n&&(i.addEventListener(o,n[0],function(n){if((null==n.pointerType||"touch"==n.pointerType)&&!e.closest(n.target,".wj-elem-filter")){var r=e.closest(n.target,".wj-cell");r instanceof HTMLElement&&(i._rcBounds=null,t._htDown=null,t._hover(n),t._szRowCol&&(r.removeAttribute("draggable"),o.style.touchAction="none",t._mousedown(n),n.preventDefault()))}}),i.addEventListener(o,n[1],function(e){null!=e.pointerType&&"touch"!=e.pointerType||t._szRowCol&&(t._mousemove(e),e.preventDefault())}),i.addEventListener(o,n[2],function(i){if(e.Control._touching=!1,(null==i.pointerType||"touch"==i.pointerType)&&t._szRowCol){if(t._szArgs)t._finishResizing(t._eMouse);else{var n=e.closest(i.target,".wj-cell");n instanceof HTMLElement&&n.click()}t.resetMouseState(),o.style.touchAction=""}}))},n.prototype._mousedown=function(i){var n=this._g,r=n.hitTest(i),s=r.cellType,l=i.ctrlKey||i.metaKey;if(this._selDown=n.selection,r.panel==n.cells){if(e.closestClass(i.target,t.CellFactory._WJC_DROPDOWN))return n._edtHdl._toggleListBox(i,r.range),void i.preventDefault();if(n.editRange&&n.editRange.contains(r.range))return}var a=e.getActiveElement();if(i.target!=a||!n._isInputElement(i.target)){if(s==t.CellType.None)return n.finishEditing(),void(i.target!=n._root&&n._edtHdl._commitRowEdits());if(this._htDown=r,this._eMouse=i,null!=this._szRowCol)return a!=n._eFocus&&(n._eFocus.tabIndex=0,n._eFocus.focus()),void this._handleResizing(i);switch(s){case t.CellType.Cell:l&&n.selectionMode==t.SelectionMode.ListBox&&this._startListBoxSelection(r.row),this._mouseSelect(i,i.shiftKey);break;case t.CellType.RowHeader:0==(this._g.allowDragging&o.Rows)&&(l&&n.selectionMode==t.SelectionMode.ListBox&&this._startListBoxSelection(r.row),this._mouseSelect(i,i.shiftKey),i.preventDefault(),n.focus())}if(s==t.CellType.Cell&&n.rows.maxGroupLevel>-1&&e.closestClass(i.target,t.CellFactory._WJC_COLLAPSE)){var c=e.tryCast(n.rows[r.row],t.GroupRow);if(c)return l?n.collapseGroupsToLevel(c.isCollapsed?c.level+1:c.level):c.isCollapsed=!c.isCollapsed,void this.resetMouseState()}}},n.prototype._mousemove=function(e){if(null!=this._htDown){if(0==e.buttons&&this._eMouse&&e.timeStamp-this._eMouse.timeStamp>600)return void this.resetMouseState();if(this._eMouse=e,this._szRowCol)this._handleResizing(e);else switch(this._htDown.cellType){case t.CellType.Cell:this._mouseSelect(e,!0);break;case t.CellType.RowHeader:0==(this._g.allowDragging&o.Rows)&&this._mouseSelect(e,!0)}}},n.prototype._mouseup=function(e){if(!this._g.isTouching||!(this._dragSource||e.target instanceof HTMLHtmlElement)){var i=this._g,o=i.hitTest(e),n=this._htDown,r=t.SelectionMode;if(n&&!e.defaultPrevented)if(this._szArgs)this._finishResizing(e);else if(n.panel!=i.topLeftCells||this._szArgs)n.panel!=i.columnHeaders||e.dataTransfer?n.panel==i.cells&&(e.ctrlKey||e.metaKey||e.shiftKey||o.panel==n.panel&&o.range.equals(n.range)&&i.selection.equals(this._selDown)&&i._edtHdl.startEditing(!0,o.row,o.col,!0,e)):o.panel==n.panel&&o.col==n.col&&!o.edgeRight&&o.col>-1&&this._clickSort(e,o);else if(o.panel==n.panel&&o.row==n.row&&o.col==n.col&&i.rows.length&&i.columns.length)switch(i.selectionMode){case r.CellRange:case r.RowRange:case r.ListBox:i.select(new t.CellRange(0,0,i.rows.length-1,i.columns.length-1))}this.resetMouseState()}},n.prototype._click=function(e){Date.now()-this._tsLast>50&&!e.pointerType&&this._handleClick(e)},n.prototype._handleClick=function(i){var o=this._g,n=i.target,r=new t.HitTestInfo(n,null);if(!i.defaultPrevented&&r.grid==o&&!o._isInputElement(n))if(r.panel==o.topLeftCells)o.select(new t.CellRange(0,0,o.rows.length-1,o.columns.length-1));else if(r.panel==o.columnHeaders)this._clickSort(i,r);else if(r.panel==o.rowHeaders)o.select(new t.CellRange(r.row,0,r.row,o.columns.length-1));else if(r.panel==o.cells)if(r.row<0)this._clickSort(i,r);else if(e.closestClass(n,t.CellFactory._WJC_COLLAPSE)){var s=o.rows[r.row];s instanceof e.grid.GroupRow&&(i.ctrlKey?o.collapseGroupsToLevel(s.isCollapsed?s.level+1:s.level):s.isCollapsed=!s.isCollapsed)}else e.closestClass(n,t.CellFactory._WJC_DROPDOWN)?o._edtHdl._toggleListBox(i,r.range):o.select(r.range)},n.prototype._clickSort=function(i,o){var n=this._g,r=n.collectionView,s=i.ctrlKey||i.metaKey;if(r&&r.canSort&&n.allowSorting){o.range.bottomRow;var l=o.panel.columns[o.col],a=n._getBindingColumn(o.panel,o.row,l),c=a?a._getBindingSort():null;if(a.allowSorting&&c){for(var h=o.grid.collectionView.sortDescriptions,u=null,d=0;d<h.length;d++)if(h[d].property==c){u=!h[d].ascending;break}if(null==u){if(s)return;u=!0}var g=new t.CellRangeEventArgs(o.panel,o.range);n.onSortingColumn(g)&&(n._edtHdl._commitRowEdits(),s?h.clear():h.splice(0,h.length,new e.collections.SortDescription(c,u)),n.onSortedColumn(g))}}},n.prototype._dblclick=function(e){var o,n=this._g,r=n.hitTest(e),s=r.cellType,l=n.selection,a=r.range;if(!e.defaultPrevented)if(r.edgeRight&&n.allowResizing&i.Columns){if(s==t.CellType.ColumnHeader||s==t.CellType.Cell&&4&n.allowResizing){e.preventDefault(),e.ctrlKey&&l.containsColumn(r.col)&&(a=l);for(var c=a.leftCol;c<=a.rightCol;c++)n.columns[c].allowResizing&&(o=new t.CellRangeEventArgs(n.cells,new t.CellRange(-1,c)),n.onAutoSizingColumn(o)&&n.onResizingColumn(o)&&(n.autoSizeColumn(c),n.onResizedColumn(o),n.onAutoSizedColumn(o)))}else s==t.CellType.TopLeft&&r.panel.columns[r.col].allowResizing&&(e.preventDefault(),o=new t.CellRangeEventArgs(r.panel,new t.CellRange(-1,r.col)),n.onAutoSizingColumn(o)&&n.onResizingColumn(o)&&(n.autoSizeColumn(r.col,!0),n.onAutoSizedColumn(o),n.onResizedColumn(o)));this.resetMouseState()}else if(r.edgeBottom&&n.allowResizing&i.Rows){if(s==t.CellType.RowHeader||s==t.CellType.Cell&&4&n.allowResizing){e.ctrlKey&&l.containsRow(r.row)&&(a=l);for(var h=a.topRow;h<=a.bottomRow;h++)n.rows[h].allowResizing&&(o=new t.CellRangeEventArgs(n.cells,new t.CellRange(h,-1)),n.onAutoSizingRow(o)&&n.onResizingRow(o)&&(n.autoSizeRow(h),n.onResizedRow(o),n.onAutoSizedRow(o)))}else s==t.CellType.TopLeft&&r.panel.rows[r.row].allowResizing&&(o=new t.CellRangeEventArgs(r.panel,new t.CellRange(r.row,-1)),n.onAutoSizingRow(o)&&n.onResizingRow(o)&&(n.autoSizeRow(r.row,!0),n.onResizedRow(o),n.onAutoSizedRow(o)));this.resetMouseState()}else;},n.prototype._hover=function(e){if(null==this._htDown){var o=this._g,n=o.hitTest(e),r=(n.panel,n.cellType),s="";return this._szRowCol=null,(r==t.CellType.ColumnHeader||r==t.CellType.TopLeft||r==t.CellType.Cell&&4&o.allowResizing)&&n.edgeRight&&0!=(o.allowResizing&i.Columns)&&(this._szRowCol=this._getResizeCol(n)),(r==t.CellType.RowHeader||r==t.CellType.TopLeft||r==t.CellType.Cell&&4&o.allowResizing)&&n.edgeBottom&&0!=(o.allowResizing&i.Rows)&&(this._szRowCol=this._getResizeRow(n)),this._szRowCol instanceof t.Column?s="col-resize":this._szRowCol instanceof t.Row&&(s="row-resize"),this._szStart=this._szRowCol?this._szRowCol.renderSize:0,o.hostElement.style.cursor=s,n}return null},n.prototype._getResizeCol=function(e){for(var i=e.panel.columns,o=i[e.col],n=e.col+1;n<i.length;n++)if((r=i[n]).visible){r.size<1&&(o=r);break}if(e.col==i.length-1&&(e.cellType==t.CellType.TopLeft||e.cellType==t.CellType.RowHeader)){i=this._g.columns;for(n=0;n<i.length;n++){var r=i[n];if(r.visible){r.size<1&&(o=r);break}}}return o.allowResizing?o:null},n.prototype._getResizeRow=function(e){for(var i=e.panel.rows,o=i[e.row],n=e.row+1;n<i.length;n++)if((r=i[n]).visible){r.size<1&&(o=r);break}if(e.row==i.length-1&&(e.cellType==t.CellType.TopLeft||e.cellType==t.CellType.ColumnHeader)){i=this._g.rows;for(n=0;n<i.length;n++){var r=i[n];if(r.visible){r.size<1&&(o=r);break}}}return o.allowResizing?o:null},n.prototype._mouseSelect=function(i,o){var n=this,r=this._g;if(this._htDown&&this._htDown.panel&&r.selectionMode!=t.SelectionMode.None){var s=new t.HitTestInfo(this._htDown.panel,i);this._handleSelection(s,o),!e.isIE9()&&i.button>=0&&i.target!=r._root&&(s=new t.HitTestInfo(r,i)).cellType!=t.CellType.Cell&&s.cellType!=t.CellType.RowHeader&&setTimeout(function(){n._mouseSelect(n._eMouse,o)},100)}},n.prototype._handleResizing=function(i){if(i.preventDefault(),this._szRowCol instanceof t.Column){var o=this._g,r=e.mouseToPage(i).x,s=Math.round(Math.max(n._SZ_MIN,this._szStart+(r-this._htDown.point.x)*(o.rightToLeft?-1:1)));if(this._szRowCol.renderSize!=s){if(null==this._szArgs){a=o.rowHeaders.columns.indexOf(this._szRowCol)>-1?o.rowHeaders:o.cells;this._szArgs=new t.CellRangeEventArgs(a,new t.CellRange(-1,this._szRowCol.index))}this._szArgs.cancel=!1,o.onResizingColumn(this._szArgs)&&(o.deferResizing?this._showResizeMarker(s):this._szRowCol.width=s)}}if(this._szRowCol instanceof t.Row){var o=this._g,l=e.mouseToPage(i).y,s=Math.round(Math.max(n._SZ_MIN,this._szStart+(l-this._htDown.point.y)));if(this._szRowCol.renderSize!=s){if(null==this._szArgs){var a=o.columnHeaders.rows.indexOf(this._szRowCol)>-1?o.columnHeaders:o.cells;this._szArgs=new t.CellRangeEventArgs(a,new t.CellRange(this._szRowCol.index,-1))}this._szArgs.cancel=!1,o.onResizingRow(this._szArgs)&&(o.deferResizing?this._showResizeMarker(s):this._szRowCol.height=s)}}},n.prototype._dragstart=function(i){var n=this._g,r=this._htDown;if(r){if(this._dragSource=null,!this._szRowCol){var s=new t.CellRangeEventArgs(r.panel,r.range);if(r.cellType==t.CellType.ColumnHeader&&n.allowDragging&o.Columns&&r.col>-1&&n.columns[r.col].allowDragging)n.onDraggingColumn(s)?this._dragSource=i.target:i.preventDefault();else if(r.cellType==t.CellType.RowHeader&&n.allowDragging&o.Rows&&r.row>-1&&n.rows[r.row].allowDragging){var l=n.rows[r.row];l instanceof t.GroupRow||l instanceof t._NewRowTemplate||(n.onDraggingRow(s)?this._dragSource=i.target:i.preventDefault())}}this._dragSource&&i.dataTransfer&&!i.defaultPrevented&&(e._startDrag(i.dataTransfer,"move"),i.stopPropagation(),e.addClass(this._dragSource,"wj-state-dragsrc"),n.beginUpdate(),this._updating=!0)}},n.prototype._dragend=function(e){this._updating&&(this._g.endUpdate(),this._updating=!1),this.resetMouseState()},n.prototype._dragover=function(i){var o=this._g,n=o.hitTest(i),r=!1,s=new t.CellRangeEventArgs(o.cells,n.range);if(this._htDown&&n.cellType==this._htDown.cellType&&(n.cellType==t.CellType.ColumnHeader?(s.cancel=!o.columns.canMoveElement(this._htDown.col,n.col),r=o.onDraggingColumnOver(s)):n.cellType==t.CellType.RowHeader&&(s.cancel=!o.rows.canMoveElement(this._htDown.row,n.row),r=o.onDraggingRowOver(s))),r?(i.dataTransfer.dropEffect="move",this._showDragMarker(n),i.preventDefault(),i.stopPropagation()):this._showDragMarker(null),this._htDown&&o.autoScroll){var l=o._rcBounds,a=o.scrollPosition,c=e.Control._DRAG_SCROLL_EDGE,h=e.Control._DRAG_SCROLL_STEP;this._htDown.panel==o.columnHeaders?(i.pageX-l.left<c&&(a.x+=h),l.right-i.pageX<c&&(a.x-=h)):this._htDown.panel==o.rowHeaders&&(i.pageY-l.top<c&&(a.y+=h),l.bottom-i.pageY<c&&(a.y-=h)),a.equals(o._ptScrl)||(o.scrollPosition=a)}},n.prototype._drop=function(e){var i=this._g,o=i.hitTest(e);if(this._htDown&&o.cellType==this._htDown.cellType){var n=i.selection,r=new t.CellRangeEventArgs(i.cells,o.range,this._htDown);o.cellType==t.CellType.ColumnHeader?(i.columns.moveElement(this._htDown.col,o.col),i.select(n.row,o.col),i.onDraggedColumn(r)):o.cellType==t.CellType.RowHeader&&(i.rows.moveElement(this._htDown.row,o.row),i.select(o.row,n.col),i.onDraggedRow(r))}this.resetMouseState()},n.prototype._showResizeMarker=function(i){var o=this._g,n=this._dvMarker,r=o.cells.hostElement;n.parentElement!=r&&r.appendChild(n);var s,l=this._szArgs.panel.cellType;this._szRowCol instanceof t.Column?(s={left:this._szRowCol.pos+i-1,top:-1e3,right:"",bottom:0,width:3,height:""},o.rightToLeft&&(s.left=r.clientWidth-s.left-s.width),l!=t.CellType.TopLeft&&l!=t.CellType.RowHeader||(s.left-=o.topLeftCells.hostElement.offsetWidth)):(s={left:-1e3,top:this._szRowCol.pos+i-1,right:0,bottom:"",width:"",height:3},l!=t.CellType.TopLeft&&l!=t.CellType.ColumnHeader||(s.top-=o.topLeftCells.hostElement.offsetHeight)),e.setCss(n,s)},n.prototype._showDragMarker=function(i){var o=this._g,n=this._dvMarker;if(!i||!i.panel)return e.removeChild(n),void(this._rngTarget=null);if(!i.range.equals(this._rngTarget)){this._rngTarget=i.range;var r=i.panel.hostElement;n.parentElement!=r&&r.appendChild(n);var s={left:0,top:0,width:6,height:6,right:"",bottom:""};switch(i.cellType){case t.CellType.ColumnHeader:s.height=i.panel.height;var l=o.columns[i.col];s.left=l.pos-s.width/2,i.col>this._htDown.col&&(s.left+=l.renderWidth),o.rightToLeft&&(s.left=n.parentElement.clientWidth-s.left-s.width);break;case t.CellType.RowHeader:s.width=i.panel.width;var a=o.rows[i.row];s.top=a.pos-s.height/2,i.row>this._htDown.row&&(s.top+=a.renderHeight)}e.setCss(n,s)}},n.prototype._finishResizing=function(i){var o=this._g,r=o.selection,s=this._szArgs,l=this._eMouse&&this._eMouse.ctrlKey;if(s&&!s.cancel){if(s.col>-1){var a=s.col,c=e.mouseToPage(i).x,h=Math.round(Math.max(n._SZ_MIN,this._szStart+(c-this._htDown.point.x)*(this._g.rightToLeft?-1:1)));if(s.panel.columns[a].width=Math.round(h),o.onResizedColumn(s),l&&this._htDown.cellType==t.CellType.ColumnHeader&&r.containsColumn(a))for(var u=r.leftCol;u<=r.rightCol;u++)o.columns[u].allowResizing&&u!=a&&(s=new t.CellRangeEventArgs(o.cells,new t.CellRange(-1,u)),o.onResizingColumn(s)&&(o.columns[u].size=o.columns[a].size,o.onResizedColumn(s)))}if(s.row>-1){var a=s.row,d=e.mouseToPage(i).y,h=Math.round(Math.max(n._SZ_MIN,this._szStart+(d-this._htDown.point.y)));if(s.panel.rows[a].height=Math.round(h),o.onResizedRow(s),l&&this._htDown.cellType==t.CellType.RowHeader&&r.containsRow(a))for(var g=r.topRow;g<=r.bottomRow;g++)o.rows[g].allowResizing&&g!=a&&(s=new t.CellRangeEventArgs(o.cells,new t.CellRange(g,-1)),o.onResizingRow(s)&&(o.rows[g].size=o.rows[a].size,o.onResizedRow(s)))}}},n.prototype._startListBoxSelection=function(e){var t=this._g.rows;this._lbSelState=!t[e].isSelected,this._lbSelRows={};for(var i=0;i<t.length;i++)t[i].isSelected&&(this._lbSelRows[i]=!0)},n.prototype._handleSelection=function(e,i){var o=this._g,n=o.rows,r=o._selHdl.selection,s=new t.CellRange(e.row,e.col);if(e.row>-1&&e.col>-1)if(null!=this._lbSelRows){var l=!1;s=new t.CellRange(e.row,e.col,this._htDown.row,this._htDown.col);for(var a=0;a<n.length;a++){var c=s.containsRow(a)?this._lbSelState:null!=this._lbSelRows[a];if(c!=n[a].isSelected){var h=new t.CellRangeEventArgs(o.cells,new t.CellRange(a,r.col,a,r.col2));o.onSelectionChanging(h)&&(n[a]._setFlag(t.RowColFlags.Selected,c,!0),l=!0,o.onSelectionChanged(h))}}l&&o.refreshCells(!1,!0,!0),o.scrollIntoView(e.row,e.col)}else e.cellType==t.CellType.RowHeader&&(s.col=0,s.col2=o.columns.length-1),i&&(s.row2=r.row2,s.col2=r.col2),o.select(s)},n._SZ_MIN=0,n}();t._MouseHandler=n}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i=function(){function i(i){var o=this;this._fullEdit=!1,this._list=null,this._g=i,this._evtInput=document.createEvent("HTMLEvents"),this._evtInput.initEvent("input",!0,!1),i.selectionChanging.addHandler(function(e,t){if(o.finishEditing()){var n=i._selHdl.selection.row;if(n!=t.row){var r=i.rows.length;(n>-1&&n<r?i.rows[n].dataItem:null)!=(t.row>-1&&t.row<r?i.rows[t.row].dataItem:null)&&o._commitRowEdits()}}else t.cancel=!0}),i.lostFocus.addHandler(function(){if(!i.containsFocus()){var t=e.getActiveElement();t&&"fixed"==getComputedStyle(t).position||o._commitRowEdits()}}),i.addEventListener(i.hostElement,"mousedown",function(n){if(!n.defaultPrevented&&0==n.button&&!i._mouseHdl._szRowCol){i.selection;var r=i.hitTest(n);if(r.cellType!=t.CellType.Cell&&r.cellType!=t.CellType.None)o.finishEditing();else if(r.cellType!=t.CellType.None){var s=e.tryCast(n.target,HTMLInputElement);o._isNativeCheckbox(s)&&(s!=o.activeEditor&&(n.preventDefault(),o.startEditing(!1,r.row,r.col,!0,n)&&(s=o.activeEditor)),!s||"checkbox"!=s.type||s.disabled||s.readOnly||(s.checked=!s.checked,s.focus(),o.finishEditing()))}}},!0),i.addEventListener(i.hostElement,"click",function(e){o._isNativeCheckbox(e.target)&&e.preventDefault()})}return i.prototype.startEditing=function(i,o,n,r,s){void 0===i&&(i=!0);var l=this._g;if(o=e.asNumber(o,!0,!0),n=e.asNumber(n,!0,!0),null==o&&(o=l.selection.row),null==n&&(n=l.selection.col),null==r&&(r=!0),!this._allowEditing(o,n))return!1;var a=l.getMergedRange(l.cells,o,n,!1);a||(a=new t.CellRange(o,n));var c=l.rows[o].dataItem;if(l.select(a,!0),!l.rows[o]||c!=l.rows[o].dataItem)return!1;if(a.equals(this._rng))return!0;if(this.activeEditor&&!this.finishEditing())return!1;var h=new t.CellRangeEventArgs(l.cells,a,s);if(!l.onBeginningEdit(h))return!1;var u=l.editableCollectionView,d=!1;u&&((d=(c=l.rows[o].dataItem)!=u.currentEditItem)&&l.onRowEditStarting(h),u.editItem(c),d&&(l.onRowEditStarted(h),this._edItem=c)),this._fullEdit=e.asBoolean(i),this._rng=a,this._list=null;var g=l.columns[n].dataMap;g&&(this._list=g.getDisplayValues(c)),a.isSingleCell?this._updateEditorCell(o,n,d):l.refresh(!1);var p=this._edt;if(p){if("checkbox"==p.type)this._fullEdit=!1;else if(r){var f=e.culture.Globalize.numberFormat["%"]||"%";if(e.isNumber(l.getCellData(o,n,!1))&&p.value.indexOf(f)>-1){for(var _=p.value,w=0,m=_.length;m>0&&_[m-1]==f;)m--;for(;w<m&&_[w]==f;)w++;e.setSelectionRange(p,w,m)}else e.setSelectionRange(p,0,p.value.length);l._setFocusNoScroll(p)}if(l.onPrepareCellForEdit(h),p.disabled||p.readOnly)return!1}return null!=p&&!p.disabled&&!p.readOnly},i.prototype.finishEditing=function(i){var o=this._edt;if(!o)return this._removeListBox(),!0;var n=this._g,r=this._rng,s=new t.CellEditEndingEventArgs(n.cells,r),l=n.containsFocus(),a=n.hostElement.querySelector(".wj-control.wj-state-focused");if(a){var c=e.Control.getControl(a);c&&c.onLostFocus(s)}if(s.cancel=i,!i&&n.validateEdits){var h=this._getValidationError();if(h){s.cancel=!0;var u=o.parentElement;u&&(e.toggleClass(u,"wj-state-invalid",!0),u.title=h,s.stayInEditMode=!0)}}if(!n.onCellEditEnding(s)&&s.stayInEditMode)return l?setTimeout(function(){o.select()}):o.select(),!1;if(!s.cancel){s.data=n.cells.getCellData(r.topRow,r.leftCol,!1);for(var d=n.cellFactory.getEditorValue(n),g=r.topRow;g<=r.bottomRow&&g<n.rows.length;g++)for(var p=r.leftCol;p<=r.rightCol&&p<n.columns.length;p++)n.cells.setCellData(g,p,d,!0,!1)}this._edt=null,this._rng=null,this._list=null,this._removeListBox();var f=e.closest(o,".wj-cell");return e.contains(f,e.getActiveElement())&&f.focus(),s.cancel||!s.refresh?this._updateEditorCell(r.row,r.col,!1):n.refresh(!1),l&&n.focus(),n.onCellEditEnded(s),!0},Object.defineProperty(i.prototype,"activeEditor",{get:function(){return this._edt},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"editRange",{get:function(){return this._rng},enumerable:!0,configurable:!0}),i.prototype.getClipString=function(i){var o=this._g,n="",r=!0,s=t.SelectionMode;if(!i)switch(i=o.selection,o.selectionMode){case s.Row:case s.RowRange:i.col=0,i.col2=o.columns.length-1;break;case s.ListBox:i.col=0,i.col2=o.columns.length-1;for(var l=0;l<o.rows.length;l++)o.rows[l].isSelected&&o.rows[l].isVisible&&(i.row=i.row2=l,n&&(n+="\n"),n+=this.getClipString(i));return n}for(var a=(i=e.asType(i,t.CellRange)).topRow;a<=i.bottomRow;a++)if(o.rows[a].isVisible){r||(n+="\n"),r=!1;for(var c=i.leftCol,h=!0;c<=i.rightCol;c++)if(o.columns[c].isVisible){h||(n+="\t"),h=!1;var u=o.cells.getCellData(a,c,!0).toString();(u=u.replace(/\t/g," ")).indexOf("\n")>-1&&(u='"'+u.replace(/"/g,'""')+'"'),n+=u}}return n},i.prototype.setClipString=function(i,o){var n=this,r=this._g,s=null==o,l=t.SelectionMode;if(!o)switch(o=r.selection,r.selectionMode){case l.Row:case l.RowRange:case l.ListBox:o.col=0,o.col2=r.columns.length-1}o=e.asType(o,t.CellRange);var a=this._parseClipString(e.asString(i));s&&!o.isSingleCell&&a.length&&this._expandClipRows(a,o);var c,h=new t.CellRange(o.topRow,o.leftCol),u=r.editableCollectionView,d=o.topRow,g=!1;r.deferUpdate(function(){u&&u.beginUpdate();for(var e=0;e<a.length&&d<r.rows.length;e++,d++)if(r.rows[d].isVisible)for(var i=a[e],s=o.leftCol,l=0;l<i.length&&s<r.columns.length;l++,s++)r.columns[s].isVisible?n._allowEditing(d,s)&&(c=new t.CellRangeEventArgs(r.cells,new t.CellRange(d,s),i[l]),r.onPastingCell(c)&&(u&&(u.editItem(r.rows[d].dataItem),n._edItem=u.currentEditItem),r.cells.setCellData(d,s,c.data)&&(r.onPastedCell(c),g=!0)),h.row2=Math.max(h.row2,d),h.col2=Math.max(h.col2,s)):l--;else e--;u&&u.endUpdate(),r.select(h)})},i.prototype._isNativeCheckbox=function(t){return t instanceof HTMLInputElement&&"checkbox"==t.type&&!t.disabled&&!t.readOnly&&e.hasClass(t,"wj-cell-check")&&e.closest(t,".wj-flexgrid")==this._g.hostElement},i.prototype._parseClipString=function(e){var t=[];e=(e=e.replace(/\r\n/g,"\n").replace(/\r/g,"\n")).replace(/\n+$/g,"");var i=0,o=0;for(i=0;i<e.length;i++){var n='"'==e[i]&&e[i+1]>=" ",r=!1,s=!1;for(o=i;o<e.length&&!s;o++){var l=e[o];switch(l){case'"':n&&(r=!r);break;case"\t":case"\n":r||(this._parseClipCell(t,e,i,o,"\n"==l),i=o,s=!0)}}if(o==e.length){this._parseClipCell(t,e,i,e.length,!1);break}}return 0==t.length&&t.push([""]),t},i.prototype._parseClipCell=function(e,t,i,o,n){e.length||e.push([]);var r=t.substr(i,o-i),s=r.length;s>1&&'"'==r[0]&&'"'==r[s-1]&&(r=(r=r.substr(1,s-2)).replace(/""/g,'"')),e[e.length-1].push(r),n&&e.push([])},i.prototype._expandClipRows=function(e,t){for(var i=e.length,o=0,n=0;n<i;n++)o=Math.max(o,e[n].length);for(var r=this._g,s=0,l=0,a=t.topRow;a<=t.bottomRow;a++)r.rows[a].isVisible&&s++;for(c=t.leftCol;c<=t.rightCol;c++)r.columns[c].isVisible&&l++;if((s>1||l>1)&&(1==s&&(s=i),1==l&&(l=o),l%o==0&&s%i==0)){for(var c=o;c<l;c++)for(a=0;a<i;a++)e[a].push(e[a%i][c%o]);for(a=i;a<s;a++)e.push(e[a%i])}},i.prototype._updateEditorCell=function(e,i,o){var n=this._g,r=n.cells.getCellElement(e,i),s=n._useFrozenDiv()&&(e<n.frozenRows||i<n.frozenColumns);if(!r||s||n._hasPendingUpdates())n.refresh(!1);else if(this._updateCell(r),(o=o||n._getHasValidation())&&n.headersVisibility&t.HeadersVisibility.Row){var l=n.rowHeaders,a=l.columns.length-1,c=l.getCellElement(e,a);c&&this._updateCell(c)}},i.prototype._updateCell=function(i){var o=new t.HitTestInfo(i,null),n=t.FlexGrid._WJS_UPDATING;o.panel&&(e.addClass(i,n),o.grid.cellFactory.updateCell(o.panel,o.row,o.col,i,o.range),e.removeClass(i,n))},i.prototype._getValidationError=function(){var e=this._g;if(e._getHasValidation()){var t=this._rng.row,i=this._rng.col,o=e.cellFactory.getEditorValue(e),n=e.getCellData(t,i,!1);if(e.setCellData(t,i,o,!0,!1)){var r=e._getError(e.cells,t,i);return e.setCellData(t,i,n,!0,!1),r}}return null},i.prototype._allowEditing=function(e,i){var o=this._g;if(o.isReadOnly||o.selectionMode==t.SelectionMode.None)return!1;if(e<0||e>=o.rows.length||o.rows[e].isReadOnly||!o.rows[e].isVisible)return!1;if(i<0||i>=o.columns.length)return!1;var n=o._getBindingColumn(o.cells,e,o.columns[i]);return!(!n||n.isReadOnly||!n.isVisible)},i.prototype._commitRowEdits=function(){var e=this._g;if(this.finishEditing()&&this._edItem){var i=e.editableCollectionView;if(i&&i.currentEditItem){var o=new t.CellRangeEventArgs(e.cells,e.selection);e.onRowEditEnding(o),i.commitEdit(),e.onRowEditEnded(o)}this._edItem=null}},i.prototype._keydown=function(t){var i=this._edt;switch(t.keyCode){case e.Key.F2:return this._fullEdit=!this._fullEdit,t.preventDefault(),!0;case e.Key.F4:return this._toggleListBox(t),t.preventDefault(),!0;case e.Key.Space:return!i||"checkbox"!=i.type||i.disabled||i.readOnly||(i.checked=!i.checked,this.finishEditing(),t.preventDefault()),!0;case e.Key.Enter:if(t.preventDefault(),i&&t.altKey){var o=t.target;if(o instanceof HTMLTextAreaElement){var n=o.value,r=o.selectionStart,s=o.selectionEnd;return o.value=n.substr(0,r)+"\n"+n.substr(s),e.setSelectionRange(o,r+1),!0}}return!this.finishEditing();case e.Key.Tab:return t.preventDefault(),!this.finishEditing();case e.Key.Escape:return t.preventDefault(),this.finishEditing(!0),!0;case e.Key.Up:case e.Key.Down:case e.Key.Left:case e.Key.Right:case e.Key.PageUp:case e.Key.PageDown:case e.Key.Home:case e.Key.End:if(this._lbx)return this._keydownListBox(t);if(t.altKey)switch(t.keyCode){case e.Key.Up:case e.Key.Down:return this._toggleListBox(t),t.preventDefault(),!0}if(!this._fullEdit&&this.finishEditing())return!1}return!0},i.prototype._keydownListBox=function(t){var i=!0;if(this._lbx)switch(t.keyCode){case e.Key.Up:t.altKey?this._toggleListBox(t):this._lbx.selectedIndex>0&&this._lbx.selectedIndex--;break;case e.Key.Down:t.altKey?this._toggleListBox(t):this._lbx.selectedIndex++;break;case e.Key.Home:case e.Key.PageUp:this._lbx.selectedIndex=0;break;case e.Key.End:case e.Key.PageDown:this._lbx.selectedIndex=this._lbx.collectionView.items.length-1;break;default:i=!1}return!!i&&(t.preventDefault(),!0)},i.prototype._keypress=function(t){var i=this._edt;if(i&&"checkbox"!=i.type&&this._list&&this._list.length>0&&t.charCode>=32&&e.getActiveElement()==i){var o=i.selectionStart,n=i.value.substr(0,o);o++,n+=String.fromCharCode(t.charCode);var r=this._findString(this._list,n,!0);r<0&&(r=this._findString(this._list,n,!1)),r>-1&&(i.value=this._list[r],e.setSelectionRange(i,o,i.value.length),i.dispatchEvent(this._evtInput),t.preventDefault())}},i.prototype._findString=function(e,t,i){i||(t=t.toLowerCase());for(var o=0;o<e.length;o++){var n=e[o];if(i||(n=n.toLowerCase()),0==n.indexOf(t))return o}return-1},i.prototype._toggleListBox=function(t,i){var o=this._g,n=o._selHdl.selection;if(i||(i=n),this._lbx&&(this._removeListBox(),n.contains(i)))return o.activeEditor?o.activeEditor.focus():o.containsFocus()||o.focus(),!0;var r=o.isTouching,s=o._getBindingColumn(o.cells,i.row,o.columns[i.col]);return!(!e.input||!s.dataMap||!1===s.showDropDown)&&(!(!e.input||!this.startEditing(!0,i.row,i.col,!r,t))&&(this._lbx=this._createListBox(),this._lbx.showSelection(),r&&this._lbx.focus(),!0))},i.prototype._createListBox=function(){var t=this,i=this._g,o=this._rng,n=i.rows[o.row],r=i._getBindingColumn(i.cells,o.row,i.columns[o.col]),s=document.createElement("div"),l=new e.input.ListBox(s);this._removeListBox(),e.addClass(s,"wj-dropdown-panel wj-grid-listbox"),l.maxHeight=4*n.renderHeight,l.isContentHtml=r.isContentHtml,l.itemsSource=r.dataMap.getDisplayValues(n.dataItem),l.selectedValue=i.activeEditor?i.activeEditor.value:i.getCellData(o.row,o.col,!0),e.addClass(s,r.dropDownCssClass),l.addEventListener(l.hostElement,"click",function(){t._removeListBox(),i.focus(),t.finishEditing()}),l.lostFocus.addHandler(function(){t._removeListBox()}),l.selectedIndexChanged.addHandler(function(){var o=i.activeEditor;o&&(o.value=t._lbx.selectedValue,o.dispatchEvent(t._evtInput),e.setSelectionRange(o,0,o.value.length))});var a=i.cells.getCellElement(o.row,o.col);return a?e.showPopup(s,a,!1,!1,!1):(e.showPopup(s,i.getCellBoundingRect(o.row,o.col)),s[e.Control._OWNR_KEY]=i.hostElement),l},i.prototype._removeListBox=function(){var t=this._lbx;t&&(this._lbx=null,e.hidePopup(t.hostElement,function(){t.dispose()}))},i}();t._EditHandler=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])};return function(t,i){function o(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(o.prototype=i.prototype,new o)}}(),wijmo;!function(e){!function(t){"use strict";var i=function(){function i(e){this._nrt=new o,this._g=e,this._keydownBnd=this._keydown.bind(this),this._attach()}return Object.defineProperty(i.prototype,"newRowAtTop",{get:function(){return this._top},set:function(t){t!=this.newRowAtTop&&(this._top=e.asBoolean(t),this.updateNewRowTemplate())},enumerable:!0,configurable:!0}),i.prototype.updateNewRowTemplate=function(){var e=this._g,i=e.editableCollectionView,o=e.rows,n=i&&i.canAddNew&&e.allowAddNew&&!e.isReadOnly,r=o.indexOf(this._nrt),s=this._top?0:o.length-1,l=!1;if(!n&&r>-1){var a=e.selection;a.row==r&&e.select(a.row-1,a.col),o.removeAt(r)}else n&&(r<0?l=!0:r!=s&&(o.removeAt(r),l=!0),l&&(this._top?o.insert(0,this._nrt):o.push(this._nrt)),this._nrt&&this._nrt._setFlag(t.RowColFlags.ParentCollapsed,!1))},i.prototype._attach=function(){var e=this._g;e&&(e.beginningEdit.addHandler(this._beginningEdit,this),e.pastingCell.addHandler(this._beginningEdit,this),e.rowEditEnded.addHandler(this._rowEditEnded,this),e.loadedRows.addHandler(this.updateNewRowTemplate,this),e.hostElement.addEventListener("keydown",this._keydownBnd,!0))},i.prototype._detach=function(){var e=this._g;e&&(e.beginningEdit.removeHandler(this._beginningEdit),e.pastingCell.removeHandler(this._beginningEdit),e.rowEditEnded.removeHandler(this._rowEditEnded),e.loadedRows.removeHandler(this.updateNewRowTemplate),e.hostElement.removeEventListener("keydown",this._keydownBnd,!0))},i.prototype._keydown=function(t){t.defaultPrevented||t.keyCode!=e.Key.Escape||null==this._g.activeEditor&&this._top&&this._nrt.dataItem&&(this._nrt.dataItem=null,this._g.invalidate())},i.prototype._beginningEdit=function(t,i){if(!i.cancel){var n=this._g.rows[i.row];if(e.tryCast(n,o)){var r=this._g.editableCollectionView;if(r&&r.canAddNew)if(this._top){if(null==this._nrt.dataItem){var s=null,l=r.sourceCollection,a=r.newItemCreator;s=e.isFunction(a)?a():l&&l.length?new l[0].constructor:{},this._nrt.dataItem=s}}else{s=r.currentAddItem&&r.currentAddItem==n.dataItem?r.currentAddItem:r.addNew();r.moveCurrentTo(s),this.updateNewRowTemplate(),this._g.refresh(!0),this._g.onRowAdded(i),i.cancel&&r.cancelNew()}}}},i.prototype._rowEditEnded=function(e,t){var i=this,o=this._g.editableCollectionView,n=this._nrt.dataItem;if(o)if(o.isAddingNew)o.commitNew();else if(n&&!t.cancel){this._nrt.dataItem=null;var r=o.addNew();for(var s in n)r[s]=n[s];this._g.onRowAdded(t),t.cancel?o.cancelNew():o.commitNew(),setTimeout(function(){i._g.select(0,i._g.columns.firstVisibleIndex),i.updateNewRowTemplate()},20)}},i}();t._AddNewHandler=i;var o=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t}(t.Row);t._NewRowTemplate=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){"use strict";var i=function(){function t(i){this._compStartBnd=this._compositionstart.bind(this),this._updateImeFocusBnd=this._updateImeFocus.bind(this),this._mouseDownBnd=this._mousedown.bind(this),this._mouseUpBnd=this._mouseup.bind(this),this._g=i,this._tbx=e.createElement('<input class="wj-grid-editor wj-form-control wj-grid-ime"/>'),e.disableAutoComplete(this._tbx),e.setCss(this._tbx,t._cssHidden),i.cells.hostElement.parentElement.appendChild(this._tbx),this._updateImeFocus();var o=i.hostElement,n=i.addEventListener.bind(this);n(this._tbx,"compositionstart",this._compStartBnd),n(o,"blur",this._updateImeFocusBnd),n(o,"focus",this._updateImeFocusBnd),n(o,"mousedown",this._mouseDownBnd,!0),n(o,"mouseup",this._mouseUpBnd,!0),i.cellEditEnded.addHandler(this._cellEditEnded,this),i.selectionChanged.addHandler(this._updateImeFocus,this)}return t.prototype.dispose=function(){var t=this._g,i=t.hostElement,o=t.removeEventListener.bind(this);o(this._tbx,"compositionstart",this._compStartBnd),o(i,"blur",this._updateImeFocusBnd),o(i,"focus",this._updateImeFocusBnd),o(i,"mousedown",this._mouseDownBnd),o(i,"mouseup",this._mouseUpBnd),t.cellEditEnded.removeHandler(this._cellEditEnded),t.selectionChanged.removeHandler(this._updateImeFocus),e.removeChild(this._tbx)},t.prototype._cellEditEnded=function(){e.setCss(this._tbx,t._cssHidden),this._tbx.value=""},t.prototype._compositionstart=function(){var t=this,i=this._g;if(null==i.activeEditor){var o=i._selHdl.selection;if(i.startEditing(!1,o.row,o.col,!1)){o=i.editRange;var n=i.cells.hostElement,r=i.columns[o.col].pos+n.offsetLeft,s=i.rows[o.row].pos+n.offsetTop,l=i.getCellBoundingRect(o.row,o.col);if(!o.isSingleCell){var a=i.cells.getCellElement(o.row,o.col);l.width=a.offsetWidth,l.height=a.offsetHeight}o.row<i.frozenRows&&(s+=n.parentElement.scrollTop),o.col<i.frozenColumns&&(r+=n.parentElement.scrollLeft);var c=i.activeEditor,h=c&&c.parentElement?c.parentElement.style.zIndex:"";e.setCss(this._tbx,{position:"absolute",pointerEvents:"",opacity:"",left:r,top:s,width:l.width-1,height:l.height-1,zIndex:h}),c instanceof HTMLInputElement&&"minLength,maxLength,pattern".split(",").forEach(function(i){e.setAttribute(t._tbx,i,c.getAttribute(i))}),i._edtHdl._edt=this._tbx}}},t.prototype._mousedown=function(e){this._isMouseDown=!0,this._updateImeFocus()},t.prototype._mouseup=function(e){this._isMouseDown=!1,this._updateImeFocus()},t.prototype._updateImeFocus=function(){var t=this._g,i=e.getActiveElement();if(!t.activeEditor&&!t.isTouching&&!this._isMouseDown&&e.contains(t.hostElement,i)){var o=this._tbx;this._enableIme()?i!=o&&(o.disabled=!1,o.select()):o.disabled=!0}},t.prototype._enableIme=function(){var t=this._g,i=t.selection,o=i.isValid?t._getBindingColumn(t.cells,i.row,t.columns[i.col]):null;return!!t.canEditCell(i.row,i.col)&&!(!o||o.dataType==e.DataType.Boolean)},t._cssHidden={position:"fixed",pointerEvents:"none",opacity:0,left:-10,top:-10,width:0},t}();t._ImeHandler=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));
/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var wijmo;!function(t){!function(t){!function(t){"use strict"}(t.filter||(t.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(t){!function(e){!function(i){"use strict";var n=function(){function i(e){this._maxValues=250,this._sortValues=!0,this._col=e,this._bnd=e.binding?new t.Binding(e.binding):null}return Object.defineProperty(i.prototype,"showValues",{get:function(){return this._values},set:function(t){this._values=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"filterText",{get:function(){return this._filterText},set:function(e){this._filterText=t.asString(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"maxValues",{get:function(){return this._maxValues},set:function(e){this._maxValues=t.asNumber(e,!1,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"uniqueValues",{get:function(){return this._uniqueValues},set:function(e){this._uniqueValues=t.asArray(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"sortValues",{get:function(){return this._sortValues},set:function(e){this._sortValues=t.asBoolean(e)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"dataMap",{get:function(){return this._map},set:function(i){this._map=t.asType(i,e.DataMap,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"column",{get:function(){return this._col},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isActive",{get:function(){return null!=this._values&&Object.keys(this._values).length>0},enumerable:!0,configurable:!0}),i.prototype.apply=function(e){var i=this.column;return!(this._bnd&&this._values&&Object.keys(this._values).length)||(e=this._bnd.getValue(e),e=this.dataMap?this.dataMap.getDisplayValue(e):i.dataMap?i.dataMap.getDisplayValue(e):t.Globalize.format(e,i.format),void 0!=this._values[e])},i.prototype.clear=function(){this.showValues=null,this.filterText=null},i.prototype.implementsInterface=function(t){return"IColumnFilter"==t},i.prototype._getUniqueValues=function(e,i){var n=[];if(this.uniqueValues){for(var r=this.uniqueValues,o=0;o<r.length;o++){d=r[o];n.push({value:d,text:d.toString()})}return n}var l={},a=e.collectionView,s=a?a.sourceCollection:[];if(i&&a&&a.sourceCollection&&a.filter){var c=this.showValues;this.showValues=null;for(var u=[],o=0;o<s.length;o++)a.filter(s[o])&&u.push(s[o]);s=u,this.showValues=c}for(o=0;o<s.length;o++){var d=e._binding.getValue(s[o]),p=this.dataMap?this.dataMap.getDisplayValue(d):e.dataMap?e.dataMap.getDisplayValue(d):t.Globalize.format(d,e.format);l[p]||(l[p]=!0,n.push({value:d,text:p}))}return n},i}();i.ValueFilter=n}(e.filter||(e.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){!function(e){"use strict";var i=function(i){function n(n,r){var o=i.call(this,n)||this;o._filter=t.asType(r,e.ValueFilter,!1);var l=o.getTemplate();if(o.applyTemplate("wj-control",l,{_divFilter:"div-filter",_cbSelectAll:"cb-select-all",_spSelectAll:"sp-select-all",_divValues:"div-values"}),o._cbSelectAll.tabIndex=0,t.setText(o._spSelectAll,t.culture.FlexGridFilter.selectAll),o._view=new t.collections.CollectionView,r.sortValues){var a=r.column.dataMap||r.dataMap?"text":"value",s=r.column.dataType!=t.DataType.Boolean;o._view.sortDescriptions.push(new t.collections.SortDescription(a,s))}return o._view.filter=o._filterValues.bind(o),o._view.collectionChanged.addHandler(o._updateSelectAllCheck,o),o._filterText="",o._cmbFilter=new t.input.ComboBox(o._divFilter,{placeholder:t.culture.FlexGridFilter.search}),o._lbValues=new t.input.ListBox(o._divValues,{displayMemberPath:"text",checkedMemberPath:"show",itemsSource:o._view,itemFormatter:function(e,i){return i||t.culture.FlexGridFilter.null}}),o._cmbFilter.textChanged.addHandler(o._filterTextChanged,o),o._cbSelectAll.addEventListener("click",o._cbSelectAllClicked.bind(o)),o.updateEditor(),o}return __extends(n,i),Object.defineProperty(n.prototype,"filter",{get:function(){return this._filter},enumerable:!0,configurable:!0}),n.prototype.updateEditor=function(){var t=this,e=this._filter.column,i=this._filter._getUniqueValues(e,!0);this._lbValues.isContentHtml=e.isContentHtml;var n=this._filter.showValues;if(n&&0!=Object.keys(n).length){for(var r in n)for(o=0;o<i.length;o++)if(i[o].text==r){i[o].show=!0;break}}else for(var o=0;o<i.length;o++)i[o].show=!0;this._view.pageSize=20,this._view.sourceCollection=i,this._view.moveCurrentTo(null),setTimeout(function(){t._view.pageSize=t._filter.maxValues,t._cmbFilter.text=t._filter.filterText,t._filterText=t._cmbFilter.text.toLowerCase()})},n.prototype.clearEditor=function(){this._cmbFilter.text="",this._filterText="",this._view.pageSize=0,this._view.refresh();for(var t=this._view.items,e=0;e<t.length;e++)t[e].show=!1;this._view.pageSize=this._filter.maxValues},n.prototype.updateFilter=function(){var t=null,e=this._view.items;if(this._filterText||this._cbSelectAll.indeterminate){t={};for(var i=0;i<e.length;i++){var n=e[i];n.show&&(t[n.text]=!0)}}this._filter.showValues=t,this._filter.filterText=""},n.prototype._filterTextChanged=function(){var t=this;this._toText&&clearTimeout(this._toText),this._toText=setTimeout(function(){var e=t._cmbFilter.text.toLowerCase(),i=e!=t._filterText;t._filterText=e,t._view.refresh(),i&&(t._cbSelectAll.checked=!0,t._cbSelectAllClicked())},300)},n.prototype._filterValues=function(t){return!this._filterText||!(!t||!t.text)&&t.text.toLowerCase().indexOf(this._filterText)>-1},n.prototype._cbSelectAllClicked=function(){for(var t=this._cbSelectAll.checked,e=this._view.items,i=0;i<e.length;i++)e[i].show=t;this._view.refresh()},n.prototype._updateSelectAllCheck=function(){for(var t=0,e=this._view.items,i=0;i<e.length;i++)e[i].show&&t++;0==t?(this._cbSelectAll.checked=!1,this._cbSelectAll.indeterminate=!1):t==e.length?(this._cbSelectAll.checked=!0,this._cbSelectAll.indeterminate=!1):this._cbSelectAll.indeterminate=!0},n.controlTemplate='<div><div wj-part="div-filter"></div><div class="wj-listbox-item"><label><input wj-part="cb-select-all" type="checkbox"> <span wj-part="sp-select-all"></span></label></div><div wj-part="div-values"></div></div>',n}(t.Control);e.ValueFilterEditor=i}(e.filter||(e.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(t){!function(e){!function(i){"use strict";var n=function(){function n(e){this._c1=new i.FilterCondition(this),this._c2=new i.FilterCondition(this),this._and=!0,this._col=e,this._bnd=e.binding?new t.Binding(e.binding):null}return Object.defineProperty(n.prototype,"condition1",{get:function(){return this._c1},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"condition2",{get:function(){return this._c2},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"and",{get:function(){return this._and},set:function(e){this._and=t.asBoolean(e),this._bnd=this._col&&this._col.binding?new t.Binding(this._col.binding):null},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"dataMap",{get:function(){return this._map},set:function(i){this._map=t.asType(i,e.DataMap,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"column",{get:function(){return this._col},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isActive",{get:function(){return this._c1.isActive||this._c2.isActive},enumerable:!0,configurable:!0}),n.prototype.apply=function(e){var i=this._col,n=this._c1,r=this._c2;if(!this._bnd||!this.isActive)return!0;e=this._bnd.getValue(e),i.dataMap?e=i.dataMap.getDisplayValue(e):t.isDate(e)?(t.isString(n.value)||t.isString(r.value))&&(e=t.Globalize.format(e,i.format)):t.isNumber(e)&&(e=t.Globalize.parseFloat(t.Globalize.format(e,i.format)));var o=n.apply(e),l=r.apply(e);return n.isActive&&r.isActive?this._and?o&&l:o||l:n.isActive?o:!r.isActive||l},n.prototype.clear=function(){this._c1.clear(),this._c2.clear(),this.and=!0},n.prototype.implementsInterface=function(t){return"IColumnFilter"==t},n}();i.ConditionFilter=n}(e.filter||(e.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){!function(e){"use strict";var i=function(i){function n(n,r){var o=i.call(this,n)||this;o._filter=t.asType(r,e.ConditionFilter,!1);var l=o.getTemplate();o.applyTemplate("wj-control",l,{_divHdr:"div-hdr",_divCmb1:"div-cmb1",_divVal1:"div-val1",_btnAnd:"btn-and",_btnOr:"btn-or",_spAnd:"sp-and",_spOr:"sp-or",_divCmb2:"div-cmb2",_divVal2:"div-val2"});var a=t.culture.FlexGridFilter;t.setText(o._divHdr,a.header),t.setText(o._spAnd,a.and),t.setText(o._spOr,a.or),o._cmb1=o._createOperatorCombo(o._divCmb1),o._cmb2=o._createOperatorCombo(o._divCmb2),o._val1=o._createValueInput(o._divVal1),o._val2=o._createValueInput(o._divVal2);var s=o.hostElement;return o.addEventListener(s,"change",o._btnAndOrChanged.bind(o)),o.addEventListener(s,"keydown",o._keydown.bind(o)),o.updateEditor(),o}return __extends(n,i),Object.defineProperty(n.prototype,"filter",{get:function(){return this._filter},enumerable:!0,configurable:!0}),n.prototype.updateEditor=function(){var e=this._filter.condition1,i=this._filter.condition2;this._cmb1.selectedValue=e.operator,this._cmb2.selectedValue=i.operator,this._val1 instanceof t.input.ComboBox?(this._val1.text=t.changeType(e.value,t.DataType.String,null),this._val2.text=t.changeType(i.value,t.DataType.String,null)):(this._val1.value=e.value,this._val2.value=i.value);var n=this._filter.and;this._checkRadio(this._btnAnd,n),this._checkRadio(this._btnOr,!n)},n.prototype.clearEditor=function(){this._cmb1.selectedValue=this._cmb2.selectedValue=null,this._val1.text=this._val2.text=null,this._checkRadio(this._btnAnd,!0),this._checkRadio(this._btnOr,!1)},n.prototype.updateFilter=function(){var e=this._filter.column,i=this._filter.condition1,n=this._filter.condition2;if(i.operator=this._cmb1.selectedValue,n.operator=this._cmb2.selectedValue,this._val1 instanceof t.input.ComboBox){var r=e.dataType==t.DataType.Date?t.DataType.String:e.dataType;i.value=t.changeType(this._val1.text,r,e.format),n.value=t.changeType(this._val2.text,r,e.format)}else i.value=this._val1.value,n.value=this._val2.value;this._filter.and=this._btnAnd.checked},n.prototype._createOperatorCombo=function(e){var i=this._filter.column,n=t.culture.FlexGridFilter,r=n.stringOperators;i.dataType==t.DataType.Date?r=n.dateOperators:i.dataType!=t.DataType.Number||i.dataMap?i.dataType!=t.DataType.Boolean||i.dataMap||(r=n.booleanOperators):r=n.numberOperators;var o=new t.input.ComboBox(e);return o.itemsSource=r,o.displayMemberPath="name",o.selectedValuePath="op",o},n.prototype._createValueInput=function(e){var i=this._filter.column,n=this._filter.dataMap||i.dataMap,r=null;return i.dataType==t.DataType.Date&&this._hasDatePart(i.format)?(r=this._hasTimePart(i.format)?new t.input.InputDateTime(e):new t.input.InputDate(e)).format=i.format:i.dataType!=t.DataType.Number||n?(r=new t.input.ComboBox(e),n?(r.itemsSource=n.getDisplayValues(),r.isEditable=!0):i.dataType==t.DataType.Boolean&&(r.itemsSource=[!0,!1])):(r=new t.input.InputNumber(e)).format=i.format,r.isRequired=!1,r},n.prototype._hasDatePart=function(e){return!!e&&(e=t.culture.Globalize.calendar.patterns[e]||e,/[yMd]+/.test(e))},n.prototype._hasTimePart=function(e){return!!e&&(e=t.culture.Globalize.calendar.patterns[e]||e,/[Hmst]+/.test(e))},n.prototype._btnAndOrChanged=function(t){var e=t.target==this._btnAnd,i=t.target==this._btnOr;(e||i)&&(this._checkRadio(this._btnAnd,e),this._checkRadio(this._btnOr,i))},n.prototype._checkRadio=function(t,e){t.checked=e,t.setAttribute("aria-checked",e.toString()),t.setAttribute("tabindex",e?"1":"-1")},n.prototype._keydown=function(e){var i=e.target==this._btnAnd,n=e.target==this._btnOr;if(i||n)switch(e.keyCode){case t.Key.Left:case t.Key.Right:case t.Key.Up:case t.Key.Down:var r=i?this._btnOr:this._btnAnd;r.click(),r.focus(),e.preventDefault()}},n.controlTemplate='<div><div wj-part="div-hdr"></div><div wj-part="div-cmb1"></div><br/><div wj-part="div-val1"></div><br/><div role="radiogroup" style="text-align:center"><label><input wj-part="btn-and" type="radio" role="radio"> <span wj-part="sp-and"></span> </label>&nbsp;&nbsp;&nbsp;<label><input wj-part="btn-or" type="radio" role="radio"> <span wj-part="sp-or"></span> </label></div><div wj-part="div-cmb2"></div><br/><div wj-part="div-val2"></div><br/></div>',n}(t.Control);e.ConditionFilterEditor=i}(e.filter||(e.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(t){!function(e){!function(e){"use strict";var i=function(){function e(t){this._op=null,this._filter=t}return Object.defineProperty(e.prototype,"operator",{get:function(){return this._op},set:function(e){this._op=t.asEnum(e,n,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"value",{get:function(){return this._val},set:function(e){if(this._val=e,this._strVal=t.isString(e)?e.toString().toLowerCase():null,this._mapVal=null,this._filter){var i=this._filter.dataMap||this._filter.column.dataMap;i&&(this._mapVal=i.getDisplayValue(e),t.isString(this._mapVal)&&(this._strVal=this._mapVal=this._mapVal.toLowerCase()))}},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isActive",{get:function(){switch(this._op){case null:return!1;case n.EQ:case n.NE:return!0;default:return null!=this._val||null!=this._strVal}},enumerable:!0,configurable:!0}),e.prototype.clear=function(){this.operator=null,this.value=null},e.prototype.apply=function(e){var i=this._mapVal||this._strVal||this._val;switch(t.isString(e)&&(e=e.toLowerCase()),t.isString(i)&&null==e&&(e=""),this._op){case null:return!0;case n.EQ:return t.isDate(e)&&t.isDate(i)?t.DateTime.sameDate(e,i):e==i;case n.NE:return e!=i;case n.GT:return e>i;case n.GE:return e>=i;case n.LT:return e<i;case n.LE:return e<=i;case n.BW:return!(!this._strVal||!t.isString(e))&&0==e.indexOf(this._strVal);case n.EW:return!!(this._strVal&&t.isString(e)&&e.length>=this._strVal.length)&&e.substr(e.length-this._strVal.length)==i;case n.CT:return!(!this._strVal||!t.isString(e))&&e.indexOf(this._strVal)>-1;case n.NC:return!(!this._strVal||!t.isString(e))&&e.indexOf(this._strVal)<0}throw"Unknown operator"},e}();e.FilterCondition=i;var n;!function(t){t[t.EQ=0]="EQ",t[t.NE=1]="NE",t[t.GT=2]="GT",t[t.GE=3]="GE",t[t.LT=4]="LT",t[t.LE=5]="LE",t[t.BW=6]="BW",t[t.EW=7]="EW",t[t.CT=8]="CT",t[t.NC=9]="NC"}(n=e.Operator||(e.Operator={}))}(e.filter||(e.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(t){!function(e){!function(e){"use strict";var i=function(){function i(t,i){this._owner=t,this._col=i,this._valueFilter=new e.ValueFilter(i),this._conditionFilter=new e.ConditionFilter(i)}return Object.defineProperty(i.prototype,"filterType",{get:function(){return null!=this._filterType?this._filterType:this._owner.defaultFilterType},set:function(i){if((i=t.asEnum(i,e.FilterType,!0))!=this._filterType){var n=this.isActive;this.clear(),this._filterType=i,n?this._owner.apply():this._col.grid&&this._col.grid.invalidate()}},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"dataMap",{get:function(){return this.conditionFilter.dataMap||this.valueFilter.dataMap},set:function(t){this.conditionFilter.dataMap=t,this.valueFilter.dataMap=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"valueFilter",{get:function(){return this._valueFilter},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"conditionFilter",{get:function(){return this._conditionFilter},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"column",{get:function(){return this._col},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isActive",{get:function(){return this._conditionFilter.isActive||this._valueFilter.isActive},enumerable:!0,configurable:!0}),i.prototype.apply=function(t){return this._conditionFilter.apply(t)&&this._valueFilter.apply(t)},i.prototype.clear=function(){this._valueFilter.clear(),this._conditionFilter.clear()},i.prototype.implementsInterface=function(t){return"IColumnFilter"==t},i}();e.ColumnFilter=i}(e.filter||(e.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),wijmo;!function(t){!function(e){!function(i){"use strict";t.culture.FlexGridFilter=window.wijmo.culture.FlexGridFilter||{ariaLabel:"Filter Editor for Column",ascending:"↑ Ascending",descending:"↓ Descending",apply:"Apply",cancel:"Cancel",clear:"Clear",conditions:"Filter by Condition",values:"Filter by Value",search:"Search",selectAll:"Select All",null:"(nothing)",header:"Show items where the value",and:"And",or:"Or",stringOperators:[{name:"(not set)",op:null},{name:"Equals",op:i.Operator.EQ},{name:"Does not equal",op:i.Operator.NE},{name:"Begins with",op:i.Operator.BW},{name:"Ends with",op:i.Operator.EW},{name:"Contains",op:i.Operator.CT},{name:"Does not contain",op:i.Operator.NC}],numberOperators:[{name:"(not set)",op:null},{name:"Equals",op:i.Operator.EQ},{name:"Does not equal",op:i.Operator.NE},{name:"Is Greater than",op:i.Operator.GT},{name:"Is Greater than or equal to",op:i.Operator.GE},{name:"Is Less than",op:i.Operator.LT},{name:"Is Less than or equal to",op:i.Operator.LE}],dateOperators:[{name:"(not set)",op:null},{name:"Equals",op:i.Operator.EQ},{name:"Is Before",op:i.Operator.LT},{name:"Is After",op:i.Operator.GT}],booleanOperators:[{name:"(not set)",op:null},{name:"Equals",op:i.Operator.EQ},{name:"Does not equal",op:i.Operator.NE}]};var n=function(n){function r(e,r,o){void 0===o&&(o=!0);var l=n.call(this,e,null,!0)||this;l.filterChanged=new t.Event,l.buttonClicked=new t.Event,l._filter=t.asType(r,i.ColumnFilter);var a=l.getTemplate();l.applyTemplate("wj-control wj-content wj-columnfiltereditor",a,{_divSort:"div-sort",_btnAsc:"btn-asc",_btnDsc:"btn-dsc",_divType:"div-type",_aVal:"a-val",_aCnd:"a-cnd",_divEdtVal:"div-edt-val",_divEdtCnd:"div-edt-cnd",_btnApply:"btn-apply",_btnCancel:"btn-cancel",_btnClear:"btn-clear"});var s=t.culture.FlexGridFilter;t.setText(l._btnAsc,s.ascending),t.setText(l._btnDsc,s.descending),t.setText(l._aVal,s.values),t.setText(l._aCnd,s.conditions),t.setText(l._btnApply,s.apply),t.setText(l._btnCancel,s.cancel),t.setText(l._btnClear,s.clear);var c=l.filter.conditionFilter.isActive||0==(r.filterType&i.FilterType.Value)?i.FilterType.Condition:i.FilterType.Value;l._showFilter(c);var u=l.filter.column.grid.collectionView;o&&u&&u.canSort||(l._divSort.style.display="none");var d=l._btnClicked.bind(l);return l._btnApply.addEventListener("click",d),l._btnCancel.addEventListener("click",d),l._btnClear.addEventListener("click",d),l._btnAsc.addEventListener("click",d),l._btnDsc.addEventListener("click",d),l._aVal.addEventListener("click",d),l._aCnd.addEventListener("click",d),l.hostElement.addEventListener("keydown",function(e){if(!e.defaultPrevented)switch(e.keyCode){case t.Key.Enter:switch(e.target.tagName){case"A":case"BUTTON":l._btnClicked(e);break;default:l.updateFilter(),l.onFilterChanged(),l.onButtonClicked()}e.preventDefault();break;case t.Key.Escape:l.onButtonClicked(),e.preventDefault();break;case t.Key.Tab:t.moveFocus(l.hostElement,e.shiftKey?-1:1),e.preventDefault()}}),l}return __extends(r,n),Object.defineProperty(r.prototype,"filter",{get:function(){return this._filter},enumerable:!0,configurable:!0}),r.prototype.updateEditor=function(){this._edtVal&&this._edtVal.updateEditor(),this._edtCnd&&this._edtCnd.updateEditor()},r.prototype.updateFilter=function(){switch(this._getFilterType()){case i.FilterType.Value:this._edtVal.updateFilter(),this.filter.conditionFilter.clear();break;case i.FilterType.Condition:this._edtCnd.updateFilter(),this.filter.valueFilter.clear()}},r.prototype.onFilterChanged=function(t){this.filterChanged.raise(this,t)},r.prototype.onButtonClicked=function(t){this.buttonClicked.raise(this,t)},r.prototype._handleResize=function(){this.isTouching||this._wasTouching||this.onButtonClicked()},r.prototype._showFilter=function(t){switch(this._wasTouching=this.isTouching,t==i.FilterType.Value&&null==this._edtVal&&(this._edtVal=new i.ValueFilterEditor(this._divEdtVal,this.filter.valueFilter)),t==i.FilterType.Condition&&null==this._edtCnd&&(this._edtCnd=new i.ConditionFilterEditor(this._divEdtCnd,this.filter.conditionFilter)),0!=(t&this.filter.filterType)&&(t==i.FilterType.Value?(this._divEdtVal.style.display="",this._divEdtCnd.style.display="none",this._enableLink(this._aVal,!1),this._enableLink(this._aCnd,!0),this._edtVal.focus()):(this._divEdtVal.style.display="none",this._divEdtCnd.style.display="",this._enableLink(this._aVal,!0),this._enableLink(this._aCnd,!1),this._edtCnd.focus())),this.filter.filterType){case i.FilterType.None:case i.FilterType.Condition:case i.FilterType.Value:this._divType.style.display="none";break;default:this._divType.style.display=""}},r.prototype._enableLink=function(e,i){t.setCss(e,{textDecoration:i?"":"none",fontWeight:i?"":"bold",color:i?"":"inherit"}),t.toggleClass(e,"wj-state-disabled",!i),t.setAttribute(e,"href",i?"":null),t.setAttribute(e,"disabled",i?null:"disabled")},r.prototype._getFilterType=function(){var t=e.filter.FilterType;return"none"!=this._divEdtVal.style.display?t.Value:t.Condition},r.prototype._btnClicked=function(e){if(e.preventDefault(),e.stopPropagation(),!t.hasClass(e.target,"wj-state-disabled")){if(e.target==this._aVal)return this._showFilter(i.FilterType.Value),void t.moveFocus(this._edtVal.hostElement,0);if(e.target==this._aCnd)return this._showFilter(i.FilterType.Condition),void t.moveFocus(this._edtCnd.hostElement,0);if(e.target==this._btnAsc||e.target==this._btnDsc){var n=this.filter.column,r=n.sortMemberPath?n.sortMemberPath:n.binding,o=n.grid.collectionView,l=new t.collections.SortDescription(r,e.target==this._btnAsc);o.sortDescriptions.deferUpdate(function(){o.sortDescriptions.clear(),o.sortDescriptions.push(l)})}e.target==this._btnApply?(this.updateFilter(),this.onFilterChanged()):e.target==this._btnClear?this.filter.isActive&&(this.filter.clear(),this.onFilterChanged()):this.updateEditor(),this.onButtonClicked()}},r.controlTemplate='<div><div wj-part="div-sort"><a wj-part="btn-asc" class="wj-btn" style="min-width:95px"></a>&nbsp;&nbsp;&nbsp;<a wj-part="btn-dsc" class="wj-btn" style="min-width:95px"></a></div><div style="text-align:right;margin:10px 0px;font-size:80%"><div wj-part="div-type"><a wj-part="a-cnd" href="" draggable="false"></a>&nbsp;|&nbsp;<a wj-part="a-val" href="" draggable="false"></a></div></div><div wj-part="div-edt-val" tabindex="-1"></div><div wj-part="div-edt-cnd" tabindex="-1"></div><div style="text-align:right;margin-top:10px"><a wj-part="btn-apply" class="wj-btn"></a>&nbsp;&nbsp;<a wj-part="btn-cancel" class="wj-btn"></a>&nbsp;&nbsp;<a wj-part="btn-clear" class="wj-btn"></a></div>',r}(t.Control);i.ColumnFilterEditor=n}(e.filter||(e.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(t){!function(e){!function(i){"use strict";var n;!function(t){t[t.None=0]="None",t[t.Condition=1]="Condition",t[t.Value=2]="Value",t[t.Both=3]="Both"}(n=i.FilterType||(i.FilterType={}));var r=function(){function r(i,r){this._showIcons=!0,this._showSort=!0,this._defFilterType=n.Both,this.filterApplied=new t.Event,this.filterChanging=new t.Event,this.filterChanged=new t.Event;var o="Missing dependency: FlexGridFilter requires ";t.assert(null!=t.grid,o+"wijmo.grid."),t.assert(null!=t.input,o+"wijmo.input."),this._filters=[],this._g=t.asType(i,e.FlexGrid,!1),this._g.formatItem.addHandler(this._formatItem.bind(this)),this._g.itemsSourceChanged.addHandler(this.clear.bind(this));var l=this._g.hostElement;i.addEventListener(l,"mousedown",this._mousedown.bind(this),!0),i.addEventListener(l,"click",this._click.bind(this),!0),i.addEventListener(l,"keydown",this._keydown.bind(this),!0),this._g.invalidate(),r&&t.copy(this,r)}return Object.defineProperty(r.prototype,"grid",{get:function(){return this._g},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"filterColumns",{get:function(){return this._filterColumns},set:function(e){this._filterColumns=t.asArray(e),this.clear()},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"showFilterIcons",{get:function(){return this._showIcons},set:function(e){e!=this.showFilterIcons&&(this._showIcons=t.asBoolean(e),this._g&&this._g.invalidate())},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"showSortButtons",{get:function(){return this._showSort},set:function(e){this._showSort=t.asBoolean(e)},enumerable:!0,configurable:!0}),r.prototype.getColumnFilter=function(t,e){void 0===e&&(e=!0),t=this._asColumn(t);for(var n=0;n<this._filters.length;n++)if(this._filters[n].column==t)return this._filters[n];if(e&&t.binding){var r=new i.ColumnFilter(this,t);return this._filters.push(r),r}return null},Object.defineProperty(r.prototype,"defaultFilterType",{get:function(){return this._defFilterType},set:function(e){(e=t.asEnum(e,n,!1))!=this.defaultFilterType&&(this._defFilterType=e,this._g.invalidate(),this.clear())},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"filterDefinition",{get:function(){for(var t={defaultFilterType:this.defaultFilterType,filters:[]},e=0;e<this._filters.length;e++){var i=this._filters[e];if(i&&i.column&&i.column.binding)if(i.conditionFilter.isActive){var n=i.conditionFilter;t.filters.push({binding:i.column.binding,type:"condition",condition1:{operator:n.condition1.operator,value:n.condition1.value},and:n.and,condition2:{operator:n.condition2.operator,value:n.condition2.value}})}else if(i.valueFilter.isActive){var r=i.valueFilter;t.filters.push({binding:i.column.binding,type:"value",filterText:r.filterText,showValues:r.showValues})}}return JSON.stringify(t)},set:function(e){if(e=t.asString(e),this.clear(),e){var i=JSON.parse(e);this.defaultFilterType=i.defaultFilterType;for(var n=0;n<i.filters.length;n++){var r=i.filters[n],o=this._g.getColumn(r.binding),l=this.getColumnFilter(o,!0);if(l)switch(r.type){case"condition":var a=l.conditionFilter;a.condition1.value=o.dataType==t.DataType.Date?t.changeType(r.condition1.value,o.dataType,null):r.condition1.value,a.condition1.operator=r.condition1.operator,a.and=r.and,a.condition2.value=o.dataType==t.DataType.Date?t.changeType(r.condition2.value,o.dataType,null):r.condition2.value,a.condition2.operator=r.condition2.operator;break;case"value":var s=l.valueFilter;s.filterText=r.filterText,s.showValues=r.showValues}}}this.apply()},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"activeEditor",{get:function(){return t.Control.getControl(this._divEdt)},enumerable:!0,configurable:!0}),r.prototype.editColumnFilter=function(n,r){var o=this;this.closeEditor(),n=this._asColumn(n);var l=document.createElement("div"),a=this.getColumnFilter(n),s=new i.ColumnFilterEditor(l,a,this.showSortButtons);t.addClass(l,"wj-dropdown-panel"),t.setAttribute(l,"role","dialog"),t.setAttribute(l,"aria-label",t.culture.FlexGridFilter.ariaLabel+" "+n.header),this._divEdt=l,this._edtCol=n;var c=new e.CellRangeEventArgs(this._g.cells,new e.CellRange(-1,n.index));if(this.onFilterChanging(c)){c.cancel=!0,this._g.rightToLeft&&(l.dir="rtl"),s.filterChanged.addHandler(function(){c.cancel=!1,setTimeout(function(){c.cancel||o.apply()})}),s.buttonClicked.addHandler(function(){o.closeEditor(),o._g.focus(),o.onFilterChanged(c)}),s.lostFocus.addHandler(function(){setTimeout(function(){var e=t.Control.getControl(o._divEdt);e&&!e.containsFocus()&&o.closeEditor()},10)});var u=this._g;u._edtHdl._commitRowEdits(),u.scrollIntoView(-1,n.index,!0);var d=this._g.columnHeaders,p=r?r.row:d.rows.length-1,h=r?r.col:n.index,f=d.getCellBoundingRect(p,h),_=d.getCellElement(p,h);_?t.showPopup(l,_,!1,!1,!1):t.showPopup(l,f),s.focus()}else this._divEdt=this._edtCol=null},r.prototype.closeEditor=function(){if(this._divEdt){var e=t.Control.getControl(this._divEdt);e&&t.hidePopup(e.hostElement,function(){e.dispose()}),this._divEdt=null,this._edtCol=null}},r.prototype.apply=function(){var e=this._g.collectionView;if(e){var i=this._g.editableCollectionView;i&&(i.commitEdit(),i.commitNew()),e.filter?e.refresh():e.filter=this._filter.bind(this)}var n=e?e.updateFilterDefinition:null;t.isFunction(n)&&n.call(e,this),this.onFilterApplied()},r.prototype.clear=function(){this._filters.length&&(this._filters=[],this.apply())},r.prototype.onFilterApplied=function(t){this.filterApplied.raise(this,t)},r.prototype.onFilterChanging=function(t){return this.filterChanging.raise(this,t),!t.cancel},r.prototype.onFilterChanged=function(t){this.filterChanged.raise(this,t)},r.prototype._asColumn=function(i){return t.isString(i)?this._g.getColumn(i):t.isNumber(i)?this._g.columns[i]:t.asType(i,e.Column,!1)},r.prototype._filter=function(t){for(var e=0;e<this._filters.length;e++)if(!this._filters[e].apply(t))return!1;return!0},r.prototype._formatItem=function(i,o){if(o.panel==i.columnHeaders){var l=this._g,a=l.getMergedRange(o.panel,o.row,o.col)||new e.CellRange(o.row,o.col),s=l.columns[a.col],c=l._getBindingColumn(o.panel,o.row,s);if(a.row2==o.panel.rows.length-1||s!=c){var u=this.getColumnFilter(c,this.defaultFilterType!=n.None);if(this._filterColumns&&this._filterColumns.indexOf(c.binding)<0&&(u=null),u&&u.filterType!=n.None){if(this._showIcons){r._filterGlyph||(r._filterGlyph=t.createElement('<div role="button" class="'+r._WJC_FILTER+'"><span class="wj-glyph-filter"></span></div> '));var d=o.cell.querySelector("div")||o.cell;d.querySelector(".wj-glyph-filter")||d.insertBefore(r._filterGlyph.cloneNode(!0),d.firstChild)}t.toggleClass(o.cell,"wj-filter-on",u.isActive),t.toggleClass(o.cell,"wj-filter-off",!u.isActive)}else t.removeClass(o.cell,"wj-filter-on"),t.removeClass(o.cell,"wj-filter-off")}}},r.prototype._mousedown=function(t){this._toggleEditor(t)&&(this._tmd=!0,t.stopPropagation(),t.preventDefault())},r.prototype._click=function(t){(this._tmd||this._toggleEditor(t))&&(t.stopPropagation(),t.preventDefault()),this._tmd=!1},r.prototype._toggleEditor=function(i){var n=this;if(this._tmd=!1,!i.defaultPrevented&&0==i.button)if(t.closestClass(i.target,r._WJC_FILTER)){var o=this._g,l=new e.HitTestInfo(i.target,null);if(l.panel||(l=o.hitTest(i,!0)),l.panel==o.columnHeaders){var a=o.columns[l.col],s=o._getBindingColumn(l.panel,l.row,a);return this._divEdt&&this._edtCol==s?(this.closeEditor(),o.focus()):setTimeout(function(){n.editColumnFilter(s,l)},this._divEdt?100:0),!0}}else this.closeEditor();return!1},r.prototype._keydown=function(e){if(!e.defaultPrevented&&!e.ctrlKey&&e.altKey&&(e.keyCode==t.Key.Down||e.keyCode==t.Key.Up)){var i=this.grid.selection,n=i.col>-1?this.grid.columns[i.col]:null;n&&!n.dataMap&&this.getColumnFilter(n,!0)&&(this.editColumnFilter(n),e.preventDefault(),e.stopPropagation())}},r._WJC_FILTER="wj-elem-filter",r}();i.FlexGridFilter=r}(e.filter||(e.filter={}))}(t.grid||(t.grid={}))}(wijmo||(wijmo={}));
/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(){function n(t){this._expressionCache={},this._idChars="$:!",this._functionTable={},this._cacheSize=0,this._tableRefStart=!1,this.unknownFunction=new e.Event,this._owner=t,this._buildSymbolTable(),this._registerAggregateFunction(),this._registerMathFunction(),this._registerLogicalFunction(),this._registerTextFunction(),this._registerDateFunction(),this._registLookUpReferenceFunction(),this._registFinacialFunction()}return n.prototype.onUnknownFunction=function(e,t){var n,i;if(t&&t.length>0){n=[];for(var s=0;s<t.length;s++)n[s]=t[s].evaluate(this._rowIndex,this._columnIndex)}if(i=new o.UnknownFunctionEventArgs(e,n),this.unknownFunction.raise(this,i),null!=i.value)return new o._Expression(i.value);throw'The function "'+e+'" has not supported in FlexSheet yet.'},n.prototype.evaluate=function(t,n,i,s,l){var r;try{if(t&&t.length>1&&"="===t[0]){for(this._containsCellRef=!1,this._rowIndex=s,this._columnIndex=l,this._sheet=i||this._owner.selectedSheet,r=this._checkCache(t).evaluate(s,l,i);r instanceof o._Expression;)r=r.evaluate(s,l,i);return n&&e.isPrimitive(r)?e.Globalize.format(r,n):r}return t||""}catch(e){return"Error: "+e}},n.prototype.addCustomFunction=function(e,t,n,i){var l=this;e=e.toLowerCase(),this._functionTable[e]=new s(function(e){var n,i=[];if(e&&e.length>0)for(var s=0;s<e.length;s++)(n=e[s])instanceof o._CellRangeExpression?i[s]=n.cells:i[s]=n.evaluate(l._rowIndex,l._columnIndex);return t.apply(l,i)},i,n)},n.prototype.addFunction=function(e,t,n,i){var l=this;e=e.toLowerCase(),this._functionTable[e]=new s(function(e){var n,i=[];if(e&&e.length>0)for(var s=0;s<e.length;s++)(n=e[s])instanceof o._CellRangeExpression?i[s]=n.getValuseWithTwoDimensions():i[s]=[[n.evaluate(l._rowIndex,l._columnIndex)]];return t.apply(l,i)},i,n)},n.prototype._clearExpressionCache=function(){this._expressionCache=null,this._expressionCache={},this._cacheSize=0},n.prototype._parse=function(e){return this._expression=e,this._expressLength=e?e.length:0,this._pointer=0,this._expressLength>0&&"="===this._expression[0]&&this._pointer++,this._parseExpression()},n.prototype._buildSymbolTable=function(){this._tokenTable||(this._tokenTable={},this._addToken("+",r.ADD,l.ADDSUB),this._addToken("-",r.SUB,l.ADDSUB),this._addToken("(",r.OPEN,l.GROUP),this._addToken(")",r.CLOSE,l.GROUP),this._addToken("*",r.MUL,l.MULDIV),this._addToken(",",r.COMMA,l.GROUP),this._addToken(".",r.PERIOD,l.GROUP),this._addToken("/",r.DIV,l.MULDIV),this._addToken("\\",r.DIVINT,l.MULDIV),this._addToken("=",r.EQ,l.COMPARE),this._addToken(">",r.GT,l.COMPARE),this._addToken("<",r.LT,l.COMPARE),this._addToken("^",r.POWER,l.POWER),this._addToken("<>",r.NE,l.COMPARE),this._addToken(">=",r.GE,l.COMPARE),this._addToken("<=",r.LE,l.COMPARE),this._addToken("&",r.CONCAT,l.CONCAT),this._addToken("[",r.OPEN,l.SQUAREBRACKETS),this._addToken("]",r.CLOSE,l.SQUAREBRACKETS))},n.prototype._registerAggregateFunction=function(){var t=this;t._functionTable.sum=new s(function(o,n){return t._getAggregateResult(e.Aggregate.Sum,o,n)}),t._functionTable.average=new s(function(o,n){return t._getAggregateResult(e.Aggregate.Avg,o,n)}),t._functionTable.max=new s(function(o,n){return t._getAggregateResult(e.Aggregate.Max,o,n)}),t._functionTable.min=new s(function(o,n){return t._getAggregateResult(e.Aggregate.Min,o,n)}),t._functionTable.var=new s(function(o,n){return t._getAggregateResult(e.Aggregate.Var,o,n)}),t._functionTable.varp=new s(function(o,n){return t._getAggregateResult(e.Aggregate.VarPop,o,n)}),t._functionTable.stdev=new s(function(o,n){return t._getAggregateResult(e.Aggregate.Std,o,n)}),t._functionTable.stdevp=new s(function(o,n){return t._getAggregateResult(e.Aggregate.StdPop,o,n)}),t._functionTable.count=new s(function(e,o){return t._getFlexSheetAggregateResult(a.Count,e,o)}),t._functionTable.counta=new s(function(e,o){return t._getFlexSheetAggregateResult(a.CountA,e,o)}),t._functionTable.countblank=new s(function(e,o){return t._getFlexSheetAggregateResult(a.ConutBlank,e,o)}),t._functionTable.countif=new s(function(e,o){return t._getFlexSheetAggregateResult(a.CountIf,e,o)},2,2),t._functionTable.countifs=new s(function(e,o){return t._getFlexSheetAggregateResult(a.CountIfs,e,o)},254,2),t._functionTable.sumif=new s(function(e,o){return t._getFlexSheetAggregateResult(a.SumIf,e,o)},3,2),t._functionTable.sumifs=new s(function(e,o){return t._getFlexSheetAggregateResult(a.SumIfs,e,o)},255,2),t._functionTable.rank=new s(function(e,o){return t._getFlexSheetAggregateResult(a.Rank,e,o)},3,2),t._functionTable.product=new s(function(e,o){return t._getFlexSheetAggregateResult(a.Product,e,o)},255,1),t._functionTable.subtotal=new s(function(e,o){return t._handleSubtotal(e,o)},255,2),t._functionTable.dcount=new s(function(e,o){return t._handleDCount(e,o)},3,3),t._functionTable.sumproduct=new s(function(e,o){return t._getSumProduct(e,o)},255,1)},n.prototype._registerMathFunction=function(){var t=this,n=["abs","acos","asin","atan","cos","exp","ln","sin","sqrt","tan"],i=["ceiling","floor"],l=["round","rounddown","roundup"];t._functionTable.pi=new s(function(){return Math.PI},0,0),t._functionTable.rand=new s(function(){return Math.random()},0,0),t._functionTable.power=new s(function(e,n){return Math.pow(o._Expression.toNumber(e[0],t._rowIndex,t._columnIndex,n),o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n))},2,2),t._functionTable.atan2=new s(function(e,n){var i=o._Expression.toNumber(e[0],t._rowIndex,t._columnIndex,n),s=o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n);if(0===i&&0===s)throw"The x number and y number can't both be zero for the atan2 function";return Math.atan2(s,i)},2,2),t._functionTable.mod=new s(function(e,n){return o._Expression.toNumber(e[0],t._rowIndex,t._columnIndex,n)%o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n)},2,2),t._functionTable.trunc=new s(function(e,n){var i,s=o._Expression.toNumber(e[0],t._rowIndex,t._columnIndex,n),l=2===e.length?o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n):0;return 0===l?s>=0?Math.floor(s):Math.ceil(s):(i=Math.pow(10,l),s>=0?Math.floor(s*i)/i:Math.ceil(s*i)/i)},2,1),i.forEach(function(e){t._functionTable[e]=new s(function(n,i){var s,l,r,a=o._Expression.toNumber(n[0],t._rowIndex,t._columnIndex,i),h=2===n.length?o._Expression.toNumber(n[1],t._rowIndex,t._columnIndex,i):1;if(isNaN(a))throw"Invalid Number!";if(isNaN(h))throw"Invalid Significance!";if(a>0&&h<0)throw"The significance has to be positive, if the number is positive.";if(0===a||0===h)return 0;if(s=h-Math.floor(h),l=1,0!==s)for(;s<1;)l*=10,s*=10;return r="ceiling"===e?Math.ceil(a/h):Math.floor(a/h),h*l*r/l},2,1)}),l.forEach(function(n){t._functionTable[n]=new s(function(i,s){var l,r,a,h=o._Expression.toNumber(i[0],t._rowIndex,t._columnIndex,s),c=o._Expression.toNumber(i[1],t._rowIndex,t._columnIndex,s);if(0===c){switch(n){case"rounddown":l=h>=0?Math.floor(h):Math.ceil(h);break;case"roundup":l=h>=0?Math.ceil(h):Math.floor(h);break;case"round":l=Math.round(h);break;default:l=Math.floor(h)}r="n0"}else if(c>0&&e.isInt(c)){switch(a=Math.pow(10,c),n){case"rounddown":l=h>=0?Math.floor(h*a)/a:Math.ceil(h*a)/a;break;case"roundup":l=h>=0?Math.ceil(h*a)/a:Math.floor(h*a)/a;break;case"round":l=Math.round(h*a)/a}r="n"+c}if(null!=l)return{value:l,format:r};throw"Invalid precision!"},2,2)}),n.forEach(function(e){t._functionTable[e]=new s(function(n,i){return"ln"===e?Math.log(o._Expression.toNumber(n[0],t._rowIndex,t._columnIndex,i)):Math[e](o._Expression.toNumber(n[0],t._rowIndex,t._columnIndex,i))},1,1)})},n.prototype._registerLogicalFunction=function(){var e=this;e._functionTable.and=new s(function(t,n){var i,s=!0;for(i=0;i<t.length&&(s=s&&o._Expression.toBoolean(t[i],e._rowIndex,e._columnIndex,n));i++);return s},Number.MAX_VALUE,1),e._functionTable.or=new s(function(t,n){var i,s=!1;for(i=0;i<t.length&&!(s=s||o._Expression.toBoolean(t[i],e._rowIndex,e._columnIndex,n));i++);return s},Number.MAX_VALUE,1),e._functionTable.not=new s(function(t,n){return!o._Expression.toBoolean(t[0],e._rowIndex,e._columnIndex,n)},1,1),e._functionTable.if=new s(function(t,n){return 3===t.length?o._Expression.toBoolean(t[0],e._rowIndex,e._columnIndex,n)?t[1].evaluate(e._rowIndex,e._columnIndex,n):t[2].evaluate(e._rowIndex,e._columnIndex,n):!!o._Expression.toBoolean(t[0],e._rowIndex,e._columnIndex,n)&&t[1].evaluate(e._rowIndex,e._columnIndex,n)},3,2),e._functionTable.true=new s(function(){return!0},0,0),e._functionTable.false=new s(function(){return!1},0,0)},n.prototype._registerTextFunction=function(){var t=this;t._functionTable.char=new s(function(e,n){var i,s="";for(i=0;i<e.length;i++)s+=String.fromCharCode(o._Expression.toNumber(e[i],t._rowIndex,t._columnIndex,n));return s},Number.MAX_VALUE,1),t._functionTable.code=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n);return i&&i.length>0?i.charCodeAt(0):-1},1,1),t._functionTable.concatenate=new s(function(e,n){var i,s="";for(i=0;i<e.length;i++)s=s.concat(o._Expression.toString(e[i],t._rowIndex,t._columnIndex,n));return s},Number.MAX_VALUE,1),t._functionTable.left=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n),s=Math.floor(o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n));return i&&i.length>0?i.slice(0,s):null},2,2),t._functionTable.right=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n),s=Math.floor(o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n));return i&&i.length>0?i.slice(-s):null},2,2),t._functionTable.find=new s(function(n,i){var s,l=o._Expression.toString(n[0],t._rowIndex,t._columnIndex,i),r=o._Expression.toString(n[1],t._rowIndex,t._columnIndex,i),a=null!=n[2]?e.asInt(o._Expression.toNumber(n[2],t._rowIndex,t._columnIndex,i)):0;return null!=r&&null!=l&&(s=!isNaN(a)&&a>0&&a<r.length?r.indexOf(l,a):r.indexOf(l))>-1?s+1:-1},3,2),t._functionTable.search=new s(function(n,i){var s,l,r,a=o._Expression.toString(n[0],t._rowIndex,t._columnIndex,i),h=o._Expression.toString(n[1],t._rowIndex,t._columnIndex,i),c=null!=n[2]?e.asInt(o._Expression.toNumber(n[2],t._rowIndex,t._columnIndex,i)):0;return null!=h&&null!=a&&(l=new RegExp(a,"i"),!isNaN(c)&&c>0&&c<h.length?(h=h.substring(c),s=c+1):s=1,(r=h.search(l))>-1)?r+s:-1},3,2),t._functionTable.len=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n);return i?i.length:-1},1,1),t._functionTable.mid=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n),s=Math.floor(o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n)),l=Math.floor(o._Expression.toNumber(e[2],t._rowIndex,t._columnIndex,n));return i&&i.length>0&&s>0?i.substr(s-1,l):null},3,3),t._functionTable.lower=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n);return i&&i.length>0?i.toLowerCase():null},1,1),t._functionTable.upper=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n);return i&&i.length>0?i.toUpperCase():null},1,1),t._functionTable.proper=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n);return i&&i.length>0?i[0].toUpperCase()+i.substring(1).toLowerCase():null},1,1),t._functionTable.trim=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n);return i&&i.length>0?i.trim():null},1,1),t._functionTable.replace=new s(function(e,n){var i=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n),s=Math.floor(o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n)),l=Math.floor(o._Expression.toNumber(e[2],t._rowIndex,t._columnIndex,n)),r=o._Expression.toString(e[3],t._rowIndex,t._columnIndex,n);return i&&i.length>0&&s>0?i.substring(0,s-1)+r+i.slice(s-1+l):null},4,4),t._functionTable.substitute=new s(function(e,n){var i,s=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n),l=o._Expression.toString(e[1],t._rowIndex,t._columnIndex,n),r=o._Expression.toString(e[2],t._rowIndex,t._columnIndex,n),a=4===e.length?o._Expression.toNumber(e[3],t._rowIndex,t._columnIndex,n):null,h=0;if(null!=a&&a<1||isNaN(a))throw"Invalid instance number.";return s&&s.length>0&&l&&l.length>0?(i=new RegExp(l,"g"),s.replace(i,function(e){return h++,null!=a?(a=Math.floor(a),h===a?r:e):r})):null},4,3),t._functionTable.rept=new s(function(e,n){var i,s=o._Expression.toString(e[0],t._rowIndex,t._columnIndex,n),l=Math.floor(o._Expression.toNumber(e[1],t._rowIndex,t._columnIndex,n)),r="";if(s&&s.length>0&&l>0)for(i=0;i<l;i++)r=r.concat(s);return r},2,2),t._functionTable.text=new s(function(n,i){var s,l=n[0].evaluate(t._rowIndex,t._columnIndex,i),r=o._Expression.toString(n[1],t._rowIndex,t._columnIndex,i);if(!e.isPrimitive(l)&&l&&(l=l.value),e.isDate(l))r=r.replace(/\[\$\-.+\]/g,"").replace(/(\\)(.)/g,"$2").replace(/H+/g,function(e){return e.toLowerCase()}).replace(/m+/g,function(e){return e.toUpperCase()}).replace(/S+/g,function(e){return e.toLowerCase()}).replace(/AM\/PM/gi,"tt").replace(/A\/P/gi,"t").replace(/\.000/g,".fff").replace(/\.00/g,".ff").replace(/\.0/g,".f").replace(/\\[\-\s,]/g,function(e){return e.substring(1)}).replace(/Y+/g,function(e){return e.toLowerCase()}).replace(/D+/g,function(e){return e.toLowerCase()}).replace(/M+:?|:?M+/gi,function(e){return e.indexOf(":")>-1?e.toLowerCase():e}).replace(/g+e/gi,function(e){return e.substring(0,e.length-1)+"yy"});else{if(!e.isNumber(l))return l;if((s=r.match(/^(\d+)(\.\d+)?\E\+(\d+)(\.\d+)?$/))&&5===s.length)return t._parseToScientificValue(l,s[1],s[2],s[3],s[4]);/M{1,4}|d{1,4}|y{1,4}/.test(r)?l=new Date(1900,0,l-1):r&&r.indexOf("#")>-1&&(r=e.xlsx.Workbook.fromXlsxFormat(r)[0])}if(e.isDate(l))switch(r){case"d":return l.getDate();case"M":return l.getMonth()+1;case"y":r="yy";break;case"yyy":r="yyyy"}return e.Globalize.format(l,r)},2,2),t._functionTable.value=new s(function(n,i){var s,l=o._Expression.toString(n[0],t._rowIndex,t._columnIndex,i);if((l=l.replace(/(\,\d{3})/g,function(e){return e.substring(1)})).length>0){if(l[0]===e.culture.Globalize.numberFormat.currency.symbol)return+(l=l.substring(1));if("%"===l[l.length-1])return+(l=l.substring(0,l.length-1))/100}return s=+l,isNaN(s)?o._Expression.toNumber(n[0],t._rowIndex,t._columnIndex,i):s},1,1)},n.prototype._registerDateFunction=function(){var t=this;t._functionTable.now=new s(function(){return{value:new Date,format:"M/d/yyyy h:mm"}},0,0),t._functionTable.today=new s(function(){var e=new Date;return{value:new Date(e.getFullYear(),e.getMonth(),e.getDate()),format:"M/d/yyyy"}},0,0),t._functionTable.year=new s(function(n,i){var s=o._Expression.toDate(n[0],t._rowIndex,t._columnIndex,i);return!e.isPrimitive(s)&&s?s.value:e.isDate(s)?s.getFullYear():1900},1,1),t._functionTable.month=new s(function(n,i){var s=o._Expression.toDate(n[0],t._rowIndex,t._columnIndex,i);return!e.isPrimitive(s)&&s?s.value:e.isDate(s)?s.getMonth()+1:1},1,1),t._functionTable.day=new s(function(n,i){var s=o._Expression.toDate(n[0],t._rowIndex,t._columnIndex,i);return!e.isPrimitive(s)&&s?s.value:e.isDate(s)?s.getDate():0},1,1),t._functionTable.hour=new s(function(n,i){var s=n[0].evaluate(t._rowIndex,t._columnIndex,i);if(e.isNumber(s)&&!isNaN(s))return Math.floor(24*(s-Math.floor(s)));if(e.isDate(s))return s.getHours();if(s=o._Expression.toDate(n[0],t._rowIndex,t._columnIndex,i),!e.isPrimitive(s)&&s&&(s=s.value),e.isDate(s))return s.getHours();throw"Invalid parameter."},1,1),t._functionTable.time=new s(function(o,n){var i=o[0].evaluate(t._rowIndex,t._columnIndex,n),s=o[1].evaluate(t._rowIndex,t._columnIndex,n),l=o[2].evaluate(t._rowIndex,t._columnIndex,n);if(e.isNumber(i)&&e.isNumber(s)&&e.isNumber(l))return i%=24,s%=60,l%=60,{value:new Date(0,0,0,i,s,l),format:"h:mm tt"};throw"Invalid parameters."},3,3),t._functionTable.date=new s(function(o,n){var i=o[0].evaluate(t._rowIndex,t._columnIndex,n),s=o[1].evaluate(t._rowIndex,t._columnIndex,n),l=o[2].evaluate(t._rowIndex,t._columnIndex,n);if(e.isNumber(i)&&e.isNumber(s)&&e.isNumber(l))return{value:new Date(i,s-1,l),format:"M/d/yyyy"};throw"Invalid parameters."},3,3),t._functionTable.datedif=new s(function(n,i){var s,l,r,a,h,c=o._Expression.toDate(n[0],t._rowIndex,t._columnIndex,i),d=o._Expression.toDate(n[1],t._rowIndex,t._columnIndex,i),u=n[2].evaluate(t._rowIndex,t._columnIndex,i);if(!e.isPrimitive(c)&&c&&(c=c.value),!e.isPrimitive(d)&&d&&(d=d.value),e.isDate(c)&&e.isDate(d)&&e.isString(u)){if(s=c.getTime(),l=d.getTime(),s>l)throw"Start date is later than end date.";switch(r=d.getDate()-c.getDate(),a=d.getMonth()-c.getMonth(),h=d.getFullYear()-c.getFullYear(),u.toUpperCase()){case"Y":return a>0?h:a<0?h-1:r>=0?h:h-1;case"M":return r>=0?12*h+a:12*h+a-1;case"D":return(l-s)/864e5;case"YM":return(a=r>=0?12*h+a:12*h+a-1)%12;case"YD":return a>0?(new Date(c.getFullYear(),d.getMonth(),d.getDate()).getTime()-c.getTime())/864e5:a<0?(new Date(c.getFullYear()+1,d.getMonth(),d.getDate()).getTime()-c.getTime())/864e5:r>=0?r:(new Date(c.getFullYear()+1,d.getMonth(),d.getDate()).getTime()-c.getTime())/864e5;case"MD":return r>=0?r:r=new Date(d.getFullYear(),d.getMonth(),0).getDate()-new Date(d.getFullYear(),d.getMonth()-1,1).getDate()+1+r;default:throw"Invalid unit."}}throw"Invalid parameters."},3,3)},n.prototype._registLookUpReferenceFunction=function(){var e=this;e._functionTable.column=new s(function(t,n,i,s){var l;if(null==t)return s+1;if(l=t[0],(l=e._ensureNonFunctionExpression(l))instanceof o._CellRangeExpression)return l.cells.col+1;throw"Invalid Cell Reference."},1,0),e._functionTable.columns=new s(function(t,n){var i=t[0];if((i=e._ensureNonFunctionExpression(i))instanceof o._CellRangeExpression)return i.cells.columnSpan;throw"Invalid Cell Reference."},1,1),e._functionTable.row=new s(function(t,n,i,s){var l;if(null==t)return i+1;if(l=t[0],(l=e._ensureNonFunctionExpression(l))instanceof o._CellRangeExpression)return l.cells.row+1;throw"Invalid Cell Reference."},1,0),e._functionTable.rows=new s(function(t,n){var i=t[0];if((i=e._ensureNonFunctionExpression(i))instanceof o._CellRangeExpression)return i.cells.rowSpan;throw"Invalid Cell Reference."},1,1),e._functionTable.choose=new s(function(t,n){var i=o._Expression.toNumber(t[0],e._rowIndex,e._columnIndex,n);if(isNaN(i))throw"Invalid index number.";if(i<1||i>=t.length)throw"The index number is out of the list range.";return t[i].evaluate(e._rowIndex,e._columnIndex,n)},255,2),e._functionTable.index=new s(function(n,i){var s,l=n[0],r=o._Expression.toNumber(n[1],e._rowIndex,e._columnIndex,i),a=null!=n[2]?o._Expression.toNumber(n[2],e._rowIndex,e._columnIndex,i):0;if(isNaN(r)||r<0)throw"Invalid Row Number.";if(isNaN(a)||a<0)throw"Invalid Column Number.";if((l=e._ensureNonFunctionExpression(l))instanceof o._CellRangeExpression){if(s=l.cells,r>s.rowSpan||a>s.columnSpan)throw"Index is out of the cell range.";if(r>0&&a>0)return e._owner.getCellValue(s.topRow+r-1,s.leftCol+a-1,!0,i);if(0===r&&0===a)return l;if(0===r)return new o._CellRangeExpression(new t.CellRange(s.topRow,s.leftCol+a-1,s.bottomRow,s.leftCol+a-1),l.sheetRef,e._owner);if(0===a)return new o._CellRangeExpression(new t.CellRange(s.topRow+r-1,s.leftCol,s.topRow+r-1,s.rightCol),l.sheetRef,e._owner)}throw"Invalid Cell Reference."},4,2),e._functionTable.hlookup=new s(function(t,o){return e._handleHLookup(t,o)},4,3)},n.prototype._registFinacialFunction=function(){var e=this;e._functionTable.rate=new s(function(t,o){return{value:e._calculateRate(t,o),format:"p2"}},6,3)},n.prototype._addToken=function(e,t,o){var n=new i(e,t,o);this._tokenTable[e]=n},n.prototype._parseExpression=function(){return this._getToken(),this._parseCompareOrConcat()},n.prototype._parseCompareOrConcat=function(){for(var e,t,n=this._parseAddSub();this._token.tokenType===l.COMPARE||this._token.tokenType===l.CONCAT;)e=this._token,this._getToken(),t=this._parseAddSub(),n=new o._BinaryExpression(e,n,t);return n},n.prototype._parseAddSub=function(){for(var e,t,n=this._parseMulDiv();this._token.tokenType===l.ADDSUB;)e=this._token,this._getToken(),t=this._parseMulDiv(),n=new o._BinaryExpression(e,n,t);return n},n.prototype._parseMulDiv=function(){for(var e,t,n=this._parsePower();this._token.tokenType===l.MULDIV;)e=this._token,this._getToken(),t=this._parsePower(),n=new o._BinaryExpression(e,n,t);return n},n.prototype._parsePower=function(){for(var e,t,n=this._parseUnary();this._token.tokenType===l.POWER;)e=this._token,this._getToken(),t=this._parseUnary(),n=new o._BinaryExpression(e,n,t);return n},n.prototype._parseUnary=function(){var e,t;return this._token.tokenID===r.ADD||this._token.tokenID===r.SUB?(e=this._token,this._getToken(),t=this._parseAtom(),new o._UnaryExpression(e,t)):this._parseAtom()},n.prototype._parseAtom=function(){var e,t,n,i,s,a,h,c,d,u,_,g,f,p=null;switch(this._token.tokenType){case l.LITERAL:p=new o._Expression(this._token);break;case l.IDENTIFIER:if(e=this._token.value.toString().toLowerCase(),t=this._functionTable[e]){if(n=this._getParameters(),this._token.tokenType===l.GROUP&&this._token.tokenID===r.CLOSE){if(i=n?n.length:0,-1!==t.paramMin&&i<t.paramMin)throw"Too few parameters.";if(-1!==t.paramMax&&i>t.paramMax)throw"Too many parameters.";"rand"===e&&(this._containsCellRef=!0),p=new o._FunctionExpression(t,n);break}if("true"===e||"false"===e){p=new o._FunctionExpression(t,n,!1);break}}if(2===(u=e.split("!")).length?(g=u[0],_=u[1]):_=u[0],a=this._getDefinedName(_,g||this._sheet.name.toLowerCase())){if(a.sheetName&&a.sheetName!==this._sheet.name&&a.sheetName.toLowerCase()!==g)throw"The defined name item works in "+a.sheetName+".  It does not work in current sheet.";d=this._pointer,c=this._expressLength,h=this._expression,this._pointer=0,p=this._checkCache(a.value),this._pointer=d,this._expressLength=c,this._expression=h;break}if(g="",null!=(f=this._owner._getTable(e))){if(""===(g=f.sheet.name))throw"The Table("+e+") is not located in any sheet.";if(this._getToken(),this._token.tokenType!==l.SQUAREBRACKETS||this._token.tokenID!==r.OPEN)throw"Invalid Table Reference.";this._tableRefStart=!0,p=this._getTableReference(f,g);break}if(s=this._getCellRange(e)){this._containsCellRef=!0,p=new o._CellRangeExpression(s.cellRange,s.sheetRef,this._owner);break}n=this._getParameters(),p=this.onUnknownFunction(e,n);break;case l.GROUP:if(this._token.tokenID!==r.OPEN)throw"Expression expected.";if(this._getToken(),p=this._parseCompareOrConcat(),this._token.tokenID!==r.CLOSE)throw"Unbalanced parenthesis.";break;case l.SQUAREBRACKETS:if(this._token.tokenID!==r.OPEN)throw"Table References expected.";null!=(f=this._sheet.findTable(this._rowIndex,this._columnIndex))&&(g=f.sheet.name,this._tableRefStart=!0,p=this._getTableReference(f,g))}if(null===p)throw"";return this._getToken(),p},n.prototype._getToken=function(){for(var e,t,o,n,s,a="",h="",c=new RegExp("[　-〿぀-ゟ゠-ヿ＀-ﾟ一-龯㐀-䶿]");this._pointer<this._expressLength&&" "===this._expression[this._pointer];)this._pointer++;if(this._pointer>=this._expressLength)this._token=new i(null,r.END,l.GROUP);else{if(t=this._expression[this._pointer],n=t>="a"&&t<="z"||t>="A"&&t<="Z"||c.test(t),s=t>="0"&&t<="9"||"."==t,!n&&!s){var d=this._tokenTable[t];if(d)return this._token=d,this._pointer++,void(this._pointer<this._expressLength&&(">"===t||"<"===t)&&(d=this._tokenTable[this._expression.substring(this._pointer-1,this._pointer+1)])&&(this._token=d,this._pointer++))}if(s)this._parseDigit();else if('"'!==t){if("'"!==t||(h=this._parseSheetRef()))if("#"!==t){if(!n&&"_"!==t&&this._idChars.indexOf(t)<0&&!h)throw"Identifier expected.";for(e=1;e+this._pointer<this._expressLength;e++)if(t=this._expression[this._pointer+e],n=t>="a"&&t<="z"||t>="A"&&t<="Z"||c.test(t),s=t>="0"&&t<="9","'"!==t||":"!==o){if(o=t,!n&&!s&&"_"!==t&&this._idChars.indexOf(t)<0)break}else a=h+this._expression.substring(this._pointer,this._pointer+e),this._pointer+=e,h=this._parseSheetRef(),e=0;a+=h+this._expression.substring(this._pointer,this._pointer+e),this._pointer+=e,this._token=new i(a,r.ATOM,l.IDENTIFIER)}else this._parseDate()}else this._parseString()}},n.prototype._getTableToken=function(){for(var e,t,o,n="",s=!1;this._pointer<this._expressLength&&" "===this._expression[this._pointer];)this._pointer++;for("@"===(t=this._expression[this._pointer])&&(n=t,this._pointer++),"["===(t=this._expression[this._pointer])&&(s=!0),e=1;e+this._pointer<this._expressLength;e++){if(t=this._expression[this._pointer+e],s&&","===t)throw"Invalid table reference.";if("]"===t)break}o=n+this._expression.substring(this._pointer+(s?1:0),this._pointer+e),this._pointer+=e+(s?1:0),this._token=new i(o,r.ATOM,l.IDENTIFIER)},n.prototype._parseDigit=function(){var e,t,o=-1,n=!1,s=!1,a=0;for(e=0;e+this._pointer<this._expressLength;e++)if((t=this._expression[this._pointer+e])>="0"&&t<="9")a=10*a+(+t-0),o>-1&&(o*=10);else if("."===t&&o<0)o=1;else{if("E"!==t&&"e"!==t||n){if("%"===t){s=!0,e++;break}break}n=!0,"+"!==(t=this._expression[this._pointer+e+1])&&"-"!==t||e++}n?a=+this._expression.substring(this._pointer,this._pointer+e):(o>1&&(a/=o),s&&(a/=100)),this._token=new i(a,r.ATOM,l.LITERAL),this._pointer+=e},n.prototype._parseString=function(){var e,t,o;for(e=1;e+this._pointer<this._expressLength;e++)if('"'===(t=this._expression[this._pointer+e])){if('"'!==(e+this._pointer<this._expressLength-1?this._expression[this._pointer+e+1]:" "))break;e++}if('"'!==t)throw"Can't find final quote.";if(o=this._expression.substring(this._pointer+1,this._pointer+e),this._pointer+=e+1,"!"===this._expression[this._pointer])throw"Illegal cross sheet reference.";this._token=new i(o.replace('""','"'),r.ATOM,l.LITERAL)},n.prototype._parseDate=function(){var e,t,o;for(e=1;e+this._pointer<this._expressLength&&"#"!==(t=this._expression[this._pointer+e]);e++);if("#"!==t)throw'Can\'t find final date delimiter ("#").';o=this._expression.substring(this._pointer+1,this._pointer+e),this._pointer+=e+1,this._token=new i(Date.parse(o),r.ATOM,l.LITERAL)},n.prototype._parseSheetRef=function(){var e,t,o;for(e=1;e+this._pointer<this._expressLength;e++)if("'"===(t=this._expression[this._pointer+e])){if("'"!==(e+this._pointer<this._expressLength-1?this._expression[this._pointer+e+1]:" "))break;e++}if("'"!==t)throw"Can't find final quote.";return o=this._expression.substring(this._pointer+1,this._pointer+e),this._pointer+=e+1,"!"===this._expression[this._pointer]?o.replace(/\'\'/g,"'"):""},n.prototype._getCellRange=function(e){var t,o,n,i,s;if(e&&(t=e.split(":")).length>0&&t.length<3&&(o=this._parseCell(t[0]),(i=o.cellRange)&&2===t.length)){if(n=this._parseCell(t[1]),s=n.cellRange,o.sheetRef&&!n.sheetRef&&(n.sheetRef=o.sheetRef),o.sheetRef!==n.sheetRef)throw"The cell reference must be in the same sheet!";s?(i.col2=s.col,i.row2=s.row):i=null}return null==i?null:{cellRange:i,sheetRef:o.sheetRef}},n.prototype._parseCellRange=function(e){var o,n,i=-1,s=-1,l=!1,r=!1;for(o=0;o<e.length;o++)if("$"!==(n=e[o])||l){if(!(n>="a"&&n<="z"||n>="A"&&n<="Z"))break;i<0&&(i=0),i=26*i+(n.toUpperCase().charCodeAt(0)-"A".charCodeAt(0)+1)}else l=!0;for(;o<e.length;o++)if("$"!==(n=e[o])||r){if(!(n>="0"&&n<="9"))break;s<0&&(s=0),s=10*s+(+n-0)}else r=!0;return o<e.length&&(s=i=-1),-1===s||-1===i?null:new t.CellRange(s-1,i-1)},n.prototype._parseCell=function(e){var t,o,n,i;if((o=e.lastIndexOf("!"))>0&&o<e.length-1)i=e.substring(0,o),n=e.substring(o+1);else{if(!(o<=0))return null;n=e}return t=this._parseCellRange(n),{cellRange:t,sheetRef:i}},n.prototype._getParameters=function(){var e,t,o=this._pointer,n=this._token;if(this._getToken(),this._token.tokenType!==l.SQUAREBRACKETS||this._token.tokenID!==r.OPEN){if(this._token.tokenID!==r.OPEN)return this._pointer=o,this._token=n,null;if(o=this._pointer,this._getToken(),this._token.tokenID===r.CLOSE)return null;for(this._pointer=o,e=new Array,t=this._parseExpression(),e.push(t);this._token.tokenID===r.COMMA;)t=this._parseExpression(),e.push(t);if(this._token.tokenID!==r.CLOSE)throw"Syntax error.";return e}},n.prototype._getTableReference=function(e,t){var n,i=[],s=this._getTableParameter(),a=!1;if(null==s)throw"Invalid table reference.";for(i.push(s);this._tableRefStart&&(this._token.tokenID===r.COMMA||":"===this._token.value);){if(":"===this._token.value&&(a=!0),null==(s=this._getTableParameter()))throw"Invalid table reference.";a?(i[i.length-1]+=":"+s,a=!1):i.push(s)}if(this._token.tokenType!==l.SQUAREBRACKETS||this._token.tokenID!==r.CLOSE)throw"Unbalanced square brackets.";return this._tableRefStart=!1,n=this._getTableRange(e,i),this._containsCellRef=!0,new o._CellRangeExpression(n,t.toLowerCase(),this._owner)},n.prototype._getTableParameter=function(){var e;for(this._pointer;this._pointer<this._expressLength&&" "===this._expression[this._pointer];)this._pointer++;return"]"===this._expression[this._pointer]?(this._tableRefStart=!1,null):(this._getTableToken(),e=this._token.value,this._getToken(),e)},n.prototype._getTableRange=function(e,n){for(var i,s,l,r,a,h,c=0;c<n.length;c++){if(s)throw"Invalid Table Refernce.";if(i=n[c].toLowerCase(),a=null,"#"===i[0]){switch(i){case"#all":a=e.getRange();break;case"#data":a=e.getRange(o.TableSection.Data);break;case"#headers":a=e.getRange(o.TableSection.Header);break;case"#totals":a=e.getRange(o.TableSection.Footer);break;case"#this row":if(r=e.getRange(),!(this._rowIndex>=r.topRow&&this._rowIndex<=r.bottomRow))throw"The row is out of the table ("+e.name+") range.";a=new t.CellRange(this._rowIndex,r.leftCol,this._rowIndex,r.rightCol);break;default:throw"Invalid Table Refernce."}if(null==a)throw"Invalid Table Refernce.";null==l?l=a:(l.row=l.topRow<a.topRow?l.topRow:a.topRow,l.row2=l.bottomRow>a.bottomRow?l.bottomRow:a.bottomRow)}else{s=!0,h=i.split(":");for(var d=0;d<h.length;d++){if(h.length>2)throw"Invalid Table Column Refernce.";if("@"===(i=h[d])[0]){if(null==(a=e.getRange(o.TableSection.Data,i.substring(1))))throw"Invalid Table Refernce.";if(!(this._rowIndex>=a.topRow&&this._rowIndex<=a.bottomRow))throw"The row is out of the table ("+e.name+") range.";a.row=this._rowIndex,a.row2=this._rowIndex}else if(null==(a=e.getRange(o.TableSection.Data,i)))throw"Invalid Table Refernce.";0===d&&(null==l?l=a:l.col=a.col),l.col2=a.col,a=null}}}return l},n.prototype._getAggregateResult=function(t,o,n){var i,s=this._getItemList(o,n);return i=e.getAggregate(t,s.items),s.isDate&&(i={value:i=new Date(i),format:s.format||"M/d/yyyy"}),i},n.prototype._getFlexSheetAggregateResult=function(e,t,n){var i,s,l,r;switch(e){case a.Count:return i=this._getItemList(t,n,!0,!1),this._countNumberCells(i.items);case a.CountA:return(i=this._getItemList(t,n,!1,!1)).items.length;case a.ConutBlank:return i=this._getItemList(t,n,!1,!0),this._countBlankCells(i.items);case a.Rank:if(l=o._Expression.toNumber(t[0],this._rowIndex,this._columnIndex,n),r=t[2]?o._Expression.toNumber(t[2],this._rowIndex,this._columnIndex,n):0,isNaN(l))throw"Invalid number.";if(isNaN(r))throw"Invalid order.";if(t[1]=this._ensureNonFunctionExpression(t[1]),t[1]instanceof o._CellRangeExpression)return i=this._getItemList([t[1]],n),this._getRankOfCellRange(l,i.items,r);throw"Invalid Cell Reference.";case a.CountIf:if(t[0]=this._ensureNonFunctionExpression(t[0]),t[0]instanceof o._CellRangeExpression)return i=this._getItemList([t[0]],n,!1),this._countCellsByCriterias([i.items],[t[1]],n);throw"Invalid Cell Reference.";case a.CountIfs:return this._handleCountIfs(t,n);case a.SumIf:if(t[0]=this._ensureNonFunctionExpression(t[0]),t[0]instanceof o._CellRangeExpression)return i=this._getItemList([t[0]],n,!1),t[2]=this._ensureNonFunctionExpression(t[2]),null!=t[2]&&t[2]instanceof o._CellRangeExpression&&(s=this._getItemList([t[2]],n)),this._sumCellsByCriterias([i.items],[t[1]],s?s.items:null,n);throw"Invalid Cell Reference.";case a.SumIfs:return this._handleSumIfs(t,n);case a.Product:return i=this._getItemList(t,n),this._getProductOfNumbers(i.items)}throw"Invalid aggregate type."},n.prototype._getItemList=function(t,n,i,s,l,r){void 0===i&&(i=!0),void 0===s&&(s=!1),void 0===l&&(l=!0);var a,h,c,d,u,_,g,f,p,w,m=new Array;for(h=0;h<t.length;h++)if(u=t[h],(u=this._ensureNonFunctionExpression(u))instanceof o._CellRangeExpression){for(d=u.getValues(l,r,n),0===h&&((p=(f=u._getSheet()||n||this._sheet).getCellStyle(u.cells.topRow,u.cells.leftCol))&&(g=p.format),g||(w=f.grid.columns[u.cells.leftCol])&&(g=w.format)),c=0;c<d.length;c++)if(a=d[c],s||null!=a&&""!==a){if(e.isString(a)&&0===a.indexOf("Error: ")){m=[0];break}null==_&&(_=a instanceof Date),a=i&&!e.isBoolean(a)?+a:a,m.push(a)}}else{if(a=u instanceof o._Expression?u.evaluate(this._rowIndex,this._columnIndex,n):u,e.isPrimitive(a)||(a=a.value),!s&&(null==a||""===a))continue;if(e.isString(a)&&0===a.indexOf("Error: ")){m=[0];break}null==_&&(_=a instanceof Date),a=i?+a:a,m.push(a)}return 0===m.length&&(_=!1),{isDate:_,items:m,format:g}},n.prototype._countBlankCells=function(t){for(var o,n=0,i=0;n<t.length;n++)(null==(o=t[n])||e.isString(o)&&""===o||e.isNumber(o)&&isNaN(o))&&i++;return i},n.prototype._countNumberCells=function(t){for(var o,n=0,i=0;n<t.length;n++)null!=(o=t[n])&&e.isNumber(o)&&!isNaN(o)&&i++;return i},n.prototype._getRankOfCellRange=function(e,t,o){void 0===o&&(o=0);var n,i=0,s=0;for(o?t.sort(function(e,t){return isNaN(e)||isNaN(t)?-1:e-t}):t.sort(function(e,t){return isNaN(e)||isNaN(t)?1:t-e});i<t.length;i++)if(n=t[i],!isNaN(n)&&(s++,e===n))return s;throw e+" is not in the cell range."},n.prototype._handleCountIfs=function(e,t){var n,i,s,l,r=0,a=[],h=[];if(e.length%2!=0)throw"Invalid params.";for(;r<e.length/2;r++){if(i=e[2*r],!((i=this._ensureNonFunctionExpression(i))instanceof o._CellRangeExpression))throw"Invalid Cell Reference.";if(0===r){if(!i.cells)throw"Invalid Cell Reference.";s=i.cells.rowSpan,l=i.cells.columnSpan}else{if(!i.cells)throw"Invalid Cell Reference.";if(i.cells.rowSpan!==s||i.cells.columnSpan!==l)throw"The row span and column span of each cell range has to be same with each other."}n=this._getItemList([i],t,!1),a[r]=n.items,h[r]=e[2*r+1]}return this._countCellsByCriterias(a,h,t)},n.prototype._countCellsByCriterias=function(t,n,i,s){for(var l,r,a,h,c,d=0,u=0,_=0,g=t[0].length,f=[];u<n.length;u++)"*"===(c=o._Expression.toString(n[u],this._rowIndex,this._columnIndex,i))?f.push(c):f.push(this._parseRightExpr(c));for(;d<g;d++){l=!1;e:for(u=0;u<t.length;u++)if(a=t[u],h=a[d],"string"==typeof(c=f[u])){if("*"!==c&&(null==h||""===h)){l=!1;break e}if(!(l="*"===c||this.evaluate(this._combineExpr(h,c),null,i,this._rowIndex,this._columnIndex)))break e}else if(!(l=l=c.reg.test(h.toString())===c.checkMathces))break e;l&&(s?null!=(r=s[d])&&e.isNumber(r)&&!isNaN(r)&&_++:_++)}return _},n.prototype._handleSumIfs=function(e,t){var n,i,s,l,r,a,h=1,c=[],d=[];if(e.length%2!=1)throw"Invalid params.";if(s=e[0],!((s=this._ensureNonFunctionExpression(s))instanceof o._CellRangeExpression))throw"Invalid Sum Cell Reference.";if(!s.cells)throw"Invalid Sum Cell Reference.";for(r=s.cells.rowSpan,a=s.cells.columnSpan,i=this._getItemList([s],t);h<(e.length+1)/2;h++){if(l=e[2*h-1],!((l=this._ensureNonFunctionExpression(l))instanceof o._CellRangeExpression))throw"Invalid Criteria Cell Reference.";if(!l.cells)throw"Invalid Criteria Cell Reference.";if(l.cells.rowSpan!==r||l.cells.columnSpan!==a)throw"The row span and column span of each cell range has to be same with each other.";n=this._getItemList([l],t,!1),c[h-1]=n.items,d[h-1]=e[2*h]}return this._sumCellsByCriterias(c,d,i.items,t)},n.prototype._sumCellsByCriterias=function(t,n,i,s){var l,r,a,h,c,d=0,u=0,_=0,g=t[0].length,f=[];for(null==i&&(i=t[0]);u<n.length;u++)"*"===(c=o._Expression.toString(n[u],this._rowIndex,this._columnIndex,s))?f.push(c):f.push(this._parseRightExpr(c));for(;d<g;d++){r=!1,l=i[d];e:for(u=0;u<t.length;u++)if(a=t[u],h=a[d],"string"==typeof(c=f[u])){if("*"!==c&&(null==h||""===h)){r=!1;break e}if(!(r="*"===c||this.evaluate(this._combineExpr(h,c),null,s,this._rowIndex,this._columnIndex)))break e}else if(!(r=c.reg.test(h.toString())===c.checkMathces))break e;r&&e.isNumber(l)&&!isNaN(l)&&(_+=l)}return _},n.prototype._getProductOfNumbers=function(t){var o,n=0,i=1,s=!1;if(t)for(;n<t.length;n++)o=t[n],e.isNumber(o)&&!isNaN(o)&&(i*=o,s=!0);return s?i:0},n.prototype._handleSubtotal=function(t,n){var i,s,l,r,a=!0;if((i=o._Expression.toNumber(t[0],this._rowIndex,this._columnIndex,n))>=1&&i<=11||i>=101&&i<=111){switch(i>=101&&i<=111&&(a=!1),i=e.asEnum(i,h),s=this._getItemList(t.slice(1),n,!0,!1,a),i){case h.Count:case h.CountWithoutHidden:return this._countNumberCells(s.items);case h.CountA:case h.CountAWithoutHidden:return s.items.length;case h.Product:case h.ProductWithoutHidden:return this._getProductOfNumbers(s.items);case h.Average:case h.AverageWithoutHidden:l=e.Aggregate.Avg;break;case h.Max:case h.MaxWithoutHidden:l=e.Aggregate.Max;break;case h.Min:case h.MinWithoutHidden:l=e.Aggregate.Min;break;case h.Std:case h.StdWithoutHidden:l=e.Aggregate.Std;break;case h.StdPop:case h.StdPopWithoutHidden:l=e.Aggregate.StdPop;break;case h.Sum:case h.SumWithoutHidden:l=e.Aggregate.Sum;break;case h.Var:case h.VarWithoutHidden:l=e.Aggregate.Var;break;case h.VarPop:case h.VarPopWithoutHidden:l=e.Aggregate.VarPop}return r=e.getAggregate(l,s.items),s.isDate&&(r=new Date(r)),r}throw"Invalid Subtotal function."},n.prototype._handleDCount=function(e,t){var n,i,s,l=e[0],r=e[2];if(l=this._ensureNonFunctionExpression(l),r=this._ensureNonFunctionExpression(r),l instanceof o._CellRangeExpression&&r instanceof o._CellRangeExpression&&(n=e[1].evaluate(this._rowIndex,this._columnIndex,t),i=this._getColumnIndexByField(l,n),(s=this._getItemList([l],t,!0,!1,!0,i)).items&&s.items.length>1))return this._DCountWithCriterias(s.items.slice(1),l,r);throw"Invalid Count Cell Reference."},n.prototype._DCountWithCriterias=function(e,t,n){var i,s,l,r,a,h,c,d,u,_,g,f=n.cells,p=0;if(i=this._getSheet(t.sheetRef),s=this._getSheet(n.sheetRef),f.rowSpan>1){for(l=f.topRow,r=f.bottomRow;r>f.topRow;r--){for(_=[],g=[],a=f.leftCol;a<=f.rightCol;a++)if(null!=(c=this._owner.getCellValue(r,a,!1,s))&&""!==c){if(g.push(new o._Expression(c)),d=this._owner.getCellValue(l,a,!1,s),h=this._getColumnIndexByField(t,d),!(null!=(u=this._getItemList([t],i,!1,!1,!0,h)).items&&u.items.length>1))throw"Invalid Count Cell Reference.";_.push(u.items.slice(1))}p+=this._countCellsByCriterias(_,g,i,e)}return p}throw"Invalid Criteria Cell Reference."},n.prototype._getColumnIndexByField=function(t,o){var n,i,s,l,r;if(n=t.cells,-1===(r=n.topRow))throw"Invalid Count Cell Reference.";if(e.isInt(o)&&!isNaN(o)){if(o>=1&&o<=n.columnSpan)return s=n.leftCol+o-1}else for(i=this._getSheet(t.sheetRef),s=n.leftCol;s<=n.rightCol;s++)if(l=this._owner.getCellValue(r,s,!1,i),o=e.isString(o)?o.toLowerCase():o,l=e.isString(l)?l.toLowerCase():l,o===l)return s;throw"Invalid field."},n.prototype._getSumProduct=function(e,t){var o,n,i,s=0,l=this._getItemListForSumProduct(e,t);if(l.length>0){n=l[0].length,i=l.length;for(var r=0;r<n;r++){o=1;for(var a=0;a<i;a++)o*=l[a][r];s+=o}}return s},n.prototype._getItemListForSumProduct=function(e,t){var n,i,s,l,r,a,h=[new Array];for(s=0;s<e.length;s++){if(a=e[s],n=new Array,(a=this._ensureNonFunctionExpression(a))instanceof o._CellRangeExpression)for(r=a.getValues(!0,null,t),l=0;l<r.length;l++)i=r[l],n.push(+i);else i=a instanceof o._Expression?a.evaluate(this._rowIndex,this._columnIndex,t):a,n.push(+i);if(s>0&&n.length!==h[0].length)throw"The cell ranges of the sumProduct formula must have the same dimensions.";h[s]=n}return h},n.prototype._getSheet=function(e){var t,o=0;if(e)for(;o<this._owner.sheets.length&&(t=this._owner.sheets[o]).name!==e;o++);return t},n.prototype._parseRightExpr=function(e){var t,o,n=!1;if(e.indexOf("?")>-1||e.indexOf("*")>-1){if(null==(t=e.match(/([\?\*]*)(\w+)([\?\*]*)(\w+)([\?\*]*)/))||6!==t.length)throw"Invalid Criteria.";return o=new RegExp("^"+(t[1].length>0?this._parseRegCriteria(t[1]):"")+t[2]+(t[3].length>0?this._parseRegCriteria(t[3]):"")+t[4]+(t[5].length>0?this._parseRegCriteria(t[5]):"")+"$","i"),/^[<>=]/.test(e)?"="===e.trim()[0]&&(n=!0):n=!0,{reg:o,checkMathces:n}}if(isNaN(+e))if(/^\w/.test(e))e='="'+e+'"';else{if(!/^[<>=]{1,2}\s*-?.+$/.test(e))throw"Invalid Criteria.";e=e.replace(/([<>=]{1,2})\s*(-?.+)/,'$1"$2"')}else e="="+ +e;return e},n.prototype._combineExpr=function(t,o){return(e.isString(t)||e.isDate(t))&&(t='"'+t+'"'),(t="="+t)+o},n.prototype._parseRegCriteria=function(e){for(var t=0,o=0,n="";t<e.length;t++)"*"===e[t]?(o>0&&(n+="\\w{"+o+"}",o=0),n+="\\w*"):"?"===e[t]&&o++;return o>0&&(n+="\\w{"+o+"}"),n},n.prototype._calculateRate=function(e,t){var n,i,s,l,r,a,h,c,d,u,_=0,g=0;for(s=o._Expression.toNumber(e[0],this._rowIndex,this._columnIndex,t),l=o._Expression.toNumber(e[1],this._rowIndex,this._columnIndex,t),r=o._Expression.toNumber(e[2],this._rowIndex,this._columnIndex,t),a=null!=e[3]?o._Expression.toNumber(e[3],this._rowIndex,this._columnIndex,t):0,h=null!=e[4]?o._Expression.toNumber(e[4],this._rowIndex,this._columnIndex,t):0,i=null!=e[5]?o._Expression.toNumber(e[5],this._rowIndex,this._columnIndex,t):.1,Math.abs(i)<1e-7?r*(1+s*i)+l*(1+i*h)*s+a:r*(c=Math.exp(s*Math.log(1+i)))+l*(1/i+h)*(c-1)+a,d=r+l*s+a,u=r*c+l*(1/i+h)*(c-1)+a,n=i;Math.abs(d-u)>1e-7&&_<20;)i=(u*g-d*n)/(u-d),g=n,n=i,d=u,u=Math.abs(i)<1e-7?r*(1+s*i)+l*(1+i*h)*s+a:r*(c=Math.exp(s*Math.log(1+i)))+l*(1/i+h)*(c-1)+a,++_;if(Math.abs(d-u)>1e-7&&20===_)throw"It is not able to calculate the rate with current parameters.";return i},n.prototype._handleHLookup=function(e,t){var n,i,s=e[0].evaluate(this._rowIndex,this._columnIndex,t),l=e[1],r=o._Expression.toNumber(e[2],this._rowIndex,this._columnIndex,t),a=null==e[3]||o._Expression.toBoolean(e[3],this._rowIndex,this._columnIndex,t);if(null==s||""==s)throw"Invalid lookup value.";if(isNaN(r)||r<0)throw"Invalid row index.";if((l=this._ensureNonFunctionExpression(l))instanceof o._CellRangeExpression){if(n=l.cells,r>n.rowSpan)throw"Row index is out of the cell range.";if(a?-1===(i=this._exactMatch(s,n,t,!1))&&(i=this._approximateMatch(s,n,t)):i=this._exactMatch(s,n,t),-1===i)throw"Lookup Value is not found.";return this._owner.getCellValue(n.topRow+r-1,i,!1,t)}throw"Invalid Cell Reference."},n.prototype._exactMatch=function(t,o,n,i){void 0===i&&(i=!0);var s,l,r,a,h=o.topRow;if(e.isString(t)&&(t=t.toLowerCase()),i&&e.isString(t)&&(t.indexOf("?")>-1||t.indexOf("*")>-1)){if(null==(r=t.match(/([\?\*]*)(\w+)([\?\*]*)(\w+)([\?\*]*)/))||6!==r.length)throw"Invalid lookup value.";a=new RegExp("^"+(r[1].length>0?this._parseRegCriteria(r[1]):"")+r[2]+(r[3].length>0?this._parseRegCriteria(r[3]):"")+r[4]+(r[5].length>0?this._parseRegCriteria(r[5]):"")+"$","i")}for(s=o.leftCol;s<=o.rightCol;s++)if(l=this._owner.getCellValue(h,s,!1,n),null!=a){if(a.test(l))return s}else if(e.isString(l)&&(l=l.toLowerCase()),t===l)return s;return-1},n.prototype._approximateMatch=function(t,o,n){var i,s,l=o.topRow,r=[],a=0;for(e.isString(t)&&(t=t.toLowerCase()),s=o.leftCol;s<=o.rightCol;s++)i=this._owner.getCellValue(l,s,!1,n),i=isNaN(+i)?i:+i,r.push({value:i,index:s});for(r.sort(function(t,o){return e.isString(t.value)&&(t.value=t.value.toLowerCase()),e.isString(o.value)&&(o.value=o.value.toLowerCase()),t.value>o.value?-1:t.value===o.value?o.index-t.index:1});a<r.length;a++)if(i=r[a],e.isString(i.value)&&(i.value=i.value.toLowerCase()),t>i.value)return i.index;throw"Lookup Value is not found."},n.prototype._parseToScientificValue=function(t,o,n,i,s){var l,r,a,h,c=0;if(Math.abs(t)>=1)for(r="+",l=Math.pow(10,o.length);t>l;)t/=l,c+=o.length;else for(r="-",l=Math.pow(10,o.length);t*l<l;)t*=l,c+=o.length;if(a=e.Globalize.format(t,"D"+o.length),n)for((a+=e.Globalize.format(t-Math.floor(t),o+n).substring(1)).indexOf(".")>-1?h=a.length-1-a.indexOf("."):(a+=".",h=0);h<n.length-1;)a+="0",h++;if(a+="E"+r+e.Globalize.format(c,"D"+i.length),s){a+=".";for(var d=1;d<s.length;d++)a+="0"}return a},n.prototype._checkCache=function(e){var t=this._expressionCache[e]||this._expressionCache[this._rowIndex+"_"+this._columnIndex+":"+e];if(t)return t;if(t=this._parse(e),this._token.tokenID!==r.END||this._token.tokenType!==l.GROUP)throw"Invalid Expression: "+e;return this._cacheSize>1e4&&this._clearExpressionCache(),this._expressionCache[(this._containsCellRef?this._rowIndex+"_"+this._columnIndex+":":"")+e]=t,this._cacheSize++,t},n.prototype._ensureNonFunctionExpression=function(e,t){for(;e instanceof o._FunctionExpression;)e=e.evaluate(this._rowIndex,this._columnIndex,t);return e},n.prototype._getDefinedName=function(e,t){for(var o,n,i=0;i<this._owner.definedNames.length;i++)if((o=this._owner.definedNames[i]).name.toLowerCase()===e)if(o.sheetName){if(o.sheetName.toLowerCase()===t)return o}else n=o;return n},n}();o._CalcEngine=n;var i=function(){function e(e,t,o){this._value=e,this._tokenID=t,this._tokenType=o}return Object.defineProperty(e.prototype,"value",{get:function(){return this._value},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"tokenID",{get:function(){return this._tokenID},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"tokenType",{get:function(){return this._tokenType},enumerable:!0,configurable:!0}),e}();o._Token=i;var s=function(){function t(t,o,n){this._paramMax=Number.MAX_VALUE,this._paramMin=Number.MIN_VALUE,this._func=t,e.isNumber(o)&&!isNaN(o)&&(this._paramMax=o),e.isNumber(n)&&!isNaN(n)&&(this._paramMin=n)}return Object.defineProperty(t.prototype,"paramMax",{get:function(){return this._paramMax},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"paramMin",{get:function(){return this._paramMin},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"func",{get:function(){return this._func},enumerable:!0,configurable:!0}),t}();o._FunctionDefinition=s;var l;!function(e){e[e.COMPARE=0]="COMPARE",e[e.ADDSUB=1]="ADDSUB",e[e.MULDIV=2]="MULDIV",e[e.POWER=3]="POWER",e[e.CONCAT=4]="CONCAT",e[e.GROUP=5]="GROUP",e[e.LITERAL=6]="LITERAL",e[e.IDENTIFIER=7]="IDENTIFIER",e[e.SQUAREBRACKETS=8]="SQUAREBRACKETS"}(l=o._TokenType||(o._TokenType={}));var r;!function(e){e[e.GT=0]="GT",e[e.LT=1]="LT",e[e.GE=2]="GE",e[e.LE=3]="LE",e[e.EQ=4]="EQ",e[e.NE=5]="NE",e[e.ADD=6]="ADD",e[e.SUB=7]="SUB",e[e.MUL=8]="MUL",e[e.DIV=9]="DIV",e[e.DIVINT=10]="DIVINT",e[e.MOD=11]="MOD",e[e.POWER=12]="POWER",e[e.CONCAT=13]="CONCAT",e[e.OPEN=14]="OPEN",e[e.CLOSE=15]="CLOSE",e[e.END=16]="END",e[e.COMMA=17]="COMMA",e[e.PERIOD=18]="PERIOD",e[e.ATOM=19]="ATOM"}(r=o._TokenID||(o._TokenID={}));var a;!function(e){e[e.Count=0]="Count",e[e.CountA=1]="CountA",e[e.ConutBlank=2]="ConutBlank",e[e.CountIf=3]="CountIf",e[e.CountIfs=4]="CountIfs",e[e.Rank=5]="Rank",e[e.SumIf=6]="SumIf",e[e.SumIfs=7]="SumIfs",e[e.Product=8]="Product"}(a||(a={}));var h;!function(e){e[e.Average=1]="Average",e[e.Count=2]="Count",e[e.CountA=3]="CountA",e[e.Max=4]="Max",e[e.Min=5]="Min",e[e.Product=6]="Product",e[e.Std=7]="Std",e[e.StdPop=8]="StdPop",e[e.Sum=9]="Sum",e[e.Var=10]="Var",e[e.VarPop=11]="VarPop",e[e.AverageWithoutHidden=101]="AverageWithoutHidden",e[e.CountWithoutHidden=102]="CountWithoutHidden",e[e.CountAWithoutHidden=103]="CountAWithoutHidden",e[e.MaxWithoutHidden=104]="MaxWithoutHidden",e[e.MinWithoutHidden=105]="MinWithoutHidden",e[e.ProductWithoutHidden=106]="ProductWithoutHidden",e[e.StdWithoutHidden=107]="StdWithoutHidden",e[e.StdPopWithoutHidden=108]="StdPopWithoutHidden",e[e.SumWithoutHidden=109]="SumWithoutHidden",e[e.VarWithoutHidden=110]="VarWithoutHidden",e[e.VarPopWithoutHidden=111]="VarPopWithoutHidden"}(h||(h={}))}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(){function t(e){e?e instanceof o._Token?this._token=e:this._token=new o._Token(e,o._TokenID.ATOM,o._TokenType.LITERAL):this._token=new o._Token(null,o._TokenID.ATOM,o._TokenType.IDENTIFIER)}return Object.defineProperty(t.prototype,"token",{get:function(){return this._token},enumerable:!0,configurable:!0}),t.prototype.evaluate=function(e,t,n){if(this._token.tokenType!==o._TokenType.LITERAL)throw"Bad expression.";return this._token.value},t.toString=function(t,o,n,i){var s=t.evaluate(o,n,i);return e.isPrimitive(s)||(s=s.value),null!=s?s.toString():""},t.toNumber=function(t,o,n,i){var s=t.evaluate(o,n,i),l=["January","February","March","April","May","June","July","August","September","October","November","December","Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];if(e.isPrimitive(s)||(s=s.value),e.isNumber(s))return s;if(e.isBoolean(s))return s?1:0;if(e.isDate(s))return this._toOADate(s);if(e.isString(s)){if(s){if(isNaN(+s)){for(var r in l)if(s.indexOf(l[r])>-1)return this._toOADate(new Date(s));return+s}return+s}return 0}return e.changeType(s,e.DataType.Number,"")},t.toBoolean=function(t,o,n,i){var s=t.evaluate(o,n,i);return e.isPrimitive(s)||(s=s.value),e.isBoolean(s)?s:e.isNumber(s)?0!==s:e.changeType(s,e.DataType.Boolean,"")},t.toDate=function(t,o,n,i){var s=t.evaluate(o,n,i);return e.isPrimitive(s)||(s=s.value),e.isDate(s)?s:e.isNumber(s)?this._fromOADate(s):e.changeType(s,e.DataType.Date,"")},t._toOADate=function(e){var t=Date.UTC(1899,11,30);return(Date.UTC(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds())-t)/864e5},t._fromOADate=function(e){var t=Date.UTC(1899,11,30),o=new Date,n=e>=60?0:864e5;return new Date(864e5*e+t+6e4*o.getTimezoneOffset()+n)},t}();o._Expression=n;var i=function(e){function t(t,o){var n=e.call(this,t)||this;return n._expr=o,n}return __extends(t,e),t.prototype.evaluate=function(e,t,i){if(this.token.tokenID===o._TokenID.SUB)return null==this._evaluatedValue&&(this._evaluatedValue=-n.toNumber(this._expr,e,t,i)),this._evaluatedValue;if(this.token.tokenID===o._TokenID.ADD)return null==this._evaluatedValue&&(this._evaluatedValue=+n.toNumber(this._expr,e,t,i)),this._evaluatedValue;throw"Bad expression."},t}(n);o._UnaryExpression=i;var s=function(t){function i(e,o,n){var i=t.call(this,e)||this;return i._leftExpr=o,i._rightExpr=n,i}return __extends(i,t),i.prototype.evaluate=function(e,t,i){var s,l,r,a,h,c,d,u=!1;if(null!=this._evaluatedValue)return this._evaluatedValue;if(s=n.toString(this._leftExpr,e,t,i),l=n.toString(this._rightExpr,e,t,i),this.token.tokenType===o._TokenType.CONCAT)return this._evaluatedValue=s+l,this._evaluatedValue;if(r=this._leftExpr.evaluate(e,t,i),a=this._rightExpr.evaluate(e,t,i),u=this._isDateValue(r)||this._isDateValue(a),h=n.toNumber(this._leftExpr,e,t,i),c=n.toNumber(this._rightExpr,e,t,i),d=h-c,this.token.tokenType===o._TokenType.COMPARE)switch(this.token.tokenID){case o._TokenID.GT:return d>0;case o._TokenID.LT:return d<0;case o._TokenID.GE:return d>=0;case o._TokenID.LE:return d<=0;case o._TokenID.EQ:return isNaN(d)?(this._evaluatedValue=s.toLowerCase()===l.toLowerCase(),this._evaluatedValue):(this._evaluatedValue=0===d,this._evaluatedValue);case o._TokenID.NE:return isNaN(d)?(this._evaluatedValue=s.toLowerCase()!==l.toLowerCase(),this._evaluatedValue):(this._evaluatedValue=0!==d,this._evaluatedValue)}switch(this.token.tokenID){case o._TokenID.ADD:this._evaluatedValue=h+c;break;case o._TokenID.SUB:this._evaluatedValue=h-c;break;case o._TokenID.MUL:this._evaluatedValue=h*c;break;case o._TokenID.DIV:this._evaluatedValue=h/c;break;case o._TokenID.DIVINT:this._evaluatedValue=Math.floor(h/c);break;case o._TokenID.MOD:this._evaluatedValue=Math.floor(h%c);break;case o._TokenID.POWER:0===c&&(this._evaluatedValue=1),.5===c&&(this._evaluatedValue=Math.sqrt(h)),1===c&&(this._evaluatedValue=h),2===c&&(this._evaluatedValue=h*h),3===c&&(this._evaluatedValue=h*h*h),4===c&&(this._evaluatedValue=h*h*h*h),this._evaluatedValue=Math.pow(h,c);break;default:this._evaluatedValue=NaN}if(!isNaN(this._evaluatedValue))return u&&(this._evaluatedValue={value:n._fromOADate(this._evaluatedValue),format:r.format||a.format}),this._evaluatedValue;throw"Bad expression."},i.prototype._isDateValue=function(t){return e.isPrimitive(t)?e.isDate(t):e.isDate(t.value)},i}(n);o._BinaryExpression=s;var l=function(o){function n(e,t,n){var i=o.call(this)||this;return i._cells=e,i._sheetRef=t,i._flex=n,i._evalutingRange={},i}return __extends(n,o),n.prototype.evaluate=function(e,t,o){return null==this._evaluatedValue&&(this._evaluatedValue=this._getCellValue(this._cells,o,e,t)),this._evaluatedValue},n.prototype.getValues=function(o,n,i){void 0===o&&(o=!0);var s,l,n,r,a,h=[],c=0;if(r=null==n||isNaN(+n)?this._cells.leftCol:n,a=null==n||isNaN(+n)?this._cells.rightCol:n,!(i=this._getSheet()||i||this._flex.selectedSheet))return null;for(l=this._cells.topRow;l<=this._cells.bottomRow;l++){if(l>=i.grid.rows.length)throw"The cell reference is out of the cell range of the flexsheet.";if(o||!1!==i.grid.rows[l].isVisible)for(n=r;n<=a;n++){if(n>=i.grid.columns.length)throw"The cell reference is out of the cell range of the flexsheet.";(o||!1!==i.grid.columns[n].isVisible)&&(s=this._getCellValue(new t.CellRange(l,n),i),e.isPrimitive(s)||(s=s.value),h[c]=s,c++)}}return h},n.prototype.getValuseWithTwoDimensions=function(o,n){void 0===o&&(o=!0);var i,s,l,r,a=[],h=0,c=0;if(!(n=this._getSheet()||n||this._flex.selectedSheet))return null;for(l=this._cells.topRow;l<=this._cells.bottomRow;l++){if(l>=n.grid.rows.length)throw"The cell reference is out of the cell range of the flexsheet.";if(o||!1!==n.grid.rows[l].isVisible){for(s=[],c=0,r=this._cells.leftCol;r<=this._cells.rightCol;r++){if(r>=n.grid.columns.length)throw"The cell reference is out of the cell range of the flexsheet.";o||!1!==n.grid.columns[r].isVisible?(i=this._getCellValue(new t.CellRange(l,r),n),e.isPrimitive(i)||(i=i.value),s[c]=i,c++):c++}a[h]=s,h++}else h++}return a},Object.defineProperty(n.prototype,"cells",{get:function(){return this._cells},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"sheetRef",{get:function(){return this._sheetRef},enumerable:!0,configurable:!0}),n.prototype._getCellValue=function(e,t,o,n){var t,i,s,l;if(!(t=this._getSheet()||t||this._flex.selectedSheet))return null;if(e.isSingleCell?(s=e.row,l=e.col):(null!=o&&o>=e.topRow&&o<=e.bottomRow&&e.col===e.col2&&(s=o,l=e.col),null!=n&&n>=e.leftCol&&n<=e.rightCol&&e.row===e.row2&&(s=e.row,l=n)),null==s||null==l)throw"Invalid Cell Reference.";if(i=t.name+":"+s+","+l+"-"+s+","+l,this._evalutingRange[i])throw"Circular Reference";try{if(this._flex)return this._evalutingRange[i]=!0,this._flex.getCellValue(s,l,!1,t)}finally{delete this._evalutingRange[i]}},n.prototype._getSheet=function(){var e,t=0;if(!this._sheetRef)return null;for(;t<this._flex.sheets.length;t++)if((e=this._flex.sheets[t]).name.toLowerCase()===this._sheetRef)return e;throw"Invalid sheet reference"},n}(n);o._CellRangeExpression=l;var r=function(e){function t(t,o,n){void 0===n&&(n=!0);var i=e.call(this)||this;return i._funcDefinition=t,i._params=o,i._needCacheEvaluatedVal=n,i}return __extends(t,e),t.prototype.evaluate=function(e,t,o){return this._needCacheEvaluatedVal?(null==this._evaluatedValue&&(this._evaluatedValue=this._funcDefinition.func(this._params,o,e,t)),this._evaluatedValue):this._funcDefinition.func(this._params,o,e,t)},t}(n);o._FunctionExpression=r}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(t){"use strict";var o=function(){function e(e){this._owner=e,this._sheetIndex=e.selectedSheetIndex}return Object.defineProperty(e.prototype,"sheetIndex",{get:function(){return this._sheetIndex},enumerable:!0,configurable:!0}),e.prototype.undo=function(){throw"This abstract method must be overridden."},e.prototype.redo=function(){throw"This abstract method must be overridden."},e.prototype.saveNewState=function(){throw"This abstract method must be overridden."},e}();t._UndoAction=o;var n=function(e){function t(t,o){var n=e.call(this,t)||this;return n._isPaste=!1,n._selections=o?[o]:t.selectedSheet.selectionRanges.length>0?t.selectedSheet.selectionRanges.slice():[t.selection.clone()],n._mergeAction=new h(t),n._cellStyleAction=new a(t),n._saveValues(!0),n}return __extends(t,e),Object.defineProperty(t.prototype,"isPaste",{get:function(){return this._isPaste},enumerable:!0,configurable:!0}),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){return!!this._saveValues(!1)&&(this._mergeAction.saveNewState(),this._cellStyleAction.saveNewState(),!this._checkActionState())},t.prototype.markIsPaste=function(){this._isPaste=!0},t.prototype.updateForPasting=function(e){var t=this._selections[this._selections.length-1],o=this._owner.getCellData(e.row,e.col,!!this._owner.columns[e.col].dataMap);t||(t=this._owner.selection,this._selections=[t]),o=null==o?"":o,this._oldValues["r"+e.row+"_c"+e.col]={row:e.row,col:e.col,value:o},t.row=Math.min(t.topRow,e.topRow),t.row2=Math.max(t.bottomRow,e.bottomRow),t.col=Math.min(t.leftCol,e.leftCol),t.col2=Math.max(t.rightCol,e.rightCol)},t.prototype._storeDeletedTables=function(e){null==this._deletedTables&&(this._deletedTables=[]),this._deletedTables.push(e)},t.prototype._checkActionState=function(){var e=this,t=!0;return Object.keys(e._oldValues).forEach(function(o){var n,i;t&&(n=e._oldValues[o],i=e._newValues[o],n&&i&&n.value!==i.value&&(t=!1))}),t},t.prototype._saveValues=function(e){var t,o,n,i,s,l,r={};for(t=0;t<this._selections.length;t++)for(i=(o=this._selections[t]).topRow;i<=o.bottomRow;i++)for(s=o.leftCol;s<=o.rightCol;s++){if(!(n=this._owner.columns[s]))return!1;l=null==(l=this._owner.getCellData(i,s,!!n.dataMap))?"":l,r["r"+i+"_c"+s]={row:i,col:s,value:l}}return e?this._oldValues=r:this._newValues=r,!0},t.prototype._handleUndoRedo=function(e){var t=this;t._owner._clearCalcEngine(),t._owner.selectedSheet.selectionRanges.clear(),t._owner.deferUpdate(function(){var o,n,i,s,l=e?t._oldValues:t._newValues;if(t._deletedTables&&t._deletedTables.length>0)for(o=0;o<t._deletedTables.length;o++)n=t._deletedTables[o],e?t._owner.selectedSheet.tables.push(n):t._owner.selectedSheet.tables.remove(n);for(i=0;i<t._selections.length;i++)s=t._selections[i],t._owner.selectedSheet.selectionRanges.push(s);Object.keys(l).forEach(function(e){var o=l[e];t._owner.setCellData(o.row,o.col,o.value)}),e?(t._mergeAction.undo(),t._cellStyleAction.undo()):(t._mergeAction.redo(),t._cellStyleAction.redo()),t._owner.refresh(!1)})},t}(o);t._EditAction=n;var i=function(e){function t(t,o,n){var i=e.call(this,t)||this;return i._panel=o,i._colIndex=n,i._oldColWidth=o.columns[n].width,i}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){return this._newColWidth=this._panel.columns[this._colIndex].width,this._oldColWidth!==this._newColWidth},t.prototype._handleUndoRedo=function(e){var t=this._panel.columns[this._colIndex];t&&(t.width=e?this._oldColWidth:this._newColWidth)},t}(o);t._ColumnResizeAction=i;var s=function(e){function t(t,o,n){var i=e.call(this,t)||this;return i._panel=o,i._rowIndex=n,i._oldRowHeight=o.rows[n].height,i}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){return this._newRowHeight=this._panel.rows[this._rowIndex].height,this._oldRowHeight!==this._newRowHeight},t.prototype._handleUndoRedo=function(e){var t=this._panel.rows[this._rowIndex];t&&(t.height=e?this._oldRowHeight:this._newRowHeight)},t}(o);t._RowResizeAction=s;var l=function(e){function t(t){var o=e.call(this,t)||this;return o._saveValues(!0),o}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){return this._saveValues(!1),!0},t.prototype._saveValues=function(e){var t,o,n,i,s=[],l=[];for(t=0;t<this._owner.columns.length;t++)s.push(this._owner.columns[t]);if(this._owner.selectedSheet.tables&&this._owner.selectedSheet.tables.length>0)for(o=0;o<this._owner.selectedSheet.tables.length;o++)(n=this._owner.selectedSheet.tables[o])&&n.sheet.name===this._owner.selectedSheet.name&&l.push({name:n.name,range:n.getRange(),columns:n.getColumns()});i={columns:s,sortList:this._owner.sortManager._committedList.slice(),styledCells:this._owner.selectedSheet?this._owner._cloneObject(this._owner.selectedSheet._styledCells):null,mergedCells:this._owner.selectedSheet?this._owner._cloneObject(this._owner.selectedSheet._mergedRanges):null,tableRanges:l,selection:this._owner.selection},e?this._oldValue=i:this._newValue=i},t.prototype._handleUndoRedo=function(e){var t,o,n,i,s,l,r,a,h,c,d=this,u=e?d._oldValue:d._newValue;if(d._owner.selectedSheet){for(d._owner._isUndoing=!0,d._owner._clearCalcEngine(),d._owner.finishEditing(),d._owner.columns.clear(),d._owner.selectedSheet._styledCells=null,d._owner.selectedSheet._mergedRanges=null,d._owner.columns.beginUpdate(),t=0;t<u.columns.length;t++)d._owner.columns.push(u.columns[t]);for(d._owner.columns.endUpdate(),d._owner.selectedSheet._styledCells=d._owner._cloneObject(u.styledCells),d._owner.selectedSheet._mergedRanges=u.mergedCells,n=0;n<u.tableRanges.length;n++)i=u.tableRanges[n],(s=d._owner._getTable(i.name))&&s._setTableRange(i.range,i.columns);if(d._affectedFormulas&&(r=e?d._affectedFormulas.oldFormulas:d._affectedFormulas.newFormulas),d._owner.deferUpdate(function(){if(r&&r.length>0)for(o=0;o<r.length;o++)null!=(l=r[o]).point?l.sheet.name===d._owner.selectedSheet.name?d._owner.setCellData(l.point.x,l.point.y,l.formula):l.sheet.grid.setCellData(l.point.x,l.point.y,l.formula):l.row._ubv[l.column._hash]=l.formula;if(d._deletedTables&&d._deletedTables.length>0)for(n=0;n<d._deletedTables.length;n++)s=d._deletedTables[n],e?d._owner.selectedSheet.tables.push(s):d._owner.selectedSheet.tables.remove(s)}),d._affectedDefinedNameVals&&(a=e?d._affectedDefinedNameVals.oldDefinedNameVals:d._affectedDefinedNameVals.newDefinedNameVals),a&&a.length>0)for(o=0;o<a.length;o++)h=a[o],(c=d._owner._getDefinedNameIndexByName(h.name))>-1&&(d._owner.definedNames[c].value=h.value);d._owner.selectedSheet.grid.wj_sheetInfo.styledCells=d._owner.selectedSheet._styledCells,d._owner.selectedSheet.grid.wj_sheetInfo.mergedRanges=d._owner.selectedSheet._mergedRanges,d._owner.sortManager.sortDescriptions.sourceCollection=u.sortList.slice(),d._owner.sortManager.commitSort(!1),d._owner.sortManager._refresh(),d._owner.selection=u.selection,d._owner.refresh(!0),d._owner._isUndoing=!1,d._owner._copyColumnsToSelectedSheet()}},t}(o);t._ColumnsChangedAction=l;var r=function(t){function o(e){var o=t.call(this,e)||this;return o._saveValues(!0),o}return __extends(o,t),o.prototype.undo=function(){this._handleUndoRedo(!0)},o.prototype.redo=function(){this._handleUndoRedo(!1)},o.prototype.saveNewState=function(){return this._saveValues(!1),!0},o.prototype._saveValues=function(t){var o,n,i,s,l,r,a=[],h=[],c=[];for(o=0;o<this._owner.rows.length;o++)a.push(this._owner.rows[o]);for(n=0;n<this._owner.columns.length;n++)h.push(this._owner.columns[n]);if(this._owner.selectedSheet.tables&&this._owner.selectedSheet.tables.length>0)for(i=0;i<this._owner.selectedSheet.tables.length;i++)(s=this._owner.selectedSheet.tables[i])&&s.sheet.name===this._owner.selectedSheet.name&&c.push({name:s.name,range:s.getRange(),setting:{showHeaderRow:s.showHeaderRow,showTotalRow:s.showTotalRow}});this._owner.itemsSource&&(l=this._owner.itemsSource instanceof e.collections.CollectionView?this._owner.itemsSource.sourceCollection.slice():this._owner.itemsSource.slice()),r={rows:a,columns:h,itemsSource:l,styledCells:this._owner.selectedSheet?this._owner._cloneObject(this._owner.selectedSheet._styledCells):null,mergedCells:this._owner.selectedSheet?this._owner._cloneObject(this._owner.selectedSheet._mergedRanges):null,tableSettings:c,selection:this._owner.selection,sortList:this._owner.sortManager._committedList.slice()},t?this._oldValue=r:this._newValue=r},o.prototype._handleUndoRedo=function(t){var o,n,i,s,l,r,a,h,c,d,u,_,g=this,f=!!g._oldValue.itemsSource,p=t?g._oldValue:g._newValue;if(g._owner.selectedSheet){if(g._owner._isUndoing=!0,g._owner._clearCalcEngine(),g._owner.finishEditing(),g._owner.columns.clear(),g._owner.rows.clear(),g._owner.selectedSheet._styledCells=null,g._owner.selectedSheet._mergedRanges=null,f)g._owner.collectionView.beginUpdate(),g._owner.autoGenerateColumns=!1,g._owner.itemsSource instanceof e.collections.CollectionView?(_=[0,g._owner.itemsSource.sourceCollection.length].concat(p.itemsSource),Array.prototype.splice.apply(g._owner.itemsSource.sourceCollection,_)):g._owner.itemsSource=p.itemsSource.slice(),g._owner.collectionView.endUpdate();else for(g._owner.rows.beginUpdate(),o=0;o<p.rows.length;o++)g._owner.rows.push(p.rows[o]);for(n=0;n<p.columns.length;n++)g._owner.columns.push(p.columns[n]);for(g._owner.rows.endUpdate(),g._owner.selectedSheet._styledCells=g._owner._cloneObject(p.styledCells),g._owner.selectedSheet._mergedRanges=p.mergedCells,s=0;s<p.tableSettings.length;s++)l=p.tableSettings[s],(r=g._owner._getTable(l.name))&&(r._showHeaderRow=l.setting.showHeaderRow,r._showTotalRow=l.setting.showTotalRow,r._setTableRange(l.range));if(g._affectedFormulas&&(h=t?g._affectedFormulas.oldFormulas:g._affectedFormulas.newFormulas),g._owner.deferUpdate(function(){if(h&&h.length>0)for(i=0;i<h.length;i++)null!=(a=h[i]).point?a.sheet.name===g._owner.selectedSheet.name?g._owner.setCellData(a.point.x,a.point.y,a.formula):a.sheet.grid.setCellData(a.point.x,a.point.y,a.formula):a.row._ubv[a.column._hash]=a.formula;if(g._deletedTables&&g._deletedTables.length>0)for(s=0;s<g._deletedTables.length;s++)r=g._deletedTables[s],t?g._owner.selectedSheet.tables.push(r):g._owner.selectedSheet.tables.remove(r)}),g._affectedDefinedNameVals&&(c=t?g._affectedDefinedNameVals.oldDefinedNameVals:g._affectedDefinedNameVals.newDefinedNameVals),c&&c.length>0)for(i=0;i<c.length;i++)d=c[i],(u=g._owner._getDefinedNameIndexByName(d.name))>-1&&(g._owner.definedNames[u].value=d.value);g._owner.selectedSheet.grid.wj_sheetInfo.styledCells=g._owner.selectedSheet._styledCells,g._owner.selectedSheet.grid.wj_sheetInfo.mergedRanges=g._owner.selectedSheet._mergedRanges,g._owner.sortManager.sortDescriptions.sourceCollection=p.sortList.slice(),g._owner.sortManager.commitSort(!1),g._owner.sortManager._refresh(),g._owner.selection=p.selection,g._owner.refresh(!0),g._owner._isUndoing=!1,g._owner._copyRowsToSelectedSheet()}},o}(o);t._RowsChangedAction=r;var a=function(e){function t(t,o){var n=e.call(this,t)||this;return n._oldStyledCells=o?t._cloneObject(o):t.selectedSheet?t._cloneObject(t.selectedSheet._styledCells):null,n}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){return this._newStyledCells=this._owner.selectedSheet?this._owner._cloneObject(this._owner.selectedSheet._styledCells):null,!0},t.prototype._handleUndoRedo=function(e){var t;this._owner.selectedSheet&&(t=e?this._oldStyledCells:this._newStyledCells,this._owner.selectedSheet._styledCells=this._owner._cloneObject(t),this._owner.selectedSheet.grid.wj_sheetInfo.styledCells=this._owner.selectedSheet._styledCells,this._owner.refresh(!1))},t}(o);t._CellStyleAction=a;var h=function(e){function t(t){var o=e.call(this,t)||this;return o._oldMergedCells=t.selectedSheet?t._cloneObject(t.selectedSheet._mergedRanges):null,o}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){return this._newMergedCells=this._owner.selectedSheet?this._owner._cloneObject(this._owner.selectedSheet._mergedRanges):null,!0},t.prototype._handleUndoRedo=function(e){var t;this._owner.selectedSheet&&(t=e?this._oldMergedCells:this._newMergedCells,this._owner._clearCalcEngine(),this._owner.selectedSheet._mergedRanges=t,this._owner.selectedSheet.grid.wj_sheetInfo.mergedRanges=this._owner.selectedSheet._mergedRanges,this._owner.refresh(!0))},t}(o);t._CellMergeAction=h;var c=function(e){function t(t){var o=e.call(this,t)||this;return o._saveValues(!0),o}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){return this._saveValues(!1),!0},t.prototype._saveValues=function(e){var t,o,n,i=[],s=[];if(!this._owner.itemsSource){for(t=0;t<this._owner.rows.length;t++)s.push(this._owner.rows[t]);for(o=0;o<this._owner.columns.length;o++)i.push(this._owner.columns[o])}n={sortList:this._owner.sortManager._committedList.slice(),rows:s,columns:i,formulas:this._owner._scanFormulas()},e?this._oldValue=n:this._newValue=n},t.prototype._handleUndoRedo=function(e){var t,o,n,i,s=this,l=e?s._oldValue:s._newValue;s._owner.selectedSheet&&(s._owner._isUndoing=!0,s._owner.deferUpdate(function(){if(s._owner._clearCalcEngine(),s._owner.sortManager.sortDescriptions.sourceCollection=l.sortList.slice(),s._owner.sortManager.commitSort(!1),s._owner.sortManager._refresh(),!s._owner.itemsSource){for(s._owner.rows.clear(),s._owner.columns.clear(),s._owner.selectedSheet.grid.rows.clear(),s._owner.selectedSheet.grid.columns.clear(),t=0;t<l.rows.length;t++)n=l.rows[t],s._owner.rows.push(n),s._owner.selectedSheet.grid.rows.push(n);for(o=0;o<l.columns.length;o++)i=l.columns[o],s._owner.columns.push(i),s._owner.selectedSheet.grid.columns.push(i);s._owner._resetFormulas(l.formulas),s._owner._isUndoing=!1,setTimeout(function(){s._owner._setFlexSheetToDirty(),s._owner.refresh(!0)},10)}}))},t}(o);t._SortColumnAction=c;var d=function(t){function o(e,o,n,i){var s=t.call(this,e)||this;return e.selectedSheet?(0===o.topRow&&o.bottomRow===e.rows.length-1?s._isDraggingColumns=!0:s._isDraggingColumns=!1,s._isCopyCells=i,s._dragRange=o,s._dropRange=n,s._saveValues(!0),s):s}return __extends(o,t),o.prototype.undo=function(){this._handleUndoRedo(!0)},o.prototype.redo=function(){this._handleUndoRedo(!1)},o.prototype.saveNewState=function(){return!!this._owner.selectedSheet&&(!!this._dropRange&&(this._saveValues(!1),!0))},o.prototype._saveValues=function(e){var t,o,n,i,s,l,r,a,h,c,d,u;for(d=[],u={},t=this._dropRange.topRow;t<=this._dropRange.bottomRow;t++)for(o=this._dropRange.leftCol;o<=this._dropRange.rightCol;o++)this._isDraggingColumns&&(u[o]||(u[o]={dataType:this._owner.columns[o].dataType,align:this._owner.columns[o].align,format:this._owner.columns[o].format})),n=t*this._owner.columns.length+o,s=this._owner.selectedSheet._styledCells[n]?this._owner._cloneObject(this._owner.selectedSheet._styledCells[n]):null,i=this._owner.getCellData(t,o,!1),d.push({rowIndex:t,columnIndex:o,cellContent:i,cellStyle:s});if(e?(this._oldDroppingCells=d,this._oldDroppingColumnSetting=u):(this._newDroppingCells=d,this._newDroppingColumnSetting=u),this._isCopyCells){if(this._isDraggingColumns)if(e)for(t=this._dragRange.topRow;t<=this._dragRange.bottomRow;t++)for(o=this._dragRange.leftCol;o<=this._dragRange.rightCol;o++)(a=this._owner.selectedSheet.findTable(t,o))&&(h=a.getRange(),c=a.getColumns(),a.showHeaderRow&&t===h.topRow&&(this._draggingTableColumns||(this._draggingTableColumns=[]),this._draggingTableColumns.push({rowIndex:t,columnIndex:o,cellContent:c[o-h.leftCol].name})));else if(this._draggingTableColumns&&this._draggingTableColumns.length>0&&this._draggingTableColumns&&this._draggingTableColumns.length>0)for(l=0;l<this._draggingTableColumns.length;l++)r=this._draggingTableColumns[l],(a=this._owner.selectedSheet.findTable(r.rowIndex,r.columnIndex))&&(h=a.getRange(),c=a.getColumns(),a.showHeaderRow&&r.rowIndex===h.topRow&&(r.updatedCellContent=c[r.columnIndex-h.leftCol].name))}else if(e)for(this._draggingCells=[],this._draggingColumnSetting={},t=this._dragRange.topRow;t<=this._dragRange.bottomRow;t++)for(o=this._dragRange.leftCol;o<=this._dragRange.rightCol;o++)this._isDraggingColumns&&(this._draggingColumnSetting[o]||(this._draggingColumnSetting[o]={dataType:this._owner.columns[o].dataType,align:this._owner.columns[o].align,format:this._owner.columns[o].format})),n=t*this._owner.columns.length+o,s=this._owner.selectedSheet._styledCells[n]?this._owner._cloneObject(this._owner.selectedSheet._styledCells[n]):null,i=this._owner.getCellData(t,o,!1),this._draggingCells.push({rowIndex:t,columnIndex:o,cellContent:i,cellStyle:s});else if(this._isDraggingColumns&&this._draggingCells&&this._draggingCells.length>0)for(l=0;l<this._draggingCells.length;l++)r=this._draggingCells[l],(a=this._owner.selectedSheet.findTable(r.rowIndex,r.columnIndex))&&(h=a.getRange(),c=a.getColumns(),a.showHeaderRow&&r.rowIndex===h.topRow&&(r.updatedCellContent=c[r.columnIndex-h.leftCol].name))},o.prototype._handleUndoRedo=function(t){var o,n,i,s,l,r,a,h,c,d,u=this,_=t?u._oldDroppingCells:u._newDroppingCells,g=t?u._oldDroppingColumnSetting:u._newDroppingColumnSetting;u._owner.selectedSheet&&(u._owner._clearCalcEngine(),u._owner.deferUpdate(function(){var f,p,w;if(u._affectedFormulas&&(r=t?u._affectedFormulas.oldFormulas:u._affectedFormulas.newFormulas),r&&r.length>0)for(o=0;o<r.length;o++)(a=r[o]).sheet.name===u._owner.selectedSheet.name?u._owner.setCellData(a.point.x,a.point.y,a.formula):a.sheet.grid.setCellData(a.point.x,a.point.y,a.formula);if(u._affectedDefinedNameVals&&(h=t?u._affectedDefinedNameVals.oldDefinedNameVals:u._affectedDefinedNameVals.newDefinedNameVals),h&&h.length>0)for(o=0;o<h.length;o++)c=h[o],(d=u._owner._getDefinedNameIndexByName(c.name))>-1&&(u._owner.definedNames[d].value=c.value);for(o=0;o<_.length;o++)n=_[o],u._owner.setCellData(n.rowIndex,n.columnIndex,n.cellContent),(f=u._owner.selectedSheet.findTable(n.rowIndex,n.columnIndex))&&(p=f.getRange(),w=f.getColumns(),f.showHeaderRow&&n.rowIndex===p.topRow&&(w[n.columnIndex-p.leftCol].name=n.cellContent)),i=n.rowIndex*u._owner.columns.length+n.columnIndex,n.cellStyle?u._owner.selectedSheet._styledCells[i]=n.cellStyle:delete u._owner.selectedSheet._styledCells[i];if(u._isDraggingColumns&&g&&Object.keys(g).forEach(function(t){u._owner.columns[+t].dataType=g[+t].dataType?g[+t].dataType:e.DataType.Object,u._owner.columns[+t].align=g[+t].align,u._owner.columns[+t].format=g[+t].format}),u._isCopyCells){if(u._draggingTableColumns&&u._draggingTableColumns.length>0)for(o=0;o<u._draggingTableColumns.length;o++)n=u._draggingTableColumns[o],(f=u._owner.selectedSheet.findTable(n.rowIndex,n.columnIndex))&&(p=f.getRange(),w=f.getColumns(),f.showHeaderRow&&n.rowIndex===p.topRow&&(u._owner.setCellData(n.rowIndex,n.columnIndex,t?n.cellContent:n.updatedCellContent),w[n.columnIndex-p.leftCol].name=t?n.cellContent:n.updatedCellContent))}else{for(o=0;o<u._draggingCells.length;o++)n=u._draggingCells[o],(f=u._owner.selectedSheet.findTable(n.rowIndex,n.columnIndex))?(p=f.getRange(),w=f.getColumns(),f.showHeaderRow&&n.rowIndex===p.topRow?(u._owner.setCellData(n.rowIndex,n.columnIndex,t?n.cellContent:n.updatedCellContent),w[n.columnIndex-p.leftCol].name=t?n.cellContent:n.updatedCellContent):u._owner.setCellData(n.rowIndex,n.columnIndex,t?n.cellContent:null)):u._owner.setCellData(n.rowIndex,n.columnIndex,t?n.cellContent:null),i=n.rowIndex*u._owner.columns.length+n.columnIndex,t?n.cellStyle&&(u._owner.selectedSheet._styledCells[i]=n.cellStyle):u._owner.selectedSheet._styledCells[i]&&delete u._owner.selectedSheet._styledCells[i];if(u._isDraggingColumns&&u._draggingColumnSetting&&Object.keys(u._draggingColumnSetting).forEach(function(o){u._owner.columns[+o].dataType=t&&u._draggingColumnSetting[+o].dataType?u._draggingColumnSetting[+o].dataType:e.DataType.Object,u._owner.columns[+o].align=t?u._draggingColumnSetting[+o].align:null,u._owner.columns[+o].format=t?u._draggingColumnSetting[+o].format:null}),t){if(u._isDraggingColumns)if(u._dragRange.leftCol<u._dropRange.leftCol)for(l=u._dragRange.leftCol,s=u._dropRange.leftCol;s<=u._dropRange.rightCol;s++)u._owner._updateColumnFiler(s,l),l++;else for(l=u._dragRange.rightCol,s=u._dropRange.rightCol;s>=u._dropRange.leftCol;s--)u._owner._updateColumnFiler(s,l),l--}else if(u._isDraggingColumns)if(u._dragRange.leftCol>u._dropRange.leftCol)for(l=u._dropRange.leftCol,s=u._dragRange.leftCol;s<=u._dragRange.rightCol;s++)u._owner._updateColumnFiler(s,l),l++;else for(l=u._dropRange.rightCol,s=u._dragRange.rightCol;s>=u._dragRange.leftCol;s--)u._owner._updateColumnFiler(s,l),l--}}))},o}(o);t._MoveCellsAction=d;var u=function(e){function t(t){var o=e.call(this,t)||this;return o._oldValues=[],o._mergeAction=new h(t),o._celltyleAction=new a(t),o._cutSheet=t._copiedSheet,o._selection=t.selection,o._cutSelection=t._copiedRanges[0],o._saveCutValues(!0),o}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){var e,t,o;this._cutSheet===this._owner.selectedSheet?this._owner:this._cutSheet.grid;for(this._saveCutValues(!1),this._newValues=[],e=this._selection.topRow;e<=this._selection.bottomRow;e++)for(t=this._selection.leftCol;t<=this._selection.rightCol;t++){if(!this._owner.columns[t])return!1;o=null==(o=this._owner.getCellData(e,t,!!this._owner.columns[t].dataMap))?"":o,this._newValues.push({row:e,col:t,value:o})}return this._mergeAction.saveNewState(),this._celltyleAction.saveNewState(),!0},t.prototype.updateForPasting=function(e){var t=this._owner.getCellData(e.row,e.col,!!this._owner.columns[e.col].dataMap);t=null==t?"":t,this._oldValues.push({row:e.row,col:e.col,value:t}),this._selection.row=Math.min(this._selection.topRow,e.topRow),this._selection.row2=Math.max(this._selection.bottomRow,e.bottomRow),this._selection.col=Math.min(this._selection.leftCol,e.leftCol),this._selection.col2=Math.max(this._selection.rightCol,e.rightCol)},t.prototype._saveCutValues=function(e){var t,o,n,i=this._cutSheet===this._owner.selectedSheet?this._owner:this._cutSheet.grid,s=[];for(t=this._cutSelection.topRow;t<=this._cutSelection.bottomRow;t++)if(null!=i.rows[t])for(o=this._cutSelection.leftCol;o<=this._cutSelection.rightCol;o++)n=null==(n=i.getCellData(t,o,!!i.columns[o].dataMap))?"":n,s.push({row:t,col:o,value:n});e?this._oldCutValues=s:this._newCutValues=s},t.prototype._handleUndoRedo=function(e){var t=this,o=e?t._oldCutValues:t._newCutValues,n=e?t._oldValues:t._newValues;t._owner._clearCalcEngine(),t._owner.selectedSheet.selectionRanges.clear(),t._owner.deferUpdate(function(){var i,s,l=t._cutSheet===t._owner.selectedSheet?t._owner:t._cutSheet.grid;for(t._owner.selectedSheet.selectionRanges.push(t._selection),i=0;i<o.length;i++)s=o[i],l.setCellData(s.row,s.col,s.value);for(i=0;i<n.length;i++)s=n[i],t._owner.setCellData(s.row,s.col,s.value);e?(t._mergeAction.undo(),t._celltyleAction.undo()):(t._mergeAction.redo(),t._celltyleAction.redo()),t._owner.refresh(!1)})},t}(o);t._CutAction=u;var _=function(e){function t(t,o){var n=e.call(this,t)||this;return n._table=o,n._saveValues(!0),n}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype.saveNewState=function(){return this._saveValues(!1),!0},t.prototype._saveValues=function(e){var t={name:this._table.name,style:this._table.style,showHeaderRow:this._table.showHeaderRow,showTotalRow:this._table.showTotalRow,showbandedRows:this._table.showBandedRows,showBandedColumns:this._table.showBandedColumns,alterFirstColumn:this._table.alterFirstColumn,alterLastColumn:this._table.alterLastColumn};e?this._oldTableSetting=t:this._newTableSetting=t},t.prototype._handleUndoRedo=function(e){var t=e?this._oldTableSetting:this._newTableSetting;this._owner.beginUpdate(),this._owner._isUndoing=!0,this._table.name=t.name,this._table.style=t.style,this._table.showHeaderRow=t.showHeaderRow,this._table.showTotalRow=t.showTotalRow,this._table.showBandedRows=t.showbandedRows,this._table.showBandedColumns=t.showBandedColumns,this._table.alterFirstColumn=t.alterFirstColumn,this._table.alterLastColumn=t.alterLastColumn,this._owner._isUndoing=!1,this._owner.endUpdate()},t}(o);t._TableSettingAction=_;var g=function(e){function t(t,o){var n=e.call(this,t)||this;return n._addedTable=o,n}return __extends(t,e),t.prototype.undo=function(){this._handleUndoRedo(!0)},t.prototype.redo=function(){this._handleUndoRedo(!1)},t.prototype._handleUndoRedo=function(e){var t,o,n;if(this._addedTable.showHeaderRow)for(o=this._addedTable.getRange(),n=this._addedTable.getColumns(),t=0;t<o.columnSpan;t++)this._owner.setCellData(o.topRow,o.leftCol+t,e?this._addedTable._orgHeaderCellsContent[t]:n[t].name);e?this._owner.selectedSheet.tables.remove(this._addedTable):this._owner.selectedSheet.tables.push(this._addedTable),this._owner.refresh()},t}(o);t._TableAction=g;var f=function(e){function t(t){var o=e.call(this,t)||this;return o._oldFilterDefinition=t.filter.filterDefinition,o}return __extends(t,e),t.prototype.undo=function(){this._owner.filter.filterDefinition=this._oldFilterDefinition},t.prototype.redo=function(){this._owner.filter.filterDefinition=this._newFilterDefinition},t.prototype.saveNewState=function(){return this._oldFilterDefinition!==this._owner.filter.filterDefinition&&(this._newFilterDefinition=this._owner.filter.filterDefinition,!0)},t}(o);t._FilteringAction=f}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(t){"use strict";var o=function(o){function n(e,t){var n=o.call(this,e)||this;return n._idx=-1,n._isDisableDelRow=!1,n._owner=t,n.applyTemplate("",n.getTemplate(),{_insRows:"insert-rows",_delRows:"delete-rows",_insCols:"insert-columns",_delCols:"delete-columns",_convertTable:"convert-table"}),n._init(),n}return __extends(n,o),Object.defineProperty(n.prototype,"visible",{get:function(){return"none"!==this.hostElement.style.display},enumerable:!0,configurable:!0}),n.prototype.show=function(t,o){if(this._owner.selectedSheet){var n=(o?o.x:t.clientX)+(t?window.pageXOffset:0),i=(o?o.y:t.clientY)+(t?window.pageYOffset:0);this.hostElement.style.position="absolute",this.hostElement.style.display="inline",this._owner.itemsSource&&(e.addClass(this._insCols,"wj-state-disabled"),e.addClass(this._delCols,"wj-state-disabled")),this._owner._isDisableDeleteRow(this._owner.selection.topRow,this._owner.selection.bottomRow)&&(this._isDisableDelRow=!0,e.addClass(this._delRows,"wj-state-disabled")),this._showTableOperation(),i+this.hostElement.clientHeight>window.innerHeight&&(i-=this.hostElement.clientHeight),n+this.hostElement.clientWidth>window.innerWidth&&(n-=this.hostElement.clientWidth),this.hostElement.style.top=i+"px",this.hostElement.style.left=n+"px"}},n.prototype.hide=function(){this._idx=-1;var t=this.hostElement.querySelectorAll(".wj-context-menu-item");this._removeSelectedState(t),this.hostElement.style.display="none",this._isDisableDelRow=!1,e.removeClass(this._delRows,"wj-state-disabled"),e.removeClass(this._insCols,"wj-state-disabled"),e.removeClass(this._delCols,"wj-state-disabled")},n.prototype.moveToNext=function(){var t=this.hostElement.querySelectorAll(".wj-context-menu-item");for(this._removeSelectedState(t),this._idx++,1===this._idx&&this._isDisableDelRow&&this._idx++;t[this._idx]&&"none"===t[this._idx].style.display;)this._idx++;this._idx>=t.length&&(this._idx=0),e.addClass(t[this._idx],"wj-context-menu-item-selected")},n.prototype.moveToPrev=function(){var t=this.hostElement.querySelectorAll(".wj-context-menu-item");for(this._removeSelectedState(t),this._idx--,1===this._idx&&this._isDisableDelRow&&this._idx--;this._idx>0&&"none"===t[this._idx].style.display;)this._idx--;this._idx<0&&(this._idx=t.length-1),e.addClass(t[this._idx],"wj-context-menu-item-selected")},n.prototype.moveToFirst=function(){var t=this.hostElement.querySelectorAll(".wj-context-menu-item");this._removeSelectedState(t),this._idx=0,e.addClass(t[this._idx],"wj-context-menu-item-selected")},n.prototype.moveToLast=function(){var t=this.hostElement.querySelectorAll(".wj-context-menu-item");this._removeSelectedState(t),this._idx=t.length-1,t[this._idx]&&"none"===t[this._idx].style.display&&this._idx--,e.addClass(t[this._idx],"wj-context-menu-item-selected")},n.prototype.handleContextMenu=function(){if(-1===this._idx)this.moveToNext();else{switch(this.hostElement.querySelectorAll(".wj-context-menu-item")[this._idx]){case this._insCols:this._owner.insertColumns();break;case this._insRows:this._owner.insertRows();break;case this._delCols:this._owner.deleteColumns();break;case this._delRows:this._isDisableDelRow||this._owner.deleteRows();break;case this._convertTable:this._addTable()}this.hide(),this._owner.hostElement.focus()}},n.prototype._init=function(){var e=this,t=this.hostElement.querySelectorAll(".wj-context-menu-item");e.hostElement.style.zIndex="9999",document.querySelector("body").appendChild(e.hostElement),e.addEventListener(document.body,"mousemove",function(){e._removeSelectedState(t)}),e.addEventListener(e.hostElement,"contextmenu",function(e){e.preventDefault()}),e.addEventListener(e._insRows,"click",function(t){e._owner.insertRows(),e.hide(),e._owner.hostElement.focus()}),e.addEventListener(e._delRows,"click",function(t){e._isDisableDelRow||e._owner.deleteRows(),e.hide(),e._owner.hostElement.focus()}),e.addEventListener(e._insCols,"click",function(t){e._owner.insertColumns(),e.hide(),e._owner.hostElement.focus()}),e.addEventListener(e._delCols,"click",function(t){e._owner.deleteColumns(),e.hide(),e._owner.hostElement.focus()}),e.addEventListener(e._convertTable,"click",function(t){e._addTable(),e.hide(),e._owner.hostElement.focus()})},n.prototype._removeSelectedState=function(t){for(var o=0;o<t.length;o++)e.removeClass(t[o],"wj-context-menu-item-selected")},n.prototype._showTableOperation=function(){var e,t,o=this._owner.selection;for(e=o.topRow;e<=o.bottomRow;e++)for(t=o.leftCol;t<=o.rightCol;t++)if(null!=this._owner.selectedSheet.findTable(e,t))return this._convertTable.style.display="none",void(this._convertTable.parentElement.style.display="none");o.isSingleCell||this._owner._containsMergedCells(o)?(this._convertTable.style.display="none",this._convertTable.parentElement.style.display="none"):(this._convertTable.style.display="inline",this._convertTable.parentElement.style.display="inline")},n.prototype._addTable=function(){var e,o;0!==this._owner.undoStack.stackSize&&(e=this._owner.selectedSheet._addTable(this._owner.selection),o=new t._TableAction(this._owner,e),this._owner.undoStack._addAction(o))},n.controlTemplate='<div class="wj-context-menu wj-control wj-flexsheet-context-menu" width="150px"><div class="wj-context-menu-item" wj-part="insert-rows">Insert Row</div><div class="wj-context-menu-item" wj-part="delete-rows">Delete Rows</div><div class="wj-context-menu-item" wj-part="insert-columns">Insert Column</div><div class="wj-context-menu-item" wj-part="delete-columns">Delete Columns</div><div><div class="wj-state-disabled" style="width:100%;height:1px;background-color:lightgray;"></div><div class="wj-context-menu-item" wj-part="convert-table">Convert To Table</div></div></div>',n}(e.Control);t._ContextMenu=o}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(t){"use strict";var o=function(e){function o(t,o){var n=e.call(this,t)||this;return n._splitterMousedownHdl=n._splitterMousedownHandler.bind(n),n._owner=o,n.applyTemplate("",n.getTemplate(),{_divSheet:"left",_divSplitter:"splitter",_divRight:"right"}),n._init(),n}return __extends(o,e),Object.defineProperty(o.prototype,"sheetControl",{get:function(){return this._sheetControl},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"visible",{get:function(){return"none"!==this.hostElement.style.display},set:function(e){this.hostElement.style.display=e?"block":"none",this._divSheet.style.display=e?"block":"none"},enumerable:!0,configurable:!0}),o.prototype.getSheetBlanketSize=function(){return 20},o.prototype.adjustSize=function(){var e=this._owner.scrollSize.width-this._owner.clientSize.width,t=(this._owner.scrollSize.height,this._owner.clientSize.height,this._divSplitter.parentElement);e<=0?(t.style.minWidth="100px",this._divSplitter.style.display="none",this._divRight.style.display="none",this._divSheet.style.width="100%",this._divSplitter.removeEventListener("mousedown",this._splitterMousedownHdl,!0)):(t.style.minWidth="300px",this._divSplitter.style.display="none",this._divRight.style.display="none",this._divSheet.style.width="100%",this._divSplitter.removeEventListener("mousedown",this._splitterMousedownHdl,!0),this._divSplitter.addEventListener("mousedown",this._splitterMousedownHdl,!0)),this._sheetControl._adjustSize()},o.prototype._init=function(){var e=this;e._funSplitterMousedown=function(t){e._splitterMouseupHandler(t)},e._divSplitter.parentElement.style.height=e.getSheetBlanketSize()+"px",e._sheetControl=new t._SheetTabs(e._divSheet,this._owner)},o.prototype._splitterMousedownHandler=function(e){this._startPos=e.pageX,document.addEventListener("mousemove",this._splitterMousemoveHandler.bind(this),!0),document.addEventListener("mouseup",this._funSplitterMousedown,!0),e.preventDefault()},o.prototype._splitterMousemoveHandler=function(e){null!==this._startPos&&void 0!==this._startPos&&this._adjustDis(e.pageX-this._startPos)},o.prototype._splitterMouseupHandler=function(e){document.removeEventListener("mousemove",this._splitterMousemoveHandler,!0),document.removeEventListener("mouseup",this._funSplitterMousedown,!0),this._adjustDis(e.pageX-this._startPos),this._startPos=null},o.prototype._adjustDis=function(e){var t=this._divRight.offsetWidth-e,o=this._divSheet.offsetWidth+e;t<=100?(t=100,e=this._divRight.offsetWidth-t,o=this._divSheet.offsetWidth+e):o<=100&&(e=(o=100)-this._divSheet.offsetWidth,t=this._divRight.offsetWidth-e),0!=e&&(this._divRight.style.width=t+"px",this._divSheet.style.width=o+"px",this._startPos=this._startPos+e)},o.controlTemplate='<div><div wj-part="left" style ="float:left;height:100%;overflow:hidden"></div><div wj-part="splitter" style="float:left;height:100%;width:6px;background-color:#e9eaee;padding:2px;cursor:e-resize"><div style="background-color:#8a9eb2;height:100%"></div></div><div wj-part="right" style="float:left;height:100%;background-color:#e9eaee"></div></div>',o}(e.Control);t._TabHolder=o}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(n){function i(){return null!==n&&n.apply(this,arguments)||this}return __extends(i,n),i.prototype.updateCell=function(i,s,l,r,a){var h,c,d,u,_,g,f,p,w,m,C,b,y,S,v,R=i.grid;switch(i.cellType===t.CellType.Cell&&this._resetCellStyle(i.columns[l],r),n.prototype.updateCell.call(this,i,s,l,r,a),a&&!a.isSingleCell&&(s=a.row,l=a.col,a.row2,a.col2),C=R._getBindingColumn(i,s,i.columns[l]),i.cellType){case t.CellType.RowHeader:r.textContent=s+1+"";break;case t.CellType.ColumnHeader:h=e.isNullOrWhiteSpace(C.header)||!e.isNullOrWhiteSpace(C.binding)&&C.header===e.toHeaderCase(C.binding)?o.FlexSheet.convertNumberToAlpha(l):C.header,r.textContent?r.innerHTML=r.innerHTML.replace(e.escapeHtml(r.textContent.trim()),h).replace(r.textContent,h):r.innerHTML+=h,r.style.textAlign="center";break;case t.CellType.Cell:if(d=i.grid,c=s*d.columns.length+l,p=d.selectedSheet&&d.selectedSheet._styledCells?d.selectedSheet._styledCells[c]:null,a&&!a.isSingleCell&&(s=(y=this._getFirstVisibleCell(d,a)).row,l=y.col),i.rows[s]instanceof o.HeaderRow)i.columns[l].dataType===e.DataType.Boolean?1===r.childElementCount&&r.firstElementChild instanceof HTMLInputElement&&"checkbox"===r.firstElementChild.type&&(r.innerHTML=e.escapeHtml(d.getCellValue(s,l))):r.innerHTML||(r.innerHTML=e.escapeHtml(d.getCellValue(s,l))),e.addClass(r,"wj-header-row");else if(_=d.getCellValue(s,l,!1),g=d.getCellData(s,l,!1),f=null!=g&&"string"==typeof g&&"="===g[0],S=i.rows[s]instanceof t.GroupRow,b=(p?p.format:null)||(S?null:C.format),d.editRange&&d.editRange.contains(s,l)?!e.isNumber(_)||C.dataMap||f||(b&&(_=this._getFormattedValue(_,b)),(m=r.querySelector("input"))&&(m.value=_)):i.columns[l].dataType===e.DataType.Boolean?(w=r.querySelector('[type="checkbox"]'))&&(w.checked=d.getCellValue(s,l),w.disabled=w.disabled||!d.canEditCell(s,l)):C.dataMap&&!S?(_=d.getCellValue(s,l,!0),(u=r.firstChild)&&3===u.nodeType&&u.nodeValue!==_&&(u.nodeValue=_)):0===r.childElementCount&&r.textContent===d.getCellData(s,l,!0)&&(""!==(_=d.getCellValue(s,l,!0))&&e.isNumber(+_)&&!isNaN(+_)&&/[hsmy\:]/i.test(b)&&(v=o._Expression._fromOADate(+_),isNaN(v.getTime())||(_=e.Globalize.formatDate(v,b))),!b&&S||(_=e.isString(_)?_.replace(/^(\')(\s*[\w|=])/,"$2"):_,e.isString(_)?_&&this._isURL(_)?r.innerHTML='<a href="'+_+'" target="_blank">'+e.escapeHtml(_)+"</a>":r.innerHTML=e.escapeHtml(_):r.innerHTML=_)),p){var x,T=r.style;for(var k in p)"className"===k?p.className&&e.addClass(r,p.className):"format"!==k&&(x=p[k])&&(!e.hasClass(r,"wj-state-selected")&&!e.hasClass(r,"wj-state-multi-selected")||"color"!==k&&"backgroundColor"!==k?T[k]="whiteSpace"===k&&"normal"===x?"":x:T[k]="")}(r.style.backgroundColor||r.style.color)&&(p||(d.selectedSheet._styledCells[c]=p={}),r.style.backgroundColor&&(p.backgroundColor=r.style.backgroundColor),r.style.color&&(p.color=r.style.color))}i.cellType===t.CellType.Cell&&(s!==R._lastVisibleFrozenRow||e.hasClass(r,"wj-frozen-row")||e.addClass(r,"wj-frozen-row"),l!==R._lastVisibleFrozenColumn||e.hasClass(r,"wj-frozen-col")||e.addClass(r,"wj-frozen-col"))},i.prototype._resetCellStyle=function(e,t){["fontFamily","fontSize","fontStyle","fontWeight","textDecoration","textAlign","verticalAlign","backgroundColor","color","whiteSpace","borderLeftStyle","borderLeftColor","borderLeftWidth","borderRightStyle","borderRightColor","borderRightWidth","borderTopStyle","borderTopColor","borderTopWidth","borderBottomStyle","borderBottomColor","borderBottomWidth"].forEach(function(o){"textAlign"===o?t.style.textAlign=e.getAlignment():t.style[o]=""})},i.prototype._getFormattedValue=function(t,o){return t!==Math.round(t)&&(o=o.replace(/([a-z])(\d*)(.*)/gi,"$0112$3")),e.Globalize.formatNumber(t,o,!0)},i.prototype._getFirstVisibleCell=function(e,o){var n,i;for(n=o.topRow;n<=o.bottomRow&&!e.rows[n].isVisible;n++);for(i=o.leftCol;i<=o.rightCol&&!e.columns[i].isVisible;i++);return new t.CellRange(n,i)},i.prototype._isURL=function(e){return new RegExp("^(https|http|ftp|rtsp|mms)://(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].[a-z]{2,6})(:[0-9]{1,4})?(/($|[a-zA-Z0-9.,?'\\+&amp;%$#=~_-]+))*").test(e)},i}(t.CellFactory);o._FlexSheetCellFactory=n}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(o){"use strict";var n=[{name:"abs",description:"Returns the absolute value of a number."},{name:"acos",description:"Returns the arccosine of a number."},{name:"and",description:"Returns TRUE if all of its arguments are TRUE."},{name:"asin",description:"Returns the arcsine of a number."},{name:"atan",description:"Returns the arctangent of a number."},{name:"atan2",description:"Returns the arctangent from x- and y-coordinates."},{name:"average",description:"Returns the average of its arguments."},{name:"ceiling",description:"Rounds a number to the nearest integer or to the nearest multiple of significance."},{name:"char",description:"Returns the character specified by the code number."},{name:"choose",description:"Chooses a value from a list of values."},{name:"code",description:"Returns a numeric code for the first character in a text string."},{name:"column",description:"Returns the column number of a reference."},{name:"columns",description:"Returns the number of columns in a reference."},{name:"concatenate",description:"Joins several text items into one text item."},{name:"cos",description:"Returns the cosine of a number."},{name:"count",description:"Counts how many numbers are in the list of arguments."},{name:"counta",description:"Counts how many values are in the list of arguments."},{name:"countblank",description:"Counts the number of blank cells within a range."},{name:"countif",description:"Counts the number of cells within a range that meet the given criteria."},{name:"countifs",description:"Counts the number of cells within a range that meet multiple criteria."},{name:"date",description:"Returns the serial number of a particular date."},{name:"datedif",description:"Calculates the number of days, months, or years between two dates."},{name:"day",description:"Converts a serial number to a day of the month."},{name:"dcount",description:"Counts the cells that contain numbers in a database."},{name:"exp",description:"Returns e raised to the power of a given number."},{name:"false",description:"Returns the logical value FALSE."},{name:"find",description:"Finds one text value within another (case-sensitive)."},{name:"floor",description:"Rounds a number down, toward zero."},{name:"hlookup",description:"Looks in the top row of an array and returns the value of the indicated cell."},{name:"hour",description:"Converts a serial number to an hour."},{name:"if",description:"Specifies a logical test to perform."},{name:"index",description:"Uses an index to choose a value from a reference."},{name:"left",description:"Returns the leftmost characters from a text value."},{name:"len",description:"Returns the number of characters in a text string."},{name:"ln",description:"Returns the natural logarithm of a number."},{name:"lower",description:"Converts text to lowercase."},{name:"max",description:"Returns the maximum value in a list of arguments."},{name:"mid",description:"Returns a specific number of characters from a text string starting at the position you specify."},{name:"min",description:"Returns the minimum value in a list of arguments."},{name:"mod",description:"Returns the remainder from division."},{name:"month",description:"Converts a serial number to a month."},{name:"not",description:"Reverses the logic of its argument."},{name:"now",description:"Returns the serial number of the current date and time."},{name:"or",description:"Returns TRUE if any argument is TRUE."},{name:"pi",description:"Returns the value of pi."},{name:"power",description:"Returns the result of a number raised to a power."},{name:"product",description:"Multiplies its arguments."},{name:"proper",description:"Capitalizes the first letter in each word of a text value."},{name:"rand",description:"Returns a random number between 0 and 1."},{name:"rank",description:"Returns the rank of a number in a list of numbers."},{name:"rate",description:"Returns the interest rate per period of an annuity."},{name:"replace",description:"Replaces characters within text."},{name:"rept",description:"Repeats text a given number of times."},{name:"right",description:"Returns the rightmost characters from a text value."},{name:"round",description:"Rounds a number to a specified number of digits."},{name:"rounddown",description:"Rounds a number down, toward zero."},{name:"roundup",description:"Rounds a number up, away from zero."},{name:"row",description:"Returns the row number of a reference."},{name:"rows",description:"Returns the number of rows in a reference."},{name:"search",description:"Finds one text value within another (not case-sensitive)."},{name:"sin",description:"Returns the sine of the given angle."},{name:"sqrt",description:"Returns a positive square root."},{name:"stdev",description:"Estimates standard deviation based on a sample."},{name:"stdevp",description:"Calculates standard deviation based on the entire population."},{name:"substitute",description:"Substitutes new text for old text in a text string."},{name:"subtotal",description:"Returns a subtotal in a list or database."},{name:"sum",description:"Adds its arguments."},{name:"sumif",description:"Adds the cells specified by a given criteria."},{name:"sumifs",description:"Adds the cells in a range that meet multiple criteria."},{name:"sumproduct",description:"Multiplies corresponding components in the given arrays, and returns the sum of those products."},{name:"tan",description:"Returns the tangent of a number."},{name:"text",description:"Formats a number and converts it to text."},{name:"time",description:"Returns the serial number of a particular time."},{name:"today",description:"Returns the serial number of today's date."},{name:"trim",description:"Removes spaces from text."},{name:"true",description:"Returns the logical value TRUE."},{name:"trunc",description:"Truncates a number to an integer."},{name:"upper",description:"Converts text to uppercase."},{name:"value",description:"Converts a text argument to a number."},{name:"var",description:"Estimates variance based on a sample."},{name:"varp",description:"Calculates variance based on the entire population."},{name:"year",description:"Converts a serial number to a year."}],i=function(i){function l(n,s){var l=i.call(this,n,s)||this;return l._selectedSheetIndex=-1,l._columnHeaderClicked=!1,l._addingSheet=!1,l._mouseMoveHdl=l._mouseMove.bind(l),l._clickHdl=l._click.bind(l),l._touchStartHdl=l._touchStart.bind(l),l._touchEndHdl=l._touchEnd.bind(l),l._isContextMenuKeyDown=!1,l._isClicking=!1,l._resettingFilter=!1,l._definedNames=new e.collections.ObservableArray,l._builtInTableStylesCache=null,l._needCopyToSheet=!0,l.selectedSheetChanged=new e.Event,l.draggingRowColumn=new e.Event,l.droppingRowColumn=new e.Event,l.loaded=new e.Event,l.unknownFunction=new e.Event,l.sheetCleared=new e.Event,l.prepareChangingRow=new e.Event,l.prepareChangingColumn=new e.Event,l.rowChanged=new e.Event,l.columnChanged=new e.Event,l._needCopyToSheet=!1,l._colorThemes=["FFFFFF","000000","EEECE1","1F497D","4F818D","C0504D","9BBB59","8064A2","4BACC6","F79646"],l._eCt.style.backgroundColor="white",e.addClass(l.hostElement,"wj-flexsheet"),e.setCss(l.hostElement,{fontFamily:"Arial"}),l._cf=new o._FlexSheetCellFactory,l._bndSortConverter=l._sheetSortConverter.bind(l),l.quickAutoSize=!1,l._init(),l.showSort=!1,l.allowSorting=!1,l.showGroups=!1,l.showMarquee=!0,l.showSelectedHeaders=t.HeadersVisibility.All,l.allowResizing=t.AllowResizing.Both,l.allowDragging=t.AllowDragging.None,l._needCopyToSheet=!0,l}return __extends(l,i),l.prototype._getProductInfo=function(){return"R20I,FlexSheet"},Object.defineProperty(l.prototype,"sheets",{get:function(){return this._sheets||(this._sheets=new o.SheetCollection,this._sheets.selectedSheetChanged.addHandler(this._selectedSheetChange,this),this._sheets.collectionChanged.addHandler(this._sourceChange,this),this._sheets.sheetVisibleChanged.addHandler(this._sheetVisibleChange,this),this._sheets.sheetCleared.addHandler(this.onSheetCleared,this)),this._sheets},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"selectedSheetIndex",{get:function(){return this._selectedSheetIndex},set:function(e){e!==this._selectedSheetIndex&&(this._showSheet(e),this._sheets.selectedIndex=e)},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"selectedSheet",{get:function(){return this._sheets[this._selectedSheetIndex]},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"isFunctionListOpen",{get:function(){return this._functionListHost&&"none"!==this._functionListHost.style.display},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"isTabHolderVisible",{get:function(){return this._tabHolder.visible},set:function(e){e!==this._tabHolder.visible&&(e?(this._divContainer.style.height=this._divContainer.parentElement.clientHeight-this._tabHolder.getSheetBlanketSize()+"px",this._eFocus.removeAttribute("tabindex")):(this._divContainer.style.height=this._divContainer.parentElement.clientHeight+"px",this._eFocus.tabIndex=this._tabIndex),this._tabHolder.visible=e)},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"undoStack",{get:function(){return this._undoStack},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"sortManager",{get:function(){return this._sortManager},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"filter",{get:function(){return this._filter},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"showFilterIcons",{get:function(){return!!this._filter&&this._filter.showFilterIcons},set:function(e){this._filter&&this._filter.showFilterIcons!==e&&(this._filter.showFilterIcons=e)},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"definedNames",{get:function(){return this._definedNames},enumerable:!0,configurable:!0}),l.prototype.onSelectedSheetChanged=function(e){this._sortManager._refresh(),this.selectedSheetChanged.raise(this,e)},l.prototype.onDraggingRowColumn=function(e){this.draggingRowColumn.raise(this,e)},l.prototype.onDroppingRowColumn=function(t){this.droppingRowColumn.raise(this,new e.EventArgs)},l.prototype.onLoaded=function(t){var o=this;o._toRefresh&&(clearTimeout(o._toRefresh),o._toRefresh=null),o._toRefresh=setTimeout(function(){o._setFlexSheetToDirty(),o.invalidate()},10),o.loaded.raise(this,new e.EventArgs)},l.prototype.onUnknownFunction=function(e){this.unknownFunction.raise(this,e)},l.prototype.onSheetCleared=function(t){this.sheetCleared.raise(this,new e.EventArgs)},l.prototype.onPrepareChangingRow=function(){this.prepareChangingRow.raise(this,new e.EventArgs)},l.prototype.onPrepareChangingColumn=function(){this.prepareChangingColumn.raise(this,new e.EventArgs)},l.prototype.onRowChanged=function(e){this.rowChanged.raise(this,e)},l.prototype.onColumnChanged=function(e){this.columnChanged.raise(this,e)},l.prototype.refresh=function(e){void 0===e&&(e=!0);var t,o,n;if(this._divContainer.style.height=this._divContainer.parentElement.clientHeight-(this.isTabHolderVisible?this._tabHolder.getSheetBlanketSize():0)+"px",!this.preserveSelectedState&&this.selectedSheet&&(this.selectedSheet.selectionRanges.clear(),this.selectedSheet.selectionRanges.push(this.selection)),e&&this._clearCalcEngine(),this._lastVisibleFrozenRow=-1,this.frozenRows>0)for(var s=this.frozenRows-1;s>=0;s--)if(this.rows[s]&&this.rows[s].isVisible){this._lastVisibleFrozenRow=s;break}if(this._lastVisibleFrozenColumn=-1,this.frozenColumns>0)for(var l=this.frozenColumns-1;l>=0;l--)if(this.columns[l]&&this.columns[l].isVisible){this._lastVisibleFrozenColumn=l;break}if(this.selectedSheet){if(this.selectedSheet._freezeHiddenRowCnt>0)for(t=0;t<this.selectedSheet._freezeHiddenRowCnt;t++)(o=this.rows[t])instanceof h||(o.visible=!1);if(this.selectedSheet._freezeHiddenColumnCnt>0)for(n=0;n<this.selectedSheet._freezeHiddenColumnCnt;n++)this.columns[n].visible=!1}i.prototype.refresh.call(this,e),this._tabHolder.adjustSize()},l.prototype.setCellData=function(t,o,n,i,s){void 0===i&&(i=!1),void 0===s&&(s=!0);var l=e.isString(n)&&n.length>1&&"="===n[0];return this._clearCalcEngine(),this.cells.setCellData(t,o,n,i&&!l,s)},l.prototype.containsFocus=function(){return this.isFunctionListOpen||i.prototype.containsFocus.call(this)},l.prototype.addUnboundSheet=function(e,t,o,n,i){var s=this._addSheet(e,t,o,n,i);return 0===s.selectionRanges.length&&s.selectionRanges.push(this.selection),s},l.prototype.addBoundSheet=function(e,t,o,n){var i=this._addSheet(e,0,0,o,n);return t&&(i.itemsSource=t,this.childItemsPath&&(i.grid.childItemsPath=this.childItemsPath)),0===i.selectionRanges.length&&i.selectionRanges.push(this.selection),i},l.prototype.applyCellsStyle=function(e,t,n){void 0===n&&(n=!1);var i,s,l,r,a,h=t||[this.selection];if(this.selectedSheet){if(!e&&this._cloneStyle)return this.selectedSheet._styledCells=this._cloneObject(this._cloneStyle),this._cloneStyle=null,void this.refresh(!1);if(h){for(t||n?n&&!this._cloneStyle&&(this._cloneStyle=this._cloneObject(this.selectedSheet._styledCells)):(this.undoStack.stackSize>0&&(a=new o._CellStyleAction(this,this._cloneStyle)),this._cloneStyle=null),r=0;r<h.length;r++)for(i=(l=h[r]).topRow;i<=l.bottomRow;i++)for(s=l.leftCol;s<=l.rightCol;s++)this._applyStyleForCell(i,s,e);a&&(a.saveNewState(),this._undoStack._addAction(a))}t||this.refresh(!1)}},l.prototype.freezeAtCursor=function(){var e,t,o,n,i,s=this;if(s.selectedSheet){if(s.selection&&0===s.frozenRows&&0===s.frozenColumns){if(s._ptScrl.y<0)for(e=0;e<s.selection.topRow-1;e++)if(!((i=s.rows[e])instanceof h)){if(!(i._pos+s._ptScrl.y<0)){s.selectedSheet._freezeHiddenRowCnt=e;break}i.visible=!1}if(s._ptScrl.x<0)for(t=0;t<s.selection.leftCol-1;t++){if(!(s.columns[t]._pos+s._ptScrl.x<0)){s.selectedSheet._freezeHiddenColumnCnt=t;break}s.columns[t].visible=!1}o=s.selection.leftCol>0?s.selection.leftCol:0,n=s.selection.topRow>0?s.selection.topRow:0}else{for(e=0;e<s.frozenRows-1;e++)s.rows[e].visible=!0;for(t=0;t<s.frozenColumns-1;t++)s.columns[t].visible=!0;s._filter.apply(),o=0,n=0,s.selectedSheet._freezeHiddenRowCnt=0,s.selectedSheet._freezeHiddenColumnCnt=0}s.frozenRows=s.selectedSheet.grid.frozenRows=n,s.frozenColumns=s.selectedSheet.grid.frozenColumns=o,setTimeout(function(){s._setFlexSheetToDirty(),s.invalidate(),s.scrollIntoView(s.selection.topRow,s.selection.leftCol)},10)}},l.prototype.showColumnFilter=function(){var e=this.selection.col>0?this.selection.col:0;this.columns.length>0&&this._filter.editColumnFilter(this.columns[e])},l.prototype.clear=function(){this.beginUpdate(),this.selection=new t.CellRange,this.sheets.clear(),this._selectedSheetIndex=-1,this.columns.clear(),this.rows.clear(),this.columnHeaders.columns.clear(),this.rowHeaders.rows.clear(),this._undoStack.clear(),this._ptScrl=new e.Point,this._clearCalcEngine(),this._definedNames.clear(),this._builtInTableStylesCache=null,this.addUnboundSheet(),this.endUpdate()},l.prototype.getSelectionFormatState=function(){var e,t,o=this.rows.length,n=this.columns.length,i={isBold:!1,isItalic:!1,isUnderline:!1,textAlign:"left",isMergedCell:!1};if(0===o||0===n)return i;if(this.selection){if(this.selection.row>=o||this.selection.row2>=o||this.selection.col>=n||this.selection.col2>=n)return i;for(e=this.selection.topRow;e<=this.selection.bottomRow;e++)for(t=this.selection.leftCol;t<=this.selection.rightCol;t++)this._checkCellFormat(e,t,i)}return i},l.prototype.insertRows=function(n,i){var s,l,a,c,d,u=e.isNumber(n)&&n>=0?n:this.selection&&this.selection.topRow>-1?this.selection.topRow:0,_=e.isNumber(i)?i:1,g=this.rows[u],f=!1;if(this.selectedSheet){if(this.rows.length>0?u>=this.rows.length&&(u=this.rows.length-1):u=0,this._clearCalcEngine(),this.finishEditing(),0===u&&g&&g.constructor===h&&(u=1),this.onPrepareChangingRow(),this.undoStack.stackSize>0&&(s=new o._RowsChangedAction(this)),this._updateCellsForUpdatingRow(this.rows.length,u,_),(!this.collectionView||0===this.collectionView.sortDescriptions.length)&&(l=this._updateAffectedFormula(u,_,!0,!0),a=this._updateAffectedNamedRanges(u,_,!0,!0)),s&&(s._affectedFormulas=l,s._affectedDefinedNameVals=a),this.collectionView){for(f=!0,d=this.itemsSource instanceof e.collections.CollectionView,this.collectionView.beginUpdate(),c=0;c<_;c++)d?this.itemsSource.sourceCollection.splice(u-1,0,{}):this.itemsSource.splice(u-1,0,{});this.collectionView.endUpdate()}else{for(this.rows.beginUpdate(),c=0;c<_;c++)this.rows.insert(u,new t.Row);this.rows.endUpdate()}this._updateTablesForUpdatingRow(u,_),this.selection&&-1!==this.selection.row&&-1!==this.selection.col||(this.selection=new t.CellRange(0,0)),s&&(s.saveNewState(),this._undoStack._addAction(s)),this.onRowChanged(new r(u,_,!0)),f&&this.refresh()}},l.prototype.deleteRows=function(n,i){var s,l,a,c,d,u,_,g,f=e.isNumber(i)&&i>=0?i:this.selection&&this.selection.topRow>-1?this.selection.bottomRow-this.selection.topRow+1:1,p=e.isNumber(n)&&n>=0?n:this.selection&&this.selection.topRow>-1?this.selection.topRow:-1,w=e.isNumber(n)&&n>=0?n+f-1:this.selection&&this.selection.topRow>-1?this.selection.bottomRow:-1,m=!1;if(this.selectedSheet&&!(p>=this.rows.length)&&(w=Math.min(w,this.rows.length-1),this._clearCalcEngine(),this.finishEditing(),p>-1&&w>-1)){for(this.onPrepareChangingRow(),this.undoStack.stackSize>0&&(s=new o._RowsChangedAction(this)),this._updateCellsForUpdatingRow(this.rows.length,p,f,!0),l=this._updateAffectedFormula(w,w-p+1,!1,!0),a=this._updateAffectedNamedRanges(w,w-p+1,!1,!0),c=this._updateTablesForUpdatingRow(p,f,!0),s&&(s._affectedFormulas=l,s._affectedDefinedNameVals=a,s._deletedTables=c),g=!!this.collectionView&&this.itemsSource instanceof e.collections.CollectionView,this.rows.beginUpdate();w>=p;w--)(d=this.rows[w])&&d.constructor===h||(d.dataItem&&this.collectionView?(m=!0,this.collectionView.beginUpdate(),this._getCvIndex(w)>-1&&(u=this.collectionView.items[w-1],g?this.itemsSource.sourceCollection.splice(this.itemsSource.sourceCollection.indexOf(u),1):this.itemsSource.splice(this.itemsSource.indexOf(u),1)),this.collectionView.endUpdate()):this.rows.removeAt(w));this.rows.endUpdate(),_=this.rows.length,this.selectedSheet.selectionRanges.clear(),0===_?(this.select(new t.CellRange),"move"===this.hostElement.style.cursor&&(this.hostElement.style.cursor="default")):w===_-1?this.select(new t.CellRange(w,0,w,this.columns.length-1)):this.select(new t.CellRange(this.selection.topRow,this.selection.col,this.selection.topRow,this.selection.col2)),s&&(s.saveNewState(),this._undoStack._addAction(s)),this.onRowChanged(new r(p,f,!1)),m&&this.refresh()}},l.prototype.insertColumns=function(n,i){var s,l,a,h,c,d=e.isNumber(n)&&n>=0?n:this.selection&&this.selection.leftCol>-1?this.selection.leftCol:0,u=e.isNumber(i)?i:1;if(this.selectedSheet&&!this.itemsSource){for(this.columns.length>0?d>=this.columns.length&&(d=this.columns.length-1):d=0,this._clearCalcEngine(),this.finishEditing(),this.onPrepareChangingColumn(),this.undoStack.stackSize>0&&(s=new o._ColumnsChangedAction(this)),this._updateCellsForUpdatingColumn(this.columns.length,d,u),h=this._updateAffectedFormula(d,u,!0,!1),c=this._updateAffectedNamedRanges(d,u,!0,!1),s&&(s._affectedFormulas=h,s._affectedDefinedNameVals=c),this.columns.beginUpdate(),a=0;a<u;a++)(l=new t.Column).isRequired=!1,this.columns.insert(d,l);this.columns.endUpdate(),this._updateTablesForUpdatingColumn(d,u),this.selection&&-1!==this.selection.row&&-1!==this.selection.col||(this.selection=new t.CellRange(0,0)),s&&(s.saveNewState(),this._undoStack._addAction(s)),this.onColumnChanged(new r(d,u,!0))}},l.prototype.deleteColumns=function(n,i){var s,l,a,h,c,d=e.isNumber(i)&&i>=0?i:this.selection&&this.selection.leftCol>-1?this.selection.rightCol-this.selection.leftCol+1:1,u=e.isNumber(n)&&n>=0?n:this.selection&&this.selection.leftCol>-1?this.selection.leftCol:-1,_=e.isNumber(n)&&n>=0?n+d-1:this.selection&&this.selection.leftCol>-1?this.selection.rightCol:-1;if(this.selectedSheet&&!this.itemsSource&&!(u>=this.columns.length)&&(_=Math.min(_,this.columns.length-1),this._clearCalcEngine(),this.finishEditing(),u>-1&&_>-1)){for(this.onPrepareChangingColumn(),this.undoStack.stackSize>0&&(l=new o._ColumnsChangedAction(this)),this._updateCellsForUpdatingColumn(this.columns.length,u,d,!0),a=this._updateAffectedFormula(_,_-u+1,!1,!1),h=this._updateAffectedNamedRanges(_,_-u+1,!1,!1),c=this._updateTablesForUpdatingColumn(u,d,!0),l&&(l._affectedFormulas=a,l._affectedDefinedNameVals=h,l._deletedTables=c),this.columns.beginUpdate();_>=u;_--)this.columns.removeAt(_),this._sortManager.deleteSortLevel(_);this.columns.endUpdate(),this._sortManager.commitSort(!1),s=this.columns.length,this.selectedSheet.selectionRanges.clear(),0===s?(this.select(new t.CellRange),"move"===this.hostElement.style.cursor&&(this.hostElement.style.cursor="default")):_===s-1?this.select(new t.CellRange(0,_,this.rows.length-1,_)):this.select(new t.CellRange(this.selection.row,this.selection.leftCol,this.selection.row2,this.selection.leftCol)),l&&(l.saveNewState(),this._undoStack._addAction(l)),this.onColumnChanged(new r(u,d,!1))}},l.prototype.mergeRange=function(e,n){void 0===n&&(n=!1);var i,s,l,r,a=e||this.selection,h=-1;if(this.selectedSheet){if(a){if(1===a.rowSpan&&1===a.columnSpan)return;for(i=a.topRow;i<=a.bottomRow;i++)for(s=a.leftCol;s<=a.rightCol;s++)if(this.selectedSheet.findTable(i,s))return;if(e||n||(this.undoStack.stackSize>0&&(r=new o._CellMergeAction(this)),this.hostElement.focus()),!this._resetMergedRange(a)){for(i=a.topRow;i<=a.bottomRow;i++)if(h<0&&this.rows[i].visible&&(h=i),!(h<0))for(s=a.leftCol;s<=a.rightCol;s++)l=i*this.columns.length+s,this.selectedSheet._mergedRanges[l]=new t.CellRange(h,a.leftCol,a.bottomRow,a.rightCol);r&&(r.saveNewState(),this._undoStack._addAction(r))}}e||this.refresh()}},l.prototype.getMergedRange=function(e,o,n,s){void 0===s&&(s=!0);var l,r,a,h,c=o*this.columns.length+n,d=this.selectedSheet?this.selectedSheet._mergedRanges[c]:null;return e===this.cells&&d?!d.isSingleCell&&(this.frozenRows>0||this.frozenColumns>0)&&(d.topRow<this.frozenRows&&d.bottomRow>=this.frozenRows||d.leftCol<this.frozenColumns&&d.rightCol>=this.frozenColumns)?(l=d.topRow,r=d.bottomRow,a=d.leftCol,h=d.rightCol,o>=this.frozenRows&&d.topRow<this.frozenRows&&(l=this.frozenRows),o<this.frozenRows&&d.bottomRow>=this.frozenRows&&(r=this.frozenRows-1),r>=this.rows.length&&(r=this.rows.length-1),n>=this.frozenColumns&&d.leftCol<this.frozenColumns&&(a=this.frozenColumns),n<this.frozenColumns&&d.rightCol>=this.frozenColumns&&(h=this.frozenColumns-1),h>=this.columns.length&&(h=this.columns.length-1),new t.CellRange(l,a,r,h)):d.bottomRow>=this.rows.length?new t.CellRange(d.topRow,d.leftCol,this.rows.length-1,d.rightCol):d.rightCol>=this.columns.length?new t.CellRange(d.topRow,d.leftCol,d.bottomRow,this.columns.length-1):d.clone():n>=0&&this.columns&&this.columns.length>n&&o>=0&&this.rows&&this.rows.length>o?i.prototype.getMergedRange.call(this,e,o,n,s):null},l.prototype.evaluate=function(t,o,n,i){void 0===i&&(i=!0);var s=this._evaluate(t,o,n);return i&&null!=s&&!e.isPrimitive(s)?s.value:s},l.prototype.getCellValue=function(t,o,n,i){void 0===n&&(n=!1);var s,l,r=i&&i!==this.selectedSheet?i.grid.columns[o]:this.columns[o],a=this._getCellStyle(t,o,i);return s=a&&a.format?a.format:"",l=i&&i!==this.selectedSheet?i.grid.getCellData(t,o,!1):this.getCellData(t,o,!1),e.isString(l)&&"="===l[0]&&(l=this._evaluate(l,n?s:"",i,t,o)),n?(s||null==l||e.isPrimitive(l)||(a?a.format=l.format:this._applyStyleForCell(t,o,{format:l.format})),l=this._formatEvaluatedResult(l,r,s)):null==l||e.isPrimitive(l)||(l=l.value),null==l?"":l},l.prototype.showFunctionList=function(t){var o,n,i=this,s=i._cumulativeOffset(t),l=i._cumulativeOffset(i._root);i._functionTarget=e.tryCast(t,HTMLInputElement),i._functionTarget&&i._functionTarget.value&&"="===i._functionTarget.value[0]?(i._functionList._cv.filter=function(e){var t,o=e.actualvalue.toLowerCase(),n=i._getCurrentFormulaIndex(i._functionTarget.value);return-1===n&&(n=0),(t=i._functionTarget.value.substr(n+1).trim().toLowerCase()).length>0&&0===o.indexOf(t)||"="===i._functionTarget.value},i._functionList.selectedIndex=0,o=s.y+t.clientHeight+2+(e.hasClass(t,"wj-grid-editor")?this._ptScrl.y:0),n=s.x+(e.hasClass(t,"wj-grid-editor")?this._ptScrl.x:0),e.setCss(i._functionListHost,{height:i._functionList._cv.items.length>5?"218px":"auto",display:i._functionList._cv.items.length>0?"block":"none",top:"",left:""}),i._functionListHost.scrollTop=0,i._functionListHost.offsetHeight+o>l.y+i._root.offsetHeight?o=o-t.clientHeight-i._functionListHost.offsetHeight-5:o+=5,i._functionListHost.offsetWidth+n>l.x+i._root.offsetWidth&&(n=l.x+i._root.offsetWidth-i._functionListHost.offsetWidth),e.setCss(i._functionListHost,{top:o,left:n})):i.hideFunctionList()},l.prototype.hideFunctionList=function(){this._functionListHost.style.display="none"},l.prototype.selectPreviousFunction=function(){this._functionList.selectedIndex>0&&this._functionList.selectedIndex--},l.prototype.selectNextFunction=function(){this._functionList.selectedIndex<this._functionList.itemsSource.length&&this._functionList.selectedIndex++},l.prototype.applyFunctionToCell=function(){var e,t=this;t._functionTarget&&(-1===(e=t._getCurrentFormulaIndex(t._functionTarget.value))?e=t._functionTarget.value.indexOf("="):e+=1,t._functionTarget.value=t._functionTarget.value.substring(0,e)+t._functionList.selectedValue+"(","="!==t._functionTarget.value[0]&&(t._functionTarget.value="="+t._functionTarget.value),t._functionTarget.focus(),t.hideFunctionList())},l.prototype.save=function(e){var t=this._saveToWorkbook();return e&&t.save(e),t},l.prototype.saveAsync=function(e,t,o){var n=this._saveToWorkbook();return n.saveAsync(e,t,o),n},l.prototype.saveToWorkbookOM=function(){return this._saveToWorkbook()._serialize()},l.prototype.load=function(t){var o,n,i=this;if(t instanceof Blob)(n=new FileReader).onload=function(){var t=n.result;t=e.xlsx.Workbook._base64EncArr(new Uint8Array(t)),(o=new e.xlsx.Workbook).load(t),i._loadFromWorkbook(o)},n.readAsArrayBuffer(t);else if(t instanceof e.xlsx.Workbook)i._loadFromWorkbook(t);else{if(t instanceof ArrayBuffer)t=e.xlsx.Workbook._base64EncArr(new Uint8Array(t));else if(!e.isString(t))throw"Invalid workbook.";(o=new e.xlsx.Workbook).load(t),i._loadFromWorkbook(o)}},l.prototype.loadAsync=function(t,o,n){var i,s,l=this;if(t instanceof Blob)(s=new FileReader).onload=function(){var t=s.result;t=e.xlsx.Workbook._base64EncArr(new Uint8Array(t)),(i=new e.xlsx.Workbook).loadAsync(t,function(e){l._loadFromWorkbook(e),o&&o(e)},n)},s.readAsArrayBuffer(t);else if(t instanceof e.xlsx.Workbook)l._loadFromWorkbook(t),o&&o(t);else{if(t instanceof ArrayBuffer)t=e.xlsx.Workbook._base64EncArr(new Uint8Array(t));else if(!e.isString(t))throw"Invalid workbook.";(i=new e.xlsx.Workbook).loadAsync(t,function(e){l._loadFromWorkbook(e),o&&o(e)},n)}},l.prototype.loadFromWorkbookOM=function(t){var o;t instanceof e.xlsx.Workbook?o=t:(o=new e.xlsx.Workbook)._deserialize(t),this._loadFromWorkbook(o)},l.prototype.undo=function(){var e=this;setTimeout(function(){e._undoStack.undo()},100)},l.prototype.redo=function(){var e=this;setTimeout(function(){e._undoStack.redo()},100)},l.prototype.select=function(o,n){void 0===n&&(n=!0);var s,l,r;if(e.isNumber(o)&&e.isNumber(n)&&(o=new t.CellRange(o,n),n=!0),o.rowSpan!==this.rows.length&&o.columnSpan!==this.columns.length)for(l=o.topRow;l<=o.bottomRow;l++)for(r=o.leftCol;r<=o.rightCol;r++)(s=this.getMergedRange(this.cells,l,r))&&!o.equals(s)&&(o.row<=o.row2?(o.row=Math.min(o.topRow,s.topRow),o.row2=Math.max(o.bottomRow,s.bottomRow)):(o.row=Math.max(o.bottomRow,s.bottomRow),o.row2=Math.min(o.topRow,s.topRow)),o.col<=o.col2?(o.col=Math.min(o.leftCol,s.leftCol),o.col2=Math.max(o.rightCol,s.rightCol)):(o.col=Math.max(o.rightCol,s.rightCol),o.col2=Math.min(o.leftCol,s.leftCol)));this._isPasting&&this.collectionView&&(this.collectionView._pendingRefresh=!1),i.prototype.select.call(this,o,n)},l.prototype.addCustomFunction=function(t,o,n,i,s){e._deprecated("addCustomFunction","addFunction"),this._calcEngine.addCustomFunction(t,o,i,s),this._addCustomFunctionDescription(t,n)},l.prototype.addFunction=function(e,t,o,n,i){this._calcEngine.addFunction(e,t,n,i),this._addCustomFunctionDescription(e,o)},l.prototype.dispose=function(){var e=window.navigator.userAgent;this._needCopyToSheet=!1,document.removeEventListener("mousemove",this._mouseMoveHdl),document.body.removeEventListener("click",this._clickHdl),(e.match(/iPad/i)||e.match(/iPhone/i))&&(document.body.removeEventListener("touchstart",this._touchStartHdl),document.body.removeEventListener("touchend",this._touchEndHdl)),this.hideFunctionList(),i.prototype.dispose.call(this)},l.prototype.getClipString=function(o){var n,s,l,r,a="",h=!0;if(!this.selectedSheet)return i.prototype.getClipString.call(this,o);if(this._isCutting=!1,!o){if(this._isMultipleRowsSelected()){for(a="",0===(n=this.selectedSheet.selectionRanges.slice(0)).length&&(n=[this.selection]),n.sort(this._sortByRow),l=0;l<n.length;l++)a&&(a+="\n"),a+=this.getClipString(n[l]);return a}if(this._isMultipleColumnsSelected())for(a="",0===(n=this.selectedSheet.selectionRanges.slice(0)).length&&(n=[this.selection]),n.sort(this._sortByColumn),s=0,h=!0;s<this.rows.length;s++){for(h||(a+="\n"),h=!1,l=0,_=!0;l<n.length;l++)_||(a+="\t"),_=!1,a+=this.getClipString(n[l]);return a}else switch(o=this.selection,this.selectionMode){case t.SelectionMode.Row:case t.SelectionMode.RowRange:o.col=0,o.col2=this.columns.length-1;break;case t.SelectionMode.ListBox:o.col=0,o.col2=this.columns.length-1;for(var c=0;c<this.rows.length;c++)this.rows[c].isSelected&&this.rows[c].isVisible&&(o.row=o.row2=c,a&&(a+="\n"),a+=this.getClipString(o));return a}}if(!(o=e.asType(o,t.CellRange)).isValid)return"";for(var d=o.topRow;d<=o.bottomRow;d++)if(this.rows[d].isVisible){h||(a+="\n"),h=!1;for(var u=o.leftCol,_=!0;u<=o.rightCol;u++)this.columns[u].isVisible&&(_||(a+="\t"),_=!1,(r=(r=this.getCellValue(d,u,!0).toString()).replace(/\t/g," ")).indexOf("\n")>-1&&(r='"'+r.replace(/"/g,'""')+'"'),a+=r)}return a},l.prototype.setClipString=function(o,n){var s,l,r,a,h,c,d,u,_,g,f,p,w,m,C,b,y,S,v,R,x,T,k,I,E=null==n,D=!1,A=!1;if(this.selectedSheet){if(n=n?e.asType(n,t.CellRange):this.selection,(o=e.asString(o).replace(/\r\n/g,"\n").replace(/\r/g,"\n"))&&"\n"==o[o.length-1]&&(o=o.substring(0,o.length-1)),T=o,c=this._edtHdl._parseClipString(e.asString(o)),E&&!n.isSingleCell&&c.length&&this._edtHdl._expandClipRows(c,n),A=this._containsMultiLineText(c),(!this._copiedRanges||0===this._copiedRanges.length||T.trim()!==this._getRangeString(this._copiedRanges,this._copiedSheet).trim()&&!this._containsRandFormula(this._copiedRanges,this._copiedSheet)||this._cutValue)&&!A)return T!==this._cutValue&&(this._cutValue=null,i.prototype.setClipString.call(this,o)),this._copiedRanges=null,void(this._copiedSheet=null);if(s=new t.CellRange(n.topRow,n.leftCol),this.beginUpdate(),A||!this._copiedRanges||this._copiedRanges.length>1||0===this._copiedRanges.length)for(l=n.topRow,a=(v=this._copiedRanges&&this._copiedRanges.length>1?this._copiedRanges[0]:new t.CellRange).topRow,g=0;g<c.length&&l<this.rows.length;g++,l++)if(this.rows[l].isVisible){for(d=c[g],h=v.leftCol,S=(r=n.leftCol)-h,f=0;f<d.length&&r<this.columns.length;f++,r++)this.columns[r].isVisible?(u=d[f],this.columns[r].isReadOnly||this.rows[l].isReadOnly||(D=this._postSetClipStringProcess(u,l,r,a,h),s.row2=Math.max(s.row2,l),s.col2=Math.max(s.col2,r)),h>=0&&h++):f--;a>=0&&a++}else g--;else if(this._copiedRanges&&1===this._copiedRanges.length)for(R=0,(v=this._copiedRanges[0]).rowSpan>n.rowSpan?v.rowSpan:n.rowSpan,v.columnSpan>n.columnSpan?v.columnSpan:n.columnSpan,l=n.topRow,g=0;g<c.length&&l<this.rows.length;g++,l++)if(x=0,this.rows[l].isVisible){for(;this._copiedSheet.grid.rows[v.topRow+R]&&!this._copiedSheet.grid.rows[v.topRow+R].isVisible;)R++;if(R>=v.rowSpan&&(R%=v.rowSpan),!this._copiedSheet.grid.rows[v.topRow+R])break;for(y=l-v.topRow-R,d=c[g],r=n.leftCol,f=0;f<d.length&&r<this.columns.length;f++,r++)if(this.columns[r]&&this.columns[r].isVisible){if(x>=v.columnSpan&&(x%=v.columnSpan),!this._copiedSheet.grid.columns[v.leftCol+x])break;if(S=r-v.leftCol-x,!this.columns[r].isReadOnly&&!this.rows[l].isReadOnly){if(k=null!=this._copiedSheet.grid.columns[v.leftCol+x].dataMap,u=this._copiedSheet.grid.getCellData(v.topRow+R,v.leftCol+x,k),I=this._getCellStyle(v.topRow+R,v.leftCol+x,this._copiedSheet),u&&"string"==typeof u&&"="===u[0]&&(0!==y||0!==S)&&(_=u.match(/((\w+)\!)?\$?[A-Za-z]{1,2}\$?\d+/g))&&_.length>0)for(p=0;p<_.length;p++)w=_[p],(m=u.indexOf(w))>0&&('"'===u[m-1]||/[\d\w]/.test(u[m-1]))||((C=e.xlsx.Workbook.tableAddress(w)).row+=C.absRow?0:y,C.col+=C.absCol?0:S,b=e.xlsx.Workbook.xlsxAddress(C.row,C.col,C.absRow,C.absCol),u=u.replace(w,b));this._copiedSheet.grid.columns[v.leftCol+x].format&&(I?I.format||(I.format=this._copiedSheet.grid.columns[v.leftCol+x].format):I={format:this._copiedSheet.grid.columns[v.leftCol+x].format}),D=this._postSetClipStringProcess(u,l,r,v.topRow+R,v.leftCol+x,I),s.row2=Math.max(s.row2,l),s.col2=Math.max(s.col2,r)}x++}else f--;R++}else g--;this._isCutting&&(this._delCutData(),this._isCutting=!1,this._cutValue=T,this._copiedRanges=null,this._copiedSheet=null),this.endUpdate(),this.collectionView&&D&&this.collectionView.refresh(),this.select(s)}else i.prototype.setClipString.call(this,o,n)},l.prototype.getBuiltInTableStyle=function(e){var t;return null==this._builtInTableStylesCache&&(this._builtInTableStylesCache={}),null==(t=this._builtInTableStylesCache[e.toLowerCase()])&&(t=this._createBuiltInTableStyle(e),Object.freeze(t),this._builtInTableStylesCache[e.toLowerCase()]=t),t},l.prototype._getCvIndex=function(e){return e>-1&&this.collectionView?this.rows[e]instanceof h?e:i.prototype._getCvIndex.call(this,e):-1},l.prototype._init=function(){var n=this,i=this,s=window.navigator.userAgent,l=function(e){document.removeEventListener("mouseup",l),i._mouseUp(e)};i.hostElement.setAttribute("tabindex","-1"),i._divContainer=i.hostElement.querySelector('[wj-part="container"]'),i._tabHolder=new o._TabHolder(i.hostElement.querySelector('[wj-part="tab-holder"]'),i),i._contextMenu=new o._ContextMenu(i.hostElement.querySelector('[wj-part="context-menu"]'),i),i._gpCells=new a(i,t.CellType.Cell,i.rows,i.columns,i._eCt),i._gpCHdr=new a(i,t.CellType.ColumnHeader,i._hdrRows,i.columns,i._eCHdrCt),i._gpRHdr=new a(i,t.CellType.RowHeader,i.rows,i._hdrCols,i._eRHdrCt),i._gpTL=new a(i,t.CellType.TopLeft,i._hdrRows,i._hdrCols,i._eTLCt),i._sortManager=new o.SortManager(i),i._filter=new o.FlexSheetFilter(i),i._filter.filterApplied.addHandler(function(){i.selectedSheet&&(i.selectedSheet._filterDefinition=i._filter.filterDefinition,i.selectedSheet.itemsSource&&(i.selectedSheet._storeRowSettings(),i.selectedSheet._setRowSettings()))}),i._calcEngine=new o._CalcEngine(i),i._calcEngine.unknownFunction.addHandler(function(e,t){i.onUnknownFunction(t)},i),i._initFuncsList(),i._undoStack=new o.UndoStack(i),i.loadedRows.addHandler(function(){if(i.itemsSource&&!(i.rows[0]instanceof h)){for(var e,o=new h,n=0;n<i.columns.length;n++)e=i.columns[n],o._ubv||(o._ubv={}),o._ubv[e._hash]=e.header;i.rows[0]instanceof t._NewRowTemplate?i.rows.insert(1,o):i.rows.insert(0,o)}i._filter&&i._filter.apply()}),i.itemsSourceChanged.addHandler(function(){var e;for(e=0;e<i.columns.length;e++)i.columns[e].isRequired=!1;i.collectionView&&i.collectionView.currentChanged.removeHandler(n._cvCurrentChanged,n)}),i.copied.addHandler(function(e,t){var o;i.selectedSheet&&(i._copiedSheet=i.selectedSheet,i._needCopyToSheet=!0,i._isMultipleRowsSelected()?((o=i.selectedSheet.selectionRanges.slice(0)).sort(i._sortByRow),i._copiedRanges=o):i._isMultipleColumnsSelected()?((o=i.selectedSheet.selectionRanges.slice(0)).sort(i._sortByColumn),i._copiedRanges=o):i._copiedRanges=[t.range])}),i.rows.collectionChanged.addHandler(function(e,o){i._clearForEmptySheet("rows"),i.itemsSource||!i.selectedSheet||!i._needCopyToSheet||i._isCopying||i._isUndoing||o.item instanceof t._NewRowTemplate||i._copyRowsToSelectedSheet()},i),i.columns.collectionChanged.addHandler(function(e,t){i._clearForEmptySheet("columns"),i.selectedSheet&&i._needCopyToSheet&&!i._isCopying&&!i._isUndoing&&i._copyColumnsToSelectedSheet()},i),i.definedNames.collectionChanged.addHandler(function(t,o){if(o.action===e.collections.NotifyCollectionChangedAction.Add||o.action===e.collections.NotifyCollectionChangedAction.Change){var n=o.action===e.collections.NotifyCollectionChangedAction.Add?"inserted":"updated";if(!(o.item instanceof c))throw i.definedNames.remove(o.item),"Invalid defined name item object was "+n+".  The DefinedName instance should be "+n+" in the definedNames array.";if(!o.item||!o.item.name||null==o.item.value)throw i.definedNames.remove(o.item),"Invalid defined name was "+n+".";if(null!=o.item.sheetName&&!i._validateSheetName(o.item.sheetName))throw i.definedNames.remove(o.item),"The sheet name ("+o.item.sheetName+") does not exist in FlexSheet.";if(i._checkExistDefinedName(o.item.name,o.item.sheetName,o.index))throw i.definedNames.remove(o.item),"The "+o.item.name+" already existed in definedNames."}}),i.addEventListener(i.hostElement,"mousedown",function(e){document.addEventListener("mouseup",l),i._isDescendant(i._divContainer,e.target)&&i._mouseDown(e)},!0),i.addEventListener(i.hostElement,"drop",function(){i._columnHeaderClicked=!1}),i.addEventListener(i.hostElement,"contextmenu",function(o){var n,s,l,r,a,h,c,d,u;!o.defaultPrevented&&i.selectedSheet&&(i.activeEditor||(i._isContextMenuKeyDown&&i.selection.row>-1&&i.selection.col>-1&&i.rows.length>0&&i.columns.length>0?(l=i.columns[i.selection.col],s=i.rows[i.selection.row],c=i._cumulativeOffset(i.hostElement),d=i._cumulativeScrollOffset(i.hostElement),r=l.pos+i._eCt.offsetLeft+c.x+l.renderSize/2+i._ptScrl.x,a=s.pos+i._eCt.offsetTop+c.y+s.renderSize/2+i._ptScrl.y,h=new e.Point(r-d.x,a-d.y),n=i.hitTest(r,a),i._isContextMenuKeyDown=!1):n=i.hitTest(o),o.preventDefault(),n&&n.cellType!==t.CellType.None&&(u=new t.CellRange(n.row,n.col),n.cellType!==t.CellType.Cell||u.intersects(i.selection)||(i.selection=u,i.selectedSheet&&(i.selectedSheet.selectionRanges.clear(),i.selectedSheet.selectionRanges.push(u))),i._contextMenu.show(o,h))))}),i.prepareCellForEdit.addHandler(i._prepareCellForEditHandler,i),i.cellEditEnded.addHandler(function(e,t){(!t.data||46!==t.data.keyCode&&8!==t.data.keyCode)&&setTimeout(function(){i.hideFunctionList()},200)}),i.cellEditEnding.addHandler(function(e,t){(!t.data||46!==t.data.keyCode&&8!==t.data.keyCode)&&i._clearCalcEngine()}),i.pasting.addHandler(function(){i._needCopyToSheet=!1,i._isPasting=!0}),i.pasted.addHandler(function(){i.selection;i._needCopyToSheet=!0,i._isPasting=!1,i._clearCalcEngine()}),i.resizingColumn.addHandler(function(){i._resizing=!0}),i.resizingRow.addHandler(function(){i._resizing=!0}),i.resizedColumn.addHandler(function(){i._resizing=!1}),i.resizedRow.addHandler(function(){i._resizing=!1}),i.selectionChanged.addHandler(function(){var e=i.selection;i._isCopying||!e.isValid||i.containsFocus()||i.hostElement.focus(),e.rightCol>=i.columns.length&&(i.selection=new t.CellRange(e.row,Math.min(e.col,i.columns.length-1),e.row2,Math.min(i.selection.col2,i.columns.length-1))),i._enableMulSel||i._isCopying||!i.selectedSheet||i.selectedSheet.selectionRanges.clear()}),i.addEventListener(i.hostElement,"keydown",function(o){var n,s,l;if(o.ctrlKey&&(89===o.keyCode&&(i.finishEditing(),i.redo(),o.preventDefault()),90===o.keyCode&&(i.finishEditing(),i.undo(),o.preventDefault()),i.selectedSheet&&65===o.keyCode&&(i.selectedSheet.selectionRanges.clear(),i.selectedSheet.selectionRanges.push(i.selection)),67!==o.keyCode&&45!=o.keyCode||(i.activeEditor&&(i._copiedRanges=null,i._copiedSheet=null),i._cutValue=null),88===o.keyCode&&(i.activeEditor||(i.finishEditing(),n=new t.CellRangeEventArgs(i.cells,i.selection),i.onCopying(n)&&(i._cutValue=null,s=i.getClipString(),i._isCutting=!0,e.Clipboard.copy(s),i.onCopied(n)),o.stopPropagation())),o.keyCode===e.Key.Space&&i.selection.isValid&&i.selectionMode===t.SelectionMode.CellRange&&i.select(new t.CellRange(0,i.selection.col,i.rows.length-1,i.selection.col))),o.keyCode===e.Key.Escape&&i._contextMenu.hide(),(93===o.keyCode||o.shiftKey&&121===o.keyCode)&&(i._isContextMenuKeyDown=!0),i.selectedSheet&&!i._edtHdl.activeEditor)switch(o.keyCode){case e.Key.Left:case e.Key.Right:case e.Key.Up:case e.Key.Down:case e.Key.PageUp:case e.Key.PageDown:case e.Key.Home:case e.Key.End:case e.Key.Tab:case e.Key.Enter:i.scrollIntoView(i.selection.row,i.selection.col),(l=i.selectedSheet.selectionRanges.length)>0&&i.selectedSheet.selectionRanges.splice(l-1,1,i.selection)}}),i.addEventListener(document.body,"keydown",function(t){!i._isDescendant(i.hostElement,t.target)&&i.hostElement!==t.target||i._edtHdl.activeEditor||!i.selectedSheet||t.keyCode!==e.Key.Delete&&t.keyCode!==e.Key.Back||(i._delSeletionContent(t),t.preventDefault()),i._contextMenu.visible&&(t.keyCode===e.Key.Down&&i._contextMenu.moveToNext(),t.keyCode===e.Key.Up&&i._contextMenu.moveToPrev(),t.keyCode===e.Key.Home&&i._contextMenu.moveToFirst(),t.keyCode===e.Key.End&&i._contextMenu.moveToLast(),t.keyCode===e.Key.Enter&&i._contextMenu.handleContextMenu(),t.preventDefault())},!0),document.body.addEventListener("click",i._clickHdl),document.addEventListener("mousemove",i._mouseMoveHdl),(s.match(/iPad/i)||s.match(/iPhone/i))&&(document.body.addEventListener("touchstart",i._touchStartHdl),document.body.addEventListener("touchend",i._touchEndHdl)),i.addEventListener(i.hostElement,"drop",function(){i._htDown=null})},l.prototype._initFuncsList=function(){var t=this;t._functionListHost=document.createElement("div"),e.addClass(t._functionListHost,"wj-flexsheet-formula-list"),document.querySelector("body").appendChild(t._functionListHost),t._functionListHost.style.display="none",t._functionListHost.style.position="absolute",t._functionList=new e.input.ListBox(t._functionListHost),t._functionList.isContentHtml=!0,t._functionList.itemsSource=t._getFunctions(),t._functionList.displayMemberPath="displayValue",t._functionList.selectedValuePath="actualvalue",t.addEventListener(t._functionListHost,"click",t.applyFunctionToCell.bind(t)),t.addEventListener(t._functionListHost,"keydown",function(o){o.keyCode===e.Key.Escape&&(t.hideFunctionList(),t.hostElement.focus(),o.preventDefault()),o.keyCode===e.Key.Enter&&(t.applyFunctionToCell(),t.hostElement.focus(),o.preventDefault(),o.stopPropagation())})},l.prototype._getFunctions=function(){for(var e,t=[],o=0;o<n.length;o++)e=n[o],t.push({displayValue:'<div class="wj-flexsheet-formula-name">'+e.name+'</div><div class="wj-flexsheet-formula-description">'+e.description+"</div>",actualvalue:e.name});return t},l.prototype._addCustomFunctionDescription=function(e,t){for(var o={displayValue:'<div class="wj-flexsheet-formula-name">'+e+"</div>"+(t?'<div class="wj-flexsheet-formula-description">'+t+"</div>":""),actualvalue:e},n=this._functionList.itemsSource,i=-1,s=0;s<n.length;s++)if(n[s].actualvalue===e){i=s;break}i>-1?n.splice(i,1,o):n.push(o)},l.prototype._getCurrentFormulaIndex=function(e){var t=-1;return["+","-","*","/","^","(","&"].forEach(function(o){var n=e.lastIndexOf(o);n>t&&(t=n)}),t},l.prototype._prepareCellForEditHandler=function(){var t=this,o=t._edtHdl._edt;o&&(t.addEventListener(o,"keydown",function(o){if(t.isFunctionListOpen)switch(o.keyCode){case e.Key.Up:t.selectPreviousFunction(),o.preventDefault(),o.stopPropagation();break;case e.Key.Down:t.selectNextFunction(),o.preventDefault(),o.stopPropagation();break;case e.Key.Tab:case e.Key.Enter:t.applyFunctionToCell(),o.preventDefault(),o.stopPropagation();break;case e.Key.Escape:t.hideFunctionList(),o.preventDefault(),o.stopPropagation()}}),t.addEventListener(o,"keyup",function(n){(n.keyCode>40||n.keyCode<32)&&n.keyCode!==e.Key.Tab&&n.keyCode!==e.Key.Escape&&setTimeout(function(){t.showFunctionList(o)},0)}))},l.prototype._addSheet=function(e,t,n,i,s){var l=this,r=new o.Sheet(l,s,e,t,n);return l.sheets.isValidSheetName(r)||r._setValidName(l.sheets.getValidSheetName(r)),r.nameChanged.addHandler(function(e,t){l._updateDefinedNameWithSheetRefUpdating(t.oldValue,t.newValue)}),"number"==typeof i?(i<0&&(i=0),i>=l.sheets.length&&(i=l.sheets.length)):i=l.sheets.length,l.sheets.insert(i,r),r},l.prototype._showSheet=function(e){!this.sheets||!this.sheets.length||e>=this.sheets.length||e<0||e===this.selectedSheetIndex||this.sheets[e]&&!this.sheets[e].visible||(this.finishEditing(),this._clearCalcEngine(),this._isCopying=!0,this.selectedSheetIndex>-1&&this.selectedSheetIndex<this.sheets.length&&(this._copyTo(this.sheets[this.selectedSheetIndex]),this._resetFilterDefinition()),this.sheets[e]&&(this._selectedSheetIndex=e,this._copyFrom(this.sheets[e])),this._isCopying=!1,this._filter.closeEditor())},l.prototype._selectedSheetChange=function(e,t){this._showSheet(t.newValue),this.invalidate(!0),this.onSelectedSheetChanged(t)},l.prototype._sourceChange=function(t,o){if(o.action===e.collections.NotifyCollectionChangedAction.Add||o.action===e.collections.NotifyCollectionChangedAction.Change)o.item._attachOwner(this),o.action===e.collections.NotifyCollectionChangedAction.Add?(this._addingSheet=!0,o.index<=this.selectedSheetIndex&&(this._selectedSheetIndex+=1)):o.index===this.selectedSheetIndex&&this._copyFrom(o.item,!0),this.selectedSheetIndex=o.index;else if(o.action===e.collections.NotifyCollectionChangedAction.Reset){for(var n=0;n<this.sheets.length;n++)this.sheets[n]._attachOwner(this);this.sheets.length>0?(0===this.selectedSheetIndex&&this._copyFrom(this.selectedSheet,!0),this.selectedSheetIndex=0):(this.rows.clear(),this.columns.clear(),this._selectedSheetIndex=-1)}else this.sheets.length>0?this.selectedSheetIndex>=this.sheets.length?this.selectedSheetIndex=0:this.selectedSheetIndex>o.index&&(this._selectedSheetIndex-=1):(this.rows.clear(),this.columns.clear(),this._selectedSheetIndex=-1);this.invalidate(!0)},l.prototype._sheetVisibleChange=function(e,t){t.item.visible||t.index===this.selectedSheetIndex&&(this.selectedSheetIndex===this.sheets.length-1?this.selectedSheetIndex=t.index-1:this.selectedSheetIndex=t.index+1)},l.prototype._applyStyleForCell=function(e,t,o){var n,i,s,l=this,r=l.rows[e];null==r||r instanceof h||!r.isVisible||(s=e*l.columns.length+t,(i=l.selectedSheet._mergedRanges[s])&&(s=i.topRow*l.columns.length+i.leftCol),(n=l.selectedSheet._styledCells[s])?(n.className="normal"===o.className?"":o.className||n.className,n.textAlign=o.textAlign||n.textAlign,n.verticalAlign=o.verticalAlign||n.verticalAlign,n.fontFamily=o.fontFamily||n.fontFamily,n.fontSize=o.fontSize||n.fontSize,n.backgroundColor=o.backgroundColor||n.backgroundColor,n.color=o.color||n.color,n.fontStyle="none"===o.fontStyle?"":o.fontStyle||n.fontStyle,n.fontWeight="none"===o.fontWeight?"":o.fontWeight||n.fontWeight,n.textDecoration="none"===o.textDecoration?"":o.textDecoration||n.textDecoration,n.format=o.format||n.format,n.whiteSpace=o.whiteSpace||n.whiteSpace):l.selectedSheet._styledCells[s]={className:o.className,textAlign:o.textAlign,verticalAlign:o.verticalAlign,fontStyle:o.fontStyle,fontWeight:o.fontWeight,fontFamily:o.fontFamily,fontSize:o.fontSize,textDecoration:o.textDecoration,backgroundColor:o.backgroundColor,color:o.color,format:o.format,whiteSpace:o.whiteSpace})},l.prototype._checkCellFormat=function(e,t,o){var n,i,s=e*this.columns.length+t;this.selectedSheet&&((n=this.selectedSheet._mergedRanges[s])&&(o.isMergedCell=!0,s=n.topRow*this.columns.length+n.leftCol),(i=this.selectedSheet._styledCells[s])&&(o.isBold=o.isBold||"bold"===i.fontWeight,o.isItalic=o.isItalic||"italic"===i.fontStyle,o.isUnderline=o.isUnderline||"underline"===i.textDecoration),e===this.selection.row&&t===this.selection.col&&(i&&i.textAlign?o.textAlign=i.textAlign:t>-1&&(o.textAlign=this.columns[t].getAlignment()||o.textAlign)))},l.prototype._resetMergedRange=function(e){var t,o,n,i,s,l,r,a=!1;for(t=e.topRow;t<=e.bottomRow;t++)for(o=e.leftCol;o<=e.rightCol;o++)if(n=t*this.columns.length+o,r=this.selectedSheet._mergedRanges[n])for(a=!0,i=r.topRow;i<=r.bottomRow;i++)for(s=r.leftCol;s<=r.rightCol;s++)l=i*this.columns.length+s,delete this.selectedSheet._mergedRanges[l];return a},l.prototype._updateCellsForUpdatingRow=function(e,t,o,n){var i,s,l,r,a,h=this,c={},d=e*this.columns.length;if(n)for(s=i=t*this.columns.length;s<d;s++)l=s-o*this.columns.length,(r=this.selectedSheet._styledCells[s])&&(s>=(t+o)*this.columns.length&&(this.selectedSheet._styledCells[l]=r),delete this.selectedSheet._styledCells[s]),(a=this.selectedSheet._mergedRanges[s])&&(t<=a.topRow&&t+o>a.bottomRow?delete this.selectedSheet._mergedRanges[s]:a.bottomRow<t||a.topRow>=t+o?(a.topRow>t&&(a.row-=o),a.row2-=o,this.selectedSheet._mergedRanges[l]=a,delete this.selectedSheet._mergedRanges[s]):this._updateCellMergeRangeForRow(a,t,o,c,!0));else for(i=t*this.columns.length-1,s=d-1;s>i;s--)l=s+this.columns.length*o,(r=this.selectedSheet._styledCells[s])&&(this.selectedSheet._styledCells[l]=r,delete this.selectedSheet._styledCells[s]),(a=this.selectedSheet._mergedRanges[s])&&(a.topRow<t&&a.bottomRow>=t?this._updateCellMergeRangeForRow(a,t,o,c):(a.row+=o,a.row2+=o,this.selectedSheet._mergedRanges[l]=a,delete this.selectedSheet._mergedRanges[s]));Object.keys(c).forEach(function(e){h.selectedSheet._mergedRanges[e]=c[e]})},l.prototype._updateCellMergeRangeForRow=function(e,t,o,n,i){var s,l,r,a,h,c,d;if(i)for(s=e.topRow;s<=e.bottomRow;s++)for(l=e.leftCol;l<=e.rightCol;l++)a=(r=s*this.columns.length+l)-o*this.columns.length,(c=this.selectedSheet._mergedRanges[r])&&((d=c.clone()).row>t&&(d.row-=d.row-t),d.row2<t+o-1?d.row2-=d.row2-t+1:d.row2-=o,s<t?n[r]=d:(s>=t+o&&(n[a]=d),delete this.selectedSheet._mergedRanges[r]));else for(s=e.bottomRow;s>=e.topRow;s--)for(l=e.rightCol;l>=e.leftCol;l--)if(r=s*this.columns.length+l,c=this.selectedSheet._mergedRanges[r]){for((d=c.clone()).row2+=o,s<t&&(n[r]=d.clone()),h=1;h<=o;h++)n[a=r+this.columns.length*h]=d;delete this.selectedSheet._mergedRanges[r]}},l.prototype._updateCellsForUpdatingColumn=function(e,t,o,n){var i,s,l,r,a,h=this,c={},d=this.rows.length*e;if(n)for(i=t;i<d;i++)s=i-o*(Math.floor(i/e)+((r=i%e)>=t?1:0)),(l=this.selectedSheet._styledCells[i])&&((r<t||r>=t+o)&&(this.selectedSheet._styledCells[s]=l),delete this.selectedSheet._styledCells[i]),(a=this.selectedSheet._mergedRanges[i])&&(t<=a.leftCol&&t+o>a.rightCol?delete this.selectedSheet._mergedRanges[i]:a.rightCol<t||a.leftCol>=t+o?(a.leftCol>=t&&(a.col-=o,a.col2-=o),this.selectedSheet._mergedRanges[s]=a,delete this.selectedSheet._mergedRanges[i]):this._updateCellMergeRangeForColumn(a,t,o,e,c,!0));else for(i=d-1;i>=t;i--)s=i+Math.floor(i/e)*o+((r=i%e)>=t?1:0),(l=this.selectedSheet._styledCells[i])&&(this.selectedSheet._styledCells[s]=l,delete this.selectedSheet._styledCells[i]),(a=this.selectedSheet._mergedRanges[i])&&(a.leftCol<t&&a.rightCol>=t?this._updateCellMergeRangeForColumn(a,t,o,e,c):(a.leftCol>=t&&(a.col+=o,a.col2+=o),this.selectedSheet._mergedRanges[s]=a,delete this.selectedSheet._mergedRanges[i]));Object.keys(c).forEach(function(e){h.selectedSheet._mergedRanges[e]=c[e]})},l.prototype._updateCellMergeRangeForColumn=function(e,t,o,n,i,s){var l,r,a,h,c,d,u;if(s)for(l=e.topRow;l<=e.bottomRow;l++)for(r=e.leftCol;r<=e.rightCol;r++)h=(a=l*n+r)-o*(l+(r>=t?1:0)),(d=this.selectedSheet._mergedRanges[a])&&((u=d.clone()).col>t&&(u.col-=u.col-t),u.col2<t+o-1?u.col2-=u.col2-t+1:u.col2-=o,(r<t||r>=t+o)&&(i[h]=u),delete this.selectedSheet._mergedRanges[a]);else for(l=e.bottomRow;l>=e.topRow;l--)for(r=e.rightCol;r>=e.leftCol;r--)if(a=l*n+r,h=a+l*o+(r>=t?1:0),d=this.selectedSheet._mergedRanges[a]){if(u=d.clone(),u.col2+=o,r===t&&(i[h-1]=u.clone()),r>=t)for(c=0;c<o;c++)i[h+c]=u;else i[h]=u;delete this.selectedSheet._mergedRanges[a]}},l.prototype._cloneObject=function(t){var o;if(null==t||!e.isObject(t))return t;o={};for(var n in t)t.hasOwnProperty(n)&&t[n]&&(t[n].clone?o[n]=t[n].clone():o[n]=this._cloneObject(t[n]));return o},l.prototype._evaluate=function(e,t,o,n,i){return e&&e.length>1?(e="="===e[0]?e:"="+e,this._calcEngine.evaluate(e,t,o,n,i)):e},l.prototype._copyTo=function(o){var n,i,s,l=this,r=o.grid.autoGenerateColumns;if(o._storeRowSettings(),o.grid.selection=new t.CellRange,o.grid.rows.clear(),o.grid.columns.clear(),o.grid.columnHeaders.columns.clear(),o.grid.rowHeaders.rows.clear(),l.itemsSource){if(o.grid.autoGenerateColumns=!1,o.itemsSource=l.itemsSource,o.grid.collectionView.beginUpdate(),!(o.grid.itemsSource instanceof e.collections.CollectionView))for(o.grid.collectionView.sortDescriptions.clear(),s=0;s<l.collectionView.sortDescriptions.length;s++)o.grid.collectionView.sortDescriptions.push(l.collectionView.sortDescriptions[s])}else for(o.itemsSource=null,i=0;i<l.rows.length;i++)o.grid.rows.push(l.rows[i]);for(o._filterDefinition=l._filter.filterDefinition,n=0;n<l.columns.length;n++)o.grid.columns.push(l.columns[n]);o.grid.collectionView&&(l._resetMappedColumns(o.grid),o.grid.collectionView.endUpdate()),o.grid.loadedRows.addHandler(function(){o._setRowSettings()}),o.grid.autoGenerateColumns=r,o.grid.frozenRows=l.frozenRows,o.grid.frozenColumns=l.frozenColumns,o.grid.allowAddNew=l.allowAddNew,null!=l.newRowAtTop&&(o.grid.newRowAtTop=l.newRowAtTop),o.grid.selection=l.selection,o._scrollPosition=l.scrollPosition,setTimeout(function(){l._setFlexSheetToDirty(),l.refresh(!0)},10)},l.prototype._copyFrom=function(o,n){void 0===n&&(n=!0);var i,s,l,r,a,h,c=this,d=c.autoGenerateColumns;if(c._isCopying=!0,c._dragable=!1,c.itemsSource=null,c.rows.clear(),c.columns.clear(),c.columnHeaders.columns.clear(),c.rowHeaders.rows.clear(),c.selection=new t.CellRange,o.selectionRanges.length>1&&c.selectionMode===t.SelectionMode.CellRange&&(c._enableMulSel=!0),o.itemsSource){if(c.autoGenerateColumns=!1,c.itemsSource=o.itemsSource,c.collectionView.beginUpdate(),!(c.itemsSource instanceof e.collections.CollectionView))for(c.collectionView.sortDescriptions.clear(),l=0;l<o.grid.collectionView.sortDescriptions.length;l++)c.collectionView.sortDescriptions.push(o.grid.collectionView.sortDescriptions[l])}else for(s=0;s<o.grid.rows.length;s++)c.rows.push(o.grid.rows[s]);for(i=0;i<o.grid.columns.length;i++)(a=o.grid.columns[i]).isRequired=!1,c.columns.push(a);for(c.collectionView&&(c._resetMappedColumns(c),c.collectionView.endUpdate(),c.collectionView.collectionChanged.addHandler(function(t,o){o.action===e.collections.NotifyCollectionChangedAction.Reset&&setTimeout(function(){c.invalidate()},10)},c)),c.rows.length&&c.columns.length&&(c.selection=o.grid.selection),o._filterDefinition&&(c._filter.filterDefinition=o._filterDefinition),s=0;s<c.rows.length;s++)(r=o._rowSettings[s])&&((h=c.rows[s]).height=r.height,h.allowMerging=r.allowMerging,h.visible=r.visible,h instanceof t.GroupRow&&(h.isCollapsed=r.isCollapsed));c.autoGenerateColumns=d,c.frozenRows=o.grid.frozenRows,c.frozenColumns=o.grid.frozenColumns,c._isCopying=!1,c._addingSheet?(c._toRefresh&&(clearTimeout(c._toRefresh),c._toRefresh=null),c._toRefresh=setTimeout(function(){c._setFlexSheetToDirty(),c.invalidate()},10),c._addingSheet=!1):n&&c.refresh(),c.scrollPosition=o._scrollPosition},l.prototype._resetMappedColumns=function(e){var t,o,n=0;if(e._mappedColumns=null,e.collectionView)for(o=e.collectionView.sortDescriptions;n<o.length;n++)(t=e.columns.getColumn(o[n].property))&&t.dataMap&&(e._mappedColumns||(e._mappedColumns={}),e._mappedColumns[t.binding]=t.dataMap)},l.prototype._resetFilterDefinition=function(){this._resettingFilter=!0,this._filter.filterDefinition=JSON.stringify({defaultFilterType:e.grid.filter.FilterType.Both,filters:[]}),this._resettingFilter=!1},l.prototype._loadFromWorkbook=function(t){var o,n,i,s=0,l=this;if(null!=t.sheets&&0!==t.sheets.length){if(l.beginUpdate(),l.clear(),l._reservedContent=t.reservedContent,o=t.sheets.length,t.colorThemes&&t.colorThemes.length>0)for(i=0;i<this._colorThemes.length;i++)this._colorThemes[i]=t.colorThemes[i];for(;s<o;s++)if(s>0&&l.addUnboundSheet(),l.selectedSheet.grid.wj_sheetInfo={},e.grid.xlsx.FlexGridXlsxConverter.load(l.selectedSheet.grid,t,{sheetIndex:s,includeColumnHeaders:!1}),l.selectedSheet.name=l.selectedSheet.grid.wj_sheetInfo.name,l.selectedSheet.visible=l.selectedSheet.grid.wj_sheetInfo.visible,l.selectedSheet._styledCells=l.selectedSheet.grid.wj_sheetInfo.styledCells,l.selectedSheet._mergedRanges=l.selectedSheet.grid.wj_sheetInfo.mergedRanges,l._copyFrom(l.selectedSheet,!1),null!=l.selectedSheet.grid.wj_sheetInfo.tables&&l.selectedSheet.grid.wj_sheetInfo.tables.length>0)for(i=0;i<l.selectedSheet.grid.wj_sheetInfo.tables.length;i++)this._parseFromWorkbookTable(l.selectedSheet.grid.wj_sheetInfo.tables[i],l.selectedSheet);if(null!=t.activeWorksheet&&t.activeWorksheet>-1&&t.activeWorksheet<l.sheets.length?l.selectedSheetIndex=t.activeWorksheet:l.selectedSheetIndex=0,t.definedNames&&t.definedNames.length>0)for(i=0;i<t.definedNames.length;i++)n=t.definedNames[i],l.definedNames.push(new c(l,n.name,n.value,n.sheetName));l.endUpdate(),l.onLoaded()}},l.prototype._saveToWorkbook=function(){var t,o,n,i,s,l;if(0===this.sheets.length)throw"The flexsheet is empty.";if(i=this.sheets[0],0===this.selectedSheetIndex&&i._storeRowSettings(),i._setRowSettings(),i.tables.length>0)for(i.grid.wj_sheetInfo.tables=[],l=0;l<i.tables.length;l++)i.grid.wj_sheetInfo.tables.push(this._parseToWorkbookTable(i.tables[l]));for((t=e.grid.xlsx.FlexGridXlsxConverter.save(i.grid,{sheetName:i.name,sheetVisible:i.visible,includeColumnHeaders:!1})).reservedContent=this._reservedContent,s=1;s<this.sheets.length;s++){if(i=this.sheets[s],this.selectedSheetIndex===s&&i._storeRowSettings(),i._setRowSettings(),i.tables.length>0)for(i.grid.wj_sheetInfo.tables=[],l=0;l<i.tables.length;l++)i.grid.wj_sheetInfo.tables.push(this._parseToWorkbookTable(i.tables[l]));o=e.grid.xlsx.FlexGridXlsxConverter.save(i.grid,{sheetName:i.name,sheetVisible:i.visible,includeColumnHeaders:!1}),t._addWorkSheet(o.sheets[0],s)}for(t.activeWorksheet=this.selectedSheetIndex,l=0;l<this.definedNames.length;l++){var r=this.definedNames[l];(n=new e.xlsx.DefinedName).name=r.name,n.value=r.value,n.sheetName=r.sheetName,t.definedNames.push(n)}if(this._colorThemes&&this._colorThemes.length>0)for(l=0;l<this._colorThemes.length;l++)t.colorThemes[l]=this._colorThemes[l];return t},l.prototype._mouseDown=function(o){var n,i,l,r=window.navigator.userAgent,a=this.hitTest(o);this.columns;if(this.selectedSheet&&(this.selectedSheet._scrollPosition=this.scrollPosition),this._wholeColumnsSelected=!1,this._dragable)return this._isDragging=!0,this._draggingMarker=document.createElement("div"),e.setCss(this._draggingMarker,{position:"absolute",display:"none",borderStyle:"dotted",cursor:"move"}),document.body.appendChild(this._draggingMarker),this._draggingTooltip=new e.Tooltip,this._draggingCells=this.selection,this.selectedSheet&&this.selectedSheet.selectionRanges.clear(),this.onDraggingRowColumn(new s(this._draggingRow,o.shiftKey)),void o.preventDefault();if(a.cellType!==t.CellType.None&&(this._isClicking=!0),this.selectionMode===t.SelectionMode.CellRange?o.ctrlKey?this._enableMulSel||(this._enableMulSel=!0):a.cellType!==t.CellType.None&&(this.selectedSheet&&this.selectedSheet.selectionRanges.clear(),this._enableMulSel&&this.refresh(!1),this._enableMulSel=!1):(this._enableMulSel=!1,this.selectedSheet&&this.selectedSheet.selectionRanges.clear()),this._htDown=a,0!==this.rows.length&&0!==this.columns.length&&(r.match(/iPad/i)||r.match(/iPhone/i)||this._contextMenu.hide(),this.selectionMode===t.SelectionMode.CellRange)){if(a.cellType===t.CellType.RowHeader&&3===o.which)return l=new t.CellRange(a.row,0,a.row,this.columns.length-1),void(this.selection.contains(l)||(this.selection=l));if((a.cellType===t.CellType.ColumnHeader||a.cellType===t.CellType.None)&&!(a.col>-1&&this.columns[a.col].isSelected)&&e.hasClass(o.target,"wj-cell")&&!a.edgeRight){if(this._columnHeaderClicked=!0,this._wholeColumnsSelected=!0,i=this.itemsSource&&this.rows[0]&&!this.rows[0].isVisible?1:0,o.shiftKey)this._multiSelectColumns(a);else{if(n=new t.CellRange(i,a.col,this.rows.length-1,a.col),3===o.which&&this.selection.contains(n))return;this.select(n)}this._eCt.children[i]&&this._eCt.children[i].children[a.col]&&this._eCt.children[i].children[a.col].focus()}}},l.prototype._mouseMove=function(e){var o,n=this.hitTest(e),i=this.selection,s=this.rows.length,l=this.columns.length,r=this.hostElement.style.cursor;return 0===this.rows.length||0===this.columns.length?(this._dragable=!1,void(n.cellType===t.CellType.Cell&&(this.hostElement.style.cursor="default"))):this._isDragging?(this.hostElement.style.cursor="move",void this._showDraggingMarker(e)):(o=this.itemsSource?0===i.topRow||1===i.topRow:0===i.topRow,i&&n.cellType!==t.CellType.None&&!this.itemsSource&&(this._draggingColumn=o&&i.bottomRow===s-1,this._draggingRow=0===i.leftCol&&i.rightCol===l-1,n.cellType===t.CellType.Cell?(this._draggingColumn&&((n.col===i.leftCol-1||n.col===i.rightCol)&&n.edgeRight||n.row===s-1&&n.edgeBottom)&&(r="move"),this._draggingRow&&!this._containsGroupRows(i)&&((n.row===i.topRow-1||n.row===i.bottomRow)&&n.edgeBottom||n.col===l-1&&n.edgeRight)&&(r="move")):n.cellType===t.CellType.ColumnHeader?n.edgeBottom&&(this._draggingColumn&&n.col>=i.leftCol&&n.col<=i.rightCol?r="move":this._draggingRow&&0===i.topRow&&(r="move")):n.cellType===t.CellType.RowHeader&&n.edgeRight&&(this._draggingColumn&&0===i.leftCol?r="move":this._draggingRow&&n.row>=i.topRow&&n.row<=i.bottomRow&&!this._containsGroupRows(i)&&(r="move")),this._dragable="move"===r,this.hostElement.style.cursor=r),void(this._htDown&&this._htDown.panel&&(n=new t.HitTestInfo(this._htDown.panel,e),this._multiSelectColumns(n),n.cellType===t.CellType.Cell&&this.scrollIntoView(n.row,n.col))))},l.prototype._mouseUp=function(e){try{this._isDragging&&(this._draggingCells.equals(this._dropRange)||(this._handleDropping(e),this.onDroppingRowColumn()))}finally{this._isDragging&&(this._draggingCells=null,this._dropRange=null,document.body.removeChild(this._draggingMarker),this._draggingMarker=null,this._draggingTooltip.hide(),this._draggingTooltip=null,this._isDragging=!1,this._draggingColumn=!1,this._draggingRow=!1),this._htDown&&this._htDown.cellType!==t.CellType.None&&this.selectedSheet&&(this._htDown.cellType===t.CellType.TopLeft&&this.selectionMode===t.SelectionMode.CellRange?(this.selection=new t.CellRange(0,0,this.rows.length-1,this.columns.length-1),this.selectedSheet.selectionRanges.push(this.selection)):this.selection.isValid&&this.selectedSheet.selectionRanges.push(this.selection),this._enableMulSel=!1),this._isClicking=!1,this._columnHeaderClicked=!1,this._htDown=null}},l.prototype._click=function(){var e=this,t=window.navigator.userAgent;t.match(/iPad/i)||t.match(/iPhone/i)||e._contextMenu.hide(),setTimeout(function(){e.hideFunctionList()},200)},l.prototype._touchStart=function(o){var n=this;e.hasClass(o.target,"wj-context-menu-item")||n._contextMenu.hide(),n._longClickTimer=setTimeout(function(){var i;!(i=n.hitTest(o))||i.cellType===t.CellType.None||n.itemsSource||n._resizing||n._contextMenu.show(null,new e.Point(o.pageX+10,o.pageY+10))},500)},l.prototype._touchEnd=function(){clearTimeout(this._longClickTimer)},l.prototype._showDraggingMarker=function(o){var n,i,s,r,a,h,c,d,u,_=new t.HitTestInfo(this.cells,o),g=this.selection,f=this.columns.length,p=this.rows.length,w=this._cumulativeScrollOffset(this.hostElement),m=this._root.getBoundingClientRect(),C=m.left+w.x,b=m.top+w.y;if(this.scrollIntoView(_.row,_.col),this._draggingColumn){for(i=g.rightCol-g.leftCol+1,a=0,((s=_.col)<0||s+i>f)&&(s=f-i),n=this.cells.getCellBoundingRect(0,s),h=this._root.offsetHeight-this._eCHdr.offsetHeight,r=(r=this.cells.height)>h?h:r,c=0;c<i;c++)a+=this.columns[s+c].renderSize;d=l.convertNumberToAlpha(s)+" : "+l.convertNumberToAlpha(s+i-1),this._dropRange?(this._dropRange.col=s,this._dropRange.col2=s+i-1):this._dropRange=new t.CellRange(0,s,this.rows.length-1,s+i-1)}else if(this._draggingRow){for(i=g.bottomRow-g.topRow+1,r=0,((s=_.row)<0||s+i>p)&&(s=p-i),n=this.cells.getCellBoundingRect(s,0),h=this._root.offsetWidth-this._eRHdr.offsetWidth,c=0;c<i;c++)r+=this.rows[s+c].renderSize;a=(a=this.cells.width)>h?h:a,d=s+1+" : "+(s+i),this._dropRange?(this._dropRange.row=s,this._dropRange.row2=s+i-1):this._dropRange=new t.CellRange(s,0,s+i-1,this.columns.length-1)}if(n){if(u={display:"inline",zIndex:"9999",opacity:.5,top:n.top-(this._draggingColumn?this._ptScrl.y:0)+w.y,left:n.left-(this._draggingRow?this._ptScrl.x:0)+w.x,height:r,width:a},n.top=n.top-(this._draggingColumn?this._ptScrl.y:0),n.left=n.left-(this._draggingRow?this._ptScrl.x:0),this.rightToLeft&&this._draggingRow&&(u.left=u.left-a+n.width+2*this._ptScrl.x,n.left=n.left+2*this._ptScrl.x),this._draggingRow){if(C+this._eRHdr.offsetWidth!==u.left||b+this._root.offsetHeight+1<u.top+u.height)return}else if(b+this._eCHdr.offsetHeight!==u.top||C+this._root.offsetWidth+1<u.left+u.width)return;e.setCss(this._draggingMarker,u),this._draggingTooltip.show(this.hostElement,d,n)}},l.prototype._handleDropping=function(t){var n,i,s,l,r,a,h,c=this;if(c.selectedSheet&&c._draggingCells&&c._dropRange&&!c._containsMergedCells(c._draggingCells)&&!c._containsMergedCells(c._dropRange)){if(c._clearCalcEngine(),c._draggingColumn&&c._draggingCells.leftCol>c._dropRange.leftCol||c._draggingRow&&c._draggingCells.topRow>c._dropRange.topRow)if(t.shiftKey){if(!c._allowExchangeCells(c._draggingRow,!0))return void console.warn("Can not complete operation: You are attempting to change a position of table row or column in a way that is not allowed.");if(c._draggingColumn){for(l=c._dropRange.leftCol,i=c._draggingCells.leftCol;i<=c._draggingCells.rightCol;i++)c.columns.moveElement(i,l),l++;c._exchangeTableColumns(!0)}else if(c._draggingRow)for(s=c._dropRange.topRow,n=c._draggingCells.topRow;n<=c._draggingCells.bottomRow;n++)c.rows.moveElement(n,s),s++;c._exchangeCellStyle(!0)}else{for(this.undoStack.stackSize>0&&(r=new o._MoveCellsAction(c,c._draggingCells,c._dropRange,t.ctrlKey)),s=c._dropRange.topRow,n=c._draggingCells.topRow;n<=c._draggingCells.bottomRow;n++){for(l=c._dropRange.leftCol,i=c._draggingCells.leftCol;i<=c._draggingCells.rightCol;i++)c._moveCellContent(n,i,s,l,t.ctrlKey),c._draggingColumn&&s===c._dropRange.topRow&&(c.columns[l].dataType=c.columns[i].dataType?c.columns[i].dataType:e.DataType.Object,c.columns[l].align=c.columns[i].align,c.columns[l].format=c.columns[i].format,t.ctrlKey||(c.columns[i].dataType=e.DataType.Object,c.columns[i].align=null,c.columns[i].format=null)),l++;s++}if(c._draggingColumn&&!t.ctrlKey)for(l=c._dropRange.leftCol,i=c._draggingCells.leftCol;i<=c._draggingCells.rightCol;i++)c._updateColumnFiler(i,l),l++}else if(c._draggingColumn&&c._draggingCells.leftCol<c._dropRange.leftCol||c._draggingRow&&c._draggingCells.topRow<c._dropRange.topRow)if(t.shiftKey){if(!c._allowExchangeCells(c._draggingRow,!1))return void console.warn("Can not complete operation: You are attempting to change a position of table row or column in a way that is not allowed.");if(c._draggingColumn){for(l=c._dropRange.rightCol,i=c._draggingCells.rightCol;i>=c._draggingCells.leftCol;i--)c.columns.moveElement(i,l),l--;c._exchangeTableColumns(!1)}else if(c._draggingRow)for(s=c._dropRange.bottomRow,n=c._draggingCells.bottomRow;n>=c._draggingCells.topRow;n--)c.rows.moveElement(n,s),s--;c._exchangeCellStyle(!1)}else{for(this.undoStack.stackSize>0&&(r=new o._MoveCellsAction(c,c._draggingCells,c._dropRange,t.ctrlKey)),s=c._dropRange.bottomRow,n=c._draggingCells.bottomRow;n>=c._draggingCells.topRow;n--){for(l=c._dropRange.rightCol,i=c._draggingCells.rightCol;i>=c._draggingCells.leftCol;i--)c._moveCellContent(n,i,s,l,t.ctrlKey),c._draggingColumn&&s===c._dropRange.bottomRow&&(c.columns[l].dataType=c.columns[i].dataType?c.columns[i].dataType:e.DataType.Object,c.columns[l].align=c.columns[i].align,c.columns[l].format=c.columns[i].format,t.ctrlKey||(c.columns[i].dataType=e.DataType.Object,c.columns[i].align=null,c.columns[i].format=null)),l--;s--}if(c._draggingColumn&&!t.ctrlKey)for(l=c._dropRange.rightCol,i=c._draggingCells.rightCol;i>=c._draggingCells.leftCol;i--)c._updateColumnFiler(i,l),l--}t.ctrlKey||(a=c._updateFormulaForDropping(t.shiftKey),h=c._updateNamedRangesForDropping()),r&&r.saveNewState()&&(r._affectedFormulas=a,r._affectedDefinedNameVals=h,c._undoStack._addAction(r)),c._undoStack._pendingAction&&(c._undoStack._pendingAction._affectedFormulas=a,c._undoStack._pendingAction._affectedDefinedNameVals=h),c.select(c._dropRange),c.selectedSheet.selectionRanges.push(c.selection),c.hostElement.focus()}},l.prototype._moveCellContent=function(e,t,o,n,i){var s,l,r,a,h,c,d,u,_,g=this.getCellData(e,t,!1),f=e*this.columns.length+t,p=o*this.columns.length+n,w=this.selectedSheet._styledCells[f],m=!0;if(i&&g&&"string"==typeof g&&"="===g[0]&&(s=this._updateCellRefForDropping(g,this.selectedSheetIndex)),(r=this.selectedSheet.findTable(o,n))&&(u=r.getRange(),_=r.getColumns(),r.showHeaderRow&&o===u.topRow&&(c=_[h=n-u.leftCol].name,null==g||""===g?m=!1:_[h].name=s||g)),m?this.setCellData(o,n,s||g):m=!0,w?this.selectedSheet._styledCells[p]=this._cloneObject(w):delete this.selectedSheet._styledCells[p],i)(l=this.selectedSheet.findTable(e,t))&&(d=l.getRange(),l===r&&e===o&&l.showHeaderRow&&e===d.topRow&&(a=t-d.leftCol,l._updateColumnName(a,s||g)));else{if(delete this.selectedSheet._styledCells[f],l=this.selectedSheet.findTable(e,t)){if(d=l.getRange(),l===r&&e===o&&l.showHeaderRow&&e===d.topRow)return a=t-d.leftCol,void l._updateColumnName(a,c);if(l.showHeaderRow&&e===d.topRow)return}this.setCellData(e,t,null)}},l.prototype._allowExchangeCells=function(e,n){var i,s,l,r,a,h=this.selectedSheet.tables;for(i=0;i<h.length;i++)if(s=h[i],e?(l=s.getRange(o.TableSection.Data),this._draggingCells.rowSpan,r=new t.CellRange(this._draggingCells.topRow,l.leftCol,this._draggingCells.bottomRow,l.rightCol),a=new t.CellRange(this._dropRange.topRow,l.leftCol,this._dropRange.bottomRow,l.rightCol)):(l=s.getRange(),this._draggingCells.columnSpan,r=new t.CellRange(l.topRow,this._draggingCells.leftCol,l.bottomRow,this._draggingCells.rightCol),a=new t.CellRange(l.topRow,this._dropRange.leftCol,l.bottomRow,this._dropRange.rightCol)),l.intersects(r)&&!l.contains(r)||l.intersects(a)&&!l.contains(a)||l.contains(r)&&!l.contains(a)||!l.contains(r)&&l.contains(a))return!1;return!0},l.prototype._exchangeTableColumns=function(e){var t,o,n,i,s,l,r=this.selectedSheet.tables;for(t=0;t<r.length;t++)if(o=r[t],(n=o.getRange()).leftCol<=this._draggingCells.leftCol&&n.rightCol>=this._draggingCells.rightCol)for(i=(e?this._draggingCells.leftCol:this._draggingCells.rightCol)-n.leftCol,s=(e?this._dropRange.leftCol:this._dropRange.rightCol)-n.leftCol,l=0;l<this._draggingCells.columnSpan;l++)o._moveColumns(i,s),e?(i++,s++):(i--,s--)},l.prototype._exchangeCellStyle=function(e){var t,o,n,i,s,l=0,r=[];for(t=this._draggingCells.topRow;t<=this._draggingCells.bottomRow;t++)for(o=this._draggingCells.leftCol;o<=this._draggingCells.rightCol;o++)n=t*this.columns.length+o,this.selectedSheet._styledCells[n]?(r.push(this._cloneObject(this.selectedSheet._styledCells[n])),delete this.selectedSheet._styledCells[n]):r.push(void 0);if(e){if(this._draggingColumn)for(s=this._draggingCells.rightCol-this._draggingCells.leftCol+1,o=this._draggingCells.leftCol-1;o>=this._dropRange.leftCol;o--)for(t=0;t<this.rows.length;t++)n=t*this.columns.length+o,i=t*this.columns.length+o+s,this.selectedSheet._styledCells[n]?(this.selectedSheet._styledCells[i]=this._cloneObject(this.selectedSheet._styledCells[n]),delete this.selectedSheet._styledCells[n]):delete this.selectedSheet._styledCells[i];else if(this._draggingRow)for(s=this._draggingCells.bottomRow-this._draggingCells.topRow+1,t=this._draggingCells.topRow-1;t>=this._dropRange.topRow;t--)for(o=0;o<this.columns.length;o++)n=t*this.columns.length+o,i=(t+s)*this.columns.length+o,this.selectedSheet._styledCells[n]?(this.selectedSheet._styledCells[i]=this._cloneObject(this.selectedSheet._styledCells[n]),delete this.selectedSheet._styledCells[n]):delete this.selectedSheet._styledCells[i]}else if(this._draggingColumn)for(s=this._draggingCells.rightCol-this._draggingCells.leftCol+1,o=this._draggingCells.rightCol+1;o<=this._dropRange.rightCol;o++)for(t=0;t<this.rows.length;t++)n=t*this.columns.length+o,i=t*this.columns.length+o-s,this.selectedSheet._styledCells[n]?(this.selectedSheet._styledCells[i]=this._cloneObject(this.selectedSheet._styledCells[n]),delete this.selectedSheet._styledCells[n]):delete this.selectedSheet._styledCells[i];else if(this._draggingRow)for(s=this._draggingCells.bottomRow-this._draggingCells.topRow+1,t=this._draggingCells.bottomRow+1;t<=this._dropRange.bottomRow;t++)for(o=0;o<this.columns.length;o++)n=t*this.columns.length+o,i=(t-s)*this.columns.length+o,this.selectedSheet._styledCells[n]?(this.selectedSheet._styledCells[i]=this._cloneObject(this.selectedSheet._styledCells[n]),delete this.selectedSheet._styledCells[n]):delete this.selectedSheet._styledCells[i];for(t=this._dropRange.topRow;t<=this._dropRange.bottomRow;t++)for(o=this._dropRange.leftCol;o<=this._dropRange.rightCol;o++)n=t*this.columns.length+o,r[l]?this.selectedSheet._styledCells[n]=r[l]:delete this.selectedSheet._styledCells[n],l++},l.prototype._containsMergedCells=function(e,t){var o,n,i,s,l;if(t=t||this.selectedSheet,l=t===this.selectedSheet?this:t.grid,!t)return!1;for(o=e.topRow;o<=e.bottomRow;o++)for(n=e.leftCol;n<=e.rightCol;n++)if(i=o*l.columns.length+n,(s=t._mergedRanges[i])&&s.isValid&&!s.isSingleCell)return!0;return!1},l.prototype._multiSelectColumns=function(e){var o;e&&this._columnHeaderClicked&&((o=new t.CellRange(e.row,e.col)).row=this.itemsSource&&this.rows[0]&&!this.rows[0].isVisible?1:0,o.row2=this.rows.length-1,o.col2=this.selection.col2,this.select(o))},l.prototype._cumulativeOffset=function(t){var o=0,n=0;do{o+=t.offsetTop||0,n+=t.offsetLeft||0,t=t.offsetParent}while(t);return new e.Point(n,o)},l.prototype._cumulativeScrollOffset=function(t){var o=0,n=0;do{o+=t.scrollTop||0,n+=t.scrollLeft||0,t=t.offsetParent}while(t&&!(t instanceof HTMLBodyElement));return o+=document.body.scrollTop||document.documentElement.scrollTop,n+=document.body.scrollLeft||document.documentElement.scrollLeft,new e.Point(n,o)},l.prototype._checkHitWithinSelection=function(e){var o;if(null!=e&&e.cellType===t.CellType.Cell){if((o=this.getMergedRange(this.cells,e.row,e.col))&&o.contains(this.selection))return!0;if(this.selection.row===e.row&&this.selection.col===e.col)return!0}return!1},l.prototype._clearForEmptySheet=function(e){this.selectedSheet&&0===this[e].length&&!0!==this._isCopying&&!0!==this._isUndoing&&(this.selectedSheet._mergedRanges=null,this.selectedSheet._styledCells=null,this.select(new t.CellRange))},l.prototype._containsGroupRows=function(e){var o;for(o=e.topRow;o<=e.bottomRow;o++)if(this.rows[o]instanceof t.GroupRow)return!0;return!1},l.prototype._delSeletionContent=function(n){var i,s,l,r,a,h,c,d,u,_,g=this.selectedSheet.selectionRanges.slice(),f=!1,p=new o._EditAction(this),w=this.editableCollectionView,m=!1;if(!this.isReadOnly)if(this.allowDelete&&this.selection.isValid&&0===this.selection.leftCol&&this.selection.rightCol===this.columns.length-1)this.deleteRows(this.selection.topRow,this.selection.rowSpan);else{for(this.beginUpdate(),this.undoStack.stackSize>0&&(p=new o._EditAction(this)),null!=g&&0!==g.length||(g=[this.selection]),l=0;l<g.length;l++){if(i=g[l],s=new t.CellRange,u=new t.CellEditEndingEventArgs(this.cells,s,n),this.selectedSheet.tables.length>0)for(h=0;h<this.selectedSheet.tables.length;h++)c=this.selectedSheet.tables[h],i.contains(c.getRange())&&(p&&p._storeDeletedTables(c),this.selectedSheet.tables.remove(c));for(a=i.topRow;a<=i.bottomRow;a++)if((_=this.rows[a])&&!_.isReadOnly)for(r=i.leftCol;r<=i.rightCol;r++)(!(d=this._getBindingColumn(this.cells,a,this.columns[r])).isReadOnly&&!1===d.isRequired||null==d.isRequired&&d.dataType==e.DataType.String)&&this.getCellData(a,r,!0)&&(s.setRange(a,r),u.cancel=!1,this.onBeginningEdit(u)&&(w&&(m||(m=!0,w.beginUpdate()),w.editItem(_.dataItem),this._edtHdl._edItem=w.currentEditItem),this.setCellData(a,r,"",!0),f=!0,this.onCellEditEnding(u),this.onCellEditEnded(u)));m&&w.endUpdate()}f&&p&&(p.saveNewState(),this._undoStack._addAction(p)),this.endUpdate()}},l.prototype._updateAffectedFormula=function(t,o,n,i){var s,l,r,a,h,c,d,u,_,g=[],f=[],p=this.selection.clone();for(this.selectedSheet._storeRowSettings(),this.beginUpdate(),s=0;s<this.sheets.length;s++)for(r=(l=this.sheets[s]).grid,a=0;a<r.rows.length;a++)for(h=0;h<r.columns.length;h++)if((u=r.getCellData(a,h,!1))&&e.isString(u)&&"="===u[0]&&(_=this._updateCellRef(u,s,t,o,n,i))){if(g.push({sheet:l,point:new e.Point(a,h),formula:u}),c=a,d=h,s===this.selectedSheetIndex&&(i?a>=t&&(n?c+=o:c-=o):h>=t&&(n?d+=o:d-=o),!n&&(i&&a<=t&&a>=t-o+1||!i&&h<=t&&h>=t-o+1)))continue;r.setCellData(a,h,_),f.push({sheet:l,point:new e.Point(c,d),formula:_})}return this.selection=p,this.endUpdate(),{oldFormulas:g,newFormulas:f}},l.prototype._updateAffectedNamedRanges=function(t,o,n,i){var s,l,r,a,h=[],c=[];for(s=0;s<this.definedNames.length;s++)(r=(l=this.definedNames[s]).value)&&e.isString(r)&&(a=this._updateCellRef(r,this.selectedSheetIndex,t,o,n,i))&&(h.push({name:l.name,value:r}),l.value=a,c.push({name:l.name,value:a}));return{oldDefinedNameVals:h,newDefinedNameVals:c}},l.prototype._updateColumnFiler=function(e,t){for(var o=JSON.parse(this._filter.filterDefinition),n=0;n<o.filters.length;n++){var i=o.filters[n];if(i.columnIndex===e){i.columnIndex=t;break}}this._filter.filterDefinition=JSON.stringify(o)},l.prototype._isDescendant=function(e,t){for(var o=t.parentNode;null!=o;){if(o===e)return!0;o=o.parentNode}return!1},l.prototype._clearCalcEngine=function(){this._calcEngine._clearExpressionCache()},l.prototype._getRangeString=function(o,n,i){void 0===i&&(i=!0);var s,l,r,a,h,c="",d=!0,u=n.grid;if(e.isArray(o)&&o.length>1){if(this._isMultipleRowsSelected(o,n)){for(c="",l=0;l<o.length;l++)c&&(c+="\n"),c+=this._getRangeString(o[l],n);return c}if(this._isMultipleColumnsSelected(o,n))for(c="",s=0,d=!0;s<u.rows.length;s++){for(d||(c+="\n"),d=!1,l=0,p=!0;l<o.length;l++)(r=o[l].clone()).row=r.row2=s,p||(c+="\t"),p=!1,c+=this._getRangeString(o[l],n);return c}else switch(h=o[0],this.selectionMode){case t.SelectionMode.Row:case t.SelectionMode.RowRange:return h.col=0,h.col2=u.columns.length-1,this._getRangeString(h,n);case t.SelectionMode.ListBox:h.col=0,h.col2=u.columns.length-1;for(var _=0;_<u.rows.length;_++)u.rows[_].isSelected&&u.rows[_].isVisible&&(h.row=h.row2=_,c&&(c+="\n"),c+=this._getRangeString(h,n));return c}}for(var g=(h=e.asType(e.isArray(o)?o[0]:o,t.CellRange)).topRow;g<=h.bottomRow;g++)if(u.rows[g]&&u.rows[g].isVisible){d||(c+="\n"),d=!1;for(var f=h.leftCol,p=!0;f<=h.rightCol;f++)if(u.columns[f]&&u.columns[f].isVisible){p||(c+="\t"),p=!1;var w=this._getCellStyle(g,f,n),m=w?w.format:"",C=u.columns[f];i?(a=u.getCellData(g,f,!1),e.isString(a)&&"="===a[0]&&(a=this._evaluate(a,m,n,g,f)),a=this._formatEvaluatedResult(a,C,m)):(a=u.getCellData(g,f,!1),e.isDate(a)&&(a=e.Globalize.formatDate(a,m||C.format))),(a=(a=null==a?"":a.toString()).replace(/\t/g," ")).indexOf("\n")>-1&&(a='"'+a.replace(/"/g,'""')+'"'),c+=a}}return c},l.prototype._containsRandFormula=function(t,o){for(var n=0;n<t.length;n++)for(var i=t[n],s=i.topRow;s<=i.bottomRow&&s<o.grid.rows.length;s++)for(var l=i.leftCol;l<=i.rightCol&&l<o.grid.columns.length;l++){var r=o.grid.getCellData(s,l,!1);if(e.isString(r)&&"="===r[0]&&-1!==r.search(/rand/i))return!0}return!1},l.prototype._isMultipleRowsSelected=function(e,t){var o,n;n=e&&e.length>0?e:this.selectedSheet.selectionRanges.length>0?this.selectedSheet.selectionRanges:[this.selection];for(var i=0;i<n.length;i++)if(o=n[i],t){if(0!==o.leftCol||o.rightCol!==t.grid.columns.length-1)return!1}else if(0!==o.leftCol||o.rightCol!==this.columns.length-1)return!1;return!0},l.prototype._isMultipleColumnsSelected=function(e,t){var o,n;n=e&&e.length>0?e:this.selectedSheet.selectionRanges.length>0?this.selectedSheet.selectionRanges:[this.selection];for(var i=0;i<n.length;i++)if(o=n[i],t){if(o.bottomRow!==t.grid.rows.length-1)return!1;if(!t.grid.itemsSource&&0!==o.topRow)return!1;if(t.grid.itemsSource&&1!==o.topRow)return!1}else{if(o.bottomRow!==this.rows.length-1)return!1;if(!this.selectedSheet.itemsSource&&0!==o.topRow)return!1;if(this.selectedSheet.itemsSource&&1!==o.topRow)return!1}return!0},l.prototype._postSetClipStringProcess=function(o,n,i,s,l,r){var a,h,c,d,u,_,g=!1;return s>=0&&l>=0&&this._copiedSheet&&(a=s*this._copiedSheet.grid.columns.length+l,(h=this._copiedSheet._mergedRanges[a])&&h.topRow===s&&h.leftCol===l&&(c=(c=n+h.rowSpan-1)<this.rows.length?c:this.rows.length-1,d=(d=i+h.columnSpan-1)<this.columns.length?d:this.columns.length-1,this.mergeRange(new t.CellRange(n,i,c,d),!0))),u=new t.CellRangeEventArgs(this.cells,new t.CellRange(n,i),o),this.onPastingCell(u)&&this.cells.setCellData(n,i,u.data)&&(e.isString(u.data)&&(_=u.data.match(/\n/g))&&_.length>0&&(r?r.whiteSpace="pre":r={whiteSpace:"pre"},this.rows[n].height=this.rows.defaultSize*(_.length+1)),r&&this._applyStyleForCell(n,i,r),this.onPastedCell(u),g=!0),g},l.prototype._delCutData=function(){var t,o,n,i=this._copiedRanges[0],s=this._copiedSheet===this.selectedSheet?this:this._copiedSheet.grid;for(t=i.topRow;t<=i.bottomRow;t++)if(null!=s.rows[t])for(o=i.leftCol;o<=i.rightCol;o++)(this._copiedSheet!==this.selectedSheet||t<this.selection.topRow||t>this.selection.bottomRow||o<this.selection.leftCol||o>this.selection.rightCol)&&(0==(n=s._getBindingColumn(s.cells,t,s.columns[o])).isRequired||null==n.isRequired&&n.dataType==e.DataType.String)&&s.getCellData(t,o,!0)&&s.setCellData(t,o,"",!0)},l.prototype._containsMultiLineText=function(e){for(var t=0;t<e.length;t++)for(var o=e[t],n=0;n<o.length;n++)if(o[n].indexOf("\n")>=0)return!0;return!1},l.prototype._sortByRow=function(e,t){return e.topRow>t.topRow?1:e.topRow<t.topRow?-1:0},l.prototype._sortByColumn=function(e,t){return e.leftCol>t.leftCol?1:e.leftCol<t.leftCol?-1:0},l.prototype._setFlexSheetToDirty=function(){this.columns._dirty=!0,this.rows._dirty=!0,this.rowHeaders.columns._dirty=!0,this.rowHeaders.rows._dirty=!0,this.columnHeaders.columns._dirty=!0,this.columnHeaders.rows._dirty=!0},l.convertNumberToAlpha=function(e){var t,o,n="";if(e>=0)do{t=Math.floor(e/26),o=e%26,n=String.fromCharCode(o+65)+n,e=t-1}while(t);return n},l.prototype._updateFormulaForReorderingRows=function(t,o){var n,i,s,l,r,a,h=o-t;this.beginUpdate();for(var c=0;c<this.columns.length;c++)if((n=this.getCellData(o,c,!1))&&"string"==typeof n&&"="===n[0]&&(i=n.match(/(?=\b\D)\$?[A-Za-z]{1,2}\$?\d+/g))&&i.length>0){for(var d=0;d<i.length;d++)s=i[d],(a=(r=e.xlsx.Workbook.tableAddress(s)).row+h)<0?a=0:a>=this.rows.length&&(a=this.rows.length-1),r.row=a,l=e.xlsx.Workbook.xlsxAddress(r.row,r.col,r.absRow,r.absCol),n=n.replace(s,l);this.setCellData(o,c,n)}this.endUpdate()},l.prototype._updateFormulaForDropping=function(t){var o,n,i,s,l,r,a,h,c,d=[],u=[];for(this.beginUpdate(),i=0;i<this.sheets.length;i++)for(n=(o=this.sheets[i]).grid,s=0;s<n.rows.length;s++)for(r=0;r<n.columns.length;r++)(h=n.getCellData(s,r,!1))&&"string"==typeof h&&"="===h[0]&&(c=this._updateCellRefForDropping(h,i))&&(n.setCellData(s,r,c),t&&i===this.selectedSheetIndex?(l=n.rows[s],a=n.columns[r],d.push({sheet:o,row:l,column:a,formula:h}),u.push({sheet:o,row:l,column:a,formula:c})):(d.push({sheet:o,point:new e.Point(s,r),formula:h}),u.push({sheet:o,point:new e.Point(s,r),formula:c})));return this.endUpdate(),{oldFormulas:d,newFormulas:u}},l.prototype._updateNamedRangesForDropping=function(){var t,o,n,i,s=[],l=[];for(t=0;t<this.definedNames.length;t++)(n=(o=this.definedNames[t]).value)&&e.isString(n)&&(i=this._updateCellRefForDropping(n,this.selectedSheetIndex))&&(s.push({name:o.name,value:n}),o.value=i,l.push({name:o.name,value:i}));return{oldDefinedNameVals:s,newDefinedNameVals:l}},l.prototype._updateCellRefForDropping=function(o,n){var i,s,l,r,a,h,c,d,u,_,g,f,p,w,m,C;if((l=o.match(/((\w+)\!)?\$?[A-Za-z]{1,2}\$?\d+:((\w+)\!)?\$?[A-Za-z]{1,2}\$?\d+/g))&&0!==l.length||(l=o.match(/((\w+)\!)?\$?[A-Za-z]{1,2}\$?\d+/g)),l&&l.length>0)for(a=0;a<l.length;a++){if(g=null,d=null,u=null,p=null,m=null,C=null,(r=l[a]).indexOf(":")>0){if(c=r.split(":"),d=c[0],u=c[1],(_=d.indexOf("!"))>=0&&(g=d.substring(0,_),d=d.substring(_+1)),n===this.selectedSheetIndex){if(g&&g.toLowerCase()!==this.selectedSheet.name.toLowerCase())continue}else if(!g||g.toLowerCase()!==this.selectedSheet.name.toLowerCase())continue;(_=d.indexOf("!"))>=0&&(f=d.substring(0,_),u=d.substring(_+1)),m=e.xlsx.Workbook.tableAddress(d),p=new t.CellRange(m.row,m.col),C=e.xlsx.Workbook.tableAddress(u),p.row2=C.row,p.col2=C.col}else{if((_=r.indexOf("!"))>=0)g=r.substring(0,_),d=r.substring(_+1);else{if((h=o.indexOf(r))>0&&/[\d\w]/.test(o[h-1]))continue;d=r}if(n===this.selectedSheetIndex){if(g&&g.toLowerCase()!==this.selectedSheet.name.toLowerCase())continue}else if(!g||g.toLowerCase()!==this.selectedSheet.name.toLowerCase())continue;m=e.xlsx.Workbook.tableAddress(d),p=new t.CellRange(m.row,m.col)}p&&this._draggingCells.contains(p)&&(0!==(s=this._dropRange.leftCol-this._draggingCells.leftCol)&&(p.col+=m.absCol?0:s,p.col2+=C?C.absCol?0:s:m.absCol?0:s),0!==(s=this._dropRange.topRow-this._draggingCells.topRow)&&(p.row+=m.absRow?0:s,p.row2+=C?C.absRow?0:s:m.absRow?0:s),null==i&&(i=o),C?(w=g?g+"!":"",w+=e.xlsx.Workbook.xlsxAddress(p.row,p.col,m.absRow,m.absCol)+":",w+=(f?f+"!":"")+e.xlsx.Workbook.xlsxAddress(p.row2,p.col2,C.absRow,C.absCol)):(w=g?g+"!":"",w+=e.xlsx.Workbook.xlsxAddress(p.row,p.col,m.absRow,m.absCol)),i=i.replace(r,w))}return i},l.prototype._scanFormulas=function(){for(var t=[],o=0;o<this.rows.length;o++)for(var n=0;n<this.columns.length;n++){var i=this.getCellData(o,n,!1);i&&e.isString(i)&&"="===i[0]&&t.push({row:o,column:n,formula:i})}return t},l.prototype._resetFormulas=function(e){var t=this;e&&t.deferUpdate(function(){for(var o=0;o<e.length;o++){var n=e[o];t.setCellData(n.row,n.column,n.formula)}})},l.prototype._getCellStyle=function(e,t,o){var n;return(o=o||this.selectedSheet)?(n=e*o.grid.columns.length+t,o._styledCells[n]):null},l.prototype._validateSheetName=function(e){for(var t=0;t<this.sheets.length;t++)if(this.sheets[t].name===e)return!0;return!1},l.prototype._checkExistDefinedName=function(e,t,o){void 0===o&&(o=-1);for(var n=0;n<this.definedNames.length;n++)if(this.definedNames[n].name===e&&this.definedNames[n].sheetName===t&&n!==o)return!0;return!1},l.prototype._updateDefinedNameWithSheetRefUpdating=function(e,t){for(var o,n,i,s=0;s<this.definedNames.length;s++)if((o=this.definedNames[s]).sheetName===e&&null!=o.sheetName&&(o._sheetName=t),(n=o.value.match(/(\w+)\!\$?[A-Za-z]+\$?\d+/g))&&n.length>0)for(var l=0;l<n.length;l++)(i=n[l]).substring(0,i.indexOf("!"))===e&&(o.value=o.value.replace(i,i.replace(e,t)))},l.prototype._updateFormulasWithNameUpdating=function(e,t,o){void 0===o&&(o=!1);var n,i,s,l,r,a,h,c,d,u,_=this.selection.clone(),g=!1;for(u=o?/\[/:/\w/,this.selectedSheet._storeRowSettings(),this.beginUpdate(),n=0;n<this.sheets.length;n++)for(l=this.sheets[n].grid,i=0;i<l.rows.length;i++)for(s=0;s<l.columns.length;s++)if((r=l.getCellData(i,s,!1))&&"string"==typeof r&&"="===r[0]){for(g=!1,a=r.indexOf(e),d=new RegExp(e,"g");a>-1;)h="",c="",a>0&&(h=r[a-1]),a+e.length<r.length&&(c=r[a+e.length]),!/\w/.test(h)&&(o&&u.test(c)||!o&&!u.test(c))&&(r=r.replace(d,function(o,n){return n===a?t:e}),g=!0),a=r.indexOf(e,a+e.length);g&&l.setCellData(i,s,r)}this.selection=_,this.endUpdate()},l.prototype._getDefinedNameIndexByName=function(e){for(var t=0;t<this.definedNames.length;t++)if(this.definedNames[t].name===e)return t;return-1},l.prototype._updateTablesForUpdatingRow=function(e,t,o){var n,i,s,l,r;if(this.selectedSheet.tables.length>0)for(n=this.selectedSheet.tables.length-1;n>=0;n--)if(i=this.selectedSheet.tables[n],s=i.getRange(),o)if((l=e+t-1)<s.topRow)i._updateTableRange(-t,-t,0,0);else if(l>=s.topRow&&l<=s.bottomRow)if(e<s.topRow)i.showHeaderRow&&(i._showHeaderRow=!1),i._updateTableRange(e-s.topRow,-t,0,0);else{if(e===s.topRow&&t===s.rowSpan){null==r&&(r=[]),r.push(i),this.selectedSheet.tables.remove(i);continue}e===s.topRow&&i.showHeaderRow&&(i._showHeaderRow=!1),l===s.bottomRow&&i.showTotalRow&&(i._showTotalRow=!1),i._updateTableRange(0,-t,0,0)}else e<=s.topRow?(null==r&&(r=[]),r.push(i),this.selectedSheet.tables.remove(i)):e<=s.bottomRow&&(i.showTotalRow&&(i._showTotalRow=!1),i._updateTableRange(0,e-s.bottomRow-1,0,0));else e<=s.topRow?i._updateTableRange(t,t,0,0):e>s.topRow&&e<=s.bottomRow&&i._updateTableRange(0,t,0,0);return r},l.prototype._updateTablesForUpdatingColumn=function(e,t,o){var n,i,s,l,r,a,h,c;if(this.selectedSheet.tables.length>0)for(n=this.selectedSheet.tables.length-1;n>=0;n--)if(i=this.selectedSheet.tables[n],s=i.getRange(),o)if((l=e+t-1)<s.leftCol)i._updateTableRange(0,0,-t,-t);else if(l>=s.leftCol&&l<=s.rightCol){if(e<s.leftCol)r=t-s.leftCol+e,a=s.leftCol,i._updateTableRange(0,0,e-s.leftCol,-t);else{if(e===s.leftCol&&t===s.columnSpan){null==c&&(c=[]),c.push(i),this.selectedSheet.tables.remove(i);continue}r=t,a=e,i._updateTableRange(0,0,0,-r)}i._columns.splice(a-s.leftCol,r)}else e<=s.leftCol?(null==c&&(c=[]),c.push(i),this.selectedSheet.tables.remove(i)):e<=s.rightCol&&(r=s.rightCol-e+1,i._updateTableRange(0,0,0,-r),i._columns.splice(e,r));else if(e<=s.leftCol)i._updateTableRange(0,0,t,t);else if(e>s.leftCol&&e<=s.rightCol)for(i._updateTableRange(0,0,0,t),a=e-s.leftCol,h=0;h<t;h++)i._addColumn(a+h);return c},l.prototype._isDisableDeleteRow=function(e,t){var o,n,i;if(this.selectedSheet.tables.length>0)for(o=0;o<this.selectedSheet.tables.length;o++)if(n=this.selectedSheet.tables[o],i=n.getRange(),n.showHeaderRow&&i.topRow>=e&&i.topRow<=t)return!0;return!1},l.prototype._copy=function(e,t){var o,n;if("columns"==e){if(i.prototype._copy.call(this,e,t),this.itemsSource&&(o=this.rows[0])instanceof h){o._ubv=null,o._ubv={};for(var s=0;s<this.columns.length;s++)n=this.columns[s],o._ubv[n._hash]=n.header}return!0}return!1},l.prototype._getTableSheetIndex=function(e,t){this.sheets;for(var o=0;o<e.length;o++)if(e[o].indexOf(t)>-1)return o;return-1},l.prototype._sheetSortConverter=function(t,o,n,s){return n=i.prototype._sortConverter.call(this,t,o,n,s),e.isString(n)&&n.length>0&&"="===n[0]&&(n=this.evaluate(n)),n},l.prototype._formatEvaluatedResult=function(t,o,n){return e.isPrimitive(t)?(o.dataMap&&(t=o.dataMap.getDisplayValue(t)),!e.isInt(t)||o.format||o.dataMap||n?((n||o.format)&&e.isString(t)&&(+t).toString()===t&&(t=+t),t=null!=t?e.Globalize.format(t,n||o.format):""):t=t.toString()):t&&(!e.isInt(t.value)||o.format||o.dataMap||n||t.format?(e.isString(t.value)&&(+t.value).toString()===t.value&&(t.value=+t.value),t=null!=t.value?e.Globalize.format(t.value,n||t.format||o.format):""):t=t.value.toString()),t},l.prototype._updateCellRef=function(o,n,i,s,l,r){var a,h,c,d,u,_,g,f,p,w,m,C,b,y,S,v,R;if((h=o.match(/((\w+)\!)?\$?[A-Za-z]{1,2}\$?\d+:((\w+)\!)?\$?[A-Za-z]{1,2}\$?\d+/g))&&0!==h.length||(h=o.match(/((\w+)\!)?\$?[A-Za-z]{1,2}\$?\d+/g)),h&&h.length>0){for(g=[],c=0;c<h.length;c++)u=h[c],g[c]=o.indexOf(h[c]);for(c=0;c<h.length;c++){if(C=null,p=null,w=null,y=null,v=null,R=null,(u=h[c]).indexOf(":")>0){if(f=u.split(":"),p=f[0],w=f[1],(m=p.indexOf("!"))>=0&&(C=p.substring(0,m),p=p.substring(m+1)),n===this.selectedSheetIndex){if(C&&C.toLowerCase()!==this.selectedSheet.name.toLowerCase())continue}else if(!C||C.toLowerCase()!==this.selectedSheet.name.toLowerCase())continue;(m=w.indexOf("!"))>=0&&(b=w.substring(0,m),w=w.substring(m+1)),v=e.xlsx.Workbook.tableAddress(p),y=new t.CellRange(v.row,v.col),R=e.xlsx.Workbook.tableAddress(w),y.row2=R.row,y.col2=R.col}else{if((m=u.indexOf("!"))>=0)C=u.substring(0,m),p=u.substring(m+1);else{if((_=g[c])>0&&/[\d\w]/.test(o[_-1]))continue;p=u}if(n===this.selectedSheetIndex){if(C&&C.toLowerCase()!==this.selectedSheet.name.toLowerCase())continue}else if(!C||C.toLowerCase()!==this.selectedSheet.name.toLowerCase())continue;v=e.xlsx.Workbook.tableAddress(p),y=new t.CellRange(v.row,v.col)}y&&(d=!1,r?l?y.topRow>=i?(y.row+=s,y.row2+=s,d=!0):y.topRow<i&&y.bottomRow>=i&&(y.row<y.row2?y.row2+=s:y.row+=s,d=!0):y.topRow>i?(y.row-=s,y.row2-=s,d=!0):y.isSingleCell?y.row>=i-s+1&&(y.row=i-s+1,y.row2=i-s+1,d=!0):y.topRow>=i-s+1?(y.row<y.row2?(y.row=i-s+1,y.row2-=s):(y.row-=s,y.row2=i-s+1),d=!0):y.topRow<i-s+1&&y.bottomRow>=i-s+1&&(y.bottomRow>i?y.row<y.row2?y.row2-=s:y.row-=s:y.row<y.row2?y.row2=i-s:y.row=i-s,d=!0):l?y.leftCol>=i?(y.col+=s,y.col2+=s,d=!0):y.leftCol<i&&y.rightCol>=i&&(y.col<y.col2?y.col2+=s:y.col+=s,d=!0):y.leftCol>i?(y.col-=s,y.col2-=s,d=!0):y.isSingleCell?y.col>=i-s+1&&(y.col=i-s+1,y.col2=i-s+1,d=!0):y.leftCol>=i-s+1?(y.col<y.col2?(y.col=i-s+1,y.col2-=s):(y.col-=s,y.col2=i-s+1),d=!0):y.leftCol<i-s+1&&y.rightCol>=i-s+1&&(y.rightCol>i?y.col<y.col2?y.col2-=s:y.col-=s:y.col<y.col2?y.col2=i-s:y.col=i-s,d=!0),d&&(R?(S=C?C+"!":"",S+=e.xlsx.Workbook.xlsxAddress(y.row,y.col,v.absRow,v.absCol)+":",S+=(b?b+"!":"")+e.xlsx.Workbook.xlsxAddress(y.row2,y.col2,R.absRow,R.absCol)):(S=C?C+"!":"",S+=e.xlsx.Workbook.xlsxAddress(y.row,y.col,v.absRow,v.absCol)),null==a&&(a=o),a=a.replace(new RegExp(u.replace(/\$/g,"\\$"),"gi"),function(e,t){return t+e.length>=g[c]?S:e})))}}return a},l.prototype._copyRowsToSelectedSheet=function(){var e,t=this;if(t.selectedSheet){for(t.selectedSheet.grid.rows.clear(),e=0;e<t.rows.length;e++)t.selectedSheet.grid.rows.push(t.rows[e]);setTimeout(function(){t._setFlexSheetToDirty(),t.invalidate()},10)}},l.prototype._copyColumnsToSelectedSheet=function(){var e,t=this;if(t.selectedSheet){for(t.selectedSheet.grid.columns.clear(),e=0;e<t.columns.length;e++)t.selectedSheet.grid.columns.push(t.columns[e]);setTimeout(function(){t._setFlexSheetToDirty(),t.invalidate()},10)}},l.prototype._parseFromWorkbookTable=function(n,i){var s,l,r,a,h,c,d,u,_,g,f,p=i===this.selectedSheet?this:i.grid;if(l=n.range.split(":"),r=l[0],a=l[1],h=e.xlsx.Workbook.tableAddress(r),s=new t.CellRange(h.row,h.col),c=e.xlsx.Workbook.tableAddress(a),s.row2=c.row,s.col2=c.col,s.bottomRow>=i.rowCount)for(f=s.bottomRow-i.rowCount+1,w=0;w<f;w++)p.rows.push(new t.Row);if(s.rightCol>=i.columnCount)for(f=s.rightCol-i.columnCount+1,w=0;w<f;w++)p.columns.push(new t.Column);if(n.columns&&n.columns.length>0){d=[];for(var w=0;w<n.columns.length;w++)u=n.columns[w],d[w]=new o.TableColumn(u.name,u.totalRowLabel,u.totalRowFunction,u.showFilterButton)}return null!=n.style&&(_=this._isBuiltInStyleName(n.style.name)?this.getBuiltInTableStyle(n.style.name):this._parseFromWorkbookTableStyle(n.style)),g=new o.Table(n.name,s,_,d,{showHeaderRow:n.showHeaderRow,showTotalRow:n.showTotalRow,showBandedColumns:n.showBandedColumns,showBandedRows:n.showBandedRows,alterFirstColumn:n.alterFirstColumn,alterLastColumn:n.alterLastColumn}),i.tables.push(g),g},l.prototype._parseFromWorkbookTableStyle=function(e){var t=new o.TableStyle(e.name);return null!=e.firstBandedColumnStyle&&(t.firstBandedColumnStyle=this._parseFromWorkbookTableStyleElement(e.firstBandedColumnStyle)),null!=e.firstBandedRowStyle&&(t.firstBandedRowStyle=this._parseFromWorkbookTableStyleElement(e.firstBandedRowStyle)),null!=e.firstColumnStyle&&(t.firstColumnStyle=this._parseFromWorkbookTableStyleElement(e.firstColumnStyle)),null!=e.firstHeaderCellStyle&&(t.firstHeaderCellStyle=this._parseFromWorkbookTableStyleElement(e.firstHeaderCellStyle)),null!=e.firstTotalCellStyle&&(t.firstTotalCellStyle=this._parseFromWorkbookTableStyleElement(e.firstTotalCellStyle)),null!=e.headerRowStyle&&(t.headerRowStyle=this._parseFromWorkbookTableStyleElement(e.headerRowStyle)),null!=e.lastColumnStyle&&(t.lastColumnStyle=this._parseFromWorkbookTableStyleElement(e.lastColumnStyle)),null!=e.lastHeaderCellStyle&&(t.lastHeaderCellStyle=this._parseFromWorkbookTableStyleElement(e.lastHeaderCellStyle)),null!=e.lastTotalCellStyle&&(t.lastTotalCellStyle=this._parseFromWorkbookTableStyleElement(e.lastTotalCellStyle)),null!=e.secondBandedColumnStyle&&(t.secondBandedColumnStyle=this._parseFromWorkbookTableStyleElement(e.secondBandedColumnStyle)),null!=e.secondBandedRowStyle&&(t.secondBandedRowStyle=this._parseFromWorkbookTableStyleElement(e.secondBandedRowStyle)),null!=e.totalRowStyle&&(t.totalRowStyle=this._parseFromWorkbookTableStyleElement(e.totalRowStyle)),null!=e.wholeTableStyle&&(t.wholeTableStyle=this._parseFromWorkbookTableStyleElement(e.wholeTableStyle)),t},l.prototype._parseFromWorkbookTableStyleElement=function(e){var o;return o={fontWeight:e.font&&e.font.bold?"bold":"none",fontStyle:e.font&&e.font.italic?"italic":"none",textDecoration:e.font&&e.font.underline?"underline":"none",fontFamily:e.font&&e.font.family?e.font.family:"",fontSize:e.font&&e.font.size?e.font.size+"px":"",color:e.font&&e.font.color?e.font.color:"",backgroundColor:e.fill&&e.fill.color?e.fill.color:""},e.borders&&(e.borders.left&&(t.xlsx.FlexGridXlsxConverter._parseBorderStyle(e.borders.left.style,"Left",o),o.borderLeftColor=e.borders.left.color),e.borders.right&&(t.xlsx.FlexGridXlsxConverter._parseBorderStyle(e.borders.right.style,"Right",o),o.borderRightColor=e.borders.right.color),e.borders.top&&(t.xlsx.FlexGridXlsxConverter._parseBorderStyle(e.borders.top.style,"Top",o),o.borderTopColor=e.borders.top.color),e.borders.bottom&&(t.xlsx.FlexGridXlsxConverter._parseBorderStyle(e.borders.bottom.style,"Bottom",o),o.borderBottomColor=e.borders.bottom.color),e.borders.vertical&&(t.xlsx.FlexGridXlsxConverter._parseBorderStyle(e.borders.vertical.style,"Vertical",o),o.borderVerticalColor=e.borders.vertical.color),e.borders.horizontal&&(t.xlsx.FlexGridXlsxConverter._parseBorderStyle(e.borders.horizontal.style,"Horizontal",o),o.borderHorizontalColor=e.borders.horizontal.color)),null!=e.size&&(o.size=e.size),o},l.prototype._parseToWorkbookTable=function(t){var o,n,i=new e.xlsx.WorkbookTable,s=t.getRange(),l=t.getColumns();i.name=t.name,o=e.xlsx.Workbook.xlsxAddress(s.topRow,s.leftCol),n=e.xlsx.Workbook.xlsxAddress(s.bottomRow,s.rightCol),i.range=o+":"+n,null!=t.style&&(t.style.isBuiltIn?(i.style=new e.xlsx.WorkbookTableStyle,i.style.name=t.style.name):i.style=this._parseToWorkbookTableStyle(t.style)),i.showBandedColumns=t.showBandedColumns,i.showBandedRows=t.showBandedRows,i.showHeaderRow=t.showHeaderRow,i.showTotalRow=t.showTotalRow,i.alterFirstColumn=t.alterFirstColumn,i.alterLastColumn=t.alterLastColumn;for(var r=0;r<l.length;r++){var a=l[r],h=new e.xlsx.WorkbookTableColumn;h.name=a.name,h.totalRowLabel=a.totalRowLabel,h.totalRowFunction=a.totalRowFunction,h.showFilterButton=a.showFilterButton,i.columns.push(h)}return i},l.prototype._parseToWorkbookTableStyle=function(t){var o=new e.xlsx.WorkbookTableStyle;return o.name=t.name,null!=t.firstBandedColumnStyle&&(o.firstBandedColumnStyle=this._parseToWorkbookTableStyleElement(t.firstBandedColumnStyle,!0)),null!=t.firstBandedRowStyle&&(o.firstBandedRowStyle=this._parseToWorkbookTableStyleElement(t.firstBandedRowStyle,!0)),null!=t.firstColumnStyle&&(o.firstColumnStyle=this._parseToWorkbookTableStyleElement(t.firstColumnStyle)),null!=t.firstHeaderCellStyle&&(o.firstHeaderCellStyle=this._parseToWorkbookTableStyleElement(t.firstHeaderCellStyle)),null!=t.firstTotalCellStyle&&(o.firstTotalCellStyle=this._parseToWorkbookTableStyleElement(t.firstTotalCellStyle)),null!=t.headerRowStyle&&(o.headerRowStyle=this._parseToWorkbookTableStyleElement(t.headerRowStyle)),null!=t.lastColumnStyle&&(o.lastColumnStyle=this._parseToWorkbookTableStyleElement(t.lastColumnStyle)),null!=t.lastHeaderCellStyle&&(o.lastHeaderCellStyle=this._parseToWorkbookTableStyleElement(t.lastHeaderCellStyle)),null!=t.lastTotalCellStyle&&(o.lastTotalCellStyle=this._parseToWorkbookTableStyleElement(t.lastTotalCellStyle)),null!=t.secondBandedColumnStyle&&(o.secondBandedColumnStyle=this._parseToWorkbookTableStyleElement(t.secondBandedColumnStyle,!0)),null!=t.secondBandedRowStyle&&(o.secondBandedRowStyle=this._parseToWorkbookTableStyleElement(t.secondBandedRowStyle,!0)),null!=t.totalRowStyle&&(o.totalRowStyle=this._parseToWorkbookTableStyleElement(t.totalRowStyle)),null!=t.wholeTableStyle&&(o.wholeTableStyle=this._parseToWorkbookTableStyleElement(t.wholeTableStyle)),o},l.prototype._parseToWorkbookTableStyleElement=function(o,n){void 0===n&&(n=!1);var i,s=t.xlsx.FlexGridXlsxConverter._parseCellStyle(o,!0);return n?(i=new e.xlsx.WorkbookTableBandedStyle).size=o.size:i=new e.xlsx.WorkbookTableCommonStyle,i._deserialize(s),i},l.prototype._isBuiltInStyleName=function(e){var t;if(0===e.search(/TableStyleLight/i)){if(t=+e.substring(15),!isNaN(t)&&t>=1&&t<=21)return!0}else if(0===e.search(/TableStyleMedium/i)){if(t=+e.substring(16),!isNaN(t)&&t>=1&&t<=28)return!0}else if(0===e.search(/TableStyleDark/i)&&(t=+e.substring(14),!isNaN(t)&&t>=1&&t<=11))return!0;return!1},l.prototype._getTable=function(e){for(var t,o,n,i=0;i<this.sheets.length;i++)for(o=this.sheets[i].tables,n=0;n<o.length;n++)if((t=o[n]).name.toLowerCase()===e.toLowerCase())return t;return null},l.prototype._isTableColumnRef=function(e,t){return new RegExp("\\[(\\s*@)?"+t+"\\]","i").test(e)},l.prototype._getThemeColor=function(t,o){var n,i,s=this._colorThemes[t];return null!=o?(n=new e.Color("#"+s),i=n.getHsl(),i[2]=o<0?i[2]*(1+o):i[2]*(1-o)+(1-1*(1-o)),(n=e.Color.fromHsl(i[0],i[1],i[2])).toString()):"#"+s},l.prototype._createBuiltInTableStyle=function(e){var t;if(0===e.search(/TableStyleLight/i)){if(t=+e.substring(15),!isNaN(t)&&t>=1&&t<=21)return t<=7?this._generateTableLightStyle1(t-1,e,!0):t<=14?this._generateTableLightStyle2(t-8,e):this._generateTableLightStyle1(t-15,e,!1)}else if(0===e.search(/TableStyleMedium/i)){if(t=+e.substring(16),!isNaN(t)&&t>=1&&t<=28)return t<=7?this._generateTableMediumStyle1(t-1,e):t<=14?this._generateTableMediumStyle2(t-8,e):t<=21?this._generateTableMediumStyle3(t-15,e):this._generateTableMediumStyle4(t-22,e)}else if(0===e.search(/TableStyleDark/i)&&(t=+e.substring(14),!isNaN(t)&&t>=1&&t<=11))return t<=7?this._generateTableDarkStyle1(t-1,e):this._generateTableDarkStyle2(t-8,e);return null},l.prototype._generateTableLightStyle1=function(e,t,n){var i=new o.TableStyle(t,!0),s=0===e?1:e+3,l=n?"1px":"2px",r=n?"solid":"double",a=n?"1px":"3px";return i.wholeTableStyle={borderTopColor:this._getThemeColor(s),borderTopStyle:"solid",borderTopWidth:"1px",borderBottomColor:this._getThemeColor(s),borderBottomStyle:"solid",borderBottomWidth:"1px"},i.firstColumnStyle={fontWeight:"bold"},i.lastColumnStyle={fontWeight:"bold"},i.headerRowStyle={borderBottomColor:this._getThemeColor(s),borderBottomStyle:"solid",borderBottomWidth:l,fontWeight:"bold"},i.totalRowStyle={borderTopColor:this._getThemeColor(s),borderTopStyle:r,borderTopWidth:a,fontWeight:"bold"},0===e?(i.wholeTableStyle.color=this._getThemeColor(s),i.firstColumnStyle.color=this._getThemeColor(s),i.lastColumnStyle.color=this._getThemeColor(s),i.headerRowStyle.color=this._getThemeColor(s),i.totalRowStyle.color=this._getThemeColor(s),i.firstBandedRowStyle={backgroundColor:this._getThemeColor(0,-.15)},i.firstBandedColumnStyle={backgroundColor:this._getThemeColor(0,-.15)}):(n?(i.wholeTableStyle.color=this._getThemeColor(s,-.25),i.firstColumnStyle.color=this._getThemeColor(s,-.25),i.lastColumnStyle.color=this._getThemeColor(s,-.25),i.headerRowStyle.color=this._getThemeColor(s,-.25),i.totalRowStyle.color=this._getThemeColor(s,-.25)):(i.wholeTableStyle.color=this._getThemeColor(1),i.firstColumnStyle.color=this._getThemeColor(1),i.lastColumnStyle.color=this._getThemeColor(1),i.headerRowStyle.color=this._getThemeColor(1),i.totalRowStyle.color=this._getThemeColor(1)),i.firstBandedRowStyle={backgroundColor:this._getThemeColor(s,.8)},i.firstBandedColumnStyle={backgroundColor:this._getThemeColor(s,.8)}),n||(i.wholeTableStyle.borderLeftColor=this._getThemeColor(s),i.wholeTableStyle.borderLeftStyle="solid",i.wholeTableStyle.borderLeftWidth="1px",i.wholeTableStyle.borderRightColor=this._getThemeColor(s),i.wholeTableStyle.borderRightStyle="solid",i.wholeTableStyle.borderRightWidth="1px",i.wholeTableStyle.borderHorizontalColor=this._getThemeColor(s),i.wholeTableStyle.borderHorizontalStyle="solid",i.wholeTableStyle.borderHorizontalWidth="1px",i.wholeTableStyle.borderVerticalColor=this._getThemeColor(s),i.wholeTableStyle.borderVerticalStyle="solid",i.wholeTableStyle.borderVerticalWidth="1px"),i},l.prototype._generateTableLightStyle2=function(e,t){var n=new o.TableStyle(t,!0),i=0===e?1:e+3;return n.wholeTableStyle={borderTopColor:this._getThemeColor(i),borderTopStyle:"solid",borderTopWidth:"1px",borderBottomColor:this._getThemeColor(i),borderBottomStyle:"solid",borderBottomWidth:"1px",borderLeftColor:this._getThemeColor(i),borderLeftStyle:"solid",borderLeftWidth:"1px",borderRightColor:this._getThemeColor(i),borderRightStyle:"solid",borderRightWidth:"1px",color:this._getThemeColor(1)},n.firstBandedRowStyle={borderTopColor:this._getThemeColor(i),borderTopStyle:"solid",borderTopWidth:"1px"},n.secondBandedRowStyle={borderTopColor:this._getThemeColor(i),borderTopStyle:"solid",borderTopWidth:"1px"},n.firstBandedColumnStyle={borderLeftColor:this._getThemeColor(i),borderLeftStyle:"solid",borderLeftWidth:"1px"},n.secondBandedColumnStyle={borderLeftColor:this._getThemeColor(i),borderLeftStyle:"solid",borderLeftWidth:"1px"},n.firstColumnStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.lastColumnStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.headerRowStyle={backgroundColor:this._getThemeColor(i),fontWeight:"bold",color:this._getThemeColor(0)},n.totalRowStyle={borderTopColor:this._getThemeColor(i),borderTopStyle:"double",borderTopWidth:"3px",fontWeight:"bold",color:this._getThemeColor(1)},n},l.prototype._generateTableMediumStyle1=function(e,t){var n=new o.TableStyle(t,!0),i=0===e?1:e+3;return n.wholeTableStyle={borderTopStyle:"solid",borderTopWidth:"1px",borderBottomStyle:"solid",borderBottomWidth:"1px",borderLeftStyle:"solid",borderLeftWidth:"1px",borderRightStyle:"solid",borderRightWidth:"1px",borderHorizontalStyle:"solid",borderHorizontalWidth:"1px",color:this._getThemeColor(1)},0===e?(n.wholeTableStyle.borderTopColor=this._getThemeColor(i),n.wholeTableStyle.borderBottomColor=this._getThemeColor(i),n.wholeTableStyle.borderLeftColor=this._getThemeColor(i),n.wholeTableStyle.borderRightColor=this._getThemeColor(i),n.wholeTableStyle.borderHorizontalColor=this._getThemeColor(i),n.firstBandedRowStyle={backgroundColor:this._getThemeColor(0,-.15)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(0,-.15)}):(n.wholeTableStyle.borderTopColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderBottomColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderLeftColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderRightColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderHorizontalColor=this._getThemeColor(i,.4),n.firstBandedRowStyle={backgroundColor:this._getThemeColor(i,.8)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(i,.8)}),n.firstColumnStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.lastColumnStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.headerRowStyle={backgroundColor:this._getThemeColor(i),fontWeight:"bold",color:this._getThemeColor(0)},n.totalRowStyle={borderTopColor:this._getThemeColor(i),borderTopStyle:"double",borderTopWidth:"3px",fontWeight:"bold",color:this._getThemeColor(1)},n},l.prototype._generateTableMediumStyle2=function(e,t){var n=new o.TableStyle(t,!0),i=0===e?1:e+3;return n.wholeTableStyle={borderVerticalStyle:"solid",borderVerticalWidth:"1px",borderVerticalColor:this._getThemeColor(0),borderHorizontalStyle:"solid",borderHorizontalWidth:"1px",borderHorizontalColor:this._getThemeColor(0),color:this._getThemeColor(1)},0===e?(n.wholeTableStyle.backgroundColor=this._getThemeColor(0,-.15),n.firstBandedRowStyle={backgroundColor:this._getThemeColor(0,-.35)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(0,-.35)}):(n.wholeTableStyle.backgroundColor=this._getThemeColor(i,.8),n.firstBandedRowStyle={backgroundColor:this._getThemeColor(i,.6)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(i,.6)}),n.firstColumnStyle={fontWeight:"bold",color:this._getThemeColor(0),backgroundColor:this._getThemeColor(i)},n.lastColumnStyle={fontWeight:"bold",color:this._getThemeColor(0),backgroundColor:this._getThemeColor(i)},n.headerRowStyle={borderBottomColor:this._getThemeColor(0),borderBottomStyle:"solid",borderBottomWidth:"3px",backgroundColor:this._getThemeColor(i),fontWeight:"bold",color:this._getThemeColor(0)},n.totalRowStyle={borderTopColor:this._getThemeColor(0),borderTopStyle:"solid",borderTopWidth:"3px",backgroundColor:this._getThemeColor(i),fontWeight:"bold",color:this._getThemeColor(0)},n},l.prototype._generateTableMediumStyle3=function(e,t){var n=new o.TableStyle(t,!0),i=0===e?1:e+3;return n.wholeTableStyle={borderTopStyle:"solid",borderTopWidth:"2px",borderTopColor:this._getThemeColor(1),borderBottomStyle:"solid",borderBottomWidth:"2px",borderBottomColor:this._getThemeColor(1),color:this._getThemeColor(1)},0===e&&(n.wholeTableStyle.borderLeftColor=this._getThemeColor(1),n.wholeTableStyle.borderLeftStyle="solid",n.wholeTableStyle.borderLeftWidth="1px",n.wholeTableStyle.borderRightColor=this._getThemeColor(1),n.wholeTableStyle.borderRightStyle="solid",n.wholeTableStyle.borderRightWidth="1px",n.wholeTableStyle.borderVerticalColor=this._getThemeColor(1),n.wholeTableStyle.borderVerticalStyle="solid",n.wholeTableStyle.borderVerticalWidth="1px",n.wholeTableStyle.borderHorizontalColor=this._getThemeColor(1),n.wholeTableStyle.borderHorizontalStyle="solid",n.wholeTableStyle.borderHorizontalWidth="1px"),n.firstBandedRowStyle={backgroundColor:this._getThemeColor(0,-.35)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(0,-.35)},n.firstColumnStyle={fontWeight:"bold",color:this._getThemeColor(0),backgroundColor:this._getThemeColor(i)},n.lastColumnStyle={fontWeight:"bold",color:this._getThemeColor(0),backgroundColor:this._getThemeColor(i)},n.headerRowStyle={borderBottomColor:this._getThemeColor(1),borderBottomStyle:"solid",borderBottomWidth:"2px",backgroundColor:this._getThemeColor(i),fontWeight:"bold",color:this._getThemeColor(0)},n.totalRowStyle={borderTopColor:this._getThemeColor(1),borderTopStyle:"double",borderTopWidth:"3px"},n},l.prototype._generateTableMediumStyle4=function(e,t){var n=new o.TableStyle(t,!0),i=0===e?1:e+3;return n.wholeTableStyle={borderTopStyle:"solid",borderTopWidth:"1px",borderBottomStyle:"solid",borderBottomWidth:"1px",borderLeftStyle:"solid",borderLeftWidth:"1px",borderRightStyle:"solid",borderRightWidth:"1px",borderVerticalStyle:"solid",borderVerticalWidth:"1px",borderHorizontalStyle:"solid",borderHorizontalWidth:"1px",color:this._getThemeColor(1)},0===e?(n.wholeTableStyle.borderTopColor=this._getThemeColor(i),n.wholeTableStyle.borderBottomColor=this._getThemeColor(i),n.wholeTableStyle.borderLeftColor=this._getThemeColor(i),n.wholeTableStyle.borderRightColor=this._getThemeColor(i),n.wholeTableStyle.borderVerticalColor=this._getThemeColor(i),n.wholeTableStyle.borderHorizontalColor=this._getThemeColor(i),n.wholeTableStyle.backgroundColor=this._getThemeColor(0,-.15),n.firstBandedRowStyle={backgroundColor:this._getThemeColor(0,-.35)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(0,-.35)}):(n.wholeTableStyle.borderTopColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderBottomColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderLeftColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderRightColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderVerticalColor=this._getThemeColor(i,.4),n.wholeTableStyle.borderHorizontalColor=this._getThemeColor(i,.4),n.wholeTableStyle.backgroundColor=this._getThemeColor(i,.8),n.firstBandedRowStyle={backgroundColor:this._getThemeColor(i,.6)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(i,.6)}),n.firstColumnStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.lastColumnStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.headerRowStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.totalRowStyle={borderTopColor:this._getThemeColor(i),borderTopStyle:"solid",borderTopWidth:"2px",fontWeight:"bold",color:this._getThemeColor(1)},n},l.prototype._generateTableDarkStyle1=function(e,t){var n=new o.TableStyle(t,!0),i=0===e?1:e+3,s=0===e?.25:-.25;return n.wholeTableStyle={color:this._getThemeColor(0)},n.firstBandedRowStyle={backgroundColor:this._getThemeColor(i,s)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(i,s)},n.firstColumnStyle={borderRightColor:this._getThemeColor(0),borderRightStyle:"solid",borderRightWidth:"2px",fontWeight:"bold",color:this._getThemeColor(0),backgroundColor:this._getThemeColor(i,s)},n.lastColumnStyle={borderLeftColor:this._getThemeColor(0),borderLeftStyle:"solid",borderLeftWidth:"2px",fontWeight:"bold",color:this._getThemeColor(0),backgroundColor:this._getThemeColor(i,s)},n.headerRowStyle={borderBottomColor:this._getThemeColor(0),borderBottomStyle:"solid",borderBottomWidth:"2px",fontWeight:"bold",color:this._getThemeColor(0),backgroundColor:this._getThemeColor(1)},n.totalRowStyle={borderTopColor:this._getThemeColor(0),borderTopStyle:"solid",borderTopWidth:"2px",fontWeight:"bold",color:this._getThemeColor(0)},0===e?(n.wholeTableStyle.backgroundColor=this._getThemeColor(i,.5),n.totalRowStyle.backgroundColor=this._getThemeColor(i,.15)):(n.wholeTableStyle.backgroundColor=this._getThemeColor(i),n.totalRowStyle.backgroundColor=this._getThemeColor(i,-.5)),n},l.prototype._generateTableDarkStyle2=function(e,t){var n=new o.TableStyle(t,!0),i=0===e?0:2*e+2,s=0===e?1:2*e+3,l=0===e?-.15:.8;return n.wholeTableStyle={backgroundColor:this._getThemeColor(i,l)},n.firstBandedRowStyle={backgroundColor:this._getThemeColor(i,l-.2)},n.firstBandedColumnStyle={backgroundColor:this._getThemeColor(i,l-.2)},n.firstColumnStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.lastColumnStyle={fontWeight:"bold",color:this._getThemeColor(1)},n.headerRowStyle={color:this._getThemeColor(0),backgroundColor:this._getThemeColor(s)},n.totalRowStyle={borderTopColor:this._getThemeColor(1),borderTopStyle:"double",borderTopWidth:"3px",fontWeight:"bold",color:this._getThemeColor(1)},n},l.controlTemplate='<div style="width:100%;height:100%"><div wj-part="container" style="width:100%">'+t.FlexGrid.controlTemplate+'</div><div wj-part="tab-holder" class="wj-tabholder" style="width:100%; min-width:100px"></div><div wj-part="context-menu" style="display:none;z-index:100"></div></div>',l}(t.FlexGrid);o.FlexSheet=i;var s=function(e){function t(t,o){var n=e.call(this)||this;return n._isDraggingRows=t,n._isShiftKey=o,n}return __extends(t,e),Object.defineProperty(t.prototype,"isDraggingRows",{get:function(){return this._isDraggingRows},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isShiftKey",{get:function(){return this._isShiftKey},enumerable:!0,configurable:!0}),t}(e.EventArgs);o.DraggingRowColumnEventArgs=s;var l=function(e){function t(t,o){var n=e.call(this)||this;return n._funcName=t,n._params=o,n}return __extends(t,e),Object.defineProperty(t.prototype,"funcName",{get:function(){return this._funcName},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"params",{get:function(){return this._params},enumerable:!0,configurable:!0}),t}(e.EventArgs);o.UnknownFunctionEventArgs=l;var r=function(t){function o(e,o,n){var i=t.call(this)||this;return i._index=e,i._count=o,i._added=n,i}return __extends(o,t),Object.defineProperty(o.prototype,"index",{get:function(){return this._index},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"count",{get:function(){return this._count},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"added",{get:function(){return this._added},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"isAdd",{get:function(){return e._deprecated("RowColumnChangedEventArgs.isAdd","RowColumnChangedEventArgs.added"),this._added},enumerable:!0,configurable:!0}),o}(e.EventArgs);o.RowColumnChangedEventArgs=r;var a=function(o){function n(e,t,n,i,s){return o.call(this,e,t,n,i,s)||this}return __extends(n,o),n.prototype.getSelectedState=function(e,n,i){var s,l,r,a,h,c;if(this.grid){if(c=this.grid.getMergedRange(this,e,n),s=this.grid.selectedSheet?this.grid.selectedSheet.selectionRanges:null,h=o.prototype.getSelectedState.call(this,e,n,i),l=s?s.length:0,h===t.SelectedState.None&&l>0)for(r=0;r<s.length;r++)if((a=s[r])&&a instanceof t.CellRange){if(this.cellType===t.CellType.Cell){if(c){if(c.contains(a.row,a.col))return r!==l-1||this.grid._isClicking?t.SelectedState.Selected:this.grid.showMarquee?t.SelectedState.None:t.SelectedState.Cursor;if(c.intersects(a))return t.SelectedState.Selected}if(a.row===e&&a.col===n)return r!==l-1||this.grid._isClicking?t.SelectedState.Selected:this.grid.showMarquee?t.SelectedState.None:t.SelectedState.Cursor;if(a.contains(e,n))return t.SelectedState.Selected}if(this.grid.showSelectedHeaders&t.HeadersVisibility.Row&&this.cellType===t.CellType.RowHeader&&a.containsRow(e))return t.SelectedState.Selected;if(this.grid.showSelectedHeaders&t.HeadersVisibility.Column&&this.cellType===t.CellType.ColumnHeader&&a.containsColumn(n))return t.SelectedState.Selected}return h}},n.prototype.getCellData=function(t,n,i){var s,l,r,a,h;if(e.isString(n)&&(n=this.columns.indexOf(n))<0)throw"Invalid column name or binding.";return t>=this.rows.length||e.asNumber(n,!1,!0)>=this.columns.length?null:(s=o.prototype.getCellData.call(this,t,n,i),l=this.columns[e.asNumber(n,!1,!0)],r=this.grid?this.grid._getBindingColumn(this,t,l):l,i&&(h=o.prototype.getCellData.call(this,t,n,!1),a=this.grid?this.grid._getCellStyle(t,n):null,!e.isNumber(h)||0===h||!r||r.format||r.dataMap||a||(s=h.toString())),s)},n.prototype.setCellData=function(t,n,i,s,l){void 0===s&&(s=!0),void 0===l&&(l=!0);var r,a=this.getCellData(t,n,!1),h=this.grid._isPasting;return s&&i&&e.isString(i)&&"'"!==i[0]&&(this.grid.columns[n].dataType===e.DataType.String||e.isNullOrWhiteSpace(i)||isNaN(+i)?this.grid.columns[n].dataType===e.DataType.Boolean?i=e.changeType(i,e.DataType.Boolean,null):"="!==i[0]&&(r=e.Globalize.parseDate(i,""))&&(i=r):i=+i),(i&&e.isString(i)&&("="===i[0]||"'"===i[0])||e.isString(a))&&(s=!1),o.prototype.setCellData.call(this,t,n,i,s&&!h,l)},n.prototype._renderCell=function(t,n,i,s,l,r){var a,h,c,d,u=n*this.grid.columns.length+i,_=this.grid.getMergedRange(this,n,i);return d=o.prototype._renderCell.call(this,t,n,i,s,l,r),this.cellType!==e.grid.CellType.Cell?d:_&&u>_.topRow*this.grid.columns.length+_.leftCol?d:((a=t.childNodes[r])&&(null!=this.grid.editRange&&this.grid.editRange.contains(n,i)||this.grid.selectedSheet&&(c=this.grid.selectedSheet.findTable(n,i))&&c._updateCell(n,i,a),e.hasClass(a,"wj-state-selected")||e.hasClass(a,"wj-state-multi-selected")?(a.style.backgroundColor="",a.style.color=""):this.grid.selectedSheet&&(h=this.grid.selectedSheet._styledCells[u])&&(""!==h.backgroundColor&&(a.style.backgroundColor=h.backgroundColor),""!==h.color&&(a.style.color=h.color))),d)},n}(t.GridPanel);o.FlexSheetPanel=a;var h=function(e){function t(){var t=e.call(this)||this;return t.isReadOnly=!0,t}return __extends(t,e),t}(t.Row);o.HeaderRow=h;var c=function(){function e(e,t,o,n){if(this._owner=e,this._name=t,this._value=o,null!=n){if(!e._validateSheetName(n))throw"The sheet name:("+n+") does not exist in FlexSheet.";this._sheetName=n}}return Object.defineProperty(e.prototype,"name",{get:function(){return this._name},set:function(e){var t;if(this._name!==e){if(this._owner._checkExistDefinedName(name,this._sheetName))throw"The "+name+" already existed in definedNames.";t=this._name,this._name=e,this._owner._updateFormulasWithNameUpdating(t,this._name)}},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"value",{get:function(){return this._value},set:function(e){this._value!==e&&(this._value=e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"sheetName",{get:function(){return this._sheetName},enumerable:!0,configurable:!0}),e}();o.DefinedName=c}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(){function n(t,n,i,s,r){this._visible=!0,this._unboundSortDesc=new e.collections.ObservableArray,this._currentStyledCells={},this._currentMergedRanges={},this._isEmptyGrid=!1,this._rowSettings=[],this._scrollPosition=new e.Point,this._freezeHiddenRowCnt=0,this._freezeHiddenColumnCnt=0,this.nameChanged=new e.Event,this.visibleChanged=new e.Event;var a=this;a._owner=t,a._name=i,e.isNumber(s)&&!isNaN(s)&&s>=0?a._rowCount=s:a._rowCount=200,e.isNumber(r)&&!isNaN(r)&&r>=0?a._columnCount=r:a._columnCount=20,a._grid=n||this._createGrid(),a._grid.itemsSourceChanged.addHandler(this._gridItemsSourceChanged,this),a._addHeaderRow(),a._unboundSortDesc.collectionChanged.addHandler(function(){var t,o,n=a._unboundSortDesc;for(t=0;t<n.length;t++)if(!e.tryCast(n[t],l))throw"sortDescriptions array must contain SortDescription objects.";if(a._owner){if(a._owner.rows.beginUpdate(),a._owner.rows.sort(a._compareRows()),!a._owner._isUndoing)for(t=0;t<a._owner.rows.length;t++)t!==(o=a._owner.rows[t])._idx&&a._owner._updateFormulaForReorderingRows(o._idx,t);a._owner.rows.endUpdate(),a._owner.rows._dirty=!0,a._owner.rows._update(),a._owner.selectedSheet&&(a._owner._copyTo(a._owner.selectedSheet),a._owner._copyFrom(a._owner.selectedSheet))}}),a.tables.collectionChanged.addHandler(function(t,n){if(null!=n.item&&!(n.item instanceof o.Table))throw"The tables only allows to handle Table instance.";if(n.action===e.collections.NotifyCollectionChangedAction.Add||n.action===e.collections.NotifyCollectionChangedAction.Change){if(n.item){var i=void 0,s=void 0,l=n.item,r=l.getRange(),h=a===a._owner.selectedSheet?a._owner:a.grid;try{if(r.topRow>=h.rows.length||r.leftCol>=h.columns.length)throw"";if(r.leftCol+r.columnSpan>h.columns.length)throw"";if(r.topRow+r.rowSpan>h.rows.length)throw"";for(i=r.topRow;i<=r.bottomRow;i++)for(s=r.leftCol;s<=r.rightCol;s++)if(a.findTable(i,s)!==l)throw"";l._attachSheet(a)}catch(e){a.tables.removeAt(n.index)}}}else n.action===e.collections.NotifyCollectionChangedAction.Remove&&n.item&&n.item._detachSheet()})}return Object.defineProperty(n.prototype,"grid",{get:function(){return null==this._grid.wj_sheetInfo&&(this._grid.wj_sheetInfo={}),this._grid},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"name",{get:function(){return this._name},set:function(t){if(!e.isNullOrWhiteSpace(t)&&(this._name&&this._name.toLowerCase()!==t.toLowerCase()||!this._name)){var o=new e.PropertyChangedEventArgs("sheetName",this._name,t);this._name=t,this.grid.wj_sheetInfo.name=t,this.onNameChanged(o)}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"visible",{get:function(){return this._visible},set:function(t){this._visible!==t&&(this._visible=t,this.grid.wj_sheetInfo.visible=t,this.onVisibleChanged(new e.EventArgs))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"rowCount",{get:function(){return null!=this._grid?this._grid.rows.length:0},set:function(o){var n;if(!this.itemsSource&&e.isNumber(o)&&!isNaN(o)&&o>=0&&this._rowCount!==o){if(this._rowCount<o)for(n=0;n<o-this._rowCount;n++)this.grid.rows.push(new t.Row);else this.grid.rows.splice(o,this._rowCount-o);this._rowCount=o,this._owner&&this._owner.selectedSheet&&this._name===this._owner.selectedSheet.name&&this._owner._copyFrom(this,!0)}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"columnCount",{get:function(){return null!=this._grid?this._grid.columns.length:0},set:function(o){var n;if(!this.itemsSource&&e.isNumber(o)&&!isNaN(o)&&o>=0&&this._columnCount!==o){if(this._columnCount<o)for(n=0;n<o-this._columnCount;n++)this._grid.columns.push(new t.Column);else this._grid.columns.splice(o,this._columnCount-o);this._columnCount=o,this._owner&&this._owner.selectedSheet&&this._name===this._owner.selectedSheet.name&&this._owner._copyFrom(this,!0)}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectionRanges",{get:function(){var o=this;return this._selectionRanges||(this._selectionRanges=new e.collections.ObservableArray,this._selectionRanges.collectionChanged.addHandler(function(){var e,n;o._owner&&!o._owner._isClicking&&((e=o._selectionRanges.length)>0&&(n=o._selectionRanges[e-1])&&n instanceof t.CellRange&&(o._owner.selection=n),e>1?(o._owner._enableMulSel=!0,o._owner.refresh(!1)):o._owner.refresh(),o._owner._enableMulSel=!1)},this)),this._selectionRanges},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"itemsSource",{get:function(){return null!=this._grid?this._grid.itemsSource:null},set:function(e){var t=this;null==t._grid&&(t._createGrid(),t._grid.itemsSourceChanged.addHandler(t._gridItemsSourceChanged,t)),t._isEmptyGrid&&t._clearGrid(),t._grid.loadedRows.addHandler(function(){t._addHeaderRow()}),t._grid.itemsSource=e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"tables",{get:function(){return null==this._tables&&(this._tables=new e.collections.ObservableArray),this._tables},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"_styledCells",{get:function(){return this._currentStyledCells||(this._currentStyledCells={}),this._currentStyledCells},set:function(e){this._currentStyledCells=e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"_mergedRanges",{get:function(){return this._currentMergedRanges||(this._currentMergedRanges={}),this._currentMergedRanges},set:function(e){this._currentMergedRanges=e},enumerable:!0,configurable:!0}),n.prototype.onNameChanged=function(e){this.nameChanged.raise(this,e)},n.prototype.onVisibleChanged=function(e){this.visibleChanged.raise(this,e)},n.prototype.getCellStyle=function(e,t){var o,n=this._grid.rows.length,i=this._grid.columns.length;return e>=n||t>=i?null:(o=e*i+t,this._styledCells[o])},n.prototype.addTableFromArray=function(n,i,s,l,r,a,h,c){void 0===c&&(c=!0);var d,u,_,g,f,p,w,m,C,b,y,S=!1,v=this===this._owner.selectedSheet?this._owner:this.grid;if(null==s||0===s.length)throw"Invalid array to load.";if(!(null!=l&&0!==l.length||null!=(l=Object.keys(s[0]))&&0!==l.length))throw"Invalid array to load.";if(n>=this.rowCount||i>=this.columnCount)return null;var R=null==(h&&h.showHeaderRow)||h.showHeaderRow,x=!(!h||!h.showTotalRow),T=n+(R?1:0),k=T+s.length-1+(x?1:0);for(d=[],C=0;C<l.length;C++)b=l[C],u=new o.TableColumn(b),0===C?u._totalRowLabel="Total":C===l.length-1&&(u._totalRowFunction="Sum"),d.push(u);if(_=new t.CellRange(n,i,k,i+l.length-1),0!==(g=this._needShiftForTable(_))){if(!c)return null;if(!this._canShiftCells(_))return null;if(f=this._needAddRowCountForAddTable(g,_),v.collectionView){for(y=v.itemsSource instanceof e.collections.CollectionView,v.collectionView.beginUpdate(),w=0;w<f;w++)y?v.itemsSource.souceCollection.push({}):v.itemsSource.push({});v.collectionView.endUpdate()}else for(w=0;w<f;w++)v.rows.push(new t.Row);S=!0}if(i+l.length>=v.columns.length){if(!c)return null;if(p=i+l.length-v.columns.length+1,this.itemsSource&&p>0)return null;for(v.columns.beginUpdate(),w=0;w<p;w++)v.columns.push(new t.Column);v.columns.endUpdate()}if(v.beginUpdate(),S&&this._moveDownCells(g,_),R)for(C=0;C<l.length;C++)b=l[C],v.setCellData(n,i+C,b);for(m=0;m<s.length;m++)for(C=0;C<l.length;C++)b=l[C],v.setCellData(T+m,i+C,s[m][b]);return v.endUpdate(),this._addTable(_,r,a,d,h)},n.prototype.findTable=function(e,t){var o,n;if(this._tables&&this._tables.length>0)for(var i=0;i<this._tables.length;i++)if(o=this._tables[i],n=o.getRange(),e>=n.topRow&&e<=n.bottomRow&&t>=n.leftCol&&t<=n.rightCol)return o;return null},n.prototype._attachOwner=function(e){this._owner!==e&&(this._owner=e)},n.prototype._setValidName=function(e){this._name=e,this.grid.wj_sheetInfo.name=e},n.prototype._storeRowSettings=function(){var e,o=0;for(this._rowSettings=[];o<this._grid.rows.length;o++)(e=this._owner.rows[o])&&(this._rowSettings[o]={height:e.height,allowMerging:e.allowMerging,isCollapsed:e instanceof t.GroupRow?e.isCollapsed:null,visible:e.visible})},n.prototype._setRowSettings=function(){for(var e,o,n=0;n<this._rowSettings.length;n++)(o=this._rowSettings[n])&&(e=this._grid.rows[n])&&(e.height=o.height,e.allowMerging=o.allowMerging,e.visible=o.visible,e instanceof t.GroupRow&&(e.isCollapsed=!!o.isCollapsed))},n.prototype._addTable=function(e,t,n,i,s){var l;return null!=t&&null==this._owner._getTable(t)||(t=this._getUniqueTableName()),l=new o.Table(t,e,n,i,s),this.tables.push(l),l},n.prototype._compareRows=function(){var t=this,o=this._unboundSortDesc;return function(n,i){for(var s=0;s<o.length;s++){var l=o[s],r=n._ubv&&l.column?n._ubv[l.column._hash]:"",a=i._ubv&&l.column?i._ubv[l.column._hash]:"";if(e.isString(r)&&"="===r[0]&&(r=t._owner.evaluate(r)),e.isString(a)&&"="===a[0]&&(a=t._owner.evaluate(a)),r!==r&&(r=null),a!==a&&(a=null),e.isString(r)&&(r=r.toLowerCase()+r),e.isString(a)&&(a=a.toLowerCase()+a),""===r||null==r)return 1;if(""===a||null==a)return-1;var h=r<a?-1:r>a?1:0;if(e.isString(r)&&e.isNumber(a)&&(h=1),e.isString(a)&&e.isNumber(r)&&(h=-1),0!==h)return l.ascending?+h:-h}return 0}},n.prototype._createGrid=function(){var e,o,n,i,s=document.createElement("div");for(this._isEmptyGrid=!0,s.style.visibility="hidden",document.body.appendChild(s),e=new t.FlexGrid(s),document.body.removeChild(s),i=0;i<this._rowCount;i++)e.rows.push(new t.Row);for(n=0;n<this._columnCount;n++)(o=new t.Column).isRequired=!1,e.columns.push(o);return e.wj_sheetInfo={name:this.name,visible:this.visible,styledCells:this._styledCells,mergedRanges:this._mergedRanges},e},n.prototype._clearGrid=function(){this._grid.rows.clear(),this._grid.columns.clear(),this._grid.columnHeaders.columns.clear(),this._grid.rowHeaders.rows.clear()},n.prototype._gridItemsSourceChanged=function(){var e=this;e._owner._isCopying||e._owner&&e._owner.selectedSheet&&e._name===e._owner.selectedSheet.name&&(e._owner.filter.clear(),e._owner._copyFrom(e,!1),setTimeout(function(){e._owner._setFlexSheetToDirty(),e._owner.invalidate()},10))},n.prototype._addHeaderRow=function(){if(this._grid.itemsSource&&!(this._grid.rows[0]instanceof o.HeaderRow)){for(var e,t=new o.HeaderRow,n=0;n<this._grid.columns.length;n++)e=this._grid.columns[n],t._ubv||(t._ubv={}),t._ubv[e._hash]=e.header;this._grid.rows.insert(0,t)}},n.prototype._getUniqueTableName=function(){for(var e="Table1",t=2;;){if(null==this._owner._getTable(e))break;e="Table"+t,t+=1}return e},n.prototype._needShiftForTable=function(e){var t,o,n,i=0,s=0,l=this===this._owner.selectedSheet?this._owner:this.grid;for(t=e.topRow;t<=e.bottomRow;t++){if(t>=l.rows.length)return i=e.rowSpan-s;for(o=e.leftCol;o<=e.rightCol&&o<l.columns.length;o++)if(null!=(n=l.getCellData(t,o,!1))&&""!==n)return i=e.rowSpan-s;s++}return i},n.prototype._needAddRowCountForAddTable=function(e,t){var o,n,i,s,l,r=this===this._owner.selectedSheet?this._owner:this.grid;for(o=1;o<=e;o++)for(n=r.rows.length-o,i=t.leftCol;i<=t.rightCol&&i<r.columns.length;i++)if(s=r.getCellData(n,i,!1),l=this.getCellStyle(n,i),null!=s&&""!==s||null!=l)return e-o+1;return 0},n.prototype._moveDownTable=function(e){var t,o,n,i,s=e.getRange(),l=this===this._owner.selectedSheet?this._owner:this.grid;for(t=s.bottomRow;t>=s.topRow;t--)for(o=s.leftCol;o<=s.rightCol;o++)i=null!=l.columns[o].dataMap,n=l.getCellData(t,o,i),l.setCellData(t+1,o,n),l.setCellData(t,o,"");e._updateTableRange(1,1,0,0)},n.prototype._moveDownCells=function(e,t){var o,n,i,s,l,r,a,h,c,d,u=this===this._owner.selectedSheet?this._owner:this.grid;for(o=u.rows.length-1-e;o>=t.topRow;o--)for(n=t.leftCol;n<=t.rightCol&&n<u.columns.length;n++)d=null!=u.columns[n].dataMap,i=u.getCellData(o,n,d),u.setCellData(o+e,n,i),u.setCellData(o,n,""),s=this.getCellStyle(o,n),r=(o+e)*u.columns.length+n,l=o*u.columns.length+n,s&&(this._styledCells[r]=s,this._styledCells[l]=null),(a=this._mergedRanges[l])&&(a.row+=e,a.row2+=e,this._mergedRanges[r]=a,this._mergedRanges[l]=null),(h=this.findTable(o,n))&&(c=h.getRange()).topRow===o&&c.leftCol===n&&h._updateTableRange(e,e,0,0)},n.prototype._moveUpCells=function(e,t){var o,n,i,s,l,r,a,h,c,d,u=this===this._owner.selectedSheet?this._owner:this.grid;for(o=t.topRow;o<u.rows.length;o++)for(n=t.leftCol;n<=t.rightCol&&n<u.columns.length;n++)d=null!=u.columns[n].dataMap,i=u.getCellData(o,n,d),u.setCellData(o-e,n,i),u.setCellData(o,n,""),s=this.getCellStyle(o,n),r=(o-e)*u.columns.length+n,l=o*u.columns.length+n,s&&(this._styledCells[r]=s,this._styledCells[l]=null),(a=this._mergedRanges[l])&&(a.row-=e,a.row2-=e,this._mergedRanges[r]=a,this._mergedRanges[l]=null),(h=this.findTable(o,n))&&(c=h.getRange()).topRow===o&&c.leftCol===n&&h._updateTableRange(-e,-e,0,0)},n.prototype._moveDownCellsWithinTable=function(e,t,o){var n,i,s,l,r=this===this._owner.selectedSheet?this._owner:this.grid;for(n=o.bottomRow;n>o.topRow+e;n--)for(i=o.leftCol;i<=o.rightCol;i++)l=null!=r.columns[i].dataMap,s=r.getCellData(n,i,l),r.setCellData(n+t,i,s),r.setCellData(n,i,""),(n+t)*r.columns.length+i,n*r.columns.length+i},n.prototype._moveUpCellsWithinTable=function(e,t,o){var n,i,s,l,r=o.topRow+e,a=this===this._owner.selectedSheet?this._owner:this.grid;for(n=r;n<=o.bottomRow;n++)for(i=o.leftCol;i<=o.rightCol;i++)n>=r+t&&(l=null!=a.columns[i].dataMap,s=a.getCellData(n,i,l),a.setCellData(n-t,i,s)),a.setCellData(n,i,""),(n-t)*a.columns.length+i,n*a.columns.length+i},n.prototype._canShiftCells=function(e){var t,o,n,i,s,l,r=this===this._owner.selectedSheet?this._owner:this.grid;for(t=e.topRow;t<r.rows.length;t++)for(o=e.leftCol;o<=e.rightCol&&o<r.columns.length;o++){if((s=this.findTable(t,o))&&((l=s.getRange()).leftCol<e.leftCol||l.rightCol>e.rightCol))return!1;if(n=t*r.columns.length+o,(i=this._mergedRanges[n])&&(i.leftCol<e.leftCol||i.rightCol>e.rightCol))return!1}return!0},n.prototype._needMoveDownTable=function(e){var t,o,n=e.getRange(),i=e.getColumns(),s=this===this._owner.selectedSheet?this._owner:this.grid;if(0===n.topRow)return!0;for(t=0;t<i.length;t++)if(null!=(o=s.getCellData(n.topRow-1,n.leftCol+t,!1))&&""!==o)return!0;return!1},n.prototype._needAddRowCountForInsertTableRows=function(e,t){var o,n,i,s,l,r=this===this._owner.selectedSheet?this._owner:this.grid;for(o=1;o<=e;o++){if((n=r.rows.length-o)<=t.bottomRow)return e;for(i=t.leftCol;i<=t.rightCol&&i<r.columns.length;i++)if(s=r.getCellData(n,i,!1),l=this.getCellStyle(n,i),null!=s&&""!==s||null!=l)return e-o+1}return 0},n}();o.Sheet=n;var i=function(t){function o(){var o=null!==t&&t.apply(this,arguments)||this;return o._current=-1,o.sheetCleared=new e.Event,o.selectedSheetChanged=new e.Event,o.sheetNameChanged=new e.Event,o.sheetVisibleChanged=new e.Event,o}return __extends(o,t),o.prototype.onSheetCleared=function(){this.sheetCleared.raise(this,new e.EventArgs)},Object.defineProperty(o.prototype,"selectedIndex",{get:function(){return this._current},set:function(e){this._moveCurrentTo(+e)},enumerable:!0,configurable:!0}),o.prototype.onSelectedSheetChanged=function(e){this.selectedSheetChanged.raise(this,e)},o.prototype.insert=function(e,o){var n;(n=o.name?this.getValidSheetName(o):this._getUniqueName())!==o.name&&(o.name=n),t.prototype.insert.call(this,e,o),this._postprocessSheet(o)},o.prototype.push=function(){for(var e=[],o=0;o<arguments.length;o++)e[o]=arguments[o];this.length;for(var n,i=0;i<e.length;i++)(n=e[i].name?this.getValidSheetName(e[i]):this._getUniqueName())!==e[i].name&&(e[i].name=n),t.prototype.push.call(this,e[i]),this._postprocessSheet(e[i]);return this.length},o.prototype.splice=function(e,o,n){var i;return n?((i=n.name?this.getValidSheetName(n):this._getUniqueName())!==n.name&&(n.name=i),this._postprocessSheet(n),t.prototype.splice.call(this,e,o,n)):t.prototype.splice.call(this,e,o,n)},o.prototype.removeAt=function(e){this.hide(e)&&(t.prototype.removeAt.call(this,e),e<this.selectedIndex&&(this._current-=1))},o.prototype.onSheetNameChanged=function(e){this.sheetNameChanged.raise(this,e)},o.prototype.onSheetVisibleChanged=function(e){this.sheetVisibleChanged.raise(this,e)},o.prototype.selectFirst=function(){return this._moveCurrentTo(0)},o.prototype.selectLast=function(){return this._moveCurrentTo(this.length-1)},o.prototype.selectPrevious=function(){return this._moveCurrentTo(this._current-1)},o.prototype.selectNext=function(){return this._moveCurrentTo(this._current+1)},o.prototype.hide=function(e){return!(e<0&&e>=this.length)&&(!!this[e].visible&&(this[e].visible=!1,!0))},o.prototype.show=function(e){return!(e<0&&e>=this.length)&&(this[e].visible=!0,this._moveCurrentTo(e),!0)},o.prototype.clear=function(){t.prototype.clear.call(this),this._current=-1,this.onSheetCleared()},o.prototype.isValidSheetName=function(e){var t=this._getSheetIndexFrom(e.name),o=this.indexOf(e);return-1===t||t===o},o.prototype.getValidSheetName=function(e){for(var t,o=e.name,n=1,i=this.indexOf(e);;){if(-1===(t=this._getSheetIndexFrom(o))||t===i)break;o=e.name.concat((n+1).toString()),n+=1}return o},o.prototype._moveCurrentTo=function(t){var o,n=t;if(t<0||t>=this.length)return!1;if(this._current<n||0===n)for(;n<this.length&&!this[n].visible;)n++;else if(this._current>n)for(;n>=0&&!this[n].visible;)n--;if(n===this.length)for(n=t;n>=0&&!this[n].visible;)n--;return!(n<0)&&(n!==this._current&&(o=new e.PropertyChangedEventArgs("sheetIndex",this._current,n),this._current=n,this.onSelectedSheetChanged(o)),!0)},o.prototype._getSheetIndexFrom=function(e){var t;if(!e)return-1;e=e.toLowerCase();for(var o=0;o<this.length;o++)if(t=this[o],(t.name?t.name.toLowerCase():"")===e)return o;return-1},o.prototype._postprocessSheet=function(t){var o=this;t.nameChanged.addHandler(function(){var n,i=o._getSheetIndexFrom(t.name);o.isValidSheetName(t)||t._setValidName(o.getValidSheetName(t)),n=new e.collections.NotifyCollectionChangedEventArgs(e.collections.NotifyCollectionChangedAction.Change,t,e.isNumber(i)?i:o.length-1),o.onSheetNameChanged(n)}),t.visibleChanged.addHandler(function(){var n=o._getSheetIndexFrom(t.name),i=new e.collections.NotifyCollectionChangedEventArgs(e.collections.NotifyCollectionChangedAction.Change,t,e.isNumber(n)?n:o.length-1);o.onSheetVisibleChanged(i)})},o.prototype._getUniqueName=function(){for(var e="Sheet1",t=2;;){if(-1===this._getSheetIndexFrom(e))break;e="Sheet"+t,t+=1}return e},o}(e.collections.ObservableArray);o.SheetCollection=i;var s=function(o){function n(e,t,n){var i=o.call(this,e,n)||this;i._rtl=!1,i._sheetTabClicked=!1;var s=i;return s._owner=t,s._sheets=t.sheets,s._rtl="rtl"==getComputedStyle(s._owner.hostElement).direction,s._initControl(),s.deferUpdate(function(){n&&s.initialize(n)}),i}return __extends(n,o),n.prototype.refresh=function(e){this._tabContainer.innerHTML="",this._tabContainer.innerHTML=this._getSheetTabs(),this._rtl&&this._adjustSheetsPosition(),this._adjustSize()},n.prototype._sourceChanged=function(t,o){void 0===o&&(o=e.collections.NotifyCollectionChangedEventArgs.reset);var n=o;switch(n.action){case e.collections.NotifyCollectionChangedAction.Add:n.index-1<0&&0,this._tabContainer.innerHTML="",this._tabContainer.innerHTML=this._getSheetTabs(),this._rtl&&this._adjustSheetsPosition(),this._adjustSize();break;case e.collections.NotifyCollectionChangedAction.Remove:this._tabContainer.removeChild(this._tabContainer.children[n.index]),this._tabContainer.hasChildNodes()&&this._updateTabActive(n.index,!0),this._adjustSize();break;default:this.invalidate()}},n.prototype._selectedSheetChanged=function(e,t){this._updateTabActive(t.oldValue,!1),this._updateTabActive(t.newValue,!0),this._sheetTabClicked?this._sheetTabClicked=!1:this._scrollToActiveSheet(t.newValue,t.oldValue),this._adjustSize()},n.prototype._initControl=function(){var e=this;e.applyTemplate("",e.getTemplate(),{_sheetContainer:"sheet-container",_tabContainer:"container",_sheetPage:"sheet-page",_newSheet:"new-sheet"}),e._rtl&&(e._sheetPage.style.right="0px",e._tabContainer.parentElement.style.right=e._sheetPage.clientWidth+"px",e._tabContainer.style.right="0px",e._tabContainer.style.cssFloat="right",e._newSheet.style.right=e._sheetPage.clientWidth+e._tabContainer.parentElement.clientWidth+"px"),e._adjustNavigationButtons(e._rtl),e.addEventListener(e._newSheet,"click",function(t){var o=e._owner.selectedSheetIndex;e._owner.addUnboundSheet(),e._scrollToActiveSheet(e._owner.selectedSheetIndex,o)}),e._sheets.collectionChanged.addHandler(e._sourceChanged,e),e._sheets.selectedSheetChanged.addHandler(e._selectedSheetChanged,e),e._sheets.sheetNameChanged.addHandler(e._updateSheetName,e),e._sheets.sheetVisibleChanged.addHandler(e._updateTabShown,e),e._initSheetPage(),e._initSheetTab()},n.prototype._initSheetTab=function(){var e=this;e.addEventListener(e._tabContainer,"mousedown",function(t){var o,n=t.target;n instanceof HTMLLIElement&&(e._sheetTabClicked=!0,o=e._getItemIndex(e._tabContainer,n),e._scrollSheetTabContainer(n),o>-1&&(e._sheets.selectedIndex=o))})},n.prototype._initSheetPage=function(){var e=this;e.hostElement.querySelector("div.wj-sheet-page").addEventListener("click",function(t){var o="[object HTMLButtonElement]"===t.target.toString()?t.target:t.target.parentElement,n=e._getItemIndex(e._sheetPage,o);if(0!==e._sheets.length)switch(n){case 0:e._sheets.selectFirst();break;case 1:e._sheets.selectPrevious();break;case 2:e._sheets.selectNext();break;case 3:e._sheets.selectLast()}})},n.prototype._getSheetTabs=function(){var e,t="";for(e=0;e<this._sheets.length;e++)t+=this._getSheetElement(this._sheets[e],this._sheets.selectedIndex===e);return t},n.prototype._getSheetElement=function(e,t){void 0===t&&(t=!1);var o="<li";return e.visible?t&&(o+=' class="active"'):o+=' class="hidden"',o+=">"+e.name+"</li>"},n.prototype._updateTabActive=function(t,o){t<0||t>=this._tabContainer.children.length||(o?e.addClass(this._tabContainer.children[t],"active"):e.removeClass(this._tabContainer.children[t],"active"))},n.prototype._updateTabShown=function(t,o){o.index<0||o.index>=this._tabContainer.children.length||(o.item.visible?e.removeClass(this._tabContainer.children[o.index],"hidden"):e.addClass(this._tabContainer.children[o.index],"hidden"),this._adjustSize())},n.prototype._adjustSize=function(){var e,t,o=this._tabContainer.childElementCount,n=0,i=0;if("none"!==this.hostElement.style.display){for(i=this._tabContainer.parentElement.scrollLeft,this._tabContainer.parentElement.style.width="",this._tabContainer.style.width="",this._sheetPage.parentElement.style.width="",e=0;e<o;e++)n+=this._tabContainer.children[e].offsetWidth+1;t=this.hostElement.offsetWidth-this._sheetPage.offsetWidth-this._newSheet.offsetWidth-2,this._tabContainer.parentElement.style.width=(n>t?t:n)+"px",this._tabContainer.style.width=n+"px",this._sheetPage.parentElement.style.width=this._sheetPage.offsetWidth+this._newSheet.offsetWidth+this._tabContainer.parentElement.offsetWidth+3+"px",this._tabContainer.parentElement.scrollLeft=i}},n.prototype._getItemIndex=function(e,t){for(var o=0;o<e.children.length;o++)if(e.children[o]===t)return o;return-1},n.prototype._updateSheetName=function(e,t){this._tabContainer.querySelectorAll("li")[t.index].textContent=t.item.name,this._adjustSize()},n.prototype._scrollSheetTabContainer=function(e){var o,n=this._tabContainer.parentElement.scrollLeft,i=this._sheetPage.offsetWidth,s=this._newSheet.offsetWidth,l=this._tabContainer.parentElement.offsetWidth;if(this._rtl)switch(t.FlexGrid._getRtlMode()){case"rev":(o=-this._tabContainer.offsetLeft)+e.offsetLeft+e.offsetWidth>l+n?this._tabContainer.parentElement.scrollLeft+=e.offsetWidth:o+e.offsetLeft<n&&(this._tabContainer.parentElement.scrollLeft-=e.offsetWidth);break;case"neg":e.offsetLeft<n?this._tabContainer.parentElement.scrollLeft-=e.offsetWidth:e.offsetLeft+e.offsetWidth>l+n&&(this._tabContainer.parentElement.scrollLeft+=e.offsetWidth);break;default:e.offsetLeft-s+n<0?this._tabContainer.parentElement.scrollLeft+=e.offsetWidth:e.offsetLeft+e.offsetWidth-s+n>l&&(this._tabContainer.parentElement.scrollLeft-=e.offsetWidth)}else e.offsetLeft+e.offsetWidth-i>l+n?this._tabContainer.parentElement.scrollLeft+=e.offsetWidth:e.offsetLeft-i<n&&(this._tabContainer.parentElement.scrollLeft-=e.offsetWidth)},n.prototype._adjustSheetsPosition=function(){var e,t,o=this._tabContainer.querySelectorAll("li"),n=0;for(t=0;t<o.length;t++)(e=o[t]).style.cssFloat="right",e.style.right=n+"px",n+=o[t].clientWidth},n.prototype._scrollToActiveSheet=function(e,o){var n,i,s,l=this._tabContainer.querySelectorAll("li");if(i=this._tabContainer.clientWidth>this._tabContainer.parentElement.clientWidth?this._tabContainer.clientWidth-this._tabContainer.parentElement.clientWidth:0,l.length>0&&e<l.length&&o<l.length){if(0===e&&!this._rtl||e===l.length-1&&this._rtl){if(this._rtl)switch(t.FlexGrid._getRtlMode()){case"rev":this._tabContainer.parentElement.scrollLeft=0;break;case"neg":this._tabContainer.parentElement.scrollLeft=-i;break;default:this._tabContainer.parentElement.scrollLeft=i}else this._tabContainer.parentElement.scrollLeft=0;return}if(0===e&&this._rtl||e===l.length-1&&!this._rtl){if(this._rtl)switch(t.FlexGrid._getRtlMode()){case"rev":this._tabContainer.parentElement.scrollLeft=i;break;case"neg":default:this._tabContainer.parentElement.scrollLeft=0}else this._tabContainer.parentElement.scrollLeft=i;return}if(e>=o)for(s=o+1;s<=e;s++)n=l[s],this._scrollSheetTabContainer(n);else for(s=o-1;s>=e;s--)n=l[s],this._scrollSheetTabContainer(n)}},n.prototype._adjustNavigationButtons=function(t){var o,n=this.hostElement.querySelectorAll(".wj-sheet-page button");n&&4===n.length&&(t?(o=n[0].querySelector("span"),e.removeClass(o,"wj-glyph-step-backward"),e.addClass(o,"wj-glyph-step-forward"),o=n[1].querySelector("span"),e.removeClass(o,"wj-glyph-left"),e.addClass(o,"wj-glyph-right"),o=n[2].querySelector("span"),e.removeClass(o,"wj-glyph-right"),e.addClass(o,"wj-glyph-left"),o=n[3].querySelector("span"),e.removeClass(o,"wj-glyph-step-forward"),e.addClass(o,"wj-glyph-step-backward")):(o=n[0].querySelector("span"),e.removeClass(o,"wj-glyph-step-forward"),e.addClass(o,"wj-glyph-step-backward"),o=n[1].querySelector("span"),e.removeClass(o,"wj-glyph-right"),e.addClass(o,"wj-glyph-left"),o=n[2].querySelector("span"),e.removeClass(o,"wj-glyph-left"),e.addClass(o,"wj-glyph-right"),o=n[3].querySelector("span"),e.removeClass(o,"wj-glyph-step-backward"),e.addClass(o,"wj-glyph-step-forward")))},n.controlTemplate='<div wj-part="sheet-container" class="wj-sheet" style="height:100%;position:relative"><div wj-part="sheet-page" class="wj-btn-group wj-sheet-page"><button type="button" class="wj-btn wj-btn-default"><span class="wj-sheet-icon wj-glyph-step-backward"></span></button><button type="button" class="wj-btn wj-btn-default"><span class="wj-sheet-icon wj-glyph-left"></span></button><button type="button" class="wj-btn wj-btn-default"><span class="wj-sheet-icon wj-glyph-right"></span></button><button type="button" class="wj-btn wj-btn-default"><span class="wj-sheet-icon wj-glyph-step-forward"></span></button></div><div class="wj-sheet-tab" style="height:100%;overflow:hidden"><ul wj-part="container"></ul></div><div wj-part="new-sheet" class="wj-new-sheet"><span class="wj-sheet-icon wj-glyph-file"></span></div></div>',n}(e.Control);o._SheetTabs=s;var l=function(){function e(e,t){this._column=e,this._ascending=t}return Object.defineProperty(e.prototype,"column",{get:function(){return this._column},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"ascending",{get:function(){return this._ascending},enumerable:!0,configurable:!0}),e}();o._UnboundSortDescription=l}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(){function n(t){this._owner=t,this._sortDescriptions=new e.collections.CollectionView,this._committedList=[new i(-1,!0)],this._sortDescriptions.newItemCreator=function(){return new i(-1,!0)},this._refresh()}return Object.defineProperty(n.prototype,"sortDescriptions",{get:function(){return this._sortDescriptions},set:function(e){this._sortDescriptions=e,this.commitSort(!0),this._refresh()},enumerable:!0,configurable:!0}),n.prototype.addSortLevel=function(t,o){void 0===o&&(o=!0);var n=this._sortDescriptions.addNew();null!=t&&!isNaN(t)&&e.isInt(t)&&(n.columnIndex=t),n.ascending=o,this._sortDescriptions.commitNew()},n.prototype.deleteSortLevel=function(e){var t;(t=null!=e?this._getSortItem(e):this._sortDescriptions.currentItem)&&this._sortDescriptions.remove(t)},n.prototype.copySortLevel=function(){var e=this._sortDescriptions.currentItem;if(e){var t=this._sortDescriptions.addNew();t.columnIndex=parseInt(e.columnIndex),t.ascending=e.ascending,this._sortDescriptions.commitNew()}},n.prototype.editSortLevel=function(e,t){null!=e&&(this._sortDescriptions.currentItem.columnIndex=e),null!=t&&(this._sortDescriptions.currentItem.ascending=t)},n.prototype.moveSortLevel=function(e){var t=this._sortDescriptions.currentItem;if(t){var o=this._sortDescriptions.sourceCollection,n=o.indexOf(t),i=n+e;n>-1&&i>-1&&(o.splice(n,1),o.splice(i,0,t),this._sortDescriptions.refresh(),this._sortDescriptions.moveCurrentTo(t))}},n.prototype.checkSortItemExists=function(e){for(var t=0,o=this._sortDescriptions.itemCount;t<o;t++)if(+this._sortDescriptions.items[t].columnIndex===e)return t;return-1},n.prototype.commitSort=function(t){var n=this;void 0===t&&(t=!0);var s,l,r,a,h,c,d,u,_,g=this._owner.itemsSource&&this._owner.itemsSource instanceof e.collections.CollectionView;if(this._owner.selectedSheet){if(this._owner._needCopyToSheet=!1,c=this._owner.selectedSheet._unboundSortDesc,t&&this._owner.undoStack.stackSize>0&&(d=new o._SortColumnAction(this._owner)),this._sortDescriptions.itemCount>0?this._committedList=this._cloneSortList(this._sortDescriptions.items):this._committedList=[new i(-1,!0)],this._owner.collectionView){for(navigator.userAgent.toLowerCase().indexOf("chrome")>-1&&(this._owner.collectionView.useStableSort=!0),(_=this._owner.editableCollectionView)&&_.currentEditItem&&-1!==_.items.indexOf(_.currentEditItem)&&!this._isEmpty(_.currentEditItem)&&_.commitEdit(),u=this._scanUnboundRows(),this._owner.collectionView.beginUpdate(),this._owner.selectedSheet.grid.collectionView.beginUpdate(),(r=this._owner.collectionView.sortDescriptions).clear(),!1===g&&(a=this._owner.selectedSheet.grid.collectionView.sortDescriptions).clear(),h=0;h<this._sortDescriptions.itemCount;h++)(s=this._sortDescriptions.items[h]).columnIndex>-1&&(l=new e.collections.SortDescription(this._owner.columns[s.columnIndex].binding,s.ascending),r.push(l),!1===g&&a.push(l));this._owner.selectedSheet.selectionRanges.clear(),this._owner.collectionView.endUpdate(),this._owner.selectedSheet.grid.collectionView.endUpdate(),u&&Object.keys(u).forEach(function(e){n._owner.rows.splice(+e,0,u[e])})}else for(c.clear(),h=0;h<this._sortDescriptions.itemCount;h++)(s=this._sortDescriptions.items[h]).columnIndex>-1&&c.push(new o._UnboundSortDescription(this._owner.columns[s.columnIndex],s.ascending));d&&(d.saveNewState(),this._owner.undoStack._addAction(d)),this._owner._copiedRanges=null,this._owner._needCopyToSheet=!0}},n.prototype.cancelSort=function(){this._sortDescriptions.sourceCollection=this._committedList.slice(),this._refresh()},n.prototype.clearSort=function(){this._sortDescriptions.sourceCollection=[],this.commitSort()},n.prototype._refresh=function(){var e,t,o=[];if(this._owner.selectedSheet){if(this._owner.collectionView&&this._owner.collectionView.sortDescriptions.length>0)for(e=0;e<this._owner.collectionView.sortDescriptions.length;e++)t=this._owner.collectionView.sortDescriptions[e],o.push(new i(this._getColumnIndex(t.property),t.ascending));else if(this._owner.selectedSheet&&this._owner.selectedSheet._unboundSortDesc.length>0)for(e=0;e<this._owner.selectedSheet._unboundSortDesc.length;e++)null!=(t=this._owner.selectedSheet._unboundSortDesc[e]).column&&o.push(new i(t.column.index,t.ascending));else o.push(new i(-1,!0));this._sortDescriptions.sourceCollection=o}},n.prototype._getColumnIndex=function(e){for(var t=0,o=this._owner.columns.length;t<o;t++)if(this._owner.columns[t].binding===e)return t;return-1},n.prototype._getSortItem=function(e){var t=this.checkSortItemExists(e);if(t>-1)return this._sortDescriptions.items[t]},n.prototype._scanUnboundRows=function(){var e,n,i;for(e=0;e<this._owner.rows.length;e++)(n=this._owner.rows[e]).dataItem||n instanceof o.HeaderRow||n instanceof t._NewRowTemplate||(i||(i={}),i[e]=n);return i},n.prototype._cloneSortList=function(e){for(var t=[],o=0;o<e.length;o++)t[o]=e[o].clone();return t},n.prototype._isEmpty=function(e){var t=Object.prototype.hasOwnProperty;if(null==e)return!0;if(e.length>0)return!1;if(0===e.length)return!0;for(var o in e)if(t.call(e,o))return!1;return!0},n}();o.SortManager=n;var i=function(){function e(e,t){this._columnIndex=e,this._ascending=t}return Object.defineProperty(e.prototype,"columnIndex",{get:function(){return this._columnIndex},set:function(e){this._columnIndex=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"ascending",{get:function(){return this._ascending},set:function(e){this._ascending=e},enumerable:!0,configurable:!0}),e.prototype.clone=function(){return new e(this._columnIndex,this._ascending)},e}();o.ColumnSortDescription=i}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){!function(t){"use strict";var o=function(){function o(o){this.MAX_STACK_SIZE=500,this._stack=[],this._pointer=-1,this._resizingTriggered=!1,this.undoStackChanged=new e.Event;var n=this;n._owner=o,n._owner.prepareCellForEdit.addHandler(n._initCellEditAction,n),n._owner.cellEditEnded.addHandler(function(e,o){n._pendingAction&&(!o.data||46!==o.data.keyCode&&8!==o.data.keyCode)&&n._pendingAction instanceof t._EditAction&&!n._pendingAction.isPaste&&n._afterProcessCellEditAction(n)},n),n._owner.pasting.addHandler(n._initCellEditActionForPasting,n),n._owner.pastingCell.addHandler(function(e,o){n._pendingAction&&(n._pendingAction instanceof t._EditAction?n._pendingAction.updateForPasting(o.range):n._pendingAction instanceof t._CutAction&&n._pendingAction.updateForPasting(o.range))},n),n._owner.pasted.addHandler(function(){n._pendingAction&&(n._pendingAction instanceof t._EditAction&&n._pendingAction.isPaste?n._afterProcessCellEditAction(n):n._pendingAction instanceof t._CutAction&&(n._pendingAction.saveNewState(),n._addAction(n._pendingAction),n._pendingAction=null))},n),n._owner.resizingColumn.addHandler(function(e,o){0!==n.stackSize&&n._owner.selectedSheet&&(n._resizingTriggered||(n._pendingAction=new t._ColumnResizeAction(n._owner,o.panel,o.col),n._resizingTriggered=!0))},n),n._owner.resizedColumn.addHandler(function(e,o){n._pendingAction instanceof t._ColumnResizeAction&&n._pendingAction.saveNewState()&&n._addAction(n._pendingAction),n._pendingAction=null,n._resizingTriggered=!1},n),n._owner.resizingRow.addHandler(function(e,o){0!==n.stackSize&&n._owner.selectedSheet&&(n._resizingTriggered||(n._pendingAction=new t._RowResizeAction(n._owner,o.panel,o.row),n._resizingTriggered=!0))},n),n._owner.resizedRow.addHandler(function(e,o){n._pendingAction instanceof t._RowResizeAction&&n._pendingAction.saveNewState()&&n._addAction(n._pendingAction),n._pendingAction=null,n._resizingTriggered=!1},n),n._owner.draggingRowColumn.addHandler(function(e,o){0!==n.stackSize&&n._owner.selectedSheet&&o.isShiftKey&&(o.isDraggingRows?n._pendingAction=new t._RowsChangedAction(n._owner):n._pendingAction=new t._ColumnsChangedAction(n._owner))},n),n._owner.droppingRowColumn.addHandler(function(){n._pendingAction&&n._pendingAction.saveNewState()&&n._addAction(n._pendingAction),n._pendingAction=null},n)}return Object.defineProperty(o.prototype,"stackSize",{get:function(){return null==this._stackSize?this.MAX_STACK_SIZE:this._stackSize},set:function(t){e.isNumber(t)&&(t<0?this._stackSize=0:t>this.MAX_STACK_SIZE?this._stackSize=this.MAX_STACK_SIZE:this._stackSize=Math.floor(t))},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"canUndo",{get:function(){return this._pointer>-1&&this._pointer<this._stack.length},enumerable:!0,configurable:!0}),Object.defineProperty(o.prototype,"canRedo",{get:function(){return this._pointer+1>-1&&this._pointer+1<this._stack.length},enumerable:!0,configurable:!0}),o.prototype.onUndoStackChanged=function(){this.undoStackChanged.raise(this)},o.prototype.undo=function(){var e;this.canUndo&&(e=this._stack[this._pointer],this._beforeUndoRedo(e),e.undo(),this._pointer--,this.onUndoStackChanged())},o.prototype.redo=function(){var e;this.canRedo&&(this._pointer++,e=this._stack[this._pointer],this._beforeUndoRedo(e),e.redo(),this.onUndoStackChanged())},o.prototype._addAction=function(e){this._stack.length>0&&this._stack.length>this._pointer+1&&this._stack.splice(this._pointer+1,this._stack.length-this._pointer-1),this._stack.length>=this.stackSize&&this._stack.splice(0,this._stack.length-this.stackSize+1),this._pointer=this._stack.length,this._stack.push(e),this.onUndoStackChanged()},o.prototype._pop=function(){var e;return this._pointer<0?null:(e=this._stack[this._pointer],this._pointer--,e)},o.prototype.clear=function(){this._stack.length=0},o.prototype._initCellEditAction=function(e,o){0!==this.stackSize&&this._owner.selectedSheet&&(this._pendingAction=new t._EditAction(this._owner,o.range))},o.prototype._initCellEditActionForPasting=function(){0!==this.stackSize&&this._owner.selectedSheet&&(this._owner._isCutting?this._pendingAction=new t._CutAction(this._owner):(this._pendingAction=new t._EditAction(this._owner),this._pendingAction.markIsPaste()))},o.prototype._afterProcessCellEditAction=function(e){e._pendingAction&&(e._pendingAction instanceof t._EditAction&&e._pendingAction.saveNewState()&&e._addAction(this._pendingAction),e._pendingAction=null)},o.prototype._beforeUndoRedo=function(e){this._owner.selectedSheetIndex=e.sheetIndex},o}();t.UndoStack=o}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(){function n(e,t,o,n,i){this._showHeaderRow=!0,this._showTotalRow=!1,this._showBandedColumns=!1,this._showBandedRows=!0,this._alterFirstColumn=!1,this._alterLastColumn=!1,this._orgHeaderCellsContent=[],this._name=e,this._range=t.clone(),this._style=o,null!=n&&n.length>0&&this._pushTableColumns(n),null!=i&&(null!=i.showHeaderRow&&(this._showHeaderRow=i.showHeaderRow),null!=i.showTotalRow&&(this._showTotalRow=i.showTotalRow),null!=i.showBandedColumns&&(this._showBandedColumns=i.showBandedColumns),null!=i.showBandedRows&&(this._showBandedRows=i.showBandedRows),null!=i.alterFirstColumn&&(this._alterFirstColumn=i.alterFirstColumn),null!=i.alterLastColumn&&(this._alterLastColumn=i.alterLastColumn))}return Object.defineProperty(n.prototype,"name",{get:function(){return this._name},set:function(e){var t,n;if(null==e||""===e)throw"The name of the Table should not be empty.";this._name.toLowerCase()!==e.toLowerCase()&&(n=this._name,this._name=e,this._owner&&(!this._owner._isUndoing&&this._owner.undoStack.stackSize>0&&(t=new o._TableSettingAction(this._owner,this)),this._owner._updateFormulasWithNameUpdating(n,e,!0),t&&(t.saveNewState(),this._owner.undoStack._addAction(t),t=null)))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"sheet",{get:function(){return this._sheet},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"style",{get:function(){return this._style},set:function(e){var t;e.name!==this._style.name&&(this._owner&&!this._owner._isUndoing&&this._owner.undoStack.stackSize>0&&(t=new o._TableSettingAction(this._owner,this)),this._style=e,this._owner&&(t&&(t.saveNewState(),this._owner.undoStack._addAction(t),t=null),this._owner.refresh()))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showHeaderRow",{get:function(){return this._showHeaderRow},set:function(e){var t,n;if(e!==this._showHeaderRow&&(this._owner&&!this._owner._isUndoing&&this._owner.undoStack.stackSize>0&&(t=new o._TableSettingAction(this._owner,this)),n=this._showHeaderRow,this._showHeaderRow=e,this._owner))try{this._owner.beginUpdate(),this._adjustTableRangeWithHeaderRow(),t&&(t.saveNewState(),this._owner.undoStack._addAction(t))}catch(e){throw this._showHeaderRow=n,e}finally{t=null,this._owner.endUpdate()}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showTotalRow",{get:function(){return this._showTotalRow},set:function(e){var t,n;if(e!==this._showTotalRow&&(this._owner&&!this._owner._isUndoing&&this._owner.undoStack.stackSize>0&&(t=new o._TableSettingAction(this._owner,this)),n=this._showTotalRow,this._showTotalRow=e,this._owner))try{this._owner.beginUpdate(),this._adjustTableRangeWithTotalRow(),t&&(t.saveNewState(),this._owner.undoStack._addAction(t))}catch(e){throw this._showTotalRow=n,e}finally{t=null,this._owner.endUpdate()}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showBandedColumns",{get:function(){return this._showBandedColumns},set:function(e){var t;e!==this._showBandedColumns&&(this._owner&&!this._owner._isUndoing&&this._owner.undoStack.stackSize>0&&(t=new o._TableSettingAction(this._owner,this)),this._showBandedColumns=e,this._owner&&(t&&(t.saveNewState(),this._owner.undoStack._addAction(t),t=null),this._owner.refresh()))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"showBandedRows",{get:function(){return this._showBandedRows},set:function(e){var t;e!==this._showBandedRows&&(this._owner&&!this._owner._isUndoing&&this._owner.undoStack.stackSize>0&&(t=new o._TableSettingAction(this._owner,this)),this._showBandedRows=e,this._owner&&(t&&(t.saveNewState(),this._owner.undoStack._addAction(t),t=null),this._owner.refresh()))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"alterFirstColumn",{get:function(){return this._alterFirstColumn},set:function(e){var t;e!==this._alterFirstColumn&&(this._owner&&!this._owner._isUndoing&&this._owner.undoStack.stackSize>0&&(t=new o._TableSettingAction(this._owner,this)),this._alterFirstColumn=e,this._owner&&(t&&(t.saveNewState(),this._owner.undoStack._addAction(t),t=null),this._owner.refresh()))},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"alterLastColumn",{get:function(){return this._alterLastColumn},set:function(e){var t;e!==this._alterLastColumn&&(this._owner&&!this._owner._isUndoing&&this._owner.undoStack.stackSize>0&&(t=new o._TableSettingAction(this._owner,this)),this._alterLastColumn=e,this._owner&&(t&&(t.saveNewState(),this._owner.undoStack._addAction(t),t=null),this._owner.refresh()))},enumerable:!0,configurable:!0}),n.prototype.getRange=function(e,t){void 0===e&&(e=l.All);var o;switch(e){case l.Data:o=this._getDataRange();break;case l.Header:o=this._getHeaderRange();break;case l.Footer:o=this._getFooterRange();break;default:o=this._range.clone()}if(null!=t&&o){var n=this._getColumnIndex(t);if(null==n)return null;o.col=o.col2=o.leftCol+n}return o},n.prototype.getColumns=function(){return this._columns?this._columns.slice():[]},n.prototype.insertRows=function(o,n,i){void 0===i&&(i=!0);var s,l,r,a,h,c=this.getRange(),d=!1;if(null==n&&(n=1),!e.isInt(n)||n<1)return!1;if(0===o&&this._showHeaderRow||o===this._range.rowSpan-1&&this._showTotalRow||o<0||o>=this._range.rowSpan)return!1;if(this._owner){if(this._owner.beginUpdate(),a=this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid,i){if(r=new t.CellRange(c.bottomRow+1,c.col,c.bottomRow+1,c.col2),this._sheet._canShiftCells(r)){if(s=this._sheet._needAddRowCountForInsertTableRows(n,c),a.collectionView){for(h=a.itemsSource instanceof e.collections.CollectionView,a.collectionView.beginUpdate(),l=0;l<s;l++)h?a.itemsSource.sourceCollection.push({}):a.itemsSource.push({});a.collectionView.endUpdate()}else for(l=0;l<s;l++)a.rows.push(new t.Row);this._sheet._moveDownCells(n,r),d=!0}}else this._canInsertRowsWithoutShift(n)&&(d=!0);d&&(this._sheet._moveDownCellsWithinTable(o,n,c),this._updateTableRange(0,n,0,0)),this._owner.endUpdate()}else this._updateTableRange(0,n,0,0),d=!0;return d},n.prototype.deleteRows=function(o,n,i){void 0===i&&(i=!0);var s,l=!1,r=this.getRange();null==n&&(n=1),!e.isInt(n)||n<1||0===o&&this._showHeaderRow||o===this._range.rowSpan-1&&this._showTotalRow||o<0||o>=this._range.rowSpan||o+n>this._range.rowSpan-(this._showTotalRow?1:0)||(this._owner?(this._owner.beginUpdate(),i?(s=new t.CellRange(r.bottomRow+1,r.col,r.bottomRow+1,r.col2),this._sheet._canShiftCells(s)&&(l=!0)):l=!0,l&&(this._sheet._moveUpCellsWithinTable(o,n,r),i&&this._sheet._moveUpCells(n,s),this._updateTableRange(0,-n,0,0)),this._owner.endUpdate()):this._updateTableRange(0,-n,0,0))},n.prototype._addColumn=function(e,t){var o,n=this.getRange();if(e<=0||e>this._columns.length)throw"The column index is out of range.";t=this._getUniqueColumnName(e,t),(o=new i(t))._attach(this),this._columns.splice(e,0,o),this.showHeaderRow&&this._owner&&this._sheet&&(this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid).setCellData(n.topRow,n.leftCol+e,t)},n.prototype._updateCell=function(e,t,o){var n,i=e-this._range.topRow,s=t-this._range.leftCol;null!=this._style&&(n=this._getTableCellAppliedStyles(i,s),this._applyStylesForCell(n,o))},n.prototype._updateTableRange=function(e,t,o,n){this._range.row<=this._range.row2?(this._range.row+=e,this._range.row2+=t):(this._range.row2+=e,this._range.row+=t),this._range.col<=this._range.col2?(this._range.col+=o,this._range.col2+=n):(this._range.col2+=o,this._range.col+=n)},n.prototype._setTableRange=function(e,t){var o;if(this._range=e,null!=t)for(this._columns.splice(0,this._columns.length),o=0;o<t.length;o++)this._columns.push(t[o])},n.prototype._updateColumnName=function(e,t){var o=this._columns[e];t=this._getUniqueColumnName(null,t),o.name=t,this._showHeaderRow&&this._owner&&this._sheet&&(this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid).setCellData(this._range.topRow,this._range.leftCol+e,t)},n.prototype._updateColumnTotalRowContent=function(e,t){var o,n;null==t&&(t=this._columns.indexOf(e)),t<0||(e.totalRowFunction?n=null!=(o=this._getSubtotalFunction(e.totalRowFunction.toLowerCase()))?"=subtotal("+o+",["+e.name+"])":"="===e.totalRowFunction[0]?e.totalRowFunction:"="+e.totalRowFunction:0===t?(e.totalRowLabel||(e.totalRowLabel="Total"),n=e.totalRowLabel):t===this._columns.length-1?(e.totalRowFunction="=subtotal(109, ["+e.name+"])",n=e.totalRowFunction):n=e.totalRowLabel,this._owner&&this._sheet&&(this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid).setCellData(this._range.bottomRow,this._range.leftCol+t,n,!1))},n.prototype._attachSheet=function(e){var t=this.getRange();if(!(this._sheet&&this._owner||(this._sheet=e,this._owner=e._owner,null==this._owner))){if(this._owner._containsMergedCells(this._range,e))throw"Table does not allow the merged cell within the table.";null==this._style&&(this._style=this._owner.getBuiltInTableStyle("TableStyleMedium9")),null!=this._columns&&0!==this._columns.length||this._generateColumns(this._showHeaderRow);try{this._owner.beginUpdate(),this._showHeaderRow&&1===t.rowSpan&&this._adjustTableRangeWithHeaderRow(),this._showTotalRow&&this._updateTotalRow()}finally{this._owner.endUpdate()}}},n.prototype._detachSheet=function(){this._sheet=null,this._owner=null},n.prototype._pushTableColumns=function(e){var t,o;for(this._columns=[],o=0;o<e.length;o++)(t=e[o])._attach(this),this._columns.push(t)},n.prototype._generateColumns=function(t){var o,n,s,l,r,a=this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid;if(!this._range.isValid)throw"The range of the table is invalid.";this._columns=[];for(var h=0;h<this._range.columnSpan;h++)l=this._sheet.grid.columns[this._range.leftCol+h],r=this._range.topRow*this._sheet.grid.columns.length+this._range.leftCol+h,1===this._range.rowSpan?o=this._getUniqueColumnName(h+1):(o=this._sheet.grid.getCellData(this._range.topRow,this._range.leftCol+h,!1)||"",e.isString(o)&&"="===o[0]&&(o=this._owner.evaluate(o,"",this._sheet,!1)),s=this._sheet._styledCells[r],o=this._owner._formatEvaluatedResult(o,l,s?s.format:""),o=this._getUniqueColumnName(h+1,o.toString())),t&&this._range.rowSpan>1&&(this._orgHeaderCellsContent[h]=this._sheet.grid.getCellData(this._range.topRow,this._range.leftCol+h,!1),isNaN(+o)||l.format||s&&s.format||(s?s.format="@":this._sheet._styledCells[r]={format:"@"}),a.setCellData(this._range.topRow,this._range.leftCol+h,o,!1)),(n=new i(o))._attach(this),0===h?n._totalRowLabel="Total":h===this._range.columnSpan-1&&(n._totalRowFunction="Sum"),this._columns.push(n)},n.prototype._getTableCellAppliedStyles=function(e,t){var o,n={},i=!1,s=!1,l=0;return this._showHeaderRow&&(l=1),this._showHeaderRow&&0===e?i=!0:this._showTotalRow&&e===this._range.rowSpan-1&&(s=!0),this._extendStyle(n,this._style.wholeTableStyle,e,t,i,s),i||s||(!this._showBandedColumns||null==this._style.firstBandedColumnStyle&&null==this._style.secondBandedColumnStyle||(t%((o=this._style.firstBandedColumnStyle?null==this._style.firstBandedColumnStyle.size?1:this._style.firstBandedColumnStyle.size:1)+(this._style.secondBandedColumnStyle?null==this._style.secondBandedColumnStyle.size?1:this._style.secondBandedColumnStyle.size:1))>=o?this._style.secondBandedColumnStyle&&this._extendStyle(n,this._style.secondBandedRowStyle,e,t,i,s):this._style.firstBandedColumnStyle&&this._extendStyle(n,this._style.firstBandedColumnStyle,e,t,i,s)),!this._showBandedRows||null==this._style.firstBandedRowStyle&&null==this._style.secondBandedRowStyle||((e-l)%((o=this._style.firstBandedRowStyle?null==this._style.firstBandedRowStyle.size?1:this._style.firstBandedRowStyle.size:1)+(this._style.secondBandedRowStyle?null==this._style.secondBandedRowStyle.size?1:this._style.secondBandedRowStyle.size:1))>=o?this._style.secondBandedRowStyle&&this._extendStyle(n,this._style.secondBandedRowStyle,e,t,i,s):this._style.firstBandedRowStyle&&this._extendStyle(n,this._style.firstBandedRowStyle,e,t,i,s))),this._alterLastColumn&&t===this._range.columnSpan-1&&this._style.lastColumnStyle&&this._extendStyle(n,this._style.lastColumnStyle,e,t,i,s),this._alterFirstColumn&&0===t&&this._style.firstColumnStyle&&this._extendStyle(n,this._style.firstColumnStyle,e,t,i,s),i?(this._style.headerRowStyle&&this._extendStyle(n,this._style.headerRowStyle,e,t,i,s),t===this._range.columnSpan-1&&this._style.lastHeaderCellStyle&&this._extendStyle(n,this._style.lastHeaderCellStyle,e,t,i,s),0===t&&this._style.firstHeaderCellStyle&&this._extendStyle(n,this._style.firstHeaderCellStyle,e,t,i,s)):s&&(this._style.totalRowStyle&&this._extendStyle(n,this._style.totalRowStyle,e,t,i,s),t===this._range.columnSpan-1&&this._style.lastTotalCellStyle&&this._extendStyle(n,this._style.lastTotalCellStyle,e,t,i,s),0===t&&this._style.firstTotalCellStyle&&this._extendStyle(n,this._style.firstTotalCellStyle,e,t,i,s)),n},n.prototype._applyStylesForCell=function(e,t){var o,n=t.style;for(var i in e)(o=e[i])&&(n[i]=o)},n.prototype._extendStyle=function(e,t,o,n,i,s){var l;for(var r in t)null!==(l=t[r])&&(r.indexOf("borderTop")>-1?(0===o||s)&&(e[r]=l):r.indexOf("borderBottom")>-1?(o===this._range.rowSpan-1||i)&&(e[r]=l):r.indexOf("borderLeft")>-1?0===n&&(e[r]=l):r.indexOf("borderRight")>-1?n===this._range.columnSpan-1&&(e[r]=l):r.indexOf("borderHorizontal")>-1?o<this._range.rowSpan-1&&("borderHorizontalStyle"===r?e.borderBottomStyle=l:"borderHorizontalWidth"===r?e.borderBottomWidth=l:e.borderBottomColor=l):r.indexOf("borderVertical")>-1?n<this._range.columnSpan-1&&("borderVerticalStyle"===r?e.borderRightStyle=l:"borderVerticalWidth"===r?e.borderRightWidth=l:e.borderRightColor=l):e[r]=l)},n.prototype._getSubtotalFunction=function(e){switch(e){case"average":return"101";case"countnums":return"102";case"count":return"103";case"max":return"104";case"min":return"105";case"stddev":return"107";case"sum":return"109";case"var":return"110"}return null},n.prototype._checkColumnNameExist=function(e){var t,o=this.getColumns();for(t=0;t<o.length;t++)if(o[t].name.toLowerCase()===e.toLowerCase())return!0;return!1},n.prototype._adjustTableRangeWithHeaderRow=function(){var o,n,i,s,l=this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid;if(this._showHeaderRow){if(this._sheet._needMoveDownTable(this)){if(i=this.getRange(),s=new t.CellRange(i.bottomRow+1,i.col,i.bottomRow+1,i.col2),!this._sheet._canShiftCells(s))throw"The operation is not allowed.  The operation is attempting to shift the cells in a table or a merged cell on the current sheet.";1===this._sheet._needAddRowCountForInsertTableRows(1,i)&&(l.collectionView?(l.collectionView.beginUpdate(),l.itemsSource instanceof e.collections.CollectionView?l.itemsSource.sourceCollection.push({}):l.itemsSource.push({}),l.collectionView.endUpdate()):l.rows.push(new t.Row)),this._sheet._moveDownCells(1,s),this._sheet._moveDownTable(this)}for(this._range.row<=this._range.row2?this._range.row-=1:this._range.row2-=1,o=0;o<this._columns.length;o++)n=this._columns[o],this._orgHeaderCellsContent[o]=l.getCellData(this._range.topRow,this._range.leftCol+o,!1),l.setCellData(this._range.topRow,this._range.leftCol+o,n.name)}else{for(o=this._range.leftCol;o<=this._range.rightCol;o++)l.setCellData(this._range.topRow,o,"");this._range.row<=this._range.row2?this._range.row+=1:this._range.row2+=1}},n.prototype._adjustTableRangeWithTotalRow=function(){var o,n,i,s=this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid;if(n=this.getRange(),i=new t.CellRange(n.bottomRow+1,n.col,n.bottomRow+1,n.col2),this._showTotalRow){if(this._sheet._canShiftCells(i))1===this._sheet._needAddRowCountForInsertTableRows(1,n)&&(s.collectionView?(s.collectionView.beginUpdate(),s.itemsSource instanceof e.collections.CollectionView?s.itemsSource.sourceCollection.push({}):s.itemsSource.push({}),s.collectionView.endUpdate()):s.rows.push(new t.Row)),this._sheet._moveDownCells(1,i);else if(!this._beneathRowIsEmpty())throw"The operation is not allowed.  The operation is attempting to shift the cells in a table or a merged cell on the current sheet.";this._range.row<=this._range.row2?this._range.row2+=1:this._range.row+=1,this._updateTotalRow()}else{for(o=this._range.leftCol;o<=this._range.rightCol;o++)s.setCellData(this._range.bottomRow,o,"");this._sheet._canShiftCells(i)&&this._sheet._moveUpCells(1,i),this._range.row<=this._range.row2?this._range.row2-=1:this._range.row-=1}},n.prototype._updateTotalRow=function(){var e;if(this.showTotalRow)for(var t=0;t<this._columns.length;t++)e=this._columns[t],this._updateColumnTotalRowContent(e,t)},n.prototype._getUniqueColumnName=function(e,t){var o,n=1;if(t||(t="Column"+e),this._checkColumnNameExist(t)){for(o=t+n;this._checkColumnNameExist(o);)o=t+ ++n;t=o}return t},n.prototype._moveColumns=function(e,t){if(this._columns){var o=this._columns[e];this._columns.splice(e,1),t<0&&(t=this._columns.length),this._columns.splice(t,0,o)}},n.prototype._canInsertRowsWithoutShift=function(e){var t,o,n,i,s,l=this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid;if(this._range.bottomRow+e>=l.rows.length)return!1;for(t=1;t<=e;t++)for(o=this._range.bottomRow+t,n=this._range.leftCol;n<=this._range.rightCol;n++)if(i=l.getCellData(o,n,!1),s=this._sheet.getCellStyle(o,n),null!=i&&""!==i||null!=s)return!1;return!0},n.prototype._beneathRowIsEmpty=function(){var e,t,o,n=this._range.bottomRow+1,i=this._sheet===this._owner.selectedSheet?this._owner:this._sheet.grid;if(n>=i.rows.length)return!1;for(e=this._range.leftCol;e<=this._range.rightCol;e++){if(null!=(t=i.getCellData(this._range.bottomRow+1,e,!1))&&""!==t)return!1;if(null!=this._sheet.getCellStyle(this._range.bottomRow+1,e))return!1;if(null!=this._sheet.findTable(n,e))return null;if(o=n*i.columns.length+e,null!=this._sheet._mergedRanges[o])return!1}return!0},n.prototype._getDataRange=function(){var e=this._range.topRow,o=this._range.bottomRow;return this._showHeaderRow&&(e+=1),this._showTotalRow&&(o-=1),new t.CellRange(e,this._range.leftCol,o,this._range.rightCol)},n.prototype._getHeaderRange=function(){return this._showHeaderRow?new t.CellRange(this._range.topRow,this._range.leftCol,this._range.topRow,this._range.rightCol):null},n.prototype._getFooterRange=function(){return this._showTotalRow?new t.CellRange(this._range.bottomRow,this._range.leftCol,this._range.bottomRow,this._range.rightCol):null},n.prototype._getColumnIndex=function(t){var o,n,s;if(e.isInt(t)&&t>=0&&t<this._columns.length)o=t;else{t instanceof i?n=t.name.toLowerCase():e.isString(t)&&""!==t&&(n=t.toLowerCase()),s=this.getColumns();for(var l=0;l<s.length;l++)if(s[l].name.toLowerCase()===n){o=l;break}}return o},n}();o.Table=n;var i=function(){function e(e,t,o,n){void 0===n&&(n=!0),this._name=e,this._totalRowLabel=t,this._totalRowFunction=o,null!=n&&(this._showFilterButton=n)}return Object.defineProperty(e.prototype,"table",{get:function(){return this._table},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"name",{get:function(){return this._name},set:function(e){e!==this._name&&(this._name=e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"totalRowLabel",{get:function(){return this._totalRowLabel},set:function(e){e!==this._totalRowLabel&&(this._totalRowLabel=e,this._updateTableTotalInfo())},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"totalRowFunction",{get:function(){return this._totalRowFunction},set:function(e){e!==this._totalRowFunction&&(this._totalRowFunction=e,this._updateTableTotalInfo())},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"showFilterButton",{get:function(){return this._showFilterButton},set:function(e){this._showFilterButton!==e&&(this._showFilterButton=e)},enumerable:!0,configurable:!0}),e.prototype._attach=function(e){this._table=e},e.prototype._updateTableTotalInfo=function(){this._table&&(this._table._updateColumnTotalRowContent(this),this._table._owner&&this._table._owner.refresh())},e}();o.TableColumn=i;var s=function(){function e(e,t){void 0===t&&(t=!1),this._name=e,this._isBuiltIn=t}return Object.defineProperty(e.prototype,"name",{get:function(){return this._name},set:function(e){e!==this._name&&(this._name=e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"wholeTableStyle",{get:function(){return this._wholeTableStyle},set:function(e){this._wholeTableStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"firstBandedColumnStyle",{get:function(){return this._firstBandedColumnStyle},set:function(e){this._firstBandedColumnStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"secondBandedColumnStyle",{get:function(){return this._secondBandedColumnStyle},set:function(e){this._secondBandedColumnStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"firstBandedRowStyle",{get:function(){return this._firstBandedRowStyle},set:function(e){this._firstBandedRowStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"secondBandedRowStyle",{get:function(){return this._secondBandedRowStyle},set:function(e){this._secondBandedRowStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"firstColumnStyle",{get:function(){return this._firstColumnStyle},set:function(e){this._firstColumnStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lastColumnStyle",{get:function(){return this._lastColumnStyle},set:function(e){this._lastColumnStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"headerRowStyle",{get:function(){return this._headerRowStyle},set:function(e){this._headerRowStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"totalRowStyle",{get:function(){return this._totalRowStyle},set:function(e){this._totalRowStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"firstHeaderCellStyle",{get:function(){return this._firstHeaderCellStyle},set:function(e){this._firstHeaderCellStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lastHeaderCellStyle",{get:function(){return this._lastHeaderCellStyle},set:function(e){this._lastHeaderCellStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"firstTotalCellStyle",{get:function(){return this._firstTotalCellStyle},set:function(e){this._firstTotalCellStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lastTotalCellStyle",{get:function(){return this._lastTotalCellStyle},set:function(e){this._lastTotalCellStyle=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isBuiltIn",{get:function(){return this._isBuiltIn},enumerable:!0,configurable:!0}),e}();o.TableStyle=s;var l;!function(e){e[e.All=0]="All",e[e.Data=1]="Data",e[e.Header=2]="Header",e[e.Footer=3]="Footer"}(l=o.TableSection||(o.TableSection={}))}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return __extends(n,e),n.prototype.apply=function(e){var n=this.column.grid;return!(n instanceof o.FlexSheet)||(!this.showValues||!Object.keys(this.showValues).length||(n.rows[e]instanceof t._NewRowTemplate||(e=n.getCellValue(e,this.column.index,!0),void 0!=this.showValues[e])))},n}(e.grid.filter.ValueFilter);o.FlexSheetValueFilter=n}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return __extends(n,e),n.prototype.updateEditor=function(){var n,i,s,l,r,a,h,c,d,u=this.filter.column,_=u.grid,g=u.index,f=[],p={};if(this.filter.uniqueValues||null!=_.itemsSource&&null!=_.childItemsPath)e.prototype.updateEditor.call(this);else{for(C=0;C<_.rows.length;C++)r=this.filter.apply(C),l=this.filter.showValues,this.filter.showValues=null,a=_.filter._filter(C),this.filter.showValues=l,(!(i=_.getMergedRange(_.cells,C,g))||C===i.topRow&&g===i.leftCol)&&((n=_.rows[C])instanceof o.HeaderRow||n instanceof t.GroupRow||n instanceof t._NewRowTemplate||!(n.visible||!r&&a)||(s=""===(s=_.getCellValue(C,g))?null:s,h=_.getCellValue(C,g,!0),c=_.getCellData(C,g,!0),p[h]||(p[h]=!0,d=c&&"="===c[0]?C+"_"+g:"",f.push({value:s,text:h,cellRef:d}))));var w=this.filter.showValues;if(w&&0!=Object.keys(w).length){for(var m in w)for(C=0;C<f.length;C++)if(w[m]&&""!==f[C].cellRef&&f[C].cellRef===w[m].cellRef)w[f[C].text]={show:!0,cellRef:f[C].cellRef},f[C].show=!0,delete w[m];else if(f[C].text==m){f[C].show=!0;break}}else for(var C=0;C<f.length;C++)f[C].show=!0;this._lbValues.isContentHtml=u.isContentHtml,this._cmbFilter.text=this.filter.filterText,this._filterText=this._cmbFilter.text.toLowerCase(),this._view.pageSize=this.filter.maxValues,this._view.sourceCollection=f,this._view.moveCurrentToPosition(-1)}},n.prototype.updateFilter=function(){var e=null,t=this._view.items;if(this._filterText||this._cbSelectAll.indeterminate){e={};for(var o=0;o<t.length;o++){var n=t[o];n.show&&(e[n.text]={show:!0,cellRef:n.cellRef})}}this._filter.showValues=e,this._filter.filterText=this._filterText},n}(e.grid.filter.ValueFilterEditor);o.FlexSheetValueFilterEditor=n}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(n){function i(){return null!==n&&n.apply(this,arguments)||this}return __extends(i,n),i.prototype.apply=function(n){var i,s,l,r=this.column,a=r.grid,h=this.condition1,c=this.condition2;if(!(a instanceof o.FlexSheet))return!0;if(!this.isActive)return!0;if(a.rows[n]instanceof t._NewRowTemplate)return!0;""===(i=a.getCellValue(n,r.index))&&r.dataType!==e.DataType.String&&(i=null),s=l=i,r.dataMap?s=l=i=r.dataMap.getDisplayValue(i):e.isDate(i)?(e.isString(h.value)||e.isString(c.value))&&(s=l=i=a.getCellValue(n,r.index,!0)):e.isNumber(i)&&(s=l=i=e.Globalize.parseFloat(a.getCellValue(n,r.index,!0)),0!==i||r.dataType||(h.isActive&&""===h.value&&(s=i.toString()),c.isActive&&""===c.value&&(l=l.toString())));var d=h.apply(s),u=c.apply(l);return h.isActive&&c.isActive?this.and?d&&u:d||u:h.isActive?d:!c.isActive||u},i}(e.grid.filter.ConditionFilter);o.FlexSheetConditionFilter=n}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(t){"use strict";var o=function(e){function o(o,n){var i=e.call(this,o,n)||this;return i._valueFilter=new t.FlexSheetValueFilter(n),i._conditionFilter=new t.FlexSheetConditionFilter(n),i}return __extends(o,e),o}(e.grid.filter.ColumnFilter);t.FlexSheetColumnFilter=o}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(t){"use strict";var o=function(o){function n(e,t,n){void 0===n&&(n=!0);var i,s,l=o.call(this,e,t,n)||this,r=l;return n&&(l._divSort.style.display=""),i=l.cloneElement(l._btnAsc),s=l.cloneElement(l._btnDsc),l._btnAsc.parentNode.replaceChild(i,l._btnAsc),l._btnDsc.parentNode.replaceChild(s,l._btnDsc),i.addEventListener("click",function(e){r._sortBtnClick(e,!0)}),s.addEventListener("click",function(e){r._sortBtnClick(e,!1)}),l}return __extends(n,o),n.prototype._showFilter=function(n){n==e.grid.filter.FilterType.Value&&null==this._edtVal&&(this._edtVal=new t.FlexSheetValueFilterEditor(this._divEdtVal,this.filter.valueFilter)),o.prototype._showFilter.call(this,n)},n.prototype._sortBtnClick=function(e,t){var o,n,i=this.filter.column,s=i.grid.sortManager;e.preventDefault(),e.stopPropagation(),(o=s.checkSortItemExists(i.index))>-1?(s.sortDescriptions.moveCurrentToPosition(o),s.sortDescriptions.currentItem.ascending=t,n=-o):(s.addSortLevel(i.index,t),n=-(s.sortDescriptions.items.length-1)),s.moveSortLevel(n),s.commitSort(),this.updateEditor(),this.onButtonClicked()},n.prototype.cloneElement=function(e){for(var t=e.cloneNode();e.firstChild;)t.appendChild(e.lastChild);return t},n}(e.grid.filter.ColumnFilterEditor);t.FlexSheetColumnFilterEditor=o}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var o in t)t.hasOwnProperty(o)&&(e[o]=t[o])};return function(t,o){function n(){this.constructor=t}e(t,o),t.prototype=null===o?Object.create(o):(n.prototype=o.prototype,new n)}}(),wijmo;!function(e){!function(t){!function(o){"use strict";var n=function(n){function i(){return null!==n&&n.apply(this,arguments)||this}return __extends(i,n),Object.defineProperty(i.prototype,"filterDefinition",{get:function(){for(var e={defaultFilterType:this.defaultFilterType,filters:[]},t=0;t<this._filters.length;t++){var o=this._filters[t];if(o&&o.column)if(o.conditionFilter.isActive){var n=o.conditionFilter;e.filters.push({columnIndex:o.column.index,type:"condition",condition1:{operator:n.condition1.operator,value:n.condition1.value},and:n.and,condition2:{operator:n.condition2.operator,value:n.condition2.value}})}else if(o.valueFilter.isActive){var i=o.valueFilter;e.filters.push({columnIndex:o.column.index,type:"value",filterText:i.filterText,showValues:i.showValues})}}return JSON.stringify(e)},set:function(t){var o=JSON.parse(e.asString(t));this.clear(),this.defaultFilterType=o.defaultFilterType;for(var n=0;n<o.filters.length;n++){var i=o.filters[n],s=this.grid.columns[i.columnIndex],l=this.getColumnFilter(s,!0);if(l)switch(i.type){case"condition":var r=l.conditionFilter;r.condition1.value=s.dataType==e.DataType.Date?e.changeType(i.condition1.value,s.dataType,null):i.condition1.value,r.condition1.operator=i.condition1.operator,r.and=i.and,r.condition2.value=s.dataType==e.DataType.Date?e.changeType(i.condition2.value,s.dataType,null):i.condition2.value,r.condition2.operator=i.condition2.operator;break;case"value":var a=l.valueFilter;a.filterText=i.filterText,a.showValues=i.showValues}}this.apply()},enumerable:!0,configurable:!0}),i.prototype.apply=function(){var n=this;n.grid.deferUpdate(function(){for(var i,s,l,r=-1,a=0;a<n.grid.rows.length;a++)if(!((i=n.grid.rows[a])instanceof o.HeaderRow||a<=r))if(r=-1,s=n._filter(a),i instanceof t.GroupRow){if(l=i.getCellRange(),null==i.dataItem||i.dataItem instanceof e.collections.CollectionViewGroup)i.visible=n._checkGroupVisible(l);else if(i.visible=s,r=l.bottomRow,l.isValid)for(var h=l.topRow;h<=l.bottomRow;h++)n.grid.rows[h].visible=s}else i.visible=s;n.grid._isCopying||n.grid._resettingFilter||n.onFilterApplied()})},i.prototype.editColumnFilter=function(n,i){var s=this;s.closeEditor(),n=e.isString(n)?s.grid.columns.getColumn(n):e.asType(n,t.Column,!1);var l=new t.CellRangeEventArgs(s.grid.cells,new t.CellRange(-1,n.index));if(s.onFilterChanging(l),!l.cancel){l.cancel=!0,s.grid.undoStack.stackSize>0&&(s._undoAcion=new o._FilteringAction(s.grid));var r=document.createElement("div"),a=s.getColumnFilter(n),h=new o.FlexSheetColumnFilterEditor(r,a,s.showSortButtons);e.addClass(r,"wj-dropdown-panel"),s.grid.rightToLeft&&(r.dir="rtl"),h.filterChanged.addHandler(function(){l.cancel=!1,s._undoAcion&&(s._undoAcion.saveNewState()&&s.grid.undoStack._addAction(s._undoAcion),s._undoAcion=null),setTimeout(function(){l.cancel||s.apply()})}),h.buttonClicked.addHandler(function(){s.closeEditor(),s.grid.focus(),s.onFilterChanged(l)}),h.lostFocus.addHandler(function(){setTimeout(function(){var t=e.Control.getControl(s._divEdt);t&&!t.containsFocus()&&s.closeEditor()},10)});var c=s.grid.columnHeaders,d=i?i.row:c.rows.length-1,u=i?i.col:n.index,_=c.getCellBoundingRect(d,u),g=document.elementFromPoint(_.left+_.width/2,_.top+_.height/2);(g=e.closest(g,".wj-cell"))?e.showPopup(r,g,!1,!1,!1):e.showPopup(r,_),h.focus(),s._divEdt=r,s._edtCol=n}},i.prototype.closeEditor=function(){this._undoAcion&&(this._undoAcion=null),n.prototype.closeEditor.call(this)},i.prototype.getColumnFilter=function(n,i){if(void 0===i&&(i=!0),e.isString(n)?n=this.grid.columns.getColumn(n):e.isNumber(n)&&(n=this.grid.columns[n]),!n)return null;n=e.asType(n,t.Column);for(var s=0;s<this._filters.length;s++)if(this._filters[s].column==n)return this._filters[s];if(i){var l=new o.FlexSheetColumnFilter(this,n);return this._filters.push(l),l}return null},i.prototype._checkGroupVisible=function(e){for(var o,n=!0,i=e.topRow+1;i<=e.bottomRow;i++)if(o=this.grid.rows[i])if(o instanceof t.GroupRow)n=this._checkGroupVisible(o.getCellRange());else if(n=this._filter(i))break;return n},i}(e.grid.filter.FlexGridFilter);o.FlexSheetFilter=n}(t.sheet||(t.sheet={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));
/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,l){e.__proto__=l}||function(e,l){for(var o in l)l.hasOwnProperty(o)&&(e[o]=l[o])};return function(l,o){function t(){this.constructor=l}e(l,o),l.prototype=null===o?Object.create(o):(t.prototype=o.prototype,new t)}}(),wijmo;!function(e){!function(l){!function(o){"use strict";var t=function(){function o(){}return o.save=function(e,l,o){var t=this._saveFlexGridToWorkbook(e,l);return o&&t.save(o),t},o.saveAsync=function(e,l,o,t,r){var n=this._saveFlexGridToWorkbook(e,l);return n.saveAsync(o,t,r),n},o.load=function(l,o,t){var r=this;if(o instanceof Blob){var n=new FileReader;n.onload=function(){var o=e.xlsx.Workbook._base64EncArr(new Uint8Array(n.result)),s=new e.xlsx.Workbook;s.load(o),o=null,l.deferUpdate(function(){r._loadToFlexGrid(l,s,t),s=null})},n.readAsArrayBuffer(o)}else if(o instanceof e.xlsx.Workbook)l.deferUpdate(function(){r._loadToFlexGrid(l,o,t),o=null});else{if(o instanceof ArrayBuffer)o=e.xlsx.Workbook._base64EncArr(new Uint8Array(o));else if(!e.isString(o))throw"Invalid workbook.";var s=new e.xlsx.Workbook;s.load(o),o=null,l.deferUpdate(function(){r._loadToFlexGrid(l,s,t),s=null})}},o.loadAsync=function(l,o,t,r,n){var s=this;if(o instanceof Blob){var a=new FileReader;a.onload=function(){var o=e.xlsx.Workbook._base64EncArr(new Uint8Array(a.result)),i=new e.xlsx.Workbook;i.loadAsync(o,function(e){o=null,i=null,l.deferUpdate(function(){s._loadToFlexGrid(l,e,t),r&&r(e),e=null})},n)},a.readAsArrayBuffer(o)}else if(o instanceof e.xlsx.Workbook)l.deferUpdate(function(){s._loadToFlexGrid(l,o,t),r&&r(o),o=null});else{if(o instanceof ArrayBuffer)o=e.xlsx.Workbook._base64EncArr(new Uint8Array(o));else if(!e.isString(o))throw"Invalid workbook.";(new e.xlsx.Workbook).loadAsync(o,function(e){o=null,l.deferUpdate(function(){s._loadToFlexGrid(l,e,t),r&&r(e),e=null})},n)}},o._saveFlexGridToWorkbook=function(o,t){var r,n,s,a,i,d,u,c,f,h,p,x,m,g=new e.xlsx.Workbook,w=new e.xlsx.WorkSheet,b=(new e.xlsx.WorkbookStyle,new e.xlsx.WorkbookFrozenPane),y=!t||null==t.includeColumnHeaders||t.includeColumnHeaders,_=!(!t||null==t.includeRowHeaders)&&t.includeRowHeaders,k=!t||null==t.includeCellStyles||t.includeCellStyles,C=t?t.activeWorksheet:null,v=t?t.includeColumns:null,S=t?t.formatItem:null,T=0,W=0,R=0,A=0,F=[];if(null==this.hasCssText&&(this.hasCssText="cssText"in document.body.style),h=o.wj_sheetInfo,w.name=t?t.sheetName:"",w.visible=!t||!1!==t.sheetVisible,h&&h.tables&&h.tables.length>0)for(var H=0;H<h.tables.length;H++)w.tables.push(h.tables[H]);if(d=[],h||!k&&!S||((p=document.createElement("div")).style.visibility="hidden",p.setAttribute(l.FlexGrid._WJS_MEASURE,"true"),o.hostElement.appendChild(p)),_){for(c=0,u=0;u<o.rowHeaders.rows.length;u++)if(!(o.rowHeaders.rows[u].renderSize<=0)){for(d[c]=[],f=0;f<o.rowHeaders.columns.length;f++)s=o._getBindingColumn(o.rowHeaders,u,o.rowHeaders.columns[f]),a=this._getColumnSetting(s,o.columnHeaders.columns.defaultSize),d[c][f]=a,0===c&&((i=new e.xlsx.WorkbookColumn)._deserialize(a),w._addWorkbookColumn(i,f));c++}A=f}if(y&&o.columnHeaders.rows.length>0){for(c=0,u=0;u<o.columnHeaders.rows.length;u++)if(!(o.columnHeaders.rows[u].renderSize<=0)){for(d[c]||(d[c]=[]),f=0;f<o.columnHeaders.columns.length;f++)s=o._getBindingColumn(o.columnHeaders,u,o.columnHeaders.columns[f]),a=this._getColumnSetting(s,o.columnHeaders.columns.defaultSize),d[c][A+f]=a,0===c&&(v&&!v(s)||((i=new e.xlsx.WorkbookColumn)._deserialize(a),w._addWorkbookColumn(i)));A=0,r={},n=new e.xlsx.WorkbookRow,_&&(A=this._parseFlexGridRowToSheetRow(o.topLeftCells,r,u,0,d,k,p,F,!1,0,v,S)),this._parseFlexGridRowToSheetRow(o.columnHeaders,r,u,A,d,k,p,F,!1,0,v,S),r.cells.length>0&&(n._deserialize(r),w._addWorkbookRow(n,c)),c++}W=c}else for(d[0]||(d[0]=[]),f=0;f<o.columnHeaders.columns.length;f++)s=o._getBindingColumn(o.columnHeaders,0,o.columnHeaders.columns[f]),a=this._getColumnSetting(s,o.columnHeaders.columns.defaultSize),d[0][A+f]=a,v&&!v(s)||((i=new e.xlsx.WorkbookColumn)._deserialize(a),w._addWorkbookColumn(i));for(u=0;u<o.cells.rows.length;u++)A=0,r={},n=new e.xlsx.WorkbookRow,(x=o.rows[u])instanceof l._NewRowTemplate||((m=x instanceof l.GroupRow)?T=e.tryCast(x,l.GroupRow).level:o.rows.maxGroupLevel>-1&&(T=o.rows.maxGroupLevel+1),_&&(A=this._parseFlexGridRowToSheetRow(o.rowHeaders,r,u,0,d,k,p,F,m,T,v,S)),this._parseFlexGridRowToSheetRow(o.cells,r,u,A,d,k,p,F,m,T,v,S),r.cells.length>0&&(n._deserialize(r),w._addWorkbookRow(n,W+u)));for(R=o.cells.rows.length,u=0;u<o.columnFooters.rows.length;u++)A=0,r={},n=new e.xlsx.WorkbookRow,m=(x=o.columnFooters.rows[u])instanceof l.GroupRow,_&&(A=this._parseFlexGridRowToSheetRow(o.rowHeaders,r,u,0,d,k,p,F,m,0,v,S)),this._parseFlexGridRowToSheetRow(o.columnFooters,r,u,A,d,k,p,F,m,0,v,S),r.cells.length>0&&(n._deserialize(r),w._addWorkbookRow(n,W+R+u));return b.rows=y?o.frozenRows+W:o.frozenRows,b.columns=_?o.frozenColumns+A:o.frozenColumns,w.frozenPane=b,g._addWorkSheet(w),h||!k&&!S||(o.hostElement.removeChild(p),F.forEach(function(e){return e.forEach(function(e){e&&e.parentElement&&e.parentElement.removeChild(e)})})),g.activeWorksheet=C,g},o._loadToFlexGrid=function(o,t,r){var n,s,a,i,d,u,c,f,h,p,x,m,g,w,b,y,_,k,C,v,S,T,W,R,A,F,H,B,N,D,E,z,I,G=!r||null==r.includeColumnHeaders||r.includeColumnHeaders,L=!r||null==r.includeColumnHeaders||r.includeColumnHeaders,O=r&&null!=r.sheetIndex&&!isNaN(r.sheetIndex)?r.sheetIndex:0,M=r?r.sheetName:null,j=!r||r.sheetVisible,P=null!=o.wj_sheetInfo,V=0,U=0,X=!1,q={};if(o.itemsSource=null,o.columns.clear(),o.rows.clear(),o.frozenColumns=0,o.frozenRows=0,H={},B={},U=0,i=[],N=[],O<0||O>=t.sheets.length)throw"The sheet index option is out of the sheet range of current workbook.";if(null!=M)for(n=0;n<t.sheets.length;n++)if(M===t.sheets[n].name){m=t.sheets[n];break}if(null!=(m=m||t.sheets[O]).rows){for(G&&(U=1,m.rows.length<=1&&(L=!1,U=0),f=m.rows[0]),w=this._getColumnCount(m.rows),g=this._getRowCount(m.rows,w),C=m.summaryBelow,a=m.columns,V=0;V<w;V++)o.columns.push(new l.Column),a[V]&&(isNaN(+a[V].width)||(o.columns[V].width=+a[V].width),a[V].visible||null==a[V].visible||(o.columns[V].visible=!!a[V].visible),a[V].style&&a[V].style.wordWrap&&(o.columns[V].wordWrap=a[V].style.wordWrap));for(;U<g;U++){if(b=!1,I=null,x=m.rows[U])for(_=U+1;_<m.rows.length;){if(k=m.rows[_]){(isNaN(x.groupLevel)&&!isNaN(k.groupLevel)||!isNaN(x.groupLevel)&&x.groupLevel<k.groupLevel)&&(b=!0);break}_++}for(b&&!C?(S&&(S.isCollapsed=X),(S=new l.GroupRow).isReadOnly=!1,X=null!=x.collapsed&&x.collapsed,S.level=isNaN(x.groupLevel)?0:x.groupLevel,q[S.level]=X,this._checkParentCollapsed(q,S.level)&&S._setFlag(l.RowColFlags.ParentCollapsed,!0),o.rows.push(S)):(v=new l.Row,x&&this._checkParentCollapsed(q,x.groupLevel)&&v._setFlag(l.RowColFlags.ParentCollapsed,!0),o.rows.push(v)),x&&x.height&&!isNaN(x.height)&&(o.rows[L?U-1:U].height=x.height),V=0;V<w;V++)if(x){if(y=x.cells[V],(R=y?y.formula:null)&&"="!==R[0]&&(R="="+R),y&&y.textRuns&&y.textRuns.length>0?(o.rows[L?U-1:U].isContentHtml=!0,o.setCellData(L?U-1:U,V,this._parseTextRunsToHTML(y.textRuns))):o.setCellData(L?U-1:U,V,R&&P?R:this._getItemValue(y)),b||this._setColumn(i,V,y),A=U*w+V,F=y?y.style:null,D=e.xlsx.Workbook._parseExcelFormat(y),F){if(I=null==I?!!F.wordWrap:I&&!!F.wordWrap,E=this._getItemType(y),F.hAlign)z=e.xlsx.Workbook._parseHAlignToString(e.asEnum(F.hAlign,e.xlsx.HAlign));else switch(E){case e.DataType.Number:z="right";break;case e.DataType.Boolean:z="center";break;default:z=D&&0===D.search(/[n,c,p]/i)?"right":"left"}H[A]={fontWeight:F.font&&F.font.bold?"bold":"none",fontStyle:F.font&&F.font.italic?"italic":"none",textDecoration:F.font&&F.font.underline?"underline":"none",textAlign:z,fontFamily:F.font&&F.font.family?F.font.family:"",fontSize:F.font&&F.font.size?F.font.size+"px":"",color:F.font&&F.font.color?F.font.color:"",backgroundColor:F.fill&&F.fill.color?F.fill.color:"",whiteSpace:F.wordWrap?"pre-wrap":"normal",format:D},F.borders&&(F.borders.left&&(this._parseBorderStyle(F.borders.left.style,"Left",H[A]),H[A].borderLeftColor=F.borders.left.color),F.borders.right&&(this._parseBorderStyle(F.borders.right.style,"Right",H[A]),H[A].borderRightColor=F.borders.right.color),F.borders.top&&(this._parseBorderStyle(F.borders.top.style,"Top",H[A]),H[A].borderTopColor=F.borders.top.color),F.borders.bottom&&(this._parseBorderStyle(F.borders.bottom.style,"Bottom",H[A]),H[A].borderBottomColor=F.borders.bottom.color)),F.font&&-1===N.indexOf(F.font.family)&&N.push(F.font.family)}if(y&&e.isNumber(y.rowSpan)&&y.rowSpan>0&&e.isNumber(y.colSpan)&&y.colSpan>0&&(y.rowSpan>1||y.colSpan>1))for(n=U;n<U+y.rowSpan;n++)for(s=V;s<V+y.colSpan;s++)B[A=n*w+s]=new l.CellRange(U,V,U+y.rowSpan-1,V+y.colSpan-1)}else o.setCellData(L?U-1:U,V,""),this._setColumn(i,V,null);x&&(this._checkParentCollapsed(q,x.groupLevel)||x.visible||null==x.visible||(o.rows[L?U-1:U].visible=x.visible),o.rows[L?U-1:U].wordWrap=!!x.style&&!!x.style.wordWrap||!!I)}for(S&&(S.isCollapsed=X),m.frozenPane&&(T=m.frozenPane.columns,e.isNumber(T)&&!isNaN(T)&&(o.frozenColumns=T),W=m.frozenPane.rows,e.isNumber(W)&&!isNaN(W)&&(o.frozenRows=L&&W>0?W-1:W)),V=0;V<o.columnHeaders.columns.length;V++)d=i[V],(u=o.columns[V]).isRequired=!1,L&&(h=f?f.cells[V]:null)&&h.value?(p=e.xlsx.Workbook._parseExcelFormat(h),c=e.Globalize.format(h.value,p)):c=this._numAlpha(V),u.header=c,d&&(d.dataType===e.DataType.Boolean&&(u.dataType=d.dataType),u.format=d.format,u.align=d.hAlign,u.wordWrap=u.wordWrap||!!d.wordWrap);P&&(o.wj_sheetInfo.name=m.name,o.wj_sheetInfo.visible=!0===j||!1!==m.visible,o.wj_sheetInfo.styledCells=H,o.wj_sheetInfo.mergedRanges=B,o.wj_sheetInfo.fonts=N,o.wj_sheetInfo.tables=m.tables)}},o._parseFlexGridRowToSheetRow=function(o,t,n,s,a,i,d,u,c,f,h,p){var x,m,g,w,b,y,_,k,C,v,S,T,W,R,A,F,H,B,N,D,E,z,I,G,L,O,M,j=!1;for(B=(x=o.grid).wj_sheetInfo,z=null!=(m=o.rows[n]).recordIndex?m.recordIndex:0,t.cells||(t.cells=[]),t.visible=m.isVisible,t.height=m.renderHeight||o.rows.defaultSize,t.groupLevel=f,c&&(t.collapsed=m.isCollapsed),m.wordWrap&&(t.style={wordWrap:m.wordWrap}),(m.constructor===e.grid.Row||m.constructor===e.grid._NewRowTemplate||e.grid.detail&&m.constructor===e.grid.detail.DetailRow||e.grid.multirow&&m.constructor===e.grid.multirow._MultiRow)&&(j=!0),w=0;w<o.columns.length;w++)if(b=null,H=1,F=1,M=0,E=!1,R=null,L=null,G=null,k=null,D=x._getBindingColumn(o,n,o.columns[w]),A=null,B&&o===x.cells?(W=n*o.columns.length+w,B.mergedRanges&&(A=B.mergedRanges[W]),B.styledCells&&(R=B.styledCells[W])):i&&(G=this._getMeasureCell(o,w,d,u),R=(A=x.getMergedRange(o,n,w,!1))?this._getCellStyle(o,G,A.bottomRow,A.rightCol)||{}:this._getCellStyle(o,G,n,w)||{}),A||(A=x.getMergedRange(o,n,w,!1)),A?n===A.topRow&&w===A.leftCol&&(F=A.bottomRow-A.topRow+1,H=this._getColSpan(o,A,h),E=!0):E=!0,!h||h(D)){if(g=a[z][w+s],j||c?(_=E?o.getCellData(n,w,!0):null,C=E?o.getCellData(n,w,!1):null,S=!1,_&&e.isString(_)&&_.length>1&&"="===_[0]&&(S=!0),N=e.isDate(C),R&&R.format?(b=R.format,/[hsmyt\:]/i.test(b)&&(N=!0),y=e.xlsx.Workbook._parseCellFormat(R.format,N)):g&&g.style&&g.style.format?(b=D.format,y=g.style.format):y=null,y||(N?y="m/d/yyyy":e.isNumber(C)&&!D.dataMap?y=e.isInt(C)?"#,##0":"#,##0.00":S?(T=_.toLowerCase()).indexOf("now()")>-1?(y="m/d/yyyy h:mm",N=!0):T.indexOf("today()")>-1||T.indexOf("date(")>-1?(y="m/d/yyyy",N=!0):T.indexOf("time(")>-1&&(y="h:mm AM/PM",N=!0):y="General")):(_=E?x.columnHeaders.getCellData(0,w,!0):null,y="General"),e.isString(_)&&-1!==_.indexOf("<span")&&(k=this._parseToTextRuns(_),_=null),L=this._parseCellStyle(R)||{},o===x.cells&&c&&m.hasChildren&&w===x.columns.firstVisibleIndex){if(_?v=_:E&&(v=m.getGroupHeader().replace(/<\/?\w+>/g,"").replace(/&#39;/g,"'")),null==v&&!R)continue;!(N=e.isDate(v))&&b&&"d"===b.toLowerCase()&&e.isInt(v)&&(y="0"),v=e.isString(v)?e.xlsx.Workbook._unescapeXML(v):v,w===x.columns.firstVisibleIndex&&x.treeIndent&&(M=f),I={value:v,isDate:N,formula:S?this._parseToExcelFormula(_,N):null,colSpan:H,rowSpan:F,style:this._extend(L,{format:y,font:{bold:!0},hAlign:e.xlsx.HAlign.Left,indent:M}),textRuns:k}}else _=e.isString(_)?e.xlsx.Workbook._unescapeXML(_):_,C=e.isString(C)?e.xlsx.Workbook._unescapeXML(C):C,!N&&b&&"d"===b.toLowerCase()&&e.isInt(C)&&(y="0"),O=L&&L.hAlign?L.hAlign:g&&g.style&&null!=g.style.hAlign?e.asEnum(g.style.hAlign,e.xlsx.HAlign,!0):e.isDate(C)?e.xlsx.HAlign.Left:e.xlsx.HAlign.General,w!==x.columns.firstVisibleIndex||!x.treeIndent||O!==e.xlsx.HAlign.Left&&O!==e.xlsx.HAlign.General||(M=f),I={value:S?null:"General"===y?_:C,isDate:N,formula:S?this._parseToExcelFormula(_,N):null,colSpan:w<x.columns.firstVisibleIndex?1:H,rowSpan:F,style:this._extend(L,{format:y,hAlign:O,vAlign:F>1?o===x.cells||!1===x.centerHeadersVertically?e.xlsx.VAlign.Top:e.xlsx.VAlign.Center:null,indent:M}),textRuns:k};p&&p(new r(o,new l.CellRange(n,w),G,d,u,I)),t.cells.push(I)}return s+w},o._parseCellStyle=function(l,o){if(void 0===o&&(o=!1),null==l)return null;var t=l.fontSize;t=t?+t.substring(0,t.indexOf("px")):null,isNaN(t)&&(t=null);var r=l.fontWeight;r="bold"===r||+r>=700;var n="italic"===l.fontStyle,s=l.textDecorationStyle;null==s&&(s=l.textDecoration),s="underline"===s;var a=l.whiteSpace;return a=!!a&&a.indexOf("pre")>-1,{font:{bold:r,italic:n,underline:s,family:this._parseToExcelFontFamily(l.fontFamily),size:t,color:l.color},fill:{color:l.backgroundColor},borders:this._parseBorder(l,o),hAlign:e.xlsx.Workbook._parseStringToHAlign(l.textAlign),wordWrap:a}},o._parseBorder=function(e,l){var o={};return o.left=this._parseEgdeBorder(e,"Left"),o.right=this._parseEgdeBorder(e,"Right"),o.top=this._parseEgdeBorder(e,"Top"),o.bottom=this._parseEgdeBorder(e,"Bottom"),l&&(o.vertical=this._parseEgdeBorder(e,"Vertical"),o.horizontal=this._parseEgdeBorder(e,"Horizontal")),o},o._parseEgdeBorder=function(l,o){var t,r=l["border"+o+"Style"],n=l["border"+o+"Width"];if(n&&n.length>2&&(n=+n.substring(0,n.length-2)),r&&"none"!==r&&"hidden"!==r){switch(t={},r=r.toLowerCase()){case"dotted":t.style=n>1?e.xlsx.BorderStyle.MediumDashDotted:e.xlsx.BorderStyle.Dotted;break;case"dashed":t.style=n>1?e.xlsx.BorderStyle.MediumDashed:e.xlsx.BorderStyle.Dashed;break;case"double":t.style=e.xlsx.BorderStyle.Double;break;default:t.style=n>2?e.xlsx.BorderStyle.Thick:n>1?e.xlsx.BorderStyle.Medium:e.xlsx.BorderStyle.Thin}t.color=l["border"+o+"Color"]}return t},o._parseBorderStyle=function(l,o,t){var r="border"+o+"Style",n="border"+o+"Width";switch(l){case e.xlsx.BorderStyle.Dotted:case e.xlsx.BorderStyle.Hair:t[r]="dotted",t[n]="1px";break;case e.xlsx.BorderStyle.Dashed:case e.xlsx.BorderStyle.ThinDashDotDotted:case e.xlsx.BorderStyle.ThinDashDotted:t[r]="dashed",t[n]="1px";break;case e.xlsx.BorderStyle.MediumDashed:case e.xlsx.BorderStyle.MediumDashDotDotted:case e.xlsx.BorderStyle.MediumDashDotted:case e.xlsx.BorderStyle.SlantedMediumDashDotted:t[r]="dashed",t[n]="2px";break;case e.xlsx.BorderStyle.Double:t[r]="double",t[n]="3px";break;case e.xlsx.BorderStyle.Medium:t[r]="solid",t[n]="2px";break;default:t[r]="solid",t[n]="1px"}},o._parseToExcelFontFamily=function(e){var l;return e&&(l=e.split(","))&&l.length>0&&(e=l[0].replace(/\"|\'/g,"")),e},o._parseToExcelFormula=function(l,o){var t,r,n,s,a,i,d,u=/(floor|ceiling)\([+-]?\d+\.?\d*\)/gi,c=/text\(\"?\w+\"?\s*\,\s*\"\w+\"\)/gi,f=/\"?\w+\"?\s*\,\s*\"(\w+)\"/i;if(t=l.match(u))for(a=0;a<t.length;a++)d=(i=t[a]).substring(0,i.lastIndexOf(")"))+", 1)",l=l.replace(i,d);if(t=null,t=l.match(c))for(a=0;a<t.length;a++)(r=(i=t[a]).match(f))&&2===r.length&&(n=r[1],/^d{1,4}?$/.test(n)||(s=e.xlsx.Workbook._parseCellFormat(n,o),d=i.replace(n,s),l=l.replace(i,d)));return l},o._parseToTextRuns=function(e){var l,o,t,r=e.split("<span "),n=[];for(l=0;l<r.length;l++)t=-1!==(o=r[l]).indexOf("</span>")?{text:o.substring(o.indexOf(">")+1,o.indexOf("</span>")),font:this._parseToTextRunFont(o.substring(o.indexOf('style="')+7,o.indexOf(';"')))}:{text:o},n.push(t);return n},o._parseToTextRunFont=function(e){var l,o,t,r,n,s,a,i,d,u=e.split(";");if(u.length>0){for(l=0;l<u.length;l++)if(2===(o=u[l].split(":")).length)switch(o[1]=o[1].trim(),o[0]){case"font-size":s=+o[1].substring(0,o[1].indexOf("px")),isNaN(s)&&(s=null);break;case"font-weight":t="bold"===o[1]||+o[1]>=700;break;case"font-style":r="italic"===o[1];break;case"text-decoration-style":case"text-decoration":n="underline"===o[1];break;case"font-family":a=this._parseToExcelFontFamily(o[1]);break;case"color":i=o[1]}d={bold:t,italic:r,underline:n,family:a,size:s,color:i}}return d},o._getMeasureCell=function(e,l,o,t){var r=t[e.cellType],n=r&&r[l],s=null==n;if(n){if(this.hasCssText){n.style;n.style.cssText="",n.style.visibility="hidden"}}else r||(t[e.cellType]=r=[]),r[l]=n=o.cloneNode();return!s&&n.parentElement||(e.hostElement.children.length>0?e.hostElement.children[0].appendChild(n):e.hostElement.appendChild(n)),n},o._getColumnSetting=function(l,o){var t=l.renderWidth;return t=t||o,{autoWidth:!0,width:t,visible:l.visible,style:{format:l.format?e.xlsx.Workbook._parseCellFormat(l.format,l.dataType===e.DataType.Date):"",hAlign:e.xlsx.Workbook._parseStringToHAlign(this._toExcelHAlign(l.getAlignment())),wordWrap:l.wordWrap}}},o._toExcelHAlign=function(e){return(e=e?e.trim().toLowerCase():e)?e.indexOf("center")>-1?"center":e.indexOf("right")>-1||e.indexOf("end")>-1?"right":e.indexOf("justify")>-1?"justify":"left":e},o._getColumnCount=function(l){for(var o,t=0,r=0,n=0;n<l.length;n++)(o=l[n]&&l[n].cells?l[n].cells:[])&&o.length>0&&(r=o.length,e.isInt(o[r-1].colSpan)&&o[r-1].colSpan>1&&(r=r+o[r-1].colSpan-1),r>t&&(t=r));return t},o._getRowCount=function(l,o){for(var t,r,n,s=l.length,a=s-1,i=0;i<o;i++)e:for(;a>=0;a--)if(t=l[a],r=t&&t.cells?t.cells:[],(n=r[i])&&(null!=n.value&&""!==n.value||e.isInt(n.rowSpan)&&n.rowSpan>1)){e.isInt(n.rowSpan)&&n.rowSpan>1&&a+n.rowSpan>s&&(s=a+n.rowSpan);break e}return s},o._numAlpha=function(e){var l=Math.floor(e/26)-1;return(l>-1?this._numAlpha(l):"")+String.fromCharCode(65+e%26)},o._getItemType=function(l){return null==l||null==l.value||isNaN(l.value)?null:e.getType(l.value)},o._setColumn=function(l,o,t){var r,n,s,a=l[o];a?(r=this._getItemType(t),a.dataType!==r&&a.dataType===e.DataType.Boolean&&r!==e.DataType.Boolean&&(a.dataType=r),t&&null!=t.value&&""!==t.value&&(n=e.xlsx.Workbook._parseExcelFormat(t))&&a.format!==n&&"General"!==n&&(a.format=n),t&&t.style&&(t.style.hAlign&&(s=e.xlsx.Workbook._parseHAlignToString(e.asEnum(t.style.hAlign,e.xlsx.HAlign))),null==a.wordWrap?a.wordWrap=!!t.style.wordWrap:a.wordWrap=a.wordWrap&&!!t.style.wordWrap),s||r!==e.DataType.Number||(s="right"),a.hAlign=s):l[o]={dataType:this._getItemType(t),format:e.xlsx.Workbook._parseExcelFormat(t),hAlign:"",wordWrap:null}},o._getItemValue=function(l){if(null==l||null==l.value)return null;var o=l.value;return e.isNumber(o)&&isNaN(o)?"":o instanceof Date&&isNaN(o.getTime())?"":o},o._getCellStyle=function(e,l,o,t){try{e.grid.cellFactory.updateCell(e,o,t,l),l.className=l.className.replace("wj-state-selected",""),l.className=l.className.replace("wj-state-multi-selected","")}catch(e){return null}return window.getComputedStyle(l)},o._parseTextRunsToHTML=function(e){var l,o,t,r;for(t="",r=0;r<e.length;r++)t+=(o=(l=e[r]).font)?'<span style="'+(o.bold?"font-weight: bold;":"")+(o.italic?"font-style: italic;":"")+(o.underline?"text-decoration: underline;":"")+(o.family?"font-family: "+o.family+";":"")+(null!=o.size?"font-size: "+o.size+"px;":"")+(o.color?"color: "+o.color+";":"")+'">'+l.text+"</span>":l.text;return t},o._extend=function(l,o){for(var t in o){var r=o[t];e.isObject(r)&&l[t]?e.copy(l[t],r):l[t]=r}return l},o._checkParentCollapsed=function(e,l){var o=!1;return Object.keys(e).forEach(function(t){!0===e[t]&&!1===o&&!isNaN(l)&&+t<l&&(o=!0)}),o},o._getColSpan=function(e,l,o){for(var t=0,r=l.leftCol;r<=l.rightCol;r++)o&&!o(e.columns[r])||t++;return t},o}();o.FlexGridXlsxConverter=t;var r=function(e){function l(l,o,t,r,n,s){var a=e.call(this,l,o)||this;return a._cell=t,a._patternCell=r,a._xlsxCell=s,a._cellsCache=n,a}return __extends(l,e),Object.defineProperty(l.prototype,"cell",{get:function(){return this._cell},enumerable:!0,configurable:!0}),Object.defineProperty(l.prototype,"xlsxCell",{get:function(){return this._xlsxCell},set:function(e){this._xlsxCell=e},enumerable:!0,configurable:!0}),l.prototype.getFormattedCell=function(){return this._cell||(this._cell=t._getMeasureCell(this.panel,this.col,this._patternCell,this._cellsCache),t._getCellStyle(this.panel,this._cell,this.row,this.col)),this._cell},l}(e.grid.CellRangeEventArgs);o.XlsxFormatItemEventArgs=r}(l.xlsx||(l.xlsx={}))}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));
/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var JSZip=window.JSZip;void 0!==JSZip&&JSZip||"function"!=typeof window.require||(JSZip=window.require("node-zip"));var wijmo;!function(e){!function(t){"use strict";t.useJSZip=function(e){JSZip=e};var s=function(){function s(){}return s.load=function(t){var s=new JSZip;e.assert(null==s.loadAsync,"Please use JSZip 2.5 to load excel files synchronously.");var l,r=new i(s);return this._loadImpl(r,t).then(function(e){return l=e}),l},s.loadAsync=function(t){var s=new JSZip;return e.assert(null!=s.loadAsync,"Please use JSZip 3.0 to load excel files asynchrounously."),this._loadImpl(s,t)},s.save=function(e){var t=Date.now(),s=this._saveWorkbookToZip(e);t=Date.now()-t;var l="";l=this._macroEnabled?"application/vnd.ms-excel.sheet.macroEnabled.12;":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;";var i=Date.now(),r=s.generate({compression:"DEFLATE"});return{base64:r,zipTime:Date.now()-i,processTime:t,href:function(){return"data:"+l+"base64,"+r}}},s.saveAsync=function(e,t){var s=this._saveWorkbookToZip(e,!0).generateAsync({type:"base64",compression:"DEFLATE"});return t&&s.catch(t),s},s._loadImpl=function(e,t){var s,l=this,i=Date.now(),r={sheets:[]},n=e.loadAsync(t,{base64:!0}).then(function(e){return s=e});t=null;var o=n.constructor;return n=n.then(function(){var e=s.file("xl/theme/theme1.xml");if(e)return e.async("string").then(function(e){l._getTheme(e),r.colorThemes=l._colorThemes}).then(function(){var e=o.resolve();return e=l._getZipStyle(s,e,r),e=l._getZipSharedString(s,e,r)});var t=o.resolve();return t=l._getZipStyle(s,t,r),t=l._getZipSharedString(s,t,r)}),n=n.then(function(){var e=s.file("xl/workbook.xml");if(e)return e.async("string").then(function(e){l._getWorkbook(e,r)})}),n=n.then(function(){l._tables=null;var e=o.resolve();return s.folder("xl/tables").forEach(function(t,s){null==l._tables&&(l._tables=[]),e=e.then(function(){return s.async("string").then(function(e){var t=l._getTable(e);t.fileName=s.name.substring(s.name.lastIndexOf("/")+1),l._tables.push(t)})})}),e}),n=n.then(function(){var e=s.file("docProps/core.xml");if(e)return e.async("string").then(function(e){l._getCoreSetting(e,r)})}),n=n.then(function(){var e=s.file("xl/vbaProject.bin");if(e)return e.async("uint8array").then(function(e){null==r.reservedContent&&(r.reservedContent={}),r.reservedContent.macros=e})}),(n=n.then(function(){var e=o.resolve();return s.folder("xl/worksheets").forEach(function(t,i){if(t&&-1===t.indexOf("/")){var n=l._getSheetIndex(i.name);e=e.then(function(){return i.async("string").then(function(e){if(l._getSheet(e,n-1,r),null!=r.sheets[n-1].tableRIds||null!=r.sheets[n-1].hyperlinkRIds){var t=s.file("xl/worksheets/_rels/sheet"+n+".xml.rels");if(t)return t.async("string").then(function(e){for(var t=e.split("<Relationship "),s=t.length;--s;){var i=t[s],o=l._getAttr(i,"Id");r.sheets[n-1].tableRIds&&-1!==r.sheets[n-1].tableRIds.indexOf(o)?(null==r.sheets[n-1].tables&&(r.sheets[n-1].tables=[]),r.sheets[n-1].tables.push(l._getSheetRelatedTable(i))):r.sheets[n-1].hyperlinkRIds&&l._getSheetRelatedHyperlink(i,o,r.sheets[n-1])}})}})})}}),e})).then(function(){return r.processTime=Date.now()-i,s=null,r})},s._getZipStyle=function(e,t,s){var l=this,i=e.file("xl/styles.xml");return i&&(t=t.then(function(){return i.async("string").then(function(e){l._getStyle(e),s.styles=l._styles,null!=l._tableStyles&&(s.tableStyles=l._tableStyles)})})),t},s._getZipSharedString=function(e,t,s){var l=this,i=e.file("xl/sharedStrings.xml");return i&&t.then(function(){return i.async("string").then(function(e){l._getSharedString(e)})}),t},s._saveWorkbookToZip=function(t,s){void 0===s&&(s=!1);Date.now();var l=new JSZip;s?e.assert(null!=l.generateAsync,"Please use JSZip 3.0 to save excel files asynchrounously."):e.assert(null==l.generateAsync,"Please use JSZip 2.5 to save excel files synchronously."),l.folder("_rels").file(".rels",this._xmlDescription+this._generateRelsDoc());var i=l.folder("docProps"),r=l.folder("xl");this._colorThemes=t.colorThemes,r.folder("theme").file("theme1.xml",this._xmlDescription+this._generateThemeDoc()),this._macroEnabled=!(!t.reservedContent||!t.reservedContent.macros),this._macroEnabled&&r.file("vbaProject.bin",t.reservedContent.macros);var n=r.folder("worksheets");i.file("core.xml",this._xmlDescription+this._generateCoreDoc(t)),this._sharedStrings=[[],0],this._styles=new Array(1),this._borders=new Array(1),this._fonts=new Array(1),this._fills=new Array(2),this._tableStyles=new Array,this._dxfs=new Array,this._contentTypes=[],this._props=[],this._xlRels=[],this._worksheets=[],this._tables=[],this._tableStyles=[];for(var o,a=t.sheets.length;a--;)if(this._generateWorkSheet(a,t,n),t.sheets[a]&&(t.sheets[a].tables&&t.sheets[a].tables.length>0||t.sheets[a].externalLinks&&t.sheets[a].externalLinks.length>0)){var h=0,u='<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">';if(t.sheets[a].externalLinks&&t.sheets[a].externalLinks.length>0&&(u+=this._generateHyperlinkRel(t.sheets[a].externalLinks),h=t.sheets[a].externalLinks.length),t.sheets[a].tables&&t.sheets[a].tables.length>0){null==o&&(o=r.folder("tables"));for(var c=0;c<t.sheets[a].tables.length;c++){var f=t.sheets[a].tables[c];this._generateTable(f,o),u+='<Relationship Target="../tables/'+f.fileName+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/table" Id="rId'+(c+1+h)+'"/>'}}u+="</Relationships>",n.folder("_rels").file("sheet"+(a+1)+".xml.rels",this._xmlDescription+u)}r.file("styles.xml",this._xmlDescription+this._generateStyleDoc()),l.file("[Content_Types].xml",this._xmlDescription+this._generateContentTypesDoc()),i.file("app.xml",this._xmlDescription+this._generateAppDoc(t)),r.folder("_rels").file("workbook.xml.rels",this._xmlDescription+this._generateWorkbookRels());var d=this._xmlDescription+this._generateSharedStringsDoc();return this._sharedStrings=[[],0],r.file("sharedStrings.xml",d),d=null,r.file("workbook.xml",this._xmlDescription+this._generateWorkbook(t)),l},s._getSharedString=function(e){var s,l,i,r,n,o,a,h=e.split(/<si.*?>/g),u=h.length;for(this._sharedStrings=[];--u;)for(s=1,r=!1,h[u].search(/<r>/gi)>-1?(r=!0,l=h[u].split(/<r>/g)):(h[u]=h[u].substring(0,h[u].indexOf("</t>")),l=h[u].split(/<t.*?>/g));s<l.length;)o=null,r?(-1!==l[s].indexOf("<rPr>")&&(o=this._getTextRunFont(l[s])),(i=l[s].match(/(<t.*?>)(.*)/))&&3===i.length&&null!=i[2]&&(a=i[2].substring(0,i[2].indexOf("</t>"))),n={font:o,text:t.Workbook._unescapeXML(a)},null==this._sharedStrings[u-1]?this._sharedStrings[u-1]=[n]:this._sharedStrings[u-1].push(n)):this._sharedStrings[u-1]=t.Workbook._unescapeXML(l[s]),s++},s._getInlineString=function(e){for(var t=e.split("<t>"),s=t.length,l="";--s;)l+=t[s].substring(0,t[s].indexOf("</t>"));return l},s._getCoreSetting=function(e,t){var s,l;(l=e.indexOf("<dc:creator>"))>=0&&(s=e.substr(l+12),t.creator=s.substring(0,s.indexOf("</dc:creator>"))),(l=e.indexOf("<cp:lastModifiedBy>"))>=0&&(s=e.substr(l+19),t.lastModifiedBy=s.substring(0,s.indexOf("</cp:lastModifiedBy>"))),(l=e.indexOf('<dcterms:created xsi:type="dcterms:W3CDTF">'))>=0&&(s=e.substr(l+43),t.created=new Date(s.substring(0,s.indexOf("</dcterms:created>")))),(l=e.indexOf('<dcterms:modified xsi:type="dcterms:W3CDTF">'))>=0&&(s=e.substr(l+44),t.modified=new Date(s.substring(0,s.indexOf("</dcterms:modified>"))))},s._getWorkbook=function(e,t){var s,l,i,r,n,o,a,h,u=e.substring(e.indexOf("<bookViews>"),e.indexOf("</bookViews>")),c="",f=e.indexOf("<definedNames>");for(u&&(c=this._getAttr(u,"activeTab")),t.activeWorksheet=+c,o=(n=e.split("<sheet ")).length;--o;)a=this._getAttr(n[o],"name"),h="hidden"!==this._getAttr(n[o],"state"),t.sheets.unshift({name:a,visible:h,columns:[],rows:[]});if(f>-1)for(t.definedNames=[],o=(n=e.substring(f,e.indexOf("</definedNames>")).split("<definedName ")).length;--o;)a=this._getAttr(n[o],"name"),(l=n[o].match(/.*>.+(?=<\/definedName>)/))&&(l=l[0].replace(/(.*>)(.+)/,"$2"),l=isNaN(+l)?l:+l),s={name:a,value:l},""!==(i=this._getAttr(n[o],"localSheetId"))&&(r=t.sheets[+i])&&(s.sheetName=r.name),t.definedNames.unshift(s)},s._getTheme=function(e){e=e.substring(e.indexOf("<a:clrScheme"),e.indexOf("</a:clrScheme>")),this._colorThemes=this._defaultColorThemes.slice(),this._colorThemes[0]=this._getAttr(e.substring(e.indexOf("a:lt1"),e.indexOf("</a:lt1>")),"lastClr")||this._getAttr(e.substring(e.indexOf("a:lt1"),e.indexOf("</a:lt1>")),"val"),this._colorThemes[1]=this._getAttr(e.substring(e.indexOf("a:dk1"),e.indexOf("</a:dk1>")),"lastClr")||this._getAttr(e.substring(e.indexOf("a:dk1"),e.indexOf("</a:dk1>")),"val"),this._colorThemes[2]=this._getAttr(e.substring(e.indexOf("a:lt2"),e.indexOf("</a:lt2>")),"val"),this._colorThemes[3]=this._getAttr(e.substring(e.indexOf("a:dk2"),e.indexOf("</a:dk2>")),"val");for(var t=e.substring(e.indexOf("<a:accent1"),e.indexOf("</a:accent6>")).split("<a:accent"),s=t.length;--s;)this._colorThemes[s+3]=this._getAttr(t[s],"val")},s._getStyle=function(e){var s,l,i,r,n,o=[],a=[],h=[],u=this._numFmts.slice();if(this._styles=[],(i=e.indexOf("<numFmts"))>=0){var c=e.substring(i+8,e.indexOf("</numFmts>")).split("<numFmt");for(s=c.length;--s;)l=c[s],u[+this._getAttr(l,"numFmtId")]=this._getAttr(l,"formatCode")}if((i=e.indexOf("<fonts"))>=0){var f=e.substring(i,e.indexOf("</fonts>")).split("<font>");for(s=f.length;--s;)l=f[s],r=this._getChildNodeValue(l,"sz"),o[s-1]={bold:l.indexOf("<b/>")>=0,italic:l.indexOf("<i/>")>=0,underline:l.indexOf("<u/>")>=0,size:Math.round(r?96*+r/72:14),family:this._getChildNodeValue(l,"name"),color:this._getColor(l,!1)},r=null}if((i=e.indexOf("<fills"))>=0){var d=e.substring(i,e.indexOf("</fills>")).split("<fill>");for(s=d.length;--s;)a[s-1]=this._getColor(d[s],!0)}if((i=e.indexOf("<borders"))>=0){var p=e.substring(i,e.indexOf("</borders>")).split("<border>");for(s=p.length;--s;)l=p[s],h[s-1]={left:this._getEdgeBorder(l,"left"),right:this._getEdgeBorder(l,"right"),top:this._getEdgeBorder(l,"top"),bottom:this._getEdgeBorder(l,"bottom")}}if((i=e.indexOf("<cellXfs"))>=0){var m=e.substring(i,e.indexOf("</cellXfs>")).split("<xf");s=m.length;for(var g,_,y,b,v,S;--s;)l=m[s],_=(g=u[y=+this._getAttr(l,"numFmtId")])?/[hsmy\:]/i.test(g)?"date":g.indexOf("0")>-1?"number":"@"===g?"string":"unknown":"unknown",b=(y=+this._getAttr(l,"fontId"))>0?o[y]:null,v=(y=+this._getAttr(l,"fillId"))>1?a[y]:null,S=(y=+this._getAttr(l,"borderId"))>0?h[y]:null,i=l.indexOf("<alignment"),n=+this._getAttr(l,"quotePrefix"),this._styles.unshift({formatCode:g,type:_,font:b,fillColor:v,borders:S,hAlign:i>=0?t.Workbook._parseStringToHAlign(this._getAttr(l,"horizontal")):null,vAlign:i>=0?t.Workbook._parseStringToVAlign(this._getAttr(l,"vertical")):null,wordWrap:i>=0?"1"===this._getAttr(l,"wrapText"):null,quotePrefix:1===n})}if(e.indexOf("<tableStyle ")>-1){this._tableStyles=[];var w=e.substring(e.indexOf("<tableStyles "),e.indexOf("</tableStyles>")),x=e.substring(e.indexOf("<dxfs "),e.indexOf("</dxfs>"));this._getTableStyles(w,x.split("<dxf>"))}},s._getEdgeBorder=function(e,s){var l,i,r,n,o=e.indexOf("<"+s),a=e.indexOf("</"+s+">");if(o>=0){i=e.substring(o),i=a>=0?i.substring(0,a):i.substring(0,i.indexOf("/>"));var h=this._getAttr(i,"style");h&&(r=t.Workbook._parseStringToBorderType(h),n=this._getColor(i,!1),r===t.BorderStyle.Thin&&n&&"#c6c6c6"===n.toLowerCase()||((l={}).style=r,l.color=n))}return l},s._getSheet=function(s,l,i){var r,n=[];if(s.indexOf("<mergeCells")>-1)for(var o=s.substring(s.indexOf("<mergeCells"),s.indexOf("</mergeCells>")).split("<mergeCell "),a=o.length;--a;)2===(r=this._getAttr(o[a],"ref").split(":")).length&&n.unshift({topRow:+r[0].match(/\d*/g).join("")-1,leftCol:this._alphaNum(r[0].match(/[a-zA-Z]*/g)[0]),bottomRow:+r[1].match(/\d*/g).join("")-1,rightCol:this._alphaNum(r[1].match(/[a-zA-Z]*/g)[0])});this._getsBaseSharedFormulas(s);var h=s.split("<row "),u=i.sheets[l];if(h[0].indexOf("<dimension")>=0){var c=this._getAttr(h[0].substr(h[0].indexOf("<dimension")),"ref");c&&(c=c.substr(c.indexOf(":")+1),u.maxCol=this._alphaNum(c.match(/[a-zA-Z]*/g)[0])+1,u.maxRow=+c.match(/\d*/g).join(""))}var f=s.indexOf("<tableParts");if(f>-1){var d=s.substring(f,s.indexOf("</tableParts>")).split("<tablePart "),p=d.length;for(u.tableRIds=[];--p;)u.tableRIds.unshift(this._getAttr(d[p],"r:id"))}var m=[],g=[],_=[],y=null,b=null;if(h.length>0&&h[0].indexOf("<cols>")>-1)for(var v=(m=h[0].substring(h[0].indexOf("<cols>")+6,h[0].indexOf("</cols>")).split("<col ")).length-1;v>0;v--){var S=this._parseCharWidthToPixel(+this._getAttr(m[v],"width"));b=null,m[v].indexOf("style")>-1&&(b=this._styles[+this._getAttr(m[v],"style")]||{type:"General",formatCode:null}),y=null,b&&(b.font||b.fillColor||b.hAlign||b.vAlign||b.wordWrap||b.borders||b.formatCode&&"General"!==b.formatCode)&&(y={format:b.formatCode&&"General"!==b.formatCode?b.formatCode:null,font:b.font,fill:{color:b.fillColor},borders:b.borders,hAlign:b.hAlign,vAlign:b.vAlign,wordWrap:b.wordWrap});for(var w=+this._getAttr(m[v],"min")-1;w<+this._getAttr(m[v],"max");w++)g[w]={visible:"1"!==this._getAttr(m[v],"hidden"),autoWidth:"1"===this._getAttr(m[v],"bestFit"),width:S,style:y}}if(u.columns=g,h.length>0&&h[0].indexOf("<pane")>-1&&"frozen"===this._getAttr(h[0].substr(h[0].indexOf("<pane")),"state")){var x=this._getAttr(h[0].substr(h[0].indexOf("<pane")),"ySplit"),C=this._getAttr(h[0].substr(h[0].indexOf("<pane")),"xSplit");u.frozenPane={rows:x?+x:NaN,columns:C?+C:NaN}}for(u.summaryBelow="0"!==this._getAttr(h[0],"summaryBelow"),a=h.length;--a;){var k=u.rows[+this._getAttr(h[a],"r")-1]={visible:!0,groupLevel:NaN,cells:[]};if(h[a].substring(0,h[a].indexOf(">")).indexOf("hidden")>-1&&"1"===this._getAttr(h[a],"hidden")&&(k.visible=!1),"1"===this._getAttr(h[a],"customHeight")){var F=+this._getAttr(h[a].substring(0,h[a].indexOf(">")).replace("customHeight",""),"ht");k.height=96*F/72}y=null,b=null,"1"===this._getAttr(h[a],"customFormat")&&(y=(b=this._styles[+this._getAttr(h[a].substring(h[a].indexOf(" s=")),"s")]||{type:"General",formatCode:null}).font||b.fillColor||b.hAlign||b.vAlign||b.wordWrap||b.borders||b.formatCode&&"General"!==b.formatCode?{format:b.formatCode&&"General"!==b.formatCode?b.formatCode:null,font:b.font,fill:{color:b.fillColor},borders:b.borders,hAlign:b.hAlign,vAlign:b.vAlign,wordWrap:b.wordWrap}:null),k.style=y;var T=this._getAttr(h[a],"outlineLevel");k.groupLevel=T&&""!==T?+T:NaN,k.collapsed="1"===this._getAttr(h[a],"collapsed");for(var z=h[a].split("<c "),A=z.length;--A;){var O=z[A];y=(b=this._styles[+this._getAttr(O,"s")]||{type:"General",formatCode:null}).font||b.fillColor||b.hAlign||b.vAlign||b.wordWrap||b.borders||b.formatCode&&"General"!==b.formatCode?{format:b.formatCode&&"General"!==b.formatCode?b.formatCode:null,font:b.font,fill:{color:b.fillColor},borders:b.borders,hAlign:b.hAlign,vAlign:b.vAlign,wordWrap:b.wordWrap}:null;var R=this._getAttr(O.substring(0,O.indexOf(">")),"t")||b.type,D=null,N="inlineStr"===R||O.indexOf("<is>")>=0;N?D=this._getInlineString(O):O.indexOf("<v>")>-1&&(D=O.substring(O.indexOf("<v>")+3,O.indexOf("</v>")));var B=null,W=null,P=null;O.indexOf("<f")>-1&&(O.indexOf("</f>")>-1?(B=O.match(/<f.*>.+(?=<\/f>)/))&&(B=B[0].replace(/(\<f.*>)(.+)/,"$2")):(W=this._getAttr(O,"si"))&&(P=this._getAttr(O,"r"),B=this._getSharedFormula(W,P))),null!=B&&(B=B.replace(/\[\#This Row\]\s*,\s*/gi,"@")),"str"===R||"e"===R||N||(D=D?+D:""),w=this._alphaNum(this._getAttr(O,"r").match(/[a-zA-Z]*/g)[0]);var L=null;switch(R){case"s":null!=(D=this._sharedStrings[D])&&(e.isString(D)?b&&b.quotePrefix&&"'"!==D[0]&&(D="'"+D):(L=D.slice(),D=this._getTextOfTextRuns(L)));break;case"b":D=1===D;break;case"date":D=D?this._convertDate(D):""}e.isNumber(D)&&(null==y&&(y={format:""}),e.isInt(D)?y.format=y.format||"#,##0":y.format=y.format||"#,##0.00"),k.cells[w]={value:D,textRuns:L,isDate:"date"===R,formula:t.Workbook._unescapeXML(B),style:y,visible:-1===_.indexOf(w)}}}var M=s.indexOf("<hyperlinks");if(M>-1)for(var E=s.substring(M,s.indexOf("</hyperlinks>")).split("<hyperlink "),I=E.length;--I;)this._getHyperlink(u,E[I]);if(u.frozenPane){if(!isNaN(u.frozenPane.rows))for(a=0;a<u.rows.length&&a<u.frozenPane.rows;a++)u.rows[a]&&!u.rows[a].visible&&u.frozenPane.rows++;if(!isNaN(u.frozenPane.columns))for(a=0;a<g.length&&a<u.frozenPane.columns;a++)g[a]&&!g[a].visible&&u.frozenPane.columns++}var H;for(A=0;A<n.length;A++)H=n[A],u.rows[H.topRow].cells[H.leftCol].rowSpan=H.bottomRow-H.topRow+1,u.rows[H.topRow].cells[H.leftCol].colSpan=H.rightCol-H.leftCol+1},s._getTable=function(e){var t={};t.name=this._getAttr(e,"name"),t.range=this._getAttr(e,"ref");var s=this._getAttr(e,"headerRowCount");t.showHeaderRow=""==s||"1"===s;var l=this._getAttr(e,"totalsRowCount");t.showTotalRow="1"===l;var i=e.substring(e.indexOf("<tableStyleInfo")),r=this._getAttr(i,"name");this._isBuiltInStyleName(r)?t.style={name:r}:t.style=this._getTableStyleByName(r),t.showBandedColumns="1"===this._getAttr(i,"showColumnStripes"),t.showBandedRows="1"===this._getAttr(i,"showRowStripes"),t.alterFirstColumn="1"===this._getAttr(i,"showFirstColumn"),t.alterLastColumn="1"===this._getAttr(i,"showLastColumn");var n=e.split("<tableColumn ");t.columns=[];for(var o=1;o<n.length;o++){var a=n[o];t.columns.push(this._getTableColumn(a))}if(e.indexOf("filterColumn")>-1)for(var h=e.substring(e.indexOf("<autoFilter"),e.indexOf("</autoFilter>")).split("<filterColumn"),u=1;u<h.length;u++){var c=h[u],f=+this._getAttr(c,"colId");t.columns[f].showFilterButton="1"!==this._getAttr(c,"hiddenButton")}return t},s._getTableColumn=function(e){var t={};t.name=this._getAttr(e,"name");var s=this._getAttr(e,"totalsRowLabel");if(s)t.totalRowLabel=s;else{var l=this._getAttr(e,"totalsRowFunction");"custom"===l&&(l=e.substring(e.indexOf("<totalsRowFormula>")+2+"totalsRowFormula".length,e.indexOf("</totalsRowFormula>"))),t.totalRowFunction=l}return t},s._getSheetRelatedTable=function(e){var t=this._getAttr(e,"Target");t=t.substring(t.lastIndexOf("/")+1);for(var s=0;s<this._tables.length;s++){var l=this._tables[s];if(t===l.fileName)return l}return null},s._getSheetRelatedHyperlink=function(e,t,s){for(var l=0;l<s.hyperlinkRIds.length;l++){var i=s.hyperlinkRIds[l];if(i.rId===t){var r=this._getAttr(e,"Target");s.rows[i.ref.row]&&s.rows[i.ref.row].cells[i.ref.col]&&(s.rows[i.ref.row].cells[i.ref.col].link=r)}}},s._getTableStyles=function(e,t){for(var s=e.split("<tableStyle "),l=s.length;--l;){var i={},r=s[l];i.name=this._getAttr(r,"name");for(var n=r.split("<tableStyleElement "),o=n.length;--o;){var a=n[o],h=this._getAttr(a,"type");switch(h){case"firstRowStripe":h="firstBandedRowStyle";break;case"secondRowStripe":h="secondBandedRowStyle";break;case"firstColumnStripe":h="firstBandedColumnStyle";break;case"secondColumnStripe":h="secondBandedColumnStyle";break;default:h+="Style"}var u=this._getAttr(a,"dxfId");""!==u&&(i[h]=this._getTableStyleElement(t[+u+1]));var c=this._getAttr(a,"size");c&&(null==i[h]&&(i[h]={}),i[h].size=+c)}this._tableStyles.push(i)}},s._getTableStyleElement=function(e){var t=null,s=null,l=null,i=null,r=e.indexOf("<font>");if(r>=0){t=e.substring(r,e.indexOf("</font>"));var n=this._getChildNodeValue(t,"sz");s={bold:"1"===this._getChildNodeValue(t,"b"),italic:"1"===this._getChildNodeValue(t,"i"),underline:"1"===this._getChildNodeValue(t,"u"),size:Math.round(n?96*+n/72:14),family:this._getChildNodeValue(t,"name"),color:this._getColor(t,!1)}}return t=null,(r=e.indexOf("<fill>"))>=0&&(t=e.substring(r,e.indexOf("</fill>")),l={color:this._getColor(t,!0)}),t=null,(r=e.indexOf("<border>"))>=0&&(t=e.substring(r,e.indexOf("</border>")),i={left:this._getEdgeBorder(t,"left"),right:this._getEdgeBorder(t,"right"),top:this._getEdgeBorder(t,"top"),bottom:this._getEdgeBorder(t,"bottom"),vertical:this._getEdgeBorder(t,"vertical"),horizontal:this._getEdgeBorder(t,"horizontal")}),{font:s,fill:l,borders:i}},s._getTableStyleByName=function(e){var t,s;if(null==this._tableStyles||0===this._tableStyles.length)return null;for(t=0;t<this._tableStyles.length;t++)if((s=this._tableStyles[t])&&s.name.toLowerCase()===e.toLowerCase())return s;return null},s._getHyperlink=function(e,s){var l,i,r,n,o,a;if(null!=(l=this._getAttr(s,"ref"))){r=l.split(":"),null==(o=this._getAttr(s,"r:id"))&&(a=this._getAttr(s,"location"));for(var h=0;h<r.length;h++)i=r[h],n=t.Workbook.tableAddress(i),o?(null==e.hyperlinkRIds&&(e.hyperlinkRIds=[]),e.hyperlinkRIds.push({ref:n,rId:o})):a&&e.rows[n.row]&&e.rows[n.row].cells[n.col]&&(e.rows[n.row].cells[n.col].link=a)}},s._getTextRunFont=function(e){var t=this._getChildNodeValue(e,"sz");return{bold:e.indexOf("<b/>")>=0,italic:e.indexOf("<i/>")>=0,underline:e.indexOf("<u/>")>=0,size:Math.round(t?96*+t/72:14),family:this._getChildNodeValue(e,"name"),color:this._getColor(e,!1)}},s._getTextOfTextRuns=function(e){var t,s,l="";for(t=0;t<e.length;t++)(s=e[t])&&(l+=s.text);return l},s._isBuiltInStyleName=function(e){var t;if(0===e.search(/TableStyleLight/i)){if(t=+e.substring(15),!isNaN(t)&&t>=1&&t<=21)return!0}else if(0===e.search(/TableStyleMedium/i)){if(t=+e.substring(16),!isNaN(t)&&t>=1&&t<=28)return!0}else if(0===e.search(/TableStyleDark/i)&&(t=+e.substring(14),!isNaN(t)&&t>=1&&t<=11))return!0;return!1},s._generateRelsDoc=function(){return'<Relationships xmlns="'+this._relationshipsNS+'"><Relationship Target="docProps/app.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Id="rId3"/><Relationship Target="docProps/core.xml" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Id="rId2"/><Relationship Target="xl/workbook.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Id="rId1"/></Relationships>'},s._generateThemeDoc=function(){return'<a:theme name="Office Theme" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"><a:themeElements>'+this._generateClrScheme()+this._generateFontScheme()+this._generateFmtScheme()+"</a:themeElements><a:objectDefaults/><a:extraClrSchemeLst/></a:theme>"},s._generateClrScheme=function(){return null===this._colorThemes&&(this._colorThemes=[]),'<a:clrScheme name="Office"><a:dk1><a:sysClr lastClr="'+(this._colorThemes[1]||"000000")+'" val="windowText"/></a:dk1><a:lt1><a:sysClr lastClr="'+(this._colorThemes[0]||"FFFFFF")+'" val="window"/></a:lt1><a:dk2><a:srgbClr val="'+(this._colorThemes[3]||"1F497D")+'"/></a:dk2><a:lt2><a:srgbClr val="'+(this._colorThemes[2]||"EEECE1")+'"/></a:lt2><a:accent1><a:srgbClr val="'+(this._colorThemes[4]||"4F81BD")+'"/></a:accent1><a:accent2><a:srgbClr val="'+(this._colorThemes[5]||"C0504D")+'"/></a:accent2><a:accent3><a:srgbClr val="'+(this._colorThemes[6]||"9BBB59")+'"/></a:accent3><a:accent4><a:srgbClr val="'+(this._colorThemes[7]||"8064A2")+'"/></a:accent4><a:accent5><a:srgbClr val="'+(this._colorThemes[8]||"4BACC6")+'"/></a:accent5><a:accent6><a:srgbClr val="'+(this._colorThemes[9]||"F79646")+'"/></a:accent6><a:hlink><a:srgbClr val="0000FF"/></a:hlink><a:folHlink><a:srgbClr val="800080"/></a:folHlink></a:clrScheme>'},s._generateFontScheme=function(){return'<a:fontScheme name="Office"><a:majorFont><a:latin typeface="Cambria"/><a:ea typeface=""/><a:cs typeface=""/><a:font typeface="ＭＳ Ｐゴシック" script="Jpan"/><a:font typeface="맑은 고딕" script="Hang"/><a:font typeface="宋体" script="Hans"/><a:font typeface="新細明體" script="Hant"/><a:font typeface="Times New Roman" script="Arab"/><a:font typeface="Times New Roman" script="Hebr"/><a:font typeface="Tahoma" script="Thai"/><a:font typeface="Nyala" script="Ethi"/><a:font typeface="Vrinda" script="Beng"/><a:font typeface="Shruti" script="Gujr"/><a:font typeface="MoolBoran" script="Khmr"/><a:font typeface="Tunga" script="Knda"/><a:font typeface="Raavi" script="Guru"/><a:font typeface="Euphemia" script="Cans"/><a:font typeface="Plantagenet Cherokee" script="Cher"/><a:font typeface="Microsoft Yi Baiti" script="Yiii"/><a:font typeface="Microsoft Himalaya" script="Tibt"/><a:font typeface="MV Boli" script="Thaa"/><a:font typeface="Mangal" script="Deva"/><a:font typeface="Gautami" script="Telu"/><a:font typeface="Latha" script="Taml"/><a:font typeface="Estrangelo Edessa" script="Syrc"/><a:font typeface="Kalinga" script="Orya"/><a:font typeface="Kartika" script="Mlym"/><a:font typeface="DokChampa" script="Laoo"/><a:font typeface="Iskoola Pota" script="Sinh"/><a:font typeface="Mongolian Baiti" script="Mong"/><a:font typeface="Times New Roman" script="Viet"/><a:font typeface="Microsoft Uighur" script="Uigh"/><a:font typeface="Sylfaen" script="Geor"/></a:majorFont><a:minorFont><a:latin typeface="Calibri"/><a:ea typeface=""/><a:cs typeface=""/><a:font typeface="ＭＳ Ｐゴシック" script="Jpan"/><a:font typeface="맑은 고딕" script="Hang"/><a:font typeface="宋体" script="Hans"/><a:font typeface="新細明體" script="Hant"/><a:font typeface="Arial" script="Arab"/><a:font typeface="Arial" script="Hebr"/><a:font typeface="Tahoma" script="Thai"/><a:font typeface="Nyala" script="Ethi"/><a:font typeface="Vrinda" script="Beng"/><a:font typeface="Shruti" script="Gujr"/><a:font typeface="DaunPenh" script="Khmr"/><a:font typeface="Tunga" script="Knda"/><a:font typeface="Raavi" script="Guru"/><a:font typeface="Euphemia" script="Cans"/><a:font typeface="Plantagenet Cherokee" script="Cher"/><a:font typeface="Microsoft Yi Baiti" script="Yiii"/><a:font typeface="Microsoft Himalaya" script="Tibt"/><a:font typeface="MV Boli" script="Thaa"/><a:font typeface="Mangal" script="Deva"/><a:font typeface="Gautami" script="Telu"/><a:font typeface="Latha" script="Taml"/><a:font typeface="Estrangelo Edessa" script="Syrc"/><a:font typeface="Kalinga" script="Orya"/><a:font typeface="Kartika" script="Mlym"/><a:font typeface="DokChampa" script="Laoo"/><a:font typeface="Iskoola Pota" script="Sinh"/><a:font typeface="Mongolian Baiti" script="Mong"/><a:font typeface="Arial" script="Viet"/><a:font typeface="Microsoft Uighur" script="Uigh"/><a:font typeface="Sylfaen" script="Geor"/></a:minorFont></a:fontScheme>'},s._generateFmtScheme=function(){return'<a:fmtScheme name="Office">'+this._generateFillScheme()+this._generateLineStyles()+this._generateEffectScheme()+this._generateBgFillScheme()+"</a:fmtScheme>"},s._generateFillScheme=function(){return'<a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin scaled="1" ang="16200000"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="51000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="80000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="94000"/><a:satMod val="135000"/></a:schemeClr></a:gs></a:gsLst><a:lin scaled="1" ang="16200000"/></a:gradFill></a:fillStyleLst>'},s._generateLineStyles=function(){return'<a:lnStyleLst><a:ln algn="ctr" cmpd="sng" cap="flat" w="9525"><a:solidFill><a:schemeClr val="phClr"><a:shade val="9500"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln algn="ctr" cmpd="sng" cap="flat" w="25400"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln algn="ctr" cmpd="sng" cap="flat" w="38100"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln></a:lnStyleLst>'},s._generateEffectScheme=function(){return'<a:effectStyleLst><a:effectStyle><a:effectLst><a:outerShdw dir="5400000" rotWithShape="0" dist="23000" blurRad="40000"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw dir="5400000" rotWithShape="0" dist="23000" blurRad="40000"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw dir="5400000" rotWithShape="0" dist="23000" blurRad="40000"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst><a:scene3d><a:camera prst="orthographicFront"><a:rot rev="0" lon="0" lat="0"/></a:camera><a:lightRig dir="t" rig="threePt"><a:rot rev="1200000" lon="0" lat="0"/></a:lightRig></a:scene3d><a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d></a:effectStyle></a:effectStyleLst>'},s._generateBgFillScheme=function(){return'<a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="200000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path></a:gradFill></a:bgFillStyleLst>'},s._generateCoreDoc=function(e){var t='<cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">';return e.creator?t+="<dc:creator>"+e.creator+"</dc:creator>":t+="<dc:creator/>",e.lastModifiedBy?t+="<cp:lastModifiedBy>"+e.lastModifiedBy+"</cp:lastModifiedBy>":t+="<cp:lastModifiedBy/>",t+='<dcterms:created xsi:type="dcterms:W3CDTF">'+(e.created||new Date).toISOString()+'</dcterms:created><dcterms:modified xsi:type="dcterms:W3CDTF">'+(e.modified||new Date).toISOString()+"</dcterms:modified></cp:coreProperties>"},s._generateSheetGlobalSetting=function(e,t,s){var l=t.rows&&t.rows[0]&&t.rows[0].cells?t.rows[0].cells.length:0,i=' xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">';return i+='<sheetPr><outlinePr summaryBelow="0"/></sheetPr>',i+='<dimension ref="A1'+(l>0?":"+this._numAlpha(l-1)+t.rows.length:"")+'"/>',i+='<sheetViews><sheetView workbookViewId="0"',e===s.activeWorksheet&&(i+=' tabSelected="1"'),!t.frozenPane||0===t.frozenPane.rows&&0===t.frozenPane.columns?i+="/>":(i+=">",i+='<pane state="frozen" activePane="'+(0!==t.frozenPane.rows&&0!==t.frozenPane.columns?"bottomRight":0!==t.frozenPane.rows?"bottomLeft":"topRight")+'" topLeftCell="'+(this._numAlpha(t.frozenPane.columns)+(t.frozenPane.rows+1))+'" ySplit="'+t.frozenPane.rows.toString()+'" xSplit="'+t.frozenPane.columns.toString()+'"/>',i+="</sheetView>"),i+="</sheetViews>",i+='<sheetFormatPr defaultRowHeight="15" x14ac:dyDescent="0.25"/>'},s._generateCell=function(e,s,l,i,r,n){var o='<c r="'+this._numAlpha(s)+(e+1)+'" s="'+l.toString()+'"';i&&(o+=' t="'+i+'"');var a="";return n&&("="===n[0]&&(n=n.substring(1)),n=n.replace(/\@\s*/gi,"[#This Row], "),a+="<f>"+t.Workbook._escapeXML(n)+"</f>"),null!=r&&""!==r&&(a+="<v>"+r+"</v>"),o+(a?">"+a+"</c>":"/>")},s._generateMergeSetting=function(e){for(var t='<mergeCells count="'+e.length.toString()+'">',s=0;s<e.length;s++)t+='<mergeCell ref="'+e[s].join(":")+'"/>';return t+"</mergeCells>"},s._generateStyleDoc=function(){var e='<styleSheet xmlns="'+this._workbookNS+'" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac">',t="",s="",l=[],i=0,r=0,n="",o="";o=this._generateFontStyle({},!0);var a="",h="";h+=this._generateFillStyle("none",null),h+=this._generateFillStyle("gray125",null);var u="",c="";c+=this._generateBorderStyle({});var f="",d="";for(d+=this._generateCellXfs(0,0,0,0,{});i<this._styles.length;){var p=this._styles[i];if(p){var m=0;if((p=JSON.parse(p)).format&&"General"!==p.format&&(m=this._numFmts.indexOf(p.format))<0){var g=l.indexOf(p.format);-1===g?(l.push(p.format),s+='<numFmt numFmtId="'+(m=164+r).toString()+'" formatCode="'+p.format+'"/>',r++):m=164+g}var _=0;if(p.borders){var y=JSON.stringify(p.borders);(_=this._borders.indexOf(y))<0&&(_=this._borders.push(y)-1,c+=this._generateBorderStyle(p.borders))}var b=0;if(p.font){var v=JSON.stringify(p.font);(b=this._fonts.indexOf(v))<0&&(b=this._fonts.push(v)-1,o+=this._generateFontStyle(p.font))}var S=0;if(p.fill&&p.fill.color){var w=JSON.stringify(p.fill);(S=this._fills.indexOf(w))<0&&(S=this._fills.push(w)-1,h+=this._generateFillStyle("solid",p.fill.color))}d+=this._generateCellXfs(m,_,b,S,p)}i++}l=null,r>0?(t='<numFmts count="'+r+'">',t+=s,t+="</numFmts>"):t='<numFmts count="0"/>',e+=t,n='<fonts count="'+this._fonts.length+'" x14ac:knownFonts="1">',n+=o,e+=n+="</fonts>",a='<fills count="'+this._fills.length+'">',a+=h,e+=a+="</fills>",u='<borders count="'+this._borders.length+'">',u+=c,e+=u+="</borders>",e+='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>',f='<cellXfs count="'+this._styles.length+'">',f+=d,f+="</cellXfs>";var x="",C="";return this._tableStyles.length>0&&(this._getDxfs(),this._dxfs.length>0&&(x=this._generateDxfs()),C=this._generateTableStyles()),e+=f+'<cellStyles count="1"><cellStyle xfId="0" builtinId="0" name="Normal"/></cellStyles>'+(""===x?'<dxfs count="0"/>':x)+(""===C?'<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleLight16"/>':C)+'<extLst><ext uri="{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}"><x14ac:slicerStyles defaultSlicerStyle="SlicerStyleLight1" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"/></ext></extLst></styleSheet>'},s._generateBorderStyle=function(e,t){void 0===t&&(t=!1);var s,l,i="<border>";for(var r in{left:0,right:0,top:0,bottom:0,diagonal:0,vertical:0,horizontal:0})(t||"vertical"!==r&&"horizontal"!==r)&&(e[r]?(s="<"+r+' style="'+e[r].style+'">',"",6===(l=(l=e[r].color)?"#"===l[0]?l.substring(1):l:"").length&&(l="FF"+l),l||(l="FF000000"),s+='<color rgb="'+l+'"/>',s+="</"+r+">"):s="<"+r+"/>",i+=s);return i+="</border>"},s._generateFontStyle=function(e,t){void 0===t&&(t=!1);var s="<font>";return e.bold&&(s+="<b/>"),e.italic&&(s+="<i/>"),e.underline&&(s+="<u/>"),s+='<sz val="'+(e.size?Math.round(72*e.size/96):this._defaultFontSize)+'"/>',e.color?s+='<color rgb="FF'+("#"===e.color[0]?e.color.substring(1):e.color)+'"/>':s+='<color theme="1"/>',s+='<name val="'+(e.family||this._defaultFontName)+'"/>',s+='<family val="2"/>',t&&(s+='<scheme val="minor"/>'),s+="</font>"},s._generateFillStyle=function(e,t,s){void 0===s&&(s=!1);var l,i='<fill><patternFill patternType="'+e+'">';return t&&(l=s?"<bgColor ":"<fgColor ",i+=l+='rgb="FF'+("#"===t[0]?t.substring(1):t)+'"/>'),i+="</patternFill></fill>"},s._generateCellXfs=function(e,t,s,l,i){var r='<xf xfId="0" ';if(r+='numFmtId="'+e.toString()+'" ',e>0&&(r+='applyNumberFormat="1" '),r+='borderId="'+t.toString()+'" ',t>0&&(r+='applyBorder="1" '),r+='fontId="'+s.toString()+'" ',s>0&&(r+='applyFont="1" '),r+='fillId="'+l.toString()+'" ',l>0&&(r+='applyFill="1" '),i.quotePrefix&&(r+='quotePrefix="1" '),i.hAlign||i.vAlign||i.indent||i.wordWrap){r+='applyAlignment="1">';var n="<alignment ";i.hAlign&&(n+='horizontal="'+i.hAlign+'" '),i.vAlign&&(n+='vertical="'+i.vAlign+'" '),i.indent&&(n+='indent="'+i.indent+'" '),i.wordWrap&&(n+='wrapText="1"'),r+=n+="/>",r+="</xf>"}else r+="/>";return r},s._generateContentTypesDoc=function(){var e,t='<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">';for(this._macroEnabled&&(t+='<Default ContentType="application/vnd.ms-office.vbaProject" Extension="bin"/>'),t+='<Default ContentType="application/vnd.openxmlformats-package.relationships+xml" Extension="rels"/><Default ContentType="application/xml" Extension="xml"/><Override ContentType="'+(this._macroEnabled?"application/vnd.ms-excel.sheet.macroEnabled.main+xml":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml")+'" PartName="/xl/workbook.xml"/>',e=0;e<this._contentTypes.length;e++)t+=this._contentTypes[e];for(t+='<Override ContentType="application/vnd.openxmlformats-officedocument.theme+xml" PartName="/xl/theme/theme1.xml"/><Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" PartName="/xl/styles.xml"/><Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml" PartName="/xl/sharedStrings.xml"/><Override ContentType="application/vnd.openxmlformats-package.core-properties+xml" PartName="/docProps/core.xml"/><Override ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml" PartName="/docProps/app.xml"/>',e=0;e<this._tables.length;e++)t+='<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml" PartName="/xl/tables/'+this._tables[e]+'"/>';return t+="</Types>"},s._generateAppDoc=function(e){for(var t='<Properties xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes" xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties"><Application>'+(e.application||"wijmo.xlsx")+'</Application><DocSecurity>0</DocSecurity><ScaleCrop>false</ScaleCrop><HeadingPairs><vt:vector baseType="variant" size="2"><vt:variant><vt:lpstr>Worksheets</vt:lpstr></vt:variant><vt:variant><vt:i4>'+this._props.length+'</vt:i4></vt:variant></vt:vector></HeadingPairs><TitlesOfParts><vt:vector baseType="lpstr" size="'+this._props.length+'">',s=0;s<this._props.length;s++)t+="<vt:lpstr>"+this._props[s]+"</vt:lpstr>";return t+="</vt:vector></TitlesOfParts><Manager/><Company>"+(e.company||"GrapeCity, Inc.")+"</Company><LinksUpToDate>false</LinksUpToDate><SharedDoc>false</SharedDoc><HyperlinksChanged>false</HyperlinksChanged><AppVersion>1.0</AppVersion></Properties>"},s._generateWorkbookRels=function(){for(var e='<Relationships xmlns="'+this._relationshipsNS+'">',t=0;t<this._xlRels.length;t++)e+=this._xlRels[t];return e+='<Relationship Target="sharedStrings.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Id="rId'+(this._xlRels.length+1)+'"/><Relationship Target="styles.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Id="rId'+(this._xlRels.length+2)+'"/><Relationship Target="theme/theme1.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme" Id="rId'+(this._xlRels.length+3)+'"/>',this._macroEnabled&&(e+='<Relationship Target="vbaProject.bin" Type="http://schemas.microsoft.com/office/2006/relationships/vbaProject" Id="rId'+(this._xlRels.length+4)+'"/>'),e+="</Relationships>"},s._generateWorkbook=function(e){for(var t='<workbook xmlns="'+this._workbookNS+'" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><fileVersion rupBuild="9303" lowestEdited="5" lastEdited="5" appName="xl"/><workbookPr/><bookViews><workbookView xWindow="480" yWindow="60" windowWidth="18195" windowHeight="8505"'+(null!=e.activeWorksheet?' activeTab="'+e.activeWorksheet.toString()+'"':"")+"/></bookViews><sheets>",s=0;s<this._worksheets.length;s++)t+=this._worksheets[s];if(t+="</sheets>",e.definedNames&&e.definedNames.length>0){for(t+="<definedNames>",s=0;s<e.definedNames.length;s++){var l=-1;e.definedNames[s].sheetName&&(l=this._getSheetIndexBySheetName(e,e.definedNames[s].sheetName)),t+='<definedName name="'+e.definedNames[s].name+'" '+(l>-1?'localSheetId="'+l+'"':"")+">"+e.definedNames[s].value+"</definedName>"}t+="</definedNames>"}return t+='<calcPr fullCalcOnLoad="1"/></workbook>'},s._generateWorkSheet=function(s,l,i){var r,n,o,a,h,u,c,f,d,p,m,g,_,y,b,v,S,w,x,C,k,F,T,z=1;if(r=s+1,n=l.sheets[s],o=n.columns,a=this._cloneColumnsStyle(o),!n)throw"Worksheet should not be empty!";var A='<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"';A+=this._generateSheetGlobalSetting(s,n,l);var O="<sheetData>";for(h=n.style?this._cloneStyle(n.style):null,"",[],c=[],f=-1,d=(u=n.rows)?u.length:0;++f<d;){for(p=-1,m=u[f]&&u[f].cells?u[f].cells.length:0,g=null,O+='<row x14ac:dyDescent="0.25" r="'+(f+1).toString()+'"',u[f]&&(u[f].height&&(O+=' customHeight="1" ht="'+(72*+u[f].height/96).toString()+'"'),u[f].groupLevel&&(O+=' outlineLevel="'+u[f].groupLevel.toString()+'"'),(g=u[f].style?this._cloneStyle(u[f].style):null)&&((g=this._resolveStyleInheritance(g)).font&&g.font.color&&(g.font.color=this._parseColor(g.font.color)),g.fill&&g.fill.color&&(g.fill.color=this._parseColor(g.fill.color)),null==g.hAlign||e.isString(g.hAlign)||(g.hAlign=t.Workbook._parseHAlignToString(e.asEnum(g.hAlign,t.HAlign))),null==g.vAlign||e.isString(g.vAlign)||(g.vAlign=t.Workbook._parseVAlignToString(e.asEnum(g.vAlign,t.VAlign))),_=JSON.stringify(g),(y=this._styles.indexOf(_))<0&&(y=this._styles.push(_)-1),O+=' customFormat="1" s="'+y.toString()+'"')),u[f]&&!1===u[f].visible&&(O+=' hidden="1"'),u[f]&&!0===u[f].collapsed&&(O+=' collapsed="1"'),O+=">";++p<m;)v=null,S=null,w="",x=-1,T=(b=u[f].cells[p])?b.textRuns:null,v=b&&b.hasOwnProperty("value")?b.value:b,S=b&&b.style?this._cloneStyle(b.style):{},S=this._resolveStyleInheritance(S),(C=a[p])&&(C=this._resolveStyleInheritance(C),S=this._extend(S,C)),g&&(S=this._extend(S,g)),h&&(h=this._resolveStyleInheritance(h),S=this._extend(S,h)),null==S.hAlign||e.isString(S.hAlign)||(S.hAlign=t.Workbook._parseHAlignToString(e.asEnum(S.hAlign,t.HAlign))),null==S.vAlign||e.isString(S.vAlign)||(S.vAlign=t.Workbook._parseVAlignToString(e.asEnum(S.vAlign,t.VAlign))),S.font&&S.font.color&&(S.font.color=this._parseColor(S.font.color)),S.fill&&S.fill.color&&(S.fill.color=this._parseColor(S.fill.color)),this._applyDefaultBorder(S),S.borders&&(S.borders=this._extend({},S.borders),this._parseBorder(S.borders,!!S.fill&&!!S.fill.color)),!e.isNumber(v)||!isNaN(v)&&isFinite(v)||(v=v.toString()),T||v&&e.isString(v)&&("@"===S.format||(+v).toString()!==v||!isFinite(+v))?(this._sharedStrings[1]++,"'"===(v=T?"{RichTextMark}"+JSON.stringify(T):t.Workbook._unescapeXML(v))[0]&&(S.quotePrefix=!0,v=v.substring(1)),(x=this._sharedStrings[0].indexOf(v))<0&&(x=this._sharedStrings[0].push(v)-1),v=x,w="s"):"boolean"==typeof v?(v=v?1:0,w="b"):"date"===this._typeOf(v)||b&&b.isDate?(v=this._convertDate(v),S.format=S.format||"mm-dd-yy"):"object"==typeof v&&(v=null),S=JSON.stringify(S),(y=this._styles.indexOf(S))<0&&(y=this._styles.push(S)-1),b&&(null!=b.colSpan&&b.colSpan>1||null!=b.rowSpan&&b.rowSpan>1)&&(b.colSpan=b.colSpan||1,b.rowSpan=b.rowSpan||1,this._checkValidMergeCell(c,f,b.rowSpan,p,b.colSpan)&&c.push([this._numAlpha(p)+(f+1),this._numAlpha(p+b.colSpan-1)+(f+b.rowSpan)])),b&&b.link&&(null==F&&(F=[]),F.push({ref:t.Workbook.xlsxAddress(f,p),value:v,href:b.link})),S=null,O+=this._generateCell(f,p,y,w,v,b&&b.formula?b.formula:null);O+="</row>"}if(O+="</sheetData>",o&&o.length>0){for(A+="<cols>",f=0;f<o.length;f++)if(y=-1,!this._isEmpty(o[f])){(C=o[f].style)&&((C=this._resolveStyleInheritance(C)).font&&C.font.color&&(C.font.color=this._parseColor(C.font.color)),C.fill&&C.fill.color&&(C.fill.color=this._parseColor(C.fill.color)),null==C.hAlign||e.isString(C.hAlign)||(C.hAlign=t.Workbook._parseHAlignToString(e.asEnum(C.hAlign,t.HAlign))),null==C.vAlign||e.isString(C.vAlign)||(C.vAlign=t.Workbook._parseVAlignToString(e.asEnum(C.vAlign,t.VAlign))),C=JSON.stringify(C),(y=this._styles.indexOf(C))<0&&(y=this._styles.push(C)-1)),k=null!=(k=o[f].width)?"string"==typeof k&&k.indexOf("ch")>-1?this._parseCharCountToCharWidth(k.substring(0,k.indexOf("ch"))):this._parsePixelToCharWidth(k):8.43;var R=(f+1).toString();A+='<col min="'+R+'" max="'+R+'"',y>=0&&(A+=' style="'+y.toString()+'"'),k&&(A+=' width="'+k+'" customWidth="1"'),!1!==o[f].autoWidth&&(A+=' bestFit="1"'),!1===o[f].visible&&(A+=' hidden="1"'),A+="/>"}A+="</cols>"}if(O=A+O,A=O,O=null,c.length>0&&(A+=this._generateMergeSetting(c)),F&&F.length>0){for(A+="<hyperlinks>",f=0;f<F.length;f++)/\'?(\w+)\'?\!\$?[A-Za-z]{1,2}\$?\d+(:\$?[A-Za-z]{1,2}\$?\d+)?/.test(F[f].href)||/^\$?[A-Za-z]{1,2}\$?\d+(:\$?[A-Za-z]{1,2}\$?\d+)?$/.test(F[f].href)?A+='<hyperlink ref="'+F[f].ref+'" display="'+F[f].value+'" location="'+F[f].href+'"/>':(null==n.externalLinks&&(n.externalLinks=[]),n.externalLinks.push(F[f].href),A+='<hyperlink ref="'+F[f].ref+'" r:id="rId'+z+'"/>',z++);A+="</hyperlinks>"}if(A+='<pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3"/>',n.tables&&n.tables.length>0){for(A+='<tableParts count="'+n.tables.length+'">',f=0;f<n.tables.length;f++)A+='<tablePart r:id="rId'+z+'"/>',z++;A+="</tableParts>"}A+="</worksheet>",i.file("sheet"+r+".xml",this._xmlDescription+A),A=null;var D='<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" PartName="/xl/worksheets/sheet'+r+'.xml"/>';this._contentTypes.unshift(D),this._props.unshift(t.Workbook._escapeXML(n.name)||"Sheet"+r);var N='<Relationship Target="worksheets/sheet'+r+'.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Id="rId'+r+'"/>';this._xlRels.unshift(N);var B='<sheet r:id="rId'+r+'" sheetId="'+r+'" name="'+(t.Workbook._escapeXML(n.name)||"Sheet"+r)+'"'+(!1===n.visible?' state="hidden"':"")+"/>";this._worksheets.unshift(B)},s._generateSharedStringsDoc=function(){var e,t='<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="'+this._sharedStrings[1]+'" uniqueCount="'+this._sharedStrings[0].length+'">';for(e=0;e<this._sharedStrings[0].length;e++){t+="<si>";var s=this._sharedStrings[0][e];if(s&&0===s.indexOf("{RichTextMark}"))try{var l=JSON.parse(s.substring(14));if(l&&l.length>0){for(var i=0;i<l.length;i++){t+="<r>";var r=l[i];r.font&&(t+=this._generateFontStyle(r.font,!0).replace(/font/g,"rPr")),t+=this._generatePlainText(r.text),t+="</r>"}t+="</si>"}}catch(e){t+=this._generatePlainText(s)+"</si>"}else t+=this._generatePlainText(s)+"</si>"}return t+"</sst>"},s._generatePlainText=function(s){var l="<t";return(e.isNullOrWhiteSpace(s)||/^\s+\w*|\w*\s+$/.test(s))&&(l+=' xml:space="preserve"'),l+=">"+t.Workbook._escapeXML(s)+"</t>"},s._generateTable=function(e,t){var s=this._tables.length+1,l="table"+s+".xml";e.fileName=l,this._tables.push(l);var i='<table ref="'+e.range+'" displayName="'+e.name+'" name="'+e.name+'" id="'+s+'" '+(!1===e.showHeaderRow?'headerRowCount="0" ':"")+(!0===e.showTotalRow?'totalsRowCount="1" ':'totalsRowShown="0" ')+' xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">';!1!==e.showHeaderRow&&(i+=this._generateTableFilterSetting(e.range,e.showTotalRow,e.columns)),i+='<tableColumns count="'+e.columns.length+'">';for(var r="",n=0;n<e.columns.length;n++){var o=e.columns[n];r+='<tableColumn name="'+o.name+'" id="'+(n+1)+'" ',o.totalRowFunction?this._tableColumnFunctions.indexOf(o.totalRowFunction)>-1?r+='totalsRowFunction="'+o.totalRowFunction+'"/>':r+='totalsRowFunction="custom"><totalsRowFormula>'+o.totalRowFunction+"</totalsRowFormula></tableColumn>":r+=(o.totalRowLabel?'totalsRowLabel="'+o.totalRowLabel+'"':"")+"/>"}if(i+=r+"</tableColumns>",i+='<tableStyleInfo name="'+e.style.name+'" showColumnStripes="'+(e.showBandedColumns?"1":"0")+'" showRowStripes="'+(e.showBandedRows?"1":"0")+'" showLastColumn="'+(e.alterLastColumn?"1":"0")+'" showFirstColumn="'+(e.alterFirstColumn?"1":"0")+'"/></table>',!this._isBuiltInStyleName(e.style.name)){var a=JSON.stringify(e.style);-1===this._tableStyles.indexOf(a)&&this._tableStyles.push(a)}t.file(l,this._xmlDescription+i),i=null},s._generateTableFilterSetting=function(e,s,l){var i=e;if(s){var r=i.indexOf(":")+1,n=t.Workbook.tableAddress(i.substring(i.indexOf(":")+1));n.row-=1,i=i.substring(0,r)+t.Workbook.xlsxAddress(n.row,n.col)}for(var o='<autoFilter ref="'+i+'"',a="",h=0;h<l.length;h++)!1===l[h].showFilterButton&&(a+='<filterColumn hiddenButton="1" colId="'+h+'"/>');return o+=""===a?"/>":">"+a+"</autoFilter>"},s._generateHyperlinkRel=function(e){for(var t="",s=0;s<e.length;s++)t+='<Relationship TargetMode="External" Target="'+e[s]+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Id="rId'+(s+1)+'"/>';return t},s._getDxfs=function(){for(var t,s=this,l=0;l<this._tableStyles.length;l++)t=JSON.parse(this._tableStyles[l]),Object.keys(t).forEach(function(l){var i,r,n=t[l];n&&!e.isString(n)&&(s._isEmptyStyleEle(n)||(i=JSON.stringify(n),-1===(r=s._dxfs.indexOf(i))&&(r=s._dxfs.push(i)-1,n.styleIndex=r)))}),this._tableStyles[l]=t},s._generateDxfs=function(){for(var e,t='<dxfs count="'+this._dxfs.length+'">',s=0;s<this._dxfs.length;s++)t+="<dxf>",(e=JSON.parse(this._dxfs[s])).font&&(t+=this._generateFontStyle(e.font)),e.fill&&e.fill.color&&(t+=this._generateFillStyle("solid",e.fill.color,!0)),e.borders&&!this._isEmpty(e.borders)&&(e.borders=this._extend({},e.borders),this._parseBorder(e.borders,!1),t+=this._generateBorderStyle(e.borders,!0)),t+="</dxf>";return t+="</dxfs>"},s._generateTableStyles=function(){for(var t,s,l,i,r,n,o='<tableStyles count="'+this._tableStyles.length+'" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleLight16">',a=0;a<this._tableStyles.length;a++){t=this._tableStyles[a],s=Object.keys(t),r="",n=0;for(var h=0;h<s.length;h++)if(l=s[h],i=t[l],!e.isString(i)){switch(n++,r+="<tableStyleElement",null!=i.styleIndex&&(r+=' dxfId="'+i.styleIndex+'"'),l){case"firstBandedColumnStyle":r+=' type="firstColumnStripe"',null!=i.size&&(r+=' size="'+i.size+'"');break;case"secondBandedColumnStyle":r+=' type="secondColumnStripe"',null!=i.size&&(r+=' size="'+i.size+'"');break;case"firstBandedRowStyle":r+=' type="firstRowStripe"',null!=i.size&&(r+=' size="'+i.size+'"');break;case"secondBandedRowStyle":r+=' type="secondRowStripe"',null!=i.size&&(r+=' size="'+i.size+'"');break;default:r+=' type="'+l.substring(0,l.length-5)+'"'}r+="/>"}n>0&&(o+='<tableStyle count="'+n+'" name="'+t.name+'" pivot="0">',o+=r+"</tableStyle>")}return o+="</tableStyles>"},s._isEmptyStyleEle=function(t){return this._isEmpty(t.borders)&&(this._isEmpty(t.fill)||e.isNullOrWhiteSpace(t.fill.color))&&(this._isEmpty(t.font)||!0!==t.font.bold&&e.isNullOrWhiteSpace(t.font.color)&&e.isNullOrWhiteSpace(t.font.family)&&!0!==t.font.italic&&null==t.font.size&&!0!==t.font.underline)},s._getTableFileName=function(e,t){for(var s="",l=0;l<e.length;l++){var i=e[l];if(i.name===t){s=i.fileName;break}}return s},s._getColor=function(e,t){var s,l,i,r,n;return-1===e.search(/fgcolor/i)&&-1===e.search(/bgcolor/i)&&t||-1===e.search(/color/i)&&!t?null:(-1===(s=e.indexOf("<fgColor"))&&(s=e.indexOf("<bgColor")),-1!==(e=t?e.substring(s,e.indexOf("/>")):e.substring(e.indexOf("<color"))).indexOf("rgb=")?(r=this._getAttr(e,"rgb"))&&8===r.length&&(r=r.substring(2)):-1!==e.indexOf("indexed")?(i=+this._getAttr(e,"indexed"),r=this._indexedColors[i]||""):(l=+this._getAttr(e,"theme"),-1!==e.indexOf("tint")&&(n=+this._getAttr(e,"tint")),r=this._getThemeColor(l,n)),r&&"#"===r[0]?r:"#"+r)},s._getThemeColor=function(t,s){var l,i,r=this._colorThemes[t];return null!=s?(l=new e.Color("#"+r),i=l.getHsl(),i[2]=s<0?i[2]*(1+s):i[2]*(1-s)+(1-1*(1-s)),(l=e.Color.fromHsl(i[0],i[1],i[2])).toString().substring(1)):r},s._parseColor=function(t){var s=new e.Color(t);return s.a<1&&(s=e.Color.toOpaque(s)),s.toString()},s._getsBaseSharedFormulas=function(e){var t,s,l,i=e.match(/\<f[^<]*ref[^<]*>[^<]+(?=\<\/f>)/g);if(this._sharedFormulas=[],i&&i.length>0)for(var r=0;r<i.length;r++)t=i[r],s=this._getAttr(t,"si"),l=(l=this._getAttr(t,"ref"))?l.substring(0,l.indexOf(":")):"",t=t.replace(/(\<f.*>)(.+)/,"$2"),this._sharedFormulas[+s]=this._parseSharedFormulaInfo(l,t)},s._parseSharedFormulaInfo=function(e,s){var l,i,r,n,o,a=s.match(/(\'?\w+\'?\!)?(\$?[A-Za-z]+)(\$?\d+)/g);if(n=t.Workbook.tableAddress(e),a&&a.length>0){o=[];for(var h=0;h<a.length;h++)l=a[h],s=s.replace(l,"{"+h+"}"),(i=l.indexOf("!"))>0&&(r=l.substring(0,i),l=l.substring(i+1)),o[h]={cellAddress:t.Workbook.tableAddress(l),sheetRef:r}}return{cellRef:n,formula:s,formulaRefs:o}},s._getSharedFormula=function(e,s){var l,i,r,n,o,a,h,u,c,f,d,p;if(this._sharedFormulas&&this._sharedFormulas.length>0&&(l=this._sharedFormulas[+e])){if(c=l.formula,(f=l.formulaRefs)&&f.length>0){i=t.Workbook.tableAddress(s),h=l.cellRef?l.cellRef.row:0,u=l.cellRef?l.cellRef.col:0,r=i.row-h,n=i.col-u;for(var m=0;m<f.length;m++)o=(d=f[m]).cellAddress.row+(d.cellAddress.absRow?0:r),a=d.cellAddress.col+(d.cellAddress.absCol?0:n),p=t.Workbook.xlsxAddress(o,a,d.cellAddress.absRow,d.cellAddress.absCol),null!=d.sheetRef&&""!==d.sheetRef&&(p=d.sheetRef+"!"+p),c=c.replace("{"+m+"}",p)}return c}return""},s._convertDate=function(t){var s,l,i=new Date(1900,0,0),r="[object Date]"===Object.prototype.toString.call(t),n=6e4*((r?t.getTimezoneOffset():(new Date).getTimezoneOffset())-i.getTimezoneOffset());return r?(t.getTime()-i.getTime()-n)/864e5+1:e.isNumber(t)?(s=t>59?1:0,l=new Date(1e3*Math.round((+i+864e5*(t-s))/1e3)),0!==(n=6e4*(l.getTimezoneOffset()-i.getTimezoneOffset()))?new Date(1e3*Math.round((+i+n+864e5*(t-s))/1e3)):l):null},s._parseBorder=function(s,l){for(var i in{left:0,right:0,top:0,bottom:0,diagonal:0}){var r=s[i];r&&(e.isString(r.color)&&(r.color=this._parseColor(r.color)),null==r.style||e.isString(r.style)||(r.style=t.Workbook._parseBorderTypeToString(e.asEnum(r.style,t.BorderStyle,!1))),!l&&r.color&&"#c6c6c6"===r.color.toLowerCase()&&"thin"===r.style&&(s[i]=null))}},s._applyDefaultBorder=function(t){if(t.fill&&t.fill.color){null==t.borders&&(t.borders={});for(var s in{left:0,right:0,top:0,bottom:0})null==t.borders[s]&&(t.borders[s]={style:e.xlsx.BorderStyle.Thin,color:"#C6C6C6"})}},s._resolveStyleInheritance=function(e){var t;if(!e.basedOn)return e;for(var s in e.basedOn)if("basedOn"===s){t=this._resolveStyleInheritance(e.basedOn);for(s in t){l=t[s];e[s]=null==e[s]?l:this._extend(e[s],l)}}else{var l=e.basedOn[s];e[s]=null==e[s]?l:this._extend(e[s],l)}return delete e.basedOn,e},s._parsePixelToCharWidth=function(e){return null==e||isNaN(+e)?null:((+e-5)/7*100+.5)/100},s._parseCharWidthToPixel=function(e){return null==e||isNaN(+e)?null:Math.floor((256*+e+128/7)/256*7)+5},s._parseCharCountToCharWidth=function(e){return null==e||isNaN(+e)?null:(7*+e+5)/7*256/256},s._numAlpha=function(e){var t=Math.floor(e/26)-1;return(t>-1?this._numAlpha(t):"")+this._alphabet.charAt(e%26)},s._alphaNum=function(e){var t=0;return 2===e.length&&(t=this._alphaNum(e.charAt(0))+1),26*t+this._alphabet.indexOf(e.substr(-1))},s._typeOf=function(e){return{}.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase()},s._extend=function(t,s){if(e.isObject(t)&&e.isObject(s)){for(var l in s){var i=s[l];e.isObject(i)&&null!=t[l]?this._extend(t[l],i):null!=i&&null==t[l]&&(t[l]=i)}return t}return s},s._isEmpty=function(e){var t=Object.prototype.hasOwnProperty;if(null==e)return!0;if(e.length>0)return!1;if(0===e.length)return!0;for(var s in e)if(t.call(e,s))return!1;return!0},s._cloneStyle=function(e){var t;if(null==e||"object"!=typeof e)return e;t={};for(var s in e)e.hasOwnProperty(s)&&(t[s]=this._cloneStyle(e[s]));return t},s._cloneColumnsStyle=function(e){for(var t,s=[],l=0;l<e.length;l++)(t=e[l])&&t.style&&(s[l]=this._cloneStyle(t.style));return s},s._getSheetIndex=function(e){return e=e.substring(0,e.lastIndexOf(".xml")),+e.substring(e.lastIndexOf("sheet")+5)},s._checkValidMergeCell=function(e,t,s,l,i){for(var r=0;r<e.length;r++){var n=e[r],o=+n[0].match(/\d*/g).join("")-1,a=this._alphaNum(n[0].match(/[a-zA-Z]*/g)[0]),h=+n[1].match(/\d*/g).join("")-1,u=this._alphaNum(n[1].match(/[a-zA-Z]*/g)[0]);if(!(t>h||t+s-1<o||l>u||l+i-1<a))return!1}return!0},s._getAttr=function(e,t){var s=e.indexOf(t+'="');return s>=0?(e=e.substr(s+t.length+2)).substring(0,e.indexOf('"')):""},s._getChildNodeValue=function(e,t){var s=e.indexOf(t+' val="');return s>=0?(e=e.substr(s+t.length+6)).substring(0,e.indexOf('"')):""},s._getSheetIndexBySheetName=function(e,t){for(var s=0;s<e.sheets.length;s++)if(e.sheets[s].name===t)return s;return-1},s._alphabet="ABCDEFGHIJKLMNOPQRSTUVWXYZ",s._indexedColors=["000000","FFFFFF","FF0000","00FF00","0000FF","FFFF00","FF00FF","00FFFF","000000","FFFFFF","FF0000","00FF00","0000FF","FFFF00","FF00FF","00FFFF","800000","008000","000080","808000","800080","008080","C0C0C0","808080","9999FF","993366","FFFFCC","CCFFFF","660066","FF8080","0066CC","CCCCFF","000080","FF00FF","FFFF00","00FFFF","800080","800000","008080","0000FF","00CCFF","CCFFFF","CCFFCC","FFFF99","99CCFF","FF99CC","CC99FF","FFCC99","3366FF","33CCCC","99CC00","FFCC00","FF9900","FF6600","666699","969696","003366","339966","003300","333300","993300","993366","333399","333333","000000","FFFFFF"],s._numFmts=["General","0","0.00","#,##0","#,##0.00",,,"$#,##0.00_);($#,##0.00)",,"0%","0.00%","0.00E+00","# ?/?","# ??/??","m/d/yyyy","d-mmm-yy","d-mmm","mmm-yy","h:mm AM/PM","h:mm:ss AM/PM","h:mm","h:mm:ss","m/d/yy h:mm",,,,,,,,,,,,,,,"#,##0 ;(#,##0)","#,##0 ;[Red](#,##0)","#,##0.00;(#,##0.00)","#,##0.00;[Red](#,##0.00)",,,,,"mm:ss","[h]:mm:ss","mmss.0","##0.0E+0","@"],s._tableColumnFunctions="average, count, countNums, max, min, stdDev, sum, var",s._xmlDescription='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>',s._workbookNS="http://schemas.openxmlformats.org/spreadsheetml/2006/main",s._relationshipsNS="http://schemas.openxmlformats.org/package/2006/relationships",s._defaultFontName="Calibri",s._defaultFontSize=11,s._macroEnabled=!1,s._defaultColorThemes=["FFFFFF","000000","EEECE1","1F497D","4F818D","C0504D","9BBB59","8064A2","4BACC6","F79646"],s}();t._xlsx=s;var l=function(){function e(e){this.value=e}return e.prototype.then=function(t,s){return new e(t?t(this.value):null)},e.prototype.catch=function(e){return this.then(null,e)},e.resolve=function(){return new e},e}(),i=function(){function e(e){this._obj=e}return e.prototype.loadAsync=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var s=(i=this._obj).load.apply(i,e);return new l(this._wrapOrNull(s));var i},e.prototype.file=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var s=(l=this._obj).file.apply(l,e);return this._wrapOrNull(s);var l},Object.defineProperty(e.prototype,"name",{get:function(){return this._obj.name},enumerable:!0,configurable:!0}),e.prototype.async=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var s;return s=e&&e.length>0&&"uint8array"===e[0].toLowerCase()?this._obj.asUint8Array():this._obj.asText(),new l(s)},e.prototype.folder=function(e){var t=this._obj.folder(e);return this._wrapOrNull(t)},e.prototype.forEach=function(t){var s=this._obj.root,l=s.length,i=this._obj.files;for(var r in i)r.length>l&&r.substr(0,l).toLowerCase()===s&&t(r.substr(l),new e(i[r]))},e.prototype._wrapOrNull=function(t){return null!=t?new e(t):null},e}()}(e.xlsx||(e.xlsx={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var s in t)t.hasOwnProperty(s)&&(e[s]=t[s])};return function(t,s){function l(){this.constructor=t}e(t,s),t.prototype=null===s?Object.create(s):(l.prototype=s.prototype,new l)}}(),wijmo;!function(e){!function(t){"use strict";var s=function(){function s(){}return Object.defineProperty(s.prototype,"sheets",{get:function(){return null==this._sheets&&(this._sheets=[]),this._sheets},enumerable:!0,configurable:!0}),Object.defineProperty(s.prototype,"styles",{get:function(){return null==this._styles&&(this._styles=[]),this._styles},enumerable:!0,configurable:!0}),Object.defineProperty(s.prototype,"definedNames",{get:function(){return null==this._definedNames&&(this._definedNames=[]),this._definedNames},enumerable:!0,configurable:!0}),Object.defineProperty(s.prototype,"colorThemes",{get:function(){return null==this._colorThemes&&(this._colorThemes=[]),this._colorThemes},enumerable:!0,configurable:!0}),Object.defineProperty(s.prototype,"reservedContent",{get:function(){return null==this._reservedContent&&(this._reservedContent={}),this._reservedContent},set:function(e){this._reservedContent=e},enumerable:!0,configurable:!0}),s.prototype.save=function(e){var s=t._xlsx.save(this);return e&&this._saveToFile(s.base64,e),s.base64},s.prototype.saveAsync=function(e,s,l){var i=this;t._xlsx.saveAsync(i,l).then(function(t){e&&i._saveToFile(t,e),s&&s(t)})},s.prototype.load=function(e){var s=t._xlsx.load(this._getBase64String(e));this._deserialize(s),s=null},s.prototype.loadAsync=function(e,s,l){var i=this;t._xlsx.loadAsync(i._getBase64String(e)).then(function(e){i._deserialize(e),e=null,s(i)}).catch(l)},s.prototype._serialize=function(){var e={sheets:[]};return e.sheets=this._serializeWorkSheets(),this._styles&&this._styles.length>0&&(e.styles=this._serializeWorkbookStyles()),this._reservedContent&&(e.reservedContent=this._reservedContent),null!=this.activeWorksheet&&!isNaN(this.activeWorksheet)&&this.activeWorksheet>=0&&(e.activeWorksheet=this.activeWorksheet),this.application&&(e.application=this.application),this.company&&(e.company=this.company),null!=this.created&&(e.created=this.created),this.creator&&(e.creator=this.creator),this.lastModifiedBy&&(e.lastModifiedBy=this.lastModifiedBy),null!=this.modified&&(e.modified=this.modified),this._definedNames&&this._definedNames.length>0&&(e.definedNames=this._serializeDefinedNames()),this._colorThemes&&this._colorThemes.length>0&&(e.colorThemes=this._colorThemes.slice()),e},s.prototype._deserialize=function(e){this._deserializeWorkSheets(e.sheets),e.styles&&e.styles.length>0&&this._deserializeWorkbookStyles(e.styles),this.activeWorksheet=e.activeWorksheet,this.application=e.application,this.company=e.company,this.created=e.created,this.creator=e.creator,this.lastModifiedBy=e.lastModifiedBy,this.modified=e.modified,this.reservedContent=e.reservedContent,e.definedNames&&e.definedNames.length>0&&this._deserializeDefinedNames(e.definedNames),e.colorThemes&&e.colorThemes.length>0&&(this._colorThemes=e.colorThemes.slice())},s.prototype._addWorkSheet=function(e,t){null==this._sheets&&(this._sheets=[]),null==t||isNaN(t)?this._sheets.push(e):this._sheets[t]=e},s.prototype._saveToFile=function(e,t){var l,i,r,n,o,a,h=window.document,u=this._reservedContent&&this._reservedContent.macros?"xlsm":"xlsx",c="xlsm"===u?"application/vnd.ms-excel.sheet.macroEnabled.12":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";if((i=t.lastIndexOf("."))<0)t+="."+u;else{if(0===i)throw"Invalid file name.";""===(l=t.substring(i+1))?t+="."+u:l!==u&&(t+="."+u)}r=new Blob([s._base64DecToArr(e)],{type:c}),navigator.msSaveBlob?navigator.msSaveBlob(r,t):URL.createObjectURL?(o=h.createElement("a"),a=function(e){var t=h.createEvent("MouseEvents");t.initMouseEvent("click",!0,!1,window,0,0,0,0,0,!1,!1,!1,!1,0,null),e.dispatchEvent(t)},o.download=t,o.href=URL.createObjectURL(r),a(o),o=null):(n=new FileReader,o=h.createElement("a"),a=function(e){var t=h.createEvent("MouseEvents");t.initMouseEvent("click",!0,!1,window,0,0,0,0,0,!1,!1,!1,!1,0,null),e.dispatchEvent(t)},n.onload=function(){o.download=t,o.href=n.result,a(o),o=null},n.readAsDataURL(r))},s.prototype._getBase64String=function(e){var t;if(null==e||0===e.length)throw"Invalid xlsx file content.";return-1!==(t=e.search(/base64,/i))&&(e=e.substring(t+7)),e},s.toXlsxDateFormat=function(t){var s;if(1===t.length)switch(t){case"r":case"R":return"ddd, dd MMM yyyy HH:mm:ss &quot;GMT&quot;";case"u":return"yyyy-MM-dd&quot;T&quot;HH:mm:ss&quot;Z&quot;";case"o":case"O":s=(s=e.culture.Globalize.calendar.patterns[t]).replace(/f+k/gi,"000");break;default:s=e.culture.Globalize.calendar.patterns[t]}return s||(s=t),s=s.replace(/"/g,"").replace(/tt/,"AM/PM").replace(/t/,"A/P").replace(/M+/gi,function(e){return e.toLowerCase()}).replace(/g+y+/gi,function(e){return e.substring(0,e.indexOf("y"))+"e"}),/FY|Q/i.test(s)?"General":s},s.toXlsxNumberFormat=function(t){var s,l,i,r,n,o,a=-1,h=t?t.toLowerCase():"",u=[];if(/^[ncpfdg]\d*,*$/.test(h)&&(s=h[0],l=this._formatMap[s]),l){if(i=e.culture.Globalize.numberFormat.currency.symbol,r=h.split(","),"c"===s&&(l=l.replace(/\{1\}/g,i)),h.length>1?a=parseInt(r[0].substr(1)):"d"!==s&&(a=2),!isNaN(a))for(o=0;o<a;o++)u.push(0);for(o=0;o<r.length-1;o++)u.push(",");n=u.length>0?"d"===s?l.replace(/\{0\}/g,u.join("")):l.replace(/\{0\}/g,(!isNaN(a)&&a>0?".":"")+u.join("")):"d"===s?l.replace(/\{0\}/g,"0"):l.replace(/\{0\}/g,"")}else n=h;return n},s.fromXlsxFormat=function(t){var s,l,i,r,n,o,a,h,u,c=[],f=e.culture.Globalize.numberFormat.currency.symbol;if(!t||"General"===t)return[""];for(l=(t=t.replace(/;@/g,"").replace(/&quot;?/g,"")).split(";"),r=0;r<l.length;r++){if(i=l[r],/[hsmy\:]/i.test(i))s=i.replace(/\[\$\-.+\]/g,"").replace(/(\\)(.)/g,"$2").replace(/H+/g,function(e){return e.toLowerCase()}).replace(/m+/g,function(e){return e.toUpperCase()}).replace(/S+/g,function(e){return e.toLowerCase()}).replace(/AM\/PM/gi,"tt").replace(/A\/P/gi,"t").replace(/\.000/g,".fff").replace(/\.00/g,".ff").replace(/\.0/g,".f").replace(/\\[\-\s,]/g,function(e){return e.substring(1)}).replace(/Y+/g,function(e){return e.toLowerCase()}).replace(/D+/g,function(e){return e.toLowerCase()}).replace(/M+:?|:?M+/gi,function(e){return e.indexOf(":")>-1?e.toLowerCase():e}).replace(/g+e/gi,function(e){return e.substring(0,e.length-1)+"yy"});else if(o=i.lastIndexOf("."),a=i.lastIndexOf("0"),h=i.lastIndexOf(","),s=i.search(/\[\$([^\-\]]+)[^\]]*\]/)>-1||i.indexOf(f)>-1&&-1===i.search(/\[\$([\-\]]+)[^\]]*\]/)?"c":"%"===i[t.length-1]?"p":"n",s+=o>-1&&o<a?i.substring(o,a).length:"0",/^0+,*$/.test(i)&&(s="d"+((a=i.lastIndexOf("0"))+1)),h>-1&&a>-1&&a<h)for(u=i.substring(a+1,h+1).split(""),n=0;n<u.length;n++)s+=",";c.push(s)}return c},s._parseCellFormat=function(e,t){return t?this.toXlsxDateFormat(e):this.toXlsxNumberFormat(e)},s._parseExcelFormat=function(t){if(void 0!==t&&null!==t&&void 0!==t.value&&null!==t.value&&!isNaN(t.value)){var s=t.style&&t.style.format?t.style.format:"";return t.isDate||e.isDate(t.value)?this.fromXlsxFormat(s)[0]:!e.isNumber(t.value)||s&&"General"!==s?e.isNumber(t.value)||""===t.value?this.fromXlsxFormat(s)[0]:s:e.isInt(t.value)?"d":"f2"}},s.xlsxAddress=function(e,t,s,l){var i=s?"$":"",r=null==l?i:l?"$":"";return(isNaN(t)?"":r+this._numAlpha(t))+(isNaN(e)?"":i+(e+1).toString())},s.tableAddress=function(e){var t=/^((\$?)([A-Za-z]+))?((\$?)(\d+))?$/,s=e&&t.exec(e),l={};return s?(s[3]&&(l.col=this._alphaNum(s[3]),l.absCol=!!s[2]),s[6]&&(l.row=+s[6]-1,l.absRow=!!s[5]),l):null},s._parseHAlignToString=function(e){switch(e){case S.Left:return"left";case S.Center:return"center";case S.Right:return"right";case S.Justify:return"justify";default:return"general"}},s._parseStringToHAlign=function(e){var t=e?e.toLowerCase():"";return"left"===t?S.Left:"center"===t?S.Center:"right"===t?S.Right:"justify"===t?S.Justify:S.General},s._parseVAlignToString=function(e){switch(e){case w.Bottom:return"bottom";case w.Center:return"center";case w.Top:return"top";default:return null}},s._parseStringToVAlign=function(e){var t=e?e.toLowerCase():"";return"top"===t?w.Top:"center"===t?w.Center:"bottom"===t?w.Bottom:null},s._parseBorderTypeToString=function(e){switch(e){case x.Dashed:return"dashed";case x.Dotted:return"dotted";case x.Double:return"double";case x.Hair:return"hair";case x.Medium:return"medium";case x.MediumDashDotDotted:return"mediumDashDotDot";case x.MediumDashDotted:return"mediumDashDot";case x.MediumDashed:return"mediumDashed";case x.SlantedMediumDashDotted:return"slantDashDot";case x.Thick:return"thick";case x.Thin:return"thin";case x.ThinDashDotDotted:return"dashDotDot";case x.ThinDashDotted:return"dashDot";case x.None:default:return"none"}},s._parseStringToBorderType=function(e){return"dashed"===e?x.Dashed:"dotted"===e?x.Dotted:"double"===e?x.Double:"hair"===e?x.Hair:"medium"===e?x.Medium:"mediumDashDotDot"===e?x.MediumDashDotDotted:"mediumDashDot"===e?x.MediumDashDotted:"mediumDashed"===e?x.MediumDashed:"slantDashDot"===e?x.SlantedMediumDashDotted:"thick"===e?x.Thick:"thin"===e?x.Thin:"dashDotDot"===e?x.ThinDashDotDotted:"dashDot"===e?x.ThinDashDotted:null},s._escapeXML=function(e){return"string"==typeof e?e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"):""},s._unescapeXML=function(e){return"string"==typeof e?e.replace(/&amp;/g,"&").replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;/g,'"').replace(/&#x27;/g,"'").replace(/&#x2F;/g,"/"):""},s._numAlpha=function(e){var t=Math.floor(e/26)-1;return(t>-1?this._numAlpha(t):"")+this._alphabet.charAt(e%26)},s._alphaNum=function(e){var t=0;return e&&(e=e.toUpperCase()),2===e.length&&(t=this._alphaNum(e.charAt(0))+1),26*t+this._alphabet.indexOf(e.substr(-1))},s._b64ToUint6=function(e){return e>64&&e<91?e-65:e>96&&e<123?e-71:e>47&&e<58?e+4:43===e?62:47===e?63:0},s._base64DecToArr=function(e,t){for(var s,l,i=e.replace(/[^A-Za-z0-9\+\/]/g,""),r=i.length,n=t?Math.ceil((3*r+1>>2)/t)*t:3*r+1>>2,o=new Uint8Array(n),a=0,h=0,u=0;u<r;u++)if(l=3&u,a|=this._b64ToUint6(i.charCodeAt(u))<<18-6*l,3===l||r-u==1){for(s=0;s<3&&h<n;s++,h++)o[h]=a>>>(16>>>s&24)&255;a=0}return o},s._uint6ToB64=function(e){return e<26?e+65:e<52?e+71:e<62?e-4:62===e?43:63===e?47:65},s._base64EncArr=function(e){for(var t=2,s="",l=e.length,i=0,r=0;r<l;r++)t=r%3,r>0&&4*r/3%76==0&&(s+="\r\n"),i|=e[r]<<(16>>>t&24),2!==t&&e.length-r!=1||(s+=String.fromCharCode(this._uint6ToB64(i>>>18&63),this._uint6ToB64(i>>>12&63),this._uint6ToB64(i>>>6&63),this._uint6ToB64(63&i)),i=0);return s.substr(0,s.length-2+t)+(2===t?"":1===t?"=":"==")},s.prototype._serializeWorkSheets=function(){var e,t,s=[];for(t=0;t<this._sheets.length;t++)(e=this._sheets[t])&&(s[t]=e._serialize());return s},s.prototype._serializeWorkbookStyles=function(){var e,t,s=[];for(t=0;t<this._styles.length;t++)(e=this._styles[t])&&(s[t]=e._serialize());return s},s.prototype._serializeDefinedNames=function(){var e,t,s=[];for(t=0;t<this._definedNames.length;t++)(e=this._definedNames[t])&&(s[t]=e._serialize());return s},s.prototype._serializeTableStyles=function(){var e,t,s=[];for(t=0;t<this._tableStyles.length;t++)(e=this._tableStyles[t])&&(s[t]=e._serialize());return s},s.prototype._deserializeWorkSheets=function(t){var s,i,r;for(this._sheets=[],e.assert(null!=t,"workSheets should not be null."),r=0;r<t.length;r++)(i=t[r])&&((s=new l)._deserialize(i),this._sheets[r]=s)},s.prototype._deserializeWorkbookStyles=function(e){var t,s,l;for(this._styles=[],l=0;l<e.length;l++)(s=e[l])&&((t=new a)._deserialize(s),this._styles[l]=t)},s.prototype._deserializeDefinedNames=function(e){var t,s,l;for(this._definedNames=[],l=0;l<e.length;l++)(s=e[l])&&((t=new d)._deserialize(s),this._definedNames[l]=t)},s.prototype._deserializeTableStyles=function(e){var t,s,l;for(this._tableStyles=[],l=0;l<e.length;l++)(s=e[l])&&((t=new g)._deserialize(s),this._tableStyles[l]=t)},s._alphabet="ABCDEFGHIJKLMNOPQRSTUVWXYZ",s._formatMap={n:"#,##0{0}",c:"{1}#,##0{0}_);({1}#,##0{0})",p:"#,##0{0}%",f:"0{0}",d:"{0}",g:"0{0}"},s}();t.Workbook=s;var l=function(){function e(){}return Object.defineProperty(e.prototype,"columns",{get:function(){return null==this._columns&&(this._columns=[]),this._columns},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"rows",{get:function(){return null==this._rows&&(this._rows=[]),this._rows},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"tables",{get:function(){return null==this._tables&&(this._tables=[]),this._tables},enumerable:!0,configurable:!0}),e.prototype._serialize=function(){var e;return this._checkEmptyWorkSheet()?null:(e={},this.style&&(e.style=this.style._serialize()),this._columns&&this._columns.length>0&&(e.columns=this._serializeWorkbookColumns()),this._rows&&this._rows.length>0&&(e.rows=this._serializeWorkbookRows()),this.frozenPane&&(e.frozenPane=this.frozenPane._serialize()),this.name&&(e.name=this.name),null!=this.summaryBelow&&(e.summaryBelow=this.summaryBelow),null!=this.visible&&(e.visible=this.visible),this._tables&&this._tables.length>0&&(e.tables=this._serializeTables()),e)},e.prototype._deserialize=function(e){var t,s;e.style&&((s=new a)._deserialize(e.style),this.style=s),e.columns&&e.columns.length>0&&this._deserializeWorkbookColumns(e.columns),e.rows&&e.rows.length>0&&this._deserializeWorkbookRows(e.rows),e.frozenPane&&((t=new o)._deserialize(e.frozenPane),this.frozenPane=t),this.name=e.name,this.summaryBelow=e.summaryBelow,this.visible=e.visible,e.tables&&e.tables.length>0&&this._deserializeTables(e.tables)},e.prototype._addWorkbookColumn=function(e,t){null==this._columns&&(this._columns=[]),null==t||isNaN(t)?this._columns.push(e):this._columns[t]=e},e.prototype._addWorkbookRow=function(e,t){null==this._rows&&(this._rows=[]),null==t||isNaN(t)?this._rows.push(e):this._rows[t]=e},e.prototype._serializeWorkbookColumns=function(){var e,t,s=[];for(t=0;t<this._columns.length;t++)(e=this._columns[t])&&(s[t]=e._serialize());return s},e.prototype._serializeWorkbookRows=function(){var e,t,s=[];for(t=0;t<this._rows.length;t++)(e=this._rows[t])&&(s[t]=e._serialize());return s},e.prototype._serializeTables=function(){var e,t,s=[];for(t=0;t<this._tables.length;t++)(e=this._tables[t])&&(s[t]=e._serialize());return s},e.prototype._deserializeWorkbookColumns=function(e){var t,s,l;for(this._columns=[],l=0;l<e.length;l++)(t=e[l])&&((s=new i)._deserialize(t),this._columns[l]=s)},e.prototype._deserializeWorkbookRows=function(e){var t,s,l;for(this._rows=[],l=0;l<e.length;l++)(t=e[l])&&((s=new r)._deserialize(t),this._rows[l]=s)},e.prototype._deserializeTables=function(e){var t,s,l;for(this._tables=[],l=0;l<e.length;l++)(s=e[l])&&((t=new p)._deserialize(s),this._tables[l]=t)},e.prototype._checkEmptyWorkSheet=function(){return!(null!=this._rows||null!=this._columns||null!=this.visible||null!=this.summaryBelow||null!=this.frozenPane||null!=this.style||null!=this.name&&""!==this.name||null!=this._tables&&0!=this._tables.length)},e}();t.WorkSheet=l;var i=function(){function e(){}return e.prototype._serialize=function(){var e;return this._checkEmptyWorkbookColumn()?null:(e={},this.style&&(e.style=this.style._serialize()),null!=this.autoWidth&&(e.autoWidth=this.autoWidth),null!=this.width&&(e.width=this.width),null!=this.visible&&(e.visible=this.visible),e)},e.prototype._deserialize=function(e){var t;e.style&&((t=new a)._deserialize(e.style),this.style=t),this.autoWidth=e.autoWidth,this.visible=e.visible,this.width=e.width},e.prototype._checkEmptyWorkbookColumn=function(){return null==this.style&&null==this.width&&null==this.autoWidth&&null==this.visible},e}();t.WorkbookColumn=i;var r=function(){function e(){}return Object.defineProperty(e.prototype,"cells",{get:function(){return null==this._cells&&(this._cells=[]),this._cells},enumerable:!0,configurable:!0}),e.prototype._serialize=function(){var e;return this._checkEmptyWorkbookRow()?null:(e={},this._cells&&this._cells.length>0&&(e.cells=this._serializeWorkbookCells()),this.style&&(e.style=this.style._serialize()),null!=this.collapsed&&(e.collapsed=this.collapsed),null==this.groupLevel||isNaN(this.groupLevel)||(e.groupLevel=this.groupLevel),null==this.height||isNaN(this.height)||(e.height=this.height),null!=this.visible&&(e.visible=this.visible),e)},e.prototype._deserialize=function(e){var t;e.cells&&e.cells.length>0&&this._deserializeWorkbookCells(e.cells),e.style&&((t=new a)._deserialize(e.style),this.style=t),this.collapsed=e.collapsed,this.groupLevel=e.groupLevel,this.height=e.height,this.visible=e.visible},e.prototype._addWorkbookCell=function(e,t){null==this._cells&&(this._cells=[]),null==t||isNaN(t)?this._cells.push(e):this._cells[t]=e},e.prototype._serializeWorkbookCells=function(){var e,t,s=[];for(t=0;t<this._cells.length;t++)(e=this._cells[t])&&(s[t]=e._serialize());return s},e.prototype._deserializeWorkbookCells=function(e){var t,s,l;for(this._cells=[],l=0;l<e.length;l++)(t=e[l])&&((s=new n)._deserialize(t),this._cells[l]=s)},e.prototype._checkEmptyWorkbookRow=function(){return null==this._cells&&null==this.style&&null==this.collapsed&&null==this.visible&&(null==this.height||isNaN(this.height))&&(null==this.groupLevel||isNaN(this.groupLevel))},e}();t.WorkbookRow=r;var n=function(){function e(){}return e.prototype._serialize=function(){var e;return this._checkEmptyWorkbookCell()?null:(e={},this.style&&(e.style=this.style._serialize()),null!=this.value&&(e.value=this.value),this.formula&&(e.formula=this.formula),null!=this.isDate&&(e.isDate=this.isDate),null!=this.colSpan&&!isNaN(this.colSpan)&&this.colSpan>1&&(e.colSpan=this.colSpan),null!=this.rowSpan&&!isNaN(this.rowSpan)&&this.rowSpan>1&&(e.rowSpan=this.rowSpan),this.link&&(e.link=this.link),this.textRuns&&this.textRuns.length>0&&(e.textRuns=this._serializeTextRuns()),e)},e.prototype._deserialize=function(e){var t;e.style&&((t=new a)._deserialize(e.style),this.style=t),this.value=e.value,this.formula=e.formula,this.isDate=e.isDate,this.colSpan=e.colSpan,this.rowSpan=e.rowSpan,this.link=e.link,e.textRuns&&e.textRuns.length>0&&this._deserializeTextRuns(e.textRuns)},e.prototype._serializeTextRuns=function(){var e,t,s=[];for(t=0;t<this.textRuns.length;t++)e=this.textRuns[t],s.push(e._serialize());return s},e.prototype._deserializeTextRuns=function(e){var t,s,l;for(this.textRuns=[],l=0;l<e.length;l++)s=new v,t=e[l],s._deserialize(t),this.textRuns.push(s)},e.prototype._checkEmptyWorkbookCell=function(){return null==this.style&&null==this.value&&null==this.isDate&&(null==this.formula||""===this.formula)&&(null==this.colSpan||isNaN(this.colSpan)||this.colSpan<=1)&&(null==this.rowSpan||isNaN(this.rowSpan)||this.rowSpan<=1)&&(null==this.link||""===this.link)},e}();t.WorkbookCell=n;var o=function(){function e(){}return e.prototype._serialize=function(){return null!=this.columns&&!isNaN(this.columns)&&0!==this.columns||null!=this.rows&&!isNaN(this.rows)&&0!==this.rows?{columns:this.columns,rows:this.rows}:null},e.prototype._deserialize=function(e){this.columns=e.columns,this.rows=e.rows},e}();t.WorkbookFrozenPane=o;var a=function(){function t(){}return t.prototype._serialize=function(){var t;return this._checkEmptyWorkbookStyle()?null:(t={},this.basedOn&&(t.basedOn=this.basedOn._serialize()),this.fill&&(t.fill=this.fill._serialize()),this.font&&(t.font=this.font._serialize()),this.borders&&(t.borders=this.borders._serialize()),this.format&&(t.format=this.format),null!=this.hAlign&&(t.hAlign=e.asEnum(this.hAlign,S,!1)),null!=this.vAlign&&(t.vAlign=e.asEnum(this.vAlign,w,!1)),null==this.indent||isNaN(this.indent)||(t.indent=this.indent),this.wordWrap&&(t.wordWrap=this.wordWrap),t)},t.prototype._deserialize=function(s){var l,i,r,n;s.basedOn&&((l=new t)._deserialize(s.basedOn),this.basedOn=l),s.fill&&((i=new u)._deserialize(s.fill),this.fill=i),s.font&&((r=new h)._deserialize(s.font),this.font=r),s.borders&&((n=new c)._deserialize(s.borders),this.borders=n),this.format=s.format,null!=s.hAlign&&(this.hAlign=e.asEnum(s.hAlign,S,!1)),null!=s.vAlign&&(this.vAlign=e.asEnum(s.vAlign,w,!1)),null==s.indent||isNaN(s.indent)||(this.indent=s.indent),s.wordWrap&&(this.wordWrap=s.wordWrap)},t.prototype._checkEmptyWorkbookStyle=function(){return null==this.basedOn&&null==this.fill&&null==this.font&&null==this.borders&&(null==this.format||""===this.format)&&null==this.hAlign&&null==this.vAlign&&null==this.wordWrap},t}();t.WorkbookStyle=a;var h=function(){function e(){}return e.prototype._serialize=function(){var e;return this._checkEmptyWorkbookFont()?null:(e={},null!=this.bold&&(e.bold=this.bold),null!=this.italic&&(e.italic=this.italic),null!=this.underline&&(e.underline=this.underline),this.color&&(e.color=this.color),this.family&&(e.family=this.family),null==this.size||isNaN(this.size)||(e.size=this.size),e)},e.prototype._deserialize=function(e){this.bold=e.bold,null!=e.color&&(this.color=e.color),this.family=e.family,this.italic=e.italic,this.size=e.size,this.underline=e.underline},e.prototype._checkEmptyWorkbookFont=function(){return null==this.bold&&null==this.italic&&null==this.underline&&(null==this.color||""===this.color)&&(null==this.family||""===this.family)&&(null==this.size||isNaN(this.size))},e}();t.WorkbookFont=h;var u=function(){function e(){}return e.prototype._serialize=function(){return this.color?{color:this.color}:null},e.prototype._deserialize=function(e){null!=e.color&&(this.color=e.color)},e}();t.WorkbookFill=u;var c=function(){function e(){}return e.prototype._serialize=function(){var e;return this._checkEmptyWorkbookBorder()?null:(e={},this.top&&(e.top=this.top._serialize()),this.bottom&&(e.bottom=this.bottom._serialize()),this.left&&(e.left=this.left._serialize()),this.right&&(e.right=this.right._serialize()),this.diagonal&&(e.diagonal=this.diagonal._serialize()),e)},e.prototype._deserialize=function(e){var t,s,l,i,r;e.top&&((t=new f)._deserialize(e.top),this.top=t),e.bottom&&((s=new f)._deserialize(e.bottom),this.bottom=s),e.left&&((l=new f)._deserialize(e.left),this.left=l),e.right&&((i=new f)._deserialize(e.right),this.right=i),e.diagonal&&((r=new f)._deserialize(e.diagonal),this.diagonal=r)},e.prototype._checkEmptyWorkbookBorder=function(){return null==this.top&&null==this.bottom&&null==this.left&&null==this.right&&null==this.diagonal},e}();t.WorkbookBorder=c;var f=function(){function t(){}return t.prototype._serialize=function(){var t;return null!=this.color&&""!==this.color||null!=this.style?(t={},this.color&&(t.color=this.color),null!=this.style&&(t.style=e.asEnum(this.style,x,!1)),t):null},t.prototype._deserialize=function(t){null!=t.color&&(this.color=t.color,null!=t.style&&(this.style=e.asEnum(t.style,x,!1)))},t}();t.WorkbookBorderSetting=f;var d=function(){function e(){}return e.prototype._serialize=function(){var e;return null==this.name?null:(e={name:this.name,value:this.value},null!=this.sheetName&&(e.sheetName=this.sheetName),e)},e.prototype._deserialize=function(e){this.name=e.name,this.value=e.value,this.sheetName=e.sheetName},e}();t.DefinedName=d;var p=function(){function t(){}return Object.defineProperty(t.prototype,"columns",{get:function(){return null==this._columns&&(this._columns=[]),this._columns},enumerable:!0,configurable:!0}),t.prototype._serialize=function(){var e,t;return null==this.name||null==this.range||null==this._columns?null:(null!=this.style&&(t=this.style._serialize()),e={name:this.name,range:this.range,showHeaderRow:this.showHeaderRow,showTotalRow:this.showTotalRow,style:t,showBandedColumns:this.showBandedColumns,showBandedRows:this.showBandedRows,alterFirstColumn:this.alterFirstColumn,alterLastColumn:this.alterLastColumn,columns:[]},e.columns=this._serializeTableColumns(),e)},t.prototype._deserialize=function(e){var t;this.name=e.name,this.range=e.range,this.showHeaderRow=e.showHeaderRow,this.showTotalRow=e.showTotalRow,null!=e.style&&((t=new g)._deserialize(e.style),this.style=t),this.showBandedColumns=e.showBandedColumns,this.showBandedRows=e.showBandedRows,this.alterFirstColumn=e.alterFirstColumn,this.alterLastColumn=e.alterLastColumn,this._deserializeTableColumns(e.columns)},t.prototype._serializeTableColumns=function(){var e,t,s=[];for(t=0;t<this._columns.length;t++)(e=this._columns[t])&&(s[t]=e._serialize());return s},t.prototype._deserializeTableColumns=function(t){var s,l,i;for(e.assert(null!=t,"table Columns should not be null."),this._columns=[],i=0;i<t.length;i++)(l=t[i])&&((s=new m)._deserialize(l),this._columns[i]=s)},t}();t.WorkbookTable=p;var m=function(){function e(){}return e.prototype._serialize=function(){return null==this.name?null:{name:this.name,totalRowLabel:this.totalRowLabel,totalRowFunction:this.totalRowFunction,showFilterButton:this.showFilterButton}},e.prototype._deserialize=function(e){this.name=e.name,this.totalRowLabel=e.totalRowLabel,this.totalRowFunction=e.totalRowFunction,this.showFilterButton=e.showFilterButton},e}();t.WorkbookTableColumn=m;var g=function(){function e(){}return e.prototype._serialize=function(){var e;return this._checkEmptyWorkbookTableStyle()?null:(e={name:this.name},this.wholeTableStyle&&(e.wholeTableStyle=this.wholeTableStyle._serialize()),this.firstBandedColumnStyle&&(e.firstBandedColumnStyle=this.firstBandedColumnStyle._serialize()),this.firstBandedRowStyle&&(e.firstBandedRowStyle=this.firstBandedRowStyle._serialize()),this.secondBandedColumnStyle&&(e.secondBandedColumnStyle=this.secondBandedColumnStyle._serialize()),this.secondBandedRowStyle&&(e.secondBandedRowStyle=this.secondBandedRowStyle._serialize()),this.headerRowStyle&&(e.headerRowStyle=this.headerRowStyle._serialize()),this.totalRowStyle&&(e.totalRowStyle=this.totalRowStyle._serialize()),this.firstColumnStyle&&(e.firstColumnStyle=this.firstColumnStyle._serialize()),this.lastColumnStyle&&(e.lastColumnStyle=this.lastColumnStyle._serialize()),this.firstHeaderCellStyle&&(e.firstHeaderCellStyle=this.firstHeaderCellStyle._serialize()),this.lastHeaderCellStyle&&(e.lastHeaderCellStyle=this.lastHeaderCellStyle._serialize()),this.firstTotalCellStyle&&(e.firstTotalCellStyle=this.firstTotalCellStyle._serialize()),this.lastTotalCellStyle&&(e.lastTotalCellStyle=this.lastTotalCellStyle._serialize()),e)},e.prototype._deserialize=function(e){this.name=e.name,e.wholeTableStyle&&(this.wholeTableStyle=new _,this.wholeTableStyle._deserialize(e.wholeTableStyle)),e.firstBandedColumnStyle&&(this.firstBandedColumnStyle=new y,this.firstBandedColumnStyle._deserialize(e.firstBandedColumnStyle)),e.firstBandedRowStyle&&(this.firstBandedRowStyle=new y,this.firstBandedRowStyle._deserialize(e.firstBandedRowStyle)),e.secondBandedColumnStyle&&(this.secondBandedColumnStyle=new y,this.secondBandedColumnStyle._deserialize(e.secondBandedColumnStyle)),e.secondBandedRowStyle&&(this.secondBandedRowStyle=new y,this.secondBandedRowStyle._deserialize(e.secondBandedRowStyle)),e.headerRowStyle&&(this.headerRowStyle=new _,this.headerRowStyle._deserialize(e.headerRowStyle)),e.totalRowStyle&&(this.totalRowStyle=new _,this.totalRowStyle._deserialize(e.totalRowStyle)),e.firstColumnStyle&&(this.firstColumnStyle=new _,this.firstColumnStyle._deserialize(e.firstColumnStyle)),e.lastColumnStyle&&(this.lastColumnStyle=new _,this.lastColumnStyle._deserialize(e.lastColumnStyle)),e.firstHeaderCellStyle&&(this.firstHeaderCellStyle=new _,this.firstHeaderCellStyle._deserialize(e.firstHeaderCellStyle)),e.lastHeaderCellStyle&&(this.lastHeaderCellStyle=new _,this.lastHeaderCellStyle._deserialize(e.lastHeaderCellStyle)),e.firstTotalCellStyle&&(this.firstTotalCellStyle=new _,this.firstTotalCellStyle._deserialize(e.firstTotalCellStyle)),e.lastTotalCellStyle&&(this.lastTotalCellStyle=new _,this.lastTotalCellStyle._deserialize(e.lastTotalCellStyle))},e.prototype._checkEmptyWorkbookTableStyle=function(){return null==this.name||null==this.wholeTableStyle&&null==this.firstBandedColumnStyle&&null==this.firstBandedRowStyle&&null==this.secondBandedColumnStyle&&null==this.secondBandedRowStyle&&null==this.headerRowStyle&&null==this.totalRowStyle&&null==this.firstColumnStyle&&null==this.lastColumnStyle&&null==this.firstHeaderCellStyle&&null==this.lastHeaderCellStyle&&null==this.firstTotalCellStyle&&null==this.lastTotalCellStyle},e}();t.WorkbookTableStyle=g;var _=function(e){function t(){return e.call(this)||this}return __extends(t,e),t.prototype._deserialize=function(t){var s;e.prototype._deserialize.call(this,t),t.borders&&((s=new b)._deserialize(t.borders),this.borders=s)},t}(a);t.WorkbookTableCommonStyle=_;var y=function(e){function t(){return e.call(this)||this}return __extends(t,e),t.prototype._serialize=function(){var t;return t=e.prototype._serialize.call(this),t.size=this.size,t},t.prototype._deserialize=function(t){e.prototype._deserialize.call(this,t),null!=t.size&&(this.size=t.size)},t}(_);t.WorkbookTableBandedStyle=y;var b=function(e){function t(){return e.call(this)||this}return __extends(t,e),t.prototype._serialize=function(){var t;return null!=(t=e.prototype._serialize.call(this))||this.vertical&&this.horizontal||(t={}),this.vertical&&(t.vertical=this.vertical._serialize()),this.horizontal&&(t.horizontal=this.horizontal._serialize()),t},t.prototype._deserialize=function(t){var s,l;e.prototype._deserialize.call(this,t),t.vertical&&((s=new f)._deserialize(t.vertical),this.vertical=s),t.horizontal&&((l=new f)._deserialize(t.horizontal),this.horizontal=l)},t}(c);t.WorkbookTableBorder=b;var v=function(){function e(){}return e.prototype._serialize=function(){var e={text:this.text};return this.font&&(e.font=this.font._serialize()),e},e.prototype._deserialize=function(e){e.font&&(this.font=new h,this.font._deserialize(e.font)),this.text=e.text},e}();t.WorkbookTextRun=v;var S;!function(e){e[e.General=0]="General",e[e.Left=1]="Left",e[e.Center=2]="Center",e[e.Right=3]="Right",e[e.Fill=4]="Fill",e[e.Justify=5]="Justify"}(S=t.HAlign||(t.HAlign={}));var w;!function(e){e[e.Top=0]="Top",e[e.Center=1]="Center",e[e.Bottom=2]="Bottom",e[e.Justify=3]="Justify"}(w=t.VAlign||(t.VAlign={}));var x;!function(e){e[e.None=0]="None",e[e.Thin=1]="Thin",e[e.Medium=2]="Medium",e[e.Dashed=3]="Dashed",e[e.Dotted=4]="Dotted",e[e.Thick=5]="Thick",e[e.Double=6]="Double",e[e.Hair=7]="Hair",e[e.MediumDashed=8]="MediumDashed",e[e.ThinDashDotted=9]="ThinDashDotted",e[e.MediumDashDotted=10]="MediumDashDotted",e[e.ThinDashDotDotted=11]="ThinDashDotDotted",e[e.MediumDashDotDotted=12]="MediumDashDotDotted",e[e.SlantedMediumDashDotted=13]="SlantedMediumDashDotted"}(x=t.BorderStyle||(t.BorderStyle={}))}(e.xlsx||(e.xlsx={}))}(wijmo||(wijmo={}));
/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),wijmo;!function(e){!function(t){var n=function(n){function i(r,s){var o=n.call(this,r)||this;o._itmPath=new t._BindingArray("items"),o._dspPath=new t._BindingArray("header"),o._imgPath=new t._BindingArray,o._html=!1,o._animated=!0,o._xpndOnClick=!0,o._autoColl=!0,o._showChk=!1,o._srch="",o._isReadOnly=!0,o.itemsSourceChanged=new e.Event,o.loadingItems=new e.Event,o.loadedItems=new e.Event,o.itemClicked=new e.Event,o.selectedItemChanged=new e.Event,o.checkedItemsChanged=new e.Event,o.isCollapsedChanging=new e.Event,o.isCollapsedChanged=new e.Event,o.isCheckedChanging=new e.Event,o.isCheckedChanged=new e.Event,o.formatItem=new e.Event,o.dragStart=new e.Event,o.dragOver=new e.Event,o.drop=new e.Event,o.dragEnd=new e.Event,o.nodeEditStarting=new e.Event,o.nodeEditStarted=new e.Event,o.nodeEditEnding=new e.Event,o.nodeEditEnded=new e.Event;var a=o.getTemplate();o.applyTemplate("wj-control wj-content wj-treeview",a,{_root:"root"});var l=o.hostElement;return e.setAttribute(l,"role","tree",!0),e.addClass(o._root,i._CNDL),e.setAttribute(o._root,"role","group",!0),o.addEventListener(l,"mousedown",o._mousedown.bind(o)),o.addEventListener(l,"click",o._click.bind(o)),o.addEventListener(l,"keydown",o._keydown.bind(o)),o.addEventListener(l,"keypress",o._keypress.bind(o)),o.addEventListener(l,"wheel",function(e){l.scrollHeight>l.offsetHeight&&(e.deltaY<0&&0==l.scrollTop||e.deltaY>0&&l.scrollTop+l.offsetHeight>=l.scrollHeight)&&(e.preventDefault(),e.stopPropagation())}),o.addEventListener(l,"blur",function(t){o._edtNode&&!e.contains(o._edtNode.element,e.getActiveElement())&&o.finishEditing()},!0),o.initialize(s),o.refresh(),o}return __extends(i,n),Object.defineProperty(i.prototype,"itemsSource",{get:function(){return this._items},set:function(t){this._items!=t&&(this._items=e.asArray(t),this.onItemsSourceChanged(),this._reload())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"childItemsPath",{get:function(){return this._itmPath.path},set:function(e){e!=this.childItemsPath&&(this._itmPath.path=e,this._reload())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"displayMemberPath",{get:function(){return this._dspPath.path},set:function(e){e!=this.displayMemberPath&&(this._dspPath.path=e,this._reload())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"imageMemberPath",{get:function(){return this._imgPath.path},set:function(e){e!=this.imageMemberPath&&(this._imgPath.path=e,this._reload())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isContentHtml",{get:function(){return this._html},set:function(t){t!=this._html&&(this._html=e.asBoolean(t),this._reload())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"showCheckboxes",{get:function(){return this._showChk},set:function(t){t!=this._showChk&&(this._showChk=e.asBoolean(t),this._reload())},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"autoCollapse",{get:function(){return this._autoColl},set:function(t){this._autoColl=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isAnimated",{get:function(){return this._animated},set:function(t){t!=this._animated&&(this._animated=e.asBoolean(t))},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isReadOnly",{get:function(){return this._isReadOnly},set:function(t){this._isReadOnly=e.asBoolean(t),e.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0}),i.prototype.startEditing=function(n){if(this.isReadOnly)return!1;if(n||(n=this.selectedNode),!n||n.isDisabled)return!1;if(!this.finishEditing())return!1;var r=n.element.querySelector("."+i._CNDT);if(!r)return!1;var s=new t.TreeNodeEventArgs(n);if(!this.onNodeEditStarting(s))return!1;r.tabIndex=0,r.focus(),r.contentEditable="true",r.style.cursor="auto";var o=document.createRange();o.selectNodeContents(r);var a=getSelection();return a.removeAllRanges(),a.addRange(o),r.focus(),e.setAttribute(r,"autocomplete","off"),e.setAttribute(r,"autocorrect","off"),this._edtNode=n,this.onNodeEditStarted(s),!0},i.prototype.finishEditing=function(e){var n=this._edtNode;if(n){var r=n.element.querySelector("."+i._CNDT);if(!r)return!1;var s=new t.TreeNodeEventArgs(n);if(!this.onNodeEditEnding(s))return!1;var o=n.dataItem,a=n.level;this.isContentHtml?e?r.innerHTML=this._dspPath.getValue(o,a):this._dspPath.setValue(o,a,r.innerHTML):e?r.textContent=this._dspPath.getValue(o,a):this._dspPath.setValue(o,a,r.textContent),document.createRange().selectNodeContents(r),getSelection().removeAllRanges(),r.contentEditable="false",r.style.cursor="",this._edtNode=null,this.onNodeEditEnded(s)}return!0},Object.defineProperty(i.prototype,"allowDragging",{get:function(){return null!=this._dd},set:function(n){if(n!=this.allowDragging){e.asBoolean(n)?this._dd=new t._TreeDragDropManager(this):(this._dd.dispose(),this._dd=null);for(var r=this.hostElement.querySelectorAll("."+i._CND),s=0;s<r.length;s++){var o=r[s];e.setAttribute(o,"draggable",!!this._dd||null)}}},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"expandOnClick",{get:function(){return this._xpndOnClick},set:function(t){this._xpndOnClick=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectedItem",{get:function(){return this._selNode?this._selNode.dataItem:null},set:function(e){e!=this.selectedItem&&(this.selectedNode=e?this.getNode(e):null)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectedNode",{get:function(){return this._selNode},set:function(t){t!=this.selectedNode&&(this._prevSel=this._selNode,t?t.select():this._selNode&&(e.removeClass(this._selNode.element,i._CSEL),this._selNode=null,this.onSelectedItemChanged()))},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"selectedPath",{get:function(){for(var e=[],t=this.selectedNode;t;t=t.parentNode){var n=this._dspPath.getValue(t.dataItem,t.level);e.splice(0,0,n)}return e},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"checkedItems",{get:function(){if(null==this._chkItems){var e=i,t="."+e._CND+"."+e._CEMP+" > input:checked."+e._CNDC,n=this._root.querySelectorAll(t);this._chkItems=[];for(var r=0;r<n.length;r++){var s=n[r].parentElement[e._DATAITEM_KEY];this._chkItems.push(s)}}return this._chkItems},set:function(e){if(this.showCheckboxes)for(var n=i,r="."+n._CND+"."+n._CEMP,s=this._root.querySelectorAll(r),o=0;o<s.length;o++){var a=new t.TreeNode(this,s[o]),l=e.indexOf(a.dataItem)>-1;a.isChecked!=l&&(a.isChecked=l)}},enumerable:!0,configurable:!0}),i.prototype.checkAllItems=function(e){if(this.showCheckboxes)for(var n=i,r="."+n._CND+"."+n._CEMP,s=this._root.querySelectorAll(r),o=0;o<s.length;o++){var a=new t.TreeNode(this,s[o]);a.isChecked!=e&&(a.isChecked=e)}},Object.defineProperty(i.prototype,"totalItemCount",{get:function(){return this.hostElement.querySelectorAll("."+i._CND).length},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"lazyLoadFunction",{get:function(){return this._lazyLoad},set:function(t){t!=this._lazyLoad&&(this._lazyLoad=e.asFunction(t),this._reload())},enumerable:!0,configurable:!0}),i.prototype.getFirstNode=function(e,n){var r=this.hostElement.querySelector("."+i._CND),s=r?new t.TreeNode(this,r):null;return e&&s&&!s.element.offsetHeight&&(s=s.next(e,n)),n&&s&&s.isDisabled&&(s=s.next(e,n)),s},i.prototype.getLastNode=function(e,n){var r=this.hostElement.querySelectorAll("."+i._CND+":last-child"),s=r.length?new t.TreeNode(this,r[r.length-1]):null;return e&&s&&!s.element.offsetHeight&&(s=s.previous(e,n)),n&&s&&s.isDisabled&&(s=s.previous(e,n)),s},Object.defineProperty(i.prototype,"nodes",{get:function(){return t.TreeNode._getChildNodes(this,this._root)},enumerable:!0,configurable:!0}),i.prototype.getNode=function(e){this._isDirty&&this._loadTree();for(var n=this.hostElement.querySelectorAll("."+i._CND),r=0;r<n.length;r++){var s=n[r];if(s[i._DATAITEM_KEY]==e)return new t.TreeNode(this,s)}return null},i.prototype.addChildNode=function(e,n){var i=this._createNode(n),r=this.nodes;return r?e<r.length?i.move(r[e],t.DropPosition.Before):i.move(r[r.length-1],t.DropPosition.After):i.move(this,t.DropPosition.Into),i},i.prototype.collapseToLevel=function(e){var t=this._animated,n=this._autoColl;this._animated=this._autoColl=!1,this._collapseToLevel(this.nodes,e,0),this._animated=t,this._autoColl=n},i.prototype.loadTree=function(e){this._loadTree(e)},i.prototype.onItemsSourceChanged=function(e){this.itemsSourceChanged.raise(this,e)},i.prototype.onLoadingItems=function(e){return this.loadingItems.raise(this,e),!e.cancel},i.prototype.onLoadedItems=function(e){this.loadedItems.raise(this,e)},i.prototype.onItemClicked=function(e){this.itemClicked.raise(this,e)},i.prototype.onSelectedItemChanged=function(e){this.selectedItemChanged.raise(this,e)},i.prototype.onCheckedItemsChanged=function(e){this._chkItems=null,this.checkedItemsChanged.raise(this,e)},i.prototype.onIsCollapsedChanging=function(e){return this.isCollapsedChanging.raise(this,e),!e.cancel},i.prototype.onIsCollapsedChanged=function(e){this.isCollapsedChanged.raise(this,e)},i.prototype.onIsCheckedChanging=function(e){return this.isCheckedChanging.raise(this,e),!e.cancel},i.prototype.onIsCheckedChanged=function(e){this.isCheckedChanged.raise(this,e)},i.prototype.onFormatItem=function(e){this.formatItem.raise(this,e)},i.prototype.onDragStart=function(e){return this.dragStart.raise(this,e),!e.cancel},i.prototype.onDragOver=function(e){return this.dragOver.raise(this,e),!e.cancel},i.prototype.onDrop=function(e){return this.drop.raise(this,e),!e.cancel},i.prototype.onDragEnd=function(e){this.dragEnd.raise(this,e)},i.prototype.onNodeEditStarting=function(e){return this.nodeEditStarting.raise(this,e),!e.cancel},i.prototype.onNodeEditStarted=function(e){this.nodeEditStarted.raise(this,e)},i.prototype.onNodeEditEnding=function(e){return this.nodeEditEnding.raise(this,e),!e.cancel},i.prototype.onNodeEditEnded=function(e){this.nodeEditEnded.raise(this,e)},i.prototype.refresh=function(e){void 0===e&&(e=!0),n.prototype.refresh.call(this,e),!this.isUpdating&&this._isDirty&&this._loadTree()},i.prototype._raiseCheckedItemsChanged=function(){var e=this;this._toItemsChanged&&clearTimeout(this._toItemsChanged),this._toItemsChanged=setTimeout(function(){e._toItemsChanged=null,e.onCheckedItemsChanged()},10)},i.prototype._reload=function(){this._isDirty=!0,this.invalidate()},i.prototype._createNode=function(e){return new i(document.createElement("div"),{childItemsPath:this.childItemsPath,displayMemberPath:this.displayMemberPath,imageMemberPath:this.imageMemberPath,isContentHtml:this.isContentHtml,showCheckboxes:this.showCheckboxes,itemsSource:[e]}).getFirstNode()},i.prototype._mousedown=function(n){if(!n.defaultPrevented){var r=e.closest(n.target,"input."+i._CNDC),s=e.closestClass(n.target,i._CND),o=s?new t.TreeNode(this,s):null;o&&!o.isDisabled&&(this.selectedNode=o),this._dnIndet=r&&r.indeterminate}},i.prototype._click=function(n){if(!n.defaultPrevented){var r=e.closestClass(n.target,i._CND);if(r){var s=new t.TreeNode(this,r),o=e.closest(n.target,"input."+i._CNDC);if(s.isDisabled)return;if(!o&&s.equals(this._edtNode))return;if(r.focus(),o&&(n.preventDefault(),n.stopPropagation(),setTimeout(function(){o.indeterminate=!1,s.isChecked=!s.isChecked})),!o){var a=n.target,l=(n.ctrlKey||n.metaKey)&&!s.hasPendingChildren,d=r.getBoundingClientRect(),h=!1;(this.rightToLeft?d.right-n.clientX:n.clientX-d.left)<=a.offsetHeight?(l?this.collapseToLevel(s.isCollapsed?s.level+1:s.level):s.isCollapsed=!s.isCollapsed,h=!0):this.expandOnClick&&s.isCollapsed&&(l?this.collapseToLevel(s.level):s.isCollapsed=!1,h=!0),h&&l&&this.selectedNode&&this.selectedNode.ensureVisible(),h||this.isReadOnly||this.selectedNode&&this.selectedNode.equals(this._prevSel)&&this.startEditing()}this.selectedItem&&this.onItemClicked()}}},i.prototype._keydown=function(t){if(!t.defaultPrevented){var n=this._selNode,i=void 0,r=t.keyCode,s=!0;if(n&&!n.isDisabled){switch(r){case e.Key.F2:this.startEditing(),t.preventDefault();break;case e.Key.Escape:this.finishEditing(!0),t.preventDefault();break;case e.Key.Up:case e.Key.Down:this.finishEditing();break;case e.Key.Enter:this._edtNode?(this.finishEditing(),r=e.Key.Down):(this.startEditing(),t.preventDefault())}if(this._edtNode)return;if(this.rightToLeft)switch(r){case e.Key.Left:r=e.Key.Right;break;case e.Key.Right:r=e.Key.Left}switch(r){case e.Key.Left:!n.isCollapsed&&n.hasChildren?n.setCollapsed(!0):(n=n.parentNode)&&n.select();break;case e.Key.Right:n.setCollapsed(!1);break;case e.Key.Up:i=n.previous(!0,!0);break;case e.Key.Down:i=n.next(!0,!0);break;case e.Key.Home:i=this.getFirstNode(!0,!0);break;case e.Key.End:i=this.getLastNode(!0,!0);break;case e.Key.Space:if(this.selectedItem){var o=n.checkBox;o&&(n.isChecked=!o.checked)}break;case e.Key.Enter:this.selectedItem&&this.onItemClicked();break;default:s=!1}s&&(t.preventDefault(),i&&i.select())}}},i.prototype._keypress=function(t){var n=this;if(!t.defaultPrevented){if(t.ctrlKey||t.metaKey||t.altKey)return;if(t.target instanceof HTMLInputElement)return;if(this._edtNode)return;if(t.charCode>32&&this.startEditing(this.selectedNode)){var r=e.getActiveElement();if(e.contains(this._edtNode.element,r)){r.textContent=String.fromCharCode(t.charCode),t.preventDefault();var s=document.createRange();s.selectNodeContents(r),s.collapse(!1);var o=getSelection();o.removeAllRanges(),o.addRange(s)}return}if(t.charCode>32||32==t.charCode&&this._srch){t.preventDefault(),this._srch+=String.fromCharCode(t.charCode).toLowerCase(),this._toSrch&&clearTimeout(this._toSrch),this._toSrch=setTimeout(function(){n._toSrch=null,n._srch=""},i._AS_DLY);var a=this._findNext();null==a&&this._srch.length>1&&(this._srch=this._srch[this._srch.length-1],a=this._findNext()),null!=a&&(this.selectedItem=a)}}},i.prototype._findNext=function(){if(this.hostElement&&this.selectedItem){var e=this.getNode(this.selectedItem),t=e,n=!1,i=!1;for(1==this._srch.length&&(i=!0);t;){if(!t.isDisabled&&!i&&0==t.element.textContent.trim().toLowerCase().indexOf(this._srch))return t.dataItem;var r=t.next(!0,!0);if(r==e&&n)break;r||n||(r=this.getFirstNode(!0,!0),n=!0),t=r,i=!1}}return null},i.prototype._loadTree=function(n){var r=this._root;if(r){if(!this.onLoadingItems(new e.CancelEventArgs))return;this._isDirty=!1;var s=this.containsFocus(),o=this.selectedItem;this.selectedItem=null,this._chkItems=null,this._ldLvl=-1;var a=void 0;if(n&&e.isFunction(window.Map)){a=new Map;for(var l=this.hostElement.querySelectorAll("."+i._CND),d=0;d<l.length;d++){h=l[d];e.hasClass(h,i._CCLD)&&a.set(h[i._DATAITEM_KEY],!0)}}if(r.innerHTML="",this._items)for(d=0;d<this._items.length;d++)this._addItem(r,0,this._items[d]);if(a)for(var l=this.hostElement.querySelectorAll("."+i._CND),d=0;d<l.length;d++){var h=l[d],c=t.TreeNode._isNodeList(h),u=a.get(h[i._DATAITEM_KEY]);e.toggleClass(h,i._CCLD,1==u),e.setAttribute(h,"aria-expanded",c?(!u).toString():null)}s&&!this.containsFocus()&&this.focus(),this.selectedItem=o,this.onLoadedItems(),this._ldLvl=-1}},i.prototype._addItem=function(n,r,s){var o=this._dspPath.getValue(s,r),a=this._imgPath.getValue(s,r),l=e.asArray(this._itmPath.getValue(s,r),!0),d=document.createElement("div");e.addClass(d,i._CND),d.tabIndex=0,e.setAttribute(d,"role","treeitem",!0);var h=document.createElement("span");if(this.isContentHtml?h.innerHTML=o:h.textContent=o,e.addClass(h,i._CNDT),d.appendChild(h),a){var c=document.createElement("img");c.src=a,d.insertBefore(c,d.firstChild)}if(this._showChk&&!this._lazyLoad){var u=document.createElement("input");u.type="checkbox",u.tabIndex=-1,e.addClass(u,i._CNDC),d.insertBefore(u,d.firstChild)}if(this._dd&&d.setAttribute("draggable","true"),n.appendChild(d),d[i._DATAITEM_KEY]=s,l&&0==l.length&&!this.lazyLoadFunction&&(l=null),l){var p=!0;if(r>this._ldLvl?(this._ldLvl=r,0==l.length&&(e.addClass(d,i._CCLD),p=!1)):(e.addClass(d,i._CCLD),p=!1,r<this._ldLvl&&(this._ldLvl=1e4)),l.length>0){var _=document.createElement("div");e.addClass(_,i._CNDL);for(var f=0;f<l.length;f++)this._addItem(_,r+1,l[f]);n.appendChild(_),e.setAttribute(d,"aria-expanded",p.toString(),!0),e.setAttribute(_,"role","group",!0)}}else e.addClass(d,i._CEMP);this.formatItem.hasHandlers&&this.onFormatItem(new t.FormatNodeEventArgs(s,d,r))},i.prototype._collapseToLevel=function(e,t,n){for(var i=0;i<e.length;i++){var r=e[i];r.hasPendingChildren||(r.isCollapsed=n>=t,r.hasChildren&&this._collapseToLevel(r.nodes,t,n+1))}},i.prototype._lazyLoadNode=function(t){var n=this.hostElement;e.hasClass(n,i._CLDG)||(e.addClass(n,i._CLDG),e.addClass(t.element,i._CLDG),this.lazyLoadFunction(t,this._lazyLoadCallback.bind(t)))},i.prototype._lazyLoadCallback=function(e){var t=this;t.treeView._lazyLoadNodeDone(t,e)},i.prototype._lazyLoadNodeDone=function(t,n){var r=i;e.removeClass(t.element,r._CLDG),e.removeClass(this.hostElement,r._CLDG);var s=t.dataItem,o=t.level,a=e.asArray(n,!0);if(null==a||0==a.length)this._itmPath.setValue(s,o,null),e.addClass(t.element,r._CEMP);else if(a.length){this._itmPath.setValue(s,o,a);var l=document.createElement("div"),d=t.element;e.addClass(l,r._CNDL),d.parentElement.insertBefore(l,d.nextSibling);for(var h=0;h<a.length;h++)this._addItem(l,o+1,a[h]);t.isCollapsed=!1}},i._DATAITEM_KEY="wj-Data-Item",i._AS_DLY=600,i._AN_DLY=200,i._CND="wj-node",i._CNDL="wj-nodelist",i._CEMP="wj-state-empty",i._CNDT="wj-node-text",i._CNDC="wj-node-check",i._CSEL="wj-state-selected",i._CCLD="wj-state-collapsed",i._CCLG="wj-state-collapsing",i._CLDG="wj-state-loading",i.controlTemplate='<div wj-part="root"></div>',i}(e.Control);t.TreeView=n}(e.nav||(e.nav={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){var n=function(){function n(t,i){e.hasClass(i,"wj-treeview")?(t=e.Control.getControl(i),i=null):n._assertNode(i),this._t=t,this._e=i}return Object.defineProperty(n.prototype,"dataItem",{get:function(){return this._e[t.TreeView._DATAITEM_KEY]},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"element",{get:function(){return this._e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"treeView",{get:function(){return this._t},enumerable:!0,configurable:!0}),n.prototype.ensureVisible=function(){for(var e=this.parentNode;e;e=e.parentNode)e.isCollapsed=!1;var t=this._t.hostElement,n=this.element.getBoundingClientRect(),i=t.getBoundingClientRect();n.bottom>i.bottom?t.scrollTop+=n.bottom-i.bottom:n.top<i.top&&(t.scrollTop-=i.top-n.top)},n.prototype.equals=function(e){return null!=e&&e.element==this.element},n.prototype.select=function(){var n=this._t,i=n._selNode;this.equals(i)||(i&&e.removeClass(i.element,t.TreeView._CSEL),n._selNode=this,e.addClass(this.element,t.TreeView._CSEL),this.ensureVisible(),n.containsFocus()&&this.element.focus(),n.onSelectedItemChanged())},Object.defineProperty(n.prototype,"index",{get:function(){for(var e=0,t=this._pse(this.element);t;t=this._pse(t))n._isNode(t)&&e++;return e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"parentNode",{get:function(){var e=null;if(this._e){var t=this._e.parentElement;n._assertNodeList(t),e=this._pse(t)}return e?new n(this._t,e):null},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"level",{get:function(){for(var e=-1,t=this;t;t=t.parentNode)e++;return e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"hasChildren",{get:function(){return n._isNode(this._e)&&!n._isEmpty(this._e)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"hasPendingChildren",{get:function(){return this.isCollapsed&&this.hasChildren&&!n._isNodeList(this.element.nextElementSibling)&&e.isFunction(this._t.lazyLoadFunction)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"nodes",{get:function(){return this.hasChildren?n._getChildNodes(this._t,this._e.nextSibling):null},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"checkBox",{get:function(){return this._e.querySelector("input."+t.TreeView._CNDC)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isCollapsed",{get:function(){return this.hasChildren&&e.hasClass(this._e,t.TreeView._CCLD)},set:function(n){if(n!=this.isCollapsed){var i=this._t,r=new t.TreeNodeEventArgs(this);i.onIsCollapsedChanging(r)&&(this.setCollapsed(e.asBoolean(n),i.isAnimated,i.autoCollapse),i.onIsCollapsedChanged(r))}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isChecked",{get:function(){var e=this.checkBox;return e&&!e.indeterminate?e.checked:null},set:function(n){if(n!=this.isChecked){var i=this._t,r=new t.TreeNodeEventArgs(this);i.onIsCheckedChanging(r)&&(this.setChecked(e.asBoolean(n),!0),i.onIsCheckedChanged(r))}},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isDisabled",{get:function(){return this._e&&null!=this._e.getAttribute("disabled")},set:function(t){(t=e.asBoolean(t,!0))!=this.isDisabled&&e.enable(this._e,!t)},enumerable:!0,configurable:!0}),n.prototype.previous=function(e,t){var i=this._pse(this._e);if(!i&&n._isNodeList(this._e.parentElement)&&(i=this._pse(this._e.parentElement)),n._isNodeList(i)){for(;n._isNodeList(i)&&i.childElementCount;)i=i.lastChild;n._isNodeList(i)&&(i=this._pse(i))}var r=n._isNode(i)?new n(this._t,i):null;return e&&r&&!r.element.offsetHeight&&(r=r.previous(e,t)),t&&r&&r.isDisabled&&(r=r.previous(e,t)),r},n.prototype.next=function(e,t){var i=this._e.nextSibling;if(n._isNodeList(i)&&(i=i.childElementCount?i.firstChild:i.nextSibling),!i)for(var r=this._e.parentElement;!i&&n._isNodeList(r);r=r.parentElement)i=r.nextSibling;var s=n._isNode(i)?new n(this._t,i):null;return e&&s&&!s.element.offsetHeight&&(s=s.next(e,t)),t&&s&&s.isDisabled&&(s=s.next(e,t)),s},n.prototype.previousSibling=function(){for(var e=this._pse(this.element);n._isNodeList(e);)e=this._pse(e);return e?new n(this._t,e):null},n.prototype.nextSibling=function(){var e=this.element.nextSibling;return n._isNodeList(e)&&(e=e.nextSibling),e?new n(this._t,e):null},n.prototype.setCollapsed=function(i,r,s){var o=this._t,a=this._e,l=this._e.nextElementSibling,d=n._isNodeList(l);if(e.setAttribute(a,"aria-expanded",d?(!i).toString():null),i!=this.isCollapsed)if(i||d||!e.isFunction(o.lazyLoadFunction)){if(null==r&&(r=o.isAnimated),null==s&&(s=o.autoCollapse),r){if(d){var h=l.offsetHeight,c=l.style;i?(e.toggleClass(a,t.TreeView._CCLG,!0),e.animate(function(n){n<1?(n=1-n,c.height=(n*h).toFixed(0)+"px"):(c.height=c.opacity="",e.toggleClass(a,t.TreeView._CCLD,!0),e.toggleClass(a,t.TreeView._CCLG,!1))},t.TreeView._AN_DLY)):(e.toggleClass(a,t.TreeView._CCLD,!1),c.height=c.opacity="0",e.animate(function(e){c.height=e>=1?c.opacity="":(e*h).toFixed(0)+"px"},t.TreeView._AN_DLY))}}else e.toggleClass(a,t.TreeView._CCLD,i);if(!i&&s){var u=a.parentElement;if(n._isNodeList(u))for(var p=0;p<u.children.length;p++){var _=u.children[p];_!=a&&n._isNode(_)&&(e.toggleClass(_,t.TreeView._CCLD,!0),_.setAttribute("aria-expanded","false"))}}}else o._lazyLoadNode(this)},n.prototype.setChecked=function(e,t){var n=this.checkBox,i=n.checked!=e;if(n.checked=e,n.indeterminate=!1,this.hasChildren)for(var r=this.nodes,s=0;s<r.length;s++)r[s].setChecked(e,!1);if(t){var o=this.parentNode;o&&o._updateCheckedState()}this._t&&i&&this._t._raiseCheckedItemsChanged()},n.prototype.remove=function(){var t=this._t,i=this.parentNode,r=this._getArray(),s=r.indexOf(this.dataItem);t.selectedNode==this&&(t.selectedNode=this.nextSibling()||this.previousSibling()||i);var o=this.element.nextSibling;n._isNodeList(o)&&e.removeChild(o),e.removeChild(this.element),i&&i._updateState(),r.splice(s,1),this._t=null},n.prototype.addChildNode=function(e,n){var i=this._t._createNode(n),r=this.nodes;return r?e<r.length?i.move(r[e],t.DropPosition.Before):i.move(r[r.length-1],t.DropPosition.After):i.move(this,t.DropPosition.Into),i},n.prototype.refresh=function(t){var n=this._getArray();t&&(n[this.index]=t),t=n[this.index];var i=this._t._createNode(t),r=this.hasChildren&&!this.hasPendingChildren?this.element.nextSibling:null;r&&e.removeChild(r),(r=i.hasChildren&&!i.hasPendingChildren?i.element.nextSibling:null)&&this.element.parentElement.insertBefore(r,this.element.nextSibling),this.element.innerHTML=i.element.innerHTML,this._updateState()},n.prototype.move=function(e,t){if(e instanceof n&&this._contains(e))return!1;var i=this.parentNode,r=this._getArray();this._moveElements(e,t);var s=this.parentNode,o=this._getArray();i&&i._updateState(),s&&s._updateState();var a=this.dataItem,l=r.indexOf(a);return r.splice(l,1),o.splice(this.index,0,a),e.treeView&&(this._t=e.treeView),!0},Object.defineProperty(n.prototype,"itemsSource",{get:function(){return this._getArray()},enumerable:!0,configurable:!0}),n.prototype._pse=function(e){return e.previousElementSibling},n.prototype._contains=function(e){for(;e;e=e.parentNode)if(e.element==this.element)return!0;return!1},n.prototype._getArray=function(){var e=this._t,t=this.parentNode,n=e.itemsSource;if(t){var i=e._itmPath;(n=i.getValue(t.dataItem,this.level))||(n=[],i.setValue(t.dataItem,this.level,n))}return n},n.prototype._moveElements=function(i,r){var s=document.createDocumentFragment(),o=this.hasChildren&&!this.hasPendingChildren?this.element.nextSibling:null;if(s.appendChild(this.element),o&&(n._assertNodeList(o),s.appendChild(o)),i instanceof t.TreeView)i._root.insertBefore(s,null);else{var a=i.element,l=a?a.parentElement:i.treeView._root;n._assertNodeList(l);var d=t.DropPosition;switch(r){case d.Before:l.insertBefore(s,a);break;case d.After:a=(i=i.nextSibling())?i.element:null,l.insertBefore(s,a);break;case d.Into:i.hasChildren&&!i.hasPendingChildren||(o=document.createElement("div"),e.addClass(o,t.TreeView._CNDL),l.insertBefore(o,a.nextSibling)),l=i.element.nextSibling,n._assertNodeList(l),l.insertBefore(s,null)}}},n.prototype._updateState=function(){this._updateEmptyState(),this._updateCheckedState()},n.prototype._updateEmptyState=function(){var i=this.element.nextSibling,r=!1;n._isNodeList(i)&&(i.childElementCount?r=!0:e.removeChild(i)),e.toggleClass(this.element,t.TreeView._CEMP,!r),r||this.element.removeAttribute("aria-expanded")},n.prototype._updateCheckedState=function(){var e=this.checkBox,t=this.nodes,n=0,i=0;if(e&&t){for(var r=0;r<t.length;r++)switch(t[r].isChecked){case!0:n++;break;case!1:i++}n==t.length?(e.checked=!0,e.indeterminate=!1):i==t.length?(e.checked=!1,e.indeterminate=!1):(e.checked=!1,e.indeterminate=!0)}var s=this.parentNode;s&&s._updateCheckedState()},n._getChildNodes=function(e,t){n._assertNodeList(t);var i=[];if(n._isNodeList(t))for(var r=t.children,s=0;s<r.length;s++){var o=r[s];n._isNode(o)&&i.push(new n(e,o))}return i},n._isNode=function(n){return n&&e.hasClass(n,t.TreeView._CND)},n._isNodeList=function(n){return n&&e.hasClass(n,t.TreeView._CNDL)},n._isEmpty=function(i){return n._isNode(i)&&e.hasClass(i,t.TreeView._CEMP)},n._isCollapsed=function(i){return n._isNode(i)&&!n._isEmpty(i)&&e.hasClass(i,t.TreeView._CCLD)},n._assertNode=function(t){e.assert(n._isNode(t),"node expected")},n._assertNodeList=function(t){e.assert(n._isNodeList(t),"nodeList expected")},n}();t.TreeNode=n}(e.nav||(e.nav={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),wijmo;!function(e){!function(t){var n=function(t){function n(n,i,r){var s=t.call(this)||this;return s._data=n,s._e=e.asType(i,HTMLElement),s._level=r,s}return __extends(n,t),Object.defineProperty(n.prototype,"dataItem",{get:function(){return this._data},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"element",{get:function(){return this._e},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"level",{get:function(){return this._level},enumerable:!0,configurable:!0}),n}(e.EventArgs);t.FormatNodeEventArgs=n;var i=function(e){function t(t){var n=e.call(this)||this;return n._node=t,n}return __extends(t,e),Object.defineProperty(t.prototype,"node",{get:function(){return this._node},enumerable:!0,configurable:!0}),t}(e.CancelEventArgs);t.TreeNodeEventArgs=i;var r=function(n){function i(i,r,s){var o=n.call(this)||this;return o._src=e.asType(i,t.TreeNode),o._tgt=e.asType(r,t.TreeNode),o._pos=s,o}return __extends(i,n),Object.defineProperty(i.prototype,"dragSource",{get:function(){return this._src},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"dropTarget",{get:function(){return this._tgt},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"position",{get:function(){return this._pos},set:function(t){this._pos=e.asEnum(t,s)},enumerable:!0,configurable:!0}),i}(e.CancelEventArgs);t.TreeNodeDragDropEventArgs=r;var s;!function(e){e[e.Before=0]="Before",e[e.After=1]="After",e[e.Into=2]="Into"}(s=t.DropPosition||(t.DropPosition={}))}(e.nav||(e.nav={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){var n=function(){function n(n){this._tree=e.asType(n,t.TreeView),this._dragstartBnd=this._dragstart.bind(this),this._dragoverBnd=this._dragover.bind(this),this._dropBnd=this._drop.bind(this),this._dragendBnd=this._dragend.bind(this);var i=this._tree,r=i.hostElement;i.addEventListener(r,"dragstart",this._dragstartBnd),i.addEventListener(r,"dragover",this._dragoverBnd),i.addEventListener(r,"dragleave",this._dragoverBnd),i.addEventListener(r,"drop",this._dropBnd),i.addEventListener(r,"dragend",this._dragendBnd),i.addEventListener(r,"keydown",this._keydown)}return n.prototype.dispose=function(){var e=this._tree,t=e.hostElement;e.removeEventListener(t,"dragstart",this._dragstartBnd),e.removeEventListener(t,"dragover",this._dragoverBnd),e.removeEventListener(t,"dragleave",this._dragoverBnd),e.removeEventListener(t,"drop",this._dropBnd),e.removeEventListener(t,"dragend",this._dragendBnd),e.removeEventListener(t,"keydown",this._keydown),this._showDragMarker()},n.prototype._dragstart=function(i){if(!i.defaultPrevented){var r=this._tree,s=e.closestClass(i.target,t.TreeView._CND),o=n;if(o._drgSrc=t.TreeNode._isNode(s)?new t.TreeNode(r,s):null,o._drgSrc){var a=new t.TreeNodeEventArgs(o._drgSrc);r.onDragStart(a)||(o._drgSrc=null)}o._drgSrc&&i.dataTransfer?(e._startDrag(i.dataTransfer,"copyMove"),i.stopPropagation()):i.preventDefault()}},n.prototype._dragover=function(e){this._handleDragDrop(e,!1)},n.prototype._drop=function(e){this._handleDragDrop(e,!0)},n.prototype._dragend=function(e){n._drgSrc=null,this._showDragMarker(),this._tree.onDragEnd()},n.prototype._keydown=function(t){t.defaultPrevented||t.keyCode==e.Key.Escape&&this._dragendBnd(null)},n.prototype._handleDragDrop=function(i,r){var s,o,a=this._tree,l=n,d=t.DropPosition,h=d.Into;if(!i.defaultPrevented&&l._drgSrc){var c=document.elementFromPoint(i.clientX,i.clientY),u=e.closestClass(c,t.TreeView._CND);if(null==u){var p=e.Control.getControl(e.closest(c,".wj-treeview"));p instanceof t.TreeView&&0==p.totalItemCount&&(u=p.hostElement)}if(u==l._drgSrc.element&&(u=null),u){o=u.getBoundingClientRect();var _=new t.TreeNode(a,u),f=_.hasPendingChildren?o.height/2:o.height/3;null==_.element?((o=e.Rect.fromBoundingRect(o)).inflate(-12,-12),h=d.Before):i.clientY<o.top+f?h=d.Before:(i.clientY>o.bottom-f||_.hasPendingChildren)&&(h=d.After,!_.hasChildren||_.isCollapsed||_.hasPendingChildren||(h=d.Before,o=(u=(_=_.next(!0,!1)).element).getBoundingClientRect())),l._drgSrc._contains(_)?u=null:((s=new t.TreeNodeDragDropEventArgs(l._drgSrc,_,h)).cancel=l._drgSrc.treeView!=_.treeView,a.onDragOver(s)||(u=null))}if(u)if((h=s.position)==d.Before){var g=s.dragSource.next(!0,!1);g&&g.element==u&&(u=null)}else if(h==d.After){var m=s.dragSource.previous(!0,!1);m&&m.element==u&&(u=null)}if(u&&!r?(i.dataTransfer.dropEffect="move",i.preventDefault(),i.stopPropagation(),this._showDragMarker(o,h)):this._showDragMarker(),u&&r&&a.onDrop(s)){a.hostElement.focus();var v=s.dragSource;v.move(s.dropTarget,s.position),v.select()}}},n.prototype._showDragMarker=function(i,r){var s=this._tree,o=n._dMarker.parentElement;if(i){var a=s.hostElement.getBoundingClientRect(),l=r==t.DropPosition.After?i.bottom:i.top,d={top:Math.round(l-a.top+s.hostElement.scrollTop-2),width:"75%",height:r==t.DropPosition.Into?i.height:4,opacity:r==t.DropPosition.Into?"0.15":""};s.rightToLeft?d.right=Math.round(a.right-i.right):d.left=Math.round(i.left-a.left),e.setCss(n._dMarker,d),o!=s._root&&s._root.appendChild(n._dMarker)}else o&&o.removeChild(n._dMarker)},n._dMarker=e.createElement('<div class="wj-marker">&nbsp;</div>'),n}();t._TreeDragDropManager=n}(e.nav||(e.nav={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){var n=function(){function t(e){this.path=e}return Object.defineProperty(t.prototype,"path",{get:function(){return this._path},set:function(t){if(this._path=t,e.isString(t))this._bindings=[new e.Binding(t)];else if(e.isArray(t)){this._bindings=[];for(var n=0;n<t.length;n++)this._bindings.push(new e.Binding(t[n]))}else null!=t&&e.assert(!1,"Path should be a string or an array of strings.");this._maxLevel=this._bindings?this._bindings.length-1:-1},enumerable:!0,configurable:!0}),t.prototype.getValue=function(e,t){var n=Math.min(t,this._maxLevel);return n>-1?this._bindings[n].getValue(e):null},t.prototype.setValue=function(e,t,n){var i=Math.min(t,this._maxLevel);i>-1&&this._bindings[i].setValue(e,n)},t}();t._BindingArray=n}(e.nav||(e.nav={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),wijmo;!function(e){!function(t){"use strict";var n=function(t){function n(n,r,s){var o=t.call(this,n,null,!0)||this;o._tabs=new e.collections.ObservableArray,o._selectedIndex=-1,o._animated=!0,o._autoSwitch=!0,o.selectedIndexChanged=new e.Event;var a=o.hostElement,l=[];if(!s)for(;a.firstElementChild;){var d=a.firstElementChild;a.removeChild(d),l.push(d)}var h=o.getTemplate();return o.applyTemplate("wj-control wj-tabpanel",h,{_dRoot:"root",_dTabHeaders:"tabheaders",_dTabPanes:"tabpanes"}),o._tabIndex=a.tabIndex,a.tabIndex=-1,o._dRoot.tabIndex=o._dTabHeaders.tabIndex=o._dTabPanes.tabIndex=-1,o.addEventListener(a,"click",o._click.bind(o)),o.addEventListener(a,"keydown",o._keydown.bind(o)),o._tabs.collectionChanged.addHandler(o._populateControl.bind(o)),o.tabs.deferUpdate(function(){l.forEach(function(t){e.assert(2==t.childElementCount,"TabPanel children should contain header and pane elements"),o.tabs.push(new i(t.children[0],t.children[1]))})}),o.initialize(r),o.selectedIndex<0&&o.tabs.length?o.selectedIndex=0:o.onSelectedIndexChanged(),o}return __extends(n,t),Object.defineProperty(n.prototype,"tabs",{get:function(){return this._tabs},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectedIndex",{get:function(){return this._selectedIndex},set:function(t){(t=e.asInt(t,!1))!=this._selectedIndex?(this._selectedIndex=t,this._updateContent(),this.onSelectedIndexChanged()):this._updateContent()},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"selectedTab",{get:function(){var e=this._selectedIndex;return e>-1?this._tabs[e]:null},set:function(e){for(var t=-1,n=0;n<this._tabs.length&&t<0;n++)this._tabs[n]==e&&(t=n);this.selectedIndex=t},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"isAnimated",{get:function(){return this._animated},set:function(t){this._animated=e.asBoolean(t)},enumerable:!0,configurable:!0}),Object.defineProperty(n.prototype,"autoSwitch",{get:function(){return this._autoSwitch},set:function(t){t!=this._autoSwitch&&(this._autoSwitch=e.asBoolean(t),this._updateContent())},enumerable:!0,configurable:!0}),n.prototype.getTab=function(e){for(t=0;t<this._tabs.length;t++)if((n=this._tabs[t]).header.id==e||n.pane.id==e)return n;for(var t=0;t<this._tabs.length;t++){var n=this._tabs[t];if(n.header.textContent==e)return n}return null},n.prototype.onSelectedIndexChanged=function(e){this.selectedIndexChanged.raise(this,e)},n.prototype._populateControl=function(){var t=this;this._removeChildren(this._dTabHeaders),this._removeChildren(this._dTabPanes);var n=-1;this._tabs.forEach(function(r,s){e.assert(r instanceof i,"tabs array must contain Tab objects."),r._setPanel(t);var o=r.header,a=r.pane;e.addClass(o,"wj-tabheader"),e.setAttribute(o,"role","tab"),e.setAttribute(o,"aria-controls",a.id?a.id:null),t._dTabHeaders.appendChild(o),e.addClass(a,"wj-tabpane"),e.setAttribute(a,"role","tabpanel"),e.setAttribute(a,"aria-labelledby",o.id?o.id:null),t._dTabPanes.appendChild(a),n<0&&(e.hasClass(o,"wj-state-active")||"true"==o.getAttribute("aria-selected"))&&(n=s)}),n<0&&this._tabs.length>0&&(n=0),n>-1?this.selectedIndex=n:this.selectedIndex>-1&&this.selectedIndex<this._tabs.length&&this._updateContent(),this._validateSelection()},n.prototype._validateSelection=function(){var e=this.selectedTab;if(e&&(e.isDisabled||!e.isVisible)){var t=this._getNextIndex(this.selectedIndex,1);t<0&&(t=this._getNextIndex(this.selectedIndex,-1)),this.selectedIndex=t}},n.prototype._updateContent=function(){var t=this,n=e.contains(this._dTabHeaders,e.getActiveElement()),i=this._dTabHeaders.children,r=this._dTabPanes.children,s=this._selectedIndex;if(s>-1&&s<r.length){var o=(h=r[s]).style;this.isAnimated?(o.opacity="0",this._toAnim&&clearInterval(this._toAnim),this._toAnim=e.animate(function(e){1==e?(o.opacity="",t._toAnim=null):o.opacity=e.toString()})):o.opacity=""}for(var a=0;a<i.length;a++){var l=a==s,d=i[a],h=r[a];e.setAttribute(d,"aria-selected",l),e.toggleClass(d,"wj-state-active",l),e.toggleClass(h,"wj-state-active",l),d.tabIndex=l||!this._autoSwitch?this._tabIndex:-1,l&&(n&&d.focus(),e.Control.invalidateAll(h))}},n.prototype._removeChildren=function(e){for(;e.firstChild;)e.removeChild(e.firstChild)},n.prototype._click=function(e){var t=this._getTabIndex(e.target);t>-1&&(this.selectedIndex=t)},n.prototype._keydown=function(t){if(!t.defaultPrevented){var n=this._getTabIndex(e.getActiveElement());if(n>-1){var i=t.keyCode;if(this.rightToLeft)switch(i){case e.Key.Left:i=e.Key.Right;break;case e.Key.Right:i=e.Key.Left}switch(i){case e.Key.Left:case e.Key.Up:case e.Key.Right:case e.Key.Down:case e.Key.Home:case e.Key.PageUp:case e.Key.End:case e.Key.PageDown:switch(i){case e.Key.Left:case e.Key.Up:n=this._getNextIndex(n,-1);break;case e.Key.Right:case e.Key.Down:n=this._getNextIndex(n,1);break;case e.Key.Home:case e.Key.PageUp:n=this._getNextIndex(-1,1);break;case e.Key.End:case e.Key.PageDown:n=this._getNextIndex(this._tabs.length,-1)}n>-1&&(this._autoSwitch?this.selectedIndex=n:this._tabs[n].header.focus()),t.preventDefault();break;case e.Key.Enter:case e.Key.Space:n>-1&&this._tabs[n].header.click(),t.preventDefault()}}}},n.prototype._getTabIndex=function(t){var n=e.closest(t,".wj-tabheader");if(n&&e.closest(n,".wj-tabpanel")==this.hostElement)for(var i=0;i<this._tabs.length;i++)if(this._tabs[i].header==n)return i;return-1},n.prototype._getNextIndex=function(e,t){for(var n=e+t;n>-1&&n<this._tabs.length;n+=t){var i=this._tabs[n];if(!i.isDisabled&&i.isVisible)return n}return-1},n.controlTemplate='<div wj-part="root"><div wj-part="tabheaders" class="wj-tabheaders" role="tablist"></div><div wj-part="tabpanes" class="wj-tabpanes"></div></div>',n}(e.Control);t.TabPanel=n;var i=function(){function t(t,n){this._hdr=e.asType(e.getElement(t),HTMLElement),this._pane=e.asType(e.getElement(n),HTMLElement)}return Object.defineProperty(t.prototype,"tabPanel",{get:function(){return this._p},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"header",{get:function(){return this._hdr},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"pane",{get:function(){return this._pane},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isDisabled",{get:function(){return e.hasClass(this._hdr,"wj-state-disabled")},set:function(t){e.toggleClass(this._hdr,"wj-state-disabled",e.asBoolean(t)),this._p&&this._p._validateSelection()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isVisible",{get:function(){return"none"!=this._hdr.style.display},set:function(t){this._hdr.style.display=e.asBoolean(t)?"":"none",this._p&&this._p._validateSelection()},enumerable:!0,configurable:!0}),t.prototype._setParts=function(t,n){if(t=e.asType(e.getElement(t),HTMLElement),n=e.asType(e.getElement(n),HTMLElement,!1),this._hdr!==t||this._pane!==n){var i=this.isDisabled,r=this.isVisible;this._hdr=t,this._pane=n,this.isDisabled=i,this.isVisible=r;var s=this.tabPanel;s&&!s.tabs.isUpdating&&s._populateControl()}},t.prototype._setPanel=function(e){this._p=e},t}();t.Tab=i}(e.nav||(e.nav={}))}(wijmo||(wijmo={}));
/*
    *
    * Wijmo Library 5.20181.436
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
var wijmo;!function(e){!function(t){var r=function(){function t(){}return t.CreateProp=function(e,t,r,i,o,a){return new n(e,t,r,i,o,a)},t.CreateEvent=function(e,t){return new a(e,t)},t.CreateComplexProp=function(e,t,r){return new s(e,t,r)},t.findProp=function(e,t){return this.findInArr(t,"propertyName",e)},t.findEvent=function(e,t){return this.findInArr(t,"eventName",e)},t.findComplexProp=function(e,t){return this.findInArr(t,"propertyName",e)},t.getMetaData=function(t){switch(t){case e.Control:return new l([this.CreateProp("isDisabled",i.Boolean)],[this.CreateEvent("gotFocus"),this.CreateEvent("lostFocus")]);case e.input&&e.input.DropDown:return this.getMetaData(e.Control).add([this.CreateProp("isDroppedDown",i.Boolean,"isDroppedDownChanged"),this.CreateProp("showDropDownButton",i.Boolean),this.CreateProp("autoExpandSelection",i.Boolean),this.CreateProp("placeholder",i.String),this.CreateProp("dropDownCssClass",i.String),this.CreateProp("isAnimated",i.Boolean),this.CreateProp("isReadOnly",i.Boolean),this.CreateProp("isRequired",i.Boolean),this.CreateProp("text",i.String,"textChanged",null,!0,1e3)],[this.CreateEvent("isDroppedDownChanging"),this.CreateEvent("isDroppedDownChanged",!0),this.CreateEvent("textChanged",!0)]);case e.input&&e.input.ComboBox:return this.getMetaData(e.input.DropDown).add([this.CreateProp("displayMemberPath",i.String),this.CreateProp("selectedValuePath",i.String),this.CreateProp("headerPath",i.String),this.CreateProp("isContentHtml",i.Boolean),this.CreateProp("isEditable",i.Boolean),this.CreateProp("maxDropDownHeight",i.Number),this.CreateProp("maxDropDownWidth",i.Number),this.CreateProp("itemFormatter",i.Function),this.CreateProp("itemsSource",i.Any,"",null,!0,900),this.CreateProp("selectedIndex",i.Number,"selectedIndexChanged",null,!0,1e3),this.CreateProp("selectedItem",i.Any,"selectedIndexChanged",null,!0,1e3),this.CreateProp("selectedValue",i.Any,"selectedIndexChanged",null,!0,1e3)],[this.CreateEvent("formatItem"),this.CreateEvent("selectedIndexChanged",!0)]).addOptions({ngModelProperty:"selectedValue"});case e.input&&e.input.AutoComplete:return this.getMetaData(e.input.ComboBox).add([this.CreateProp("delay",i.Number),this.CreateProp("maxItems",i.Number),this.CreateProp("minLength",i.Number),this.CreateProp("cssMatch",i.String),this.CreateProp("itemsSourceFunction",i.Function),this.CreateProp("searchMemberPath",i.String)]);case e.input&&e.input.Calendar:return this.getMetaData(e.Control).add([this.CreateProp("monthView",i.Boolean),this.CreateProp("showHeader",i.Boolean),this.CreateProp("itemFormatter",i.Function),this.CreateProp("itemValidator",i.Function),this.CreateProp("firstDayOfWeek",i.Number),this.CreateProp("max",i.Date),this.CreateProp("min",i.Date),this.CreateProp("formatYearMonth",i.String),this.CreateProp("formatDayHeaders",i.String),this.CreateProp("formatDays",i.String),this.CreateProp("formatYear",i.String),this.CreateProp("formatMonths",i.String),this.CreateProp("selectionMode",i.Enum,"",e.input.DateSelectionMode),this.CreateProp("isReadOnly",i.Boolean),this.CreateProp("value",i.Date,"valueChanged"),this.CreateProp("displayMonth",i.Date,"displayMonthChanged")],[this.CreateEvent("valueChanged",!0),this.CreateEvent("displayMonthChanged",!0),this.CreateEvent("formatItem",!1)]).addOptions({ngModelProperty:"value"});case e.input&&e.input.ColorPicker:return this.getMetaData(e.Control).add([this.CreateProp("showAlphaChannel",i.Boolean),this.CreateProp("showColorString",i.Boolean),this.CreateProp("palette",i.Any),this.CreateProp("value",i.String,"valueChanged")],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case e.input&&e.input.ListBox:return this.getMetaData(e.Control).add([this.CreateProp("isContentHtml",i.Boolean),this.CreateProp("maxHeight",i.Number),this.CreateProp("selectedValuePath",i.String),this.CreateProp("itemFormatter",i.Function),this.CreateProp("displayMemberPath",i.String),this.CreateProp("checkedMemberPath",i.String),this.CreateProp("itemsSource",i.Any),this.CreateProp("selectedIndex",i.Number,"selectedIndexChanged"),this.CreateProp("selectedItem",i.Any,"selectedIndexChanged"),this.CreateProp("selectedValue",i.Any,"selectedIndexChanged"),this.CreateProp("checkedItems",i.Any,"checkedItemsChanged")],[this.CreateEvent("formatItem",!1),this.CreateEvent("itemsChanged",!0),this.CreateEvent("itemChecked",!0),this.CreateEvent("selectedIndexChanged",!0),this.CreateEvent("checkedItemsChanged",!0)]).addOptions({ngModelProperty:"selectedValue"});case"ItemTemplate":return new l([],[],[],void 0,void 0,void 0,"owner");case e.input&&e.input.Menu:return this.getMetaData(e.input.ComboBox).add([this.CreateProp("header",i.String),this.CreateProp("commandParameterPath",i.String),this.CreateProp("commandPath",i.String),this.CreateProp("isButton",i.Boolean),this.CreateProp("value",i.Any,"itemClicked",null,!1,1e3)],[this.CreateEvent("itemClicked")]);case"MenuItem":return new l([this.CreateProp("value",i.Any,""),this.CreateProp("cmd",i.Any,""),this.CreateProp("cmdParam",i.Any,"")],[],[],"itemsSource",!0);case"MenuSeparator":return new l([],[],[],"itemsSource",!0);case e.input&&e.input.InputDate:return this.getMetaData(e.input.DropDown).add([this.CreateProp("selectionMode",i.Enum,"",e.input.DateSelectionMode),this.CreateProp("format",i.String),this.CreateProp("mask",i.String),this.CreateProp("max",i.Date),this.CreateProp("min",i.Date),this.CreateProp("inputType",i.String),this.CreateProp("value",i.Date,"valueChanged",null,!0,1e3),this.CreateProp("itemValidator",i.Function),this.CreateProp("itemFormatter",i.Function)],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case e.input&&e.input.InputDateTime:return this.getMetaData(e.input.InputDate).add([this.CreateProp("timeMax",i.Date),this.CreateProp("timeMin",i.Date),this.CreateProp("timeStep",i.Number),this.CreateProp("timeFormat",i.String)]).addOptions({ngModelProperty:"value"});case e.input&&e.input.InputNumber:return this.getMetaData(e.Control).add([this.CreateProp("showSpinner",i.Boolean),this.CreateProp("repeatButtons",i.Boolean),this.CreateProp("max",i.Number),this.CreateProp("min",i.Number),this.CreateProp("step",i.Number),this.CreateProp("isRequired",i.Boolean),this.CreateProp("placeholder",i.String),this.CreateProp("inputType",i.String),this.CreateProp("format",i.String),this.CreateProp("isReadOnly",i.Boolean),this.CreateProp("value",i.Number,"valueChanged"),this.CreateProp("text",i.String,"textChanged")],[this.CreateEvent("valueChanged",!0),this.CreateEvent("textChanged",!0)]).addOptions({ngModelProperty:"value"});case e.input&&e.input.InputMask:return this.getMetaData(e.Control).add([this.CreateProp("mask",i.String),this.CreateProp("isRequired",i.Boolean),this.CreateProp("isReadOnly",i.Boolean),this.CreateProp("promptChar",i.String),this.CreateProp("placeholder",i.String),this.CreateProp("rawValue",i.String,"valueChanged"),this.CreateProp("value",i.String,"valueChanged")],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case e.input&&e.input.InputTime:return this.getMetaData(e.input.ComboBox).add([this.CreateProp("max",i.Date),this.CreateProp("min",i.Date),this.CreateProp("step",i.Number),this.CreateProp("format",i.String),this.CreateProp("mask",i.String),this.CreateProp("inputType",i.String),this.CreateProp("value",i.Date,"valueChanged",null,!0,1e3)],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case e.input&&e.input.InputColor:return this.getMetaData(e.input.DropDown).add([this.CreateProp("showAlphaChannel",i.Boolean),this.CreateProp("value",i.String,"valueChanged")],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case e.input&&e.input.Popup:return this.getMetaData(e.Control).add([this.CreateProp("owner",i.String),this.CreateProp("showTrigger",i.Enum,"",e.input.PopupTrigger),this.CreateProp("hideTrigger",i.Enum,"",e.input.PopupTrigger),this.CreateProp("fadeIn",i.Boolean),this.CreateProp("fadeOut",i.Boolean),this.CreateProp("isDraggable",i.Boolean),this.CreateProp("dialogResultEnter",i.String),this.CreateProp("modal",i.Boolean),this.CreateProp("removeOnHide",i.Boolean)],[this.CreateEvent("showing"),this.CreateEvent("shown"),this.CreateEvent("hiding"),this.CreateEvent("hidden")]);case e.input&&e.input.MultiSelect:return this.getMetaData(e.input.ComboBox).add([this.CreateProp("checkedMemberPath",i.String),this.CreateProp("maxHeaderItems",i.Number),this.CreateProp("headerFormat",i.String),this.CreateProp("headerFormatter",i.Function),this.CreateProp("showSelectAllCheckbox",i.Boolean),this.CreateProp("selectAllLabel",i.String),this.CreateProp("checkedItems",i.Any,"checkedItemsChanged",o.TwoWay,!0,950)],[this.CreateEvent("checkedItemsChanged",!0)]).addOptions({ngModelProperty:"checkedItems"});case"CollectionViewNavigator":case"CollectionViewPager":return new l([this.CreateProp("cv",i.Any)]);case e.input&&e.input.MultiAutoComplete:return this.getMetaData(e.input.AutoComplete).add([this.CreateProp("maxSelectedItems",i.Number),this.CreateProp("selectedMemberPath",i.String,"",null,!0,950),this.CreateProp("selectedItems",i.Any,"selectedItemsChanged")],[this.CreateEvent("selectedItemsChanged",!0)]).addOptions({ngModelProperty:"selectedItems"});case e.grid&&e.grid.FlexGrid:return this.getMetaData(e.Control).add([this.CreateProp("newRowAtTop",i.Boolean),this.CreateProp("allowAddNew",i.Boolean),this.CreateProp("allowDelete",i.Boolean),this.CreateProp("allowDragging",i.Enum,"",e.grid.AllowDragging),this.CreateProp("allowMerging",i.Enum,"",e.grid.AllowMerging),this.CreateProp("allowResizing",i.Enum,"",e.grid.AllowResizing),this.CreateProp("allowSorting",i.Boolean),this.CreateProp("quickAutoSize",i.Boolean),this.CreateProp("autoScroll",i.Boolean),this.CreateProp("autoSizeMode",i.Enum,"",e.grid.AutoSizeMode),this.CreateProp("autoGenerateColumns",i.Boolean),this.CreateProp("childItemsPath",i.Any),this.CreateProp("groupHeaderFormat",i.String),this.CreateProp("headersVisibility",i.Enum,"",e.grid.HeadersVisibility),this.CreateProp("showSelectedHeaders",i.Enum,"",e.grid.HeadersVisibility),this.CreateProp("showMarquee",i.Boolean),this.CreateProp("itemFormatter",i.Function),this.CreateProp("isReadOnly",i.Boolean),this.CreateProp("imeEnabled",i.Boolean),this.CreateProp("mergeManager",i.Any),this.CreateProp("selectionMode",i.Enum,"",e.grid.SelectionMode),this.CreateProp("showGroups",i.Boolean),this.CreateProp("showSort",i.Boolean),this.CreateProp("showDropDown",i.Boolean),this.CreateProp("showAlternatingRows",i.Boolean),this.CreateProp("showErrors",i.Boolean),this.CreateProp("validateEdits",i.Boolean),this.CreateProp("treeIndent",i.Number),this.CreateProp("itemsSource",i.Any),this.CreateProp("autoClipboard",i.Boolean),this.CreateProp("frozenRows",i.Number),this.CreateProp("frozenColumns",i.Number),this.CreateProp("cloneFrozenCells",i.Boolean),this.CreateProp("deferResizing",i.Boolean),this.CreateProp("sortRowIndex",i.Number),this.CreateProp("stickyHeaders",i.Boolean),this.CreateProp("preserveSelectedState",i.Boolean),this.CreateProp("preserveOutlineState",i.Boolean),this.CreateProp("keyActionTab",i.Enum,"",e.grid.KeyAction),this.CreateProp("keyActionEnter",i.Enum,"",e.grid.KeyAction),this.CreateProp("rowHeaderPath",i.String),this.CreateProp("virtualizationThreshold",i.Number)],[this.CreateEvent("beginningEdit"),this.CreateEvent("cellEditEnded"),this.CreateEvent("cellEditEnding"),this.CreateEvent("prepareCellForEdit"),this.CreateEvent("formatItem"),this.CreateEvent("resizingColumn"),this.CreateEvent("resizedColumn"),this.CreateEvent("autoSizingColumn"),this.CreateEvent("autoSizedColumn"),this.CreateEvent("draggingColumn"),this.CreateEvent("draggingColumnOver"),this.CreateEvent("draggedColumn"),this.CreateEvent("sortingColumn"),this.CreateEvent("sortedColumn"),this.CreateEvent("resizingRow"),this.CreateEvent("resizedRow"),this.CreateEvent("autoSizingRow"),this.CreateEvent("autoSizedRow"),this.CreateEvent("draggingRow"),this.CreateEvent("draggingRowOver"),this.CreateEvent("draggedRow"),this.CreateEvent("deletingRow"),this.CreateEvent("deletedRow"),this.CreateEvent("loadingRows"),this.CreateEvent("loadedRows"),this.CreateEvent("rowEditStarting"),this.CreateEvent("rowEditStarted"),this.CreateEvent("rowEditEnding"),this.CreateEvent("rowEditEnded"),this.CreateEvent("rowAdded"),this.CreateEvent("groupCollapsedChanged"),this.CreateEvent("groupCollapsedChanging"),this.CreateEvent("itemsSourceChanged",!0),this.CreateEvent("selectionChanging"),this.CreateEvent("selectionChanged",!0),this.CreateEvent("scrollPositionChanged",!1),this.CreateEvent("updatingView"),this.CreateEvent("updatedView"),this.CreateEvent("updatingLayout"),this.CreateEvent("updatedLayout"),this.CreateEvent("pasting"),this.CreateEvent("pasted"),this.CreateEvent("pastingCell"),this.CreateEvent("pastedCell"),this.CreateEvent("copying"),this.CreateEvent("copied")]);case e.grid&&e.grid.Column:return new l([this.CreateProp("name",i.String),this.CreateProp("dataMap",i.Any),this.CreateProp("dataType",i.Enum,"",e.DataType),this.CreateProp("binding",i.String),this.CreateProp("sortMemberPath",i.String),this.CreateProp("format",i.String),this.CreateProp("header",i.String),this.CreateProp("width",i.Number),this.CreateProp("maxLength",i.Number),this.CreateProp("minWidth",i.Number),this.CreateProp("maxWidth",i.Number),this.CreateProp("align",i.String),this.CreateProp("allowDragging",i.Boolean),this.CreateProp("allowSorting",i.Boolean),this.CreateProp("allowResizing",i.Boolean),this.CreateProp("allowMerging",i.Boolean),this.CreateProp("aggregate",i.Enum,"",e.Aggregate),this.CreateProp("isReadOnly",i.Boolean),this.CreateProp("cssClass",i.String),this.CreateProp("isContentHtml",i.Boolean),this.CreateProp("isSelected",i.Boolean,"grid.selectionChanged"),this.CreateProp("visible",i.Boolean),this.CreateProp("wordWrap",i.Boolean),this.CreateProp("multiLine",i.Boolean),this.CreateProp("mask",i.String),this.CreateProp("inputType",i.String),this.CreateProp("isRequired",i.Boolean),this.CreateProp("showDropDown",i.Boolean),this.CreateProp("dropDownCssClass",i.String),this.CreateProp("quickAutoSize",i.Boolean)],[],[],"columns",!0);case"FlexGridCellTemplate":return new l([this.CreateProp("cellType",i.String,"",null,!1),this.CreateProp("cellOverflow",i.String,""),this.CreateProp("forceFullEdit",i.Boolean)],[],[],void 0,void 0,void 0,"owner");case e.grid&&e.grid.filter&&e.grid.filter.FlexGridFilter:return new l([this.CreateProp("showFilterIcons",i.Boolean),this.CreateProp("showSortButtons",i.Boolean),this.CreateProp("defaultFilterType",i.Enum,"",e.grid.filter.FilterType),this.CreateProp("filterColumns",i.Any)],[this.CreateEvent("filterChanging"),this.CreateEvent("filterChanged"),this.CreateEvent("filterApplied")],[],void 0,void 0,void 0,"");case e.grid&&e.grid.grouppanel&&e.grid.grouppanel.GroupPanel:return this.getMetaData(e.Control).add([this.CreateProp("hideGroupedColumns",i.Boolean),this.CreateProp("maxGroups",i.Number),this.CreateProp("placeholder",i.String),this.CreateProp("grid",i.Any)]);case e.grid&&e.grid.detail&&e.grid.detail.FlexGridDetailProvider:return new l([this.CreateProp("maxHeight",i.Number),this.CreateProp("detailVisibilityMode",i.Enum,"",e.grid.detail.DetailVisibilityMode),this.CreateProp("rowHasDetail",i.Function),this.CreateProp("isAnimated",i.Boolean)],[],[],void 0,void 0,void 0,"");case e.grid&&e.grid.sheet&&e.grid.sheet.FlexSheet:return this.getMetaData(e.grid.FlexGrid).add([this.CreateProp("isTabHolderVisible",i.Boolean),this.CreateProp("selectedSheetIndex",i.Number,"selectedSheetChanged")],[this.CreateEvent("selectedSheetChanged",!0),this.CreateEvent("draggingRowColumn"),this.CreateEvent("droppingRowColumn"),this.CreateEvent("loaded"),this.CreateEvent("unknownFunction"),this.CreateEvent("sheetCleared")]);case e.grid&&e.grid.sheet&&e.grid.sheet.Sheet:return new l([this.CreateProp("name",i.String),this.CreateProp("itemsSource",i.Any),this.CreateProp("visible",i.Boolean),this.CreateProp("rowCount",i.Number,"",null,!1),this.CreateProp("columnCount",i.Number,"",null,!1)],[this.CreateEvent("nameChanged")]).addOptions({parentReferenceProperty:""});case e.grid&&e.grid.multirow&&e.grid.multirow.MultiRow:return this.getMetaData(e.grid.FlexGrid).add([this.CreateProp("layoutDefinition",i.Any),this.CreateProp("centerHeadersVertically",i.Boolean),this.CreateProp("collapsedHeaders",i.Boolean),this.CreateProp("showHeaderCollapseButton",i.Boolean)]);case e.chart&&e.chart.FlexChartBase:return this.getMetaData(e.Control).add([this.CreateProp("binding",i.String),this.CreateProp("footer",i.String),this.CreateProp("header",i.String),this.CreateProp("selectionMode",i.Enum,"",e.chart.SelectionMode),this.CreateProp("palette",i.Any),this.CreateProp("plotMargin",i.Any),this.CreateProp("footerStyle",i.Any),this.CreateProp("headerStyle",i.Any),this.CreateProp("tooltipContent",i.String,"",null,!1),this.CreateProp("itemsSource",i.Any)],[this.CreateEvent("rendering"),this.CreateEvent("rendered"),this.CreateEvent("selectionChanged",!0)]);case e.chart&&e.chart.FlexChartCore:return this.getMetaData(e.chart.FlexChartBase).add([this.CreateProp("bindingX",i.String),this.CreateProp("interpolateNulls",i.Boolean),this.CreateProp("legendToggle",i.Boolean),this.CreateProp("symbolSize",i.Number),this.CreateProp("options",i.Any),this.CreateProp("selection",i.Any,"selectionChanged"),this.CreateProp("itemFormatter",i.Function),this.CreateProp("labelContent",i.String,"",null,!1)],[this.CreateEvent("seriesVisibilityChanged")],[this.CreateComplexProp("axisX",!1,!1),this.CreateComplexProp("axisY",!1,!1),this.CreateComplexProp("axes",!0),this.CreateComplexProp("plotAreas",!0)]);case e.chart&&e.chart.FlexChart:return this.getMetaData(e.chart.FlexChartCore).add([this.CreateProp("chartType",i.Enum,"",e.chart.ChartType),this.CreateProp("rotated",i.Boolean),this.CreateProp("stacking",i.Enum,"",e.chart.Stacking)]);case e.chart&&e.chart.FlexPie:return this.getMetaData(e.chart.FlexChartBase).add([this.CreateProp("bindingName",i.String),this.CreateProp("innerRadius",i.Number),this.CreateProp("isAnimated",i.Boolean),this.CreateProp("offset",i.Number),this.CreateProp("reversed",i.Boolean),this.CreateProp("startAngle",i.Number),this.CreateProp("selectedItemPosition",i.Enum,"",e.chart.Position),this.CreateProp("selectedItemOffset",i.Number),this.CreateProp("itemFormatter",i.Function),this.CreateProp("labelContent",i.String,"",null,!1)]);case e.chart&&e.chart.FlexPie&&e.chart.hierarchical&&e.chart.hierarchical.Sunburst:return this.getMetaData(e.chart.FlexChartBase).add([this.CreateProp("bindingName",i.Any),this.CreateProp("innerRadius",i.Number),this.CreateProp("isAnimated",i.Boolean),this.CreateProp("offset",i.Number),this.CreateProp("reversed",i.Boolean),this.CreateProp("startAngle",i.Number),this.CreateProp("selectedItemPosition",i.Enum,"",e.chart.Position),this.CreateProp("selectedItemOffset",i.Number),this.CreateProp("itemFormatter",i.Function),this.CreateProp("labelContent",i.String,"",null,!1),this.CreateProp("childItemsPath",i.Any)]);case e.chart&&e.chart.hierarchical&&e.chart.hierarchical.TreeMap:return this.getMetaData(e.chart.FlexChartBase).add([this.CreateProp("bindingName",i.Any),this.CreateProp("maxDepth",i.Number),this.CreateProp("type",i.Enum,"",e.chart.hierarchical.TreeMapType),this.CreateProp("labelContent",i.String,"",null,!1),this.CreateProp("childItemsPath",i.Any)]);case e.chart&&e.chart.Axis:return new l([this.CreateProp("axisLine",i.Boolean),this.CreateProp("format",i.String),this.CreateProp("labels",i.Boolean),this.CreateProp("majorGrid",i.Boolean),this.CreateProp("majorTickMarks",i.Enum,"",e.chart.TickMark),this.CreateProp("majorUnit",i.Number),this.CreateProp("max",i.Number),this.CreateProp("min",i.Number),this.CreateProp("position",i.Enum,"",e.chart.Position),this.CreateProp("reversed",i.Boolean),this.CreateProp("title",i.String),this.CreateProp("labelAngle",i.Number),this.CreateProp("minorGrid",i.Boolean),this.CreateProp("minorTickMarks",i.Enum,"",e.chart.TickMark),this.CreateProp("minorUnit",i.Number),this.CreateProp("origin",i.Number),this.CreateProp("logBase",i.Number),this.CreateProp("plotArea",i.Any),this.CreateProp("labelAlign",i.String),this.CreateProp("name",i.String),this.CreateProp("overlappingLabels",i.Enum,"",e.chart.OverlappingLabels),this.CreateProp("labelPadding",i.Number),this.CreateProp("itemFormatter",i.Function),this.CreateProp("itemsSource",i.Any),this.CreateProp("binding",i.String)],[this.CreateEvent("rangeChanged")],[],"axes",!0);case e.chart&&e.chart.Legend:return new l([this.CreateProp("position",i.Enum,"",e.chart.Position),this.CreateProp("title",i.String),this.CreateProp("titleAlign",i.String)],[],[],"legend",!1,!1,"");case e.chart&&e.chart.DataLabelBase:return new l([this.CreateProp("content",i.Any,""),this.CreateProp("border",i.Boolean),this.CreateProp("offset",i.Number),this.CreateProp("connectingLine",i.Boolean)],[this.CreateEvent("rendering")],[],"dataLabel",!1,!1);case e.chart&&e.chart.DataLabel:return this.getMetaData(e.chart.DataLabelBase).add([this.CreateProp("position",i.Enum,"",e.chart.LabelPosition)]);case e.chart&&e.chart.PieDataLabel:return this.getMetaData(e.chart.DataLabelBase).add([this.CreateProp("position",i.Enum,"",e.chart.PieLabelPosition)]);case e.chart&&e.chart.SeriesBase:return new l([this.CreateProp("axisX",i.Any),this.CreateProp("axisY",i.Any),this.CreateProp("binding",i.String),this.CreateProp("bindingX",i.String),this.CreateProp("cssClass",i.String),this.CreateProp("name",i.String),this.CreateProp("style",i.Any),this.CreateProp("altStyle",i.Any),this.CreateProp("symbolMarker",i.Enum,"",e.chart.Marker),this.CreateProp("symbolSize",i.Number),this.CreateProp("symbolStyle",i.Any),this.CreateProp("visibility",i.Enum,"chart.seriesVisibilityChanged",e.chart.SeriesVisibility),this.CreateProp("itemsSource",i.Any)],[this.CreateEvent("rendering"),this.CreateEvent("rendered")],[this.CreateComplexProp("axisX",!1,!0),this.CreateComplexProp("axisY",!1,!0)],"series",!0);case e.chart&&e.chart.Series:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("chartType",i.Enum,"",e.chart.ChartType)]);case e.chart&&e.chart.LineMarker:return new l([this.CreateProp("isVisible",i.Boolean),this.CreateProp("seriesIndex",i.Number),this.CreateProp("horizontalPosition",i.Number),this.CreateProp("content",i.Function),this.CreateProp("verticalPosition",i.Number),this.CreateProp("alignment",i.Enum,"",e.chart.LineMarkerAlignment),this.CreateProp("lines",i.Enum,"",e.chart.LineMarkerLines),this.CreateProp("interaction",i.Enum,"",e.chart.LineMarkerInteraction),this.CreateProp("dragLines",i.Boolean),this.CreateProp("dragThreshold",i.Number),this.CreateProp("dragContent",i.Boolean)],[this.CreateEvent("positionChanged")],[],void 0,void 0,void 0,"");case e.chart&&e.chart.DataPoint:return new l([this.CreateProp("x",i.AnyPrimitive),this.CreateProp("y",i.AnyPrimitive)],[],[],"");case e.chart&&e.chart.annotation&&e.chart.annotation.AnnotationLayer:return new l([],[],[],void 0,void 0,void 0,"");case"FlexChartAnnotation":return new l([this.CreateProp("type",i.String,"",null,!1),this.CreateProp("attachment",i.Enum,"",e.chart.annotation.AnnotationAttachment),this.CreateProp("position",i.Enum,"",e.chart.annotation.AnnotationPosition),this.CreateProp("point",i.Any),this.CreateProp("seriesIndex",i.Number),this.CreateProp("pointIndex",i.Number),this.CreateProp("offset",i.Any),this.CreateProp("style",i.Any),this.CreateProp("isVisible",i.Boolean),this.CreateProp("tooltip",i.String),this.CreateProp("text",i.String),this.CreateProp("content",i.String),this.CreateProp("name",i.String),this.CreateProp("width",i.Number),this.CreateProp("height",i.Number),this.CreateProp("start",i.Any),this.CreateProp("end",i.Any),this.CreateProp("radius",i.Number),this.CreateProp("length",i.Number),this.CreateProp("href",i.String)],[],[this.CreateComplexProp("point",!1,!0),this.CreateComplexProp("start",!1,!0),this.CreateComplexProp("end",!1,!0),this.CreateComplexProp("points",!0)],"items",!0);case e.chart&&e.chart.interaction&&e.chart.interaction.RangeSelector:return new l([this.CreateProp("isVisible",i.Boolean),this.CreateProp("min",i.Number),this.CreateProp("max",i.Number),this.CreateProp("orientation",i.Enum,"",e.chart.interaction.Orientation),this.CreateProp("seamless",i.Boolean),this.CreateProp("minScale",i.Number),this.CreateProp("maxScale",i.Number)],[this.CreateEvent("rangeChanged")],[],void 0,void 0,void 0,"");case e.chart&&e.chart.interaction&&e.chart.interaction.ChartGestures:return new l([this.CreateProp("mouseAction",i.Enum,"",e.chart.interaction.MouseAction),this.CreateProp("interactiveAxes",i.Enum,"",e.chart.interaction.InteractiveAxes),this.CreateProp("enable",i.Boolean),this.CreateProp("scaleX",i.Number),this.CreateProp("scaleY",i.Number),this.CreateProp("posX",i.Number),this.CreateProp("posY",i.Number)],[],[],void 0,void 0,void 0,"");case e.chart&&e.chart.animation&&e.chart.animation.ChartAnimation:return new l([this.CreateProp("animationMode",i.Enum,"",e.chart.animation.AnimationMode),this.CreateProp("easing",i.Enum,"",e.chart.animation.Easing),this.CreateProp("duration",i.Number),this.CreateProp("axisAnimation",i.Boolean)],[],[],void 0,void 0,void 0,"");case e.chart&&e.chart.finance&&e.chart.finance.FinancialChart:return this.getMetaData(e.chart.FlexChartCore).add([this.CreateProp("chartType",i.Enum,"",e.chart.finance.FinancialChartType)]);case e.chart&&e.chart.finance&&e.chart.finance.FinancialSeries:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("chartType",i.Enum,"",e.chart.finance.FinancialChartType)]);case e.chart&&e.chart.radar&&e.chart.radar.FlexRadar:return this.getMetaData(e.chart.FlexChartCore).add([this.CreateProp("chartType",i.Enum,"",e.chart.radar.RadarChartType),this.CreateProp("startAngle",i.Number),this.CreateProp("totalAngle",i.Number),this.CreateProp("reversed",i.Boolean),this.CreateProp("stacking",i.Enum,"",e.chart.Stacking)]);case e.chart&&e.chart.radar&&e.chart.radar.FlexRadarSeries:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("chartType",i.Enum,"",e.chart.radar.RadarChartType)]);case e.chart&&e.chart.radar&&e.chart.radar.FlexRadarAxis:return this.getMetaData(e.chart.Axis);case e.chart&&e.chart.analytics&&e.chart.analytics.TrendLineBase:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("sampleCount",i.Number)]);case e.chart&&e.chart.analytics&&e.chart.analytics.TrendLine:return this.getMetaData(e.chart.analytics.TrendLineBase).add([this.CreateProp("order",i.Number),this.CreateProp("fitType",i.Enum,"",e.chart.analytics.TrendLineFitType)]);case e.chart&&e.chart.analytics&&e.chart.analytics.MovingAverage:return this.getMetaData(e.chart.analytics.TrendLineBase).add([this.CreateProp("period",i.Number),this.CreateProp("type",i.Enum,"",e.chart.analytics.MovingAverageType)]);case e.chart&&e.chart.analytics&&e.chart.analytics.FunctionSeries:return this.getMetaData(e.chart.analytics.TrendLineBase).add([this.CreateProp("min",i.Number),this.CreateProp("max",i.Number)]);case e.chart&&e.chart.analytics&&e.chart.analytics.YFunctionSeries:return this.getMetaData(e.chart.analytics.FunctionSeries).add([this.CreateProp("func",i.Function)]);case e.chart&&e.chart.analytics&&e.chart.analytics.ParametricFunctionSeries:return this.getMetaData(e.chart.analytics.FunctionSeries).add([this.CreateProp("func",i.Function),this.CreateProp("xFunc",i.Function),this.CreateProp("yFunc",i.Function)]);case e.chart&&e.chart.analytics&&e.chart.analytics.Waterfall:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("relativeData",i.Boolean),this.CreateProp("start",i.Number),this.CreateProp("startLabel",i.String),this.CreateProp("showTotal",i.Boolean),this.CreateProp("totalLabel",i.String),this.CreateProp("showIntermediateTotal",i.Boolean),this.CreateProp("intermediateTotalPositions",i.Any),this.CreateProp("intermediateTotalLabels",i.Any),this.CreateProp("connectorLines",i.Boolean),this.CreateProp("styles",i.Any)]);case e.chart&&e.chart.analytics&&e.chart.analytics.BoxWhisker:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("quartileCalculation",i.Enum,"",e.chart.analytics.QuartileCalculation),this.CreateProp("groupWidth",i.Number),this.CreateProp("gapWidth",i.Number),this.CreateProp("showMeanLine",i.Boolean),this.CreateProp("meanLineStyle",i.Any),this.CreateProp("showMeanMarker",i.Boolean),this.CreateProp("meanMarkerStyle",i.Any),this.CreateProp("showInnerPoints",i.Boolean),this.CreateProp("showOutliers",i.Boolean)]);case e.chart&&e.chart.analytics&&e.chart.analytics.ErrorBar:return this.getMetaData(e.chart.Series).add([this.CreateProp("errorBarStyle",i.Any),this.CreateProp("value",i.Any),this.CreateProp("errorAmount",i.Enum,"",e.chart.analytics.ErrorAmount),this.CreateProp("endStyle",i.Enum,"",e.chart.analytics.ErrorBarEndStyle),this.CreateProp("direction",i.Enum,"",e.chart.analytics.ErrorBarDirection)]);case e.chart&&e.chart.PlotArea:return new l([this.CreateProp("column",i.Number),this.CreateProp("height",i.String),this.CreateProp("name",i.String),this.CreateProp("row",i.Number),this.CreateProp("style",i.Any),this.CreateProp("width",i.String)],[],[],"plotAreas",!0);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.Fibonacci:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("high",i.Number),this.CreateProp("low",i.Number),this.CreateProp("labelPosition",i.Enum,"",e.chart.LabelPosition),this.CreateProp("levels",i.Any),this.CreateProp("minX",i.AnyPrimitive),this.CreateProp("maxX",i.AnyPrimitive),this.CreateProp("uptrend",i.Boolean)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.FibonacciTimeZones:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("startX",i.Any),this.CreateProp("endX",i.Any),this.CreateProp("labelPosition",i.Enum,"",e.chart.LabelPosition),this.CreateProp("levels",i.Any)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.FibonacciArcs:case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.FibonacciFans:return this.getMetaData(e.chart.SeriesBase).add([this.CreateProp("start",i.Any),this.CreateProp("end",i.Any),this.CreateProp("labelPosition",i.Enum,"",e.chart.LabelPosition),this.CreateProp("levels",i.Any)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.OverlayIndicatorBase:return this.getMetaData(e.chart.SeriesBase);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.SingleOverlayIndicatorBase:return this.getMetaData(e.chart.finance.analytics.OverlayIndicatorBase).add([this.CreateProp("period",i.Number)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.MacdBase:return this.getMetaData(e.chart.finance.analytics.OverlayIndicatorBase).add([this.CreateProp("fastPeriod",i.Number),this.CreateProp("slowPeriod",i.Number),this.CreateProp("smoothingPeriod",i.Number)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.Macd:return this.getMetaData(e.chart.finance.analytics.MacdBase).add([this.CreateProp("styles",i.Any)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.MacdHistogram:return this.getMetaData(e.chart.finance.analytics.MacdBase);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.ATR:case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.RSI:case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.WilliamsR:return this.getMetaData(e.chart.finance.analytics.SingleOverlayIndicatorBase);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.CCI:return this.getMetaData(e.chart.finance.analytics.SingleOverlayIndicatorBase).add([this.CreateProp("constant",i.Number)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.Stochastic:return this.getMetaData(e.chart.finance.analytics.OverlayIndicatorBase).add([this.CreateProp("dPeriod",i.Number),this.CreateProp("kPeriod",i.Number),this.CreateProp("smoothingPeriod",i.Number),this.CreateProp("styles",i.Any)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.Envelopes:return this.getMetaData(e.chart.finance.analytics.OverlayIndicatorBase).add([this.CreateProp("period",i.Number),this.CreateProp("size",i.Number),this.CreateProp("type",i.Enum,"",e.chart.finance.analytics.MovingAverageType)]);case e.chart&&e.chart.finance&&e.chart.finance.analytics&&e.chart.finance.analytics.BollingerBands:return this.getMetaData(e.chart.finance.analytics.OverlayIndicatorBase).add([this.CreateProp("period",i.Number),this.CreateProp("multiplier",i.Number)]);case e.gauge&&e.gauge.Gauge:return this.getMetaData(e.Control).add([this.CreateProp("value",i.Number,"valueChanged"),this.CreateProp("min",i.Number),this.CreateProp("max",i.Number),this.CreateProp("origin",i.Number),this.CreateProp("isReadOnly",i.Boolean),this.CreateProp("step",i.Number),this.CreateProp("format",i.String),this.CreateProp("thickness",i.Number),this.CreateProp("hasShadow",i.Boolean),this.CreateProp("isAnimated",i.Boolean),this.CreateProp("showText",i.Enum,"",e.gauge.ShowText),this.CreateProp("showTicks",i.Boolean),this.CreateProp("showRanges",i.Boolean),this.CreateProp("thumbSize",i.Number),this.CreateProp("tickSpacing",i.Number),this.CreateProp("getText",i.Function)],[this.CreateEvent("valueChanged",!0)],[this.CreateComplexProp("ranges",!0),this.CreateComplexProp("pointer",!1,!1),this.CreateComplexProp("face",!1,!1)]).addOptions({ngModelProperty:"value"});case e.gauge&&e.gauge.LinearGauge:return this.getMetaData(e.gauge.Gauge).add([this.CreateProp("direction",i.Enum,"",e.gauge.GaugeDirection)]);case e.gauge&&e.gauge.BulletGraph:return this.getMetaData(e.gauge.LinearGauge).add([this.CreateProp("target",i.Number),this.CreateProp("good",i.Number),this.CreateProp("bad",i.Number)]);case e.gauge&&e.gauge.RadialGauge:return this.getMetaData(e.gauge.Gauge).add([this.CreateProp("autoScale",i.Boolean),this.CreateProp("startAngle",i.Number),this.CreateProp("sweepAngle",i.Number)]);case e.gauge&&e.gauge.Range:return new l([this.CreateProp("color",i.String),this.CreateProp("min",i.Number),this.CreateProp("max",i.Number),this.CreateProp("name",i.String),this.CreateProp("thickness",i.Number)],[],[],"ranges",!0);case e.olap&&e.olap.PivotGrid:return this.getMetaData(e.grid.FlexGrid).add([this.CreateProp("showDetailOnDoubleClick",i.Boolean),this.CreateProp("customContextMenu",i.Boolean),this.CreateProp("collapsibleSubtotals",i.Boolean),this.CreateProp("centerHeadersVertically",i.Boolean),this.CreateProp("showColumnFieldHeaders",i.Boolean),this.CreateProp("showRowFieldHeaders",i.Boolean)]);case e.olap&&e.olap.PivotChart:return this.getMetaData(e.Control).add([this.CreateProp("chartType",i.Enum,"",e.olap.PivotChartType),this.CreateProp("showHierarchicalAxes",i.Boolean),this.CreateProp("showTotals",i.Boolean),this.CreateProp("showTitle",i.Boolean),this.CreateProp("showLegend",i.Enum,"",e.olap.LegendVisibility),this.CreateProp("legendPosition",i.Enum,"",e.chart.Position),this.CreateProp("stacking",i.Enum,"",e.chart.Stacking),this.CreateProp("maxSeries",i.Number),this.CreateProp("maxPoints",i.Number),this.CreateProp("itemsSource",i.Any)]);case e.olap&&e.olap.PivotPanel:return this.getMetaData(e.Control).add([this.CreateProp("autoGenerateFields",i.Boolean),this.CreateProp("viewDefinition",i.String),this.CreateProp("engine",i.Any),this.CreateProp("itemsSource",i.Any),this.CreateProp("showFieldIcons",i.Boolean),this.CreateProp("restrictDragging",i.Boolean)],[this.CreateEvent("itemsSourceChanged"),this.CreateEvent("viewDefinitionChanged"),this.CreateEvent("updatingView"),this.CreateEvent("updatedView")]);case e.olap&&e.olap.PivotField:return new l([this.CreateProp("binding",i.String),this.CreateProp("header",i.String),this.CreateProp("dataType",i.Enum,"",e.DataType)],[],[],"",!0,!0,"");case e.viewer&&e.viewer.ViewerBase:return new l([this.CreateProp("serviceUrl",i.String),this.CreateProp("filePath",i.String),this.CreateProp("fullScreen",i.Boolean,"fullScreenChanged"),this.CreateProp("zoomFactor",i.Number,"zoomFactorChanged"),this.CreateProp("mouseMode",i.Enum,"mouseModeChanged",e.viewer.MouseMode),this.CreateProp("selectMouseMode",i.Boolean,"selectMouseModeChanged"),this.CreateProp("viewMode",i.Enum,"viewModeChanged",e.viewer.ViewMode)],[this.CreateEvent("pageIndexChanged"),this.CreateEvent("viewModeChanged"),this.CreateEvent("mouseModeChanged"),this.CreateEvent("selectMouseModeChanged"),this.CreateEvent("fullScreenChanged"),this.CreateEvent("zoomFactorChanged",!0),this.CreateEvent("queryLoadingData")]);case e.viewer&&e.viewer.ReportViewer:return this.getMetaData(e.viewer.ViewerBase).add([this.CreateProp("paginated",i.Boolean),this.CreateProp("reportName",i.String)]);case e.viewer&&e.viewer.PdfViewer:return this.getMetaData(e.viewer.ViewerBase);case e.nav&&e.nav.TreeView:return this.getMetaData(e.Control).add([this.CreateProp("childItemsPath",i.Any),this.CreateProp("displayMemberPath",i.Any),this.CreateProp("imageMemberPath",i.Any),this.CreateProp("isContentHtml",i.Boolean),this.CreateProp("showCheckboxes",i.Boolean),this.CreateProp("autoCollapse",i.Boolean),this.CreateProp("isAnimated",i.Boolean),this.CreateProp("isReadOnly",i.Boolean),this.CreateProp("allowDragging",i.Boolean),this.CreateProp("expandOnClick",i.Boolean),this.CreateProp("lazyLoadFunction",i.Function),this.CreateProp("itemsSource",i.Any),this.CreateProp("selectedItem",i.Any,"selectedItemChanged"),this.CreateProp("selectedNode",i.Any,"selectedItemChanged"),this.CreateProp("checkedItems",i.Any,"checkedItemsChanged")],[this.CreateEvent("itemsSourceChanged",!0),this.CreateEvent("loadingItems"),this.CreateEvent("loadedItems"),this.CreateEvent("itemClicked"),this.CreateEvent("selectedItemChanged"),this.CreateEvent("checkedItemsChanged",!0),this.CreateEvent("isCollapsedChanging"),this.CreateEvent("isCollapsedChanged"),this.CreateEvent("isCheckedChanging"),this.CreateEvent("isCheckedChanged"),this.CreateEvent("formatItem"),this.CreateEvent("dragStart"),this.CreateEvent("dragOver"),this.CreateEvent("drop"),this.CreateEvent("dragEnd"),this.CreateEvent("nodeEditStarting"),this.CreateEvent("nodeEditStarted"),this.CreateEvent("nodeEditEnding"),this.CreateEvent("nodeEditEnded")]);case e.nav&&e.nav.TabPanel:return this.getMetaData(e.Control).add([this.CreateProp("isAnimated",i.Boolean),this.CreateProp("autoSwitch",i.Boolean),this.CreateProp("selectedIndex",i.Number,"selectedIndexChanged"),this.CreateProp("selectedTab",i.Any,"selectedIndexChanged")],[this.CreateEvent("selectedIndexChanged",!0)]);case e.nav&&e.nav.Tab:return new l([this.CreateProp("isDisabled",i.Boolean),this.CreateProp("isVisible",i.Boolean)],[],[],"tabs",!0)}return new l([])},t.getClassName=function(e){return(e.toString().match(/function (.+?)\(/)||[,""])[1]},t.toCamelCase=function(e){return e.toLowerCase().replace(/-(.)/g,function(e,t){return t.toUpperCase()})},t.findInArr=function(e,t,r){for(var n in e)if(e[n][t]===r)return e[n];return null},t}();t.ControlMetaFactory=r;var n=function(){function t(e,t,r,n,i,o){void 0===i&&(i=!0),void 0===o&&(o=0),this._priority=0,this._propertyName=e,this._propertyType=t,this._changeEvent=r,this._enumType=n,this._isNativeControlProperty=i,this._priority=o}return Object.defineProperty(t.prototype,"propertyName",{get:function(){return this._propertyName},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"propertyType",{get:function(){return this._propertyType},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"changeEvent",{get:function(){return this._changeEvent},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"enumType",{get:function(){return this._enumType},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bindingMode",{get:function(){return this.changeEvent?o.TwoWay:o.OneWay},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isNativeControlProperty",{get:function(){return this._isNativeControlProperty},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"priority",{get:function(){return this._priority},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"shouldUpdateSource",{get:function(){return this.bindingMode===o.TwoWay&&this.propertyType!=i.EventHandler},enumerable:!0,configurable:!0}),t.prototype.initialize=function(t){e.copy(this,t)},t.prototype.castValueToType=function(t){if(void 0==t)return t;var r=this.propertyType,n=i;if(r===n.AnyPrimitive){if(!e.isString(t))return t;if("true"!==t&&"false"!==t){if(o=+t,!isNaN(o))return o;var o=this._parseDate(t);return e.isString(o)?t:o}r=n.Boolean}switch(r){case n.Number:if("string"==typeof t){if(t.indexOf("*")>=0)return t;if(""===t.trim())return null}return+t;case n.Boolean:return"true"===t||"false"!==t&&!!t;case n.String:return t+"";case n.Date:return this._parseDate(t);case n.Enum:return"number"==typeof t?t:this.enumType[t];default:return t}},t.prototype._parseDate=function(t){if(t&&e.isString(t)){t=t.replace(/["']/g,"");var r=e.changeType(t,e.DataType.Date,"r");if(e.isDate(r))return r}return t},t}();t.PropDescBase=n;var i;!function(e){e[e.Boolean=0]="Boolean",e[e.Number=1]="Number",e[e.Date=2]="Date",e[e.String=3]="String",e[e.AnyPrimitive=4]="AnyPrimitive",e[e.Enum=5]="Enum",e[e.Function=6]="Function",e[e.EventHandler=7]="EventHandler",e[e.Any=8]="Any"}(i=t.PropertyType||(t.PropertyType={})),t.isSimpleType=function(e){return e<=i.Enum};var o;!function(e){e[e.OneWay=0]="OneWay",e[e.TwoWay=1]="TwoWay"}(o=t.BindingMode||(t.BindingMode={}));var a=function(){function e(e,t){this._eventName=e,this._isPropChanged=t}return Object.defineProperty(e.prototype,"eventName",{get:function(){return this._eventName},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isPropChanged",{get:function(){return!0===this._isPropChanged},enumerable:!0,configurable:!0}),e}();t.EventDescBase=a;var s=function(){function e(e,t,r){void 0===r&&(r=!1),this.isArray=!1,this._ownsObject=!1,this.propertyName=e,this.isArray=t,this._ownsObject=r}return Object.defineProperty(e.prototype,"ownsObject",{get:function(){return this.isArray||this._ownsObject},enumerable:!0,configurable:!0}),e}();t.ComplexPropDescBase=s;var l=function(){function e(e,t,r,n,i,o,a,s){this._props=[],this._events=[],this._complexProps=[],this.props=e,this.events=t,this.complexProps=r,this.parentProperty=n,this.isParentPropertyArray=i,this.ownsObject=o,this.parentReferenceProperty=a,this.ngModelProperty=s}return Object.defineProperty(e.prototype,"props",{get:function(){return this._props},set:function(e){this._props=e||[]},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"events",{get:function(){return this._events},set:function(e){this._events=e||[]},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"complexProps",{get:function(){return this._complexProps},set:function(e){this._complexProps=e||[]},enumerable:!0,configurable:!0}),e.prototype.add=function(e,t,r,n,i,o,a,s){return this.addOptions({props:e,events:t,complexProps:r,parentProperty:n,isParentPropertyArray:i,ownsObject:o,parentReferenceProperty:a,ngModelProperty:s})},e.prototype.addOptions=function(e){for(var t in e){var r=this[t],n=e[t];r instanceof Array?this[t]=r.concat(n||[]):void 0!==n&&(this[t]=n)}return this},e.prototype.prepare=function(){var e=[].concat(this._props);this._props.sort(function(t,r){var n=t.priority-r.priority;return n||(n=e.indexOf(t)-e.indexOf(r)),n})},e}();t.MetaDataBase=l}(e.meta||(e.meta={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),r.CreateProp=function(e,t,r,i,o,a){return new n(e,t,r,i,o,a)},r.CreateEvent=function(e,t){return new i(e,t)},r.CreateComplexProp=function(e,t,r){return new o(e,t,r)},r.findProp=function(t,r){return e.meta.ControlMetaFactory.findProp(t,r)},r.findEvent=function(t,r){return e.meta.ControlMetaFactory.findEvent(t,r)},r.findComplexProp=function(t,r){return e.meta.ControlMetaFactory.findComplexProp(t,r)},r}(e.meta.ControlMetaFactory);t.MetaFactory=r;var n=function(t){function r(r,n,i,o,a,s){var l=t.call(this,r,n,i,o,a,s)||this;return l._scopeBindingMode=l.propertyType===e.meta.PropertyType.EventHandler?"&":l.bindingMode==e.meta.BindingMode.OneWay&&e.meta.isSimpleType(l.propertyType)?"@":"=",l}return __extends(r,t),Object.defineProperty(r.prototype,"scopeBindingMode",{get:function(){return this._scopeBindingMode},set:function(e){this._scopeBindingMode=e},enumerable:!0,configurable:!0}),Object.defineProperty(r.prototype,"customHandler",{get:function(){return this._customHandler},set:function(e){this._customHandler=e},enumerable:!0,configurable:!0}),r}(e.meta.PropDescBase);t.PropDesc=n;var i=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t}(e.meta.EventDescBase);t.EventDesc=i;var o=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t}(e.meta.ComplexPropDescBase);t.ComplexPropDesc=o}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var wijmo;!function(e){!function(t){var r=function(){function r(){this.replace=!0,this.restrict="E",this.template="<div />",this.transclude=!1,this._props=[],this._events=[],this._complexProps=[];var e=this;this._dirId=++r._dirIdCounter+"",this.link=this._postLinkFn(),this.controller=["$scope","$parse","$element",function(t,n,i){e._$parse=n,i[0][r._elemScopeProp]=t,this[r._cntrlScopeProp]=t,t[r._scopeChildrenProp]=[],e._controllerImpl(this,t,i)}],this._initDirective()}return r._versionOk=function(e){var t=window.angular.version,r=[t.major,t.minor,t.dot],n=e.split(".");if(n.length!==r.length)throw"Unrecognizable version number.";for(var i=0;i<n.length;i++){if(r[i]<n[i])return!1;if(r[i]>n[i])return!0}return!0},Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){throw"Abstract method call"},enumerable:!0,configurable:!0}),r.prototype._getMetaDataId=function(){return this._controlConstructor},r.prototype._getMetaData=function(){return t.MetaFactory.getMetaData(this._getMetaDataId())},r.prototype._initDirective=function(){this._initSharedMeta(),this._prepareProps(),this._initEvents(),this._initScopeEvents(),this._initScopeDescription()},r.prototype._initSharedMeta=function(){var e=this._getMetaData();this._props=e.props,this._events=e.events,this._complexProps=e.complexProps,this._property=e.parentProperty,this._isPropertyArray=e.isParentPropertyArray,this._ownObject=e.ownsObject,this._parentReferenceProperty=e.parentReferenceProperty,this._ngModelProperty=e.ngModelProperty},r.prototype._initProps=function(){},r.prototype._initEvents=function(){},r.prototype._createLink=function(){return new n},r.prototype._controllerImpl=function(e,t,r){},r.prototype._initControl=function(e){try{return new(0,this._controlConstructor)(e)}catch(e){return}},r.prototype._isChild=function(){return this._isParentInitializer()||this._isParentReferencer()},r.prototype._isParentInitializer=function(){return void 0!=this._property},r.prototype._isParentReferencer=function(){return void 0!=this._parentReferenceProperty},r.prototype._scopeToAttrName=function(e){var t=this.scope[e];if(t){var r=1,n=t.length;return n<2?e:("?"===t.charAt(1)&&(r=2),n===r?e:t.substr(r))}return e},r.prototype._getComplexPropDesc=function(e){return t.MetaFactory.findComplexProp(e,this._complexProps)},r.prototype._initScopeEvents=function(){for(var r in this._events){var n=this._events[r];this._props.push(new t.PropDesc(n.eventName,e.meta.PropertyType.EventHandler))}},r.prototype._initScopeDescription=function(){var e=this._props,t={},n=r._optionalAttr?"=?":"=";if(null!=e)for(var i,o=0;o<e.length;o++)t[(i=e[o]).propertyName]=i.scopeBindingMode,r._optionalAttr&&"="==i.scopeBindingMode&&(t[i.propertyName]="=?");t.control=n,t[r._initPropAttr]=n,t[r._initEventAttr]="&",t[r._parPropAttr]="@",t[r._wjModelPropAttr]="@",this.scope=t},r.prototype._postLinkFn=function(){var t=this;return function(n,i,o,a){var s=t._createLink();if(s.directive=t,s.scope=n,s.tElement=i,s.tAttrs=o,e.isArray(a)){var l=i.parent()[0][r._elemScopeProp];for(var c in a){var u=a[c];if(void 0!=u&&(u[r._cntrlScopeProp]===n&&(u=i.parent().controller(t._stripRequire(+c))),u&&u[r._cntrlScopeProp]===l)){s.controller=u;break}}}else s.controller=a;s.ngModel=i.controller("ngModel"),s._link()}},r.prototype._prepareProps=function(){this._initProps();var e=[].concat(this._props);this._props.sort(function(t,r){var n=t.priority-r.priority;return n||(n=e.indexOf(t)-e.indexOf(r)),n})},r.prototype._stripRequire=function(e){if(this._stripReq||(this._stripReq=[],this._stripReq.length=this.require.length),!this._stripReq[e]){var t=/^[^A-Za-z]*(.*)/.exec(this.require[e]);this._stripReq[e]=t?t[1]:""}return this._stripReq[e]},r.prototype._getId=function(){return this._dirId},r._removeTransclude=function(e){if(!e)return e;var t=document.createElement("div");t.innerHTML=e;var r=t.querySelectorAll("[ng-transclude]");return[].forEach.call(r,function(e,t){e.removeAttribute("ng-transclude")}),t.innerHTML},r._parPropAttr="wjProperty",r._wjModelPropAttr="wjModelProperty",r._initPropAttr="isInitialized",r._initEventAttr="initialized",r._cntrlScopeProp="_cntrlScope",r._elemScopeProp="_elemCntrl",r._cntrlLinkProp="$_thisLink",r._scopeChildrenProp="$_childLinks",r._dirIdAttr="wj-directive-id",r._optionalAttr=r._versionOk("1.1.4"),r._dynaTemplates=r._optionalAttr,r._angStripPrefixes=["data","x"],r._dirIdCounter=0,r}();t.WjDirective=r;var n=function(){function n(){this._nonAssignable={},this._definedProps={},this._definedEvents={},this._oldValues={},this._isInitialized=!1,this._hasTriggeredInitialized=!1,this._isNgModelInitialized=!1,this._scopeSuspend=0,this._suspendedEvents=[],this._areChlildrenReady=!1,this._isDestroyed=!1,this._isAppliedToParent=!1}return n.prototype._link=function(){var e=this.directive,n=this;if(this.tElement[0].setAttribute(r._dirIdAttr,e._getId()),this.directiveTemplateElement=e.replace?this.tElement:window.angular.element(this.tElement.children()[0]),this._initNonAssignable(),this._isChild()){this._parentPropDesc=new t.ComplexPropDesc(e._property,e._isPropertyArray,e._ownObject),this.controller[r._cntrlScopeProp][r._scopeChildrenProp].push(this);var i=this.controller[r._cntrlScopeProp][r._cntrlLinkProp];i&&i._areChlildrenReady&&this._parentReady(i)}else this._createInstance(),this._notifyReady(),this._prepareControl();this._destroyEhUnreg=this.scope.$on("$destroy",function(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];n._destroy()})},n.prototype._onChildrenReady=function(){},n.prototype._createInstance=function(){this.control=this._initControl(),this._safeApply(this.scope,"control",this.control)},n.prototype._parentReady=function(e){if(this._isChild()){var t=this;if(!this._isAttrDefined(r._parPropAttr)||this.scope[r._parPropAttr]){var n=this._getParentProp(),i=e.directive._getComplexPropDesc(n);i?this._parentPropDesc=i:this._parentPropDesc.propertyName=n,this.parent=e,this._useParentObj()?(this.control=e.control[n],this._safeApply(this.scope,"control",this.control)):this._createInstance(),this._notifyReady(),this._prepareControl(),this._initParent(),this.directiveTemplateElement[0].style.display="none",this._appliedToParent()}else this.scope.$watch(r._parPropAttr,function(){t._parentReady(e)})}},n.prototype._initParent=function(){if(!this._useParentObj()){this.directive;var e=this._getParentProp(),t=this.parent.control,r=this.control;if(this._isParentInitializer())if(this._isParentArray()){var n=t[e],i=this._getIndex();(i<0||i>=n.length)&&(i=n.length),n.splice(i,0,r);this._siblingInsertedEH=this._siblingInserted.bind(this),this.tElement[0].addEventListener("DOMNodeInserted",this._siblingInsertedEH)}else t[e]=r;this._isParentReferencer()&&!this._parentInCtor()&&(r[this._getParentReferenceProperty()]=t)}},n.prototype._destroy=function(){if(!this._isDestroyed){this._isDestroyed=!0;var t=this.control;if(this._destroyEhUnreg&&(this._destroyEhUnreg=null),this._siblingInsertedEH&&this.tElement[0].removeEventListener("DOMNodeInserted",this._siblingInsertedEH),this._isParentArray()&&!this.parent._isDestroyed){var n=this.parent.control,i=this._getParentProp();if(n&&i&&t){var o=n[i];if(o){var a=o.indexOf(t);a>=0&&o.splice(a,1)}}}this.tElement[0][r._elemScopeProp]=null,t instanceof e.Control&&setTimeout(function(){t.hostElement&&t.dispose()},0)}},n.prototype._siblingInserted=function(e){if(e.target===this.tElement[0]){var t=this._getIndex(),r=this.parent.control[this._getParentProp()],n=this.control,i=r.indexOf(n);t>=0&&i>=0&&t!==i&&(r.splice(i,1),t=Math.min(t,r.length),r.splice(t,0,n))}},n.prototype._notifyReady=function(){this.scope[r._cntrlLinkProp]=this;for(var e=[].concat(this.scope[r._scopeChildrenProp]),t=0;t<e.length;t++)e[t]._parentReady(this);this._areChlildrenReady=!0,this._onChildrenReady()},n.prototype._initControl=function(){return this.directive._initControl(this._parentInCtor()?this.parent.control:this.directiveTemplateElement[0])},n.prototype._prepareControl=function(){this._addEventHandlers(),this._addWatchers()},n.prototype._setupScopeWithControlProperties=function(){for(var t,r,n,i,o=this.control,a=this.scope,s=this.directive._props,l=0;l<s.length;l++)if("="===(t=s[l]).scopeBindingMode&&t.isNativeControlProperty&&t.shouldUpdateSource){n=a[r=t.propertyName],i=o[r];var c=t.propertyType==e.meta.PropertyType.Function,u=t.propertyType==e.meta.PropertyType.EventHandler;!this._canApply(a,t.propertyName)||i==n||c||u||(a[t.propertyName]=i)}a.$root.$$phase||a.$apply()},n.prototype._initNonAssignable=function(){var e,t=this.directive._$parse,r=this.directive.scope;for(var n in r)"="===r[n].charAt(0)&&(void 0!==(e=this.tAttrs[this.directive._scopeToAttrName(n)])&&void 0!=t(e).assign||(this._nonAssignable[n]=!0))},n.prototype._suspendScope=function(){this._scopeSuspend++},n.prototype._resumeScope=function(){this._scopeSuspend>0&&0==--this._scopeSuspend&&this._suspendedEvents.length>0&&this._updateScope()},n.prototype._isScopeSuspended=function(){return this._scopeSuspend>0},n.prototype._isAttrDefined=function(e){return null!=this.tAttrs.$attr[this.directive._scopeToAttrName(e)]},n.prototype._childInitialized=function(e){var t=this.scope[r._scopeChildrenProp],n=t.indexOf(e);n>=0&&(t.splice(n,1),this._checkRaiseInitialized())},n.prototype._thisInitialized=function(){this._checkRaiseInitialized()},n.prototype._initialized=function(){},n.prototype._appliedToParent=function(){this._isAppliedToParent=!0,this._checkRaiseInitialized()},n.prototype._checkRaiseInitialized=function(){if(!this._hasTriggeredInitialized&&0===this.scope[r._scopeChildrenProp].length&&this._isInitialized&&(!this._isChild()||this._isAppliedToParent)){this._hasTriggeredInitialized=!0,this._initialized(),this._safeApply(this.scope,r._initPropAttr,!0);var e=this.scope[r._initEventAttr],t=this;e&&setTimeout(function(){e({s:t.control,e:void 0})},0),this._isChild()&&this.parent&&this.parent._childInitialized(this)}},n.prototype._addWatchers=function(){var t=this,n=this.directive._props,i=this.scope;if(n){if(this.ngModel){var o=this.ngModel;o.$pristine&&e.addClass(this.tElement[0],"ng-pristine"),o.$valid&&e.addClass(this.tElement[0],"ng-valid"),o.$untouched&&e.addClass(this.tElement[0],"ng-untouched"),o.$render=this._ngModelRender.bind(this),this._updateNgModelPropDesc(),this._isAttrDefined(r._wjModelPropAttr)&&i.$watch(r._wjModelPropAttr,function(){t._updateNgModelPropDesc(),t._ngModelRender()})}var a,s,l;for(a=0;a<n.length;a++)s=(l=n[a]).propertyName,l.propertyType!==e.meta.PropertyType.EventHandler&&this._isAttrDefined(s)&&(this._definedProps[s]=l);var c=this.control;i.$watch(function(e){if(!t._isDestroyed)try{var r={};for(var n in t._definedProps)e[n]!==t._oldValues[n]&&(r[n]=e[n]);for(var n in r){var i=r[n];if(i!==t._oldValues[n]&&(t._oldValues[n]=i,t._isInitialized||void 0!==i)){var o=t._definedProps[n],a=t._nullOrValue(t._castValueToType(i,o)),s=c[n];if(s!=a){var l=!1;null!=o.customHandler&&(l=o.customHandler(e,c,a,s,t)),o.isNativeControlProperty&&!0!==l&&(c[n]=a)}}}}finally{t._isInitialized||(t._isNgModelInitialized=!0,t.ngModel&&(void 0!==t.ngModel.$viewValue?t._ngModelRender():t._ngModelPropDesc&&(t.ngModel.$setViewValue(c[t._ngModelPropDesc.propertyName]),t.ngModel.$setPristine())),t._isInitialized=!0,t._setupScopeWithControlProperties(),t._thisInitialized())}})}},n.prototype._addEventHandlers=function(){var e,t,r=this.directive._events;for(e=0;e<r.length;e++)t=r[e],this._addEventHandler(t)},n.prototype._addEventHandler=function(e){var t=this,r=e.eventName,n=this.control[r];if(null==n)throw'Event "'+r+'" not found in '+t.constructor.name;if(this._isAttrDefined(r))this._definedEvents[r]=e;else if(!e.isPropChanged)return;this.scope,this.directive._props;var i=this.control;n.addHandler(function(r,n){var i={eventDesc:e,s:r,e:n};t._isScopeSuspended()?t._suspendedEvents.push(i):t._updateScope(i)},i)},n.prototype._updateScope=function(e){if(void 0===e&&(e=null),!this._isDestroyed){var t=e?e.eventDesc.isPropChanged:this._suspendedEvents.some(function(e){return e.eventDesc.isPropChanged}),r=this;if(t)for(var n=this.directive._props,i=0;i<n.length;i++){var o=n[i];if("="==o.scopeBindingMode&&o.isNativeControlProperty&&o.shouldUpdateSource){var a=o.propertyName,s=this.control[a];this._shouldApply(this.scope,a,s)&&(this.scope[a]=s,this.directive._$parse(this.tAttrs[this.directive._scopeToAttrName(a)]).assign(this.scope.$parent,s)),this._ngModelPropDesc&&this._isInitialized&&this._ngModelPropDesc.propertyName==a&&this.ngModel.$viewValue!==s&&this.ngModel.$setViewValue(s)}}var l=function(){for(var t=e?[e]:this._suspendedEvents,n=0;n<t.length;n++){var i=t[n],o=i.eventDesc.eventName,a=this.scope[o];r._definedEvents[o]&&a&&a({s:i.s,e:i.e})}e||(this._suspendedEvents.length=0)}.bind(this);if(t)if(this.scope.$root.$$phase)var c=this.scope.$watch("value",function(){c()});else this.scope.$apply();l()}},n.prototype._ngModelRender=function(){if(this._isNgModelInitialized){var e=this.ngModel.$viewValue,t=this._ngModelPropDesc;if(t&&(void 0!==e||this._isInitialized)){this._nullOrValue(this._castValueToType(e,t));e!==this.control[t.propertyName]&&(this.control[t.propertyName]=e)}}},n.prototype._castValueToType=function(e,t){return t.castValueToType(e)},n.prototype._isChild=function(){return this.directive._isChild()},n.prototype._isParentInitializer=function(){return this.directive._isParentInitializer()},n.prototype._isParentReferencer=function(){return this.directive._isParentReferencer()},n.prototype._getParentProp=function(){return this._isParentInitializer()?this.scope[r._parPropAttr]||this.directive._property:void 0},n.prototype._getParentReferenceProperty=function(){return this.directive._parentReferenceProperty},n.prototype._useParentObj=function(){return!this._isParentReferencer()&&this._isParentInitializer()&&!this._parentPropDesc.isArray&&!this._parentPropDesc.ownsObject},n.prototype._isParentArray=function(){return this._isParentInitializer()&&this._parentPropDesc.isArray},n.prototype._parentInCtor=function(){return this._isParentReferencer()&&""==this._getParentReferenceProperty()},n.prototype._getNgModelProperty=function(){return this.scope[r._wjModelPropAttr]||this.directive._ngModelProperty},n.prototype._updateNgModelPropDesc=function(){var r=this._getNgModelProperty();this._ngModelPropDesc=e.isNullOrWhiteSpace(r)?null:t.MetaFactory.findProp(r,this.directive._props)},n.prototype._safeApply=function(e,t,r){return!!this._shouldApply(e,t,r)&&(e[t]=r,e.$root.$$phase||e.$apply(),!0)},n.prototype._shouldApply=function(e,t,r){return this._canApply(e,t)&&r!=e[t]},n.prototype._canApply=function(e,t){return!this._nonAssignable[t]},n.prototype._nullOrValue=function(e){return void 0!=e?e:null},n.prototype._getIndex=function(){var e=this.tElement[0],t=e.parentElement;if(!t)return-1;for(var n=t.childNodes,i=-1,o=this.directive._getId(),a=0;a<n.length;a++){var s=n[a];if(1==s.nodeType&&s.getAttribute(r._dirIdAttr)==o&&(++i,s===e))return i}return-1},n}();t.WjLink=n}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=window.angular.module("wj.container",[]);r.directive("wjTooltip",[function(){return new n}]),r.directive("wjValidationError",[function(){return new o}]);var n=function(t){function r(){var e=t.call(this)||this;return e.restrict="A",e.template="",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.Tooltip},enumerable:!0,configurable:!0}),r.prototype._initControl=function(t){return new e.Tooltip},r.prototype._createLink=function(){return new i},r}(t.WjDirective),i=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype._link=function(){e.prototype._link.call(this);var t=this.control,r=this;this.tAttrs.$observe("wjTooltip",function(e){t.setTooltip(r.tElement[0],e)})},t}(t.WjLink),o=function(e){function t(){var t=e.call(this)||this;return t.restrict="A",t.template="",t.require="ngModel",t.scope=!1,t}return __extends(t,e),t.prototype._postLinkFn=function(){return function(e,t,r,n){var i="wjValidationError";e.$watch(r[i],function(e){var r="INPUT"==t[0].tagName?t[0]:t[0].querySelector("input");"boolean"==typeof e&&(e=e?"error":""),r&&r.setCustomValidity&&r.setCustomValidity(e),n&&n.$setValidity(i,!e)})}},t.prototype._getMetaDataId=function(){return"ValidationError"},t}(t.WjDirective)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=window.angular.module("wj.input",[]);e.input&&e.input.InputNumber&&(r.directive("wjAutoComplete",["$compile",function(e){return new o(e)}]),r.directive("wjCalendar",[function(){return new a}]),r.directive("wjColorPicker",[function(){return new s}]),r.directive("wjComboBox",["$compile",function(e){return new i(e)}]),r.directive("wjInputDate",[function(){return new m}]),r.directive("wjInputDateTime",[function(){return new y}]),r.directive("wjInputNumber",[function(){return new _}]),r.directive("wjInputMask",[function(){return new v}]),r.directive("wjInputTime",["$compile",function(e){return new P(e)}]),r.directive("wjInputColor",[function(){return new w}]),r.directive("wjListBox",[function(){return new l}]),r.directive("wjItemTemplate",["$compile",function(e){return new c(e)}]),r.directive("wjMenu",["$compile",function(e){return new p(e)}]),r.directive("wjMenuItem",[function(e){return new d}]),r.directive("wjMenuSeparator",[function(){return new C}]),r.directive("wjContextMenu",[function(){return new g}]),r.directive("wjCollectionViewNavigator",[function(){return new E}]),r.directive("wjCollectionViewPager",[function(){return new S}]),r.directive("wjPopup",[function(){return new b}]),r.directive("wjMultiSelect",["$compile",function(e){return new j(e)}]),r.directive("wjMultiAutoComplete",["$compile",function(e){return new x(e)}]));var n=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.DropDown},enumerable:!0,configurable:!0}),r}(t.WjDirective),i=function(t){function r(e){var r=t.call(this)||this;return r._$compile=e,r.template="<div ng-transclude />",r.transclude=!0,r}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.ComboBox},enumerable:!0,configurable:!0}),r}(n),o=function(t){function r(e){return t.call(this,e)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.AutoComplete},enumerable:!0,configurable:!0}),r}(i),a=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.Calendar},enumerable:!0,configurable:!0}),r}(t.WjDirective),s=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.ColorPicker},enumerable:!0,configurable:!0}),r}(t.WjDirective),l=function(t){function r(){var e=t.call(this)||this;return e.transclude=!0,e.template="<div ng-transclude />",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.ListBox},enumerable:!0,configurable:!0}),r}(t.WjDirective),c=function(e){function r(n){var i=e.call(this)||this;return i._$compile=n,i.require=["?^wjListBox","?^wjMenu"],i.terminal=!0,t.WjDirective._dynaTemplates?(i.transclude=!1,i.priority=100,i.template=function(e,t){return t[r._itemTemplateProp]=e[0].innerHTML,"<div />"}):(i.transclude=!0,i.template="<div ng-transclude/>"),i}return __extends(r,e),r.prototype._initControl=function(e){return{}},r.prototype._createLink=function(){return new u},r.prototype._getMetaDataId=function(){return"ItemTemplate"},r._itemTemplateProp="$__wjItemTemplate",r._itemScopeProp="$_itemScope",r}(t.WjDirective),u=function(r){function n(){return null!==r&&r.apply(this,arguments)||this}return __extends(n,r),n.prototype._initParent=function(){r.prototype._initParent.call(this);var e=this.tAttrs[c._itemTemplateProp],n=this.parent.control,i=this._getListBox();this.itemTemplate=null!=e?e:t.WjDirective._removeTransclude(this.tElement[0].innerHTML),i.formatItem.addHandler(this._fmtItem,this),i.loadingItems.addHandler(this._loadingItems,this),this.parent._isInitialized&&n.invalidate()},n.prototype._destroy=function(){var e=this.parent&&this.parent.control,t=this._getListBox();t&&(t.formatItem.removeHandler(this._fmtItem,this),t.loadingItems.removeHandler(this._loadingItems,this)),r.prototype._destroy.call(this),this._tmplLink=null,e&&e.invalidate()},n.prototype._loadingItems=function(e){for(var t=e.hostElement.getElementsByClassName("wj-listbox-item"),r=t.length-1;r>=0;r--){var n=t[r],i=n[c._itemScopeProp];i&&(n[c._itemScopeProp]=null,i.$destroy())}},n.prototype._fmtItem=function(e,t){this._tmplLink||(this._tmplLink=this.directive._$compile("<div>"+this.itemTemplate+"</div>"));var r=t.item,n=this.scope.$parent.$new();r[c._itemScopeProp]=n,n.$control=e,n.$item=t.data,n.$itemIndex=t.index;var i=this._tmplLink(n,function(e,t){})[0];1===r.childNodes.length?r.replaceChild(i,r.firstChild):(r.textContent="",r.appendChild(i));clearTimeout(this._closingApplyTimeOut),this._closingApplyTimeOut=setTimeout(function(){n.$root.$$phase||n.$apply()},40)},n._invalidateControl=function(e){e&&e.invalidate()},n.prototype._getListBox=function(){var t=this.parent&&this.parent.control;return t?t instanceof e.input.ListBox?t:t.listBox:null},n}(t.WjLink),p=function(r){function n(e){return r.call(this,e)||this}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.input.Menu},enumerable:!0,configurable:!0}),n.prototype._createLink=function(){return new h},n.prototype._initProps=function(){r.prototype._initProps.call(this);var e=this;t.MetaFactory.findProp("value",this._props).customHandler=function(t,r,n,i,o){e.updateControlValue(t,r,o)}},n.prototype.updateControlValue=function(e,t,r){null!=e.value&&(t.selectedValue=e.value,r.directive.updateHeader(e,t,r))},n.prototype.updateHeader=function(e,t,r){t.header=e.header||"";var n=t.selectedItem;if(void 0!==e.value&&n&&t.displayMemberPath){var i=n[d._itemLinkProp],o=i?i.linkedContent.innerHTML:n[t.displayMemberPath];null!=o&&(t.header+=": <b>"+o+"</b>")}},n}(i),h=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),r.prototype._initControl=function(){var t=this,r=new e.input.Menu(this.directiveTemplateElement[0],{itemsSource:new e.collections.ObservableArray,selectedIndex:0,itemClicked:function(){t._safeApply(t.scope,"value",r.selectedValue)||t.scope.$root.$$phase||t.scope.$apply(),t.directive.updateHeader(t.scope,r,t)}.bind(t)});return r.listBox.formatItem.addHandler(t._fmtItem,this),r.listBox.loadingItems.addHandler(this._loadingItems,this),r},r.prototype._initialized=function(){this.directive.updateControlValue(this.scope,this.control,this)},r.prototype._fmtItem=function(t,r){var n=r.data[d._itemLinkProp];if(n){n.contentLink||(n.contentLink=this.directive._$compile("<div>"+n.itemTemplate+"</div>"));var i=this,o=r.item,a=n.scope.$parent.$new();o[d._itemScopeProp]=a,a.$control=this.control,a.$item=r.data,a.$itemIndex=r.index;var s=n.linkedContent=n.contentLink(a,function(e,t){})[0];n.isSeparator&&e.addClass(o,"wj-state-disabled"),1===o.childNodes.length?o.replaceChild(s,o.firstChild):(o.textContent="",o.appendChild(s));clearTimeout(this._closingApplyTimeOut),this._closingApplyTimeOut=setTimeout(function(){a.$root.$$phase||a.$apply(),i.control.selectedItem&&i.directive.updateHeader(i.scope,i.control,i)},40)}},r.prototype._loadingItems=function(e){for(var t=e.hostElement.getElementsByClassName("wj-listbox-item"),r=t.length-1;r>=0;r--){var n=t[r],i=n[d._itemScopeProp];i&&(n[c._itemScopeProp]=null,i.$destroy())}},r}(t.WjLink);t.WjMenuLink=h;var d=function(e){function r(){var r=e.call(this)||this;return r.require="^wjMenu",r.terminal=!0,t.WjDirective._dynaTemplates?(r.transclude=!1,r.priority=100,r.template=function(e,t){return t[c._itemTemplateProp]=e[0].innerHTML,"<div />"}):(r.transclude=!0,r.template="<div ng-transclude/>"),r}return __extends(r,e),r.prototype._createLink=function(){return new f(!1)},r.prototype._getMetaDataId=function(){return"MenuItem"},r.prototype._getId=function(){return r._directiveId},r._itemTemplateProp="$__wjMenuItemTemplate",r._itemScopeProp="$_menuItemScope",r._itemLinkProp="$_menuItemLink",r._directiveId="menuItemDir",r}(t.WjDirective),f=function(e){function r(t){var r=e.call(this)||this;return r.isSeparator=t,r}return __extends(r,e),r.prototype._initControl=function(){var e=this.tAttrs[c._itemTemplateProp];this.itemTemplate=this.isSeparator?'<div class="wj-state-disabled" style="width:100%;height:1px;background-color:lightgray"/>':null!=e?e:t.WjDirective._removeTransclude(this.tElement[0].innerHTML);var r={value:null,cmd:null,cmdParam:null,header:this.itemTemplate};return r[d._itemLinkProp]=this,r},r.prototype._initParent=function(){e.prototype._initParent.call(this);var t=this.parent.control;1==t.itemsSource.length&&t.selectedIndex<0&&(t.selectedIndex=0),t.displayMemberPath||(t.displayMemberPath="header"),t.selectedValuePath||(t.selectedValuePath="value"),t.commandPath||(t.commandPath="cmd"),t.commandParameterPath||(t.commandParameterPath="cmdParam")},r.prototype._destroy=function(){var t=this.parent&&this.parent.control;e.prototype._destroy.call(this),t&&t.invalidate()},r}(t.WjLink),C=function(e){function t(){var t=e.call(this)||this;return t.template="<span />",t.require="^wjMenu",t}return __extends(t,e),t.prototype._getMetaDataId=function(){return"MenuSeparator"},t.prototype._createLink=function(){return new f(!0)},t.prototype._getId=function(){return d._directiveId},t}(t.WjDirective),g=function(t){function r(){var e=t.call(this)||this;return e.template=void 0,e.restrict="A",e.scope=!1,e}return __extends(r,t),r.prototype._getMetaDataId=function(){return"WjContextMenu"},r.prototype._postLinkFn=function(){return function(t,r,n){var i=e.getElement(n.wjContextMenu);r[0].addEventListener("contextmenu",function(t){var n=e.Control.getControl(i),o=n.dropDown;n&&o&&!e.closest(t.target,"[disabled]")&&(t.preventDefault(),n.owner=r[0],n.show(t))})}},r}(t.WjDirective),m=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.InputDate},enumerable:!0,configurable:!0}),r}(n),y=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.InputDateTime},enumerable:!0,configurable:!0}),r}(m),_=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.InputNumber},enumerable:!0,configurable:!0}),r}(t.WjDirective),v=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.InputMask},enumerable:!0,configurable:!0}),r}(t.WjDirective),P=function(t){function r(e){return t.call(this,e)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.InputTime},enumerable:!0,configurable:!0}),r}(i),w=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.InputColor},enumerable:!0,configurable:!0}),r}(n),b=function(r){function n(){var e=r.call(this)||this;return e.transclude=!0,e.template="<div ng-transclude/>",e}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.input.Popup},enumerable:!0,configurable:!0}),n.prototype._initProps=function(){r.prototype._initProps.call(this),t.MetaFactory.findProp("owner",this._props).customHandler=function(e,t,r,n,i){null==e.modal&&(t.modal=!r)}},n}(t.WjDirective),j=function(t){function r(e){return t.call(this,e)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.MultiSelect},enumerable:!0,configurable:!0}),r}(i),x=function(t){function r(e){return t.call(this,e)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.input.MultiAutoComplete},enumerable:!0,configurable:!0}),r}(o),E=function(e){function t(){var t=e.call(this)||this;return t.template='<div class="wj-control wj-content wj-pager"><div class="wj-input-group"><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button" ng-click="cv.moveCurrentToFirst()" ng-disabled="cv.currentPosition <= 0"><span class="wj-glyph-left" style="margin-right:-4px"></span><span class="wj-glyph-left"></span> </button></span><span class="wj-input-group-btn"> <button class="wj-btn wj-btn-default" type="button" ng-click="cv.moveCurrentToPrevious()" ng-disabled="cv.currentPosition <= 0"><span class="wj-glyph-left"></span> </button></span><input type="text" class="wj-form-control" value=" {{cv.currentPosition + 1 | number}} / {{cv.itemCount | number}} " disabled /><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button" ng-click="cv.moveCurrentToNext()" ng-disabled="cv.currentPosition >= cv.itemCount - 1"><span class="wj-glyph-right"></span></button></span><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button" ng-click="cv.moveCurrentToLast()" ng-disabled="cv.currentPosition >= cv.itemCount - 1"><span class="wj-glyph-right"></span><span class="wj-glyph-right" style="margin-left:-4px"></span></button></span></div></div>',t}return __extends(t,e),t.prototype._getMetaDataId=function(){return"CollectionViewNavigator"},t.prototype._postLinkFn=function(){return function(e,t,r,n){}},t}(t.WjDirective),S=function(e){function t(){var t=e.call(this)||this;return t.template='<div class="wj-control wj-content wj-pager"><div class="wj-input-group"><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button"ng-click="cv.moveToFirstPage()"ng-disabled="cv.pageIndex <= 0"><span class="wj-glyph-left" style="margin-right:-4px"></span><span class="wj-glyph-left"></span></button></span><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button"ng-click="cv.moveToPreviousPage()"ng-disabled="cv.pageIndex <= 0"><span class="wj-glyph-left"></span></button></span><input type="text" class="wj-form-control" value="{{cv.pageIndex + 1 | number}} / {{cv.pageCount | number}}" disabled /><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button"ng-click="cv.moveToNextPage()"ng-disabled="cv.pageIndex >= cv.pageCount - 1"><span class="wj-glyph-right"></span></button></span><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button"ng-click="cv.moveToLastPage()"ng-disabled="cv.pageIndex >= cv.pageCount - 1"><span class="wj-glyph-right"></span><span class="wj-glyph-right" style="margin-left:-4px"></span></button></span></div></div>',t}return __extends(t,e),t.prototype._getMetaDataId=function(){return"CollectionViewPager"},t.prototype._postLinkFn=function(){return function(e,t,r,n){}},t}(t.WjDirective)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=window.angular.module("wj.chart",[]);e.chart&&e.chart.FlexChart&&(r.directive("wjFlexChart",[function(){return new o}]),r.directive("wjFlexChartAxis",[function(){return new a}]),r.directive("wjFlexChartSeries",[function(){return new h}]),r.directive("wjFlexChartLegend",[function(){return new s}]),r.directive("wjFlexChartDataLabel",[function(){return new c}]),r.directive("wjFlexPieDataLabel",[function(){return new u}]),r.directive("wjFlexChartLineMarker",[function(){return new d}]),r.directive("wjFlexChartPlotArea",[function(){return new N}]),r.directive("wjFlexChartDataPoint",[function(){return new f}]),e.chart.interaction&&(r.directive("wjFlexChartRangeSelector",[function(){return new _}]),r.directive("wjFlexChartGestures",[function(){return new v}]),r.directive("wjFlexChartChartGestures",[function(){return new v}])),e.chart.annotation&&(r.directive("wjFlexChartAnnotationLayer",[function(){return new C}]),r.directive("wjFlexChartAnnotation",[function(){return new m}])),r.directive("wjFlexPie",[function(){return new P}]),e.chart.hierarchical&&(r.directive("wjSunburst",[function(){return new w}]),r.directive("wjTreeMap",[function(){return new b}])),e.chart.radar&&(r.directive("wjFlexRadar",[function(){return new j}]),r.directive("wjFlexRadarSeries",[function(){return new x}])),e.chart.finance&&(r.directive("wjFinancialChart",[function(){return new E}]),r.directive("wjFinancialChartSeries",[function(){return new S}]),e.chart.finance.analytics&&(r.directive("wjFlexChartFibonacci",[function(){return new L}]),r.directive("wjFlexChartFibonacciArcs",[function(){return new k}]),r.directive("wjFlexChartFibonacciFans",[function(){return new R}]),r.directive("wjFlexChartFibonacciTimeZones",[function(){return new $}]),r.directive("wjFlexChartAtr",[function(){return new V}]),r.directive("wjFlexChartCci",[function(){return new G}]),r.directive("wjFlexChartRsi",[function(){return new z}]),r.directive("wjFlexChartWilliamsR",[function(){return new q}]),r.directive("wjFlexChartMacd",[function(){return new X}]),r.directive("wjFlexChartMacdHistogram",[function(){return new Y}]),r.directive("wjFlexChartStochastic",[function(){return new Z}]),r.directive("wjFlexChartBollingerBands",[function(){return new K}]),r.directive("wjFlexChartEnvelopes",[function(){return new J}]))),e.chart.analytics&&(r.directive("wjFlexChartTrendLine",[function(){return new A}]),r.directive("wjFlexChartMovingAverage",[function(){return new F}]),r.directive("wjFlexChartYFunctionSeries",[function(){return new D}]),r.directive("wjFlexChartParametricFunctionSeries",[function(){return new T}]),r.directive("wjFlexChartWaterfall",[function(){return new B}]),r.directive("wjFlexChartBoxWhisker",[function(){return new I}]),r.directive("wjFlexChartErrorBar",[function(){return new O}])),e.chart.animation&&r.directive("wjFlexChartAnimation",[function(){return new g}]));var n=function(r){function n(){var e=r.call(this)||this;return e.template="<div ng-transclude />",e.transclude=!0,e}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.chart.FlexChartBase},enumerable:!0,configurable:!0}),n.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("tooltipContent",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.tooltip.content=r)}},n}(t.WjDirective),i=function(r){function n(){return null!==r&&r.apply(this,arguments)||this}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.chart.FlexChartCore},enumerable:!0,configurable:!0}),n.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("labelContent",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.dataLabel.content=r)}},n}(n),o=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.FlexChart},enumerable:!0,configurable:!0}),r}(i),a=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChartSeries","?^wjFinancialChartSeries","?^wjFlexChart","?^wjFinancialChart","?^wjFlexRadar"],e.template='<div class="wjFlexChartAxis" />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.Axis},enumerable:!0,configurable:!0}),r.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)},r}(t.WjDirective),s=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFlexPie","?^wjSunburst","?^wjFinancialChart","?^wjFlexRadar"],e.template="<div />",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.Legend},enumerable:!0,configurable:!0}),r}(t.WjDirective),l=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFlexPie","?^wjSunburst","?^wjTreeMap"],e.template="<div />",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.DataLabelBase},enumerable:!0,configurable:!0}),r}(t.WjDirective),c=function(t){function r(){var e=t.call(this)||this;return e.require=["^wjFlexChart","?^wjTreeMap"],e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.DataLabel},enumerable:!0,configurable:!0}),r}(l),u=function(t){function r(){var e=t.call(this)||this;return e.require=["^wjFlexPie","?^wjSunburst"],e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.PieDataLabel},enumerable:!0,configurable:!0}),r}(l),p=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFinancialChart","?^wjFlexRadar"],e.template='<div class="wjSeriesBase" ng-transclude />',e.transclude=!0,e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.SeriesBase},enumerable:!0,configurable:!0}),r.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)},r.prototype._getId=function(){return"series"},r}(t.WjDirective),h=function(t){function r(){var e=t.call(this)||this;return e.require="^wjFlexChart",e.template='<div class="wjFlexChartSeries" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.Series},enumerable:!0,configurable:!0}),r}(p),d=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFinancialChart"],e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.LineMarker},enumerable:!0,configurable:!0}),r}(t.WjDirective),f=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChartAnnotation"],e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.DataPoint},enumerable:!0,configurable:!0}),r}(t.WjDirective),C=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFinancialChart"],e.template='<div class="wjFlexChartAnnotationLayer" ng-transclude />',e.transclude=!0,e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.annotation.AnnotationLayer},enumerable:!0,configurable:!0}),r}(t.WjDirective),g=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFlexPie","?^wjSunburst","?^wjFinancialChart","?^wjFlexRadar"],e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.animation.ChartAnimation},enumerable:!0,configurable:!0}),r}(t.WjDirective),m=function(e){function t(){var t=e.call(this)||this;return t.require="^wjFlexChartAnnotationLayer",t.template='<div class="wjFlexChartAnnotation" ng-transclude />',t.transclude=!0,t}return __extends(t,e),t.prototype._createLink=function(){return new y},t.prototype._getMetaDataId=function(){return"FlexChartAnnotation"},t}(t.WjDirective),y=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),r.prototype._initControl=function(){return new e.chart.annotation[this.scope.type]},r}(t.WjLink),_=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFinancialChart"],e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.interaction.RangeSelector},enumerable:!0,configurable:!0}),r}(t.WjDirective),v=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFinancialChart"],e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.interaction.ChartGestures},enumerable:!0,configurable:!0}),r}(t.WjDirective),P=function(r){function n(){return null!==r&&r.apply(this,arguments)||this}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.chart.FlexPie},enumerable:!0,configurable:!0}),n.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("labelContent",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.dataLabel.content=r)}},n}(n),w=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.hierarchical.Sunburst},enumerable:!0,configurable:!0}),r}(P),b=function(r){function n(){return null!==r&&r.apply(this,arguments)||this}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.chart.hierarchical.TreeMap},enumerable:!0,configurable:!0}),n.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("labelContent",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.dataLabel.content=r)}},n}(n),j=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.radar.FlexRadar},enumerable:!0,configurable:!0}),r}(i),x=function(t){function r(){var e=t.call(this)||this;return e.require="^wjFlexRadar",e.template='<div class="wjFlexRadarSeries" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.radar.FlexRadarSeries},enumerable:!0,configurable:!0}),r}(p),E=(function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexRadarSeries","?^wjFlexRadar"],e.template='<div class="wjFlexRadarAxis" />',e}__extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.radar.FlexRadarAxis},enumerable:!0,configurable:!0}),r.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)}}(t.WjDirective),function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.FinancialChart},enumerable:!0,configurable:!0}),r}(i)),S=function(t){function r(){var e=t.call(this)||this;return e.require="^wjFinancialChart",e.template='<div class="wjFinancialChartSeries" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.FinancialSeries},enumerable:!0,configurable:!0}),r}(p),M=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFinancialChart"],e.template='<div class="wjTrendLineBase" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.TrendLineBase},enumerable:!0,configurable:!0}),r}(p),A=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjTrendLine" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.TrendLine},enumerable:!0,configurable:!0}),r}(M),F=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjMovingAverage" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.MovingAverage},enumerable:!0,configurable:!0}),r}(M),D=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjYFunctionSeries" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.YFunctionSeries},enumerable:!0,configurable:!0}),r}(M),T=function(r){function n(){var e=r.call(this)||this;return e.template='<div class="wjParametricFunctionSeries" ng-transclude />',e}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.ParametricFunctionSeries},enumerable:!0,configurable:!0}),n.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("func",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.xFunc=r)}},n}(M),B=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFinancialChart"],e.template='<div class="wjWaterfall" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.Waterfall},enumerable:!0,configurable:!0}),r}(p),I=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart","?^wjFinancialChart"],e.template='<div class="wjBoxWhisker" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.BoxWhisker},enumerable:!0,configurable:!0}),r}(p),O=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChart"],e.template='<div class="wjErrorBar" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.ErrorBar},enumerable:!0,configurable:!0}),r}(h),N=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFlexChartPlotArea","?^wjFlexChart","?^wjFinancialChart"],e.template='<div class="wjFlexChartPlotArea" />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.PlotArea},enumerable:!0,configurable:!0}),r.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)},r}(t.WjDirective),L=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFinancialChart"],e.template='<div class="wjFlexChartFibonacci" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.Fibonacci},enumerable:!0,configurable:!0}),r.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)},r}(p),k=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFinancialChart"],e.template='<div class="wjFlexChartFibonacciArcs" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.FibonacciArcs},enumerable:!0,configurable:!0}),r.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)},r}(p),R=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFinancialChart"],e.template='<div class="wjFlexChartFibonacciFans" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.FibonacciFans},enumerable:!0,configurable:!0}),r.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)},r}(p),$=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjFinancialChart"],e.template='<div class="wjFlexChartFibonacciTimeZones" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.FibonacciTimeZones},enumerable:!0,configurable:!0}),r.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)},r}(p),H=function(t){function r(){var e=t.call(this)||this;return e.require="^wjFinancialChart",e.template='<div class="wjBaseOverlayIndicator" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.OverlayIndicatorBase},enumerable:!0,configurable:!0}),r}(p),W=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjBaseSingleOverlayIndicator" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.SingleOverlayIndicatorBase},enumerable:!0,configurable:!0}),r}(H),V=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartAtr" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.ATR},enumerable:!0,configurable:!0}),r}(W),G=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartCci" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.CCI},enumerable:!0,configurable:!0}),r}(W),z=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartRsi" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.RSI},enumerable:!0,configurable:!0}),r}(W),q=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartWilliamsR" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.WilliamsR},enumerable:!0,configurable:!0}),r}(W),U=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartBaseMacd" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.MacdBase},enumerable:!0,configurable:!0}),r}(H),X=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartMacd" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.Macd},enumerable:!0,configurable:!0}),r}(U),Y=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartMacdHistogram" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.MacdHistogram},enumerable:!0,configurable:!0}),r}(U),Z=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartStochastic" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.Stochastic},enumerable:!0,configurable:!0}),r}(H),K=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartBollingerBands" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.BollingerBands},enumerable:!0,configurable:!0}),r}(H),J=function(t){function r(){var e=t.call(this)||this;return e.template='<div class="wjFlexChartEnvelopes" ng-transclude />',e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.Envelopes},enumerable:!0,configurable:!0}),r}(H)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=window.angular.module("wj.gauge",[]);e.gauge&&e.gauge.LinearGauge&&(r.directive("wjLinearGauge",[function(){return new i}]),r.directive("wjBulletGraph",[function(){return new o}]),r.directive("wjRadialGauge",[function(){return new a}]),r.directive("wjRange",[function(){return new s}]));var n=function(t){function r(){var e=t.call(this)||this;return e.template="<div ng-transclude />",e.transclude=!0,e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.gauge.Gauge},enumerable:!0,configurable:!0}),r}(t.WjDirective),i=function(t){function r(){return t.call(this)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.gauge.LinearGauge},enumerable:!0,configurable:!0}),r}(n),o=function(t){function r(){return t.call(this)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.gauge.BulletGraph},enumerable:!0,configurable:!0}),r}(i),a=function(t){function r(){return t.call(this)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.gauge.RadialGauge},enumerable:!0,configurable:!0}),r}(n),s=function(t){function r(){var e=t.call(this)||this;return e.require=["?^wjLinearGauge","?^wjRadialGauge","?^wjBulletGraph"],e.template="<div ng-transclude />",e.transclude=!0,e._property="ranges",e._isPropertyArray=!0,e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.gauge.Range},enumerable:!0,configurable:!0}),r.prototype._initControl=function(t){return new e.gauge.Range},r}(t.WjDirective)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=window.angular.module("wj.grid",[]);e.grid&&e.grid.FlexGrid&&(r.directive("wjFlexGrid",["$compile","$interpolate",function(e,t){return new n(e,t)}]),r.directive("wjFlexGridColumn",["$compile",function(e){return new c(e)}]),r.directive("wjFlexGridCellTemplate",[function(){return new p}]),e.grid.filter&&r.directive("wjFlexGridFilter",[function(){return new d}]),e.grid.grouppanel&&r.directive("wjGroupPanel",[function(){return new f}]),e.grid.detail&&r.directive("wjFlexGridDetail",["$compile",function(e){return new C(e)}]),e.grid.sheet&&(r.directive("wjFlexSheet",["$compile","$interpolate",function(e,t){return new m(e,t)}]),r.directive("wjSheet",[function(){return new y}])),e.grid.multirow&&r.directive("wjMultiRow",["$compile","$interpolate",function(e,t){return new v(e,t)}]));var n=function(r){function n(e,t){var n=r.call(this)||this;n._$compile=e,n._$interpolate=t;return n.transclude=!0,n.template="<div ng-transclude />",n}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.grid.FlexGrid},enumerable:!0,configurable:!0}),n.prototype._createLink=function(){return new i},n.prototype._initProps=function(){var e=t.MetaFactory.findProp("childItemsPath",this._props);e.scopeBindingMode="@",e.customHandler=function(e,t,r,n,i){if(r&&(r=r.trim())&&"["===r[0]){var o=e.$parent.$eval(r);return t.childItemsPath=o,!0}return!1}},n}(t.WjDirective);t.WjFlexGrid=n;var i=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype._initControl=function(){var t=e.prototype._initControl.call(this);return new a(t,this),t},t}(t.WjLink);t.WjFlexGridLink=i;var o=e.grid&&e.grid.CellFactory;o||(e.grid={},e.grid.CellFactory=function(){});var a=function(t){function r(n,i){var o=t.call(this)||this;if(o._lastApplyTimeStamp=0,o._noApplyLag=!1,o._startingEditing=!1,o._cellStampCounter=0,o._composing=!1,o._grid=n,o._gridLink=i,o._rowHeightUpdates=new s(o),!r._templateTypes){r._templateTypes=[];for(var a in l)isNaN(a)&&r._templateTypes.push(a)}var c=o;return o._baseCf=n.cellFactory,n.cellFactory=o,o._evtInput=document.createEvent("HTMLEvents"),o._evtInput.initEvent("input",!0,!1),o._evtChange=document.createEvent("HTMLEvents"),o._evtChange.initEvent("change",!0,!1),o._evtBlur=document.createEvent("HTMLEvents"),o._evtBlur.initEvent("blur",!1,!1),n.prepareCellForEdit.addHandler(function(e,t){c._noApplyLag=!0}),n.cellEditEnded.addHandler(function(e,t){(t.range.col<0||!n.columns[t.range.col][p._getTemplContextProp(l.CellEdit)])&&(c._editChar=null),setTimeout(function(){c._noApplyLag=!1},300)}),n.beginningEdit.addHandler(function(e,t){!t.data||t.data instanceof KeyboardEvent&&!(t.data.charCode<=32)||(c._editChar=null),c._startingEditing=!0}),n.hostElement.addEventListener("keydown",function(e){c._startingEditing=!1},!0),n.hostElement.addEventListener("keypress",function(t){var r=t.charCode>32?String.fromCharCode(t.charCode):null;r&&e.closest(t.target,".wj-flexgrid")===n.hostElement&&(!n.activeEditor||c._startingEditing?c._editChar=r:c._editChar&&(c._editChar+=r))},!0),n.hostElement.addEventListener("compositionstart",function(e){c._composing=!0},!0),n.hostElement.addEventListener("compositionend",function(e){c._composing=!1},!0),o}return __extends(r,t),r.prototype.updateCell=function(t,n,i,o,a){var s=this;this._cellStampCounter=(this._cellStampCounter+1)%1e7;var c=o[r._cellStampProp]=this._cellStampCounter;o.style.overflow&&(o.style.overflow="");var u=n,h=i;a&&!a.isSingleCell&&(n=a.row,i=a.col);var d,f=this,C=t.grid,g=C.editRange,m=t.rows[n],y=m.dataItem,_=!1,v=!1,P=!1,w=!1;switch(t.cellType){case e.grid.CellType.Cell:if(g&&g.row===n&&g.col===i)d=l.CellEdit,v=P=!0;else if(m instanceof e.grid.GroupRow){var b=!((w=y instanceof e.collections.CollectionViewGroup)||m.hasChildren);i==t.columns.firstVisibleIndex?d=b?l.Cell:l.GroupHeader:(d=b?l.Cell:l.Group,v=!0)}else e.grid.detail&&e.grid.detail.DetailRow&&m instanceof e.grid.detail.DetailRow||(d=l.Cell);break;case e.grid.CellType.ColumnHeader:d=l.ColumnHeader;break;case e.grid.CellType.RowHeader:d=C.collectionView&&C.collectionView.currentEditItem===y?l.RowHeaderEdit:l.RowHeader,_=!0;break;case e.grid.CellType.TopLeft:d=l.TopLeft,_=!0;break;case e.grid.CellType.ColumnFooter:d=l.ColumnFooter,v=!0;break;case e.grid.CellType.BottomLeft:d=l.BottomLeft,_=!0}var j=!1;if(null!=d){var x=w&&d==l.GroupHeader?C.getColumn(y.groupDescription.propertyName):i>=0&&i<t.columns.length?t.columns[i]:null;if(x){var E=p._getTemplContextProp(d),S=(_?C:x)[E];if(S||(d===l.RowHeaderEdit?(d=l.RowHeader,E=p._getTemplContextProp(d),S=C[E]):d!==l.Group&&d!==l.GroupHeader||w||(d=l.Cell,E=p._getTemplContextProp(d),S=x[E])),S){var M,A=f._getCellTemplate(S.cellTemplate),F=S.cellStyle,D=S.cellClass,T=!e.isNullOrWhiteSpace(A),B=!e.isNullOrWhiteSpace(F),I=!e.isNullOrWhiteSpace(D);if(v&&(M=t.getCellData(n,i,!1)),T){var O=o.getAttribute(e.grid.FlexGrid._WJS_MEASURE),N=O&&"true"===O.toLowerCase();j=!0,P&&this._baseCf.updateCell(t,u,h,o,a,!0);var L=o[E]||{},k=L.column!==x||!L.cellScope||!L.cellScope.$root,R=P&&this._composing&&C.imeEnabled,$=L.cellScope;k&&(this._doDisposeCell(o),L.cellScope=$=S.templLink.scope.$parent.$new(),L.column=x,o[E]=L);var H=$.$row!==m||$.$col!==x||$.$item!==y||$.$value!==M;H&&f._initCellScope($,m,x,y,M);var W=S.cellLink;W||(W=S.cellLink=this._gridLink.directive._$compile('<div style="display:none"'+(B?' ng-style="'+F+'"':"")+(I?' ng-class="'+D+'"':"")+">"+A+"</div>"));var V=L.clonedElement;if(k){var G=$.$watch(function(r){if(V&&(G(),V[0].style.display="",t.cellType===e.grid.CellType.ColumnHeader||t.cellType===e.grid.CellType.TopLeft)){var n=V[0].style,i=n.outlineColor,o=n.outlineWidth;n.outlineColor="white",n.outlineWidth="0px",setTimeout(function(){n.outlineColor=i,n.outlineWidth=o},0)}});L.clonedElement=V=W($,function(e,t){})}N&&(V[0].style.display="");var z=!1;if(P){var q=o.firstElementChild;q&&(R||o.focus(),q.style.display="none")}else(z=1==o.childNodes.length)||(o.textContent="");z?V[0]!==o.firstChild&&o.replaceChild(V[0],o.firstChild):o.appendChild(V[0]),S.cellOverflow&&(o.style.overflow=S.cellOverflow);if(this._closingApplyTimeOut&&clearTimeout(this._closingApplyTimeOut),f._rowHeightUpdates.add({panel:t,cell:o,rng:a,cellStamp:c}),N||g||this._noApplyLag||H&&Date.now()-this._lastApplyTimeStamp>40?(clearTimeout(this._closingApplyTimeOut),$.$root&&!$.$root.$$phase&&$.$apply(),g||N||f._rowHeightUpdates.execute(),this._lastApplyTimeStamp=Date.now()):(clearTimeout(this._closingApplyTimeOut),this._closingApplyTimeOut=setTimeout(function(){clearTimeout(this._closingApplyTimeOut),$.$root&&!$.$root.$$phase&&$.$apply(),f._rowHeightUpdates.execute()},10)),R?P&&setTimeout(function(){R?s._initImeEditInput(L,S):s._initEditInput(L,S,null)},0):setTimeout(function(){if(f._updateRowHeight(t,o,a,c)){if(P){f._rowHeightUpdates.clear();var e=f._isFullEdit();return C.refresh(),void C.startEditing(e)}}else P&&f._initEditInput(L,S,null)},0),P){f._cellEditorScope=$;var U=function(r,a){if(C.cellEditEnding.removeHandler(U),!a.stayInEditMode){var s=e.getActiveElement();s&&s.dispatchEvent(f._evtBlur),o.focus()}a.cancel||a.stayInEditMode||(a.cancel=!0,t.grid.setCellData(n,i,$.$value));var l=o.querySelectorAll(".wj-dropdown");[].forEach.call(l,function(t){var r=e.Control.getControl(t);r&&r instanceof e.input.DropDown&&(r.isDroppedDown=!1)})};C.cellEditEnding.addHandler(U),C.cellEditEnded.addHandler(function(){f._cellEditorScope=null})}else this._baseCf.updateCell(t,u,h,o,a,!1)}}}}if(j||(this._doDisposeCell(o),this._baseCf.updateCell(t,u,h,o,a)),!T&&(B||I)){var X=f._initCellScope({},m,x,y,M),Y=B?this._gridLink.scope.$parent.$eval(F,X):null,Z=I?this._gridLink.scope.$parent.$eval(D,X):null;if(Y||Z){for(var K=document.createElement("div");o.firstChild;)K.appendChild(o.firstChild);if(o.appendChild(K),Y)for(var J in Y)K.style[J]=Y[J];if(Z){for(var Q=e.isArray(Z)?Z:[Z],ee="",te=0;te<Q.length;te++){var re=Q[te];if(re)if(e.isString(re))ee+=" "+re;else for(var ne in re)re[ne]&&(ee+=" "+ne)}K.className=ee}}}},r.prototype.getEditorValue=function(e){return this._cellEditorScope?this._cellEditorScope.$value:t.prototype.getEditorValue.call(this,e)},r.prototype.disposeCell=function(e){this._doDisposeCell(e)},r.prototype._doDisposeCell=function(e){for(var t=r._templateTypes,n=0;n<t.length;n++){var i=p._getTemplContextProp(l[t[n]]),o=e[i];o&&o.cellScope&&o.cellScope.$root&&(o.cellScope.$destroy(),o.clonedElement&&(o.clonedElement.remove(),o.clonedElement=null),e[i]=null)}},r.prototype._updateRowHeight=function(e,t,n,i){var o=t.scrollHeight,a=e.rows,s=n&&n.rowSpan||1;return i===t[r._cellStampProp]&&a.defaultSize*s<o&&(a.defaultSize=o/s,!0)},r.prototype._initCellScope=function(e,t,r,n,i){return e.$row=t,e.$col=r,e.$item=n,e.$value=i,e},r.prototype._getCellTemplate=function(e){return e&&(e=(e=(e=e.replace(/ class\=\"ng\-scope\"( \"ng\-binding\")?/g,"")).replace(/<span>\s*<\/span>/g,"")).trim()),e},r.prototype._isFullEdit=function(){var e=this._grid;return!e.activeEditor||e._edtHdl._fullEdit},r.prototype._setFullEdit=function(e){var t=this._grid;e.forceFullEdit&&t.activeEditor&&(t._edtHdl._fullEdit=!0)},r.prototype._initEditInput=function(t,n,i){var o=this;this._setFullEdit(n);var a=this._findInitialInput(t);if(a){var s=function(){a.removeEventListener("focus",s),setTimeout(function(){var t=null!=i?i:o._editChar;t&&(a.value=t,o._editChar=null,r._setSelectionRange(a,t.length,t.length),!r.isNgIE||e.hasClass(a,"wj-form-control")||a.getAttribute("wj-part")?a.dispatchEvent(o._evtInput):a.dispatchEvent(o._evtChange))},r._FOCUS_INTERVAL)};a.addEventListener("focus",s),a.focus()}},r.prototype._initImeEditInput=function(t,r){var n=this,i=e.getActiveElement();if(i&&i instanceof HTMLInputElement&&e.hasClass(i,"wj-grid-ime")){var o=function(a){i.removeEventListener("compositionend",o),e.setCss(i,e.grid._ImeHandler._cssHidden),n._initEditInput(t,r,i.value)};i.addEventListener("compositionend",o);var a=this._findInitialInput(t);if(a){var s=a.getBoundingClientRect(),l=i.getBoundingClientRect(),c=window.getComputedStyle(i),u=parseFloat(c.left),p=parseFloat(c.top);e.setCss(i,{left:u+s.left-l.left+"px",top:p+s.top-l.top+"px",width:s.width+"px",height:s.height+"px"})}}},r.prototype._findInitialInput=function(e){var t=e.clonedElement[0].querySelectorAll("input,textarea");if(t)for(var r=0;r<t.length;r++){var n=t[r],i=window.getComputedStyle(n);if("none"!==i.display&&"visible"===i.visibility)return n}return null},r._setSelectionRange=function(t,r,n){if(void 0===n&&(n=r),e.contains(document.body,t)&&!t.disabled&&"none"!=t.style.display)try{t.setSelectionRange(e.asNumber(r),e.asNumber(n),e.isIE()?null:"backward"),t.focus()}catch(e){}},r._cellStampProp="__wjCellStamp",r._FOCUS_INTERVAL=e.Control._FOCUS_INTERVAL+20,r.isNgIE=!!document.documentMode,r}(e.grid.CellFactory),s=function(){function e(e){this._requests=[],this._timeOuts=[],this._cellFactory=e}return e.prototype.add=function(e){this._requests.push(e)},e.prototype.execute=function(){for(var e=this._requests;e.length>0;){var t=this,r=function(e){return setTimeout(function(){if(t._cellFactory._updateRowHeight(e.panel,e.cell,e.rng,e.cellStamp))t.clear();else{var n=t._timeOuts.indexOf(r);n>-1&&t._timeOuts.splice(n,1)}},0)}(this._requests.shift());this._timeOuts.push(r)}},e.prototype.clear=function(){this._requests.splice(0,this._requests.length),this._clearTimeouts()},e.prototype._clearTimeouts=function(){for(var e=this._timeOuts,t=0;t<e.length;t++)clearTimeout(e[t]);e.splice(0,e.length)},e}();o||(e.grid=null);var l,c=function(r){function n(e){var i=r.call(this)||this;return i._$compile=e,i.scope.dataMap+="map",i.scope.dataType+="type",i.require="^wjFlexGrid",i.terminal=!0,t.WjDirective._dynaTemplates?(i.transclude=!1,i.priority=100,i.template=function(e,t){return t[n._colTemplateProp]=e[0].innerHTML,'<div class="wjGridColumn"/>'}):(i.transclude=!0,i.template='<div class="wjGridColumn" ng-transclude/>'),i}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.grid.Column},enumerable:!0,configurable:!0}),n.prototype._initControl=function(t){return new e.grid.Column},n.prototype._createLink=function(){return new u},n._colTemplateProp="$__wjColTemplate",n._colWjLinkProp="$__wjLink",n._cellCtxProp="$_cellCtxProp",n}(t.WjDirective),u=function(r){function n(){return null!==r&&r.apply(this,arguments)||this}return __extends(n,r),n.prototype._initParent=function(){var e=this.parent.control;e.autoGenerateColumns&&(e.autoGenerateColumns=!1,this._safeApply(this.scope,"autoGenerateColumns",!1),e.columns.clear()),r.prototype._initParent.call(this);var t=p._getTemplContextProp(l.Cell),n=this.control[t],i=this[c._cellCtxProp];!n&&i&&(this.control[t]=i),this.control[c._colWjLinkProp]=this},n.prototype._link=function(){var n=this.tElement[0],i=this.tAttrs[c._colTemplateProp],o=null!=i?i:t.WjDirective._removeTransclude(n.innerHTML),a={};if(!e.isNullOrWhiteSpace(o)){var s=document.createElement("div");s.innerHTML=o;var l=[];[].forEach.call(s.children,function(e){l.push(e)});for(var u,h=0;h<l.length;h++){var d=l[h];d.tagName.toLocaleLowerCase()===p._tagName&&(u||(u=this.scope.$parent.$new()),s.removeChild(d),n.appendChild(d),this.directive._$compile(d)(u))}var f=s.innerHTML;e.isNullOrWhiteSpace(f)||(a.cellTemplate=f)}var C=this.tAttrs.ngStyle,g=this.tAttrs.ngClass;C&&(a.cellStyle=C),g&&(a.cellClass=g),(a.cellTemplate||a.cellStyle||a.cellClass)&&(a.templLink=this,this[c._cellCtxProp]=a),r.prototype._link.call(this)},n}(t.WjLink);!function(e){e[e.Cell=0]="Cell",e[e.CellEdit=1]="CellEdit",e[e.ColumnHeader=2]="ColumnHeader",e[e.RowHeader=3]="RowHeader",e[e.RowHeaderEdit=4]="RowHeaderEdit",e[e.TopLeft=5]="TopLeft",e[e.GroupHeader=6]="GroupHeader",e[e.Group=7]="Group",e[e.ColumnFooter=8]="ColumnFooter",e[e.BottomLeft=9]="BottomLeft"}(l=t.CellTemplateType||(t.CellTemplateType={}));var p=function(e){function r(){var r=e.call(this)||this;return r.require=["?^wjFlexGridColumn","?^wjFlexGrid"],r.terminal=!0,t.WjDirective._dynaTemplates?(r.transclude=!1,r.priority=100,r.template=function(e,t){return t[c._colTemplateProp]=e[0].innerHTML,"<div />"}):(r.transclude=!0,r.template="<div ng-transclude/>"),r}return __extends(r,e),r._getTemplContextProp=function(e){return"$__cellTempl"+l[e]},r.prototype._initControl=function(e){return{}},r.prototype._createLink=function(){return new h},r.prototype._getMetaDataId=function(){return"FlexGridCellTemplate"},r._tagName="wj-flex-grid-cell-template",r}(t.WjDirective),h=function(r){function n(){return null!==r&&r.apply(this,arguments)||this}return __extends(n,r),n.prototype._initParent=function(){r.prototype._initParent.call(this);var i,o=this.scope.cellType;if(o){i=l[o];var a=this.tAttrs[c._colTemplateProp],s=null!=a?a:t.WjDirective._removeTransclude(this.tElement[0].innerHTML),u=this.control;e.isNullOrWhiteSpace(s)||(u.cellTemplate=s);var h=this.tAttrs.ngStyle,d=this.tAttrs.ngClass;if(h&&(u.cellStyle=h),d&&(u.cellClass=d),this.tAttrs.forceFullEdit||(u.forceFullEdit=!0),u.cellTemplate||u.cellStyle||u.cellClass){u.templLink=this;var f=this.parent.control;f[p._getTemplContextProp(i)]=u,f instanceof e.grid.Column&&f._setFlag(e.grid.RowColFlags.HasTemplate,!0)}n._invalidateGrid(this.parent.control)}},n.prototype._destroy=function(){var e=this.parent&&this.parent.control,t=this.scope.cellType;r.prototype._destroy.call(this),t&&(e[p._getTemplContextProp(l[t])]=void 0,n._invalidateGrid(e))},n._invalidateGrid=function(t){var r=t;r&&(r instanceof e.grid.Column&&(r=r.grid),r&&r.invalidate())},n}(t.WjLink),d=function(t){function r(){var e=t.call(this)||this;return e.require="^wjFlexGrid",e.template="<div />",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.grid.filter.FlexGridFilter},enumerable:!0,configurable:!0}),r}(t.WjDirective),f=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.grid.grouppanel.GroupPanel},enumerable:!0,configurable:!0}),r}(t.WjDirective),C=function(r){function n(e){var i=r.call(this)||this;return i._$compile=e,i.require="^wjFlexGrid",i.terminal=!0,t.WjDirective._dynaTemplates?(i.transclude=!1,i.priority=100,i.template=function(e,t){return t[n._detailTemplateProp]=e[0].innerHTML,"<div />"}):(i.transclude=!0,i.template="<div ng-transclude/>"),i}return __extends(n,r),Object.defineProperty(n.prototype,"_controlConstructor",{get:function(){return e.grid.detail.FlexGridDetailProvider},enumerable:!0,configurable:!0}),n.prototype._createLink=function(){return new g},n._detailTemplateProp="$__wjDetailTemplate",n._detailScopeProp="$_detailScope",n}(t.WjDirective),g=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return __extends(r,e),r.prototype._initParent=function(){e.prototype._initParent.call(this);var r=this,n=this.tAttrs[C._detailTemplateProp],i=this.control;this.itemTemplate=this._getCellTemplate(null!=n?n:t.WjDirective._removeTransclude(this.tElement[0].innerHTML));var o=this._getCellTemplate(this.itemTemplate);this._tmplLink=this.directive._$compile("<div>"+o+"</div>"),i.createDetailCell=function(e,n){var o=r._getCellScope(r.scope.$parent,e,n),a=r._tmplLink(o,function(e,t){})[0];return a[t.WjDirective._elemScopeProp]=o,i.grid.hostElement.appendChild(a),o.$root&&!o.$root.$$phase&&o.$apply(),a.parentElement.removeChild(a),a},i.disposeDetailCell=function(e){if(e.detail){var r=e.detail[t.WjDirective._elemScopeProp];r&&r.$destroy()}},this.parent._isInitialized&&this.control&&this.control.invalidate()},r.prototype._destroy=function(){var t=this.parent&&this.parent.control,r=this.control;r.createDetailCell=null,r.disposeDetailCell=null,e.prototype._destroy.call(this),this._tmplLink=null,t&&t.invalidate()},r.prototype._getCellScope=function(e,t,r){var n=e.$new();return n.$row=t,n.$col=r,n.$item=t.dataItem,n},r.prototype._getCellTemplate=function(e){return e&&(e=(e=(e=e.replace(/ng\-style/g,"style")).replace(/ class\=\"ng\-scope\"( \"ng\-binding\")?/g,"")).replace(/<span>\s*<\/span>/g,"")),e},r}(t.WjLink),m=function(t){function r(e,r){return t.call(this,e,r)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.grid.sheet.FlexSheet},enumerable:!0,configurable:!0}),r}(n),y=function(t){function r(){var e=t.call(this)||this;return e.require="^wjFlexSheet",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.grid.sheet.Sheet},enumerable:!0,configurable:!0}),r.prototype._createLink=function(){return new _},r}(t.WjDirective),_=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype._initControl=function(){var t=e.prototype._initControl.call(this),r=this.scope,n=this.parent.control;return t.name=r.name,r.itemsSource?t.itemsSource=r.itemsSource:(t.rowCount=+r.rowCount,t.columnCount=+r.columnCount),n.sheets.push(t),t.selectionRanges.push(n.selection),t},t}(t.WjLink),v=function(t){function r(e,r){return t.call(this,e,r)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.grid.multirow.MultiRow},enumerable:!0,configurable:!0}),r}(n)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=window.angular.module("wj.olap",["wj.grid","wj.chart"]);e.olap&&e.olap.PivotGrid&&(r.directive("wjPivotGrid",["$compile","$interpolate",function(e,t){return new n(e,t)}]),r.directive("wjPivotChart",[function(){return new i}]),r.directive("wjPivotPanel",[function(){return new o}]));var n=function(t){function r(e,r){return t.call(this,e,r)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.olap.PivotGrid},enumerable:!0,configurable:!0}),r}(t.WjFlexGrid);t.WjPivotGrid=n;var i=function(t){function r(){return null!==t&&t.apply(this,arguments)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.olap.PivotChart},enumerable:!0,configurable:!0}),r}(t.WjDirective);t.WjPivotChart=i;var o=function(t){function r(){var e=t.call(this)||this;return e.transclude=!0,e.template="<div ng-transclude />",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.olap.PivotPanel},enumerable:!0,configurable:!0}),r}(t.WjDirective);t.WjPivotPanel=o}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=window.angular.module("wj.viewer",[]);e.viewer&&e.viewer.ReportViewer&&r.directive("wjReportViewer",[function(){return new i}]),e.viewer&&e.viewer.PdfViewer&&r.directive("wjPdfViewer",[function(){return new o}]);var n=function(t){function r(){var e=t.call(this)||this;return e.template="<div ng-transclude />",e.transclude=!0,e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.viewer.ViewerBase},enumerable:!0,configurable:!0}),r}(t.WjDirective),i=function(t){function r(){return t.call(this)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.viewer.ReportViewer},enumerable:!0,configurable:!0}),r}(n),o=function(t){function r(){return t.call(this)||this}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.viewer.PdfViewer},enumerable:!0,configurable:!0}),r}(n)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var __extends=this&&this.__extends||function(){var e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),wijmo;!function(e){!function(t){var r=window.angular.module("wj.nav",[]);e.nav&&(r.directive("wjTreeView",[function(){return new n}]),r.directive("wjTabPanel",[function(){return new i}]),r.directive("wjTab",[function(){return new a}]));var n=function(t){function r(){var e=t.call(this)||this;return e.transclude=!0,e.template="<div ng-transclude />",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.nav.TreeView},enumerable:!0,configurable:!0}),r}(t.WjDirective),i=function(t){function r(){var e=t.call(this)||this;return e.transclude=!0,e.template="<div ng-transclude />",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.nav.TabPanel},enumerable:!0,configurable:!0}),r.prototype._initControl=function(t){var r=new e.nav.TabPanel(t,null,!0);return r.tabs.beginUpdate(),r},r.prototype._createLink=function(){return new o},r}(t.WjDirective),o=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype._onChildrenReady=function(){e.prototype._onChildrenReady.call(this);var t=this.control;t.tabs.endUpdate(),t.selectedIndex<0&&t.tabs.length&&(t.selectedIndex=0)},t}(t.WjLink),a=function(t){function r(){var e=t.call(this)||this;return e.transclude=!0,e.template="<div ng-transclude />",e.require="^wjTabPanel",e}return __extends(r,t),Object.defineProperty(r.prototype,"_controlConstructor",{get:function(){return e.nav.Tab},enumerable:!0,configurable:!0}),r.prototype._initControl=function(t){return new e.nav.Tab(t.children[0],t.children[1])},r}(t.WjDirective)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));var wijmo;!function(e){e.angular||(e.angular={}),window.angular.module("wj",["wj.input","wj.grid","wj.chart","wj.container","wj.gauge","wj.olap","wj.viewer","wj.nav"])}(wijmo||(wijmo={}));
/**
 *  UtilityService.js
 *  Reusable utilities/toolkits
 *  by rcnet
 *  4.12.2016
 */
(function() {
    'use strict';

    angular.module('app.corelib')
        .service('utils', utilityService);

    function utilityService(
        moment,
        alasql,
        $q, _,
        $translate,
        localisationService
    ) {
        var self = this;

        // Lazy loaded
        self.localeSettings = function() {
            return localisationService.getLocaleFormatSettings();
        };

        self.activate = function() {

            // Perform library extension here !!!

            // --------------------
            // HashCode generator
            // --------------------
            String.prototype.hashCode = function() {
                var hash = 0,
                    i, chr, len;
                if (this.length === 0) return hash;
                for (i = 0, len = this.length; i < len; i++) {
                    chr = this.charCodeAt(i);
                    hash = ((hash << 5) - hash) + chr;
                    hash |= 0; // Convert to 32bit integer
                }
                return hash;
            };

            // ----------------------------------
            //  Format date extension for AlaSql
            // ----------------------------------
            if (alasql) {
                alasql.fn.formatDate = function(dateStr, fmt) {
                    var date = moment(dateStr).format(fmt);
                    return date;
                };

                // Converts to date object first
                alasql.fn.formatDate2 = function(dateStr, fmt) {
                    return moment(dateStr, 'YYYY-MM-DD').format(fmt);
                    // let dt = new Date(dateStr);
                    // var date = moment(dt).format(fmt);
                    //return date;
                }
            }
        }

        self.activate();

        self.translate = function(word, params) {
            // params (optional) are interpolation values for {{placeholders}} in the translation.
            return $translate.instant(word, params);
        };

        self.newGuid = function() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
            });
            return uuid;
        };

        self.shuffleArray = function(arr) {
            return arr.map(function(a) {
                return [Math.random(), a];
            }).sort(function(a, b) {
                return a[0] - b[0];
            }).map(function(a) {
                return a[1];
            });
        };

        self.isUndefinedOrNull = function(val) {
            return angular.isUndefined(val) || val === null;
        };

        function distinct(objectArray) {

            var distinctResult = [];

            $.each(objectArray, function(i, currentObject) {
                if (!exists(distinctResult, currentObject))
                    distinctResult.push(currentObject);
            });

            return distinctResult;
        }

        function exists(arr, object) {
            var compareToJson = JSON.stringify(object),
                result = false;
            $.each(arr, function(i, existingObject) {
                if (JSON.stringify(existingObject) === compareToJson) {
                    result = true;
                    return false; // break
                }
            });

            return result;
        }

        /**
         * Todo: Remove this not specific to generic helper library
         * This should be in the service class
         */
        self.getBranchSkills = function(branches, skillGroups) {
            let formattedSkills = [];

            angular.forEach(branches, function(branch) {
                angular.forEach(skillGroups, function(skillGroup) {
                    angular.forEach(skillGroup.Skills, function(skill) {
                        angular.forEach(skill.SkillBranches, function(skillBranch) {
                            if (skillBranch.Id === branch.id) {
                                formattedSkills.push({
                                    Id: skill.id,
                                    Name: skill.SkillName
                                })
                            }
                        });
                    });
                });
            });

            const uniqueSkills = distinct(formattedSkills);

            return alasql('select * from ? order by Name', [uniqueSkills]);
        }

        self.isNullOrEmpty = function(val) {
            return angular.isUndefined(val) || val === null || val.length === 0;
        };

        self.currentDate = function() {
            var format = self.localeSettings().dateFormat;
            return moment(new Date()).format(format).toUpperCase();
        };

        /**
         * Respects User Preference (Date Setting in account)
         */
        self.displayDate = function(date) {
            var settings = self.localeSettings();
            var format = settings.displayDateFormat;

            // Todo: Fix issue here if user has selected a date preference format !!!!! - rcnet
            if (date == '' || date == undefined || date == null || moment(date).format(format).toUpperCase() == settings.minDate) {
                return "";
            }

            return moment(date).format(format).toUpperCase();
        };

        /**
         * JsDate
         * Returns date format: YYYY-MM-DD
         */
        self.jsDate = function(date) {
            var settings = self.localeSettings();
            if (date == '' || date == undefined || date == null || moment(date).format(settings.dateFormat).toUpperCase() == settings.minDate) {
                return "";
            }

            return moment(date).format('YYYY-MM-DD').toUpperCase();
        };

        self.datePickerFormatDate = function(date) {
            var settings = self.localeSettings();
            if (!date || moment(date).format(settings.dateFormat).toUpperCase() == settings.minDate) {
                return "";
            }

            return moment(date).format(settings.shortdateFormatWithSlash).toUpperCase();
        };

        self.datePickerFormatDate2 = function(date, includeTime) {
            var settings = self.localeSettings();
            if (!date || moment(date).format(settings.dateFormat).toUpperCase() == settings.minDate) {
                return "";
            }

            let fmt = includeTime === true ? settings.dateTimeFormatWithSlash : settings.shortdateFormatWithSlash;
            return moment(date).format(fmt).toUpperCase();
        };

        self.jsDateTime = function(date, inputFormat) {
            var settings = self.localeSettings();

            if (!inputFormat) {
                if (date == '' || date == undefined || date == null || moment(date).format(settings.dateFormat).toUpperCase() == settings.minDate)
                    return "";
                return moment(date).format(settings.isoDateTime).toUpperCase();
            } else {
                if (date == '' || date == undefined || date == null || moment(date, inputFormat).format(settings.dateFormat).toUpperCase() == settings.minDate)
                    return "";
                return moment(date, inputFormat).format(settings.isoDateTime).toUpperCase();
            }
        };

        self.jsDateTime2 = function(date) {
            var settings = self.localeSettings();
            if (date == '' || date == undefined || date == null || moment(date).format(settings.dateFormat).toUpperCase() == settings.minDate) {
                return "";
            }
            return moment(date).format(settings.isoDateTimeWithSlash).toUpperCase();
        };

        self.jsTime = function(date, fmt) {
            var settings = self.localeSettings();
            if (date == '' || date == undefined || date == null || moment(date).format(settings.dateFormat).toUpperCase() == settings.minDate) {
                return "";
            }
            return moment(date, settings.isoDateTime).format(fmt ? fmt : 'HH:mm:ss').toUpperCase();
        };

        self.isoDateFormat = function() {
            return self.localeSettings().isoDateTime;
        };

        self.currentTime = function() {
            return moment(new Date()).format('HH:mm').toUpperCase();
        };

        self.compareStrings = function(string1, string2) {
            return string1.toLowerCase() === string2.toLowerCase();
        };

        self.validEmailAddress = function(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        };

        self.moneyFormat = function(number, decimalPlaces) {
            var parsedNumber = number;

            var decimalPadding = function() {
                var tNum = ".";
                if (decimalPlaces > 0) {
                    for (var i = 0; i < decimalPlaces; i++) {
                        tNum += "0";
                    }
                } else {
                    tNum += "00";
                }
                return tNum;
            }

            if (!number || isNaN(number)) return "0" + decimalPadding();

            if (decimalPlaces > 0) {
                parsedNumber = number.toFixed(decimalPlaces);
            }

            var arr = parsedNumber.toString().split('.');

            var result = arr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            result += arr.length > 1 ? "." + arr[1] : decimalPadding();

            return result;
        };

        self.toNumber = function(num) {
            if (!num) return 0;

            var isNegative = num.indexOf('(') > -1;
            var tNum = parseFloat(num.replace(')', '').replace('(', '').replace(',', ''));
            if (isNegative) {
                tNum *= -1;
            }

            return tNum;
        };

        self.random = function(num) {
            return Math.floor((Math.random() * num) + 1);
        };

        self.objectSanitize = function(obj) {
            return angular.fromJson(angular.toJson(obj));
        };


        /**
         * @desc Accepts DateTime parameter
         * @jsDateTime - DateTime object or string
         * @format - output format
         *
         */
        self.epochToJsDateTime = function(unixtime, format) {
            var settings = self.localeSettings();
            var fmt = format ? format : settings.isoDateTimeWithSlash; //'YYYY/MM/DD hh:mm:ss';
            if (unixtime === -2147483648 || !unixtime)
                return null;

            // Apply server date format 'MM/DD/YYYY HH:mm' together with Unix time
            var dt = moment(moment.unix(unixtime), settings.isoDateTime).format(settings.isoDateTime);
            //var result = _toLocalDateTime(dt, fmt);

            return (format ? moment(dt).format(fmt) : moment(dt).toDate());
        };

        /**
         * @desc Accepts DateTime parameter
         * @jsDateTime - DateTime object or string
         * @inputFormat - actual format/mask of the input date supplied (depends on the format locality)
         *
         */
        self.jsDateTimeToEpoch = function(jsDateTime, inputFormat) {
            var settings = self.localeSettings();
            // TODO: Create UTC detection if input is already converted to utc counterpart
            let fmt = inputFormat ? inputFormat : settings.serverDefaultDateFormat; //'MM/DD/YYYY HH:mm:ss';
            let result;
            //var m = moment(new Date(jsDateTime)).format('YYYY-MM-DD HH:mm:ss');
            //var m = _toUtcDateTime(jsDateTime, fmt);

            if (Object.prototype.toString.call(jsDateTime) === '[object Date]') {
                //result = moment.utc(jsDateTime).format('YYYY-MM-DD HH:mm:ss');
                result = moment(jsDateTime).format(settings.isoDateTime); //'YYYY-MM-DD HH:mm:ss');
            } else {
                result = moment(jsDateTime, fmt).format(settings.isoDateTime);
                //result = moment(new Date(jsDateTime)).format('YYYY-MM-DD HH:mm:ss');
                //result = moment.utc(dt).format('YYYY-MM-DD HH:mm:ss');
            }

            // Convert to server date format
            var epoch = moment(result, settings.isoDateTime).unix();
            return epoch;
        };

        /**
         * @desc Converts Local to UTC date time.
         *
         * usage:
         *        utils.localToUtcDateTime('5/26/2016 09:37');
         *        utils.localToUtcDateTime('5/26/2016 09:37', { inputFormat: 'MM/DD/YYYY hh:mm:ss' } );
         *        utils.localToUtcDateTime('5/26/2016 09:37', { inputFormat: 'MM/DD/YYYY hh:mm:ss', outputFormat: 'MM/DD/YYYY hh:mm:ss' } );
         */
        self.localToUtcDateTime = function(jsDateTime, options) {
            let defaults = {
                inputFormat: self.localeSettings().isoDateTime, //'YYYY-MM-DD hh:mm:ss',
                outputFormat: null
            };

            let opts = angular.extend({}, defaults, options);
            // From local date to UTC datetime
            let result = opts.outputFormat ? moment(jsDateTime, opts.inputFormat).utc().format(opts.outputFormat) :
                moment(jsDateTime, opts.inputFormat).utc().format();
            return result;
        }

        /**
         * @desc Converts UTC to Local date time.
         *
         * usage:
         *        utils.utcToLocalDateTime('5/26/2016 09:37');
         *        utils.utcToLocalDateTime('5/26/2016 09:37', { inputFormat: 'MM/DD/YYYY hh:mm:ss' } );
         *        utils.utcToLocalDateTime('5/26/2016 09:37', { inputFormat: 'MM/DD/YYYY hh:mm:ss', outputFormat: 'MM/DD/YYYY hh:mm:ss' } );
         */
        self.utcToLocalDateTime = function(jsDateTime, options) {
            let defaults = {
                inputFormat: self.localeSettings().isoDateTimeWithSlash, // 'YYYY/MM/DD hh:mm:ss',
                outputFormat: null
            };

            let opts = angular.extend({}, defaults, options);

            // From UTC datetime to Local format
            let result = opts.outputFormat ? moment.utc(jsDateTime, opts.inputFormat).local().format(opts.outputFormat) :
                moment.utc(jsDateTime, opts.inputFormat).local().format();

            return result;
        }

        /**
         * @desc Identify if d (date) is in range between start and end.
         * @param {*} d
         * @param {*} start
         * @param {*} end
         */
        self.dateInRange = function(d, start, end) {
            // Checks if date in d is between dates in start and end.
            // Returns a boolean or NaN:
            //    true  : if d is between start and end (inclusive)
            //    false : if d is before start or after end
            //    NaN   : if one or more of the dates is illegal.
            // NOTE: The code inside isFinite does an assignment (=).
            return (
                isFinite(d = convert(d).valueOf()) &&
                isFinite(start = convert(start).valueOf()) &&
                isFinite(end = convert(end).valueOf()) ?
                start <= d && d <= end :
                NaN
            );
        }

        /**
         * @desc Get last day of month
         * @param {*} dt
         */
        self.getLastDayOfMonth = function(dt) {
            return new Date(dt.year(), dt.month() + 1, 0, 23, 59, 59);
            //return new Date(dt.getFullYear(), dt.getMonth() + 1, 0, 23, 59, 59);
        }

        /**
         * @desc Convert d param to Date object
         * @param {*} d
         */
        self.convert = function(d) {
            // Converts the date in d to a date-object. The input can be:
            //   a date object: returned without modification
            //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
            //   a number     : Interpreted as number of milliseconds
            //                  since 1 Jan 1970 (a timestamp)
            //   a string     : Any format supported by the javascript engine, like
            //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
            //  an object     : Interpreted as an object with year, month and date
            //                  attributes.  **NOTE** month is 0-11.
            return (
                d.constructor === Date ? d :
                d.constructor === Array ? new Date(d[0], d[1], d[2]) :
                d.constructor === Number ? new Date(d) :
                d.constructor === String ? new Date(d) :
                typeof d === "object" ? new Date(d.year, d.month, d.date) :
                NaN
            );
        }

        self.isNull = function(obj, replacementValue) {
            return self.isUndefinedOrNull(obj) ? replacementValue : obj;
        };

        self.cutString = function(obj, num, addition) {
            return obj.substring(0, num).concat(addition);
        }

        self.createGuid = function() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        /**
         * Splits a Pascal-Case word into individual words separated by spaces.
         * @param {Object} word
         * @returns {String}
         */
        self.pascalCaseToSentence = function(word) {
            var wordRegEx = /($[a-z])|[A-Z][^A-Z]+/g;
            return word.match(wordRegEx).join(" ");
        }

        /**
         * Get File name extension
         */
        self.getFileExtension = function(fileName) {
            var extensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/
            var ext = fileName.match(extensionPattern)[0];
            return ext.toLowerCase();
        }

        /**
         * Gives the correct Ordinal (1st, 2nd, 3rd etc...)
         * Pass the number then it will return the correct ordinal
         */
        self.getGetOrdinal = function(n) {
            var s = ["th", "st", "nd", "rd"],
                v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        }

        self.setDateFormat = function() {
            return self.localeSettings().shortdateFormatWithSlash;
        }

        self.getCleanedTime = function(time, displayAs24HourTime) {

            if (time === "" || time === '') {
                return null;
            }

            var regex1 = /^([01]?[0-9]|2[0-3])\ *[\ \.:-]\ *([0-5][0-9]|[0-5])\ *([apAP][mnMN])*/m;
            var regex2 = /^([01]?[0-9]|2[0-3])([0-5][0-9]|[0-5])*\ *([apAP][mnMN])*/m;

            var hasTime = false;
            var match;
            var hours = 0;
            var mins = 0;
            if (!time) {
                return;
            }
            if (time.length === 2) {
                if (time[1].toLowerCase() === 'a' || time[1].toLowerCase() === 'p') {
                    hours = parseInt(time[0]);

                    if (time[1].toLowerCase() === 'p')
                        hours += 12;
                } else
                    hours = parseInt(time);

                if (hours === 24) {
                    hours = 0;
                    hasTime = true;
                } else if (hours > 0 && hours <= 23)
                    hasTime = true;
            } else if (time.length === 4) {
                if (time[3].toLowerCase() === 'a' || time[3].toLowerCase() === 'p') {
                    hours = parseInt(time[0]);

                    if (time[3].toLowerCase() === 'p')
                        hours += 12;

                    mins = parseInt(time[1] + time[2]);
                } else {
                    hours = parseInt(time[0] + time[1]);
                    mins = parseInt(time[2] + time[3]);
                }

                if (hours === 24) {
                    hours = 0;
                    hasTime = true;
                } else if (hours > 0 && hours <= 23)
                    hasTime = true;

                if (mins < 0 || mins > 59)
                    mins = 0;
            }

            if (!hasTime && regex1.test(time)) {
                match = regex1.exec(time);
                hours = parseInt(match[1]);

                mins = match[2].length === 1 && match[2][0] !== '0' ? parseInt(match[2]) * 10 : parseInt(match[2]);

                if (match[3] !== undefined && (match[3].toLowerCase() === 'pm' || match[3].toLowerCase() === 'pn') && hours < 12)
                    hours += 12;

                hasTime = true;
            } else if (!hasTime && regex2.test(time)) {
                match = regex2.exec(time);

                if (match[1].length === 1) {
                    hours = parseInt(match[1]);
                    hasTime = true;
                } else if (match[1].length === 2) {
                    hours = parseInt(match[1]);
                    hasTime = true;
                }

                if (match[2] !== undefined && match[2].length === 2) {
                    mins = parseInt(match[2]);
                    hasTime = true;
                }

                if (match[3] !== undefined && (match[3].toLowerCase() === 'pm' || match[3].toLowerCase() === 'pn') && hours < 12)
                    hours += 12;
            }

            var formatted_time = null;

            if (hasTime) {
                formatted_time = hasTime ? (displayAs24HourTime ? (hours < 10 ? "0" : "") + hours + ":" + (mins < 10 ? "0" : "") + mins : (hours > 12 ? hours - 12 : hours) + ":" + (mins >= 10 ? mins : "0" + mins) + (hours >= 12 ? " pm" : " am")) : time;
            }

            return formatted_time;
        }

        self.getDistance = function(origins, destinations, mode) {
            var service = new google.maps.DistanceMatrixService();
            var defer = $q.defer();
            var req = {
                origins: origins,
                destinations: destinations,
                travelMode: mode
            }
            service.getDistanceMatrix(req, callback, callback2);

            function callback(resp) {
                defer.resolve(resp);
            }

            function callback2(err) {
                defer.reject(err);
            }
            return defer.promise;
        }

        self.computeLengthofShift = function(StartDate, EndDate) {
            return ((new Date(EndDate).getTime() - new Date(StartDate).getTime()) / (1000 * 60 * 60)).toFixed(0);
        }

        self.noOfHours = function(StartDate) {
            var inputDateTime = moment(StartDate).format(self.localeSettings().longDateFormat1); //'MMMM DD, YYYY HH:mm');
            var hours = parseInt(new Date(inputDateTime).getHours());
            var minutes = parseInt(new Date(inputDateTime).getMinutes());

            return hours + (minutes / 60); //((new Date(StartDate).getTime()) / (1000 * 60 * 60 * 24)).toFixed(0);
        }

        self.filterStartDate = function(date, numberOfday, _format) {
            var dates = moment(date).format(self.localeSettings().shortdateFormatWithSlash); //'MM/DD/YYYY');
            return moment(dates).diff(moment(), 'days') > numberOfday;
        };

        self.filterEndDate = function(date, numberOfday, model, _format, is24Hour) {
            var dates = moment(date).format(self.localeSettings().shortdateFormatWithSlash); //'MM/DD/YYYY');
            if (model) {
                if (is24Hour) {
                    return moment(dates).diff(model, 'days') >= 1;
                }
                return moment(dates).diff(model, 'days') >= 0;
            }
            return moment(dates).diff(moment(), 'days') > numberOfday;
        };

        self.formatToLocaleDate = function(date, dateFormat) {
            return date ? moment(date).format(dateFormat) : null;
        }

        self.parseToLocaleDate = function(dateString, dateFormat) {
            var m = moment(dateString, dateFormat, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        }

        self.validateDateOnChange = function(startDate, endDate, mode, is24Hours) {
            if (endDate < startDate) {
                if (mode) {
                    return startDate;
                } else {
                    return null;
                }
            } else {
                if (is24Hours) {
                    return null;
                }
                return endDate;
            }
        }

        self.removeDuplicates = function(myArr, prop) {
            return myArr.filter(function(obj, pos, arr) {
                return arr.map(function(mapObj) {
                    return mapObj[prop];
                }).indexOf(obj[prop]) === pos;
            });
        }

        self.getSelectedText = function(selected, title, property) {
            if (!selected ||
                !Array.isArray(selected) ||
                selected.length === 0) {
                return title;
            }

            var itemsToDisplay = 2;
            var selectedItems = selected.sort();
            var displayText = "";
            var limitedLength = selectedItems.length > itemsToDisplay ? itemsToDisplay : selectedItems.length;
            var dots = selectedItems.length > itemsToDisplay ? ` +${selectedItems.length-itemsToDisplay} more` : "";

            if (property === null) {
                for (var i = 0; i < limitedLength; i++) {
                    displayText += (displayText != "" ? ", " : "") + selectedItems[i];
                }

                return displayText + dots;
            }

            var props = property.split("|");
            var actual_prop = null;

            if (selectedItems.length > 0) {
                props.forEach(function(prop) {
                    let sample = selectedItems[0];
                    let match = sample[prop.trim()];
                    if (match) {
                        actual_prop = prop.trim();
                    }
                });
            }

            let query = "select * from ? order by " + actual_prop + " asc";
            selectedItems = alasql(query, [selectedItems, actual_prop]);

            for (var i = 0; i < limitedLength; i++) {
                displayText += (displayText != "" ? ", " : "") + selectedItems[i][actual_prop];
            }

            return displayText + dots;
        };

        /**
         * Base64 string to Blob type converter
         */
        self.b64toBlob = function(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {
                type: contentType
            });
            return blob;
        }

        self.getStartOfWeek = function(startOfPeriod) {
            let start = moment(startOfPeriod);
            let isoWeekStart = start.startOf('isoWeek');
            let lastWeek = isoWeekStart.weekday(-7);
            let result = null;
            result = lastWeek.format('YYYY-MM-DD');

            return new Date(result);
        }

        self.getEndOfWeek = function(startOfPeriod) {
            let start = moment(startOfPeriod);
            let isoWeekStart = start.startOf('isoWeek');
            let lastWeek = isoWeekStart.weekday(-7);
            let result = null;
            result = lastWeek.add(6, 'd').format('YYYY-MM-DD');

            return new Date(result);
        }

        self.convertTime = function(time) {
            const time_copy = time.toString().toLowerCase();
            if (is12Format(time_copy)) {
                return isAM(time) ? convertAM(time) : convertPM(time);
            } else {
                return time;
            }
        }

        self.displayUtcInLocalDateTimeFormat = function(dateTime) {
            let dateTimeFormatWithSlash = self.localeSettings().dateTimeFormatWithSlash;
            return moment(dateTime).format(dateTimeFormatWithSlash || 'L LTS') + ' UTC';
        };
    }

    function convertAM(time) {
        var trimmed = time.toString().toLowerCase().replace("am", "").trim();
        var minute = trimmed.substring(trimmed.indexOf(":") + 1).trim()
        var hour = trimmed.substring(0, trimmed.indexOf(":")).trim();
        hour = hour === "12" ? "00" : hour.length === 1 ? ("0" + hour) : hour;
        return hour + ":" + minute;
    }

    function convertPM(time) {
        var trimmed = time.toString().toLowerCase().replace("pm", "").trim();
        var minute = trimmed.substring(trimmed.indexOf(":") + 1).trim()
        var hour = trimmed.substring(0, trimmed.indexOf(":")).trim();
        hour = hour === "12" ? "12" : (parseInt(hour) + 12).toString();
        return hour + ":" + minute;
    }

    function is12Format(time) {
        return (isAM(time) || isPM(time));
    }

    function isAM(time) {
        return time.toLowerCase().includes("am");
    }

    function isPM(time) {
        return time.toLowerCase().includes("pm");
    }

})();

angular.module('app.corelib').directive('apsUploadFile', apsUploadFile);

function apsUploadFile() {
    var directive = {
        restrict: 'E',
        template: '<input id="fileInput" type="file" class="ng-hide" a8-file-upload="files" upload-url="vm.uploadUrl" on-upload-validate="vm.onUploadValidate(fileObj)" behavior="vm.behavior" on-upload-start="vm.onUploadStart()"on-upload-completed="vm.onUploadSuccess(data)" on-upload-error="vm.onUploadError(ex)"> <i class="icon-attachment" id="uploadButton"><md-tooltip>Attach Evidence</md-tooltip></i><md-input-container  md-no-float> </md-input-container>',
        link: apsUploadFileLink
    };
    return directive;
}

function apsUploadFileLink(scope, element, attrs) {
    var input = $(element[0].querySelector('#fileInput'));
    var button = $(element[0].querySelector('#uploadButton'));

    if (input.length && button.length) {
        button.click(function(e) {
            input.click();
        });
    }

    input.on('change', function(e) {
        var files = e.target.files;

        if (files[0]) {
            scope.fileName = files[0].name;
        } else {
            scope.fileName = null;
        }

        scope.$apply();
    });
}

'use strict';
/*jshint globalstrict: true*/
/*jshint undef:false */

angular.module('unsavedChanges', ['resettable'])

  .provider('unsavedWarningsConfig', function() {

    var _this = this;

    // defaults
    var logEnabled = false;
    var useTranslateService = true;
    var routeEvent = ['$locationChangeStart', '$stateChangeStart'];
    var navigateMessage = 'You will lose unsaved changes if you leave this page';
    var reloadMessage = 'You will lose unsaved changes if you reload this page';

    Object.defineProperty(_this, 'navigateMessage', {
      get: function() {
        return navigateMessage;
      },
      set: function(value) {
        navigateMessage = value;
      }
    });

    Object.defineProperty(_this, 'reloadMessage', {
      get: function() {
        return reloadMessage;
      },
      set: function(value) {
        reloadMessage = value;
      }
    });

    Object.defineProperty(_this, 'useTranslateService', {
      get: function() {
        return useTranslateService;
      },
      set: function(value) {
        useTranslateService = !! (value);
      }
    });

    Object.defineProperty(_this, 'routeEvent', {
      get: function() {
        return routeEvent;
      },
      set: function(value) {
        if (typeof value === 'string') value = [value];
        routeEvent = value;
      }
    });
    Object.defineProperty(_this, 'logEnabled', {
      get: function() {
        return logEnabled;
      },
      set: function(value) {
        logEnabled = !! (value);
      }
    });

    this.$get = ['$injector',
      function($injector) {

        function translateIfAble(message) {
          if ($injector.has('$translate') && useTranslateService) {
            return $injector.get('$translate').instant(message);
          } else {
            return false;
          }
        }

        var publicInterface = {
          // log function that accepts any number of arguments
          // @see http://stackoverflow.com/a/7942355/1738217
          log: function() {
            if (console.log && logEnabled && arguments.length) {
              var newarr = [].slice.call(arguments);
              if (typeof console.log === 'object') {
                log.apply.call(console.log, console, newarr);
              } else {
                console.log.apply(console, newarr);
              }
            }
          }
        };

        Object.defineProperty(publicInterface, 'useTranslateService', {
          get: function() {
            return useTranslateService;
          }
        });

        Object.defineProperty(publicInterface, 'reloadMessage', {
          get: function() {
            return translateIfAble(reloadMessage) || reloadMessage;
          }
        });

        Object.defineProperty(publicInterface, 'navigateMessage', {
          get: function() {
            return translateIfAble(navigateMessage) || navigateMessage;
          }
        });

        Object.defineProperty(publicInterface, 'routeEvent', {
          get: function() {
            return routeEvent;
          }
        });

        Object.defineProperty(publicInterface, 'logEnabled', {
          get: function() {
            return logEnabled;
          }
        });

        return publicInterface;
      }
    ];
  })

  .service('unsavedWarningSharedService', ['$rootScope', 'unsavedWarningsConfig', '$injector', '$window',
    function($rootScope, unsavedWarningsConfig, $injector, $window) {

      // Controller scopped variables
      var _this = this;
      var allForms = [];
      var areAllFormsClean = true;
      var removeFunctions = [];

      // @note only exposed for testing purposes.
      this.allForms = function() {
        return allForms;
      };

      // Check all registered forms
      // if any one is dirty function will return true

      function allFormsClean() {
        areAllFormsClean = true;
        // angular.forEach(allForms, function(item, idx) {
        //   unsavedWarningsConfig.log('Form : ' + item.$name + ' dirty : ' + item.$dirty);
        //   if (item.$dirty) {
        //     areAllFormsClean = false;
        //   }
        // });
        return areAllFormsClean; // no dirty forms were found
      }

      // adds form controller to registered forms array
      // this array will be checked when user navigates away from page
      this.init = function(form) {
        if (allForms.length === 0) setup();
        unsavedWarningsConfig.log("Registering form", form);
        allForms.push(form);
      };

      this.removeForm = function(form) {
        var idx = allForms.indexOf(form);

        // this form is not present array
        // @todo needs test coverage
        if (idx === -1) return;

        allForms.splice(idx, 1);
        unsavedWarningsConfig.log("Removing form from watch list", form);

        if (allForms.length === 0) tearDown();
      };

      function tearDown() {
        unsavedWarningsConfig.log('No more forms, tearing down');
        angular.forEach(removeFunctions, function(fn) {
          fn();
        });
        removeFunctions = [];
        $window.onbeforeunload = null;
      }

      // Function called when user tries to close the window
      this.confirmExit = function() {
        if (!allFormsClean()) return unsavedWarningsConfig.reloadMessage;
        $rootScope.$broadcast('resetResettables');
        tearDown();
      };

      // bind to window close
      // @todo investigate new method for listening as discovered in previous tests

      function setup() {
        unsavedWarningsConfig.log('Setting up');

        $window.onbeforeunload = _this.confirmExit;

        var eventsToWatchFor = unsavedWarningsConfig.routeEvent;

        angular.forEach(eventsToWatchFor, function(aEvent) {
          //calling this function later will unbind this, acting as $off()
          var removeFn = $rootScope.$on(aEvent, function(event, next, current) {
            unsavedWarningsConfig.log("user is moving with " + aEvent);
            // @todo this could be written a lot cleaner!
            if (!allFormsClean()) {
              unsavedWarningsConfig.log("a form is dirty");
              if (!confirm(unsavedWarningsConfig.navigateMessage)) {
                unsavedWarningsConfig.log("user wants to cancel leaving");
                event.preventDefault(); // user clicks cancel, wants to stay on page
              } else {
                unsavedWarningsConfig.log("user doesn't care about loosing stuff");
                $rootScope.$broadcast('resetResettables');
              }
            } else {
              unsavedWarningsConfig.log("all forms are clean");
            }

          });
          removeFunctions.push(removeFn);
        });
      }
    }
  ])

  .directive('unsavedWarningClear', ['unsavedWarningSharedService',
    function(unsavedWarningSharedService) {
      return {
        scope: {},
        require: '^form',
        priority: 10,
        link: function(scope, element, attrs, formCtrl) {
          element.bind('click', function(event) {
            formCtrl.$setPristine();
          });

        }
      };
    }
  ])

  .directive('unsavedWarningForm', ['unsavedWarningSharedService', '$rootScope',
    function(unsavedWarningSharedService, $rootScope) {
      return {
        scope: {},
        require: '^form',
        link: function(scope, formElement, attrs, formCtrl) {

          // @todo refactor, temp fix for issue #22
          // where user might use form on element inside a form
          // we shouldnt need isolate scope on this, but it causes the tests to fail
          // traverse up parent elements to find the form.
          // we need a form element since we bind to form events: submit, reset
          var count = 0;
          while(formElement[0].tagName !== 'FORM' && count < 3) {
            count++;
            formElement = formElement.parent();
          }
          if(count >= 3) {
            throw('unsavedWarningForm must be inside a form element');
          }

          // register this form
          unsavedWarningSharedService.init(formCtrl);

          // bind to form submit, this makes the typical submit button work
          // in addition to the ability to bind to a seperate button which clears warning
          formElement.bind('submit', function(event) {
            if (formCtrl.$valid) {
              formCtrl.$setPristine();
            }
          });

          // bind to form submit
          // developers can hook into resetResettables to do
          // do things like reset validation, present messages, etc.
          formElement.bind('reset', function(event) {
            event.preventDefault();

            // trigger resettables within this form or element
            var resettables = angular.element(formElement[0].querySelector('[resettable]'));
            if(resettables.length) {
              scope.$apply(resettables.triggerHandler('resetResettables'));
            }

            // sets for back to valid and pristine states
            formCtrl.$setPristine();
          });

          // @todo check destroy on clear button too?
          scope.$on('$destroy', function() {
            unsavedWarningSharedService.removeForm(formCtrl);
          });
        }
      };
    }
  ]);


/**
 * --------------------------------------------
 * resettable models adapted from vitalets lazy model
 * @see https://github.com/vitalets/lazy-model/
 *
 * The main difference is that we DO set the model value
 * as the user changes the inputs. However we provide a hook
 * to reset the model to original value. This we can then
 * broadcast on from reset which triggers resettable to revert
 * to original value.
 * --------------------------------------------
 *
 * @note we don't create a seperate scope so the model value
 * is still available onChange within the controller scope.
 * This fixes https://github.com/facultymatt/angular-unsavedChanges/issues/19
 *
 */
angular.module('resettable', [])

  .directive('resettable', ['$parse', '$compile', '$rootScope',
    function($parse, $compile, $rootScope) {

      return {
        restrict: 'A',
        link: function postLink(scope, elem, attr, ngModelCtrl) {

          var setter, getter, originalValue;

          // save getters and setters and store the original value.
          attr.$observe('ngModel', function(newValue) {
            getter = $parse(attr.ngModel);
            setter = getter.assign;
            originalValue = getter(scope);
          });

          // reset our form to original value
          var resetFn = function() {
            setter(scope, originalValue);
          };

          elem.on('resetResettables', resetFn);

          // @note this doesn't work if called using
          // $rootScope.on() and $rootScope.$emit() pattern
          var removeListenerFn = scope.$on('resetResettables', resetFn);
          scope.$on('$destroy', removeListenerFn);

        }
      };
    }
  ]);

(function () {
    'use strict';

    angular.module('app.corelib')
        .service('TimeSetter', TimeSetter);

    /** @ngInject */
    function TimeSetter() {

        var service = {
            setTime : setTime
        };

        return service;

        function setTime(time){
            var displayAs24HourTime = true;
            var regex1 = /^([01]?[0-9]|2[0-3])\ *[\ \.:-]\ *([0-5][0-9]|[0-5])\ *([apAP][mnMN])*/m;
            var regex2 = /^([01]?[0-9]|2[0-3])([0-5][0-9]|[0-5])*\ *([apAP][mnMN])*/m;

            var hasTime = false;
            var match;
            var hours = 0;
            var mins = 0;

            if (!time)
                return "";

            if (time.length === 2) {
                if (time[1].toLowerCase() === 'a' || time[1].toLowerCase() === 'p') {
                    hours = parseInt(time[0]);

                    if (time[1].toLowerCase() === 'p')
                        hours += 12;
                }
                else
                    hours = parseInt(time);

                if (hours === 24) {
                    hours = 0;
                    hasTime = true;
                }
                else if (hours > 0 && hours <= 23)
                    hasTime = true;
            }
            else if (time.length === 4) {
                if (time[3].toLowerCase() === 'a' || time[3].toLowerCase() === 'p') {
                    hours = parseInt(time[0]);

                    if (time[3].toLowerCase() === 'p')
                        hours += 12;

                    mins = parseInt(time[1] + time[2]);
                }
                else if (time[2] === '.') {
                    hours = parseInt(time[0] + time[1]);
                    mins = parseInt(time[3] + "0");
                }
                else {
                    hours = parseInt(time[0] + time[1]);
                    mins = parseInt(time[2] + time[3]);
                }

                if (hours === 24) {
                    hours = 0;
                    hasTime = true;
                }
                else if (hours > 0 && hours <= 23)
                    hasTime = true;

                if (mins < 0 || mins > 59)
                    mins = 0;
            }

            if (!hasTime && regex1.test(time)) {
                match = regex1.exec(time);
                hours = parseInt(match[1]);

                mins = match[2].length === 1 && match[2][0] !== '0' ? parseInt(match[2]) * 10 : parseInt(match[2]);

                if (match[3] !== undefined && (match[3].toLowerCase() === 'pm' || match[3].toLowerCase() === 'pn') && hours < 12)
                    hours += 12;

                hasTime = true;
            }
            else if (!hasTime && regex2.test(time)) {
                match = regex2.exec(time);

                if (match[1].length === 1) {
                    hours = parseInt(match[1]);
                    hasTime = true;
                }
                else if (match[1].length === 2) {
                    hours = parseInt(match[1]);
                    hasTime = true;
                }

                if (match[2] !== undefined && match[2].length === 2) {
                    mins = parseInt(match[2]);
                    hasTime = true;
                }

                if (match[3] !== undefined && (match[3].toLowerCase() === 'pm' || match[3].toLowerCase() === 'pn') && hours < 12)
                    hours += 12;
            }

            var formattedTime = null;

            if (hasTime)
                formattedTime = formatTime(hasTime, displayAs24HourTime, hours, mins);
            return formattedTime;
        }
        function formatTime(hasTime, displayAs24HourTime, hours, mins){
            let time_string = hasTime ? (displayAs24HourTime ? getHour(hours) + ":" + (mins < 10 ? "0" : "") + mins : (hours > 12 ? hours - 12 : hours == 0 ? "12" : hours) + ":" + (mins >= 10 ? mins : "0" + mins) + (hours >= 12 ? " pm" : " am")) : time;
            return time_string;
        }

        function getHour(hours){
            if(hours === 0){
                return "00";
            }else if(hours > 0 && hours < 10){
                return "0" + hours.toString();
            }else{
                return hours.toString();
            }
        }


    }
})();

// angular.module('app.corelib').directive('timePicker', function (identityService) {
angular.module('app.corelib').directive('timePicker', function (TimeLibrary, _) {
    return {
        scope: {
            ngModel: '='
        },
        link: function (scope, element) {
            scope.formatTime = function() {
                var time_value = scope.ngModel;
                if (!_.isNil(time_value)) {
                    scope.ngModel = TimeLibrary.convertTime(time_value);
                }
            };

            element.bind("blur", function () {
                scope.formatTime();
                scope.$apply();
            });

            scope.formatTime();
        }
    };

    //Old Converter =>

    // function getCleanedTime(time, displayAs24HourTime) {
    //   var regex1 = /^([01]?[0-9]|2[0-3])\ *[\ \.:-]\ *([0-5][0-9]|[0-5])\ *([apAP][mnMN])*/m;
    //   var regex2 = /^([01]?[0-9]|2[0-3])([0-5][0-9]|[0-5])*\ *([apAP][mnMN])*/m;
    //
    //   var hasTime = false;
    //   var match;
    //   var hours = 0;
    //   var mins = 0;
    //
    //   if (!time)
    //     return "";
    //
    //   if (time.length === 2) {
    //     if (time[1].toLowerCase() === 'a' || time[1].toLowerCase() === 'p') {
    //       hours = parseInt(time[0]);
    //
    //       if (time[1].toLowerCase() === 'p')
    //         hours += 12;
    //     }
    //     else
    //       hours = parseInt(time);
    //
    //     if (hours === 24) {
    //       hours = 0;
    //       hasTime = true;
    //     }
    //     else if (hours > 0 && hours <= 23)
    //       hasTime = true;
    //   }
    //   else if (time.length === 4) {
    //     if (time[3].toLowerCase() === 'a' || time[3].toLowerCase() === 'p') {
    //       hours = parseInt(time[0]);
    //
    //       if (time[3].toLowerCase() === 'p')
    //         hours += 12;
    //
    //       mins = parseInt(time[1] + time[2]);
    //     }
    //     else if (time[2] === '.') {
    //       hours = parseInt(time[0] + time[1]);
    //       mins = parseInt(time[3] + "0");
    //     }
    //     else {
    //       hours = parseInt(time[0] + time[1]);
    //       mins = parseInt(time[2] + time[3]);
    //     }
    //
    //     if (hours === 24) {
    //       hours = 0;
    //       hasTime = true;
    //     }
    //     else if (hours > 0 && hours <= 23)
    //       hasTime = true;
    //
    //     if (mins < 0 || mins > 59)
    //       mins = 0;
    //   }
    //
    //   if (!hasTime && regex1.test(time)) {
    //     match = regex1.exec(time);
    //     hours = parseInt(match[1]);
    //
    //     mins = match[2].length === 1 && match[2][0] !== '0' ? parseInt(match[2]) * 10 : parseInt(match[2]);
    //
    //     if (match[3] !== undefined && (match[3].toLowerCase() === 'pm' || match[3].toLowerCase() === 'pn') && hours < 12)
    //       hours += 12;
    //
    //     hasTime = true;
    //   }
    //   else if (!hasTime && regex2.test(time)) {
    //     match = regex2.exec(time);
    //
    //     if (match[1].length === 1) {
    //       hours = parseInt(match[1]);
    //       hasTime = true;
    //     }
    //     else if (match[1].length === 2) {
    //       hours = parseInt(match[1]);
    //       hasTime = true;
    //     }
    //
    //     if (match[2] !== undefined && match[2].length === 2) {
    //       mins = parseInt(match[2]);
    //       hasTime = true;
    //     }
    //
    //     if (match[3] !== undefined && (match[3].toLowerCase() === 'pm' || match[3].toLowerCase() === 'pn') && hours < 12)
    //       hours += 12;
    //   }
    //
    //   var formattedTime = null;
    //
    //   if (hasTime)
    //     formattedTime = formatTime(hasTime, displayAs24HourTime, hours, mins);
    //   return formattedTime;
    // }
    //
    // function formatTime(hasTime, displayAs24HourTime, hours, mins){
    //     let time_string = hasTime ? (displayAs24HourTime ? getHour(hours) + ":" + (mins < 10 ? "0" : "") + mins : (hours > 12 ? hours - 12 : hours == 0 ? "12" : hours) + ":" + (mins >= 10 ? mins : "0" + mins) + (hours >= 12 ? " pm" : " am")) : time;
    //     return time_string;
    // }
    //
    // function getHour(hours){
    //       if(hours === 0){
    //           return "00";
    //       }else if(hours > 0 && hours < 10){
    //           return "0" + hours.toString();
    //       }else{
    //           return hours.toString();
    //       }
    // }

});

(function () {
    'use strict';

    angular.module('app.corelib')
        .service('TimeLibrary', TimeLibrary);

    /** @ngInject */
    function TimeLibrary(identityService, _, localisationService) {

        var service = {
            convertTime: convertTime,
            convertToServerTime : convertToServerTime,
            convertTo24 : convertTo24,
            covertTimesInString : covertTimesInString,
            convertTimeAppend : convertTimeAppend,
            getTimeFromString: getTimeFromString
        };

        return service;

        //Universal Time Converter to replace timeSetter and TimePicker

        //convert time according to user preferred time format
        function convertTime(time) {
            let format = getUserPreferredFormat();
            return convert(time, format);
        }

        function convertTimeAppend(time) {
            let format = getUserPreferredFormat();
            return appendTime(convert(time, format));
        }

        function appendTime(time){
            //Adds '0' before actual time if necessary
            let index = time.indexOf(":");
            let length = time.substring(0, index).trim().length;
            return length === 1 ? ("0" + time) : time;
        }

        function covertTimesInString(log_string) {
            var matches = getTimeMatches(log_string);
            return matches != null ? operate(matches, log_string) : log_string
        }

        function getTimeMatches(log_string) {
            var pattern = /(?:[01]\d|2[0-3]):[0-5]\d/g;
            return log_string.match(pattern);
        }

        function operate(matches, log_string) {
            matches.forEach(function (match) {
                log_string = log_string.replace(match, convertTime(match));
            });
            return log_string;
        }

        //convert to server time //24-hour format
        function convertToServerTime(time) {
            return moment(moment(convert(_.isNull(time) ? "00:00" : time, "24"), "HH:mm")).format('HH:mm:ss');
        }

        function convertTo24(time) {
            return moment(moment(convert(_.isNull(time) ? "00:00" : time, "24"), "HH:mm")).format('HH:mm');
        }

        function getUserPreferredFormat() {
            //if format is null || undefined, format will be set to 24 hour by default
            return localisationService.getTimeFormatSettings();
        }

        //Main Functions
        function convert(str, format) {
            if (str === "") {
                return null;
            }

            if (!_.isNil(str)) {
                var sanitized_string = cleanString(str);
                var res = validateSeparatedChars(separateCharacters(sanitized_string), format);
                return res != null ? res.toString().toLowerCase() : res;
            } else {
                return null;
            }
        }

        function cleanString(str) {
            var regex = /\W/g;
            return str.replace(regex, "").replace("_", "");
        }

        function validateSeparatedChars(str, format) {
            if (str.length == 0 || str.length > 2) {
                return;
            } else if (str.length == 1) {
                return isNumber(str[0]) ? autoSelect(str, format) : null;
            } else {
                return isNumber(str[0]) ? autoSelect(str, format) : null;
            }
        }

        function separateCharacters(str) {
            return str.match(/[a-z]+|[^a-z]+/gi).sort()
        }

        function autoSelect(str, format) {
            var evaluated_number = evaluateNumberElement(str, format);
            var pre_format = containsFormat(str);
            return format == "12" ? fmt12Hr(evaluated_number, pre_format) : fmt24Hr(evaluated_number, evaluated_number === 0 ? null : pre_format);
        }

        function containsFormat(str) {
            if (str.length === 1) {
                return null;
            } else {
                if (str[1].toLowerCase().includes("a")) {
                    return "AM";
                } else if (str[1].toLowerCase().includes("p")) {
                    return "PM";
                } else {
                    return null;
                }
            }
        }

        function evaluateNumberElement(str, format) {
            var time_str = str[0];
            var length = time_str.length;

            if (length === 1) {
                return formatTimeJSON((parseInt(time_str)), 0);
            } else if (length === 2) {
                if (parseInt(time_str) === 24) {
                    return formatTimeJSON(0, 0);
                }
                else if (parseInt(time_str) <= 24) {
                    return formatTimeJSON((parseInt(time_str)), 0);
                } else {
                    var minutes = time_str[1];
                    return formatTimeJSON(parseInt(time_str[0]), parseInt(minutes));
                }
            } else if (length === 3) {
                var hour = parseInt(time_str[0]);
                var min_partial = parseInt(time_str.substring(1));
                var minute = min_partial <= 59 ? min_partial : parseInt(time_str[1] + "0") > 59 ? parseInt("0" + time_str[1]) : parseInt(time_str[1] + "0");
                return formatTimeJSON(hour, minute);
            } else if (length === 4) {
                return handle4Chars(time_str);
            } else {
                return handle4Chars(time_str);
            }
        }

        function handle4Chars(str) {
            str = str.substring(0, 4).trim();
            var hour = parseInt(str.substring(0, 2));
            var partial_minute = parseInt(str.substring(2));
            var minute = null;
            if (hour == 24 && partial_minute == 0) {
                hour = 0;
                minute = 0;
            } else if (hour == 24 && partial_minute > 0) {
                hour = 0;
                minute = partial_minute > 59 ? parseInt(str.charAt(2)) : partial_minute;
            } else if (hour > 23 && hour != 24) {
                hour = parseInt(str.substring(0, 1));
                if (parseInt(str.substring(1, 2) > 59)) {
                    minute = parseInt(str.substring(1, 1));
                } else {
                    minute = parseInt(str.substring(1, 2));
                }
            } else {
                minute = parseInt(str.substring(2)) > 59 ? parseInt(str.charAt(2)) : parseInt(str.substring(2));
            }
            return formatTimeJSON(hour, minute);
        }

        function formatTimeJSON(hour, minute) {
            return {
                hour: hour,
                minute: minute
            }
        }

        function fmt12Hr(time, pre_format) {
            if (time.hour > 12) {
                return time.hour - 12 + ":" + (time.minute < 10 ? "0" + time.minute.toString() : time.minute.toString()) + " PM"
            } else if (time.hour == 0) {
                return ("12:" + (time.minute < 10 ? "0" + time.minute : time.minute)) + " AM";
            } else if (time.hour > 0 && time.hour < 12) {
                return time.hour.toString() + ":" + (time.minute < 10 ? "0" + time.minute.toString() : time.minute.toString()) + (pre_format != null ? " " + pre_format : " AM");
            } else {
                return time.hour.toString() + ":" + (time.minute < 10 ? "0" + time.minute.toString() : time.minute.toString()) + (pre_format != null ? " " + pre_format : " PM");
            }
        }

        function fmt24Hr(time, pre_format) {
            pre_format = time.hour === 24 || time.hour === 0 ? null : pre_format;
            if (pre_format == null) {
                time.hour = time.hour === 24 ? time.hour = 0 : time.hour;
                return time.hour + ":" + (time.minute < 10 ? "0" + time.minute.toString() : time.minute.toString());
            } else if (time.hour === 12 && pre_format != null) {
                var minute = time.minute < 9 ? ("0" + time.minute.toString()) : time.minute.toString();
                return (pre_format == "AM" ? "0" : "12") + ":" + minute;
            } else {
                return pre_format == "AM" ? toTimeString(time, false) : toTimeString(time, time.hour < 12 ? true : false);
            }
        }

        function toTimeString(time, adjust24) {
            return (adjust24 ? time.hour + 12 : time.hour) + ":" + (time.minute < 10 ? "0" + time.minute.toString() : time.minute.toString());
        }

        function getTimeFromString(str) {
            var momentObj = moment(str, 'H:mm a')
            if (!momentObj.isValid()) {
                return null;
            }
            return {
                hour: momentObj.hour(),
                minute: momentObj.minute()
            }
        }

        function isNumber(str) {
            return Number.isInteger(parseInt(str));
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.corelib')
        .service('signalRService', signalRService);

    function signalRService(
        $log,
        $q,
        $http,
        $rootScope,
        identityService,
        tenantSettings,
        exceptionService,
        $timeout,
        $mdDialog,
        NUM_TRIES_RECONNECT
    ) {
        var service = {
            connect: connect,
            disconnect: disconnect,
            isOnline: false,
            messageHub: null,
            invoiceDistributionHub: null,
            onConnected: null,
            isConnected: false,
            ping: ping,
            safeSend: safeSend,
            reconnectCounter: 0
        };

        var signalRConnection = null;
        var isLogout = true;

        activate();

        return service;

        function activate() {
            if (identityService.getToken() == null) {
                return;
            }
            
            createHub();
            registerHubEvents();
            attachCommonConnectionEvents();
        }

        function createHub() {            
            signalRConnection = $.hubConnection(tenantSettings.coreApiUrl);

            $.signalR.ajaxDefaults.headers = {
                Authorization: 'Bearer ' + identityService.getToken()
            };
            document.cookie = 'BearerToken=' + identityService.getToken() + '; path=/';
            signalRConnection.logging = true;

            service.messageHub = signalRConnection.createHubProxy('MessageHub');
            service.invoiceDistributionHub = signalRConnection.createHubProxy('InvoiceDistributionHub');
        }

        function registerHubEvents() {
            service.messageHub.on('disconnectClient', function() {
                $log.log('Disconnect client...');
                service.messageHub.connection.stop();
            });

            // ----------------------
            // Pub-Subs handlers
            // ----------------------
            $rootScope.$on('disconnect', function(data) {
                service.messageHub.connection.stop();
                $log.debug('Message Hub: Disconnecting hub.');
            });

            $rootScope.$on('restartHub', function() {
                startHub();
            });

            // Update JWT for signalR
            $rootScope.$on('identityService:applyClaimsRules', function() {
                // Do nothing for the meantime
                //grabLatestToken();
                $log.debug('SignalR: Scheduled for applying new claims/jwt token to socket.');
            });
        }

        /**
         * Register common hub connection events
         */
        function attachCommonConnectionEvents() {
            
            signalRConnection.reconnecting(function() {
                $log.debug('Alloc8: Reconnecting to SignalR server...');
                signalRConnection.stop();
                $timeout(function() {
                    pingAndConnect();
                }, 2000);
            });

            signalRConnection.disconnected(function() {
                service.isOnline = false;
                service.isConnected = false;
                if (!isLogout) {
                    $log.debug('Alloc8: SignalR disconnected...');
                    setTimeout(function() {
                        pingAndConnect();
                    }, 2000); // Restart connection after 2 seconds.
                }
            });

            signalRConnection.error(function(err) {
                if (err.message == 'Send Failed.' || err.message == 'Error during negotiation request.') {
                    $timeout(function() {
                        pingAndConnect();
                    }, 2000);
                }
            });
        }

        function pingAndConnect() {
            apiPing().then(function(r) {
                connect().then(function(res) {}, function(err) {
                    retryConnection();
                });
            }).catch(function(ex) {
                retryConnection();
            });
        }

        function retryConnection() {
            service.reconnectCounter++;
            if (service.reconnectCounter < NUM_TRIES_RECONNECT) {
                $timeout(function() {
                    pingAndConnect();
                }, 5000);
            } else {
                let data = "Sorry, we were unable to reconnect to the server. Please click refresh or press your browser refresh button to reload Alloc8.";

                let confirm = $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .htmlContent(data)
                    .ok('Close')
                    .cancel('Refresh');

                $mdDialog.show(confirm)
                    .then(function() {

                    }, function() {
                        location.reload();
                    });
            }
        }

        function grabLatestToken() {
            $.signalR.ajaxDefaults.headers = {
                Authorization: 'Bearer ' + identityService.getToken()
            };
            document.cookie = 'BearerToken=' + identityService.getToken() + '; path=/';
        }

        // Start the connection.
        function connect() {
            let deferred = $q.defer();

            if (signalRConnection == null && identityService.getToken() != null) {               
                createHub();
                attachCommonConnectionEvents();
            } else if (signalRConnection == null && identityService.getToken() == null) {
                return;
            } else {
                // Get latest token we might miss something like real-time jwt update (just to be safe)
                grabLatestToken();  
            }          

            // Trick: Register at least single method to force onConnected hub event in the server (Actually its a rule in the SignalR best practice.)
            service.messageHub.on('foo', function() {
                console.debug('Dummy method regs: Alloc8 test - rcnet');
            });

            // Give enough time to connect
            $timeout(function() {
                //{ transport: ['webSockets', 'longPolling'] }
                signalRConnection.start().done(function() {
                    $log.debug('Client status: Connected');
                    $log.debug('Connected, transport = ' + signalRConnection.transport.name);
                    // Fire event
                    service.isConnected = true;
                    isLogout = false;
                    service.reconnectCounter = 0;

                    (service.onConnected || angular.noop)();

                    $rootScope.$broadcast('signalR_OnConnected');

                    // Send ping to server
                    service.messageHub.invoke('echo', 'pingpong')
                        .done(function(resp) {
                            if (resp === 'pingpong') {
                                $log.debug('Success in pinging the server.');
                                service.isOnline = true;
                                deferred.resolve('Successfully connected to hub.');
                            }
                        }).fail(function(error) {
                            deferred.reject('Unable to ping hub endpoint.');
                        });

                }).fail(function(ex) {
                    deferred.reject('Real-time communication: Unable to connect. Please try again.');
                });
            }, 250);

            return deferred.promise;
        }

        function disconnect() {
            isLogout = true;
            document.cookie = "BearerToken=; path=/; expires=" + new Date(0).toUTCString();
            signalRConnection.stop();
            signalRConnection = null;
        }

        /**
         * Implement retry here
         */
        function ping(retryCount) {
            let deferred = $q.defer();
            retryCount = retryCount || 1;

            // Send ping to server
            if (service.isOnline && service.messageHub.connection.state === 1) {
                service.messageHub.invoke('echo', 'pingpong')
                    .done(function(resp) {
                        if (resp === 'pingpong') {
                            $log.debug('Success in pinging the server.');
                            service.isOnline = true;
                            deferred.resolve('ping successful');
                        }
                    }).fail(function(error) {
                        deferred.reject('Real-time communication: Unable to connect. Please try again.');
                    });
            } else {
                // Recon
                return connect();
            }

            return deferred.promise;
        }

        /**
         * Ping before send
         */
        function safeSend(fn) {
            var isTryRecoveryDeferred = $q.defer();

            ping().then(function(resp) {
                (fn || angular.noop)();
            }).catch(function(ex) {
                isTryRecoveryDeferred.resolve();
                //exceptionService.resolve(ex);
            });

            // This is only executed when error occured in the previous execution of signalR request
            isTryRecoveryDeferred.promise.then(function(r1) {
                apiPing().then(function(r2) {
                    // Retry pinging signalR using the updated access token
                    ping().then(function(r3) {
                        (fn || angular.noop)();
                    }).catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
                });
            });
        }

        function apiPing() {
            return $http({
                method: 'POST',
                url: tenantSettings.coreApiUrl + 'api/application/ping',
                data: 'pong'
            });
        }
    }
})();

angular.module('app.corelib').directive('confirmOnExit', function() {
  return {
    link: function($scope, elem, attrs, ctrl) {
      // window.onbeforeunload = function(){
      //   if ($scope[attrs["name"]].$dirty) {
      //     return "Your edits will be lost.";
      //   }
      // }
      
      $scope[attrs["name"]].$setPristine();
    }
  };
});

(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('sessionTokenInterceptor', sessionTokenInterceptor);

    /** @ngInject */
    function sessionTokenInterceptor(
        identityTokenStorageService,
        tenantSettings,
        _
    ) {
        var coreApiUrl = _.get(tenantSettings, 'coreApiUrl', '');

        var service = {
            request: request
        };

        return service;

        function request(config) {
            var token = identityTokenStorageService.getToken();

            if (config.skipInterceptor) {
                return config;
            }

            // Identifies the portal to CoreAPI so actions can be attributed to a platform in the
            // history log. The mobile app sets the same header. CoreAPI is the only reader, so it
            // is scoped to that origin rather than sent on every request this interceptor sees.
            if (isCoreApiRequest(config.url)) {
                config.headers['X-Alloc8-Client'] = 'Alloc8Portal';
            }

            if (token && _.isUndefined(config.headers['Authorization'])) {
                config.headers['Authorization'] = 'Bearer ' + token;
            }

            if (!_.isUndefined(config.headers['Authorization'])) {
                if (config.headers['Authorization'] === null) {
                    delete config.headers['Authorization'];
                }
            }

            return config;
        }

        function isCoreApiRequest(url) {
            return !!coreApiUrl && _.isString(url) && url.indexOf(coreApiUrl) === 0;
        }
    };
})();

angular.module('app.corelib').directive("regExInput", function(){
  "use strict";
  return {
    restrict: "A",
    require: "?regEx",
    scope: {},
    replace: false,
    link: function(scope, element, attrs, ctrl){
      element.bind('keypress', function (event) {
        var regex = new RegExp(attrs.regEx);
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
  };
});

angular.module('app.corelib').directive('testpackery', ['$rootScope', '$timeout',
    function($rootScope, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                if ($rootScope.packery === undefined || $rootScope.packery === null) {
                    scope.element = element;
                    $rootScope.packery = new Packery(element[0].parentElement, {
                        isResizeBound: true,
                        rowHeight: 230,
                        columnWidth: 230,
                        itemSelector: '.itemwin',
                        draggable: true
                    });
                    if ($rootScope.packery.options.draggable) {
                        $rootScope.packery.bindResize();
                        var draggable1 = new Draggabilly(element[0]);
                        $rootScope.packery.bindDraggabillyEvents(draggable1);

                        draggable1.on('dragEnd', function(instance, event, pointer) {
                            $timeout(function() {
                                $rootScope.packery.layout();
                            }, 200);
                        });


                        var orderItems = function() {
                            var itemElems = $rootScope.packery.getItemElements();
                            $(itemElems).each(function(i, itemElem) {
                                $(itemElem).text(i + 1);
                            });
                        };

                        $rootScope.packery.on('layoutComplete', orderItems);
                        $rootScope.packery.on('dragItemPositioned', orderItems);
                    }

                } else {
                    if ($rootScope.packery.options.draggable) {
                        var draggable2 = new Draggabilly(element[0]);
                        $rootScope.packery.bindDraggabillyEvents(draggable2);


                        draggable2.on('dragEnd', function(instance, event, pointer) {
                            $timeout(function() {
                                $rootScope.packery.layout();
                            }, 200);
                        });

                    }
                    $timeout(function() {
                        $rootScope.packery.reloadItems();
                        $rootScope.packery.layout();
                    }, 100);
                }
            }
        };
    }
]);

/*!
 * angular-packery
 * http://github.com/sungard-labs/angular-packery
 * Version: 1.0.4
 * License: MIT
 */

'use strict';

(function (){

  var moduleDependencies = [
    'packeryTemplates'
  ];

  var moduleConfig = {
    columnWidth: '.packery-sizer',
    itemSelector: '.packery-object',
    rowHeight: '.packery-sizer',
    draggable: true,
    handle: '*',
    timeout: 2000,
    acceptedAttributes: [
      'containerStyle',
      'columnWidth',
      'gutter',
      'isHorizontal',
      'isInitLayout',
      'isOriginLeft',
      'isOriginTop',
      'isResizeBound',
      'itemSelector',
      'rowHeight',
      'transitionDuration'
    ]
  };

  var packeryService = function($rootScope, $q, $interval, $timeout, config) {
    var created = [],
        packeryObj;

    var uniqueId = function(obj, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === obj) {
          return false;
        }
      }
      return true;
    };

    return {
      Packery: function (hash, el, opts) {
        var deferred = $q.defer();

        el = el || undefined;
        opts = opts || {};

        if (uniqueId(hash, created) && el !== undefined) {
          packeryObj = new Packery(el[0], opts);
          created.push({
            id: hash,
            packery: packeryObj
          });
          el.data('Packery', packeryObj);
          $rootScope.$emit('packeryInstantiated', packeryObj);
          return packeryObj;
        } else {
          var interval = $interval(function(){
            if (packeryObj !== undefined) {
              $interval.cancel(interval);
              deferred.resolve(packeryObj);
            }
          }, config.timeout / 10);

          $timeout(function() {
            $interval.cancel(interval);
            deferred.reject(false);
          }, config.timeout);

          return deferred.promise;
        }
      }
    };
  };

  var packeryController = function ($rootScope, config, service) {

    var self = this;

    self.packeryInstantiated = false;
    self.packeryDraggable = false;
    self.dragHandle = undefined;
    self.uniqueId = new Date().getTime();
    self.packery = {};

    this.bindDragEvents = function(el) {
      var handleSelector, handle, draggabilly;

      handleSelector = self.dragHandle;

      if (handleSelector === '*') {
        draggabilly = new Draggabilly(el[0]);
        handle = el;
      } else {
        draggabilly = new Draggabilly(el[0], {
          handle: handleSelector
        });
        handle = el[0].querySelectorAll(handleSelector);
      }

      // Init Draggabilly events
      self.packery.bindDraggabillyEvents(draggabilly);

      // Bind animate events for touch
      angular.element(handle).on('mouseenter', function(){
        el.addClass('hovered');
      }).
      on('mouseleave', function(){
        el.removeClass('hovered');
      });
    };

    this.createAttrObj = function (scope) {
      var obj = {},
          attrs = config.acceptedAttributes;

      for (var i = 0; i < attrs.length; i++) {
        var attr = scope[attrs[i]];
        if (attr !== undefined) {

          if (attr === 'null') { // check for 'null' values
            obj[attrs[i]] = null;
          } else if (isNaN(attr) === false) { // check for numeric values
            obj[attrs[i]] = +scope[attrs[i]];
          } else { // all other values should be strings
            obj[attrs[i]] = scope[attrs[i]];
          }
        }
      }

      return obj;
    };

    this.packObject = function (el) {
      var promise = service.Packery(self.uniqueId);

      promise.then(function () {
        var packeryEls = self.packery.getItemElements();

        if (packeryEls.indexOf(el[0]) === -1) {
          self.packery.appended(el[0]);
        }

        if (self.packeryDraggable === true) {
          self.bindDragEvents(el);
        }

        el.css('visibility','visible');
        $rootScope.$emit('packeryObjectPacked', el[0]);
      });
    };

    this.setDraggable = function (handle) {
      self.packeryDraggable = true;
      self.dragHandle = handle;
    };
  };

  var packeryDirective = function (config, service) {

    return {
      restrict: 'EAC',
      controller: 'PackeryController',
      transclude: true,
      replace: true,
      templateUrl: 'template/packery/packery.html',
      scope: {
        containerStyle: '=?', // Type: Object, null
        columnWidth: '@?', // Type: Number, Selector String
        gutter: '@?', // Type: Number, Selector String
        isHorizontal: '@?', // Type: Boolean
        isInitLayout: '@?', // Type: Boolean
        isOriginLeft: '@?', // Type: Boolean
        isOriginTop: '@?', // Type: Boolean
        isResizeBound: '@?', // Type: Boolean
        itemSelector: '@?', // Type: Selector String
        rowHeight: '@?', // Type: Number, Selector String
        transitionDuration: '@?', // Type: String

        draggable: '@?', // Type: Boolean
        handle: '@?' // Type: Boolean

        // Let's come back to this one...
        // stamp: '@?',
      },
      link: function (scope, element, attrs, controller) {

        var packeryObj, packeryId, packery;

        // If empty, use defaults from config
        scope.columnWidth = scope.columnWidth || config.columnWidth;
        scope.itemSelector = scope.itemSelector || config.itemSelector;
        scope.rowHeight = scope.rowHeight || config.rowHeight;
        scope.draggable = scope.draggable || config.draggable;
        scope.handle = scope.handle || config.handle;

        // Quick fix so 'false' strings don't evaluate to true
        // @TODO: Check for attribute itself, not value of attribute
        if (scope.draggable === 'false') { scope.draggable = false; }
        if (scope.isHorizontal === 'false') { scope.isHorizontal = false; }
        if (scope.isInitLayout === 'false') { scope.isInitLayout = false; }
        if (scope.isOriginLeft === 'false') { scope.isOriginLeft = false; }
        if (scope.isOriginTop === 'false') { scope.isOriginTop = false; }
        if (scope.isResizeBound === 'false') { scope.isResizeBound = false; }

        // Creates JS Object for passing CSS styles into Packery
        if (scope.containerStyle && (typeof scope.containerStyle === 'object' )) { scope.containerStyle = scope.containerStyle; }

        // Set global draggability
        if (scope.draggable) { controller.setDraggable(scope.handle); }

        // Create object for Packery instantiation
        packeryObj = controller.createAttrObj(scope);
        packeryId = controller.uniqueId;

        // Instantiate Packery and broadcast event
        packery = service.Packery(packeryId, element, packeryObj);
        if (packery instanceof Packery) {
          controller.packeryInstantiated = true;
          controller.packery = packery;
        }

      }
    };
  };

  var packeryObjectTemplateDirective = function () {
    return {
      restrict: 'EA',
      templateUrl: 'template/packery/packery-object.html',
      transclude: true,
      replace: true
    };
  };

  var packeryObjectDirective = function () {
    return {
      require: '^packery',
      restrict: 'C',
      link: function (scope, element, attrs, controller) {
        // Prevents a FOUC on dynamically added objects
        element.css('visibility','hidden');

        // Packs individual objects
        controller.packObject(element);
      }
    };
  };

  var packeryTemplates = function ($templateCache) {
    $templateCache
      .put('template/packery/packery.html', [
        '<div class="packery-wrapper">',
          '<div class="packery-sizer"></div>',
          '<div class="packery-container" ng-transclude></div>',
        '</div>'
      ].join(''));

    $templateCache
      .put('template/packery/packery-object.html',
        '<div class="packery-object" ng-transclude></div>'
      );
  };

  angular
    .module('angular-packery', moduleDependencies)
    .constant('packeryConfig', moduleConfig)
    .service('packeryService', [ '$rootScope', '$q', '$interval', '$timeout', 'packeryConfig', packeryService ])
    .controller('PackeryController', [ '$rootScope', 'packeryConfig', 'packeryService', packeryController ])
    .directive('packery', [ 'packeryConfig', 'packeryService', packeryDirective ])
    .directive('packeryObject', [ packeryObjectTemplateDirective ])
    .directive('packeryObject', [ packeryObjectDirective ]);

  angular
    .module('packeryTemplates', []).run([ '$templateCache', packeryTemplates ]);

})();
angular.module('app.corelib').directive('numericOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, modelCtrl) {

            modelCtrl.$parsers.push(function (inputValue) {
                var transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g, '') : null;

                if (transformedInput != inputValue) {
                    modelCtrl.$setViewValue(transformedInput);
                    modelCtrl.$render();
                }

                return transformedInput;
            });
        }
    };
});
/**
 * Numeric directive.
 * Version: 0.9.8
 * 
 * Numeric only input. Limits input to:
 * - max value: maximum input value. Default undefined (no max).
 * - min value: minimum input value. Default undefined (no min).
 * - decimals: number of decimals. Default 2.
 * - formatting: apply thousand separator formatting. Default true.
 */
(function () {
    'use strict';

    /* global angular */
    angular
        .module('purplefox.numeric', [])
        .directive('numeric', numeric);

    numeric.$inject = ['$locale'];

    function numeric($locale) {
        // Usage:
        //     <input type="text" decimals="3" min="-20" max="40" formatting="false" ></input>
        // Creates:
        // 
        var directive = {
            link: link,
            require: 'ngModel',
            restrict: 'A'
        };
        return directive;


        function link(scope, el, attrs, ngModelCtrl) {
            var decimalSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
            var groupSeparator = $locale.NUMBER_FORMATS.GROUP_SEP;

            // Create new regular expression with current decimal separator.
            var NUMBER_REGEXP = "^\\s*(\\-|\\+)?(\\d+|(\\d*(\\.\\d*)))\\s*$";
            var regex = new RegExp(NUMBER_REGEXP);

            var formatting = true;
            var maxInputLength = 16;            // Maximum input length. Default max ECMA script.
            var max;                            // Maximum value. Default undefined.
            var min;                            // Minimum value. Default undefined.
            var decimals = 2;                   // Number of decimals. Default 2.
            var lastValidValue;                 // Last valid value.

            // Create parsers and formatters.
            ngModelCtrl.$parsers.push(parseViewValue);
            ngModelCtrl.$parsers.push(minValidator);
            ngModelCtrl.$parsers.push(maxValidator);
            ngModelCtrl.$formatters.push(formatViewValue);

            el.bind('blur', onBlur);        // Event handler for the leave event.
            el.bind('focus', onFocus);      // Event handler for the focus event.

            // Put a watch on the min, max and decimal value changes in the attribute.
            scope.$watch(attrs.min, onMinChanged);
            scope.$watch(attrs.max, onMaxChanged);
            scope.$watch(attrs.decimals, onDecimalsChanged);
            scope.$watch(attrs.formatting, onFormattingChanged);

            // Setup decimal formatting.
            if (decimals > -1) {
                ngModelCtrl.$parsers.push(function (value) {
                    return (value) ? round(value) : value;
                });
                ngModelCtrl.$formatters.push(function (value) {
                    return (value) ? formatPrecision(value) : value;
                });
            }

            function onMinChanged(value) {
                if (!angular.isUndefined(value)) {
                    min = parseFloat(value);
                    lastValidValue = minValidator(ngModelCtrl.$modelValue);
                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
                    ngModelCtrl.$render();
                }
            }

            function onMaxChanged(value) {
                if (!angular.isUndefined(value)) {
                    max = parseFloat(value);
                    maxInputLength = calculateMaxLength(max);
                    lastValidValue = maxValidator(ngModelCtrl.$modelValue);
                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
                    ngModelCtrl.$render();
                }
            }

            function onDecimalsChanged(value) {
                if (!angular.isUndefined(value)) {
                    decimals = parseFloat(value);
                    maxInputLength = calculateMaxLength(max);
                    if (lastValidValue !== undefined) {
                        ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
                        ngModelCtrl.$render();
                    }
                }
            }

            function onFormattingChanged(value) {
                if (!angular.isUndefined(value)) {
                    formatting = (value !== false);
                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
                    ngModelCtrl.$render();
                }
            }

            /**
             * Round the value to the closest decimal.
             */
            function round(value) {
                var d = Math.pow(10, decimals);
                return Math.round(value * d) / d;
            }

            /**
             * Format a number with the thousand group separator.
             */
            function numberWithCommas(value) {
                if (formatting) {
                    var parts = value.toString().split(decimalSeparator);
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
                    return parts.join(decimalSeparator);
                }
                else {
                    // No formatting applies.
                    return value;
                }
            }

            /**
             * Format a value with thousand group separator and correct decimal char.
             */
            function formatPrecision(value) {
                if (!(value || value === 0)) {
                    return '';
                }
                var formattedValue = parseFloat(value).toFixed(decimals);
                formattedValue = formattedValue.replace('.', decimalSeparator);
                return numberWithCommas(formattedValue);
            }

            function formatViewValue(value) {
                return ngModelCtrl.$isEmpty(value) ? '' : '' + value;
            }

            /**
             * Parse the view value.
             */
            function parseViewValue(value) {
                if (angular.isUndefined(value)) {
                    value = '';
                }
                value = value.toString().replace(decimalSeparator, '.');

                // Handle leading decimal point, like ".5"
                if (value.indexOf('.') === 0) {
                    value = '0' + value;
                }

                // Allow "-" inputs only when min < 0
                if (value.indexOf('-') === 0) {
                    if (min >= 0) {
                        value = null;
                        ngModelCtrl.$setViewValue(formatViewValue(lastValidValue));
                        ngModelCtrl.$render();
                    }
                    else if (value === '-') {
                        value = '';
                    }
                }

                var empty = ngModelCtrl.$isEmpty(value);
                if (empty) {
                    lastValidValue = '';
                    //ngModelCtrl.$modelValue = undefined;
                } 
                else {
                    if (regex.test(value) && (value.length <= maxInputLength)) {
                        if (value > max) {
                            lastValidValue = max;
                        }
                        else if (value < min) {
                            lastValidValue = min;
                        }
                        else {
                            lastValidValue = (value === '') ? null : parseFloat(value);
                        }
                    }
                    else {
                        // Render the last valid input in the field
                        ngModelCtrl.$setViewValue(formatViewValue(lastValidValue));
                        ngModelCtrl.$render();
                    }
                }

                return lastValidValue;
            }

            /**
             * Calculate the maximum input length in characters.
             * If no maximum the input will be limited to 16; the maximum ECMA script int.
             */
            function calculateMaxLength(value) {
                var length = 16;
                if (!angular.isUndefined(value)) {
                    length = Math.floor(value).toString().length;
                }
                if (decimals > 0) {
                    // Add extra length for the decimals plus one for the decimal separator.
                    length += decimals + 1; 
                }
                if (min < 0) {
                    // Add extra length for the - sign.
                    length++;
                }
                return length;
            }

            /**
             * Minimum value validator.
             */
            function minValidator(value) {
                if (!angular.isUndefined(min)) {
                    if (!ngModelCtrl.$isEmpty(value) && (value < min)) {
                        return min;
                    } else {
                        return value;
                    }
                }
                else {
                    return value;
                }
            }

            /**
             * Maximum value validator.
             */
            function maxValidator(value) {
                if (!angular.isUndefined(max)) {
                    if (!ngModelCtrl.$isEmpty(value) && (value > max)) {
                        return max;
                    } else {
                        return value;
                    }
                }
                else {
                    return value;
                }
            }


            /**
             * Function for handeling the blur (leave) event on the control.
             */
            function onBlur() {
                var value = ngModelCtrl.$modelValue;
                if (!angular.isUndefined(value)) {
                    // Format the model value.
                    ngModelCtrl.$viewValue = formatPrecision(value);
                    ngModelCtrl.$render();
                }
            }

            
            /**
             * Function for handeling the focus (enter) event on the control.
             * On focus show the value without the group separators.
             */
            function onFocus() {
                var value = ngModelCtrl.$modelValue;
                if (!angular.isUndefined(value) && value != null) {
                    ngModelCtrl.$viewValue = value.toString().replace(".", decimalSeparator);
                    ngModelCtrl.$render();
                }
            }
        }
    }

})();

/**
 * NotifierService
 * Alloc8
 * by rcnet 8.8.2018
 *
 * Nice abstraction of Pub-Subs event emitter
 */
(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('notifierService', notifierService);

    /** @ngInject */
    function notifierService($rootScope) {
        var service = {
            subscribe: subscribe,
            notify: notify
        };

        var myscope = $rootScope.$new(true);

        return service;

        function subscribe(scope, callback) {
            var handler = myscope.$on('urn:notifying-service-events', callback);
            scope.$on('$destroy', handler);
        }

        function notify(data) {
            myscope.$emit('urn:notifying-service-events', data);
        }
    };

})();
(function() {
    'use strict';

    angular.module('app.corelib')
        .service('notificationService', notificationService);

    function notificationService(todoNotificationService, $mdToast) {
        var service = {
            showNotifications: showNotifications,
            showToast: showToast
        };

        return service;

        function showNotifications(resp) {
            // Update side panel todo notifications
            todoNotificationService.refreshNotifications({
                refreshMode: todoNotificationService.refreshOptions.getUnread
            });
        }

        function showToast(textContent) {
            $mdToast.show($mdToast.simple()
                .textContent(textContent)
                .position('bottom right')
                .hideDelay(3000));
        }
    };
})();

(function(){

  'use strict';

  var lat = null;
  var lng = null;
  var getLocation = function( addressObj, fallback, callback ){

    // # Get location coords
    try{
      lat = addressObj.geometry.location.A;
      lng = addressObj.geometry.location.F;
      return new google.maps.LatLng( lat, lng );
    }catch(e){
      return new google.maps.LatLng( fallback.lat, fallback.lng );
    }
  };


  angular.module('ngPlacesMap', [])
    .filter('gps', function() {
      return function(input,field) {
        var json;
        try{
          json = JSON.parse(input);
        }catch(e){
          json = false;
        }
        return json && json[field] ? json[field] : '';
      };
    })
    .directive( 'placesMap', function($http){
      return {
        restrict:'E',
        replace: true,
        scope:{
          customCallback: '&?',
          picked: '=?',
          textInput: '=',
          address: '=?',
          fallback: '=?',
          mapType: '@?',
          readonly: '@?',
          responsive: '@?',
          draggable: '@?',
          toggleMapDraggable: '=?',
          placeNotFound: '=?',
          updateMarkerLabel: '=?',
          redrawMap: '=?',
          mapOptions: '=?',
          country: '@',
          static: '@'
        },
        controller: ['$scope', '$http', function ($scope, $http) {}],
        template: '<div class="dp-places-map-wrapper"><input type="text" ng-model="textInput" class="dp-places-map-input"><div class="dp-places-map-canvas"></div></div>',

        link: function( $scope, element, attrs, controller){

          var isCurrentlyDraggable = $scope.draggable == 'true';

          $scope.toggleMapDraggable = function( draggable ){
            isCurrentlyDraggable = draggable;
            map.setOptions({draggable:isCurrentlyDraggable,scrollwheel:isCurrentlyDraggable});
          };

          $scope.updateMarkerLabel = function( label ){
            infowindow.setContent( label );
          };

          if( $scope.redrawMap ){
            $scope.redrawMap.updateMap = function( address ){
              var latlng = new google.maps.LatLng( address.lat, address.lng );
              placeMarker( latlng, false, false);
              map.setCenter( latlng );
            };
          }

          var defaultMapOptions;
          if ($scope.static && $scope.static == 'true') {
            defaultMapOptions = {
              zoom: 15,
              draggable: false,
              panControl: false,
              zoomControl: false,
              scrollwheel: false,
              mapTypeControl: false,
              streetViewControl: false,
              clickableIcons: false
            };
          } else {
            defaultMapOptions = {zoom: 15};
          }


          var mapOptions = angular.extend(defaultMapOptions, $scope.mapOptions);

          var providedAddress = {};
          if( $scope.address ){
            providedAddress = $scope.address;
            mapOptions.zoom = $scope.address.zoom || 15;
          }

          var fallbackAddress = {};
          // # If fallback is not provided use this coords

          fallbackAddress.lat = -23.189058;
          fallbackAddress.lng =  132.994012;

          // fallbackAddress.lat = 39.33429742980724;
          // fallbackAddress.lng =  -102.0849609375;

          if( $scope.fallback ){
            fallbackAddress = $scope.fallback;
            mapOptions.zoom = $scope.fallback.zoom || mapOptions.zoom;
          }

          if( $scope.draggable && $scope.draggable == 'false'){
            mapOptions.draggable = false;
            mapOptions.scrollwheel = false;
          }

          // # Set map type if provided
          if( $scope.mapType && google.maps.MapTypeId[$scope.mapType] ){
            mapOptions.mapTypeId = google.maps.MapTypeId[$scope.mapType];
          }

          // # Get place from coords and Set map center
          mapOptions.center = getLocation( providedAddress, fallbackAddress );

          var canvas = element.find('div')[0];
          var input = element.find('input')[0];

          if( $scope.responsive && $scope.responsive == 'true' ){
            canvas.className += ' responsive';
          }

          // # Create map
          var map = new google.maps.Map( canvas, mapOptions );

          // # Init place service
          var placeService = new google.maps.places.PlacesService( map );

          // # Init geocoder service
          var geocoder = new google.maps.Geocoder();

          // # Prepare Marker
          var marker = new google.maps.Marker({
            map: map,
            anchorPoint: new google.maps.Point(0, -29),
            draggable : true
          });
          // # Prepare InfoWindow
          var infowindow = new google.maps.InfoWindow();

          // # Place input field
          if( !$scope.readonly ){
            map.controls[ google.maps.ControlPosition.TOP_LEFT ].push( input );
          }else{
            input.style.display = 'none';
          }

          // # Add autocomplete
          var options = {
            types: ['geocode'],
            componentRestrictions: $scope.country !== undefined ? {country: $scope.country} : null
          };

          var autocomplete = new google.maps.places.Autocomplete(input, options);
          autocomplete.bindTo('bounds', map);

          var placeAutocompleteMarker = function( place, customAddress, executeCallback ){

            // # Get geometry
            if( !place.geometry ){
              if(typeof $scope.placeNotFound == 'function'){
                $scope.placeNotFound();
              }else{
                alert('Pick a valid location');
              }
              return;
            }

            // # If the place has a geometry, then present it on a map.
            if( place.geometry.viewport ){
              map.fitBounds( place.geometry.viewport );
            }else{
              map.setCenter( place.geometry.location  );
              map.setZoom( ( $scope.address && $scope.address.zoom ) ? $scope.address.zoom : 15 );
            }

            var address = '';
            var infoWindowContent = '';

            if( !customAddress ){

              if( place.address_components ) {
                address = [
                  (place.address_components[0] && place.address_components[0].short_name || ''),
                  (place.address_components[1] && place.address_components[1].short_name || ''),
                  (place.address_components[2] && place.address_components[2].short_name || '')
                ].join(' ');
              }

              if( address !== '' ){
                infoWindowContent = '<div><strong>' + place.name + '</strong><br>' + address + '</div>';
              }

            }else{

              infoWindowContent = customAddress;
              place.geometry.address = providedAddress;
              place.formatted_address = providedAddress;

            }

            updateMapAndScope( place.geometry.location, infoWindowContent, place, executeCallback );
          };

          var placeMarker = function( location, customAddress, executeCallback ){
            // # Build LatLng
            var lat1 = location.lat();
            var lng2 = location.lng();

            var latlng = new google.maps.LatLng(location.lat(), location.lng());

            // # Close info window
            infowindow.close();

            // # Build place object
            var place = {};
            place.place_id = null;
            place.geometry = {};
            place.geometry.location = {
              A : location.lat(),
              F : location.lng()
            };
            var infoWindowContent = '';

            // # If customAddress is not provided query API, else just show
            // # provided information
            if( !customAddress ){

              // # Query maps api
              geocoder.geocode( {'location' : latlng}, function( result, status ){

                var address = '';

                if( status === google.maps.GeocoderStatus.OK && result[0]){
                  if( result[0].address_components ) {
                    address = [
                      (result[0].address_components[0] && result[0].address_components[0].short_name || ''),
                      (result[0].address_components[1] && result[0].address_components[1].short_name || ''),
                      (result[0].address_components[2] && result[0].address_components[2].short_name || '')
                    ].join(' ');
                  }
                }

                if( address !== '' ){
                  //infoWindowContent = '<div><strong>' + address + '</strong></div>';
                }else{
                  address = location.lat() + ', ' + location.lng();
                }

                place.geometry.address = address;
                place.formatted_address = address;

                marker.setPosition( latlng );
                marker.setVisible( true );
                //input.value = result[0].formatted_address;
                markerChange();
                updateMapAndScope( location, infoWindowContent, place, executeCallback );

              });

            }else{
              infoWindowContent = customAddress;
              place.geometry.address = providedAddress;
              place.formatted_address = providedAddress;

              updateMapAndScope( location, infoWindowContent, place, executeCallback );
            }

          };

          var placeMarker2 = function( lat, lng, latlng2, customAddress, executeCallback ){
            // # Build LatLng
            var latlng = new google.maps.LatLng(lat, lng);

            // # Close info window
            infowindow.close();

            // # Build place object
            var place = {};
            place.place_id = null;
            place.geometry = {};
            place.geometry.location = {
              A : lat,
              F : lng
            };
            var infoWindowContent = '';

            // # If customAddress is not provided query API, else just show
            // # provided information
            if( !customAddress ){

              // # Query maps api
              geocoder.geocode( {'location' : latlng}, function( result, status ){

                var address = '';

                if( status === google.maps.GeocoderStatus.OK && result[0]){
                  if( result[0].address_components ) {
                    address = [
                      (result[0].address_components[0] && result[0].address_components[0].short_name || ''),
                      (result[0].address_components[1] && result[0].address_components[1].short_name || ''),
                      (result[0].address_components[2] && result[0].address_components[2].short_name || '')
                    ].join(' ');
                  }
                }

                if( address !== '' ){
                  //infoWindowContent = '<div><strong>' + address + '</strong></div>';
                }else{
                  address = lat + ', ' + lng;
                }

                place.geometry.address = address;
                place.formatted_address = address;
                
                marker.setPosition(latlng);
                marker.setVisible( true );
                //input.value = result[0].formatted_address;

                var lat4 = parseFloat(lat);
                var lng5 = parseFloat(lng);
                var latlng = {lat:lat4, lng:lng5}
                geocoder.geocode({'location':latlng}, function( result, status ){
                  if( status === google.maps.GeocoderStatus.OK ){
                    input.value = result[0].formatted_address;
                    result[0]['Lat'] = lat4;
                    result[0]['Lng'] = lng5;
                    $scope.customCallback( { pickedPlace : result[0]});
                  }
                });

                updateMapAndScope( location, infoWindowContent, place, executeCallback );

              });

            }else{
              infoWindowContent = customAddress;
              place.geometry.address = providedAddress;
              place.formatted_address = providedAddress;

              updateMapAndScope( location, infoWindowContent, place, executeCallback );
            }

          };

          var updateMapAndScope = function( location, infoWindowContent, place, executeCallback ){

            // # Hide marker and info window
            infowindow.close();
            marker.setVisible( false );

            // # Update and show info window if has content
            if( infoWindowContent !== '' ){
              infowindow.setContent( infoWindowContent );
              //infowindow.open( map, marker );
            }
            if(!place.geometry.location.A && !place.geometry.location.F) {
              var latlng = new google.maps.LatLng(lat, lng);
            } else {
              var latlng = new google.maps.LatLng(place.geometry.location.A, place.geometry.location.F);
            }

            // # Update and show marker
            marker.setPosition( latlng );
            marker.setVisible( true );
            //Map Fix

            // # Update scope var (if any)
            $scope.picked = place;

            if (!place.geometry.location.lat || typeof place.geometry.location.lat !== 'function'){
              place.geometry.location.lat = function(){
                return place.geometry.location.A;
              };
            }

            if (!place.geometry.location.lng || typeof place.geometry.location.lng !== 'function'){
              place.geometry.location.lng = function(){
                return place.geometry.location.F;
              };
            }

            if( executeCallback ){
              // # Execute callback function (if any)
              place['Lat'] = place.geometry.location.A || place.geometry.location.lat();
              place['Lng'] = place.geometry.location.F || place.geometry.location.lng();
              $scope.customCallback({ pickedPlace : place });
            }

            // # Apply
            $scope.$apply();

          };

          var locationChange = function(){
            infowindow.close();
            marker.setVisible( false );
            var place = autocomplete.getPlace();
            if (!place || !place.geometry || !place.geometry.location) {
              // Trigger a search request if no place is selected
              placeService.textSearch({ query: input.value }, function(placeResult, status) {
                if (status === google.maps.places.PlacesServiceStatus.OK && placeResult[0]) {
                    lat = placeResult[0].geometry.location.lat();
                    lng = placeResult[0].geometry.location.lng();
                    placeAutocompleteMarker( placeResult[0], null, true );
                }        
              });
            } else {
                lat = place.geometry.location.lat();
                lng = place.geometry.location.lng();
                placeAutocompleteMarker( place, null, true );
            }
          };

          //Added function to fetch cmarker position
          var markerChange = function(){
            let position = marker.getPosition();
            let lat = position.lat();
            let lng = position.lng();
            let latlng = {lat:lat, lng:lng}
            geocoder.geocode({'location':latlng}, function( result, status ){
              if( status === google.maps.GeocoderStatus.OK ){
                input.value = result[0].formatted_address;
                  result[0]['Lat'] = lat;
                  result[0]['Lng'] = lng;
                  $scope.customCallback( { pickedPlace : result[0] });
              }
            });
          }


          // # Create marker for saved position

          // # If providedAddress has a place_id, use placeService to retrieve information
          if( providedAddress.place_id ){
            // # Ajax request to API
            placeService.getDetails({placeId: providedAddress.place_id},function( place, status ){
              if( status === google.maps.places.PlacesServiceStatus.OK ){
                // # Place marker
                placeAutocompleteMarker( place, providedAddress.address, false );
              }
            });
          }else if(providedAddress.hasOwnProperty('geometry')){
            // # Just place a pin
            var latlng = new google.maps.LatLng(providedAddress.geometry.location.A, providedAddress.geometry.location.F);
            geocoder.geocode({'location':latlng}, function( result, status ){
              if( status === google.maps.GeocoderStatus.OK ){

                var latlng = new google.maps.LatLng(providedAddress.geometry.location.A, providedAddress.geometry.location.F);
                placeMarker2(providedAddress.geometry.location.A, providedAddress.geometry.location.F, latlng, providedAddress.address, false );
              }
            });

          }

          // # Autocomplete listener
          google.maps.event.addListener(autocomplete, 'place_changed', locationChange );
          google.maps.event.addListener(marker, 'dragend', markerChange);
          google.maps.event.addListener(marker, 'dblclick', markerChange);

          // # Responsive utils listener
          google.maps.event.addDomListener(window, "resize", function() {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
          });

          google.maps.event.addListener(map, 'click', function(evt) {
            if(isCurrentlyDraggable){
              placeMarker( evt.latLng, null, true );
            }
          });
        }
      };
    });

}());

'use strict';
angular.module('ngPlacesAutocomplete', [])
  .directive('singleAddress', function () {
    var moduleString = '[ngPlacesAutocomplete] - ' // ModuleString is used for Errors for better identification
      // Mapping from the actual optins object to the functions to set them on the autocomplete
      , optionNameToFunc = {
        'bounds': 'setBounds',
        'types': 'setTypes',
        'componentRestrictions': 'setComponentRestrictions'
      }
      , defaultOptions = {
        'bounds': null,
        'types': [],
        'componentRestrictions': null,
        'bindTo': null,
        'updateModel': false,
        'watchOptions': false,
        'preventSubmit': true
      };


    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        callBack: '&',
        paTrigger: '=?',
        country: '@'
      },
      link: function (scope, element, attributes, ngModel) {
        var paOptions = {
          updateModel: true,
          componentRestrictions: scope.country !== undefined ? { country: scope.country } : null
        }

        if (!google.maps || !google.maps.places) {
          throw new Error(moduleString + 'Google Places Service not found!');
        }

        // Instantiate the autocompleteion feature on the current element
        var autocomplete = new google.maps.places.Autocomplete(element[0], {}),
          acService = new google.maps.places.AutocompleteService(), // acService needed to manual search
          dummyDiv = angular.element('<div>')[0], // we need a dummy div since the placesService needs an HTML Element (usually a map) to be instantiated
          placesService = new google.maps.places.PlacesService(dummyDiv); // PlacesService needed for detailed search

        /**
         * On place_changed event either send the result if any, or execute a manual-search
         */
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          element[0].blur();
          var result = autocomplete.getPlace();
          if (result.address_components) {
            scope.$apply(function () {
              // An empty search just returns an object with on property "name" which contains the used query:
              // { name: <query> } - so only if there is the address_components field it means we have an actual result
              if (paOptions.updateModel) {
                ngModel.$setViewValue(result.formatted_address);
              }
              (scope.callBack() || angular.noop)(result);
            });
          }
          else {
            manualSearch();
          }
        });

        /**
         * The manual search first uses the Autocomplete-Service to get Place-Predictions. We could also use the
         * PlacesService.textSearch here, but the problem is that it doesnt support (yet?) the same options as
         * autocompletion (especially the componentRestriction to a country). We then take the first prediction
         * if any and use the PlacesService to do a detailed search about it.
         *
         * Credit for this idea actually goes to "wpalahnuk" who did this in his ngAutocomplete-Directive
         * (https://github.com/wpalahnuk/ngAutocomplete)
         */
        var manualSearch = function () {
          element[0].blur();
          if (!ngModel.$viewValue) {
            (scope.callBack() || angular.noop)(null);
          }
          // Create the query object by using the viewValue
          var queryObject = angular.extend({
            input: ngModel.$viewValue
          }, paOptions);

          acService.getPlacePredictions(queryObject, function (predictionResults) {
            // If there is no result
            if (!predictionResults || predictionResults.length === 0) {
              return scope.$apply(function () {
                (scope.callBack() || angular.noop)(null);
              });
            }
            detailSearch(predictionResults[0].place_id);
          });
        };

        /**
         * The detailSearch takes a placeId (as specified by the google-places-api) and returns a result-object
         * with all the information we need.
         * @param placeId
         */
        var detailSearch = function (placeId) {
          placesService.getDetails({ placeId: placeId }, function (place, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK
              || status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {

              scope.$apply(function () {
                if (paOptions.updateModel) {
                  ngModel.$setViewValue(place.formatted_address);
                  ngModel.$render();
                }
                (scope.callBack() || angular.noop)(place);
              });

            }
            else {
              scope.$apply(function () {
                (scope.callBack() || angular.noop)(null);
              });
            }
          });
        };

        // If the paTrigger is set, assign the manual search function to it so the user is able to trigger it wherever he wants
        if (scope.paTrigger) {
          scope.paTrigger = manualSearch;
        }

        scope.$watch('country', newCountryVal => {
          if (!newCountryVal) {
            return;
          }

          paOptions.componentRestrictions.country = newCountryVal;
          setOptions();
        });

        /**
         * Function to set Options to the autocomplete-instance.
         * It always copies the defaultOptions properties and extends/overwrites this with the options
         * given (if any). Then it uses the optionNameToFunc for every option to correctly set the option
         * on the autocomplete feature.
         */
        function setOptions() {
          if (autocomplete) {
            // Copy the default options and extend the current options.
            paOptions = angular.extend(angular.copy(defaultOptions), paOptions);
            angular.forEach(optionNameToFunc, function (funcName, key) {
              var value = paOptions[key] || undefined;

              // Use the optionNameToFunc to use the right function to set the option
              autocomplete[funcName](value);
            });

            if (paOptions.preventSubmit) {
              element.on('keydown', function (e) {
                if (e.keyCode == 13) {
                  e.preventDefault();
                }
              });
            }
          }
        }

        /**
         * If no options-object given, use the default options.
         * Only put a $watch on the options if the user explicitly wants it. Else, this costs to much ressources
         * and is better just done once.
         */
        if (!angular.isObject(paOptions) || !paOptions.watchOptions) {
          setOptions();
        }
        else {
          scope.$watch('paOptions', function () {
            setOptions();
          }, true);
        }
      }
    };
  }).directive('fullAddress', function () {
    var moduleString = '[ngPlacesAutocomplete] - ' // ModuleString is used for Errors for better identification
      // Mapping from the actual optins object to the functions to set them on the autocomplete
      , optionNameToFunc = {
        'bounds': 'setBounds',
        'types': 'setTypes',
        'componentRestrictions': 'setComponentRestrictions'
      }
      , defaultOptions = {
        'bounds': null,
        'types': [],
        'componentRestrictions': null,
        'bindTo': null,
        'updateModel': false,
        'watchOptions': false,
        'preventSubmit': true
      };


    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        callBack: '&',
        paTrigger: '=?',
        country: '='
      },
      link: function (scope, element, attributes, ngModel) {
        var paOptions = {
          updateModel: true,
          componentRestrictions: scope.country !== undefined ? { country: scope.country } : null
        }

        if (!google.maps || !google.maps.places) {
          throw new Error(moduleString + 'Google Places Service not found!');
        }

        // Instantiate the autocompleteion feature on the current element
        var autocomplete = new google.maps.places.Autocomplete(element[0], {}),
          acService = new google.maps.places.AutocompleteService(), // acService needed to manual search
          dummyDiv = angular.element('<div>')[0], // we need a dummy div since the placesService needs an HTML Element (usually a map) to be instantiated
          placesService = new google.maps.places.PlacesService(dummyDiv); // PlacesService needed for detailed search

        /**
         * On place_changed event either send the result if any, or execute a manual-search
         */
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          element[0].blur();
          var result = autocomplete.getPlace();
          if (result.address_components) {
            scope.$apply(function () {
              // An empty search just returns an object with on property "name" which contains the used query:
              // { name: <query> } - so only if there is the address_components field it means we have an actual result
              if (paOptions.updateModel) {
                ngModel.$setViewValue(result.formatted_address);
              }
              (scope.callBack() || angular.noop)(result);
            });
          }
          else {
            manualSearch();
          }
        });

        /**
         * The manual search first uses the Autocomplete-Service to get Place-Predictions. We could also use the
         * PlacesService.textSearch here, but the problem is that it doesnt support (yet?) the same options as
         * autocompletion (especially the componentRestriction to a country). We then take the first prediction
         * if any and use the PlacesService to do a detailed search about it.
         *
         * Credit for this idea actually goes to "wpalahnuk" who did this in his ngAutocomplete-Directive
         * (https://github.com/wpalahnuk/ngAutocomplete)
         */
        var manualSearch = function () {
          element[0].blur();
          if (!ngModel.$viewValue) {
            (scope.callBack() || angular.noop)(null);
          }
          // Create the query object by using the viewValue
          var queryObject = angular.extend({
            input: ngModel.$viewValue
          }, paOptions);

          acService.getPlacePredictions(queryObject, function (predictionResults) {
            // If there is no result
            if (!predictionResults || predictionResults.length === 0) {
              return scope.$apply(function () {
                (scope.callBack() || angular.noop)(null);
              });
            }
            detailSearch(predictionResults[0].place_id);
          });
        };

        /**
         * The detailSearch takes a placeId (as specified by the google-places-api) and returns a result-object
         * with all the information we need.
         * @param placeId
         */
        var detailSearch = function (placeId) {
          placesService.getDetails({ placeId: placeId }, function (place, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK
              || status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {

              scope.$apply(function () {
                if (paOptions.updateModel) {
                  ngModel.$setViewValue(place.formatted_address);
                  ngModel.$render();
                }
                (scope.callBack() || angular.noop)(place);
              });

            }
            else {
              scope.$apply(function () {
                (scope.callBack() || angular.noop)(null);
              });
            }
          });
        };

        // If the paTrigger is set, assign the manual search function to it so the user is able to trigger it wherever he wants
        if (scope.paTrigger) {
          scope.paTrigger = manualSearch;
        }

        scope.$watch('country', newCountryVal => {
          if (!newCountryVal) {
            return;
          }

          paOptions.componentRestrictions.country = newCountryVal;
          setOptions();
        });

        /**
         * Function to set Options to the autocomplete-instance.
         * It always copies the defaultOptions properties and extends/overwrites this with the options
         * given (if any). Then it uses the optionNameToFunc for every option to correctly set the option
         * on the autocomplete feature.
         */
        function setOptions() {
          if (autocomplete) {
            // Copy the default options and extend the current options.
            paOptions = angular.extend(angular.copy(defaultOptions), paOptions);
            angular.forEach(optionNameToFunc, function (funcName, key) {
              var value = paOptions[key] || undefined;

              // Use the optionNameToFunc to use the right function to set the option
              autocomplete[funcName](value);
            });

            if (paOptions.preventSubmit) {
              element.on('keydown', function (e) {
                if (e.keyCode == 13) {
                  e.preventDefault();
                }
              });
            }
          }
        }

        /**
         * If no options-object given, use the default options.
         * Only put a $watch on the options if the user explicitly wants it. Else, this costs to much ressources
         * and is better just done once.
         */
        if (!angular.isObject(paOptions) || !paOptions.watchOptions) {
          setOptions();
        }
        else {
          scope.$watch('paOptions', function () {
            setOptions();
          }, true);
        }
      }
    };
  });

angular.module('app.corelib').directive('ngEnter', function() {
  return function(scope, element, attrs) {
    element.bind("keydown keypress", function(event) {
      if(event.which === 13) {
        scope.$apply(function(){
          scope.$eval(attrs.ngEnter);
        });

        event.preventDefault();
      }
    });
  };
});

(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('myobService', myobService);

    /** @ngInject */
    function myobService(
        integrationsApi
    ) {

        var service = {
            getMyobTenants: getMyobTenants,
            getMyobEmployees: getMyobEmployees,
            getMyobCompaniesByTenant: getMyobCompaniesByTenant,
            getMyobJobs: getMyobJobs
        };

        return service;

        function getMyobTenants() {
            return integrationsApi.getTenantsByProvider(integrationsApi.providerTypes.myob);
        }

        function getMyobEmployees() {
            return integrationsApi.getEmployeesByProvider(integrationsApi.providerTypes.myob);
        }

        function getMyobCompaniesByTenant(tenantId) {
            return integrationsApi.getCompaniesByProviderAndTenant(integrationsApi.providerTypes.myob, tenantId);
        }

        function getMyobJobs(tenantId) {
            return integrationsApi.getJobsByProvider(integrationsApi.providerTypes.myob, tenantId);
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.corelib')
        .factory('msgboxService', msgboxService);

    function msgboxService($mdDialog) {

        var service = {
            show : show,
            yepNo : yesNo,
            showCustomDialog : showCustomDialog,
            alert : alert,
            showPromptDialog : showPromptDialog
        };

        return service;
        ///////

        function alert(title, message, okay_button){
            return $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title || "System Message")
                    .htmlContent(message)
                    .ariaLabel(message)
                    .ok(okay_button)
                    .multiple(true)
            );
        }

        function showPromptDialog(title, content, placeholder, required, ok, cancel) {
            let prompt = $mdDialog.prompt()
                .title(title)
                .textContent(content)
                .placeholder(placeholder)
                .ariaLabel(placeholder)
                .required(required)
                .ok(ok)
                .cancel(cancel);
            return $mdDialog.show(prompt);
        }

        function show(msg, title) {
            let titleMsg = title || 'System Message';

            var confirm = $mdDialog.alert()
                .title(titleMsg)
                .htmlContent(msg)
                .ariaLabel(titleMsg)
                .ok('Close')
                .multiple(true)

            return $mdDialog.show(confirm);
        }

        function yesNo(msg, title, okButton, cancelButton) {
            let titleMsg = title || 'System Message';

            var confirm = $mdDialog.confirm()
                .title(titleMsg)
                .ariaLabel(titleMsg)
                .htmlContent(msg)
                .ok(okButton || 'Yes')
                .cancel(cancelButton || 'No');

            return $mdDialog.show(confirm);
        }

        function showCustomDialog(template, controller, locals){
            return $mdDialog.show({
                templateUrl : template,
                controller : controller,
                locals : locals
            })
        }
    }
})();

/**
 * Identity Service
 * - Handles user data services
 * rcnet 6.6.2016
 */
(function () {
    'use strict';

    angular.module('app.corelib')
        .factory('mediaQueryService', mediaQueryService);

    /** @ngInject */
    function mediaQueryService($mdMedia) {

        var service = {
            isDeviceBig: isDeviceBig,
            isDeviceSmall: isDeviceSmall,
            isDeviceXS: isDeviceXS,
            isDeviceSM: isDeviceSM,
            isDeviceMD: isDeviceMD,
            isDeviceLG: isDeviceLG,
            isDeviceXL: isDeviceXL,
            isDeviceResourceLarge: isDeviceResourceLarge,
            isDeviceResourceBig: isDeviceResourceBig,
            isDeviceResourceMedium: isDeviceResourceMedium,
            isDeviceResourceBetweenBigAndLarge: isDeviceResourceBetweenBigAndLarge,
            isDeviceResource738PX: isDeviceResource738PX,
            isDeviceTablet: isDeviceTablet,
            isDevicePhone: isDevicePhone,
            isDeviceTablet2: isDeviceTablet2,
            isDraggableSmall: isDraggableSmall,
            isResourceView1: isResourceView1,
            isResourceView2: isResourceView2,
            isResourceView3: isResourceView3,
            isResourceView4: isResourceView4,
            isResourceView5: isResourceView5,
            isDeviceMessagingBig: isDeviceMessagingBig,
            isDeviceMessagingSmall: isDeviceMessagingSmall,
            isDevice1457 : isDevice1457,
            isDeviceBetweenConfigOptions : isDeviceBetweenConfigOptions,
            isDevice1426 : isDevice1426,
            isDeviceLessThan1426 : isDeviceLessThan1426,
            showFilter : showFilter
        }

        function isDeviceXS() {
            return $mdMedia('xs');
        }

        function isDeviceSM() {
            return $mdMedia('sm');
        }

        function isDeviceMD() {
            return $mdMedia('md');
        }

        function isDeviceLG() {
            return $mdMedia('lg');
        }

        function isDeviceXL() {
            return $mdMedia('xl');
        }

        function isDeviceBig() {
            return isDeviceXL() || isDeviceLG() || isDeviceMD();
        }

        function isDeviceSmall() {
            return isDeviceSM() || isDeviceXS();
        }

        //Resource Allocation Services
        function isDeviceResourceLarge() {
            return $mdMedia('min-width : 1464px');
        }

        function isDeviceResourceBetweenBigAndLarge() {
            return $mdMedia('min-width : 1025px') && $mdMedia('max-width : 1463px');
        }

        function isDeviceResourceBig() {
            return $mdMedia('min-width : 960px') && $mdMedia('max-width : 1024px');
        }

        function isDeviceResourceMedium() {
            return $mdMedia('min-width : 883px') && $mdMedia('max-width : 959px');
        }

        function isDeviceResource738PX() {
            return $mdMedia('min-width : 0px') && $mdMedia('max-width : 738px');
        }

        function isDeviceTablet2() {
            return $mdMedia('min-width : 739px') && $mdMedia('max-width : 882px');
        }

        function isDeviceTablet() {
            return $mdMedia('min-width : 565px') && $mdMedia('max-width : 738px');
        }

        function isDevicePhone() {
            return $mdMedia('min-width : 0px') && $mdMedia('max-width : 564px');
        }

        function isDraggableSmall() {
            return $mdMedia('min-width : 0px') && $mdMedia('max-width : 376px');
        }

        function isResourceView1() {
            return $mdMedia('min-width : 1550px');
        }

        function isResourceView2() {
            return $mdMedia('min-width : 1046px') && $mdMedia('max-width : 1549px');
        }

        function isResourceView3() {
            return $mdMedia('min-width : 960px') && $mdMedia('max-width : 1045px');
        }

        function isResourceView4() {
            return $mdMedia('min-width : 805px') && $mdMedia('max-width : 959px');
        }

        function isResourceView5() {
            return $mdMedia('min-width : 0px') && $mdMedia('max-width : 804px');
        }

        //Resource Allocation Services

        //Messaging Particular Functions
        function isDeviceMessagingBig() {
            return isDeviceXL() || isDeviceLG();
        }

        function isDeviceMessagingSmall() {
            return isDeviceSM() || isDeviceXS() || isDeviceMD();
        }

        function isDevice1457(){
            return $mdMedia('min-width : 0px') && $mdMedia('max-width : 1563px');
        }

        //Messaging Particular Functions

        //config options
        function isDeviceBetweenConfigOptions(){
            return $mdMedia('min-width : 597px') && $mdMedia('max-width : 1062px');
        }
        //config options

        //Exception Report
        function isDevice1426(){
            return $mdMedia('min-width : 1426px');
        }

        function isDeviceLessThan1426(){
            return $mdMedia('max-width : 1425px');
        }

        function showFilter(){
            return isDeviceXS() || isDeviceSM() || isDeviceMD() || isDeviceLG();
        }
        //Exception Report


        return service;

    }
})();

angular.module('app.corelib').directive('stickyContacts', function($mdSticky, $compile) {
    return {
        restrict: 'A',
        link: function(scope,element) {
            $mdSticky(scope, element);
        }
    };
});

angular.module('app.corelib').directive('mdInputIcon', function ($compile) {
    return {
        scope: {
            mdInputIcon: '='
        },
        compile: function(element, attributes) {
            var linkFunction = function($scope, element, attributes) {
                var icon = $compile('<md-icon ng-show="mdInputIcon" class="md-input-icon" md-font-icon="{{mdInputIcon}}"></md-icon>')($scope);
                element.prepend(icon);
            }
            return linkFunction;
       }
  };
});
/**
 * Locale Formatter Service
 * Depends on the country set
 */
(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('localizedService', localizedService);

    function localizedService(
        tenantSettings,
        localisationApi,
        exceptionService,
        localStorageService
    ) {
        const CACHE_KEY = 'urn:localisation:localeSettings';

        var service = {
            getLocaleFormatSettings: getLocaleFormatSettings,
            getLocaleFormatSettingsCached: getLocaleFormatSettingsCached
        };

        activate();

        return service;

        function activate() {
            getLocalisationFieldSettings();
        }

        function getLocaleFormatSettingsCached() {
            var cacheLocaleFormatSetting = localStorageService.get(CACHE_KEY);
            return cacheLocaleFormatSetting;
        }

        function getLocaleFormatSettings() {
            return getLocalisationFieldSettings();
        }

        function getDefaultTimeFormat() {
            return 24;
        }

        function getLocalisationFieldSettings() {

            return localisationApi.getFieldSettings().then(response => {
                var settings = {
                    isoDateTime: 'YYYY-MM-DD HH:mm:ss',
                    isoDateTimeWithSlash: 'YYYY/MM/DD HH:mm:ss',
                    timeFormatSettings: getDefaultTimeFormat(),
                    gmapCountry: tenantSettings.countryCode,
                };

                settings['bankAccountNumber'] = _.find(response, function(o) {
                    return o.fieldKey === 'BankAccountNumber';
                }).settings;

                settings['bankBranchCode'] = _.find(response, function(o) {
                    return o.fieldKey === 'BankBranchCode';
                }).settings;

                settings['registeredBusinessNumber'] = _.find(response, function(o) {
                    return o.fieldKey === 'RegisteredBusinessNumber';
                }).settings;

                var localeFormatSetting = _.find(response, function(o) {
                    return o.fieldKey === 'LocaleFormatSetting';
                }).settings;

                if (localeFormatSetting) {
                    var t12HourTimeFormat = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 't12HourTimeFormat';
                    }).settingValue; //hh:mm:ss a
                    var t24HourTimeFormat = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 't24HourTimeFormat';
                    }).settingValue; //HH:mm:ss
                    var t12HourTimeFormat2 = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 't12HourTimeFormat2';
                    }).settingValue; //hh:mm a
                    var t24HourTimeFormat2 = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 't24HourTimeFormat2';
                    }).settingValue; //HH:mm

                    settings['timeFormat'] = getDefaultTimeFormat() == 12 ? t12HourTimeFormat : t24HourTimeFormat;

                    settings['timeFormat2'] = getDefaultTimeFormat() == 12 ? t12HourTimeFormat2 : t24HourTimeFormat2;

                    settings['t12HourTimeFormat'] = t12HourTimeFormat;

                    settings['t24HourTimeFormat'] = t24HourTimeFormat;

                    settings['firstDayOfWeek'] = parseInt(_.find(localeFormatSetting, function(o) {
                        return o.settingKey === 'FirstDayOfWeek';
                    }).settingValue);

                    settings['dateFormat'] = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 'DateFormat';
                    }).settingValue;

                    settings['shortdateFormatWithSlash'] = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 'ShortdateFormatWithSlash';
                    }).settingValue;

                    settings['displayDateFormat'] = settings['shortdateFormatWithSlash'];

                    settings['dateTimeFormatWithSlash'] = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 'DateTimeFormatWithSlash';
                    }).settingValue;

                    settings['minDate'] = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 'MinDate';
                    }).settingValue;

                    settings['serverDefaultDateFormat'] = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 'ServerDefaultDateFormat';
                    }).settingValue;

                    settings['longDateFormat1'] = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 'LongDateFormat1';
                    }).settingValue;

                    settings['longDateFormat2'] = _.find(localeFormatSetting, function(o) {
                        return o.settingKey === 'LongDateFormat2';
                    }).settingValue;
                }

                localStorageService.set(CACHE_KEY, settings);

                return settings;
            }).catch(function(ex) {
                var settings = {
                    isoDateTime: 'YYYY-MM-DD HH:mm:ss',
                    isoDateTimeWithSlash: 'YYYY/MM/DD HH:mm:ss',
                    displayDateFormat: 'DD/MM/YYYY',
                    timeFormatSettings: getDefaultTimeFormat(),
                    gmapCountry: tenantSettings.countryCode,
                    firstDayOfWeek: 1, // Monday
                    dateFormat: 'DD MMM YYYY',
                    shortdateFormatWithSlash: 'DD/MM/YYYY',
                    dateTimeFormatWithSlash: 'DD/MM/YYYY HH:mm:ss',
                    minDate: '01 JAN 1900',
                    serverDefaultDateFormat: 'MM/DD/YYYY HH:mm:ss',
                    longDateFormat1: 'MMMM DD, YYYY HH:mm',
                    longDateFormat2: 'MMMM DD, YYYY HH:mm:ss',
                    timeFormat: getDefaultTimeFormat() == 12 ? 'hh:mm:ss a' : 'HH:mm:ss', // With seconds
                    timeFormat2: getDefaultTimeFormat() == 12 ? 'hh:mm a' : 'HH:mm', // Without seconds part
                    t12HourTimeFormat: 'hh:mm:ss a',
                    t24HourTimeFormat: 'HH:mm:ss',
                };

                exceptionService.resolve(ex);

                return settings;
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.corelib')
        .provider('localisationService', localisationServiceProvider);

    /** @ngInject **/
    function localisationServiceProvider()
    {
        var settings = {
            isoDateTime: 'YYYY-MM-DD HH:mm:ss',
            isoDateTimeWithSlash: 'YYYY/MM/DD HH:mm:ss',
            gmapCountry: null,
            firstDayOfWeek: 1, // Monday
            dateFormat: 'DD MMM YYYY',
            shortdateFormatWithSlash: 'DD/MM/YYYY',
            dateTimeFormatWithSlash: 'DD/MM/YYYY HH:mm:ss',
            displayDateFormat: 'DD/MM/YYYY',
            minDate: '01 JAN 1900',
            serverDefaultDateFormat: 'MM/DD/YYYY HH:mm:ss',
            longDateFormat1: 'MMMM DD, YYYY HH:mm',
            longDateFormat2: 'MMMM DD, YYYY HH:mm:ss',
            t12HourTimeFormat: 'hh:mm:ss a',
            t24HourTimeFormat: 'HH:mm:ss',
            t12HourTimeFormat2: 'hh:mm a',
            t24HourTimeFormat2: 'HH:mm',
        };

        this.config = config;

        function setMomentLocale(languageCode, firstDayOfWeek) {
            moment.updateLocale(languageCode, {
                week: {
                    dow: firstDayOfWeek
                }
            });
        }

        function config(tenantSettings, localisationFieldSettings) {
            settings.gmapCountry = tenantSettings.countryCode;

            if (localisationFieldSettings) {
                var localisationFieldSettingMap = _.keyBy(localisationFieldSettings, 'fieldKey');
                settings['bankAccountNumber'] = _.get(localisationFieldSettingMap, 'BankAccountNumber.settings');
                settings['bankBranchCode'] = _.get(localisationFieldSettingMap, 'BankBranchCode.settings');
                settings['registeredBusinessNumber'] = _.get(localisationFieldSettingMap, 'RegisteredBusinessNumber.settings');
                var localeFormatSetting = _.get(localisationFieldSettingMap, 'LocaleFormatSetting.settings');

                if (localeFormatSetting) {
                    var localeFormatSettingMap = _.keyBy(localeFormatSetting, 'settingKey');

                    settings.t12HourTimeFormat = _.get(localeFormatSettingMap, 't12HourTimeFormat.settingValue', settings.t12HourTimeFormat);
                    settings.t24HourTimeFormat = _.get(localeFormatSettingMap, 't24HourTimeFormat.settingValue', settings.t24HourTimeFormat);
                    settings.t12HourTimeFormat2 = _.get(localeFormatSettingMap, 't12HourTimeFormat2.settingValue', settings.t12HourTimeFormat2);
                    settings.t24HourTimeFormat2 = _.get(localeFormatSettingMap, 't24HourTimeFormat2.settingValue', settings.t24HourTimeFormat2);

                    settings.firstDayOfWeek = parseInt(_.get(localeFormatSettingMap, 'FirstDayOfWeek.settingValue', settings.firstDayOfWeek));
                    settings.dateFormat = _.get(localeFormatSettingMap, 'DateFormat.settingValue', settings.dateFormat);
                    settings.shortdateFormatWithSlash = _.get(localeFormatSettingMap, 'ShortdateFormatWithSlash.settingValue', settings.shortdateFormatWithSlash);
                    settings.displayDateFormat = settings.shortdateFormatWithSlash;
                    settings.dateTimeFormatWithSlash = _.get(localeFormatSettingMap, 'DateTimeFormatWithSlash.settingValue', settings.dateTimeFormatWithSlash);
                    settings.minDate = _.get(localeFormatSettingMap, 'MinDate.settingValue', settings.minDate);
                    settings.serverDefaultDateFormat = _.get(localeFormatSettingMap, 'ServerDefaultDateFormat.settingValue', settings.serverDefaultDateFormat);
                    settings.longDateFormat1 = _.get(localeFormatSettingMap, 'LongDateFormat1.settingValue', settings.longDateFormat1);
                    settings.longDateFormat2 = _.get(localeFormatSettingMap, 'LongDateFormat2.settingValue', settings.longDateFormat2);
                    settings.timeFormat = settings.t24HourTimeFormat;
                    settings.timeFormat2 = settings.t24HourTimeFormat2;
                }
            }

            setMomentLocale(tenantSettings.languageCode, settings.firstDayOfWeek);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ()
        {
            // Data

            // Methods
            var service = {
                getLocaleFormatSettings: getLocaleFormatSettings,
                getTimeFormatSettings: getTimeFormatSettings,
            };

            function getLocaleFormatSettings() {
                return settings;
            }

            function getTimeFormatSettings() {
                return 24;
            }

            return service;
        };
    }
})();

/** 
 * Kendo UI v2018.1.221 (http://www.telerik.com/kendo-ui)                                                                                                                                               
 * Copyright 2018 Telerik AD. All rights reserved.                                                                                                                                                      
 *                                                                                                                                                                                                      
 * Kendo UI commercial licenses may be obtained at                                                                                                                                                      
 * http://www.telerik.com/purchase/license-agreement/kendo-ui-complete                                                                                                                                  
 * If you do not own a commercial license, this file shall be governed by the trial license terms.                                                                                                      
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       
                                                                                                                                                                                                       

*/
!function(e,define){define("kendo.core.min",["jquery"],e)}(function(){return function(e,t,n){function i(){}function o(e,t){if(t)return"'"+e.split("'").join("\\'").split('\\"').join('\\\\\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t")+"'";var n=e.charAt(0),i=e.substring(1);return"="===n?"+("+i+")+":":"===n?"+$kendoHtmlEncode("+i+")+":";"+e+";$kendoOutput+="}function r(e,t,n){return e+="",t=t||2,n=t-e.length,n?U[t].substring(0,n)+e:e}function s(e){var t=e.css(ve.support.transitions.css+"box-shadow")||e.css("box-shadow"),n=t?t.match(Ae)||[0,0,0,0,0]:[0,0,0,0,0],i=xe.max(+n[3],+(n[4]||0));return{left:-n[1]+i,right:+n[1]+i,bottom:+n[2]+i}}function a(t,n){var i,o,r,s,a,l,c,d=Se.browser,u=ve._outerWidth,h=ve._outerHeight;return t.parent().hasClass("k-animation-container")?(l=t.parent(".k-animation-container"),c=l[0].style,l.is(":hidden")&&l.css({display:"",position:""}),i=Te.test(c.width)||Te.test(c.height),i||l.css({width:n?u(t)+1:u(t),height:h(t),boxSizing:"content-box",mozBoxSizing:"content-box",webkitBoxSizing:"content-box"})):(o=t[0].style.width,r=t[0].style.height,s=Te.test(o),a=Te.test(r),i=s||a,!s&&(!n||n&&o)&&(o=n?u(t)+1:u(t)),!a&&(!n||n&&r)&&(r=h(t)),t.wrap(e("<div/>").addClass("k-animation-container").css({width:o,height:r})),i&&t.css({width:"100%",height:"100%",boxSizing:"border-box",mozBoxSizing:"border-box",webkitBoxSizing:"border-box"})),d.msie&&xe.floor(d.version)<=7&&(t.css({zoom:1}),t.children(".k-menu").width(t.width())),t.parent()}function l(e){var t=1,n=arguments.length;for(t=1;t<n;t++)c(e,arguments[t]);return e}function c(e,t){var n,i,o,r,s,a=ve.data.ObservableArray,l=ve.data.LazyObservableArray,d=ve.data.DataSource,u=ve.data.HierarchicalDataSource;for(n in t)i=t[n],o=typeof i,r=o===Fe&&null!==i?i.constructor:null,r&&r!==Array&&r!==a&&r!==l&&r!==d&&r!==u&&r!==RegExp?i instanceof Date?e[n]=new Date(i.getTime()):R(i.clone)?e[n]=i.clone():(s=e[n],e[n]=typeof s===Fe?s||{}:{},c(e[n],i)):o!==Be&&(e[n]=i);return e}function d(e,t,i){for(var o in t)if(t.hasOwnProperty(o)&&t[o].test(e))return o;return i!==n?i:e}function u(e){return e.replace(/([a-z][A-Z])/g,function(e){return e.charAt(0)+"-"+e.charAt(1).toLowerCase()})}function h(e){return e.replace(/\-(\w)/g,function(e,t){return t.toUpperCase()})}function f(t,n){var i,o={};return document.defaultView&&document.defaultView.getComputedStyle?(i=document.defaultView.getComputedStyle(t,""),n&&e.each(n,function(e,t){o[t]=i.getPropertyValue(t)})):(i=t.currentStyle,n&&e.each(n,function(e,t){o[t]=i[h(t)]})),ve.size(o)||(o=i),o}function p(e){if(e&&e.className&&"string"==typeof e.className&&e.className.indexOf("k-auto-scrollable")>-1)return!0;var t=f(e,["overflow"]).overflow;return"auto"==t||"scroll"==t}function m(t,i){var o,r=Se.browser.webkit,s=Se.browser.mozilla,a=t instanceof e?t[0]:t;if(t)return o=Se.isRtl(t),i===n?o&&r?a.scrollWidth-a.clientWidth-a.scrollLeft:Math.abs(a.scrollLeft):(a.scrollLeft=o&&r?a.scrollWidth-a.clientWidth-i:o&&s?-i:i,n)}function g(e){var t,n=0;for(t in e)e.hasOwnProperty(t)&&"toJSON"!=t&&n++;return n}function v(e,n,i){var o,r,s;return n||(n="offset"),o=e[n](),r={top:o.top,right:o.right,bottom:o.bottom,left:o.left},Se.browser.msie&&(Se.pointers||Se.msPointers)&&!i&&(s=Se.isRtl(e)?1:-1,r.top-=t.pageYOffset-document.documentElement.scrollTop,r.left-=t.pageXOffset+s*document.documentElement.scrollLeft),r}function _(e){var t={};return be("string"==typeof e?e.split(" "):e,function(e){t[e]=this}),t}function b(e){return new ve.effects.Element(e)}function w(e,t,n,i){return typeof e===Me&&(R(t)&&(i=t,t=400,n=!1),R(n)&&(i=n,n=!1),typeof t===Pe&&(n=t,t=400),e={effects:e,duration:t,reverse:n,complete:i}),_e({effects:{},duration:400,reverse:!1,init:ke,teardown:ke,hide:!1},e,{completeCallback:e.complete,complete:ke})}function y(t,n,i,o,r){for(var s,a=0,l=t.length;a<l;a++)s=e(t[a]),s.queue(function(){j.promise(s,w(n,i,o,r))});return t}function k(e,t,n,i){return t&&(t=t.split(" "),be(t,function(t,n){e.toggleClass(n,i)})),e}function x(e){return(""+e).replace(q,"&amp;").replace(G,"&lt;").replace(Y,"&gt;").replace($,"&quot;").replace(K,"&#39;")}function C(e,t){var i;return 0===t.indexOf("data")&&(t=t.substring(4),t=t.charAt(0).toLowerCase()+t.substring(1)),t=t.replace(oe,"-$1"),i=e.getAttribute("data-"+ve.ns+t),null===i?i=n:"null"===i?i=null:"true"===i?i=!0:"false"===i?i=!1:Ee.test(i)&&"mask"!=t?i=parseFloat(i):ne.test(i)&&!ie.test(i)&&(i=Function("return ("+i+")")()),i}function S(t,i){var o,r,s={};for(o in i)r=C(t,o),r!==n&&(te.test(o)&&(r="string"==typeof r?ve.template(e("#"+r).html()):t.getAttribute(o)),s[o]=r);return s}function T(t,n){return e.contains(t,n)?-1:1}function D(){var t=e(this);return e.inArray(t.attr("data-"+ve.ns+"role"),["slider","rangeslider"])>-1||t.is(":visible")}function A(e,t){var n=e.nodeName.toLowerCase();return(/input|select|textarea|button|object/.test(n)?!e.disabled:"a"===n?e.href||t:t)&&E(e)}function E(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return"hidden"===e.css(this,"visibility")}).length}function I(e,t){return new I.fn.init(e,t)}var M,R,F,z,P,B,L,H,N,O,V,U,W,j,q,G,$,K,Y,Q,X,Z,J,ee,te,ne,ie,oe,re,se,ae,le,ce,de,ue,he,fe,pe,me,ge,ve=t.kendo=t.kendo||{cultures:{}},_e=e.extend,be=e.each,we=e.isArray,ye=e.proxy,ke=e.noop,xe=Math,Ce=t.JSON||{},Se={},Te=/%/,De=/\{(\d+)(:[^\}]+)?\}/g,Ae=/(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+)?/i,Ee=/^(\+|-?)\d+(\.?)\d*$/,Ie="function",Me="string",Re="number",Fe="object",ze="null",Pe="boolean",Be="undefined",Le={},He={},Ne=[].slice;ve.version="2018.1.221".replace(/^\s+|\s+$/g,""),i.extend=function(e){var t,n,i=function(){},o=this,r=e&&e.init?e.init:function(){o.apply(this,arguments)};i.prototype=o.prototype,n=r.fn=r.prototype=new i;for(t in e)n[t]=null!=e[t]&&e[t].constructor===Object?_e(!0,{},i.prototype[t],e[t]):e[t];return n.constructor=r,r.extend=o.extend,r},i.prototype._initOptions=function(e){this.options=l({},this.options,e)},R=ve.isFunction=function(e){return"function"==typeof e},F=function(){this._defaultPrevented=!0},z=function(){return this._defaultPrevented===!0},P=i.extend({init:function(){this._events={}},bind:function(e,t,i){var o,r,s,a,l,c=this,d=typeof e===Me?[e]:e,u=typeof t===Ie;if(t===n){for(o in e)c.bind(o,e[o]);return c}for(o=0,r=d.length;o<r;o++)e=d[o],a=u?t:t[e],a&&(i&&(s=a,a=function(){c.unbind(e,a),s.apply(c,arguments)},a.original=s),l=c._events[e]=c._events[e]||[],l.push(a));return c},one:function(e,t){return this.bind(e,t,!0)},first:function(e,t){var n,i,o,r,s=this,a=typeof e===Me?[e]:e,l=typeof t===Ie;for(n=0,i=a.length;n<i;n++)e=a[n],o=l?t:t[e],o&&(r=s._events[e]=s._events[e]||[],r.unshift(o));return s},trigger:function(e,t){var n,i,o=this,r=o._events[e];if(r){for(t=t||{},t.sender=o,t._defaultPrevented=!1,t.preventDefault=F,t.isDefaultPrevented=z,r=r.slice(),n=0,i=r.length;n<i;n++)r[n].call(o,t);return t._defaultPrevented===!0}return!1},unbind:function(e,t){var i,o=this,r=o._events[e];if(e===n)o._events={};else if(r)if(t)for(i=r.length-1;i>=0;i--)r[i]!==t&&r[i].original!==t||r.splice(i,1);else o._events[e]=[];return o}}),B=/^\w+/,L=/\$\{([^}]*)\}/g,H=/\\\}/g,N=/__CURLY__/g,O=/\\#/g,V=/__SHARP__/g,U=["","0","00","000","0000"],M={paramName:"data",useWithBlock:!0,render:function(e,t){var n,i,o="";for(n=0,i=t.length;n<i;n++)o+=e(t[n]);return o},compile:function(e,t){var n,i,r,s=_e({},this,t),a=s.paramName,l=a.match(B)[0],c=s.useWithBlock,d="var $kendoOutput, $kendoHtmlEncode = kendo.htmlEncode;";if(R(e))return e;for(d+=c?"with("+a+"){":"",d+="$kendoOutput=",i=e.replace(H,"__CURLY__").replace(L,"#=$kendoHtmlEncode($1)#").replace(N,"}").replace(O,"__SHARP__").split("#"),r=0;r<i.length;r++)d+=o(i[r],r%2===0);d+=c?";}":";",d+="return $kendoOutput;",d=d.replace(V,"#");try{return n=Function(l,d),n._slotCount=Math.floor(i.length/2),n}catch(u){throw Error(ve.format("Invalid template:'{0}' Generated code:'{1}'",e,d))}}},function(){function e(e){return s.lastIndex=0,s.test(e)?'"'+e.replace(s,function(e){var t=a[e];return typeof t===Me?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+e+'"'}function t(r,s){var a,c,d,u,h,f,p=n,m=s[r];if(m&&typeof m===Fe&&typeof m.toJSON===Ie&&(m=m.toJSON(r)),typeof o===Ie&&(m=o.call(s,r,m)),f=typeof m,f===Me)return e(m);if(f===Re)return isFinite(m)?m+"":ze;if(f===Pe||f===ze)return m+"";if(f===Fe){if(!m)return ze;if(n+=i,h=[],"[object Array]"===l.apply(m)){for(u=m.length,a=0;a<u;a++)h[a]=t(a,m)||ze;return d=0===h.length?"[]":n?"[\n"+n+h.join(",\n"+n)+"\n"+p+"]":"["+h.join(",")+"]",n=p,d}if(o&&typeof o===Fe)for(u=o.length,a=0;a<u;a++)typeof o[a]===Me&&(c=o[a],d=t(c,m),d&&h.push(e(c)+(n?": ":":")+d));else for(c in m)Object.hasOwnProperty.call(m,c)&&(d=t(c,m),d&&h.push(e(c)+(n?": ":":")+d));return d=0===h.length?"{}":n?"{\n"+n+h.join(",\n"+n)+"\n"+p+"}":"{"+h.join(",")+"}",n=p,d}}var n,i,o,s=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,a={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},l={}.toString;typeof Date.prototype.toJSON!==Ie&&(Date.prototype.toJSON=function(){var e=this;return isFinite(e.valueOf())?r(e.getUTCFullYear(),4)+"-"+r(e.getUTCMonth()+1)+"-"+r(e.getUTCDate())+"T"+r(e.getUTCHours())+":"+r(e.getUTCMinutes())+":"+r(e.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(){return this.valueOf()}),typeof Ce.stringify!==Ie&&(Ce.stringify=function(e,r,s){var a;if(n="",i="",typeof s===Re)for(a=0;a<s;a+=1)i+=" ";else typeof s===Me&&(i=s);if(o=r,r&&typeof r!==Ie&&(typeof r!==Fe||typeof r.length!==Re))throw Error("JSON.stringify");return t("",{"":e})})}(),function(){function t(e){if(e){if(e.numberFormat)return e;if(typeof e===Me){var t=ve.cultures;return t[e]||t[e.split("-")[0]]||null}return null}return null}function i(e){return e&&(e=t(e)),e||ve.cultures.current}function o(e,t,o){o=i(o);var s=o.calendars.standard,a=s.days,l=s.months;return t=s.patterns[t]||t,t.replace(d,function(t){var i,o,c;return"d"===t?o=e.getDate():"dd"===t?o=r(e.getDate()):"ddd"===t?o=a.namesAbbr[e.getDay()]:"dddd"===t?o=a.names[e.getDay()]:"M"===t?o=e.getMonth()+1:"MM"===t?o=r(e.getMonth()+1):"MMM"===t?o=l.namesAbbr[e.getMonth()]:"MMMM"===t?o=l.names[e.getMonth()]:"yy"===t?o=r(e.getFullYear()%100):"yyyy"===t?o=r(e.getFullYear(),4):"h"===t?o=e.getHours()%12||12:"hh"===t?o=r(e.getHours()%12||12):"H"===t?o=e.getHours():"HH"===t?o=r(e.getHours()):"m"===t?o=e.getMinutes():"mm"===t?o=r(e.getMinutes()):"s"===t?o=e.getSeconds():"ss"===t?o=r(e.getSeconds()):"f"===t?o=xe.floor(e.getMilliseconds()/100):"ff"===t?(o=e.getMilliseconds(),o>99&&(o=xe.floor(o/10)),o=r(o)):"fff"===t?o=r(e.getMilliseconds(),3):"tt"===t?o=e.getHours()<12?s.AM[0]:s.PM[0]:"zzz"===t?(i=e.getTimezoneOffset(),c=i<0,o=(""+xe.abs(i/60)).split(".")[0],i=xe.abs(i)-60*o,o=(c?"+":"-")+r(o),o+=":"+r(i)):"zz"!==t&&"z"!==t||(o=e.getTimezoneOffset()/60,c=o<0,o=(""+xe.abs(o)).split(".")[0],o=(c?"+":"-")+("zz"===t?r(o):o)),o!==n?o:t.slice(1,t.length-1)})}function s(e,t,o){o=i(o);var r,s,c,d,w,y,k,x,C,S,T,D,A,E,I,M,R,F,z,P,B,L,H,N=o.numberFormat,O=N[m],V=N.decimals,U=N.pattern[0],W=[],j=e<0,q=p,G=p,$=-1;if(e===n)return p;if(!isFinite(e))return e;if(!t)return o.name.length?e.toLocaleString():""+e;if(w=u.exec(t)){if(t=w[1].toLowerCase(),s="c"===t,c="p"===t,(s||c)&&(N=s?N.currency:N.percent,O=N[m],V=N.decimals,r=N.symbol,U=N.pattern[j?0:1]),d=w[2],d&&(V=+d),"e"===t)return d?e.toExponential(V):e.toExponential();if(c&&(e*=100),e=l(e,V),j=e<0,e=e.split(m),y=e[0],k=e[1],j&&(y=y.substring(1)),G=a(y,0,y.length,N),k&&(G+=O+k),"n"===t&&!j)return G;for(e=p,S=0,T=U.length;S<T;S++)D=U.charAt(S),e+="n"===D?G:"$"===D||"%"===D?r:D;return e}if(j&&(e=-e),(t.indexOf("'")>-1||t.indexOf('"')>-1||t.indexOf("\\")>-1)&&(t=t.replace(h,function(e){var t=e.charAt(0).replace("\\",""),n=e.slice(1).replace(t,"");return W.push(n),b})),t=t.split(";"),j&&t[1])t=t[1],E=!0;else if(0===e){if(t=t[2]||t[0],t.indexOf(v)==-1&&t.indexOf(_)==-1)return t}else t=t[0];if(P=t.indexOf("%"),B=t.indexOf("$"),c=P!=-1,s=B!=-1,c&&(e*=100),s&&"\\"===t[B-1]&&(t=t.split("\\").join(""),s=!1),(s||c)&&(N=s?N.currency:N.percent,O=N[m],V=N.decimals,r=N.symbol),A=t.indexOf(g)>-1,A&&(t=t.replace(f,p)),I=t.indexOf(m),T=t.length,I!=-1?(k=(""+e).split("e"),k=k[1]?l(e,Math.abs(k[1])):k[0],k=k.split(m)[1]||p,R=t.lastIndexOf(_)-I,M=t.lastIndexOf(v)-I,F=R>-1,z=M>-1,S=k.length,F||z||(t=t.substring(0,I)+t.substring(I+1),T=t.length,I=-1,S=0),F&&R>M?S=R:M>R&&(z&&S>M?S=M:F&&S<R&&(S=R)),S>-1&&(e=l(e,S))):e=l(e),M=t.indexOf(v),L=R=t.indexOf(_),$=M==-1&&R!=-1?R:M!=-1&&R==-1?M:M>R?R:M,M=t.lastIndexOf(v),R=t.lastIndexOf(_),H=M==-1&&R!=-1?R:M!=-1&&R==-1?M:M>R?M:R,$==T&&(H=$),$!=-1){for(G=(""+e).split(m),y=G[0],k=G[1]||p,x=y.length,C=k.length,j&&e*-1>=0&&(j=!1),e=t.substring(0,$),j&&!E&&(e+="-"),S=$;S<T;S++){if(D=t.charAt(S),I==-1){if(H-S<x){e+=y;break}}else if(R!=-1&&R<S&&(q=p),I-S<=x&&I-S>-1&&(e+=y,S=I),I===S){e+=(k?O:p)+k,S+=H-I+1;continue}D===_?(e+=D,q=D):D===v&&(e+=q)}if(A&&(e=a(e,$+(j&&!E?1:0),Math.max(H,x+$),N)),H>=$&&(e+=t.substring(H+1)),s||c){for(G=p,S=0,T=e.length;S<T;S++)D=e.charAt(S),G+="$"===D||"%"===D?r:D;e=G}if(T=W.length)for(S=0;S<T;S++)e=e.replace(b,W[S])}return e}var a,l,c,d=/dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g,u=/^(n|c|p|e)(\d*)$/i,h=/(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g,f=/\,/g,p="",m=".",g=",",v="#",_="0",b="??",w="en-US",y={}.toString;ve.cultures["en-US"]={name:w,numberFormat:{pattern:["-n"],decimals:2,",":",",".":".",groupSize:[3],percent:{pattern:["-n %","n %"],decimals:2,",":",",".":".",groupSize:[3],symbol:"%"},currency:{name:"US Dollar",abbr:"USD",pattern:["($n)","$n"],decimals:2,",":",",".":".",groupSize:[3],symbol:"$"}},calendars:{standard:{days:{names:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],namesAbbr:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],namesShort:["Su","Mo","Tu","We","Th","Fr","Sa"]},months:{names:["January","February","March","April","May","June","July","August","September","October","November","December"],namesAbbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},AM:["AM","am","AM"],PM:["PM","pm","PM"],patterns:{d:"M/d/yyyy",D:"dddd, MMMM dd, yyyy",F:"dddd, MMMM dd, yyyy h:mm:ss tt",g:"M/d/yyyy h:mm tt",G:"M/d/yyyy h:mm:ss tt",m:"MMMM dd",M:"MMMM dd",s:"yyyy'-'MM'-'ddTHH':'mm':'ss",t:"h:mm tt",T:"h:mm:ss tt",u:"yyyy'-'MM'-'dd HH':'mm':'ss'Z'",y:"MMMM, yyyy",Y:"MMMM, yyyy"},"/":"/",":":":",firstDay:0,twoDigitYearMax:2029}}},ve.culture=function(e){var i,o=ve.cultures;return e===n?o.current:(i=t(e)||o[w],i.calendar=i.calendars.standard,o.current=i,n)},ve.findCulture=t,ve.getCulture=i,ve.culture(w),a=function(e,t,i,o){var r,s,a,l,c,d,u=e.indexOf(o[m]),h=o.groupSize.slice(),f=h.shift();if(i=u!==-1?u:i+1,r=e.substring(t,i),s=r.length,s>=f){for(a=s,l=[];a>-1;)if(c=r.substring(a-f,a),c&&l.push(c),a-=f,d=h.shift(),f=d!==n?d:f,0===f){a>0&&l.push(r.substring(0,a));break}r=l.reverse().join(o[g]),e=e.substring(0,t)+r+e.substring(i)}return e},l=function(e,t){return t=t||0,e=(""+e).split("e"),e=Math.round(+(e[0]+"e"+(e[1]?+e[1]+t:t))),e=(""+e).split("e"),e=+(e[0]+"e"+(e[1]?+e[1]-t:-t)),e.toFixed(Math.min(t,20))},c=function(e,t,i){if(t){if("[object Date]"===y.call(e))return o(e,t,i);if(typeof e===Re)return s(e,t,i)}return e!==n?e:""},ve.format=function(e){var t=arguments;return e.replace(De,function(e,n,i){var o=t[parseInt(n,10)+1];return c(o,i?i.substring(1):"")})},ve._extractFormat=function(e){return"{0:"===e.slice(0,3)&&(e=e.slice(3,e.length-1)),e},ve._activeElement=function(){try{return document.activeElement}catch(e){return document.documentElement.activeElement}},ve._round=l,ve._outerWidth=function(t,n){return e(t).outerWidth(n||!1)||0},ve._outerHeight=function(t,n){return e(t).outerHeight(n||!1)||0},ve.toString=c}(),function(){function t(e,t,n){return!(e>=t&&e<=n)}function i(e){return e.charAt(0)}function o(t){return e.map(t,i)}function r(e,t){t||23!==e.getHours()||e.setHours(e.getHours()+2)}function s(e){for(var t=0,n=e.length,i=[];t<n;t++)i[t]=(e[t]+"").toLowerCase();return i}function a(e){var t,n={};for(t in e)n[t]=s(e[t]);return n}function l(e,i,s,l){if(!e)return null;var c,d,u,h,f,g,v,_,b,y,k,x,C,S=function(e){for(var t=0;i[L]===e;)t++,L++;return t>0&&(L-=1),t},T=function(t){var n=w[t]||RegExp("^\\d{1,"+t+"}"),i=e.substr(H,t).match(n);return i?(i=i[0],H+=i.length,parseInt(i,10)):null},D=function(t,n){for(var i,o,r,s=0,a=t.length,l=0,c=0;s<a;s++)i=t[s],o=i.length,r=e.substr(H,o),n&&(r=r.toLowerCase()),r==i&&o>l&&(l=o,c=s);return l?(H+=l,c+1):null},A=function(){var t=!1;return e.charAt(H)===i[L]&&(H++,t=!0),t},E=s.calendars.standard,I=null,M=null,R=null,F=null,z=null,P=null,B=null,L=0,H=0,N=!1,O=new Date,V=E.twoDigitYearMax||2029,U=O.getFullYear();for(i||(i="d"),h=E.patterns[i],h&&(i=h),i=i.split(""),u=i.length;L<u;L++)if(c=i[L],N)"'"===c?N=!1:A();else if("d"===c){if(d=S("d"),E._lowerDays||(E._lowerDays=a(E.days)),null!==R&&d>2)continue;if(R=d<3?T(2):D(E._lowerDays[3==d?"namesAbbr":"names"],!0),null===R||t(R,1,31))return null}else if("M"===c){if(d=S("M"),E._lowerMonths||(E._lowerMonths=a(E.months)),M=d<3?T(2):D(E._lowerMonths[3==d?"namesAbbr":"names"],!0),null===M||t(M,1,12))return null;M-=1}else if("y"===c){if(d=S("y"),I=T(d),null===I)return null;2==d&&("string"==typeof V&&(V=U+parseInt(V,10)),I=U-U%100+I,I>V&&(I-=100))}else if("h"===c){if(S("h"),F=T(2),12==F&&(F=0),null===F||t(F,0,11))return null}else if("H"===c){if(S("H"),F=T(2),null===F||t(F,0,23))return null}else if("m"===c){if(S("m"),z=T(2),null===z||t(z,0,59))return null}else if("s"===c){if(S("s"),P=T(2),null===P||t(P,0,59))return null}else if("f"===c){if(d=S("f"),C=e.substr(H,d).match(w[3]),B=T(d),null!==B&&(B=parseFloat("0."+C[0],10),B=ve._round(B,3),B*=1e3),null===B||t(B,0,999))return null}else if("t"===c){if(d=S("t"),_=E.AM,b=E.PM,1===d&&(_=o(_),b=o(b)),f=D(b),!f&&!D(_))return null}else if("z"===c){if(g=!0,d=S("z"),"Z"===e.substr(H,1)){A();continue}if(v=e.substr(H,6).match(d>2?m:p),!v)return null;if(v=v[0].split(":"),y=v[0],k=v[1],!k&&y.length>3&&(H=y.length-2,k=y.substring(H),y=y.substring(0,H)),y=parseInt(y,10),t(y,-12,13))return null;if(d>2&&(k=parseInt(k,10),isNaN(k)||t(k,0,59)))return null}else if("'"===c)N=!0,A();else if(!A())return null;return l&&!/^\s*$/.test(e.substr(H))?null:(x=null!==F||null!==z||P||null,null===I&&null===M&&null===R&&x?(I=U,M=O.getMonth(),R=O.getDate()):(null===I&&(I=U),null===R&&(R=1)),f&&F<12&&(F+=12),g?(y&&(F+=-y),k&&(z+=-k),e=new Date(Date.UTC(I,M,R,F,z,P,B))):(e=new Date(I,M,R,F,z,P,B),r(e,F)),I<100&&e.setFullYear(I),e.getDate()!==R&&g===n?null:e)}function c(e){var t="-"===e.substr(0,1)?-1:1;return e=e.substring(1),e=60*parseInt(e.substr(0,2),10)+parseInt(e.substring(2),10),t*e}function d(e){var t,n,i,o=xe.max(_.length,b.length),r=e.calendar.patterns,s=[];for(i=0;i<o;i++){for(t=_[i],n=0;n<t.length;n++)s.push(r[t[n]]);s=s.concat(b[i])}return s}function u(e,t,n,i){var o,r,s,a;if("[object Date]"===y.call(e))return e;if(o=0,r=null,e&&0===e.indexOf("/D")&&(r=g.exec(e)))return r=r[1],a=v.exec(r.substring(1)),r=new Date(parseInt(r,10)),a&&(a=c(a[0]),r=ve.timezone.apply(r,0),r=ve.timezone.convert(r,0,-1*a)),r;for(n=ve.getCulture(n),t||(t=d(n)),t=we(t)?t:[t],s=t.length;o<s;o++)if(r=l(e,t[o],n,i))return r;return r}var h=/\u00A0/g,f=/[eE][\-+]?[0-9]+/,p=/[+|\-]\d{1,2}/,m=/[+|\-]\d{1,2}:?\d{2}/,g=/^\/Date\((.*?)\)\/$/,v=/[+-]\d*/,_=[[],["G","g","F"],["D","d","y","m","T","t"]],b=[["yyyy-MM-ddTHH:mm:ss.fffffffzzz","yyyy-MM-ddTHH:mm:ss.fffffff","yyyy-MM-ddTHH:mm:ss.fffzzz","yyyy-MM-ddTHH:mm:ss.fff","ddd MMM dd yyyy HH:mm:ss","yyyy-MM-ddTHH:mm:sszzz","yyyy-MM-ddTHH:mmzzz","yyyy-MM-ddTHH:mmzz","yyyy-MM-ddTHH:mm:ss","yyyy-MM-dd HH:mm:ss","yyyy/MM/dd HH:mm:ss"],["yyyy-MM-ddTHH:mm","yyyy-MM-dd HH:mm","yyyy/MM/dd HH:mm"],["yyyy/MM/dd","yyyy-MM-dd","HH:mm:ss","HH:mm"]],w={2:/^\d{1,2}/,3:/^\d{1,3}/,4:/^\d{4}/},y={}.toString;ve.parseDate=function(e,t,n){return u(e,t,n,!1)},ve.parseExactDate=function(e,t,n){return u(e,t,n,!0)},ve.parseInt=function(e,t){var n=ve.parseFloat(e,t);return n&&(n=0|n),n},ve.parseFloat=function(e,t,n){if(!e&&0!==e)return null;if(typeof e===Re)return e;e=""+e,t=ve.getCulture(t);var i,o,r=t.numberFormat,s=r.percent,a=r.currency,l=a.symbol,c=s.symbol,d=e.indexOf("-");return f.test(e)?(e=parseFloat(e.replace(r["."],".")),isNaN(e)&&(e=null),e):d>0?null:(d=d>-1,e.indexOf(l)>-1||n&&n.toLowerCase().indexOf("c")>-1?(r=a,i=r.pattern[0].replace("$",l).split("n"),e.indexOf(i[0])>-1&&e.indexOf(i[1])>-1&&(e=e.replace(i[0],"").replace(i[1],""),d=!0)):e.indexOf(c)>-1&&(o=!0,r=s,l=c),e=e.replace("-","").replace(l,"").replace(h," ").split(r[","].replace(h," ")).join("").replace(r["."],"."),e=parseFloat(e),isNaN(e)?e=null:d&&(e*=-1),e&&o&&(e/=100),e)}}(),function(){var i,o,r,s,a,l,c,u,h;Se._scrollbar=n,Se.scrollbar=function(e){if(isNaN(Se._scrollbar)||e){var t,n=document.createElement("div");return n.style.cssText="overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block",n.innerHTML="&nbsp;",document.body.appendChild(n),Se._scrollbar=t=n.offsetWidth-n.scrollWidth,document.body.removeChild(n),t}return Se._scrollbar},Se.isRtl=function(t){return e(t).closest(".k-rtl").length>0},i=document.createElement("table");try{i.innerHTML="<tr><td></td></tr>",Se.tbodyInnerHtml=!0}catch(f){Se.tbodyInnerHtml=!1}Se.touch="ontouchstart"in t,o=document.documentElement.style,r=Se.transitions=!1,s=Se.transforms=!1,a="HTMLElement"in t?HTMLElement.prototype:[],Se.hasHW3D="WebKitCSSMatrix"in t&&"m11"in new t.WebKitCSSMatrix||"MozPerspective"in o||"msPerspective"in o,Se.cssFlexbox="flexWrap"in o||"WebkitFlexWrap"in o||"msFlexWrap"in o,be(["Moz","webkit","O","ms"],function(){var e,t=""+this,n=typeof i.style[t+"Transition"]===Me;if(n||typeof i.style[t+"Transform"]===Me)return e=t.toLowerCase(),s={css:"ms"!=e?"-"+e+"-":"",prefix:t,event:"o"===e||"webkit"===e?e:""},n&&(r=s,r.event=r.event?r.event+"TransitionEnd":"transitionend"),!1}),i=null,Se.transforms=s,Se.transitions=r,Se.devicePixelRatio=t.devicePixelRatio===n?1:t.devicePixelRatio;try{Se.screenWidth=t.outerWidth||t.screen?t.screen.availWidth:t.innerWidth,Se.screenHeight=t.outerHeight||t.screen?t.screen.availHeight:t.innerHeight}catch(f){Se.screenWidth=t.screen.availWidth,Se.screenHeight=t.screen.availHeight}Se.detectOS=function(e){var n,i,o=!1,r=[],s=!/mobile safari/i.test(e),a={wp:/(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,fire:/(Silk)\/(\d+)\.(\d+(\.\d+)?)/,android:/(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.(\d+(\.\d+)?)/,iphone:/(iPhone|iPod).*OS\s+(\d+)[\._]([\d\._]+)/,ipad:/(iPad).*OS\s+(\d+)[\._]([\d_]+)/,meego:/(MeeGo).+NokiaBrowser\/(\d+)\.([\d\._]+)/,webos:/(webOS)\/(\d+)\.(\d+(\.\d+)?)/,blackberry:/(BlackBerry|BB10).*?Version\/(\d+)\.(\d+(\.\d+)?)/,playbook:/(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,windows:/(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,tizen:/(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,sailfish:/(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i,ffos:/(Mobile).*rv:(\d+)\.(\d+(\.\d+)?).*Firefox/},l={ios:/^i(phone|pad|pod)$/i,android:/^android|fire$/i,blackberry:/^blackberry|playbook/i,windows:/windows/,wp:/wp/,flat:/sailfish|ffos|tizen/i,meego:/meego/},c={tablet:/playbook|ipad|fire/i},u={omini:/Opera\sMini/i,omobile:/Opera\sMobi/i,firefox:/Firefox|Fennec/i,mobilesafari:/version\/.*safari/i,ie:/MSIE|Windows\sPhone/i,chrome:/chrome|crios/i,webkit:/webkit/i};for(i in a)if(a.hasOwnProperty(i)&&(r=e.match(a[i]))){if("windows"==i&&"plugins"in navigator)return!1;o={},o.device=i,o.tablet=d(i,c,!1),o.browser=d(e,u,"default"),o.name=d(i,l),o[o.name]=!0,o.majorVersion=r[2],o.minorVersion=r[3].replace("_","."),n=o.minorVersion.replace(".","").substr(0,2),o.flatVersion=o.majorVersion+n+Array(3-(n.length<3?n.length:2)).join("0"),o.cordova=typeof t.PhoneGap!==Be||typeof t.cordova!==Be,o.appMode=t.navigator.standalone||/file|local|wmapp/.test(t.location.protocol)||o.cordova,o.android&&(Se.devicePixelRatio<1.5&&o.flatVersion<400||s)&&(Se.screenWidth>800||Se.screenHeight>800)&&(o.tablet=i);break}return o},l=Se.mobileOS=Se.detectOS(navigator.userAgent),Se.wpDevicePixelRatio=l.wp?screen.width/320:0,Se.hasNativeScrolling=!1,(l.ios||l.android&&l.majorVersion>2||l.wp)&&(Se.hasNativeScrolling=l),Se.delayedClick=function(){if(Se.touch){if(l.ios)return!0;if(l.android)return!Se.browser.chrome||!(Se.browser.version<32)&&!(e("meta[name=viewport]").attr("content")||"").match(/user-scalable=no/i)}return!1},Se.mouseAndTouchPresent=Se.touch&&!(Se.mobileOS.ios||Se.mobileOS.android),Se.detectBrowser=function(e){var t,n=!1,i=[],o={edge:/(edge)[ \/]([\w.]+)/i,webkit:/(chrome)[ \/]([\w.]+)/i,safari:/(webkit)[ \/]([\w.]+)/i,opera:/(opera)(?:.*version|)[ \/]([\w.]+)/i,msie:/(msie\s|trident.*? rv:)([\w.]+)/i,mozilla:/(mozilla)(?:.*? rv:([\w.]+)|)/i};for(t in o)if(o.hasOwnProperty(t)&&(i=e.match(o[t]))){n={},n[t]=!0,n[i[1].toLowerCase().split(" ")[0].split("/")[0]]=!0,n.version=parseInt(document.documentMode||i[2],10);break}return n},Se.browser=Se.detectBrowser(navigator.userAgent),Se.detectClipboardAccess=function(){var e={copy:!!document.queryCommandSupported&&document.queryCommandSupported("copy"),cut:!!document.queryCommandSupported&&document.queryCommandSupported("cut"),paste:!!document.queryCommandSupported&&document.queryCommandSupported("paste")};return Se.browser.chrome&&(e.paste=!1,Se.browser.version>=43&&(e.copy=!0,e.cut=!0)),e},Se.clipboard=Se.detectClipboardAccess(),Se.zoomLevel=function(){var e,n,i;try{return e=Se.browser,n=0,i=document.documentElement,e.msie&&11==e.version&&i.scrollHeight>i.clientHeight&&!Se.touch&&(n=Se.scrollbar()),Se.touch?i.clientWidth/t.innerWidth:e.msie&&e.version>=10?((top||t).document.documentElement.offsetWidth+n)/(top||t).innerWidth:1}catch(o){return 1}},Se.cssBorderSpacing=n!==o.borderSpacing&&!(Se.browser.msie&&Se.browser.version<8),function(t){var n="",i=e(document.documentElement),o=parseInt(t.version,10);t.msie?n="ie":t.mozilla?n="ff":t.safari?n="safari":t.webkit?n="webkit":t.opera?n="opera":t.edge&&(n="edge"),n&&(n="k-"+n+" k-"+n+o),Se.mobileOS&&(n+=" k-mobile"),Se.cssFlexbox||(n+=" k-no-flexbox"),i.addClass(n)}(Se.browser),Se.eventCapture=document.documentElement.addEventListener,c=document.createElement("input"),Se.placeholder="placeholder"in c,Se.propertyChangeEvent="onpropertychange"in c,Se.input=function(){for(var e,t=["number","date","time","month","week","datetime","datetime-local"],n=t.length,i="test",o={},r=0;r<n;r++)e=t[r],c.setAttribute("type",e),c.value=i,o[e.replace("-","")]="text"!==c.type&&c.value!==i;return o}(),c.style.cssText="float:left;",Se.cssFloat=!!c.style.cssFloat,c=null,Se.stableSort=function(){var e,t=513,n=[{index:0,field:"b"}];for(e=1;e<t;e++)n.push({index:e,field:"a"});return n.sort(function(e,t){return e.field>t.field?1:e.field<t.field?-1:0}),1===n[0].index}(),Se.matchesSelector=a.webkitMatchesSelector||a.mozMatchesSelector||a.msMatchesSelector||a.oMatchesSelector||a.matchesSelector||a.matches||function(t){for(var n=document.querySelectorAll?(this.parentNode||document).querySelectorAll(t)||[]:e(t),i=n.length;i--;)if(n[i]==this)return!0;return!1},Se.pushState=t.history&&t.history.pushState,u=document.documentMode,Se.hashChange="onhashchange"in t&&!(Se.browser.msie&&(!u||u<=8)),Se.customElements="registerElement"in t.document,h=Se.browser.chrome,Se.msPointers=!h&&t.MSPointerEvent,Se.pointers=!h&&t.PointerEvent,Se.kineticScrollNeeded=l&&(Se.touch||Se.msPointers||Se.pointers)}(),W={left:{reverse:"right"},right:{reverse:"left"},down:{reverse:"up"},up:{reverse:"down"},top:{reverse:"bottom"},bottom:{reverse:"top"},"in":{reverse:"out"},out:{reverse:"in"}},j={},e.extend(j,{enabled:!0,Element:function(t){this.element=e(t)},promise:function(e,t){e.is(":visible")||e.css({display:e.data("olddisplay")||"block"}).css("display"),t.hide&&e.data("olddisplay",e.css("display")).hide(),t.init&&t.init(),t.completeCallback&&t.completeCallback(e),e.dequeue()},disable:function(){this.enabled=!1,this.promise=this.promiseShim},enable:function(){this.enabled=!0,this.promise=this.animatedPromise}}),j.promiseShim=j.promise,"kendoAnimate"in e.fn||_e(e.fn,{kendoStop:function(e,t){return this.stop(e,t)},kendoAnimate:function(e,t,n,i){return y(this,e,t,n,i)},kendoAddClass:function(e,t){return ve.toggleClass(this,e,t,!0)},kendoRemoveClass:function(e,t){return ve.toggleClass(this,e,t,!1)},kendoToggleClass:function(e,t,n){return ve.toggleClass(this,e,t,n)}}),q=/&/g,G=/</g,$=/"/g,K=/'/g,Y=/>/g,Q=function(e){return e.target},Se.touch&&(Q=function(e){var t="originalEvent"in e?e.originalEvent.changedTouches:"changedTouches"in e?e.changedTouches:null;return t?document.elementFromPoint(t[0].clientX,t[0].clientY):e.target},be(["swipe","swipeLeft","swipeRight","swipeUp","swipeDown","doubleTap","tap"],function(t,n){e.fn[n]=function(e){return this.bind(n,e)}})),Se.touch?Se.mobileOS?(Se.mousedown="touchstart",Se.mouseup="touchend",Se.mousemove="touchmove",Se.mousecancel="touchcancel",Se.click="touchend",Se.resize="orientationchange"):(Se.mousedown="mousedown touchstart",Se.mouseup="mouseup touchend",Se.mousemove="mousemove touchmove",Se.mousecancel="mouseleave touchcancel",Se.click="click",Se.resize="resize"):Se.pointers?(Se.mousemove="pointermove",Se.mousedown="pointerdown",Se.mouseup="pointerup",Se.mousecancel="pointercancel",Se.click="pointerup",Se.resize="orientationchange resize"):Se.msPointers?(Se.mousemove="MSPointerMove",Se.mousedown="MSPointerDown",Se.mouseup="MSPointerUp",Se.mousecancel="MSPointerCancel",Se.click="MSPointerUp",Se.resize="orientationchange resize"):(Se.mousemove="mousemove",Se.mousedown="mousedown",Se.mouseup="mouseup",Se.mousecancel="mouseleave",Se.click="click",Se.resize="resize"),X=function(e,t){var n,i,o,r,s=t||"d",a=1;for(i=0,o=e.length;i<o;i++)r=e[i],""!==r&&(n=r.indexOf("["),0!==n&&(n==-1?r="."+r:(a++,r="."+r.substring(0,n)+" || {})"+r.substring(n))),a++,s+=r+(i<o-1?" || {})":")"));return Array(a).join("(")+s},Z=/^([a-z]+:)?\/\//i,_e(ve,{widgets:[],_widgetRegisteredCallbacks:[],ui:ve.ui||{},fx:ve.fx||b,effects:ve.effects||j,mobile:ve.mobile||{},data:ve.data||{},dataviz:ve.dataviz||{},drawing:ve.drawing||{},spreadsheet:{messages:{}},keys:{INSERT:45,DELETE:46,BACKSPACE:8,TAB:9,ENTER:13,ESC:27,LEFT:37,UP:38,RIGHT:39,DOWN:40,END:35,HOME:36,SPACEBAR:32,PAGEUP:33,PAGEDOWN:34,F2:113,F10:121,F12:123,NUMPAD_PLUS:107,NUMPAD_MINUS:109,NUMPAD_DOT:110},support:ve.support||Se,animate:ve.animate||y,ns:"",attr:function(e){return"data-"+ve.ns+e},getShadows:s,wrap:a,deepExtend:l,getComputedStyles:f,webComponents:ve.webComponents||[],isScrollable:p,scrollLeft:m,size:g,toCamelCase:h,toHyphens:u,getOffset:ve.getOffset||v,parseEffects:ve.parseEffects||_,toggleClass:ve.toggleClass||k,directions:ve.directions||W,Observable:P,Class:i,Template:M,template:ye(M.compile,M),render:ye(M.render,M),stringify:ye(Ce.stringify,Ce),eventTarget:Q,htmlEncode:x,isLocalUrl:function(e){return e&&!Z.test(e)},expr:function(e,t,n){return e=e||"",typeof t==Me&&(n=t,t=!1),n=n||"d",e&&"["!==e.charAt(0)&&(e="."+e),t?(e=e.replace(/"([^.]*)\.([^"]*)"/g,'"$1_$DOT$_$2"'),e=e.replace(/'([^.]*)\.([^']*)'/g,"'$1_$DOT$_$2'"),e=X(e.split("."),n),e=e.replace(/_\$DOT\$_/g,".")):e=n+e,e},getter:function(e,t){var n=e+t;return Le[n]=Le[n]||Function("d","return "+ve.expr(e,t))},setter:function(e){return He[e]=He[e]||Function("d,value",ve.expr(e)+"=value")},accessor:function(e){return{get:ve.getter(e),set:ve.setter(e)}},guid:function(){var e,t,n="";for(e=0;e<32;e++)t=16*xe.random()|0,8!=e&&12!=e&&16!=e&&20!=e||(n+="-"),n+=(12==e?4:16==e?3&t|8:t).toString(16);return n},roleSelector:function(e){return e.replace(/(\S+)/g,"["+ve.attr("role")+"=$1],").slice(0,-1)},directiveSelector:function(e){var t,n=e.split(" ");if(n)for(t=0;t<n.length;t++)"view"!=n[t]&&(n[t]=n[t].replace(/(\w*)(view|bar|strip|over)$/,"$1-$2"));return n.join(" ").replace(/(\S+)/g,"kendo-mobile-$1,").slice(0,-1)},triggeredByInput:function(e){return/^(label|input|textarea|select)$/i.test(e.target.tagName)},onWidgetRegistered:function(e){for(var t=0,n=ve.widgets.length;t<n;t++)e(ve.widgets[t]);ve._widgetRegisteredCallbacks.push(e);
},logToConsole:function(e,i){var o=t.console;!ve.suppressLog&&n!==o&&o.log&&o[i||"log"](e)}}),J=P.extend({init:function(e,t){var n,i=this;i.element=ve.jQuery(e).handler(i),i.angular("init",t),P.fn.init.call(i),n=t?t.dataSource:null,n&&(t=_e({},t,{dataSource:{}})),t=i.options=_e(!0,{},i.options,t),n&&(t.dataSource=n),i.element.attr(ve.attr("role"))||i.element.attr(ve.attr("role"),(t.name||"").toLowerCase()),i.element.data("kendo"+t.prefix+t.name,i),i.bind(i.events,t)},events:[],options:{prefix:""},_hasBindingTarget:function(){return!!this.element[0].kendoBindingTarget},_tabindex:function(e){e=e||this.wrapper;var t=this.element,n="tabindex",i=e.attr(n)||t.attr(n);t.removeAttr(n),e.attr(n,isNaN(i)?0:i)},setOptions:function(t){this._setEvents(t),e.extend(this.options,t)},_setEvents:function(e){for(var t,n=this,i=0,o=n.events.length;i<o;i++)t=n.events[i],n.options[t]&&e[t]&&n.unbind(t,n.options[t]);n.bind(n.events,e)},resize:function(e){var t=this.getSize(),n=this._size;(e||(t.width>0||t.height>0)&&(!n||t.width!==n.width||t.height!==n.height))&&(this._size=t,this._resize(t,e),this.trigger("resize",t))},getSize:function(){return ve.dimensions(this.element)},size:function(e){return e?(this.setSize(e),n):this.getSize()},setSize:e.noop,_resize:e.noop,destroy:function(){var e=this;e.element.removeData("kendo"+e.options.prefix+e.options.name),e.element.removeData("handler"),e.unbind()},_destroy:function(){this.destroy()},angular:function(){},_muteAngularRebind:function(e){this._muteRebind=!0,e.call(this),this._muteRebind=!1}}),ee=J.extend({dataItems:function(){return this.dataSource.flatView()},_angularItems:function(t){var n=this;n.angular(t,function(){return{elements:n.items(),data:e.map(n.dataItems(),function(e){return{dataItem:e}})}})}}),ve.dimensions=function(e,t){var n=e[0];return t&&e.css(t),{width:n.offsetWidth,height:n.offsetHeight}},ve.notify=ke,te=/template$/i,ne=/^\s*(?:\{(?:.|\r\n|\n)*\}|\[(?:.|\r\n|\n)*\])\s*$/,ie=/^\{(\d+)(:[^\}]+)?\}|^\[[A-Za-z_]+\]$/,oe=/([A-Z])/g,ve.initWidget=function(i,o,r){var s,a,l,c,d,u,h,f,p,m,g,v,_;if(r?r.roles&&(r=r.roles):r=ve.ui.roles,i=i.nodeType?i:i[0],u=i.getAttribute("data-"+ve.ns+"role")){p=u.indexOf(".")===-1,l=p?r[u]:ve.getter(u)(t),g=e(i).data(),v=l?"kendo"+l.fn.options.prefix+l.fn.options.name:"",m=p?RegExp("^kendo.*"+u+"$","i"):RegExp("^"+v+"$","i");for(_ in g)if(_.match(m)){if(_!==v)return g[_];s=g[_]}if(l){for(f=C(i,"dataSource"),o=e.extend({},S(i,l.fn.options),o),f&&(o.dataSource=typeof f===Me?ve.getter(f)(t):f),c=0,d=l.fn.events.length;c<d;c++)a=l.fn.events[c],h=C(i,a),h!==n&&(o[a]=ve.getter(h)(t));return s?e.isEmptyObject(o)||s.setOptions(o):s=new l(i,o),s}}},ve.rolesFromNamespaces=function(e){var t,n,i=[];for(e[0]||(e=[ve.ui,ve.dataviz.ui]),t=0,n=e.length;t<n;t++)i[t]=e[t].roles;return _e.apply(null,[{}].concat(i.reverse()))},ve.init=function(t){var n=ve.rolesFromNamespaces(Ne.call(arguments,1));e(t).find("[data-"+ve.ns+"role]").addBack().each(function(){ve.initWidget(this,{},n)})},ve.destroy=function(t){e(t).find("[data-"+ve.ns+"role]").addBack().each(function(){var t,n=e(this).data();for(t in n)0===t.indexOf("kendo")&&typeof n[t].destroy===Ie&&n[t].destroy()})},ve.resize=function(t,n){var i,o=e(t).find("[data-"+ve.ns+"role]").addBack().filter(D);o.length&&(i=e.makeArray(o),i.sort(T),e.each(i,function(){var t=ve.widgetInstance(e(this));t&&t.resize(n)}))},ve.parseOptions=S,_e(ve.ui,{Widget:J,DataBoundWidget:ee,roles:{},progress:function(t,n,i){var o,r,s,a,l,c=t.find(".k-loading-mask"),d=ve.support,u=d.browser;i=e.extend({},{width:"100%",height:"100%",top:t.scrollTop(),opacity:!1},i),l=i.opacity?"k-loading-mask k-opaque":"k-loading-mask",n?c.length||(o=d.isRtl(t),r=o?"right":"left",a=t.scrollLeft(),s=u.webkit&&o?t[0].scrollWidth-t.width()-2*a:0,c=e(ve.format("<div class='{0}'><span class='k-loading-text'>{1}</span><div class='k-loading-image'/><div class='k-loading-color'/></div>",l,ve.ui.progress.messages.loading)).width(i.width).height(i.height).css("top",i.top).css(r,Math.abs(a)+s).prependTo(t)):c&&c.remove()},plugin:function(t,i,o){var r,s,a,l,c=t.fn.options.name;for(i=i||ve.ui,o=o||"",i[c]=t,i.roles[c.toLowerCase()]=t,r="getKendo"+o+c,c="kendo"+o+c,s={name:c,widget:t,prefix:o||""},ve.widgets.push(s),a=0,l=ve._widgetRegisteredCallbacks.length;a<l;a++)ve._widgetRegisteredCallbacks[a](s);e.fn[c]=function(i){var o,r=this;return typeof i===Me?(o=Ne.call(arguments,1),this.each(function(){var t,s,a=e.data(this,c);if(!a)throw Error(ve.format("Cannot call method '{0}' of {1} before it is initialized",i,c));if(t=a[i],typeof t!==Ie)throw Error(ve.format("Cannot find method '{0}' of {1}",i,c));if(s=t.apply(a,o),s!==n)return r=s,!1})):this.each(function(){return new t(this,i)}),r},e.fn[c].widget=t,e.fn[r]=function(){return this.data(c)}}}),ve.ui.progress.messages={loading:"Loading..."},re={bind:function(){return this},nullObject:!0,options:{}},se=J.extend({init:function(e,t){J.fn.init.call(this,e,t),this.element.autoApplyNS(),this.wrapper=this.element,this.element.addClass("km-widget")},destroy:function(){J.fn.destroy.call(this),this.element.kendoDestroy()},options:{prefix:"Mobile"},events:[],view:function(){var e=this.element.closest(ve.roleSelector("view splitview modalview drawer"));return ve.widgetInstance(e,ve.mobile.ui)||re},viewHasNativeScrolling:function(){var e=this.view();return e&&e.options.useNativeScrolling},container:function(){var e=this.element.closest(ve.roleSelector("view layout modalview drawer splitview"));return ve.widgetInstance(e.eq(0),ve.mobile.ui)||re}}),_e(ve.mobile,{init:function(e){ve.init(e,ve.mobile.ui,ve.ui,ve.dataviz.ui)},appLevelNativeScrolling:function(){return ve.mobile.application&&ve.mobile.application.options&&ve.mobile.application.options.useNativeScrolling},roles:{},ui:{Widget:se,DataBoundWidget:ee.extend(se.prototype),roles:{},plugin:function(e){ve.ui.plugin(e,ve.mobile.ui,"Mobile")}}}),l(ve.dataviz,{init:function(e){ve.init(e,ve.dataviz.ui)},ui:{roles:{},themes:{},views:[],plugin:function(e){ve.ui.plugin(e,ve.dataviz.ui)}},roles:{}}),ve.touchScroller=function(t,n){return n||(n={}),n.useNative=!0,e(t).map(function(t,i){return i=e(i),!(!Se.kineticScrollNeeded||!ve.mobile.ui.Scroller||i.data("kendoMobileScroller"))&&(i.kendoMobileScroller(n),i.data("kendoMobileScroller"))})[0]},ve.preventDefault=function(e){e.preventDefault()},ve.widgetInstance=function(e,n){var i,o,r,s,a=e.data(ve.ns+"role"),l=[];if(a){if("content"===a&&(a="scroller"),n)if(n[0])for(i=0,o=n.length;i<o;i++)l.push(n[i].roles[a]);else l.push(n.roles[a]);else l=[ve.ui.roles[a],ve.dataviz.ui.roles[a],ve.mobile.ui.roles[a]];for(a.indexOf(".")>=0&&(l=[ve.getter(a)(t)]),i=0,o=l.length;i<o;i++)if(r=l[i],r&&(s=e.data("kendo"+r.fn.options.prefix+r.fn.options.name)))return s}},ve.onResize=function(n){var i=n;return Se.mobileOS.android&&(i=function(){setTimeout(n,600)}),e(t).on(Se.resize,i),i},ve.unbindResize=function(n){e(t).off(Se.resize,n)},ve.attrValue=function(e,t){return e.data(ve.ns+t)},ve.days={Sunday:0,Monday:1,Tuesday:2,Wednesday:3,Thursday:4,Friday:5,Saturday:6},e.extend(e.expr[":"],{kendoFocusable:function(t){var n=e.attr(t,"tabindex");return A(t,!isNaN(n)&&n>-1)}}),ae=["mousedown","mousemove","mouseenter","mouseleave","mouseover","mouseout","mouseup","click"],le="label, input, [data-rel=external]",ce={setupMouseMute:function(){var t,n=0,i=ae.length,o=document.documentElement;if(!ce.mouseTrap&&Se.eventCapture)for(ce.mouseTrap=!0,ce.bustClick=!1,ce.captureMouse=!1,t=function(t){ce.captureMouse&&("click"===t.type?ce.bustClick&&!e(t.target).is(le)&&(t.preventDefault(),t.stopPropagation()):t.stopPropagation())};n<i;n++)o.addEventListener(ae[n],t,!0)},muteMouse:function(e){ce.captureMouse=!0,e.data.bustClick&&(ce.bustClick=!0),clearTimeout(ce.mouseTrapTimeoutID)},unMuteMouse:function(){clearTimeout(ce.mouseTrapTimeoutID),ce.mouseTrapTimeoutID=setTimeout(function(){ce.captureMouse=!1,ce.bustClick=!1},400)}},de={down:"touchstart mousedown",move:"mousemove touchmove",up:"mouseup touchend touchcancel",cancel:"mouseleave touchcancel"},Se.touch&&(Se.mobileOS.ios||Se.mobileOS.android)?de={down:"touchstart",move:"touchmove",up:"touchend touchcancel",cancel:"touchcancel"}:Se.pointers?de={down:"pointerdown",move:"pointermove",up:"pointerup",cancel:"pointercancel pointerleave"}:Se.msPointers&&(de={down:"MSPointerDown",move:"MSPointerMove",up:"MSPointerUp",cancel:"MSPointerCancel MSPointerLeave"}),!Se.msPointers||"onmspointerenter"in t||e.each({MSPointerEnter:"MSPointerOver",MSPointerLeave:"MSPointerOut"},function(t,n){e.event.special[t]={delegateType:n,bindType:n,handle:function(t){var i,o=this,r=t.relatedTarget,s=t.handleObj;return r&&(r===o||e.contains(o,r))||(t.type=s.origType,i=s.handler.apply(this,arguments),t.type=n),i}}}),ue=function(e){return de[e]||e},he=/([^ ]+)/g,ve.applyEventMap=function(e,t){return e=e.replace(he,ue),t&&(e=e.replace(he,"$1."+t)),e},fe=e.fn.on,_e(!0,I,e),I.fn=I.prototype=new e,I.fn.constructor=I,I.fn.init=function(t,n){return n&&n instanceof e&&!(n instanceof I)&&(n=I(n)),e.fn.init.call(this,t,n,pe)},I.fn.init.prototype=I.fn,pe=I(document),_e(I.fn,{handler:function(e){return this.data("handler",e),this},autoApplyNS:function(e){return this.data("kendoNS",e||ve.guid()),this},on:function(){var e,t,n,i,o,r,s=this,a=s.data("kendoNS");return 1===arguments.length?fe.call(s,arguments[0]):(e=s,t=Ne.call(arguments),typeof t[t.length-1]===Be&&t.pop(),n=t[t.length-1],i=ve.applyEventMap(t[0],a),Se.mouseAndTouchPresent&&i.search(/mouse|click/)>-1&&this[0]!==document.documentElement&&(ce.setupMouseMute(),o=2===t.length?null:t[1],r=i.indexOf("click")>-1&&i.indexOf("touchend")>-1,fe.call(this,{touchstart:ce.muteMouse,touchend:ce.unMuteMouse},o,{bustClick:r})),typeof n===Me&&(e=s.data("handler"),n=e[n],t[t.length-1]=function(t){n.call(e,t)}),t[0]=i,fe.apply(s,t),s)},kendoDestroy:function(e){return e=e||this.data("kendoNS"),e&&this.off("."+e),this}}),ve.jQuery=I,ve.eventMap=de,ve.timezone=function(){function e(e,t){var n,i,o,r=t[3],s=t[4],a=t[5],l=t[8];return l||(t[8]=l={}),l[e]?l[e]:(isNaN(s)?0===s.indexOf("last")?(n=new Date(Date.UTC(e,d[r]+1,1,a[0]-24,a[1],a[2],0)),i=u[s.substr(4,3)],o=n.getUTCDay(),n.setUTCDate(n.getUTCDate()+i-o-(i>o?7:0))):s.indexOf(">=")>=0&&(n=new Date(Date.UTC(e,d[r],s.substr(5),a[0],a[1],a[2],0)),i=u[s.substr(0,3)],o=n.getUTCDay(),n.setUTCDate(n.getUTCDate()+i-o+(i<o?7:0))):n=new Date(Date.UTC(e,d[r],s,a[0],a[1],a[2],0)),l[e]=n)}function t(t,n,i){var o,r,s,a;return(n=n[i])?(s=new Date(t).getUTCFullYear(),n=jQuery.grep(n,function(e){var t=e[0],n=e[1];return t<=s&&(n>=s||t==s&&"only"==n||"max"==n)}),n.push(t),n.sort(function(t,n){return"number"!=typeof t&&(t=+e(s,t)),"number"!=typeof n&&(n=+e(s,n)),t-n}),a=n[jQuery.inArray(t,n)-1]||n[n.length-1],isNaN(a)?a:null):(o=i.split(":"),r=0,o.length>1&&(r=60*o[0]+ +o[1]),[-1e6,"max","-","Jan",1,[0,0,0],r,"-"])}function n(e,t,n){var i,o,r,s=t[n];if("string"==typeof s&&(s=t[s]),!s)throw Error('Timezone "'+n+'" is either incorrect, or kendo.timezones.min.js is not included.');for(i=s.length-1;i>=0&&(o=s[i][3],!(o&&e>o));i--);if(r=s[i+1],!r)throw Error('Timezone "'+n+'" not found on '+e+".");return r}function i(e,i,o,r){typeof e!=Re&&(e=Date.UTC(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()));var s=n(e,i,r);return{zone:s,rule:t(e,o,s[1])}}function o(e,t){var n,o,r;return"Etc/UTC"==t||"Etc/GMT"==t?0:(n=i(e,this.zones,this.rules,t),o=n.zone,r=n.rule,ve.parseFloat(r?o[0]-r[6]:o[0]))}function r(e,t){var n=i(e,this.zones,this.rules,t),o=n.zone,r=n.rule,s=o[2];return s.indexOf("/")>=0?s.split("/")[r&&+r[6]?1:0]:s.indexOf("%s")>=0?s.replace("%s",r&&"-"!=r[7]?r[7]:""):s}function s(e,t,n){var i,o,r,s=n;return typeof t==Me&&(t=this.offset(e,t)),typeof n==Me&&(n=this.offset(e,n)),o=e.getTimezoneOffset(),e=new Date(e.getTime()+6e4*(t-n)),r=e.getTimezoneOffset(),typeof s==Me&&(s=this.offset(e,s)),i=r-o+(n-s),new Date(e.getTime()+6e4*i)}function a(e,t){return this.convert(e,e.getTimezoneOffset(),t)}function l(e,t){return this.convert(e,t,e.getTimezoneOffset())}function c(e){return this.apply(new Date(e),"Etc/UTC")}var d={Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11},u={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6};return{zones:{},rules:{},offset:o,convert:s,apply:a,remove:l,abbr:r,toLocalDate:c}}(),ve.date=function(){function e(e,t){return 0===t&&23===e.getHours()&&(e.setHours(e.getHours()+2),!0)}function t(t,n,i){var o=t.getHours();i=i||1,n=(n-t.getDay()+7*i)%7,t.setDate(t.getDate()+n),e(t,o)}function i(e,n,i){return e=new Date(e),t(e,n,i),e}function o(e){return new Date(e.getFullYear(),e.getMonth(),1)}function r(e){var t=new Date(e.getFullYear(),e.getMonth()+1,0),n=o(e),i=Math.abs(t.getTimezoneOffset()-n.getTimezoneOffset());return i&&t.setHours(n.getHours()+i/60),t}function s(e,t){return 1!==t?p(i(e,t,-1),4):p(e,4-(e.getDay()||7))}function a(e,t){var n=new Date(e.getFullYear(),0,1,(-6)),i=s(e,t),o=i.getTime()-n.getTime(),r=Math.floor(o/y);return 1+Math.floor(r/7)}function l(e,t){var i,o,r;return t===n&&(t=ve.culture().calendar.firstDay),i=p(e,-7),o=p(e,7),r=a(e,t),0===r?a(i,t)+1:53===r&&a(o,t)>1?1:r}function c(t){return t=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0),e(t,0),t}function d(e){return Date.UTC(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds())}function u(e){return b(e).getTime()-c(b(e))}function h(e,t,n){var i,o=u(t),r=u(n);return!e||o==r||(t>=n&&(n+=y),i=u(e),o>i&&(i+=y),r<o&&(r+=y),i>=o&&i<=r)}function f(e,t,n){var i,o=t.getTime(),r=n.getTime();return o>=r&&(r+=y),i=e.getTime(),i>=o&&i<=r}function p(t,n){var i=t.getHours();return t=new Date(t),m(t,n*y),e(t,i),t}function m(e,t,n){var i,o=e.getTimezoneOffset();e.setTime(e.getTime()+t),n||(i=e.getTimezoneOffset()-o,e.setTime(e.getTime()+i*w))}function g(t,n){return t=new Date(ve.date.getDate(t).getTime()+ve.date.getMilliseconds(n)),e(t,n.getHours()),t}function v(){return c(new Date)}function _(e){return c(e).getTime()==v().getTime()}function b(e){var t=new Date(1980,1,1,0,0,0);return e&&t.setHours(e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()),t}var w=6e4,y=864e5;return{adjustDST:e,dayOfWeek:i,setDayOfWeek:t,getDate:c,isInDateRange:f,isInTimeRange:h,isToday:_,nextDay:function(e){return p(e,1)},previousDay:function(e){return p(e,-1)},toUtcTime:d,MS_PER_DAY:y,MS_PER_HOUR:60*w,MS_PER_MINUTE:w,setTime:m,setHours:g,addDays:p,today:v,toInvariantTime:b,firstDayOfMonth:o,lastDayOfMonth:r,weekInYear:l,getMilliseconds:u}}(),ve.stripWhitespace=function(e){var t,n,i;if(document.createNodeIterator)for(t=document.createNodeIterator(e,NodeFilter.SHOW_TEXT,function(t){return t.parentNode==e?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT},!1);t.nextNode();)t.referenceNode&&!t.referenceNode.textContent.trim()&&t.referenceNode.parentNode.removeChild(t.referenceNode);else for(n=0;n<e.childNodes.length;n++)i=e.childNodes[n],3!=i.nodeType||/\S/.test(i.nodeValue)||(e.removeChild(i),n--),1==i.nodeType&&ve.stripWhitespace(i)},me=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,1e3/60)},ve.animationFrame=function(e){me.call(t,e)},ge=[],ve.queueAnimation=function(e){ge[ge.length]=e,1===ge.length&&ve.runNextAnimation()},ve.runNextAnimation=function(){ve.animationFrame(function(){ge[0]&&(ge.shift()(),ge[0]&&ve.runNextAnimation())})},ve.parseQueryStringParams=function(e){for(var t=e.split("?")[1]||"",n={},i=t.split(/&|=/),o=i.length,r=0;r<o;r+=2)""!==i[r]&&(n[decodeURIComponent(i[r])]=decodeURIComponent(i[r+1]));return n},ve.elementUnderCursor=function(e){if(n!==e.x.client)return document.elementFromPoint(e.x.client,e.y.client)},ve.wheelDeltaY=function(e){var t,i=e.originalEvent,o=i.wheelDeltaY;return i.wheelDelta?(o===n||o)&&(t=i.wheelDelta):i.detail&&i.axis===i.VERTICAL_AXIS&&(t=10*-i.detail),t},ve.throttle=function(e,t){var i,o,r=0;return!t||t<=0?e:(o=function(){function o(){e.apply(s,l),r=+new Date}var s=this,a=+new Date-r,l=arguments;return r?(i&&clearTimeout(i),a>t?o():i=setTimeout(o,t-a),n):o()},o.cancel=function(){clearTimeout(i)},o)},ve.caret=function(t,i,o){var r,s,a,l,c,d=i!==n;if(o===n&&(o=i),t[0]&&(t=t[0]),!d||!t.disabled){try{t.selectionStart!==n?d?(t.focus(),s=Se.mobileOS,s.wp||s.android?setTimeout(function(){t.setSelectionRange(i,o)},0):t.setSelectionRange(i,o)):i=[t.selectionStart,t.selectionEnd]:document.selection&&(e(t).is(":visible")&&t.focus(),r=t.createTextRange(),d?(r.collapse(!0),r.moveStart("character",i),r.moveEnd("character",o-i),r.select()):(a=r.duplicate(),r.moveToBookmark(document.selection.createRange().getBookmark()),a.setEndPoint("EndToStart",r),l=a.text.length,c=l+r.text.length,i=[l,c]))}catch(u){i=[]}return i}},ve.compileMobileDirective=function(e,n){var i=t.angular;return e.attr("data-"+ve.ns+"role",e[0].tagName.toLowerCase().replace("kendo-mobile-","").replace("-","")),i.element(e).injector().invoke(["$compile",function(t){t(e)(n),/^\$(digest|apply)$/.test(n.$$phase)||n.$digest()}]),ve.widgetInstance(e,ve.mobile.ui)},ve.antiForgeryTokens=function(){var t={},i=e("meta[name=csrf-token],meta[name=_csrf]").attr("content"),o=e("meta[name=csrf-param],meta[name=_csrf_header]").attr("content");return e("input[name^='__RequestVerificationToken']").each(function(){t[this.name]=this.value}),o!==n&&i!==n&&(t[o]=i),t},ve.cycleForm=function(e){function t(e){var t=ve.widgetInstance(e);t&&t.focus?t.focus():e.focus()}var n=e.find("input, .k-widget").first(),i=e.find("button, .k-button").last();i.on("keydown",function(e){e.keyCode!=ve.keys.TAB||e.shiftKey||(e.preventDefault(),t(n))}),n.on("keydown",function(e){e.keyCode==ve.keys.TAB&&e.shiftKey&&(e.preventDefault(),t(i))})},ve.focusElement=function(n){var i=[],o=n.parentsUntil("body").filter(function(e,t){var n=ve.getComputedStyles(t,["overflow"]);return"visible"!==n.overflow}).add(t);o.each(function(t,n){i[t]=e(n).scrollTop()});try{n[0].setActive()}catch(r){n[0].focus()}o.each(function(t,n){e(n).scrollTop(i[t])})},function(){function n(t,n,i,o){var r,s,a=e("<form>").attr({action:i,method:"POST",target:o}),l=ve.antiForgeryTokens();l.fileName=n,r=t.split(";base64,"),l.contentType=r[0].replace("data:",""),l.base64=r[1];for(s in l)l.hasOwnProperty(s)&&e("<input>").attr({value:l[s],name:s,type:"hidden"}).appendTo(a);a.appendTo("body").submit().remove()}function i(e,t){var n,i,o,r,s,a=e;if("string"==typeof e){for(n=e.split(";base64,"),i=n[0],o=atob(n[1]),r=new Uint8Array(o.length),s=0;s<o.length;s++)r[s]=o.charCodeAt(s);a=new Blob([r.buffer],{type:i})}navigator.msSaveBlob(a,t)}function o(e,n){t.Blob&&e instanceof Blob&&(e=URL.createObjectURL(e)),r.download=n,r.href=e;var i=document.createEvent("MouseEvents");i.initMouseEvent("click",!0,!1,t,0,0,0,0,0,!1,!1,!1,!1,0,null),r.dispatchEvent(i),setTimeout(function(){URL.revokeObjectURL(e)})}var r=document.createElement("a"),s="download"in r&&!ve.support.browser.edge;ve.saveAs=function(e){var t=n;e.forceProxy||(s?t=o:navigator.msSaveBlob&&(t=i)),t(e.dataURI,e.fileName,e.proxyURL,e.proxyTarget)}}(),ve.proxyModelSetters=function(e){var t={};return Object.keys(e||{}).forEach(function(n){Object.defineProperty(t,n,{get:function(){return e[n]},set:function(t){e[n]=t,e.dirty=!0}})}),t}}(jQuery,window),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.router.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(e,t){if(!t)return e;e+"/"===t&&(e=t);var n=RegExp("^"+t,"i");return n.test(e)||(e=t+"/"+e),f.protocol+"//"+(f.host+"/"+e).replace(/\/\/+/g,"/")}function i(e){return e?"#!":"#"}function o(e){var t=f.href;return"#!"===e&&t.indexOf("#")>-1&&t.indexOf("#!")<0?null:t.split(e)[1]||""}function r(e,t){return 0===t.indexOf(e)?t.substr(e.length).replace(/\/\//g,"/"):t}function s(e){return e.replace(/^(#)?/,"#")}function a(e){return e.replace(/^(#(!)?)?/,"#!")}var l=window.kendo,c="change",d="back",u="same",h=l.support,f=window.location,p=window.history,m=50,g=l.support.browser.msie,v=/^#*/,_=window.document,b=l.Class.extend({back:function(){g?setTimeout(function(){p.back()}):p.back()},forward:function(){g?setTimeout(function(){p.forward()}):p.forward()},length:function(){return p.length},replaceLocation:function(e){f.replace(e)}}),w=b.extend({init:function(e){this.root=e},navigate:function(e){p.pushState({},_.title,n(e,this.root))},replace:function(e){p.replaceState({},_.title,n(e,this.root))},normalize:function(e){return r(this.root,e)},current:function(){var e=f.pathname;return f.search&&(e+=f.search),r(this.root,e)},change:function(t){e(window).bind("popstate.kendo",t)},stop:function(){e(window).unbind("popstate.kendo")},normalizeCurrent:function(e){var t,r=e.root,s=f.pathname,a=o(i(e.hashBang));r===s+"/"&&(t=r),r===s&&a&&(t=n(a.replace(v,""),r)),t&&p.pushState({},_.title,t)}}),y=b.extend({init:function(e){this._id=l.guid(),this.prefix=i(e),this.fix=e?a:s},navigate:function(e){f.hash=this.fix(e)},replace:function(e){this.replaceLocation(this.fix(e))},normalize:function(e){return e.indexOf(this.prefix)<0?e:e.split(this.prefix)[1]},change:function(t){h.hashChange?e(window).on("hashchange."+this._id,t):this._interval=setInterval(t,m)},stop:function(){e(window).off("hashchange."+this._id),clearInterval(this._interval)},current:function(){return o(this.prefix)},normalizeCurrent:function(e){var t=f.pathname,n=e.root;return!(!e.pushState||n===t)&&(this.replaceLocation(n+this.prefix+r(n,t)),!0)}}),k=l.Observable.extend({start:function(t){if(t=t||{},this.bind([c,d,u],t),!this._started){this._started=!0,t.root=t.root||"/";var n,i=this.createAdapter(t);i.normalizeCurrent(t)||(n=i.current(),e.extend(this,{adapter:i,root:t.root,historyLength:i.length(),current:n,locations:[n]}),i.change(e.proxy(this,"_checkUrl")))}},createAdapter:function(e){return h.pushState&&e.pushState?new w(e.root):new y(e.hashBang)},stop:function(){this._started&&(this.adapter.stop(),this.unbind(c),this._started=!1)},change:function(e){this.bind(c,e)},replace:function(e,t){this._navigate(e,t,function(t){t.replace(e),this.locations[this.locations.length-1]=this.current})},navigate:function(e,n){return"#:back"===e?(this.backCalled=!0,this.adapter.back(),t):(this._navigate(e,n,function(t){t.navigate(e),this.locations.push(this.current)}),t)},_navigate:function(e,n,i){var o=this.adapter;return e=o.normalize(e),this.current===e||this.current===decodeURIComponent(e)?(this.trigger(u),t):(!n&&this.trigger(c,{url:e,decode:!1})||(this.current=e,i.call(this,o),this.historyLength=o.length()),t)},_checkUrl:function(){var e=this.adapter,n=e.current(),i=e.length(),o=this.historyLength===i,r=n===this.locations[this.locations.length-2]&&o,s=this.backCalled,a=this.current;return null===n||this.current===n||this.current===decodeURIComponent(n)||(this.historyLength=i,this.backCalled=!1,this.current=n,r&&this.trigger("back",{url:a,to:n})?(e.forward(),this.current=a,t):this.trigger(c,{url:n,backButtonPressed:!s})?(r?e.forward():(e.back(),this.historyLength--),this.current=a,t):(r?this.locations.pop():this.locations.push(n),t))}});l.History=k,l.History.HistoryAdapter=b,l.History.HashAdapter=y,l.History.PushStateAdapter=w,l.absoluteURL=n,l.history=new k}(window.kendo.jQuery),function(){function e(e,t){return t?e:"([^/]+)"}function t(t,n){return RegExp("^"+t.replace(p,"\\$&").replace(u,"(?:$1)?").replace(h,e).replace(f,"(.*?)")+"$",n?"i":"")}function n(e){return e.replace(/(\?.*)|(#.*)/g,"")}var i=window.kendo,o=i.history,r=i.Observable,s="init",a="routeMissing",l="change",c="back",d="same",u=/\((.*?)\)/g,h=/(\(\?)?:\w+/g,f=/\*\w+/g,p=/[\-{}\[\]+?.,\\\^$|#\s]/g,m=i.Class.extend({init:function(e,n,i){e instanceof RegExp||(e=t(e,i)),this.route=e,this._callback=n},callback:function(e,t,o){var r,s,a=0,l=i.parseQueryStringParams(e);if(l._back=t,e=n(e),r=this.route.exec(e).slice(1),s=r.length,o)for(;a<s;a++)void 0!==r[a]&&(r[a]=decodeURIComponent(r[a]));r.push(l),this._callback.apply(null,r)},worksWith:function(e,t,i){return!!this.route.test(n(e))&&(this.callback(e,t,i),!0)}}),g=r.extend({init:function(e){e||(e={}),r.fn.init.call(this),this.routes=[],this.pushState=e.pushState,this.hashBang=e.hashBang,this.root=e.root,this.ignoreCase=e.ignoreCase!==!1,this.bind([s,a,l,d],e)},destroy:function(){o.unbind(l,this._urlChangedProxy),o.unbind(d,this._sameProxy),o.unbind(c,this._backProxy),this.unbind()},start:function(){var e,t=this,n=function(){t._same()},i=function(e){t._back(e)},r=function(e){t._urlChanged(e)};o.start({same:n,change:r,back:i,pushState:t.pushState,hashBang:t.hashBang,root:t.root}),e={url:o.current||"/",preventDefault:$.noop},t.trigger(s,e)||t._urlChanged(e),this._urlChangedProxy=r,this._backProxy=i},route:function(e,t){this.routes.push(new m(e,t,this.ignoreCase))},navigate:function(e,t){i.history.navigate(e,t)},replace:function(e,t){i.history.replace(e,t)},_back:function(e){this.trigger(c,{url:e.url,to:e.to})&&e.preventDefault()},_same:function(){this.trigger(d)},_urlChanged:function(e){var t,n,o,r,s=e.url,c=!!e.decode,d=e.backButtonPressed;if(s||(s="/"),this.trigger(l,{url:e.url,params:i.parseQueryStringParams(e.url),backButtonPressed:d}))return void e.preventDefault();for(t=0,n=this.routes,r=n.length;t<r;t++)if(o=n[t],o.worksWith(s,d,c))return;this.trigger(a,{url:s,params:i.parseQueryStringParams(s),backButtonPressed:d})&&e.preventDefault()}});i.Router=g}(),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.data.odata.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(i,o){var r,s,a,l,c,d,u,h,f=[],p=i.logic||"and",g=i.filters;for(r=0,s=g.length;r<s;r++)i=g[r],a=i.field,u=i.value,d=i.operator,i.filters?i=n(i,o):(h=i.ignoreCase,a=a.replace(/\./g,"/"),i=w[d],o&&(i=y[d]),"isnull"===d||"isnotnull"===d?i=m.format("{0} {1} null",a,i):"isempty"===d||"isnotempty"===d?i=m.format("{0} {1} ''",a,i):i&&u!==t&&(l=e.type(u),"string"===l?(c="'{1}'",u=u.replace(/'/g,"''"),h===!0&&(a="tolower("+a+")")):"date"===l?o?(c="{1:yyyy-MM-ddTHH:mm:ss+00:00}",u=m.timezone.apply(u,"Etc/UTC")):c="datetime'{1:yyyy-MM-ddTHH:mm:ss}'":c="{1}",i.length>3?"substringof"!==i?c="{0}({2},"+c+")":(c="{0}("+c+",{2})","doesnotcontain"===d&&(o?(c="{0}({2},'{1}') eq -1",i="indexof"):c+=" eq false")):c="{2} {0} "+c,i=m.format(c,i,u,a))),f.push(i);return i=f.join(" "+p+" "),f.length>1&&(i="("+i+")"),i}function i(e){for(var t in e)0===t.indexOf("@odata")&&delete e[t]}function o(){return Math.floor(65536*(1+Math.random())).toString(16).substr(1)}function r(e){return e+o()+"-"+o()+"-"+o()}function s(e,t){var n=v+"--"+e;return t&&(n+="--"),n}function a(e,t,n,i){var o=e.options[i].url,r=m.format("{0} ",n);return b(o)?r+o(t):r+o}function l(e,t){var n="";return n+=s(e,!1),n+=v+"Content-Type: application/http",n+=v+"Content-Transfer-Encoding: binary",n+=v+"Content-ID: "+t}function c(e){var t="";return t+=v+"Content-Type: application/json;odata=minimalmetadata",t+=v+"Prefer: return=representation",t+=_+m.stringify(e)}function d(e,t,n,i,o,r){var s,d="";for(s=0;s<e.length;s++)d+=l(t,n),d+=_+a(o,e[s],o.options[i].type,i)+" HTTP/1.1",r||(d+=c(e[s])),d+=v,n++;return d}function u(e,t,n,i,o,r,a){var l="";return l+=h(t,n),l+=d(e,n,i,r,o,a),l+=s(n,!0),l+=v}function h(e,t){var n="";return n+="--"+e+v,n+="Content-Type: multipart/mixed; boundary="+t+v}function f(e,t){var n={},i=r("sf_batch_"),o="",a=0,l=e.options.batch.url,c=r("sf_changeset_");return n.type=e.options.batch.type,n.url=b(l)?l():l,n.headers={"Content-Type":"multipart/mixed; boundary="+i},t.updated.length&&(o+=u(t.updated,i,c,a,e,"update",!1),a+=t.updated.length,c=r("sf_changeset_")),t.destroyed.length&&(o+=u(t.destroyed,i,c,a,e,"destroy",!0),a+=t.destroyed.length,c=r("sf_changeset_")),t.created.length&&(o+=u(t.created,i,c,a,e,"create",!1)),o+=s(i,!0),n.data=o,n}function p(e){var t,n,i,o,r,s,a=e.match(/--changesetresponse_[a-z0-9-]+$/gm),l=0,c=[];for(c.push({models:[],passed:!0}),s=0;s<a.length;s++)o=a[s],o.lastIndexOf("--",o.length-1)?s<a.length-1&&c.push({models:[],passed:!0}):(l=l?e.indexOf(o,l+o.length):e.indexOf(o),t=e.substring(l,e.indexOf("--",l+1)),n=t.match(/^HTTP\/1\.\d (\d{3}) (.*)$/gm).pop(),i=m.parseFloat(n.match(/\d{3}/g).pop()),i>=200&&i<=299?(r=t.match(/\{.*\}/gm),r&&c[c.length-1].models.push(JSON.parse(r[0]))):c[c.length-1].passed=!1);return c}var m=window.kendo,g=e.extend,v="\r\n",_="\r\n\r\n",b=m.isFunction,w={eq:"eq",neq:"ne",gt:"gt",gte:"ge",lt:"lt",lte:"le",contains:"substringof",doesnotcontain:"substringof",endswith:"endswith",startswith:"startswith",isnull:"eq",isnotnull:"ne",isempty:"eq",isnotempty:"ne"},y=g({},w,{contains:"contains"}),k={pageSize:e.noop,page:e.noop,filter:function(e,t,i){t&&(t=n(t,i),t&&(e.$filter=t))},sort:function(t,n){var i=e.map(n,function(e){var t=e.field.replace(/\./g,"/");return"desc"===e.dir&&(t+=" desc"),t}).join(",");i&&(t.$orderby=i)},skip:function(e,t){t&&(e.$skip=t)},take:function(e,t){t&&(e.$top=t)}},x={read:{dataType:"jsonp"}};g(!0,m.data,{schemas:{odata:{type:"json",data:function(e){return e.d.results||[e.d]},total:"d.__count"}},transports:{odata:{read:{cache:!0,dataType:"jsonp",jsonp:"$callback"},update:{cache:!0,dataType:"json",contentType:"application/json",type:"PUT"},create:{cache:!0,dataType:"json",contentType:"application/json",type:"POST"},destroy:{cache:!0,dataType:"json",type:"DELETE"},parameterMap:function(e,t,n){var i,o,r,s;if(e=e||{},t=t||"read",s=(this.options||x)[t],s=s?s.dataType:"json","read"===t){i={$inlinecount:"allpages"},"json"!=s&&(i.$format="json");for(r in e)k[r]?k[r](i,e[r],n):i[r]=e[r]}else{if("json"!==s)throw Error("Only json dataType can be used for "+t+" operation.");if("destroy"!==t){for(r in e)o=e[r],"number"==typeof o&&(e[r]=o+"");i=m.stringify(e)}}return i}}}}),g(!0,m.data,{schemas:{"odata-v4":{type:"json",data:function(t){if(e.isArray(t)){for(var n=0;n<t.length;n++)i(t[n]);return t}return t=e.extend({},t),i(t),t.value?t.value:[t]},total:function(e){return e["@odata.count"]}}},transports:{"odata-v4":{batch:{type:"POST"},read:{cache:!0,dataType:"json"},update:{cache:!0,dataType:"json",contentType:"application/json;IEEE754Compatible=true",type:"PUT"},create:{cache:!0,dataType:"json",contentType:"application/json;IEEE754Compatible=true",type:"POST"},destroy:{cache:!0,dataType:"json",type:"DELETE"},parameterMap:function(e,t){var n=m.data.transports.odata.parameterMap(e,t,!0);return"read"==t&&(n.$count=!0,delete n.$inlinecount),n},submit:function(t){var n=this,i=f(n,t.data),o=t.data;(o.updated.length||o.destroyed.length||o.created.length)&&e.ajax(g(!0,{},{success:function(e){var n,i=p(e),r=0;o.updated.length&&(n=i[r],n.passed&&t.success(n.models.length?n.models:[],"update"),r++),o.destroyed.length&&(n=i[r],n.passed&&t.success([],"destroy"),r++),o.created.length&&(n=i[r],n.passed&&t.success(n.models,"create"))},error:function(e,n,i){t.error(e,n,i)}},i))}}}})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.data.xml.min",["kendo.core.min"],e)}(function(){return function(e,t){var n=window.kendo,i=e.isArray,o=e.isPlainObject,r=e.map,s=e.each,a=e.extend,l=n.getter,c=n.Class,d=c.extend({init:function(t){var l,c,d,u,h=this,f=t.total,p=t.model,m=t.parse,g=t.errors,v=t.serialize,_=t.data;p&&(o(p)&&(l=t.modelBase||n.data.Model,p.fields&&s(p.fields,function(t,n){o(n)&&n.field?e.isFunction(n.field)||(n=a(n,{field:h.getter(n.field)})):n={field:h.getter(n)},p.fields[t]=n}),c=p.id,c&&(d={},d[h.xpathToMember(c,!0)]={field:h.getter(c)},p.fields=a(d,p.fields),p.id=h.xpathToMember(c)),p=l.define(p)),h.model=p),f&&("string"==typeof f?(f=h.getter(f),h.total=function(e){return parseInt(f(e),10)}):"function"==typeof f&&(h.total=f)),g&&("string"==typeof g?(g=h.getter(g),h.errors=function(e){return g(e)||null}):"function"==typeof g&&(h.errors=g)),_&&("string"==typeof _?(_=h.xpathToMember(_),h.data=function(e){var t,n=h.evaluate(e,_);return n=i(n)?n:[n],h.model&&p.fields?(t=new h.model,r(n,function(e){if(e){var n,i={};for(n in p.fields)i[n]=t._parse(n,p.fields[n].field(e));
return i}})):n}):"function"==typeof _&&(h.data=_)),"function"==typeof m&&(u=h.parse,h.parse=function(e){var t=m.call(h,e);return u.call(h,t)}),"function"==typeof v&&(h.serialize=v)},total:function(e){return this.data(e).length},errors:function(e){return e?e.errors:null},serialize:function(e){return e},parseDOM:function(e){var n,o,r,s,a,l,c,d={},u=e.attributes,h=u.length;for(c=0;c<h;c++)l=u[c],d["@"+l.nodeName]=l.nodeValue;for(o=e.firstChild;o;o=o.nextSibling)r=o.nodeType,3===r||4===r?d["#text"]=o.nodeValue:1===r&&(n=this.parseDOM(o),s=o.nodeName,a=d[s],i(a)?a.push(n):a=a!==t?[a,n]:n,d[s]=a);return d},evaluate:function(e,t){for(var n,o,r,s,a,l=t.split(".");n=l.shift();)if(e=e[n],i(e)){for(o=[],t=l.join("."),a=0,r=e.length;a<r;a++)s=this.evaluate(e[a],t),s=i(s)?s:[s],o.push.apply(o,s);return o}return e},parse:function(t){var n,i,o={};return n=t.documentElement||e.parseXML(t).documentElement,i=this.parseDOM(n),o[n.nodeName]=i,o},xpathToMember:function(e,t){return e?(e=e.replace(/^\//,"").replace(/\//g,"."),e.indexOf("@")>=0?e.replace(/\.?(@.*)/,t?"$1":'["$1"]'):e.indexOf("text()")>=0?e.replace(/(\.?text\(\))/,t?"#text":'["#text"]'):e):""},getter:function(e){return l(this.xpathToMember(e),!0)}});e.extend(!0,n.data,{XmlDataReader:d,readers:{xml:d}})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.data.min",["kendo.core.min","kendo.data.odata.min","kendo.data.xml.min"],e)}(function(){return function(e,t){function n(e,t,n,i){return function(o){var r,s={};for(r in o)s[r]=o[r];s.field=i?n+"."+o.field:n,t==Ae&&e._notifyChange&&e._notifyChange(s),e.trigger(t,s)}}function i(t,n){if(t===n)return!0;var o,r=e.type(t),s=e.type(n);if(r!==s)return!1;if("date"===r)return t.getTime()===n.getTime();if("object"!==r&&"array"!==r)return!1;for(o in t)if(!i(t[o],n[o]))return!1;return!0}function o(e,t){var n,i;for(i in e){if(n=e[i],ue(n)&&n.field&&n.field===t)return n;if(n===t)return n}return null}function r(e){this.data=e||[]}function s(e,n){if(e){var i=typeof e===ke?{field:e,dir:n}:e,o=fe(i)?i:i!==t?[i]:[];return pe(o,function(e){return!!e.dir})}}function a(e){var t,n,i,o,r=e.filters;if(r)for(t=0,n=r.length;t<n;t++)i=r[t],o=i.operator,o&&typeof o===ke&&(i.operator=X[o.toLowerCase()]||o),a(i)}function l(e){if(e&&!he(e))return!fe(e)&&e.filters||(e={logic:"and",filters:fe(e)?e:[e]}),a(e),e}function c(e,t){return!e.logic&&!t.logic&&(e.field===t.field&&e.value===t.value&&e.operator===t.operator)}function d(e){return e=e||{},he(e)?{logic:"and",filters:[]}:l(e)}function u(e,t){return t.logic||e.field>t.field?1:e.field<t.field?-1:0}function h(e,t){var n,i,o,r,s;if(e=d(e),t=d(t),e.logic!==t.logic)return!1;if(o=(e.filters||[]).slice(),r=(t.filters||[]).slice(),o.length!==r.length)return!1;for(o=o.sort(u),r=r.sort(u),s=0;s<o.length;s++)if(n=o[s],i=r[s],n.logic&&i.logic){if(!h(n,i))return!1}else if(!c(n,i))return!1;return!0}function f(e){return fe(e)?e:[e]}function p(e,n){var i=typeof e===ke?{field:e,dir:n}:e,o=fe(i)?i:i!==t?[i]:[];return U(o,function(e){return{field:e.field,dir:e.dir||"asc",aggregates:e.aggregates}})}function m(e,t){return e&&e.getTime&&t&&t.getTime?e.getTime()===t.getTime():e===t}function g(e,t,n,i,o,r){var s,a,l,c,d;for(t=t||[],c=t.length,s=0;s<c;s++)a=t[s],l=a.aggregate,d=a.field,e[d]=e[d]||{},r[d]=r[d]||{},r[d][l]=r[d][l]||{},e[d][l]=Z[l.toLowerCase()](e[d][l],n,_e.accessor(d),i,o,r[d][l])}function v(e){return"number"==typeof e&&!isNaN(e)}function _(e){return e&&e.getTime}function b(e){var t,n=e.length,i=Array(n);for(t=0;t<n;t++)i[t]=e[t].toJSON();return i}function w(e,t,n,i,o){var r,s,a,l,c,d={};for(l=0,c=e.length;l<c;l++){r=e[l];for(s in t)a=o[s],a&&a!==s&&(d[a]||(d[a]=_e.setter(a)),d[a](r,t[s](r)),delete r[s])}}function y(e,t,n,i,o){var r,s,a,l,c;for(l=0,c=e.length;l<c;l++){r=e[l];for(s in t)r[s]=n._parse(s,t[s](r)),a=o[s],a&&a!==s&&delete r[a]}}function k(e,t,n,i,o){var r,s,a,l;for(s=0,l=e.length;s<l;s++)r=e[s],a=i[r.field],a&&a!=r.field&&(r.field=a),r.value=n._parse(r.field,r.value),r.hasSubgroups?k(r.items,t,n,i,o):y(r.items,t,n,i,o)}function x(e,t,n,i,o,r){return function(s){return s=e(s),s&&!he(i)&&("[object Array]"===$e.call(s)||s instanceof Qe||(s=[s]),n(s,i,new t,o,r)),s||[]}}function C(e,t,n,i){for(var o,r,s,a=0;t.length&&i&&(o=t[a],r=o.items,s=r.length,e&&e.field===o.field&&e.value===o.value?(e.hasSubgroups&&e.items.length?C(e.items[e.items.length-1],o.items,n,i):(r=r.slice(n,n+i),e.items=e.items.concat(r)),t.splice(a--,1)):o.hasSubgroups&&r.length?(C(o,r,n,i),o.items.length||t.splice(a--,1)):(r=r.slice(n,n+i),o.items=r,o.items.length||t.splice(a--,1)),0===r.length?n-=s:(n=0,i-=r.length),!(++a>=t.length)););a<t.length&&t.splice(a,t.length-a)}function S(e){var t,n,i,o,r,s=[];for(t=0,n=e.length;t<n;t++)if(r=e.at(t),r.hasSubgroups)s=s.concat(S(r.items));else for(i=r.items,o=0;o<i.length;o++)s.push(i.at(o));return s}function T(e,t){var n,i,o;if(t)for(n=0,i=e.length;n<i;n++)o=e.at(n),o.hasSubgroups?T(o.items,t):o.items=new W(o.items,t)}function D(e,t){for(var n=0,i=e.length;n<i;n++)if(e[n].hasSubgroups){if(D(e[n].items,t))return!0}else if(t(e[n].items,e[n]))return!0}function A(e,t,n,i){for(var o=0;o<e.length&&e[o].data!==t&&!E(e[o].data,n,i);o++);}function E(e,t,n){for(var i=0,o=e.length;i<o;i++){if(e[i]&&e[i].hasSubgroups)return E(e[i].items,t,n);if(e[i]===t||e[i]===n)return e[i]=n,!0}}function I(e,n,i,o,r){var s,a,l,c;for(s=0,a=e.length;s<a;s++)if(l=e[s],l&&!(l instanceof o))if(l.hasSubgroups===t||r){for(c=0;c<n.length;c++)if(n[c]===l){e[s]=n.at(c),A(i,n,l,e[s]);break}}else I(l.items,n,i,o,r)}function M(e,t){var n,i,o=e.length;for(i=0;i<o;i++)if(n=e[i],n.uid&&n.uid==t.uid)return e.splice(i,1),n}function R(e,t){return t?z(e,function(e){return e.uid&&e.uid==t.uid||e[t.idField]===t.id&&t.id!==t._defaultId}):-1}function F(e,t){return t?z(e,function(e){return e.uid==t.uid}):-1}function z(e,t){var n,i;for(n=0,i=e.length;n<i;n++)if(t(e[n]))return n;return-1}function P(e,t){var n,i;return e&&!he(e)?(n=e[t],i=ue(n)?n.from||n.field||t:e[t]||t,be(i)?t:i):t}function B(e,t){var n,i,o,r={};for(o in e)"filters"!==o&&(r[o]=e[o]);if(e.filters)for(r.filters=[],n=0,i=e.filters.length;n<i;n++)r.filters[n]=B(e.filters[n],t);else r.field=P(t.fields,r.field);return r}function L(e,t){var n,i,o,r,s,a=[];for(n=0,i=e.length;n<i;n++){o={},r=e[n];for(s in r)o[s]=r[s];o.field=P(t.fields,o.field),o.aggregates&&fe(o.aggregates)&&(o.aggregates=L(o.aggregates,t)),a.push(o)}return a}function H(t,n){var i,o,r,s,a,l,c,d,u,h;for(t=e(t)[0],i=t.options,o=n[0],r=n[1],s=[],a=0,l=i.length;a<l;a++)u={},d=i[a],c=d.parentNode,c===t&&(c=null),d.disabled||c&&c.disabled||(c&&(u.optgroup=c.label),u[o.field]=d.text,h=d.attributes.value,h=h&&h.specified?d.value:d.text,u[r.field]=h,s.push(u));return s}function N(t,n){var i,o,r,s,a,l,c,d=e(t)[0].tBodies[0],u=d?d.rows:[],h=n.length,f=[];for(i=0,o=u.length;i<o;i++){for(a={},c=!0,s=u[i].cells,r=0;r<h;r++)l=s[r],"th"!==l.nodeName.toLowerCase()&&(c=!1,a[n[r].field]=l.innerHTML);c||f.push(a)}return f}function O(e){return function(){var t=this._data,n=ie.fn[e].apply(this,qe.call(arguments));return this._data!=t&&this._attachBubbleHandlers(),n}}function V(t,n){function i(e,t){return e.filter(t).add(e.find(t))}var o,r,s,a,l,c,d,u,h=e(t).children(),f=[],p=n[0].field,m=n[1]&&n[1].field,g=n[2]&&n[2].field,v=n[3]&&n[3].field;for(o=0,r=h.length;o<r;o++)s={_loaded:!0},a=h.eq(o),c=a[0].firstChild,u=a.children(),t=u.filter("ul"),u=u.filter(":not(ul)"),l=a.attr("data-id"),l&&(s.id=l),c&&(s[p]=3==c.nodeType?c.nodeValue:u.text()),m&&(s[m]=i(u,"a").attr("href")),v&&(s[v]=i(u,"img").attr("src")),g&&(d=i(u,".k-sprite").prop("className"),s[g]=d&&e.trim(d.replace("k-sprite",""))),t.length&&(s.items=V(t.eq(0),n)),"true"==a.attr("data-hasChildren")&&(s.hasChildren=!0),f.push(s);return f}var U,W,j,q,G,$,K,Y,Q,X,Z,J,ee,te,ne,ie,oe,re,se,ae,le,ce=e.extend,de=e.proxy,ue=e.isPlainObject,he=e.isEmptyObject,fe=e.isArray,pe=e.grep,me=e.ajax,ge=e.each,ve=e.noop,_e=window.kendo,be=_e.isFunction,we=_e.Observable,ye=_e.Class,ke="string",xe="function",Ce="create",Se="read",Te="update",De="destroy",Ae="change",Ee="sync",Ie="get",Me="error",Re="requestStart",Fe="progress",ze="requestEnd",Pe=[Ce,Se,Te,De],Be=function(e){return e},Le=_e.getter,He=_e.stringify,Ne=Math,Oe=[].push,Ve=[].join,Ue=[].pop,We=[].splice,je=[].shift,qe=[].slice,Ge=[].unshift,$e={}.toString,Ke=_e.support.stableSort,Ye=/^\/Date\((.*?)\)\/$/,Qe=we.extend({init:function(e,t){var n=this;n.type=t||j,we.fn.init.call(n),n.length=e.length,n.wrapAll(e,n)},at:function(e){return this[e]},toJSON:function(){var e,t,n=this.length,i=Array(n);for(e=0;e<n;e++)t=this[e],t instanceof j&&(t=t.toJSON()),i[e]=t;return i},parent:ve,wrapAll:function(e,t){var n,i,o=this,r=function(){return o};for(t=t||[],n=0,i=e.length;n<i;n++)t[n]=o.wrap(e[n],r);return t},wrap:function(e,t){var n,i=this;return null!==e&&"[object Object]"===$e.call(e)&&(n=e instanceof i.type||e instanceof $,n||(e=e instanceof j?e.toJSON():e,e=new i.type(e)),e.parent=t,e.bind(Ae,function(e){i.trigger(Ae,{field:e.field,node:e.node,index:e.index,items:e.items||[this],action:e.node?e.action||"itemloaded":"itemchange"})})),e},push:function(){var e,t=this.length,n=this.wrapAll(arguments);return e=Oe.apply(this,n),this.trigger(Ae,{action:"add",index:t,items:n}),e},slice:qe,sort:[].sort,join:Ve,pop:function(){var e=this.length,t=Ue.apply(this);return e&&this.trigger(Ae,{action:"remove",index:e-1,items:[t]}),t},splice:function(e,t,n){var i,o,r,s=this.wrapAll(qe.call(arguments,2));if(i=We.apply(this,[e,t].concat(s)),i.length)for(this.trigger(Ae,{action:"remove",index:e,items:i}),o=0,r=i.length;o<r;o++)i[o]&&i[o].children&&i[o].unbind(Ae);return n&&this.trigger(Ae,{action:"add",index:e,items:s}),i},shift:function(){var e=this.length,t=je.apply(this);return e&&this.trigger(Ae,{action:"remove",index:0,items:[t]}),t},unshift:function(){var e,t=this.wrapAll(arguments);return e=Ge.apply(this,t),this.trigger(Ae,{action:"add",index:0,items:t}),e},indexOf:function(e){var t,n,i=this;for(t=0,n=i.length;t<n;t++)if(i[t]===e)return t;return-1},forEach:function(e,t){for(var n=0,i=this.length,o=t||window;n<i;n++)e.call(o,this[n],n,this)},map:function(e,t){for(var n=0,i=[],o=this.length,r=t||window;n<o;n++)i[n]=e.call(r,this[n],n,this);return i},reduce:function(e){var t,n=0,i=this.length;for(2==arguments.length?t=arguments[1]:n<i&&(t=this[n++]);n<i;n++)t=e(t,this[n],n,this);return t},reduceRight:function(e){var t,n=this.length-1;for(2==arguments.length?t=arguments[1]:n>0&&(t=this[n--]);n>=0;n--)t=e(t,this[n],n,this);return t},filter:function(e,t){for(var n,i=0,o=[],r=this.length,s=t||window;i<r;i++)n=this[i],e.call(s,n,i,this)&&(o[o.length]=n);return o},find:function(e,t){for(var n,i=0,o=this.length,r=t||window;i<o;i++)if(n=this[i],e.call(r,n,i,this))return n},every:function(e,t){for(var n,i=0,o=this.length,r=t||window;i<o;i++)if(n=this[i],!e.call(r,n,i,this))return!1;return!0},some:function(e,t){for(var n,i=0,o=this.length,r=t||window;i<o;i++)if(n=this[i],e.call(r,n,i,this))return!0;return!1},remove:function(e){var t=this.indexOf(e);t!==-1&&this.splice(t,1)},empty:function(){this.splice(0,this.length)}});"undefined"!=typeof Symbol&&Symbol.iterator&&!Qe.prototype[Symbol.iterator]&&(Qe.prototype[Symbol.iterator]=[][Symbol.iterator]),W=Qe.extend({init:function(e,t){we.fn.init.call(this),this.type=t||j;for(var n=0;n<e.length;n++)this[n]=e[n];this.length=n,this._parent=de(function(){return this},this)},at:function(e){var t=this[e];return t instanceof this.type?t.parent=this._parent:t=this[e]=this.wrap(t,this._parent),t}}),j=we.extend({init:function(e){var t,n,i=this,o=function(){return i};we.fn.init.call(this),this._handlers={};for(n in e)t=e[n],"object"==typeof t&&t&&!t.getTime&&"_"!=n.charAt(0)&&(t=i.wrap(t,n,o)),i[n]=t;i.uid=_e.guid()},shouldSerialize:function(e){return this.hasOwnProperty(e)&&"_handlers"!==e&&"_events"!==e&&typeof this[e]!==xe&&"uid"!==e},forEach:function(e){for(var t in this)this.shouldSerialize(t)&&e(this[t],t)},toJSON:function(){var e,t,n={};for(t in this)this.shouldSerialize(t)&&(e=this[t],(e instanceof j||e instanceof Qe)&&(e=e.toJSON()),n[t]=e);return n},get:function(e){var t,n=this;return n.trigger(Ie,{field:e}),t="this"===e?n:_e.getter(e,!0)(n)},_set:function(e,t){var n,i,o,r=this,s=e.indexOf(".")>=0;if(s)for(n=e.split("."),i="";n.length>1;){if(i+=n.shift(),o=_e.getter(i,!0)(r),o instanceof j)return o.set(n.join("."),t),s;i+="."}return _e.setter(e)(r,t),s},set:function(e,t){var n=this,i=!1,o=e.indexOf(".")>=0,r=_e.getter(e,!0)(n);return r!==t&&(r instanceof we&&this._handlers[e]&&(this._handlers[e].get&&r.unbind(Ie,this._handlers[e].get),r.unbind(Ae,this._handlers[e].change)),i=n.trigger("set",{field:e,value:t}),i||(o||(t=n.wrap(t,e,function(){return n})),(!n._set(e,t)||e.indexOf("(")>=0||e.indexOf("[")>=0)&&n.trigger(Ae,{field:e}))),i},parent:ve,wrap:function(e,t,i){var o,r,s,a,l=this,c=$e.call(e);return null==e||"[object Object]"!==c&&"[object Array]"!==c||(s=e instanceof Qe,a=e instanceof ie,"[object Object]"!==c||a||s?("[object Array]"===c||s||a)&&(s||a||(e=new Qe(e)),r=n(l,Ae,t,!1),e.bind(Ae,r),l._handlers[t]={change:r}):(e instanceof j||(e=new j(e)),o=n(l,Ie,t,!0),e.bind(Ie,o),r=n(l,Ae,t,!0),e.bind(Ae,r),l._handlers[t]={get:o,change:r}),e.parent=i),e}}),q={number:function(e){return typeof e===ke&&"null"===e.toLowerCase()?null:_e.parseFloat(e)},date:function(e){return typeof e===ke&&"null"===e.toLowerCase()?null:_e.parseDate(e)},"boolean":function(e){return typeof e===ke?"null"===e.toLowerCase()?null:"true"===e.toLowerCase():null!=e?!!e:e},string:function(e){return typeof e===ke&&"null"===e.toLowerCase()?null:null!=e?e+"":e},"default":function(e){return e}},G={string:"",number:0,date:new Date,"boolean":!1,"default":""},$=j.extend({init:function(n){var i,o,r=this;if((!n||e.isEmptyObject(n))&&(n=e.extend({},r.defaults,n),r._initializers))for(i=0;i<r._initializers.length;i++)o=r._initializers[i],n[o]=r.defaults[o]();j.fn.init.call(r,n),r.dirty=!1,r.dirtyFields={},r.idField&&(r.id=r.get(r.idField),r.id===t&&(r.id=r._defaultId))},shouldSerialize:function(e){return j.fn.shouldSerialize.call(this,e)&&"uid"!==e&&!("id"!==this.idField&&"id"===e)&&"dirty"!==e&&"dirtyFields"!==e&&"_accessors"!==e},_parse:function(e,t){var n,i=this,r=e,s=i.fields||{};return e=s[e],e||(e=o(s,r)),e&&(n=e.parse,!n&&e.type&&(n=q[e.type.toLowerCase()])),n?n(t):t},_notifyChange:function(e){var t=e.action;"add"!=t&&"remove"!=t||(this.dirty=!0,this.dirtyFields[e.field]=!0)},editable:function(e){return e=(this.fields||{})[e],!e||e.editable!==!1},set:function(e,t,n){var o=this,r=o.dirty;o.editable(e)&&(t=o._parse(e,t),i(t,o.get(e))?o.trigger("equalSet",{field:e,value:t}):(o.dirty=!0,o.dirtyFields[e]=!0,j.fn.set.call(o,e,t,n)&&!r&&(o.dirty=r,o.dirty||(o.dirtyFields[e]=!1))))},accept:function(e){var t,n,i=this,o=function(){return i};for(t in e)n=e[t],"_"!=t.charAt(0)&&(n=i.wrap(e[t],t,o)),i._set(t,n);i.idField&&(i.id=i.get(i.idField)),i.dirty=!1,i.dirtyFields={}},isNew:function(){return this.id===this._defaultId}}),$.define=function(e,n){n===t&&(n=e,e=$);var i,o,r,s,a,l,c,d,u=ce({defaults:{}},n),h={},f=u.id,p=[];if(f&&(u.idField=f),u.id&&delete u.id,f&&(u.defaults[f]=u._defaultId=""),"[object Array]"===$e.call(u.fields)){for(l=0,c=u.fields.length;l<c;l++)r=u.fields[l],typeof r===ke?h[r]={}:r.field&&(h[r.field]=r);u.fields=h}for(o in u.fields)r=u.fields[o],s=r.type||"default",a=null,d=o,o=typeof r.field===ke?r.field:o,r.nullable||(a=u.defaults[d!==o?d:o]=r.defaultValue!==t?r.defaultValue:G[s.toLowerCase()],"function"==typeof a&&p.push(o)),n.id===o&&(u._defaultId=a),u.defaults[d!==o?d:o]=a,r.parse=r.parse||q[s];return p.length>0&&(u._initializers=p),i=e.extend(u),i.define=function(e){return $.define(i,e)},u.fields&&(i.fields=u.fields,i.idField=u.idField),i},K={selector:function(e){return be(e)?e:Le(e)},compare:function(e){var t=this.selector(e);return function(e,n){return e=t(e),n=t(n),null==e&&null==n?0:null==e?-1:null==n?1:e.localeCompare?e.localeCompare(n):e>n?1:e<n?-1:0}},create:function(e){var t=e.compare||this.compare(e.field);return"desc"==e.dir?function(e,n){return t(n,e,!0)}:t},combine:function(e){return function(t,n){var i,o,r=e[0](t,n);for(i=1,o=e.length;i<o;i++)r=r||e[i](t,n);return r}}},Y=ce({},K,{asc:function(e){var t=this.selector(e);return function(e,n){var i=t(e),o=t(n);return i&&i.getTime&&o&&o.getTime&&(i=i.getTime(),o=o.getTime()),i===o?e.__position-n.__position:null==i?-1:null==o?1:i.localeCompare?i.localeCompare(o):i>o?1:-1}},desc:function(e){var t=this.selector(e);return function(e,n){var i=t(e),o=t(n);return i&&i.getTime&&o&&o.getTime&&(i=i.getTime(),o=o.getTime()),i===o?e.__position-n.__position:null==i?1:null==o?-1:o.localeCompare?o.localeCompare(i):i<o?1:-1}},create:function(e){return this[e.dir](e.field)}}),U=function(e,t){var n,i=e.length,o=Array(i);for(n=0;n<i;n++)o[n]=t(e[n],n,e);return o},Q=function(){function e(e){return"string"==typeof e&&(e=e.replace(/[\r\n]+/g,"")),JSON.stringify(e)}function t(t){return function(n,i,o){return i+="",o&&(n="("+n+" || '').toLowerCase()",i=i.toLowerCase()),t(n,e(i),o)}}function n(t,n,i,o){if(null!=i){if(typeof i===ke){var r=Ye.exec(i);r?i=new Date((+r[1])):o?(i=e(i.toLowerCase()),n="(("+n+" || '')+'').toLowerCase()"):i=e(i)}i.getTime&&(n="("+n+"&&"+n+".getTime?"+n+".getTime():"+n+")",i=i.getTime())}return n+" "+t+" "+i}function i(e){var t,n,i,o;for(t="/^",n=!1,i=0;i<e.length;++i){if(o=e.charAt(i),n)t+="\\"+o;else{if("~"==o){n=!0;continue}t+="*"==o?".*":"?"==o?".":".+^$()[]{}|\\/\n\r\u2028\u2029 ".indexOf(o)>=0?"\\"+o:o}n=!1}return t+"$/"}return{quote:function(t){return t&&t.getTime?"new Date("+t.getTime()+")":e(t)},eq:function(e,t,i){return n("==",e,t,i)},neq:function(e,t,i){return n("!=",e,t,i)},gt:function(e,t,i){return n(">",e,t,i)},gte:function(e,t,i){return n(">=",e,t,i)},lt:function(e,t,i){return n("<",e,t,i)},lte:function(e,t,i){return n("<=",e,t,i)},startswith:t(function(e,t){return e+".lastIndexOf("+t+", 0) == 0"}),doesnotstartwith:t(function(e,t){return e+".lastIndexOf("+t+", 0) == -1"}),endswith:t(function(e,t){var n=t?t.length-2:0;return e+".indexOf("+t+", "+e+".length - "+n+") >= 0"}),doesnotendwith:t(function(e,t){var n=t?t.length-2:0;return e+".indexOf("+t+", "+e+".length - "+n+") < 0"}),contains:t(function(e,t){return e+".indexOf("+t+") >= 0"}),doesnotcontain:t(function(e,t){return e+".indexOf("+t+") == -1"}),matches:t(function(e,t){return t=t.substring(1,t.length-1),i(t)+".test("+e+")"}),doesnotmatch:t(function(e,t){return t=t.substring(1,t.length-1),"!"+i(t)+".test("+e+")"}),isempty:function(e){return e+" === ''"},isnotempty:function(e){return e+" !== ''"},isnull:function(e){return"("+e+" == null)"},isnotnull:function(e){return"("+e+" != null)"},isnullorempty:function(e){return"("+e+" === null) || ("+e+" === '')"},isnotnullorempty:function(e){return"("+e+" !== null) && ("+e+" !== '')"}}}(),r.filterExpr=function(e){var n,i,o,s,a,l,c=[],d={and:" && ",or:" || "},u=[],h=[],f=e.filters;for(n=0,i=f.length;n<i;n++)o=f[n],a=o.field,l=o.operator,o.filters?(s=r.filterExpr(o),o=s.expression.replace(/__o\[(\d+)\]/g,function(e,t){return t=+t,"__o["+(h.length+t)+"]"}).replace(/__f\[(\d+)\]/g,function(e,t){return t=+t,"__f["+(u.length+t)+"]"}),h.push.apply(h,s.operators),u.push.apply(u,s.fields)):(typeof a===xe?(s="__f["+u.length+"](d)",u.push(a)):s=_e.expr(a),typeof l===xe?(o="__o["+h.length+"]("+s+", "+Q.quote(o.value)+")",h.push(l)):o=Q[(l||"eq").toLowerCase()](s,o.value,o.ignoreCase===t||o.ignoreCase)),c.push(o);return{expression:"("+c.join(d[e.logic])+")",fields:u,operators:h}},X={"==":"eq",equals:"eq",isequalto:"eq",equalto:"eq",equal:"eq","!=":"neq",ne:"neq",notequals:"neq",isnotequalto:"neq",notequalto:"neq",notequal:"neq","<":"lt",islessthan:"lt",lessthan:"lt",less:"lt","<=":"lte",le:"lte",islessthanorequalto:"lte",lessthanequal:"lte",">":"gt",isgreaterthan:"gt",greaterthan:"gt",greater:"gt",">=":"gte",isgreaterthanorequalto:"gte",greaterthanequal:"gte",ge:"gte",notsubstringof:"doesnotcontain",isnull:"isnull",isempty:"isempty",isnotempty:"isnotempty"},r.normalizeFilter=l,r.compareFilters=h,r.prototype={toArray:function(){return this.data},range:function(e,t){return new r(this.data.slice(e,e+t))},skip:function(e){return new r(this.data.slice(e))},take:function(e){return new r(this.data.slice(0,e))},select:function(e){return new r(U(this.data,e))},order:function(e,t,n){var i={dir:t};return e&&(e.compare?i.compare=e.compare:i.field=e),new r(n?this.data.sort(K.create(i)):this.data.slice(0).sort(K.create(i)))},orderBy:function(e,t){return this.order(e,"asc",t)},orderByDescending:function(e,t){return this.order(e,"desc",t)},sort:function(e,t,n,i){var o,r,a=s(e,t),l=[];if(n=n||K,a.length){for(o=0,r=a.length;o<r;o++)l.push(n.create(a[o]));return this.orderBy({compare:n.combine(l)},i)}return this},filter:function(e){var t,n,i,o,s,a,c,d,u=this.data,h=[];if(e=l(e),!e||0===e.filters.length)return this;for(o=r.filterExpr(e),a=o.fields,c=o.operators,s=d=Function("d, __f, __o","return "+o.expression),(a.length||c.length)&&(d=function(e){return s(e,a,c)}),t=0,i=u.length;t<i;t++)n=u[t],d(n)&&h.push(n);return new r(h)},group:function(e,t){e=p(e||[]),t=t||this.data;var n,i=this,o=new r(i.data);return e.length>0&&(n=e[0],o=o.groupBy(n).select(function(i){var o=new r(t).filter([{field:i.field,operator:"eq",value:i.value,ignoreCase:!1}]);return{field:i.field,value:i.value,items:e.length>1?new r(i.items).group(e.slice(1),o.toArray()).toArray():i.items,hasSubgroups:e.length>1,aggregates:o.aggregate(n.aggregates)}})),o},groupBy:function(e){if(he(e)||!this.data.length)return new r([]);var t,n,i,o,s=e.field,a=this._sortForGrouping(s,e.dir||"asc"),l=_e.accessor(s),c=l.get(a[0],s),d={field:s,value:c,items:[]},u=[d];for(i=0,o=a.length;i<o;i++)t=a[i],n=l.get(t,s),m(c,n)||(c=n,d={field:s,value:c,items:[]},u.push(d)),d.items.push(t);return new r(u)},_sortForGrouping:function(e,t){var n,i,o=this.data;if(!Ke){for(n=0,i=o.length;n<i;n++)o[n].__position=n;for(o=new r(o).sort(e,t,Y).toArray(),n=0,i=o.length;n<i;n++)delete o[n].__position;return o}return this.sort(e,t).toArray()},aggregate:function(e){var t,n,i={},o={};if(e&&e.length)for(t=0,n=this.data.length;t<n;t++)g(i,e,this.data[t],t,n,o);return i}},Z={sum:function(e,t,n){var i=n.get(t);return v(e)?v(i)&&(e+=i):e=i,e},count:function(e){return(e||0)+1},average:function(e,n,i,o,r,s){var a=i.get(n);return s.count===t&&(s.count=0),v(e)?v(a)&&(e+=a):e=a,v(a)&&s.count++,o==r-1&&v(e)&&(e/=s.count),e},max:function(e,t,n){var i=n.get(t);return v(e)||_(e)||(e=i),e<i&&(v(i)||_(i))&&(e=i),e},min:function(e,t,n){var i=n.get(t);return v(e)||_(e)||(e=i),e>i&&(v(i)||_(i))&&(e=i),e}},r.process=function(e,n,i){n=n||{};var o,a=new r(e),l=n.group,c=p(l||[]).concat(s(n.sort||[])),d=n.filterCallback,u=n.filter,h=n.skip,f=n.take;return u&&(a=a.filter(u),d&&(a=d(a)),o=a.toArray().length),c&&(a=i?a.sort(c,t,t,i):a.sort(c),l&&(e=a.toArray())),h!==t&&f!==t&&(a=a.range(h,f)),l&&(a=a.group(l,e)),{total:o,data:a.toArray()}},J=ye.extend({init:function(e){this.data=e.data},read:function(e){e.success(this.data)},update:function(e){e.success(e.data)},create:function(e){e.success(e.data)},destroy:function(e){e.success(e.data)}}),ee=ye.extend({init:function(e){var t,n=this;e=n.options=ce({},n.options,e),ge(Pe,function(t,n){typeof e[n]===ke&&(e[n]={url:e[n]})}),n.cache=e.cache?te.create(e.cache):{find:ve,add:ve},t=e.parameterMap,n.submit=e.submit,be(e.push)&&(n.push=e.push),n.push||(n.push=Be),n.parameterMap=be(t)?t:function(e){var n={};return ge(e,function(e,i){e in t&&(e=t[e],ue(e)&&(i=e.value(i),e=e.key)),n[e]=i}),n}},options:{parameterMap:Be},create:function(e){return me(this.setup(e,Ce))},read:function(n){var i,o,r,s=this,a=s.cache;n=s.setup(n,Se),i=n.success||ve,o=n.error||ve,r=a.find(n.data),r!==t?i(r):(n.success=function(e){a.add(n.data,e),i(e)},e.ajax(n))},update:function(e){return me(this.setup(e,Te))},destroy:function(e){return me(this.setup(e,De))},setup:function(e,t){e=e||{};var n,i=this,o=i.options[t],r=be(o.data)?o.data(e.data):o.data;return e=ce(!0,{},o,e),n=ce(!0,{},r,e.data),e.data=i.parameterMap(n,t),be(e.url)&&(e.url=e.url(n)),e}}),te=ye.extend({init:function(){this._store={}},add:function(e,n){e!==t&&(this._store[He(e)]=n)},find:function(e){return this._store[He(e)]},clear:function(){this._store={}},remove:function(e){delete this._store[He(e)]}}),te.create=function(e){var t={inmemory:function(){return new te}};return ue(e)&&be(e.find)?e:e===!0?new te:t[e]()},ne=ye.extend({init:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f,p=this;e=e||{};for(t in e)n=e[t],p[t]=typeof n===ke?Le(n):n;o=e.modelBase||$,ue(p.model)&&(p.model=i=o.define(p.model)),r=de(p.data,p),p._dataAccessFunction=r,p.model&&(s=de(p.groups,p),a=de(p.serialize,p),l={},c={},d={},u={},h=!1,i=p.model,i.fields&&(ge(i.fields,function(e,t){var n;f=e,ue(t)&&t.field?f=t.field:typeof t===ke&&(f=t),ue(t)&&t.from&&(n=t.from),h=h||n&&n!==e||f!==e,c[e]=Le(n||f),d[e]=Le(e),l[n||f]=e,u[e]=n||f}),!e.serialize&&h&&(p.serialize=x(a,i,w,d,l,u))),p._dataAccessFunction=r,p.data=x(r,i,y,c,l,u),p.groups=x(s,i,k,c,l,u))},errors:function(e){return e?e.errors:null},parse:Be,data:Be,total:function(e){return e.length},groups:Be,aggregates:function(){return{}},serialize:function(e){return e}}),ie=we.extend({init:function(e){var n,i,o,r=this;e&&(i=e.data),e=r.options=ce({},r.options,e),r._map={},r._prefetch={},r._data=[],r._pristineData=[],r._ranges=[],r._view=[],r._pristineTotal=0,r._destroyed=[],r._pageSize=e.pageSize,r._page=e.page||(e.pageSize?1:t),r._sort=s(e.sort),r._filter=l(e.filter),r._group=p(e.group),r._aggregate=e.aggregate,r._total=e.total,r._shouldDetachObservableParents=!0,we.fn.init.call(r),r.transport=oe.create(e,i,r),be(r.transport.push)&&r.transport.push({pushCreate:de(r._pushCreate,r),pushUpdate:de(r._pushUpdate,r),pushDestroy:de(r._pushDestroy,r)}),null!=e.offlineStorage&&("string"==typeof e.offlineStorage?(o=e.offlineStorage,r._storage={getItem:function(){return JSON.parse(localStorage.getItem(o))},setItem:function(e){localStorage.setItem(o,He(r.reader.serialize(e)))}}):r._storage=e.offlineStorage),r.reader=new _e.data.readers[e.schema.type||"json"](e.schema),n=r.reader.model||{},r._detachObservableParents(),r._data=r._observe(r._data),r._online=!0,r.bind(["push",Me,Ae,Re,Ee,ze,Fe],e)},options:{data:null,schema:{modelBase:$},offlineStorage:null,serverSorting:!1,serverPaging:!1,serverFiltering:!1,serverGrouping:!1,serverAggregates:!1,batch:!1,inPlaceSort:!1},clone:function(){return this},online:function(n){return n!==t?this._online!=n&&(this._online=n,n)?this.sync():e.Deferred().resolve().promise():this._online},offlineData:function(e){return null==this.options.offlineStorage?null:e!==t?this._storage.setItem(e):this._storage.getItem()||[]},_isServerGrouped:function(){var e=this.group()||[];return this.options.serverGrouping&&e.length},_pushCreate:function(e){this._push(e,"pushCreate")},_pushUpdate:function(e){this._push(e,"pushUpdate")},_pushDestroy:function(e){this._push(e,"pushDestroy")},_push:function(e,t){var n=this._readData(e);n||(n=e),this[t](n)},_flatData:function(e,t){if(e){if(this._isServerGrouped())return S(e);if(!t)for(var n=0;n<e.length;n++)e.at(n)}return e},parent:ve,get:function(e){var t,n,i=this._flatData(this._data,this.options.useRanges);for(t=0,n=i.length;t<n;t++)if(i[t].id==e)return i[t]},getByUid:function(e){return this._getByUid(e,this._data)},_getByUid:function(e,t){var n,i,o=this._flatData(t,this.options.useRanges);if(o)for(n=0,i=o.length;n<i;n++)if(o[n].uid==e)return o[n]},indexOf:function(e){return F(this._data,e)},at:function(e){return this._data.at(e)},data:function(e){var n,i=this;if(e===t){if(i._data)for(n=0;n<i._data.length;n++)i._data.at(n);return i._data}i._detachObservableParents(),i._data=this._observe(e),i._pristineData=e.slice(0),i._storeData(),i._ranges=[],i.trigger("reset"),i._addRange(i._data),i._total=i._data.length,i._pristineTotal=i._total,i._process(i._data)},view:function(e){return e===t?this._view:(this._view=this._observeView(e),t)},_observeView:function(e){var t,n=this;return I(e,n._data,n._ranges,n.reader.model||j,n._isServerGrouped()),t=new W(e,n.reader.model),t.parent=function(){return n.parent()},t},flatView:function(){var e=this.group()||[];return e.length?S(this._view):this._view},add:function(e){return this.insert(this._data.length,e)},_createNewModel:function(e){return this.reader.model?new this.reader.model(e):e instanceof j?e:new j(e)},insert:function(e,t){return t||(t=e,e=0),t instanceof $||(t=this._createNewModel(t)),this._isServerGrouped()?this._data.splice(e,0,this._wrapInEmptyGroup(t)):this._data.splice(e,0,t),this._insertModelInRange(e,t),t},pushInsert:function(e,t){var n,i,o,r,s,a;t||(t=e,e=0),fe(t)||(t=[t]),n=[],i=this.options.autoSync,this.options.autoSync=!1;try{for(o=0;o<t.length;o++)r=t[o],s=this.insert(e,r),n.push(s),a=s.toJSON(),this._isServerGrouped()&&(a=this._wrapInEmptyGroup(a)),this._pristineData.push(a),e++}finally{this.options.autoSync=i}n.length&&this.trigger("push",{type:"create",items:n})},pushCreate:function(e){this.pushInsert(this._data.length,e)},pushUpdate:function(e){var t,n,i,o,r;for(fe(e)||(e=[e]),t=[],n=0;n<e.length;n++)i=e[n],o=this._createNewModel(i),r=this.get(o.id),r?(t.push(r),r.accept(i),r.trigger(Ae),this._updatePristineForModel(r,i)):this.pushCreate(i);t.length&&this.trigger("push",{type:"update",items:t})},pushDestroy:function(e){var t=this._removeItems(e);t.length&&this.trigger("push",{type:"destroy",items:t})},_removeItems:function(e){var t,n,i,o,r,s;fe(e)||(e=[e]),t=[],n=this.options.autoSync,this.options.autoSync=!1;try{for(i=0;i<e.length;i++)o=e[i],r=this._createNewModel(o),s=!1,this._eachItem(this._data,function(e){var n,i;for(n=0;n<e.length;n++)if(i=e.at(n),i.id===r.id){t.push(i),e.splice(n,1),s=!0;break}}),s&&(this._removePristineForModel(r),this._destroyed.pop())}finally{this.options.autoSync=n}return t},remove:function(e){var t,n=this,i=n._isServerGrouped();return this._eachItem(n._data,function(o){if(t=M(o,e),t&&i)return t.isNew&&t.isNew()||n._destroyed.push(t),!0}),this._removeModelFromRanges(e),e},destroyed:function(){return this._destroyed},created:function(){var e,t,n=[],i=this._flatData(this._data,this.options.useRanges);for(e=0,t=i.length;e<t;e++)i[e].isNew&&i[e].isNew()&&n.push(i[e]);return n},updated:function(){var e,t,n=[],i=this._flatData(this._data,this.options.useRanges);for(e=0,t=i.length;e<t;e++)i[e].isNew&&!i[e].isNew()&&i[e].dirty&&n.push(i[e]);return n},sync:function(){var t,n=this,i=[],o=[],r=n._destroyed,s=e.Deferred().resolve().promise();if(n.online()){if(!n.reader.model)return s;i=n.created(),o=n.updated(),t=[],n.options.batch&&n.transport.submit?t=n._sendSubmit(i,o,r):(t.push.apply(t,n._send("create",i)),t.push.apply(t,n._send("update",o)),t.push.apply(t,n._send("destroy",r))),s=e.when.apply(null,t).then(function(){var e,t;for(e=0,t=arguments.length;e<t;e++)arguments[e]&&n._accept(arguments[e]);n._storeData(!0),n._change({action:"sync"}),n.trigger(Ee)})}else n._storeData(!0),n._change({action:"sync"});return s},cancelChanges:function(e){var t=this;e instanceof _e.data.Model?t._cancelModel(e):(t._destroyed=[],t._detachObservableParents(),t._data=t._observe(t._pristineData),t.options.serverPaging&&(t._total=t._pristineTotal),t._ranges=[],t._addRange(t._data,0),t._change(),t._markOfflineUpdatesAsDirty())},_markOfflineUpdatesAsDirty:function(){var e=this;null!=e.options.offlineStorage&&e._eachItem(e._data,function(e){var t,n;for(t=0;t<e.length;t++)n=e.at(t),"update"!=n.__state__&&"create"!=n.__state__||(n.dirty=!0)})},hasChanges:function(){var e,t,n=this._flatData(this._data,this.options.useRanges);if(this._destroyed.length)return!0;for(e=0,t=n.length;e<t;e++)if(n[e].isNew&&n[e].isNew()||n[e].dirty)return!0;return!1},_accept:function(t){var n,i=this,o=t.models,r=t.response,s=0,a=i._isServerGrouped(),l=i._pristineData,c=t.type;if(i.trigger(ze,{response:r,type:c}),r&&!he(r)){if(r=i.reader.parse(r),i._handleCustomErrors(r))return;r=i.reader.data(r),fe(r)||(r=[r])}else r=e.map(o,function(e){return e.toJSON()});for("destroy"===c&&(i._destroyed=[]),
s=0,n=o.length;s<n;s++)"destroy"!==c?(o[s].accept(r[s]),"create"===c?l.push(a?i._wrapInEmptyGroup(o[s]):r[s]):"update"===c&&i._updatePristineForModel(o[s],r[s])):i._removePristineForModel(o[s])},_updatePristineForModel:function(e,t){this._executeOnPristineForModel(e,function(e,n){_e.deepExtend(n[e],t)})},_executeOnPristineForModel:function(e,t){this._eachPristineItem(function(n){var i=R(n,e);if(i>-1)return t(i,n),!0})},_removePristineForModel:function(e){this._executeOnPristineForModel(e,function(e,t){t.splice(e,1)})},_readData:function(e){var t=this._isServerGrouped()?this.reader.groups:this.reader.data;return t.call(this.reader,e)},_eachPristineItem:function(e){this._eachItem(this._pristineData,e)},_eachItem:function(e,t){e&&e.length&&(this._isServerGrouped()?D(e,t):t(e))},_pristineForModel:function(e){var t,n,i=function(i){if(n=R(i,e),n>-1)return t=i[n],!0};return this._eachPristineItem(i),t},_cancelModel:function(e){var t=this,n=this._pristineForModel(e);this._eachItem(this._data,function(i){var o=F(i,e);o>=0&&(!n||e.isNew()&&!n.__state__?(i.splice(o,1),t._removeModelFromRanges(e)):(i[o].accept(n),"update"==n.__state__&&(i[o].dirty=!0)))})},_submit:function(t,n){var i=this;i.trigger(Re,{type:"submit"}),i.trigger(Fe),i.transport.submit(ce({success:function(n,i){var o=e.grep(t,function(e){return e.type==i})[0];o&&o.resolve({response:n,models:o.models,type:i})},error:function(e,n,o){for(var r=0;r<t.length;r++)t[r].reject(e);i.error(e,n,o)}},n))},_sendSubmit:function(t,n,i){var o=this,r=[];return o.options.batch&&(t.length&&r.push(e.Deferred(function(e){e.type="create",e.models=t})),n.length&&r.push(e.Deferred(function(e){e.type="update",e.models=n})),i.length&&r.push(e.Deferred(function(e){e.type="destroy",e.models=i})),o._submit(r,{data:{created:o.reader.serialize(b(t)),updated:o.reader.serialize(b(n)),destroyed:o.reader.serialize(b(i))}})),r},_promise:function(t,n,i){var o=this;return e.Deferred(function(e){o.trigger(Re,{type:i}),o.trigger(Fe),o.transport[i].call(o.transport,ce({success:function(t){e.resolve({response:t,models:n,type:i})},error:function(t,n,i){e.reject(t),o.error(t,n,i)}},t))}).promise()},_send:function(e,t){var n,i,o=this,r=[],s=o.reader.serialize(b(t));if(o.options.batch)t.length&&r.push(o._promise({data:{models:s}},t,e));else for(n=0,i=t.length;n<i;n++)r.push(o._promise({data:s[n]},[t[n]],e));return r},read:function(t){var n=this,i=n._params(t),o=e.Deferred();return n._queueRequest(i,function(){var e=n.trigger(Re,{type:"read"});e?(n._dequeueRequest(),o.resolve(e)):(n.trigger(Fe),n._ranges=[],n.trigger("reset"),n.online()?n.transport.read({data:i,success:function(e){n._ranges=[],n.success(e,i),o.resolve()},error:function(){var e=qe.call(arguments);n.error.apply(n,e),o.reject.apply(o,e)}}):null!=n.options.offlineStorage&&(n.success(n.offlineData(),i),o.resolve()))}),o.promise()},_readAggregates:function(e){return this.reader.aggregates(e)},success:function(e){var n,i,o,r,s,a,l,c,d,u,h=this,f=h.options;if(h.trigger(ze,{response:e,type:"read"}),h.online()){if(e=h.reader.parse(e),h._handleCustomErrors(e))return h._dequeueRequest(),t;h._total=h.reader.total(e),h._pageSize>h._total&&(h._pageSize=h._total),h._aggregate&&f.serverAggregates&&(h._aggregateResult=h._readAggregates(e)),n=arguments.length>1?arguments[1]:t,e=h._readData(e,n),h._destroyed=[]}else{for(e=h._readData(e),i=[],o={},r=h.reader.model,s=r?r.idField:"id",a=0;a<this._destroyed.length;a++)l=this._destroyed[a][s],o[l]=l;for(a=0;a<e.length;a++)c=e[a],d=c.__state__,"destroy"==d?o[c[s]]||this._destroyed.push(this._createNewModel(c)):i.push(c);e=i,h._total=e.length}if(h._pristineTotal=h._total,h._pristineData=e.slice(0),h._detachObservableParents(),h.options.endless){for(h._data.unbind(Ae,h._changeHandler),e=h._observe(e),u=0;u<e.length;u++)h._data.push(e[u]);h._data.bind(Ae,h._changeHandler)}else h._data=h._observe(e);h._markOfflineUpdatesAsDirty(),h._storeData(),h._addRange(h._data),h._process(h._data),h._dequeueRequest()},_detachObservableParents:function(){if(this._data&&this._shouldDetachObservableParents)for(var e=0;e<this._data.length;e++)this._data[e].parent&&(this._data[e].parent=ve)},_storeData:function(e){function t(e){var n,i,o,r=[];for(n=0;n<e.length;n++)i=e.at(n),o=i.toJSON(),s&&i.items?o.items=t(i.items):(o.uid=i.uid,a&&(i.isNew()?o.__state__="create":i.dirty&&(o.__state__="update"))),r.push(o);return r}var n,i,o,r,s=this._isServerGrouped(),a=this.reader.model;if(null!=this.options.offlineStorage){for(n=t(this._data),i=[],o=0;o<this._destroyed.length;o++)r=this._destroyed[o].toJSON(),r.__state__="destroy",i.push(r);this.offlineData(n.concat(i)),e&&(this._pristineData=this._readData(n))}},_addRange:function(e,n){var i=this,o=t!==n?n:i._skip||0,r=o+i._flatData(e,!0).length;i._ranges.push({start:o,end:r,data:e,timestamp:(new Date).getTime()}),i._ranges.sort(function(e,t){return e.start-t.start})},error:function(e,t,n){this._dequeueRequest(),this.trigger(ze,{}),this.trigger(Me,{xhr:e,status:t,errorThrown:n})},_params:function(e){var t=this,n=ce({take:t.take(),skip:t.skip(),page:t.page(),pageSize:t.pageSize(),sort:t._sort,filter:t._filter,group:t._group,aggregate:t._aggregate},e);return t.options.serverPaging||(delete n.take,delete n.skip,delete n.page,delete n.pageSize),t.options.serverGrouping?t.reader.model&&n.group&&(n.group=L(n.group,t.reader.model)):delete n.group,t.options.serverFiltering?t.reader.model&&n.filter&&(n.filter=B(n.filter,t.reader.model)):delete n.filter,t.options.serverSorting?t.reader.model&&n.sort&&(n.sort=L(n.sort,t.reader.model)):delete n.sort,t.options.serverAggregates?t.reader.model&&n.aggregate&&(n.aggregate=L(n.aggregate,t.reader.model)):delete n.aggregate,n},_queueRequest:function(e,n){var i=this;i._requestInProgress?i._pending={callback:de(n,i),options:e}:(i._requestInProgress=!0,i._pending=t,n())},_dequeueRequest:function(){var e=this;e._requestInProgress=!1,e._pending&&e._queueRequest(e._pending.options,e._pending.callback)},_handleCustomErrors:function(e){if(this.reader.errors){var t=this.reader.errors(e);if(t)return this.trigger(Me,{xhr:null,status:"customerror",errorThrown:"custom error",errors:t}),!0}return!1},_shouldWrap:function(e){var t=this.reader.model;return!(!t||!e.length)&&!(e[0]instanceof t)},_observe:function(e){var t,n=this,i=n.reader.model;return n._shouldDetachObservableParents=!0,e instanceof Qe?(n._shouldDetachObservableParents=!1,n._shouldWrap(e)&&(e.type=n.reader.model,e.wrapAll(e,e))):(t=n.pageSize()&&!n.options.serverPaging?W:Qe,e=new t(e,n.reader.model),e.parent=function(){return n.parent()}),n._isServerGrouped()&&T(e,i),n._changeHandler&&n._data&&n._data instanceof Qe?n._data.unbind(Ae,n._changeHandler):n._changeHandler=de(n._change,n),e.bind(Ae,n._changeHandler)},_updateTotalForAction:function(e,t){var n=this,i=parseInt(n._total,10);v(n._total)||(i=parseInt(n._pristineTotal,10)),"add"===e?i+=t.length:"remove"===e?i-=t.length:"itemchange"===e||"sync"===e||n.options.serverPaging?"sync"===e&&(i=n._pristineTotal=parseInt(n._total,10)):i=n._pristineTotal,n._total=i},_change:function(e){var t,n,i,o=this,r=e?e.action:"";if("remove"===r)for(t=0,n=e.items.length;t<n;t++)e.items[t].isNew&&e.items[t].isNew()||o._destroyed.push(e.items[t]);!o.options.autoSync||"add"!==r&&"remove"!==r&&"itemchange"!==r?(o._updateTotalForAction(r,e?e.items:[]),o._process(o._data,e)):(i=function(t){"sync"===t.action&&(o.unbind("change",i),o._updateTotalForAction(r,e.items))},o.first("change",i),o.sync())},_calculateAggregates:function(e,t){t=t||{};var n=new r(e),i=t.aggregate,o=t.filter;return o&&(n=n.filter(o)),n.aggregate(i)},_process:function(e,n){var i,o=this,r={};o.options.serverPaging!==!0&&(r.skip=o._skip,r.take=o._take||o._pageSize,r.skip===t&&o._page!==t&&o._pageSize!==t&&(r.skip=(o._page-1)*o._pageSize)),o.options.serverSorting!==!0&&(r.sort=o._sort),o.options.serverFiltering!==!0&&(r.filter=o._filter),o.options.serverGrouping!==!0&&(r.group=o._group),o.options.serverAggregates!==!0&&(r.aggregate=o._aggregate,o._aggregateResult=o._calculateAggregates(e,r)),i=o._queryProcess(e,r),o.view(i.data),i.total===t||o.options.serverFiltering||(o._total=i.total),n=n||{},n.items=n.items||o._view,o.trigger(Ae,n)},_queryProcess:function(e,t){return this.options.inPlaceSort?r.process(e,t,this.options.inPlaceSort):r.process(e,t)},_mergeState:function(e){var n=this;return e!==t&&(n._pageSize=e.pageSize,n._page=e.page,n._sort=e.sort,n._filter=e.filter,n._group=e.group,n._aggregate=e.aggregate,n._skip=n._currentRangeStart=e.skip,n._take=e.take,n._skip===t&&(n._skip=n._currentRangeStart=n.skip(),e.skip=n.skip()),n._take===t&&n._pageSize!==t&&(n._take=n._pageSize,e.take=n._take),e.sort&&(n._sort=e.sort=s(e.sort)),e.filter&&(n._filter=e.filter=l(e.filter)),e.group&&(n._group=e.group=p(e.group)),e.aggregate&&(n._aggregate=e.aggregate=f(e.aggregate))),e},query:function(n){var i,o,r,s=this.options.serverSorting||this.options.serverPaging||this.options.serverFiltering||this.options.serverGrouping||this.options.serverAggregates;return s||(this._data===t||0===this._data.length)&&!this._destroyed.length?(this.options.endless&&(o=n.pageSize-this.pageSize(),o>0?(o=this.pageSize(),n.page=n.pageSize/o,n.pageSize=o):(n.page=1,this.options.endless=!1)),this.read(this._mergeState(n))):(r=this.trigger(Re,{type:"read"}),r||(this.trigger(Fe),i=this._queryProcess(this._data,this._mergeState(n)),this.options.serverFiltering||(this._total=i.total!==t?i.total:this._data.length),this._aggregateResult=this._calculateAggregates(this._data,n),this.view(i.data),this.trigger(ze,{type:"read"}),this.trigger(Ae,{items:i.data})),e.Deferred().resolve(r).promise())},fetch:function(e){var t=this,n=function(n){n!==!0&&be(e)&&e.call(t)};return this._query().then(n)},_query:function(e){var t=this;return t.query(ce({},{page:t.page(),pageSize:t.pageSize(),sort:t.sort(),filter:t.filter(),group:t.group(),aggregate:t.aggregate()},e))},next:function(e){var t=this,n=t.page(),i=t.total();if(e=e||{},n&&!(i&&n+1>t.totalPages()))return t._skip=t._currentRangeStart=n*t.take(),n+=1,e.page=n,t._query(e),n},prev:function(e){var t=this,n=t.page();if(e=e||{},n&&1!==n)return t._skip=t._currentRangeStart=t._skip-t.take(),n-=1,e.page=n,t._query(e),n},page:function(e){var n,i=this;return e!==t?(e=Ne.max(Ne.min(Ne.max(e,1),i.totalPages()),1),i._query({page:e}),t):(n=i.skip(),n!==t?Ne.round((n||0)/(i.take()||1))+1:t)},pageSize:function(e){var n=this;return e!==t?(n._query({pageSize:e,page:1}),t):n.take()},sort:function(e){var n=this;return e!==t?(n._query({sort:e}),t):n._sort},filter:function(e){var n=this;return e===t?n._filter:(n.trigger("reset"),n._query({filter:e,page:1}),t)},group:function(e){var n=this;return e!==t?(n._query({group:e}),t):n._group},total:function(){return parseInt(this._total||0,10)},aggregate:function(e){var n=this;return e!==t?(n._query({aggregate:e}),t):n._aggregate},aggregates:function(){var e=this._aggregateResult;return he(e)&&(e=this._emptyAggregates(this.aggregate())),e},_emptyAggregates:function(e){var t,n,i={};if(!he(e))for(t={},fe(e)||(e=[e]),n=0;n<e.length;n++)t[e[n].aggregate]=0,i[e[n].field]=t;return i},_wrapInEmptyGroup:function(e){var t,n,i,o,r=this.group();for(i=r.length-1,o=0;i>=o;i--)n=r[i],t={value:e.get(n.field),field:n.field,items:t?[t]:[e],hasSubgroups:!!t,aggregates:this._emptyAggregates(n.aggregates)};return t},totalPages:function(){var e=this,t=e.pageSize()||e.total();return Ne.ceil((e.total()||0)/t)},inRange:function(e,t){var n=this,i=Ne.min(e+t,n.total());return!n.options.serverPaging&&n._data.length>0||n._findRange(e,i).length>0},lastRange:function(){var e=this._ranges;return e[e.length-1]||{start:0,end:0,data:[]}},firstItemUid:function(){var e=this._ranges;return e.length&&e[0].data.length&&e[0].data[0].uid},enableRequestsInProgress:function(){this._skipRequestsInProgress=!1},_timeStamp:function(){return(new Date).getTime()},range:function(e,n,i){this._currentRequestTimeStamp=this._timeStamp(),this._skipRequestsInProgress=!0,e=Ne.min(e||0,this.total()),i=be(i)?i:ve;var o,r=this,s=Ne.max(Ne.floor(e/n),0)*n,a=Ne.min(s+n,r.total());return o=r._findRange(e,Ne.min(e+n,r.total())),o.length||0===r.total()?(r._processRangeData(o,e,n,s,a),i(),t):(n!==t&&(r._rangeExists(s,a)?s<e&&r.prefetch(a,n,function(){r.range(e,n,i)}):r.prefetch(s,n,function(){e>s&&a<r.total()&&!r._rangeExists(a,Ne.min(a+n,r.total()))?r.prefetch(a,n,function(){r.range(e,n,i)}):r.range(e,n,i)})),t)},_findRange:function(e,n){var i,o,r,a,l,c,d,u,h,f,m,g,v=this,_=v._ranges,b=[],w=v.options,y=w.serverSorting||w.serverPaging||w.serverFiltering||w.serverGrouping||w.serverAggregates;for(o=0,m=_.length;o<m;o++)if(i=_[o],e>=i.start&&e<=i.end){for(f=0,r=o;r<m;r++)if(i=_[r],h=v._flatData(i.data,!0),h.length&&e+f>=i.start&&(c=i.data,d=i.end,y||(w.inPlaceSort?u=v._queryProcess(i.data,{filter:v.filter()}):(g=p(v.group()||[]).concat(s(v.sort()||[])),u=v._queryProcess(i.data,{sort:g,filter:v.filter()})),h=c=u.data,u.total!==t&&(d=u.total)),a=0,e+f>i.start&&(a=e+f-i.start),l=h.length,d>n&&(l-=d-n),f+=l-a,b=v._mergeGroups(b,c,a,l),n<=i.end&&f==n-e))return b;break}return[]},_mergeGroups:function(e,t,n,i){if(this._isServerGrouped()){var o,r=t.toJSON();return e.length&&(o=e[e.length-1]),C(o,r,n,i),e.concat(r)}return e.concat(t.slice(n,i))},_processRangeData:function(e,n,i,o,r){var s,a,l,c,d=this;d._pending=t,d._skip=n>d.skip()?Ne.min(r,(d.totalPages()-1)*d.take()):o,d._currentRangeStart=n,d._take=i,s=d.options.serverPaging,a=d.options.serverSorting,l=d.options.serverFiltering,c=d.options.serverAggregates;try{d.options.serverPaging=!0,d._isServerGrouped()||d.group()&&d.group().length||(d.options.serverSorting=!0),d.options.serverFiltering=!0,d.options.serverPaging=!0,d.options.serverAggregates=!0,s&&(d._detachObservableParents(),d._data=e=d._observe(e)),d._process(e)}finally{d.options.serverPaging=s,d.options.serverSorting=a,d.options.serverFiltering=l,d.options.serverAggregates=c}},skip:function(){var e=this;return e._skip===t?e._page!==t?(e._page-1)*(e.take()||1):t:e._skip},currentRangeStart:function(){return this._currentRangeStart||0},take:function(){return this._take||this._pageSize},_prefetchSuccessHandler:function(e,t,n,i){var o=this,r=o._timeStamp();return function(s){var a,l,c,d=!1,u={start:e,end:t,data:[],timestamp:o._timeStamp()};if(o._dequeueRequest(),o.trigger(ze,{response:s,type:"read"}),s=o.reader.parse(s),c=o._readData(s),c.length){for(a=0,l=o._ranges.length;a<l;a++)if(o._ranges[a].start===e){d=!0,u=o._ranges[a];break}d||o._ranges.push(u)}u.data=o._observe(c),u.end=u.start+o._flatData(u.data,!0).length,o._ranges.sort(function(e,t){return e.start-t.start}),o._total=o.reader.total(s),(i||r>=o._currentRequestTimeStamp||!o._skipRequestsInProgress)&&(n&&c.length?n():o.trigger(Ae,{}))}},prefetch:function(e,t,n){var i=this,o=Ne.min(e+t,i.total()),r={take:t,skip:e,page:e/t+1,pageSize:t,sort:i._sort,filter:i._filter,group:i._group,aggregate:i._aggregate};i._rangeExists(e,o)?n&&n():(clearTimeout(i._timeout),i._timeout=setTimeout(function(){i._queueRequest(r,function(){i.trigger(Re,{type:"read"})?i._dequeueRequest():i.transport.read({data:i._params(r),success:i._prefetchSuccessHandler(e,o,n),error:function(){var e=qe.call(arguments);i.error.apply(i,e)}})})},100))},_multiplePrefetch:function(e,t,n){var i=this,o=Ne.min(e+t,i.total()),r={take:t,skip:e,page:e/t+1,pageSize:t,sort:i._sort,filter:i._filter,group:i._group,aggregate:i._aggregate};i._rangeExists(e,o)?n&&n():i.trigger(Re,{type:"read"})||i.transport.read({data:i._params(r),success:i._prefetchSuccessHandler(e,o,n,!0)})},_rangeExists:function(e,t){var n,i,o=this,r=o._ranges;for(n=0,i=r.length;n<i;n++)if(r[n].start<=e&&r[n].end>=t)return!0;return!1},_removeModelFromRanges:function(e){var t,n,i,o,r=this;for(i=0,o=this._ranges.length;i<o&&(n=this._ranges[i],this._eachItem(n.data,function(n){t=M(n,e)}),!t);i++);r._updateRangesLength()},_insertModelInRange:function(e,t){var n,i,o=this,r=o._ranges||[],s=r.length;for(i=0;i<s;i++)if(n=r[i],n.start<=e&&n.end>=e){o._getByUid(t.uid,n.data)||(o._isServerGrouped()?n.data.splice(e,0,o._wrapInEmptyGroup(t)):n.data.splice(e,0,t));break}o._updateRangesLength()},_updateRangesLength:function(){var e,t,n=this,i=n._ranges||[],o=i.length,r=!1,s=0,a=0;for(t=0;t<o;t++)e=i[t],a=n._flatData(e.data,!0).length-Ne.abs(e.end-e.start),r||0===a?r&&(e.start+=s,e.end+=s):(r=!0,s=a,e.end+=s)}}),oe={},oe.create=function(t,n,i){var o,r=t.transport?e.extend({},t.transport):null;return r?(r.read=typeof r.read===ke?{url:r.read}:r.read,"jsdo"===t.type&&(r.dataSource=i),t.type&&(_e.data.transports=_e.data.transports||{},_e.data.schemas=_e.data.schemas||{},_e.data.transports[t.type]?ue(_e.data.transports[t.type])?r=ce(!0,{},_e.data.transports[t.type],r):o=new _e.data.transports[t.type](ce(r,{data:n})):_e.logToConsole("Unknown DataSource transport type '"+t.type+"'.\nVerify that registration scripts for this type are included after Kendo UI on the page.","warn"),t.schema=ce(!0,{},_e.data.schemas[t.type],t.schema)),o||(o=be(r.read)?r:new ee(r))):o=new J({data:t.data||[]}),o},ie.create=function(e){(fe(e)||e instanceof Qe)&&(e={data:e});var n,i,o,r=e||{},s=r.data,a=r.fields,l=r.table,c=r.select,d={};if(s||!a||r.transport||(l?s=N(l,a):c&&(s=H(c,a),r.group===t&&s[0]&&s[0].optgroup!==t&&(r.group="optgroup"))),_e.data.Model&&a&&(!r.schema||!r.schema.model)){for(n=0,i=a.length;n<i;n++)o=a[n],o.type&&(d[o.field]=o);he(d)||(r.schema=ce(!0,r.schema,{model:{fields:d}}))}return r.data=s,c=null,r.select=null,l=null,r.table=null,r instanceof ie?r:new ie(r)},re=$.define({idField:"id",init:function(e){var t,n=this,i=n.hasChildren||e&&e.hasChildren,o="items",r={};_e.data.Model.fn.init.call(n,e),typeof n.children===ke&&(o=n.children),r={schema:{data:o,model:{hasChildren:i,id:n.idField,fields:n.fields}}},typeof n.children!==ke&&ce(r,n.children),r.data=e,i||(i=r.schema.data),typeof i===ke&&(i=_e.getter(i)),be(i)&&(t=i.call(n,n),n.hasChildren=(!t||0!==t.length)&&!!t),n._childrenOptions=r,n.hasChildren&&n._initChildren(),n._loaded=!(!e||!e._loaded)},_initChildren:function(){var e,t,n,i=this;i.children instanceof se||(e=i.children=new se(i._childrenOptions),t=e.transport,n=t.parameterMap,t.parameterMap=function(e,t){return e[i.idField||"id"]=i.id,n&&(e=n(e,t)),e},e.parent=function(){return i},e.bind(Ae,function(e){e.node=e.node||i,i.trigger(Ae,e)}),e.bind(Me,function(e){var t=i.parent();t&&(e.node=e.node||i,t.trigger(Me,e))}),i._updateChildrenField())},append:function(e){this._initChildren(),this.loaded(!0),this.children.add(e)},hasChildren:!1,level:function(){for(var e=this.parentNode(),t=0;e&&e.parentNode;)t++,e=e.parentNode?e.parentNode():null;return t},_updateChildrenField:function(){var e=this._childrenOptions.schema.data;this[e||"items"]=this.children.data()},_childrenLoaded:function(){this._loaded=!0,this._updateChildrenField()},load:function(){var n,i,o={},r="_query";return this.hasChildren?(this._initChildren(),n=this.children,o[this.idField||"id"]=this.id,this._loaded||(n._data=t,r="read"),n.one(Ae,de(this._childrenLoaded,this)),this._matchFilter&&(o.filter={field:"_matchFilter",operator:"eq",value:!0}),i=n[r](o)):this.loaded(!0),i||e.Deferred().resolve().promise()},parentNode:function(){var e=this.parent();return e.parent()},loaded:function(e){return e===t?this._loaded:(this._loaded=e,t)},shouldSerialize:function(e){return $.fn.shouldSerialize.call(this,e)&&"children"!==e&&"_loaded"!==e&&"hasChildren"!==e&&"_childrenOptions"!==e}}),se=ie.extend({init:function(e){var t=re.define({children:e});e.filter&&!e.serverFiltering&&(this._hierarchicalFilter=e.filter,e.filter=null),ie.fn.init.call(this,ce(!0,{},{schema:{modelBase:t,model:t}},e)),this._attachBubbleHandlers()},_attachBubbleHandlers:function(){var e=this;e._data.bind(Me,function(t){e.trigger(Me,t)})},read:function(e){var t=ie.fn.read.call(this,e);return this._hierarchicalFilter&&(this._data&&this._data.length>0?this.filter(this._hierarchicalFilter):(this.options.filter=this._hierarchicalFilter,this._filter=l(this.options.filter),this._hierarchicalFilter=null)),t},remove:function(e){var t,n=e.parentNode(),i=this;return n&&n._initChildren&&(i=n.children),t=ie.fn.remove.call(i,e),n&&!i.data().length&&(n.hasChildren=!1),t},success:O("success"),data:O("data"),insert:function(e,t){var n=this.parent();return n&&n._initChildren&&(n.hasChildren=!0,n._initChildren()),ie.fn.insert.call(this,e,t)},filter:function(e){return e===t?this._filter:(!this.options.serverFiltering&&this._markHierarchicalQuery(e)&&(e={logic:"or",filters:[e,{field:"_matchFilter",operator:"equals",value:!0}]}),this.trigger("reset"),this._query({filter:e,page:1}),t)},_markHierarchicalQuery:function(e){var t,n,i,o,s;return e=l(e),e&&0!==e.filters.length?(t=r.filterExpr(e),i=t.fields,o=t.operators,n=s=Function("d, __f, __o","return "+t.expression),(i.length||o.length)&&(s=function(e){return n(e,i,o)}),this._updateHierarchicalFilter(s),!0):(this._updateHierarchicalFilter(function(){return!0}),!1)},_updateHierarchicalFilter:function(e){var t,n,i=this._data,o=!1;for(n=0;n<i.length;n++)t=i[n],t.hasChildren?(t._matchFilter=t.children._updateHierarchicalFilter(e),t._matchFilter||(t._matchFilter=e(t))):t._matchFilter=e(t),t._matchFilter&&(o=!0);return o},_find:function(e,t){var n,i,o,r,s=this._data;if(s){if(o=ie.fn[e].call(this,t))return o;for(s=this._flatData(this._data),n=0,i=s.length;n<i;n++)if(r=s[n].children,r instanceof se&&(o=r[e](t)))return o}},get:function(e){return this._find("get",e)},getByUid:function(e){return this._find("getByUid",e)}}),se.create=function(e){e=e&&e.push?{data:e}:e;var t=e||{},n=t.data,i=t.fields,o=t.list;return n&&n._dataSource?n._dataSource:(n||!i||t.transport||o&&(n=V(o,i)),t.data=n,t instanceof se?t:new se(t))},ae=_e.Observable.extend({init:function(e,t,n){_e.Observable.fn.init.call(this),this._prefetching=!1,this.dataSource=e,this.prefetch=!n;var i=this;e.bind("change",function(){i._change()}),e.bind("reset",function(){i._reset()}),this._syncWithDataSource(),this.setViewSize(t)},setViewSize:function(e){this.viewSize=e,this._recalculate()},at:function(e){var n=this.pageSize,i=!0;return e>=this.total()?(this.trigger("endreached",{index:e}),null):this.useRanges?this.useRanges?((e<this.dataOffset||e>=this.skip+n)&&(i=this.range(Math.floor(e/n)*n)),e===this.prefetchThreshold&&this._prefetch(),e===this.midPageThreshold?this.range(this.nextMidRange,!0):e===this.nextPageThreshold?this.range(this.nextFullRange):e===this.pullBackThreshold&&this.range(this.offset===this.skip?this.previousMidRange:this.previousFullRange),i?this.dataSource.at(e-this.dataOffset):(this.trigger("endreached",{index:e}),null)):t:this.dataSource.view()[e]},indexOf:function(e){return this.dataSource.data().indexOf(e)+this.dataOffset},total:function(){return parseInt(this.dataSource.total(),10)},next:function(){var e=this,t=e.pageSize,n=e.skip-e.viewSize+t,i=Ne.max(Ne.floor(n/t),0)*t;this.offset=n,this.dataSource.prefetch(i,t,function(){e._goToRange(n,!0)})},range:function(e,t){if(this.offset===e)return!0;var n=this,i=this.pageSize,o=Ne.max(Ne.floor(e/i),0)*i,r=this.dataSource;return t&&(o+=i),r.inRange(e,i)?(this.offset=e,this._recalculate(),this._goToRange(e),!0):!this.prefetch||(r.prefetch(o,i,function(){n.offset=e,n._recalculate(),n._goToRange(e,!0)}),!1)},syncDataSource:function(){var e=this.offset;this.offset=null,this.range(e)},destroy:function(){this.unbind()},_prefetch:function(){var e=this,t=this.pageSize,n=this.skip+t,i=this.dataSource;i.inRange(n,t)||this._prefetching||!this.prefetch||(this._prefetching=!0,this.trigger("prefetching",{skip:n,take:t}),i.prefetch(n,t,function(){e._prefetching=!1,e.trigger("prefetched",{skip:n,take:t})}))},_goToRange:function(e,t){this.offset===e&&(this.dataOffset=e,this._expanding=t,this.dataSource.range(e,this.pageSize),this.dataSource.enableRequestsInProgress())},_reset:function(){this._syncPending=!0},_change:function(){var e=this.dataSource;this.length=this.useRanges?e.lastRange().end:e.view().length,this._syncPending&&(this._syncWithDataSource(),this._recalculate(),this._syncPending=!1,this.trigger("reset",{offset:this.offset})),this.trigger("resize"),this._expanding&&this.trigger("expand"),delete this._expanding},_syncWithDataSource:function(){var e=this.dataSource;this._firstItemUid=e.firstItemUid(),this.dataOffset=this.offset=e.skip()||0,this.pageSize=e.pageSize(),this.useRanges=e.options.serverPaging},_recalculate:function(){var e=this.pageSize,t=this.offset,n=this.viewSize,i=Math.ceil(t/e)*e;this.skip=i,this.midPageThreshold=i+e-1,this.nextPageThreshold=i+n-1,this.prefetchThreshold=i+Math.floor(e/3*2),this.pullBackThreshold=this.offset-1,this.nextMidRange=i+e-n,this.nextFullRange=i,this.previousMidRange=t-n,this.previousFullRange=i-e}}),le=_e.Observable.extend({init:function(e,t){var n=this;_e.Observable.fn.init.call(n),this.dataSource=e,this.batchSize=t,this._total=0,this.buffer=new ae(e,3*t),this.buffer.bind({endreached:function(e){n.trigger("endreached",{index:e.index})},prefetching:function(e){n.trigger("prefetching",{skip:e.skip,take:e.take})},prefetched:function(e){n.trigger("prefetched",{skip:e.skip,take:e.take})},reset:function(){n._total=0,n.trigger("reset")},resize:function(){n._total=Math.ceil(this.length/n.batchSize),n.trigger("resize",{total:n.total(),offset:this.offset})}})},syncDataSource:function(){this.buffer.syncDataSource()},at:function(e){var t,n,i=this.buffer,o=e*this.batchSize,r=this.batchSize,s=[];for(i.offset>o&&i.at(i.offset-1),n=0;n<r&&(t=i.at(o+n),null!==t);n++)s.push(t);return s},total:function(){return this._total},destroy:function(){this.buffer.destroy(),this.unbind()}}),ce(!0,_e.data,{readers:{json:ne},Query:r,DataSource:ie,HierarchicalDataSource:se,Node:re,ObservableObject:j,ObservableArray:Qe,LazyObservableArray:W,LocalTransport:J,RemoteTransport:ee,Cache:te,DataReader:ne,Model:$,Buffer:ae,BatchBuffer:le})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.binder.min",["kendo.core.min","kendo.data.min"],e)}(function(){return function(e,t){function n(t,n,i){return v.extend({init:function(e,t,n){var i=this;v.fn.init.call(i,e.element[0],t,n),i.widget=e,i._dataBinding=M(i.dataBinding,i),i._dataBound=M(i.dataBound,i),i._itemChange=M(i.itemChange,i)},itemChange:function(e){s(e.item[0],e.data,this._ns(e.ns),[e.data].concat(this.bindings[t]._parents()))},dataBinding:function(e){var t,n,i=this.widget,o=e.removedItems||i.items();for(t=0,n=o.length;t<n;t++)c(o[t],!1)},_ns:function(t){t=t||C.ui;var n=[C.ui,C.dataviz.ui,C.mobile.ui];return n.splice(e.inArray(t,n),1),n.unshift(t),C.rolesFromNamespaces(n)},dataBound:function(e){var i,o,r,a,l=this.widget,c=e.addedItems||l.items(),d=l[n],u=C.data.HierarchicalDataSource;if(!(u&&d instanceof u)&&c.length)for(r=e.addedDataItems||d.flatView(),a=this.bindings[t]._parents(),i=0,o=r.length;i<o;i++)c[i]&&s(c[i],r[i],this._ns(e.ns),[r[i]].concat(a))},refresh:function(e){var o,r,s,a=this,l=a.widget;e=e||{},e.action||(a.destroy(),l.bind("dataBinding",a._dataBinding),l.bind("dataBound",a._dataBound),l.bind("itemChange",a._itemChange),o=a.bindings[t].get(),l[n]instanceof C.data.DataSource&&l[n]!=o&&(o instanceof C.data.DataSource?l[i](o):o&&o._dataSource?l[i](o._dataSource):(l[n].data(o),r=C.ui.Select&&l instanceof C.ui.Select,s=C.ui.MultiSelect&&l instanceof C.ui.MultiSelect,a.bindings.value&&(r||s)&&l.value(f(a.bindings.value.get(),l.options.dataValueField)))))},destroy:function(){var e=this.widget;e.unbind("dataBinding",this._dataBinding),e.unbind("dataBound",this._dataBound),e.unbind("itemChange",this._itemChange)}})}function i(e,t){var n=C.initWidget(e,{},t);if(n)return new y(n)}function o(e){var t,n,i,r,s,a,l,c={};for(l=e.match(k),t=0,n=l.length;t<n;t++)i=l[t],r=i.indexOf(":"),s=i.substring(0,r),a=i.substring(r+1),"{"==a.charAt(0)&&(a=o(a)),c[s]=a;return c}function r(e,t,n){var i,o={};for(i in e)o[i]=new n(t,e[i]);return o}function s(e,t,n,a){var c,d,u,h,f=e.getAttribute("data-"+C.ns+"role"),v=e.getAttribute("data-"+C.ns+"bind"),_=[],b=!0,y={};if(a=a||[t],(f||v)&&l(e,!1),f&&(u=i(e,n)),v&&(v=o(v.replace(x,"")),u||(y=C.parseOptions(e,{textField:"",valueField:"",template:"",valueUpdate:N,valuePrimitive:!1,autoBind:!0}),y.roles=n,u=new w(e,y)),u.source=t,d=r(v,a,p),y.template&&(d.template=new g(a,"",y.template)),d.click&&(v.events=v.events||{},v.events.click=v.click,d.click.destroy(),delete d.click),d.source&&(b=!1),v.attr&&(d.attr=r(v.attr,a,p)),v.style&&(d.style=r(v.style,a,p)),v.events&&(d.events=r(v.events,a,m)),v.css&&(d.css=r(v.css,a,p)),u.bind(d)),u&&(e.kendoBindingTarget=u),h=e.children,b&&h){for(c=0;c<h.length;c++)_[c]=h[c];for(c=0;c<_.length;c++)s(_[c],t,n,a)}}function a(t,n){var i,o,r,a=C.rolesFromNamespaces([].slice.call(arguments,2));for(n=C.observable(n),t=e(t),i=0,o=t.length;i<o;i++)r=t[i],1===r.nodeType&&s(r,n,a)}function l(t,n){var i,o=t.kendoBindingTarget;o&&(o.destroy(),L?delete t.kendoBindingTarget:t.removeAttribute?t.removeAttribute("kendoBindingTarget"):t.kendoBindingTarget=null),n&&(i=C.widgetInstance(e(t)),i&&typeof i.destroy===H&&i.destroy())}function c(e,t){l(e,t),d(e,t)}function d(e,t){var n,i,o=e.children;if(o)for(n=0,i=o.length;n<i;n++)c(o[n],t)}function u(t){var n,i;for(t=e(t),n=0,i=t.length;n<i;n++)c(t[n],!1)}function h(e,t){var n=e.element,i=n[0].kendoBindingTarget;i&&a(n,i.source,t)}function f(e,t){var n,i,o=[],r=0;if(!t)return e;if(e instanceof D){for(n=e.length;r<n;r++)i=e[r],o[r]=i.get?i.get(t):i[t];e=o}else e instanceof T&&(e=e.get(t));return e}var p,m,g,v,_,b,w,y,k,x,C=window.kendo,S=C.Observable,T=C.data.ObservableObject,D=C.data.ObservableArray,A={}.toString,E={},I=C.Class,M=e.proxy,R="value",F="source",z="events",P="checked",B="css",L=!0,H="function",N="change";!function(){var e=document.createElement("a");try{delete e.test}catch(t){L=!1}}(),p=S.extend({init:function(e,t){var n=this;S.fn.init.call(n),n.source=e[0],n.parents=e,n.path=t,n.dependencies={},n.dependencies[t]=!0,n.observable=n.source instanceof S,n._access=function(e){n.dependencies[e.field]=!0},n.observable&&(n._change=function(e){n.change(e)},n.source.bind(N,n._change))},_parents:function(){var t,n=this.parents,i=this.get();return i&&"function"==typeof i.parent&&(t=i.parent(),e.inArray(t,n)<0&&(n=[t].concat(n))),n},change:function(e){var t,n,i=e.field,o=this;if("this"===o.path)o.trigger(N,e);else for(t in o.dependencies)if(0===t.indexOf(i)&&(n=t.charAt(i.length),!n||"."===n||"["===n)){o.trigger(N,e);break}},start:function(e){e.bind("get",this._access)},stop:function(e){e.unbind("get",this._access)},get:function(){var e=this,n=e.source,i=0,o=e.path,r=n;if(!e.observable)return r;for(e.start(e.source),r=n.get(o);r===t&&n;)n=e.parents[++i],n instanceof T&&(r=n.get(o));if(r===t)for(n=e.source;r===t&&n;)n=n.parent(),n instanceof T&&(r=n.get(o));return"function"==typeof r&&(i=o.lastIndexOf("."),i>0&&(n=n.get(o.substring(0,i))),e.start(n),r=n!==e.source?r.call(n,e.source):r.call(n),e.stop(n)),n&&n!==e.source&&(e.currentSource=n,n.unbind(N,e._change).bind(N,e._change)),e.stop(e.source),r},set:function(e){var t=this.currentSource||this.source,n=C.getter(this.path)(t);"function"==typeof n?t!==this.source?n.call(t,this.source,e):n.call(t,e):t.set(this.path,e)},destroy:function(){this.observable&&(this.source.unbind(N,this._change),this.currentSource&&this.currentSource.unbind(N,this._change)),this.unbind()}}),m=p.extend({get:function(){var e,t=this.source,n=this.path,i=0;for(e=t.get(n);!e&&t;)t=this.parents[++i],t instanceof T&&(e=t.get(n));return M(e,t)}}),g=p.extend({init:function(e,t,n){var i=this;p.fn.init.call(i,e,t),i.template=n},render:function(e){var t;return this.start(this.source),t=C.render(this.template,e),this.stop(this.source),t}}),v=I.extend({init:function(e,t,n){this.element=e,this.bindings=t,this.options=n},bind:function(e,t){var n=this;e=t?e[t]:e,e.bind(N,function(e){n.refresh(t||e)}),n.refresh(t)},destroy:function(){}}),_=v.extend({dataType:function(){var e=this.element.getAttribute("data-type")||this.element.type||"text";return e.toLowerCase()},parsedValue:function(){return this._parseValue(this.element.value,this.dataType());
},_parseValue:function(e,t){return"date"==t?e=C.parseDate(e,"yyyy-MM-dd"):"datetime-local"==t?e=C.parseDate(e,["yyyy-MM-ddTHH:mm:ss","yyyy-MM-ddTHH:mm"]):"number"==t?e=C.parseFloat(e):"boolean"==t&&(e=e.toLowerCase(),e=null!==C.parseFloat(e)?!!C.parseFloat(e):"true"===e.toLowerCase()),e}}),E.attr=v.extend({refresh:function(e){this.element.setAttribute(e,this.bindings.attr[e].get())}}),E.css=v.extend({init:function(e,t,n){v.fn.init.call(this,e,t,n),this.classes={}},refresh:function(t){var n=e(this.element),i=this.bindings.css[t],o=this.classes[t]=i.get();o?n.addClass(t):n.removeClass(t)}}),E.style=v.extend({refresh:function(e){this.element.style[e]=this.bindings.style[e].get()||""}}),E.enabled=v.extend({refresh:function(){this.bindings.enabled.get()?this.element.removeAttribute("disabled"):this.element.setAttribute("disabled","disabled")}}),E.readonly=v.extend({refresh:function(){this.bindings.readonly.get()?this.element.setAttribute("readonly","readonly"):this.element.removeAttribute("readonly")}}),E.disabled=v.extend({refresh:function(){this.bindings.disabled.get()?this.element.setAttribute("disabled","disabled"):this.element.removeAttribute("disabled")}}),E.events=v.extend({init:function(e,t,n){v.fn.init.call(this,e,t,n),this.handlers={}},refresh:function(t){var n=e(this.element),i=this.bindings.events[t],o=this.handlers[t];o&&n.off(t,o),o=this.handlers[t]=i.get(),n.on(t,i.source,o)},destroy:function(){var t,n=e(this.element);for(t in this.handlers)n.off(t,this.handlers[t])}}),E.text=v.extend({refresh:function(){var t=this.bindings.text.get(),n=this.element.getAttribute("data-format")||"";null==t&&(t=""),e(this.element).text(C.toString(t,n))}}),E.visible=v.extend({refresh:function(){this.element.style.display=this.bindings.visible.get()?"":"none"}}),E.invisible=v.extend({refresh:function(){this.element.style.display=this.bindings.invisible.get()?"none":""}}),E.html=v.extend({refresh:function(){this.element.innerHTML=this.bindings.html.get()}}),E.value=_.extend({init:function(t,n,i){_.fn.init.call(this,t,n,i),this._change=M(this.change,this),this.eventName=i.valueUpdate||N,e(this.element).on(this.eventName,this._change),this._initChange=!1},change:function(){this._initChange=this.eventName!=N,this.bindings[R].set(this.parsedValue()),this._initChange=!1},refresh:function(){var e,t;this._initChange||(e=this.bindings[R].get(),null==e&&(e=""),t=this.dataType(),"date"==t?e=C.toString(e,"yyyy-MM-dd"):"datetime-local"==t&&(e=C.toString(e,"yyyy-MM-ddTHH:mm:ss")),this.element.value=e),this._initChange=!1},destroy:function(){e(this.element).off(this.eventName,this._change)}}),E.source=v.extend({init:function(e,t,n){v.fn.init.call(this,e,t,n);var i=this.bindings.source.get();i instanceof C.data.DataSource&&n.autoBind!==!1&&i.fetch()},refresh:function(e){var t=this,n=t.bindings.source.get();n instanceof D||n instanceof C.data.DataSource?(e=e||{},"add"==e.action?t.add(e.index,e.items):"remove"==e.action?t.remove(e.index,e.items):"itemchange"!=e.action&&t.render()):t.render()},container:function(){var e=this.element;return"table"==e.nodeName.toLowerCase()&&(e.tBodies[0]||e.appendChild(document.createElement("tbody")),e=e.tBodies[0]),e},template:function(){var e=this.options,t=e.template,n=this.container().nodeName.toLowerCase();return t||(t="select"==n?e.valueField||e.textField?C.format('<option value="#:{0}#">#:{1}#</option>',e.valueField||e.textField,e.textField||e.valueField):"<option>#:data#</option>":"tbody"==n?"<tr><td>#:data#</td></tr>":"ul"==n||"ol"==n?"<li>#:data#</li>":"#:data#",t=C.template(t)),t},add:function(t,n){var i,o,r,a,l=this.container(),c=l.cloneNode(!1),d=l.children[t];if(e(c).html(C.render(this.template(),n)),c.children.length)for(i=this.bindings.source._parents(),o=0,r=n.length;o<r;o++)a=c.children[0],l.insertBefore(a,d||null),s(a,n[o],this.options.roles,[n[o]].concat(i))},remove:function(e,t){var n,i,o=this.container();for(n=0;n<t.length;n++)i=o.children[e],c(i,!0),i.parentNode==o&&o.removeChild(i)},render:function(){var t,n,i,o=this.bindings.source.get(),r=this.container(),a=this.template();if(null!=o)if(o instanceof C.data.DataSource&&(o=o.view()),o instanceof D||"[object Array]"===A.call(o)||(o=[o]),this.bindings.template){if(d(r,!0),e(r).html(this.bindings.template.render(o)),r.children.length)for(t=this.bindings.source._parents(),n=0,i=o.length;n<i;n++)s(r.children[n],o[n],this.options.roles,[o[n]].concat(t))}else e(r).html(C.render(a,o))}}),E.input={checked:_.extend({init:function(t,n,i){_.fn.init.call(this,t,n,i),this._change=M(this.change,this),e(this.element).change(this._change)},change:function(){var e,t,n,i=this.element,o=this.value();if("radio"==i.type)o=this.parsedValue(),this.bindings[P].set(o);else if("checkbox"==i.type)if(e=this.bindings[P].get(),e instanceof D){if(o=this.parsedValue(),o instanceof Date){for(n=0;n<e.length;n++)if(e[n]instanceof Date&&+e[n]===+o){t=n;break}}else t=e.indexOf(o);t>-1?e.splice(t,1):e.push(o)}else this.bindings[P].set(o)},refresh:function(){var e,t,n=this.bindings[P].get(),i=n,o=this.dataType(),r=this.element;if("checkbox"==r.type)if(i instanceof D){if(e=-1,n=this.parsedValue(),n instanceof Date){for(t=0;t<i.length;t++)if(i[t]instanceof Date&&+i[t]===+n){e=t;break}}else e=i.indexOf(n);r.checked=e>=0}else r.checked=i;else"radio"==r.type&&null!=n&&("date"==o?n=C.toString(n,"yyyy-MM-dd"):"datetime-local"==o&&(n=C.toString(n,"yyyy-MM-ddTHH:mm:ss")),r.checked=r.value===""+n)},value:function(){var e=this.element,t=e.value;return"checkbox"==e.type&&(t=e.checked),t},destroy:function(){e(this.element).off(N,this._change)}})},E.select={source:E.source.extend({refresh:function(n){var i,o=this,r=o.bindings.source.get();r instanceof D||r instanceof C.data.DataSource?(n=n||{},"add"==n.action?o.add(n.index,n.items):"remove"==n.action?o.remove(n.index,n.items):"itemchange"!=n.action&&n.action!==t||(o.render(),o.bindings.value&&o.bindings.value&&(i=f(o.bindings.value.get(),e(o.element).data("valueField")),null===i?o.element.selectedIndex=-1:o.element.value=i))):o.render()}}),value:_.extend({init:function(t,n,i){_.fn.init.call(this,t,n,i),this._change=M(this.change,this),e(this.element).change(this._change)},parsedValue:function(){var e,t,n,i,o=this.dataType(),r=[];for(n=0,i=this.element.options.length;n<i;n++)t=this.element.options[n],t.selected&&(e=t.attributes.value,e=e&&e.specified?t.value:t.text,r.push(this._parseValue(e,o)));return r},change:function(){var e,n,i,o,r,s,a,l,c=[],d=this.element,u=this.options.valueField||this.options.textField,h=this.options.valuePrimitive;for(r=0,s=d.options.length;r<s;r++)n=d.options[r],n.selected&&(o=n.attributes.value,o=o&&o.specified?n.value:n.text,c.push(u?o:this._parseValue(o,this.dataType())));if(u)for(e=this.bindings.source.get(),e instanceof C.data.DataSource&&(e=e.view()),i=0;i<c.length;i++)for(r=0,s=e.length;r<s;r++)if(a=e[r].get(u),l=a+""===c[i]){c[i]=e[r];break}o=this.bindings[R].get(),o instanceof D?o.splice.apply(o,[0,o.length].concat(c)):this.bindings[R].set(h||!(o instanceof T||null===o||o===t)&&u?c[0].get(u):c[0])},refresh:function(){var e,t,n,i=this.element,o=i.options,r=this.bindings[R].get(),s=r,a=this.options.valueField||this.options.textField,l=!1,c=this.dataType();for(s instanceof D||(s=new D([r])),i.selectedIndex=-1,n=0;n<s.length;n++)for(r=s[n],a&&r instanceof T&&(r=r.get(a)),"date"==c?r=C.toString(s[n],"yyyy-MM-dd"):"datetime-local"==c&&(r=C.toString(s[n],"yyyy-MM-ddTHH:mm:ss")),e=0;e<o.length;e++)t=o[e].value,""===t&&""!==r&&(t=o[e].text),null!=r&&t==""+r&&(o[e].selected=!0,l=!0)},destroy:function(){e(this.element).off(N,this._change)}})},E.widget={events:v.extend({init:function(e,t,n){v.fn.init.call(this,e.element[0],t,n),this.widget=e,this.handlers={}},refresh:function(e){var t=this.bindings.events[e],n=this.handlers[e];n&&this.widget.unbind(e,n),n=t.get(),this.handlers[e]=function(e){e.data=t.source,n(e),e.data===t.source&&delete e.data},this.widget.bind(e,this.handlers[e])},destroy:function(){var e;for(e in this.handlers)this.widget.unbind(e,this.handlers[e])}}),checked:v.extend({init:function(e,t,n){v.fn.init.call(this,e.element[0],t,n),this.widget=e,this._change=M(this.change,this),this.widget.bind(N,this._change)},change:function(){this.bindings[P].set(this.value())},refresh:function(){this.widget.check(this.bindings[P].get()===!0)},value:function(){var e=this.element,t=e.value;return"on"!=t&&"off"!=t||(t=e.checked),t},destroy:function(){this.widget.unbind(N,this._change)}}),visible:v.extend({init:function(e,t,n){v.fn.init.call(this,e.element[0],t,n),this.widget=e},refresh:function(){var e=this.bindings.visible.get();this.widget.wrapper[0].style.display=e?"":"none"}}),invisible:v.extend({init:function(e,t,n){v.fn.init.call(this,e.element[0],t,n),this.widget=e},refresh:function(){var e=this.bindings.invisible.get();this.widget.wrapper[0].style.display=e?"none":""}}),enabled:v.extend({init:function(e,t,n){v.fn.init.call(this,e.element[0],t,n),this.widget=e},refresh:function(){this.widget.enable&&this.widget.enable(this.bindings.enabled.get())}}),disabled:v.extend({init:function(e,t,n){v.fn.init.call(this,e.element[0],t,n),this.widget=e},refresh:function(){this.widget.enable&&this.widget.enable(!this.bindings.disabled.get())}}),source:n("source","dataSource","setDataSource"),value:v.extend({init:function(t,n,i){v.fn.init.call(this,t.element[0],n,i),this.widget=t,this._change=e.proxy(this.change,this),this.widget.first(N,this._change);var o=this.bindings.value.get();this._valueIsObservableObject=!i.valuePrimitive&&(null==o||o instanceof T),this._valueIsObservableArray=o instanceof D,this._initChange=!1},_source:function(){var e;return this.widget.dataItem&&(e=this.widget.dataItem(),e&&e instanceof T)?[e]:(this.bindings.source&&(e=this.bindings.source.get()),(!e||e instanceof C.data.DataSource)&&(e=this.widget.dataSource.flatView()),e)},change:function(){var e,t,n,i,o,r,s,a=this.widget.value(),l=this.options.dataValueField||this.options.dataTextField,c="[object Array]"===A.call(a),d=this._valueIsObservableObject,u=[];if(this._initChange=!0,l)if(""===a&&(d||this.options.valuePrimitive))a=null;else{for(s=this._source(),c&&(t=a.length,u=a.slice(0)),o=0,r=s.length;o<r;o++)if(n=s[o],i=n.get(l),c){for(e=0;e<t;e++)if(i==u[e]){u[e]=n;break}}else if(i==a){a=d?n:i;break}u[0]&&(a=this._valueIsObservableArray?u:d||!l?u[0]:u[0].get(l))}this.bindings.value.set(a),this._initChange=!1},refresh:function(){var e,n,i,o,r,s,a,l,c;if(!this._initChange){if(e=this.widget,n=e.options,i=n.dataTextField,o=n.dataValueField||i,r=this.bindings.value.get(),s=n.text||"",a=0,c=[],r===t&&(r=null),o)if(r instanceof D){for(l=r.length;a<l;a++)c[a]=r[a].get(o);r=c}else r instanceof T&&(s=r.get(i),r=r.get(o));n.autoBind!==!1||n.cascadeFrom||!e.listView||e.listView.bound()?e.value(r):(i!==o||s||(s=r),s||!r&&0!==r||!n.valuePrimitive?e._preselect(r,s):e.value(r))}this._initChange=!1},destroy:function(){this.widget.unbind(N,this._change)}}),gantt:{dependencies:n("dependencies","dependencies","setDependenciesDataSource")},multiselect:{value:v.extend({init:function(t,n,i){v.fn.init.call(this,t.element[0],n,i),this.widget=t,this._change=e.proxy(this.change,this),this.widget.first(N,this._change),this._initChange=!1},change:function(){var e,n,i,o,r,s,a,l,c,d=this,u=d.bindings[R].get(),h=d.options.valuePrimitive,f=h?d.widget.value():d.widget.dataItems(),p=this.options.dataValueField||this.options.dataTextField;if(f=f.slice(0),d._initChange=!0,u instanceof D){for(e=[],n=f.length,i=0,o=0,r=u[i],s=!1;r!==t;){for(c=!1,o=0;o<n;o++)if(h?s=f[o]==r:(l=f[o],l=l.get?l.get(p):l,s=l==(r.get?r.get(p):r)),s){f.splice(o,1),n-=1,c=!0;break}c?i+=1:(e.push(r),b(u,i,1),a=i),r=u[i]}b(u,u.length,0,f),e.length&&u.trigger("change",{action:"remove",items:e,index:a}),f.length&&u.trigger("change",{action:"add",items:f,index:u.length-1})}else d.bindings[R].set(f);d._initChange=!1},refresh:function(){if(!this._initChange){var e,n,i=this.options,o=this.widget,r=i.dataValueField||i.dataTextField,s=this.bindings.value.get(),a=s,l=0,c=[];if(s===t&&(s=null),r)if(s instanceof D){for(e=s.length;l<e;l++)n=s[l],c[l]=n.get?n.get(r):n;s=c}else s instanceof T&&(s=s.get(r));i.autoBind!==!1||i.valuePrimitive===!0||o._isBound()?o.value(s):o._preselect(a,s)}},destroy:function(){this.widget.unbind(N,this._change)}})},scheduler:{source:n("source","dataSource","setDataSource").extend({dataBound:function(e){var t,n,i,o,r=this.widget,a=e.addedItems||r.items();if(a.length)for(i=e.addedDataItems||r.dataItems(),o=this.bindings.source._parents(),t=0,n=i.length;t<n;t++)s(a[t],i[t],this._ns(e.ns),[i[t]].concat(o))}})}},b=function(e,t,n,i){var o,r,s,a,l;if(i=i||[],n=n||0,o=i.length,r=e.length,s=[].slice.call(e,t+n),a=s.length,o){for(o=t+o,l=0;t<o;t++)e[t]=i[l],l++;e.length=o}else if(n)for(e.length=t,n+=t;t<n;)delete e[--n];if(a){for(a=t+a,l=0;t<a;t++)e[t]=s[l],l++;e.length=a}for(t=e.length;t<r;)delete e[t],t++},w=I.extend({init:function(e,t){this.target=e,this.options=t,this.toDestroy=[]},bind:function(e){var t,n,i,o,r,s,a=this instanceof y,l=this.binders();for(t in e)t==R?n=!0:t==F?i=!0:t!=z||a?t==P?r=!0:t==B?s=!0:this.applyBinding(t,e,l):o=!0;i&&this.applyBinding(F,e,l),n&&this.applyBinding(R,e,l),r&&this.applyBinding(P,e,l),o&&!a&&this.applyBinding(z,e,l),s&&!a&&this.applyBinding(B,e,l)},binders:function(){return E[this.target.nodeName.toLowerCase()]||{}},applyBinding:function(e,t,n){var i,o=n[e]||E[e],r=this.toDestroy,s=t[e];if(o)if(o=new o(this.target,t,this.options),r.push(o),s instanceof p)o.bind(s),r.push(s);else for(i in s)o.bind(s,i),r.push(s[i]);else if("template"!==e)throw Error("The "+e+" binding is not supported by the "+this.target.nodeName.toLowerCase()+" element")},destroy:function(){var e,t,n=this.toDestroy;for(e=0,t=n.length;e<t;e++)n[e].destroy()}}),y=w.extend({binders:function(){return E.widget[this.target.options.name.toLowerCase()]||{}},applyBinding:function(e,t,n){var i,o=n[e]||E.widget[e],r=this.toDestroy,s=t[e];if(!o)throw Error("The "+e+" binding is not supported by the "+this.target.options.name+" widget");if(o=new o(this.target,t,this.target.options),r.push(o),s instanceof p)o.bind(s),r.push(s);else for(i in s)o.bind(s,i),r.push(s[i])}}),k=/[A-Za-z0-9_\-]+:(\{([^}]*)\}|[^,}]+)/g,x=/\s/g,C.unbind=u,C.bind=a,C.data.binders=E,C.data.Binder=v,C.notify=h,C.observable=function(e){return e instanceof T||(e=new T(e)),e},C.observableHierarchy=function(e){function t(e){var n,i;for(n=0;n<e.length;n++)e[n]._initChildren(),i=e[n].children,i.fetch(),e[n].items=i.data(),t(e[n].items)}var n=C.data.HierarchicalDataSource.create(e);return n.fetch(),t(n.data()),n._data._dataSource=n,n._data}}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.fx.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(e){return parseInt(e,10)}function i(e,t){return n(e.css(t))}function o(e){var t,n=[];for(t in e)n.push(t);return n}function r(e){for(var t in e)U.indexOf(t)!=-1&&W.indexOf(t)==-1&&delete e[t];return e}function s(e,t){var n,i,o,r,s=[],a={};for(i in t)n=i.toLowerCase(),r=M&&U.indexOf(n)!=-1,!E.hasHW3D&&r&&W.indexOf(n)==-1?delete t[i]:(o=t[i],r?s.push(i+"("+o+")"):a[i]=o);return s.length&&(a[ae]=s.join(" ")),a}function a(e,t){var i,o,r;return M?(i=e.css(ae),i==Y?"scale"==t?1:0:(o=i.match(RegExp(t+"\\s*\\(([\\d\\w\\.]+)")),r=0,o?r=n(o[1]):(o=i.match(B)||[0,0,0,0,0],t=t.toLowerCase(),H.test(t)?r=parseFloat(o[3]/o[2]):"translatey"==t?r=parseFloat(o[4]/o[2]):"scale"==t?r=parseFloat(o[2]):"rotate"==t&&(r=parseFloat(Math.atan2(o[2],o[1])))),r)):parseFloat(e.css(t))}function l(e){return e.charAt(0).toUpperCase()+e.substring(1)}function c(e,t){var n=p.extend(t),i=n.prototype.directions;S[l(e)]=n,S.Element.prototype[e]=function(e,t,i,o){return new n(this.element,e,t,i,o)},T(i,function(t,i){S.Element.prototype[e+l(i)]=function(e,t,o){return new n(this.element,i,e,t,o)}})}function d(e,n,i,o){c(e,{directions:g,startValue:function(e){return this._startValue=e,this},endValue:function(e){return this._endValue=e,this},shouldHide:function(){return this._shouldHide},prepare:function(e,r){var s,a,l=this,c="out"===this._direction,d=l.element.data(n),u=!(isNaN(d)||d==i);s=u?d:t!==this._startValue?this._startValue:c?i:o,a=t!==this._endValue?this._endValue:c?o:i,this._reverse?(e[n]=a,r[n]=s):(e[n]=s,r[n]=a),l._shouldHide=r[n]===o}})}function u(e,t){var n=C.directions[t].vertical,i=e[n?Z:X]()/2+"px";return _[t].replace("$size",i)}var h,f,p,m,g,v,_,b,w,y,k,x,C=window.kendo,S=C.effects,T=e.each,D=e.extend,A=e.proxy,E=C.support,I=E.browser,M=E.transforms,R=E.transitions,F={scale:0,scalex:0,scaley:0,scale3d:0},z={translate:0,translatex:0,translatey:0,translate3d:0},P=t!==document.documentElement.style.zoom&&!M,B=/matrix3?d?\s*\(.*,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?/i,L=/^(-?[\d\.\-]+)?[\w\s]*,?\s*(-?[\d\.\-]+)?[\w\s]*/i,H=/translatex?$/i,N=/(zoom|fade|expand)(\w+)/,O=/(zoom|fade|expand)/,V=/[xy]$/i,U=["perspective","rotate","rotatex","rotatey","rotatez","rotate3d","scale","scalex","scaley","scalez","scale3d","skew","skewx","skewy","translate","translatex","translatey","translatez","translate3d","matrix","matrix3d"],W=["rotate","scale","scalex","scaley","skew","skewx","skewy","translate","translatex","translatey","matrix"],j={rotate:"deg",scale:"",skew:"px",translate:"px"},q=M.css,G=Math.round,$="",K="px",Y="none",Q="auto",X="width",Z="height",J="hidden",ee="origin",te="abortId",ne="overflow",ie="translate",oe="position",re="completeCallback",se=q+"transition",ae=q+"transform",le=q+"backface-visibility",ce=q+"perspective",de="1500px",ue="perspective("+de+")",he={left:{reverse:"right",property:"left",transition:"translatex",vertical:!1,modifier:-1},right:{reverse:"left",property:"left",transition:"translatex",vertical:!1,modifier:1},down:{reverse:"up",property:"top",transition:"translatey",vertical:!0,modifier:1},up:{reverse:"down",property:"top",transition:"translatey",vertical:!0,modifier:-1},top:{reverse:"bottom"},bottom:{reverse:"top"},"in":{reverse:"out",modifier:-1},out:{reverse:"in",modifier:1},vertical:{reverse:"vertical"},horizontal:{reverse:"horizontal"}};C.directions=he,D(e.fn,{kendoStop:function(e,t){return R?S.stopQueue(this,e||!1,t||!1):this.stop(e,t)}}),M&&!R&&(T(W,function(n,i){e.fn[i]=function(n){if(t===n)return a(this,i);var o=e(this)[0],r=i+"("+n+j[i.replace(V,"")]+")";return o.style.cssText.indexOf(ae)==-1?e(this).css(ae,r):o.style.cssText=o.style.cssText.replace(RegExp(i+"\\(.*?\\)","i"),r),this},e.fx.step[i]=function(t){e(t.elem)[i](t.now)}}),h=e.fx.prototype.cur,e.fx.prototype.cur=function(){return W.indexOf(this.prop)!=-1?parseFloat(e(this.elem)[this.prop]()):h.apply(this,arguments)}),C.toggleClass=function(e,t,n,i){return t&&(t=t.split(" "),R&&(n=D({exclusive:"all",duration:400,ease:"ease-out"},n),e.css(se,n.exclusive+" "+n.duration+"ms "+n.ease),setTimeout(function(){e.css(se,"").css(Z)},n.duration)),T(t,function(t,n){e.toggleClass(n,i)})),e},C.parseEffects=function(e,t){var n={};return"string"==typeof e?T(e.split(" "),function(e,i){var o=!O.test(i),r=i.replace(N,function(e,t,n){return t+":"+n.toLowerCase()}),s=r.split(":"),a=s[1],l={};s.length>1&&(l.direction=t&&o?he[a].reverse:a),n[s[0]]=l}):T(e,function(e){var i=this.direction;i&&t&&!O.test(e)&&(this.direction=he[i].reverse),n[e]=this}),n},R&&D(S,{transition:function(t,n,i){var r,a,l,c,d=0,u=t.data("keys")||[];i=D({duration:200,ease:"ease-out",complete:null,exclusive:"all"},i),l=!1,c=function(){l||(l=!0,a&&(clearTimeout(a),a=null),t.removeData(te).dequeue().css(se,"").css(se),i.complete.call(t))},i.duration=e.fx?e.fx.speeds[i.duration]||i.duration:i.duration,r=s(t,n),e.merge(u,o(r)),t.data("keys",e.unique(u)).height(),t.css(se,i.exclusive+" "+i.duration+"ms "+i.ease).css(se),t.css(r).css(ae),R.event&&(t.one(R.event,c),0!==i.duration&&(d=500)),a=setTimeout(c,i.duration+d),t.data(te,a),t.data(re,c)},stopQueue:function(e,t,n){var i,o=e.data("keys"),r=!n&&o,s=e.data(re);return r&&(i=C.getComputedStyles(e[0],o)),s&&s(),r&&e.css(i),e.removeData("keys").stop(t)}}),f=C.Class.extend({init:function(e,t){var n=this;n.element=e,n.effects=[],n.options=t,n.restore=[]},run:function(t){var n,i,o,a,l,c,d,u=this,h=t.length,f=u.element,p=u.options,m=e.Deferred(),g={},v={};for(u.effects=t,m.then(e.proxy(u,"complete")),f.data("animating",!0),i=0;i<h;i++)for(n=t[i],n.setReverse(p.reverse),n.setOptions(p),u.addRestoreProperties(n.restore),n.prepare(g,v),l=n.children(),o=0,c=l.length;o<c;o++)l[o].duration(p.duration).run();for(d in p.effects)D(v,p.effects[d].properties);for(f.is(":visible")||D(g,{display:f.data("olddisplay")||"block"}),M&&!p.reset&&(a=f.data("targetTransform"),a&&(g=D(a,g))),g=s(f,g),M&&!R&&(g=r(g)),f.css(g).css(ae),i=0;i<h;i++)t[i].setup();return p.init&&p.init(),f.data("targetTransform",v),S.animate(f,v,D({},p,{complete:m.resolve})),m.promise()},stop:function(){e(this.element).kendoStop(!0,!0)},addRestoreProperties:function(e){for(var t,n=this.element,i=0,o=e.length;i<o;i++)t=e[i],this.restore.push(t),n.data(t)||n.data(t,n.css(t))},restoreCallback:function(){var e,t,n,i=this.element;for(e=0,t=this.restore.length;e<t;e++)n=this.restore[e],i.css(n,i.data(n))},complete:function(){var t=this,n=0,i=t.element,o=t.options,r=t.effects,s=r.length;for(i.removeData("animating").dequeue(),o.hide&&i.data("olddisplay",i.css("display")).hide(),this.restoreCallback(),P&&!M&&setTimeout(e.proxy(this,"restoreCallback"),0);n<s;n++)r[n].teardown();o.completeCallback&&o.completeCallback(i)}}),S.promise=function(e,t){var n,i,o,r=[],s=new f(e,t),a=C.parseEffects(t.effects);t.effects=a;for(o in a)n=S[l(o)],n&&(i=new n(e,a[o].direction),r.push(i));r[0]?s.run(r):(e.is(":visible")||e.css({display:e.data("olddisplay")||"block"}).css("display"),t.init&&t.init(),e.dequeue(),s.complete())},D(S,{animate:function(n,o,s){var a=s.transition!==!1;delete s.transition,R&&"transition"in S&&a?S.transition(n,o,s):M?n.animate(r(o),{queue:!1,show:!1,hide:!1,duration:s.duration,complete:s.complete}):n.each(function(){var n=e(this),r={};T(U,function(e,s){var a,l,c,d,u,h,f,p=o?o[s]+" ":null;p&&(l=o,s in F&&o[s]!==t?(a=p.match(L),M&&D(l,{scale:+a[0]})):s in z&&o[s]!==t&&(c=n.css(oe),d="absolute"==c||"fixed"==c,n.data(ie)||(d?n.data(ie,{top:i(n,"top")||0,left:i(n,"left")||0,bottom:i(n,"bottom"),right:i(n,"right")}):n.data(ie,{top:i(n,"marginTop")||0,left:i(n,"marginLeft")||0})),u=n.data(ie),a=p.match(L),a&&(h=s==ie+"y"?0:+a[1],f=s==ie+"y"?+a[1]:+a[2],d?(isNaN(u.right)?isNaN(h)||D(l,{left:u.left+h}):isNaN(h)||D(l,{right:u.right-h}),isNaN(u.bottom)?isNaN(f)||D(l,{top:u.top+f}):isNaN(f)||D(l,{bottom:u.bottom-f})):(isNaN(h)||D(l,{marginLeft:u.left+h}),isNaN(f)||D(l,{marginTop:u.top+f})))),!M&&"scale"!=s&&s in l&&delete l[s],l&&D(r,l))}),I.msie&&delete r.scale,n.animate(r,{queue:!1,show:!1,hide:!1,duration:s.duration,complete:s.complete})})}}),S.animatedPromise=S.promise,p=C.Class.extend({init:function(e,t){var n=this;n.element=e,n._direction=t,n.options={},n._additionalEffects=[],n.restore||(n.restore=[])},reverse:function(){return this._reverse=!0,this.run()},play:function(){return this._reverse=!1,this.run()},add:function(e){return this._additionalEffects.push(e),this},direction:function(e){return this._direction=e,this},duration:function(e){return this._duration=e,this},compositeRun:function(){var e=this,t=new f(e.element,{reverse:e._reverse,duration:e._duration}),n=e._additionalEffects.concat([e]);return t.run(n)},run:function(){if(this._additionalEffects&&this._additionalEffects[0])return this.compositeRun();var t,n,i=this,o=i.element,a=0,l=i.restore,c=l.length,d=e.Deferred(),u={},h={},f=i.children(),p=f.length;for(d.then(e.proxy(i,"_complete")),o.data("animating",!0),a=0;a<c;a++)t=l[a],o.data(t)||o.data(t,o.css(t));for(a=0;a<p;a++)f[a].duration(i._duration).run();return i.prepare(u,h),o.is(":visible")||D(u,{display:o.data("olddisplay")||"block"}),M&&(n=o.data("targetTransform"),n&&(u=D(n,u))),u=s(o,u),M&&!R&&(u=r(u)),o.css(u).css(ae),i.setup(),o.data("targetTransform",h),S.animate(o,h,{duration:i._duration,complete:d.resolve}),d.promise()},stop:function(){var t=0,n=this.children(),i=n.length;for(t=0;t<i;t++)n[t].stop();return e(this.element).kendoStop(!0,!0),this},restoreCallback:function(){var e,t,n,i=this.element;for(e=0,t=this.restore.length;e<t;e++)n=this.restore[e],i.css(n,i.data(n))},_complete:function(){var t=this,n=t.element;n.removeData("animating").dequeue(),t.restoreCallback(),t.shouldHide()&&n.data("olddisplay",n.css("display")).hide(),P&&!M&&setTimeout(e.proxy(t,"restoreCallback"),0),t.teardown()},setOptions:function(e){D(!0,this.options,e)},children:function(){return[]},shouldHide:e.noop,setup:e.noop,prepare:e.noop,teardown:e.noop,directions:[],setReverse:function(e){return this._reverse=e,this}}),m=["left","right","up","down"],g=["in","out"],c("slideIn",{directions:m,divisor:function(e){return this.options.divisor=e,this},prepare:function(e,t){var n,i=this,o=i.element,r=C._outerWidth,s=C._outerHeight,a=he[i._direction],l=-a.modifier*(a.vertical?s(o):r(o)),c=l/(i.options&&i.options.divisor||1)+K,d="0px";i._reverse&&(n=e,e=t,t=n),M?(e[a.transition]=c,t[a.transition]=d):(e[a.property]=c,t[a.property]=d)}}),c("tile",{directions:m,init:function(e,t,n){p.prototype.init.call(this,e,t),this.options={previous:n}},previousDivisor:function(e){return this.options.previousDivisor=e,this},children:function(){var e=this,t=e._reverse,n=e.options.previous,i=e.options.previousDivisor||1,o=e._direction,r=[C.fx(e.element).slideIn(o).setReverse(t)];return n&&r.push(C.fx(n).slideIn(he[o].reverse).divisor(i).setReverse(!t)),r}}),d("fade","opacity",1,0),d("zoom","scale",1,.01),c("slideMargin",{prepare:function(e,t){var n,i=this,o=i.element,r=i.options,s=o.data(ee),a=r.offset,l=i._reverse;l||null!==s||o.data(ee,parseFloat(o.css("margin-"+r.axis))),n=o.data(ee)||0,t["margin-"+r.axis]=l?n:n+a}}),c("slideTo",{prepare:function(e,t){var n=this,i=n.element,o=n.options,r=o.offset.split(","),s=n._reverse;M?(t.translatex=s?0:r[0],t.translatey=s?0:r[1]):(t.left=s?0:r[0],t.top=s?0:r[1]),i.css("left")}}),c("expand",{directions:["horizontal","vertical"],restore:[ne],prepare:function(e,n){var i=this,o=i.element,r=i.options,s=i._reverse,a="vertical"===i._direction?Z:X,l=o[0].style[a],c=o.data(a),d=parseFloat(c||l),u=G(o.css(a,Q)[a]());e.overflow=J,d=r&&r.reset?u||d:d||u,n[a]=(s?0:d)+K,e[a]=(s?d:0)+K,c===t&&o.data(a,l)},shouldHide:function(){return this._reverse},teardown:function(){var e=this,t=e.element,n="vertical"===e._direction?Z:X,i=t.data(n);i!=Q&&i!==$||setTimeout(function(){t.css(n,Q).css(n)},0)}}),v={position:"absolute",marginLeft:0,marginTop:0,scale:1},c("transfer",{init:function(e,t){this.element=e,this.options={target:t},this.restore=[]},setup:function(){this.element.appendTo(document.body)},prepare:function(e,t){var n=this,i=n.element,o=S.box(i),r=S.box(n.options.target),s=a(i,"scale"),l=S.fillScale(r,o),c=S.transformOrigin(r,o);D(e,v),t.scale=1,i.css(ae,"scale(1)").css(ae),i.css(ae,"scale("+s+")"),e.top=o.top,e.left=o.left,e.transformOrigin=c.x+K+" "+c.y+K,n._reverse?e.scale=l:t.scale=l}}),_={top:"rect(auto auto $size auto)",bottom:"rect($size auto auto auto)",left:"rect(auto $size auto auto)",right:"rect(auto auto auto $size)"},b={top:{start:"rotatex(0deg)",end:"rotatex(180deg)"},bottom:{start:"rotatex(-180deg)",end:"rotatex(0deg)"},left:{start:"rotatey(0deg)",end:"rotatey(-180deg)"},right:{start:"rotatey(180deg)",end:"rotatey(0deg)"}},c("turningPage",{directions:m,init:function(e,t,n){p.prototype.init.call(this,e,t),this._container=n},prepare:function(e,t){var n=this,i=n._reverse,o=i?he[n._direction].reverse:n._direction,r=b[o];e.zIndex=1,n._clipInHalf&&(e.clip=u(n._container,C.directions[o].reverse)),e[le]=J,t[ae]=ue+(i?r.start:r.end),e[ae]=ue+(i?r.end:r.start)},setup:function(){this._container.append(this.element)},face:function(e){return this._face=e,this},shouldHide:function(){var e=this,t=e._reverse,n=e._face;return t&&!n||!t&&n},clipInHalf:function(e){return this._clipInHalf=e,this},temporary:function(){return this.element.addClass("temp-page"),this}}),c("staticPage",{directions:m,init:function(e,t,n){p.prototype.init.call(this,e,t),this._container=n},restore:["clip"],prepare:function(e,t){var n=this,i=n._reverse?he[n._direction].reverse:n._direction;e.clip=u(n._container,i),e.opacity=.999,t.opacity=1},shouldHide:function(){var e=this,t=e._reverse,n=e._face;return t&&!n||!t&&n},face:function(e){return this._face=e,this}}),c("pageturn",{directions:["horizontal","vertical"],init:function(e,t,n,i){p.prototype.init.call(this,e,t),this.options={},this.options.face=n,this.options.back=i},children:function(){var e,t=this,n=t.options,i="horizontal"===t._direction?"left":"top",o=C.directions[i].reverse,r=t._reverse,s=n.face.clone(!0).removeAttr("id"),a=n.back.clone(!0).removeAttr("id"),l=t.element;return r&&(e=i,i=o,o=e),[C.fx(n.face).staticPage(i,l).face(!0).setReverse(r),C.fx(n.back).staticPage(o,l).setReverse(r),C.fx(s).turningPage(i,l).face(!0).clipInHalf(!0).temporary().setReverse(r),C.fx(a).turningPage(o,l).clipInHalf(!0).temporary().setReverse(r)]},prepare:function(e,t){e[ce]=de,e.transformStyle="preserve-3d",e.opacity=.999,t.opacity=1},teardown:function(){this.element.find(".temp-page").remove()}}),c("flip",{directions:["horizontal","vertical"],init:function(e,t,n,i){p.prototype.init.call(this,e,t),this.options={},this.options.face=n,this.options.back=i},children:function(){var e,t=this,n=t.options,i="horizontal"===t._direction?"left":"top",o=C.directions[i].reverse,r=t._reverse,s=t.element;return r&&(e=i,i=o,o=e),[C.fx(n.face).turningPage(i,s).face(!0).setReverse(r),C.fx(n.back).turningPage(o,s).setReverse(r)]},prepare:function(e){e[ce]=de,e.transformStyle="preserve-3d"}}),w=!E.mobileOS.android,y=".km-touch-scrollbar, .km-actionsheet-wrapper",c("replace",{_before:e.noop,_after:e.noop,init:function(t,n,i){p.prototype.init.call(this,t),this._previous=e(n),this._transitionClass=i},duration:function(){throw Error("The replace effect does not support duration setting; the effect duration may be customized through the transition class rule")},beforeTransition:function(e){return this._before=e,this},afterTransition:function(e){return this._after=e,this},_both:function(){return e().add(this._element).add(this._previous)},_containerClass:function(){var e=this._direction,t="k-fx k-fx-start k-fx-"+this._transitionClass;return e&&(t+=" k-fx-"+e),this._reverse&&(t+=" k-fx-reverse"),t},complete:function(t){if(!(!this.deferred||t&&e(t.target).is(y))){var n=this.container;n.removeClass("k-fx-end").removeClass(this._containerClass()).off(R.event,this.completeProxy),this._previous.hide().removeClass("k-fx-current"),this.element.removeClass("k-fx-next"),w&&n.css(ne,""),this.isAbsolute||this._both().css(oe,""),this.deferred.resolve(),delete this.deferred}},run:function(){if(this._additionalEffects&&this._additionalEffects[0])return this.compositeRun();var t,n=this,i=n.element,o=n._previous,r=i.parents().filter(o.parents()).first(),s=n._both(),a=e.Deferred(),l=i.css(oe);return r.length||(r=i.parent()),this.container=r,this.deferred=a,this.isAbsolute="absolute"==l,this.isAbsolute||s.css(oe,"absolute"),w&&(t=r.css(ne),r.css(ne,"hidden")),R?(i.addClass("k-fx-hidden"),r.addClass(this._containerClass()),this.completeProxy=e.proxy(this,"complete"),r.on(R.event,this.completeProxy),C.animationFrame(function(){i.removeClass("k-fx-hidden").addClass("k-fx-next"),o.css("display","").addClass("k-fx-current"),n._before(o,i),C.animationFrame(function(){r.removeClass("k-fx-start").addClass("k-fx-end"),n._after(o,i)})})):this.complete(),a.promise()},stop:function(){this.complete()}}),k=C.Class.extend({init:function(){var e=this;e._tickProxy=A(e._tick,e),e._started=!1},tick:e.noop,done:e.noop,onEnd:e.noop,onCancel:e.noop,start:function(){this.enabled()&&(this.done()?this.onEnd():(this._started=!0,C.animationFrame(this._tickProxy)))},enabled:function(){return!0},cancel:function(){this._started=!1,this.onCancel()},_tick:function(){var e=this;e._started&&(e.tick(),e.done()?(e._started=!1,
e.onEnd()):C.animationFrame(e._tickProxy))}}),x=k.extend({init:function(e){var t=this;D(t,e),k.fn.init.call(t)},done:function(){return this.timePassed()>=this.duration},timePassed:function(){return Math.min(this.duration,new Date-this.startDate)},moveTo:function(e){var t=this,n=t.movable;t.initial=n[t.axis],t.delta=e.location-t.initial,t.duration="number"==typeof e.duration?e.duration:300,t.tick=t._easeProxy(e.ease),t.startDate=new Date,t.start()},_easeProxy:function(e){var t=this;return function(){t.movable.moveAxis(t.axis,e(t.timePassed(),t.initial,t.delta,t.duration))}}}),D(x,{easeOutExpo:function(e,t,n,i){return e==i?t+n:n*(-Math.pow(2,-10*e/i)+1)+t},easeOutBack:function(e,t,n,i,o){return o=1.70158,n*((e=e/i-1)*e*((o+1)*e+o)+1)+t}}),S.Animation=k,S.Transition=x,S.createEffect=c,S.box=function(t){t=e(t);var n=t.offset();return n.width=C._outerWidth(t),n.height=C._outerHeight(t),n},S.transformOrigin=function(e,t){var n=(e.left-t.left)*t.width/(t.width-e.width),i=(e.top-t.top)*t.height/(t.height-e.height);return{x:isNaN(n)?0:n,y:isNaN(i)?0:i}},S.fillScale=function(e,t){return Math.min(e.width/t.width,e.height/t.height)},S.fitScale=function(e,t){return Math.max(e.width/t.width,e.height/t.height)}}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.view.min",["kendo.core.min","kendo.binder.min","kendo.fx.min"],e)}(function(){return function(e,t){function n(e){if(!e)return{};var t=e.match(_)||[];return{type:t[1],direction:t[3],reverse:"reverse"===t[5]}}var i=window.kendo,o=i.Observable,r="SCRIPT",s="init",a="show",l="hide",c="transitionStart",d="transitionEnd",u="attach",h="detach",f=/unrecognized expression/,p=o.extend({init:function(e,t){var n=this;t=t||{},o.fn.init.call(n),n.content=e,n.id=i.guid(),n.tagName=t.tagName||"div",n.model=t.model,n._wrap=t.wrap!==!1,this._evalTemplate=t.evalTemplate||!1,n._fragments={},n.bind([s,a,l,c,d],t)},render:function(t){var n=this,o=!n.element;return o&&(n.element=n._createElement()),t&&e(t).append(n.element),o&&(i.bind(n.element,n.model),n.trigger(s)),t&&(n._eachFragment(u),n.trigger(a)),n.element},clone:function(){return new m(this)},triggerBeforeShow:function(){return!0},triggerBeforeHide:function(){return!0},showStart:function(){this.element.css("display","")},showEnd:function(){},hideEnd:function(){this.hide()},beforeTransition:function(e){this.trigger(c,{type:e})},afterTransition:function(e){this.trigger(d,{type:e})},hide:function(){this._eachFragment(h),this.element.detach(),this.trigger(l)},destroy:function(){var e=this.element;e&&(i.unbind(e),i.destroy(e),e.remove())},fragments:function(t){e.extend(this._fragments,t)},_eachFragment:function(e){for(var t in this._fragments)this._fragments[t][e](this,t)},_createElement:function(){var t,n,o,s=this,a="<"+s.tagName+" />";try{n=e(document.getElementById(s.content)||s.content),n[0].tagName===r&&(n=n.html())}catch(l){f.test(l.message)&&(n=s.content)}return"string"==typeof n?(n=n.replace(/^\s+|\s+$/g,""),s._evalTemplate&&(n=i.template(n)(s.model||{})),t=e(a).append(n),s._wrap||(t=t.contents())):(t=n,s._evalTemplate&&(o=e(i.template(e("<div />").append(t.clone(!0)).html())(s.model||{})),e.contains(document,t[0])&&t.replaceWith(o),t=o),s._wrap&&(t=t.wrapAll(a).parent())),t}}),m=i.Class.extend({init:function(t){e.extend(this,{element:t.element.clone(!0),transition:t.transition,id:t.id}),t.element.parent().append(this.element)},hideEnd:function(){this.element.remove()},beforeTransition:e.noop,afterTransition:e.noop}),g=p.extend({init:function(e,t){p.fn.init.call(this,e,t),this.containers={}},container:function(e){var t=this.containers[e];return t||(t=this._createContainer(e),this.containers[e]=t),t},showIn:function(e,t,n){this.container(e).show(t,n)},_createContainer:function(e){var t,n=this.render(),i=n.find(e);if(!i.length&&n.is(e)){if(!n.is(e))throw Error("can't find a container with the specified "+e+" selector");i=n}return t=new b(i),t.bind("accepted",function(e){e.view.render(i)}),t}}),v=p.extend({attach:function(e,t){e.element.find(t).replaceWith(this.render())},detach:function(){}}),_=/^(\w+)(:(\w+))?( (\w+))?$/,b=o.extend({init:function(e){o.fn.init.call(this),this.container=e,this.history=[],this.view=null,this.running=!1},after:function(){this.running=!1,this.trigger("complete",{view:this.view}),this.trigger("after")},end:function(){this.view.showEnd(),this.previous.hideEnd(),this.after()},show:function(e,t,o){if(!e.triggerBeforeShow()||this.view&&!this.view.triggerBeforeHide())return this.trigger("after"),!1;o=o||e.id;var r=this,s=e===r.view?e.clone():r.view,a=r.history,l=a[a.length-2]||{},c=l.id===o,d=t||(c?a[a.length-1].transition:e.transition),u=n(d);return r.running&&r.effect.stop(),"none"===d&&(d=null),r.trigger("accepted",{view:e}),r.view=e,r.previous=s,r.running=!0,c?a.pop():a.push({id:o,transition:d}),s?(d&&i.effects.enabled?(e.element.addClass("k-fx-hidden"),e.showStart(),c&&!t&&(u.reverse=!u.reverse),r.effect=i.fx(e.element).replace(s.element,u.type).beforeTransition(function(){e.beforeTransition("show"),s.beforeTransition("hide")}).afterTransition(function(){e.afterTransition("show"),s.afterTransition("hide")}).direction(u.direction).setReverse(u.reverse),r.effect.run().then(function(){r.end()})):(e.showStart(),r.end()),!0):(e.showStart(),e.showEnd(),r.after(),!0)}});i.ViewContainer=b,i.Fragment=v,i.Layout=g,i.View=p,i.ViewClone=m}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dom.min",["kendo.core.min"],e)}(function(){return function(e){function t(){this.node=null}function n(){}function i(e,t,n){this.nodeName=e,this.attr=t||{},this.children=n||[]}function o(e){this.nodeValue=e+""}function r(e){this.html=e}function s(e,t){for(h.innerHTML=t;h.firstChild;)e.appendChild(h.firstChild)}function a(e){return new r(e)}function l(e,t,n){return new i(e,t,n)}function c(e){return new o(e)}function d(e){this.root=e,this.children=[]}var u,h;t.prototype={remove:function(){this.node.parentNode&&this.node.parentNode.removeChild(this.node),this.attr={}},attr:{},text:function(){return""}},n.prototype={nodeName:"#null",attr:{style:{}},children:[],remove:function(){}},u=new n,i.prototype=new t,i.prototype.appendTo=function(e){var t,n=document.createElement(this.nodeName),i=this.children;for(t=0;t<i.length;t++)i[t].render(n,u);return e.appendChild(n),n},i.prototype.render=function(e,t){var n,i,o,r,s,a;if(t.nodeName!==this.nodeName)t.remove(),n=this.appendTo(e);else{if(n=t.node,o=this.children,r=o.length,s=t.children,a=s.length,Math.abs(a-r)>2)return void this.render({appendChild:function(n){e.replaceChild(n,t.node)}},u);for(i=0;i<r;i++)o[i].render(n,s[i]||u);for(i=r;i<a;i++)s[i].remove()}this.node=n,this.syncAttributes(t.attr),this.removeAttributes(t.attr)},i.prototype.syncAttributes=function(e){var t,n,i,o=this.attr;for(t in o)n=o[t],i=e[t],"style"===t?this.setStyle(n,i):n!==i&&this.setAttribute(t,n,i)},i.prototype.setStyle=function(e,t){var n,i=this.node;if(t)for(n in e)e[n]!==t[n]&&(i.style[n]=e[n]);else for(n in e)i.style[n]=e[n]},i.prototype.removeStyle=function(e){var t,n=this.attr.style||{},i=this.node;for(t in e)void 0===n[t]&&(i.style[t]="")},i.prototype.removeAttributes=function(e){var t,n=this.attr;for(t in e)"style"===t?this.removeStyle(e.style):void 0===n[t]&&this.removeAttribute(t)},i.prototype.removeAttribute=function(e){var t=this.node;"style"===e?t.style.cssText="":"className"===e?t.className="":t.removeAttribute(e)},i.prototype.setAttribute=function(e,t){var n=this.node;void 0!==n[e]?n[e]=t:n.setAttribute(e,t)},i.prototype.text=function(){var e,t="";for(e=0;e<this.children.length;++e)t+=this.children[e].text();return t},o.prototype=new t,o.prototype.nodeName="#text",o.prototype.render=function(e,t){var n;t.nodeName!==this.nodeName?(t.remove(),n=document.createTextNode(this.nodeValue),e.appendChild(n)):(n=t.node,this.nodeValue!==t.nodeValue&&n.parentNode&&(n.nodeValue=this.nodeValue)),this.node=n},o.prototype.text=function(){return this.nodeValue},r.prototype={nodeName:"#html",attr:{},remove:function(){var e,t;for(e=0;e<this.nodes.length;e++)t=this.nodes[e],t.parentNode&&t.parentNode.removeChild(t)},render:function(e,t){var n,i;if(t.nodeName!==this.nodeName||t.html!==this.html)for(t.remove(),n=e.lastChild,s(e,this.html),this.nodes=[],i=n?n.nextSibling:e.firstChild;i;i=i.nextSibling)this.nodes.push(i);else this.nodes=t.nodes.slice(0)}},h=document.createElement("div"),d.prototype={html:a,element:l,text:c,render:function(e){var t,n,i,o=this.children;for(t=0,n=e.length;t<n;t++)i=o[t],i?i.node&&i.node.parentNode||(i.remove(),i=u):i=u,e[t].render(this.root,i);for(t=n;t<o.length;t++)o[t].remove();this.children=e}},e.dom={html:a,text:c,element:l,Tree:d,Node:t}}(window.kendo),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("ooxml/utils.min",["kendo.core.min"],e)}(function(){!function(){kendo.ooxml=kendo.ooxml||{},kendo.ooxml.createZip=function(){if("undefined"==typeof JSZip)throw Error("JSZip not found. Check http://docs.telerik.com/kendo-ui/framework/excel/introduction#requirements for more details.");return new JSZip}}()},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("ooxml/kendo-ooxml.min",["kendo.core.min","ooxml/utils.min"],e)}(function(){!function(e){function t(e){return P+e}function n(e,t){return t.indexOf(e)}function i(e){return(e+"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\"/g,"&quot;").replace(/\'/g,"&#39;")}function o(e,t){var n,i="";for(n=0;n<e;++n)i+=t(n);return i}function r(e,t){var n,i="";for(n=0;n<e.length;++n)i+=t(e[n],n);return i}function s(e){return"string"==typeof e?"<f>"+i(e)+"</f>":'<f t="array" ref="'+e.ref+'">'+i(e.src)+"</f>"}function a(e){var t=Math.floor(e/26)-1;return(t>=0?a(t):"")+String.fromCharCode(65+e%26)}function l(e,t){return a(t)+(e+1)}function c(e,t){return a(t)+"$"+(e+1)}function d(e){var t=e.frozenRows||(e.freezePane||{}).rowSplit||1;return t-1}function u(e){return(e/7*100+.5)/100}function h(e){return.75*e}function f(e){return(e+"").replace(/[\x00-\x08]/g,"").replace(/\n/g,"\r\n")}function p(e){var t=e;return t.length<6&&(t=t.replace(/(\w)/g,function(e,t){return t+t})),t=t.substring(1).toUpperCase(),t.length<8&&(t="FF"+t),t}function m(e){var t="thin";return 2===e?t="medium":3===e&&(t="thick"),t}function g(e,t){var n="";return t&&(n+="<"+e+' style="'+m(t.size)+'">',t.color&&(n+='<color rgb="'+p(t.color)+'"/>'),n+="</"+e+">"),n}function v(e){return"<border>"+g("left",e.left)+g("right",e.right)+g("top",e.top)+g("bottom",e.bottom)+"</border>"}function _(e,t){var n,i,o,r=[],s=[];for(b(e,function(e,t){var n={_source:e,index:t,height:e.height,cells:[]};r.push(n),s[t]=n}),n=w(r).slice(0),i={rowData:r,rowsByIndex:s,mergedCells:t},o=0;o<n.length;o++)C(n[o],i),delete n[o]._source;return w(r)}function b(e,t){var n,i,o;for(n=0;n<e.length;n++)i=e[n],i&&(o=i.index,"number"!=typeof o&&(o=n),t(i,o))}function w(e){return e.sort(function(e,t){return e.index-t.index})}function y(e,t){e.indexOf(t)<0&&e.push(t)}function k(e,t){var n,i,o,r,s;for(n=0;n<e.length;++n)if(i=e[n],o=i.split(":"),r=o[0],r===t)return s=o[1],r=x(r),s=x(s),{rowSpan:s.row-r.row+1,colSpan:s.col-r.col+1}}function x(e){function t(e){var t,n=e.toUpperCase(),i=0;for(t=0;t<n.length;++t)i=26*i+n.charCodeAt(t)-64;return i-1}function n(e){return parseInt(e,10)-1}var i=/^([a-z]+)(\d+)$/i.exec(e);return{row:n(i[2]),col:t(i[1])}}function C(e,t){var n,i,o,r,s,a,c,d,u,h=e._source,f=e.index,p=h.cells,m=e.cells;if(p)for(n=0;n<p.length;n++)if(i=p[n]||ie,o=i.rowSpan||1,r=i.colSpan||1,s=S(m,i),a=l(f,s),1===o&&1===r&&(c=k(t.mergedCells,a),c&&(r=c.colSpan,o=c.rowSpan)),A(i,m,s,r),(o>1||r>1)&&y(t.mergedCells,a+":"+l(f+o-1,s+r-1)),o>1)for(d=f+1;d<f+o;d++)u=t.rowsByIndex[d],u||(u=t.rowsByIndex[d]={index:d,cells:[]},t.rowData.push(u)),A(i,u.cells,s-1,r+1)}function S(e,t){var n;return"number"==typeof t.index?(n=t.index,T(e,t,t.index)):n=D(e,t),n}function T(e,t,n){e[n]=t}function D(e,t){var n,i=e.length;for(n=0;n<e.length+1;n++)if(!e[n]){e[n]=t,i=n;break}return i}function A(e,t,n,i){var o,r;for(o=1;o<i;o++)r={borderTop:e.borderTop,borderRight:e.borderRight,borderBottom:e.borderBottom,borderLeft:e.borderLeft},T(t,r,n+o)}function E(e){return oe({ref:e.ref,columns:e.columns,generators:{custom:re,dynamic:se,top:ae,value:le}})}var I,M,R,F,z,P,B,L,H,N,O,V,U,W,j,q,G,$,K,Y,Q,X,Z,J,ee,te,ne,ie,oe,re,se,ae,le;window.kendo.ooxml=window.kendo.ooxml||{},I=kendo.ooxml,M=e.map,R=I.createZip,F={toString:function(e){return e}},z=kendo.Class.extend({}),z.register=function(e){F=e},z.toString=function(e,t){return F.toString(e,t)},P="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",B={compression:"DEFLATE",type:"base64"},L=6e4,H=864e5,N=JSON.parse.bind(JSON),O='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r',V=O+'\n            <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n               <Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/>\n               <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/>\n               <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>\n            </Relationships>',U=function(e){var t=e.creator,n=e.lastModifiedBy,o=e.created,r=e.modified;return O+'\n <cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties"\n   xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/"\n   xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">\n   <dc:creator>'+i(t)+"</dc:creator>\n   <cp:lastModifiedBy>"+i(n)+'</cp:lastModifiedBy>\n   <dcterms:created xsi:type="dcterms:W3CDTF">'+i(o)+'</dcterms:created>\n   <dcterms:modified xsi:type="dcterms:W3CDTF">'+i(r)+"</dcterms:modified>\n</cp:coreProperties>"},W=function(e){var t=e.sheets;return O+'\n<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes">\n  <Application>Microsoft Excel</Application>\n  <DocSecurity>0</DocSecurity>\n  <ScaleCrop>false</ScaleCrop>\n  <HeadingPairs>\n    <vt:vector size="2" baseType="variant">\n      <vt:variant>\n        <vt:lpstr>Worksheets</vt:lpstr>\n      </vt:variant>\n      <vt:variant>\n        <vt:i4>'+t.length+'</vt:i4>\n      </vt:variant>\n    </vt:vector>\n  </HeadingPairs>\n  <TitlesOfParts>\n    <vt:vector size="'+t.length+'" baseType="lpstr">'+r(t,function(e,t){return e.options.title?"<vt:lpstr>"+i(e.options.title)+"</vt:lpstr>":"<vt:lpstr>Sheet"+(t+1)+"</vt:lpstr>"})+"</vt:vector>\n  </TitlesOfParts>\n  <LinksUpToDate>false</LinksUpToDate>\n  <SharedDoc>false</SharedDoc>\n  <HyperlinksChanged>false</HyperlinksChanged>\n  <AppVersion>14.0300</AppVersion>\n</Properties>"},j=function(e){var t=e.count;return O+'\n<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">\n  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" />\n  <Default Extension="xml" ContentType="application/xml" />\n  <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" />\n  <Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>\n  <Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"/>\n  '+o(t,function(e){return'<Override PartName="/xl/worksheets/sheet'+(e+1)+'.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />'})+'\n  <Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml" />\n  <Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml" />\n</Types>'},q=function(e){var t=e.sheets,n=e.filterNames,o=e.userNames;return O+'\n<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">\n  <fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="9303" />\n  <workbookPr defaultThemeVersion="124226" />\n  <bookViews>\n    <workbookView xWindow="240" yWindow="45" windowWidth="18195" windowHeight="7995" />\n  </bookViews>\n  <sheets>\n  '+r(t,function(e,t){var n=e.options,o=n.name||n.title||"Sheet"+(t+1);return'<sheet name="'+i(o)+'" sheetId="'+(t+1)+'" r:id="rId'+(t+1)+'" />'})+"\n  </sheets>\n  "+(n.length||o.length?"\n    <definedNames>\n      "+r(n,function(e){return'\n          <definedName name="_xlnm._FilterDatabase" hidden="1" localSheetId="'+e.localSheetId+'">'+i(e.name)+"!$"+i(e.from)+":$"+i(e.to)+"</definedName>"})+"\n      "+r(o,function(e){return'\n         <definedName name="'+e.name+'" hidden="'+(e.hidden?1:0)+'"'+(null!=e.localSheetId?'localSheetId="'+e.localSheetId+'"':"")+"</definedName>"})+"\n    </definedNames>":"")+'\n  <calcPr fullCalcOnLoad="1" calcId="145621" />\n</workbook>'},G=function(e){var t=e.frozenColumns,n=e.frozenRows,o=e.columns,a=e.defaults,l=e.data,c=e.index,d=e.mergeCells,f=e.autoFilter,p=e.filter,m=e.showGridLines,g=e.hyperlinks,v=e.validations,_=e.defaultCellStyleId,b=e.rtl;return O+'\n<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" mc:Ignorable="x14ac">\n   <dimension ref="A1" />\n\n   <sheetViews>\n     <sheetView '+(b?'rightToLeft="1"':"")+" "+(0===c?'tabSelected="1"':"")+' workbookViewId="0" '+(m===!1?'showGridLines="0"':"")+">\n     "+(n||t?'\n       <pane state="frozen"\n         '+(t?'xSplit="'+t+'"':"")+"\n         "+(n?'ySplit="'+n+'"':"")+'\n         topLeftCell="'+(String.fromCharCode(65+(t||0))+((n||0)+1))+'"\n       />':"")+'\n     </sheetView>\n   </sheetViews>\n\n   <sheetFormatPr x14ac:dyDescent="0.25" defaultRowHeight="'+(a.rowHeight?.75*a.rowHeight:15)+'"\n     '+(a.columnWidth?'defaultColWidth="'+u(a.columnWidth)+'"':"")+" />\n\n   "+(null!=_||o&&o.length>0?"\n     <cols>\n       "+(o&&o.length?"":'\n         <col min="1" max="16384" style="'+_+'"\n              '+(a.columnWidth?'width="'+u(a.columnWidth)+'"':"")+" /> ")+"\n       "+r(o,function(e,t){var n="number"==typeof e.index?e.index+1:t+1;return 0===e.width?"<col "+(null!=_?'style="'+_+'"':"")+'\n                        min="'+n+'" max="'+n+'" hidden="1" customWidth="1" />':"<col "+(null!=_?'style="'+_+'"':"")+'\n                      min="'+n+'" max="'+n+'" customWidth="1"\n                      '+(e.autoWidth?'width="'+(7*e.width+5)/7*256/256+'" bestFit="1"':'width="'+u(e.width)+'"')+" />"})+"\n     </cols>":"")+"\n\n   <sheetData>\n     "+r(l,function(e,t){var n="number"==typeof e.index?e.index+1:t+1;return'\n         <row r="'+n+'" x14ac:dyDescent="0.25"\n              '+(0===e.height?'hidden="1"':e.height?'ht="'+h(e.height)+'" customHeight="1"':"")+">\n           "+r(e.data,function(e){return'\n             <c r="'+e.ref+'" '+(e.style?'s="'+e.style+'"':"")+" "+(e.type?'t="'+e.type+'"':"")+">\n               "+(null!=e.formula?s(e.formula):"")+"\n               "+(null!=e.value?"<v>"+i(e.value)+"</v>":"")+"\n             </c>"})+"\n         </row>\n       "})+"\n   </sheetData>\n\n   "+(f?'<autoFilter ref="'+f.from+":"+f.to+'"/>':p?E(p):"")+"\n\n   "+(d.length?'\n     <mergeCells count="'+d.length+'">\n       '+r(d,function(e){return'<mergeCell ref="'+e+'"/>'})+"\n     </mergeCells>":"")+"\n\n   "+(v.length?"\n     <dataValidations>\n       "+r(v,function(e){return'\n         <dataValidation sqref="'+e.sqref.join(" ")+'"\n                         showErrorMessage="'+e.showErrorMessage+'"\n                         type="'+i(e.type)+'"\n                         '+("list"!==e.type?'operator="'+i(e.operator)+'"':"")+'\n                         allowBlank="'+e.allowBlank+'"\n                         showDropDown="'+e.showDropDown+'"\n                         '+(e.error?'error="'+i(e.error)+'"':"")+"\n                         "+(e.errorTitle?'errorTitle="'+i(e.errorTitle)+'"':"")+">\n           "+(e.formula1?"<formula1>"+i(e.formula1)+"</formula1>":"")+"\n           "+(e.formula2?"<formula2>"+i(e.formula2)+"</formula2>":"")+"\n         </dataValidation>"})+"\n     </dataValidations>":"")+"\n\n   "+(g.length?"\n     <hyperlinks>\n       "+r(g,function(e,t){return'\n         <hyperlink ref="'+e.ref+'" r:id="rId'+t+'"/>'})+"\n     </hyperlinks>":"")+'\n\n   <pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3" />\n</worksheet>'},$=function(e){var t=e.count;return O+'\n<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n  '+o(t,function(e){return'\n    <Relationship Id="rId'+(e+1)+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet'+(e+1)+'.xml" />'})+'\n  <Relationship Id="rId'+(t+1)+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml" />\n  <Relationship Id="rId'+(t+2)+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml" />\n</Relationships>'},K=function(e){var t=e.hyperlinks;return O+'\n<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n  '+r(t,function(e,t){return'\n    <Relationship Id="rId'+t+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="'+i(e.target)+'" TargetMode="External" />'})+"\n</Relationships>"},Y=function(e){var t=e.count,n=e.uniqueCount,o=e.indexes;return O+'\n<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="'+t+'" uniqueCount="'+n+'">\n  '+r(Object.keys(o),function(e){return'\n    <si><t xml:space="preserve">'+i(e.substring(1))+"</t></si>"})+"\n</sst>"},Q=function(e){var t=e.formats,n=e.fonts,o=e.fills,s=e.borders,a=e.styles;return O+'\n<styleSheet\n    xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"\n    xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006"\n    mc:Ignorable="x14ac"\n    xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">\n  <numFmts count="'+t.length+'">\n  '+r(t,function(e,t){return'\n    <numFmt formatCode="'+i(e.format)+'" numFmtId="'+(165+t)+'" />'})+'\n  </numFmts>\n  <fonts count="'+(n.length+1)+'" x14ac:knownFonts="1">\n    <font>\n       <sz val="11" />\n       <color theme="1" />\n       <name val="Calibri" />\n       <family val="2" />\n       <scheme val="minor" />\n    </font>\n    '+r(n,function(e){return'\n    <font>\n      <sz val="'+(e.fontSize||11)+'" />\n      '+(e.bold?"<b/>":"")+"\n      "+(e.italic?"<i/>":"")+"\n      "+(e.underline?"<u/>":"")+"\n      "+(e.color?'<color rgb="'+i(e.color)+'" />':'<color theme="1" />')+"\n      "+(e.fontFamily?'\n        <name val="'+i(e.fontFamily)+'" />\n        <family val="2" />\n      ':'\n        <name val="Calibri" />\n        <family val="2" />\n        <scheme val="minor" />\n      ')+"\n    </font>"})+'\n  </fonts>\n  <fills count="'+(o.length+2)+'">\n      <fill><patternFill patternType="none"/></fill>\n      <fill><patternFill patternType="gray125"/></fill>\n    '+r(o,function(e){return"\n      "+(e.background?'\n        <fill>\n          <patternFill patternType="solid">\n              <fgColor rgb="'+i(e.background)+'"/>\n          </patternFill>\n        </fill>\n      ':"")})+'\n  </fills>\n  <borders count="'+(s.length+1)+'">\n    <border><left/><right/><top/><bottom/><diagonal/></border>\n    '+r(s,v)+'\n  </borders>\n  <cellStyleXfs count="1">\n    <xf borderId="0" fillId="0" fontId="0" />\n  </cellStyleXfs>\n  <cellXfs count="'+(a.length+1)+'">\n    <xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" />\n    '+r(a,function(e){return'\n      <xf xfId="0"\n          '+(e.fontId?'fontId="'+e.fontId+'" applyFont="1"':"")+"\n          "+(e.fillId?'fillId="'+e.fillId+'" applyFill="1"':"")+"\n          "+(e.numFmtId?'numFmtId="'+e.numFmtId+'" applyNumberFormat="1"':"")+"\n          "+(e.textAlign||e.verticalAlign||e.wrap?'applyAlignment="1"':"")+"\n          "+(e.borderId?'borderId="'+e.borderId+'" applyBorder="1"':"")+">\n        "+(e.textAlign||e.verticalAlign||e.wrap?"\n        <alignment\n          "+(e.textAlign?'horizontal="'+i(e.textAlign)+'"':"")+"\n          "+(e.verticalAlign?'vertical="'+i(e.verticalAlign)+'"':"")+"\n          "+(e.wrap?'wrapText="1"':"")+" />\n        ":"")+"\n      </xf>\n    "})+'\n  </cellXfs>\n  <cellStyles count="1">\n    <cellStyle name="Normal" xfId="0" builtinId="0"/>\n  </cellStyles>\n  <dxfs count="0" />\n  <tableStyles count="0" defaultTableStyle="TableStyleMedium2" defaultPivotStyle="PivotStyleMedium9" />\n</styleSheet>'},X=new Date(1900,0,0),Z=kendo.Class.extend({init:function(e,t,n,i){this.options=e,this._strings=t,this._styles=n,this._borders=i,this._validations={}},relsToXML:function(){var e=this.options.hyperlinks||[];return e.length?K({hyperlinks:e}):""},toXML:function(e){var t,n,i,o,r,s,a,c=this,u=this.options.mergedCells||[],h=this.options.rows||[],f=_(h,u);this._readCells(f),t=this.options.filter,t&&"number"==typeof t.from&&"number"==typeof t.to?t={from:l(d(this.options),t.from),to:l(d(this.options),t.to)}:t&&t.ref&&t.columns&&(n=t,t=null),i=[];for(o in this._validations)Object.prototype.hasOwnProperty.call(c._validations,o)&&i.push(c._validations[o]);return r=null,this.options.defaultCellStyle&&(r=this._lookupStyle(this.options.defaultCellStyle)),s=this.options.freezePane||{},a=this.options.defaults||{},G({frozenColumns:this.options.frozenColumns||s.colSplit,frozenRows:this.options.frozenRows||s.rowSplit,columns:this.options.columns,defaults:a,data:f,index:e,mergeCells:u,autoFilter:t,filter:n,showGridLines:this.options.showGridLines,hyperlinks:this.options.hyperlinks||[],validations:i,defaultCellStyleId:r,rtl:void 0!==this.options.rtl?this.options.rtl:a.rtl})},_lookupString:function(e){var t,n="$"+e,i=this._strings.indexes[n];return void 0!==i?t=i:(t=this._strings.indexes[n]=this._strings.uniqueCount,this._strings.uniqueCount++),this._strings.count++,t},_lookupStyle:function(e){var t,i=JSON.stringify(e);return"{}"===i?0:(t=n(i,this._styles),t<0&&(t=this._styles.push(i)-1),t+1)},_lookupBorder:function(e){var t,i=JSON.stringify(e);if("{}"!==i)return t=n(i,this._borders),t<0&&(t=this._borders.push(i)-1),t+1},_readCells:function(e){var t,n,i,o,r,s=this;for(t=0;t<e.length;t++)for(n=e[t],i=n.cells,n.data=[],o=0;o<i.length;o++)r=s._cell(i[o],n.index,o),r&&n.data.push(r)},_cell:function(e,t,n){var i,o,r,s,a,c,d,u,h,p;return e&&e!==ie?(i=e.value,o={},e.borderLeft&&(o.left=e.borderLeft),e.borderRight&&(o.right=e.borderRight),e.borderTop&&(o.top=e.borderTop),e.borderBottom&&(o.bottom=e.borderBottom),o=this._lookupBorder(o),r=this.options.defaultCellStyle||{},s={borderId:o},function(e){e("color"),e("background"),e("bold"),e("italic"),e("underline"),e("fontFamily")||e("fontName","fontFamily"),e("fontSize"),e("format"),e("textAlign")||e("hAlign","textAlign"),e("verticalAlign")||e("vAlign","verticalAlign"),e("wrap")}(function(t,n){var i=e[t];if(void 0===i&&(i=r[t]),void 0!==i)return s[n||t]=i,!0}),a=this.options.columns||[],c=a[n],d=typeof i,c&&c.autoWidth&&(u=i,"number"===d&&(u=z.toString(i,e.format)),c.width=Math.max(c.width||0,(u+"").length)),"string"===d?(i=f(i),i=this._lookupString(i),d="s"):"number"===d?d="n":"boolean"===d?(d="b",i=+i):i&&i.getTime?(d=null,h=(i.getTimezoneOffset()-X.getTimezoneOffset())*L,i=(i-X-h)/H+1,s.format||(s.format="mm-dd-yy")):(d=null,i=null),s=this._lookupStyle(s),p=l(t,n),e.validation&&this._addValidation(e.validation,p),{value:i,formula:e.formula,type:d,style:s,ref:p}):null},_addValidation:function(e,t){var n={showErrorMessage:"reject"===e.type?1:0,formula1:e.from,formula2:e.to,type:ee[e.dataType]||e.dataType,operator:J[e.comparerType]||e.comparerType,allowBlank:e.allowNulls?1:0,showDropDown:e.showButton?0:1,error:e.messageTemplate,errorTitle:e.titleTemplate},i=JSON.stringify(n);this._validations[i]||(this._validations[i]=n,n.sqref=[]),this._validations[i].sqref.push(t)}}),J={greaterThanOrEqualTo:"greaterThanOrEqual",lessThanOrEqualTo:"lessThanOrEqual"},ee={number:"decimal"},te={General:0,0:1,"0.00":2,"#,##0":3,"#,##0.00":4,"0%":9,"0.00%":10,"0.00E+00":11,"# ?/?":12,"# ??/??":13,"mm-dd-yy":14,"d-mmm-yy":15,"d-mmm":16,"mmm-yy":17,"h:mm AM/PM":18,"h:mm:ss AM/PM":19,"h:mm":20,"h:mm:ss":21,"m/d/yy h:mm":22,"#,##0 ;(#,##0)":37,"#,##0 ;[Red](#,##0)":38,"#,##0.00;(#,##0.00)":39,"#,##0.00;[Red](#,##0.00)":40,"mm:ss":45,"[h]:mm:ss":46,"mmss.0":47,"##0.0E+0":48,"@":49,"[$-404]e/m/d":27,"m/d/yy":30,t0:59,"t0.00":60,"t#,##0":61,"t#,##0.00":62,"t0%":67,"t0.00%":68,"t# ?/?":69,"t# ??/??":70},ne=kendo.Class.extend({init:function(e){var t=this;this.options=e||{},this._strings={indexes:{},count:0,uniqueCount:0},this._styles=[],this._borders=[],this._sheets=M(this.options.sheets||[],function(e){return e.defaults=t.options,new Z(e,t._strings,t._styles,t._borders)})},toZIP:function(){var e,t,i,o,r,s,a,l,u,h,f,m,g,v,_,b,w,y=this,k=R(),x=k.folder("docProps");for(x.file("core.xml",U({creator:this.options.creator||"Kendo UI",lastModifiedBy:this.options.creator||"Kendo UI",created:this.options.date||(new Date).toJSON(),modified:this.options.date||(new Date).toJSON()})),e=this._sheets.length,x.file("app.xml",W({sheets:this._sheets})),t=k.folder("_rels"),t.file(".rels",V),i=k.folder("xl"),o=i.folder("_rels"),o.file("workbook.xml.rels",$({count:e})),r={},i.file("workbook.xml",q({sheets:this._sheets,filterNames:M(this._sheets,function(e,t){var n,i=e.options,o=i.name||i.title||"Sheet"+(t+1);if(r[o.toLowerCase()]=t,n=i.filter,n&&void 0!==n.from&&void 0!==n.to)return{localSheetId:t,name:o,from:c(d(i),n.from),to:c(d(i),n.to)}}),userNames:M(this.options.names||[],function(e){return{name:e.localName,localSheetId:e.sheet?r[e.sheet.toLowerCase()]:null,value:e.value,hidden:e.hidden}})})),s=i.folder("worksheets"),a=s.folder("_rels"),l=0;l<e;l++)u=y._sheets[l],h="sheet"+(l+1)+".xml",f=u.relsToXML(),f&&a.file(h+".rels",f),s.file(h,u.toXML(l));return m=M(this._borders,N),g=M(this._styles,N),v=function(e){return e.underline||e.bold||e.italic||e.color||e.fontFamily||e.fontSize},_=M(g,function(e){if(e.color&&(e.color=p(e.color)),v(e))return e}),b=M(g,function(e){if(e.format&&void 0===te[e.format])return e}),w=M(g,function(e){if(e.background)return e.background=p(e.background),e}),i.file("styles.xml",Q({fonts:_,fills:w,formats:b,borders:m,styles:M(g,function(e){var t={};return v(e)&&(t.fontId=n(e,_)+1),e.background&&(t.fillId=n(e,w)+2),t.textAlign=e.textAlign,t.verticalAlign=e.verticalAlign,t.wrap=e.wrap,t.borderId=e.borderId,e.format&&(t.numFmtId=void 0!==te[e.format]?te[e.format]:165+n(e,b)),t})})),i.file("sharedStrings.xml",Y(this._strings)),k.file("[Content_Types].xml",j({count:e})),k},toDataURL:function(){var e=this.toZIP();return e.generateAsync?e.generateAsync(B).then(t):t(e.generate(B))}}),ie={},oe=function(e){var t=e.ref,n=e.columns,i=e.generators;return'\n<autoFilter ref="'+t+'">\n  '+r(n,function(e){return'\n    <filterColumn colId="'+e.index+'">\n      '+i[e.filter](e)+"\n    </filterColumn>\n  "})+"\n</autoFilter>"},re=function(e){var t=e.logic,n=e.criteria;return"\n<customFilters "+("and"===t?'and="1"':"")+">\n"+r(n,function(e){var t=E.customOperator(e),n=E.customValue(e);return"<customFilter "+(t?'operator="'+t+'"':"")+' val="'+n+'"/>'})+"\n</customFilters>";
},se=function(e){var t=e.type;return'<dynamicFilter type="'+E.dynamicFilterType(t)+'" />'},ae=function(e){var t=e.type,n=e.value;return'<top10 percent="'+(/percent$/i.test(t)?1:0)+'"\n       top="'+(/^top/i.test(t)?1:0)+'"\n       val="'+n+'" />'},le=function(e){var t=e.blanks,n=e.values;return"<filters "+(t?'blank="1"':"")+">\n    "+r(n,function(e){return'\n      <filter val="'+e+'" />'})+"\n  </filters>"},E.customOperator=function(e){return{eq:"equal",gt:"greaterThan",gte:"greaterThanOrEqual",lt:"lessThan",lte:"lessThanOrEqual",ne:"notEqual",doesnotstartwith:"notEqual",doesnotendwith:"notEqual",doesnotcontain:"notEqual",doesnotmatch:"notEqual"}[e.operator.toLowerCase()]},E.customValue=function(e){function t(e){return e.replace(/([*?])/g,"~$1")}switch(e.operator.toLowerCase()){case"startswith":case"doesnotstartwith":return t(e.value)+"*";case"endswith":case"doesnotendwith":return"*"+t(e.value);case"contains":case"doesnotcontain":return"*"+t(e.value)+"*";default:return e.value}},E.dynamicFilterType=function(e){return{quarter1:"Q1",quarter2:"Q2",quarter3:"Q3",quarter4:"Q4",january:"M1",february:"M2",march:"M3",april:"M4",may:"M5",june:"M6",july:"M7",august:"M8",september:"M9",october:"M10",november:"M11",december:"M12"}[e.toLowerCase()]||e},kendo.deepExtend(kendo.ooxml,{IntlService:z,Workbook:ne,Worksheet:Z})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("ooxml/main.min",["kendo.core.min","ooxml/kendo-ooxml.min"],e)}(function(){!function(e){var t=kendo.ooxml.Workbook;kendo.ooxml.IntlService.register({toString:kendo.toString}),kendo.ooxml.Workbook=t.extend({toDataURL:function(){var e=t.fn.toDataURL.call(this);if("string"!=typeof e)throw Error("The toDataURL method can be used only with jsZip 2. Either include jsZip 2 or use the toDataURLAsync method.");return e},toDataURLAsync:function(){var n=e.Deferred(),i=t.fn.toDataURL.call(this);return"string"==typeof i?i=n.resolve(i):i&&i.then&&i.then(function(e){n.resolve(e)},function(){n.reject()}),n.promise()}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.ooxml.min",["ooxml/main.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("excel/kendo-excel.min",["kendo.core.min"],e)}(function(){!function(e){function t(e){return e.title+": "+e.value}function n(e,t){var n,i=[];for(n=0;n<e;n++)i.push(t(n));return i}var i,o,r,s,a;window.kendo.excel=window.kendo.excel||{},i=kendo.getter,o=e.map,r={compile:function(e){return e}},s=kendo.Class.extend({}),s.register=function(e){r=e},s.compile=function(e){return r.compile(e)},a=kendo.Class.extend({init:function(e){e.columns=this._trimColumns(e.columns||[]),this.allColumns=o(this._leafColumns(e.columns||[]),this._prepareColumn),this.columns=this.allColumns.filter(function(e){return!e.hidden}),this.options=e,this.data=e.data||[],this.aggregates=e.aggregates||{},this.groups=[].concat(e.groups||[]),this.hierarchy=e.hierarchy},workbook:function(){var e={sheets:[{columns:this._columns(),rows:this.hierarchy?this._hierachyRows():this._rows(),freezePane:this._freezePane(),filter:this._filter()}]};return e},_trimColumns:function(e){var t=this;return e.filter(function(e){var n=!!e.field;return!n&&e.columns&&(n=t._trimColumns(e.columns).length>0),n})},_leafColumns:function(e){var t,n=this,i=[];for(t=0;t<e.length;t++)e[t].columns?i=i.concat(n._leafColumns(e[t].columns)):i.push(e[t]);return i},_prepareColumn:function(n){var o,r;return n.field?(o=function(e){return i(n.field)(e)},r=null,n.values&&(r={},n.values.forEach(function(e){r[e.value]=e.text}),o=function(e){return r[i(n.field)(e)]}),e.extend({},n,{value:o,values:r,groupHeaderTemplate:n.groupHeaderTemplate?s.compile(n.groupHeaderTemplate):t,groupFooterTemplate:n.groupFooterTemplate?s.compile(n.groupFooterTemplate):null,footerTemplate:n.footerTemplate?s.compile(n.footerTemplate):null})):null},_filter:function(){if(!this.options.filterable)return null;var e=this._depth();return{from:e,to:e+this.columns.length-1}},_createPaddingCells:function(t){var i=this;return n(t,function(){return e.extend({background:"#dfdfdf",color:"#333"},i.options.paddingCellOptions)})},_dataRow:function(t,n,i){var o,r,s,a,l,c,d,u,h=this,f=this._createPaddingCells(n);if(i&&t.items)return o=this.allColumns.filter(function(e){return e.field===t.field})[0],r=o&&o.title?o.title:t.field,s=o?o.groupHeaderTemplate:null,a=e.extend({title:r,field:t.field,value:o&&o.values?o.values[t.value]:t.value,aggregates:t.aggregates,items:t.items},t.aggregates[t.field]),l=r+": "+t.value,s&&(l=s(a)),f.push(e.extend({value:l,background:"#dfdfdf",color:"#333",colSpan:this.columns.length+i-n},(o||{}).groupHeaderCellOptions)),c=this._dataRows(t.items,n+1),c.unshift({type:"group-header",cells:f}),c.concat(this._footer(t));for(d=[],u=0;u<this.columns.length;u++)d[u]=h._cell(t,h.columns[u]);return this.hierarchy&&(d[0].colSpan=i-n+1),[{type:"data",cells:f.concat(d)}]},_dataRows:function(e,t){var n,i=this,o=this._depth(),r=[];for(n=0;n<e.length;n++)r.push.apply(r,i._dataRow(e[n],t,o));return r},_hierachyRows:function(){var e,t,n,i,o,r=this,s=this._depth(),a=this.data,l=this.hierarchy.itemLevel,c=this._hasFooterTemplate(),d=[],u=[],h=0;for(t=0;t<a.length;t++)n=a[t],i=l(n),c&&(i>h?u.push({id:e,level:h}):i<h&&d.push.apply(d,r._hierarchyFooterRows(u,i,s)),h=i,e=n.id),d.push.apply(d,r._dataRow(n,i+1,s));return c&&(d.push.apply(d,this._hierarchyFooterRows(u,0,s)),o=a.length?this.aggregates[a[0].parentId]:{},d.push(this._hierarchyFooter(o,0,s))),this._prependHeaderRows(d),d},_hierarchyFooterRows:function(e,t,n){for(var i,o=this,r=[];e.length&&e[e.length-1].level>=t;)i=e.pop(),r.push(o._hierarchyFooter(o.aggregates[i.id],i.level+1,n));return r},_hasFooterTemplate:function(){var e,t=this.columns;for(e=0;e<t.length;e++)if(t[e].footerTemplate)return!0},_hierarchyFooter:function(t,n,i){var o=this.columns.map(function(o,r){var s=r?1:i-n+1;return o.footerTemplate?e.extend({background:"#dfdfdf",color:"#333",colSpan:s,value:o.footerTemplate(e.extend({},(t||{})[o.field]))},o.footerCellOptions):e.extend({background:"#dfdfdf",color:"#333",colSpan:s},o.footerCellOptions)});return{type:"footer",cells:this._createPaddingCells(n).concat(o)}},_footer:function(t){var n=this,i=[],o=!1,r=this.columns.map(function(i){if(i.groupFooterTemplate){var r=e.extend({},n.aggregates,t.aggregates,t.aggregates[i.field],{group:{items:t.items,field:t.field,value:t.value}});return r[t.field]=r,o=!0,e.extend({background:"#dfdfdf",color:"#333",value:i.groupFooterTemplate(r)},i.groupFooterCellOptions)}return e.extend({background:"#dfdfdf",color:"#333"},i.groupFooterCellOptions)});return o&&i.push({type:"group-footer",cells:this._createPaddingCells(this.groups.length).concat(r)}),i},_isColumnVisible:function(e){return this._visibleColumns([e]).length>0&&(e.field||e.columns)},_visibleColumns:function(e){var t=this;return e.filter(function(e){var n=!e.hidden;return n&&e.columns&&(n=t._visibleColumns(e.columns).length>0),n})},_headerRow:function(t,i){var o=this,r=t.cells.map(function(n){return e.extend(n,{colSpan:n.colSpan>1?n.colSpan:1,rowSpan:t.rowSpan>1&&!n.colSpan?t.rowSpan:1})});return this.hierarchy&&(r[0].colSpan=this._depth()+1),{type:"header",cells:n(i.length,function(){return e.extend({background:"#7a7a7a",color:"#fff"},o.options.headerPaddingCellOptions)}).concat(r)}},_prependHeaderRows:function(e){var t,n=this,i=this.groups,o=[{rowSpan:1,cells:[],index:0}];for(this._prepareHeaderRows(o,this.options.columns),t=o.length-1;t>=0;t--)e.unshift(n._headerRow(o[t],i))},_prepareHeaderRows:function(t,n,i,o){var r,s,a,l=this,c=o||t[t.length-1],d=t[c.index+1],u=0;for(r=0;r<n.length;r++)s=n[r],l._isColumnVisible(s)&&(a=e.extend({background:"#7a7a7a",color:"#fff",value:s.title||s.field,colSpan:0},s.headerCellOptions),c.cells.push(a),s.columns&&s.columns.length&&(d||(d={rowSpan:0,cells:[],index:t.length},t.push(d)),a.colSpan=l._trimColumns(l._visibleColumns(s.columns)).length,l._prepareHeaderRows(t,s.columns,a,d),u+=a.colSpan-1,c.rowSpan=t.length-c.index));i&&(i.colSpan+=u)},_rows:function(){var t,n,i=this,o=this._dataRows(this.data,0);return this.columns.length&&(this._prependHeaderRows(o),t=!1,n=this.columns.map(function(n){return n.footerTemplate?(t=!0,e.extend({background:"#dfdfdf",color:"#333",value:n.footerTemplate(e.extend({},i.aggregates,i.aggregates[n.field]))},n.footerCellOptions)):e.extend({background:"#dfdfdf",color:"#333"},n.footerCellOptions)}),t&&o.push({type:"footer",cells:this._createPaddingCells(this.groups.length).concat(n)})),o},_headerDepth:function(e){var t,n,i=this,o=1,r=0;for(t=0;t<e.length;t++)e[t].columns&&(n=i._headerDepth(e[t].columns),n>r&&(r=n));return o+r},_freezePane:function(){var e=this._visibleColumns(this.options.columns||[]),t=this._visibleColumns(this._trimColumns(this._leafColumns(e.filter(function(e){return e.locked})))).length;return{rowSplit:this._headerDepth(e),colSplit:t?t+this.groups.length:0}},_cell:function(t,n){return e.extend({value:n.value(t)},n.cellOptions)},_depth:function(){var e=0;return e=this.hierarchy?this.hierarchy.depth:this.groups.length},_columns:function(){var e=this._depth(),t=n(e,function(){return{width:20}});return t.concat(this.columns.map(function(e){return{width:parseInt(e.width,10),autoWidth:!e.width}}))}}),kendo.deepExtend(kendo.excel,{ExcelExporter:a,TemplateService:s})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("excel/main.min",["kendo.core.min","kendo.data.min","excel/kendo-excel.min"],e)}(function(){return function(e,t){var n=t.excel.ExcelExporter,i=e.extend;t.excel.TemplateService.register({compile:t.template}),t.ExcelExporter=t.Class.extend({init:function(e){var n,o,r;this.options=e,n=e.dataSource,n instanceof t.data.DataSource?(this.dataSource=new n.constructor(i({},n.options,{page:e.allPages?0:n.page(),filter:n.filter(),pageSize:e.allPages?n.total():n.pageSize(),sort:n.sort(),group:n.group(),aggregate:n.aggregate()})),o=n.data(),o.length>0&&(this.dataSource._data=o,r=this.dataSource.transport,n._isServerGrouped()&&r.options&&r.options.data&&(r.options.data=null))):this.dataSource=t.data.DataSource.create(n)},_hierarchy:function(){var e,t,n,i,o=this.options.hierarchy,r=this.dataSource;if(o&&r.level){for(o={itemLevel:function(e){return r.level(e)}},e=r.view(),t=0,i=0;i<e.length;i++)n=r.level(e[i]),n>t&&(t=n);o.depth=t+1}else o=!1;return{hierarchy:o}},workbook:function(){return e.Deferred(e.proxy(function(t){this.dataSource.fetch().then(e.proxy(function(){var e=new n(i({},this.options,this._hierarchy(),{data:this.dataSource.view(),groups:this.dataSource.group(),aggregates:this.dataSource.aggregates()})).workbook();t.resolve(e,this.dataSource.view())},this))},this)).promise()}})}(kendo.jQuery,kendo),kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("excel/mixins.min",["excel/main.min","kendo.ooxml.min"],e)}(function(){return function(e,t){t.ExcelMixin={extend:function(t){t.events.push("excelExport"),t.options.excel=e.extend(t.options.excel,this.options),t.saveAsExcel=this.saveAsExcel},options:{proxyURL:"",allPages:!1,filterable:!1,fileName:"Export.xlsx"},saveAsExcel:function(){var n=this.options.excel||{},i=new t.ExcelExporter({columns:this.columns,dataSource:this.dataSource,allPages:n.allPages,filterable:n.filterable,hierarchy:n.hierarchy});i.workbook().then(e.proxy(function(e,i){if(!this.trigger("excelExport",{workbook:e,data:i})){var o=new t.ooxml.Workbook(e);o.toDataURLAsync().then(function(i){t.saveAs({dataURI:i,fileName:e.fileName||n.fileName,proxyURL:n.proxyURL,forceProxy:n.forceProxy})})}},this))}}}(kendo.jQuery,kendo),kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.excel.min",["excel/main.min","excel/mixins.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.data.signalr.min",["kendo.data.min"],e)}(function(){return function(e){var t=kendo.data.RemoteTransport.extend({init:function(e){var t,n=e&&e.signalr?e.signalr:{},i=n.promise;if(!i)throw Error('The "promise" option must be set.');if("function"!=typeof i.done||"function"!=typeof i.fail)throw Error('The "promise" option must be a Promise.');if(this.promise=i,t=n.hub,!t)throw Error('The "hub" option must be set.');if("function"!=typeof t.on||"function"!=typeof t.invoke)throw Error('The "hub" option is not a valid SignalR hub proxy.');this.hub=t,kendo.data.RemoteTransport.fn.init.call(this,e)},push:function(e){var t=this.options.signalr.client||{};t.create&&this.hub.on(t.create,e.pushCreate),t.update&&this.hub.on(t.update,e.pushUpdate),t.destroy&&this.hub.on(t.destroy,e.pushDestroy)},_crud:function(t,n){var i,o,r=this.hub,s=this.options.signalr.server;if(!s||!s[n])throw Error(kendo.format('The "server.{0}" option must be set.',n));i=[s[n]],o=this.parameterMap(t.data,n),e.isEmptyObject(o)||i.push(o),this.promise.done(function(){r.invoke.apply(r,i).done(t.success).fail(t.error)})},read:function(e){this._crud(e,"read")},create:function(e){this._crud(e,"create")},update:function(e){this._crud(e,"update")},destroy:function(e){this._crud(e,"destroy")}});e.extend(!0,kendo.data,{transports:{signalr:t}})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("drawing/util.min",["kendo.core.min"],e)}(function(){return function(e){function t(){return e.Deferred()}function n(t){return e.when.apply(e,t)}kendo.drawing.util=kendo.drawing.util||{},kendo.deepExtend(kendo.drawing.util,{createPromise:t,promiseAll:n})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.color.min",["kendo.core.min"],e)}(function(){function e(e,t,n){void 0===n&&(n="0");for(var i=e.toString(16);t>i.length;)i=n+i;return i}function t(e,t,n){var i=n;return i<0&&(i+=1),i>1&&(i-=1),i<1/6?e+6*(t-e)*i:i<.5?t:i<2/3?e+(t-e)*(2/3-i)*6:e}function n(e,t){var i,o,s;if(null==e||"none"===e)return null;if(e instanceof l)return e;if(s=e.toLowerCase(),i=a(s))return s="transparent"===i[1]?new c(1,1,1,0):n(r[i[1]],t),s.match=[i[1]],s;if((i=/^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(s))?o=new d(parseInt(i[1],16),parseInt(i[2],16),parseInt(i[3],16),1):(i=/^#?([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(s))?o=new d(parseInt(i[1]+i[1],16),parseInt(i[2]+i[2],16),parseInt(i[3]+i[3],16),1):(i=/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/.exec(s))?o=new d(parseInt(i[1],10),parseInt(i[2],10),parseInt(i[3],10),1):(i=/^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)/.exec(s))?o=new d(parseInt(i[1],10),parseInt(i[2],10),parseInt(i[3],10),parseFloat(i[4])):(i=/^rgb\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*\)/.exec(s))?o=new c(parseFloat(i[1])/100,parseFloat(i[2])/100,parseFloat(i[3])/100,1):(i=/^rgba\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9.]+)\s*\)/.exec(s))&&(o=new c(parseFloat(i[1])/100,parseFloat(i[2])/100,parseFloat(i[3])/100,parseFloat(i[4]))),o)o.match=i;else if(!t)throw Error("Cannot parse color: "+s);return o}var i,o,r,s,a,l,c,d,u,h,f;window.kendo=window.kendo||{},i=kendo.Class,o=kendo.support,r={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgrey:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",grey:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"778899",lightslategrey:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"},s=o.browser,a=function(e){var t,n=Object.keys(r);return n.push("transparent"),t=RegExp("^("+n.join("|")+")(\\W|$)","i"),a=function(e){return t.exec(e)},t.exec(e)},l=i.extend({init:function(){},toHSV:function(){return this},toRGB:function(){return this},toHex:function(){return this.toBytes().toHex()},toBytes:function(){return this},toCss:function(){return"#"+this.toHex()},toCssRgba:function(){var e=this.toBytes();return"rgba("+e.r+", "+e.g+", "+e.b+", "+parseFloat((+this.a).toFixed(3))+")"},toDisplay:function(){return s.msie&&s.version<9?this.toCss():this.toCssRgba()},equals:function(e){return e===this||null!==e&&this.toCssRgba()===n(e).toCssRgba()},diff:function(e){var t,n;return null===e?NaN:(t=this.toBytes(),n=e.toBytes(),Math.sqrt(Math.pow(.3*(t.r-n.r),2)+Math.pow(.59*(t.g-n.g),2)+Math.pow(.11*(t.b-n.b),2)))},clone:function(){var e=this.toBytes();return e===this&&(e=new d(e.r,e.g,e.b,e.a)),e}}),c=l.extend({init:function(e,t,n,i){l.fn.init.call(this),this.r=e,this.g=t,this.b=n,this.a=i},toHSV:function(){var e,t,n=this,i=n.r,o=n.g,r=n.b,s=Math.min(i,o,r),a=Math.max(i,o,r),l=a-s,c=a;return 0===l?new u(0,0,c,this.a):(0!==a?(t=l/a,e=i===a?(o-r)/l:o===a?2+(r-i)/l:4+(i-o)/l,e*=60,e<0&&(e+=360)):(t=0,e=-1),new u(e,t,c,this.a))},toHSL:function(){var e,t,n,i=this,o=i.r,r=i.g,s=i.b,a=Math.max(o,r,s),l=Math.min(o,r,s),c=(a+l)/2;if(a===l)e=t=0;else{switch(n=a-l,t=c>.5?n/(2-a-l):n/(a+l),a){case o:e=(r-s)/n+(r<s?6:0);break;case r:e=(s-o)/n+2;break;case s:e=(o-r)/n+4}e*=60,t*=100,c*=100}return new h(e,t,c,this.a)},toBytes:function(){return new d(255*this.r,255*this.g,255*this.b,this.a)}}),d=c.extend({init:function(e,t,n,i){c.fn.init.call(this,Math.round(e),Math.round(t),Math.round(n),i)},toRGB:function(){return new c(this.r/255,this.g/255,this.b/255,this.a)},toHSV:function(){return this.toRGB().toHSV()},toHSL:function(){return this.toRGB().toHSL()},toHex:function(){return e(this.r,2)+e(this.g,2)+e(this.b,2)},toBytes:function(){return this}}),u=l.extend({init:function(e,t,n,i){l.fn.init.call(this),this.h=e,this.s=t,this.v=n,this.a=i},toRGB:function(){var e,t,n,i,o,r,s,a,l=this,d=l.h,u=l.s,h=l.v;if(0===u)e=t=n=h;else switch(d/=60,i=Math.floor(d),o=d-i,r=h*(1-u),s=h*(1-u*o),a=h*(1-u*(1-o)),i){case 0:e=h,t=a,n=r;break;case 1:e=s,t=h,n=r;break;case 2:e=r,t=h,n=a;break;case 3:e=r,t=s,n=h;break;case 4:e=a,t=r,n=h;break;default:e=h,t=r,n=s}return new c(e,t,n,this.a)},toHSL:function(){return this.toRGB().toHSL()},toBytes:function(){return this.toRGB().toBytes()}}),h=l.extend({init:function(e,t,n,i){l.fn.init.call(this),this.h=e,this.s=t,this.l=n,this.a=i},toRGB:function(){var e,n,i,o,r,s=this,a=s.h,l=s.s,d=s.l;return 0===l?e=n=i=d:(a/=360,l/=100,d/=100,o=d<.5?d*(1+l):d+l-d*l,r=2*d-o,e=t(r,o,a+1/3),n=t(r,o,a),i=t(r,o,a-1/3)),new c(e,n,i,this.a)},toHSV:function(){return this.toRGB().toHSV()},toBytes:function(){return this.toRGB().toBytes()}}),f=i.extend({init:function(e){var t,n,i,o,r,s,a,l=this;if(1===arguments.length)for(t=f.formats,n=this.resolveColor(e),i=0;i<t.length;i++)o=t[i].re,r=t[i].process,s=o.exec(n),s&&(a=r(s),l.r=a[0],l.g=a[1],l.b=a[2]);else this.r=arguments[0],this.g=arguments[1],this.b=arguments[2];this.r=this.normalizeByte(this.r),this.g=this.normalizeByte(this.g),this.b=this.normalizeByte(this.b)},toHex:function(){var e=this.padDigit,t=this.r.toString(16),n=this.g.toString(16),i=this.b.toString(16);return"#"+e(t)+e(n)+e(i)},resolveColor:function(e){var t=e||"black";return"#"===t.charAt(0)&&(t=t.substr(1,6)),t=t.replace(/ /g,""),t=t.toLowerCase(),t=f.namedColors[t]||t},normalizeByte:function(e){return e<0||isNaN(e)?0:e>255?255:e},padDigit:function(e){return 1===e.length?"0"+e:e},brightness:function(e){var t=Math.round;return this.r=t(this.normalizeByte(this.r*e)),this.g=t(this.normalizeByte(this.g*e)),this.b=t(this.normalizeByte(this.b*e)),this},percBrightness:function(){return Math.sqrt(.241*this.r*this.r+.691*this.g*this.g+.068*this.b*this.b)}}),f.fromBytes=function(e,t,n,i){return new d(e,t,n,null!=i?i:1)},f.fromRGB=function(e,t,n,i){return new c(e,t,n,null!=i?i:1)},f.fromHSV=function(e,t,n,i){return new u(e,t,n,null!=i?i:1)},f.fromHSL=function(e,t,n,i){return new h(e,t,n,null!=i?i:1)},f.formats=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,process:function(e){return[parseInt(e[1],10),parseInt(e[2],10),parseInt(e[3],10)]}},{re:/^(\w{2})(\w{2})(\w{2})$/,process:function(e){return[parseInt(e[1],16),parseInt(e[2],16),parseInt(e[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,process:function(e){return[parseInt(e[1]+e[1],16),parseInt(e[2]+e[2],16),parseInt(e[3]+e[3],16)]}}],f.namedColors=r,kendo.deepExtend(kendo,{parseColor:n,Color:f})},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("util/text-metrics.min",["kendo.core.min"],e)}(function(){!function(e){function t(e){return(e+"").replace(a,l)}function n(e){var t,n=[];for(t in e)n.push(t+e[t]);return n.sort().join("")}function i(e){var t,n=2166136261;for(t=0;t<e.length;++t)n+=(n<<1)+(n<<4)+(n<<7)+(n<<8)+(n<<24),n^=e.charCodeAt(t);return n>>>0}function o(){return{width:0,height:0,baseline:0}}function r(e,t,n){return u.current.measure(e,t,n)}var s,a,l,c,d,u;window.kendo.util=window.kendo.util||{},s=kendo.Class.extend({init:function(e){this._size=e,this._length=0,this._map={}},put:function(e,t){var n=this._map,i={key:e,value:t};n[e]=i,this._head?(this._tail.newer=i,i.older=this._tail,this._tail=i):this._head=this._tail=i,this._length>=this._size?(n[this._head.key]=null,this._head=this._head.newer,this._head.older=null):this._length++},get:function(e){var t=this._map[e];if(t)return t===this._head&&t!==this._tail&&(this._head=t.newer,this._head.older=null),t!==this._tail&&(t.older&&(t.older.newer=t.newer,t.newer.older=t.older),t.older=this._tail,t.newer=null,this._tail.newer=t,this._tail=t),t.value}}),a=/\r?\n|\r|\t/g,l=" ",c={baselineMarkerSize:1},"undefined"!=typeof document&&(d=document.createElement("div"),d.style.cssText="position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;"),u=kendo.Class.extend({init:function(t){this._cache=new s(1e3),this.options=e.extend({},c,t)},measure:function(e,r,s){var a,l,c,u,h,f,p,m,g;if(void 0===s&&(s={}),!e)return o();if(a=n(r),l=i(e+a),c=this._cache.get(l))return c;u=o(),h=s.box||d,f=this._baselineMarker().cloneNode(!1);for(p in r)m=r[p],void 0!==m&&(h.style[p]=m);return g=s.normalizeText!==!1?t(e):e+"",h.textContent=g,h.appendChild(f),document.body.appendChild(h),g.length&&(u.width=h.offsetWidth-this.options.baselineMarkerSize,u.height=h.offsetHeight,u.baseline=f.offsetTop+this.options.baselineMarkerSize),u.width>0&&u.height>0&&this._cache.put(l,u),h.parentNode.removeChild(h),u},_baselineMarker:function(){var e=document.createElement("div");return e.style.cssText="display: inline-block; vertical-align: baseline;width: "+this.options.baselineMarkerSize+"px; height: "+this.options.baselineMarkerSize+"px;overflow: hidden;",e}}),u.current=new u,kendo.deepExtend(kendo.util,{LRUCache:s,TextMetrics:u,measureText:r,objectKey:n,hashKey:i,normalizeText:t})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("drawing/kendo-drawing.min",["drawing/util.min","kendo.color.min","util/text-metrics.min"],e)}(function(){!function(e){function t(e,t){return e.push.apply(e,t),e}function n(e){for(var t=[1e3,900,800,700,600,500,400,300,200,100,90,80,70,60,50,40,30,20,10,9,8,7,6,5,4,3,2,1],n="";e>0;)e<t[0]?t.shift():(n+=Xt[t[0]],e-=t[0]);return n}function i(e){return typeof e!==Zt}function o(){return"kdef"+Jt++}function r(e){return e/en}function s(e){var t,n,i="";for(t=0;t<e.length;t++)n=e.charCodeAt(t),n<128?i+=rn(n):n<2048?(i+=rn(192|n>>>6),i+=rn(128|63&n)):n<65536&&(i+=rn(224|n>>>12),i+=rn(128|n>>>6&63),i+=rn(128|63&n));return i}function a(e){for(var t,n,i,o,r,a,l,c="",d=0,u=s(e);d<u.length;)t=u.charCodeAt(d++),n=u.charCodeAt(d++),i=u.charCodeAt(d++),o=t>>2,r=(3&t)<<4|n>>4,a=(15&n)<<2|i>>6,l=63&i,isNaN(n)?a=l=64:isNaN(i)&&(l=64),c=c+on.charAt(o)+on.charAt(r)+on.charAt(a)+on.charAt(l);return c}function l(e){return i((e.x||{}).location)?{x:e.x.location,y:e.y.location}:{x:e.pageX||e.clientX||0,y:e.pageY||e.clientY||0}}function c(e){return void 0===e&&(e={}),e.touch?e.touch.initialTouch:e.target}function d(e){return""===e||null===e||"none"===e||"transparent"===e||!i(e)}function u(e){if(e)return e[e.length-1]}function h(e,t,n){return Math.max(Math.min(e,n),t)}function f(e,t){function n(e,n){for(var i=[],o=0,r=0,s=0;o<e.length&&r<n.length;)t(e[o],n[r])<=0?i[s++]=e[o++]:i[s++]=n[r++];return o<e.length&&i.push.apply(i,e.slice(o)),r<n.length&&i.push.apply(i,n.slice(r)),i}return e.length<2?e.slice():function i(e){var t,o,r;return e.length<=1?e:(t=Math.floor(e.length/2),o=e.slice(0,t),r=e.slice(t),o=i(o),r=i(r),n(o,r))}(e)}function p(e){return e*en}function m(e){return e?Math.pow(10,e):1}function g(e,t){var n=m(t);return Math.round(e*n)/n}function v(e,t){return i(e)?e:t}function _(e,t){var n,i,o;for(n in t)for(i=n.trim().split(" "),o=0;o<i.length;o++)e.addEventListener(i[o],t[n],!1)}function b(e){var t=e.getBoundingClientRect(),n=document.documentElement;return{top:t.top+(window.pageYOffset||n.scrollTop)-(n.clientTop||0),left:t.left+(window.pageXOffset||n.scrollLeft)-(n.clientLeft||0)}}function w(e,t){var n,i,o={},r=window.getComputedStyle(e),s=Array.isArray(t)?t:[t];for(n=0;n<s.length;n++)i=s[n],o[i]=r[i];return o}function y(e){return isNaN(e)?e:e+"px"}function k(e,t){var n,o,r;return t?(n=t.width,o=t.height,i(n)&&(e.style.width=y(n)),i(o)&&(e.style.height=y(o)),void 0):(r=w(e,["width","height"]),{width:parseInt(r.width,10),height:parseInt(r.height,10)})}function x(e,t){var n,i,o;void 0===t&&(t={});for(n in t)for(i=n.trim().split(" "),o=0;o<i.length;o++)e.removeEventListener(i[o],t[n],!1)}function C(e){return function(t){return this[e]!==t&&(this[e]=t,this.geometryChange()),this}}function S(e){return function(){return this[e]}}function T(e,t){var n,i,o;for(n=0;n<t.length;n++)i=t[n],o=i.charAt(0).toUpperCase()+i.substring(1,i.length),e["set"+o]=C(i),e["get"+o]=S(i)}function D(e){return e&&"function"==typeof e.matrix?e.matrix():e}function A(e){return null===e?null:e instanceof fn?e:new fn(e)}function E(e,t,n,i){var o=0,r=0;return i&&(o=Math.atan2(i.c*n,i.a*t),0!==i.b&&(r=Math.atan2(i.d*n,i.b*t))),{x:o,y:r}}function I(e){var t="_"+e;return function(e){return i(e)?(this._observerField(t,e),this.geometryChange(),this):this[t]}}function M(e,t){for(var n=0;n<t.length;n++)e[t[n]]=I(t[n])}function R(e,t,n){return void 0===n&&(n=xn),0===g(Math.abs(e-t),n)}function F(e,t,n){return e<t||R(e,t,n)}function z(e,t,n,i){var o=t.x-e.x,r=i.x-n.x,s=t.y-e.y,a=i.y-n.y,l=e.x-n.x,c=e.y-n.y,d=o*a-r*s,u=(o*c-s*l)/d,h=(r*c-a*l)/d;if(u>=0&&u<=1&&h>=0&&h<=1)return new dn(e.x+h*o,e.y+h*s)}function P(e,t,n,i,o,s){var a=g((o-e)/n,3),l=g((s-t)/i,3);return g(r(Math.atan2(l,a)))}function B(e){var t,n,i,o,s,a,l,c,d,u,h,f,m,v,_,b,w,y,k,x,C,S,T,D,A,E=e.x1,I=e.y1,M=e.x2,R=e.y2,F=e.rx,z=e.ry,P=e.largeArc,B=e.swipe,L=e.rotation;return void 0===L&&(L=0),t=p(L),n=Math.cos(t),i=Math.sin(t),o=n*(E-M)/2+i*(I-R)/2,s=-i*(E-M)/2+n*(I-R)/2,a=P!==B?1:-1,l=Math.pow(o,2),c=Math.pow(s,2),d=Math.pow(F,2),u=Math.pow(z,2),h=l/d+c/u,h>1&&(h=Math.sqrt(l/d+c/u),F=h*F,d=Math.pow(F,2),z=h*z,u=Math.pow(z,2)),f=a*Math.sqrt((d*u-d*c-u*l)/(d*c+u*l)),isNaN(f)&&(f=0),m=f*(F*s)/z,v=-f*(z*o)/F,_=n*m-i*v+(E+M)/2,b=i*m+n*v+(I+R)/2,w=(o-m)/F,y=(s-v)/z,k=-(o+m)/F,x=-(s+v)/z,C=(y>=0?1:-1)*r(Math.acos(w/Math.sqrt(w*w+y*y))),S=g((w*k+y*x)/(Math.sqrt(w*w+y*y)*Math.sqrt(k*k+x*x)),10),T=(w*x-y*k>=0?1:-1)*r(Math.acos(S)),!B&&T>0&&(T-=360),B&&T<0&&(T+=360),D=C+T,A=D>=0?1:-1,D=Math.abs(D)%360*A,{center:new dn(_,b),startAngle:C,endAngle:D,radiusX:F,radiusY:z,xRotation:L}}function L(e,t){for(var n=e;n<t;)n+=90;return n}function H(e){var t="_"+e;return function(e){return i(e)?(this._observerField(t,dn.create(e)),this.geometryChange(),this):this[t]}}function N(e,t){for(var n=0;n<t.length;n++)e[t[n]]=H(t[n])}function O(e,t,n){var i=r(Math.atan2(t.y-e.y,t.x-e.x)),o=n.transformCopy(A().rotate(-i,e));return o.x<e.x}function V(e,t,n){var i=1-e;return Math.pow(i,3)*n[0][t]+3*Math.pow(i,2)*e*n[1][t]+3*Math.pow(e,2)*i*n[2][t]+Math.pow(e,3)*n[3][t]}function U(e,t){return[-e[0][t]+3*e[1][t]-3*e[2][t]+e[3][t],3*(e[0][t]-2*e[1][t]+e[2][t]),3*(-e[0][t]+e[1][t]),e[0][t]]}function W(e){return e<0?-1:1}function j(e,t,n){var i=Math.sqrt(Math.pow(t,2)-4*e*n);return[(-t+i)/(2*e),(-t-i)/(2*e)]}function q(e,t,n,i){var o,r,s,a,l,c,d,u,h,f,p,m,v;return 0===e?j(t,n,i):(o=(3*e*n-Math.pow(t,2))/(3*Math.pow(e,2)),r=(2*Math.pow(t,3)-9*e*t*n+27*Math.pow(e,2)*i)/(27*Math.pow(e,3)),s=Math.pow(o/3,3)+Math.pow(r/2,2),a=new Pn(0,1),l=-t/(3*e),s<0?(c=new Pn(-r/2,Math.sqrt(-s)).nthRoot(3),d=new Pn(-r/2,(-Math.sqrt(-s))).nthRoot(3)):(c=-r/2+Math.sqrt(s),c=new Pn(W(c)*Math.pow(Math.abs(c),1/3)),d=-r/2-Math.sqrt(s),d=new Pn(W(d)*Math.pow(Math.abs(d),1/3))),u=c.add(d),p=c.add(d).multiplyConstant(-.5),m=c.add(d.negate()).multiplyConstant(Math.sqrt(3)/2),h=p.add(a.multiply(m)),f=p.add(a.negate().multiply(m)),v=[],u.isReal()&&v.push(g(u.real+l,xn)),h.isReal()&&v.push(g(h.real+l,xn)),f.isReal()&&v.push(g(f.real+l,xn)),v)}function G(e,t,n,i,o){var r,s,a=U(e,i),l=q(a[0],a[1],a[2],a[3]-t[i]);for(s=0;s<l.length;s++)if(0<=l[s]&&l[s]<=1&&(r=V(l[s],n,e),Math.abs(r-t[n])<=o))return!0}function $(e,t,n){var i,o,r,s=U(e,"x"),a=q(s[0],s[1],s[2],s[3]-t.x),l=0;for(r=0;r<a.length;r++)i=V(a[r],"y",e),o=R(i,t.y)||i>t.y,o&&((0===a[r]||1===a[r])&&n.bottomRight().x>t.x||0<a[r]&&a[r]<1)&&l++;return l}function K(e,t,n){var i,o,r,s,a,l;return e.x!==t.x&&(o=Math.min(e.x,t.x),r=Math.max(e.x,t.x),s=Math.min(e.y,t.y),a=Math.max(e.y,t.y),l=o<=n.x&&n.x<r,i=s===a?n.y<=s&&l:l&&(a-s)*((e.x-t.x)*(e.y-t.y)>0?n.x-o:r-n.x)/(r-o)+s-n.y>=0),
i?1:0}function Y(e){var t,n=e.length,i=tn,o=nn;for(t=0;t<n;t++)o=Math.max(o,e[t]),i=Math.min(i,e[t]);return{min:i,max:o}}function Q(e,t,n){var i,o,r,s;for(o=0;o<e.length;o++)r=e[o],r.visible()&&(s=t?r.bbox(n):r.rawBBox(),s&&(i=i?hn.union(i,s):s));return i}function X(e,t){var n,i,o,r;for(i=0;i<e.length;i++)o=e[i],o.visible()&&(r=o.clippedBBox(t),r&&(n=n?hn.union(n,r):r));return n}function Z(e,t,n){var i=n.transform()||A(),o=i.matrix();o.e+=e.x-t.origin.x,o.f+=e.y-t.origin.y,i.matrix(o),n.transform(i)}function J(e,t,n,i,o){var r;return r="start"===n?t.origin[i]:"end"===n?t.origin[i]+t.size[o]-e:t.origin[i]+(t.size[o]-e)/2}function ee(e,t,n,i,o){var r;return r="start"===n?t.origin[i]+t.size[o]-e:"end"===n?t.origin[i]:t.origin[i]+(t.size[o]-e)/2}function te(e,t,n,i,o){var r,s,a;for(r=0;r<e.length;r++)s=e[r].clippedBBox(),s&&(a=s.origin.clone(),a[i]=J(s.size[o],t,n||"start",i,o),Z(a,s,e[r]))}function ne(e,t,n){te(e,t,n,"x","width")}function ie(e,t,n){te(e,t,n,"y","height")}function oe(e,t,n,i){var o,r,s,a,l;if(e.length>1)for(o=new dn,r=e[0].bbox,s=1;s<e.length;s++)a=e[s].element,l=e[s].bbox,o[t]=r.origin[t]+r.size[i],o[n]=l.origin[n],Z(o,l,a),l.origin[t]=o[t],r=l}function re(e){var t,n,i,o=[];for(t=0;t<e.length;t++)n=e[t],i=n.clippedBBox(),i&&o.push({element:n,bbox:i});return o}function se(e){oe(re(e),"x","y","width")}function ae(e){oe(re(e),"y","x","height")}function le(e,t,n){var i,o,r,s,a=t.size[n],l=[],c=[],d=0,u=function(){c.push({element:i,bbox:o})};for(r=0;r<e.length;r++)i=e[r],o=i.clippedBBox(),o&&(s=o.size[n],d+s>a?c.length?(l.push(c),c=[],u(),d=s):(u(),l.push(c),c=[],d=0):(u(),d+=s));return c.length&&l.push(c),l}function ce(e,t,n,i,o){var r,s,a,l,c=le(e,t,o),d=t.origin.clone(),u=[];for(r=0;r<c.length;r++)for(s=c[r],a=s[0],d[i]=a.bbox.origin[i],Z(d,a.bbox,a.element),a.bbox.origin[n]=d[n],oe(s,n,i,o),u.push([]),l=0;l<s.length;l++)u[r].push(s[l].element);return u}function de(e,t){return ce(e,t,"x","y","width")}function ue(e,t){return ce(e,t,"y","x","height")}function he(e,t){var n,i,o,r,s=e.clippedBBox();s&&(n=s.size,i=t.size,(i.width<n.width||i.height<n.height)&&(o=Math.min(i.width/n.width,i.height/n.height),r=e.transform()||A(),r.scale(o,o),e.transform(r)))}function fe(e){return function(t){return i(t)?(this.options.set(e,t),this):this.options.get(e)}}function pe(e,t){for(var n=0;n<t.length;n++)e[t[n]]=fe(t[n])}function me(e){return.5-Math.cos(e*Math.PI)/2}function ge(e){return e}function ve(e,t,n,i){var o=1.70158,r=0,s=i;return 0===e?n:1===e?n+i:(r||(r=.5),s<Math.abs(i)?(s=i,o=r/4):o=r/(2*Math.PI)*Math.asin(i/s),s*Math.pow(2,-10*e)*Math.sin((+e-o)*(1.1*Math.PI)/r)+i+n)}function _e(e,t,n){var i,o=t?0:1;for(i=0;i<e.length;i+=2)e.splice(i+o,0,n)}function be(e,t){if(e&&t)return t.scaleCopy(2).translate(-e.x,-e.y)}function we(e,t,n){var i=t.clone().scale(2/3);return{controlOut:i.clone().translateWith(e.scaleCopy(li)),controlIn:i.translateWith(n.scaleCopy(li))}}function ye(e){var t=[];return e.replace(di,function(e,n){t.push(parseFloat(n))}),t}function ke(e,t){return i(t)&&null!==t?" "+e+"='"+t+"' ":""}function xe(e){var t,n="";for(t=0;t<e.length;t++)n+=ke(e[t][0],e[t][1]);return n}function Ce(e){var t,n,o="";for(t=0;t<e.length;t++)n=e[t][1],i(n)&&(o+=e[t][0]+":"+n+";");if(""!==o)return o}function Se(e,t){return"clip"===e||"fill"===e&&(!t||"Gradient"===t.nodeType)}function Te(){var e=document.getElementsByTagName("base")[0],t=document.location.href,n=t.indexOf("#"),i="";return e&&!$t.msie&&(n!==-1&&(t=t.substring(0,n)),i=t),i}function De(e,t){var n=t?"":Te();return"url("+n+"#"+e+")"}function Ae(e){var t,n,i,o;try{t=e.getScreenCTM?e.getScreenCTM():null}catch(r){}t&&(n=-t.e%1,i=-t.f%1,o=e.style,0===n&&0===i||(o.left=n+"px",o.top=i+"px"))}function Ee(e){if(!e||"string"!=typeof e||!Yi.test(e))return e;var t=Ee._element;return Yi.lastIndex=0,e.replace(Yi,function(e){return t.innerHTML=e,t.textContent||t.innerText})}function Ie(e){var t,n,i,o=new Pi({skipBaseHref:!0}),r=e.clippedBBox(),s=e;return r&&(t=r.getOrigin(),n=new Gn,n.transform(A().translate(-t.x,-t.y)),n.children.push(e),s=n),o.load([s]),i="<?xml version='1.0' ?><svg xmlns='"+bi+"' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>"+o.render()+"</svg>",o.destroy(),i}function Me(e,t){var n,i,o,r,s,a,l=t.segments;if(0!==l.length){for(n=l[0],i=n.anchor(),e.moveTo(i.x,i.y),o=1;o<l.length;o++)n=l[o],i=n.anchor(),r=l[o-1],s=r.controlOut(),a=n.controlIn(),s&&a?e.bezierCurveTo(s.x,s.y,a.x,a.y,i.x,i.y):e.lineTo(i.x,i.y);t.options.closed&&e.closePath()}}function Re(e,t){return e._zIndex<t._zIndex?1:e._zIndex>t._zIndex?-1:0}function Fe(e,t){var n,i,o;for(n=0;n<t.length;n++)i=t[n],o=kendo.parseColor(i.color()),o.a*=i.opacity(),e.addColorStop(i.offset(),o.toCssRgba())}function ze(t,n){var i,o,r,s,a,l,c,d,u={width:"800px",height:"600px",cors:"Anonymous"},h=t,f=t.clippedBBox();return f&&(i=f.getOrigin(),h=new Gn,h.transform(A().translate(-i.x,-i.y)),h.children.push(t),o=f.getSize(),u.width=o.width+"px",u.height=o.height+"px"),r=e.extend(u,n),s=document.createElement("div"),a=s.style,a.display="none",a.width=r.width,a.height=r.height,document.body.appendChild(s),l=new fo(s,r),l.suspendTracking(),l.draw(h),c=l.image(),d=function(){l.destroy(),document.body.removeChild(s)},c.then(d,d),c}function Pe(e,t){var n=Ie(e);return t&&t.raw||(n="data:image/svg+xml;base64,"+a(n)),Kt().resolve(n)}function Be(e){return Array.prototype.slice.call(e)}function Le(e,t){e.classList?e.classList.add(t):e.className+=" "+t}function He(e,t){e.classList?e.classList.remove(t):e.className=e.className.split(/\s+/).reduce(function(e,n){return n!=t&&e.push(n),e},[]).join(" ")}function Ne(e,t){Object.keys(t).forEach(function(n){e.style[n]=t[n]})}function Oe(e,t){if(e.closest)return e.closest(t);for(;e&&!/^\[object (?:HTML)?Document\]$/.test(e+"");){if(1==e.nodeType&&Ao(e,t))return e;e=e.parentNode}}function Ve(e){return"number"==typeof e?{x:e,y:e}:Array.isArray(e)?{x:e[0],y:e[1]}:{x:e.x,y:e.y}}function Ue(e,t){function n(e){var n=new Gn,i=e.getBoundingClientRect();return vt(n,[s.x,0,0,s.y,-i.left*s.x,-i.top*s.y]),So._clipbox=!1,So._matrix=cn.unit(),So._stackingContext={element:e,group:n},So._avoidLinks=t.avoidLinks===!0?"a":t.avoidLinks,Le(e,"k-pdf-export"),Ot(e,n),He(e,"k-pdf-export"),n}function i(e){if(null!=e)return"string"==typeof e&&(e=kendo.template(e.replace(/^\s+|\s+$/g,""))),"function"==typeof e?function(t){var n,i=e(t);return i&&"string"==typeof i&&(n=document.createElement("div"),n.innerHTML=i,i=n.firstElementChild),i}:function(){return e.cloneNode(!0)}}function o(e,t,n,o,r,s,a){function l(){("-"!=n||r)&&d(w);var t=f();w.parentNode.insertBefore(t,w),t.appendChild(w),v&&b.forEach(function(e,t){var n=v({element:e,pageNum:t+1,totalPages:b.length});n&&e.appendChild(n)}),Je(b,function(){Ze(b,function(){e({pages:b,container:y})})})}function c(e){if(a.keepTogether&&Ao(e,a.keepTogether)&&e.offsetHeight<=r-k)return!0;var t=e.tagName;return!(/^h[1-6]$/i.test(t)&&e.offsetHeight>=r-k)&&(e.getAttribute("data-kendo-chart")||/^(?:img|tr|thead|th|tfoot|iframe|svg|object|canvas|input|textarea|select|video|h[1-6])/i.test(e.tagName))}function d(e){var t,i,o,s,a,l,u;for("TABLE"==e.tagName&&Ne(e,{tableLayout:"fixed"}),t=st(e),i=parseFloat(at(t,"padding-bottom")),o=parseFloat(at(t,"border-bottom-width")),s=k,k+=i+o,a=!0,l=e.firstChild;l;l=l.nextSibling)if(1==l.nodeType){if(a=!1,Ao(l,n)){h(l);continue}if(!r){d(l);continue}if(!/^(?:static|relative)$/.test(at(st(l),"position")))continue;u=p(l),1==u?h(l):u&&c(l)?h(l):d(l)}else 3==l.nodeType&&r&&(m(l,a),a=!1);k=s}function u(e){var t=e.parentNode,n=t.firstChild;if(e===n)return!0;if(e===t.children[0]){if(7==n.nodeType||8==n.nodeType)return!0;if(3==n.nodeType)return!/\S/.test(n.data)}return!1}function h(e){var t,n,i,o,r,s,l;return 1==e.nodeType&&e!==w&&u(e)?h(e.parentNode):(t=Oe(e,"table"),n=t&&t.querySelector("colgroup"),a.repeatHeaders&&(i=t&&t.querySelector("thead"),o=Oe(e,".k-grid.k-widget"),o&&o.querySelector(".k-auto-scrollable")&&(r=o.querySelector(".k-grid-header"))),s=f(),l=_.createRange(),l.setStartBefore(w),l.setEndBefore(e),s.appendChild(l.extractContents()),w.parentNode.insertBefore(s,w),g(e.parentNode),t&&(t=Oe(e,"table"),a.repeatHeaders&&i&&t.insertBefore(i.cloneNode(!0),t.firstChild),n&&t.insertBefore(n.cloneNode(!0),t.firstChild)),void(a.repeatHeaders&&r&&(o=Oe(e,".k-grid.k-widget"),o.insertBefore(r.cloneNode(!0),o.firstChild))))}function f(){var e=_.createElement("KENDO-PDF-PAGE");return Ne(e,{display:"block",boxSizing:"content-box",width:o?o+"px":"auto",padding:s.top+"px "+s.right+"px "+s.bottom+"px "+s.left+"px",position:"relative",height:r?r+"px":"auto",overflow:r||o?"hidden":"visible",clear:"both"}),a&&a.pageClassName&&(e.className=a.pageClassName),b.push(e),e}function p(e){var t,n,i=e.getBoundingClientRect();return 0===i.width||0===i.height?0:(t=w.getBoundingClientRect().top,n=r-k,i.height>n?3:i.top-t>n?1:i.bottom-t>n?2:0)}function m(e,t){var n,i,o,r,s;/\S/.test(e.data)&&(n=e.data.length,i=_.createRange(),i.selectNodeContents(e),o=p(i),o&&(r=e,1==o?h(t?e.parentNode:e):(!function a(t,n,o){return i.setEnd(e,n),t==n||n==o?n:p(i)?a(t,t+n>>1,n):a(n,n+o>>1,o)}(0,n>>1,n),!/\S/.test(""+i)&&t?h(e.parentNode):(r=e.splitText(i.endOffset),s=f(),i.setStartBefore(w),s.appendChild(i.extractContents()),w.parentNode.insertBefore(s,w),g(r.parentNode))),m(r)))}function g(e){var t=Oe(e,"li");t&&(t.setAttribute("kendo-no-bullet","1"),g(t.parentNode))}var v=i(a.template),_=t.ownerDocument,b=[],w=a._destructive?t:Eo(t),y=_.createElement("KENDO-PDF-DOCUMENT"),k=0;Be(w.querySelectorAll("tfoot")).forEach(function(e){e.parentNode.appendChild(e)}),Be(w.querySelectorAll("ol")).forEach(function(e){Be(e.children).forEach(function(e,t){e.setAttribute("kendo-split-index",t)})}),Ne(y,{display:"block",position:"absolute",boxSizing:"content-box",left:"-10000px",top:"-10000px"}),o&&(Ne(y,{width:o+"px",paddingLeft:s.left+"px",paddingRight:s.right+"px"}),Ne(w,{overflow:"hidden"})),t.parentNode.insertBefore(y,t),y.appendChild(w),a.beforePageBreak?setTimeout(function(){a.beforePageBreak(y,l)},15):setTimeout(l,15)}var r,s;if(t||(t={}),r=Kt(),!e)return r.reject("No element to export");if("function"!=typeof window.getComputedStyle)throw Error("window.getComputedStyle is missing.  You are using an unsupported browser, or running in IE8 compatibility mode.  Drawing HTML is supported in Chrome, Firefox, Safari and IE9+.");return kendo.pdf.defineFont(We(e.ownerDocument)),s=Ve(t.scale||1),Je(e,function(){var i,a=t&&t.forcePageBreak,l=t&&t.paperSize&&"auto"!=t.paperSize,c=kendo.pdf.getPaperOptions(function(e,n){return"paperSize"==e?l?t[e]:"A4":e in t?t[e]:n}),d=l&&c.paperSize[0],u=l&&c.paperSize[1],h=t.margin&&c.margin,f=!!h;a||u?(h||(h={left:0,top:0,right:0,bottom:0}),d&&(d/=s.x),u&&(u/=s.y),h.left/=s.x,h.right/=s.x,h.top/=s.y,h.bottom/=s.y,i=new Gn({pdf:{multiPage:!0,paperSize:l?c.paperSize:"auto",_ignoreMargin:f}}),o(function(e){if(t.progress){var o=!1,s=0;!function a(){if(s<e.pages.length){var l=n(e.pages[s]);i.append(l),t.progress({page:l,pageNum:++s,totalPages:e.pages.length,cancel:function(){o=!0}}),o?e.container.parentNode.removeChild(e.container):setTimeout(a)}else e.container.parentNode.removeChild(e.container),r.resolve(i)}()}else e.pages.forEach(function(e){i.append(n(e))}),e.container.parentNode.removeChild(e.container),r.resolve(i)},e,a,d?d-h.left-h.right:null,u?u-h.top-h.bottom:null,h,t)):r.resolve(n(e))}),r}function We(e){function t(e){if(e){var t=null;try{t=e.cssRules}catch(n){}t&&i(e,t)}}function n(e){var t,n=at(e.style,"src");return n?Mo(n).reduce(function(e,t){var n=Ro(t);return n&&e.push(n),e},[]):(t=Ro(e.cssText),t?[t]:[])}function i(e,i){var r,s,a,l,c,d,u;for(r=0;r<i.length;++r)switch(s=i[r],s.type){case 3:t(s.styleSheet);break;case 5:a=s.style,l=Mo(at(a,"font-family")),c=/^([56789]00|bold)$/i.test(at(a,"font-weight")),d="italic"==at(a,"font-style"),u=n(s),u.length>0&&o(e,l,c,d,u[0])}}function o(e,t,n,i,o){/^data:/i.test(o)||/^[^\/:]+:\/\//.test(o)||/^\//.test(o)||(o=(e.href+"").replace(/[^\/]*$/,"")+o),t.forEach(function(e){e=e.replace(/^(['"]?)(.*?)\1$/,"$2"),n&&(e+="|bold"),i&&(e+="|italic"),r[e]=o})}var r,s;for(null==e&&(e=document),r={},s=0;s<e.styleSheets.length;++s)t(e.styleSheets[s]);return r}function je(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function qe(e){return e="_counter_"+e,So[e]}function Ge(e){var t=[],n=So;for(e="_counter_"+e;n;)je(n,e)&&t.push(n[e]),n=Object.getPrototypeOf(n);return t.reverse()}function $e(e,t){var n=So;for(e="_counter_"+e;n&&!je(n,e);)n=Object.getPrototypeOf(n);n||(n=So._root),n[e]=(n[e]||0)+(null==t?1:t)}function Ke(e,t){e="_counter_"+e,So[e]=null==t?0:t}function Ye(e,t,n){var i,o,r;for(i=0;i<e.length;)o=e[i++],r=parseFloat(e[i]),isNaN(r)?t(o,n):(t(o,r),++i)}function Qe(e){var t,n=at(e,"counter-reset");n&&Ye(Mo(n,/^\s+/),Ke,0),t=at(e,"counter-increment"),t&&Ye(Mo(t,/^\s+/),$e,1)}function Xe(e,t){var n=kendo.parseColor(e,!0);return n&&(n=n.toRGB(),t?n=n.toCssRgba():0===n.a&&(n=null)),n}function Ze(e,t){function n(){--i<=0&&t()}var i=0;e.forEach(function(e){var t,o,r=e.querySelectorAll("img");for(t=0;t<r.length;++t)o=r[t],o.complete||(i++,o.onload=o.onerror=n)}),i||n()}function Je(e,t){function n(e){Co[e]||(Co[e]=!0,s.push(e))}function i(e){/^img$/i.test(e.tagName)&&n(e.src),Io(at(st(e),"background-image")).forEach(function(e){"url"==e.type&&n(e.url)}),e.children&&Be(e.children).forEach(i)}function o(){--r<=0&&t()}var r,s=[];Array.isArray(e)?e.forEach(i):i(e),r=s.length,0===r&&o(),s.forEach(function(e){var t=Co[e]=new window.Image;/^data:/i.test(e)||(t.crossOrigin="Anonymous"),t.src=e,t.complete?o():(t.onload=o,t.onerror=function(){Co[e]=null,o()})})}function et(e){var t,n="";do t=e%26,n=String.fromCharCode(97+t)+n,e=Math.floor(e/26);while(e>0);return n}function tt(e,t,n){var i,o;So=Object.create(So),So[e.tagName.toLowerCase()]={element:e,style:t},i=at(t,"text-decoration"),i&&"none"!=i&&(o=at(t,"color"),i.split(/\s+/g).forEach(function(e){So[e]||(So[e]=o)})),rt(t)&&(So._stackingContext={element:e,group:n})}function nt(){So=Object.getPrototypeOf(So)}function it(e){if(null!=So._clipbox){var t=e.bbox(So._matrix);So._clipbox=So._clipbox?hn.intersect(So._clipbox,t):t}}function ot(){var e=So._clipbox;return null==e||(e?0===e.width()||0===e.height():void 0)}function rt(e){function t(t){return at(e,t)}if("none"!=t("transform")||"static"!=t("position")||"auto"!=t("z-index")||t("opacity")<1)return!0}function st(e,t){return window.getComputedStyle(e,t||null)}function at(e,t,n){var i=e.getPropertyValue(t);return null!=i&&""!==i||(ko.webkit?i=e.getPropertyValue("-webkit-"+t):ko.mozilla?i=e.getPropertyValue("-moz-"+t):ko.opera?i=e.getPropertyValue("-o-"+t):To&&(i=e.getPropertyValue("-ms-"+t))),arguments.length>2&&(null==i||""===i)?n:i}function lt(e,t,n,i){e.setProperty(t,n,i),ko.webkit?e.setProperty("-webkit-"+t,n,i):ko.mozilla?e.setProperty("-moz-"+t,n,i):ko.opera?e.setProperty("-o-"+t,n,i):To&&(e.setProperty("-ms-"+t,n,i),t="ms"+t.replace(/(^|-)([a-z])/g,function(e,t,n){return t+n.toUpperCase()}),e[t]=n)}function ct(e,t){return t="border-"+t,{width:parseFloat(at(e,t+"-width")),style:at(e,t+"-style"),color:Xe(at(e,t+"-color"),!0)}}function dt(e,t){var n=e.style.cssText,i=t();return e.style.cssText=n,i}function ut(e,t){var n=at(e,"border-"+t+"-radius").split(/\s+/g).map(parseFloat);return 1==n.length&&n.push(n[0]),wt({x:n[0],y:n[1]})}function ht(e){var t=e.getBoundingClientRect();return t=ft(t,"border-*-width",e),t=ft(t,"padding-*",e)}function ft(e,t,n){var i,o,r,s,a;return"string"==typeof t?(i=st(n),o=parseFloat(at(i,t.replace("*","top"))),r=parseFloat(at(i,t.replace("*","right"))),s=parseFloat(at(i,t.replace("*","bottom"))),a=parseFloat(at(i,t.replace("*","left")))):"number"==typeof t&&(o=r=s=a=t),{top:e.top+o,right:e.right-r,bottom:e.bottom-s,left:e.left+a,width:e.right-e.left-r-a,height:e.bottom-e.top-s-o}}function pt(e){var t,n,i=at(e,"transform");return"none"==i?null:(t=/^\s*matrix\(\s*(.*?)\s*\)\s*$/.exec(i),t?(n=at(e,"transform-origin"),t=t[1].split(/\s*,\s*/g).map(parseFloat),n=n.split(/\s+/g).map(parseFloat),{matrix:t,origin:n}):void 0)}function mt(e){return 180*e/Math.PI%360}function gt(e){var t=parseFloat(e);return/grad$/.test(e)?Math.PI*t/200:/rad$/.test(e)?t:/turn$/.test(e)?Math.PI*t*2:/deg$/.test(e)?Math.PI*t/180:void 0}function vt(e,t){return t=new cn(t[0],t[1],t[2],t[3],t[4],t[5]),e.transform(t),t}function _t(e,t){e.clip(t)}function bt(e,t,n,i){for(var o=new Tn([t,n],i).curvePoints(),r=1;r<o.length;)e.curveTo(o[r++],o[r++],o[r++])}function wt(e){return(e.x<=0||e.y<=0)&&(e.x=e.y=0),e}function yt(e,t,n,i,o){var r=Math.max(0,t.x),s=Math.max(0,t.y),a=Math.max(0,n.x),l=Math.max(0,n.y),c=Math.max(0,i.x),d=Math.max(0,i.y),u=Math.max(0,o.x),h=Math.max(0,o.y),f=Math.min(e.width/(r+a),e.height/(l+d),e.width/(c+u),e.height/(h+s));return f<1&&(r*=f,s*=f,a*=f,l*=f,c*=f,d*=f,u*=f,h*=f),{tl:{x:r,y:s},tr:{x:a,y:l},br:{x:c,y:d},bl:{x:u,y:h}}}function kt(e,t,n){var i,o,r,s,a,l,c,d,u=st(e),h=ut(u,"top-left"),f=ut(u,"top-right"),p=ut(u,"bottom-left"),m=ut(u,"bottom-right");return"padding"!=n&&"content"!=n||(i=ct(u,"top"),o=ct(u,"right"),r=ct(u,"bottom"),s=ct(u,"left"),h.x-=s.width,h.y-=i.width,f.x-=o.width,f.y-=i.width,m.x-=o.width,m.y-=r.width,p.x-=s.width,p.y-=r.width,"content"==n&&(a=parseFloat(at(u,"padding-top")),l=parseFloat(at(u,"padding-right")),c=parseFloat(at(u,"padding-bottom")),d=parseFloat(at(u,"padding-left")),h.x-=d,h.y-=a,f.x-=l,f.y-=a,m.x-=l,m.y-=c,p.x-=d,p.y-=c)),"number"==typeof n&&(h.x-=n,h.y-=n,f.x-=n,f.y-=n,m.x-=n,m.y-=n,p.x-=n,p.y-=n),xt(t,h,f,m,p)}function xt(e,t,n,i,o){var r=yt(e,t,n,i,o),s=r.tl,a=r.tr,l=r.br,c=r.bl,d=new Ln({fill:null,stroke:null});return d.moveTo(e.left,e.top+s.y),s.x&&bt(d,e.left+s.x,e.top+s.y,{startAngle:-180,endAngle:-90,radiusX:s.x,radiusY:s.y}),d.lineTo(e.right-a.x,e.top),a.x&&bt(d,e.right-a.x,e.top+a.y,{startAngle:-90,endAngle:0,radiusX:a.x,radiusY:a.y}),d.lineTo(e.right,e.bottom-l.y),l.x&&bt(d,e.right-l.x,e.bottom-l.y,{startAngle:0,endAngle:90,radiusX:l.x,radiusY:l.y}),d.lineTo(e.left+c.x,e.bottom),c.x&&bt(d,e.left+c.x,e.bottom-c.y,{startAngle:90,endAngle:180,radiusX:c.x,radiusY:c.y}),d.close()}function Ct(e,t){var i=parseFloat(e)+"";switch(t){case"decimal-leading-zero":return i.length<2&&(i="0"+i),i;case"lower-roman":return n(e).toLowerCase();case"upper-roman":return n(e).toUpperCase();case"lower-latin":case"lower-alpha":return et(e-1);case"upper-latin":case"upper-alpha":return et(e-1).toUpperCase();default:return i}}function St(e,t){function n(e,t,n){return n?(n=n.replace(/^\s*(["'])(.*)\1\s*$/,"$2"),Ge(e).map(function(e){return Ct(e,t)}).join(n)):Ct(qe(e)||0,t)}var i,o=Mo(t,/^\s+/),r=[];return o.forEach(function(t){var o;(i=/^\s*(["'])(.*)\1\s*$/.exec(t))?r.push(i[2].replace(/\\([0-9a-f]{4})/gi,function(e,t){return String.fromCharCode(parseInt(t,16))})):(i=/^\s*counter\((.*?)\)\s*$/.exec(t))?(o=Mo(i[1]),r.push(n(o[0],o[1]))):(i=/^\s*counters\((.*?)\)\s*$/.exec(t))?(o=Mo(i[1]),r.push(n(o[0],o[2],o[1]))):r.push((i=/^\s*attr\((.*?)\)\s*$/.exec(t))?e.getAttribute(i[1])||"":t)}),r.join("")}function Tt(e){var t,n;if(e.cssText)return e.cssText;for(t=[],n=0;n<e.length;++n)t.push(e[n]+": "+at(e,e[n]));return t.join(";\n")}function Dt(e,t){function n(t,n){var o,r=st(e,t),s=r.content;Qe(r),s&&"normal"!=s&&"none"!=s&&"0px"!=r.width&&(o=e.ownerDocument.createElement(xo),o.style.cssText=Tt(r),o.textContent=St(e,s),e.insertBefore(o,n),i.push(o))}var i,o;return e.tagName==xo?void At(e,t):(i=[],n(":before",e.firstChild),n(":after",null),void(i.length>0?(o=e.className,e.className+=" kendo-pdf-hide-pseudo-elements",At(e,t),e.className=o,i.forEach(function(t){e.removeChild(t)})):At(e,t)))}function At(e,t){function i(t){var n,i,o,r,s,a;if(/^td$/i.test(e.tagName)&&(n=So.table,n&&"collapse"==at(n.style,"border-collapse"))){if(i=ct(n.style,"left").width,o=ct(n.style,"top").width,0===i&&0===o)return t;if(r=n.element.getBoundingClientRect(),s=n.element.rows[0].cells[0],a=s.getBoundingClientRect(),a.top==r.top||a.left==r.left)return Be(t).map(function(e){return{left:e.left+i,top:e.top+o,right:e.right+i,bottom:e.bottom+o,height:e.height,width:e.width}})}return t}function o(e,n,i,o,r,s,a,l){function c(t,n,o){var r=Math.PI/2*t/(t+i),s={x:n.x-t,y:n.y-i},a=new Ln({fill:{color:e},stroke:null}).moveTo(0,0);vt(a,o),bt(a,0,n.y,{startAngle:-90,endAngle:-mt(r),radiusX:n.x,radiusY:n.y}),s.x>0&&s.y>0?(a.lineTo(s.x*Math.cos(r),n.y-s.y*Math.sin(r)),bt(a,0,n.y,{startAngle:-mt(r),endAngle:-90,radiusX:s.x,radiusY:s.y,anticlockwise:!0})):s.x>0?a.lineTo(s.x,i).lineTo(0,i):a.lineTo(s.x,i).lineTo(s.x,0),u.append(a.close())}if(!(i<=0)){var d,u=new Gn;vt(u,l),t.append(u),wt(s),wt(a),d=new Ln({fill:{color:e},stroke:null}),u.append(d),d.moveTo(s.x?Math.max(s.x,o):0,0).lineTo(n-(a.x?Math.max(a.x,r):0),0).lineTo(n-Math.max(a.x,r),i).lineTo(Math.max(s.x,o),i).close(),s.x&&c(o,s,[-1,0,0,1,s.x,0]),a.x&&c(r,a,[1,0,0,1,n-a.x,0])}}function r(e){var n,i,o=new Gn;for(_t(o,xt(e,S,T,A,D)),t.append(o),I&&(n=new Ln({fill:{color:I.toCssRgba()},stroke:null}),n.moveTo(e.left,e.top).lineTo(e.right,e.top).lineTo(e.right,e.bottom).lineTo(e.left,e.bottom).close(),o.append(n)),i=c.length;--i>=0;)s(o,e,c[i],d[i%d.length],u[i%u.length],h[i%h.length],f[i%f.length])}function s(t,n,i,o,r,s,a){function l(t,n,i,l,c){function d(){for(;g.origin.x>n.left;)g.origin.x-=i}function u(){for(;g.origin.y>n.top;)g.origin.y-=l}function h(){for(;g.origin.x<n.right;)c(t,g.clone()),g.origin.x+=i}var f,p,m,g,v,_=i/l,b=n;switch("content-box"==s?(b=ft(b,"border-*-width",e),b=ft(b,"padding-*",e)):"padding-box"==s&&(b=ft(b,"border-*-width",e)),/^\s*auto(\s+auto)?\s*$/.test(a)||("contain"==a?(f=Math.min(b.width/i,b.height/l),i*=f,l*=f):"cover"==a?(f=Math.max(b.width/i,b.height/l),i*=f,l*=f):(p=a.split(/\s+/g),i=/%$/.test(p[0])?b.width*parseFloat(p[0])/100:parseFloat(p[0]),l=1==p.length||"auto"==p[1]?i/_:/%$/.test(p[1])?b.height*parseFloat(p[1])/100:parseFloat(p[1]))),m=r+""){case"bottom":m="50% 100%";break;case"top":m="50% 0";break;case"left":m="0 50%";break;case"right":m="100% 50%";break;case"center":m="50% 50%"}if(m=m.split(/\s+/),1==m.length&&(m[1]="50%"),m[0]=/%$/.test(m[0])?parseFloat(m[0])/100*(b.width-i):parseFloat(m[0]),m[1]=/%$/.test(m[1])?parseFloat(m[1])/100*(b.height-l):parseFloat(m[1]),g=new hn([b.left+m[0],b.top+m[1]],[i,l]),"no-repeat"==o)c(t,g);else if("repeat-x"==o)d(),h();else if("repeat-y"==o)for(u();g.origin.y<n.bottom;)c(t,g.clone()),g.origin.y+=l;else if("repeat"==o)for(d(),u(),v=g.origin.clone();g.origin.y<n.bottom;)g.origin.x=v.x,h(),g.origin.y+=l}if(i&&"none"!=i)if("url"==i.type){if(/^url\(\"data:image\/svg/i.test(i.url))return;var c=Co[i.url];c&&c.width>0&&c.height>0&&l(t,n,c.width,c.height,function(e,t){e.append(new jn(i.url,t))})}else{if("linear"!=i.type)return;l(t,n,n.width,n.height,Et(i))}}function a(){function i(n){dt(e,function(){e.style.position="relative";var i=e.ownerDocument.createElement(xo);i.style.position="absolute",i.style.boxSizing="border-box","outside"==r?(i.style.width="6em",i.style.left="-6.8em",i.style.textAlign="right"):i.style.left="0px",n(i),e.insertBefore(i,e.firstChild),Ot(i,t),e.removeChild(i)})}function o(t){var n,i=e.parentNode.children,o=e.getAttribute("kendo-split-index");if(null!=o)return t(0|o,i.length);for(n=0;n<i.length;++n)if(i[n]===e)return t(n,i.length)}var r,s=at(w,"list-style-type");if("none"!=s)switch(r=at(w,"list-style-position"),s){case"circle":case"disc":case"square":i(function(e){e.style.fontSize="60%",e.style.lineHeight="200%",e.style.paddingRight="0.5em",e.style.fontFamily="DejaVu Serif",e.innerHTML={disc:"●",circle:"◯",square:"■"}[s]});break;case"decimal":case"decimal-leading-zero":i(function(e){o(function(t){++t,"decimal-leading-zero"==s&&t<10&&(t="0"+t),e.innerHTML=t+"."})});break;case"lower-roman":case"upper-roman":i(function(e){o(function(t){t=n(t+1),"upper-roman"==s&&(t=t.toUpperCase()),e.innerHTML=t+"."})});break;case"lower-latin":case"lower-alpha":case"upper-latin":case"upper-alpha":i(function(e){o(function(t){t=et(t),/^upper/i.test(s)&&(t=t.toUpperCase()),e.innerHTML=t+"."})})}}function l(n,i,s){function a(e){return{x:e.y,y:e.x}}var l,c,d,u,h,f,p,m;if(0!==n.width&&0!==n.height&&(r(n),l=C.width>0&&(i&&"ltr"==E||s&&"rtl"==E),c=k.width>0&&(s&&"ltr"==E||i&&"rtl"==E),0!==y.width||0!==C.width||0!==k.width||0!==x.width)){if(y.color==k.color&&y.color==x.color&&y.color==C.color&&y.width==k.width&&y.width==x.width&&y.width==C.width&&l&&c)return n=ft(n,y.width/2),d=kt(e,n,y.width/2),d.options.stroke={color:y.color,width:y.width},void t.append(d);if(0===S.x&&0===T.x&&0===A.x&&0===D.x&&y.width<2&&C.width<2&&k.width<2&&x.width<2)return y.width>0&&t.append(new Ln({stroke:{width:y.width,color:y.color}}).moveTo(n.left,n.top+y.width/2).lineTo(n.right,n.top+y.width/2)),x.width>0&&t.append(new Ln({stroke:{width:x.width,color:x.color}}).moveTo(n.left,n.bottom-x.width/2).lineTo(n.right,n.bottom-x.width/2)),l&&t.append(new Ln({stroke:{width:C.width,color:C.color}}).moveTo(n.left+C.width/2,n.top).lineTo(n.left+C.width/2,n.bottom)),void(c&&t.append(new Ln({stroke:{width:k.width,color:k.color}}).moveTo(n.right-k.width/2,n.top).lineTo(n.right-k.width/2,n.bottom)));u=yt(n,S,T,A,D),h=u.tl,f=u.tr,p=u.br,m=u.bl,o(y.color,n.width,y.width,C.width,k.width,h,f,[1,0,0,1,n.left,n.top]),o(x.color,n.width,x.width,k.width,C.width,p,m,[-1,0,0,-1,n.right,n.bottom]),o(C.color,n.height,C.width,x.width,y.width,a(m),a(h),[0,-1,1,0,n.left,n.bottom]),o(k.color,n.height,k.width,y.width,x.width,a(f),a(p),[0,1,-1,0,n.right,n.top])}}var c,d,u,h,f,p,m,g,v,_,b,w=st(e),y=ct(w,"top"),k=ct(w,"right"),x=ct(w,"bottom"),C=ct(w,"left"),S=ut(w,"top-left"),T=ut(w,"top-right"),D=ut(w,"bottom-left"),A=ut(w,"bottom-right"),E=at(w,"direction"),I=at(w,"background-color");if(I=Xe(I),c=Io(at(w,"background-image")),d=Mo(at(w,"background-repeat")),u=Mo(at(w,"background-position")),h=Mo(at(w,"background-origin")),f=Mo(at(w,"background-size")),ko.msie&&ko.version<10&&(u=Mo(e.currentStyle.backgroundPosition)),p=ft(e.getBoundingClientRect(),"border-*-width",e),function(){var e,n,i,o,r,s,a,l=at(w,"clip"),c=/^\s*rect\((.*)\)\s*$/.exec(l);c&&(e=c[1].split(/[ ,]+/g),n="auto"==e[0]?p.top:parseFloat(e[0])+p.top,i="auto"==e[1]?p.right:parseFloat(e[1])+p.left,o="auto"==e[2]?p.bottom:parseFloat(e[2])+p.top,r="auto"==e[3]?p.left:parseFloat(e[3])+p.left,s=new Gn,a=(new Ln).moveTo(r,n).lineTo(i,n).lineTo(i,o).lineTo(r,o).close(),_t(s,a),t.append(s),t=s,it(a))}(),_=at(w,"display"),"table-row"==_)for(m=[],g=0,v=e.children;g<v.length;++g)m.push(v[g].getBoundingClientRect());else m=e.getClientRects(),1==m.length&&(m=[e.getBoundingClientRect()]);for(m=i(m),g=0;g<m.length;++g)l(m[g],0===g,g==m.length-1);return"A"==e.tagName&&e.href&&!/^#?$/.test(e.getAttribute("href"))&&(So._avoidLinks&&Ao(e,So._avoidLinks)||(b=document.createRange(),b.selectNodeContents(e),Be(b.getClientRects()).forEach(function(n){var i=new Gn;i._pdfLink={url:e.href,top:n.top,right:n.right,bottom:n.bottom,left:n.left},t.append(i)}))),m.length>0&&"list-item"==_&&!e.getAttribute("kendo-no-bullet")&&a(m[0]),function(){function n(){var n=kt(e,p,"padding"),i=new Gn;_t(i,n),t.append(i),t=i,it(n)}Ft(e)?n():/^(hidden|auto|scroll)/.test(at(w,"overflow"))?n():/^(hidden|auto|scroll)/.test(at(w,"overflow-x"))?n():/^(hidden|auto|scroll)/.test(at(w,"overflow-y"))&&n()}(),It(e,t)||Lt(e,t),t}function Et(e){return function(t,n){var i,o,r,s,a,l,c,d,u,h,f,p,m,g=n.width(),v=n.height();switch(e.type){case"linear":switch(i=null!=e.angle?e.angle:Math.PI,e.to){case"top":i=0;break;case"left":i=-Math.PI/2;break;case"bottom":i=Math.PI;break;case"right":i=Math.PI/2;break;case"top left":case"left top":i=-Math.atan2(v,g);break;case"top right":case"right top":i=Math.atan2(v,g);break;case"bottom left":case"left bottom":i=Math.PI+Math.atan2(v,g);break;case"bottom right":case"right bottom":i=Math.PI-Math.atan2(v,g)}e.reverse&&(i-=Math.PI),i%=2*Math.PI,i<0&&(i+=2*Math.PI),o=Math.abs(g*Math.sin(i))+Math.abs(v*Math.cos(i)),r=Math.atan(g*Math.tan(i)/v),s=Math.sin(r),a=Math.cos(r),l=Math.abs(s)+Math.abs(a),c=l/2*s,d=l/2*a,i>Math.PI/2&&i<=3*Math.PI/2&&(c=-c,d=-d),u=[],h=0,f=e.stops.map(function(t,n){var i,r=t.percent;return r?r=parseFloat(r)/100:t.length?r=parseFloat(t.length)/o:0===n?r=0:n==e.stops.length-1&&(r=1),i={color:t.color.toCssRgba(),offset:r},null!=r?(h=r,u.forEach(function(e,t){var n=e.stop;n.offset=e.left+(h-e.left)*(t+1)/(u.length+1)}),u=[]):u.push({left:h,stop:i}),i}),p=[.5-c,.5+d],m=[.5+c,.5-d],t.append(Ln.fromRect(n).stroke(null).fill(new ti({start:p,end:m,stops:f,userSpace:!1})));break;case"radial":window.console&&window.console.log&&window.console.log("Radial gradients are not yet supported in HTML renderer")}}}function It(e,t){var n,i,o,r;return e._kendoExportVisual?n=e._kendoExportVisual():window.kendo&&window.kendo.jQuery&&e.getAttribute(window.kendo.attr("role"))&&(i=window.kendo.widgetInstance(window.kendo.jQuery(e)),i&&(i.exportDOMVisual||i.exportVisual)&&(n=i.exportDOMVisual?i.exportDOMVisual():i.exportVisual())),!!n&&(o=new Gn,o.children.push(n),r=e.getBoundingClientRect(),o.transform(A().translate(r.left,r.top)),t.append(o),!0)}function Mt(e,t,n){var i=ht(e),o=new hn([i.left,i.top],[i.width,i.height]),r=new jn(t,o);_t(r,kt(e,i,"content")),n.append(r)}function Rt(e,t){var n=st(e),i=st(t),o=parseFloat(at(n,"z-index")),r=parseFloat(at(i,"z-index")),s=at(n,"position"),a=at(i,"position");return isNaN(o)&&isNaN(r)?/static|absolute/.test(s)&&/static|absolute/.test(a)?0:"static"==s?-1:"static"==a?1:0:isNaN(o)?0===r?0:r>0?-1:1:isNaN(r)?0===o?0:o>0?1:-1:parseFloat(o)-parseFloat(r)}function Ft(e){return/^(?:textarea|select|input)$/i.test(e.tagName)}function zt(e){return e.selectedOptions&&e.selectedOptions.length>0?e.selectedOptions[0]:e.options[e.selectedIndex]}function Pt(e,t){var n=st(e),i=at(n,"color"),o=e.getBoundingClientRect();"checkbox"==e.type?(t.append(Ln.fromRect(new hn([o.left+1,o.top+1],[o.width-2,o.height-2])).stroke(i,1)),e.checked&&t.append((new Ln).stroke(i,1.2).moveTo(o.left+.22*o.width,o.top+.55*o.height).lineTo(o.left+.45*o.width,o.top+.75*o.height).lineTo(o.left+.78*o.width,o.top+.22*o.width))):(t.append(new kn(new gn([(o.left+o.right)/2,(o.top+o.bottom)/2],Math.min(o.width-2,o.height-2)/2)).stroke(i,1)),e.checked&&t.append(new kn(new gn([(o.left+o.right)/2,(o.top+o.bottom)/2],Math.min(o.width-8,o.height-8)/2)).fill(i).stroke(null)))}function Bt(e,t){var n,i,o,r,s,a=e.tagName.toLowerCase();if("input"==a&&("checkbox"==e.type||"radio"==e.type))return Pt(e,t);if(n=e.parentNode,i=e.ownerDocument,o=i.createElement(xo),o.style.cssText=Tt(st(e)),"input"==a&&(o.style.whiteSpace="pre"),"select"!=a&&"textarea"!=a||(o.style.overflow="auto"),"select"==a)if(e.multiple)for(s=0;s<e.options.length;++s)r=i.createElement(xo),r.style.cssText=Tt(st(e.options[s])),r.style.display="block",r.textContent=e.options[s].textContent,o.appendChild(r);else r=zt(e),r&&(o.textContent=r.textContent);else o.textContent=e.value;n.insertBefore(o,e),o.scrollLeft=e.scrollLeft,o.scrollTop=e.scrollTop,e.style.display="none",Lt(o,t),e.style.display="",n.removeChild(o)}function Lt(e,t){var n,i,o,r,s,a,l;switch(So._stackingContext.element===e&&(So._stackingContext.group=t),e.tagName.toLowerCase()){case"img":Mt(e,e.src,t);break;case"canvas":try{Mt(e,e.toDataURL("image/png"),t)}catch(c){}break;case"textarea":case"input":case"select":Bt(e,t);break;default:for(n=[],i=[],o=[],r=e.firstChild;r;r=r.nextSibling)switch(r.nodeType){case 3:/\S/.test(r.data)&&Ht(e,r,t);break;case 1:s=st(r),a=at(s,"float"),l=at(s,"position"),"static"!=l?o.push(r):"none"!=a?i.push(r):n.push(r)}f(n,Rt).forEach(function(e){Ot(e,t)}),f(i,Rt).forEach(function(e){Ot(e,t)}),f(o,Rt).forEach(function(e){Ot(e,t)})}}function Ht(e,t,n){function i(e){var t,n,i,o;if(To||ko.chrome){for(t=e.getClientRects(),n={top:1/0,right:-(1/0),bottom:-(1/0),left:1/0},i=0;i<t.length;++i)o=t[i],o.width<=1||o.bottom===C||(n.left=Math.min(o.left,n.left),n.top=Math.min(o.top,n.top),n.right=Math.max(o.right,n.right),n.bottom=Math.max(o.bottom,n.bottom));return n.width=n.right-n.left,n.height=n.bottom-n.top,n}return e.getBoundingClientRect()}function o(){var e,n,o,s,a,u,h,f=c,p=l.substr(c).search(/\S/);if(c+=p,
p<0||c>=d)return!0;if(m.setStart(t,c),m.setEnd(t,c+1),e=i(m),n=!1,(v||_>1)&&(p=l.substr(c).search(/\s/),p>=0&&(m.setEnd(t,c+p),o=i(m),o.bottom==e.bottom&&(e=o,n=!0,c+=p))),!n){if(p=function g(n,o,r){m.setEnd(t,o);var s=i(m);return s.bottom!=e.bottom&&n<o?g(n,n+o>>1,o):s.right!=e.right?(e=s,o<r?g(o,o+r>>1,r):o):o}(c,Math.min(d,c+x),d),p==c)return!0;if(c=p,p=(""+m).search(/\s+$/),0===p)return!1;p>0&&(m.setEnd(t,m.startOffset+p),e=i(m))}if(To&&(e=m.getClientRects()[0]),s=""+m,/^(?:pre|pre-wrap)$/i.test(b)){if(/\t/.test(s)){for(a=0,p=f;p<m.startOffset;++p)u=l.charCodeAt(p),9==u?a+=8-a%8:10==u||13==u?a=0:a++;for(;(p=s.search("\t"))>=0;)h="        ".substr(0,8-(a+p)%8),s=s.substr(0,p)+h+s.substr(p+1)}}else s=s.replace(/\s+/g," ");n||(C=e.bottom),r(s,e)}function r(e,t){var i,o,r;switch(To&&!isNaN(h)&&(i=Fo(f),o=(t.top+t.bottom-i)/2,t={top:o,right:t.right,bottom:o+i,left:t.left,height:i,width:t.right-t.left}),w){case"uppercase":e=e.toUpperCase();break;case"lowercase":e=e.toLowerCase();break;case"capitalize":e=e.replace(/(?:^|\s)\S/g,function(e){return e.toUpperCase()})}r=new Do(e,new hn([t.left,t.top],[t.width,t.height]),{font:f,fill:{color:p}}),n.append(r)}function s(e){function t(t,i){var o,r;t&&(o=u/12,r=new Ln({stroke:{width:o,color:t}}),i-=o,r.moveTo(e.left,i).lineTo(e.right,i),n.append(r))}t(S,e.bottom),t(T,e.bottom-e.height/2.7),t(D,e.top)}var a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C,S,T,D,A;if(!ot()&&(a=st(e),!(parseFloat(at(a,"text-indent"))<-500)&&(l=t.data,c=0,d=l.search(/\S\s*$/)+1,d&&(u=at(a,"font-size"),h=at(a,"line-height"),f=[at(a,"font-style"),at(a,"font-variant"),at(a,"font-weight"),u,at(a,"font-family")].join(" "),u=parseFloat(u),h=parseFloat(h),0!==u)))){for(p=at(a,"color"),m=e.ownerDocument.createRange(),g=at(a,"text-align"),v="justify"==g,_=at(a,"column-count",1),b=at(a,"white-space"),w=at(a,"text-transform"),To&&(y=a.textOverflow,"ellipsis"==y&&(k=e.style.textOverflow,e.style.textOverflow="clip")),x=e.getBoundingClientRect().width/u*5,0===x&&(x=500),C=null,S=So.underline,T=So["line-through"],D=So.overline,A=S||T||D;!o(););To&&"ellipsis"==y&&(e.style.textOverflow=k),A&&(m.selectNode(t),Be(m.getClientRects()).forEach(s))}}function Nt(e,t,n){var i,o,r,s,a,l;for("auto"!=n?(i=So._stackingContext.group,n=parseFloat(n)):(i=t,n=0),o=i.children,r=0;r<o.length&&!(null!=o[r]._dom_zIndex&&o[r]._dom_zIndex>n);++r);return s=new Gn,i.insert(r,s),s._dom_zIndex=n,i!==t&&So._clipbox&&(a=So._matrix.invert(),l=So._clipbox.transformCopy(a),_t(s,Ln.fromRect(l))),s}function Ot(e,t){var n,i,o,r,s,a,l=st(e);Qe(l),/^(style|script|link|meta|iframe|svg|col|colgroup)$/i.test(e.tagName)||null!=So._clipbox&&(n=parseFloat(at(l,"opacity")),i=at(l,"visibility"),o=at(l,"display"),0!==n&&"hidden"!=i&&"none"!=o&&(r=pt(l),a=at(l,"z-index"),(r||n<1)&&"auto"==a&&(a=0),s=Nt(e,t,a),n<1&&s.opacity(n*s.opacity()),tt(e,l,s),r?dt(e,function(){var t,n,i,o;lt(e.style,"transform","none","important"),lt(e.style,"transition","none","important"),"static"==at(l,"position")&&lt(e.style,"position","relative","important"),t=e.getBoundingClientRect(),n=t.left+r.origin[0],i=t.top+r.origin[1],o=[1,0,0,1,-n,-i],o=Vt(o,r.matrix),o=Vt(o,[1,0,0,1,n,i]),o=vt(s,o),So._matrix=So._matrix.multiplyCopy(o),Dt(e,s)}):Dt(e,s),nt()))}function Vt(e,t){var n=e[0],i=e[1],o=e[2],r=e[3],s=e[4],a=e[5],l=t[0],c=t[1],d=t[2],u=t[3],h=t[4],f=t[5];return[n*l+i*d,n*c+i*u,o*l+r*d,o*c+r*u,s*l+a*d+h,s*c+a*u+f]}var Ut,Wt,jt,qt,Gt,$t,Kt,Yt,Qt,Xt,Zt,Jt,en,tn,nn,on,rn,sn,an,ln,cn,dn,un,hn,fn,pn,mn,gn,vn,_n,bn,wn,yn,kn,xn,Cn,Sn,Tn,Dn,An,En,In,Mn,Rn,Fn,zn,Pn,Bn,Ln,Hn,Nn,On,Vn,Un,Wn,jn,qn,Gn,$n,Kn,Yn,Qn,Xn,Zn,Jn,ei,ti,ni,ii,oi,ri,si,ai,li,ci,di,ui,hi,fi,pi,mi,gi,vi,_i,bi,wi,yi,ki,xi,Ci,Si,Ti,Di,Ai,Ei,Ii,Mi,Ri,Fi,zi,Pi,Bi,Li,Hi,Ni,Oi,Vi,Ui,Wi,ji,qi,Gi,$i,Ki,Yi,Qi,Xi,Zi,Ji,eo,to,no,io,oo,ro,so,ao,lo,co,uo,ho,fo,po,mo,go,vo,_o,bo,wo,yo,ko,xo,Co,So,To,Do,Ao,Eo,Io,Mo,Ro,Fo,zo;window.kendo=window.kendo||{},Ut=kendo.drawing,Wt=Ut.util,jt=kendo.Class,qt=kendo.util,Gt=kendo.support,$t=Gt.browser,Kt=Wt.createPromise,Yt=Wt.promiseAll,Qt={extend:function(e){var t,n=this;for(t in this)"extend"!==t&&(e[t]=n[t])},observers:function(){return this._observers=this._observers||[]},addObserver:function(e){return this._observers?this._observers.push(e):this._observers=[e],this},removeObserver:function(e){var t=this.observers(),n=t.indexOf(e);return n!==-1&&t.splice(n,1),this},trigger:function(e,t){var n,i,o=this._observers;if(o&&!this._suspended)for(n=0;n<o.length;n++)i=o[n],i[e]&&i[e](t);return this},optionsChange:function(e){void 0===e&&(e={}),e.element=this,this.trigger("optionsChange",e)},geometryChange:function(){this.trigger("geometryChange",{element:this})},suspend:function(){return this._suspended=(this._suspended||0)+1,this},resume:function(){return this._suspended=Math.max((this._suspended||0)-1,0),this},_observerField:function(e,t){this[e]&&this[e].removeObserver(this),this[e]=t,t.addObserver(this)}},Xt={1:"i",10:"x",100:"c",2:"ii",20:"xx",200:"cc",3:"iii",30:"xxx",300:"ccc",4:"iv",40:"xl",400:"cd",5:"v",50:"l",500:"d",6:"vi",60:"lx",600:"dc",7:"vii",70:"lxx",700:"dcc",8:"viii",80:"lxxx",800:"dccc",9:"ix",90:"xc",900:"cm",1e3:"m"},Zt="undefined",Jt=1,en=Math.PI/180,tn=Number.MAX_VALUE,nn=-Number.MAX_VALUE,on="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",rn=String.fromCharCode,sn={append:t,arabicToRoman:n,createPromise:Kt,defined:i,definitionId:o,deg:r,encodeBase64:a,eventCoordinates:l,eventElement:c,isTransparent:d,last:u,limitValue:h,mergeSort:f,promiseAll:Yt,rad:p,round:g,valueOrDefault:v,bindEvents:_,elementOffset:b,elementSize:k,elementStyles:w,unbindEvents:x,DEG_TO_RAD:en,MAX_NUM:tn,MIN_NUM:nn},an={}.toString,ln=jt.extend({init:function(e,t){var n,i,o=this;void 0===t&&(t=""),this.prefix=t;for(n in e)i=e[n],i=o._wrap(i,n),o[n]=i},get:function(e){for(var t,n=e.split("."),i=this;n.length&&i;)t=n.shift(),i=i[t];return i},set:function(e,t){var n=this.get(e);n!==t&&(this._set(e,this._wrap(t,e)),this.optionsChange({field:this.prefix+e,value:t}))},_set:function(e,t){var n,i,o,r=this,s=e.indexOf(".")>=0,a=this,l=e;if(s){for(n=l.split("."),i=this.prefix;n.length>1;)l=n.shift(),i+=l+".",o=a[l],o||(o=new ln({},i),o.addObserver(r),a[l]=o),a=o;l=n[0]}a._clear(l),a[l]=t},_clear:function(e){var t=this[e];t&&t.removeObserver&&t.removeObserver(this)},_wrap:function(e,t){var n=an.call(e),o=e;return null!==o&&i(o)&&"[object Object]"===n&&(e instanceof ln||e instanceof jt||(o=new ln(o,this.prefix+t+".")),o.addObserver(this)),o}}),Qt.extend(ln.prototype),cn=jt.extend({init:function(e,t,n,i,o,r){void 0===e&&(e=0),void 0===t&&(t=0),void 0===n&&(n=0),void 0===i&&(i=0),void 0===o&&(o=0),void 0===r&&(r=0),this.a=e,this.b=t,this.c=n,this.d=i,this.e=o,this.f=r},multiplyCopy:function(e){return new cn(this.a*e.a+this.c*e.b,this.b*e.a+this.d*e.b,this.a*e.c+this.c*e.d,this.b*e.c+this.d*e.d,this.a*e.e+this.c*e.f+this.e,this.b*e.e+this.d*e.f+this.f)},invert:function(){var e=this,t=e.a,n=e.b,i=e.c,o=e.d,r=e.e,s=e.f,a=t*o-n*i;return 0===a?null:new cn(o/a,-n/a,-i/a,t/a,(i*s-o*r)/a,(n*r-t*s)/a)},clone:function(){return new cn(this.a,this.b,this.c,this.d,this.e,this.f)},equals:function(e){return!!e&&(this.a===e.a&&this.b===e.b&&this.c===e.c&&this.d===e.d&&this.e===e.e&&this.f===e.f)},round:function(e){return this.a=g(this.a,e),this.b=g(this.b,e),this.c=g(this.c,e),this.d=g(this.d,e),this.e=g(this.e,e),this.f=g(this.f,e),this},toArray:function(e){var t,n=[this.a,this.b,this.c,this.d,this.e,this.f];if(i(e))for(t=0;t<n.length;t++)n[t]=g(n[t],e);return n},toString:function(e,t){return void 0===t&&(t=","),this.toArray(e).join(t)}}),cn.translate=function(e,t){return new cn(1,0,0,1,e,t)},cn.unit=function(){return new cn(1,0,0,1,0,0)},cn.rotate=function(e,t,n){var i=new cn;return i.a=Math.cos(p(e)),i.b=Math.sin(p(e)),i.c=-i.b,i.d=i.a,i.e=t-t*i.a+n*i.b||0,i.f=n-n*i.a-t*i.b||0,i},cn.scale=function(e,t){return new cn(e,0,0,t,0,0)},cn.IDENTITY=cn.unit(),dn=jt.extend({init:function(e,t){this.x=e||0,this.y=t||0},equals:function(e){return e&&e.x===this.x&&e.y===this.y},clone:function(){return new dn(this.x,this.y)},rotate:function(e,t){var n=dn.create(t)||dn.ZERO;return this.transform(cn.rotate(e,n.x,n.y))},translate:function(e,t){return this.x+=e,this.y+=t,this.geometryChange(),this},translateWith:function(e){return this.translate(e.x,e.y)},move:function(e,t){return this.x=this.y=0,this.translate(e,t)},scale:function(e,t){return void 0===t&&(t=e),this.x*=e,this.y*=t,this.geometryChange(),this},scaleCopy:function(e,t){return this.clone().scale(e,t)},transform:function(e){var t=D(e),n=this,i=n.x,o=n.y;return this.x=t.a*i+t.c*o+t.e,this.y=t.b*i+t.d*o+t.f,this.geometryChange(),this},transformCopy:function(e){var t=this.clone();return e&&t.transform(e),t},distanceTo:function(e){var t=this.x-e.x,n=this.y-e.y;return Math.sqrt(t*t+n*n)},round:function(e){return this.x=g(this.x,e),this.y=g(this.y,e),this.geometryChange(),this},toArray:function(e){var t=i(e),n=t?g(this.x,e):this.x,o=t?g(this.y,e):this.y;return[n,o]},toString:function(e,t){var n,o,r;return void 0===t&&(t=" "),n=this,o=n.x,r=n.y,i(e)&&(o=g(o,e),r=g(r,e)),o+t+r}}),dn.create=function(e,t){if(i(e))return e instanceof dn?e:1===arguments.length&&2===e.length?new dn(e[0],e[1]):new dn(e,t)},dn.min=function(){var e,t,n=arguments,i=tn,o=tn;for(e=0;e<arguments.length;e++)t=n[e],i=Math.min(t.x,i),o=Math.min(t.y,o);return new dn(i,o)},dn.max=function(){var e,t,n=arguments,i=nn,o=nn;for(e=0;e<arguments.length;e++)t=n[e],i=Math.max(t.x,i),o=Math.max(t.y,o);return new dn(i,o)},dn.minPoint=function(){return new dn(nn,nn)},dn.maxPoint=function(){return new dn(tn,tn)},Object.defineProperties&&Object.defineProperties(dn,{ZERO:{get:function(){return new dn(0,0)}}}),T(dn.prototype,["x","y"]),Qt.extend(dn.prototype),un=jt.extend({init:function(e,t){this.width=e||0,this.height=t||0},equals:function(e){return e&&e.width===this.width&&e.height===this.height},clone:function(){return new un(this.width,this.height)},toArray:function(e){var t=i(e),n=t?g(this.width,e):this.width,o=t?g(this.height,e):this.height;return[n,o]}}),un.create=function(e,t){if(i(e))return e instanceof un?e:1===arguments.length&&2===e.length?new un(e[0],e[1]):new un(e,t)},Object.defineProperties&&Object.defineProperties(un,{ZERO:{get:function(){return new un(0,0)}}}),T(un.prototype,["width","height"]),Qt.extend(un.prototype),hn=jt.extend({init:function(e,t){void 0===e&&(e=new dn),void 0===t&&(t=new un),this.setOrigin(e),this.setSize(t)},clone:function(){return new hn(this.origin.clone(),this.size.clone())},equals:function(e){return e&&e.origin.equals(this.origin)&&e.size.equals(this.size)},setOrigin:function(e){return this._observerField("origin",dn.create(e)),this.geometryChange(),this},getOrigin:function(){return this.origin},setSize:function(e){return this._observerField("size",un.create(e)),this.geometryChange(),this},getSize:function(){return this.size},width:function(){return this.size.width},height:function(){return this.size.height},topLeft:function(){return this.origin.clone()},bottomRight:function(){return this.origin.clone().translate(this.width(),this.height())},topRight:function(){return this.origin.clone().translate(this.width(),0)},bottomLeft:function(){return this.origin.clone().translate(0,this.height())},center:function(){return this.origin.clone().translate(this.width()/2,this.height()/2)},bbox:function(e){var t=this.topLeft().transformCopy(e),n=this.topRight().transformCopy(e),i=this.bottomRight().transformCopy(e),o=this.bottomLeft().transformCopy(e);return hn.fromPoints(t,n,i,o)},transformCopy:function(e){return hn.fromPoints(this.topLeft().transform(e),this.bottomRight().transform(e))},expand:function(e,t){return void 0===t&&(t=e),this.size.width+=2*e,this.size.height+=2*t,this.origin.translate(-e,-t),this},expandCopy:function(e,t){return this.clone().expand(e,t)},containsPoint:function(e){var t=this.origin,n=this.bottomRight();return!(e.x<t.x||e.y<t.y||n.x<e.x||n.y<e.y)},_isOnPath:function(e,t){var n=this.expandCopy(t,t),i=this.expandCopy(-t,-t);return n.containsPoint(e)&&!i.containsPoint(e)}}),hn.fromPoints=function(){var e=dn.min.apply(null,arguments),t=dn.max.apply(null,arguments),n=new un(t.x-e.x,t.y-e.y);return new hn(e,n)},hn.union=function(e,t){return hn.fromPoints(dn.min(e.topLeft(),t.topLeft()),dn.max(e.bottomRight(),t.bottomRight()))},hn.intersect=function(e,t){var n={left:e.topLeft().x,top:e.topLeft().y,right:e.bottomRight().x,bottom:e.bottomRight().y},i={left:t.topLeft().x,top:t.topLeft().y,right:t.bottomRight().x,bottom:t.bottomRight().y};if(n.left<=i.right&&i.left<=n.right&&n.top<=i.bottom&&i.top<=n.bottom)return hn.fromPoints(new dn(Math.max(n.left,i.left),Math.max(n.top,i.top)),new dn(Math.min(n.right,i.right),Math.min(n.bottom,i.bottom)))},Qt.extend(hn.prototype),fn=jt.extend({init:function(e){void 0===e&&(e=cn.unit()),this._matrix=e},clone:function(){return new fn(this._matrix.clone())},equals:function(e){return e&&e._matrix.equals(this._matrix)},translate:function(e,t){return this._matrix=this._matrix.multiplyCopy(cn.translate(e,t)),this._optionsChange(),this},scale:function(e,t,n){void 0===t&&(t=e),void 0===n&&(n=null);var i=n;return i&&(i=dn.create(i),this._matrix=this._matrix.multiplyCopy(cn.translate(i.x,i.y))),this._matrix=this._matrix.multiplyCopy(cn.scale(e,t)),i&&(this._matrix=this._matrix.multiplyCopy(cn.translate(-i.x,-i.y))),this._optionsChange(),this},rotate:function(e,t){var n=dn.create(t)||dn.ZERO;return this._matrix=this._matrix.multiplyCopy(cn.rotate(e,n.x,n.y)),this._optionsChange(),this},multiply:function(e){var t=D(e);return this._matrix=this._matrix.multiplyCopy(t),this._optionsChange(),this},matrix:function(e){return e?(this._matrix=e,this._optionsChange(),this):this._matrix},_optionsChange:function(){this.optionsChange({field:"transform",value:this})}}),Qt.extend(fn.prototype),pn=jt.extend({init:function(e){this._initOptions(e)},_initOptions:function(e){var t,n;void 0===e&&(e={}),t=e.clip,n=e.transform,n&&(e.transform=A(n)),t&&!t.id&&(t.id=o()),this.options=new ln(e),this.options.addObserver(this)},transform:function(e){return i(e)?void this.options.set("transform",A(e)):this.options.get("transform")},parentTransform:function(){for(var e,t,n=this;n.parent;)n=n.parent,t=n.transform(),t&&(e=t.matrix().multiplyCopy(e||cn.unit()));if(e)return A(e)},currentTransform:function(e){var t,n,i,o;if(void 0===e&&(e=this.parentTransform()),t=this.transform(),n=D(t),i=D(e),o=n&&i?i.multiplyCopy(n):n||i)return A(o)},visible:function(e){return i(e)?(this.options.set("visible",e),this):this.options.get("visible")!==!1},clip:function(e){var t=this.options;return i(e)?(e&&!e.id&&(e.id=o()),t.set("clip",e),this):t.get("clip")},opacity:function(e){return i(e)?(this.options.set("opacity",e),this):v(this.options.get("opacity"),1)},clippedBBox:function(e){var t,n=this._clippedBBox(e);if(n)return t=this.clip(),t?hn.intersect(n,t.bbox(e)):n},containsPoint:function(e,t){var n,i;return!!this.visible()&&(n=this.currentTransform(t),i=e,n&&(i=e.transformCopy(n.matrix().invert())),this._hasFill()&&this._containsPoint(i)||this._isOnPath&&this._hasStroke()&&this._isOnPath(i))},_hasFill:function(){var e=this.options.fill;return e&&!d(e.color)},_hasStroke:function(){var e=this.options.stroke;return e&&e.width>0&&!d(e.color)},_clippedBBox:function(e){return this.bbox(e)}}),pn.prototype.nodeType="Element",Qt.extend(pn.prototype),mn=Math.PI/2,gn=jt.extend({init:function(e,t){void 0===e&&(e=new dn),void 0===t&&(t=0),this.setCenter(e),this.setRadius(t)},setCenter:function(e){return this._observerField("center",dn.create(e)),this.geometryChange(),this},getCenter:function(){return this.center},equals:function(e){return e&&e.center.equals(this.center)&&e.radius===this.radius},clone:function(){return new gn(this.center.clone(),this.radius)},pointAt:function(e){return this._pointAt(p(e))},bbox:function(e){var t,n,i,o,r=this,s=E(this.center,this.radius,this.radius,e),a=dn.maxPoint(),l=dn.minPoint();for(t=0;t<4;t++)n=r._pointAt(s.x+t*mn).transformCopy(e),i=r._pointAt(s.y+t*mn).transformCopy(e),o=new dn(n.x,i.y),a=dn.min(a,o),l=dn.max(l,o);return hn.fromPoints(a,l)},_pointAt:function(e){var t=this,n=t.center,i=t.radius;return new dn(n.x+i*Math.cos(e),n.y+i*Math.sin(e))},containsPoint:function(e){var t=this,n=t.center,i=t.radius,o=Math.pow(e.x-n.x,2)+Math.pow(e.y-n.y,2)<=Math.pow(i,2);return o},_isOnPath:function(e,t){var n=this,i=n.center,o=n.radius,r=i.distanceTo(e);return o-t<=r&&r<=o+t}}),T(gn.prototype,["radius"]),Qt.extend(gn.prototype),vn="Gradient",_n={extend:function(e){e.fill=this.fill,e.stroke=this.stroke},fill:function(e,t){var n,o=this.options;return i(e)?(e&&e.nodeType!==vn?(n={color:e},i(t)&&(n.opacity=t),o.set("fill",n)):o.set("fill",e),this):o.get("fill")},stroke:function(e,t,n){return i(e)?(this.options.set("stroke.color",e),i(t)&&this.options.set("stroke.width",t),i(n)&&this.options.set("stroke.opacity",n),this):this.options.get("stroke")}},bn=""+cn.IDENTITY,wn={extend:function(e){e.bbox=this.bbox,e.geometryChange=this.geometryChange},bbox:function(e){var t,n,i=D(this.currentTransform(e)),o=i?""+i:bn;return this._bboxCache&&this._matrixHash===o?t=this._bboxCache.clone():(t=this._bbox(i),this._bboxCache=t?t.clone():null,this._matrixHash=o),n=this.options.get("stroke.width"),n&&t&&t.expand(n/2),t},geometryChange:function(){delete this._bboxCache,this.trigger("geometryChange",{element:this})}},yn="#000",kn=pn.extend({init:function(e,t){void 0===e&&(e=new gn),void 0===t&&(t={}),pn.fn.init.call(this,t),this.geometry(e),i(this.options.stroke)||this.stroke(yn)},rawBBox:function(){return this._geometry.bbox()},_bbox:function(e){return this._geometry.bbox(e)},_containsPoint:function(e){return this.geometry().containsPoint(e)},_isOnPath:function(e){return this.geometry()._isOnPath(e,this.options.stroke.width/2)}}),kn.prototype.nodeType="Circle",_n.extend(kn.prototype),wn.extend(kn.prototype),M(kn.prototype,["geometry"]),xn=10,Cn=45,Sn=Math.pow,Tn=jt.extend({init:function(e,t){void 0===e&&(e=new dn),void 0===t&&(t={}),this.setCenter(e),this.radiusX=t.radiusX,this.radiusY=t.radiusY||t.radiusX,this.startAngle=t.startAngle,this.endAngle=t.endAngle,this.anticlockwise=t.anticlockwise||!1,this.xRotation=t.xRotation},clone:function(){return new Tn(this.center,{radiusX:this.radiusX,radiusY:this.radiusY,startAngle:this.startAngle,endAngle:this.endAngle,anticlockwise:this.anticlockwise})},setCenter:function(e){return this._observerField("center",dn.create(e)),this.geometryChange(),this},getCenter:function(){return this.center},pointAt:function(e){var t=this.center,n=p(e);return new dn(t.x+this.radiusX*Math.cos(n),t.y+this.radiusY*Math.sin(n))},curvePoints:function(){var e,t,n,i,o=this,r=this.startAngle,s=this.anticlockwise?-1:1,a=[this.pointAt(r)],l=this._arcInterval(),c=l.endAngle-l.startAngle,d=Math.ceil(c/Cn),u=c/d,h=r;for(this.xRotation&&(e=A().rotate(this.xRotation,this.center)),t=1;t<=d;t++)n=h+s*u,i=o._intervalCurvePoints(h,n,e),a.push(i.cp1,i.cp2,i.p2),h=n;return a},bbox:function(e){for(var t,n,i=this,o=this._arcInterval(),s=o.startAngle,a=o.endAngle,l=E(this.center,this.radiusX,this.radiusY,e),c=r(l.x),d=r(l.y),u=this.pointAt(a).transformCopy(e),h=L(c,s),f=L(d,s),p=this.pointAt(s).transformCopy(e),m=dn.min(p,u),g=dn.max(p,u);h<a||f<a;)t=void 0,h<a&&(t=i.pointAt(h).transformCopy(e),h+=90),n=void 0,f<a&&(n=i.pointAt(f).transformCopy(e),f+=90),p=new dn(t.x,n.y),m=dn.min(m,p),g=dn.max(g,p);return hn.fromPoints(m,g)},_arcInterval:function(){var e,t=this,n=t.startAngle,i=t.endAngle,o=t.anticlockwise;return o&&(e=n,n=i,i=e),(n>i||o&&n===i)&&(i+=360),{startAngle:n,endAngle:i}},_intervalCurvePoints:function(e,t,n){var i=this.pointAt(e),o=this.pointAt(t),r=this._derivativeAt(e),s=this._derivativeAt(t),a=(p(t)-p(e))/3,l=new dn(i.x+a*r.x,i.y+a*r.y),c=new dn(o.x-a*s.x,o.y-a*s.y);return n&&(i.transform(n),o.transform(n),l.transform(n),c.transform(n)),{p1:i,cp1:l,cp2:c,p2:o}},_derivativeAt:function(e){var t=p(e);return new dn(-this.radiusX*Math.sin(t),this.radiusY*Math.cos(t))},containsPoint:function(e){var t,n,i,o=this._arcInterval(),r=o.endAngle-o.startAngle,s=this,a=s.center,l=s.radiusX,c=s.radiusY,d=a.distanceTo(e),u=Math.atan2(e.y-a.y,e.x-a.x),h=l*c/Math.sqrt(Sn(l,2)*Sn(Math.sin(u),2)+Sn(c,2)*Sn(Math.cos(u),2)),f=this.pointAt(this.startAngle).round(xn),p=this.pointAt(this.endAngle).round(xn),m=z(a,e.round(xn),f,p);return r<180?t=m&&F(a.distanceTo(m),d)&&F(d,h):(n=P(a.x,a.y,l,c,e.x,e.y),360!==n&&(n=(360+n)%360),i=o.startAngle<=n&&n<=o.endAngle,t=i&&F(d,h)||!i&&(!m||m.equals(e))),t},_isOnPath:function(e,t){var n,i=this._arcInterval(),o=this.center,r=P(o.x,o.y,this.radiusX,this.radiusY,e.x,e.y);return 360!==r&&(r=(360+r)%360),n=i.startAngle<=r&&r<=i.endAngle,n&&this.pointAt(r).distanceTo(e)<=t}}),Tn.fromPoints=function(e,t,n,i,o,r,s){var a=B({x1:e.x,y1:e.y,x2:t.x,y2:t.y,rx:n,ry:i,largeArc:o,swipe:r,rotation:s});return new Tn(a.center,{startAngle:a.startAngle,endAngle:a.endAngle,radiusX:a.radiusX,radiusY:a.radiusY,xRotation:a.xRotation,anticlockwise:0===r})},T(Tn.prototype,["radiusX","radiusY","startAngle","endAngle","anticlockwise"]),Qt.extend(Tn.prototype),Dn=[].push,An=[].pop,En=[].splice,In=[].shift,Mn=[].slice,Rn=[].unshift,Fn=jt.extend({init:function(e){void 0===e&&(e=[]),this.length=0,this._splice(0,e.length,e)},elements:function(e){return e?(this._splice(0,this.length,e),this._change(),this):this.slice(0)},push:function(){var e=arguments,t=Dn.apply(this,e);return this._add(e),t},slice:function(){return Mn.call(this)},pop:function(){var e=this.length,t=An.apply(this);return e&&this._remove([t]),t},splice:function(e,t){var n=Mn.call(arguments,2),i=this._splice(e,t,n);return this._change(),i},shift:function(){var e=this.length,t=In.apply(this);return e&&this._remove([t]),t},unshift:function(){var e=arguments,t=Rn.apply(this,e);return this._add(e),t},indexOf:function(e){var t,n=this,i=this.length;for(t=0;t<i;t++)if(n[t]===e)return t;return-1},_splice:function(e,t,n){var i=En.apply(this,[e,t].concat(n));return this._clearObserver(i),this._setObserver(n),i},_add:function(e){this._setObserver(e),this._change()},_remove:function(e){this._clearObserver(e),this._change()},_setObserver:function(e){var t,n=this;for(t=0;t<e.length;t++)e[t].addObserver(n)},_clearObserver:function(e){var t,n=this;for(t=0;t<e.length;t++)e[t].removeObserver(n)},_change:function(){}}),Qt.extend(Fn.prototype),zn=Fn.extend({_change:function(){this.geometryChange()}}),Pn=jt.extend({init:function(e,t){void 0===e&&(e=0),void 0===t&&(t=0),this.real=e,this.img=t},add:function(e){return new Pn(g(this.real+e.real,xn),g(this.img+e.img,xn))},addConstant:function(e){return new Pn(this.real+e,this.img)},negate:function(){return new Pn((-this.real),(-this.img))},multiply:function(e){return new Pn(this.real*e.real-this.img*e.img,this.real*e.img+this.img*e.real)},multiplyConstant:function(e){return new Pn(this.real*e,this.img*e)},nthRoot:function(e){var t=Math.atan2(this.img,this.real),n=Math.sqrt(Math.pow(this.img,2)+Math.pow(this.real,2)),i=Math.pow(n,1/e);return new Pn(i*Math.cos(t/e),i*Math.sin(t/e))},equals:function(e){return this.real===e.real&&this.img===e.img},isReal:function(){return 0===this.img}}),Bn=jt.extend({init:function(e,t,n){this.anchor(e||new dn),this.controlIn(t),this.controlOut(n)},bboxTo:function(e,t){var n,i=this.anchor().transformCopy(t),o=e.anchor().transformCopy(t);return n=this.controlOut()&&e.controlIn()?this._curveBoundingBox(i,this.controlOut().transformCopy(t),e.controlIn().transformCopy(t),o):this._lineBoundingBox(i,o)},_lineBoundingBox:function(e,t){return hn.fromPoints(e,t)},_curveBoundingBox:function(e,t,n,i){var o=[e,t,n,i],r=this._curveExtremesFor(o,"x"),s=this._curveExtremesFor(o,"y"),a=Y([r.min,r.max,e.x,i.x]),l=Y([s.min,s.max,e.y,i.y]);return hn.fromPoints(new dn(a.min,l.min),new dn(a.max,l.max))},_curveExtremesFor:function(e,t){var n=this._curveExtremes(e[0][t],e[1][t],e[2][t],e[3][t]);return{min:V(n.min,t,e),max:V(n.max,t,e)}},_curveExtremes:function(e,t,n,i){var o,r,s=e-3*t+3*n-i,a=-2*(e-2*t+n),l=e-t,c=Math.sqrt(a*a-4*s*l),d=0,u=1;return 0===s?0!==a&&(d=u=-l/a):isNaN(c)||(d=(-a+c)/(2*s),u=(-a-c)/(2*s)),o=Math.max(Math.min(d,u),0),(o<0||o>1)&&(o=0),r=Math.min(Math.max(d,u),1),(r>1||r<0)&&(r=1),{min:o,max:r}},_intersectionsTo:function(e,t){var n;return n=this.controlOut()&&e.controlIn()?$([this.anchor(),this.controlOut(),e.controlIn(),e.anchor()],t,this.bboxTo(e)):K(this.anchor(),e.anchor(),t)},_isOnCurveTo:function(e,t,n,i){var o,r,s,a,l,c,d,u=this.bboxTo(e).expand(n,n);if(u.containsPoint(t))return o=this.anchor(),r=this.controlOut(),s=e.controlIn(),a=e.anchor(),"start"===i&&o.distanceTo(t)<=n?!O(o,r,t):"end"===i&&a.distanceTo(t)<=n?!O(a,s,t):(l=[o,r,s,a],!(!G(l,t,"x","y",n)&&!G(l,t,"y","x",n))||(c=A().rotate(45,t),d=[o.transformCopy(c),r.transformCopy(c),s.transformCopy(c),a.transformCopy(c)],G(d,t,"x","y",n)||G(d,t,"y","x",n)))},_isOnLineTo:function(e,t,n){var i=this.anchor(),o=e.anchor(),s=r(Math.atan2(o.y-i.y,o.x-i.x)),a=new hn([i.x,i.y-n/2],[i.distanceTo(o),n]);return a.containsPoint(t.transformCopy(A().rotate(-s,i)))},_isOnPathTo:function(e,t,n,i){var o;return o=this.controlOut()&&e.controlIn()?this._isOnCurveTo(e,t,n/2,i):this._isOnLineTo(e,t,n)}}),N(Bn.prototype,["anchor","controlIn","controlOut"]),Qt.extend(Bn.prototype),Ln=pn.extend({init:function(e){pn.fn.init.call(this,e),this.segments=new zn,this.segments.addObserver(this),i(this.options.stroke)||(this.stroke("#000"),i(this.options.stroke.lineJoin)||this.options.set("stroke.lineJoin","miter"))},moveTo:function(e,t){return this.suspend(),this.segments.elements([]),this.resume(),this.lineTo(e,t),this},lineTo:function(e,t){var n=i(t)?new dn(e,t):e,o=new Bn(n);return this.segments.push(o),this},curveTo:function(e,t,n){var i,o;return this.segments.length>0&&(i=u(this.segments),o=new Bn(n,t),this.suspend(),i.controlOut(e),this.resume(),this.segments.push(o)),this},arc:function(e,t,n,i,o){var r,s,a,l,c;return this.segments.length>0&&(r=u(this.segments),s=r.anchor(),a=p(e),l=new dn(s.x-n*Math.cos(a),s.y-i*Math.sin(a)),c=new Tn(l,{startAngle:e,endAngle:t,radiusX:n,radiusY:i,anticlockwise:o}),this._addArcSegments(c)),this},arcTo:function(e,t,n,i,o,r){var s,a,l;return this.segments.length>0&&(s=u(this.segments),a=s.anchor(),l=Tn.fromPoints(a,e,t,n,i,o,r),this._addArcSegments(l)),this},_addArcSegments:function(e){var t,n,i=this;for(this.suspend(),t=e.curvePoints(),n=1;n<t.length;n+=3)i.curveTo(t[n],t[n+1],t[n+2]);this.resume(),this.geometryChange()},close:function(){return this.options.closed=!0,this.geometryChange(),this},rawBBox:function(){return this._bbox()},_containsPoint:function(e){var t,n,i,o=this.segments,r=o.length,s=0;for(i=1;i<r;i++)t=o[i-1],n=o[i],s+=t._intersectionsTo(n,e);return!this.options.closed&&o[0].anchor().equals(o[r-1].anchor())||(s+=K(o[0].anchor(),o[r-1].anchor(),e)),s%2!==0},_isOnPath:function(e,t){var n,i=this.segments,o=i.length,r=t||this.options.stroke.width;if(o>1){if(i[0]._isOnPathTo(i[1],e,r,"start"))return!0;for(n=2;n<=o-2;n++)if(i[n-1]._isOnPathTo(i[n],e,r))return!0;if(i[o-2]._isOnPathTo(i[o-1],e,r,"end"))return!0}return!1},_bbox:function(e){var t,n,i,o,r=this.segments,s=r.length;if(1===s)n=r[0].anchor().transformCopy(e),t=new hn(n,un.ZERO);else if(s>0)for(i=1;i<s;i++)o=r[i-1].bboxTo(r[i],e),t=t?hn.union(t,o):o;return t}}),Ln.fromRect=function(e,t){return new Ln(t).moveTo(e.topLeft()).lineTo(e.topRight()).lineTo(e.bottomRight()).lineTo(e.bottomLeft()).close()},Ln.fromPoints=function(e,t){var n,i,o;if(e){for(n=new Ln(t),i=0;i<e.length;i++)o=dn.create(e[i]),o&&(0===i?n.moveTo(o):n.lineTo(o));return n}},Ln.fromArc=function(e,t){var n=new Ln(t),i=e.startAngle,o=e.pointAt(i);return n.moveTo(o.x,o.y),n.arc(i,e.endAngle,e.radiusX,e.radiusY,e.anticlockwise),n},Ln.prototype.nodeType="Path",_n.extend(Ln.prototype),wn.extend(Ln.prototype),Hn="#000",Nn=pn.extend({init:function(e,t){void 0===e&&(e=new Tn),void 0===t&&(t={}),pn.fn.init.call(this,t),this.geometry(e),i(this.options.stroke)||this.stroke(Hn)},_bbox:function(e){return this._geometry.bbox(e)},rawBBox:function(){return this.geometry().bbox()},toPath:function(){var e,t=new Ln,n=this.geometry().curvePoints();if(n.length>0)for(t.moveTo(n[0].x,n[0].y),e=1;e<n.length;e+=3)t.curveTo(n[e],n[e+1],n[e+2]);return t},_containsPoint:function(e){return this.geometry().containsPoint(e)},_isOnPath:function(e){return this.geometry()._isOnPath(e,this.options.stroke.width/2)}}),Nn.prototype.nodeType="Arc",_n.extend(Nn.prototype),wn.extend(Nn.prototype),M(Nn.prototype,["geometry"]),On=pn.extend({init:function(e){pn.fn.init.call(this,e),this.paths=new zn,this.paths.addObserver(this),i(this.options.stroke)||this.stroke("#000")},moveTo:function(e,t){var n=new Ln;return n.moveTo(e,t),this.paths.push(n),this},lineTo:function(e,t){return this.paths.length>0&&u(this.paths).lineTo(e,t),this},curveTo:function(e,t,n){return this.paths.length>0&&u(this.paths).curveTo(e,t,n),this},arc:function(e,t,n,i,o){return this.paths.length>0&&u(this.paths).arc(e,t,n,i,o),this},arcTo:function(e,t,n,i,o,r){return this.paths.length>0&&u(this.paths).arcTo(e,t,n,i,o,r),this},close:function(){return this.paths.length>0&&u(this.paths).close(),this},_bbox:function(e){return Q(this.paths,!0,e)},rawBBox:function(){return Q(this.paths,!1)},_containsPoint:function(e){var t,n=this.paths;for(t=0;t<n.length;t++)if(n[t]._containsPoint(e))return!0;return!1},_isOnPath:function(e){var t,n=this.paths,i=this.options.stroke.width;for(t=0;t<n.length;t++)if(n[t]._isOnPath(e,i))return!0;return!1},_clippedBBox:function(e){return X(this.paths,this.currentTransform(e))}}),On.prototype.nodeType="MultiPath",_n.extend(On.prototype),wn.extend(On.prototype),Vn="12px sans-serif",Un="#000",Wn=pn.extend({init:function(e,t,n){void 0===t&&(t=new dn),void 0===n&&(n={}),pn.fn.init.call(this,n),this.content(e),this.position(t),this.options.font||(this.options.font=Vn),i(this.options.fill)||this.fill(Un)},content:function(e){return i(e)?(this.options.set("content",e),this):this.options.get("content")},measure:function(){var e=qt.measureText(this.content(),{font:this.options.get("font")});return e},rect:function(){var e=this.measure(),t=this.position().clone();return new hn(t,[e.width,e.height])},bbox:function(e){var t=D(this.currentTransform(e));return this.rect().bbox(t)},rawBBox:function(){return this.rect().bbox()},_containsPoint:function(e){return this.rect().containsPoint(e)}}),Wn.prototype.nodeType="Text",_n.extend(Wn.prototype),N(Wn.prototype,["position"]),jn=pn.extend({init:function(e,t,n){void 0===t&&(t=new hn),void 0===n&&(n={}),pn.fn.init.call(this,n),this.src(e),this.rect(t)},src:function(e){return i(e)?(this.options.set("src",e),this):this.options.get("src")},bbox:function(e){var t=D(this.currentTransform(e));return this._rect.bbox(t)},rawBBox:function(){return this._rect.bbox()},_containsPoint:function(e){return this._rect.containsPoint(e)},_hasFill:function(){return this.src()}}),jn.prototype.nodeType="Image",M(jn.prototype,["rect"]),qn={extend:function(e,t){e.traverse=function(e){var n,i,o=this[t];for(n=0;n<o.length;n++)i=o[n],i.traverse?i.traverse(e):e(i);return this}}},Gn=pn.extend({init:function(e){pn.fn.init.call(this,e),this.children=[]},childrenChange:function(e,t,n){this.trigger("childrenChange",{action:e,items:t,index:n})},append:function(){return t(this.children,arguments),this._reparent(arguments,this),this.childrenChange("add",arguments),this},insert:function(e,t){return this.children.splice(e,0,t),t.parent=this,this.childrenChange("add",[t],e),this},insertAt:function(e,t){return this.insert(t,e)},remove:function(e){var t=this.children.indexOf(e);return t>=0&&(this.children.splice(t,1),e.parent=null,this.childrenChange("remove",[e],t)),this},removeAt:function(e){if(0<=e&&e<this.children.length){var t=this.children[e];this.children.splice(e,1),t.parent=null,this.childrenChange("remove",[t],e)}return this},clear:function(){var e=this.children;return this.children=[],this._reparent(e,null),this.childrenChange("remove",e,0),this},bbox:function(e){return Q(this.children,!0,this.currentTransform(e))},rawBBox:function(){return Q(this.children,!1);
},_clippedBBox:function(e){return X(this.children,this.currentTransform(e))},currentTransform:function(e){return pn.prototype.currentTransform.call(this,e)||null},containsPoint:function(e,t){var n,i,o;if(this.visible())for(n=this.children,i=this.currentTransform(t),o=0;o<n.length;o++)if(n[o].containsPoint(e,i))return!0;return!1},_reparent:function(e,t){var n,i,o,r=this;for(n=0;n<e.length;n++)i=e[n],o=i.parent,o&&o!==r&&o.remove&&o.remove(i),i.parent=t}}),Gn.prototype.nodeType="Group",qn.extend(Gn.prototype,"children"),$n={alignContent:"start",justifyContent:"start",alignItems:"start",spacing:0,orientation:"horizontal",lineSpacing:0,wrap:!0,revers:!1},Kn=function(e,t){e.forEach(t)},Yn=function(e,t){var n,i=e.length;for(n=i-1;n>=0;n--)t(e[n],n)},Qn=Gn.extend({init:function(t,n){Gn.fn.init.call(this,e.extend({},$n,n)),this._rect=t,this._fieldMap={}},rect:function(e){return e?(this._rect=e,this):this._rect},_initMap:function(){var e=this.options,t=this._fieldMap;"horizontal"===e.orientation?(t.sizeField="width",t.groupsSizeField="height",t.groupAxis="x",t.groupsAxis="y"):(t.sizeField="height",t.groupsSizeField="width",t.groupAxis="y",t.groupsAxis="x"),e.reverse?(this.forEach=Yn,this.justifyAlign=ee):(this.forEach=Kn,this.justifyAlign=J)},reflow:function(){var e,t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C=this;if(this._rect&&0!==this.children.length){for(this._initMap(),this.options.transform&&this.transform(null),e=this.options,t=this._rect,n=this._initGroups(),i=n.groups,o=n.groupsSize,r=this._fieldMap,s=r.sizeField,a=r.groupsSizeField,l=r.groupAxis,c=r.groupsAxis,d=new dn,u=new dn,h=new un,f=J(o,t,e.alignContent,c,a),v=function(t,n){var i=m.elements[n];u[l]=p,u[c]=J(t.size[a],g,e.alignItems,c,a),Z(u,t,i),p+=t.size[s]+e.spacing},_=0;_<i.length;_++)m=i[_],d[l]=p=C.justifyAlign(m.size,t,e.justifyContent,l,s),d[c]=f,h[s]=m.size,h[a]=m.lineSize,g=new hn(d,h),C.forEach(m.bboxes,v),f+=m.lineSize+e.lineSpacing;!e.wrap&&m.size>t.size[s]&&(b=t.size[s]/g.size[s],w=g.topLeft().scale(b,b),y=g.size[a]*b,k=J(y,t,e.alignContent,c,a),x=A(),"x"===l?x.translate(t.origin.x-w.x,k-w.y):x.translate(k-w.x,t.origin.y-w.y),x.scale(b,b),this.transform(x))}},_initGroups:function(){var e,t,n,i=this,o=this,r=o.options,s=o.children,a=r.lineSpacing,l=r.wrap,c=r.spacing,d=this._fieldMap.sizeField,u=this._newGroup(),h=[],f=function(){h.push(u),p+=u.lineSize+a},p=-a;for(e=0;e<s.length;e++)t=s[e],n=s[e].clippedBBox(),t.visible()&&n&&(l&&u.size+n.size[d]+c>i._rect.size[d]?0===u.bboxes.length?(i._addToGroup(u,n,t),f(),u=i._newGroup()):(f(),u=i._newGroup(),i._addToGroup(u,n,t)):i._addToGroup(u,n,t));return u.bboxes.length&&f(),{groups:h,groupsSize:p}},_addToGroup:function(e,t,n){e.size+=t.size[this._fieldMap.sizeField]+this.options.spacing,e.lineSize=Math.max(t.size[this._fieldMap.groupsSizeField],e.lineSize),e.bboxes.push(t),e.elements.push(n)},_newGroup:function(){return{lineSize:0,size:-this.options.spacing,bboxes:[],elements:[]}}}),Xn=pn.extend({init:function(e,t){void 0===e&&(e=new hn),void 0===t&&(t={}),pn.fn.init.call(this,t),this.geometry(e),i(this.options.stroke)||this.stroke("#000")},_bbox:function(e){return this._geometry.bbox(e)},rawBBox:function(){return this._geometry.bbox()},_containsPoint:function(e){return this._geometry.containsPoint(e)},_isOnPath:function(e){return this.geometry()._isOnPath(e,this.options.stroke.width/2)}}),Xn.prototype.nodeType="Rect",_n.extend(Xn.prototype),wn.extend(Xn.prototype),M(Xn.prototype,["geometry"]),Zn=Fn.extend({_change:function(){this.optionsChange({field:"stops"})}}),Jn=jt.extend({init:function(e,t,n){this.options=new ln({offset:e,color:t,opacity:i(n)?n:1}),this.options.addObserver(this)}}),Jn.create=function(e){if(i(e)){var t;return t=e instanceof Jn?e:e.length>1?new Jn(e[0],e[1],e[2]):new Jn(e.offset,e.color,e.opacity)}},pe(Jn.prototype,["offset","color","opacity"]),Qt.extend(Jn.prototype),ei=jt.extend({init:function(e){void 0===e&&(e={}),this.stops=new Zn(this._createStops(e.stops)),this.stops.addObserver(this),this._userSpace=e.userSpace,this.id=o()},userSpace:function(e){return i(e)?(this._userSpace=e,this.optionsChange(),this):this._userSpace},_createStops:function(e){var t,n;for(void 0===e&&(e=[]),t=[],n=0;n<e.length;n++)t.push(Jn.create(e[n]));return t},addStop:function(e,t,n){this.stops.push(new Jn(e,t,n))},removeStop:function(e){var t=this.stops.indexOf(e);t>=0&&this.stops.splice(t,1)}}),ei.prototype.nodeType="Gradient",Qt.extend(ei.prototype),e.extend(ei.prototype,{optionsChange:function(e){this.trigger("optionsChange",{field:"gradient"+(e?"."+e.field:""),value:this})},geometryChange:function(){this.optionsChange()}}),ti=ei.extend({init:function(e){void 0===e&&(e={}),ei.fn.init.call(this,e),this.start(e.start||new dn),this.end(e.end||new dn(1,0))}}),N(ti.prototype,["start","end"]),ni=ei.extend({init:function(e){void 0===e&&(e={}),ei.fn.init.call(this,e),this.center(e.center||new dn),this._radius=i(e.radius)?e.radius:1,this._fallbackFill=e.fallbackFill},radius:function(e){return i(e)?(this._radius=e,this.geometryChange(),this):this._radius},fallbackFill:function(e){return i(e)?(this._fallbackFill=e,this.optionsChange(),this):this._fallbackFill}}),N(ni.prototype,["center"]),ii={swing:me,linear:ge,easeOutElastic:ve},oi=Date.now||function(){return(new Date).getTime()},ri=jt.extend({init:function(t,n){this.options=e.extend({},this.options,n),this.element=t},setup:function(){},step:function(){},play:function(){var e,t,n,i=this,o=this.options,r=o.duration,s=o.delay;void 0===s&&(s=0),e=ii[o.easing],t=oi()+s,n=t+r,0===r?(this.step(1),this.abort()):setTimeout(function(){var o=function(){var s,a,l,c;i._stopped||(s=oi(),a=h(s-t,0,r),l=a/r,c=e(l,a,0,1,r),i.step(c),s<n?kendo.animationFrame(o):i.abort())};o()},s)},abort:function(){this._stopped=!0},destroy:function(){this.abort()}}),ri.prototype.options={duration:500,easing:"swing"},si=jt.extend({init:function(){this._items=[]},register:function(e,t){this._items.push({name:e,type:t})},create:function(e,t){var n,i,o,r=this._items;if(t&&t.type)for(i=t.type.toLowerCase(),o=0;o<r.length;o++)if(r[o].name.toLowerCase()===i){n=r[o];break}if(n)return new n.type(e,t)}}),si.current=new si,ri.create=function(e,t,n){return si.current.create(e,t,n)},ai={l:function(e,t){var n,i,o=t.parameters,r=t.position;for(n=0;n<o.length;n+=2)i=new dn(o[n],o[n+1]),t.isRelative&&i.translateWith(r),e.lineTo(i.x,i.y),r.x=i.x,r.y=i.y},c:function(e,t){var n,i,o,r,s=t.parameters,a=t.position;for(n=0;n<s.length;n+=6)i=new dn(s[n],s[n+1]),o=new dn(s[n+2],s[n+3]),r=new dn(s[n+4],s[n+5]),t.isRelative&&(o.translateWith(a),i.translateWith(a),r.translateWith(a)),e.curveTo(i,o,r),a.x=r.x,a.y=r.y},v:function(e,t){var n=t.isRelative?0:t.position.x;_e(t.parameters,!0,n),this.l(e,t)},h:function(e,t){var n=t.isRelative?0:t.position.y;_e(t.parameters,!1,n),this.l(e,t)},a:function(e,t){var n,i,o,r,s,a,l,c=t.parameters,d=t.position;for(n=0;n<c.length;n+=7)i=c[n],o=c[n+1],r=c[n+2],s=c[n+3],a=c[n+4],l=new dn(c[n+5],c[n+6]),t.isRelative&&l.translateWith(d),d.x===l.x&&d.y===l.y||(e.arcTo(l,i,o,s,a,r),d.x=l.x,d.y=l.y)},s:function(e,t){var n,i,o,r,s,a=t.parameters,l=t.position,c=t.previousCommand;for("s"!==c&&"c"!==c||(n=u(u(e.paths).segments).controlIn()),i=0;i<a.length;i+=4)o=new dn(a[i],a[i+1]),r=new dn(a[i+2],a[i+3]),s=void 0,t.isRelative&&(o.translateWith(l),r.translateWith(l)),s=n?be(n,l):l.clone(),n=o,e.curveTo(s,o,r),l.x=r.x,l.y=r.y},q:function(e,t){var n,i,o,r,s=t.parameters,a=t.position;for(n=0;n<s.length;n+=4)i=new dn(s[n],s[n+1]),o=new dn(s[n+2],s[n+3]),t.isRelative&&(i.translateWith(a),o.translateWith(a)),r=we(a,i,o),e.curveTo(r.controlOut,r.controlIn,o),a.x=o.x,a.y=o.y},t:function(e,t){var n,i,o,r,s,a=t.parameters,l=t.position,c=t.previousCommand;for("q"!==c&&"t"!==c||(i=u(u(e.paths).segments),n=i.controlIn().clone().translateWith(l.scaleCopy(-1/3)).scale(1.5)),o=0;o<a.length;o+=2)r=new dn(a[o],a[o+1]),t.isRelative&&r.translateWith(l),n=n?be(n,l):l.clone(),s=we(l,n,r),e.curveTo(s.controlOut,s.controlIn,r),l.x=r.x,l.y=r.y}},li=1/3,ci=/([a-df-z]{1})([^a-df-z]*)(z)?/gi,di=/[,\s]?([+\-]?(?:\d*\.\d+|\d+)(?:[eE][+\-]?\d+)?)/g,ui="m",hi="z",fi=jt.extend({parse:function(e,t){var n,i=new On(t),o=new dn;return e.replace(ci,function(e,t,r,s){var a=t.toLowerCase(),l=a===t,c=ye(r.trim());if(a===ui&&(l?(o.x+=c[0],o.y+=c[1]):(o.x=c[0],o.y=c[1]),i.moveTo(o.x,o.y),c.length>2&&(a="l",c.splice(0,2))),ai[a])ai[a](i,{parameters:c,position:o,isRelative:l,previousCommand:n}),s&&s.toLowerCase()===hi&&i.close();else if(a!==ui)throw Error("Error while parsing SVG path. Unsupported command: "+a);n=a}),i}}),fi.current=new fi,Ln.parse=function(e,t){return fi.current.parse(e,t)},pi=jt.extend({init:function(){this._items=[]},register:function(e,t,n){var i=this._items,o=i[0],r={name:e,type:t,order:n};!o||n<o.order?i.unshift(r):i.push(r)},create:function(e,t){var n,i,o=this._items,r=o[0];if(t&&t.type)for(n=t.type.toLowerCase(),i=0;i<o.length;i++)if(o[i].name===n){r=o[i];break}return r?new r.type(e,t):void kendo.logToConsole("Warning: Unable to create Kendo UI Drawing Surface. Possible causes:\n- The browser does not support SVG and Canvas. User agent: "+navigator.userAgent)}}),pi.current=new pi,mi=["click","mouseenter","mouseleave","mousemove","resize"],gi=kendo.Observable.extend({init:function(t,n){kendo.Observable.fn.init.call(this),this.options=e.extend({},n),this.element=t,this.element._kendoExportVisual=this.exportVisual.bind(this),this._click=this._handler("click"),this._mouseenter=this._handler("mouseenter"),this._mouseleave=this._handler("mouseleave"),this._mousemove=this._handler("mousemove"),this._visual=new Gn,k(t,this.options),this.bind(mi,this.options),this._enableTracking()},draw:function(e){this._visual.children.push(e)},clear:function(){this._visual.children=[]},destroy:function(){this._visual=null,this.element._kendoExportVisual=null,this.unbind()},eventTarget:function(e){for(var t,n=this,i=c(e);!t&&i&&(t=i._kendoNode,i!==n.element);)i=i.parentElement;if(t)return t.srcElement},exportVisual:function(){return this._visual},getSize:function(){return k(this.element)},currentSize:function(e){return e?void(this._size=e):this._size},setSize:function(e){k(this.element,e),this.currentSize(e),this._resize()},resize:function(e){var t=this.getSize(),n=this.currentSize();(e||(t.width>0||t.height>0)&&(!n||t.width!==n.width||t.height!==n.height))&&(this.currentSize(t),this._resize(t,e),this.trigger("resize",t))},size:function(e){return e?void this.setSize(e):this.getSize()},suspendTracking:function(){this._suspendedTracking=!0},resumeTracking:function(){this._suspendedTracking=!1},_enableTracking:function(){},_resize:function(){},_handler:function(e){var t=this;return function(n){var i=t.eventTarget(n);i&&!t._suspendedTracking&&t.trigger(e,{element:i,originalEvent:n,type:e})}},_elementOffset:function(){var e=this.element,t=w(e,["paddingLeft","paddingTop"]),n=t.paddingLeft,i=t.paddingTop,o=b(e),r=o.left,s=o.top;return{left:r+parseInt(n,10),top:s+parseInt(i,10)}},_surfacePoint:function(e){var t=this._elementOffset(),n=l(e),i=n.x-t.left,o=n.y-t.top;return new dn(i,o)}}),gi.create=function(e,t){return pi.current.create(e,t)},gi.support={},vi=jt.extend({init:function(e){this.childNodes=[],this.parent=null,e&&(this.srcElement=e,this.observe())},destroy:function(){var e,t,n=this;for(this.srcElement&&this.srcElement.removeObserver(this),e=this.childNodes,t=0;t<e.length;t++)n.childNodes[t].destroy();this.parent=null},load:function(){},observe:function(){this.srcElement&&this.srcElement.addObserver(this)},append:function(e){this.childNodes.push(e),e.parent=this},insertAt:function(e,t){this.childNodes.splice(t,0,e),e.parent=this},remove:function(e,t){var n,i=this,o=e+t;for(n=e;n<o;n++)i.childNodes[n].removeSelf();this.childNodes.splice(e,t)},removeSelf:function(){this.clear(),this.destroy()},clear:function(){this.remove(0,this.childNodes.length)},invalidate:function(){this.parent&&this.parent.invalidate()},geometryChange:function(){this.invalidate()},optionsChange:function(){this.invalidate()},childrenChange:function(e){"add"===e.action?this.load(e.items,e.index):"remove"===e.action&&this.remove(e.index,e.items.length),this.invalidate()}}),_i={},bi="http://www.w3.org/2000/svg",wi="none",yi=function(e,t){e.innerHTML=t},"undefined"!=typeof document&&(ki="<svg xmlns='"+bi+"'></svg>",xi=document.createElement("div"),Ci="undefined"!=typeof DOMParser,xi.innerHTML=ki,Ci&&xi.firstChild.namespaceURI!==bi&&(yi=function(e,t){var n=new DOMParser,i=n.parseFromString(t,"text/xml"),o=document.adoptNode(i.documentElement);e.innerHTML="",e.appendChild(o)})),Si=yi,Ti="transform",Di={clip:"clip-path",fill:"fill"},Ai=vi.extend({init:function(e,t){vi.fn.init.call(this,e),this.definitions={},this.options=t},destroy:function(){this.element&&(this.element._kendoNode=null,this.element=null),this.clearDefinitions(),vi.fn.destroy.call(this)},load:function(e,t){var n,o,r,s,a,l=this;for(n=0;n<e.length;n++)o=e[n],r=o.children,s=new _i[o.nodeType](o,l.options),i(t)?l.insertAt(s,t):l.append(s),s.createDefinitions(),r&&r.length>0&&s.load(r),a=l.element,a&&s.attachTo(a,t)},root:function(){for(var e=this;e.parent;)e=e.parent;return e},attachTo:function(e,t){var n,o=document.createElement("div");Si(o,"<svg xmlns='"+bi+"' version='1.1'>"+this.render()+"</svg>"),n=o.firstChild.firstChild,n&&(i(t)?e.insertBefore(n,e.childNodes[t]||null):e.appendChild(n),this.setElement(n))},setElement:function(e){var t,n,i;for(this.element&&(this.element._kendoNode=null),this.element=e,this.element._kendoNode=this,t=this.childNodes,n=0;n<t.length;n++)i=e.childNodes[n],t[n].setElement(i)},clear:function(){var e,t;for(this.clearDefinitions(),this.element&&(this.element.innerHTML=""),e=this.childNodes,t=0;t<e.length;t++)e[t].destroy();this.childNodes=[]},removeSelf:function(){if(this.element){var e=this.element.parentNode;e&&e.removeChild(this.element),this.element=null}vi.fn.removeSelf.call(this)},template:function(){return this.renderChildren()},render:function(){return this.template()},renderChildren:function(){var e,t=this.childNodes,n="";for(e=0;e<t.length;e++)n+=t[e].render();return n},optionsChange:function(e){var t=e.field,n=e.value;"visible"===t?this.css("display",n?"":wi):Di[t]&&Se(t,n)?this.updateDefinition(t,n):"opacity"===t?this.attr("opacity",n):"cursor"===t?this.css("cursor",n):"id"===t&&(n?this.attr("id",n):this.removeAttr("id")),vi.fn.optionsChange.call(this,e)},attr:function(e,t){this.element&&this.element.setAttribute(e,t)},allAttr:function(e){var t,n=this;for(t=0;t<e.length;t++)n.attr(e[t][0],e[t][1])},css:function(e,t){this.element&&(this.element.style[e]=t)},allCss:function(e){var t,n=this;for(t=0;t<e.length;t++)n.css(e[t][0],e[t][1])},removeAttr:function(e){this.element&&this.element.removeAttribute(e)},mapTransform:function(e){var t=[];return e&&t.push([Ti,"matrix("+e.matrix().toString(6)+")"]),t},renderTransform:function(){return xe(this.mapTransform(this.srcElement.transform()))},transformChange:function(e){e?this.allAttr(this.mapTransform(e)):this.removeAttr(Ti)},mapStyle:function(){var e=this.srcElement.options,t=[["cursor",e.cursor]];return e.visible===!1&&t.push(["display",wi]),t},renderStyle:function(){return ke("style",Ce(this.mapStyle(!0)))},renderOpacity:function(){return ke("opacity",this.srcElement.options.opacity)},renderId:function(){return ke("id",this.srcElement.options.id)},createDefinitions:function(){var e,t,n,i,o=this.srcElement,r=this.definitions;if(o){e=o.options;for(n in Di)i=e.get(n),i&&Se(n,i)&&(r[n]=i,t=!0);t&&this.definitionChange({action:"add",definitions:r})}},definitionChange:function(e){this.parent&&this.parent.definitionChange(e)},updateDefinition:function(e,t){var n=this.definitions,i=n[e],o=Di[e],r={};i&&(r[e]=i,this.definitionChange({action:"remove",definitions:r}),delete n[e]),t?(r[e]=t,this.definitionChange({action:"add",definitions:r}),n[e]=t,this.attr(o,this.refUrl(t.id))):i&&this.removeAttr(o)},clearDefinitions:function(){var e=this.definitions;this.definitionChange({action:"remove",definitions:e}),this.definitions={}},renderDefinitions:function(){return xe(this.mapDefinitions())},mapDefinitions:function(){var e,t=this,n=this.definitions,i=[];for(e in n)i.push([Di[e],t.refUrl(n[e].id)]);return i},refUrl:function(e){var t=(this.options||{}).skipBaseHref;return De(e,t)}}),Ei=Ai.extend({template:function(){return"<stop "+this.renderOffset()+" "+this.renderStyle()+" />"},renderOffset:function(){return ke("offset",this.srcElement.offset())},mapStyle:function(){var e=this.srcElement;return[["stop-color",e.color()],["stop-opacity",e.opacity()]]},optionsChange:function(e){"offset"===e.field?this.attr(e.field,e.value):"color"!==e.field&&"opacity"!==e.field||this.css("stop-"+e.field,e.value)}}),Ii=Ai.extend({init:function(e){Ai.fn.init.call(this,e),this.id=e.id,this.loadStops()},loadStops:function(){var e,t,n=this,i=this.srcElement.stops,o=this.element;for(e=0;e<i.length;e++)t=new Ei(i[e]),n.append(t),o&&t.attachTo(o)},optionsChange:function(e){"gradient.stops"===e.field?(vi.prototype.clear.call(this),this.loadStops()):"gradient"===e.field&&this.allAttr(this.mapCoordinates())},renderCoordinates:function(){return xe(this.mapCoordinates())},mapSpace:function(){return["gradientUnits",this.srcElement.userSpace()?"userSpaceOnUse":"objectBoundingBox"]}}),Mi=Ii.extend({template:function(){return"<linearGradient id='"+this.id+"' "+this.renderCoordinates()+">"+this.renderChildren()+"</linearGradient>"},mapCoordinates:function(){var e=this.srcElement,t=e.start(),n=e.end(),i=[["x1",t.x],["y1",t.y],["x2",n.x],["y2",n.y],this.mapSpace()];return i}}),Ri=Ii.extend({template:function(){return"<radialGradient id='"+this.id+"' "+this.renderCoordinates()+">"+this.renderChildren()+"</radialGradient>"},mapCoordinates:function(){var e=this.srcElement,t=e.center(),n=e.radius(),i=[["cx",t.x],["cy",t.y],["r",n],this.mapSpace()];return i}}),Fi=Ai.extend({init:function(e){Ai.fn.init.call(this),this.srcElement=e,this.id=e.id,this.load([e])},template:function(){return"<clipPath id='"+this.id+"'>"+this.renderChildren()+"</clipPath>"}}),zi=Ai.extend({init:function(){Ai.fn.init.call(this),this.definitionMap={}},attachTo:function(e){this.element=e},template:function(){return"<defs>"+this.renderChildren()+"</defs>"},definitionChange:function(e){var t=e.definitions,n=e.action;"add"===n?this.addDefinitions(t):"remove"===n&&this.removeDefinitions(t)},createDefinition:function(e,t){var n;return"clip"===e?n=Fi:"fill"===e&&(t instanceof ti?n=Mi:t instanceof ni&&(n=Ri)),new n(t)},addDefinitions:function(e){var t,n=this;for(t in e)n.addDefinition(t,e[t])},addDefinition:function(e,t){var n,i=this,o=i.element,r=i.definitionMap,s=t.id,a=r[s];a?a.count++:(n=this.createDefinition(e,t),r[s]={element:n,count:1},this.append(n),o&&n.attachTo(this.element))},removeDefinitions:function(e){var t,n=this;for(t in e)n.removeDefinition(e[t])},removeDefinition:function(e){var t=this.definitionMap,n=e.id,i=t[n];i&&(i.count--,0===i.count&&(this.remove(this.childNodes.indexOf(i.element),1),delete t[n]))}}),Pi=Ai.extend({init:function(e){Ai.fn.init.call(this),this.options=e,this.defs=new zi},attachTo:function(e){this.element=e,this.defs.attachTo(e.firstElementChild)},clear:function(){vi.prototype.clear.call(this)},template:function(){return this.defs.render()+this.renderChildren()},definitionChange:function(e){this.defs.definitionChange(e)}}),Bi="rtl",Li=gi.extend({init:function(t,n){gi.fn.init.call(this,t,n),this._root=new Pi(e.extend({rtl:w(t,"direction").direction===Bi},this.options)),Si(this.element,this._template()),this._rootElement=this.element.firstElementChild,Ae(this._rootElement),this._root.attachTo(this._rootElement),_(this.element,{click:this._click,mouseover:this._mouseenter,mouseout:this._mouseleave,mousemove:this._mousemove}),this.resize()},destroy:function(){this._root&&(this._root.destroy(),this._root=null,this._rootElement=null,x(this.element,{click:this._click,mouseover:this._mouseenter,mouseout:this._mouseleave,mousemove:this._mousemove})),gi.fn.destroy.call(this)},translate:function(e){var t=Math.round(e.x)+" "+Math.round(e.y)+" "+this._size.width+" "+this._size.height;this._offset=e,this._rootElement.setAttribute("viewBox",t)},draw:function(e){gi.fn.draw.call(this,e),this._root.load([e])},clear:function(){gi.fn.clear.call(this),this._root.clear()},svg:function(){return"<?xml version='1.0' ?>"+this._template()},exportVisual:function(){var e,t=this,n=t._visual,i=t._offset;return i&&(e=new Gn,e.children.push(n),e.transform(A().translate(-i.x,-i.y)),n=e),n},_resize:function(){this._offset&&this.translate(this._offset)},_template:function(){return"<svg style='width: 100%; height: 100%; overflow: hidden;' xmlns='"+bi+"' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>"+this._root.render()+"</svg>"}}),Li.prototype.type="svg","undefined"!=typeof document&&document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1")&&(gi.support.svg=!0,pi.current.register("svg",Li,10)),Hi=Ai.extend({template:function(){return"<g"+(this.renderId()+this.renderTransform()+this.renderStyle()+this.renderOpacity()+this.renderDefinitions())+">"+this.renderChildren()+"</g>"},optionsChange:function(e){"transform"===e.field&&this.transformChange(e.value),Ai.fn.optionsChange.call(this,e)}}),_i.Group=Hi,Ni={dot:[1.5,3.5],dash:[4,3.5],longdash:[8,3.5],dashdot:[3.5,3.5,1.5,3.5],longdashdot:[8,3.5,1.5,3.5],longdashdotdot:[8,3.5,1.5,3.5,1.5,3.5]},Oi="solid",Vi="butt",Ui={"fill.opacity":"fill-opacity","stroke.color":"stroke","stroke.width":"stroke-width","stroke.opacity":"stroke-opacity"},Wi=" ",ji=Ai.extend({geometryChange:function(){this.attr("d",this.renderData()),this.invalidate()},optionsChange:function(e){switch(e.field){case"fill":e.value?this.allAttr(this.mapFill(e.value)):this.removeAttr("fill");break;case"fill.color":this.allAttr(this.mapFill({color:e.value}));break;case"stroke":e.value?this.allAttr(this.mapStroke(e.value)):this.removeAttr("stroke");break;case"transform":this.transformChange(e.value);break;default:var t=Ui[e.field];t&&this.attr(t,e.value)}Ai.fn.optionsChange.call(this,e)},content:function(){this.element&&(this.element.textContent=this.srcElement.content())},renderData:function(){return this.printPath(this.srcElement)},printPath:function(e){var t,n,i,o,r,s=this,a=e.segments,l=a.length;if(l>0){for(t=[],o=1;o<l;o++)r=s.segmentType(a[o-1],a[o]),r!==i&&(i=r,t.push(r)),t.push("L"===r?s.printPoints(a[o].anchor()):s.printPoints(a[o-1].controlOut(),a[o].controlIn(),a[o].anchor()));return n="M"+this.printPoints(a[0].anchor())+Wi+t.join(Wi),e.options.closed&&(n+="Z"),n}},printPoints:function(){var e,t=arguments,n=t.length,i=[];for(e=0;e<n;e++)i.push(t[e].toString(3));return i.join(" ")},segmentType:function(e,t){return e.controlOut()&&t.controlIn()?"C":"L"},mapStroke:function(e){var t=[];return e&&!d(e.color)?(t.push(["stroke",e.color]),t.push(["stroke-width",e.width]),t.push(["stroke-linecap",this.renderLinecap(e)]),t.push(["stroke-linejoin",e.lineJoin]),i(e.opacity)&&t.push(["stroke-opacity",e.opacity]),i(e.dashType)&&t.push(["stroke-dasharray",this.renderDashType(e)])):t.push(["stroke",wi]),t},renderStroke:function(){return xe(this.mapStroke(this.srcElement.options.stroke))},renderDashType:function(e){var t,n,i,o=e.dashType,r=e.width;if(void 0===r&&(r=1),o&&o!==Oi){for(t=Ni[o.toLowerCase()],n=[],i=0;i<t.length;i++)n.push(t[i]*r);return n.join(" ")}},renderLinecap:function(e){var t=e.dashType,n=e.lineCap;return t&&"solid"!==t?Vi:n},mapFill:function(e){var t=[];return e&&"Gradient"===e.nodeType||(e&&!d(e.color)?(t.push(["fill",e.color]),i(e.opacity)&&t.push(["fill-opacity",e.opacity])):t.push(["fill",wi])),t},renderFill:function(){return xe(this.mapFill(this.srcElement.options.fill))},template:function(){return"<path "+this.renderId()+" "+this.renderStyle()+" "+this.renderOpacity()+" "+ke("d",this.renderData())+this.renderStroke()+this.renderFill()+this.renderDefinitions()+this.renderTransform()+"></path>"}}),_i.Path=ji,qi=ji.extend({renderData:function(){return this.printPath(this.srcElement.toPath())}}),_i.Arc=qi,Gi=ji.extend({geometryChange:function(){var e=this.center();this.attr("cx",e.x),this.attr("cy",e.y),this.attr("r",this.radius()),this.invalidate()},center:function(){return this.srcElement.geometry().center},radius:function(){return this.srcElement.geometry().radius},template:function(){return"<circle "+this.renderId()+" "+this.renderStyle()+" "+this.renderOpacity()+"cx='"+this.center().x+"' cy='"+this.center().y+"' r='"+this.radius()+"'"+this.renderStroke()+" "+this.renderFill()+" "+this.renderDefinitions()+this.renderTransform()+" ></circle>"}}),_i.Circle=Gi,$i=ji.extend({geometryChange:function(){var e=this.srcElement.geometry();this.attr("x",e.origin.x),this.attr("y",e.origin.y),this.attr("width",e.size.width),this.attr("height",e.size.height),this.invalidate()},size:function(){return this.srcElement.geometry().size},origin:function(){return this.srcElement.geometry().origin},template:function(){return"<rect "+this.renderId()+" "+this.renderStyle()+" "+this.renderOpacity()+" x='"+this.origin().x+"' y='"+this.origin().y+"' width='"+this.size().width+"' height='"+this.size().height+"' "+this.renderStroke()+" "+this.renderFill()+" "+this.renderDefinitions()+" "+this.renderTransform()+" />"}}),_i.Rect=$i,Ki=ji.extend({geometryChange:function(){this.allAttr(this.mapPosition()),this.invalidate()},optionsChange:function(e){"src"===e.field&&this.allAttr(this.mapSource()),ji.fn.optionsChange.call(this,e)},mapPosition:function(){var e=this.srcElement.rect(),t=e.topLeft();return[["x",t.x],["y",t.y],["width",e.width()+"px"],["height",e.height()+"px"]]},renderPosition:function(){return xe(this.mapPosition())},mapSource:function(e){var t=this.srcElement.src();return e&&(t=kendo.htmlEncode(t)),[["xlink:href",t]]},renderSource:function(){return xe(this.mapSource(!0))},template:function(){return"<image preserveAspectRatio='none' "+this.renderId()+" "+this.renderStyle()+" "+this.renderTransform()+" "+this.renderOpacity()+this.renderPosition()+" "+this.renderSource()+" "+this.renderDefinitions()+"></image>"}}),_i.Image=Ki,Yi=/&(?:[a-zA-Z]+|#\d+);/g,"undefined"!=typeof document&&(Ee._element=document.createElement("span")),Qi=ji.extend({geometryChange:function(){var e=this.pos();this.attr("x",e.x),this.attr("y",e.y),this.invalidate()},optionsChange:function(e){"font"===e.field?(this.attr("style",Ce(this.mapStyle())),this.geometryChange()):"content"===e.field&&ji.fn.content.call(this,this.srcElement.content()),ji.fn.optionsChange.call(this,e)},mapStyle:function(e){var t=ji.fn.mapStyle.call(this,e),n=this.srcElement.options.font;return e&&(n=kendo.htmlEncode(n)),t.push(["font",n],["white-space","pre"]),t},pos:function(){var e=this.srcElement.position(),t=this.srcElement.measure();return e.clone().setY(e.y+t.baseline)},renderContent:function(){var e=this.srcElement.content();return e=Ee(e),e=kendo.htmlEncode(e),qt.normalizeText(e)},renderTextAnchor:function(){var e;return!(this.options||{}).rtl||$t.msie||$t.edge||(e="end"),ke("text-anchor",e)},template:function(){return"<text "+this.renderId()+" "+this.renderTextAnchor()+" "+this.renderStyle()+" "+this.renderOpacity()+"x='"+this.pos().x+"' y='"+this.pos().y+"' "+this.renderStroke()+" "+this.renderTransform()+" "+this.renderDefinitions()+this.renderFill()+">"+this.renderContent()+"</text>"}}),_i.Text=Qi,Xi=ji.extend({renderData:function(){var e,t,n=this,i=this.srcElement.paths;if(i.length>0){for(e=[],t=0;t<i.length;t++)e.push(n.printPath(i[t]));return e.join(" ")}}}),_i.MultiPath=Xi,Zi={Circle:gn,Arc:Tn,Rect:hn,Point:dn,Segment:Bn,Matrix:cn,Size:un,toMatrix:D,Transformation:fn,transform:A},Ji={Surface:Li,RootNode:Pi,Node:Ai,GroupNode:Hi,ArcNode:qi,CircleNode:Gi,RectNode:$i,ImageNode:Ki,TextNode:Qi,PathNode:ji,MultiPathNode:Xi,DefinitionNode:zi,ClipNode:Fi,GradientStopNode:Ei,LinearGradientNode:Mi,RadialGradientNode:Ri,exportGroup:Ie},eo={},to=vi.extend({init:function(e){vi.fn.init.call(this,e),e&&this.initClip()},initClip:function(){var e=this.srcElement.clip();e&&(this.clip=e,e.addObserver(this))},clear:function(){this.srcElement&&this.srcElement.removeObserver(this),this.clearClip(),vi.fn.clear.call(this)},clearClip:function(){this.clip&&(this.clip.removeObserver(this),delete this.clip)},setClip:function(e){this.clip&&(e.beginPath(),Me(e,this.clip),e.clip())},optionsChange:function(e){"clip"===e.field&&(this.clearClip(),this.initClip()),vi.fn.optionsChange.call(this,e)},setTransform:function(e){if(this.srcElement){var t=this.srcElement.transform();t&&e.transform.apply(e,t.matrix().toArray(6))}},loadElements:function(e,t,n){var o,r,s,a,l=this;for(o=0;o<e.length;o++)r=e[o],s=r.children,a=new eo[r.nodeType](r,n),s&&s.length>0&&a.load(s,t,n),i(t)?l.insertAt(a,t):l.append(a)},load:function(e,t,n){this.loadElements(e,t,n),this.invalidate()},setOpacity:function(e){if(this.srcElement){var t=this.srcElement.opacity();i(t)&&this.globalAlpha(e,t)}},globalAlpha:function(e,t){var n=t;n&&e.globalAlpha&&(n*=e.globalAlpha),e.globalAlpha=n},visible:function(){var e=this.srcElement;return!e||e&&e.options.visible!==!1}}),no=to.extend({renderTo:function(e){var t,n,i;if(this.visible()){for(e.save(),this.setTransform(e),this.setClip(e),this.setOpacity(e),t=this.childNodes,n=0;n<t.length;n++)i=t[n],i.visible()&&i.renderTo(e);e.restore()}}}),qn.extend(no.prototype,"childNodes"),eo.Group=no,io=1e3/60,oo=no.extend({init:function(e){no.fn.init.call(this),this.canvas=e,this.ctx=e.getContext("2d");var t=this._invalidate.bind(this);this.invalidate=kendo.throttle(function(){kendo.animationFrame(t)},io)},destroy:function(){no.fn.destroy.call(this),this.canvas=null,this.ctx=null},load:function(e,t,n){this.loadElements(e,t,n),this._invalidate()},_invalidate:function(){this.ctx&&(this.ctx.clearRect(0,0,this.canvas.width,this.canvas.height),this.renderTo(this.ctx))}}),qn.extend(oo.prototype,"childNodes"),ro=jt.extend({init:function(){this.shapes=[]},_add:function(e,t){this.shapes.push({bbox:t,shape:e}),e._quadNode=this},pointShapes:function(e){var t,n=this.shapes,i=n.length,o=[];for(t=0;t<i;t++)n[t].bbox.containsPoint(e)&&o.push(n[t].shape);return o},insert:function(e,t){this._add(e,t)},remove:function(e){var t,n=this.shapes,i=n.length;for(t=0;t<i;t++)if(n[t].shape===e){n.splice(t,1);break}}}),so=ro.extend({init:function(e){ro.fn.init.call(this),this.children=[],this.rect=e},inBounds:function(e){var t=this.rect,n=t.bottomRight(),i=e.bottomRight(),o=t.origin.x<=e.origin.x&&t.origin.y<=e.origin.y&&i.x<=n.x&&i.y<=n.y;return o},pointShapes:function(e){var n,i=this.children,o=i.length,r=ro.fn.pointShapes.call(this,e);for(n=0;n<o;n++)t(r,i[n].pointShapes(e));return r},insert:function(e,t){var n,i=this.children,o=!1;if(this.inBounds(t)){if(this.shapes.length<4)this._add(e,t);else{for(i.length||this._initChildren(),n=0;n<i.length;n++)if(i[n].insert(e,t)){o=!0;break}o||this._add(e,t)}o=!0}return o},_initChildren:function(){var e=this,t=e.rect,n=e.children,i=t.center(),o=t.width()/2,r=t.height()/2;n.push(new so(new hn([t.origin.x,t.origin.y],[o,r])),new so(new hn([i.x,t.origin.y],[o,r])),new so(new hn([t.origin.x,i.y],[o,r])),new so(new hn([i.x,i.y],[o,r])))}}),ao=3e3,lo=1e4,co=75,uo=jt.extend({init:function(){this.initRoots()},initRoots:function(){this.rootMap={},this.root=new ro,this.rootElements=[]},clear:function(){var e,t=this,n=this.rootElements;for(e=0;e<n.length;e++)t.remove(n[e]);this.initRoots()},pointShape:function(e){var t,n=(this.rootMap[Math.floor(e.x/ao)]||{})[Math.floor(e.y/ao)],i=this.root.pointShapes(e);for(n&&(i=i.concat(n.pointShapes(e))),this.assignZindex(i),i.sort(Re),t=0;t<i.length;t++)if(i[t].containsPoint(e))return i[t]},assignZindex:function(e){var t,n,i,o,r,s=this;for(t=0;t<e.length;t++){for(n=e[t],i=0,o=Math.pow(lo,co),r=[];n;)r.push(n),n=n.parent;for(;r.length;)n=r.pop(),i+=((n.parent?n.parent.children:s.rootElements).indexOf(n)+1)*o,o/=lo;e[t]._zIndex=i}},optionsChange:function(e){"transform"!==e.field&&"stroke.width"!==e.field||this.bboxChange(e.element)},geometryChange:function(e){this.bboxChange(e.element);
},bboxChange:function(e){var t,n=this;if("Group"===e.nodeType)for(t=0;t<e.children.length;t++)n.bboxChange(e.children[t]);else e._quadNode&&e._quadNode.remove(e),this._insertShape(e)},add:function(e){var n=Array.isArray(e)?e.slice(0):[e];t(this.rootElements,n),this._insert(n)},childrenChange:function(e){var t,n=this;if("remove"===e.action)for(t=0;t<e.items.length;t++)n.remove(e.items[t]);else this._insert(Array.prototype.slice.call(e.items,0))},_insert:function(e){for(var n,i=this;e.length>0;)n=e.pop(),n.addObserver(i),"Group"===n.nodeType?t(e,n.children):i._insertShape(n)},_insertShape:function(e){var t,n,i,o,r=e.bbox();r&&(t=this.getSectors(r),n=t[0][0],i=t[1][0],this.inRoot(t)?this.root.insert(e,r):(o=this.rootMap,o[n]||(o[n]={}),o[n][i]||(o[n][i]=new so(new hn([n*ao,i*ao],[ao,ao]))),o[n][i].insert(e,r)))},remove:function(e){var t,n,i=this;if(e.removeObserver(this),"Group"===e.nodeType)for(t=e.children,n=0;n<t.length;n++)i.remove(t[n]);else e._quadNode&&(e._quadNode.remove(e),delete e._quadNode)},inRoot:function(e){return e[0].length>1||e[1].length>1},getSectors:function(e){var t,n,i=e.bottomRight(),o=Math.floor(i.x/ao),r=Math.floor(i.y/ao),s=[[],[]];for(t=Math.floor(e.origin.x/ao);t<=o;t++)s[0].push(t);for(n=Math.floor(e.origin.y/ao);n<=r;n++)s[1].push(n);return s}}),ho=jt.extend({init:function(e){e.bind("mouseenter",this._mouseenter.bind(this)),e.bind("mouseleave",this._mouseleave.bind(this)),this.element=e.element},clear:function(){this._resetCursor()},destroy:function(){this._resetCursor(),delete this.element},_mouseenter:function(e){var t=this._shapeCursor(e);t?(this._current||(this._defaultCursor=this._getCursor()),this._setCursor(t)):this._resetCursor()},_mouseleave:function(){this._resetCursor()},_shapeCursor:function(e){for(var t=e.element;t&&!i(t.options.cursor);)t=t.parent;if(t)return t.options.cursor},_getCursor:function(){if(this.element)return this.element.style.cursor},_setCursor:function(e){this.element&&(this.element.style.cursor=e,this._current=e)},_resetCursor:function(){this._current&&(this._setCursor(this._defaultCursor||""),delete this._current)}}),fo=gi.extend({init:function(e,t){var n,i;gi.fn.init.call(this,e,t),this.element.innerHTML=this._template(this),n=this.element.firstElementChild,i=k(e),n.width=i.width,n.height=i.height,this._rootElement=n,this._root=new oo(n),this._mouseTrackHandler=this._trackMouse.bind(this),_(this.element,{click:this._mouseTrackHandler,mousemove:this._mouseTrackHandler})},destroy:function(){gi.fn.destroy.call(this),this._root&&(this._root.destroy(),this._root=null),this._searchTree&&(this._searchTree.clear(),delete this._searchTree),this._cursor&&(this._cursor.destroy(),delete this._cursor),x(this.element,{click:this._mouseTrackHandler,mousemove:this._mouseTrackHandler})},draw:function(e){gi.fn.draw.call(this,e),this._root.load([e],void 0,this.options.cors),this._searchTree&&this._searchTree.add([e])},clear:function(){gi.fn.clear.call(this),this._root.clear(),this._searchTree&&this._searchTree.clear(),this._cursor&&this._cursor.clear()},eventTarget:function(e){var t,n;if(this._searchTree)return t=this._surfacePoint(e),n=this._searchTree.pointShape(t)},image:function(){var e,t,n=this,i=n._root,o=n._rootElement,r=[];return i.traverse(function(e){e.loading&&r.push(e.loading)}),e=Kt(),t=function(){i._invalidate();try{var t=o.toDataURL();e.resolve(t)}catch(n){e.reject(n)}},Yt(r).then(t,t),e},suspendTracking:function(){gi.fn.suspendTracking.call(this),this._searchTree&&(this._searchTree.clear(),delete this._searchTree)},resumeTracking:function(){var e,t,n;if(gi.fn.resumeTracking.call(this),!this._searchTree){for(this._searchTree=new uo,e=this._root.childNodes,t=[],n=0;n<e.length;n++)t.push(e[n].srcElement);this._searchTree.add(t)}},_resize:function(){this._rootElement.width=this._size.width,this._rootElement.height=this._size.height,this._root.invalidate()},_template:function(){return"<canvas style='width: 100%; height: 100%;'></canvas>"},_enableTracking:function(){this._searchTree=new uo,this._cursor=new ho(this),gi.fn._enableTracking.call(this)},_trackMouse:function(e){var t,n;this._suspendedTracking||(t=this.eventTarget(e),"click"!==e.type?(n=this._currentShape,n&&n!==t&&this.trigger("mouseleave",{element:n,originalEvent:e,type:"mouseleave"}),t&&n!==t&&this.trigger("mouseenter",{element:t,originalEvent:e,type:"mouseenter"}),this.trigger("mousemove",{element:t,originalEvent:e,type:"mousemove"}),this._currentShape=t):t&&this.trigger("click",{element:t,originalEvent:e,type:"click"}))}}),fo.prototype.type="canvas","undefined"!=typeof document&&document.createElement("canvas").getContext&&(gi.support.canvas=!0,pi.current.register("canvas",fo,20)),po=to.extend({renderTo:function(e){e.save(),this.setTransform(e),this.setClip(e),this.setOpacity(e),e.beginPath(),this.renderPoints(e,this.srcElement),this.setLineDash(e),this.setLineCap(e),this.setLineJoin(e),this.setFill(e),this.setStroke(e),e.restore()},setFill:function(e){var t=this.srcElement.options.fill,n=!1;return t&&("Gradient"===t.nodeType?(this.setGradientFill(e,t),n=!0):d(t.color)||(e.fillStyle=t.color,e.save(),this.globalAlpha(e,t.opacity),e.fill(),e.restore(),n=!0)),n},setGradientFill:function(e,t){var n,i,o,r,s=this.srcElement.rawBBox();t instanceof ti?(i=t.start(),o=t.end(),n=e.createLinearGradient(i.x,i.y,o.x,o.y)):t instanceof ni&&(r=t.center(),n=e.createRadialGradient(r.x,r.y,0,r.x,r.y,t.radius())),Fe(n,t.stops),e.save(),t.userSpace()||e.transform(s.width(),0,0,s.height(),s.origin.x,s.origin.y),e.fillStyle=n,e.fill(),e.restore()},setStroke:function(e){var t=this.srcElement.options.stroke;if(t&&!d(t.color)&&t.width>0)return e.strokeStyle=t.color,e.lineWidth=v(t.width,1),e.save(),this.globalAlpha(e,t.opacity),e.stroke(),e.restore(),!0},dashType:function(){var e=this.srcElement.options.stroke;if(e&&e.dashType)return e.dashType.toLowerCase()},setLineDash:function(e){var t,n=this.dashType();n&&n!==Oi&&(t=Ni[n],e.setLineDash?e.setLineDash(t):(e.mozDash=t,e.webkitLineDash=t))},setLineCap:function(e){var t=this.dashType(),n=this.srcElement.options.stroke;t&&t!==Oi?e.lineCap=Vi:n&&n.lineCap&&(e.lineCap=n.lineCap)},setLineJoin:function(e){var t=this.srcElement.options.stroke;t&&t.lineJoin&&(e.lineJoin=t.lineJoin)},renderPoints:function(e,t){Me(e,t)}}),eo.Path=po,mo=po.extend({renderPoints:function(e){var t=this.srcElement.toPath();Me(e,t)}}),eo.Arc=mo,go=po.extend({renderPoints:function(e){var t=this.srcElement.geometry(),n=t.center,i=t.radius;e.arc(n.x,n.y,i,0,2*Math.PI)}}),eo.Circle=go,vo=po.extend({renderPoints:function(e){var t=this.srcElement.geometry(),n=t.origin,i=t.size;e.rect(n.x,n.y,i.width,i.height)}}),eo.Rect=vo,_o=po.extend({init:function(e,t){po.fn.init.call(this,e),this.onLoad=this.onLoad.bind(this),this.onError=this.onError.bind(this),this.loading=Kt();var n=this.img=new Image;t&&!/^data:/i.test(e.src())&&(n.crossOrigin=t),n.src=e.src(),n.complete?this.onLoad():(n.onload=this.onLoad,n.onerror=this.onError)},renderTo:function(e){"resolved"===this.loading.state()&&(e.save(),this.setTransform(e),this.setClip(e),this.drawImage(e),e.restore())},optionsChange:function(e){"src"===e.field?(this.loading=Kt(),this.img.src=this.srcElement.src()):po.fn.optionsChange.call(this,e)},onLoad:function(){this.loading.resolve(),this.invalidate()},onError:function(){this.loading.reject(Error("Unable to load image '"+this.img.src+"'. Check for connectivity and verify CORS headers."))},drawImage:function(e){var t=this.srcElement.rect(),n=t.topLeft();e.drawImage(this.img,n.x,n.y,t.width(),t.height())}}),eo.Image=_o,bo=po.extend({renderTo:function(e){var t=this.srcElement,n=t.position(),i=t.measure();e.save(),this.setTransform(e),this.setClip(e),this.setOpacity(e),e.beginPath(),e.font=t.options.font,e.textAlign="left",this.setFill(e)&&e.fillText(t.content(),n.x,n.y+i.baseline),this.setStroke(e)&&(this.setLineDash(e),e.strokeText(t.content(),n.x,n.y+i.baseline)),e.restore()}}),eo.Text=bo,wo=po.extend({renderPoints:function(e){var t,n=this.srcElement.paths;for(t=0;t<n.length;t++)Me(e,n[t])}}),eo.MultiPath=wo,yo={Surface:fo,RootNode:oo,Node:to,GroupNode:no,ArcNode:mo,CircleNode:go,RectNode:vo,ImageNode:_o,TextNode:bo,PathNode:po,MultiPathNode:wo},ko=$t,xo="KENDO-PSEUDO-ELEMENT",Co={},So={},So._root=So,To=ko.msie||ko.edge,Do=Wn.extend({init:function(e,t,n){Wn.fn.init.call(this,e,t.getOrigin(),n),this._pdfRect=t},rect:function(){return this._pdfRect},rawBBox:function(){return this._pdfRect}}),Ao="undefined"!=typeof Element&&Element.prototype&&function(e){return e.matches?function(e,t){return e.matches(t)}:e.webkitMatchesSelector?function(e,t){return e.webkitMatchesSelector(t)}:e.mozMatchesSelector?function(e,t){return e.mozMatchesSelector(t)}:e.msMatchesSelector?function(e,t){return e.msMatchesSelector(t)}:function(e){return[].indexOf.call(document.querySelectorAll(e),this)!==-1}}(Element.prototype),Eo=function(e){return e?function t(n){var i,o,r,s,a=n.cloneNode(!1);if(1==n.nodeType){i=e(n),o=e(a),s=i.data();for(r in s)o.data(r,s[r]);for(/^canvas$/i.test(n.tagName)?a.getContext("2d").drawImage(n,0,0):/^(?:input|select|textarea|option)$/i.test(n.tagName)&&(a.removeAttribute("id"),a.removeAttribute("name"),a.value=n.value,a.checked=n.checked,a.selected=n.selected),r=n.firstChild;r;r=r.nextSibling)a.appendChild(t(r))}return a}:function(e){var t,n=function o(e){var t,n=e.cloneNode(!1);for(e._kendoExportVisual&&(n._kendoExportVisual=e._kendoExportVisual),t=e.firstChild;t;t=t.nextSibling)n.appendChild(o(t));return n}(e),i=e.querySelectorAll("canvas");return i.length&&Be(n.querySelectorAll("canvas")).forEach(function(e,t){e.getContext("2d").drawImage(i[t],0,0)}),t=e.querySelectorAll("input, select, textarea, option"),Be(n.querySelectorAll("input, select, textarea, option")).forEach(function(e,n){e.removeAttribute("id"),e.removeAttribute("name"),e.value=t[n].value,e.checked=t[n].checked,e.selected=t[n].selected}),n}}("undefined"!=typeof window&&window.kendo&&window.kendo.jQuery),Ue.getFontFaces=We,Ue.drawText=function(e){var t=new Gn;return So._clipbox=!1,So._matrix=cn.unit(),So._stackingContext={element:e,group:t},tt(e,st(e),t),3==e.firstChild.nodeType?Ht(e,e.firstChild,t):At(e,t),nt(),t},Io=function(){function e(e){function f(){var t=s.exec(e);t&&(e=e.substr(t[1].length))}function p(t){f();var n=t.exec(e);if(n)return e=e.substr(n[1].length),n[1]}function m(){var t,o,r,s=kendo.parseColor(e,!0);if(s)return r=/^#[0-9a-f]+/i.exec(e)||/^rgba?\(.*?\)/i.exec(e)||/^..*?\b/.exec(e),e=e.substr(r[0].length),s=s.toRGB(),(t=p(i))||(o=p(n)),{color:s,length:t,percent:o}}function g(t){var i,s,d,u,h,f,g=[],v=!1;if(p(a)){for(i=p(r),i?(i=gt(i),p(c)):(s=p(o),"to"==s?s=p(o):s&&/^-/.test(t)&&(v=!0),d=p(o),p(c)),/-moz-/.test(t)&&null==i&&null==s&&(u=p(n),h=p(n),v=!0,"0%"==u?s="left":"100%"==u&&(s="right"),"0%"==h?d="top":"100%"==h&&(d="bottom"),p(c));e&&!p(l)&&(f=m());)g.push(f),p(c);return{type:"linear",angle:i,to:s&&d?s+" "+d:s?s:d?d:null,stops:g,reverse:v}}}function v(){if(p(a)){var e=p(u);return e=e.replace(/^['"]+|["']+$/g,""),p(l),{type:"url",url:e}}}var _,b=e;return je(h,b)?h[b]:((_=p(t))?_=g(_):(_=p(d))&&(_=v()),h[b]=_||{type:"none"})}var t=/^((-webkit-|-moz-|-o-|-ms-)?linear-gradient\s*)\(/,n=/^([-0-9.]+%)/,i=/^([-0-9.]+px)/,o=/^(left|right|top|bottom|to|center)\W/,r=/^([-0-9.]+(deg|grad|rad|turn))/,s=/^(\s+)/,a=/^(\()/,l=/^(\))/,c=/^(,)/,d=/^(url)\(/,u=/^(.*?)\)/,h={},f={};return function(t){return je(f,t)?f[t]:f[t]=Mo(t).map(e)}}(),Mo=function(){var e={};return function(t,n){function i(e){return u=e.exec(t.substr(l))}function o(e){return e.replace(/^\s+|\s+$/g,"")}var r,s,a,l,c,d,u;if(n||(n=/^\s*,\s*/),r=t+n,je(e,r))return e[r];for(s=[],a=0,l=0,c=0,d=!1;l<t.length;)!d&&i(/^[\(\[\{]/)?(c++,l++):!d&&i(/^[\)\]\}]/)?(c--,l++):!d&&i(/^[\"\']/)?(d=u[0],l++):"'"==d&&i(/^\\\'/)?l+=2:'"'==d&&i(/^\\\"/)?l+=2:"'"==d&&i(/^\'/)?(d=!1,l++):'"'==d&&i(/^\"/)?(d=!1,l++):i(n)?(!d&&!c&&l>a&&(s.push(o(t.substring(a,l))),a=l+u[0].length),l+=u[0].length):l++;return a<l&&s.push(o(t.substring(a,l))),e[r]=s}}(),Ro=function(e){return function(t){var n,i=e[t];return i||((n=/url\((['"]?)([^'")]*?)\1\)\s+format\((['"]?)truetype\3\)/.exec(t))?i=e[t]=n[2]:(n=/url\((['"]?)([^'")]*?\.ttf)\1\)/.exec(t))&&(i=e[t]=n[2])),i}}(Object.create?Object.create(null):{}),Fo=function(e){return function(t){var n=e[t];return null==n&&(n=e[t]=qt.measureText("Mapq",{font:t}).height),n}}(Object.create?Object.create(null):{}),zo={svg:Ji,canvas:yo,util:sn,PathParser:fi,Surface:gi,BaseNode:vi,SurfaceFactory:pi,OptionsStore:ln,exportImage:ze,exportSVG:Pe,QuadNode:so,ShapesQuadTree:uo,ObserversMixin:Qt,Element:pn,Circle:kn,Arc:Nn,Path:Ln,MultiPath:On,Text:Wn,Image:jn,Group:Gn,Layout:Qn,Rect:Xn,align:ne,vAlign:ie,stack:se,vStack:ae,wrap:de,vWrap:ue,fit:he,LinearGradient:ti,RadialGradient:ni,GradientStop:Jn,Gradient:ei,Animation:ri,AnimationFactory:si,drawDOM:Ue},kendo.deepExtend(kendo,{drawing:zo,geometry:Zi}),kendo.drawing.Segment=kendo.geometry.Segment,kendo.dataviz.drawing=kendo.drawing,kendo.dataviz.geometry=kendo.geometry,kendo.drawing.util.measureText=kendo.util.measureText,kendo.drawing.util.objectKey=kendo.util.objectKey,kendo.drawing.Color=kendo.Color,kendo.util.encodeBase64=kendo.drawing.util.encodeBase64}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.popup.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(t,n){return!(!t||!n)&&(t===n||e.contains(t,n))}var i,o,r,s,a=window.kendo,l=a.ui,c=l.Widget,d=a.Class,u=a.support,h=a.getOffset,f=a._outerWidth,p=a._outerHeight,m="open",g="close",v="deactivate",_="activate",b="center",w="left",y="right",k="top",x="bottom",C="absolute",S="hidden",T="body",D="location",A="position",E="visible",I="effects",M="k-state-active",R="k-state-border",F=/k-state-border-(\w+)/,z=".k-picker-wrap, .k-dropdown-wrap, .k-link",P="down",B=e(document.documentElement),L=e.proxy,H=e(window),N="scroll",O=u.transitions.css,V=O+"transform",U=e.extend,W=".kendoPopup",j=["font-size","font-family","font-stretch","font-style","font-weight","line-height"],q=c.extend({init:function(t,n){var i,o=this;n=n||{},n.isRtl&&(n.origin=n.origin||x+" "+y,n.position=n.position||k+" "+y),c.fn.init.call(o,t,n),t=o.element,n=o.options,o.collisions=n.collision?n.collision.split(" "):[],o.downEvent=a.applyEventMap(P,a.guid()),1===o.collisions.length&&o.collisions.push(o.collisions[0]),i=e(o.options.anchor).closest(".k-popup,.k-group").filter(":not([class^=km-])"),n.appendTo=e(e(n.appendTo)[0]||i[0]||document.body),o.element.hide().addClass("k-popup k-group k-reset").toggleClass("k-rtl",!!n.isRtl).css({position:C}).appendTo(n.appendTo).attr("aria-hidden",!0).on("mouseenter"+W,function(){o._hovered=!0}).on("wheel"+W,function(t){var n=e(t.target).find(".k-list"),i=n.parent();n.length&&n.is(":visible")&&(0===i.scrollTop()&&t.originalEvent.deltaY<0||i.scrollTop()===i.prop("scrollHeight")-i.prop("offsetHeight")&&t.originalEvent.deltaY>0)&&t.preventDefault()}).on("mouseleave"+W,function(){o._hovered=!1}),o.wrapper=e(),n.animation===!1&&(n.animation={open:{effects:{}},close:{hide:!0,effects:{}}}),U(n.animation.open,{complete:function(){o.wrapper.css({overflow:E}),o._activated=!0,o._trigger(_)}}),U(n.animation.close,{complete:function(){o._animationClose()}}),o._mousedownProxy=function(e){o._mousedown(e)},o._resizeProxy=u.mobileOS.android?function(e){setTimeout(function(){o._resize(e)},600)}:function(e){o._resize(e)},n.toggleTarget&&e(n.toggleTarget).on(n.toggleEvent+W,e.proxy(o.toggle,o))},events:[m,_,g,v],options:{name:"Popup",toggleEvent:"click",origin:x+" "+w,position:k+" "+w,anchor:T,appendTo:null,collision:"flip fit",viewport:window,copyAnchorStyles:!0,autosize:!1,modal:!1,adjustSize:{width:0,height:0},animation:{open:{effects:"slideIn:down",transition:!0,duration:200},close:{duration:100,hide:!0}}},_animationClose:function(){var e=this,t=e.wrapper.data(D);e.wrapper.hide(),t&&e.wrapper.css(t),e.options.anchor!=T&&e._hideDirClass(),e._closing=!1,e._trigger(v)},destroy:function(){var t,n=this,i=n.options,o=n.element.off(W);c.fn.destroy.call(n),i.toggleTarget&&e(i.toggleTarget).off(W),i.modal||(B.unbind(n.downEvent,n._mousedownProxy),n._toggleResize(!1)),a.destroy(n.element.children()),o.removeData(),i.appendTo[0]===document.body&&(t=o.parent(".k-animation-container"),t[0]?t.remove():o.remove())},open:function(t,n){var i,o,r=this,s={isFixed:!isNaN(parseInt(n,10)),x:t,y:n},l=r.element,c=r.options,d=e(c.anchor),h=l[0]&&l.hasClass("km-widget");if(!r.visible()){if(c.copyAnchorStyles&&(h&&"font-size"==j[0]&&j.shift(),l.css(a.getComputedStyles(d[0],j))),l.data("animating")||r._trigger(m))return;r._activated=!1,c.modal||(B.unbind(r.downEvent,r._mousedownProxy).bind(r.downEvent,r._mousedownProxy),r._toggleResize(!1),r._toggleResize(!0)),r.wrapper=o=a.wrap(l,c.autosize).css({overflow:S,display:"block",position:C}).attr("aria-hidden",!1),u.mobileOS.android&&o.css(V,"translatez(0)"),o.css(A),e(c.appendTo)[0]==document.body&&o.css(k,"-10000px"),r.flipped=r._position(s),i=r._openAnimation(),c.anchor!=T&&r._showDirClass(i),l.data(I,i.effects).kendoStop(!0).kendoAnimate(i).attr("aria-hidden",!1)}},_location:function(t){var n,i,o=this,r=o.element,s=o.options,l=e(s.anchor),c=r[0]&&r.hasClass("km-widget");return s.copyAnchorStyles&&(c&&"font-size"==j[0]&&j.shift(),r.css(a.getComputedStyles(l[0],j))),o.wrapper=n=a.wrap(r,s.autosize).css({overflow:S,display:"block",position:C}),u.mobileOS.android&&n.css(V,"translatez(0)"),n.css(A),e(s.appendTo)[0]==document.body&&n.css(k,"-10000px"),o._position(t||{}),i=n.offset(),{width:a._outerWidth(n),height:a._outerHeight(n),left:i.left,top:i.top}},_openAnimation:function(){var e=U(!0,{},this.options.animation.open);return e.effects=a.parseEffects(e.effects,this.flipped),e},_hideDirClass:function(){var t=e(this.options.anchor),n=((t.attr("class")||"").match(F)||["","down"])[1],i=R+"-"+n;t.removeClass(i).children(z).removeClass(M).removeClass(i),this.element.removeClass(R+"-"+a.directions[n].reverse)},_showDirClass:function(t){var n=t.effects.slideIn?t.effects.slideIn.direction:"down",i=R+"-"+n;e(this.options.anchor).addClass(i).children(z).addClass(M).addClass(i),this.element.addClass(R+"-"+a.directions[n].reverse)},position:function(){this.visible()&&(this.flipped=this._position())},toggle:function(){var e=this;e[e.visible()?g:m]()},visible:function(){return this.element.is(":"+E)},close:function(n){var i,o,r,s,l=this,c=l.options;if(l.visible()){if(i=l.wrapper[0]?l.wrapper:a.wrap(l.element).hide(),l._toggleResize(!1),l._closing||l._trigger(g))return l._toggleResize(!0),t;l.element.find(".k-popup").each(function(){var t=e(this),i=t.data("kendoPopup");i&&i.close(n)}),B.unbind(l.downEvent,l._mousedownProxy),n?o={hide:!0,effects:{}}:(o=U(!0,{},c.animation.close),r=l.element.data(I),s=o.effects,!s&&!a.size(s)&&r&&a.size(r)&&(o.effects=r,o.reverse=!0),l._closing=!0),l.element.kendoStop(!0).attr("aria-hidden",!0),i.css({overflow:S}).attr("aria-hidden",!0),l.element.kendoAnimate(o),n&&l._animationClose()}},_trigger:function(e){return this.trigger(e,{type:e})},_resize:function(e){var t=this;u.resize.indexOf(e.type)!==-1?(clearTimeout(t._resizeTimeout),t._resizeTimeout=setTimeout(function(){t._position(),t._resizeTimeout=null},50)):(!t._hovered||t._activated&&t.element.hasClass("k-list-container"))&&t.close()},_toggleResize:function(e){var t=e?"on":"off",n=u.resize;u.mobileOS.ios||u.mobileOS.android||(n+=" "+N),this._scrollableParents()[t](N,this._resizeProxy),H[t](n,this._resizeProxy)},_mousedown:function(t){var i=this,o=i.element[0],r=i.options,s=e(r.anchor)[0],l=r.toggleTarget,c=a.eventTarget(t),d=e(c).closest(".k-popup"),u=d.parent().parent(".km-shim").length;d=d[0],!u&&d&&d!==i.element[0]||"popover"!==e(t.target).closest("a").data("rel")&&(n(o,c)||n(s,c)||l&&n(e(l)[0],c)||i.close())},_fit:function(e,t,n){var i=0;return e+t>n&&(i=n-(e+t)),e<0&&(i=-e),i},_flip:function(e,t,n,i,o,r,s){var a=0;return s=s||t,r!==o&&r!==b&&o!==b&&(e+s>i&&(a+=-(n+t)),e+a<0&&(a+=n+t)),a},_scrollableParents:function(){return e(this.options.anchor).parentsUntil("body").filter(function(e,t){return a.isScrollable(t)})},_position:function(t){var n,i,o,r,s,l,c,d,m,g,v,_,b,w,y,k,x,S=this,T=S.element,E=S.wrapper,I=S.options,M=e(I.viewport),R=u.zoomLevel(),F=!!(M[0]==window&&window.innerWidth&&R<=1.02),z=e(I.anchor),P=I.origin.toLowerCase().split(" "),B=I.position.toLowerCase().split(" "),L=S.collisions,H=10002,N=0,O=document.documentElement;if(s=I.viewport===window?{top:window.pageYOffset||document.documentElement.scrollTop||0,left:window.pageXOffset||document.documentElement.scrollLeft||0}:M.offset(),F?(l=window.innerWidth,c=window.innerHeight):(l=M.width(),c=M.height()),F&&O.scrollHeight-O.clientHeight>0&&(d=I.isRtl?-1:1,l-=d*a.support.scrollbar()),n=z.parents().filter(E.siblings()),n[0])if(o=Math.max(+n.css("zIndex"),0))H=o+10;else for(i=z.parentsUntil(n),r=i.length;N<r;N++)o=+e(i[N]).css("zIndex"),o&&H<o&&(H=o+10);return E.css("zIndex",H),E.css(t&&t.isFixed?{left:t.x,top:t.y}:S._align(P,B)),m=h(E,A,z[0]===E.offsetParent()[0]),g=h(E),v=z.offsetParent().parent(".k-animation-container,.k-popup,.k-group"),v.length&&(m=h(E,A,!0),g=h(E)),g.top-=s.top,g.left-=s.left,S.wrapper.data(D)||E.data(D,U({},m)),_=U({},g),b=U({},m),w=I.adjustSize,"fit"===L[0]&&(b.top+=S._fit(_.top,p(E)+w.height,c/R)),"fit"===L[1]&&(b.left+=S._fit(_.left,f(E)+w.width,l/R)),y=U({},b),k=p(T),x=p(E),!E.height()&&k&&(x+=k),"flip"===L[0]&&(b.top+=S._flip(_.top,k,p(z),c/R,P[0],B[0],x)),"flip"===L[1]&&(b.left+=S._flip(_.left,f(T),f(z),l/R,P[1],B[1],f(E))),T.css(A,C),E.css(b),b.left!=y.left||b.top!=y.top},_align:function(t,n){var i,o=this,r=o.wrapper,s=e(o.options.anchor),a=t[0],l=t[1],c=n[0],d=n[1],u=h(s),m=e(o.options.appendTo),g=f(r),v=p(r)||p(r.children().first()),_=f(s),w=p(s),k=u.top,C=u.left,S=Math.round;return m[0]!=document.body&&(i=h(m),k-=i.top,C-=i.left),a===x&&(k+=w),a===b&&(k+=S(w/2)),c===x&&(k-=v),c===b&&(k-=S(v/2)),l===y&&(C+=_),l===b&&(C+=S(_/2)),d===y&&(C-=g),d===b&&(C-=S(g/2)),{top:k,left:C}}});l.plugin(q),i=a.support.stableSort,o="kendoTabKeyTrap",r="a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], *[contenteditable]",s=d.extend({init:function(t){this.element=e(t),this.element.autoApplyNS(o)},trap:function(){this.element.on("keydown",L(this._keepInTrap,this))},removeTrap:function(){this.element.kendoDestroy(o)},destroy:function(){this.element.kendoDestroy(o),this.element=t},shouldTrap:function(){return!0},_keepInTrap:function(e){var t,n,i;9===e.which&&this.shouldTrap()&&!e.isDefaultPrevented()&&(t=this._focusableElements(),n=this._sortFocusableElements(t),i=this._nextFocusable(e,n),this._focus(i),e.preventDefault())},_focusableElements:function(){var t=this.element.find(r).filter(function(t,n){return n.tabIndex>=0&&e(n).is(":visible")&&!e(n).is("[disabled]")});return this.element.is("[tabindex]")&&t.push(this.element[0]),t},_sortFocusableElements:function(e){var t,n;return i?t=e.sort(function(e,t){return e.tabIndex-t.tabIndex}):(n="__k_index",e.each(function(e,t){t.setAttribute(n,e)}),t=e.sort(function(e,t){return e.tabIndex===t.tabIndex?parseInt(e.getAttribute(n),10)-parseInt(t.getAttribute(n),10):e.tabIndex-t.tabIndex}),e.removeAttr(n)),t},_nextFocusable:function(e,t){var n=t.length,i=t.index(e.target);return t.get((i+(e.shiftKey?-1:1))%n)},_focus:function(e){return"IFRAME"==e.nodeName?(e.contentWindow.document.body.focus(),t):(e.focus(),"INPUT"==e.nodeName&&e.setSelectionRange&&this._haveSelectionRange(e)&&e.setSelectionRange(0,e.value.length),t)},_haveSelectionRange:function(e){var t=e.type.toLowerCase();return"text"===t||"search"===t||"url"===t||"tel"===t||"password"===t}}),l.Popup.TabKeyTrap=s}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("drawing/surface-tooltip.min",["kendo.popup.min","drawing/kendo-drawing.min"],e)}(function(){!function(e){var t=".kendo",n=window.kendo,i=n.deepExtend,o=n.drawing.util,r=o.defined,s=o.limitValue,a=o.eventCoordinates,l=n._outerWidth,c=n._outerHeight,d=e.proxy,u='<div class="k-tooltip"><div class="k-tooltip-content"></div></div>',h='<div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close">close</a></div>',f=n.Class.extend({init:function(t,n){this.element=e(u),this.content=this.element.children(".k-tooltip-content"),n=n||{},this.options=i({},this.options,this._tooltipOptions(n)),this.popupOptions={appendTo:n.appendTo,animation:n.animation,copyAnchorStyles:!1,collision:"fit fit"},this._openPopupHandler=e.proxy(this._openPopup,this),this.surface=t,this._bindEvents()},options:{position:"top",showOn:"mouseenter",offset:7,autoHide:!0,hideDelay:0,showAfter:100},_bindEvents:function(){this._showHandler=d(this._showEvent,this),this._surfaceLeaveHandler=d(this._surfaceLeave,this),this._mouseleaveHandler=d(this._mouseleave,this),this._mousemoveHandler=d(this._mousemove,this),this.surface.bind("click",this._showHandler),this.surface.bind("mouseenter",this._showHandler),this.surface.bind("mouseleave",this._mouseleaveHandler),this.surface.bind("mousemove",this._mousemoveHandler),this.surface.element.on("mouseleave"+t,this._surfaceLeaveHandler),this.element.on("click"+t,".k-tooltip-button",d(this._hideClick,this))},getPopup:function(){return this.popup||(this.popup=new n.ui.Popup(this.element,this.popupOptions)),this.popup},destroy:function(){var e=this.popup;this.surface.unbind("click",this._showHandler),this.surface.unbind("mouseenter",this._showHandler),this.surface.unbind("mouseleave",this._mouseleaveHandler),this.surface.unbind("mousemove",this._mousemoveHandler),this.surface.element.off("mouseleave"+t,this._surfaceLeaveHandler),this.element.off("click"+t),e&&(e.destroy(),delete this.popup),delete this.popupOptions,clearTimeout(this._timeout),delete this.element,delete this.content,delete this.surface},_tooltipOptions:function(e){return e=e||{},{position:e.position,showOn:e.showOn,offset:e.offset,autoHide:e.autoHide,width:e.width,height:e.height,content:e.content,shared:e.shared,hideDelay:e.hideDelay,showAfter:e.showAfter}},_tooltipShape:function(e){for(;e&&!e.options.tooltip;)e=e.parent;return e},_updateContent:function(e,t,i){var o=i.content;if(n.isFunction(o)&&(o=o({element:t,target:e})),o)return this.content.html(o),!0},_position:function(e,t,n,i){var o,r=t.position,l=t.offset||0,c=this.surface,d=c._instance._elementOffset(),u=c.getSize(),h=c._instance._offset,f=e.bbox(),p=n.width,m=n.height,g=0,v=0;return f.origin.translate(d.left,d.top),h&&f.origin.translate(-h.x,-h.y),"cursor"==r&&i?(o=a(i),g=o.x-p/2,v=o.y-m-l):"left"==r?(g=f.origin.x-p-l,v=f.center().y-m/2):"right"==r?(g=f.bottomRight().x+l,v=f.center().y-m/2):"bottom"==r?(g=f.center().x-p/2,v=f.bottomRight().y+l):(g=f.center().x-p/2,v=f.origin.y-m-l),{left:s(g,d.left,d.left+u.width),top:s(v,d.top,d.top+u.height)}},show:function(e,t){this._show(e,e,i({},this.options,this._tooltipOptions(e.options.tooltip),t))},hide:function(){var e=this.popup,t=this._current;delete this._current,clearTimeout(this._showTimeout),e&&e.visible()&&t&&!this.surface.trigger("tooltipClose",{element:t.shape,target:t.target,popup:e})&&e.close()},_hideClick:function(e){e.preventDefault(),this.hide()},_show:function(e,t,n,i,o){var r,s,a=this._current;clearTimeout(this._timeout),a&&(a.shape===t&&n.shared||a.target===e)||(clearTimeout(this._showTimeout),r=this.getPopup(),!this.surface.trigger("tooltipOpen",{element:t,target:e,popup:r})&&this._updateContent(e,t,n)&&(this._autoHide(n),s=this._measure(n),r.visible()&&r.close(!0),this._current={options:n,elementSize:s,shape:t,target:e,position:this._position(n.shared?t:e,n,s,i)},o?this._showTimeout=setTimeout(this._openPopupHandler,n.showAfter||0):this._openPopup()))},_openPopup:function(){var e=this._current,t=e.position;this.getPopup().open(t.left,t.top)},_autoHide:function(t){t.autoHide&&this._closeButton&&(this.element.removeClass("k-tooltip-closable"),this._closeButton.remove(),delete this._closeButton),t.autoHide||this._closeButton||(this.element.addClass("k-tooltip-closable"),this._closeButton=e(h).prependTo(this.element))},_showEvent:function(e){var t,n=this._tooltipShape(e.element);n&&(t=i({},this.options,this._tooltipOptions(n.options.tooltip)),t&&t.showOn==e.type&&this._show(e.element,n,t,e.originalEvent,!0))},_measure:function(e){var t,n,i,o=this.getPopup();return this.element.css({width:"auto",height:"auto"}),i=o.visible(),i||o.wrapper.show(),this.element.css({width:r(e.width)?e.width:"auto",height:r(e.height)?e.height:"auto"}),t=l(this.element),n=c(this.element),i||o.wrapper.hide(),{width:t,height:n}},_mouseleave:function(e){var t,n;this.popup&&!this._popupRelatedTarget(e.originalEvent)&&(t=this,n=t._current,n&&n.options.autoHide&&(t._timeout=setTimeout(function(){clearTimeout(t._showTimeout),t.hide()},n.options.hideDelay||0)))},_mousemove:function(e){var t,n,i=this._current;i&&e.element&&(t=i.options,"cursor"==t.position&&(n=this._position(e.element,t,i.elementSize,e.originalEvent),i.position=n,this.getPopup().wrapper.css({left:n.left,top:n.top})))},_surfaceLeave:function(e){this.popup&&!this._popupRelatedTarget(e)&&(clearTimeout(this._showTimeout),this.hide())},_popupRelatedTarget:function(t){return t.relatedTarget&&e(t.relatedTarget).closest(this.popup.wrapper).length}});n.drawing.SurfaceTooltip=f}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("drawing/surface.min",["drawing/kendo-drawing.min","drawing/surface-tooltip.min"],e)}(function(){!function(e){function t(e){this._instance.translate(e)}var n,i=window.kendo,o=i.drawing,r=o.Surface,s=i.ui.Widget,a=i.deepExtend,l=e.proxy;i.support.svg=r.support.svg,i.support.canvas=r.support.canvas,n=s.extend({init:function(e,n){s.fn.init.call(this,e,{}),this.options=a({},this.options,n),this._instance=r.create(this.element[0],n),this._instance.translate&&(this.translate=t),this._triggerInstanceHandler=l(this._triggerInstanceEvent,this),this._bindHandler("click"),this._bindHandler("mouseenter"),this._bindHandler("mouseleave"),this._bindHandler("mousemove"),this._enableTracking()},options:{name:"Surface",tooltip:{}},events:["click","mouseenter","mouseleave","mousemove","resize","tooltipOpen","tooltipClose"],_triggerInstanceEvent:function(e){this.trigger(e.type,e)},_bindHandler:function(e){this._instance.bind(e,this._triggerInstanceHandler)},draw:function(e){this._instance.draw(e)},clear:function(){this._instance&&this._instance.clear(),this.hideTooltip()},destroy:function(){this._instance&&(this._instance.destroy(),delete this._instance),this._tooltip&&(this._tooltip.destroy(),delete this._tooltip),s.fn.destroy.call(this)},exportVisual:function(){return this._instance.exportVisual()},eventTarget:function(e){return this._instance.eventTarget(e)},showTooltip:function(e,t){this._tooltip&&this._tooltip.show(e,t)},hideTooltip:function(){this._tooltip&&this._tooltip.hide()},suspendTracking:function(){this._instance.suspendTracking(),this.hideTooltip()},resumeTracking:function(){this._instance.resumeTracking()},getSize:function(){return{width:this.element.width(),height:this.element.height()}},setSize:function(e){this.element.css({width:e.width,height:e.height}),this._size=e,this._instance.currentSize(e),this._resize()},_resize:function(){this._instance.currentSize(this._size),this._instance._resize()},_enableTracking:function(){i.ui.Popup&&(this._tooltip=new o.SurfaceTooltip(this,this.options.tooltip||{}))}}),i.ui.plugin(n),n.create=function(e,t){return new n(e,t)},i.drawing.Surface=n}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("drawing/html.min",["drawing/kendo-drawing.min"],e)}(function(){!function(e){var t=window.kendo,n=t.drawing,i=n.drawDOM;n.drawDOM=function(t,n){return i(e(t)[0],n)},n.drawDOM.drawText=i.drawText,n.drawDOM.getFontFaces=i.getFontFaces}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){
define("kendo.drawing.min",["drawing/util.min","drawing/kendo-drawing.min","drawing/surface-tooltip.min","drawing/surface.min","drawing/html.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.validator.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(t){var n,i=l.ui.validator.ruleResolvers||{},o={};for(n in i)e.extend(!0,o,i[n].resolve(t));return o}function i(e){return e.replace(/&amp/g,"&amp;").replace(/&quot;/g,'"').replace(/&#39;/g,"'").replace(/&lt;/g,"<").replace(/&gt;/g,">")}function o(e){return e=(e+"").split("."),e.length>1?e[1].length:0}function r(t){return e(e.parseHTML?e.parseHTML(t):t)}function s(t,n){var i,o,r,s,a=e();for(r=0,s=t.length;r<s;r++)i=t[r],h.test(i.className)&&(o=i.getAttribute(l.attr("for")),o===n&&(a=a.add(i)));return a}var a,l=window.kendo,c=l.ui.Widget,d=".kendoValidator",u="k-invalid-msg",h=RegExp(u,"i"),f="k-invalid",p="k-valid",m=/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i,g=/^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,v=":input:not(:button,[type=submit],[type=reset],[disabled],[readonly])",_=":checkbox:not([disabled],[readonly])",b="[type=number],[type=range]",w="blur",y="name",k="form",x="novalidate",C="validate",S="change",T="validateInput",D=e.proxy,A=function(e,t){return"string"==typeof t&&(t=RegExp("^(?:"+t+")$")),t.test(e)},E=function(e,t,n){var i=e.val();return!e.filter(t).length||""===i||A(i,n)},I=function(e,t){return!!e.length&&null!=e[0].attributes[t]};l.ui.validator||(l.ui.validator={rules:{},messages:{}}),a=c.extend({init:function(t,i){var o=this,r=n(t),s="["+l.attr("validate")+"!=false]";i=i||{},i.rules=e.extend({},l.ui.validator.rules,r.rules,i.rules),i.messages=e.extend({},l.ui.validator.messages,r.messages,i.messages),c.fn.init.call(o,t,i),o._errorTemplate=l.template(o.options.errorTemplate),o.element.is(k)&&o.element.attr(x,x),o._inputSelector=v+s,o._checkboxSelector=_+s,o._errors={},o._attachEvents(),o._isValidated=!1},events:[C,S,T],options:{name:"Validator",errorTemplate:'<span class="k-widget k-tooltip k-tooltip-validation"><span class="k-icon k-i-warning"> </span> #=message#</span>',messages:{required:"{0} is required",pattern:"{0} is not valid",min:"{0} should be greater than or equal to {1}",max:"{0} should be smaller than or equal to {1}",step:"{0} is not valid",email:"{0} is not valid email",url:"{0} is not valid URL",date:"{0} is not valid date",dateCompare:"End date should be greater than or equal to the start date"},rules:{required:function(e){var t=e.filter("[type=checkbox]").length&&!e.is(":checked"),n=e.val();return!(I(e,"required")&&(!n||""===n||0===n.length||t))},pattern:function(e){return!e.filter("[type=text],[type=email],[type=url],[type=tel],[type=search],[type=password]").filter("[pattern]").length||""===e.val()||A(e.val(),e.attr("pattern"))},min:function(e){if(e.filter(b+",["+l.attr("type")+"=number]").filter("[min]").length&&""!==e.val()){var t=parseFloat(e.attr("min"))||0,n=l.parseFloat(e.val());return t<=n}return!0},max:function(e){if(e.filter(b+",["+l.attr("type")+"=number]").filter("[max]").length&&""!==e.val()){var t=parseFloat(e.attr("max"))||0,n=l.parseFloat(e.val());return t>=n}return!0},step:function(e){if(e.filter(b+",["+l.attr("type")+"=number]").filter("[step]").length&&""!==e.val()){var t,n=parseFloat(e.attr("min"))||0,i=parseFloat(e.attr("step"))||1,r=parseFloat(e.val()),s=o(i);return s?(t=Math.pow(10,s),Math.floor((r-n)*t)%(i*t)/Math.pow(100,s)===0):(r-n)%i===0}return!0},email:function(e){return E(e,"[type=email],["+l.attr("type")+"=email]",m)},url:function(e){return E(e,"[type=url],["+l.attr("type")+"=url]",g)},date:function(e){return!e.filter("[type^=date],["+l.attr("type")+"=date]").length||""===e.val()||null!==l.parseDate(e.val(),e.attr(l.attr("format")))}},validateOnBlur:!0},destroy:function(){c.fn.destroy.call(this),this.element.off(d)},value:function(){return!!this._isValidated&&0===this.errors().length},_submit:function(e){return!!this.validate()||(e.stopPropagation(),e.stopImmediatePropagation(),e.preventDefault(),!1)},_checkElement:function(e){var t=this.value();this.validateInput(e),this.value()!==t&&this.trigger(S)},_attachEvents:function(){var t=this;t.element.is(k)&&t.element.on("submit"+d,D(t._submit,t)),t.options.validateOnBlur&&(t.element.is(v)?(t.element.on(w+d,function(){t._checkElement(t.element)}),t.element.is(_)&&t.element.on("click"+d,function(){t._checkElement(t.element)})):(t.element.on(w+d,t._inputSelector,function(){t._checkElement(e(this))}),t.element.on("click"+d,t._checkboxSelector,function(){t._checkElement(e(this))})))},validate:function(){var e,t,n,i,o=!1,r=this.value();if(this._errors={},this.element.is(v))o=this.validateInput(this.element);else{for(i=!1,e=this.element.find(this._inputSelector),t=0,n=e.length;t<n;t++)this.validateInput(e.eq(t))||(i=!0);o=!i}return this.trigger(C,{valid:o}),r!==o&&this.trigger(S),o},validateInput:function(t){var n,o,s,a,c,d,h,m,g,v,_;return t=e(t),this._isValidated=!0,n=this,o=n._errorTemplate,s=n._checkValidity(t),a=s.valid,c="."+u,d=t.attr(y)||"",h=n._findMessageContainer(d).add(t.next(c).filter(function(){var t=e(this);return!t.filter("["+l.attr("for")+"]").length||t.attr(l.attr("for"))===d})).hide(),g=!t.attr("aria-invalid"),t.removeAttr("aria-invalid"),a?delete n._errors[d]:(m=n._extractMessage(t,s.key),n._errors[d]=m,v=r(o({message:i(m)})),_=h.attr("id"),n._decorateMessageContainer(v,d),_&&v.attr("id",_),h.replaceWith(v).length||v.insertAfter(t),v.show(),t.attr("aria-invalid",!0)),g!==a&&this.trigger(T,{valid:a,input:t}),t.toggleClass(f,!a),t.toggleClass(p,a),a},hideMessages:function(){var e=this,t="."+u,n=e.element;n.is(v)?n.next(t).hide():n.find(t).hide()},_findMessageContainer:function(t){var n,i,o,r=l.ui.validator.messageLocators,a=e();for(i=0,o=this.element.length;i<o;i++)a=a.add(s(this.element[i].getElementsByTagName("*"),t));for(n in r)a=a.add(r[n].locate(this.element,t));return a},_decorateMessageContainer:function(e,t){var n,i=l.ui.validator.messageLocators;e.addClass(u).attr(l.attr("for"),t||"");for(n in i)i[n].decorate(e,t);e.attr("role","alert")},_extractMessage:function(e,t){var n,i=this,o=i.options.messages[t],r=e.attr(y);return l.ui.Validator.prototype.options.messages[t]||(n=l.isFunction(o)?o(e):o),o=l.isFunction(o)?o(e):o,l.format(e.attr(l.attr(t+"-msg"))||e.attr("validationMessage")||n||e.attr("title")||o||"",r,e.attr(t)||e.attr(l.attr(t)))},_checkValidity:function(e){var t,n=this.options.rules;for(t in n)if(!n[t].call(this,e))return{valid:!1,key:t};return{valid:!0}},errors:function(){var e,t=[],n=this._errors;for(e in n)t.push(n[e]);return t}}),l.ui.plugin(a)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.userevents.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(e,t){var n=e.x.location,i=e.y.location,o=t.x.location,r=t.y.location,s=n-o,a=i-r;return{center:{x:(n+o)/2,y:(i+r)/2},distance:Math.sqrt(s*s+a*a)}}function i(e){var t,n,i,o=[],r=e.originalEvent,a=e.currentTarget,l=0;if(e.api)o.push({id:2,event:e,target:e.target,currentTarget:e.target,location:e,type:"api"});else if(e.type.match(/touch/))for(n=r?r.changedTouches:[],t=n.length;l<t;l++)i=n[l],o.push({location:i,event:e,target:i.target,currentTarget:a,id:i.identifier,type:"touch"});else o.push(s.pointers||s.msPointers?{location:r,event:e,target:e.target,currentTarget:a,id:r.pointerId,type:"pointer"}:{id:1,event:e,target:e.target,currentTarget:a,location:e,type:"mouse"});return o}function o(e){for(var t=r.eventMap.up.split(" "),n=0,i=t.length;n<i;n++)e(t[n])}var r=window.kendo,s=r.support,a=r.Class,l=r.Observable,c=e.now,d=e.extend,u=s.mobileOS,h=u&&u.android,f=800,p=s.browser.msie?5:0,m="press",g="hold",v="select",_="start",b="move",w="end",y="cancel",k="tap",x="release",C="gesturestart",S="gesturechange",T="gestureend",D="gesturetap",A={api:0,touch:0,mouse:9,pointer:9},E=!s.touch||s.mouseAndTouchPresent,I=a.extend({init:function(e,t){var n=this;n.axis=e,n._updateLocationData(t),n.startLocation=n.location,n.velocity=n.delta=0,n.timeStamp=c()},move:function(e){var t=this,n=e["page"+t.axis],i=c(),o=i-t.timeStamp||1;!n&&h||(t.delta=n-t.location,t._updateLocationData(e),t.initialDelta=n-t.startLocation,t.velocity=t.delta/o,t.timeStamp=i)},_updateLocationData:function(e){var t=this,n=t.axis;t.location=e["page"+n],t.client=e["client"+n],t.screen=e["screen"+n]}}),M=a.extend({init:function(e,t,n){d(this,{x:new I("X",n.location),y:new I("Y",n.location),type:n.type,useClickAsTap:e.useClickAsTap,threshold:e.threshold||A[n.type],userEvents:e,target:t,currentTarget:n.currentTarget,initialTouch:n.target,id:n.id,pressEvent:n,_moved:!1,_finished:!1})},press:function(){this._holdTimeout=setTimeout(e.proxy(this,"_hold"),this.userEvents.minHold),this._trigger(m,this.pressEvent)},_hold:function(){this._trigger(g,this.pressEvent)},move:function(e){var t=this;if(!t._finished){if(t.x.move(e.location),t.y.move(e.location),!t._moved){if(t._withinIgnoreThreshold())return;if(R.current&&R.current!==t.userEvents)return t.dispose();t._start(e)}t._finished||t._trigger(b,e)}},end:function(e){this.endTime=c(),this._finished||(this._finished=!0,this._trigger(x,e),this._moved?this._trigger(w,e):this.useClickAsTap||this._trigger(k,e),clearTimeout(this._holdTimeout),this.dispose())},dispose:function(){var t=this.userEvents,n=t.touches;this._finished=!0,this.pressEvent=null,clearTimeout(this._holdTimeout),n.splice(e.inArray(this,n),1)},skip:function(){this.dispose()},cancel:function(){this.dispose()},isMoved:function(){return this._moved},_start:function(e){clearTimeout(this._holdTimeout),this.startTime=c(),this._moved=!0,this._trigger(_,e)},_trigger:function(e,t){var n=this,i=t.event,o={touch:n,x:n.x,y:n.y,target:n.target,event:i};n.userEvents.notify(e,o)&&i.preventDefault()},_withinIgnoreThreshold:function(){var e=this.x.initialDelta,t=this.y.initialDelta;return Math.sqrt(e*e+t*t)<=this.threshold}}),R=l.extend({init:function(t,n){var i,a,c,u,h=this,A=r.guid();n=n||{},i=h.filter=n.filter,h.threshold=n.threshold||p,h.minHold=n.minHold||f,h.touches=[],h._maxTouches=n.multiTouch?2:1,h.allowSelection=n.allowSelection,h.captureUpIfMoved=n.captureUpIfMoved,h.useClickAsTap=!n.fastTap&&!s.delayedClick(),h.eventNS=A,t=e(t).handler(h),l.fn.init.call(h),d(h,{element:t,surface:e(n.global&&E?t[0].ownerDocument.documentElement:n.surface||t),stopPropagation:n.stopPropagation,pressed:!1}),h.surface.handler(h).on(r.applyEventMap("move",A),"_move").on(r.applyEventMap("up cancel",A),"_end"),t.on(r.applyEventMap("down",A),i,"_start"),h.useClickAsTap&&t.on(r.applyEventMap("click",A),i,"_click"),(s.pointers||s.msPointers)&&(s.browser.version<11?(a="pinch-zoom double-tap-zoom",t.css("-ms-touch-action",n.touchAction&&"none"!=n.touchAction?a+" "+n.touchAction:a)):t.css("touch-action",n.touchAction||"none")),n.preventDragEvent&&t.on(r.applyEventMap("dragstart",A),r.preventDefault),t.on(r.applyEventMap("mousedown",A),i,{root:t},"_select"),h.captureUpIfMoved&&s.eventCapture&&(c=h.surface[0],u=e.proxy(h.preventIfMoving,h),o(function(e){c.addEventListener(e,u,!0)})),h.bind([m,g,k,_,b,w,x,y,C,S,T,D,v],n)},preventIfMoving:function(e){this._isMoved()&&e.preventDefault()},destroy:function(){var e,t=this;t._destroyed||(t._destroyed=!0,t.captureUpIfMoved&&s.eventCapture&&(e=t.surface[0],o(function(n){e.removeEventListener(n,t.preventIfMoving)})),t.element.kendoDestroy(t.eventNS),t.surface.kendoDestroy(t.eventNS),t.element.removeData("handler"),t.surface.removeData("handler"),t._disposeAll(),t.unbind(),delete t.surface,delete t.element,delete t.currentTarget)},capture:function(){R.current=this},cancel:function(){this._disposeAll(),this.trigger(y)},notify:function(e,t){var i=this,o=i.touches;if(this._isMultiTouch()){switch(e){case b:e=S;break;case w:e=T;break;case k:e=D}d(t,{touches:o},n(o[0],o[1]))}return this.trigger(e,d(t,{type:e}))},press:function(e,t,n){this._apiCall("_start",e,t,n)},move:function(e,t){this._apiCall("_move",e,t)},end:function(e,t){this._apiCall("_end",e,t)},_isMultiTouch:function(){return this.touches.length>1},_maxTouchesReached:function(){return this.touches.length>=this._maxTouches},_disposeAll:function(){for(var e=this.touches;e.length>0;)e.pop().dispose()},_isMoved:function(){return e.grep(this.touches,function(e){return e.isMoved()}).length},_select:function(e){this.allowSelection&&!this.trigger(v,{event:e})||e.preventDefault()},_start:function(t){var n,o,r=this,s=0,a=r.filter,l=i(t),c=l.length,d=t.which;if(!(d&&d>1||r._maxTouchesReached()))for(R.current=null,r.currentTarget=t.currentTarget,r.stopPropagation&&t.stopPropagation();s<c&&!r._maxTouchesReached();s++)o=l[s],n=a?e(o.currentTarget):r.element,n.length&&(o=new M(r,n,o),r.touches.push(o),o.press(),r._isMultiTouch()&&r.notify("gesturestart",{}))},_move:function(e){this._eachTouch("move",e)},_end:function(e){this._eachTouch("end",e)},_click:function(t){var n={touch:{initialTouch:t.target,target:e(t.currentTarget),endTime:c(),x:{location:t.pageX,client:t.clientX},y:{location:t.pageY,client:t.clientY}},x:t.pageX,y:t.pageY,target:e(t.currentTarget),event:t,type:"tap"};this.trigger("tap",n)&&t.preventDefault()},_eachTouch:function(e,t){var n,o,r,s,a=this,l={},c=i(t),d=a.touches;for(n=0;n<d.length;n++)o=d[n],l[o.id]=o;for(n=0;n<c.length;n++)r=c[n],s=l[r.id],s&&s[e](r)},_apiCall:function(t,n,i,o){this[t]({api:!0,pageX:n,pageY:i,clientX:n,clientY:i,target:e(o||this.element)[0],stopPropagation:e.noop,preventDefault:e.noop})}});R.defaultThreshold=function(e){p=e},R.minHold=function(e){f=e},r.getTouches=i,r.touchDelta=n,r.UserEvents=R}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.draganddrop.min",["kendo.core.min","kendo.userevents.min"],e)}(function(){return function(e,t){function n(t,n){try{return e.contains(t,n)||t==n}catch(i){return!1}}function i(e,t){return parseInt(e.css(t),10)||0}function o(e,t){return Math.min(Math.max(e,t.min),t.max)}function r(e,t){var n=A(e),o=_._outerWidth,r=_._outerHeight,s=n.left+i(e,"borderLeftWidth")+i(e,"paddingLeft"),a=n.top+i(e,"borderTopWidth")+i(e,"paddingTop"),l=s+e.width()-o(t,!0),c=a+e.height()-r(t,!0);return{x:{min:s,max:l},y:{min:a,max:c}}}function s(n,i,o){for(var r,s,a=0,l=i&&i.length,c=o&&o.length;n&&n.parentNode;){for(a=0;a<l;a++)if(r=i[a],r.element[0]===n)return{target:r,targetElement:n};for(a=0;a<c;a++)if(s=o[a],e.contains(s.element[0],n)&&b.matchesSelector.call(n,s.options.filter))return{target:s,targetElement:n};n=n.parentNode}return t}function a(e,t){var n,i=t.options.group,o=e[i];if(x.fn.destroy.call(t),o.length>1){for(n=0;n<o.length;n++)if(o[n]==t){o.splice(n,1);break}}else o.length=0,delete e[i]}function l(e){var t,n,i,o=c()[0];return e[0]===o?(n=o.scrollTop,i=o.scrollLeft,{top:n,left:i,bottom:n+y.height(),right:i+y.width()}):(t=e.offset(),t.bottom=t.top+e.height(),t.right=t.left+e.width(),t)}function c(){return e(_.support.browser.chrome?w.body:w.documentElement)}function d(t){var n,i=c();if(!t||t===w.body||t===w.documentElement)return i;for(n=e(t)[0];n&&!_.isScrollable(n)&&n!==w.body;)n=n.parentNode;return n===w.body?i:e(n)}function u(e,t,n){var i={x:0,y:0},o=50;return e-n.left<o?i.x=-(o-(e-n.left)):n.right-e<o&&(i.x=o-(n.right-e)),t-n.top<o?i.y=-(o-(t-n.top)):n.bottom-t<o&&(i.y=o-(n.bottom-t)),i}var h,f,p,m,g,v,_=window.kendo,b=_.support,w=window.document,y=e(window),k=_.Class,x=_.ui.Widget,C=_.Observable,S=_.UserEvents,T=e.proxy,D=e.extend,A=_.getOffset,E={},I={},M={},R=_.elementUnderCursor,F="keyup",z="change",P="dragstart",B="hold",L="drag",H="dragend",N="dragcancel",O="hintDestroyed",V="dragenter",U="dragleave",W="drop",j=C.extend({init:function(t,n){var i=this,o=t[0];i.capture=!1,o.addEventListener?(e.each(_.eventMap.down.split(" "),function(){o.addEventListener(this,T(i._press,i),!0)}),e.each(_.eventMap.up.split(" "),function(){o.addEventListener(this,T(i._release,i),!0)})):(e.each(_.eventMap.down.split(" "),function(){o.attachEvent(this,T(i._press,i))}),e.each(_.eventMap.up.split(" "),function(){o.attachEvent(this,T(i._release,i))})),C.fn.init.call(i),i.bind(["press","release"],n||{})},captureNext:function(){this.capture=!0},cancelCapture:function(){this.capture=!1},_press:function(e){var t=this;t.trigger("press"),t.capture&&e.preventDefault()},_release:function(e){var t=this;t.trigger("release"),t.capture&&(e.preventDefault(),t.cancelCapture())}}),q=C.extend({init:function(t){var n=this;C.fn.init.call(n),n.forcedEnabled=!1,e.extend(n,t),n.scale=1,n.horizontal?(n.measure="offsetWidth",n.scrollSize="scrollWidth",n.axis="x"):(n.measure="offsetHeight",n.scrollSize="scrollHeight",n.axis="y")},makeVirtual:function(){e.extend(this,{virtual:!0,forcedEnabled:!0,_virtualMin:0,_virtualMax:0})},virtualSize:function(e,t){this._virtualMin===e&&this._virtualMax===t||(this._virtualMin=e,this._virtualMax=t,this.update())},outOfBounds:function(e){return e>this.max||e<this.min},forceEnabled:function(){this.forcedEnabled=!0},getSize:function(){return this.container[0][this.measure]},getTotal:function(){return this.element[0][this.scrollSize]},rescale:function(e){this.scale=e},update:function(e){var t=this,n=t.virtual?t._virtualMax:t.getTotal(),i=n*t.scale,o=t.getSize();(0!==n||t.forcedEnabled)&&(t.max=t.virtual?-t._virtualMin:0,t.size=o,t.total=i,t.min=Math.min(t.max,o-i),t.minScale=o/n,t.centerOffset=(i-o)/2,t.enabled=t.forcedEnabled||i>o,e||t.trigger(z,t))}}),G=C.extend({init:function(e){var t=this;C.fn.init.call(t),t.x=new q(D({horizontal:!0},e)),t.y=new q(D({horizontal:!1},e)),t.container=e.container,t.forcedMinScale=e.minScale,t.maxScale=e.maxScale||100,t.bind(z,e)},rescale:function(e){this.x.rescale(e),this.y.rescale(e),this.refresh()},centerCoordinates:function(){return{x:Math.min(0,-this.x.centerOffset),y:Math.min(0,-this.y.centerOffset)}},refresh:function(){var e=this;e.x.update(),e.y.update(),e.enabled=e.x.enabled||e.y.enabled,e.minScale=e.forcedMinScale||Math.min(e.x.minScale,e.y.minScale),e.fitScale=Math.max(e.x.minScale,e.y.minScale),e.trigger(z)}}),$=C.extend({init:function(e){var t=this;D(t,e),C.fn.init.call(t)},outOfBounds:function(){return this.dimension.outOfBounds(this.movable[this.axis])},dragMove:function(e){var t=this,n=t.dimension,i=t.axis,o=t.movable,r=o[i]+e;n.enabled&&((r<n.min&&e<0||r>n.max&&e>0)&&(e*=t.resistance),o.translateAxis(i,e),t.trigger(z,t))}}),K=k.extend({init:function(t){var n,i,o,r,s=this;D(s,{elastic:!0},t),o=s.elastic?.5:0,r=s.movable,s.x=n=new $({axis:"x",dimension:s.dimensions.x,resistance:o,movable:r}),s.y=i=new $({axis:"y",dimension:s.dimensions.y,resistance:o,movable:r}),s.userEvents.bind(["press","move","end","gesturestart","gesturechange"],{gesturestart:function(e){s.gesture=e,s.offset=s.dimensions.container.offset()},press:function(t){e(t.event.target).closest("a").is("[data-navigate-on-press=true]")&&t.sender.cancel()},gesturechange:function(e){var t,o,a,l=s.gesture,c=l.center,d=e.center,u=e.distance/l.distance,h=s.dimensions.minScale,f=s.dimensions.maxScale;r.scale<=h&&u<1&&(u+=.8*(1-u)),r.scale*u>=f&&(u=f/r.scale),o=r.x+s.offset.left,a=r.y+s.offset.top,t={x:(o-c.x)*u+d.x-o,y:(a-c.y)*u+d.y-a},r.scaleWith(u),n.dragMove(t.x),i.dragMove(t.y),s.dimensions.rescale(r.scale),s.gesture=e,e.preventDefault()},move:function(e){e.event.target.tagName.match(/textarea|input/i)||(n.dimension.enabled||i.dimension.enabled?(n.dragMove(e.x.delta),i.dragMove(e.y.delta),e.preventDefault()):e.touch.skip())},end:function(e){e.preventDefault()}})}}),Y=b.transitions.prefix+"Transform";f=b.hasHW3D?function(e,t,n){return"translate3d("+e+"px,"+t+"px,0) scale("+n+")"}:function(e,t,n){return"translate("+e+"px,"+t+"px) scale("+n+")"},p=C.extend({init:function(t){var n=this;C.fn.init.call(n),n.element=e(t),n.element[0].style.webkitTransformOrigin="left top",n.x=0,n.y=0,n.scale=1,n._saveCoordinates(f(n.x,n.y,n.scale))},translateAxis:function(e,t){this[e]+=t,this.refresh()},scaleTo:function(e){this.scale=e,this.refresh()},scaleWith:function(e){this.scale*=e,this.refresh()},translate:function(e){this.x+=e.x,this.y+=e.y,this.refresh()},moveAxis:function(e,t){this[e]=t,this.refresh()},moveTo:function(e){D(this,e),this.refresh()},refresh:function(){var e,t=this,n=t.x,i=t.y;t.round&&(n=Math.round(n),i=Math.round(i)),e=f(n,i,t.scale),e!=t.coordinates&&(_.support.browser.msie&&_.support.browser.version<10?(t.element[0].style.position="absolute",t.element[0].style.left=t.x+"px",t.element[0].style.top=t.y+"px"):t.element[0].style[Y]=e,t._saveCoordinates(e),t.trigger(z))},_saveCoordinates:function(e){this.coordinates=e}}),m=x.extend({init:function(e,t){var n,i=this;x.fn.init.call(i,e,t),n=i.options.group,n in I?I[n].push(i):I[n]=[i]},events:[V,U,W],options:{name:"DropTarget",group:"default"},destroy:function(){a(I,this)},_trigger:function(e,t){var n=this,i=E[n.options.group];if(i)return n.trigger(e,D({},t.event,{draggable:i,dropTarget:t.dropTarget}))},_over:function(e){this._trigger(V,e)},_out:function(e){this._trigger(U,e)},_drop:function(e){var t=this,n=E[t.options.group];n&&(n.dropped=!t._trigger(W,e))}}),m.destroyGroup=function(e){var t,n=I[e]||M[e];if(n){for(t=0;t<n.length;t++)x.fn.destroy.call(n[t]);n.length=0,delete I[e],delete M[e]}},m._cache=I,g=m.extend({init:function(e,t){var n,i=this;x.fn.init.call(i,e,t),n=i.options.group,n in M?M[n].push(i):M[n]=[i]},destroy:function(){a(M,this)},options:{name:"DropTargetArea",group:"default",filter:null}}),v=x.extend({init:function(e,t){var n=this;x.fn.init.call(n,e,t),n._activated=!1,n.userEvents=new S(n.element,{global:!0,allowSelection:!0,filter:n.options.filter,threshold:n.options.distance,start:T(n._start,n),hold:T(n._hold,n),move:T(n._drag,n),end:T(n._end,n),cancel:T(n._cancel,n),select:T(n._select,n)}),n._afterEndHandler=T(n._afterEnd,n),n._captureEscape=T(n._captureEscape,n)},events:[B,P,L,H,N,O],options:{name:"Draggable",distance:_.support.touch?0:5,group:"default",cursorOffset:null,axis:null,container:null,filter:null,ignore:null,holdToDrag:!1,autoScroll:!1,dropped:!1},cancelHold:function(){this._activated=!1},_captureEscape:function(e){var t=this;e.keyCode===_.keys.ESC&&(t._trigger(N,{event:e}),t.userEvents.cancel())},_updateHint:function(t){var n,i=this,r=i.options,s=i.boundaries,a=r.axis,l=i.options.cursorOffset;l?n={left:t.x.location+l.left,top:t.y.location+l.top}:(i.hintOffset.left+=t.x.delta,i.hintOffset.top+=t.y.delta,n=e.extend({},i.hintOffset)),s&&(n.top=o(n.top,s.y),n.left=o(n.left,s.x)),"x"===a?delete n.top:"y"===a&&delete n.left,i.hint.css(n)},_shouldIgnoreTarget:function(t){var n=this.options.ignore;return n&&e(t).is(n)},_select:function(e){this._shouldIgnoreTarget(e.event.target)||e.preventDefault()},_start:function(n){var i,o=this,s=o.options,a=s.container?e(s.container):null,l=s.hint;return this._shouldIgnoreTarget(n.touch.initialTouch)||s.holdToDrag&&!o._activated?(o.userEvents.cancel(),t):(o.currentTarget=n.target,o.currentTargetOffset=A(o.currentTarget),l&&(o.hint&&o.hint.stop(!0,!0).remove(),o.hint=_.isFunction(l)?e(l.call(o,o.currentTarget)):l,i=A(o.currentTarget),o.hintOffset=i,o.hint.css({position:"absolute",zIndex:2e4,left:i.left,top:i.top}).appendTo(w.body),o.angular("compile",function(){o.hint.removeAttr("ng-repeat");for(var t=e(n.target);!t.data("$$kendoScope")&&t.length;)t=t.parent();return{elements:o.hint.get(),scopeFrom:t.data("$$kendoScope")}})),E[s.group]=o,o.dropped=!1,a&&(o.boundaries=r(a,o.hint)),e(w).on(F,o._captureEscape),o._trigger(P,n)&&(o.userEvents.cancel(),o._afterEnd()),o.userEvents.capture(),t)},_hold:function(e){this.currentTarget=e.target,this._trigger(B,e)?this.userEvents.cancel():this._activated=!0},_drag:function(t){var n,i;t.preventDefault(),n=this._elementUnderCursor(t),this.options.autoScroll&&this._cursorElement!==n&&(this._scrollableParent=d(n),this._cursorElement=n),this._lastEvent=t,this._processMovement(t,n),this.options.autoScroll&&this._scrollableParent[0]&&(i=u(t.x.location,t.y.location,l(this._scrollableParent)),this._scrollCompenstation=e.extend({},this.hintOffset),this._scrollVelocity=i,0===i.y&&0===i.x?(clearInterval(this._scrollInterval),this._scrollInterval=null):this._scrollInterval||(this._scrollInterval=setInterval(e.proxy(this,"_autoScroll"),50))),this.hint&&this._updateHint(t)},_processMovement:function(n,i){this._withDropTarget(i,function(i,o){if(!i)return h&&(h._trigger(U,D(n,{dropTarget:e(h.targetElement)})),h=null),t;if(h){if(o===h.targetElement)return;h._trigger(U,D(n,{dropTarget:e(h.targetElement)}))}i._trigger(V,D(n,{dropTarget:e(o)})),h=D(i,{targetElement:o})}),this._trigger(L,D(n,{dropTarget:h,elementUnderCursor:i}))},_autoScroll:function(){var e,t,n,i,o,r,s,a,l=this._scrollableParent[0],d=this._scrollVelocity,u=this._scrollCompenstation;l&&(e=this._elementUnderCursor(this._lastEvent),this._processMovement(this._lastEvent,e),i=l===c()[0],i?(t=w.body.scrollHeight>y.height(),n=w.body.scrollWidth>y.width()):(t=l.offsetHeight<=l.scrollHeight,n=l.offsetWidth<=l.scrollWidth),o=l.scrollTop+d.y,r=t&&o>0&&o<l.scrollHeight,s=l.scrollLeft+d.x,a=n&&s>0&&s<l.scrollWidth,r&&(l.scrollTop+=d.y),a&&(l.scrollLeft+=d.x),this.hint&&i&&(a||r)&&(r&&(u.top+=d.y),a&&(u.left+=d.x),this.hint.css(u)))},_end:function(t){this._withDropTarget(this._elementUnderCursor(t),function(n,i){n&&(n._drop(D({},t,{dropTarget:e(i)})),h=null)}),this._cancel(this._trigger(H,t))},_cancel:function(e){var t=this;t._scrollableParent=null,this._cursorElement=null,clearInterval(this._scrollInterval),t._activated=!1,t.hint&&!t.dropped?setTimeout(function(){t.hint.stop(!0,!0),e?t._afterEndHandler():t.hint.animate(t.currentTargetOffset,"fast",t._afterEndHandler)},0):t._afterEnd()},_trigger:function(e,t){var n=this;return n.trigger(e,D({},t.event,{x:t.x,y:t.y,currentTarget:n.currentTarget,initialTarget:t.touch?t.touch.initialTouch:null,dropTarget:t.dropTarget,elementUnderCursor:t.elementUnderCursor}))},_elementUnderCursor:function(e){var t=R(e),i=this.hint;return i&&n(i[0],t)&&(i.hide(),t=R(e),t||(t=R(e)),i.show()),t},_withDropTarget:function(e,t){var n,i=this.options.group,o=I[i],r=M[i];(o&&o.length||r&&r.length)&&(n=s(e,o,r),n?t(n.target,n.targetElement):t())},destroy:function(){var e=this;x.fn.destroy.call(e),e._afterEnd(),e.userEvents.destroy(),this._scrollableParent=null,this._cursorElement=null,clearInterval(this._scrollInterval),e.currentTarget=null},_afterEnd:function(){var t=this;t.hint&&t.hint.remove(),delete E[t.options.group],t.trigger("destroy"),t.trigger(O),e(w).off(F,t._captureEscape)}}),_.ui.plugin(m),_.ui.plugin(g),_.ui.plugin(v),_.TapCapture=j,_.containerBoundaries=r,D(_.ui,{Pane:K,PaneDimensions:G,Movable:p}),_.ui.Draggable.utils={autoScrollVelocity:u,scrollableViewPort:l,findScrollableParent:d}}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.scroller.min",["kendo.fx.min","kendo.draganddrop.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile,o=n.effects,r=i.ui,s=e.proxy,a=e.extend,l=r.Widget,c=n.Class,d=n.ui.Movable,u=n.ui.Pane,h=n.ui.PaneDimensions,f=o.Transition,p=o.Animation,m=Math.abs,g=500,v=.7,_=.96,b=10,w=55,y=.5,k=5,x="km-scroller-release",C="km-scroller-refresh",S="pull",T="change",D="resize",A="scroll",E=2,I=p.extend({init:function(e){var t=this;p.fn.init.call(t),a(t,e),t.userEvents.bind("gestureend",s(t.start,t)),t.tapCapture.bind("press",s(t.cancel,t))},enabled:function(){return this.movable.scale<this.dimensions.minScale},done:function(){return this.dimensions.minScale-this.movable.scale<.01},tick:function(){var e=this.movable;e.scaleWith(1.1),this.dimensions.rescale(e.scale)},onEnd:function(){var e=this.movable;e.scaleTo(this.dimensions.minScale),this.dimensions.rescale(e.scale)}}),M=p.extend({init:function(e){var t=this;p.fn.init.call(t),a(t,e,{transition:new f({axis:e.axis,movable:e.movable,onEnd:function(){t._end()}})}),t.tapCapture.bind("press",function(){t.cancel()}),t.userEvents.bind("end",s(t.start,t)),t.userEvents.bind("gestureend",s(t.start,t)),t.userEvents.bind("tap",s(t.onEnd,t))},onCancel:function(){this.transition.cancel()},freeze:function(e){var t=this;t.cancel(),t._moveTo(e)},onEnd:function(){var e=this;e.paneAxis.outOfBounds()?e._snapBack():e._end()},done:function(){return m(this.velocity)<1},start:function(e){var t,n=this;n.dimension.enabled&&(n.paneAxis.outOfBounds()?n._snapBack():(t=e.touch.id===E?0:e.touch[n.axis].velocity,n.velocity=Math.max(Math.min(t*n.velocityMultiplier,w),-w),n.tapCapture.captureNext(),p.fn.start.call(n)))},tick:function(){var e=this,t=e.dimension,n=e.paneAxis.outOfBounds()?y:e.friction,i=e.velocity*=n,o=e.movable[e.axis]+i;!e.elastic&&t.outOfBounds(o)&&(o=Math.max(Math.min(o,t.max),t.min),e.velocity=0),e.movable.moveAxis(e.axis,o)},_end:function(){this.tapCapture.cancelCapture(),this.end()},_snapBack:function(){var e=this,t=e.dimension,n=e.movable[e.axis]>t.max?t.max:t.min;e._moveTo(n)},_moveTo:function(e){this.transition.moveTo({location:e,duration:g,ease:f.easeOutExpo})}}),R=p.extend({init:function(e){var t=this;n.effects.Animation.fn.init.call(this),a(t,e,{origin:{},destination:{},offset:{}})},tick:function(){this._updateCoordinates(),this.moveTo(this.origin)},done:function(){return m(this.offset.y)<k&&m(this.offset.x)<k},onEnd:function(){this.moveTo(this.destination),this.callback&&this.callback.call()},setCoordinates:function(e,t){this.offset={},this.origin=e,this.destination=t},setCallback:function(e){e&&n.isFunction(e)?this.callback=e:e=t},_updateCoordinates:function(){this.offset={x:(this.destination.x-this.origin.x)/4,y:(this.destination.y-this.origin.y)/4},this.origin={y:this.origin.y+this.offset.y,x:this.origin.x+this.offset.x}}}),F=c.extend({init:function(t){var n=this,i="x"===t.axis,o=e('<div class="km-touch-scrollbar km-'+(i?"horizontal":"vertical")+'-scrollbar" />');a(n,t,{element:o,elementSize:0,movable:new d(o),scrollMovable:t.movable,alwaysVisible:t.alwaysVisible,size:i?"width":"height"}),n.scrollMovable.bind(T,s(n.refresh,n)),n.container.append(o),t.alwaysVisible&&n.show()},refresh:function(){var e=this,t=e.axis,n=e.dimension,i=n.size,o=e.scrollMovable,r=i/n.total,s=Math.round(-o[t]*r),a=Math.round(i*r);r>=1?this.element.css("display","none"):this.element.css("display",""),s+a>i?a=i-s:s<0&&(a+=s,s=0),e.elementSize!=a&&(e.element.css(e.size,a+"px"),e.elementSize=a),e.movable.moveAxis(t,s)},show:function(){this.element.css({opacity:v,visibility:"visible"})},hide:function(){this.alwaysVisible||this.element.css({opacity:0})}}),z=l.extend({init:function(i,o){var r,c,f,p,g,v,_,b,w,y=this;return l.fn.init.call(y,i,o),i=y.element,(y._native=y.options.useNative&&n.support.hasNativeScrolling)?(i.addClass("km-native-scroller").prepend('<div class="km-scroll-header"/>'),a(y,{scrollElement:i,fixedContainer:i.children().first()}),t):(i.css("overflow","hidden").addClass("km-scroll-wrapper").wrapInner('<div class="km-scroll-container"/>').prepend('<div class="km-scroll-header"/>'),
r=i.children().eq(1),c=new n.TapCapture(i),f=new d(r),p=new h({element:r,container:i,forcedEnabled:y.options.zoom}),g=this.options.avoidScrolling,v=new n.UserEvents(i,{touchAction:"pan-y",fastTap:!0,allowSelection:!0,preventDragEvent:!0,captureUpIfMoved:!0,multiTouch:y.options.zoom,start:function(t){p.refresh();var n=m(t.x.velocity),i=m(t.y.velocity),o=2*n>=i,r=e.contains(y.fixedContainer[0],t.event.target),s=2*i>=n;!r&&!g(t)&&y.enabled&&(p.x.enabled&&o||p.y.enabled&&s)?v.capture():v.cancel()}}),_=new u({movable:f,dimensions:p,userEvents:v,elastic:y.options.elastic}),b=new I({movable:f,dimensions:p,userEvents:v,tapCapture:c}),w=new R({moveTo:function(e){y.scrollTo(e.x,e.y)}}),f.bind(T,function(){y.scrollTop=-f.y,y.scrollLeft=-f.x,y.trigger(A,{scrollTop:y.scrollTop,scrollLeft:y.scrollLeft})}),y.options.mousewheelScrolling&&i.on("DOMMouseScroll mousewheel",s(this,"_wheelScroll")),a(y,{movable:f,dimensions:p,zoomSnapBack:b,animatedScroller:w,userEvents:v,pane:_,tapCapture:c,pulled:!1,enabled:!0,scrollElement:r,scrollTop:0,scrollLeft:0,fixedContainer:i.children().first()}),y._initAxis("x"),y._initAxis("y"),y._wheelEnd=function(){y._wheel=!1,y.userEvents.end(0,y._wheelY)},p.refresh(),y.options.pullToRefresh&&y._initPullToRefresh(),t)},_wheelScroll:function(e){this._wheel||(this._wheel=!0,this._wheelY=0,this.userEvents.press(0,this._wheelY)),clearTimeout(this._wheelTimeout),this._wheelTimeout=setTimeout(this._wheelEnd,50);var t=n.wheelDeltaY(e);t&&(this._wheelY+=t,this.userEvents.move(0,this._wheelY)),e.preventDefault()},makeVirtual:function(){this.dimensions.y.makeVirtual()},virtualSize:function(e,t){this.dimensions.y.virtualSize(e,t)},height:function(){return this.dimensions.y.size},scrollHeight:function(){return this.scrollElement[0].scrollHeight},scrollWidth:function(){return this.scrollElement[0].scrollWidth},options:{name:"Scroller",zoom:!1,pullOffset:140,visibleScrollHints:!1,elastic:!0,useNative:!1,mousewheelScrolling:!0,avoidScrolling:function(){return!1},pullToRefresh:!1,messages:{pullTemplate:"Pull to refresh",releaseTemplate:"Release to refresh",refreshTemplate:"Refreshing"}},events:[S,A,D],_resize:function(){this._native||this.contentResized()},setOptions:function(e){var t=this;l.fn.setOptions.call(t,e),e.pullToRefresh&&t._initPullToRefresh()},reset:function(){this._native?this.scrollElement.scrollTop(0):(this.movable.moveTo({x:0,y:0}),this._scale(1))},contentResized:function(){this.dimensions.refresh(),this.pane.x.outOfBounds()&&this.movable.moveAxis("x",this.dimensions.x.min),this.pane.y.outOfBounds()&&this.movable.moveAxis("y",this.dimensions.y.min)},zoomOut:function(){var e=this.dimensions;e.refresh(),this._scale(e.fitScale),this.movable.moveTo(e.centerCoordinates())},enable:function(){this.enabled=!0},disable:function(){this.enabled=!1},scrollTo:function(e,t){this._native?(this.scrollElement.scrollLeft(m(e)),this.scrollElement.scrollTop(m(t))):(this.dimensions.refresh(),this.movable.moveTo({x:e,y:t}))},animatedScrollTo:function(e,t,n){var i,o;this._native?this.scrollTo(e,t):(i={x:this.movable.x,y:this.movable.y},o={x:e,y:t},this.animatedScroller.setCoordinates(i,o),this.animatedScroller.setCallback(n),this.animatedScroller.start())},pullHandled:function(){var e=this;e.refreshHint.removeClass(C),e.hintContainer.html(e.pullTemplate({})),e.yinertia.onEnd(),e.xinertia.onEnd(),e.userEvents.cancel()},destroy:function(){l.fn.destroy.call(this),this.userEvents&&this.userEvents.destroy()},_scale:function(e){this.dimensions.rescale(e),this.movable.scaleTo(e)},_initPullToRefresh:function(){var e=this;e.dimensions.y.forceEnabled(),e.pullTemplate=n.template(e.options.messages.pullTemplate),e.releaseTemplate=n.template(e.options.messages.releaseTemplate),e.refreshTemplate=n.template(e.options.messages.refreshTemplate),e.scrollElement.prepend('<span class="km-scroller-pull"><span class="km-icon"></span><span class="km-loading-left"></span><span class="km-loading-right"></span><span class="km-template">'+e.pullTemplate({})+"</span></span>"),e.refreshHint=e.scrollElement.children().first(),e.hintContainer=e.refreshHint.children(".km-template"),e.pane.y.bind("change",s(e._paneChange,e)),e.userEvents.bind("end",s(e._dragEnd,e))},_dragEnd:function(){var e=this;e.pulled&&(e.pulled=!1,e.refreshHint.removeClass(x).addClass(C),e.hintContainer.html(e.refreshTemplate({})),e.yinertia.freeze(e.options.pullOffset/2),e.trigger("pull"))},_paneChange:function(){var e=this;e.movable.y/y>e.options.pullOffset?e.pulled||(e.pulled=!0,e.refreshHint.removeClass(C).addClass(x),e.hintContainer.html(e.releaseTemplate({}))):e.pulled&&(e.pulled=!1,e.refreshHint.removeClass(x),e.hintContainer.html(e.pullTemplate({})))},_initAxis:function(e){var t=this,n=t.movable,i=t.dimensions[e],o=t.tapCapture,r=t.pane[e],s=new F({axis:e,movable:n,dimension:i,container:t.element,alwaysVisible:t.options.visibleScrollHints});i.bind(T,function(){s.refresh()}),r.bind(T,function(){s.show()}),t[e+"inertia"]=new M({axis:e,paneAxis:r,movable:n,tapCapture:o,userEvents:t.userEvents,dimension:i,elastic:t.options.elastic,friction:t.options.friction||_,velocityMultiplier:t.options.velocityMultiplier||b,end:function(){s.hide(),t.trigger("scrollEnd",{axis:e,scrollTop:t.scrollTop,scrollLeft:t.scrollLeft})}})}});r.plugin(z)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.groupable.min",["kendo.core.min","kendo.draganddrop.min"],e)}(function(){return function(e,t){function n(e){return e.position().top+3}var i=window.kendo,o=i.ui.Widget,r=i._outerWidth,s=e.proxy,a=!1,l=".kendoGroupable",c="change",d=i.template('<div class="k-group-indicator" data-#=data.ns#field="${data.field}" data-#=data.ns#title="${data.title || ""}" data-#=data.ns#dir="${data.dir || "asc"}"><a href="\\#" class="k-link"><span class="k-icon k-i-sort-${(data.dir || "asc") == "asc" ? "asc-sm" : "desc-sm"}" title="(sorted ${(data.dir || "asc") == "asc" ? "ascending": "descending"})"></span>${data.title ? data.title: data.field}</a><a class="k-button k-button-icon k-bare"><span class="k-icon k-i-close"></span></a></div>',{useWithBlock:!1}),u=function(t){var n=t.attr(i.attr("title"));return n&&(n=i.htmlEncode(n)),e('<div class="k-header k-drag-clue" />').css({width:t.width(),paddingLeft:t.css("paddingLeft"),paddingRight:t.css("paddingRight"),lineHeight:t.height()+"px",paddingTop:t.css("paddingTop"),paddingBottom:t.css("paddingBottom")}).html(n||t.attr(i.attr("field"))).prepend('<span class="k-icon k-drag-status k-i-cancel" />')},h=e('<div class="k-grouping-dropclue"/>'),f=o.extend({init:function(d,f){var p,m,g=this,v=i.guid(),_=s(g._intializePositions,g),b=g._dropCuePositions=[];o.fn.init.call(g,d,f),a=i.support.isRtl(d),m=a?"right":"left",g.draggable=p=g.options.draggable||new i.ui.Draggable(g.element,{filter:g.options.draggableElements,hint:u,group:v}),g.groupContainer=e(g.options.groupContainer,g.element).kendoDropTarget({group:p.options.group,dragenter:function(e){g._canDrag(e.draggable.currentTarget)&&(e.draggable.hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus"),h.css("top",n(g.groupContainer)).css(m,0).appendTo(g.groupContainer))},dragleave:function(e){e.draggable.hint.find(".k-drag-status").removeClass("k-i-plus").addClass("k-i-cancel"),h.remove()},drop:function(t){var n,o=t.draggable.currentTarget,r=o.attr(i.attr("field")),s=o.attr(i.attr("title")),l=g.indicator(r),c=g._dropCuePositions,d=c[c.length-1];(o.hasClass("k-group-indicator")||g._canDrag(o))&&(d?(n=g._dropCuePosition(i.getOffset(h).left+parseInt(d.element.css("marginLeft"),10)*(a?-1:1)+parseInt(d.element.css("marginRight"),10)),n&&g._canDrop(e(l),n.element,n.left)&&(n.before?n.element.before(l||g.buildIndicator(r,s)):n.element.after(l||g.buildIndicator(r,s)),g._change())):(g.groupContainer.append(g.buildIndicator(r,s)),g._change()))}}).kendoDraggable({filter:"div.k-group-indicator",hint:u,group:p.options.group,dragcancel:s(g._dragCancel,g),dragstart:function(e){var t=e.currentTarget,i=parseInt(t.css("marginLeft"),10),o=t.position(),s=a?o.left-i:o.left+r(t);_(),h.css({top:n(g.groupContainer),left:s}).appendTo(g.groupContainer),this.hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus")},dragend:function(){g._dragEnd(this)},drag:s(g._drag,g)}).on("click"+l,".k-button",function(t){t.preventDefault(),g._removeIndicator(e(this).parent())}).on("click"+l,".k-link",function(t){var n=e(this).parent(),o=g.buildIndicator(n.attr(i.attr("field")),n.attr(i.attr("title")),"asc"==n.attr(i.attr("dir"))?"desc":"asc");n.before(o).remove(),g._change(),t.preventDefault()}),p.bind(["dragend","dragcancel","dragstart","drag"],{dragend:function(){g._dragEnd(this)},dragcancel:s(g._dragCancel,g),dragstart:function(e){var n,i,o;return g.options.allowDrag||g._canDrag(e.currentTarget)?(_(),b.length?(n=b[b.length-1].element,i=parseInt(n.css("marginRight"),10),o=n.position().left+r(n)+i):o=0,t):(e.preventDefault(),t)},drag:s(g._drag,g)}),g.dataSource=g.options.dataSource,g.dataSource&&g._refreshHandler?g.dataSource.unbind(c,g._refreshHandler):g._refreshHandler=s(g.refresh,g),g.dataSource&&(g.dataSource.bind("change",g._refreshHandler),g.refresh())},refresh:function(){var t=this,n=t.dataSource;t.groupContainer&&t.groupContainer.empty().append(e.map(n.group()||[],function(n){var o=n.field,r=i.attr("field"),s=t.element.find(t.options.filter).filter(function(){return e(this).attr(r)===o});return t.buildIndicator(n.field,s.attr(i.attr("title")),n.dir)}).join("")),t._invalidateGroupContainer()},destroy:function(){var e=this;o.fn.destroy.call(e),e.groupContainer.off(l),e.groupContainer.data("kendoDropTarget")&&e.groupContainer.data("kendoDropTarget").destroy(),e.groupContainer.data("kendoDraggable")&&e.groupContainer.data("kendoDraggable").destroy(),e.options.draggable||e.draggable.destroy(),e.dataSource&&e._refreshHandler&&(e.dataSource.unbind("change",e._refreshHandler),e._refreshHandler=null),e.groupContainer=e.element=e.draggable=null},events:["change"],options:{name:"Groupable",filter:"th",draggableElements:"th",messages:{empty:"Drag a column header and drop it here to group by that column"}},indicator:function(t){var n=e(".k-group-indicator",this.groupContainer);return e.grep(n,function(n){return e(n).attr(i.attr("field"))===t})[0]},buildIndicator:function(e,t,n){return d({field:e.replace(/"/g,"'"),dir:n,title:t,ns:i.ns})},descriptors:function(){var t,n,o,r,s,a=this,l=e(".k-group-indicator",a.groupContainer);return t=a.element.find(a.options.filter).map(function(){var t=e(this),o=t.attr(i.attr("aggregates")),a=t.attr(i.attr("field"));if(o&&""!==o)for(n=o.split(","),o=[],r=0,s=n.length;r<s;r++)o.push({field:a,aggregate:n[r]});return o}).toArray(),e.map(l,function(n){return n=e(n),o=n.attr(i.attr("field")),{field:o,dir:n.attr(i.attr("dir")),aggregates:t||[]}})},_removeIndicator:function(e){var t=this;e.remove(),t._invalidateGroupContainer(),t._change()},_change:function(){var e,n=this;if(n.dataSource){if(e=n.descriptors(),n.trigger("change",{groups:e}))return n.refresh(),t;n.dataSource.group(e)}},_dropCuePosition:function(t){var n,i,o,s,l,c=this._dropCuePositions;if(h.is(":visible")&&0!==c.length)return t=Math.ceil(t),n=c[c.length-1],i=n.left,o=n.right,s=parseInt(n.element.css("marginLeft"),10),l=parseInt(n.element.css("marginRight"),10),t>=o&&!a||t<i&&a?t={left:n.element.position().left+(a?-s:r(n.element)+l),element:n.element,before:!1}:(t=e.grep(c,function(e){return e.left<=t&&t<=e.right||a&&t>e.right})[0],t&&(t={left:a?t.element.position().left+r(t.element)+l:t.element.position().left-s,element:t.element,before:!0})),t},_drag:function(e){var t=this._dropCuePosition(e.x.location);t&&h.css({left:t.left,right:"auto"})},_canDrag:function(e){var t=e.attr(i.attr("field"));return"false"!=e.attr(i.attr("groupable"))&&t&&(e.hasClass("k-group-indicator")||!this.indicator(t))},_canDrop:function(e,t,n){var i=e.next(),o=e[0]!==t[0]&&(!i[0]||t[0]!==i[0]||!a&&n>i.position().left||a&&n<i.position().left);return o},_dragEnd:function(t){var n=this,o=t.currentTarget.attr(i.attr("field")),r=n.indicator(o);t!==n.options.draggable&&!t.dropped&&r&&n._removeIndicator(e(r)),n._dragCancel()},_dragCancel:function(){h.remove(),this._dropCuePositions=[]},_intializePositions:function(){var t,n=this,o=e(".k-group-indicator",n.groupContainer);n._dropCuePositions=e.map(o,function(n){return n=e(n),t=i.getOffset(n).left,{left:parseInt(t,10),right:parseInt(t+r(n),10),element:n}})},_invalidateGroupContainer:function(){var e=this.groupContainer;e&&e.is(":empty")&&e.html(this.options.messages.empty)}});i.ui.plugin(f)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.reorderable.min",["kendo.core.min","kendo.draganddrop.min"],e)}(function(){return function(e,t){function n(t,n){t=e(t),n?t.find(".k-drag-status").removeClass("k-i-plus").addClass("k-i-cancel"):t.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus")}var i=window.kendo,o=i._outerWidth,r=i._outerHeight,s=i.getOffset,a=i.ui.Widget,l="change",c="k-reorderable",d=a.extend({init:function(t,d){var u,h=this,f=i.guid()+"-reorderable";a.fn.init.call(h,t,d),t=h.element.addClass(c),d=h.options,h.draggable=u=d.draggable||new i.ui.Draggable(t,{group:f,autoScroll:!0,filter:d.filter,hint:d.hint}),h.reorderDropCue=e('<div class="k-reorder-cue"></div></div>'),t.find(u.options.filter).kendoDropTarget({group:u.options.group,dragenter:function(e){var t,i,a,l;h._draggable&&(t=this.element,a=!h._dropTargetAllowed(t)||h._isLastDraggable(),n(e.draggable.hint,a),a||(i=s(t),l=i.left,d.inSameContainer&&!d.inSameContainer({source:t,target:h._draggable,sourceIndex:h._index(t),targetIndex:h._index(h._draggable)})?h._dropTarget=t:h._index(t)>h._index(h._draggable)&&(l+=o(t)),h.reorderDropCue.css({height:r(t),top:i.top,left:l}).appendTo(document.body)))},dragleave:function(e){n(e.draggable.hint,!0),h.reorderDropCue.remove(),h._dropTarget=null},drop:function(){var e,t;h._dropTarget=null,h._draggable&&(e=this.element,t=h._draggable,h._dropTargetAllowed(e)&&!h._isLastDraggable()&&h.trigger(l,{element:h._draggable,target:e,oldIndex:h._index(t),newIndex:h._index(e),position:s(h.reorderDropCue).left>s(e).left?"after":"before"}))}}),u.bind(["dragcancel","dragend","dragstart","drag"],{dragcancel:function(){h.reorderDropCue.remove(),h._draggable=null,h._elements=null},dragend:function(){h.reorderDropCue.remove(),h._draggable=null,h._elements=null},dragstart:function(e){h._draggable=e.currentTarget,h._elements=h.element.find(h.draggable.options.filter)},drag:function(e){var t,n;h._dropTarget&&!this.hint.find(".k-drag-status").hasClass("k-i-cancel")&&(t=s(h._dropTarget).left,n=o(h._dropTarget),h.reorderDropCue.css(e.pageX>t+n/2?{left:t+n}:{left:t}))}})},options:{name:"Reorderable",filter:"*"},events:[l],_isLastDraggable:function(){var e,t=this.options.inSameContainer,n=this._draggable[0],i=this._elements.get(),o=!1;if(!t)return!1;for(;!o&&i.length>0;)e=i.pop(),o=n!==e&&t({source:n,target:e,sourceIndex:this._index(n),targetIndex:this._index(e)});return!o},_dropTargetAllowed:function(e){var t=this.options.inSameContainer,n=this.options.dragOverContainers,i=this._draggable;return i[0]!==e[0]&&(!t||!n||(!!t({source:i,target:e,sourceIndex:this._index(i),targetIndex:this._index(e)})||n(this._index(i),this._index(e))))},_index:function(e){return this._elements.index(e)},destroy:function(){var t=this;a.fn.destroy.call(t),t.element.find(t.draggable.options.filter).each(function(){var t=e(this);t.data("kendoDropTarget")&&t.data("kendoDropTarget").destroy()}),t.draggable&&(t.draggable.destroy(),t.draggable.element=t.draggable=null),t.elements=t.reorderDropCue=t._elements=t._draggable=null}});i.ui.plugin(d)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.resizable.min",["kendo.core.min","kendo.draganddrop.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.ui,o=i.Widget,r=e.proxy,s=n.isFunction,a=e.extend,l="horizontal",c="vertical",d="start",u="resize",h="resizeend",f=o.extend({init:function(e,t){var n=this;o.fn.init.call(n,e,t),n.orientation=n.options.orientation.toLowerCase()!=c?l:c,n._positionMouse=n.orientation==l?"x":"y",n._position=n.orientation==l?"left":"top",n._sizingDom=n.orientation==l?"outerWidth":"outerHeight",n.draggable=new i.Draggable(t.draggableElement||e,{distance:1,filter:t.handle,drag:r(n._resize,n),dragcancel:r(n._cancel,n),dragstart:r(n._start,n),dragend:r(n._stop,n)}),n.userEvents=n.draggable.userEvents},events:[u,h,d],options:{name:"Resizable",orientation:l},resize:function(){},_max:function(e){var n=this,i=n.hint?n.hint[n._sizingDom]():0,o=n.options.max;return s(o)?o(e):o!==t?n._initialElementPosition+o-i:o},_min:function(e){var n=this,i=n.options.min;return s(i)?i(e):i!==t?n._initialElementPosition+i:i},_start:function(t){var n=this,i=n.options.hint,o=e(t.currentTarget);n._initialElementPosition=o.position()[n._position],n._initialMousePosition=t[n._positionMouse].startLocation,i&&(n.hint=s(i)?e(i(o)):i,n.hint.css({position:"absolute"}).css(n._position,n._initialElementPosition).appendTo(n.element)),n.trigger(d,t),n._maxPosition=n._max(t),n._minPosition=n._min(t),e(document.body).css("cursor",o.css("cursor"))},_resize:function(e){var n,i=this,o=i._maxPosition,r=i._minPosition,s=i._initialElementPosition+(e[i._positionMouse].location-i._initialMousePosition);n=r!==t?Math.max(r,s):s,i.position=n=o!==t?Math.min(o,n):n,i.hint&&i.hint.toggleClass(i.options.invalidClass||"",n==o||n==r).css(i._position,n),i.resizing=!0,i.trigger(u,a(e,{position:n}))},_stop:function(t){var n=this;n.hint&&n.hint.remove(),n.resizing=!1,n.trigger(h,a(t,{position:n.position})),e(document.body).css("cursor","")},_cancel:function(e){var n=this;n.hint&&(n.position=t,n.hint.css(n._position,n._initialElementPosition),n._stop(e))},destroy:function(){var e=this;o.fn.destroy.call(e),e.draggable&&e.draggable.destroy()},press:function(e){if(e){var t=e.position(),n=this;n.userEvents.press(t.left,t.top,e[0]),n.targetPosition=t,n.target=e}},move:function(e){var n=this,i=n._position,o=n.targetPosition,r=n.position;r===t&&(r=o[i]),o[i]=r+e,n.userEvents.move(o.left,o.top)},end:function(){this.userEvents.end(),this.target=this.position=t}});n.ui.plugin(f)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.sortable.min",["kendo.draganddrop.min"],e)}(function(){return function(e,t){function n(t,n){try{return e.contains(t,n)||t==n}catch(i){return!1}}function i(e){return e.clone()}function o(e){return e.clone().removeAttr("id").css("visibility","hidden")}var r=window.kendo,s=r.ui.Widget,a=r._outerWidth,l=r._outerHeight,c="start",d="beforeMove",u="move",h="end",f="change",p="cancel",m="sort",g="remove",v="receive",_=">*",b=-1,w=s.extend({init:function(e,t){var n=this;s.fn.init.call(n,e,t),n.options.placeholder||(n.options.placeholder=o),n.options.hint||(n.options.hint=i),n.draggable=n._createDraggable()},events:[c,d,u,h,f,p],options:{name:"Sortable",hint:null,placeholder:null,filter:_,holdToDrag:!1,disabled:null,container:null,connectWith:null,handler:null,cursorOffset:null,axis:null,ignore:null,autoScroll:!1,cursor:"auto",moveOnDragEnter:!1},destroy:function(){this.draggable.destroy(),s.fn.destroy.call(this)},_createDraggable:function(){var t=this,n=t.element,i=t.options;return new r.ui.Draggable(n,{filter:i.filter,hint:r.isFunction(i.hint)?i.hint:e(i.hint),holdToDrag:i.holdToDrag,container:i.container?e(i.container):null,cursorOffset:i.cursorOffset,axis:i.axis,ignore:i.ignore,autoScroll:i.autoScroll,dragstart:e.proxy(t._dragstart,t),dragcancel:e.proxy(t._dragcancel,t),drag:e.proxy(t._drag,t),dragend:e.proxy(t._dragend,t)})},_dragstart:function(t){var n=this.draggedElement=t.currentTarget,i=this.options.disabled,o=this.options.handler,s=this.options.placeholder,a=this.placeholder=e(r.isFunction(s)?s.call(this,n):s);i&&n.is(i)?t.preventDefault():o&&!e(t.initialTarget).is(o)?t.preventDefault():this.trigger(c,{item:n,draggableEvent:t})?t.preventDefault():(n.css("display","none"),n.before(a),this._setCursor())},_dragcancel:function(){this._cancel(),this.trigger(p,{item:this.draggedElement}),this._resetCursor()},_drag:function(n){var i,o,r,s,a,l=this.draggedElement,c=this._findTarget(n),d={left:n.x.location,top:n.y.location},u={x:n.x.delta,y:n.y.delta},h=this.options.axis,f=this.options.moveOnDragEnter,p={item:l,list:this,draggableEvent:n};if("x"===h||"y"===h)return this._movementByAxis(h,d,u[h],p),t;if(c){if(i=this._getElementCenter(c.element),o={left:Math.round(d.left-i.left),top:Math.round(d.top-i.top)},e.extend(p,{target:c.element}),c.appendToBottom)return this._movePlaceholder(c,null,p),t;if(c.appendAfterHidden&&this._movePlaceholder(c,"next",p),this._isFloating(c.element)?u.x<0&&f||!f&&o.left<0?r="prev":(u.x>0&&f||!f&&o.left>0)&&(r="next"):u.y<0&&f||!f&&o.top<0?r="prev":(u.y>0&&f||!f&&o.top>0)&&(r="next"),r){for(a="prev"===r?jQuery.fn.prev:jQuery.fn.next,s=a.call(c.element);s.length&&!s.is(":visible");)s=a.call(s);s[0]!=this.placeholder[0]&&this._movePlaceholder(c,r,p)}}},_dragend:function(n){var i,o,r,s,a=this.placeholder,l=this.draggedElement,c=this.indexOf(l),d=this.indexOf(a),u=this.options.connectWith;return this._resetCursor(),r={action:m,item:l,oldIndex:c,newIndex:d,draggableEvent:n},d>=0?o=this.trigger(h,r):(i=a.parents(u).getKendoSortable(),r.action=g,s=e.extend({},r,{action:v,oldIndex:b,newIndex:i.indexOf(a)}),o=!(!this.trigger(h,r)&&!i.trigger(h,s))),o||d===c?(this._cancel(),t):(a.replaceWith(l),l.show(),this.draggable.dropped=!0,r={action:this.indexOf(l)!=b?m:g,item:l,oldIndex:c,newIndex:this.indexOf(l),draggableEvent:n},this.trigger(f,r),i&&(s=e.extend({},r,{action:v,oldIndex:b,newIndex:i.indexOf(l)}),i.trigger(f,s)),t)},_findTarget:function(n){var i,o,r=this._findElementUnderCursor(n),s=this.options.connectWith;return e.contains(this.element[0],r)?(i=this.items(),o=i.filter(r)[0]||i.has(r)[0],o?{element:e(o),sortable:this}:null):this.element[0]==r&&this._isEmpty()?{element:this.element,sortable:this,appendToBottom:!0}:this.element[0]==r&&this._isLastHidden()?(o=this.items().eq(0),{element:o,sortable:this,appendAfterHidden:!0}):s?this._searchConnectedTargets(r,n):t},_findElementUnderCursor:function(e){var t=r.elementUnderCursor(e),i=e.sender;return n(i.hint[0],t)&&(i.hint.hide(),t=r.elementUnderCursor(e),t||(t=r.elementUnderCursor(e)),i.hint.show()),t},_searchConnectedTargets:function(t,n){var i,o,r,s,a=e(this.options.connectWith);for(s=0;s<a.length;s++)if(i=a.eq(s).getKendoSortable(),e.contains(a[s],t)){if(i)return o=i.items(),r=o.filter(t)[0]||o.has(t)[0],r?(i.placeholder=this.placeholder,{element:e(r),sortable:i}):null}else if(a[s]==t){if(i&&i._isEmpty())return{element:a.eq(s),sortable:i,appendToBottom:!0};if(this._isCursorAfterLast(i,n))return r=i.items().last(),{element:r,sortable:i}}},_isCursorAfterLast:function(e,t){var n,i,o=e.items().last(),s={left:t.x.location,top:t.y.location};return n=r.getOffset(o),n.top+=l(o),n.left+=a(o),i=this._isFloating(o)?n.left-s.left:n.top-s.top,i<0},_movementByAxis:function(t,n,i,o){var r,s="x"===t?n.left:n.top,a=i<0?this.placeholder.prev():this.placeholder.next();a.length&&!a.is(":visible")&&(a=i<0?a.prev():a.next()),e.extend(o,{target:a}),r=this._getElementCenter(a),r&&(r="x"===t?r.left:r.top),a.length&&i<0&&s-r<0?this._movePlaceholder({element:a,sortable:this},"prev",o):a.length&&i>0&&s-r>0&&this._movePlaceholder({element:a,sortable:this},"next",o)},_movePlaceholder:function(e,t,n){var i=this.placeholder;e.sortable.trigger(d,n)||(t?"prev"===t?e.element.before(i):"next"===t&&e.element.after(i):e.element.append(i),e.sortable.trigger(u,n))},_setCursor:function(){var t,n=this.options.cursor;n&&"auto"!==n&&(t=e(document.body),this._originalCursorType=t.css("cursor"),t.css({cursor:n}),this._cursorStylesheet||(this._cursorStylesheet=e("<style>* { cursor: "+n+" !important; }</style>")),this._cursorStylesheet.appendTo(t))},_resetCursor:function(){this._originalCursorType&&(e(document.body).css("cursor",this._originalCursorType),this._originalCursorType=null,this._cursorStylesheet.remove())},_getElementCenter:function(e){var t=e.length?r.getOffset(e):null;return t&&(t.top+=l(e)/2,t.left+=a(e)/2),t},_isFloating:function(e){return/left|right/.test(e.css("float"))||/inline|table-cell/.test(e.css("display"))},_cancel:function(){this.draggedElement.show(),this.placeholder.remove()},_items:function(){var e,t=this.options.filter;return e=t?this.element.find(t):this.element.children()},indexOf:function(e){var t=this._items(),n=this.placeholder,i=this.draggedElement;return n&&e[0]==n[0]?t.not(i).index(e):t.not(n).index(e)},items:function(){var e=this.placeholder,t=this._items();return e&&(t=t.not(e)),t},_isEmpty:function(){return!this.items().length},_isLastHidden:function(){return 1===this.items().length&&this.items().is(":hidden")}});r.ui.plugin(w)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.selectable.min",["kendo.core.min","kendo.userevents.min"],e)}(function(){return function(e,t){function n(e,t){if(!e.is(":visible"))return!1;var n=o.getOffset(e),i=t.left+t.width,r=t.top+t.height;return n.right=n.left+o._outerWidth(e),n.bottom=n.top+o._outerHeight(e),!(n.left>i||n.right<t.left||n.top>r||n.bottom<t.top)}var i,o=window.kendo,r=o.ui.Widget,s=e.proxy,a=Math.abs,l="aria-selected",c="k-state-selected",d="k-state-selecting",u="k-selectable",h="change",f=".kendoSelectable",p="k-state-unselecting",m="input,a,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up",g=o.support.browser.msie,v=!1;!function(e){!function(){e('<div class="parent"><span /></div>').on("click",">*",function(){v=!0}).find("span").click().end().off()}()}(e),i=r.extend({init:function(t,n){var i,a=this;r.fn.init.call(a,t,n),a._marquee=e("<div class='k-marquee'><div class='k-marquee-color'></div></div>"),a._lastActive=null,a.element.addClass(u),a.relatedTarget=a.options.relatedTarget,i=a.options.multiple,this.options.aria&&i&&a.element.attr("aria-multiselectable",!0),a.userEvents=new o.UserEvents(a.element,{global:!0,allowSelection:!0,filter:(v?"":"."+u+" ")+a.options.filter,tap:s(a._tap,a),touchAction:i?"none":"pan-x pan-y"}),i&&a.userEvents.bind("start",s(a._start,a)).bind("move",s(a._move,a)).bind("end",s(a._end,a)).bind("select",s(a._select,a))},events:[h],options:{name:"Selectable",filter:">*",inputSelectors:m,multiple:!1,relatedTarget:e.noop},_isElement:function(e){var t,n=this.element,i=n.length,o=!1;for(e=e[0],t=0;t<i;t++)if(n[t]===e){o=!0;break}return o},_tap:function(t){var n,i=e(t.target),o=this,r=t.event.ctrlKey||t.event.metaKey,s=o.options.multiple,a=s&&t.event.shiftKey,l=t.event.which,d=t.event.button;!o._isElement(i.closest("."+u))||l&&3==l||d&&2==d||this._allowSelection(t.event.target)&&(n=i.hasClass(c),s&&r||o.clear(),i=i.add(o.relatedTarget(i)),a?o.selectRange(o._firstSelectee(),i,t):(n&&r?(o._unselect(i),o._notify(h,t)):o.value(i,t),o._lastActive=o._downTarget=i))},_start:function(n){var i,o=this,r=e(n.target),s=r.hasClass(c),a=n.event.ctrlKey||n.event.metaKey;if(this._allowSelection(n.event.target)){if(o._downTarget=r,!o._isElement(r.closest("."+u)))return o.userEvents.cancel(),t;o.options.useAllItems?o._items=o.element.find(o.options.filter):(i=r.closest(o.element),o._items=i.find(o.options.filter)),n.sender.capture(),o._marquee.appendTo(document.body).css({left:n.x.client+1,top:n.y.client+1,width:0,height:0}),a||o.clear(),r=r.add(o.relatedTarget(r)),s&&(o._selectElement(r,!0),a&&r.addClass(p))}},_move:function(e){var t=this,n={left:e.x.startLocation>e.x.location?e.x.location:e.x.startLocation,top:e.y.startLocation>e.y.location?e.y.location:e.y.startLocation,width:a(e.x.initialDelta),height:a(e.y.initialDelta)};t._marquee.css(n),t._invalidateSelectables(n,e.event.ctrlKey||e.event.metaKey),e.preventDefault()},_end:function(e){var t,n=this;n._marquee.remove(),n._unselect(n.element.find(n.options.filter+"."+p)).removeClass(p),t=n.element.find(n.options.filter+"."+d),t=t.add(n.relatedTarget(t)),n.value(t,e),n._lastActive=n._downTarget,n._items=null},_invalidateSelectables:function(e,t){var i,o,r,s,a=this._downTarget[0],l=this._items;for(i=0,o=l.length;i<o;i++)s=l.eq(i),r=s.add(this.relatedTarget(s)),n(s,e)?s.hasClass(c)?t&&a!==s[0]&&r.removeClass(c).addClass(p):s.hasClass(d)||s.hasClass(p)||r.addClass(d):s.hasClass(d)?r.removeClass(d):t&&s.hasClass(p)&&r.removeClass(p).addClass(c)},value:function(e,n){var i=this,o=s(i._selectElement,i);return e?(e.each(function(){o(this)}),i._notify(h,n),t):i.element.find(i.options.filter+"."+c)},_firstSelectee:function(){var e,t=this;return null!==t._lastActive?t._lastActive:(e=t.value(),e.length>0?e[0]:t.element.find(t.options.filter)[0])},_selectElement:function(t,n){var i=e(t),o=!n&&this._notify("select",{element:t});i.removeClass(d),o||(i.addClass(c),this.options.aria&&i.attr(l,!0))},_notify:function(e,t){return t=t||{},this.trigger(e,t)},_unselect:function(e){return e.removeClass(c),this.options.aria&&e.attr(l,!1),e},_select:function(t){this._allowSelection(t.event.target)&&(!g||g&&!e(o._activeElement()).is(this.options.inputSelectors))&&t.preventDefault()},_allowSelection:function(t){return!e(t).is(this.options.inputSelectors)||(this.userEvents.cancel(),this._downTarget=null,!1)},resetTouchEvents:function(){this.userEvents.cancel()},clear:function(){var e=this.element.find(this.options.filter+"."+c);this._unselect(e)},selectRange:function(t,n,i){var o,r,s,a=this;for(a.clear(),a.element.length>1&&(s=a.options.continuousItems()),s&&s.length||(s=a.element.find(a.options.filter)),t=e.inArray(e(t)[0],s),n=e.inArray(e(n)[0],s),t>n&&(r=t,t=n,n=r),a.options.useAllItems||(n+=a.element.length-1),o=t;o<=n;o++)a._selectElement(s[o]);a._notify(h,i)},destroy:function(){var e=this;r.fn.destroy.call(e),e.element.off(f),e.userEvents.destroy(),e._marquee=e._lastActive=e.element=e.userEvents=null}}),i.parseOptions=function(e){var t="string"==typeof e&&e.toLowerCase();return{multiple:t&&t.indexOf("multiple")>-1,cell:t&&t.indexOf("cell")>-1}},o.ui.plugin(i)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.button.min",["kendo.core.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.ui.Widget,o=e.proxy,r=n.keys,s="click",a="k-button",l="k-button-icon",c="k-button-icontext",d=".kendoButton",u="disabled",h="k-state-disabled",f="k-state-focused",p="k-state-active",m=i.extend({init:function(e,t){var r=this;i.fn.init.call(r,e,t),e=r.wrapper=r.element,t=r.options,e.addClass(a).attr("role","button"),t.enable=t.enable&&!e.attr(u),r.enable(t.enable),t.enable&&r._tabindex(),r._graphics(),e.on(s+d,o(r._click,r)).on("focus"+d,o(r._focus,r)).on("blur"+d,o(r._blur,r)).on("keydown"+d,o(r._keydown,r)).on("keyup"+d,o(r._keyup,r)),n.notify(r)},destroy:function(){var e=this;e.wrapper.off(d),i.fn.destroy.call(e)},events:[s],options:{name:"Button",icon:"",spriteCssClass:"",imageUrl:"",enable:!0},_isNativeButton:function(){return"button"==this.element.prop("tagName").toLowerCase()},_click:function(e){this.options.enable&&this.trigger(s,{event:e})&&e.preventDefault()},_focus:function(){this.options.enable&&this.element.addClass(f)},_blur:function(){var e=this;e.element.removeClass(f),setTimeout(function(){e.element.removeClass(p)})},_keydown:function(e){var t=this;e.keyCode!=r.ENTER&&e.keyCode!=r.SPACEBAR||(t.options.enable&&t.element.addClass(p),t._isNativeButton()||(e.keyCode==r.SPACEBAR&&e.preventDefault(),t._click(e)))},_keyup:function(){this.element.removeClass(p)},_graphics:function(){var t,n,i,o=this,r=o.element,s=o.options,a=s.icon,d=s.spriteCssClass,u=s.imageUrl;(d||u||a)&&(i=!0,r.contents().filter(function(){return!e(this).hasClass("k-sprite")&&!e(this).hasClass("k-icon")&&!e(this).hasClass("k-image")}).each(function(t,n){(1==n.nodeType||3==n.nodeType&&e.trim(n.nodeValue).length>0)&&(i=!1);
}),r.addClass(i?l:c)),a?(t=r.children("span.k-icon").first(),t[0]||(t=e('<span class="k-icon"></span>').prependTo(r)),t.addClass("k-i-"+a)):d?(t=r.children("span.k-sprite").first(),t[0]||(t=e('<span class="k-sprite"></span>').prependTo(r)),t.addClass(d)):u&&(n=r.children("img.k-image").first(),n[0]||(n=e('<img alt="icon" class="k-image" />').prependTo(r)),n.attr("src",u))},enable:function(e){var n=this,i=n.element;e===t&&(e=!0),e=!!e,n.options.enable=e,i.toggleClass(h,!e).attr("aria-disabled",!e).attr(u,!e),e&&n._tabindex();try{i.blur()}catch(o){}}});n.ui.plugin(m)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.buttongroup.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(n,o){n!==t&&e('<span class="k-badge">'+i.htmlEncode(n)+"</span>").appendTo(o)}var i=window.kendo,o=i.ui,r=o.Widget,s=i.keys,a=e.proxy,l=".kendoButtonGroup",c="k-widget",d="k-button-group",u="k-button",h="k-button-icontext",f="k-button-icon",p="k-state-active",m="k-state-focused",g="k-state-disabled",v="select",_="click",b="keydown",w="focus",y="blur",k="mousedown",x='# var item = data; ## var text = item.text; ## var selected = item.selected; ## var enabled = item.enabled; ## var icon = item.icon; ## var badge = item.badge; ## var image = item.imageUrl; #<span class="#= selected ? " '+p+'" : "" #" #= enabled === false ? "disabled" : "" # # if (icon && !image) { #'+i.attr("icon")+'="#=icon#"# } ## if (badge) { #'+i.attr("badge")+'="#=badge#"# } #># if (image) { #<img alt="icon" src="#=image#" /># } ## if (text) { ##= text ## } #</span>',C=r.extend({init:function(t,n){var i,o,s,h=this;if(r.fn.init.call(h,t,n),h.wrapper=h.element,h.options.items)for(i=0;i<h.options.items.length;i++)o=h.options.items[i],s=e(h._renderItem(h.options.items[i])),o.attributes&&s.attr(o.attributes),s.appendTo(h.element);h.selectedIndices=[],h.element.addClass(c+" "+d).attr("role","group").attr("tabindex",h.element.attr("tabindex")||"0").children().each(function(){var t=e(this);h._button.bind(h)(t)}),h._enable=!0,h.options.enable||(h._enable=!1,h.element.attr("aria-disabled",!0).addClass(g)),h.select(h.options.index),h.element.on(_+l,"."+u,a(h._click,h)).on(w+l,a(h._focus,h)).on(b+l,a(h._keyDown,h)).on(y+l,function(){h.preventFocus=!1,h.element.find("."+u).removeClass(m)}).on(k+l,function(){h.preventFocus=!0})},events:[v],options:{name:"ButtonGroup",selection:"single",index:-1,enable:!0},current:function(){return this.element.find("."+p)},_renderItem:function(e){return i.template(x,{useWithBlock:!1})(e)},_focus:function(){var t=e(this.element);this.preventFocus||(t.find("."+p).length?t.find("."+p).first().focus().addClass(m):t.children().first().focus().addClass(m))},_keyDown:function(t){var n,o=this,r=e(o.element),a=r.find("."+u),l=r.find("."+m),c=a.index(l),d=i.support.isRtl(o.element);t.keyCode===s.LEFT&&!d||t.keyCode===s.RIGHT&&d?(l.removeClass(m),n=0===c?a.eq(a.length-1):e(a[c-1]),n.focus().addClass(m),t.preventDefault()):t.keyCode===s.LEFT&&d||t.keyCode===s.RIGHT&&!d?(l.removeClass(m),n=c+1===a.length?a.eq(0):e(a[c+1]),n.focus().addClass(m),t.preventDefault()):t.keyCode!==s.ENTER&&t.keyCode!==s.SPACEBAR||(o._select(l),t.preventDefault())},select:function(n){var i,o=this,r=-1;n!==t&&n!==-1&&(o.element.find("."+u).removeClass(m),"number"==typeof n?(r=n,n=o.element.children().eq(n)):n.nodeType&&(n=e(n),r=n.index()),"multiple"===o.options.selection?(i="true"===n.attr("aria-pressed"),n.attr("aria-pressed",!i).toggleClass(p),o.selectedIndices.indexOf(r)===-1?o.selectedIndices.push(r):o.selectedIndices.splice(o.selectedIndices.indexOf(r),1)):(o.selectedIndices=[],o.current().attr("aria-pressed",!1).removeClass(p),n.attr("aria-pressed",!0).addClass(p),o.selectedIndices.push(r)),o.trigger(v,{indices:o.selectedIndices}))},badge:function(e,o){var r,s=this.element,a=isNaN(e)?s.find(e):s.children().eq(e),l=o||0===o;if(a.length){if(r=a.children(".k-badge").eq(0),!r.length&&l)return n(i.htmlEncode(o),a),i.htmlEncode(o);if(l)r.html(i.htmlEncode(o));else if(o===!1)return r.empty().remove(),t;return r.html()}},enable:function(e){t===e&&(e=!0),this.element.attr("aria-disabled",!e).toggleClass(g,!e),this._enable=this.options.enable=e},destroy:function(){var e=this;e.element.off(l),r.fn.destroy.call(e)},_button:function(t){var o=i.attrValue(t,"icon"),r=i.attrValue(t,"badge"),s=t.find("img").addClass("k-image"),a=!0;t.attr("aria-pressed",!1).attr("role","button").addClass(u),(t.is("[disabled]")||t.hasClass(g))&&t.addClass(g).attr("aria-disabled",!0).removeAttr("disabled"),t.is("."+p)&&(t.removeClass(p),(!t.hasClass(g)&&"single"===this.options.selection||"multiple"===this.options.selection)&&this.select(t[0])),!s[0]&&o&&t.prepend(e('<span class="k-icon k-i-'+o+'" />')),t.contents().filter(function(){return!e(this).hasClass("k-icon")&&!e(this).hasClass("k-image")}).each(function(){(1==this.nodeType||3==this.nodeType&&e.trim(this.nodeValue).length>0)&&(a=!1)}),(s[0]||o)&&t.addClass(a?f:h),(r||0===r)&&n(r,t)},_click:function(t){var n=e(t.target).closest("."+u);t.isDefaultPrevented()||this._select(n)},_select:function(e){var n=e;return this.element.find("."+u).removeClass(m),!this._enable||n.is("."+g)?(n.addClass(m),t):(this.select(e[0]),n.addClass(m),t)}});o.plugin(C)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.pager.min",["kendo.data.min"],e)}(function(){return function(e,t){function n(e,t,n,i,o){return e({idx:t,text:n,ns:c.ns,numeric:i,title:o||""})}function i(e,t,n){return S({className:e.substring(1),text:t,wrapClassName:n||""})}function o(e,t,n,i){e.find(t).parent().attr(c.attr("page"),n).attr("tabindex",-1).toggleClass("k-state-disabled",i)}function r(e,t){o(e,f,1,t<=1)}function s(e,t){o(e,m,Math.max(1,t-1),t<=1)}function a(e,t,n){o(e,g,Math.min(n,t+1),t>=n)}function l(e,t,n){o(e,p,n,t>=n)}var c=window.kendo,d=c.ui,u=d.Widget,h=e.proxy,f=".k-i-arrow-end-left",p=".k-i-arrow-end-right",m=".k-i-arrow-60-left",g=".k-i-arrow-60-right",v="change",_=".kendoPager",b="click",w="keydown",y="disabled",k="down",x=e(document.documentElement),C=Number.MAX_VALUE,S=c.template('<a href="\\#" aria-label="#=text#" title="#=text#" class="k-link k-pager-nav #= wrapClassName #"><span class="k-icon #= className #"></span></a>'),T=u.extend({init:function(t,n){var o,d,y,x,C=this;u.fn.init.call(C,t,n),n=C.options,C.dataSource=c.data.DataSource.create(n.dataSource),C.linkTemplate=c.template(C.options.linkTemplate),C.selectTemplate=c.template(C.options.selectTemplate),C.currentPageTemplate=c.template(C.options.currentPageTemplate),o=C.page(),d=C.totalPages(),C._refreshHandler=h(C.refresh,C),C.dataSource.bind(v,C._refreshHandler),C.downEvent=c.applyEventMap(k,c.guid()),n.previousNext&&(C.element.find(f).length||(C.element.append(i(f,n.messages.first,"k-pager-first")),r(C.element,o,d)),C.element.find(m).length||(C.element.append(i(m,n.messages.previous)),s(C.element,o,d))),n.numeric&&(C.list=C.element.find(".k-pager-numbers"),C.list.length||(C.list=e('<ul class="k-pager-numbers k-reset" />').appendTo(C.element))),n.input&&(C.element.find(".k-pager-input").length||C.element.append('<span class="k-pager-input k-label">'+n.messages.page+'<input class="k-textbox">'+c.format(n.messages.of,d)+"</span>"),C.element.on(w+_,".k-pager-input input",h(C._keydown,C))),n.previousNext&&(C.element.find(g).length||(C.element.append(i(g,n.messages.next)),a(C.element,o,d)),C.element.find(p).length||(C.element.append(i(p,n.messages.last,"k-pager-last")),l(C.element,o,d))),n.pageSizes&&(C.element.find(".k-pager-sizes").length||(y=n.pageSizes.length?n.pageSizes:["all",5,10,20],x=e.map(y,function(e){return e.toLowerCase&&"all"===e.toLowerCase()?"<option value='all'>"+n.messages.allPages+"</option>":"<option>"+e+"</option>"}),e('<span class="k-pager-sizes k-label"><select/>'+n.messages.itemsPerPage+"</span>").appendTo(C.element).find("select").html(x.join("")).end().appendTo(C.element)),C.element.find(".k-pager-sizes select").val(C.pageSize()),c.ui.DropDownList&&C.element.find(".k-pager-sizes select").show().kendoDropDownList(),C.element.on(v+_,".k-pager-sizes select",h(C._change,C))),n.refresh&&(C.element.find(".k-pager-refresh").length||C.element.append('<a href="#" class="k-pager-refresh k-link" title="'+n.messages.refresh+'" aria-label="'+n.messages.refresh+'"><span class="k-icon k-i-reload"></span></a>'),C.element.on(b+_,".k-pager-refresh",h(C._refreshClick,C))),n.info&&(C.element.find(".k-pager-info").length||C.element.append('<span class="k-pager-info k-label" />')),C.element.on(b+_,"a",h(C._click,C)).addClass("k-pager-wrap k-widget k-floatwrap"),C.element.on(b+_,".k-current-page",h(C._toggleActive,C)),n.autoBind&&C.refresh(),c.notify(C)},destroy:function(){var e=this;u.fn.destroy.call(e),e.element.off(_),e.dataSource.unbind(v,e._refreshHandler),e._refreshHandler=null,c.destroy(e.element),e.element=e.list=null},events:[v],options:{name:"Pager",selectTemplate:'<li><span class="k-state-selected">#=text#</span></li>',currentPageTemplate:'<li class="k-current-page"><span class="k-link k-pager-nav">#=text#</span></li>',linkTemplate:'<li><a tabindex="-1" href="\\#" class="k-link" data-#=ns#page="#=idx#" #if (title !== "") {# title="#=title#" #}#>#=text#</a></li>',buttonCount:10,autoBind:!0,numeric:!0,info:!0,input:!1,previousNext:!0,pageSizes:!1,refresh:!1,messages:{allPages:"All",display:"{0} - {1} of {2} items",empty:"No items to display",page:"Page",of:"of {0}",itemsPerPage:"items per page",first:"Go to the first page",previous:"Go to the previous page",next:"Go to the next page",last:"Go to the last page",refresh:"Refresh",morePages:"More pages"}},setDataSource:function(e){var t=this;t.dataSource.unbind(v,t._refreshHandler),t.dataSource=t.options.dataSource=e,e.bind(v,t._refreshHandler),t.options.autoBind&&e.fetch()},refresh:function(t){var i,o,d,u,h,f,p=this,m=1,g=p.page(),v="",_=p.options,b=p.pageSize(),w=p.dataSource.total(),k=p.totalPages(),S=p.linkTemplate,T=_.buttonCount;if(x.unbind(p.downEvent,e.proxy(p._hideList,p)),!t||"itemchange"!=t.action){if(_.numeric){for(g>T&&(d=g%T,m=0===d?g-T+1:g-d+1),o=Math.min(m+T-1,k),m>1&&(v+=n(S,m-1,"...",!1,_.messages.morePages)),i=m;i<=o;i++)v+=n(i==g?p.selectTemplate:S,i,i,!0);o<k&&(v+=n(S,i,"...",!1,_.messages.morePages)),""===v&&(v=p.selectTemplate({text:0})),v=this.currentPageTemplate({text:g})+v,p.list.removeClass("k-state-expanded").html(v)}_.info&&(v=w>0?c.format(_.messages.display,p.dataSource.options.endless?1:Math.min((g-1)*b+1,w),Math.min(g*b,w),w):_.messages.empty,p.element.find(".k-pager-info").html(v)),_.input&&p.element.find(".k-pager-input").html(p.options.messages.page+'<input class="k-textbox" aria-label="'+g+'">'+c.format(_.messages.of,k)).find("input").val(g).attr(y,w<1).toggleClass("k-state-disabled",w<1),_.previousNext&&(r(p.element,g,k),s(p.element,g,k),a(p.element,g,k),l(p.element,g,k)),_.pageSizes&&(u=p.element.find(".k-pager-sizes option[value='all']").length>0,h=u&&(b===this.dataSource.total()||b==C),f=b,h&&(b="all",f=_.messages.allPages),p.element.find(".k-pager-sizes select").val(b).attr("aria-label",b).filter("["+c.attr("role")+"=dropdownlist]").kendoDropDownList("value",b).kendoDropDownList("text",f))}},_keydown:function(e){if(e.keyCode===c.keys.ENTER){var t=this.element.find(".k-pager-input").find("input"),n=parseInt(t.val(),10);(isNaN(n)||n<1||n>this.totalPages())&&(n=this.page()),t.val(n),this.page(n)}},_refreshClick:function(e){e.preventDefault(),this.dataSource.read()},_change:function(e){var n=e.currentTarget.value,i=parseInt(n,10),o=this.dataSource;isNaN(i)?"all"==(n+"").toLowerCase()&&(o._pageSize=t,o._take=t,o.fetch()):o.pageSize(i)},_toggleActive:function(){var t=this;t.list.hasClass("k-state-expanded")?x.unbind(t.downEvent,e.proxy(t._hideList,t)):x.bind(t.downEvent,e.proxy(t._hideList,t)),t.list.toggleClass("k-state-expanded")},_hideList:function(t){var n=this,i=c.eventTarget(t);e.contains(n.list[0],i)||(x.unbind(n.downEvent,e.proxy(n._hideList,n)),n.list.removeClass("k-state-expanded"))},_click:function(t){var n=e(t.currentTarget);t.preventDefault(),n.is(".k-state-disabled")||this.page(n.attr(c.attr("page")))},totalPages:function(){return Math.ceil((this.dataSource.total()||0)/(this.pageSize()||1))},pageSize:function(){return this.dataSource.pageSize()||this.dataSource.total()},page:function(e){return e===t?this.dataSource.total()>0?this.dataSource.page():0:(this.trigger("pageChange",{index:e})||(this.dataSource.page(e),this.trigger(v,{index:e})),t)}});d.plugin(T)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.notification.min",["kendo.core.min","kendo.popup.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.ui.Widget,o=e.proxy,r=e.extend,s=window.setTimeout,a="click",l="show",c="hide",d="k-notification",u=".k-notification-wrap .k-i-close",h="k-hiding",f="info",p="success",m="warning",g="error",v="top",_="left",b="bottom",w="right",y="up",k=".kendoNotification",x='<div class="k-widget k-popup k-notification"></div>',C='<div class="k-notification-wrap"><span class="k-icon k-i-#=typeIcon#" title="#=typeIcon#"></span>#=content#<span class="k-icon k-i-close" title="Hide"></span></div>',S=C.replace("#=content#","#:content#"),T=i.extend({init:function(t,o){var r=this;i.fn.init.call(r,t,o),o=r.options,o.appendTo&&e(o.appendTo).is(t)||r.element.hide(),r._compileTemplates(o.templates),r._guid="_"+n.guid(),r._isRtl=n.support.isRtl(t),r._compileStacking(o.stacking,o.position.top,o.position.left),n.notify(r)},events:[l,c],options:{name:"Notification",position:{pinned:!0,top:null,left:null,bottom:20,right:20},stacking:"default",hideOnClick:!0,button:!1,allowHideAfter:0,autoHideAfter:5e3,appendTo:null,width:null,height:null,templates:[],animation:{open:{effects:"fade:in",duration:300},close:{effects:"fade:out",duration:600,hide:!0}}},_compileTemplates:function(t){var i=this,o=n.template;i._compiled={},e.each(t,function(t,n){i._compiled[n.type]=o(n.template||e("#"+n.templateId).html())}),i._defaultCompiled=o(C),i._safeCompiled=o(S)},_getCompiled:function(e,t){var n=t?this._safeCompiled:this._defaultCompiled;return e?this._compiled[e]||n:n},_compileStacking:function(e,t,n){var i,o,r=this,s={paddingTop:0,paddingRight:0,paddingBottom:0,paddingLeft:0},a=null!==n?_:w;switch(e){case"down":i=b+" "+a,o=v+" "+a,delete s.paddingBottom;break;case w:i=v+" "+w,o=v+" "+_,delete s.paddingRight;break;case _:i=v+" "+_,o=v+" "+w,delete s.paddingLeft;break;case y:i=v+" "+a,o=b+" "+a,delete s.paddingTop;break;default:null!==t?(i=b+" "+a,o=v+" "+a,delete s.paddingBottom):(i=v+" "+a,o=b+" "+a,delete s.paddingTop)}r._popupOrigin=i,r._popupPosition=o,r._popupPaddings=s},_attachPopupEvents:function(e,t){function n(e){e.on(a+k,function(){o._hidePopup(t)})}var i,o=this,r=e.allowHideAfter,l=!isNaN(r)&&r>0;e.hideOnClick?t.bind("activate",function(){l?s(function(){n(t.element)},r):n(t.element)}):e.button&&(i=t.element.find(u),l?s(function(){n(i)},r):n(i))},_showPopup:function(t,i){var o,a,l=this,c=i.autoHideAfter,d=i.position.left,f=i.position.top;a=e("."+l._guid+":not(."+h+")").last(),o=new n.ui.Popup(t,{anchor:a[0]?a:document.body,origin:l._popupOrigin,position:l._popupPosition,animation:i.animation,modal:!0,collision:"",isRtl:l._isRtl,close:function(){l._triggerHide(this.element)},deactivate:function(e){e.sender.element.off(k),e.sender.element.find(u).off(k),e.sender.destroy()}}),l._attachPopupEvents(i,o),t.removeClass("k-group k-reset"),a[0]?o.open():(null===d&&(d=e(window).width()-t.width()-i.position.right),null===f&&(f=e(window).height()-t.height()-i.position.bottom),o.open(d,f)),o.wrapper.addClass(l._guid).css(r({margin:0,zIndex:10050},l._popupPaddings)),i.position.pinned?(o.wrapper.css("position","fixed"),a[0]&&l._togglePin(o.wrapper,!0)):a[0]||l._togglePin(o.wrapper,!1),c>0&&s(function(){l._hidePopup(o)},c)},_hidePopup:function(e){e.wrapper.addClass(h),e.close()},_togglePin:function(t,n){var i=e(window),o=n?-1:1;t.css({top:parseInt(t.css(v),10)+o*i.scrollTop(),left:parseInt(t.css(_),10)+o*i.scrollLeft()})},_attachStaticEvents:function(e,t){function n(e){e.on(a+k,o(i._hideStatic,i,t))}var i=this,r=e.allowHideAfter,l=!isNaN(r)&&r>0;e.hideOnClick?l?s(function(){n(t)},r):n(t):e.button&&(l?s(function(){n(t.find(u))},r):n(t.find(u)))},_showStatic:function(e,t){var n=this,i=t.autoHideAfter,o=t.animation,r=t.stacking==y||t.stacking==_?"prependTo":"appendTo";e.removeClass("k-popup").addClass(n._guid)[r](t.appendTo).hide().kendoAnimate(o.open||!1),n._attachStaticEvents(t,e),i>0&&s(function(){n._hideStatic(e)},i)},_hideStatic:function(e){e.kendoAnimate(r(this.options.animation.close||!1,{complete:function(){e.off(k).find(u).off(k),e.remove()}})),this._triggerHide(e)},_triggerHide:function(e){this.trigger(c,{element:e}),this.angular("cleanup",function(){return{elements:e}})},show:function(i,o,s){var a,c,u=this,h=u.options,p=e(x);return o||(o=f),null!==i&&i!==t&&""!==i&&(n.isFunction(i)&&(i=i()),c={typeIcon:o,content:""},a=e.isPlainObject(i)?r(c,i):r(c,{content:i}),p.addClass(d+"-"+o).toggleClass(d+"-button",h.button).attr("data-role","alert").css({width:h.width,height:h.height}).append(u._getCompiled(o,s)(a)),u.angular("compile",function(){return{elements:p,data:[{dataItem:a}]}}),e(h.appendTo)[0]?u._showStatic(p,h):u._showPopup(p,h),u.trigger(l,{element:p})),u},showText:function(e,t){this.show(e,t,!0)},info:function(e){return this.show(e,f)},success:function(e){return this.show(e,p)},warning:function(e){return this.show(e,m)},error:function(e){return this.show(e,g)},hide:function(){var t=this,n=t.getNotifications();return n.each(t.options.appendTo?function(n,i){t._hideStatic(e(i))}:function(n,i){var o=e(i).data("kendoPopup");o&&t._hidePopup(o)}),t},getNotifications:function(){var t=this,n=e("."+t._guid+":not(."+h+")");return t.options.appendTo?n:n.children("."+d)},setOptions:function(e){var n,o=this;i.fn.setOptions.call(o,e),n=o.options,e.templates!==t&&o._compileTemplates(n.templates),e.stacking===t&&e.position===t||o._compileStacking(n.stacking,n.position.top,n.position.left)},destroy:function(){i.fn.destroy.call(this),this.getNotifications().off(k).find(u).off(k)}});n.ui.plugin(T)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.tooltip.min",["kendo.core.min","kendo.popup.min"],e)}(function(){return function(e,t){function n(e){for(;e.length&&!i(e);)e=e.parent()}function i(e){var t=e.data(s.ns+"title");if(t)return e.attr("title",t),e.removeData(s.ns+"title"),!0}function o(e){var t=e.attr("title");if(t)return e.data(s.ns+"title",t),e.attr("title",""),!0}function r(e){for(;e.length&&!e.is("body")&&!o(e);)e=e.parent()}var s=window.kendo,a=s.ui.Widget,l=s.ui.Popup,c=s.isFunction,d=e.isPlainObject,u=e.extend,h=e.proxy,f=e(document),p=s.isLocalUrl,m="_tt_active",g="aria-describedby",v="show",_="hide",b="error",w="contentLoad",y="requestStart",k="k-content-frame",x='<div role="tooltip" class="k-widget k-tooltip#if (!autoHide) {# k-tooltip-closable#}#">#if (!autoHide) {# <div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close" title="Close"></a></div> #}#<div class="k-tooltip-content"></div>#if (callout){ #<div class="k-callout k-callout-#=dir#"></div>#}#</div>',C=s.template("<iframe frameborder='0' class='"+k+"' src='#= content.url #'>This page requires frames in order to show content</iframe>"),S=".kendoTooltip",T={bottom:{origin:"bottom center",position:"top center"},top:{origin:"top center",position:"bottom center"},left:{origin:"center left",position:"center right",collision:"fit flip"},right:{origin:"center right",position:"center left",collision:"fit flip"},center:{position:"center center",origin:"center center"}},D={top:"bottom",bottom:"top",left:"right",right:"left",center:"center"},A={bottom:"n",top:"s",left:"e",right:"w",center:"n"},E={horizontal:{offset:"top",size:"outerHeight"},vertical:{offset:"left",size:"outerWidth"}},I=function(e){return e.target.data(s.ns+"title")},M=a.extend({init:function(e,t){var n,i=this;a.fn.init.call(i,e,t),n=i.options.position.match(/left|right/)?"horizontal":"vertical",i.dimensions=E[n],i._documentKeyDownHandler=h(i._documentKeyDown,i),i.element.on(i.options.showOn+S,i.options.filter,h(i._showOn,i)),this._isShownOnFocus()||i.element.on("mouseenter"+S,i.options.filter,h(i._mouseenter,i)),this.options.autoHide&&!this._isShownOnFocus()&&i.element.on("mouseleave"+S,i.options.filter,h(i._mouseleave,i)),this.options.autoHide&&this._isShownOnFocus()&&i.element.on("blur"+S,i.options.filter,h(i._blur,i))},options:{name:"Tooltip",filter:"",content:I,showAfter:100,callout:!0,position:"bottom",showOn:"mouseenter",autoHide:!0,width:null,height:null,animation:{open:{effects:"fade:in",duration:0},close:{duration:40,hide:!0}}},events:[v,_,w,b,y],_isShownOnFocus:function(){return this.options.showOn&&this.options.showOn.match(/focus/)},_mouseenter:function(t){r(e(t.currentTarget))},_showOn:function(t){var n=this,i=e(t.currentTarget);n.options.showOn&&n.options.showOn.match(/click/)?n._show(i):n._isShownOnFocus()?(r(i),n._show(i)):(clearTimeout(n.timeout),n.timeout=setTimeout(function(){n._show(i)},n.options.showAfter))},_appendContent:function(e){var t,n=this,i=n.options.content,o=n.content,r=n.options.iframe;d(i)&&i.url?("iframe"in n.options||(r=!p(i.url)),n.trigger(y,{options:i,target:e}),r?(o.hide(),t=o.find("."+k)[0],t?t.src=i.url||t.src:o.html(C({content:i})),o.find("."+k).off("load"+S).on("load"+S,function(){n.trigger(w),o.show()})):(o.empty(),s.ui.progress(o,!0),n._ajaxRequest(i))):i&&c(i)?(i=i({sender:this,target:e}),o.html(i||"")):o.html(i),n.angular("compile",function(){return{elements:o}})},_ajaxRequest:function(e){var t=this;jQuery.ajax(u({type:"GET",dataType:"html",cache:!1,error:function(e,n){s.ui.progress(t.content,!1),t.trigger(b,{status:n,xhr:e})},success:h(function(e){s.ui.progress(t.content,!1),t.content.html(e),t.trigger(w)},t)},e))},_documentKeyDown:function(e){e.keyCode===s.keys.ESC&&this.hide()},refresh:function(){var e=this,t=e.popup;t&&t.options.anchor&&e._appendContent(t.options.anchor)},hide:function(){this.popup&&this.popup.close()},show:function(e){e=e||this.element,r(e),this._show(e)},_show:function(e){var t=this,i=t.target();t.popup||t._initPopup(),i&&i[0]!=e[0]&&(t.popup.close(),t.popup.element.kendoStop(!0,!0)),i&&i[0]==e[0]||(t._appendContent(e),t.popup.options.anchor=e),t.popup.one("deactivate",function(){n(e),e.removeAttr(g),this.element.removeAttr("id").attr("aria-hidden",!0),f.off("keydown"+S,t._documentKeyDownHandler)}),t.popup.open()},_initPopup:function(){var t=this,n=t.options,i=e(s.template(x)({callout:n.callout&&"center"!==n.position,dir:A[n.position],autoHide:n.autoHide}));t.popup=new l(i,u({activate:function(){var e=this.options.anchor,i=e[0].id||t.element[0].id;i&&(e.attr(g,i+m),this.element.attr("id",i+m)),n.callout&&t._positionCallout(),this.element.removeAttr("aria-hidden"),f.on("keydown"+S,t._documentKeyDownHandler),t.trigger(v)},close:function(){t.trigger(_)},copyAnchorStyles:!1,animation:n.animation},T[n.position])),i.css({width:n.width,height:n.height}),t.content=i.find(".k-tooltip-content"),t.arrow=i.find(".k-callout"),n.autoHide&&!this._isShownOnFocus()?i.on("mouseleave"+S,h(t._mouseleave,t)):i.on("click"+S,".k-tooltip-button",h(t._closeButtonClick,t))},_closeButtonClick:function(e){e.preventDefault(),this.hide()},_mouseleave:function(e){this._closePopup(e.currentTarget),clearTimeout(this.timeout)},_blur:function(e){this._closePopup(e.currentTarget)},_closePopup:function(t){this.popup?this.popup.close():n(e(t))},_positionCallout:function(){var t=this,n=t.options.position,i=t.dimensions,o=i.offset,r=t.popup,s=r.options.anchor,a=e(s).offset(),l=parseInt(t.arrow.css("border-top-width"),10),c=e(r.element).offset(),d=A[r.flipped?D[n]:n],u=a[o]-c[o]+e(s)[i.size]()/2-l;t.arrow.removeClass("k-callout-n k-callout-s k-callout-w k-callout-e").addClass("k-callout-"+d).css(o,u)},target:function(){return this.popup?this.popup.options.anchor:null},destroy:function(){var e=this.popup;e&&(e.element.off(S),e.destroy()),clearTimeout(this.timeout),this.element.off(S),f.off("keydown"+S,this._documentKeyDownHandler),a.fn.destroy.call(this)}});s.ui.plugin(M)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.list.min",["kendo.data.min","kendo.popup.min"],e)}(function(){return function(e,t){function n(e,n){return e!==t&&""!==e&&null!==e&&("boolean"===n?e=!!e:"number"===n?e=+e:"string"===n&&(e=""+e)),e}function i(e){return e[e.length-1]}function o(e){var t=e.selectedIndex;return t>-1?e.options[t]:{}}function r(e,t){var n,i,o,r,s=t.length,a=e.length,l=[],c=[];if(a)for(o=0;o<a;o++){for(n=e[o],i=!1,r=0;r<s;r++)if(n===t[r]){i=!0,l.push({index:o,item:n});break}i||c.push(n)}return{changed:l,unchanged:c}}function s(t){return!(!t||e.isEmptyObject(t))&&!(t.filters&&!t.filters.length)}function a(t,n){var i,o=!1;return t.filters&&(i=e.grep(t.filters,function(e){return o=a(e,n),e.filters?e.filters.length:e.field!=n}),o||t.filters.length===i.length||(o=!0),t.filters=i),o}var l,c,d=window.kendo,u=d.ui,h=d._outerWidth,f=d._outerHeight,p=u.Widget,m=d.keys,g=d.support,v=d.htmlEncode,_=d._activeElement,b=d.data.ObservableArray,w="id",y="change",k="k-state-focused",x="k-state-hover",C="k-i-loading",S="k-hidden",T=".k-group-header",D="_label",A="open",E="close",I="cascade",M="select",R="selected",F="requestStart",z="requestEnd",P="width",B=e.extend,L=e.proxy,H=e.isArray,N=g.browser,O=N.msie,V=O&&N.version<9,U=/"/g,W={ComboBox:"DropDownList",DropDownList:"ComboBox"},j=d.ui.DataBoundWidget.extend({init:function(t,n){var i,o=this,r=o.ns;p.fn.init.call(o,t,n),t=o.element,n=o.options,o._isSelect=t.is(M),o._isSelect&&o.element[0].length&&(n.dataSource||(n.dataTextField=n.dataTextField||"text",n.dataValueField=n.dataValueField||"value")),o.ul=e('<ul unselectable="on" class="k-list k-reset"/>').attr({tabIndex:-1,"aria-hidden":!0}),o.list=e("<div class='k-list-container'/>").append(o.ul).on("mousedown"+r,L(o._listMousedown,o)),i=t.attr(w),i&&(o.list.attr(w,i+"-list"),o.ul.attr(w,i+"_listbox")),o._header(),o._noData(),o._footer(),o._accessors(),o._initValue()},options:{valuePrimitive:!1,footerTemplate:"",headerTemplate:"",noDataTemplate:"No data found."},setOptions:function(e){p.fn.setOptions.call(this,e),e&&e.enable!==t&&(e.enabled=e.enable),this._header(),this._noData(),this._footer(),this._renderFooter(),this._renderNoData()},focus:function(){this._focused.focus()},readonly:function(e){this._editable({readonly:e===t||e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t||e)})},_listOptions:function(t){var n=this,i=n.options,o=i.virtual,r={change:L(n._listChange,n)},s=L(n._listBound,n);return o="object"==typeof o?o:{},t=e.extend({autoBind:!1,selectable:!0,dataSource:n.dataSource,click:L(n._click,n),activate:L(n._activateItem,n),deactivate:L(n._deactivateItem,n),dataBinding:function(){n.trigger("dataBinding")},dataBound:s,height:i.height,dataValueField:i.dataValueField,dataTextField:i.dataTextField,groupTemplate:i.groupTemplate,fixedGroupTemplate:i.fixedGroupTemplate,template:i.template},t,o,r),t.template||(t.template="#:"+d.expr(t.dataTextField,"data")+"#"),i.$angular&&(t.$angular=i.$angular),t},_initList:function(){var e=this,t=e._listOptions({selectedItemChange:L(e._listChange,e)});e.listView=e.options.virtual?new d.ui.VirtualList(e.ul,t):new d.ui.StaticList(e.ul,t),e.listView.bind("listBound",L(e._listBound,e)),e._setListValue()},_setListValue:function(e){e=e||this.options.value,e!==t&&this.listView.value(e).done(L(this._updateSelectionState,this))},_updateSelectionState:e.noop,_listMousedown:function(e){this.filterInput&&this.filterInput[0]===e.target||e.preventDefault()},_isFilterEnabled:function(){var e=this.options.filter;return e&&"none"!==e},_hideClear:function(){var e=this;e._clear&&this._clear.addClass(S)},_showClear:function(){var e=this;e._clear&&this._clear.removeClass(S)},_clearValue:function(){this._clearText(),this._accessor(""),this.listView.value([]),this._isFilterEnabled()&&!this.options.enforceMinLength&&this._filter({word:"",open:!1}),this._change()},_clearText:function(){this.text("")},_clearFilter:function(){this.options.virtual||this.listView.bound(!1),this._filterSource()},_filterSource:function(t,n){var i,o,r=this,l=r.options,c=r.dataSource,d=B({},c.filter()||{}),u=t||d.filters&&d.filters.length&&!t,h=a(d,l.dataTextField);if(!t&&!h||!r.trigger("filtering",{filter:t}))return i={filters:[],logic:"and"},s(t)&&e.trim(t.value).length&&i.filters.push(t),s(d)&&(i.logic===d.logic?i.filters=i.filters.concat(d.filters):i.filters.push(d)),r._cascading&&this.listView.setDSFilter(i),o=B({},{page:u?1:c.page(),pageSize:u?c.options.pageSize:c.pageSize(),sort:c.sort(),filter:c.filter(),group:c.group(),aggregate:c.aggregate()},{filter:i}),c[n?"read":"query"](c._mergeState(o))},_angularElement:function(e,t){e&&this.angular(t,function(){return{elements:e}})},_noData:function(){var n=e(this.noData),i=this.options.noDataTemplate;return this.angular("cleanup",function(){return{elements:n}}),d.destroy(n),n.remove(),i?(this.noData=e('<div class="k-nodata" style="display:none"><div></div></div>').appendTo(this.list),this.noDataTemplate="function"!=typeof i?d.template(i):i,t):(this.noData=null,t)},_renderNoData:function(){var e=this.noData;e&&(this._angularElement(e,"cleanup"),e.children(":first").html(this.noDataTemplate({instance:this})),this._angularElement(e,"compile"))},_toggleNoData:function(t){e(this.noData).toggle(t)},_toggleHeader:function(e){var t=this.listView.content.prev(T);t.toggle(e)},_footer:function(){var n=e(this.footer),i=this.options.footerTemplate;return this._angularElement(n,"cleanup"),d.destroy(n),n.remove(),i?(this.footer=e('<div class="k-footer"></div>').appendTo(this.list),this.footerTemplate="function"!=typeof i?d.template(i):i,t):(this.footer=null,t)},_renderFooter:function(){var e=this.footer;e&&(this._angularElement(e,"cleanup"),e.html(this.footerTemplate({instance:this})),this._angularElement(e,"compile"))},_header:function(){var n,i=e(this.header),o=this.options.headerTemplate;return this._angularElement(i,"cleanup"),d.destroy(i),i.remove(),o?(n="function"!=typeof o?d.template(o):o,i=e(n({})),this.header=i[0]?i:null,this.list.prepend(i),this._angularElement(this.header,"compile"),t):(this.header=null,t)},_allowOpening:function(){return this.options.noDataTemplate||this.dataSource.flatView().length},_initValue:function(){var e=this,t=e.options.value;null!==t?e.element.val(t):(t=e._accessor(),e.options.value=t),e._old=t},_ignoreCase:function(){var e,t=this,n=t.dataSource.reader.model;n&&n.fields&&(e=n.fields[t.options.dataTextField],e&&e.type&&"string"!==e.type&&(t.options.ignoreCase=!1))},_focus:function(e){return this.listView.focus(e)},_filter:function(e){var t=this,n=t.options,i=n.ignoreCase,o=n.dataTextField,r={value:i?e.word.toLowerCase():e.word,field:o,operator:n.filter,ignoreCase:i};t._open=e.open,t._filterSource(r)},_clearButton:function(){this._clear||(this._clear=e('<span unselectable="on" class="k-icon k-clear-value k-i-close" title="clear"></span>').attr({role:"button",tabIndex:-1})),this.options.clearButton||this._clear.remove()},search:function(t){var n=this.options;t="string"==typeof t?t:this._inputValue(),clearTimeout(this._typingTimeout),(!n.enforceMinLength&&!t.length||t.length>=n.minLength)&&(this._state="filter",this._isFilterEnabled()?(this.listView._emptySearch=!e.trim(t).length||!this.listView,this._filter({word:t,open:!0})):this._searchByWord(t))},current:function(e){return this._focus(e)},items:function(){return this.ul[0].children},destroy:function(){var e=this,t=e.ns;p.fn.destroy.call(e),e._unbindDataSource(),e.listView.destroy(),e.list.off(t),e.popup.destroy(),e._form&&e._form.off("reset",e._resetHandler)},dataItem:function(n){var i=this;if(n===t)return i.listView.selectedDataItems()[0];if("number"!=typeof n){
if(i.options.virtual)return i.dataSource.getByUid(e(n).data("uid"));n=e(i.items()).index(n)}return i.dataSource.flatView()[n]},_activateItem:function(){var e=this.listView.focus();e&&this._focused.add(this.filterInput).attr("aria-activedescendant",e.attr("id"))},_deactivateItem:function(){this._focused.add(this.filterInput).removeAttr("aria-activedescendant")},_accessors:function(){var e=this,t=e.element,n=e.options,i=d.getter,o=t.attr(d.attr("text-field")),r=t.attr(d.attr("value-field"));!n.dataTextField&&o&&(n.dataTextField=o),!n.dataValueField&&r&&(n.dataValueField=r),e._text=i(n.dataTextField),e._value=i(n.dataValueField)},_aria:function(e){var n=this,i=n.options,o=n._focused.add(n.filterInput);i.suggest!==t&&o.attr("aria-autocomplete",i.suggest?"both":"list"),e=e?e+" "+n.ul[0].id:n.ul[0].id,o.attr("aria-owns",e),n.ul.attr("aria-live",n._isFilterEnabled()?"polite":"off"),n._ariaLabel()},_ariaLabel:function(){var t,n=this,i=n._focused,o=n.element,r=o.attr("id"),s=e('label[for="'+r+'"]'),a=o.attr("aria-label"),l=o.attr("aria-labelledby");i!==o&&(a?i.attr("aria-label",a):l?i.attr("aria-labelledby",l):s.length&&(t=s.attr("id")||n._generateLabelId(s,r),i.attr("aria-labelledby",t)))},_generateLabelId:function(e,t){var n=t+D;return e.attr("id",n),n},_blur:function(){var e=this;e._change(),e.close()},_change:function(){var e,i=this,o=i.selectedIndex,r=i.options.value,s=i.value();i._isSelect&&!i.listView.bound()&&r&&(s=r),s!==n(i._old,typeof s)?e=!0:i._valueBeforeCascade!==t&&i._valueBeforeCascade!==n(i._old,typeof i._valueBeforeCascade)&&i._userTriggered?e=!0:o===t||o===i._oldIndex||i.listView.isFiltered()||(e=!0),e&&(i._valueBeforeCascade=i._old=null===i._old||""===s?s:i.dataItem()?i.dataItem()[i.options.dataValueField]:null,i._oldIndex=o,i._typing||i.element.trigger(y),i.trigger(y)),i.typing=!1},_data:function(){return this.dataSource.view()},_enable:function(){var e=this,n=e.options,i=e.element.is("[disabled]");n.enable!==t&&(n.enabled=n.enable),!n.enabled||i?e.enable(!1):e.readonly(e.element.is("[readonly]"))},_dataValue:function(e){var n=this._value(e);return n===t&&(n=this._text(e)),n},_offsetHeight:function(){var t=0,n=this.listView.content.prevAll(":visible");return n.each(function(){var n=e(this);t+=f(n,!0)}),t},_height:function(n){var i,o,r,s=this,a=s.list,l=s.options.height,c=s.popup.visible();if(n||s.options.noDataTemplate){if(o=a.add(a.parent(".k-animation-container")).show(),!a.is(":visible"))return o.hide(),t;l=s.listView.content[0].scrollHeight>l?l:"auto",o.height(l),"auto"!==l&&(i=s._offsetHeight(),r=f(e(s.footer))||0,l=l-i-r),s.listView.content.height(l),c||o.hide()}return l},_adjustListWidth:function(){var e,t,n=this.list,i=n[0].style.width,o=this.wrapper;if(n.data(P)||!i)return e=window.getComputedStyle?window.getComputedStyle(o[0],null):0,t=parseFloat(e&&e.width)||h(o),e&&N.msie&&(t+=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight)+parseFloat(e.borderLeftWidth)+parseFloat(e.borderRightWidth)),i="border-box"!==n.css("box-sizing")?t-(h(n)-n.width()):t,n.css({fontFamily:o.css("font-family"),width:this.options.autoWidth?"auto":i,minWidth:i,whiteSpace:this.options.autoWidth?"nowrap":"normal"}).data(P,i),!0},_openHandler:function(e){this._adjustListWidth(),this.trigger(A)?e.preventDefault():(this._focused.attr("aria-expanded",!0),this.ul.attr("aria-hidden",!1))},_closeHandler:function(e){this.trigger(E)?e.preventDefault():(this._focused.attr("aria-expanded",!1),this.ul.attr("aria-hidden",!0))},_focusItem:function(){var e=this.listView,n=!e.focus(),o=i(e.select());o===t&&this.options.highlightFirst&&n&&(o=0),o!==t?e.focus(o):n&&e.scrollToIndex(0)},_calculateGroupPadding:function(e){var t=this.ul.children(".k-first:first"),n=this.listView.content.prev(T),i=0;n[0]&&"none"!==n[0].style.display&&("auto"!==e&&(i=d.support.scrollbar()),i+=parseFloat(t.css("border-right-width"),10)+parseFloat(t.children(".k-group").css("padding-right"),10),n.css("padding-right",i))},_calculatePopupHeight:function(e){var t=this._height(this.dataSource.flatView().length||e);this._calculateGroupPadding(t)},_resizePopup:function(e){this.options.virtual||(this.popup.element.is(":visible")?this._calculatePopupHeight(e):this.popup.one("open",function(e){return L(function(){this._calculatePopupHeight(e)},this)}.call(this,e)))},_popup:function(){var e=this;e.popup=new u.Popup(e.list,B({},e.options.popup,{anchor:e.wrapper,open:L(e._openHandler,e),close:L(e._closeHandler,e),animation:e.options.animation,isRtl:g.isRtl(e.wrapper),autosize:e.options.autoWidth}))},_makeUnselectable:function(){V&&this.list.find("*").not(".k-textbox").attr("unselectable","on")},_toggleHover:function(t){e(t.currentTarget).toggleClass(x,"mouseenter"===t.type)},_toggle:function(e,n){var i=this,o=g.mobileOS&&(g.touch||g.MSPointers||g.pointers);e=e!==t?e:!i.popup.visible(),n||o||i._focused[0]===_()||(i._prevent=!0,i._focused.focus(),i._prevent=!1),i[e?A:E]()},_triggerCascade:function(){var e=this;e._cascadeTriggered&&e.value()===n(e._cascadedValue,typeof e.value())||(e._cascadedValue=e.value(),e._cascadeTriggered=!0,e.trigger(I,{userTriggered:e._userTriggered}))},_triggerChange:function(){this._valueBeforeCascade!==this.value()&&this.trigger(y)},_unbindDataSource:function(){var e=this;e.dataSource.unbind(F,e._requestStartHandler).unbind(z,e._requestEndHandler).unbind("error",e._errorHandler)},requireValueMapper:function(e,t){var n=(e.value instanceof Array?e.value.length:e.value)||(t instanceof Array?t.length:t);if(n&&e.virtual&&"function"!=typeof e.virtual.valueMapper)throw Error("ValueMapper is not provided while the value is being set. See http://docs.telerik.com/kendo-ui/controls/editors/combobox/virtualization#the-valuemapper-function")}});B(j,{inArray:function(e,t){var n,i,o=t.children;if(!e||e.parentNode!==t)return-1;for(n=0,i=o.length;n<i;n++)if(e===o[n])return n;return-1},unifyType:n}),d.ui.List=j,u.Select=j.extend({init:function(e,t){j.fn.init.call(this,e,t),this._initial=this.element.val()},setDataSource:function(e){var t,n=this;n.options.dataSource=e,n._dataSource(),n.listView.bound()&&(n._initialIndex=null,n.listView._current=null),n.listView.setDataSource(n.dataSource),n.options.autoBind&&n.dataSource.fetch(),t=n._parentWidget(),t&&n._cascadeSelect(t)},close:function(){this.popup.close()},select:function(e){var n=this;return e===t?n.selectedIndex:n._select(e).done(function(){n._cascadeValue=n._old=n._accessor(),n._oldIndex=n.selectedIndex})},_accessor:function(e,t){return this[this._isSelect?"_accessorSelect":"_accessorInput"](e,t)},_accessorInput:function(e){var n=this.element[0];return e===t?n.value:(null===e&&(e=""),n.value=e,t)},_accessorSelect:function(e,n){var i,r=this.element[0];return e===t?o(r).value||"":(o(r).selected=!1,n===t&&(n=-1),i=null!==e&&""!==e,i&&n==-1?this._custom(e):e?r.value=e:r.selectedIndex=n,t)},_syncValueAndText:function(){return!0},_custom:function(t){var n=this,i=n.element,o=n._customOption;o||(o=e("<option/>"),n._customOption=o,i.append(o)),o.text(t),o[0].selected=!0},_hideBusy:function(){var e=this;clearTimeout(e._busy),e._arrowIcon.removeClass(C),e._focused.attr("aria-busy",!1),e._busy=null,e._showClear()},_showBusy:function(e){var t=this;e.isDefaultPrevented()||(t._request=!0,t._busy||(t._busy=setTimeout(function(){t._arrowIcon&&(t._focused.attr("aria-busy",!0),t._arrowIcon.addClass(C),t._hideClear())},100)))},_requestEnd:function(){this._request=!1,this._hideBusy()},_dataSource:function(){var t,n=this,i=n.element,o=n.options,r=o.dataSource||{};r=e.isArray(r)?{data:r}:r,n._isSelect&&(t=i[0].selectedIndex,t>-1&&(o.index=t),r.select=i,r.fields=[{field:o.dataTextField},{field:o.dataValueField}]),n.dataSource?n._unbindDataSource():(n._requestStartHandler=L(n._showBusy,n),n._requestEndHandler=L(n._requestEnd,n),n._errorHandler=L(n._hideBusy,n)),n.dataSource=d.data.DataSource.create(r).bind(F,n._requestStartHandler).bind(z,n._requestEndHandler).bind("error",n._errorHandler)},_firstItem:function(){this.listView.focusFirst()},_lastItem:function(){this.listView.focusLast()},_nextItem:function(){this.listView.focusNext()},_prevItem:function(){this.listView.focusPrev()},_move:function(e){var n,i,o,r,s,a,l=this,c=l.listView,d=e.keyCode,u=d===m.DOWN;if(d===m.UP||u){if(e.altKey)l.toggle(u);else{if(!c.bound()&&!l.ul[0].firstChild)return l._fetch||(l.dataSource.one(y,function(){l._fetch=!1,l._move(e)}),l._fetch=!0,l._filterSource()),e.preventDefault(),!0;if(o=l._focus(),l._fetch||o&&!o.hasClass("k-state-selected")||(u?(l._nextItem(),l._focus()||l._lastItem()):(l._prevItem(),l._focus()||l._firstItem())),n=c.dataItemByIndex(c.getElementIndex(l._focus())),l.trigger(M,{dataItem:n,item:l._focus()}))return l._focus(o),t;l._select(l._focus(),!0).done(function(){l.popup.visible()||l._blur(),l._cascadedValue=null===l._cascadedValue?l.value():l.dataItem()?l.dataItem()[l.options.dataValueField]:null})}e.preventDefault(),i=!0}else if(d===m.ENTER||d===m.TAB){if(l.popup.visible()&&e.preventDefault(),o=l._focus(),n=l.dataItem(),l.popup.visible()||n&&l.text()===l._text(n)||(o=null),r=l.filterInput&&l.filterInput[0]===_(),o){if(n=c.dataItemByIndex(c.getElementIndex(o)),s=!0,n&&(s=l._value(n)!==j.unifyType(l.value(),typeof l._value(n))),s&&l.trigger(M,{dataItem:n,item:o}))return;l._select(o)}else l.input&&((l._syncValueAndText()||l._isSelect)&&l._accessor(l.input.val()),l.listView.value(l.input.val()));l._focusElement&&l._focusElement(l.wrapper),r&&d===m.TAB?l.wrapper.focusout():l._blur(),l.close(),i=!0}else d===m.ESC?(l.popup.visible()&&e.preventDefault(),l.close(),i=!0):!l.popup.visible()||d!==m.PAGEDOWN&&d!==m.PAGEUP||(e.preventDefault(),a=d===m.PAGEDOWN?1:-1,c.scrollWith(a*c.screenHeight()),i=!0);return i},_fetchData:function(){var e=this,t=!!e.dataSource.view().length;e._request||e.options.cascadeFrom||e.listView.bound()||e._fetch||t||(e._fetch=!0,e.dataSource.fetch().done(function(){e._fetch=!1}))},_options:function(e,n,i){var r,s,a,l,c=this,d=c.element,u=d[0],h=e.length,f="",p=0;for(n&&(f=n);p<h;p++)r="<option",s=e[p],a=c._text(s),l=c._value(s),l!==t&&(l+="",l.indexOf('"')!==-1&&(l=l.replace(U,"&quot;")),r+=' value="'+l+'"'),r+=">",a!==t&&(r+=v(a)),r+="</option>",f+=r;d.html(f),i!==t&&(u.value=i,u.value&&!i&&(u.selectedIndex=-1)),u.selectedIndex!==-1&&(r=o(u),r&&r.setAttribute(R,R))},_reset:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){setTimeout(function(){t.value(t._initial)})},t._form=o.on("reset",t._resetHandler))},_parentWidget:function(){var t,n,i=this.options.name;if(this.options.cascadeFrom)return t=e("#"+this.options.cascadeFrom),n=t.data("kendo"+i),n||(n=t.data("kendo"+W[i])),n},_cascade:function(){var e,t=this,n=t.options,i=n.cascadeFrom;if(i){if(e=t._parentWidget(),!e)return;t._cascadeHandlerProxy=L(t._cascadeHandler,t),t._cascadeFilterRequests=[],n.autoBind=!1,e.bind("set",function(){t.one("set",function(e){t._selectedValue=e.value||t._accessor()})}),e.first(I,t._cascadeHandlerProxy),e.listView.bound()?(t._toggleCascadeOnFocus(),t._cascadeSelect(e)):(e.one("dataBound",function(){t._toggleCascadeOnFocus(),e.popup.visible()&&e._focused.focus()}),e.value()||t.enable(!1))}},_toggleCascadeOnFocus:function(){var e=this,t=e._parentWidget(),n=O?"blur":"focusout";t._focused.add(t.filterInput).bind("focus",function(){t.unbind(I,e._cascadeHandlerProxy),t.first(y,e._cascadeHandlerProxy)}),t._focused.add(t.filterInput).bind(n,function(){t.unbind(y,e._cascadeHandlerProxy),t.first(I,e._cascadeHandlerProxy)})},_cascadeHandler:function(e){var t=this._parentWidget(),n=this.value();this._userTriggered=e.userTriggered,this.listView.bound()&&this._clearSelection(t,!0),this._cascadeSelect(t,n)},_cascadeChange:function(e){var t=this,n=t._accessor()||t._selectedValue;t._cascadeFilterRequests.length||(t._selectedValue=null),t._userTriggered?t._clearSelection(e,!0):n?(n!==t.listView.value()[0]&&t.value(n),t.dataSource.view()[0]&&t.selectedIndex!==-1||t._clearSelection(e,!0)):t.dataSource.flatView().length&&t.select(t.options.index),t.enable(),t._triggerCascade(),t._triggerChange(),t._userTriggered=!1},_cascadeSelect:function(e,n){var i,o,r=this,s=e.dataItem(),l=s?s[r.options.cascadeFromField]||e._value(s):null,c=r.options.cascadeFromField||e.options.dataValueField;r._valueBeforeCascade=n!==t?n:r.value(),l||0===l?(i=r.dataSource.filter()||{},a(i,c),o=function(){var t=r._cascadeFilterRequests.shift();t&&r.unbind("dataBound",t),t=r._cascadeFilterRequests[0],t&&r.first("dataBound",t),r._cascadeChange(e)},r._cascadeFilterRequests.push(o),1===r._cascadeFilterRequests.length&&r.first("dataBound",o),r._cascading=!0,r._filterSource({field:c,operator:"eq",value:l}),r._cascading=!1):(r.enable(!1),r._clearSelection(e),r._triggerCascade(),r._triggerChange(),r._userTriggered=!1)}}),l=".StaticList",c=d.ui.DataBoundWidget.extend({init:function(t,n){p.fn.init.call(this,t,n),this.element.attr("role","listbox").on("click"+l,"li",L(this._click,this)).on("mouseenter"+l,"li",function(){e(this).addClass(x)}).on("mouseleave"+l,"li",function(){e(this).removeClass(x)}),"multiple"===this.options.selectable&&this.element.attr("aria-multiselectable",!0),this.content=this.element.wrap("<div class='k-list-scroller' unselectable='on'></div>").parent(),this.header=this.content.before('<div class="k-group-header" style="display:none"></div>').prev(),this.bound(!1),this._optionID=d.guid(),this._selectedIndices=[],this._view=[],this._dataItems=[],this._values=[];var i=this.options.value;i&&(this._values=e.isArray(i)?i.slice(0):[i]),this._getter(),this._templates(),this.setDataSource(this.options.dataSource),this._onScroll=L(function(){var e=this;clearTimeout(e._scrollId),e._scrollId=setTimeout(function(){e._renderHeader()},50)},this)},options:{name:"StaticList",dataValueField:null,valuePrimitive:!1,selectable:!0,template:null,groupTemplate:null,fixedGroupTemplate:null},events:["click",y,"activate","deactivate","dataBinding","dataBound","selectedItemChange"],setDataSource:function(t){var n,i=this,o=t||{};o=e.isArray(o)?{data:o}:o,o=d.data.DataSource.create(o),i.dataSource?(i.dataSource.unbind(y,i._refreshHandler),n=i.value(),i.value([]),i.bound(!1),i.value(n)):i._refreshHandler=L(i.refresh,i),i.setDSFilter(o.filter()),i.dataSource=o.bind(y,i._refreshHandler),i._fixedHeader()},skip:function(){return this.dataSource.skip()},setOptions:function(e){p.fn.setOptions.call(this,e),this._getter(),this._templates(),this._render()},destroy:function(){this.element.off(l),this._refreshHandler&&this.dataSource.unbind(y,this._refreshHandler),clearTimeout(this._scrollId),p.fn.destroy.call(this)},dataItemByIndex:function(e){return this.dataSource.flatView()[e]},screenHeight:function(){return this.content[0].clientHeight},scrollToIndex:function(e){var t=this.element[0].children[e];t&&this.scroll(t)},scrollWith:function(e){this.content.scrollTop(this.content.scrollTop()+e)},scroll:function(e){if(e){e[0]&&(e=e[0]);var t=this.content[0],n=e.offsetTop,i=e.offsetHeight,o=t.scrollTop,r=t.clientHeight,s=n+i;o>n?o=n:s>o+r&&(o=s-r),t.scrollTop=o}},selectedDataItems:function(e){return e===t?this._dataItems.slice():(this._dataItems=e,this._values=this._getValues(e),t)},_getValues:function(t){var n=this._valueGetter;return e.map(t,function(e){return n(e)})},focusNext:function(){var e=this.focus();e=e?e.next():0,this.focus(e)},focusPrev:function(){var e=this.focus();e=e?e.prev():this.element[0].children.length-1,this.focus(e)},focusFirst:function(){this.focus(this.element[0].children[0])},focusLast:function(){this.focus(i(this.element[0].children))},focus:function(n){var o,r=this,s=r._optionID;return n===t?r._current:(n=i(r._get(n)),n=e(this.element[0].children[n]),r._current&&(r._current.removeClass(k).removeAttr(w),r.trigger("deactivate")),o=!!n[0],o&&(n.addClass(k),r.scroll(n),n.attr("id",s)),r._current=o?n:null,r.trigger("activate"),t)},focusIndex:function(){return this.focus()?this.focus().index():t},skipUpdate:function(e){this._skipUpdate=e},select:function(n){var o,r,s,a=this,l=a.options.selectable,c="multiple"!==l&&l!==!1,d=a._selectedIndices,u=[],h=[];return n===t?d.slice():(n=a._get(n),1===n.length&&n[0]===-1&&(n=[]),r=e.Deferred().resolve(),s=a.isFiltered(),s&&!c&&a._deselectFiltered(n)?r:c&&!s&&e.inArray(i(n),d)!==-1?(a._dataItems.length&&a._view.length&&(a._dataItems=[a._view[d[0]].item]),r):(o=a._deselect(n),h=o.removed,n=o.indices,n.length&&(c&&(n=[i(n)]),u=a._select(n)),(u.length||h.length)&&(a._valueComparer=null,a.trigger(y,{added:u,removed:h})),r))},removeAt:function(e){return this._selectedIndices.splice(e,1),this._values.splice(e,1),this._valueComparer=null,{position:e,dataItem:this._dataItems.splice(e,1)[0]}},setValue:function(t){t=e.isArray(t)||t instanceof b?t.slice(0):[t],this._values=t,this._valueComparer=null},value:function(n){var i,o=this,r=o._valueDeferred;return n===t?o._values.slice():(o.setValue(n),r&&"resolved"!==r.state()||(o._valueDeferred=r=e.Deferred()),o.bound()&&(i=o._valueIndices(o._values),"multiple"===o.options.selectable&&o.select(-1),o.select(i),r.resolve()),o._skipUpdate=!1,r)},items:function(){return this.element.children(".k-item")},_click:function(t){t.isDefaultPrevented()||this.trigger("click",{item:e(t.currentTarget)})||this.select(t.currentTarget)},_valueExpr:function(e,t){var i,o,r=this,s=0,a=[];if(!r._valueComparer||r._valueType!==e){for(r._valueType=e;s<t.length;s++)a.push(n(t[s],e));i="for (var idx = 0; idx < "+a.length+"; idx++) { if (current === values[idx]) {   return idx; }} return -1;",o=Function("current","values",i),r._valueComparer=function(e){return o(e,a)}}return r._valueComparer},_dataItemPosition:function(e,t){var n=this._valueGetter(e),i=this._valueExpr(typeof n,t);return i(n)},_getter:function(){this._valueGetter=d.getter(this.options.dataValueField)},_deselect:function(t){var n,i,o,r=this,s=r.element[0].children,a=r.options.selectable,l=r._selectedIndices,c=r._dataItems,d=r._values,u=[],h=0,f=0;if(t=t.slice(),a!==!0&&t.length){if("multiple"===a)for(;h<t.length;h++)if(i=t[h],e(s[i]).hasClass("k-state-selected"))for(n=0;n<l.length;n++)if(o=l[n],o===i){e(s[o]).removeClass("k-state-selected").attr("aria-selected",!1),u.push({position:n+f,dataItem:c.splice(n,1)[0]}),l.splice(n,1),t.splice(h,1),d.splice(n,1),f+=1,h-=1,n-=1;break}}else{for(;h<l.length;h++)e(s[l[h]]).removeClass("k-state-selected").attr("aria-selected",!1),u.push({position:h,dataItem:c[h]});r._values=[],r._dataItems=[],r._selectedIndices=[]}return{indices:t,removed:u}},_deselectFiltered:function(t){for(var n,i,o,r=this.element[0].children,s=[],a=0;a<t.length;a++)i=t[a],n=this._view[i].item,o=this._dataItemPosition(n,this._values),o>-1&&(s.push(this.removeAt(o)),e(r[i]).removeClass("k-state-selected"));return!!s.length&&(this.trigger(y,{added:[],removed:s}),!0)},_select:function(t){var n,o,r=this,s=r.element[0].children,a=r._view,l=[],c=0;for(i(t)!==-1&&r.focus(t);c<t.length;c++)o=t[c],n=a[o],o!==-1&&n&&(n=n.item,r._selectedIndices.push(o),r._dataItems.push(n),r._values.push(r._valueGetter(n)),e(s[o]).addClass("k-state-selected").attr("aria-selected",!0),l.push({dataItem:n}));return l},getElementIndex:function(t){return e(t).data("offset-index")},_get:function(e){return"number"==typeof e?e=[e]:H(e)||(e=this.getElementIndex(e),e=[e!==t?e:-1]),e},_template:function(){var e=this,t=e.options,n=t.template;return n?(n=d.template(n),n=function(e){return'<li tabindex="-1" role="option" unselectable="on" class="k-item">'+n(e)+"</li>"}):n=d.template('<li tabindex="-1" role="option" unselectable="on" class="k-item">${'+d.expr(t.dataTextField,"data")+"}</li>",{useWithBlock:!1}),n},_templates:function(){var e,t,n=this.options,i={template:n.template,groupTemplate:n.groupTemplate,fixedGroupTemplate:n.fixedGroupTemplate};for(t in i)e=i[t],e&&"function"!=typeof e&&(i[t]=d.template(e));this.templates=i},_normalizeIndices:function(e){for(var n=[],i=0;i<e.length;i++)e[i]!==t&&n.push(e[i]);return n},_valueIndices:function(e,t){var n,i=this._view,o=0;if(t=t?t.slice():[],!e.length)return[];for(;o<i.length;o++)n=this._dataItemPosition(i[o].item,e),n!==-1&&(t[n]=o);return this._normalizeIndices(t)},_firstVisibleItem:function(){for(var t=this.element[0],n=this.content[0],i=n.scrollTop,o=e(t.children[0]).height(),r=Math.floor(i/o)||0,s=t.children[r]||t.lastChild,a=s.offsetTop<i;s;)if(a){if(s.offsetTop+o>i||!s.nextSibling)break;s=s.nextSibling}else{if(s.offsetTop<=i||!s.previousSibling)break;s=s.previousSibling}return this._view[e(s).data("offset-index")]},_fixedHeader:function(){this.isGrouped()&&this.templates.fixedGroupTemplate?(this.header.show(),this.content.scroll(this._onScroll)):(this.header.hide(),this.content.off("scroll",this._onScroll))},_renderHeader:function(){var e,t=this.templates.fixedGroupTemplate;t&&(e=this._firstVisibleItem(),e&&e.group&&this.header.html(t(e.group)))},_renderItem:function(e){var t='<li tabindex="-1" role="option" unselectable="on" class="k-item',n=e.item,i=0!==e.index,o=e.selected;return i&&e.newGroup&&(t+=" k-first"),o&&(t+=" k-state-selected"),t+='" aria-selected="'+(o?"true":"false")+'" data-offset-index="'+e.index+'">',t+=this.templates.template(n),i&&e.newGroup&&(t+='<div class="k-group">'+this.templates.groupTemplate(e.group)+"</div>"),t+"</li>"},_render:function(){var e,t,n,i,o="",r=0,s=0,a=[],l=this.dataSource.view(),c=this.value(),d=this.isGrouped();if(d)for(r=0;r<l.length;r++)for(t=l[r],n=!0,i=0;i<t.items.length;i++)e={selected:this._selected(t.items[i],c),item:t.items[i],group:t.value,newGroup:n,index:s},a[s]=e,s+=1,o+=this._renderItem(e),n=!1;else for(r=0;r<l.length;r++)e={selected:this._selected(l[r],c),item:l[r],index:r},a[r]=e,o+=this._renderItem(e);this._view=a,this.element[0].innerHTML=o,d&&a.length&&this._renderHeader()},_selected:function(e,t){var n=!this.isFiltered()||"multiple"===this.options.selectable;return n&&this._dataItemPosition(e,t)!==-1},setDSFilter:function(e){this._lastDSFilter=B({},e)},isFiltered:function(){return this._lastDSFilter||this.setDSFilter(this.dataSource.filter()),!d.data.Query.compareFilters(this.dataSource.filter(),this._lastDSFilter)},refresh:function(e){var t,n=this,i=e&&e.action,o=n.options.skipUpdateOnBind,s="itemchange"===i;n.trigger("dataBinding"),n._angularItems("cleanup"),n._fixedHeader(),n._render(),n.bound(!0),s||"remove"===i?(t=r(n._dataItems,e.items),t.changed.length&&(s?n.trigger("selectedItemChange",{items:t.changed}):n.value(n._getValues(t.unchanged)))):n.isFiltered()||n._skipUpdate||n._emptySearch?(n.focus(0),n._skipUpdate&&(n._skipUpdate=!1,n._selectedIndices=n._valueIndices(n._values,n._selectedIndices))):o||i&&"add"!==i||n.value(n._values),n._valueDeferred&&n._valueDeferred.resolve(),n._angularItems("compile"),n.trigger("dataBound")},bound:function(e){return e===t?this._bound:(this._bound=e,t)},isGrouped:function(){return(this.dataSource.group()||[]).length}}),u.plugin(c)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.calendar.min",["kendo.core.min","kendo.selectable.min"],e)}(function(){return function(e,t){function n(e,t,n,i){var o,r=e.getFullYear(),s=t.getFullYear(),a=n.getFullYear();return r-=r%i,o=r+(i-1),r<s&&(r=s),o>a&&(o=a),r+"-"+o}function i(e){var t,n=0,i=e.min,o=e.max,r=e.start,s=e.setter,l=e.build,c=e.weekNumberBuild,d=e.cells||12,u=e.isWeekColumnVisible,h=e.perRow||4,f=e.weekNumber||W,m=e.content||V,g=e.empty||U,v=e.html||'<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><tbody><tr role="row">';for(u&&(v+=f(c(r)));n<d;n++)n>0&&n%h===0&&(v+='</tr><tr role="row">',u&&(v+=f(c(r)))),r=p(r.getFullYear(),r.getMonth(),r.getDate()),F(r,0),t=l(r,n,e.disableDates),v+=a(r,i,o)?m(t):g(t),s(r,1);return v+"</tr></tbody></table>"}function o(e,t,n){var i=e.getFullYear(),o=t.getFullYear(),r=o,s=0;return n&&(o-=o%n,r=o-o%n+n-1),i>r?s=1:i<o&&(s=-1),s}function r(){var e=new Me;return new Me(e.getFullYear(),e.getMonth(),e.getDate())}function s(e,t,n){var i=r();return e&&(i=new Me((+e))),t>i?i=new Me((+t)):n<i&&(i=new Me((+n))),i}function a(e,t,n){return+e>=+t&&+e<=+n}function l(e,t){return e.slice(t).concat(e.slice(0,t))}function c(e,t,n){t=t instanceof Me?t.getFullYear():e.getFullYear()+n*t,e.setFullYear(t)}function d(e,t){var n,i,o;return+t<+e&&(n=+e,T.views[0].setDate(e,t),T.views[0].setDate(t,new Date(n))),i=Date.UTC(e.getFullYear(),e.getMonth(),e.getDate()),o=Date.UTC(t.getFullYear(),t.getMonth(),t.getDate()),Math.ceil((+o-+i)/D.date.MS_PER_DAY)}function u(e,t,n,i){var o,r;for(o=0;o<=t;o++)r=new Date(n.getTime()),r=new Date(r.setDate(r.getDate()+o)),i(r)||e.push(r)}function h(t){var n=e(this).hasClass("k-state-disabled");n||e(this).toggleClass(se,be.indexOf(t.type)>-1||t.type==ve)}function f(e){e.preventDefault()}function p(e,t,n){var i=1904,o=new Me(i,t,n);return o.setFullYear(e),o}function m(e){return H(e).calendars.standard}function g(e){var n=Re[e.start],i=Re[e.depth],o=H(e.culture);e.format=B(e.format||o.calendars.standard.patterns.d),isNaN(n)&&(n=0,e.start=te),(i===t||i>n)&&(e.depth=te),null===e.dates&&(e.dates=[])}function v(e){q&&e.find("*").attr("unselectable","on")}function _(e,t){e.addClass("k-"+t)}function b(e,t){for(var n=0,i=t.length;n<i;n++)if(e===+t[n])return!0;return!1}function w(e,t){return!!e&&(e.getFullYear()===t.getFullYear()&&e.getMonth()===t.getMonth()&&e.getDate()===t.getDate())}function y(e,t){return!!e&&(e.getFullYear()===t.getFullYear()&&e.getMonth()===t.getMonth())}function k(t){return D.isFunction(t)?t:e.isArray(t)?C(t):e.noop}function x(e){var t,n=[];for(t=0;t<e.length;t++)n.push(e[t].setHours(0,0,0,0));return n}function C(t){var n,i,o,r,s,a=[],l=["su","mo","tu","we","th","fr","sa"],c="if (found) { return true } else {return false}";if(t[0]instanceof Me)a=x(t),n="var found = date && window.kendo.jQuery.inArray(date.setHours(0, 0, 0, 0),["+a+"]) > -1;"+c;else{for(o=0;o<t.length;o++)r=t[o].slice(0,2).toLowerCase(),s=e.inArray(r,l),s>-1&&a.push(s);n="var found = date && window.kendo.jQuery.inArray(date.getDay(),["+a+"]) > -1;"+c}return i=Function("date",n)}function S(e,t){return e instanceof Date&&t instanceof Date&&(e=e.getTime(),t=t.getTime()),e===t}var T,D=window.kendo,A=D.support,E=D.ui,I=E.Widget,M=D.keys,R=D.parseDate,F=D.date.adjustDST,z=D.date.weekInYear,P=D.ui.Selectable,B=D._extractFormat,L=D.template,H=D.getCulture,N=D.support.transitions,O=N?N.css+"transform-origin":"",V=L('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link" href="\\#" data-#=data.ns#value="#=data.dateString#">#=data.value#</a></td>',{useWithBlock:!1}),U=L('<td role="gridcell">&nbsp;</td>',{useWithBlock:!1}),W=L('<td class="k-alt">#= data.weekNumber #</td>',{useWithBlock:!1}),j=D.support.browser,q=j.msie&&j.version<9,G=D._outerHeight,$=D._outerWidth,K=".kendoCalendar",Y="click"+K,Q="keydown"+K,X="id",Z="min",J="left",ee="slideIn",te="month",ne="century",ie="change",oe="navigate",re="value",se="k-state-hover",ae="k-state-disabled",le="k-state-focused",ce="k-other-month",de=' class="'+ce+'"',ue="k-nav-today",he="td:has(.k-link)",fe="td:has(.k-link):not(."+ae+")",pe="td:not(:has(.k-link))",me="k-state-selected",ge="blur"+K,ve="focus",_e=ve+K,be=A.touch?"touchstart":"mouseenter",we=A.touch?"touchstart"+K:"mouseenter"+K,ye=A.touch?"touchend"+K+" touchmove"+K:"mouseleave"+K,ke=6e4,xe=864e5,Ce="_prevArrow",Se="_nextArrow",Te="aria-disabled",De="aria-selected",Ae="aria-label",Ee=e.proxy,Ie=e.extend,Me=Date,Re={month:0,year:1,decade:2,century:3},Fe=I.extend({init:function(t,n){var i,o,a=this;I.fn.init.call(a,t,n),t=a.wrapper=a.element,n=a.options,n.url=window.unescape(n.url),a.options.disableDates=k(a.options.disableDates),a._templates(),a._selectable(),a._header(),a._footer(a.footer),o=t.addClass("k-widget k-calendar "+(n.weekNumber?" k-week-number":"")).on(we+" "+ye,he,h).on(Q,"table.k-content",Ee(a._move,a)).on(Y,he,function(t){var i=t.currentTarget.firstChild,o=a._toDateObject(i);i.href.indexOf("#")!=-1&&t.preventDefault(),"month"==a._view.name&&a.options.disableDates(o)||"month"==a._view.name&&"single"!=n.selectable||a._click(e(i))}).on("mouseup"+K,"table.k-content, .k-footer",function(){a._focusView(a.options.focusOnNav!==!1)}).attr(X),o&&(a._cellID=o+"_cell_selected"),a._isMultipleSelection()&&a.options.weekNumber&&t.on(Y,pe,function(t){var n=e(t.currentTarget).closest("tr").find(fe).first(),i=a.selectable._lastActive=e(t.currentTarget).closest("tr").find(fe).last();a.selectable.selectRange(n,i,{event:t}),a._current=a._value=a._toDateObject(i.find("a")),a._class(le,a._current)}),g(n),i=R(n.value,n.format,n.culture),a._selectDates=[],a._index=Re[n.start],a._current=new Me((+s(i,n.min,n.max))),a._addClassProxy=function(){if(a._active=!0,a._cell.hasClass(ae)){var e=a._view.toDateString(r());a._cell=a._cellByDate(e)}a._cell.addClass(le)},a._removeClassProxy=function(){a._active=!1,a._cell.removeClass(le)},a.value(i),a._isMultipleSelection()&&n.selectDates.length>0&&a.selectDates(n.selectDates),D.notify(a)},options:{name:"Calendar",value:null,min:new Me(1900,0,1),max:new Me(2099,11,31),dates:[],disableDates:null,url:"",culture:"",footer:"",format:"",month:{},weekNumber:!1,selectable:"single",selectDates:[],start:te,depth:te,animation:{horizontal:{effects:ee,reverse:!0,duration:500,divisor:2},vertical:{effects:"zoomIn",duration:400}},messages:{weekColumnHeader:""}},events:[ie,oe],setOptions:function(e){var t=this;g(e),e.disableDates=k(e.disableDates),I.fn.setOptions.call(t,e),t._templates(),t._selectable(),t._footer(t.footer),t._index=Re[t.options.start],t.navigate()},destroy:function(){var e=this,t=e._today;e.element.off(K),e._title.off(K),e[Ce].off(K),e[Se].off(K),e._destroySelectable(),D.destroy(e._table),t&&D.destroy(t.off(K)),I.fn.destroy.call(e)},current:function(){return this._current},view:function(){return this._view},focus:function(e){e=e||this._table,this._bindTable(e),e.focus()},min:function(e){return this._option(Z,e)},max:function(e){return this._option("max",e)},navigateToPast:function(){this._navigate(Ce,-1)},navigateToFuture:function(){this._navigate(Se,1)},navigateUp:function(){var e=this,t=e._index;e._title.hasClass(ae)||e.navigate(e._current,++t)},navigateDown:function(e){var n=this,i=n._index,o=n.options.depth;if(e)return i===Re[o]?(S(n._value,n._current)&&S(n._value,e)||(n.value(e),n.trigger(ie)),t):(n.navigate(e,--i),t)},navigate:function(n,i){var o,r,a,l,c,d,u,h,f,p,m,g,b,w,y,k;i=isNaN(i)?Re[i]:i,o=this,r=o.options,a=r.culture,l=r.min,c=r.max,d=o._title,u=o._table,h=o._oldTable,f=o._current,p=n&&+n>+f,m=i!==t&&i!==o._index,n||(n=f),o._current=n=new Me((+s(n,l,c))),i===t?i=o._index:o._index=i,o._view=b=T.views[i],w=b.compare,y=i===Re[ne],d.toggleClass(ae,y).attr(Te,y),y=w(n,l)<1,o[Ce].toggleClass(ae,y).attr(Te,y),o[Ce].hasClass(ae)&&o[Ce].removeClass(se),y=w(n,c)>-1,o[Se].toggleClass(ae,y).attr(Te,y),o[Se].hasClass(ae)&&o[Se].removeClass(se),u&&h&&h.data("animating")&&(h.kendoStop(!0,!0),u.kendoStop(!0,!0)),o._oldTable=u,u&&!o._changeView||(d.html(b.title(n,l,c,a)),o._table=g=e(b.content(Ie({min:l,max:c,date:n,url:r.url,dates:r.dates,format:r.format,culture:a,disableDates:r.disableDates,isWeekColumnVisible:r.weekNumber,messages:r.messages},o[b.name]))),_(g,b.name),v(g),k=u&&u.data("start")===g.data("start"),o._animate({from:u,to:g,vertical:m,future:p,replace:k}),o.trigger(oe),o._focus(n)),i===Re[r.depth]&&o._selectDates.length>0&&o._visualizeSelectedDatesInView(),"single"===o.options.selectable&&i===Re[r.depth]&&o._value&&!o.options.disableDates(o._value)&&o._class("k-state-selected",o._value),o._class(le,n),!u&&o._cell&&o._cell.removeClass(le),o._changeView=!0},selectDates:function(n){var i,o,r=this;return n===t?r._selectDates:(o=n.map(function(e){return e.getTime()}).filter(function(e,t,n){return n.indexOf(e)===t}).map(function(e){return new Date(e)}),i=e.grep(o,function(e){if(e)return+r._validateValue(new Date(e.setHours(0,0,0,0)))===+e}),r._selectDates=i.length>0?i:0===o.length?o:r._selectDates,r._visualizeSelectedDatesInView(),t)},value:function(e){var n,i=this,o=i._view,r=i._view;return e===t?i._value:(e=i._validateValue(e),e&&i._isMultipleSelection()&&(n=new Date((+e)),
n.setHours(0,0,0,0),i._selectDates=[n],i.selectable._lastActive=null),o&&null===e&&i._cell?i._cell.removeClass(me):(i._changeView=!e||r&&0!==r.compare(e,i._current),i.navigate(e)),t)},_validateValue:function(e){var n=this,i=n.options,o=i.min,r=i.max;return null===e&&(n._current=p(n._current.getFullYear(),n._current.getMonth(),n._current.getDate())),e=R(e,i.format,i.culture),null!==e&&(e=new Me((+e)),a(e,o,r)||(e=null)),null!==e&&n.options.disableDates(new Date((+e)))?n._value===t&&(n._value=null):n._value=e,n._value},_visualizeSelectedDatesInView:function(){var t,n=this,i={};e.each(n._selectDates,function(e,t){i[D.calendar.views[0].toDateString(t)]=t}),n.selectable.clear(),t=n._table.find(he).filter(function(t,n){return i[e(n.firstChild).attr(D.attr(re))]}),t.length>0&&n.selectable._selectElement(t,!0)},_isMultipleSelection:function(){var e=this;return"multiple"===e.options.selectable},_selectable:function(){var e,t,n=this;n._isMultipleSelection()&&(e=n.options.selectable,t=P.parseOptions(e),t.multiple&&n.element.attr("aria-multiselectable","true"),n.selectable=new P(n.wrapper,{aria:!0,inputSelectors:"input,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up",multiple:t.multiple,filter:"table.k-month:eq(0) "+fe,change:Ee(n._onSelect,n),relatedTarget:Ee(n._onRelatedTarget,n)}))},_onRelatedTarget:function(e){var t=this;t.selectable.options.multiple&&e.is(fe)&&(t._current=t._toDateObject(e.find("a")),t._class(le,t._toDateObject(e.find("a"))))},_onSelect:function(n){var i=this,o=n,r=P.parseOptions(i.options.selectable);return r.multiple?(o.event.ctrlKey?e(o.event.currentTarget).is(fe)?i._toggleSelection(e(o.event.currentTarget)):(i._cellsBySelector(fe).each(function(t,n){var o=i._toDateObject(e(n).find("a"));i._deselect(o)}),i._addSelectedCellsToArray()):o.event.shiftKey?i._rangeSelection(i._cell):e(o.event.currentTarget).is(he)?i.value(i._toDateObject(e(o.event.currentTarget).find("a"))):(i._selectDates=[],i._addSelectedCellsToArray()),i.trigger(ie),t):(e(o.event.currentTarget).is("td")&&!e(o.event.currentTarget).hasClass("k-state-selected")?e(o.event.currentTarget).addClass("k-state-selected"):i._click(e(o.event.currentTarget).find("a")),t)},_destroySelectable:function(){var e=this;e.selectable&&(e.selectable.destroy(),e.selectable=null)},_toggleSelection:function(e){var t=this,n=t._toDateObject(e.find("a"));e.hasClass("k-state-selected")?t._selectDates.push(n):t._deselect(n)},_rangeSelection:function(e,t){var n,i=this,o=t||i._toDateObject(i.selectable.value().first().find("a")),r=i._toDateObject(e.find("a"));i.selectable._lastActive||i._value?o=i.selectable._lastActive?i._toDateObject(i.selectable._lastActive.find("a")):new Date((+i._value)):i.selectable._lastActive=t?i._cellByDate(i._view.toDateString(t),fe):i.selectable.value().first(),i._selectDates=[],n=d(o,r),u(i._selectDates,n,o,i.options.disableDates),i._visualizeSelectedDatesInView()},_cellsBySelector:function(e){var t=this;return t._table.find(e)},_addSelectedCellsToArray:function(){var t=this;t.selectable.value().each(function(n,i){var o=t._toDateObject(e(i.firstChild));t.options.disableDates(o)||t._selectDates.push(o)})},_deselect:function(e){var t=this,n=t._selectDates.map(Number).indexOf(+e);n!=-1&&t._selectDates.splice(n,1)},_dateInView:function(e){var t=this,n=t._toDateObject(t._cellsBySelector(he+":first").find("a")),i=t._toDateObject(t._cellsBySelector(he+":last").find("a"));return+e<=+i&&+e>=+n},_move:function(n){var i,o,r,l,c,d=this,u=d.options,h=n.keyCode,f=d._view,m=d._index,g=d.options.min,v=d.options.max,_=new Me((+d._current)),b=D.support.isRtl(d.wrapper),w=d.options.disableDates;return n.target===d._table[0]&&(d._active=!0),h==M.RIGHT&&!b||h==M.LEFT&&b?(i=1,o=!0):h==M.LEFT&&!b||h==M.RIGHT&&b?(i=-1,o=!0):h==M.UP?(i=0===m?-7:-4,o=!0):h==M.DOWN?(i=0===m?7:4,o=!0):h==M.SPACEBAR?(i=0,o=!0):h!=M.HOME&&h!=M.END||(r=h==M.HOME?"first":"last",l=f[r](_),_=new Me(l.getFullYear(),l.getMonth(),l.getDate(),_.getHours(),_.getMinutes(),_.getSeconds(),_.getMilliseconds()),_.setFullYear(l.getFullYear()),o=!0),n.ctrlKey?h==M.RIGHT&&!b||h==M.LEFT&&b?(d.navigateToFuture(),o=!0):h==M.LEFT&&!b||h==M.RIGHT&&b?(d.navigateToPast(),o=!0):h==M.UP?(d.navigateUp(),o=!0):h==M.DOWN?(d._click(e(d._cell[0].firstChild)),o=!0):h!=M.ENTER&&h!=M.SPACEBAR||!d._isMultipleSelection()||(d._keyboardToggleSelection(n),c=d._toDateObject(e(d._cell[0]).find("a")),d._class(le,c)):n.shiftKey?(i!==t||r)&&(r||f.setDate(_,i),w(_)&&(_=d._nextNavigatable(_,i)),g=p(g.getFullYear(),g.getMonth(),g.getDate()),a(_,g,v)&&(d._isMultipleSelection()?d._keyboardRangeSelection(n,_):d._focus(s(_,u.min,u.max)))):(h==M.ENTER||h==M.SPACEBAR?("month"==f.name&&d._isMultipleSelection()?(d.value(d._toDateObject(e(d._cell.find("a")))),d.selectable._lastActive=e(d._cell[0]),d.trigger(ie)):d._click(e(d._cell[0].firstChild)),o=!0):h==M.PAGEUP?(o=!0,d.navigateToPast()):h==M.PAGEDOWN&&(o=!0,d.navigateToFuture()),(i||r)&&(r||f.setDate(_,i),w(_)&&(_=d._nextNavigatable(_,i)),g=p(g.getFullYear(),g.getMonth(),g.getDate()),a(_,g,v)&&(d._isMultipleSelection()?d._dateInView(_)?(d._current=_,d._class(le,_)):d.navigate(_):d._focus(s(_,u.min,u.max))))),o&&n.preventDefault(),d._current},_keyboardRangeSelection:function(e,n){var i,o,r=this;return r._dateInView(n)?(r.selectable.options.filter=r.wrapper.find("table").length>1&&+n>+r._current?"table.k-month:eq(1) "+fe:"table.k-month:eq(0) "+fe,r._class(le,n),r._current=n,r._rangeSelection(r._cellByDate(r._view.toDateString(n),fe),n),r.trigger(ie),r.selectable.options.filter="table.k-month:eq(0) "+fe,t):(r._selectDates=[],i=r.selectable._lastActive?r._toDateObject(r.selectable._lastActive.find("a")):n,o=d(i,new Date((+n))),u(r._selectDates,o,i,r.options.disableDates),r.navigate(n),r._current=n,r.selectable._lastActive=r.selectable._lastActive||r._cellByDate(r._view.toDateString(n),fe),r.trigger(ie),t)},_keyboardToggleSelection:function(t){var n=this;t.currentTarget=n._cell[0],n.selectable._lastActive=e(n._cell[0]),e(n._cell[0]).hasClass(me)?(n.selectable._unselect(e(n._cell[0])),n.selectable.trigger(ie,{event:t})):n.selectable.value(e(n._cell[0]),{event:t})},_nextNavigatable:function(e,t){var n=this,i=!0,o=n._view,r=n.options.min,s=n.options.max,l=n.options.disableDates,c=new Date(e.getTime());for(o.setDate(c,-t);i;){if(o.setDate(e,t),!a(e,r,s)){e=c;break}i=l(e)}return e},_animate:function(e){var t=this,n=e.from,i=e.to,o=t._active;n?n.parent().data("animating")?(n.off(K),n.parent().kendoStop(!0,!0).remove(),n.remove(),i.insertAfter(t.element[0].firstChild),t._focusView(o)):!n.is(":visible")||t.options.animation===!1||e.replace?(i.insertAfter(n),n.off(K).remove(),t._focusView(o)):t[e.vertical?"_vertical":"_horizontal"](n,i,e.future):(i.insertAfter(t.element[0].firstChild),t._bindTable(i))},_horizontal:function(e,t,n){var i=this,o=i._active,r=i.options.animation.horizontal,s=r.effects,a=$(e);s&&s.indexOf(ee)!=-1&&(e.add(t).css({width:a}),e.wrap("<div/>"),i._focusView(o,e),e.parent().css({position:"relative",width:2*a,"float":J,"margin-left":n?0:-a}),t[n?"insertAfter":"insertBefore"](e),Ie(r,{effects:ee+":"+(n?"right":J),complete:function(){e.off(K).remove(),i._oldTable=null,t.unwrap(),i._focusView(o)}}),e.parent().kendoStop(!0,!0).kendoAnimate(r))},_vertical:function(e,t){var n,i,o=this,r=o.options.animation.vertical,s=r.effects,a=o._active;s&&s.indexOf("zoom")!=-1&&(t.css({position:"absolute",top:G(e.prev()),left:0}).insertBefore(e),O&&(n=o._cellByDate(o._view.toDateString(o._current)),i=n.position(),i=i.left+parseInt(n.width()/2,10)+"px "+(i.top+parseInt(n.height()/2,10)+"px"),t.css(O,i)),e.kendoStop(!0,!0).kendoAnimate({effects:"fadeOut",duration:600,complete:function(){e.off(K).remove(),o._oldTable=null,t.css({position:"static",top:0,left:0}),o._focusView(a)}}),t.kendoStop(!0,!0).kendoAnimate(r))},_cellByDate:function(t,n){return this._table.find(n?n:"td:not(."+ce+")").filter(function(){return e(this.firstChild).attr(D.attr(re))===t})},_class:function(e,t){var n,i=this,o=i._cellID,r=i._cell,s=i._view.toDateString(t);r&&r.removeAttr(De).removeAttr(Ae).removeAttr(X),t&&"month"==i._view.name&&(n=i.options.disableDates(t)),i._cellsBySelector(i._isMultipleSelection()?he:"td:not(."+ce+")").removeClass(e),r=i._cellByDate(s,"multiple"==i.options.selectable?he:"td:not(."+ce+")").attr(De,!0),(e===le&&!i._active&&i.options.focusOnNav!==!1||n)&&(e=""),r.addClass(e),r[0]&&(i._cell=r),o&&(r.attr(X,o),i._table.removeAttr("aria-activedescendant").attr("aria-activedescendant",o))},_bindTable:function(e){e.on(_e,this._addClassProxy).on(ge,this._removeClassProxy)},_click:function(e){var t=this,n=t.options,i=new Date((+t._current)),o=t._toDateObject(e);F(o,0),"month"==t._view.name&&t.options.disableDates(o)&&(o=t._value),t._view.setDate(i,o),t.navigateDown(s(i,n.min,n.max))},_focus:function(e){var t=this,n=t._view;0!==n.compare(e,t._current)?t.navigate(e):(t._current=e,t._class(le,e))},_focusView:function(e,t){e&&this.focus(t)},_footer:function(n){var i=this,o=r(),s=i.element,a=s.find(".k-footer");return n?(a[0]||(a=e('<div class="k-footer"><a href="#" class="k-link k-nav-today"></a></div>').appendTo(s)),i._today=a.show().find(".k-link").html(n(o)).attr("title",D.toString(o,"D",i.options.culture)),i._toggle(),t):(i._toggle(!1),a.hide(),t)},_header:function(){var e,t=this,n=t.element;n.find(".k-header")[0]||n.html('<div class="k-header"><a href="#" role="button" class="k-link k-nav-prev" '+Ae+'="Previous"><span class="k-icon k-i-arrow-60-left"></span></a><a href="#" role="button" aria-live="assertive" aria-atomic="true" class="k-link k-nav-fast"></a><a href="#" role="button" class="k-link k-nav-next" '+Ae+'="Next"><span class="k-icon k-i-arrow-60-right"></span></a></div>'),e=n.find(".k-link").on(we+" "+ye+" "+_e+" "+ge,h).click(!1),t._title=e.eq(1).on(Y,function(){t._active=t.options.focusOnNav!==!1,t.navigateUp()}),t[Ce]=e.eq(0).on(Y,function(){t._active=t.options.focusOnNav!==!1,t.navigateToPast()}),t[Se]=e.eq(2).on(Y,function(){t._active=t.options.focusOnNav!==!1,t.navigateToFuture()})},_navigate:function(e,t){var n,i=this,o=i._index+1,r=new Me((+i._current));i._isMultipleSelection()&&(n=i._table.find("td:not(.k-other-month)").has(".k-link").first(),r=i._toDateObject(n.find("a")),i._current=new Date((+r))),e=i[e],e.hasClass(ae)||(o>3?r.setFullYear(r.getFullYear()+100*t):T.views[o].setDate(r,t),i.navigate(r))},_option:function(e,n){var i,o=this,r=o.options,s=o._value||o._current;return n===t?r[e]:(n=R(n,r.format,r.culture),n&&(r[e]=new Me((+n)),i=e===Z?n>s:s>n,(i||y(s,n))&&(i&&(o._value=null),o._changeView=!0),o._changeView||(o._changeView=!(!r.month.content&&!r.month.empty)),o.navigate(o._value),o._toggle()),t)},_toggle:function(e){var n=this,i=n.options,o=n.options.disableDates(r()),s=n._today;e===t&&(e=a(r(),i.min,i.max)),s&&(s.off(Y),e&&!o?s.addClass(ue).removeClass(ae).on(Y,Ee(n._todayClick,n)):s.removeClass(ue).addClass(ae).on(Y,f))},_todayClick:function(e){var t=this,n=Re[t.options.depth],i=t.options.disableDates,o=r();e.preventDefault(),i(o)||(0===t._view.compare(t._current,o)&&t._index==n&&(t._changeView=!1),t._isMultipleSelection()&&(t._selectDates=[o],t.selectable._lastActive=null),t._value=o,t.navigate(o,n),t.trigger(ie))},_toDateObject:function(t){var n=e(t).attr(D.attr(re)).split("/");return n=p(n[0],n[1],n[2])},_templates:function(){var e=this,t=e.options,n=t.footer,i=t.month,o=i.content,r=i.weekNumber,s=i.empty;e.month={content:L('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link#=data.linkClass#" href="#=data.url#" '+D.attr(re)+'="#=data.dateString#" title="#=data.title#">'+(o||"#=data.value#")+"</a></td>",{useWithBlock:!!o}),empty:L('<td role="gridcell">'+(s||"&nbsp;")+"</td>",{useWithBlock:!!s}),weekNumber:L('<td class="k-alt">'+(r||"#= data.weekNumber #")+"</td>",{useWithBlock:!!r})},e.footer=n!==!1?L(n||'#= kendo.toString(data,"D","'+t.culture+'") #',{useWithBlock:!1}):null}});E.plugin(Fe),T={firstDayOfMonth:function(e){return p(e.getFullYear(),e.getMonth(),1)},firstVisibleDay:function(e,t){t=t||D.culture().calendar;var n=t.firstDay,i=new Me(e.getFullYear(),e.getMonth(),1,e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds());for(i.setFullYear(e.getFullYear());i.getDay()!=n;)T.setTime(i,-1*xe);return i},setTime:function(e,t){var n=e.getTimezoneOffset(),i=new Me(e.getTime()+t),o=i.getTimezoneOffset()-n;e.setTime(i.getTime()+o*ke)},views:[{name:te,title:function(e,t,n,i){return m(i).months.names[e.getMonth()]+" "+e.getFullYear()},content:function(e){var t=this,n=0,o=e.min,s=e.max,a=e.date,c=e.dates,d=e.format,u=e.culture,h=e.url,f=e.isWeekColumnVisible,g=h&&c[0],v=m(u),_=v.firstDay,w=v.days,y=l(w.names,_),k=l(w.namesShort,_),x=T.firstVisibleDay(a,v),C=t.first(a),S=t.last(a),A=t.toDateString,E=r(),I='<table tabindex="0" role="grid" class="k-content" cellspacing="0" data-start="'+A(x)+'"><thead><tr role="row">';for(f&&(I+='<th scope="col" class="k-alt">'+e.messages.weekColumnHeader+"</th>");n<7;n++)I+='<th scope="col" title="'+y[n]+'">'+k[n]+"</th>";return F(E,0),E=+E,i({cells:42,perRow:7,html:I+='</tr></thead><tbody><tr role="row">',start:x,isWeekColumnVisible:f,weekNumber:e.weekNumber,min:p(o.getFullYear(),o.getMonth(),o.getDate()),max:p(s.getFullYear(),s.getMonth(),s.getDate()),content:e.content,empty:e.empty,setter:t.setDate,disableDates:e.disableDates,build:function(e,t,n){var i=[],o=e.getDay(),r="",s="#";return(e<C||e>S)&&i.push(ce),n(e)&&i.push(ae),+e===E&&i.push("k-today"),0!==o&&6!==o||i.push("k-weekend"),g&&b(+e,c)&&(s=h.replace("{0}",D.toString(e,d,u)),r=" k-action-link"),{date:e,dates:c,ns:D.ns,title:D.toString(e,"D",u),value:e.getDate(),dateString:A(e),cssClass:i[0]?' class="'+i.join(" ")+'"':"",linkClass:r,url:s}},weekNumberBuild:function(e){return{weekNumber:z(e,D.culture().calendar.firstDay),currentDate:e}}})},first:function(e){return T.firstDayOfMonth(e)},last:function(e){var t=p(e.getFullYear(),e.getMonth()+1,0),n=T.firstDayOfMonth(e),i=Math.abs(t.getTimezoneOffset()-n.getTimezoneOffset());return i&&t.setHours(n.getHours()+i/60),t},compare:function(e,t){var n,i=e.getMonth(),o=e.getFullYear(),r=t.getMonth(),s=t.getFullYear();return n=o>s?1:o<s?-1:i==r?0:i>r?1:-1},setDate:function(e,t){var n=e.getHours();t instanceof Me?e.setFullYear(t.getFullYear(),t.getMonth(),t.getDate()):T.setTime(e,t*xe),F(e,n)},toDateString:function(e){return e.getFullYear()+"/"+e.getMonth()+"/"+e.getDate()}},{name:"year",title:function(e){return e.getFullYear()},content:function(e){var t=m(e.culture).months.namesAbbr,n=this.toDateString,o=e.min,r=e.max;return i({min:p(o.getFullYear(),o.getMonth(),1),max:p(r.getFullYear(),r.getMonth(),1),start:p(e.date.getFullYear(),0,1),setter:this.setDate,build:function(e){return{value:t[e.getMonth()],ns:D.ns,dateString:n(e),cssClass:""}}})},first:function(e){return p(e.getFullYear(),0,e.getDate())},last:function(e){return p(e.getFullYear(),11,e.getDate())},compare:function(e,t){return o(e,t)},setDate:function(e,t){var n,i=e.getHours();t instanceof Me?(n=t.getMonth(),e.setFullYear(t.getFullYear(),n,e.getDate()),n!==e.getMonth()&&e.setDate(0)):(n=e.getMonth()+t,e.setMonth(n),n>11&&(n-=12),n>0&&e.getMonth()!=n&&e.setDate(0)),F(e,i)},toDateString:function(e){return e.getFullYear()+"/"+e.getMonth()+"/1"}},{name:"decade",title:function(e,t,i){return n(e,t,i,10)},content:function(e){var t=e.date.getFullYear(),n=this.toDateString;return i({start:p(t-t%10-1,0,1),min:p(e.min.getFullYear(),0,1),max:p(e.max.getFullYear(),0,1),setter:this.setDate,build:function(e,t){return{value:e.getFullYear(),ns:D.ns,dateString:n(e),cssClass:0===t||11==t?de:""}}})},first:function(e){var t=e.getFullYear();return p(t-t%10,e.getMonth(),e.getDate())},last:function(e){var t=e.getFullYear();return p(t-t%10+9,e.getMonth(),e.getDate())},compare:function(e,t){return o(e,t,10)},setDate:function(e,t){c(e,t,1)},toDateString:function(e){return e.getFullYear()+"/0/1"}},{name:ne,title:function(e,t,i){return n(e,t,i,100)},content:function(e){var t=e.date.getFullYear(),n=e.min.getFullYear(),o=e.max.getFullYear(),r=this.toDateString,s=n,a=o;return s-=s%10,a-=a%10,a-s<10&&(a=s+9),i({start:p(t-t%100-10,0,1),min:p(s,0,1),max:p(a,0,1),setter:this.setDate,build:function(e,t){var i=e.getFullYear(),s=i+9;return i<n&&(i=n),s>o&&(s=o),{ns:D.ns,value:i+" - "+s,dateString:r(e),cssClass:0===t||11==t?de:""}}})},first:function(e){var t=e.getFullYear();return p(t-t%100,e.getMonth(),e.getDate())},last:function(e){var t=e.getFullYear();return p(t-t%100+99,e.getMonth(),e.getDate())},compare:function(e,t){return o(e,t,100)},setDate:function(e,t){c(e,t,10)},toDateString:function(e){var t=e.getFullYear();return t-t%10+"/0/1"}}]},T.isEqualDatePart=w,T.isEqualDate=S,T.makeUnselectable=v,T.restrictValue=s,T.isInRange=a,T.addClassToViewContainer=_,T.normalize=g,T.viewsEnum=Re,T.disabled=k,D.calendar=T}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dateinput.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(e,t,n,i){var o,r,s,a,l=e[i+e.length-n.length];if(e=e.substring(0,i+e.length-n.length),n=n.substring(0,i),o=[],e===n&&i>0)return o.push([t[i-1],n[i-1]]),o;if(0===e.indexOf(n)&&(0===n.length||t[n.length-1]!==t[n.length])){for(s="",r=n.length;r<e.length;r++)t[r]!==s&&w.indexOf(t[r])>=0&&(s=t[r],o.push([s,""]));return o}if(" "===n[n.length-1]||n[n.length-1]===l)return[[t[i-1]," "]];if(0===n.indexOf(e)||w.indexOf(t[i-1])===-1){for(a=t[0],r=Math.max(0,e.length-1);r<t.length;r++)if(w.indexOf(t[r])>=0){a=t[r];break}return[[a,n[i-1]]]}return[[t[i-1],n[i-1]]]}var i,o=window,r=o.kendo,s=r.caret,a=r.ui,l=a.Widget,c=r.keys,d=".kendoDateInput",u=e.proxy,h={}.toString,f=(r.support.propertyChangeEvent?"propertychange.kendoDateInput input":"input")+d,p="k-state-disabled",m="k-state-default",g="k-state-invalid",v="disabled",_="readonly",b="change",w="dMyHhmftsz",y=l.extend({init:function(t,n){var i,o,s=this;l.fn.init.call(s,t,n),t=s.element,n=s.options,n.format=r._extractFormat(n.format||r.getCulture(n.culture).calendars.standard.patterns.d),n.min=r.parseDate(t.attr("min"))||r.parseDate(n.min),n.max=r.parseDate(t.attr("max"))||r.parseDate(n.max),i=(t.parent().attr("class")||"").indexOf("k-picker-wrap")>=0,i?s.wrapper=t.parent():(s.wrapper=t.wrap("<span class='k-widget k-dateinput'></span>").parent(),s.wrapper.addClass(t[0].className),s.wrapper[0].style.cssText=t[0].style.cssText,t.css({width:"100%",height:t[0].style.height})),e("<span class='k-icon k-i-warning'></span>").insertAfter(t),s._form(),s.element.addClass(i?" ":"k-textbox").attr("autocomplete","off").on("focusout"+d,function(){s._change()});try{t[0].setAttribute("type","text")}catch(a){t[0].type="text"}o=t.is("[disabled]")||e(s.element).parents("fieldset").is(":disabled"),o?s.enable(!1):s.readonly(t.is("[readonly]")),s.value(s.options.value||t.val()),r.notify(s)},options:{name:"DateInput",culture:"",value:"",format:"",min:new Date(1900,0,1),max:new Date(2099,11,31),messages:{year:"year",month:"month",day:"day",weekday:"day of the week",hour:"hours",minute:"minutes",second:"seconds",dayperiod:"AM/PM"}},events:[b],min:function(e){return e===t?this.options.min:(this.options.min=e,t)},max:function(e){return e===t?this.options.max:(this.options.max=e,t)},setOptions:function(e){var t=this;l.fn.setOptions.call(t,e),this._unbindInput(),this._bindInput(),this._updateElementValue()},destroy:function(){var e=this;e.element.off(d),e._formElement&&e._formElement.off("reset",e._resetHandler),l.fn.destroy.call(e)},value:function(e){return e===t?this._dateTime.getDateObject():(null===e&&(e=""),"[object Date]"!==h.call(e)&&(e=r.parseDate(e,this.options.format,this.options.culture)),e&&!e.getTime()&&(e=null),this._dateTime=new i(e,this.options.format,this.options.culture,this.options.messages),this._updateElementValue(),this._oldValue=e,t)},_updateElementValue:function(){var e=this._dateTime.toPair(this.options.format,this.options.culture,this.options.messages);this.element.val(e[0]),this._oldText=e[0],this._format=e[1]},readonly:function(e){this._editable({readonly:e===t||e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t||e)})},_bindInput:function(){var e=this;e.element.on("paste"+d,u(e._paste,e)).on("keydown"+d,u(e._keydown,e)).on(f,u(e._input,e)).on("mouseup"+d,u(e._mouseUp,e)).on("DOMMouseScroll"+d+" mousewheel"+d,u(e._scroll,e))},_unbindInput:function(){this.element.off("keydown"+d).off("paste"+d).off(f).off("mouseup"+d).off("DOMMouseScroll"+d+" mousewheel"+d)},_editable:function(e){var t=this,n=t.element,i=e.disable,o=e.readonly,r=t.wrapper;t._unbindInput(),o||i?(i&&(r.addClass(p).removeClass(m),n.attr(v,i),n.removeAttr(_)),o&&n.attr(_,o)):(r.addClass(m).removeClass(p),n.removeAttr(v).removeAttr(_),t._bindInput())},_change:function(){var e=this,t=e._oldValue,n=e.value();n&&e.min()&&n<e.min()&&(e.value(e.min()),n=e.value()),n&&e.max()&&n>e.max()&&(e.value(e.max()),n=e.value()),(t&&n&&n.getTime()!==t.getTime()||t&&!n||!t&&n)&&(e._oldValue=n,e.trigger(b),e.element.trigger(b))},_input:function(){var e,t,i,o,a,l,c,d=this,u=d.element[0],h=!1;if(r._activeElement()===u){if(e=n(this._oldText,this._format,this.element[0].value,s(this.element[0])[0]),t=1===e.length&&" "===e[0][1],!t)for(i=0;i<e.length;i++)o=this._dateTime.parsePart(e[i][0],e[i][1]),h=h||!o;this._updateElementValue(),e.length&&" "!==e[0][0]&&(this._selectSegment(e[0][0]),t||(a=e[0][0],setTimeout(function(){d._selectSegment(a)}))),t&&(l={keyCode:39,preventDefault:function(){}},this._keydown(l)),h&&(clearTimeout(d._blinkInvalidTimeout),c=g,d.wrapper.addClass(g),d._blinkInvalidTimeout=setTimeout(function(){d.wrapper.removeClass(c)},100))}},_mouseUp:function(){var e=s(this.element[0]);e[0]===e[1]&&this._selectNearestSegment()},_scroll:function(e){if(r._activeElement()===this.element[0]&&!this.element.is("[readonly]")){e=window.event||e;var t={keyCode:37,preventDefault:function(){}};t.keyCode=e.shiftKey?(e.wheelDelta||-e.detail)>0?37:39:(e.wheelDelta||-e.detail)>0?38:40,this._keydown(t),e.returnValue=!1,e.preventDefault&&e.preventDefault(),e.stopPropagation&&e.stopPropagation()}},_form:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){setTimeout(function(){t.value(n[0].value)})},t._formElement=o.on("reset",t._resetHandler))},_paste:function(e){e.preventDefault()},_keydown:function(e){var t,n,i,o,a,l,d=e.keyCode;if(37==d||39==d)for(e.preventDefault(),t=s(this.element[0]),t[0]!=t[1]&&this._selectNearestSegment(),n=37==d?-1:1,i=n==-1?s(this.element[0])[0]-1:s(this.element[0])[1]+1;i>=0&&i<this._format.length;){if(w.indexOf(this._format[i])>=0){this._selectSegment(this._format[i]);break}i+=n}38!=d&&40!=d||(e.preventDefault(),t=s(this.element[0]),o=this._format[t[0]],w.indexOf(o)>=0&&(this._dateTime.modifyPart(o,38==d?1:-1),this._updateElementValue(),this._selectSegment(o))),r.support.browser.msie&&r.support.browser.version<10&&(a=e.keyCode?e.keyCode:e.which,8!==a&&46!==a||(l=this,setTimeout(function(){l._input()},0))),d===c.ENTER&&this._change()},_selectNearestSegment:function(){var e,n,i=s(this.element[0]),o=i[0];for(e=o,n=o-1;e<this._format.length||n>=0;e++,n--){if(e<this._format.length&&w.indexOf(this._format[e])!==-1)return this._selectSegment(this._format[e]),t;if(n>=0&&w.indexOf(this._format[n])!==-1)return this._selectSegment(this._format[n]),t}},_selectSegment:function(e){var t,n=-1,i=0;for(t=0;t<this._format.length;t++)this._format[t]===e&&(i=t+1,n===-1&&(n=t));n<0&&(n=0),s(this.element,n,i)}});a.plugin(y),i=function(e,n,i,o){function s(e,t,n){return e+="",t=t||2,n=t-e.length,n?k[t].substring(0,n)+e:e}function a(e){return D=e,A}function l(e,t){switch(e){case"y":h=t;break;case"M":f=t,t||(u.setMonth(0),b="");break;case"d":p=t;break;case"H":case"h":m=t,t||(w="");break;case"m":g=t;break;case"s":v=t;break;default:return}}var c,d,u=null,h=!0,f=!0,p=!0,m=!0,g=!0,v=!0,_=!0,b="",w="",y={},k=["","0","00","000","0000"],x=/dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g,C=null,S=null,T=null,D=!1,A=function(e){var n,i,o,r,a;switch(e){case"d":o=p?u.getDate():y.day;break;case"dd":o=p?s(u.getDate()):y.day;break;case"ddd":o=p&&f&&h?T.namesAbbr[u.getDay()]:y.weekday;break;case"dddd":o=p&&f&&h?T.names[u.getDay()]:y.weekday;break;case"M":o=f?u.getMonth()+1:y.month;break;case"MM":o=f?s(u.getMonth()+1):y.month;break;case"MMM":o=f?C.namesAbbr[u.getMonth()]:y.month;break;case"MMMM":o=f?C.names[u.getMonth()]:y.month;break;case"yy":o=h?s(u.getFullYear()%100):y.year;break;case"yyyy":o=h?s(u.getFullYear(),4):y.year;break;case"h":o=m?u.getHours()%12||12:y.hour;break;case"hh":o=m?s(u.getHours()%12||12):y.hour;break;case"H":o=m?u.getHours():y.hour;break;case"HH":o=m?s(u.getHours()):y.hour;break;case"m":o=g?u.getMinutes():y.minute;break;case"mm":o=g?s(u.getMinutes()):y.minute;break;case"s":o=v?u.getSeconds():y.second;break;case"ss":o=v?s(u.getSeconds()):y.second;break;case"f":o=_?Math.floor(u.getMilliseconds()/100):_;break;case"ff":o=u.getMilliseconds(),o>99&&(o=Math.floor(o/10)),o=_?s(o):e;break;case"fff":o=_?s(u.getMilliseconds(),3):e;break;case"tt":o=m?u.getHours()<12?S.AM[0]:S.PM[0]:y.dayperiod;break;case"zzz":n=u.getTimezoneOffset(),i=n<0,o=(""+Math.abs(n/60)).split(".")[0],n=Math.abs(n)-60*o,o=(i?"+":"-")+s(o),o+=":"+s(n);break;case"z":case"zz":o=u.getTimezoneOffset()/60,i=o<0,o=(""+Math.abs(o)).split(".")[0],o=(i?"+":"-")+("zz"===e?s(o):o)}if(o=o!==t?o:e.slice(1,e.length-1),D){for(o=""+o,r="","ddd"==e&&(e="EEE"),"dddd"==e&&(e="EEEE"),a=0;a<o.length;a++)r+=e[0];return r}return o};if(this.setValue=function(e){p=e},this.getValue=function(){return p},this.modifyPart=function(e,t){var n,i=new Date(u&&u.getTime?u.getTime():u);switch(e){case"y":i.setFullYear(i.getFullYear()+t);break;case"M":n=i.getMonth()+t,i.setMonth(n),i.getMonth()%12!==(n+12)%12&&(i.setDate(1),i.setMonth(n));break;case"d":case"E":i.setDate(i.getDate()+t);break;case"H":case"h":i.setHours(i.getHours()+t);break;case"m":i.setMinutes(i.getMinutes()+t);break;case"s":i.setSeconds(i.getSeconds()+t);break;case"t":i.setHours((i.getHours()+12)%24)}i.getFullYear()>0&&(l(e,!0),u=i)},this.parsePart=function(e,t){var n,i,o,r,s,a,c,d,_;if(!t)return l(e,!1),!0;switch(n=new Date(u&&u.getTime?u.getTime():u),e){case"d":if(o=(p?10*n.getDate():0)+parseInt(t,10),isNaN(o))return;for(;o>31;)o=parseInt((""+o).slice(1),10);if(o<1)p=!1;else{if(n.setDate(o),n.getMonth()!==u.getMonth())return;p=!0}break;case"M":if(r=(f?10*(n.getMonth()+1):0)+parseInt(t,10),isNaN(r)){for(s=S.months.names,b+=t.toLowerCase();b.length>0;){for(a=0;a<s.length;a++)if(0===s[a].toLowerCase().indexOf(b))return n.setMonth(a),f=!0,u=n,!0;b=b.substring(1,b.length)}return!1}for(;r>12;)r=parseInt((""+r).slice(1),10);r<1?f=!1:(n.setMonth(r-1),n.getMonth()!==r-1&&(n.setDate(1),n.setMonth(r-1)),f=!0);break;case"y":if(c=(h?10*n.getFullYear():0)+parseInt(t,10),isNaN(c))return;for(;c>9999;)c=parseInt((""+c).slice(1),10);c<1?h=!1:(n.setFullYear(c),h=!0);break;case"h":if(i=(m?10*(n.getHours()%12||12):0)+parseInt(t,10),isNaN(i))return;for(;i>12;)i=parseInt((""+i).slice(1),10);n.setHours(12*Math.floor(n.getHours()/12)+i%12),m=!0;break;case"H":if(i=(m?10*n.getHours():0)+parseInt(t,10),isNaN(i))return;for(;i>23;)i=parseInt((""+i).slice(1),10);n.setHours(i),m=!0;break;case"m":if(d=(g?10*n.getMinutes():0)+parseInt(t,10),isNaN(d))return;for(;d>59;)d=parseInt((""+d).slice(1),10);n.setMinutes(d),g=!0;break;case"s":if(_=(v?10*n.getSeconds():0)+parseInt(t,10),isNaN(_))return;for(;_>59;)_=parseInt((""+_).slice(1),10);n.setSeconds(_),v=!0;break;case"t":if(m){for(w+=t.toLowerCase();w.length>0;){if(0===S.AM[0].toLowerCase().indexOf(w)&&n.getHours()>=12||0===S.PM[0].toLowerCase().indexOf(w)&&n.getHours()<12)return n.setHours((n.getHours()+12)%24),u=n,!0;w=w.substring(1,w.length)}return!1}}return u=n,!0},this.toPair=function(e,t,n){return e?(t=r.getCulture(t),S=t.calendars.standard,e=S.patterns[e]||e,T=S.days,C=S.months,y=n,[e.replace(x,a(!1)),e.replace(x,a(!0))]):["",""]},this.getDateObject=function(){return h&&f&&p&&m&&g&&v&&_?new Date(u.getTime()):null},e)u=new Date(e.getTime());else for(u=new Date,c=this.toPair(n,i,o)[1],d=0;d<c.length;d++)l(c[d],!1)}}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.datepicker.min",["kendo.calendar.min","kendo.popup.min","kendo.dateinput.min"],e)}(function(){return function(e,t){function n(t){var n=t.parseFormats,i=t.format;L.normalize(t),n=e.isArray(n)?n:[n],n.length||n.push("yyyy-MM-dd"),e.inArray(i,n)===-1&&n.splice(0,0,t.format),t.parseFormats=n}function i(e){e.preventDefault()}var o,r=window.kendo,s=r.ui,a=s.Widget,l=r.parseDate,c=r.keys,d=r.support,u=r.template,h=r._activeElement,f="<div />",p="<span />",m=".kendoDatePicker",g="click"+m,v=d.mouseAndTouchPresent?r.applyEventMap("up",m.slice(1)):g,_="open",b="close",w="change",y="disabled",k="readonly",x="k-state-default",C="k-state-focused",S="k-state-selected",T="k-state-disabled",D="k-state-hover",A="mouseenter"+m+" mouseleave"+m,E="mousedown"+m,I="id",M="min",R="max",F="month",z="aria-disabled",P="aria-expanded",B="aria-hidden",L=r.calendar,H=L.isInRange,N=L.restrictValue,O=L.isEqualDatePart,V=e.extend,U=e.proxy,W=Date,j=function(t){var n,i=this,o=document.body,a=e(f).attr(B,"true").addClass("k-calendar-container").appendTo(o);i.options=t=t||{},n=t.id,n&&(n+="_dateview",a.attr(I,n),i._dateViewID=n),i.popup=new s.Popup(a,V(t.popup,t,{name:"Popup",isRtl:r.support.isRtl(t.anchor)})),i.div=a,i.value(t.value)};j.prototype={_calendar:function(){var t,n=this,o=n.calendar,a=n.options;o||(t=e(f).attr(I,r.guid()).appendTo(n.popup.element).on(E,i).on(g,"td:has(.k-link)",U(n._click,n)),n.calendar=o=new s.Calendar(t),n._setOptions(a),r.calendar.makeUnselectable(o.element),o.navigate(n._value||n._current,a.start),n.value(n._value))},_setOptions:function(e){this.calendar.setOptions({focusOnNav:!1,change:e.change,culture:e.culture,dates:e.dates,depth:e.depth,footer:e.footer,format:e.format,max:e.max,min:e.min,month:e.month,weekNumber:e.weekNumber,start:e.start,disableDates:e.disableDates})},setOptions:function(e){var t=this.options,n=e.disableDates;n&&(e.disableDates=L.disabled(n)),this.options=V(t,e,{change:t.change,close:t.close,open:t.open}),this.calendar&&this._setOptions(this.options)},destroy:function(){this.popup.destroy()},open:function(){var e=this;e._calendar(),e.popup.open()},close:function(){this.popup.close()},min:function(e){this._option(M,e)},max:function(e){this._option(R,e)},toggle:function(){var e=this;e[e.popup.visible()?b:_]()},move:function(e){var t=this,n=e.keyCode,i=t.calendar,o=e.ctrlKey&&n==c.DOWN||n==c.ENTER,r=!1;if(e.altKey)n==c.DOWN?(t.open(),e.preventDefault(),r=!0):n==c.UP&&(t.close(),e.preventDefault(),r=!0);else if(t.popup.visible()){if(n==c.ESC||o&&i._cell.hasClass(S))return t.close(),e.preventDefault(),!0;n!=c.SPACEBAR&&(t._current=i._move(e)),r=!0}return r},current:function(e){this._current=e,this.calendar._focus(e)},value:function(e){var t=this,n=t.calendar,i=t.options,o=i.disableDates;o&&o(e)&&(e=null),t._value=e,t._current=new W((+N(e,i.min,i.max))),n&&n.value(e)},_click:function(e){e.currentTarget.className.indexOf(S)!==-1&&this.close()},_option:function(e,t){var n=this,i=n.calendar;n.options[e]=t,i&&i[e](t)}},j.normalize=n,r.DateView=j,o=a.extend({init:function(t,i){var o,c,d=this;a.fn.init.call(d,t,i),t=d.element,i=d.options,i.disableDates=r.calendar.disabled(i.disableDates),i.min=l(t.attr("min"))||l(i.min),i.max=l(t.attr("max"))||l(i.max),n(i),d._initialOptions=V({},i),d._wrapper(),d.dateView=new j(V({},i,{id:t.attr(I),anchor:d.wrapper,change:function(){d._change(this.value()),d.close()},close:function(e){d.trigger(b)?e.preventDefault():(t.attr(P,!1),c.attr(B,!0))},open:function(e){var n,i=d.options;d.trigger(_)?e.preventDefault():(d.element.val()!==d._oldText&&(n=l(t.val(),i.parseFormats,i.culture),d.dateView[n?"current":"value"](n)),t.attr(P,!0),c.attr(B,!1),d._updateARIA(n))}})),c=d.dateView.div,d._icon();try{
t[0].setAttribute("type","text")}catch(u){t[0].type="text"}t.addClass("k-input").attr({role:"combobox","aria-expanded":!1,"aria-owns":d.dateView._dateViewID}),d._reset(),d._template(),o=t.is("[disabled]")||e(d.element).parents("fieldset").is(":disabled"),o?d.enable(!1):d.readonly(t.is("[readonly]")),i.dateInput&&(d._dateInput=new s.DateInput(t,{culture:i.culture,format:i.format,min:i.min,max:i.max,value:i.value})),d._old=d._update(i.value||d.element.val()),d._oldText=t.val(),r.notify(d)},events:[_,b,w],options:{name:"DatePicker",value:null,footer:"",format:"",culture:"",parseFormats:[],min:new Date(1900,0,1),max:new Date(2099,11,31),start:F,depth:F,animation:{},month:{},dates:[],disableDates:null,ARIATemplate:'Current focused date is #=kendo.toString(data.current, "D")#',dateInput:!1,weekNumber:!1},setOptions:function(e){var t=this,i=t._value;a.fn.setOptions.call(t,e),e=t.options,e.min=l(e.min),e.max=l(e.max),n(e),t.dateView.setOptions(e),t._dateInput&&t._dateInput.setOptions({culture:e.culture,format:e.format,min:e.min,max:e.max,value:e.value}),i&&(t.element.val(r.toString(i,e.format,e.culture)),t._updateARIA(i))},_editable:function(e){var t=this,n=t._dateIcon.off(m),o=t.element.off(m),r=t._inputWrapper.off(m),s=e.readonly,a=e.disable;s||a?(r.addClass(a?T:x).removeClass(a?x:T),o.attr(y,a).attr(k,s).attr(z,a)):(r.addClass(x).removeClass(T).on(A,t._toggleHover),o.removeAttr(y).removeAttr(k).attr(z,!1).on("keydown"+m,U(t._keydown,t)).on("focusout"+m,U(t._blur,t)).on("focus"+m,function(){t._inputWrapper.addClass(C)}),n.on(v,U(t._click,t)).on(E,i))},readonly:function(e){this._editable({readonly:e===t||e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t||e)})},destroy:function(){var e=this;a.fn.destroy.call(e),e.dateView.destroy(),e.element.off(m),e._dateIcon.off(m),e._inputWrapper.off(m),e._form&&e._form.off("reset",e._resetHandler)},open:function(){this.dateView.open()},close:function(){this.dateView.close()},min:function(e){return this._option(M,e)},max:function(e){return this._option(R,e)},value:function(e){var n=this;return e===t?n._value:(n._old=n._update(e),null===n._old&&n.element.val(""),n._oldText=n.element.val(),t)},_toggleHover:function(t){e(t.currentTarget).toggleClass(D,"mouseenter"===t.type)},_blur:function(){var e=this,t=e.element.val();e.close(),t!==e._oldText&&e._change(t),e._inputWrapper.removeClass(C)},_click:function(e){var t=this;t.dateView.toggle(),t._focusElement(e.type)},_focusElement:function(e){var t=this.element;d.touch&&(!d.mouseAndTouchPresent||(e||"").match(/touch/i))||t[0]===h()||t.focus()},_change:function(e){var t,n,i,o=this,s=o.element.val();e=o._update(e),t=!r.calendar.isEqualDate(o._old,e),n=t&&!o._typing,i=s!==o.element.val(),(n||i)&&o.element.trigger(w),t&&(o._old=e,o._oldText=o.element.val(),o.trigger(w)),o._typing=!1},_keydown:function(e){var t=this,n=t.dateView,i=t.element.val(),o=!1;n.popup.visible()||e.keyCode!=c.ENTER||i===t._oldText?(o=n.move(e),t._updateARIA(n._current),o?t._dateInput&&e.stopImmediatePropagation&&e.stopImmediatePropagation():t._typing=!0):t._change(i)},_icon:function(){var t,n=this,i=n.element;t=i.next("span.k-select"),t[0]||(t=e('<span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-calendar"></span></span>').insertAfter(i)),n._dateIcon=t.attr({role:"button","aria-controls":n.dateView._dateViewID})},_option:function(e,n){var i=this,o=i.options;return n===t?o[e]:(n=l(n,o.parseFormats,o.culture),n&&(o[e]=new W((+n)),i.dateView[e](n)),t)},_update:function(e){var t,n=this,i=n.options,o=i.min,s=i.max,a=n._value,c=l(e,i.parseFormats,i.culture),d=null===c&&null===a||c instanceof Date&&a instanceof Date;return i.disableDates(c)&&(c=null,n._old||n.element.val()||(e=null)),+c===+a&&d?(t=r.toString(c,i.format,i.culture),t!==e&&n.element.val(null===c?e:t),c):(null!==c&&O(c,o)?c=N(c,o,s):H(c,o,s)||(c=null),n._value=c,n.dateView.value(c),n._dateInput&&c?n._dateInput.value(c||e):n.element.val(r.toString(c||e,i.format,i.culture)),n._updateARIA(c),c)},_wrapper:function(){var t,n=this,i=n.element;t=i.parents(".k-datepicker"),t[0]||(t=i.wrap(p).parent().addClass("k-picker-wrap k-state-default"),t=t.wrap(p).parent()),t[0].style.cssText=i[0].style.cssText,i.css({width:"100%",height:i[0].style.height}),n.wrapper=t.addClass("k-widget k-datepicker k-header").addClass(i[0].className),n._inputWrapper=e(t[0].firstChild)},_reset:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){t.value(n[0].defaultValue),t.max(t._initialOptions.max),t.min(t._initialOptions.min)},t._form=o.on("reset",t._resetHandler))},_template:function(){this._ariaTemplate=u(this.options.ARIATemplate)},_updateARIA:function(e){var t,n=this,i=n.dateView.calendar;n.element.removeAttr("aria-activedescendant"),i&&(t=i._cell,t.attr("aria-label",n._ariaTemplate({current:e||i.current()})),n.element.attr("aria-activedescendant",t.attr("id")))}}),s.plugin(o)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.virtuallist.min",["kendo.data.min"],e)}(function(){return function(e,t){function n(e){return e[e.length-1]}function i(e){return e instanceof Array?e:[e]}function o(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e}function r(e,t,n){return Math.ceil(e*t/n)}function s(e,t,n){var i=document.createElement(n||"div");return t&&(i.className=t),e.appendChild(i),i}function a(){var t,n=e('<div class="k-popup"><ul class="k-list"><li class="k-item"><li></ul></div>');return n.css({position:"absolute",left:"-200000px",visibility:"hidden"}),n.appendTo(document.body),t=parseFloat(_.getComputedStyles(n.find(".k-item")[0],["line-height"])["line-height"]),n.remove(),t}function l(e,t,n){return{down:e*n,up:e*(t-1-n)}}function c(e,t){var n=(e.listScreens-1-e.threshold)*t,i=e.threshold*t;return function(e,t,o){return t>o?t-e.top<n:0===e.top||t-e.top>i}}function d(e,t){return function(n){return t(e.scrollTop,n)}}function u(e){return function(t,n){return e(t.items,t.index,n),t}}function h(e,t){_.support.browser.msie&&_.support.browser.version<10?e.style.top=t+"px":(e.style.webkitTransform="translateY("+t+"px)",e.style.transform="translateY("+t+"px)")}function f(t,n){return function(i,o){for(var r=0,s=i.length;r<s;r++)t(i[r],o[r],n),o[r].item&&this.trigger(H,{item:e(i[r]),data:o[r].item,ns:_.ui})}}function p(e,t){var n;return t>0?(n=e.splice(0,t),e.push.apply(e,n)):(n=e.splice(t,-t),e.unshift.apply(e,n)),n}function m(n,i,o){var r=o.template;n=e(n),i.item||(r=o.placeholderTemplate),0===i.index&&this.header&&i.group&&this.header.html(o.fixedGroupTemplate(i.group)),this.angular("cleanup",function(){return{elements:[n]}}),n.attr("data-uid",i.item?i.item.uid:"").attr("data-offset-index",i.index).html(r(i.item||{})),n.toggleClass(F,i.current),n.toggleClass(R,i.selected),n.toggleClass("k-first",i.newGroup),n.toggleClass("k-loading-item",!i.item),0!==i.index&&i.newGroup&&e("<div class="+M+"></div>").appendTo(n).html(o.groupTemplate(i.group)),i.top!==t&&h(n[0],i.top),this.angular("compile",function(){return{elements:[n],data:[{dataItem:i.item,group:i.group,newGroup:i.newGroup}]}})}function g(e,t){var n,i,o,r,s=t.length,a=e.length,l=[],c=[];if(a)for(o=0;o<a;o++){for(n=e[o],i=!1,r=0;r<s;r++)if(n===t[r]){i=!0,l.push({index:o,item:n});break}i||c.push(n)}return{changed:l,unchanged:c}}function v(e){return e&&"resolved"!==e.state()}var _=window.kendo,b=_.ui,w=b.Widget,y=b.DataBoundWidget,k=e.proxy,x="k-virtual-wrap",C="k-virtual-list",S="k-virtual-content",T="k-list",D="k-group-header",A="k-virtual-item",E="k-item",I="k-height-container",M="k-group",R="k-state-selected",F="k-state-focused",z="k-state-hover",P="change",B="click",L="listBound",H="itemChange",N="activate",O="deactivate",V=".VirtualList",U=y.extend({init:function(t,n){var o=this;o.bound(!1),o._fetching=!1,w.fn.init.call(o,t,n),o.options.itemHeight||(o.options.itemHeight=a()),n=o.options,o.element.addClass(T+" "+C).attr("role","listbox"),o.content=o.element.wrap("<div unselectable='on' class='"+S+"'></div>").parent(),o.wrapper=o.content.wrap("<div class='"+x+"'></div>").parent(),o.header=o.content.before("<div class='"+D+"'></div>").prev(),o.element.on("mouseenter"+V,"li:not(.k-loading-item)",function(){e(this).addClass(z)}).on("mouseleave"+V,"li",function(){e(this).removeClass(z)}),o._values=i(o.options.value),o._selectedDataItems=[],o._selectedIndexes=[],o._rangesList={},o._promisesList=[],o._optionID=_.guid(),o._templates(),o.setDataSource(n.dataSource),o.content.on("scroll"+V,_.throttle(function(){o._renderItems(),o._triggerListBound()},n.delay)),o._selectable()},options:{name:"VirtualList",autoBind:!0,delay:100,height:null,listScreens:4,threshold:.5,itemHeight:null,oppositeBuffer:1,type:"flat",selectable:!1,value:[],dataValueField:null,template:"#:data#",placeholderTemplate:"loading...",groupTemplate:"#:data#",fixedGroupTemplate:"#:data#",mapValueTo:"index",valueMapper:null},events:[P,B,L,H,N,O],setOptions:function(e){w.fn.setOptions.call(this,e),this._selectProxy&&this.options.selectable===!1?this.element.off(B,"."+A,this._selectProxy):!this._selectProxy&&this.options.selectable&&this._selectable(),this._templates(),this.refresh()},items:function(){return e(this._items)},destroy:function(){this.wrapper.off(V),this.dataSource.unbind(P,this._refreshHandler),w.fn.destroy.call(this)},setDataSource:function(t){var n,i=this,o=t||{};o=e.isArray(o)?{data:o}:o,o=_.data.DataSource.create(o),i.dataSource?(i.dataSource.unbind(P,i._refreshHandler),i._clean(),i.bound(!1),i._deferValueSet=!0,n=i.value(),i.value([]),i.mute(function(){i.value(n)})):i._refreshHandler=e.proxy(i.refresh,i),i.dataSource=o.bind(P,i._refreshHandler),i.setDSFilter(o.filter()),0!==o.view().length?i.refresh():i.options.autoBind&&o.fetch()},skip:function(){return this.dataSource.currentRangeStart()},_triggerListBound:function(){var e=this,t=e.skip();e.bound()&&!e._selectingValue&&e._skip!==t&&(e._skip=t,e.trigger(L))},_getValues:function(t){var n=this._valueGetter;return e.map(t,function(e){return n(e)})},refresh:function(e){var t,n=this,i=e&&e.action,o="itemchange"===i,r=this.isFiltered();n._mute||(n._deferValueSet=!1,n._fetching?(n._renderItems&&n._renderItems(!0),n._triggerListBound()):(r&&n.focus(0),n._createList(),i||!n._values.length||r||n.options.skipUpdateOnBind?(n.bound(!0),n._triggerListBound()):(n._selectingValue=!0,n.value(n._values,!0).done(function(){n.bound(!0),n._selectingValue=!1,n._triggerListBound()}))),(o||"remove"===i)&&(t=g(n._selectedDataItems,e.items),t.changed.length&&(o?n.trigger("selectedItemChange",{items:t.changed}):n.value(n._getValues(t.unchanged)))),n._fetching=!1)},removeAt:function(e){return this._selectedIndexes.splice(e,1),this._values.splice(e,1),{position:e,dataItem:this._selectedDataItems.splice(e,1)[0]}},setValue:function(e){this._values=i(e)},value:function(n,o){var r,s=this;return n===t?s._values.slice():(null===n&&(n=[]),n=i(n),s._valueDeferred&&"resolved"!==s._valueDeferred.state()||(s._valueDeferred=e.Deferred()),r="multiple"===s.options.selectable&&s.select().length&&n.length,!r&&n.length||s.select(-1),s._values=n,(s.bound()&&!s._mute&&!s._deferValueSet||o)&&s._prefetchByValue(n),s._valueDeferred)},_prefetchByValue:function(e){var n,i,r,s=this,a=s._dataView,l=s._valueGetter,c=s.options.mapValueTo,d=!1,u=[];for(i=0;i<e.length;i++)for(r=0;r<a.length;r++)n=a[r].item,n&&(d=o(n)?e[i]===n:e[i]===l(n),d&&u.push(a[r].index));return u.length===e.length?(s._values=[],s.select(u),t):("function"==typeof s.options.valueMapper?s.options.valueMapper({value:"multiple"===this.options.selectable?e:e[0],success:function(e){"index"===c?s.mapValueToIndex(e):"dataItem"===c&&s.mapValueToDataItem(e)}}):s.select([-1]),t)},mapValueToIndex:function(e){if(e=e===t||e===-1||null===e?[]:i(e),e.length){var n=this._deselect([]).removed;n.length&&this._triggerChange(n,[])}else e=[-1];this.select(e)},mapValueToDataItem:function(n){var o,r,s,a;if(n=n===t||null===n?[]:i(n),n.length){for(o=e.map(this._selectedDataItems,function(e,t){return{index:t,dataItem:e}}),r=e.map(n,function(e,t){return{index:t,dataItem:e}}),this._selectedDataItems=n,this._selectedIndexes=[],s=0;s<this._selectedDataItems.length;s++)a=this._getElementByDataItem(this._selectedDataItems[s]),this._selectedIndexes.push(this._getIndecies(a)[0]),a.addClass(R);this._triggerChange(o,r),this._valueDeferred&&this._valueDeferred.resolve()}else this.select([-1])},deferredRange:function(t){var n=this.dataSource,i=this.itemCount,o=this._rangesList,r=e.Deferred(),s=[],a=Math.floor(t/i)*i,l=Math.ceil(t/i)*i,c=l===a?[l]:[a,l];return e.each(c,function(t,r){var a,l=r+i,c=o[r];c&&c.end===l?a=c.deferred:(a=e.Deferred(),o[r]={end:l,deferred:a},n._multiplePrefetch(r,i,function(){a.resolve()})),s.push(a)}),e.when.apply(e,s).then(function(){r.resolve()}),r},prefetch:function(t){var n=this,i=this.itemCount,o=!n._promisesList.length;return v(n._activeDeferred)||(n._activeDeferred=e.Deferred(),n._promisesList=[]),e.each(t,function(e,t){n._promisesList.push(n.deferredRange(n._getSkip(t,i)))}),o&&e.when.apply(e,n._promisesList).done(function(){n._promisesList=[],n._activeDeferred.resolve()}),n._activeDeferred},_findDataItem:function(e,t){var n,i;if("group"===this.options.type)for(i=0;i<e.length;i++){if(n=e[i].items,!(n.length<=t))return n[t];t-=n.length}return e[t]},_getRange:function(e,t){return this.dataSource._findRange(e,Math.min(e+t,this.dataSource.total()))},dataItemByIndex:function(e){var t=this,n=t.itemCount,i=t._getSkip(e,n);return t._getRange(i,n).length?(t.mute(function(){t.dataSource.range(i,n)}),t._findDataItem(t.dataSource.view(),[e-i])):null},selectedDataItems:function(){return this._selectedDataItems.slice()},scrollWith:function(e){this.content.scrollTop(this.content.scrollTop()+e)},scrollTo:function(e){this.content.scrollTop(e)},scrollToIndex:function(e){this.scrollTo(e*this.options.itemHeight)},focus:function(i){var o,r,s,a,l,c,d=this.options.itemHeight,u=this._optionID,h=!0;if(i===t)return a=this.element.find("."+F),a.length?a:null;if("function"==typeof i)for(s=this.dataSource.flatView(),l=0;l<s.length;l++)if(i(s[l])){i=l;break}return i instanceof Array&&(i=n(i)),isNaN(i)?(o=e(i),r=parseInt(e(o).attr("data-offset-index"),10)):(r=i,o=this._getElementByIndex(r)),r===-1?(this.element.find("."+F).removeClass(F),this._focusedIndex=t,t):(o.length?(o.hasClass(F)&&(h=!1),this._focusedIndex!==t&&(a=this._getElementByIndex(this._focusedIndex),a.removeClass(F).removeAttr("id"),h&&this.trigger(O)),this._focusedIndex=r,o.addClass(F).attr("id",u),c=this._getElementLocation(r),"top"===c?this.scrollTo(r*d):"bottom"===c?this.scrollTo(r*d+d-this._screenHeight):"outScreen"===c&&this.scrollTo(r*d),h&&this.trigger(N)):(this._focusedIndex=r,this.items().removeClass(F),this.scrollToIndex(r)),t)},focusIndex:function(){return this._focusedIndex},focusFirst:function(){this.scrollTo(0),this.focus(0)},focusLast:function(){var e=this.dataSource.total();this.scrollTo(this.heightContainer.offsetHeight),this.focus(e)},focusPrev:function(){var e,t=this._focusedIndex;return!isNaN(t)&&t>0?(t-=1,this.focus(t),e=this.focus(),e&&e.hasClass("k-loading-item")&&(t+=1,this.focus(t)),t):(t=this.dataSource.total()-1,this.focus(t),t)},focusNext:function(){var e,t=this._focusedIndex,n=this.dataSource.total()-1;return!isNaN(t)&&t<n?(t+=1,this.focus(t),e=this.focus(),e&&e.hasClass("k-loading-item")&&(t-=1,this.focus(t)),t):(t=0,this.focus(t),t)},_triggerChange:function(e,t){e=e||[],t=t||[],(e.length||t.length)&&this.trigger(P,{removed:e,added:t})},select:function(i){var o,r,s,a,l,c=this,d="multiple"!==c.options.selectable,u=v(c._activeDeferred),h=this.isFiltered(),f=[];return i===t?c._selectedIndexes.slice():(c._selectDeferred&&"resolved"!==c._selectDeferred.state()||(c._selectDeferred=e.Deferred()),o=c._getIndecies(i),r=d&&!h&&n(o)===n(this._selectedIndexes),f=c._deselectCurrentValues(o),f.length||!o.length||r?(c._triggerChange(f),c._valueDeferred&&c._valueDeferred.resolve(),c._selectDeferred.resolve().promise()):(1===o.length&&o[0]===-1&&(o=[]),a=c._deselect(o),f=a.removed,o=a.indices,d&&(u=!1,o.length&&(o=[n(o)])),l=function(){var e=c._select(o);c.focus(o),c._triggerChange(f,e),c._valueDeferred&&c._valueDeferred.resolve(),c._selectDeferred.resolve()},s=c.prefetch(o),u||(s?s.done(l):l()),c._selectDeferred.promise()))},bound:function(e){return e===t?this._listCreated:(this._listCreated=e,t)},mute:function(e){this._mute=!0,k(e(),this),this._mute=!1},setDSFilter:function(t){this._lastDSFilter=e.extend({},t)},isFiltered:function(){return this._lastDSFilter||this.setDSFilter(this.dataSource.filter()),!_.data.Query.compareFilters(this.dataSource.filter(),this._lastDSFilter)},skipUpdate:e.noop,_getElementByIndex:function(t){return this.items().filter(function(n,i){return t===parseInt(e(i).attr("data-offset-index"),10)})},_getElementByDataItem:function(t){var n,i,r,s=this._dataView,a=this._valueGetter;for(r=0;r<s.length;r++)if(i=s[r].item&&o(s[r].item)?s[r].item===t:s[r].item&&t&&a(s[r].item)==a(t)){n=s[r];break}return n?this._getElementByIndex(n.index):e()},_clean:function(){this.result=t,this._lastScrollTop=t,this._skip=t,e(this.heightContainer).remove(),this.heightContainer=t,this.element.empty()},_height:function(){var e=!!this.dataSource.view().length,t=this.options.height,n=this.options.itemHeight,i=this.dataSource.total();return e?t/n>i&&(t=i*n):t=0,t},setScreenHeight:function(){var e=this._height();this.content.height(e),this._screenHeight=e},screenHeight:function(){return this._screenHeight},_getElementLocation:function(e){var t,n=this.content.scrollTop(),i=this._screenHeight,o=this.options.itemHeight,r=e*o,s=r+o,a=n+i;return t=r===n-o||s>n&&r<n?"top":r===a||r<a&&a<s?"bottom":r>=n&&r<=n+(i-o)?"inScreen":"outScreen"},_templates:function(){var e,t=this.options,n={template:t.template,placeholderTemplate:t.placeholderTemplate,groupTemplate:t.groupTemplate,fixedGroupTemplate:t.fixedGroupTemplate};for(e in n)"function"!=typeof n[e]&&(n[e]=_.template(n[e]||""));this.templates=n},_generateItems:function(e,t){for(var n,i=[],o=this.options.itemHeight+"px";t-- >0;)n=document.createElement("li"),n.tabIndex=-1,n.className=A+" "+E,n.setAttribute("role","option"),n.style.height=o,n.style.minHeight=o,e.appendChild(n),i.push(n);return i},_saveInitialRanges:function(){var t,n=this.dataSource._ranges,i=e.Deferred();for(i.resolve(),this._rangesList={},t=0;t<n.length;t++)this._rangesList[n[t].start]={end:n[t].end,deferred:i}},_createList:function(){var t=this,n=t.content.get(0),i=t.options,o=t.dataSource;t.bound()&&t._clean(),t._saveInitialRanges(),t._buildValueGetter(),t.setScreenHeight(),t.itemCount=r(t._screenHeight,i.listScreens,i.itemHeight),t.itemCount>o.total()&&(t.itemCount=o.total()),t._items=t._generateItems(t.element[0],t.itemCount),t._setHeight(i.itemHeight*o.total()),t.options.type=(o.group()||[]).length?"group":"flat","flat"===t.options.type?t.header.hide():t.header.show(),t.getter=t._getter(function(){t._renderItems(!0)}),t._onScroll=function(e,n){var i=t._listItems(t.getter);return t._fixedHeader(e,i(e,n))},t._renderItems=t._whenChanged(d(n,t._onScroll),u(t._reorderList(t._items,e.proxy(m,t)))),t._renderItems(),t._calculateGroupPadding(t._screenHeight)},_setHeight:function(e){var t,n,i=this.heightContainer;if(i?t=i.offsetHeight:i=this.heightContainer=s(this.content[0],I),e!==t)for(i.innerHTML="";e>0;)n=Math.min(e,25e4),s(i).style.height=n+"px",e-=n},_getter:function(){var e=null,t=this.dataSource,n=t.skip(),i=this.options.type,o=this.itemCount,r={};return t.pageSize()<o&&this.mute(function(){t.pageSize(o)}),function(s,a){var l,c,d,u,h,f,p,m,g=this;if(t.inRange(a,o)){if(n!==a&&this.mute(function(){t.range(a,o),n=a}),"group"===i){if(!r[a])for(c=r[a]=[],d=t.view(),u=0,h=d.length;u<h;u++)for(f=d[u],p=0,m=f.items.length;p<m;p++)c.push({item:f.items[p],group:f.value});l=r[a][s-a]}else l=t.view()[s-a];return l}return e!==a&&(e=a,n=a,g._getterDeferred&&g._getterDeferred.reject(),g._getterDeferred=g.deferredRange(a),g._getterDeferred.then(function(){var e=g._indexConstraint(g.content[0].scrollTop);g._getterDeferred=null,a<=e&&e<=a+o&&(g._fetching=!0,t.range(a,o))})),null}},_fixedHeader:function(e,t){var n,i,o=this.currentVisibleGroup,r=this.options.itemHeight,s=Math.floor((e-t.top)/r),a=t.items[s];return a&&a.item&&(n=a.group,n!==o&&(i=n||"",this.header.html(this.templates.fixedGroupTemplate(i)),this.currentVisibleGroup=n)),t},_itemMapper:function(e,t,n){var i,r=this.options.type,s=this.options.itemHeight,a=this._focusedIndex,l=!1,c=!1,d=!1,u=null,h=!1,f=this._valueGetter;if("group"===r&&(e&&(d=0===t||this._currentGroup&&this._currentGroup!==e.group,this._currentGroup=e.group),u=e?e.group:null,e=e?e.item:null),!this.isFiltered()&&n.length&&e)for(i=0;i<n.length;i++)if(h=o(e)?n[i]===e:n[i]===f(e)){n.splice(i,1),l=!0;break}return a===t&&(c=!0),{item:e?e:null,group:u,newGroup:d,selected:l,current:c,index:t,top:t*s}},_range:function(e){var t,n,i,o=this.itemCount,r=this._values.slice(),s=[];for(this._view={},this._currentGroup=null,n=e,i=e+o;n<i;n++)t=this._itemMapper(this.getter(n,e),n,r),s.push(t),this._view[t.index]=t;return this._dataView=s,s},_getDataItemsCollection:function(e,t){var n=this._range(this._listIndex(e,t));return{index:n.length?n[0].index:0,top:n.length?n[0].top:0,items:n}},_listItems:function(){var t=this._screenHeight,n=this.options,i=c(n,t);return e.proxy(function(e,t){var n=this.result,o=this._lastScrollTop;return!t&&n&&i(n,e,o)||(n=this._getDataItemsCollection(e,o)),this._lastScrollTop=e,this.result=n,n},this)},_whenChanged:function(e,t){var n;return function(i){var o=e(i);o!==n&&(n=o,t(o,i))}},_reorderList:function(t,n){var i=this,o=t.length,r=-(1/0);return n=e.proxy(f(n,this.templates),this),function(e,s,a){var l,c,d=s-r;a||Math.abs(d)>=o?(l=t,c=e):(l=p(t,d),c=d>0?e.slice(-d):e.slice(0,-d)),n(l,c,i.bound()),r=s}},_bufferSizes:function(){var e=this.options;return l(this._screenHeight,e.listScreens,e.oppositeBuffer)},_indexConstraint:function(e){var t=this.itemCount,n=this.options.itemHeight,i=this.dataSource.total();return Math.min(Math.max(i-t,0),Math.max(0,Math.floor(e/n)))},_listIndex:function(e,t){var n,i=this._bufferSizes();return n=e-(e>t?i.down:i.up),this._indexConstraint(n)},_selectable:function(){this.options.selectable&&(this._selectProxy=e.proxy(this,"_clickHandler"),this.element.on(B+V,"."+A,this._selectProxy))},getElementIndex:function(e){return e instanceof jQuery?parseInt(e.attr("data-offset-index"),10):t},_getIndecies:function(e){var t,n,i,o=[];if("function"==typeof e)for(t=this.dataSource.flatView(),n=0;n<t.length;n++)if(e(t[n])){o.push(n);break}return"number"==typeof e&&o.push(e),i=this.getElementIndex(e),isNaN(i)||o.push(i),e instanceof Array&&(o=e),o},_deselect:function(n){var i,r,s,a,l,c,d,u=[],h=this._selectedIndexes,f=this._selectedDataItems,p=0,m=this.options.selectable,g=0,v=this._valueGetter,_=null;if(n=n.slice(),m!==!0&&n.length){if("multiple"===m)for(c=0;c<n.length;c++){if(_=null,p=e.inArray(n[c],h),r=this.dataItemByIndex(n[c]),p===-1&&r)for(d=0;d<f.length;d++)a=o(r)?f[d]===r:v(f[d])===v(r),a&&(s=this._getElementByIndex(n[c]),_=this._deselectSingleItem(s,d,n[c],g));else i=h[p],i!==t&&(s=this._getElementByIndex(i),_=this._deselectSingleItem(s,p,i,g));_&&(n.splice(c,1),u.push(_),g++,c--)}}else{for(l=0;l<h.length;l++)h[l]!==t?this._getElementByIndex(h[l]).removeClass(R):f[l]&&this._getElementByDataItem(f[l]).removeClass(R),u.push({index:h[l],position:l,dataItem:f[l]});this._values=[],this._selectedDataItems=[],this._selectedIndexes=[]}return{indices:n,removed:u}},_deselectSingleItem:function(e,t,n,i){var o;if(e.hasClass("k-state-selected"))return e.removeClass(R),this._values.splice(t,1),this._selectedIndexes.splice(t,1),o=this._selectedDataItems.splice(t,1)[0],{index:n,position:t+i,dataItem:o}},_deselectCurrentValues:function(t){var n,i,o,r,s=this.element[0].children,a=this._values,l=[],c=0;if("multiple"!==this.options.selectable||!this.isFiltered())return[];if(t[0]===-1)return e(s).removeClass("k-state-selected"),l=e.map(this._selectedDataItems.slice(0),function(e,t){return{dataItem:e,position:t}}),this._selectedIndexes=[],this._selectedDataItems=[],this._values=[],l;for(;c<t.length;c++){for(o=-1,i=t[c],n=this._valueGetter(this.dataItemByIndex(i)),r=0;r<a.length;r++)if(n==a[r]){o=r;break}o>-1&&(l.push(this.removeAt(o)),e(s[i]).removeClass("k-state-selected"))}return l},_getSkip:function(e,t){var n=e<t?1:Math.floor(e/t)+1;return(n-1)*t},_select:function(t){var n,i,r=this,s="multiple"!==this.options.selectable,a=this.dataSource,l=this.itemCount,c=this._valueGetter,d=[];return s&&(r._selectedIndexes=[],r._selectedDataItems=[],r._values=[]),i=a.skip(),e.each(t,function(e,t){var s=r._getSkip(t,l);r.mute(function(){a.range(s,l),n=r._findDataItem(a.view(),[t-s]),r._selectedIndexes.push(t),r._selectedDataItems.push(n),r._values.push(o(n)?n:c(n)),d.push({index:t,dataItem:n}),r._getElementByIndex(t).addClass(R),a.range(i,l)})}),d},_clickHandler:function(t){var n=e(t.currentTarget);!t.isDefaultPrevented()&&n.attr("data-uid")&&this.trigger(B,{item:n})},_buildValueGetter:function(){this._valueGetter=_.getter(this.options.dataValueField)},_calculateGroupPadding:function(e){var t=this.items().first(),n=this.header,i=0;n[0]&&"none"!==n[0].style.display&&("auto"!==e&&(i=_.support.scrollbar()),i+=parseFloat(t.css("border-right-width"),10)+parseFloat(t.children(".k-group").css("right"),10),n.css("padding-right",i))}});_.ui.VirtualList=U,_.ui.plugin(U)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.autocomplete.min",["kendo.list.min","kendo.mobile.scroller.min","kendo.virtuallist.min"],e)}(function(){return function(e,t){function n(e,t,n){return n?t.substring(0,e).split(n).length-1:0}function i(e,t,i){return t.split(i)[n(e,t,i)]}function o(e,t,i,o,r){var s=t.split(o);return s.splice(n(e,t,o),1,i),o&&""!==s[s.length-1]&&s.push(""),s.join(r)}var r=window.kendo,s=r.support,a=r.caret,l=r._activeElement,c=s.placeholder,d=r.ui,u=d.List,h=r.keys,f=r.data.DataSource,p="aria-disabled",m="aria-readonly",g="change",v="k-state-default",_="disabled",b="readonly",w="k-state-focused",y="k-state-selected",k="k-state-disabled",x="k-state-hover",C=".kendoAutoComplete",S="mouseenter"+C+" mouseleave"+C,T=e.proxy,D=u.extend({init:function(t,n){var i,o,s=this;s.ns=C,n=e.isArray(n)?{dataSource:n}:n,u.fn.init.call(s,t,n),t=s.element,n=s.options,n.placeholder=n.placeholder||t.attr("placeholder"),c&&t.attr("placeholder",n.placeholder),s._wrapper(),s._loader(),s._clearButton(),s._dataSource(),s._ignoreCase(),t[0].type="text",i=s.wrapper,s._popup(),t.addClass("k-input").on("keydown"+C,T(s._keydown,s)).on("keypress"+C,T(s._keypress,s)).on("paste"+C,T(s._search,s)).on("focus"+C,function(){s._prev=s._accessor(),s._oldText=s._prev,s._placeholder(!1),i.addClass(w)}).on("focusout"+C,function(){s._change(),s._placeholder(),s.close(),i.removeClass(w)}).attr({autocomplete:"off",role:"textbox","aria-haspopup":!0}),s._clear.on("click"+C,T(s._clearValue,s)),s._enable(),s._old=s._accessor(),t[0].id&&t.attr("aria-owns",s.ul[0].id),s._aria(),s._placeholder(),s._initList(),o=e(s.element).parents("fieldset").is(":disabled"),o&&s.enable(!1),s.listView.bind("click",function(e){e.preventDefault()}),s._resetFocusItemHandler=e.proxy(s._resetFocusItem,s),r.notify(s),s._toggleCloseVisibility()},options:{name:"AutoComplete",enabled:!0,suggest:!1,template:"",groupTemplate:"#:data#",fixedGroupTemplate:"#:data#",dataTextField:"",minLength:1,enforceMinLength:!1,delay:200,height:200,filter:"startswith",ignoreCase:!0,highlightFirst:!1,separator:null,placeholder:"",animation:{},virtual:!1,value:null,clearButton:!0,autoWidth:!1},_dataSource:function(){var e=this;e.dataSource&&e._refreshHandler?e._unbindDataSource():(e._progressHandler=T(e._showBusy,e),e._errorHandler=T(e._hideBusy,e)),e.dataSource=f.create(e.options.dataSource).bind("progress",e._progressHandler).bind("error",e._errorHandler)},setDataSource:function(e){this.options.dataSource=e,this._dataSource(),this.listView.setDataSource(this.dataSource)},events:["open","close",g,"select","filtering","dataBinding","dataBound"],setOptions:function(e){var t=this._listOptions(e);u.fn.setOptions.call(this,e),this.listView.setOptions(t),this._accessors(),this._aria(),this._clearButton()},_listOptions:function(t){var n=u.fn._listOptions.call(this,e.extend(t,{skipUpdateOnBind:!0}));return n.dataValueField=n.dataTextField,n.selectedItemChange=null,n},_editable:function(e){var t=this,n=t.element,i=t.wrapper.off(C),o=e.readonly,r=e.disable;o||r?(i.addClass(r?k:v).removeClass(r?v:k),n.attr(_,r).attr(b,o).attr(p,r).attr(m,o)):(i.addClass(v).removeClass(k).on(S,t._toggleHover),n.removeAttr(_).removeAttr(b).attr(p,!1).attr(m,!1))},close:function(){var e=this,t=e.listView.focus();t&&t.removeClass(y),e.popup.close()},destroy:function(){var e=this;e.element.off(C),e._clear.off(C),e.wrapper.off(C),u.fn.destroy.call(e)},refresh:function(){this.listView.refresh()},select:function(e){this._select(e)},search:function(t){var n,o=this,r=o.options,s=r.ignoreCase,l=o._separator();t=t||o._accessor(),clearTimeout(o._typingTimeout),l&&(t=i(a(o.element)[0],t,l)),n=t.length,(!r.enforceMinLength&&!n||n>=r.minLength)&&(o._open=!0,o._mute(function(){this.listView.value([])}),o._filterSource({value:s?t.toLowerCase():t,operator:r.filter,field:r.dataTextField,ignoreCase:s}),o.one("close",e.proxy(o._unifySeparators,o))),o._toggleCloseVisibility()},suggest:function(e){var i,o=this,r=o._last,s=o._accessor(),c=o.element[0],d=a(c)[0],f=o._separator(),p=s.split(f),m=n(d,s,f),g=d;return r==h.BACKSPACE||r==h.DELETE?(o._last=t,t):(e=e||"","string"!=typeof e&&(e[0]&&(e=o.dataSource.view()[u.inArray(e[0],o.ul[0])]),e=e?o._text(e):""),d<=0&&(d=s.toLowerCase().indexOf(e.toLowerCase())+1),i=s.substring(0,d).lastIndexOf(f),i=i>-1?d-(i+f.length):d,s=p[m].substring(0,i),e&&(e=""+e,i=e.toLowerCase().indexOf(s.toLowerCase()),i>-1&&(e=e.substring(i+s.length),g=d+e.length,s+=e),f&&""!==p[p.length-1]&&p.push("")),p[m]=s,o._accessor(p.join(f||"")),c===l()&&a(c,d,g),t)},value:function(e){return e===t?this._accessor():(this.listView.value(e),this._accessor(e),this._old=this._accessor(),this._oldText=this._accessor(),t)},_click:function(e){var n=e.item,i=this,o=i.element,r=i.listView.dataItemByIndex(i.listView.getElementIndex(n));return e.preventDefault(),i._active=!0,i.trigger("select",{dataItem:r,item:n})?(i.close(),t):(i._oldText=o.val(),i._select(n).done(function(){i._blur(),a(o,o.val().length)}),t)},_clearText:e.noop,_resetFocusItem:function(){var e=this.options.highlightFirst?0:-1;this.options.virtual&&this.listView.scrollTo(0),this.listView.focus(e)},_listBound:function(){var e,n=this,i=n.popup,o=n.options,r=n.dataSource.flatView(),s=r.length,a=n.dataSource._group.length,c=n.element[0]===l();n._renderFooter(),n._renderNoData(),n._toggleNoData(!s),n._toggleHeader(!!a&&!!s),n._resizePopup(),i.position(),s&&o.suggest&&c&&n.suggest(r[0]),n._open&&(n._open=!1,e=n._allowOpening()?"open":"close",n._typingTimeout&&!c&&(e="close"),s&&(n._resetFocusItem(),o.virtual&&n.popup.unbind("activate",n._resetFocusItemHandler).one("activate",n._resetFocusItemHandler)),i[e](),n._typingTimeout=t),n._touchScroller&&n._touchScroller.reset(),n._hideBusy(),n._makeUnselectable(),n.trigger("dataBound")},_mute:function(e){this._muted=!0,e.call(this),this._muted=!1},_listChange:function(){var e=this._active||this.element[0]===l();e&&!this._muted&&this._selectValue(this.listView.selectedDataItems()[0])},_selectValue:function(e){var t=this._separator(),n="";e&&(n=this._text(e)),null===n&&(n=""),t&&(n=o(a(this.element)[0],this._accessor(),n,t,this._defaultSeparator())),this._prev=n,this._accessor(n),this._placeholder()},_unifySeparators:function(){return this._accessor(this.value().split(this._separator()).join(this._defaultSeparator())),this},_preselect:function(e,t){this._inputValue(t),this._accessor(e),this._old=this.oldText=this._accessor(),this.listView.setValue(e),
this._placeholder()},_change:function(){var e=this,t=e._unifySeparators().value(),n=t!==u.unifyType(e._old,typeof t),i=n&&!e._typing,o=e._oldText!==t;e._old=t,e._oldText=t,(i||o)&&e.element.trigger(g),n&&e.trigger(g),e.typing=!1,e._toggleCloseVisibility()},_accessor:function(e){var n=this,i=n.element[0];return e===t?(e=i.value,i.className.indexOf("k-readonly")>-1&&e===n.options.placeholder?"":e):(i.value=null===e?"":e,n._placeholder(),t)},_keydown:function(e){var t,n,i=this,o=e.keyCode,r=i.listView,s=i.popup.visible(),a=r.focus();if(i._last=o,o===h.DOWN)s?this._move(a?"focusNext":"focusFirst"):i.value()&&i._filterSource({value:i.ignoreCase?i.value().toLowerCase():i.value(),operator:i.options.filter,field:i.options.dataTextField,ignoreCase:i.ignoreCase}).done(function(){i._resetFocusItem(),i.popup.open()}),e.preventDefault();else if(o===h.UP)s&&this._move(a?"focusPrev":"focusLast"),e.preventDefault();else if(o===h.HOME)this._move("focusFirst");else if(o===h.END)this._move("focusLast");else if(o===h.ENTER||o===h.TAB){if(o===h.ENTER&&s&&e.preventDefault(),s&&a){if(t=r.dataItemByIndex(r.getElementIndex(a)),i.trigger("select",{dataItem:t,item:a}))return;this._select(a)}this._blur()}else o===h.ESC?(s?e.preventDefault():i._clearValue(),i.close()):!i.popup.visible()||o!==h.PAGEDOWN&&o!==h.PAGEUP?(i.popup._hovered=!0,i._search()):(e.preventDefault(),n=o===h.PAGEDOWN?1:-1,r.scrollWith(n*r.screenHeight()))},_keypress:function(){this._oldText=this.element.val(),this._typing=!0},_move:function(e){this.listView[e](),this.options.suggest&&this.suggest(this.listView.focus())},_hideBusy:function(){var e=this;clearTimeout(e._busy),e._loading.hide(),e.element.attr("aria-busy",!1),e._busy=null,e._showClear()},_showBusy:function(){var e=this;e._busy||(e._busy=setTimeout(function(){e.element.attr("aria-busy",!0),e._loading.show(),e._hideClear()},100))},_placeholder:function(e){if(!c){var n,i=this,o=i.element,r=i.options.placeholder;if(r){if(n=o.val(),e===t&&(e=!n),e||(r=n!==r?n:""),n===i._old&&!e)return;o.toggleClass("k-readonly",e).val(r),r||o[0]!==document.activeElement||a(o[0],0,0)}}},_separator:function(){var e=this.options.separator;return e instanceof Array?RegExp(e.join("|"),"gi"):e},_defaultSeparator:function(){var e=this.options.separator;return e instanceof Array?e[0]:e},_inputValue:function(){return this.element.val()},_search:function(){var e=this;clearTimeout(e._typingTimeout),e._typingTimeout=setTimeout(function(){e._prev!==e._accessor()&&(e._prev=e._accessor(),e.search())},e.options.delay)},_select:function(e){var t=this;return t._active=!0,t.listView.select(e).done(function(){t._active=!1})},_loader:function(){this._loading=e('<span class="k-icon k-i-loading" style="display:none"></span>').insertAfter(this.element)},_clearButton:function(){u.fn._clearButton.call(this),this.options.clearButton&&(this._clear.insertAfter(this.element),this.wrapper.addClass("k-autocomplete-clearable"))},_toggleHover:function(t){e(t.currentTarget).toggleClass(x,"mouseenter"===t.type)},_toggleCloseVisibility:function(){this.value()?this._showClear():this._hideClear()},_wrapper:function(){var e,t=this,n=t.element,i=n[0];e=n.parent(),e.is("span.k-widget")||(e=n.wrap("<span />").parent()),e.attr("tabindex",-1),e.attr("role","presentation"),e[0].style.cssText=i.style.cssText,n.css({width:"",height:i.style.height}),t._focused=t.element,t.wrapper=e.addClass("k-widget k-autocomplete k-header").addClass(i.className)}});d.plugin(D)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dropdownlist.min",["kendo.list.min","kendo.mobile.scroller.min","kendo.virtuallist.min"],e)}(function(){return function(e,t){function n(e,t,n){for(var i,o=0,r=t.length-1;o<r;++o)i=t[o],i in e||(e[i]={}),e=e[i];e[t[r]]=n}function i(e,t){return e>=t&&(e-=t),e}function o(e,t){for(var n=0;n<e.length;n++)if(e.charAt(n)!==t)return!1;return!0}var r=window.kendo,s=r.ui,a=s.List,l=s.Select,c=r.support,d=r._activeElement,u=r.data.ObservableObject,h=r.keys,f=".kendoDropDownList",p="disabled",m="readonly",g="change",v="k-state-focused",_="k-state-default",b="k-state-disabled",w="aria-disabled",y="mouseenter"+f+" mouseleave"+f,k="tabindex",x="filter",C="accept",S="The `optionLabel` option is not valid due to missing fields. Define a custom optionLabel as shown here http://docs.telerik.com/kendo-ui/api/javascript/ui/dropdownlist#configuration-optionLabel",T=e.proxy,D=l.extend({init:function(n,i){var o,s,a,c=this,d=i&&i.index;c.ns=f,i=e.isArray(i)?{dataSource:i}:i,l.fn.init.call(c,n,i),i=c.options,n=c.element.on("focus"+f,T(c._focusHandler,c)),c._focusInputHandler=e.proxy(c._focusInput,c),c.optionLabel=e(),c._optionLabel(),c._inputTemplate(),c._reset(),c._prev="",c._word="",c._wrapper(),c._tabindex(),c.wrapper.data(k,c.wrapper.attr(k)),c._span(),c._popup(),c._mobile(),c._dataSource(),c._ignoreCase(),c._filterHeader(),c._aria(),c.wrapper.attr("aria-live","polite"),c._enable(),c._oldIndex=c.selectedIndex=-1,d!==t&&(i.index=d),c._initialIndex=i.index,c.requireValueMapper(c.options),c._initList(),c._cascade(),c.one("set",function(e){!e.sender.listView.bound()&&c.hasOptionLabel()&&c._textAccessor(c._optionLabelText())}),i.autoBind?c.dataSource.fetch():c.selectedIndex===-1&&(s=i.text||"",s||(o=i.optionLabel,o&&0===i.index?s=o:c._isSelect&&(s=n.children(":selected").text())),c._textAccessor(s)),a=e(c.element).parents("fieldset").is(":disabled"),a&&c.enable(!1),c.listView.bind("click",function(e){e.preventDefault()}),r.notify(c)},options:{name:"DropDownList",enabled:!0,autoBind:!0,index:0,text:null,value:null,delay:500,height:200,dataTextField:"",dataValueField:"",optionLabel:"",cascadeFrom:"",cascadeFromField:"",ignoreCase:!0,animation:{},filter:"none",minLength:1,enforceMinLength:!1,virtual:!1,template:null,valueTemplate:null,optionLabelTemplate:null,groupTemplate:"#:data#",fixedGroupTemplate:"#:data#",autoWidth:!1},events:["open","close",g,"select","filtering","dataBinding","dataBound","cascade","set"],setOptions:function(e){l.fn.setOptions.call(this,e),this.listView.setOptions(this._listOptions(e)),this._optionLabel(),this._inputTemplate(),this._accessors(),this._filterHeader(),this._enable(),this._aria(),!this.value()&&this.hasOptionLabel()&&this.select(0)},destroy:function(){var e=this;l.fn.destroy.call(e),e.wrapper.off(f),e.element.off(f),e._inputWrapper.off(f),e._arrow.off(),e._arrow=null,e._arrowIcon=null,e.optionLabel.off()},open:function(){var e=this,t=!!e.dataSource.filter()&&e.dataSource.filter().filters.length>0;e.popup.visible()||(e.listView.bound()&&e._state!==C?e._allowOpening()&&(e._focusFilter=!0,e.popup.one("activate",e._focusInputHandler),e.popup._hovered=!0,e.popup.open(),e._resizeFilterInput(),e._focusItem()):(e._open=!0,e._state="rebind",e.filterInput&&(e.filterInput.val(""),e._prev=""),e.filterInput&&1!==e.options.minLength&&!t?(e.refresh(),e.popup.one("activate",e._focusInputHandler),e.popup.open(),e._resizeFilterInput()):e._filterSource()))},_focusInput:function(){this._focusElement(this.filterInput)},_resizeFilterInput:function(){var e,t,n=this.filterInput,i=this._prevent;n&&(e=this.filterInput[0]===d(),t=r.caret(this.filterInput[0])[0],this._prevent=!0,n.css("display","none").css("width",this.popup.element.css("width")).css("display","inline-block"),e&&(n.focus(),r.caret(n[0],t)),this._prevent=i)},_allowOpening:function(){return this.hasOptionLabel()||this.filterInput||l.fn._allowOpening.call(this)},toggle:function(e){this._toggle(e,!0)},current:function(e){var n;return e===t?(n=this.listView.focus(),!n&&0===this.selectedIndex&&this.hasOptionLabel()?this.optionLabel:n):(this._focus(e),t)},dataItem:function(n){var i=this,o=null;if(null===n)return n;if(n===t)o=i.listView.selectedDataItems()[0];else{if("number"!=typeof n){if(i.options.virtual)return i.dataSource.getByUid(e(n).data("uid"));n=n.hasClass("k-list-optionlabel")?-1:e(i.items()).index(n)}else i.hasOptionLabel()&&(n-=1);o=i.dataSource.flatView()[n]}return o||(o=i._optionLabelDataItem()),o},refresh:function(){this.listView.refresh()},text:function(e){var n,i=this,o=i.options.ignoreCase;return e=null===e?"":e,e===t?i._textAccessor():"string"!=typeof e?(i._textAccessor(e),t):(n=o?e.toLowerCase():e,i._select(function(e){return e=i._text(e),o&&(e=(e+"").toLowerCase()),e===n}).done(function(){i._textAccessor(i.dataItem()||e)}),t)},_clearFilter:function(){e(this.filterInput).val(""),l.fn._clearFilter.call(this)},value:function(e){var n=this,i=n.listView,o=n.dataSource;return e===t?(e=n._accessor()||n.listView.value()[0],e===t||null===e?"":e):(n.requireValueMapper(n.options,e),!e&&n.hasOptionLabel()||(n._initialIndex=null),this.trigger("set",{value:e}),n._request&&n.options.cascadeFrom&&n.listView.bound()?(n._valueSetter&&o.unbind(g,n._valueSetter),n._valueSetter=T(function(){n.value(e)},n),o.one(g,n._valueSetter),t):(n._isFilterEnabled()&&i.bound()&&i.isFiltered()?n._clearFilter():n._fetchData(),i.value(e).done(function(){n._old=n._accessor(),n._oldIndex=n.selectedIndex}),t))},hasOptionLabel:function(){return this.optionLabel&&!!this.optionLabel[0]},_optionLabel:function(){var n=this,i=n.options,o=i.optionLabel,s=i.optionLabelTemplate;return o?(s||(s="#:",s+="string"==typeof o?"data":r.expr(i.dataTextField,"data"),s+="#"),"function"!=typeof s&&(s=r.template(s)),n.optionLabelTemplate=s,n.hasOptionLabel()||(n.optionLabel=e('<div class="k-list-optionlabel"></div>').prependTo(n.list)),n.optionLabel.html(s(o)).off().click(T(n._click,n)).on(y,n._toggleHover),n.angular("compile",function(){return{elements:n.optionLabel,data:[{dataItem:n._optionLabelDataItem()}]}}),t):(n.optionLabel.off().remove(),n.optionLabel=e(),t)},_optionLabelText:function(){var e=this.options.optionLabel;return"string"==typeof e?e:this._text(e)},_optionLabelDataItem:function(){var n=this,i=n.options.optionLabel;return n.hasOptionLabel()?e.isPlainObject(i)?new u(i):n._assignInstance(n._optionLabelText(),""):t},_buildOptions:function(e){var n,i,o,r=this;r._isSelect&&(n=r.listView.value()[0],i=r._optionLabelDataItem(),o=i&&r._value(i),n!==t&&null!==n||(n=""),i&&(o!==t&&null!==o||(o=""),i='<option value="'+o+'">'+r._text(i)+"</option>"),r._options(e,i,n),n!==a.unifyType(r._accessor(),typeof n)&&(r._customOption=null,r._custom(n)))},_listBound:function(){var e,t=this,n=t._initialIndex,i=t._state===x,o=t.dataSource.flatView();t._presetValue=!1,t._renderFooter(),t._renderNoData(),t._toggleNoData(!o.length),t._resizePopup(!0),t.popup.position(),t._buildOptions(o),t._makeUnselectable(),i||(t._open&&t.toggle(t._allowOpening()),t._open=!1,t._fetch||(o.length?(!t.listView.value().length&&n>-1&&null!==n&&t.select(n),t._initialIndex=null,e=t.listView.selectedDataItems()[0],e&&t.text()!==t._text(e)&&t._selectValue(e)):t._textAccessor()!==t._optionLabelText()&&(t.listView.value(""),t._selectValue(null),t._oldIndex=t.selectedIndex))),t._hideBusy(),t.trigger("dataBound")},_listChange:function(){this._selectValue(this.listView.selectedDataItems()[0]),(this._presetValue||this._old&&this._oldIndex===-1)&&(this._oldIndex=this.selectedIndex)},_filterPaste:function(){this._search()},_focusHandler:function(){this.wrapper.focus()},_focusinHandler:function(){this._inputWrapper.addClass(v),this._prevent=!1},_focusoutHandler:function(){var e=this,t=window.self!==window.top;e._prevent||(clearTimeout(e._typingTimeout),c.mobileOS.ios&&t?e._change():e._blur(),e._inputWrapper.removeClass(v),e._prevent=!0,e._open=!1,e.element.blur())},_wrapperMousedown:function(){this._prevent=!!this.filterInput},_wrapperClick:function(e){e.preventDefault(),this.popup.unbind("activate",this._focusInputHandler),this._focused=this.wrapper,this._prevent=!1,this._toggle()},_editable:function(e){var t=this,n=t.element,i=e.disable,o=e.readonly,r=t.wrapper.add(t.filterInput).off(f),s=t._inputWrapper.off(y);o||i?i?(r.removeAttr(k),s.addClass(b).removeClass(_)):(s.addClass(_).removeClass(b),r.on("focusin"+f,T(t._focusinHandler,t)).on("focusout"+f,T(t._focusoutHandler,t))):(n.removeAttr(p).removeAttr(m),s.addClass(_).removeClass(b).on(y,t._toggleHover),r.attr(k,r.data(k)).attr(w,!1).on("keydown"+f,T(t._keydown,t)).on("focusin"+f,T(t._focusinHandler,t)).on("focusout"+f,T(t._focusoutHandler,t)).on("mousedown"+f,T(t._wrapperMousedown,t)).on("paste"+f,T(t._filterPaste,t)),t.wrapper.on("click"+f,T(t._wrapperClick,t)),t.filterInput||r.on("keypress"+f,T(t._keypress,t))),n.attr(p,i).attr(m,o),r.attr(w,i)},_keydown:function(e){var n,i,o,r=this,s=e.keyCode,a=e.altKey,l=r.popup.visible();if(r.filterInput&&(n=r.filterInput[0]===d()),s===h.LEFT?(s=h.UP,i=!0):s===h.RIGHT&&(s=h.DOWN,i=!0),!i||!n){if(e.keyCode=s,(a&&s===h.UP||s===h.ESC)&&r._focusElement(r.wrapper),r._state===x&&s===h.ESC&&(r._clearFilter(),r._open=!1,r._state=C),s===h.ENTER&&r._typingTimeout&&r.filterInput&&l)return e.preventDefault(),t;if(s!==h.SPACEBAR||n||(r.toggle(!l),e.preventDefault()),i=r._move(e),!i){if((!l||!r.filterInput)&&(o=r._focus(),s===h.HOME?(i=!0,r._firstItem()):s===h.END&&(i=!0,r._lastItem()),i)){if(r.trigger("select",{dataItem:r._getElementDataItem(r._focus()),item:r._focus()}))return r._focus(o),t;r._select(r._focus(),!0).done(function(){l||r._blur()}),e.preventDefault()}a||i||!r.filterInput||r._search()}}},_matchText:function(e,n){var i=this.options.ignoreCase;return e!==t&&null!==e&&(e+="",i&&(e=e.toLowerCase()),0===e.indexOf(n))},_shuffleData:function(e,t){var n=this._optionLabelDataItem();return n&&(e=[n].concat(e)),e.slice(t).concat(e.slice(0,t))},_selectNext:function(){var e,t,n,r=this,s=r.dataSource.flatView(),a=s.length+(r.hasOptionLabel()?1:0),l=o(r._word,r._last),c=r.selectedIndex;for(c===-1?c=0:(c+=l?1:0,c=i(c,a)),s=s.toJSON?s.toJSON():s.slice(),s=r._shuffleData(s,c),n=0;n<a&&(t=r._text(s[n]),!l||!r._matchText(t,r._last))&&!r._matchText(t,r._word);n++);n!==a&&(e=r._focus(),r._select(i(c+n,a)).done(function(){var t=function(){r.popup.visible()||r._change()};r.trigger("select",{dataItem:r._getElementDataItem(r._focus()),item:r._focus()})?r._select(e).done(t):t()}))},_keypress:function(e){var t,n=this;0!==e.which&&e.keyCode!==r.keys.ENTER&&(t=String.fromCharCode(e.charCode||e.keyCode),n.options.ignoreCase&&(t=t.toLowerCase())," "===t&&e.preventDefault(),n._word+=t,n._last=t,n._search())},_popupOpen:function(){var e=this.popup;e.wrapper=r.wrap(e.element),e.element.closest(".km-root")[0]&&(e.wrapper.addClass("km-popup km-widget"),this.wrapper.addClass("km-widget"))},_popup:function(){l.fn._popup.call(this),this.popup.one("open",T(this._popupOpen,this))},_getElementDataItem:function(e){return e&&e[0]?e[0]===this.optionLabel[0]?this._optionLabelDataItem():this.listView.dataItemByIndex(this.listView.getElementIndex(e)):null},_click:function(n){var i=this,o=n.item||e(n.currentTarget);return n.preventDefault(),i.trigger("select",{dataItem:i._getElementDataItem(o),item:o})?(i.close(),t):(i._userTriggered=!0,i._select(o).done(function(){i._focusElement(i.wrapper),i._blur()}),t)},_focusElement:function(e){var t=d(),n=this.wrapper,i=this.filterInput,o=e===i?n:i,r=c.mobileOS&&(c.touch||c.MSPointers||c.pointers);i&&i[0]===e[0]&&r||i&&(o[0]===t||this._focusFilter)&&(this._focusFilter=!1,this._prevent=!0,this._focused=e.focus())},_searchByWord:function(e){var t,n;e&&(t=this,n=t.options.ignoreCase,n&&(e=e.toLowerCase()),t._select(function(n){return t._matchText(t._text(n),e)}))},_inputValue:function(){return this.text()},_search:function(){var e=this,n=e.dataSource;if(clearTimeout(e._typingTimeout),e._isFilterEnabled())e._typingTimeout=setTimeout(function(){var t=e.filterInput.val();e._prev!==t&&(e._prev=t,e.search(t),e._resizeFilterInput()),e._typingTimeout=null},e.options.delay);else{if(e._typingTimeout=setTimeout(function(){e._word=""},e.options.delay),!e.listView.bound())return n.fetch().done(function(){e._selectNext()}),t;e._selectNext()}},_get:function(t){var n,i,o,r="function"==typeof t,s=r?e():e(t);if(this.hasOptionLabel()&&("number"==typeof t?t>-1&&(t-=1):s.hasClass("k-list-optionlabel")&&(t=-1)),r){for(n=this.dataSource.flatView(),o=0;o<n.length;o++)if(t(n[o])){t=o,i=!0;break}i||(t=-1)}return t},_firstItem:function(){this.hasOptionLabel()?this._focus(this.optionLabel):this.listView.focusFirst()},_lastItem:function(){this._resetOptionLabel(),this.listView.focusLast()},_nextItem:function(){this.optionLabel.hasClass("k-state-focused")?(this._resetOptionLabel(),this.listView.focusFirst()):this.listView.focusNext()},_prevItem:function(){this.optionLabel.hasClass("k-state-focused")||(this.listView.focusPrev(),this.listView.focus()||this._focus(this.optionLabel))},_focusItem:function(){var e=this.options,n=this.listView,i=n.focus(),o=n.select();o=o[o.length-1],o===t&&e.highlightFirst&&!i&&(o=0),o!==t?n.focus(o):!e.optionLabel||e.virtual&&"dataItem"===e.virtual.mapValueTo?n.scrollToIndex(0):(this._focus(this.optionLabel),this._select(this.optionLabel))},_resetOptionLabel:function(e){this.optionLabel.removeClass("k-state-focused"+(e||"")).removeAttr("id")},_focus:function(e){var n=this.listView,i=this.optionLabel;return e===t?(e=n.focus(),!e&&i.hasClass("k-state-focused")&&(e=i),e):(this._resetOptionLabel(),e=this._get(e),n.focus(e),e===-1&&(i.addClass("k-state-focused").attr("id",n._optionID),this._focused.add(this.filterInput).removeAttr("aria-activedescendant").attr("aria-activedescendant",n._optionID)),t)},_select:function(e,t){var n=this;return e=n._get(e),n.listView.select(e).done(function(){t||n._state!==x||(n._state=C),e===-1&&n._selectValue(null)})},_selectValue:function(e){var n=this,i=n.options.optionLabel,o=n.listView.select(),r="",s="";o=o[o.length-1],o===t&&(o=-1),this._resetOptionLabel(" k-state-selected"),e||0===e?(s=e,r=n._dataValue(e),i&&(o+=1)):i&&(n._focus(n.optionLabel.addClass("k-state-selected")),s=n._optionLabelText(),r="string"==typeof i?"":n._value(i),o=0),n.selectedIndex=o,null===r&&(r=""),n._textAccessor(s),n._accessor(r,o),n._triggerCascade()},_mobile:function(){var e=this,t=e.popup,n=c.mobileOS,i=t.element.parents(".km-root").eq(0);i.length&&n&&(t.options.animation.open.effects=n.android||n.meego?"fadeIn":n.ios||n.wp?"slideIn:up":t.options.animation.open.effects)},_filterHeader:function(){var t;this.filterInput&&(this.filterInput.off(f).parent().remove(),this.filterInput=null),this._isFilterEnabled()&&(t='<span class="k-icon k-i-zoom"></span>',this.filterInput=e('<input class="k-textbox"/>').attr({placeholder:this.element.attr("placeholder"),title:this.element.attr("title"),role:"listbox","aria-haspopup":!0,"aria-expanded":!1}),this.list.prepend(e('<span class="k-list-filter" />').append(this.filterInput.add(t))))},_span:function(){var t,n=this,i=n.wrapper,o="span.k-input";t=i.find(o),t[0]||(i.append('<span unselectable="on" class="k-dropdown-wrap k-state-default"><span unselectable="on" class="k-input">&nbsp;</span><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>').append(n.element),t=i.find(o)),n.span=t,n._inputWrapper=e(i[0].firstChild),n._arrow=i.find(".k-select"),n._arrowIcon=n._arrow.find(".k-icon")},_wrapper:function(){var e,t=this,n=t.element,i=n[0];e=n.parent(),e.is("span.k-widget")||(e=n.wrap("<span />").parent(),e[0].style.cssText=i.style.cssText,e[0].title=i.title),t._focused=t.wrapper=e.addClass("k-widget k-dropdown k-header").addClass(i.className).css("display","").attr({accesskey:n.attr("accesskey"),unselectable:"on",role:"listbox","aria-haspopup":!0,"aria-expanded":!1}),n.hide().removeAttr("accesskey")},_clearSelection:function(e){this.select(e.value()?0:-1)},_inputTemplate:function(){var t=this,n=t.options.valueTemplate;if(n=n?r.template(n):e.proxy(r.template("#:this._text(data)#",{useWithBlock:!1}),t),t.valueTemplate=n,t.hasOptionLabel()&&!t.options.optionLabelTemplate)try{t.valueTemplate(t._optionLabelDataItem())}catch(i){throw Error(S)}},_textAccessor:function(n){var i,o=null,r=this.valueTemplate,s=this._optionLabelText(),a=this.span;if(n===t)return a.text();e.isPlainObject(n)||n instanceof u?o=n:s&&s===n&&(o=this.options.optionLabel),o||(o=this._assignInstance(n,this._accessor())),this.hasOptionLabel()&&(o!==s&&this._text(o)!==s||(r=this.optionLabelTemplate,"string"!=typeof this.options.optionLabel||this.options.optionLabelTemplate||(o=s))),i=function(){return{elements:a.get(),data:[{dataItem:o}]}},this.angular("cleanup",i);try{a.html(r(o))}catch(l){a.html("")}this.angular("compile",i)},_preselect:function(e,t){e||t||(t=this._optionLabelText()),this._accessor(e),this._textAccessor(t),this._old=this._accessor(),this._oldIndex=this.selectedIndex,this.listView.setValue(e),this._initialIndex=null,this._presetValue=!0},_assignInstance:function(e,t){var i=this.options.dataTextField,o={};return i?(n(o,i.split("."),e),n(o,this.options.dataValueField.split("."),t),o=new u(o)):o=e,o}});s.plugin(D)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.combobox.min",["kendo.list.min","kendo.mobile.scroller.min","kendo.virtuallist.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.ui,o=i.List,r=i.Select,s=n.caret,a=n.support,l=a.placeholder,c=n._activeElement,d=n.keys,u=".kendoComboBox",h="click"+u,f="mousedown"+u,p="disabled",m="readonly",g="change",v="k-i-loading",_="k-state-default",b="k-state-focused",w="k-state-disabled",y="aria-disabled",k="filter",x="accept",C="rebind",S="mouseenter"+u+" mouseleave"+u,T=e.proxy,D=/(\r\n|\n|\r)/gm,A=r.extend({init:function(t,i){var o,s,a=this;a.ns=u,i=e.isArray(i)?{dataSource:i}:i,r.fn.init.call(a,t,i),i=a.options,t=a.element.on("focus"+u,T(a._focusHandler,a)),i.placeholder=i.placeholder||t.attr("placeholder"),a._reset(),a._wrapper(),a._input(),a._clearButton(),a._tabindex(a.input),a._popup(),a._dataSource(),a._ignoreCase(),a._enable(),a._oldIndex=a.selectedIndex=-1,a._aria(),a._initialIndex=i.index,a.requireValueMapper(a.options),a._initList(),a._cascade(),i.autoBind?a._filterSource():(o=i.text,!o&&a._isSelect&&(o=t.children(":selected").text()),o&&a._setText(o)),o||a._placeholder(),s=e(a.element).parents("fieldset").is(":disabled"),s&&a.enable(!1),n.notify(a),a._toggleCloseVisibility()},options:{name:"ComboBox",enabled:!0,index:-1,text:null,value:null,autoBind:!0,delay:200,dataTextField:"",dataValueField:"",minLength:1,enforceMinLength:!1,height:200,highlightFirst:!0,filter:"none",placeholder:"",suggest:!1,cascadeFrom:"",cascadeFromField:"",ignoreCase:!0,animation:{},virtual:!1,template:null,groupTemplate:"#:data#",fixedGroupTemplate:"#:data#",clearButton:!0,syncValueAndText:!0,autoWidth:!1},events:["open","close",g,"select","filtering","dataBinding","dataBound","cascade","set"],setOptions:function(e){var t=this._listOptions(e);r.fn.setOptions.call(this,e),this.listView.setOptions(t),this._accessors(),this._aria(),this._clearButton()},destroy:function(){var e=this;e.input.off(u),e.element.off(u),e._inputWrapper.off(u),clearTimeout(e._pasteTimeout),e._arrow.off(h+" "+f),e._clear.off(h+" "+f),r.fn.destroy.call(e)},_change:function(){var e=this,n=e.text(),i=n&&n!==e._oldText&&n!==e.options.placeholder,o=e.selectedIndex,s=o===-1;return!e.options.syncValueAndText&&!e.value()&&s&&i?(e._old="",e._oldIndex=o,e._oldText=n,e._typing||e.element.trigger(g),e.trigger(g),e._typing=!1,t):(r.fn._change.call(e),e._toggleCloseVisibility(),t)},_focusHandler:function(){this.input.focus()},_arrowClick:function(){this._toggle()},_inputFocus:function(){this._inputWrapper.addClass(b),this._placeholder(!1)},_inputFocusout:function(){var e,n,i=this,o=i.value();return i._userTriggered=!0,i._inputWrapper.removeClass(b),clearTimeout(i._typingTimeout),i._typingTimeout=null,i.text(i.text()),e=i._focus(),n=this.listView.dataItemByIndex(this.listView.getElementIndex(e)),o!==i.value()&&i.trigger("select",{dataItem:n,item:e})?(i.value(o),t):(i._placeholder(),i._blur(),i.element.blur(),t)},_inputPaste:function(){var e=this;clearTimeout(e._pasteTimeout),e._pasteTimeout=null,e._pasteTimeout=setTimeout(function(){e.search()})},_editable:function(e){var t=this,n=e.disable,i=e.readonly,o=t._inputWrapper.off(u),r=t.element.add(t.input.off(u)),s=t._arrow.off(h+" "+f),a=t._clear;i||n?(o.addClass(n?w:_).removeClass(n?_:w),r.attr(p,n).attr(m,i).attr(y,n)):(o.addClass(_).removeClass(w).on(S,t._toggleHover),r.removeAttr(p).removeAttr(m).attr(y,!1),s.on(h,T(t._arrowClick,t)).on(f,function(e){e.preventDefault()}),a.on(h,T(t._clearValue,t)).on(f,function(e){e.preventDefault()}),t.input.on("keydown"+u,T(t._keydown,t)).on("focus"+u,T(t._inputFocus,t)).on("focusout"+u,T(t._inputFocusout,t)).on("paste"+u,T(t._inputPaste,t)))},open:function(){var e=this,t=e._state,n=!!e.dataSource.filter()&&e.dataSource.filter().filters.length>0;e.popup.visible()||(!e.listView.bound()&&t!==k||t===x?(e._open=!0,e._state=C,1!==e.options.minLength&&!n||n&&e.value()&&e.selectedIndex===-1?(e.refresh(),e._openPopup(),e.listView.bound(!1)):e._filterSource()):e._allowOpening()&&(e.popup._hovered=!0,e._openPopup(),e.options.virtual&&e._focusItem()))},_scrollToFocusedItem:function(){var e=this.listView;e.scrollToIndex(e.getElementIndex(e.focus()))},_openPopup:function(){this.popup.one("activate",T(this._scrollToFocusedItem,this)),this.popup.open()},_updateSelectionState:function(){var e=this,n=e.options.text,i=e.options.value;e.listView.isFiltered()||(e.selectedIndex===-1?(n!==t&&null!==n||(n=i),e._accessor(i),e.input.val(n||e.input.val()),e._placeholder()):e._oldIndex===-1&&(e._oldIndex=e.selectedIndex))},_buildOptions:function(e){var n,i=this;i._isSelect&&(n=i._customOption,i._state===C&&(i._state=""),i._customOption=t,i._options(e,"",i.value()),n&&n[0].selected&&i._custom(n.val()))},_updateSelection:function(){var n,i=this,o=i.listView,r=i._initialIndex,s=null!==r&&r>-1,a=i._state===k;return a?(e(o.focus()).removeClass("k-state-selected"),t):(i._fetch||(o.value().length||(s?i.select(r):i._accessor()&&o.value(i._accessor())),i._initialIndex=null,n=o.selectedDataItems()[0],n&&(i._value(n)!==i.value()&&i._custom(i._value(n)),i.text()&&i.text()!==i._text(n)&&i._selectValue(n))),t)},_updateItemFocus:function(){var e=this.listView;this.options.highlightFirst?e.focus()||e.focusIndex()||e.focus(0):e.focus(-1)},_listBound:function(){var e=this,n=e.input[0]===c(),i=e.dataSource.flatView(),o=e.listView.skip(),r=i.length,s=e.dataSource._group?e.dataSource._group.length:0,a=o===t||0===o;e._presetValue=!1,e._renderFooter(),e._renderNoData(),e._toggleNoData(!r),e._toggleHeader(!!s&&!!r),e._resizePopup(),e.popup.position(),e._buildOptions(i),e._makeUnselectable(),e._updateSelection(),i.length&&a&&(e._updateItemFocus(),e.options.suggest&&n&&e.input.val()&&e.suggest(i[0])),e._open&&(e._open=!1,e._typingTimeout&&!n?e.popup.close():e.toggle(e._allowOpening()),e._typingTimeout=null),e._hideBusy(),e.trigger("dataBound")},_listChange:function(){this._selectValue(this.listView.selectedDataItems()[0]),this._presetValue&&(this._oldIndex=this.selectedIndex)},_get:function(e){var t,n,i;if("function"==typeof e){for(t=this.dataSource.flatView(),i=0;i<t.length;i++)if(e(t[i])){e=i,n=!0;break}n||(e=-1)}return e},_select:function(e,t){var n=this;return e=n._get(e),e===-1&&(n.input[0].value="",n._accessor("")),n.listView.select(e).done(function(){t||n._state!==k||(n._state=x)})},_selectValue:function(e){var n=this.listView.select(),i="",o="";n=n[n.length-1],n===t&&(n=-1),this.selectedIndex=n,this.listView.isFiltered()&&n!==-1&&(this._valueBeforeCascade=this._old),n!==-1||e?((e||0===e)&&(i=this._dataValue(e),o=this._text(e)),null===i&&(i="")):(this.options.syncValueAndText?(o=this._accessor(),i=o):o=this.text(),this.listView.focus(-1)),this._setDomInputValue(o),this._accessor(i!==t?i:o,n),this._placeholder(),this._triggerCascade()},_setDomInputValue:function(e){var t,n,i=this,o=s(this.input);o&&o.length&&(t=o[0]),this._prev=this.input[0].value=e,t&&this.selectedIndex===-1&&(n=a.mobileOS,n.wp||n.android?setTimeout(function(){i.input[0].setSelectionRange(t,t)},0):this.input[0].setSelectionRange(t,t))},refresh:function(){this.listView.refresh()},_toggleCloseVisibility:function(){this.text()?this._showClear():this._hideClear()},suggest:function(e){var n,i=this,r=i.input[0],a=i.text(),l=s(r)[0],u=i._last;return u==d.BACKSPACE||u==d.DELETE?(i._last=t,t):(e=e||"","string"!=typeof e&&(e[0]&&(e=i.dataSource.view()[o.inArray(e[0],i.ul[0])]),e=e?i._text(e):""),l<=0&&(l=a.toLowerCase().indexOf(e.toLowerCase())+1),e?(e=""+e,n=e.toLowerCase().indexOf(a.toLowerCase()),n>-1&&(a+=e.substring(n+a.length))):a=a.substring(0,l),a.length===l&&e||(r.value=a,r===c()&&s(r,l,a.length)),t)},text:function(e){var n,i,r,s,a,l;return e=null===e?"":e,n=this,i=n.input[0],r=n.options.ignoreCase,s=e,e===t?i.value:n.options.autoBind!==!1||n.listView.bound()?(a=n.dataItem(),a&&n._text(a).replace&&n._text(a).replace(D,"")===e&&(l=n._value(a),l===o.unifyType(n._old,typeof l))?(n._triggerCascade(),t):(r&&(s=s.toLowerCase()),n._select(function(e){return e=n._text(e),r&&(e=(e+"").toLowerCase()),e===s}).done(function(){n.selectedIndex<0&&(i.value=e,n.options.syncValueAndText&&n._accessor(e),n._cascadeTriggered=!0,n._triggerCascade()),n._prev=i.value}),t)):(n._setText(e),t)},toggle:function(e){this._toggle(e,!0)},value:function(e){var n=this,i=n.options,o=n.listView;return e===t?(e=n._accessor()||n.listView.value()[0],e===t||null===e?"":e):(n._toggleCloseVisibility(),n.requireValueMapper(n.options,e),n.trigger("set",{value:e}),e===i.value&&n.input.val()===i.text||(n._accessor(e),n._isFilterEnabled()&&o.bound()&&o.isFiltered()?n._clearFilter():n._fetchData(),o.value(e).done(function(){n.selectedIndex===-1&&(n._accessor(e),n.input.val(e),n._placeholder(!0)),n._old=n._accessor(),n._oldIndex=n.selectedIndex,n._prev=n.input.val(),n._state===k&&(n._state=x)})),t)},_hideBusy:function(){var e=this;clearTimeout(e._busy),e._arrowIcon.removeClass(v),e._focused.attr("aria-busy",!1),e._busy=null,e._toggleCloseVisibility()},_click:function(e){var n=this,i=e.item,o=n.listView.dataItemByIndex(n.listView.getElementIndex(i));return e.preventDefault(),n.trigger("select",{dataItem:o,item:i})?(n.close(),t):(n._userTriggered=!0,n._select(i).done(function(){n._blur()}),t)},_syncValueAndText:function(){return this.options.syncValueAndText},_inputValue:function(){return this.text()},_searchByWord:function(e){var n,i=this,o=i.options,r=i.dataSource,s=o.ignoreCase,a=function(n){var o=i._text(n);if(o!==t)return o+="",(""===o||""!==e)&&(s&&(o=o.toLowerCase()),0===o.indexOf(e))};return s&&(e=e.toLowerCase()),i.ul[0].firstChild?(this.listView.focus(this._get(a)),n=this.listView.focus(),n&&(o.suggest&&i.suggest(n),this.open()),this.options.highlightFirst&&!e&&this.listView.focusFirst(),t):(r.one(g,function(){r.view()[0]&&i.search(e)}).fetch(),t)},_input:function(){var t,n,i=this,o=i.element.removeClass("k-input")[0],r=o.accessKey,s=i.wrapper,a="input.k-input",c=o.name||"";c&&(c='name="'+c+'_input" '),t=s.find(a),t[0]||(s.append('<span tabindex="-1" unselectable="on" class="k-dropdown-wrap k-state-default"><input '+c+'class="k-input" type="text" autocomplete="off"/><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>').append(i.element),t=s.find(a)),t[0].style.cssText=o.style.cssText,t[0].title=o.title,n=parseInt(this.element.prop("maxlength")||this.element.attr("maxlength"),10),n>-1&&(t[0].maxLength=n),t.addClass(o.className).css({width:"",height:o.style.height}).attr({role:"combobox","aria-expanded":!1}).show(),l&&t.attr("placeholder",i.options.placeholder),r&&(o.accessKey="",t[0].accessKey=r),i._focused=i.input=t,i._inputWrapper=e(s[0].firstChild),i._arrow=s.find(".k-select").attr({role:"button",tabIndex:-1}),i._arrowIcon=i._arrow.find(".k-icon"),o.id&&i._arrow.attr("aria-controls",i.ul[0].id)},_clearButton:function(){o.fn._clearButton.call(this),this.options.clearButton&&(this._clear.insertAfter(this.input),this.wrapper.addClass("k-combobox-clearable"))},_keydown:function(e){var t,n,i,r=this,s=e.keyCode;if(r._last=s,clearTimeout(r._typingTimeout),r._typingTimeout=null,s===d.HOME)r._firstItem();else if(s===d.END)r._lastItem();else if(s===d.ENTER)if(t=r.listView.focus(),
n=r.dataItem(),i=!0,r.popup.visible()||n&&r.text()===r._text(n)||(t=null),t){if(r.popup.visible()&&e.preventDefault(),n=r.listView.dataItemByIndex(r.listView.getElementIndex(t)),n&&(i=r._value(n)!==o.unifyType(r.value(),typeof r._value(n))),i&&r.trigger("select",{dataItem:n,item:t}))return;r._userTriggered=!0,r._select(t).done(function(){r._blur(),r._valueBeforeCascade=r._old=r.value()})}else(r._syncValueAndText()||r._isSelect)&&r._accessor(r.input.val()),r.listView.value(r.input.val()),r._blur();else s==d.TAB||r._move(e)?s!==d.ESC||r.popup.visible()||r._clearValue():r._search()},_placeholder:function(e){if(!l){var n,i=this,o=i.input,r=i.options.placeholder;if(r){if(n=i.value(),e===t&&(e=!n),o.toggleClass("k-readonly",e),!e){if(n)return;r=""}o.val(r),r||o[0]!==c()||s(o[0],0,0)}}},_search:function(){var e=this;e._typingTimeout=setTimeout(function(){var t=e.text();e._prev!==t&&(e._prev=t,"none"===e.options.filter&&e.options.virtual&&e.listView.select(-1),e.search(t),e._toggleCloseVisibility()),e._typingTimeout=null},e.options.delay)},_setText:function(e){this.input.val(e),this._prev=e},_wrapper:function(){var e=this,t=e.element,n=t.parent();n.is("span.k-widget")||(n=t.hide().wrap("<span />").parent(),n[0].style.cssText=t[0].style.cssText),e.wrapper=n.addClass("k-widget k-combobox k-header").addClass(t[0].className).css("display","")},_clearSelection:function(e,t){var n=this,i=e.value(),o=i&&e.selectedIndex===-1;this.selectedIndex==-1&&this.value()||(t||!i||o)&&(n.options.value="",n.value(""))},_preselect:function(e,t){this.input.val(t),this._accessor(e),this._old=this._accessor(),this._oldIndex=this.selectedIndex,this.listView.setValue(e),this._placeholder(),this._initialIndex=null,this._presetValue=!0,this._toggleCloseVisibility()}});i.plugin(A)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.multiselect.min",["kendo.list.min","kendo.mobile.scroller.min","kendo.virtuallist.min"],e)}(function(){return function(e,t){function n(e,t){var n;if(null===e&&null!==t||null!==e&&null===t)return!1;if(n=e.length,n!==t.length)return!1;for(;n--;)if(e[n]!==t[n])return!1;return!0}var i=window.kendo,o=i.ui,r=o.List,s=e.extend({A:65},i.keys),a=i._activeElement,l=i.data.ObservableArray,c=e.proxy,d="id",u="li",h="accept",f="filter",p="rebind",m="open",g="close",v="change",_="progress",b="select",w="deselect",y="aria-disabled",k="k-state-focused",x="k-state-selected",C="k-hidden",S="k-state-hover",T="k-state-disabled",D="disabled",A="readonly",E=".kendoMultiSelect",I="click"+E,M="keydown"+E,R="mouseenter"+E,F="mouseleave"+E,z=R+" "+F,P=/"/g,B=e.isArray,L=["font-family","font-size","font-stretch","font-style","font-weight","letter-spacing","text-transform","line-height"],H=r.extend({init:function(t,n){var o,s,a=this;a.ns=E,r.fn.init.call(a,t,n),a._optionsMap={},a._customOptions={},a._wrapper(),a._tagList(),a._input(),a._textContainer(),a._loader(),a._clearButton(),a._tabindex(a.input),t=a.element.attr("multiple","multiple").hide(),n=a.options,n.placeholder||(n.placeholder=t.data("placeholder")),o=t.attr(d),o&&(a._tagID=o+"_tag_active",o+="_taglist",a.tagList.attr(d,o)),a._initialOpen=!0,a._aria(o),a._dataSource(),a._ignoreCase(),a._popup(),a._tagTemplate(),a.requireValueMapper(a.options),a._initList(),a._reset(),a._enable(),a._placeholder(),n.autoBind?a.dataSource.fetch():n.value&&a._preselect(n.value),s=e(a.element).parents("fieldset").is(":disabled"),s&&a.enable(!1),i.notify(a),a._toggleCloseVisibility()},options:{name:"MultiSelect",tagMode:"multiple",enabled:!0,autoBind:!0,autoClose:!0,highlightFirst:!0,dataTextField:"",dataValueField:"",filter:"startswith",ignoreCase:!0,minLength:1,enforceMinLength:!1,delay:100,value:null,maxSelectedItems:null,placeholder:"",height:200,animation:{},virtual:!1,itemTemplate:"",tagTemplate:"",groupTemplate:"#:data#",fixedGroupTemplate:"#:data#",clearButton:!0,autoWidth:!1},events:[m,g,v,b,w,"filtering","dataBinding","dataBound"],setDataSource:function(e){this.options.dataSource=e,this._state="",this._dataSource(),this.persistTagList=!1,this.listView.setDataSource(this.dataSource),this.options.autoBind&&this.dataSource.fetch()},setOptions:function(e){var t=this._listOptions(e);r.fn.setOptions.call(this,e),this.listView.setOptions(t),this._accessors(),this._aria(this.tagList.attr(d)),this._tagTemplate(),this._placeholder(),this._clearButton()},currentTag:function(e){var n=this;return e===t?n._currentTag:(n._currentTag&&(n._currentTag.removeClass(k).removeAttr(d),n.input.removeAttr("aria-activedescendant")),e&&(e.addClass(k).attr(d,n._tagID),n.input.attr("aria-activedescendant",n._tagID)),n._currentTag=e,t)},dataItems:function(){return this.listView.selectedDataItems()},destroy:function(){var e=this,t=e.ns;clearTimeout(e._busy),clearTimeout(e._typingTimeout),e.wrapper.off(t),e.tagList.off(t),e.input.off(t),e._clear.off(t),r.fn.destroy.call(e)},_activateItem:function(){r.fn._activateItem.call(this),this.currentTag(null)},_listOptions:function(t){var n=this,o=r.fn._listOptions.call(n,e.extend(t,{selectedItemChange:c(n._selectedItemChange,n),selectable:"multiple"})),s=this.options.itemTemplate||this.options.template,a=o.itemTemplate||s||o.template;return a||(a="#:"+i.expr(o.dataTextField,"data")+"#"),o.template=a,o},_setListValue:function(){r.fn._setListValue.call(this,this._initialValues.slice(0))},_listChange:function(e){var n,i=this.dataSource.flatView(),o=this._optionsMap,r=this._value;for(this._state===p&&(this._state=""),n=0;n<e.added.length;n++)if(o[r(e.added[n].dataItem)]===t){this._render(i);break}this.persistTagList=!1,this._selectValue(e.added,e.removed)},_selectedItemChange:function(e){var t,n,i=e.items;for(n=0;n<i.length;n++)t=i[n],this.tagList.children().eq(t.index).children("span:first").html(this.tagTextTemplate(t.item))},_wrapperMousedown:function(t){var n=this,o="input"!==t.target.nodeName.toLowerCase(),r=e(t.target),s=r.hasClass("k-select")||r.hasClass("k-icon");s&&(s=!r.closest(".k-select").children(".k-i-arrow-60-down").length),!o||s&&i.support.mobileOS||t.preventDefault(),s||(n.input[0]!==a()&&o&&n.input.focus(),1===n.options.minLength&&n.open())},_inputFocus:function(){this._placeholder(!1),this.wrapper.addClass(k)},_inputFocusout:function(){var e=this;clearTimeout(e._typingTimeout),e.wrapper.removeClass(k),e._placeholder(!e.listView.selectedDataItems()[0],!0),e.close(),e._state===f&&(e._state=h,e.listView.skipUpdate(!0)),e.listView.bound()&&e.listView.isFiltered()&&(e.persistTagList=!0,e._clearFilter()),e.element.blur()},_removeTag:function(e,n){var i,o,r=this,s=r._state,a=e.index(),l=r.listView,c=l.value()[a],d=r.listView.selectedDataItems()[a],u=r._customOptions[c];return r.trigger(w,{dataItem:d,item:e})?(r._close(),t):(u!==t||s!==h&&s!==f||(u=r._optionsMap[c]),o=function(){r.currentTag(null),n&&r._change(),r._close()},u===t?(r.persistTagList=!1,l.select(l.select()[a]).done(o)):(i=r.element[0].children[u],i.selected=!1,l.removeAt(a),e.remove(),o()),t)},_tagListClick:function(t){var n=e(t.currentTarget);n.children(".k-i-arrow-60-down").length||this._removeTag(n.closest(u),!0)},_clearClick:function(){var t=this;"single"===t.options.tagMode?t.value([]):t.tagList.children().each(function(n,i){t._removeTag(e(i),!1)}),t.input.val(""),t._search(),t.trigger(v),t.focus()},_editable:function(t){var n=this,i=t.disable,o=t.readonly,r=n.wrapper.off(E),s=n.tagList.off(E),a=n.element.add(n.input.off(E));o||i?(i?r.addClass(T):r.removeClass(T),a.attr(D,i).attr(A,o).attr(y,i)):(r.removeClass(T).on(z,n._toggleHover).on("mousedown"+E+" touchend"+E,c(n._wrapperMousedown,n)),n.input.on(M,c(n._keydown,n)).on("paste"+E,c(n._search,n)).on("focus"+E,c(n._inputFocus,n)).on("focusout"+E,c(n._inputFocusout,n)),n._clear.on("click"+E,c(n._clearClick,n)),a.removeAttr(D).removeAttr(A).attr(y,!1),s.on(R,u,function(){e(this).addClass(S)}).on(F,u,function(){e(this).removeClass(S)}).on(I,"li.k-button .k-select",c(n._tagListClick,n)))},_close:function(){var e=this;e.options.autoClose?e.close():e.popup.position()},_filterSource:function(e,t){t||(t=this._retrieveData),this._retrieveData=!1,r.fn._filterSource.call(this,e,t)},close:function(){this._activeItem=null,this.popup.close()},open:function(){var t=this;t._request&&(t._retrieveData=!1),t._retrieveData||!t.listView.bound()||t._state===h?(t._open=!0,t._state=p,t.listView.skipUpdate(!0),t.persistTagList=!0,t._filterSource(),t._focusItem()):t._allowOpening()&&(t.options.autoBind||t.options.virtual||!t.options.value||e.isPlainObject(t.options.value[0])||(t.value(t._initialValues),t._initialOpen=!1),t.popup._hovered=!0,t.popup.open(),t._focusItem())},toggle:function(e){e=e!==t?e:!this.popup.visible(),this[e?m:g]()},refresh:function(){this.listView.refresh()},_listBound:function(){var e=this,n=e.dataSource.flatView(),i=e.listView.skip();e._render(n),e._renderFooter(),e._renderNoData(),e._toggleNoData(!n.length),e._resizePopup(),e._open&&(e._open=!1,e.toggle(e._allowOpening())),e.popup.position(),!e.options.highlightFirst||i!==t&&0!==i||e.listView.focusFirst(),e._touchScroller&&e._touchScroller.reset(),e._hideBusy(),e._makeUnselectable(),e.trigger("dataBound")},_inputValue:function(){var e=this,t=e.input.val();return e.options.placeholder===t&&(t=""),t},value:function(e){var n=this,i=n.listView,o=i.value().slice(),r=n.options.maxSelectedItems,s=i.bound()&&i.isFiltered();return e===t?o:(n._toggleCloseVisibility(),n.persistTagList=!1,n.requireValueMapper(n.options,e),e=n._normalizeValues(e),null!==r&&e.length>r&&(e=e.slice(0,r)),s&&n._clearFilter(),i.value(e),n._old=i.value(),s||n._fetchData(),t)},_preselect:function(t,n){var o=this;B(t)||t instanceof i.data.ObservableArray||(t=[t]),(e.isPlainObject(t[0])||t[0]instanceof i.data.ObservableObject||!o.options.dataValueField)&&(o.dataSource.data(t),o.value(n||o._initialValues),o._retrieveData=!0)},_setOption:function(e,t){var n=this.element[0].children[this._optionsMap[e]];n&&(n.selected=t)},_fetchData:function(){var e=this,t=!!e.dataSource.view().length,n=0===e.listView.value().length;n||e._request||(e._retrieveData||!e._fetch&&!t)&&(e._fetch=!0,e._retrieveData=!1,e.dataSource.read().done(function(){e._fetch=!1}))},_isBound:function(){return this.listView.bound()&&!this._retrieveData},_dataSource:function(){var e=this,t=e.element,n=e.options,o=n.dataSource||{};o=B(o)?{data:o}:o,o.select=t,o.fields=[{field:n.dataTextField},{field:n.dataValueField}],e.dataSource&&e._refreshHandler?e._unbindDataSource():(e._progressHandler=c(e._showBusy,e),e._errorHandler=c(e._hideBusy,e)),e.dataSource=i.data.DataSource.create(o).bind(_,e._progressHandler).bind("error",e._errorHandler)},_reset:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){setTimeout(function(){t.value(t._initialValues),t._placeholder()})},t._form=o.on("reset",t._resetHandler))},_initValue:function(){var e=this.options.value||this.element.val();this._old=this._initialValues=this._normalizeValues(e)},_normalizeValues:function(t){var n=this;return null===t?t=[]:t&&e.isPlainObject(t)?t=[n._value(t)]:t&&e.isPlainObject(t[0])?t=e.map(t,function(e){return n._value(e)}):B(t)||t instanceof l?B(t)&&(t=t.slice()):t=[t],t},_change:function(){var e=this,t=e.value();n(t,e._old)||(e._old=t.slice(),e.trigger(v),e.element.trigger(v)),e._toggleCloseVisibility()},_click:function(e){var t=this,n=e.item;e.preventDefault(),t._select(n).done(function(){t._activeItem=n,t._change(),t._close()})},_getActiveItem:function(){return this._activeItem||e(this.listView.items()[this._getSelectedIndices().length-1])||this.listView.focus()},_getSelectedIndices:function(){return this.listView._selectedIndices||this.listView._selectedIndexes},_keydown:function(n){var o,r,a,l,c=this,d=n.keyCode,u=c._currentTag,f=c.listView,p=c.input.val(),m=i.support.isRtl(c.wrapper),g=c.popup.visible(),_=0;if(d===s.DOWN){if(n.preventDefault(),!g)return c.open(),f.focus()||f.focusFirst(),t;f.focus()?(!c._activeItem&&n.shiftKey&&(c._activeItem=f.focus(),_=-1),o=f.getElementIndex(c._getActiveItem()[0]),f.focusNext(),f.focus()?n.shiftKey&&c._selectRange(o,f.getElementIndex(f.focus()[0])+_):f.focusLast()):f.focusFirst()}else if(d===s.UP)g&&(!c._activeItem&&n.shiftKey&&(c._activeItem=f.focus(),_=1),o=f.getElementIndex(c._getActiveItem()[0]),f.focusPrev(),f.focus()?n.shiftKey&&c._selectRange(o,f.getElementIndex(f.focus()[0])+_):c.close()),n.preventDefault();else if(d===s.LEFT&&!m||d===s.RIGHT&&m)p||(u=u?u.prev():e(c.tagList[0].lastChild),u[0]&&c.currentTag(u));else if(d===s.RIGHT&&!m||d===s.LEFT&&m)!p&&u&&(u=u.next(),c.currentTag(u[0]?u:null));else if(n.ctrlKey&&d===s.A&&g)this._getSelectedIndices().length===f.items().length&&(c._activeItem=null),f.items().length&&c._selectRange(0,f.items().length-1);else if(d===s.ENTER&&g){if(n.preventDefault(),f.focus().hasClass(x))return c._close(),t;c._select(f.focus()).done(function(){c._change(),c._close()})}else if(d===s.SPACEBAR&&n.ctrlKey&&g)c._activeItem&&f.focus()&&f.focus()[0]===c._activeItem[0]&&(c._activeItem=null),e(f.focus()).hasClass(x)||(c._activeItem=f.focus()),c._select(f.focus()).done(function(){c._change()}),n.preventDefault();else if(d===s.SPACEBAR&&n.shiftKey&&g)r=f.getElementIndex(c._getActiveItem()),a=f.getElementIndex(f.focus()),r!==t&&a!==t&&c._selectRange(r,a),n.preventDefault();else if(d===s.ESC)g?n.preventDefault():(c.tagList.children().each(function(t,n){c._removeTag(e(n),!1)}),c.trigger(v)),c.close();else if(d===s.HOME)g?f.focus()?(n.ctrlKey&&n.shiftKey&&c._selectRange(f.getElementIndex(f.focus()[0]),0),f.focusFirst()):c.close():p||(u=c.tagList[0].firstChild,u&&c.currentTag(e(u)));else if(d===s.END)g?f.focus()?(n.ctrlKey&&n.shiftKey&&c._selectRange(f.getElementIndex(f.focus()[0]),f.element.children().length-1),f.focusLast()):c.close():p||(u=c.tagList[0].lastChild,u&&c.currentTag(e(u)));else if(d!==s.DELETE&&d!==s.BACKSPACE||p)!c.popup.visible()||d!==s.PAGEDOWN&&d!==s.PAGEUP?(clearTimeout(c._typingTimeout),setTimeout(function(){c._scale()}),c._search()):(n.preventDefault(),l=d===s.PAGEDOWN?1:-1,f.scrollWith(l*f.screenHeight()));else{if(c._state=h,"single"===c.options.tagMode)return f.value([]),c._change(),c._close(),t;d!==s.BACKSPACE||u||(u=e(c.tagList[0].lastChild)),u&&u[0]&&c._removeTag(u,!0)}},_hideBusy:function(){var e=this;clearTimeout(e._busy),e.input.attr("aria-busy",!1),e._loading.addClass(C),e._request=!1,e._busy=null,e._toggleCloseVisibility()},_showBusyHandler:function(){this.input.attr("aria-busy",!0),this._loading.removeClass(C),this._hideClear()},_showBusy:function(){var e=this;e._request=!0,e._busy||(e._busy=setTimeout(c(e._showBusyHandler,e),100))},_placeholder:function(e,n){var o=this,r=o.input,s=a(),l=o.options.placeholder,c=r.val(),d=r[0]===s,u=c.length;d&&!o.options.autoClose&&c!==l||(u=0,c=""),e===t&&(e=!1,r[0]!==s&&(e=!o.listView.selectedDataItems()[0])),o._prev=c,r.toggleClass("k-readonly",e).val(e?l:c),d&&!n&&i.caret(r[0],u,u),o._scale()},_scale:function(){var e,t=this,n=t.wrapper.find(".k-multiselect-wrap"),i=n.width(),o=t._span.text(t.input.val());n.is(":visible")?e=o.width()+25:(o.appendTo(document.documentElement),i=e=o.width()+25,o.appendTo(n)),t.input.width(e>i?i:e)},_option:function(e,n,o){var r="<option";return e!==t&&(e+="",e.indexOf('"')!==-1&&(e=e.replace(P,"&quot;")),r+=' value="'+e+'"'),o&&(r+=" selected"),r+=">",n!==t&&(r+=i.htmlEncode(n)),r+="</option>"},_render:function(e){var t,n,i,o,r,s,a=this.listView.selectedDataItems(),l=this.listView.value(),c=e.length,d="";for(l.length!==a.length&&(a=this._buildSelectedItems(l)),r={},s={},o=0;o<c;o++)n=e[o],i=this._value(n),t=this._selectedItemIndex(i,a),t!==-1&&a.splice(t,1),s[i]=o,d+=this._option(i,this._text(n),t!==-1);if(a.length)for(o=0;o<a.length;o++)n=a[o],i=this._value(n),r[i]=c,s[i]=c,c+=1,d+=this._option(i,this._text(n),!0);this._customOptions=r,this._optionsMap=s,this.element.html(d)},_buildSelectedItems:function(e){var t,n,i=this.options.dataValueField,o=this.options.dataTextField,r=[];for(n=0;n<e.length;n++)t={},t[i]=e[n],t[o]=e[n],r.push(t);return r},_selectedItemIndex:function(e,t){for(var n=this._value,i=0;i<t.length;i++)if(e===n(t[i]))return i;return-1},_search:function(){var e=this;e._typingTimeout=setTimeout(function(){var t=e._inputValue();e._prev!==t&&(e._prev=t,e.search(t),e._toggleCloseVisibility())},e.options.delay)},_toggleCloseVisibility:function(){this.value().length||this.input.val()&&this.input.val()!==this.options.placeholder?this._showClear():this._hideClear()},_allowOpening:function(){return this._allowSelection()&&r.fn._allowOpening.call(this)},_allowSelection:function(){var e=this.options.maxSelectedItems;return null===e||e>this.listView.value().length},_angularTagItems:function(t){var n=this;n.angular(t,function(){return{elements:n.tagList[0].children,data:e.map(n.dataItems(),function(e){return{dataItem:e}})}})},updatePersistTagList:function(e,t){this.persistTagList=(!this.persistTagList.added||this.persistTagList.added.length!==t.length||!this.persistTagList.removed||this.persistTagList.removed.length!==e.length)&&{added:e,removed:t}},_selectValue:function(e,n){var i,o,r,s=this,a=s.value(),l=s.dataSource.total(),c=s.tagList,d=s._value;if(this.persistTagList)return this.updatePersistTagList(e,n),t;if(s._angularTagItems("cleanup"),"multiple"===s.options.tagMode){for(r=n.length-1;r>-1;r--)i=n[r],c.children().length&&(c[0].removeChild(c[0].children[i.position]),s._setOption(d(i.dataItem),!1));for(r=0;r<e.length;r++)o=e[r],c.append(s.tagTemplate(o.dataItem)),s._setOption(d(o.dataItem),!0)}else{for((!s._maxTotal||s._maxTotal<l)&&(s._maxTotal=l),c.html(""),a.length&&c.append(s.tagTemplate({values:a,dataItems:s.dataItems(),maxTotal:s._maxTotal,currentTotal:l})),r=n.length-1;r>-1;r--)s._setOption(d(n[r].dataItem),!1);for(r=0;r<e.length;r++)s._setOption(d(e[r].dataItem),!0)}s._angularTagItems("compile"),s._placeholder()},_select:function(t){var n,i,o,r,s=e.Deferred().resolve();return t?(n=this,i=n.listView,o=i.dataItemByIndex(i.getElementIndex(t)),r=t.hasClass("k-state-selected"),n._state===p&&(n._state=""),n._allowSelection()||r?n.trigger(r?w:b,{dataItem:o,item:t})?(n._close(),s):(n.persistTagList=!1,i.select(t).done(function(){n._placeholder(),n._state===f&&(n._state=h,i.skipUpdate(!0))})):s):s},_selectRange:function(n,i){var o,r,s=this,a=this.listView,l=this.options.maxSelectedItems,c=this._getSelectedIndices().slice(),d=[],u=function(t){a.select(t).done(function(){t.forEach(function(t){var n=a.dataItemByIndex(t),i=a.element.children()[t],o=e(i).hasClass("k-state-selected");s.trigger(o?b:w,{dataItem:n,item:i})}),s._change()})};if(c.length-1===i-n)return u(c);if(n<i)for(o=n;o<=i;o++)d.push(o);else for(o=n;o>=i;o--)d.push(o);for(null!==l&&d.length>l&&(d=d.slice(0,l)),o=0;o<d.length;o++)r=d[o],this._getSelectedIndices().indexOf(r)==-1?c.push(r):c.splice(c.indexOf(r),1);return c.length?(s.persistTagList=!1,u(c)):t},_input:function(){var t=this,n=t.element,i=n[0].accessKey,o=t._innerWrapper.children("input.k-input");o[0]||(o=e('<input class="k-input" style="width: 25px" />').appendTo(t._innerWrapper)),n.removeAttr("accesskey"),t._focused=t.input=o.attr({accesskey:i,autocomplete:"off",role:"listbox",title:n[0].title,"aria-expanded":!1})},_tagList:function(){var t=this,n=t._innerWrapper.children("ul");n[0]||(n=e('<ul role="listbox" deselectable="on" class="k-reset"/>').appendTo(t._innerWrapper)),t.tagList=n},_tagTemplate:function(){var e,t=this,n=t.options,o=n.tagTemplate,r=n.dataSource,s="multiple"===n.tagMode;t.element[0].length&&!r&&(n.dataTextField=n.dataTextField||"text",n.dataValueField=n.dataValueField||"value"),e=s?i.template("#:"+i.expr(n.dataTextField,"data")+"#",{useWithBlock:!1}):i.template("#:values.length# item(s) selected"),t.tagTextTemplate=o=o?i.template(o):e,t.tagTemplate=function(e){return'<li class="k-button" deselectable="on"><span deselectable="on">'+o(e)+'</span><span unselectable="on" aria-label="'+(s?"delete":"open")+'" class="k-select"><span class="k-icon '+(s?"k-i-close":"k-i-arrow-60-down")+'"></span></span></li>'}},_loader:function(){this._loading=e('<span class="k-icon k-i-loading '+C+'"></span>').insertAfter(this.input)},_clearButton:function(){r.fn._clearButton.call(this),this.options.clearButton&&(this._clear.insertAfter(this.input),this.wrapper.addClass("k-multiselect-clearable"))},_textContainer:function(){var t=i.getComputedStyles(this.input[0],L);t.position="absolute",t.visibility="hidden",t.top=-3333,t.left=-3333,this._span=e("<span/>").css(t).appendTo(this.wrapper)},_wrapper:function(){var t=this,n=t.element,i=n.parent("span.k-multiselect");i[0]||(i=n.wrap('<div class="k-widget k-multiselect k-header" deselectable="on" />').parent(),i[0].style.cssText=n[0].style.cssText,i[0].title=n[0].title,e('<div class="k-multiselect-wrap k-floatwrap" deselectable="on" />').insertBefore(n)),t.wrapper=i.addClass(n[0].className).css("display",""),t._innerWrapper=e(i[0].firstChild)}});o.plugin(H)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.slider.min",["kendo.draganddrop.min"],e)}(function(){return function(e,t){function n(e,t,n){var i=n?" k-slider-horizontal":" k-slider-vertical",o=e.style?e.style:t.attr("style"),r=t.attr("class")?" "+t.attr("class"):"",s="";return"bottomRight"==e.tickPlacement?s=" k-slider-bottomright":"topLeft"==e.tickPlacement&&(s=" k-slider-topleft"),o=o?" style='"+o+"'":"","<div class='k-widget k-slider"+i+r+"'"+o+"><div class='k-slider-wrap"+(e.showButtons?" k-slider-buttons":"")+s+"'></div></div>"}function i(e,t,n,i){var o="";return o=n?!i&&"increase"==t||i&&"increase"!=t?"k-i-arrow-60-right":"k-i-arrow-60-left":"increase"==t?"k-i-arrow-60-up":"k-i-arrow-60-down","<a class='k-button k-button-"+t+"' title='"+e[t+"ButtonTitle"]+"' aria-label='"+e[t+"ButtonTitle"]+"'><span class='k-icon "+o+"'></span></a>"}function o(e,t){var n,i="<ul class='k-reset k-slider-items'>",o=S.floor(d(t/e.smallStep))+1;for(n=0;n<o;n++)i+="<li class='k-tick' role='presentation'>&nbsp;</li>";return i+="</ul>"}function r(e,t){var n=t.is("input")?1:2,i=2==n?e.leftDragHandleTitle:e.dragHandleTitle;return"<div class='k-slider-track'><div class='k-slider-selection'><!-- --></div><a href='#' class='k-draghandle' title='"+i+"' role='slider' aria-valuemin='"+e.min+"' aria-valuemax='"+e.max+"' aria-valuenow='"+(n>1?e.selectionStart||e.min:e.value||e.min)+"'>Drag</a>"+(n>1?"<a href='#' class='k-draghandle' title='"+e.rightDragHandleTitle+"'role='slider' aria-valuemin='"+e.min+"' aria-valuemax='"+e.max+"' aria-valuenow='"+(e.selectionEnd||e.max)+"'>Drag</a>":"")+"</div>"}function s(e){return function(t){return t+e}}function a(e){return function(){return e}}function l(e){return(e+"").replace(".",m.cultures.current.numberFormat["."])}function c(e){var t=""+e,n=0;return t=t.split("."),t[1]&&(n=t[1].length),n=n>10?10:n}function d(e){var t,n;return e=parseFloat(e,10),t=c(e),n=S.pow(10,t||0),S.round(e*n)/n}function u(e,n){var i=k(e.getAttribute(n));return null===i&&(i=t),i}function h(e){return typeof e!==Q}function f(e){return 1e4*e}var p,m=window.kendo,g=m.ui.Widget,v=m.ui.Draggable,_=m._outerWidth,b=m._outerHeight,w=e.extend,y=m.format,k=m.parseFloat,x=e.proxy,C=e.isArray,S=Math,T=m.support,D=T.pointers,A=T.msPointers,E="change",I="slide",M=".slider",R="touchstart"+M+" mousedown"+M,F=D?"pointerdown"+M:A?"MSPointerDown"+M:R,z="touchend"+M+" mouseup"+M,P=D?"pointerup":A?"MSPointerUp"+M:z,B="moveSelection",L="keydown"+M,H="click"+M,N="mouseover"+M,O="focus"+M,V="blur"+M,U=".k-draghandle",W=".k-slider-track",j=".k-tick",q="k-state-selected",G="k-state-focused",$="k-state-default",K="k-state-disabled",Y="disabled",Q="undefined",X="tabindex",Z=m.getTouches,J=g.extend({init:function(e,t){var n,i=this;if(g.fn.init.call(i,e,t),t=i.options,i._isHorizontal="horizontal"==t.orientation,i._isRtl=i._isHorizontal&&m.support.isRtl(e),i._position=i._isHorizontal?"left":"bottom",i._sizeFn=i._isHorizontal?"width":"height",i._outerSize=i._isHorizontal?_:b,t.tooltip.format=t.tooltip.enabled?t.tooltip.format||"{0}":"{0}",t.smallStep<=0)throw Error("Kendo UI Slider smallStep must be a positive number.");i._createHtml(),i.wrapper=i.element.closest(".k-slider"),i._trackDiv=i.wrapper.find(W),i._setTrackDivWidth(),i._maxSelection=i._trackDiv[i._sizeFn](),i._sliderItemsInit(),i._reset(),i._tabindex(i.wrapper.find(U)),i[t.enabled?"enable":"disable"](),n=m.support.isRtl(i.wrapper)?-1:1,i._keyMap={37:s(-1*n*t.smallStep),40:s(-t.smallStep),39:s(1*n*t.smallStep),38:s(+t.smallStep),35:a(t.max),36:a(t.min),33:s(+t.largeStep),34:s(-t.largeStep)},m.notify(i)},events:[E,I],options:{enabled:!0,min:0,max:10,smallStep:1,largeStep:5,orientation:"horizontal",tickPlacement:"both",tooltip:{enabled:!0,format:"{0}"}},_distance:function(){return d(this.options.max-this.options.min)},_resize:function(){this._setTrackDivWidth(),this.wrapper.find(".k-slider-items").remove(),this._maxSelection=this._trackDiv[this._sizeFn](),this._sliderItemsInit(),this._refresh(),this.options.enabled&&this.enable(!0)},_sliderItemsInit:function(){var t=this,n=t.options,i=t._maxSelection/((n.max-n.min)/n.smallStep),r=t._calculateItemsWidth(S.floor(t._distance()/n.smallStep));"none"!=n.tickPlacement&&i>=2&&(e(this.element).parent().find(".k-slider-items").remove(),t._trackDiv.before(o(n,t._distance())),t._setItemsWidth(r),t._setItemsTitle()),t._calculateSteps(r),"none"!=n.tickPlacement&&i>=2&&n.largeStep>=n.smallStep&&t._setItemsLargeTick()},getSize:function(){return m.dimensions(this.wrapper)},_setTrackDivWidth:function(){var e=this,t=2*parseFloat(e._trackDiv.css(e._isRtl?"right":e._position),10);e._trackDiv[e._sizeFn](e.wrapper[e._sizeFn]()-2-t)},_setItemsWidth:function(t){var n,i=this,o=i.options,r=0,s=t.length-1,a=i.wrapper.find(j),l=0,c=2,d=a.length,u=0;for(n=0;n<d-2;n++)e(a[n+1])[i._sizeFn](t[n]);if(i._isHorizontal?(e(a[r]).addClass("k-first")[i._sizeFn](t[s-1]),e(a[s]).addClass("k-last")[i._sizeFn](t[s])):(e(a[s]).addClass("k-first")[i._sizeFn](t[s]),e(a[r]).addClass("k-last")[i._sizeFn](t[s-1])),i._distance()%o.smallStep!==0&&!i._isHorizontal){for(n=0;n<t.length;n++)u+=t[n];l=i._maxSelection-u,l+=parseFloat(i._trackDiv.css(i._position),10)+c,i.wrapper.find(".k-slider-items").css("padding-top",l)}},_setItemsTitle:function(){for(var t=this,n=t.options,i=t.wrapper.find(j),o=n.min,r=i.length,s=t._isHorizontal&&!t._isRtl?0:r-1,a=t._isHorizontal&&!t._isRtl?r:-1,l=t._isHorizontal&&!t._isRtl?1:-1;s-a!==0;s+=l)e(i[s]).attr("title",y(n.tooltip.format,d(o))),o+=n.smallStep},_setItemsLargeTick:function(){var t,n,i,o=this,r=o.options,s=o.wrapper.find(j),a=0;if(f(r.largeStep)%f(r.smallStep)===0||o._distance()/r.largeStep>=3)for(o._isHorizontal||o._isRtl||(s=e.makeArray(s).reverse()),a=0;a<s.length;a++)t=e(s[a]),n=o._values[a],i=d(f(n-this.options.min)),i%f(r.smallStep)===0&&i%f(r.largeStep)===0&&(t.addClass("k-tick-large").html("<span class='k-label'>"+t.attr("title")+"</span>"),0!==a&&a!==s.length-1&&t.css("line-height",t[o._sizeFn]()+"px"))},_calculateItemsWidth:function(e){var t,n,i,o=this,r=o.options,s=parseFloat(o._trackDiv.css(o._sizeFn))+1,a=o._distance(),l=s/a;for(a/r.smallStep-S.floor(a/r.smallStep)>0&&(s-=a%r.smallStep*l),t=s/e,n=[],i=0;i<e-1;i++)n[i]=t;return n[e-1]=n[e]=t/2,o._roundWidths(n)},_roundWidths:function(e){var t,n=0,i=e.length;for(t=0;t<i;t++)n+=e[t]-S.floor(e[t]),e[t]=S.floor(e[t]);return n=S.round(n),this._addAdditionalSize(n,e)},_addAdditionalSize:function(e,t){if(0===e)return t;var n,i=parseFloat(t.length-1)/parseFloat(1==e?e:e-1);for(n=0;n<e;n++)t[parseInt(S.round(i*n),10)]+=1;return t},_calculateSteps:function(e){var t,n=this,i=n.options,o=i.min,r=0,s=n._distance(),a=S.ceil(s/i.smallStep),l=1;if(a+=s/i.smallStep%1===0?1:0,e.splice(0,0,2*e[a-2]),e.splice(a-1,1,2*e.pop()),n._pixelSteps=[r],n._values=[o],0!==a){for(;l<a;)r+=(e[l-1]+e[l])/2,n._pixelSteps[l]=r,o+=i.smallStep,n._values[l]=d(o),l++;t=s%i.smallStep===0?a-1:a,n._pixelSteps[t]=n._maxSelection,n._values[t]=i.max,n._isRtl&&(n._pixelSteps.reverse(),n._values.reverse())}},_getValueFromPosition:function(e,t){var n,i=this,o=i.options,r=S.max(o.smallStep*(i._maxSelection/i._distance()),0),s=0,a=r/2;if(i._isHorizontal?(s=e-t.startPoint,i._isRtl&&(s=i._maxSelection-s)):s=t.startPoint-e,i._maxSelection-(parseInt(i._maxSelection%r,10)-3)/2<s)return o.max;for(n=0;n<i._pixelSteps.length;n++)if(S.abs(i._pixelSteps[n]-s)-1<=a)return d(i._values[n])},_getFormattedValue:function(e,t){var n,i,o,r=this,s="",a=r.options.tooltip;return C(e)?(i=e[0],o=e[1]):t&&t.type&&(i=t.selectionStart,o=t.selectionEnd),t&&(n=t.tooltipTemplate),!n&&a.template&&(n=m.template(a.template)),C(e)||t&&t.type?n?s=n({selectionStart:i,selectionEnd:o}):(i=y(a.format,i),o=y(a.format,o),s=i+" - "+o):(t&&(t.val=e),s=n?n({value:e}):y(a.format,e)),s},_getDraggableArea:function(){var e=this,t=m.getOffset(e._trackDiv);return{startPoint:e._isHorizontal?t.left:t.top+e._maxSelection,endPoint:e._isHorizontal?t.left+e._maxSelection:t.top}},_createHtml:function(){var e=this,t=e.element,o=e.options,s=t.find("input");2==s.length?(s.eq(0).prop("value",l(o.selectionStart)),s.eq(1).prop("value",l(o.selectionEnd))):t.prop("value",l(o.value)),t.wrap(n(o,t,e._isHorizontal)).hide(),o.showButtons&&t.before(i(o,"increase",e._isHorizontal,e._isRtl)).before(i(o,"decrease",e._isHorizontal,e._isRtl)),t.before(r(o,t))},_focus:function(t){var n=this,i=t.target,o=n.value(),r=n._drag;r||(i==n.wrapper.find(U).eq(0)[0]?(r=n._firstHandleDrag,n._activeHandle=0):(r=n._lastHandleDrag,n._activeHandle=1),o=o[n._activeHandle]),e(i).addClass(G+" "+q),r&&(n._activeHandleDrag=r,r.selectionStart=n.options.selectionStart,r.selectionEnd=n.options.selectionEnd,r._updateTooltip(o))},_focusWithMouse:function(t){t=e(t);var n=this,i=t.is(U)?t.index():0;window.setTimeout(function(){n.wrapper.find(U)[2==i?1:0].focus()},1),n._setTooltipTimeout()},_blur:function(t){var n=this,i=n._activeHandleDrag;e(t.target).removeClass(G+" "+q),i&&(i._removeTooltip(),delete n._activeHandleDrag,delete n._activeHandle)},_setTooltipTimeout:function(){var e=this;e._tooltipTimeout=window.setTimeout(function(){var t=e._drag||e._activeHandleDrag;t&&t._removeTooltip()},300)},_clearTooltipTimeout:function(){var e,t=this;window.clearTimeout(this._tooltipTimeout),e=t._drag||t._activeHandleDrag,e&&e.tooltipDiv&&e.tooltipDiv.stop(!0,!1).css("opacity",1)},_reset:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._form=o.on("reset",x(t._formResetHandler,t)))},min:function(e){return e?(this.setOptions({min:e}),t):this.options.min},max:function(e){return e?(this.setOptions({max:e}),t):this.options.max},setOptions:function(e){g.fn.setOptions.call(this,e),this._sliderItemsInit(),this._refresh()},destroy:function(){this._form&&this._form.off("reset",this._formResetHandler),g.fn.destroy.call(this)}}),ee=J.extend({init:function(n,i){var o,r=this;n.type="text",i=w({},{value:u(n,"value"),min:u(n,"min"),max:u(n,"max"),smallStep:u(n,"step")},i),n=e(n),i&&i.enabled===t&&(i.enabled=!n.is("[disabled]")),J.fn.init.call(r,n,i),i=r.options,h(i.value)&&null!==i.value||(i.value=i.min,n.prop("value",l(i.min))),i.value=S.max(S.min(i.value,i.max),i.min),o=r.wrapper.find(U),this._selection=new ee.Selection(o,r,i),r._drag=new ee.Drag(o,"",r,i)},options:{name:"Slider",showButtons:!0,increaseButtonTitle:"Increase",decreaseButtonTitle:"Decrease",dragHandleTitle:"drag",tooltip:{format:"{0:#,#.##}"},value:null},enable:function(n){var i,o,r,s=this,a=s.options;s.disable(),n!==!1&&(s.wrapper.removeClass(K).addClass($),s.wrapper.find("input").removeAttr(Y),i=function(n){var i,o,r,a=Z(n)[0];if(a){if(i=s._isHorizontal?a.location.pageX:a.location.pageY,o=s._getDraggableArea(),r=e(n.target),r.hasClass("k-draghandle"))return r.addClass(G+" "+q),t;s._update(s._getValueFromPosition(i,o)),s._focusWithMouse(n.target),s._drag.dragstart(n),n.preventDefault()}},s.wrapper.find(j+", "+W).on(F,i).end().on(F,function(){e(document.documentElement).one("selectstart",m.preventDefault)}).on(P,function(){s._drag._end()}),s.wrapper.find(U).attr(X,0).on(z,function(){
s._setTooltipTimeout()}).on(H,function(e){s._focusWithMouse(e.target),e.preventDefault()}).on(O,x(s._focus,s)).on(V,x(s._blur,s)),o=x(function(e){var t=s._nextValueByIndex(s._valueIndex+1*e);s._setValueInRange(t),s._drag._updateTooltip(t)},s),a.showButtons&&(r=x(function(e,t){this._clearTooltipTimeout(),(1===e.which||T.touch&&0===e.which)&&(o(t),this.timeout=setTimeout(x(function(){this.timer=setInterval(function(){o(t)},60)},this),200))},s),s.wrapper.find(".k-button").on(z,x(function(e){this._clearTimer(),s._focusWithMouse(e.target)},s)).on(N,function(t){e(t.currentTarget).addClass("k-state-hover")}).on("mouseout"+M,x(function(t){e(t.currentTarget).removeClass("k-state-hover"),this._clearTimer()},s)).eq(0).on(R,x(function(e){r(e,1)},s)).click(!1).end().eq(1).on(R,x(function(e){r(e,-1)},s)).click(m.preventDefault)),s.wrapper.find(U).off(L,!1).on(L,x(this._keydown,s)),a.enabled=!0)},disable:function(){var t=this;t.wrapper.removeClass($).addClass(K),e(t.element).prop(Y,Y),t.wrapper.find(".k-button").off(R).on(R,function(t){t.preventDefault(),e(this).addClass("k-state-active")}).off(z).on(z,function(t){t.preventDefault(),e(this).removeClass("k-state-active")}).off("mouseleave"+M).on("mouseleave"+M,m.preventDefault).off(N).on(N,m.preventDefault),t.wrapper.find(j+", "+W).off(F).off(P),t.wrapper.find(U).attr(X,-1).off(z).off(L).off(H).off(O).off(V),t.options.enabled=!1},_update:function(e){var t=this,n=t.value()!=e;t.value(e),n&&t.trigger(E,{value:t.options.value})},value:function(e){var n=this,i=n.options;return e=d(e),isNaN(e)?i.value:(e>=i.min&&e<=i.max&&i.value!=e&&(n.element.prop("value",l(e)),i.value=e,n._refreshAriaAttr(e),n._refresh()),t)},_refresh:function(){this.trigger(B,{value:this.options.value})},_refreshAriaAttr:function(e){var t,n=this,i=n._drag;t=i&&i._tooltipDiv?i._tooltipDiv.text():n._getFormattedValue(e,null),this.wrapper.find(U).attr("aria-valuenow",e).attr("aria-valuetext",t)},_clearTimer:function(){clearTimeout(this.timeout),clearInterval(this.timer)},_keydown:function(e){var t=this;e.keyCode in t._keyMap&&(t._clearTooltipTimeout(),t._setValueInRange(t._keyMap[e.keyCode](t.options.value)),t._drag._updateTooltip(t.value()),e.preventDefault())},_setValueInRange:function(e){var n=this,i=n.options;return e=d(e),isNaN(e)?(n._update(i.min),t):(e=S.max(S.min(e,i.max),i.min),n._update(e),t)},_nextValueByIndex:function(e){var t=this._values.length;return this._isRtl&&(e=t-1-e),this._values[S.max(0,S.min(e,t-1))]},_formResetHandler:function(){var e=this,t=e.options.min;setTimeout(function(){var n=e.element[0].value;e.value(""===n||isNaN(n)?t:n)})},destroy:function(){var e=this;J.fn.destroy.call(e),e.wrapper.off(M).find(".k-button").off(M).end().find(U).off(M).end().find(j+", "+W).off(M).end(),e._drag.draggable.destroy(),e._drag._removeTooltip(!0)}});ee.Selection=function(e,t,n){function i(i){var o=i-n.min,r=t._valueIndex=S.ceil(d(o/n.smallStep)),s=parseInt(t._pixelSteps[r],10),a=t._trackDiv.find(".k-slider-selection"),l=parseInt(t._outerSize(e)/2,10),c=t._isRtl?2:0;a[t._sizeFn](t._isRtl?t._maxSelection-s:s),e.css(t._position,s-l-c)}i(n.value),t.bind([I,B],function(e){i(parseFloat(e.value,10))}),t.bind(E,function(e){i(parseFloat(e.sender.value(),10))})},ee.Drag=function(e,t,n,i){var o=this;o.owner=n,o.options=i,o.element=e,o.type=t,o.draggable=new v(e,{distance:0,dragstart:x(o._dragstart,o),drag:x(o.drag,o),dragend:x(o.dragend,o),dragcancel:x(o.dragcancel,o)}),e.click(!1)},ee.Drag.prototype={dragstart:function(e){this.owner._activeDragHandle=this,this.draggable.userEvents.cancel(),this._dragstart(e),this.dragend()},_dragstart:function(n){var i=this,o=i.owner,r=i.options;return r.enabled?(this.owner._activeDragHandle=this,o.element.off(N),o.wrapper.find("."+G).removeClass(G+" "+q),i.element.addClass(G+" "+q),e(document.documentElement).css("cursor","pointer"),i.dragableArea=o._getDraggableArea(),i.step=S.max(r.smallStep*(o._maxSelection/o._distance()),0),i.type?(i.selectionStart=r.selectionStart,i.selectionEnd=r.selectionEnd,o._setZIndex(i.type)):i.oldVal=i.val=r.value,i._removeTooltip(!0),i._createTooltip(),t):(n.preventDefault(),t)},_createTooltip:function(){var t,n,i=this,o=i.owner,r=i.options.tooltip,s="",a=e(window);r.enabled&&(r.template&&(t=i.tooltipTemplate=m.template(r.template)),e(".k-slider-tooltip").remove(),i.tooltipDiv=e("<div class='k-widget k-tooltip k-slider-tooltip'><!-- --></div>").appendTo(document.body),s=o._getFormattedValue(i.val||o.value(),i),i.type||(n="k-callout-"+(o._isHorizontal?"s":"e"),i.tooltipInnerDiv="<div class='k-callout "+n+"'><!-- --></div>",s+=i.tooltipInnerDiv),i.tooltipDiv.html(s),i._scrollOffset={top:a.scrollTop(),left:a.scrollLeft()},i.moveTooltip())},drag:function(e){var t,n=this,i=n.owner,o=e.x.location,r=e.y.location,s=n.dragableArea.startPoint,a=n.dragableArea.endPoint;e.preventDefault(),n.val=i._isHorizontal?i._isRtl?n.constrainValue(o,s,a,o<a):n.constrainValue(o,s,a,o>=a):n.constrainValue(r,a,s,r<=a),n.oldVal!=n.val&&(n.oldVal=n.val,n.type?("firstHandle"==n.type?n.selectionStart=n.val<n.selectionEnd?n.val:n.selectionEnd=n.val:n.val>n.selectionStart?n.selectionEnd=n.val:n.selectionStart=n.selectionEnd=n.val,t={values:[n.selectionStart,n.selectionEnd],value:[n.selectionStart,n.selectionEnd]}):t={value:n.val},i.trigger(I,t)),n._updateTooltip(n.val)},_updateTooltip:function(e){var t=this,n=t.options,i=n.tooltip,o="";i.enabled&&(t.tooltipDiv||t._createTooltip(),o=t.owner._getFormattedValue(d(e),t),t.type||(o+=t.tooltipInnerDiv),t.tooltipDiv.html(o),t.moveTooltip())},dragcancel:function(){return this.owner._refresh(),e(document.documentElement).css("cursor",""),this._end()},dragend:function(){var t=this,n=t.owner;return e(document.documentElement).css("cursor",""),t.type?n._update(t.selectionStart,t.selectionEnd):(n._update(t.val),t.draggable.userEvents._disposeAll()),t.draggable.userEvents.cancel(),t._end()},_end:function(){var e=this,t=e.owner;return t._focusWithMouse(e.element),t.element.on(N),!1},_removeTooltip:function(t){var n=this,i=n.owner;n.tooltipDiv&&i.options.tooltip.enabled&&i.options.enabled&&(t?(n.tooltipDiv.remove(),n.tooltipDiv=null):n.tooltipDiv.fadeOut("slow",function(){e(this).remove(),n.tooltipDiv=null}))},moveTooltip:function(){var t,n,i,o,r=this,s=r.owner,a=0,l=0,c=r.element,d=m.getOffset(c),u=8,h=e(window),f=r.tooltipDiv.find(".k-callout"),p=_(r.tooltipDiv),g=b(r.tooltipDiv);r.type?(t=s.wrapper.find(U),d=m.getOffset(t.eq(0)),n=m.getOffset(t.eq(1)),s._isHorizontal?(a=n.top,l=d.left+(n.left-d.left)/2):(a=d.top+(n.top-d.top)/2,l=n.left),o=_(t.eq(0))+2*u):(a=d.top,l=d.left,o=_(c)+2*u),s._isHorizontal?(l-=parseInt((p-s._outerSize(c))/2,10),a-=g+f.height()+u):(a-=parseInt((g-s._outerSize(c))/2,10),l-=p+f.width()+u),s._isHorizontal?(i=r._flip(a,g,o,b(h)+r._scrollOffset.top),a+=i,l+=r._fit(l,p,_(h)+r._scrollOffset.left)):(i=r._flip(l,p,o,_(h)+r._scrollOffset.left),a+=r._fit(a,g,b(h)+r._scrollOffset.top),l+=i),i>0&&f&&(f.removeClass(),f.addClass("k-callout k-callout-"+(s._isHorizontal?"n":"w"))),r.tooltipDiv.css({top:a,left:l})},_fit:function(e,t,n){var i=0;return e+t>n&&(i=n-(e+t)),e<0&&(i=-e),i},_flip:function(e,t,n,i){var o=0;return e+t>i&&(o+=-(n+t)),e+o<0&&(o+=n+t),o},constrainValue:function(e,t,n,i){var o=this,r=0;return r=t<e&&e<n?o.owner._getValueFromPosition(e,o.dragableArea):i?o.options.max:o.options.min}},m.ui.plugin(ee),p=J.extend({init:function(n,i){var o,r=this,s=e(n).find("input"),a=s.eq(0)[0],c=s.eq(1)[0];a.type="text",c.type="text",i&&i.showButtons&&(window.console&&window.console.warn("showbuttons option is not supported for the range slider, ignoring"),i.showButtons=!1),i=w({},{selectionStart:u(a,"value"),min:u(a,"min"),max:u(a,"max"),smallStep:u(a,"step")},{selectionEnd:u(c,"value"),min:u(c,"min"),max:u(c,"max"),smallStep:u(c,"step")},i),i&&i.enabled===t&&(i.enabled=!s.is("[disabled]")),J.fn.init.call(r,n,i),i=r.options,h(i.selectionStart)&&null!==i.selectionStart||(i.selectionStart=i.min,s.eq(0).prop("value",l(i.min))),h(i.selectionEnd)&&null!==i.selectionEnd||(i.selectionEnd=i.max,s.eq(1).prop("value",l(i.max))),o=r.wrapper.find(U),this._selection=new p.Selection(o,r,i),r._firstHandleDrag=new ee.Drag(o.eq(0),"firstHandle",r,i),r._lastHandleDrag=new ee.Drag(o.eq(1),"lastHandle",r,i)},options:{name:"RangeSlider",leftDragHandleTitle:"drag",rightDragHandleTitle:"drag",tooltip:{format:"{0:#,#.##}"},selectionStart:null,selectionEnd:null},enable:function(n){var i,o=this,r=o.options;o.disable(),n!==!1&&(o.wrapper.removeClass(K).addClass($),o.wrapper.find("input").removeAttr(Y),i=function(n){var i,s,a,l,c,d,u,h=Z(n)[0];if(h){if(i=o._isHorizontal?h.location.pageX:h.location.pageY,s=o._getDraggableArea(),a=o._getValueFromPosition(i,s),l=e(n.target),l.hasClass("k-draghandle"))return o.wrapper.find("."+G).removeClass(G+" "+q),l.addClass(G+" "+q),t;a<r.selectionStart?(c=a,d=r.selectionEnd,u=o._firstHandleDrag):a>o.selectionEnd?(c=r.selectionStart,d=a,u=o._lastHandleDrag):a-r.selectionStart<=r.selectionEnd-a?(c=a,d=r.selectionEnd,u=o._firstHandleDrag):(c=r.selectionStart,d=a,u=o._lastHandleDrag),u.dragstart(n),o._setValueInRange(c,d),o._focusWithMouse(u.element)}},o.wrapper.find(j+", "+W).on(F,i).end().on(F,function(){e(document.documentElement).one("selectstart",m.preventDefault)}).on(P,function(){o._activeDragHandle&&o._activeDragHandle._end()}),o.wrapper.find(U).attr(X,0).on(z,function(){o._setTooltipTimeout()}).on(H,function(e){o._focusWithMouse(e.target),e.preventDefault()}).on(O,x(o._focus,o)).on(V,x(o._blur,o)),o.wrapper.find(U).off(L,m.preventDefault).eq(0).on(L,x(function(e){this._keydown(e,"firstHandle")},o)).end().eq(1).on(L,x(function(e){this._keydown(e,"lastHandle")},o)),o.options.enabled=!0)},disable:function(){var e=this;e.wrapper.removeClass($).addClass(K),e.wrapper.find("input").prop(Y,Y),e.wrapper.find(j+", "+W).off(F).off(P),e.wrapper.find(U).attr(X,-1).off(z).off(L).off(H).off(O).off(V),e.options.enabled=!1},_keydown:function(e,t){var n,i,o,r=this,s=r.options.selectionStart,a=r.options.selectionEnd;e.keyCode in r._keyMap&&(r._clearTooltipTimeout(),"firstHandle"==t?(o=r._activeHandleDrag=r._firstHandleDrag,s=r._keyMap[e.keyCode](s),s>a&&(a=s)):(o=r._activeHandleDrag=r._lastHandleDrag,a=r._keyMap[e.keyCode](a),s>a&&(s=a)),r._setValueInRange(d(s),d(a)),n=Math.max(s,r.options.selectionStart),i=Math.min(a,r.options.selectionEnd),o.selectionEnd=Math.max(i,r.options.selectionStart),o.selectionStart=Math.min(n,r.options.selectionEnd),o._updateTooltip(r.value()[r._activeHandle]),e.preventDefault())},_update:function(e,t){var n=this,i=n.value(),o=i[0]!=e||i[1]!=t;n.value([e,t]),o&&n.trigger(E,{values:[e,t],value:[e,t]})},value:function(e){return e&&e.length?this._value(e[0],e[1]):this._value()},_value:function(e,n){var i=this,o=i.options,r=o.selectionStart,s=o.selectionEnd;return isNaN(e)&&isNaN(n)?[r,s]:(e=d(e),n=d(n),e>=o.min&&e<=o.max&&n>=o.min&&n<=o.max&&e<=n&&(r==e&&s==n||(i.element.find("input").eq(0).prop("value",l(e)).end().eq(1).prop("value",l(n)),o.selectionStart=e,o.selectionEnd=n,i._refresh(),i._refreshAriaAttr(e,n))),t)},values:function(e,t){return C(e)?this._value(e[0],e[1]):this._value(e,t)},_refresh:function(){var e=this,t=e.options;e.trigger(B,{values:[t.selectionStart,t.selectionEnd],value:[t.selectionStart,t.selectionEnd]}),t.selectionStart==t.max&&t.selectionEnd==t.max&&e._setZIndex("firstHandle")},_refreshAriaAttr:function(e,t){var n,i=this,o=i.wrapper.find(U),r=i._activeHandleDrag;n=i._getFormattedValue([e,t],r),o.eq(0).attr("aria-valuenow",e),o.eq(1).attr("aria-valuenow",t),o.attr("aria-valuetext",n)},_setValueInRange:function(e,t){var n=this.options;e=S.max(S.min(e,n.max),n.min),t=S.max(S.min(t,n.max),n.min),e==n.max&&t==n.max&&this._setZIndex("firstHandle"),this._update(S.min(e,t),S.max(e,t))},_setZIndex:function(t){this.wrapper.find(U).each(function(n){e(this).css("z-index","firstHandle"==t?1-n:n)})},_formResetHandler:function(){var e=this,t=e.options;setTimeout(function(){var n=e.element.find("input"),i=n[0].value,o=n[1].value;e.values(""===i||isNaN(i)?t.min:i,""===o||isNaN(o)?t.max:o)})},destroy:function(){var e=this;J.fn.destroy.call(e),e.wrapper.off(M).find(j+", "+W).off(M).end().find(U).off(M),e._firstHandleDrag.draggable.destroy(),e._lastHandleDrag.draggable.destroy()}}),p.Selection=function(e,t,n){function i(i){i=i||[];var r=i[0]-n.min,s=i[1]-n.min,a=S.ceil(d(r/n.smallStep)),l=S.ceil(d(s/n.smallStep)),c=t._pixelSteps[a],u=t._pixelSteps[l],h=parseInt(t._outerSize(e.eq(0))/2,10),f=t._isRtl?2:0;e.eq(0).css(t._position,c-h-f).end().eq(1).css(t._position,u-h-f),o(c,u)}function o(e,n){var i,o,r=t._trackDiv.find(".k-slider-selection");i=S.abs(e-n),r[t._sizeFn](i),t._isRtl?(o=S.max(e,n),r.css("right",t._maxSelection-o-1)):(o=S.min(e,n),r.css(t._position,o-1))}i(t.value()),t.bind([E,I,B],function(e){i(e.values)})},m.ui.plugin(p)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.colorpicker.min",["kendo.core.min","kendo.color.min","kendo.popup.min","kendo.slider.min","kendo.userevents.min","kendo.button.min"],e)}(function(){return function(e,t,n){function i(e,t,n){n=d(n),n&&!n.equals(e.color())&&("change"==t&&(e._value=n),n=1!=n.a?n.toCssRgba():n.toCss(),e.trigger(t,{value:n}))}function o(e,t,n){var i,o;return e=Array.prototype.slice.call(e),i=e.length,o=e.indexOf(t),o<0?n<0?e[i-1]:e[0]:(o+=n,o<0?o+=i:o%=i,e[o])}function r(e){e.preventDefault()}function s(e,t){return function(){return e.apply(t,arguments)}}var a=window.kendo,l=a.ui,c=l.Widget,d=a.parseColor,u=a.Color,h=a.keys,f="background-color",p="k-state-selected",m="000000,7f7f7f,880015,ed1c24,ff7f27,fff200,22b14c,00a2e8,3f48cc,a349a4,ffffff,c3c3c3,b97a57,ffaec9,ffc90e,efe4b0,b5e61d,99d9ea,7092be,c8bfe7",g="FFFFFF,FFCCFF,FF99FF,FF66FF,FF33FF,FF00FF,CCFFFF,CCCCFF,CC99FF,CC66FF,CC33FF,CC00FF,99FFFF,99CCFF,9999FF,9966FF,9933FF,9900FF,FFFFCC,FFCCCC,FF99CC,FF66CC,FF33CC,FF00CC,CCFFCC,CCCCCC,CC99CC,CC66CC,CC33CC,CC00CC,99FFCC,99CCCC,9999CC,9966CC,9933CC,9900CC,FFFF99,FFCC99,FF9999,FF6699,FF3399,FF0099,CCFF99,CCCC99,CC9999,CC6699,CC3399,CC0099,99FF99,99CC99,999999,996699,993399,990099,FFFF66,FFCC66,FF9966,FF6666,FF3366,FF0066,CCFF66,CCCC66,CC9966,CC6666,CC3366,CC0066,99FF66,99CC66,999966,996666,993366,990066,FFFF33,FFCC33,FF9933,FF6633,FF3333,FF0033,CCFF33,CCCC33,CC9933,CC6633,CC3333,CC0033,99FF33,99CC33,999933,996633,993333,990033,FFFF00,FFCC00,FF9900,FF6600,FF3300,FF0000,CCFF00,CCCC00,CC9900,CC6600,CC3300,CC0000,99FF00,99CC00,999900,996600,993300,990000,66FFFF,66CCFF,6699FF,6666FF,6633FF,6600FF,33FFFF,33CCFF,3399FF,3366FF,3333FF,3300FF,00FFFF,00CCFF,0099FF,0066FF,0033FF,0000FF,66FFCC,66CCCC,6699CC,6666CC,6633CC,6600CC,33FFCC,33CCCC,3399CC,3366CC,3333CC,3300CC,00FFCC,00CCCC,0099CC,0066CC,0033CC,0000CC,66FF99,66CC99,669999,666699,663399,660099,33FF99,33CC99,339999,336699,333399,330099,00FF99,00CC99,009999,006699,003399,000099,66FF66,66CC66,669966,666666,663366,660066,33FF66,33CC66,339966,336666,333366,330066,00FF66,00CC66,009966,006666,003366,000066,66FF33,66CC33,669933,666633,663333,660033,33FF33,33CC33,339933,336633,333333,330033,00FF33,00CC33,009933,006633,003333,000033,66FF00,66CC00,669900,666600,663300,660000,33FF00,33CC00,339900,336600,333300,330000,00FF00,00CC00,009900,006600,003300,000000",v="#ffffff",_={apply:"Apply",cancel:"Cancel",noColor:"no color",clearColor:"Clear color",previewInput:"Color Hexadecimal Code"},b=".kendoColorTools",w="click"+b,y="keydown"+b,k=a.support.browser,x=k.msie&&k.version<9,C=c.extend({init:function(e,t){var n,i=this;c.fn.init.call(i,e,t),e=i.element,t=i.options,i._value=t.value=d(t.value),i._tabIndex=e.attr("tabIndex")||0,n=i._ariaId=t.ariaId,n&&e.attr("aria-labelledby",n),t._standalone&&(i._triggerSelect=i._triggerChange)},options:{name:"ColorSelector",value:null,_standalone:!0},events:["change","select","cancel"],color:function(e){return e!==n&&(this._value=d(e),this._updateUI(this._value)),this._value},value:function(e){return e=this.color(e),e&&(e=this.options.opacity?e.toCssRgba():e.toCss()),e||null},enable:function(t){0===arguments.length&&(t=!0),e(".k-disabled-overlay",this.wrapper).remove(),t||this.wrapper.append("<div class='k-disabled-overlay'></div>"),this._onEnable(t)},_select:function(e,t){var n=this._value;e=this.color(e),t||(this.element.trigger("change"),e.equals(n)?this._standalone||this.trigger("cancel"):this.trigger("change",{value:this.value()}))},_triggerSelect:function(e){i(this,"select",e)},_triggerChange:function(e){i(this,"change",e)},destroy:function(){this.element&&this.element.off(b),this.wrapper&&this.wrapper.off(b).find("*").off(b),this.wrapper=null,c.fn.destroy.call(this)},_updateUI:e.noop,_selectOnHide:function(){return null},_cancel:function(){this.trigger("cancel")}}),S=C.extend({init:function(t,n){var i,o,r,l,c=this;if(C.fn.init.call(c,t,n),t=c.wrapper=c.element,n=c.options,i=n.palette,"websafe"==i?(i=g,n.columns=18):"basic"==i&&(i=m),"string"==typeof i&&(i=i.split(",")),e.isArray(i)&&(i=e.map(i,function(e){return d(e)})),c._selectedID=(n.ariaId||a.guid())+"_selected",t.addClass("k-widget k-colorpalette").attr("role","grid").attr("aria-readonly","true").append(e(c._template({colors:i,columns:n.columns,tileSize:n.tileSize,value:c._value,id:n.ariaId}))).on(w,".k-item",function(t){c._select(e(t.currentTarget).css(f))}).attr("tabIndex",c._tabIndex).on(y,s(c._keydown,c)),o=n.tileSize){if(/number|string/.test(typeof o))r=l=parseFloat(o);else{if("object"!=typeof o)throw Error("Unsupported value for the 'tileSize' argument");r=parseFloat(o.width),l=parseFloat(o.height)}t.find(".k-item").css({width:r,height:l})}},focus:function(){this.wrapper&&!this.wrapper.is("[unselectable='on']")&&this.wrapper.focus()},options:{name:"ColorPalette",columns:10,tileSize:null,palette:"basic"},_onEnable:function(e){e?this.wrapper.attr("tabIndex",this._tabIndex):this.wrapper.removeAttr("tabIndex")},_keydown:function(t){var n,i,s=this.wrapper,a=s.find(".k-item"),l=a.filter("."+p).get(0),c=t.keyCode;if(c==h.LEFT?n=o(a,l,-1):c==h.RIGHT?n=o(a,l,1):c==h.DOWN?n=o(a,l,this.options.columns):c==h.UP?n=o(a,l,-this.options.columns):c==h.ENTER?(r(t),l&&this._select(e(l).css(f))):c==h.ESC&&this._cancel(),n){r(t),this._current(n);try{i=d(n.css(f)),this._triggerSelect(i)}catch(u){}}},_current:function(t){this.wrapper.find("."+p).removeClass(p).attr("aria-selected",!1).removeAttr("id"),e(t).addClass(p).attr("aria-selected",!0).attr("id",this._selectedID),this.element.removeAttr("aria-activedescendant").attr("aria-activedescendant",this._selectedID)},_updateUI:function(t){var n=null;this.wrapper.find(".k-item").each(function(){var i=d(e(this).css(f));if(i&&i.equals(t))return n=this,!1}),this._current(n)},_template:a.template('<table class="k-palette k-reset" role="presentation"><tr role="row"># for (var i = 0; i < colors.length; ++i) { ## var selected = colors[i].equals(value); ## if (i && i % columns == 0) { # </tr><tr role="row"> # } #<td role="gridcell" unselectable="on" style="background-color:#= colors[i].toCss() #"#= selected ? " aria-selected=true" : "" # #=(id && i === 0) ? "id=\\""+id+"\\" " : "" # class="k-item#= selected ? " '+p+'" : "" #" aria-label="#= colors[i].toCss() #"></td># } #</tr></table>')}),T=C.extend({init:function(t,n){var i=this;C.fn.init.call(i,t,n),n=i.options,n.messages=n.options?e.extend(i.options.messages,n.options.messages):i.options.messages,t=i.element,i.wrapper=t.addClass("k-widget k-flatcolorpicker").append(i._template(n)),i._hueElements=e(".k-hsv-rectangle, .k-transparency-slider .k-slider-track",t),i._selectedColor=e(".k-selected-color-display",t),i._colorAsText=e("input.k-color-value",t),i._sliders(),i._hsvArea(),i._updateUI(i._value||d("#f00")),t.find("input.k-color-value").on(y,function(t){var n,o,r=this;if(t.keyCode==h.ENTER)try{n=d(r.value),o=i.color(),i._select(n,n.equals(o))}catch(s){e(r).addClass("k-state-error")}else i.options.autoupdate&&setTimeout(function(){var e=d(r.value,!0);e&&i._updateUI(e,!0)},10)}).end().on(w,".k-controls button.apply",function(){i.options._clearedColor?i.trigger("change"):i._select(i._getHSV())}).on(w,".k-controls button.cancel",function(){i._updateUI(i.color()),i._cancel()}),x&&i._applyIEFilter()},destroy:function(){this._hueSlider.destroy(),this._opacitySlider&&this._opacitySlider.destroy(),this._hueSlider=this._opacitySlider=this._hsvRect=this._hsvHandle=this._hueElements=this._selectedColor=this._colorAsText=null,C.fn.destroy.call(this)},options:{name:"FlatColorPicker",opacity:!1,buttons:!1,input:!0,preview:!0,clearButton:!1,autoupdate:!0,messages:_},_applyIEFilter:function(){var e=this.element.find(".k-hue-slider .k-slider-track")[0],t=e.currentStyle.backgroundImage;t=t.replace(/^url\([\'\"]?|[\'\"]?\)$/g,""),e.style.filter="progid:DXImageTransform.Microsoft.AlphaImageLoader(src='"+t+"', sizingMethod='scale')"},_sliders:function(){function e(e){n._updateUI(n._getHSV(e.value,null,null,null))}function t(e){n._updateUI(n._getHSV(null,null,null,e.value/100))}var n=this,i=n.element,o=i.find(".k-hue-slider"),r=i.find(".k-transparency-slider");o.attr("aria-label","hue saturation"),n._hueSlider=o.kendoSlider({min:0,max:360,tickPlacement:"none",showButtons:!1,slide:e,change:e}).data("kendoSlider"),r.attr("aria-label","opacity"),n._opacitySlider=r.kendoSlider({min:0,max:100,tickPlacement:"none",showButtons:!1,slide:t,change:t}).data("kendoSlider")},_hsvArea:function(){function e(e,n){var i=this.offset,o=e-i.left,r=n-i.top,s=this.width,a=this.height;o=o<0?0:o>s?s:o,r=r<0?0:r>a?a:r,t._svChange(o/s,1-r/a)}var t=this,n=t.element,i=n.find(".k-hsv-rectangle"),o=i.find(".k-draghandle").attr("tabIndex",0).on(y,s(t._keydown,t));t._hsvEvents=new a.UserEvents(i,{global:!0,press:function(t){this.offset=a.getOffset(i),this.width=i.width(),this.height=i.height(),o.focus(),e.call(this,t.x.location,t.y.location)},start:function(){i.addClass("k-dragging"),o.focus()},move:function(t){t.preventDefault(),e.call(this,t.x.location,t.y.location)},end:function(){i.removeClass("k-dragging")}}),t._hsvRect=i,t._hsvHandle=o},_onEnable:function(e){this._hueSlider.enable(e),this._opacitySlider&&this._opacitySlider.enable(e),this.wrapper.find("input").attr("disabled",!e);var t=this._hsvRect.find(".k-draghandle");e?t.attr("tabIndex",this._tabIndex):t.removeAttr("tabIndex")},_keydown:function(e){function t(t,n){var o=i._getHSV();o[t]+=n*(e.shiftKey?.01:.05),o[t]<0&&(o[t]=0),o[t]>1&&(o[t]=1),i._updateUI(o),r(e)}function n(t){var n=i._getHSV();n.h+=t*(e.shiftKey?1:5),n.h<0&&(n.h=0),n.h>359&&(n.h=359),i._updateUI(n),r(e)}var i=this;switch(e.keyCode){case h.LEFT:e.ctrlKey?n(-1):t("s",-1);break;case h.RIGHT:e.ctrlKey?n(1):t("s",1);break;case h.UP:t(e.ctrlKey&&i._opacitySlider?"a":"v",1);break;case h.DOWN:t(e.ctrlKey&&i._opacitySlider?"a":"v",-1);break;case h.ENTER:i._select(i._getHSV());break;case h.F2:i.wrapper.find("input.k-color-value").focus().select();break;case h.ESC:i._cancel()}},focus:function(){this._hsvHandle.focus()},_getHSV:function(e,t,n,i){var o=this._hsvRect,r=o.width(),s=o.height(),a=this._hsvHandle.position();return null==e&&(e=this._hueSlider.value()),null==t&&(t=a.left/r),null==n&&(n=1-a.top/s),null==i&&(i=this._opacitySlider?this._opacitySlider.value()/100:1),u.fromHSV(e,t,n,i)},_svChange:function(e,t){var n=this._getHSV(null,e,t,null);this._updateUI(n)},_updateUI:function(e,t){var n=this,i=n._hsvRect;e&&(this._colorAsText.attr("title",n.options.messages.previewInput),this._colorAsText.removeClass("k-state-error"),n._selectedColor.css(f,e.toDisplay()),t||n._colorAsText.val(n._opacitySlider?e.toCssRgba():e.toCss()),n._triggerSelect(e),e=e.toHSV(),n._hsvHandle.css({left:e.s*i.width()+"px",top:(1-e.v)*i.height()+"px"}),n._hueElements.css(f,u.fromHSV(e.h,1,1,1).toCss()),n._hueSlider.value(e.h),n._opacitySlider&&n._opacitySlider.value(100*e.a))},_selectOnHide:function(){return this.options.buttons?null:this._getHSV()},_template:a.template('# if (preview) { #<div class="k-selected-color"><div class="k-selected-color-display"><div class="k-color-input"><input class="k-color-value" # if (clearButton && !_standalone) { #placeholder="#: messages.noColor #" # } ##= !data.input ? \'style="visibility: hidden;"\' : "" #># if (clearButton && !_standalone) { #<span class="k-clear-color k-button k-bare" title="#: messages.clearColor #"></span># } #</div></div></div># } ## if (clearButton && !_standalone && !preview) { #<div class="k-clear-color-container"><span class="k-clear-color k-button k-bare">#: messages.clearColor #</span></div># } #<div class="k-hsv-rectangle"><div class="k-hsv-gradient"></div><div class="k-draghandle"></div></div><input class="k-hue-slider" /># if (opacity) { #<input class="k-transparency-slider" /># } ## if (buttons) { #<div unselectable="on" class="k-controls"><button class="k-button k-primary apply">#: messages.apply #</button> <button class="k-button cancel">#: messages.cancel #</button></div># } #')}),D=c.extend({init:function(t,n){var i,o,r,s,a,l=this;c.fn.init.call(l,t,n),n=l.options,t=l.element,i=t.attr("value")||t.val(),i=i?d(i,!0):d(n.value,!0),l._value=n.value=i,o=l.wrapper=e(l._template(n)),t.hide().after(o),t.is("input")&&(t.appendTo(o),r=t.closest("label"),s=t.attr("id"),s&&(r=r.add('label[for="'+s+'"]')),r.click(function(e){l.open(),e.preventDefault()})),l._tabIndex=t.attr("tabIndex")||0,l.enable(!t.attr("disabled")),a=t.attr("accesskey"),a&&(t.attr("accesskey",null),o.attr("accesskey",a)),l.bind("activate",function(e){e.isDefaultPrevented()||l.toggle()}),l._updateUI(i)},destroy:function(){this.wrapper.off(b).find("*").off(b),this._popup&&(this._selector.destroy(),this._popup.destroy()),this._selector=this._popup=this.wrapper=null,c.fn.destroy.call(this)},enable:function(e){var t=this,n=t.wrapper,i=n.children(".k-picker-wrap"),o=i.find(".k-select");0===arguments.length&&(e=!0),t.element.attr("disabled",!e),n.attr("aria-disabled",!e),o.off(b).on("mousedown"+b,r),n.addClass("k-state-disabled").removeAttr("tabIndex").add("*",n).off(b),e?n.removeClass("k-state-disabled").attr("tabIndex",t._tabIndex).on("mouseenter"+b,function(){i.addClass("k-state-hover")}).on("mouseleave"+b,function(){i.removeClass("k-state-hover")}).on("focus"+b,function(){i.addClass("k-state-focused")}).on("blur"+b,function(){i.removeClass("k-state-focused")}).on(y,s(t._keydown,t)).on(w,".k-select",s(t.toggle,t)).on(w,t.options.toolIcon?".k-tool-icon":".k-selected-color",function(){t.trigger("activate")}):t.close()},_template:a.template('<span role="textbox" aria-haspopup="true" class="k-widget k-colorpicker k-header"><span class="k-picker-wrap k-state-default"># if (toolIcon) { #<span class="k-icon k-tool-icon #= toolIcon #"><span class="k-selected-color"></span></span># } else { #<span class="k-selected-color"><span class="k-icon k-i-line" style="display: none;"></span></span># } #<span class="k-select" unselectable="on" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span></span>'),options:{name:"ColorPicker",palette:null,columns:10,toolIcon:null,value:null,messages:_,opacity:!1,buttons:!0,preview:!0,clearButton:!1,ARIATemplate:'Current selected color is #=data || ""#'},events:["activate","change","select","open","close"],open:function(){this.element.prop("disabled")||this._getPopup().open()},close:function(){var e=this._selector&&this._selector.options||{};e._closing=!0,this._getPopup().close(),delete e._closing},toggle:function(){this.element.prop("disabled")||this._getPopup().toggle()},_noColorIcon:function(){return this.wrapper.find(".k-picker-wrap > .k-selected-color > .k-icon.k-i-line")},color:C.fn.color,value:C.fn.value,_select:C.fn._select,_triggerSelect:C.fn._triggerSelect,_isInputTypeColor:function(){var e=this.element[0];return/^input$/i.test(e.tagName)&&/^color$/i.test(e.type)},_updateUI:function(e){var t="";e&&(t=this._isInputTypeColor()||1==e.a?e.toCss():e.toCssRgba(),this.element.val(t)),this._ariaTemplate||(this._ariaTemplate=a.template(this.options.ARIATemplate)),this.wrapper.attr("aria-label",this._ariaTemplate(t)),this._triggerSelect(e),this.wrapper.find(".k-selected-color").css(f,e?e.toDisplay():v),this._noColorIcon()[t?"hide":"show"]()},_keydown:function(e){var t=e.keyCode;this._getPopup().visible()?(t==h.ESC?this._selector._cancel():this._selector._keydown(e),r(e)):t!=h.ENTER&&t!=h.DOWN||(this.open(),r(e))},_getPopup:function(){var t,i,o,r,s=this,l=s._popup;return l||(t=s.options,i=t.palette?S:T,t._standalone=!1,delete t.select,delete t.change,delete t.cancel,o=a.guid(),r=s._selector=new i(e('<div id="'+o+'"/>').appendTo(document.body),t),s.wrapper.attr("aria-owns",o),s._popup=l=r.wrapper.kendoPopup({anchor:s.wrapper,adjustSize:{width:5,height:0}}).data("kendoPopup"),r.element.find(".k-clear-color").kendoButton({icon:"reset-color",click:function(e){r.options._clearedColor=!0,s.value(null),s.element.val(null),s._updateUI(null),r._colorAsText.val(""),r._hsvHandle.css({top:"0px",left:"0px"}),r._selectedColor.css(f,v),s.trigger("change",{value:s.value()}),e.preventDefault()}}),r.bind({select:function(e){s._updateUI(d(e.value)),delete r.options._clearedColor},change:function(){r.options._clearedColor||s._select(r.color()),s.close()},cancel:function(){r.options._clearedColor&&!s.value()&&r.value()&&s._select(r.color(),!0),s.close()}}),l.bind({close:function(e){var t,i,o,a;return s.trigger("close")?(e.preventDefault(),n):(s.wrapper.children(".k-picker-wrap").removeClass("k-state-focused"),t=r._selectOnHide(),i=r.value(),o=s.value(),a=r.options,t?a._clearedColor&&!o||s._select(t):(setTimeout(function(){s.wrapper&&!s.wrapper.is("[unselectable='on']")&&s.wrapper.focus()}),!a._closing&&a._clearedColor&&!o&&i?s._select(i,!0):s._updateUI(s.color())),n)},open:function(e){s.trigger("open")?e.preventDefault():s.wrapper.children(".k-picker-wrap").addClass("k-state-focused")},activate:function(){r._select(s.color(),!0),r.focus(),s.wrapper.children(".k-picker-wrap").addClass("k-state-focused")}})),l}});l.plugin(S),l.plugin(T),l.plugin(D)}(jQuery,parseInt),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.numerictextbox.min",["kendo.core.min","kendo.userevents.min"],e)}(function(){return function(e,t){function n(e,t){var n="k-i-arrow-"+("increase"===e?"60-up":"60-down");return'<span unselectable="on" class="k-link k-link-'+e+'" aria-label="'+t+'" title="'+t+'"><span unselectable="on" class="'+A+" "+n+'"></span></span>'}function i(e,t){var n=(""+parseFloat(e,10)).split(D);return n[1]&&(n[1]=n[1].substring(0,t)),n.join(D)}var o=window.kendo,r=o.caret,s=o.keys,a=o.ui,l=a.Widget,c=o._activeElement,d=o._extractFormat,u=o.parseFloat,h=o.support.placeholder,f=o.getCulture,p="change",m="disabled",g="readonly",v="k-input",_="spin",b=".kendoNumericTextBox",w="touchend",y="mouseleave"+b,k="mouseenter"+b+" "+y,x="k-state-default",C="k-state-focused",S="k-state-hover",T="focus",D=".",A="k-icon",E="k-state-selected",I="k-state-disabled",M="k-state-invalid",R="aria-disabled",F=/^(-)?(\d*)$/,z=null,P=e.proxy,B=e.extend,L=l.extend({init:function(n,i){var r,s,a,c,u,h=this,f=i&&i.step!==t;l.fn.init.call(h,n,i),i=h.options,n=h.element.on("focusout"+b,P(h._focusout,h)).attr("role","spinbutton"),i.placeholder=i.placeholder||n.attr("placeholder"),r=h.min(n.attr("min")),s=h.max(n.attr("max")),a=h._parse(n.attr("step")),i.min===z&&r!==z&&(i.min=r),i.max===z&&s!==z&&(i.max=s),f||a===z||(i.step=a),h._initialOptions=B({},i),h._reset(),h._wrapper(),h._arrows(),h._validation(),h._input(),o.support.mobileOS?h._text.on(w+b+" "+T+b,function(){o.support.browser.edge?h._text.one(T+b,function(){h._toggleText(!1),n.focus()}):(h._toggleText(!1),n.focus())}):h._text.on(T+b,P(h._click,h)),n.attr("aria-valuemin",i.min!==z?i.min*i.factor:i.min).attr("aria-valuemax",i.max!==z?i.max*i.factor:i.max),i.format=d(i.format),c=i.value,h.value(c!==z?c:n.val()),u=n.is("[disabled]")||e(h.element).parents("fieldset").is(":disabled"),u?h.enable(!1):h.readonly(n.is("[readonly]")),o.notify(h)},options:{name:"NumericTextBox",decimals:z,restrictDecimals:!1,min:z,max:z,value:z,step:1,round:!0,culture:"",format:"n",spinners:!0,placeholder:"",factor:1,upArrowText:"Increase value",
downArrowText:"Decrease value"},events:[p,_],_editable:function(e){var t=this,n=t.element,i=e.disable,o=e.readonly,r=t._text.add(n),s=t._inputWrapper.off(k);t._toggleText(!0),t._upArrowEventHandler.unbind("press"),t._downArrowEventHandler.unbind("press"),n.off("keydown"+b).off("keypress"+b).off("keyup"+b).off("paste"+b),o||i?(s.addClass(i?I:x).removeClass(i?x:I),r.attr(m,i).attr(g,o).attr(R,i)):(s.addClass(x).removeClass(I).on(k,t._toggleHover),r.removeAttr(m).removeAttr(g).attr(R,!1),t._upArrowEventHandler.bind("press",function(e){e.preventDefault(),t._spin(1),t._upArrow.addClass(E)}),t._downArrowEventHandler.bind("press",function(e){e.preventDefault(),t._spin(-1),t._downArrow.addClass(E)}),t.element.on("keydown"+b,P(t._keydown,t)).on("keypress"+b,P(t._keypress,t)).on("keyup"+b,P(t._keyup,t)).on("paste"+b,P(t._paste,t)))},readonly:function(e){this._editable({readonly:e===t||e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t||e)})},setOptions:function(e){var n=this;l.fn.setOptions.call(n,e),n._arrowsWrap.toggle(n.options.spinners),n._inputWrapper.toggleClass("k-expand-padding",!n.options.spinners),n._text.prop("placeholder",n.options.placeholder),n._placeholder(n.options.placeholder),n.element.attr({"aria-valuemin":n.options.min!==z?n.options.min*n.options.factor:n.options.min,"aria-valuemax":n.options.max!==z?n.options.max*n.options.factor:n.options.max}),n.options.format=d(n.options.format),e.value!==t&&n.value(e.value)},destroy:function(){var e=this;e.element.add(e._text).add(e._upArrow).add(e._downArrow).add(e._inputWrapper).off(b),e._upArrowEventHandler.destroy(),e._downArrowEventHandler.destroy(),e._form&&e._form.off("reset",e._resetHandler),l.fn.destroy.call(e)},min:function(e){return this._option("min",e)},max:function(e){return this._option("max",e)},step:function(e){return this._option("step",e)},value:function(e){var n,i=this;return e===t?i._value:(e=i._parse(e),n=i._adjust(e),e===n&&(i._update(e),i._old=i._value),t)},focus:function(){this._focusin()},_adjust:function(e){var t=this,n=t.options,i=n.min,o=n.max;return e===z?e:(i!==z&&e<i?e=i:o!==z&&e>o&&(e=o),e)},_arrows:function(){var t,i=this,r=function(){clearTimeout(i._spinning),t.removeClass(E)},s=i.options,a=s.spinners,l=i.element;t=l.siblings("."+A),t[0]||(t=e(n("increase",s.upArrowText)+n("decrease",s.downArrowText)).insertAfter(l),i._arrowsWrap=t.wrapAll('<span class="k-select"/>').parent()),a||(t.parent().toggle(a),i._inputWrapper.addClass("k-expand-padding")),i._upArrow=t.eq(0),i._upArrowEventHandler=new o.UserEvents(i._upArrow,{release:r}),i._downArrow=t.eq(1),i._downArrowEventHandler=new o.UserEvents(i._downArrow,{release:r})},_validation:function(){var t=this,n=t.element;t._validationIcon=e("<span class='"+A+" k-i-warning'></span>").hide().insertAfter(n)},_blur:function(){var e=this;e._toggleText(!0),e._change(e.element.val())},_click:function(e){var t=this;clearTimeout(t._focusing),t._focusing=setTimeout(function(){var n,i,o,s=e.target,a=r(s)[0],l=s.value.substring(0,a),c=t._format(t.options.format),d=c[","],u=0;d&&(i=RegExp("\\"+d,"g"),o=RegExp("([\\d\\"+d+"]+)(\\"+c[D]+")?(\\d+)?")),o&&(n=o.exec(l)),n&&(u=n[0].replace(i,"").length,l.indexOf("(")!=-1&&t._value<0&&u++),t._focusin(),r(t.element[0],u)})},_change:function(e){var t=this,n=t.options.factor;n&&1!==n&&(e=o.parseFloat(e),null!==e&&(e/=n)),t._update(e),e=t._value,t._old!=e&&(t._old=e,t._typing||t.element.trigger(p),t.trigger(p)),t._typing=!1},_culture:function(e){return e||f(this.options.culture)},_focusin:function(){var e=this;e._inputWrapper.addClass(C),e._toggleText(!1),e.element[0].focus()},_focusout:function(){var e=this;clearTimeout(e._focusing),e._inputWrapper.removeClass(C).removeClass(S),e._blur(),e._removeInvalidState()},_format:function(e,t){var n=this._culture(t).numberFormat;return e=e.toLowerCase(),e.indexOf("c")>-1?n=n.currency:e.indexOf("p")>-1&&(n=n.percent),n},_input:function(){var t,n=this,i=n.options,o="k-formatted-value",r=n.element.addClass(v).show()[0],s=r.accessKey,a=n.wrapper;t=a.find(D+o),t[0]||(t=e('<input type="text"/>').insertBefore(r).addClass(o));try{r.setAttribute("type","text")}catch(l){r.type="text"}n._initialTitle=r.title,t[0].title=r.title,t[0].tabIndex=r.tabIndex,t[0].style.cssText=r.style.cssText,t.prop("placeholder",i.placeholder),s&&(t.attr("accesskey",s),r.accessKey=""),n._text=t.addClass(r.className).attr({role:"spinbutton","aria-valuemin":i.min!==z?i.min*i.factor:i.min,"aria-valuemax":i.max!==z?i.max*i.factor:i.max})},_keydown:function(e){var t=this,n=e.keyCode;t._key=n,n==s.DOWN?t._step(-1):n==s.UP?t._step(1):n==s.ENTER?t._change(t.element.val()):t._typing=!0},_keypress:function(e){var t,n,i,o,a,l,c,d,u,h,f;0===e.which||e.metaKey||e.ctrlKey||e.keyCode===s.BACKSPACE||e.keyCode===s.ENTER||(t=this,n=t.options.min,i=t.element,o=r(i),a=o[0],l=o[1],c=String.fromCharCode(e.which),d=t._format(t.options.format),u=t._key===s.NUMPAD_DOT,h=i.val(),u&&(c=d[D]),h=h.substring(0,a)+c+h.substring(l),f=t._numericRegex(d).test(h),f&&u?(i.val(h),r(i,a+c.length),e.preventDefault()):(null!==n&&n>=0&&"-"===h.charAt(0)||!f)&&(t._addInvalidState(),e.preventDefault()),t._key=0)},_keyup:function(){this._removeInvalidState()},_addInvalidState:function(){var e=this;e._inputWrapper.addClass(M),e._validationIcon.show()},_removeInvalidState:function(){var e=this;e._inputWrapper.removeClass(M),e._validationIcon.hide()},_numericRegex:function(e){var t=this,n=e[D],i=t.options.decimals,o="*";return n===D&&(n="\\"+n),i===z&&(i=e.decimals),0===i&&t.options.restrictDecimals?F:(t.options.restrictDecimals&&(o="{0,"+i+"}"),t._separator!==n&&(t._separator=n,t._floatRegExp=RegExp("^(-)?(((\\d+("+n+"\\d"+o+")?)|("+n+"\\d"+o+")))?$")),t._floatRegExp)},_paste:function(e){var t=this,n=e.target,i=n.value,o=t._format(t.options.format);setTimeout(function(){var e=t._parse(n.value);e===z?t._update(i):(n.value=(""+e).replace(D,o[D]),t._adjust(e)===e&&t._numericRegex(o).test(n.value)||t._update(i))})},_option:function(e,n){var i=this,o=i.element,r=i.options;return n===t?r[e]:(n=i._parse(n),(n||"step"!==e)&&(r[e]=n,o.add(i._text).attr("aria-value"+e,n),o.attr(e,n)),t)},_spin:function(e,t){var n=this;t=t||500,clearTimeout(n._spinning),n._spinning=setTimeout(function(){n._spin(e,50)},t),n._step(e)},_step:function(e){var t=this,n=t.element,i=t._parse(n.val())||0;c()!=n[0]&&t._focusin(),t.options.factor&&i&&(i/=t.options.factor),i+=t.options.step*e,t._update(t._adjust(i)),t._typing=!1,t.trigger(_)},_toggleHover:function(t){e(t.currentTarget).toggleClass(S,"mouseenter"===t.type)},_toggleText:function(e){var t=this;t._text.toggle(e),t.element.toggle(!e)},_parse:function(e,t){return u(e,this._culture(t),this.options.format)},_round:function(e,t){var n=this.options.round?o._round:i;return n(e,t)},_update:function(e){var t,n=this,i=n.options,r=i.factor,s=i.format,a=i.decimals,l=n._culture(),c=n._format(s,l);a===z&&(a=c.decimals),e=n._parse(e,l),t=e!==z,t&&(e=parseFloat(n._round(e,a),10)),n._value=e=n._adjust(e),n._placeholder(o.toString(e,s,l)),t?(r&&(e=parseFloat(n._round(e*r,a),10)),e=""+e,e.indexOf("e")!==-1&&(e=n._round(+e,a)),e=e.replace(D,c[D])):e=null,n.element.val(e),n.element.add(n._text).attr("aria-valuenow",e)},_placeholder:function(e){var t=this._text;t.val(e),h||e||t.val(this.options.placeholder),t.attr("title",this._initialTitle||t.val())},_wrapper:function(){var t,n=this,i=n.element,o=i[0];t=i.parents(".k-numerictextbox"),t.is("span.k-numerictextbox")||(t=i.hide().wrap('<span class="k-numeric-wrap k-state-default" />').parent(),t=t.wrap("<span/>").parent()),t[0].style.cssText=o.style.cssText,o.style.width="",n.wrapper=t.addClass("k-widget k-numerictextbox").addClass(o.className).css("display",""),n._inputWrapper=e(t[0].firstChild)},_reset:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){setTimeout(function(){t.value(n[0].value),t.max(t._initialOptions.max),t.min(t._initialOptions.min)})},t._form=o.on("reset",t._resetHandler))}});a.plugin(L)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.filtermenu.min",["kendo.datepicker.min","kendo.numerictextbox.min","kendo.dropdownlist.min","kendo.binder.min"],e)}(function(){return function(e,t){function n(t,i){t.filters&&(t.filters=e.grep(t.filters,function(e){return n(e,i),e.filters?e.filters.length:e.field!=i}))}function i(e){var t,n,i,o,r,s;if(e&&e.length)for(s=[],t=0,n=e.length;t<n;t++)i=e[t],r=""!==i.text?i.text||i.value||i:i.text,o=null==i.value?i.text||i:i.value,s[t]={text:r,value:o};return s}function o(t,n){return e.grep(t,function(t){return t.filters?(t.filters=e.grep(t.filters,function(e){return e.field!=n}),t.filters.length):t.field!=n})}function r(t,n){t.filters&&(t.filters=e.grep(t.filters,function(e){return r(e,n),e.filters?e.filters.length:e.field==n&&"eq"==e.operator}))}function s(n){return"and"==n.logic&&n.filters.length>1?[]:n.filters?e.map(n.filters,function(e){return s(e)}):n.value!==t?[n.value]:[]}function a(e,n){for(var i,o,r=c.getter(n,!0),s=[],a=0,l={};a<e.length;)i=e[a++],o=r(i),o===t||l.hasOwnProperty(o)||(s.push(i),l[o]=!0);return s}function l(e,t){return function(n){var i=e(n);return a(i,t)}}var c=window.kendo,d=c.ui,u=e.proxy,h="kendoPopup",f="init",p="open",m="refresh",g="change",v=".kendoFilterMenu",_="Is equal to",b="Is not equal to",w={number:"numerictextbox",date:"datepicker"},y={string:"text",number:"number",date:"date"},k=c.isFunction,x=d.Widget,C='<div><div class="k-filter-help-text">#=messages.info#</div><label><input type="radio" data-#=ns#bind="checked: filters[0].value" value="true" name="filters[0].value"/>#=messages.isTrue#</label><label><input type="radio" data-#=ns#bind="checked: filters[0].value" value="false" name="filters[0].value"/>#=messages.isFalse#</label><div><button type="submit" class="k-button k-primary">#=messages.filter#</button><button type="reset" class="k-button">#=messages.clear#</button></div></div>',S='<div><div class="k-filter-help-text">#=messages.info#</div><select title="#=messages.operator#" data-#=ns#bind="value: filters[0].operator" data-#=ns#role="dropdownlist">#for(var op in operators){#<option value="#=op#">#=operators[op]#</option>#}#</select>#if(values){#<select title="#=messages.value#" data-#=ns#bind="value:filters[0].value" data-#=ns#text-field="text" data-#=ns#value-field="value" data-#=ns#source=\'#=kendo.stringify(values).replace(/\'/g,"&\\#39;")#\' data-#=ns#role="dropdownlist" data-#=ns#option-label="#=messages.selectValue#" data-#=ns#value-primitive="true"></select>#}else{#<input title="#=messages.value#" data-#=ns#bind="value:filters[0].value" class="k-textbox" type="text" #=role ? "data-" + ns + "role=\'" + role + "\'" : ""# />#}##if(extra){#<select title="#=messages.logic#" class="k-filter-and" data-#=ns#bind="value: logic" data-#=ns#role="dropdownlist"><option value="and">#=messages.and#</option><option value="or">#=messages.or#</option></select><select title="#=messages.additionalOperator#" data-#=ns#bind="value: filters[1].operator" data-#=ns#role="dropdownlist">#for(var op in operators){#<option value="#=op#">#=operators[op]#</option>#}#</select>#if(values){#<select title="#=messages.additionalValue#" data-#=ns#bind="value:filters[1].value" data-#=ns#text-field="text" data-#=ns#value-field="value" data-#=ns#source=\'#=kendo.stringify(values).replace(/\'/g,"&\\#39;")#\' data-#=ns#role="dropdownlist" data-#=ns#option-label="#=messages.selectValue#" data-#=ns#value-primitive="true"></select>#}else{#<input title="#=messages.additionalValue#" data-#=ns#bind="value: filters[1].value" class="k-textbox" type="text" #=role ? "data-" + ns + "role=\'" + role + "\'" : ""#/>#}##}#<div><button type="submit" class="k-button k-primary">#=messages.filter#</button><button type="reset" class="k-button">#=messages.clear#</button></div></div>',T='<div data-#=ns#role="view" data-#=ns#init-widgets="false" data-#=ns#use-native-scrolling="true" class="k-grid-filter-menu"><div data-#=ns#role="header" class="k-header"><button class="k-button k-i-cancel">#=messages.cancel#</button>#=title#<button type="submit" class="k-button k-submit">#=messages.filter#</button></div><form title="#=messages.title#" class="k-filter-menu k-mobile-list"><ul class="k-filter-help-text"><li><span class="k-link">#=messages.info#</span><ul><li class="k-item"><label class="k-label">#=messages.operator#<select data-#=ns#bind="value: filters[0].operator">#for(var op in operators){#<option value="#=op#">#=operators[op]#</option>#}#</select></label></li><li class="k-item"><label class="k-label">#=messages.value##if(values){#<select data-#=ns#bind="value:filters[0].value"><option value="">#=messages.selectValue#</option>#for(var val in values){#<option value="#=values[val].value#">#=values[val].text#</option>#}#</select>#}else{#<input data-#=ns#bind="value:filters[0].value" class="k-textbox" type="#=inputType#" #=useRole ? "data-" + ns + "role=\'" + role + "\'" : ""# />#}#</label></li>#if(extra){#</ul><ul class="k-filter-help-text"><li><span class="k-link"></span><li class="k-item"><label class="k-label"><input type="radio" name="logic" class="k-check" data-#=ns#bind="checked: logic" value="and" />#=messages.and#</label></li><li class="k-item"><label class="k-label"><input type="radio" name="logic" class="k-check" data-#=ns#bind="checked: logic" value="or" />#=messages.or#</label></li></ul><ul class="k-filter-help-text"><li><span class="k-link"></span><li class="k-item"><label class="k-label">#=messages.additionalOperator#<select data-#=ns#bind="value: filters[1].operator">#for(var op in operators){#<option value="#=op#">#=operators[op]#</option>#}#</select></label></li><li class="k-item"><label class="k-label">#=messages.additionalValue##if(values){#<select data-#=ns#bind="value:filters[1].value"><option value="">#=messages.selectValue#</option>#for(var val in values){#<option value="#=values[val].value#">#=values[val].text#</option>#}#</select>#}else{#<input data-#=ns#bind="value:filters[1].value" class="k-textbox" type="#=inputType#" #=useRole ? "data-" + ns + "role=\'" + role + "\'" : ""# />#}#</label></li>#}#</ul></li><li class="k-button-container"><button type="reset" class="k-button">#=messages.clear#</button></li></ul></div></form></div>',D='<div data-#=ns#role="view" data-#=ns#init-widgets="false" data-#=ns#use-native-scrolling="true" class="k-grid-filter-menu"><div data-#=ns#role="header" class="k-header"><button class="k-button k-i-cancel">#=messages.cancel#</button>#=title#<button type="submit" class="k-button k-submit">#=messages.filter#</button></div><form title="#=messages.title#" class="k-filter-menu k-mobile-list"><ul class="k-filter-help-text"><li><span class="k-link">#=messages.info#</span><ul><li class="k-item"><label class="k-label"><input class="k-check" type="radio" data-#=ns#bind="checked: filters[0].value" value="true" name="filters[0].value"/>#=messages.isTrue#</label></li><li class="k-item"><label class="k-label"><input class="k-check" type="radio" data-#=ns#bind="checked: filters[0].value" value="false" name="filters[0].value"/>#=messages.isFalse#</label></li></ul></li><li class="k-button-container"><button type="reset" class="k-button">#=messages.clear#</button></li></ul></form></div>',A=x.extend({init:function(t,n){var i,o,r,s,a=this,l="string";x.fn.init.call(a,t,n),i=a.operators=n.operators||{},t=a.element,n=a.options,n.appendToElement||(r=t.addClass("k-with-icon k-filterable").find(".k-grid-filter"),r[0]||(r=t.prepend('<a class="k-grid-filter" href="#" title="'+n.messages.filter+'" aria-label="'+n.messages.filter+'"><span class="k-icon k-i-filter"></span></a>').find(".k-grid-filter")),r.attr("tabindex",-1).on("click"+v,u(a._click,a))),a.link=r||e(),a.dataSource=I.create(n.dataSource),a.field=n.field||t.attr(c.attr("field")),a.model=a.dataSource.reader.model,a._parse=function(e){return null!=e?e+"":e},a.model&&a.model.fields&&(s=a.model.fields[a.field],s&&(l=s.type||"string",s.parse&&(a._parse=u(s.parse,s)))),n.values&&(l="enums"),a.type=l,i=i[l]||n.operators[l];for(o in i)break;a._defaultFilter=function(){return{field:a.field,operator:o||"eq",value:""}},a._refreshHandler=u(a.refresh,a),a.dataSource.bind(g,a._refreshHandler),n.appendToElement?a._init():a.refresh()},_init:function(){var t,n=this,i=n.options.ui,o=k(i);n.pane=n.options.pane,n.pane&&(n._isMobile=!0),o||(t=i||w[n.type]),n._isMobile?n._createMobileForm(t):n._createForm(t),n.form.on("submit"+v,u(n._submit,n)).on("reset"+v,u(n._reset,n)),o&&n.form.find(".k-textbox").removeClass("k-textbox").each(function(){i(e(this))}),n.form.find("["+c.attr("role")+"=numerictextbox]").removeClass("k-textbox").end().find("["+c.attr("role")+"=datetimepicker]").removeClass("k-textbox").end().find("["+c.attr("role")+"=timepicker]").removeClass("k-textbox").end().find("["+c.attr("role")+"=datepicker]").removeClass("k-textbox"),n.refresh(),n.trigger(f,{field:n.field,container:n.form}),c.cycleForm(n.form)},_createForm:function(t){var n=this,o=n.options,r=n.operators||{},s=n.type;r=r[s]||o.operators[s],n.form=e('<form title="'+n.options.messages.title+'" class="k-filter-menu"/>').html(c.template("boolean"===s?C:S)({field:n.field,format:o.format,ns:c.ns,messages:o.messages,extra:o.extra,operators:r,type:s,role:t,values:i(o.values)})),o.appendToElement?(n.element.append(n.form),n.popup=n.element.closest(".k-popup").data(h)):n.popup=n.form[h]({anchor:n.link,open:u(n._open,n),activate:u(n._activate,n),close:function(){n.options.closeCallback&&n.options.closeCallback(n.element)}}).data(h),n.form.on("keydown"+v,u(n._keydown,n))},_createMobileForm:function(t){var n=this,o=n.options,r=n.operators||{},s=n.type;r=r[s]||o.operators[s],n.form=e("<div />").html(c.template("boolean"===s?D:T)({field:n.field,title:o.title||n.field,format:o.format,ns:c.ns,messages:o.messages,extra:o.extra,operators:r,type:s,role:t,useRole:!c.support.input.date&&"date"===s||"number"===s,inputType:y[s],values:i(o.values)})),n.view=n.pane.append(n.form.html()),n.form=n.view.element.find("form"),n.view.element.on("click",".k-submit",function(e){n.form.submit(),e.preventDefault()}).on("click",".k-i-cancel",function(e){n._closeForm(),e.preventDefault()})},refresh:function(){var e=this,t=e.dataSource.filter()||{filters:[],logic:"and"},n=[e._defaultFilter()],i=e._defaultFilter().operator;(e.options.extra||"isnull"!==i&&"isnullorempty"!==i&&"isnotnullorempty"!==i&&"isnotnull"!==i)&&n.push(e._defaultFilter()),e.filterModel=c.observable({logic:"and",filters:n}),e.form&&c.bind(e.form.children().first(),e.filterModel),e._bind(t)?e.link.addClass("k-state-active"):e.link.removeClass("k-state-active")},destroy:function(){var e=this;x.fn.destroy.call(e),e.form&&(c.unbind(e.form),c.destroy(e.form),e.form.unbind(v),e.popup&&(e.popup.destroy(),e.popup=null),e.form=null),e.view&&(e.view.purge(),e.view=null),e.link.unbind(v),e._refreshHandler&&(e.dataSource.unbind(g,e._refreshHandler),e.dataSource=null),e.element=e.link=e._refreshHandler=e.filterModel=null},_bind:function(e){var t,n,i,o,r=this,s=e.filters,a=!1,l=0,c=r.filterModel;for(t=0,n=s.length;t<n;t++)o=s[t],o.field==r.field?(c.set("logic",e.logic),i=c.filters[l],i||(c.filters.push({field:r.field}),i=c.filters[l]),i.set("value",r._parse(o.value)),i.set("operator",o.operator),l++,a=!0):o.filters&&(a=a||r._bind(o));return a},_stripFilters:function(t){return e.grep(t,function(e){return""!==e.value&&null!=e.value||"isnull"===e.operator||"isnotnull"===e.operator||"isempty"===e.operator||"isnotempty"===e.operator||"isnullorempty"==e.operator||"isnotnullorempty"==e.operator})},_merge:function(e){var t,i,o,r=this,s=e.logic||"and",a=this._stripFilters(e.filters),l=r.dataSource.filter()||{filters:[],logic:"and"};for(n(l,r.field),i=0,o=a.length;i<o;i++)t=a[i],t.value=r._parse(t.value);return a.length&&(l.filters.length?(e.filters=a,"and"!==l.logic&&(l.filters=[{logic:l.logic,filters:l.filters}],l.logic="and"),l.filters.push(a.length>1?e:a[0])):(l.filters=a,l.logic=s)),l},filter:function(e){var t=this._stripFilters(e.filters);t.length&&this.trigger("change",{filter:{logic:e.logic,filters:t},field:this.field})||(e=this._merge(e),e.filters.length&&this.dataSource.filter(e))},clear:function(){var e=this,t=e.dataSource.filter()||{filters:[]};this.trigger("change",{filter:null,field:e.field})||e._removeFilter(t)},_removeFilter:function(t){var n=this;t.filters=e.grep(t.filters,function(e){return e.filters?(e.filters=o(e.filters,n.field),e.filters.length):e.field!=n.field}),t.filters.length||(t=null),n.dataSource.filter(t)},_submit:function(t){var n,i;t.preventDefault(),t.stopPropagation(),n=this.filterModel.toJSON(),i=e.grep(n.filters,function(e){return""!==e.value}),this._checkForNullOrEmptyFilter(n)||i&&i.length?this.filter(n):this._removeFilter(n),this._closeForm()},_checkForNullOrEmptyFilter:function(e){var t,n,i;return!!(e&&e.filters&&e.filters.length)&&(t=!1,n=!1,e.filters[0]&&(i=e.filters[0].operator,t="isnull"==i||"isnotnull"==i||"isnotempty"==i||"isempty"==i||"isnullorempty"==i||"isnotnullorempty"==i),e.filters[1]&&(i=e.filters[1].operator,n="isnull"==i||"isnotnull"==i||"isnotempty"==i||"isempty"==i||"isnullorempty"==i||"isnotnullorempty"==i),!this.options.extra&&t||this.options.extra&&(t||n))},_reset:function(){this.clear(),this.options.search&&this.container&&this.container.find("label").parent().show(),this._closeForm()},_closeForm:function(){this._isMobile?this.pane.navigate("",this.options.animations.right):this.popup.close()},_click:function(e){e.preventDefault(),e.stopPropagation(),this.popup||this.pane||this._init(),this._isMobile?this.pane.navigate(this.view,this.options.animations.left):this.popup.toggle()},_open:function(){var t;e(".k-filter-menu").not(this.form).each(function(){t=e(this).data(h),t&&t.close()})},_activate:function(){this.form.find(":kendoFocusable:first").focus(),this.trigger(p,{field:this.field,container:this.form})},_keydown:function(e){e.keyCode==c.keys.ESC&&this.popup.close()},events:[f,"change",p],options:{name:"FilterMenu",extra:!0,appendToElement:!1,type:"string",operators:{string:{eq:_,neq:b,startswith:"Starts with",contains:"Contains",doesnotcontain:"Does not contain",endswith:"Ends with",isnull:"Is null",isnotnull:"Is not null",isempty:"Is empty",isnotempty:"Is not empty",isnullorempty:"Has no value",isnotnullorempty:"Has value"},number:{eq:_,neq:b,gte:"Is greater than or equal to",gt:"Is greater than",lte:"Is less than or equal to",lt:"Is less than",isnull:"Is null",isnotnull:"Is not null"},date:{eq:_,neq:b,gte:"Is after or equal to",gt:"Is after",lte:"Is before or equal to",lt:"Is before",isnull:"Is null",isnotnull:"Is not null"},enums:{eq:_,neq:b,isnull:"Is null",isnotnull:"Is not null"}},messages:{info:"Show items with value that:",title:"Show items with value that:",isTrue:"is true",isFalse:"is false",filter:"Filter",clear:"Clear",and:"And",or:"Or",selectValue:"-Select value-",operator:"Operator",value:"Value",additionalValue:"Additional value",additionalOperator:"Additional operator",logic:"Filters logic",cancel:"Cancel"},animations:{left:"slide",right:"slide:right"}}}),E=".kendoFilterMultiCheck",I=c.data.DataSource,M='<div data-#=ns#role="view" data-#=ns#init-widgets="false" class="k-grid-filter-menu"><div data-#=ns#role="header" class="k-header"><button class="k-button k-i-cancel">#=messages.cancel#</button>#=title#<button type="submit" class="k-button k-submit">#=messages.filter#</button></div><form class="k-filter-menu k-mobile-list">#if(search){#<div class=\'k-textbox k-space-right\'><input placeholder=\'#=messages.search#\'/><span class=\'k-icon k-i-zoom\' /></div>#}#<ul class="k-multicheck-wrap"></ul></li><li class="k-button-container">#if(messages.selectedItemsFormat){#<div class=\'k-filter-selected-items\'></div>#}#<button type="reset" class="k-button">#=messages.clear#</button></li></ul></form></div>',R=x.extend({init:function(t,n){var i,o;x.fn.init.call(this,t,n),n=this.options,this.element=e(t),i=this.field=this.options.field||this.element.attr(c.attr("field")),o=n.checkSource,this._foreignKeyValues()?(this.checkSource=I.create(n.values),this.checkSource.fetch()):n.forceUnique?(o=e.extend(!0,{},n.dataSource.options),delete o.pageSize,this.checkSource=I.create(o),this.checkSource.reader.data=l(this.checkSource.reader.data,this.field)):this.checkSource=I.create(o),this.dataSource=n.dataSource,this.model=this.dataSource.reader.model,this._parse=function(e){return e+""},this.model&&this.model.fields&&(i=this.model.fields[this.field],i&&("number"==i.type?this._parse=function(e){return"string"==typeof e&&"null"===e.toLowerCase()?null:parseFloat(e)}:i.parse&&(this._parse=u(i.parse,i)),this.type=i.type||"string")),n.appendToElement?this._init():this._createLink(),this._refreshHandler=u(this.refresh,this),this.dataSource.bind(g,this._refreshHandler)},_createLink:function(){var e=this.element,t=e.addClass("k-with-icon k-filterable").find(".k-grid-filter");t[0]||(t=e.prepend('<a class="k-grid-filter" href="#" aria-label="'+this.options.messages.filter+'"><span class="k-icon k-i-filter"/></a>').find(".k-grid-filter")),this._link=t.attr("tabindex",-1).on("click"+v,u(this._click,this))},_init:function(){var e=this,t=this.options.forceUnique,n=this.options;this.pane=n.pane,this.pane&&(this._isMobile=!0),this._createForm(),this._foreignKeyValues()?this.refresh():t&&!this.checkSource.options.serverPaging&&this.dataSource.data().length?(this.checkSource.data(a(this.dataSource.data(),this.field)),this.refresh()):(this._attachProgress(),this.checkSource.fetch(function(){e.refresh.call(e)})),this.options.forceUnique||(this.checkChangeHandler=function(){e.container.empty(),e.refresh()},this.checkSource.bind(g,this.checkChangeHandler)),this.form.on("keydown"+E,u(this._keydown,this)).on("submit"+E,u(this._filter,this)).on("reset"+E,u(this._reset,this)),this.trigger(f,{field:this.field,container:this.form})},_attachProgress:function(){var e=this;this._progressHandler=function(){d.progress(e.container,!0)},this._progressHideHandler=function(){d.progress(e.container,!1)},this.checkSource.bind("progress",this._progressHandler).bind("change",this._progressHideHandler)},_input:function(){var e=this;e._clearTypingTimeout(),e._typingTimeout=setTimeout(function(){e.search()},100)},_clearTypingTimeout:function(){this._typingTimeout&&(clearTimeout(this._typingTimeout),this._typingTimeout=null)},search:function(){var e,t,n,i=this.options.ignoreCase,o=this.searchTextBox[0].value,r=this.container.find("label");for(i&&(o=o.toLowerCase()),e=0,this.options.checkAll&&r.length&&(r[0].parentNode.style.display=o?"none":"",e++);e<r.length;)t=r[e],n=t.textContent||t.innerText,i&&(n=n.toLowerCase()),t.parentNode.style.display=n.indexOf(o)>=0?"":"none",e++},_activate:function(){this.form.find(":kendoFocusable:first").focus(),this.trigger(p,{field:this.field,container:this.form})},_createForm:function(){var t,n,i=this.options,o="";this._isMobile||(i.search&&(o+="<div class='k-textbox k-space-right'><input placeholder='"+i.messages.search+"'/><span class='k-icon k-i-zoom' /></div>"),o+="<ul class='k-reset k-multicheck-wrap'></ul>",i.messages.selectedItemsFormat&&(o+="<div class='k-filter-selected-items'>"+c.format(i.messages.selectedItemsFormat,0)+"</div>"),o+="<button type='submit' class='k-button k-primary'>"+i.messages.filter+"</button>",o+="<button type='reset' class='k-button'>"+i.messages.clear+"</button>",this.form=e('<form class="k-filter-menu"/>').html(o),this.container=this.form.find(".k-multicheck-wrap")),this._isMobile?(t=this,t.form=e("<div />").html(c.template(M)({field:t.field,title:i.title||t.field,ns:c.ns,messages:i.messages,search:i.search})),t.view=t.pane.append(t.form.html()),t.form=t.view.element.find("form"),n=this.view.element,this.container=n.find(".k-multicheck-wrap"),n.on("click",".k-submit",function(e){t.form.submit(),e.preventDefault()}).on("click",".k-i-cancel",function(e){t._closeForm(),e.preventDefault()})):i.appendToElement?(this.popup=this.element.closest(".k-popup").data(h),this.element.append(this.form)):this.popup=this.form.kendoPopup({anchor:this._link,activate:u(this._activate,this)}).data(h),i.search&&(this.searchTextBox=this.form.find(".k-textbox > input"),this.searchTextBox.on("input",u(this._input,this)))},createCheckAllItem:function(){var t=this.options,n=c.template(t.itemTemplate({field:"all",mobile:this._isMobile})),i=e(n({all:t.messages.checkAll}));this.container.prepend(i),this.checkBoxAll=i.find(":checkbox").eq(0).addClass("k-check-all"),this.checkAllHandler=u(this.checkAll,this),this.checkBoxAll.on(g+E,this.checkAllHandler)},updateCheckAllState:function(){if(this.options.messages.selectedItemsFormat&&this.form.find(".k-filter-selected-items").text(c.format(this.options.messages.selectedItemsFormat,this.container.find(":checked:not(.k-check-all)").length)),this.checkBoxAll){var e=this.container.find(":checkbox:not(.k-check-all)").length==this.container.find(":checked:not(.k-check-all)").length;this.checkBoxAll.prop("checked",e)}},refresh:function(e){var t=this.options.forceUnique,n=this.dataSource,i=this.getFilterArray();this._link&&this._link.toggleClass("k-state-active",0!==i.length),this.form&&(e&&t&&e.sender===n&&!n.options.serverPaging&&("itemchange"==e.action||"add"==e.action||"remove"==e.action||n.options.autoSync&&"sync"===e.action)&&!this._foreignKeyValues()&&(this.checkSource.data(a(this.dataSource.data(),this.field)),this.container.empty()),this.container.is(":empty")&&this.createCheckBoxes(),this.checkValues(i),this.trigger(m))},getFilterArray:function(){var t,n=e.extend(!0,{},{filters:[],logic:"and"},this.dataSource.filter());return r(n,this.field),t=s(n)},createCheckBoxes:function(){var e,t,n,i=this.options,o={field:this.field,format:i.format,mobile:this._isMobile,type:this.type};this.options.forceUnique?this._foreignKeyValues()?(e=this.checkSource.data(),o.valueField="value",o.field="text"):e=this.checkSource.data():e=this.checkSource.view(),t=c.template(i.itemTemplate(o)),n=c.render(t,e),i.checkAll&&this.createCheckAllItem(),this.container.on(g+E,":checkbox",u(this.updateCheckAllState,this)),this.container.append(n)},checkAll:function(){var e=this.checkBoxAll.is(":checked");this.container.find(":checkbox").prop("checked",e)},checkValues:function(t){var n=this;e(e.grep(this.container.find(":checkbox").prop("checked",!1),function(i){var o,r,s=!1;if(!e(i).is(".k-check-all"))for(o=n._parse(e(i).val()),r=0;r<t.length;r++)if(s="date"==n.type?t[r]&&o?t[r].getTime()==o.getTime():null===t[r]&&null===o:t[r]==o)return s})).prop("checked",!0),this.updateCheckAllState()},_filter:function(t){var n,i;t.preventDefault(),t.stopPropagation(),n={logic:"or"},i=this,n.filters=e.map(this.form.find(":checkbox:checked:not(.k-check-all)"),function(t){return{value:e(t).val(),operator:"eq",field:i.field}}),n.filters.length&&this.trigger("change",{filter:n,field:i.field})||(n=this._merge(n),n.filters.length?this.dataSource.filter(n):this.clear(),this._closeForm())},_stripFilters:function(t){return e.grep(t,function(e){return null!=e.value})},_foreignKeyValues:function(){var e=this.options;return e.values&&!e.checkSource},destroy:function(){var e=this;x.fn.destroy.call(e),e.form&&(c.unbind(e.form),c.destroy(e.form),e.form.unbind(E),e.popup&&(e.popup.destroy(),e.popup=null),e.form=null,e.container&&(e.container.unbind(E),e.container=null),e.checkBoxAll&&e.checkBoxAll.unbind(E)),e.view&&(e.view.purge(),e.view=null),e._link&&e._link.unbind(v),e._refreshHandler&&(e.dataSource.unbind(g,e._refreshHandler),e.dataSource=null),e.checkChangeHandler&&e.checkSource.unbind(g,e.checkChangeHandler),e._progressHandler&&e.checkSource.unbind("progress",e._progressHandler),e._progressHideHandler&&e.checkSource.unbind("change",e._progressHideHandler),this._clearTypingTimeout(),this.searchTextBox=null,e.element=e.checkSource=e.container=e.checkBoxAll=e._link=e._refreshHandler=e.checkAllHandler=null},options:{name:"FilterMultiCheck",itemTemplate:function(e){var n=e.field,i=e.format,o=e.valueField,r=e.mobile,s="";return o===t&&(o=n),"date"==e.type&&(s=":yyyy-MM-ddTHH:mm:sszzz"),
"<li class='k-item'><label class='k-label'><input type='checkbox' class='"+(r?"k-check":"")+"'  value='#:kendo.format('{0"+s+"}',"+o+")#'/>#:kendo.format('"+(i?i:"{0}")+"', "+n+")#</label></li>"},checkAll:!0,search:!1,ignoreCase:!0,appendToElement:!1,messages:{checkAll:"Select All",clear:"Clear",filter:"Filter",search:"Search",cancel:"Cancel",selectedItemsFormat:"{0} items selected"},forceUnique:!0,animations:{left:"slide",right:"slide:right"}},events:[f,m,"change",p]});e.extend(R.fn,{_click:A.fn._click,_keydown:A.fn._keydown,_reset:A.fn._reset,_closeForm:A.fn._closeForm,_removeFilter:A.fn._removeFilter,clear:A.fn.clear,_merge:A.fn._merge}),d.plugin(A),d.plugin(R)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.menu.min",["kendo.popup.min"],e)}(function(){return function(e,t){function n(e,t){return e=e.split(" ")[!t+0]||e,e.replace("top","up").replace("bottom","down")}function i(e,t,n){e=e.split(" ")[!t+0]||e;var i={origin:["bottom",n?"right":"left"],position:["top",n?"right":"left"]},o=/left|right/.test(e);return o?(i.origin=["top",e],i.position[1]=T.directions[e].reverse):(i.origin[0]=e,i.position[0]=T.directions[e].reverse),i.origin=i.origin.join(" "),i.position=i.position.join(" "),i}function o(t,n){try{return e.contains(t,n)}catch(i){return!1}}function r(t){t=e(t),t.addClass("k-item").children(U).addClass(Q),t.children("a").addClass(q).children(U).addClass(Q),t.filter(":not([disabled])").addClass(ve),t.filter(".k-separator").empty().append("&nbsp;"),t.filter("li[disabled]").addClass(we).removeAttr("disabled").attr("aria-disabled",!0),t.filter("[role]").length||t.attr("role","menuitem"),t.children("."+q).length||t.contents().filter(function(){return!(this.nodeName.match(O)||3==this.nodeType&&!e.trim(this.nodeValue))}).wrapAll("<span class='"+q+"'/>"),s(t),l(t)}function s(t){t=e(t),t.find("> .k-link > [class*=k-i-arrow-60]:not(.k-sprite)").remove(),t.filter(":has(.k-menu-group)").children(".k-link:not(:has([class*=k-i-arrow]:not(.k-sprite)))").each(function(){var t=e(this),n=a(t);t.append("<span class='k-icon"+n+" k-menu-expand-arrow'/>")})}function a(e){var t,n=e.parent().parent(),i=T.support.isRtl(n);return t=n.hasClass(j+"-horizontal")?" k-i-arrow-60-down":i?" k-i-arrow-60-left":" k-i-arrow-60-right"}function l(t){t=e(t),t.filter(".k-first:not(:first-child)").removeClass(Y),t.filter(".k-last:not(:last-child)").removeClass(G),t.filter(":first-child").addClass(Y),t.filter(":last-child").addClass(G)}function c(e){var t,n;if(e&&e.length)for(t in e)n=e.eq(t),n.find("ul").length?n.attr("aria-haspopup",!0):n.removeAttr("aria-haspopup")}function d(e){if(!e.hasClass(j))return e.parentsUntil("."+j,"li")}function u(t,n){var i=f(n);i&&h(t,i),n.items&&e(t).children("ul").children("li").each(function(e){u(this,n.items[e])})}function h(t,n){e(t).children(".k-link").data({selectHandler:n})}function f(e){var t=e.select,n=T.isFunction;return t&&n(t)?t:null}function p(e){return e?"li[data-groupparent='"+e+"']":"li[data-groupparent]"}function m(e){return e?"ul[data-group='"+e+"']":"ul[data-group]"}function g(t,n){var i=t.find(p()),o=[];return i.each(function(i,r){var s,a;for(r=e(r),s=r.data(pe),a=t;s;)a=n.find(m(s)+":visible"),a.length&&o.push(a),r=a.find(p()),s=r.data(pe)}),o}function v(t,n){var i=t.data(fe);return i?n.find(p(i)):e([])}function _(t,n){var i=t.data(pe);return i?n.children(Ce).children(m(i)):e([])}function b(t,n){var i,o,r=[],s=function(e){for(;e.parentNode&&!n.is(e.parentNode);)r.push(e.parentNode),e=e.parentNode},a=t[0]||t;for(s(a),i=r[r.length-1];e(i).is(Ce)&&(o=e(i).children("ul"),a=v(o,n)[0]);)r.push(a),s(a),i=r[r.length-1];return r}function w(e){var t=0;return e.wheelDelta&&(t=-e.wheelDelta/120,t=t>0?Math.ceil(t):Math.floor(t)),e.detail&&(t=Math.round(e.detail/3)),t}function y(e,t){for(var n=0,i=e.parentNode;i&&!isNaN(i[t]);)n+=i[t],i=i.parentNode;return n}function k(e){return oe&&e.originalEvent&&e.originalEvent.pointerType in Be}function x(e){var t=e.originalEvent;return E&&/touch/i.test(t.type||"")}function C(e){e.contents().filter(function(){return"LI"!=this.nodeName}).remove()}var S,T=window.kendo,D=T.ui,A=T._activeElement,E=T.support.touch&&T.support.mobileOS,I="mousedown",M="click",R=30,F=50,z=e.extend,P=e.proxy,B=e.each,L=T.template,H=T.keys,N=D.Widget,O=/^(ul|a|div)$/i,V=".kendoMenu",U="img",W="open",j="k-menu",q="k-link",G="k-last",$="close",K="timer",Y="k-first",Q="k-image",X="select",Z="zIndex",J="activate",ee="deactivate",te="touchstart"+V+" MSPointerDown"+V+" pointerdown"+V,ne=T.support.pointers,ie=T.support.msPointers,oe=ie||ne,re=ne?"pointerenter":ie?"MSPointerEnter":"mouseenter",se=ne?"pointerleave":ie?"MSPointerLeave":"mouseleave",ae="DOMMouseScroll"+V+" mousewheel"+V,le=T.support.resize+V,ce="scrollWidth",de="scrollHeight",ue="offsetWidth",he="offsetHeight",fe="group",pe="groupparent",me=e(document.documentElement),ge="kendoPopup",ve="k-state-default",_e="k-state-hover",be="k-state-focused",we="k-state-disabled",ye="k-state-selected",ke=".k-menu",xe=".k-menu-group",Ce=".k-animation-container",Se=xe+","+Ce,Te=":not(.k-list) > .k-item",De=".k-item.k-state-disabled",Ae=".k-item",Ee=".k-item:not(.k-state-disabled)",Ie=".k-item:not(.k-state-disabled) > .k-link",Me=":not(.k-item.k-separator)",Re=Ae+Me+":eq(0)",Fe=Ae+Me+":last",ze="div:not(.k-animation-container,.k-list-container)",Pe=".k-menu-scroll-button",Be={2:1,touch:1},Le={content:L("<div #= contentCssAttributes(item) # tabindex='-1'>#= content(item) #</div>"),group:L("<ul class='#= groupCssClass(group) #'#= groupAttributes(group) # role='menu' aria-hidden='true'>#= renderItems(data) #</ul>"),itemWrapper:L("<#= tag(item) # class='#= textClass(item) #'#= textAttributes(item) #>#= image(data) ##= sprite(item) ##= text(item) ##= arrow(data) #</#= tag(item) #>"),item:L("<li class='#= wrapperCssClass(group, item) #' #= itemCssAttributes(item) # role='menuitem'  #=item.items ? \"aria-haspopup='true'\": \"\"##=item.enabled === false ? \"aria-disabled='true'\" : ''#>#= itemWrapper(data) ## if (item.items) { ##= subGroup({ items: item.items, menu: menu, group: { expanded: item.expanded } }) ## } else if (item.content || item.contentUrl) { ##= renderContent(data) ## } #</li>"),scrollButton:L("<span class='k-button k-button-icon k-menu-scroll-button k-scroll-#= direction #' unselectable='on'><span class='k-icon k-i-arrow-60-#= direction #'></span></span>"),image:L("<img #= imageCssAttributes(item) # alt='' src='#= item.imageUrl #' />"),arrow:L("<span class='#= arrowClass(item, group) #'></span>"),sprite:L("<span class='k-sprite #= spriteCssClass #'></span>"),empty:L("")},He={wrapperCssClass:function(e,t){var n="k-item",i=t.index;return n+=t.enabled===!1?" k-state-disabled":" k-state-default",e.firstLevel&&0===i&&(n+=" k-first"),i==e.length-1&&(n+=" k-last"),t.cssClass&&(n+=" "+t.cssClass),t.attr&&t.attr.hasOwnProperty("class")&&(n+=" "+t.attr["class"]),t.selected&&(n+=" "+ye),n},itemCssAttributes:function(e){var t,n="",i=e.attr||{};for(t in i)i.hasOwnProperty(t)&&"class"!==t&&(n+=t+'="'+i[t]+'" ');return n},imageCssAttributes:function(e){var t,n="",i=e.imageAttr||{};i["class"]?i["class"]+=" "+Q:i["class"]=Q;for(t in i)i.hasOwnProperty(t)&&(n+=t+'="'+i[t]+'" ');return n},contentCssAttributes:function(e){var t,n="",i=e.contentAttr||{},o="k-content k-group k-menu-group";i["class"]?i["class"]+=" "+o:i["class"]=o;for(t in i)i.hasOwnProperty(t)&&(n+=t+'="'+i[t]+'" ');return n},textClass:function(){return q},textAttributes:function(e){return e.url?" href='"+e.url+"'":""},arrowClass:function(e,t){var n="k-icon";return n+=t.horizontal?" k-i-arrow-60-down":" k-i-arrow-60-right"},text:function(e){return e.encoded===!1?e.text:T.htmlEncode(e.text)},tag:function(e){return e.url?"a":"span"},groupAttributes:function(e){return e.expanded!==!0?" style='display:none'":""},groupCssClass:function(){return"k-group k-menu-group"},content:function(e){return e.content?e.content:"&nbsp;"}},Ne=N.extend({init:function(e,t){var n=this;N.fn.init.call(n,e,t),e=n.wrapper=n.element,t=n.options,n._updateClasses(),n._initData(t),n._animations(t),n.nextItemZIndex=100,n._tabindex(),n._initOverflow(t),n._attachMenuEventsHandlers(),t.openOnClick&&(n.clicked=!1),e.attr("role","menubar"),e[0].id&&(n._ariaId=T.format("{0}_mn_active",e[0].id)),T.notify(n)},events:[W,$,J,ee,X],options:{name:"Menu",animation:{open:{duration:200},close:{duration:100}},orientation:"horizontal",direction:"default",openOnClick:!1,closeOnClick:!0,hoverDelay:100,scrollable:!1,popupCollision:t},_initData:function(e){var t=this;e.dataSource&&(t.angular("cleanup",function(){return{elements:t.element.children()}}),t.element.empty(),t.append(e.dataSource,t.element),t.angular("compile",function(){return{elements:t.element.children()}}))},_attachMenuEventsHandlers:function(){var t=this,n=t.element,i=t.options,o=t._overflowWrapper();(o||n).on(te,Ae,P(t._focusHandler,t)).on(M+V,De,!1).on(M+V,Ae,P(t._click,t)).on(te+" "+I+V,".k-content",P(t._preventClose,t)).on(re+V,Ee,P(t._mouseenter,t)).on(se+V,Ee,P(t._mouseleave,t)).on(I+V,Ee,P(t._mousedown,t)).on(re+V+" "+se+V+" "+I+V+" "+M+V,Ie,P(t._toggleHover,t)),n.on("keydown"+V,P(t._keydown,t)).on("focus"+V,P(t._focus,t)).on("focus"+V,".k-content",P(t._focus,t)).on("blur"+V,P(t._removeHoverItem,t)).on("blur"+V,"[tabindex]",P(t._checkActiveElement,t)),o&&o.on(se+V,Se,P(t._mouseleavePopup,t)).on(re+V,Se,P(t._mouseenterPopup,t)),i.openOnClick&&(t._documentClickHandler=P(t._documentClick,t),e(document).click(t._documentClickHandler))},_detachMenuEventsHandlers:function(){var t=this,n=t._overflowWrapper();n&&n.off(V),t.element.off(V),t._documentClickHandler&&e(document).unbind("click",t._documentClickHandler)},_initOverflow:function(t){var n,i,o,r,s=this,a="horizontal"==t.orientation;t.scrollable&&(s._openedPopups={},s._scrollWrapper=s.element.wrap("<div class='k-menu-scroll-wrapper "+t.orientation+"'></div>").parent(),a&&C(s.element),n=e(Le.scrollButton({direction:a?"left":"up"})),i=e(Le.scrollButton({direction:a?"right":"down"})),n.add(i).appendTo(s._scrollWrapper),s._initScrolling(s.element,n,i,a),o=s.element.outerWidth(),r=s.element[0].style.width,r="auto"===r?"":r,a&&e(window).on(le,T.throttle(function(){s._setOverflowWrapperWidth(o,r),s._toggleScrollButtons(s.element,n,i,a)},100)),s._setOverflowWrapperWidth(o,r),s._toggleScrollButtons(s.element,n,i,a))},_overflowWrapper:function(){return this._scrollWrapper||this._popupsWrapper},_setOverflowWrapperWidth:function(e,t){var n,i,o,r,s=this,a=s._scrollWrapper.css("width");s._scrollWrapper.css({width:""}),n=s._scrollWrapper.outerWidth(),s._scrollWrapper.css({width:a}),i=s.element.outerWidth(),o=s.element[0].offsetWidth-s.element[0].clientWidth,i!=n&&n>0&&(r=t?Math.min(e,n):n,s.element.width(r-o),s._scrollWrapper.width(r))},_reinitOverflow:function(e){var t=this,n=e.scrollable&&!t.options.scrollable||!e.scrollable&&t.options.scrollable||e.scrollable&&t.options.scrollable&&e.scrollable.distance!=t.options.scrollable.distance||e.orientation!=t.options.orientation;n&&(t._detachMenuEventsHandlers(),t._destroyOverflow(),t._initOverflow(e),t._attachMenuEventsHandlers())},_destroyOverflow:function(){var n=this,i=n._overflowWrapper();i&&(i.off(V),i.find(Pe).off(V).remove(),i.children(Ce).each(function(t,n){var o,r=e(n).children(xe);r.off(ae),o=v(r,i),o.length&&o.append(n)}),i.find(p()).removeAttr("data-groupparent"),i.find(m()).removeAttr("data-group"),n.element.off(ae),e(window).off(le),i.contents().unwrap(),n._scrollWrapper=n._popupsWrapper=n._openedPopups=t)},_initScrolling:function(t,n,i,o){var r=this,s=r.options.scrollable,a=e.isNumeric(s.distance)?s.distance:F,l=a/2,c="-="+a,d="+="+a,u="-="+2*a,h="+="+2*a,f=!1,p=!1,m=function(e){var s=o?{scrollLeft:e}:{scrollTop:e};t.finish().animate(s,"fast","linear",function(){f&&m(e)}),r._toggleScrollButtons(t,n,i,o)},g=function(e){f||p||(m(e.data.direction),f=!0)},v=function(s){var a=o?{scrollLeft:s.data.direction}:{scrollTop:s.data.direction};p=x(s)||k(s),t.stop().animate(a,"fast","linear",function(){p?(r._toggleScrollButtons(t,n,i,o),f=!0):e(s.currentTarget).trigger(re)}),f=!1,s.stopPropagation(),s.preventDefault()};n.on(re+V,{direction:c},g).on(T.eventMap.down+V,{direction:u},v),i.on(re+V,{direction:d},g).on(T.eventMap.down+V,{direction:h},v),n.add(i).on(se+V,function(){t.stop(),f=!1,r._toggleScrollButtons(t,n,i,o)}),t.on(ae,function(e){var s,a,c,d;e.ctrlKey||e.shiftKey||e.altKey||(s=w(e.originalEvent),a=Math.abs(s)*l,c=(s>0?"+=":"-=")+a,d=o?{scrollLeft:c}:{scrollTop:c},r._closeChildPopups(t),t.finish().animate(d,"fast","linear",function(){r._toggleScrollButtons(t,n,i,o)}),e.preventDefault())})},_toggleScrollButtons:function(e,t,n,i){var o=i?e.scrollLeft():e.scrollTop(),r=i?ce:de,s=i?ue:he;t.toggle(0!==o),n.toggle(o<e[0][r]-e[0][s]-1)},setOptions:function(e){var t=this.options.animation;this._animations(e),e.animation=z(!0,t,e.animation),"dataSource"in e&&this._initData(e),this._updateClasses(),this._reinitOverflow(e),N.fn.setOptions.call(this,e)},destroy:function(){var e=this;N.fn.destroy.call(e),e._detachMenuEventsHandlers(),e._destroyOverflow(),T.destroy(e.element)},enable:function(e,t){return this._toggleDisabled(e,t!==!1),this},disable:function(e){return this._toggleDisabled(e,!1),this},append:function(e,t){t=this.element.find(t);var n=this._insert(e,t,t.length?t.find("> .k-menu-group, > .k-animation-container > .k-menu-group"):null);return B(n.items,function(t){n.group.append(this),s(this),u(this,e[t]||e)}),s(t),l(n.group.find(".k-first, .k-last").add(n.items)),c(d(n.group)),this},insertBefore:function(e,t){t=this.element.find(t);var n=this._insert(e,t,t.parent());return B(n.items,function(n){t.before(this),s(this),l(this),u(this,e[n]||e)}),l(t),this},insertAfter:function(e,t){t=this.element.find(t);var n=this._insert(e,t,t.parent());return B(n.items,function(n){t.after(this),s(this),l(this),u(this,e[n]||e)}),l(t),this},_insert:function(t,n,i){var o,s,a,l,c=this;return n&&n.length||(i=c.element),a=e.isPlainObject(t),l={firstLevel:i.hasClass(j),horizontal:i.hasClass(j+"-horizontal"),expanded:!0,length:i.children().length},n&&!i.length&&(i=e(Ne.renderGroup({group:l})).appendTo(n)),a||e.isArray(t)?o=e(e.map(a?[t]:t,function(t,n){return"string"==typeof t?e(t).get():e(Ne.renderItem({group:l,item:z(t,{index:n})})).get()})):(o="string"==typeof t&&"<"!=t.charAt(0)?c.element.find(t):e(t),s=o.find("> ul").addClass("k-menu-group").attr("role","menu"),o=o.filter("li"),o.add(s.find("> li")).each(function(){r(this)})),{items:o,group:i}},remove:function(e){var t,n,i,o,r;return e=this.element.find(e),t=this,n=e.parentsUntil(t.element,Te),i=e.parent("ul:not(.k-menu)"),e.remove(),i&&!i.children(Te).length&&(o=d(i),r=i.parent(Ce),r.length?r.remove():i.remove(),c(o)),n.length&&(n=n.eq(0),s(n),l(n)),t},open:function(o){var r=this,s=r.options,a="horizontal"==s.orientation,l=s.direction,c=T.support.isRtl(r.wrapper),d=r._overflowWrapper();return o=(d||r.element).find(o),/^(top|bottom|default)$/.test(l)&&(l=c?a?(l+" left").replace("default","bottom"):"left":a?(l+" right").replace("default","bottom"):"right"),r.options.openOnClick&&(r.clicked=!0),o.each(function(){var o=e(this);clearTimeout(o.data(K)),o.data(K,setTimeout(function(){var u,h,f,m,g,v,_,b,w,y,k=o.find(".k-menu-group:first:hidden");!k[0]&&d&&(h=r._getPopup(o),k=h&&h.element),k.is(":visible")||k[0]&&r._triggerEvent({item:o[0],type:W})===!1&&(!k.find(".k-menu-group")[0]&&k.children(".k-item").length>1?(f=e(window).height(),m=function(){k.css({maxHeight:f-(T._outerHeight(k)-k.height())-T.getShadows(k).bottom,overflow:"auto"})},T.support.browser.msie&&T.support.browser.version<=7?setTimeout(m,0):m()):k.css({maxHeight:"",overflow:""}),o.data(Z,o.css(Z)),g=r.nextItemZIndex++,o.css(Z,g),r.options.scrollable&&o.parent().siblings(Pe).css({zIndex:++g}),u=k.data(ge),v=o.parent().hasClass(j),_=v&&a,b=i(l,v,c),w=s.animation.open.effects,y=w!==t?w:"slideIn:"+n(l,v),u?(u=k.data(ge),u.options.origin=b.origin,u.options.position=b.position,u.options.animation.open.effects=y):u=k.kendoPopup({activate:function(){r._triggerEvent({item:this.wrapper.parent(),type:J})},deactivate:function(e){e.sender.element.removeData("targetTransform").css({opacity:""}),r._triggerEvent({item:this.wrapper.parent(),type:ee})},origin:b.origin,position:b.position,collision:s.popupCollision!==t?s.popupCollision:_?"fit":"fit flip",anchor:o,appendTo:d||o,animation:{open:z(!0,{effects:y},s.animation.open),close:s.animation.close},open:P(r._popupOpen,r),close:function(e){var t,n=e.sender.wrapper.parent();d&&(t=e.sender.element.data(fe),t&&(n=(d||r.element).find(p(t))),e.sender.wrapper.children(Pe).hide()),r._triggerEvent({item:n[0],type:$})?e.preventDefault():(n.css(Z,n.data(Z)),n.removeData(Z),r.options.scrollable&&n.parent().siblings(Pe).css({zIndex:""}),(E||oe)&&(n.removeClass(_e),r._removeHoverItem()))}}).data(ge),k.removeAttr("aria-hidden"),r._configurePopupOverflow(u,o),u._hovered=!0,u.open(),r._initPopupScrolling(u))},r.options.hoverDelay))}),r},_configurePopupOverflow:function(e,t){var n,i=this;i.options.scrollable&&(i._wrapPopupElement(e),t.attr("data-groupparent")||(n=(new Date).getTime(),t.attr("data-groupparent",n),e.element.attr("data-group",n)))},_wrapPopupElement:function(e){e.element.parent().is(Ce)||(e.wrapper=T.wrap(e.element,e.options.autosize).css({overflow:"hidden",display:"block",position:"absolute"}))},_initPopupScrolling:function(e,t,n){var i=this;i.options.scrollable&&e.element[0].scrollHeight>e.element[0].offsetHeight&&i._initPopupScrollButtons(e,t,n)},_initPopupScrollButtons:function(t,n,i){var o=this,r=t.wrapper.children(Pe),s=o.options.animation,a=(s&&s.open&&s.open.duration||0)+R;setTimeout(function(){var s,a;r.length||(s=e(Le.scrollButton({direction:n?"left":"up"})),a=e(Le.scrollButton({direction:n?"right":"down"})),r=s.add(a).appendTo(t.wrapper),o._initScrolling(t.element,s,a,n),i||r.on(re+V,function(){var n=o._overflowWrapper();e(g(t.element,n)).each(function(e,t){var i=n.find(p(t.data(fe)));o.close(i)})}).on(se+V,function(){setTimeout(function(){e.isEmptyObject(o._openedPopups)&&o._closeParentPopups(t.element)},R)})),o._toggleScrollButtons(t.element,r.first(),r.last(),n)},a)},_popupOpen:function(e){this._keyTriggered||e.sender.element.children("."+be).removeClass(be),this.options.scrollable&&this._setPopupHeight(e.sender)},_setPopupHeight:function(t,n){var i,o,r,s,a,l,c,d,u,h=t.element,f=h.add(h.parent(Ce));f.height(h.hasClass(j)&&this._initialHeight||""),i=t._location(n),o=e(window).height(),r=i.height,s=n?0:Math.max(i.top,0),a=n?0:y(this._overflowWrapper()[0],"scrollTop"),l=window.innerHeight-o,c=o-T.getShadows(h).bottom+l,d=c+a>r+s,d||(u=Math.min(c,c-s+a),f.css({overflow:"hidden",height:u+"px"}))},close:function(t,n){var i,o,r=this,s=r._overflowWrapper(),a=s||r.element;return t=a.find(t),t.length||(t=a.find(">.k-item")),i=function(t){var n=!1;return e.isEmptyObject(r._openedPopups)?n:(e(g(t,s)).each(function(e,t){return n=!!r._openedPopups[""+t.data(fe)],!n}),n)},o=function(e){var t=e.data(pe);return!s||!t||!r._openedPopups[""+t]},t.each(function(){var a=e(this);!n&&r._isRootItem(a)&&(r.clicked=!1),clearTimeout(a.data(K)),a.data(K,setTimeout(function(){var e=r._getPopup(a);if(e&&(o(a)||r._forceClose)){if(!r._forceClose&&i(e.element))return;e.close(),e.element.attr("aria-hidden",!0),s&&r._forceClose&&t.last().is(a[0])&&delete r._forceClose}},r.options.hoverDelay))}),r},_getPopup:function(e){var t,n,i=this,o=e.find(".k-menu-group:not(.k-list-container):not(.k-calendar-container):first:visible").data(ge),r=i._overflowWrapper();return!o&&r&&(t=e.data(pe),t&&(n=r.find(m(t)),o=n.data(ge))),o},_toggleDisabled:function(t,n){this.element.find(t).each(function(){e(this).toggleClass(ve,n).toggleClass(we,!n).attr("aria-disabled",!n)})},_toggleHover:function(t){var n=e(T.eventTarget(t)||t.target).closest(Te),i=t.type==re||I.indexOf(t.type)!==-1;n.parents("li."+we).length||n.toggleClass(_e,i||"mousedown"==t.type||"click"==t.type),this._removeHoverItem()},_preventClose:function(){this.options.closeOnClick||(this._closurePrevented=!0)},_checkActiveElement:function(t){var n=this,i=e(t?t.currentTarget:this._hoverItem()),r=n._findRootParent(i)[0];this._closurePrevented||setTimeout(function(){document.hasFocus()&&(o(r,T._activeElement())||!t||o(r,t.currentTarget))||n.close(r)},0),this._closurePrevented=!1},_removeHoverItem:function(){var e=this._hoverItem();e&&e.hasClass(be)&&(e.removeClass(be),this._oldHoverItem=null)},_updateClasses:function(){var e,t=this.element,n=".k-menu-init div ul";t.removeClass("k-menu-horizontal k-menu-vertical"),t.addClass("k-widget k-reset k-header k-menu-init "+j).addClass(j+"-"+this.options.orientation),t.find("li > ul").filter(function(){return!T.support.matchesSelector.call(this,n)}).addClass("k-group k-menu-group").attr("role","menu").attr("aria-hidden",t.is(":visible")).parent("li").attr("aria-haspopup","true").end().find("li > div").addClass("k-content").attr("tabindex","-1"),e=t.find("> li,.k-menu-group > li"),t.removeClass("k-menu-init"),e.each(function(){r(this)})},_mouseenter:function(t){var n=this,i=e(t.currentTarget),r=n._itemHasChildren(i),s=i.data(pe)||i.parent().data(fe),a=k(t);s&&(n._openedPopups[""+s]=!0),t.delegateTarget!=i.parents(ke)[0]&&t.delegateTarget!=i.parents(".k-menu-scroll-wrapper,.k-popups-wrapper")[0]||(n._keyTriggered=!1,n.options.openOnClick.rootMenuItems&&n._isRootItem(i.closest(Te))||n.options.openOnClick.subMenuItems&&!n._isRootItem(i.closest(Te))||(!(n.options.openOnClick===!1||n.options.openOnClick.rootMenuItems===!1&&n._isRootItem(i.closest(Te))||n.options.openOnClick.subMenuItems===!1&&!n._isRootItem(i.closest(Te))||n.clicked)||E||a&&n._isRootItem(i.closest(Te))||!o(t.currentTarget,t.relatedTarget)&&r&&n.open(i),(n.options.openOnClick===!0&&n.clicked||E)&&i.siblings().each(P(function(e,t){n.close(t,!0)},n))))},_mousedown:function(t){var n=this,i=e(t.currentTarget);(n.options.openOnClick.subMenuItems&&!n._isRootItem(i)||E)&&i.siblings().each(P(function(e,t){n.close(t,!0)},n))},_mouseleave:function(n){var i=this,r=e(n.currentTarget),s=r.data(pe),a=r.children(Ce).length||r.children(xe).length||s,l=e(window);return s&&delete i._openedPopups[""+s],r.parentsUntil(Ce,".k-list-container,.k-calendar-container")[0]?(n.stopImmediatePropagation(),t):i.options.openOnClick!==!1&&(i.options.openOnClick.rootMenuItems||!i._isRootItem(r))&&(i.options.openOnClick.subMenuItems||i._isRootItem(r))||E||k(n)||o(n.currentTarget,n.relatedTarget||n.target)||!a||o(n.currentTarget,T._activeElement())?((T.support.browser.msie&&!n.toElement&&!n.relatedTarget||n.clientX<0||n.clientY<0||n.clientY>l.height()||n.clientX>l.width())&&i.close(r),t):(i.close(r,!0),t)},_mouseenterPopup:function(t){var n,i=this,o=e(t.currentTarget);o.parent().is(Ce)||(o=o.children("ul"),n=o.data(fe),n&&(i._openedPopups[""+n]=!0))},_mouseleavePopup:function(t){var n=this,i=e(t.currentTarget);!k(t)&&i.is(Ce)&&n._closePopups(i.children("ul"))},_closePopups:function(t){var n,i=this,o=i._overflowWrapper(),r=t.data(fe);r&&(delete i._openedPopups[""+r],n=o.find(p(r)),setTimeout(function(){if(i.options.openOnClick)i._closeChildPopups(t);else if(e.isEmptyObject(i._openedPopups)){var o=i._innerPopup(t);i._closeParentPopups(o)}else i.close(n,!0)},0))},_closeChildPopups:function(t){var n=this,i=n._overflowWrapper();e(g(t,i)).each(function(){var e=i.find(p(this.data(fe)));n.close(e,!0)})},_innerPopup:function(e){var t=this._overflowWrapper(),n=g(e,t);return n[n.length-1]||e},_closeParentPopups:function(e){var t=this,n=t._overflowWrapper(),i=e.data(fe),o=n.find(p(i));for(i=o.parent().data(fe),t.close(o,!0);i&&!t._openedPopups[i]&&!o.parent().is(ke);)o=n.find(p(i)),t.close(o,!0),i=o.parent().data(fe)},_click:function(n){for(var i,o,r,s,a,l,c=this,d=c.options,u=e(T.eventTarget(n)),h=u[0],f=u[0]?u[0].nodeName.toUpperCase():"",p="INPUT"==f||"SELECT"==f||"BUTTON"==f||"LABEL"==f,g=u.closest("."+q),v=u.closest(Te),_=v[0],b=g.attr("href"),w=u.attr("href"),y=e("<a href='#' />").attr("href"),x=!!b&&b!==y,C=x&&!!b.match(/^#/),S=!!w&&w!==y,D=c._overflowWrapper();h&&h.parentNode!=_;)h=h.parentNode;if(!e(h).is(ze)){if(v.hasClass(we))return n.preventDefault(),t;if(n.handled||!c._triggerSelect(u,_)||p||n.preventDefault(),n.handled=!0,o=v.children(Se),D&&(a=v.data(pe),a&&(o=D.find(m(a)))),r=o.is(":visible"),s=d.openOnClick&&r&&c._isRootItem(v),d.closeOnClick&&(!x||C)&&(!o.length||s))return v.removeClass(_e).css("height"),c._oldHoverItem=c._findRootParent(v),l=c._parentsUntil(g,c.element,Te),c._forceClose=!!D,c.close(l),c.clicked=!1,"MSPointerUp".indexOf(n.type)!=-1&&n.preventDefault(),t;x&&n.enterKey&&g[0].click(),(c._isRootItem(v)&&d.openOnClick!==!1||d.openOnClick.subMenuItems||T.support.touch||k(n)&&c._isRootItem(v.closest(Te)))&&(x||p||S||n.preventDefault(),c.clicked=!0,i=o.is(":visible")?$:W,(d.closeOnClick||i!=$)&&c[i](v))}},_parentsUntil:function(n,i,o){var r,s,a=this._overflowWrapper();return a?(r=b(n,a),s=[],e(r).each(function(){var n=e(this);return!n.is(i)&&(n.is(o)&&s.push(this),t)}),e(s)):n.parentsUntil(i,o)},_triggerSelect:function(e,t){var n,i,o,r;return e=e.is(".k-link")?e:e.closest(".k-link"),n=e.data("selectHandler"),n&&(i=this._getEventData(e),n.call(this,i)),o=i&&i.isDefaultPrevented(),r=this._triggerEvent({item:t,type:X}),o||r},_getEventData:function(e){var t={sender:this,target:e,_defaultPrevented:!1,preventDefault:function(){this._defaultPrevented=!0},isDefaultPrevented:function(){return this._defaultPrevented}};return t},_documentClick:function(e){var t=this;o((t._overflowWrapper()||t.element)[0],e.target)||(t.clicked=!1)},_focus:function(n){var i=this,o=n.target,r=i._hoverItem(),s=A();return o==i.wrapper[0]||e(o).is(":kendoFocusable")?(s===n.currentTarget&&(r.length?i._moveHover([],r):i._oldHoverItem||i._moveHover([],i.wrapper.children().first())),t):(n.stopPropagation(),e(o).closest(".k-content").closest(".k-menu-group").closest(".k-item").addClass(be),i.wrapper.focus(),t)},_keydown:function(e){var n,i,o,r=this,s=e.keyCode,a=r._oldHoverItem,l=T.support.isRtl(r.wrapper);if(e.target==e.currentTarget||s==H.ESC){if(a||(a=r._oldHoverItem=r._hoverItem()),i=r._itemBelongsToVertival(a),o=r._itemHasChildren(a),r._keyTriggered=!0,s==H.RIGHT)n=r[l?"_itemLeft":"_itemRight"](a,i,o);else if(s==H.LEFT)n=r[l?"_itemRight":"_itemLeft"](a,i,o);else if(s==H.DOWN)n=r._itemDown(a,i,o);else if(s==H.UP)n=r._itemUp(a,i,o);else if(s==H.HOME)r._moveHover(a,a.parent().children().first()),e.preventDefault();else if(s==H.END)r._moveHover(a,a.parent().children().last()),e.preventDefault();else if(s==H.ESC)n=r._itemEsc(a,i);else if(s==H.ENTER||s==H.SPACEBAR)n=a.children(".k-link"),n.length>0&&(r._click({target:n[0],preventDefault:function(){},enterKey:!0}),o&&!a.hasClass(we)?(r.open(a),r._moveHover(a,r._childPopupElement(a).children().first())):r._moveHover(a,r._findRootParent(a)));else if(s==H.TAB)return n=r._findRootParent(a),r._moveHover(a,n),r._checkActiveElement(),t;n&&n[0]&&(e.preventDefault(),e.stopPropagation())}},_hoverItem:function(){return this.wrapper.find(".k-item.k-state-hover,.k-item.k-state-focused").filter(":visible")},_itemBelongsToVertival:function(e){var t=this.wrapper.hasClass("k-menu-vertical");return e.length?e.parent().hasClass("k-menu-group")||t:t},_itemHasChildren:function(e){return!!(e&&e.length&&e[0].nodeType)&&(e.children(".k-menu-group, div.k-animation-container").length>0||!!e.data(pe)&&!!this._overflowWrapper().children(m(e.data(pe))))},_moveHover:function(t,n){var i=this,o=i._ariaId;t.length&&n.length&&t.removeClass(be),n.length&&(n[0].id&&(o=n[0].id),n.addClass(be),i._oldHoverItem=n,o&&(i.element.removeAttr("aria-activedescendant"),e("#"+o).removeAttr("id"),n.attr("id",o),i.element.attr("aria-activedescendant",o)),i._scrollToItem(n))},_findRootParent:function(e){return this._isRootItem(e)?e:this._parentsUntil(e,ke,"li.k-item").last()},_isRootItem:function(e){return e.parent().hasClass(j)},_itemRight:function(e,t,n){var i,o,r,s,a=this;return t?n&&!e.hasClass(we)?(a.open(e),i=a._childPopupElement(e).children().first()):"horizontal"==a.options.orientation&&(o=a._findRootParent(e),r=a._overflowWrapper(),r&&(s=_(o,r),a._closeChildPopups(s)),a.close(o),i=o.nextAll(Re)):(i=e.nextAll(Re),i.length||(i=e.prevAll(Fe)),a.close(e)),i&&!i.length?i=a.wrapper.children(".k-item").first():i||(i=[]),a._moveHover(e,i),i},_itemLeft:function(e,t){var n,i,o=this;return t?(n=e.parent().closest(".k-item"),i=o._overflowWrapper(),!n.length&&i&&(n=v(e.parent(),i)),o.close(n),o._isRootItem(n)&&"horizontal"==o.options.orientation&&(n=n.prevAll(Re))):(n=e.prevAll(Re),n.length||(n=e.nextAll(Fe)),o.close(e)),n.length||(n=o.wrapper.children(".k-item").last()),o._moveHover(e,n),n},_itemDown:function(e,t,n){var i,o=this;if(t)i=e.nextAll(Re);else{if(!n||e.hasClass(we))return;o.open(e),i=o._childPopupElement(e).children().first()}return!i.length&&e.length?i=e.parent().children().first():e.length||(i=o.wrapper.children(".k-item").first()),o._moveHover(e,i),i},_itemUp:function(e,t){var n,i=this;if(t)return n=e.prevAll(Re),!n.length&&e.length?n=e.parent().children().last():e.length||(n=i.wrapper.children(".k-item").last()),i._moveHover(e,n),n},_scrollToItem:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f=this;f.options.scrollable&&e&&e.length&&(t=e.parent(),n=!!t.hasClass(j)&&"horizontal"==f.options.orientation,i=n?"scrollLeft":"scrollTop",o=n?T._outerWidth:T._outerHeight,r=t[i](),s=o(e),a=e[0][n?"offsetLeft":"offsetTop"],l=o(t),c=t.siblings(Pe),d=c.length?o(c.first()):0,r+l<a+s+d?u=a+s-l+d:r>a-d&&(u=a-d),isNaN(u)||(h={},h[i]=u,t.finish().animate(h,"fast","linear",function(){f._toggleScrollButtons(t,c.first(),c.last(),n)})))},_itemEsc:function(e,t){var n,i=this;return t?(n=e.parent().closest(".k-item"),i.close(n),i._moveHover(e,n),n):e},_childPopupElement:function(e){var t=e.find(".k-menu-group"),n=this._overflowWrapper();return!t.length&&n&&(t=_(e,n)),t},_triggerEvent:function(e){var t=this;return t.trigger(e.type,{type:e.type,item:e.item})},_focusHandler:function(t){var n=this,i=e(T.eventTarget(t)).closest(Te);i.hasClass(we)||setTimeout(function(){n._moveHover([],i),i.children(".k-content")[0]&&i.parent().closest(".k-item").removeClass(be)},200)},_animations:function(e){e&&"animation"in e&&!e.animation&&(e.animation={open:{effects:{}},close:{hide:!0,effects:{}}})}});z(Ne,{renderItem:function(e){e=z({menu:{},group:{}},e);var t=Le.empty,n=e.item;return Le.item(z(e,{image:n.imageUrl?Le.image:t,sprite:n.spriteCssClass?Le.sprite:t,itemWrapper:Le.itemWrapper,renderContent:Ne.renderContent,arrow:n.items||n.content?Le.arrow:t,subGroup:Ne.renderGroup},He))},renderGroup:function(e){return Le.group(z({renderItems:function(e){for(var t="",n=0,i=e.items,o=i?i.length:0,r=z({length:o},e.group);n<o;n++)t+=Ne.renderItem(z(e,{group:r,item:z({index:n},i[n])}));return t}},e,He))},renderContent:function(e){return Le.content(z(e,He))}}),S=Ne.extend({init:function(t,n){var i=this;Ne.fn.init.call(i,t,n),i._marker=T.guid().substring(0,8),i.target=e(i.options.target),i._popup(),i._wire()},_initOverflow:function(e){var t=this;e.scrollable&&!t._overflowWrapper()&&(t._openedPopups={},t._popupsWrapper=(t.element.parent().is(Ce)?t.element.parent():t.element).wrap("<div class='k-popups-wrapper "+e.orientation+"'></div>").parent(),"horizontal"==t.options.orientation&&C(t.element),e.appendTo&&e.appendTo.append(t._popupsWrapper),t._initialHeight=t.element[0].style.height,t._initialWidth=t.element[0].style.width)},options:{name:"ContextMenu",filter:null,showOn:"contextmenu",orientation:"vertical",alignToAnchor:!1,target:"body"},events:[W,$,J,ee,X],setOptions:function(t){var n=this;Ne.fn.setOptions.call(n,t),n.target.off(n.showOn+V+n._marker,n._showProxy),n.userEvents&&n.userEvents.destroy(),n.target=e(n.options.target),t.orientation&&n.popup.wrapper[0]&&n.popup.element.unwrap(),n._wire(),Ne.fn.setOptions.call(this,t)},destroy:function(){var e=this;e.target.off(e.options.showOn+V+e._marker),me.off(T.support.mousedown+V+e._marker,e._closeProxy),e.userEvents&&e.userEvents.destroy(),Ne.fn.destroy.call(e)},open:function(n,i){var r,s,a=this;return n=e(n)[0],
o(a.element[0],e(n)[0])||a._itemHasChildren(e(n))?Ne.fn.open.call(a,n):a._triggerEvent({item:a.element,type:W})===!1&&(a.popup.visible()&&a.options.filter&&(a.popup.close(!0),a.popup.element.kendoStop(!0)),i!==t?(r=a._overflowWrapper(),r&&(s=r.offset(),n-=s.left,i-=s.top),a.popup.wrapper.hide(),a._configurePopupScrolling(n,i),a.popup.open(n,i)):(a.popup.options.anchor=(n?n:a.popup.anchor)||a.target,a.popup.element.kendoStop(!0),a._configurePopupScrolling(),a.popup.open()),me.off(a.popup.downEvent,a.popup._mousedownProxy),me.on(T.support.mousedown+V+a._marker,a._closeProxy)),a},_configurePopupScrolling:function(e,n){var i=this,o=i.popup,r="horizontal"==i.options.orientation;i.options.scrollable&&(i._wrapPopupElement(o),o.element.parent().css({position:"",height:""}),o.element.css({visibility:"hidden",display:"",position:""}),r?i._setPopupWidth(o,isNaN(e)?t:{isFixed:!0,x:e,y:n}):i._setPopupHeight(o,isNaN(e)?t:{isFixed:!0,x:e,y:n}),o.element.css({visibility:"",display:"none",position:"absolute"}),i._initPopupScrollButtons(o,r,!0),o.element.siblings(Pe).hide())},_setPopupWidth:function(t,n){var i,o,r,s,a,l,c,d,u=t.element,h=u.add(u.parent(Ce));h.width(this._initialWidth||""),i=t._location(n),o=e(window).width(),r=i.width,s=Math.max(i.left,0),a=n?0:y(this._overflowWrapper()[0],"scrollLeft"),l=T.getShadows(u),c=o-l.left-l.right,d=c+a>r+s,d||h.css({overflow:"hidden",width:c-s+a+"px"})},close:function(){var t=this;o(t.element[0],e(arguments[0])[0])||t._itemHasChildren(arguments[0])?Ne.fn.close.call(t,arguments[0]):t.popup.visible()&&t._triggerEvent({item:t.element,type:$})===!1&&(t.popup.close(),me.off(T.support.mousedown+V,t._closeProxy),t.unbind(X,t._closeTimeoutProxy))},_showHandler:function(e){var t,n=e,i=this,r=i.options;e.event&&(n=e.event,n.pageX=e.x.location,n.pageY=e.y.location),o(i.element[0],e.relatedTarget||e.target)||(i._eventOrigin=n,n.preventDefault(),n.stopImmediatePropagation(),i.element.find("."+be).removeClass(be),(r.filter&&T.support.matchesSelector.call(n.currentTarget,r.filter)||!r.filter)&&(r.alignToAnchor?(i.popup.options.anchor=n.currentTarget,i.open(n.currentTarget)):(i.popup.options.anchor=n.currentTarget,i._targetChild?(t=i.target.offset(),i.open(n.pageX-t.left,n.pageY-t.top)):i.open(n.pageX,n.pageY))))},_closeHandler:function(t){var n,i=this,r=e(t.relatedTarget||t.target),s=r.closest(i.target.selector)[0]==i.target[0],a=r.closest(Ae),l=i._itemHasChildren(a),c=i._overflowWrapper(),d=o(i.element[0],r[0])||c&&o(c[0],r[0]);i._eventOrigin=t,n=3!==t.which,i.popup.visible()&&(n&&s||!s)&&(i.options.closeOnClick&&!l&&d||!d)&&(d?(this.unbind(X,this._closeTimeoutProxy),i.bind(X,i._closeTimeoutProxy)):i.close())},_wire:function(){var e=this,t=e.options,n=e.target;e._showProxy=P(e._showHandler,e),e._closeProxy=P(e._closeHandler,e),e._closeTimeoutProxy=P(e.close,e),n[0]&&(T.support.mobileOS&&"contextmenu"==t.showOn?(e.userEvents=new T.UserEvents(n,{filter:t.filter,allowSelection:!1}),n.on(t.showOn+V+e._marker,!1),e.userEvents.bind("hold",e._showProxy)):t.filter?n.on(t.showOn+V+e._marker,t.filter,e._showProxy):n.on(t.showOn+V+e._marker,e._showProxy))},_triggerEvent:function(n){var i=this,o=e(i.popup.options.anchor)[0],r=i._eventOrigin;return i._eventOrigin=t,i.trigger(n.type,z({type:n.type,item:n.item||this.element[0],target:o},r?{event:r}:{}))},_popup:function(){var t=this,n=t._overflowWrapper();t._triggerProxy=P(t._triggerEvent,t),t.popup=t.element.addClass("k-context-menu").kendoPopup({anchor:t.target||"body",copyAnchorStyles:t.options.copyAnchorStyles,collision:t.options.popupCollision||"fit",animation:t.options.animation,activate:t._triggerProxy,deactivate:t._triggerProxy,appendTo:n||t.options.appendTo,close:n?function(t){e(g(t.sender.element,n)).each(function(e,t){var n=t.data(ge);n&&n.close(!0)})}:e.noop}).data(ge),t._targetChild=o(t.target[0],t.popup.element[0])}}),D.plugin(Ne),D.plugin(S)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.columnmenu.min",["kendo.popup.min","kendo.filtermenu.min","kendo.menu.min"],e)}(function(){return function(e,t){function n(t){return e.trim(t).replace(/&nbsp;/gi,"")}function i(e,t){var n,i,o,r={};for(n=0,i=e.length;n<i;n++)o=e[n],r[o[t]]=o;return r}function o(e){var t,n=[];for(t=0;t<e.length;t++)e[t].columns?n=n.concat(o(e[t].columns)):n.push(e[t]);return n}function r(e,t){return"["+a.attr(e)+"='"+(t||"").replace(/'/g,'"')+"']"}function s(e,t,n){e>0?t.insertAfter(n.children().eq(e-1)):n.prepend(t)}var a=window.kendo,l=a.ui,c=e.proxy,d=e.extend,u=e.grep,h=e.map,f=e.inArray,p="k-state-selected",m="asc",g="desc",v="change",_="init",b="open",w="select",y="kendoPopup",k="kendoFilterMenu",x="kendoMenu",C=".kendoColumnMenu",S=l.Widget,T=S.extend({init:function(t,n){var i,o=this;S.fn.init.call(o,t,n),t=o.element,n=o.options,o.owner=n.owner,o.dataSource=n.dataSource,o.field=t.attr(a.attr("field")),o.title=t.attr(a.attr("title")),i=t.find(".k-header-column-menu"),i[0]||(i=t.addClass("k-with-icon").prepend('<a class="k-header-column-menu" href="#" title="'+n.messages.settings+'" aria-label="'+n.messages.settings+'"><span class="k-icon k-i-more-vertical"></span></a>').find(".k-header-column-menu")),o.link=i.attr("tabindex",-1).on("click"+C,c(o._click,o)),o.wrapper=e('<div class="k-column-menu"/>'),o._refreshHandler=c(o.refresh,o),o.dataSource.bind(v,o._refreshHandler)},_init:function(){var e=this;e.pane=e.options.pane,e.pane&&(e._isMobile=!0),e._isMobile?e._createMobileMenu():e._createMenu(),e.owner._muteAngularRebind(function(){e._angularItems("compile")}),e._sort(),e._columns(),e._filter(),e._lockColumns(),e.trigger(_,{field:e.field,container:e.wrapper})},events:[_,b,"sort","filtering"],options:{name:"ColumnMenu",messages:{sortAscending:"Sort Ascending",sortDescending:"Sort Descending",filter:"Filter",columns:"Columns",done:"Done",settings:"Column Settings",lock:"Lock",unlock:"Unlock"},filter:"",columns:!0,sortable:!0,filterable:!0,animations:{left:"slide"}},_createMenu:function(){var e=this,t=e.options;e.wrapper.html(a.template(D)({uid:a.guid(),ns:a.ns,messages:t.messages,sortable:t.sortable,filterable:t.filterable,columns:e._ownerColumns(),showColumns:t.columns,lockedColumns:t.lockedColumns})),e.popup=e.wrapper[y]({anchor:e.link,open:c(e._open,e),activate:c(e._activate,e),close:function(){e.options.closeCallback&&e.options.closeCallback(e.element)}}).data(y),e.menu=e.wrapper.children()[x]({orientation:"vertical",closeOnClick:!1}).data(x)},_createMobileMenu:function(){var e=this,t=e.options,n=a.template(A)({ns:a.ns,field:e.field,title:e.title||e.field,messages:t.messages,sortable:t.sortable,filterable:t.filterable,columns:e._ownerColumns(),showColumns:t.columns,lockedColumns:t.lockedColumns});e.view=e.pane.append(n),e.wrapper=e.view.element.find(".k-column-menu"),e.menu=new E(e.wrapper.children(),{pane:e.pane}),e.view.element.on("click",".k-done",function(t){e.close(),t.preventDefault()}),e.options.lockedColumns&&e.view.bind("show",function(){e._updateLockedColumns()})},_angularItems:function(t){var n=this;n.angular(t,function(){var t=n.wrapper.find(".k-columns-item input["+a.attr("field")+"]").map(function(){return e(this).closest("li")}),i=h(n._ownerColumns(),function(e){return{column:e._originalObject}});return{elements:t,data:i}})},destroy:function(){var e=this;e._angularItems("cleanup"),S.fn.destroy.call(e),e.filterMenu&&e.filterMenu.destroy(),e._refreshHandler&&e.dataSource.unbind(v,e._refreshHandler),e.options.columns&&e.owner&&(e._updateColumnsMenuHandler&&(e.owner.unbind("columnShow",e._updateColumnsMenuHandler),e.owner.unbind("columnHide",e._updateColumnsMenuHandler)),e._updateColumnsLockedStateHandler&&(e.owner.unbind("columnLock",e._updateColumnsLockedStateHandler),e.owner.unbind("columnUnlock",e._updateColumnsLockedStateHandler))),e.menu&&(e.menu.element.off(C),e.menu.destroy()),e.wrapper.off(C),e.popup&&e.popup.destroy(),e.view&&e.view.purge(),e.link.off(C),e.owner=null,e.wrapper=null,e.element=null},close:function(){this.menu.close(),this.popup&&(this.popup.close(),this.popup.element.off("keydown"+C))},_click:function(e){var t,n=this;e.preventDefault(),e.stopPropagation(),t=this.options,t.filter&&this.element.is(!t.filter)||(this.popup||this.pane?n._reorderColumnList():this._init(),this._isMobile?this.pane.navigate(this.view,this.options.animations.left):this.popup.toggle())},_reorderColumnList:function(){var t,n,i=this,o=i._ownerColumns()||[],a=i._isMobile&&i.view?e(i.view.element).find(".k-columns-item").children("ul"):e(i.wrapper).find(".k-menu-group");for(t=0;t<o.length;t++)n=a.find(r("field",o[t].originalField)).closest("li"),n[0]&&n.index()!==t&&s(t,n,a)},_open:function(){var t=this;e(".k-column-menu").not(t.wrapper).each(function(){e(this).data(y).close()}),t.popup.element.on("keydown"+C,function(e){e.keyCode==a.keys.ESC&&t.close()}),t.options.lockedColumns&&t._updateLockedColumns()},_activate:function(){this.menu.element.focus(),this.trigger(b,{field:this.field,container:this.wrapper})},_ownerColumns:function(){var e=o(this.owner.columns),t=u(e,function(e){var t=!0,i=n(e.title||"");return e.menu!==!1&&(e.field||i.length)||(t=!1),t});return h(t,function(t){return{originalField:t.field,field:t.field||t.title,title:t.title||t.field,hidden:t.hidden,index:f(t,e),locked:!!t.locked,_originalObject:t}})},_sort:function(){var t=this;t.options.sortable&&(t.refresh(),t.menu.bind(w,function(n){var i,o=e(n.item);o.hasClass("k-sort-asc")?i=m:o.hasClass("k-sort-desc")&&(i=g),i&&(o.parent().find(".k-sort-"+(i==m?g:m)).removeClass(p),t._sortDataSource(o,i),t.close())}))},_sortDataSource:function(e,n){var i,o,r=this,s=r.options.sortable,a=null===s.compare?t:s.compare,l=r.dataSource,c=l.sort()||[],d=e.hasClass(p)&&s&&s.allowUnsort!==!1;if(n=d?t:n,!r.trigger("sort",{sort:{field:r.field,dir:n,compare:a}})){if(d?e.removeClass(p):e.addClass(p),"multiple"===s.mode){for(i=0,o=c.length;i<o;i++)if(c[i].field===r.field){c.splice(i,1);break}c.push({field:r.field,dir:n,compare:a})}else c=[{field:r.field,dir:n,compare:a}];l.sort(c)}},_columns:function(){var t=this;t.options.columns&&(t._updateColumnsMenu(),t._updateColumnsMenuHandler=c(t._updateColumnsMenu,t),t.owner.bind(["columnHide","columnShow"],t._updateColumnsMenuHandler),t._updateColumnsLockedStateHandler=c(t._updateColumnsLockedState,t),t.owner.bind(["columnUnlock","columnLock"],t._updateColumnsLockedStateHandler),t.menu.bind(w,function(n){var i,r,s,l=e(n.item),c=o(t.owner.columns);t._isMobile&&n.preventDefault(),l.parent().closest("li.k-columns-item")[0]&&(i=l.find(":checkbox"),i.attr("disabled")||(s=i.attr(a.attr("field")),r=u(c,function(e){return e.field==s||e.title==s})[0],r.hidden===!0?t.owner.showColumn(r):t.owner.hideColumn(r)))}))},_updateColumnsMenu:function(){var e,t,n,i,o,r,s=a.attr("field"),l=a.attr("locked"),c=u(this._ownerColumns(),function(e){return!e.hidden}),d=u(c,function(e){return e.originalField}),p=u(d,function(e){return e.locked===!0}).length,m=u(d,function(e){return e.locked!==!0}).length;for(c=h(c,function(e){return e.field}),this.wrapper.find("[role='menuitemcheckbox']").attr("aria-checked",!1),r=this.wrapper.find(".k-columns-item input["+s+"]").prop("disabled",!1).prop("checked",!1),e=0,t=r.length;e<t;e++)n=r.eq(e),o="true"===n.attr(l),i=!1,f(n.attr(s),c)>-1&&(i=!0,n.prop("checked",i)),n.closest("[role='menuitemcheckbox']").attr("aria-checked",i),i&&(1==p&&o&&n.prop("disabled",!0),1!=m||o||n.prop("disabled",!0))},_updateColumnsLockedState:function(){var e,t,n,o,r=a.attr("field"),s=a.attr("locked"),l=i(this._ownerColumns(),"field"),c=this.wrapper.find(".k-columns-item input[type=checkbox]");for(e=0,t=c.length;e<t;e++)n=c.eq(e),o=l[n.attr(r)],o&&n.attr(s,o.locked);this._updateColumnsMenu()},_filter:function(){var t=this,n=k,i=t.options;i.filterable!==!1&&(i.filterable.multi&&(n="kendoFilterMultiCheck",i.filterable.dataSource&&(i.filterable.checkSource=i.filterable.dataSource,delete i.filterable.dataSource)),t.filterMenu=t.wrapper.find(".k-filterable")[n](d(!0,{},{appendToElement:!0,dataSource:i.dataSource,values:i.values,field:t.field,title:t.title,change:function(e){t.trigger("filtering",{filter:e.filter,field:e.field})&&e.preventDefault()}},i.filterable)).data(n),t._isMobile&&t.menu.bind(w,function(n){var i=e(n.item);i.hasClass("k-filter-item")&&t.pane.navigate(t.filterMenu.view,t.options.animations.left)}))},_lockColumns:function(){var t=this;t.menu.bind(w,function(n){var i=e(n.item);i.hasClass("k-lock")?(t.owner.lockColumn(t.field),t.close()):i.hasClass("k-unlock")&&(t.owner.unlockColumn(t.field),t.close())})},_updateLockedColumns:function(){var e,t,n,i,o=this.field,r=this.owner.columns,s=u(r,function(e){return e.field==o||e.title==o})[0];s&&(e=s.locked===!0,t=u(r,function(t){return!t.hidden&&(t.locked&&e||!t.locked&&!e)}).length,n=this.wrapper.find(".k-lock").removeClass("k-state-disabled"),i=this.wrapper.find(".k-unlock").removeClass("k-state-disabled"),(e||1==t)&&n.addClass("k-state-disabled"),e&&1!=t||i.addClass("k-state-disabled"),this._updateColumnsLockedState())},refresh:function(){var e,t,n,i=this,o=i.options.dataSource.sort()||[],r=i.field;for(i.wrapper.find(".k-sort-asc, .k-sort-desc").removeClass(p),t=0,n=o.length;t<n;t++)e=o[t],r==e.field&&i.wrapper.find(".k-sort-"+e.dir).addClass(p);i.link[i._filterExist(i.dataSource.filter())?"addClass":"removeClass"]("k-state-active")},_filterExist:function(e){var t,n,i,o=!1;if(e){for(e=e.filters,n=0,i=e.length;n<i;n++)t=e[n],t.field==this.field?o=!0:t.filters&&(o=o||this._filterExist(t));return o}}}),D='<ul id="#=uid#">#if(sortable){#<li class="k-item k-sort-asc"><span class="k-link"><span class="k-icon k-i-sort-asc-sm"></span>${messages.sortAscending}</span></li><li class="k-item k-sort-desc"><span class="k-link"><span class="k-icon k-i-sort-desc-sm"></span>${messages.sortDescending}</span></li>#if(showColumns || filterable){#<li class="k-separator" role="presentation"></li>#}##}##if(showColumns){#<li class="k-item k-columns-item" aria-haspopup="true"><span class="k-link"><span class="k-icon k-i-columns"></span>${messages.columns}</span><ul>#for (var idx = 0; idx < columns.length; idx++) {#<li role="menuitemcheckbox" aria-checked="false"><input type="checkbox" data-#=ns#field="#=columns[idx].field.replace(/"/g,"&\\#34;")#" data-#=ns#index="#=columns[idx].index#" data-#=ns#locked="#=columns[idx].locked#"/>#=columns[idx].title#</li>#}#</ul></li>#if(filterable || lockedColumns){#<li class="k-separator" role="presentation"></li>#}##}##if(filterable){#<li class="k-item k-filter-item" aria-haspopup="true"><span class="k-link"><span class="k-icon k-i-filter"></span>${messages.filter}</span><ul><li><div class="k-filterable"></div></li></ul></li>#if(lockedColumns){#<li class="k-separator" role="presentation"></li>#}##}##if(lockedColumns){#<li class="k-item k-lock"><span class="k-link"><span class="k-icon k-i-lock"></span>${messages.lock}</span></li><li class="k-item k-unlock"><span class="k-link"><span class="k-icon k-i-unlock"></span>${messages.unlock}</span></li>#}#</ul>',A='<div data-#=ns#role="view" data-#=ns#init-widgets="false" data-#=ns#use-native-scrolling="true" class="k-grid-column-menu"><div data-#=ns#role="header" class="k-header">${messages.settings}<button class="k-button k-done">#=messages.done#</button></div><div class="k-column-menu k-mobile-list"><ul><li><span class="k-link">${title}</span><ul>#if(sortable){#<li class="k-item k-sort-asc"><span class="k-link"><span class="k-icon k-i-sort-asc-sm"></span>${messages.sortAscending}</span></li><li class="k-item k-sort-desc"><span class="k-link"><span class="k-icon k-i-sort-desc-sm"></span>${messages.sortDescending}</span></li>#}##if(lockedColumns){#<li class="k-item k-lock"><span class="k-link"><span class="k-icon k-i-lock"></span>${messages.lock}</span></li><li class="k-item k-unlock"><span class="k-link"><span class="k-icon k-i-unlock"></span>${messages.unlock}</span></li>#}##if(filterable){#<li class="k-item k-filter-item"><span class="k-link k-filterable"><span class="k-icon k-i-filter"></span>${messages.filter}</span></li>#}#</ul></li>#if(showColumns){#<li class="k-columns-item"><span class="k-link">${messages.columns}</span><ul>#for (var idx = 0; idx < columns.length; idx++) {#<li class="k-item"><label class="k-label"><input type="checkbox" class="k-check" data-#=ns#field="#=columns[idx].field.replace(/"/g,"&\\#34;")#" data-#=ns#index="#=columns[idx].index#" data-#=ns#locked="#=columns[idx].locked#"/>#=columns[idx].title#</label></li>#}#</ul></li>#}#</ul></div></div>',E=S.extend({init:function(e,t){S.fn.init.call(this,e,t),this.element.on("click"+C,"li.k-item:not(.k-separator):not(.k-state-disabled)","_click")},events:[w],_click:function(t){e(t.target).is("[type=checkbox]")||t.preventDefault(),this.trigger(w,{item:t.currentTarget})},close:function(){this.options.pane.navigate("")},destroy:function(){S.fn.destroy.call(this),this.element.off(C)}});l.plugin(T)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.columnsorter.min",["kendo.core.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.ui,o=i.Widget,r="dir",s="asc",a="single",l="field",c="desc",d=".kendoColumnSorter",u=".k-link",h="aria-sort",f=e.proxy,p=o.extend({init:function(e,t){var n,i=this;o.fn.init.call(i,e,t),i._refreshHandler=f(i.refresh,i),i.dataSource=i.options.dataSource.bind("change",i._refreshHandler),i.directions=i.options.initialDirection===s?[s,c]:[c,s],n=i.element.find(u),n[0]||(n=i.element.wrapInner('<a class="k-link" href="#"/>').find(u)),i.link=n,i.element.on("click"+d,f(i._click,i))},options:{name:"ColumnSorter",mode:a,allowUnsort:!0,compare:null,filter:"",initialDirection:s,showIndexes:!1},events:["change"],destroy:function(){var e=this;o.fn.destroy.call(e),e.element.off(d),e.dataSource.unbind("change",e._refreshHandler),e._refreshHandler=e.element=e.link=e.dataSource=null},refresh:function(){var i,o,a,d,u,f,p=this,m=p.dataSource.sort()||[],g=p.element,v=g.attr(n.attr(l));for(g.removeAttr(n.attr(r)),g.removeAttr(h),i=0,o=m.length;i<o;i++)a=m[i],v==a.field&&(g.attr(n.attr(r),a.dir),u=i+1);d=g.attr(n.attr(r)),g.is("th")&&(f=g.closest("table"),f.parent().hasClass("k-grid-header-wrap")?f=f.closest(".k-grid").find(".k-grid-content > table"):f.parent().hasClass("k-grid")||(f=null),f&&(g.toggleClass("k-sorted",d!==t),f.children("colgroup").children().eq(g.index()).toggleClass("k-sorted",d!==t))),g.find(".k-i-sort-asc-sm,.k-i-sort-desc-sm,.k-sort-order").remove(),d===s?(e('<span class="k-icon k-i-sort-asc-sm" />').appendTo(p.link),g.attr(h,"ascending")):d===c&&(e('<span class="k-icon k-i-sort-desc-sm" />').appendTo(p.link),g.attr(h,"descending")),p.options.showIndexes&&m.length>1&&u&&e('<span class="k-sort-order" />').html(u).appendTo(p.link)},_toggleSortDirection:function(e){var n=this.directions;return e===n[n.length-1]&&this.options.allowUnsort?t:n[0]===e?n[1]:n[0]},_click:function(e){var i,o,s=this,c=s.element,d=c.attr(n.attr(l)),u=c.attr(n.attr(r)),h=s.options,f=null===s.options.compare?t:s.options.compare,p=s.dataSource.sort()||[];if(e.preventDefault(),(!h.filter||c.is(h.filter))&&(u=this._toggleSortDirection(u),!this.trigger("change",{sort:{field:d,dir:u,compare:f}}))){if(h.mode===a)p=[{field:d,dir:u,compare:f}];else if("multiple"===h.mode){for(i=0,o=p.length;i<o;i++)if(p[i].field===d){p.splice(i,1);break}p.push({field:d,dir:u,compare:f})}this.dataSource.options.endless&&(this.dataSource.options.endless=null,c.closest(".k-grid").getKendoGrid()._endlessPageSize=s.dataSource.options.pageSize,this.dataSource.pageSize(s.dataSource.options.pageSize)),this.dataSource.sort(p)}}});i.plugin(p)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.editable.min",["kendo.datepicker.min","kendo.numerictextbox.min","kendo.validator.min","kendo.binder.min"],e)}(function(){return function(e,t){function n(t){return t=null!=t?t:"",t.type||e.type(t)||"string"}function i(t){t.find(":input:not(:button, .k-combobox .k-input, ["+a.attr("role")+"=listbox], ["+a.attr("role")+"=upload], ["+a.attr("skip")+"], [type=file])").each(function(){var t=a.attr("bind"),n=this.getAttribute(t)||"",i="checkbox"===this.type||"radio"===this.type?"checked:":"value:",o=this.name;n.indexOf(i)===-1&&o&&(n+=(n.length?",":"")+i+o,e(this).attr(t,n))})}function o(e){var t,i,o=(e.model.fields||e.model)[e.field],r=n(o),s=o?o.validation:{},l=a.attr("type"),c=a.attr("bind"),d={name:e.field,title:e.title};for(t in s)i=s[t],p(t,b)>=0?d[l]=t:h(i)||(d[t]=f(i)?i.value||t:i),d[a.attr(t+"-msg")]=i.message;return p(r,b)>=0&&(d[l]=r),d[c]=("boolean"===r?"checked:":"value:")+e.field,d}function r(e){var t,n,i,o,r,s;if(e&&e.length)for(s=[],t=0,n=e.length;t<n;t++)i=e[t],r=i.text||i.value||i,o=null==i.value?i.text||i:i.value,s[t]={text:r,value:o};return s}function s(e,t){var n,i,o=e?e.validation||{}:{};for(n in o)i=o[n],f(i)&&i.value&&(i=i.value),h(i)&&(t[n]=i)}var a=window.kendo,l=a.ui,c=l.Widget,d=e.extend,u=a.support.browser.msie&&a.support.browser.version<9,h=a.isFunction,f=e.isPlainObject,p=e.inArray,m=/("|\%|'|\[|\]|\$|\.|\,|\:|\;|\+|\*|\&|\!|\#|\(|\)|<|>|\=|\?|\@|\^|\{|\}|\~|\/|\||`)/g,g='<div class="k-widget k-tooltip k-tooltip-validation" style="margin:0.5em"><span class="k-icon k-i-warning"> </span>#=message#<div class="k-callout k-callout-n"></div></div>',v="change",_="equalSet",b=["url","email","number","date","boolean"],w={number:function(t,n){var i=o(n);e('<input type="text"/>').attr(i).appendTo(t).kendoNumericTextBox({format:n.format}),e("<span "+a.attr("for")+'="'+n.field+'" class="k-invalid-msg"/>').hide().appendTo(t)},date:function(t,n){var i=o(n),r=n.format;r&&(r=a._extractFormat(r)),i[a.attr("format")]=r,e('<input type="text"/>').attr(i).appendTo(t).kendoDatePicker({format:n.format}),e("<span "+a.attr("for")+'="'+n.field+'" class="k-invalid-msg"/>').hide().appendTo(t)},string:function(t,n){var i=o(n);e('<input type="text" class="k-input k-textbox"/>').attr(i).appendTo(t)},"boolean":function(t,n){var i=o(n);e('<input type="checkbox" />').attr(i).appendTo(t)},values:function(t,n){var i=o(n),s=a.stringify(r(n.values));e("<select "+a.attr("text-field")+'="text"'+a.attr("value-field")+'="value"'+a.attr("source")+"='"+(s?s.replace(/\'/g,"&apos;"):s)+"'"+a.attr("role")+'="dropdownlist"/>').attr(i).appendTo(t),e("<span "+a.attr("for")+'="'+n.field+'" class="k-invalid-msg"/>').hide().appendTo(t)}},y=c.extend({init:function(t,n){var i=this;n.target&&(n.$angular=n.target.options.$angular),c.fn.init.call(i,t,n),i._validateProxy=e.proxy(i._validate,i),i.refresh()},events:[v],options:{name:"Editable",editors:w,clearContainer:!0,errorTemplate:g,skipFocus:!1},editor:function(e,t){var i=this,o=i.options.editors,r=f(e),s=r?e.field:e,l=i.options.model||{},c=r&&e.values,u=c?"values":n(t),h=r&&e.editor,p=h?e.editor:o[u],g=i.element.find("["+a.attr("container-for")+"="+s.replace(m,"\\$1")+"]");p=p?p:o.string,h&&"string"==typeof e.editor&&(p=function(t){t.append(e.editor)}),g=g.length?g:i.element,p(g,d(!0,{},r?e:{field:s},{model:l}))},_validate:function(t){var n,i=this,o=t.value,r=i._validationEventInProgress,s={},l=a.attr("bind"),c=t.field.replace(m,"\\$1"),d=RegExp("(value|checked)\\s*:\\s*"+c+"\\s*(,|$)");s[t.field]=t.value,n=e(":input["+l+'*="'+c+'"]',i.element).filter("["+a.attr("validate")+"!='false']").filter(function(){return d.test(e(this).attr(l))}),n.length>1&&(n=n.filter(function(){var t=e(this);return!t.is(":radio")||t.val()==o}));try{i._validationEventInProgress=!0,(!i.validatable.validateInput(n)||!r&&i.trigger(v,{values:s}))&&t.preventDefault()}finally{i._validationEventInProgress=!1}},end:function(){return this.validatable.validate()},destroy:function(){var e=this;e.angular("cleanup",function(){return{elements:e.element}}),c.fn.destroy.call(e),e.options.model.unbind("set",e._validateProxy),e.options.model.unbind(_,e._validateProxy),a.unbind(e.element),e.validatable&&e.validatable.destroy(),a.destroy(e.element),e.element.removeData("kendoValidator"),e.element.is("["+a.attr("role")+"=editable]")&&e.element.removeAttr(a.attr("role"))},refresh:function(){var n,o,r,l,c,d,h,p,m=this,g=m.options.fields||[],v=m.options.clearContainer?m.element.empty():m.element,b=m.options.model||{},w={};for(e.isArray(g)||(g=[g]),n=0,o=g.length;n<o;n++)r=g[n],l=f(r),c=l?r.field:r,d=(b.fields||b)[c],s(d,w),m.editor(r,d);if(m.options.target&&m.angular("compile",function(){return{elements:v,data:v.map(function(){return{dataItem:b}})}}),!o){h=b.fields||b;for(c in h)s(h[c],w)}i(v),m.validatable&&m.validatable.destroy(),a.bind(v,m.options.model),m.options.model.unbind("set",m._validateProxy),m.options.model.bind("set",m._validateProxy),m.options.model.unbind(_,m._validateProxy),m.options.model.bind(_,m._validateProxy),m.validatable=new a.ui.Validator(v,{validateOnBlur:!1,errorTemplate:m.options.errorTemplate||t,rules:w}),m.options.skipFocus||(p=v.find(":kendoFocusable").eq(0).focus(),u&&p.focus())}});l.plugin(y)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.window.min",["kendo.draganddrop.min","kendo.popup.min"],e)}(function(){return function(e,t){function n(e){return t!==e}function i(e,t,n){return Math.max(Math.min(parseInt(e,10),n===1/0?n:parseInt(n,10)),parseInt(t,10))}function o(){return!this.type||this.type.toLowerCase().indexOf("script")>=0}function r(e){var t=this;t.owner=e,t._preventDragging=!1,t._draggable=new u(e.wrapper,{filter:">"+D,group:e.wrapper.id+"-resizing",dragstart:g(t.dragstart,t),drag:g(t.drag,t),dragend:g(t.dragend,t)}),t._draggable.userEvents.bind("press",g(t.addOverlay,t)),t._draggable.userEvents.bind("release",g(t.removeOverlay,t))}function s(t){for(var n,i,o={top:t.offsetTop,left:t.offsetLeft},r=t.offsetParent;r;)o.top+=r.offsetTop,o.left+=r.offsetLeft,n=e(r).css("overflowX"),i=e(r).css("overflowY"),"auto"!==i&&"scroll"!==i||(o.top-=r.scrollTop),"auto"!==n&&"scroll"!==n||(o.left-=r.scrollLeft),r=r.offsetParent;return o}function a(e,t){var n=this;n.owner=e,n._preventDragging=!1,n._draggable=new u(e.wrapper,{filter:t,group:e.wrapper.id+"-moving",dragstart:g(n.dragstart,n),drag:g(n.drag,n),dragend:g(n.dragend,n),dragcancel:g(n.dragcancel,n)}),n._draggable.userEvents.stopPropagation=!1}var l=window.kendo,c=l.ui.Widget,d=l.ui.Popup.TabKeyTrap,u=l.ui.Draggable,h=e.isPlainObject,f=l._activeElement,p=l._outerWidth,m=l._outerHeight,g=e.proxy,v=e.extend,_=e.each,b=l.template,w="body",y=".kendoWindow",k=".k-window",x=".k-window-title",C=x+"bar",S=".k-window-content",T=".k-dialog-content",D=".k-resize-handle",A=".k-overlay",E="k-content-frame",I="k-i-loading",M="k-state-hover",R="k-state-focused",F="k-window-maximized",z=":visible",P="hidden",B="cursor",L="open",H="activate",N="deactivate",O="close",V="refresh",U="minimize",W="maximize",j="resizeStart",q="resize",G="resizeEnd",$="dragstart",K="dragend",Y="error",Q="overflow",X="original-overflow-rule",Z="zIndex",J=".k-window-actions .k-i-window-minimize,.k-window-actions .k-i-window-maximize",ee=".k-i-pin",te=".k-i-unpin",ne=ee+","+te,ie=".k-window-titlebar .k-window-action",oe=".k-window-titlebar .k-i-refresh",re="WindowEventsHandled",se=/^0[a-z]*$/i,ae=l.isLocalUrl,le=c.extend({init:function(i,r){var s,a,u,f,p,m,v,_,b,w=this,D={},A=!1,I=r&&r.actions&&!r.actions.length;c.fn.init.call(w,i,r),r=w.options,f=r.position,i=w.element,p=r.content,_=e(window),I&&(r.actions=[]),w.appendTo=e(r.appendTo),p&&!h(p)&&(p=r.content={url:p}),i.find("script").filter(o).remove(),i.parent().is(w.appendTo)||f.top!==t&&f.left!==t||(i.is(z)?(D=i.offset(),A=!0):(a=i.css("visibility"),u=i.css("display"),i.css({visibility:P,display:""}),D=i.offset(),i.css({visibility:a,display:u})),f.top===t&&(f.top=D.top),f.left===t&&(f.left=D.left)),n(r.visible)&&null!==r.visible||(r.visible=i.is(z)),s=w.wrapper=i.closest(k),i.is(".k-content")&&s[0]||(i.addClass("k-window-content k-content"),w._createWindow(i,r),s=w.wrapper=i.closest(k),w._dimensions()),w._position(),p&&w.refresh(p),r.visible&&w.toFront(),m=s.children(S),w._tabindex(m),r.visible&&r.modal&&w._overlay(s.is(z)).css({opacity:.5}),s.on("mouseenter"+y,ie,g(w._buttonEnter,w)).on("mouseleave"+y,ie,g(w._buttonLeave,w)).on("click"+y,"> "+ie,g(w._windowActionHandler,w)).on("keydown"+y,g(w._keydown,w)).on("focus"+y,g(w._focus,w)).on("blur"+y,g(w._blur,w)),m.on("keydown"+y,g(w._keydown,w)).on("focus"+y,g(w._focus,w)).on("blur"+y,g(w._blur,w)),v=m.find("."+E)[0],v&&!_.data(re)&&(_.on("blur"+y,function(){var t,n=e(document.activeElement).parent(S);n.length&&(t=l.widgetInstance(n),t._focus())}),_.on("focus"+y,function(){e(S).not(T).each(function(t,n){l.widgetInstance(e(n))._blur()})}),_.data(re,!0)),this._resizable(),this._draggable(),r.pinned&&this.wrapper.is(":visible")&&w.pin(),b=i.attr("id"),b&&(b+="_wnd_title",s.children(C).children(x).attr("id",b),m.attr({role:"dialog","aria-labelledby":b})),s.add(s.children(".k-resize-handle,"+C)).on("mousedown"+y,g(w.toFront,w)),w.touchScroller=l.touchScroller(i),w._resizeHandler=g(w._onDocumentResize,w),w._marker=l.guid().substring(0,8),e(window).on("resize"+y+w._marker,w._resizeHandler),r.visible&&(w.trigger(L),w.trigger(H)),l.notify(w),this.options.modal&&(this._tabKeyTrap=new d(s),this._tabKeyTrap.trap(),this._tabKeyTrap.shouldTrap=function(){return m.data("isFront")})},_buttonEnter:function(t){e(t.currentTarget).addClass(M)},_buttonLeave:function(t){e(t.currentTarget).removeClass(M)},_focus:function(){this.wrapper.addClass(R)},_blur:function(){this.wrapper.removeClass(R)},_dimensions:function(){var e,t,n=this.wrapper,o=this.options,r=o.width,s=o.height,a=o.maxHeight,l=["minWidth","minHeight","maxWidth","maxHeight"];for(this.title(o.title),e=0;e<l.length;e++)t=o[l[e]]||"",t!=1/0&&n.css(l[e],t);a!=1/0&&this.element.css("maxHeight",a),n.width(r?isNaN(r)&&(""+r).indexOf("px")<0?r:i(r,o.minWidth,o.maxWidth):""),n.height(s?isNaN(s)&&(""+s).indexOf("px")<0?s:i(s,o.minHeight,o.maxHeight):""),o.visible||n.hide()},_position:function(){var e=this.wrapper,t=this.options.position;0===t.top&&(t.top=""+t.top),0===t.left&&(t.left=""+t.left),e.css({top:t.top||"",left:t.left||""})},_animationOptions:function(e){var t=this.options.animation,n={open:{effects:{}},close:{hide:!0,effects:{}}};return t&&t[e]||n[e]},_resize:function(){l.resize(this.element.children())},_resizable:function(){var t=this.options.resizable,n=this.wrapper;this.resizing&&(n.off("dblclick"+y).children(D).remove(),this.resizing.destroy(),this.resizing=null),t&&(n.on("dblclick"+y,C,g(function(t){e(t.target).closest(".k-window-action").length||this.toggleMaximization()},this)),_("n e s w se sw ne nw".split(" "),function(e,t){n.append(ce.resizeHandle(t))}),this.resizing=new r(this)),n=null},_draggable:function(){var e=this.options.draggable;this.dragging&&(this.dragging.destroy(),this.dragging=null),e&&(this.dragging=new a(this,e.dragHandle||C))},_actions:function(){var t=this.options,n=t.actions,i=t.pinned,o=this.wrapper.children(C),r=o.find(".k-window-actions"),s=["maximize","minimize"];n=e.map(n,function(e){return e=i&&"pin"===e.toLowerCase()?"unpin":e,{name:s.indexOf(e.toLowerCase())>-1?"window-"+e:e}}),r.html(l.render(ce.action,n))},setOptions:function(e){var n,i,o=JSON.parse(JSON.stringify(e));v(e.position,this.options.position),v(e.position,o.position),c.fn.setOptions.call(this,e),n=this.options.scrollable!==!1,this.restore(),this._dimensions(),this._position(),this._resizable(),this._draggable(),this._actions(),t!==e.modal&&(i=this.options.visible!==!1,this._overlay(e.modal&&i)),this.element.css(Q,n?"":"hidden")},events:[L,H,N,O,U,W,V,j,q,G,$,K,Y],options:{name:"Window",animation:{open:{effects:{zoom:{direction:"in"},fade:{direction:"in"}},duration:350},close:{effects:{zoom:{direction:"out",properties:{scale:.7}},fade:{direction:"out"}},duration:350,hide:!0}},title:"",actions:["Close"],autoFocus:!0,modal:!1,resizable:!0,draggable:!0,minWidth:90,minHeight:50,maxWidth:1/0,maxHeight:1/0,pinned:!1,scrollable:!0,position:{},content:null,visible:null,height:null,width:null,appendTo:"body",
isMaximized:!1,isMinimized:!1},_closable:function(){return e.inArray("close",e.map(this.options.actions,function(e){return e.toLowerCase()}))>-1},_keydown:function(e){var t,n,o,r,s,a,c=this,d=c.options,u=l.keys,h=e.keyCode,f=c.wrapper,p=10,m=c.options.isMaximized,g=c.options.isMinimized;h==u.ESC&&c._closable()&&c._close(!1),e.target!=e.currentTarget||c._closing||(e.altKey&&82==h&&c.refresh(),e.altKey&&80==h&&(c.options.pinned?c.unpin():c.pin()),e.altKey&&h==u.UP?g?(c.restore(),c.element.focus()):m||(c.maximize(),c.element.focus()):e.altKey&&h==u.DOWN&&(g||m?m&&(c.restore(),c.element.focus()):(c.minimize(),c.wrapper.focus())),!d.draggable||e.ctrlKey||e.altKey||m||(t=l.getOffset(f),h==u.UP?n=f.css("top",t.top-p):h==u.DOWN?n=f.css("top",t.top+p):h==u.LEFT?n=f.css("left",t.left-p):h==u.RIGHT&&(n=f.css("left",t.left+p))),d.resizable&&e.ctrlKey&&!m&&!g&&(h==u.UP?(n=!0,r=f.height()-p):h==u.DOWN&&(n=!0,r=f.height()+p),h==u.LEFT?(n=!0,o=f.width()-p):h==u.RIGHT&&(n=!0,o=f.width()+p),n&&(s=i(o,d.minWidth,d.maxWidth),a=i(r,d.minHeight,d.maxHeight),isNaN(s)||(f.width(s),c.options.width=s+"px"),isNaN(a)||(f.height(a),c.options.height=a+"px"),c.resize())),n&&e.preventDefault())},_overlay:function(t){var n=this.appendTo.children(A),i=this.wrapper;return n.length||(n=e("<div class='k-overlay' />")),n.insertBefore(i[0]).toggle(t).css(Z,parseInt(i.css(Z),10)-1),n},_actionForIcon:function(e){var t=/\bk-i(-\w+)+\b/.exec(e[0].className)[0];return{"k-i-close":"_close","k-i-window-maximize":"maximize","k-i-window-minimize":"minimize","k-i-window-restore":"restore","k-i-refresh":"refresh","k-i-pin":"pin","k-i-unpin":"unpin"}[t]},_windowActionHandler:function(n){var i,o;if(!this._closing)return i=e(n.target).closest(".k-window-action").find(".k-icon"),o=this._actionForIcon(i),o?(n.preventDefault(),this[o](),!1):t},_modals:function(){var t=this,n=e(k).filter(function(){var n=e(this),i=t._object(n),o=i&&i.options;return o&&o.modal&&o.visible&&o.appendTo===t.options.appendTo&&n.is(z)}).sort(function(t,n){return+e(t).css("zIndex")-+e(n).css("zIndex")});return t=null,n},_object:function(e){var n=e.children(S),i=l.widgetInstance(n);return i?i:t},center:function(){var t,n,i=this,o=i.options.position,r=i.wrapper,s=e(window),a=0,l=0;return i.options.isMaximized?i:(i.options.pinned&&!i._isPinned&&i.pin(),i.options.pinned||(a=s.scrollTop(),l=s.scrollLeft()),n=l+Math.max(0,(s.width()-r.width())/2),t=a+Math.max(0,(s.height()-r.height()-parseInt(r.css("paddingTop"),10))/2),r.css({left:n,top:t}),o.top=t,o.left=n,i)},title:function(e){var t,n=this,i=n.wrapper,o=n.options,r=i.children(C),s=r.children(x);return arguments.length?(e===!1?(i.addClass("k-window-titleless"),r.remove()):(r.length?s.html(l.htmlEncode(e)):(i.prepend(ce.titlebar(o)),n._actions(),r=i.children(C)),t=parseInt(m(r),10),i.css("padding-top",t),r.css("margin-top",-t)),n.options.title=e,n):s.html()},content:function(e,t){var i=this.wrapper.children(S),o=i.children(".km-scroll-container");return i=o[0]?o:i,n(e)?(this.angular("cleanup",function(){return{elements:i.children()}}),l.destroy(this.element.children()),i.empty().html(e),this.angular("compile",function(){var e,n=[];for(e=i.length;--e>=0;)n.push({dataItem:t});return{elements:i.children(),data:n}}),this):i.html()},open:function(){var t,n,i,o=this,r=o.wrapper,s=o.options,a=this._animationOptions("open"),c=r.children(S),d=e(document);return o.trigger(L)||(o._closing&&r.kendoStop(!0,!0),o._closing=!1,o.toFront(),s.autoFocus&&o.element.focus(),s.visible=!0,s.modal&&(n=!!o._modals().length,t=o._overlay(n),t.kendoStop(!0,!0),a.duration&&l.effects.Fade&&!n?(i=l.fx(t).fadeIn(),i.duration(a.duration||0),i.endValue(.5),i.play()):t.css("opacity",.5),t.show(),e(window).on("focus",function(){c.data("isFront")&&!e(document.activeElement).closest(c).length&&o.element.focus()})),r.is(z)||(c.css(Q,P),r.show().kendoStop().kendoAnimate({effects:a.effects,duration:a.duration,complete:g(this._activate,this)}))),s.isMaximized&&(o._documentScrollTop=d.scrollTop(),o._documentScrollLeft=d.scrollLeft(),o._stopDocumentScrolling()),s.pinned&&!o._isPinned&&o.pin(),o},_activate:function(){var e=this.options.scrollable!==!1;this.options.autoFocus&&this.element.focus(),this.element.css(Q,e?"":"hidden"),l.resize(this.element.children()),this.trigger(H)},_removeOverlay:function(n){var i,o=this._modals(),r=this.options,s=r.modal&&!o.length,a=r.modal?this._overlay(!0):e(t),c=this._animationOptions("close");s?!n&&c.duration&&l.effects.Fade?(i=l.fx(a).fadeOut(),i.duration(c.duration||0),i.startValue(.5),i.play()):this._overlay(!1).remove():o.length&&this._object(o.last())._overlay(!0)},_close:function(t){var n,i=this,o=i.wrapper,r=i.options,s=this._animationOptions("open"),a=this._animationOptions("close"),l=e(document);i._closing||(n=i.trigger(O,{userTriggered:!t}),i._closing=!n,o.is(z)&&!n&&(r.visible=!1,e(k).each(function(t,n){var i=e(n).children(S);n!=o&&i.find("> ."+E).length>0&&i.children(A).remove()}),this._removeOverlay(),o.kendoStop().kendoAnimate({effects:a.effects||s.effects,reverse:a.reverse===!0,duration:a.duration,complete:g(this._deactivate,this)})),i.options.isMaximized&&(i._enableDocumentScrolling(),i._documentScrollTop&&i._documentScrollTop>0&&l.scrollTop(i._documentScrollTop),i._documentScrollLeft&&i._documentScrollLeft>0&&l.scrollLeft(i._documentScrollLeft)))},_deactivate:function(){var e,t=this;t.wrapper.hide().css("opacity",""),t.trigger(N),t.options.modal&&(e=t._object(t._modals().last()),e&&e.toFront())},close:function(){return this._close(!0),this},_actionable:function(t){return e(t).is(ie+","+ie+" .k-icon,:input,a")},_shouldFocus:function(t){var n=f(),i=this.element;return this.options.autoFocus&&!e(n).is(i)&&!this._actionable(t)&&(!i.find(n).length||!i.find(t).length)},toFront:function(t){var n,i,o=this,r=o.wrapper,s=r[0],a=+r.css(Z),l=a,c=t&&t.target||null;return e(k).each(function(t,n){var i=e(n),o=i.css(Z),r=i.children(S);isNaN(o)||(a=Math.max(+o,a)),r.data("isFront",n==s),n!=s&&r.find("> ."+E).length>0&&r.append(ce.overlay)}),(!r[0].style.zIndex||l<a)&&r.css(Z,a+2),o.element.find("> .k-overlay").remove(),o._shouldFocus(c)&&(o.isMinimized()?o.wrapper.focus():e(c).is(A)?setTimeout(function(){o.element.focus()}):o.element.focus(),n=e(window).scrollTop(),i=parseInt(r.position().top,10),!o.options.pinned&&i>0&&i<n&&(n>0?e(window).scrollTop(i):r.css("top",n))),r=null,o},toggleMaximization:function(){return this._closing?this:this[this.options.isMaximized?"restore":"maximize"]()},restore:function(){var t=this,n=t.options,i=n.minHeight,o=t.restoreOptions,r=e(document);return n.isMaximized||n.isMinimized?(i&&i!=1/0&&t.wrapper.css("min-height",i),t.wrapper.css({position:n.pinned?"fixed":"absolute",left:o.left,top:o.top,width:o.width,height:o.height}).removeClass(F).find(".k-window-content,.k-resize-handle").show().end().find(".k-window-titlebar .k-i-window-restore").parent().remove().end().end().find(J).parent().show().end().end().find(ne).parent().show(),n.isMaximized?t.wrapper.find(".k-i-window-maximize").parent().focus():n.isMinimized&&t.wrapper.find(".k-i-window-minimize").parent().focus(),t.options.width=o.width,t.options.height=o.height,t._enableDocumentScrolling(),this._documentScrollTop&&this._documentScrollTop>0&&r.scrollTop(this._documentScrollTop),this._documentScrollLeft&&this._documentScrollLeft>0&&r.scrollLeft(this._documentScrollLeft),n.isMaximized=n.isMinimized=!1,this.wrapper.removeAttr("tabindex"),this.wrapper.removeAttr("aria-labelled-by"),t.resize(),t):t},_sizingAction:function(e,t){var n=this,i=n.wrapper,o=i[0].style,r=n.options;return r.isMaximized||r.isMinimized?n:(n.restoreOptions={width:o.width,height:o.height},i.children(D).hide().end().children(C).find(J).parent().hide().eq(0).before(ce.action({name:"window-restore"})),t.call(n),n.wrapper.children(C).find(ne).parent().toggle("maximize"!==e),n.trigger(e),i.find(".k-i-window-restore").parent().focus(),n)},maximize:function(){return this._sizingAction("maximize",function(){var t=this,n=t.wrapper,i=n.position(),o=e(document);v(t.restoreOptions,{left:i.left,top:i.top}),n.css({left:0,top:0,position:"fixed"}).addClass(F),this._documentScrollTop=o.scrollTop(),this._documentScrollLeft=o.scrollLeft(),t._stopDocumentScrolling(),t.options.isMaximized=!0,t._onDocumentResize()}),this},_stopDocumentScrolling:function(){var t,n=this,i=e("body");n._storeOverflowRule(i),i.css(Q,P),t=e("html"),n._storeOverflowRule(t),t.css(Q,P)},_enableDocumentScrolling:function(){var t=this;t._restoreOverflowRule(e(document.body)),t._restoreOverflowRule(e("html"))},_storeOverflowRule:function(e){if(!this._isOverflowStored(e)){var t=e.get(0).style.overflow;"string"==typeof t&&e.data(X,t)}},_isOverflowStored:function(e){return"string"==typeof e.data(X)},_restoreOverflowRule:function(e){var n=e.data(X);null!==n&&n!==t?(e.css(Q,n),e.removeData(X)):e.css(Q,"")},isMaximized:function(){return this.options.isMaximized},minimize:function(){return this._sizingAction("minimize",function(){var e=this;e.wrapper.css({height:"",minHeight:""}),e.element.hide(),e.options.isMinimized=!0}),this.wrapper.attr("tabindex",0),this.wrapper.attr("aria-labelled-by",this.element.attr("aria-labelled-by")),this},isMinimized:function(){return this.options.isMinimized},pin:function(){var t=this,n=e(window),i=t.wrapper,o=parseInt(i.css("top"),10),r=parseInt(i.css("left"),10);t.options.isMaximized||(i.css({position:"fixed",top:o-n.scrollTop(),left:r-n.scrollLeft()}),i.children(C).find(ee).addClass("k-i-unpin").removeClass("k-i-pin"),t._isPinned=!0,t.options.pinned=!0)},unpin:function(){var t=this,n=e(window),i=t.wrapper,o=parseInt(i.css("top"),10),r=parseInt(i.css("left"),10);t.options.isMaximized||(i.css({position:"",top:o+n.scrollTop(),left:r+n.scrollLeft()}),i.children(C).find(te).addClass("k-i-pin").removeClass("k-i-unpin"),t._isPinned=!1,t.options.pinned=!1)},_onDocumentResize:function(){var t,n,i,o,r=this,s=r.wrapper,a=e(window),c=l.support.zoomLevel();r.options.isMaximized&&(i=parseInt(s.css("border-left-width"),10)+parseInt(s.css("border-right-width"),10),o=parseInt(s.css("border-top-width"),10)+parseInt(s.css("border-bottom-width"),10),t=a.width()/c-i,n=a.height()/c-parseInt(s.css("padding-top"),10)-o,s.css({width:t,height:n}),r.options.width=t,r.options.height=n,r.resize())},refresh:function(t){var i,o,r,s=this,a=s.options,l=e(s.element);return h(t)||(t={url:t}),t=v({},a.content,t),o=n(a.iframe)?a.iframe:t.iframe,r=t.url,r?(n(o)||(o=!ae(r)),o?(i=l.find("."+E)[0],i?i.src=r||i.src:l.html(ce.contentFrame(v({},a,{content:t}))),l.find("."+E).unbind("load"+y).on("load"+y,g(this._triggerRefresh,this))):s._ajaxRequest(t)):(t.template&&s.content(b(t.template)({})),s.trigger(V)),l.toggleClass("k-window-iframecontent",!!o),s},_triggerRefresh:function(){this.trigger(V)},_ajaxComplete:function(){clearTimeout(this._loadingIconTimeout),this.wrapper.find(oe).removeClass(I)},_ajaxError:function(e,t){this.trigger(Y,{status:t,xhr:e})},_ajaxSuccess:function(e){return function(t){var n=t;e&&(n=b(e)(t||{})),this.content(n,t),this.element.prop("scrollTop",0),this.trigger(V)}},_showLoading:function(){this.wrapper.find(oe).addClass(I)},_ajaxRequest:function(t){this._loadingIconTimeout=setTimeout(g(this._showLoading,this),100),e.ajax(v({type:"GET",dataType:"html",cache:!1,error:g(this._ajaxError,this),complete:g(this._ajaxComplete,this),success:g(this._ajaxSuccess(t.template),this)},t))},_destroy:function(){this.resizing&&this.resizing.destroy(),this.dragging&&this.dragging.destroy(),this.wrapper.off(y).children(S).off(y).end().find(".k-resize-handle,.k-window-titlebar").off(y),e(window).off("resize"+y+this._marker),e(window).off(y),clearTimeout(this._loadingIconTimeout),c.fn.destroy.call(this),this.unbind(t),l.destroy(this.wrapper),this._removeOverlay(!0)},destroy:function(){this._destroy(),this.wrapper.empty().remove(),this.wrapper=this.appendTo=this.element=e()},_createWindow:function(){var t,n,i=this.element,o=this.options,r=l.support.isRtl(i);o.scrollable===!1&&i.css("overflow","hidden"),n=e(ce.wrapper(o)),t=i.find("iframe:not(.k-content)").map(function(){var e=this.getAttribute("src");return this.src="",e}),n.toggleClass("k-rtl",r).appendTo(this.appendTo).append(i).find("iframe:not(.k-content)").each(function(e){this.src=t[e]}),n.find(".k-window-title").css(r?"left":"right",p(n.find(".k-window-actions"))+10),i.css("visibility","").show(),i.find("[data-role=editor]").each(function(){var t=e(this).data("kendoEditor");t&&t.refresh()}),n=i=null}}),ce={wrapper:b("<div class='k-widget k-window' />"),action:b("<a role='button' href='\\#' class='k-button k-bare k-button-icon k-window-action' aria-label='#= name #'><span class='k-icon k-i-#= name.toLowerCase() #'></span></a>"),titlebar:b("<div class='k-window-titlebar k-header'>&nbsp;<span class='k-window-title'>#: title #</span><div class='k-window-actions' /></div>"),overlay:"<div class='k-overlay' />",contentFrame:b("<iframe frameborder='0' title='#= title #' class='"+E+"' src='#= content.url #'>This page requires frames in order to show content</iframe>"),resizeHandle:b("<div class='k-resize-handle k-resize-#= data #'></div>")};r.prototype={addOverlay:function(){this.owner.wrapper.append(ce.overlay)},removeOverlay:function(){this.owner.wrapper.find(A).remove()},dragstart:function(t){var n,i,o,r,a,c,d,u=this,h=u.owner,f=h.wrapper;u._preventDragging=h.trigger(j),u._preventDragging||(u.elementPadding=parseInt(f.css("padding-top"),10),u.initialPosition=l.getOffset(f,"position"),u.resizeDirection=t.currentTarget.prop("className").replace("k-resize-handle k-resize-",""),u.initialSize={width:f.width(),height:f.height()},u.containerOffset=l.getOffset(h.appendTo,"position"),n=f.offsetParent(),n.is("html")?u.containerOffset.top=u.containerOffset.left=0:(i=n.css("margin-top"),o=n.css("margin-left"),r=!se.test(i)||!se.test(o),r&&(a=s(f[0]),c=a.left-u.containerOffset.left-u.initialPosition.left,d=a.top-u.containerOffset.top-u.initialPosition.top,u._relativeElMarginLeft=c>1?c:0,u._relativeElMarginTop=d>1?d:0,u.initialPosition.left+=u._relativeElMarginLeft,u.initialPosition.top+=u._relativeElMarginTop)),f.children(D).not(t.currentTarget).hide(),e(w).css(B,t.currentTarget.css(B)))},drag:function(t){var n,o,r,s,a,l,c,d,u,h,f,p,m,g,v;this._preventDragging||(n=this,o=n.owner,r=o.wrapper,s=o.options,a=n.resizeDirection,l=n.containerOffset,c=n.initialPosition,d=n.initialSize,m=Math.max(t.x.location,0),g=Math.max(t.y.location,0),a.indexOf("e")>=0?(u=m-c.left-l.left,r.width(i(u,s.minWidth,s.maxWidth))):a.indexOf("w")>=0&&(p=c.left+d.width+l.left,u=i(p-m,s.minWidth,s.maxWidth),r.css({left:p-u-l.left-(n._relativeElMarginLeft||0),width:u})),v=g,o.options.pinned&&(v-=e(window).scrollTop()),a.indexOf("s")>=0?(h=v-c.top-n.elementPadding-l.top,r.height(i(h,s.minHeight,s.maxHeight))):a.indexOf("n")>=0&&(f=c.top+d.height+l.top,h=i(f-v,s.minHeight,s.maxHeight),r.css({top:f-h-l.top-(n._relativeElMarginTop||0),height:h})),u&&(o.options.width=u+"px"),h&&(o.options.height=h+"px"),o.resize())},dragend:function(t){if(!this._preventDragging){var n=this,i=n.owner,o=i.wrapper;return o.children(D).not(t.currentTarget).show(),e(w).css(B,""),i.touchScroller&&i.touchScroller.reset(),27==t.keyCode&&o.css(n.initialPosition).css(n.initialSize),i.trigger(G),!1}},destroy:function(){this._draggable&&this._draggable.destroy(),this._draggable=this.owner=null}},a.prototype={dragstart:function(t){var n=this.owner,i=n.element,o=i.find(".k-window-actions"),r=l.getOffset(n.appendTo);this._preventDragging=n.trigger($)||!n.options.draggable,this._preventDragging||(n.initialWindowPosition=l.getOffset(n.wrapper,"position"),n.initialPointerPosition={left:t.x.client,top:t.y.client},n.startPosition={left:t.x.client-n.initialWindowPosition.left,top:t.y.client-n.initialWindowPosition.top},n.minLeftPosition=o.length>0?p(o)+parseInt(o.css("right"),10)-p(i):20-p(i),n.minLeftPosition-=r.left,n.minTopPosition=-r.top,n.wrapper.append(ce.overlay).children(D).hide(),e(w).css(B,t.currentTarget.css(B)))},drag:function(t){var n,i;this._preventDragging||(n=this.owner,i=n.options.position,i.top=Math.max(t.y.client-n.startPosition.top,n.minTopPosition),i.left=Math.max(t.x.client-n.startPosition.left,n.minLeftPosition),l.support.transforms?e(n.wrapper).css("transform","translate("+(t.x.client-n.initialPointerPosition.left)+"px, "+(t.y.client-n.initialPointerPosition.top)+"px)"):e(n.wrapper).css(i))},_finishDrag:function(){var t=this.owner;t.wrapper.children(D).toggle(!t.options.isMinimized).end().find(A).remove(),e(w).css(B,"")},dragcancel:function(e){this._preventDragging||(this._finishDrag(),e.currentTarget.closest(k).css(this.owner.initialWindowPosition))},dragend:function(){if(!this._preventDragging)return e(this.owner.wrapper).css(this.owner.options.position).css("transform",""),this._finishDrag(),this.owner.trigger(K),!1},destroy:function(){this._draggable&&this._draggable.destroy(),this._draggable=this.owner=null}},l.ui.plugin(le)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.view.min",["kendo.core.min","kendo.fx.min","kendo.mobile.scroller.min","kendo.view.min"],e)}(function(){return function(e,t){function n(e){var t,n,i=e.find(k("popover")),o=a.roles;for(t=0,n=i.length;t<n;t++)r.initWidget(i[t],{},o)}function i(e){r.triggeredByInput(e)||e.preventDefault()}function o(t){t.each(function(){r.initWidget(e(this),{},a.roles)})}var r=window.kendo,s=r.mobile,a=s.ui,l=r.attr,c=a.Widget,d=r.ViewClone,u="init",h='<div style="height: 100%; width: 100%; position: absolute; top: 0; left: 0; z-index: 20000; display: none" />',f="beforeShow",p="show",m="afterShow",g="beforeHide",v="transitionEnd",_="transitionStart",b="hide",w="destroy",y=r.attrValue,k=r.roleSelector,x=r.directiveSelector,C=r.compileMobileDirective,S=c.extend({init:function(t,n){c.fn.init.call(this,t,n),this.params={},e.extend(this,n),this.transition=this.transition||this.defaultTransition,this._id(),this.options.$angular?this._overlay():(this._layout(),this._overlay(),this._scroller(),this._model())},events:[u,f,p,m,g,b,w,_,v],options:{name:"View",title:"",layout:null,getLayout:e.noop,reload:!1,transition:"",defaultTransition:"",useNativeScrolling:!1,stretch:!1,zoom:!1,model:null,modelScope:window,scroller:{},initWidgets:!0},enable:function(e){t===e&&(e=!0),e?this.overlay.hide():this.overlay.show()},destroy:function(){this.layout&&this.layout.detach(this),this.trigger(w),c.fn.destroy.call(this),this.scroller&&this.scroller.destroy(),this.options.$angular&&this.element.scope().$destroy(),r.destroy(this.element)},purge:function(){this.destroy(),this.element.remove()},triggerBeforeShow:function(){return!this.trigger(f,{view:this})},triggerBeforeHide:function(){return!this.trigger(g,{view:this})},showStart:function(){var e=this.element;e.css("display",""),this.inited?this._invokeNgController():(this.inited=!0,this.trigger(u,{view:this})),this.layout&&this.layout.attach(this),this._padIfNativeScrolling(),this.trigger(p,{view:this}),r.resize(e)},showEnd:function(){this.trigger(m,{view:this}),this._padIfNativeScrolling()},hideEnd:function(){var e=this;e.element.hide(),e.trigger(b,{view:e}),e.layout&&e.layout.trigger(b,{view:e,layout:e.layout})},beforeTransition:function(e){this.trigger(_,{type:e})},afterTransition:function(e){this.trigger(v,{type:e})},_padIfNativeScrolling:function(){if(s.appLevelNativeScrolling()){var e=r.support.mobileOS&&r.support.mobileOS.android,t=s.application.skin()||"",n=s.application.os.android||t.indexOf("android")>-1,i="flat"===t||t.indexOf("material")>-1,o=!e&&!n||i?"header":"footer",a=!e&&!n||i?"footer":"header";this.content.css({paddingTop:this[o].height(),paddingBottom:this[a].height()})}},contentElement:function(){var e=this;return e.options.stretch?e.content:e.scrollerContent},clone:function(){return new d(this)},_scroller:function(){var t=this;s.appLevelNativeScrolling()||(t.options.stretch?t.content.addClass("km-stretched-view"):(t.content.kendoMobileScroller(e.extend(t.options.scroller,{zoom:t.options.zoom,useNative:t.options.useNativeScrolling})),t.scroller=t.content.data("kendoMobileScroller"),t.scrollerContent=t.scroller.scrollElement),r.support.kineticScrollNeeded&&(e(t.element).on("touchmove",".km-header",i),t.options.useNativeScrolling||t.options.stretch||e(t.element).on("touchmove",".km-content",i)))},_model:function(){var e=this,t=e.element,i=e.options.model;"string"==typeof i&&(i=r.getter(i)(e.options.modelScope)),e.model=i,n(t),e.element.css("display",""),e.options.initWidgets&&(i?r.bind(t,i,a,r.ui,r.dataviz.ui):s.init(t.children())),e.element.css("display","none")},_id:function(){var e=this.element,t=e.attr("id")||"";this.id=y(e,"url")||"#"+t,"#"==this.id&&(this.id=r.guid(),e.attr("id",this.id))},_layout:function(){var e=k("content"),t=this.element;t.addClass("km-view"),this.header=t.children(k("header")).addClass("km-header"),this.footer=t.children(k("footer")).addClass("km-footer"),t.children(e)[0]||t.wrapInner("<div "+l("role")+'="content"></div>'),this.content=t.children(k("content")).addClass("km-content"),this.element.prepend(this.header).append(this.footer),this.layout=this.options.getLayout(this.layout),this.layout&&this.layout.setup(this)},_overlay:function(){this.overlay=e(h).appendTo(this.element)},_invokeNgController:function(){var t,n,i;this.options.$angular&&(t=this.element.controller(),n=this.options.$angular[0],t&&(i=e.proxy(this,"_callController",t,n),/^\$(digest|apply)$/.test(n.$$phase)?i():n.$apply(i)))},_callController:function(e,t){this.element.injector().invoke(e.constructor,e,{$scope:t})}}),T=c.extend({init:function(e,t){c.fn.init.call(this,e,t),e=this.element,this.header=e.children(this._locate("header")).addClass("km-header"),this.footer=e.children(this._locate("footer")).addClass("km-footer"),this.elements=this.header.add(this.footer),n(e),this.options.$angular||r.mobile.init(this.element.children()),this.element.detach(),this.trigger(u,{layout:this})},_locate:function(e){return this.options.$angular?x(e):k(e)},options:{name:"Layout",id:null,platform:null},events:[u,p,b],setup:function(e){e.header[0]||(e.header=this.header),e.footer[0]||(e.footer=this.footer)},detach:function(e){var t=this;e.header===t.header&&t.header[0]&&e.element.prepend(t.header.detach()[0].cloneNode(!0)),e.footer===t.footer&&t.footer.length&&e.element.append(t.footer.detach()[0].cloneNode(!0))},attach:function(e){var t=this,n=t.currentView;n&&t.detach(n),e.header===t.header&&(t.header.detach(),e.element.children(k("header")).remove(),e.element.prepend(t.header)),e.footer===t.footer&&(t.footer.detach(),e.element.children(k("footer")).remove(),e.element.append(t.footer)),t.trigger(p,{layout:t,view:e}),t.currentView=e}}),D=r.Observable,A=/<body[^>]*>(([\u000a\u000d\u2028\u2029]|.)*)<\/body>/i,E="loadStart",I="loadComplete",M="showStart",R="sameViewRequested",F="viewShow",z="viewTypeDetermined",P="after",B=D.extend({init:function(t){var n,i,s,a,l=this;if(D.fn.init.call(l),e.extend(l,t),l.sandbox=e("<div />"),s=l.container,n=l._hideViews(s),l.rootView=n.first(),!l.rootView[0]&&t.rootNeeded)throw i=s[0]==r.mobile.application.element[0]?'Your kendo mobile application element does not contain any direct child elements with data-role="view" attribute set. Make sure that you instantiate the mobile application using the correct container.':'Your pane element does not contain any direct child elements with data-role="view" attribute set.',Error(i);l.layouts={},l.viewContainer=new r.ViewContainer(l.container),l.viewContainer.bind("accepted",function(e){e.view.params=l.params}),l.viewContainer.bind("complete",function(e){l.trigger(F,{view:e.view})}),l.viewContainer.bind(P,function(){l.trigger(P)}),this.getLayoutProxy=e.proxy(this,"_getLayout"),l._setupLayouts(s),a=s.children(l._locate("modalview drawer")),l.$angular?(l.$angular[0].viewOptions={defaultTransition:l.transition,loader:l.loader,container:l.container,getLayout:l.getLayoutProxy},a.each(function(n,i){C(e(i),t.$angular[0])})):o(a),this.bind(this.events,t)},events:[M,P,F,E,I,R,z],destroy:function(){r.destroy(this.container);for(var e in this.layouts)this.layouts[e].destroy()},view:function(){return this.viewContainer.view},showView:function(e,t,n){if(e=e.replace(RegExp("^"+this.remoteViewURLPrefix),""),""===e&&this.remoteViewURLPrefix&&(e="/"),e.replace(/^#/,"")===this.url)return this.trigger(R),!1;this.trigger(M);var i=this,o=function(n){return i.viewContainer.show(n,t,e)},s=i._findViewElement(e),a=r.widgetInstance(s);return i.url=e.replace(/^#/,""),i.params=n,a&&a.reload&&(a.purge(),s=[]),this.trigger(z,{remote:0===s.length,url:e}),s[0]?(a||(a=i._createView(s)),o(a)):(this.serverNavigation?location.href=e:i._loadView(e,o),!0)},append:function(e,t){var n,i,r,s=this.sandbox,a=(t||"").split("?")[0],c=this.container;return A.test(e)&&(e=RegExp.$1),s[0].innerHTML=e,c.append(s.children("script, style")),n=this._hideViews(s),r=n.first(),r.length||(n=r=s.wrapInner("<div data-role=view />").children()),a&&r.hide().attr(l("url"),a),this._setupLayouts(s),i=s.children(this._locate("modalview drawer")),c.append(s.children(this._locate("layout modalview drawer")).add(n)),o(i),this._createView(r)},_locate:function(e){return this.$angular?x(e):k(e)},_findViewElement:function(e){var t,n=e.split("?")[0];return n?(t=this.container.children("["+l("url")+"='"+n+"']"),t[0]||n.indexOf("/")!==-1||(t=this.container.children("#"===n.charAt(0)?n:"#"+n)),t):this.rootView},_createView:function(e){return this.$angular?C(e,this.$angular[0]):r.initWidget(e,{defaultTransition:this.transition,loader:this.loader,container:this.container,getLayout:this.getLayoutProxy,modelScope:this.modelScope,reload:y(e,"reload")},a.roles)},_getLayout:function(e){return""===e?null:e?this.layouts[e]:this.layouts[this.layout]},_loadView:function(t,n){this._xhr&&this._xhr.abort(),this.trigger(E),this._xhr=e.get(r.absoluteURL(t,this.remoteViewURLPrefix),"html").always(e.proxy(this,"_xhrComplete",n,t))},_xhrComplete:function(e,t,n){var i=!0;if("object"==typeof n&&0===n.status){if(!(n.responseText&&n.responseText.length>0))return;i=!0,n=n.responseText}this.trigger(I),i&&e(this.append(n,t))},_hideViews:function(e){return e.children(this._locate("view splitview")).hide()},_setupLayouts:function(t){var n,i=this;t.children(i._locate("layout")).each(function(){n=i.$angular?C(e(this),i.$angular[0]):r.initWidget(e(this),{},a.roles);var t=n.options.platform;t&&t!==s.application.os.name?n.destroy():i.layouts[n.options.id]=n})}});r.mobile.ViewEngine=B,a.plugin(S),a.plugin(T)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.loader.min",["kendo.core.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile.ui,o=i.Widget,r=e.map(n.eventMap,function(e){return e}).join(" ").split(" "),s=o.extend({init:function(t,n){var i=this,r=e('<div class="km-loader"><span class="km-loading km-spin"></span><span class="km-loading-left"></span><span class="km-loading-right"></span></div>');o.fn.init.call(i,r,n),i.container=t,i.captureEvents=!1,i._attachCapture(),r.append(i.options.loading).hide().appendTo(t)},options:{name:"Loader",loading:"<h1>Loading...</h1>",timeout:100},show:function(){var e=this;clearTimeout(e._loading),e.options.loading!==!1&&(e.captureEvents=!0,e._loading=setTimeout(function(){e.element.show()},e.options.timeout))},hide:function(){this.captureEvents=!1,clearTimeout(this._loading),this.element.hide()},changeMessage:function(e){this.options.loading=e,this.element.find(">h1").html(e)},transition:function(){this.captureEvents=!0,this.container.css("pointer-events","none")},transitionDone:function(){this.captureEvents=!1,this.container.css("pointer-events","")},_attachCapture:function(){function e(e){n.captureEvents&&e.preventDefault()}var t,n=this;for(n.captureEvents=!1,t=0;t<r.length;t++)n.container[0].addEventListener(r[t],e,!0)}});i.plugin(s)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.pane.min",["kendo.mobile.view.min","kendo.mobile.loader.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile,o=n.roleSelector,r=i.ui,s=r.Widget,a=i.ViewEngine,l=r.View,c=i.ui.Loader,d="external",u="href",h="#!",f="navigate",p="viewShow",m="sameViewRequested",g=n.support.mobileOS,v=g.ios&&!g.appMode&&g.flatVersion>=700,_=/popover|actionsheet|modalview|drawer/,b="#:back",w=n.attrValue,y=s.extend({init:function(e,t){var i=this;s.fn.init.call(i,e,t),t=i.options,e=i.element,e.addClass("km-pane"),i.options.collapsible&&e.addClass("km-collapsible-pane"),this.history=[],this.historyCallback=function(e,t,n){var o=i.transition;return i.transition=null,v&&n&&(o="none"),i.viewEngine.showView(e,o,t)},this._historyNavigate=function(e){if(e===b){if(1===i.history.length)return;i.history.pop(),e=i.history[i.history.length-1]}else i.history.push(e);i.historyCallback(e,n.parseQueryStringParams(e))},this._historyReplace=function(e){var t=n.parseQueryStringParams(e);i.history[i.history.length-1]=e,i.historyCallback(e,t)},i.loader=new c(e,{loading:i.options.loading}),i.viewEngine=new a({container:e,transition:t.transition,modelScope:t.modelScope,rootNeeded:!t.initial,serverNavigation:t.serverNavigation,remoteViewURLPrefix:t.root||"",layout:t.layout,$angular:t.$angular,loader:i.loader,showStart:function(){i.loader.transition(),i.closeActiveDialogs()},after:function(){i.loader.transitionDone()},viewShow:function(e){i.trigger(p,e)},loadStart:function(){i.loader.show()},loadComplete:function(){i.loader.hide()},sameViewRequested:function(){i.trigger(m)},viewTypeDetermined:function(e){e.remote&&i.options.serverNavigation||i.trigger(f,{url:e.url})}}),this._setPortraitWidth(),n.onResize(function(){i._setPortraitWidth()}),i._setupAppLinks()},closeActiveDialogs:function(){var t=this.element.find(o("actionsheet popover modalview")).filter(":visible");t.each(function(){n.widgetInstance(e(this),r).close()})},navigateToInitial:function(){var e=this.options.initial;return e&&this.navigate(e),e},options:{name:"Pane",portraitWidth:"",transition:"",layout:"",collapsible:!1,initial:null,modelScope:window,loading:"<h1>Loading...</h1>"},events:[f,p,m],append:function(e){return this.viewEngine.append(e)},destroy:function(){s.fn.destroy.call(this),this.viewEngine.destroy(),this.userEvents.destroy()},navigate:function(e,t){e instanceof l&&(e=e.id),this.transition=t,this._historyNavigate(e)},replace:function(e,t){e instanceof l&&(e=e.id),this.transition=t,this._historyReplace(e)},bindToRouter:function(e){var t=this,i=this.history,o=this.viewEngine;e.bind("init",function(t){var r,s=t.url,a=e.pushState?s:"/";o.rootView.attr(n.attr("url"),a),r=i.length,"/"===s&&r&&(e.navigate(i[r-1],!0),t.preventDefault())}),e.bind("routeMissing",function(e){t.historyCallback(e.url,e.params,e.backButtonPressed)||e.preventDefault()}),e.bind("same",function(){t.trigger(m)}),t._historyNavigate=function(t){e.navigate(t)},t._historyReplace=function(t){e.replace(t)}},hideLoading:function(){this.loader.hide()},showLoading:function(){this.loader.show()},changeLoadingMessage:function(e){this.loader.changeMessage(e)},view:function(){return this.viewEngine.view()},_setPortraitWidth:function(){var e,t=this.options.portraitWidth;t&&(e=n.mobile.application.element.is(".km-vertical")?t:"auto",this.element.css("width",e))},_setupAppLinks:function(){var t=this,i="tab",r="[data-"+n.ns+"navigate-on-press]",s=e.map(["button","backbutton","detailbutton","listview-link"],function(e){return o(e)+":not("+r+")"}).join(",");this.element.handler(this).on("down",o(i)+","+r,"_mouseup").on("click",o(i)+","+s+","+r,"_appLinkClick"),this.userEvents=new n.UserEvents(this.element,{fastTap:!0,filter:s,tap:function(e){e.event.currentTarget=e.touch.currentTarget,t._mouseup(e.event)}}),this.element.css("-ms-touch-action","")},_appLinkClick:function(t){var n=e(t.currentTarget).attr("href"),i=n&&"#"!==n[0]&&this.options.serverNavigation;i||w(e(t.currentTarget),"rel")==d||t.preventDefault()},_mouseup:function(o){
if(!(o.which>1||o.isDefaultPrevented())){var s=this,a=e(o.currentTarget),l=w(a,"transition"),c=w(a,"rel")||"",f=w(a,"target"),p=a.attr(u),m=v&&0===a[0].offsetHeight,g=p&&"#"!==p[0]&&this.options.serverNavigation;m||g||c===d||t===p||p===h||(a.attr(u,h),setTimeout(function(){a.attr(u,p)}),c.match(_)?(n.widgetInstance(e(p),r).openFor(a),"actionsheet"!==c&&"drawer"!==c||o.stopPropagation()):("_top"===f?s=i.application.pane:f&&(s=e("#"+f).data("kendoMobilePane")),s.navigate(p,l)),o.preventDefault())}}});y.wrap=function(e){e.is(o("view"))||(e=e.wrap("<div data-"+n.ns+'role="view" data-stretch="true"></div>').parent());var t=e.wrap('<div class="km-pane-wrapper"><div></div></div>').parent(),i=new y(t);return i.navigate(""),i},r.plugin(y)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.popover.min",["kendo.popup.min","kendo.mobile.pane.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile,o=i.ui,r="hide",s="open",a="close",l='<div class="km-popup-wrapper" />',c='<div class="km-popup-arrow" />',d='<div class="km-popup-overlay" />',u="km-up km-down km-left km-right",h=o.Widget,f={down:{origin:"bottom center",position:"top center"},up:{origin:"top center",position:"bottom center"},left:{origin:"center left",position:"center right",collision:"fit flip"},right:{origin:"center right",position:"center left",collision:"fit flip"}},p={animation:{open:{effects:"fade:in",duration:0},close:{effects:"fade:out",duration:400}}},m={horizontal:{offset:"top",size:"height"},vertical:{offset:"left",size:"width"}},g={up:"down",down:"up",left:"right",right:"left"},v=h.extend({init:function(t,i){var o,s,a=this,u=t.closest(".km-modalview-wrapper"),g=t.closest(".km-root").children(".km-pane").first(),v=u[0]?u:g;i.viewport?g=i.viewport:g[0]||(g=window),i.container?v=i.container:v[0]||(v=document.body),o={viewport:g,copyAnchorStyles:!1,autosize:!0,open:function(){a.overlay.show()},activate:e.proxy(a._activate,a),deactivate:function(){a.overlay.hide(),a._apiCall||a.trigger(r),a._apiCall=!1}},h.fn.init.call(a,t,i),t=a.element,i=a.options,t.wrap(l).addClass("km-popup").show(),s=a.options.direction.match(/left|right/)?"horizontal":"vertical",a.dimensions=m[s],a.wrapper=t.parent().css({width:i.width,height:i.height}).addClass("km-popup-wrapper km-"+i.direction).hide(),a.arrow=e(c).prependTo(a.wrapper).hide(),a.overlay=e(d).appendTo(v).hide(),o.appendTo=a.overlay,i.className&&a.overlay.addClass(i.className),a.popup=new n.ui.Popup(a.wrapper,e.extend(!0,o,p,f[i.direction]))},options:{name:"Popup",width:240,height:"",direction:"down",container:null,viewport:null},events:[r],show:function(t){this.popup.options.anchor=e(t),this.popup.open()},hide:function(){this._apiCall=!0,this.popup.close()},destroy:function(){h.fn.destroy.call(this),this.popup.destroy(),this.overlay.remove()},target:function(){return this.popup.options.anchor},_activate:function(){var t=this,n=t.options.direction,i=t.dimensions,o=i.offset,r=t.popup,s=r.options.anchor,a=e(s).offset(),l=e(r.element).offset(),c=r.flipped?g[n]:n,d=2*t.arrow[i.size](),h=t.element[i.size]()-t.arrow[i.size](),f=e(s)[i.size](),p=a[o]-l[o]+f/2;p<d&&(p=d),p>h&&(p=h),t.wrapper.removeClass(u).addClass("km-"+c),t.arrow.css(o,p).show()}}),_=h.extend({init:function(t,i){var r,s=this;s.initialOpen=!1,h.fn.init.call(s,t,i),r=e.extend({className:"km-popover-root",hide:function(){s.trigger(a)}},this.options.popup),s.popup=new v(s.element,r),s.popup.overlay.on("move",function(e){e.target==s.popup.overlay[0]&&e.preventDefault()}),s.pane=new o.Pane(s.element,e.extend(this.options.pane,{$angular:this.options.$angular})),n.notify(s,o)},options:{name:"PopOver",popup:{},pane:{}},events:[s,a],open:function(e){this.popup.show(e),this.initialOpen?this.pane.view()._invokeNgController():(this.pane.navigateToInitial()||this.pane.navigate(""),this.popup.popup._position(),this.initialOpen=!0)},openFor:function(e){this.open(e),this.trigger(s,{target:this.popup.target()})},close:function(){this.popup.hide()},destroy:function(){h.fn.destroy.call(this),this.pane.destroy(),this.popup.destroy(),n.destroy(this.element)}});o.plugin(v),o.plugin(_)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.shim.min",["kendo.popup.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile.ui,o=n.ui.Popup,r='<div class="km-shim"/>',s="hide",a=i.Widget,l=a.extend({init:function(t,i){var l=this,c=n.mobile.application,d=n.support.mobileOS,u=c?c.os.name:d?d.name:"ios",h="ios"===u||"wp"===u||!!c&&c.os.skin,f="blackberry"===u,p=i.align||(h?"bottom center":f?"center right":"center center"),m=i.position||(h?"bottom center":f?"center right":"center center"),g=i.effect||(h?"slideIn:up":f?"slideIn:left":"fade:in"),v=e(r).handler(l).hide();a.fn.init.call(l,t,i),l.shim=v,t=l.element,i=l.options,i.className&&l.shim.addClass(i.className),i.modal||l.shim.on("down","_hide"),(c?c.element:e(document.body)).append(v),l.popup=new o(l.element,{anchor:v,modal:!0,appendTo:v,origin:p,position:m,animation:{open:{effects:g,duration:i.duration},close:{duration:i.duration}},close:function(e){var t=!1;l._apiCall||(t=l.trigger(s)),t&&e.preventDefault(),l._apiCall=!1},deactivate:function(){v.hide()},open:function(){v.show()}}),n.notify(l)},events:[s],options:{name:"Shim",modal:!1,align:t,position:t,effect:t,duration:200},show:function(){this.popup.open()},hide:function(){this._apiCall=!0,this.popup.close()},destroy:function(){a.fn.destroy.call(this),this.shim.kendoDestroy(),this.popup.destroy(),this.shim.remove()},_hide:function(t){t&&e.contains(this.shim.children().children(".k-popup")[0],t.target)||this.popup.close()}});i.plugin(l)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.actionsheet.min",["kendo.mobile.popover.min","kendo.mobile.shim.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.support,o=n.mobile.ui,r=o.Shim,s=o.Popup,a=o.Widget,l="open",c="close",d="command",u="li>a",h="actionsheetContext",f='<div class="km-actionsheet-wrapper" />',p=n.template('<li class="km-actionsheet-cancel"><a href="\\#">#:cancel#</a></li>'),m=a.extend({init:function(t,l){var c,d,h,m=this,g=i.mobileOS;a.fn.init.call(m,t,l),l=m.options,h=l.type,t=m.element,d="auto"===h?g&&g.tablet:"tablet"===h,c=d?s:r,l.cancelTemplate&&(p=n.template(l.cancelTemplate)),t.addClass("km-actionsheet").append(p({cancel:m.options.cancel})).wrap(f).on("up",u,"_click").on("click",u,n.preventDefault),m.view().bind("destroy",function(){m.destroy()}),m.wrapper=t.parent().addClass(h?" km-actionsheet-"+h:""),m.shim=new c(m.wrapper,e.extend({modal:g.ios&&g.majorVersion<7,className:"km-actionsheet-root"},m.options.popup)),m._closeProxy=e.proxy(m,"_close"),m._shimHideProxy=e.proxy(m,"_shimHide"),m.shim.bind("hide",m._shimHideProxy),d&&n.onResize(m._closeProxy),n.notify(m,o)},events:[l,c,d],options:{name:"ActionSheet",cancel:"Cancel",type:"auto",popup:{height:"auto"}},open:function(t,n){var i=this;i.target=e(t),i.context=n,i.shim.show(t)},close:function(){this.context=this.target=null,this.shim.hide()},openFor:function(e){var t=this,n=e.data(h);t.open(e,n),t.trigger(l,{target:e,context:n})},destroy:function(){a.fn.destroy.call(this),n.unbindResize(this._closeProxy),this.shim.destroy()},_click:function(t){var i,o,r,s;t.isDefaultPrevented()||(i=e(t.currentTarget),o=i.data("action"),o&&(r={target:this.target,context:this.context},s=this.options.$angular,s?this.element.injector().get("$parse")(o)(s[0])(r):n.getter(o)(window)(r)),this.trigger(d,{target:this.target,context:this.context,currentTarget:i}),t.preventDefault(),this._close())},_shimHide:function(e){this.trigger(c)?e.preventDefault():this.context=this.target=null},_close:function(e){this.trigger(c)?e.preventDefault():this.close()}});o.plugin(m)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.progressbar.min",["kendo.core.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.ui,o=i.Widget,r="horizontal",s="vertical",a=0,l=100,c=0,d=5,u="k-progressbar",h="k-progressbar-reverse",f="k-progressbar-indeterminate",p="k-complete",m="k-state-selected",g="k-progress-status",v="k-state-selected",_="k-state-default",b="k-state-disabled",w={VALUE:"value",PERCENT:"percent",CHUNK:"chunk"},y="change",k="complete",x="boolean",C=Math,S=e.extend,T=e.proxy,D=100,A=400,E=3,I={progressStatus:"<span class='k-progress-status-wrap'><span class='k-progress-status'></span></span>"},M=o.extend({init:function(e,t){var n=this;o.fn.init.call(this,e,t),t=n.options,n._progressProperty=t.orientation===r?"width":"height",n._fields(),t.value=n._validateValue(t.value),n._validateType(t.type),n._wrapper(),n._progressAnimation(),t.value!==t.min&&t.value!==!1&&n._updateProgress()},setOptions:function(e){var t=this;o.fn.setOptions.call(t,e),e.hasOwnProperty("reverse")&&t.wrapper.toggleClass("k-progressbar-reverse",e.reverse),e.hasOwnProperty("enable")&&t.enable(e.enable),t._progressAnimation(),t._validateValue(),t._updateProgress()},events:[y,k],options:{name:"ProgressBar",orientation:r,reverse:!1,min:a,max:l,value:c,enable:!0,type:w.VALUE,chunkCount:d,showStatus:!0,animation:{}},_fields:function(){var t=this;t._isStarted=!1,t.progressWrapper=t.progressStatus=e()},_validateType:function(t){var i=!1;if(e.each(w,function(e,n){if(n===t)return i=!0,!1}),!i)throw Error(n.format("Invalid ProgressBar type '{0}'",t))},_wrapper:function(){var e,t=this,n=t.wrapper=t.element,i=t.options,o=i.orientation;n.addClass("k-widget "+u),n.addClass(u+"-"+(o===r?r:s)),i.enable===!1&&n.addClass(b),i.reverse&&n.addClass(h),i.value===!1&&n.addClass(f),i.type===w.CHUNK?t._addChunkProgressWrapper():i.showStatus&&(t.progressStatus=t.wrapper.prepend(I.progressStatus).find("."+g),e=i.value!==!1?i.value:i.min,t.progressStatus.text(i.type===w.VALUE?e:t._calculatePercentage(e).toFixed()+"%"))},value:function(e){return this._value(e)},_value:function(e){var n,i=this,o=i.options;return e===t?o.value:(typeof e!==x?(e=i._roundValue(e),isNaN(e)||(n=i._validateValue(e),n!==o.value&&(i.wrapper.removeClass(f),o.value=n,i._isStarted=!0,i._updateProgress()))):e||(i.wrapper.addClass(f),o.value=!1),t)},_roundValue:function(e){e=parseFloat(e);var t=C.pow(10,E);return C.floor(e*t)/t},_validateValue:function(e){var t=this,n=t.options;if(e!==!1){if(e<=n.min||e===!0)return n.min;if(e>=n.max)return n.max}else if(e===!1)return!1;return isNaN(t._roundValue(e))?n.min:e},_updateProgress:function(){var e=this,t=e.options,n=e._calculatePercentage();t.type===w.CHUNK?(e._updateChunks(n),e._onProgressUpdateAlways(t.value)):e._updateProgressWrapper(n)},_updateChunks:function(e){var t,n=this,i=n.options,o=i.chunkCount,a=parseInt(D/o*100,10)/100,l=parseInt(100*e,10)/100,c=C.floor(l/a);t=n.wrapper.find(i.orientation===r&&!i.reverse||i.orientation===s&&i.reverse?"li.k-item:lt("+c+")":"li.k-item:gt(-"+(c+1)+")"),n.wrapper.find("."+v).removeClass(v).addClass(_),t.removeClass(_).addClass(v)},_updateProgressWrapper:function(e){var t=this,n=t.options,i=t.wrapper.find("."+m),o=t._isStarted?t._animation.duration:0,r={};0===i.length&&t._addRegularProgressWrapper(),r[t._progressProperty]=e+"%",t.progressWrapper.animate(r,{duration:o,start:T(t._onProgressAnimateStart,t),progress:T(t._onProgressAnimate,t),complete:T(t._onProgressAnimateComplete,t,n.value),always:T(t._onProgressUpdateAlways,t,n.value)})},_onProgressAnimateStart:function(){this.progressWrapper.show()},_onProgressAnimate:function(e){var t,n=this,i=n.options,o=parseFloat(e.elem.style[n._progressProperty],10);i.showStatus&&(t=1e4/parseFloat(n.progressWrapper[0].style[n._progressProperty]),n.progressWrapper.find(".k-progress-status-wrap").css(n._progressProperty,t+"%")),i.type!==w.CHUNK&&o<=98&&n.progressWrapper.removeClass(p)},_onProgressAnimateComplete:function(e){var t,n=this,i=n.options,o=parseFloat(n.progressWrapper[0].style[n._progressProperty]);i.type!==w.CHUNK&&o>98&&n.progressWrapper.addClass(p),i.showStatus&&(t=i.type===w.VALUE?e:i.type==w.PERCENT?n._calculatePercentage(e).toFixed()+"%":C.floor(n._calculatePercentage(e))+"%",n.progressStatus.text(t)),e===i.min&&n.progressWrapper.hide()},_onProgressUpdateAlways:function(e){var t=this,n=t.options;t._isStarted&&t.trigger(y,{value:e}),e===n.max&&t._isStarted&&t.trigger(k,{value:n.max})},enable:function(e){var n=this,i=n.options;i.enable=t===e||e,n.wrapper.toggleClass(b,!i.enable)},destroy:function(){var e=this;o.fn.destroy.call(e)},_addChunkProgressWrapper:function(){var e,t=this,n=t.options,i=t.wrapper,o=D/n.chunkCount,r="";for(n.chunkCount<=1&&(n.chunkCount=1),r+="<ul class='k-reset'>",e=n.chunkCount-1;e>=0;e--)r+="<li class='k-item k-state-default'></li>";r+="</ul>",i.append(r).find(".k-item").css(t._progressProperty,o+"%").first().addClass("k-first").end().last().addClass("k-last"),t._normalizeChunkSize()},_normalizeChunkSize:function(){var e=this,t=e.options,n=e.wrapper.find(".k-item:last"),i=parseFloat(n[0].style[e._progressProperty]),o=D-t.chunkCount*i;o>0&&n.css(e._progressProperty,i+o+"%")},_addRegularProgressWrapper:function(){var t=this;t.progressWrapper=e("<div class='"+m+"'></div>").appendTo(t.wrapper),t.options.showStatus&&(t.progressWrapper.append(I.progressStatus),t.progressStatus=t.wrapper.find("."+g))},_calculateChunkSize:function(){var e=this,t=e.options.chunkCount,n=e.wrapper.find("ul.k-reset");return(parseInt(n.css(e._progressProperty),10)-(t-1))/t},_calculatePercentage:function(e){var n=this,i=n.options,o=e!==t?e:i.value,r=i.min,s=i.max;return n._onePercent=C.abs((s-r)/100),C.abs((o-r)/n._onePercent)},_progressAnimation:function(){var e=this,t=e.options,n=t.animation;e._animation=n===!1?{duration:0}:S({duration:A},t.animation)}});n.ui.plugin(M)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("pdf/pako.min",["kendo.core.min"],e)}(function(){return function(){kendo.pdf=kendo.pdf||{},kendo.pdf.supportsDeflate=function(){return window.pako&&"function"==typeof window.pako.deflate},kendo.pdf.deflate=function(e){return window.pako.deflate(e)}}(),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("pdf/core.min",["pdf/pako.min","kendo.core.min","kendo.color.min","kendo.drawing.min"],e)}(function(){return function(e){function t(e){function t(){return S>=T}function n(){return S<T?e[S++]:0}function i(t){w(S),e[S++]=255&t,S>T&&(T=S)}function o(){return n()<<8|n()}function r(e){i(e>>8),i(e)}function s(){var e=o();return e>=32768?e-65536:e}function a(e){r(e<0?e+65536:e)}function l(){return 65536*o()+o()}function c(e){r(e>>>16&65535),r(65535&e)}function d(){var e=l();return e>=2147483648?e-4294967296:e}function u(e){c(e<0?e+4294967296:e)}function h(){return l()/65536}function f(e){c(Math.round(65536*e))}function p(){return d()/65536}function m(e){u(Math.round(65536*e))}function g(e){return b(e,n)}function v(e){return String.fromCharCode.apply(String,g(e))}function _(e){for(var t=0;t<e.length;++t)i(e.charCodeAt(t))}function b(e,t){for(var n=Array(e),i=0;i<e;++i)n[i]=t();return n}var w,y,k,x,C,S=0,T=0;return null==e?e=Te?new Uint8Array(256):[]:T=e.length,w=Te?function(t){if(t>=e.length){var n=new Uint8Array(Math.max(t+256,2*e.length));n.set(e,0),e=n}}:function(){},y=Te?function(){return new Uint8Array(e.buffer,0,T)}:function(){return e},k=Te?function(t){if("string"==typeof t)return _(t);var n=t.length;w(S+n),e.set(t,S),S+=n,S>T&&(T=S)}:function(e){if("string"==typeof e)return _(e);for(var t=0;t<e.length;++t)i(e[t])},x=Te?function(t,n){if(e.buffer.slice)return new Uint8Array(e.buffer.slice(t,t+n));var i=new Uint8Array(n);return i.set(new Uint8Array(e.buffer,t,n)),i}:function(t,n){return e.slice(t,t+n)},C={eof:t,readByte:n,writeByte:i,readShort:o,writeShort:r,readLong:l,writeLong:c,readFixed:h,writeFixed:f,readShort_:s,writeShort_:a,readLong_:d,writeLong_:u,readFixed_:p,writeFixed_:m,read:g,write:k,readString:v,writeString:_,times:b,get:y,slice:x,offset:function(e){return null!=e?(S=e,C):S},skip:function(e){S+=e},toString:function(){throw Error("FIX CALLER.  BinaryStream is no longer convertible to string!")},length:function(){return T},saveExcursion:function(e){var t=S;try{return e()}finally{S=t}},writeBase64:function(e){window.atob?_(window.atob(e)):k(De.decode(e))},base64:function(){return De.encode(y())}}}function n(e){for(var t,n,i=[],o=0,r=e.length;o<r;)t=e.charCodeAt(o++),t>=55296&&t<=56319&&o<r?(n=e.charCodeAt(o++),56320==(64512&n)?i.push(((1023&t)<<10)+(1023&n)+65536):(i.push(t),o--)):i.push(t);return i}function i(e){return e.map(function(e){var t="";return e>65535&&(e-=65536,t+=String.fromCharCode(e>>>10&1023|55296),e=56320|1023&e),t+=String.fromCharCode(e)}).join("")}function o(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function r(e){return Object.keys(e).sort(function(e,t){return e-t}).map(parseFloat)}function s(e){var t,n,i;for(this.raw=e,this.scalerType=e.readLong(),this.tableCount=e.readShort(),this.searchRange=e.readShort(),this.entrySelector=e.readShort(),this.rangeShift=e.readShort(),t=this.tables={},n=0;n<this.tableCount;++n)i={tag:e.readString(4),checksum:e.readLong(),offset:e.readLong(),length:e.readLong()},t[i.tag]=i}function a(e){function t(e,t){this.definition=t,this.length=t.length,this.offset=t.offset,this.file=e,this.rawData=e.raw,this.parse(e.raw)}t.prototype.raw=function(){return this.rawData.slice(this.offset,this.length)};for(var n in e)o(e,n)&&(t[n]=t.prototype[n]=e[n]);return t}function l(){var e,t="",n=He+"";for(e=0;e<n.length;++e)t+=String.fromCharCode(n.charCodeAt(e)-48+65);return++He,t}function c(e){this.font=e,this.subset={},this.unicodes={},this.ogid2ngid={0:0},this.ngid2ogid={0:0},this.ncid2ogid={},this.next=this.firstChar=1,this.nextGid=1,this.psName=l()+"+"+this.font.psName}function d(e,n){var i,o,r,s,a=this,l=a.contents=t(e);if("ttcf"==l.readString(4)){if(o=function(){l.offset(i),a.parse()},!n)throw Error("Must specify a name for TTC files");for(l.readLong(),r=l.readLong(),s=0;s<r;++s)if(i=l.readLong(),l.saveExcursion(o),a.psName==n)return;throw Error("Font "+n+" not found in collection")}l.offset(0),a.parse()}function u(){function e(){var t,n,o,r=arguments;for(t=0;t<arguments.length;++t){if(n=r[t],void 0===n)throw Error("Cannot output undefined to PDF");if(n instanceof I)n.beforeRender(e),n.render(e);else if(Ke(n))C(n,e);else if(x(n))S(n,e);else if("number"==typeof n){if(isNaN(n))throw Error("Cannot output NaN to PDF");o=n.toFixed(7),o.indexOf(".")>=0&&(o=o.replace(/\.?0+$/,"")),"-0"==o&&(o="0"),i.writeString(o)}else/string|boolean/.test(typeof n)?i.writeString(n+""):"function"==typeof n.get?i.write(n.get()):"object"==typeof n&&(n?e(new Je(n)):i.writeString("null"))}}var n=0,i=t();return e.writeData=function(e){i.write(e)},e.withIndent=function(t){++n,t(e),--n},e.indent=function(){e(Ve,w("",2*n,"  ")),e.apply(null,arguments)},e.offset=function(){return i.offset()},e.toString=function(){throw Error("FIX CALLER")},e.get=function(){return i.get()},e.stream=function(){return i},e}function h(e,t){var n=e.beforeRender,i=e.render;e.beforeRender=function(){},e.render=function(e){e(t," 0 R")},e.renderFull=function(o){e._offset=o.offset(),o(t," 0 obj "),n.call(e,o),i.call(e,o),o(" endobj")}}function f(e){var t,n,i;if("function"!=typeof e&&(t=e,e=function(e,n){return e in t?t[e]:n}),n=e("paperSize",We.a4),!n)return{};if("string"==typeof n&&(n=We[n.toLowerCase()],null==n))throw Error("Unknown paper size");return n[0]=E(n[0]),n[1]=E(n[1]),e("landscape",!1)&&(n=[Math.max(n[0],n[1]),Math.min(n[0],n[1])]),i=e("margin"),i&&("string"==typeof i||"number"==typeof i?(i=E(i,0),i={left:i,top:i,right:i,bottom:i}):i={left:E(i.left,0),top:E(i.top,0),right:E(i.right,0),bottom:E(i.bottom,0)},e("addMargin")&&(n[0]+=i.left+i.right,n[1]+=i.top+i.bottom)),{paperSize:n,margin:i}}function p(e){function t(t,n){return e&&null!=e[t]?e[t]:n}var n,i,o,r=this,s=u(),a=0,l=[];r.getOption=t,r.attach=function(e){return l.indexOf(e)<0&&(h(e,++a),l.push(e)),e},r.pages=[],r.FONTS={},r.IMAGES={},r.GRAD_COL_FUNCTIONS={},r.GRAD_OPC_FUNCTIONS={},r.GRAD_COL={},r.GRAD_OPC={},n=r.attach(new tt),i=r.attach(new nt),n.setPages(i),o=r.attach(new Je({Producer:new Ye(t("producer","Kendo UI PDF Generator")),Title:new Ye(t("title","")),Author:new Ye(t("author","")),Subject:new Ye(t("subject","")),Keywords:new Ye(t("keywords","")),Creator:new Ye(t("creator","Kendo UI PDF Generator")),CreationDate:t("date",new Date)})),r.addPage=function(e){var t,n,o,s=f(function(t,n){return e&&null!=e[t]?e[t]:n}),a=s.paperSize,l=s.margin,c=a[0],d=a[1];return l&&(c-=l.left+l.right,d-=l.top+l.bottom),t=new et(u(),null,(!0)),n={Contents:r.attach(t),Parent:i,MediaBox:[0,0,a[0],a[1]]},o=new at(r,n),o._content=t,i.addPage(r.attach(o)),o.transform(1,0,0,-1,0,a[1]),l&&(o.translate(l.left,l.top),o.rect(0,0,c,d),o.clip()),r.pages.push(o),o},r.render=function(){var e,t;for(s("%PDF-1.4",Ve,"%ÂÁÚÏÎ",Ve,Ve),e=0;e<l.length;++e)l[e].renderFull(s),s(Ve,Ve);for(t=s.offset(),s("xref",Ve,0," ",l.length+1,Ve),s("0000000000 65535 f ",Ve),e=0;e<l.length;++e)s(y(l[e]._offset,10)," 00000 n ",Ve);return s(Ve),s("trailer",Ve),s(new Je({Size:l.length+1,Root:n,Info:o}),Ve,Ve),s("startxref",Ve,t,Ve),s("%%EOF",Ve),s.stream().offset(0)}}function m(e,t){function n(){window.console&&(window.console.error?window.console.error("Cannot load URL: %s",e):window.console.log("Cannot load URL: %s",e)),t(null)}var i=new XMLHttpRequest;i.open("GET",e,!0),Oe&&(i.responseType="arraybuffer"),i.onload=function(){200==i.status||304==i.status?t(Oe?new Uint8Array(i.response):new window.VBArray(i.responseBody).toArray()):n()},i.onerror=n,i.send(null)}function g(e,t){var n=je[e];n?t(n):m(e,function(n){if(null==n)throw Error("Cannot load font from "+e);var i=new d(n);je[e]=i,t(i)})}function v(){qe={}}function _(e,n,i){function o(e){d.src=e,d.complete&&!Ne.msie?s():(d.onload=s,d.onerror=r)}function r(){i(qe[e]="TAINTED")}function s(){var o,s,c,u,h,f,p,m,g,v,_,b;if(n&&(n.width>=d.width||n.height>=d.height)&&(n=null),!n&&l&&/^image\/jpe?g$/i.test(l.type))return o=new FileReader,o.onload=function(){var n=new F(t(new Uint8Array(this.result)));URL.revokeObjectURL(a),i(qe[e]=n)},void o.readAsArrayBuffer(l);n||(n={width:d.width,height:d.height}),s=document.createElement("canvas"),s.width=n.width,s.height=n.height,c=s.getContext("2d"),c.drawImage(d,0,0,n.width,n.height);try{u=c.getImageData(0,0,n.width,n.height)}catch(w){return void r()}finally{a&&URL.revokeObjectURL(a)}for(h=!1,f=t(),p=t(),m=u.data,g=0;g<m.length;)f.writeByte(m[g++]),f.writeByte(m[g++]),f.writeByte(m[g++]),v=m[g++],v<255&&(h=!0),p.writeByte(v);h?d=new z(n.width,n.height,f,p):(_=s.toDataURL("image/jpeg"),_=_.substr(_.indexOf(";base64,")+8),b=t(),b.writeBase64(_),d=new F(b)),i(qe[e]=d)}var a,l,c,d=qe[e];d?i(d):(d=new Image,/^data:/i.test(e)||(d.crossOrigin="Anonymous"),Oe&&!/^data:/i.test(e)?(c=new XMLHttpRequest,c.onload=function(){l=c.response,a=URL.createObjectURL(l),o(a)},c.onerror=r,c.open("GET",e,!0),c.responseType="blob",c.send()):o(e))}function b(e){return function(t,n){function i(){0===--o&&n()}var o=t.length,r=o;if(0===o)return n();for(;r-- >0;)e(t[r],i)}}function w(e,t,n){for(;e.length<t;)e=n+e;return e}function y(e,t){return w(e+"",t,"0")}function k(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function x(e){return e instanceof Date}function C(e,t){t("["),e.length>0&&t.withIndent(function(){for(var n=0;n<e.length;++n)n>0&&n%8===0?t.indent(e[n]):t(" ",e[n])}),t(" ]")}function S(e,t){t("(D:",y(e.getUTCFullYear(),4),y(e.getUTCMonth()+1,2),y(e.getUTCDate(),2),y(e.getUTCHours(),2),y(e.getUTCMinutes(),2),y(e.getUTCSeconds(),2),"Z)")}function T(e){return e*(72/25.4)}function D(e){return T(10*e)}function A(e){return 72*e}function E(e,t){var n,i;if("number"==typeof e)return e;if("string"==typeof e&&(n=/^\s*([0-9.]+)\s*(mm|cm|in|pt)\s*$/.exec(e),n&&(i=parseFloat(n[1]),!isNaN(i))))return"pt"==n[2]?i:{mm:T,cm:D,"in":A}[n[2]](i);if(null!=t)return t;throw Error("Can't parse unit: "+e)}function I(){}function M(e,t,n){n||(n=I),e.prototype=new n;for(var i in t)k(t,i)&&(e.prototype[i]=t[i]);return e}function R(e){return k(Ze,e)?Ze[e]:Ze[e]=new Xe(e)}function F(e){var t,n,i,o,r,s,a,l,c;if(e.offset(0),r=e.readShort(),65496!=r)throw Error("Invalid JPEG image");for(;!e.eof();){if(s=e.readByte(),255!=s)throw Error("Invalid JPEG image");if(a=e.readByte(),l=e.readShort(),it.indexOf(a)>=0){o=e.readByte(),n=e.readShort(),t=e.readShort(),i=e.readByte();break}e.skip(l-2)}if(null==i)throw Error("Invalid JPEG image");switch(c={Type:R("XObject"),Subtype:R("Image"),Width:t,Height:n,BitsPerComponent:o,Filter:R("DCTDecode")},i){case 1:c.ColorSpace=R("DeviceGray");break;case 3:c.ColorSpace=R("DeviceRGB");break;case 4:c.ColorSpace=R("DeviceCMYK"),c.Decode=[1,0,1,0,1,0,1,0]}this.asStream=function(){e.offset(0);var t=new et(e,c);return t._resourceName=R("I"+ ++Ue),t}}function z(e,t,n,i){this.asStream=function(o){var r=new et(i,{Type:R("XObject"),Subtype:R("Image"),Width:e,Height:t,BitsPerComponent:8,ColorSpace:R("DeviceGray")},(!0)),s=new et(n,{Type:R("XObject"),Subtype:R("Image"),Width:e,Height:t,BitsPerComponent:8,ColorSpace:R("DeviceRGB"),SMask:o.attach(r)},(!0));return s._resourceName=R("I"+ ++Ue),s}}function P(e){return e.map(function(e){return Ke(e)?P(e):"number"==typeof e?(Math.round(1e3*e)/1e3).toFixed(3):e}).join(" ")}function B(e,t,n,i,o,r,s){var a=P([t,n,i,o,r,s]),l=e.GRAD_COL_FUNCTIONS[a];return l||(l=e.GRAD_COL_FUNCTIONS[a]=e.attach(new Je({FunctionType:2,Domain:[0,1],Range:[0,1,0,1,0,1],N:1,C0:[t,n,i],C1:[o,r,s]}))),l}function L(e,t,n){var i=P([t,n]),o=e.GRAD_OPC_FUNCTIONS[i];return o||(o=e.GRAD_OPC_FUNCTIONS[i]=e.attach(new Je({FunctionType:2,Domain:[0,1],Range:[0,1],N:1,C0:[t],C1:[n]}))),o}function H(e,t){function n(e){return 1==e.length?e[0]:{FunctionType:3,Functions:e,Domain:[0,1],Bounds:u,Encode:h}}var i,o,r,s,a,l=!1,c=[],d=[],u=[],h=[];for(i=1;i<t.length;++i)o=t[i-1],r=t[i],s=o.color,a=r.color,d.push(B(e,s.r,s.g,s.b,a.r,a.g,a.b)),(s.a<1||a.a<1)&&(l=!0),u.push(r.offset),h.push(0,1);if(l)for(i=1;i<t.length;++i)o=t[i-1],r=t[i],s=o.color,a=r.color,c.push(L(e,s.a,a.a));return u.pop(),{hasAlpha:l,colors:n(d),opacities:l?n(c):null}}function N(e,t,n,i,o,r){var s,a,l;return r||(l=[t].concat(i),n.forEach(function(e){l.push(e.offset,e.color.r,e.color.g,e.color.b)}),a=P(l),s=e.GRAD_COL[a]),s||(s=new Je({Type:R("Shading"),ShadingType:t?3:2,ColorSpace:R("DeviceRGB"),Coords:i,Domain:[0,1],Function:o,Extend:[!0,!0]}),e.attach(s),s._resourceName="S"+ ++Ue,a&&(e.GRAD_COL[a]=s)),s}function O(e,t,n,i,o,r){var s,a,l;return r||(l=[t].concat(i),n.forEach(function(e){l.push(e.offset,e.color.a)}),a=P(l),s=e.GRAD_OPC[a]),s||(s=new Je({Type:R("ExtGState"),AIS:!1,CA:1,ca:1,SMask:{Type:R("Mask"),S:R("Luminosity"),G:e.attach(new et("/a0 gs /s0 sh",{Type:R("XObject"),Subtype:R("Form"),FormType:1,BBox:r?[r.left,r.top+r.height,r.left+r.width,r.top]:[0,1,1,0],Group:{Type:R("Group"),S:R("Transparency"),CS:R("DeviceGray"),I:!0},Resources:{ExtGState:{a0:{CA:1,ca:1}},Shading:{s0:{ColorSpace:R("DeviceGray"),Coords:i,Domain:[0,1],ShadingType:t?3:2,Function:o,Extend:[!0,!0]}}}}))}}),e.attach(s),s._resourceName="O"+ ++Ue,a&&(e.GRAD_OPC[a]=s)),s}function V(e,t,n){var i="radial"==t.type,o=H(e,t.stops),r=i?[t.start.x,t.start.y,t.start.r,t.end.x,t.end.y,t.end.r]:[t.start.x,t.start.y,t.end.x,t.end.y],s=N(e,i,t.stops,r,o.colors,t.userSpace&&n),a=o.hasAlpha?O(e,i,t.stops,r,o.opacities,t.userSpace&&n):null;return{hasAlpha:o.hasAlpha,shading:s,opacity:a}}function U(e){return e.replace(/^\s*(['"])(.*)\1\s*$/,"$2")}function W(e){var t,n=/^\s*((normal|italic)\s+)?((normal|small-caps)\s+)?((normal|bold|\d+)\s+)?(([0-9.]+)(px|pt))(\/(([0-9.]+)(px|pt)|normal))?\s+(.*?)\s*$/i,i=n.exec(e);return i?(t=i[8]?parseInt(i[8],10):12,{italic:i[2]&&"italic"==i[2].toLowerCase(),variant:i[4],bold:i[6]&&/bold|700/i.test(i[6]),fontSize:t,lineHeight:i[12]?"normal"==i[12]?t:parseInt(i[12],10):null,fontFamily:i[14].split(/\s*,\s*/g).map(U)}):{fontSize:12,fontFamily:"sans-serif"}}function j(e){function t(t){return e.bold&&(t+="|bold"),e.italic&&(t+="|italic"),t.toLowerCase()}var n,i,o,r=e.fontFamily;if(r instanceof Array)for(o=0;o<r.length&&(n=t(r[o]),!(i=lt[n]));++o);else i=lt[r.toLowerCase()];for(;"function"==typeof i;)i=i();return i||(i="Times-Roman"),i}function q(e,t){e=e.toLowerCase(),lt[e]=function(){return lt[t]},lt[e+"|bold"]=function(){return lt[t+"|bold"]},lt[e+"|italic"]=function(){return lt[t+"|italic"]},lt[e+"|bold|italic"]=function(){return lt[t+"|bold|italic"]}}function G(e,t){if(1==arguments.length)for(var n in e)k(e,n)&&G(n,e[n]);else switch(e=e.toLowerCase(),lt[e]=t,e){case"dejavu sans":lt["sans-serif"]=t;break;case"dejavu sans|bold":lt["sans-serif|bold"]=t;break;case"dejavu sans|italic":lt["sans-serif|italic"]=t;break;case"dejavu sans|bold|italic":lt["sans-serif|bold|italic"]=t;break;case"dejavu serif":lt.serif=t;break;case"dejavu serif|bold":lt["serif|bold"]=t;break;case"dejavu serif|italic":lt["serif|italic"]=t;break;case"dejavu serif|bold|italic":lt["serif|bold|italic"]=t;break;case"dejavu mono":lt.monospace=t;break;case"dejavu mono|bold":lt["monospace|bold"]=t;break;case"dejavu mono|italic":lt["monospace|italic"]=t;break;case"dejavu mono|bold|italic":lt["monospace|bold|italic"]=t}}function $(e,t){var n=e[0],i=e[1],o=e[2],r=e[3],s=e[4],a=e[5],l=t[0],c=t[1],d=t[2],u=t[3],h=t[4],f=t[5];return[n*l+i*d,n*c+i*u,o*l+r*d,o*c+r*u,s*l+a*d+h,s*c+a*u+f]}function K(e){return 1===e[0]&&0===e[1]&&0===e[2]&&1===e[3]&&0===e[4]&&0===e[5]}function Y(e,t){function n(e,t,n){return n||(n=a),n.pdf&&null!=n.pdf[e]?n.pdf[e]:t}function i(){function i(e){var t,i,o,s,a,l=e.options,c=_e(e),d=c.bbox;e=c.root,t=n("paperSize",n("paperSize","auto"),l),i=!1,"auto"==t&&(d?(o=d.getSize(),t=[o.width,o.height],i=!0,s=d.getOrigin(),c=new xe.Group,c.transform(new Se.Matrix(1,0,0,1,(-s.x),(-s.y))),c.append(e),e=c):t="A4"),a=r.addPage({paperSize:t,margin:n("margin",n("margin"),l),addMargin:i,landscape:n("landscape",n("landscape",!1),l)}),ee(e,a,r)}if(!(--o>0)){var r=new p({producer:n("producer"),title:n("title"),author:n("author"),subject:n("subject"),keywords:n("keywords"),creator:n("creator"),date:n("date")});l?e.children.forEach(i):i(e),t(r.render(),r)}}var o,r=[],s={},a=e.options,l=n("multiPage"),c=n("imgDPI");c&&v(),e.traverse(function(e){J({Image:function(e){var t,n,i=e.src();c?(t=e.bbox().size,n=s[i],t={width:Math.ceil(t.width*c/72),height:Math.ceil(t.height*c/72)},n&&(t.width=Math.max(n.width,t.width),t.height=Math.max(n.height,t.height)),s[i]=t):s[i]=null},Text:function(e){var t=W(e.options.font),n=j(t);r.indexOf(n)<0&&r.push(n)}},e)}),o=2,Ge(r,i),$e(s,i)}function Q(e,t){Y(e,function(e){t("data:application/pdf;base64,"+e.base64())})}function X(e,t){Y(e,function(e){t(new window.Blob([e.get()],{type:"application/pdf"}))})}function Z(t,n,i,o){window.Blob&&!ye.safari?X(t,function(t){e.saveAs({dataURI:t,fileName:n}),o&&o(t)}):Q(t,function(t){e.saveAs({dataURI:t,fileName:n,proxyURL:i}),o&&o(t)})}function J(e,t){var n=e[t.nodeType];return n?n.call.apply(n,arguments):t}function ee(e,t,n){var i,o,r;e.options._pdfDebug&&t.comment("BEGIN: "+e.options._pdfDebug),i=e.transform(),o=e.opacity(),t.save(),null!=o&&o<1&&t.setOpacity(o),te(e,t,n),ne(e,t,n),i&&(r=i.matrix(),t.transform(r.a,r.b,r.c,r.d,r.e,r.f)),ie(e,t,n),J({Path:ce,MultiPath:de,Circle:ue,Arc:he,Text:fe,Image:me,Group:pe,Rect:ge},e,t,n),t.restore(),e.options._pdfDebug&&t.comment("END: "+e.options._pdfDebug)}function te(e,t){var n,i,o,r,s,a,l=e.stroke&&e.stroke();if(l){if(n=l.color){if(n=ve(n),null==n)return;t.setStrokeColor(n.r,n.g,n.b),1!=n.a&&t.setStrokeOpacity(n.a)}if(i=l.width,null!=i){if(0===i)return;t.setLineWidth(i)}o=l.dashType,o&&t.setDashPattern(ut[o],0),r=l.lineCap,r&&t.setLineCap(ht[r]),s=l.lineJoin,s&&t.setLineJoin(ft[s]),a=l.opacity,null!=a&&t.setStrokeOpacity(a)}}function ne(e,t){var n,i,o=e.fill&&e.fill();if(o&&!(o instanceof xe.Gradient)){if(n=o.color){if(n=ve(n),null==n)return;
t.setFillColor(n.r,n.g,n.b),1!=n.a&&t.setFillOpacity(n.a)}i=o.opacity,null!=i&&t.setFillOpacity(i)}}function ie(e,t,n){var i=e.clip();i&&(le(i,t,n),t.clip())}function oe(e){return e&&(e instanceof xe.Gradient||e.color&&!/^(none|transparent)$/i.test(e.color)&&(null==e.width||e.width>0)&&(null==e.opacity||e.opacity>0))}function re(e,t,n,i){var o,r,s,a,l,c,d,u,h=e.fill();if(h instanceof xe.Gradient)return i?t.clipStroke():t.clip(),o=h instanceof xe.RadialGradient,o?(r={x:h.center().x,y:h.center().y,r:0},s={x:h.center().x,y:h.center().y,r:h.radius()}):(r={x:h.start().x,y:h.start().y},s={x:h.end().x,y:h.end().y}),a=h.stops.elements().map(function(e){var t,n=e.offset();return n=/%$/.test(n)?parseFloat(n)/100:parseFloat(n),t=ve(e.color()),t.a*=e.opacity(),{offset:n,color:t}}),a.unshift(a[0]),a.push(a[a.length-1]),l={userSpace:h.userSpace(),type:o?"radial":"linear",start:r,end:s,stops:a},c=e.rawBBox(),d=c.topLeft(),u=c.getSize(),c={left:d.x,top:d.y,width:u.width,height:u.height},t.gradient(l,c),!0}function se(e,t,n){oe(e.fill())&&oe(e.stroke())?re(e,t,n,!0)||t.fillStroke():oe(e.fill())?re(e,t,n,!1)||t.fill():oe(e.stroke())?t.stroke():t.nop()}function ae(e,t){var n,i,o,r=e.segments;if(4==r.length&&e.options.closed){for(n=[],i=0;i<r.length;++i){if(r[i].controlIn())return!1;n[i]=r[i].anchor()}if(o=n[0].y==n[1].y&&n[1].x==n[2].x&&n[2].y==n[3].y&&n[3].x==n[0].x||n[0].x==n[1].x&&n[1].y==n[2].y&&n[2].x==n[3].x&&n[3].y==n[0].y)return t.rect(n[0].x,n[0].y,n[2].x-n[0].x,n[2].y-n[0].y),!0}}function le(e,t,n){var i,o,r,s,a,l,c=e.segments;if(0!==c.length&&!ae(e,t,n)){for(o=0;o<c.length;++o)r=c[o],s=r.anchor(),i?(a=i.controlOut(),l=r.controlIn(),a&&l?t.bezier(a.x,a.y,l.x,l.y,s.x,s.y):t.lineTo(s.x,s.y)):t.moveTo(s.x,s.y),i=r;e.options.closed&&t.close()}}function ce(e,t,n){le(e,t,n),se(e,t,n)}function de(e,t,n){var i,o=e.paths;for(i=0;i<o.length;++i)le(o[i],t,n);se(e,t,n)}function ue(e,t,n){var i=e.geometry();t.circle(i.center.x,i.center.y,i.radius),se(e,t,n)}function he(e,t,n){var i,o=e.geometry().curvePoints();for(t.moveTo(o[0].x,o[0].y),i=1;i<o.length;)t.bezier(o[i].x,o[i++].y,o[i].x,o[i++].y,o[i].x,o[i++].y);se(e,t,n)}function fe(e,t){var n,i=W(e.options.font),o=e._position;e.fill()&&e.stroke()?n=dt.fillAndStroke:e.fill()?n=dt.fill:e.stroke()&&(n=dt.stroke),t.transform(1,0,0,-1,o.x,o.y+i.fontSize),t.beginText(),t.setFont(j(i),i.fontSize),t.setTextRenderingMode(n),t.showText(e.content(),e._pdfRect?e._pdfRect.width():null),t.endText()}function pe(e,t,n){var i,o;for(e._pdfLink&&t.addLink(e._pdfLink.url,e._pdfLink),i=e.children,o=0;o<i.length;++o)ee(i[o],t,n)}function me(e,t){var n,i,o,r=e.src();r&&(n=e.rect(),i=n.getOrigin(),o=n.getSize(),t.transform(o.width,0,0,-o.height,i.x,i.y+o.height),t.drawImage(r))}function ge(e,t,n){var i=e.geometry();t.rect(i.origin.x,i.origin.y,i.size.width,i.size.height),se(e,t,n)}function ve(t){var n=e.parseColor(t,!0);return n?n.toRGB():null}function _e(e){function t(e){return a=!0,e}function n(e){return e.visible()&&e.opacity()>0&&(oe(e.fill())||oe(e.stroke()))}function i(e){var t,n,i=[];for(t=0;t<e.length;++t)n=s(e[t]),null!=n&&i.push(n);return i}function o(e,t){var n,i=l,o=c;e.transform()&&(c=c.multiplyCopy(e.transform().matrix())),n=e.clip(),n&&(n=n.bbox(),n&&(n=n.bbox(c),l=l?Se.Rect.intersect(l,n):n));try{return t()}finally{l=i,c=o}}function r(e){if(null==l)return!1;var t=e.rawBBox().bbox(c);return l&&t&&(t=Se.Rect.intersect(t,l)),t}function s(s){return o(s,function(){if(!(s instanceof xe.Group||s instanceof xe.MultiPath)){var o=r(s);if(!o)return t(null);d=d?Se.Rect.union(d,o):o}return J({Path:function(e){return 0!==e.segments.length&&n(e)?e:t(null)},MultiPath:function(e){if(!n(e))return t(null);var o=new xe.MultiPath(e.options);return o.paths=i(e.paths),0===o.paths.length?t(null):o},Circle:function(e){return n(e)?e:t(null)},Arc:function(e){return n(e)?e:t(null)},Text:function(e){return/\S/.test(e.content())&&n(e)?e:t(null)},Image:function(e){return e.visible()&&e.opacity()>0?e:t(null)},Group:function(n){var o=new xe.Group(n.options);return o.children=i(n.children),o._pdfLink=n._pdfLink,n===e||0!==o.children.length||n._pdfLink?o:t(null)},Rect:function(e){return n(e)?e:t(null)}},s)})}var a,l=!1,c=Se.Matrix.unit(),d=null;do a=!1,e=s(e);while(e&&a);return{root:e,bbox:d}}function be(e,t){var n,i=Ce.createPromise();for(n in t)"margin"==n&&e.options.pdf&&e.options.pdf._ignoreMargin||e.options.set("pdf."+n,t[n]);return Q(e,i.resolve),i}var we,ye,ke,xe,Ce,Se,Te,De,Ae,Ee,Ie,Me,Re,Fe,ze,Pe,Be,Le,He,Ne,Oe,Ve,Ue,We,je,qe,Ge,$e,Ke,Ye,Qe,Xe,Ze,Je,et,tt,nt,it,ot,rt,st,at,lt,ct,dt,ut,ht,ft;window.kendo.pdf=window.kendo.pdf||{},we=e.support,ye=we.browser,ke=e.pdf,xe=e.drawing,Ce=xe.util,Se=e.geometry,Te="undefined"!=typeof Uint8Array,De=function(){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";return{decode:function(t){for(var n,i,o,r,s,a,l,c=t.replace(/[^A-Za-z0-9\+\/\=]/g,""),d=0,u=c.length,h=[];d<u;)n=e.indexOf(c.charAt(d++)),i=e.indexOf(c.charAt(d++)),o=e.indexOf(c.charAt(d++)),r=e.indexOf(c.charAt(d++)),s=n<<2|i>>>4,a=(15&i)<<4|o>>>2,l=(3&o)<<6|r,h.push(s),64!=o&&h.push(a),64!=r&&h.push(l);return h},encode:function(t){for(var n,i,o,r,s,a,l,c=0,d=t.length,u="";c<d;)n=t[c++],i=t[c++],o=t[c++],r=n>>>2,s=(3&n)<<4|i>>>4,a=(15&i)<<2|o>>>6,l=63&o,c-d==2?a=l=64:c-d==1&&(l=64),u+=e.charAt(r)+e.charAt(s)+e.charAt(a)+e.charAt(l);return u}}}(),s.prototype={readTable:function(e,t){var n=this.tables[e];if(!n)throw Error("Table "+e+" not found in directory");return this[e]=n.table=new t(this,n)},render:function(e){var n,i,r,s,a,l,c,d,u=this,h=Object.keys(e).length,f=Math.pow(2,Math.floor(Math.log(h)/Math.LN2)),p=16*f,m=Math.floor(Math.log(f)/Math.LN2),g=16*h-p,v=t();v.writeLong(this.scalerType),v.writeShort(h),v.writeShort(p),v.writeShort(m),v.writeShort(g),n=16*h,i=v.offset()+n,r=null,s=t();for(a in e)if(o(e,a))for(l=e[a],v.writeString(a),v.writeLong(u.checksum(l)),v.writeLong(i),v.writeLong(l.length),s.write(l),"head"==a&&(r=i),i+=l.length;i%4;)s.writeByte(0),i++;return v.write(s.get()),c=this.checksum(v.get()),d=2981146554-c,v.offset(r+8),v.writeLong(d),v.get()},checksum:function(e){e=t(e);for(var n=0;!e.eof();)n+=e.readLong();return 4294967295&n}},Ae=a({parse:function(e){e.offset(this.offset),this.version=e.readLong(),this.revision=e.readLong(),this.checkSumAdjustment=e.readLong(),this.magicNumber=e.readLong(),this.flags=e.readShort(),this.unitsPerEm=e.readShort(),this.created=e.read(8),this.modified=e.read(8),this.xMin=e.readShort_(),this.yMin=e.readShort_(),this.xMax=e.readShort_(),this.yMax=e.readShort_(),this.macStyle=e.readShort(),this.lowestRecPPEM=e.readShort(),this.fontDirectionHint=e.readShort_(),this.indexToLocFormat=e.readShort_(),this.glyphDataFormat=e.readShort_()},render:function(e){var n=t();return n.writeLong(this.version),n.writeLong(this.revision),n.writeLong(0),n.writeLong(this.magicNumber),n.writeShort(this.flags),n.writeShort(this.unitsPerEm),n.write(this.created),n.write(this.modified),n.writeShort_(this.xMin),n.writeShort_(this.yMin),n.writeShort_(this.xMax),n.writeShort_(this.yMax),n.writeShort(this.macStyle),n.writeShort(this.lowestRecPPEM),n.writeShort_(this.fontDirectionHint),n.writeShort_(e),n.writeShort_(this.glyphDataFormat),n.get()}}),Ee=a({parse:function(e){e.offset(this.offset);var t=this.file.head.indexToLocFormat;this.offsets=0===t?e.times(this.length/2,function(){return 2*e.readShort()}):e.times(this.length/4,e.readLong)},offsetOf:function(e){return this.offsets[e]},lengthOf:function(e){return this.offsets[e+1]-this.offsets[e]},render:function(e){var n,i=t(),o=e[e.length-1]>65535;for(n=0;n<e.length;++n)o?i.writeLong(e[n]):i.writeShort(e[n]/2);return{format:o?1:0,table:i.get()}}}),Ie=a({parse:function(e){e.offset(this.offset),this.version=e.readLong(),this.ascent=e.readShort_(),this.descent=e.readShort_(),this.lineGap=e.readShort_(),this.advanceWidthMax=e.readShort(),this.minLeftSideBearing=e.readShort_(),this.minRightSideBearing=e.readShort_(),this.xMaxExtent=e.readShort_(),this.caretSlopeRise=e.readShort_(),this.caretSlopeRun=e.readShort_(),this.caretOffset=e.readShort_(),e.skip(8),this.metricDataFormat=e.readShort_(),this.numOfLongHorMetrics=e.readShort()},render:function(e){var n=t();return n.writeLong(this.version),n.writeShort_(this.ascent),n.writeShort_(this.descent),n.writeShort_(this.lineGap),n.writeShort(this.advanceWidthMax),n.writeShort_(this.minLeftSideBearing),n.writeShort_(this.minRightSideBearing),n.writeShort_(this.xMaxExtent),n.writeShort_(this.caretSlopeRise),n.writeShort_(this.caretSlopeRun),n.writeShort_(this.caretOffset),n.write([0,0,0,0,0,0,0,0]),n.writeShort_(this.metricDataFormat),n.writeShort(e.length),n.get()}}),Me=a({parse:function(e){e.offset(this.offset),this.version=e.readLong(),this.numGlyphs=e.readShort(),this.maxPoints=e.readShort(),this.maxContours=e.readShort(),this.maxComponentPoints=e.readShort(),this.maxComponentContours=e.readShort(),this.maxZones=e.readShort(),this.maxTwilightPoints=e.readShort(),this.maxStorage=e.readShort(),this.maxFunctionDefs=e.readShort(),this.maxInstructionDefs=e.readShort(),this.maxStackElements=e.readShort(),this.maxSizeOfInstructions=e.readShort(),this.maxComponentElements=e.readShort(),this.maxComponentDepth=e.readShort()},render:function(e){var n=t();return n.writeLong(this.version),n.writeShort(e.length),n.writeShort(this.maxPoints),n.writeShort(this.maxContours),n.writeShort(this.maxComponentPoints),n.writeShort(this.maxComponentContours),n.writeShort(this.maxZones),n.writeShort(this.maxTwilightPoints),n.writeShort(this.maxStorage),n.writeShort(this.maxFunctionDefs),n.writeShort(this.maxInstructionDefs),n.writeShort(this.maxStackElements),n.writeShort(this.maxSizeOfInstructions),n.writeShort(this.maxComponentElements),n.writeShort(this.maxComponentDepth),n.get()}}),Re=a({parse:function(e){var t,n,i;e.offset(this.offset),t=this.file,n=t.hhea,this.metrics=e.times(n.numOfLongHorMetrics,function(){return{advance:e.readShort(),lsb:e.readShort_()}}),i=t.maxp.numGlyphs-t.hhea.numOfLongHorMetrics,this.leftSideBearings=e.times(i,e.readShort_)},forGlyph:function(e){var t=this.metrics,n=t.length;return e<n?t[e]:{advance:t[n-1].advance,lsb:this.leftSideBearings[e-n]}},render:function(e){var n,i,o=this,r=t();for(n=0;n<e.length;++n)i=o.forGlyph(e[n]),r.writeShort(i.advance),r.writeShort_(i.lsb);return r.get()}}),Fe=function(){function e(e){this.raw=e}function n(e){var t,n,o;for(this.raw=e,t=this.glyphIds=[],n=this.idOffsets=[];;){if(o=e.readShort(),n.push(e.offset()),t.push(e.readShort()),!(o&s))break;e.skip(o&i?4:2),o&c?e.skip(8):o&l?e.skip(4):o&r&&e.skip(2)}}var i,r,s,l,c;return e.prototype={compound:!1,render:function(){return this.raw.get()}},i=1,r=8,s=32,l=64,c=128,n.prototype={compound:!0,render:function(e){var n,i,o=this,r=t(this.raw.get());for(n=0;n<this.glyphIds.length;++n)i=o.glyphIds[n],r.offset(o.idOffsets[n]),r.writeShort(e[i]);return r.get()}},a({parse:function(){this.cache={}},glyphFor:function(i){var r,s,a,l,c,d,u,h,f,p,m,g=this.cache;return o(g,i)?g[i]:(r=this.file.loca,s=r.lengthOf(i),0===s?g[i]=null:(a=this.rawData,l=this.offset+r.offsetOf(i),c=t(a.slice(l,s)),d=c.readShort_(),u=c.readShort_(),h=c.readShort_(),f=c.readShort_(),p=c.readShort_(),m=g[i]=d==-1?new n(c):new e(c),m.numberOfContours=d,m.xMin=u,m.yMin=h,m.xMax=f,m.yMax=p,m))},render:function(e,n,i){var o,r,s,a=t(),l=[];for(o=0;o<n.length;++o)r=n[o],s=e[r],l.push(a.offset()),s&&a.write(s.render(i));return l.push(a.offset()),{table:a.get(),offsets:l}}})}(),ze=function(){function e(e,t){this.text=e,this.length=e.length,this.platformID=t.platformID,this.platformSpecificID=t.platformSpecificID,this.languageID=t.languageID,this.nameID=t.nameID}return a({parse:function(t){var n,i,o,r,s,a,l;for(t.offset(this.offset),t.readShort(),n=t.readShort(),i=this.offset+t.readShort(),o=t.times(n,function(){return{platformID:t.readShort(),platformSpecificID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:t.readShort()+i}}),r=this.strings={},s=0;s<o.length;++s)a=o[s],t.offset(a.offset),l=t.readString(a.length),r[a.nameID]||(r[a.nameID]=[]),r[a.nameID].push(new e(l,a));this.postscriptEntry=r[6][0],this.postscriptName=this.postscriptEntry.text.replace(/[^\x20-\x7F]/g,"")},render:function(n){var i,r,s,a,l,c,d=this,u=this.strings,h=0;for(i in u)o(u,i)&&(h+=u[i].length);r=t(),s=t(),r.writeShort(0),r.writeShort(h),r.writeShort(6+12*h);for(i in u)if(o(u,i))for(a=6==i?[new e(n,d.postscriptEntry)]:u[i],l=0;l<a.length;++l)c=a[l],r.writeShort(c.platformID),r.writeShort(c.platformSpecificID),r.writeShort(c.languageID),r.writeShort(c.nameID),r.writeShort(c.length),r.writeShort(s.offset()),s.writeString(c.text);return r.write(s.get()),r.get()}})}(),Pe=function(){var e=".notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat".split(/\s+/g);return a({parse:function(e){var t,n,i=this;switch(e.offset(this.offset),this.format=e.readLong(),this.italicAngle=e.readFixed_(),this.underlinePosition=e.readShort_(),this.underlineThickness=e.readShort_(),this.isFixedPitch=e.readLong(),this.minMemType42=e.readLong(),this.maxMemType42=e.readLong(),this.minMemType1=e.readLong(),this.maxMemType1=e.readLong(),this.format){case 65536:case 196608:break;case 131072:for(t=e.readShort(),this.glyphNameIndex=e.times(t,e.readShort),this.names=[],n=this.offset+this.length;e.offset()<n;)i.names.push(e.readString(e.readByte()));break;case 151552:t=e.readShort(),this.offsets=e.read(t);break;case 262144:this.map=e.times(this.file.maxp.numGlyphs,e.readShort)}},glyphFor:function(t){switch(this.format){case 65536:return e[t]||".notdef";case 131072:var n=this.glyphNameIndex[t];return n<e.length?e[n]:this.names[n-e.length]||".notdef";case 151552:case 196608:return".notdef";case 262144:return this.map[t]||65535}},render:function(n){var i,o,r,s,a,l,c,d=this;if(196608==this.format)return this.raw();for(i=t(this.rawData.slice(this.offset,32)),i.writeLong(131072),i.offset(32),o=[],r=[],s=0;s<n.length;++s)a=n[s],l=d.glyphFor(a),c=e.indexOf(l),c>=0?o.push(c):(o.push(e.length+r.length),r.push(l));for(i.writeShort(n.length),s=0;s<o.length;++s)i.writeShort(o[s]);for(s=0;s<r.length;++s)i.writeByte(r[s].length),i.writeString(r[s]);return i.get()}})}(),Be=function(){function e(e,t,n){var i=this;i.platformID=e.readShort(),i.platformSpecificID=e.readShort(),i.offset=t+e.readLong(),e.saveExcursion(function(){var t,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b;switch(e.offset(i.offset),i.format=e.readShort()){case 0:for(i.length=e.readShort(),i.language=e.readShort(),o=0;o<256;++o)n[o]=e.readByte();break;case 4:for(i.length=e.readShort(),i.language=e.readShort(),r=e.readShort()/2,e.skip(6),s=e.times(r,e.readShort),e.skip(2),a=e.times(r,e.readShort),l=e.times(r,e.readShort_),c=e.times(r,e.readShort),d=(i.length+i.offset-e.offset())/2,u=e.times(d,e.readShort),o=0;o<r;++o)for(h=a[o],f=s[o],t=h;t<=f;++t)0===c[o]?p=t+l[o]:(m=c[o]/2-(r-o)+(t-h),p=u[m]||0,0!==p&&(p+=l[o])),n[t]=65535&p;break;case 6:for(i.length=e.readShort(),i.language=e.readShort(),t=e.readShort(),g=e.readShort();g-- >0;)n[t++]=e.readShort();break;case 12:for(e.readShort(),i.length=e.readLong(),i.language=e.readLong(),v=e.readLong();v-- >0;)for(t=e.readLong(),_=e.readLong(),b=e.readLong();t<=_;)n[t++]=b++;break;default:window.console&&window.console.error("Unhandled CMAP format: "+i.format)}})}function n(e,n){function i(t){return n[e[t]]}var o,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k=r(e),x=[],C=[],S=null,T=null;for(o=0;o<k.length;++o)s=k[o],a=i(s),l=a-s,null!=S&&l===T||(S&&C.push(S),x.push(s),T=l),S=s;for(S&&C.push(S),C.push(65535),x.push(65535),c=x.length,d=2*c,u=2*Math.pow(2,Math.floor(Math.log(c)/Math.LN2)),h=Math.log(u/2)/Math.LN2,f=d-u,p=[],m=[],g=[],o=0;o<c;++o){if(v=x[o],_=C[o],65535==v){p.push(0),m.push(0);break}if(b=i(v),v-b>=32768)for(p.push(0),m.push(2*(g.length+c-o)),w=v;w<=_;++w)g.push(i(w));else p.push(b-v),m.push(0)}return y=t(),y.writeShort(3),y.writeShort(1),y.writeLong(12),y.writeShort(4),y.writeShort(16+8*c+2*g.length),y.writeShort(0),y.writeShort(d),y.writeShort(u),y.writeShort(h),y.writeShort(f),C.forEach(y.writeShort),y.writeShort(0),x.forEach(y.writeShort),p.forEach(y.writeShort_),m.forEach(y.writeShort),g.forEach(y.writeShort),y.get()}return a({parse:function(t){var n,i=this,o=i.offset;t.offset(o),i.codeMap={},i.version=t.readShort(),n=t.readShort(),i.tables=t.times(n,function(){return new e(t,o,i.codeMap)})},render:function(e,i){var o=t();return o.writeShort(0),o.writeShort(1),o.write(n(e,i)),o.get()}})}(),Le=a({parse:function(e){e.offset(this.offset),this.version=e.readShort(),this.averageCharWidth=e.readShort_(),this.weightClass=e.readShort(),this.widthClass=e.readShort(),this.type=e.readShort(),this.ySubscriptXSize=e.readShort_(),this.ySubscriptYSize=e.readShort_(),this.ySubscriptXOffset=e.readShort_(),this.ySubscriptYOffset=e.readShort_(),this.ySuperscriptXSize=e.readShort_(),this.ySuperscriptYSize=e.readShort_(),this.ySuperscriptXOffset=e.readShort_(),this.ySuperscriptYOffset=e.readShort_(),this.yStrikeoutSize=e.readShort_(),this.yStrikeoutPosition=e.readShort_(),this.familyClass=e.readShort_(),this.panose=e.times(10,e.readByte),this.charRange=e.times(4,e.readLong),this.vendorID=e.readString(4),this.selection=e.readShort(),this.firstCharIndex=e.readShort(),this.lastCharIndex=e.readShort(),this.version>0&&(this.ascent=e.readShort_(),this.descent=e.readShort_(),this.lineGap=e.readShort_(),this.winAscent=e.readShort(),this.winDescent=e.readShort(),this.codePageRange=e.times(2,e.readLong),this.version>1&&(this.xHeight=e.readShort(),this.capHeight=e.readShort(),this.defaultChar=e.readShort(),this.breakChar=e.readShort(),this.maxContext=e.readShort()))},render:function(){return this.raw()}}),He=1e5,c.prototype={use:function(e){var t,i,o,r=this;return"string"==typeof e?n(e).reduce(function(e,t){return e+String.fromCharCode(r.use(t))},""):(t=r.unicodes[e],t||(t=r.next++,r.subset[t]=e,r.unicodes[e]=t,i=r.font.cmap.codeMap[e],i&&(r.ncid2ogid[t]=i,null==r.ogid2ngid[i]&&(o=r.nextGid++,r.ogid2ngid[i]=o,r.ngid2ogid[o]=i))),t)},encodeText:function(e){return this.use(e)},glyphIds:function(){return r(this.ogid2ngid)},glyphsFor:function(e,t){var n,i,o,r=this;for(t||(t={}),n=0;n<e.length;++n)i=e[n],t[i]||(o=t[i]=r.font.glyf.glyphFor(i),o&&o.compound&&r.glyphsFor(o.glyphIds,t));return t},render:function(){var e,t,n,i,s,a,l,c,d=this,u=this.glyphsFor(this.glyphIds());for(e in u)o(u,e)&&(e=parseInt(e,10),null==d.ogid2ngid[e]&&(t=d.nextGid++,d.ogid2ngid[e]=t,d.ngid2ogid[t]=e));return n=r(this.ngid2ogid),i=n.map(function(e){return this.ngid2ogid[e]},this),s=this.font,a=s.glyf.render(u,i,this.ogid2ngid),l=s.loca.render(a.offsets),this.lastChar=this.next-1,c={cmap:Be.render(this.ncid2ogid,this.ogid2ngid),glyf:a.table,loca:l.table,hmtx:s.hmtx.render(i),hhea:s.hhea.render(i),maxp:s.maxp.render(i),post:s.post.render(i),name:s.name.render(this.psName),head:s.head.render(l.format),"OS/2":s.os2.render()},this.font.directory.render(c)},cidToGidMap:function(){var e,n,i,o=this,r=t(),s=0;for(e=this.firstChar;e<this.next;++e){for(;s<e;)r.writeShort(0),s++;n=o.ncid2ogid[e],n?(i=o.ogid2ngid[n],r.writeShort(i)):r.writeShort(0),s++}return r.get()}},d.prototype={parse:function(){var e=this.directory=new s(this.contents);this.head=e.readTable("head",Ae),this.loca=e.readTable("loca",Ee),this.hhea=e.readTable("hhea",Ie),this.maxp=e.readTable("maxp",Me),this.hmtx=e.readTable("hmtx",Re),this.glyf=e.readTable("glyf",Fe),this.name=e.readTable("name",ze),this.post=e.readTable("post",Pe),this.cmap=e.readTable("cmap",Be),this.os2=e.readTable("OS/2",Le),this.psName=this.name.postscriptName,this.ascent=this.os2.ascent||this.hhea.ascent,this.descent=this.os2.descent||this.hhea.descent,this.lineGap=this.os2.lineGap||this.hhea.lineGap,this.scale=1e3/this.head.unitsPerEm},widthOfGlyph:function(e){return this.hmtx.forGlyph(e).advance*this.scale},makeSubset:function(){return new c(this)}},Ne=e.support.browser,Oe="undefined"!=typeof Uint8Array,Ve="\n",Ue=0,We={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],executive:[521.86,756],folio:[612,936],legal:[612,1008],letter:[612,792],tabloid:[792,1224]},je={"Times-Roman":!0,"Times-Bold":!0,"Times-Italic":!0,"Times-BoldItalic":!0,Helvetica:!0,"Helvetica-Bold":!0,"Helvetica-Oblique":!0,"Helvetica-BoldOblique":!0,Courier:!0,"Courier-Bold":!0,"Courier-Oblique":!0,"Courier-BoldOblique":!0,Symbol:!0,ZapfDingbats:!0},qe={},Ge=b(g),$e=function(e,t){function n(){0===--o&&t()}var i=Object.keys(e),o=i.length;return 0===o?t():void i.forEach(function(t){_(t,e[t],n)})},p.prototype={loadFonts:Ge,loadImages:$e,getFont:function(e){var t=this.FONTS[e];if(!t){if(t=je[e],!t)throw Error("Font "+e+" has not been loaded");t=this.attach(t===!0?new ot(e):new rt(this,t)),this.FONTS[e]=t}return t},getImage:function(e){var t=this.IMAGES[e];if(!t){if(t=qe[e],!t)throw Error("Image "+e+" has not been loaded");if("TAINTED"===t)return null;t=this.IMAGES[e]=this.attach(t.asStream(this))}return t},getOpacityGS:function(e,t){var n,i,o,r=parseFloat(e).toFixed(3);return e=parseFloat(r),r+=t?"S":"F",n=this._opacityGSCache||(this._opacityGSCache={}),i=n[r],i||(o={Type:R("ExtGState")},t?o.CA=e:o.ca=e,i=this.attach(new Je(o)),i._resourceName=R("GS"+ ++Ue),n[r]=i),i},dict:function(e){return new Je(e)},name:function(e){return R(e)},stream:function(e,t){return new et(t,e)}},Ke=Array.isArray||function(e){return e instanceof Array},I.prototype.beforeRender=function(){},Ye=M(function(e){this.value=e},{render:function(e){var t,n="",i=this.value;for(t=0;t<i.length;++t)n+=String.fromCharCode(255&i.charCodeAt(t));e("(",n.replace(/([\(\)\\])/g,"\\$1"),")")},toString:function(){return this.value}}),Qe=M(function(e){this.value=e},{render:function(e){var t,n=this;for(e("<"),t=0;t<this.value.length;++t)e(y(n.value.charCodeAt(t).toString(16),4));e(">")}},Ye),Xe=M(function(e){this.name=e},{render:function(e){e("/"+this.escape())},escape:function(){return this.name.replace(/[^\x21-\x7E]/g,function(e){return"#"+y(e.charCodeAt(0).toString(16),2)})},toString:function(){return this.name}}),Ze={},Xe.get=R,Je=M(function(e){this.props=e},{render:function(e){var t=this.props,n=!0;e("<<"),e.withIndent(function(){for(var i in t)k(t,i)&&!/^_/.test(i)&&(n=!1,e.indent(R(i)," ",t[i]))}),n||e.indent(),e(">>")}}),et=M(function(e,n,i){if("string"==typeof e){var o=t();o.write(e),e=o}this.data=e,this.props=n||{},this.compress=i},{render:function(e){var t=this.data.get(),n=this.props;this.compress&&ke.supportsDeflate()&&(n.Filter?n.Filter instanceof Array||(n.Filter=[n.Filter]):n.Filter=[],n.Filter.unshift(R("FlateDecode")),t=ke.deflate(t)),n.Length=t.length,e(new Je(n)," stream",Ve),e.writeData(t),e(Ve,"endstream")}}),tt=M(function(e){e=this.props=e||{},e.Type=R("Catalog")},{setPages:function(e){this.props.Pages=e}},Je),nt=M(function(){this.props={Type:R("Pages"),Kids:[],Count:0}},{addPage:function(e){this.props.Kids.push(e),this.props.Count++}},Je),it=[192,193,194,195,197,198,199,201,202,203,205,206,207],ot=M(function(e){this.props={Type:R("Font"),Subtype:R("Type1"),BaseFont:R(e)},this._resourceName=R("F"+ ++Ue)},{encodeText:function(e){return new Ye(e+"")}},Je),rt=M(function(e,t,n){var i,o;n=this.props=n||{},n.Type=R("Font"),n.Subtype=R("Type0"),n.Encoding=R("Identity-H"),this._pdf=e,this._font=t,this._sub=t.makeSubset(),this._resourceName=R("F"+ ++Ue),i=t.head,this.name=t.psName,o=this.scale=t.scale,this.bbox=[i.xMin*o,i.yMin*o,i.xMax*o,i.yMax*o],this.italicAngle=t.post.italicAngle,this.ascent=t.ascent*o,this.descent=t.descent*o,this.lineGap=t.lineGap*o,this.capHeight=t.os2.capHeight||this.ascent,this.xHeight=t.os2.xHeight||0,this.stemV=0,this.familyClass=(t.os2.familyClass||0)>>8,this.isSerif=this.familyClass>=1&&this.familyClass<=7,this.isScript=10==this.familyClass,this.flags=(t.post.isFixedPitch?1:0)|(this.isSerif?2:0)|(this.isScript?8:0)|(0!==this.italicAngle?64:0)|32},{encodeText:function(e){return new Qe(this._sub.encodeText(e+""))},getTextWidth:function(e,t){var n,i,o=this,r=0,s=this._font.cmap.codeMap;for(n=0;n<t.length;++n)i=s[t.charCodeAt(n)],r+=o._font.widthOfGlyph(i||0);return r*e/1e3},beforeRender:function(){var e,n,i,o,r=this,s=r._sub,a=s.render(),l=new et(t(a),{Length1:a.length},(!0)),c=r._pdf.attach(new Je({Type:R("FontDescriptor"),FontName:R(r._sub.psName),FontBBox:r.bbox,Flags:r.flags,StemV:r.stemV,ItalicAngle:r.italicAngle,Ascent:r.ascent,Descent:r.descent,CapHeight:r.capHeight,XHeight:r.xHeight,FontFile2:r._pdf.attach(l)})),d=s.ncid2ogid,h=s.firstChar,f=s.lastChar,p=[];!function m(e,t){if(e<=f){var n=d[e];null==n?m(e+1):(t||p.push(e,t=[]),t.push(r._font.widthOfGlyph(n)),m(e+1,t))}}(h),e=new Je({Type:R("Font"),Subtype:R("CIDFontType2"),BaseFont:R(r._sub.psName),CIDSystemInfo:new Je({Registry:new Ye("Adobe"),Ordering:new Ye("Identity"),Supplement:0}),FontDescriptor:c,FirstChar:h,LastChar:f,DW:Math.round(r._font.widthOfGlyph(0)),W:p,CIDToGIDMap:r._pdf.attach(r._makeCidToGidMap())}),n=r.props,n.BaseFont=R(r._sub.psName),n.DescendantFonts=[r._pdf.attach(e)],i=new st(h,f,s.subset),o=new et(u(),null,(!0)),o.data(i),n.ToUnicode=r._pdf.attach(o)},_makeCidToGidMap:function(){return new et(t(this._sub.cidToGidMap()),null,(!0))}},Je),st=M(function(e,t,n){this.firstChar=e,this.lastChar=t,this.map=n},{render:function(e){e.indent("/CIDInit /ProcSet findresource begin"),e.indent("12 dict begin"),e.indent("begincmap"),e.indent("/CIDSystemInfo <<"),e.indent("  /Registry (Adobe)"),e.indent("  /Ordering (UCS)"),e.indent("  /Supplement 0"),e.indent(">> def"),e.indent("/CMapName /Adobe-Identity-UCS def"),e.indent("/CMapType 2 def"),e.indent("1 begincodespacerange"),e.indent("  <0000><ffff>"),e.indent("endcodespacerange");var t=this;e.indent(t.lastChar-t.firstChar+1," beginbfchar"),e.withIndent(function(){var n,o,r,s;for(n=t.firstChar;n<=t.lastChar;++n){for(o=t.map[n],r=i([o]),e.indent("<",y(n.toString(16),4),">","<"),s=0;s<r.length;++s)e(y(r.charCodeAt(s).toString(16),4));e(">")}}),e.indent("endbfchar"),e.indent("endcmap"),e.indent("CMapName currentdict /CMap defineresource pop"),e.indent("end"),e.indent("end")}}),at=M(function(e,t){this._pdf=e,this._rcount=0,this._textMode=!1,this._fontResources={},this._gsResources={},this._xResources={},this._patResources={},this._shResources={},this._opacity=1,this._matrix=[1,0,0,1,0,0],this._annotations=[],this._font=null,this._fontSize=null,this._contextStack=[],t=this.props=t||{},t.Type=R("Page"),t.ProcSet=[R("PDF"),R("Text"),R("ImageB"),R("ImageC"),R("ImageI")],t.Resources=new Je({Font:new Je(this._fontResources),ExtGState:new Je(this._gsResources),XObject:new Je(this._xResources),Pattern:new Je(this._patResources),Shading:new Je(this._shResources)}),t.Annots=this._annotations},{_out:function(){this._content.data.apply(null,arguments)},transform:function(e,t,n,i,o,r){K(arguments)||(this._matrix=$(arguments,this._matrix),this._out(e," ",t," ",n," ",i," ",o," ",r," cm"),this._out(Ve))},translate:function(e,t){this.transform(1,0,0,1,e,t)},scale:function(e,t){this.transform(e,0,0,t,0,0)},rotate:function(e){var t=Math.cos(e),n=Math.sin(e);this.transform(t,n,-n,t,0,0)},beginText:function(){this._textMode=!0,this._out("BT",Ve)},endText:function(){this._textMode=!1,this._out("ET",Ve)},_requireTextMode:function(){if(!this._textMode)throw Error("Text mode required; call page.beginText() first")},_requireFont:function(){if(!this._font)throw Error("No font selected; call page.setFont() first")},setFont:function(e,t){this._requireTextMode(),null==e?e=this._font:e instanceof rt||(e=this._pdf.getFont(e)),null==t&&(t=this._fontSize),this._fontResources[e._resourceName]=e,this._font=e,this._fontSize=t,this._out(e._resourceName," ",t," Tf",Ve)},setTextLeading:function(e){this._requireTextMode(),this._out(e," TL",Ve)},setTextRenderingMode:function(e){this._requireTextMode(),this._out(e," Tr",Ve)},showText:function(e,t){var n,i;this._requireFont(),e.length>1&&t&&this._font instanceof rt&&(n=this._font.getTextWidth(this._fontSize,e),i=t/n*100,this._out(i," Tz ")),this._out(this._font.encodeText(e)," Tj",Ve)},showTextNL:function(e){this._requireFont(),this._out(this._font.encodeText(e)," '",Ve)},addLink:function(e,t){var n=this._toPage({x:t.left,y:t.bottom}),i=this._toPage({x:t.right,y:t.top});this._annotations.push(new Je({Type:R("Annot"),Subtype:R("Link"),Rect:[n.x,n.y,i.x,i.y],Border:[0,0,0],A:new Je({Type:R("Action"),S:R("URI"),URI:new Ye(e)})}))},setStrokeColor:function(e,t,n){this._out(e," ",t," ",n," RG",Ve)},setOpacity:function(e){this.setFillOpacity(e),this.setStrokeOpacity(e),this._opacity*=e},setStrokeOpacity:function(e){if(e<1){var t=this._pdf.getOpacityGS(this._opacity*e,!0);this._gsResources[t._resourceName]=t,this._out(t._resourceName," gs",Ve)}},setFillColor:function(e,t,n){this._out(e," ",t," ",n," rg",Ve)},setFillOpacity:function(e){if(e<1){var t=this._pdf.getOpacityGS(this._opacity*e,!1);this._gsResources[t._resourceName]=t,this._out(t._resourceName," gs",Ve)}},gradient:function(e,t){var n,i,o;this.save(),this.rect(t.left,t.top,t.width,t.height),this.clip(),e.userSpace||this.transform(t.width,0,0,t.height,t.left,t.top),n=V(this._pdf,e,t),i=n.shading._resourceName,this._shResources[i]=n.shading,n.hasAlpha&&(o=n.opacity._resourceName,this._gsResources[o]=n.opacity,this._out("/"+o+" gs ")),this._out("/"+i+" sh",Ve),this.restore()},setDashPattern:function(e,t){this._out(e," ",t," d",Ve)},setLineWidth:function(e){this._out(e," w",Ve)},setLineCap:function(e){this._out(e," J",Ve)},setLineJoin:function(e){this._out(e," j",Ve)},setMitterLimit:function(e){this._out(e," M",Ve)},save:function(){this._contextStack.push(this._context()),this._out("q",Ve)},restore:function(){this._out("Q",Ve),this._context(this._contextStack.pop())},moveTo:function(e,t){this._out(e," ",t," m",Ve)},lineTo:function(e,t){
this._out(e," ",t," l",Ve)},bezier:function(e,t,n,i,o,r){this._out(e," ",t," ",n," ",i," ",o," ",r," c",Ve)},bezier1:function(e,t,n,i){this._out(e," ",t," ",n," ",i," y",Ve)},bezier2:function(e,t,n,i){this._out(e," ",t," ",n," ",i," v",Ve)},close:function(){this._out("h",Ve)},rect:function(e,t,n,i){this._out(e," ",t," ",n," ",i," re",Ve)},ellipse:function(e,t,n,i){function o(t){return e+t}function r(e){return t+e}var s=.5522847498307936;this.moveTo(o(0),r(i)),this.bezier(o(n*s),r(i),o(n),r(i*s),o(n),r(0)),this.bezier(o(n),r(-i*s),o(n*s),r(-i),o(0),r(-i)),this.bezier(o(-n*s),r(-i),o(-n),r(-i*s),o(-n),r(0)),this.bezier(o(-n),r(i*s),o(-n*s),r(i),o(0),r(i))},circle:function(e,t,n){this.ellipse(e,t,n,n)},stroke:function(){this._out("S",Ve)},nop:function(){this._out("n",Ve)},clip:function(){this._out("W n",Ve)},clipStroke:function(){this._out("W S",Ve)},closeStroke:function(){this._out("s",Ve)},fill:function(){this._out("f",Ve)},fillStroke:function(){this._out("B",Ve)},drawImage:function(e){var t=this._pdf.getImage(e);t&&(this._xResources[t._resourceName]=t,this._out(t._resourceName," Do",Ve))},comment:function(e){var t=this;e.split(/\r?\n/g).forEach(function(e){t._out("% ",e,Ve)})},_context:function(e){return null==e?{opacity:this._opacity,matrix:this._matrix}:(this._opacity=e.opacity,void(this._matrix=e.matrix))},_toPage:function(e){var t=this._matrix,n=t[0],i=t[1],o=t[2],r=t[3],s=t[4],a=t[5];return{x:n*e.x+o*e.y+s,y:i*e.x+r*e.y+a}}},Je),lt={serif:"Times-Roman","serif|bold":"Times-Bold","serif|italic":"Times-Italic","serif|bold|italic":"Times-BoldItalic","sans-serif":"Helvetica","sans-serif|bold":"Helvetica-Bold","sans-serif|italic":"Helvetica-Oblique","sans-serif|bold|italic":"Helvetica-BoldOblique",monospace:"Courier","monospace|bold":"Courier-Bold","monospace|italic":"Courier-Oblique","monospace|bold|italic":"Courier-BoldOblique",zapfdingbats:"ZapfDingbats","zapfdingbats|bold":"ZapfDingbats","zapfdingbats|italic":"ZapfDingbats","zapfdingbats|bold|italic":"ZapfDingbats"},q("Times New Roman","serif"),q("Courier New","monospace"),q("Arial","sans-serif"),q("Helvetica","sans-serif"),q("Verdana","sans-serif"),q("Tahoma","sans-serif"),q("Georgia","sans-serif"),q("Monaco","monospace"),q("Andale Mono","monospace"),ct={fill:0,stroke:1,fillAndStroke:2,invisible:3,fillAndClip:4,strokeAndClip:5,fillStrokeClip:6,clip:7},dt=ct,ut={dash:[4],dashDot:[4,2,1,2],dot:[1,2],longDash:[8,2],longDashDot:[8,2,1,2],longDashDotDot:[8,2,1,2,1,2],solid:[]},ht={butt:0,round:1,square:2},ft={miter:0,round:1,bevel:2},e.deepExtend(e.pdf,{Document:p,BinaryStream:t,defineFont:G,parseFontDef:W,getFontURL:j,loadFonts:Ge,loadImages:$e,getPaperOptions:f,clearImageCache:v,TEXT_RENDERING_MODE:ct,exportPDF:be,saveAs:Z,toDataURL:Q,toBlob:X,render:Y}),e.drawing.exportPDF=e.pdf.exportPDF,e.drawing.pdf=e.pdf}(kendo),kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("pdf/mixins.min",["pdf/core.min"],e)}(function(){return function(e,t){kendo.PDFMixin={extend:function(e){e.events.push("pdfExport"),e.options.pdf=this.options,e.saveAsPDF=this.saveAsPDF,e._drawPDF=this._drawPDF,e._drawPDFShadow=this._drawPDFShadow},options:{fileName:"Export.pdf",proxyURL:"",paperSize:"auto",allPages:!1,landscape:!1,margin:null,title:null,author:null,subject:null,keywords:null,creator:"Kendo UI PDF Generator v."+kendo.version,date:null},saveAsPDF:function(){var t,n=new e.Deferred,i=n.promise(),o={promise:i};if(!this.trigger("pdfExport",o))return t=this.options.pdf,t.multiPage=t.multiPage||t.allPages,this._drawPDF(n).then(function(e){return kendo.drawing.exportPDF(e,t)}).done(function(e){kendo.saveAs({dataURI:e,fileName:t.fileName,proxyURL:t.proxyURL,forceProxy:t.forceProxy,proxyTarget:t.proxyTarget}),n.resolve()}).fail(function(e){n.reject(e)}),i},_drawPDF:function(t){var n=new e.Deferred;return kendo.drawing.drawDOM(this.wrapper).done(function(e){var i={page:e,pageNumber:1,progress:1,totalPages:1};t.notify(i),n.resolve(i.page)}).fail(function(e){n.reject(e)}),n},_drawPDFShadow:function(t,n){var i,o,r;return t=t||{},i=this.wrapper,o=e("<div class='k-pdf-export-shadow'>"),t.width&&o.css({width:t.width,overflow:"visible"}),i.before(o),o.append(t.content||i.clone(!0,!0)),r=e.Deferred(),setTimeout(function(){var e=kendo.drawing.drawDOM(o,n);e.always(function(){o.remove()}).then(function(){r.resolve.apply(r,arguments)}).fail(function(){r.reject.apply(r,arguments)}).progress(function(){r.progress.apply(r,arguments)})},15),r.promise()}}}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.pdf.min",["kendo.core.min","kendo.drawing.min","pdf/core.min","pdf/mixins.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.grid.min",["kendo.data.min","kendo.columnsorter.min","kendo.editable.min","kendo.window.min","kendo.filtermenu.min","kendo.columnmenu.min","kendo.groupable.min","kendo.pager.min","kendo.selectable.min","kendo.sortable.min","kendo.reorderable.min","kendo.resizable.min","kendo.mobile.actionsheet.min","kendo.mobile.pane.min","kendo.ooxml.min","kendo.excel.min","kendo.progressbar.min","kendo.pdf.min"],e)}(function(){return function(e,t){function n(e,t){return"["+pe.attr(e)+"="+t+"]"}function i(e){return Array(e+1).join('<td class="k-group-cell">&nbsp;</td>')}function o(e){var t,n=" ";if(e){if(typeof e===Mt)return e;for(t in e)""!==e[t]&&(n+=t+'="'+e[t]+'"')}return n}function r(t,n){e("th, th .k-grid-filter, th .k-link",t).add(document.body).css("cursor",n)}function s(t,n,i,o,r){var s,a=n;for(n=e(),r=r||1,s=0;s<r;s++)n=n.add(t.eq(a+s));"number"==typeof i?n[o?"insertBefore":"insertAfter"](t.eq(i)):n.appendTo(i)}function a(t,n,i){return e(t).add(n).find(i)}function l(e,t,n){var i,o,r,s;for(n=Ae(n)?n:[n],i=0,o=n.length;i<o;i++)r=n[i],Ce(r)&&r.click&&(s=r.name||r.text,t.on(Dt+$e,"a.k-grid-"+(s||"").replace(/\s/g,""),{commandName:s},Me(r.click,e)))}function c(e,t,n){return Te(e,function(e){var i,o;return e=typeof e===Mt?{field:e}:e,p(e)&&!n||(e.attributes=q(e.attributes),e.footerAttributes=q(e.footerAttributes),e.headerAttributes=q(e.headerAttributes),i=!0),e.columns&&(e.columns=c(e.columns,t,i)),o=pe.guid(),e.headerAttributes=Se({id:o},e.headerAttributes),Se({encoded:t,hidden:i},e)})}function d(e,t){var n=[];return u(e,t,n),n[n.length-1]}function u(e,t,n){var i,o;for(n=n||[],i=0;i<t.length;i++){if(e===t[i])return!0;if(t[i].columns){if(o=n.length,n.push(t[i]),u(e,t[i].columns,n))return!0;n.splice(o,n.length-o)}}return!1}function h(e,t){var n=t?G:q;e.hidden=!t,e.attributes=n(e.attributes),e.footerAttributes=n(e.footerAttributes),e.headerAttributes=n(e.headerAttributes)}function f(){return"none"!==this.style.display}function p(e){return m([e]).length>0}function m(e){return De(e,function(e){var t=!e.hidden;return t&&e.columns&&(t=m(e.columns).length>0),t})}function g(t){return e(t).map(function(){return this.toArray()})}function v(e,t,n){var i=w(P(t)),o=w(B(t)),r=e.rowSpan;e.rowSpan=n?i>o?r-(i-o)||1:r+(o-i):i>o?r+(i-o):r-(o-i)||1}function _(t,n,i,o,r,s,a){var l,c,d=w(t),u=w([n]);d>u&&(l=Array(a+1).join('<th class="k-group-cell k-header" scope="col">&nbsp;</th>'),c=s.children(":not(.k-filter-row)"),e(Array(d-u+1).join("<tr>"+l+"</tr>")).insertAfter(c.last())),R(s,d-u),y(i,o,r,s)}function b(t,n,i){var o,r,s,a,l,c,d,u;for(i=i||0,s=n,n=O(n),a={},l=t.find(">tr:not(.k-filter-row)"),c=function(){var t=e(this);return!t.hasClass("k-group-cell")&&!t.hasClass("k-hierarchy-cell")},d=0,u=n.length;d<u;d++)o=k(n[d],s),a[o.row]||(a[o.row]=l.eq(o.row).find(".k-header").filter(c)),r=a[o.row].eq(o.cell),r.attr(pe.attr("index"),i+d);return n.length}function w(e){var t,n,i=1,o=0;for(t=0;t<e.length;t++)e[t].columns&&(n=w(e[t].columns),n>o&&(o=n));return i+o}function y(t,n,i,o){var r,s,a=S(t[0],n),l=i.find(">tr:not(.k-filter-row):eq("+a.row+")>th.k-header"),c=e(),d=a.cell;for(r=0;r<t.length;r++)c=c.add(l.eq(d+r));for(o.find(">tr:not(.k-filter-row)").eq(a.row).append(c),s=[],r=0;r<t.length;r++)t[r].columns&&(s=s.concat(t[r].columns));s.length&&y(s,n,i,o)}function k(e,t,n,i){var o,r;for(n=n||0,i=i||{},i[n]=i[n]||0,r=0;r<t.length;r++){if(t[r]==e){o={cell:i[n],row:n};break}if(t[r].columns&&(o=k(e,t[r].columns,n+1,i)))break;i[n]++}return o}function x(e,t,n,i){var o,r=n.locked;do o=e[t],t+=i?1:-1;while(o&&t>-1&&t<e.length&&o!=n&&!o.columns&&o.locked==r);return o}function C(e,t,n,i){var o,r,s,a;return t.columns?(t=t.columns,t[i?0:t.length-1]):(o=d(t,e),r=o?o.columns:e,s=Ee(t,r),0===s&&i?s++:s!=r.length-1||i?(s>0||0===s&&!i)&&(s+=i?-1:1):s--,a=Ee(n,r),t=x(r,s,n,a>s),t&&t!=n&&t.columns?C(e,t,n,i):null)}function S(e,t,n,i){var o,r;for(n=n||0,i=i||{},i[n]=i[n]||0,r=0;r<t.length;r++){if(t[r]==e){o={cell:i[n],row:n};break}if(t[r].columns&&(o=S(e,t[r].columns,n+1,i)))break;t[r].hidden||i[n]++}return o}function T(e){var t=A(P(e));return t.concat(A(B(e)))}function D(e,t,n,i){var o=e[n],r=e[i],s=d(o,t);return t=s?s.columns:t,Ee(r,t)}function A(e){var t,n=[],i=[];for(t=0;t<e.length;t++)n.push(e[t]),e[t].columns&&(i=i.concat(e[t].columns));return i.length&&(n=n.concat(A(i))),n}function E(e){var t,n,i=0;for(n=0;n<e.length;n++)t=e[n],t.columns?i+=E(t.columns):t.hidden&&i++;return i}function I(e){var t,n,i,o=0;for(n=0,i=e.length;n<i;n++)t=e[n].style.width,t&&t.indexOf("%")==-1&&(o+=parseInt(t,10));return o}function M(e,t){var n,i,o=e.find("tr:not(.k-filter-row) th:not(.k-group-cell,.k-hierarchy-cell)");for(i=0;i<o.length;i++)n=o[i].rowSpan,n>1&&(o[i].rowSpan=n-t||1)}function R(e,t){var n,i=e.find("tr:not(.k-filter-row) th:not(.k-group-cell,.k-hierarchy-cell)");for(n=0;n<i.length;n++)i[n].rowSpan+=t}function F(t){var n,i=t.find("tr:not(.k-filter-row)"),o=i.filter(function(){return!e(this).children().length}).remove().length,r=i.find("th:not(.k-group-cell,.k-hierarchy-cell)");for(n=0;n<r.length;n++)r[n].rowSpan>1&&(r[n].rowSpan-=o);return i.length-o}function z(e,t,n,i,o){var r,s,a,l=[];for(r=0,a=e.length;r<a;r++)s=n[i]||[],s.push(t.eq(o+r)),n[i]=s,e[r].columns&&(l=l.concat(e[r].columns));l.length&&z(l,t,n,i+1,o+e.length)}function P(e){return De(e,function(e){return e.locked})}function B(e){return De(e,function(e){return!e.locked})}function L(e){return De(e,function(e){return!e.locked&&p(e)})}function H(e){return De(e,function(e){return e.locked&&p(e)})}function N(e){var t,n=[];for(t=0;t<e.length;t++)e[t].hidden||(e[t].columns?n=n.concat(N(e[t].columns)):n.push(e[t]));return n}function O(e){var t,n=[];for(t=0;t<e.length;t++)e[t].columns?n=n.concat(O(e[t].columns)):n.push(e[t]);return n}function V(n){var i,o=n.find(">tr:not(.k-filter-row)"),r=function(){var t=e(this);return!t.hasClass("k-group-cell")&&!t.hasClass("k-hierarchy-cell")},s=e();return o.length>1&&(s=o.find("th").filter(r).filter(function(){return this.rowSpan>1})),s=s.add(o.last().find("th").filter(r)),i=pe.attr("index"),s.sort(function(n,o){var r,s;return n=e(n),o=e(o),r=n.attr(i),s=o.attr(i),r===t&&(r=e(n).index()),s===t&&(s=e(o).index()),r=parseInt(r,10),s=parseInt(s,10),r>s?1:r<s?-1:0}),s}function U(t){var n,i,o,r,s,a,l,c=t.closest("table"),d=e().add(t),u=t.closest("tr"),h=c.find("tr:not(.k-filter-row)"),f=h.index(u);if(f>0){for(n=h.eq(f-1),i=n.find("th:not(.k-group-cell,.k-hierarchy-cell)").filter(function(){return!e(this).attr("rowspan")}),o=0,r=u.find("th:not(.k-group-cell,.k-hierarchy-cell)").index(t),s=t.prevAll(":not(.k-group-cell,.k-hierarchy-cell)").filter(function(){return this.colSpan>1}),a=0;a<s.length;a++)o+=s[a].colSpan||1;for(r+=Math.max(o-1,0),o=0,a=0;a<i.length;a++)if(l=i.eq(a),o+=l.attr("data-colspan")?l[0].getAttribute("data-colspan"):1,r>=a&&r<o){d=U(l).add(d);break}}return d}function W(t){var n,i,o,r,s,a,l,c=t.closest("thead"),d=e().add(t),u=t.closest("tr"),h=c.find("tr:not(.k-filter-row)"),f=h.index(u)+t[0].rowSpan,p=pe.attr("colspan");if(f<=h.length-1){for(n=u.next(),i=t.prevAll(":not(.k-group-cell,.k-hierarchy-cell)"),i=i.filter(function(){return!this.rowSpan||1===this.rowSpan}),r=0,o=0;o<i.length;o++)r+=parseInt(i.eq(o).attr(p),10)||1;for(s=n.find("th:not(.k-group-cell,.k-hierarchy-cell)"),a=parseInt(t.attr(p),10)||1,o=0;o<a;)n=s.eq(o+r),d=d.add(W(n)),l=parseInt(n.attr(p),10),l>1&&(a-=l-1),o++}return d}function j(t,n,i,o){var r,s=t;return o&&t.empty(),_e?t[0].innerHTML=i:(r=document.createElement("div"),r.innerHTML="<table><tbody>"+i+"</tbody></table>",t=r.firstChild.firstChild,n[0].replaceChild(t,s[0]),t=e(t)),t}function q(e){e=e||{};var t=e.style;return t?(t=t.replace(/((.*)?display)(.*)?:([^;]*)/i,"$1:none"),t===e.style&&(t=t.replace(/(.*)?/i,"display:none;$1"))):t="display:none",Se({},e,{style:t})}function G(e){e=e||{};var t=e.style;return t&&(e.style=t.replace(/(display\s*:\s*none\s*;?)*/gi,"")),e}function $(t,n,i,o){var r,s=t.find(">colgroup"),a=Te(n,function(e){return r=e.width,r&&0!==parseInt(r,10)?pe.format('<col style="width:{0}"/>',typeof r===Mt?r:r+"px"):"<col />"});(i||s.find(".k-hierarchy-col").length)&&a.splice(0,0,'<col class="k-hierarchy-col" />'),s.length&&s.remove(),s=e(Array(o+1).join('<col class="k-group-col">')+a.join("")),s.is("colgroup")||(s=e("<colgroup/>").append(s)),t.prepend(s),tn.msie&&8==tn.version&&(t.css("display","inline-table"),window.setTimeout(function(){t.css("display","")},1))}function K(e,t){var n,i,o=0,r=e.find("th:not(.k-group-cell)");for(n=0,i=t.length;n<i;n++)t[n].locked&&(r.eq(n).insertBefore(r.eq(o)),r=e.find("th:not(.k-group-cell)"),o++)}function Y(e){var t,n,i,o={};for(n=0,i=e.length;n<i;n++)t=e[n],o[t.value]=t.text;return o}function Q(e,t,n,i){var o=n&&n.length&&Ce(n[0])&&"value"in n[0],r=o?Y(n)[e]:e;return r=null!=r?r:"",t?pe.format(t,r):i===!1?r:pe.htmlEncode(r)}function X(e,t,n){for(var i,o=0,r=e[o];r;){if(i=!!n||"none"!==r.style.display,i&&!Yt.test(r.className)&&--t<0){r.style.display=n?"":"none";break}r=e[++o]}}function Z(t,n){for(var i,o,r=0,s=t.length;r<s;r+=1)o=t.eq(r),o.is(".k-grouping-row,.k-detail-row")?(i=o.children(":not(.k-group-cell):first,.k-detail-cell").last(),i.attr("colspan",parseInt(i.attr("colspan"),10)-1)):(o.hasClass("k-grid-edit-row")&&(i=o.children(".k-edit-container")[0])&&(i=e(i),i.attr("colspan",parseInt(i.attr("colspan"),10)-1),i.find("col").eq(n).remove(),o=i.find("tr:first")),X(o[0].cells,n,!1))}function J(e){var t,n,i=[];for(n=0;n<e.length&&(t=e[n],"field"in t&&"value"in t&&"items"in t);n++)i.push(t),t.hasSubgroups&&(i=i.concat(J(t.items)));return i}function ee(e){var t,n,i=[];for(n=0;n<e.length&&(t=e[n],"field"in t&&"value"in t&&"items"in t);n++)t.hasSubgroups&&(i=i.concat(ee(t.items))),i.push(t.aggregates);return i}function te(t,n){for(var i,o,r,s=0,a=t.length;s<a;s+=1)o=t.eq(s),o.is(".k-grouping-row,.k-detail-row")?(i=o.children(":not(.k-group-cell):first,.k-detail-cell").last(),i.attr("colspan",parseInt(i.attr("colspan"),10)+1)):(o.hasClass("k-grid-edit-row")&&(i=o.children(".k-edit-container")[0])&&(i=e(i),i.attr("colspan",parseInt(i.attr("colspan"),10)+1),$(i.find(">form>table"),m(r),!1,0),o=i.find("tr:first")),X(o[0].cells,n,!0))}function ne(e,t,n){n=n||1;var i,o,r;for(o=0,r=e.length;o<r;o++)i=e.eq(o).children().last(),i.attr("colspan",parseInt(i.attr("colspan"),10)+n),i=t.eq(o).children().last(),i.attr("colspan",parseInt(i.attr("colspan"),10)-n)}function ie(e){var t,n,i=0,o=e.find(">colgroup>col");for(t=0,n=o.length;t<n;t+=1)i+=parseInt(o[t].style.width,10);return i}function oe(e,t){var n,i,o,r;e=e[0],t=t[0],e.rows.length!==t.rows.length&&(n=e.offsetHeight,i=t.offsetHeight,n>i?(o=t.rows[t.rows.length-1],Qt.test(o.className)&&(o=t.rows[t.rows.length-2]),r=n-i):(o=e.rows[e.rows.length-1],Qt.test(o.className)&&(o=e.rows[e.rows.length-2]),r=i-n),o.style.height=o.offsetHeight+r+"px")}function re(e,t){var n,i=e.offsetHeight,o=t.offsetHeight;i>o?n=i+"px":i<o&&(n=o+"px"),n&&(e.style.height=t.style.height=n)}function se(e,t){var n,i,o;if(typeof e===Mt&&e===t)return e;if(Ce(e)&&e.name===t)return e;if(Ae(e))for(n=0,i=e.length;n<i;n++)if(o=e[n],typeof o===Mt&&o===t||o.name===t)return o;return null}function ae(t,n){if(n===!0){t=e(t);var i=t.parent().scrollLeft();pe.focusElement(t),t.parent().scrollLeft(i)}else e(t).one("focusin",function(e){e.preventDefault()}).focus()}function le(e,t){return!(!e.field||e.selectable)&&(!(t.editable&&!t.editable(e.field))&&!(e.editable&&!e.editable(t)))}function ce(t){return e(t).is(":button,a,:input,a>.k-icon,textarea,span.k-select,span.k-icon,span.k-link,label.k-checkbox-label,.k-input,.k-multiselect-wrap,.k-picker-wrap,.k-picker-wrap>.k-selected-color,.k-tool-icon,.k-dropdown")}function de(n){var i=e(n.currentTarget),o=i.is("th"),r=this.table.add(this.lockedTable),s=this.thead.parent().add(e(">table",this.lockedHeader)),a=ce(n.target),l=e(n.target),c=i.closest("table")[0];if(!pe.support.touch)return a&&i.find(pe.roleSelector("filtercell")).length?(this._setCurrent(i),t):(c!==r[0]&&c!==r[1]&&c!==s[0]&&c!==s[1]||l.is("a.k-i-expand, a.k-i-collapse")||(this.options.navigatable&&this._setCurrent(i),!o&&a||setTimeout(function(){on&&e(pe._activeElement()).hasClass("k-widget")||ce(pe._activeElement())&&e.contains(c,pe._activeElement())||ae(c,!0)}),o&&n.preventDefault()),t)}function ue(e){return e&&(e.hasClass("k-edit-cell")||e.parent().hasClass("k-grid-edit-row"))}function he(e,t,n){return'<tr role="row" class="k-grouping-row">'+i(t)+'<td colspan="'+e+'" aria-expanded="true"><p class="k-reset"><a class="k-icon k-i-collapse" href="#" tabindex="-1" '+qt+'="'+Wt+'"></a>'+n+"</p></td></tr>"}function fe(e){return'<tr role="row" class="k-grouping-row"><td colspan="'+e+'" aria-expanded="true"><p class="k-reset">&nbsp;</p></td></tr>'}var pe=window.kendo,me=pe.ui,ge=pe.data.DataSource,ve=pe.data.ObservableObject,_e=pe.support.tbodyInnerHtml,be=pe._activeElement,we=me.Widget,ye=pe._outerWidth,ke=pe._outerHeight,xe=pe.keys,Ce=e.isPlainObject,Se=e.extend,Te=e.map,De=e.grep,Ae=e.isArray,Ee=e.inArray,Ie=Array.prototype.push,Me=e.proxy,Re=pe.isFunction,Fe=e.isEmptyObject,ze=e.contains,Pe=Math,Be="progress",Le="error",He=":not(.k-group-cell):not(.k-hierarchy-cell):visible",Ne="tbody>tr:not(.k-grouping-row):not(.k-detail-row):not(.k-group-footer) > td:not(.k-group-cell):not(.k-hierarchy-cell)",Oe="tr:not(.k-footer-template):visible",Ve=":not(.k-group-cell):not(.k-hierarchy-cell):visible",Ue="tr:not(.k-grouping-row):not(.k-detail-row):not(.k-footer-template):not(.k-group-footer):visible",We=Ue+":first",je=Ue+":last",qe=Oe+":first>"+Ve+":first",Ge="th.k-header:not(.k-group-cell):not(.k-hierarchy-cell)",$e=".kendoGrid",Ke="edit",Ye="beforeEdit",Qe="save",Xe="remove",Ze="detailInit",Je="filterMenuInit",et="columnMenuInit",tt="filterMenuOpen",nt="columnMenuOpen",it="cellClose",ot="change",rt="columnHide",st="columnShow",at="saveChanges",lt="dataBound",ct="detailExpand",dt="detailCollapse",ut="itemchange",ht="page",ft="paging",pt="scroll",mt="sync",gt="k-state-focused",vt=":kendoFocusable",_t="k-state-selected",bt="k-checkbox",wt="input[data-role='checkbox']."+bt,yt="k-grid-norecords",kt="columnResize",xt="columnReorder",Ct="columnLock",St="columnUnlock",Tt="navigate",Dt="click",At="height",Et="tabIndex",It="function",Mt="string",Rt="bottom",Ft="container-for",zt="field",Pt="input",Bt="incell",Lt="inline",Ht="uid",Nt="Are you sure you want to delete this record?",Ot="No records available.",Vt="Delete",Ut="Cancel",Wt="Collapse",jt="Expand",qt="aria-label",Gt=/(\}|\#)/gi,$t=/#/gi,Kt="[\\x20\\t\\r\\n\\f]",Yt=RegExp("(^|"+Kt+")(k-group-cell|k-hierarchy-cell)("+Kt+"|$)"),Qt=RegExp("(^|"+Kt+")(k-filter-row)("+Kt+"|$)"),Xt='# if (iconClass) {#<a role="button" class="k-button k-button-icontext #=className#" #=attr# href="\\#"><span class="#=iconClass#"></span>#=text#</a># } else { #<a role="button" class="k-button k-button-icontext #=className#" #=attr# href="\\#">#=text#</a># } #',Zt='# var checkboxGuid = kendo.guid(); #<input class="'+bt+'" data-role="checkbox" id="#= checkboxGuid #" aria-label="Select row" aria-checked="false" type="checkbox"><label for="#= checkboxGuid #" class="k-checkbox-label k-no-text">&\\#8203;</label>',Jt='# var checkboxGuid = kendo.guid(); #<input class="'+bt+'" data-role="checkbox" aria-label="Select all rows" aria-checked="false" type="checkbox" id="#= checkboxGuid #"><label for="#= checkboxGuid #" class="k-checkbox-label k-no-text">##&\\#8203;##</label>',en=!1,tn=pe.support.browser,nn=tn.msie&&7==tn.version,on=tn.msie&&8==tn.version,rn=we.extend({init:function(e,t){var n=this;we.fn.init.call(n,e,t),n._refreshHandler=Me(n.refresh,n),n.setDataSource(t.dataSource),n.wrap()},setDataSource:function(e){var t=this;t.dataSource&&t.dataSource.unbind(ot,t._refreshHandler),t.dataSource=e,t.dataSource.bind(ot,t._refreshHandler),t.dataSource.options.useRanges=!0},options:{name:"VirtualScrollable",itemHeight:e.noop,prefetch:!0,maxScrollHeight:25e4},events:[ft,ht,pt],destroy:function(){var e=this;we.fn.destroy.call(e),e.dataSource.unbind(ot,e._refreshHandler),e.wrapper.add(e.verticalScrollbar).off($e),e.drag&&(e.drag.destroy(),e.drag=null),e.wrapper=e.element=e.verticalScrollbar=null,e._refreshHandler=null},wrap:function(){var t,n=this,i=pe.support.scrollbar()+1,o=n.element;o.css({width:"auto",overflow:"hidden"}).css(en?"padding-left":"padding-right",i),n.content=o.children().first(),t=n.wrapper=n.content.wrap('<div class="k-virtual-scrollable-wrap"/>').parent().bind("DOMMouseScroll"+$e+" mousewheel"+$e,Me(n._wheelScroll,n)),pe.support.kineticScrollNeeded&&(n.drag=new pe.UserEvents(n.wrapper,{global:!0,allowSelection:!0,start:function(e){e.sender.capture()},move:function(e){n.verticalScrollbar.scrollTop(n.verticalScrollbar.scrollTop()-e.y.delta),t.scrollLeft(t.scrollLeft()-e.x.delta),e.preventDefault()}})),n.verticalScrollbar=e('<div class="k-scrollbar k-scrollbar-vertical" />').css({width:i}).appendTo(o).bind("scroll"+$e,Me(n._scroll,n))},_wheelScroll:function(e){if(!e.ctrlKey){var t=this.verticalScrollbar,n=t.scrollTop(),i=pe.wheelDeltaY(e);!i||i>0&&0===n||i<0&&n+t[0].clientHeight==t[0].scrollHeight||(e.preventDefault(),this.verticalScrollbar.scrollTop(n+-i))}},_scroll:function(e){var n=this,i=!n.options.prefetch,o=e.currentTarget.scrollTop,r=n.dataSource,s=n.itemHeight,a=r.skip()||0,l=n._rangeStart||a,c=n.element.innerHeight(),d=!!(n._scrollbarTop&&n._scrollbarTop>o),u=Pe.max(Pe.floor(o/s),0),h=d?Pe.ceil(c/s):Pe.floor(c/s),f=Pe.max(u+h,0);return n._preventScroll?(n._preventScroll=!1,t):(n._scrollTop=o-l*s,n._scrollbarTop=o,n._scrolling=i,n._fetch(u,f,d)||(n.wrapper[0].scrollTop=n._scrollTop),n.trigger(pt),i&&(n._scrollingTimeout&&clearTimeout(n._scrollingTimeout),n._scrollingTimeout=setTimeout(function(){n._scrolling=!1,n._page(n._rangeStart,n.dataSource.take())},100)),t)},scrollToTop:function(){this._scrollTo(0)},scrollToBottom:function(){var e=this.verticalScrollbar;this._scrollTo(e[0].scrollHeight-e.height())},_scrollWrapperToTop:function(){this.wrapper.scrollTop(0)},_scrollWrapperToBottom:function(){this.wrapper.scrollTop(this.wrapper[0].scrollHeight)},_scrollWrapperOnColumnResize:function(){var e=this,t=this.wrapper,n=t.scrollTop();t[0].scrollWidth>t[0].clientWidth?e._wrapperScrolled&&!e._isScrolledToBottom()||(t.scrollTop(n+pe.support.scrollbar()),e._scrollTop=t.scrollTop(),e._wrapperScrolled=!0):e._wrapperScrolled&&(e._isWrapperScrolledToBottom()||(t.scrollTop(n-pe.support.scrollbar()),e._scrollTop=t.scrollTop()),e._wrapperScrolled=!1)},_scrollTo:function(e){var t=this,n=t.verticalScrollbar;n.scrollTop()!==e&&(t._preventScroll=!0),t.wrapper.scrollTop(e),t._scrollTop=t.wrapper.scrollTop(),n.scrollTop(e),t._scrollbarTop=n.scrollTop()},_isScrolledToTop:function(){return 0===this.verticalScrollbar.scrollTop()},_isScrolledToBottom:function(){var e=this.verticalScrollbar,t=e.scrollTop();return t>0&&t>=parseInt(e[0].scrollHeight-e.height(),10)},_isWrapperScrolledToBottom:function(){var e=this.wrapper;return e.scrollTop()>=parseInt(e[0].scrollHeight-e.height(),10)},itemIndex:function(e){var t=this._rangeStart||this.dataSource.skip()||0;return t+e},_isElementVisible:function(e){return this._isElementVisibleInWrapper(e)},_isElementVisibleInWrapper:function(t){var n,i,o=this,r=o.wrapper;return t=e(t),!!(t[0]&&ze(r[0],t[0])&&(n=parseInt(t.position().top,10),i=t.outerHeight()/2,(n>=0||Pe.abs(n)<=i)&&n+i<=r.height()))},position:function(e){var t,n=this._rangeStart||this.dataSource.skip()||0,i=this.dataSource.pageSize();return t=e>n?e-n+1:n-e-1,t>i?i:t},scrollIntoView:function(e){var t=this.wrapper[0],n=t.clientHeight,i=this._isScrolledToBottom()?t.scrollTop:this._scrollTop||t.scrollTop,o=e[0].offsetTop,r=e[0].offsetHeight;i>o?this.verticalScrollbar[0].scrollTop-=n/2:o+r>=i+n&&(this.verticalScrollbar[0].scrollTop+=n/2)},_fetch:function(t,n,i){var o=this,r=o.dataSource,s=o.itemHeight,a=r.take(),l=o._rangeStart||r.skip()||0,c=Pe.floor(t/a)*a,d=!1,u=.33,h=o.verticalScrollbar,f=tn.webkit?1:0;return t<l?(d=!0,l=Pe.max(0,n-a),o._scrollTop=h.scrollTop()-l*s,o._page(l,a)):n>=l+a&&!i?(d=!0,l=Pe.min(t,r.total()-a),o._scrollTop=h.scrollTop()>=h[0].scrollHeight-h.height()-f?o.wrapper[0].scrollHeight-o.wrapper.height():s,o._page(l,a)):!o._fetching&&o.options.prefetch&&(t<c+a-a*u&&t>a&&r.prefetch(c-a,a,e.noop),n>c+a*u&&r.prefetch(c+a,a,e.noop)),d},fetching:function(){return this._fetching},_page:function(t,n,i){var o=this,r=!o.options.prefetch,s=o.dataSource;i=Re(i)?i:e.noop,o.trigger(ft,{skip:t,take:n})||(clearTimeout(o._timeout),o._fetching=!0,o._rangeStart=t,s.inRange(t,n)?(pe.ui.progress(e(o.wrapper).parent(),!0),s.range(t,n,function(){pe.ui.progress(e(o.wrapper).parent(),!1),i(),o.trigger(ht)})):(r||pe.ui.progress(o.wrapper.parent(),!0),o._timeout=setTimeout(function(){o._scrolling||(r&&pe.ui.progress(o.wrapper.parent(),!0),s.range(t,n,function(){pe.ui.progress(o.wrapper.parent(),!1),i(),o.trigger(ht)}))},100)))},repaintScrollbar:function(e){var n,i=this,o="",r=i.options.maxScrollHeight,s=i.dataSource,a=pe.support.kineticScrollNeeded?0:pe.support.scrollbar(),l=i.wrapper[0],c=i._isScrolledToBottom(),d=i.itemHeight=i.options.itemHeight()||0,u=l.scrollWidth>l.offsetWidth?a:0,h=s.total()*d+u;for(n=0;n<Pe.floor(h/r);n++)o+='<div style="width:1px;height:'+r+'px"></div>';h%r&&(o+='<div style="width:1px;height:'+h%r+'px"></div>'),i.verticalScrollbar.html(o),c&&!i._isScrolledToBottom()&&i.scrollToBottom(),t!==i._scrollTop&&e&&(l.scrollTop=i._scrollTop,i._scrollWrapperOnColumnResize())},refresh:function(e){var n=this,i=n.dataSource,o=n._rangeStart,r=(e||{}).action,s=n._isScrolledToBottom()||!r||r!==ut&&r!==Xe&&r!==mt;pe.ui.progress(n.wrapper.parent(),!1),clearTimeout(n._timeout),n.repaintScrollbar(s),n.drag&&n.drag.cancel(),t===o||n._fetching||((!r||r!==mt&&r!==ut)&&(n._rangeStart=i.skip()),1!==i.page()||r&&(r===mt||r===ut)||(n.verticalScrollbar[0].scrollTop=0)),n._fetching=!1}}),sn={create:{text:"Add new record",className:"k-grid-add",iconClass:"k-icon k-i-plus"},cancel:{text:"Cancel changes",className:"k-grid-cancel-changes",iconClass:"k-icon k-i-cancel"},save:{text:"Save changes",className:"k-grid-save-changes",iconClass:"k-icon k-i-check"},destroy:{text:"Delete",className:"k-grid-delete",iconClass:"k-icon k-i-close"},edit:{text:"Edit",className:"k-grid-edit",iconClass:"k-icon k-i-edit"},update:{text:"Update",className:"k-primary k-grid-update",iconClass:"k-icon k-i-check"},canceledit:{text:"Cancel",className:"k-grid-cancel",iconClass:"k-icon k-i-cancel"},excel:{text:"Export to Excel",className:"k-grid-excel",iconClass:"k-icon k-i-file-excel"},pdf:{text:"Export to PDF",className:"k-grid-pdf",iconClass:"k-icon k-i-file-pdf"}},an=pe.ui.DataBoundWidget.extend({init:function(t,n,i){var o=this;n=Ae(n)?{dataSource:n}:n,we.fn.init.call(o,t,n),i&&(o._events=i),en=pe.support.isRtl(t),o._element(),o._aria(),o._columns(e.extend(!0,[],o.options.columns)),o._dataSource(),o._tbody(),o._pageable(),o._thead(),o._groupable(),o._toolbar(),o._setContentHeight(),o._templates(),o._navigatable(),o._selectable(),o._clipboard(),o._details(),o._editable(),o._attachCustomCommandsEvent(),o._minScreenSupport(),o.options.autoBind?o.dataSource.fetch():(o._group=o._groups()>0,o._footer()),o.lockedContent&&(o.wrapper.addClass("k-grid-lockedcolumns"),o._resizeHandler=function(){o.resize()},e(window).on("resize"+$e,o._resizeHandler)),pe.notify(o)},events:[ot,"dataBinding","cancel",lt,ct,dt,Ze,Je,tt,et,nt,Ke,Ye,Qe,Xe,at,it,kt,xt,st,rt,Ct,St,Tt,"page","sort","filter","group","groupExpand","groupCollapse"],setDataSource:function(e){var t=this,n=t.options.scrollable;t.options.dataSource=e,t._dataSource(),t._pageable(),t._thead(),n&&(n.virtual?t.content.find(">.k-virtual-scrollable-wrap").scrollLeft(0):t.content.scrollLeft(0)),t.options.groupable&&t._groupable(),t.virtualScrollable&&t.virtualScrollable.setDataSource(t.options.dataSource),t.options.navigatable&&t._navigatable(),t.options.selectable&&t._selectable(),t.options.autoBind&&e.fetch()},options:{name:"Grid",columns:[],toolbar:null,autoBind:!0,filterable:!1,scrollable:!0,sortable:!1,selectable:!1,allowCopy:!1,navigatable:!1,pageable:!1,persistSelection:!1,editable:!1,groupable:!1,rowTemplate:"",altRowTemplate:"",noRecords:!1,dataSource:{},height:null,resizable:!1,reorderable:!1,columnMenu:!1,detailTemplate:null,columnResizeHandleWidth:3,mobile:"",messages:{editable:{cancelDelete:Ut,confirmation:Nt,confirmDelete:Vt},commands:{create:sn.create.text,cancel:sn.cancel.text,save:sn.save.text,destroy:sn.destroy.text,edit:sn.edit.text,update:sn.update.text,canceledit:sn.canceledit.text,excel:sn.excel.text,pdf:sn.pdf.text},noRecords:Ot,expandCollapseColumnHeader:""}},destroy:function(){var t,n=this;n._angularItems("cleanup"),n._destroyColumnAttachments(),we.fn.destroy.call(n),this._navigatableTables=null,n._resizeHandler&&e(window).off("resize"+$e,n._resizeHandler),n.pager&&n.pager.element&&n.pager.destroy(),n.pager=null,n.groupable&&n.groupable.element&&n.groupable.element.kendoGroupable("destroy"),n.groupable=null,n.options.reorderable&&n.wrapper.data("kendoReorderable").destroy(),n.selectable&&n.selectable.element&&(n.selectable.destroy(),n.clearArea(),n.options.persistSelection===!0&&(n._selectedIds=null),n.copyHandler&&(n.wrapper.off("keydown",n.copyHandler),n.unbind(n.copyHandler)),n.updateClipBoardState&&(n.unbind(n.updateClipBoardState),n.updateClipBoardState=null),n.clearAreaHandler&&n.wrapper.off("keyup",n.clearAreaHandler)),n.selectable=null,n.resizable&&(n.resizable.destroy(),n._resizeUserEvents&&(n._resizeHandleDocumentClickHandler&&e(document).off("click",n._resizeHandleDocumentClickHandler),n._resizeUserEvents.destroy(),n._resizeUserEvents=null),n.resizable=null),n._destroyVirtualScrollable(),n._destroyEditable(),n.dataSource&&(n.dataSource.unbind(ot,n._refreshHandler).unbind(Be,n._progressHandler).unbind(Le,n._errorHandler),n._refreshHandler=n._progressHandler=n._errorHandler=null),t=n.element.add(n.wrapper).add(n.table).add(n.thead).add(n.wrapper.find(">.k-grid-toolbar")),n.content&&(t=t.add(n.content).add(n.content.find(">.k-virtual-scrollable-wrap"))),n.lockedHeader&&n._removeLockedContainers(),n.pane&&n.pane.destroy(),n.minScreenResizeHandler&&e(window).off("resize",n.minScreenResizeHandler),n._draggableInstance&&n._draggableInstance.element&&n._draggableInstance.destroy(),n._draggableInstance=null,t.off($e),pe.destroy(n.wrapper),n.rowTemplate=n.altRowTemplate=n.lockedRowTemplate=n.lockedAltRowTemplate=n.detailTemplate=n.footerTemplate=n.groupFooterTemplate=n.lockedGroupFooterTemplate=n.noRecordsTemplate=null,n.scrollables=n.thead=n.tbody=n.element=n.table=n.content=n.footer=n.wrapper=n.lockedTable=n.lockedContent=n.lockedHeader=n.lockedFooter=n._groupableClickHandler=n._groupRows=n._setContentWidthHandler=null},getOptions:function(){var n,i,o,r=this.options;return r.dataSource=null,n=Se(!0,{},this.options),n.columns=pe.deepExtend([],this.columns),i=this.dataSource,o=i.options.data&&i._data,i.options.data=null,n.dataSource=e.extend(!0,{},i.options),i.options.data=o,n.dataSource.data=o,n.dataSource.page=i.page(),n.dataSource.filter=i.filter(),n.dataSource.pageSize=i.pageSize(),n.dataSource.sort=i.sort(),n.dataSource.group=i.group(),n.dataSource.aggregate=i.aggregate(),n.dataSource.transport&&(n.dataSource.transport.dataSource=null),n.pageable&&n.pageable.pageSize&&(n.pageable.pageSize=i.pageSize()),n.$angular=t,n;
},setOptions:function(e){var t,n,i,o,r=this.getOptions();pe.deepExtend(r,e),e.dataSource||(r.dataSource=this.dataSource),t=this.wrapper,n=this._events,i=this.element,this.destroy(),this.options=null,this._isMobile&&(o=t.closest(pe.roleSelector("pane")).parent(),o.after(t),o.remove(),t.removeClass("k-grid-mobile")),t[0]!==i[0]&&(t.before(i),t.remove()),i.empty(),this.init(i,r,n),this._setEvents(r)},items:function(){return this.lockedContent?this._items(this.tbody).add(this._items(this.lockedTable.children("tbody"))):this._items(this.tbody)},_items:function(t){return t.children().filter(function(){var t=e(this);return!t.hasClass("k-grouping-row")&&!t.hasClass("k-detail-row")&&!t.hasClass("k-group-footer")})},dataItems:function(){var e,t,n,i=pe.ui.DataBoundWidget.fn.dataItems.call(this);if(this.lockedContent){for(e=i.length,t=Array(2*e),n=e;--n>=0;)t[n]=t[n+e]=i[n];i=t}return i},_destroyColumnAttachments:function(){var t=this;t.resizeHandle=null,t.thead&&(this.angular("cleanup",function(){return{elements:t.thead.get()}}),t.thead.add(t.lockedHeader).find("th").each(function(){var t=e(this),n=t.data("kendoFilterMenu"),i=t.data("kendoColumnSorter"),o=t.data("kendoColumnMenu");n&&n.destroy(),i&&i.destroy(),o&&o.destroy()}))},_attachCustomCommandsEvent:function(){var e,t,n,i=this,o=O(i.columns||[]);for(t=0,n=o.length;t<n;t++)e=o[t].command,e&&l(i,i.wrapper,e)},_aria:function(){var e=this.element.attr("id")||"aria";e&&(this._cellId=e+"_active_cell")},_element:function(){var t=this,n=t.element;n.is("table")||(n=t.options.scrollable?t.element.find("> .k-grid-content > table"):t.element.children("table"),n.length||(n=e("<table />").appendTo(t.element))),nn&&n.attr("cellspacing",0),t.table=n.attr("role",t._hasDetails()?"treegrid":"grid"),t._wrapper()},_createResizeHandle:function(t,n){var i,o,r,s,a,l,c,d=this,u=d.options.columnResizeHandleWidth,h=d.options.scrollable,f=d.resizeHandle,p=this._groups();if(f&&d.lockedContent&&f.data("th")[0]!==n[0]&&(f.off($e).remove(),f=null),f||(f=d.resizeHandle=e('<div class="k-resize-handle"><div class="k-resize-handle-inner"></div></div>'),t.append(f)),en)i=n.position().left,h&&(s=n.closest(".k-grid-header-wrap, .k-grid-header-locked"),a=tn.msie?s.scrollLeft():0,l=tn.webkit?s[0].scrollWidth-s[0].offsetWidth-s.scrollLeft():0,c=tn.mozilla?s[0].scrollWidth-s[0].offsetWidth-(s[0].scrollWidth-s[0].offsetWidth-s.scrollLeft()):0,i-=l-c+a);else{for(i=n[0].offsetWidth,o=V(n.closest("thead")).filter(":visible"),r=0;r<o.length&&o[r]!=n[0];r++)i+=o[r].offsetWidth;p>0&&(i+=ye(t.find(".k-group-cell:first"))*p),d._hasDetails()&&(i+=ye(t.find(".k-hierarchy-cell:first")))}f.css({top:n.position().top,left:i-u,height:ke(n),width:3*u}).data("th",n).show(),f.off("dblclick"+$e).on("dblclick"+$e,function(){d._autoFitLeafColumn(n.data("index"))})},_positionColumnResizeHandle:function(){var n=this,i=n.lockedHeader?n.lockedHeader.find("thead:first"):e();n.thead.add(i).on("mousemove"+$e,"th",function(i){var o=t!==i.buttons?i.buttons:i.which||i.button,r=e(this);r.hasClass("k-group-cell")||r.hasClass("k-hierarchy-cell")||t!==o&&0!==o||n._createResizeHandle(r.closest("div"),r)})},_resizeHandleDocumentClick:function(t){e(t.target).closest(".k-column-active").length||(e(document).off(t),this._hideResizeHandle())},_hideResizeHandle:function(){this.resizeHandle&&(this.resizeHandle.data("th").removeClass("k-column-active"),this.lockedContent&&!this._isMobile?(this.resizeHandle.off($e).remove(),this.resizeHandle=null):this.resizeHandle.hide())},_positionColumnResizeHandleTouch:function(){var t=this,n=t.lockedHeader?t.lockedHeader.find("thead:first"):e();t._resizeUserEvents=new pe.UserEvents(n.add(t.thead),{filter:"th:not(.k-group-cell):not(.k-hierarchy-cell)",threshold:10,hold:function(n){var i=e(n.target);n.preventDefault(),i.addClass("k-column-active"),t._createResizeHandle(i.closest("div"),i),t._resizeHandleDocumentClickHandler||(t._resizeHandleDocumentClickHandler=Me(t._resizeHandleDocumentClick,t)),e(document).on("click",t._resizeHandleDocumentClickHandler)}})},_resizable:function(){var t,n,i,o,s,a,l,c,d=this,u=d.options,h=this._isMobile,f=pe.support.mobileOS?0:pe.support.scrollbar();u.resizable&&(t=u.scrollable?d.wrapper.find(".k-grid-header-wrap:first"):d.wrapper,h?d._positionColumnResizeHandleTouch(t):d._positionColumnResizeHandle(t),d.resizable&&d.resizable.destroy(),d.resizable=new me.Resizable(t.add(d.lockedHeader),{handle:(u.scrollable?"":">")+".k-resize-handle",hint:function(t){return e('<div class="k-grid-resize-indicator" />').css({height:ke(t.data("th"))+d.tbody.attr("clientHeight")})},start:function(t){var f,p,m,g;c=e(t.currentTarget).data("th"),h&&d._hideResizeHandle(),f=c.closest("table"),p=e.inArray(c[0],V(c.closest("thead")).filter(":visible")),a=f.parent().hasClass("k-grid-header-locked"),m=a?d.lockedTable:d.table,g=d.footer||e(),d.footer&&d.lockedContent&&(g=d.footer.children(a?".k-grid-footer-locked":".k-grid-footer-wrap")),r(d.wrapper,"col-resize"),l=u.scrollable?f.find("col:not(.k-group-col):not(.k-hierarchy-col):eq("+p+")").add(m.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq("+p+")")).add(g.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq("+p+")")):m.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq("+p+")"),n=t.x.location,i=ye(c),o=O(d.columns)[p].minResizableWidth||10,s=ye(a?m.children("tbody"):d.tbody),tn.webkit&&d.wrapper.addClass("k-grid-column-resizing")},resize:function(t){var r,h,p,m,g,v,_=en?-1:1,b=i+t.x.location*_-n*_;u.scrollable?(a&&d.lockedFooter?r=d.lockedFooter.children("table"):d.footer&&(r=d.footer.find(">.k-grid-footer-wrap>table")),r&&r[0]||(r=e()),h=c.closest("table"),p=a?d.lockedTable:d.table,m=!1,g=d.wrapper.width()-f,v=b,a&&s-i+v>g&&(v=i+(g-s-2*f),v<0&&(v=b),m=!0),v>10&&v>=o&&(l.css("width",v),s&&(v=m?g-2*f:s+t.x.location*_-n*_,p.add(h).add(r).css("width",v),a||(d._footerWidth=v))),d._scrollVirtualWrapperOnColumnResize()):b>10&&b>=o&&l.css("width",b)},resizeend:function(){var e,t,n,o=ye(c);r(d.wrapper,""),tn.webkit&&d.wrapper.removeClass("k-grid-column-resizing"),i!=o&&(t=d.lockedHeader?d.lockedHeader.find("thead:first tr:first").add(d.thead.find("tr:first")):c.parent(),n=c.attr(pe.attr("index")),n||(n=t.find("th:not(.k-group-cell):not(.k-hierarchy-cell)").index(c)),e=O(d.columns)[n],e.width=o,d.trigger(kt,{column:e,oldWidth:i,newWidth:o}),d._applyLockedContainersWidth(),d._syncLockedContentHeight(),d._syncLockedHeaderHeight()),d._hideResizeHandle(),c=null}}))},_draggable:function(){var t,n=this;n.options.reorderable&&(n._draggableInstance&&n._draggableInstance.destroy(),t=n.wrapper.children(".k-grid-header"),n._draggableInstance=n.wrapper.kendoDraggable({group:pe.guid(),autoScroll:!0,filter:n.content?".k-grid-header:first "+Ge:"table:first>.k-grid-header "+Ge,dragstart:function(){t.children(".k-grid-header-wrap").unbind("scroll"+$e+"scrolling").bind("scroll"+$e+"scrolling",function(e){n.virtualScrollable?n.content.find(">.k-virtual-scrollable-wrap").scrollLeft(this.scrollLeft):n.scrollables.not(e.currentTarget).scrollLeft(this.scrollLeft)})},dragend:function(){t.children(".k-grid-header-wrap").unbind("scroll"+$e+"scrolling")},drag:function(){n._hideResizeHandle()},hint:function(t){var n=t.attr(pe.attr("title"));return n&&(n=pe.htmlEncode(n)),e('<div class="k-header k-drag-clue" />').css({width:t.width(),paddingLeft:t.css("paddingLeft"),paddingRight:t.css("paddingRight"),lineHeight:t.height()+"px",paddingTop:t.css("paddingTop"),paddingBottom:t.css("paddingBottom")}).html(n||t.attr(pe.attr("field"))||t.text()).prepend('<span class="k-icon k-drag-status k-i-cancel" />')}}).data("kendoDraggable"))},_reorderable:function(){var t=this;t.options.reorderable&&(t.wrapper.data("kendoReorderable")&&t.wrapper.data("kendoReorderable").destroy(),t.wrapper.kendoReorderable({draggable:t._draggableInstance,dragOverContainers:function(e,n){var i=T(t.columns);return i[e].lockable!==!1&&D(i,t.columns,e,n)>-1},inSameContainer:function(n){return e(n.source).parent()[0]===e(n.target).parent()[0]&&D(T(t.columns),t.columns,n.sourceIndex,n.targetIndex)>-1},change:function(e){var n=T(t.columns),i=n[e.oldIndex],o=D(n,t.columns,e.oldIndex,e.newIndex);t.trigger(xt,{newIndex:o,oldIndex:Ee(i,n),column:i}),t.reorderColumn(o,i,"before"===e.position)}}))},_reorderHeader:function(e,t,n){var i,o,r,l,c=this,d=k(e[0],c.columns),u=k(t,c.columns),h=[];for(i=0;i<e.length;i++)e[i].columns&&(h=h.concat(e[i].columns));o=a(c.lockedHeader,c.thead,"tr:eq("+d.row+")>th.k-header:not(.k-group-cell,.k-hierarchy-cell)"),r=P(e).length,l=P([t]).length,h.length?(r>0&&0===l?_(e,t,h,c.columns,c.lockedHeader.find("thead"),c.thead,this._groups()):0===r&&l>0&&_(e,t,h,c.columns,c.thead,c.lockedHeader.find("thead"),this._groups()),(t.columns||d.cell-u.cell>1||u.cell-d.cell>1)&&(t=C(c.columns,t,e[0],n),t&&c._reorderHeader(h,t,n))):r!==l&&v(o[d.cell],c.columns,r),s(o,d.cell,u.cell,n,e.length)},_reorderContent:function(t,n,i){var o,r,l,c,d=this,u=e(),h=t[0],f=m(t),p=Ee(h,O(d.columns)),g=Ee(n,O(d.columns)),v=Ee(h,N(d.columns)),_=Ee(n,N(d.columns)),b=P(d.columns).length,w=!!n.locked,y=d.footer||d.wrapper.find(".k-grid-footer"),k=o=_;for(n.hidden&&(w?(_=d.lockedTable.find("colgroup"),k=d.lockedHeader.find("colgroup"),o=e(d.lockedFooter).find(">table>colgroup")):(_=d.tbody.prev(),k=d.thead.prev(),o=y.find(".k-grid-footer-wrap").find(">table>colgroup"))),d._hasFilterRow()&&s(d.wrapper.find(".k-filter-row th:not(.k-group-cell,.k-hierarchy-cell)"),p,g,i,t.length),s(a(d.lockedHeader,d.thead.prev(),"col:not(.k-group-col,.k-hierarchy-col)"),v,k,i,f.length),d.options.scrollable&&s(a(d.lockedTable,d.tbody.prev(),"col:not(.k-group-col,.k-hierarchy-col)"),v,_,i,f.length),y&&y.length&&(s(a(d.lockedFooter,y.find(".k-grid-footer-wrap"),">table>colgroup>col:not(.k-group-col,.k-hierarchy-col)"),v,o,i,f.length),s(y.find(".k-footer-template>td:not(.k-group-cell,.k-hierarchy-cell)"),p,g,i,t.length)),r=d.tbody.children(":not(.k-grouping-row,.k-detail-row)"),d.lockedTable&&(b>g?b<=p&&ne(d.lockedTable.find(">tbody>tr.k-grouping-row"),d.table.find(">tbody>tr.k-grouping-row"),t.length):b>p&&ne(d.table.find(">tbody>tr.k-grouping-row"),d.lockedTable.find(">tbody>tr.k-grouping-row"),t.length),u=d.lockedTable.find(">tbody>tr:not(.k-grouping-row,.k-detail-row)")),l=0,c=r.length;l<c;l+=1)s(a(u[l],r[l],">td:not(.k-group-cell,.k-hierarchy-cell)"),p,g,i,t.length)},_autoFitLeafColumn:function(e){this.autoFitColumn(O(this.columns)[e])},autoFitColumn:function(t){var n,i,o,r,s,a,l,c,d,u,h,m,g,v,_,b,w,y,k,x,C=this,S=C.options,T=C.columns,D=C.lockedHeader?V(C.lockedHeader.find(">table>thead")).filter(f).length:0,E="col:not(.k-group-col):not(.k-hierarchy-col)",I="td:visible:not(.k-group-cell):not(.k-hierarchy-cell)";if(t="number"==typeof t?T[t]:Ce(t)?De(A(T),function(e){return e===t})[0]:De(A(T),function(e){return e.field===t})[0],t&&p(t)){for(a=t.minResizableWidth,n=Ee(t,O(T)),r=t.locked,o=r?C.lockedHeader.children("table"):C.thead.parent(),i=o.find("[data-index='"+n+"']"),d=r?C.lockedTable:C.table,u=C.footer||e(),C.footer&&C.lockedContent&&(u=C.footer.children(r?".k-grid-footer-locked":".k-grid-footer-wrap")),h=u.find("table").first(),C.lockedHeader&&!r&&(n-=D),m=0;m<T.length&&T[m]!==t;m++)T[m].hidden&&n--;if(S.scrollable?(s=o.find(E).eq(n).add(d.children("colgroup").find(E).eq(n)).add(h.find("colgroup").find(E).eq(n)),r||(l=d.parent(),c=l.scrollLeft())):s=d.children("colgroup").find(E).eq(n),g=o.add(d).add(h),v=ye(i),s.width(""),g.css("table-layout","fixed"),s.width("auto"),g.addClass("k-autofitting"),g.css("table-layout",""),_=Math.ceil(Math.max(ye(i),ye(d.find("tr:not(.k-grouping-row)").eq(0).children(I).eq(n)),ye(h.find("tr").eq(0).children(I).eq(n))))+1,a&&a>_&&(_=a),s.width(_),t.width=_,S.scrollable){for(b=o.find("col"),y=0,k=0,x=b.length;k<x;k+=1)if(w=b[k].style.width,w&&w.indexOf("%")==-1)y+=parseInt(w,10);else{if(!b.eq(k).hasClass("k-group-col")){y=0;break}y+=parseInt(b.eq(k).width(),10)}y&&g.each(function(){this.style.width=y+"px"})}tn.msie&&8==tn.version&&(g.css("display","inline-table"),setTimeout(function(){g.css("display","table")},1)),g.removeClass("k-autofitting"),c&&l.scrollLeft(c),C.trigger(kt,{column:t,oldWidth:v,newWidth:_}),C._applyLockedContainersWidth(),C._syncLockedContentHeight(),C._syncLockedHeaderHeight()}},reorderColumn:function(e,n,i){var o,r,s=this,a=d(n,s.columns),l=a?a.columns:s.columns,c=Ee(n,l),u=l[e],h=!!u.locked,f=P(s.columns).length;c!==e&&(!n.locked&&h&&1==B(s.columns).length||n.locked&&!h&&1==f||(s._hideResizeHandle(),i===t&&(i=e<c),r=[n],s._reorderHeader(r,u,i),s.lockedHeader&&(F(s.thead),F(s.lockedHeader)),u.columns&&(u=O(u.columns),u=u[i?0:u.length-1]),n.columns&&(r=O(n.columns)),s._reorderContent(r,u,i),o=!!n.locked,o=o!=h,n.locked=h,l.splice(i?e:e+1,0,n),l.splice(c<e?c:c+1,1),s._templates(),s._updateColumnCellIndex(),s._updateTablesWidth(),s._applyLockedContainersWidth(),s._syncLockedHeaderHeight(),s._syncLockedContentHeight(),s._updateFirstColumnClass(),o&&(h?s.trigger(Ct,{column:n}):s.trigger(St,{column:n}))))},_updateColumnCellIndex:function(){var e,t=0;this.lockedHeader&&(e=this.lockedHeader.find("thead"),t=b(e,P(this.columns))),b(this.thead,B(this.columns),t)},lockColumn:function(e){var t,n=this.columns;e="number"==typeof e?n[e]:De(n,function(t){return t.field===e})[0],!e||e.locked||e.hidden||(t=P(n).length-1,this.reorderColumn(t,e,!1))},unlockColumn:function(e){var t,n=this.columns;e="number"==typeof e?n[e]:De(n,function(t){return t.field===e})[0],e&&e.locked&&!e.hidden&&(t=P(n).length,this.reorderColumn(t,e,!0))},cellIndex:function(t){var n=0;return this.lockedTable&&!e.contains(this.lockedTable[0],t[0])&&(n=O(P(this.columns)).length),e(t).parent().children("td:not(.k-group-cell,.k-hierarchy-cell)").index(t)+n},_modelForContainer:function(t){t=e(t),t.is("tr")||"popup"===this._editMode()||(t=t.closest("tr"));var n=t.attr(pe.attr("uid"));return this.dataSource.getByUid(n)},_editable:function(){var t,n=this,i=n.selectable&&n.selectable.options.multiple,o=n.options.editable,r=function(){var t=be(),i=n._editContainer;!i||e.contains(i[0],t)||i[0]===t||e(t).closest(".k-animation-container").length||(n.editable.end()?n.closeCell():n._scrollVirtualWrapper())};o&&(this.wrapper.addClass("k-editable"),t=n._editMode(),"incell"===t?(n.table.add(n.lockedTable).on(pe.support.touch?"touchstart"+$e:"mousedown"+$e,Oe+">"+Ve,function(t){var i=e(t.target);"incell"===n._editMode()&&i.hasClass("k-checkbox-label")&&i.prev().attr(pe.attr("bind"))&&t.preventDefault()}),o.update!==!1&&n.wrapper.on(Dt+$e,"tr:not(.k-grouping-row) > td",function(t){var o=e(this),r=n.lockedTable&&o.closest("table")[0]===n.lockedTable[0];o.hasClass("k-hierarchy-cell")||o.hasClass("k-detail-cell")||o.hasClass("k-group-cell")||o.hasClass("k-edit-cell")||o.has("a.k-grid-delete").length||o.has("button.k-grid-delete").length||o.closest("tbody")[0]!==n.tbody[0]&&!r||e(t.target).is(":input")||(n.editable?n.editable.end()?(i&&e(be()).blur(),n.closeCell(),n.editCell(o)):n._scrollVirtualWrapper():n.editCell(o))}).on("focusin"+$e,function(){e.contains(this,be())||(clearTimeout(n.timer),n.timer=null)}).on("focusout"+$e,function(){n.timer=setTimeout(r,1)})):o.update!==!1&&(n.wrapper.on(Dt+$e,"tbody>tr:not(.k-detail-row,.k-grouping-row):visible a.k-grid-edit",function(t){t.preventDefault(),n.editRow(e(this).closest("tr"))}),n._isVirtualInlineEditable()&&n.wrapper.on("focusout"+$e,"tr:not(.k-grouping-row) > td",function(){n.editable&&!n.editable.end()&&n._scrollVirtualWrapper()})),o.destroy!==!1?n.wrapper.on(Dt+$e,"tbody>tr:not(.k-detail-row,.k-grouping-row):visible .k-grid-delete",function(t){t.preventDefault(),t.stopPropagation(),n.removeRow(e(this).closest("tr"))}):n.wrapper.on(Dt+$e,"tbody>tr:not(.k-detail-row,.k-grouping-row):visible button.k-grid-delete",function(e){e.stopPropagation(),n._confirmation()||e.preventDefault()}))},editCell:function(t){var n,i,o,r;if(t=e(t),n=this,i=O(n.columns)[n.cellIndex(t)],o=n._modelForContainer(t),n.closeCell(),o&&le(i,o)&&!i.command){if(n.trigger(Ye,{model:o}))return;n._attachModelChange(o),n._editContainer=t,n._shouldClearEditableState&&n._clearEditableState(),n.editable=t.addClass("k-edit-cell").kendoEditable({fields:{field:i.field,format:i.format,editor:i.editor,values:i.values},model:o,target:n,change:function(e){n.trigger(Qe,{values:e.values,container:t,model:o})&&e.preventDefault()},skipFocus:!(!n._isVirtualIncellEditable()||!n._editableState)}).data("kendoEditable"),r=t.parent().addClass("k-grid-edit-row"),n.lockedContent&&re(r[0],n._relatedRow(r).addClass("k-grid-edit-row")[0]),n.trigger(Ke,{container:t,model:o})}},_adjustLockedHorizontalScrollBar:function(){var e=this.table,t=e.parent(),n=e[0].offsetWidth>t[0].clientWidth?pe.support.scrollbar():0;this.lockedContent.height(t.height()-n)},_syncLockedContentHeight:function(){this.lockedTable&&(this.touchScroller||this._adjustLockedHorizontalScrollBar(),this._adjustRowsHeight(this.table,this.lockedTable))},_syncLockedHeaderHeight:function(){var e,t;this.lockedHeader&&(e=this.lockedHeader.children("table"),t=this.thead.parent(),this._adjustRowsHeight(e,t),oe(e,t))},_syncLockedFooterHeight:function(){this.lockedFooter&&this.footer&&this.footer.length&&this._adjustRowsHeight(this.lockedFooter.children("table"),this.footer.find(".k-grid-footer-wrap > table"))},_destroyEditable:function(){var e=this,t=function(){if(e.editable){var t=e.editView?e.editView.element:e._editContainer;t&&(t.off(Dt+$e,"a.k-grid-cancel",e._editCancelClickHandler),t.off(Dt+$e,"a.k-grid-update",e._editUpdateClickHandler)),e._detachModelChange(),e.editable.destroy(),e.editable=null,e._editContainer=null,e._destroyEditView()}};e.editable&&("popup"!==e._editMode()||e._isMobile?t():e._editContainer.data("kendoWindow").bind("deactivate",t).close()),e._actionSheet&&(e._actionSheet.destroy(),e._actionSheet=null)},_destroyEditView:function(){this.editView&&(this.editView.purge(),this.editView=null,this.pane.navigate(""))},_attachModelChange:function(e){var t=this;t._modelChangeHandler=function(e){t._modelChange({field:e.field,model:this})},e.bind("change",t._modelChangeHandler)},_detachModelChange:function(){var e=this,t=e._editContainer,n=e._modelForContainer(t);n&&n.unbind(ot,e._modelChangeHandler)},closeCell:function(e){var t,n,i,o=this,r=o._editContainer;r&&(i=o._modelForContainer(r),e&&o.trigger("cancel",{container:r,model:i})||(o.trigger(it,{type:e?"cancel":"save",model:i,container:r}),r.removeClass("k-edit-cell"),t=O(o.columns)[o.cellIndex(r)],n=r.parent().removeClass("k-grid-edit-row"),o.lockedContent&&o._relatedRow(n).removeClass("k-grid-edit-row"),o._destroyEditable(),o._displayCell(r,t,i),o._shouldClearEditableState&&o._clearEditableState(),o.trigger("itemChange",{item:n,data:i,ns:me}),o.lockedContent&&re(n.css("height","")[0],o._relatedRow(n).css("height","")[0])))},_displayCell:function(e,t,n){var i=this,o={storage:{},count:0},r=Se({},pe.Template,i.options.templateSettings),s=pe.template(i._cellTmpl(t,o),r);o.count>0&&(s=Me(s,o.storage)),e.empty().html(s(n)),i.angular("compile",function(){return{elements:e,data:[{dataItem:n}]}})},removeRow:function(e){this._confirmation(e)&&this._removeRow(e)},_removeRow:function(t){var n,i,o,r=this,s=r._editMode();"incell"!==s&&r.cancelRow(),t=e(t),r.lockedContent&&(t=t.add(r._relatedRow(t))),t=t.hide(),n=r._modelForContainer(t),n&&!r.trigger(Xe,{row:t,model:n})?(r.options.persistSelection&&(i=r.dataSource.options.schema.model.id,o=n[i],delete r._selectedIds[o]),r.dataSource.remove(n),"inline"!==s&&"popup"!==s||r.dataSource.sync()):"incell"===s&&r._destroyEditable()},_editMode:function(){var e="incell",t=this.options.editable;return t!==!0&&(e="string"==typeof t?t:t.mode||e),e},editRow:function(t){var n,i,o,r=this;t instanceof ve?n=t:(t=e(t),n=r._modelForContainer(t)),i=r._editMode(),r.cancelRow(),n&&(t=r.tbody.children("["+pe.attr("uid")+"="+n.uid+"]"),r._attachModelChange(n),"popup"===i?r._createPopupEditor(n):"inline"===i?r._createInlineEditor(t,n):"incell"===i&&e(t).children(He).each(function(){var t=e(this),i=O(r.columns)[r.cellIndex(t)];if(n=r._modelForContainer(t),n&&(!n.editable||n.editable(i.field))&&i.field&&!i.selectable)return r.editCell(t),!1}),o=r.editView?r.editView.element:r._editContainer,o&&(this._editCancelClickHandler||(this._editCancelClickHandler=Me(this._editCancelClick,this)),o.on(Dt+$e,"a.k-grid-cancel",this._editCancelClickHandler),this._editUpdateClickHandler||(this._editUpdateClickHandler=Me(this._editUpdateClick,this)),o.on(Dt+$e,"a.k-grid-update",this._editUpdateClickHandler)))},_editUpdateClick:function(e){e.preventDefault(),e.stopPropagation(),this.saveRow()},_editCancelClick:function(t){var n,i=this,o=i.options.navigatable,r=i.editable.options.model,s=i.editView?i.editView.element:i._editContainer;t.preventDefault(),t.stopPropagation(),i.trigger("cancel",{container:s,model:r})||(n=i.items().index(e(i.current()).parent()),i.cancelRow(),o&&(i._setCurrent(i.items().eq(n).children().filter(Ve).first()),ae(i.table,!0)))},_createPopupEditor:function(n){var i,o,r,s,a,l,c,d,u,h,f,p,m,g=this,v="<div "+pe.attr("uid")+'="'+n.uid+'" class="k-popup-edit-form'+(g._isMobile?" k-mobile-list":"")+'"><div class="k-edit-form-container">',_=[],b=O(g.columns),w=g.options.editable,y=w.template,k=Ce(w)?w.window:{},x=Se({},pe.Template,g.options.templateSettings);if(!g.trigger(Ye,{model:n})){if(k=k||{},y)for(typeof y===Mt&&(y=window.unescape(y)),v+=pe.template(y,x)(n),r=0,s=b.length;r<s;r++)i=b[r],i.command&&(h=se(i.command,"edit"),h&&(o=h));else for(r=0,s=b.length;r<s;r++)i=b[r],i.selectable||(i.command?i.command&&(h=se(i.command,"edit"),h&&(o=h)):(v+='<div class="k-edit-label"><label for="'+i.field+'">'+(i.title||i.field||"")+"</label></div>",le(i,n)?(_.push({field:i.field,format:i.format,editor:i.editor,values:i.values}),v+="<div "+pe.attr("container-for")+'="'+i.field+'" class="k-edit-field"></div>'):(p={storage:{},count:0},a=pe.template(g._cellTmpl(i,p),x),p.count>0&&(a=Me(a,p.storage)),v+='<div class="k-edit-field">'+a(n)+"</div>")));o&&Ce(o)&&(Ce(o.text)&&(l=o.text.update,c=o.text.cancel),Ce(o.iconClass)&&(d=o.iconClass.update,u=o.iconClass.cancel),o.attr&&(f=o.attr)),g._isMobile?(v+="</div></div>",g.editView=g.pane.append("<div data-"+pe.ns+'role="view" data-'+pe.ns+'use-native-scrolling="true" data-'+pe.ns+'init-widgets="false" class="k-grid-edit-form"><div data-'+pe.ns+'role="header" class="k-header">'+g._createButton({name:"update",text:l,attr:f})+(k.title||"Edit")+g._createButton({name:"canceledit",text:c,attr:f})+"</div>"+v+"</div>"),m=g._editContainer=g.editView.element.find(".k-popup-edit-form")):(v+='<div class="k-edit-buttons k-state-default">',v+=g._createButton({name:"update",text:l,attr:f,iconClass:d})+g._createButton({name:"canceledit",text:c,attr:f,iconClass:u}),v+="</div></div></div>",m=g._editContainer=e(v).appendTo(g.wrapper).eq(0).kendoWindow(Se({modal:!0,resizable:!1,draggable:!0,title:"Edit",visible:!1,close:function(i){if(i.userTriggered){if(i.sender.element.focus(),g.trigger("cancel",{container:m,model:n}))return i.preventDefault(),t;var o=g.items().index(e(g.current()).parent());g.cancelRow(),g.options.navigatable&&(g._setCurrent(g.items().eq(o).children().filter(Ve).first()),ae(g.table,!0))}}},k))),g.editable=g._editContainer.kendoEditable({fields:_,model:n,clearContainer:!1,target:g}).data("kendoEditable"),g._isMobile&&m.find("input[type=checkbox],input[type=radio]").parent(".k-edit-field").addClass("k-check").prev(".k-edit-label").addClass("k-check").click(function(){e(this).next().children("input").click()}),g._openPopUpEditor(),g.trigger(Ke,{container:m,model:n})}},_openPopUpEditor:function(){this._isMobile?this.pane.navigate(this.editView,this._editAnimation):this._editContainer.data("kendoWindow").center().open()},_createInlineEditor:function(t,n){var i,o,r,s=this,a=[];s.trigger(Ye,{model:n})||(s.lockedContent&&(t=t.add(s._relatedRow(t))),t.children(":not(.k-group-cell,.k-hierarchy-cell)").each(function(){if(o=e(this),i=O(s.columns)[s.cellIndex(o)],!i.command&&le(i,n))a.push({field:i.field,format:i.format,editor:i.editor,values:i.values}),o.attr(pe.attr("container-for"),i.field),o.empty();else if(i.command&&(r=se(i.command,"edit"))){o.empty();var t,l,c,d,u;Ce(r)&&(Ce(r.text)&&(t=r.text.update,l=r.text.cancel),Ce(r.iconClass)&&(c=r.iconClass.update,d=r.iconClass.cancel),r.attr&&(u=r.attr)),e(s._createButton({name:"update",text:t,attr:u,iconClass:c})+s._createButton({name:"canceledit",text:l,attr:u,iconClass:d})).appendTo(o)}}),s._editContainer=t,s._editContainer.addClass("k-grid-edit-row"),s._shouldClearEditableState&&s._clearEditableState(),s.editable=new pe.ui.Editable(s._editContainer,{target:s,fields:a,model:n,skipFocus:!!(s._isVirtualInlineEditable()&&s._editableState&&s._editableState.field),clearContainer:!1}),t.length>1&&(re(t[0],t[1]),s._applyLockedContainersWidth()),s.trigger(Ke,{container:t,model:n}))},cancelRow:function(e){var t,n=this,i=n._editContainer,o=n.virtualScrollable,r=o&&o._isScrolledToBottom();if(i){if(t=n._modelForContainer(i),!t||e&&n.trigger("cancel",{container:i,model:t}))return;n._destroyEditable(),n.dataSource.cancelChanges(t),n._isVirtualEditable()&&r&&n._restoreVirtualView(),n._clearEditableState(),n._displayRow("popup"!==n._editMode()?i:n.tbody.find("["+pe.attr("uid")+"="+t.uid+"]"))}},saveRow:function(){var t,n=this,i=this._editContainer,o=this._modelForContainer(i),r=e.Deferred();return i&&this.editable?(t=n.editable&&n.editable.end(),!t||this.trigger(Qe,{container:i,model:o})?(t||n._scrollVirtualWrapper(),r.reject().promise()):(n._clearEditableState(),this.dataSource.sync())):r.resolve().promise()},_displayRow:function(t){var n,i,o,r,s,a=this,l=a._modelForContainer(t),c=t.hasClass("k-state-selected"),d=t.hasClass("k-alt");l&&(a.lockedContent&&(n=e((d?a.lockedAltRowTemplate:a.lockedRowTemplate)(l)),a._relatedRow(t.last()).replaceWith(n)),a.angular("cleanup",function(){return{elements:t.get()}}),i=e((d?a.altRowTemplate:a.rowTemplate)(l)),t.is(":visible")||i.hide(),t.replaceWith(i),a.trigger("itemChange",{item:i,data:l,ns:me}),n&&n.length&&a.trigger("itemChange",{item:n,data:l,ns:me}),r=i,s=[{dataItem:l}],n&&n.length&&(r=i.add(n),s.push({dataItem:l})),a.angular("compile",function(){return{elements:r.get(),data:s}}),c&&(a.options.selectable||a._checkBoxSelection)&&a.select(i.add(n)),n&&re(i[0],n[0]),o=i.next(),o.hasClass("k-detail-row")&&o.is(":visible")&&i.find(".k-hierarchy-cell .k-icon").removeClass("k-i-expand").addClass("k-i-collapse"))},_showMessage:function(t,n){var i,o,r,s=this;return s._isMobile?(i=pe.template('<ul><li class="km-actionsheet-title">#:title#</li><li><a href="\\#" class="k-button k-grid-delete">#:confirmDelete#</a></li></ul>'),o=e(i(t)).appendTo(s.view.element),r=s._actionSheet=new pe.mobile.ui.ActionSheet(o,{cancel:t.cancelDelete,cancelTemplate:'<li class="km-actionsheet-cancel"><a class="k-button" href="\\#">#:cancel#</a></li>',close:function(){this.destroy()},command:function(t){var i=e(t.currentTarget).parent();i.hasClass("km-actionsheet-cancel")||s._removeRow(n)},popup:s._actionSheetPopupOptions}),r.open(n),!1):window.confirm(t.title)},_confirmation:function(e){var t=this,n=t.options.editable,i=n===!0||typeof n===Mt?t.options.messages.editable.confirmation:n.confirmation;return Ce(n)&&typeof n.mode===Mt&&typeof i!==It&&typeof i!==Mt&&i!==!1&&(i=t.options.messages.editable.confirmation),i===!1||null==i||(typeof i===It&&(i=i(t._modelForContainer(e))),t._showMessage({confirmDelete:n.confirmDelete||t.options.messages.editable.confirmDelete,cancelDelete:n.cancelDelete||t.options.messages.editable.cancelDelete,title:i===!0?t.options.messages.editable.confirmation:i},e))},cancelChanges:function(){var e=this;e.dataSource.cancelChanges(),e._isVirtualEditable()&&e._virtualPageToTop(function(){e.virtualScrollable.scrollToTop()})},saveChanges:function(){var e=this,t=e.editable&&e.editable.end();!t&&e.editable||e.trigger(at)?t||e._scrollVirtualWrapper():e.dataSource.sync()},addRow:function(){var e,t,n=this,i=n.dataSource,o=n._editMode(),r=n.options.editable.createAt||"",s=i.pageSize(),a=i.view()||[],l=r.toLowerCase()===Rt,c=n._isVirtualEditable();n.editable&&n.editable.end()||!n.editable?("incell"!=o&&n.cancelRow(),e=i.indexOf(a[0]),l&&(e+=a.length,s&&!i.options.serverPaging&&s<=a.length&&(e-=1)),e<0&&(e=i.page()>i.totalPages()?(i.page()-1)*s:0),n.options.navigatable&&"incell"==o&&n._removeCurrent(),c?n._virtualAddRow():(t=i.insert(e,{}),n._editModel(t))):n._scrollVirtualWrapper()},_editModel:function(e){var t,n,i,o,r=this,s=r.options.editable.createAt||"",a=r._editMode();e&&(t=e.uid,n=r.lockedContent?r.lockedTable:r.table,i=n.find("tr["+pe.attr("uid")+"="+t+"]"),o=i.children("td:not(.k-group-cell,.k-hierarchy-cell)").eq(r._firstEditableColumnIndex(i)),"inline"===a&&i.length?r.editRow(i):"popup"===a?r.editRow(e):o.length&&r.editCell(o),"bottom"==s.toLowerCase()&&r.lockedContent&&(r.lockedContent[0].scrollTop=r.content[0].scrollTop=r.table[0].offsetHeight))},_virtualAddRow:function(){var e=this,t=(e.options.editable.createAt||"").toLowerCase()===Rt;e._clearEditableState(),t?e._virtualAddRowAtBottom():e._virtualAddRowAtTop()},_virtualAddRowAtTop:function(){var e,t=this,n=t.dataSource,i=t.virtualScrollable;1===n.page()?(e=n.insert(0,{}),t._editModel(e),i.scrollToTop()):t._virtualPageToTop(function(){e=n.insert(0,{}),t._editModel(e),i.scrollToTop()})},_virtualAddRowAtBottom:function(){var e,t=this,n=t.dataSource,i=t.virtualScrollable,o=n.total();n.at(o-1)instanceof ve?(e=n.insert(o,{}),t._virtualPageToBottom(function(){t._editModel(e),i.scrollToBottom()})):t._virtualPageToBottom(function(){e=n.insert(o,{}),t._editModel(e),i.scrollToBottom()})},_virtualPageToTop:function(e){var t=this;t._virtualPage(0,t.dataSource.take(),function(){e()})},_virtualPageToBottom:function(e){var t=this,n=t.dataSource,i=n.take(),o=n.total(),r=o>i?o-i:0;t._virtualPage(r,i,function(){e()})},_virtualPage:function(e,t,n){var i=this;i._isVirtualEditable()&&(i.virtualScrollable._preventScroll=!0,i.virtualScrollable._page(e,t,n))},_restoreVirtualView:function(){var e=this,t=e.dataSource,n=e.virtualScrollable,i=n.verticalScrollbar,o=n.wrapper,r=t.take(),s=t.total(),a=t.currentRangeStart(),l=s>=r?Pe.min(a,s-r):a,c=n.itemHeight,d=i.scrollTop()/c;e._virtualPage(l,r,function(){var e=n.itemHeight,t=d*e;n._isScrolledToBottom()?n.scrollToBottom():(n._preventScroll=i.scrollTop()!==t,i.scrollTop(t),o.scrollTop(i.scrollTop()-l*e))})},_firstEditableColumnIndex:function(e){var t,n,i,o=this,r=O(o.columns),s=o._modelForContainer(e);for(n=0,i=r.length;n<i;n++)if(t=r[n],s&&(!s.editable||s.editable(t.field))&&!t.command&&t.field&&t.hidden!==!0)return n;return-1},_toolbar:function(){var t,n=this,i=n.wrapper,o=n.options.toolbar,r=n.options.editable;o&&(t=n.wrapper.find(".k-grid-toolbar"),t.length||(Re(o)||(o=typeof o===Mt?o:n._toolbarTmpl(o).replace($t,"\\#"),o=Me(pe.template(o),n)),t=e('<div class="k-header k-grid-toolbar" />').html(o({})).prependTo(i),n.angular("compile",function(){return{elements:t.get()}})),r&&r.create!==!1&&t.on(Dt+$e,".k-grid-add",function(e){e.preventDefault(),n.addRow()}).on(Dt+$e,".k-grid-cancel-changes",function(e){e.preventDefault(),n.cancelChanges()}).on(Dt+$e,".k-grid-save-changes",function(e){e.preventDefault(),n.saveChanges()}),t.on(Dt+$e,".k-grid-excel",function(e){e.preventDefault(),n.saveAsExcel()}),t.on(Dt+$e,".k-grid-pdf",function(e){e.preventDefault(),n.saveAsPDF()}))},_toolbarTmpl:function(e){var t,n,i=this,o="";if(Ae(e))for(t=0,n=e.length;t<n;t++)o+=i._createButton(e[t]);return o},_createButton:function(e){var n,i=e.template||Xt,r=typeof e===Mt?e:e.name||e.text,s=sn[r]?sn[r].className:"k-grid-"+(r||"").replace(/\s/g,""),a={className:s,text:r,attr:"",iconClass:""},l=this.options.messages.commands;if(!(r||Ce(e)&&e.template))throw Error("Custom commands should have name specified");return Ce(e)?(e=Se(!0,{},e),e.className&&Ee(a.className,e.className.split(" "))<0?e.className+=" "+a.className:e.className===t&&(e.className=a.className),"edit"===r&&(e=Se(!0,{},e),e.text=Ce(e.text)?e.text.edit:e.text,e.iconClass=Ce(e.iconClass)?e.iconClass.edit:e.iconClass),
e.attr&&(Ce(e.attr)&&(e.attr=o(e.attr)),typeof e.attr===Mt&&(n=e.attr.match(/class="(.+?)"/),n&&Ee(n[1],e.className.split(" "))<0&&(e.className+=" "+n[1]))),a=Se(!0,a,sn[r],{text:l[r]},e)):a=Se(!0,a,sn[r],{text:l[r]}),pe.template(i)(a)},_hasFooters:function(){return!!this.footerTemplate||!!this.groupFooterTemplate||this.footer&&this.footer.length>0||this.wrapper.find(".k-grid-footer").length>0},_groupable:function(){var t=this;t._groupableClickHandler?t.table.add(t.lockedTable).off(Dt+$e,t._groupableClickHandler):t._groupableClickHandler=function(n){var i=e(this),o=i.closest("tr"),r=t._groupRows?t._groupRows[t.wrapper.find(".k-grouping-row").index(o)]:{};i.hasClass("k-i-collapse")?t.trigger("groupCollapse",{group:r,element:o})||t.collapseGroup(o):t.trigger("groupExpand",{group:r,element:o})||t.expandGroup(o),n.preventDefault(),n.stopPropagation()},t._isLocked()?t.lockedTable.on(Dt+$e,".k-grouping-row .k-i-expand, .k-grouping-row .k-i-collapse",t._groupableClickHandler):t.table.on(Dt+$e,".k-grouping-row .k-i-expand, .k-grouping-row .k-i-collapse",t._groupableClickHandler),t._attachGroupable()},_attachGroupable:function(){var t=this,n=t.wrapper,i=t.options.groupable,o=Ge+"["+pe.attr("field")+"]",r=t.content?".k-grid-header:first "+o:"table:first>.k-grid-header "+o;i&&i.enabled!==!1&&(n.has("div.k-grouping-header")[0]||e("<div>&nbsp;</div>").addClass("k-grouping-header").prependTo(n),t.groupable&&t.groupable.destroy(),t.groupable=new me.Groupable(n,Se({},i,{draggable:t._draggableInstance,groupContainer:">div.k-grouping-header",dataSource:t.dataSource,draggableElements:r,filter:r,allowDrag:t.options.reorderable,change:function(e){t.trigger("group",{groups:e.groups})?e.preventDefault():(t._clearEditableState(),t.dataSource.options.endless&&(t.dataSource.options.endless=null,t._endlessPageSize=t.dataSource.options.pageSize,t.dataSource.pageSize(t.dataSource.options.pageSize)))}})))},_continuousItems:function(t,n){var i,o,r,s,a,l,c,d;if(this.lockedContent){for(i=this,o=i.table.add(i.lockedTable),r=e(t,o[0]),s=e(t,o[1]),a=n?P(i.columns).length:1,l=n?i.columns.length-a:1,c=[],d=0;d<r.length;d+=a)Ie.apply(c,r.slice(d,d+a)),Ie.apply(c,s.splice(0,l));return c}},_selectable:function(){var n,i,o,r,s=this,a=[],l=s._isLocked(),c=s.options.selectable;c&&(s.selectable&&s.selectable.destroy(),s.options.persistSelection===!0&&(s._selectedIds={}),c=pe.ui.Selectable.parseOptions(c),n=c.multiple,i=c.cell,s._hasDetails()&&(a[a.length]=".k-detail-row"),(s.options.groupable||s._hasFooters()||s._groups())&&(a[a.length]=".k-grouping-row,.k-group-footer"),a=a.join(","),""!==a&&(a=":not("+a+")"),o=s.table,l&&(o=o.add(s.lockedTable)),r=">"+(i?Ne:"tbody>tr"+a),s.selectable=new pe.ui.Selectable(o,{filter:r,aria:!0,multiple:n,change:function(){s.options.persistSelection&&!i&&s._persistSelectedRows(),s.trigger(ot)},useAllItems:l&&n&&i,relatedTarget:function(t){var n,o,r,a;if(!i&&l){for(o=e(),r=0,a=t.length;r<a;r++)n=s._relatedRow(t[r]),Ee(n[0],t)<0&&(o=o.add(n));return o}},continuousItems:function(){return s._continuousItems(r,i)}}),s.options.navigatable&&o.on("keydown"+$e,function(r){var a=s.current(),c=r.target;if(r.keyCode===xe.SPACEBAR&&!r.shiftKey&&e.inArray(c,o)>-1&&!a.is(".k-edit-cell,.k-header")&&a.parent().is(":not(.k-grouping-row,.k-detail-row,.k-group-footer)")){if(r.preventDefault(),r.stopPropagation(),a=i?a:a.parent(),l&&!i&&(a=a.add(s._relatedRow(a))),n)if(r.ctrlKey){if(a.hasClass(_t))return a.removeClass(_t),s.trigger(ot),t}else s.selectable.clear();else s.selectable.clear();i||(s.selectable._lastActive=a),s.selectable.value(a)}else!i&&(r.shiftKey&&r.keyCode==xe.LEFT||r.shiftKey&&r.keyCode==xe.RIGHT||r.shiftKey&&r.keyCode==xe.UP||r.shiftKey&&r.keyCode==xe.DOWN||r.keyCode===xe.SPACEBAR&&r.shiftKey)&&(r.preventDefault(),r.stopPropagation(),a=a.parent(),l&&(a=a.add(s._relatedRow(a))),n?(s.selectable._lastActive||(s.selectable._lastActive=a),s.selectable.selectRange(s.selectable._firstSelectee(),a)):(s.selectable.clear(),s.selectable.value(a)))}))},_clipboard:function(){var e,t=this.options,n=t.selectable;n&&t.allowCopy&&(e=this,t.navigatable||e.table.add(e.lockedTable).attr("tabindex",0).on("mousedown"+$e+" keydown"+$e,".k-detail-cell",function(e){e.target!==e.currentTarget&&e.stopImmediatePropagation()}).on("mousedown"+$e,Oe+">"+Ve,Me(de,e)),e.copyHandler=Me(e.copySelection,e),e.updateClipBoardState=function(){e.areaClipBoard&&e.areaClipBoard.val(e.getTSV()).focus().select()},e.bind("change",e.updateClipBoardState),e.wrapper.on("keydown",e.copyHandler),e.clearAreaHandler=Me(e.clearArea,e),e.wrapper.on("keyup",e.clearAreaHandler))},copySelection:function(t){t instanceof jQuery.Event&&!t.ctrlKey&&!t.metaKey||e(t.target).is("input:visible,textarea:visible")||window.getSelection&&""+window.getSelection()||document.selection&&document.selection.createRange().text||(this.areaClipBoard||(this.areaClipBoard=e("<textarea />").css({position:"fixed",top:"50%",left:"50%",opacity:0,width:0,height:0}).appendTo(this.wrapper)),this.areaClipBoard.val(this.getTSV()).focus().select())},getTSV:function(){var t,n,i,o,r,s,a=this,l=a.select(),c="\t",d=a.options.allowCopy,u=!0;return e.isPlainObject(d)&&d.delimeter&&(c=d.delimeter),t="",l.length&&(l.eq(0).is("tr")&&(l=l.find("td:not(.k-group-cell)")),u&&l.filter(":visible"),n=[],i=this.columns.length,o=a._isLocked()&&P(a.columns).length,r=!0,e.each(l,function(t,s){var l,c,d,h;s=e(s),l=s.closest("tr"),c=l.index(),d=s.index(),u&&(d-=s.prevAll(":hidden").length),o&&r&&(r=e.contains(a.lockedTable[0],s[0])),a._groups()&&r&&(d-=a._groups()),d=r?d:d+o,i>d&&(i=d),h=s.text(),n[c]||(n[c]=[]),n[c][d]=h}),s=n.length,n=e.each(n,function(e,t){t&&(n[e]=t.slice(i),s>e&&(s=e))}),e.each(n.slice(s),function(e,n){t+=n?n.join(c)+"\r\n":"\r\n"})),t},clearArea:function(t){var n;this.areaClipBoard&&t&&t.target===this.areaClipBoard[0]&&(n=this.options.navigatable?e(this.current()).closest("table"):this.table,ae(n,!0)),this.areaClipBoard&&(this.areaClipBoard.remove(),this.areaClipBoard=null)},_minScreenSupport:function(){var t=this.hideMinScreenCols();t&&(this.minScreenResizeHandler=Me(this.hideMinScreenCols,this),e(window).on("resize",this.minScreenResizeHandler))},hideMinScreenCols:function(){var e=this.columns,t=window.innerWidth>0?window.innerWidth:screen.width;return this._iterateMinScreenCols(e,t)},_iterateMinScreenCols:function(e,n){var i,o,r,s=!1;for(i=0;i<e.length;i++)o=e[i],r=o.minScreenWidth,r!==t&&null!==r&&(s=!0,r>n?this.hideColumn(o):this.showColumn(o)),!o.hidden&&o.columns&&(s=this._iterateMinScreenCols(o.columns,n)||s);return s},_relatedRow:function(t){var n,i,o=this.lockedTable;return t=e(t),o?(n=t.closest(this.table.add(this.lockedTable)),i=n.find(">tbody>tr").index(t),n=n[0]===this.table[0]?o:this.table,n.find(">tbody>tr").eq(i)):t},clearSelection:function(){var e=this;return e.selectable&&e.selectable.clear(),e._checkBoxSelection?(e._deselectCheckRows(e.select()),t):(e.options.persistSelection&&e._persistSelectedRows(),e.trigger(ot),t)},select:function(n){var i=this,o=i.selectable;return n=i.table.add(i.lockedTable).find(n),n.length?(o&&!o.options.multiple&&(o.clear(),n=n.first()),i._isLocked()&&(n=n.add(n.map(function(){return i._relatedRow(this)}))),o?o.value(n):(n.each(function(){e(this).addClass(_t).find(wt).prop("checked",!0).attr("aria-label","Deselect row").attr("aria-checked",!0)}),i.select().length===i.items().length&&i._toggleHeaderCheckState(!0),i.options.persistSelection&&i._persistSelectedRows(),i.trigger(ot)),t):o?o.value():i.items().filter("."+_t)},_toggleHeaderCheckState:function(e){var t=this;e?t.thead.add(t.lockedHeader).find("tr "+wt).prop("checked",!0).attr("aria-checked",!0).attr("aria-label","Deselect all rows"):t.thead.add(t.lockedHeader).find("tr "+wt).prop("checked",!1).attr("aria-checked",!1).attr("aria-label","Select all rows")},_deselectCheckRows:function(t){var n=this;t=n.table.add(n.lockedTable).find(t),n._isLocked()&&(t=t.add(t.map(function(){return n._relatedRow(this)}))),t.each(function(){e(this).removeClass(_t).find(wt).attr("aria-checked",!1).prop("checked",!1).attr("aria-label","Select row")}),n._toggleHeaderCheckState(!1),n.options.persistSelection&&n._persistSelectedRows(),n.trigger(ot)},_persistSelectedRows:function(){var e,t,n,i=this,o=i.items(),r=i.dataSource.options,s=r.schema.model.id,a={};for(i.select().each(function(){t=i.dataItem(this),a[t[s]]=!0}),n=0;n<o.length;n++)t=i.dataItem(o[n]),e=t[s],a[e]?i._selectedIds[e]=!0:delete i._selectedIds[e]},selectedKeyNames:function(){var e,t=this,n=[];for(e in t._selectedIds)n.push(e);return n.sort(),n},_updateCurrentAttr:function(t,n){var i=e(t).data("headerId");e(t).removeClass(gt).closest("table").removeAttr("aria-activedescendant"),i?(i=i.replace(this._cellId,""),e(t).attr("id",i)):e(t).removeAttr("id"),n.data("headerId",n.attr("id")).attr("id",this._cellId).addClass(gt).closest("table").attr("aria-activedescendant",this._cellId),this._current=n},_scrollCurrent:function(){var t,n,i,o,r,s,a=this._current,l=this.options.scrollable;a&&l&&(t=a.parent(),n=t.closest("table").parent(),i=n.is(".k-grid-content-locked,.k-grid-header-locked"),o=n.is(".k-grid-content-locked,.k-grid-content,.k-virtual-scrollable-wrap"),r=e(this.content).find(">.k-virtual-scrollable-wrap").addBack().last()[0],o&&(l.virtual?(s=Math.max(Ee(t[0],this._items(t.parent())),0),this._rowVirtualIndex=this.virtualScrollable.itemIndex(s),this.virtualScrollable.scrollIntoView(t)):this._scrollTo(this._relatedRow(t)[0],r)),this.lockedContent&&(this.lockedContent[0].scrollTop=r.scrollTop),i||this._scrollTo(a[0],r))},current:function(e){return this._setCurrent(e,!0)},_setCurrent:function(t,n){var i=this._current;return t=e(t),t.length&&(i&&i[0]===t[0]||(this._updateCurrentAttr(i,t),this._scrollCurrent(),n||this.trigger(Tt,{element:t}))),t&&t.length&&(this._lastCellIndex=t.parent().children(He).index(t)),this._current},_removeCurrent:function(){this._current&&(this._current.removeClass(gt),this._current=null)},_scrollTo:function(t,n){var i,o=t.tagName.toLowerCase(),r="td"===o||"th"===o,s=t[r?"offsetLeft":"offsetTop"],a=t[r?"offsetWidth":"offsetHeight"],l=n[r?"scrollLeft":"scrollTop"],c=n[r?"clientWidth":"clientHeight"],d=s+a,u=0,h=0,f=0;en&&r&&(i=e(t).closest("table")[0],tn.msie?h=i.offsetLeft:tn.mozilla&&(f=i.offsetLeft-pe.support.scrollbar())),l=Math.abs(l+h-f),u=l>s?s:d>l+c?a<=c?d-c:s:l,u=Math.abs(u+h)+f,n[r?"scrollLeft":"scrollTop"]=u},_navigatable:function(){var t,n,i,o=this;o.options.navigatable&&(t=o.table.add(o.lockedTable),n=o.thead.parent().add(e(">table",o.lockedHeader)),i=t,o.options.scrollable&&(i=i.add(n),n.attr(Et,-1)),this._navigatableTables=i,i.off("mousedown"+$e+" focus"+$e+" focusout"+$e+" keydown"+$e),n.on("keydown"+$e,Me(o._openHeaderMenu,o)).find("a.k-link").attr("tabIndex",-1),t.attr(Et,Pe.max(t.attr(Et)||0,0)).on("mousedown"+$e+" keydown"+$e,".k-detail-cell",function(e){e.target!==e.currentTarget&&e.stopImmediatePropagation()}),i.on(pe.support.touch?"touchstart"+$e:"mousedown"+$e,Oe+">"+Ve,Me(de,o)).on("focus"+$e,Me(o._tableFocus,o)).on("focusout"+$e,Me(o._tableBlur,o)).on("keydown"+$e,Me(o._tableKeyDown,o)))},_openHeaderMenu:function(e){e.altKey&&e.keyCode==xe.DOWN&&(this.current().find(".k-grid-filter, .k-header-column-menu").click(),e.stopImmediatePropagation())},_setTabIndex:function(e){this._navigatableTables.attr(Et,-1),e.attr(Et,0)},_tableFocus:function(t){var n,i;pe.support.touch||(n=this.current(),i=e(t.currentTarget),n&&n.is(":visible")?n.addClass(gt):this._setCurrent(i.find(qe)),this._setTabIndex(i))},_tableBlur:function(){var e=this.current();e&&e.removeClass(gt)},_tableKeyDown:function(n){var i,o=this.current(),r=this.virtualScrollable&&this.virtualScrollable.fetching(),s=e(n.target),a=!n.isDefaultPrevented()&&!s.is(":button,a,:input,a>.k-icon");return r?(n.preventDefault(),t):(o=o?o:e(this.lockedTable).add(this.options.scrollable?this.table:this.tbody).find(qe),o.length&&(i=!1,a&&n.keyCode==xe.UP&&(i=this._moveUp(o,n.shiftKey)),a&&n.keyCode==xe.DOWN&&(i=this._moveDown(o,n.shiftKey)),a&&n.keyCode==(en?xe.LEFT:xe.RIGHT)&&(i=this._moveRight(o,n.altKey,n.shiftKey,n.ctrlKey,n.currentTarget)),a&&n.keyCode==(en?xe.RIGHT:xe.LEFT)&&(i=this._moveLeft(o,n.altKey,n.shiftKey,n.ctrlKey,n.currentTarget)),a&&n.keyCode==xe.PAGEDOWN&&(i=this._handlePageDown()),a&&n.keyCode==xe.PAGEUP&&(i=this._handlePageUp()),a&&n.keyCode==xe.HOME&&(i=this._handleHome(o,n.ctrlKey)),a&&n.keyCode==xe.END&&(i=this._handleEnd(o,n.ctrlKey)),n.keyCode!=xe.ENTER&&n.keyCode!=xe.F2||(i=this._handleEnterKey(o,n.currentTarget,s)),n.keyCode==xe.ESC&&(i=this._handleEscKey(o,n.currentTarget)),n.keyCode==xe.TAB&&(i=this._handleTabKey(o,n.currentTarget,n.shiftKey)),i&&(n.preventDefault(),n.stopPropagation())),t)},_moveLeft:function(t,n,i,o,r){var s,a,l=t.parent(),c=l.parent();return n?this.collapseRow(l):o&&t.is(".k-header")&&this.options.reorderable?this._moveColumn(t,!0):(a=c.find(Oe).index(l),s=this._prevHorizontalCell(c,t,a),s[0]||(i?this.lockedTable?(s=this._relatedRow(l),e.contains(this.lockedTable[0],l[0])&&(s=s.prevAll(Ue+":first")),s=s.children(He+":last")):s=this._tabNext(t,r,!0):(c=this._horizontalContainer(c),s=this._prevHorizontalCell(c,t,a),s[0]!==t[0]&&ae(c.parent(),!0))),this._setCurrent(s)),!0},_moveRight:function(t,n,i,o,r){var s,a,l=t.parent(),c=l.parent();return n?this.expandRow(l):o&&t.is(".k-header")&&this.options.reorderable?this._moveColumn(t,!1):(a=c.find(Oe).index(l),s=this._nextHorizontalCell(c,t,a),s[0]||(i?this.lockedTable?(s=this._relatedRow(l),e.contains(this.table[0],l[0])&&(s=s.nextAll(Ue+":first")),s=s.children(He+":first")):s=this._tabNext(t,r,!1):(c=this._horizontalContainer(c,!0),s=this._nextHorizontalCell(c,t,a),s[0]!==t[0]&&ae(c.parent(),!0))),this._setCurrent(s)),!0},_moveUp:function(e,t){var n,i,o=e.parent().parent();return t?(n=e.parent(),n=n.prevAll(Ue+":first"),n=e.parent().is(Ue)?n.children().eq(e.index()):n.children(He+":last")):(n=this._prevVerticalCell(o,e),n[0]||(this._lastCellIndex=0,o=this._verticalContainer(o,!0),n=this._prevVerticalCell(o,e),n[0]&&ae(o.parent(),!0))),i=this._lastCellIndex||0,this._setCurrent(n),this._lastCellIndex=i,!0},_moveDown:function(e,t){var n,i,o=e.parent().parent();return t?(n=e.parent(),n=n.nextAll(Ue+":first"),n=e.parent().is(Ue)?n.children().eq(e.index()):n.children(He+":first")):(n=this._nextVerticalCell(o,e),n[0]||(this._lastCellIndex=0,o=this._verticalContainer(o),n=this._nextVerticalCell(o,e),n[0]&&ae(o.parent(),!0))),i=this._lastCellIndex||0,this._setCurrent(n),this._lastCellIndex=i,!0},_moveColumn:function(t,n){var i=this.wrapper.data().kendoReorderable.element.find(this._draggableInstance.options.filter+":visible"),o=m(T(this.columns)),r=i.index(e(t)),s=n?-1:1,a=o[r],l=D(o,this.columns,r,r+s);l>=0&&this.reorderColumn(l,a,n)},_handleHome:function(e,t){var n,i=e.parent(),o=i.parent(),r=this.lockedTable&&this.lockedTable.children("tbody")[0]===o[0],s=o[0]===this.tbody[0];if(t?n=this.lockedTable?this.lockedTable.find(We+">"+Ve+":first"):this.table.find(We+">"+Ve+":first"):(s||r)&&(s&&this.lockedTable&&(i=this._relatedRow(i)),n=i.children(He+":first")),n&&n.length)return this._setCurrent(n),!0},_handleEnd:function(e,t){var n,i=e.parent(),o=i.parent(),r=this.lockedTable&&this.lockedTable.children("tbody")[0]===o[0],s=o[0]===this.tbody[0];if(t?n=this.table.find(je+">"+Ve+":last"):(s||r)&&(!s&&this.lockedTable&&(i=this._relatedRow(i)),n=i.children(He+":last")),n&&n.length)return this._setCurrent(n),!0},_handlePageDown:function(){return!!this.options.pageable&&(this.dataSource.page(this.dataSource.page()+1),!0)},_handlePageUp:function(){return!!this.options.pageable&&(this.dataSource.page(this.dataSource.page()-1),!0)},_handleTabKey:function(t,n,i){var o,r=this.options.editable&&"incell"==this._editMode();return!(!r||t.is("th"))&&(o=e(be()).closest(".k-edit-cell"),o[0]&&o[0]!==t[0]&&(t=o),o=this._tabNext(t,n,i),!!o.length&&(this._handleEditing(t,o,o.closest("table")),!0))},_handleEscKey:function(t,n){var i,o=be(),r="incell"==this._editMode();return ue(t)?(r?this.closeCell(!0):(i=e(t).parent().index(),o&&o.blur(),this.cancelRow(!0),i>=0&&this._setCurrent(this.items().eq(i).children(Ve).first())),tn.msie&&tn.version<9&&document.body.focus(),ae(n,!0),!0):!!t.has(o).length&&(ae(n,!0),!0)},_toggleCurrent:function(e,t){var n=e.parent();return n.is(".k-grouping-row")?(n.find(".k-icon:first").click(),!0):!(t||!n.is(".k-master-row"))&&(n.find(".k-icon:first").click(),!0)},_handleEnterKey:function(t,n,i){var o,r,s=this.options.editable&&this.options.editable.update!==!1,a=i.closest("[role=gridcell]");return i.is("table")||e.contains(t[0],i[0])||(t=a),t.is("th")?(o=t.find(".k-link"),o.length?o.click():t.find(wt).focus(),!0):!!this._toggleCurrent(t,s)||(r=t.find(":kendoFocusable:first"),r[0]&&!t.hasClass("k-edit-cell")&&t.hasClass("k-state-focused")?(r.focus(),!0):!(!s||i.is(":button,.k-button,textarea"))&&(a[0]||(a=t),this._handleEditing(a,!1,n),!0))},_nextHorizontalCell:function(e,t,n){var i,o,r,s=t.nextAll(He);return s.length||(i=e.find(Oe),o=i.index(t.parent()),o!=-1)?s.first():t.hasClass("k-header")?(r=[],z([P(this.columns)[0]],W(i.eq(0).children(":visible").first()),r,0,0),r[n]?r[n][0]:t):t.parent().hasClass("k-filter-row")?i.last().children(He).first():i.eq(n).children(He).first()},_prevHorizontalCell:function(e,t,n){var i,o,r,s,a=t.prevAll(He);return a.length||(i=e.find(Oe),o=i.index(t.parent()),o!=-1)?a.first():t.hasClass("k-header")?(r=[],s=P(this.columns),z([s[s.length-1]],W(i.eq(0).children().last()),r,0,0),r[n]?r[n][0]:t):t.parent().hasClass("k-filter-row")?i.last().children(He).last():i.eq(n).children(He).last()},_currentDataIndex:function(e,n){var i,o=n.attr("data-index");return o?(i=P(this.columns).length,i&&!e.closest("div").hasClass("k-grid-content-locked")[0]?o-i:o):t},_prevVerticalCell:function(t,n){var i,o=n.parent(),r=t.children(Oe),s=r.index(o),a=this._currentDataIndex(t,n);if(a||n.hasClass("k-header"))return i=U(n),i.eq(i.length-2);if(a=Math.max(o.children(He).index(n),this._lastCellIndex||0),o.hasClass("k-filter-row"))return V(t).filter(f).eq(a);if(s==-1){if(o=t.find("tr.k-filter-row:visible"),!o[0])return V(t).filter(f).eq(a)}else o=0===s?e():r.eq(s-1);return i=o.children(He),i.eq(i.length>a?a:0)},_nextVerticalCell:function(e,n){var i,o,r,s,a,l,c=n.parent(),d=e.children(Oe),u=d.index(c),h=this._currentDataIndex(e,n);if(u!=-1&&h===t&&n.hasClass("k-header"))return W(n).eq(1);if(h=h?parseInt(h,10):c.children(He).index(n),h=Math.max(h,this._lastCellIndex||0),c=d.eq(u==-1?0:u+n[0].rowSpan),o=h,this._currentDataIndex(e,n)!==t)for(r=c.children(":not(.k-group-cell):not(.k-hierarchy-cell)"),s=r.filter(":hidden"),a=0,l=s.length;a<l;a++)r.index(s[a])<h&&o--;return h=o,i=c.children(He),i.eq(i.length>h?h:0)},_verticalContainer:function(e,t){var n=e.parent(),i=this._navigatableTables.length,o=Math.floor(i/2),r=Ee(n[0],this._navigatableTables);return t&&(o*=-1),r+=o,(r>=0||r<i)&&(n=this._navigatableTables.eq(r)),n.find(t?"thead":"tbody")},_horizontalContainer:function(e,t){var n,i,o=this._navigatableTables.length;return o<=2?e:(n=e.parent(),i=Ee(n[0],this._navigatableTables),i+=t?1:-1,!t||2!=i&&i!=o?!t&&(1==i||i<0)?e:this._navigatableTables.eq(i).find("thead, tbody"):e)},_tabNext:function(e,t,n){var i=!0,o=n?e.prevAll(He+":first"):e.nextAll(":visible:first");return o.length||(o=e.parent(),this.lockedTable&&(i=n&&t==this.lockedTable[0]||!n&&t==this.table[0],o=this._relatedRow(o)),i&&(o=o[n?"prevAll":"nextAll"]("tr:not(.k-grouping-row):not(.k-detail-row):visible:first")),o=o.children(He+(n?":last":":first"))),o},_handleEditing:function(n,i,o){var r,s,a=this,l=e(be()),c=a._editMode(),d=tn.msie,u=d&&tn.version<9,h=a._editContainer,f=a.options.editable&&a.options.editable.update!==!1;if(o=e(o),s="incell"==c?n.hasClass("k-edit-cell"):n.parent().hasClass("k-grid-edit-row"),a.editable){if(e.contains(h[0],l[0])&&(tn.opera||u?l.blur().change().triggerHandler("blur"):(l.blur(),d&&l.blur())),!a.editable)return ae(o),t;if(!a.editable.end())return a._setCurrent("incell"==c?h:h.children().filter(He).first()),r=h.find(":kendoFocusable:first")[0],r&&r.focus(),t;"incell"==c?a.closeCell():(a.saveRow(),s=!0)}i&&a._setCurrent(i),u&&document.body.focus(),ae(o,!0),f&&(!s&&!i||i)&&("incell"==c?a.editCell(a.current()):a.editRow(a.current().parent()))},_wrapper:function(){var e=this,t=e.table,n=e.options.height,i=e.element;i.is("div")||(i=i.wrap("<div/>").parent()),e.wrapper=i.addClass("k-grid k-widget k-display-block"),n&&(e.wrapper.css(At,n),t.css(At,"auto")),e._initMobile()},_initMobile:function(){var t,n=this.options,i=this;this._isMobile=n.mobile===!0&&pe.support.mobileOS||"phone"===n.mobile||"tablet"===n.mobile,this._isMobile&&(t=this.wrapper.addClass("k-grid-mobile").wrap("<div data-"+pe.ns+'stretch="true" data-'+pe.ns+'role="view" data-'+pe.ns+'init-widgets="false"></div>').parent(),this.pane=pe.mobile.ui.Pane.wrap(t),this.view=this.pane.view(),this._actionSheetPopupOptions=e(document.documentElement).hasClass("km-root")?{modal:!1}:{align:"bottom center",position:"bottom center",effect:"slideIn:up"},n.height&&this.pane.element.parent().css(At,n.height),this._editAnimation="slide",this.view.bind("show",function(){i._isLocked()&&(i._updateTablesWidth(),i._applyLockedContainersWidth(),i._syncLockedContentHeight(),i._syncLockedHeaderHeight(),i._syncLockedFooterHeight())}))},_tbody:function(){var t,n=this,i=n.table;t=i.find(">tbody"),t.length||(t=e("<tbody/>").appendTo(i)),n.tbody=t.attr("role","rowgroup")},_scrollable:function(){var t,n,i,o,r,s,a,l=this,c=l.options,d=c.scrollable,u=d!==!0&&d.virtual&&!l.virtualScrollable,h=!pe.support.kineticScrollNeeded||u?pe.support.scrollbar():0;d&&(t=l.wrapper.children(".k-grid-header"),t[0]||(t=e('<div class="k-grid-header" />').insertBefore(l.table)),t.css(en?"padding-left":"padding-right",d.virtual?h+1:h),n=e('<table role="grid" />'),nn&&n.attr("cellspacing",0),n.width(l.table[0].style.width),n.append(l.thead),t.empty().append(e('<div class="k-grid-header-wrap k-auto-scrollable" />').append(n)),l.content=l.table.parent(),l.content.is(".k-virtual-scrollable-wrap, .km-scroll-container")&&(l.content=l.content.parent()),l.content.is(".k-grid-content, .k-virtual-scrollable-wrap")||(l.content=l.table.wrap('<div class="k-grid-content k-auto-scrollable" />').parent()),u&&l._createVirtualScrollable(),i=t.children(".k-grid-header-wrap"),l.scrollables=i.add(l.content),o=l.wrapper.find(".k-grid-footer"),o.length&&(l.scrollables=l.scrollables.add(o.children(".k-grid-footer-wrap"))),i.unbind("scroll"+$e).bind("scroll"+$e,function(e){l.scrollables.not(e.currentTarget).scrollLeft(this.scrollLeft)}),d.virtual?l.content.find(">.k-virtual-scrollable-wrap").unbind("scroll"+$e).bind("scroll"+$e,function(){l.scrollables.scrollLeft(this.scrollLeft),l.lockedContent&&(l.lockedContent[0].scrollTop=this.scrollTop)}):(r=d.endless,s=l.dataSource.options.pageSize,r&&(l._endlessPageSize=s),l.content.unbind("scroll"+$e).bind("scroll"+$e,function(e){l.scrollables.not(e.currentTarget).scrollLeft(this.scrollLeft),l.lockedContent&&e.currentTarget==l.content[0]&&(l.lockedContent[0].scrollTop=this.scrollTop),r&&this.scrollTop+this.clientHeight-this.scrollHeight>=-10&&!l._endlessFetchInProgress&&l._endlessPageSize<l.dataSource.total()&&(l._skipRerenderItemsCount=l._endlessPageSize,l._endlessPageSize=l._endlessPageSize+s,l.dataSource.options.endless=!0,l._endlessFetchInProgress=!0,l.dataSource.pageSize(l._endlessPageSize))}),a=l.content.data("kendoTouchScroller"),a&&a.destroy(),a=pe.touchScroller(l.content),a&&a.movable&&(l.touchScroller=a,a.movable.bind("change",function(e){l.scrollables.scrollLeft(-e.sender.x),l.lockedContent&&l.lockedContent.scrollTop(-e.sender.y)}),l.one(lt,function(e){e.sender.wrapper.addClass("k-grid-backface")}))))},_createVirtualScrollable:function(){var e=this;e.virtualScrollable&&e.virtualScrollable.destroy(),e.virtualScrollable=new rn(e.content,{dataSource:e.dataSource,itemHeight:function(){return e._averageRowHeight()},page:function(){e._restoreEditableState()},scroll:function(){e._focusEditable()}}),e.virtualScrollable.bind(ft,Me(e._onVirtualPaging,e))},_onVirtualPaging:function(){var e=this;e._cacheEditableState(),e._isVirtualIncellEditable()&&(e._shouldClearEditableState=!1,e.closeCell(),e._shouldClearEditableState=!0)},_isVirtualEditable:function(){return this._isVirtualIncellEditable()||this._isVirtualInlineEditable()||this._isVirtualPopupEditable()},_isVirtualInlineEditable:function(){return this.virtualScrollable&&this._editMode()===Lt},_isVirtualIncellEditable:function(){return this.virtualScrollable&&this._editMode()===Bt},_isVirtualPopupEditable:function(){return this.virtualScrollable&&"popup"===this._editMode()},_scrollVirtualWrapper:function(){var e=this,t=e.virtualScrollable;(e._isVirtualInlineEditable()||e._isVirtualIncellEditable())&&(t._isScrolledToBottom()?t._scrollWrapperToBottom():t._isScrolledToTop()&&t._scrollWrapperToTop())},_scrollVirtualWrapperOnColumnResize:function(){var e=this.virtualScrollable;e&&e._scrollWrapperOnColumnResize()},_restoreEditableState:function(){var t,i,o=this,r=o._editableState||{},s=r.model,a=o.dataSource,l=o._isVirtualInlineEditable(),c=o._isVirtualIncellEditable();(l||c)&&s&&a._getByUid(s.uid,a.view())&&(l?(o._shouldClearEditableState=!1,o.editRow(s),o._focusEditable()):c&&(t=o.tbody.children(n(Ht,s.uid)),i=e(t).children(n(zt,r.field)),i[0]&&(o._shouldClearEditableState=!1,o.editCell(i),o._focusEditable()))),o._shouldClearEditableState=!0},_focusEditable:function(){var e=this,t=(e._editableState||{}).field,i=e._editContainer;i&&!ze(i[0],be())&&e._canFocusEditable()&&(e._isVirtualInlineEditable()?i.find(n(Ft,t)).find(vt).eq(0).focus():e._isVirtualIncellEditable()&&i.find(vt).eq(0).focus())},_canFocusEditable:function(){var e=this;return(e._isVirtualIncellEditable()||e._isVirtualInlineEditable())&&e.virtualScrollable._isElementVisible(e._editContainer)},_cacheEditableState:function(){var t,n,i=this,o=i._editContainer,r=o?i._modelForContainer(o):null,s=i._isVirtualInlineEditable(),a=i._isVirtualIncellEditable();(s||a)&&r&&(i._clearEditableState(),t=e(be()),o&&t[0]&&ze(o[0],t[0])&&(t.change(),n=pe.widgetInstance(t,pe.ui),n&&Re(n.value)&&t.is(Pt)&&(n.value(t.val()),n.trigger(ot))),s?i._editableState={model:r,field:t.closest("["+pe.attr(Ft)+"]").attr(pe.attr(Ft))}:a&&(i._editableState={model:r,field:o.attr(pe.attr(zt))}))},_clearEditableState:function(){var e=this;e.virtualScrollable&&(e._editableState=null)},_destroyVirtualScrollable:function(){var e=this;e._clearEditableState(),e.virtualScrollable&&e.virtualScrollable.element&&e.virtualScrollable.destroy(),e.virtualScrollable=null},_renderNoRecordsContent:function(){var t,n=this;n.options.noRecords&&(t=n.table.parent().children("."+yt),t.length&&(n.angular("cleanup",function(){return{elements:t.get()}}),t.remove()),n.dataSource&&n.dataSource.view().length||(t=e(n.noRecordsTemplate({})).insertAfter(n.table),n.angular("compile",function(){return{elements:t.get(),data:[{}]}})))},_setContentWidth:function(t){var n,i=this,o="k-grid-content-expander",r='<div class="'+o+'"></div>',s=i.resizable;i.options.scrollable&&i.wrapper.is(":visible")&&(n=i.table.parent().children("."+o),i._setContentWidthHandler=Me(i._setContentWidth,i),i.dataSource&&i.dataSource.view().length?n[0]&&(n.remove(),s&&s.unbind("resize",i._setContentWidthHandler)):(n[0]||(n=e(r).appendTo(i.table.parent()),s&&s.bind("resize",i._setContentWidthHandler)),i.thead&&(n.width(i.thead.width()),isNaN(parseFloat(t,10))||i.content.scrollLeft(t))),i._applyLockedContainersWidth(),i.lockedHeader&&0===i.table[0].clientWidth&&(i.table[0].style.width="1px"))},_applyLockedContainersWidth:function(){if(this.options.scrollable&&this.lockedHeader){var e,t=this.thead.parent(),n=t.parent(),i=this.wrapper[0].clientWidth,o=this._groups(),r=pe.support.scrollbar(),s=this.lockedHeader.find(">table>colgroup>col:not(.k-group-col, .k-hierarchy-col)"),a=t.find(">colgroup>col:not(.k-group-col, .k-hierarchy-col)"),l=I(s),c=I(a);o>0&&(l+=ye(this.lockedHeader.find(".k-group-cell:first"))*o),l>=i&&(l=i-3*r),this.lockedHeader.add(this.lockedContent).width(l),n[0].style.width=n.parent().width()-l-2+"px",t.add(this.table).width(c),this.virtualScrollable&&(i-=r),this.content[0].style.width=i-l-2+"px",this.lockedFooter&&this.lockedFooter.length&&(this.lockedFooter.width(l),e=this.footer.find(".k-grid-footer-wrap"),e[0].style.width=n[0].clientWidth+"px",e.children().first().width(c))}},_setContentHeight:function(){var e,t=this,n=t.options,i=t.wrapper.innerHeight(),o=t.wrapper.children(".k-grid-header"),r=pe.support.scrollbar();n.scrollable&&t.wrapper.is(":visible")&&(i-=ke(o),t.pager&&t.pager.element.is(":visible")&&(i-=ke(t.pager.element)),n.groupable&&(i-=ke(t.wrapper.children(".k-grouping-header"))),n.toolbar&&(i-=ke(t.wrapper.children(".k-grid-toolbar"))),t.footerTemplate&&(i-=ke(t.wrapper.children(".k-grid-footer"))),e=function(e){var t,n;return!!e[0].style.height||(t=e.height(),e.height("auto"),n=e.height(),t!=n?(e.height(""),!0):(e.height(""),!1))},e(t.wrapper)&&(i>2*r?(t.lockedContent&&(r=t.table[0].offsetWidth>t.table.parent()[0].clientWidth?r:0,t.lockedContent.height(i-r)),t.content.height(i)):t.content.height(2*r+1)))},_averageRowHeight:function(){var e,t=this,n=t._items(t.tbody).length,i=t._rowHeight;return 0===n?i:(t._rowHeight||(t._rowHeight=i=ke(t.table)/n,t._sum=i,t._measures=1),e=ke(t.table)/n,i!==e&&(t._measures++,t._sum+=e,t._rowHeight=t._sum/t._measures),i)},_dataSource:function(){var e,n=this,i=n.options,o=i.dataSource;o=Ae(o)?{data:o}:o,Ce(o)&&(Se(o,{table:n.table,fields:n.columns}),e=i.pageable,Ce(e)&&e.pageSize!==t&&(o.pageSize=e.pageSize)),n.dataSource&&n._refreshHandler?n.dataSource.unbind(ot,n._refreshHandler).unbind(Be,n._progressHandler).unbind(Le,n._errorHandler):(n._refreshHandler=Me(n.refresh,n),n._progressHandler=Me(n._requestStart,n),n._errorHandler=Me(n._error,n)),n.dataSource=ge.create(o).bind(ot,n._refreshHandler).bind(Be,n._progressHandler).bind(Le,n._errorHandler)},_error:function(){this._progress(!1)},_requestStart:function(){this._progress(!0)},_modelChange:function(t){var n,i,o,r,s,a,l,c,d,u,h=this,f=h.tbody,p=t.model,m=h.tbody.find("tr["+pe.attr("uid")+"="+p.uid+"]"),g=m.hasClass("k-alt"),v=h._items(f).index(m),_=h.lockedContent;if(_&&(n=h._relatedRow(m)),m.add(n).children(".k-edit-cell").length&&!h.options.rowTemplate)m.add(n).children(":not(.k-group-cell,.k-hierarchy-cell)").each(function(){i=e(this),o=O(h.columns)[h.cellIndex(i)],o.field===t.field&&(i.hasClass("k-edit-cell")?i.addClass("k-dirty-cell"):h._displayCell(i,o,p))});else if(!m.hasClass("k-grid-edit-row")){for(a=e().add(m),_&&(r=(g?h.lockedAltRowTemplate:h.lockedRowTemplate)(p),a=a.add(n),n.replaceWith(r)),h.angular("cleanup",function(){return{elements:a.get()}}),r=(g?h.altRowTemplate:h.rowTemplate)(p),m.replaceWith(r),r=h._items(f).eq(v),u=[{dataItem:p}],_&&(m=m.add(n),n=h._relatedRow(r)[0],re(r[0],n),r=r.add(n),u.push({dataItem:p})),h.angular("compile",function(){return{elements:r.get(),data:u}}),s=h.options.selectable,(s||h._checkBoxSelection)&&m.hasClass("k-state-selected")&&h.select(r),c=a.children(":not(.k-group-cell,.k-hierarchy-cell)"),l=r.children(":not(.k-group-cell,.k-hierarchy-cell)"),v=0,d=h.columns.length;v<d;v++)o=h.columns[v],i=l.eq(v),s&&c.eq(v).hasClass("k-state-selected")&&i.addClass("k-state-selected");h.trigger("itemChange",{item:r,data:p,ns:me})}},_pageable:function(){var t,n=this,i=n.options.pageable;i&&(t=n.wrapper.children("div.k-grid-pager"),t.length||(t=e('<div class="k-pager-wrap k-grid-pager"/>').appendTo(n.wrapper)),n.pager&&n.pager.destroy(),n.pager="object"==typeof i&&i instanceof pe.ui.Pager?i:new pe.ui.Pager(t,Se({},i,{dataSource:n.dataSource})),n.pager.bind("pageChange",function(e){n.trigger("page",{page:e.index})&&e.preventDefault()}))},_footer:function(){var t,n,i,o=this,r=o.dataSource.aggregates(),s="",a=o.footerTemplate,l=o.options,c=o.footer||o.wrapper.find(".k-grid-footer");a?(s=e(o._wrapFooter(a(r))),c.length?(n=s,o.angular("cleanup",function(){return{elements:c.get()}}),c.replaceWith(n),c=o.footer=n):c=o.footer=l.scrollable?l.pageable?s.insertBefore(o.wrapper.children("div.k-grid-pager")):s.appendTo(o.wrapper):s.insertBefore(o.tbody),
o.angular("compile",function(){return{elements:c.find("td:not(.k-group-cell, .k-hierarchy-cell)").get(),data:Te(o.columns,function(e){return{column:e,aggregate:r[e.field]}})}})):c&&!o.footer&&(o.footer=c),c.length&&(l.scrollable&&(t=c.attr("tabindex",-1).children(".k-grid-footer-wrap"),o.scrollables=e(o.scrollables.filter(function(){return!e(this).is(".k-grid-footer-wrap")}).toArray()).add(t)),o._footerWidth&&c.find("table").css("width",o._footerWidth),t&&(i=o.content.scrollLeft(),l.scrollable!==!0&&l.scrollable.virtual&&(i=o.wrapper.find(".k-virtual-scrollable-wrap").scrollLeft()),t.scrollLeft(i))),o.lockedContent&&(o._appendLockedColumnFooter(),o._applyLockedContainersWidth(),o._syncLockedFooterHeight())},_wrapFooter:function(t){var n=this,i="",o=pe.support.mobileOS?0:pe.support.scrollbar();return n.options.scrollable?(i=e('<div class="k-grid-footer"><div class="k-grid-footer-wrap"><table'+(nn?' cellspacing="0"':"")+"><tbody>"+t+"</tbody></table></div></div>"),n._appendCols(i.find("table")),i.css(en?"padding-left":"padding-right",o),i):'<tfoot class="k-grid-footer">'+t+"</tfoot>"},_columnMenu:function(){var e,n,i,o,r,s,a,l,c,d=this,u=O(d.columns),h=d.options,f=h.columnMenu,p=De(d.columns,function(e){return e.columns!==t}).length>0,m=this._isMobile,g=function(e){d.trigger(et,{field:e.field,container:e.container})},v=function(e){d.trigger(nt,{field:e.field,container:e.container})},_=function(e){ae(e.closest("table"),!0)},b=function(e){d.trigger("sort",{sort:e.sort})?e.preventDefault():(d._clearEditableState(),d.dataSource.options.endless&&(d.dataSource.options.endless=null,d._endlessPageSize=d.dataSource.options.pageSize,d.dataSource.pageSize(d.dataSource.options.pageSize)))},w=function(e){d.trigger("filter",{filter:e.filter,field:e.field})?e.preventDefault():(d._clearEditableState(),d.dataSource.options.endless&&(d.dataSource.options.endless=null,d._endlessPageSize=d.dataSource.options.pageSize,d.dataSource.pageSize(d.dataSource.options.pageSize)))},y=h.$angular;if(f)for("boolean"==typeof f&&(f={}),s=V(d.thead),a=0,l=s.length;a<l;a++)n=u[a],c=s.eq(a),n.command||!n.field&&!c.attr("data-"+pe.ns+"field")||(e=c.data("kendoColumnMenu"),e&&e.destroy(),o=n.sortable!==!1&&f.sortable!==!1&&h.sortable!==!1&&Se({},h.sortable,{compare:(n.sortable||{}).compare}),r=!(!h.filterable||n.filterable===!1||f.filterable===!1)&&Se({pane:d.pane},h.filterable,n.filterable),n.filterable&&n.filterable.dataSource&&(r.forceUnique=!1,r.checkSource=n.filterable.dataSource),r&&(r.format=n.format),i={dataSource:d.dataSource,values:n.values,columns:f.columns,sortable:o,filterable:r,messages:f.messages,owner:d,closeCallback:_,init:g,open:v,pane:d.pane,sort:b,filtering:w,filter:m?":not(.k-column-active)":"",lockedColumns:!p&&n.lockable!==!1&&P(u).length>0},y&&(i.$angular=y),c.kendoColumnMenu(i))},_headerCells:function(){return this.thead.find("th").filter(function(){var t=e(this);return!t.hasClass("k-group-cell")&&!t.hasClass("k-hierarchy-cell")})},_filterable:function(){var e,t,n,i,o,r,s,a=this,l=O(a.columns),c=function(e){a.trigger(Je,{field:e.field,container:e.container})},d=function(e){ae(e.closest("table"),!0)},u=function(e){a.trigger("filter",{filter:e.filter,field:e.field})?e.preventDefault():(a._clearEditableState(),a.dataSource.options.endless&&(a.dataSource.options.endless=null,a._endlessPageSize=a.dataSource.options.pageSize,a.dataSource.pageSize(a.dataSource.options.pageSize)))},h=function(e){a.trigger(tt,{field:e.field,container:e.container})},f=a.options.filterable;if(f&&typeof f.mode==Mt&&f.mode.indexOf("menu")==-1&&(f=!1),f&&!a.options.columnMenu)for(t=V(a.thead),i=0,o=t.length;i<o;i++)n=t.eq(i),l[i].filterable===!1||l[i].command||!l[i].field&&!n.attr("data-"+pe.ns+"field")||(e=n.data("kendoFilterMenu"),e&&e.destroy(),e=n.data("kendoFilterMultiCheck"),e&&e.destroy(),r=l[i].filterable,s=Se({},f,r,{dataSource:a.dataSource,values:l[i].values,format:l[i].format,closeCallback:d,title:l[i].title||l[i].field,init:c,open:h,pane:a.pane,change:u}),r&&r.messages&&(s.messages=Se(!0,{},f.messages,r.messages)),r&&r.dataSource&&(s.forceUnique=!1,s.checkSource=r.dataSource),r&&r.multi?n.kendoFilterMultiCheck(s):n.kendoFilterMenu(s))},_filterRow:function(){var t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g=this;if(g._hasFilterRow())for(n=g.options.$angular,i=O(g.columns),o=g.options.filterable,r=g.thead.find(".k-filter-row"),s=function(e){g.trigger("filter",{filter:e.filter,field:e.field})?e.preventDefault():(g._clearEditableState(),g.dataSource.options.endless&&(g.dataSource.options.endless=null,g._endlessPageSize=g.dataSource.options.pageSize,g.dataSource.pageSize(g.dataSource.options.pageSize)))},this._updateHeader(this.dataSource.group().length),a=0;a<i.length;a++)if(c=i[a],d=g.options.filterable.operators,u=!1,h=e("<th/>"),f=c.field,c.hidden&&h.hide(),r.append(h),f&&c.filterable!==!1){if(p=c.filterable&&c.filterable.cell||{},l=g.options.dataSource,l instanceof ge&&(l=g.options.dataSource.options),m=Se(!0,{},o.messages),c.filterable&&Se(!0,m,c.filterable.messages),p.enabled===!1){h.html("&nbsp;");continue}p.dataSource&&(l=p.dataSource,u=!0),c.filterable&&c.filterable.operators&&(d=c.filterable.operators),t={column:c,dataSource:g.dataSource,suggestDataSource:l,customDataSource:u,field:f,messages:m,values:c.values,template:p.template,delay:p.delay,inputWidth:p.inputWidth,suggestionOperator:p.suggestionOperator,minLength:p.minLength,dataTextField:p.dataTextField,operator:p.operator,operators:d,showOperators:p.showOperators,change:s},n&&(t.$angular=n),e("<span/>").attr(pe.attr("field"),f).appendTo(h).kendoFilterCell(t)}else h.html("&nbsp;")},_sortable:function(){var e,t,n,i,o,r,s=this,a=O(s.columns),l=s.options.sortable,c=function(e){s.trigger("sort",{sort:e.sort})?e.preventDefault():s._clearEditableState()};if(l){for(i=V(s.thead),o=0,r=i.length;o<r;o++)e=a[o],e.sortable!==!1&&!e.command&&e.field&&(n=i.eq(o),t=n.data("kendoColumnSorter"),t&&t.destroy(),n.attr("data-"+pe.ns+"field",e.field).kendoColumnSorter(Se({},l,e.sortable,{dataSource:s.dataSource,aria:!0,filter:":not(.k-column-active)",change:c})));i=null}},_columns:function(t){var n,i,o,r=this,s=r.table,a=s.find("col"),l=r.options.dataSource;if(t=t.length?t:Te(s.find("th"),function(t,n){t=e(t);var i=t.attr(pe.attr("sortable")),o=t.attr(pe.attr("filterable")),r=t.attr(pe.attr("type")),s=t.attr(pe.attr("groupable")),l=t.attr(pe.attr("field")),c=t.attr(pe.attr("title")),d=t.attr(pe.attr("menu"));return l||(l=t.text().replace(/\s|[^A-z0-9]/g,"")),{field:l,type:r,title:c,sortable:"false"!==i,filterable:"false"!==o,groupable:"false"!==s,menu:d,template:t.attr(pe.attr("template")),width:a.eq(n).css("width")}}),n=!(r.table.find("tbody tr").length>0&&(!l||!l.transport)),r.options.scrollable){if(o=t,i=P(t),t=B(t),i.length>0&&0===t.length)throw Error("There should be at least one non locked column");K(r.element.find("tr:has(th):first"),o),t=i.concat(t)}r.columns=c(t,n),e.grep(O(r.columns),function(e){return e.selectable}).length&&(r.options.persistSelection&&(r._selectedIds={}),r._checkBoxSelection=!0,r.wrapper.on(Dt+$e,"tbody > tr "+wt,Me(r._checkboxClick,r)),r.wrapper.on(Dt+$e,"thead > tr "+wt,Me(r._headerCheckboxClick,r)))},_headerCheckboxClick:function(t){var n=this,i=e(t.target),o=i.prop("checked"),r=i.closest(".k-grid.k-widget").getKendoGrid();n===r&&(o?n.select(r.items()):n.clearSelection())},_checkboxClick:function(t){var n=this,i=e(t.target).closest("tr"),o=!i.hasClass(_t);n===i.closest(".k-grid.k-widget").getKendoGrid()&&(o?n.select(i):n._deselectCheckRows(i))},_groups:function(){var e=this.dataSource.group();return e?e.length:0},_tmpl:function(e,n,r,s){var a,l,c,d,u,h=this,f=Se({},pe.Template,h.options.templateSettings),p=f.paramName,m=n.length,g={storage:{},count:0},v=h._hasDetails(),_=[],b=h._groups(),w=h.options.navigatable,y=pe.attr("field"),k="";if(!e){for(e="<tr",r&&_.push("k-alt"),v&&_.push("k-master-row"),_.length&&(e+=' class="'+_.join(" ")+'"'),m&&(e+=" "+pe.attr("uid")+'="#='+pe.expr("uid",f.paramName)+'#"'),e+=" role='row'>",b>0&&!s&&(e+=i(b)),v&&(e+='<td class="k-hierarchy-cell" aria-expanded="false"><a class="k-icon k-i-expand" href="\\#" '+qt+'="'+jt+'" tabindex="-1"></a></td>'),a=0;a<m;a++)c=n[a],l=c.template,d=typeof l,u=c.field,h._editMode()===Bt&&u&&(c.attributes=c.attributes||{},h.virtualScrollable&&(c.attributes[y]=u),k=h._dirtyCellTemplate(u,p),c.attributes["class"]=c.attributes["class"]||"",c.attributes["class"].indexOf(k)<0&&(c.attributes["class"]+=k)),c.command&&(c.attributes=c.attributes||{},t!==c.attributes["class"]?c.attributes["class"]+=" k-command-cell":c.attributes["class"]="k-command-cell"),e+="<td"+o(c.attributes),w&&(e+=" aria-describedby='"+c.headerAttributes.id+"'"),e+=" role='gridcell'>",e+=h._cellTmpl(c,g),e+="</td>";e+="</tr>"}return e=pe.template(e,f),g.count>0?Me(e,g.storage):e},_dirtyCellTemplate:function(e,t){var n;return e&&t?(n="["===e.charAt(0)?pe.expr(e,t+".dirtyFields"):t+".dirtyFields['"+e+"']","#= "+t+" && "+t+".dirty && "+t+".dirtyFields && "+n+" ? ' k-dirty-cell' : '' #"):""},_headerCellText:function(e){var t=this,n=Se({},pe.Template,t.options.templateSettings),i=e.headerTemplate,o=typeof i,r=e.title||e.field||"";return o===It?r=pe.template(i,n)({}):o===Mt&&(r=i),r},_cellTmpl:function(e,t){var n,i,o=this,r=Se({},pe.Template,o.options.templateSettings),s=e.template,a=r.paramName,l=e.field,c="",d=e.format,u=typeof s,h=e.values;if(e.command){if(Ae(e.command)){for(n=0,i=e.command.length;n<i;n++)c+=e.command[n].visible?pe.format("#= {0}(data)? '{1}':'' #",e.command[n].visible,o._createButton(e.command[n]).replace($t,"\\#")):o._createButton(e.command[n]).replace($t,"\\#");return c}return o._createButton(e.command).replace($t,"\\#")}return e.selectable?Zt:(c+=o._dirtyIndicatorTemplate(l,a),u===It?(t.storage["tmpl"+t.count]=s,c+="#=this.tmpl"+t.count+"("+a+")#",t.count++):u===Mt?c+=s:h&&h.length&&Ce(h[0])&&"value"in h[0]&&l?(c+="#var v ="+pe.stringify(Y(h)).replace($t,"\\#")+"#",c+="#var f = v[",r.useWithBlock||(c+=a+"."),c+=l+"]#",c+="${f != null ? f : ''}"):(c+=e.encoded?"#:":"#=",d&&(c+='kendo.format("'+d.replace(Gt,"\\$1")+'",'),l?(l=pe.expr(l,a),c+=l+"==null?'':"+l):c+="''",d&&(c+=")"),c+="#"),c)},_dirtyIndicatorTemplate:function(e,t){var n;return e&&t?(n="["===e.charAt(0)?pe.expr(e,t+".dirtyFields"):t+".dirtyFields['"+e+"']","#= "+t+" && "+t+".dirty && "+t+".dirtyFields && "+n+" ? '<span class=\"k-dirty\"></span>' : '' #"):""},_templates:function(){var t=this,n=t.options,i=t.dataSource,o=i.group(),r=t.footer||t.wrapper.find(".k-grid-footer"),s=i.aggregate(),a=O(t.columns),l=O(P(t.columns)),c=n.scrollable?O(B(t.columns)):a;if(n.scrollable&&l.length){if(n.rowTemplate||n.altRowTemplate)throw Error("Having both row template and locked columns is not supported");t.rowTemplate=t._tmpl(n.rowTemplate,c,!1,!0),t.altRowTemplate=t._tmpl(n.altRowTemplate||n.rowTemplate,c,!0,!0),t.lockedRowTemplate=t._tmpl(n.rowTemplate,l),t.lockedAltRowTemplate=t._tmpl(n.altRowTemplate||n.rowTemplate,l,!0)}else t.rowTemplate=t._tmpl(n.rowTemplate,c),t.altRowTemplate=t._tmpl(n.altRowTemplate||n.rowTemplate,c,!0);t._hasDetails()&&(t.detailTemplate=t._detailTmpl(n.detailTemplate||"")),(t._group&&!Fe(s)||!Fe(s)&&!r.length||De(a,function(e){return e.footerTemplate}).length)&&(t.footerTemplate=t._footerTmpl(a,s,"footerTemplate","k-footer-template")),o&&De(a,function(e){return e.groupFooterTemplate}).length&&(s=e.map(o,function(e){return e.aggregates}),t.groupFooterTemplate=t._footerTmpl(c,s,"groupFooterTemplate","k-group-footer",l.length),n.scrollable&&l.length&&(t.lockedGroupFooterTemplate=t._footerTmpl(l,s,"groupFooterTemplate","k-group-footer"))),t.options.noRecords&&(t.noRecordsTemplate=t._noRecordsTmpl())},_noRecordsTmpl:function(){var t,n,i,o='<div class="{0}">{1}</div>',r='<div class="k-grid-norecords-template"{1}>{0}</div>',s=this.options.scrollable&&!this.wrapper[0].style.height?' style="margin:0 auto;position:static;"':"",a={storage:{},count:0},l=e.extend({},pe.Template,this.options.templateSettings),c=l.paramName,d="";return t=this.options.noRecords.template?this.options.noRecords.template:pe.format(r,this.options.messages.noRecords,s),n=typeof t,"function"===n?(a.storage["tmpl"+a.count]=t,d+="#=this.tmpl"+a.count+"("+c+")#",a.count++):"string"===n&&(d+=t),i=pe.template(pe.format(o,yt,d),l),a.count>0&&(i=e.proxy(i,a.storage)),i},_footerTmpl:function(e,t,n,r,s){var a,l,c,d,u,h=this,f=Se({},pe.Template,h.options.templateSettings),p=f.paramName,m="",g={},v=0,_={},b=h._groups(),w=h.dataSource._emptyAggregates(t);for(m+='<tr class="'+r+'">',b>0&&!s&&(m+=i(b)),h._hasDetails()&&(m+='<td class="k-hierarchy-cell">&nbsp;</td>'),a=0,l=e.length;a<l;a++)u=e[a],c=u[n],d=typeof c,m+="<td"+o(u.footerAttributes)+">",c?(d!==It&&(_=w[u.field]?Se({},f,{paramName:p+"['"+u.field+"']"}):{},c=pe.template(c,_)),g["tmpl"+v]=c,m+="#=this.tmpl"+v+"("+p+")#",v++):m+="&nbsp;",m+="</td>";return m+="</tr>",m=pe.template(m,f),v>0?Me(m,g):m},_detailTmpl:function(e){var t=this,n="",o=Se({},pe.Template,t.options.templateSettings),r=o.paramName,s={},a=0,l=t._groups(),c=m(O(t.columns)).length,d=typeof e;return n+='<tr class="k-detail-row">',l>0&&(n+=i(l)),n+='<td class="k-hierarchy-cell"></td><td class="k-detail-cell"'+(c?' colspan="'+c+'"':"")+">",d===It?(s["tmpl"+a]=e,n+="#=this.tmpl"+a+"("+r+")#",a++):n+=e,n+="</td></tr>",n=pe.template(n,o),a>0?Me(n,s):n},_hasDetails:function(){var e=this;return null!==e.options.detailTemplate||(e._events[Ze]||[]).length},_hasFilterRow:function(){var t=this.options.filterable,n=t&&typeof t.mode==Mt&&t.mode.indexOf("row")!=-1,i=this.columns,o=e.grep(i,function(e){return e.filterable===!1});return i.length&&o.length==i.length&&(n=!1),n},_details:function(){var t=this;if(t.options.scrollable&&t._hasDetails()&&P(t.columns).length)throw Error("Having both detail template and locked columns is not supported");t.table.on(Dt+$e,".k-hierarchy-cell .k-i-expand, .k-hierarchy-cell .k-i-collapse",function(n){var i,o,r=e(this),s=r.closest("td.k-hierarchy-cell"),a=r.hasClass("k-i-expand"),l=r.closest("tr.k-master-row"),c=t.detailTemplate,d=t._hasDetails(),u=a?Wt:jt,h=!!a;return r.toggleClass("k-i-expand",!a).toggleClass("k-i-collapse",a).attr(qt,u),s.attr("aria-expanded",h),i=l.next(),d&&!i.hasClass("k-detail-row")&&(o=t.dataItem(l),i=e(c(o)).addClass(l.hasClass("k-alt")?"k-alt":"").insertAfter(l),t.angular("compile",function(){return{elements:i.get(),data:[{dataItem:o}]}}),t.trigger(Ze,{masterRow:l,detailRow:i,data:o,detailCell:i.find(".k-detail-cell")})),t.trigger(a?ct:dt,{masterRow:l,detailRow:i}),i.toggle(a),n.preventDefault(),!1})},dataItem:function(t){if(t=e(t)[0],!t)return null;var n,i,o=this.tbody.children(),r=/k-grouping-row|k-detail-row|k-group-footer/,s=t.sectionRowIndex;for(i=s,n=0;n<s;n++)r.test(o[n].className)&&i--;return this._data[i]},expandRow:function(t){e(t).find("> td .k-i-expand").click()},collapseRow:function(t){e(t).find("> td .k-i-collapse").click()},_createHeaderCells:function(e,n){var i,r,s,a,l,c,d=this,u="",h=O(d.columns);for(i=0,a=e.length;i<a;i++)r=e[i].column||e[i],s=d._headerCellText(r),l="",c=Ee(r,h),r.selectable?(u+="<th scope='col'"+o(r.headerAttributes),n&&!e[i].colSpan&&(u+=" rowspan='"+n+"'"),c>-1&&(u+=pe.attr("index")+"='"+c+"'"),s=r.headerTemplate?s:pe.template(Jt)({}),u+=">"+s+"</th>"):r.command?(u+="<th scope='col'"+o(r.headerAttributes),n&&!e[i].colSpan&&(u+=" rowspan='"+n+"'"),c>-1&&(u+=pe.attr("index")+"='"+c+"'"),u+=">"+s+"</th>"):(r.field&&(l=pe.attr("field")+"='"+r.field+"' "),u+="<th scope='col' role='columnheader' "+l,u+=" aria-haspopup='true'",n&&!e[i].colSpan&&(u+=" rowspan='"+n+"'"),e[i].colSpan>1&&(u+='colspan="'+(e[i].colSpan-E(r.columns))+'" ',u+=pe.attr("colspan")+"='"+e[i].colSpan+"'"),r.title&&(u+=pe.attr("title")+'="'+r.title.replace('"',"&quot;").replace(/'/g,"'")+'" '),r.groupable!==t&&(u+=pe.attr("groupable")+"='"+r.groupable+"' "),r.aggregates&&r.aggregates.length&&(u+=pe.attr("aggregates")+"='"+r.aggregates+"'"),c>-1&&(u+=pe.attr("index")+"='"+c+"'"),u+=o(r.headerAttributes),u+=">"+s+"</th>");return u},_appendLockedColumnContent:function(){var t,n,i,o,r,s=this.columns,a=this.table.find("colgroup"),l=a.find("col:not(.k-group-col,.k-hierarchy-col)"),c=e(),d=0,u=0;for(t=0,n=s.length;t<n;t++)if(s[t].locked)if(p(s[t])){for(o=1,s[t].columns&&(o=O(s[t].columns).length-E(s[t].columns)),o=o||1,r=0;r<o;r++)c=c.add(l.eq(t+u+r-d));u+=o-1}else d++;i=e('<div class="k-grid-content-locked"><table'+(nn?' cellspacing="0"':"")+"><colgroup/><tbody></tbody></table></div>"),a.detach(),i.find("colgroup").append(c),a.insertBefore(this.table.find("tbody")),this.lockedContent=i.insertBefore(this.content),this.lockedTable=i.children("table")},_appendLockedColumnFooter:function(){var t,n,i=this,o=i.footer,r=o.find(".k-footer-template>td"),s=o.find(".k-grid-footer-wrap>table>colgroup>col"),a=e('<div class="k-grid-footer-locked"><table><colgroup /><tbody><tr class="k-footer-template"></tr></tbody></table></div>'),l=i._groups(),c=e(),d=e();for(c=c.add(r.filter(".k-group-cell")),t=0,n=O(P(i.columns)).length;t<n;t++)c=c.add(r.eq(t+l));for(d=d.add(s.filter(".k-group-col")),t=0,n=m(O(H(i.columns))).length;t<n;t++)d=d.add(s.eq(t+l));c.appendTo(a.find("tr")),d.appendTo(a.find("colgroup")),i.lockedFooter=a.prependTo(o)},_appendLockedColumnHeader:function(t){var n,i,o,r,s,a,l,c,d,u,h,f=this,m=this.columns,v=[],_=0,b=e(),w=f._hasFilterRow(),y=0,k=e(),x=0,C=e(),S=f.thead.prev().find("col:not(.k-group-col,.k-hierarchy-col)"),T=f.thead.find("tr:first .k-header:not(.k-group-cell,.k-hierarchy-cell)"),D=f.thead.find(".k-filter-row").find("th:not(.k-group-cell,.k-hierarchy-cell)"),A=0;for(n=0,o=m.length;n<o;n++){if(m[n].locked){if(l=T.eq(n),x=O(m[n].columns||[]).length,p(m[n])){for(c=null,m[n].columns&&(c=x-E(m[n].columns)),c=c||1,d=0;d<c;d++)b=b.add(S.eq(n+A+d-_));A+=c-1}for(z([m[n]],W(l),v,0,0),x=x||1,u=0;u<x;u++)k=k.add(D.eq(y+u));y+=x}m[n].columns&&(_+=E(m[n].columns)),p(m[n])||_++}if(v.length){for(i='<div class="k-grid-header-locked" style="width:1px"><table'+(nn?' cellspacing="0"':"")+"><colgroup/><thead>",i+=Array(v.length+1).join("<tr></tr>"),i+=(w?'<tr class="k-filter-row" />':"")+"</thead></table></div>",a=e(i),S=a.find("colgroup"),S.append(f.thead.prev().find("col.k-group-col").add(b)),r=a.find("thead tr:not(.k-filter-row)"),n=0,o=v.length;n<o;n++)C=g(v[n]),r.eq(n).append(f.thead.find("tr:eq("+n+") .k-group-cell").add(C));return h=F(this.thead),v.length<h&&M(a,h-v.length),s=a.find(".k-filter-row"),s.append(f.thead.find(".k-filter-row .k-group-cell").add(k)),this.lockedHeader=a.prependTo(t),this.thead.find(".k-group-cell").remove(),!0}return!1},_removeLockedContainers:function(){var e=this.lockedHeader.add(this.lockedContent).add(this.lockedFooter);pe.destroy(e),e.off($e).remove(),this.lockedHeader=this.lockedContent=this.lockedFooter=null,this.selectable=null},_thead:function(){var t,n,i,o,r,s,a,l=this,c=l.columns,d=l._hasDetails()&&c.length,u=l._hasFilterRow(),h="",f=l.table.find(">thead"),p=l.element.find("thead:first").length>0;if(f.length||(f=e("<thead/>").insertBefore(l.tbody)),l.lockedHeader&&l.thead?(n=l.thead.find("tr:has(th):not(.k-filter-row)").html(""),n.remove(),n=e(),l._removeLockedContainers()):n=l.element.find(p?"thead:first tr:has(th):not(.k-filter-row)":"tr:has(th):first"),!n.length&&(n=f.children().first(),!n.length)){for(i=[{rowSpan:1,cells:[],index:0}],l._prepareColumns(i,c),t=0;t<i.length;t++)h+="<tr>",d&&(h+='<th class="k-hierarchy-cell" scope="col">'+l.options.messages.expandCollapseColumnHeader+"</th>"),h+=l._createHeaderCells(i[t].cells,i[t].rowSpan),h+="</tr>";n=e(h)}u&&(o=e("<tr/>"),o.addClass("k-filter-row"),(d||n.find(".k-hierarchy-cell").length)&&o.prepend('<th class="k-hierarchy-cell" scope="col">&nbsp;</th>'),r=(l.thead||f).find(".k-filter-row"),r.length&&(pe.destroy(r),r.remove()),f.append(o)),n.children().length?d&&!n.find(".k-hierarchy-cell")[0]&&n.prepend('<th class="k-hierarchy-cell" scope="col">&nbsp;</th>'):(h="",d&&(h+='<th class="k-hierarchy-cell" scope="col">&nbsp;</th>'),h+=l._createHeaderCells(c),n.html(h)),n.attr("role","row").find("th").addClass("k-header"),l.options.scrollable||f.addClass("k-grid-header"),n.find("script").remove().end().prependTo(f),l.thead&&l._destroyColumnAttachments(),this.angular("cleanup",function(){return{elements:f.find("th").get()}}),this.angular("compile",function(){return{elements:f.find("th").get(),data:Te(c,function(e){return{column:e}})}}),l.thead=f.attr("role","rowgroup"),l._sortable(),l._filterable(),l._filterRow(),l._scrollable(),l._updateCols(),l._columnMenu(),a=this.options.scrollable&&P(this.columns).length,a&&(s=l._appendLockedColumnHeader(l.thead.closest(".k-grid-header")),l._appendLockedColumnContent(),l.lockedContent.bind("DOMMouseScroll"+$e+" mousewheel"+$e,Me(l._wheelScroll,l))),l._updateColumnCellIndex(),l._updateFirstColumnClass(),l._resizable(),l._draggable(),l._reorderable(),l._updateHeader(l._groups()),a&&(s&&l._syncLockedHeaderHeight(),l._applyLockedContainersWidth()),l.groupable&&l._attachGroupable()},_retrieveFirstColumn:function(t,n){var i,o=e();if(n.length&&t[0]){for(i=t[0];i.columns&&i.columns.length;)i=i.columns[0],n=n.filter(":not(:first())");o=o.add(n)}return o},_updateFirstColumnClass:function(){var t,n,i=this,o=i.columns||[],r=i._hasDetails()&&o.length;r||i._groups()||(t=i.thead.find(">tr:not(.k-filter-row):not(:first)"),o=B(o),n=i._retrieveFirstColumn(o,t),i._isLocked()&&(t=i.lockedHeader.find("thead>tr:not(.k-filter-row):not(:first)"),o=P(i.columns),n=n.add(i._retrieveFirstColumn(o,t))),n.each(function(){var t=e(this).find("th");t.removeClass("k-first"),t.eq(0).addClass("k-first")}))},_prepareColumns:function(e,t,n,i){var o,r,s=i||e[e.length-1],a=e[s.index+1],l=0;for(o=0;o<t.length;o++)r={column:t[o],colSpan:0},s.cells.push(r),t[o].columns&&t[o].columns.length&&(a||(a={rowSpan:0,cells:[],index:e.length},e.push(a)),r.colSpan=t[o].columns.length,this._prepareColumns(e,t[o].columns,r,a),l+=r.colSpan-1,s.rowSpan=e.length-s.index);n&&(n.colSpan+=l)},_wheelScroll:function(e){var t,n,i;e.ctrlKey||(t=this.content,this.options.scrollable.virtual&&(t=this.virtualScrollable.verticalScrollbar),n=t.scrollTop(),i=pe.wheelDeltaY(e),i&&(t[0].scrollHeight>t[0].clientHeight&&(t[0].scrollTop<t[0].scrollHeight-t[0].clientHeight&&i<0||t[0].scrollTop>0&&i>0)&&e.preventDefault(),t.scrollTop(n+-i)))},_isLocked:function(){return null!=this.lockedHeader},_updateHeaderCols:function(){var e=this.thead.parent().add(this.table);this._isLocked()?$(e,N(L(this.columns)),this._hasDetails(),0):$(e,N(m(this.columns)),this._hasDetails(),0)},_updateCols:function(e){e=e||this.thead.parent().add(this.table),this._appendCols(e,this._isLocked())},_updateLockedCols:function(e){this._isLocked()&&(e=e||this.lockedHeader.find("table").add(this.lockedTable),$(e,N(H(this.columns)),this._hasDetails(),this._groups()))},_appendCols:function(e,t){t?$(e,N(L(this.columns)),this._hasDetails(),0):$(e,N(m(this.columns)),this._hasDetails(),this._groups())},_autoColumns:function(e){if(e&&e.toJSON){var t,n,i=this;e=e.toJSON(),n=!(i.table.find("tbody tr").length>0&&(!i.dataSource||!i.dataSource.transport));for(t in e)i.columns.push({field:t,encoded:n,headerAttributes:{id:pe.guid()}});i._thead(),i._templates()}},_rowsHtml:function(e,t){var n,i,o=this,r="",s=t.rowTemplate,a=t.altRowTemplate;for(n=0,i=e.length;n<i;n++)o._skipRerenderItemsCount>0?o._skipRerenderItemsCount--:r+=n%2?a(e[n]):s(e[n]),o._data.push(e[n]);return r},_groupRowHtml:function(e,t,n,i,o,r){var s,a,l,c,d=this,u="",h=e.field,f=De(O(d.columns),function(e){return e.field==h})[0]||{},p=f.groupHeaderTemplate,m=(f.title||h)+": "+Q(e.value,f.format,f.values,f.encoded),g=d._groupAggregatesDefaultObject||{},v=e.items,_=Se({},g,e.aggregates),b=Se({},{field:e.field,value:e.value,items:v,aggregates:_},e.aggregates[e.field]),w=o.groupFooterTemplate;if(p&&(m=typeof p===It?p(b):pe.template(p)(b)),d._skipRerenderItemsCount?i(t,n,m):u+=i(t,n,m),e.hasSubgroups)for(s=0,a=v.length;s<a;s++)d._skipRerenderItemsCount?d._groupRowHtml(v[s],r?t:t-1,n+1,i,o,r):u+=d._groupRowHtml(v[s],r?t:t-1,n+1,i,o,r);else u+=d._rowsHtml(v,o);if(w){l={};for(c in _)l[c]=Se({},_[c],{group:{field:e.field,value:e.value,items:v}});u+=w(l)}return u},collapseGroup:function(t){var n,i,o,r,s,a,l=this,c=t,d=this.options.groupable,u=d.showFooter,h=u?0:1,f=e();for(t=e(t),this._isLocked()&&(t.closest("div").hasClass("k-grid-content-locked")?f=this.tbody.children("tr:eq("+t.index()+")").nextAll("tr"):(f=t.nextAll("tr"),t=this.lockedTable.find(">tbody>tr:eq("+t.index()+")"))),n=t.find(".k-group-cell").length,t.find(".k-i-collapse").addClass("k-i-expand").removeClass("k-i-collapse"),t.find("td[aria-expanded='true']:first").attr("aria-expanded",!1).find("a").attr(qt,jt),t=t.nextAll("tr"),a=[],o=0,r=t.length;o<r&&(s=t.eq(o),i=s.find(".k-group-cell").length,s.hasClass("k-grouping-row")?h++:s.hasClass("k-group-footer")&&h--,!(i<=n||s.hasClass("k-group-footer")&&h<0));o++)f.length&&a.push(f[o]),a.push(s[0]);e(a).hide(),this.options.scrollable.endless&&this.content&&setTimeout(function(){l.content.scroll(),l._groupToCollapse=c})},expandGroup:function(t){t=e(t);var n,i,o,r,s,a=this,l=a.options.groupable.showFooter,c=e(),d=[],u=1;for(this._isLocked()&&(t.closest("div").hasClass("k-grid-content-locked")?c=this.tbody.children("tr:eq("+t.index()+")").nextAll("tr"):(c=t.nextAll("tr"),t=this.lockedTable.find(">tbody>tr:eq("+t.index()+")"))),n=t.find(".k-group-cell").length,t.find(".k-i-expand").addClass("k-i-collapse").removeClass("k-i-expand"),t.find("td[aria-expanded='false']:first").attr("aria-expanded",!0).find("a").attr(qt,Wt),t=t.nextAll("tr"),r=0,s=t.length;r<s&&(i=t.eq(r),o=i.find(".k-group-cell").length,!(o<=n));r++)o!=n+1||i.hasClass("k-detail-row")||(i.show(),c.eq(r).show(),i.hasClass("k-grouping-row")&&i.find(".k-icon").hasClass("k-i-collapse")&&a.expandGroup(i),i.hasClass("k-master-row")&&i.find(".k-icon").hasClass("k-i-collapse")&&(i.next().show(),c.eq(r+1).show())),i.hasClass("k-grouping-row")&&(l&&d.push(i.is(":visible")),u++),i.hasClass("k-group-footer")&&(l&&i.toggle(d.pop()),1==u?(i.show(),c.eq(r).show()):u--)},_updateHeader:function(t){var n=this,i=n._isLocked()?n.lockedHeader.find("thead"):n.thead,o=i.find("tr.k-filter-row").find("th.k-group-cell").length,r=i.find("tr:first").find("th.k-group-cell").length,s=i.children("tr:not(:first)").filter(function(){return!e(this).children(":visible").length});t>r?(e(Array(t-r+1).join('<th class="k-group-cell k-header" scope="col">'+n.options.messages.expandCollapseColumnHeader+"</th>")).prependTo(i.children("tr:not(.k-filter-row)")),n.element.is(":visible")&&s.find("th.k-group-cell").hide()):t<r&&i.find("tr").each(function(){e(this).find("th.k-group-cell").filter(":eq("+t+"),:gt("+t+")").remove()}),t>o&&e(Array(t-o+1).join('<th class="k-group-cell k-header" scope="col">&nbsp;</th>')).prependTo(i.find(".k-filter-row"))},_firstDataItem:function(e,t){return e&&t&&(e=e.hasSubgroups?this._firstDataItem(e.items[0],t):e.items[0]),e},_updateTablesWidth:function(){var t,n=this;n._isLocked()&&(t=e(">.k-grid-footer>.k-grid-footer-wrap>table",n.wrapper).add(n.thead.parent()).add(n.table),n._footerWidth=ie(t.eq(0)),t.width(n._footerWidth),t=e(">.k-grid-footer>.k-grid-footer-locked>table",n.wrapper).add(n.lockedHeader.find(">table")).add(n.lockedTable),t.width(ie(t.eq(0))))},hideColumn:function(n){var i,o,r,s,l,c,d,u,g,v,_=this,b=0,w=_.footer||_.wrapper.find(".k-grid-footer"),y=_.columns,k=_.lockedHeader?V(_.lockedHeader.find(">table>thead")).filter(f).length:0;if(n="number"==typeof n?y[n]:Ce(n)?De(A(y),function(e){return e===n})[0]:De(A(y),function(e){return e.field===n})[0],n&&p(n)){if(n.columns&&n.columns.length){for(c=S(n,y),h(n,!1),X(a(e(">table>thead",_.lockedHeader),_.thead,">tr:eq("+c.row+")>th"),c.cell,!1),r=0;r<n.columns.length;r++)this.hideColumn(n.columns[r]);return _.trigger(rt,{column:n}),t}if(g=Ee(n,m(O(y))),h(n,!1),_._setParentsVisibility(n,!1),_._templates(),_._updateCols(),_._updateLockedCols(),v=_.thead,d=g,_.lockedHeader&&k>g?v=_.lockedHeader.find(">table>thead"):d-=k,i=V(v).filter(f).eq(d),i[0].style.display="none",X(a(e(">table>thead",_.lockedHeader),_.thead,">tr.k-filter-row>th"),g,!1),w[0]&&(_._updateCols(w.find(">.k-grid-footer-wrap>table")),_._updateLockedCols(w.find(">.k-grid-footer-locked>table")),X(w.find(".k-footer-template>td"),g,!1)),_.lockedTable&&k>g?Z(_.lockedTable.find(">tbody>tr"),g):Z(_.tbody.children(),g-k),_.lockedTable)_._updateTablesWidth(),_._applyLockedContainersWidth(),_._syncLockedContentHeight(),_._syncLockedHeaderHeight(),_._syncLockedFooterHeight();else{for(s=_.thead.prev().find("col"),r=0,u=s.length;r<u;r+=1){if(l=s[r].style.width,!l||l.indexOf("%")!=-1){b=0;break}b+=parseInt(l,10)}o=e(">.k-grid-header table:first,>.k-grid-footer table:first",_.wrapper).add(_.table),_._footerWidth=null,b&&(o.each(function(){this.style.width=b+"px"}),_._footerWidth=b),tn.msie&&8==tn.version&&(o.css("display","inline-table"),setTimeout(function(){o.css("display","table")},1))}_._updateFirstColumnClass(),_.trigger(rt,{column:n})}},_setParentsVisibility:function(t,n){var i,o,r,s,l,c=this.columns,d=[],f=n?function(e){return m(e.columns).length&&e.hidden}:function(e){return!m(e.columns).length&&!e.hidden};if(u(t,c,d)&&d.length)for(i=d.length-1;i>=0;i--)o=d[i],r=k(o,c),s=a(e(">table>thead",this.lockedHeader),this.thead,">tr:eq("+r.row+")>th:not(.k-group-cell):not(.k-hierarchy-cell)").eq(r.cell),f(o)&&(h(o,n),s[0].style.display=n?"":"none"),s.filter("["+pe.attr("colspan")+"]").length&&(l=parseInt(s.attr(pe.attr("colspan")),10),s[0].colSpan=l-E(o.columns)||1)},showColumn:function(n){var i,o,r,s,l,c,d,u,f,m,g,v,_,b=this,w=b.columns,y=b.footer||b.wrapper.find(".k-grid-footer"),x=b.lockedHeader?V(b.lockedHeader.find(">table>thead")).length:0;if("number"==typeof n?(m=n,n=w[n]):Ce(n)?e.each(A(w),function(e,t){if(t===n)return n=t,m=e,!1}):e.each(A(w),function(e,t){if(t.field===n)return n=t,m=e,!1}),n&&!p(n)){if(n.columns&&n.columns.length){for(d=k(n,w),g=A(b.options.columns)[m],h(n,!0),X(a(e(">table>thead",b.lockedHeader),b.thead,">tr:eq("+d.row+")>th"),d.cell,!0),i=0;i<n.columns.length;i++)g.columns[i].hidden||this.showColumn(n.columns[i]);return b.trigger(st,{column:n}),t}if(v=Ee(n,O(w)),h(n,!0),b._setParentsVisibility(n,!0),b._templates(),b._updateCols(),b._updateLockedCols(),_=b.thead,c=v,b.lockedHeader&&x>v?_=b.lockedHeader.find(">table>thead"):c-=x,r=V(_).eq(c),r[0].style.display="",X(a(e(">table>thead",b.lockedHeader),b.thead,">tr.k-filter-row>th"),v,!0),y[0]&&(b._updateCols(y.find(">.k-grid-footer-wrap>table")),b._updateLockedCols(y.find(">.k-grid-footer-locked>table")),X(y.find(".k-footer-template>td"),v,!0)),b.lockedTable&&x>v?te(b.lockedTable.find(">tbody>tr"),v):te(b.tbody.children(),v-x),b.lockedTable)b._updateTablesWidth(),b._applyLockedContainersWidth(),b._syncLockedContentHeight(),b._syncLockedHeaderHeight();else if(s=e(">.k-grid-header table:first,>.k-grid-footer table:first",b.wrapper).add(b.table),n.width){for(l=0,f=b.thead.prev().find("col"),i=0,o=f.length;i<o;i+=1){if(u=f[i].style.width,u.indexOf("%")>-1){l=0;break}l+=parseInt(u,10)}b._footerWidth=null,l&&(s.each(function(){this.style.width=l+"px"}),b._footerWidth=l)}else s.width("");b._updateFirstColumnClass(),b.trigger(st,{column:n})}},_progress:function(e){var t=this.element,n=this.options.scrollable&&this.options.scrollable.endless;this._editContainer&&"popup"===this._editMode()?t=this._editContainer:this.lockedContent||n?t=this.wrapper:this.element.is("table")?t=this.element.parent():this.content&&this.content.length&&(t=this.content),n&&e?pe.ui.progress(t,e,{height:this.content.height(),top:this.content[0].offsetTop,opacity:!0}):pe.ui.progress(t,e)},_resize:function(e,t){this._syncLockedContentHeight(),this._syncLockedHeaderHeight(),this.content&&(this._setContentWidth(),this._setContentHeight()),this.virtualScrollable&&(t||this._rowHeight)&&(t&&(this._rowHeight=null),this.virtualScrollable.repaintScrollbar())},_isActiveInTable:function(){var t=be();return!!t&&(this.table[0]===t||e.contains(this.table[0],t)||this._isLocked()&&(this.lockedTable[0]===t||e.contains(this.lockedTable[0],t)));
},refresh:function(n){var i,o,r=this,s=r.dataSource.view(),a=r.options.navigatable,l=e(r.current()),c=!1,d=(r.dataSource.group()||[]).length,u=d+N(m(r.columns)).length;if(!n||"itemchange"!==n.action||!r.editable)return n&&"remove"===n.action&&r.editable&&r.editable.options.model&&Ee(r.editable.options.model,n.items)>-1&&r.editable.options.model.unbind(ot,r._modelChangeHandler),n=n||{},n.action===mt&&r._isVirtualEditable()?(r._destroyEditable(),r._clearEditableState(),r._restoreVirtualView(),t):(r.trigger("dataBinding",{action:n.action||"rebind",index:n.index,items:n.items})||(r._angularItems("cleanup"),r._endlessFetchInProgress||(a&&(r._isActiveInTable()||r._editContainer&&r._editContainer.data("kendoWindow"))&&(c=l.is("th"),i=c?l.index():Math.max(r.cellIndex(l),0)),r._destroyEditable()),r.options.scrollable&&r.options.scrollable.endless?(clearTimeout(r._progressTimeOut),r._progressTimeOut=setTimeout(function(){r._endlessFetchInProgress||r._progress(!1)},100)):r._progress(!1),r._hideResizeHandle(),r._data=[],r.columns.length||(r._autoColumns(r._firstDataItem(s[0],d)),u=d+r.columns.length),r._group=d>0||r._group,r._group&&(r._templates(),r._updateCols(),r._updateLockedCols(),r._updateHeader(d),r._group=d>0,r._groupRows=J(s)),r.content&&(o=r.content.scrollLeft()),r._renderContent(s,u,d),r._renderLockedContent(s,u,d),r._footer(),r._renderNoRecordsContent(),r._togglePagerVisibility(),r._setContentHeight(),r._setContentWidth(r.content&&o),r.lockedTable&&(r.options.scrollable.virtual?r.content.find(">.k-virtual-scrollable-wrap").trigger("scroll"):r.touchScroller?r.touchScroller.movable.trigger("change"):(r.wrapper.one("scroll",function(e){e.stopPropagation()}),r.content.trigger("scroll"))),r._endlessFetchInProgress||r._restoreCurrent(i,c),r.touchScroller&&r.touchScroller.contentResized(),r.selectable&&r.selectable.resetTouchEvents(),r._muteAngularRebind(function(){r._angularItems("compile")}),r._checkBoxSelection&&r._toggleHeaderCheckState(!1),r.options.persistSelection&&(r.selectable&&!pe.ui.Selectable.parseOptions(r.options.selectable).cell||r._checkBoxSelection)&&r._restoreSelection(),r.trigger(lt)),t)},_restoreCurrent:function(n,i){var o,r,s;n===t||n<0||(this._removeCurrent(),i?this._setCurrent(this.thead.find("th:not(.k-group-cell)").eq(n)):(o=0,this._rowVirtualIndex?o=this.virtualScrollable.position(this._rowVirtualIndex):n=0,r=e(),this.lockedTable&&(r=this.lockedTable.find(">tbody>tr").eq(o)),r=r.add(this.tbody.children().eq(o)),s=r.find(">td:not(.k-group-cell):not(.k-hierarchy-cell)").eq(n),this._setCurrent(s)),this._current&&ae(this._current.closest("table")[0],!0))},_restoreSelection:function(){var e,t=this,n=t.items();e=De(n,function(e){var n=t.dataItem(e)[t.dataSource.options.schema.model.id];if(t._selectedIds[n])return e}),t.select(e)},_angularItems:function(e){pe.ui.DataBoundWidget.fn._angularItems.call(this,e),"cleanup"===e&&this._cleanupDetailItems(),this._angularGroupItems(e),this._angularGroupFooterItems(e)},_cleanupDetailItems:function(){var e=this;e._hasDetails()&&(e.angular("cleanup",function(){return{elements:e.tbody.children(".k-detail-row")}}),e.tbody.find(".k-detail-cell").empty())},_angularGroupItems:function(t){var n=this,i=n.tbody;n.lockedContent&&(i=n.lockedTable.find("tbody")),n._group&&n.angular(t,function(){return{elements:i.children(".k-grouping-row"),data:e.map(J(n.dataSource.view()),function(e){return{dataItem:e}})}})},_angularGroupFooterItems:function(t){var n=this,i=n.tbody;n.lockedContent&&(i=n.element),n._group&&n.groupFooterTemplate&&n.angular(t,function(){return{elements:i.find(".k-group-footer"),data:e.map(ee(n.dataSource.view()),function(e){return{dataItem:e}})}})},_renderContent:function(e,t,n){var i,o,r=this,s="",a=null!=r.lockedContent,l=null,c=r.options.scrollable,d={rowTemplate:r.rowTemplate,altRowTemplate:r.altRowTemplate,groupFooterTemplate:r.groupFooterTemplate};if(c&&c.endless&&!r.dataSource.options.endless&&(r._skipRerenderItemsCount=0,r.content&&(r.content[0].scrollTop=0)),l=r._skipRerenderItemsCount>0,t=a?t-N(H(r.columns)).length:t,n>0)for(t=a?t-n:t,r.detailTemplate&&t++,r.groupFooterTemplate&&(r._groupAggregatesDefaultObject=r.dataSource.aggregates()),i=0,o=e.length;i<o;i++)s+=r._groupRowHtml(e[i],t,0,a?fe:he,d,a);else s+=r._rowsHtml(e,d);l?(r.tbody.append(s),setTimeout(function(){r._groupToCollapse&&(r.collapseGroup(r._groupToCollapse),r._groupToCollapse=null)}),r._endlessFetchInProgress=null):r.tbody=j(r.tbody,r.table,s,this.options.$angular)},_renderLockedContent:function(e,t,n){var i,o,r,s="",a={rowTemplate:this.lockedRowTemplate,altRowTemplate:this.lockedAltRowTemplate,groupFooterTemplate:this.lockedGroupFooterTemplate};if(this.lockedContent){if(r=this.lockedTable,n>0)for(t-=m(O(B(this.columns))).length,i=0,o=e.length;i<o;i++)s+=this._groupRowHtml(e[i],t,0,he,a);else s=this._rowsHtml(e,a);j(r.children("tbody"),r,s,this.options.$angular),this._syncLockedContentHeight()}},_togglePagerVisibility:function(){this.options.pageable.alwaysVisible===!1&&this.wrapper.find(".k-grid-pager").toggle(this.dataSource.total()>=this.dataSource.pageSize())},_adjustRowsHeight:function(e,t){var n,i,o,r,s=e[0].rows,a=s.length,l=t[0].rows,c=e.add(t),d=c.length,u=[];for(n=0;n<a&&l[n];n++)s[n].style.height&&(s[n].style.height=l[n].style.height="");for(n=0;n<a&&l[n];n++)i=s[n].offsetHeight,o=l[n].offsetHeight,r=0,i>o?r=i:i<o&&(r=o),u.push(r);for(n=0;n<d;n++)c[n].style.display="none";for(n=0;n<a;n++)u[n]&&(s[n].style.height=l[n].style.height=u[n]+1+"px");for(n=0;n<d;n++)c[n].style.display=""}});pe.ExcelMixin&&pe.ExcelMixin.extend(an.prototype),pe.PDFMixin&&(pe.PDFMixin.extend(an.prototype),an.prototype._drawPDF_autoPageBreak=function(n){function i(){u&&a!==t?(d.one("change",o),d.page(a)):(l.refresh(),o())}function o(){f.appendTo(document.body);var t=e.extend({},l.options.pdf,{_destructive:!0,progress:function(e){n.notify({page:e.page,pageNumber:e.pageNum,progress:.5+e.pageNum/e.totalPages/2,totalPages:e.totalPages})}});pe.drawing.drawDOM(p,t).always(function(){f.remove()}).then(function(e){c.resolve(e)}).fail(function(e){c.reject(e)})}function r(){var e=d.page(),t=u?d.totalPages():1;s.append(h.find("tr")),e<t?d.page(e+1):(d.unbind("change",r),i())}var s,a,l=this,c=new e.Deferred,d=l.dataSource,u=l.options.pdf.allPages,h=l.wrapper.find('table[role="grid"] > tbody'),f=e("<div>").css({position:"absolute",left:-1e4,top:-1e4}),p=l.wrapper.clone().css({height:"auto",width:"auto"}).appendTo(f);return p.find(".k-grid-content").css({height:"auto",width:"auto",overflow:"visible"}),p.find('table[role="grid"], .k-grid-footer table').css({height:"auto",width:"100%",overflow:"visible"}),p.find(".k-grid-pager, .k-grid-toolbar, .k-grouping-header").remove(),p.find(".k-grid-header, .k-grid-footer").css({paddingRight:0}),this._initPDFProgress(n),s=p.find('table[role="grid"] > tbody').empty(),a=d.page(),u?(d.bind("change",r),d.page(1)):r(),c.promise()},an.prototype._drawPDF=function(n){function i(){a&&c!==t?(s.unbind("change",o),s.one("change",function(){r.resolve(l)}),s.page(c)):r.resolve(l)}function o(){d._drawPDFShadow({width:d.wrapper.width()},{avoidLinks:d.options.pdf.avoidLinks}).done(function(e){var t=s.page(),o=a?s.totalPages():1,r={page:e,pageNumber:t,progress:t/o,totalPages:o};n.notify(r),l.append(r.page),t<o?s.page(t+1):i()}).fail(function(e){r.reject(e)})}var r,s,a,l,c,d=this;return d.options.pdf.paperSize&&"auto"!=d.options.pdf.paperSize?d._drawPDF_autoPageBreak(n):(r=new e.Deferred,s=d.dataSource,a=d.options.pdf.allPages,this._initPDFProgress(n),l=new pe.drawing.Group,c=s.page(),a?(s.bind("change",o),s.page(1)):o(),r.promise())},an.prototype._initPDFProgress=function(t){var n,i=e("<div class='k-loading-pdf-mask'><div class='k-loading-color'/></div>");i.prepend(this.wrapper.clone().css({position:"absolute",top:0,left:0})),this.wrapper.append(i),n=e("<div class='k-loading-pdf-progress'>").appendTo(i).kendoProgressBar({type:"chunk",chunkCount:10,min:0,max:1,value:0}).data("kendoProgressBar"),t.progress(function(e){n.value(e.progress)}).always(function(){pe.destroy(i),i.remove()})}),me.plugin(an),me.plugin(rn)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.listview.min",["kendo.data.min","kendo.editable.min","kendo.selectable.min"],e)}(function(){return function(e,t){var n=window.kendo,i="change",o="cancel",r="dataBound",s="dataBinding",a=n.ui.Widget,l=n.keys,c=">*:not(.k-loading-mask)",d="progress",u="error",h="k-state-focused",f="k-state-selected",p="k-edit-item",m="edit",g="remove",v="save",_="click",b=".kendoListView",w=e.proxy,y=n._activeElement,k=n.ui.progress,x=n.data.DataSource,C=n.ui.DataBoundWidget.extend({init:function(t,i){var o=this;i=e.isArray(i)?{dataSource:i}:i,a.fn.init.call(o,t,i),i=o.options,o.wrapper=t=o.element,t[0].id&&(o._itemId=t[0].id+"_lv_active"),o._element(),o._dataSource(),o._templates(),o._navigatable(),o._selectable(),o._pageable(),o._crudHandlers(),o.options.autoBind&&o.dataSource.fetch(),n.notify(o)},events:[i,o,s,r,m,g,v],options:{name:"ListView",autoBind:!0,selectable:!1,navigatable:!1,template:"",altTemplate:"",editTemplate:""},setOptions:function(e){a.fn.setOptions.call(this,e),this._templates(),this.selectable&&(this.selectable.destroy(),this.selectable=null),this._selectable()},_templates:function(){var e=this.options;this.template=n.template(e.template||""),this.altTemplate=n.template(e.altTemplate||e.template),this.editTemplate=n.template(e.editTemplate||"")},_item:function(e){return this.element.children()[e]()},items:function(){return this.element.children()},dataItem:function(t){var i=n.attr("uid"),o=e(t).closest("["+i+"]").attr(i);return this.dataSource.getByUid(o)},setDataSource:function(e){this.options.dataSource=e,this._dataSource(),this.options.autoBind&&e.fetch()},_unbindDataSource:function(){var e=this;e.dataSource.unbind(i,e._refreshHandler).unbind(d,e._progressHandler).unbind(u,e._errorHandler)},_dataSource:function(){var e=this;e.dataSource&&e._refreshHandler?e._unbindDataSource():(e._refreshHandler=w(e.refresh,e),e._progressHandler=w(e._progress,e),e._errorHandler=w(e._error,e)),e.dataSource=x.create(e.options.dataSource).bind(i,e._refreshHandler).bind(d,e._progressHandler).bind(u,e._errorHandler)},_progress:function(){k(this.element,!0)},_error:function(){k(this.element,!1)},_element:function(){this.element.addClass("k-widget k-listview").attr("role","listbox")},refresh:function(e){var i,o,a,l,c,d=this,u=d.dataSource.view(),h="",f=d.template,p=d.altTemplate,m=y();if(e=e||{},"itemchange"===e.action)return d._hasBindingTarget()||d.editable||(i=e.items[0],a=d.items().filter("["+n.attr("uid")+"="+i.uid+"]"),a.length>0&&(l=a.index(),d.angular("cleanup",function(){return{elements:[a]}}),a.replaceWith(f(i)),a=d.items().eq(l),a.attr(n.attr("uid"),i.uid),d.angular("compile",function(){return{elements:[a],data:[{dataItem:i}]}}),d.trigger("itemChange",{item:a,data:i}))),t;if(!d.trigger(s,{action:e.action||"rebind",items:e.items,index:e.index})){for(d._angularItems("cleanup"),d._destroyEditable(),l=0,c=u.length;l<c;l++)h+=l%2?p(u[l]):f(u[l]);for(d.element.html(h),o=d.items(),l=0,c=u.length;l<c;l++)o.eq(l).attr(n.attr("uid"),u[l].uid).attr("role","option").attr("aria-selected","false");d.element[0]===m&&d.options.navigatable&&d.current(o.eq(0)),d._angularItems("compile"),d.trigger(r,{action:e.action||"rebind",items:e.items,index:e.index})}},_pageable:function(){var t,i,o=this,r=o.options.pageable;e.isPlainObject(r)&&(i=r.pagerId,t=e.extend({},r,{dataSource:o.dataSource,pagerId:null}),o.pager=new n.ui.Pager(e("#"+i),t))},_selectable:function(){var e,o,r=this,s=r.options.selectable,a=r.options.navigatable;s&&(e=n.ui.Selectable.parseOptions(s).multiple,r.selectable=new n.ui.Selectable(r.element,{aria:!0,multiple:e,filter:c,change:function(){r.trigger(i)}}),a&&r.element.on("keydown"+b,function(n){if(n.keyCode===l.SPACEBAR){if(o=r.current(),n.target==n.currentTarget&&n.preventDefault(),e)if(n.ctrlKey){if(o&&o.hasClass(f))return o.removeClass(f),t}else r.selectable.clear();else r.selectable.clear();r.selectable.value(o)}}))},current:function(e){var n=this,i=n.element,o=n._current,r=n._itemId;return e===t?o:(o&&o[0]&&(o[0].id===r&&o.removeAttr("id"),o.removeClass(h),i.removeAttr("aria-activedescendant")),e&&e[0]&&(r=e[0].id||r,n._scrollTo(e[0]),i.attr("aria-activedescendant",r),e.addClass(h).attr("id",r)),n._current=e,t)},_scrollTo:function(t){var n,i,o=this,r=!1,s="scroll";"auto"==o.wrapper.css("overflow")||o.wrapper.css("overflow")==s?n=o.wrapper[0]:(n=window,r=!0),i=function(i,o){var a=r?e(t).offset()[i.toLowerCase()]:t["offset"+i],l=t["client"+o],c=e(n)[s+i](),d=e(n)[o.toLowerCase()]();a+l>c+d?e(n)[s+i](a+l-d):a<c&&e(n)[s+i](a)},i("Top","Height"),i("Left","Width")},_navigatable:function(){var t=this,i=t.options.navigatable,o=t.element,r=function(i){t.current(e(i.currentTarget)),e(i.target).is(":button,a,:input,a>.k-icon,textarea")||n.focusElement(o)};i&&(t._tabindex(),o.on("focus"+b,function(){var e=t._current;e&&e.is(":visible")||(e=t._item("first")),t.current(e)}).on("focusout"+b,function(){t._current&&t._current.removeClass(h)}).on("keydown"+b,function(i){var r,s,a=i.keyCode,c=t.current(),d=e(i.target),u=!d.is(":button,textarea,a,a>.t-icon,input"),h=d.is(":text,:password"),f=n.preventDefault,m=o.find("."+p),g=y();if(!(!u&&!h&&l.ESC!=a||h&&l.ESC!=a&&l.ENTER!=a))if(l.UP===a||l.LEFT===a)c&&(c=c.prev()),t.current(c&&c[0]?c:t._item("last")),f(i);else if(l.DOWN===a||l.RIGHT===a)c&&(c=c.next()),t.current(c&&c[0]?c:t._item("first")),f(i);else if(l.PAGEUP===a)t.current(null),t.dataSource.page(t.dataSource.page()-1),f(i);else if(l.PAGEDOWN===a)t.current(null),t.dataSource.page(t.dataSource.page()+1),f(i);else if(l.HOME===a)t.current(t._item("first")),f(i);else if(l.END===a)t.current(t._item("last")),f(i);else if(l.ENTER===a)0!==m.length&&(u||h)?(r=t.items().index(m),g&&g.blur(),t.save(),s=function(){t.element.trigger("focus"),t.current(t.items().eq(r))},t.one("dataBound",s)):""!==t.options.editTemplate&&t.edit(c);else if(l.ESC===a){if(m=o.find("."+p),0===m.length)return;r=t.items().index(m),t.cancel(),t.element.trigger("focus"),t.current(t.items().eq(r))}}),o.on("mousedown"+b+" touchstart"+b,c,w(r,t)))},clearSelection:function(){var e=this;e.selectable.clear(),e.trigger(i)},select:function(n){var i=this,o=i.selectable;return n=e(n),n.length?(o.options.multiple||(o.clear(),n=n.first()),o.value(n),t):o.value()},_destroyEditable:function(){var e=this;e.editable&&(e.editable.destroy(),delete e.editable)},_modelFromElement:function(e){var t=e.attr(n.attr("uid"));return this.dataSource.getByUid(t)},_closeEditable:function(){var e,t,i,o=this,r=o.editable,s=o.template;return r&&(r.element.index()%2&&(s=o.altTemplate),o.angular("cleanup",function(){return{elements:[r.element]}}),e=o._modelFromElement(r.element),o._destroyEditable(),i=r.element.index(),r.element.replaceWith(s(e)),t=o.items().eq(i),t.attr(n.attr("uid"),e.uid),o._hasBindingTarget()&&n.bind(t,e),o.angular("compile",function(){return{elements:[t],data:[{dataItem:e}]}})),!0},edit:function(e){var t,i,o=this,r=o._modelFromElement(e),s=r.uid;o.cancel(),e=o.items().filter("["+n.attr("uid")+"="+s+"]"),i=e.index(),e.replaceWith(o.editTemplate(r)),t=o.items().eq(i).addClass(p).attr(n.attr("uid"),r.uid),o.editable=t.kendoEditable({model:r,clearContainer:!1,errorTemplate:!1,target:o}).data("kendoEditable"),o.trigger(m,{model:r,item:t})},save:function(){var e,t,n=this,i=n.editable;i&&(t=i.element,e=n._modelFromElement(t),i.end()&&!n.trigger(v,{model:e,item:t})&&(n._closeEditable(),n.dataSource.sync()))},remove:function(e){var t=this,n=t.dataSource,i=t._modelFromElement(e);t.editable&&(n.cancelChanges(t._modelFromElement(t.editable.element)),t._closeEditable()),t.trigger(g,{model:i,item:e})||(e.hide(),n.remove(i),n.sync())},add:function(){var e,t=this,n=t.dataSource,i=n.indexOf((n.view()||[])[0]);i<0&&(i=0),t.cancel(),e=n.insert(i,{}),t.edit(t.element.find("[data-uid='"+e.uid+"']"))},cancel:function(){var e,t,n=this,i=n.dataSource;n.editable&&(e=n.editable.element,t=n._modelFromElement(e),n.trigger(o,{model:t,container:e})||(i.cancelChanges(t),n._closeEditable()))},_crudHandlers:function(){var t=this,i=_+b;t.element.on(i,".k-edit-button",function(i){var o=e(this).closest("["+n.attr("uid")+"]");t.edit(o),i.preventDefault()}),t.element.on(i,".k-delete-button",function(i){var o=e(this).closest("["+n.attr("uid")+"]");t.remove(o),i.preventDefault()}),t.element.on(i,".k-update-button",function(e){t.save(),e.preventDefault()}),t.element.on(i,".k-cancel-button",function(e){t.cancel(),e.preventDefault()})},destroy:function(){var e=this;a.fn.destroy.call(e),e._unbindDataSource(),e._destroyEditable(),e.element.off(b),e.pager&&e.pager.destroy(),n.destroy(e.element)}});n.ui.plugin(C)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.listbox.min",["kendo.draganddrop.min","kendo.data.min","kendo.selectable.min"],e)}(function(){return function(e,t){function n(t){var n=e.map(t,function(t){return e(t).index()});return n}function i(e){return t===e}function o(e){return e.clone().removeClass(ue).removeClass(W).addClass(_.format("{0} {1} {2}",H,K,j)).width(e.width())}function r(){return e("<li>").addClass(q)}var s,a,l,c,d,u,h,f,p,m,g,v,_=window.kendo,b=_.attr,w=_.data,y=_.keys,k=_.template,x=_.ui.Widget,C=w.DataSource,S=_.ui.Selectable,T=_.ui.DataBoundWidget,D=_.Class,A=e.extend,E=e.noop,I=e.proxy,M="-",R=".",F=" ",z="#",P="kendoListBox",B=R+P,L="k-state-disabled",H="k-state-selected",N=".k-item:not(.k-state-disabled)",O=".k-list:not(.k-state-disabled) >"+N,V="k-listbox-toolbar",U="li > a.k-button:not(.k-state-disabled)",W="k-state-focused",j="k-drag-clue",q="k-drop-hint",G="k-reset k-list",$=".k-reset.k-list",K="k-reset",Y="click"+B,Q="keydown"+B,X="blur"+B,Z=_._outerWidth,J=_._outerHeight,ee="change",te="dataBound",ne="add",ie="remove",oe="reorder",re="moveUp",se="moveDown",ae="transferTo",le="transferFrom",ce="transferAllTo",de="transferAllFrom",ue="k-ghost",he="uid",fe="tabindex",pe="command",me=-1,ge=1,ve="dragstart",_e="drag",be="drop",we="dragend",ye="ul.k-reset.k-list>li.k-item",ke="right",xe="bottom",Ce=[V+M+"left",V+M+ke,V+M+"top",V+M+xe],Se=T.extend({init:function(e,t){var n=this;x.fn.init.call(n,e,t),n._wrapper(),n._list(),e=n.element.attr("multiple","multiple").hide(),e[0]&&!n.options.dataSource&&(n.options.dataTextField=n.options.dataTextField||"text",n.options.dataValueField=n.options.dataValueField||"value"),n._templates(),n._selectable(),n._dataSource(),n._createToolbar(),n._createDraggable(),n._createNavigatable()},destroy:function(){var e=this;T.fn.destroy.call(e),isNaN(e._listTabIndex)||(e._getList().off(),e._listTabIndex=null),e._unbindDataSource(),e._destroySelectable(),e._destroyToolbar(),e.wrapper.off(B),e._target&&(e._target=null),e._draggable&&(e._draggable.destroy(),e.placeholder=null),_.destroy(e.element)},events:[ee,te,ne,ie,oe,ve,_e,be,we],options:{name:"ListBox",autoBind:!0,template:"",dataTextField:"",dataValueField:"",selectable:"single",draggable:null,dropSources:[],connectWith:"",navigatable:!0,toolbar:{position:ke,tools:[]},messages:{tools:{remove:"Delete",moveUp:"Move Up",moveDown:"Move Down",transferTo:"Transfer To",transferFrom:"Transfer From",transferAllTo:"Transfer All To",transferAllFrom:"Transfer All From"}}},add:function(e){var t,n=this,i=e&&e.length?e:[e],o=i.length;for(n._unbindDataSource(),t=0;t<o;t++)n._addItem(i[t]);n._bindDataSource(),n._syncElement()},_addItem:function(t){var n=this,i=n.templates.itemTemplate({item:t,r:n.templates.itemContent});e(i).attr(b(he),t.uid).appendTo(n._getList()),"string"==typeof t?n.dataSource._data.push(t):n.dataSource.add(t)},_addItemAt:function(t,n){var i=this,o=i.templates.itemTemplate({item:t,r:i.templates.itemContent});i._unbindDataSource(),"string"==typeof t?(i._insertElementAt(o,n),i.dataSource._data.push(t)):(i._insertElementAt(e(o).attr(b(he),t.uid),n),i.dataSource.add(t)),i._bindDataSource(),i._syncElement()},_insertElementAt:function(t,n){var i=this,o=i._getList();n>0?e(t).insertAfter(o.children().eq(n-1)):e(o).prepend(t)},_createNavigatable:function(){var e=this,t=e.options;t.navigatable&&e._getList().on(Y,N,I(e._click,e)).on(Q,I(e._keyDown,e)).on(X,I(e._blur,e))},_getTabIndex:function(){var e,t=this;return isNaN(t._listTabIndex)?(e=t.element.attr(fe),t._listTabIndex=isNaN(e)?0:e,t.element.removeAttr(fe),t._listTabIndex):t._listTabIndex},_blur:function(){this._target&&(this._target.removeClass(W),this._getList().removeAttr("aria-activedescendant")),this._target=null},_click:function(t){var n=this,i=e(t.currentTarget),o=n._target;o&&o.removeClass(W),n._target=i,i.addClass(W),n._getList().attr("aria-activedescendant",i.attr("id")),n._getList()[0]!==_._activeElement()&&n.focus()},_getNavigatableItem:function(e){var t,n=this;return t=n._target?n._target:n.items().filter(N).first(),e===y.UP&&n._target&&(t=n._target.prevAll(N).first()),e===y.DOWN&&n._target&&(t=n._target.nextAll(N).first()),t.length?t:null},_scrollIntoView:function(e){var t,n,i,o,r;e&&(e[0]&&(e=e[0]),t=this._getList().parent()[0],n=e.offsetTop,i=t.scrollTop,o=t.clientHeight,r=n+e.offsetHeight,i>n?i=n:r>i+o&&(i=r-o),t.scrollTop=i)},_keyDown:function(e){var n,i=this,o=e.keyCode,r=i._getNavigatableItem(o);if(i._target&&i._target.removeClass(W),(!e.shiftKey||e.ctrlKey||o!==y.DOWN&&o!==y.UP)&&(i._shiftSelecting=!1),o==y.DELETE)i._executeCommand(ie),i._target&&(i._target.removeClass(W),i._getList().removeAttr("aria-activedescendant"),i._target=null),n=!0;else if(o===y.DOWN||o===y.UP){if(!r)return e.preventDefault(),t;if(e.shiftKey&&!e.ctrlKey)i._shiftSelecting||(i.clearSelection(),i._shiftSelecting=!0),i._target&&r.hasClass("k-state-selected")?(i._target.removeClass(H),i.trigger(ee)):i.select("single"==i.options.selectable?r:r.add(i._target));else{if(e.shiftKey&&e.ctrlKey)return i._executeCommand(o===y.DOWN?se:re),i._scrollIntoView(i._target),e.preventDefault(),t;e.shiftKey||e.ctrlKey||("multiple"===i.options.selectable&&i.clearSelection(),i.select(r))}i._target=r,i._target?(i._target.addClass(W),i._scrollIntoView(i._target),i._getList().attr("aria-activedescendant",i._target.attr("id"))):i._getList().removeAttr("aria-activedescendant"),n=!0}else o==y.SPACEBAR?(e.ctrlKey&&i._target?i._target.hasClass(H)?(i._target.removeClass(H),i.trigger(ee)):i.select(i._target):(i.clearSelection(),i.select(i._target)),n=!0):e.ctrlKey&&o==y.RIGHT?(i._executeCommand(e.shiftKey?ce:ae),i._target=i.select().length?i.select():null,n=!0):e.ctrlKey&&o==y.LEFT&&(i._executeCommand(e.shiftKey?de:le),n=!0);n&&e.preventDefault()},focus:function(){_.focusElement(this._getList())},_createDraggable:function(){var t,n=this,i=n.options.draggable;if(i){if(t=i.hint,!n.options.selectable)throw Error("Dragging requires selection to be enabled");t||(t=o),n._draggable=new _.ui.Draggable(n.wrapper,{filter:i.filter?i.filter:ye,hint:_.isFunction(t)?t:e(t),dragstart:I(n._dragstart,n),dragcancel:I(n._clear,n),drag:I(n._drag,n),dragend:I(n._dragend,n)})}},_dragstart:function(n){var i=this,o=i.draggedElement=n.currentTarget,s=i.options.draggable.placeholder,a=i.dataItem(o),l={dataItems:a,items:e(o),draggableEvent:n};return i.options.draggable.enabled===!1?(n.preventDefault(),t):(s||(s=r),i.placeholder=e(_.isFunction(s)?s.call(i,o):s),o.is(R+L)?n.preventDefault():i.trigger(ve,l)?n.preventDefault():(i.clearSelection(),i.select(o),o.addClass(ue)),t)},_clear:function(){this.draggedElement.removeClass(ue),this.placeholder.remove()},_findElementUnderCursor:function(t){var n=_.elementUnderCursor(t),i=t.sender;return(e.contains(i.hint[0],n)||i.hint[0]===n)&&(i.hint.hide(),n=_.elementUnderCursor(t),i.hint.show()),n},_findTarget:function(t){var n,i,o=this,r=o._findElementUnderCursor(t),s=e(r),a=o._getList();return e.contains(a[0],r)?(n=o.items(),r=s.is("li")?r:s.closest("li")[0],i=n.filter(r)[0]||n.has(r)[0],i?(i=e(i),i.hasClass(L)?null:{element:i,listBox:o}):null):a[0]==r||a.parent()[0]==r?{element:e(a),appendToBottom:!0,listBox:o}:o._searchConnectedListBox(s)},_getElementCenter:function(e){var t=e.length?_.getOffset(e):null;return t&&(t.top+=J(e)/2,t.left+=Z(e)/2),t},_searchConnectedListBox:function(t){var n,i,o,r,s=t;return r=t.hasClass("k-list-scroller k-selectable")?t:t.closest(".k-list-scroller.k-selectable"),r.length?(n=r.parent().find("[data-role='listbox']").getKendoListBox(),n&&e.inArray(this.element[0].id,n.options.dropSources)!==-1?(i=n.items(),t=t.is("li")?t[0]:t.closest("li")[0],o=i.filter(t)[0]||i.has(t)[0],o?(o=e(o),o.hasClass(L)?null:{element:o,listBox:n}):!i.length||s.hasClass("k-list-scroller k-selectable")||s.hasClass("k-reset k-list")?{element:n._getList(),listBox:n,appendToBottom:!0}:null):null):null},_drag:function(n){var i,o,r,s=this,a=s.draggedElement,l=s._findTarget(n),c={left:n.x.location,top:n.y.location},d=s.dataItem(a),u={dataItems:[d],items:e(a),draggableEvent:n};if(s.trigger(_e,u))return n.preventDefault(),t;if(l){if(i=this._getElementCenter(l.element),o={left:Math.round(c.left-i.left),top:Math.round(c.top-i.top)},l.appendToBottom)return s._movePlaceholder(l,null,a),t;o.top<0?r="prev":o.top>0&&(r="next"),r&&l.element[0]!=s.placeholder[0]&&s._movePlaceholder(l,r,a)}else s.placeholder.parent().length&&s.placeholder.remove()},_movePlaceholder:function(t,n,i){var o=this,s=o.placeholder,a=t.listBox.options.draggable;s.parent().length&&(o.placeholder.remove(),o.placeholder=e(a&&a.placeholder?_.isFunction(a.placeholder)?a.placeholder.call(o,i):a.placeholder:r.call(o,i))),n?"prev"===n?t.element.before(o.placeholder):"next"===n&&t.element.after(o.placeholder):t.element.append(o.placeholder)},_dragend:function(n){var i=this,o=i.draggedElement,r=i.items(),s=r.not(i.draggedElement).index(i.placeholder),a=r.not(i.placeholder).index(i.draggedElement),l=i.dataItem(o),c={dataItems:[l],items:e(o)},d=i.placeholder.closest(".k-widget.k-listbox").find("[data-role='listbox']").getKendoListBox();return i.trigger(be,A({},c,{draggableEvent:n}))?(n.preventDefault(),this._clear(),t):(s>=0?s===a||i.trigger(oe,A({},c,{offset:s-a}))||(o.removeClass(ue),i.reorder(o,s)):d&&(i.trigger(ie,c)||i.remove(e(o)),d.trigger(ne,c)||d._addItemAt(l,d.items().index(i.placeholder))),i._clear(),i._draggable.dropped=!0,i.trigger(we,A({},c,{draggableEvent:n})),i._updateToolbar(),i._updateAllToolbars(),t)},reorder:function(t,n){var i=this,o=i.dataSource,r=i.dataItem(t),s=o.at(n),a=i.items()[n],l=e(t);r&&a&&s&&(i._removeElement(l),i._insertElementAt(l,n),i._updateToolbar())},remove:function(t){var n,i=this,o=i._getItems(t),r=o.length;for(i._unbindDataSource(),n=0;n<r;n++)i._removeItem(e(o[n]));i._bindDataSource(),i._syncElement(),i._updateToolbar(),i._updateAllToolbars()},_removeItem:function(e){var t,n,i=this,o=i.dataSource,r=i.dataItem(e);if(r&&o){if("string"==typeof r){for(t=o._data,n=0;n<t.length;n++)if(r===t[n]){t[n]=t[t.length-1],t.pop();break}}else o.remove(r);i._removeElement(e)}},_removeElement:function(t){_.destroy(t),e(t).off().remove()},dataItem:function(t){var n=b(he),i=e(t).attr(n)||e(t).closest("["+n+"]").attr(n);return i?this.dataSource.getByUid(i):e(t).html()},_dataItems:function(t){var n,i=[],o=e(t),r=o.length;for(n=0;n<r;n++)i.push(this.dataItem(o.eq(n)));return i},items:function(){var e=this._getList();return e.children()},select:function(e){var t,n=this,o=n.selectable;return i(e)?o.value():(t=n.items().filter(e).filter(O),o.options.multiple||(o.clear(),t=t.first()),o.value(t))},clearSelection:function(){var e=this,t=e.selectable;t&&t.clear()},enable:function(t,n){var o,r=this,s=!!i(n)||!!n,a=r._getItems(t),l=a.length;for(o=0;o<l;o++)r._enableItem(e(a[o]),s);r._updateAllToolbars()},_enableItem:function(t,n){var i=this,o=i.dataItem(t);o&&(n?e(t).removeClass(L):e(t).addClass(L).removeClass(H))},setDataSource:function(e){var t=this;t.options.dataSource=e,t._dataSource()},_dataSource:function(){var t=this,n=t.options,i=n.dataSource||{};i=e.isArray(i)?{data:i}:i,i.select=t.element,i.fields=[{field:n.dataTextField},{field:n.dataValueField}],t._unbindDataSource(),t.dataSource=C.create(i),t._bindDataSource(),t.options.autoBind&&t.dataSource.fetch()},_bindDataSource:function(){var e=this,t=e.dataSource;e._dataChangeHandler=I(e.refresh,e),t&&t.bind(ee,e._dataChangeHandler)},_unbindDataSource:function(){var e=this,t=e.dataSource;t&&t.unbind(ee,e._dataChangeHandler)},_wrapper:function(){var t=this,n=t.element,i=n.parent("div.k-listbox");i[0]||(i=n.wrap('<div class="k-widget k-listbox" deselectable="on" />').parent(),i[0].style.cssText=n[0].style.cssText,i[0].title=n[0].title,e('<div class="k-list-scroller" />').insertBefore(n)),t.wrapper=i.addClass(n[0].className).css("display",""),t._innerWrapper=e(i[0].firstChild)},_list:function(){var t=this;e("<ul class='"+G+"' role='listbox'></ul>").appendTo(t._innerWrapper),t.options.navigatable&&t._getList().attr(fe,t._getTabIndex())},_templates:function(){var e,t=this,n=this.options;e=n.template&&"string"==typeof n.template?_.template(n.template):n.template?n.template:_.template("${"+_.expr(n.dataTextField,"data")+"}",{useWithBlock:!1}),t.templates={itemTemplate:_.template("# var item = data.item, r = data.r; # <li class='k-item' role='option' aria-selected='false'>#=r(item)#</li>",{useWithBlock:!1}),itemContent:e,toolbar:"<div class='"+V+"'></div>"}},refresh:function(){var e,t=this,n=t.dataSource.view(),i=t.templates.itemTemplate,o="";for(e=0;e<n.length;e++)o+=i({item:n[e],r:t.templates.itemContent});t._getList().html(o),t._setItemIds(),t._createToolbar(),t._syncElement(),t._updateToolbar(),t._updateAllToolbars(),t.trigger(te)},_syncElement:function(){var e,t="",n=this.dataSource.view();for(e=0;e<n.length;e++)t+=this._option(n[e][this.options.dataValueField]||n[e],n[e][this.options.dataTextField]||n[e],!0);this.element.html(t)},_option:function(e,n){var i="<option";return e!==t&&(e+="",e.indexOf('"')!==-1&&(e=e.replace(/"/g,"&quot;")),i+=' value="'+e+'"'),i+=" selected>",n!==t&&(i+=_.htmlEncode(n)),i+="</option>"},_setItemIds:function(){var e,t=this,n=t.items(),i=t.dataSource.view(),o=i.length;for(e=0;e<o;e++)n.eq(e).attr(b(he),i[e].uid).attr("id",i[e].uid)},_selectable:function(){var e=this,t=e.options.selectable,n=S.parseOptions(t);n.multiple&&e.element.attr("aria-multiselectable","true"),e.selectable=new S(e._innerWrapper,{aria:!0,multiple:n.multiple,filter:N,change:I(e._onSelect,e)})},_onSelect:function(){var e=this;e._updateToolbar(),e._updateAllToolbars(),e.trigger(ee)},_destroySelectable:function(){var e=this;e.selectable&&e.selectable.element&&(e.selectable.destroy(),e.selectable=null)},_getList:function(){return this.wrapper.find($)},_getItems:function(e){return this.items().filter(e)},_createToolbar:function(){var t,n=this,i=n.options.toolbar,o=i.position||ke,r=o===xe?"insertAfter":"insertBefore",s=i.tools||[],a=n.options.messages;n._destroyToolbar(),n.wrapper.removeClass(Ce.join(F)),s.length&&s.length>0&&(t=e(n.templates.toolbar)[r](n._innerWrapper),n.toolbar=new v(t,A({},i,{listBox:n,messages:a})),n.wrapper.addClass(V+M+o))},_destroyToolbar:function(){var e=this;e.toolbar&&(e.toolbar.destroy(),e.toolbar=null)},_executeCommand:function(e){var t=this,n=s.current.create(e,{listBox:t});n&&(n.execute(),t._updateToolbar(),t._updateAllToolbars())},_updateToolbar:function(){var e=this.toolbar;e&&e._updateToolStates()},_updateAllToolbars:function(){var t,n,i=e("select[data-role='listbox']"),o=i.length;for(n=0;n<o;n++)t=e(i[n]).data(P),t&&t._updateToolbar()}});_.ui.plugin(Se),s=D.extend({init:function(){this._commands=[]},register:function(e,t){this._commands.push({commandName:e,commandType:t})},create:function(e,t){var n,i,o,r=this._commands,s=r.length,a=e?e.toLowerCase():"";for(o=0;o<s;o++)if(i=r[o],i.commandName.toLowerCase()===a){n=i;break}if(n)return new n.commandType(t)}}),s.current=new s,a=D.extend({init:function(e){var t=this;t.options=A({},t.options,e),t.listBox=t.options.listBox},options:{listBox:null},getItems:function(){return e(this.listBox.select())},execute:E,canExecute:E}),l=a.extend({execute:function(){var e=this,t=e.listBox,n=e.getItems();
t.trigger(ie,{dataItems:t._dataItems(n),items:n})||t.remove(n)},canExecute:function(){return this.listBox.select().length>0}}),s.current.register(ie,l),c=a.extend({execute:function(){var e=this;e.canExecute()&&e.moveItems()},canExecute:E,moveItems:function(){var t,i=this,o=i.listBox,r=i.options,s=i.getItems(),a=r.offset,l=n(s),c=e.makeArray(s.sort(i.itemComparer)),d=r.moveAction;if(!o.trigger(oe,{dataItems:o._dataItems(c),items:e(c),offset:a}))for(;c.length>0&&l.length>0;)t=c[d](),o.reorder(t,l[d]()+a)},options:{offset:0,moveAction:"pop"},itemComparer:function(t,n){var i=e(t).index(),o=e(n).index();return i===o?0:i>o?1:-1}}),d=c.extend({options:{offset:me,moveAction:"shift"},canExecute:function(){var e=this.getItems(),t=n(e);return t.length>0&&t[0]>0}}),s.current.register(re,d),u=c.extend({options:{offset:ge,moveAction:"pop"},canExecute:function(){var t=this,i=t.getItems(),o=n(i);return o.length>0&&e(o).last()[0]<t.listBox.items().length-1}}),s.current.register(se,u),h=a.extend({options:{filter:N},execute:function(){var e=this,t=e.getSourceListBox(),n=e.getItems().filter(e.options.filter),i=t?t._dataItems(n):[],o=e.getDestinationListBox(),r=e.getUpdatedSelection(n);o&&n.length>0&&(o.trigger(ne,{dataItems:i,items:n})||o.add(i),t.trigger(ie,{dataItems:i,items:n})||(t.remove(n),e.updateSelection(r)))},getUpdatedSelection:function(t){var n=this,i=n.options.filter,o=n.getSourceListBox(),r=o?o.items().filter(i).last():null,s=e(t).filter(r).length>0,a=s?e(t).prevAll(i)[0]:e(t).nextAll(i)[0];return 1===e(t).length&&a?a:null},updateSelection:function(t){var n=this.getSourceListBox();n&&t&&(e(n.select(e(t))),n._scrollIntoView(t))},getSourceListBox:E,getDestinationListBox:E}),f=h.extend({canExecute:function(){var e=this.getSourceListBox();return!!e&&e.select().length>0},getSourceListBox:function(){return this.listBox},getDestinationListBox:function(){var t=this.getSourceListBox();return t&&t.options.connectWith?e(z+t.options.connectWith).data(P):null},getItems:function(){var t=this.getSourceListBox();return t?e(t.select()):e()}}),s.current.register(ae,f),p=h.extend({canExecute:function(){var e=this.getSourceListBox();return!!e&&e.select().length>0},getSourceListBox:function(){var t=this.getDestinationListBox();return t&&t.options.connectWith?e(z+t.options.connectWith).data(P):null},getDestinationListBox:function(){return this.listBox},getItems:function(){var t=this.getSourceListBox();return t?e(t.select()):e()}}),s.current.register(le,p),m=f.extend({canExecute:function(){var e=this.getSourceListBox();return!!e&&e.items().filter(N).length>0},getItems:function(){var t=this.getSourceListBox();return t?t.items():e()},getUpdatedSelection:E,updateSelection:E}),s.current.register(ce,m),g=p.extend({canExecute:function(){var e=this.getSourceListBox();return!!e&&e.items().filter(N).length>0},getItems:function(){var t=this.getSourceListBox();return t?t.items():e()},getUpdatedSelection:E,updateSelection:E}),s.current.register(de,g),v=D.extend({init:function(t,n){var i=this;i.element=e(t).addClass(V),i.options=A({},i.options,n),i.listBox=i.options.listBox,i._initTemplates(),i._createTools(),i._updateToolStates(),i._attachEventHandlers()},destroy:function(){var e=this;e._detachEventHandlers(),_.destroy(e.element),e.element.remove(),e.element=null},options:{position:ke,tools:[]},_initTemplates:function(){this.templates={tool:k("<li><a href='\\\\#' class='k-button k-button-icon' data-command='#= command #' title='#= text #' aria-label='#= text #' role='button'><span class='k-icon #= iconClass #'></span></a></li>")}},_createTools:function(){var t,n,i=this,o=i.options.tools,r=o.length,s=i.options.messages.tools,a=i._createToolList();for(n=0;n<r;n++)t=A({},v.defaultTools[o[n]],{text:s[o[n]]}),t&&a.append(e(i.templates.tool(t)));i.element.append(a)},_createToolList:function(){return e("<ul class='k-reset' />")},_attachEventHandlers:function(){var e=this;e.element.on(Y,U,I(e._onToolClick,e))},_detachEventHandlers:function(){this.element.off(B).find("*").off(B)},_onToolClick:function(t){t.preventDefault(),this._executeToolCommand(e(t.currentTarget).data(pe))},_executeToolCommand:function(e){var t=this,n=t.listBox;n&&n._executeCommand(e)},_updateToolStates:function(){var e,t=this,n=t.options.tools,i=n.length;for(e=0;e<i;e++)t._updateToolState(n[e])},_updateToolState:function(t){var n=this,i=s.current.create(t,{listBox:n.listBox}),o=n.element.find("[data-command='"+t+"']")[0];o&&i&&i.canExecute&&(i.canExecute()?e(o).removeClass(L):e(o).addClass(L))}}),v.defaultTools={remove:{command:ie,iconClass:"k-i-x"},moveUp:{command:re,iconClass:"k-i-arrow-60-up"},moveDown:{command:se,iconClass:"k-i-arrow-60-down"},transferTo:{command:ae,iconClass:"k-i-arrow-60-right"},transferFrom:{command:le,iconClass:"k-i-arrow-60-left"},transferAllTo:{command:ce,iconClass:"k-i-arrow-double-60-right"},transferAllFrom:{command:de,iconClass:"k-i-arrow-double-60-left"}},A(Se,{ToolBar:v})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.upload.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(t){return e.map(i(t),function(e){return e.name}).join(", ")}function i(e){var t=e[0];return t.files?o(t.files):[{name:a(t.value),extension:s(t.value),size:null}]}function o(t){return e.map(t,function(e){return r(e)})}function r(e){var t=e.name||e.fileName;return{name:C.htmlEncode(t),extension:s(t),size:"number"==typeof e.size?e.size:e.fileSize,rawFile:e}}function s(e){var t=e.match(A);return t?t[0]:""}function a(e){var t=e.lastIndexOf("\\");return t!=-1?e.substr(t+1):e}function l(t,n){var i=C.guid();return e.map(t,function(e){return e.uid=n?C.guid():i,e})}function c(e,t){var n,i=d(t.allowedExtensions),o=t.maxFileSize,r=t.minFileSize;for(n=0;n<e.length;n++)u(e[n],i),h(e[n],r,o)}function d(t){var n=e.map(t,function(e){var t="."===e.substring(0,1)?e:"."+e;return t.toLowerCase()});return n}function u(t,n){n.length>0&&n.indexOf(t.extension.toLowerCase())<0&&(t.validationErrors=t.validationErrors||[],e.inArray(j,t.validationErrors)===-1&&t.validationErrors.push(j))}function h(t,n,i){0!==n&&t.size<n&&(t.validationErrors=t.validationErrors||[],e.inArray(W,t.validationErrors)===-1&&t.validationErrors.push(W)),0!==i&&t.size>i&&(t.validationErrors=t.validationErrors||[],e.inArray(U,t.validationErrors)===-1&&t.validationErrors.push(U))}function f(e){var t,n=0;if("number"!=typeof e[0].size)return"";for(t=0;t<e.length;t++)e[t].size&&(n+=e[t].size);return n/=1024,n<1024?n.toFixed(2)+" KB":(n/1024).toFixed(2)+" MB"}function p(t){return!t.multiple&&e(".k-file",t.wrapper).length>1}function m(n,i,o,r){var s,a;return i._supportsRemove()?(s=n.data("fileNames"),a=e.map(s,function(e){return e.name}),r===!1?(i._removeFileEntry(n),t):(i._submitRemove(a,o,function(e,t,o){var r=i.trigger(R,{operation:"remove",files:s,response:e,XMLHttpRequest:o});r||i._removeFileEntry(n)},function(e){p(i)&&i._removeFileEntry(n),i.trigger(F,{operation:"remove",files:s,XMLHttpRequest:e}),D("Server response: "+e.responseText)}),t)):(!p(i)&&r||i._removeFileEntry(n),t)}function g(t,n,i){var o=!1,r="";try{r=e.parseJSON(v(t)),o=!0}catch(s){i()}o&&n(r)}function v(e){return t!==e&&""!==e||(e="{}"),e}function _(e){e.stopPropagation(),e.preventDefault()}function b(e,t,n,i){var o,r;e.on("dragenter"+t,function(e){n(e),r=new Date,o||(o=setInterval(function(){var e=new Date-r;e>100&&(i(),clearInterval(o),o=null)},100))}).on("dragover"+t,function(){r=new Date})}function w(e){return e.is(".k-file-progress, .k-file-success, .k-file-error")}function y(t){return e(t.target).closest(".k-file")}var k,x,C=window.kendo,S=C.ui.Widget,T=C.antiForgeryTokens,D=C.logToConsole,A=/\.([^\.]+)$/,E=".kendoUpload",I="select",M="upload",R="success",F="error",z="complete",P="cancel",B="clear",L="pause",H="resume",N="progress",O="remove",V="validationErrors",U="invalidMaxFileSize",W="invalidMinFileSize",j="invalidFileExtension",q=1e3,G=2e3,$={loading:"k-i-loading",warning:"k-i-warning",success:"k-i-check"},K=S.extend({init:function(t,n){var i,o,r,s=this;S.fn.init.call(s,t,n),s.name=t.name,s.multiple=s.options.multiple,s.directory=s.options.directory,s.localization=s.options.localization,i=s.element,s.wrapper=i.closest(".k-upload"),0===s.wrapper.length&&(s.wrapper=s._wrapInput(i)),s._activeInput(i),s.toggle(s.options.enabled),o=s._ns=E+"-"+C.guid(),i.closest("form").on("submit"+o,e.proxy(s._onParentFormSubmit,s)).on("reset"+o,e.proxy(s._onParentFormReset,s)),s.options.async.saveUrl?(s._module=s._supportsFormData()?new x(s):new k(s),s._async=!0,r=s.options.files,r.length>0&&s._renderInitialFiles(r)):s._module=new Y(s),s._supportsDrop()&&(""!==s.options.dropZone?s._setupCustomDropZone():s._setupDropZone()),s.wrapper.on("click",".k-upload-action",e.proxy(s._onFileAction,s)).on("click",".k-clear-selected",e.proxy(s._onClearSelected,s)).on("click",".k-upload-selected",e.proxy(s._onUploadSelected,s)),s.element.val()&&s._onInputChange({target:s.element})},events:[I,M,R,F,z,P,B,N,O,L,H],options:{name:"Upload",enabled:!0,multiple:!0,directory:!1,showFileList:!0,template:"",files:[],async:{autoRetryAfter:0,bufferChunkSize:1e7,maxAutoRetries:1,removeVerb:"POST",autoUpload:!0,withCredentials:!0,accept:"*/*; q=0.5, application/json",useArrayBuffer:!1},localization:{select:"Select files...",cancel:"Cancel",retry:"Retry",remove:"Remove",pause:"Pause",resume:"Resume",clearSelectedFiles:"Clear",uploadSelectedFiles:"Upload",dropFilesHere:"Drop files here to upload",invalidFiles:"Invalid file(s). Please check file upload requirements.",statusUploading:"uploading",statusUploaded:"uploaded",statusWarning:"warning",statusFailed:"failed",headerStatusUploading:"Uploading...",headerStatusPaused:"Paused",headerStatusUploaded:"Done",invalidMaxFileSize:"File size too large.",invalidMinFileSize:"File size too small.",invalidFileExtension:"File type not allowed."},validation:{allowedExtensions:[],maxFileSize:0,minFileSize:0},dropZone:""},setOptions:function(e){var t=this,n=t.element;S.fn.setOptions.call(t,e),t.multiple=t.options.multiple,t.directory=t.options.directory,n.attr("multiple",!!t._supportsMultiple()&&t.multiple),t.directory&&(n.attr("webkitdirectory",t.directory),n.attr("directory",t.directory)),t.toggle(t.options.enabled)},enable:function(e){e=t===e||e,this.toggle(e)},disable:function(){this.toggle(!1)},toggle:function(e){e=t===e?e:!e,this.wrapper.toggleClass("k-state-disabled",e),this.element.prop("disabled",e)},focus:function(){this.element.focus()},destroy:function(){var t=this,n=e(t.options.dropZone);e(document).add(e(".k-dropzone",t.wrapper)).add(t.wrapper.closest("form")).off(t._ns),n.length>0&&n.off(t._ns),e(t.element).off(E),S.fn.destroy.call(t)},pause:function(t){this._module.onPause({target:e(t,this.wrapper)});var n=t.find(".k-i-pause-sm");n.removeClass("k-i-pause-sm").addClass("k-i-play-sm").attr("title",this.localization.resume),e(n).parent().attr("aria-label",this.localization.resume)},resume:function(t){this._module.onResume({target:e(t,this.wrapper)});var n=t.find(".k-i-play-sm");n.removeClass("k-i-play-sm").addClass("k-i-pause-sm").attr("title",this.localization.pause),e(n).parent().attr("aria-label",this.localization.pause)},upload:function(){var e=this;e._module.onSaveSelected()},getFiles:function(){var t,n,i,o=this,r=[],s=o.wrapper.find(".k-file");for(n=0;n<s.length;n++)if(t=e(s[n]).data("fileNames"))for(i=0;i<t.length;i++)r.push(t[i]);return r},clearAllFiles:function(){var e=this,t=e.wrapper.find(".k-file");t.each(function(t,n){e._removeFileByDomElement(n,!1)})},removeAllFiles:function(){var e=this,t=e.wrapper.find(".k-file");t.each(function(t,n){e._removeFileByDomElement(n,!0)})},removeFileByUid:function(e){this._removeFileByUid(e,!0)},clearFileByUid:function(e){this._removeFileByUid(e,!1)},_removeFileByUid:function(t,n){var i,o=this;"string"==typeof t&&(i=e(".k-file["+C.attr("uid")+'="'+t+'"]',o.wrapper),i.length>0&&o._removeFileByDomElement(i,n))},clearFile:function(e){this._removeFile(e,!1)},removeFile:function(e){this._removeFile(e,!0)},_removeFile:function(t,n){var i,o=this,r=o.wrapper.find(".k-file");"function"==typeof t&&r.each(function(r,s){i=e(s).data("fileNames"),t(i)&&o._removeFileByDomElement(s,n)})},_removeFileByDomElement:function(t,n){var i,o=this,r={target:e(t,o.wrapper)};o.options.async.saveUrl?(e(t).hasClass("k-file-progress")?o._module.onCancel(r):o._module.onRemove(r,{},n),i=e(".k-file",o.wrapper),0===i.length?o._hideHeaderUploadstatus():o._updateHeaderUploadStatus()):o._module.onRemove(r,{},n)},_addInput:function(t){if(t[0].nodeType){var n=this,i=t.clone().val("");i.insertAfter(n.element).data("kendoUpload",n),e(n.element).hide().attr("tabindex","-1").removeAttr("id").off(E),n._activeInput(i),n.element.focus()}},_activeInput:function(t){var n=this,i=n.wrapper;n.element=t,n.directory&&(t.attr("webkitdirectory",n.directory),t.attr("directory",n.directory)),t.attr("multiple",!!n._supportsMultiple()&&n.multiple).attr("autocomplete","off").on("click"+E,function(e){i.hasClass("k-state-disabled")&&e.preventDefault()}).on("focus"+E,function(){e(this).parent().addClass("k-state-focused")}).on("blur"+E,function(){e(this).parent().removeClass("k-state-focused")}).on("change"+E,e.proxy(n._onInputChange,n)).on("keydown"+E,e.proxy(n._onInputKeyDown,n))},_onInputKeyDown:function(e){var t=this,n=t.wrapper.find(".k-upload-action:visible:first");e.keyCode===C.keys.TAB&&n.length>0&&!e.shiftKey&&(e.preventDefault(),n.focus())},_onInputChange:function(t){var n,i=this,o=e(t.target),r=l(i._inputFiles(o),i._isAsyncNonBatch());c(r,i.options.validation),n=i.trigger(I,{files:r}),n?(i._addInput(o),o.remove()):i._module.onSelect({target:o},r)},_readDirectory:function(t){var n=new e.Deferred,i=t.createReader(),o=[],r=function(){i.readEntries(function(e){e.length?(o=o.concat(e),r()):n.resolve(o)},n.reject)};return r(),n.promise()},_readFile:function(e){var t=this,n=e.fullPath;e.file(function(e){e.relativePath=n.slice(1),t.droppedFolderFiles.push(e),t.droppedFolderCounter--,0===t.droppedFolderCounter&&setTimeout(function(){0===t.droppedFolderCounter&&t.droppedFolderFiles.length&&(t._proceedDroppedItems(t.droppedFolderFiles),t.droppedFolderFiles=[])},0)},function(){D("File error.")})},_traverseFileTree:function(e,t){var n=this;t||n.droppedFolderCounter--,this._readDirectory(e).then(function(e){n.droppedFolderCounter+=e.length;for(var t=0;t<e.length;t++)e[t].isFile?n._readFile(e[t]):e[t].isDirectory&&n._traverseFileTree(e[t])})},_onDrop:function(e){var t,n,i,o=e.originalEvent.dataTransfer,r=this,s=o.files;if(_(e),r.options.directoryDrop&&o.items)for(t=o.items.length,r.droppedFolderCounter=0,r.droppedFolderFiles=[],n=0;n<t;n++)o.items[n].webkitGetAsEntry?(i=o.items[n].webkitGetAsEntry(),i.isDirectory?r._traverseFileTree(i,!0):i.isFile&&r.droppedFolderFiles.push(o.files[n])):r._proceedDroppedItems(s);else r._proceedDroppedItems(s)},_proceedDroppedItems:function(t){var n,i=this,r=l(o(t),i._isAsyncNonBatch());t.length>0&&!i.wrapper.hasClass("k-state-disabled")&&(!i.multiple&&r.length>1&&r.splice(1,r.length-1),c(r,i.options.validation),n=i.trigger(I,{files:r}),n||i._module.onSelect({target:e(".k-dropzone",i.wrapper)},r))},_filesContainValidationErrors:function(t){var n=!1;return e(t).each(function(e,t){if(t[V]&&t[V].length>0)return n=!0,!1}),n},_isAsyncNonBatch:function(){return this._async&&!this.options.async.batch||!1},_renderInitialFiles:function(e){var t,n,i=this,o=0;for(e=l(e,!0),o=0;o<e.length;o++)t=e[o],n=i._enqueueFile(t.name,{fileNames:[t]}),n.addClass("k-file-success").data("files",[e[o]]),i._supportsRemove()&&i._fileAction(n,O)},_prepareTemplateData:function(e,t){var n=t.fileNames,i={},o=0,r=0;for(r=0;r<n.length;r++)o+=n[r].size;return i.name=e,i.size=o,i.files=t.fileNames,i},_prepareDefaultSingleFileEntryTemplate:function(t){var n=this,i=t.fileNames[0],o=f(t.fileNames),r=i[V],s="";return s+=r&&r.length>0?"<li class='k-file k-file-invalid'><span class='k-progress'></span><span class='k-file-invalid-extension-wrapper'><span class='k-file-invalid-icon'>!</span><span class='k-file-state'></span></span><span class='k-file-name-size-wrapper'><span class='k-file-name k-file-name-invalid' title='"+i.name+"'>"+i.name+"</span><span class='k-file-validation-message'>"+n.localization[r[0]]+"</span></span>":"<li class='k-file'><span class='k-progress'></span><span class='k-file-extension-wrapper'><span class='k-file-extension'>"+i.extension.substring(1)+"</span><span class='k-file-state'></span></span><span class='k-file-name-size-wrapper'><span class='k-file-name' title='"+i.name+"'>"+i.name+"</span><span class='k-file-size'>"+o+"</span></span>",s+="<strong class='k-upload-status'></strong>",e(s)},_prepareDefaultMultipleFileEntriesTemplate:function(t){var n,i,o=this,r=t.fileNames,s=o._filesContainValidationErrors(r),a=f(r),l="";for(l+=s?"<li class='k-file k-file-invalid'><span class='k-progress'></span><span class='k-multiple-files-invalid-extension-wrapper'><span class='k-file-invalid-icon'>!</span>":"<li class='k-file'><span class='k-progress'></span><span class='k-multiple-files-extension-wrapper'>",l+="<span class='k-file-state'></span></span>",r.sort(function(e,t){return e[V]?-1:t[V]?1:0}),l+="<span class='k-file-name-size-wrapper'>",n=0;n<r.length;n++)i=r[n],l+=i[V]&&i[V].length>0?"<span class='k-file-name k-file-name-invalid' title='"+i.name+"'>"+i.name+"</span>":"<span class='k-file-name' title='"+i.name+"'>"+i.name+"</span>";return l+=s?"<span class='k-file-validation-message'>"+o.localization.invalidFiles+"</span>":"<span class='k-file-information'>Total: "+r.length+" files, "+a+"</span>",l+="</span><strong class='k-upload-status'></strong>",e(l)},_enqueueFile:function(t,n){var i,o,r,s,a=this,l=n.fileNames[0].uid,c=e(".k-upload-files",a.wrapper),d=a.options,u=d.template;return 0===c.length&&(c=e("<ul class='k-upload-files k-reset'></ul>").appendTo(a.wrapper),a.options.showFileList||c.hide(),a.wrapper.removeClass("k-upload-empty")),i=e(".k-file",c),u?(r=a._prepareTemplateData(t,n),u=C.template(u),o=e("<li class='k-file'>"+u(r)+"</li>"),o.find(".k-upload-action").addClass("k-button"),a.angular("compile",function(){return{elements:o,data:[r]}})):o=1===n.fileNames.length?a._prepareDefaultSingleFileEntryTemplate(n):a._prepareDefaultMultipleFileEntriesTemplate(n),o.attr(C.attr("uid"),l).appendTo(c).data(n),a._async||e(".k-progress",o).width("100%"),!a.multiple&&i.length>0&&(s={files:i.data("fileNames"),headers:{}},a.trigger(O,s)||a._module.onRemove({target:e(i,a.wrapper)},s)),o},_removeFileEntry:function(t){var n,i,o,r=this,s=t.closest(".k-upload-files");t.remove(),n=e(".k-file",s),i=e(".k-file-success, .k-file-error",s),o=e(".k-file-invalid",s),i.length!==n.length&&o.length!==n.length||this._hideUploadButton(),0===n.length?(s.remove(),r.wrapper.addClass("k-upload-empty"),r._hideHeaderUploadstatus()):r._updateHeaderUploadStatus()},_fileAction:function(e,t,n){var i,o={remove:"k-i-x",cancel:"k-i-cancel",retry:"k-i-retry",pause:"k-i-pause-sm"},r={remove:"k-i-close",cancel:"k-i-close",retry:"k-i-reload-sm",pause:"k-i-pause-sm"};o.hasOwnProperty(t)&&(n||this._clearFileAction(e),this.options.template?(i=e.find(".k-upload-action").first(),i.find(".k-icon").length?i.next(".k-upload-action").length&&i.next(".k-upload-action").addClass("k-button").append("<span class='k-icon "+r[t]+" "+o[t]+"' title='"+this.localization[t]+"'aria-label='"+this.localization[t]+"'></span>").show():i.addClass("k-button").append("<span class='k-icon "+r[t]+" "+o[t]+"' title='"+this.localization[t]+"'aria-label='"+this.localization[t]+"'></span>").show()):(n||e.find(".k-upload-status .k-upload-action").remove(),e.find(".k-upload-status").append(this._renderAction(o[t],this.localization[t],r[t]))))},_fileState:function(t,n){var i=this.localization,o={uploading:{text:i.statusUploading},uploaded:{text:i.statusUploaded},failed:{text:i.statusFailed}},r=o[n];r&&e("span.k-file-state",t).text(r.text)},_renderAction:function(t,n,i){return""!==t?e("<button type='button' class='k-button k-upload-action' aria-label='"+n+"'><span class='k-icon "+i+" "+t+"' title='"+n+"'></span></button>").on("focus",function(){e(this).addClass("k-state-focused")}).on("blur",function(){e(this).removeClass("k-state-focused")}):e("<button type='button' class='k-button'>"+n+"</button>")},_clearFileAction:function(t){e(".k-upload-action",t).empty().hide()},_onFileAction:function(t){var n,i,o,r,s,a,l=this;return l.wrapper.hasClass("k-state-disabled")||(n=e(t.target).closest(".k-upload-action"),i=n.find(".k-icon"),o=n.closest(".k-file"),r=o.data("fileNames"),s=l._filesContainValidationErrors(r),a={files:r,headers:{}},l._retryClicked=!1,i.hasClass("k-i-x")?l.trigger(O,a)||l._module.onRemove({target:e(o,l.wrapper)},a,!s):i.hasClass("k-i-cancel")?(l.trigger(P,a),l._module.onCancel({target:e(o,l.wrapper)}),l._checkAllComplete(),l._updateHeaderUploadStatus()):i.hasClass("k-i-pause-sm")?(l.trigger(L,a),l.pause(o),l._updateHeaderUploadStatus()):i.hasClass("k-i-play-sm")?(l.trigger(H,a),l.resume(o)):i.hasClass("k-i-retry")&&(e(".k-i-warning",o).remove(),e(".k-progress",o).finish().show(),l._module.onRetry({target:e(o,l.wrapper)}),l._retryClicked=!0)),!1},_onUploadSelected:function(){var e=this,t=e.wrapper;return t.hasClass("k-state-disabled")||this._module.onSaveSelected(),!1},_onClearSelected:function(){var e=this,t=e.wrapper,n={};return t.hasClass("k-state-disabled")||e.trigger(B,n)||e.clearAllFiles(),!1},_onFileProgress:function(t,n){var i,o;n>100&&(n=100),this.options.template?e(".k-progress",t.target).width(n+"%"):(i=e(".k-upload-pct",t.target),o=e(".k-i-warning",t.target),o.length?o.removeClass("k-i-warning").removeClass("k-icon").addClass("k-upload-pct"):0===i.length&&e(".k-upload-status",t.target).prepend("<span class='k-upload-pct'></span>"),100!==n?e(".k-upload-pct",t.target).text(n+"%"):e(".k-upload-pct",t.target).remove(),e(".k-progress",t.target).width(n+"%")),this.trigger(N,{files:y(t).data("fileNames"),percentComplete:n})},_onUploadSuccess:function(e,t,n){var i=this,o=y(e),r=i.trigger(R,{files:o.data("fileNames"),response:t,operation:"upload",XMLHttpRequest:n});r?i._setUploadErrorState(o):(i._fileState(o,"uploaded"),o.removeClass("k-file-progress").addClass("k-file-success"),i._updateHeaderUploadStatus(),i._supportsRemove()?i._fileAction(o,O):i._clearFileAction(o)),i._hideUploadProgress(o),i._checkAllComplete()},_onUploadError:function(e,t){var n=this,i=n._module,o=y(e),r=o.data("uid");n._setUploadErrorState(o),n.trigger(F,{operation:"upload",files:o.data("fileNames"),XMLHttpRequest:t}),D("Server response: "+t.responseText),n.options.async.chunkSize?i._decreasePosition&&i._decreasePosition(r):n._hideUploadProgress(o),n._checkAllComplete(),this.options.async.autoRetryAfter&&this._autoRetryAfter(o)},_autoRetryAfter:function(e){var t=this,n=this._module.retries;n&&(n[e.data("uid")]||(n[e.data("uid")]=1),n[e.data("uid")]<=this.options.async.maxAutoRetries&&(n[e.data("uid")]++,setTimeout(function(){t._module.performUpload(e)},this.options.async.autoRetryAfter)))},_setUploadErrorState:function(t){var n,i=this;i._fileState(t,"failed"),t.removeClass("k-file-progress").addClass("k-file-error"),i._updateUploadProgress(t),n=e(".k-upload-pct",t),n.length>0?(n.parent().find(".k-i-warning").length||n.removeClass("k-upload-pct").addClass("k-icon k-i-warning"),n.empty()):e(".k-upload-status",t).prepend("<span class='k-icon k-i-warning'></span>"),this._updateHeaderUploadStatus(),this._fileAction(t,"retry"),this._fileAction(t,O,!0),i._retryClicked&&t.find(".k-i-retry").parent().focus()},_updateUploadProgress:function(t){var n,i,o,r=this;r.options.async.chunkSize?(n=t.data("uid"),r._module.metaData&&(i=r._module.metaData[n],i&&(o=i.totalChunks?Math.round(i.chunkIndex/i.totalChunks*100):100,r._onFileProgress({target:e(t,r.wrapper)},o)))):e(".k-progress",t).width("100%")},_hideUploadProgress:function(t){e(".k-progress",t).delay(q).fadeOut(G,function(){e(this).css("width","0%")})},_showUploadButton:function(){var t=this,n=e(".k-upload-selected",t.wrapper),i=e(".k-clear-selected",t.wrapper);0===n.length&&(n=t._renderAction("",this.localization.uploadSelectedFiles).addClass("k-upload-selected"),i=t._renderAction("",this.localization.clearSelectedFiles).addClass("k-clear-selected")),this.wrapper.append(i,n)},_hideUploadButton:function(){e(".k-upload-selected, .k-clear-selected",this.wrapper).remove()},_showHeaderUploadStatus:function(t){var n=this,i=n.localization,o=e(".k-dropzone",n.wrapper),r=e(".k-upload-status-total",n.wrapper);0!==r.length&&r.remove(),r='<strong class="k-upload-status k-upload-status-total"><span class="k-icon"></span></strong>',t?(r=e(r).append(i.headerStatusUploading),r.find(".k-icon").addClass($.loading)):(r=e(r).append(i.headerStatusUploaded),r.find(".k-icon").addClass($.warning)),o.length>0?o.append(r):e(".k-upload-button",n.wrapper).after(r)},_updateHeaderUploadStatus:function(){var t,n,i=this,o=e(".k-upload-status-total",this.wrapper),r=e(".k-file",i.wrapper).not(".k-file-success, .k-file-error, .k-file-invalid"),s=e(".k-file-invalid",i.wrapper),a=e(".k-file-error",i.wrapper),l=e(".k-file",i.wrapper).find(".k-i-play-sm");!l.length||l.length!==r.length&&i.options.async.concurrent?(0===r.length||s.length>0||a.length>0)&&(t=e(".k-file.k-file-error, .k-file.k-file-invalid",i.wrapper),o=e(".k-upload-status-total",i.wrapper),n=e(".k-icon",o).removeClass().addClass("k-icon").addClass(0!==t.length?$.warning:$.success),o.html(n).append(i.localization.headerStatusUploaded)):(n=e(".k-icon",o).removeClass().addClass("k-icon").addClass("k-i-pause-sm"),o.html(n).append(i.localization.headerStatusPaused))},_hideHeaderUploadstatus:function(){e(".k-upload-status-total",this.wrapper).remove()},_onParentFormSubmit:function(){var n,i=this,o=i.element;t!==this._module.onAbort&&this._module.onAbort(),o.value||(n=e(o),n.attr("disabled","disabled"),window.setTimeout(function(){n.removeAttr("disabled")},0))},_onParentFormReset:function(){e(".k-upload-files",this.wrapper).remove()},_supportsFormData:function(){return"undefined"!=typeof FormData},_supportsMultiple:function(){var e=this._userAgent().indexOf("Windows")>-1;return!(C.support.browser.opera||C.support.browser.safari&&e)},_supportsDrop:function(){var e=this._userAgent().toLowerCase(),t=/chrome/.test(e),n=!t&&/safari/.test(e),i=n&&/windows/.test(e);return!i&&this._supportsFormData()&&this.options.async.saveUrl},_userAgent:function(){return navigator.userAgent},_setupDropZone:function(){var t,n,i=this;e(".k-upload-button",i.wrapper).wrap("<div class='k-dropzone'></div>"),t=i._ns,n=e(".k-dropzone",i.wrapper).append(e("<em>"+i.localization.dropFilesHere+"</em>")).on("dragenter"+t,_).on("dragover"+t,function(e){e.preventDefault()}).on("drop"+t,e.proxy(i._onDrop,i)),b(n,t,function(){n.closest(".k-upload").hasClass("k-state-disabled")||n.addClass("k-dropzone-hovered")},function(){n.removeClass("k-dropzone-hovered")}),i._bindDocumentDragEventWrappers(n)},_setupCustomDropZone:function(){var t,n=this,i=e(n.options.dropZone);e(".k-upload-button",n.wrapper).wrap("<div class='k-dropzone'></div>").after(e("<em>"+n.localization.dropFilesHere+"</em>")),t=n._ns,i.on("dragenter"+t,_).on("dragover"+t,function(e){e.preventDefault()}).on("drop"+t,e.proxy(n._onDrop,n)),b(i,t,function(t){n.wrapper.hasClass("k-state-disabled")||(i.removeClass("k-dropzone-hovered"),e(t.target).addClass("k-dropzone-hovered"))},function(){i.removeClass("k-dropzone-hovered")}),n._bindDocumentDragEventWrappers(i)},_bindDocumentDragEventWrappers:function(t){var n=this,i=n._ns;b(e(document),i,function(){n.wrapper.hasClass("k-state-disabled")||(t.addClass("k-dropzone-active"),t.closest(".k-upload").removeClass("k-upload-empty"))},function(){t.removeClass("k-dropzone-active"),0===e("li.k-file",t.closest(".k-upload")).length&&t.closest(".k-upload").addClass("k-upload-empty")})},_supportsRemove:function(){return!!this.options.async.removeUrl},_submitRemove:function(t,n,i,o){var r=this,s=r.options.async.removeField||"fileNames",a=e.extend(n.data,T());a[s]=t,jQuery.ajax({type:this.options.async.removeVerb,dataType:"json",dataFilter:v,url:this.options.async.removeUrl,traditional:!0,data:a,headers:n.headers,success:i,error:o,xhrFields:{withCredentials:this.options.async.withCredentials}})},_wrapInput:function(e){var t=this,n=t.options;return e.wrap("<div class='k-widget k-upload k-header'><div class='k-button k-upload-button' aria-label='"+this.localization.select+"'></div></div>"),n.async.saveUrl||e.closest(".k-upload").addClass("k-upload-sync"),e.closest(".k-upload").addClass("k-upload-empty"),e.closest(".k-button").append("<span>"+this.localization.select+"</span>"),e.closest(".k-upload")},_checkAllComplete:function(){0===e(".k-file.k-file-progress",this.wrapper).length&&this.trigger(z)},_inputFiles:function(e){return i(e)}}),Y=function(e){this.name="syncUploadModule",this.element=e.wrapper,this.upload=e,this.element.closest("form").attr("enctype","multipart/form-data").attr("encoding","multipart/form-data")};Y.prototype={onSelect:function(t,i){var o,r,s=this.upload,a=e(t.target),l=s._filesContainValidationErrors(i);s._addInput(a),o={fileNames:i},l?a.remove():o.relatedInput=a,r=s._enqueueFile(n(a),o),l&&s._hideUploadProgress(r),s._fileAction(r,O)},onRemove:function(e){var t=y(e),n=t.data("relatedInput");n&&n.remove(),this.upload._removeFileEntry(t)}},k=function(e){this.name="iframeUploadModule",this.element=e.wrapper,this.upload=e,this.iframes=[]},K._frameId=0,k.prototype={onSelect:function(t,n){var i=this.upload,o=e(t.target),r=i._filesContainValidationErrors(n),s=this.prepareUpload(o,n,r);i.options.async.autoUpload?r?(i._fileAction(s,O),i._showHeaderUploadStatus(!1)):this.performUpload(s):(i._fileAction(s,O),r?i._updateHeaderUploadStatus():i._showUploadButton()),r&&i._hideUploadProgress(s)},prepareUpload:function(t,i,o){var r,s,a,l,c=this.upload,d=e(c.element),u=c.options.async.saveField||t.attr("name");return c._addInput(t),t.attr("name",u),o?(t.remove(),s={fileNames:i}):(a=this.createFrame(c.name+"_"+K._frameId++),this.registerFrame(a),l=this.createForm(c.options.async.saveUrl,a.attr("name")).append(d),s={frame:a,relatedInput:d,fileNames:i}),r=c._enqueueFile(n(t),s),a&&a.data({form:l,file:r}),r},performUpload:function(t){var n,i,o,r={files:t.data("fileNames")},s=t.data("frame"),a=this.upload;if(a.trigger(M,r))a._removeFileEntry(s.data("file")),this.cleanupFrame(s),this.unregisterFrame(s);else{a._hideUploadButton(),a._showHeaderUploadStatus(!0),s.appendTo(document.body),n=s.data("form").attr("action",a.options.async.saveUrl).appendTo(document.body),r.data=e.extend({},r.data,T());for(i in r.data)o=n.find("input[name='"+i+"']"),0===o.length&&(o=e("<input>",{type:"hidden",name:i}).prependTo(n)),o.val(r.data[i]);a._fileAction(t,P),a._fileState(t,"uploading"),e(t).removeClass("k-file-error").addClass("k-file-progress"),s.one("load",e.proxy(this.onIframeLoad,this)),n[0].submit()}},onSaveSelected:function(){var t=this,n=t.upload;e(".k-file",this.element).each(function(){var i=e(this),o=w(i),r=n._filesContainValidationErrors(i.data("fileNames"));o||r||t.performUpload(i)})},onIframeLoad:function(t){var n,i=e(t.target);try{n=i.contents().text()}catch(o){n="Error trying to get server response: "+o}this.processResponse(i,n)},processResponse:function(t,n){var i=t.data("file"),o=this,r={responseText:n};g(n,function(n){e.extend(r,{statusText:"OK",status:"200"}),o.upload._onFileProgress({target:e(i,o.upload.wrapper)},100),o.upload._onUploadSuccess({target:e(i,o.upload.wrapper)},n,r),o.cleanupFrame(t),o.unregisterFrame(t)},function(){e.extend(r,{statusText:"error",status:"500"}),o.upload._onUploadError({target:e(i,o.upload.wrapper)},r)})},onCancel:function(t){var n=e(t.target).data("frame");this.stopFrameSubmit(n),this.cleanupFrame(n),this.unregisterFrame(n),this.upload._removeFileEntry(n.data("file"))},onRetry:function(e){var t=y(e);this.performUpload(t)},onRemove:function(e,t,n){var i=this,o=i.upload,r=y(e),s=r.data("frame");s?(i.unregisterFrame(s),o._removeFileEntry(r),i.cleanupFrame(s)):r.hasClass("k-file-success")?m(r,o,t,n):o._removeFileEntry(r);
},onAbort:function(){var t=this.element,n=this;e.each(this.iframes,function(){e("input",this.data("form")).appendTo(t),n.stopFrameSubmit(this[0]),this.data("form").remove(),this.remove()}),this.iframes=[]},createFrame:function(t){return e("<iframe name='"+t+"' id='"+t+"' style='display:none;' />")},createForm:function(t,n){return e("<form enctype='multipart/form-data' method='POST' action='"+t+"' target='"+n+"'/>")},stopFrameSubmit:function(e){t!==e.stop?e.stop():e.document&&e.document.execCommand("Stop")},registerFrame:function(e){this.iframes.push(e)},unregisterFrame:function(t){this.iframes=e.grep(this.iframes,function(e){return e.attr("name")!=t.attr("name")})},cleanupFrame:function(e){var t=e.data("form");e.data("file").data("frame",null),setTimeout(function(){t.remove(),e.remove()},1)}},x=function(e){this.name="formDataUploadModule",this.element=e.wrapper,this.upload=e,this.position={},this.metaData={},this.cancelled={},this.resume={},this.paused={},this.retries={}},x.prototype={onSelect:function(t,n){var i,o,r=this.upload,s=this,a=e(t.target),l=this.prepareUpload(a,n);e.each(l,function(t){i=r._filesContainValidationErrors(e(this.data("fileNames"))),r.options.async.autoUpload?i?(r._fileAction(this,O),r._showHeaderUploadStatus(!1)):r.options.async.chunkSize?(s.prepareChunk(this),o=this.prev(),(r.options.async.concurrent||0===t&&!o.length||0===t&&o.hasClass("k-file-success"))&&s.performUpload(this)):s.performUpload(this):(r._fileAction(this,O),i?r._updateHeaderUploadStatus():(r._showUploadButton(),this.addClass("k-toupload"))),i&&r._hideUploadProgress(this)})},prepareUpload:function(t,n){var i=this.enqueueFiles(n);return t.is("input")&&(e.each(i,function(){e(this).data("relatedInput",t)}),t.data("relatedFileEntries",i),this.upload._addInput(t)),i},enqueueFiles:function(t){var n,i,o,r,s=this.upload,a=t.length,l=[];if(s.options.async.batch===!0)n=e.map(t,function(e){return e.name}).join(", "),(s.directory||s.options.directoryDrop)&&e(t).each(function(){(this.rawFile.webkitRelativePath||this.rawFile.relativePath)&&(this.name=this.rawFile.webkitRelativePath||this.rawFile.relativePath)}),r=s._enqueueFile(n,{fileNames:t}),r.data("files",t),l.push(r);else for(i=0;i<a;i++)o=t[i],n=o.name,(s.directory||s.options.directoryDrop)&&(o.rawFile.webkitRelativePath||o.rawFile.relativePath)&&(o.name=o.rawFile.webkitRelativePath||o.rawFile.relativePath),r=s._enqueueFile(n,{fileNames:[o]}),r.data("files",[o]),l.push(r);return l},performUpload:function(t){var n,i,o=this.upload,r=this.createFormData(),s=this.createXHR(),a={files:t.data("fileNames"),XMLHttpRequest:s};if(o.trigger(M,a))this.removeFileEntry(t);else{if(0===t.find(".k-i-cancel").length&&(o.options.async.chunkSize&&o._fileAction(t,L),o._fileAction(t,P,o.options.async.chunkSize)),o.wrapper.find(".k-toupload").length||o._hideUploadButton(),o._showHeaderUploadStatus(!0),a.formData)r=a.formData;else{a.data=e.extend({},a.data,T());for(i in a.data)r.append(i,a.data[i]);n=t.data("files"),n&&this.populateFormData(r,n)}o._fileState(t,"uploading"),e(t).removeClass("k-file-error").addClass("k-file-progress"),o.options.async.useArrayBuffer&&window.FileReader?this._readFile(o.options.async.saveUrl,r,t,s):this.postFormData(o.options.async.saveUrl,r,t,s)}},_readFile:function(n,i,o,r){var s=this,a=s.upload,l=o.data("files")[0],c=new FileReader;c.onload=function(c){try{s.fileArrayBuffer=s.fileArrayBuffer?s._appendBuffer(s.fileArrayBuffer,c.target.result):c.target.result}catch(d){return a._onUploadError({target:e(o,a.wrapper)},r),t}s.position[l.uid]>l.size?(s.postFormData(a.options.async.saveUrl,s.fileArrayBuffer,o,r),s.fileArrayBuffer=null):s._readFile(n,i,o,r)},c.onerror=function(){a._onUploadError({target:e(o,a.wrapper)},r)},c.readAsArrayBuffer(s._getCurrentChunk(l.rawFile,l.uid))},_appendBuffer:function(e,t){var n=new Uint8Array(e.byteLength+t.byteLength);return n.set(new Uint8Array(e),0),n.set(new Uint8Array(t),e.byteLength),n.buffer},onSaveSelected:function(){var t=this,n=t.upload;e(".k-toupload",this.element).filter(function(){var t=e(this),i=w(t),o=n._filesContainValidationErrors(t.data("fileNames"));return!i&&!o}).each(function(i){var o=e(this),r=o.prev();o.removeClass("k-toupload"),n.options.async.chunkSize?(t.prepareChunk(o),(n.options.async.concurrent||0===i&&!r.length||0===i&&r.hasClass("k-file-success")||r.hasClass("k-file-error"))&&t.performUpload(o)):t.performUpload(o)})},onCancel:function(e){var t=y(e);this.upload.options.async.chunkSize&&(this.cancelled[t.data("uid")]=!0),this.stopUploadRequest(t),this.removeFileEntry(t)},onPause:function(e){var t=y(e),n=t.data("uid"),i=this.upload.options.async;i.chunkSize&&(this.retries[n]=i.maxAutoRetries+1,this.paused[n]=!0,this.resume[n]=!1)},onResume:function(e){var t=y(e),n=t.data("uid");this.upload.options.async.chunkSize&&(delete this.paused[n],this.resume[n]=!0,this.retries[t.data("uid")]=1,this._increaseChunkIndex(n),this.performUpload(t))},onRetry:function(e){var t=y(e),n=this.upload.options.async;n.chunkSize&&(this.retries[t.data("uid")]=n.maxAutoRetries+1,delete this.paused[t.data("uid")]),this.performUpload(t)},onRemove:function(e,t,n){var i=this,o=i.upload,r=y(e),s=this.upload.options.async;s.chunkSize&&(this.retries[r.data("uid")]=s.maxAutoRetries+1),r.hasClass("k-file-success")?m(r,o,t,n):i.removeFileEntry(r)},createXHR:function(){return new XMLHttpRequest},postFormData:function(e,t,n,i){var o,r=this;n.data("request",i),i.addEventListener("load",function(e){r.onRequestSuccess.call(r,e,n)},!1),i.addEventListener(F,function(e){r.onRequestError.call(r,e,n)},!1),i.upload.addEventListener("progress",function(e){r.onRequestProgress.call(r,e,n)},!1),i.open("POST",e,!0),i.withCredentials=this.upload.options.async.withCredentials,o=this.upload.options.async.accept,o&&i.setRequestHeader("Accept",o),i.send(t)},createFormData:function(){return new FormData},populateFormData:function(e,t){var n,i,o,r,s=t.length,a=this.upload;if(a.options.async.chunkSize)o=t[0].uid,n=this._getCurrentChunk(t[0].rawFile,o),e.append(a.options.async.saveField||a.name,n),r=JSON.stringify(this.metaData[o]),e.append("metadata",r);else for(i=0;i<s;i++)e.append(a.options.async.saveField||a.name,t[i].rawFile);return e},onRequestSuccess:function(t,n){function i(){s.upload._onUploadError({target:e(n,s.upload.wrapper)},r)}function o(t){var i=s.upload.options.async.batch,o=s.upload.options.async.chunkSize,a=s.upload.options.async.concurrent,l=t.fileUid;s.paused[l]||s.cancelled[l]||(delete s.retries[l],!o||i||t.uploaded?!o||i||a||!n.next().length||n.next().hasClass("k-toupload")?(s.upload._onFileProgress({target:e(n,s.upload.wrapper)},100),s.upload._onUploadSuccess({target:e(n,s.upload.wrapper)},t,r),s.cleanupFileEntry(n)):(s.upload._onFileProgress({target:e(n,s.upload.wrapper)},100),s._resetChunkIndex(l),s.upload._onUploadSuccess({target:e(n,s.upload.wrapper)},t,r),s.performUpload(n.next())):(s._increaseChunkIndex(l),s.performUpload(n)))}var r=t.target,s=this;r.status>=200&&r.status<=299?g(r.responseText,o,i):i()},onRequestError:function(t,n){var i=t.target;this.upload._onUploadError({target:e(n,this.upload.wrapper)},i)},cleanupFileEntry:function(t){var n=t.data("relatedInput"),i=!0;n&&(e.each(n.data("relatedFileEntries")||[],function(){this.parent().length>0&&this[0]!=t[0]&&(i=i&&this.hasClass("k-file-success"))}),i&&n.remove())},removeFileEntry:function(e){var t=this.upload.options.async.chunkSize,n=this.upload.options.async.concurrent;this.cleanupFileEntry(e),t&&!n&&e.next().length&&this.performUpload(e.next()),this.upload._removeFileEntry(e)},onRequestProgress:function(t,n){var i,o=Math.round(100*t.loaded/t.total),r=n.data("uid");this.upload.options.async.chunkSize&&(i=this.metaData[r],o=i.totalChunks?Math.round(i.chunkIndex/i.totalChunks*100):100),this.upload._onFileProgress({target:e(n,this.upload.wrapper)},o)},stopUploadRequest:function(e){e.data("request").abort()},prepareChunk:function(e){var t=e.data("files")[0].rawFile,n=e.data("files")[0].uid,i=this.upload.options.async.chunkSize;this.position[n]=0,this.metaData[n]={chunkIndex:0,contentType:t.type,fileName:t.name,totalFileSize:t.size,totalChunks:Math.ceil(t.size/i),uploadUid:n}},_decreaseChunkIndex:function(e){this.metaData[e].chunkIndex--},_increaseChunkIndex:function(e){this.metaData[e].chunkIndex++},_resetChunkIndex:function(e){this.metaData[e].chunkIndex=0},_decreasePosition:function(e){this.position[e]-=this.upload.options.async.chunkSize},_getCurrentChunk:function(e,t){var n,i=this.position[t],o=this.upload.options.async,r=o.chunkSize||o.bufferChunkSize;return this.position[t]||(this.position[t]=0),this.position[t]+=r,(n=this._getChunker(e))?e[n](i,this.position[t]):e},_getChunker:function(e){return e.slice?"slice":e.mozSlice?"mozSlice":e.webkitSlice?"webkitSlice":null}},C.ui.plugin(K)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.filebrowser.min",["kendo.listview.min","kendo.dropdownlist.min","kendo.upload.min"],e)}(function(){return function(e,t){function n(e,t,n){var i,o;e.on("dragenter"+x,function(){t(),o=new Date,i||(i=setInterval(function(){var e=new Date-o;e>100&&(n(),clearInterval(i),i=null)},100))}).on("dragover"+x,function(){o=new Date})}function i(e,n){return e!==t&&e.match(/\/$/)||(e=(e||"")+"/"),e+n}function o(e){if(!e)return"";var t=" bytes";return e>=1073741824?(t=" GB",e/=1073741824):e>=1048576?(t=" MB",e/=1048576):e>=1024&&(t=" KB",e/=1024),Math.round(100*e)/100+t}function r(e,t){var n=e[t];return h(n)?n.from||n.field||t:n}var s,a,l,c,d=window.kendo,u=d.ui.Widget,h=e.isPlainObject,f=e.proxy,p=e.extend,m=d.support.placeholder,g=d.support.browser,v=d.isFunction,_=/(^\/|\/$)/g,b="change",w="apply",y="error",k="click",x=".kendoFileBrowser",C=".kendoBreadcrumbs",S=".kendoSearchBox",T="name",D="size",A="type",E={field:A,dir:"asc"},I=d.template('<li class="k-tile-empty"><strong>${text}</strong></li>'),M='<div class="k-widget k-filebrowser-toolbar k-header k-floatwrap"><div class="k-toolbar-wrap"># if (showUpload) { # <div class="k-widget k-upload"><div class="k-button k-button-icontext k-upload-button"><span class="k-icon k-i-plus"></span>#=messages.uploadFile#<input type="file" name="file" /></div></div># } ## if (showCreate) { #<button type="button" class="k-button k-button-icon"><span class="k-icon k-i-folder-add" /></button># } ## if (showDelete) { #<button type="button" class="k-button k-button-icon k-state-disabled"><span class="k-icon k-i-close" /></button>&nbsp;# } #</div><div class="k-tiles-arrange"><label>#=messages.orderBy#: <select /></label></div></div>';p(!0,d.data,{schemas:{filebrowser:{data:function(e){return e.items||e||[]},model:{id:"name",fields:{name:"name",size:"size",type:"type"}}}}}),p(!0,d.data,{transports:{filebrowser:d.data.RemoteTransport.extend({init:function(t){d.data.RemoteTransport.fn.init.call(this,e.extend(!0,{},this.options,t))},_call:function(t,n){n.data=e.extend({},n.data,{path:this.options.path()}),v(this.options[t])?this.options[t].call(this,n):d.data.RemoteTransport.fn[t].call(this,n)},read:function(e){this._call("read",e)},create:function(e){this._call("create",e)},destroy:function(e){this._call("destroy",e)},update:function(){},options:{read:{type:"POST"},update:{type:"POST"},create:{type:"POST"},destroy:{type:"POST"}}})}}),s=g.msie&&g.version<8?function(e){return e.offsetTop}:function(t){return t.offsetTop-e(t).height()},a=u.extend({init:function(e,t){var n=this;t=t||{},u.fn.init.call(n,e,t),n.element.addClass("k-filebrowser"),n.element.on(k+x,".k-filebrowser-toolbar button:not(.k-state-disabled):has(.k-i-close)",f(n._deleteClick,n)).on(k+x,".k-filebrowser-toolbar button:not(.k-state-disabled):has(.k-i-folder-add)",f(n._addClick,n)).on("keydown"+x,"li.k-state-selected input",f(n._directoryKeyDown,n)).on("blur"+x,"li.k-state-selected input",f(n._directoryBlur,n)),n._dataSource(),n.refresh(),n.path(n.options.path)},options:{name:"FileBrowser",messages:{uploadFile:"Upload",orderBy:"Arrange by",orderByName:"Name",orderBySize:"Size",directoryNotFound:"A directory with this name was not found.",emptyFolder:"Empty Folder",deleteFile:'Are you sure you want to delete "{0}"?',invalidFileType:'The selected file "{0}" is not valid. Supported file types are {1}.',overwriteFile:'A file with name "{0}" already exists in the current directory. Do you want to overwrite it?',dropFilesHere:"drop file here to upload",search:"Search"},transport:{},path:"/",fileTypes:"*.*"},events:[y,b,w],destroy:function(){var e=this;u.fn.destroy.call(e),e.dataSource.unbind(y,e._errorHandler),e.element.add(e.list).add(e.toolbar).off(x),d.destroy(e.element)},value:function(){var e,t=this,n=t._selectedItem(),o=t.options.transport.fileUrl;if(n&&"f"===n.get(A))return e=i(t.path(),n.get(T)).replace(_,""),o&&(e=v(o)?o(e):d.format(o,encodeURIComponent(e))),e},_selectedItem:function(){var e=this.listView,t=e.select();if(t.length)return this.dataSource.getByUid(t.attr(d.attr("uid")))},_toolbar:function(){var t=this,n=d.template(M),i=t.options.messages,o=[{text:i.orderByName,value:"name"},{text:i.orderBySize,value:"size"}];t.toolbar=e(n({messages:i,showUpload:t.options.transport.uploadUrl,showCreate:t.options.transport.create,showDelete:t.options.transport.destroy})).appendTo(t.element).find(".k-upload input").kendoUpload({multiple:!1,localization:{dropFilesHere:i.dropFilesHere},async:{saveUrl:t.options.transport.uploadUrl,autoUpload:!0},upload:f(t._fileUpload,t),error:function(e){t._error({xhr:e.XMLHttpRequest,status:"error"})}}).end(),t.upload=t.toolbar.find(".k-upload input").data("kendoUpload"),t.arrangeBy=t.toolbar.find(".k-tiles-arrange select").kendoDropDownList({dataSource:o,dataTextField:"text",dataValueField:"value",change:function(){t.orderBy(this.value())}}).data("kendoDropDownList"),t._attachDropzoneEvents()},_attachDropzoneEvents:function(){var t=this;t.options.transport.uploadUrl&&(n(e(document.documentElement),e.proxy(t._dropEnter,t),e.proxy(t._dropLeave,t)),t._scrollHandler=f(t._positionDropzone,t))},_dropEnter:function(){this._positionDropzone(),e(document).on("scroll"+x,this._scrollHandler)},_dropLeave:function(){this._removeDropzone(),e(document).off("scroll"+x,this._scrollHandler)},_positionDropzone:function(){var e=this,t=e.element,n=t.offset();e.toolbar.find(".k-dropzone").addClass("k-filebrowser-dropzone").offset(n).css({width:t[0].clientWidth,height:t[0].clientHeight,lineHeight:t[0].clientHeight+"px"})},_removeDropzone:function(){this.toolbar.find(".k-dropzone").removeClass("k-filebrowser-dropzone").css({width:"",height:"",lineHeight:"",top:"",left:""})},_deleteClick:function(){var e=this,t=e.listView.select(),n=d.format(e.options.messages.deleteFile,t.find("strong").text());t.length&&e._showMessage(n,"confirm")&&e.listView.remove(t)},_addClick:function(){this.createDirectory()},_getFieldName:function(e){return r(this.dataSource.reader.model.fields,e)},_fileUpload:function(e){var t,n=this,i=n.options,o=i.fileTypes,r=RegExp(("("+o.split(",").join(")|(")+")").replace(/\*\./g,".*."),"i"),s=e.files[0].name,a=T,l=D;r.test(s)?(e.data={path:n.path()},t=n._createFile(s),t?n.upload.one("success",function(e){var i=n._insertFileToList(t);i.set(a,e.response[n._getFieldName(a)]),i.set(l,e.response[n._getFieldName(l)]),n._tiles=n.listView.items().filter("["+d.attr("type")+"=f]")}):e.preventDefault()):(e.preventDefault(),n._showMessage(d.format(i.messages.invalidFileType,s,o)))},_findFile:function(e){var t,n,i,o=this.dataSource.data(),r=A,s=T;for(e=e.toLowerCase(),t=0,i=o.length;t<i;t++)if("f"===o[t].get(r)&&o[t].get(s).toLowerCase()===e){n=o[t];break}return n},_createFile:function(e){var t=this,n={},i=A,o=t._findFile(e);return o?t._showMessage(d.format(t.options.messages.overwriteFile,e),"confirm")?(o._override=!0,o):null:(n[i]="f",n[T]=e,n[D]=0,n)},_insertFileToList:function(e){var t,n,i,o,r;if(e._override)return e;for(n=this.dataSource,i=n.view(),o=0,r=i.length;o<r;o++)if("f"===i[o].get(A)){t=o;break}return n.insert(++t,e)},createDirectory:function(){var e,t,n=this,i=0,o=A,r=T,s=n.dataSource.data(),a=n._nameDirectory(),l=new n.dataSource.reader.model;for(e=0,t=s.length;e<t;e++)"d"===s[e].get(o)&&(i=e);l.set(o,"d"),l.set(r,a),n.listView.one("dataBound",function(){var e=n.listView.items().filter("["+d.attr("uid")+"="+l.uid+"]"),t=e.find("input");e.length&&this.edit(e),this.element.scrollTop(e.attr("offsetTop")-this.element[0].offsetHeight),setTimeout(function(){t.select()})}).one("save",function(e){var t=e.model.get(r);t?e.model.set(r,n._nameExists(t,l.uid)?n._nameDirectory():t):e.model.set(r,a)}),n.dataSource.insert(++i,l)},_directoryKeyDown:function(e){13==e.keyCode&&e.currentTarget.blur()},_directoryBlur:function(){this.listView.save()},_nameExists:function(e,t){var n,i,o=this.dataSource.data(),r=A,s=T;for(n=0,i=o.length;n<i;n++)if("d"===o[n].get(r)&&o[n].get(s).toLowerCase()===e.toLowerCase()&&o[n].uid!==t)return!0;return!1},_nameDirectory:function(){var t,n,i,o="New folder",r=this.dataSource.data(),s=[],a=A,l=T;for(n=0,i=r.length;n<i;n++)"d"===r[n].get(a)&&r[n].get(l).toLowerCase().indexOf(o.toLowerCase())>-1&&s.push(r[n].get(l));if(e.inArray(o,s)>-1){n=2;do t=o+" ("+n+")",n++;while(e.inArray(t,s)>-1);o=t}return o},orderBy:function(e){this.dataSource.sort([{field:A,dir:"asc"},{field:e,dir:"asc"}])},search:function(e){this.dataSource.filter({field:T,operator:"contains",value:e})},_content:function(){var t=this;t.list=e('<ul class="k-reset k-floats k-tiles" />').appendTo(t.element).on("dblclick"+x,"li",f(t._dblClick,t)),t.listView=new d.ui.ListView(t.list,{dataSource:t.dataSource,template:t._itemTmpl(),editTemplate:t._editTmpl(),selectable:!0,autoBind:!1,dataBinding:function(e){t.toolbar.find(".k-i-close").parent().addClass("k-state-disabled"),"remove"!==e.action&&"sync"!==e.action||(e.preventDefault(),d.ui.progress(t.listView.element,!1))},dataBound:function(){t.dataSource.view().length?t._tiles=this.items().filter("["+d.attr("type")+"=f]"):this.wrapper.append(I({text:t.options.messages.emptyFolder}))},change:f(t._listViewChange,t)})},_dblClick:function(t){var n,o=this,r=e(t.currentTarget);r.hasClass("k-edit-item")&&o._directoryBlur(),r.filter("["+d.attr("type")+"=d]").length?(n=o.dataSource.getByUid(r.attr(d.attr("uid"))),n&&(o.path(i(o.path(),n.get(T))),o.breadcrumbs.value(o.path()))):r.filter("["+d.attr("type")+"=f]").length&&o.trigger(w)},_listViewChange:function(){var e=this._selectedItem();e&&(this.toolbar.find(".k-i-close").parent().removeClass("k-state-disabled"),this.trigger(b,{selected:e}))},_dataSource:function(){var e,t=this,n=t.options,i=n.transport,o=p({},E),r={field:T,dir:"asc"},s={type:i.type||"filebrowser",sort:[o,r]};h(i)&&(i.path=f(t.path,t),s.transport=i),h(n.schema)?s.schema=n.schema:i.type&&h(d.data.schemas[i.type])&&(e=d.data.schemas[i.type]),t.dataSource&&t._errorHandler?t.dataSource.unbind(y,t._errorHandler):t._errorHandler=f(t._error,t),t.dataSource=d.data.DataSource.create(s).bind(y,t._errorHandler)},_navigation:function(){var t=this,n=e('<div class="k-floatwrap"><input/><input/></div>').appendTo(this.element);t.breadcrumbs=n.find("input:first").kendoBreadcrumbs({value:t.options.path,change:function(){t.path(this.value())}}).data("kendoBreadcrumbs"),t.searchBox=n.parent().find("input:last").kendoSearchBox({label:t.options.messages.search,change:function(){t.search(this.value())}}).data("kendoSearchBox")},_error:function(e){var t,n,i=this;i.trigger(y,e)||(t=e.xhr.status,"error"==e.status?"404"==t?i._showMessage(i.options.messages.directoryNotFound):"0"!=t&&i._showMessage("Error! The requested URL returned "+t+" - "+e.xhr.statusText):"timeout"==t&&i._showMessage("Error! Server timeout."),n=i.dataSource,n.hasChanges()&&n.cancelChanges())},_showMessage:function(e,t){return window[t||"alert"](e)},refresh:function(){var e=this;e._navigation(),e._toolbar(),e._content()},_editTmpl:function(){var e='<li class="k-tile k-state-selected" '+d.attr("uid")+'="#=uid#" ';return e+=d.attr("type")+'="${'+A+'}">',e+="#if("+A+' == "d") { #',e+='<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>',e+="#}else{#",e+='<div class="k-thumb"><span class="k-icon k-i-loading"></span></div>',e+="#}#",e+="#if("+A+' == "d") { #',e+='<input class="k-input" '+d.attr("bind")+'="value:'+T+'"/>',e+="#}#",e+="</li>",f(d.template(e),{sizeFormatter:o})},_itemTmpl:function(){var e='<li class="k-tile" '+d.attr("uid")+'="#=uid#" ';return e+=d.attr("type")+'="${'+A+'}">',e+="#if("+A+' == "d") { #',e+='<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>',e+="#}else{#",e+='<div class="k-thumb"><span class="k-icon k-i-file"></span></div>',e+="#}#",e+="<strong>${"+T+"}</strong>",e+="#if("+A+' == "f") { # <span class="k-filesize">${this.sizeFormatter('+D+")}</span> #}#",e+="</li>",f(d.template(e),{sizeFormatter:o})},path:function(e){var n=this,i=n._path||"";return e!==t?(n._path=e.replace(_,"")+"/",n.dataSource.read({path:n._path}),t):(i&&(i=i.replace(_,"")),"/"===i||""===i?"":i+"/")}}),l=u.extend({init:function(e,t){var n=this;t=t||{},u.fn.init.call(n,e,t),m&&n.element.attr("placeholder",n.options.label),n._wrapper(),n.element.on("keydown"+S,f(n._keydown,n)).on("change"+S,f(n._updateValue,n)),n.wrapper.on(k+S,"a",f(n._click,n)),m||n.element.on("focus"+S,f(n._focus,n)).on("blur"+S,f(n._blur,n))},options:{name:"SearchBox",label:"Search",value:""},events:[b],destroy:function(){var e=this;e.wrapper.add(e.element).add(e.label).off(S),u.fn.destroy.call(e)},_keydown:function(e){13===e.keyCode&&this._updateValue()},_click:function(e){e.preventDefault(),this._updateValue()},_updateValue:function(){var e=this,t=e.element.val();t!==e.value()&&(e.value(t),e.trigger(b))},_blur:function(){this._updateValue(),this._toggleLabel()},_toggleLabel:function(){m||this.label.toggle(!this.element.val())},_focus:function(){this.label.hide()},_wrapper:function(){var t=this.element,n=t.parents(".k-search-wrap");t[0].style.width="",t.addClass("k-input"),n.length||(n=t.wrap(e('<div class="k-widget k-search-wrap k-textbox"/>')).parent(),m||e('<label style="display:block">'+this.options.label+"</label>").insertBefore(t),e('<a href="#" class="k-icon k-i-zoom k-search"/>').appendTo(n)),this.wrapper=n,this.label=n.find(">label")},value:function(e){var n=this;return e!==t?(n.options.value=e,n.element.val(e),n._toggleLabel(),t):n.options.value}}),c=u.extend({init:function(e,t){var n=this;t=t||{},u.fn.init.call(n,e,t),n._wrapper(),n.wrapper.on("focus"+C,"input",f(n._focus,n)).on("blur"+C,"input",f(n._blur,n)).on("keydown"+C,"input",f(n._keydown,n)).on(k+C,"a.k-i-arrow-60-up:first",f(n._rootClick,n)).on(k+C,"a:not(.k-i-arrow-60-up)",f(n._click,n)),n.value(n.options.value)},options:{name:"Breadcrumbs",gap:50},events:[b],destroy:function(){var e=this;u.fn.destroy.call(e),e.wrapper.add(e.wrapper.find("input")).add(e.wrapper.find("a")).off(C)},_update:function(e){e="/"===(e||"").charAt(0)?e:"/"+(e||""),e!==this.value()&&(this.value(e),this.trigger(b))},_click:function(t){t.preventDefault(),this._update(this._path(e(t.target).prevAll("a:not(.k-i-arrow-60-up)").addBack()))},_rootClick:function(e){e.preventDefault(),this._update("")},_focus:function(){var e=this,t=e.element;e.overlay.hide(),e.element.val(e.value()),setTimeout(function(){t.select()})},_blur:function(){if(!this.overlay.is(":visible")){var e=this,t=e.element,n=t.val().replace(/\/{2,}/g,"/");e.overlay.show(),t.val(""),e._update(n)}},_keydown:function(e){var t=this;13===e.keyCode&&(t._blur(),setTimeout(function(){t.overlay.find("a:first").focus()}))},_wrapper:function(){var t,n=this.element,i=n.parents(".k-breadcrumbs");n[0].style.width="",n.addClass("k-input"),i.length||(i=n.wrap(e('<div class="k-widget k-breadcrumbs k-textbox"/>')).parent()),t=i.find(".k-breadcrumbs-wrap"),t.length||(t=e('<div class="k-breadcrumbs-wrap"/>').appendTo(i)),this.wrapper=i,this.overlay=t},refresh:function(){var n,i,o,r,s="",a=this.value();for(a!==t&&a.match(/^\//)||(a="/"+(a||"")),n=a.split("/"),o=0,r=n.length;o<r;o++)i=n[o],i&&(s||(s+='<a href="#" class="k-icon k-i-arrow-60-up" title="Go to parent folder"></a>'),s+='<a class="k-link" href="#">'+n[o]+"</a>",s+='<span class="k-icon k-i-arrow-60-right" title="Go to child folder"></span>');this.overlay.empty().append(e(s)),this._adjustSectionWidth()},_adjustSectionWidth:function(){var t,n=this,i=n.wrapper,o=i.width()-n.options.gap,r=n.overlay.find("a");r.each(function(n){t=e(this),t.parent().width()>o&&(n==r.length-1?t.width(o):t.prev().addBack().hide())})},value:function(e){return e!==t?(this._value=e.replace(/\/{2,}/g,"/"),this.refresh(),t):this._value},_path:function(t){return"/"+e.map(t,function(t){return e(t).text()}).join("/")}}),d.ui.plugin(a),d.ui.plugin(c),d.ui.plugin(l)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.imagebrowser.min",["kendo.filebrowser.min"],e)}(function(){return function(e,t){function n(e,n){return e!==t&&e.match(/\/$/)||(e=(e||"")+"/"),e+n}function i(e){if(!e)return"";var t=" bytes";return e>=1073741824?(t=" GB",e/=1073741824):e>=1048576?(t=" MB",e/=1048576):e>=1024&&(t=" KB",e/=1024),Math.round(100*e)/100+t}var o,r,s=window.kendo,a=s.ui.FileBrowser,l=e.isPlainObject,c=e.proxy,d=e.extend,u=s.support.browser,h=s.isFunction,f=/(^\/|\/$)/g,p="error",m=".kendoImageBrowser",g="name",v="size",_="type",b={field:_,dir:"asc"},w=s.template('<li class="k-tile-empty"><strong>${text}</strong></li>');d(!0,s.data,{schemas:{imagebrowser:{data:function(e){return e.items||e||[]},model:{id:"name",fields:{name:"name",size:"size",type:"type"}}}}}),d(!0,s.data,{transports:{imagebrowser:s.data.RemoteTransport.extend({init:function(t){s.data.RemoteTransport.fn.init.call(this,e.extend(!0,{},this.options,t))},_call:function(t,n){n.data=e.extend({},n.data,{path:this.options.path()}),h(this.options[t])?this.options[t].call(this,n):s.data.RemoteTransport.fn[t].call(this,n)},read:function(e){this._call("read",e)},create:function(e){this._call("create",e)},destroy:function(e){this._call("destroy",e)},update:function(){},options:{read:{type:"POST"},update:{type:"POST"},create:{type:"POST"},destroy:{type:"POST"}}})}}),o=u.msie&&u.version<8?function(e){return e.offsetTop}:function(t){return t.offsetTop-e(t).height()},r=a.extend({init:function(e,t){var n=this;t=t||{},a.fn.init.call(n,e,t),n.element.addClass("k-imagebrowser")},options:{name:"ImageBrowser",fileTypes:"*.png,*.gif,*.jpg,*.jpeg"},value:function(){var e,t=this,i=t._selectedItem(),o=t.options.transport.imageUrl;if(i&&"f"===i.get(_))return e=n(t.path(),i.get(g)).replace(f,""),o&&(e=h(o)?o(e):s.format(o,encodeURIComponent(e))),e},_fileUpload:function(e){var t,n=this,i=n.options,o=i.fileTypes,r=RegExp(("("+o.split(",").join(")|(")+")").replace(/\*\./g,".*."),"i"),a=e.files[0].name,l=g,c=v;r.test(a)?(e.data={path:n.path()},t=n._createFile(a),t?(t._uploading=!0,n.upload.one("success",function(e){delete t._uploading;var i=n._insertFileToList(t);i.set(l,e.response[n._getFieldName(l)]),i.set(c,e.response[n._getFieldName(c)]),n._tiles=n.listView.items().filter("["+s.attr("type")+"=f]"),n._scroll()})):e.preventDefault()):(e.preventDefault(),n._showMessage(s.format(i.messages.invalidFileType,a,o)))},_content:function(){var t=this;t.list=e('<ul class="k-reset k-floats k-tiles" />').appendTo(t.element).on("scroll"+m,c(t._scroll,t)).on("dblclick"+m,"li",c(t._dblClick,t)),t.listView=new s.ui.ListView(t.list,{dataSource:t.dataSource,template:t._itemTmpl(),editTemplate:t._editTmpl(),selectable:!0,autoBind:!1,dataBinding:function(e){t.toolbar.find(".k-i-close").parent().addClass("k-state-disabled"),"remove"!==e.action&&"sync"!==e.action||(e.preventDefault(),s.ui.progress(t.listView.element,!1))},dataBound:function(){t.dataSource.view().length?(t._tiles=this.items().filter("["+s.attr("type")+"=f]"),t._scroll()):this.wrapper.append(w({text:t.options.messages.emptyFolder}))},change:c(t._listViewChange,t)})},_dataSource:function(){var e,t=this,n=t.options,i=n.transport,o=d({},b),r={field:g,dir:"asc"},a={type:i.type||"imagebrowser",sort:[o,r]};l(i)&&(i.path=c(t.path,t),a.transport=i),l(n.schema)?a.schema=n.schema:i.type&&l(s.data.schemas[i.type])&&(e=s.data.schemas[i.type]),t.dataSource&&t._errorHandler?t.dataSource.unbind(p,t._errorHandler):t._errorHandler=c(t._error,t),t.dataSource=s.data.DataSource.create(a).bind(p,t._errorHandler)},_loadImage:function(t){var n=this,i=e(t),o=n.dataSource.getByUid(i.attr(s.attr("uid"))),r=o.get(g),a=n.options.transport.thumbnailUrl,l=e("<img />",{alt:r}),c="?";o._uploading||(l.hide().on("load"+m,function(){e(this).prev().remove().end().addClass("k-image").fadeIn()}),i.find(".k-i-loading").after(l),h(a)?a=a(n.path(),encodeURIComponent(r)):(a.indexOf("?")>=0&&(c="&"),a=a+c+"path="+encodeURIComponent(n.path()+r),o._override&&(a+="&_="+(new Date).getTime(),delete o._override)),l.attr("src",a),t.loaded=!0)},_scroll:function(){var e=this;e.options.transport&&e.options.transport.thumbnailUrl&&(clearTimeout(e._timeout),e._timeout=setTimeout(function(){var t=s._outerHeight(e.list),n=e.list.scrollTop(),i=n+t;e._tiles.each(function(){var t=o(this),r=t+this.offsetHeight;if((t>=n&&t<i||r>=n&&r<i)&&e._loadImage(this),t>i)return!1}),e._tiles=e._tiles.filter(function(){return!this.loaded})},250))},_itemTmpl:function(){var e=this,t='<li class="k-tile" '+s.attr("uid")+'="#=uid#" ';return t+=s.attr("type")+'="${'+_+'}">',t+="#if("+_+' == "d") { #',t+='<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>',t+="#}else{#",t+=e.options.transport&&e.options.transport.thumbnailUrl?'<div class="k-thumb"><span class="k-icon k-i-loading"></span></div>':'<div class="k-thumb"><span class="k-icon k-i-file"></span></div>',t+="#}#",t+="<strong>${"+g+"}</strong>",t+="#if("+_+' == "f") { # <span class="k-filesize">${this.sizeFormatter('+v+")}</span> #}#",t+="</li>",c(s.template(t),{sizeFormatter:i})}}),s.ui.plugin(r)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.tabstrip.min",["kendo.data.min"],e)}(function(){return function(e,t){function n(t){t.children(b).addClass(E),t.children("a").addClass(C).children(b).addClass(E),t.filter(":not([disabled]):not([class*=k-state-disabled])").addClass(N),t.filter("li[disabled]").addClass(H).attr("aria-disabled","true").removeAttr("disabled"),t.filter(":not([class*=k-state])").children("a").filter(":focus").parent().addClass(O+" "+W),t.attr("role","tab"),t.filter("."+O).attr("aria-selected",!0),t.each(function(){var t=e(this);t.children("."+C).length||t.contents().filter(function(){return!(this.nodeName.match(v)||3==this.nodeType&&!d(this.nodeValue))}).wrapAll("<span UNSELECTABLE='on' class='"+C+"'/>")})}function i(e){var t=e.children(".k-item");t.filter(".k-first:not(:first-child)").removeClass(I),t.filter(".k-last:not(:last-child)").removeClass(S),t.filter(":first-child").addClass(I),t.filter(":last-child").addClass(S)}function o(e,t){return"<span class='k-button k-button-icon k-bare k-tabstrip-"+e+"' unselectable='on'><span class='k-icon "+t+"'></span></span>"}var r=window.kendo,s=r.ui,a=r.keys,l=e.map,c=e.each,d=e.trim,u=e.extend,h=r.isFunction,f=r.template,p=r._outerWidth,m=r._outerHeight,g=s.Widget,v=/^(a|div)$/i,_=".kendoTabStrip",b="img",w="href",y="prev",k="next",x="show",C="k-link",S="k-last",T="click",D="error",A=":empty",E="k-image",I="k-first",M="select",R="activate",F="k-content",z="contentUrl",P="mouseenter",B="mouseleave",L="contentLoad",H="k-state-disabled",N="k-state-default",O="k-state-active",V="k-state-focused",U="k-state-hover",W="k-tab-on-top",j=".k-item:not(."+H+")",q=".k-item",G=".k-tabstrip-items > "+j+":not(."+O+")",$=200,K={content:f("<div class='k-content'#= contentAttributes(data) # role='tabpanel'>#= content(item) #</div>"),itemWrapper:f("<#= tag(item) # class='k-link'#= contentUrl(item) ##= textAttributes(item) #>#= image(item) ##= sprite(item) ##= text(item) #</#= tag(item) #>"),item:f("<li class='#= wrapperCssClass(group, item) #' role='tab' #=item.active ? \"aria-selected='true'\" : ''#>#= itemWrapper(data) #</li>"),image:f("<img class='k-image' alt='' src='#= imageUrl #' />"),
sprite:f("<span class='k-sprite #= spriteCssClass #'></span>"),empty:f("")},Y={wrapperCssClass:function(e,t){var n="k-item",i=t.index;return n+=t.enabled===!1?" k-state-disabled":" k-state-default",0===i&&(n+=" k-first"),i==e.length-1&&(n+=" k-last"),n},textAttributes:function(e){return e.url?" href='"+e.url+"'":""},text:function(e){return e.encoded===!1?e.text:r.htmlEncode(e.text)},tag:function(e){return e.url?"a":"span"},contentAttributes:function(e){return e.active!==!0?" style='display:none' aria-hidden='true' aria-expanded='false'":""},content:function(e){return e.content?e.content:e.contentUrl?"":"&nbsp;"},contentUrl:function(e){return e.contentUrl?r.attr("content-url")+'="'+e.contentUrl+'"':""}},Q=g.extend({init:function(t,n){var i,o,s,a=this;g.fn.init.call(a,t,n),a._animations(a.options),n=a.options,a._contentUrls=n.contentUrls||[],a._wrapper(),a._isRtl=r.support.isRtl(a.wrapper),a._tabindex(),a._updateClasses(),a._dataSource(),n.dataSource&&a.dataSource.fetch(),a._tabPosition(),a._scrollable(),a._contentUrls.length?a.wrapper.find(".k-tabstrip-items > .k-item").each(function(t,n){var i=a._contentUrls[t];"string"==typeof i&&e(n).find(">."+C).data(z,i)}):a._contentUrls.length=a.tabGroup.find("li.k-item").length,a.wrapper.on(P+_+" "+B+_,G,a._toggleHover).on("focus"+_,e.proxy(a._active,a)).on("blur"+_,function(){a._current(null)}),a._keyDownProxy=e.proxy(a._keydown,a),n.navigatable&&a.wrapper.on("keydown"+_,a._keyDownProxy),a.options.value&&(i=a.options.value),a.wrapper.children(".k-tabstrip-items").on(T+_,".k-state-disabled .k-link",!1).on(T+_," > "+j,function(t){var n,i=a.wrapper[0];if(i!==document.activeElement)if(n=r.support.browser.msie)try{i.setActive()}catch(o){i.focus()}else i.focus();a._click(e(t.currentTarget))&&t.preventDefault()}),o=a.tabGroup.children("li."+O),s=a.contentHolder(o.index()),o[0]&&s.length>0&&0===s[0].childNodes.length&&a.activateTab(o.eq(0)),a.element.attr("role","tablist"),a.element[0].id&&(a._ariaId=a.element[0].id+"_ts_active"),a.value(i),r.notify(a)},_active:function(){var e=this.tabGroup.children().filter("."+O);e=e[0]?e:this._endItem("first"),e[0]&&this._current(e)},_endItem:function(e){return this.tabGroup.children(j)[e]()},_getItem:function(e){return this.tabGroup.children(q)[e]()},_item:function(e,t){var n;return n=t===y?"last":"first",e?(e=e[t](),e[0]||(e=this.tabGroup.children(q)[n]()),e.hasClass(H)&&e.addClass(V),(e.hasClass(H)||e.hasClass(O))&&(this._focused=e),e):this._endItem(n)},_current:function(e){var n=this,i=n._focused,o=n._ariaId;return e===t?i:(i&&(n.tabGroup.children("#"+o).removeAttr("id"),i.removeClass(V)),e&&(e.hasClass(O)||e.addClass(V),n.element.removeAttr("aria-activedescendant"),o=e[0].id||o,o&&(e.attr("id",o),n.element.attr("aria-activedescendant",o))),n._focused=e,t)},_keydown:function(e){var n,i=this,o=e.keyCode,r=i._current(),s=i._isRtl,l=/top|bottom/.test(i.options.tabPosition);if(e.target==e.currentTarget){if(o!==a.DOWN||l)if(o!==a.UP||l)if(o===a.RIGHT&&l)n=s?y:k;else if(o===a.LEFT&&l)n=s?k:y;else if(o==a.ENTER||o==a.SPACEBAR)i._click(r),e.preventDefault();else{if(o==a.HOME)return i._click(i._getItem("first")),e.preventDefault(),t;if(o==a.END)return i._click(i._getItem("last")),e.preventDefault(),t}else n=y;else n=k;n&&(i._click(i._item(r,n)),e.preventDefault())}},_dataSource:function(){var t=this;t.dataSource&&t._refreshHandler?t.dataSource.unbind("change",t._refreshHandler):t._refreshHandler=e.proxy(t.refresh,t),t.dataSource=r.data.DataSource.create(t.options.dataSource).bind("change",t._refreshHandler)},setDataSource:function(e){var t=this;t.options.dataSource=e,t._dataSource(),t.dataSource.fetch()},_animations:function(e){e&&"animation"in e&&!e.animation&&(e.animation={open:{effects:{}},close:{effects:{}}})},refresh:function(e){var t,n,i,o,s=this,a=s.options,l=r.getter(a.dataEncodedField),c=r.getter(a.dataTextField),d=r.getter(a.dataContentField),u=r.getter(a.dataContentUrlField),h=r.getter(a.dataImageUrlField),f=r.getter(a.dataUrlField),p=r.getter(a.dataSpriteCssClass),m=[],g=s.dataSource.view();for(e=e||{},i=e.action,i&&(g=e.items),t=0,o=g.length;t<o;t++)n={text:c(g[t])},a.dataEncodedField&&(n.encoded=l(g[t])),a.dataContentField&&(n.content=d(g[t])),a.dataContentUrlField&&(n.contentUrl=u(g[t])),a.dataUrlField&&(n.url=f(g[t])),a.dataImageUrlField&&(n.imageUrl=h(g[t])),a.dataSpriteCssClass&&(n.spriteCssClass=p(g[t])),m[t]=n;if("add"==e.action)e.index<s.tabGroup.children().length?s.insertBefore(m,s.tabGroup.children().eq(e.index)):s.append(m);else if("remove"==e.action)for(t=0;t<g.length;t++)s.remove(e.index);else"itemchange"==e.action?(t=s.dataSource.view().indexOf(g[0]),e.field===a.dataTextField&&s.tabGroup.children().eq(t).find(".k-link").text(g[0].get(e.field)),e.field===a.dataUrlField&&(s._contentUrls[t]=g[0].get(e.field))):(s.trigger("dataBinding"),s.remove("li"),s._contentUrls=[],s.append(m),s.trigger("dataBound"))},value:function(n){var i=this;return n===t?i.select().text():(n!=i.value()&&i.tabGroup.children().each(function(){e.trim(e(this).text())==n&&i.select(this)}),t)},items:function(){return this.tabGroup[0].children},setOptions:function(e){var t=this,n=t.options.animation;t._animations(e),e.contentUrls&&(t._contentUrls=e.contentUrls),e.animation=u(!0,n,e.animation),e.navigatable?t.wrapper.on("keydown"+_,t._keyDownProxy):t.wrapper.off("keydown"+_,t._keyDownProxy),g.fn.setOptions.call(t,e)},events:[M,R,x,D,L,"change","dataBinding","dataBound"],options:{name:"TabStrip",dataEncodedField:"",dataTextField:"",dataContentField:"",dataImageUrlField:"",dataUrlField:"",dataSpriteCssClass:"",dataContentUrlField:"",tabPosition:"top",animation:{open:{effects:"expand:vertical fadeIn",duration:200},close:{duration:200}},collapsible:!1,navigatable:!0,contentUrls:!1,scrollable:{distance:$}},destroy:function(){var e=this,t=e.scrollWrap;g.fn.destroy.call(e),e._refreshHandler&&e.dataSource.unbind("change",e._refreshHandler),e.wrapper.off(_),e.wrapper.children(".k-tabstrip-items").off(_),e._scrollableModeActive&&(e._scrollPrevButton.off().remove(),e._scrollNextButton.off().remove()),r.destroy(e.wrapper),t.children(".k-tabstrip").unwrap()},select:function(t){var n=this;return 0===arguments.length?n.tabGroup.children("li."+O):(isNaN(t)||(t=n.tabGroup.children().get(t)),t=n.tabGroup.find(t),e(t).each(function(t,i){i=e(i),i.hasClass(O)||n.trigger(M,{item:i[0],contentElement:n.contentHolder(i.index())[0]})||n.activateTab(i)}),n)},enable:function(e,t){return this._toggleDisabled(e,t!==!1),this},disable:function(e){return this._toggleDisabled(e,!1),this},reload:function(t){var n,i;return t=this.tabGroup.find(t),n=this,i=n._contentUrls,t.each(function(){var t=e(this),o=t.find("."+C).data(z)||i[t.index()],r=n.contentHolder(t.index());o&&n.ajaxRequest(t,r,null,o)}),n},append:function(e){var t=this,n=t._create(e);return c(n.tabs,function(e){var i=n.contents[e];t.tabGroup.append(this),"bottom"==t.options.tabPosition?t.tabGroup.before(i):t._scrollableModeActive?t._scrollPrevButton.before(i):t.wrapper.append(i),t.angular("compile",function(){return{elements:[i]}})}),i(t.tabGroup),t._updateContentElements(),t.resize(!0),t},_appendUrlItem:function(e){this._contentUrls.push(e)},_moveUrlItem:function(e,t){this._contentUrls.splice(t,0,this._contentUrls.splice(e,1)[0])},_removeUrlItem:function(e){this._contentUrls.splice(e,1)},insertBefore:function(t,n){n=e(t).is(e(n))?this.tabGroup.find(n).next():this.tabGroup.find(n);var o=this,r=o._create(t),s=o.element.find("[id='"+n.attr("aria-controls")+"']");return c(r.tabs,function(t){var i=r.contents[t],a=r.newTabsCreated?o._contentUrls.length-(r.tabs.length-t):e(i).index()-1;n.before(this),s.before(i),o._moveUrlItem(a,e(this).index()),o.angular("compile",function(){return{elements:[i]}})}),i(o.tabGroup),o._updateContentElements(r.newTabsCreated),o.resize(!0),o},insertAfter:function(t,n){n=e(t).is(e(n))?this.tabGroup.find(n).prev():this.tabGroup.find(n);var o=this,r=o._create(t),s=o.element.find("[id='"+n.attr("aria-controls")+"']");return c(r.tabs,function(t){var i=r.contents[t],a=r.newTabsCreated?o._contentUrls.length-(r.tabs.length-t):e(i).index()-1;n.after(this),s.after(i),o._moveUrlItem(a,e(this).index()),o.angular("compile",function(){return{elements:[i]}})}),i(o.tabGroup),o._updateContentElements(r.newTabsCreated),o.resize(!0),o},remove:function(t){var n,i=this,o=typeof t;return"string"===o?t=i.tabGroup.find(t):"number"===o&&(t=i.tabGroup.children().eq(t)),n=t.map(function(){var t=e(this).index(),n=i.contentElement(t);return r.destroy(n),i._removeUrlItem(t),n}),t.remove(),n.empty(),n.remove(),i._updateContentElements(),i.resize(!0),i},_create:function(t){var i,o,s,a=this,c=!1;return t=t instanceof r.data.ObservableArray?t.toJSON():t,e.isPlainObject(t)||e.isArray(t)?(t=e.isArray(t)?t:[t],c=!0,i=l(t,function(n,i){return a._appendUrlItem(t[i].contentUrl||null),e(Q.renderItem({group:a.tabGroup,item:u(n,{index:i})}))}),o=l(t,function(t,n){if("string"==typeof t.content||t.contentUrl)return e(Q.renderContent({item:u(t,{index:n})}))})):(i="string"==typeof t&&"<"!=t[0]?a.element.find(t):e(t),o=e(),i.each(function(){if(/k-tabstrip-items/.test(this.parentNode.className)){var t=a.element.find("[id='"+this.getAttribute("aria-controls")+"']");s=t}else s=e("<div class='"+F+"'/>");o=o.add(s)}),n(i)),{tabs:i,contents:o,newTabsCreated:c}},_toggleDisabled:function(t,n){t=this.tabGroup.find(t),t.each(function(){e(this).toggleClass(N,n).toggleClass(H,!n).attr("aria-disabled",!n)})},_updateClasses:function(){var o,r,s,a=this;a.wrapper.addClass("k-widget k-header k-tabstrip"),a.tabGroup=a.wrapper.children("ul").addClass("k-tabstrip-items k-reset"),a.tabGroup[0]||(a.tabGroup=e("<ul class='k-tabstrip-items k-reset'/>").appendTo(a.wrapper)),o=a.tabGroup.find("li").addClass("k-item"),o.length&&(r=o.filter("."+O).index(),s=r>=0?r:t,a.tabGroup.contents().filter(function(){return 3==this.nodeType&&!d(this.nodeValue)}).remove()),r>=0&&o.eq(r).addClass(W),a.contentElements=a.wrapper.children("div"),a.contentElements.addClass(F).eq(s).addClass(O).css({display:"block"}),o.length&&(n(o),i(a.tabGroup),a._updateContentElements(!0))},_elementId:function(e,t){var n,i=e.attr("id"),o=this.element.attr("id");return!i||i.indexOf(o+"-")>-1?(n=(o||r.guid())+"-",n+(t+1)):i},_updateContentElements:function(t){var n=this,i=n._contentUrls,o=n.tabGroup.children(".k-item"),s=n.wrapper.children("div"),a=n._elementId.bind(n);s.length&&o.length>s.length?s.each(function(n){var i=a(e(this),n),r=o.filter("[aria-controls="+(this.id||0)+"]")[0];!r&&t&&(r=o[n]),r&&r.setAttribute("aria-controls",i),this.setAttribute("id",i)}):o.each(function(t){var o=s.eq(t),r=a(o,t);this.setAttribute("aria-controls",r),!o.length&&i[t]?e("<div class='"+F+"'/>").appendTo(n.wrapper).attr("id",r):(o.attr("id",r),e(this).children(".k-loading")[0]||i[t]||e("<span class='k-loading k-complete'/>").prependTo(this)),o.attr("role","tabpanel"),o.filter(":not(."+O+")").attr("aria-hidden",!0).attr("aria-expanded",!1),o.filter("."+O).attr("aria-expanded",!0)}),n.contentElements=n.contentAnimators=n.wrapper.children("div"),n.tabsHeight=m(n.tabGroup)+parseInt(n.wrapper.css("border-top-width"),10)+parseInt(n.wrapper.css("border-bottom-width"),10),r.kineticScrollNeeded&&r.mobile.ui.Scroller&&(r.touchScroller(n.contentElements),n.contentElements=n.contentElements.children(".km-scroll-container"))},_wrapper:function(){var e=this;e.wrapper=e.element.is("ul")?e.element.wrapAll("<div />").parent():e.element,e.scrollWrap=e.wrapper.parent(".k-tabstrip-wrapper"),e.scrollWrap[0]||(e.scrollWrap=e.wrapper.wrapAll("<div class='k-tabstrip-wrapper' />").parent())},_tabPosition:function(){var e=this,t=e.options.tabPosition;e.wrapper.addClass("k-floatwrap k-tabstrip-"+t),"bottom"==t&&e.tabGroup.appendTo(e.wrapper),e.resize(!0)},_setContentElementsDimensions:function(){var e,t,n,i,o,r,s=this,a=s.options.tabPosition;"left"!=a&&"right"!=a||(e=s.wrapper.children(".k-content"),t=e.filter(":visible"),n="margin-"+a,i=s.tabGroup,o=p(i),r=Math.ceil(i.height())-parseInt(t.css("padding-top"),10)-parseInt(t.css("padding-bottom"),10)-parseInt(t.css("border-top-width"),10)-parseInt(t.css("border-bottom-width"),10),setTimeout(function(){e.css(n,o).css("min-height",r)}))},_resize:function(){this._setContentElementsDimensions(),this._scrollable()},_sizeScrollWrap:function(e){var t,n;e.is(":visible")&&(t=this.options.tabPosition,n=Math.floor(m(e,!0))+("left"===t||"right"===t?2:this.tabsHeight),this.scrollWrap.css("height",n).css("height"))},_toggleHover:function(t){e(t.currentTarget).toggleClass(U,t.type==P)},_click:function(e){var t,n,i=this,o=e.find("."+C),r=o.attr(w),s=i.options.collapsible,a=e.index(),l=i.contentHolder(a),c=e.parent().children(),d=c.filter("."+V);if(e.closest(".k-widget")[0]==i.wrapper[0]){if(e.is("."+H+(s?"":",."+O)))return d.removeClass(V),i._focused=e,e.addClass(V),i._current(e),i._scrollableModeActive&&i._scrollTabsToItem(e),!0;if(n=o.data(z)||i._contentUrls[a]||r&&("#"==r.charAt(r.length-1)||r.indexOf("#"+i.element[0].id+"-")!=-1),t=!r||n,i.tabGroup.children("[data-animating]").length)return t;if(i.trigger(M,{item:e[0],contentElement:l[0]}))return!0;if(t!==!1)return s&&e.is("."+O)?(i.deactivateTab(e),!0):(i.activateTab(e)&&(t=!0),t)}},_scrollable:function(){var e,t,n,i,s,a,l=this,c=l.options;l._scrollableAllowed()&&(l.wrapper.addClass("k-tabstrip-scrollable"),e=l.wrapper[0].offsetWidth,t=l.tabGroup[0].scrollWidth,t>e&&!l._scrollableModeActive?(l._nowScrollingTabs=!1,l._isRtl=r.support.isRtl(l.element),s=r.support.mobileOS?"touchstart":"mousedown",a=r.support.mobileOS?"touchend":"mouseup",l.wrapper.append(o("prev","k-i-arrow-60-left")+o("next","k-i-arrow-60-right")),n=l._scrollPrevButton=l.wrapper.children(".k-tabstrip-prev"),i=l._scrollNextButton=l.wrapper.children(".k-tabstrip-next"),l.tabGroup.css({marginLeft:p(n)+9,marginRight:p(i)+12}),n.on(s+_,function(){l._nowScrollingTabs=!0,l._scrollTabsByDelta(c.scrollable.distance*(l._isRtl?1:-1))}),i.on(s+_,function(){l._nowScrollingTabs=!0,l._scrollTabsByDelta(c.scrollable.distance*(l._isRtl?-1:1))}),n.add(i).on(a+_,function(){l._nowScrollingTabs=!1}),l._scrollableModeActive=!0,l._toggleScrollButtons()):l._scrollableModeActive&&t<=e?(l._scrollableModeActive=!1,l.wrapper.removeClass("k-tabstrip-scrollable"),l._scrollPrevButton.off().remove(),l._scrollNextButton.off().remove(),l.tabGroup.css({marginLeft:"",marginRight:""})):l._scrollableModeActive?l._toggleScrollButtons():l.wrapper.removeClass("k-tabstrip-scrollable"))},_scrollableAllowed:function(){var e=this.options;return e.scrollable&&!e.scrollable.distance&&(e.scrollable={distance:$}),e.scrollable&&!isNaN(e.scrollable.distance)&&("top"==e.tabPosition||"bottom"==e.tabPosition)},_scrollTabsToItem:function(e){var t,n=this,i=n.tabGroup,o=i.scrollLeft(),r=p(e),s=n._isRtl?e.position().left:e.position().left-i.children().first().position().left,a=i[0].offsetWidth,l=Math.ceil(parseFloat(i.css("padding-left")));n._isRtl?s<0?t=o+s-(a-o)-l:s+r>a&&(t=o+s-r+2*l):o+a<s+r?t=s+r-a+2*l:o>s&&(t=s-l),i.finish().animate({scrollLeft:t},"fast","linear",function(){n._toggleScrollButtons()})},_scrollTabsByDelta:function(e){var t=this,n=t.tabGroup,i=n.scrollLeft();n.finish().animate({scrollLeft:i+e},"fast","linear",function(){t._nowScrollingTabs&&!jQuery.fx.off?t._scrollTabsByDelta(e):t._toggleScrollButtons()})},_toggleScrollButtons:function(){var e=this,t=e.tabGroup,n=t.scrollLeft();e._scrollPrevButton.toggle(e._isRtl?n<t[0].scrollWidth-t[0].offsetWidth-1:0!==n),e._scrollNextButton.toggle(e._isRtl?0!==n:n<t[0].scrollWidth-t[0].offsetWidth-1)},deactivateTab:function(e){var t=this,n=t.options.animation,i=n.open,o=u({},n.close),s=o&&"effects"in o;e=t.tabGroup.find(e),o=u(s?o:u({reverse:!0},i),{hide:!0}),r.size(i.effects)?(e.kendoAddClass(N,{duration:i.duration}),e.kendoRemoveClass(O,{duration:i.duration})):(e.addClass(N),e.removeClass(O)),e.removeAttr("aria-selected"),t.contentAnimators.filter("."+O).kendoStop(!0,!0).kendoAnimate(o).removeClass(O).attr("aria-hidden",!0)},activateTab:function(e){var t,n,i,o,s,a,l,c,d,h,f,p,g,v,_,b;if(!this.tabGroup.children("[data-animating]").length)return e=this.tabGroup.find(e),t=this,n=t.options.animation,i=n.open,o=u({},n.close),s=o&&"effects"in o,a=e.parent().children(),l=a.filter("."+O),c=a.index(e),d=i&&"duration"in i&&"effects"in i,o=u(s?o:u({reverse:!0},i),{hide:!0}),r.size(i.effects)?(l.kendoRemoveClass(O,{duration:o.duration}),e.kendoRemoveClass(U,{duration:o.duration})):(l.removeClass(O),e.removeClass(U)),h=t.contentAnimators,t.inRequest&&(t.xhr.abort(),t.inRequest=!1),0===h.length?(t.tabGroup.find("."+W).removeClass(W),e.addClass(W).css("z-index"),e.addClass(O),t._current(e),t.trigger("change"),t._scrollableModeActive&&t._scrollTabsToItem(e),!1):(f=h.filter("."+O),p=t.contentHolder(c),g=p.closest(".k-content"),t.tabsHeight=m(t.tabGroup)+parseInt(t.wrapper.css("border-top-width"),10)+parseInt(t.wrapper.css("border-bottom-width"),10),t._sizeScrollWrap(f),0===p.length?(f.removeClass(O).attr("aria-hidden",!0).kendoStop(!0,!0).kendoAnimate(o),!1):(e.attr("data-animating",!0),v=(e.children("."+C).data(z)||t._contentUrls[c]||!1)&&p.is(A),_=function(){l.removeAttr("aria-selected"),e.attr("aria-selected",!0),t._current(e),t._sizeScrollWrap(g),g.addClass(O).removeAttr("aria-hidden").kendoStop(!0,!0).attr("aria-expanded",!0).kendoAnimate(u({init:function(){t.trigger(x,{item:e[0],contentElement:p[0]}),r.resize(p)}},i,{complete:function(){e.removeAttr("data-animating"),t.trigger(R,{item:e[0],contentElement:p[0]}),r.resize(p),t.scrollWrap.css("height","").css("height"),d&&(r.support.browser.msie||r.support.browser.edge)&&p.finish().animate({opacity:.9},"fast","linear",function(){p.finish().animate({opacity:1},"fast","linear")})}}))},b=function(){v?(e.removeAttr("data-animating"),t.ajaxRequest(e,p,function(){e.attr("data-animating",!0),_(),t.trigger("change")})):(_(),t.trigger("change")),t._scrollableModeActive&&t._scrollTabsToItem(e)},f.removeClass(O),t.tabGroup.find("."+W).removeClass(W),e.addClass(W).css("z-index"),r.size(i.effects)?(l.kendoAddClass(N,{duration:i.duration}),e.kendoAddClass(O,{duration:i.duration})):(l.addClass(N),e.addClass(O)),f.attr("aria-hidden",!0),f.attr("aria-expanded",!1),f.length?f.kendoStop(!0,!0).kendoAnimate(u({complete:b},o)):b(),!0))},contentElement:function(n){var i,o,s,a;if(isNaN(n-0))return t;if(i=this.contentElements&&this.contentElements[0]&&!r.kineticScrollNeeded?this.contentElements:this.contentAnimators,o=e(this.tabGroup.children()[n]).attr("aria-controls"),i)for(s=0,a=i.length;s<a;s++)if(i.eq(s).closest(".k-content")[0].id==o)return i[s];return t},contentHolder:function(t){var n=e(this.contentElement(t)),i=n.children(".km-scroll-container");return r.support.touch&&i[0]?i:n},ajaxRequest:function(t,n,i,o){var s,a,l,c,d,u,f,p,m,g;t=this.tabGroup.find(t),s=this,a=e.ajaxSettings.xhr,l=t.find("."+C),c={},d=t.width()/2,u=!1,f=t.find(".k-loading").removeClass("k-complete"),f[0]||(f=e("<span class='k-loading'/>").prependTo(t)),p=2*d-f.width(),m=function(){f.animate({marginLeft:(parseInt(f.css("marginLeft"),10)||0)<d?p:0},500,m)},r.support.browser.msie&&r.support.browser.version<10&&setTimeout(m,40),o=o||l.data(z)||s._contentUrls[t.index()]||l.attr(w),s.inRequest=!0,g={type:"GET",cache:!1,url:o,dataType:"html",data:c,xhr:function(){var t=this,n=a(),i=t.progressUpload?"progressUpload":!!t.progress&&"progress";return n&&e.each([n,n.upload],function(){this.addEventListener&&this.addEventListener("progress",function(e){i&&t[i](e)},!1)}),t.noProgress=!(window.XMLHttpRequest&&"upload"in new XMLHttpRequest),n},progress:function(e){if(e.lengthComputable){var t=parseInt(e.loaded/e.total*100,10)+"%";f.stop(!0).addClass("k-progress").css({width:t,marginLeft:0})}},error:function(e,t){s.trigger("error",{xhr:e,status:t})&&this.complete()},stopProgress:function(){clearInterval(u),f.stop(!0).addClass("k-progress")[0].style.cssText=""},complete:function(e){s.inRequest=!1,this.noProgress?setTimeout(this.stopProgress,500):this.stopProgress(),"abort"==e.statusText&&f.remove()},success:function(e){var a,l,c;f.addClass("k-complete");try{a=this,l=10,a.noProgress&&(f.width(l+"%"),u=setInterval(function(){a.progress({lengthComputable:!0,loaded:Math.min(l,100),total:100}),l+=10},40)),s.angular("cleanup",function(){return{elements:n.get()}}),r.destroy(n),n.html(e)}catch(d){c=window.console,c&&c.error&&c.error(d.name+": "+d.message+" in "+o),this.error(this.xhr,"error")}i&&i.call(s,n),s.angular("compile",function(){return{elements:n.get()}}),s.trigger(L,{item:t[0],contentElement:n[0]})}},"object"==typeof o&&(g=e.extend(!0,{},g,o),h(g.url)&&(g.url=g.url())),s.xhr=e.ajax(g)}});u(Q,{renderItem:function(e){e=u({tabStrip:{},group:{}},e);var t=K.empty,n=e.item;return K.item(u(e,{image:n.imageUrl?K.image:t,sprite:n.spriteCssClass?K.sprite:t,itemWrapper:K.itemWrapper},Y))},renderContent:function(e){return K.content(u(e,Y))}}),r.ui.plugin(Q)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("util/undoredostack.min",["kendo.core.min"],e)}(function(){!function(e){var t=e.Observable.extend({init:function(t){e.Observable.fn.init.call(this,t),this.clear()},events:["undo","redo"],push:function(e){this.stack=this.stack.slice(0,this.currentCommandIndex+1),this.currentCommandIndex=this.stack.push(e)-1},undo:function(){if(this.canUndo()){var e=this.stack[this.currentCommandIndex--];e.undo(),this.trigger("undo",{command:e})}},redo:function(){if(this.canRedo()){var e=this.stack[++this.currentCommandIndex];e.redo(),this.trigger("redo",{command:e})}},clear:function(){this.stack=[],this.currentCommandIndex=-1},canUndo:function(){return this.currentCommandIndex>=0},canRedo:function(){return this.currentCommandIndex!=this.stack.length-1}});e.deepExtend(e,{util:{UndoRedoStack:t}})}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/main.min",["util/undoredostack.min","kendo.combobox.min","kendo.dropdownlist.min","kendo.window.min","kendo.colorpicker.min"],e)}(function(){!function(e,t){var n,i,o,r,s=window.kendo,a=s.Class,l=s.ui.Widget,c=s.support.mobileOS,d=s.support.browser,u=e.extend,h=e.proxy,f=s.deepExtend,p=s.keys,m="select",g="select.k-select-overlay",v=a.extend({init:function(e){this.options=e},getHtml:function(){var e=this.options;return s.template(e.template,{useWithBlock:!1})(e)}}),_={editorWrapperTemplate:'<table cellspacing="4" cellpadding="0" class="k-widget k-editor k-header" role="presentation"><tbody><tr role="presentation"><td class="k-editor-toolbar-wrap" role="presentation"><ul class="k-editor-toolbar" role="toolbar" /></td></tr><tr><td class="k-editable-area" /></tr></tbody></table>',buttonTemplate:'# var iconCssClass= "k-icon k-i-" + kendo.toHyphens(data.cssClass.replace("k-", ""));#<a tabindex="0" role="button" class="k-tool"#= data.popup ? " data-popup" : "" # unselectable="on" title="#= data.title #"><span unselectable="on" class="k-tool-icon #= iconCssClass #"></span><span class="k-tool-text">#= data.title #</span></a>',colorPickerTemplate:'<div class="k-colorpicker k-icon k-i-#= data.cssClass.replace("k-", "") #" />',comboBoxTemplate:'<select title="#= data.title #" class="#= data.cssClass #" />',dropDownListTemplate:'<span class="k-editor-dropdown"><select title="#= data.title #" class="#= data.cssClass #" /></span>',separatorTemplate:'<span class="k-separator" />',overflowAnchorTemplate:'<a tabindex="0" role="button" class="k-tool k-overflow-anchor" data-popup unselectable="on" title="#= data.title #" aria-haspopup="true" aria-expanded="false"><span unselectable="on" class="k-icon k-i-more-vertical"></span><span class="k-tool-text">#= data.title #</span></a>',formatByName:function(t,n){for(var i=0;i<n.length;i++)if(e.inArray(t,n[i].tags)>=0)return n[i]},getToolCssClass:function(e){var t={superscript:"sup-script",subscript:"sub-script",justifyLeft:"align-left",justifyCenter:"align-center",justifyRight:"align-right",justifyFull:"align-justify",insertUnorderedList:"list-unordered",insertOrderedList:"list-ordered","import":"login",indent:"indent-increase",outdent:"indent-decrease",createLink:"link-horizontal",unlink:"unlink-horizontal",insertImage:"image",insertFile:"file-add",viewHtml:"html",foreColor:"foreground-color",backColor:"paint",createTable:"table-insert",addColumnLeft:"table-column-insert-left",addColumnRight:"table-column-insert-right",addRowAbove:"table-row-insert-above",addRowBelow:"table-row-insert-below",deleteRow:"table-row-delete",deleteColumn:"table-column-delete",tableWizard:"table-properties",tableWizardInsert:"table-wizard",cleanFormatting:"clear-css"},n=t[e];return n?n:e},registerTool:function(e,t){var n=t.options;n&&n.template&&(n.template.options.cssClass="k-"+_.getToolCssClass(e)),t.name||(t.options.name=e,t.name=e.toLowerCase()),k.defaultTools[e]=t},registerFormat:function(e,t){k.fn.options.formats[e]=t},cacheComments:function(e,t){for(var n in t)e=e.replace(t[n],"{"+n+"}");return e},retrieveComments:function(e,t){for(var n in t)e=e.replace("{"+n+"}",t[n]);return e}},b={bold:"Bold",italic:"Italic",underline:"Underline",strikethrough:"Strikethrough",superscript:"Superscript",subscript:"Subscript",justifyCenter:"Center text",justifyLeft:"Align text left",justifyRight:"Align text right",justifyFull:"Justify",insertUnorderedList:"Insert unordered list",insertOrderedList:"Insert ordered list",indent:"Indent",outdent:"Outdent",createLink:"Insert hyperlink",unlink:"Remove hyperlink",insertImage:"Insert image",insertFile:"Insert file",insertHtml:"Insert HTML",viewHtml:"View HTML",fontName:"Select font family",fontNameInherit:"(inherited font)",fontSize:"Select font size",fontSizeInherit:"(inherited size)",formatBlock:"Format",formatting:"Format",foreColor:"Color",backColor:"Background color",style:"Styles",emptyFolder:"Empty Folder",editAreaTitle:"Editable area. Press F10 for toolbar.",uploadFile:"Upload",overflowAnchor:"More tools",orderBy:"Arrange by:",orderBySize:"Size",orderByName:"Name",invalidFileType:'The selected file "{0}" is not valid. Supported file types are {1}.',deleteFile:'Are you sure you want to delete "{0}"?',overwriteFile:'A file with name "{0}" already exists in the current directory. Do you want to overwrite it?',directoryNotFound:"A directory with this name was not found.",imageWebAddress:"Web address",imageAltText:"Alternate text",imageWidth:"Width (px)",imageHeight:"Height (px)",fileWebAddress:"Web address",fileTitle:"Title",fileText:"Text",linkWebAddress:"Web address",linkText:"Text",linkToolTip:"ToolTip",linkOpenInNewWindow:"Open link in new window",dialogUpdate:"Update",dialogInsert:"Insert",dialogOk:"Ok",dialogCancel:"Cancel",cleanFormatting:"Clean formatting",createTable:"Create a table",createTableHint:"Create a {0} x {1} table",addColumnLeft:"Add column on the left",addColumnRight:"Add column on the right",addRowAbove:"Add row above",addRowBelow:"Add row below",deleteRow:"Delete row",deleteColumn:"Delete column",tableWizard:"Table Wizard",tableTab:"Table",cellTab:"Cell",accessibilityTab:"Accessibility",caption:"Caption",summary:"Summary",width:"Width",height:"Height",units:"Units",cellSpacing:"Cell Spacing",cellPadding:"Cell Padding",cellMargin:"Cell Margin",alignment:"Alignment",background:"Background",cssClass:"CSS Class",id:"ID",border:"Border",borderStyle:"Border Style",collapseBorders:"Collapse borders",wrapText:"Wrap text",associateCellsWithHeaders:"Associate cells with headers",alignLeft:"Align Left",alignCenter:"Align Center",alignRight:"Align Right",alignLeftTop:"Align Left Top",alignCenterTop:"Align Center Top",alignRightTop:"Align Right Top",alignLeftMiddle:"Align Left Middle",alignCenterMiddle:"Align Center Middle",alignRightMiddle:"Align Right Middle",alignLeftBottom:"Align Left Bottom",alignCenterBottom:"Align Center Bottom",alignRightBottom:"Align Right Bottom",alignRemove:"Remove Alignment",columns:"Columns",rows:"Rows",selectAllCells:"Select All Cells",exportAs:"Export As","import":"Import"},w=!c||c.ios&&c.flatVersion>=500||!c.ios&&t!==document.documentElement.contentEditable,y={basic:["bold","italic","underline"],alignment:["justifyLeft","justifyCenter","justifyRight"],lists:["insertUnorderedList","insertOrderedList"],indenting:["indent","outdent"],links:["createLink","unlink"],tables:["tableWizard","createTable","addColumnLeft","addColumnRight","addRowAbove","addRowBelow","deleteRow","deleteColumn"]},k=l.extend({init:function(n,i){var o,r,a,c,d,p,m=this,g=s.ui.editor,v=g.Dom;w&&(l.fn.init.call(m,n,i),m.options=f({},m.options,i),m.options.tools=m.options.tools.slice(),n=m.element,p=n[0],c=v.name(p),this._registerHandler(n.closest("form"),"submit",h(m.update,m,t)),a=u({},m.options),a.editor=m,"textarea"==c?(m._wrapTextarea(),r=m.wrapper.find(".k-editor-toolbar"),p.id&&r.attr("aria-controls",p.id)):(m.element.attr("contenteditable",!0).addClass("k-widget k-editor k-editor-inline"),a.popup=!0,r=e('<ul class="k-editor-toolbar" role="toolbar" />').insertBefore(n)),m.toolbar=new g.Toolbar(r[0],a),m.toolbar.bindTo(m),"textarea"==c&&setTimeout(function(){var e=m.wrapper[0].style.height,t=parseInt(e,10),n=m.wrapper.height();e.indexOf("px")>0&&!isNaN(t)&&n>t&&m.wrapper.height(t-(n-t))}),m._resizable(),m._initializeContentElement(m),m.keyboard=new g.Keyboard([new g.BackspaceHandler(m),new g.TypingHandler(m),new g.SystemHandler(m),new g.SelectAllHandler(m)]),m.clipboard=new g.Clipboard(this),m.undoRedoStack=new s.util.UndoRedoStack,i&&i.value?o=i.value:m.textarea?(o=p.value,m.options.encoded&&e.trim(p.defaultValue).length&&(o=p.defaultValue),d=v.getAllComments(e("<div></div>").html(o)[0]),o=_.cacheComments(o,d),o=o.replace(/[\r\n\v\f\t ]+/gi," "),o=_.retrieveComments(o,d)):o=p.innerHTML,m.value(o||s.ui.editor.emptyElementContent),this._registerHandler(document,{mousedown:function(){m._endTyping()},mouseup:function(e){m._mouseup(e)}}),m._initializeImmutables(),m.toolbar.resize(),s.notify(m))},setOptions:function(e){var t=this;l.fn.setOptions.call(t,e),e.tools&&t.toolbar.bindTo(t)},_endTyping:function(){var e=this.keyboard;try{e.isTypingInProgress()&&(e.endTyping(!0),this.saveSelection())}catch(t){}},_selectionChange:function(){this._selectionStarted=!1,this.saveSelection(),this.trigger("select",{})},_resizable:function(){var n,i=this.options.resizable,o=e.isPlainObject(i)?i.content===t||i.content===!0:i;o&&this.textarea&&(e("<div class='k-resize-handle'><span class='k-icon k-i-arrow-45-down-right' /></div>").insertAfter(this.textarea),this.wrapper.addClass("k-resizable"),this.wrapper.kendoResizable(u({},this.options.resizable,{start:function(t){var n=this.editor=e(t.currentTarget).closest(".k-editor");this.initialSize=n.height(),n.find("td:last").append("<div class='k-overlay' />")},resize:function(e){var t=e.y.initialDelta,n=this.initialSize+t,i=this.options.min||0,o=this.options.max||1/0;n=Math.min(o,Math.max(i,n)),this.editor.height(n)},resizeend:function(){this.editor.find(".k-overlay").remove(),this.editor=null}})),s.support.mobileOS.ios&&(n=this.wrapper.getKendoResizable(),n.draggable.options.ignore=g))},_initializeTableResizing:function(){var e=this;s.ui.editor.TableResizing.create(e),e._showTableResizeHandlesProxy=h(e._showTableResizeHandles,e),e.bind(m,e._showTableResizeHandlesProxy)},_destroyTableResizing:function(){var e=this,t=e.tableResizing;t&&(t.destroy(),e.tableResizing=null),e._showTableResizeHandlesProxy&&e.unbind(m,e._showTableResizeHandlesProxy)},_showTableResizeHandles:function(){var e=this,t=e.tableResizing;t&&t.showResizeHandles()},_initializeColumnResizing:function(){s.ui.editor.ColumnResizing.create(this)},_destroyColumnResizing:function(){var e=this;e.columnResizing&&(e.columnResizing.destroy(),e.columnResizing=null)},_initializeRowResizing:function(){s.ui.editor.RowResizing.create(this)},_destroyRowResizing:function(){var e=this;e.rowResizing&&(e.rowResizing.destroy(),e.rowResizing=null)},_wrapTextarea:function(){var t=this,n=t.element,i=n[0].style.width,o=n[0].style.height,r=_.editorWrapperTemplate,s=e(r).insertBefore(n).width(i).height(o),a=s.find(".k-editable-area");n.attr("autocomplete","off").appendTo(a).addClass("k-content k-raw-content").css("display","none"),
t.textarea=n,t.wrapper=s},_createContentElement:function(t){var n,i,o,r=this,a=r.textarea,l=r.options.domain,u=l||document.domain,h="",f='javascript:""';return(l||u!=location.hostname)&&(h='<script>document.domain="'+u+'"</script>',f="javascript:document.write('"+h+"')"),a.hide(),n=e("<iframe />",{title:r.options.messages.editAreaTitle,frameBorder:"0"})[0],e(n).css("display","").addClass("k-content").attr("tabindex",a[0].tabIndex).insertBefore(a),n.src=f,i=n.contentWindow||n,o=i.document||n.contentDocument,e(n).one("load",function(){r.toolbar.decorateFrom(o.body)}),o.open(),o.write("<!DOCTYPE html><html><head><meta charset='utf-8' /><style>html,body{padding:0;margin:0;height:100%;min-height:100%;}body{box-sizing:border-box;font-size:12px;font-family:Verdana,Geneva,sans-serif;margin-top:-1px;padding:5px .4em 0;word-wrap: break-word;-webkit-nbsp-mode: space;-webkit-line-break: after-white-space;"+(s.support.isRtl(a)?"direction:rtl;":"")+(d.msie||d.edge?"height:auto;":"")+(c.ios?"word-break:break-all;":"")+"}h1{font-size:2em;margin:.67em 0}h2{font-size:1.5em}h3{font-size:1.16em}h4{font-size:1em}h5{font-size:.83em}h6{font-size:.7em}p{margin:0 0 1em;}.k-marker{display:none;}.k-paste-container,.Apple-style-span{position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden}ul,ol{padding-left:2.5em}span{-ms-high-contrast-adjust:none;}a{color:#00a}code{font-size:1.23em}telerik\\3Ascript{display: none;}.k-table{width:100%;border-spacing:0;margin: 0 0 1em;}.k-table td{min-width:1px;padding:.2em .3em;}.k-table,.k-table td{outline:0;border: 1px dotted #ccc;}.k-table p{margin:0;padding:0;}.k-column-resize-handle-wrapper {position: absolute; height: 10px; width:10px; cursor: col-resize; z-index: 2;}.k-column-resize-handle {width: 100%; height: 100%;}.k-column-resize-handle > .k-column-resize-marker {width:2px; height:100%; margin:0 auto; background-color:#00b0ff; display:none; opacity:0.8;}.k-row-resize-handle-wrapper {position: absolute; cursor: row-resize; z-index:2; width: 10px; height: 10px;}.k-row-resize-handle {display: table; width: 100%; height: 100%;}.k-row-resize-marker-wrapper{display: table-cell; height:100%; width:100%; margin:0; padding:0; vertical-align: middle;}.k-row-resize-marker{margin: 0; padding:0; width:100%; height:2px; background-color: #00b0ff; opacity:0.8; display:none;}.k-table-resize-handle-wrapper {position: absolute; background-color: #fff; border: 1px solid #000; z-index: 100; width: 5px; height: 5px;}.k-table-resize-handle {width: 100%; height: 100%;}.k-table-resize-handle.k-resize-east{cursor:e-resize;}.k-table-resize-handle.k-resize-north{cursor:n-resize;}.k-table-resize-handle.k-resize-northeast{cursor:ne-resize;}.k-table-resize-handle.k-resize-northwest{cursor:nw-resize;}.k-table-resize-handle.k-resize-south{cursor:s-resize;}.k-table-resize-handle.k-resize-southeast{cursor:se-resize;}.k-table-resize-handle.k-resize-southwest{cursor:sw-resize;}.k-table-resize-handle.k-resize-west{cursor:w-resize;}.k-table.k-table-resizing{opacity:0.6;}k\\:script{display:none;}</style>"+h+"<script>(function(d,c){d[c]('header'),d[c]('article'),d[c]('nav'),d[c]('section'),d[c]('footer');})(document, 'createElement');</script>"+e.map(t,function(e){return"<link rel='stylesheet' href='"+e+"'>"}).join("")+"</head><body autocorrect='off' contenteditable='true'></body></html>"),o.close(),i},_blur:function(){var e=this.textarea,t=e?e.val():this._oldValue,n=this.options.encoded?this.encodedValue():this.value();this.update(),e&&e.trigger("blur"),n!=t&&(this.trigger("change"),e&&e.trigger("change"))},_spellCorrect:function(e){var n,i=!1;this._registerHandler(e.body,{contextmenu:function(){e.one("select",function(){n=null}),e._spellCorrectTimeout=setTimeout(function(){n=new s.ui.editor.RestorePoint(e.getRange(),e.body),i=!1},10)},input:function(){if(n)return s.support.browser.mozilla&&!i?(i=!0,t):(s.ui.editor._finishUpdate(e,n),t)}})},_registerHandler:function(t,n,i){var o,r,a,l=this,c=".kendoEditor";if(t=e(t),this._handlers||(this._handlers=[]),t.length)if(e.isPlainObject(n))for(a in n)n.hasOwnProperty(a)&&this._registerHandler(t,a,n[a]);else for(o=s.applyEventMap(n).split(" "),r=0;r<o.length;r++)l._handlers.push({element:t,type:o[r]+c,handler:i}),t.on(o[r]+c,i)},_deregisterHandlers:function(){var e,t,n=this._handlers;for(e=0;e<n.length;e++)t=n[e],t.element.off(t.type,t.handler);this._handlers=[]},_initializeContentElement:function(){var n,i,o,r,a,l=this;l.textarea?(l.window=l._createContentElement(l.options.stylesheets),n=l.document=l.window.contentDocument||l.window.document,n.body||(r=n.createElement("body"),r.setAttribute("contenteditable","true"),r.setAttribute("autocorrect","off"),n.getElementsByTagName("html")[0].appendChild(r),a=setInterval(function(){e(l.document).find("body").length>1&&(e(l.document).find("body:last").remove(),window.clearInterval(a))},10)),l.body=n.body,i=l.window,o=n,this._registerHandler(n,"mouseup",h(this._mouseup,this))):(l.window=window,n=l.document=document,l.body=l.element[0],i=l.body,o=l.body,l.toolbar.decorateFrom(l.body)),this._registerHandler(i,"blur",h(this._blur,this)),l._registerHandler(o,"down",h(l._mousedown,l));try{n.execCommand("enableInlineTableEditing",null,!1)}catch(c){}s.support.touch&&this._registerHandler(n,{keydown:function(){s._activeElement()!=n.body&&l.window.focus()}}),this._spellCorrect(l),this._registerHandler(l.body,{keydown:function(e){var n,i,o,r,s,a,c,d,u,f;return(e.keyCode!==p.BACKSPACE&&e.keyCode!==p.DELETE||"true"===l.body.getAttribute("contenteditable"))&&(e.keyCode===p.F10?(setTimeout(h(l.toolbar.focus,l.toolbar),100),e.preventDefault(),t):(e.keyCode!=p.LEFT&&e.keyCode!=p.RIGHT||(n=l.getRange(),i=e.keyCode==p.LEFT,o=n[i?"startContainer":"endContainer"],r=n[i?"startOffset":"endOffset"],s=i?-1:1,a=r+s,c=i?a:r,3==o.nodeType&&"\ufeff"==o.nodeValue[c]&&(n.setStart(o,a),n.collapse(!0),l.selectRange(n))),d=l.toolbar.tools,u=l.keyboard.toolFromShortcut(d,e),f=u?d[u].options:{},u&&!f.keyPressCommand?(e.preventDefault(),/^(undo|redo)$/.test(u)||l.keyboard.endTyping(!0),l.trigger("keydown",e),l.exec(u),l._runPostContentKeyCommands(e),!1):(l.keyboard.clearTimeout(),l.keyboard.keydown(e),t)))},keypress:function(e){setTimeout(function(){l._runPostContentKeyCommands(e),l._showTableResizeHandles()},0)},keyup:function(t){var n=[p.BACKSPACE,p.TAB,p.PAGEUP,p.PAGEDOWN,p.END,p.HOME,p.LEFT,p.UP,p.RIGHT,p.DOWN,p.INSERT,p.DELETE];(e.inArray(t.keyCode,n)>-1||65==t.keyCode&&t.ctrlKey&&!t.altKey&&!t.shiftKey)&&l._selectionChange(),l.keyboard.keyup(t)},click:function(e){var t,n=s.ui.editor.Dom;"img"===n.name(e.target)&&(t=l.createRange(),t.selectNode(e.target),l.selectRange(t))},"cut copy paste drop dragover":function(e){l.clipboard["on"+e.type](e)},focusin:function(){l.body.hasAttribute("contenteditable")&&(e(this).addClass("k-state-active"),l.toolbar.show())},focusout:function(){setTimeout(function(){var t,n=s._activeElement(),i=l.body,o=l.toolbar;o.options.popup&&(t=o.window.element.get(0),t&&!e.contains(t,n)&&t!=n&&(o.preventPopupHide=!1)),n==i||e.contains(i,n)||e(n).is(".k-editortoolbar-dragHandle")||o.focused()||(e(i).removeClass("k-state-active"),o.hide())},10)}}),l._initializeColumnResizing(),l._initializeRowResizing(),l._initializeTableResizing()},_initializeImmutables:function(){var e=this,t=s.ui.editor;e.options.immutables&&(e.immutables=new t.Immutables(e))},_mousedown:function(t){var n,i=this;i._selectionStarted=!0,e(i.body).parents(".k-window").length&&t.stopPropagation(),d.gecko||(n=e(t.target),(2==t.which||1==t.which&&t.ctrlKey)&&n.is("a[href]")&&window.open(n.attr("href"),"_new"))},_mouseup:function(t){var n=this;s.support.mobileOS.ios&&t&&e(t.target).is(g)||n._selectionStarted&&setTimeout(function(){n._selectionChange()},1)},_runPostContentKeyCommands:function(e){var t,n,i,o,r=this.getRange(),s=this.keyboard.toolsFromShortcut(this.toolbar.tools,e);for(t=0;t<s.length;t++)n=s[t],i=n.options,i.keyPressCommand&&(o=new i.command({range:r}),o.changesContent()&&(this.keyboard.endTyping(!0),this.exec(n.name)))},refresh:function(){var e,t=this;t.textarea&&(t._destroyResizings(),e=t.value(),t.textarea.val(e),t.wrapper.find("iframe").remove(),t._initializeContentElement(t),t.value(e))},events:["select","change","execute","error","paste","keydown","keyup"],options:{name:"Editor",messages:b,formats:{},encoded:!0,domain:null,resizable:!1,deserialization:{custom:null},serialization:{entities:!0,semantic:!0,scripts:!1},pasteCleanup:{all:!1,css:!1,custom:null,keepNewLines:!1,msAllFormatting:!1,msConvertLists:!0,msTags:!0,none:!1,span:!1},stylesheets:[],dialogOptions:{modal:!0,resizable:!1,draggable:!0,animation:!1},imageBrowser:null,fileBrowser:null,fontName:[{text:"Arial",value:"Arial,Helvetica,sans-serif"},{text:"Courier New",value:"'Courier New',Courier,monospace"},{text:"Georgia",value:"Georgia,serif"},{text:"Impact",value:"Impact,Charcoal,sans-serif"},{text:"Lucida Console",value:"'Lucida Console',Monaco,monospace"},{text:"Tahoma",value:"Tahoma,Geneva,sans-serif"},{text:"Times New Roman",value:"'Times New Roman',Times,serif"},{text:"Trebuchet MS",value:"'Trebuchet MS',Helvetica,sans-serif"},{text:"Verdana",value:"Verdana,Geneva,sans-serif"}],fontSize:[{text:"1 (8pt)",value:"xx-small"},{text:"2 (10pt)",value:"x-small"},{text:"3 (12pt)",value:"small"},{text:"4 (14pt)",value:"medium"},{text:"5 (18pt)",value:"large"},{text:"6 (24pt)",value:"x-large"},{text:"7 (36pt)",value:"xx-large"}],formatBlock:[{text:"Paragraph",value:"p"},{text:"Quotation",value:"blockquote"},{text:"Heading 1",value:"h1"},{text:"Heading 2",value:"h2"},{text:"Heading 3",value:"h3"},{text:"Heading 4",value:"h4"},{text:"Heading 5",value:"h5"},{text:"Heading 6",value:"h6"}],tools:[].concat.call(["formatting"],y.basic,y.alignment,y.lists,y.indenting,y.links,["insertImage"],y.tables)},destroy:function(){var e=this;l.fn.destroy.call(this),this._endTyping(!0),this._deregisterHandlers(),clearTimeout(this._spellCorrectTimeout),this._focusOutside(),this.toolbar.destroy(),e._destroyUploadWidget(),e._destroyResizings(),s.destroy(this.wrapper)},_destroyResizings:function(){var e=this;e._destroyTableResizing(),s.ui.editor.TableResizing.dispose(e),e._destroyRowResizing(),s.ui.editor.RowResizing.dispose(e),e._destroyColumnResizing(),s.ui.editor.ColumnResizing.dispose(e)},_focusOutside:function(){if(s.support.browser.msie&&this.textarea){var t=e("<input style='position:fixed;left:1px;top:1px;width:1px;height:1px;font-size:0;border:0;opacity:0' />").appendTo(document.body).focus();t.blur().remove()}},_destroyUploadWidget:function(){var e=this;e._uploadWidget&&(e._uploadWidget.destroy(),e._uploadWidget=null)},state:function(e){var t,n,i=k.defaultTools[e],o=i&&(i.options.finder||i.finder),r=s.ui.editor.RangeUtils;return!!o&&(t=this.getRange(),n=r.textNodes(t),!n.length&&t.collapsed&&(n=[t.startContainer]),o.getFormat?o.getFormat(n):o.isFormatted(n))},value:function(e){var n=this.body,i=s.ui.editor,o=this.options,r=i.Serializer.domToXhtml(n,o.serialization);return e===t?r:(e!=r&&(i.Serializer.htmlToDom(e,n,o.deserialization),this.selectionRestorePoint=null,this.update(),this.toolbar.refreshTools()),t)},saveSelection:function(t){t=t||this.getRange();var n=t.commonAncestorContainer,i=this.body;(n==i||e.contains(i,n))&&(this.selectionRestorePoint=new s.ui.editor.RestorePoint(t,i))},_focusBody:function(){var e,t=this.body,n=this.wrapper&&this.wrapper.find("iframe")[0],i=this.document.documentElement,o=s._activeElement();n?o!=t&&o!=n&&(e=i.scrollTop,t.focus(),i.scrollTop=e):(e=t.scrollTop,t.focus(),t.scrollTop=e)},restoreSelection:function(){this._focusBody(),this.selectionRestorePoint&&this.selectRange(this.selectionRestorePoint.toRange())},focus:function(){this.restoreSelection()},update:function(e){e=e||this.options.encoded?this.encodedValue():this.value(),this.textarea?this.textarea.val(e):this._oldValue=e},encodedValue:function(){return s.ui.editor.Dom.encode(this.value())},createRange:function(e){return s.ui.editor.RangeUtils.createRange(e||this.document)},getSelection:function(){return s.ui.editor.SelectionUtils.selectionFromDocument(this.document)},selectRange:function(e){this._focusBody();var t=this.getSelection();t.removeAllRanges(),t.addRange(e),this.saveSelection(e)},getRange:function(){var e=this.getSelection(),t=e&&e.rangeCount>0?e.getRangeAt(0):this.createRange(),n=this.document;return t.startContainer!=n||t.endContainer!=n||t.startOffset||t.endOffset||(t.setStart(this.body,0),t.collapse(!0)),t},_containsRange:function(e){var t=s.ui.editor.Dom,n=this.body;return e&&t.isAncestorOrSelf(n,e.startContainer)&&t.isAncestorOrSelf(n,e.endContainer)},_deleteSavedRange:function(){"_range"in this&&delete this._range},selectedHtml:function(){return s.ui.editor.Serializer.domToXhtml(this.getRange().cloneContents())},paste:function(t,n){this.focus();var i=new s.ui.editor.InsertHtmlCommand(e.extend({range:this.getRange(),html:t},n));i.editor=this,i.exec()},exec:function(e,n){var i,o,r,s,a=this,l=null;if(!e)throw Error("kendoEditor.exec(): `name` parameter cannot be empty");if("true"!==a.body.getAttribute("contenteditable")&&"print"!==e&&"pdf"!==e)return!1;if(e=e.toLowerCase(),a.keyboard.isTypingInProgress()||(a._focusBody(),a.selectRange(a._range||a.getRange())),o=a.toolbar.toolById(e),!o)for(s in k.defaultTools)if(s.toLowerCase()==e){o=k.defaultTools[s];break}if(o){if(i=a.getRange(),o.command&&(l=o.command(u({range:i,body:a.body,immutables:!!a.immutables},n))),r=a.trigger("execute",{name:e,command:l}))return;if(/^(undo|redo)$/i.test(e))a.undoRedoStack[e]();else if(l&&(a.execCommand(l),l.async))return l.change=h(a._selectionChange,a),t;a._selectionChange()}},execCommand:function(e){e.managesUndoRedo||this.undoRedoStack.push(e),e.editor=this,e.exec()}});k.defaultTools={undo:{options:{key:"Z",ctrl:!0}},redo:{options:{key:"Y",ctrl:!0}}},s.ui.plugin(k),n=a.extend({init:function(e){this.options=e},initialize:function(e,t){e.attr({unselectable:"on",title:t.title}),e.children(".k-tool-text").html(t.title)},command:function(e){return new this.options.command(e)},update:e.noop}),n.exec=function(e,t,n){e.exec(t,{value:n})},_.registerTool("separator",new n({template:new v({template:_.separatorTemplate})})),i=d.msie&&d.version<9?"\ufeff":"",o="\ufeff",r=o,(d.msie||d.edge)&&(r=o="&nbsp;"),u(s.ui,{editor:{ToolTemplate:v,EditorUtils:_,Tool:n,_bomFill:i,emptyElementContent:o,emptyTableCellContent:r}}),s.PDFMixin&&(s.PDFMixin.extend(k.prototype),k.prototype._drawPDF=function(){return s.drawing.drawDOM(this.body,this.options.pdf)},k.prototype.saveAsPDF=function(){var t,n=new e.Deferred,i=n.promise(),o={promise:i};if(!this.trigger("pdfExport",o))return t=this.options.pdf,this._drawPDF(n).then(function(e){return s.drawing.exportPDF(e,t)}).done(function(e){s.saveAs({dataURI:e,fileName:t.fileName,proxyURL:t.proxyURL,proxyTarget:t.proxyTarget,forceProxy:t.forceProxy}),n.resolve()}).fail(function(e){n.reject(e)}),i})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/dom.min",["editor/main.min"],e)}(function(){!function(e){function t(e){var t,n,i={};for(t=0,n=e.length;t<n;t++)i[e[t]]=!0;return i}var n,i,o,r,s,a,l,c,d,u,h,f=window.kendo,p=e.map,m=e.extend,g=f.support.browser,v="style",_="float",b="cssFloat",w="styleFloat",y="class",k="k-marker",x=t("area,base,basefont,br,col,frame,hr,img,input,isindex,link,meta,param,embed".split(",")),C="div,p,h1,h2,h3,h4,h5,h6,address,applet,blockquote,button,center,dd,dir,dl,dt,fieldset,form,frameset,hr,iframe,isindex,map,menu,noframes,noscript,object,pre,script,table,tbody,td,tfoot,th,thead,tr,header,article,nav,footer,section,aside,main,figure,figcaption".split(","),S=C.concat(["ul","ol","li"]),T=t(S),D="span,em,a,abbr,acronym,applet,b,basefont,bdo,big,br,button,cite,code,del,dfn,font,i,iframe,img,input,ins,kbd,label,map,object,q,s,samp,script,select,small,strike,strong,sub,sup,textarea,tt,u,var,data,time,mark,ruby".split(","),A=t(D),E=t("checked,compact,declare,defer,disabled,ismap,multiple,nohref,noresize,noshade,nowrap,readonly,selected".split(",")),I=function(e){1==e.nodeType&&e.normalize()};g.msie&&g.version>=8&&(I=function(e){if(1==e.nodeType&&e.firstChild)for(var t=e.firstChild,n=t;;){if(n=n.nextSibling,!n)break;3==n.nodeType&&3==t.nodeType&&(n.nodeValue=t.nodeValue+n.nodeValue,h.remove(t)),t=n}}),n=/^\s+$/,i=/^[\n\r\t]+$/,o=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i,r=/\ufeff/g,s=/^(\s+|\ufeff)$/,l="color,padding-left,padding-right,padding-top,padding-bottom,background-color,background-attachment,background-image,background-position,background-repeat,border-top-style,border-top-width,border-top-color,border-bottom-style,border-bottom-width,border-bottom-color,border-left-style,border-left-width,border-left-color,border-right-style,border-right-width,border-right-color,font-family,font-size,font-style,font-variant,font-weight,line-height".split(","),c=/[<>\&]/g,d=/[\u00A0-\u2666<>\&]/g,u={34:"quot",38:"amp",39:"apos",60:"lt",62:"gt",160:"nbsp",161:"iexcl",162:"cent",163:"pound",164:"curren",165:"yen",166:"brvbar",167:"sect",168:"uml",169:"copy",170:"ordf",171:"laquo",172:"not",173:"shy",174:"reg",175:"macr",176:"deg",177:"plusmn",178:"sup2",179:"sup3",180:"acute",181:"micro",182:"para",183:"middot",184:"cedil",185:"sup1",186:"ordm",187:"raquo",188:"frac14",189:"frac12",190:"frac34",191:"iquest",192:"Agrave",193:"Aacute",194:"Acirc",195:"Atilde",196:"Auml",197:"Aring",198:"AElig",199:"Ccedil",200:"Egrave",201:"Eacute",202:"Ecirc",203:"Euml",204:"Igrave",205:"Iacute",206:"Icirc",207:"Iuml",208:"ETH",209:"Ntilde",210:"Ograve",211:"Oacute",212:"Ocirc",213:"Otilde",214:"Ouml",215:"times",216:"Oslash",217:"Ugrave",218:"Uacute",219:"Ucirc",220:"Uuml",221:"Yacute",222:"THORN",223:"szlig",224:"agrave",225:"aacute",226:"acirc",227:"atilde",228:"auml",229:"aring",230:"aelig",231:"ccedil",232:"egrave",233:"eacute",234:"ecirc",235:"euml",236:"igrave",237:"iacute",238:"icirc",239:"iuml",240:"eth",241:"ntilde",242:"ograve",243:"oacute",244:"ocirc",245:"otilde",246:"ouml",247:"divide",248:"oslash",249:"ugrave",250:"uacute",251:"ucirc",252:"uuml",253:"yacute",254:"thorn",255:"yuml",402:"fnof",913:"Alpha",914:"Beta",915:"Gamma",916:"Delta",917:"Epsilon",918:"Zeta",919:"Eta",920:"Theta",921:"Iota",922:"Kappa",923:"Lambda",924:"Mu",925:"Nu",926:"Xi",927:"Omicron",928:"Pi",929:"Rho",931:"Sigma",932:"Tau",933:"Upsilon",934:"Phi",935:"Chi",936:"Psi",937:"Omega",945:"alpha",946:"beta",947:"gamma",948:"delta",949:"epsilon",950:"zeta",951:"eta",952:"theta",953:"iota",954:"kappa",955:"lambda",956:"mu",957:"nu",958:"xi",959:"omicron",960:"pi",961:"rho",962:"sigmaf",963:"sigma",964:"tau",965:"upsilon",966:"phi",967:"chi",968:"psi",969:"omega",977:"thetasym",978:"upsih",982:"piv",8226:"bull",8230:"hellip",8242:"prime",8243:"Prime",8254:"oline",8260:"frasl",8472:"weierp",8465:"image",8476:"real",8482:"trade",8501:"alefsym",8592:"larr",8593:"uarr",8594:"rarr",8595:"darr",8596:"harr",8629:"crarr",8656:"lArr",8657:"uArr",8658:"rArr",8659:"dArr",8660:"hArr",8704:"forall",8706:"part",8707:"exist",8709:"empty",8711:"nabla",8712:"isin",8713:"notin",8715:"ni",8719:"prod",8721:"sum",8722:"minus",8727:"lowast",8730:"radic",8733:"prop",8734:"infin",8736:"ang",8743:"and",8744:"or",8745:"cap",8746:"cup",8747:"int",8756:"there4",8764:"sim",8773:"cong",8776:"asymp",8800:"ne",8801:"equiv",8804:"le",8805:"ge",8834:"sub",8835:"sup",8836:"nsub",8838:"sube",8839:"supe",8853:"oplus",8855:"otimes",8869:"perp",8901:"sdot",8968:"lceil",8969:"rceil",8970:"lfloor",8971:"rfloor",9001:"lang",9002:"rang",9674:"loz",9824:"spades",9827:"clubs",9829:"hearts",9830:"diams",338:"OElig",339:"oelig",352:"Scaron",353:"scaron",376:"Yuml",710:"circ",732:"tilde",8194:"ensp",8195:"emsp",8201:"thinsp",8204:"zwnj",8205:"zwj",8206:"lrm",8207:"rlm",8211:"ndash",8212:"mdash",8216:"lsquo",8217:"rsquo",8218:"sbquo",8220:"ldquo",8221:"rdquo",8222:"bdquo",8224:"dagger",8225:"Dagger",8240:"permil",8249:"lsaquo",8250:"rsaquo",8364:"euro"},h={block:T,inline:A,findNodeIndex:function(e,t){var n=0;if(!e)return-1;for(;;){if(e=e.previousSibling,!e)break;t&&3==e.nodeType||n++}return n},isDataNode:function(e){return e&&null!==e.nodeValue&&null!==e.data},isAncestorOf:function(t,n){try{return!h.isDataNode(t)&&(e.contains(t,h.isDataNode(n)?n.parentNode:n)||n.parentNode==t)}catch(i){return!1}},isAncestorOrSelf:function(e,t){return h.isAncestorOf(e,t)||e==t},findClosestAncestor:function(e,t){if(h.isAncestorOf(e,t))for(;t&&t.parentNode!=e;)t=t.parentNode;return t},getAllComments:function(e){for(var t=[],n=document.createNodeIterator(e,NodeFilter.SHOW_COMMENT,function(){return NodeFilter.FILTER_ACCEPT},!1),i=n.nextNode();i;)t.push(i.nodeValue),i=n.nextNode();return t},getNodeLength:function(e){return h.isDataNode(e)?e.length:e.childNodes.length},splitDataNode:function(e,t){for(var n,i=e.cloneNode(!1),o="",r=e.nextSibling;r&&3==r.nodeType&&r.nodeValue;)o+=r.nodeValue,n=r,r=r.nextSibling,h.remove(n);e.deleteData(t,e.length),i.deleteData(0,t),i.nodeValue+=o,h.insertAfter(i,e)},attrEquals:function(e,t){var n,i;for(n in t)if(i=e[n],n==_&&(i=e[f.support.cssFloat?b:w]),"object"==typeof i){if(!h.attrEquals(i,t[n]))return!1}else if(i!=t[n])return!1;return!0},blockParentOrBody:function(e){return h.parentOfType(e,S)||e.ownerDocument.body},blockParents:function(t){var n,i,o,r=[];for(n=0,i=t.length;n<i;n++)o=h.parentOfType(t[n],h.blockElements),o&&e.inArray(o,r)<0&&r.push(o);return r},windowFromDocument:function(e){return e.defaultView||e.parentWindow},normalize:I,blockElements:S,nonListBlockElements:C,inlineElements:D,empty:x,fillAttrs:E,nodeTypes:{ELEMENT_NODE:1,ATTRIBUTE_NODE:2,TEXT_NODE:3,CDATA_SECTION_NODE:4,ENTITY_REFERENCE_NODE:5,ENTITY_NODE:6,PROCESSING_INSTRUCTION_NODE:7,COMMENT_NODE:8,DOCUMENT_NODE:9,DOCUMENT_TYPE_NODE:10,DOCUMENT_FRAGMENT_NODE:11,NOTATION_NODE:12},toHex:function(e){var t=o.exec(e);return t?"#"+p(t.slice(1),function(e){return e=parseInt(e,10).toString(16),e.length>1?e:"0"+e}).join(""):e},encode:function(e,t){var n=!t||t.entities?d:c;return e.replace(n,function(e){var t=e.charCodeAt(0),n=u[t];return n?"&"+n+";":e})},isBom:function(e){return e&&3===e.nodeType&&/^[\ufeff]+$/.test(e.nodeValue)},stripBom:function(e){return(e||"").replace(r,"")},stripBomNode:function(e){h.isBom(e)&&e.parentNode.removeChild(e)},insignificant:function(e){var t=e.attributes;return"k-marker"==e.className||h.is(e,"br")&&("k-br"==e.className||t._moz_dirty||t._moz_editor_bogus_node)},tableCell:function(e){return h.is(e,"td")||h.is(e,"th")},significantNodes:function(t){return e.grep(t,function(e){var t=h.name(e);return"br"!=t&&(!h.insignificant(e)&&(!h.emptyTextNode(e)&&!(1==e.nodeType&&!x[t]&&h.emptyNode(e))))})},emptyTextNode:function(e){return e&&3==e.nodeType&&s.test(e.nodeValue)},emptyNode:function(e){return 1==e.nodeType&&!h.significantNodes(e.childNodes).length},name:function(e){return e.nodeName.toLowerCase()},significantChildNodes:function(t){return e.grep(t.childNodes,function(e){return 3!=e.nodeType||!h.isWhitespace(e)})},lastTextNode:function(e){var t,n=null;if(3==e.nodeType)return e;for(t=e.lastChild;t;t=t.previousSibling)if(n=h.lastTextNode(t))return n;return n},is:function(e,t){return e&&h.name(e)==t},isMarker:function(e){return e.className==k},isWhitespace:function(e){return n.test(e.nodeValue)},allWhitespaceContent:function(e){for(var t=e.firstChild;t&&h.isWhitespace(t);)t=t.nextSibling;return!t},isEmptyspace:function(e){return i.test(e.nodeValue)},htmlIndentSpace:function(t){var n,o,s,a,l,c;return!(!h.isDataNode(t)||!h.isWhitespace(t))&&(!!i.test(t.nodeValue)||(n=function(e,t){for(;e[t];)if(e=e[t],h.significantNodes([e]).length>0)return e},o=t.parentNode,s=n(t,"previousSibling"),a=n(t,"nextSibling"),r.test(t.nodeValue)?!(!s&&!a):!!e(o).is("tr,tbody,thead,tfoot,table,ol,ul")||!!((h.isBlock(o)||h.is(o,"body"))&&(l=s&&h.isBlock(s),c=a&&h.isBlock(a),!a&&l||!s&&c||l&&c))))},isBlock:function(e){return T[h.name(e)]},isEmpty:function(e){return x[h.name(e)]},isInline:function(e){return A[h.name(e)]},isBr:function(e){return"br"==h.name(e)},list:function(e){var t=e?h.name(e):"";return"ul"==t||"ol"==t||"dl"==t},scrollContainer:function(e){var t=h.windowFromDocument(e),n=(t.contentWindow||t).document||t.ownerDocument||t;return n="BackCompat"==n.compatMode?n.body:n.scrollingElement||n.documentElement},scrollTo:function(t,n){var i,o,r,s,a=t.ownerDocument,l=h.windowFromDocument(a),c=l.innerHeight,d=h.scrollContainer(a);h.isDataNode(t)?n?(s=h.create(a,"span",{innerHTML:"&#xfeff;"}),h.insertBefore(s,t),i=e(s)):i=e(t.parentNode):i=e(t),o=i.offset().top,r=i[0].offsetHeight,!n&&r||(r=parseInt(i.css("line-height"),10)||Math.ceil(1.2*parseInt(i.css("font-size"),10))||15),s&&h.remove(s),r+o>d.scrollTop+c&&(d.scrollTop=r+o-c)},persistScrollTop:function(e){a=h.scrollContainer(e).scrollTop},offset:function(e,t){for(var n={top:e.offsetTop,left:e.offsetLeft},i=e.offsetParent;i&&(!t||h.isAncestorOf(t,i));)n.top+=i.offsetTop,n.left+=i.offsetLeft,i=i.offsetParent;return n},restoreScrollTop:function(e){"number"==typeof a&&(h.scrollContainer(e).scrollTop=a)},insertAt:function(e,t,n){e.insertBefore(t,e.childNodes[n]||null)},insertBefore:function(e,t){return t.parentNode?t.parentNode.insertBefore(e,t):t},insertAfter:function(e,t){return t.parentNode.insertBefore(e,t.nextSibling)},remove:function(e){e.parentNode&&e.parentNode.removeChild(e)},removeChildren:function(e){for(;e.firstChild;)e.removeChild(e.firstChild)},removeTextSiblings:function(e){for(var t=e.parentNode;e.nextSibling&&3==e.nextSibling.nodeType;)t.removeChild(e.nextSibling);for(;e.previousSibling&&3==e.previousSibling.nodeType;)t.removeChild(e.previousSibling)},trim:function(e){var t,n;for(t=e.childNodes.length-1;t>=0;t--)n=e.childNodes[t],h.isDataNode(n)?h.stripBom(n.nodeValue).length||h.remove(n):n.className!=k&&(h.trim(n),(0===n.childNodes.length||h.allWhitespaceContent(n)&&h.isBlock(n)&&!h.isEmpty(n))&&h.remove(n));return e},closest:function(e,t){for(;e&&h.name(e)!=t;)e=e.parentNode;return e},closestBy:function(e,t,n){for(;e&&!t(e);){if(n&&n(e))return null;e=e.parentNode}return e},sibling:function(e,t){do e=e[t];while(e&&1!=e.nodeType);return e},next:function(e){return h.sibling(e,"nextSibling")},prev:function(e){return h.sibling(e,"previousSibling")},parentOfType:function(e,t){do e=e.parentNode;while(e&&!h.ofType(e,t));return e},ofType:function(t,n){return e.inArray(h.name(t),n)>=0},changeTag:function(e,t,n){var i,o,r,s,a,l=h.create(e.ownerDocument,t),c=e.attributes;if(!n)for(i=0,o=c.length;i<o;i++)a=c[i],a.specified&&(r=a.nodeName,s=a.nodeValue,r==y?l.className=s:r==v?l.style.cssText=e.style.cssText:l.setAttribute(r,s));for(;e.firstChild;)l.appendChild(e.firstChild);return h.insertBefore(l,e),h.remove(e),l},editableParent:function(e){for(;e&&(3==e.nodeType||"true"!==e.contentEditable);)e=e.parentNode;return e},wrap:function(e,t){return h.insertBefore(t,e),t.appendChild(e),t},unwrap:function(e){for(var t=e.parentNode;e.firstChild;)t.insertBefore(e.firstChild,e);t.removeChild(e)},wrapper:function(t){var n=h.closestBy(t,function(e){return e.parentNode&&h.significantNodes(e.parentNode.childNodes).length>1});return e(n).is("body,.k-editor")?void 0:n},create:function(e,t,n){return h.attr(e.createElement(t),n)},createEmptyNode:function(e,t,n){var i=h.attr(e.createElement(t),n);return i.innerHTML="\ufeff",i},attr:function(e,t){t=m({},t),t&&v in t&&(h.style(e,t.style),delete t.style);for(var n in t)null===t[n]?(e.removeAttribute(n),delete t[n]):"className"==n&&(e[n]=t[n]);return m(e,t)},style:function(t,n){e(t).css(n||{})},unstyle:function(e,t){for(var n in t)n==_&&(n=f.support.cssFloat?b:w),e.style[n]="";""===e.style.cssText&&e.removeAttribute(v)},inlineStyle:function(t,n,i){var o,r=e(h.create(t.ownerDocument,n,i));return t.appendChild(r[0]),o=p(l,function(e){return g.msie&&"line-height"==e&&"1px"==r.css(e)?"line-height:1.5":e+":"+r.css(e)}).join(";"),r.remove(),o},getEffectiveBackground:function(e){var t=e.css("background-color")||"";return t.indexOf("rgba(0, 0, 0, 0")<0&&"transparent"!==t?t:"html"===e[0].tagName.toLowerCase()?"Window":h.getEffectiveBackground(e.parent())},innerText:function(e){var t=e.innerHTML;return t=t.replace(/<!--(.|\s)*?-->/gi,""),t=t.replace(/<\/?[^>]+?\/?>/gm,"")},removeClass:function(t,n){var i,o,r=" "+t.className+" ",s=n.split(" ");for(i=0,o=s.length;i<o;i++)r=r.replace(" "+s[i]+" "," ");r=e.trim(r),r.length?t.className=r:t.removeAttribute(y)},commonAncestor:function(){var e,t,n,i,o,r=arguments.length,s=[],a=1/0,l=null;if(!r)return null;if(1==r)return arguments[0];for(e=0;e<r;e++){for(t=[],n=arguments[e];n;)t.push(n),n=n.parentNode;s.push(t.reverse()),a=Math.min(a,t.length)}if(1==r)return s[0][0];for(e=0;e<a;e++){for(i=s[0][e],o=1;o<r;o++)if(i!=s[o][e])return l;l=i}return l},closestSplittableParent:function(t){var n,i,o;return n=1==t.length?h.parentOfType(t[0],["ul","ol"]):h.commonAncestor.apply(null,t),n||(n=h.parentOfType(t[0],["p","td"])||t[0].ownerDocument.body),h.isInline(n)&&(n=h.blockParentOrBody(n)),i=p(t,h.editableParent),o=h.commonAncestor(i)[0],e.contains(n,o)&&(n=o),n},closestEditable:function(t,n){var i,o=h.editableParent(t);return i=h.ofType(t,n)?t:h.parentOfType(t,n),i&&o&&e.contains(i,o)?i=o:!i&&o&&(i=o),i},closestEditableOfType:function(e,t){var n=h.closestEditable(e,t);if(n&&h.ofType(n,t))return n},filter:function(e,t,n){var i=function(t){return h.name(t)==e};return h.filterBy(t,i,n)},filterBy:function(e,t,n){for(var i,o=0,r=e.length,s=[];o<r;o++)i=t(e[o]),(i&&!n||!i&&n)&&s.push(e[o]);return s},ensureTrailingBreaks:function(t){var n=e(t).find("p,td,th"),i=n.length,o=0;if(i)for(;o<i;o++)h.ensureTrailingBreak(n[o]);else h.ensureTrailingBreak(t)},removeTrailingBreak:function(t){e(t).find("br[type=_moz],.k-br").remove()},ensureTrailingBreak:function(e){var t,n,i;h.removeTrailingBreak(e),t=e.lastChild,n=t&&h.name(t),(!n||"br"!=n&&"img"!=n||"br"==n&&"k-br"!=t.className)&&(i=e.ownerDocument.createElement("br"),i.className="k-br",e.appendChild(i))}},f.ui.editor.Dom=h}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/serializer.min",["editor/dom.min"],e)}(function(){!function(e,t){var n,i,o,r,s=window.kendo,a=s.ui.editor,l=a.Dom,c=e.extend,d="xx-small,x-small,small,medium,large,x-large,xx-large".split(","),u=/"/g,h=/<br[^>]*>/i,f=/^\d+(\.\d*)?(px)?$/i,p=/<p>(?:&nbsp;)?<\/p>/i,m=/(\*?[-#\/\*\\\w]+(?:\[[0-9a-z_-]+\])?)\s*:\s*((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/g,g=/^sizzle-\d+/i,v=/^k-script-/i,_=/\s*onerror\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/i,b='<br class="k-br">',w=document.createElement("div");w.innerHTML=" <hr>",n=3===w.firstChild.nodeType,w=null,i=e.isFunction,o="td",r={toEditableHtml:function(e){return(e||"").replace(/<!\[CDATA\[(.*)?\]\]>/g,"<!--[CDATA[$1]]-->").replace(/<(\/?)script([^>]*)>/gi,"<$1k:script$2>").replace(/<img([^>]*)>/gi,function(e){return e.replace(_,"")}).replace(/(<\/?img[^>]*>)[\r\n\v\f\t ]+/gi,"$1").replace(/^<(table|blockquote)/i,b+"<$1").replace(/^[\s]*(&nbsp;|\u00a0)/i,"$1").replace(/<\/(table|blockquote)>$/i,"</$1>"+b)},_toEditableImmutables:function(t){for(var n=a.Immutables.immutable,i=l.emptyTextNode,o=t.firstChild,r=t.lastChild;i(o);)o=o.nextSibling;for(;i(r);)r=r.previousSibling;o&&n(o)&&e(b).prependTo(t),r&&n(r)&&e(b).appendTo(t)},_fillEmptyElements:function(t){e(t).find("p,td").each(function(){var t,n=e(this);if(/^\s*$/g.test(n.text())&&!n.find("img,input").length){for(t=this;t.firstChild&&3!=t.firstChild.nodeType;)t=t.firstChild;1!=t.nodeType||l.empty[l.name(t)]||(t.innerHTML=l.is(t,"td")?s.ui.editor.emptyTableCellContent:s.ui.editor.emptyElementContent)}})},_removeSystemElements:function(t){e(".k-paste-container",t).remove()},_resetOrderedLists:function(e){var t,n,i,o=e.getElementsByTagName("ol");for(t=0;t<o.length;t++)n=o[t],i=n.getAttribute("start"),n.setAttribute("start",1),i?n.setAttribute("start",i):n.removeAttribute(i)},_preventScriptExecution:function(t){e(t).find("*").each(function(){var e,t,n,i,o=this.attributes;for(t=0,n=o.length;t<n;t++)e=o[t],i=e.nodeName,e.specified&&/^on/i.test(i)&&(this.setAttribute("k-script-"+i,e.value),
this.removeAttribute(i))})},htmlToDom:function(t,n,o){var a=s.support.browser,c=a.msie,d=c&&a.version<9,u="originalsrc",h="originalhref",f=o||{},p=f.immutables;return t=r.toEditableHtml(t),d&&(t="<br/>"+t,t=t.replace(/href\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/,h+'="$1"'),t=t.replace(/src\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/,u+'="$1"')),i(f.custom)&&(t=f.custom(t)||t),n.innerHTML=t,p&&p.deserialize(n),d?(l.remove(n.firstChild),e(n).find("k\\:script,script,link,img,a").each(function(){var e=this;e[h]&&(e.setAttribute("href",e[h]),e.removeAttribute(h)),e[u]&&(e.setAttribute("src",e[u]),e.removeAttribute(u))})):c&&(l.normalize(n),r._resetOrderedLists(n)),r._preventScriptExecution(n),r._fillEmptyElements(n),r._removeSystemElements(n),r._toEditableImmutables(n),e("table",n).addClass("k-table"),n},domToXhtml:function(i,r){function c(t){return e.grep(t,function(e){return"style"!=e.name})}function _(e,t){E.push("<"+t),k(e),E.push(">")}function b(t){var n,i,o,r=e.trim,s=r(t),a=[];for(m.lastIndex=0;;){if(n=m.exec(s),!n)break;i=r(n[1].toLowerCase()),o=r(n[2]),"font-size-adjust"!=i&&"font-stretch"!=i&&(i.indexOf("color")>=0?o=l.toHex(o):i.indexOf("font")>=0?o=o.replace(u,"'"):/\burl\(/g.test(o)&&(o=o.replace(u,"")),a.push({property:i,value:o}))}return a}function w(e){var t,n=b(e);for(t=0;t<n.length;t++)E.push(n[t].property),E.push(":"),E.push(n[t].value),E.push(";")}function y(e){var t,n,i,o,s,a,c=[],d=e.attributes;for(n=0,i=d.length;n<i;n++)t=d[n],o=t.nodeName,s=t.value,a=t.specified,"value"==o&&"value"in e&&e.value?a=!0:"type"==o&&"text"==s?a=!0:"class"!=o||s?g.test(o)?a=!1:"complete"==o?a=!1:"altHtml"==o?a=!1:"start"==o&&l.is(e,"ul")?a=!1:"start"==o&&l.is(e,"ol")&&"1"==s?a=!1:o.indexOf("_moz")>=0?a=!1:v.test(o)?a=!!r.scripts:"data-role"==o&&"resizable"==s&&(l.is(e,"tr")||l.is(e,"td"))&&(a=!1):a=!1,a&&c.push(t);return c}function k(n,i){var o,r,a,c,d,u,h,p;if(i=i||y(n),l.is(n,"img")&&(u=n.style.width,h=n.style.height,p=e(n),u&&f.test(u)&&(p.attr("width",parseInt(u,10)),l.unstyle(n,{width:t})),h&&f.test(h)&&(p.attr("height",parseInt(h,10)),l.unstyle(n,{height:t}))),i.length)for(o=0,r=i.length;o<r;o++)a=i[o],c=a.nodeName,d=a.value,"class"==c&&"k-table"==d||(c=c.replace(v,""),E.push(" "),E.push(c),E.push('="'),"style"==c?w(d||n.style.cssText):E.push("src"==c||"href"==c?s.htmlEncode(n.getAttribute(c,2)):l.fillAttrs[c]?c:d),E.push('"'))}function x(e,t,n){for(var i=e.firstChild;i;i=i.nextSibling)T(i,t,n)}function C(e){return e.nodeValue.replace(/\ufeff/g,"")}function S(e){if(l.isBom(e)){do{if(e=e.parentNode,l.is(e,o)&&1===e.childNodes.length)return!0;if(1!==e.childNodes.length)return!1}while(!l.isBlock(e));return!0}return!1}function T(i,o,s){var c,d,u,h,f,p,m=i.nodeType;if(I&&a.Immutables.immutable(i))E.push(I.serialize(i));else if(1==m){if(c=l.name(i),p=e(i),p.hasClass("k-table-resize-handle-wrapper")||p.hasClass("k-column-resize-handle-wrapper")||p.hasClass("k-row-resize-handle-wrapper"))return;if(!c||l.insignificant(i))return;if(!r.scripts&&("script"==c||"k:script"==c))return;if(d=M[c],d&&(t===d.semantic||r.semantic^d.semantic))return d.start(i),x(i,!1,d.skipEncoding),d.end(i),t;E.push("<"),E.push(c),k(i),l.empty[c]?E.push(" />"):(E.push(">"),x(i,o||l.is(i,"pre")),E.push("</"),E.push(c),E.push(">"))}else if(3==m){if(S(i))return E.push("&nbsp;"),t;h=C(i),!o&&n&&(u=i.parentNode,f=i.previousSibling,f||(f=(l.isInline(u)?u:i).previousSibling),f&&""!==f.innerHTML&&!l.isBlock(f)||(h=h.replace(/^[\r\n\v\f\t ]+/,"")),h=h.replace(/ +/," ")),E.push(s?h:l.encode(h,r))}else 4==m?(E.push("<![CDATA["),E.push(i.data),E.push("]]>")):8==m&&(i.data.indexOf("[CDATA[")<0?(E.push("<!--"),E.push(i.data),E.push("-->")):(E.push("<!"),E.push(i.data),E.push(">")))}function D(e){var t=e.childNodes.length,n=t&&3==e.firstChild.nodeType;return n&&(1==t||2==t&&l.insignificant(e.lastChild))}function A(){e.isFunction(r.custom)&&(E=r.custom(E)||E)}var E=[],I=r&&r.immutables,M={iframe:{start:function(e){_(e,"iframe")},end:function(){E.push("</iframe>")}},"k:script":{start:function(e){_(e,"script")},end:function(){E.push("</script>")},skipEncoding:!0},span:{semantic:!0,start:function(t){var n,i,o=t.style,r=y(t),s=c(r);s.length&&(E.push("<span"),k(t,s),E.push(">")),"underline"==o.textDecoration&&E.push("<u>"),n=[],o.color&&n.push('color="'+l.toHex(o.color)+'"'),o.fontFamily&&n.push('face="'+o.fontFamily+'"'),o.fontSize&&(i=e.inArray(o.fontSize,d),n.push('size="'+i+'"')),n.length&&E.push("<font "+n.join(" ")+">")},end:function(e){var t=e.style;(t.color||t.fontFamily||t.fontSize)&&E.push("</font>"),"underline"==t.textDecoration&&E.push("</u>"),c(y(e)).length&&E.push("</span>")}},strong:{semantic:!0,start:function(e){_(e,"b")},end:function(){E.push("</b>")}},em:{semantic:!0,start:function(e){_(e,"i")},end:function(){E.push("</i>")}},b:{semantic:!1,start:function(e){_(e,"strong")},end:function(){E.push("</strong>")}},i:{semantic:!1,start:function(e){_(e,"em")},end:function(){E.push("</em>")}},u:{semantic:!1,start:function(t){var n,i,o;E.push("<span"),n=y(t),i=e(n).filter(function(e,t){return"style"==t.name})[0],o={nodeName:"style",value:"text-decoration:underline;"},i&&(o.value=i.value,/text-decoration/i.test(o.value)||(o.value="text-decoration:underline;"+o.value),n.splice(e.inArray(i,n),1)),n.push(o),k(t,n),E.push(">")},end:function(){E.push("</span>")}},font:{semantic:!1,start:function(e){var t,n,i;E.push('<span style="'),t=e.getAttribute("color"),n=d[e.getAttribute("size")],i=e.getAttribute("face"),t&&(E.push("color:"),E.push(l.toHex(t)),E.push(";")),i&&(E.push("font-family:"),E.push(i),E.push(";")),n&&(E.push("font-size:"),E.push(n),E.push(";")),E.push('">')},end:function(){E.push("</span>")}}};return M.script=M["k:script"],r=r||{},t===r.semantic&&(r.semantic=!0),D(i)?(E=l.encode(C(i.firstChild).replace(/[\r\n\v\f\t ]+/," "),r),A(),E):(x(i),E=E.join(""),A(),""===E.replace(h,"").replace(p,"")?"":E)}},c(a,{Serializer:r})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/components.min",["editor/serializer.min"],e)}(function(){!function(e,t){var n=window.kendo,i=n.ui.DropDownList,o=n.ui.editor.Dom,r=i.extend({init:function(t,o){var r=this;i.fn.init.call(r,t,o),n.support.mobileOS.ios&&(this._initSelectOverlay(),this.bind("dataBound",e.proxy(this._initSelectOverlay,this))),r.text(r.options.title),r.bind("open",function(){if(r.options.autoSize){var e,t=r.list;t.css({whiteSpace:"nowrap",width:"auto"}),e=t.width(),e?e+=20:e=r._listWidth,t.css("width",e+n.support.scrollbar()),r._listWidth=e}})},options:{name:"SelectBox",index:-1},_initSelectOverlay:function(){var t,i,o,r,s=this,a=s.value(),l=this.dataSource.view(),c="",d=n.htmlEncode;for(i=0;i<l.length;i++)t=l[i],c+="<option value='"+d(t.value)+"'",t.value==a&&(c+=" selected"),c+=">"+d(t.text)+"</option>";o=e("<select class='k-select-overlay'>"+c+"</select>"),r=e(this.element).closest(".k-widget"),r.next(".k-select-overlay").remove(),o.insertAfter(r),o.on("change",function(){s.value(this.value),s.trigger("change")})},value:function(e){var n=this,o=i.fn.value.call(n,e);return e===t?o:(i.fn.value.call(n)||n.text(n.options.title),t)},decorate:function(t){var n,i,r,s,a=this,l=a.dataSource,c=l.data();for(t&&a.list.css("background-color",o.getEffectiveBackground(e(t))),n=0;n<c.length;n++)i=c[n].tag||"span",r=c[n].className,s=o.inlineStyle(t,i,{className:r}),s=s.replace(/"/g,"'"),c[n].style=s+";display:inline-block";l.trigger("change")}});n.ui.plugin(r),n.ui.editor.SelectBox=r}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/range.min",["editor/components.min"],e)}(function(){!function(e){function t(e,t,n,i){var o,r,s,a;if(e==t)return i-n;for(o=t;o&&o.parentNode!=e;)o=o.parentNode;if(o)return k(o)-n;for(o=e;o&&o.parentNode!=t;)o=o.parentNode;if(o)return i-k(o)-1;for(r=y.commonAncestor(e,t),s=e;s&&s.parentNode!=r;)s=s.parentNode;for(s||(s=r),a=t;a&&a.parentNode!=r;)a=a.parentNode;return a||(a=r),s==a?0:k(a)-k(s)}function n(e,n){function i(e){try{return t(e.startContainer,e.endContainer,e.startOffset,e.endOffset)<0}catch(n){return!0}}i(e)&&(n?(e.commonAncestorContainer=e.endContainer=e.startContainer,e.endOffset=e.startOffset):(e.commonAncestorContainer=e.startContainer=e.endContainer,e.startOffset=e.endOffset),e.collapsed=!0)}function i(e){e.collapsed=e.startContainer==e.endContainer&&e.startOffset==e.endOffset;for(var t=e.startContainer;t&&t!=e.endContainer&&!y.isAncestorOf(t,e.endContainer);)t=t.parentNode;e.commonAncestorContainer=t}function o(e){var t=e.duplicate(),n=e.duplicate();return t.collapse(!0),n.collapse(!1),y.commonAncestor(e.parentElement(),t.parentElement(),n.parentElement())}function r(e,t,n){var i,o=t[n?"startContainer":"endContainer"],r=t[n?"startOffset":"endOffset"],s=0,a=x(o),l=a?o:o.childNodes[r]||null,c=a?o.parentNode:o,d=t.ownerDocument,u=d.body.createTextRange();3!=o.nodeType&&4!=o.nodeType||(s=r),c||(c=d.body),"img"==c.nodeName.toLowerCase()?(u.moveToElementText(c),u.collapse(!1),e.setEndPoint(n?"StartToStart":"EndToStart",u)):(i=c.insertBefore(y.create(d,"a"),l),u.moveToElementText(i),y.remove(i),u[n?"moveStart":"moveEnd"]("character",s),u.collapse(!1),e.setEndPoint(n?"StartToStart":"EndToStart",u))}function s(e,t,n,i){var o,r,s,a,l,c,d,u=y.create(t.ownerDocument,"a"),h=e.duplicate(),f=i?"StartToStart":"StartToEnd",p=!1;u.innerHTML="\ufeff",h.collapse(i),r=h.parentElement(),y.isAncestorOrSelf(n,r)||(r=n);do p?r.insertBefore(u,u.previousSibling):(r.appendChild(u),p=!0),h.moveToElementText(u);while((o=h.compareEndPoints(f,e))>0&&u.previousSibling);s=u.nextSibling,o==-1&&x(s)?(h.setEndPoint(i?"EndToStart":"EndToEnd",e),y.remove(u),c=[s,h.text.length]):(a=!i&&u.previousSibling,l=i&&u.nextSibling,x(l)?c=[l,0]:x(a)?c=[a,a.length]:(d=k(u),c=r.nextSibling&&d==r.childNodes.length-1?[r.nextSibling,0]:[r,d]),y.remove(u)),t[i?"setStart":"setEnd"].apply(t,c)}var a,l,c,d,u,h,f,p,m,g=window.kendo,v=g.Class,_=e.extend,b=g.ui.editor,w=g.support.browser,y=b.Dom,k=y.findNodeIndex,x=y.isDataNode,C=y.findClosestAncestor,S=y.getNodeLength,T=y.normalize,D={selectionFromWindow:function(e){return"getSelection"in e?e.getSelection():new l(e.document)},selectionFromRange:function(e){var t=m.documentFromRange(e);return D.selectionFromDocument(t)},selectionFromDocument:function(e){return D.selectionFromWindow(y.windowFromDocument(e))}},A=v.extend({init:function(t){e.extend(this,{ownerDocument:t,startContainer:t,endContainer:t,commonAncestorContainer:t,startOffset:0,endOffset:0,collapsed:!0})},setStart:function(e,t){this.startContainer=e,this.startOffset=t,i(this),n(this,!0)},setEnd:function(e,t){this.endContainer=e,this.endOffset=t,i(this),n(this,!1)},setStartBefore:function(e){this.setStart(e.parentNode,k(e))},setStartAfter:function(e){this.setStart(e.parentNode,k(e)+1)},setEndBefore:function(e){this.setEnd(e.parentNode,k(e))},setEndAfter:function(e){this.setEnd(e.parentNode,k(e)+1)},selectNode:function(e){this.setStartBefore(e),this.setEndAfter(e)},selectNodeContents:function(e){this.setStart(e,0),this.setEnd(e,e[1===e.nodeType?"childNodes":"nodeValue"].length)},collapse:function(e){var t=this;e?t.setEnd(t.startContainer,t.startOffset):t.setStart(t.endContainer,t.endOffset)},deleteContents:function(){var e=this,t=e.cloneRange();e.startContainer!=e.commonAncestorContainer&&e.setStartAfter(C(e.commonAncestorContainer,e.startContainer)),e.collapse(!0),function n(e){for(;e.next();)e.hasPartialSubtree()?n(e.getSubtreeIterator()):e.remove()}(new a(t))},cloneContents:function(){var e=m.documentFromRange(this);return function t(n){for(var i,o=e.createDocumentFragment();i=n.next();)i=i.cloneNode(!n.hasPartialSubtree()),n.hasPartialSubtree()&&i.appendChild(t(n.getSubtreeIterator())),o.appendChild(i);return o}(new a(this))},extractContents:function(){var e,t=this,n=t.cloneRange();return t.startContainer!=t.commonAncestorContainer&&t.setStartAfter(C(t.commonAncestorContainer,t.startContainer)),t.collapse(!0),e=m.documentFromRange(t),function i(n){for(var o,r=e.createDocumentFragment();o=n.next();)n.hasPartialSubtree()?(o=o.cloneNode(!1),o.appendChild(i(n.getSubtreeIterator()))):n.remove(t.originalRange),r.appendChild(o);return r}(new a(n))},insertNode:function(e){var t=this;x(t.startContainer)?(t.startOffset!=t.startContainer.nodeValue.length&&y.splitDataNode(t.startContainer,t.startOffset),y.insertAfter(e,t.startContainer)):y.insertAt(t.startContainer,e,t.startOffset),t.setStart(t.startContainer,t.startOffset)},cloneRange:function(){return e.extend(new A(this.ownerDocument),{startContainer:this.startContainer,endContainer:this.endContainer,commonAncestorContainer:this.commonAncestorContainer,startOffset:this.startOffset,endOffset:this.endOffset,collapsed:this.collapsed,originalRange:this})},toString:function(){var e=this.startContainer.nodeName,t=this.endContainer.nodeName;return("#text"==e?this.startContainer.nodeValue:e)+"("+this.startOffset+") : "+("#text"==t?this.endContainer.nodeValue:t)+"("+this.endOffset+")"}});A.fromNode=function(e){return new A(e.ownerDocument)},a=v.extend({init:function(t){if(e.extend(this,{range:t,_current:null,_next:null,_end:null}),!t.collapsed){var n=t.commonAncestorContainer;this._next=t.startContainer!=n||x(t.startContainer)?C(n,t.startContainer):t.startContainer.childNodes[t.startOffset],this._end=t.endContainer!=n||x(t.endContainer)?C(n,t.endContainer).nextSibling:t.endContainer.childNodes[t.endOffset]}},hasNext:function(){return!!this._next},next:function(){var e=this,t=e._current=e._next;return e._next=e._current&&e._current.nextSibling!=e._end?e._current.nextSibling:null,x(e._current)&&(e.range.endContainer==e._current&&(t=t.cloneNode(!0),t.deleteData(e.range.endOffset,t.length-e.range.endOffset)),e.range.startContainer==e._current&&(t=t.cloneNode(!0),t.deleteData(0,e.range.startOffset))),t},traverse:function(e){function t(){return i._current=i._next,i._next=i._current&&i._current.nextSibling!=i._end?i._current.nextSibling:null,i._current}for(var n,i=this;n=t();)i.hasPartialSubtree()?i.getSubtreeIterator().traverse(e):e(n);return n},remove:function(e){var t,n,i,o,r,s=this,a=s.range.startContainer==s._current,l=s.range.endContainer==s._current;x(s._current)&&(a||l)?(t=a?s.range.startOffset:0,n=l?s.range.endOffset:s._current.length,i=n-t,e&&(a||l)&&(s._current==e.startContainer&&t<=e.startOffset&&(e.startOffset-=i),s._current==e.endContainer&&n<=e.endOffset&&(e.endOffset-=i)),s._current.deleteData(t,i)):(o=s._current.parentNode,!e||s.range.startContainer!=o&&s.range.endContainer!=o||(r=k(s._current),o==e.startContainer&&r<=e.startOffset&&(e.startOffset-=1),o==e.endContainer&&r<e.endOffset&&(e.endOffset-=1)),y.remove(s._current))},hasPartialSubtree:function(){return!x(this._current)&&(y.isAncestorOrSelf(this._current,this.range.startContainer)||y.isAncestorOrSelf(this._current,this.range.endContainer))},getSubtreeIterator:function(){return new a(this.getSubRange())},getSubRange:function(){var e=this,t=e.range.cloneRange();return t.selectNodeContents(e._current),y.isAncestorOrSelf(e._current,e.range.startContainer)&&t.setStart(e.range.startContainer,e.range.startOffset),y.isAncestorOrSelf(e._current,e.range.endContainer)&&t.setEnd(e.range.endContainer,e.range.endOffset),t}}),l=v.extend({init:function(e){this.ownerDocument=e,this.rangeCount=1},addRange:function(e){var t=this.ownerDocument.body.createTextRange();r(t,e,!1),r(t,e,!0),t.select()},removeAllRanges:function(){var e=this.ownerDocument.selection;"None"!=e.type&&e.empty()},getRangeAt:function(){var e,t,n,i,r,a,l,c,d=new A(this.ownerDocument),u=this.ownerDocument.selection;try{if(e=u.createRange(),t=e.item?e.item(0):e.parentElement(),t.ownerDocument!=this.ownerDocument)return d}catch(h){return d}if("Control"==u.type)d.selectNode(e.item(0));else if(n=o(e),s(e,d,n,!0),s(e,d,n,!1),9==d.startContainer.nodeType&&d.setStart(d.endContainer,d.startOffset),9==d.endContainer.nodeType&&d.setEnd(d.startContainer,d.endOffset),0===e.compareEndPoints("StartToEnd",e)&&d.collapse(!1),i=d.startContainer,r=d.endContainer,a=this.ownerDocument.body,!(d.collapsed||0!==d.startOffset||d.endOffset!=S(d.endContainer)||i==r&&x(i)&&i.parentNode==a)){for(l=!1,c=!1;0===k(i)&&i==i.parentNode.firstChild&&i!=a;)i=i.parentNode,l=!0;for(;k(r)==S(r.parentNode)-1&&r==r.parentNode.lastChild&&r!=a;)r=r.parentNode,c=!0;i==a&&r==a&&l&&c&&(d.setStart(i,0),d.setEnd(r,S(a)))}return d}}),c=v.extend({init:function(e){this.enumerate=function(){function t(e){if(y.is(e,"img")||3==e.nodeType&&(!y.isEmptyspace(e)||"\ufeff"==e.nodeValue))n.push(e);else for(e=e.firstChild;e;)t(e),e=e.nextSibling}var n=[];return new a(e).traverse(t),n}}}),d=a.extend({hasPartialSubtree:function(){var e=b.Immutables&&b.Immutables.immutable;return e&&!e(this._current)&&a.fn.hasPartialSubtree.call(this)},getSubtreeIterator:function(){return new d(this.getSubRange())}}),u=v.extend({init:function(e){this.enumerate=function(){function t(e){if(i&&!i(e))if(y.is(e,"img")||3==e.nodeType&&(!y.isEmptyspace(e)||"\ufeff"==e.nodeValue))n.push(e);else for(e=e.firstChild;e;)t(e),e=e.nextSibling}var n=[],i=b.Immutables&&b.Immutables.immutable;return new d(e).traverse(t),n}}}),h=v.extend({init:function(e,t,n){var i=this;i.range=e,i.rootNode=m.documentFromRange(e),i.body=t||i.getEditable(e),"body"!=y.name(i.body)&&(i.rootNode=i.body),i.startContainer=i.nodeToPath(e.startContainer),i.endContainer=i.nodeToPath(e.endContainer),i.startOffset=i.offset(e.startContainer,e.startOffset),i.endOffset=i.offset(e.endContainer,e.endOffset),i.immutables=n&&n.immutables,i.immutables&&(i.serializedImmutables=b.Immutables.removeImmutables(i.body)),i.html=i.body.innerHTML,i.immutables&&!i.serializedImmutables.empty&&b.Immutables.restoreImmutables(i.body,i.serializedImmutables)},index:function(e){for(var t,n=0,i=e.nodeType;e=e.previousSibling;)t=e.nodeType,3==t&&i==t||n++,i=t;return n},getEditable:function(e){for(var t=e.commonAncestorContainer;t&&(3==t.nodeType||t.attributes&&(!t.attributes.contentEditable||"false"==t.attributes.contentEditable.nodeValue.toLowerCase()));)t=t.parentNode;return t},restoreHtml:function(){var e=this;y.removeChildren(e.body),e.body.innerHTML=e.html,e.immutables&&!e.serializedImmutables.empty&&b.Immutables.restoreImmutables(e.body,e.serializedImmutables)},offset:function(e,t){if(3==e.nodeType)for(;(e=e.previousSibling)&&3==e.nodeType;)t+=e.nodeValue.length;return t},nodeToPath:function(e){for(var t=[];e!=this.rootNode;)t.push(this.index(e)),e=e.parentNode;return t},toRangePoint:function(e,t,n,i){for(var o=this.rootNode,r=n.length,s=i;r--;)o=o.childNodes[n[r]];for(;o&&3==o.nodeType&&o.nodeValue.length<s;)s-=o.nodeValue.length,o=o.nextSibling;o&&s>=0&&e[t?"setStart":"setEnd"](o,s)},toRange:function(){var e=this,t=e.range.cloneRange();return e.toRangePoint(t,!0,e.startContainer,e.startOffset),e.toRangePoint(t,!1,e.endContainer,e.endOffset),t}}),f=v.extend({init:function(){this.caret=null},addCaret:function(e){var t=this,n=t.caret=y.create(m.documentFromRange(e),"span",{className:"k-marker"});return e.insertNode(n),y.stripBomNode(n.previousSibling),y.stripBomNode(n.nextSibling),e.selectNode(n),n},removeCaret:function(e){var t,n,i,o,r=this,s=r.caret.previousSibling,a=0;s&&(a=x(s)?s.nodeValue.length:k(s)),t=r.caret.parentNode,n=s?k(s):0,y.remove(r.caret),T(t),i=t.childNodes[n],x(i)?e.setStart(i,a):i?(o=y.lastTextNode(i),o?e.setStart(o,o.nodeValue.length):e[s?"setStartAfter":"setStartBefore"](i)):(w.msie||t.innerHTML||(t.innerHTML='<br _moz_dirty="" />'),e.selectNodeContents(t)),e.collapse(!0)},add:function(e,t){var n,i,o=this,r=e.collapsed&&!m.isExpandable(e),s=m.documentFromRange(e);return t&&e.collapsed&&(o.addCaret(e),e=m.expand(e)),n=e.cloneRange(),n.collapse(!1),o.end=y.create(s,"span",{className:"k-marker"}),n.insertNode(o.end),n=e.cloneRange(),n.collapse(!0),o.start=o.end.cloneNode(!0),n.insertNode(o.start),o._removeDeadMarkers(o.start,o.end),r&&(i=s.createTextNode("\ufeff"),y.insertAfter(i.cloneNode(),o.start),y.insertBefore(i,o.end)),T(e.commonAncestorContainer),e.setStartBefore(o.start),e.setEndAfter(o.end),e},_removeDeadMarkers:function(e,t){e.previousSibling&&"\ufeff"==e.previousSibling.nodeValue&&y.remove(e.previousSibling),t.nextSibling&&"\ufeff"==t.nextSibling.nodeValue&&y.remove(t.nextSibling)},_normalizedIndex:function(e){for(var t=k(e),n=e;n.previousSibling;)3==n.nodeType&&3==n.previousSibling.nodeType&&t--,n=n.previousSibling;return t},remove:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f=this,p=f.start,m=f.end;for(T(e.commonAncestorContainer);!p.nextSibling&&p.parentNode;)p=p.parentNode;for(;!m.previousSibling&&m.parentNode;)m=m.parentNode;if(t=p.previousSibling&&3==p.previousSibling.nodeType&&p.nextSibling&&3==p.nextSibling.nodeType,n=m.previousSibling&&3==m.previousSibling.nodeType&&m.nextSibling&&3==m.nextSibling.nodeType,i=t&&n,p=p.nextSibling,m=m.previousSibling,o=p===m&&y.isBom(p),o&&p.length>1&&(p.nodeValue=p.nodeValue.charAt(0)),r=o,s=!1,p==f.end&&(s=!!f.start.previousSibling,p=m=f.start.previousSibling||f.end.nextSibling,r=!0),y.remove(f.start),y.remove(f.end),!p||!m)return e.selectNodeContents(e.commonAncestorContainer),void e.collapse(!0);if(a=r?x(p)?p.nodeValue.length:p.childNodes.length:0,l=x(m)?m.nodeValue.length:m.childNodes.length,3==p.nodeType)for(;p.previousSibling&&3==p.previousSibling.nodeType;)p=p.previousSibling,a+=p.nodeValue.length;if(3==m.nodeType)for(;m.previousSibling&&3==m.previousSibling.nodeType;)m=m.previousSibling,l+=m.nodeValue.length;c=p.parentNode,d=m.parentNode,u=this._normalizedIndex(p),h=this._normalizedIndex(m),T(c),3==p.nodeType&&(p=c.childNodes[u]),T(d),3==m.nodeType&&(m=d.childNodes[h]),r?(3==p.nodeType?e.setStart(p,a):e[s?"setStartAfter":"setStartBefore"](p),e.collapse(!0)):(3==p.nodeType?e.setStart(p,a):e.setStartBefore(p),3==m.nodeType?e.setEnd(m,l):e.setEndAfter(m)),f.caret&&f.removeCaret(e)}}),p=/[\u0009-\u000d]|\u0020|\u00a0|\ufeff|\.|,|;|:|!|\(|\)|\?/,m={nodes:function(e){var t=m.textNodes(e);return t.length||(e.selectNodeContents(e.commonAncestorContainer),t=m.textNodes(e),t.length||(t=y.significantChildNodes(e.commonAncestorContainer))),t},textNodes:function(e){return new c(e).enumerate()},editableTextNodes:function(e){var t=[],n=b.Immutables&&b.Immutables.immutableParent;return n&&!n(e.commonAncestorContainer)&&(t=new u(e).enumerate()),t},documentFromRange:function(e){var t=e.startContainer;return 9==t.nodeType?t:t.ownerDocument},createRange:function(e){return w.msie&&w.version<9?new A(e):e.createRange()},selectRange:function(e){var t,n=m.image(e);n&&(e.setStartAfter(n),e.setEndAfter(n)),t=D.selectionFromRange(e),t.removeAllRanges(),t.addRange(e)},stringify:function(e){return g.format("{0}:{1} - {2}:{3}",y.name(e.startContainer),e.startOffset,y.name(e.endContainer),e.endOffset)},split:function(e,t,n){function i(i){var o,r=e.cloneRange();r.collapse(i),r[i?"setStartBefore":"setEndAfter"](t),o=r.extractContents(),n&&(o=y.trim(o)),y[i?"insertBefore":"insertAfter"](o,t)}i(!0),i(!1)},mapAll:function(t,n){var i=[];return new a(t).traverse(function(t){var o=n(t);o&&e.inArray(o,i)<0&&i.push(o)}),i},getAll:function(e,t){var n=t;return"string"==typeof t&&(t=function(e){return y.is(e,n)}),m.mapAll(e,function(e){if(t(e))return e})},getMarkers:function(e){return m.getAll(e,function(e){return"k-marker"==e.className})},image:function(e){var t=m.getAll(e,"img");if(1==t.length)return t[0]},isStartOf:function(e,t){var n,i,o;if(0!==e.startOffset)return!1;for(n=e.cloneRange();0===n.startOffset&&n.startContainer!=t;){for(i=y.findNodeIndex(n.startContainer),o=n.startContainer.parentNode;i>0&&o[i-1]&&y.insignificant(o[i-1]);)i--;n.setStart(o,i)}return 0===n.startOffset&&n.startContainer==t},isEndOf:function(e,t){function n(e){y.insignificant(e)||y.isDataNode(e)&&/^[\ufeff]*$/.test(e.nodeValue)||o.push(e)}var i,o,r=e.cloneRange();return r.collapse(!1),i=r.startContainer,y.isDataNode(i)&&r.startOffset==y.getNodeLength(i)&&(r.setStart(i.parentNode,y.findNodeIndex(i)+1),r.collapse(!0)),r.setEnd(t,y.getNodeLength(t)),o=[],new a(r).traverse(n),!o.length},wrapSelectedElements:function(e){function t(e,t){var n,i=y.getNodeLength(t);if(e==i)return!0;for(n=e;n<i;n++)if(!y.insignificant(t.childNodes[n]))return!1;return!0}for(var n=y.editableParent(e.startContainer),i=y.editableParent(e.endContainer);0===e.startOffset&&e.startContainer!=n;)e.setStart(e.startContainer.parentNode,y.findNodeIndex(e.startContainer));for(;t(e.endOffset,e.endContainer)&&e.endContainer!=i;)e.setEnd(e.endContainer.parentNode,y.findNodeIndex(e.endContainer)+1);return e},expand:function(e){var t,n,i,o,r=e.cloneRange(),s=r.startContainer.childNodes[0===r.startOffset?0:r.startOffset-1],a=r.endContainer.childNodes[r.endOffset];return x(s)&&x(a)?(t=s.nodeValue,n=a.nodeValue,t&&n?(i=t.split("").reverse().join("").search(p),o=n.search(p),i&&o?(o=o==-1?n.length:o,i=i==-1?0:t.length-i,r.setStart(s,i),r.setEnd(a,o),r):r):r):r},isExpandable:function(e){var t,n,i,o,r,s,a=e.startContainer,l=m.documentFromRange(e);return a!=l&&a!=l.body&&(t=e.cloneRange(),!!(n=a.nodeValue)&&(i=n.substring(0,t.startOffset),o=n.substring(t.startOffset),r=0,s=0,i&&(r=i.split("").reverse().join("").search(p)),o&&(s=o.search(p)),r&&s))}},_(b,{SelectionUtils:D,W3CRange:A,RangeIterator:a,W3CSelection:l,RangeEnumerator:c,RestorePoint:h,Marker:f,RangeUtils:m})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/immutables.min",["editor/range.min"],e)}(function(){!function(e,t){var n=window.kendo,i=n.Class,o=n.ui.editor,r=o.Dom,s=n.template,a=o.RangeUtils,l=["ul","ol","tbody","thead","table"],c=["bold","italic","underline","strikethrough","superscript","subscript","forecolor","backcolor","fontname","fontsize","createlink","unlink","autolink","addcolumnleft","addcolumnright","addrowabove","addrowbelow","deleterow","deletecolumn","mergecells","formatting","cleanformatting"],d="k-immutable",u="["+d+"]",h="[contenteditable='false']",f=function(t){return e(t).is("body,.k-editor")},p=function(e){return e.getAttribute&&"false"==e.getAttribute("contenteditable")},m=function(e){return r.closestBy(e,p,f)},g=function(e){var t=m(e.startContainer),n=m(e.endContainer);(t||n)&&(t&&e.setStartBefore(t),n&&e.setEndAfter(n))},v=function(e){if(m(e.commonAncestorContainer))return!0;if(m(e.startContainer)||m(e.endContainer)){var t=a.editableTextNodes(e);if(0===t.length)return!0}return!1},_=function(e){var t,n="",i="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";for(t=e||10;t>0;--t)n+=i.charAt(Math.round(Math.random()*(i.length-1)));return n},b=function(t){var n,i,o,s={empty:!0};return e(t).find(h).each(function(t,a){n=r.name(a),i=_(),o="<"+n+" "+d+"='"+i+"'></"+n+">",s[i]={node:a,style:e(a).attr("style")},s.empty=!1,e(a).replaceWith(o)}),s},w=function(t,n){var i,o;e(t).find(u).each(function(t,r){i=r.getAttribute(d),o=n[i],e(r).replaceWith(o.node),o.style!=e(o.node).attr("style")&&e(o.node).removeAttr("style").attr("style",o.style)})},y=function(e){var t=n.keys;return e===t.BACKSPACE||e==t.DELETE},k=function(e){var n=e?e.options:t;n&&n.finder&&n.finder._initOptions({immutables:!0})},x=i.extend({init:function(t){this.editor=t,this.serializedImmutables={},this.options=e.extend({},t&&t.options&&t.options.immutables);var n=t.toolbar.tools;k(n.justifyLeft),k(n.justifyCenter),k(n.justifyRight),k(n.justifyFull)},serialize:function(e){var t,n=this._toHtml(e);return n.indexOf(d)===-1?(t=this.randomId(),n=n.replace(/>/," "+d+'="'+t+'">')):t=n.match(/k-immutable\s*=\s*['"](.*)['"]/)[1],this.serializedImmutables[t]=e,n},_toHtml:function(e){var t,n=this.options.serialization,i=typeof n;switch(i){case"string":return s(n)(e);case"function":return n(e);default:return t=r.name(e),"<"+t+"></"+t+">"}},deserialize:function(t){var i=this,o=this.options.deserialization;e(u,t).each(function(){var t=this.getAttribute(d),r=i.serializedImmutables[t];n.isFunction(o)&&o(this,r),e(this).replaceWith(r)}),i.serializedImmutables={}},randomId:function(e){return _(e)},keydown:function(e,t){var n=y(e.keyCode),i=n&&this._cancelDeleting(e,t)||!n&&this._cancelTyping(e,t);if(i)return e.preventDefault(),!0},_cancelTyping:function(e,t){var n=this.editor,i=n.keyboard;return t.collapsed&&!i.typingInProgress&&i.isTypingKey(e)&&v(t)},_cancelDeleting:function(e,t){var i,o,s,a,c=n.keys,d=e.keyCode===c.BACKSPACE,u=e.keyCode==c.DELETE;if(!d&&!u)return!1;if(i=!1,t.collapsed){if(v(t))return!0;if(o=this.nextImmutable(t,u),o&&d&&(s=r.closest(t.commonAncestorContainer,"li"),s&&(a=r.closest(o,"li"),a&&a!==s)))return i;if(o&&!r.tableCell(o)){if(r.parentOfType(o,l)===r.parentOfType(t.commonAncestorContainer,l)){for(;o&&1==o.parentNode.childNodes.length;)o=o.parentNode;if(r.tableCell(o))return i;this._removeImmutable(o,t)}i=!0}}return i},nextImmutable:function(e,t){var n,i=e.commonAncestorContainer;if(r.isBom(i)||t&&a.isEndOf(e,i)||!t&&a.isStartOf(e,i)){if(n=this._nextNode(i,t),n&&r.isBlock(n)&&!m(n))for(;n&&n.children&&n.children[t?0:n.children.length-1];)n=n.children[t?0:n.children.length-1];return m(n)}},_removeImmutable:function(e,t){var n=this.editor,i=new o.RestorePoint(t,n.body);r.remove(e),o._finishUpdate(n,i)},_nextNode:function(e,t){for(var n,i=t?"nextSibling":"previousSibling",o=e;o&&!n;)n=o[i],n&&r.isDataNode(n)&&/^\s|[\ufeff]$/.test(n.nodeValue)&&(o=n,n=o[i]),n||(o=o.parentNode);return n}});x.immutable=p,x.immutableParent=m,x.expandImmutablesIn=g,x.immutablesContext=v,x.toolsToBeUpdated=c,x.removeImmutables=b,x.restoreImmutables=w,o.Immutables=x}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/command.min",["editor/immutables.min"],e)}(function(){!function(e){function t(e,t){var n=e.selectionRestorePoint=new s(e.getRange(),e.body),i=new d(t,n);return i.editor=e,e.undoRedoStack.push(i),n}var n=window.kendo,i=n.Class,o=n.ui.editor,r=o.Dom,s=o.RestorePoint,a=o.Marker,l=e.extend,c=i.extend({init:function(e){this.options=e,this.restorePoint=new s(e.range,e.body,{immutables:e.immutables}),this.marker=new a,this.formatter=e.formatter},getRange:function(){return this.restorePoint.toRange()},lockRange:function(e){return this.marker.add(this.getRange(),e)},releaseRange:function(e){this.marker.remove(e),this.editor.selectRange(e)},undo:function(){var e=this.restorePoint;e.restoreHtml(),this.editor.selectRange(e.toRange())},redo:function(){this.exec()},createDialog:function(t,i){var o=this.editor;return e(t).appendTo(document.body).kendoWindow(l({},o.options.dialogOptions,i)).closest(".k-window").toggleClass("k-rtl",n.support.isRtl(o.wrapper)).end()},exec:function(){var e=this.lockRange(!0);this.formatter.editor=this.editor,this.formatter.toggle(e),this.releaseRange(e)},immutables:function(){return this.editor&&this.editor.options.immutables},expandImmutablesIn:function(e){this.immutables()&&(n.ui.editor.Immutables.expandImmutablesIn(e),this.restorePoint=new s(e,this.editor.body))}}),d=i.extend({init:function(e,t){this.body=e.body,this.startRestorePoint=e,this.endRestorePoint=t},redo:function(){r.removeChildren(this.body),this.body.innerHTML=this.endRestorePoint.html,this.editor.selectRange(this.endRestorePoint.toRange())},undo:function(){r.removeChildren(this.body),this.body.innerHTML=this.startRestorePoint.html,this.editor.selectRange(this.startRestorePoint.toRange())}});l(o,{_finishUpdate:t,Command:c,GenericCommand:d})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/toolbar.min",["editor/range.min"],e)}(function(){!function(e,t){var n,i=window.kendo,o=i.ui,r=o.editor,s=o.Widget,a=e.extend,l=e.proxy,c=i.keys,d=".kendoEditor",u=r.EditorUtils,h=r.ToolTemplate,f=r.Tool,p=i._outerWidth,m=i._outerHeight,g="overflowAnchor",v=".k-tool-group:visible a.k-tool:not(.k-state-disabled),.k-tool.k-overflow-anchor:visible,.k-tool-group:visible .k-widget.k-colorpicker,.k-tool-group:visible .k-selectbox,.k-tool-group:visible .k-dropdown,.k-tool-group:visible .k-combobox .k-input",_={"k-i-sup-script":"superscript","k-i-sub-script":"subscript","k-i-align-left":"justifyLeft","k-i-align-center":"justifyCenter",
"k-i-align-right":"justifyRight","k-i-align-justify":"justifyFull","k-i-list-unordered":"insertUnorderedList","k-i-list-ordered":"insertOrderedList","k-i-login":"import","k-i-indent-increase":"indent","k-i-indent-decrease":"outdent","k-i-link-horizontal":"createLink","k-i-unlink-horizontal":"unlink","k-i-image":"insertImage","k-i-file-add":"insertFile","k-i-html":"viewHtml","k-i-foreground-color":"foreColor","k-i-paint":"backColor","k-i-table-insert":"createTable","k-i-table-column-insert-left":"addColumnLeft","k-i-table-column-insert-right":"addColumnRight","k-i-table-row-insert-above":"addRowAbove","k-i-table-row-insert-below":"addRowBelow","k-i-table-row-delete":"deleteRow","k-i-table-column-delete":"deleteColumn","k-i-table-properties":"tableWizard","k-i-table-wizard":"tableWizardInsert","k-i-clear-css":"cleanFormatting"},b=f.extend({initialize:function(t,n){t.attr({unselectable:"on"});var i=n.editor.toolbar;t.attr("aria-controls",n.editor.element.attr("id")).on("click",e.proxy(function(){this.overflowPopup.toggle()},i))},options:{name:g},command:e.noop,update:e.noop,destroy:e.noop});u.registerTool(g,new b({key:"",ctrl:!0,template:new h({template:u.overflowAnchorTemplate})})),n=s.extend({init:function(e,t){var n=this;t=a({},t,{name:"EditorToolbar"}),s.fn.init.call(n,e,t),t.popup&&n._initPopup(),t.resizable&&t.resizable.toolbar&&(n._resizeHandler=i.onResize(function(){n.resize()}),n.element.addClass("k-toolbar-resizable"))},events:["execute"],groups:{basic:["bold","italic","underline","strikethrough"],scripts:["subscript","superscript"],alignment:["justifyLeft","justifyCenter","justifyRight","justifyFull"],links:["insertImage","insertFile","createLink","unlink"],lists:["insertUnorderedList","insertOrderedList","indent","outdent"],tables:["createTable","addColumnLeft","addColumnRight","addRowAbove","addRowBelow","deleteRow","deleteColumn"],advanced:["viewHtml","cleanFormatting","print","pdf","exportAs","import"],fonts:["fontName","fontSize"],colors:["foreColor","backColor"]},overflowFlaseTools:["formatting","fontName","fontSize","foreColor","backColor","insertHtml"],_initPopup:function(){var t=this;this.window=e(this.element).wrap("<div class='editorToolbarWindow k-header' />").parent().prepend("<button class='k-button k-bare k-editortoolbar-dragHandle'><span class='k-icon k-i-handler-drag' /></button>").kendoWindow({title:!1,resizable:!1,draggable:{dragHandle:".k-editortoolbar-dragHandle"},animation:{open:{effects:"fade:in"},close:{effects:"fade:out"}},minHeight:42,visible:!1,autoFocus:!1,actions:[],dragend:function(){this._moved=!0}}).on("mousedown",function(n){e(n.target).is(".k-icon")||(t.preventPopupHide=!0)}).on("focusout",function(){t.options.editor.element.focusout()}).data("kendoWindow")},_toggleOverflowStyles:function(e,t){e.find("li").toggleClass("k-item k-state-default",t).find(".k-tool:not(.k-state-disabled),.k-overflow-button").toggleClass("k-overflow-button k-button",t)},_initOverflowPopup:function(t){var n=this,i="<ul class='k-editor-overflow-popup k-overflow-container k-list-container'></ul>";n.overflowPopup=e(i).appendTo("body").kendoPopup({anchor:t,origin:"bottom right",position:"top right",copyAnchorStyles:!1,open:function(e){this.element.is(":empty")&&e.preventDefault(),n._toggleOverflowStyles(this.element,!0),t.attr("aria-expanded",!0)},close:function(){t.attr("aria-expanded",!1)},activate:l(n.focusOverflowPopup,n)}).data("kendoPopup")},items:function(){var e,t,n=this.options.resizable&&this.options.resizable.toolbar;return t=this.element.children().find("> *, select"),n&&(e=this.overflowPopup,t=t.add(e.element.children().find("> *"))),t},focused:function(){return this.element.find(".k-state-focused").length>0||this.preventPopupHide||this.overflowPopup&&this.overflowPopup.visible()},toolById:function(e){var t,n=this.tools;for(t in n)if(t.toLowerCase()==e)return n[t]},toolGroupFor:function(t){var n,i=this.groups;if(this.isCustomTool(t))return"custom";for(n in i)if(e.inArray(t,i[n])>=0)return n},bindTo:function(t){var n=this,i=n.window;n._editor&&n._editor.unbind("select",l(n.resize,n)),n._editor=t,n.options.resizable&&n.options.resizable.toolbar&&t.options.tools.push(g),n.tools=n.expandTools(t.options.tools),n.render(),n.element.find(".k-combobox .k-input").keydown(function(t){var n=e(this).closest(".k-combobox").data("kendoComboBox"),i=t.keyCode;i==c.RIGHT||i==c.LEFT?n.close():i==c.DOWN&&(n.dropDown.isOpened()||(t.stopImmediatePropagation(),n.open()))}),n._attachEvents(),n.items().each(function(){var i,o=n._toolName(this),r="moreVertical"!==o?n.tools[o]:n.tools.overflowAnchor,s=r&&r.options,a=t.options.messages,l=s&&s.tooltip||a[o],c=e(this);r&&r.initialize&&("fontSize"!=o&&"fontName"!=o||(i=a[o+"Inherit"],c.find("input").val(i).end().find("span.k-input").text(i).end()),r.initialize(c,{title:n._appendShortcutSequence(l,r),editor:n._editor}),c.closest(".k-widget",n.element).addClass("k-editor-widget"),c.closest(".k-colorpicker",n.element).next(".k-colorpicker").addClass("k-editor-widget"))}),t.bind("select",l(n.resize,n)),n.update(),i&&i.wrapper.css({top:"",left:"",width:""})},show:function(){var e,t,n,o=this,r=o.window,s=o.options.editor,a=i.support.browser;r&&(e=r.wrapper,t=s.element,e.is(":visible")&&o.window.options.visible||(e[0].style.width||e.width(p(t)-parseInt(e.css("border-left-width"),10)-parseInt(e.css("border-right-width"),10)),r._moved||(n=t.offset(),e.css({top:Math.max(0,parseInt(n.top,10)-m(e)-parseInt(o.window.element.css("padding-bottom"),10)),left:Math.max(0,parseInt(n.left,10))})),(a.msie||a.edge)&&o._overlaps(t)?setTimeout(function(){r.open()},0):r.open()))},_overlaps:function(e){var t=this.window.wrapper,n=t.offset(),i=n.left,o=n.top,r=e.offset(),s=r.left,a=r.top;return!(s+e.width()<i||s>i+t.width()||a+e.height()<o||a>o+t.height())},hide:function(){this.window&&this.window.close()},focus:function(){var e="tabIndex",t=this.element,n=this._editor.element.attr(e);t.attr(e,n||0).focus().find(v).first().focus(),n||0===n||t.removeAttr(e)},focusOverflowPopup:function(){var e="tabIndex",t=this.overflowPopup.element,n=this._editor.element.attr(e);t.closest(".k-animation-container").addClass("k-overflow-wrapper"),t.attr(e,n||0).find(v).first().focus(),n||0===n||t.removeAttr(e)},_appendShortcutSequence:function(e,t){if(!t.key)return e;var n=e+" (";return t.ctrl&&(n+="Ctrl + "),t.shift&&(n+="Shift + "),t.alt&&(n+="Alt + "),n+=t.key+")"},_nativeTools:["insertLineBreak","insertParagraph","redo","undo","autoLink"],tools:{},isCustomTool:function(e){return!(e in i.ui.Editor.defaultTools)},expandTools:function(t){var n,o,s,l,c=this._nativeTools,d=i.deepExtend({},i.ui.Editor.defaultTools),u={};for(o=0;o<t.length;o++)n=t[o],l=n.name,e.isPlainObject(n)?l&&d[l]?(u[l]=a({},d[l]),a(u[l].options,n)):(s=a({cssClass:"k-i-gear",type:"button",title:""},n),s.name||(s.name="custom"),s.cssClass="k-"+s.name,s.template||"button"!=s.type||(s.template=r.EditorUtils.buttonTemplate,s.title=s.title||s.tooltip),u[l]={options:s}):d[n]&&(u[n]=d[n]);for(o=0;o<c.length;o++)u[c[o]]||(u[c[o]]=d[c[o]]);return u},render:function(){function t(t){var n;return t.getHtml?n=t.getHtml():(e.isFunction(t)||(t=i.template(t)),n=t(r)),e.trim(n)}function n(){h.children().length&&(k&&(h.data("position",y),y++),h.appendTo(_))}function o(t){t!==g?(h=e("<li class='k-tool-group' role='presentation' />"),h.data("overflow",e.inArray(t,x)===-1)):h=e("<li class='k-overflow-tools' />")}var r,s,a,c,d,u,h,f,p=this,m=p.tools,v=p._editor.element,_=p.element.empty(),b=p._editor.options.tools,w=i.support.browser,y=0,k=p.options.resizable&&p.options.resizable.toolbar,x=this.overflowFlaseTools;for(_.empty(),b.length&&(c=b[0].name||b[0]),o(c,x),f=0;f<b.length;f++)c=b[f].name||b[f],r=m[c]&&m[c].options,!r&&e.isPlainObject(c)&&(r=c),s=r&&r.template,"break"==c&&(n(),e("<li class='k-row-break' />").appendTo(p.element),o(c,x)),s&&(u=p.toolGroupFor(c),d==u&&c!=g||(n(),o(c,x),d=u),c==g&&(s.options.title=p.options.messages.overflowAnchor),s=t(s),a=e(s).appendTo(h),"custom"==u&&(n(),o(c,x)),r.exec&&a.hasClass("k-tool")&&a.click(l(r.exec,v[0])));n(),e(p.element).children(":has(> .k-tool)").addClass("k-button-group"),p.options.popup&&w.msie&&w.version<9&&p.window.wrapper.find("*").attr("unselectable","on"),p.updateGroups(),k&&p._initOverflowPopup(p.element.find(".k-overflow-anchor")),p.angular("compile",function(){return{elements:p.element}})},updateGroups:function(){e(this.element).children().each(function(){e(this).addClass("k-state-disabled"),e(this).children().filter(function(){return!e(this).hasClass("k-state-disabled")}).removeClass("k-group-end").first().addClass("k-group-start").end().last().addClass("k-group-end").end().parent().removeClass("k-state-disabled")})},decorateFrom:function(t){this.items().filter(".k-decorated").each(function(){var n=e(this).data("kendoSelectBox");n&&n.decorate(t)})},destroy:function(){s.fn.destroy.call(this);var e,t=this.tools;for(e in t)t[e].destroy&&t[e].destroy();this.window&&this.window.destroy(),this._resizeHandler&&i.unbindResize(this._resizeHandler),this.overflowPopup&&this.overflowPopup.destroy()},_attachEvents:function(){var t=this,n=t.overflowPopup?t.overflowPopup.element:e([]);t.attachToolsEvents(t.element.add(n))},attachToolsEvents:function(t){var n=this,o="[role=button].k-tool",r=o+":not(.k-state-disabled)",s=o+".k-state-disabled",a=".k-dropdown",l=".k-colorpicker",u=[o,a,l].join(",");t.off(d).on("mouseenter"+d,r,function(){e(this).addClass("k-state-hover")}).on("mouseleave"+d,r,function(){e(this).removeClass("k-state-hover")}).on("mousedown"+d,u,function(e){e.preventDefault()}).on("keydown"+d,v,function(t){function o(e,t,n){var i=t.find(v),o=i.index(l)+e;return n&&(o=Math.max(0,Math.min(i.length-1,o))),i[o]}var r,s,a,l=this,d=n.options.resizable&&n.options.resizable.toolbar,u=i.support.isRtl(n.element)?-1:1,h=t.keyCode;h==c.RIGHT||h==c.LEFT?s=e(l).is(".k-dropdown")?e(l):o(h==c.RIGHT?1*u:-1*u,n.element,!0):!d||h!=c.UP&&h!=c.DOWN?h==c.HOME?(s=n.element.find(v)[0],t.preventDefault()):h==c.END?(r=n.element.find(v).filter(function(){return"hidden"!==e(this).css("visibility")}),s=r[r.length-1],t.preventDefault()):h==c.ESC?(n.overflowPopup&&n.overflowPopup.visible()&&n.overflowPopup.close(),s=n._editor):h!=c.TAB||t.ctrlKey||t.altKey||(a=d&&e(l.parentElement).hasClass("k-overflow-tool-group")?n.overflowPopup.element:n.element,t.shiftKey?s=o(-1,a):(s=o(1,a),s&&"hidden"!==e(s).closest(".k-overflow-tools").css("visibility")||(s=n._editor))):s=o(h==c.DOWN?1:-1,n.overflowPopup.element,!0),s&&(t.preventDefault(),s.focus()),h!==c.ENTER&&h!==c.SPACEBAR||!e(l).is("a")||e(l).attr("href")||n._executeToolCommand(l,t)}).on("click"+d,r,function(e){n._executeToolCommand(this,e)}).on("click"+d,s,function(e){e.preventDefault()})},_executeToolCommand:function(t,n){var i=this,o=e(t);n.preventDefault(),n.stopPropagation(),o.removeClass("k-state-hover"),o.is("[data-popup]")||i._editor.exec(i._toolName(t))},_toolName:function(t){var n,o,r;if(t)return n=t.className,/k-tool\b/i.test(n)&&(n=t.firstChild.className),o=e.grep(n.split(" "),function(e){return!/^k-(widget|tool|tool-icon|icon|state-hover|header|combobox|dropdown|selectbox|colorpicker)$/i.test(e)}),o[0]?(r=o[0],_[r]&&(r=_[r]),r.indexOf("k-i-")>=0?i.toCamelCase(r.substring(r.indexOf("k-i-")+4)):r.substring(r.lastIndexOf("-")+1)):"custom"},refreshTools:function(){var t=this,n=t._editor,i=n.getRange(),o=r.RangeUtils.textNodes(i),s=n.options.immutables,a=t._immutablesContext(i);o=r.Dom.filterBy(o,r.Dom.htmlIndentSpace,!0),o.length||(o=[i.startContainer]),t.items().each(function(){var n,i=t.tools[t._toolName(this)];i&&(n=e(this),i.update&&i.update(n,o),s&&t._updateImmutablesState(i,n,a))}),this.update()},_immutablesContext:function(e){if(this._editor.options.immutables)return e.collapsed?r.Immutables.immutablesContext(e):0===r.RangeUtils.editableTextNodes(e).length},_updateImmutablesState:function(n,i,o){var s,a,l,c,d,u=n.name,h=i,f=n.options.trackImmutables;if(f===t&&(f=e.inArray(u,r.Immutables.toolsToBeUpdated)>-1),f){if(s=o?"none":"",!i.is(".k-tool")){a=i.data();for(l in a)if(l.match(/^kendo[A-Z][a-zA-Z]*/)){c=a[l],h=c.wrapper;break}}h.css("display",s),d=h.closest("li"),0===d.children(":visible").length&&d.css("display",s)}},update:function(){this.updateGroups()},_resize:function(e){var t=e.width,n=this.options.resizable&&this.options.resizable.toolbar,i=this.overflowPopup;this.refreshTools(),n&&(i.visible()&&i.close(!0),this._refreshWidths(),this._shrink(t),this._stretch(t),this._toggleOverflowStyles(this.element,!1),this._toggleOverflowStyles(this.overflowPopup.element,!0),this.element.children("li.k-overflow-tools").css("visibility",i.element.is(":empty")?"hidden":"visible"))},_refreshWidths:function(){this.element.children("li").each(function(t,n){var i=e(n);i.data("outerWidth",p(i,!0))})},_shrink:function(e){var t,n,i;if(e<this._groupsWidth())for(n=this._visibleGroups().filter(":not(.k-overflow-tools)"),i=n.length-1;i>=0&&(t=n.eq(i),!(e>this._groupsWidth()));i--)this._hideGroup(t)},_stretch:function(e){var t,n,i;if(e>this._groupsWidth())for(n=this._hiddenGroups(),i=0;i<n.length&&(t=n.eq(i),!(e<this._groupsWidth())&&this._showGroup(t,e));i++);},_hiddenGroups:function(){var t=this.overflowPopup,n=this.element.children("li.k-tool-group").filter(":hidden");return n=n.add(t.element.children("li")),n.sort(function(t,n){return e(t).data("position")>e(n).data("position")?1:-1}),n},_visibleGroups:function(){return this.element.children("li.k-tool-group, li.k-overflow-tools").filter(":visible")},_groupsWidth:function(){var t=0;return this._visibleGroups().each(function(){t+=e(this).data("outerWidth")}),Math.ceil(t)},_hideGroup:function(e){if(e.data("overflow")){var t=this.overflowPopup;e.detach().prependTo(t.element).addClass("k-overflow-tool-group")}else e.hide()},_showGroup:function(t,n){var i,o;return!!(t.length&&n>this._groupsWidth()+t.data("outerWidth"))&&(t.hasClass("k-overflow-tool-group")?(i=t.data("position"),0===i?t.detach().prependTo(this.element):(o=this.element.children().filter(function(t,n){return e(n).data("position")===i-1}),t.detach().insertAfter(o)),t.removeClass("k-overflow-tool-group")):t.show(),!0)}}),e.extend(r,{Toolbar:n})}(window.jQuery||window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/viewhtml.min",["editor/command.min"],e)}(function(){!function(e,t){var n=window.kendo,i=e.extend,o=n.ui.editor,r=o.EditorUtils,s=o.Command,a=o.Tool,l=o.ToolTemplate,c=o.Dom,d=s.extend({init:function(e){var t=this;t.options=e,s.fn.init.call(t,e),t.attributes=null,t.async=!0},exec:function(){function i(e){h.deserialization.immutables=u.immutables,u.value(p.find(m).val()),h.deserialization.immutables=t,o(e),l.change&&l.change(),u.trigger("change")}function o(e){e.preventDefault(),p.data("kendoWindow").destroy(),u.immutables&&(u.immutables.serializedImmutables={}),u.focus()}var s,a,l=this,u=l.editor,h=u.options,f=u.options.messages,p=e(n.template(d.template)(f)).appendTo(document.body),m=".k-editor-textarea";h.serialization.immutables=u.immutables,a=c.getAllComments(u.body),s=r.cacheComments(u.value(),a),s=d.indent(s),s=r.retrieveComments(s,a),h.serialization.immutables=t,this.createDialog(p,{title:f.viewHtml,close:o,visible:!1}).find(m).val(s).end().find(".k-dialog-update").click(i).end().find(".k-dialog-close").click(o).end().data("kendoWindow").center().open(),p.find(m).focus()}});i(d,{template:"<div class='k-editor-dialog k-popup-edit-form k-viewhtml-dialog'><div class='k-edit-form-container'></div><textarea class='k-editor-textarea k-input'></textarea><div class='k-edit-buttons k-state-default'><button class='k-dialog-update k-button k-primary'>#: dialogUpdate #</button><button class='k-dialog-close k-button'>#: dialogCancel #</button></div></div></div>",indent:function(e){return e.replace(/<\/(p|li|ul|ol|h[1-6]|table|tr|td|th)>/gi,"</$1>\n").replace(/<(ul|ol)([^>]*)><li/gi,"<$1$2>\n<li").replace(/<br \/>/gi,"<br />\n").replace(/\n$/,"")}}),n.ui.editor.ViewHtmlCommand=d,o.EditorUtils.registerTool("viewHtml",new a({command:d,template:new l({template:r.buttonTemplate,title:"View HTML"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/format.min",["editor/command.min"],e)}(function(){!function(e){var t=window.kendo,n=e.extend,i=t.ui.editor,o=i.Tool,r=i.Command,s=i.EditorUtils,a=r.extend({init:function(e){e.formatter=e.formatter();var t=e.formatter.finder;t&&s.formatByName("immutable",t.format)&&t._initOptions({immutables:e.immutables}),r.fn.init.call(this,e)}}),l=o.extend({init:function(e){o.fn.init.call(this,e)},command:function(e){var t=this;return new a(n(e,{formatter:t.options.formatter}))},update:function(e,t){var n=this.options.finder.isFormatted(t);e.toggleClass("k-state-selected",n),e.attr("aria-pressed",n)}});e.extend(i,{FormatCommand:a,FormatTool:l})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/inlineformat.min",["editor/plugins/format.min"],e)}(function(){!function(e){var t=window.kendo,n=t.Class,i=t.ui.editor,o=t.ui.Editor.fn.options.formats,r=i.EditorUtils,s=i.Tool,a=i.ToolTemplate,l=i.FormatTool,c=i.Dom,d=i.RangeUtils,u=e.extend,h=i.EditorUtils.registerTool,f=i.EditorUtils.registerFormat,p=function(e){e.preventDefault()},m="mousedown.kendoEditor",g="keydown.kendoEditor",v="k-marker",_=n.extend({init:function(e){this.format=e},numberOfSiblings:function(e){var t,n=0,i=0,o=0,r=e.parentNode;for(t=r.firstChild;t;t=t.nextSibling)t!=e&&(t.className==v?o++:3==t.nodeType?n++:i++);return o>1&&r.firstChild.className==v&&r.lastChild.className==v?0:i+n},findSuitable:function(e,t){var n,i;if(!t&&this.numberOfSiblings(e)>0)return null;for(n=e.parentNode,i=this.format[0].tags;!c.ofType(n,i);){if(this.numberOfSiblings(n)>0)return null;n=n.parentNode}return n},findFormat:function(e){var t,n,i,o,r,s=this.format,a=c.attrEquals;for(t=0,n=s.length;t<n;t++){if(i=e,o=s[t].tags,r=s[t].attr,i&&c.ofType(i,o)&&a(i,r))return i;for(;i;)if(i=c.parentOfType(i,o),i&&a(i,r))return i}return null},isFormatted:function(e){var t,n;for(t=0,n=e.length;t<n;t++)if(this.findFormat(e[t]))return!0;return!1}}),b=n.extend({init:function(e,t){this.finder=new _(e),this.attributes=u({},e[0].attr,t),this.tag=e[0].tags[0]},wrap:function(e){return c.wrap(e,c.create(e.ownerDocument,this.tag,this.attributes))},activate:function(e,t){this.finder.isFormatted(t)?(this.split(e),this.remove(t)):this.apply(t)},toggle:function(e){var t=this.immutables()?d.editableTextNodes:d.textNodes,n=t(e);n.length>0&&this.activate(e,n)},immutables:function(){return this.editor&&this.editor.options.immutables},apply:function(e){var t,n,i,o,r=[],s=this.attributes,a=s?s.style||{}:{};for(t=0,n=e.length;t<n;t++){if(i=e[t],o=this.finder.findSuitable(i))c.is(o,"font")&&(a.color&&o.removeAttribute("color"),a.fontName&&o.removeAttribute("face"),a.fontSize&&o.removeAttribute("size")),c.attr(o,s);else{for(;!c.isBlock(i.parentNode)&&1==i.parentNode.childNodes.length&&"true"!==i.parentNode.contentEditable;)i=i.parentNode;o=this.wrap(i)}r.push(o)}this.consolidate(r)},remove:function(e){var t,n,i;for(t=0,n=e.length;t<n;t++)i=this.finder.findFormat(e[t]),i&&(this.attributes&&this.attributes.style?(c.unstyle(i,this.attributes.style),i.style.cssText||i.attributes["class"]||c.unwrap(i)):c.unwrap(i))},split:function(e){var t,n,i=d.textNodes(e),o=i.length;if(o>0)for(t=0;t<o;t++)n=this.finder.findFormat(i[t]),n&&d.split(e,n,!0)},consolidate:function(e){for(var t,n;e.length>1;)if(t=e.pop(),n=e[e.length-1],t.previousSibling&&t.previousSibling.className==v&&n.appendChild(t.previousSibling),t.tagName==n.tagName&&t.previousSibling==n&&t.style.cssText==n.style.cssText){for(;t.firstChild;)n.appendChild(t.firstChild);c.remove(t)}}}),w=_.extend({init:function(e,t){this.format=e,this.greedyProperty=t,_.fn.init.call(this,e)},getInlineCssValue:function(t){var n,i,o,r,s,a,l,d,u,h,f,p,m=t.attributes,g=e.trim;if(m)for(n=0,i=m.length;n<i;n++)if(o=m[n],r=o.nodeName,s=o.nodeValue,o.specified&&"style"==r)for(a=g(s||t.style.cssText).split(";"),d=0,u=a.length;d<u;d++)if(l=a[d],l.length){if(h=l.split(":"),f=g(h[0].toLowerCase()),p=g(h[1]),f!=this.greedyProperty)continue;return f.indexOf("color")>=0?c.toHex(p):p}},getFormatInner:function(t){var n,i,o,r=e(c.isDataNode(t)?t.parentNode:t),s=r.parentsUntil("[contentEditable]").addBack().toArray().reverse();for(n=0,i=s.length;n<i;n++)if(o="className"==this.greedyProperty?s[n].className:this.getInlineCssValue(s[n]))return o;return"inherit"},getFormat:function(e){var t,n,i=this.getFormatInner(e[0]);for(t=1,n=e.length;t<n;t++)if(i!=this.getFormatInner(e[t]))return"";return i},isFormatted:function(e){return""!==this.getFormat(e)}}),y=b.extend({init:function(e,n,i){b.fn.init.call(this,e,n),this.values=n,this.finder=new w(e,i),i&&(this.greedyProperty=t.toCamelCase(i))},activate:function(e,t){var n=this.greedyProperty,i="apply";this.split(e),n&&"inherit"==this.values.style[n]&&(i="remove"),this[i](t)}}),k=l.extend({init:function(e){l.fn.init.call(this,u(e,{finder:new _(e.format),formatter:function(){return new b(e.format)}}))}}),x=s.extend({update:function(e,t){var n=e.data(this.type);n.close(),n.value(this.finder.getFormat(t))}}),C=x.extend({init:function(e){s.fn.init.call(this,e),this.type=t.support.browser.msie||t.support.touch?"kendoDropDownList":"kendoComboBox",this.format=[{tags:["span","font"]}],this.finder=new w(this.format,e.cssAttr)},command:function(e){var t=this.options,n=this.format,o={};return new i.FormatCommand(u(e,{formatter:function(){return o[t.domAttr]=e.value,new y(n,{style:o},t.cssAttr)}}))},initialize:function(e,n){var i,o,r,a=n.editor,l=this.options,c=l.name,d=[];l.defaultValue&&(d=[{text:a.options.messages[l.defaultValue[0].text],value:l.defaultValue[0].value}]),i=d.concat(l.items?l.items:a.options[c]||[]),e.attr({title:n.title}),e[this.type]({dataTextField:"text",dataValueField:"value",dataSource:i,change:function(){a._range=o,s.exec(a,c,this.value())},close:function(){setTimeout(function(){a._deleteSavedRange()},0)},highlightFirst:!1}),e.closest(".k-widget").removeClass("k-"+c).find("*").addBack().attr("unselectable","on"),r=e.data(this.type),r.value("inherit"),r.wrapper.on(m,".k-select,.k-input",function(){var e=a.getRange();o=a._containsRange(e)?e:o}).on(g,function(e){e.keyCode===t.keys.ENTER&&(a._deleteSavedRange(),e.preventDefault())})}}),S=s.extend({init:function(e){s.fn.init.call(this,e),this.format=[{tags:["span","font"]}],this.finder=new w(this.format,e.cssAttr)},options:{palette:"websafe"},update:function(){this._widget.close()},command:function(e){var t=this.options,n=this.format,o={};return new i.FormatCommand(u(e,{formatter:function(){return o[t.domAttr]=e.value,new y(n,{style:o},t.cssAttr)}}))},initialize:function(e,n){var i=n.editor,o=this.name,a=u({},S.fn.options,this.options),l=a.palette,c=a.columns;e=this._widget=new t.ui.ColorPicker(e,{toolIcon:"k-icon k-i-"+r.getToolCssClass(a.name),palette:l,columns:c,change:function(){var t=e.value();t&&s.exec(i,o,t),i.focus()},open:function(e){var t=e.sender;t.value(null),t._popup.element.on(m,p),t._popup.element.is("[unselectable='on']")||t._popup.element.attr({unselectable:"on"}).find("*").attr("unselectable","on")},close:function(e){e.sender._popup.element.off(m)},activate:function(t){t.preventDefault(),e.trigger("change")}}),e.wrapper.attr({title:n.title,unselectable:"on"}).find("*").attr("unselectable","on")}});u(i,{InlineFormatFinder:_,InlineFormatter:b,DelayedExecutionTool:x,GreedyInlineFormatFinder:w,GreedyInlineFormatter:y,InlineFormatTool:k,FontTool:C,ColorTool:S}),f("bold",[{tags:["strong","b"]},{tags:["span"],attr:{style:{fontWeight:"bold"}}}]),h("bold",new k({key:"B",ctrl:!0,format:o.bold,template:new a({template:r.buttonTemplate,title:"Bold"})})),f("italic",[{tags:["em","i"]},{tags:["span"],attr:{style:{fontStyle:"italic"}}}]),h("italic",new k({key:"I",ctrl:!0,format:o.italic,template:new a({template:r.buttonTemplate,title:"Italic"})})),f("underline",[{tags:["span"],attr:{style:{textDecoration:"underline"}}},{tags:["u"]}]),h("underline",new k({key:"U",ctrl:!0,format:o.underline,template:new a({template:r.buttonTemplate,title:"Underline"})})),f("strikethrough",[{tags:["del","strike"]},{tags:["span"],attr:{style:{textDecoration:"line-through"}}}]),h("strikethrough",new k({format:o.strikethrough,template:new a({template:r.buttonTemplate,title:"Strikethrough"})})),f("superscript",[{tags:["sup"]}]),h("superscript",new k({format:o.superscript,template:new a({template:r.buttonTemplate,title:"Superscript"})})),f("subscript",[{tags:["sub"]}]),h("subscript",new k({format:o.subscript,template:new a({template:r.buttonTemplate,title:"Subscript"})})),h("foreColor",new S({cssAttr:"color",domAttr:"color",name:"foreColor",template:new a({template:r.colorPickerTemplate,title:"Color"})})),h("backColor",new S({cssAttr:"background-color",domAttr:"backgroundColor",name:"backColor",template:new a({template:r.colorPickerTemplate,title:"Background Color"})})),h("fontName",new C({cssAttr:"font-family",domAttr:"fontFamily",name:"fontName",defaultValue:[{text:"fontNameInherit",value:"inherit"}],template:new a({template:r.comboBoxTemplate,title:"Font Name"})})),h("fontSize",new C({cssAttr:"font-size",domAttr:"fontSize",name:"fontSize",defaultValue:[{text:"fontSizeInherit",value:"inherit"}],template:new a({template:r.comboBoxTemplate,title:"Font Size"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/link.min",["editor/plugins/inlineformat.min"],e)}(function(){!function(e,t){function n(e,t){for(var n=e.length;n--&&!t.test(e[n]););return n}function i(e,t){var n=t.exec(e);return n?n.index:-1}var o=window.kendo,r=o.Class,s=e.extend,a=e.proxy,l=o.ui.editor,c=l.Dom,d=l.RangeUtils,u=l.EditorUtils,h=l.Command,f=l.Tool,p=l.ToolTemplate,m=l.InlineFormatter,g=l.InlineFormatFinder,v=d.textNodes,_=d.editableTextNodes,b=l.EditorUtils.registerTool,w=o.keys,y="http://",k=/^\w*:\/\//,x=/[\w\/\$\-_\*\?]/i,C=r.extend({findSuitable:function(e){return c.parentOfType(e,["a"])}}),S=r.extend({init:function(){this.finder=new C},apply:function(e,t){var n,i,o,r,s,a,l,u=this.immutables?_(e):v(e);if(t.innerHTML){for(i=d.documentFromRange(e),n=d.getMarkers(e),e.deleteContents(),r=c.create(i,"a",t),e.insertNode(r),s=r.parentNode,"a"==c.name(s)&&c.insertAfter(r,s),c.emptyNode(s)&&c.remove(s),a=r,l=0;l<n.length;l++)c.insertAfter(n[l],a),a=n[l];n.length&&(c.insertBefore(i.createTextNode("\ufeff"),n[1]),c.insertAfter(i.createTextNode("\ufeff"),n[1]),e.setStartBefore(n[0]),e.setEndAfter(n[n.length-1]))}else o=new m([{tags:["a"]}],t),o.finder=this.finder,o.apply(u)}}),T=h.extend({init:function(e){var t=this;e.formatter={toggle:function(e){var n=t.immutables()?_(e):v(e);new m([{tags:["a"]}]).remove(n)}},this.options=e,h.fn.init.call(this,e)}}),D=h.extend({init:function(e){var t;this.options=e,h.fn.init.call(this,e),this.formatter=new S,e.url?this.exec=function(){this.formatter.immutables=t&&t.immutables(),this.formatter.apply(e.range,{href:e.url,innerHTML:e.text||e.url,target:e.target})}:(this.attributes=null,this.async=!0)},_dialogTemplate:function(){return o.template("<div class=\"k-editor-dialog k-popup-edit-form\"><div class=\"k-edit-form-container\"><div class='k-edit-label'><label for='k-editor-link-url'>#: messages.linkWebAddress #</label></div><div class='k-edit-field'><input type='text' class='k-input k-textbox' id='k-editor-link-url'></div><div class='k-edit-label k-editor-link-text-row'><label for='k-editor-link-text'>#: messages.linkText #</label></div><div class='k-edit-field k-editor-link-text-row'><input type='text' class='k-input k-textbox' id='k-editor-link-text'></div><div class='k-edit-label'><label for='k-editor-link-title'>#: messages.linkToolTip #</label></div><div class='k-edit-field'><input type='text' class='k-input k-textbox' id='k-editor-link-title'></div><div class='k-edit-label'></div><div class='k-edit-field'><input type='checkbox' class='k-checkbox' id='k-editor-link-target'><label for='k-editor-link-target' class='k-checkbox-label'>#: messages.linkOpenInNewWindow #</label></div><div class='k-edit-buttons k-state-default'><button class=\"k-dialog-insert k-button k-primary\">#: messages.dialogInsert #</button><button class=\"k-dialog-close k-button\">#: messages.dialogCancel #</button></div></div></div>")({messages:this.editor.options.messages})},exec:function(){var t,n,i,o,r=this.editor.options.messages;this._initialText="",this._range=this.lockRange(!0),this.formatter.immutables=this.immutables(),t=v(this._range),n=t.length?this.formatter.finder.findSuitable(t[0]):null,i=t.length&&"img"==c.name(t[0]),o=this.createDialog(this._dialogTemplate(),{title:r.createLink,close:a(this._close,this),visible:!1}),n&&(this._range.selectNodeContents(n),t=v(this._range)),this._initialText=this.linkText(t),o.find(".k-dialog-insert").click(a(this._apply,this)).end().find(".k-dialog-close").click(a(this._close,this)).end().find(".k-edit-field input").keydown(a(this._keydown,this)).end().find("#k-editor-link-url").val(this.linkUrl(n)).end().find("#k-editor-link-text").val(this._initialText).end().find("#k-editor-link-title").val(n?n.title:"").end().find("#k-editor-link-target").attr("checked",!!n&&"_blank"==n.target).end().find(".k-editor-link-text-row").toggle(!i),this._dialog=o.data("kendoWindow").center().open(),e("#k-editor-link-url",o).focus().select()},_keydown:function(e){var t=o.keys;e.keyCode==t.ENTER?this._apply(e):e.keyCode==t.ESC&&this._close(e)},_apply:function(t){var n,i,o,r=this._dialog.element,s=e("#k-editor-link-url",r).val(),a=e("#k-editor-link-text",r);s&&s!=y&&(s.indexOf("@")>0&&!/^(\w+:)|(\/\/)/i.test(s)&&(s="mailto:"+s),this.attributes={href:s},n=e("#k-editor-link-title",r).val(),n&&(this.attributes.title=n),a.is(":visible")&&(i=a.val(),i||this._initialText?i&&i!==this._initialText&&(this.attributes.innerHTML=c.stripBom(i)):this.attributes.innerHTML=s),o=e("#k-editor-link-target",r).is(":checked"),this.attributes.target=o?"_blank":null,this.formatter.apply(this._range,this.attributes)),this._close(t),this.change&&this.change()},_close:function(e){e.preventDefault(),this._dialog.destroy(),c.windowFromDocument(d.documentFromRange(this._range)).focus(),this.releaseRange(this._range)},linkUrl:function(e){return e?e.getAttribute("href",2):y},linkText:function(e){var t,n="";for(t=0;t<e.length;t++)n+=e[t].nodeValue;return c.stripBom(n||"")},redo:function(){var e=this.lockRange(!0);this.formatter.apply(e,this.attributes),this.releaseRange(e)}}),A=h.extend({init:function(e){h.fn.init.call(this,e),this.formatter=new S},exec:function(){var e,t,n,i=this.detectLink();i&&(e=this.getRange(),t=new o.ui.editor.Marker,n=e.cloneRange(),n.setStart(i.start.node,i.start.offset),n.setEnd(i.end.node,i.end.offset),e=this.lockRange(),t.add(n),this.formatter.apply(n,{href:this._ensureWebProtocol(i.text)}),t.remove(n),this.releaseRange(e))},detectLink:function(){var e,t,n=this.getRange(),i=n.startContainer,o=n.startOffset,r=i.previousSibling;return!r&&(c.isBom(i)&&!i.nextSibling||!o&&c.isDataNode(i))&&(i=i.parentNode,o=0),e=new F({node:i,offset:o,cancelAtNode:function(e){return e&&"a"===c.name(e)}}),t=new I(e),t.detectLink()},changesContent:function(){return!!this.detectLink()},_ensureWebProtocol:function(e){var t=this._hasProtocolPrefix(e);return t?e:this._prefixWithWebProtocol(e)},_hasProtocolPrefix:function(e){return k.test(e)},_prefixWithWebProtocol:function(e){return y+e}}),E=f.extend({init:function(t){this.options=t,this.finder=new g([{tags:["a"]}]),f.fn.init.call(this,e.extend(t,{command:T}))},initialize:function(e,t){f.fn.initialize.call(this,e,t),e.addClass("k-state-disabled")},update:function(e,t){e.toggleClass("k-state-disabled",!this.finder.isFormatted(t)).removeClass("k-state-hover")}}),I=r.extend({init:function(e){this.traverser=e,this.start=M(),this.end=M(),this.text=""},detectLink:function(){var t,n,i,o,r=this.traverser.node,s=this.traverser.offset;
if(c.isDataNode(r)){if(t=r.data.substring(0,s),/\s{2}$/.test(c.stripBom(t)))return}else 0===s&&(n=c.closestEditableOfType(r,c.blockElements),n&&n.previousSibling&&this.traverser.init({node:n.previousSibling}));return this.traverser.traverse(e.proxy(this._detectEnd,this)),this.end.blank()||(this.traverser=this.traverser.clone(this.end),this.traverser.traverse(e.proxy(this._detectStart,this)),this._isLinkDetected()||(i=this.traverser.extendOptions(this.start),o=new z(i),o.traverse(e.proxy(this._skipStartPuntuation,this)),this._isLinkDetected()||(this.start=M()))),this.start.blank()?null:{start:this.start,end:this.end,text:this.text}},_isLinkDetected:function(){return k.test(this.text)||/^w{3}\./i.test(this.text)},_detectEnd:function(e,t){var i=n(e,x);if(i>-1)return this.end.node=t,this.end.offset=i+1,!1},_detectStart:function(e,t){var i=n(e,/\s/),o=i+1;if(this.text=e.substring(o)+this.text,this.start.node=t,this.start.offset=o,i>-1)return!1},_skipStartPuntuation:function(e,t,n){var o=i(e,/\w/),r=o;if(o===-1&&(r=e.length),this.text=this.text.substring(r),this.start.node=t,this.start.offset=r+(0|n),o>-1)return!1}}),M=function(){return{node:null,offset:null,blank:function(){return null===this.node&&null===this.offset}}},R=r.extend({init:function(n){this.node=n.node,this.offset=n.offset===t?c.isDataNode(this.node)&&this.node.length||0:n.offset,this.cancelAtNode=n.cancelAtNode||this.cancelAtNode||e.noop},traverse:function(e){e&&(this.cancel=!1,this._traverse(e,this.node,this.offset))},_traverse:function(e,n,i){var o,r,s,a;if(n&&!this.cancel){if(3!==n.nodeType)return r=this.edgeNode(n),this.cancel=this.cancel||this.cancelAtNode(r),this._traverse(e,r);if(o=n.data,i!==t&&(o=this.subText(o,i)),this.cancel=e(o,n,i)===!1,s=this.next(n),!s)for(a=n.parentNode;!s&&c.isInline(a);)s=this.next(a),a=a.parentNode;this.cancel=this.cancel||this.cancelAtNode(s),this._traverse(e,s)}},extendOptions:function(t){return e.extend({node:this.node,offset:this.offset,cancelAtNode:this.cancelAtNode},t||{})},edgeNode:function(e){},next:function(e){},subText:function(e,t){}}),F=R.extend({subText:function(e,t){return e.substring(0,t)},next:function(e){return e.previousSibling},edgeNode:function(e){return e.lastChild},clone:function(e){var t=this.extendOptions(e);return new F(t)}}),z=R.extend({subText:function(e,t){return e.substring(t)},next:function(e){return e.nextSibling},edgeNode:function(e){return e.firstChild},clone:function(e){var t=this.extendOptions(e);return new z(t)}});s(o.ui.editor,{LinkFormatFinder:C,LinkFormatter:S,UnlinkCommand:T,LinkCommand:D,AutoLinkCommand:A,UnlinkTool:E,DomTextLinkDetection:I,LeftDomTextTraverser:F,RightDomTextTraverser:z}),b("createLink",new f({key:"K",ctrl:!0,command:D,template:new p({template:u.buttonTemplate,title:"Create Link"})})),b("unlink",new E({key:"K",ctrl:!0,shift:!0,template:new p({template:u.buttonTemplate,title:"Remove Link"})})),b("autoLink",new f({key:[w.ENTER,w.SPACEBAR],keyPressCommand:!0,command:A}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/formatblock.min",["editor/plugins/format.min"],e)}(function(){!function(e){var t,n=window.kendo,i=n.Class,o=e.extend,r=n.ui.editor,s=n.ui.Editor.fn.options.formats,a=r.Dom,l=r.ToolTemplate,c=r.FormatTool,d=r.EditorUtils,u=d.registerTool,h=d.registerFormat,f=r.RangeUtils,p=i.extend({init:function(e){this.format=e},contains:function(e,t){var n,i,o;for(n=0,i=t.length;n<i;n++)if(o=t[n],!o||!a.isAncestorOrSelf(e,o))return!1;return!0},findSuitable:function(t){var n,i,o,r,s=this.format,l=[];for(n=0,i=t.length;n<i;n++){for(r=s.length-1;r>=0&&!(o=a.ofType(t[n],s[r].tags)?t[n]:a.closestEditableOfType(t[n],s[r].tags));r--);if(!o||"true"===o.contentEditable)return[];e.inArray(o,l)<0&&l.push(o)}for(this._resolveListsItems(l),n=0,i=l.length;n<i;n++)if(this.contains(l[n],l))return[l[n]];return l},_resolveListsItems:function(e){var t,n,i;for(t=0;t<e.length;t++)n=e[t],i=a.is(n,"li")?n:a.wrapper(n),i=i&&a.list(i)?i.children[0]:i,a.is(i,"li")&&(n=e[t]=i)},findFormat:function(e){var t,n,i,o,s,l,c=this.format,d=a.editableParent(e),u=this.options&&this.options.immutables,h=r.Immutables;for(t=0,n=c.length;t<n;t++){if(i=e,o=c[t].tags,s=c[t].attr,u&&o&&"immutable"==o[0]&&(l=h.immutableParent(i),l&&a.attrEquals(l,s)))return i;for(;i&&a.isAncestorOf(d,i);){if(a.ofType(i,o)&&a.attrEquals(i,s))return i;i=i.parentNode}}return null},getFormat:function(e){var t,n,i=this,o=function(e){return i.findFormat(a.isDataNode(e)?e.parentNode:e)},r=o(e[0]);if(!r)return"";for(t=1,n=e.length;t<n;t++)if(r!=o(e[t]))return"";return r.nodeName.toLowerCase()},isFormatted:function(e){for(var t=0,n=e.length;t<n;t++)if(!this.findFormat(e[t]))return!1;return!0}}),m=i.extend({init:function(e,t){this.format=e,this.values=t,this.finder=new p(e)},wrap:function(e,t,n){var i,o,r,s,l,c=1==n.length?a.blockParentOrBody(n[0]):a.commonAncestor.apply(null,n);for(a.isInline(c)&&(c=a.blockParentOrBody(c)),i=a.significantChildNodes(c),o=a.findNodeIndex(i[0]),r=a.create(c.ownerDocument,e,t),s=0;s<i.length;s++)l=i[s],a.isBlock(l)?(a.attr(l,t),r.childNodes.length&&(a.insertBefore(r,l),r=r.cloneNode(!1)),o=a.findNodeIndex(l)+1):r.appendChild(l);r.firstChild&&a.insertAt(c,r,o)},apply:function(t){function n(e){return o({},e&&e.attr,p)}var i,r,s,l,c,u,h,f,p=this.values;if(this._handleImmutables(t,!0),r=a.filter("img",t),s=d.formatByName("img",this.format),l=n(s),e.each(r,function(){a.attr(this,l)}),r.length!=t.length)if(c=a.filter("img",t,!0),u=this.finder.findSuitable(c),u.length)for(h=0,f=u.length;h<f;h++)i=d.formatByName(a.name(u[h]),this.format),a.attr(u[h],n(i));else i=this.format[0],this.wrap(i.tags[0],n(i),c)},_handleImmutables:function(e,t){var n,i,o,s,l;if(this.immutables()&&(n=d.formatByName("immutable",this.format)))for(i=r.Immutables,o=e.length-1,s=o;s>=0;s--)l=i.immutableParent(e[s]),l&&(l!==e[s+1]&&(t?a.attr(l,n.attr):a.unstyle(l,n.attr.style)),e.splice(s,1))},immutables:function(){return this.editor&&this.editor.options.immutables},remove:function(e){var t,n,i,o,r;for(this._handleImmutables(e,!1),t=0,n=e.length;t<n;t++)i=this.finder.findFormat(e[t]),i&&(r=a.name(i),"div"!=r||i.getAttribute("class")?(o=d.formatByName(r,this.format),o.attr.style&&a.unstyle(i,o.attr.style),o.attr.className&&a.removeClass(i,o.attr.className)):a.unwrap(i))},toggle:function(e){var t=this,n=a.filterBy(f.nodes(e),a.htmlIndentSpace,!0);t.finder.isFormatted(n)?t.remove(n):t.apply(n)}}),g=i.extend({init:function(e,t){var n=this;n.format=e,n.values=t,n.finder=new p(e)},apply:function(e){var t,n,i,o,s,l,c,d,u,h,f=this.format,p=a.blockParents(e),g=f[0].tags[0];if(p.length)for(t=0,n=p.length;t<n;t++)d=p[t],u=this.immutables()&&r.Immutables.immutableParent(d),u||(c=a.name(d),"li"==c?(i=d.parentNode,o=new r.ListFormatter(i.nodeName.toLowerCase(),g),s=this.editor.createRange(),s.selectNode(p[t]),o.toggle(s)):g&&("td"==c||d.attributes.contentEditable)?new m(f,this.values).apply(d.childNodes):(l=a.changeTag(d,g),a.attr(l,f[0].attr)));else h=new m(f,this.values),h.editor=this.editor,h.apply(e)},toggle:function(e){var t=f.textNodes(e);t.length||(e.selectNodeContents(e.commonAncestorContainer),t=f.textNodes(e),t.length||(t=a.significantChildNodes(e.commonAncestorContainer))),this.apply(t)},immutables:function(){return this.editor&&this.editor.options.immutables}}),v=c.extend({init:function(e){c.fn.init.call(this,o(e,{finder:new p(e.format),formatter:function(){return new m(e.format)}}))}});o(r,{BlockFormatFinder:p,BlockFormatter:m,GreedyBlockFormatter:g,BlockFormatTool:v}),t=["ul","ol","li"],h("justifyLeft",[{tags:a.nonListBlockElements,attr:{style:{textAlign:"left"}}},{tags:["img"],attr:{style:{"float":"left",display:"",marginLeft:"",marginRight:""}}},{tags:["immutable"],attr:{style:{"float":"left",display:"",marginLeft:"",marginRight:""}}},{tags:t,attr:{style:{textAlign:"left",listStylePosition:""}}}]),u("justifyLeft",new v({format:s.justifyLeft,template:new l({template:d.buttonTemplate,title:"Justify Left"})})),h("justifyCenter",[{tags:a.nonListBlockElements,attr:{style:{textAlign:"center"}}},{tags:["img"],attr:{style:{display:"block",marginLeft:"auto",marginRight:"auto","float":""}}},{tags:["immutable"],attr:{style:{display:"block",marginLeft:"auto",marginRight:"auto","float":""}}},{tags:t,attr:{style:{textAlign:"center",listStylePosition:"inside"}}}]),u("justifyCenter",new v({format:s.justifyCenter,template:new l({template:d.buttonTemplate,title:"Justify Center"})})),h("justifyRight",[{tags:a.nonListBlockElements,attr:{style:{textAlign:"right"}}},{tags:["img"],attr:{style:{"float":"right",display:"",marginLeft:"",marginRight:""}}},{tags:["immutable"],attr:{style:{"float":"right",display:"",marginLeft:"",marginRight:""}}},{tags:t,attr:{style:{textAlign:"right",listStylePosition:"inside"}}}]),u("justifyRight",new v({format:s.justifyRight,template:new l({template:d.buttonTemplate,title:"Justify Right"})})),h("justifyFull",[{tags:a.nonListBlockElements,attr:{style:{textAlign:"justify"}}},{tags:["img"],attr:{style:{display:"block",marginLeft:"auto",marginRight:"auto","float":""}}},{tags:["immutable"],attr:{style:{display:"block",marginLeft:"auto",marginRight:"auto","float":""}}},{tags:t,attr:{style:{textAlign:"justify",listStylePosition:""}}}]),u("justifyFull",new v({format:s.justifyFull,template:new l({template:d.buttonTemplate,title:"Justify Full"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/lists.min",["editor/plugins/formatblock.min"],e)}(function(){!function(e){var t=window.kendo,n=t.Class,i=e.extend,o=t.ui.editor,r=o.Dom,s=o.RangeUtils,a=o.EditorUtils,l=o.Command,c=o.ToolTemplate,d=o.FormatTool,u=o.BlockFormatFinder,h=s.textNodes,f=o.EditorUtils.registerTool,p=u.extend({init:function(e){this.tag=e;var t=this.tags=["ul"==e?"ol":"ul",e];u.fn.init.call(this,[{tags:t}])},isFormatted:function(e){var t,n,i=[];for(n=0;n<e.length;n++)t=this.findFormat(e[n]),t&&r.name(t)==this.tag&&i.push(t);if(i.length<1)return!1;if(i.length!=e.length)return!1;for(n=0;n<i.length&&i[n].parentNode==t.parentNode;n++)if(i[n]!=t)return!1;return!0},findSuitable:function(e){var t=this.findFormat(e[0]);return t&&r.name(t)==this.tag?t:null}}),m=n.extend({init:function(e,t){var n=this;n.finder=new p(e),n.tag=e,n.unwrapTag=t},isList:function(e){return r.list(e)},immutables:function(){return this.editor&&!!this.editor.options.immutables},wrap:function(t,n){var i,s,a=r.create(t.ownerDocument,"li"),l=this.immutables()?o.Immutables.immutable:e.noop;for(i=0;i<n.length;i++)if(s=n[i],r.is(s,"li"))t.appendChild(s);else if(this.isList(s))for(;s.firstChild;)t.appendChild(s.firstChild);else if(r.is(s,"td")){for(;s.firstChild;)a.appendChild(s.firstChild);t.appendChild(a),s.appendChild(t),t=t.cloneNode(!1),a=a.cloneNode(!1)}else a.appendChild(s),r.isBlock(s)&&(t.appendChild(a),l(s)||r.unwrap(s),a=a.cloneNode(!1));a.firstChild&&t.appendChild(a)},containsAny:function(e,t){for(var n=0;n<t.length;n++)if(r.isAncestorOrSelf(e,t[n]))return!0;return!1},suitable:function(e,t){if("k-marker"==e.className){var n=e.nextSibling;if(n&&r.isBlock(n))return!1;if(n=e.previousSibling,n&&r.isBlock(n))return!1}return this.containsAny(e,t)||r.isInline(e)||3==e.nodeType},_parentLists:function(t){var n=r.closestEditable(t);return e(t).parentsUntil(n,"ul,ol")},split:function(e){var t,n,i,o,a,l,c=h(e);if(c.length)for(t=r.parentOfType(c[0],["li"]),n=r.parentOfType(c[c.length-1],["li"]),e.setStartBefore(t),e.setEndAfter(n),o=0,a=c.length;o<a;o++)l=this.finder.findFormat(c[o]),l&&(i=this._parentLists(l),i.length?s.split(e,i.last()[0],!0):s.split(e,l,!0))},merge:function(e,t){for(var n,i=t.previousSibling;i&&("k-marker"==i.className||3==i.nodeType&&r.isWhitespace(i));)i=i.previousSibling;if(i&&r.name(i)==e){for(;t.firstChild;)i.appendChild(t.firstChild);r.remove(t),t=i}for(n=t.nextSibling;n&&("k-marker"==n.className||3==n.nodeType&&r.isWhitespace(n));)n=n.nextSibling;if(n&&r.name(n)==e){for(;t.lastChild;)n.insertBefore(t.lastChild,n.firstChild);r.remove(t)}},breakable:function(e){return e!=e.ownerDocument.body&&!/table|tbody|tr|td/.test(r.name(e))&&!e.attributes.contentEditable},applyOnSection:function(t,n){function i(){u.push(this)}var o,s,a,l,c=this.tag,d=r.closestSplittableParent(n),u=[],h=this.finder.findSuitable(n);for(h||(h=new p("ul"==c?"ol":"ul").findSuitable(n)),/table|tbody/.test(r.name(d))?o=e.map(n,function(e){return r.parentOfType(e,["td"])}):(o=r.significantChildNodes(d),e.grep(o,r.isBlock).length&&(o=e.grep(o,e.proxy(function(e){return this.containsAny(e,n)},this))),o.length||(o=n)),s=0;s<o.length;s++)a=o[s],l=(!h||!r.isAncestorOrSelf(h,a))&&this.suitable(a,n),l&&(h&&this.isList(a)?(e.each(a.children,i),r.remove(a)):u.push(a));for(u.length==o.length&&this.breakable(d)&&(u=[d]),h||(h=r.create(d.ownerDocument,c),r.insertBefore(h,u[0])),this.wrap(h,u);r.isBom(h.nextSibling);)r.remove(h.nextSibling);r.is(h,c)||r.changeTag(h,c),this.merge(c,h)},apply:function(t){function n(){i&&d.push({section:i,nodes:s})}var i,s,a,l,c=0,d=[],u=t.length,h=this.immutables()?o.Immutables.immutableParent:e.noop;for(c=0;c<u;c++)l=h(t[c])||t[c],a=r.closestEditable(l,["td","body"]),i&&a==i?s.push(l):(n(),s=[l],i=a);for(n(),c=0;c<d.length;c++)this.applyOnSection(d[c].section,d[c].nodes)},unwrap:function(e){var t,n,i,o,s=e.ownerDocument.createDocumentFragment(),a=this.unwrapTag;for(n=e.firstChild;n;n=n.nextSibling){for(i=r.create(e.ownerDocument,a||"p");n.firstChild;)o=n.firstChild,r.isBlock(o)?(i.firstChild&&(s.appendChild(i),i=r.create(e.ownerDocument,a||"p")),s.appendChild(o)):i.appendChild(o);i.firstChild&&s.appendChild(i)}t=this._parentLists(e),t[0]?(r.insertAfter(s,t.last()[0]),t.last().remove()):r.insertAfter(s,e),r.remove(e)},remove:function(e){var t,n,i;for(n=0,i=e.length;n<i;n++)t=this.finder.findFormat(e[n]),t&&this.unwrap(t)},toggle:function(e){var t,n=this,i=h(e),o=e.commonAncestorContainer;i.length||(e.selectNodeContents(o),i=h(e),i.length||(t=o.ownerDocument.createTextNode(""),e.startContainer.appendChild(t),i=[t],e.selectNode(t.parentNode))),i=r.filterBy(i,r.htmlIndentSpace,!0),n.finder.isFormatted(i)?(n.split(e),n.remove(i)):n.apply(i)}}),g=l.extend({init:function(e){e.formatter=new m(e.tag),l.fn.init.call(this,e)}}),v=d.extend({init:function(e){this.options=e,d.fn.init.call(this,i(e,{finder:new p(e.tag)}))},command:function(e){return new g(i(e,{tag:this.options.tag}))}});i(o,{ListFormatFinder:p,ListFormatter:m,ListCommand:g,ListTool:v}),f("insertUnorderedList",new v({tag:"ul",template:new c({template:a.buttonTemplate,title:"Insert unordered list"})})),f("insertOrderedList",new v({tag:"ol",template:new c({template:a.buttonTemplate,title:"Insert ordered list"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/formatting.min",["editor/plugins/inlineformat.min"],e)}(function(){!function(e){function t(e){var t,o,r=l.closestEditableOfType(e,["li"]);r&&(t=new i.ListFormatter(l.name(r.parentNode)),o=n.ui.editor.W3CRange.fromNode(e),o.selectNode(r),t.toggle(o))}var n=window.kendo,i=n.ui.editor,o=i.Tool,r=i.ToolTemplate,s=i.DelayedExecutionTool,a=i.Command,l=i.Dom,c=i.EditorUtils,d=i.RangeUtils,u=c.registerTool,h=s.extend({init:function(e){var t=this;o.fn.init.call(t,n.deepExtend({},t.options,e)),t.type="kendoSelectBox",t.finder={getFormat:function(){return""}}},options:{items:[{text:"Paragraph",value:"p"},{text:"Quotation",value:"blockquote"},{text:"Heading 1",value:"h1"},{text:"Heading 2",value:"h2"},{text:"Heading 3",value:"h3"},{text:"Heading 4",value:"h4"},{text:"Heading 5",value:"h5"},{text:"Heading 6",value:"h6"}],width:110},toFormattingItem:function(e){var t,n=e.value;return n?e.tag||e.className?e:(t=n.indexOf("."),0===t?e.className=n.substring(1):t==-1?e.tag=n:(e.tag=n.substring(0,t),e.className=n.substring(t+1)),e):e},command:function(t){var n=this,o=t.value;return o=this.toFormattingItem(o),new i.FormatCommand({range:t.range,formatter:function(){var t,r=(o.tag||o.context||"span").split(","),s=[{tags:r,attr:{className:o.className||""}}];return t=e.inArray(r[0],l.inlineElements)>=0?new i.GreedyInlineFormatter(s):new i.GreedyBlockFormatter(s),t.editor=n.editor,t}})},initialize:function(e,t){var i=t.editor,r=this.options,s=r.name,a=this;a.editor=i,e.width(r.width),e.kendoSelectBox({dataTextField:"text",dataValueField:"value",dataSource:r.items||i.options[s],title:i.options.messages[s],autoSize:!0,change:function(){var e=this.dataItem();e&&o.exec(i,s,e.toJSON())},dataBound:function(){var e,t=this.dataSource.data();for(e=0;e<t.length;e++)t[e]=a.toFormattingItem(t[e])},highlightFirst:!1,template:n.template('<span unselectable="on" style="display:block;#=(data.style||"")#">#:data.text#</span>')}),e.addClass("k-decorated").closest(".k-widget").removeClass("k-"+s).find("*").addBack().attr("unselectable","on")},getFormattingValue:function(t,n){var i,o,r,s,a,l,c;for(i=0;i<t.length;i++)if(o=t[i],r=o.tag||o.context||"",s=o.className?"."+o.className:"",a=r+s,l=e(n[0]).closest(a)[0]){if(1==n.length)return o.value;for(c=1;c<n.length&&e(n[c]).closest(a)[0];c++)if(c==n.length-1)return o.value}return""},update:function(t,n){var i,o,r,a,c,d=e(t).data(this.type);if(d&&(i=d.dataSource,o=i.data(),c=l.commonAncestor.apply(null,n),c==l.closestEditable(c)||this._ancestor!=c)){for(this._ancestor=c,r=0;r<o.length;r++)a=o[r].context,o[r].visible=!a||!!e(c).closest(a).length;i.filter([{field:"visible",operator:"eq",value:!0}]),s.fn.update.call(this,t,n),d.value(this.getFormattingValue(i.view(),n)),d.wrapper.toggleClass("k-state-disabled",!i.view().length)}},destroy:function(){this._ancestor=null}}),f=a.extend({exec:function(){var e,t,n,i=this.lockRange(!0);for(this.tagsToClean=this.options.remove||"strong,em,span,sup,sub,del,b,i,u,font".split(","),d.wrapSelectedElements(i),e=d.mapAll(i,function(e){return e}),t=e.length-1;t>=0;t--)n=e[t],this.immutableParent(n)||this.clean(n);this.releaseRange(i)},clean:function(n){var o,r,s,a,c;if(n&&!l.isMarker(n)){if(o=l.name(n),"ul"==o||"ol"==o)for(r=new i.ListFormatter(o),s=n.previousSibling,a=n.nextSibling,r.unwrap(n);s&&s!=a;s=s.nextSibling)this.clean(s);else if("blockquote"==o)l.changeTag(n,"p");else if(1!=n.nodeType||l.insignificant(n))t(n);else{for(c=n.childNodes.length-1;c>=0;c--)this.clean(n.childNodes[c]);n.removeAttribute("style"),n.removeAttribute("class")}e.inArray(o,this.tagsToClean)>-1&&l.unwrap(n)}},immutableParent:function(e){return this.immutables()&&i.Immutables.immutableParent(e)}});e.extend(i,{FormattingTool:h,CleanFormatCommand:f}),u("formatting",new h({template:new r({template:c.dropDownListTemplate,title:"Format"})})),u("cleanFormatting",new o({command:f,template:new r({template:c.buttonTemplate,title:"Clean formatting"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/image.min",["kendo.imagebrowser.min","editor/command.min"],e)}(function(){!function(e,t){var n=window.kendo,i=e.extend,o=n.ui.editor,r=o.EditorUtils,s=o.Dom,a=r.registerTool,l=o.ToolTemplate,c=o.RangeUtils,d=o.Command,u=n.keys,h="#k-editor-image-url",f="#k-editor-image-title",p="#k-editor-image-width",m="#k-editor-image-height",g=d.extend({init:function(e){var t=this;d.fn.init.call(t,e),t.async=!0,t.attributes={}},insertImage:function(e,t){var n,i=this.attributes,o=c.documentFromRange(t);if(i.src&&"http://"!=i.src){if(n=function(){setTimeout(function(){i.width||e.removeAttribute("width"),i.height||e.removeAttribute("height"),e.removeAttribute("complete")})},!e)return e=s.create(o,"img",i),e.onload=e.onerror=n,t.deleteContents(),t.insertNode(e),e.nextSibling||s.insertAfter(o.createTextNode("\ufeff"),e),n(),t.setStartAfter(e),t.setEndAfter(e),c.selectRange(t),!0;e.onload=e.onerror=n,s.attr(e,i),n()}return!1},_dialogTemplate:function(e){return n.template('<div class="k-editor-dialog k-popup-edit-form"><div class="k-edit-form-container"><div class="k-edit-form-content"># if (showBrowser) { #<div class="k-filebrowser k-imagebrowser"></div># } #<div class=\'k-edit-label\'><label for="k-editor-image-url">#: messages.imageWebAddress #</label></div><div class=\'k-edit-field\'><input type="text" class="k-input k-textbox" id="k-editor-image-url"></div><div class=\'k-edit-label\'><label for="k-editor-image-title">#: messages.imageAltText #</label></div><div class=\'k-edit-field\'><input type="text" class="k-input k-textbox" id="k-editor-image-title"></div><div class=\'k-edit-label\'><label for="k-editor-image-width">#: messages.imageWidth #</label></div><div class=\'k-edit-field\'><input type="text" class="k-input k-textbox" id="k-editor-image-width"></div><div class=\'k-edit-label\'><label for="k-editor-image-height">#: messages.imageHeight #</label></div><div class=\'k-edit-field\'><input type="text" class="k-input k-textbox" id="k-editor-image-height"></div></div><div class="k-edit-buttons k-state-default"><button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button><button class="k-dialog-close k-button">#: messages.dialogCancel #</button></div></div></div>')({messages:this.editor.options.messages,showBrowser:e})},redo:function(){var e=this,t=e.lockRange();e.insertImage(c.image(t),t)||e.releaseRange(t)},exec:function(){function e(e){var t=a.element,n=parseInt(t.find(p).val(),10),i=parseInt(t.find(m).val(),10);g.attributes={src:t.find(h).val().replace(/ /g,"%20"),alt:t.find(f).val()},g.attributes.width=null,g.attributes.height=null,!isNaN(n)&&n>0&&(g.attributes.width=n),!isNaN(i)&&i>0&&(g.attributes.height=i),_=g.insertImage(b,v),o(e),g.change&&g.change()}function o(e){e.preventDefault(),a.destroy(),s.windowFromDocument(c.documentFromRange(v)).focus(),_||g.releaseRange(v)}function r(t){t.keyCode==u.ENTER?e(t):t.keyCode==u.ESC&&o(t)}var a,l,d,g=this,v=g.lockRange(),_=!1,b=c.image(v),w=b&&b.getAttribute("width")||"",y=b&&b.getAttribute("height")||"",k=n.support.browser.msie,x=g.editor.options,C=x.messages,S=x.imageBrowser,T=!!(n.ui.ImageBrowser&&S&&S.transport&&S.transport.read!==t),D={title:C.insertImage,visible:!1,resizable:T};this.expandImmutablesIn(v),D.close=o,T&&(D.width=750),a=this.createDialog(g._dialogTemplate(T),D).toggleClass("k-filebrowser-dialog",T).find(".k-dialog-insert").click(e).end().find(".k-dialog-close").click(o).end().find(".k-edit-field input").keydown(r).end().find(h).val(b?b.getAttribute("src",2):"http://").end().find(f).val(b?b.alt:"").end().find(p).val(w).end().find(m).val(y).end().data("kendoWindow"),l=a.element,T&&(this._imageBrowser=new n.ui.ImageBrowser(l.find(".k-imagebrowser"),i({},S)),this._imageBrowser.bind("change",function(e){"f"===e.selected.get("type")&&l.find(h).val(this.value())}),this._imageBrowser.bind("apply",e)),k&&(d=l.closest(".k-window").height(),l.css("max-height",d)),a.center().open(),l.find(h).focus().select()}});n.ui.editor.ImageCommand=g,a("insertImage",new o.Tool({command:g,template:new l({template:r.buttonTemplate,title:"Insert Image"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/import.min",["editor/main.min"],e)}(function(){!function(e,t){var n=window.kendo,i=e.extend,o=e.proxy,r=n.ui.editor,s=r.EditorUtils,a=r.Command,l=r.Tool,c=s.registerTool,d=r.ToolTemplate,u='<div contenteditable="false" class="k-loading-mask" style="width: 100%; height: 100%; position: absolute; top: 0px; left: 0px;"><div class="k-loading-image"></div><div class="k-loading-color"></div></div>',h=a.extend({exec:function(){(this.editor._uploadWidget||this._initializeUploadWidget()).element.click()},_initializeUploadWidget:function(){var t=this,n=t.editor,i=n.options["import"],r=e('<input id="editorImport" name="files" type="file" />').kendoUpload({success:o(t._onUploadSuccess,t),progress:o(t._onUploadProgress,t),select:o(t._onUploadSelect,t),error:o(t._onUploadError,t),complete:o(t._onUploadComplete,t),showFileList:!1,multiple:!1,async:{saveUrl:i.proxyUrl,autoUpload:!0,saveField:"file"},validation:{allowedExtensions:i.allowedExtensions,maxFileSize:i.maxFileSize}}).getKendoUpload();return n._uploadWidget=r,r},_onUploadComplete:function(e){this._trigger("complete",e),e.sender.clearAllFiles(),this._removeLoadingOverlay()},_onUploadSuccess:function(e){this.editor.value(e.response.html.replace(/<\/?body>/gi,"")),this._trigger("success",e)},_onUploadProgress:function(e){this._trigger("progress",e)},_onUploadSelect:function(e){this._trigger("select",e),e.files[0].validationErrors||this._initLoadingOverlay()},_onUploadError:function(e){this._trigger("error",e)},_trigger:function(e,t){var n=this.editor,i=n.options["import"];"function"==typeof i[e]&&i[e].call(n,t)},_initLoadingOverlay:function(){var t=this.editor.body;r.Dom.is(t,"body")?this._iframeWrapper=this._container=this.editor.wrapper.find("iframe").parent().css({position:"relative"}).append(u):this._container=e(t).append(u),n.ui.progress(this._container,!0)},_removeLoadingOverlay:function(){n.ui.progress(this._container,!1),e(this._iframeWrapper).css({position:""}),delete this._container,delete this._iframeWrapper}});i(r,{ImportCommand:h}),c("import",new l({command:h,template:new d({template:s.buttonTemplate,title:"Import"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/insert.min",["editor/command.min"],e)}(function(){!function(e){var t=window.kendo,n=t.ui.editor,i=n.Command,o=n.GenericCommand,r=n.EditorUtils,s=r.registerTool,a=n.Tool,l=n.ToolTemplate,c=n.RestorePoint,d=e.extend,u=i.extend({init:function(e){i.fn.init.call(this,e),this.managesUndoRedo=!0},exec:function(){var e,t=this.editor,n=this.options,i=n.range,r=t.body,s=new c(i,r),a=n.html||n.value||"";t.selectRange(i),t.clipboard.paste(a,n),n.postProcess&&n.postProcess(t,t.getRange()),e=new o(s,new c(t.getRange(),r)),e.editor=t,t.undoRedoStack.push(e),t.focus()}}),h=a.extend({initialize:function(e,t){var i=t.editor,o=this.options,r=o.items?o.items:i.options.insertHtml;this._selectBox=new n.SelectBox(e,{dataSource:r,dataTextField:"text",dataValueField:"value",change:function(){a.exec(i,"insertHtml",this.value())},title:i.options.messages.insertHtml,highlightFirst:!1})},command:function(e){return new u(e)},update:function(e){var t=e.data("kendoSelectBox")||e.find("select").data("kendoSelectBox");t.close(),t.value(t.options.title)}});d(n,{InsertHtmlCommand:u,InsertHtmlTool:h}),s("insertHtml",new h({template:new l({template:r.dropDownListTemplate,title:"Insert HTML",initialValue:"Insert HTML"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/export.min",["editor/main.min"],e)}(function(){!function(e,t){var n=window.kendo,i=e.extend,o=e.proxy,r=n.ui.editor,s=r.EditorUtils,a=r.Command,l=r.Tool,c=s.registerTool,d=r.ToolTemplate,u=[{text:"Docx",value:"docx"},{text:"Rtf",value:"rtf"},{text:"Pdf",value:"pdf"},{text:"Html",value:"html"},{text:"Plain Text",value:"txt"}],h=a.extend({init:function(e){var t=this;t.options=e,a.fn.init.call(t,e),t.attributes=null,t.exportType=e.exportType},exec:function(){var e=this,t=this.lockRange(!0);e.postToProxy(),e.releaseRange(t)},postToProxy:function(){this.generateForm().appendTo("body").submit().remove()},generateForm:function(){var t=this,n=t.editor.options.exportAs,i=e("<form>").attr({action:n&&n.proxyURL||"",method:"POST"});return i.append([t.valueInput(),t.exportTypeInput(),t.fileNameInput()]),i},valueInput:function(){var t=this.editor;return e("<input>").attr({value:t.encodedValue(),name:"value",type:"hidden"})},exportTypeInput:function(){var t=this;return e("<input>").attr({value:t.exportType,name:"exportType",type:"hidden"})},fileNameInput:function(){var t=this.editor,n=t.options.exportAs,i=n&&n.fileName||t.element.attr("id")||"editor";return e("<input>").attr({value:i,name:"fileName",type:"hidden"})}}),f=l.extend({init:function(e){var t=this;l.fn.init.call(t,n.deepExtend({},t.options,e)),t.type="kendoSelectBox"},options:{items:u,width:115},command:function(e){var t=e.value;return new r.ExportAsCommand({range:e.range,exportType:t.exportType})},initialize:function(e,t){var i=this,r=t.editor,s=i.options,a=s.name,l=o(i.changeHandler,i),c=s.items||r.options[a];c.unshift({text:r.options.messages[a],value:""}),i.editor=r,e.width(s.width),e.kendoSelectBox({dataTextField:"text",dataValueField:"value",dataSource:c,autoSize:!0,change:l,open:function(e){var t=e.sender;t.items()[0].style.display="none",t.unbind("open")},highlightFirst:!1,template:n.template('<span unselectable="on" style="display:block;#=(data.style||"")#">#:data.text#</span>')}),e.addClass("k-decorated").closest(".k-widget").removeClass("k-"+a).find("*").addBack().attr("unselectable","on")},changeHandler:function(e){var t=e.sender,n=t.dataItem(),i=n&&n.value;this._exec(i),t.value("")},_exec:function(e){e&&l.exec(this.editor,this.options.name,{exportType:e})},destroy:function(){this._ancestor=null}});i(r,{ExportAsTool:f,ExportAsCommand:h}),c("exportAs",new f({template:new d({template:s.dropDownListTemplate,title:"Export As"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/indent.min",["editor/plugins/formatblock.min"],e)}(function(){!function(e,t){function n(n,i){var o="rtl"==e(n).css("direction"),r=o?"Right":"Left",s="td"!=a.name(n)?"margin"+r:"padding"+r;return i===t?n.style[s]||0:(i>0?n.style[s]=i+"px":(n.style[s]="",n.style.cssText||n.removeAttribute("style")),t)}var i=window.kendo,o=i.Class,r=e.extend,s=i.ui.editor,a=s.Dom,l=s.EditorUtils,c=l.registerTool,d=s.Command,u=s.Tool,h=s.ToolTemplate,f=s.RangeUtils,p=a.blockElements,m=s.BlockFormatFinder,g=s.BlockFormatter,v=o.extend({init:function(){this.finder=new m([{tags:a.blockElements}])},apply:function(t){var i,o,r,s,l,c,d,u,h,f,p,m;if(t=a.filterBy(t,a.htmlIndentSpace,!0),i=this.finder.findSuitable(t),o=[],i=this.mapImmutables(i),i.length){for(r=0,s=i.length;r<s;r++)a.is(i[r],"li")?e(i[r]).index()?e.inArray(i[r].parentNode,o)<0&&o.push(i[r]):o.push(i[r].parentNode):o.push(i[r]);for(;o.length;)if(l=o.shift(),a.is(l,"li"))if(c=l.parentNode,d=e(l).prev("li"),u=d.find("ul,ol").last(),h=e(l).children("ul,ol")[0],h&&d[0])u[0]?(u.append(l),u.append(e(h).children()),a.remove(h)):(d.append(h),h.insertBefore(l,h.firstChild));else for(h=d.children("ul,ol")[0],h||(h=a.create(l.ownerDocument,a.name(c)),d.append(h));l&&l.parentNode==c;)h.appendChild(l),l=o.shift();else for(f=parseInt(n(l),10)+30,n(l,f),p=0;p<o.length;p++)e.contains(l,o[p])&&o.splice(p,1)}else m=new g([{tags:["p"]}],{style:{marginLeft:30}}),m.apply(t)},mapImmutables:function(t){if(this.immutables){var n=[];return e.map(t,function(t){var i=s.Immutables.immutableParent(t);if(i){if(e.inArray(i,n)!==-1)return null;n.push(i)}return i||t})}return t},remove:function(t){t=a.filterBy(t,a.htmlIndentSpace,!0);var i,o,r,s,l,c,d,u,h=this.finder.findSuitable(t);for(h=this.mapImmutables(h),o=0,r=h.length;o<r;o++){if(d=e(h[o]),d.is("li")){if(s=d.parent(),l=s.parent(),l.is("li,ul,ol")&&!n(s[0])){if(i&&e.contains(i,l[0]))continue;c=d.nextAll("li"),c.length&&e(s[0].cloneNode(!1)).appendTo(d).append(c),l.is("li")?d.insertAfter(l):d.appendTo(l),s.children("li").length||s.remove();continue}if(i==s[0])continue;i=s[0]}else i=h[o];u=parseInt(n(i),10)-30,n(i,u)}}}),_=d.extend({init:function(t){var n=this;t.formatter={toggle:e.proxy(function(e){var t=new v;t.immutables=this.editor&&this.editor.options.immutables,t.apply(f.nodes(e))},n)},d.fn.init.call(this,t)}}),b=d.extend({init:function(t){var n=this;t.formatter={toggle:e.proxy(function(e){var t=new v;t.immutables=this.editor&&this.editor.options.immutables,t.remove(f.nodes(e))},n)},d.fn.init.call(this,t)}}),w=u.extend({init:function(e){u.fn.init.call(this,e),this.finder=new m([{tags:p}])},initialize:function(t,n){u.fn.initialize.call(this,t,n),e.extend(this.options,{immutables:n.editor&&n.editor.options.immutables}),t.addClass("k-state-disabled")},update:function(i,o){
var r,l,c,d,u,h,f=this.finder.findSuitable(o);for(c=0,d=f.length;c<d;c++)if(u=f[c],this.options.immutables&&(h=s.Immutables.immutableParent(u),h&&(u=h)),r=n(u),r||(l=e(u).parents("ul,ol").length,r=a.is(u,"li")&&(l>1||n(u.parentNode))||a.ofType(u,["ul","ol"])&&l>0),r)return i.removeClass("k-state-disabled"),t;i.addClass("k-state-disabled").removeClass("k-state-hover")}});r(s,{IndentFormatter:v,IndentCommand:_,OutdentCommand:b,OutdentTool:w}),c("indent",new u({command:_,template:new h({template:l.buttonTemplate,title:"Indent"})})),c("outdent",new w({command:b,template:new h({template:l.buttonTemplate,title:"Outdent"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/linebreak.min",["editor/plugins/formatblock.min"],e)}(function(){!function(e){var t=window.kendo,n=e.extend,i=t.ui.editor,o=i.Dom,r=i.Command,s=i.Tool,a=i.BlockFormatter,l=o.normalize,c=i.RangeUtils,d=i.EditorUtils.registerTool,u=r.extend({init:function(e){this.options=e,r.fn.init.call(this,e)},_insertMarker:function(e,t){var n,i=o.create(e,"a");return i.className="k-marker",t.insertNode(i),i.parentNode||(n=t.commonAncestorContainer,n.innerHTML="",n.appendChild(i)),l(i.parentNode),i},_moveFocus:function(e,t){var n,i;if(o.isEmpty(t))e.setStartBefore(t);else{if(e.selectNodeContents(t),n=c.textNodes(e)[0],!n){for(;t.childNodes.length&&!o.is(t.firstChild,"br");)t=t.firstChild;n=t}o.isEmpty(n)?e.setStartBefore(n):(o.emptyNode(n)&&(n.innerHTML="\ufeff"),i=n.firstChild||n,o.isDataNode(i)?e.setStart(i,0):e.setStartBefore(i))}},shouldTrim:function(e){var t="p,h1,h2,h3,h4,h5,h6".split(","),n=o.parentOfType(e.startContainer,t),i=o.parentOfType(e.endContainer,t);return n&&!i||!n&&i},_blankAfter:function(e){for(;e&&(o.isMarker(e)||""===o.stripBom(e.nodeValue));)e=e.nextSibling;return!e},exec:function(){var t,n,r,s,d,u,h,f,p,m,g,v,_,b,w=this.getRange(),y=c.documentFromRange(w),k=i.emptyElementContent;this.expandImmutablesIn(w),m=this.shouldTrim(w),w.deleteContents(),d=this._insertMarker(y,w),o.stripBomNode(d.previousSibling),o.stripBomNode(d.nextSibling),u=o.closestEditableOfType(d,["li"]),h=o.closestEditableOfType(d,"h1,h2,h3,h4,h5,h6".split(",")),f=o.is(d.parentNode,"table")&&d.parentNode,u?o.emptyNode(u)&&(s=o.create(y,"p"),o.next(u)&&(p=w.cloneRange(),p.selectNode(u),c.split(p,u.parentNode)),g=e("br",u),1==g.length&&g.remove(),v=u.parentNode,_=u.parentNode.children.length,b=_>1&&1==u.childNodes.length&&u.children[0],o.insertAfter(s,v),o.remove(1==_?u.parentNode:u),b&&b!==d?(s.appendChild(b),s.appendChild(d)):s.innerHTML=k,r=s):h&&this._blankAfter(d)?(s=this._insertParagraphAfter(h),o.remove(d),r=s):f&&(s=this._insertParagraphAfter(f),o.remove(d),r=s),r||(u||h||new a([{tags:["p"]}]).apply([d]),w.selectNode(d),t=o.parentOfType(d,[u?"li":h?o.name(h):"p"]),c.split(w,t,m),n=t.previousSibling,o.is(n,"li")&&n.firstChild&&!o.is(n.firstChild,"br")&&(n=n.firstChild),r=t.nextSibling,this.clean(n,{links:!0}),this.clean(r,{links:!0}),o.is(r,"li")&&r.firstChild&&!o.is(r.firstChild,"br")&&(r=r.firstChild),o.remove(t),l(n)),l(r),this._moveFocus(w,r),w.collapse(!0),o.scrollTo(r,!0),c.selectRange(w)},_insertParagraphAfter:function(e){var t=this.getRange(),n=c.documentFromRange(t),r=i.emptyElementContent,s=o.create(n,"p");return o.insertAfter(s,e),s.innerHTML=r,s},clean:function(t,n){var r,s=t;if(t.firstChild&&o.is(t.firstChild,"br")&&o.remove(t.firstChild),o.isDataNode(t)&&!t.nodeValue&&(t=t.parentNode),t){for(r=!1;t.firstChild&&1==t.firstChild.nodeType;)r=r||o.significantNodes(t.childNodes).length>1,t=t.firstChild;if(o.isEmpty(t)||!/^\s*$/.test(t.innerHTML)||r||(e(s).find(".k-br").remove(),t.innerHTML=i.emptyElementContent),n&&n.links)for(;t!=s;){if(o.is(t,"a")&&o.emptyNode(t)){o.unwrap(t);break}t=t.parentNode}}}}),h=r.extend({init:function(e){this.options=e,r.fn.init.call(this,e)},exec:function(){var e,n,i,r,s,a,d=this.getRange();this.expandImmutablesIn(d),e=o.create(c.documentFromRange(d),"br"),n=d.startContainer,r=t.support.browser,s=r.msie&&r.version<11,a=o.is(n,"table")&&n,d.deleteContents(),a?o.insertAfter(e,a):d.insertNode(e),l(e.parentNode),s||e.nextSibling&&!o.isWhitespace(e.nextSibling)||(i=e.cloneNode(!0),i.className="k-br",o.insertAfter(i,e)),d.setStartAfter(e),d.collapse(!0),o.scrollTo(e.nextSibling||e,!0),c.selectRange(d)}});n(i,{ParagraphCommand:u,NewLineCommand:h}),d("insertLineBreak",new s({key:13,shift:!0,command:h})),d("insertParagraph",new s({key:13,command:u}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/file.min",["kendo.filebrowser.min","editor/plugins/link.min"],e)}(function(){!function(e,t){var n=window.kendo,i=e.extend,o=n.ui.editor,r=o.EditorUtils,s=o.Dom,a=r.registerTool,l=o.ToolTemplate,c=o.RangeUtils,d=o.Command,u=o.LinkFormatter,h=c.textNodes,f=n.keys,p="#k-editor-file-url",m="#k-editor-file-text",g="#k-editor-file-title",v=d.extend({init:function(e){var t=this;d.fn.init.call(t,e),t.formatter=new u,t.async=!0,t.attributes={}},insertFile:function(e,t){var n=this.attributes,i=c.documentFromRange(t);if(n.href&&"http://"!=n.href){if(!e)return e=s.create(i,"a",{href:n.href}),e.innerHTML=n.innerHTML,e.title=n.title,t.deleteContents(),t.insertNode(e),e.nextSibling||s.insertAfter(i.createTextNode("\ufeff"),e),t.setStartAfter(e),t.setEndAfter(e),c.selectRange(t),!0;s.attr(e,n)}return!1},_dialogTemplate:function(e){return n.template('<div class="k-editor-dialog k-popup-edit-form"><div class="k-edit-form-container"><div class="k-edit-form-content"># if (showBrowser) { #<div class="k-filebrowser"></div># } #<div class=\'k-edit-label\'><label for="k-editor-file-url">#: messages.fileWebAddress #</label></div><div class=\'k-edit-field\'><input type="text" class="k-input k-textbox" id="k-editor-file-url"></div><div class=\'k-edit-label\'><label for="k-editor-file-text">#: messages.fileText #</label></div><div class=\'k-edit-field\'><input type="text" class="k-input k-textbox" id="k-editor-file-text"></div><div class=\'k-edit-label\'><label for="k-editor-file-title">#: messages.fileTitle #</label></div><div class=\'k-edit-field\'><input type="text" class="k-input k-textbox" id="k-editor-file-title"></div></div><div class="k-edit-buttons k-state-default"><button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button><button class="k-dialog-close k-button">#: messages.dialogCancel #</button></div></div></div>')({messages:this.editor.options.messages,showBrowser:e})},redo:function(){var e=this,t=e.lockRange();this.formatter.apply(t,this.attributes),e.releaseRange(t)},exec:function(){function e(e){var t=a.element,n=t.find(p).val().replace(/ /g,"%20"),i=t.find(m).val(),r=t.find(g).val();u.attributes={href:n,innerHTML:""!==i?i:n,title:r},b=u.insertFile(w,v),o(e),u.change&&u.change()}function o(e){e.preventDefault(),a.destroy(),s.windowFromDocument(c.documentFromRange(v)).focus(),b||u.releaseRange(v)}function r(t){t.keyCode==f.ENTER?e(t):t.keyCode==f.ESC&&o(t)}var a,l,d,u=this,v=u.lockRange(),_=h(v),b=!1,w=_.length?this.formatter.finder.findSuitable(_[0]):null,y=n.support.browser.msie,k=u.editor.options,x=k.messages,C=k.fileBrowser,S=!!(n.ui.FileBrowser&&C&&C.transport&&C.transport.read!==t),T={title:x.insertFile,visible:!1,resizable:S};this.expandImmutablesIn(v),T.close=o,S&&(T.width=750),a=this.createDialog(u._dialogTemplate(S),T).toggleClass("k-filebrowser-dialog",S).find(".k-dialog-insert").click(e).end().find(".k-dialog-close").click(o).end().find(".k-edit-field input").keydown(r).end().find(p).val(w?w.getAttribute("href",2):"http://").end().find(m).val(w?w.innerText:"").end().find(g).val(w?w.title:"").end().data("kendoWindow"),l=a.element,S&&(u._fileBrowser=new n.ui.FileBrowser(l.find(".k-filebrowser"),i({},C)),u._fileBrowser.bind("change",function(e){"f"===e.selected.get("type")&&l.find(p).val(this.value())}),u._fileBrowser.bind("apply",e)),y&&(d=l.closest(".k-window").height(),l.css("max-height",d)),a.center().open(),l.find(p).focus().select()}});n.ui.editor.FileCommand=v,a("insertFile",new o.Tool({command:v,template:new l({template:r.buttonTemplate,title:"Insert File"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/tables.min",["editor/plugins/formatblock.min"],e)}(function(){!function(e,t){var n=window.kendo,i=e.extend,o=e.proxy,r=n.ui.editor,s=r.Dom,a=r.EditorUtils,l=r.RangeUtils,c=r.Command,d="kendoEditor",u="k-state-active",h="k-state-selected",f=r.Tool,p=r.ToolTemplate,m=r.InsertHtmlCommand,g=r.BlockFormatFinder,v=r.EditorUtils.registerTool,_=n.getTouches,b=n.template,w="<td style='width:#=width#%;'>#=content#</td>",y=new g([{tags:["table"]}]),k=m.extend({init:function(t){var n=e.extend({postProcess:this.postProcess,skipCleaners:!0},t||{});m.fn.init.call(this,n)},_tableHtml:function(e,t){var n,i;return e=e||1,t=t||1,n=b(w)({width:100/t,content:r.emptyTableCellContent}),i=100/e,"<table class='k-table' data-last>"+Array(e+1).join("<tr style='height:"+i+"%;'>"+Array(t+1).join(n)+"</tr>")+"</table>"},postProcess:function(t,n){var i=e("table[data-last]",t.document).removeAttr("data-last");n.setStart(i.find("td")[0],0),n.collapse(!0),t.selectRange(n)},exec:function(){var e=this.options;e.html=this._tableHtml(e.rows,e.columns),m.fn.exec.call(this)}}),x=f.extend({initialize:function(t,n){var i,s,l,c;f.fn.initialize.call(this,t,n),i=e(this.options.popupTemplate).appendTo("body").kendoPopup({anchor:t,copyAnchorStyles:!1,open:o(this._open,this),activate:o(this._activate,this),close:o(this._close,this)}).data("kendoPopup"),t.click(o(this._toggle,this)).keydown(o(this._keydown,this)),s=this._editor=n.editor,this._popup=i,l=new r.TableWizardTool({template:new p({template:a.buttonTemplate,title:s.options.messages.tableWizard}),command:r.TableWizardCommand,insertNewTable:!0}),v("tableWizardInsert",l),c=e("<div class='k-editor-toolbar'>"+l.options.template.getHtml()+"</div>"),c.appendTo(i.element),s.toolbar&&s.toolbar.attachToolsEvents(c)},popup:function(){return this._popup},_activate:e.noop,_open:function(){this._popup.options.anchor.addClass(u)},_close:function(){this._popup.options.anchor.removeClass(u)},_keydown:function(e){var t=n.keys,i=e.keyCode;i==t.DOWN&&e.altKey?this._popup.open():i==t.ESC&&this._popup.close()},_toggle:function(t){var n=e(t.target).closest(".k-tool");n.hasClass("k-state-disabled")||this.popup().toggle()},update:function(e){var t=this.popup();t.wrapper&&"block"==t.wrapper.css("display")&&t.close(),e.removeClass("k-state-hover")},destroy:function(){this._popup.destroy()}}),C=x.extend({init:function(t){this.cols=8,this.rows=6,x.fn.init.call(this,e.extend(t,{command:k,popupTemplate:"<div class='k-ct-popup'>"+Array(this.cols*this.rows+1).join("<span class='k-ct-cell k-state-disabled' />")+"<div class='k-status'></div></div>"}))},_activate:function(){function t(t){var n=e(window);return{row:Math.floor((t.clientY+n.scrollTop()-u.top)/o)+1,col:Math.floor((t.clientX+n.scrollLeft()-u.left)/i)+1}}var i,o,r=this,s=r._popup.element,a=s.find(".k-ct-cell"),l=a.eq(0),c=a.eq(a.length-1),u=n.getOffset(l),h=n.getOffset(c),f=r.cols,p=r.rows;s.find("*").addBack().attr("unselectable","on"),h.left+=c[0].offsetWidth,h.top+=c[0].offsetHeight,i=(h.left-u.left)/f,o=(h.top-u.top)/p,s.autoApplyNS(d).on("mousemove",function(e){r._setTableSize(t(e))}).on("mouseleave",function(){r._setTableSize()}).on("down",function(e){e.preventDefault();var n=_(e)[0];r._exec(t(n.location))})},_valid:function(e){return e&&e.row>0&&e.col>0&&e.row<=this.rows&&e.col<=this.cols},_exec:function(e){this._valid(e)&&(this._editor.exec("createTable",{rows:e.row,columns:e.col}),this._popup.close())},_setTableSize:function(t){var i=this._popup.element,o=i.find(".k-status"),r=i.find(".k-ct-cell"),s=this.cols,a=this._editor.options.messages;this._valid(t)?(o.text(n.format(a.createTableHint,t.row,t.col)),r.each(function(n){e(this).toggleClass(h,n%s<t.col&&n/s<t.row)})):(o.text(a.createTable),r.removeClass(h))},_keydown:function(e){var t,i,o,r,s,a,l,c;x.fn._keydown.call(this,e),this._popup.visible()&&(t=n.keys,i=e.keyCode,o=this._popup.element.find(".k-ct-cell"),r=Math.max(o.filter(".k-state-selected").last().index(),0),s=Math.floor(r/this.cols),a=r%this.cols,l=!1,i!=t.DOWN||e.altKey?i==t.UP?(l=!0,s--):i==t.RIGHT?(l=!0,a++):i==t.LEFT&&(l=!0,a--):(l=!0,s++),c={row:Math.max(1,Math.min(this.rows,s+1)),col:Math.max(1,Math.min(this.cols,a+1))},i==t.ENTER?this._exec(c):this._setTableSize(c),l&&(e.preventDefault(),e.stopImmediatePropagation()))},_open:function(){var e=this._editor.options.messages;x.fn._open.call(this),this.popup().element.find(".k-status").text(e.createTable).end().find(".k-ct-cell").removeClass(h)},_close:function(){x.fn._close.call(this),this.popup().element.off("."+d)}}),S=c.extend({exec:function(){for(var e,t,n,i,o=this.lockRange(!0),a=o.endContainer;"td"!=s.name(a);)a=a.parentNode;if(!this.immutables()||!r.Immutables.immutableParent(a)){for(t=a.parentNode,e=t.children.length,n=t.cloneNode(!0),i=0;i<t.cells.length;i++)n.cells[i].innerHTML=r.emptyTableCellContent;"before"==this.options.position?s.insertBefore(n,t):s.insertAfter(n,t),this.releaseRange(o)}}}),T=c.extend({exec:function(){var e,t,n,i,o=this.lockRange(!0),a=s.closest(o.endContainer,"td"),l=s.closest(a,"table"),c=l.rows,d=this.options.position;if(!this.immutables()||!r.Immutables.immutableParent(a)){for(e=s.findNodeIndex(a,!0),t=0;t<c.length;t++)n=c[t].cells[e],i=n.cloneNode(),i.innerHTML=r.emptyTableCellContent,"before"==d?s.insertBefore(i,n):s.insertAfter(i,n);this.releaseRange(o)}}}),D=c.extend({exec:function(){var t,n,i,o=this.lockRange(),a=l.mapAll(o,function(t){return e(t).closest("tr")[0]}),c=a[0];if(!this.immutables()||!r.Immutables.immutableParent(c)){if(t=s.closest(c,"table"),t.rows.length<=a.length)n=s.next(t),n&&!s.insignificant(n)||(n=s.prev(t)),s.remove(t);else for(i=0;i<a.length;i++)c=a[i],s.removeTextSiblings(c),n=s.next(c)||s.prev(c),n=n.cells[0],s.remove(c);n&&(o.setStart(n,0),o.collapse(!0),this.editor.selectRange(o))}}}),A=c.extend({exec:function(){var e,t,n=this.lockRange(),i=s.closest(n.endContainer,"td"),o=s.closest(i,"table"),a=o.rows,l=s.findNodeIndex(i,!0),c=a[0].cells.length;if(!this.immutables()||!r.Immutables.immutableParent(i)){if(1==c)e=s.next(o),e&&!s.insignificant(e)||(e=s.prev(o)),s.remove(o);else for(s.removeTextSiblings(i),e=s.next(i)||s.prev(i),t=0;t<a.length;t++)s.remove(a[t].cells[l]);e&&(n.setStart(e,0),n.collapse(!0),this.editor.selectRange(n))}}}),E=f.extend({command:function(e){return e=i(e,this.options),"delete"==e.action?"row"==e.type?new D(e):new A(e):"row"==e.type?new S(e):new T(e)},initialize:function(e,t){f.fn.initialize.call(this,e,t),e.addClass("k-state-disabled")},update:function(e,t){var n=!y.isFormatted(t);e.toggleClass("k-state-disabled",n)}});i(n.ui.editor,{PopupTool:x,TableCommand:k,InsertTableTool:C,TableModificationTool:E,InsertRowCommand:S,InsertColumnCommand:T,DeleteRowCommand:D,DeleteColumnCommand:A}),v("createTable",new C({template:new p({template:a.buttonTemplate,popup:!0,title:"Create table"})})),v("addColumnLeft",new E({type:"column",position:"before",template:new p({template:a.buttonTemplate,title:"Add column on the left"})})),v("addColumnRight",new E({type:"column",template:new p({template:a.buttonTemplate,title:"Add column on the right"})})),v("addRowAbove",new E({type:"row",position:"before",template:new p({template:a.buttonTemplate,title:"Add row above"})})),v("addRowBelow",new E({type:"row",template:new p({template:a.buttonTemplate,title:"Add row below"})})),v("deleteRow",new E({type:"row",action:"delete",template:new p({template:a.buttonTemplate,title:"Delete row"})})),v("deleteColumn",new E({type:"column",action:"delete",template:new p({template:a.buttonTemplate,title:"Delete column"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/clipboard.min",["editor/command.min"],e)}(function(){!function(e){var t=window.kendo,n=t.Class,i=t.ui.editor,o=i.RangeUtils,r=i.Dom,s=i.RestorePoint,a=i.Marker,l=t.support.browser,c=e.extend,d=n.extend({init:function(e){this.editor=e;var t=e.options.pasteCleanup;this.cleaners=[new h(t),new f(t),new p(t),new m(t),new v(t),new _(t),new k(t),new x(t)]},htmlToFragment:function(e){var t=this.editor,n=t.document,i=r.create(n,"div"),o=n.createDocumentFragment();for(i.innerHTML=e;i.firstChild;)o.appendChild(i.firstChild);return o},isBlock:function(e){return/<(div|p|ul|ol|table|h[1-6])/i.test(e)},_startModification:function(){var e,t,n=this.editor;if(!this._inProgress)return this._inProgress=!0,e=n.getRange(),t=new s(e,n.body),r.persistScrollTop(n.document),{range:e,restorePoint:t}},_endModification:function(e){i._finishUpdate(this.editor,e.restorePoint),this.editor._selectionChange(),this._inProgress=!1},_contentModification:function(e,t){var n=this,i=n.editor,o=n._startModification();o&&(e.call(n,i,o.range),setTimeout(function(){t.call(n,i,o.range),n._endModification(o)}))},_removeBomNodes:function(e){var t,n=o.textNodes(e);for(t=0;t<n.length;t++)n[t].nodeValue=r.stripBom(n[t].nodeValue)||n[t].nodeValue},_onBeforeCopy:function(e){var t=new a;t.add(e),this._removeBomNodes(e),t.remove(e),this.editor.selectRange(e)},oncopy:function(){this._onBeforeCopy(this.editor.getRange())},oncut:function(){this._onBeforeCopy(this.editor.getRange()),this._contentModification(e.noop,e.noop)},_fileToDataURL:function(t){var n=e.Deferred(),i=new FileReader;return t instanceof window.File||!t.getAsFile||(t=t.getAsFile()),i.onload=e.proxy(n.resolve,n),i.readAsDataURL(t),n.promise()},_triggerPaste:function(e,t){var n={html:e||""};n.html=n.html.replace(/\ufeff/g,""),this.editor.trigger("paste",n),this.paste(n.html,t||{})},_handleImagePaste:function(e){var t,n;if("FileReader"in window&&!(l.msie&&l.version>10))return t=e.clipboardData||e.originalEvent.clipboardData||window.clipboardData||{},n=t.items||t.files,this._insertImages(n)},_insertImages:function(t){var n,i,o;if(t&&(n=e.grep(t,function(e){return/^image\//i.test(e.type)}),i=e.grep(t,function(e){return/^text\/html/i.test(e.type)}),!i.length&&n.length&&(o=this._startModification())))return e.when.apply(e,e.map(n,this._fileToDataURL)).done(e.proxy(function(){var t=Array.prototype.slice.call(arguments),n=e.map(t,function(e){return'<img src="'+e.target.result+'" />'}).join("");this._triggerPaste(n),this._endModification(o)},this)),!0},onpaste:function(n){return this._handleImagePaste(n)?void n.preventDefault():(this.expandImmutablesIn(),void this._contentModification(function(i,o){var s,a,l,c=r.create(i.document,"div",{className:"k-paste-container",innerHTML:"\ufeff"}),d=t.support.browser,u=i.body;this._decoreateClipboardNode(c,u),u.appendChild(c),d.webkit&&this._moveToCaretPosition(c,o),d.msie&&d.version<11?(n.preventDefault(),s=i.createRange(),s.selectNodeContents(c),i.selectRange(s),a=i.document.body.createTextRange(),a.moveToElementText(c),e(u).unbind("paste"),a.execCommand("Paste"),e(u).bind("paste",e.proxy(this.onpaste,this))):(l=i.createRange(),l.selectNodeContents(c),i.selectRange(l)),o.deleteContents()},function(t,n){var i,o="";t.selectRange(n),i=e(t.body).children(".k-paste-container"),i.each(function(){var e=this.lastChild;e&&r.is(e,"br")&&r.remove(e),o+=this.innerHTML}),i.remove(),this._triggerPaste(o,{clean:!0})}))},ondragover:function(e){(l.msie||l.edge)&&(e.stopPropagation(),e.preventDefault())},ondrop:function(e){var t,n;"FileReader"in window&&(t=(e.originalEvent||e).dataTransfer||{},n=t.items||t.files,this._insertImages(n)&&e.preventDefault())},_decoreateClipboardNode:function(t,n){var i,o,r,s;(l.msie||l.webkit)&&(t=e(t),t.css({borderWidth:"0px",width:"0px",height:"0px",overflow:"hidden",margin:"0",padding:"0"}),l.msie&&(i=e(n.ownerDocument.documentElement),t.css({fontVariant:"normal",fontWeight:"normal",lineSpacing:"normal",lineHeight:"normal",textDecoration:"none"}),o=i.css("color"),o&&t.css("color",o),r=i.css("fontFamily"),r&&t.css("fontFamily",r),s=i.css("fontSize"),s&&t.css("fontSize",s)))},_moveToCaretPosition:function(t,n){var i=this,o=i.editor.body,s=r.offset(t,o),a=i._caretOffset(n,o),l=a.left-s.left,c=a.top-s.top,d="translate("+l+"px,"+c+"px)";e(t).css({"-webkit-transform":d,transform:d})},_caretOffset:function(e,t){var n,i,o,s,a,l,c=this.editor,d=r.create(c.document,"span",{innerHTML:"\ufeff"}),u=e.startContainer;return e.collapsed?(i=r.isDataNode(u),i&&(r.isBom(u)||0===e.startOffset)?r.insertBefore(d,u):i&&e.startOffset===u.length?r.insertAfter(d,u):(e.insertNode(d),n=!0)):(u=u===t?u.childNodes[e.startOffset]:u,r.insertBefore(d,u)),o=r.offset(d,t),s=d.previousSibling,a=d.nextSibling,r.remove(d),n&&r.isDataNode(s)&&r.isDataNode(a)&&!r.isBom(s)&&!r.isBom(a)&&(l=s.length,a.data=s.data+a.data,e.setStart(a,l),r.remove(s),e.collapse(!0),c.selectRange(e)),o},expandImmutablesIn:function(e){var n,i,o,r=this.editor;r&&r.options.immutables&&(n=r.body,e=e||r.getRange(),t.ui.editor.Immutables.expandImmutablesIn(e),e.startContainer===n&&0===e.startOffset&&(i=n.ownerDocument,o=i.createTextNode("\ufeff"),n.insertBefore(o,n.childNodes[0]),e.setStartBefore(o)),r.selectRange(e))},splittableParent:function(e,t){var n,i;if(e)return r.closestEditableOfType(t,["p","ul","ol"])||t.parentNode;if(n=t.parentNode,i=t.ownerDocument.body,r.isInline(n))for(;n.parentNode!=i&&!r.isBlock(n.parentNode);)n=n.parentNode;return n},paste:function(t,n){var i,s,l,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C=this.editor;if(this.expandImmutablesIn(),n=c({clean:!1,split:!0},n),!n.skipCleaners)for(i=0,s=this.cleaners.length;i<s;i++)this.cleaners[i].applicable(t)&&(t=this.cleaners[i].clean(t));if(n.clean&&(t=t.replace(/(<br>(\s|&nbsp;)*)+(<\/?(div|p|li|col|t))/gi,"$3"),t=t.replace(/<(a|span)[^>]*><\/\1>/gi,"")),t=t.replace(/^<li/i,"<ul><li").replace(/li>$/g,"li></ul>"),d=this.isBlock(t),C.focus(),u=C.getRange(),u.deleteContents(),u.startContainer==C.document&&u.selectNodeContents(C.body),h=new a,f=h.addCaret(u),p=this.splittableParent(d,f),m=!1,g=p!=C.body&&!r.is(p,"td"),n.split&&g&&(d||r.isInline(p))&&(u.selectNode(f),o.split(u,p,!0),m=!0),v=this.htmlToFragment(t),v.firstChild&&"k-paste-container"===v.firstChild.className){for(_=[],i=0,s=v.childNodes.length;i<s;i++)_.push(v.childNodes[i].innerHTML);v=this.htmlToFragment(_.join("<br />"))}if(l=v.childNodes,e(l).filter("table").addClass("k-table").end().find("table").addClass("k-table"),e(l).each(function(e,t){r.isBlock(t)&&""===t.innerHTML&&t.appendChild(C.document.createTextNode("\ufeff"))}),u.insertNode(v),p=this.splittableParent(d,f),m){for(;f.parentNode!=p;)r.unwrap(f.parentNode);r.unwrap(f.parentNode)}if(r.normalize(u.commonAncestorContainer),f.style.display="inline",r.restoreScrollTop(C.document),r.scrollTo(f),h.removeCaret(u),b=u.commonAncestorContainer.parentNode,u.collapsed&&"tbody"==r.name(b)&&(u.setStartAfter(e(b).closest("table")[0]),u.collapse(!0)),w=e(u.commonAncestorContainer.parentNode).closest("table"),w.get(0)){for(y=w.parent().contents(),k=y.length-1,x=y.get(k);null!==x.nodeValue&&(" "===x.nodeValue||""===x.nodeValue);)k-=1,x=y.get(k);x===w.get(0)&&r.insertAfter(r.createEmptyNode(C.document,"p"),w[0])}C.selectRange(u)}}),u=n.extend({init:function(e){this.options=e||{},this.replacements=[]},clean:function(e,t){var n,i,o=this,r=t||o.replacements;for(n=0,i=r.length;n<i;n+=2)e=e.replace(r[n],r[n+1]);return e}}),h=u.extend({init:function(e){u.fn.init.call(this,e),this.replacements=[/<(\/?)script([^>]*)>/i,"<$1telerik:script$2>"]},applicable:function(e){return!this.options.none&&/<script[^>]*>/i.test(e)}}),f=u.extend({init:function(e){u.fn.init.call(this,e);var t=" ";this.replacements=[/<span\s+class="Apple-tab-span"[^>]*>\s*<\/span>/gi,t,/\t/gi,t,/&nbsp;&nbsp; &nbsp;/gi,t]},applicable:function(e){return/&nbsp;&nbsp; &nbsp;|class="?Apple-tab-span/i.test(e)}}),p=u.extend({init:function(e){u.fn.init.call(this,e),this.junkReplacements=[/<\?xml[^>]*>/gi,"",/<!--(.|\n)*?-->/g,"",/&quot;/g,"'",/<o:p>&nbsp;<\/o:p>/gi,"&nbsp;",/<\/?(meta|link|style|o:|v:|x:)[^>]*>((?:.|\n)*?<\/(meta|link|style|o:|v:|x:)[^>]*>)?/gi,"",/<\/o>/g,""],this.replacements=this.junkReplacements.concat([/(?:<br>&nbsp;[\s\r\n]+|<br>)*(<\/?(h[1-6]|hr|p|div|table|tbody|thead|tfoot|th|tr|td|li|ol|ul|caption|address|pre|form|blockquote|dl|dt|dd|dir|fieldset)[^>]*>)(?:<br>&nbsp;[\s\r\n]+|<br>)*/g,"$1",/<br><br>/g,"<BR><BR>",/<br>(?!\n)/g," ",/<table([^>]*)>(\s|&nbsp;)+<t/gi,"<table$1><t",/<tr[^>]*>(\s|&nbsp;)*<\/tr>/gi,"",/<tbody[^>]*>(\s|&nbsp;)*<\/tbody>/gi,"",/<table[^>]*>(\s|&nbsp;)*<\/table>/gi,"",/<BR><BR>/g,"<br>",/^\s*(&nbsp;)+/gi,"",/(&nbsp;|<br[^>]*>)+\s*$/gi,"",/mso-[^;"]*;?/gi,"",/<(\/?)b(\s[^>]*)?>/gi,"<$1strong$2>",/<(\/?)font(\s[^>]*)?>/gi,this.convertFontMatch,/<(\/?)i(\s[^>]*)?>/gi,"<$1em$2>",/style=(["|'])\s*\1/g,"",/(<br[^>]*>)?\n/g,function(e,t){return t?e:" "}])},convertFontMatch:function(e,t,n){var i=/face=['"]([^'"]+)['"]/i,o=i.exec(n),r=n&&o&&o[1];return t?"</span>":r?'<span style="font-family:'+r+'">':"<span>"},applicable:function(e){return/class="?Mso/i.test(e)||/style="[^"]*mso-/i.test(e)||/urn:schemas-microsoft-com:office/.test(e)},stripEmptyAnchors:function(e){return e.replace(/<a([^>]*)>\s*<\/a>/gi,function(e,t){return!t||t.indexOf("href")<0?"":e})},listType:function(e,t){var n,i=e.innerHTML,o=r.innerText(e),s=i.match(/^(?:<span [^>]*texhtml[^>]*>)?<span [^>]*(?:Symbol|Wingdings)[^>]*>([^<]+)/i),a=s&&s[1],l=/^[a-z\d]/i.test(a),c=function(e){return e.replace(/^(?:&nbsp;|[\u00a0\n\r\s])+/,"")};return s&&(n=!0),i=i.replace(/<\/?\w+[^>]*>/g,"").replace(/&nbsp;/g," "),!n&&/^[\u2022\u00b7\u00a7\u00d8o]\u00a0+/.test(i)||n&&/^.\u00a0+/.test(i)||a&&!l&&t?{tag:"ul",style:this._guessUnorderedListStyle(c(o))}:/^\s*\w+[\.\)][\u00a0 ]{2,}/.test(i)?{tag:"ol",style:this._guessOrderedListStyle(c(o))}:void 0},_convertToLi:function(e){var t,n=r.name(e);return 1==e.childNodes.length?t=e.firstChild.innerHTML.replace(/^\w+[\.\)](&nbsp;)+ /,""):(r.remove(e.firstChild),3==e.firstChild.nodeType&&/^[ivxlcdm]+\.$/i.test(e.firstChild.nodeValue)&&r.remove(e.firstChild),/^(&nbsp;|\s)+$/i.test(e.firstChild.innerHTML)&&r.remove(e.firstChild),t="p"!=n?"<"+n+">"+e.innerHTML+"</"+n+">":e.innerHTML),r.remove(e),r.create(document,"li",{innerHTML:t})},_guessUnorderedListStyle:function(e){return/^[\u2022\u00b7\u00FC\u00D8\u002dv-]/.test(e)?null:/^o/.test(e)?"circle":"square"},_guessOrderedListStyle:function(e){var t=null;return/^\d/.test(e)||(t=(/^[a-z]/.test(e)?"lower-":"upper-")+(/^[ivxlcdm]/i.test(e)?"roman":"alpha")),t},extractListLevels:function(e){var n=/style=['"]?[^'"]*?mso-list:\s?[a-zA-Z]+(\d+)\s[a-zA-Z]+(\d+)\s(\w+)/gi;return e=e.replace(n,function(e,n,i){return t.format('data-list="{0}" data-level="{1}" {2}',n,i,e)})},_createList:function(e,t){return r.create(document,e,{style:{listStyleType:t}})},lists:function(t){var n,i,o,s,a,l,c,d,u,h,f,p,m,g,v,_,b=e(t).find(r.blockElements.join(",")),w=-1,y={},k=["p","h1","h2","h3","h4","h5","h6"];for(d=0;d<b.length;d++)u=b[d],m=e(u).data(),g=m.list,n=r.name(u),"td"!=n&&(v=this.listType(u,m),h=v&&v.tag,!h||k.indexOf(n)<0?u.innerHTML?i&&!l&&i.append(u):r.remove(u):(f=m.level||parseFloat(u.style.marginLeft||0),_=h+g,y[f]||(y[f]={}),(!o||o<0)&&(o=f,s=g,a=e(t).find("[data-list='"+s+"']:last")[0],c=this._createList(h,v.style),r.insertBefore(c,u),w=f,y[f][_]=c),l=a===u,p=y[f][_],(f>w||!p)&&(p=this._createList(h,v.style),y[f][_]=p,i.appendChild(p)),i=this._convertToLi(u),p.appendChild(i),l?o=w=-1:w=f))},removeAttributes:function(e){for(var t=e.attributes,n=t.length;n--;)"colspan"!=r.name(t[n])&&e.removeAttributeNode(t[n])},createColGroup:function(n){var i=n.cells,o=e(n).closest("table"),r=o.children("colgroup");i.length<2||(r.length&&(i=r.children(),r[0].parentNode.removeChild(r[0])),r=e(e.map(i,function(e){var n=e.width;return n&&0!==parseInt(n,10)?t.format('<col style="width:{0}px;"/>',n):"<col />"}).join("")),r.is("colgroup")||(r=e("<colgroup/>").append(r)),r.prependTo(o))},convertHeaders:function(t){var n,i=t.cells,o=e.map(i,function(t){var n=e(t).children("p").children("strong")[0];if(n&&"strong"==r.name(n))return n});if(o.length==i.length){for(n=0;n<o.length;n++)r.unwrap(o[n]);for(e(t).closest("table").find("colgroup").after("<thead></thead>").end().find("thead").append(t),n=0;n<i.length;n++)r.changeTag(i[n],"th")}},removeParagraphs:function(t){var n,i,o,s,a;for(n=0;n<t.length;n++)for(this.removeAttributes(t[n]),s=e(t[n]),a=s.children("p"),i=0,o=a.length;i<o;i++)i<o-1&&r.insertAfter(r.create(document,"br"),a[i]),r.unwrap(a[i])},removeDefaultColors:function(e){for(var t=0;t<e.length;t++)/^\s*color:\s*[^;]*;?$/i.test(e[t].style.cssText)&&r.unwrap(e[t])},tables:function(t){var n,i,o,r,s,a=e(t).find("table"),l=this;for(r=0;r<a.length;r++){for(n=a[r].rows,o=i=n[0],s=1;s<n.length;s++)n[s].cells.length>o.cells.length&&(o=n[s]);l.createColGroup(o),l.convertHeaders(i),l.removeAttributes(a[r]),l.removeParagraphs(a.eq(r).find("td,th")),l.removeDefaultColors(a.eq(r).find("span"))}},headers:function(t){var n,i=e(t).find("p.MsoTitle");for(n=0;n<i.length;n++)r.changeTag(i[n],"h1")},removeFormatting:function(t){e(t).find("*").each(function(){e(this).css({fontSize:"",fontFamily:""}),this.getAttribute("style")||this.style.cssText||this.removeAttribute("style")})},clean:function(e){var t,n=this,i=this.options;return i.none?(e=u.fn.clean.call(n,e,this.junkReplacements),e=n.stripEmptyAnchors(e)):(e=this.extractListLevels(e),e=u.fn.clean.call(n,e),e=n.stripEmptyAnchors(e),t=r.create(document,"div",{innerHTML:e}),n.headers(t),i.msConvertLists&&n.lists(t),n.tables(t),i.msAllFormatting&&n.removeFormatting(t),e=t.innerHTML.replace(/(<[^>]*)\s+class="?[^"\s>]*"?/gi,"$1")),e}}),m=u.extend({init:function(e){u.fn.init.call(this,e),this.replacements=[/\s+class="Apple-style-span[^"]*"/gi,"",/<(div|p|h[1-6])\s+style="[^"]*"/gi,"<$1",/^<div>(.*)<\/div>$/,"$1"]},applicable:function(e){return/class="?Apple-style-span|style="[^"]*-webkit-nbsp-mode/i.test(e)}}),g=u.extend({clean:function(e){var t=r.create(document,"div",{innerHTML:e});return t=this.cleanDom(t),t.innerHTML},cleanDom:function(e){return e}}),v=g.extend({cleanDom:function(t){var n=this.collectTags();return e(t).find(n).each(function(){r.unwrap(this)}),t},collectTags:function(){if(this.options.span)return"span"},applicable:function(){return this.options.span}}),_=g.extend({cleanDom:function(t){var n=this.collectAttr(),i=e(t).find("["+n.join("],[")+"]");return i.removeAttr(n.join(" ")),t},collectAttr:function(){return this.options.css?["class","style"]:[]},applicable:function(){return this.options.css}}),b=function(){this.text="",this.add=function(e){this.text+=e}},w=n.extend({init:function(e){this.separators=e||{text:" ",line:"<br/>"},this.lines=[],this.inlineBlockText=[],this.resetLine()},appendText:function(e){3===e.nodeType&&(e=e.nodeValue),this.textContainer.add(e)},appendInlineBlockText:function(e){this.inlineBlockText.push(e)},flashInlineBlockText:function(){this.inlineBlockText.length&&(this.appendText(this.inlineBlockText.join(" ")),this.inlineBlockText=[])},endLine:function(){this.flashInlineBlockText(),this.resetLine()},html:function(){var e,t,n,i,o,r,s,a,l=this.separators,c="",d=this.lines;for(this.flashInlineBlockText(),e=0,t=d.length,n=t-1;e<t;e++){for(i=d[e],o=0,r=i.length,s=r-1;o<r;o++)a=i[o].text,c+=a,o!==s&&(c+=l.text);e!==n&&(c+=l.line)}return c},resetLine:function(){this.textContainer=new b,this.line=[],this.line.push(this.textContainer),this.lines.push(this.line)}}),y=n.extend({init:function(e){this.callback=e},enumerate:function(e){var t,n;e&&(t=this.callback(e),n=e.firstChild,!t&&n&&this.enumerate(n),this.enumerate(e.nextSibling))}}),k=u.extend({init:function(t){u.fn.init.call(this,t),this.hasText=!1,this.enumerator=new y(e.proxy(this.buildText,this))},clean:function(e){var t=r.create(document,"div",{innerHTML:e});return this.cleanDom(t)},cleanDom:function(e){return this.separators=this.getDefaultSeparators(),this.htmlLines=new w(this.separators),this.enumerator.enumerate(e.firstChild),this.hasText=!1,this.htmlLines.html()},buildText:function(e){if(r.isDataNode(e)){
if(r.isEmptyspace(e))return;this.htmlLines.appendText(e.nodeValue.replace("\n",this.separators.line)),this.hasText=!0}else{if(r.isBlock(e)&&this.hasText){var t=this.actions[r.name(e)]||this.actions.block;return t(this,e)}r.isBr(e)&&this.htmlLines.appendText(this.separators.line)}},applicable:function(){var e=this.options;return e.all||e.keepNewLines},getDefaultSeparators:function(){return this.options.all?{text:" ",line:" "}:{text:" ",line:"<br/>"}},actions:{ul:e.noop,ol:e.noop,table:e.noop,thead:e.noop,tbody:e.noop,td:function(e,t){var n=new k({all:!0}),i=n.cleanDom(t);return e.htmlLines.appendInlineBlockText(i),!0},block:function(e){e.htmlLines.endLine()}}}),x=u.extend({clean:function(e){return this.options.custom(e)},applicable:function(){return"function"==typeof this.options.custom}});c(i,{Clipboard:d,Cleaner:u,ScriptCleaner:h,TabCleaner:f,MSWordFormatCleaner:p,WebkitFormatCleaner:m,HtmlTagsCleaner:v,HtmlAttrCleaner:_,HtmlContentCleaner:k,HtmlTextLines:w,CustomCleaner:x})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/keyboard.min",["editor/command.min"],e)}(function(){!function(e){function t(e,t){return t.startContainer===e&&t.endContainer===e&&0===t.startOffset&&t.endOffset==e.childNodes.length}function n(e,t,n){for(var i=e?e[t]:null;i&&!n(i);)i=i[t];return i}var i=window.kendo,o=i.Class,r=i.ui.editor,s=r.RangeUtils,a=r.Dom,l=r.RestorePoint,c=r.Marker,d=i.support.browser,u='<br class="k-br">',h=e.extend,f=a.nodeTypes,p="previousSibling",m="td,th,caption",g="table,tbody,thead,tfoot,tr",v=g+","+m,_=function(t){return!t.collapsed&&e(t.commonAncestorContainer).is(g)},b=o.extend({remove:function(t){var n,i,o,r,l,d,u,h=this,f=new c;f.add(t,!1),n=s.getAll(t,function(t){return e(t).is(v)}),i=s.documentFromRange(t),o=f.start,r=f.end,l=m.split(","),d=a.parentOfType(o,l),u=a.parentOfType(r,l),h._removeContent(o,d,!0),h._removeContent(r,u,!1),e(n).each(function(t,n){n=e(n),(n.is(m)?n:n.find(m)).each(function(e,t){t.innerHTML="&#65279;"})}),d&&!o.previousSibling&&a.insertBefore(i.createTextNode("\ufeff"),o),u&&!r.nextSibling&&a.insertAfter(i.createTextNode("\ufeff"),r),d?t.setStartBefore(o):n[0]&&(d=e(n[0]),d=d.is(m)?d:d.find(m).first(),d.length&&t.setStart(d.get(0),0)),t.collapse(!0),a.remove(o),a.remove(r)},_removeContent:function(t,n,i){if(n){var o,r=i?"nextSibling":"previousSibling",s=function(t){for(;t&&!t[r];)t=t.parentNode;return t&&e.contains(n,t)?t[r]:null};for(t=s(t);t;)o=s(t),a.remove(t),t=o}}}),w=o.extend({init:function(e){this.editor=e},keydown:function(n){var i,o,s,a,c=this,u=c.editor,f=u.keyboard,p=f.isTypingKey(n),m=h(e.Event(),n);return c.editor.trigger("keydown",m),m.isDefaultPrevented()?(n.preventDefault(),!0):!(m.isDefaultPrevented()||!p||f.isTypingInProgress())&&(i=u.getRange(),o=u.body,c.startRestorePoint=new l(i,o),_(i)&&(s=new b(u),s.remove(i),u.selectRange(i)),d.webkit&&!i.collapsed&&t(o,i)&&(o.innerHTML=""),u.immutables&&r.Immutables.immutablesContext(i)&&(a=new r.BackspaceHandler(u),a.deleteSelection(i)),f.startTyping(function(){c.endRestorePoint=r._finishUpdate(u,c.startRestorePoint)}),!0)},keyup:function(e){var t=this.editor.keyboard;return this.editor.trigger("keyup",e),!!t.isTypingInProgress()&&(t.endTyping(),!0)}}),y=o.extend({init:function(e){this.editor=e},_addCaret:function(e){var t=a.create(this.editor.document,"a");return a.insertAt(e,t,0),a.stripBomNode(t.previousSibling),a.stripBomNode(t.nextSibling),t},_restoreCaret:function(e){var t=this.editor.createRange();!e.nextSibling&&a.isDataNode(e.previousSibling)?t.setStart(e.previousSibling,e.previousSibling.length):t.setStartAfter(e),t.collapse(!0),this.editor.selectRange(t),a.remove(e)},_handleDelete:function(e){var t,n,i=e.endContainer,o=a.closestEditableOfType(i,a.blockElements);return!(!o||!r.RangeUtils.isEndOf(e,o))&&(t=a.next(o),!(!t||"p"!=a.name(t))&&(n=this._addCaret(t),this._merge(o,t),this._restoreCaret(n),!0))},_cleanBomBefore:function(e){for(var t=e.startOffset,n=e.startContainer,i=n.nodeValue,o=0;t-o>=0&&"\ufeff"==i[t-o-1];)o++;o>0&&(n.deleteData(t-o,o),e.setStart(n,Math.max(0,t-o)),e.collapse(!0),this.editor.selectRange(e))},_handleBackspace:function(t){var i,o,s,l,c,d,u,h,f,m,g,v,_,b=t.startContainer,w=a.closestEditableOfType(b,["li"]),y=a.closestEditableOfType(b,"p,h1,h2,h3,h4,h5,h6".split(",")),k=this.editor;if(a.isDataNode(b)){if(t.collapsed&&/^\s[\ufeff]+$/.test(b.nodeValue))return t.setStart(b,0),t.setEnd(b,b.length),k.selectRange(t),!1;this._cleanBomBefore(t)}return i=n(y,p,function(e){return!a.htmlIndentSpace(e)}),t.collapsed&&t.startOffset!==t.endOffset&&t.startOffset<0&&(t.startOffset=0,t.endOffset=0,k.selectRange(t)),o=w&&r.RangeUtils.isStartOf(t,w),s=w&&e(w).index(),l=o&&s>0,l&&(y=w,i=a.prev(w)),y&&i&&a.is(i,"table")&&r.RangeUtils.isStartOf(t,y)?(""===y.innerText&&(y.innerHTML="\ufeff"),!0):y&&i&&r.RangeUtils.isStartOf(t,y)||l?(c=this._addCaret(y),this._merge(i,y),this._restoreCaret(c),!0):o&&0===s?(d=w.firstChild,d||(w.innerHTML=r.emptyElementContent,d=w.firstChild),u=new r.ListFormatter(a.name(w.parentNode),"p"),t.selectNodeContents(w),u.toggle(t),a.insignificant(d)?t.setStartBefore(d):t.setStart(d,0),k.selectRange(t),!0):(h=b.childNodes[t.startOffset-1],f=t,m=h&&a.closestEditableOfType(h,["a"]),g=n(h||b,p,function(e){return!a.isDataNode(e)||!a.isBom(e)&&e.length>0}),(m||(0===t.startOffset||h)&&a.is(g,"a"))&&(m=m||g,f=k.createRange(),f.setStart(m,m.childNodes.length),f.collapse(!0)),m=m||a.closestEditableOfType(h||f.startContainer,["a"]),v=m&&r.RangeUtils.isEndOf(f,m),v&&(_=new r.UnlinkCommand({range:f,body:k.body,immutables:!!k.immutables}),k.execCommand(_),k._selectionChange()),!1)},_handleSelection:function(t){var n,i,o,s,l=t.commonAncestorContainer,d=a.closest(l,"table"),u=r.emptyElementContent,h=this.editor;return _(t)?(n=new b(h),n.remove(t),h.selectRange(t),!0):(i=new c,i.add(t,!1),h.immutables&&this._handleImmutables(i),this._surroundFullySelectedAnchor(i,t),t.setStartAfter(i.start),t.setEndBefore(i.end),o=t.startContainer,s=t.endContainer,t.deleteContents(),d&&""===e(d).text()&&(t.selectNode(d),t.deleteContents()),l=t.commonAncestorContainer,"p"===a.name(l)&&""===l.innerHTML&&(l.innerHTML=u,t.setStart(l,0)),this._join(o,s),a.insertAfter(h.document.createTextNode("\ufeff"),i.start),i.remove(t),o=t.startContainer,"tr"==a.name(o)&&(o=o.childNodes[Math.max(0,t.startOffset-1)],t.setStart(o,a.getNodeLength(o))),t.collapse(!0),h.selectRange(t),!0)},_handleImmutables:function(e){var t=r.Immutables.immutableParent,n=t(e.start),i=t(e.start);n&&a.insertBefore(e.start,n),i&&a.insertAfter(e.end,i),n&&a.remove(n),i&&i.parentNode&&a.remove(i)},_surroundFullySelectedAnchor:function(t,n){var i=t.start,o=e(i).closest("a").get(0),r=t.end,l=e(r).closest("a").get(0);o&&s.isStartOf(n,o)&&a.insertBefore(i,o),l&&s.isEndOf(n,l)&&a.insertAfter(r,l)},_root:function(e){for(;e&&"body"!=a.name(e)&&e.parentNode&&"body"!=a.name(e.parentNode);)e=e.parentNode;return e},_join:function(e,t){e=this._root(e),t=this._root(t),e!=t&&a.is(t,"p")&&this._merge(e,t)},_merge:function(e,t){for(a.removeTrailingBreak(e);e&&t.firstChild;)1==e.nodeType?(e=a.list(e)?e.children[e.children.length-1]:e,e&&e.appendChild(t.firstChild)):e.nodeType===f.TEXT_NODE?this._mergeWithTextNode(e,t.firstChild):e.parentNode.appendChild(t.firstChild);a.remove(t)},_mergeWithTextNode:function(e,t){e&&e.nodeType===f.TEXT_NODE&&(e.nextSibling&&this._isCaret(e.nextSibling)?a.insertAfter(t,e.nextSibling):a.insertAfter(t,e))},_isCaret:function(t){return e(t).is("a")},keydown:function(e){var t,n,o=this.editor,s=o.getRange(),a=e.keyCode,c=i.keys,d=a===c.BACKSPACE,u=a==c.DELETE;o.immutables&&o.immutables.keydown(e,s)||(!d&&!u||s.collapsed?d?t="_handleBackspace":u&&(t="_handleDelete"):t="_handleSelection",t&&(n=new l(s,o.body),this[t](s)&&(e.preventDefault(),r._finishUpdate(o,n))))},deleteSelection:function(e){this._handleSelection(e)},keyup:e.noop}),k=o.extend({init:function(e){this.editor=e,this.systemCommandIsInProgress=!1},createUndoCommand:function(){this.startRestorePoint=this.endRestorePoint=r._finishUpdate(this.editor,this.startRestorePoint)},changed:function(){return!!this.startRestorePoint&&this.startRestorePoint.html!=this.editor.body.innerHTML},keydown:function(e){var t=this,n=t.editor,i=n.keyboard;return i.isModifierKey(e)?(i.isTypingInProgress()&&i.endTyping(!0),t.startRestorePoint=new l(n.getRange(),n.body),!0):!!i.isSystem(e)&&(t.systemCommandIsInProgress=!0,t.changed()&&(t.systemCommandIsInProgress=!1,t.createUndoCommand()),!0)},keyup:function(){var e=this;return!(!e.systemCommandIsInProgress||!e.changed())&&(e.systemCommandIsInProgress=!1,e.createUndoCommand(),!0)}}),x=o.extend({init:function(e){this.editor=e},keydown:function(e){!d.webkit||e.isDefaultPrevented()||!e.ctrlKey||65!=e.keyCode||e.altKey||e.shiftKey||(this.editor.options.immutables&&this._toSelectableImmutables(),this._selectEditorBody())},_selectEditorBody:function(){var e=this.editor,t=e.getRange();t.selectNodeContents(e.body),e.selectRange(t)},_toSelectableImmutables:function(){for(var t=this.editor,n=t.body,i=r.Immutables.immutable,o=a.emptyTextNode,s=n.firstChild,l=n.lastChild;o(s);)s=s.nextSibling;for(;o(l);)l=l.previousSibling;s&&i(s)&&e(u).prependTo(n),l&&i(l)&&e(u).appendTo(n)},keyup:e.noop}),C=o.extend({init:function(e){this.handlers=e,this.typingInProgress=!1},isCharacter:function(e){return e>=48&&e<=90||e>=96&&e<=111||e>=186&&e<=192||e>=219&&e<=222||229==e},toolFromShortcut:function(t,n){var i,o,r=String.fromCharCode(n.keyCode),s=this._getShortcutModifier(n,navigator.platform);for(i in t)if(o=e.extend({ctrl:!1,alt:!1,shift:!1},t[i].options),(o.key==r||o.key==n.keyCode)&&o.ctrl==s&&o.alt==n.altKey&&o.shift==n.shiftKey)return i},_getShortcutModifier:function(e,t){var n=t.toUpperCase().indexOf("MAC")>=0;return n?e.metaKey:e.ctrlKey},toolsFromShortcut:function(t,n){var i,o,r,s=String.fromCharCode(n.keyCode),a=[],l=function(e){return e==s||e==n.keyCode||e==n.charCode};for(i in t)o=e.extend({ctrl:!1,alt:!1,shift:!1},t[i].options),r=e.isArray(o.key)?e.grep(o.key,l).length>0:l(o.key),r&&o.ctrl==n.ctrlKey&&o.alt==n.altKey&&o.shift==n.shiftKey&&a.push(t[i]);return a},isTypingKey:function(e){var t=e.keyCode;return this.isCharacter(t)&&!e.ctrlKey&&!e.altKey||32==t||13==t||8==t||46==t&&!e.shiftKey&&!e.ctrlKey&&!e.altKey},isModifierKey:function(e){var t=e.keyCode;return 17==t&&!e.shiftKey&&!e.altKey||16==t&&!e.ctrlKey&&!e.altKey||18==t&&!e.ctrlKey&&!e.shiftKey},isSystem:function(e){return 46==e.keyCode&&e.ctrlKey&&!e.altKey&&!e.shiftKey},startTyping:function(e){this.onEndTyping=e,this.typingInProgress=!0},stopTyping:function(){this.typingInProgress&&this.onEndTyping&&this.onEndTyping(),this.typingInProgress=!1},endTyping:function(t){var n=this;n.clearTimeout(),t?n.stopTyping():n.timeout=window.setTimeout(e.proxy(n.stopTyping,n),1e3)},isTypingInProgress:function(){return this.typingInProgress},clearTimeout:function(){window.clearTimeout(this.timeout)},notify:function(e,t){var n,i=this.handlers;for(n=0;n<i.length&&!i[n][t](e);n++);},keydown:function(e){this.notify(e,"keydown")},keyup:function(e){this.notify(e,"keyup")}});h(r,{TypingHandler:w,SystemHandler:k,BackspaceHandler:y,SelectAllHandler:x,Keyboard:C})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/exportpdf.min",["editor/command.min"],e)}(function(){!function(e){var t=window.kendo,n=t.ui.editor,i=n.Command,o=n.EditorUtils,r=o.registerTool,s=n.Tool,a=n.ToolTemplate,l=e.extend,c=i.extend({init:function(e){this.async=!0,i.fn.init.call(this,e)},exec:function(){var e=this,t=e.lockRange(!0),n=e.editor;n._destroyResizings(),n.saveAsPDF().then(function(){e.releaseRange(t),n._initializeColumnResizing(),n._initializeRowResizing(),n._initializeTableResizing()})}});l(n,{ExportPdfCommand:c}),r("pdf",new s({command:c,template:new a({template:o.buttonTemplate,title:"Export PDF"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/plugins/print.min",["editor/command.min"],e)}(function(){!function(e){var t=window.kendo,n=t.ui.editor,i=n.Command,o=n.EditorUtils,r=o.registerTool,s=n.Tool,a=n.ToolTemplate,l=e.extend,c=i.extend({init:function(e){i.fn.init.call(this,e),this.managesUndoRedo=!0},exec:function(){var e=this.editor;t.support.browser.msie?e.document.execCommand("print",!1,null):e.window.print&&e.window.print()}});l(n,{PrintCommand:c}),r("print",new s({command:c,template:new a({template:o.buttonTemplate,title:"Print"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/resizing/resizing-utils.min",["editor/main.min"],e)}(function(){!function(e,t){function n(e){var t=e.value,n=e.min,i=e.max;return h(u(f(t),f(i)),f(n))}function i(t){return t&&!p(t).is("body")&&t.scrollHeight>t.clientHeight?e.support.scrollbar():0}function o(e,t){return r(e)?f(e):f(e)/t*100}function r(e){return typeof e===y&&b.test(e)}function s(e){return typeof e===y&&w.test(e)}function a(e){return f(e)+v}function l(e){return f(e)+_}var c=window,d=c.Math,u=d.min,h=d.max,f=c.parseFloat,p=e.jQuery,m=p.extend,g=e.ui.editor,v="%",_="px",b=/(\d+)(\.?)(\d*)%/,w=/(\d+)(\.?)(\d*)px/,y="string",k={constrain:n,getScrollBarWidth:i,calculatePercentageRatio:o,inPercentages:r,inPixels:s,toPercentages:a,toPixels:l};m(g,{ResizingUtils:k})}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/resizing/table-element-resizing.min",["editor/main.min","kendo.resizable.min","editor/resizing/resizing-utils.min"],e)}(function(){!function(e,t){var n=e.jQuery,i=n.extend,o=n.noop,r=n.proxy,s=e.ui.editor,a=e.Class,l="keydown",c="mousedown",d="mouseenter",u="mouseleave",h="mousemove",f="mouseup",p=",",m=".",g=":last-child",v="table",_=a.extend({init:function(e,t){var o=this;o.options=i({},o.options,t),o.options.tags=n.isArray(o.options.tags)?o.options.tags:[o.options.tags],n(e).is(v)&&(o.element=e,o._attachEventHandlers())},destroy:function(){var e=this,t=e.options.eventNamespace;e.element&&(n(e.element).off(t),e.element=null),n(e.options.rootElement).off(l+t),e._destroyResizeHandle()},options:{tags:[],min:0,rootElement:null,eventNamespace:"",rtl:!1,handle:{dataAttribute:"",height:0,width:0,classNames:{},template:""}},_attachEventHandlers:function(){var e=this,t=e.options;n(e.element).on(h+t.eventNamespace,t.tags.join(p),r(e.detectElementBorderHovering,e))},resizingInProgress:function(){var e=this,t=e._resizable;return!!t&&!!t.resizing},resize:o,detectElementBorderHovering:function(e){var t=this,i=t.options,o=i.handle,r=n(e.currentTarget),s=t.resizeHandle,a=o.dataAttribute;t.resizingInProgress()||(!r.is(g)&&t.elementBorderHovered(r,e)?s?s.data(a)&&s.data(a)!==r[0]&&t.showResizeHandle(r,e):t.showResizeHandle(r,e):s&&t._destroyResizeHandle())},elementBorderHovered:o,showResizeHandle:function(e,t){var n=this;0===t.buttons&&(n._initResizeHandle(),n.setResizeHandlePosition(e),n.setResizeHandleDimensions(),n.setResizeHandleDataAttributes(e[0]),n._attachResizeHandleEventHandlers(),n._initResizable(e),n._hideResizeMarker(),n.resizeHandle.show())},_initResizeHandle:function(){var e=this,t=e.options;e._destroyResizeHandle(),e.resizeHandle=n(t.handle.template).appendTo(t.rootElement)},setResizeHandlePosition:o,setResizeHandleDimensions:o,setResizeHandleDataAttributes:function(e){var t=this;t.resizeHandle.data(t.options.handle.dataAttribute,e)},_attachResizeHandleEventHandlers:function(){var e=this,t=e.options,n=t.eventNamespace,i=t.handle.classNames.marker,o=e.resizeHandle;e.resizeHandle.on(c+n,function(){o.find(m+i).show()}).on(f+n,function(){o.find(m+i).hide()})},_hideResizeMarker:function(){var e=this;e.resizeHandle.find(m+e.options.handle.classNames.marker).hide()},_destroyResizeHandle:function(){var e=this;e.resizeHandle&&(e._destroyResizable(),e.resizeHandle.off(e.options.eventNamespace).remove(),e.resizeHandle=null)},_initResizable:function(t){var n=this;n.resizeHandle&&(n._destroyResizable(),n._resizable=new e.ui.Resizable(t,{draggableElement:n.resizeHandle[0],start:r(n.onResizeStart,n),resize:r(n.onResize,n),resizeend:r(n.onResizeEnd,n)}))},_destroyResizable:function(){var e=this;e._resizable&&(e._resizable.destroy(),e._resizable=null)},onResizeStart:function(){this._disableKeyboard()},onResize:function(e){this.setResizeHandleDragPosition(e)},setResizeHandleDragPosition:o,onResizeEnd:function(e){var t=this;t.resize(e),t._destroyResizeHandle(),t._enableKeyboard()},_enableKeyboard:function(){var e=this.options;n(e.rootElement).off(l+e.eventNamespace)},_disableKeyboard:function(){var e=this.options;n(e.rootElement).on(l+e.eventNamespace,function(e){e.preventDefault()})},_forceResizing:function(e){var t=this._resizable;t&&t.userEvents&&t.userEvents._end(e)}}),b=a.extend({create:function(e,t){var i=this,o=t.name,r=t.eventNamespace;n(e.body).on(d+r,v,function(n){var r=n.currentTarget,s=e[o];n.stopPropagation(),s?s.element===r||s.resizingInProgress()||(i._destroyResizing(e,t),i._initResizing(e,r,t)):i._initResizing(e,r,t)}).on(u+r,v,function(r){var s,a=e[o];r.stopPropagation(),!a||a.resizingInProgress()||a.resizeHandle||(s=n(a.element).parents(v)[0],s&&(i._destroyResizing(e,t),i._initResizing(e,s,t)))}).on(u+r,function(){var n=e[o];n&&!n.resizingInProgress()&&i._destroyResizing(e,t)}).on(f+r,function(r){var s,a=e[o];a&&a.resizingInProgress()&&(s=n(r.target).parents(v)[0],s&&(a._forceResizing(r),i._destroyResizing(e,t),i._initResizing(e,s,t)))})},dispose:function(e,t){n(e.body).off(t.eventNamespace)},_initResizing:function(t,n,i){var o=i.name,r=i.type;t[o]=new r(n,{rtl:e.support.isRtl(t.element),rootElement:t.body})},_destroyResizing:function(e,t){var n=t.name;e[n]&&(e[n].destroy(),e[n]=null)}});b.current=new b,_.create=function(e,t){b.current.create(e,t)},_.dispose=function(e,t){b.current.dispose(e,t)},i(s,{TableElementResizing:_})}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/resizing/column-resizing.min",["editor/main.min","editor/resizing/resizing-utils.min","editor/resizing/table-element-resizing.min"],e)}(function(){!function(e,t){var n=window,i=n.Math,o=i.abs,r=e.jQuery,s=r.extend,a=e.ui.editor,l=a.TableElementResizing,c=a.ResizingUtils,d=c.constrain,u=c.calculatePercentageRatio,h=c.getScrollBarWidth,f=c.inPercentages,p=c.toPercentages,m=c.toPixels,g=e._outerWidth,v=".kendoEditorColumnResizing",_="k-column-resize-handle",b="k-column-resize-marker",w="body",y="tbody",k="td",x="th",C="tr",S=",",T="width",D=l.extend({options:{tags:[k,x],min:20,rootElement:null,eventNamespace:v,rtl:!1,handle:{dataAttribute:"column",width:10,height:0,classNames:{handle:_,marker:b},template:'<div class="k-column-resize-handle-wrapper" unselectable="on" contenteditable="false"><div class="'+_+'"><div class="'+b+'"></div></div></div>'}},elementBorderHovered:function(e,t){var n=this,i=n.options,o=i.handle.width,s=e.offset().left+(i.rtl?0:g(e)),a=t.clientX+r(e[0].ownerDocument).scrollLeft();return a>s-o&&a<s+o},setResizeHandlePosition:function(e){var t=this,n=r(t.element).children(y),i=t.options,o=i.rtl,s=i.handle.width,a=r(i.rootElement),l=a.is(w)?0:a.scrollTop(),c=a.is(w)?0:a.scrollLeft(),d=o?0:g(e),u=o?h(a[0]):0;t.resizeHandle.css({top:n.position().top+l,left:e.position().left+d+(c-u)-s/2,position:"absolute"})},setResizeHandleDimensions:function(){var e=this,t=r(e.element).children(y);e.resizeHandle.css({width:e.options.handle.width,height:t.height()})},setResizeHandleDragPosition:function(e){var t=this,n=r(r(e.currentTarget).data(t.options.handle.dataAttribute)),i=t.options,o=i.handle?i.handle.width:0,s=i.min,a=i.rtl,l=g(n),c=n.position().left,u=g(n.next()),f=r(t.resizeHandle),p=r(i.rootElement),m=p.is(w)?0:p.scrollLeft(),v=a?h(p[0]):0,_=d({value:f.position().left+(m-v)+e.x.delta,min:c+(m-v)-(a?u:0)+s,max:c+l+(m-v)+(a?0:u)-o-s});f.css({left:_})},resize:function(e){var t,n,i,o=this,s=r(r(e.currentTarget).data(o.options.handle.dataAttribute)),a=o.options,l=a.rtl?-1:1,c=a.min,u=l*e.x.initialDelta;o._setTableComputedWidth(),o._setColumnsComputedWidth(),i=g(s),n=g(s.next()),t=d({value:i+u,min:c,max:i+n-c}),o._resizeColumn(s[0],t),o._resizeTopAndBottomColumns(s[0],t),o._resizeAdjacentColumns(s.index(),n,i,i-t)},_setTableComputedWidth:function(){var e=this.element;""===e.style[T]&&(e.style[T]=m(g(r(e))))},_setColumnsComputedWidth:function(){var e,t=this,n=r(t.element).children(y),i=g(n),o=n.children(C).children(k),s=o.length,a=o.map(function(){return g(r(this))});for(e=0;e<s;e++)o[e].style[T]=f(o[e].style[T])?p(u(a[e],i)):m(a[e])},_resizeTopAndBottomColumns:function(e,t){var n,i=this,o=r(e).index(),s=r(i.element).children(y).children(C).children(i.options.tags.join(S)).filter(function(){var t=this;return r(t).index()===o&&t!==e}),a=s.length;for(n=0;n<a;n++)i._resizeColumn(s[n],t)},_resizeColumn:function(e,t){e.style[T]=f(e.style[T])?p(u(t,g(r(this.element).children(y)))):m(t)},_resizeAdjacentColumns:function(e,t,n,i){var o,s=this,a=r(s.element).children(y).children(C).children(s.options.tags.join(S)).filter(function(){return r(this).index()===e+1}),l=a.length;for(o=0;o<l;o++)s._resizeAdjacentColumn(a[o],t,n,i)},_resizeAdjacentColumn:function(e,t,n,i){var r=this,s=r.options.min,a=d({value:t+i,min:s,max:o(n+t-s)});r._resizeColumn(e,a)}});D.create=function(e){l.create(e,{name:"columnResizing",type:D,eventNamespace:v})},D.dispose=function(e){l.dispose(e,{eventNamespace:v})},s(a,{ColumnResizing:D})}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/resizing/row-resizing.min",["editor/main.min","editor/resizing/resizing-utils.min","editor/resizing/table-element-resizing.min"],e)}(function(){!function(e,t){var n=window.Math,i=n.abs,o=e.jQuery,r=o.extend,s=e.ui.editor,a=s.TableElementResizing,l=s.ResizingUtils,c=l.getScrollBarWidth,d=l.constrain,u=l.calculatePercentageRatio,h=l.inPercentages,f=l.toPercentages,p=l.toPixels,m=e._outerHeight,g=".kendoEditorRowResizing",v="k-row-resize-handle",_="k-row-resize-marker-wrapper",b="k-row-resize-marker",w="body",y="tr",k="tbody",x="height",C=a.extend({options:{tags:[y],min:20,rootElement:null,eventNamespace:g,rtl:!1,handle:{dataAttribute:"row",width:0,height:10,classNames:{handle:v,marker:b},template:'<div class="k-row-resize-handle-wrapper" unselectable="on" contenteditable="false"><div class="'+v+'"><div class="'+_+'"><div class="'+b+'"></div></div></div></div>'}},elementBorderHovered:function(e,t){var n=this,i=n.options.handle[x],r=e.offset().top+m(e),s=t.clientY+o(e[0].ownerDocument).scrollTop();return s>r-i&&s<r+i},setResizeHandlePosition:function(e){var t=this,n=t.options,i=n.handle[x],r=e.position(),s=o(n.rootElement),a=s.is(w)?0:s.scrollTop(),l=s.is(w)?0:s.scrollLeft(),d=n.rtl?c(s[0]):0;t.resizeHandle.css({top:r.top+m(e)+a-i/2,left:r.left+(l-d),position:"absolute"})},setResizeHandleDimensions:function(){var e=this;e.resizeHandle.css({width:o(e.element).children(k).width(),height:e.options.handle[x]})},setResizeHandleDragPosition:function(e){var t=this,n=t.options,i=n.min,r=o(t.element).children(k),s=r.position().top,a=o(t.resizeHandle),l=o(e.currentTarget).data(n.handle.dataAttribute),c=o(n.rootElement),u=c.is(w)?0:c.scrollTop(),h=d({value:a.position().top+u+e.y.delta,min:o(l).position().top+u+i,max:s+m(r)+u-n.handle[x]-i});a.css({top:h})},resize:function(e){var t=this,n=t.options,r=o(e.currentTarget).data(n.handle.dataAttribute),s=m(o(r)),a=o(t.element),l=m(a),c=a.children(k),u=c.height(),f=r.style[x],g=d({value:s+e.y.initialDelta,min:n.min,max:i(u-n.min)});t._setRowsHeightInPixels(),r.style[x]=p(g),t._setTableHeight(l+(g-s)),h(f)&&t._setRowsHeightInPercentages()},_setRowsHeightInPixels:function(){var e,t=this,n=o(t.element).children(k).children(y),i=n.length,r=n.map(function(){return m(o(this))});for(e=0;e<i;e++)n[e].style[x]=p(r[e])},_setRowsHeightInPercentages:function(){var e,t=this,n=o(t.element).children(k),i=n.height(),r=n.children(y),s=r.length,a=r.map(function(){return m(o(this))});for(e=0;e<s;e++)r[e].style[x]=f(u(a[e],i))},_setTableHeight:function(e){var t=this.element;t.style[x]=h(t.style[x])?f(u(e,o(t).parent().height())):p(e)}});C.create=function(e){a.create(e,{name:"rowResizing",type:C,eventNamespace:g})},C.dispose=function(e){a.dispose(e,{eventNamespace:g})},r(s,{RowResizing:C})}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/resizing/table-resize-handle.min",["editor/main.min","kendo.draganddrop.min","editor/resizing/resizing-utils.min"],e)}(function(){!function(e,t){var n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C=e.jQuery,S=C.extend,T=C.noop,D=C.proxy,A=e.ui.editor,E=e.Class,I=e.ui.Draggable,M=e.Observable,R=A.ResizingUtils.getScrollBarWidth,F=e._outerWidth,z=e._outerHeight,P=".kendoEditorTableResizeHandle",B="k-table-resize-handle",L="dragStart",H="drag",N="dragEnd",O="halfInside",V="mouseover",U="mouseout",W="body",j="table",q="east",G="north",$="northeast",K="northwest",Y="south",Q="southeast",X="southwest",Z="west",J=".",ee=M.extend({init:function(e){var t=this;M.fn.init.call(t),t.options=S({},t.options,e),t.element=C(t.options.template).appendTo(t.options.appendTo)[0],t._attachEventHandlers(),t._addStyles(),t._initDraggable(),t._initPositioningStrategy(),t._initDraggingStrategy(),C(t.element).data(j,t.options.resizableElement)},destroy:function(){var e=this;C(e.element).off(P).remove(),e.element=null,e._destroyDraggable(),e.unbind()},options:{appendTo:null,direction:Q,resizableElement:null,rtl:!1,template:"<div class='k-table-resize-handle-wrapper' unselectable='on' contenteditable='false'><div class='"+B+"'></div></div>"},events:[L,H,N,V,U],show:function(){this._setPosition()},_setPosition:function(){var e=this,t=e._positioningStrategy.getPosition();C(e.element).css({top:t.top,left:t.left,position:"absolute"})},_attachEventHandlers:function(){var e=this;C(e.element).on(V+P,D(e._onMouseOver,e)).on(U+P,D(e._onMouseOut,e))},_onMouseOver:function(){this.trigger(V)},_onMouseOut:function(){this.trigger(U)},_addStyles:function(){var e=this;C(e.element).children(J+B).addClass("k-resize-"+e.options.direction)},_initPositioningStrategy:function(){var e=this,t=e.options;e._positioningStrategy=n.create({name:t.direction,handle:e.element,resizableElement:t.resizableElement,rootElement:t.rootElement,rtl:t.rtl})},_initDraggable:function(){var e=this,t=e.element;!e._draggable&&t&&(e._draggable=new I(t,{dragstart:D(e._onDragStart,e),drag:D(e._onDrag,e),dragend:D(e._onDragEnd,e)}))},_onDragStart:function(){this.trigger(L)},_onDrag:function(e){var t=this;t.trigger(H,t._draggingStrategy.adjustDragDelta({deltaX:e.x.delta,deltaY:e.y.delta,initialDeltaX:e.x.initialDelta,initialDeltaY:e.y.initialDelta}))},_onDragEnd:function(){this.trigger(N)},_destroyDraggable:function(){var e=this;e._draggable&&(e._draggable.destroy(),e._draggable=null)},_initDraggingStrategy:function(){var e=this;e._draggingStrategy=h.create({name:e.options.direction})}}),te=E.extend({init:function(){this._items=[]},register:function(e,t){this._items.push({name:e,type:t})},create:function(e){var t,n,i,o=this._items,r=o.length,s=e.name?e.name.toLowerCase():"";for(i=0;i<r;i++)if(n=o[i],n.name.toLowerCase()===s){t=n;break}if(t)return new t.type(e)}}),ne=te.extend({});ne.current=new ne,n=E.extend({init:function(e){var t=this;t.options=S({},t.options,e)},options:{handle:null,offset:O,resizableElement:null,rootElement:null,rtl:!1},getPosition:function(){var e=this,t=e.calculatePosition(),n=e.applyHandleOffset(t),i=e.applyScrollOffset(n);return i},calculatePosition:T,applyHandleOffset:function(e){var t=this.options,n=C(t.handle);return t.offset===O?{top:e.top-z(n)/2,left:e.left-F(n)/2}:e},applyScrollOffset:function(e){var t=this.options,n=C(t.rootElement),i=t.rtl?R(n[0]):0;return n.is(W)?e:{top:e.top+(n.scrollTop()||0),left:e.left+(n.scrollLeft()||0)-i}}}),n.create=function(e){return ne.current.create(e)},i=n.extend({calculatePosition:function(){var e=C(this.options.resizableElement),t=e.position();return{top:t.top+z(e)/2,left:t.left+F(e)}}}),ne.current.register(q,i),o=n.extend({calculatePosition:function(){var e=C(this.options.resizableElement),t=e.position();return{top:t.top,left:t.left+F(e)/2}}}),ne.current.register(G,o),r=n.extend({calculatePosition:function(){var e=C(this.options.resizableElement),t=e.position();return{top:t.top,left:t.left+F(e)}}}),ne.current.register($,r),s=n.extend({calculatePosition:function(){var e=C(this.options.resizableElement),t=e.position();return{top:t.top,left:t.left}}}),ne.current.register(K,s),a=n.extend({calculatePosition:function(){var e=C(this.options.resizableElement),t=e.position();return{top:t.top+z(e),left:t.left+F(e)/2}}}),ne.current.register(Y,a),l=n.extend({calculatePosition:function(){var e=C(this.options.resizableElement),t=e.position();return{top:t.top+z(e),left:t.left+F(e)}}}),ne.current.register(Q,l),c=n.extend({calculatePosition:function(){var e=C(this.options.resizableElement),t=e.position();return{top:t.top+z(e),left:t.left}}}),ne.current.register(X,c),d=n.extend({calculatePosition:function(){var e=C(this.options.resizableElement),t=e.position();return{top:t.top+z(e)/2,left:t.left}}}),ne.current.register(Z,d),u=te.extend({}),u.current=new u,h=E.extend({init:function(e){var t=this;t.options=S({},t.options,e)},options:{deltaX:{adjustment:null,modifier:null},deltaY:{adjustment:null,modifier:null}},adjustDragDelta:function(e){var t=this.options,n=t.deltaX.adjustment*t.deltaX.modifier,i=t.deltaY.adjustment*t.deltaY.modifier;return{deltaX:e.deltaX*n,deltaY:e.deltaY*i,initialDeltaX:e.initialDeltaX*n,initialDeltaY:e.initialDeltaY*i}}}),h.create=function(e){return u.current.create(e)},f=h.extend({options:{deltaX:{adjustment:1,modifier:1},deltaY:{adjustment:0,modifier:0}}}),p=f.extend({options:{deltaX:{modifier:1}}}),u.current.register(q,p),m=f.extend({options:{deltaX:{modifier:-1}}}),u.current.register(Z,m),g=h.extend({options:{deltaX:{adjustment:0,modifier:0},deltaY:{adjustment:1,modifier:1}}}),v=g.extend({options:{deltaY:{modifier:-1}}}),u.current.register(G,v),_=g.extend({options:{deltaY:{modifier:1}}}),u.current.register(Y,_),b=h.extend({options:{deltaX:{adjustment:1,modifier:1},deltaY:{adjustment:1,modifier:1}}}),w=b.extend({options:{deltaX:{modifier:1},deltaY:{modifier:-1}}}),u.current.register($,w),y=b.extend({options:{deltaX:{modifier:-1},deltaY:{modifier:-1}}}),u.current.register(K,y),k=b.extend({options:{deltaX:{modifier:1},deltaY:{modifier:1}}}),u.current.register(Q,k),x=b.extend({options:{deltaX:{modifier:-1},deltaY:{modifier:1}}}),u.current.register(X,x),S(A,{TableResizeHandle:ee})}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/resizing/table-resizing.min",["editor/main.min","editor/resizing/table-resize-handle.min","editor/resizing/resizing-utils.min"],e)}(function(){!function(e,t){function n(e){return t===e}var i=window,o=i.Math,r=o.min,s=o.max,a=e.jQuery,l=a.contains,c=a.extend,d=a.proxy,u=e.support.browser,h=e.ui.editor,f=e.Class,p=h.TableResizeHandle,m=h.ResizingUtils,g=m.calculatePercentageRatio,v=m.constrain,_=m.inPercentages,b=m.inPixels,w=m.toPercentages,y=m.toPixels,k=e._outerWidth,x=e._outerHeight,C=".kendoEditorTableResizing",S="k-table-resize-handle-wrapper",T="k-table",D="k-table-resizing",A="dragStart",E="drag",I="dragEnd",M="keydown",R="mousedown",F="mouseover",z="mouseout",P="td",B="tr",L="tbody",H="table",N="width",O="height",V="east",U="north",W="northeast",j="northwest",q="south",G="southeast",$="southwest",K="west",Y=".",Q=f.extend({init:function(e,t){var n=this;n.options=c({},n.options,t),n.handles=[],a(e).is(H)&&(n.element=e)},destroy:function(){var e=this;a(e.element).off(C),e.element=null,a(e.options.rootElement).off(M+C),e._destroyResizeHandles()},options:{appendHandlesTo:null,rtl:!1,rootElement:null,minWidth:10,minHeight:10,handles:[{direction:j},{direction:U},{direction:W},{direction:V},{direction:G},{direction:q},{direction:$},{direction:K}]},resize:function(e){
var t=this,n=c({},{deltaX:0,deltaY:0,initialDeltaX:0,initialDeltaY:0},e);t._resizeWidth(n.deltaX,n.initialDeltaX),t._resizeHeight(n.deltaY,n.initialDeltaY),t.showResizeHandles()},_resizeWidth:function(e,t){var i,o,l,c,d=this,u=a(d.element),h=u[0].style[N],f=k(u),p=u.parent().width(),m=d._getMaxDimensionValue(N);0!==e&&(n(d._initialElementWidth)&&(d._initialElementWidth=f),c=v({value:d._initialElementWidth+t,min:d.options.minWidth,max:m}),_(h)?(f+e>p?(o=s(c,p),l=r(c,p)):(o=r(c,p),l=s(c,p)),i=w(g(o,l))):i=y(c),d._setColumnsWidth(),u[0].style[N]=i)},_resizeHeight:function(e,t){var i,o,l,c,d=this,u=a(d.element),h=u[0].style[O],f=x(u),p=u.parent(),m=p.height(),b=d._getMaxDimensionValue(O),k=d.options.minHeight,C=d._hasRowsInPixels();0!==e&&(n(d._initialElementHeight)&&(d._initialElementHeight=f),c=v({value:d._initialElementHeight+t,min:k,max:b}),C&&e<0&&d._setRowsHeightInPercentages(),_(h)?(f+e>m?(o=s(c,m),l=r(c,m)):(o=r(c,m),l=s(c,m)),i=w(g(o,l))):i=y(c),u[0].style[O]=i,C&&e<0&&d._setRowsHeightInPixels())},_getMaxDimensionValue:function(e){var t=this,n=a(t.element),i=e.toLowerCase(),o=t.options.rtl?-1:1,r=a(t.element).parent(),s=r[0],l=r[i](),c=o*(e===N?r.scrollLeft():r.scrollTop());return s===n.closest(P)[0]?""!==s.style[i]||_(t.element.style[i])?l+c:1/0:l+c},_setColumnsWidth:function(){function e(e){var t=e.style.width;return""!==t?!!_(t):!!a(e).hasClass(T)}var t,n=this,i=a(n.element),o=i.parent()[0],r=i.closest(P),s=r.closest(B).children(),l=s.length;if(e(i[0])&&o===r[0]&&""===o.style[N])for(t=0;t<l;t++)s[t].style[N]=y(a(s[t]).width())},_hasRowsInPixels:function(){var e,t=this,n=a(t.element).children(L).children(B);for(e=0;e<n.length;e++)if(""===n[e].style.height||b(n[e].style.height))return!0;return!1},_setRowsHeightInPercentages:function(){var e,t=this,n=a(t.element).children(L),i=n.height(),o=n.children(B),r=o.length,s=o.map(function(){return x(a(this))});for(e=0;e<r;e++)o[e].style[O]=w(g(s[e],i))},_setRowsHeightInPixels:function(){var e,t=this,n=a(t.element).children(L).children(B),i=n.length,o=n.map(function(){return x(a(this))});for(e=0;e<i;e++)n[e].style[O]=y(o[e])},showResizeHandles:function(){var e=this;e._initResizeHandles(),e._showResizeHandles()},_initResizeHandles:function(){var e,t=this,n=t.handles,i=t.options,o=t.options.handles,r=o.length;if(!(n&&n.length>0)){for(e=0;e<r;e++)t.handles.push(new p(c({appendTo:i.appendHandlesTo,resizableElement:t.element,rootElement:i.rootElement,rtl:i.rtl},o[e])));t._bindToResizeHandlesEvents()}},_destroyResizeHandles:function(){var e,t=this,n=t.handles?t.handles.length:0;for(e=0;e<n;e++)t.handles[e].destroy()},_showResizeHandles:function(){var e,t=this,n=t.handles||[],i=n.length;for(e=0;e<i;e++)t.handles[e].show()},_bindToResizeHandlesEvents:function(){var e,t,n=this,i=n.handles||[],o=i.length;for(e=0;e<o;e++)t=i[e],t.bind(A,d(n._onResizeHandleDragStart,n)),t.bind(E,d(n._onResizeHandleDrag,n)),t.bind(I,d(n._onResizeHandleDragEnd,n)),t.bind(F,d(n._onResizeHandleMouseOver,n)),t.bind(z,d(n._onResizeHandleMouseOut,n))},_onResizeHandleDragStart:function(){var e=this,t=a(e.element);t.addClass(D),e._initialElementHeight=x(t),e._initialElementWidth=k(t),e._disableKeyboard()},_onResizeHandleDrag:function(e){this.resize(e)},_onResizeHandleDragEnd:function(){var e=this;a(e.element).removeClass(D),e._enableKeyboard()},_enableKeyboard:function(){a(this.options.rootElement).off(M+C)},_disableKeyboard:function(){a(this.options.rootElement).on(M+C,function(e){e.preventDefault()})}}),X=f.extend({create:function(e){var t=this;a(e.body).on(R+C,H,function(n){var i=n.target,o=n.currentTarget,r=e.tableResizing,s=r?r.element:null;if(r){if(s&&o!==s){if(l(o,s)&&s!==i&&l(s,i))return;s!==i&&(e._destroyTableResizing(),t._initResizing(e,o))}}else t._initResizing(e,o);e._showTableResizeHandles()}).on(R+C,function(t){var n=e.tableResizing,i=n?n.element:null,o=t.target,r=a(o).hasClass(S)||a(o).parents(Y+S).length>0;!n||i===o||l(i,o)||r||e._destroyTableResizing()})},dispose:function(e){a(e.body).off(C)},_initResizing:function(t,n){u.msie||u.mozilla||(t.tableResizing=new Q(n,{appendHandlesTo:t.body,rtl:e.support.isRtl(t.element),rootElement:t.body}))}});X.current=new X,Q.create=function(e){X.current.create(e)},Q.dispose=function(e){X.current.dispose(e)},c(h,{TableResizing:Q})}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/table-wizard/table-wizard-command.min",["editor/plugins/tables.min"],e)}(function(){!function(e,t){var n=window.kendo,i=n.ui.editor,o=i.EditorUtils,r=i.RangeUtils,s=i.Dom,a=o.registerTool,l=i.ToolTemplate,c=i.Command,d=new i.BlockFormatFinder([{tags:["table"]}]),u=new i.BlockFormatFinder([{tags:["td","th"]}]),h=/([a-z]+|%)$/i,f=c.extend({exec:function(){var o=this,r=o.editor,s=o.range=o.lockRange(),a=o._sourceTable=o.options.insertNewTable?t:o._selectedTable(s),l=o._selectedTableCells=a?o._selectedCells(s):t,c={visible:!1,messages:r.options.messages,closeCallback:e.proxy(o.onDialogClose,o),table:o.parseTable(a,l),dialogOptions:r.options.dialogOptions,isRtl:n.support.isRtl(r.wrapper)},d=new i.TableWizardDialog(c);d.open()},onDialogClose:function(e){var t=this;t.releaseRange(t.range),e&&(t.options.insertNewTable?t.insertTable(t.createNewTable(e)):t.updateTable(e,t._sourceTable,t._selectedTableCells))},releaseRange:function(e){var t=this,n=t.editor.document;s.windowFromDocument(n).focus(),c.fn.releaseRange.call(t,e)},insertTable:function(e){var t=this.range;t.insertNode(e),t.collapse(!0),this.editor.selectRange(t),this._ensureFocusableAfterTable(e)},_ensureFocusableAfterTable:function(t){for(var n=e(t).parent().contents(),i=n.length-1,o=n.get(i);null!==o.nodeValue&&(" "===o.nodeValue||""===o.nodeValue);)i-=1,o=n.get(i);o===t&&s.insertAfter(s.createEmptyNode(this.editor.document,"p"),t)},updateTable:function(t,n,i){for(var o,r,a,l,c,d,u,h,f=this,p=e(n.rows).toArray(),m=t.tableProperties,g=m.rows,v=m.columns,_=function(e){return e[e.length-1]};i.length>1;)i.pop();if(o=i.length?_(i).parentNode:_(p),f._deleteTableRows(p,p.length-g),p.length<g)for(l=e(o).index(),c=o.cells.length,d=g-p.length,a=o.parentNode;d;)r=a.insertRow(l+1),f._insertCells(c-r.cells.length,r),d--;p[0].cells.length>v&&e(p).each(function(e,t){for(;t.cells.length>v;)t.deleteCell(-1)}),p[0].cells.length<v&&(u=e(_(i)||_(o.cells)).index(),e(p).each(function(e,t){f._insertCells(v-t.cells.length,t,u+1)})),f._updateTableProperties(n,m),h=t.cellProperties,i[0]&&s.attr(i[0],{id:h.id||null}),(h.selectAllCells?e(p).children():e(i)).each(function(e,t){f._updateCellProperties(t,h)}),f._updateCaption(n,m),m.cellsWithHeaders=m.cellsWithHeaders||!1,f.cellsWithHeadersAssociated(n)!=m.cellsWithHeaders&&f.associateCellsWithHeader(n,m.cellsWithHeaders)},_isHeadingRow:function(e){return s.is(e.parentNode,"thead")||s.is(e.cells[0],"th")},associateCellsWithHeader:function(t,n){var i,o,r,s=(new Date).getTime(),a=[],l=t.rows[0].cells.length,c=function(){for(var e=0;e<l;e++)a[e]="table"+ ++s},d=function(t,i){e(i)[n?"attr":"removeAttr"]("id",a[t])},u=function(t,i){e(i)[n?"attr":"removeAttr"]("headers",a[t])},h=this._isHeadingRow;e(t.rows).each(function(n,s){if(h(s))for(i=n,o=t.rows[++i],r=o&&!h(o),r&&(c(),e(s.cells).each(d));r;)e(o.cells).each(u),o=t.rows[++i],r=o&&!h(o)})},cellsWithHeadersAssociated:function(t){var n,i=e(t.rows).children(),o=this._isHeadingRow,r=[];return i.each(function(e,t){t.id&&o(t.parentNode)&&r.push(t.id)}),n=i.filter(function(t,n){var i=n.getAttribute("headers");return i&&!o(n.parentNode)&&e.inArray(i,r)>-1}),!!n.length},_insertCells:function(e,t,n){n=isNaN(n)?-1:n;for(var i,o=0;o<e;o++)i=t.insertCell(n),i.innerHTML="&nbsp;"},_deleteTableRows:function(e,t){for(var n,i,o=0;o<t;o++)n=e.pop(),i=n.parentNode,i.removeChild(n),i.rows.length||s.remove(i)},createNewTable:function(e){var t,n,i,o,r,a=this,l=a.editor.document,c=e.tableProperties,d=e.cellProperties,u=d.selectAllCells,h=s.create(l,"table");for(a._updateTableProperties(h,c),a._updateCaption(h,c),t=h.createTBody(),n=0;n<c.rows;n++)for(i=t.insertRow(),o=0;o<c.columns;o++)r=i.insertCell(),r.innerHTML="&nbsp;",0===n&&0===o&&d.id&&(r.id=d.id),a._updateCellProperties(r,u||0===n&&0===o?d:{});return c.cellsWithHeaders&&a.associateCellsWithHeader(h,c.cellsWithHeaders),h},_updateTableProperties:function(t,n){var i=this._getStylesData(n);s.attr(t,{cellSpacing:n.cellSpacing||null,cellPadding:n.cellPadding||null,className:n.className||null,id:n.id||null,summary:n.summary||null,style:i||null}),e(t).addClass("k-table")},_updateCellProperties:function(e,t){var n=this._getStylesData(t);n.padding=t.cellPadding||null,n.margin=t.cellMargin||null,s.attr(e,{style:n||null,className:t.className||null})},_updateCaption:function(e,t){var n,i;e.caption&&!t.captionContent?e.deleteCaption():t.captionContent&&(n=e.createCaption(),n.innerHTML=t.captionContent,i=this._getAlignmentData(t.captionAlignment),s.attr(n,{style:{textAlign:i.textAlign,verticalAlign:i.verticalAlign}}))},_getStylesData:function(e){var t=this._getAlignmentData(e.alignment),n="wrapText"in e?e.wrapText?"":"nowrap":null;return{width:e.width?e.width+e.widthUnit:null,height:e.height?e.height+e.heightUnit:null,textAlign:t.textAlign,verticalAlign:t.verticalAlign,backgroundColor:e.bgColor||null,borderWidth:e.borderWidth,borderStyle:e.borderStyle,borderColor:e.borderColor,borderCollapse:e.collapseBorders?"collapse":null,whiteSpace:n}},_getAlignmentData:function(e){var t,n="",i=n;return e&&(e.indexOf(" ")!=-1?(t=e.split(" "),n=t[0],i=t[1]):n=e),{textAlign:n,verticalAlign:i}},parseTable:function(n,i){var o,r,s,a,l,c,d,u,h,f;return n?(o=this,r=n.style,s=n.rows,a=n.caption,l=e(a?a.cloneNode(!0):t),l.find(".k-marker").remove(),c=n.className,c=c.replace(/^k-table\s|\sk-table$/,""),c=c.replace(/\sk-table\s/," "),c=c.replace(/^k-table$/,""),d=o._getAlignment(n,!0),u=a?o._getAlignment(a):t,h=o.cellsWithHeadersAssociated(n),f={tableProperties:{width:r.width||n.width?parseFloat(r.width||n.width):null,height:r.height||n.height?parseFloat(r.height||n.height):null,columns:s[0]?s[0].children.length:0,rows:s.length,widthUnit:o._getUnit(r.width),heightUnit:o._getUnit(r.height),cellSpacing:n.cellSpacing,cellPadding:n.cellPadding,alignment:d.textAlign,bgColor:r.backgroundColor||n.bgColor,className:c,id:n.id,borderWidth:r.borderWidth||n.border,borderColor:r.borderColor,borderStyle:r.borderStyle||"",collapseBorders:!!r.borderCollapse,summary:n.summary,captionContent:a?l.html():"",captionAlignment:a&&u.textAlign?u.textAlign+" "+u.verticalAlign:"",cellsWithHeaders:h},selectedCells:[]},f.rows=o.parseTableRows(s,i,f),f):{tableProperties:{},selectedCells:[]}},parseTableRows:function(t,n,i){var o,r,s,a,l,c,d,u=this,h=[];for(c=0;c<t.length;c++)for(o=t[c],r={cells:[]},s=o.cells,h.push(r),d=0;d<s.length;d++)a=s[d],l=u.parseCell(a),e.inArray(a,n)!=-1&&i.selectedCells.push(l),r.cells.push(l);return h},parseCell:function(e){var t,n=this,i=e.style,o=n._getAlignment(e);return o=o.textAlign?o.textAlign+" "+o.verticalAlign:"",t={width:i.width||e.width?parseFloat(i.width||e.width):null,height:i.height||e.height?parseFloat(i.height||e.height):null,widthUnit:n._getUnit(i.width),heightUnit:n._getUnit(i.height),cellMargin:i.margin,cellPadding:i.padding,alignment:o,bgColor:i.backgroundColor||e.bgColor,className:e.className,id:e.id,borderWidth:i.borderWidth||e.border,borderColor:i.borderColor,borderStyle:i.borderStyle,wrapText:"nowrap"!=i.whiteSpace}},_getAlignment:function(e,t){var n,i=e.style,o=i.textAlign||e.align||"";return t?{textAlign:o}:(n=i.verticalAlign||e.vAlign||"",o&&n?{textAlign:o,verticalAlign:n}:!o&&n?{textAlign:"left",verticalAlign:n}:o&&!n?{textAlign:o,verticalAlign:"top"}:{textAlign:"",verticalAlign:""})},_getUnit:function(e){var t=(e||"").match(h);return t?t[0]:"px"},_selectedTable:function(e){var t=s.filterBy(r.nodes(e),s.htmlIndentSpace,!0);return d.findSuitable(t)[0]},_selectedCells:function(e){var t=s.filterBy(r.nodes(e),s.htmlIndentSpace,!0);return u.findSuitable(t)}}),p=i.Tool.extend({command:function(e){return e.insertNewTable=this.options.insertNewTable,new f(e)}}),m=p.extend({update:function(e,t){var n=!d.isFormatted(t);e.toggleClass("k-state-disabled",n)}});n.ui.editor.TableWizardTool=p,n.ui.editor.TableWizardCommand=f,a("tableWizard",new m({command:f,insertNewTable:!1,template:new l({template:o.buttonTemplate,title:"Table Wizard"})}))}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("editor/table-wizard/table-wizard-dialog.min",["editor/table-wizard/table-wizard-command.min"],e)}(function(){!function(e,t){var n=window.kendo,i={format:"0",min:0},o=["px","em"],r=["solid","dotted","dashed","double","groove","ridge","inset","outset","initial","inherit","none","hidden"],s={dataSource:[{className:"k-icon k-i-table-align-middle-left",value:"left"},{className:"k-icon k-i-table-align-middle-center",value:"center"},{className:"k-icon k-i-table-align-middle-right",value:"right"},{className:"k-icon k-i-align-remove",value:""}],dataTextField:"className",dataValueField:"value",template:"<span class='#: className #' title='#: tooltip #'></span>",valueTemplate:"<span class='k-align-group #: className #' title='#: tooltip #'></span>"},a={dataSource:[{className:"k-icon k-i-table-align-top-left",value:"left top"},{className:"k-icon k-i-table-align-top-center",value:"center top"},{className:"k-icon k-i-table-align-top-right",value:"right top"},{className:"k-icon k-i-table-align-middle-left",value:"left middle"},{className:"k-icon k-i-table-align-middle-center",value:"center middle"},{className:"k-icon k-i-table-align-middle-right",value:"right middle"},{className:"k-icon k-i-table-align-bottom-left",value:"left bottom"},{className:"k-icon k-i-table-align-bottom-center",value:"center bottom"},{className:"k-icon k-i-table-align-bottom-right",value:"right bottom"},{className:"k-icon k-i-align-remove",value:""}],dataTextField:"className",dataValueField:"value",template:"<span class='#: className #' title='#: tooltip #'></span>",valueTemplate:"<span class='k-align-group #: className #' title='#: tooltip #'></span>"},l={dataSource:[{className:"k-icon k-i-table-align-top-left",value:"left top"},{className:"k-icon k-i-table-align-top-center",value:"center top"},{className:"k-icon k-i-table-align-top-right",value:"right top"},{className:"k-icon k-i-table-align-bottom-left",value:"left bottom"},{className:"k-icon k-i-table-align-bottom-center",value:"center bottom"},{className:"k-icon k-i-table-align-bottom-right",value:"right bottom"},{className:"k-icon k-i-align-remove",value:""}],dataTextField:"className",dataValueField:"value",template:"<span class='#: className #' title='#: tooltip #'></span>",valueTemplate:"<span class='k-align-group #: className #' title='#: tooltip #'></span>"},c='<div class="k-editor-dialog k-editor-table-wizard-dialog k-action-window k-popup-edit-form"><div class="k-edit-form-container"><div id="k-table-wizard-tabs" class="k-root-tabs"><ul><li class="k-state-active">#= messages.tableTab #</li><li>#= messages.cellTab #</li><li>#= messages.accessibilityTab #</li></ul><div id="k-table-properties"><div class="k-edit-label"><label for="k-editor-table-width">#= messages.width #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-width" /><input id="k-editor-table-width-type" aria-label="#= messages.units #" /></div><div class="k-edit-label"><label for="k-editor-table-height">#= messages.height #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-height" /><input id="k-editor-table-height-type" aria-label="#= messages.units #" /></div><div class="k-edit-label"><label for="k-editor-table-columns">#= messages.columns #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-columns" /></div><div class="k-edit-label"><label for="k-editor-table-rows">#= messages.rows #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-rows" /></div><div class="k-edit-label"><label for="k-editor-table-cell-spacing">#= messages.cellSpacing #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-cell-spacing" /></div><div class="k-edit-label"><label for="k-editor-table-cell-padding">#= messages.cellPadding #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-cell-padding" /></div><div class="k-edit-label"><label for="k-editor-table-alignment">#= messages.alignment #</label></div><div class="k-edit-field"><input id="k-editor-table-alignment" class="k-align" /></div><div class="k-edit-label"><label for="k-editor-table-bg">#= messages.background #</label></div><div class="k-edit-field"><input id="k-editor-table-bg" /></div><div class="k-edit-label"><label for="k-editor-css-class">#= messages.cssClass #</label></div><div class="k-edit-field"><input id="k-editor-css-class" class="k-input k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-id">#= messages.id #</label></div><div class="k-edit-field"><input id="k-editor-id" class="k-input k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-border-width">#= messages.border #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-border-width" /><input id="k-editor-border-color" /></div><div class="k-edit-label"><label for="k-editor-border-style">#= messages.borderStyle #</label></div><div class="k-edit-field"><input id="k-editor-border-style" /></div><div class="k-edit-label">&nbsp;</div><div class="k-edit-field"><input id="k-editor-collapse-borders" type="checkbox" class="k-checkbox" /><label for="k-editor-collapse-borders" class="k-checkbox-label">#= messages.collapseBorders #</label></div></div><div id="k-cell-properties"><div class="k-edit-field"><input id="k-editor-selectAllCells" type="checkbox" class="k-checkbox" /><label for="k-editor-selectAllCells" class="k-checkbox-label">#= messages.selectAllCells #</label></div><div class="k-edit-label"><label for="k-editor-cell-width">#= messages.width #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-cell-width" /><input id="k-editor-cell-width-type" aria-label="#= messages.units #" /></div><div class="k-edit-label"><label for="k-editor-cell-height">#= messages.height #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-cell-height" /><input id="k-editor-cell-height-type" aria-label="#= messages.units #" /></div><div class="k-edit-label"><label for="k-editor-table-cell-margin">#= messages.cellMargin #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-cell-margin" /></div><div class="k-edit-label"><label for="k-editor-table-cells-padding">#= messages.cellPadding #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-cells-padding" /></div><div class="k-edit-label"><label for="k-editor-cell-alignment">#= messages.alignment #</label></div><div class="k-edit-field"><input id="k-editor-cell-alignment" class="k-align" /></div><div class="k-edit-label"><label for="k-editor-cell-bg">#= messages.background #</label></div><div class="k-edit-field"><input id="k-editor-cell-bg" /></div><div class="k-edit-label"><label for="k-editor-cell-css-class">#= messages.cssClass #</label></div><div class="k-edit-field"><input id="k-editor-cell-css-class" class="k-input k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-cell-id">#= messages.id #</label></div><div class="k-edit-field"><input id="k-editor-cell-id" class="k-input k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-cell-border-width">#= messages.border #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-cell-border-width" /><input id="k-editor-cell-border-color" /></div><div class="k-edit-label"><label for="k-editor-cell-border-style">#= messages.borderStyle #</label></div><div class="k-edit-field"><input id="k-editor-cell-border-style" /></div><div class="k-edit-label">&nbsp;</div><div class="k-edit-field"><input id="k-editor-wrap-text" type="checkbox" class="k-checkbox" /><label for="k-editor-wrap-text" class="k-checkbox-label">#= messages.wrapText #</label></div></div><div id="k-accessibility-properties"><div class="k-edit-label"><label for="k-editor-table-caption">#= messages.caption #</label></div><div class="k-edit-field"><input id="k-editor-table-caption" class="k-input k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-accessibility-alignment">#= messages.alignment #</label></div><div class="k-edit-field"><input id="k-editor-accessibility-alignment" class="k-align" /></div><div class="k-edit-label"><label for="k-editor-accessibility-summary">#= messages.summary #</label></div><div class="k-edit-field"><textarea id="k-editor-accessibility-summary" class="k-input k-textbox"></textarea></div><div class="k-edit-label">&nbsp;</div><div class="k-edit-field"><input id="k-editor-cells-headers" type="checkbox" class="k-checkbox" /><label for="k-editor-cells-headers" class="k-checkbox-label">#= messages.associateCellsWithHeaders #</label></div></div></div><div class="k-edit-buttons k-state-default"><button class="k-button k-primary k-dialog-ok">#= messages.dialogOk #</button><button class="k-button k-dialog-close">#= messages.dialogCancel #</button></div></div></div>',d=n.Class.extend({init:function(e){this.options=e},open:function(){function t(e){e.preventDefault(),l.destroy(),r.destroy()}function i(e){l.collectDialogValues(u),t(e),l.change&&l.change(),c.closeCallback(u)}function o(e){t(e),c.closeCallback()}var r,s,a,l=this,c=l.options,d=c.dialogOptions,u=c.table,h=c.messages,f=n.support.browser.msie;d.close=o,d.title=h.tableWizard,d.visible=c.visible,r=e(l._dialogTemplate(h)).appendTo(document.body).kendoWindow(d).closest(".k-window").toggleClass("k-rtl",c.isRtl).end().find(".k-dialog-ok").click(i).end().find(".k-dialog-close").click(o).end().data("kendoWindow"),s=r.element,l._initTabStripComponent(s),l._initTableViewComponents(s,u),l._initCellViewComponents(s,u),l._initAccessibilityViewComponents(s,u),r.center(),r.open(),f&&(a=s.closest(".k-window").height(),s.css("max-height",a))},_initTabStripComponent:function(e){var t=this.components={};t.tabStrip=e.find("#k-table-wizard-tabs").kendoTabStrip({animation:!1}).data("kendoTabStrip")},collectDialogValues:function(){var e=this,t=e.options.table;e._collectTableViewValues(t),e._collectCellViewValues(t),e._collectAccessibilityViewValues(t)},_collectTableViewValues:function(e){var t=this.components.tableView,n=e.tableProperties;n.width=t.width.value(),n.widthUnit=t.widthUnit.value(),n.height=t.height.value(),n.columns=t.columns.value(),n.rows=t.rows.value(),n.heightUnit=t.heightUnit.value(),n.cellSpacing=t.cellSpacing.value(),n.cellPadding=t.cellPadding.value(),n.alignment=t.alignment.value(),n.bgColor=t.bgColor.value(),n.className=t.className.value,n.id=t.id.value,n.borderWidth=t.borderWidth.value(),n.borderColor=t.borderColor.value(),n.borderStyle=t.borderStyle.value(),n.collapseBorders=t.collapseBorders.checked},_collectCellViewValues:function(e){var t=e.cellProperties={},n=this.components.cellView;t.selectAllCells=n.selectAllCells.checked,t.width=n.width.value(),t.widthUnit=n.widthUnit.value(),t.height=n.height.value(),t.heightUnit=n.heightUnit.value(),t.cellMargin=n.cellMargin.value(),t.cellPadding=n.cellPadding.value(),t.alignment=n.alignment.value(),t.bgColor=n.bgColor.value(),t.className=n.className.value,t.id=n.id.value,t.borderWidth=n.borderWidth.value(),t.borderColor=n.borderColor.value(),t.borderStyle=n.borderStyle.value(),t.wrapText=n.wrapText.checked,t.width||(t.selectAllCells=!0,t.width=100/e.tableProperties.columns,t.widthUnit="%")},_collectAccessibilityViewValues:function(e){var t=e.tableProperties,n=this.components.accessibilityView;t.captionContent=n.captionContent.value,t.captionAlignment=n.captionAlignment.value(),t.summary=n.summary.value,t.cellsWithHeaders=n.cellsWithHeaders.checked},_addUnit:function(t,n){n&&e.inArray(n,t)==-1&&t.push(n)},_initTableViewComponents:function(e,t){var n=this.components,i=n.tableView={},s=t.tableProperties=t.tableProperties||{};s.borderStyle=s.borderStyle||"",this._addUnit(o,s.widthUnit),this._addUnit(o,s.heightUnit),this._initNumericTextbox(e.find("#k-editor-table-width"),"width",s,i),this._initNumericTextbox(e.find("#k-editor-table-height"),"height",s,i),this._initNumericTextbox(e.find("#k-editor-table-columns"),"columns",s,i,{min:1,value:4}),this._initNumericTextbox(e.find("#k-editor-table-rows"),"rows",s,i,{min:1,value:4}),this._initDropDownList(e.find("#k-editor-table-width-type"),"widthUnit",s,i,o),this._initDropDownList(e.find("#k-editor-table-height-type"),"heightUnit",s,i,o),this._initNumericTextbox(e.find("#k-editor-table-cell-spacing"),"cellSpacing",s,i),this._initNumericTextbox(e.find("#k-editor-table-cell-padding"),"cellPadding",s,i),this._initTableAlignmentDropDown(e.find("#k-editor-table-alignment"),s),this._initColorPicker(e.find("#k-editor-table-bg"),"bgColor",s,i),this._initInput(e.find("#k-editor-css-class"),"className",s,i),this._initInput(e.find("#k-editor-id"),"id",s,i),this._initNumericTextbox(e.find("#k-editor-border-width"),"borderWidth",s,i),this._initColorPicker(e.find("#k-editor-border-color"),"borderColor",s,i),this._initDropDownList(e.find("#k-editor-border-style"),"borderStyle",s,i,r),this._initCheckbox(e.find("#k-editor-collapse-borders"),"collapseBorders",s,i)},_initCellViewComponents:function(e,t){var n,i=this.components,s=i.cellView={};t.selectedCells=t.selectedCells=t.selectedCells||[],n=t.selectedCells[0]||{borderStyle:"",wrapText:!0},this._addUnit(o,n.widthUnit),this._addUnit(o,n.heightUnit),this._initCheckbox(e.find("#k-editor-selectAllCells"),"selectAllCells",t.tableProperties,s),this._initNumericTextbox(e.find("#k-editor-cell-width"),"width",n,s),this._initNumericTextbox(e.find("#k-editor-cell-height"),"height",n,s),this._initDropDownList(e.find("#k-editor-cell-width-type"),"widthUnit",n,s,o),this._initDropDownList(e.find("#k-editor-cell-height-type"),"heightUnit",n,s,o),this._initNumericTextbox(e.find("#k-editor-table-cell-margin"),"cellMargin",n,s),this._initNumericTextbox(e.find("#k-editor-table-cells-padding"),"cellPadding",n,s),this._initCellAlignmentDropDown(e.find("#k-editor-cell-alignment"),n),this._initColorPicker(e.find("#k-editor-cell-bg"),"bgColor",n,s),this._initInput(e.find("#k-editor-cell-css-class"),"className",n,s),this._initInput(e.find("#k-editor-cell-id"),"id",n,s),this._initNumericTextbox(e.find("#k-editor-cell-border-width"),"borderWidth",n,s),this._initColorPicker(e.find("#k-editor-cell-border-color"),"borderColor",n,s),this._initDropDownList(e.find("#k-editor-cell-border-style"),"borderStyle",n,s,r),this._initCheckbox(e.find("#k-editor-wrap-text"),"wrapText",n,s)},_initAccessibilityViewComponents:function(e,t){var n=this.components,i=n.accessibilityView={},o=t.tableProperties;this._initInput(e.find("#k-editor-table-caption"),"captionContent",o,i),this._initAccessibilityAlignmentDropDown(e.find("#k-editor-accessibility-alignment"),o),this._initInput(e.find("#k-editor-accessibility-summary"),"summary",o,i),this._initCheckbox(e.find("#k-editor-cells-headers"),"cellsWithHeaders",o,i)},_initNumericTextbox:function(t,n,o,r,s){var a=r[n]=t.kendoNumericTextBox(s?e.extend({},i,s):i).data("kendoNumericTextBox");n in o&&a.value(parseInt(o[n],10))},_initDropDownList:function(e,t,n,i,o){var r=i[t]=e.kendoDropDownList({dataSource:o}).data("kendoDropDownList");this._setComponentValue(r,n,t)},_initTableAlignmentDropDown:function(e,t){var n=this.options.messages,i=this.components.tableView,o=s.dataSource;o[0].tooltip=n.alignLeft,o[1].tooltip=n.alignCenter,o[2].tooltip=n.alignRight,o[3].tooltip=n.alignRemove,this._initAlignmentDropDown(e,s,"alignment",t,i)},_initCellAlignmentDropDown:function(e,t){var n=this.options.messages,i=this.components.cellView,o=a.dataSource;o[0].tooltip=n.alignLeftTop,o[1].tooltip=n.alignCenterTop,o[2].tooltip=n.alignRightTop,o[3].tooltip=n.alignLeftMiddle,o[4].tooltip=n.alignCenterMiddle,o[5].tooltip=n.alignRightMiddle,o[6].tooltip=n.alignLeftBottom,o[7].tooltip=n.alignCenterBottom,o[8].tooltip=n.alignRightBottom,o[9].tooltip=n.alignRemove,this._initAlignmentDropDown(e,a,"alignment",t,i)},_initAccessibilityAlignmentDropDown:function(e,t){var n=this.options.messages,i=this.components.accessibilityView,o=l.dataSource;o[0].tooltip=n.alignLeftTop,o[1].tooltip=n.alignCenterTop,o[2].tooltip=n.alignRightTop,o[3].tooltip=n.alignLeftBottom,o[4].tooltip=n.alignCenterBottom,o[5].tooltip=n.alignRightBottom,o[6].tooltip=n.alignRemove,this._initAlignmentDropDown(e,l,"captionAlignment",t,i)},_initAlignmentDropDown:function(e,t,n,i,o){var r=o[n]=e.kendoDropDownList(t).data("kendoDropDownList");r.list.addClass("k-align").css("width","110px"),this._setComponentValue(r,i,n)},_setComponentValue:function(e,t,n){n in t&&e.value(t[n])},_initColorPicker:function(e,t,n,i){var o=i[t]=e.kendoColorPicker({buttons:!1,clearButton:!0}).data("kendoColorPicker");n[t]&&o.value(n[t])},_initInput:function(e,t,n,i){var o=i[t]=e.get(0);t in n&&(o.value=n[t])},_initCheckbox:function(e,t,n,i){var o=i[t]=e.get(0);t in n&&(o.checked=n[t])},destroy:function(){this._destroyComponents(this.components.tableView),this._destroyComponents(this.components.cellView),this._destroyComponents(this.components.accessibilityView),this._destroyComponents(this.components),delete this.components},_destroyComponents:function(e){for(var t in e)e[t].destroy&&e[t].destroy(),delete e[t]},_dialogTemplate:function(e){return n.template(c)({messages:e})}});n.ui.editor.TableWizardDialog=d}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.editor.min",["kendo.combobox.min","kendo.dropdownlist.min","kendo.resizable.min","kendo.window.min","kendo.colorpicker.min","kendo.imagebrowser.min","kendo.tabstrip.min","kendo.numerictextbox.min","util/undoredostack.min","editor/main.min","editor/dom.min","editor/serializer.min","editor/range.min","editor/command.min","editor/components.min","editor/toolbar.min","editor/immutables.min","editor/plugins/viewhtml.min","editor/plugins/link.min","editor/plugins/lists.min","editor/plugins/formatting.min","editor/plugins/image.min","editor/plugins/import.min","editor/plugins/insert.min","editor/plugins/export.min","editor/plugins/indent.min","editor/plugins/linebreak.min","editor/plugins/format.min","editor/plugins/inlineformat.min","editor/plugins/formatblock.min","editor/plugins/file.min","editor/plugins/tables.min","editor/plugins/clipboard.min","editor/plugins/keyboard.min","editor/plugins/exportpdf.min","editor/plugins/print.min","editor/resizing/column-resizing.min","editor/resizing/row-resizing.min","editor/resizing/table-resizing.min","editor/resizing/table-resize-handle.min","editor/table-wizard/table-wizard-command.min","editor/table-wizard/table-wizard-dialog.min"],e)}(function(){return window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.maskedtextbox.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(e){return e+u}function i(e,t){for(var n=0;n<t.length&&e[n]===t[n];)n++;return n}var o=window,r=o.Math.min,s=o.kendo,a=s.caret,l=s.keys,c=s.ui,d=c.Widget,u=".kendoMaskedTextBox",h=e.proxy,f=window.setTimeout,p="k-state-disabled",m="k-state-invalid",g="disabled",v="readonly",_="change",b="mouseup",w="drop",y="keydown",k="paste",x="input",C=n(s.support.propertyChangeEvent?"propertychange":x),S=d.extend({init:function(t,n){var i,o,r=this;d.fn.init.call(r,t,n),r._rules=e.extend({},r.rules,r.options.rules),t=r.element,i=t[0],r._wrapper(),r._tokenize(),r._form(),r.element.addClass("k-textbox").attr("autocomplete","off").on("focus"+u,function(){var e=i.value;e?r._togglePrompt(!0):i.value=r._old=r._emptyMask,r._oldValue=e,r._timeoutId=f(function(){a(t,0,e?r._maskLength:0)})}).on("focusout"+u,function(){var e=t.val();clearTimeout(r._timeoutId),i.value=r._old="",e!==r._emptyMask&&(i.value=r._old=e),r._change(),r._togglePrompt()}),o=t.is("[disabled]")||e(r.element).parents("fieldset").is(":disabled"),o?r.enable(!1):r.readonly(t.is("[readonly]")),r.value(r.options.value||t.val()),
r._validationIcon=e("<span class='k-icon k-i-warning'></span>").insertAfter(t),s.notify(r)},options:{name:"MaskedTextBox",clearPromptChar:!1,unmaskOnPost:!1,promptChar:"_",culture:"",rules:{},value:"",mask:""},events:[_],rules:{0:/\d/,9:/\d|\s/,"#":/\d|\s|\+|\-/,L:/[a-zA-Z]/,"?":/[a-zA-Z]|\s/,"&":/\S/,C:/./,A:/[a-zA-Z0-9]/,a:/[a-zA-Z0-9]|\s/},setOptions:function(t){var n=this;d.fn.setOptions.call(n,t),n._rules=e.extend({},n.rules,n.options.rules),n._tokenize(),this._unbindInput(),this._bindInput(),n.value(n.element.val())},destroy:function(){var e=this;e.element.off(u),e._formElement&&(e._formElement.off("reset",e._resetHandler),e._formElement.off("submit",e._submitHandler)),d.fn.destroy.call(e)},raw:function(){var e=this._unmask(this.element.val(),0);return e.replace(RegExp(this.options.promptChar,"g"),"")},value:function(e){var n=this.element,i=this._emptyMask;return e===t?this.element.val():(null===e&&(e=""),i?(e=this._unmask(e+""),n.val(e?i:""),this._mask(0,this._maskLength,e),this._unmaskedValue=null,e=n.val(),this._oldValue=e,s._activeElement()!==n&&(e===i?n.val(""):this._togglePrompt()),t):(this._oldValue=e,n.val(e),t))},_togglePrompt:function(e){var t=this.element[0],n=t.value;this.options.clearPromptChar&&(n=e?this._oldValue:n.replace(RegExp(this.options.promptChar,"g")," "),t.value=this._old=n)},readonly:function(e){this._editable({readonly:e===t||e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t||e)})},_bindInput:function(){var e,t,i=this;i._maskLength&&(i.options.$angular&&i.element.off(x),i.element.on(n(y),h(i._keydown,i)).on(n(w),h(i._drop,i)).on(n(_),h(i._trackChange,i)).on(C,h(i._inputHandler,i)),s.support.browser.msie&&(e=s.support.browser.version,e>8&&e<11&&(t=[n(b),n(w),n(y),n(k)].join(" "),i.element.on(t,h(i._legacyIEInputHandler,i)))))},_unbindInput:function(){var e=[C,n(y),n(b),n(w),n(k)].join(" ");this.element.off(e)},_editable:function(e){var t=this,n=t.element,i=t.wrapper,o=e.disable,r=e.readonly;t._unbindInput(),r||o?(n.attr(g,o).attr(v,r),i.toggleClass(p,o)):(n.removeAttr(g).removeAttr(v),i.removeClass(p),t._bindInput())},_change:function(){var e=this,t=e.value();t!==e._oldValue?(e._oldValue=t,e.trigger(_),e.element.trigger(_)):""===t&&e.__changing&&e.element.trigger(_)},inputChange:function(e){var t,n,o,l,c,d=this,u=d._old,h=d.element[0],f=h.value,p=a(h),m=p[1],g=f.length-u.length,v=s.support.mobileOS;d.__dropping&&g<0||(g===-1&&v.android&&"chrome"===v.browser&&(e=!0),t=r(m,i(f,u)),n=f.substring(t,m),h.value=f.substring(0,t)+d._emptyMask.substring(t),o=d._mask(t,m,n),l=d._trimStartPromptChars(f.substring(m),r(g,o-t)),c=d._unmask(l,u.length-l.length),d._mask(o,o,c),e&&(o=d._findCaretPosBackwards(t)),a(h,o),d.__dropping=!1)},_trimStartPromptChars:function(e,t){for(var n=this.options.promptChar;t-- >0&&0===e.indexOf(n);)e=e.substring(1);return e},_findCaretPosBackwards:function(e){var t=this._find(e,!0);return t<e&&(t+=1),t},_inputHandler:function(){s._activeElement()===this.element[0]&&this.inputChange(this.__backward)},_legacyIEInputHandler:function(e){var t=this,n=t.element[0],i=n.value,o=e.type;t.__pasting="paste"===o,f(function(){"mouseup"===o&&t.__pasting||n.value&&n.value!==i&&t.inputChange(t.__backward)})},_trackChange:function(){var e=this;e.__changing=!0,f(function(){e.__changing=!1})},_form:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){f(function(){t.value(n[0].value)})},t._submitHandler=function(){t.element[0].value=t._old=t.raw()},t.options.unmaskOnPost&&o.on("submit",t._submitHandler),t._formElement=o.on("reset",t._resetHandler))},_keydown:function(e){var t=e.keyCode;this.__backward=t===l.BACKSPACE,t===l.ENTER&&this._change()},_drop:function(){this.__dropping=!0},_find:function(e,t){var n=this.element.val()||this._emptyMask,i=1;for(t===!0&&(i=-1);e>-1||e<=this._maskLength;){if(n.charAt(e)!==this.tokens[e])return e;e+=i}return-1},_mask:function(e,n,i,o){var r,l,c,d,u=this.element[0],h=u.value||this._emptyMask,f=this.options.promptChar,p=0;for(e=this._find(e,o),e>n&&(n=e),l=this._unmask(h.substring(n),n),i=this._unmask(i,e),r=i.length,i&&(l=l.replace(RegExp("^_{0,"+r+"}"),"")),i+=l,h=h.split(""),c=i.charAt(p);e<this._maskLength;)h[e]=c||f,c=i.charAt(++p),d===t&&p>r&&(d=e),e=this._find(e+1);return u.value=this._old=h.join(""),s._activeElement()===u&&(d===t&&(d=this._maskLength),a(u,d)),d},_unmask:function(t,n){var i,o,r,s,a,l,c,d;if(!t)return"";if(this._unmaskedValue===t)return this._unmaskedValue;for(t=(t+"").split(""),r=0,s=n||0,a=this.options.promptChar,l=t.length,c=this.tokens.length,d="";s<c&&(i=t[r],o=this.tokens[s],i===o||i===a?(d+=i===a?a:"",r+=1,s+=1):"string"!=typeof o?(o&&o.test&&o.test(i)||e.isFunction(o)&&o(i)?(d+=i,s+=1):1===l&&this._blinkInvalidState(),r+=1):s+=1,!(r>=l)););return this._unmaskedValue=d,d},_wrapper:function(){var e=this,t=e.element,n=t[0],i=t.wrap("<span class='k-widget k-maskedtextbox'></span>").parent();i[0].style.cssText=n.style.cssText,n.style.width="100%",e.wrapper=i.addClass(n.className)},_blinkInvalidState:function(){var e=this;e.wrapper.addClass(m),clearTimeout(e._invalidStateTimeout),e._invalidStateTimeout=f(h(e._removeInvalidState,e),100)},_removeInvalidState:function(){var e=this;e.wrapper.removeClass(m),e._invalidStateTimeout=null},_tokenize:function(){for(var e,t,n,i,o=[],r=0,a=this.options.mask||"",l=a.split(""),c=l.length,d=0,u="",h=this.options.promptChar,f=s.getCulture(this.options.culture).numberFormat,p=this._rules;d<c;d++)if(e=l[d],t=p[e])o[r]=t,u+=h,r+=1;else for("."===e||","===e?e=f[e]:"$"===e?e=f.currency.symbol:"\\"===e&&(d+=1,e=l[d]),e=e.split(""),n=0,i=e.length;n<i;n++)o[r]=e[n],u+=e[n],r+=1;this.tokens=o,this._emptyMask=u,this._maskLength=u.length}});c.plugin(S)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.toolbar.min",["kendo.core.min","kendo.userevents.min","kendo.popup.min"],e)}(function(){return function(e,t){function n(e){e.target.is(".k-toggle-button")||e.target.toggleClass(H,"press"==e.type)}function i(t){return t=e(t),t.hasClass("km-actionsheet")?t.closest(".km-popup-wrapper"):t.addClass("km-widget km-actionsheet").wrap('<div class="km-actionsheet-wrapper km-actionsheet-tablet km-widget km-popup"></div>').parent().wrap('<div class="km-popup-wrapper k-popup"></div>').parent()}function o(t){e(t.target).closest("a.k-button").length&&t.preventDefault()}function r(t,n){var i="next"===n?e.fn.next:e.fn.prev,o="next"===n?e.fn.first:e.fn.last,s=i.call(t);return s.is(":kendoFocusable")||!s.length?s:s.find(":kendoFocusable").length?o.call(s.find(":kendoFocusable")):r(s,n)}var s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k=window.kendo,x=k.Class,C=k.ui.Widget,S=e.proxy,T=k.isFunction,D=k.keys,A=k._outerWidth,E="k-toolbar",I="k-button",M="k-overflow-button",R="k-toggle-button",F="k-button-group",z="k-split-button",P="k-separator",B="k-popup",L="k-toolbar-resizable",H="k-state-active",N="k-state-disabled",O="k-state-hidden",V="k-group-start",U="k-group-end",W="k-primary",j="k-icon",q="k-i-",G="k-button-icon",$="k-button-icontext",K="k-list-container k-split-container",Y="k-split-button-arrow",Q="k-overflow-anchor",X="k-overflow-container",Z="k-toolbar-first-visible",J="k-toolbar-last-visible",ee="click",te="toggle",ne="open",ie="close",oe="overflowOpen",re="overflowClose",se="never",ae="auto",le="always",ce="k-overflow-hidden",de="_optionlist",ue=k.attr("uid");k.toolbar={},s={overflowAnchor:'<div tabindex="0" class="k-overflow-anchor"></div>',overflowContainer:'<ul class="k-overflow-container k-list-container"></ul>'},k.toolbar.registerComponent=function(e,t,n){s[e]={toolbar:t,overflow:n}},a=k.Class.extend({addOverflowAttr:function(){this.element.attr(k.attr("overflow"),this.options.overflow||ae)},addUidAttr:function(){this.element.attr(ue,this.options.uid)},addIdAttr:function(){this.options.id&&this.element.attr("id",this.options.id)},addOverflowIdAttr:function(){this.options.id&&this.element.attr("id",this.options.id+"_overflow")},attributes:function(){this.options.attributes&&this.element.attr(this.options.attributes)},show:function(){this.element.removeClass(O).show(),this.options.hidden=!1},hide:function(){this.element.addClass(O).hide(),this.overflow&&this.overflowHidden&&this.overflowHidden(),this.options.hidden=!0},remove:function(){this.element.remove()},enable:function(e){e===t&&(e=!0),this.element.toggleClass(N,!e),this.options.enable=e},twin:function(){var n=this.element.attr(ue);return this.overflow&&this.options.splitContainerId?e("#"+this.options.splitContainerId).find("["+ue+"='"+n+"']").data(this.options.type):this.overflow?this.toolbar.element.find("["+ue+"='"+n+"']").data(this.options.type):this.toolbar.options.resizable?this.toolbar.popup.element.find("["+ue+"='"+n+"']").data(this.options.type):t}}),k.toolbar.Item=a,l=a.extend({init:function(n,i){var o=e(n.useButtonTag?'<button tabindex="0"></button>':'<a href tabindex="0"></a>');this.element=o,this.options=n,this.toolbar=i,this.attributes(),n.primary&&o.addClass(W),n.togglable&&(o.addClass(R),this.toggle(n.selected)),n.url===t||n.useButtonTag||(o.attr("href",n.url),n.mobile&&o.attr(k.attr("role"),"button")),n.group&&(o.attr(k.attr("group"),n.group),this.group=this.toolbar.addToGroup(this,n.group)),!n.togglable&&n.click&&T(n.click)&&(this.clickHandler=n.click),n.togglable&&n.toggle&&T(n.toggle)&&(this.toggleHandler=n.toggle)},toggle:function(e,t){e=!!e,this.group&&e?this.group.select(this):this.group||this.select(e),t&&this.twin()&&this.twin().toggle(e)},getParentGroup:function(){if(this.options.isChild)return this.element.closest("."+F).data("buttonGroup")},_addGraphics:function(){var t,n,i,o=this.element,r=this.options.icon,s=this.options.spriteCssClass,a=this.options.imageUrl;(s||a||r)&&(t=!0,o.contents().filter(function(){return!e(this).hasClass("k-sprite")&&!e(this).hasClass(j)&&!e(this).hasClass("k-image")}).each(function(n,i){(1==i.nodeType||3==i.nodeType&&e.trim(i.nodeValue).length>0)&&(t=!1)}),o.addClass(t?G:$)),r?(n=o.children("span."+j).first(),n[0]||(n=e('<span class="'+j+'"></span>').prependTo(o)),n.addClass(q+r)):s?(n=o.children("span.k-sprite").first(),n[0]||(n=e('<span class="k-sprite '+j+'"></span>').prependTo(o)),n.addClass(s)):a&&(i=o.children("img.k-image").first(),i[0]||(i=e('<img alt="icon" class="k-image" />').prependTo(o)),i.attr("src",a))}}),k.toolbar.Button=l,c=l.extend({init:function(e,t){l.fn.init.call(this,e,t);var n=this.element;n.addClass(I),this.addIdAttr(),e.align&&n.addClass("k-align-"+e.align),"overflow"!=e.showText&&e.text&&n.html(e.mobile?'<span class="km-text">'+e.text+"</span>":e.text),e.hasIcon="overflow"!=e.showIcon&&(e.icon||e.spriteCssClass||e.imageUrl),e.hasIcon&&this._addGraphics(),this.addUidAttr(),this.addOverflowAttr(),this.enable(e.enable),e.hidden&&this.hide(),this.element.data({type:"button",button:this})},select:function(e){e===t&&(e=!1),this.element.toggleClass(H,e),this.options.selected=e}}),k.toolbar.ToolBarButton=c,d=l.extend({init:function(t,n){this.overflow=!0,l.fn.init.call(this,e.extend({},t),n);var i=this.element;"toolbar"!=t.showText&&t.text&&i.html(t.mobile?'<span class="km-text">'+t.text+"</span>":'<span class="k-text">'+t.text+"</span>"),t.hasIcon="toolbar"!=t.showIcon&&(t.icon||t.spriteCssClass||t.imageUrl),t.hasIcon&&this._addGraphics(),t.isChild||this._wrap(),this.addOverflowIdAttr(),this.attributes(),this.addUidAttr(),this.addOverflowAttr(),this.enable(t.enable),i.addClass(M+" "+I),t.hidden&&this.hide(),t.togglable&&this.toggle(t.selected),this.element.data({type:"button",button:this})},_wrap:function(){this.element=this.element.wrap("<li></li>").parent()},overflowHidden:function(){this.element.addClass(ce)},select:function(e){e===t&&(e=!1),this.options.isChild?this.element.toggleClass(H,e):this.element.find(".k-button").toggleClass(H,e),this.options.selected=e}}),k.toolbar.OverflowButton=d,k.toolbar.registerComponent("button",c,d),u=a.extend({createButtons:function(t){var n,i,o=this.options,r=o.buttons||[];for(i=0;i<r.length;i++)r[i].uid||(r[i].uid=k.guid()),n=new t(e.extend({mobile:o.mobile,isChild:!0,type:"button"},r[i]),this.toolbar),n.element.appendTo(this.element)},refresh:function(){this.element.children().filter(":not('."+O+"'):first").addClass(V),this.element.children().filter(":not('."+O+"'):last").addClass(U)}}),k.toolbar.ButtonGroup=u,h=u.extend({init:function(t,n){var i=this.element=e("<div></div>");this.options=t,this.toolbar=n,this.addIdAttr(),t.align&&i.addClass("k-align-"+t.align),this.createButtons(c),this.attributes(),this.addUidAttr(),this.addOverflowAttr(),this.refresh(),i.addClass(F),this.element.data({type:"buttonGroup",buttonGroup:this})}}),k.toolbar.ToolBarButtonGroup=h,f=u.extend({init:function(t,n){var i=this.element=e("<li></li>");this.options=t,this.toolbar=n,this.overflow=!0,this.addOverflowIdAttr(),this.createButtons(d),this.attributes(),this.addUidAttr(),this.addOverflowAttr(),this.refresh(),i.addClass((t.mobile?"":F)+" k-overflow-group"),this.element.data({type:"buttonGroup",buttonGroup:this})},overflowHidden:function(){this.element.addClass(ce)}}),k.toolbar.OverflowButtonGroup=f,k.toolbar.registerComponent("buttonGroup",h,f),p=a.extend({init:function(t,n){var i=this.element=e('<div class="'+z+'" tabindex="0"></div>');this.options=t,this.toolbar=n,this.mainButton=new c(e.extend({},t,{hidden:!1}),n),this.arrowButton=e('<a class="'+I+" "+Y+'"><span class="'+(t.mobile?"km-icon km-arrowdown":"k-icon k-i-arrow-60-down")+'"></span></a>'),this.popupElement=e('<ul class="'+K+'"></ul>'),this.mainButton.element.removeAttr("href tabindex").appendTo(i),this.arrowButton.appendTo(i),this.popupElement.appendTo(i),t.align&&i.addClass("k-align-"+t.align),t.id||(t.id=t.uid),i.attr("id",t.id+"_wrapper"),this.addOverflowAttr(),this.addUidAttr(),this.createMenuButtons(),this.createPopup(),this._navigatable(),this.mainButton.main=!0,this.enable(t.enable),t.hidden&&this.hide(),i.data({type:"splitButton",splitButton:this,kendoPopup:this.popup})},_navigatable:function(){var t=this;t.popupElement.on("keydown","."+I,function(n){var i=e(n.target).parent();n.preventDefault(),n.keyCode===D.ESC||n.keyCode===D.TAB||n.altKey&&n.keyCode===D.UP?(t.toggle(),t.focus()):n.keyCode===D.DOWN?r(i,"next").focus():n.keyCode===D.UP?r(i,"prev").focus():n.keyCode===D.SPACEBAR||n.keyCode===D.ENTER?t.toolbar.userEvents.trigger("tap",{target:e(n.target)}):n.keyCode===D.HOME?i.parent().find(":kendoFocusable").first().focus():n.keyCode===D.END&&i.parent().find(":kendoFocusable").last().focus()})},createMenuButtons:function(){var t,n,i=this.options,o=i.menuButtons;for(n=0;n<o.length;n++)t=new c(e.extend({mobile:i.mobile,type:"button",click:i.click},o[n]),this.toolbar),t.element.wrap("<li></li>").parent().appendTo(this.popupElement)},createPopup:function(){var n=this,r=this.options,s=this.element;this.popupElement.attr("id",r.id+de).attr(ue,r.rootUid),r.mobile&&(this.popupElement=i(this.popupElement)),this.popup=this.popupElement.kendoPopup({appendTo:r.mobile?e(r.mobile).children(".km-pane"):null,anchor:s,isRtl:this.toolbar._isRtl,copyAnchorStyles:!1,animation:r.animation,open:function(e){var i=n.toolbar.trigger(ne,{target:s});return i?(e.preventDefault(),t):(n.adjustPopupWidth(e.sender),t)},activate:function(){this.element.find(":kendoFocusable").first().focus()},close:function(e){var t=n.toolbar.trigger(ie,{target:s});t&&e.preventDefault(),s.focus()}}).data("kendoPopup"),this.popup.element.on(ee,"a.k-button",o)},adjustPopupWidth:function(e){var t,n=e.options.anchor,i=A(n);k.wrap(e.element).addClass("k-split-wrapper"),t="border-box"!==e.element.css("box-sizing")?i-(A(e.element)-e.element.width()):i,e.element.css({fontFamily:n.css("font-family"),"min-width":t})},remove:function(){this.popup.element.off(ee,"a.k-button"),this.popup.destroy(),this.element.remove()},toggle:function(){(this.options.enable||this.popup.visible())&&this.popup.toggle()},enable:function(e){e===t&&(e=!0),this.mainButton.enable(e),this.element.toggleClass(N,!e),this.options.enable=e},focus:function(){this.element.focus()},hide:function(){this.popup&&this.popup.close(),this.element.addClass(O).hide(),this.options.hidden=!0},show:function(){this.element.removeClass(O).hide(),this.options.hidden=!1}}),k.toolbar.ToolBarSplitButton=p,m=a.extend({init:function(t,n){var i,o,r,s=this.element=e('<li class="'+z+'"></li>'),a=t.menuButtons;for(this.options=t,this.toolbar=n,this.overflow=!0,o=(t.id||t.uid)+de,this.mainButton=new d(e.extend({},t)),this.mainButton.element.appendTo(s),r=0;r<a.length;r++)i=new d(e.extend({mobile:t.mobile,type:"button",splitContainerId:o},a[r]),this.toolbar),i.element.appendTo(s);this.addUidAttr(),this.addOverflowAttr(),this.mainButton.main=!0,s.data({type:"splitButton",splitButton:this})},overflowHidden:function(){this.element.addClass(ce)}}),k.toolbar.OverflowSplitButton=m,k.toolbar.registerComponent("splitButton",p,m),g=a.extend({init:function(t,n){var i=this.element=e("<div>&nbsp;</div>");this.element=i,this.options=t,this.toolbar=n,this.attributes(),this.addIdAttr(),this.addUidAttr(),this.addOverflowAttr(),i.addClass(P),i.data({type:"separator",separator:this})}}),v=a.extend({init:function(t,n){var i=this.element=e("<li>&nbsp;</li>");this.element=i,this.options=t,this.toolbar=n,this.overflow=!0,this.attributes(),this.addUidAttr(),this.addOverflowIdAttr(),i.addClass(P),i.data({type:"separator",separator:this})},overflowHidden:function(){this.element.addClass(ce)}}),k.toolbar.registerComponent("separator",g,v),_=a.extend({init:function(t,n,i){var o=T(t)?t(n):t;o=o instanceof jQuery?o.wrap("<div></div>").parent():e("<div></div>").html(o),this.element=o,this.options=n,this.options.type="template",this.toolbar=i,this.attributes(),this.addUidAttr(),this.addIdAttr(),this.addOverflowAttr(),o.data({type:"template",template:this})}}),k.toolbar.TemplateItem=_,b=a.extend({init:function(t,n,i){var o=e(T(t)?t(n):t);o=o instanceof jQuery?o.wrap("<li></li>").parent():e("<li></li>").html(o),this.element=o,this.options=n,this.options.type="template",this.toolbar=i,this.overflow=!0,this.attributes(),this.addUidAttr(),this.addOverflowIdAttr(),this.addOverflowAttr(),o.data({type:"template",template:this})},overflowHidden:function(){this.element.addClass(ce)}}),k.toolbar.OverflowTemplateItem=b,w=x.extend({init:function(e){this.name=e,this.buttons=[]},add:function(e){this.buttons[this.buttons.length]=e},remove:function(t){var n=e.inArray(t,this.buttons);this.buttons.splice(n,1)},select:function(e){var t,n;for(n=0;n<this.buttons.length;n++)t=this.buttons[n],t.select(!1);e.select(!0),e.twin()&&e.twin().select(!0)}}),y=C.extend({init:function(t,i){var r,s=this;if(C.fn.init.call(s,t,i),i=s.options,t=s.wrapper=s.element,t.addClass(E+" k-widget"),this.uid=k.guid(),this._isRtl=k.support.isRtl(t),this._groups={},t.attr(ue,this.uid),s.isMobile="boolean"==typeof i.mobile?i.mobile:s.element.closest(".km-root")[0],s.animation=s.isMobile?{open:{effects:"fade"}}:{},s.isMobile&&(t.addClass("km-widget"),j="km-icon",q="km-",I="km-button",F="km-buttongroup km-widget",H="km-state-active",N="km-state-disabled"),i.resizable?(s._renderOverflow(),t.addClass(L),s.overflowUserEvents=new k.UserEvents(s.element,{threshold:5,allowSelection:!0,filter:"."+Q,tap:S(s._toggleOverflow,s)}),s._resizeHandler=k.onResize(function(){s.resize()})):s.popup={element:e([])},i.items&&i.items.length){for(r=0;r<i.items.length;r++)s.add(i.items[r]);s._shrink(s.element.innerWidth())}s.userEvents=new k.UserEvents(document,{threshold:5,allowSelection:!0,filter:"["+ue+"="+this.uid+"] a."+I+", ["+ue+"="+this.uid+"] ."+M,tap:S(s._buttonClick,s),press:n,release:n}),s.element.on(ee,"a.k-button",o),s._navigatable(),i.resizable&&s.popup.element.on(ee,NaN,o),i.resizable&&this._toggleOverflowAnchor(),k.notify(s)},events:[ee,te,ne,ie,oe,re],options:{name:"ToolBar",items:[],resizable:!0,mobile:null},addToGroup:function(e,t){var n;return n=this._groups[t]?this._groups[t]:this._groups[t]=new w,n.add(e),n},destroy:function(){var t=this;t.element.find("."+z).each(function(t,n){e(n).data("kendoPopup").destroy()}),t.element.off(ee,"a.k-button"),t.userEvents.destroy(),t.options.resizable&&(k.unbindResize(t._resizeHandler),t.overflowUserEvents.destroy(),t.popup.element.off(ee,"a.k-button"),t.popup.destroy()),C.fn.destroy.call(t)},add:function(t){var n,i,o,r=s[t.type],a=t.template,l=this,c=l.isMobile?"":"k-item k-state-default",d=t.overflowTemplate;if(e.extend(t,{uid:k.guid(),animation:l.animation,mobile:l.isMobile,rootUid:l.uid}),t.menuButtons)for(o=0;o<t.menuButtons.length;o++)e.extend(t.menuButtons[o],{uid:k.guid()});a&&!d?t.overflow=se:t.overflow||(t.overflow=ae),t.overflow!==se&&l.options.resizable&&(d?i=new b(d,t,l):r&&(i=new r.overflow(t,l),i.element.addClass(c)),i&&(t.overflow===ae&&i.overflowHidden(),i.element.appendTo(l.popup.container),l.angular("compile",function(){return{elements:i.element.get()}}))),t.overflow!==le&&(a?n=new _(a,t,l):r&&(n=new r.toolbar(t,l)),n&&(n.element.appendTo(l.element),l.angular("compile",function(){return{elements:n.element.get()}})))},_getItem:function(t){var n,i,o,r,s=this.options.resizable;return n=this.element.find(t),n.length||(n=e(".k-split-container[data-uid="+this.uid+"]").find(t)),r=n.length?n.data("type"):"",i=n.data(r),i?(i.main&&(n=n.parent("."+z),r="splitButton",i=n.data(r)),s&&(o=i.twin())):s&&(n=this.popup.element.find(t),r=n.length?n.data("type"):"",o=n.data(r),o&&o.main&&(n=n.parent("."+z),r="splitButton",o=n.data(r))),{type:r,toolbar:i,overflow:o}},remove:function(e){var t=this._getItem(e);t.toolbar&&t.toolbar.remove(),t.overflow&&t.overflow.remove(),this.resize(!0)},hide:function(e){var t=this._getItem(e);t.toolbar&&("button"===t.toolbar.options.type&&t.toolbar.options.isChild?(t.toolbar.hide(),t.toolbar.getParentGroup().refresh()):t.toolbar.options.hidden||t.toolbar.hide()),t.overflow&&("button"===t.overflow.options.type&&t.overflow.options.isChild?(t.overflow.hide(),t.overflow.getParentGroup().refresh()):t.overflow.options.hidden||t.overflow.hide()),this.resize(!0)},show:function(e){var t=this._getItem(e);t.toolbar&&("button"===t.toolbar.options.type&&t.toolbar.options.isChild?(t.toolbar.show(),t.toolbar.getParentGroup().refresh()):t.toolbar.options.hidden&&t.toolbar.show()),t.overflow&&("button"===t.overflow.options.type&&t.overflow.options.isChild?(t.toolbar.show(),t.overflow.getParentGroup().refresh()):t.overflow.options.hidden&&t.overflow.show()),this.resize(!0)},enable:function(e,n){var i=this._getItem(e);t===n&&(n=!0),i.toolbar&&i.toolbar.enable(n),i.overflow&&i.overflow.enable(n)},getSelectedFromGroup:function(e){return this.element.find("."+R+"[data-group='"+e+"']").filter("."+H)},toggle:function(n,i){var o=e(n),r=o.data("button");r.options.togglable&&(i===t&&(i=!0),r.toggle(i,!0))},_renderOverflow:function(){var t=this,n=s.overflowContainer,o=t._isRtl,a=o?"left":"right";t.overflowAnchor=e(s.overflowAnchor).addClass(I),t.element.append(t.overflowAnchor),t.isMobile?(t.overflowAnchor.append('<span class="km-icon km-more"></span>'),n=i(n)):t.overflowAnchor.append('<span class="k-icon k-i-more-vertical"></span>'),t.popup=new k.ui.Popup(n,{origin:"bottom "+a,position:"top "+a,anchor:t.overflowAnchor,isRtl:o,animation:t.animation,appendTo:t.isMobile?e(t.isMobile).children(".km-pane"):null,copyAnchorStyles:!1,open:function(n){var i=k.wrap(t.popup.element).addClass("k-overflow-wrapper");t.isMobile?t.popup.container.css("max-height",parseFloat(e(".km-content:visible").innerHeight())-15+"px"):i.css("margin-left",(o?-1:1)*((A(i)-i.width())/2+1)),t.trigger(oe)&&n.preventDefault()},activate:function(){this.element.find(":kendoFocusable").first().focus()},close:function(e){t.trigger(re)&&e.preventDefault(),this.element.focus()}}),t.popup.element.on("keydown","."+I,function(n){var i,o=e(n.target),s=o.parent(),a=s.is("."+F)||s.is("."+z);n.preventDefault(),n.keyCode===D.ESC||n.keyCode===D.TAB||n.altKey&&n.keyCode===D.UP?(t._toggleOverflow(),t.overflowAnchor.focus()):n.keyCode===D.DOWN?(i=!a||a&&o.is(":last-child")?s:o,r(i,"next").focus()):n.keyCode===D.UP?(i=!a||a&&o.is(":first-child")?s:o,r(i,"prev").focus()):n.keyCode===D.SPACEBAR||n.keyCode===D.ENTER?(t.userEvents.trigger("tap",{target:e(n.target)}),t.overflowAnchor.focus()):n.keyCode===D.HOME?s.parent().find(":kendoFocusable").first().focus():n.keyCode===D.END&&s.parent().find(":kendoFocusable").last().focus()}),t.popup.container=t.isMobile?t.popup.element.find("."+X):t.popup.element,t.popup.container.attr(ue,this.uid)},_toggleOverflowAnchor:function(){var e=!1;e=this.options.mobile?this.popup.element.find("."+X).children(":not(."+ce+", ."+B+")").length>0:this.popup.element.children(":not(."+ce+", ."+B+")").length>0,this.overflowAnchor.css(e?{visibility:"visible",width:""}:{visibility:"hidden",width:"1px"})},_buttonClick:function(n){var i,o,r,s,a,l,c,d=this,u=n.target.closest("."+Y).length;return n.preventDefault(),u?(d._toggle(n),t):(o=e(n.target).closest("."+I,d.element),o.hasClass(Q)||(r=o.data("button"),!r&&d.popup&&(o=e(n.target).closest("."+M,d.popup.container),r=o.parent("li").data("button")),r&&r.options.enable&&(r.options.togglable?(a=T(r.toggleHandler)?r.toggleHandler:null,r.toggle(!r.options.selected,!0),l={target:o,group:r.options.group,checked:r.options.selected,id:r.options.id},a&&a.call(d,l),d.trigger(te,l)):(a=T(r.clickHandler)?r.clickHandler:null,l={sender:d,target:o,id:r.options.id},a&&a.call(d,l),d.trigger(ee,l)),r.options.url&&(r.options.attributes&&r.options.attributes.target&&(c=r.options.attributes.target),window.open(r.options.url,c||"_self")),o.hasClass(M)&&d.popup.close(),s=o.closest(".k-split-container"),s[0]&&(i=s.data("kendoPopup"),(i?i:s.parents(".km-popup-wrapper").data("kendoPopup")).close()))),t)},_navigatable:function(){var t=this;t.element.attr("tabindex",0).on("focusin",function(t){var n=e(t.target),i=e(this).find(":kendoFocusable:first");n.is("."+E)&&0!==i.length&&(i.is("."+Q)&&(i=r(i,"next")),i[0].focus())}).on("keydown",S(t._keydown,t))},_keydown:function(n){var i,o,r,s,a,l,c,d=e(n.target),u=n.keyCode,h=this.element.children(":not(.k-separator):visible"),f=this._isRtl?-1:1;if(u===D.TAB&&(i=d.parentsUntil(this.element).last(),o=!1,r=!1,i.length||(i=d),i.is("."+Q)&&(n.shiftKey&&n.preventDefault(),h.last().is(":kendoFocusable")?h.last().focus():h.last().find(":kendoFocusable").last().focus()),n.shiftKey||h.index(i)!==h.length-1||(o=!i.is("."+F)||d.is(":last-child")),s=h.index(i)===h.not(".k-overflow-anchor").first().index(),n.shiftKey&&s&&(r=!i.is("."+F)||d.is(":first-child")),o&&this.overflowAnchor&&"hidden"!==this.overflowAnchor.css("visibility")&&(n.preventDefault(),this.overflowAnchor.focus()),r&&(n.preventDefault(),a=this._getPrevFocusable(this.wrapper),a&&a.focus()),this._preventNextFocus=!1),n.altKey&&u===D.DOWN)return l=e(document.activeElement).data("splitButton"),c=e(document.activeElement).is("."+Q),l?l.toggle():c&&this._toggleOverflow(),t;if((u===D.SPACEBAR||u===D.ENTER)&&!d.is("input, checkbox"))return n.preventDefault(),d.is("."+z)&&(d=d.children().first()),this.userEvents.trigger("tap",{target:d}),t;if(u===D.HOME){if(d.is(".k-dropdown")||d.is("input"))return;this.overflowAnchor?h.eq(1).focus():h.first().focus(),n.preventDefault()}else if(u===D.END){if(d.is(".k-dropdown")||d.is("input"))return;this.overflowAnchor&&"hidden"!=e(this.overflowAnchor).css("visibility")?this.overflowAnchor.focus():h.last().focus(),n.preventDefault()}else u!==D.RIGHT||this._preventNextFocus||d.is("input, select, .k-dropdown, .k-colorpicker")||!this._getNextElement(n.target,1*f)?u!==D.LEFT||this._preventNextFocus||d.is("input, select, .k-dropdown, .k-colorpicker")||!this._getNextElement(n.target,-1*f)||(this._getNextElement(n.target,-1*f).focus(),n.preventDefault()):(this._getNextElement(n.target,1*f).focus(),n.preventDefault())},_getNextElement:function(t,n){var i=this.element.children(":not(.k-separator):visible"),o=i.index(i.index(t)===-1?t.parentElement:t),r=this.overflowAnchor?1:0,s=n,a=1===n?i.length-1:r,l=1===n?r:i.length-1,c=i[o+n];if(this._preventNextFocus=!1,e(t).closest("."+F).length&&!e(t).is(1===n?":last-child":":first-child"))return e(t).closest("."+F).children()[e(t).closest("."+F).children().index(t)+n];for(this.overflowAnchor&&t===this.overflowAnchor[0]&&n===-1&&(c=i[i.length-1]),o===a&&(c=!this.overflowAnchor||this.overflowAnchor&&"hidden"===e(this.overflowAnchor).css("visibility")?i[l]:this.overflowAnchor);!e(c).is(":kendoFocusable");){if(c=n===-1&&e(c).closest("."+F).length?e(c).children(":not(label, div)").last():e(c).children(":not(label, div)").first(),!c.length&&(s+=n,c=i[o+s],!c))return this.overflowAnchor;this._preventNextFocus=!e(c).closest("."+F).length}return c},_getPrevFocusable:function(n){if(n.is("html"))return n;var i,o,r=n.prevAll();return r.each(function(){return o=e(this),o.is(":kendoFocusable")?(i=o,!1):o.find(":kendoFocusable").length>0?(i=o.find(":kendoFocusable").last(),!1):t}),i?i:this._getPrevFocusable(n.parent())},_toggle:function(t){var n=e(t.target).closest("."+z).data("splitButton");t.preventDefault(),n.options.enable&&n.toggle()},_toggleOverflow:function(){this.popup.toggle()},_resize:function(e){var t=e.width;this.options.resizable&&(this.popup.close(),this._shrink(t),this._stretch(t),this._markVisibles(),this._toggleOverflowAnchor())},_childrenWidth:function(){var t=0;return this.element.children(":visible:not('."+O+"')").each(function(){t+=A(e(this),!0)}),Math.ceil(t)},_shrink:function(e){var t,n,i;if(e<this._childrenWidth())for(n=this.element.children(":visible:not([data-overflow='never'], ."+Q+")"),i=n.length-1;i>=0&&(t=n.eq(i),!(e>this._childrenWidth()));i--)this._hideItem(t)},_stretch:function(e){var t,n,i;if(e>this._childrenWidth())for(n=this.element.children(":hidden:not('."+O+"')"),i=0;i<n.length&&(t=n.eq(i),!(e<this._childrenWidth())&&this._showItem(t,e));i++);},_hideItem:function(e){e.hide(),this.popup&&this.popup.container.find(">li[data-uid='"+e.data("uid")+"']").removeClass(ce)},_showItem:function(e,t){return!!(e.length&&t>this._childrenWidth()+A(e,!0))&&(e.show(),this.popup&&this.popup.container.find(">li[data-uid='"+e.data("uid")+"']").addClass(ce),!0)},_markVisibles:function(){var e=this.popup.container.children(),t=this.element.children(":not(.k-overflow-anchor)"),n=e.filter(":not(.k-overflow-hidden)"),i=t.filter(":visible");e.add(t).removeClass(Z+" "+J),n.first().add(i.first()).addClass(Z),n.last().add(i.last()).addClass(J)}}),k.ui.plugin(y)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mediaplayer.min",["kendo.slider.min","kendo.toolbar.min","kendo.dropdownlist.min","kendo.tooltip.min"],e)}(function(){return function(e,t){var n=window.kendo,i="end",o="pause",r="play",s="ready",a="timeChange",l="volumeChange",c="k-i-full-screen",d="k-i-full-screen-exit",u="k-i-volume-off",h="k-i-volume-down",f="k-i-volume-up",p="k-mediaplayer-quality",m="k-i-play",g="k-i-pause",v="k-mediaplayer-titlebar",_="k-title",b="k-mediaplayer-toolbar-wrap",w="k-mediaplayer-toolbar",y="k-mediaplayer-seekbar",k="k-mediaplayer-volume",x="k-mediaplayer-media",C="k-mediaplayer-overlay",S="k-mediaplayer-yt",T=".",D=n.ui,A=".kendoMediaPlayer",E=new Date(1970,0,1),I=60*E.getTimezoneOffset(),M=n.ui.Widget,R=e.isArray,F={shortTime:"mm:ss",longTime:"HH:mm:ss"},z=n.template,P=e.proxy,B=n.keys,L={htmlPlayer:"<video class='"+x+"'> </video>",titleBar:z("<div class='"+v+"' role='heading'><span class='"+_+"'>Video Title</span></div>"),toolBar:"<div class='"+b+"'><div class='"+w+"'></div></div>",youtubePlayer:"<div class='"+S+"'> </div>",toolBarTime:"<span class='k-mediaplayer-currenttime'>00:00:00</span> / <span class='k-mediaplayer-duration'>00:00:00</span>",slider:"<input class='"+y+"' value='0' title='seekbar' />",volumeSlider:"<input class='"+k+"' title='volume'/>",qualityDropDown:"<input class='"+p+"' title='video quality' />",toolTip:"#= kendo.toString(new Date(value), 'HH:mm:ss') #"},H=M.extend({init:function(t,i){this.wrapper=e(t),M.fn.init.call(this,t,i),this.wrapper.addClass("k-mediaplayer k-widget"),
i=this.options,this._currentIndex=0,this._createTitlebar(),this._createToolbar(),this._createDropDown(),this._createSlider(),this._createVolumeSlider(),this._timers={},this._aria(),this._navigatable(),i.fullScreen&&this.fullScreen(!0),i.media&&this.media(this.options.media),n.notify(this)},events:[i,o,r,s,a,l],options:{name:"MediaPlayer",autoPlay:!1,autoRepeat:!1,volume:100,fullScreen:!1,mute:!1,navigatable:!1,forwardSeek:!0,media:null,messages:{pause:"Pause",play:"Play",mute:"Mute",unmute:"Unmute",quality:"Quality",fullscreen:"Full Screen"}},_msToTime:function(e){var t=new Date(E.getTime());return t.setSeconds(e),t},_timeToSec:function(e){var t=new Date(e).getTime();return t/1e3},_createTitlebar:function(){this._titleBar=this.wrapper.find(T+v),0===this._titleBar.length&&(this.wrapper.append(L.titleBar),this._titleBar=this.wrapper.find(T+v))},_createSlider:function(){var e=this.wrapper.find(T+y);this._slider||(this._sliderDragChangeHandler=P(this._sliderDragChange,this),this._sliderDraggingHandler=P(this._sliderDragging,this),e=this.wrapper.find(T+y),this._slider=new D.Slider(e[0],{smallStep:1e3,tickPlacement:"none",showButtons:!1,change:this._sliderDragChangeHandler,slide:this._sliderDraggingHandler,tooltip:{template:L.toolTip},dragHandleTitle:""}))},_createVolumeSlider:function(){var e=this.wrapper.find(T+k);this._volumeSlider||(this._volumeDraggingHandler=P(this._volumeDragging,this),this._volumeChangeHandler=P(this._volumeChange,this),e.width(87),this._volumeSlider=new D.Slider(e[0],{smallStep:1,min:0,max:100,value:this.options.volume,slide:this._volumeDraggingHandler,change:this._volumeChangeHandler,tickPlacement:"none",showButtons:!1,tooltip:{enabled:!1},dragHandleTitle:""}))},_resetTime:function(){this._youTubeVideo?this._ytmedia.seekTo(0,!0):this._media.currentTime=0,this._mediaTimeUpdate(),e.grep(this._toolBar.options.items,function(e){return!!e.template}).template=L.toolBarTime},_currentUrl:function(){var e=this.media();return R(e.source)?e.source[this._currentIndex].url:e.source},_isYouTubeUrl:function(){return!!this._currentUrl().match("youtube.com/|youtu.be/")},_setPlayerUrl:function(){var e,t=this._youTubeVideo;this.stop(),this._youTubeVideo=this._isYouTubeUrl(),t!==this._youTubeVideo&&(this.wrapper.find(T+S).toggle(),this.wrapper.find(T+x).toggle()),e=this._media||this._ytmedia,this._initializePlayer(),e&&(this.mute(this.mute()),this.volume(this.volume())),this._youTubeVideo?this._ytmedia&&(this._videoOverlay&&this._videoOverlay.hide(),this.options.autoPlay?(this._ytmedia.loadVideoById(this._getMediaId()),this._playStateToggle(!0)):(this._ytmedia.cueVideoById(this._getMediaId()),this._playStateToggle(!0))):(this._videoOverlay.show(),this.wrapper.find(T+x+" > source").remove(),this.wrapper.find(T+x).attr("src",this._currentUrl()),this.options.autoPlay&&this.play())},_createToolbar:function(){var t=this.wrapper.find(T+w);0===t.length&&(this._toolbarClickHandler=P(this._toolbarClick,this),this.wrapper.append(L.toolBar),t=this.wrapper.find(T+w),t.width(this.wrapper.find(T+x).width()),this._toolBar=new D.ToolBar(t,{click:this._toolbarClickHandler,resizable:!1,items:[{type:"button",attributes:{"class":"k-play-button"},icon:"play"},{template:L.toolBarTime,attributes:{"class":"k-mediaplayer-currenttime-wrap"}},{type:"separator",attributes:{"class":"k-toolbar-spacer"}},{type:"button",attributes:{"class":"k-volume-button"},icon:"volume-up"},{template:L.volumeSlider,attributes:{"class":"k-mediaplayer-volume-wrap"}},{template:L.qualityDropDown,attributes:{"class":"k-mediaplayer-quality-wrap"}},{type:"button",attributes:{"class":"k-fullscreen-button"},icon:"full-screen"}]}),this._toolBar.wrapper.off("keydown"),t.before(L.slider),this._volumeButton=t.find(".k-volume-button"),this._fullscreenButton=t.find(".k-fullscreen-button"),this._volumeButton.attr("title",this.options.mute?this.options.messages.unmute:this.options.messages.mute),this._volumeButton.attr("aria-label",this.options.mute?this.options.messages.unmute:this.options.messages.mute),this._fullscreenButton.attr("title",this.options.messages.fullscreen),this._fullscreenButton.attr("aria-label",this.options.messages.fullscreen),t.width("auto"),this._currentTimeElement=t.find(".k-mediaplayer-currenttime"),this._durationElement=t.find(".k-mediaplayer-duration"),this._playButton=t.find(".k-play-button"),this._playButtonSpan=this._playButton.find(".k-i-play"),this.options.autoPlay&&this._playStateToggle(!0),e([this._volumeButton[0],t.find(".k-mediaplayer-volume-wrap")[0],t.find(".k-mediaplayer-quality-wrap")[0],this._fullscreenButton[0]]).wrapAll("<div class='k-align-right' />"),t.find(".k-button").addClass("k-bare"))},_createDropDown:function(){var e=this.wrapper.find(T+p),n=this.media();t===e.data("kendoDropDownList")&&(this._dropDownSelectHandler=P(this._dropDownSelect,this),this._dropDown=new D.DropDownList(e,{dataTextField:"quality",dataValueField:"url",popup:{position:"bottom",origin:"top",appendTo:this.wrapper},animation:{open:{effects:"slideIn:up",duration:1}},select:this._dropDownSelectHandler}),n&&R(n.source)&&(this._dropDown.setDataSource(n.source),this._dropDown.select(0)),this._dropDown.wrapper.addClass("k-button k-bare"),this._dropDown.wrapper.attr("title",this.options.messages.quality).hide(),this._dropDown.wrapper.find("span.k-i-arrow-60-down").removeClass("k-i-arrow-60-down").addClass("k-icon k-i-hd"),this._dropDown.list.addClass("k-quality-list"))},_dropDownSelect:function(e){this._currentIndex!==e.item.index()&&(this._currentIndex=e.item.index(),this._setPlayerUrl())},_toolbarClick:function(t){var n,i=e(t.target).children().first(),o=i.hasClass(m);this.media()&&((i.hasClass(m)||i.hasClass(g))&&(o?this.play():this.pause()),(i.hasClass(c)||i.hasClass(d))&&(this._isInFullScreen?(i.removeClass(d).addClass(c),this.fullScreen(!1)):(i.removeClass(c).addClass(d),this.fullScreen(!0))),(i.hasClass(u)||i.hasClass(h)||i.hasClass(f))&&(n=this.mute(),this.mute(!n)))},_sliderDragging:function(){this.media()&&(this._isDragging=!0)},_sliderDragChange:function(e){var t=this,n=e.sender,i=1e3*I;this.media()&&(t._sliderChangeFired=!0,t._isDragging=!1,!this.options.forwardSeek&&n.value()>this._seekBarLastPosition?setTimeout(function(){n.value(t._seekBarLastPosition)},1):this._youTubeVideo?t._ytmedia.seekTo(t._timeToSec(e.value-i)):t._media.currentTime=t._timeToSec(e.value-i),t.trigger(a),t._preventPlay=!0)},_changeVolumeButtonImage:function(e){var t=this._volumeButton,n=t.find("span"),i=n.attr("class");i=i.substring(0,i.lastIndexOf(" ")),0===e?(n.attr("class",i+" "+u),t.attr("title",this.options.messages.unmute),t.attr("aria-label",this.options.messages.unmute)):e>0&&e<51?(n.attr("class",i+" "+h),t.attr("title",this.options.messages.mute),t.attr("aria-label",this.options.messages.mute)):(n.attr("class",i+" "+f),t.attr("title",this.options.messages.mute),t.attr("aria-label",this.options.messages.mute))},_volumeDragging:function(e){this.media()&&(this.volume(e.value),this._changeVolumeButtonImage(e.value),this.trigger(l))},_volumeChange:function(e){this.media()&&(this.volume(e.value),this._changeVolumeButtonImage(e.value),this.trigger(l))},_mediaTimeUpdate:function(){var e=this._youTubeVideo?this._ytmedia.getCurrentTime():this._media.currentTime,t=this._msToTime(e);return this._currentTimeElement.text(n.toString(t,this._timeFormat)),this._isDragging||(this._seekBarLastPosition=1e3*(e+I),this._slider.value(this._seekBarLastPosition)),this.isPlaying()},_playStateToggle:function(e){t===e&&(e=this._playButtonSpan.is(T+m)),e?(this._playButtonSpan.removeClass(m).addClass(g),this._playButton.attr("title",this.options.messages.pause),this._playButton.attr("aria-label",this.options.messages.pause)):(this._playButtonSpan.removeClass(g).addClass(m),this._playButton.attr("title",this.options.messages.play),this._playButton.attr("aria-label",this.options.messages.play))},_mediaEnded:function(){this._playStateToggle(!1),this._currentTimeElement.text(n.toString(this._msToTime(0),this._timeFormat)),this._slider.value(1e3*(0+I)),this.trigger(i)},_mediaPlay:function(){this.trigger(r)},_mediaReady:function(){this.trigger(s)},_mediaDurationChange:function(){var e=this._msToTime(this._youTubeVideo?this._ytmedia.getDuration():this._media.duration);this._timeFormat=0===e.getHours()?F.shortTime:F.longTime,this._durationElement.text(n.toString(e,this._timeFormat)),this._slider.setOptions({min:E.getTime(),max:e.getTime()}),this._isFirstRun||(this._resetTime(),this._isFirstRun=!0)},_createYoutubePlayer:function(){this._mediaTimeUpdateHandler=P(this._mediaTimeUpdate,this),this._mediaDurationChangeHandler=P(this._mediaDurationChange,this),this.wrapper.prepend(L.youtubePlayer),this._ytPlayer=this.wrapper.find(T+S)[0],e(this._ytPlayer).css({width:this.wrapper.width(),height:this.wrapper.height()}),window.YT&&window.YT.Player?this._configurePlayer():(window.onYouTubeIframeAPIReadyRegister||(window.onYouTubeIframeAPIReadyRegister=[],e.getScript("https://www.youtube.com/iframe_api"),window.onYouTubeIframeAPIReady=function(){if(window.onYouTubeIframeAPIReadyRegister)for(var e=0;e<window.onYouTubeIframeAPIReadyRegister.length;e++)window.onYouTubeIframeAPIReadyRegister[e]._youtubeApiReady();window.onYouTubeIframeAPIReadyRegister.length=0,window.onYouTubeIframeAPIReadyRegister=t}),window.onYouTubeIframeAPIReadyRegister[window.onYouTubeIframeAPIReadyRegister.length]=this)},_poll:function(e,t,n,i){var o=this;return null!==o._timers[e]&&clearTimeout(o._timers[e]),o._timers[e]=setTimeout(function(i){return function r(){t.call(i)&&(o._timers[e]=setTimeout(r,n))}}(i),n)},_youtubeApiReady:function(){this._configurePlayer()},_configurePlayer:function(){var e,t={autoplay:+this.options.autoPlay,wmode:"transparent",controls:0,rel:0,showinfo:0};this._onYouTubePlayerReady=P(this._onYouTubePlayerReady,this),window.onYouTubePlayerReady=this._onYouTubePlayerReady,this._onPlayerStateChangeHandler=P(this._onPlayerStateChange,this),window.onPlayerStateChange=this._onPlayerStateChange,e=new window.YT.Player(this.wrapper.find(T+S)[0],{height:this.wrapper.height(),width:this.wrapper.width(),videoId:this._getMediaId(),playerVars:t,events:{onReady:this._onYouTubePlayerReady,onStateChange:this._onPlayerStateChangeHandler}})},_onYouTubePlayerReady:function(e){this._ytmedia=e.target,this._ytmedia.getIframe().style.width="100%",this._ytmedia.getIframe().style.height="100%",this._youTubeVideo=!0,this._mediaDurationChangeHandler(),this.options.autoPlay?(this._playStateToggle(!0),this._ytmedia.loadVideoById(this._getMediaId())):this._ytmedia.cueVideoById(this._getMediaId()),this.options.mute&&this.mute(!0),this.trigger(s)},_updateTitle:function(){this.titlebar().text(this.media().title||this.media().source)},_onPlayerStateChange:function(e){0===e.data?(this._slider.value(0),this._paused=!1,this._playStateToggle(!0),this.trigger(i),this.options.autoRepeat&&this.play()):1===e.data?(this._mediaDurationChange(),this._ytmedia.setVolume(this.volume()),this._sliderChangeFired?this._sliderChangeFired=!1:this._uiDisplay(!1),this.trigger(r),this._playStateToggle(!0),this._poll("progress",this._mediaTimeUpdate,500,this),this._paused=!1):2===e.data&&(this._paused||(this._uiDisplay(!0),this._playStateToggle(!1),this.trigger(o),this._paused=!0))},_getMediaId:function(){var e=this._currentUrl(),t=/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/,n=e.match(t);return n&&11===n[7].length&&(e=n[7]),e},_mouseClick:function(){this.isPaused()?this.play():this.pause()},_initializePlayer:function(){this._mouseMoveHandler||(this._mouseMoveHandler=P(this._mouseMove,this),this._mouseInHandler=P(this._mouseIn,this),this._mouseOutHandler=P(this._mouseOut,this),e(this.wrapper).on("mouseenter"+A,this._mouseInHandler).on("mouseleave"+A,this._mouseOutHandler).on("mousemove"+A,this._mouseMoveHandler)),!this._ytmedia&&this._youTubeVideo?this._createYoutubePlayer():this._media||this._youTubeVideo||this._createHtmlPlayer()},_createHtmlPlayer:function(){this._videoOverlay||(this._mouseClickHanlder=P(this._mouseClick,this),this.wrapper.append("<div class='"+C+"'></div>"),this._videoOverlay=this.wrapper.find(".k-mediaplayer-overlay").on("click"+A,this._mouseClickHanlder)),this._mediaTimeUpdateHandler=P(this._mediaTimeUpdate,this),this._mediaDurationChangeHandler=P(this._mediaDurationChange,this),this._mediaEndedHandler=P(this._mediaEnded,this),this._mediaCanPlayHandler=P(this._mediaReady,this),this._mediaPlayHandler=P(this._mediaPlay,this),this._videoOverlay.after(L.htmlPlayer),this._media=this.wrapper.find(T+x)[0],e(this._media).css({width:"100%",height:"100%"}),this.options.mute&&this.mute(!0),this._media.ontimeupdate=this._mediaTimeUpdateHandler,this._media.ondurationchange=this._mediaDurationChangeHandler,this._media.oncanplay=this._mediaCanPlayHandler,this._media.onplay=this._mediaPlayHandler,this._media.onended=this._mediaEndedHandler,this._media.loop=this.options.autoRepeat},_mouseIn:function(){this._uiDisplay(!0)},_mouseOut:function(){this._poll("mouseIdle",this._mouseIdle,3e3,this)},_mouseIdle:function(){return this._uiDisplay(!1),!1},_mouseMove:function(){this._titleBar.is(":animated")||this._toolBar.element.is(":animated")||this._slider.wrapper.is(":animated")||this._uiDisplay(!0),this._poll("mouseIdle",this._mouseIdle,3e3,this)},_uiDisplay:function(e){var t="slow",n=this._titleBar.add(this._toolBar.element.parent());e?n.fadeIn(t):(n.fadeOut(t),this.options.navigatable&&this.wrapper.focus())},setOptions:function(e){M.fn.setOptions.call(this,e)},destroy:function(){M.fn.destroy.call(this),this.isPaused()||this.pause(),this.element.off(A),this.element.find(T+C).off(A),this._timers=null,this._mouseMoveHandler=null,this._mouseOutHandler=null,this._mouseInHandler=null,this._mouseClickHanlder=null,this._keyDownHandler=null,this._fullscreenHandler=null,this._toolbarClickHandler=null,this._sliderDragChangeHandler=null,this._sliderDraggingHandler=null,this._volumeDraggingHandler=null,this._volumeChangeHandler=null,this._youtubeApiReadyHandler=null,this._onYouTubePlayerReady=null,this._onPlayerStateChangeHandler=null,this._dropDownSelectHandler=null,this._youTubeVideo?this._ytmedia.destroy():(this._media.ontimeupdate=this._mediaTimeUpdateHandler=null,this._media.ondurationchange=this._mediaDurationChangeHandler=null,this._media.oncanplay=this._mediaCanPlayHandler=null,this._media.onplay=this._mediaPlayHandler=null,this._media.onended=this._mediaEndedHandler=null,this._media.src="",this._media.remove()),this._mouseMoveTimer=null,clearTimeout(this._mouseMoveTimer),n.destroy(this.element)},seek:function(e){if(t===e)return 1e3*this._youTubeVideo?this._ytmedia.getCurrentTime():this._media?this._media.currentTime:0;var n=e/1e3;return this._youTubeVideo?n+3>=this._ytmedia.getDuration()|0?this._ytmedia.seekTo(this._ytmedia.getDuration()-3|0,!0):this._ytmedia.seekTo(n,!0):this._media.currentTime=n,this},play:function(){return this._youTubeVideo?this._ytmedia.playVideo():(n.support.mobileOS&&this._uiDisplay(!1),this._media.play()),this._paused=!1,this._playStateToggle(!0),this},stop:function(){return this._youTubeVideo&&this._ytmedia?this._ytmedia.stopVideo():this._media&&!this._youTubeVideo&&(n.support.mobileOS&&this._uiDisplay(!0),this._media.pause(),this._media.currentTime=0),this._paused=!0,this._playStateToggle(!1),this},pause:function(){return this._youTubeVideo?this._ytmedia.pauseVideo():(n.support.mobileOS&&this._uiDisplay(!0),this._media.pause()),this._paused=!0,this._playStateToggle(!1),this.trigger(o),this},toolbar:function(){return this._toolBar},dropdown:function(){return this._dropDown},titlebar:function(){return this._titleBar},fullScreen:function(e){if(t===e)return this._isInFullScreen||!1;var n=this.element.get(0);e?(this.element.addClass("k-mediaplayer-fullscreen"),n.requestFullscreen?n.requestFullscreen():n.webkitRequestFullscreen?n.webkitRequestFullscreen():n.mozRequestFullScreen?n.mozRequestFullScreen():n.msRequestFullscreen&&n.msRequestFullscreen(),this._isInFullScreen=!0):(document.cancelFullscreen?document.cancelFullscreen():document.webkitCancelFullScreen?document.webkitCancelFullScreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.msCancelFullscreen?document.msCancelFullscreen():document.exitFullscreen?document.exitFullscreen():document.msExitFullscreen&&document.msExitFullscreen(),this.element.removeClass("k-mediaplayer-fullscreen"),this._isInFullScreen=!1),this._slider.resize()},volume:function(e){return t===e?t!==this._volume?this._volume:this._volume=this.options.volume:(this._volume=e,this.mute(e<=0),this._youTubeVideo?this._ytmedia.setVolume(this._volume):this._media.volume=this._volume/100,this._volumeSlider.value(e),t)},mute:function(e){var n=this._youTubeVideo?this._ytmedia&&this._ytmedia.isMuted():this._media&&this._media.muted;return t===e||e===n?n:(this._youTubeVideo?e?this._ytmedia.mute():this._ytmedia.unMute():this._media.muted=e,this._volumeSlider.value(e?0:this._media&&100*this._media.volume||this._ytmedia&&this._ytmedia.getVolume()),this.trigger(l),this._changeVolumeButtonImage(this._volumeSlider.value()),t)},isEnded:function(){return this._youTubeVideo?0===this._ytmedia.getPlayerState():this._media.ended},media:function(e){var n=this.dropdown();return t===e?t!==this._mediaData?this._mediaData:this._mediaData=this.options.media:(R(e.source)?(n.setDataSource(e.source),n.wrapper.show()):n.wrapper.hide(),this._mediaData=e,this._updateTitle(),this._setPlayerUrl(),t)},isPaused:function(){return this._paused},isPlaying:function(){return!this.isEnded()&&!this._paused},_aria:function(){this.wrapper.attr("role","region")},_navigatable:function(){this._fullscreenHandler=P(this._fullscreen,this),e(document).on("webkitfullscreenchange mozfullscreenchange fullscreenchange"+A,this._fullscreenHandler),this.options.navigatable&&(this.wrapper.attr("tabIndex",0),this._keyDownHandler=P(this._keyDown,this),this.wrapper.on("keydown"+A,this._keyDownHandler))},_fullscreen:function(){var e=document.fullScreen||document.mozFullScreen||document.webkitIsFullScreen;this._uiDisplay(!0),this._slider.resize(),e||(this.wrapper.find('span[class*="k-i-fullscreen"]').removeClass(d).addClass(c),this.fullScreen(!1))},_keyDown:function(e){var t,n;e.preventDefault(),t=this.wrapper.find('span[class*="k-i-fullscreen"]'),e.keyCode===B.SPACEBAR?this.isPlaying()?this.pause():this.play():e.keyCode!==B.ENTER||this._isInFullScreen?77===e.keyCode?(n=this.mute(),this.mute(!n)):e.keyCode===B.ESC&&this._isInFullScreen&&(t.removeClass(d).addClass(c),this.fullScreen(!1)):(t.removeClass(c).addClass(d),this.fullScreen(!0))},_error:function(){},_progress:function(){}});D.plugin(H)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.pivotgrid.min",["kendo.dom.min","kendo.data.min"],e)}(function(){return function(e,t){function n(e){var n="string"==typeof e?[{name:e}]:e,i="[object Array]"===we.call(n)?n:n!==t?[n]:[];return ke(i,function(e){return"string"==typeof e?{name:e}:{name:e.name,type:e.type}})}function i(e){var n="string"==typeof e?[{name:[e],expand:!1}]:e,i="[object Array]"===we.call(n)?n:n!==t?[n]:[];return ke(i,function(e){return"string"==typeof e?{name:[e],expand:!1}:{name:"[object Array]"===we.call(e.name)?e.name.slice():[e.name],expand:e.expand}})}function o(e){return e.indexOf(" ")!==-1&&(e='["'+e+'"]'),e}function r(e,t,n,i){var o,s,a,l;if(n||(n=t),i||(i=0),l=n.members[i],l&&!l.measure){if(a=l.children,s=a.length,n===t?e[fe.stringify([l.name])]=!!s:s&&(e[fe.stringify(ae(n,i))]=!0),s)for(o=0;o<s;o++)r(e,t,a[o],i);r(e,t,n,i+1)}}function s(t){var n,i,o={};t.length&&r(o,t[0]),n=[];for(i in o)n.push({name:e.parseJSON(i),expand:o[i]});return n}function a(e,t){var n,i,o,r,s=t.tuples||[],a=s[0];if(a&&e.length<a.members.length)for(n=a.members,i=0;i<n.length;i++)if(!n[i].measure){for(o=!1,r=0;r<e.length;r++)if(0===H(e[r]).indexOf(n[i].hierarchy)){o=!0;break}o||e.push({name:[n[i].name],expand:!1})}}function l(e){var t,n=[],i=e.members;for(t=0;t<i.length;t++)i[t].measure||n.push({name:[i[t].name],expand:i[t].children.length>0});return n}function c(e,t,n){var o,r;return e=e||{},a(t,e),n.length>1&&t.push({name:De,measure:!0,children:i(n)}),o={members:t},e.tuples&&(r=x(e.tuples,o),r.tuple&&(t=l(r.tuple))),t}function d(e){var t=fe.getter(e.field,!0);return function(n,i){return e.aggregate(t(n.dataItem),i,n)}}function u(e){return"number"==typeof e&&!isNaN(e)}function h(e){return e&&e.getTime}function f(e){return e[e.length]={value:"",fmtValue:"",ordinal:e.length},e}function p(e,t,n){if(e.tuples.length<_(t.tuples,n))return t}function m(e,t,n,i,o){var r,s,a,l=e.length,c=_(t,i),d=i.length||1;for(s=0;s<n;s++)for(r=0;r<l;r++)a=v(e[r],t)*d,a+=r%d,o[s*l+r].ordinal=s*c+a}function g(e,t,n,i,o){var r,s,a,l=e.length,c=i.length||1;for(s=0;s<l;s++)for(a=v(e[s],t),a*=c,a+=s%c,r=0;r<n;r++)o[s*n+r].ordinal=a*n+r}function v(e,t){return x(t,e).index}function _(e,t){var n,i,o;if(!e.length)return 0;for(n=e.slice(),i=n.shift(),o=1;i;)i.members?[].push.apply(n,i.members):i.children&&(i.measure||(o+=i.children.length),[].push.apply(n,i.children)),i=n.shift();return t.length&&(o*=t.length),o}function b(e){return e||(e={tuples:[]}),e.tuples||(e.tuples=[]),e}function w(e,t,n){var i,o,r,s;if(!e)return 0;for(i=Math.max(n.length,1),o=e.members.slice(0,t),r=o.shift(),s=i;r;)r.name===De?s+=i-1:r.children?[].push.apply(o,r.children):(s++,[].push.apply(o,r.members)),r=o.shift();return s}function y(e,t,n){var i,o,r,s,a,l;if(!t[0])return{parsedRoot:null,tuples:e,memberIndex:0,index:0};if(i=x(e,t[0]),!i.tuple)return{parsedRoot:null,tuples:t,memberIndex:0,index:0};if(o=i.tuple.members,r=t[0].members,s=-1,o.length!==r.length)return{parsedRoot:null,tuples:t,memberIndex:0,index:0};for(a=0,l=o.length;a<l;a++)!o[a].measure&&r[a].children[0]&&(s==-1&&r[a].children.length&&(s=a),o[a].children=r[a].children);return n=Math.max(n.length,1),{parsedRoot:i.tuple,index:i.index*n,memberIndex:s,tuples:e}}function k(e,t){var n,i,o=!0;for(e=e.members,t=t.members,n=0,i=e.length;n<i;n++)e[n].measure||t[n].measure||(o=o&&H(e[n])===H(t[n]));return o}function x(e,t){var n,i,o,r,s,a,l,c=0;for(n=0,i=e.length;n<i;n++){if(o=e[n],k(o,t))return{tuple:o,index:c};for(c++,s=0,a=o.members.length;s<a;s++)if(l=o.members[s],!l.measure&&(r=x(l.children,t),c+=r.index,r.tuple))return{tuple:r.tuple,index:c}}return{index:c}}function C(e,t){var n,i,o,r="";for(i=0,o=e.length;i<o;i++)n=e[i],r+=n.name,t[r]||(t[r]=n)}function S(e,t){var n,i,o,r,s=e.members,a="",l="";for(n=0,i=s.length;n<i;n++){if(o=s[n],r){if(t[a+o.name]){a+=o.name,r=t[a];continue}return t[a+o.parentName]?t[a+o.parentName]:t[l+o.parentName]?t[l+o.parentName]:t[l]}if(a+=o.name,r=t[o.parentName],!r&&(r=t[a],!r))return null;r&&(l+=r.name)}return r}function T(e,t){var n,i,o,r;if(0===t.length)return-1;for(n=t[0],i=e.members,o=0,r=i.length;o<r;o++)if(i[o].name==n.name)return o}function D(n,i){if(!(i<0)){var o={name:De,measure:!0,children:[e.extend({members:[],dataIndex:n.dataIndex},n.members[i])]};n.members.splice(i,1,o),n.dataIndex=t}}function A(e,t){var n,i,o,r,s,a;if(e.length<1)return[];for(n=[],i={},o=T(e[0],t),r=0;r<e.length;r++)s=e[r],s.dataIndex=r,D(s,o),a=S(s,i),a?a.children.push(o<0||!a.measure?s:s.members[o].children[0]):n.push(s),C(s.members,i);return n}function E(e,t){var n,i,o,r,s,a,l,c,d;if(!e||!e.length)return t;for(n=[],i=M(e),o=i.length,r=Math.max(t.length/o,1),s=0;s<o;s++)for(l=r*s,c=r*i[s],a=0;a<r;a++)d=parseInt(c+a,10),n[parseInt(l+a,10)]=t[d]||{value:"",fmtValue:"",ordinal:d};return n}function I(e,t){var n,i,o,r,s,a,l,c;if(!e||!e.length)return t;for(n=[],i=M(e),o=i.length,r=Math.max(t.length/o,1),a=0;a<r;a++)for(l=o*a,s=0;s<o;s++)c=i[s]+l,n[l+s]=t[c]||{value:"",fmtValue:"",ordinal:c};return n}function M(e){var n,i,o,r,s,a,l;for(e=e.slice(),n=[],i=e.shift();i;){for(i.dataIndex!==t&&n.push(i.dataIndex),s=0,o=0,r=i.members.length;o<r;o++)l=i.members[o],a=l.children,l.measure?[].splice.apply(e,[0,0].concat(a)):[].splice.apply(e,[s,0].concat(a)),s+=a.length;i=e.shift()}return n}function R(e){var t=e.split(".");return t.length>2?t[0]+"."+t[1]:e}function F(e,t){var n=e.length-1,i=e[n],o=z(t,i);return o&&o.dir?i="ORDER("+i+".Children,"+o.field+".CurrentMember.MEMBER_CAPTION,"+o.dir+")":i+=".Children",e[n]=i,e}function z(e,t){for(var n=0,i=e.length;n<i;n++)if(0===t.indexOf(e[n].field))return e[n];return null}function P(e){var t,n="CROSSJOIN({";return e.length>2?(t=e.pop(),n+=P(e)):(n+=e.shift(),t=e.pop()),n+="},{",n+=t,n+="})"}function B(e,t){var n=e.slice(0);return t.length>1&&n.push("{"+L(t).join(",")+"}"),P(n)}function L(e){for(var n,i=0,o=e.length,r=[];i<o;i++)n=e[i],r.push(n.name!==t?n.name:n);return r}function H(e){return e=e.name||e,"[object Array]"===we.call(e)&&(e=e[e.length-1]),e}function N(e){for(var t=e.length,n=[],i=0;i<t;i++)n.push(e[i].name[0]);return n}function O(e,t){var n,i,o,r=0,s=e.length,a=t.length;for(t=t.slice(0);r<s;r++)for(n=e[r],o=0;o<a;o++)if(i=R(t[o]),n.indexOf(i)!==-1){t[o]=n;break}return{names:t,expandedIdx:o,uniquePath:t.slice(0,o+1).join("")}}function V(e){for(var t,n,i,o,r,s,a=[],l=[],c=[],d=0,u=e.length;d<u;d++)if(t=e[d],o=t.name,s=!1,"[object Array]"!==we.call(o)&&(t.name=o=[o]),o.length>1)l.push(t);else{for(r=R(o[0]),n=0,i=c.length;n<i;n++)if(0===c[n].name[0].indexOf(r)){s=!0;break}s||c.push(t),t.expand&&a.push(t)}return a=a.concat(l),{root:c,expanded:a}}function U(e,t,n){var i,o,r,s,a,l,c,d,u="";if(e=e||[],i=V(e),o=i.root,r=N(o),s=[],i=i.expanded,a=i.length,l=0,d=[],r.length>1||t.length>1){for(s.push(B(r,t));l<a;l++)c=F(i[l].name,n),d=O(c,r).names,s.push(B(d,t));u+=s.join(",")}else{for(;l<a;l++)c=F(i[l].name,n),d.push(c[0]);u+=r.concat(d).join(",")}return u}function W(e){var t="",n=e.value,i=e.field,o=e.operator;return"in"==o?(t+="{",t+=n,t+="}"):(t+="neq"==o||"doesnotcontain"==o?"-":"",t+="Filter(",t+=i+".MEMBERS",t+=fe.format(K[o],i,n),t+=")"),t}function j(e,t){var n,i,o="",r=e.filters,s=r.length;for(i=s-1;i>=0;i--)n="SELECT (",n+=W(r[i]),n+=") ON 0",i==s-1?(n+=" FROM ["+t+"]",o=n):o=n+" FROM ( "+o+" )";return o}function q(e,t,n){var i,o,r="";if(t){r+="<"+e+">";for(o in t)i=t[o],n&&(o=o.replace(/([A-Z]+(?=$|[A-Z][a-z])|[A-Z]?[a-z]+)/g,"$1_").toUpperCase().replace(/_$/,"")),r+="<"+o+">"+i+"</"+o+">";r+="</"+e+">"}else r+="<"+e+"/>";return r}function G(e){if(null==e)return[];var t=we.call(e);return"[object Array]"!==t?[e]:e}function $(e){var t,n,i,o,r={tuples:[]},s=G(fe.getter("Tuples.Tuple",!0)(e)),a=fe.getter("Caption['#text']"),l=fe.getter("UName['#text']"),c=fe.getter("LName['#text']"),d=fe.getter("LNum['#text']"),u=fe.getter("CHILDREN_CARDINALITY['#text']",!0),h=fe.getter("['@Hierarchy']"),f=fe.getter("PARENT_UNIQUE_NAME['#text']",!0);for(t=0;t<s.length;t++){for(n=[],i=G(s[t].Member),o=0;o<i.length;o++)n.push({children:[],caption:a(i[o]),name:l(i[o]),levelName:c(i[o]),levelNum:d(i[o]),hasChildren:parseInt(u(i[o]),10)>0,parentName:f(i[o]),hierarchy:h(i[o])});r.tuples.push({members:n})}return r}var K,Y,Q,X,Z,J,ee,te,ne,ie,oe,re,se,ae,le,ce,de,ue,he,fe=window.kendo,pe=fe.ui,me=fe.Class,ge=pe.Widget,ve=fe.data.DataSource,_e=fe._outerWidth,be=fe._outerHeight,we={}.toString,ye=function(e){return e},ke=e.map,xe=e.extend,Ce=fe.isFunction,Se="change",Te="error",De="Measures",Ae="progress",Ee="stateReset",Ie="auto",Me="<div/>",Re=".kendoPivotGrid",Fe="__row_total__",ze="dataBinding",Pe="dataBound",Be="expandMember",Le="collapseMember",He="k-i-collapse",Ne="k-i-expand",Oe="<span>#: data.member.caption || data.member.name #</span>",Ve='<span class="k-icon k-i-kpi-status-#=data.dataItem.value > 0 ? "open" : data.dataItem.value < 0 ? "deny" : "hold"#" title="#:data.dataItem.value#"></span>',Ue='<span class="k-icon k-i-kpi-trend-#=data.dataItem.value > 0 ? "increase" : data.dataItem.value < 0 ? "decrease" : "equal"#" title="#:data.dataItem.value#"></span>',We='#= data.dataItem ? kendo.htmlEncode(data.dataItem.fmtValue || data.dataItem.value) || "&nbsp;" : "&nbsp;" #',je='<table class="k-pivot-layout"><tr><td><div class="k-pivot-rowheaders"></div></td><td><div class="k-pivot-table k-state-default"></div></td></tr></table>',qe="rows",Ge="columns",$e={sum:function(e,t){var n=t.accumulator;return u(n)?u(e)&&(n+=e):n=e,n},count:function(e,t){return(t.accumulator||0)+1},average:{aggregate:function(e,n){var i=n.accumulator;return n.count===t&&(n.count=0),u(i)?u(e)&&(i+=e):i=e,u(e)&&n.count++,i},result:function(e){var t=e.accumulator;return u(t)&&(t/=e.count),t}},max:function(e,t){var n=t.accumulator;return u(n)||h(n)||(n=e),n<e&&(u(e)||h(e))&&(n=e),n},min:function(e,t){var n=t.accumulator;return u(n)||h(n)||(n=e),n>e&&(u(e)||h(e))&&(n=e),n}},Ke=me.extend({init:function(e){this.options=xe({},this.options,e),this.dimensions=this._normalizeDescriptors("field",this.options.dimensions),this.measures=this._normalizeDescriptors("name",this.options.measures)},_normalizeDescriptors:function(e,t){var n,i,o,r;if(t=t||{},n={},"[object Array]"===we.call(t)){for(o=0,r=t.length;o<r;o++)i=t[o],"string"==typeof i?n[i]={}:i[e]&&(n[i[e]]=i);t=n}return t},_rootTuples:function(e,n){var i,o,r,s,a=n.length||1,l=this.dimensions||[],c=0,d=e.length,u=[],h=[];if(d||n.length){for(c=0;c<a;c++){for(i={members:[]},s=0;s<d;s++)o=e[s],r=o.split("&"),i.members[i.members.length]={children:[],caption:(l[o]||{}).caption||"All",name:o,levelName:o,levelNum:"0",hasChildren:!0,parentName:r.length>1?r[0]:t,hierarchy:o};a>1&&(i.members[i.members.length]={children:[],caption:n[c].caption,name:n[c].descriptor.name,levelName:"MEASURES",levelNum:"0",hasChildren:!1,parentName:t,hierarchy:"MEASURES"}),u[u.length]=i}h.push(Fe)}return{keys:h,tuples:u}},_expandedTuples:function(e,n,i){var o,r,s,a,l,c,d,u,h,f,p,m=i.length||1,g=this.dimensions||[],v=[],_=[];for(s in e){for(a=e[s],d=this._findExpandedMember(n,a.uniquePath),l=v[d.index]||[],c=_[d.index]||[],u=d.member.names,o=0;o<m;o++){for(r={members:[]},p=0;p<u.length;p++)p===d.member.expandedIdx?(r.members[r.members.length]={children:[],caption:a.value,name:a.name,hasChildren:!1,levelNum:1,levelName:a.parentName+a.name,parentName:a.parentName,hierarchy:a.parentName+a.name},0===o&&c.push(ae(r,p).join(""))):(f=u[p],h=f.split("&"),r.members[r.members.length]={children:[],caption:(g[f]||{}).caption||"All",name:f,levelName:f,levelNum:"0",hasChildren:!0,parentName:h.length>1?h[0]:t,hierarchy:f});m>1&&(r.members[r.members.length]={children:[],caption:i[o].caption,name:i[o].descriptor.name,levelName:"MEASURES",levelNum:"0",hasChildren:!0,parentName:t,hierarchy:"MEASURES"}),l[l.length]=r}v[d.index]=l,_[d.index]=c}return{keys:_,tuples:v}},_findExpandedMember:function(e,t){for(var n=0;n<e.length;n++)if(e[n].uniquePath===t)return{member:e[n],index:n}},_asTuples:function(e,t,n){var i,o;return n=n||[],i=this._rootTuples(t.root,n),o=this._expandedTuples(e,t.expanded,n),{keys:[].concat.apply(i.keys,o.keys),tuples:[].concat.apply(i.tuples,o.tuples)}},_measuresInfo:function(e,t){for(var n,i,o=0,r=e&&e.length,s=[],a={},l={},c=this.measures||{};o<r;o++)i=e[o].descriptor.name,n=c[i]||{},s.push(i),n.result&&(a[i]=n.result),n.format&&(l[i]=n.format);return{names:s,formats:l,resultFuncs:a,rowAxis:t}},_toDataArray:function(e,t,n,i){var o,r,s,a,l,c,d,u,h,f,p=[],m=1,g=[],v=n.length||1,_=i.length||1;for(t.rowAxis?(g=t.names,m=g.length):f=t.names,s=0;s<v;s++)for(d=e[n[s]||Fe],c=0;c<m;c++)for(t.rowAxis&&(f=[g[c]]),a=0;a<_;a++)for(h=i[a]||Fe,u=d.items[h],o=h===Fe?d.aggregates:u?u.aggregates:{},l=0;l<f.length;l++)r=f[l],this._addData(p,o[r],t.formats[r],t.resultFuncs[r]);return p},_addData:function(e,t,n,i){var o,r="";t&&(t=i?i(t):t.accumulator,r=n?fe.format(n,t):t),o=e.length,e[o]={ordinal:o,value:t||"",fmtValue:r}},_matchDescriptors:function(e,n,i){for(var o,r,s,a,l=n.names,c=n.expandedIdx;c>0;)if(o=l[--c].split("&"),o.length>1&&(r=o[0],s=o[1],a=i[r](e),a=a!==t&&null!==a?""+a:a,a!=s))return!1;return!0},_calculateAggregate:function(e,t,n){var i,o,r,s={};for(r=0;r<e.length;r++)o=e[r].descriptor.name,i=n.aggregates[o]||{},i.accumulator=e[r].aggregator(t,i),s[o]=i;return s},_processColumns:function(e,n,i,o,r,s,a,l){for(var c,d,u,h,f,p,m,g,v=r.dataItem,_=0;_<n.length;_++)d=n[_],
this._matchDescriptors(v,d,i)&&(g=d.names.slice(0,d.expandedIdx).join(""),p=d.names[d.expandedIdx],c=i[p](v),c=c!==t&&null!==c?""+c:c,m=p,p=p+"&"+c,f=g+p,u=o[f]||{index:a.columnIndex,parentName:m,name:p,uniquePath:g+m,value:c},h=s.items[f]||{aggregates:{}},s.items[f]={index:u.index,aggregates:this._calculateAggregate(e,r,h)},l&&(o[f]||a.columnIndex++,o[f]=u))},_measureAggregators:function(e){var t,n,i,o,r,s,a=e.measures||[],l=this.measures||{},c=[];if(a.length){for(i=0,o=a.length;i<o;i++)if(t=a[i],n=l[t.name],r=null,n){if(s=n.aggregate,"string"==typeof s){if(r=$e[s.toLowerCase()],!r)throw Error("There is no such aggregate function");n.aggregate=r.aggregate||r,n.result=r.result}c.push({descriptor:t,caption:n.caption,result:n.result,aggregator:d(n)})}}else c.push({descriptor:{name:"default"},caption:"default",aggregator:function(){return 1}});return c},_buildGetters:function(e){var t,n,i,r={};for(i=0;i<e.length;i++)n=e[i],t=n.split("&"),t.length>1?r[t[0]]=fe.getter(t[0],!0):r[n]=fe.getter(o(n),!0);return r},_parseDescriptors:function(e){var t,n=V(e),i=N(n.root),o=n.expanded,r=[];for(t=0;t<o.length;t++)r.push(O(o[t].name,i));return{root:i,expanded:r}},_filter:function(e,t){var n,i,o;if(!t)return e;for(i=0,o=t.filters;i<o.length;i++)n=o[i],"in"===n.operator&&(o[i]=this._normalizeFilter(n));return new fe.data.Query(e).filter(t).data},_normalizeFilter:function(e){var t,n=e.value.split(","),i=[];if(!n.length)return n;for(t=0;t<n.length;t++)i.push({field:e.field,operator:"eq",value:n[t]});return{logic:"or",filters:i}},process:function(e,n){var o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C,S,T,D,A,E,I,M,R,F;if(e=e||[],n=n||{},e=this._filter(e,n.filter),o=n.measures||[],r="rows"===n.measuresAxis,s=n.columns||[],a=n.rows||[],!s.length&&a.length&&(!o.length||o.length&&r)&&(s=a,a=[],r=!1),s.length||a.length||(r=!1),!s.length&&o.length&&(s=i(n.measures)),s=this._parseDescriptors(s),a=this._parseDescriptors(a),l={},c={},d={},h={columnIndex:0},f=this._measureAggregators(n),p=this._buildGetters(s.root),m=this._buildGetters(a.root),g=!1,v=s.expanded,_=a.expanded,y=0!==_.length,R=e.length,F=0,s.root.length||a.root.length)for(g=!0,F=0;F<R;F++)for(b=e[F],w={dataItem:b,index:F},S=l[Fe]||{items:{},aggregates:{}},this._processColumns(f,v,p,c,w,S,h,!y),S.aggregates=this._calculateAggregate(f,w,S),l[Fe]=S,k=0;k<_.length;k++)x=_[k],this._matchDescriptors(b,x,m)?(D=x.names.slice(0,x.expandedIdx).join(""),C=x.names[x.expandedIdx],A=C,u=m[C](b),u=u!==t?""+u:u,C=C+"&"+u,T=D+C,d[T]={uniquePath:D+A,parentName:A,name:C,value:u},E=l[T]||{items:{},aggregates:{}},this._processColumns(f,v,p,c,w,E,h,!0),E.aggregates=this._calculateAggregate(f,w,E),l[T]=E):this._processColumns(f,v,p,c,w,{items:{},aggregates:{}},h,!0);return g&&R?(!(f.length>1)||n.columns&&n.columns.length||(s={root:[],expanded:[]}),I=this._asTuples(c,s,r?[]:f),M=this._asTuples(d,a,r?f:[]),c=I.tuples,d=M.tuples,l=this._toDataArray(l,this._measuresInfo(f,r),M.keys,I.keys)):l=c=d=[],{axes:{columns:{tuples:c},rows:{tuples:d}},data:l}}}),Ye=me.extend({init:function(e,t){this.transport=t,this.options=t.options||{},this.transport.discover||Ce(e.discover)&&(this.discover=e.discover)},read:function(e){return this.transport.read(e)},update:function(e){return this.transport.update(e)},create:function(e){return this.transport.create(e)},destroy:function(e){return this.transport.destroy(e)},discover:function(e){return this.transport.discover?this.transport.discover(e):(e.success({}),t)},catalog:function(n){var i,o=this.options||{};return n===t?(o.connection||{}).catalog:(i=o.connection||{},i.catalog=n,this.options.connection=i,e.extend(this.transport.options,{connection:i}),t)},cube:function(e){var n,i=this.options||{};return e===t?(i.connection||{}).cube:(n=i.connection||{},n.cube=e,this.options.connection=n,xe(!0,this.transport.options,{connection:n}),t)}}),Qe=ve.extend({init:function(t){var o,r=((t||{}).schema||{}).cube,s="columns",a={axes:ye,cubes:ye,catalogs:ye,measures:ye,dimensions:ye,hierarchies:ye,levels:ye,members:ye};r&&(a=e.extend(a,this._cubeSchema(r)),this.cubeBuilder=new Ke(r)),ve.fn.init.call(this,xe(!0,{},{schema:a},t)),this.transport=new Ye(this.options.transport||{},this.transport),this._columns=i(this.options.columns),this._rows=i(this.options.rows),o=this.options.measures||[],"[object Object]"===we.call(o)&&(s=o.axis||"columns",o=o.values||[]),this._measures=n(o),this._measuresAxis=s,this._skipNormalize=0,this._axes={}},_cubeSchema:function(t){return{dimensions:function(){var e,n=[],i=t.dimensions;for(e in i)n.push({name:e,caption:i[e].caption||e,uniqueName:e,defaultHierarchy:e,type:1});return t.measures&&n.push({name:De,caption:De,uniqueName:De,type:2}),n},hierarchies:function(){return[]},measures:function(){var e,n=[],i=t.measures;for(e in i)n.push({name:e,caption:e,uniqueName:e,aggregator:e});return n},members:e.proxy(function(e,n){var i,r,s=n.levelUniqueName||n.memberUniqueName,a=this.options.schema.data,l=Ce(a)?a:fe.getter(a,!0),c=this.options.data&&l(this.options.data)||this._rawData||[],d=[],u=0,h={};if(s&&(s=s.split(".")[0]),!n.treeOp)return d.push({caption:t.dimensions[s].caption||s,childrenCardinality:"1",dimensionUniqueName:s,hierarchyUniqueName:s,levelUniqueName:s,name:s,uniqueName:s}),d;for(i=fe.getter(o(s),!0);u<c.length;u++)r=i(c[u]),!r&&0!==r||h[r]||(h[r]=!0,d.push({caption:r,childrenCardinality:"0",dimensionUniqueName:s,hierarchyUniqueName:s,levelUniqueName:s,name:r,uniqueName:r}));return d},this)}},options:{serverSorting:!0,serverPaging:!0,serverFiltering:!0,serverGrouping:!0,serverAggregates:!0},catalog:function(e){return e===t?this.transport.catalog():(this.transport.catalog(e),this._mergeState({}),this._axes={},this.data([]),t)},cube:function(e){return e===t?this.transport.cube():(this.transport.cube(e),this._axes={},this._mergeState({}),this.data([]),t)},axes:function(){return this._axes},columns:function(e){return e===t?this._columns:(this._skipNormalize+=1,this._clearAxesData=!0,this._columns=i(e),this.query({columns:e,rows:this.rowsAxisDescriptors(),measures:this.measures(),sort:this.sort(),filter:this.filter()}),t)},rows:function(e){return e===t?this._rows:(this._skipNormalize+=1,this._clearAxesData=!0,this._rows=i(e),this.query({columns:this.columnsAxisDescriptors(),rows:e,measures:this.measures(),sort:this.sort(),filter:this.filter()}),t)},measures:function(e){return e===t?this._measures:(this._skipNormalize+=1,this._clearAxesData=!0,this.query({columns:this.columnsAxisDescriptors(),rows:this.rowsAxisDescriptors(),measures:n(e),sort:this.sort(),filter:this.filter()}),t)},measuresAxis:function(){return this._measuresAxis||"columns"},_expandPath:function(e,t){var n,o,r,s="columns"===t?"columns":"rows",a="columns"===t?"rows":"columns",l=i(e),d=H(l[l.length-1]);for(this._lastExpanded=s,l=c(this.axes()[s],l,this.measures()),n=0;n<l.length;n++)if(o=H(l[n]),o===d){if(l[n].expand)return;l[n].expand=!0}else l[n].expand=!1;r={},r[s]=l,r[a]=this._descriptorsForAxis(a),this._query(r)},_descriptorsForAxis:function(e){var t=this.axes(),n=this[e]()||[];return t&&t[e]&&t[e].tuples&&t[e].tuples[0]&&(n=s(t[e].tuples||[])),n},columnsAxisDescriptors:function(){return this._descriptorsForAxis("columns")},rowsAxisDescriptors:function(){return this._descriptorsForAxis("rows")},_process:function(e,t){this._view=e,t=t||{},t.items=t.items||this._view,this.trigger(Se,t)},_query:function(e){var t=this;return e||(this._skipNormalize+=1,this._clearAxesData=!0),t.query(xe({},{page:t.page(),pageSize:t.pageSize(),sort:t.sort(),filter:t.filter(),group:t.group(),aggregate:t.aggregate(),columns:this.columnsAxisDescriptors(),rows:this.rowsAxisDescriptors(),measures:this.measures()},e))},query:function(t){var n=this._mergeState(t);return this._data.length&&this.cubeBuilder?(this._params(n),this._updateLocalData(this._pristineData),e.Deferred().resolve().promise()):this.read(n)},_mergeState:function(e){return e=ve.fn._mergeState.call(this,e),e!==t&&(this._measures=n(e.measures),e.columns?e.columns=i(e.columns):e.columns||(this._columns=[]),e.rows?e.rows=i(e.rows):e.rows||(this._rows=[])),e},filter:function(e){return e===t?this._filter:(this._skipNormalize+=1,this._clearAxesData=!0,this._query({filter:e,page:1}),t)},expandColumn:function(e){this._expandPath(e,"columns")},expandRow:function(e){this._expandPath(e,"rows")},success:function(e){var t;this.cubeBuilder&&(t=(this.reader.data(e)||[]).slice(0)),ve.fn.success.call(this,e),t&&(this._pristineData=t)},_processResult:function(e,t){var n,i,o,r,s,a,l,c,d,u,h;return this.cubeBuilder&&(n=this.cubeBuilder.process(e,this._requestData),e=n.data,t=n.axes),c=this.columns(),d=this.rows(),u=t.columns&&t.columns.tuples,c.length||!d.length||!u||!this._rowMeasures().length&&this.measures().length||(t={columns:{},rows:t.columns}),c.length||d.length||"rows"!==this.measuresAxis()||!u||(t={columns:{},rows:t.columns}),this._axes={columns:b(this._axes.columns),rows:b(this._axes.rows)},t={columns:b(t.columns),rows:b(t.rows)},i=this._normalizeTuples(t.columns.tuples,this._axes.columns.tuples,c,this._columnMeasures()),o=this._normalizeTuples(t.rows.tuples,this._axes.rows.tuples,d,this._rowMeasures()),this._skipNormalize>0&&(this._skipNormalize-=1),this.cubeBuilder||(e=this._normalizeData({columnsLength:t.columns.tuples.length,rowsLength:t.rows.tuples.length,columnIndexes:i,rowIndexes:o,data:e})),"rows"==this._lastExpanded?(r=t.columns.tuples,a=this._columnMeasures(),s=p(t.columns,this._axes.columns,a),s&&(l="columns",t.columns=s,m(r,s.tuples,t.rows.tuples.length,a,e),this.cubeBuilder||(e=this._normalizeData({columnsLength:_(t.columns.tuples,a),rowsLength:t.rows.tuples.length,data:e})))):"columns"==this._lastExpanded&&(r=t.rows.tuples,a=this._rowMeasures(),s=p(t.rows,this._axes.rows,a),s&&(l="rows",t.rows=s,g(r,s.tuples,t.columns.tuples.length,a,e),this.cubeBuilder||(e=this._normalizeData({columnsLength:_(t.rows.tuples,a),rowsLength:t.columns.tuples.length,data:e})))),this._lastExpanded=null,h=this._mergeAxes(t,e,l),this._axes=h.axes,h.data},_readData:function(e){var t=this.reader.axes(e),n=this.reader.data(e);return this.cubeBuilder&&(this._rawData=n),this._processResult(n,t)},_createTuple:function(e,t,n){var i,o,r,s,a,l,c,d,u=e.members,h=u.length,f={members:[]},p=0;for(t&&(h-=1);p<h;p++)d=u[p],o=+d.levelNum,r=d.name,s=d.parentName,c=d.caption||r,a=d.hasChildren,l=d.hierarchy,i=d.levelName,n&&(c="All",0===o?s=d.name:o-=1,a=!0,r=l=i=s),f.members.push({name:r,children:[],caption:c,levelName:i,levelNum:""+o,hasChildren:a,hierarchy:l,parentName:n?"":s});return t&&f.members.push({name:t.name,children:[]}),f},_hasRoot:function(e,t,n){var i,o,r,s,a,l,c;if(t.length)return x(t,e).tuple;for(i=e.members,s=!0,l=0,c=i.length;l<c;l++)if(o=i[l],a=+o.levelNum||0,r=n[l],!(0===a||r&&o.name===H(r))){s=!1;break}return s},_mergeAxes:function(e,t,n){var i,o,r,s,a,l=this._columnMeasures(),c=this._rowMeasures(),d=this.axes(),u=_(d.rows.tuples,c),h=e.rows.tuples.length,f=_(d.columns.tuples,l),p=e.columns.tuples.length;return"columns"==n?(p=f,o=e.columns.tuples):(o=A(e.columns.tuples,l),t=I(o,t)),r=y(d.columns.tuples,o,l),"rows"==n?(h=_(e.rows.tuples,c),o=e.rows.tuples):(o=A(e.rows.tuples,c),t=E(o,t)),s=y(d.rows.tuples,o,c),d.columns.tuples=r.tuples,d.rows.tuples=s.tuples,f!==_(d.columns.tuples,l)?(i=r.index+w(r.parsedRoot,r.memberIndex,l),a=f+p,t=this._mergeColumnData(t,i,h,p,a)):u!==_(d.rows.tuples,c)&&(i=s.index+w(s.parsedRoot,s.memberIndex,c),t=this._mergeRowData(t,i,h,p)),0===d.columns.tuples.length&&0===d.rows.tuples.length&&(t=[]),{axes:d,data:t}},_mergeColumnData:function(e,t,n,i,o){var r,s,a,l=this.data().toJSON(),c=0,d=Math.max(this._columnMeasures().length,1);for(n=Math.max(n,1),l.length>0&&(c=d,o-=d),r=0;r<n;r++)s=t+r*o,a=e.splice(0,i),a.splice(0,c),[].splice.apply(l,[s,0].concat(a));return l},_mergeRowData:function(e,t,n,i){var o,r,s,a=this.data().toJSON(),l=Math.max(this._rowMeasures().length,1);for(i=Math.max(i,1),a.length>0&&(n-=l,e.splice(0,i*l)),o=0;o<n;o++)s=e.splice(0,i),r=t*i+o*i,[].splice.apply(a,[r,0].concat(s));return a},_columnMeasures:function(){var e=this.measures(),t=[];return"columns"===this.measuresAxis()&&(0===this.columns().length?t=e:e.length>1&&(t=e)),t},_rowMeasures:function(){var e=this.measures(),t=[];return"rows"===this.measuresAxis()&&(0===this.rows().length?t=e:e.length>1&&(t=e)),t},_updateLocalData:function(e,t){this.cubeBuilder&&(t&&(this._requestData=t),e=this._processResult(e)),this._data=this._observe(e),this._ranges=[],this._addRange(this._data),this._total=this._data.length,this._pristineTotal=this._total,this._process(this._data)},data:function(e){var n=this;return e===t?n._data:(this._pristineData=e.slice(0),this._updateLocalData(e,{columns:this.columns(),rows:this.rows(),measures:this.measures()}),t)},_normalizeTuples:function(e,t,n,i){var o,r,s,a=i.length||1,l=0,c=[],d={},u=0;if(e.length){if(this._skipNormalize<=0&&!this._hasRoot(e[0],t,n)){for(this._skipNormalize=0;l<a;l++)c.push(this._createTuple(e[0],i[l],!0)),d[l]=l;e.splice.apply(e,[0,e.length].concat(c).concat(e)),l=a}if(i.length)for(s=o=e[l],r=o.members.length-1;o;){if(u>=a&&(u=0),o.members[r].name!==i[u].name&&(e.splice(l,0,this._createTuple(o,i[u])),d[l]=l),l+=1,u+=1,o=e[l],a>u&&(!o||le(s,r-1)!==le(o,r-1))){for(;u<a;u++)e.splice(l,0,this._createTuple(s,i[u])),d[l]=l,l+=1;o=e[l]}s=o}return d}},_addMissingDataItems:function(e,n){for(;n.rowIndexes[parseInt(e.length/n.columnsLength,10)]!==t;)for(var i=0;i<n.columnsLength;i++)e=f(e);for(;n.columnIndexes[e.length%n.columnsLength]!==t;)e=f(e);return e},_normalizeOrdinals:function(e,t,n){var i=n.lastOrdinal;if(!t)return f(e);if(t.ordinal-i>1)for(i+=1;i<t.ordinal&&e.length<n.length;)e=this._addMissingDataItems(f(e),n),i+=1;return t.ordinal=e.length,e[e.length]=t,e},_normalizeData:function(e){var t,n,i,o=e.data,r=0,s=[];if(e.lastOrdinal=0,e.columnIndexes=e.columnIndexes||{},e.rowIndexes=e.rowIndexes||{},e.columnsLength=e.columnsLength||1,e.rowsLength=e.rowsLength||1,e.length=e.columnsLength*e.rowsLength,i=e.length,o.length===i)return o;for(;s.length<i;)t=o[r++],t&&(n=t.ordinal),s=this._normalizeOrdinals(this._addMissingDataItems(s,e),t,e),e.lastOrdinal=n;return s},discover:function(t,n){var i=this,o=i.transport;return e.Deferred(function(e){o.discover(xe({success:function(t){t=i.reader.parse(t),i._handleCustomErrors(t)||(n&&(t=n(t)),e.resolve(t))},error:function(t,n,o){e.reject(t),i.error(t,n,o)}},t))}).promise().done(function(){i.trigger("schemaChange")})},schemaMeasures:function(){var e=this;return e.discover({data:{command:"schemaMeasures",restrictions:{catalogName:e.transport.catalog(),cubeName:e.transport.cube()}}},function(t){return e.reader.measures(t)})},schemaKPIs:function(){var e=this;return e.discover({data:{command:"schemaKPIs",restrictions:{catalogName:e.transport.catalog(),cubeName:e.transport.cube()}}},function(t){return e.reader.kpis(t)})},schemaDimensions:function(){var e=this;return e.discover({data:{command:"schemaDimensions",restrictions:{catalogName:e.transport.catalog(),cubeName:e.transport.cube()}}},function(t){return e.reader.dimensions(t)})},schemaHierarchies:function(e){var t=this;return t.discover({data:{command:"schemaHierarchies",restrictions:{catalogName:t.transport.catalog(),cubeName:t.transport.cube(),dimensionUniqueName:e}}},function(e){return t.reader.hierarchies(e)})},schemaLevels:function(e){var t=this;return t.discover({data:{command:"schemaLevels",restrictions:{catalogName:t.transport.catalog(),cubeName:t.transport.cube(),hierarchyUniqueName:e}}},function(e){return t.reader.levels(e)})},schemaCubes:function(){var e=this;return e.discover({data:{command:"schemaCubes",restrictions:{catalogName:e.transport.catalog()}}},function(t){return e.reader.cubes(t)})},schemaCatalogs:function(){var e=this;return e.discover({data:{command:"schemaCatalogs"}},function(t){return e.reader.catalogs(t)})},schemaMembers:function(e){var t=this,n=function(e){return function(n){return t.reader.members(n,e)}}(e);return t.discover({data:{command:"schemaMembers",restrictions:xe({catalogName:t.transport.catalog(),cubeName:t.transport.cube()},e)}},n)},_params:function(e){this._clearAxesData&&(this._axes={},this._data=this._observe([]),this._clearAxesData=!1,this.trigger(Ee));var t=ve.fn._params.call(this,e);return t=xe({measures:this.measures(),measuresAxis:this.measuresAxis(),columns:this.columns(),rows:this.rows()},t),this.cubeBuilder&&(this._requestData=t),t}});Qe.create=function(e){e=e&&e.push?{data:e}:e;var t=e||{},n=t.data;if(t.data=n,!(t instanceof Qe)&&t instanceof fe.data.DataSource)throw Error("Incorrect DataSource type. Only PivotDataSource instances are supported");return t instanceof Qe?t:new Qe(t)},K={contains:', InStr({0}.CurrentMember.MEMBER_CAPTION,"{1}") > 0',doesnotcontain:', InStr({0}.CurrentMember.MEMBER_CAPTION,"{1}")',startswith:', Left({0}.CurrentMember.MEMBER_CAPTION,Len("{1}"))="{1}"',endswith:', Right({0}.CurrentMember.MEMBER_CAPTION,Len("{1}"))="{1}"',eq:', {0}.CurrentMember.MEMBER_CAPTION = "{1}"',neq:', {0}.CurrentMember.MEMBER_CAPTION = "{1}"'},Y={schemaCubes:"MDSCHEMA_CUBES",schemaCatalogs:"DBSCHEMA_CATALOGS",schemaMeasures:"MDSCHEMA_MEASURES",schemaDimensions:"MDSCHEMA_DIMENSIONS",schemaHierarchies:"MDSCHEMA_HIERARCHIES",schemaLevels:"MDSCHEMA_LEVELS",schemaMembers:"MDSCHEMA_MEMBERS",schemaKPIs:"MDSCHEMA_KPIS"},Q={read:function(e){var t,n,i,o,r,s='<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Header/><Body><Execute xmlns="urn:schemas-microsoft-com:xml-analysis"><Command><Statement>';return s+="SELECT NON EMPTY {",t=e.columns||[],n=e.rows||[],i=e.measures||[],o="rows"===e.measuresAxis,r=e.sort||[],!t.length&&n.length&&(!i.length||i.length&&o)&&(t=n,n=[],o=!1),t.length||n.length||(o=!1),t.length?s+=U(t,o?[]:i,r):i.length&&!o&&(s+=L(i).join(",")),s+="} DIMENSION PROPERTIES CHILDREN_CARDINALITY, PARENT_UNIQUE_NAME ON COLUMNS",(n.length||o&&i.length>1)&&(s+=", NON EMPTY {",s+=n.length?U(n,o?i:[],r):L(i).join(","),s+="} DIMENSION PROPERTIES CHILDREN_CARDINALITY, PARENT_UNIQUE_NAME ON ROWS"),e.filter?(s+=" FROM ",s+="(",s+=j(e.filter,e.connection.cube),s+=")"):s+=" FROM ["+e.connection.cube+"]",1==i.length&&t.length&&(s+=" WHERE ("+L(i).join(",")+")"),s+="</Statement></Command><Properties><PropertyList><Catalog>"+e.connection.catalog+"</Catalog><Format>Multidimensional</Format></PropertyList></Properties></Execute></Body></Envelope>",s.replace(/\&/g,"&amp;")},discover:function(t){t=t||{};var n='<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Header/><Body><Discover xmlns="urn:schemas-microsoft-com:xml-analysis">';return n+="<RequestType>"+(Y[t.command]||t.command)+"</RequestType>",n+="<Restrictions>"+q("RestrictionList",t.restrictions,!0)+"</Restrictions>",t.connection&&t.connection.catalog&&(t.properties=e.extend({},{Catalog:t.connection.catalog},t.properties)),n+="<Properties>"+q("PropertyList",t.properties)+"</Properties>",n+="</Discover></Body></Envelope>"}},X=fe.data.RemoteTransport.extend({init:function(e){var t=e;e=this.options=xe(!0,{},this.options,e),fe.data.RemoteTransport.call(this,e),Ce(t.discover)?this.discover=t.discover:"string"==typeof t.discover?this.options.discover={url:t.discover}:t.discover||(this.options.discover=this.options.read)},setup:function(t,n){return t.data=t.data||{},e.extend(!0,t.data,{connection:this.options.connection}),fe.data.RemoteTransport.fn.setup.call(this,t,n)},options:{read:{dataType:"text",contentType:"text/xml",type:"POST"},discover:{dataType:"text",contentType:"text/xml",type:"POST"},parameterMap:function(e,t){return Q[t](e,t)}},discover:function(t){return e.ajax(this.setup(t,"discover"))}}),Z={cubes:{name:fe.getter("CUBE_NAME['#text']",!0),caption:fe.getter("CUBE_CAPTION['#text']",!0),description:fe.getter("DESCRIPTION['#text']",!0),type:fe.getter("CUBE_TYPE['#text']",!0)},catalogs:{name:fe.getter("CATALOG_NAME['#text']",!0),description:fe.getter("DESCRIPTION['#text']",!0)},measures:{name:fe.getter("MEASURE_NAME['#text']",!0),caption:fe.getter("MEASURE_CAPTION['#text']",!0),uniqueName:fe.getter("MEASURE_UNIQUE_NAME['#text']",!0),description:fe.getter("DESCRIPTION['#text']",!0),aggregator:fe.getter("MEASURE_AGGREGATOR['#text']",!0),groupName:fe.getter("MEASUREGROUP_NAME['#text']",!0),displayFolder:fe.getter("MEASURE_DISPLAY_FOLDER['#text']",!0),defaultFormat:fe.getter("DEFAULT_FORMAT_STRING['#text']",!0)},kpis:{name:fe.getter("KPI_NAME['#text']",!0),caption:fe.getter("KPI_CAPTION['#text']",!0),value:fe.getter("KPI_VALUE['#text']",!0),goal:fe.getter("KPI_GOAL['#text']",!0),status:fe.getter("KPI_STATUS['#text']",!0),trend:fe.getter("KPI_TREND['#text']",!0),statusGraphic:fe.getter("KPI_STATUS_GRAPHIC['#text']",!0),trendGraphic:fe.getter("KPI_TREND_GRAPHIC['#text']",!0),description:fe.getter("KPI_DESCRIPTION['#text']",!0),groupName:fe.getter("MEASUREGROUP_NAME['#text']",!0)},dimensions:{name:fe.getter("DIMENSION_NAME['#text']",!0),caption:fe.getter("DIMENSION_CAPTION['#text']",!0),description:fe.getter("DESCRIPTION['#text']",!0),uniqueName:fe.getter("DIMENSION_UNIQUE_NAME['#text']",!0),defaultHierarchy:fe.getter("DEFAULT_HIERARCHY['#text']",!0),type:fe.getter("DIMENSION_TYPE['#text']",!0)},hierarchies:{name:fe.getter("HIERARCHY_NAME['#text']",!0),caption:fe.getter("HIERARCHY_CAPTION['#text']",!0),description:fe.getter("DESCRIPTION['#text']",!0),uniqueName:fe.getter("HIERARCHY_UNIQUE_NAME['#text']",!0),dimensionUniqueName:fe.getter("DIMENSION_UNIQUE_NAME['#text']",!0),displayFolder:fe.getter("HIERARCHY_DISPLAY_FOLDER['#text']",!0),origin:fe.getter("HIERARCHY_ORIGIN['#text']",!0),defaultMember:fe.getter("DEFAULT_MEMBER['#text']",!0)},levels:{name:fe.getter("LEVEL_NAME['#text']",!0),caption:fe.getter("LEVEL_CAPTION['#text']",!0),description:fe.getter("DESCRIPTION['#text']",!0),uniqueName:fe.getter("LEVEL_UNIQUE_NAME['#text']",!0),dimensionUniqueName:fe.getter("DIMENSION_UNIQUE_NAME['#text']",!0),displayFolder:fe.getter("LEVEL_DISPLAY_FOLDER['#text']",!0),orderingProperty:fe.getter("LEVEL_ORDERING_PROPERTY['#text']",!0),origin:fe.getter("LEVEL_ORIGIN['#text']",!0),hierarchyUniqueName:fe.getter("HIERARCHY_UNIQUE_NAME['#text']",!0)},members:{name:fe.getter("MEMBER_NAME['#text']",!0),caption:fe.getter("MEMBER_CAPTION['#text']",!0),uniqueName:fe.getter("MEMBER_UNIQUE_NAME['#text']",!0),dimensionUniqueName:fe.getter("DIMENSION_UNIQUE_NAME['#text']",!0),hierarchyUniqueName:fe.getter("HIERARCHY_UNIQUE_NAME['#text']",!0),levelUniqueName:fe.getter("LEVEL_UNIQUE_NAME['#text']",!0),childrenCardinality:fe.getter("CHILDREN_CARDINALITY['#text']",!0)}},J=["axes","catalogs","cubes","dimensions","hierarchies","levels","measures"],ee=fe.data.XmlDataReader.extend({init:function(e){fe.data.XmlDataReader.call(this,e),this._extend(e)},_extend:function(e){for(var t,n,i=0,o=J.length;i<o;i++)t=J[i],n=e[t],n&&n!==ye&&(this[t]=n)},parse:function(e){var t=fe.data.XmlDataReader.fn.parse(e.replace(/<(\/?)(\w|-)+:/g,"<$1"));return fe.getter("['Envelope']['Body']",!0)(t)},errors:function(e){var t=fe.getter("['Fault']",!0)(e);return t?[{faultstring:fe.getter("faultstring['#text']",!0)(t),faultcode:fe.getter("faultcode['#text']",!0)(t)}]:null},axes:function(e){var t,n,i,o;for(e=fe.getter('ExecuteResponse["return"].root',!0)(e),t=G(fe.getter("Axes.Axis",!0)(e)),i={columns:{},rows:{}},o=0;o<t.length;o++)n=t[o],"sliceraxis"!==n["@name"].toLowerCase()&&(i.columns.tuples?i.rows=$(n):i.columns=$(n));return i},data:function(e){var t,n,i,o,r,s;for(e=fe.getter('ExecuteResponse["return"].root',!0)(e),t=G(fe.getter("CellData.Cell",!0)(e)),n=[],i=fe.getter("['@CellOrdinal']"),o=fe.getter("Value['#text']"),r=fe.getter("FmtValue['#text']"),s=0;s<t.length;s++)n.push({value:o(t[s]),fmtValue:r(t[s]),ordinal:parseInt(i(t[s]),10)});return n},_mapSchema:function(e,t){var n,i,o,r,s;for(e=fe.getter('DiscoverResponse["return"].root',!0)(e),n=G(fe.getter("row",!0)(e)),i=[],o=0;o<n.length;o++){r={};for(s in t)r[s]=t[s](n[o]);i.push(r)}return i},measures:function(e){return this._mapSchema(e,Z.measures)},kpis:function(e){return this._mapSchema(e,Z.kpis)},hierarchies:function(e){return this._mapSchema(e,Z.hierarchies)},levels:function(e){return this._mapSchema(e,Z.levels)},dimensions:function(e){return this._mapSchema(e,Z.dimensions)},cubes:function(e){return this._mapSchema(e,Z.cubes)},catalogs:function(e){return this._mapSchema(e,Z.catalogs)},members:function(e){return this._mapSchema(e,Z.members)}}),xe(!0,fe.data,{PivotDataSource:Qe,XmlaTransport:X,XmlaDataReader:ee,PivotCubeBuilder:Ke,transports:{xmla:X},readers:{xmla:ee}}),te=function(e,t){if(!e)return null;for(var n=0,i=e.length;n<i;n++)if(e[n].field===t)return e[n];return null},ne=function(e,t){var n,i,o=[];for(n=0,i=e.length;n<i;n++)e[n].field!==t&&o.push(e[n]);return o},fe.ui.PivotSettingTarget=ge.extend({init:function(t,n){var i=this;ge.fn.init.call(i,t,n),i.element.addClass("k-pivot-setting"),i.dataSource=fe.data.PivotDataSource.create(n.dataSource),i._refreshHandler=e.proxy(i.refresh,i),i.dataSource.first(Se,i._refreshHandler),n.template||(i.options.template="<div data-"+fe.ns+'name="${data.name || data}">${data.name || data}'+(i.options.enabled?'<a class="k-button k-button-icon k-bare"><span class="k-icon k-i-close k-setting-delete"></span></a>':"")+"</div>"),i.template=fe.template(i.options.template),i.emptyTemplate=fe.template(i.options.emptyTemplate),i._sortable(),i.element.on("click"+Re,".k-button,.k-item",function(t){var n=e(t.target),o=n.closest("["+fe.attr("name")+"]").attr(fe.attr("name"));o&&(n.hasClass("k-i-close")?i.remove(o):i.options.sortable&&n[0]===t.currentTarget&&i.sort({field:o,dir:n.find(".k-i-sort-asc-sm")[0]?"desc":"asc"}))}),(n.filterable||n.sortable)&&(i.fieldMenu=new pe.PivotFieldMenu(i.element,{messages:i.options.messages.fieldMenu,filter:".k-setting-fieldmenu",filterable:n.filterable,sortable:n.sortable,dataSource:i.dataSource})),i.refresh()},options:{name:"PivotSettingTarget",template:null,filterable:!1,sortable:!1,emptyTemplate:"<div class='k-empty'>${data}</div>",setting:"columns",enabled:!0,messages:{empty:"Drop Fields Here"}},setDataSource:function(e){this.dataSource.unbind(Se,this._refreshHandler),this.dataSource=this.options.dataSource=e,this.fieldMenu&&this.fieldMenu.setDataSource(e),e.first(Se,this._refreshHandler),this.refresh()},_sortable:function(){var e=this;e.options.enabled&&(this.sortable=this.element.kendoSortable({connectWith:this.options.connectWith,hint:e.options.hint,cursor:"move",start:function(e){e.item.focus().blur()},change:function(t){var n=t.item.attr(fe.attr("name"));"receive"==t.action?e.add(n):"remove"==t.action?e.remove(n):"sort"==t.action&&e.move(n,t.newIndex)}}).data("kendoSortable"))},_indexOf:function(e,t){var n,i,o=-1;for(n=0,i=t.length;n<i;n++)if(H(t[n])===e){o=n;break}return o},_isKPI:function(e){return"kpi"===e.type||e.measure},validate:function(e){var t,n,i=2==e.type||"aggregator"in e||this._isKPI(e);return i?"measures"===this.options.setting:"measures"===this.options.setting?i:(t=this.dataSource[this.options.setting](),n=e.defaultHierarchy||e.uniqueName,!(this._indexOf(n,t)>-1)&&(t=this.dataSource["columns"===this.options.setting?"rows":"columns"](),!(this._indexOf(n,t)>-1)))},add:function(t){var n,i,o=this.dataSource[this.options.setting]();for(t=e.isArray(t)?t.slice(0):[t],n=0,i=t.length;n<i;n++)this._indexOf(t[n],o)!==-1&&(t.splice(n,1),n-=1,i-=1);t.length&&(o=o.concat(t),this.dataSource[this.options.setting](o))},move:function(e,t){var n=this.dataSource[this.options.setting](),i=this._indexOf(e,n);i>-1&&(e=n.splice(i,1)[0],n.splice(t,0,e),this.dataSource[this.options.setting](n))},remove:function(e){var t=this.dataSource[this.options.setting](),n=this._indexOf(e,t),i=this.dataSource.sort(),o=this.dataSource.filter();n>-1&&(o&&(o.filters=ne(o.filters,e),this.dataSource._filter.filters=o.filters,o.filters.length||(this.dataSource._filter=null)),i&&(i=ne(i,e),this.dataSource._sort=i),t.splice(n,1),this.dataSource[this.options.setting](t))},sort:function(e){var t=this.options.sortable,n=t===!0||t.allowUnsort,i=n&&"asc"===e.dir,o=this.dataSource.sort()||[],r=ne(o,e.field);i&&o.length!==r.length&&(e=null),e&&r.push(e),this.dataSource.sort(r)},refresh:function(){var e,n="",i=this.dataSource[this.options.setting](),o=i.length,r=0;if(o)for(;r<o;r++)e=i[r],e=e.name===t?{name:e}:e,n+=this.template(xe({sortIcon:this._sortIcon(e.name)},e));else n=this.emptyTemplate(this.options.messages.empty);this.element.html(n)},destroy:function(){ge.fn.destroy.call(this),this.dataSource.unbind(Se,this._refreshHandler),this.element.off(Re),this.sortable&&this.sortable.destroy(),this.fieldMenu&&this.fieldMenu.destroy(),this.element=null,this._refreshHandler=null},_sortIcon:function(e){var t=this.dataSource.sort(),n=te(t,H(e)),i="";return n&&(i="k-i-sort-"+n.dir),i}}),ie=ge.extend({init:function(n,i){var o,r,s=this;ge.fn.init.call(s,n,i),s._dataSource(),s._bindConfigurator(),s._wrapper(),s._createLayout(),s._columnBuilder=o=new ce,s._rowBuilder=r=new de,s._contentBuilder=new ue,s._templates(),s.columnsHeader.add(s.rowsHeader).on("click","span.k-icon",function(){var n,i,a,l,c=e(this),d=o,u="expandColumn",h=c.attr(fe.attr("path")),f={axis:"columns",path:e.parseJSON(h)};c.parent().is("td")&&(d=r,u="expandRow",f.axis="rows"),i=c.hasClass(He),a=d.metadata[h],l=a.expanded===t,n=i?Le:Be,f.childrenLoaded=a.maxChildren>a.children,s.trigger(n,f)||(d.metadata[h].expanded=!i,c.toggleClass(He,!i).toggleClass(Ne,i),!i&&l?s.dataSource[u](f.path):s.refresh())}),s._scrollable(),s.options.autoBind&&s.dataSource.fetch(),fe.notify(s)},events:[ze,Pe,Be,Le],options:{name:"PivotGrid",autoBind:!0,reorderable:!0,filterable:!1,sortable:!1,height:null,columnWidth:100,configurator:"",columnHeaderTemplate:null,rowHeaderTemplate:null,dataCellTemplate:null,kpiStatusTemplate:null,kpiTrendTemplate:null,messages:{measureFields:"Drop Data Fields Here",columnFields:"Drop Column Fields Here",rowFields:"Drop Rows Fields Here"}},_templates:function(){var e=this.options.columnHeaderTemplate,t=this.options.rowHeaderTemplate,n=this.options.dataCellTemplate,i=this.options.kpiStatusTemplate,o=this.options.kpiTrendTemplate;this._columnBuilder.template=fe.template(e||Oe,{useWithBlock:!!e}),this._contentBuilder.dataTemplate=fe.template(n||We,{useWithBlock:!!n}),this._contentBuilder.kpiStatusTemplate=fe.template(i||Ve,{useWithBlock:!!i}),this._contentBuilder.kpiTrendTemplate=fe.template(o||Ue,{useWithBlock:!!o}),this._rowBuilder.template=fe.template(t||Oe,{useWithBlock:!!t})},_bindConfigurator:function(){var t=this.options.configurator;t&&e(t).kendoPivotConfigurator("setDataSource",this.dataSource)},cellInfoByElement:function(t){return t=e(t),this.cellInfo(t.index(),t.parent("tr").index())},cellInfo:function(e,t){var n,i=this._contentBuilder,o=i.columnIndexes[e||0],r=i.rowIndexes[t||0];return o&&r?(n=r.index*i.rowLength+o.index,{columnTuple:o.tuple,rowTuple:r.tuple,measure:o.measure||r.measure,dataItem:this.dataSource.view()[n]}):null},setDataSource:function(e){this.options.dataSource=e,this._dataSource(),this.measuresTarget&&this.measuresTarget.setDataSource(e),this.rowsTarget&&this.rowsTarget.setDataSource(e),this.columnsTarget&&this.columnsTarget.setDataSource(e),this._bindConfigurator(),this.options.autoBind&&e.fetch()},setOptions:function(e){ge.fn.setOptions.call(this,e),this._templates()},destroy:function(){ge.fn.destroy.call(this),clearTimeout(this._headerReflowTimeout)},_dataSource:function(){var t=this,n=t.options.dataSource;n=e.isArray(n)?{data:n}:n,t.dataSource&&this._refreshHandler?t.dataSource.unbind(Se,t._refreshHandler).unbind(Ee,t._stateResetHandler).unbind(Ae,t._progressHandler).unbind(Te,t._errorHandler):(t._refreshHandler=e.proxy(t.refresh,t),t._progressHandler=e.proxy(t._requestStart,t),t._stateResetHandler=e.proxy(t._stateReset,t),t._errorHandler=e.proxy(t._error,t)),t.dataSource=fe.data.PivotDataSource.create(n).bind(Se,t._refreshHandler).bind(Ae,t._progressHandler).bind(Ee,t._stateResetHandler).bind(Te,t._errorHandler)},_error:function(){this._progress(!1)},_requestStart:function(){this._progress(!0)},_stateReset:function(){this._columnBuilder.reset(),this._rowBuilder.reset()},_wrapper:function(){
var e=this.options.height;this.wrapper=this.element.addClass("k-widget k-pivot"),e&&this.wrapper.css("height",e)},_measureFields:function(){this.measureFields=e(Me).addClass("k-pivot-toolbar k-header k-settings-measures"),this.measuresTarget=this._createSettingTarget(this.measureFields,{setting:"measures",messages:{empty:this.options.messages.measureFields}})},_createSettingTarget:function(t,n){var i='<span tabindex="0" class="k-button" data-'+fe.ns+'name="${data.name}">${data.name}',o=n.sortable,r="";return o&&(r+="#if (data.sortIcon) {#",r+='<span class="k-icon ${data.sortIcon}-sm"></span>',r+="#}#"),(n.filterable||o)&&(r+='<span class="k-icon k-i-more-vertical k-setting-fieldmenu"></span>'),this.options.reorderable&&(r+='<span class="k-icon k-i-close k-setting-delete"></span>'),r&&(i+='<span class="k-field-actions">'+r+"</span>"),i+="</span>",new fe.ui.PivotSettingTarget(t,e.extend({template:i,emptyTemplate:'<span class="k-empty">${data}</span>',enabled:this.options.reorderable,dataSource:this.dataSource},n))},_initSettingTargets:function(){this.columnsTarget=this._createSettingTarget(this.columnFields,{connectWith:this.rowFields,setting:"columns",filterable:this.options.filterable,sortable:this.options.sortable,messages:{empty:this.options.messages.columnFields,fieldMenu:this.options.messages.fieldMenu}}),this.rowsTarget=this._createSettingTarget(this.rowFields,{connectWith:this.columnFields,setting:"rows",filterable:this.options.filterable,sortable:this.options.sortable,messages:{empty:this.options.messages.rowFields,fieldMenu:this.options.messages.fieldMenu}})},_createLayout:function(){var t=this,n=e(je),i=n.find(".k-pivot-rowheaders"),o=n.find(".k-pivot-table"),r=e(Me).addClass("k-grid k-widget");t._measureFields(),t.columnFields=e(Me).addClass("k-pivot-toolbar k-header k-settings-columns"),t.rowFields=e(Me).addClass("k-pivot-toolbar k-header k-settings-rows"),t.columnsHeader=e('<div class="k-grid-header-wrap" />').wrap('<div class="k-grid-header" />'),t.columnsHeader.parent().css("padding-right",fe.support.scrollbar()),t.rowsHeader=e('<div class="k-grid k-widget k-alt"/>'),t.content=e('<div class="k-grid-content" />'),i.append(t.measureFields),i.append(t.rowFields),i.append(t.rowsHeader),r.append(t.columnsHeader.parent()),r.append(t.content),o.append(t.columnFields),o.append(r),t.wrapper.append(n),t.columnsHeaderTree=new fe.dom.Tree(t.columnsHeader[0]),t.rowsHeaderTree=new fe.dom.Tree(t.rowsHeader[0]),t.contentTree=new fe.dom.Tree(t.content[0]),t._initSettingTargets()},_progress:function(e){fe.ui.progress(this.wrapper,e)},_resize:function(){this.content[0].firstChild&&(this._setSectionsWidth(),this._setSectionsHeight(),this._setContentWidth(),this._setContentHeight(),this._columnHeaderReflow())},_columnHeaderReflow:function(){var e=this.columnsHeader.children("table");fe.support.browser.mozilla&&(clearTimeout(this._headerReflowTimeout),e.css("table-layout","auto"),this._headerReflowTimeout=setTimeout(function(){e.css("table-layout","")}))},_setSectionsWidth:function(){var e=this.rowsHeader,t=e.parent(".k-pivot-rowheaders").width(Ie),n=Math.max(_e(this.measureFields),_e(this.rowFields));n=Math.max(e.children("table").width(),n),t.width(n)},_setSectionsHeight:function(){var e=this.measureFields.height(Ie).height(),t=this.columnFields.height(Ie).height(),n=this.rowFields.height(Ie).innerHeight(),i=this.columnsHeader.height(Ie).innerHeight(),o=n-this.rowFields.height(),r=t>e?t:e,s=i>n?i:n;this.measureFields.height(r),this.columnFields.height(r),this.rowFields.height(s-o),this.columnsHeader.height(s)},_setContentWidth:function(){var e=this.content.find("table"),t=this.columnsHeader.children("table"),n=e.children("colgroup").children().length,i=n*this.options.columnWidth,o=Math.ceil(i/this.content.width()*100);o<100&&(o=100),e.add(t).css("width",o+"%"),this._resetColspan(t)},_setContentHeight:function(){var e=this,n=e.content,i=e.rowsHeader,o=e.wrapper.innerHeight(),r=fe.support.scrollbar(),s=n[0].offsetHeight===n[0].clientHeight,a=e.options.height;if(e.wrapper.is(":visible")){if(!o||!a)return s&&(r=0),n.height("auto"),i.height(n.height()-r),t;o-=be(e.columnFields),o-=be(e.columnsHeader),o<=2*r&&(o=2*r+1,s||(o+=r)),n.height(o),s&&(r=0),i.height(o-r)}},_resetColspan:function(e){var n=this,i=e.children("tbody").children(":first").children(":first");n._colspan===t&&(n._colspan=i.attr("colspan")),i.attr("colspan",1),clearTimeout(n._layoutTimeout),n._layoutTimeout=setTimeout(function(){i.attr("colspan",n._colspan),n._colspan=t})},_axisMeasures:function(e){var t=[],n=this.dataSource,i=n.measures(),o=i.length>1||i[0]&&i[0].type;return n.measuresAxis()===e&&(0===n[e]().length||o)&&(t=i),t},items:function(){return[]},refresh:function(){var e,t=this,n=t.dataSource,i=n.axes(),o=(i.columns||{}).tuples||[],r=(i.rows||{}).tuples||[],s=t._columnBuilder,a=t._rowBuilder,l={},c={};t.trigger(ze,{action:"rebind"})||(s.measures=t._axisMeasures(Ge),a.measures=t._axisMeasures(qe),t.columnsHeaderTree.render(s.build(o)),t.rowsHeaderTree.render(a.build(r)),l={indexes:s._indexes,measures:s.measures,metadata:s.metadata},c={indexes:a._indexes,measures:a.measures,metadata:a.metadata},t.contentTree.render(t._contentBuilder.build(n.view(),l,c)),t._resize(),t.touchScroller?t.touchScroller.contentResized():(e=fe.touchScroller(t.content),e&&e.movable&&(t.touchScroller=e,e.movable.bind("change",function(e){t.columnsHeader.scrollLeft(-e.sender.x),t.rowsHeader.scrollTop(-e.sender.y)}))),t._progress(!1),t.trigger(Pe))},_scrollable:function(){var t=this,n=t.columnsHeader,i=t.rowsHeader;t.content.scroll(function(){n.scrollLeft(this.scrollLeft),i.scrollTop(this.scrollTop)}),i.bind("DOMMouseScroll"+Re+" mousewheel"+Re,e.proxy(t._wheelScroll,t))},_wheelScroll:function(t){var n,i;t.ctrlKey||(n=fe.wheelDeltaY(t),i=this.content.scrollTop(),n&&(t.preventDefault(),e(t.currentTarget).one("wheel"+Re,!1),this.rowsHeader.scrollTop(i+-n),this.content.scrollTop(i+-n)))}}),oe=fe.dom.element,re=fe.dom.html,se=function(e,t){return{maxChildren:0,children:0,maxMembers:0,members:0,measures:1,levelNum:e,parentMember:0!==t}},ae=function(e,t){for(var n=[],i=0;i<=t;i++)n.push(e.members[i].name);return n},le=function(e,t){for(var n="",i=0;i<=t;i++)n+=e.members[i].name;return n},ce=me.extend({init:function(){this.measures=1,this.metadata={}},build:function(e){var t=this._tbody(e),n=this._colGroup();return[oe("table",null,[n,t])]},reset:function(){this.metadata={}},_colGroup:function(){for(var e=this._rowLength(),t=[],n=0;n<e;n++)t.push(oe("col",null));return oe("colgroup",null,t)},_tbody:function(e){var t=e[0];return this.map={},this.rows=[],this.rootTuple=t,this._indexes=[],t?(this._buildRows(t,0),this._normalize()):this.rows.push(oe("tr",null,[oe("th",null,[re("&nbsp;")])])),oe("tbody",null,this.rows)},_normalize:function(){for(var e,t,n,i,o,r=this.rows,s=r.length,a=0;a<s;a++)if(e=r[a],1!==e.rowSpan)for(i=e.children,n=0,t=i.length;n<t;n++)o=i[n],o.tupleAll&&(o.attr.rowSpan=e.rowSpan)},_rowIndex:function(e){for(var t=this.rows,n=t.length,i=0;i<n&&t[i]!==e;i++);return i},_rowLength:function(){var e=this.rows[0]?this.rows[0].children:[],t=e.length,n=0,i=0;if(t)for(;i<t;i++)n+=e[i].attr.colSpan||1;return n||(n=this.measures),n},_row:function(e,t,n){var i,o,r=this.rootTuple.members[t].name,s=e.members[t].levelNum,a=r+s,l=this.map,c=l[a];return c?(c.notFirst=!1,c.parentMember&&c.parentMember===n||(c.parentMember=n,c.collapsed=0,c.colSpan=0)):(c=oe("tr",null,[]),c.parentMember=n,c.collapsed=0,c.colSpan=0,c.rowSpan=1,l[a]=c,i=l[r+(+s-1)],i&&(o=i.children,c.notFirst=!(!o[1]||o[1].attr.className.indexOf("k-alt")!==-1)||i.notFirst),this.rows.splice(this._rowIndex(i)+1,0,c)),c},_measures:function(e,t,n){var i,o,r,s=this.map,a=s.measureRow;for(a||(a=oe("tr",null,[]),s.measureRow=a,this.rows.push(a)),o=0,r=e.length;o<r;o++)i=e[o],a.children.push(this._cell(n||"",[this._content(i,t)],i));return r},_content:function(e,t){return re(this.template({member:e,tuple:t}))},_cell:function(e,t,n){var i=oe("th",{className:"k-header"+e},t);return i.value=n.caption||n.name,i},_buildRows:function(e,n,i){var o,r,s,a,l,c,d,u,h,f,p=e.members,m=p[n],g=p[n+1],v=[],_=0,b=0,w=0;if(m.measure)return this._measures(m.children,e),t;if(u=fe.stringify(ae(e,n)),o=this._row(e,n,i),s=m.children,a=s.length,h=this.metadata[u],h||(this.metadata[u]=h=se(+m.levelNum,n),h.rootLevelNum=+this.rootTuple.members[n].levelNum),this._indexes.push({path:u,tuple:e}),m.hasChildren&&(h.expanded===!1&&(b=h.maxChildren,o.collapsed+=b,h.children=0,a=0),d={className:"k-icon "+(a?He:Ne)},d[fe.attr("path")]=u,v.push(oe("span",d))),v.push(this._content(m,e)),l=this._cell(o.notFirst?" k-first":"",v,m),o.children.push(l),o.colSpan+=1,a){for(c=this._cell(" k-alt",[this._content(m,e)],m),o.children.push(c);_<a;_++)r=this._buildRows(s[_],n,m);f=r.colSpan,b=r.collapsed,l.attr.colSpan=f,h.children=f,h.members=1,o.colSpan+=f,o.collapsed+=b,o.rowSpan=r.rowSpan+1,g&&(g.measure?f=this._measures(g.children,e," k-alt"):(r=this._buildRows(e,n+1),f=r.colSpan,o.collapsed+=r.collapsed,w=r.collapsed),c.attr.colSpan=f,f-=1,h.members+=f,o.colSpan+=f)}else g&&(g.measure?f=this._measures(g.children,e):(r=this._buildRows(e,n+1),f=r.colSpan,o.collapsed+=r.collapsed,w=r.collapsed),h.members=f,f>1&&(l.attr.colSpan=f,o.colSpan+=f-1));return h.maxMembers<h.members+w&&(h.maxMembers=h.members+w),s=h.children+b,h.maxChildren<s&&(h.maxChildren=s),(c||l).tupleAll=!0,o}}),de=me.extend({init:function(){this.metadata={}},build:function(e){var t=this._tbody(e),n=this._colGroup();return[oe("table",null,[n,t])]},reset:function(){this.metadata={}},_rowLength:function(){for(var e=this.rows[0].children,t=0,n=0,i=e[n];i;)t+=i.attr.colSpan||1,i=e[++n];return t},_colGroup:function(){for(var e=this._rowLength(),t=[],n=0;n<e;n++)t.push(oe("col",null));return oe("colgroup",null,t)},_tbody:function(e){var t=e[0];return this.rootTuple=t,this.rows=[],this.map={},this._indexes=[],t?(this._buildRows(t,0),this._normalize()):this.rows.push(oe("tr",null,[oe("td",null,[re("&nbsp;")])])),oe("tbody",null,this.rows)},_normalize:function(){for(var e,t,n,i,o=this.rows,r=o.length,s=0,a=this.rootTuple.members,l=a[0].name,c=a.length,d=0,u=this.map;s<r;s++)for(e=o[s],d=0;d<c;d++)n=this[a[d].name],t=e.colSpan["dim"+d],t&&t.colSpan<n&&(t.attr.colSpan=n-t.colSpan+1);e=u[l],i=u[l+"all"],e&&(e.children[0].attr.className="k-first"),i&&(i.children[0].attr.className+=" k-first")},_row:function(e){var t=oe("tr",null,e);return t.rowSpan=1,t.colSpan={},this.rows.push(t),t},_content:function(e,t){return re(this.template({member:e,tuple:t}))},_cell:function(e,t,n){var i=oe("td",{className:e},t);return i.value=n.caption||n.name,i},_buildRows:function(e,t){var n,i,o,r,s,a,l,c,d,u=this.map,h=e.members,f=h[t],p=h[t+1],m=f.children,g=m.length,v=+f.levelNum,_=this.rootTuple.members[t].name,b=ae(e,t-1).join(""),w=+this.rootTuple.members[t].levelNum,y=b+(w===v?"":f.parentName||""),k=u[y+"all"]||u[y],x=v+1,C=[];if(!k||k.hasChild?k=this._row():k.hasChild=!0,f.measure){for(l=k.allCell?"k-grid-footer":"",k.children.push(this._cell(l,[this._content(m[0],e)],m[0])),k.rowSpan=g,d=1;d<g;d++)this._row([this._cell(l,[this._content(m[d],e)],m[d])]);return k}if(u[b+f.name]=k,n=fe.stringify(ae(e,t)),a=this.metadata[n],a||(this.metadata[n]=a=se(v,t),a.rootLevelNum=w),this._indexes.push({path:n,tuple:e}),f.hasChildren&&(a.expanded===!1&&(g=0,a.children=0),c={className:"k-icon "+(g?He:Ne)},c[fe.attr("path")]=n,C.push(oe("span",c))),C.push(this._content(f,e)),l=k.allCell&&!g?"k-grid-footer":"",i=this._cell(l,C,f),i.colSpan=x,k.children.push(i),k.colSpan["dim"+t]=i,(!this[_]||this[_]<x)&&(this[_]=x),g){for(k.allCell=!1,k.hasChild=!1,d=0;d<g;d++)r=this._buildRows(m[d],t),k!==r&&(k.rowSpan+=r.rowSpan);k.rowSpan>1&&(i.attr.rowSpan=k.rowSpan),a.children=k.rowSpan,o=this._cell("k-grid-footer",[this._content(f,e)],f),o.colSpan=x,s=this._row([o]),s.colSpan["dim"+t]=o,s.allCell=!0,u[b+f.name+"all"]=s,p&&(r=this._buildRows(e,t+1),o.attr.rowSpan=r.rowSpan),k.rowSpan+=s.rowSpan,a.members=s.rowSpan}else p&&(k.hasChild=!1,this._buildRows(e,t+1),(o||i).attr.rowSpan=k.rowSpan,a.members=k.rowSpan);return a.maxChildren<a.children&&(a.maxChildren=a.children),a.maxMembers<a.members&&(a.maxMembers=a.members),k}}),ue=me.extend({init:function(){this.columnAxis={},this.rowAxis={}},build:function(e,n,i){var o,r,s=n.indexes[0],a=n.metadata[s?s.path:t];return this.columnAxis=n,this.rowAxis=i,this.data=e,this.rowLength=a?a.maxChildren+a.maxMembers:n.measures.length||1,this.rowLength||(this.rowLength=1),o=this._tbody(),r=this._colGroup(),[oe("table",null,[r,o])]},_colGroup:function(){var e=this.columnAxis.measures.length||1,t=[],n=0;for(this.rows[0]&&(e=this.rows[0].children.length);n<e;n++)t.push(oe("col",null));return oe("colgroup",null,t)},_tbody:function(){return this.rows=[],this.data[0]?(this.columnIndexes=this._indexes(this.columnAxis,this.rowLength),this.rowIndexes=this._indexes(this.rowAxis,Math.ceil(this.data.length/this.rowLength)),this._buildRows()):this.rows.push(oe("tr",null,[oe("td",null,[re("&nbsp;")])])),oe("tbody",null,this.rows)},_indexes:function(e,n){var i,o,r,s,a,l,c=[],d=e.indexes,u=e.metadata,h=e.measures,f=h.length||1,p=0,m=0,g=0,v=d.length;if(!v){for(r=0;r<f;r++)c[r]={index:r,measure:h[r],tuple:null};return c}for(;g<v;g++){if(i=d[g],o=u[i.path],a=o.children+o.members,l=0,a&&(a-=f),o.expanded===!1&&o.children!==o.maxChildren&&(l=o.maxChildren),o.parentMember&&o.levelNum===o.rootLevelNum&&(a=-1),a>-1){for(r=0;r<f;r++)s=a+r,o.children||(s+=m),c[a+m+r]={children:a,index:p,measure:h[r],tuple:i.tuple},p+=1;for(;c[m]!==t;)m+=1}if(m===n)break;p+=l}return c},_buildRows:function(){for(var e,t=this.rowIndexes,n=t.length,i=0;i<n;i++)e=t[i],e&&this.rows.push(this._buildRow(e))},_buildRow:function(e){for(var n,i,o,r,s,a,l,c=e.index*this.rowLength,d=this.columnIndexes,u=d.length,h=[],f=0;f<u;f++)n=d[f],n!==t&&(s={},n.children&&(s.className="k-alt"),r="",a=this.data[c+n.index],l=n.measure||e.measure,i={columnTuple:n.tuple,rowTuple:e.tuple,measure:l,dataItem:a},""!==a.value&&l&&l.type&&("status"===l.type?r=this.kpiStatusTemplate(i):"trend"===l.type&&(r=this.kpiTrendTemplate(i))),r||(r=this.dataTemplate(i)),o=oe("td",s,[re(r)]),o.value=a.value,h.push(o));return s={},e.children&&(s.className="k-grid-footer"),oe("tr",s,h)}}),pe.plugin(ie),fe.PivotExcelExporter=fe.Class.extend({init:function(e){this.options=e,this.widget=e.widget,this.dataSource=this.widget.dataSource},_columns:function(){var e,t=this.widget.columnsHeaderTree.children[0],n=this.widget.rowsHeaderTree.children[0],i=t.children[0].children.length,o=n.children[0].children.length,r=this.widget.options.columnWidth,s=[];if(o&&this.dataSource.data()[0])for(e=0;e<o;e++)s.push({autoWidth:!0});for(e=0;e<i;e++)s.push({autoWidth:!1,width:r});return s},_cells:function(e,t,n){for(var i,o,r,s,a,l=[],c=0,d=e.length;c<d;c++){for(o=[],r=e[c].children,i=r.length,s=0;s<i;s++)a=r[s],o.push({background:"#7a7a7a",color:"#fff",value:a.value,colSpan:a.attr.colSpan||1,rowSpan:a.attr.rowSpan||1});n&&n(o,c),l.push({cells:o,type:t})}return l},_rows:function(){var e,t,n=this.widget.columnsHeaderTree.children[0],i=this.widget.rowsHeaderTree.children[0],o=n.children[0].children.length,r=i.children[0].children.length,s=n.children[1].children,a=i.children[1].children,l=this.widget.contentTree.children[0].children[1].children,c=this._cells(s,"header");return r&&c[0].cells.splice(0,0,{background:"#7a7a7a",color:"#fff",value:"",colSpan:r,rowSpan:s.length}),e=function(e,t){for(var n,i,r=0,s=l[t].children;r<o;r++)n=s[r],i=+n.value,isNaN(i)&&(i=n.value),e.push({background:"#dfdfdf",color:"#333",value:i,colSpan:1,rowSpan:1})},t=this._cells(a,"data",e),c.concat(t)},_freezePane:function(){var e=this.widget.columnsHeaderTree.children[0],t=this.widget.rowsHeaderTree.children[0],n=t.children[0].children.length,i=e.children[1].children;return{colSplit:n,rowSplit:i.length}},workbook:function(){var t;return this.dataSource.view()[0]?(t=e.Deferred(),t.resolve()):t=this.dataSource.fetch(),t.then(e.proxy(function(){return{sheets:[{columns:this._columns(),rows:this._rows(),freezePane:this._freezePane(),filter:null}]}},this))}}),he={extend:function(t){t.events.push("excelExport"),t.options.excel=e.extend(t.options.excel,this.options),t.saveAsExcel=this.saveAsExcel},options:{proxyURL:"",filterable:!1,fileName:"Export.xlsx"},saveAsExcel:function(){var t=this.options.excel||{},n=new fe.PivotExcelExporter({widget:this});n.workbook().then(e.proxy(function(e){if(!this.trigger("excelExport",{workbook:e})){var n=new fe.ooxml.Workbook(e);n.toDataURLAsync().then(function(n){fe.saveAs({dataURI:n,fileName:e.fileName||t.fileName,proxyURL:t.proxyURL,forceProxy:t.forceProxy})})}},this))}},fe.PivotExcelMixin=he,fe.ooxml&&fe.ooxml.Workbook&&he.extend(ie.prototype),fe.PDFMixin&&(fe.PDFMixin.extend(ie.prototype),ie.fn._drawPDF=function(){return this._drawPDFShadow({width:this.wrapper.width()},{avoidLinks:this.options.pdf.avoidLinks})})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.treeview.draganddrop.min",["kendo.data.min","kendo.draganddrop.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.ui,o=e.proxy,r=e.extend,s="visibility",a="k-state-hover",l="input,a,textarea,.k-multiselect-wrap,select,button,a.k-button>.k-icon,button.k-button>.k-icon,span.k-icon.k-i-arrow-60-right,span.k-icon.k-i-arrow-45-down-right";i.HierarchicalDragAndDrop=n.Class.extend({init:function(t,s){this.element=t,this.hovered=t,this.options=r({dragstart:e.noop,drag:e.noop,drop:e.noop,dragend:e.noop},s),this._draggable=new i.Draggable(t,{ignore:l,filter:s.filter,autoScroll:s.autoScroll,cursorOffset:{left:10,top:n.support.mobileOS?-40/n.support.zoomLevel():10},hint:o(this._hint,this),dragstart:o(this.dragstart,this),dragcancel:o(this.dragcancel,this),drag:o(this.drag,this),dragend:o(this.dragend,this),$angular:s.$angular})},_hint:function(e){return"<div class='k-header k-drag-clue'><span class='k-icon k-drag-status' />"+this.options.hintText(e)+"</div>"},_removeTouchHover:function(){n.support.touch&&this.hovered&&(this.hovered.find("."+a).removeClass(a),this.hovered=!1)},_hintStatus:function(n){var i=this._draggable.hint.find(".k-drag-status")[0];return n?(i.className="k-icon k-drag-status "+n,t):e.trim(i.className.replace(/(p|k)-(icon|drag-status)/g,""))},dragstart:function(t){this.source=t.currentTarget.closest(this.options.itemSelector),this.options.dragstart(this.source)&&t.preventDefault(),this.dropHint=this.options.reorderable?e("<div class='k-i-drag-and-drop' />").css(s,"hidden").appendTo(this.element):e()},drag:function(t){var i,o,r,l,c,d,u,h,f,p,m,g=this.options,v=this.source,_=this.dropTarget=e(n.eventTarget(t)),b=_.closest(g.allowedContainers);b.length?v[0]==_[0]||g.contains(v[0],_[0])?m="k-i-cancel":(m="k-i-insert-middle",f=g.itemFromTarget(_),i=f.item,i.length?(this._removeTouchHover(),o=n._outerHeight(i),l=f.content,g.reorderable?(c=o/(l.length>0?4:2),r=n.getOffset(i).top,d=t.y.location<r+c,u=r+o-c<t.y.location,h=l.length&&!d&&!u):(h=!0,d=!1,u=!1),this.hovered=!!h&&b,this.dropHint.css(s,h?"hidden":"visible"),this._lastHover&&this._lastHover[0]!=l[0]&&this._lastHover.removeClass(a),this._lastHover=l.toggleClass(a,h),h?m="k-i-plus":(p=i.position(),p.top+=d?0:o,this.dropHint.css(p)[d?"prependTo":"appendTo"](g.dropHintContainer(i)),d&&f.first&&(m="k-i-insert-up"),u&&f.last&&(m="k-i-insert-down"))):_[0]!=this.dropHint[0]&&(this._lastHover&&this._lastHover.removeClass(a),m=e.contains(this.element[0],b[0])?"k-i-cancel":"k-i-plus")):(m="k-i-cancel",this._removeTouchHover()),this.options.drag({originalEvent:t.originalEvent,source:v,target:_,pageY:t.y.location,pageX:t.x.location,status:m.substring(2),setStatus:function(e){m=e}}),0!==m.indexOf("k-i-insert")&&this.dropHint.css(s,"hidden"),this._hintStatus(m)},dragcancel:function(){this.dropHint.remove()},dragend:function(e){var n,i,o,r="over",l=this.source,c=this.dropHint,d=this.dropTarget;return"visible"==c.css(s)?(r=this.options.dropPositionFrom(c),n=c.closest(this.options.itemSelector)):d&&(n=d.closest(this.options.itemSelector),n.length||(n=d.closest(this.options.allowedContainers))),i={originalEvent:e.originalEvent,source:l[0],destination:n[0],valid:"k-i-cancel"!=this._hintStatus(),setValid:function(e){this.valid=e},dropTarget:d[0],position:r},o=this.options.drop(i),c.remove(),this._removeTouchHover(),this._lastHover&&this._lastHover.removeClass(a),!i.valid||o?(this._draggable.dropped=i.valid,t):(this._draggable.dropped=!0,this.options.dragend({originalEvent:e.originalEvent,source:l,destination:n,position:r}),t)},destroy:function(){this._lastHover=this.hovered=null,this._draggable.destroy()}})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.treeview.min",["kendo.data.min","kendo.treeview.draganddrop.min"],e)}(function(){return function(e,t){function n(e){return function(t){var n=t.children(".k-animation-container");return n.length||(n=t),n.children(e)}}function i(e){return f.template(e,{useWithBlock:!1})}function o(e){return e.find("> div .k-checkbox-wrapper [type=checkbox]")}function r(e){return function(t,n){n=n.closest(W);var i,o=n.parent();return o.parent().is("li")&&(i=o.parent()),this._dataSourceMove(t,o,i,function(t,i){return this._insert(t.data(),i,n.index()+e)})}}function s(t,n){for(var i;t&&"ul"!=t.nodeName.toLowerCase();)i=t,t=t.nextSibling,3==i.nodeType&&(i.nodeValue=e.trim(i.nodeValue)),h.test(i.className)?n.insertBefore(i,n.firstChild):n.appendChild(i)}function a(t){var n=t.children("div"),i=t.children("ul"),o=n.children(".k-icon"),r=t.children(":checkbox"),a=n.children(".k-in");t.hasClass("k-treeview")||(n.length||(n=e("<div />").prependTo(t)),!o.length&&i.length?o=e("<span class='k-icon' />").prependTo(n):i.length&&i.children().length||(o.remove(),i.remove()),r.length&&e("<span class='k-checkbox-wrapper' />").appendTo(n).append(r),a.length||(a=t.children("a").eq(0).addClass("k-in k-link"),a.length||(a=e("<span class='k-in' />")),a.appendTo(n),n.length&&s(n[0].nextSibling,a[0])))}var l,c,d,u,h,f=window.kendo,p=f.ui,m=f.data,g=e.extend,v=f.template,_=e.isArray,b=p.Widget,w=m.HierarchicalDataSource,y=e.proxy,k=f.keys,x=".kendoTreeView",C="select",S="check",T="navigate",D="expand",A="change",E="error",I="checked",M="indeterminate",R="collapse",F="dragstart",z="drag",P="drop",B="dragend",L="dataBound",H="click",N="undefined",O="k-state-hover",V="k-treeview",U=":visible",W=".k-item",j="string",q="aria-selected",G="aria-disabled",$="k-state-disabled",K={text:"dataTextField",url:"dataUrlField",spriteCssClass:"dataSpriteCssClassField",imageUrl:"dataImageUrlField"},Y=function(e){return e instanceof f.jQuery||e instanceof window.jQuery},Q=function(e){return"object"==typeof HTMLElement?e instanceof HTMLElement:e&&"object"==typeof e&&1===e.nodeType&&typeof e.nodeName===j};c=n(".k-group"),d=n(".k-group,.k-content"),u=function(e){return e.children("div").children(".k-icon")},h=/k-sprite/,l=f.ui.DataBoundWidget.extend({init:function(e,t){var n,i=this,o=!1,r=t&&!!t.dataSource;_(t)&&(t={dataSource:t}),t&&typeof t.loadOnDemand==N&&_(t.dataSource)&&(t.loadOnDemand=!1),b.prototype.init.call(i,e,t),e=i.element,t=i.options,n=e.is("ul")&&e||e.hasClass(V)&&e.children("ul"),o=!r&&n.length,o&&(t.dataSource.list=n),i._animation(),i._accessors(),i._templates(),e.hasClass(V)?(i.wrapper=e,i.root=e.children("ul").eq(0)):(i._wrapper(),n&&(i.root=e,i._group(i.wrapper))),i._tabindex(),i.root.attr("role","tree"),i._dataSource(o),i._attachEvents(),i._dragging(),o?i._syncHtmlAndDataSource():t.autoBind&&(i._progress(!0),i.dataSource.fetch()),t.checkboxes&&t.checkboxes.checkChildren&&i.updateIndeterminate(),i.element[0].id&&(i._ariaId=f.format("{0}_tv_active",i.element[0].id)),f.notify(i)},_attachEvents:function(){var t=this,n=".k-in:not(.k-state-selected,.k-state-disabled)",i="mouseenter";t.wrapper.on(i+x,".k-in.k-state-selected",function(e){e.preventDefault()}).on(i+x,n,function(){e(this).addClass(O)}).on("mouseleave"+x,n,function(){e(this).removeClass(O)}).on(H+x,n,y(t._click,t)).on("dblclick"+x,".k-in:not(.k-state-disabled)",y(t._toggleButtonClick,t)).on(H+x,".k-i-expand,.k-i-collapse",y(t._toggleButtonClick,t)).on("keydown"+x,y(t._keydown,t)).on("keypress"+x,y(t._keypress,t)).on("focus"+x,y(t._focus,t)).on("blur"+x,y(t._blur,t)).on("mousedown"+x,".k-in,.k-checkbox-wrapper :checkbox,.k-i-expand,.k-i-collapse",y(t._mousedown,t)).on("change"+x,".k-checkbox-wrapper :checkbox",y(t._checkboxChange,t)).on("click"+x,".checkbox-span",y(t._checkboxLabelClick,t)).on("click"+x,".k-request-retry",y(t._retryRequest,t)).on("click"+x,".k-link.k-state-disabled",function(e){e.preventDefault()}).on("click"+x,function(n){e(n.target).is(":kendoFocusable")||t.focus()})},_checkboxLabelClick:function(t){var n=e(t.target.previousSibling);n.is("[disabled]")||(n.prop("checked",!n.prop("checked")),n.trigger("change"))},_syncHtmlAndDataSource:function(e,t){e=e||this.root,t=t||this.dataSource;var n,i,r,s,a,l=t.view(),c=f.attr("uid"),d=f.attr("expanded"),u=this.options.checkboxes,h=e.children("li");for(n=0;n<h.length;n++)r=l[n],s=r.uid,i=h.eq(n),i.attr("role","treeitem").attr(c,s).attr(q,i.hasClass("k-state-selected")),r.expanded="true"===i.attr(d),u&&(a=o(i),r.checked=a.prop(I),a.attr("id","_"+s),a.next(".k-checkbox-label").attr("for","_"+s)),this._syncHtmlAndDataSource(i.children("ul"),r.children)},_animation:function(){var e=this.options,t=e.animation,n=t.collapse&&"effects"in t.collapse,i=g({},t.expand,t.collapse);n||(i=g(i,{reverse:!0})),t===!1&&(t={expand:{effects:{}},collapse:{hide:!0,effects:{}}}),t.collapse=g(i,{hide:!0}),e.animation=t},_dragging:function(){var t,n=this.options.dragAndDrop,i=this.dragging;n&&!i?(t=this,this.dragging=new p.HierarchicalDragAndDrop(this.element,{reorderable:!0,$angular:this.options.$angular,autoScroll:this.options.autoScroll,filter:"div:not(.k-state-disabled) .k-in",allowedContainers:".k-treeview",itemSelector:".k-treeview .k-item",hintText:y(this._hintText,this),contains:function(t,n){return e.contains(t,n)},dropHintContainer:function(e){return e},itemFromTarget:function(e){var t=e.closest(".k-top,.k-mid,.k-bot");return{item:t,content:e.closest(".k-in"),first:t.hasClass("k-top"),last:t.hasClass("k-bot")}},dropPositionFrom:function(e){return e.prevAll(".k-in").length>0?"after":"before"},dragstart:function(e){return t.trigger(F,{sourceNode:e[0]})},drag:function(e){t.trigger(z,{originalEvent:e.originalEvent,sourceNode:e.source[0],dropTarget:e.target[0],pageY:e.pageY,pageX:e.pageX,statusClass:e.status,setStatusClass:e.setStatus})},drop:function(e){return t.trigger(P,{originalEvent:e.originalEvent,sourceNode:e.source,destinationNode:e.destination,valid:e.valid,setValid:function(t){this.valid=t,e.setValid(t)},dropTarget:e.dropTarget,dropPosition:e.position})},dragend:function(e){function n(n){t.options.checkboxes&&t.options.checkboxes.checkChildren&&t.updateIndeterminate(),t.trigger(B,{originalEvent:e.originalEvent,sourceNode:n&&n[0],destinationNode:o[0],dropPosition:r})}var i=e.source,o=e.destination,r=e.position;"over"==r?t.append(i,o,n):("before"==r?i=t.insertBefore(i,o):"after"==r&&(i=t.insertAfter(i,o)),n(i))}})):!n&&i&&(i.destroy(),this.dragging=null)},_hintText:function(e){return this.templates.dragClue({item:this.dataItem(e),treeview:this.options})},_templates:function(){var e=this,t=e.options,n=y(e._fieldAccessor,e);t.template&&typeof t.template==j?t.template=v(t.template):t.template||(t.template=i("# var text = "+n("text")+"(data.item); ## if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {##= text ## } else { ##: text ## } #")),e._checkboxes(),e.templates={wrapperCssClass:function(e,t){var n="k-item",i=t.index;return e.firstLevel&&0===i&&(n+=" k-first"),i==e.length-1&&(n+=" k-last"),n},cssClass:function(e,t){var n="",i=t.index,o=e.length-1;return e.firstLevel&&0===i&&(n+="k-top "),n+=0===i&&i!=o?"k-top":i==o?"k-bot":"k-mid"},textClass:function(e,t){var n="k-in";return t&&(n+=" k-link"),e.enabled===!1&&(n+=" k-state-disabled"),e.selected===!0&&(n+=" k-state-selected"),n},toggleButtonClass:function(e){var t="k-icon";return t+=e.expanded!==!0?" k-i-expand":" k-i-collapse"},groupAttributes:function(e){var t="";return e.firstLevel||(t="role='group'"),t+(e.expanded!==!0?" style='display:none'":"")},groupCssClass:function(e){var t="k-group";return e.firstLevel&&(t+=" k-treeview-lines"),t},dragClue:i("#= data.treeview.template(data) #"),group:i("<ul class='#= data.r.groupCssClass(data.group) #'#= data.r.groupAttributes(data.group) #>#= data.renderItems(data) #</ul>"),itemContent:i("# var imageUrl = "+n("imageUrl")+"(data.item); ## var spriteCssClass = "+n("spriteCssClass")+"(data.item); ## if (imageUrl) { #<img class='k-image' alt='' src='#= imageUrl #'># } ## if (spriteCssClass) { #<span class='k-sprite #= spriteCssClass #' /># } ##= data.treeview.template(data) #"),itemElement:i("# var item = data.item, r = data.r; ## var url = "+n("url")+"(item); #<div class='#= r.cssClass(data.group, item) #'># if (item.hasChildren) { #<span class='#= r.toggleButtonClass(item) #'/># } ## if (data.treeview.checkboxes) { #<span class='k-checkbox-wrapper' role='presentation'>#= data.treeview.checkboxes.template(data) #</span># } ## var tag = url ? 'a' : 'span'; ## var textAttr = url ? ' href=\\'' + url + '\\'' : ''; #<#=tag# class='#= r.textClass(item, !!url) #'#= textAttr #>#= r.itemContent(data) #</#=tag#></div>"),item:i("# var item = data.item, r = data.r; #<li role='treeitem' class='#= r.wrapperCssClass(data.group, item) #' "+f.attr("uid")+"='#= item.uid #' aria-selected='#= item.selected ? \"true\" : \"false\" #' #=item.enabled === false ? \"aria-disabled='true'\" : ''## if (item.expanded) { #data-expanded='true' aria-expanded='true'# } #>#= r.itemElement(data) #</li>"),loading:i("<div class='k-icon k-i-loading' /> #: data.messages.loading #"),retry:i("#: data.messages.requestFailed # <button class='k-button k-request-retry'>#: data.messages.retry #</button>")}},items:function(){return this.element.find(".k-item > div:first-child")},setDataSource:function(t){var n=this.options;n.dataSource=t,this._dataSource(),n.checkboxes&&n.checkboxes.checkChildren&&this.dataSource.one("change",e.proxy(this.updateIndeterminate,this,null)),this.options.autoBind&&this.dataSource.fetch()},_bindDataSource:function(){this._refreshHandler=y(this.refresh,this),this._errorHandler=y(this._error,this),this.dataSource.bind(A,this._refreshHandler),this.dataSource.bind(E,this._errorHandler)},_unbindDataSource:function(){var e=this.dataSource;e&&(e.unbind(A,this._refreshHandler),e.unbind(E,this._errorHandler))},_dataSource:function(e){function t(e){for(var n=0;n<e.length;n++)e[n]._initChildren(),e[n].children.fetch(),t(e[n].children.view())}var n=this,i=n.options,o=i.dataSource;o=_(o)?{data:o}:o,n._unbindDataSource(),o.fields||(o.fields=[{field:"text"},{field:"url"},{field:"spriteCssClass"},{field:"imageUrl"}]),n.dataSource=o=w.create(o),e&&(o.fetch(),t(o.view())),n._bindDataSource()},events:[F,z,P,B,L,D,R,C,A,T,S],options:{name:"TreeView",dataSource:{},animation:{expand:{effects:"expand:vertical",duration:200},collapse:{duration:100}},messages:{loading:"Loading...",requestFailed:"Request failed.",retry:"Retry"},dragAndDrop:!1,checkboxes:!1,autoBind:!0,autoScroll:!1,loadOnDemand:!0,template:"",dataTextField:null},_accessors:function(){var e,t,n,i=this,o=i.options,r=i.element;for(e in K)t=o[K[e]],n=r.attr(f.attr(e+"-field")),!t&&n&&(t=n),t||(t=e),_(t)||(t=[t]),o[K[e]]=t},_fieldAccessor:function(t){var n=this.options[K[t]],i=n.length,o="(function(item) {";return 0===i?o+="return item['"+t+"'];":(o+="var levels = ["+e.map(n,function(e){return"function(d){ return "+f.expr(e)+"}"}).join(",")+"];",o+="return levels[Math.min(item.level(), "+i+"-1)](item)"),o+="})"},setOptions:function(e){b.fn.setOptions.call(this,e),this._animation(),this._dragging(),this._templates()},_trigger:function(e,t){return this.trigger(e,{node:t.closest(W)[0]})},_setChecked:function(t,n){if(t&&e.isFunction(t.view))for(var i=0,o=t.view();i<o.length;i++)o[i][I]=n,
o[i].children&&this._setChecked(o[i].children,n)},_setIndeterminate:function(e){var t,n,i,r=c(e),s=!0;if(r.length&&(t=o(r.children()),n=t.length)){if(n>1){for(i=1;i<n;i++)if(t[i].checked!=t[i-1].checked||t[i].indeterminate||t[i-1].indeterminate){s=!1;break}}else s=!t[0].indeterminate;return o(e).data(M,!s).prop(M,!s).prop(I,s&&t[0].checked)}},updateIndeterminate:function(e){var t,n,i,o;if(e=e||this.wrapper,t=c(e).children(),t.length){for(n=0;n<t.length;n++)this.updateIndeterminate(t.eq(n));i=this._setIndeterminate(e),o=this.dataItem(e),i&&i.prop(I)?o.checked=!0:o&&delete o.checked}},_bubbleIndeterminate:function(e,t){if(e.length){t||this.updateIndeterminate(e);var n,i=this.parent(e);i.length&&(this._setIndeterminate(i),n=i.children("div").find(".k-checkbox-wrapper :checkbox"),this._skip=!0,n.prop(M)===!1?this.dataItem(i).set(I,n.prop(I)):delete this.dataItem(i).checked,this._skip=!1,this._bubbleIndeterminate(i,!0))}},_checkboxChange:function(t){var n=e(t.target),i=n.prop(I),o=n.closest(W),r=this.dataItem(o);r.checked!=i&&(r.set(I,i),this._trigger(S,o))},_toggleButtonClick:function(t){var n=e(t.currentTarget).closest(W);n.is("[aria-disabled='true']")||this.toggle(e(t.target).closest(W))},_mousedown:function(t){var n=e(t.currentTarget).closest(W);n.is("[aria-disabled='true']")||(this._clickTarget=n,this.current(n))},_focusable:function(e){return e&&e.length&&e.is(":visible")&&!e.find(".k-in:first").hasClass($)},_focus:function(){var t=this.select(),n=this._clickTarget;f.support.touch||(n&&n.length&&(t=n),this._focusable(t)||(t=this.current()),this._focusable(t)||(t=this._nextVisible(e())),this.current(t))},focus:function(){var e,t=this.wrapper,n=t[0],i=[],o=[],r=document.documentElement;do n=n.parentNode,n.scrollHeight>n.clientHeight&&(i.push(n),o.push(n.scrollTop));while(n!=r);for(t.focus(),e=0;e<i.length;e++)i[e].scrollTop=o[e]},_blur:function(){this.current().find(".k-in:first").removeClass("k-state-focused")},_enabled:function(e){return!e.children("div").children(".k-in").hasClass($)},parent:function(t){var n,i,o=/\bk-treeview\b/,r=/\bk-item\b/;typeof t==j&&(t=this.element.find(t)),Q(t)||(t=t[0]),i=r.test(t.className);do t=t.parentNode,r.test(t.className)&&(i?n=t:i=!0);while(!o.test(t.className)&&!n);return e(n)},_nextVisible:function(e){function t(e){for(;e.length&&!e.next().length;)e=i.parent(e);return e.next().length?e.next():e}var n,i=this,o=i._expanded(e);return e.length&&e.is(":visible")?o?(n=c(e).children().first(),n.length||(n=t(e))):n=t(e):n=i.root.children().eq(0),n},_previousVisible:function(e){var t,n,i=this;if(!e.length||e.prev().length)for(n=e.length?e.prev():i.root.children().last();i._expanded(n)&&(t=c(n).children().last(),t.length);)n=t;else n=i.parent(e)||e;return n},_keydown:function(n){var i,o=this,r=n.keyCode,s=o.current(),a=o._expanded(s),l=s.find(".k-checkbox-wrapper:first :checkbox"),c=f.support.isRtl(o.element);n.target==n.currentTarget&&(!c&&r==k.RIGHT||c&&r==k.LEFT?a?i=o._nextVisible(s):s.find(".k-in:first").hasClass($)||o.expand(s):!c&&r==k.LEFT||c&&r==k.RIGHT?a&&!s.find(".k-in:first").hasClass($)?o.collapse(s):(i=o.parent(s),o._enabled(i)||(i=t)):r==k.DOWN?i=o._nextVisible(s):r==k.UP?i=o._previousVisible(s):r==k.HOME?i=o._nextVisible(e()):r==k.END?i=o._previousVisible(e()):r!=k.ENTER||s.find(".k-in:first").hasClass($)?r==k.SPACEBAR&&l.length&&!s.find(".k-in:first").hasClass($)&&(l.prop(I,!l.prop(I)).data(M,!1).prop(M,!1),o._checkboxChange({target:l}),i=s):s.find(".k-in:first").hasClass("k-state-selected")||o._trigger(C,s)||o.select(s),i&&(n.preventDefault(),s[0]!=i[0]&&(o._trigger(T,i),o.current(i))))},_keypress:function(e){var t,n=this,i=300,o=n._getSelectedNode();e.keyCode!==k.ENTER&&e.keyCode!==k.SPACEBAR&&(n._match||(n._match=""),n._match+=String.fromCharCode(e.keyCode),clearTimeout(n._matchTimer),n._matchTimer=setTimeout(function(){n._match=""},i),t=o&&n._matchNextByText(Array.prototype.indexOf.call(this.element.find(".k-item"),o[0]),n._match),t||(t=n._matchNextByText(-1,n._match)),n.select(t))},_matchNextByText:function(t,n){return e(this.element).find(".k-in").filter(function(i,o){return i>t&&e(o).is(":visible")&&!e(o).hasClass($)&&0===e(o).text().toLowerCase().indexOf(n)}).closest(W)[0]},_click:function(t){var n,i=this,o=e(t.currentTarget),r=d(o.closest(W)),s=o.attr("href");n=s?"#"==s||s.indexOf("#"+this.element.id+"-")>=0:r.length&&!r.children().length,n&&t.preventDefault(),o.hasClass(".k-state-selected")||i._trigger(C,o)||i.select(o)},_wrapper:function(){var e,t,n=this,i=n.element,o="k-widget k-treeview";i.is("ul")?(e=i.wrap("<div />").parent(),t=i):(e=i,t=e.children("ul").eq(0)),n.wrapper=e.addClass(o),n.root=t},_getSelectedNode:function(){return this.element.find(".k-state-selected").closest(W)},_group:function(e){var t=this,n=e.hasClass(V),i={firstLevel:n,expanded:n||t._expanded(e)},o=e.children("ul");o.addClass(t.templates.groupCssClass(i)).css("display",i.expanded?"":"none"),t._nodes(o,i)},_nodes:function(t,n){var i,o=this,r=t.children("li");n=g({length:r.length},n),r.each(function(t,r){r=e(r),i={index:t,expanded:o._expanded(r)},a(r),o._updateNodeClasses(r,n,i),o._group(r)})},_checkboxes:function(){var e,t=this.options,n=t.checkboxes;n&&(e="<input aria-label='#=item.text#' type='checkbox' tabindex='-1' #= (item.enabled === false) ? 'disabled' : '' # #= item.checked ? 'checked' : '' #",n.name&&(e+=" name='"+n.name+"'"),e+=" id='_#= item.uid #' class='k-checkbox' /><span class='k-checkbox-label checkbox-span'></span>",n=g({template:e},t.checkboxes),typeof n.template==j&&(n.template=v(n.template)),t.checkboxes=n)},_updateNodeClasses:function(e,t,n){var i,o,r=e.children("div"),s=e.children("ul"),a=this.templates;e.hasClass("k-treeview")||(n=n||{},n.expanded=typeof n.expanded!=N?n.expanded:this._expanded(e),n.index=typeof n.index!=N?n.index:e.index(),n.enabled=typeof n.enabled!=N?n.enabled:!r.children(".k-in").hasClass("k-state-disabled"),t=t||{},t.firstLevel=typeof t.firstLevel!=N?t.firstLevel:e.parent().parent().hasClass(V),t.length=typeof t.length!=N?t.length:e.parent().children().length,e.removeClass("k-first k-last").addClass(a.wrapperCssClass(t,n)),r.removeClass("k-top k-mid k-bot").addClass(a.cssClass(t,n)),i=r.children(".k-in"),o=i[0]&&"a"==i[0].nodeName.toLowerCase(),i.removeClass("k-in k-link k-state-default k-state-disabled").addClass(a.textClass(n,o)),(s.length||"true"==e.attr("data-hasChildren"))&&(r.children(".k-icon").removeClass("k-i-expand k-i-collapse").addClass(a.toggleButtonClass(n)),s.addClass("k-group")))},_processNodes:function(t,n){var i=this;i.element.find(t).each(function(t,o){n.call(i,t,e(o).closest(W))})},dataItem:function(t){var n=e(t).closest(W).attr(f.attr("uid")),i=this.dataSource;return i&&i.getByUid(n)},_insertNode:function(t,n,i,o,r){var s,l,d,u,h=this,f=c(i),p=f.children().length+1,m={firstLevel:i.hasClass(V),expanded:!r,length:p},g="",v=function(e,t){e.appendTo(t)};for(d=0;d<t.length;d++)u=t[d],u.index=n+d,g+=h._renderItem({group:m,item:u});if(l=e(g),l.length){for(h.angular("compile",function(){return{elements:l.get(),data:t.map(function(e){return{dataItem:e}})}}),f.length||(f=e(h._renderGroup({group:m})).appendTo(i)),o(l,f),i.hasClass("k-item")&&(a(i),h._updateNodeClasses(i)),h._updateNodeClasses(l.prev().first()),h._updateNodeClasses(l.next().last()),d=0;d<t.length;d++)u=t[d],u.hasChildren&&(s=u.children.data(),s.length&&h._insertNode(s,u.index,l.eq(d),v,!h._expanded(l.eq(d))));return l}},_updateNodes:function(t,n){function i(e,t){e.find(".k-checkbox-wrapper :checkbox").not("[disabled]").prop(I,t).data(M,!1).prop(M,!1)}var o,r,s,a,l,c,u,h=this,f={treeview:h.options,item:a},m="expanded"!=n&&"checked"!=n;if("selected"==n)a=t[0],r=h.findByUid(a.uid).find(".k-in:first").removeClass("k-state-hover").toggleClass("k-state-selected",a[n]).end(),a[n]&&h.current(r),r.attr(q,!!a[n]);else{for(u=e.map(t,function(e){return h.findByUid(e.uid).children("div")}),m&&h.angular("cleanup",function(){return{elements:u}}),o=0;o<t.length;o++)f.item=a=t[o],s=u[o],r=s.parent(),m&&s.children(".k-in").html(h.templates.itemContent(f)),n==I?(l=a[n],i(s,l),h.options.checkboxes.checkChildren&&(i(r.children(".k-group"),l),h._setChecked(a.children,l),h._bubbleIndeterminate(r))):"expanded"==n?h._toggle(r,a,a[n]):"enabled"==n&&(r.find(".k-checkbox-wrapper :checkbox").prop("disabled",!a[n]),c=!d(r).is(U),r.removeAttr(G),a[n]||(a.selected&&a.set("selected",!1),a.expanded&&a.set("expanded",!1),c=!0,r.attr(q,!1).attr(G,!0)),h._updateNodeClasses(r,{},{enabled:a[n],expanded:!c})),s.length&&this.trigger("itemChange",{item:s,data:a,ns:p});m&&h.angular("compile",function(){return{elements:u,data:e.map(t,function(e){return[{dataItem:e}]})}})}},_appendItems:function(e,t,n){var i=c(n),o=i.children(),r=!this._expanded(n);typeof e==N&&(e=o.length),this._insertNode(t,e,n,function(t,n){e>=o.length?t.appendTo(n):t.insertBefore(o.eq(e))},r),this._expanded(n)&&(this._updateNodeClasses(n),c(n).css("display","block"))},_refreshChildren:function(e,t,n){var i,o,r,s=this.options,l=s.loadOnDemand,d=s.checkboxes&&s.checkboxes.checkChildren;if(c(e).empty(),t.length)for(this._appendItems(n,t,e),o=c(e).children(),l&&d&&this._bubbleIndeterminate(o.last()),i=0;i<o.length;i++)r=o.eq(i),this.trigger("itemChange",{item:r.children("div"),data:this.dataItem(r),ns:p});else a(e)},_refreshRoot:function(t){var n,i,o,r=this._renderGroup({items:t,group:{firstLevel:!0,expanded:!0}});for(this.root.length?(this._angularItems("cleanup"),n=e(r),this.root.attr("class",n.attr("class")).html(n.html())):this.root=this.wrapper.html(r).children("ul"),this.root.attr("role","tree"),i=this.root.children(".k-item"),o=0;o<t.length;o++)this.trigger("itemChange",{item:i.eq(o),data:t[o],ns:p});this._angularItems("compile")},refresh:function(e){var n,i,o=e.node,r=e.action,s=e.items,a=this.wrapper,l=this.options,c=l.loadOnDemand,d=l.checkboxes&&l.checkboxes.checkChildren;if(!this._skip){if(e.field){if(!s[0]||!s[0].level)return;return this._updateNodes(s,e.field)}if(o&&(a=this.findByUid(o.uid),this._progress(a,!1)),d&&"remove"!=r){for(i=!1,n=0;n<s.length;n++)if("checked"in s[n]){i=!0;break}if(!i&&o&&o.checked)for(n=0;n<s.length;n++)s[n].checked=!0}if("add"==r?this._appendItems(e.index,s,a):"remove"==r?this._remove(this.findByUid(s[0].uid),!1):"itemchange"==r?this._updateNodes(s):"itemloaded"==r?this._refreshChildren(a,s,e.index):this._refreshRoot(s),"remove"!=r)for(n=0;n<s.length;n++)c&&!s[n].expanded||s[n].load();this.trigger(L,{node:o?a:t}),this.options.checkboxes.checkChildren&&this.updateIndeterminate()}},_error:function(e){var t=e.node&&this.findByUid(e.node.uid),n=this.templates.retry({messages:this.options.messages});t?(this._progress(t,!1),this._expanded(t,!1),u(t).addClass("k-i-reload"),e.node.loaded(!1)):(this._progress(!1),this.element.html(n))},_retryRequest:function(e){e.preventDefault(),this.dataSource.fetch()},expand:function(e){this._processNodes(e,function(e,t){this.toggle(t,!0)})},collapse:function(e){this._processNodes(e,function(e,t){this.toggle(t,!1)})},enable:function(e,t){"boolean"==typeof e?(t=e,e=this.items()):t=2!=arguments.length||!!t,this._processNodes(e,function(e,n){this.dataItem(n).set("enabled",t)})},current:function(n){var i=this,o=i._current,r=i.element,s=i._ariaId;return arguments.length>0&&n&&n.length?(o&&(o[0].id===s&&o.removeAttr("id"),o.find(".k-in:first").removeClass("k-state-focused")),o=i._current=e(n,r).closest(W),o.find(".k-in:first").addClass("k-state-focused"),s=o[0].id||s,s&&(i.wrapper.removeAttr("aria-activedescendant"),o.attr("id",s),i.wrapper.attr("aria-activedescendant",s)),t):(o||(o=i._nextVisible(e())),o)},select:function(n){var i=this,o=i.element;return arguments.length?(n=e(n,o).closest(W),o.find(".k-state-selected").each(function(){var t=i.dataItem(this);t?(t.set("selected",!1),delete t.selected):e(this).removeClass("k-state-selected")}),n.length&&(i.dataItem(n).set("selected",!0),i._clickTarget=n),i.trigger(A),t):o.find(".k-state-selected").closest(W)},_toggle:function(e,t,n){var i,o=this.options,r=d(e),s=n?"expand":"collapse";r.data("animating")||this._trigger(s,e)||(this._expanded(e,n),i=t&&t.loaded(),n&&!i?(o.loadOnDemand&&this._progress(e,!0),r.remove(),t.load()):(this._updateNodeClasses(e,{},{expanded:n}),n||r.css("height",r.height()).css("height"),r.kendoStop(!0,!0).kendoAnimate(g({reset:!0},o.animation[s],{complete:function(){n&&r.css("height","")}}))))},toggle:function(t,n){t=e(t),u(t).is(".k-i-expand, .k-i-collapse")&&(1==arguments.length&&(n=!this._expanded(t)),this._expanded(t,n))},destroy:function(){var e=this;b.fn.destroy.call(e),e.wrapper.off(x),e._unbindDataSource(),e.dragging&&e.dragging.destroy(),f.destroy(e.element),e.root=e.wrapper=e.element=null},_expanded:function(e,n){var i=f.attr("expanded"),o=this.dataItem(e),r=n;return 1==arguments.length?"true"===e.attr(i)||o&&o.expanded:(d(e).data("animating")||(o&&(o.set("expanded",r),r=o.expanded),r?(e.attr(i,"true"),e.attr("aria-expanded","true")):(e.removeAttr(i),e.attr("aria-expanded","false"))),t)},_progress:function(e,t){var n=this.element,i=this.templates.loading({messages:this.options.messages});1==arguments.length?(t=e,t?n.html(i):n.empty()):u(e).toggleClass("k-i-loading",t).removeClass("k-i-reload")},text:function(e,n){var i=this.dataItem(e),o=this.options[K.text],r=i.level(),s=o.length,a=o[Math.min(r,s-1)];return n?(i.set(a,n),t):i[a]},_objectOrSelf:function(t){return e(t).closest("[data-role=treeview]").data("kendoTreeView")||this},_dataSourceMove:function(t,n,i,o){var r,s=this._objectOrSelf(i||n),a=s.dataSource,l=e.Deferred().resolve().promise();return i&&i[0]!=s.element[0]&&(r=s.dataItem(i),r.loaded()||(s._progress(i,!0),l=r.load()),i!=this.root&&(a=r.children,a&&a instanceof w||(r._initChildren(),r.loaded(!0),a=r.children))),t=this._toObservableData(t),o.call(s,a,t,l)},_toObservableData:function(t){var n,i,o=t;return(Y(t)||Q(t))&&(n=this._objectOrSelf(t).dataSource,i=e(t).attr(f.attr("uid")),o=n.getByUid(i),o&&(o=n.remove(o))),o},_insert:function(e,t,n){t instanceof f.data.ObservableArray?t=t.toJSON():_(t)||(t=[t]);var i=e.parent();return i&&i._initChildren&&(i.hasChildren=!0,i._initChildren()),e.splice.apply(e,[n,0].concat(t)),this.findByUid(e[n].uid)},insertAfter:r(1),insertBefore:r(0),append:function(t,n,i){var o=this.root;return n&&(o=c(n)),this._dataSourceMove(t,o,n,function(t,o,r){function s(){n&&l._expanded(n,!0);var e=t.data(),i=Math.max(e.length,0);return l._insert(e,o,i)}var a,l=this;return r.done(function(){a=s(),(i=i||e.noop)(a)}),a||null})},_remove:function(t,n){var i,o,r,s=this;return t=e(t,s.element),this.angular("cleanup",function(){return{elements:t.get()}}),i=t.parent().parent(),o=t.prev(),r=t.next(),t[n?"detach":"remove"](),i.hasClass("k-item")&&(a(i),s._updateNodeClasses(i)),s._updateNodeClasses(o),s._updateNodeClasses(r),t},remove:function(e){var t=this.dataItem(e);t&&this.dataSource.remove(t)},detach:function(e){return this._remove(e,!0)},findByText:function(t){return e(this.element).find(".k-in").filter(function(n,i){return e(i).text()==t}).closest(W)},findByUid:function(t){var n,i,o=this.element.find(".k-item"),r=f.attr("uid");for(i=0;i<o.length;i++)if(o[i].getAttribute(r)==t){n=o[i];break}return e(n)},expandPath:function(t,n){function i(){s.shift(),s.length?o(s[0]).then(i):a.call(r)}function o(t){var n=e.Deferred(),i=r.dataSource.get(t);return i?i.loaded()?(i.set("expanded",!0),n.resolve()):(r._progress(r.findByUid(i.uid),!0),i.load().then(function(){i.set("expanded",!0),n.resolve()})):n.resolve(),n.promise()}var r=this,s=t.slice(0),a=n||e.noop;o(s[0]).then(i)},_parentIds:function(e){for(var t=e&&e.parentNode(),n=[];t&&t.parentNode;)n.unshift(t.id),t=t.parentNode();return n},expandTo:function(e){e instanceof f.data.Node||(e=this.dataSource.get(e));var t=this._parentIds(e);this.expandPath(t)},_renderItem:function(e){return e.group||(e.group={}),e.treeview=this.options,e.r=this.templates,this.templates.item(e)},_renderGroup:function(e){var t=this;return e.renderItems=function(e){var n="",i=0,o=e.items,r=o?o.length:0,s=e.group;for(s.length=r;i<r;i++)e.group=s,e.item=o[i],e.item.index=i,n+=t._renderItem(e);return n},e.r=t.templates,t.templates.group(e)}}),p.plugin(l)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.pivot.fieldmenu.min",["kendo.pivotgrid.min","kendo.menu.min","kendo.window.min","kendo.treeview.min","kendo.dropdownlist.min"],e)}(function(){return function(e,t){function n(e,t){var n,i,o=[];for(n=0,i=e.length;n<i;n++)e[n].field!==t&&o.push(e[n]);return o}function i(e,t,n){var i,o,r,s;if(!e)return[];for(e=e.filters,i=0,o=[],r=e.length;i<r;i++)s=e[i].operator,(n||"in"===s)&&s!==n||e[i].field!==t||o.push(e[i]);return o}function o(t,n,o){var r,s=0,a=o.length;if(t=i(t,n,"in")[0])for(r=t.value.split(",");s<a;s++)o[s].checked=e.inArray(o[s].uniqueName,r)>=0;else for(;s<a;s++)o[s].checked=!0}function r(e,t){var n,i=e.length;for(n=0;n<i;n++)e[n].checked&&0!==e[n].level()&&t.push(e[n].uniqueName),e[n].hasChildren&&r(e[n].children.view(),t)}var s=window.kendo,a=s.ui,l="kendoContextMenu",c=e.proxy,d=".kendoPivotFieldMenu",u=a.Widget,h="k-filter-item",f="aria-label",p=u.extend({init:function(e,t){u.fn.init.call(this,e,t),this._dataSource(),this._layout(),s.notify(this)},events:[],options:{name:"PivotFieldMenu",filter:null,filterable:!0,sortable:!0,messages:{info:"Show items with value that:",sortAscending:"Sort Ascending",sortDescending:"Sort Descending",filterFields:"Fields Filter",filter:"Filter",include:"Include Fields...",title:"Fields to include",clear:"Clear",ok:"OK",cancel:"Cancel",operators:{contains:"Contains",doesnotcontain:"Does not contain",startswith:"Starts with",endswith:"Ends with",eq:"Is equal to",neq:"Is not equal to"}}},_layout:function(){var t=this.options;this.wrapper=e(s.template(g)({ns:s.ns,filterable:t.filterable,sortable:t.sortable,messages:t.messages})),this.menu=this.wrapper[l]({filter:t.filter,target:this.element,orientation:"vertical",showOn:"click",closeOnClick:!1,open:c(this._menuOpen,this),select:c(this._select,this),copyAnchorStyles:!1}).data(l),this._createWindow(),t.filterable&&this._initFilterForm()},_initFilterForm:function(){var e=this.menu.element.find("."+h),t=c(this._filter,this);this._filterOperator=new s.ui.DropDownList(e.find("select")),this._filterValue=e.find(".k-textbox"),this._updateFilterAriaLabel(),e.on("submit"+d,t).on("click"+d,".k-button-filter",t).on("click"+d,".k-button-clear",c(this._reset,this))},_setFilterForm:function(e){var t=this._filterOperator,n="",i="";e&&(n=e.operator,i=e.value),t.value(n),t.value()||t.select(0),this._filterValue.val(i)},_clearFilters:function(e){var t,n,o=this.dataSource.filter()||{},r=0;for(o.filters=o.filters||[],t=i(o,e),n=t.length;r<n;r++)o.filters.splice(o.filters.indexOf(t[r]),1);return o},_convert:function(t){var n=this.dataSource.options.schema,i=((n.model||{}).fields||{})[this.currentMember];return i&&("number"===i.type?t=parseFloat(t):"boolean"===i.type&&(t=!!e.parseJSON(t))),t},_filter:function(e){var n,i,o=this,r=o._convert(o._filterValue.val());return e.preventDefault(),""===r?(o.menu.close(),t):(n={field:o.currentMember,operator:o._filterOperator.value(),value:r},i=o._clearFilters(o.currentMember),i.filters.push(n),o.dataSource.filter(i),o.menu.close(),t)},_updateFilterAriaLabel:function(){var e=this.menu.element.find("."+h),t=this._filterOperator.value(),n=this.options.messages.operators[t];e.find("select").attr(f,n)},_reset:function(e){var t=this,n=t._clearFilters(t.currentMember);e.preventDefault(),n.filters[0]||(n={}),t.dataSource.filter(n),t._setFilterForm(null),t.menu.close()},_sort:function(e){var t=this.currentMember,i=this.dataSource.sort()||[];i=n(i,t),i.push({field:t,dir:e}),this.dataSource.sort(i),this.menu.close()},setDataSource:function(e){this.options.dataSource=e,this._dataSource()},_dataSource:function(){this.dataSource=s.data.PivotDataSource.create(this.options.dataSource)},_createWindow:function(){var t=this.options.messages;this.includeWindow=e(s.template(v)({messages:t})).on("click"+d,".k-button-ok",c(this._applyIncludes,this)).on("click"+d,".k-button-cancel",c(this._closeWindow,this)),this.includeWindow=new a.Window(this.includeWindow,{title:t.title,visible:!1,resizable:!1,open:c(this._windowOpen,this)})},_applyIncludes:function(e){var t,n=[],o=this.treeView.dataSource.view(),s=o[0].checked,a=this.dataSource.filter(),l=i(a,this.currentMember,"in")[0];r(o,n),l&&(s?(a.filters.splice(a.filters.indexOf(l),1),a.filters.length||(a={})):l.value=n.join(","),t=a),n.length&&(t||s||(t={field:this.currentMember,operator:"in",value:n.join(",")},a&&(a.filters.push(t),t=a))),t&&this.dataSource.filter(t),this._closeWindow(e)},_closeWindow:function(e){e.preventDefault(),this.includeWindow.close()},_treeViewDataSource:function(){var e=this;return s.data.HierarchicalDataSource.create({schema:{model:{id:"uniqueName",hasChildren:function(e){return parseInt(e.childrenCardinality,10)>0}}},transport:{read:function(t){var n={},i=e.treeView.dataSource.get(t.data.uniqueName),r=t.data.uniqueName;r?(n.memberUniqueName=i.uniqueName.replace(/\&/g,"&amp;"),n.treeOp=1):n.levelUniqueName=e.currentMember+".[(ALL)]",e.dataSource.schemaMembers(n).done(function(n){o(e.dataSource.filter(),e.currentMember,n),t.success(n)}).fail(t.error)}}})},_createTreeView:function(e){var t=this;t.treeView=new a.TreeView(e,{autoBind:!1,dataSource:t._treeViewDataSource(),dataTextField:"caption",template:"#: data.item.caption || data.item.name #",checkboxes:{checkChildren:!0},dataBound:function(){a.progress(t.includeWindow.element,!1)}})},_menuOpen:function(t){if(t.event){var n=s.attr("name");this.currentMember=e(t.event.target).closest("["+n+"]").attr(n),this.options.filterable&&this._setFilterForm(i(this.dataSource.filter(),this.currentMember)[0])}},_select:function(t){var n=e(t.item);e(".k-pivot-filter-window").not(this.includeWindow.element).kendoWindow("close"),n.hasClass("k-include-item")?this.includeWindow.center().open():n.hasClass("k-sort-asc")?this._sort("asc"):n.hasClass("k-sort-desc")?this._sort("desc"):n.hasClass(h)&&this._updateFilterAriaLabel()},_windowOpen:function(){this.treeView||this._createTreeView(this.includeWindow.element.find(".k-treeview")),a.progress(this.includeWindow.element,!0),this.treeView.dataSource.read()},destroy:function(){u.fn.destroy.call(this),this.menu&&(this.menu.destroy(),this.menu=null),this.treeView&&(this.treeView.destroy(),this.treeView=null),this.includeWindow&&(this.includeWindow.destroy(),this.includeWindow=null),this.wrapper=null,this.element=null}}),m='<div class="k-filterable k-content" tabindex="-1" data-role="fieldmenu"><form class="k-filter-menu"><div><div class="k-filter-help-text">#=messages.info#</div><select>#for(var op in messages.operators){#<option value="#=op#">#=messages.operators[op]#</option>#}#</select><input class="k-textbox" type="text" '+f+'="#=messages.filter#" /><div><a class="k-button k-primary k-button-filter" href="\\#">#=messages.filter#</a><a class="k-button k-button-clear" href="\\#">#=messages.clear#</a></div></div></form></div>',g='<ul class="k-pivot-fieldmenu"># if (sortable) {#<li class="k-item k-sort-asc"><span class="k-link"><span class="k-icon k-i-sort-asc-sm"></span>${messages.sortAscending}</span></li><li class="k-item k-sort-desc"><span class="k-link"><span class="k-icon k-i-sort-desc-sm"></span>${messages.sortDescending}</span></li># if (filterable) {#<li class="k-separator"></li># } ## } ## if (filterable) {#<li class="k-item k-include-item"><span class="k-link"><span class="k-icon k-i-filter"></span>${messages.include}</span></li><li class="k-separator"></li><li class="k-item '+h+'"><span class="k-link"><span class="k-icon k-i-filter"></span>${messages.filterFields}</span><ul><li>'+m+"</li></ul></li># } #</ul>",v='<div class="k-popup-edit-form k-pivot-filter-window"><div class="k-edit-form-container"><div class="k-treeview"></div><div class="k-edit-buttons k-state-default"><a class="k-button k-primary k-button-ok" href="\\#">${messages.ok}</a><a class="k-button k-button-cancel" href="\\#">${messages.cancel}</a></div></div>';a.plugin(p)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.filtercell.min",["kendo.autocomplete.min","kendo.datepicker.min","kendo.numerictextbox.min","kendo.combobox.min","kendo.dropdownlist.min"],e)}(function(){return function(e,t){function n(t){var n="string"==typeof t?t:t.operator;return e.inArray(n,v)>-1}function i(t,n){var o,r,s=[];if(e.isPlainObject(t))if(t.hasOwnProperty("filters"))s=t.filters;else if(t.field==n)return t;for(e.isArray(t)&&(s=t),o=0;o<s.length;o++)if(r=i(s[o],n))return r}function o(t,n){t.filters&&(t.filters=e.grep(t.filters,function(e){return o(e,n),e.filters?e.filters.length:e.field!=n}))}function r(e,t){var n=s.getter(t,!0);return function(t){for(var i,o,r=e(t),s=[],a=0,l={};a<r.length;)i=r[a++],o=n(i),l.hasOwnProperty(o)||(s.push(i),l[o]=!0);return s}}var s=window.kendo,a=s.ui,l=s.data.DataSource,c=a.Widget,d="change",u="boolean",h="enums",f="string",p="Is equal to",m="Is not equal to",g=e.proxy,v=["isnull","isnotnull","isempty","isnotempty","isnullorempty","isnotnullorempty"],_=c.extend({init:function(i,o){var r,a,l,p,m,v,_,b,w,y,k,x,C;if(i=e(i).addClass("k-filtercell"),r=this.wrapper=e("<span/>").appendTo(i),a=this,m=o,b=a.operators=o.operators||{},w=a.input=e("<input/>").attr(s.attr("bind"),"value: value").appendTo(r),y=o?o.suggestDataSource:null,y&&(o=e.extend({},o,{suggestDataSource:{}})),c.fn.init.call(a,i[0],o),y&&(a.options.suggestDataSource=y),o=a.options,l=a.dataSource=o.dataSource,a.model=l.reader.model,_=o.type=f,k=s.getter("reader.model.fields",!0)(l)||{},x=k[o.field],x&&x.type&&(_=o.type=x.type),o.values&&(o.type=_=h),b=b[_]||o.operators[_],!m.operator)for(v in b){o.operator=v;break}a._parse=function(e){return null!=e?e+"":e},a.model&&a.model.fields&&(C=a.model.fields[o.field],C&&C.parse&&(a._parse=g(C.parse,C))),a.defaultOperator=o.operator,a.viewModel=p=s.observable({operator:o.operator,value:null,operatorVisible:function(){var e=this.get("value");return null!==e&&e!==t&&"undefined"!=e||n(this.get("operator"))&&!a._clearInProgress}}),p.bind(d,g(a.updateDsFilter,a)),_==f&&a.initSuggestDataSource(o),null!==o.inputWidth&&(w.addClass("k-sized-input"),w.width(o.inputWidth)),w.attr("aria-label",a._getColumnTitle()),a._setInputType(o,_),_!=u&&o.showOperators!==!1?a._createOperatorDropDown(b):(e('<div unselectable="on" />').css("display","none").text("eq").appendTo(r),r.addClass("k-operator-hidden")),a._createClearIcon(),s.bind(this.wrapper,p),_==f&&(o.template||a.setAutoCompleteSource()),_==h&&a.setComboBoxSource(a.options.values),a._refreshUI(),a._refreshHandler=g(a._refreshUI,a),a.dataSource.bind(d,a._refreshHandler)},_setInputType:function(t,n){var i,o,r,a,l,c=this,d=c.input;"function"==typeof t.template?(t.template.call(c.viewModel,{element:c.input,dataSource:c.suggestDataSource}),c._angularItems("compile")):n==f?d.attr(s.attr("role"),"autocomplete").attr(s.attr("text-field"),t.dataTextField||t.field).attr(s.attr("filter"),t.suggestionOperator).attr(s.attr("delay"),t.delay).attr(s.attr("min-length"),t.minLength).attr(s.attr("value-primitive"),!0):"date"==n?d.attr(s.attr("role"),"datepicker"):n==u?(d.remove(),i=e("<input type='radio'/>"),o=c.wrapper,r=s.guid(),a=e("<label/>").text(t.messages.isTrue).append(i),i.attr(s.attr("bind"),"checked:value").attr("name",r).val("true"),l=a.clone().text(t.messages.isFalse),i.clone().val("false").appendTo(l),o.append([a,l])):"number"==n?d.attr(s.attr("role"),"numerictextbox").attr("title",c._getColumnTitle()):n==h&&d.attr(s.attr("role"),"combobox").attr(s.attr("text-field"),"text").attr(s.attr("suggest"),!0).attr(s.attr("filter"),"contains").attr(s.attr("value-field"),"value").attr(s.attr("value-primitive"),!0)},_getColumnTitle:function(){var e=this.options.column;return e?e.title||e.field:""},_createOperatorDropDown:function(t){var n,i,o=[],r=this.viewModel;for(n in t)o.push({text:t[n],value:n});i=e('<input class="k-dropdown-operator" '+s.attr("bind")+'="value: operator"/>').appendTo(this.wrapper),this.operatorDropDown=i.kendoDropDownList({dataSource:o,dataTextField:"text",dataValueField:"value",open:function(){this.popup.element.width(150)},valuePrimitive:!0}).data("kendoDropDownList"),r.bind("change",function(){var e=t[r.operator];i.attr("aria-label",e)}),this.operatorDropDown.wrapper.find(".k-i-arrow-60-down").removeClass("k-i-arrow-60-down").addClass("k-i-filter")},initSuggestDataSource:function(e){var n=e.suggestDataSource;n instanceof l||(!e.customDataSource&&n&&(n.group=t),n=this.suggestDataSource=l.create(n)),e.customDataSource||(n._pageSize=t,n.reader.data=r(n.reader.data,this.options.field)),this.suggestDataSource=n},setAutoCompleteSource:function(){var e=this.input.data("kendoAutoComplete");e&&e.setDataSource(this.suggestDataSource)},setComboBoxSource:function(e){var t=l.create({data:e}),n=this.input.data("kendoComboBox");n&&n.setDataSource(t)},_refreshUI:function(){var t=this,n=i(t.dataSource.filter(),this.options.field)||{},o=t.viewModel;t.manuallyUpdatingVM=!0,n=e.extend(!0,{},n),t.options.type==u&&o.value!==n.value&&t.wrapper.find(":radio").prop("checked",!1),n.operator&&o.set("operator",n.operator),o.set("value",n.value),t.manuallyUpdatingVM=!1},updateDsFilter:function(i){var o,r,s,a,l=this,c=l.viewModel;l.manuallyUpdatingVM||"operator"==i.field&&c.value===t&&!n(c)||(o=e.extend({},l.viewModel.toJSON(),{field:l.options.field}),r={logic:"and",filters:[]},s=!1,(o.value!==t&&null!==o.value||n(o)&&!this._clearInProgress)&&(r.filters.push(o),s=l.trigger(d,{filter:r,field:l.options.field})),(l._clearInProgress||null===o.value)&&(s=l.trigger(d,{filter:null,field:l.options.field})),s||(a=l._merge(r),l.dataSource.filter(a.filters.length?a:{})))},_merge:function(t){var i,r,s,a=this,l=t.logic||"and",c=t.filters,d=a.dataSource.filter()||{filters:[],logic:"and"};for(o(d,a.options.field),r=0,s=c.length;r<s;r++)i=c[r],i.value=a._parse(i.value);return c=e.grep(c,function(e){return""!==e.value&&null!==e.value||n(e)}),c.length&&(d.filters.length?(t.filters=c,"and"!==d.logic&&(d.filters=[{logic:d.logic,filters:d.filters}],d.logic="and"),d.filters.push(c.length>1?t:c[0])):(d.filters=c,d.logic=l)),d},_createClearIcon:function(){var t=this;e("<button type='button' class='k-button k-button-icon' title = "+t.options.messages.clear+"/>").attr("aria-label",t.options.messages.clear).attr(s.attr("bind"),"visible:operatorVisible").html("<span class='k-icon k-i-filter-clear'/>").click(g(t.clearFilter,t)).appendTo(t.wrapper)},clearFilter:function(){this._clearInProgress=!0,n(this.viewModel.operator)&&this.viewModel.set("operator",this.defaultOperator),this.viewModel.set("value",null),this._clearInProgress=!1},_angularItems:function(e){var t=this.wrapper.closest("th").get(),n=this.options.column;this.angular(e,function(){return{elements:t,data:[{column:n}]}})},destroy:function(){var e=this;e.filterModel=null,e.operatorDropDown=null,e._angularItems("cleanup"),e._refreshHandler&&(e.dataSource.bind(d,e._refreshHandler),e._refreshHandler=null),s.unbind(e.element),c.fn.destroy.call(e),s.destroy(e.element)},events:[d],options:{name:"FilterCell",delay:200,minLength:1,inputWidth:null,values:t,customDataSource:!1,field:"",dataTextField:"",type:"string",suggestDataSource:null,suggestionOperator:"startswith",operator:"eq",showOperators:!0,template:null,messages:{isTrue:"is true",isFalse:"is false",filter:"Filter",clear:"Clear",operator:"Operator"},operators:{string:{eq:p,neq:m,startswith:"Starts with",contains:"Contains",doesnotcontain:"Does not contain",endswith:"Ends with",isnull:"Is null",isnotnull:"Is not null",isempty:"Is empty",isnotempty:"Is not empty",isnullorempty:"Has no value",isnotnullorempty:"Has value"},number:{eq:p,neq:m,gte:"Is greater than or equal to",gt:"Is greater than",lte:"Is less than or equal to",lt:"Is less than",isnull:"Is null",isnotnull:"Is not null"},date:{eq:p,neq:m,gte:"Is after or equal to",gt:"Is after",lte:"Is before or equal to",lt:"Is before",isnull:"Is null",
isnotnull:"Is not null"},enums:{eq:p,neq:m,isnull:"Is null",isnotnull:"Is not null"}}}});a.plugin(_)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.panelbar.min",["kendo.data.min"],e)}(function(){return function(e,t){function n(t){t=e(t),t.filter(".k-first:not(:first-child)").removeClass(T),t.filter(".k-last:not(:last-child)").removeClass(_),t.filter(":first-child").addClass(T),t.filter(":last-child").addClass(_)}function i(t){var n=t,i=t.children("ul"),o=n.children(".k-link").children(".k-icon");t.hasClass("k-panelbar")||(!o.length&&i.length?o=e("<span class='k-icon' />").appendTo(n):i.length&&i.children().length||(o.remove(),i.remove()))}var o=window.kendo,r=o.ui,s=o.keys,a=e.extend,l=e.proxy,c=e.each,d=e.isArray,u=o.template,h=r.Widget,f=o.data.HierarchicalDataSource,p=/^(ul|a|div)$/i,m=".kendoPanelBar",g="img",v="href",_="k-last",b="k-link",w="."+b,y="error",k=".k-item",x=".k-group",C=x+":visible",S="k-image",T="k-first",D="change",A="expand",E="select",I="k-content",M="activate",R="collapse",F="dataBound",z="mouseenter",P="mouseleave",B="contentLoad",L="undefined",H="k-state-active",N="> .k-panel",O="> .k-content",V="string",U="k-state-focused",W="k-state-disabled",j="k-state-selected",q="."+j,G="k-state-highlight",$=k+":not(.k-state-disabled)",K="> "+$+" > "+w+", .k-panel > "+$+" > "+w,Y=k+".k-state-disabled > .k-link",Q="> li > "+q+", .k-panel > li > "+q,X="k-state-default",Z="aria-disabled",J="aria-expanded",ee="aria-hidden",te="aria-selected",ne=":visible",ie=":empty",oe="single",re={text:"dataTextField",url:"dataUrlField",spriteCssClass:"dataSpriteCssClassField",imageUrl:"dataImageUrlField"},se={aria:function(e){var t="";return(e.items||e.content||e.contentUrl||e.expanded)&&(t+=J+"='"+(e.expanded?"true":"false")+"' "),e.enabled===!1&&(t+=Z+"='true'"),t},wrapperCssClass:function(e,t){var n="k-item",i=t.index;return n+=t.enabled===!1?" "+W:t.expanded===!0?" "+H:" k-state-default",0===i&&(n+=" k-first"),i==e.length-1&&(n+=" k-last"),t.cssClass&&(n+=" "+t.cssClass),n},textClass:function(e,t){var n=b;return t.firstLevel&&(n+=" k-header"),n},textAttributes:function(e){return e?" href='"+e+"'":""},arrowClass:function(e){var t="k-icon";return t+=e.expanded?" k-panelbar-collapse k-i-arrow-60-up":" k-panelbar-expand k-i-arrow-60-down"},text:function(e){return e.encoded===!1?e.text:o.htmlEncode(e.text)},groupAttributes:function(e){return e.expanded!==!0?" style='display:none'":""},ariaHidden:function(e){return e.expanded!==!0},groupCssClass:function(){return"k-group k-panel"},contentAttributes:function(e){return e.item.expanded!==!0?" style='display:none'":""},content:function(e){return e.content?e.content:e.contentUrl?"":"&nbsp;"},contentUrl:function(e){return e.contentUrl?'href="'+e.contentUrl+'"':""}},ae=function(e){return e.children("span").children(".k-icon")},le=o.ui.DataBoundWidget.extend({init:function(t,n){var i,r,s=this;d(n)&&(n={dataSource:n}),r=n&&!!n.dataSource,h.fn.init.call(s,t,n),t=s.wrapper=s.element.addClass("k-widget k-reset k-header k-panelbar"),n=s.options,t[0].id&&(s._itemId=t[0].id+"_pb_active"),s._tabindex(),s._accessors(),s._dataSource(),s._templates(),s._initData(r),s._updateClasses(),s._animations(n),t.on("click"+m,K,function(t){s._click(e(t.currentTarget))&&t.preventDefault()}).on(z+m+" "+P+m,K,s._toggleHover).on("click"+m,Y,!1).on("click"+m,".k-request-retry",l(s._retryRequest,s)).on("keydown"+m,e.proxy(s._keydown,s)).on("focus"+m,function(){var e=s.select();s._current(e[0]?e:s._first())}).on("blur"+m,function(){s._current(null)}).attr("role","menu"),i=t.find("li."+H+" > ."+I),i[0]&&s.expand(i.parent(),!1),n.dataSource||s._angularCompile(),o.notify(s)},events:[A,R,E,M,D,y,F,B],options:{name:"PanelBar",dataSource:{},animation:{expand:{effects:"expand:vertical",duration:200},collapse:{duration:200}},messages:{loading:"Loading...",requestFailed:"Request failed.",retry:"Retry"},autoBind:!0,loadOnDemand:!0,expandMode:"multiple",template:"",dataTextField:null},_angularCompile:function(){var e=this;e.angular("compile",function(){return{elements:e.element.children("li"),data:[{dataItem:e.options.$angular}]}})},_angularCompileElements:function(t,n){var i=this;i.angular("compile",function(){return{elements:t,data:e.map(n,function(e){return[{dataItem:e}]})}})},_angularCleanup:function(){var e=this;e.angular("cleanup",function(){return{elements:e.element.children("li")}})},destroy:function(){h.fn.destroy.call(this),this.element.off(m),this._angularCleanup(),o.destroy(this.element)},_initData:function(e){var t=this;e&&(t.element.empty(),t.options.autoBind&&(t._progress(!0),t.dataSource.fetch()))},_templates:function(){var e=this,t=e.options,n=l(e._fieldAccessor,e);t.template&&typeof t.template==V?t.template=u(t.template):t.template||(t.template=u("# var text = "+n("text")+"(data.item); ## if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {##= text ## } else { ##: text ## } #")),e.templates={content:u("<div role='region' class='k-content'#= contentAttributes(data) #>#= content(item) #</div>"),group:u("<ul role='group' aria-hidden='#= ariaHidden(group) #' class='#= groupCssClass(group) #'#= groupAttributes(group) #>#= renderItems(data) #</ul>"),itemWrapper:u("# var url = "+n("url")+"(item); ## var imageUrl = "+n("imageUrl")+"(item); ## var spriteCssClass = "+n("spriteCssClass")+"(item); ## var contentUrl = contentUrl(item); ## var tag = url||contentUrl ? 'a' : 'span'; #<#= tag # class='#= textClass(item, group) #' #= contentUrl ##= textAttributes(url) #># if (imageUrl) { #<img class='k-image' alt='' src='#= imageUrl #' /># } ## if (spriteCssClass) { #<span class='k-sprite #= spriteCssClass #'></span># } ##= data.panelBar.options.template(data) ##= arrow(data) #</#= tag #>"),item:u("<li role='menuitem' #=aria(item)#class='#= wrapperCssClass(group, item) #'"+o.attr("uid")+"='#= item.uid #'>#= itemWrapper(data) ## if (item.items && item.items.length > 0) { ##= subGroup({ items: item.items, panelBar: panelBar, group: { expanded: item.expanded } }) ## } else if (item.content || item.contentUrl) { ##= renderContent(data) ## } #</li>"),loading:u("<div class='k-item'><span class='k-icon k-i-loading'></span> #: data.messages.loading #</div>"),retry:u("#: data.messages.requestFailed # <button class='k-button k-request-retry'>#: data.messages.retry #</button>"),arrow:u("<span class='#= arrowClass(item) #'></span>"),empty:u("")}},setOptions:function(e){var t=this.options.animation;this._animations(e),e.animation=a(!0,t,e.animation),"dataSource"in e&&this.setDataSource(e.dataSource),h.fn.setOptions.call(this,e)},expand:function(n,i){var o=this,r={};return n=this.element.find(n),o._animating&&n.find("ul").is(":visible")?(o.one("complete",function(){setTimeout(function(){o.expand(n)})}),t):(o._animating=!0,i=i!==!1,n.each(function(t,s){var a,l;if(s=e(s),a=n.children(".k-group,.k-content"),a.length||(a=o._addGroupElement(n)),l=a.add(s.find(O)),!s.hasClass(W)&&l.length>0){if(o.options.expandMode==oe&&o._collapseAllExpanded(s))return o;n.find("."+G).removeClass(G),s.addClass(G),i||(r=o.options.animation,o.options.animation={expand:{effects:{}},collapse:{hide:!0,effects:{}}}),o._triggerEvent(A,s)||o._toggleItem(s,!1,!1),i||(o.options.animation=r)}}),o)},collapse:function(t,n){var i=this,o={};return i._animating=!0,n=n!==!1,t=i.element.find(t),t.each(function(t,r){r=e(r);var s=r.find(N).add(r.find(O));!r.hasClass(W)&&s.is(ne)&&(r.removeClass(G),n||(o=i.options.animation,i.options.animation={expand:{effects:{}},collapse:{hide:!0,effects:{}}}),i._triggerEvent(R,r)||i._toggleItem(r,!0),n||(i.options.animation=o))}),i},updateArrow:function(t){var n=this;t=e(t),t.children(w).children(".k-panelbar-collapse, .k-panelbar-expand").remove(),t.filter(function(){var t=n.dataItem(this);return t?t.hasChildren||t.content||t.contentUrl:e(this).find(".k-panel").length>0||e(this).find(".k-content").length>0}).children(".k-link:not(:has([class*=k-i-arrow]))").each(function(){var t=e(this),n=t.parent();t.append("<span class='k-icon "+(n.hasClass(H)?" k-panelbar-collapse k-i-arrow-60-up":" k-panelbar-expand k-i-arrow-60-down")+"'/>")})},_accessors:function(){var e,t,n,i=this,r=i.options,s=i.element;for(e in re)t=r[re[e]],n=s.attr(o.attr(e+"-field")),!t&&n&&(t=n),t||(t=e),d(t)||(t=[t]),r[re[e]]=t},_progress:function(e,t){var n=this.element,i=this.templates.loading({messages:this.options.messages});1==arguments.length?(t=e,t?n.html(i):n.empty()):ae(e).toggleClass("k-i-loading",t).removeClass("k-i-refresh")},_refreshRoot:function(t){var n,i=this,o=i.element,r={firstLevel:!0,expanded:!0,length:o.children().length};this.element.empty(),n=e.map(t,function(t,n){return"string"==typeof t?e(t):(t.items=[],e(i.renderItem({group:r,item:a(t,{index:n})})))}),this.element.append(n),this._angularCompileElements(n,t)},_refreshChildren:function(e,t){var n,o,s,a;if(t.children(".k-group").empty(),a=e.children.data(),a.length)for(this.append(e.children,t),this.options.loadOnDemand&&this._toggleGroup(t.children(".k-group"),!1),o=t.children(".k-group").children("li"),n=0;n<o.length;n++)s=o.eq(n),this.trigger("itemChange",{item:s,data:this.dataItem(s),ns:r});else i(t),o=t.children(".k-group").children("li"),this._angularCompileElements(o,a)},findByUid:function(t){var n,i,r=this.element.find(".k-item"),s=o.attr("uid");for(i=0;i<r.length;i++)if(r[i].getAttribute(s)==t){n=r[i];break}return e(n)},refresh:function(e){var n,i,o=this.options,r=e.node,s=e.action,a=e.items,l=this.wrapper,c=o.loadOnDemand;if(e.field){if(!a[0]||!a[0].level)return;return this._updateItems(a,e.field)}if(r&&(l=this.findByUid(r.uid),this._progress(l,!1)),"add"==s?this._appendItems(e.index,a,l):"remove"==s?this.remove(this.findByUid(a[0].uid)):"itemchange"==s?this._updateItems(a):"itemloaded"==s?this._refreshChildren(r,l):this._refreshRoot(a),"remove"!=s)for(n=0;n<a.length;n++)c&&!a[n].expanded||(i=a[n],this._hasChildItems(i)&&i.load());this.trigger(F,{node:r?l:t})},_error:function(e){var t=e.node&&this.findByUid(e.node.uid),n=this.templates.retry({messages:this.options.messages});t?(this._progress(t,!1),this._expanded(t,!1),ae(t).addClass("k-i-refresh"),e.node.loaded(!1)):(this._progress(!1),this.element.html(n))},_retryRequest:function(e){e.preventDefault(),this.dataSource.fetch()},items:function(){return this.element.find(".k-item > span:first-child")},setDataSource:function(e){var t=this.options;t.dataSource=e,this._dataSource(),this.options.autoBind&&(this._progress(!0),this.dataSource.fetch())},_bindDataSource:function(){this._refreshHandler=l(this.refresh,this),this._errorHandler=l(this._error,this),this.dataSource.bind(D,this._refreshHandler),this.dataSource.bind(y,this._errorHandler)},_unbindDataSource:function(){var e=this.dataSource;e&&(e.unbind(D,this._refreshHandler),e.unbind(y,this._errorHandler))},_fieldAccessor:function(t){var n=this.options[re[t]]||[],i=n.length,r="(function(item) {";return 0===i?r+="return item['"+t+"'];":(r+="var levels = ["+e.map(n,function(e){return"function(d){ return "+o.expr(e)+"}"}).join(",")+"];",r+="if(item.level){return levels[Math.min(item.level(), "+i+"-1)](item);}else",r+="{return levels["+i+"-1](item)}"),r+="})"},_dataSource:function(){var e=this,t=e.options,n=t.dataSource;n&&(n=d(n)?{data:n}:n,e._unbindDataSource(),n.fields||(n.fields=[{field:"text"},{field:"url"},{field:"spriteCssClass"},{field:"imageUrl"}]),e.dataSource=f.create(n),e._bindDataSource())},_appendItems:function(t,n,i){var o,r,s,l,c,d=this;for(i.hasClass("k-panelbar")?(o=i.children("li"),r=i):(r=i.children(".k-group"),r.length||(r=d._addGroupElement(i)),o=r.children("li")),s={firstLevel:i.hasClass("k-panelbar"),expanded:!0,length:o.length},l=e.map(n,function(t,n){return e("string"==typeof t?t:d.renderItem({group:s,item:a(t,{index:n})}))}),typeof t==L&&(t=o.length),c=0;c<l.length;c++)0===o.length||0===t?r.append(l[c]):l[c].insertAfter(o[t-1]);d._angularCompileElements(l,n),d.dataItem(i)&&(d.dataItem(i).hasChildren=!0,d.updateArrow(i))},_updateItems:function(t,n){var i,o,s,l,c,d,u=this,h={panelBar:u.options,item:l,group:{}},f="expanded"!=n;if("selected"==n)t[0][n]?(c=u.findByUid(t[0].uid),c.hasClass(W)||u.select(c,!0)):u.clearSelection();else{for(d=e.map(t,function(e){return u.findByUid(e.uid)}),f&&u.angular("cleanup",function(){return{elements:d}}),i=0;i<t.length;i++)h.item=l=t[i],h.panelBar=u,s=d[i],o=s.parent(),f&&(h.group={firstLevel:o.hasClass("k-panelbar"),expanded:s.parent().hasClass(H),length:s.children().length},s.children(".k-link").remove(),s.prepend(u.templates.itemWrapper(a(h,{arrow:l.hasChildren||l.content||l.contentUrl?u.templates.arrow:u.templates.empty},se)))),"expanded"==n?u._toggleItem(s,!l[n],!l[n]||"true"):"enabled"==n&&(u.enable(s,l[n]),l[n]||l.selected&&l.set("selected",!1)),s.length&&this.trigger("itemChange",{item:s,data:l,ns:r});f&&u.angular("compile",function(){return{elements:d,data:e.map(t,function(e){return[{dataItem:e}]})}})}},_toggleDisabled:function(e,t){e=this.element.find(e),e.toggleClass(X,t).toggleClass(W,!t).attr(Z,!t)},dataItem:function(t){var n=e(t).closest(k).attr(o.attr("uid")),i=this.dataSource;return i&&i.getByUid(n)},select:function(n,i){var o=this;return n===t?o.element.find(Q).parent():(n=o.element.find(n),n.length?n.each(function(){var n=e(this),r=n.children(w);return n.hasClass(W)?o:(o._updateSelected(r,i),t)}):this._updateSelected(n),o)},clearSelection:function(){this.select(e())},enable:function(e,t){return this._toggleDisabled(e,t!==!1),this},disable:function(e){return this._toggleDisabled(e,!1),this},append:function(e,t){t=this.element.find(t);var i=this._insert(e,t,t.length?t.find(N):null);return c(i.items,function(){i.group.append(this),n(this)}),this.updateArrow(t),n(i.group.find(".k-first, .k-last")),i.group.height("auto"),this},insertBefore:function(e,t){t=this.element.find(t);var i=this._insert(e,t,t.parent());return c(i.items,function(){t.before(this),n(this)}),n(t),i.group.height("auto"),this},insertAfter:function(e,t){t=this.element.find(t);var i=this._insert(e,t,t.parent());return c(i.items,function(){t.after(this),n(this)}),n(t),i.group.height("auto"),this},remove:function(e){e=this.element.find(e);var t=this,i=e.parentsUntil(t.element,k),o=e.parent("ul");return e.remove(),!o||o.hasClass("k-panelbar")||o.children(k).length||o.remove(),i.length&&(i=i.eq(0),t.updateArrow(i),n(i)),t},reload:function(t){var n=this;t=n.element.find(t),t.each(function(){var t=e(this);n._ajaxRequest(t,t.children("."+I),!t.is(ne))})},_first:function(){return this.element.children($).first()},_last:function(){var e=this.element.children($).last(),t=e.children(C);return t[0]?t.children($).last():e},_current:function(n){var i=this,o=i._focused,r=i._itemId;return n===t?o:(i.element.removeAttr("aria-activedescendant"),o&&o.length&&(o[0].id===r&&o.removeAttr("id"),o.children(w).removeClass(U)),e(n).length&&(r=n[0].id||r,n.attr("id",r).children(w).addClass(U),i.element.attr("aria-activedescendant",r)),i._focused=n,t)},_keydown:function(e){var t=this,n=e.keyCode,i=t._current();e.target==e.currentTarget&&(n==s.DOWN||n==s.RIGHT?(t._current(t._nextItem(i)),e.preventDefault()):n==s.UP||n==s.LEFT?(t._current(t._prevItem(i)),e.preventDefault()):n==s.ENTER||n==s.SPACEBAR?(t._click(i.children(w)),e.preventDefault()):n==s.HOME?(t._current(t._first()),e.preventDefault()):n==s.END&&(t._current(t._last()),e.preventDefault()))},_nextItem:function(e){if(!e)return this._first();var t=e.children(C),n=e.nextAll(":visible").first();return t[0]&&(n=t.children("."+T)),n[0]||(n=e.parent(C).parent(k).next()),n[0]||(n=this._first()),n.hasClass(W)&&(n=this._nextItem(n)),n},_prevItem:function(e){if(!e)return this._last();var t,n=e.prevAll(":visible").first();if(n[0])for(t=n;t[0];)t=t.children(C).children("."+_),t[0]&&(n=t);else n=e.parent(C).parent(k),n[0]||(n=this._last());return n.hasClass(W)&&(n=this._prevItem(n)),n},_insert:function(t,n,i){var o,r,s,l=this,c=e.isPlainObject(t),d=n&&n[0];return d||(i=l.element),r={firstLevel:i.hasClass("k-panelbar"),expanded:e(n).hasClass(H),length:i.children().length},d&&!i.length&&(i=e(l.renderGroup({group:r,options:l.options})).appendTo(n)),c||e.isArray(t)||t instanceof f?(t instanceof f&&(t=t.data()),o=e.map(c?[t]:t,function(t,n){return e("string"==typeof t?t:l.renderItem({group:r,item:a(t,{index:n})}))}),d&&(s=l.dataItem(n),s?(s.hasChildren=!0,n.attr(J,s.expanded).not("."+H).children("ul").attr(ee,!s.expanded)):n.attr(J,!1))):(o="string"==typeof t&&"<"!=t.charAt(0)?l.element.find(t):e(t),l._updateItemsClasses(o)),t.length||(t=[t]),l._angularCompileElements(o,t),{items:o,group:i}},_toggleHover:function(t){var n=e(t.currentTarget);n.parents("li."+W).length||n.toggleClass("k-state-hover",t.type==z)},_updateClasses:function(){var t,i,o,r,s,a=this;t=a.element.find("li > ul").not(function(){return e(this).parentsUntil(".k-panelbar","div").length}).addClass("k-group k-panel").attr("role","group"),r=t.parent(),s=a.dataItem(r),o=s&&s.expanded||!1,t.parent().attr(J,o).not("."+H).children("ul").attr(ee,!o).hide(),i=a.element.add(t).children(),a._updateItemsClasses(i),a.updateArrow(i),n(i)},_updateItemsClasses:function(e){for(var t=e.length,n=0;n<t;n++)this._updateItemClasses(e[n],n)},_updateItemClasses:function(t,n){var i,r,s=this._selected,a=this.options.contentUrls,l=a&&a[n],c=this.element[0];t=e(t).addClass("k-item").attr("role","menuitem"),o.support.browser.msie&&t.css("list-style-position","inside").css("list-style-position",""),t.children(g).addClass(S),r=t.children("a").addClass(b),r[0]&&(r.attr("href",l),r.children(g).addClass(S)),t.filter(":not([disabled]):not([class*=k-state])").addClass("k-state-default"),t.filter("li[disabled]").addClass("k-state-disabled").attr(Z,!0).removeAttr("disabled"),t.children("div").addClass(I).attr("role","region").attr(ee,!0).hide().parent().attr(J,!1),r=t.children(q),r[0]&&(s&&s.removeAttr(te).children(q).removeClass(j),r.addClass(j),this._selected=t.attr(te,!0)),t.children(w)[0]||(i="<span class='"+b+"'/>",a&&a[n]&&t[0].parentNode==c&&(i='<a class="k-link k-header" href="'+a[n]+'"/>'),t.contents().filter(function(){return!(this.nodeName.match(p)||3==this.nodeType&&!e.trim(this.nodeValue))}).wrapAll(i)),t.parent(".k-panelbar")[0]&&t.children(w).addClass("k-header")},_click:function(e){var t,n,i,o,r,s,a,l,c,d=this,u=d.element;if(!e.parents("li."+W).length&&e.closest(".k-widget")[0]==u[0]){if(r=e.closest(w),s=r.closest(k),d._updateSelected(r),a=s.children(".k-group,.k-content"),l=this.dataItem(s),!a.length&&(d.options.loadOnDemand&&l&&l.hasChildren||this._hasChildItems(s)||s.content||s.contentUrl)&&(a=d._addGroupElement(s)),n=s.find(N).add(s.find(O)),i=r.attr(v),o=i&&("#"==i.charAt(i.length-1)||i.indexOf("#"+d.element[0].id+"-")!=-1),t=!(!o&&!n.length),n.data("animating"))return t;if(d._triggerEvent(E,s)&&(t=!0),t!==!1)return d.options.expandMode==oe&&d._collapseAllExpanded(s)?t:(n.length&&(c=n.is(ne),d._triggerEvent(c?R:A,s)||(t=d._toggleItem(s,c))),t)}},_hasChildItems:function(e){return e.items&&e.items.length>0||e.hasChildren},_toggleItem:function(e,n,i){var o,r,s=this,a=e.find(N),l=e.find(w),c=l.attr(v),d=s.dataItem(e),u=!n,h=d&&d.loaded();return d&&!i&&d.expanded!==u?(d.set("expanded",u),o=d.hasChildren||!!d.content||!!d.contentUrl):(!d||i&&"true"!==i||h||d.content||d.contentUrl?a.length?(this._toggleGroup(a,n),o=!0):(r=e.children("."+I),r.length&&(o=!0,r.is(ie)&&c!==t?s._ajaxRequest(e,r,n):s._toggleGroup(r,n))):(s.options.loadOnDemand&&this._progress(e,!0),e.children(".k-group,.k-content").remove(),o=d.hasChildren,d.load()),o)},_toggleGroup:function(e,n){var i=this,o=i.options.animation,r=o.expand,s=o.collapse&&"effects"in o.collapse,l=a({},o.expand,o.collapse);return s||(l=a(l,{reverse:!0})),e.is(ne)!=n?(i._animating=!1,t):(e.attr(ee,!!n),e.parent().attr(J,!n).toggleClass(H,!n).find("> .k-link > .k-panelbar-collapse,> .k-link > .k-panelbar-expand").toggleClass("k-i-arrow-60-up",!n).toggleClass("k-panelbar-collapse",!n).toggleClass("k-i-arrow-60-down",n).toggleClass("k-panelbar-expand",n),n?(r=a(l,{hide:!0}),r.complete=function(){i._animationCallback()}):r=a({complete:function(e){i._triggerEvent(M,e.closest(k)),i._animationCallback()}},r),e.kendoStop(!0,!0).kendoAnimate(r),t)},_animationCallback:function(){var e=this;e.trigger("complete"),e._animating=!1},_addGroupElement:function(t){var n=e('<ul role="group" aria-hidden="true" class="k-group k-panel" style="display:none"></ul>');return t.append(n),n},_collapseAllExpanded:function(t){var n,i=this,o=!1,r=t.find(N).add(t.find(O));return r.is(ne)&&(o=!0),r.is(ne)||0===r.length||(n=t.siblings(),n.find(N).add(n.find(O)).filter(function(){return e(this).is(ne)}).each(function(t,n){n=e(n),o=i._triggerEvent(R,n.closest(k)),o||i._toggleGroup(n,!0)}),i.one("complete",function(){setTimeout(function(){n.each(function(e,t){var n=i.dataItem(t);n&&n.set("expanded",!1)})})})),o},_ajaxRequest:function(t,n,i){var o=this,r=t.find(".k-panelbar-collapse, .k-panelbar-expand"),s=t.find(w),a=setTimeout(function(){r.addClass("k-i-loading")},100),l={},c=s.attr(v);e.ajax({type:"GET",cache:!1,url:c,dataType:"html",data:l,error:function(e,t){r.removeClass("k-i-loading"),o.trigger(y,{xhr:e,status:t})&&this.complete()},complete:function(){clearTimeout(a),r.removeClass("k-i-loading")},success:function(e){function r(){return{elements:n.get()}}try{o.angular("cleanup",r),n.html(e),o.angular("compile",r)}catch(s){var a=window.console;a&&a.error&&a.error(s.name+": "+s.message+" in "+c),this.error(this.xhr,"error")}o._toggleGroup(n,i),o.trigger(B,{item:t[0],contentElement:n[0]})}})},_triggerEvent:function(e,t){var n=this;return n.trigger(e,{item:t[0]})},_updateSelected:function(e,t){var n=this,i=n.element,o=e.parent(k),r=n._selected,s=n.dataItem(o);r&&r.removeAttr(te),n._selected=o.attr(te,!0),i.find(Q).removeClass(j),i.find("> ."+G+", .k-panel > ."+G).removeClass(G),e.addClass(j),e.parentsUntil(i,k).filter(":has(.k-header)").addClass(G),n._current(o[0]?o:null),s&&s.set("selected",!0),t||n.trigger(D)},_animations:function(e){e&&"animation"in e&&!e.animation&&(e.animation={expand:{effects:{}},collapse:{hide:!0,effects:{}}})},renderItem:function(e){var t,n,i=this;return e=a({panelBar:i,group:{}},e),t=i.templates.empty,n=e.item,i.templates.item(a(e,{itemWrapper:i.templates.itemWrapper,renderContent:i.renderContent,arrow:i._hasChildItems(n)||n.content||n.contentUrl?i.templates.arrow:t,subGroup:!e.loadOnDemand||n.expanded?i.renderGroup:t},se))},renderGroup:function(e){var t=this,n=t.templates||e.panelBar.templates;return n.group(a({renderItems:function(e){for(var t="",n=0,i=e.items,o=i?i.length:0,r=a({length:o},e.group);n<o;n++)t+=e.panelBar.renderItem(a(e,{group:r,item:a({index:n},i[n])}));return t}},e,se))},renderContent:function(e){return e.panelBar.templates.content(a(e,se))}});o.ui.plugin(le)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.responsivepanel.min",["kendo.core.min"],e)}(function(){return function(e,t){var n=e.proxy,i=".kendoResponsivePanel",o="open",r="close",s="click"+i+" touchstart"+i,a=kendo.ui.Widget,l=a.extend({init:function(t,o){a.fn.init.call(this,t,o),this._guid="_"+kendo.guid(),this._toggleHandler=n(this._toggleButtonClick,this),this._closeHandler=n(this._close,this),e(document.documentElement).on(s,this.options.toggleButton,this._toggleHandler),this._registerBreakpoint(),this.element.addClass("k-rpanel k-rpanel-"+this.options.orientation+" "+this._guid),this._resizeHandler=n(this.resize,this,!0),e(window).on("resize"+i,this._resizeHandler)},_mediaQuery:"@media (max-width: #= breakpoint-1 #px) {.#= guid #.k-rpanel-animate.k-rpanel-left,.#= guid #.k-rpanel-animate.k-rpanel-right {-webkit-transition: -webkit-transform .2s ease-out;-ms-transition: -ms-transform .2s ease-out;transition: transform .2s ease-out;} .#= guid #.k-rpanel-top {overflow: hidden;}.#= guid #.k-rpanel-animate.k-rpanel-top {-webkit-transition: max-height .2s linear;-ms-transition: max-height .2s linear;transition: max-height .2s linear;}} @media (min-width: #= breakpoint #px) {#= toggleButton # { display: none; } .#= guid #.k-rpanel-left { float: left; } .#= guid #.k-rpanel-right { float: right; } .#= guid #.k-rpanel-left, .#= guid #.k-rpanel-right {position: relative;-webkit-transform: translateX(0);-ms-transform: translateX(0);transform: translateX(0);-webkit-transform: translateX(0) translateZ(0);-ms-transform: translateX(0) translateZ(0);transform: translateX(0) translateZ(0);} .k-ie9 .#= guid #.k-rpanel-left { left: 0; } .#= guid #.k-rpanel-top { max-height: none; }}",_registerBreakpoint:function(){var e=this.options;this._registerStyle(kendo.template(this._mediaQuery)({breakpoint:e.breakpoint,toggleButton:e.toggleButton,guid:this._guid}))},_registerStyle:function(t){var n=e("head,body")[0],i=document.createElement("style");n.appendChild(i),i.styleSheet?i.styleSheet.cssText=t:i.appendChild(document.createTextNode(t))},options:{name:"ResponsivePanel",orientation:"left",toggleButton:".k-rpanel-toggle",breakpoint:640,autoClose:!0},events:[o,r],_resize:function(){this.element.removeClass("k-rpanel-animate k-rpanel-expanded"),e(document.documentElement).off(s,this._closeHandler)},_toggleButtonClick:function(e){e.preventDefault(),this.element.hasClass("k-rpanel-expanded")?this.close():this.open()},open:function(){this.trigger(o)||(this.element.addClass("k-rpanel-animate k-rpanel-expanded"),this.options.autoClose&&e(document.documentElement).on(s,this._closeHandler))},close:function(){this.trigger(r)||(this.element.addClass("k-rpanel-animate").removeClass("k-rpanel-expanded"),e(document.documentElement).off(s,this._closeHandler))},_close:function(t){var n=t.isDefaultPrevented(),i=e(t.target).closest(this.options.toggleButton+",.k-rpanel");i.length||n||this.close()},destroy:function(){a.fn.destroy.call(this),e(window).off("resize"+i,this._resizeHandler),e(document.documentElement).off(s,this._closeHandler)}});kendo.ui.plugin(l)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.timepicker.min",["kendo.popup.min","kendo.dateinput.min"],e)}(function(){return function(e,t){function n(e,t,n){var i,o=e.getTimezoneOffset();e.setTime(e.getTime()+t),n||(i=e.getTimezoneOffset()-o,e.setTime(e.getTime()+i*F))}function i(){var e=new G,t=new G(e.getFullYear(),e.getMonth(),e.getDate(),0,0,0),n=new G(e.getFullYear(),e.getMonth(),e.getDate(),12,0,0);return-1*(t.getTimezoneOffset()-n.getTimezoneOffset())}function o(e){return 60*e.getHours()*F+e.getMinutes()*F+1e3*e.getSeconds()+e.getMilliseconds()}function r(e,t,n){var i,r=o(t),s=o(n);return!e||r==s||(i=o(e),r>i&&(i+=z),s<r&&(s+=z),i>=r&&i<=s)}function s(e){var t=e.parseFormats;e.format=p(e.format||d.getCulture(e.culture).calendars.standard.patterns.t),t=W(t)?t:[t],t.splice(0,0,e.format),e.parseFormats=t}function a(e){e.preventDefault()}var l,c,d=window.kendo,u=d.keys,h=d.parseDate,f=d._activeElement,p=d._extractFormat,m=d.support,g=m.browser,v=d.ui,_=v.Widget,b="open",w="close",y="change",k=".kendoTimePicker",x="click"+k,C="k-state-default",S="disabled",T="readonly",D="li",A="<span/>",E="k-state-focused",I="k-state-hover",M="mouseenter"+k+" mouseleave"+k,R="mousedown"+k,F=6e4,z=864e5,P="k-state-selected",B="k-state-disabled",L="aria-selected",H="aria-expanded",N="aria-hidden",O="aria-disabled",V="aria-activedescendant",U="id",W=e.isArray,j=e.extend,q=e.proxy,G=Date,$=new G;$=new G($.getFullYear(),$.getMonth(),$.getDate(),0,0,0),l=function(t){var n=this,i=t.id;n.options=t,n._dates=[],n.ul=e('<ul tabindex="-1" role="listbox" aria-hidden="true" unselectable="on" class="k-list k-reset"/>').css({overflow:m.kineticScrollNeeded?"":"auto"}).on(x,D,q(n._click,n)).on("mouseenter"+k,D,function(){e(this).addClass(I)}).on("mouseleave"+k,D,function(){e(this).removeClass(I)}),n.list=e("<div class='k-list-container k-list-scroller' unselectable='on'/>").append(n.ul).on(R,a),i&&(n._timeViewID=i+"_timeview",n._optionID=i+"_option_selected",n.ul.attr(U,n._timeViewID)),n._popup(),n._heightHandler=q(n._height,n),n.template=d.template('<li tabindex="-1" role="option" class="k-item" unselectable="on">#=data#</li>',{useWithBlock:!1})},l.prototype={current:function(n){var i=this,o=i.options.active;return n===t?i._current:(i._current&&i._current.removeClass(P).removeAttr(L).removeAttr(U),n&&(n=e(n).addClass(P).attr(U,i._optionID).attr(L,!0),i.scroll(n[0])),i._current=n,o&&o(n),t)},close:function(){this.popup.close()},destroy:function(){var e=this;e.ul.off(k),e.list.off(k),e.popup.destroy()},open:function(){var e=this;e.ul[0].firstChild||e.bind(),e.popup.open(),e._current&&e.scroll(e._current[0])},dataBind:function(e){for(var t,n=this,i=n.options,o=i.format,s=d.toString,a=n.template,l=e.length,c=0,u="";c<l;c++)t=e[c],r(t,i.min,i.max)&&(u+=a(s(t,o,i.culture)));n._html(u)},refresh:function(){var e,t,r,s=this,a=s.options,l=a.format,c=i(),u=c<0,h=a.min,f=a.max,p=o(h),m=o(f),g=a.interval*F,v=d.toString,_=s.template,b=new G((+h)),w=b.getDate(),y=0,k="";for(r=u?(z+c*F)/g:z/g,p!=m&&(p>m&&(m+=z),r=(m-p)/g+1),t=parseInt(r,10);y<r;y++)y&&n(b,g,u),m&&t==y&&(e=o(b),w<b.getDate()&&(e+=z),e>m&&(b=new G((+f)))),s._dates.push(o(b)),k+=_(v(b,l,a.culture));s._html(k)},bind:function(){var e=this,t=e.options.dates;t&&t[0]?e.dataBind(t):e.refresh()},_html:function(e){var t=this;t.ul[0].innerHTML=e,t.popup.unbind(b,t._heightHandler),t.popup.one(b,t._heightHandler),t.current(null),t.select(t._value)},scroll:function(e){if(e){var t=this.list[0],n=e.offsetTop,i=e.offsetHeight,o=t.scrollTop,r=t.clientHeight,s=n+i;o>n?o=n:s>o+r&&(o=s-r),t.scrollTop=o}},select:function(t){var n,i=this,o=i.options,r=i._current;t instanceof Date&&(t=d.toString(t,o.format,o.culture)),"string"==typeof t&&(r&&r.text()===t?t=r:(t=e.grep(i.ul[0].childNodes,function(e){return(e.textContent||e.innerText)==t}),t=t[0]?t:null)),n=i._distinctSelection(t),i.current(n)},_distinctSelection:function(t){var n,i,r=this;return t&&t.length>1&&(n=o(r._value),i=e.inArray(n,r._dates),t=r.ul.children()[i]),t},setOptions:function(e){var t=this.options;e.min=h(e.min),e.max=h(e.max),this.options=j(t,e,{active:t.active,change:t.change,close:t.close,open:t.open}),this.bind()},toggle:function(){var e=this;e.popup.visible()?e.close():e.open()},value:function(e){var t=this;t._value=e,t.ul[0].firstChild&&t.select(e)},_click:function(t){var n=this,i=e(t.currentTarget),o=i.text(),r=n.options.dates;r&&r.length>0&&(o=r[i.index()]),t.isDefaultPrevented()||(n.select(i),n.options.change(o,!0),n.close())},_height:function(){var e=this,t=e.list,n=t.parent(".k-animation-container"),i=e.options.height;e.ul[0].children.length&&t.add(n).show().height(e.ul[0].scrollHeight>i?i:"auto").hide()},_parse:function(e){var t=this,n=t.options,i=t._value||$;return e instanceof G?e:(e=h(e,n.parseFormats,n.culture),e&&(e=new G(i.getFullYear(),i.getMonth(),i.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds())),e)},_adjustListWidth:function(){var e,t,n=this.list,i=n[0].style.width,o=this.options.anchor,r=d._outerWidth;!n.data("width")&&i||(e=window.getComputedStyle?window.getComputedStyle(o[0],null):0,t=e?parseFloat(e.width):r(o),e&&(g.mozilla||g.msie)&&(t+=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight)+parseFloat(e.borderLeftWidth)+parseFloat(e.borderRightWidth)),i=t-(r(n)-n.width()),n.css({fontFamily:o.css("font-family"),width:i}).data("width",i))},_popup:function(){var e=this,t=e.list,n=e.options,i=n.anchor;e.popup=new v.Popup(t,j(n.popup,{anchor:i,open:n.open,close:n.close,animation:n.animation,isRtl:m.isRtl(n.anchor)}))},move:function(e){var n=this,i=e.keyCode,o=n.ul[0],r=n._current,s=i===u.DOWN;if(i===u.UP||s){if(e.altKey)return n.toggle(s),t;r=s?r?r[0].nextSibling:o.firstChild:r?r[0].previousSibling:o.lastChild,r&&n.select(r),n.options.change(n._current.text()),e.preventDefault()}else i!==u.ENTER&&i!==u.TAB&&i!==u.ESC||(e.preventDefault(),r&&n.options.change(r.text(),!0),n.close())}},l.getMilliseconds=o,d.TimeView=l,c=_.extend({init:function(t,n){var i,r,a,c,u,f,p=this;
_.fn.init.call(p,t,n),t=p.element,n=p.options,n.min=h(t.attr("min"))||h(n.min),n.max=h(t.attr("max"))||h(n.max),s(n),p._initialOptions=j({},n),p._wrapper(),p.timeView=r=new l(j({},n,{id:t.attr(U),anchor:p.wrapper,format:n.format,change:function(e,n){n?p._change(e):t.val(e)},open:function(e){p.timeView._adjustListWidth(),p.trigger(b)?e.preventDefault():(t.attr(H,!0),i.attr(N,!1))},close:function(e){p.trigger(w)?e.preventDefault():(t.attr(H,!1),i.attr(N,!0))},active:function(e){t.removeAttr(V),e&&t.attr(V,r._optionID)}})),i=r.ul,p._icon(),p._reset();try{t[0].setAttribute("type","text")}catch(m){t[0].type="text"}t.addClass("k-input").attr({role:"combobox","aria-expanded":!1,"aria-owns":r._timeViewID}),a=t.is("[disabled]")||e(p.element).parents("fieldset").is(":disabled"),a?p.enable(!1):p.readonly(t.is("[readonly]")),n.dateInput&&(c=n.min,u=n.max,f=new G,o(c)==o(u)?(c=new G(f.getFullYear(),f.getMonth(),f.getDate(),0,0,0),u=new G(f.getFullYear(),f.getMonth(),f.getDate(),24,0,0)):(c=new G(f.getFullYear(),f.getMonth(),f.getDate(),c.getHours(),c.getMinutes(),c.getSeconds(),c.getMilliseconds()),u=new G(f.getFullYear(),f.getMonth(),f.getDate(),u.getHours(),u.getMinutes(),u.getSeconds(),u.getMilliseconds())),p._dateInput=new v.DateInput(t,{culture:n.culture,format:n.format,min:c,max:u,value:n.value})),p._old=p._update(n.value||p.element.val()),p._oldText=t.val(),d.notify(p)},options:{name:"TimePicker",min:$,max:$,format:"",dates:[],parseFormats:[],value:null,interval:30,height:200,animation:{},dateInput:!1},events:[b,w,y],setOptions:function(e){var t=this,n=t._value;_.fn.setOptions.call(t,e),e=t.options,s(e),t.timeView.setOptions(e),n&&t.element.val(d.toString(n,e.format,e.culture))},dataBind:function(e){W(e)&&this.timeView.dataBind(e)},_editable:function(e){var t=this,n=e.disable,i=e.readonly,o=t._arrow.off(k),r=t.element.off(k),s=t._inputWrapper.off(k);i||n?(s.addClass(n?B:C).removeClass(n?C:B),r.attr(S,n).attr(T,i).attr(O,n)):(s.addClass(C).removeClass(B).on(M,t._toggleHover),r.removeAttr(S).removeAttr(T).attr(O,!1).on("keydown"+k,q(t._keydown,t)).on("focusout"+k,q(t._blur,t)).on("focus"+k,function(){t._inputWrapper.addClass(E)}),o.on(x,q(t._click,t)).on(R,a))},readonly:function(e){this._editable({readonly:e===t||e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t||e)})},destroy:function(){var e=this;_.fn.destroy.call(e),e.timeView.destroy(),e.element.off(k),e._arrow.off(k),e._inputWrapper.off(k),e._form&&e._form.off("reset",e._resetHandler)},close:function(){this.timeView.close()},open:function(){this.timeView.open()},min:function(e){return this._option("min",e)},max:function(e){return this._option("max",e)},value:function(e){var n=this;return e===t?n._value:(n._old=n._update(e),null===n._old&&n.element.val(""),n._oldText=n.element.val(),t)},_blur:function(){var e=this,t=e.element.val();e.close(),t!==e._oldText&&e._change(t),e._inputWrapper.removeClass(E)},_click:function(){var e=this,t=e.element;e.timeView.toggle(),m.touch||t[0]===f()||t.focus()},_change:function(e){var t=this;e=t._update(e),+t._old!=+e&&(t._old=e,t._oldText=t.element.val(),t._typing||t.element.trigger(y),t.trigger(y)),t._typing=!1},_icon:function(){var t,n=this,i=n.element;t=i.next("span.k-select"),t[0]||(t=e('<span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-clock"></span></span>').insertAfter(i)),n._arrow=t.attr({role:"button","aria-controls":n.timeView._timeViewID})},_keydown:function(e){var t=this,n=e.keyCode,i=t.timeView,o=t.element.val();i.popup.visible()||e.altKey?(i.move(e),t._dateInput&&e.stopImmediatePropagation&&e.stopImmediatePropagation()):n===u.ENTER&&o!==t._oldText?t._change(o):t._typing=!0},_option:function(e,n){var i=this,o=i.options;return n===t?o[e]:(n=i.timeView._parse(n),n&&(n=new G((+n)),o[e]=n,i.timeView.options[e]=n,i.timeView.bind()),t)},_toggleHover:function(t){e(t.currentTarget).toggleClass(I,"mouseenter"===t.type)},_update:function(e){var t,n=this,i=n.options,o=n.timeView,s=o._parse(e),a=n._value,l=null===s&&null===a||s instanceof Date&&a instanceof Date;return r(s,i.min,i.max)||(s=null),+s===+a&&l?(t=d.toString(s,i.format,i.culture),t!==e&&n.element.val(null===s?e:t),s):(n._value=s,n._dateInput&&s?n._dateInput.value(s||e):n.element.val(d.toString(s||e,i.format,i.culture)),o.value(s),s)},_wrapper:function(){var t,n=this,i=n.element;t=i.parents(".k-timepicker"),t[0]||(t=i.wrap(A).parent().addClass("k-picker-wrap k-state-default"),t=t.wrap(A).parent()),t[0].style.cssText=i[0].style.cssText,n.wrapper=t.addClass("k-widget k-timepicker k-header").addClass(i[0].className),i.css({width:"100%",height:i[0].style.height}),n._inputWrapper=e(t[0].firstChild)},_reset:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){t.value(n[0].defaultValue),t.max(t._initialOptions.max),t.min(t._initialOptions.min)},t._form=o.on("reset",t._resetHandler))}}),v.plugin(c)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.datetimepicker.min",["kendo.datepicker.min","kendo.timepicker.min"],e)}(function(){return function(e,t){function n(e){var t=new Date(2100,0,1);return t.setMinutes(-e),t}function i(e){e.preventDefault()}function o(t){var n,i=r.getCulture(t.culture).calendars.standard.patterns,o=!t.parseFormats.length;t.format=d(t.format||i.g),t.timeFormat=n=d(t.timeFormat||i.t),r.DateView.normalize(t),o&&t.parseFormats.unshift("yyyy-MM-ddTHH:mm:ss"),e.inArray(n,t.parseFormats)===-1&&t.parseFormats.push(n)}var r=window.kendo,s=r.TimeView,a=r.parseDate,l=r.support,c=r._activeElement,d=r._extractFormat,u=r.calendar,h=u.isInRange,f=u.restrictValue,p=u.isEqualDatePart,m=s.getMilliseconds,g=r.ui,v=g.Widget,_="open",b="close",w="change",y=".kendoDateTimePicker",k="click"+y,x=l.mouseAndTouchPresent?r.applyEventMap("up",y.slice(1)):k,C="disabled",S="readonly",T="k-state-default",D="k-state-focused",A="k-state-hover",E="k-state-disabled",I="mouseenter"+y+" mouseleave"+y,M="mousedown"+y,R="month",F="<span/>",z="aria-activedescendant",P="aria-expanded",B="aria-hidden",L="aria-owns",H="aria-disabled",N=Date,O=new N(1800,0,1),V=new N(2099,11,31),U={view:"date"},W={view:"time"},j=e.extend,q=v.extend({init:function(t,n){var i,s=this;v.fn.init.call(s,t,n),t=s.element,n=s.options,n.disableDates=r.calendar.disabled(n.disableDates),n.min=a(t.attr("min"))||a(n.min),n.max=a(t.attr("max"))||a(n.max),o(n),s._initialOptions=j({},n),s._wrapper(),s._views(),s._icons(),s._reset(),s._template();try{t[0].setAttribute("type","text")}catch(l){t[0].type="text"}t.addClass("k-input").attr({role:"combobox","aria-expanded":!1}),s._midnight=s._calculateMidnight(n.min,n.max),i=t.is("[disabled]")||e(s.element).parents("fieldset").is(":disabled"),i?s.enable(!1):s.readonly(t.is("[readonly]")),n.dateInput&&(s._dateInput=new g.DateInput(t,{culture:n.culture,format:n.format,min:n.min,max:n.max,value:n.value})),s._old=s._update(n.value||s.element.val()),s._oldText=t.val(),r.notify(s)},options:{name:"DateTimePicker",value:null,format:"",timeFormat:"",culture:"",parseFormats:[],dates:[],disableDates:null,min:new N(O),max:new N(V),interval:30,height:200,footer:"",start:R,depth:R,animation:{},month:{},ARIATemplate:'Current focused date is #=kendo.toString(data.current, "d")#',dateButtonText:"Open the date view",timeButtonText:"Open the time view",dateInput:!1,weekNumber:!1},events:[_,b,w],setOptions:function(e){var t,n,i,s=this,l=s._value;v.fn.setOptions.call(s,e),e=s.options,e.min=t=a(e.min),e.max=n=a(e.max),o(e),s._midnight=s._calculateMidnight(e.min,e.max),i=e.value||s._value||s.dateView._current,t&&!p(t,i)&&(t=new N(O)),n&&!p(n,i)&&(n=new N(V)),s.dateView.setOptions(e),s.timeView.setOptions(j({},e,{format:e.timeFormat,min:t,max:n})),l&&(s.element.val(r.toString(l,e.format,e.culture)),s._updateARIA(l))},_editable:function(t){var n=this,o=n.element.off(y),r=n._dateIcon.off(y),s=n._timeIcon.off(y),a=n._inputWrapper.off(y),l=t.readonly,c=t.disable;l||c?(a.addClass(c?E:T).removeClass(c?T:E),o.attr(C,c).attr(S,l).attr(H,c)):(a.addClass(T).removeClass(E).on(I,n._toggleHover),o.removeAttr(C).removeAttr(S).attr(H,!1).on("keydown"+y,e.proxy(n._keydown,n)).on("focus"+y,function(){n._inputWrapper.addClass(D)}).on("focusout"+y,function(){n._inputWrapper.removeClass(D),o.val()!==n._oldText&&n._change(o.val()),n.close("date"),n.close("time")}),r.on(M,i).on(x,function(e){n.toggle("date"),n._focusElement(e.type)}),s.on(M,i).on(x,function(e){n.toggle("time"),n._focusElement(e.type)}))},_focusElement:function(e){var t=this.element;l.touch&&(!l.mouseAndTouchPresent||(e||"").match(/touch/i))||t[0]===c()||t.focus()},readonly:function(e){this._editable({readonly:e===t||e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t||e)})},destroy:function(){var e=this;v.fn.destroy.call(e),e.dateView.destroy(),e.timeView.destroy(),e.element.off(y),e._dateIcon.off(y),e._timeIcon.off(y),e._inputWrapper.off(y),e._form&&e._form.off("reset",e._resetHandler)},close:function(e){"time"!==e&&(e="date"),this[e+"View"].close()},open:function(e){"time"!==e&&(e="date"),this[e+"View"].open()},min:function(e){return this._option("min",e)},max:function(e){return this._option("max",e)},toggle:function(e){var t="timeView";"time"!==e?e="date":t="dateView",this[e+"View"].toggle(),this[t].close()},value:function(e){var n=this;return e===t?n._value:(n._old=n._update(e),null===n._old&&n.element.val(""),n._oldText=n.element.val(),t)},_change:function(e){var t,n,i,o=this,r=o.element.val();e=o._update(e),t=+o._old!=+e,n=t&&!o._typing,i=r!==o.element.val(),(n||i)&&o.element.trigger(w),t&&(o._old=e,o._oldText=o.element.val(),o.trigger(w)),o._typing=!1},_option:function(e,i){var o,r,s=this,l=s.options,c=s.timeView,d=c.options,u=s._value||s._old;if(i===t)return l[e];if(i=a(i,l.parseFormats,l.culture)){if(l.min.getTime()===l.max.getTime()&&(d.dates=[]),l[e]=new N(i.getTime()),s.dateView[e](i),s._midnight=s._calculateMidnight(l.min,l.max),u&&(o=p(l.min,u),r=p(l.max,u)),o||r){if(d[e]=i,o&&!r&&(d.max=n(l.interval)),r){if(s._midnight)return c.dataBind([V]),t;o||(d.min=O)}}else d.max=V,d.min=O;c.bind()}},_toggleHover:function(t){e(t.currentTarget).toggleClass(A,"mouseenter"===t.type)},_update:function(t){var i,o,s,l,c,d=this,u=d.options,m=u.min,g=u.max,v=u.dates,_=d.timeView,b=d._value,y=a(t,u.parseFormats,u.culture),k=null===y&&null===b||y instanceof Date&&b instanceof Date;return u.disableDates&&u.disableDates(y)&&(y=null,d._old||d.element.val()||(t=null)),+y===+b&&k?(c=r.toString(y,u.format,u.culture),c!==t&&(d.element.val(null===y?t:c),t instanceof String&&d.element.trigger(w)),y):(null!==y&&p(y,m)?y=f(y,m,g):h(y,m,g)||(y=null),d._value=y,_.value(y),d.dateView.value(y),y&&(s=d._old,o=_.options,v[0]&&(v=e.grep(v,function(e){return p(y,e)}),v[0]&&(_.dataBind(v),l=!0)),l||(p(y,m)&&(o.min=m,o.max=n(u.interval),i=!0),p(y,g)&&(d._midnight?(_.dataBind([V]),l=!0):(o.max=g,i||(o.min=O),i=!0))),!l&&(!s&&i||s&&!p(s,y))&&(i||(o.max=V,o.min=O),_.bind())),d._dateInput&&y?d._dateInput.value(y||t):d.element.val(r.toString(y||t,u.format,u.culture)),d._updateARIA(y),y)},_keydown:function(e){var t=this,n=t.dateView,i=t.timeView,o=t.element.val(),s=n.popup.visible(),a=t._dateInput&&e.stopImmediatePropagation;e.altKey&&e.keyCode===r.keys.DOWN?t.toggle(s?"time":"date"):s?(n.move(e),t._updateARIA(n._current)):i.popup.visible()?i.move(e):e.keyCode===r.keys.ENTER&&o!==t._oldText?t._change(o):(t._typing=!0,a=!1),a&&e.stopImmediatePropagation()},_views:function(){var e,t,n,i,o,l,c=this,d=c.element,u=c.options,f=d.attr("id");c.dateView=e=new r.DateView(j({},u,{id:f,anchor:c.wrapper,change:function(){var t,n,i=e.calendar.value(),o=+i,s=+u.min,a=+u.max;o!==s&&o!==a||(t=o===s?s:a,t=new N(c._value||t),t.setFullYear(i.getFullYear(),i.getMonth(),i.getDate()),h(t,s,a)&&(i=t)),c._value&&(n=r.date.setHours(new Date(i),c._value),h(n,s,a)&&(i=n)),c._change(i),c.close("date")},close:function(e){c.trigger(b,U)?e.preventDefault():(d.attr(P,!1),n.attr(B,!0),t.popup.visible()||d.removeAttr(L))},open:function(t){c.trigger(_,U)?t.preventDefault():(d.val()!==c._oldText&&(l=a(d.val(),u.parseFormats,u.culture),c.dateView[l?"current":"value"](l)),n.attr(B,!1),d.attr(P,!0).attr(L,e._dateViewID),c._updateARIA(l))}})),n=e.div,o=u.min.getTime(),c.timeView=t=new s({id:f,value:u.value,anchor:c.wrapper,animation:u.animation,format:u.timeFormat,culture:u.culture,height:u.height,interval:u.interval,min:new N(O),max:new N(V),dates:o===u.max.getTime()?[new Date(o)]:[],parseFormats:u.parseFormats,change:function(n,i){n=t._parse(n),n<u.min?(n=new N((+u.min)),t.options.min=n):n>u.max&&(n=new N((+u.max)),t.options.max=n),i?(c._timeSelected=!0,c._change(n)):(d.val(r.toString(n,u.format,u.culture)),e.value(n),c._updateARIA(n))},close:function(t){c.trigger(b,W)?t.preventDefault():(i.attr(B,!0),d.attr(P,!1),e.popup.visible()||d.removeAttr(L))},open:function(e){t._adjustListWidth(),c.trigger(_,W)?e.preventDefault():(d.val()!==c._oldText&&(l=a(d.val(),u.parseFormats,u.culture),c.timeView.value(l)),i.attr(B,!1),d.attr(P,!0).attr(L,t._timeViewID),t.options.active(t.current()))},active:function(e){d.removeAttr(z),e&&d.attr(z,t._optionID)}}),i=t.ul},_icons:function(){var t=this,n=t.element,i=t.options,o=n.next("span.k-select");o[0]||(o=e('<span unselectable="on" class="k-select"><span class="k-link k-link-date" aria-label="'+i.dateButtonText+'"><span unselectable="on" class="k-icon k-i-calendar"></span></span><span class="k-link k-link-time" aria-label="'+i.timeButtonText+'"><span unselectable="on" class="k-icon k-i-clock"></span></span></span>').insertAfter(n)),o=o.children(),o=o.children(),t._dateIcon=o.eq(0).attr("aria-controls",t.dateView._dateViewID),t._timeIcon=o.eq(1).attr("aria-controls",t.timeView._timeViewID)},_wrapper:function(){var t,n=this,i=n.element;t=i.parents(".k-datetimepicker"),t[0]||(t=i.wrap(F).parent().addClass("k-picker-wrap k-state-default"),t=t.wrap(F).parent()),t[0].style.cssText=i[0].style.cssText,i.css({width:"100%",height:i[0].style.height}),n.wrapper=t.addClass("k-widget k-datetimepicker k-header").addClass(i[0].className),n._inputWrapper=e(t[0].firstChild)},_reset:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){t.value(n[0].defaultValue),t.max(t._initialOptions.max),t.min(t._initialOptions.min)},t._form=o.on("reset",t._resetHandler))},_template:function(){this._ariaTemplate=r.template(this.options.ARIATemplate)},_calculateMidnight:function(e,t){return m(e)+m(t)===0},_updateARIA:function(e){var t,n=this,i=n.dateView.calendar;n.element.removeAttr(z),i&&(t=i._cell,t.attr("aria-label",n._ariaTemplate({current:e||i.current()})),n.element.attr(z,t.attr("id")))}});g.plugin(q)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.splitter.min",["kendo.resizable.min"],e)}(function(){return function(e,t){function n(e){return v.test(e)}function i(e){return g.test(e)||/^\d+$/.test(e)}function o(e){return!n(e)&&!i(e)}function r(e,t){var i=parseInt(e,10);return n(e)&&(i=Math.floor(i*t/100)),i}function s(e,n){return function(i,o){var r,s=this.element.find(i).data(E);return 1==arguments.length?s[e]:(s[e]=o,n&&(r=this.element.data("kendo"+this.options.name),r.resize(!0)),t)}}function a(e){var t=this,n=e.orientation;t.owner=e,t._element=e.element,t.orientation=n,f(t,n===S?c:l),t._resizable=new d.ui.Resizable(e.element,{orientation:n,handle:".k-splitbar-draggable-"+n+"[data-marker="+e._marker+"]",hint:p(t._createHint,t),start:p(t._start,t),max:p(t._max,t),min:p(t._min,t),invalidClass:"k-restricted-size-"+n,resizeend:p(t._stop,t)})}var l,c,d=window.kendo,u=d.ui,h=d.keys,f=e.extend,p=e.proxy,m=u.Widget,g=/^\d+(\.\d+)?px$/i,v=/^\d+(\.\d+)?%$/i,_=".kendoSplitter",b="expand",w="collapse",y="contentLoad",k="error",x="resize",C="layoutChange",S="horizontal",T="vertical",D="mouseenter",A="click",E="pane",I="mouseleave",M="k-state-focused",R="k-"+E,F="."+R,z=m.extend({init:function(e,t){var n,i=this;m.fn.init.call(i,e,t),i.wrapper=i.element,i.options.orientation&&(n=i.options.orientation.toLowerCase()!=T),i.orientation=n?S:T,i._dimension=n?"width":"height",i._keys={decrease:n?h.LEFT:h.UP,increase:n?h.RIGHT:h.DOWN},i._resizeStep=10,i._marker=d.guid().substring(0,8),i._initPanes(),i.resizing=new a(i),i.element.triggerHandler("init"+_)},events:[b,w,y,k,x,C],_addOverlays:function(){this._panes().append("<div class='k-splitter-overlay k-overlay' />")},_removeOverlays:function(){this._panes().children(".k-splitter-overlay").remove()},_attachEvents:function(){var t=this,n=t.options.orientation;t.element.children(".k-splitbar-draggable-"+n).on("keydown"+_,p(t._keydown,t)).on("mousedown"+_,function(e){e.currentTarget.focus()}).on("focus"+_,function(t){e(t.currentTarget).addClass(M)}).on("blur"+_,function(n){e(n.currentTarget).removeClass(M),t.resizing&&t.resizing.end()}).on(D+_,function(){e(this).addClass("k-splitbar-"+t.orientation+"-hover")}).on(I+_,function(){e(this).removeClass("k-splitbar-"+t.orientation+"-hover")}).on("mousedown"+_,p(t._addOverlays,t)).end().children(".k-splitbar").on("dblclick"+_,p(t._togglePane,t)).children(".k-collapse-next, .k-collapse-prev").on(A+_,t._arrowClick(w)).end().children(".k-expand-next, .k-expand-prev").on(A+_,t._arrowClick(b)).end().end(),e(window).on("resize"+_+t._marker,p(t.resize,t,!1)),e(document).on("mouseup"+_+t._marker,p(t._removeOverlays,t))},_detachEvents:function(){var t=this;t.element.children(".k-splitbar-draggable-"+t.orientation).off(_).end().children(".k-splitbar").off("dblclick"+_).children(".k-collapse-next, .k-collapse-prev, .k-expand-next, .k-expand-prev").off(_),e(window).off(_+t._marker),e(document).off(_+t._marker)},options:{name:"Splitter",orientation:S,panes:[]},destroy:function(){m.fn.destroy.call(this),this._detachEvents(),this.resizing&&this.resizing.destroy(),d.destroy(this.element),this.wrapper=this.element=null},_keydown:function(t){var n,i=this,o=t.keyCode,r=i.resizing,s=e(t.currentTarget),a=i._keys,l=o===a.increase,c=o===a.decrease;l||c?(t.ctrlKey?(n=s[c?"next":"prev"](),r&&r.isResizing()&&r.end(),n[i._dimension]()?i._triggerAction(w,s[c?"prev":"next"]()):i._triggerAction(b,n)):r&&r.move((c?-1:1)*i._resizeStep,s),t.preventDefault()):o===h.HOME?(r.move(-r._maxPosition,s),t.preventDefault()):o===h.END?(r.move(r._maxPosition,s),t.preventDefault()):o===h.ENTER&&r&&(r.end(),t.preventDefault())},_initPanes:function(){var e=this.options.panes||[],t=this;this.element.addClass("k-widget").addClass("k-splitter").children().each(function(n,i){"script"!=i.nodeName.toLowerCase()&&t._initPane(i,e[n])}),this.resize()},_initPane:function(t,n){t=e(t).attr("role","group").addClass(R),t.data(E,n?n:{}).toggleClass("k-scrollable",!n||n.scrollable!==!1),this.ajaxRequest(t)},ajaxRequest:function(e,t,n){var i,o=this;e=o.element.find(e),i=e.data(E),t=t||i.contentUrl,t&&(e.append("<span class='k-icon k-i-loading k-pane-loading' />"),d.isLocalUrl(t)?jQuery.ajax({url:t,data:n||{},type:"GET",dataType:"html",success:function(t){o.angular("cleanup",function(){return{elements:e.get()}}),e.html(t),o.angular("compile",function(){return{elements:e.get()}}),o.trigger(y,{pane:e[0]})},error:function(t,n){o.trigger(k,{pane:e[0],status:n,xhr:t})}}):e.removeClass("k-scrollable").html("<iframe src='"+t+"' frameborder='0' class='k-content-frame'>This page requires frames in order to show content</iframe>"))},_triggerAction:function(e,t){this.trigger(e,{pane:t[0]})||this[e](t[0])},_togglePane:function(t){var n,i=this,o=e(t.target);o.closest(".k-splitter")[0]==i.element[0]&&(n=o.children(".k-icon:not(.k-resize-handle)"),1===n.length&&(n.is(".k-collapse-prev")?i._triggerAction(w,o.prev()):n.is(".k-collapse-next")?i._triggerAction(w,o.next()):n.is(".k-expand-prev")?i._triggerAction(b,o.prev()):n.is(".k-expand-next")&&i._triggerAction(b,o.next())))},_arrowClick:function(t){var n=this;return function(i){var o,r=e(i.target);r.closest(".k-splitter")[0]==n.element[0]&&(o=r.is(".k-"+t+"-prev")?r.parent().prev():r.parent().next(),n._triggerAction(t,o))}},_updateSplitBar:function(e,t,n){var i=function(e,t){return t?"<div class='k-icon "+e+"' />":""},o=this.orientation,r=t.resizable!==!1&&n.resizable!==!1,s=t.collapsible,a=t.collapsed,l=n.collapsible,c=n.collapsed;e.addClass("k-splitbar k-state-default k-splitbar-"+o).attr("role","separator").attr("aria-expanded",!(a||c)).removeClass("k-splitbar-"+o+"-hover").toggleClass("k-splitbar-draggable-"+o,r&&!a&&!c).toggleClass("k-splitbar-static-"+o,!r&&!s&&!l).html(i("k-collapse-prev k-i-arrow-60-up",s&&!a&&!c&&o==T)+i("k-collapse-prev k-i-arrow-60-left",s&&!a&&!c&&o==S)+i("k-expand-prev k-i-arrow-60-down",s&&a&&!c&&o==T)+i("k-expand-prev k-i-arrow-60-right",s&&a&&!c&&o==S)+i("k-resize-handle k-i-hbar",r&&o==T)+i("k-resize-handle k-i-vbar",r&&o==S)+i("k-collapse-next k-i-arrow-60-down",l&&!c&&!a&&o==T)+i("k-collapse-next k-i-arrow-60-right",l&&!c&&!a&&o==S)+i("k-expand-next k-i-arrow-60-up",l&&c&&!a&&o==T)+i("k-expand-next k-i-arrow-60-left",l&&c&&!a&&o==S)),r||s||l||e.removeAttr("tabindex")},_updateSplitBars:function(){var t=this;this.element.children(".k-splitbar").each(function(){var n=e(this),i=n.prevAll(F).first().data(E),o=n.nextAll(F).first().data(E);o&&t._updateSplitBar(n,i,o)})},_removeSplitBars:function(){this.element.children(".k-splitbar").remove()},_panes:function(){return this.element?this.element.children(F):e()},_resize:function(){var n,i,s,a,l,c,u,h,f,p,m=this,g=m.element,v=g.children(F),_=m.orientation==S,b=g.children(".k-splitbar"),w=b.length,y=_?"width":"height",k=g[y]();m.wrapper.addClass("k-splitter-resizing"),0===w?(w=v.length-1,v.slice(0,w).after("<div tabindex='0' class='k-splitbar' data-marker='"+m._marker+"' />"),m._updateSplitBars(),b=g.children(".k-splitbar")):m._updateSplitBars(),b.each(function(){k-=this[_?"offsetWidth":"offsetHeight"]}),n=0,i=0,s=e(),v.css({position:"absolute",top:0})[y](function(){var a,l=e(this),c=l.data(E)||{};if(l.removeClass("k-state-collapsed"),c.collapsed)a=c.collapsedSize?r(c.collapsedSize,k):0,l.css("overflow","hidden").addClass("k-state-collapsed");else{if(o(c.size))return s=s.add(this),t;a=r(c.size,k)}return i++,n+=a,a}),k-=n,a=s.length,l=Math.floor(k/a),s.slice(0,a-1).css(y,l).end().eq(a-1).css(y,k-(a-1)*l),c=0,u=_?"height":"width",h=_?"left":"top",f=_?"offsetWidth":"offsetHeight",0===a&&(p=v.filter(function(){return!(e(this).data(E)||{}).collapsed}).last(),p[y](k+p[0][f])),g.children().css(u,g[u]()).each(function(e,t){"script"!=t.tagName.toLowerCase()&&(t.style[h]=Math.floor(c)+"px",c+=t[f])}),m._detachEvents(),m._attachEvents(),m.wrapper.removeClass("k-splitter-resizing"),d.resize(v),m.trigger(C)},toggle:function(e,n){var i,o=this;e=o.element.find(e),i=e.data(E),(n||i.collapsible)&&(1==arguments.length&&(n=i.collapsed!==t&&i.collapsed),i.collapsed=!n,i.collapsed?e.css("overflow","hidden"):e.css("overflow",""),o.resize(!0))},collapse:function(e){this.toggle(e,!1)},expand:function(e){this.toggle(e,!0)},_addPane:function(e,t,n){var i=this;return n.length&&(i.options.panes.splice(t,0,e),i._initPane(n,e),i._removeSplitBars(),i.resize(!0)),n},append:function(t){t=t||{};var n=this,i=e("<div />").appendTo(n.element);return n._addPane(t,n.options.panes.length,i)},insertBefore:function(t,n){n=e(n),t=t||{};var i=this,o=i.wrapper.children(".k-pane").index(n),r=e("<div />").insertBefore(e(n));return i._addPane(t,o,r)},insertAfter:function(t,n){n=e(n),t=t||{};var i=this,o=i.wrapper.children(".k-pane").index(n),r=e("<div />").insertAfter(e(n));return i._addPane(t,o+1,r)},remove:function(t){t=e(t);var n=this;return t.length&&(d.destroy(t),t.each(function(t,i){n.options.panes.splice(n.wrapper.children(".k-pane").index(i),1),e(i).remove()}),n._removeSplitBars(),n.options.panes.length&&n.resize(!0)),n},size:s("size",!0),min:s("min"),max:s("max")});u.plugin(z),l={sizingProperty:"height",sizingDomProperty:"offsetHeight",alternateSizingProperty:"width",positioningProperty:"top",mousePositioningProperty:"pageY"},c={sizingProperty:"width",sizingDomProperty:"offsetWidth",alternateSizingProperty:"height",positioningProperty:"left",mousePositioningProperty:"pageX"},a.prototype={press:function(e){this._resizable.press(e)},move:function(e,t){this.pressed||(this.press(t),this.pressed=!0),this._resizable.target||this._resizable.press(t),this._resizable.move(e)},end:function(){this._resizable.end(),this.pressed=!1},destroy:function(){this._resizable.destroy(),this._resizable=this._element=this.owner=null},isResizing:function(){return this._resizable.resizing},_createHint:function(t){var n=this;return e("<div class='k-ghost-splitbar k-ghost-splitbar-"+n.orientation+" k-state-default' />").css(n.alternateSizingProperty,t[n.alternateSizingProperty]())},_start:function(t){var n=this,o=e(t.currentTarget),r=o.prev(),s=o.next(),a=r.data(E),l=s.data(E),c=parseInt(r[0].style[n.positioningProperty],10),d=parseInt(s[0].style[n.positioningProperty],10)+s[0][n.sizingDomProperty]-o[0][n.sizingDomProperty],u=parseInt(n._element.css(n.sizingProperty),10),h=function(e){var t=parseInt(e,10);return(i(e)?t:u*t/100)||0},f=h(a.min),p=h(a.max)||d-c,m=h(l.min),g=h(l.max)||d-c;n.previousPane=r,n.nextPane=s,n._maxPosition=Math.min(d-m,c+p),n._minPosition=Math.max(c+f,d-g)},_max:function(){return this._maxPosition},_min:function(){return this._minPosition},_stop:function(t){var n,i,r,s,a,l,c,u,h=this,f=e(t.currentTarget),p=h.owner;return p._panes().children(".k-splitter-overlay").remove(),t.keyCode!==d.keys.ESC&&(n=t.position,i=f.prev(),r=f.next(),s=i.data(E),a=r.data(E),l=n-parseInt(i[0].style[h.positioningProperty],10),c=parseInt(r[0].style[h.positioningProperty],10)+r[0][h.sizingDomProperty]-n-f[0][h.sizingDomProperty],u=h._element.children(F).filter(function(){return o(e(this).data(E).size)}).length,(!o(s.size)||u>1)&&(o(s.size)&&u--,s.size=l+"px"),(!o(a.size)||u>1)&&(a.size=c+"px"),p.resize(!0)),!1}}}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dialog.min",["kendo.core.min","kendo.popup.min"],e)}(function(){return function(e,t){function n(e){return t!==e}function i(e,t,n){return Math.max(Math.min(parseInt(e,10),n===1/0?n:parseInt(n,10)),parseInt(t,10))}function o(e){return e.keyCode==_.ENTER||e.keyCode==_.SPACEBAR}var r,s,a,l,c,d,u,h,f=window.kendo,p=f.ui.Widget,m=f.ui.Popup.TabKeyTrap,g=e.proxy,v=f.template,_=f.keys,b=e.isFunction,w="kendoWindow",y=".k-dialog",k=".k-window",x=".k-dialog-close",C="k-content k-window-content k-dialog-content",S=".k-content",T="k-dialog-titleless",D=".k-dialog-title",A=D+"bar",E=".k-dialog-buttongroup",I=".k-button",M="k-alert",R="k-confirm",F="k-prompt",z=".k-textbox",P=".k-overlay",B=":visible",L="zIndex",H="body",N="initOpen",O="open",V="close",U="show",W="hide",j="width",q=100,G={okText:"OK",cancel:"Cancel",promptInput:"Input"},$=Math.ceil,K=":not(link,meta,script,style)",Y=p.extend({init:function(e,t){var n=this;p.fn.init.call(n,e,t),n._init(n.element,n.options),f.notify(n)},_init:function(i,o){var s,a=this;a._centerCallback=g(a._center,a),a.appendTo=e(H),n(o.visible)&&null!==o.visible||(o.visible=i.is(B)),a.wrapperTemplate===t&&(a.wrapperTemplate=r.wrapper),a._createDialog(),s=a.wrapper=i.closest(y),o._defaultFocus===t&&(a._defaultFocus=i[0]),a._tabindex(i),a._dimensions(),this._tabKeyTrap=new m(s),a.options.visible?(a.toFront(),a._triggerInitOpen(),a.trigger(O),o.modal&&(a._overlay(s.is(B)).css({opacity:.5}),a._focusDialog())):a.wrapper.hide(),o.closable&&(s.autoApplyNS(w),i.autoApplyNS(w),s.find(x).on("click",g(a._closeClick,a)).on("keydown",g(a._closeKeyHandler,a)),i.on("keydown",g(a._keydown,a)))},_dimensions:function(){var e,t,n=this,o=n.wrapper,r=n.options,s=r.width,a=r.height,l=["minWidth","minHeight","maxWidth","maxHeight"];for(e=0;e<l.length;e++)t=r[l[e]],t&&t!=1/0&&o.css(l[e],t);this._setElementMaxHeight(),s&&((""+s).indexOf("%")>0?o.width(s):o.outerWidth(i(s,r.minWidth,r.maxWidth))),a&&((""+a).indexOf("%")>0?o.height(a):o.outerHeight(i(a,r.minHeight,r.maxHeight)),this._setElementHeight())},_setElementMaxHeight:function(){var e,t,n=this,i=n.element,o=n.options.maxHeight;o!=1/0&&(e=n._paddingBox(i),t=parseFloat(o,10)-n._uiHeight()-e.vertical,t>0&&i.css({maxHeight:$(t)+"px"}))},_paddingBox:function(e){var t=parseFloat(e.css("padding-top"),10),n=parseFloat(e.css("padding-left"),10),i=parseFloat(e.css("padding-bottom"),10),o=parseFloat(e.css("padding-right"),10);return{vertical:t+i,horizontal:n+o}},_setElementHeight:function(){var e=this,t=e.element,n=e.options.height,i=e._paddingBox(t),o=parseFloat(n,10)-e._uiHeight()-i.vertical;o<0&&(o=0),e.element.css({height:$(o)+"px"})},_uiHeight:function(){var e=this,t=e.wrapper,n=t.children(E),i=n[0]&&n[0].offsetHeight||0,o=t.children(A),r=o[0]&&o[0].offsetHeight||0;return i+r},_overlay:function(t){var n=this.appendTo.children(P),i=this.wrapper;return n.length||(n=e(r.overlay)),n.insertBefore(i[0]).toggle(t).css(L,parseInt(i.css(L),10)-1),t?this._waiAriaOverlay():this._removeWaiAriaOverlay(),n},_waiAriaOverlay:function(){var t=this.wrapper;this._overlayedNodes=t.prevAll(K).add(t.nextAll(K)).each(function(){var t=e(this);t.data("ariaHidden",t.attr("aria-hidden")),t.attr("aria-hidden","true")})},_removeWaiAriaOverlay:function(){return this._overlayedNodes&&this._overlayedNodes.each(function(){var t=e(this),n=t.data("ariaHidden");n?t.attr("aria-hidden",n):t.removeAttr("aria-hidden")})},_closeClick:function(e){e.preventDefault(),this.close()},_closeKeyHandler:function(e){(o(e)||e.keyCode==_.ESC)&&this.close()},_keydown:function(e){var t=this,n=t.options,i=e.keyCode;i==_.ESC&&!t._closing&&n.closable&&t.close()},_createDialog:function(){var t=this,n=t.element,i=t.options,o=f.support.isRtl(n),s=e(r.titlebar(i)),a=s.find(".k-window-actions"),l=(n.id||f.guid())+"_title",c=e(t.wrapperTemplate(i));c.toggleClass("k-rtl",o),n.addClass(C),t.appendTo.append(c),i.closable!==!1&&(i.title!==!1?a.append(r.close(i)):c.append(r.close(i))),i.title!==!1?(c.append(s),s.attr("id",l),c.attr("aria-labelledby",l)):c.addClass(T),c.append(n),i.content&&(f.destroy(n.children()),n.html(i.content)),i.actions.length&&t._createActionbar(c)},_createActionbar:function(t){var n="stretched"===this.options.buttonLayout,i=n?"stretched":"normal",o=e(r.actionbar({buttonLayout:i}));this._addButtons(o),n&&this._normalizeButtonSize(o),t.append(o)},_addButtons:function(t){var n,i,o,s,a=this,l=a.options,c=g(a._actionClick,a),d=g(a._actionKeyHandler,a),u=a.options.actions,h=u.length,f=Math.round(q/h);for(o=0;o<h;o++)n=u[o],i=a._mergeTextWithOptions(n),s=e(r.action(n)).autoApplyNS(w).html(i).appendTo(t).data("action",n.action).on("click",c).on("keydown",d),"stretched"===l.buttonLayout&&(o==h-1&&(f=q-o*f),s.css(j,f+"%"))},_mergeTextWithOptions:function(e){var t=e.text;return t?v(t)(this.options):""},_normalizeButtonSize:function(e){var t=this,n=t.options,i=e.children(I+":last"),o=parseFloat(i[0].style[j]),r=q-n.actions.length*o;r>0&&i.css(j,o+r+"%")},_tabindex:function(e){var t,n=this,i=n.wrapper,o=i.find(x),r=i.find(E+" "+I);p.fn._tabindex.call(this,e),t=e.attr("tabindex"),o.attr("tabIndex",t),r.attr("tabIndex",t)},_actionClick:function(e){this._runActionBtn(e.currentTarget)},_actionKeyHandler:function(e){o(e)?this._runActionBtn(e.currentTarget):e.keyCode==_.ESC&&this.close()},_runActionBtn:function(t){var n,i,o=this;o._closing||(n=e(t).data("action"),i=b(n)&&n({sender:o})===!1,i||o.close())},open:function(){var e,t,n,i=this,o=i.wrapper,r=this._animationOptions(O),s=i.options;return this._triggerInitOpen(),i.trigger(O)||(i._closing&&o.kendoStop(!0,!0),i._closing=!1,i.toFront(),s.visible=!0,s.modal&&(t=!!i._modals().length,e=i._overlay(t),e.kendoStop(!0,!0),r.duration&&f.effects.Fade&&!t?(n=f.fx(e).fadeIn(),n.duration(r.duration||0),n.endValue(.5),n.play()):e.css("opacity",.5),e.show()),o.show().kendoStop().kendoAnimate({effects:r.effects,duration:r.duration,complete:g(i._openAnimationEnd,i)}),o.show()),i},_animationOptions:function(e){var t=this.options.animation,n={
open:{effects:{}},close:{hide:!0,effects:{}}};return t&&t[e]||n[e]},_openAnimationEnd:function(){this.options.modal&&this._focusDialog(),this.trigger(U)},_triggerInitOpen:function(){n(this._initOpenTriggered)||(this._initOpenTriggered=!0,this.trigger(N))},toFront:function(){var t=this,n=t.wrapper,i=+n.css(L),o=i;return t.center(),e(k).each(function(t,n){var o=e(n),r=o.css(L);isNaN(r)||(i=Math.max(+r,i))}),(!n[0].style.zIndex||o<i)&&n.css(L,i+2),t.element.find("> .k-overlay").remove(),n=null,t},close:function(){return this._close(!0),this._stopCenterOnResize(),this},_close:function(e){var t=this,n=t.wrapper,i=t.options,o=this._animationOptions("open"),r=this._animationOptions("close");if(n.is(B)&&!t.trigger(V,{userTriggered:!e})){if(t._closing)return;t._closing=!0,i.visible=!1,this._removeOverlay(),n.kendoStop().kendoAnimate({effects:r.effects||o.effects,reverse:r.reverse===!0,duration:r.duration,complete:g(this._closeAnimationEnd,this)})}return t},center:function(){this._center(),this._centerOnResize()},_center:function(){var t=this,n=t.wrapper,i=e(window),o=0,r=0,s=r+Math.max(0,(i.width()-n.width())/2),a=o+Math.max(0,(i.height()-n.height()-parseInt(n.css("paddingTop"),10))/2);return n.css({left:s,top:a}),t},_centerOnResize:function(){this._trackResize||(f.onResize(this._centerCallback),this._trackResize=!0)},_stopCenterOnResize:function(){f.unbindResize(this._centerCallback),this._trackResize=!1},_removeOverlay:function(){var e=this._modals(),t=this.options,n=t.modal&&!e.length;n?this._overlay(!1).remove():e.length&&this._object(e.last())._overlay(!0)},_closeAnimationEnd:function(){var e,t=this;t._closing=!1,t.wrapper.hide().css("opacity",""),t.trigger(W),t.options.modal&&(e=t._object(t._modals().last()),e&&e.toFront())},_modals:function(){var t=this,n=e(k).filter(function(){var n=e(this),i=t._object(n),o=i&&i.options;return o&&o.modal&&t.options.appendTo==o.appendTo&&o.visible&&n.is(B)}).sort(function(t,n){return+e(t).css("zIndex")-+e(n).css("zIndex")});return t=null,n},_object:function(e){var n=e.children(S),i=f.widgetInstance(n);return i?i:t},destroy:function(){var t=this;t._destroy(),p.fn.destroy.call(t),t.wrapper.remove(),t.wrapper=t.element=e()},_destroy:function(){var e=this,t="."+w;e.wrapper.off(t),e.element.off(t),e.wrapper.find(x+","+E+" > "+I).off(t),e._stopCenterOnResize()},title:function(t){var n=this,i=n.wrapper,o=n.options,s=i.children(A),a=s.children(D),l=f.htmlEncode(t);return arguments.length?(t===!1?(s.remove(),i.addClass(T)):(s.length||(s=e(r.titlebar(o)).prependTo(i),a=s.children(D),i.removeClass(T)),a.html(l)),n.options.title=l,n):a.html()},content:function(e,t){var i=this,o=i.wrapper.children(S);return n(e)?(this.angular("cleanup",function(){return{elements:o.children()}}),f.destroy(o.children()),o.html(e),this.angular("compile",function(){var e,n=[];for(e=o.length;--e>=0;)n.push({dataItem:t});return{elements:o.children(),data:n}}),i.options.content=e,i):o.html()},_focusDialog:function(){this._defaultFocus&&this._focus(this._defaultFocus),this._tabKeyTrap.trap()},_focus:function(e){e&&e.focus()},events:[N,O,V,U,W],options:{title:"",buttonLayout:"stretched",actions:[],modal:!0,width:null,height:null,minWidth:0,minHeight:0,maxWidth:1/0,maxHeight:1/0,content:null,visible:null,appendTo:H,closable:!0}}),Q=Y.extend({options:{name:"Dialog",messages:{close:"Close"}}});f.ui.plugin(Q),s=Y.extend({_init:function(e,t){var n=this;n.wrapperTemplate=r.alertWrapper,t._defaultFocus=null,n._ensureContentId(e),Y.fn._init.call(n,e,t),n.bind(W,g(n.destroy,n)),n._ariaDescribedBy(),n._initFocus()},_ensureContentId:function(t){var n=e(t);n.attr("id")||n.attr("id",f.guid()+"_k-popup")},_ariaDescribedBy:function(){this.wrapper.attr("aria-describedby",this.element.attr("id"))},_initFocus:function(){var e=this.options;this._defaultFocus=this._chooseEntryFocus(),this._defaultFocus&&e.visible&&e.modal&&this._focusDialog()},_chooseEntryFocus:function(){return this.wrapper.find(E+" > "+I)[0]},options:{title:window.location.host,closable:!1,messages:G}}),a=s.extend({_init:function(e,t){var n=this;s.fn._init.call(n,e,t),n.wrapper.addClass(M)},options:{name:"Alert",modal:!0,actions:[{text:"#: messages.okText #"}]}}),f.ui.plugin(a),l=function(t){return e(r.alert).kendoAlert({content:t}).data("kendoAlert").open()},c=s.extend({_init:function(t,n){var i=this;s.fn._init.call(i,t,n),i.wrapper.addClass(R),i.result=e.Deferred()},options:{name:"Confirm",modal:!0,actions:[{text:"#: messages.okText #",primary:!0,action:function(e){e.sender.result.resolve()}},{text:"#: messages.cancel #",action:function(e){e.sender.result.reject()}}]}}),f.ui.plugin(c),d=function(t){var n=e(r.confirm).kendoConfirm({content:t}).data("kendoConfirm").open();return n.result},u=s.extend({_init:function(t,n){var i=this;s.fn._init.call(i,t,n),i.wrapper.addClass(F),i._createPrompt(),i.result=e.Deferred()},_createPrompt:function(){var t=this.options.value,n=e(r.promptInputContainer(this.options)).insertAfter(this.element);t&&n.children(z).val(t),this._defaultFocus=this._chooseEntryFocus(),this._focusDialog()},_chooseEntryFocus:function(){return this.wrapper.find(z)[0]},options:{name:"Prompt",modal:!0,value:"",actions:[{text:"#: messages.okText #",primary:!0,action:function(e){var t=e.sender,n=t.wrapper.find(z).val();t.result.resolve(n)}},{text:"#: messages.cancel #",action:function(e){var t=e.sender,n=t.wrapper.find(z).val();e.sender.result.reject(n)}}]}}),f.ui.plugin(u),h=function(t,n){var i=e(r.prompt).kendoPrompt({content:t,value:n}).data("kendoPrompt").open();return i.result},r={wrapper:v("<div class='k-widget k-window k-dialog' role='dialog' />"),action:v("<button type='button' class='k-button# if (data.primary) { # k-primary# } role='button' #'></button>"),titlebar:v("<div class='k-window-titlebar k-dialog-titlebar k-header'><span class='k-window-title k-dialog-title'>#: title #</span><div class='k-window-actions k-dialog-actions' /></div>"),close:v("<a role='button' href='\\#' class='k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close' title='#: messages.close #' aria-label='#: messages.close #' tabindex='-1'><span class='k-icon k-i-close'></span></a>"),actionbar:v("<div class='k-button-group k-dialog-buttongroup k-dialog-button-layout-#: buttonLayout #' role='toolbar' />"),overlay:"<div class='k-overlay' />",alertWrapper:v("<div class='k-widget k-window k-dialog' role='alertdialog' />"),alert:"<div />",confirm:"<div />",prompt:"<div />",promptInputContainer:v("<div class='k-prompt-container'><input type='text' class='k-textbox' title='#: messages.promptInput #' aria-label='#: messages.promptInput #' /></div>")},f.alert=l,f.confirm=d,f.prompt=h}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.scheduler.view.min",["kendo.core.min"],e)}(function(){return kendo.ui.scheduler={},function(e){function t(e,t){function n(e,o){var r,s;if(o=o[t])for(r=i[e]=i[e]||[],s=0;s<o.length;s++)r.push(o[s]),n(e+1,o[s])}var i=[];return n(0,e),i}function n(){return x.support.cssBorderSpacing?"":'cellspacing="0"'}function i(t,i){return t.length?"<table "+n()+' class="'+e.trim("k-scheduler-table "+(i||""))+'"><tr>'+t.join("</tr><tr>")+"</tr></table>":""}function o(e,t){return e.length?"<div style='position:relative'>"+i(e,t)+"</div>":""}function r(t,n,o){var r,s=[];if(o>0)for(r=0;r<t;r++)s.push("<th>&#8203;</th>");return n&&s.push('<th class="k-scheduler-times-all-day">'+n.text+"</th>"),o<1?e():e('<div class="k-scheduler-times">'+i(s)+"</div>")}function s(t,n,r){var s,a,l,c,d,u,h,f,p,m,g=[];for(a=0;a<t.length;a++){for(l=t[a],c=[],d=n/l.length,s=0;s<l.length;s++)u=l[s],c.push('<th colspan="'+(u.colspan||d)+'" class="'+(u.className||"")+'">'+u.text+"</th>");g.push(c.join(""))}if(h=[],r){for(f=t[t.length-1],p=[],m=r.cellContent,s=0;s<f.length;s++)p.push('<td class="'+(f[s].className||"")+'">'+(m?m(s):"&nbsp;")+"</td>");h.push(p.join(""))}return e('<div class="k-scheduler-header k-state-default"><div class="k-scheduler-header-wrap">'+i(g)+o(h,"k-scheduler-header-all-day")+"</div></div>")}function a(t,n){var o,r,s,a,l,c=Array(n).join().split(","),d=[];for(r=0;r<t.length;r++)for(s=t[r],a=n/s.length,o=0;o<s.length;o++)l=s[o].className||"",s[o].allDay&&(l="k-scheduler-times-all-day"),c[a*o]+='<th class="'+l+'" rowspan="'+a+'">'+s[o].text+"</th>";for(o=0;o<n;o++)d.push(c[o]);return n<1?e():e('<div class="k-scheduler-times">'+i(d)+"</div>")}function l(){return e('<div class="k-scheduler-content"><table '+n()+' class="k-scheduler-table"/></div>')}function c(){return w=w?w:x.support.scrollbar()}function d(e,t,n){var i,o,r,s,a;for(i=e.length-1;i>=0;i--)o=u(e[i]),r=o.start,a=o.end,s=r<=t&&a>=t,(s||r>=t&&a<=n||t<=r&&n>=r)&&(r<t&&(t=r),a>n&&(n=a));return h(e,t,n)}function u(e){return{start:e.start,end:e.end}}function h(e,t,n){var i,o,r=[];for(i=0;i<e.length;i++)o=u(e[i]),(o.start<t&&o.end>t||o.start>=t&&o.end<=n)&&r.push(e[i]);return r}function f(e){return m(e)}function p(e){return m(e)}function m(e){var t,n,i,o,r,s,a,l=[];for(t=0;t<e.length;t++){for(n=e[t],i=u(n),o=null,r=0,s=l.length;r<s;r++)if(a=i.start>l[r].end,i.start<l[r].start||a){o=l[r],o.end<i.end&&(o.end=i.end);break}o||(o={start:i.start,end:i.end,events:[]},l.push(o)),o.events.push(n)}return l}function g(t,n,i,o){var r=[];return e.each(n,function(e,n){var s=n.className?"k-slot-cell "+n.className:"k-slot-cell",a={text:n.text,className:s};a[t]=o&&!n.minorTicks?g(t,n.columns,i,o):i,r.push(a)}),r}function v(t,n,i,o,r,s){var a,l,c,d=n[0],u=[];if(d){if(r&&i)e.each(r,function(e,i){i[t]=s&&!i.minorTicks?v(t,n,i.columns,o,i.columns,s):v(t,n,null,o)}),u=r;else for(a=d.dataSource.view(),l=0;l<a.length;l++)c={text:o({text:x.htmlEncode(x.getter(d.dataTextField)(a[l])),color:x.getter(d.dataColorField)(a[l]),field:d.field,title:d.title,name:d.name,value:x.getter(d.dataValueField)(a[l])}),className:"k-slot-cell"},c[t]=v(t,n.slice(1),i,o),u.push(c);return u}return i}function _(t){return function(n){if(e.isArray(n)||n instanceof x.data.ObservableArray){for(var i=0;i<n.length;i++)if(n[i]==t)return!0;return!1}return n==t}}function b(e){e.className=e.className.replace(k,"")+" k-state-selected"}var w,y,k,x=window.kendo,C=x.ui,S=x.date.getDate,T=C.Widget,D=x._outerHeight,A=x.keys,E=".kendoSchedulerView",I=Math,M='<div class="k-marquee k-scheduler-marquee"><div class="k-marquee-color"></div><div class="k-marquee-text"><div class="k-label-top"></div><div class="k-label-bottom"></div></div></div>',R=x.Class.extend({init:function(e,t){this._index=e,this._timeSlotCollections=[],this._daySlotCollections=[],this._isRtl=t},addTimeSlotCollection:function(e,t){return this._addCollection(e,t,this._timeSlotCollections)},addDaySlotCollection:function(e,t){return this._addCollection(e,t,this._daySlotCollections)},_addCollection:function(e,t,n){var i=new B(e,t,this._index,n.length);return n.push(i),i},timeSlotCollectionCount:function(){return this._timeSlotCollections.length},daySlotCollectionCount:function(){return this._daySlotCollections.length},daySlotByPosition:function(e,t,n){return this._slotByPosition(e,t,this._daySlotCollections,n)},timeSlotByPosition:function(e,t,n){return this._slotByPosition(e,t,this._timeSlotCollections,n)},_slotByPosition:function(e,t,n,i){var o,r,s,a,l,c,d,u,h;for(o=0;o<n.length;o++)for(r=n[o],s=0;s<r.count();s++)if(a=r.at(s),l=a.offsetWidth,c=a.offsetHeight,u=a.offsetLeft+l,h=a.offsetTop+c,i||(d=r.at(s+1)),d&&(d.offsetLeft!=a.offsetLeft?u=this._isRtl?a.offsetLeft+(a.offsetLeft-d.offsetLeft):d.offsetLeft:h=d.offsetTop),e>=a.offsetLeft&&e<u&&t>=a.offsetTop&&t<h)return a},refresh:function(){var e;for(e=0;e<this._daySlotCollections.length;e++)this._daySlotCollections[e].refresh();for(e=0;e<this._timeSlotCollections.length;e++)this._timeSlotCollections[e].refresh()},timeSlotRanges:function(e,t){var n,i=this._timeSlotCollections,o=this._startSlot(e,i);if(!o.inRange&&e>=o.slot.end&&(o=null),n=o,e<t&&(n=this._endSlot(t,i)),n&&!n.inRange&&t<=n.slot.start&&(n=null),null===o&&null===n)return[];if(null===o){if(n.slot.end<=e)return[];o={inRange:!0,slot:i[n.slot.collectionIndex].first()}}if(null===n){if(o.slot.start>=t)return[];n={inRange:!0,slot:i[o.slot.collectionIndex].last()}}return this._continuousRange(z,i,o,n)},daySlotRanges:function(e,t,n){var i,o=this._daySlotCollections,r=this._startSlot(e,o,n);if(!r.inRange&&e>=r.slot.end&&(r=null),i=r,e<t&&(i=this._endSlot(t,o,n)),i&&!i.inRange&&t<=i.slot.start&&(i=null),null===r&&null===i)return[];if(null===r){if(i.slot.end<=e)return[];do e+=x.date.MS_PER_DAY,r=this._startSlot(e,o,n);while(!r.inRange&&e>=r.slot.end)}if(null===i){if(r.slot.start>=t)return[];do t-=x.date.MS_PER_DAY,i=this._endSlot(t,o,n);while(!i.inRange&&t<=i.slot.start)}return this._continuousRange(P,o,r,i)},_continuousRange:function(e,t,n,i){var o,r,s,a,l,c,d=n.slot,u=i.slot,h=d.collectionIndex,f=u.collectionIndex,p=[];for(o=h;o<=f;o++)r=t[o],s=r.first(),a=r.last(),l=!1,c=!1,o==h&&(c=!n.inRange),o==f&&(l=!i.inRange),s.start<d.start&&(s=d),a.start>u.start&&(a=u),h<f&&(o==h?l=!0:o==f?c=!0:l=c=!0),p.push(new e({start:s,end:a,collection:r,head:l,tail:c}));return p},slotRanges:function(e,t){var n=e._startTime||x.date.toUtcTime(e.start),i=e._endTime||x.date.toUtcTime(e.end);return void 0===t&&(t=e.isMultiDay()),t?this.daySlotRanges(n,i,e.isAllDay):this.timeSlotRanges(n,i)},ranges:function(e,t,n,i){return"number"!=typeof e&&(e=x.date.toUtcTime(e)),"number"!=typeof t&&(t=x.date.toUtcTime(t)),n?this.daySlotRanges(e,t,i):this.timeSlotRanges(e,t)},_startCollection:function(e,t){var n,i;for(n=0;n<t.length;n++)if(i=t[n],i.startInRange(e))return i;return null},_endCollection:function(e,t,n){var i,o;for(i=0;i<t.length;i++)if(o=t[i],o.endInRange(e,n))return o;return null},_getCollections:function(e){return e?this._daySlotCollections:this._timeSlotCollections},continuousSlot:function(e,t){var n=t?-1:1,i=this._getCollections(e.isDaySlot),o=i[e.collectionIndex+n];return o?o[t?"last":"first"]():void 0},firstSlot:function(){var e=this._getCollections(this.daySlotCollectionCount());return e[0].first()},lastSlot:function(){var e=this._getCollections(this.daySlotCollectionCount());return e[e.length-1].last()},upSlot:function(e,t,n){var i=this,o=function(e,n,o){var r=0===o;if(!t&&!e&&r&&i.daySlotCollectionCount())return i._daySlotCollections[0].at(n)};return this.timeSlotCollectionCount()||(t=!0),this._verticalSlot(e,-1,o,n)},downSlot:function(e,t,n){var i=this,o=function(e,n,o){if(!t&&e&&i.timeSlotCollectionCount())return i._timeSlotCollections[o].at(0)};return this.timeSlotCollectionCount()||(t=!0),this._verticalSlot(e,1,o,n)},leftSlot:function(e,t){return this._horizontalSlot(e,-1,t)},rightSlot:function(e,t){return this._horizontalSlot(e,1,t)},_horizontalSlot:function(e,t,n){var i,o=e.index,r=e.isDaySlot,s=e.collectionIndex,a=this._getCollections(r);return r=!n&&r,r?o+=t:s+=t,i=a[s],i?i.at(o):void 0},_verticalSlot:function(e,t,n,i){var o,r=e.index,s=e.isDaySlot,a=e.collectionIndex,l=this._getCollections(s);return(e=n(s,a,r))?e:(s=!i&&s,s?a+=t:r+=t,o=l[a],o?o.at(r):void 0)},_collection:function(e,t){var n=t?this._daySlotCollections:this._timeSlotCollections;return n[e]},_startSlot:function(e,t,n){var i,o=this._startCollection(e,t),r=!0;return o||(o=t[0],r=!1),i=o.slotByStartDate(e,n),i||(i=o.first(),r=!1),{slot:i,inRange:r}},_endSlot:function(e,t,n){var i,o=this._endCollection(e,t,n),r=!0;return o||(o=t[t.length-1],r=!1),i=o.slotByEndDate(e,n),i||(i=o.last(),r=!1),{slot:i,inRange:r}},getSlotCollection:function(e,t){return this[t?"getDaySlotCollection":"getTimeSlotCollection"](e)},getTimeSlotCollection:function(e){return this._timeSlotCollections[e]},getDaySlotCollection:function(e){return this._daySlotCollections[e]}}),F=x.Class.extend({init:function(t){e.extend(this,t)},innerHeight:function(){var e,t=this.collection,n=this.start.index,i=this.end.index,o=0;for(e=n;e<=i;e++)o+=t.at(e).offsetHeight;return o},events:function(){return this.collection.events()},addEvent:function(e){this.events().push(e)},startSlot:function(){return this.start.offsetLeft>this.end.offsetLeft?this.end:this.start},endSlot:function(){return this.start.offsetLeft>this.end.offsetLeft?this.start:this.end}}),z=F.extend({innerHeight:function(){var e,t=this.collection,n=this.start.index,i=this.end.index,o=0;for(e=n;e<=i;e++)o+=t.at(e).offsetHeight;return o},outerRect:function(e,t,n){return this._rect("offset",e,t,n)},_rect:function(e,t,n,i){var o,r,s,a,l,c,d,u,h=this.start,f=this.end,p=x.support.isRtl(h.element);return"number"!=typeof t&&(t=x.date.toUtcTime(t)),"number"!=typeof n&&(n=x.date.toUtcTime(n)),i?(o=h.offsetTop,r=f.offsetTop+f[e+"Height"],p?(s=f.offsetLeft,a=h.offsetLeft+h[e+"Width"]):(s=h.offsetLeft,a=f.offsetLeft+f[e+"Width"])):(l=t-h.start,l<0&&(l=0),c=h.end-h.start,o=h.offsetTop+h[e+"Height"]*l/c,d=f.end-n,d<0&&(d=0),u=f.end-f.start,r=f.offsetTop+f[e+"Height"]-f[e+"Height"]*d/u,p?(s=Math.round(f.offsetLeft+f[e+"Width"]*d/u),a=Math.round(h.offsetLeft+h[e+"Width"]-h[e+"Width"]*l/c)):(s=Math.round(h.offsetLeft+h[e+"Width"]*l/c),a=Math.round(f.offsetLeft+f[e+"Width"]-f[e+"Width"]*d/u))),{top:o,bottom:r,left:0===s?s:s+1,right:a}},innerRect:function(e,t,n){return this._rect("client",e,t,n)}}),P=F.extend({innerWidth:function(){var e,t=this.collection,n=this.start.index,i=this.end.index,o=0,r=n!==i?"offsetWidth":"clientWidth";for(e=n;e<=i;e++)o+=t.at(e)[r];return o}}),B=x.Class.extend({init:function(e,t,n,i){this._slots=[],this._events=[],this._start=x.date.toUtcTime(e),this._end=x.date.toUtcTime(t),this._groupIndex=n,this._collectionIndex=i},refresh:function(){for(var e=0;e<this._slots.length;e++)this._slots[e].refresh()},startInRange:function(e){return this._start<=e&&e<this._end},endInRange:function(e,t){var n=t?e<this._end:e<=this._end;return this._start<=e&&n},slotByStartDate:function(e){var t,n,i=e;for("number"!=typeof i&&(i=x.date.toUtcTime(e)),t=0;t<this._slots.length;t++)if(n=this._slots[t],n.startInRange(i))return n;return null},slotByEndDate:function(e,t){var n,i,o=e;if("number"!=typeof o&&(o=x.date.toUtcTime(e)),t)return this.slotByStartDate(e,!1);for(n=0;n<this._slots.length;n++)if(i=this._slots[n],i.endInRange(o))return i;return null},count:function(){return this._slots.length},events:function(){return this._events},addTimeSlot:function(e,t,n,i){var o=new H(e,t,n,this._groupIndex,this._collectionIndex,this._slots.length,i);this._slots.push(o)},addDaySlot:function(e,t,n,i){var o=new N(e,t,n,this._groupIndex,this._collectionIndex,this._slots.length,i);this._slots.push(o)},first:function(){return this._slots[0]},last:function(){return this._slots[this._slots.length-1]},at:function(e){return this._slots[e]}}),L=x.Class.extend({init:function(e,t,n,i,o,r){this.element=e,this.clientWidth=e.clientWidth,this.clientHeight=e.clientHeight,this.offsetWidth=e.offsetWidth,this.offsetHeight=e.offsetHeight,this.offsetTop=e.offsetTop,this.offsetLeft=e.offsetLeft,this.start=t,this.end=n,this.element=e,this.groupIndex=i,this.collectionIndex=o,this.index=r,this.isDaySlot=!1},refresh:function(){var e=this.element;this.clientWidth=e.clientWidth,this.clientHeight=e.clientHeight,this.offsetWidth=e.offsetWidth,this.offsetHeight=e.offsetHeight,this.offsetTop=e.offsetTop,this.offsetLeft=e.offsetLeft},startDate:function(){return x.timezone.toLocalDate(this.start)},endDate:function(){return x.timezone.toLocalDate(this.end)},startInRange:function(e){return this.start<=e&&e<this.end},endInRange:function(e){return this.start<e&&e<=this.end},startOffset:function(){return this.start},endOffset:function(){return this.end}}),H=L.extend({init:function(e,t,n,i,o,r,s){L.fn.init.apply(this,arguments),this.isHorizontal=!!s},offsetX:function(e,t){return e?this.offsetLeft+t:this.offsetLeft+t},startInRange:function(e){return this.start<=e&&e<this.end},endInRange:function(e){return this.start<e&&e<=this.end},startOffset:function(t,n,i){var o,r,s,a,l;if(i)return this.start;if(o=e(this.element).offset(),r=this.end-this.start,this.isHorizontal){if(l=x.support.isRtl(this.element),s=t-o.left,a=Math.floor(r*(s/this.offsetWidth)),l)return this.start+r-a}else s=n-o.top,a=Math.floor(r*(s/this.offsetHeight));return this.start+a},endOffset:function(t,n,i){var o,r,s,a,l;if(i)return this.end;if(o=e(this.element).offset(),r=this.end-this.start,this.isHorizontal){if(l=x.support.isRtl(this.element),s=t-o.left,a=Math.floor(r*(s/this.offsetWidth)),l)return this.start+r-a}else s=n-o.top,a=Math.floor(r*(s/this.offsetHeight));return this.start+a}}),N=L.extend({init:function(e,t,n,i,o,r,s){if(L.fn.init.apply(this,arguments),this.eventCount=s,this.isDaySlot=!0,this.element.children.length){var a=this.element.children[0];this.firstChildHeight=a.offsetHeight,this.firstChildTop=a.offsetTop}else this.firstChildHeight=3,this.firstChildTop=0},startDate:function(){var e=new Date(this.start);return x.timezone.apply(e,"Etc/UTC")},endDate:function(){var e=new Date(this.end);return x.timezone.apply(e,"Etc/UTC")},startInRange:function(e){return this.start<=e&&e<this.end},endInRange:function(e){return this.start<e&&e<=this.end}});x.ui.SchedulerView=T.extend({init:function(t,n){T.fn.init.call(this,t,n),this._normalizeOptions(),this._scrollbar=c(),this._isRtl=x.support.isRtl(t),this._resizeHint=e(),this._moveHint=e(),this._cellId=x.guid(),this._resourcesForGroups(),this._selectedSlots=[]},visibleEndDate:function(){return this.endDate()},_normalizeOptions:function(){var e=this.options;e.startTime&&e.startTime.setMilliseconds(0),e.endTime&&e.endTime.setMilliseconds(0),e.workDayStart&&e.workDayStart.setMilliseconds(0),e.workDayEnd&&e.workDayEnd.setMilliseconds(0)},_isMobile:function(){var e=this.options;return e.mobile===!0&&x.support.mobileOS||"phone"===e.mobile||"tablet"===e.mobile},_isMobilePhoneView:function(){var e=this.options;return e.mobile===!0&&x.support.mobileOS&&!x.support.mobileOS.tablet||"phone"===e.mobile},_addResourceView:function(){var e=new R(this.groups.length,this._isRtl);return this.groups.push(e),e},dateForTitle:function(){return x.format(this.options.selectedDateFormat,this.startDate(),this.endDate())},shortDateForTitle:function(){return x.format(this.options.selectedShortDateFormat,this.startDate(),this.endDate())},_changeGroup:function(e,t){var n=t?"prevGroupSlot":"nextGroupSlot",i=this[n](e.start,e.groupIndex,e.isAllDay);return i&&(e.groupIndex+=t?-1:1),this._isGroupedByDate()&&!i&&(e.groupIndex=t?this.groups.length-1:0),i},_changeDate:function(e,t,n){var i,o,r,s=this.groups[e.groupIndex];if(n){if(i=s._getCollections(!1),o=s.daySlotCollectionCount()?t.index-1:t.collectionIndex-1,o>=0)return i[o]._slots[i[o]._slots.length-1]}else if(i=s._getCollections(s.daySlotCollectionCount()),o=s.daySlotCollectionCount()?0:t.collectionIndex+1,r=s.daySlotCollectionCount()?t.collectionIndex+1:0,i[o]&&i[o]._slots[r])return i[o]._slots[r]},_changeGroupContinuously:function(){return null},_changeViewPeriod:function(){return!1},_isInRange:function(e,t){return!!(e&&t&&this.options.min&&this.options.max)&&(S(e)<=S(this.options.min)||S(t)>=S(this.options.max))},_horizontalSlots:function(e,t,n,i){var o,r,s,a=i?"leftSlot":"rightSlot",l={startSlot:t[0].start,endSlot:t[t.length-1].end},c=this.groups[e.groupIndex],d=this._isVerticallyGrouped();return n||(o=this._normalizeHorizontalSelection(e,t,i),o&&(l.startSlot=l.endSlot=o)),this._isGroupedByDate()&&!n?(r=this._changeGroup(e,i),r?l.startSlot=l.endSlot=r:l=this._getNextHorizontalRange(c,a,l)):(l.startSlot=c[a](l.startSlot),l.endSlot=c[a](l.endSlot),n||d||l.startSlot&&l.endSlot||(l.startSlot=l.endSlot=this._changeGroup(e,i))),l.startSlot&&l.endSlot||this._isGroupedByDate()||(s=this._continuousSlot(e,t,i),s=this._changeGroupContinuously(e,s,n,i),s&&(l.startSlot=l.endSlot=s)),l},_getNextHorizontalRange:function(e,t,n){return this._isVerticallyGrouped()||(n.startSlot=e[t](n.startSlot),n.endSlot=e[t](n.endSlot)),n},_verticalSlots:function(e,t,n,i){var o,r,s=this.groups[e.groupIndex],a={startSlot:t[0].start,endSlot:t[t.length-1].end};return n||(o=this._normalizeVerticalSelection(e,t,i),o&&(a.startSlot=a.endSlot=o)),r=i?"upSlot":"downSlot",a=this._getNextVerticalRange(s,r,a,n),n||!this._isVerticallyGrouped()||a.startSlot&&a.endSlot||(a.startSlot=a.endSlot=this._isGroupedByDate()?this._changeDate(e,o,i):this._changeGroup(e,i)),a},_getNextVerticalRange:function(e,t,n,i){return n.startSlot=e[t](n.startSlot,i),n.endSlot=e[t](n.endSlot,i),n},_normalizeHorizontalSelection:function(){return null},_normalizeVerticalSelection:function(e,t,n){var i;return i=n?t[0].start:t[t.length-1].end},_continuousSlot:function(){return null},constrainSelection:function(e){var t,n=this.groups[0];this.inRange(e)?n.daySlotCollectionCount()?n.timeSlotCollectionCount()||(e.isAllDay=!0):e.isAllDay=!1:(t=n.firstSlot(),e.isAllDay=t.isDaySlot,e.start=t.startDate(),e.end=t.endDate()),this.groups[e.groupIndex]||(e.groupIndex=0)},move:function(e,t,n){var i,o,r,s,a,l,c=!1,d=this.groups[e.groupIndex],u=this._isGroupedByDate()&&this._isVerticallyGrouped();if(d.timeSlotCollectionCount()||(e.isAllDay=!0),i=d.ranges(e.start,e.end,e.isAllDay,!1),t===A.DOWN||t===A.UP){if(c=!0,s=t===A.UP,this._updateDirection(e,i,n,s,!0),a=this._verticalSlots(e,i,n,s),!a.startSlot&&!n&&this._changeViewPeriod(e,s,!u))return c}else if((t===A.LEFT||t===A.RIGHT)&&(c=!0,s=t===A.LEFT,this._updateDirection(e,i,n,s,!1),a=this._horizontalSlots(e,i,n,s),!a.startSlot&&!n&&this._changeViewPeriod(e,s,u)))return c;return c&&(o=a.startSlot,r=a.endSlot,n?(l=e.backward,l&&o?e.start=o.startDate():!l&&r&&(e.end=r.endDate())):o&&r&&(e.isAllDay=o.isDaySlot,e.start=o.startDate(),e.end=r.endDate()),e.events=[]),c},moveToEventInGroup:function(t,n,i,o){var r,s,a,l,c=t._continuousEvents||[],d=o?-1:1,u=c.length,h=o?u-1:0;if(i.length)for(a=i[i.length-1],l=0;l<c.length;l++)c[l].uid===a&&(h=l+d);for(;h<u&&h>-1;){if(s=c[h],(!o&&s.start.startDate()>=n.startDate()||o&&s.start.startDate()<=n.startDate())&&s&&e.inArray(s.uid,i)===-1){r=!!s;break}h+=d}return s},moveToEvent:function(e,t){var n,i,o,r,s,a,l=e.groupIndex,c=this.groups[l],d=c.ranges(e.start,e.end,e.isAllDay,!1)[0].start,u=this.groups.length,h=t?-1:1,f=e.events;if(this._isGroupedByDate())if(i=this._getAllEvents(),o=this._getUniqueEvents(i),r=this._getSortedEvents(o),0===f.length)s=this._getNextEventIndexBySlot(d,r,l),t&&s--,n=r[s];else for(a=this._getStartIdx(f,r);a<r.length&&a>-1&&(f.length>0&&(d=this._getSelectedSlot(d,r,n,a,h,t)),d);){if((!t&&r[a].start.startDate()>=d.startDate()||t&&r[a].start.startDate()<=d.startDate())&&f[0]!=r[a].uid){n=r[a];break}a+=h}else for(;l<u&&l>-1&&(n=this.moveToEventInGroup(c,d,f,t),l+=h,c=this.groups[l],c&&!n);)f=[],d=t?c.lastSlot():c.firstSlot(!0);return n&&(e.events=[n.uid],e.start=n.start.startDate(),e.end=n.end.endDate(),e.isAllDay=n.start.isDaySlot,e.groupIndex=n.start.groupIndex),!!n},current:function(e){return void 0===e?this._current:(this._current=e,void(this.content.has(e)&&this._scrollTo(e,this.content[0])))},select:function(e){this.clearSelection(),this._selectEvents(e)||this._selectSlots(e)},_getNextEventIndexBySlot:function(e,t,n){var i,o,r=0,s=x.date.getDate(e.startDate());for(i=0;i<t.length;i++)if(o=x.date.getDate(t[i].start.startDate()),s>o)r++;else if(s.getTime()===o.getTime()&&n>t[i].start.groupIndex)r++;else{if(!(s.getTime()===o.getTime()&&n>=t[i].start.groupIndex&&e.startDate()>t[i].start.startDate()))break;r++}return r},_getSelectedSlot:function(e,t,n,i,o,r){var s,a;return t[i+o]&&t[i].start.groupIndex!==t[i+o].start.groupIndex&&(s=t[i+o].start.groupIndex,a=this.groups[s],a&&!n||(e=null),e=r?a.lastSlot():a.firstSlot(!0)),e},_getStartIdx:function(t,n){var i=0;return e.each(n,function(){return this.uid!==t[0]&&void i++}),i},_getAllEvents:function(){var e,t=[],n=this.groups;for(e=0;e<n.length;e++)n[e]._continuousEvents&&(t=t.concat(n[e]._continuousEvents));return t},_getUniqueEvents:function(e){var t,n,i,o=[];for(t=0;t<e.length;t++){for(n=!1,i=0;i<o.length;i++)if(e[t].uid===o[i].uid){n=!0;break}n||o.push(e[t])}return o},_getSortedEvents:function(t){return t.sort(function(t,n){var i=t.start.startDate(),o=n.start.startDate(),r=x.date.getDate(i)-x.date.getDate(o);return 0===r&&(r=t.start.groupIndex-n.start.groupIndex),0===r&&(r=i.getTime()-o.getTime()),0===r&&(t.start.isDaySlot&&!n.start.isDaySlot&&(r=-1),!t.start.isDaySlot&&n.start.isDaySlot&&(r=1)),0===r&&(r=e(t.element).index()-e(n.element).index()),r})},_selectSlots:function(e){var t,n,i,o,r,s,a,l=e.isAllDay,c=this.groups[e.groupIndex];for(c.timeSlotCollectionCount()||(l=!0),this._selectedSlots=[],t=c.ranges(e.start,e.end,l,!1),o=0;o<t.length;o++)for(r=t[o],s=r.collection,a=r.start.index;a<=r.end.index;a++)i=s.at(a),n=i.element,n.setAttribute("aria-selected",!0),b(n),this._selectedSlots.push({start:i.startDate(),end:i.endDate(),element:n});e.backward&&(n=t[0].start.element),this.current(n)},_selectEvents:function(t){var n,i,o,r=!1,s=t.events,a=this._getAllEvents(),l=a.length,c=[];if(!s[0]||!a[0])return r;for(o=e(),t.events=[],n=0;n<l;n++)e.inArray(a[n].uid,s)>-1&&(i=a[n],o=o.add(i.element),t.events.indexOf(i.uid)===-1?t.events.push(i.uid):c.indexOf(i.uid)===-1&&c.push(i.uid));return o[0]&&(o.addClass("k-state-selected").attr("aria-selected",!0),c.indexOf(o.last().attr("data-uid"))===-1&&this.current(o.last()[0]),this._selectedSlots=[],r=!0),r},inRange:function(e){var t=this.startDate(),n=x.date.addDays(this.endDate(),1),i=e.start,o=e.end;return t<=i&&i<n&&t<o&&o<=n},_resourceValue:function(e,t){return e.valuePrimitive&&(t=x.getter(e.dataValueField)(t)),t},_resourceBySlot:function(e){var t,n,i,o,r,s=this.groupedResources,a={};if(s.length)for(t=e.groupIndex,n=s.length-1;n>=0;n--)i=s[n],o=this._resourceValue(i,i.dataSource.view()[t%i.dataSource.total()]),i.multiple&&(o=[o]),r=x.setter(i.field),r(a,o),t=Math.floor(t/i.dataSource.total());return a},_createResizeHint:function(t,n,i,o){return e(M).css({left:t,top:n,width:i,height:o})},_removeResizeHint:function(){this._resizeHint.remove(),this._resizeHint=e()},_removeMoveHint:function(t){t?(this._moveHint.filter("[data-uid='"+t+"']").remove(),this._moveHint=this._moveHint.filter("[data-uid!='"+t+"']")):(this._moveHint.remove(),this._moveHint=e())},_scrollTo:function(e,t){var n=e.offsetTop,i=e.offsetHeight,o=t.scrollTop,r=t.clientHeight,s=n+i,a=0;a=o>n?n:s>o+r?i<=r?s-r:n:o,t.scrollTop=a},_shouldInverseResourceColor:function(e){var t=new y(e.color).isDark(),n=this.element.css("color"),i=new y(n).isDark();return t==i},_eventTmpl:function(t,n){var i,o=this.options,r=e.extend({},x.Template,o.templateSettings),s=r.paramName,a="",l=typeof t,c={storage:{},count:0};return"function"===l?(c.storage["tmpl"+c.count]=t,a+="#=this.tmpl"+c.count+"("+s+")#",c.count++):"string"===l&&(a+=t),i=x.template(x.format(n,a),r),c.count>0&&(i=e.proxy(i,c.storage)),i},eventResources:function(e){var t,n,i,o,r,s,a,l,c,d,u=[],h=this.options;if(!h.resources)return u;for(t=0;t<h.resources.length;t++)if(n=h.resources[t],i=n.field,o=x.getter(i)(e),null!=o)for(n.multiple||(o=[o]),r=n.dataSource.view(),s=0;s<o.length;s++){for(a=null,l=o[s],n.valuePrimitive||(l=x.getter(n.dataValueField)(l)),c=0;c<r.length;c++)if(r[c].get(n.dataValueField)==l){a=r[c];break}null!==a&&(d=x.getter(n.dataColorField)(a),u.push({field:n.field,title:n.title,name:n.name,text:x.getter(n.dataTextField)(a),value:l,color:d}))}return u},createLayout:function(i){var o,r,s,a,l,c=-1;for(i.rows||(i.rows=[]),o=0;o<i.rows.length;o++)if(i.rows[o].allDay){c=o;break}r=i.rows[c],c>=0&&i.rows.splice(c,1),s=this.columnLevels=t(i,"columns"),a=this.rowLevels=t(i,"rows"),this.table=e("<table "+n()+' class="k-scheduler-layout k-scheduler-'+this.name+'view"><tbody></tbody></table>'),l=a[a.length-1].length,this.table.find("tbody:first").append(this._topSection(s,r,l)),this.table.find("tbody:first").append(this._bottomSection(s,a,l)),this.element.append(this.table),this._scroller()},refreshLayout:function(){var t,n,i,o,r,s,a=this,l=a.element.find(">.k-scheduler-toolbar"),c=a.element.innerHeight(),d=this._scrollbar,u=0,h=this._isRtl?"left":"right";for(t=0;t<l.length;t++)c-=D(l.eq(t));a.datesHeader&&(u=D(a.datesHeader)),a.timesHeader&&D(a.timesHeader)>u&&(u=D(a.timesHeader)),
a.datesHeader&&a.timesHeader&&(n=a.datesHeader.find("table:first tr"),a.timesHeader.find("tr").height(function(t){e(this).height(n.eq(t).height())})),u&&(c-=u),a.footer&&(c-=D(a.footer)),i=function(e){var t,n;return!!e[0].style.height||(t=e.height(),e.height("auto"),n=e.height(),t!=n?(e.height(""),!0):(e.height(""),!1))},o=a.content[0],r=x.support.kineticScrollNeeded?0:d,i(a.element)&&(a.content.height(c>2*d?c:2*d+1),a.times.height(o.clientHeight),s=a.times.find("table"),s.length&&s.height(a.content.find("table")[0].clientHeight)),o.offsetWidth-o.clientWidth>0?(a.table.addClass("k-scrollbar-v"),a.datesHeader.css("padding-"+h,r-parseInt(a.datesHeader.children().css("border-"+h+"-width"),10))):a.datesHeader.css("padding-"+h,""),o.offsetHeight-o.clientHeight>0||o.clientHeight>a.content.children(".k-scheduler-table").height()?a.table.addClass("k-scrollbar-h"):a.table.removeClass("k-scrollbar-h")},_topSection:function(t,n,i){this.timesHeader=r(t.length,n,i);var o=t[t.length-1].length;return this.datesHeader=s(t,o,n),e("<tr>").append(this.timesHeader.add(this.datesHeader).wrap("<td>").parent())},_bottomSection:function(t,n,i){return this.times=a(n,i),this.content=l(t[t.length-1],n[n.length-1]),e("<tr>").append(this.times.add(this.content).wrap("<td>").parent())},_scroller:function(){var t,n=this;this.content.bind("scroll"+E,function(){n.datesHeader.find(">.k-scheduler-header-wrap").scrollLeft(this.scrollLeft),n.times.scrollTop(this.scrollTop)}),t=x.touchScroller(this.content,{avoidScrolling:function(t){return e(t.event.target).closest(".k-event.k-event-active").length>0}}),t&&t.movable&&(this._touchScroller=t,this.content=t.scrollElement,t.movable.bind("change",function(e){n.datesHeader.find(">.k-scheduler-header-wrap").scrollLeft(-e.sender.x),n.times.scrollTop(-e.sender.y)}))},_resourcesForGroups:function(){var e,t,n,i,o=[],r=this.options.group,s=this.options.resources;if(r=r&&r.resources?r.resources:[],s&&r.length)for(e=0,t=s.length;e<t;e++)for(n=0,i=r.length;n<i;n++)s[e].name===r[n]&&o.push(s[e]);this.groupedResources=o},_createDateLayout:function(e,t,n){return g("rows",e,t,n)},_createColumnsLayout:function(e,t,n,i,o){return v("columns",e,t,n,i,o)},_groupOrientation:function(){var e=this.options.group;return e&&e.resources?e.orientation:"horizontal"},_isGroupedByDate:function(){return this.options.group&&this.options.group.date},_isVerticallyGrouped:function(){return this.groupedResources.length&&"vertical"===this._groupOrientation()},_createRowsLayout:function(e,t,n,i){return v("rows",e,t,n,i)},selectionByElement:function(){return null},clearSelection:function(){this.content.find(".k-state-selected").removeAttr("id").attr("aria-selected",!1).removeClass("k-state-selected")},destroy:function(){var e=this;T.fn.destroy.call(this),e.table&&(x.destroy(e.table),e.table.remove()),e.groups=null,e.table=null,e.content=null,e.times=null,e.datesHeader=null,e.timesHeader=null,e.footer=null,e._resizeHint=null,e._moveHint=null},calendarInfo:function(){return x.getCulture().calendars.standard},prevGroupSlot:function(e,t,n){var i,o=this.groups[t],r=o.ranges(e,e,n,!1)[0].start;if(!(t<=0))return this._isGroupedByDate()?r:this._isVerticallyGrouped()?o.timeSlotCollectionCount()?(i=o._collection(n?r.index:r.collectionIndex,!1),i.last()):(i=o._collection(o.daySlotCollectionCount()-1,!0),i.at(r.index)):o.timeSlotCollectionCount()?(i=o._collection(n?0:o.timeSlotCollectionCount()-1,n),n?i.last():i.at(r.index)):(i=o._collection(r.collectionIndex,!0),i.last())},nextGroupSlot:function(e,t,n){var i,o,r=this.groups[t],s=r.ranges(e,e,n,!1)[0].start;if(!(t>=this.groups.length-1))return this._isGroupedByDate()?s:this._isVerticallyGrouped()?r.timeSlotCollectionCount()?(o=r.daySlotCollectionCount(),i=r._collection(o?0:s.collectionIndex,o),n?i.first():i.at(s.collectionIndex)):(i=r._collection(0,!0),i.at(s.index)):r.timeSlotCollectionCount()?(i=r._collection(0,n),n?i.first():i.at(s.index)):(i=r._collection(s.collectionIndex,!0),i.first())},_eventOptionsForMove:function(){return{}},_updateEventForResize:function(){},_updateEventForSelection:function(e){return e}}),y=function(e){var t,n,i,o,r,s=this,a=y.formats;if(1===arguments.length)for(e=s.resolveColor(e),o=0;o<a.length;o++)t=a[o].re,n=a[o].process,i=t.exec(e),i&&(r=n(i),s.r=r[0],s.g=r[1],s.b=r[2]);else s.r=arguments[0],s.g=arguments[1],s.b=arguments[2];s.r=s.normalizeByte(s.r),s.g=s.normalizeByte(s.g),s.b=s.normalizeByte(s.b)},y.prototype={resolveColor:function(e){return e=e||"#000","#"==e.charAt(0)&&(e=e.substr(1,6)),e=e.replace(/ /g,""),e=e.toLowerCase(),e=y.namedColors[e]||e},normalizeByte:function(e){return e<0||isNaN(e)?0:e>255?255:e},percBrightness:function(){var e=this;return I.sqrt(.241*e.r*e.r+.691*e.g*e.g+.068*e.b*e.b)},isDark:function(){var e=this,t=e.percBrightness();return t<180}},y.formats=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,process:function(e){return[parseInt(e[1],10),parseInt(e[2],10),parseInt(e[3],10)]}},{re:/^(\w{2})(\w{2})(\w{2})$/,process:function(e){return[parseInt(e[1],16),parseInt(e[2],16),parseInt(e[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,process:function(e){return[parseInt(e[1]+e[1],16),parseInt(e[2]+e[2],16),parseInt(e[3]+e[3],16)]}}],y.namedColors={aqua:"00ffff",azure:"f0ffff",beige:"f5f5dc",black:"000000",blue:"0000ff",brown:"a52a2a",coral:"ff7f50",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgray:"a9a9a9",darkgreen:"006400",darkorange:"ff8c00",darkred:"8b0000",dimgray:"696969",fuchsia:"ff00ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lightblue:"add8e6",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumblue:"0000cd",navy:"000080",olive:"808000",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",pink:"ffc0cb",plum:"dda0dd",purple:"800080",red:"ff0000",royalblue:"4169e1",salmon:"fa8072",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",steelblue:"4682b4",tan:"d2b48c",teal:"008080",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"},k=/\s*k-state-selected/,e.extend(C.SchedulerView,{createColumns:f,createRows:p,rangeIndex:u,collidingEvents:d,groupEqFilter:_})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.scheduler.dayview.min",["kendo.scheduler.view.min"],e)}(function(){return function(e,t){function n(e){var t=new Date(1980,1,1,0,0,0);return d(t,k(e)),t}function i(e,t,n){return e>=t&&e<=n}function o(e,t,n,i){return i=i?e<=n:e<n,e>t&&i}function r(e,t,n,i){var o,r=e._continuousEvents,s=r[r.length-1],l=g(t.start.startDate()).getTime();if(i&&s&&g(s.start.startDate()).getTime()==l){for(o=r.length-1;o>-1&&!(r[o].isAllDay||g(r[o].start.startDate()).getTime()<l);o--);r.splice(o+1,0,{element:n,isAllDay:!0,uid:n.attr(a.attr("uid")),start:t.start,end:t.end})}else r.push({element:n,isAllDay:i,uid:n.attr(a.attr("uid")),start:t.start,end:t.end})}function s(e){var t=[],n=e.workWeekStart%7,i=Math.abs(e.workWeekEnd%7);for(t.push(n);i!=n;)n>6?n-=7:n++,t.push(n);return t}var a=window.kendo,l=a.ui,c=a.support.browser,d=a.date.setTime,u=l.SchedulerView,h=a._outerWidth,f=a._outerHeight,p=e.extend,m=e.proxy,g=a.date.getDate,v=a.date.MS_PER_MINUTE,_=a.date.MS_PER_DAY,b="k-current-time",w="k-current-time-arrow",y=.8666,k=a.date.getMilliseconds,x=".kendoMultiDayView",C=a.template('<div title="(#=kendo.format("{0:t} - {1:t}", start, end)#): #=title.replace(/"/g,"&\\#34;")#"><div class="k-event-template k-event-time">#:kendo.format("{0:t} - {1:t}", start, end)#</div><div class="k-event-template">${title}</div></div>'),S=a.template('<div title="(#=kendo.format("{0:t}", start)#): #=title.replace(/"/g,"&\\#34;")#"><div class="k-event-template">${title}</div></div>'),T=a.template("<span class='k-link k-nav-day'>#=kendo.toString(date, 'ddd M/dd')#</span>"),D='<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#"#if (resources[0]) { #style="background-color:#=resources[0].color#; border-color: #=resources[0].color#"class="k-event#=inverseColor ? " k-event-inverse" : ""#" #} else {#class="k-event"#}#><span class="k-event-actions"># if(data.tail || data.middle) {#<span class="k-icon k-i-arrow-60-left"></span>#}## if(data.isException()) {#<span class="k-icon k-i-non-recurrence"></span># } else if(data.isRecurring()) {#<span class="k-icon k-i-reload"></span># } #</span>{0}<span class="k-event-actions">#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}## if(data.head || data.middle) {#<span class="k-icon k-i-arrow-60-right"></span>#}#</span>#if(resizable && !singleDay && !data.tail && !data.middle){#<span class="k-resize-handle k-resize-w"></span>#}##if(resizable && !singleDay && !data.head && !data.middle){#<span class="k-resize-handle k-resize-e"></span>#}#</div>',A='<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#" #if (resources[0]) { #style="background-color:#=resources[0].color #; border-color: #=resources[0].color#"class="k-event#=inverseColor ? " k-event-inverse" : ""#"#} else {#class="k-event"#}#><span class="k-event-actions"># if(data.isException()) {#<span class="k-icon k-i-non-recurrence"></span># } else if(data.isRecurring()) {#<span class="k-icon k-i-reload"></span># } #</span>{0}<span class="k-event-actions">#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}#</span><span class="k-event-top-actions"># if(data.tail || data.middle) {#<span class="k-icon k-i-arrow-60-up"></span># } #</span><span class="k-event-bottom-actions"># if(data.head || data.middle) {#<span class="k-icon k-i-arrow-60-down"></span># } #</span># if(resizable && !data.tail && !data.middle) {#<span class="k-resize-handle k-resize-n"></span># } ## if(resizable && !data.head && !data.middle) {#<span class="k-resize-handle k-resize-s"></span># } #</div>',E=u.extend({init:function(e,t){var n=this;u.fn.init.call(n,e,t),n.title=n.options.title||n.options.name,n._workDays=s(n.options),n._templates(),n._editable(),n.calculateDateRange(),n._groups(),n._currentTime(!0)},_currentTimeMarkerUpdater:function(){this._updateCurrentTimeMarker(new Date)},_updateCurrentTimeMarker:function(t){var n,i,o,r,s,l,d,u,p,m,g,v,_,k,x,C,S=this.options;for(S.currentTimeMarker.useLocalTimezone===!1&&(n=S.dataSource.options.schema.timezone,S.dataSource&&n&&(i=a.timezone.offset(t,n),t=a.timezone.convert(t,t.getTimezoneOffset(),i))),this.times.find("."+b).remove(),this.content.find("."+b).remove(),o=S.group&&"horizontal"!=S.group.orientation?this.groups.length:1,r=this.times.find("tr:first th:first"),s=this.times.find("tr:first th:last"),l=0;l<o;l++){if(d=this.groups[l],!d)return;if(u=a.date.toUtcTime(t),p=d.timeSlotRanges(u,u+1),0===p.length)return;m=p[0].collection,g=m.slotByStartDate(t),g&&(v="<div class='"+b+"'></div>",_=e(v).prependTo(this.times),k=Math.round(p[0].innerRect(t,new Date(t.getTime()+1),!1).top),x={},C=this.content[0].scrollWidth,(c.msie||c.edge)&&(C-=1),this._isRtl?(x.right=r.position().left+f(r)-f(s),_.addClass(w+"-left")):(x.left=s.position().left,_.addClass(w+"-right")),x.top=k-h(_)*y/2,_.css(x),e(v).prependTo(this.content).css({top:k,height:"1px",right:0,width:C,left:0}))}},_currentTime:function(e){var n=this,i=n.options.currentTimeMarker;i!==!1&&i.updateInterval!==t&&(n._currentTimeMarkerUpdater(),e&&(n._currentTimeUpdateTimer=setInterval(m(this._currentTimeMarkerUpdater,n),i.updateInterval)))},_updateResizeHint:function(e,t,n,i){var o,r,s,l,c,d,h,f,p,m,g,v,_=e.isMultiDay(),b=this.groups[t],w=b.ranges(n,i,_,e.isAllDay);for(this._removeResizeHint(),c=0;c<w.length;c++)if(d=w[c],h=d.startSlot(),this._isGroupedByDate()&&_)for(f=h.index;f<=d.end.index;f++)p=d.collection._slots[f],o=p.offsetWidth,r=p.clientHeight,s=p.offsetTop,l=u.fn._createResizeHint.call(this,p.offsetLeft,s,o,r),this._resizeHint=this._resizeHint.add(l);else o=h.offsetWidth,r=h.clientHeight,s=h.offsetTop,_?o=d.innerWidth():(m=d.outerRect(n,i,this.options.snap),s=m.top,r=m.bottom-m.top),l=u.fn._createResizeHint.call(this,h.offsetLeft,s,o,r),this._resizeHint=this._resizeHint.add(l);g="t",v=this.content,_&&(g="M/dd",v=this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day) > div"),v.length||(v=this.content)),this._resizeHint.appendTo(v),this._resizeHint.find(".k-label-top,.k-label-bottom").text(""),this._resizeHint.first().addClass("k-first").find(".k-label-top").text(a.toString(a.timezone.toLocalDate(n),g)),this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(a.toString(a.timezone.toLocalDate(i),g))},_updateMoveHint:function(t,n,i){var o,r,s,l,c,d,u,h,f,p,m=t.isMultiDay(),g=this.groups[n],v=a.date.toUtcTime(t.start)+i,_=v+t.duration(),b=g.ranges(v,_,m,t.isAllDay);for(v=a.timezone.toLocalDate(v),_=a.timezone.toLocalDate(_),this._removeMoveHint(t.uid),!m&&(0===k(_)||k(_)<k(this.startTime()))&&b.length>1&&b.pop(),o=e(),r=0;r<b.length;r++)if(s=b[r],l=s.start,d={left:l.offsetLeft+2,top:l.offsetTop},this._isGroupedByDate()&&m)for(u=l.index;u<=s.end.index;u++)h=s.collection._slots[u],d.left=this._isRtl?.1*h.clientWidth+h.offsetLeft+2:h.offsetLeft+2,d.height=h.offsetHeight,d.width=.9*h.clientWidth-4,c=this._createEventElement(t.clone({start:v,end:_}),!m),this._appendMoveHint(c,d),o=o.add(c);else this._isRtl&&(d.left=.1*l.clientWidth+l.offsetLeft+2),m?d.width=s.innerWidth()-4:(f=s.outerRect(v,_,this.options.snap),d.top=f.top,d.height=f.bottom-f.top,d.width=.9*l.clientWidth-4),c=this._createEventElement(t.clone({start:v,end:_}),!m),this._appendMoveHint(c,d),o=o.add(c);p=this.content,m&&(p=this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day) > div"),p.length||(p=this.content)),o.appendTo(p)},_appendMoveHint:function(e,t){e.addClass("k-event-drag-hint"),e.css(t),this._moveHint=this._moveHint.add(e)},_slotByPosition:function(e,t){var n,i,o,r;for(this._isVerticallyGrouped()?(i=this.content.offset(),t+=this.content[0].scrollTop,e+=this.content[0].scrollLeft):i=this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day)").find(">div").offset(),i&&(e-=i.left,t-=i.top),e=Math.ceil(e),t=Math.ceil(t),r=0;r<this.groups.length;r++)if(o=this.groups[r],n=o.daySlotByPosition(e,t,this._isGroupedByDate()))return n;for(i&&(e+=i.left,t+=i.top),i=this.content.offset(),e-=i.left,t-=i.top,this._isVerticallyGrouped()||(t+=this.content[0].scrollTop,e+=this.content[0].scrollLeft),e=Math.ceil(e),t=Math.ceil(t),r=0;r<this.groups.length;r++)if(o=this.groups[r],n=o.timeSlotByPosition(e,t))return n;return null},_groupCount:function(){var e=this.groupedResources,t=this._isGroupedByDate();return e.length?"vertical"===this._groupOrientation()?t?this._columnCountForLevel(e.length-1):this._rowCountForLevel(e.length-1):t?this._columnCountForLevel(e.length)/this._columnCountForLevel(0):this._columnCountForLevel(e.length)/this._columnOffsetForResource(e.length):1},_columnCountInResourceView:function(){var e=this.groupedResources,t=this._isGroupedByDate();return!e.length||this._isVerticallyGrouped()?t?this._rowCountForLevel(0):this._columnCountForLevel(0):t?this._columnCountForLevel(0):this._columnOffsetForResource(e.length)},_timeSlotGroups:function(e,t){var n,i,o,r,s,a,l,c,d,u,h=this._timeSlotInterval(),f=e,p=this._isGroupedByDate(),m=this.content.find("tr:not(.k-scheduler-header-all-day)");for(m.attr("role","row"),s=m.length,this._isVerticallyGrouped()&&(p&&(f=t),s=Math.floor(s/f)),a=0;a<f;a++)for(l=0,c=0,this._isVerticallyGrouped()?l=a:c=a,o=l*s;o<(l+1)*s;){if(d=m[o].children,o%s===0&&(i=k(new Date((+this.startTime())))),u=0,p)if(this._isVerticallyGrouped())for(r=0;r<e;r++)n=this.groups[r],this._addTimeSlotGroup(n,d,r,i,h,a);else for(n=this.groups[a],r=c;r<e*t;r+=e)this._addTimeSlotGroup(n,d,r,i,h,u),u++;else for(n=this.groups[a],r=c*t;r<(c+1)*t;r++)this._addTimeSlotGroup(n,d,r,i,h,u),u++;i+=h,o++}},_addTimeSlotGroup:function(e,t,n,i,o,r){var s,a,l,c=t[n],d=e.getTimeSlotCollection(r),u=this._dates[r];u&&(s=Date.UTC(u.getFullYear(),u.getMonth(),u.getDate()),a=s+i,l=a+o,c.setAttribute("role","gridcell"),c.setAttribute("aria-selected",!1),d.addTimeSlot(c,a,l))},_addDaySlotGroup:function(e,t,n,i,o){var r,s=t[n],l=this._dates[o];l&&(r=Date.UTC(l.getFullYear(),l.getMonth(),l.getDate()),s.setAttribute("role","gridcell"),s.setAttribute("aria-selected",!1),e.addDaySlot(s,r,r+a.date.MS_PER_DAY))},_daySlotGroups:function(e,t){var n,i,o,r,s,a,l,c,d,u=e,h=this._isGroupedByDate();for(this._isVerticallyGrouped()?(h&&(u=t),n=this.element.find(".k-scheduler-header-all-day")):n=this.element.find(".k-scheduler-header-all-day tr"),n.attr("role","row"),o=0;o<u;o++)if(r=0,this._isVerticallyGrouped()&&(r=o),l=n[r].children,c=0,this._isVerticallyGrouped()||(c=o),d=0,h)if(this._isVerticallyGrouped())for(i=0;i<e;i++)s=this.groups[i],a=s.getDaySlotCollection(0),this._addDaySlotGroup(a,l,i,t,o);else for(s=this.groups[o],a=s.getDaySlotCollection(0),i=c;i<e*t;i+=e)this._addDaySlotGroup(a,l,i,t,d),d++;else for(s=this.groups[o],a=s.getDaySlotCollection(0),i=c*t;i<(c+1)*t;i++)this._addDaySlotGroup(a,l,i,t,d),d++},_groups:function(){var e,t,n,i=this._groupCount(),o=this._columnCountInResourceView();for(this.groups=[],e=0;e<i;e++){for(t=this._addResourceView(e),n=0;n<o;n++)this._dates[n]&&t.addTimeSlotCollection(this._dates[n],a.date.addDays(this._dates[n],1));this.options.allDaySlot&&t.addDaySlotCollection(this._dates[0],a.date.addDays(this._dates[this._dates.length-1],1))}this._timeSlotGroups(i,o),this.options.allDaySlot&&this._daySlotGroups(i,o)},options:{name:"MultiDayView",selectedDateFormat:"{0:D}",selectedShortDateFormat:"{0:d}",allDaySlot:!0,showWorkHours:!1,title:"",startTime:a.date.today(),endTime:a.date.today(),minorTickCount:2,majorTick:60,majorTimeHeaderTemplate:"#=kendo.toString(date, 't')#",minorTimeHeaderTemplate:"&\\#8203;",groupHeaderTemplate:"#=text#",slotTemplate:"&nbsp;",allDaySlotTemplate:"&nbsp;",eventTemplate:C,allDayEventTemplate:S,dateHeaderTemplate:T,editable:!0,workDayStart:new Date(1980,1,1,8,0,0),workDayEnd:new Date(1980,1,1,17,0,0),workWeekStart:1,workWeekEnd:5,footer:{command:"workDay"},messages:{allDay:"all day",showFullDay:"Show full day",showWorkDay:"Show business hours"},currentTimeMarker:{updateInterval:1e4,useLocalTimezone:!0}},events:["remove","add","edit"],_templates:function(){var e=this.options,t=p({},a.Template,e.templateSettings);this.eventTemplate=this._eventTmpl(e.eventTemplate,A),this.allDayEventTemplate=this._eventTmpl(e.allDayEventTemplate,D),this.majorTimeHeaderTemplate=a.template(e.majorTimeHeaderTemplate,t),this.minorTimeHeaderTemplate=a.template(e.minorTimeHeaderTemplate,t),this.dateHeaderTemplate=a.template(e.dateHeaderTemplate,t),this.slotTemplate=a.template(e.slotTemplate,t),this.allDaySlotTemplate=a.template(e.allDaySlotTemplate,t),this.groupHeaderTemplate=a.template(e.groupHeaderTemplate,t)},_editable:function(){this.options.editable&&(this._isMobile()?this._touchEditable():this._mouseEditable())},_mouseEditable:function(){var t=this;t.element.on("click"+x,".k-event a:has(.k-i-close)",function(n){t.trigger("remove",{uid:e(this).closest(".k-event").attr(a.attr("uid"))}),n.preventDefault()}),t.options.editable.create!==!1&&t.element.on("dblclick"+x,".k-scheduler-content td",function(n){var i,o;e(this).parent().hasClass("k-scheduler-header-all-day")||(i=t._slotByPosition(n.pageX,n.pageY),i&&(o=t._resourceBySlot(i),t.trigger("add",{eventInfo:p({start:i.startDate(),end:i.endDate()},o)})),n.preventDefault())}).on("dblclick"+x,".k-scheduler-header-all-day td",function(e){var n,i=t._slotByPosition(e.pageX,e.pageY);i&&(n=t._resourceBySlot(i),t.trigger("add",{eventInfo:p({},{isAllDay:!0,start:a.date.getDate(i.startDate()),end:a.date.getDate(i.startDate())},n)})),e.preventDefault()}),t.options.editable.update!==!1&&t.element.on("dblclick"+x,".k-event",function(n){t.trigger("edit",{uid:e(this).closest(".k-event").attr(a.attr("uid"))}),n.preventDefault()})},_touchEditable:function(){var n=this,i=0;a.support.mobileOS.android&&(i=5),n.options.editable.create!==!1&&(n._addUserEvents=new a.UserEvents(n.element,{threshold:i,filter:".k-scheduler-content td",tap:function(i){var o,r,s,a;e(i.target).parent().hasClass("k-scheduler-header-all-day")||(o=i.x.location!==t?i.x.location:i.x,r=i.y.location!==t?i.y.location:i.y,s=n._slotByPosition(o,r),s&&(a=n._resourceBySlot(s),n.trigger("add",{eventInfo:p({start:s.startDate(),end:s.endDate()},a)})),i.preventDefault())}}),n._allDayUserEvents=new a.UserEvents(n.element,{threshold:i,filter:".k-scheduler-header-all-day td",tap:function(e){var i,o=e.x.location!==t?e.x.location:e.x,r=e.y.location!==t?e.y.location:e.y,s=n._slotByPosition(o,r);s&&(i=n._resourceBySlot(s),n.trigger("add",{eventInfo:p({},{isAllDay:!0,start:a.date.getDate(s.startDate()),end:a.date.getDate(s.startDate())},i)})),e.preventDefault()}})),n.options.editable.update!==!1&&(n._editUserEvents=new a.UserEvents(n.element,{threshold:i,filter:".k-event",tap:function(t){var i=e(t.target).closest(".k-event");i.hasClass("k-event-active")||n.trigger("edit",{uid:i.attr(a.attr("uid"))}),t.preventDefault()}}))},_layout:function(e){var t,n,i,o=[],r=[],s=this.options,l=this,c=l._isGroupedByDate();for(t=0;t<e.length;t++)n={},n.text=l.dateHeaderTemplate({date:e[t]}),a.date.isToday(e[t])&&(n.className="k-today"),o.push(n);return i=this.groupedResources,s.allDaySlot&&r.push({text:s.messages.allDay,allDay:!0,cellContent:function(t){var n=t;return t=i.length&&"vertical"!==l._groupOrientation()?t%e.length:t,l.allDaySlotTemplate({date:e[t],resources:function(){return l._resourceBySlot({groupIndex:n})}})}}),this._forTimeRange(this.startTime(),this.endTime(),function(e,t,n,i){var o=t?l.majorTimeHeaderTemplate:l.minorTimeHeaderTemplate,s={text:o({date:e}),className:i?"k-slot-cell":""};r.push(s)}),i.length&&("vertical"===this._groupOrientation()?c?(r=this._createDateLayout(o,r),o=this._createColumnsLayout(i,null,this.groupHeaderTemplate)):r=this._createRowsLayout(i,r,this.groupHeaderTemplate):o=c?this._createColumnsLayout(i,o,this.groupHeaderTemplate,o):this._createColumnsLayout(i,o,this.groupHeaderTemplate)),{columns:o,rows:r}},_footer:function(){var t,n,i,o=this.options;o.footer!==!1&&(t='<div class="k-header k-scheduler-footer">',n=o.footer.command,n&&"workDay"===n?(t+='<ul class="k-reset k-header">',t+='<li class="k-state-default k-scheduler-fullday"><a href="#" class="k-link"><span class="k-icon k-i-clock"></span>',t+=(o.showWorkHours?o.messages.showFullDay:o.messages.showWorkDay)+"</a></li>",t+="</ul>"):t+="&nbsp;",t+="</div>",this.footer=e(t).appendTo(this.element),i=this,this.footer.on("click"+x,".k-scheduler-fullday",function(e){e.preventDefault(),i.trigger("navigate",{view:i.name||o.name,date:o.date,isWorkDay:!o.showWorkHours})}))},_forTimeRange:function(e,t,i,o){var r,s,a,l,c,u,h,f,p,m,g,b,w,y,x,C;for(e=n(e),t=n(t),r=this,s=k(e),a=k(t),l=r.options.minorTickCount,c=r.options.majorTick*v,u=c/l||1,h=new Date((+e)),f=h.getDate(),m=0,b="",g=_/u,s!=a&&(s>a&&(a+=_),g=(a-s)/u),g=Math.round(g);m<g;m++)w=m%(c/u),y=0===w,x=w<l-1,C=w===l-1,b+=i(h,y,x,C),d(h,u,!1);return a&&(p=k(h),f<h.getDate()&&(p+=_),p>a&&(h=new Date((+t)))),o&&(b+=o(h)),b},_content:function(e){var t,n,i,o=this,r=o.options,s=o.startTime(),a=this.endTime(),l=1,c=1,d=e.length,u="",h=this.groupedResources,f=this.allDaySlotTemplate,p=!1,m=o._isGroupedByDate(),g=0;for(h.length&&(p="vertical"===o._groupOrientation(),p?(c=this._rowCountForLevel(this.rowLevels.length-2),m&&(l=this._columnCountForLevel(this.columnLevels.length-1)),r.allDaySlot&&(t=function(t){var n,i='<tr class="k-scheduler-header-all-day">',r=m?0:t,s=function(){return o._resourceBySlot({groupIndex:r})};if(m)for(;r<l;r++)i+="<td>"+f({date:e[g],resources:s})+"</td>";else for(n=0;n<e.length;n++)i+="<td>"+f({date:e[n],resources:s})+"</td>";return i+"</tr>"})):l=m?this._columnCountForLevel(this.columnLevels.length-1)/this._columnCountForLevel(0):this._columnCountForLevel(this.columnLevels.length-2)),u+="<tbody>",n=function(t,n,r){var s,a,c,u="",h=0;if(u="<tr"+(r?' class="k-middle-row"':"")+">",m)for(s=0,a=d;s<a;s++){for(h=0;h<l;h++)c=s,p&&(c=g),u=o._addCellsToContent(u,e,t,c,h,i);if(p)break}else for(;h<l;h++)for(s=0,a=d;s<a;s++)u=o._addCellsToContent(u,e,t,s,h,i);return u+="</tr>"},i=0;i<c;i++)u+=t?t(i):"",u+=this._forTimeRange(s,a,n),p&&g++;u+="</tbody>",this.content.find("table").append(u)},_addCellsToContent:function(e,t,n,i,o,r){var s,l=this,c="",d=this.slotTemplate,u="vertical"===this._groupOrientation(),h=function(e){return function(){return l._resourceBySlot({groupIndex:e})}};return a.date.isToday(t[i])&&(c+="k-today"),(a.date.getMilliseconds(n)<a.date.getMilliseconds(this.options.workDayStart)||a.date.getMilliseconds(n)>=a.date.getMilliseconds(this.options.workDayEnd)||!this._isWorkDay(t[i]))&&(c+=" k-nonwork-hour"),e+="<td"+(""!==c?' class="'+c+'"':"")+">",s=a.date.getDate(t[i]),a.date.setTime(s,a.date.getMilliseconds(n)),e+=d({date:s,resources:h(u&&!l._isGroupedByDate()?r:o)}),e+="</td>"},_isWorkDay:function(e){var t,n=e.getDay(),i=this._workDays;for(t=0;t<i.length;t++)if(i[t]===n)return!0;return!1},_render:function(t){var n,i=this;t=t||[],this._dates=t,this._startDate=t[0],this._endDate=t[t.length-1||0],this.createLayout(this._layout(t)),this._content(t),this._footer(),this.refreshLayout(),n=this.element.find(".k-scheduler-header-all-day td"),n.length&&(this._allDayHeaderHeight=n.first()[0].clientHeight),i.element.on("click"+x,".k-nav-day",function(t){var n,o=e(t.currentTarget).closest("th"),r=o.offset(),s=0,a=f(o);i._isGroupedByDate()&&(i._isVerticallyGrouped()?(s=h(i.times),a=0):a=f(i.datesHeader)),n=i._slotByPosition(r.left+s,r.top+a),i.trigger("navigate",{view:"day",date:n.startDate()})})},startTime:function(){var e=this.options;return e.showWorkHours?e.workDayStart:e.startTime},endTime:function(){var e=this.options;return e.showWorkHours?e.workDayEnd:e.endTime},startDate:function(){return this._startDate},endDate:function(){return this._endDate},_end:function(e){var t=k(this.endTime())||_;return e&&(t=0),new Date(this._endDate.getTime()+t)},nextDate:function(){return a.date.nextDay(this.endDate())},previousDate:function(){return a.date.previousDay(this.startDate())},calculateDateRange:function(){this._render([this.options.date])},destroy:function(){var e=this;e._currentTimeUpdateTimer&&clearInterval(e._currentTimeUpdateTimer),e.datesHeader&&e.datesHeader.off(x),e.element&&e.element.off(x),e.footer&&e.footer.remove(),u.fn.destroy.call(this),this._isMobile()&&e.options.editable&&(e.options.editable.create!==!1&&(e._addUserEvents.destroy(),e._allDayUserEvents.destroy()),e.options.editable.update!==!1&&e._editUserEvents.destroy())},inRange:function(e){var t,n,i,o,r=u.fn.inRange.call(this,e);return e.isAllDay?r:(t=k(this.startTime()),n=k(this.endTime())||a.date.MS_PER_DAY,i=k(e.start),o=k(e.end)||a.date.MS_PER_DAY,r&&t<=i&&o<=n)},selectionByElement:function(e){var t=e.offset();return this._slotByPosition(t.left,t.top)},_timeSlotInterval:function(){var e=this.options;return e.majorTick/e.minorTickCount*v},_timeSlotIndex:function(e){var t=this.options,n=k(e),i=k(this.startTime()),o=t.majorTick/t.minorTickCount*v;return(n-i)/o},_slotIndex:function(e,t){return t?this._dateSlotIndex(e):this._timeSlotIndex(e)},_dateSlotIndex:function(e,t){var n,o,r,s,l=this._dates||[],c=1;for(n=0,o=l.length;n<o;n++)if(r=a.date.getDate(l[n]),s=new Date(a.date.getDate(l[n]).getTime()+_-(t?0:1)),i(e,r,s))return n*c;return-1},_positionAllDayEvent:function(t,n){var i,o,r,s,a,l,c,d=n.innerWidth(),h=n.start.index,f=n.end.index,p=u.collidingEvents(n.events(),h,f),m=this._headerColumnCount||0,g=2,v=h!==f?5:4,_=this._allDayHeaderHeight,b=n.startSlot();for(t.css({left:b.offsetLeft+g,width:d-v}),n.addEvent({slotIndex:h,start:h,end:f,element:t}),p.push({slotIndex:h,start:h,end:f,element:t}),i=u.createRows(p),i.length&&i.length>m&&(this._headerColumnCount=i.length),o=n.start.offsetTop,r=0,s=i.length;r<s;r++)for(a=i[r].events,l=0,c=a.length;l<c;l++)e(a[l].element).css({top:o+r*_})},_arrangeColumns:function(e,t,n,i){var o,r,s,a,l,c,d,h,f,p,m,g=i.start;for(e={element:e,slotIndex:g.index,start:t,end:t+n},r=g.clientWidth,s=.1*r,l=i.events(),c=u.collidingEvents(l,e.start,e.end),i.addEvent(e),c.push(e),o=u.createColumns(c),d=(r-s)/o.length,h=0,f=o.length;h<f;h++)for(a=o[h].events,p=0,m=a.length;p<m;p++)a[p].element[0].style.width=d-4+"px",a[p].element[0].style.left=(this._isRtl?s:0)+g.offsetLeft+h*d+2+"px"},_positionEvent:function(e,t,n){var i=e._startTime||e.start,o=e._endTime||e.end,r=n.innerRect(i,o,!1),s=r.bottom-r.top-2;s<0&&(s=0),t.css({top:r.top,height:s}),this._arrangeColumns(t,r.top,t[0].clientHeight,n)},_createEventElement:function(t,n,o,r){var s,l,c,d,u,h,f=n?this.eventTemplate:this.allDayEventTemplate,m=this.options,v=m.editable,b=this._isMobile(),w=v&&v.destroy!==!1&&!b,y=v&&v.resize!==!1,x=g(this.startDate()),C=g(this.endDate()),S=k(this.startTime()),T=k(this.endTime()),D=t._time("start"),A=t._time("end");return S>=T&&(T=k(new Date(this.endTime().getTime()+_-1))),n||t.isAllDay||(C=new Date(C.getTime()+_)),l=t.start,c=t.end,t.isAllDay&&(c=g(t.end)),!i(g(l),x,C)&&!i(c,x,C)||n&&D<S&&A>T?s=!0:g(l)<x||n&&D<S?r=!0:(c>C&&!n||n&&A>T)&&(o=!0),d=this.eventResources(t),t._startTime&&D!==a.date.getMilliseconds(t.start)&&(l=new Date(D),l=a.timezone.apply(l,"Etc/UTC")),t._endTime&&A!==a.date.getMilliseconds(t.end)&&(c=new Date(A),c=a.timezone.apply(c,"Etc/UTC")),u=p({},{ns:a.ns,resizable:y,showDelete:w,middle:s,head:o,tail:r,singleDay:1==this._dates.length,resources:d,inverseColor:!(!d||!d[0])&&this._shouldInverseResourceColor(d[0]),messages:m.messages},t,{start:l,end:c}),h=e(f(u)),this.angular("compile",function(){return{elements:h,data:[{dataItem:u}]}}),h},_isInTimeSlot:function(e){var t,n=this.startTime(),i=this.endTime(),r=e._startTime||e.start,s=e._endTime||e.end;return k(i)===k(a.date.getDate(i))&&(i=a.date.getDate(i),d(i,_-1)),e._date("end")>e._date("start")&&(s=+e._date("end")+(_-1)),s=e._endTime?s-e._date("end"):k(new Date(s)),r=e._startTime?r-e._date("start"):k(new Date(r)),i=k(i),n=k(n),n===r&&r===s||(t=r!==i,o(r,n,i,t)||o(s,n,i,t)||o(n,r,s)||o(i,r,s))},_isInDateSlot:function(e){var t=this.groups[0],n=t.firstSlot().start,o=t.lastSlot().end-1,r=a.date.toUtcTime(e.start),s=a.date.toUtcTime(e.end);return(i(r,n,o)||i(s,n,o)||i(n,r,s)||i(o,r,s))&&(!i(s,n,n)||i(s,r,r)||e.isAllDay)},_updateAllDayHeaderHeight:function(e){var t,n;if(this._height!==e&&(this._height=e,t=this.element.find(".k-scheduler-header-all-day td"),t.length))for(t.parent().add(this.element.find(".k-scheduler-times-all-day").parent()).height(e),n=0;n<this.groups.length;n++)this.groups[n].refresh()},_renderEvents:function(e,t){var n,i,o,s,a,l,c,d,u,h,f,p,m,g,v,b,w,y,k,x,C,S=this.datesHeader.find(".k-scheduler-header-wrap > div"),T=this._isGroupedByDate();for(i=0,o=e.length;i<o;i++)if(n=e[i],this._isInDateSlot(n))if(s=n.isAllDay||n.duration()>=_,a=s&&!this._isVerticallyGrouped()?S:this.content,s){if(this.options.allDaySlot&&(f=this.groups[t],f._continuousEvents||(f._continuousEvents=[]),c=f.slotRanges(n),c.length))if(d=c[0],b=d.start.index,w=d.end.index,T&&b!==w)for(u=d.start.start,h=d.end.end,y=new Date(u),k=new Date(u),x=d.start.index;x<=d.end.index;x++)l=this._createEventElement(n,!s,x!==w,x!==b),C=f.daySlotRanges(y,k,!0)[0],k.setDate(k.getDate()+1),y.setDate(y.getDate()+1),this._positionAllDayEvent(l,C),r(f,C,l,!0),l.appendTo(a);else l=this._createEventElement(n,!s),this._positionAllDayEvent(l,c[0]),r(f,c[0],l,!0),l.appendTo(a)}else if(this._isInTimeSlot(n))for(f=this.groups[t],f._continuousEvents||(f._continuousEvents=[]),c=f.slotRanges(n),p=c.length,m=0;m<p;m++)d=c[m],u=n.start,h=n.end,p>1&&(0===m?h=d.end.endDate():m==p-1?u=d.start.startDate():(u=d.start.startDate(),
h=d.end.endDate())),g=n.clone({start:u,end:h,_startTime:n._startTime,_endTime:n.endTime}),this._isInTimeSlot(g)&&(v=d.head,l=this._createEventElement(n,!s,v,d.tail),l.appendTo(a),this._positionEvent(g,l,d),r(f,d,l,!1))},render:function(t){var n,o,r,s;for(this._headerColumnCount=0,this._groups(),this.element.find(".k-event").remove(),t=new a.data.Query(t).sort([{field:"start",dir:"asc"},{field:"end",dir:"desc"}]).toArray(),n=[],this._eventsByResource(t,this.groupedResources,n),o=e.map(this._dates,function(t){return Math.max.apply(null,e.map(n,function(n){return e.grep(n,function(e){return e.isMultiDay()&&i(t,g(e.start),g(e.end))}).length}))}),r=Math.max.apply(null,o),this._updateAllDayHeaderHeight((r+1)*this._allDayHeaderHeight),s=0;s<n.length;s++)this._renderEvents(n[s],s);this.refreshLayout(),this._currentTime(!1),this.trigger("activate")},_eventsByResource:function(e,t,n){var i,o,r,s,l=t[0];if(l)for(i=l.dataSource.view(),o=0;o<i.length;o++)r=this._resourceValue(l,i[o]),s=new a.data.Query(e).filter({field:l.field,operator:u.groupEqFilter(r)}).toArray(),t.length>1?this._eventsByResource(s,t.slice(1),n):n.push(s);else n.push(e)},_columnOffsetForResource:function(e){return this._columnCountForLevel(e)/this._columnCountForLevel(e-1)},_columnCountForLevel:function(e){var t=this.columnLevels[e];return t?t.length:0},_rowCountForLevel:function(e){var t=this.rowLevels[e];return t?t.length:0},clearSelection:function(){this.content.add(this.datesHeader).find(".k-state-selected").removeAttr("id").attr("aria-selected",!1).removeClass("k-state-selected")},_updateDirection:function(e,t,n,i,o){var r=e.isAllDay,s=t[0].start,a=t[t.length-1].end;n&&(o?r||s.index!==a.index||s.collectionIndex!==a.collectionIndex||(e.backward=i):(r&&s.index===a.index||!r&&s.collectionIndex===a.collectionIndex)&&(e.backward=i))},_changeViewPeriod:function(e,t,n){var i,o,r,s,a,l,c,u,h,f,p,m,g;if(!n)return i=t?this.previousDate():this.nextDate(),o=e.start,r=e.end,s=this._isGroupedByDate()&&this._isVerticallyGrouped(),a=this.groups[e.groupIndex],l=t?a._timeSlotCollections:a._getCollections(a.daySlotCollectionCount()),c=l[l.length-1]._slots,u=t||a.daySlotCollectionCount()?c.length-1:0,f=new Date(i),p=new Date(i),!this._isInRange(f,p)&&(e.start=f,e.end=p,s?(m=new Date(c[u].startDate()),g=new Date(c[u].endDate()),h=k(g)?k(g):_,d(e.start,k(m)),d(e.end,h),a.daySlotCollectionCount()&&(e.isAllDay=!e.isAllDay)):(h=e.isAllDay||!k(r)?_:k(r),d(e.start,k(o)),d(e.end,h)),this._isVerticallyGrouped()||(e.groupIndex=t?this.groups.length-1:0),e.events=[],!0)}});p(!0,l,{MultiDayView:E,DayView:E.extend({options:{name:"DayView",title:"Day"},name:"day"}),WeekView:E.extend({options:{name:"WeekView",title:"Week",selectedDateFormat:"{0:D} - {1:D}",selectedShortDateFormat:"{0:d} - {1:d}"},name:"week",calculateDateRange:function(){var e,t,n=this.options.date,i=a.date.dayOfWeek(n,this.calendarInfo().firstDay,-1),o=[];for(e=0,t=7;e<t;e++)o.push(i),i=a.date.nextDay(i);this._render(o)}}),WorkWeekView:E.extend({options:{name:"WorkWeekView",title:"Work Week",selectedDateFormat:"{0:D} - {1:D}",selectedShortDateFormat:"{0:d} - {1:d}"},name:"workWeek",nextDate:function(){var e=a.date.dayOfWeek(a.date.nextDay(this.startDate()),this.calendarInfo().firstDay,1);return a.date.addDays(e,this._workDays[0])},previousDate:function(){var e=a.date.dayOfWeek(this.startDate(),this.calendarInfo().firstDay,-1),t=this._workDays;return a.date.addDays(e,t[t.length-1]-7)},calculateDateRange:function(){for(var e=this.options.date,t=a.date.dayOfWeek,n=t(e,this.calendarInfo().firstDay,-1),i=t(n,this.options.workWeekStart,1),o=t(i,this.options.workWeekEnd,1),r=[];i<=o;)r.push(i),i=a.date.nextDay(i);this._render(r)}})})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.scheduler.agendaview.min",["kendo.scheduler.view.min"],e)}(function(){return function(e){function t(e){var t,n,i=0;for(t=0,n=e.length;t<n;t++)i+=e[t].items.length;return i}function n(e,t){return e.valuePrimitive&&(t=r.getter(e.dataValueField)(t)),t}function i(e){for(var t,n=0,i=e.length,r=[];n<i;n++)t=e[n],t.groups?(t=o(t.groups),r=r.concat(t)):r=r.concat(o(t.items));return r}function o(e){for(var t=[].concat(e),n=t.shift(),i=[],o=[].push;n;)n.groups?o.apply(t,n.groups):n.items?o.apply(t,n.items):o.call(i,n),n=t.shift();return i}var r=window.kendo,s=r.ui,a=".kendoAgendaView",l='<div class="k-task" title="#:title.replace(/"/g,"\'")#" data-#=kendo.ns#uid="#=uid#"># if (resources[0]) {#<span class="k-scheduler-mark" style="background-color:#=resources[0].color#"></span># } ## if (data.isException()) { #<span class="k-icon k-i-non-recurrence"></span># } else if (data.isRecurring()) {#<span class="k-icon k-i-reload"></span># } #{0}#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}#</div>',c=r.Class.extend({init:function(e){this._view=e},_getColumns:function(e,t){return e.concat(t)},_getGroupsInDay:function(){return[]},_getSumOfItemsForDate:function(){return 0},_renderTaskGroupsCells:function(e,t,n,i){var o=this._view;0===n&&0===i&&t.length&&o._renderTaskGroupsCells(e,t)},_renderDateCell:function(e,t,n,i,o,s){var a=this._view;e.push(r.format('<td class="k-scheduler-datecolumn{3}{2}" rowspan="{0}">{1}</td>',n.length,a._dateTemplate({date:i}),o!=s.length-1||t.length?"":" k-last",t.length?"":" k-first"))},_renderDates:function(){},_getParents:function(e){return e.splice(0)},_getGroupsByDate:function(){},_renderTaskGroups:function(e,t,n){var i=this._view;e.append(i._renderTaskGroups(t,n))}}),d=r.Class.extend({init:function(e){this._view=e},_getColumns:function(e,t){var n,i,o=this._view;return o._isMobilePhoneView()?e.concat(t):(n=t.slice(0,1),i=t.slice(1),n.concat(e).concat(i))},_compareDateGroups:function(e,t,n){return e[n].text==t[n].text&&(0===n||this._compareDateGroups(e,t,n-1))},_getGroupsInDay:function(e,t){var n,i,o,r,s,a=[],l=null;for(n=0;n<e.length;n++)for(i=0;i<e[n].items.length;i++){if(o=0,0===a.length)for(o;o<t[n].length;o++)a.push([1]);else for(o;o<t[n].length;o++)if(this._compareDateGroups(t[n],l,o))a[o][a[o].length-1]++;else{for(r=a[o][a[o].length-1]-1,s=0;s<r;s++)a[o].push(0);a[o].push(1)}l=t[n]}return a},_getSumOfItemsForDate:function(e){var t,n=0;for(t=0;t<e.length;t++)n+=e[t].items.length;return n},_renderTaskGroupsCells:function(e,t,n,i,o,s,a,l){var c,d=this._view,u=d._isMobilePhoneView();if(u)0===n&&0===i&&t.length&&d._renderTaskGroupsCells(e,t);else for(0===n&&0===i&&e.push(r.format('<td class="k-scheduler-datecolumn k-first" rowspan="{0}">{1}</td>',s,d._dateTemplate({date:a}))),c=0;c<t[n].length;c++)o[c][l]&&e.push(r.format('<td class="k-scheduler-groupcolumn" rowspan="{0}">{1}</td>',o[c][l],d._groupTemplate({value:t[n][c].text}),t[n][c].className))},_renderDateCell:function(){},_renderDates:function(e){var t,n=this._view,i=n._groupsByDate.sort(function(e,t){return e.array[0].value.getTime()-t.array[0].value.getTime()});for(t=0;t<i.length;t++)e.append(n._renderTaskGroups(i[t].array,i[t].groups))},_getParents:function(e){return e.slice(0)},_getGroupsByDate:function(e,t,n){var i,o,r,s,a=this._view;if(e[t].items)for(i=0;i<e[t].items.length;i++){for(o=e[t].items[i].value,r=!1,s=0;s<a._groupsByDate.length;s++)a._groupsByDate[s].array[0].value.getTime()===o.getTime()&&(r=!0,a._groupsByDate[s].array.push(e[t].items[i]),a._groupsByDate[s].groups.push(n));r||a._groupsByDate.push({array:[e[t].items[i]],groups:[n]})}},_renderTaskGroups:function(){}});r.ui.scheduler.AgendaGroupedView=c,r.ui.scheduler.AgendaGroupedByDateView=d,s.AgendaView=s.SchedulerView.extend({init:function(t,n){s.SchedulerView.fn.init.call(this,t,n),this._groupedView=this._getGroupedView(),n=this.options,n.editable&&(n.editable=e.extend({"delete":!0},n.editable,{create:!1,update:!1},{messages:n.messages})),this.title=n.title,this._eventTemplate=this._eventTmpl(n.eventTemplate,l),this._dateTemplate=r.template(n.eventDateTemplate),this._groupTemplate=r.template(n.eventGroupTemplate),this._timeTemplate=r.template(n.eventTimeTemplate),this.element.on("mouseenter"+a,".k-scheduler-agenda .k-scheduler-content tr","_mouseenter").on("mouseleave"+a,".k-scheduler-agenda .k-scheduler-content tr","_mouseleave").on("click"+a,".k-scheduler-agenda .k-scheduler-content .k-link:has(.k-i-close)","_remove"),this._renderLayout(n.date)},name:"agenda",_getGroupedView:function(){return this._isGroupedByDate()?new r.ui.scheduler.AgendaGroupedByDateView(this):new r.ui.scheduler.AgendaGroupedView(this)},_mouseenter:function(t){e(t.currentTarget).addClass("k-state-hover")},_mouseleave:function(t){e(t.currentTarget).removeClass("k-state-hover")},_remove:function(t){t.preventDefault(),this.trigger("remove",{uid:e(t.currentTarget).closest(".k-task").attr(r.attr("uid"))})},nextDate:function(){return r.date.nextDay(this.startDate())},startDate:function(){return this._startDate},endDate:function(){return this._endDate},previousDate:function(){return r.date.previousDay(this.startDate())},_renderLayout:function(e){this._startDate=e,this._endDate=r.date.addDays(e,7),this.createLayout(this._layout()),this.table.addClass("k-scheduler-agenda")},_layout:function(){var e,t,n,i=[{text:this.options.messages.time,className:"k-scheduler-timecolumn"},{text:this.options.messages.event}];if(this._isMobilePhoneView()||i.splice(0,0,{text:this.options.messages.date,className:"k-scheduler-datecolumn"}),e=this.groupedResources,e.length){for(t=[],n=0;n<e.length;n++)t.push({text:"",className:"k-scheduler-groupcolumn"});i=this._groupedView._getColumns(t,i)}return{columns:i}},_tasks:function(e){var t,n,i,o,s,a,l,c=[];for(t=0;t<e.length;t++)if(n=e[t],i=n.start,o=n.isAllDay?r.date.getDate(n.end):n.end,s=Math.ceil((o-r.date.getDate(i))/r.date.MS_PER_DAY),n.isAllDay&&(s+=1),a=n.clone(),a.startDate=r.date.getDate(i),a.startDate>=this.startDate()&&c.push(a),s>1)for(a.end=r.date.nextDay(i),a.head=!0,l=1;l<s;l++)i=a.end,a=n.clone(),a.start=a.startDate=r.date.getDate(i),a.end=r.date.nextDay(i),l==s-1?(a.end=new Date(a.start.getFullYear(),a.start.getMonth(),a.start.getDate(),o.getHours(),o.getMinutes(),o.getSeconds(),o.getMilliseconds()),a.tail=!0):(a.isAllDay=!0,a.middle=!0),(r.date.getDate(a.end)<=this.endDate()&&a.start>=this.startDate()||r.date.getDate(a.start).getTime()==this.endDate().getTime())&&c.push(a);return new r.data.Query(c).sort([{field:"start",dir:"asc"},{field:"end",dir:"asc"}]).groupBy({field:"startDate"}).toArray()},_renderTaskGroups:function(e,t){var n,i,o,s,a,l,c,d,u=[],h=this.options.editable,f=h&&h.destroy!==!1&&!this._isMobile(),p=this._isMobilePhoneView(),m=this._groupedView._getSumOfItemsForDate(e),g=this._groupedView._getGroupsInDay(e,t),v=0;for(n=0;n<e.length;n++)for(i=e[n].value,o=e[n].items,s=r.date.isToday(i),a=0;a<o.length;a++)l=o[a],c=[],d=p?[]:c,this._groupedView._renderTaskGroupsCells(d,t,n,a,g,m,i,v),v++,0===a&&(p?(d.push(r.format('<td class="k-scheduler-datecolumn" colspan="2">{0}</td>',this._dateTemplate({date:i}))),u.push('<tr role="row" aria-selected="false"'+(s?' class="k-today">':">")+d.join("")+"</tr>")):this._groupedView._renderDateCell(c,t,o,i,n,e)),l.format=l.head?"{0:t}":l.tail?"{1:t}":"{0:t}-{1:t}",l.resources=this.eventResources(l),c.push(r.format('<td class="k-scheduler-timecolumn"><div>{0}{1}{2}</div></td><td>{3}</td>',l.tail||l.middle?'<span class="k-icon k-i-arrow-60-left"></span>':"",this._timeTemplate(l.clone({start:l._startTime||l.start,end:l.endTime||l.end})),l.head||l.middle?'<span class="k-icon k-i-arrow-60-right"></span>':"",this._eventTemplate(l.clone({showDelete:f,messages:this.options.messages})))),u.push('<tr role="row" aria-selected="false"'+(s?' class="k-today">':">")+c.join("")+"</tr>");return u.join("")},_renderTaskGroupsCells:function(e,t){for(var n=0;n<t.length;n++)e.push(r.format('<td class="k-scheduler-groupcolumn{2}" rowspan="{0}">{1}</td>',t[n].rowSpan,this._groupTemplate({value:t[n].text}),t[n].className))},render:function(e){var t,n,o=this.content.find("table").empty(),r=[];e.length>0&&(t=this.groupedResources,t.length?(r=this._createGroupConfiguration(e,t,null),this._groupsByDate=[],this._renderGroups(r,o,[]),this._groupedView._renderDates(o)):(r=this._tasks(e),o.append(this._renderTaskGroups(r,[])))),n=this._eventsList=i(r),this._angularItems(o,n),this.refreshLayout(),this.trigger("activate")},_angularItems:function(e,t){this.angular("compile",function(){var n=[],i=t.map(function(t){return n.push({dataItem:t}),e.find(".k-task["+r.attr("uid")+"="+t.uid+"]")});return{elements:i,data:n}})},_renderGroups:function(e,t,n){var i,o,r;for(i=0,o=e.length;i<o;i++)r=this._groupedView._getParents(n),r.push(e[i]),this._groupedView._getGroupsByDate(e,i,r),e[i].groups?this._renderGroups(e[i].groups,t,r):this._groupedView._renderTaskGroups(t,e[i].items,r)},_createGroupConfiguration:function(e,i,o){var a,l,c,d,u,h,f,p=i[0],m=[],g=p.dataSource.view(),v=this._isMobilePhoneView();for(a=0;a<g.length;a++)l=n(p,g[a]),c=new r.data.Query(e).filter({field:p.field,operator:s.SchedulerView.groupEqFilter(l)}).toArray(),c.length&&(d=this._tasks(c),u=o?"":" k-first",a===g.length-1&&(!o||o.className.indexOf("k-last")>-1)&&(u+=" k-last"),h={text:r.getter(p.dataTextField)(g[a]),value:l,rowSpan:0,className:u},i.length>1?(h.groups=this._createGroupConfiguration(c,i.slice(1),h),o&&(o.rowSpan+=h.rowSpan)):(h.items=d,f=t(h.items),v&&(f+=h.items.length),h.rowSpan=f,o&&(o.rowSpan+=f)),m.push(h));return m},selectionByElement:function(t){var n,i,o;if(t=e(t),!t.hasClass("k-scheduler-datecolumn")&&this._eventsList.length)return t.is(".k-task")&&(t=t.closest("td")),this._isMobile()?(o=t.parent(),n=o.parent().children().filter(function(){return e(this).children(":not(.k-scheduler-datecolumn)").length}).index(o)):n=t.parent().index(),i=this._eventsList[n],{index:n,start:i.start,end:i.end,isAllDay:i.isAllDay,uid:i.uid}},select:function(e){this.clearSelection();var t=this.table.find(".k-task").eq(e.index).closest("tr").addClass("k-state-selected").attr("aria-selected",!0)[0];this.current(t)},move:function(e,t){var n,i=!1,o=e.index;return t==r.keys.UP?(o--,i=!0):t==r.keys.DOWN&&(o++,i=!0),i&&(n=this._eventsList[o],n&&(e.start=n.start,e.end=n.end,e.isAllDay=n.isAllDay,e.events=[n.uid],e.index=o)),i},moveToEvent:function(){return!1},constrainSelection:function(e){var t=this._eventsList[0];t&&(e.start=t.start,e.end=t.end,e.isAllDay=t.isAllDay,e.events=[t.uid],e.index=0)},isInRange:function(){return!0},destroy:function(){this.element&&this.element.off(a),s.SchedulerView.fn.destroy.call(this)},options:{title:"Agenda",name:"agenda",editable:!0,selectedDateFormat:"{0:D}-{1:D}",selectedShortDateFormat:"{0:d} - {1:d}",eventTemplate:"#:title#",eventTimeTemplate:"#if(data.isAllDay) {##=this.options.messages.allDay##} else { ##=kendo.format(format, start, end)## } #",eventDateTemplate:'<strong class="k-scheduler-agendaday">#=kendo.toString(date, "dd")#</strong><em class="k-scheduler-agendaweek">#=kendo.toString(date,"dddd")#</em><span class="k-scheduler-agendadate">#=kendo.toString(date, "y")#</span>',eventGroupTemplate:'<strong class="k-scheduler-adgendagroup">#=value#</strong>',messages:{event:"Event",date:"Date",time:"Time",allDay:"all day"}}})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.scheduler.monthview.min",["kendo.scheduler.view.min"],e)}(function(){return function(e){function t(e,t){return e.slice(t).concat(e.slice(0,t))}function n(e,t){for(var n=t.firstDay,i=new Date(e.getFullYear(),e.getMonth(),0,e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds());i.getDay()!=n;)o.date.setTime(i,-1*d);return i}function i(e,t,n){var i,o=t,r=n;return i=e,i>=o&&i<=r}var o=window.kendo,r=o.ui,s=r.SchedulerView,a=".kendoMonthView",l=e.extend,c=o.date.getDate,d=o.date.MS_PER_DAY,u=6,h=7,f=o.template('<span class="k-link k-nav-day">#:kendo.toString(date, "dd")#</span>'),p='<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#"#if (resources[0]) { #style="background-color:#=resources[0].color #; border-color: #=resources[0].color#"class="k-event#=inverseColor ? " k-event-inverse" : ""#"#} else {#class="k-event"#}#><span class="k-event-actions"># if(data.tail || data.middle) {#<span class="k-icon k-i-arrow-60-left"></span>#}## if(data.isException()) {#<span class="k-icon k-i-non-recurrence"></span># } else if(data.isRecurring()) {#<span class="k-icon k-i-reload"></span>#}#</span>{0}<span class="k-event-actions">#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}## if(data.head || data.middle) {#<span class="k-icon k-i-arrow-60-right"></span>#}#</span># if(resizable && !data.tail && !data.middle) {#<span class="k-resize-handle k-resize-w"></span>#}## if(resizable && !data.head && !data.middle) {#<span class="k-resize-handle k-resize-e"></span>#}#</div>',m=o.template('<div title="#=title.replace(/"/g,"&\\#34;")#"><div class="k-event-template">#:title#</div></div>'),g=o.template('<div style="width:#=width#px;left:#=left#px;top:#=top#px" class="k-more-events k-button"><span>...</span></div>'),v=o.Class.extend({init:function(e){this._view=e},_verticalRowCountForLevel:function(e){var t=this._view;return t._rowCountForLevel(e)},_horizontalGroupCountForLevel:function(e){var t=this._view;return t._columnCountForLevel(e)},_getCalendarRowsLength:function(e,t){return t/e},_createRows:function(e,t,n,i){var o,r=this._view,s=h,a=r._isVerticallyGrouped(),l="";for(o=0;o<n;o++)l+=r._createRow(e,t,s,a?i:o);return l},_adjustStartDate:function(e){return o.date.addDays(e,h)},_getContent:function(e,t,n){return e({date:t,resources:n})},_getTimeSlotByPosition:function(e,t,n){var i=this._view.groups[n];return i.daySlotByPosition(e,t)},_nextSlotStartDate:function(e){return o.date.nextDay(e)},_createRowsLayout:function(e,t,n){var i=this._view;return i._createRowsLayout(e,t,n)},_createVerticalColumnsLayout:function(e,t,n,i){return i},_createColumnsLayout:function(e,t,n){var i=this._view;return i._createColumnsLayout(e,t,n)},_verticalGroupCount:function(e){var t=this._view;return t._rowCountForLevel(e)},_horizontalGroupCount:function(e){var t=this._view;return t._columnCountForLevel(e)/t._columnOffsetForResource(e)},_positionEvent:function(e,t,n,i,o,r,s){var a,l=this._view,c=l._isMobilePhoneView();i>1&&(0===s?r=n.end.endDate():s==i-1?o=n.start.startDate():(o=n.start.startDate(),r=n.end.endDate())),a=e.clone({start:o,end:r,head:n.head,tail:n.tail}),c?l._positionMobileEvent(n,l._createEventElement(a),t):l._positionEvent(n,l._createEventElement(a),t)},_addDaySlotCollections:function(e,t,n){var i,r,s,a,l,c,d,f,p,m,g,v=this._view,_=h,b=u;for(i=0;i<e;i++)for(r=0,s=0,v._isVerticallyGrouped()&&(s=i),a=s*b;a<(s+1)*b;a++)for(l=v.groups[i],c=l.addDaySlotCollection(o.date.addDays(n,r),o.date.addDays(n,r+_)),d=t[a],f=d.children,p=0,d.setAttribute("role","row"),v._isVerticallyGrouped()||(p=i),m=p*_;m<(p+1)*_;m++)g=f[m],v.addDaySlot(c,g,n,r),r++},_changePeriodGroupIndex:function(e){var t=this._view;return e?t.groups.length-1:0},_createResizeHint:function(e){var t=this._view,n=e.startSlot().offsetLeft,i=e.start.offsetTop,o=e.innerWidth(),r=e.start.clientHeight-2,a=s.fn._createResizeHint.call(t,n,i,o,r);t._appendResizeHint(a)},_createMoveHint:function(e,t){var n=this._view,i=e.startSlot(),o=e.endSlot(),r=n._createEventElement(t.clone({head:e.head,tail:e.tail}));r.css({left:i.offsetLeft+2,top:i.offsetTop+i.firstChildHeight,height:n.options.eventHeight,width:e.innerWidth()-(i.index!==o.index?5:4)}),r.addClass("k-event-drag-hint"),n._appendMoveHint(r)}}),_=o.Class.extend({init:function(e){this._view=e},_verticalRowCountForLevel:function(){return 1},_horizontalGroupCountForLevel:function(e){var t=this._view;return t._columnCountForLevel(e+1)/h},_createRows:function(e,t,n){var i,r,s=this._view,a=h,l=s._isVerticallyGrouped(),c="",d=0;if(l){for(i=new Date(e),r=s._groupCount(),d;d<u;d++)c+=s._createRow(i,t,r,d),i=o.date.addDays(i,a);e=o.date.nextDay(e)}else{for(d;d<a;d++)c+=s._createRow(e,t,n,d),e=o.date.nextDay(e);e=o.date.addDays(e,a)}return c},_adjustStartDate:function(e,t){var n=this._view,i=n._isVerticallyGrouped();return i?t?o.date.addDays(e,h*(u-1)+1):o.date.nextDay(e):o.date.addDays(e,h)},_getContent:function(e,t,n,i){return 0===i?e({date:t,resources:n}):""},_getTimeSlotByPosition:function(e,t,n){var i=this._view.groups[n];return i.daySlotByPosition(e,t,!0)},_nextSlotStartDate:function(e){return e},_getCalendarRowsLength:function(){var e=this._view,t=e._isVerticallyGrouped();return t?h:u},_createRowsLayout:function(e,t,n,i){var o=this._view;return o._createDateLayout(i,null,!1)},_createVerticalColumnsLayout:function(e,t,n){var i,r,s=this._view,a=e[0],l=[],c=a.dataSource.view();for(i=0;i<c.length*u;i++)r={text:n({text:o.htmlEncode(o.getter(a.dataTextField)(c[i%c.length])),color:o.getter(a.dataColorField)(c[i%c.length]),field:a.field,title:a.title,name:a.name,value:o.getter(a.dataValueField)(c[i%c.length])}),className:"k-slot-cell"},r.columns=s._createColumnsLayout(e.slice(1),null,n),l.push(r);return l},_createColumnsLayout:function(e,t,n,i){var o=this._view;return o._createColumnsLayout(e,t,n,i,!0)},_verticalGroupCount:function(e){var t=this._view;return t._columnCountForLevel(e)/u},_horizontalGroupCount:function(e){var t=this._view;return t._columnCountForLevel(e)/h},_positionEvent:function(e,t,n,i,o,r){var s,a,l,c,d=this._view,u=n.start.index,h=n.end.index,f=d._isMobilePhoneView();for(s=n.start.index;s<=n.end.index;s++)a=n.collection._slots[s],l=t.daySlotRanges(a.start,a.start,!0)[0],c=e.clone({start:s===u?a.start:o,end:s===h?a.end:r,head:s!==h||n.head,tail:s!==u||n.tail}),f?d._positionMobileEvent(l,d._createEventElement(c),t):d._positionEvent(l,d._createEventElement(c),t)},_addDaySlotCollections:function(e,t,n){var i,r,s,a,l,c,d,f,p,m,g,v,_,b,w=this._view,y=h,k=u,x=w._isVerticallyGrouped();for(i=0;i<y;i++)for(r=0;r<k;r++)for(s=0,a=x?i:r,l=t[a],c=l.children,d=0,l.setAttribute("role","row"),w._isVerticallyGrouped()||(d=i),f=d*e;f<(d+1)*e;f++)p=r*y+i,m=x?f+r*e:f,g=c[m],v=x?f:s,_=w.groups[v],b=0===i?_.addDaySlotCollection(o.date.addDays(n,p),o.date.addDays(n,p+y)):_._daySlotCollections[r],w.addDaySlot(b,g,n,p),s++},_changePeriodGroupIndex:function(e,t,n){var i=this._view;return t&&i._isVerticallyGrouped()?e?i.groups.length-1:0:n},_createResizeHint:function(e){var t,n,i,o,r,a,l,c=this._view;if(c._isVerticallyGrouped())t=e.startSlot().offsetLeft,n=e.start.offsetTop,i=e.startSlot().offsetWidth,o=e.endSlot().offsetTop+e.startSlot().offsetHeight-e.startSlot().offsetTop-2,r=s.fn._createResizeHint.call(c,t,n,i,o),c._appendResizeHint(r);else for(a=e.startSlot().index;a<=e.endSlot().index;a++)l=e.collection._slots[a],t=l.offsetLeft,n=l.offsetTop,i=l.offsetWidth,o=l.offsetHeight-2,r=s.fn._createResizeHint.call(c,t,n,i,o),c._appendResizeHint(r)},_createMoveHint:function(e,t){var n,i,o,r=this._view,s=e.startSlot(),a=e.endSlot();for(n=s.index;n<=a.index;n++)i=e.collection._slots[n],o=r._createEventElement(t.clone({head:e.head,tail:e.tail})),o.css({left:i.offsetLeft,top:i.offsetTop+i.firstChildHeight,height:r.options.eventHeight,width:i.offsetWidth-2}),o.addClass("k-event-drag-hint"),r._appendMoveHint(o)}});o.ui.scheduler.MonthGroupedView=v,o.ui.scheduler.MonthGroupedByDateView=_,r.MonthView=s.extend({init:function(e,t){var n=this;s.fn.init.call(n,e,t),n._groupedView=n._getGroupedView(),n.title=n.options.title,n._templates(),n._editable(),n._renderLayout(n.options.date),n._groups()},name:"month",_getGroupedView:function(){return this._isGroupedByDate()?new o.ui.scheduler.MonthGroupedByDateView(this):new o.ui.scheduler.MonthGroupedView(this)},_updateDirection:function(e,t,n,i,o){var r,s,a,l,c;n&&(r=t[0].start,s=t[t.length-1].end,a=r.index===s.index,l=r.collectionIndex===s.collectionIndex,c=o?a&&l||l:a&&l,c&&(e.backward=i))},_changeDate:function(e,t,n){var i,o,r,s=this.groups[e.groupIndex];if(n){if(i=s._getCollections(s.daySlotCollectionCount()),o=t.collectionIndex-1,o>=0)return i[o]._slots[i[o]._slots.length-1]}else if(i=s._getCollections(s.daySlotCollectionCount()),o=t.collectionIndex+1,r=0,i[o]&&i[o]._slots[r])return i[o]._slots[r]},_getNextHorizontalRange:function(e,t,n){var i=this._isVerticallyGrouped();return n.startSlot=e[t](n.startSlot,i),n.endSlot=e[t](n.endSlot,i),n},_getNextVerticalRange:function(e,t,n,i){var o=this._isVerticallyGrouped()&&this._isGroupedByDate();return n.startSlot=e[t](n.startSlot,i,o),n.endSlot=e[t](n.endSlot,i,o),n},_changeViewPeriod:function(e,t,n){var i,r,s=n?7:1;return t&&(s*=-1),i=o.date.addDays(e.start,s),r=o.date.addDays(e.end,s),!this._isInRange(i,r)&&(e.start=i,e.end=r,(!n||n&&this._isVerticallyGrouped())&&(e.groupIndex=this._groupedView._changePeriodGroupIndex(t,n,e.groupIndex)),e.events=[],!0)},_continuousSlot:function(e,t,n){var i=e.backward?0:t.length-1,o=this.groups[e.groupIndex];return o.continuousSlot(t[i].start,n)},_changeGroupContinuously:function(e,t,n,i){var o,r,s,a;return n||(o=e.groupIndex,r=this.groups.length-1,s=this._isVerticallyGrouped(),a=this.groups[o],!t&&s?(t=a[i?"lastSlot":"firstSlot"](),o+=i?-1:1):t&&!s&&(o=i?r:0),(o<0||o>r)&&(o=i?r:0,t=null),e.groupIndex=o),t},_normalizeHorizontalSelection:function(e,t,n){var i;return i=n?t[0].start:t[t.length-1].end},_normalizeVerticalSelection:function(e,t){var n;return n=e.backward?t[0].start:t[t.length-1].end},_templates:function(){var e=this.options,t=l({},o.Template,e.templateSettings);this.eventTemplate=this._eventTmpl(e.eventTemplate,p),this.dayTemplate=o.template(e.dayTemplate,t),this.groupHeaderTemplate=o.template(e.groupHeaderTemplate,t)},dateForTitle:function(){return o.format(this.options.selectedDateFormat,this._firstDayOfMonth,this._lastDayOfMonth)},shortDateForTitle:function(){return o.format(this.options.selectedShortDateFormat,this._firstDayOfMonth,this._lastDayOfMonth)},nextDate:function(){return o.date.nextDay(this._lastDayOfMonth)},previousDate:function(){return o.date.previousDay(this._firstDayOfMonth)},startDate:function(){return this._startDate},endDate:function(){return this._endDate},_renderLayout:function(t){var i=this;this._firstDayOfMonth=o.date.firstDayOfMonth(t),this._lastDayOfMonth=o.date.lastDayOfMonth(t),this._startDate=n(t,this.calendarInfo()),this.createLayout(this._layout()),this._content(),this.refreshLayout(),this.content.on("click"+a,".k-nav-day,.k-more-events",function(t){var n=e(t.currentTarget).offset(),o=i._slotByPosition(n.left,n.top);t.preventDefault(),i.trigger("navigate",{view:"day",date:o.startDate()})})},_editable:function(){this.options.editable&&!this._isMobilePhoneView()&&(this._isMobile()?this._touchEditable():this._mouseEditable())},_mouseEditable:function(){var t=this;t.element.on("click"+a,".k-scheduler-monthview .k-event a:has(.k-i-close)",function(n){t.trigger("remove",{uid:e(this).closest(".k-event").attr(o.attr("uid"))}),n.preventDefault()}),t.options.editable.create!==!1&&t.element.on("dblclick"+a,".k-scheduler-monthview .k-scheduler-content td",function(n){var i,o=e(n.currentTarget).offset(),r=t._slotByPosition(o.left,o.top);r&&(i=t._resourceBySlot(r),t.trigger("add",{eventInfo:l({isAllDay:!0,start:r.startDate(),end:r.startDate()},i)})),n.preventDefault()}),t.options.editable.update!==!1&&t.element.on("dblclick"+a,".k-scheduler-monthview .k-event",function(n){t.trigger("edit",{uid:e(this).closest(".k-event").attr(o.attr("uid"))}),n.preventDefault()})},_touchEditable:function(){var t=this,n=0;o.support.mobileOS.android&&(n=5),t.options.editable.create!==!1&&(t._addUserEvents=new o.UserEvents(t.element,{threshold:n,filter:".k-scheduler-monthview .k-scheduler-content td",tap:function(n){var i,o=e(n.target).offset(),r=t._slotByPosition(o.left,o.top);r&&(i=t._resourceBySlot(r),t.trigger("add",{eventInfo:l({isAllDay:!0,start:r.startDate(),end:r.startDate()},i)})),n.preventDefault()}})),t.options.editable.update!==!1&&(t._editUserEvents=new o.UserEvents(t.element,{threshold:n,filter:".k-scheduler-monthview .k-event",tap:function(n){0===e(n.event.target).closest("a:has(.k-i-close)").length&&(t.trigger("edit",{uid:e(n.target).closest(".k-event").attr(o.attr("uid"))}),n.preventDefault())}}))},selectionByElement:function(t){var n=e(t).offset();return this._slotByPosition(n.left,n.top)},_columnCountForLevel:function(e){var t=this.columnLevels[e];return t?t.length:0},_rowCountForLevel:function(e){var t=this.rowLevels[e];return t?t.length:0},_content:function(){var e,t="<tbody>",n=1,i=this._groupedView,o=this.groupedResources;for(o.length&&this._isVerticallyGrouped()&&(n=i._verticalRowCountForLevel(o.length-1)),e=0;e<n;e++)t+=this._createCalendar(e);t+="</tbody>",this.content.find("table").html(t)},_createCalendar:function(e){var t,n,i,r=this.startDate(),s=h*u,a=h,l=[r],c="",d=1,f=this._isVerticallyGrouped(),p=this._groupedView,m=this.groupedResources;for(m.length&&(f||(d=p._horizontalGroupCountForLevel(m.length-1))),this._slotIndices={},t=p._getCalendarRowsLength(a,s),n=0;n<t;n++)c+="<tr>",l.push(r),i=n*a,c+=p._createRows(r,i,d,e),r=p._adjustStartDate(r,n===t-1),c+="</tr>";return this._weekStartDates=l,this._endDate=o.date.previousDay(r),c},_createRow:function(e,t,n,i){var r,s=this,a=s._firstDayOfMonth,l=s._lastDayOfMonth,d=s.dayTemplate,u="",h="",f=this._groupedView,p=function(){return s._resourceBySlot({groupIndex:i})};for(r=0;r<n;r++)u="",o.date.isToday(e)&&(u+="k-today"),o.date.isInDateRange(e,a,l)||(u+=" k-other-month"),h+="<td ",""!==u&&(h+='class="'+u+'"'),h+=">",h+=f._getContent(d,e,p,r),h+="</td>",s._slotIndices[c(e).getTime()]=t+r,e=f._nextSlotStartDate(e);return h},_layout:function(){var n,i,o,r=this.calendarInfo(),s=this._isMobile()?r.days.namesShort:r.days.names,a=t(s,r.firstDay),l=e.map(a,function(e){return{text:e}}),c=this.groupedResources,d=this._groupedView;if(c.length)if(this._isVerticallyGrouped()){for(i=[],o=0;o<6;o++)i.push({text:"<div>&nbsp;</div>",className:"k-hidden k-slot-cell"});n=d._createRowsLayout(c,i,this.groupHeaderTemplate,l),l=d._createVerticalColumnsLayout(c,i,this.groupHeaderTemplate,l)}else l=d._createColumnsLayout(c,l,this.groupHeaderTemplate,l);return{columns:l,rows:n}},_createEventElement:function(t){var n,i=this.options,r=i.editable,s=this._isMobile();return t.showDelete=r&&r.destroy!==!1&&!s,t.resizable=r&&r.resize!==!1&&!s,t.ns=o.ns,t.resources=this.eventResources(t),t.inverseColor=!(!t.resources||!t.resources[0])&&this._shouldInverseResourceColor(t.resources[0]),t.messages=i.messages||{destroy:"Delete"},n=e(this.eventTemplate(t)),this.angular("compile",function(){return{elements:n,data:[{dataItem:t}]}}),n},_isInDateSlot:function(e){var t=this.groups[0],n=t.firstSlot().start,r=t.lastSlot().end-1,s=o.date.toUtcTime(e.start),a=o.date.toUtcTime(e.end);return(i(s,n,r)||i(a,n,r)||i(n,s,a)||i(r,s,a))&&(!i(a,n,n)||i(a,s,s)||e.isAllDay)},_slotIndex:function(e){return this._slotIndices[c(e).getTime()]},_positionMobileEvent:function(t,n,i){var r,a,l,c,d,u,h,f=t.start;t.start.offsetLeft>t.end.offsetLeft&&(f=t.end),r=t.start.index,a=r,l=3,c=s.collidingEvents(t.events(),r,a),c.push({element:n,start:r,end:a}),d=s.createRows(c),u=t.collection.at(r),h=u.container,h||(h=e(o.format('<div class="k-events-container" style="top:{0};left:{1};width:{2}"/>',f.offsetTop+f.firstChildTop+f.firstChildHeight+"px",f.offsetLeft+"px",f.offsetWidth+"px")),u.container=h,this.content[0].appendChild(h[0])),d.length<=l&&(t.addEvent({element:n,start:r,end:a,groupIndex:f.groupIndex}),i._continuousEvents.push({element:n,uid:n.attr(o.attr("uid")),start:t.start,end:t.end}),h[0].appendChild(n[0]))},_positionEvent:function(t,n,i){var r,a,l,c,d,u,h,f,p,m,v,_,b,w,y,k=this.options.eventHeight,x=t.start;for(t.start.offsetLeft>t.end.offsetLeft&&(x=t.end),r=t.start.index,a=t.end.index,l=x.eventCount,c=s.collidingEvents(t.events(),r,a),d=r!==a?5:4,c.push({element:n,start:r,end:a}),u=s.createRows(c),h=0,f=Math.min(u.length,l);h<f;h++)for(p=u[h].events,m=x.offsetTop+x.firstChildTop+x.firstChildHeight+h*k+3*h+"px",
v=0,_=p.length;v<_;v++)p[v].element[0].style.top=m;if(u.length>l)for(b=r;b<=a;b++)w=t.collection,y=w.at(b),y.more||(y.more=e(g({ns:o.ns,start:b,end:b,width:y.clientWidth-2,left:y.offsetLeft+2,top:y.offsetTop+y.firstChildTop+y.firstChildHeight+l*k+3*l})),this.content[0].appendChild(y.more[0]));else t.addEvent({element:n,start:r,end:a,groupIndex:x.groupIndex}),n[0].style.width=t.innerWidth()-d+"px",n[0].style.left=x.offsetLeft+2+"px",n[0].style.height=k+"px",i._continuousEvents.push({element:n,uid:n.attr(o.attr("uid")),start:t.start,end:t.end}),n.appendTo(this.content)},_slotByPosition:function(e,t){var n,i,o=this.content.offset();for(e-=o.left,t-=o.top,t+=this.content[0].scrollTop,e+=this.content[0].scrollLeft,e=Math.ceil(e),t=Math.ceil(t),n=0;n<this.groups.length;n++)if(i=this._groupedView._getTimeSlotByPosition(e,t,n))return i;return null},_appendResizeHint:function(e){e.appendTo(this.content),this._resizeHint=this._resizeHint.add(e)},_updateResizeHint:function(e,t,n,i){var r,s,a;for(this._removeResizeHint(),r=this.groups[t],s=r.ranges(n,i,!0,e.isAllDay),a=0;a<s.length;a++)this._groupedView._createResizeHint(s[a]);this._resizeHint.find(".k-label-top,.k-label-bottom").text(""),this._resizeHint.first().addClass("k-first").find(".k-label-top").text(o.toString(o.timezone.toLocalDate(n),"M/dd")),this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(o.toString(o.timezone.toLocalDate(i),"M/dd"))},_updateMoveHint:function(e,t,n){var i,r=o.date.toUtcTime(e.start)+n,s=r+e.duration(),a=this.groups[t],l=a.ranges(r,s,!0,e.isAllDay);for(this._removeMoveHint(e.uid),i=0;i<l.length;i++)this._groupedView._createMoveHint(l[i],e)},_appendMoveHint:function(e){e.appendTo(this.content),this._moveHint=this._moveHint.add(e)},_groups:function(){var e,t=this._groupCount(),n=this.content[0].getElementsByTagName("tr"),i=this.startDate();for(this.groups=[],e=0;e<t;e++)this._addResourceView(e);this._groupedView._addDaySlotCollections(t,n,i)},addDaySlot:function(e,t,n,i){var r,s=t.clientHeight,a=t.children.length?t.children[0].offsetHeight+3:0,l=o.date.addDays(n,i),c=o.date.MS_PER_DAY;n.getHours()!==l.getHours()&&(c+=(n.getHours()-l.getHours())*o.date.MS_PER_HOUR),l=o.date.toUtcTime(l),c+=l,r=Math.floor((s-a-this.options.moreButtonHeight)/(this.options.eventHeight+3)),t.setAttribute("role","gridcell"),t.setAttribute("aria-selected",!1),e.addDaySlot(t,l,c,r)},render:function(e){this.content.children(".k-event,.k-more-events,.k-events-container").remove(),this._groups(),e=new o.data.Query(e).sort([{field:"start",dir:"asc"},{field:"end",dir:"desc"}]).toArray();var t=this.groupedResources;t.length?this._renderGroups(e,t,0,1):this._renderEvents(e,0),this.refreshLayout(),this.trigger("activate")},_renderEvents:function(e,t){var n,i,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b;for(i=0,r=e.length;i<r;i++)if(n=e[i],this._isInDateSlot(n))if(c=this.groups[t],d=this._groupedView._view,u=d._isMobilePhoneView(),c._continuousEvents||(c._continuousEvents=[]),h=c.slotRanges(n,!0),f=h.length,u)for(s=h[0],a=s.start.start,l=s.end.end,p=new Date(Math.max(n.start.getTime(),o.timezone.toLocalDate(s.start.start))),m=new Date(Math.min(n.end.getTime(),o.timezone.toLocalDate(h[h.length-1].end.end))).getTime(),g=new Date(a),v=new Date(a);p.getTime()<m;)_=c.daySlotRanges(g,v,!0)[0],v.setDate(v.getDate()+1),g.setDate(g.getDate()+1),this._groupedView._positionEvent(n,c,_,1,a,l,0),p=o.date.addDays(p,1);else for(b=0;b<f;b++)s=h[b],a=n.start,l=n.end,this._groupedView._positionEvent(n,c,s,f,a,l,b)},_renderGroups:function(e,t,n,i){var r,a,l,c,d=t[0];if(d)for(r=d.dataSource.view(),a=0;a<r.length;a++)l=this._resourceValue(d,r[a]),c=new o.data.Query(e).filter({field:d.field,operator:s.groupEqFilter(l)}).toArray(),t.length>1?n=this._renderGroups(c,t.slice(1),n++,i+1):this._renderEvents(c,n++);return n},_groupCount:function(){var e=this.groupedResources,t=this._groupedView;return e.length?this._isVerticallyGrouped()?t._verticalGroupCount(e.length-1):t._horizontalGroupCount(e.length):1},_columnOffsetForResource:function(e){return this._columnCountForLevel(e)/this._columnCountForLevel(e-1)},destroy:function(){this.table&&this.table.removeClass("k-scheduler-monthview"),this.content&&this.content.off(a),this.element&&this.element.off(a),s.fn.destroy.call(this),this._isMobile()&&!this._isMobilePhoneView()&&this.options.editable&&(this.options.editable.create!==!1&&this._addUserEvents.destroy(),this.options.editable.update!==!1&&this._editUserEvents.destroy())},events:["remove","add","edit","navigate"],options:{title:"Month",name:"month",eventHeight:25,moreButtonHeight:13,editable:!0,selectedDateFormat:"{0:y}",selectedShortDateFormat:"{0:y}",groupHeaderTemplate:"#=text#",dayTemplate:f,eventTemplate:m}})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.scheduler.recurrence.min",["kendo.dropdownlist.min","kendo.datepicker.min","kendo.numerictextbox.min"],e)}(function(){return function(e,t){function n(e,t){var n;return 0!==e&&e<t?n=t-e:(n=e%t,n&&(n=t-n)),n}function i(e){var t=e.getMonth(),n=g(e)?ie[t]:oe[t];return n+e.getDate()}function o(e,n){var i,o;return e=new Date(e.getFullYear(),e.getMonth(),e.getDate()),ee(e,0),i=e.getFullYear(),n!==t?(J(e,n,-1),e.setDate(e.getDate()+4)):e.setDate(e.getDate()+(4-(e.getDay()||7))),ee(e,0),o=Math.floor((e.getTime()-new Date(i,0,1,(-6)))/864e5),1+Math.floor(o/7)}function r(e,t){var n=te(e).getDay(),i=7-(n+7-(t||7))||7;return i<0&&(i+=7),Math.ceil((e.getDate()-i)/7)+1}function s(e,t){return e+(e<t?7:0)}function a(e,t,n){var i,o,a,l,c,d=t.offset;return d?(i=new Date(e.getFullYear(),e.getMonth()+1,0),o=r(i,n),a=s(t.day,n),l=a<s(new Date(e.getFullYear(),e.getMonth(),1).getDay(),n),c=a>s(i.getDay(),n),d<0?d=o+(d+1-(c?1:0)):l&&(d+=1),o-=c?1:0,d<(l?1:0)||d>o?null:d):r(e,n)}function l(e,t){return r(new Date(e.getFullYear(),e.getMonth()+1,0),t)}function c(e,t,n){return r(e,n)===a(e,t,n)}function d(e,t,n){for(var i,o,l,c,d=s(t.getDay(),n),u=e.length,h=[],f=0;f<u;f++)if(o=e[f],c=r(t,n),i=a(t,o,n),null!==i)if(c<i)h.push(o);else if(c===i)if(l=s(o.day,n),d<l)h.push(o);else if(d===l)return null;return h}function u(e,t,n){for(var i,o=0,r=e.length,s=[];o<r;o++){if(i=e[o],n&&(i=n(i)),t===i)return null;t<i&&s.push(i)}return s}function h(e,t){for(var n,i=0,o=e.length;i<o;i++){if(n=parseInt(e[i],10),isNaN(n)||n<t.start||n>t.end||0===n&&t.start<0)return null;e[i]=n}return e.sort(v)}function f(e){for(var n,i,o,r=0,s=e.length;r<s;r++){if(n=e[r],i=n.length,o=n.substring(i-2).toUpperCase(),o=ae[o],o===t)return null;e[r]={offset:parseInt(n.substring(0,i-2),10)||0,day:o}}return e}function p(e){for(var t,n,i=0,o=e.length,r=[];i<o;i++)t=e[i],"string"==typeof t?n=t:(n=""+se[t.day],t.offset&&(n=t.offset+n)),r.push(n);return""+r}function m(e){var t=e.getMonth();return 1===t?1===new Date(e.getFullYear(),1,29).getMonth()?29:28:re[t]}function g(e){return e=e.getFullYear(),e%4===0&&e%100!==0||e%400===0}function v(e,t){return e-t}function _(e,t){var n,i,o=0,r=[];if(e)for(e=e.split(e.indexOf(";")!==-1?";":","),n=e.length;o<n;o++)i=A(e[o],t),i&&r.push(i);return r}function b(t,n,i){for(var o=e.isArray(t)?t:_(t,i),r=n.getTime()-n.getMilliseconds(),s=0,a=o.length;s<a;s++)if(o[s].getTime()===r)return!0;return!1}function w(e,t){var n,i,o=0,r=[].concat(e);for(n=r.length;o<n;o++)i=r[o],i=q.timezone.convert(i,t||i.getTimezoneOffset(),"Etc/UTC"),r[o]=q.toString(i,ue);return r.join(",")}function y(e,t){var n=new Date(e);switch(t.freq){case"yearly":n.setFullYear(n.getFullYear(),0,1);break;case"monthly":n.setFullYear(n.getFullYear(),n.getMonth(),1);break;case"weekly":J(n,t.weekStart,-1)}return t.hours&&n.setHours(0),t.minutes&&n.setMinutes(0),t.seconds&&n.setSeconds(0),n}function k(e,t){var n=new Date(e);switch(t.freq){case"yearly":n.setFullYear(n.getFullYear(),11,31);break;case"monthly":n.setFullYear(n.getFullYear(),n.getMonth()+1,0);break;case"weekly":J(n,t.weekStart,-1),n.setDate(n.getDate()+6)}return t.hours&&n.setHours(23),t.minutes&&n.setMinutes(59),t.seconds&&n.setSeconds(59),n}function x(e,t,n){var i,o,r,s,a=e.length,l=[];for(r=0,s=n.length;r<s;r++)i=n[r],i<0?i=a+i:i-=1,o=e[i],o&&o.start>=t&&l.push(o);return l}function C(e,t,n){var i,o,r=[];for(o=0;o<e.length;o++)i=e[o],b(t,i.start,n)||r.push(i);return r}function S(e,n,i,o){var r,s,a,l,c,d,u,h,f,p,m,g,v,S,A,E,M,R,F,z,P,B,L,H,N,O,V,U,W,j,q,G,$,K,Y,Q,J=I(e.recurrenceRule,o),ee=[];if(!J)return[e];for(z=J.positions,P=z?0:1,p=J.start,m=J.end,(p||m)&&(e=e.clone({start:p?new Date(p.value[0]):t,end:m?new Date(m.value[0]):t})),M=e.start,E=M.getTime(),A=ne(M),S=_(e.recurrenceException,o),!S[0]&&J.exdates&&(S=J.exdates.value,e.set("recurrenceException",w(S,o))),h=n=new Date(n),i=new Date(i),v=J.freq,F=be[v],R=J.count,J.until&&J.until<i&&(i=new Date(J.until)),g="yearly"===v||"monthly"===v||"weekly"===v,n<E||R||J.interval>1||g?n=new Date(E):(l=n.getHours(),c=n.getMinutes(),d=n.getSeconds(),J.hours||(l=M.getHours()),J.minutes||(c=M.getMinutes()),J.seconds||(d=M.getSeconds()),n.setHours(l,c,d,M.getMilliseconds())),J._startPeriod=new Date(n),z&&(n=y(n,J),i=k(i,J),V=ne(i)-ne(n),V<0&&(l=n.getHours(),i.setHours(l,n.getMinutes(),n.getSeconds(),n.getMilliseconds()),X.adjustDST(i,l)),J._startPeriod=new Date(n),J._endPeriod=k(n,J)),u=e.duration(),J._startTime=r=X.toInvariantTime(n),F.setup&&F.setup(J,M,n),F.limit(n,i,J);n<=i;)if(a=new Date(n),Z(a,u),f=n>=h||a>h,(f&&!b(S,n,o)||z)&&(r=X.toUtcTime(X.getDate(n))+ne(J._startTime),s=r+u,E!==n.getTime()||A!==ne(J._startTime)?(e.isAllDay||(U=e.startTimezone||e.endTimezone,W=e.endTimezone||e.startTimezone,(o&&U||!o&&!U)&&(j=D(n,o)-D(e.start,o),q=D(a,o)-D(e.end,o),G=D(n,U)-D(e.start,U),$=D(a,W)-D(e.end,W),j!==G&&(K=6e4*(j-G),L=new Date(n.getTime()-K),N=r-K),q!==$&&(Y=6e4*(q-$),H=new Date(a.getTime()-Y),O=s-Y))),ee.push(e.toOccurrence({start:L||new Date(n),end:H||a,_startTime:N||r,_endTime:O||s})),L=H=N=O=null):(e._startTime=r,e._endTime=s,ee.push(e))),z){if(F.next(n,J),F.limit(n,i,J),n>J._endPeriod&&(B=x(ee.slice(P),M,z),B=C(B,S,o),ee=ee.slice(0,P).concat(B),J._endPeriod=k(n,J),P=ee.length),R&&R===P)break}else{if(R&&R===P)break;P+=1,Q=T(n),F.next(n,J),Q&&"hourly"!==J.freq&&X.toInvariantTime(e.start).getTime()!==X.toInvariantTime(n).getTime()&&(J._startTime=r=new Date(n.getTime()-36e5)),F.limit(n,i,J)}return ee}function T(e){var t=e.getTimezoneOffset(),n=new Date(e.getTime()-36e5),i=n.getTimezoneOffset();return t<i}function D(e,t){return t?q.timezone.offset(e,t):e.getTimezoneOffset()}function A(e,t){return e=q.parseDate(e,le),e&&t&&(e=G.apply(e,t)),e}function E(e,t){var n,i,o,r,s,a,l,c,d=e.split(";");for(l=0,c=d.length;l<c;l++)if(n=d[l].split(":"),i=n[0],o=n[1],i.indexOf("TZID")!==-1&&(r=i.substring(i.indexOf("TZID")).split("=")[1]),o)for(o=o.split(","),s=0,a=o.length;s<a;s++)o[s]=A(o[s],r||t);if(o)return{value:o,tzid:r}}function I(n,i){var o,r,s,a,l,c,d,u,p,m={},g=0,v=!1,_=function(e,t){var n=e.day,i=t.day;return n<u&&(n+=7),i<u&&(i+=7),n-i};if(!n)return null;for(c=n.split("\n"),c[1]||n.indexOf("DTSTART")===-1&&n.indexOf("DTEND")===-1&&n.indexOf("EXDATE")===-1||(c=n.split(" ")),g=0,s=c.length;g<s;g++)l=e.trim(c[g]),l.indexOf("DTSTART")!==-1?m.start=E(l,i):l.indexOf("DTEND")!==-1?m.end=E(l,i):l.indexOf("EXDATE")!==-1?m.exdates=E(l,i):l.indexOf("RRULE")!==-1?a=l.substring(6):e.trim(l)&&(a=l);for(a=a.split(";"),g=0,s=a.length;g<s;g++)switch(d=a[g],o=d.split("="),r=e.trim(o[1]).split(","),e.trim(o[0]).toUpperCase()){case"FREQ":m.freq=r[0].toLowerCase();break;case"UNTIL":m.until=A(r[0],i);break;case"COUNT":m.count=parseInt(r[0],10);break;case"INTERVAL":m.interval=parseInt(r[0],10);break;case"BYSECOND":m.seconds=h(r,{start:0,end:60}),v=!0;break;case"BYMINUTE":m.minutes=h(r,{start:0,end:59}),v=!0;break;case"BYHOUR":m.hours=h(r,{start:0,end:23}),v=!0;break;case"BYMONTHDAY":m.monthDays=h(r,{start:-31,end:31}),v=!0;break;case"BYYEARDAY":m.yearDays=h(r,{start:-366,end:366}),v=!0;break;case"BYMONTH":m.months=h(r,{start:1,end:12}),v=!0;break;case"BYDAY":m.weekDays=p=f(r),v=!0;break;case"BYWEEKNO":m.weeks=h(r,{start:-53,end:53}),v=!0;break;case"BYSETPOS":m.positions=h(r,{start:-366,end:366});break;case"WKST":m.weekStart=u=ae[r[0]]}return m.freq===t||m.count!==t&&m.until?null:(m.interval||(m.interval=1),u===t&&(m.weekStart=u=q.culture().calendar.firstDay),p&&(m.weekDays=p.sort(_)),m.positions&&!v&&(m.positions=null),m._hasRuleValue=v,m)}function M(e,t){for(var n,i=e.value,o=e.tzid||"",r=i.length,s=0;s<r;s++)n=i[s],n=G.convert(n,o||t||n.getTimezoneOffset(),"Etc/UTC"),i[s]=q.toString(n,"yyyyMMddTHHmmssZ");return o&&(o=";TZID="+o),o+":"+i.join(",")+" "}function R(e,n){var i=e.weekStart,o="FREQ="+e.freq.toUpperCase(),r=e.exdates||"",s=e.start||"",a=e.end||"",l=e.until;return e.interval>1&&(o+=";INTERVAL="+e.interval),e.count&&(o+=";COUNT="+e.count),l&&(l=G.convert(l,n||l.getTimezoneOffset(),"Etc/UTC"),o+=";UNTIL="+q.toString(l,"yyyyMMddTHHmmssZ")),e.months&&(o+=";BYMONTH="+e.months),e.weeks&&(o+=";BYWEEKNO="+e.weeks),e.yearDays&&(o+=";BYYEARDAY="+e.yearDays),e.monthDays&&(o+=";BYMONTHDAY="+e.monthDays),e.weekDays&&(o+=";BYDAY="+p(e.weekDays)),e.hours&&(o+=";BYHOUR="+e.hours),e.minutes&&(o+=";BYMINUTE="+e.minutes),e.seconds&&(o+=";BYSECOND="+e.seconds),e.positions&&(o+=";BYSETPOS="+e.positions),i!==t&&(o+=";WKST="+se[i]),s&&(s="DTSTART"+M(s,n)),a&&(a="DTEND"+M(a,n)),r&&(r="EXDATE"+M(r,n)),(s||a||r)&&(o=s+a+r+"RRULE:"+o),o}var F,z,P,B,L,H,N,O,V,U,W,j,q=window.kendo,G=q.timezone,$=q.Class,K=q.ui,Y=K.Widget,Q=K.DropDownList,X=q.date,Z=X.setTime,J=X.setDayOfWeek,ee=X.adjustDST,te=X.firstDayOfMonth,ne=X.getMilliseconds,ie=[0,31,60,91,121,152,182,213,244,274,305,335,366],oe=[0,31,59,90,120,151,181,212,243,273,304,334,365],re=[31,28,31,30,31,30,31,31,30,31,30,31],se={0:"SU",1:"MO",2:"TU",3:"WE",4:"TH",5:"FR",6:"SA"},ae={SU:0,MO:1,TU:2,WE:3,TH:4,FR:5,SA:6},le=["yyyy-MM-ddTHH:mm:ss.fffzzz","yyyy-MM-ddTHH:mm:sszzz","yyyy-MM-ddTHH:mm:ss","yyyy-MM-ddTHH:mm","yyyy-MM-ddTHH","yyyy-MM-dd","yyyyMMddTHHmmssfffzzz","yyyyMMddTHHmmsszzz","yyyyMMddTHHmmss","yyyyMMddTHHmm","yyyyMMddTHH","yyyyMMdd"],ce=["months","weeks","yearDays","monthDays","weekDays","hours","minutes","seconds"],de=ce.length,ue="yyyyMMddTHHmmssZ",he={months:function(e,t,n){var i=n.months,o=u(i,e.getMonth()+1),r=!1;return null!==o&&(o.length?e.setMonth(o[0]-1,1):e.setFullYear(e.getFullYear()+1,i[0]-1,1),r=!0),r},monthDays:function(e,t,n){for(var i,o,r,s=!1,a=e.getHours(),l=function(e){return e<0&&(e=i+e+1),e};e<=t;){if(o=e.getMonth(),i=m(e),r=u(n.monthDays,e.getDate(),l),null===r)return s;if(s=!0,r.length){if(e.setMonth(o,r.sort(v)[0]),ee(e,a),o===e.getMonth())break}else e.setMonth(o+1,1)}return s},yearDays:function(e,t,n){for(var o,r,s=!1,a=e.getHours(),l=function(e){return e<0&&(e=o+e),e};e<t;){if(o=g(e)?366:365,r=u(n.yearDays,i(e),l),null===r)return s;if(s=!0,o=e.getFullYear(),r.length){e.setFullYear(o,0,r.sort(v)[0]),ee(e,a);break}e.setFullYear(o+1,0,1)}return s},weeks:function(e,t,n){for(var i,r,s,a=n.weekStart,l=!1,c=e.getHours(),d=function(e){return e<0&&(e=53+e),e};e<t;){if(r=u(n.weeks,o(e,a),d),null===r)return l;if(l=!0,i=e.getFullYear(),r.length){s=7*r.sort(v)[0]-1,e.setFullYear(i,0,s),J(e,a,-1),ee(e,c);break}e.setFullYear(i+1,0,1)}return l},weekDays:function(e,t,n){var i,o,s=n.weekDays,a=n.weekStart,u=d(s,e,a),h=e.getHours();if(null===u)return!1;if(i=u[0],i||(i=s[0],J(e,a)),o=i.day,i.offset)for(;e<=t&&!c(e,i,a);)r(e,a)===l(e,a)?(e.setMonth(e.getMonth()+1,1),ee(e,h)):(e.setDate(e.getDate()+7),ee(e,h),J(e,a,-1));return e.getDay()!==o&&J(e,o),!0},hours:function(e,t,n){var i=n.hours,o=n._startTime,r=o.getHours(),s=u(i,r),a=!1;return null!==s&&(a=!0,e.setHours(r),ee(e,r),s.length?(s=s[0],e.setHours(s)):(s=e.getHours(),e.setDate(e.getDate()+1),ee(e,s),s=i[0],e.setHours(s),ee(e,s)),n.minutes&&e.setMinutes(0),o.setHours(s,e.getMinutes())),a},minutes:function(e,t,n){var i=n.minutes,o=e.getMinutes(),r=u(i,o),s=n._startTime.getHours(),a=!1;return null!==r&&(a=!0,r.length?r=r[0]:(s+=1,r=i[0]),n.seconds&&e.setSeconds(0),e.setHours(s,r),s%=24,ee(e,s),n._startTime.setHours(s,r,e.getSeconds())),a},seconds:function(e,t,n){var i=n.seconds,o=n._startTime.getHours(),r=u(i,e.getSeconds()),s=e.getMinutes(),a=!1;return null!==r&&(a=!0,r.length?e.setSeconds(r[0]):(s+=1,e.setMinutes(s,i[0]),s>59&&(s%=60,o=(o+1)%24)),n._startTime.setHours(o,s,e.getSeconds())),a}},fe=$.extend({next:function(e,t){var n,i,o=t._startTime,r=o.getDate();if(t.seconds)i=e.getSeconds()+1,e.setSeconds(i),o.setSeconds(i),o.setDate(r);else{if(!t.minutes)return!1;n=e.getMinutes()+1,e.setMinutes(n),o.setMinutes(n),o.setDate(r)}return!0},normalize:function(e){var t=e.rule;4===e.idx&&t.hours&&(t._startTime.setHours(0),this._hour(e.date,t))},limit:function(e,n,i){for(var o,r,s,a,l,c=i.interval;e<=n;){for(s=r=t,l=e.getDate(),a=0;a<de;a++){if(o=ce[a],i[o]){if(s=he[o](e,n,i),r!==t&&s)break;r=s}s&&this.normalize({date:e,rule:i,day:l,idx:a})}if((1===c||!this.interval(i,e))&&a===de)break}},interval:function(e,t){var i,o,r,a,l=new Date(e._startPeriod),c=new Date(t),d=t.getHours(),u=e.weekStart,h=e.interval,f=e.freq,p=!1,m=0,g=0,v=1;return"hourly"===f?(i=c.getTimezoneOffset()-l.getTimezoneOffset(),o=e._startTime.getHours(),c=c.getTime(),d!==o&&(c+=(o-d)*X.MS_PER_HOUR),c-=l,i&&(c-=i*X.MS_PER_MINUTE),i=Math.floor(c/X.MS_PER_HOUR),m=n(i,h),0!==m&&(this._hour(t,e,m),p=!0)):"daily"===f?(X.setTime(c,-l,!0),i=Math.round(c/X.MS_PER_DAY),m=n(i,h),0!==m&&(this._date(t,e,m),p=!0)):"weekly"===f?(m=this._getNumberOfWeeksBetweenDates(l,t),r=s(t.getDay(),u),a=s(l.getDay(),u),r<a&&(m+=1),m=n(m,h),0!==m&&(X.setDayOfWeek(t,e.weekStart,-1),t.setDate(t.getDate()+7*m),ee(t,d),p=!0)):"monthly"===f?(i=t.getFullYear()-l.getFullYear(),i=t.getMonth()-l.getMonth()+12*i,m=n(i,h),0!==m&&(v=e._hasRuleValue?1:t.getDate(),t.setFullYear(t.getFullYear(),t.getMonth()+m,v),ee(t,d),p=!0)):"yearly"===f&&(i=t.getFullYear()-l.getFullYear(),m=n(i,h),e.months||(g=t.getMonth()),e.yearDays||e.monthDays||e.weekDays||(v=t.getDate()),0!==m&&(t.setFullYear(t.getFullYear()+m,g,v),ee(t,d),p=!0)),p},_getNumberOfWeeksBetweenDates:function(e,t){var n=(t-e)/6048e5,i=Math.floor(n);return n-i>.99&&(i=Math.round(n)),i},_hour:function(e,t,n){var i=t._startTime,o=i.getHours();n&&(o+=n),e.setHours(o),o%=24,i.setHours(o),ee(e,o)},_date:function(e,t,n){var i=e.getHours();e.setDate(e.getDate()+n),ee(e,i)||this._hour(e,t)}}),pe=fe.extend({next:function(e,t){fe.fn.next(e,t)||this._hour(e,t,1)},normalize:function(e){var t=e.rule;4===e.idx&&(t._startTime.setHours(0),this._hour(e.date,t))}}),me=fe.extend({next:function(e,t){fe.fn.next(e,t)||this[t.hours?"_hour":"_date"](e,t,1)}}),ge=me.extend({setup:function(e,t){e.weekDays||(e.weekDays=[{day:t.getDay(),offset:0}])}}),ve=fe.extend({next:function(e,t){var n,i;if(!fe.fn.next(e,t))if(t.hours)this._hour(e,t,1);else if(t.monthDays||t.weekDays||t.yearDays||t.weeks)this._date(e,t,1);else{for(n=e.getDate(),i=e.getHours(),e.setMonth(e.getMonth()+1),ee(e,i);e.getDate()!==n;)e.setDate(n),ee(e,i);this._hour(e,t)}},normalize:function(e){var t=e.rule,n=e.date,i=n.getHours();0!==e.idx||t.monthDays||t.weekDays?fe.fn.normalize(e):(n.setDate(e.day),ee(n,i))},setup:function(e,t,n){e.monthDays||e.weekDays||n.setDate(t.getDate())}}),_e=ve.extend({next:function(e,t){var n,i=e.getHours();if(!fe.fn.next(e,t))if(t.hours)this._hour(e,t,1);else if(t.monthDays||t.weekDays||t.yearDays||t.weeks)this._date(e,t,1);else if(t.months){for(n=e.getDate(),e.setMonth(e.getMonth()+1),ee(e,i);e.getDate()!==n;)e.setDate(n),ee(e,i);this._hour(e,t)}else e.setFullYear(e.getFullYear()+1),ee(e,i),this._hour(e,t)},setup:function(){}}),be={hourly:new pe,daily:new me,weekly:new ge,monthly:new ve,yearly:new _e},we="click";q.recurrence={rule:{parse:I,serialize:R},expand:S,dayInYear:i,weekInYear:o,weekInMonth:r,numberOfWeeks:l,isException:b,toExceptionString:w},F=function(e){for(var t=q.culture().calendar.days.namesShort,n=t.length,i="",o=0,r=[];o<n;o++)r.push(o);for(t=t.slice(e).concat(t.slice(0,e)),r=r.slice(e).concat(r.slice(0,e)),o=0;o<n;o++)i+='<label class="k-check"><input class="k-recur-weekday-checkbox" type="checkbox" value="'+r[o]+'" /> '+t[o]+"</label>";return i},z=q.template('# if (frequency !== "never") { #<div class="k-edit-label"><label>#:messages.repeatEvery#</label></div><div class="k-edit-field"><input class="k-recur-interval" title="#:messages.interval#"/>#:messages.interval#</div># } ## if (frequency === "weekly") { #<div class="k-edit-label"><label>#:messages.repeatOn#</label></div><div class="k-edit-field">#=weekDayCheckBoxes(firstWeekDay)#</div># } else if (frequency === "monthly") { #<div class="k-edit-label"><label>#:messages.repeatOn#</label></div><div class="k-edit-field"><ul class="k-reset"><li><label><input class="k-recur-month-radio" type="radio" name="month" value="monthday" title="#:messages.day#" />#:messages.day#</label><input class="k-recur-monthday" title="#:messages.day#" /></li><li><input class="k-recur-month-radio" type="radio" name="month" value="weekday" title="#:messages.repeatOn#" /><input class="k-recur-weekday-offset" title="#:messages.repeatOn#" /><input class="k-recur-weekday" title="#:messages.day#" /></li></ul></div># } else if (frequency === "yearly") { #<div class="k-edit-label"><label>#:messages.repeatOn#</label></div><div class="k-edit-field"><ul class="k-reset"><li><input class="k-recur-year-radio" type="radio" name="year" value="monthday" title="#:messages.repeatOn#" /><input class="k-recur-month" title="#:messages.repeatOn#" /><input class="k-recur-monthday" title="#:messages.day#" /></li><li><input class="k-recur-year-radio" type="radio" name="year" value="weekday" title="#:messages.repeatOn#" /><input class="k-recur-weekday-offset" title="#:messages.repeatOn#" /><input class="k-recur-weekday" title="#:messages.day#"  />#:messages.of#<input class="k-recur-month" title="#:messages.of#"/></li></ul></div># } ## if (frequency !== "never") { #<div class="k-edit-label"><label>#:end.label#</label></div><div class="k-edit-field"><ul class="k-reset"><li><label><input class="k-recur-end-never" type="radio" name="end" value="never" />#:end.never#</label></li><li><label><input class="k-recur-end-count" type="radio" name="end" value="count" />#:end.after#</label><input class="k-recur-count" title="#:end.occurrence#" />#:end.occurrence#</li><li><label><input class="k-recur-end-until" type="radio" name="end" value="until" />#:end.on#</label><input class="k-recur-until" title="#:end.on#" /></li></ul></div># } #'),P=[{day:0,offset:0},{day:1,offset:0},{day:2,offset:0},{day:3,offset:0},{day:4,offset:0},{day:5,offset:0},{day:6,offset:0}],B=[{day:1,offset:0},{day:2,offset:0},{day:3,offset:0},{day:4,offset:0},{day:5,offset:0}],L=[{day:0,offset:0},{day:6,offset:0}],H=Y.extend({init:function(e,t){var n,i=this,o=t&&t.frequencies;Y.fn.init.call(i,e,t),i.wrapper=i.element,t=i.options,t.start=n=t.start||X.today(),o&&(t.frequencies=o),"string"==typeof n&&(t.start=q.parseDate(n,"yyyyMMddTHHmmss")),null===t.firstWeekDay&&(t.firstWeekDay=q.culture().calendar.firstDay),i._namespace="."+t.name},options:{value:"",start:"",timezone:"",spinners:!0,firstWeekDay:null,frequencies:["never","daily","weekly","monthly","yearly"],mobile:!1,messages:{recurrenceEditorTitle:"Recurrence editor",frequencies:{never:"Never",hourly:"Hourly",daily:"Daily",weekly:"Weekly",monthly:"Monthly",yearly:"Yearly"},hourly:{repeatEvery:"Repeat every: ",interval:" hour(s)"},daily:{repeatEvery:"Repeat every: ",interval:" day(s)"},weekly:{interval:" week(s)",repeatEvery:"Repeat every: ",repeatOn:"Repeat on: "},monthly:{repeatEvery:"Repeat every: ",repeatOn:"Repeat on: ",interval:" month(s)",day:"Day "},yearly:{repeatEvery:"Repeat every: ",repeatOn:"Repeat on: ",interval:" year(s)",of:" of "},end:{label:"End:",mobileLabel:"Ends",never:"Never",after:"After ",occurrence:" occurrence(s)",on:"On "},offsetPositions:{first:"first",second:"second",third:"third",fourth:"fourth",last:"last"},weekdays:{day:"day",weekday:"weekday",weekend:"weekend day"}}},events:["change"],_initInterval:function(){var e=this,t=e._value;e._container.find(".k-recur-interval").kendoNumericTextBox({spinners:e.options.spinners,value:t.interval||1,decimals:0,format:"#",min:1,change:function(){t.interval=this.value(),e._trigger()}})},_weekDayRule:function(e){var t=this,n=(t._weekDay.element||t._weekDay).val(),i=+(t._weekDayOffset.element||t._weekDayOffset).val(),o=null,r=null;e||("day"===n?(o=P,r=i):"weekday"===n?(o=B,r=i):"weekend"===n?(o=L,r=i):o=[{offset:i,day:+n}]),t._value.weekDays=o,t._value.positions=r},_weekDayView:function(){var e,t,n,i,o=this,r=o._value.weekDays,s=o._value.positions,a=o._weekDayOffset;r&&(n=r.length,s&&(7===n?(t="day",e=s):5===n?(t="weekday",e=s):2===n&&(t="weekend",e=s)),t||(r=r[0],t=r.day,e=r.offset||""),i=a.value?"value":"val",a[i](e),o._weekDay[i](t))},_initWeekDay:function(){var t,n=this,i=n.options.messages.weekdays,o=n.options.messages.offsetPositions,r=n._container.find(".k-recur-weekday"),s=function(){n._weekDayRule(),n._trigger()};r[0]&&(n._weekDayOffset=new Q(n._container.find(".k-recur-weekday-offset"),{change:s,dataTextField:"text",dataValueField:"value",dataSource:[{text:o.first,value:"1"},{text:o.second,value:"2"},{text:o.third,value:"3"},{text:o.fourth,value:"4"},{text:o.last,value:"-1"}]}),t=[{text:i.day,value:"day"},{text:i.weekday,value:"weekday"},{text:i.weekend,value:"weekend"}],n._weekDay=new Q(r,{value:n.options.start.getDay(),change:s,dataTextField:"text",dataValueField:"value",dataSource:t.concat(e.map(q.culture().calendar.days.names,function(e,t){return{text:e,value:t}}))}),n._weekDayView())},_initWeekDays:function(){var t,n,i,o,r,s=this,a=s._value,l=s._container.find(".k-recur-weekday-checkbox");if(l[0]&&(l.on(we+s._namespace,function(){a.weekDays=e.map(l.filter(":checked"),function(e){return{day:+e.value,offset:0}}),s.options.mobile||s._trigger()}),a.weekDays))for(i=0,o=l.length,r=a.weekDays.length;i<o;i++)for(n=l[i],t=0;t<r;t++)n.value==a.weekDays[t].day&&(n.checked=!0)},_initMonthDay:function(){var e=this,t=e._value,n=e._container.find(".k-recur-monthday");n[0]&&(e._monthDay=new q.ui.NumericTextBox(n,{spinners:e.options.spinners,min:1,max:31,decimals:0,format:"#",value:t.monthDays?t.monthDays[0]:e.options.start.getDate(),change:function(){var n=this.value();t.monthDays=n?[n]:n,e._trigger()}}))},_initCount:function(){var e=this,t=e._container.find(".k-recur-count"),n=e._value;e._count=t.kendoNumericTextBox({spinners:e.options.spinners,value:n.count||1,decimals:0,format:"#",min:1,change:function(){n.count=this.value(),e._trigger()}}).data("kendoNumericTextBox")},_initUntil:function(){var e=this,t=e._container.find(".k-recur-until"),n=e.options.start,i=e._value,o=i.until;e._until=t.kendoDatePicker({min:o&&o<n?o:n,value:o||new Date(n.getFullYear(),n.getMonth(),n.getDate(),23,59,59),change:function(){var t=this.value();i.until=new Date(t.getFullYear(),t.getMonth(),t.getDate(),23,59,59),e._trigger()}}).data("kendoDatePicker")},_trigger:function(){this.options.mobile||this.trigger("change")}}),N=H.extend({init:function(e,t){var n=this;H.fn.init.call(n,e,t),n._initFrequency(),n._initContainer(),n.value(n.options.value)},options:{name:"RecurrenceEditor"},events:["change"],destroy:function(){var e=this;e._frequency.destroy(),e._container.find("input[type=radio],input[type=checkbox]").off(we+e._namespace),q.destroy(e._container),H.fn.destroy.call(e)},value:function(e){var n,i=this,o=i.options.timezone;return e===t?i._value.freq?R(i._value,o):"":(i._value=I(e,o)||{},n=i._value.freq,n?i._frequency.value(n):i._frequency.select(0),i._initView(i._frequency.value()),t)},_initContainer:function(){var t=this.element,n=e('<div class="k-recur-view" />'),i=t.parent(".k-edit-field");i[0]?n.insertAfter(i):t.append(n),this._container=n},_initFrequency:function(){var t,n=this,i=n.options,o=i.frequencies,r=i.messages.frequencies,s=e("<input />").attr({title:i.messages.recurrenceEditorTitle});o=e.map(o,function(e){return{text:r[e],value:e}}),t=o[0],t&&"never"===t.value&&(t.value=""),n.element.append(s),n._frequency=new Q(s,{dataTextField:"text",dataValueField:"value",dataSource:o,change:function(){n._value={},n._initView(n._frequency.value()),n.trigger("change")}})},_initView:function(e){var n=this,i=n._value,o=n.options,r={frequency:e||"never",weekDayCheckBoxes:F,firstWeekDay:o.firstWeekDay,messages:o.messages[e],end:o.messages.end};return q.destroy(n._container),n._container.html(z(r)),e?(i.freq=e,"weekly"!==e||i.weekDays||(i.weekDays=[{day:o.start.getDay(),offset:0}]),n._initInterval(),n._initWeekDays(),n._initMonthDay(),n._initWeekDay(),n._initMonth(),n._initCount(),n._initUntil(),n._period(),n._end(),t):(n._value={},t)},_initMonth:function(){var t,n=this,i=n._value,o=i.months||[n.options.start.getMonth()+1],r=n._container.find(".k-recur-month");r[0]&&(t={change:function(){i.months=[+this.value()],n.trigger("change")},dataTextField:"text",dataValueField:"value",dataSource:e.map(q.culture().calendar.months.names,function(e,t){return{text:e,value:t+1}})},n._month1=new Q(r[0],t),n._month2=new Q(r[1],t),o&&(o=o[0],n._month1.value(o),n._month2.value(o)))},_end:function(){var e,t=this,n=t._value,i=t._container,o=t._namespace,r=function(e){t._toggleEnd(e.currentTarget.value),t.trigger("change")};t._buttonNever=i.find(".k-recur-end-never").on(we+o,r),t._buttonCount=i.find(".k-recur-end-count").on(we+o,r),t._buttonUntil=i.find(".k-recur-end-until").on(we+o,r),n.count?e="count":n.until&&(e="until"),t._toggleEnd(e)},_period:function(){var e=this,t=e._value,n="monthly"===t.freq,i=n?e._toggleMonthDay:e._toggleYear,o=".k-recur-"+(n?"month":"year")+"-radio",r=e._container.find(o);(n||"yearly"===t.freq)&&(r.on(we+e._namespace,function(t){i.call(e,t.currentTarget.value),e.trigger("change")}),e._buttonMonthDay=r.eq(0),e._buttonWeekDay=r.eq(1),i.call(e,t.weekDays?"weekday":"monthday"))},_toggleEnd:function(e){var t,n,i,o,r=this;"count"===e?(r._buttonCount.prop("checked",!0),i=!0,o=!1,t=r._count.value(),n=null):"until"===e?(r._buttonUntil.prop("checked",!0),i=!1,o=!0,t=null,n=r._until.value()):(r._buttonNever.prop("checked",!0),i=o=!1,t=n=null),r._count&&r._count.enable(i),r._until&&r._until.enable(o),r._value.count=t,r._value.until=n},_toggleMonthDay:function(e){var t,n=this,i=!1,o=!0,r=!1;"monthday"===e?(n._buttonMonthDay.prop("checked",!0),t=[n._monthDay.value()],i=!0,o=!1,r=!0):(n._buttonWeekDay.prop("checked",!0),t=null),n._weekDay.enable(o),n._weekDayOffset.enable(o),n._monthDay.enable(i),n._value.monthDays=t,n._weekDayRule(r)},_toggleYear:function(e){var t,n=this,i=!1,o=!0;"monthday"===e?(i=!0,o=!1,t=n._month1.value()):t=n._month2.value(),n._month1.enable(i),n._month2.enable(o),n._value.months=[t],n._toggleMonthDay(e)}}),K.plugin(N),O=q.template('<div class="k-edit-label"><label>#:headerTitle#</label></div><div class="k-edit-field k-recur-pattern k-scheduler-toolbar"></div><div class="k-recur-view"></div>'),V=q.template('# if (frequency !== "never") { #<div class="k-edit-label"><label>#:messages.repeatEvery#</label></div><div class="k-edit-field"><input class="k-recur-interval" pattern="\\\\d*"/>#:messages.interval#</div># } ## if (frequency === "weekly") { #<div class="k-edit-label"><label>#:messages.repeatOn#</label></div><div class="k-edit-field">#=weekDayCheckBoxes(firstWeekDay)#</div># } else if (frequency === "monthly") { #<div class="k-edit-label"><label>#:messages.repeatBy#</label></div><div class="k-edit-field k-scheduler-toolbar k-repeat-rule"></div><div class="k-monthday-view" style="display:none"><div class="k-edit-label"><label>#:messages.day#</label></div><div class="k-edit-field"><input class="k-recur-monthday" title="#:messages.day#" pattern="\\\\d*"/></div></div><div class="k-weekday-view" style="display:none"><div class="k-edit-label"><label>#:messages.every#</label></div><div class="k-edit-field"><select class="k-recur-weekday-offset" title="#:messages.every#"></select></div><div class="k-edit-label"><label>#:messages.day#</label></div><div class="k-edit-field"><select class="k-recur-weekday" title="#:messages.day#"></select></div></div># } else if (frequency === "yearly") { #<div class="k-edit-label"><label>#:messages.repeatBy#</label></div><div class="k-edit-field k-scheduler-toolbar k-repeat-rule"></div><div class="k-monthday-view" style="display:none"><div class="k-edit-label"><label>#:messages.day#</label></div><div class="k-edit-field"><input class="k-recur-monthday" title="#:messages.day#" pattern="\\\\d*"/></div></div><div class="k-weekday-view" style="display:none"><div class="k-edit-label"><label>#:messages.every#</label></div><div class="k-edit-field"><select class="k-recur-weekday-offset" title="#:messages.every#"></select></div><div class="k-edit-label"><label>#:messages.day#</label></div><div class="k-edit-field"><select class="k-recur-weekday" title="#:messages.day#"></select></div></div><div class="k-edit-label"><label>#:messages.month#</label></div><div class="k-edit-field"><select class="k-recur-month" title="#:messages.month#"></select></div># } #'),
U=q.template('# if (endPattern === "count") { #<div class="k-edit-label"><label>#:messages.after#</label></div><div class="k-edit-field"><input class="k-recur-count" pattern="\\\\d*" /></div># } else if (endPattern === "until") { #<div class="k-edit-label"><label>#:messages.on#</label></div><div class="k-edit-field"><input type="date" class="k-recur-until" /></div># } #'),W=q.template('<ul class="k-reset k-header k-scheduler-navigation">#for (var i = 0, length = dataSource.length; i < length; i++) {#<li class="k-state-default #= value === dataSource[i].value ? "k-state-selected" : "" #"><a role="button" href="\\#" class="k-link" data-#=ns#value="#=dataSource[i].value#">#:dataSource[i].text#</a></li>#}#</ul>'),j=H.extend({init:function(e,t){var n=this;H.fn.init.call(n,e,t),t=n.options,n._optionTemplate=q.template('<option value="#:value#">#:text#</option>'),n.value(t.value),n._pane=t.pane,n._initRepeatButton(),n._initRepeatEnd(),n._defaultValue=n._value},options:{name:"MobileRecurrenceEditor",animations:{left:"slide",right:"slide:right"},mobile:!0,messages:{cancel:"Cancel",update:"Save",endTitle:"Repeat ends",repeatTitle:"Repeat pattern",headerTitle:"Repeat event",end:{patterns:{never:"Never",after:"After...",on:"On..."},never:"Never",after:"End repeat after",on:"End repeat on"},daily:{interval:""},hourly:{interval:""},weekly:{interval:""},monthly:{interval:"",repeatBy:"Repeat by: ",dayOfMonth:"Day of the month",dayOfWeek:"Day of the week",repeatEvery:"Repeat every",every:"Every",day:"Day "},yearly:{interval:"",repeatBy:"Repeat by: ",dayOfMonth:"Day of the month",dayOfWeek:"Day of the week",repeatEvery:"Repeat every: ",every:"Every",month:"Month",day:"Day"}}},events:["change"],value:function(e){var n=this,i=n.options.timezone;return e===t?n._value.freq?R(n._value,i):"":(n._value=I(e,i)||{},t)},destroy:function(){this._destroyView(),q.destroy(this._endFields),this._repeatButton.off(we+this._namespace),H.fn.destroy.call(this)},_initRepeatButton:function(){var t=this,n=t.options.messages.frequencies[this._value.freq||"never"];t._repeatButton=e('<a href="#" class="k-button k-scheduler-recur">'+n+"</a>").on(we+t._namespace,function(e){e.preventDefault(),t._createView("repeat"),t._pane.navigate("recurrence",t.options.animations.left)}),t.element.append(t._repeatButton)},_initRepeatEnd:function(){var t=this,n=e('<div class="k-edit-label"><label>'+t.options.messages.end.mobileLabel+"</label></div>").insertAfter(t.element.parent(".k-edit-field")),i=e('<div class="k-edit-field"><a href="#" class="k-button k-scheduler-recur-end"></a></div>').on(we+t._namespace,function(e){e.preventDefault(),t._value.freq&&(t._createView("end"),t._pane.navigate("recurrence",t.options.animations.left))}).insertAfter(n);t._endFields=n.add(i).toggleClass("k-state-disabled",!t._value.freq),t._endButton=i.find(".k-scheduler-recur-end").text(t._endText())},_endText:function(){var e=this._value,t=this.options.messages.end,n=t.never;return e.count?n=q.format("{0} {1}",t.after,e.count):e.until&&(n=q.format("{0} {1:d}",t.on,e.until)),n},_initFrequency:function(){var t=this,n=t.options.messages.frequencies,i=W({dataSource:e.map(this.options.frequencies,function(e){return{text:n[e],value:"never"!==e?e:""}}),value:t._value.freq||"",ns:q.ns});t._view.element.find(".k-recur-pattern").append(i).on(we+t._namespace,".k-scheduler-navigation li",function(n){var i=e(this);n.preventDefault(),i.addClass("k-state-selected").siblings().removeClass("k-state-selected"),t._value={freq:i.children("a").attr(q.attr("value"))},t._initRepeatView()})},_initEndNavigation:function(){var t,n=this,i=n.options.messages.end.patterns,o=n._value,r="";o.count?r="count":o.until&&(r="until"),t=W({dataSource:[{text:i.never,value:""},{text:i.after,value:"count"},{text:i.on,value:"until"}],value:r,ns:q.ns}),n._view.element.find(".k-recur-pattern").append(t).on(we+n._namespace,".k-scheduler-navigation li",function(t){var i=e(this),r=null,s=null;t.preventDefault(),i.addClass("k-state-selected").siblings().removeClass("k-state-selected"),n._initEndView(i.children("a").attr(q.attr("value"))),n._count?(r=n._count.value(),s=null):n._until&&(r=null,s=n._until.val?q.parseDate(n._until.val(),"yyyy-MM-dd"):n._until.value()),o.count=r,o.until=s})},_createView:function(t){var n=this,i=n.options,o=i.messages,r=o["repeat"===t?"repeatTitle":"endTitle"],s='<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form k-mobile-list" id="recurrence"><div data-role="header" class="k-header"><a href="#" class="k-button k-scheduler-cancel">'+o.cancel+"</a>"+o.headerTitle+'<a href="#" class="k-button k-scheduler-update">'+o.update+"</a></div>",a=n._pane.view().id;n._view=n._pane.append(s+O({headerTitle:r})),n._view.element.on(we+n._namespace,"a.k-scheduler-cancel, a.k-scheduler-update",function(t){t.preventDefault(),t.stopPropagation(),e(this).hasClass("k-scheduler-update")?(n.trigger("change"),n._defaultValue=e.extend({},n._value)):n._value=n._defaultValue;var i=n._value.freq;n._endButton.text(n._endText()),n._endFields.toggleClass("k-state-disabled",!i),n._repeatButton.text(o.frequencies[i||"never"]),n._pane.one("viewShow",function(){n._destroyView()}),n._pane.navigate(a,n.options.animations.right)}),n._container=n._view.element.find(".k-recur-view"),"repeat"===t?(n._initFrequency(),n._initRepeatView()):(n._initEndNavigation(),n._initEndView())},_destroyView:function(){this._view&&(this._view.destroy(),this._view.element.remove()),this._view=null},_initRepeatView:function(){var e=this,n=e._value.freq||"never",i={frequency:n,weekDayCheckBoxes:F,firstWeekDay:e.options.firstWeekDay,messages:e.options.messages[n]},o=V(i),r=e._container,s=e._value;return q.destroy(r),r.html(o),o?("weekly"!==n||s.weekDays||(s.weekDays=[{day:e.options.start.getDay(),offset:0}]),e._initInterval(),e._initMonthDay(),e._initWeekDays(),e._initWeekDay(),e._initMonth(),e._period(),t):(e._value={},t)},_initEndView:function(e){var n,i=this,o=i._value;e===t&&(o.count?e="count":o.until&&(e="until")),n={endPattern:e,messages:i.options.messages.end},q.destroy(i._container),i._container.html(U(n)),i._initCount(),i._initUntil()},_initWeekDay:function(){var t,n=this,i=n.options.messages.weekdays,o=n.options.messages.offsetPositions,r=n._container.find(".k-recur-weekday"),s=function(){n._weekDayRule(),n.trigger("change")};r[0]&&(n._weekDayOffset=n._container.find(".k-recur-weekday-offset").html(n._options([{text:o.first,value:"1"},{text:o.second,value:"2"},{text:o.third,value:"3"},{text:o.fourth,value:"4"},{text:o.last,value:"-1"}])).change(s),t=[{text:i.day,value:"day"},{text:i.weekday,value:"weekday"},{text:i.weekend,value:"weekend"}],t=t.concat(e.map(q.culture().calendar.days.names,function(e,t){return{text:e,value:t}})),n._weekDay=r.html(n._options(t)).change(s).val(n.options.start.getDay()),n._weekDayView())},_initMonth:function(){var t,n=this,i=n._value,o=n.options.start,r=i.months||[o.getMonth()+1],s=n._container.find(".k-recur-month"),a=q.culture().calendar.months.names;s[0]&&(t=e.map(a,function(e,t){return{text:e,value:t+1}}),s.html(n._options(t)).change(function(){i.months=[+this.value]}),n._monthSelect=s,r&&s.val(r[0]))},_period:function(){var t,n,i,o=this,r=o._value,s=o._container,a=o.options.messages[r.freq],l=s.find(".k-repeat-rule"),c=s.find(".k-weekday-view"),d=s.find(".k-monthday-view");l[0]&&(t=r.weekDays?"weekday":"monthday",n=W({value:t,dataSource:[{text:a.dayOfMonth,value:"monthday"},{text:a.dayOfWeek,value:"weekday"}],ns:q.ns}),i=function(e){var t=o._weekDay.val(),n=o._weekDayOffset.val(),i=o._monthDay.value(),s=o._monthSelect?o._monthSelect.val():null;"monthday"===e?(r.weekDays=null,r.monthDays=i?[i]:i,r.months=s?[+s]:s,c.hide(),d.show()):(r.monthDays=null,r.months=s?[+s]:s,r.weekDays=[{offset:+n,day:+t}],c.show(),d.hide())},l.append(n).on(we+o._namespace,".k-scheduler-navigation li",function(t){var n,o=e(this).addClass("k-state-selected");t.preventDefault(),o.siblings().removeClass("k-state-selected"),n=o.children("a").attr(q.attr("value")),i(n)}),i(t))},_initUntil:function(){var e=this,t=e._container.find(".k-recur-until"),n=e.options.start,i=e._value,o=i.until,r=o&&o<n?o:n;e._until=q.support.input.date?t.attr("min",q.toString(r,"yyyy-MM-dd")).val(q.toString(o||n,"yyyy-MM-dd")).on("change",function(){i.until=q.parseDate(this.value,"yyyy-MM-dd")}):t.kendoDatePicker({min:r,value:o||n,change:function(){i.until=this.value()}}).data("kendoDatePicker")},_options:function(e,t){var n=0,i="",o=e.length,r=this._optionTemplate;for(t&&(i+=r({value:"",text:t}));n<o;n++)i+=r(e[n]);return i}}),K.plugin(j)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.scheduler.timelineview.min",["kendo.scheduler.view.min"],e)}(function(){return function(e,t){function n(e){var t=new Date(1980,1,1,0,0,0);return d(t,v(e)),t}function i(e){var t=[],n=e.workWeekStart%7,i=Math.abs(e.workWeekEnd%7);for(t.push(n);i!=n;)n>6?n-=7:n++,t.push(n);return t}function o(e){var t,n=0;if(e.columns){for(t=0;t<e.columns.length;t++)n+=o(e.columns[t]);return e.colspan=n,n}return e.colspan=1,1}function r(e,t,n){var i,o,r,a;for(i=e.length-1;i>=0;i--)o=e[i].rectLeft,a=e[i].rectRight,r=o<=t&&a>=t,(r||o>=t&&a<=n||t<=o&&n>=o)&&(o<t&&(t=o),a>n&&(n=a));return s(e,t,n)}function s(e,t,n){var i,o,r=[];for(i=0;i<e.length;i++)o={rectLeft:e[i].rectLeft,rectRight:e[i].rectRight},(o.rectLeft<t&&o.rectRight>t||o.rectLeft>=t&&o.rectRight<=n)&&r.push(e[i]);return r}var a,l=window.kendo,c=l.ui,d=l.date.setTime,u=c.SchedulerView,h=l._outerWidth,f=l._outerHeight,p=e.extend,m=e.proxy,g=l.date.getDate,v=l.date.getMilliseconds,_=l.date.MS_PER_DAY,b=l.date.MS_PER_MINUTE,w="k-current-time",y="k-current-time-arrow",k="k-scheduler-header-wrap",x=.8666,C=".kendoTimelineView",S=l.template('<div><div class="k-event-template k-event-time">#:kendo.format("{0:t} - {1:t}", start, end)#</div><div class="k-event-template">${title}</div></div>'),T=l.template("<span class='k-link k-nav-day'>#=kendo.format('{0:m}', date)#</span>"),D='<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#"#if (resources[0]) { #style="background-color:#=resources[0].color#; border-color: #=resources[0].color#"class="k-event#=inverseColor ? " k-event-inverse" : ""#" #} else {#class="k-event"#}#><span class="k-event-actions"># if(data.tail) {#<span class="k-icon k-i-arrow-60-left"></span>#}## if(data.isException()) {#<span class="k-icon k-i-non-recurrence"></span># } else if(data.isRecurring()) {#<span class="k-icon k-i-reload"></span># } #</span>{0}<span class="k-event-actions">#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}## if(data.head) {#<span class="k-icon k-i-arrow-60-right"></span>#}#</span>#if(resizable && !data.tail){#<span class="k-resize-handle k-resize-w"></span>#}##if(resizable && !data.head){#<span class="k-resize-handle k-resize-e"></span>#}#</div>',A=l.Class.extend({init:function(e){this._view=e},_getTimeSlotByPosition:function(e,t,n){var i=this._view.groups[n];return i.timeSlotByPosition(e,t)},_hideHeaders:function(){var e=this._view;e.timesHeader.find("table tr:last").hide(),e.datesHeader.find("table tr:last").hide()},_setColspan:function(e){o(e)},_createRowsLayout:function(e,t,n){var i=this._view;return i._createRowsLayout(e,t,n)},_createVerticalColumnsLayout:function(e,t,n,i){return i},_createColumnsLayout:function(e,t,n){var i=this._view;return i._createColumnsLayout(e,t,n)},_getRowCount:function(){var e=this._view;return e._groupCount()},_getGroupsCount:function(){return 1},_addContent:function(e,t,n,i,o,r,s,a){var c,d,u,h,f=this._view,p="",m=f.options,g=function(t){var n,i="",o="",r=function(e){return function(){return f._resourceBySlot({groupIndex:e})}};return l.date.isToday(e[u])&&(o+="k-today"),(l.date.getMilliseconds(t)<l.date.getMilliseconds(m.workDayStart)||l.date.getMilliseconds(t)>=l.date.getMilliseconds(m.workDayEnd)||!f._isWorkDay(e[u]))&&(o+=" k-nonwork-hour"),i+="<td"+(""!==o?' class="'+o+'"':"")+">",n=l.date.getDate(e[u]),l.date.setTime(n,l.date.getMilliseconds(t)),i+=s({date:n,resources:r(a?c:d)}),i+="</td>"};for(c=0;c<i;c++){for(p+="<tr>",d=0;d<n;d++)for(u=0,h=t;u<h;u++)p+=f._forTimeRange(o,r,g);p+="</tr>"}return p},_addTimeSlotsCollections:function(e,t,n,i,o){var r,s,a,l,c,d,u,h,f,p,m,g,_=this._view,b=n.length;for(o&&(b=Math.floor(b/e)),r=0;r<e;r++)for(s=0,a=_.groups[r],o&&(s=r),c=s*b,d=0,o||(d=r),u=n[c].children,h=u.length/(o?1:e),f=h/t,p=0;p<t;p++)for(m=p*f+h*d,l=v(new Date((+_.startTime()))),g=0;g<f;g++)_._addTimeSlotToCollection(a,u,g,m,p,l,i),l+=i},_getVerticalGroupCount:function(e){return e},_getVerticalRowCount:function(e,t,n){var i=this._view;return i._isVerticallyGrouped()?e[t].maxRowCount:n},_renderEvent:function(e,t,n,i,o,r){var s,a=this._view,l=a._createEventElement(n.occurrence,t,o.head||n.head,o.tail||n.tail);l.appendTo(r).css({top:0,height:a.options.eventHeight}),s={start:n.occurrence._startTime||n.occurrence.start,end:n.occurrence._endTime||n.occurrence.end,element:l,uid:t.uid,slotRange:o,rowIndex:0,offsetTop:0},e.events[t.uid]=s,a.addContinuousEvent(i,o,l,t.isAllDay),a._arrangeRows(s,o,e)},_verticalCountForLevel:function(e){var t=this._view;return t._rowCountForLevel(e)},_horizontalCountForLevel:function(e){var t=this._view;return t._columnCountForLevel(e)},_updateCurrentVerticalTimeMarker:function(t,n){var i=this._view,o="<div class='"+w+"'></div>",r=i.datesHeader.find("."+k),s=Math.round(t[0].innerRect(n,new Date(n.getTime()+1),!1).left),a=e(o).prependTo(r).addClass(y+"-down");a.css({left:i._adjustLeftPosition(s-h(a)*x/2),top:r.find("tr:last").prev().position().top}),e(o).prependTo(i.content).css({left:i._adjustLeftPosition(s),width:"1px",height:i.content[0].scrollHeight-1,top:0})},_changeGroup:function(){return t},_prevGroupSlot:function(e,t,n){var i,o=this._view;return o._isVerticallyGrouped()?e:(i=t._collection(0,n),i.last())},_nextGroupSlot:function(e,t,n){var i,o=this._view;return o._isVerticallyGrouped()?e:(i=t._collection(0,n),i.first())},_verticalSlots:function(e,t){var n=this._view;return n._changeGroup(e,t)},_verticalMethod:function(e){return e?"leftSlot":"rightSlot"},_normalizeVerticalSelection:function(){return t},_horizontalSlots:function(e,t,n,i,o,r,s){var a=this._view,l={};return l.startSlot=t[n](i),l.endSlot=t[n](o),r||!a._isHorizontallyGrouped()||l.startSlot&&l.endSlot||(l.startSlot=l.endSlot=a._changeGroup(e,s)),l},_changeVerticalViewPeriod:function(){return!1},_changeHorizontalViewPeriod:function(e,t,n,i){var o=this._view;return!(e.startSlot&&e.endSlot||t||!o._changeViewPeriod(n,i,!1))},_updateDirection:function(e,t,n,i){var o=this._view;o._updateDirection(e,t,n,i,!0)},_createMoveHint:function(e,t){var n,i,o,r,s=this._view,a=e.start,l=s._createEventElement(t.occurrence,t.occurrence,!1,!1);l.addClass("k-event-drag-hint"),n=e.innerRect(t.occurrence.start,t.occurrence.end,s.options.snap),i=n.right-n.left-2,i<0&&(i=0),o=s._adjustLeftPosition(n.left),r={left:o,top:a.offsetTop,height:a.offsetHeight-2,width:i},l.css(r),s._appendMoveHint(l)},_adjustLeftPosition:function(e){var t=this._view;return t._isRtl&&(e-=t.content[0].scrollWidth-t.content[0].offsetWidth),e}}),E=l.Class.extend({init:function(e){this._view=e},_getTimeSlotByPosition:function(e,t,n){var i=this._view.groups[n];return i.timeSlotByPosition(e,t,!0)},_hideHeaders:function(){var e=this._view;e._isVerticallyGrouped()?e.times.find(".k-last").hide():(e.timesHeader.find("table tr").eq(2).hide(),e.datesHeader.find("table tr").eq(2).hide())},_setColspan:function(){},_createRowsLayout:function(e,t,n,i){var o=this._view;return o._createDateLayout(i,null,!0)},_createVerticalColumnsLayout:function(e,t,n){var i=this._view;return i._createColumnsLayout(e,null,n)},_createColumnsLayout:function(e,t,n,i){var o=this._view;return o._createColumnsLayout(e,t,n,i,!0)},_getRowCount:function(e){var t=this._view;return t._rowCountForLevel(e)},_getGroupsCount:function(){var e=this._view;return e._groupCount()},_addContent:function(e,t,n,i,o,r,s,a){var c,u,h,f,p=this._view,m="",g=p.options,v=function(t,n,i,o,r,a){var d,u="",f="",m=p._isVerticallyGrouped()?c:h,v=function(e){return function(){return p._resourceBySlot({groupIndex:e})}};return l.date.isToday(e[h])&&(f+="k-today"),(l.date.getMilliseconds(t)<l.date.getMilliseconds(g.workDayStart)||l.date.getMilliseconds(t)>=l.date.getMilliseconds(g.workDayEnd)||!p._isWorkDay(e[m]))&&(f+=" k-nonwork-hour"),u+="<td"+(""!==f?' class="'+f+'"':"")+">",d=l.date.getDate(e[h]),l.date.setTime(d,l.date.getMilliseconds(t)),u+=s({date:d,resources:v(a)}),u+="</td>"},_=new Date(o),w=p.options.minorTickCount,y=p.options.majorTick*b,k=y/w||1;for(u=0;u<i;u++){for(m+="<tr>",u%(i/p._dates.length)===0&&(c=u/(i/p._dates.length),_=new Date(p._dates[c]),l.date.setTime(_,l.date.getMilliseconds(o))),h=0,f=t;h<f;h++)if(m+=p._forTimeRange(_,r,v,a,n),a){d(_,k,!1);break}m+="</tr>"}return m},_addTimeSlotsCollections:function(e,t,n,i,o){var r,s,a,l,c,d,u,h,f,p,m,g,_=this._view,b=n.length;for(o&&(b/=t),r=0;r<t;r++)for(s=0,o&&(s=r),l=s*b,c=0,d=n[l].children,u=o?b:d.length/(t*e),h=d.length/t,a=v(new Date((+_.startTime()))),p=0;p<u;p++){for(o?(f=0,d=n[p+u*r].children):(f=r*h+e*p,c++),m=0;m<e;m++)g=_.groups[m],_._addTimeSlotToCollection(g,d,m,f,r,a,i);a+=i}},_getVerticalGroupCount:function(){var e=this._view;return e.content.find("tr").length},_getVerticalRowCount:function(e,t,n){return n},_renderEvent:function(e,t,n,i,o,r,s,a){var l,c,d,u,h,f=this._view,p=[];for(c=o.start.index;c<=o.end.index;c++)l=f._createEventElement(n.occurrence,t,c!==a,c!==s),l.appendTo(r).css({top:0,height:f.options.eventHeight}),d=i._timeSlotCollections[0]._slots[c],u=i.timeSlotRanges(d.start,d.end,!1)[0],h={start:c===s?n.occurrence._startTime||n.occurrence.start:d.start,end:c===a?n.occurrence._endTime||n.occurrence.end:d.end,element:l,uid:t.uid,slotRange:u,rowIndex:0,offsetTop:0},e.events[t.uid]=h,p.push(h),f.addContinuousEvent(i,u,l,t.isAllDay),f._arrangeRows(h,u,e);e.events[t.uid]=p},_verticalCountForLevel:function(e){var t=this._view;return t._columnCountForLevel(e)},_horizontalCountForLevel:function(e,t){var n=this._view;return n._columnCountForLevel(t)/n._columnCountForLevel(2)},_updateCurrentVerticalTimeMarker:function(t,n){var i=this._view,o=i.times.find("tr:first th:first"),r=i.times.find("tr:first th:last"),s="<div class='"+w+"'></div>",a=e(s).prependTo(i.times),l=Math.round(t[0].innerRect(n,new Date(n.getTime()+1),!1).top),c={};this._isRtl?(c.right=o.position().left+f(o)-f(r),a.addClass(y+"-left")):(c.left=r.position().left,a.addClass(y+"-right")),c.top=l-h(a)*x/2,a.css(c),e(s).prependTo(i.content).css({top:l,height:"1px",right:"1px",width:i.content[0].scrollWidth,left:0})},_changeGroup:function(e,t,n){var i=this._view;n||(e.groupIndex=t?i.groups.length-1:0)},_prevGroupSlot:function(e){return e},_nextGroupSlot:function(e){return e},_changeDate:function(e,t,n){var i,o,r=this._view,s=r.groups[e.groupIndex];if(t){if(i=s._getCollections(!1),o=n.index-1,o>=0)return i[0]._slots[o]}else if(i=s._getCollections(!1),o=n.index+1,i[0]&&i[0]._slots[o])return i[0]._slots[o]},_verticalSlots:function(e,t,n){return this._changeDate(e,t,n)},_verticalMethod:function(e,t){return t?e?"upSlot":"downSlot":e?"leftSlot":"rightSlot"},_normalizeVerticalSelection:function(e,n,i,o){var r=this._view;return o?t:r._normalizeVerticalSelection(e,n,i)},_horizontalSlots:function(e,t,n,i,o,r,s){var a=this._view,l=a._changeGroup(e,s),c={};return l?c.startSlot=c.endSlot=l:a._isVerticallyGrouped()||(c.startSlot=t[n](i),c.endSlot=t[n](o)),c},_changeVerticalViewPeriod:function(e,t,n,i){var o=this._view;return!(e.startSlot&&e.endSlot||t||!o._changeViewPeriod(n,i,o._isVerticallyGrouped()))},_changeHorizontalViewPeriod:function(e,t,n,i){var o=this._view;return!o._isVerticallyGrouped()&&!(e.startSlot&&e.endSlot||t||!o._changeViewPeriod(n,i,!1))},_updateDirection:function(e,t,n,i){var o=this._view;o._updateDirection(e,t,n,i,!o._isVerticallyGrouped())},_createMoveHint:function(e,t){var n,i,o,r,s=this._view,a=e.start,l=e.end;for(n=a.index;n<=l.index;n++)i=e.collection._slots[n],o=s._createEventElement(t.occurrence,t.occurrence,!1,!1),o.addClass("k-event-drag-hint"),r={left:i.offsetLeft+2,top:i.offsetTop,height:s.options.eventHeight,width:i.offsetWidth},o.css(r),s._appendMoveHint(o)},_adjustLeftPosition:function(e){var t=this._view;return t._isRtl&&!t._isVerticallyGrouped()&&(e-=t.content[0].scrollWidth-t.content[0].offsetWidth),e}});l.ui.scheduler.TimelineGroupedView=A,l.ui.scheduler.TimelineGroupedByDateView=E,a=u.extend({init:function(e,t){var n=this;u.fn.init.call(n,e,t),n._groupedView=n._getGroupedView(),n.title=n.options.title||n.options.name,n._workDays=i(n.options),n._templates(),n._editable(),n.calculateDateRange(),n._groups(),n._currentTime(!0)},name:"timeline",_getGroupedView:function(){return this._isGroupedByDate()?new l.ui.scheduler.TimelineGroupedByDateView(this):new l.ui.scheduler.TimelineGroupedView(this)},_getNextEventIndexBySlot:function(e,t,n){var i,o;if(this._isVerticallyGrouped())return l.ui.SchedulerView.fn._getNextEventIndexBySlot.call(this,e,t,n);for(i=0,o=0;o<t.length;o++)if(e.startDate()>t[o].start.startDate())i++;else{if(!(e.startDate().getTime()===t[o].start.startDate().getTime()&&n>t[o].start.groupIndex))break;i++}return i},_getSelectedSlot:function(e,t,n,i,o,r){return this._isVerticallyGrouped()?l.ui.SchedulerView.fn._getSelectedSlot.call(this,e,t,n,i,o,r):e},_getSortedEvents:function(t){return this._isVerticallyGrouped()?l.ui.SchedulerView.fn._getSortedEvents.call(this,t):t.sort(function(t,n){var i=t.start.startDate().getTime()-n.start.startDate().getTime();return 0===i&&(t.start.isDaySlot&&!n.start.isDaySlot&&(i=-1),!t.start.isDaySlot&&n.start.isDaySlot&&(i=1)),0===i&&(i=t.start.groupIndex-n.start.groupIndex),0===i&&(i=e(t.element).index()-e(n.element).index()),i})},_currentTimeMarkerUpdater:function(){this._updateCurrentTimeMarker(new Date)},_updateCurrentTimeMarker:function(t){var n,i,o,r,s,a,c,d,u,f,p,m,g,v=this.options;if(this.datesHeader.find("."+w).remove(),this.times.find("."+w).remove(),this.content.find("."+w).remove(),this._isInDateSlot({start:t,end:t}))for(v.currentTimeMarker.useLocalTimezone===!1&&(n=v.dataSource.options.schema.timezone,v.dataSource&&n&&(i=l.timezone.offset(t,n),t=l.timezone.convert(t,t.getTimezoneOffset(),i))),o=v.group&&"vertical"!=v.group.orientation?this.groups.length:1,r=0;r<o;r++){if(s=this.groups[r],!s)return;if(a=l.date.toUtcTime(t),c=s.timeSlotRanges(a,a+1),0===c.length)return;d=c[0].collection,u=d.slotByStartDate(t),u&&(this._isVerticallyGrouped()?this._groupedView._updateCurrentVerticalTimeMarker(c,t):(f="<div class='"+w+"'></div>",p=this.datesHeader.find("."+k),m=Math.round(c[0].innerRect(t,new Date(t.getTime()+1),!1).left),g=e(f).prependTo(p).addClass(y+"-down"),g.css({left:this._adjustLeftPosition(m-h(g)*x/2),top:p.find("tr:last").prev().position().top}),e(f).prependTo(this.content).css({left:this._adjustLeftPosition(m),width:"1px",height:this.content[0].scrollHeight-1,top:0})))}},_adjustLeftPosition:function(e){return this._groupedView._adjustLeftPosition(e)},_currentTime:function(e){var n=this,i=n.options.currentTimeMarker;i!==!1&&i.updateInterval!==t&&(n._currentTimeMarkerUpdater(),e&&(n._currentTimeUpdateTimer=setInterval(m(this._currentTimeMarkerUpdater,n),i.updateInterval)))},_editable:function(){this.options.editable&&(this._isMobile()?this._touchEditable():this._mouseEditable())},_mouseEditable:function(){var t=this;t.element.on("click"+C,".k-event a:has(.k-i-close)",function(n){t.trigger("remove",{uid:e(this).closest(".k-event").attr(l.attr("uid"))}),n.preventDefault()}),t.options.editable.create!==!1&&t.element.on("dblclick"+C,".k-scheduler-content td",function(e){var n,i=t._slotByPosition(e.pageX,e.pageY);i&&(n=t._resourceBySlot(i),t.trigger("add",{eventInfo:p({start:i.startDate(),end:i.endDate()},n)})),e.preventDefault()}),t.options.editable.update!==!1&&t.element.on("dblclick"+C,".k-event",function(n){t.trigger("edit",{uid:e(this).closest(".k-event").attr(l.attr("uid"))}),n.preventDefault()})},_touchEditable:function(){var n=this,i=0;l.support.mobileOS.android&&(i=5),n.options.editable.create!==!1&&(n._addUserEvents=new l.UserEvents(n.element,{threshold:i,filter:".k-scheduler-content td",tap:function(e){var i,o=e.x.location!==t?e.x.location:e.x,r=e.y.location!==t?e.y.location:e.y,s=n._slotByPosition(o,r);s&&(i=n._resourceBySlot(s),n.trigger("add",{eventInfo:p({start:s.startDate(),end:s.endDate()},i)})),e.preventDefault()}})),n.options.editable.update!==!1&&(n._editUserEvents=new l.UserEvents(n.element,{threshold:i,filter:".k-event",tap:function(t){var i=e(t.target).closest(".k-event");i.hasClass("k-event-active")||n.trigger("edit",{uid:i.attr(l.attr("uid"))}),t.preventDefault()}}))},_slotByPosition:function(e,t){var n,i,o,r=this.content,s=r.offset();for(e-=s.left,t-=s.top,this._isRtl?(o=l.support.browser,o.mozilla?(e+=r[0].scrollWidth-r[0].offsetWidth,e+=r[0].scrollLeft):o.msie?(e-=r.scrollLeft(),e+=r[0].scrollWidth-r[0].offsetWidth):o.webkit&&(e+=r[0].scrollLeft)):e+=r[0].scrollLeft,t+=r[0].scrollTop,e=Math.ceil(e),t=Math.ceil(t),i=0;i<this.groups.length;i++)if(n=this._groupedView._getTimeSlotByPosition(e,t,i))return n;return null},options:{name:"TimelineView",title:"Timeline",selectedDateFormat:"{0:D}",selectedShortDateFormat:"{0:d}",date:l.date.today(),startTime:l.date.today(),endTime:l.date.today(),showWorkHours:!1,minorTickCount:2,editable:!0,workDayStart:new Date(1980,1,1,8,0,0),workDayEnd:new Date(1980,1,1,17,0,0),workWeekStart:1,workWeekEnd:5,majorTick:60,eventHeight:25,eventMinWidth:0,columnWidth:100,groupHeaderTemplate:"#=text#",majorTimeHeaderTemplate:"#=kendo.toString(date, 't')#",slotTemplate:"&nbsp;",eventTemplate:S,dateHeaderTemplate:T,footer:{command:"workDay"},currentTimeMarker:{updateInterval:1e4,useLocalTimezone:!0},messages:{defaultRowText:"All events",showFullDay:"Show full day",showWorkDay:"Show business hours"}},events:["remove","add","edit"],_templates:function(){var e=this.options,t=p({},l.Template,e.templateSettings);this.eventTemplate=this._eventTmpl(e.eventTemplate,D),this.majorTimeHeaderTemplate=l.template(e.majorTimeHeaderTemplate,t),this.dateHeaderTemplate=l.template(e.dateHeaderTemplate,t),this.slotTemplate=l.template(e.slotTemplate,t),this.groupHeaderTemplate=l.template(e.groupHeaderTemplate,t)},_render:function(t){var n=this;t=t||[],n._dates=t,n._startDate=t[0],n._endDate=t[t.length-1||0],n._calculateSlotRanges(),n.createLayout(n._layout(t)),n._content(t),n._footer(),n._setContentWidth(),n.refreshLayout(),n.datesHeader.on("click"+C,".k-nav-day",function(t){var i=e(t.currentTarget).closest("th"),o=n._slotByPosition(i.offset().left,n.content.offset().top);n.trigger("navigate",{view:"timeline",date:o.startDate()})}),n._groupedView._hideHeaders()},_setContentWidth:function(){var e=this.content,t=e.width(),n=this.content.find("table"),i=n.find("tr:first").children().length,o=100,r=i*this.options.columnWidth;t<r&&(o=Math.ceil(r/t*100)),n.add(this.datesHeader.find("table")).css("width",o+"%")},_calculateSlotRanges:function(){var e,t,n,i,o=this._dates,r=this.startTime(),s=this.endTime();for(s=v(s),r=v(r),s===r?s+=_-1:s<r&&(s+=_),e=[],t=0;t<o.length;t++)n=g(o[t]),d(n,r),i=g(o[t]),d(i,s),e.push({start:l.date.toUtcTime(n),end:l.date.toUtcTime(i)});this._slotRanges=e},_forTimeRange:function(e,t,i,o,r){var s,a,l,c,u,h,f,p,m,g,w,y,k,x,C,S;for(e=n(e),t=n(t),s=this,a=v(e),l=v(t),c=s.options.minorTickCount,u=s.options.majorTick*b,h=u/c||1,f=new Date((+e)),p=0,g="",m=_/h,a!=l&&(a>l&&(l+=_),m=(l-a)/h),m=o?1:Math.round(m),r&&(m*=r);p<m;p++)w=p%(u/h),y=0===w,k=w<c-1,x=w===c-1,C=c,m%c!==0&&(S=m-(p+1)<c,y&&S&&(C=m%c)),g+=i(f,y,k,x,C,p%r),o||(r?p%r===r-1&&d(f,h,!1):d(f,h,!1));return g},_layout:function(e){var t,n,i,o=[],r=[],s=this,a=[{text:s.options.messages.defaultRowText}],l=s._groupedView,c=[];for(t=0;t<s.options.minorTickCount;t++)c.push({text:"&#8203;",className:"k-last",minorTicks:!0});for(this._forTimeRange(s.startTime(),s.endTime(),function(e,t,n,i,r){var a,d=s.majorTimeHeaderTemplate;t&&(a={text:d({date:e}),className:i?"k-slot-cell":"",columns:c.slice(0,r)},l._setColspan(a),o.push(a))}),n=0;n<e.length;n++)r.push({text:s.dateHeaderTemplate({date:e[n]}),className:"k-slot-cell",columns:o.slice(0)});return i=this.groupedResources,i.length&&("vertical"===this._groupOrientation()?(a=l._createRowsLayout(i,null,this.groupHeaderTemplate,r),r=l._createVerticalColumnsLayout(i,null,this.groupHeaderTemplate,r)):r=l._createColumnsLayout(i,r,this.groupHeaderTemplate,r)),{columns:r,rows:a}},_footer:function(){var t,n,i,o=this.options;o.footer!==!1&&(t='<div class="k-header k-scheduler-footer">',n=o.footer.command,n&&"workDay"===n?(t+='<ul class="k-reset k-header">',t+='<li class="k-state-default k-scheduler-fullday"><a href="#" class="k-link"><span class="k-icon k-i-clock"></span>',t+=(o.showWorkHours?o.messages.showFullDay:o.messages.showWorkDay)+"</a></li>",t+="</ul>"):t+="&nbsp;",t+="</div>",this.footer=e(t).appendTo(this.element),i=this,this.footer.on("click"+C,".k-scheduler-fullday",function(e){e.preventDefault(),i.trigger("navigate",{view:i.name||o.name,date:i.startDate(),isWorkDay:!o.showWorkHours})}))},_columnCountForLevel:function(e){var t=this.columnLevels[e];return t?t.length:0},_rowCountForLevel:function(e){var t=this.rowLevels[e];return t?t.length:0},_isWorkDay:function(e){var t,n=e.getDay(),i=this._workDays;for(t=0;t<i.length;t++)if(i[t]===n)return!0;return!1},_content:function(e){var t=this,n=t.startTime(),i=this.endTime(),o=1,r=1,s=e.length,a="",l=this.groupedResources,c=this.slotTemplate,d=!1;l.length&&(d="vertical"===t._groupOrientation(),d?(r=t._groupedView._getRowCount(this.rowLevels.length-1),o=t._groupedView._getGroupsCount()):o=t._groupCount()),a+="<tbody>",a+=t._groupedView._addContent(e,s,o,r,n,i,c,d),a+="</tbody>",this.content.find("table").append(a)},_groups:function(){var e,t,n,i,o,r,s=this._groupCount(),a=this._dates,c=a.length;for(this.groups=[],e=0;e<s;e++)t=this._addResourceView(e),n=a[0],i=a[a.length-1||0],o=v(this.startTime()),r=v(this.endTime()),0!==o&&r<=o&&(n=g(n),d(n,o),i=g(i),d(i,r)),t.addTimeSlotCollection(n,l.date.addDays(i,1));this._timeSlotGroups(s,c)},_isHorizontallyGrouped:function(){return this.groupedResources.length&&"horizontal"===this._groupOrientation()},_timeSlotGroups:function(e,t){var n=this._timeSlotInterval(),i=this._isVerticallyGrouped(),o=this.content.find("tr");o.attr("role","row"),this._groupedView._addTimeSlotsCollections(e,t,o,n,i)},_addTimeSlotToCollection:function(e,t,n,i,o,r,s){var a=t[n+i],l=e.getTimeSlotCollection(0),c=this._dates[o],d=Date.UTC(c.getFullYear(),c.getMonth(),c.getDate()),u=d+r,h=u+s;a.setAttribute("role","gridcell"),a.setAttribute("aria-selected",!1),l.addTimeSlot(a,u,h,!0)},startDate:function(){return this._startDate},endDate:function(){return this._endDate},visibleEndDate:function(){var e=v(this.startTime()),t=v(this.endTime()),n=this.endDate();return 0!==e&&t<=e&&(n=l.date.addDays(n,1)),n},startTime:function(){var e=this.options;return e.showWorkHours?e.workDayStart:e.startTime},endTime:function(){var e=this.options;return e.showWorkHours?e.workDayEnd:e.endTime},_timeSlotInterval:function(){var e=this.options;return e.majorTick/e.minorTickCount*b},nextDate:function(){return l.date.nextDay(this.endDate())},previousDate:function(){return l.date.previousDay(this.startDate())},calculateDateRange:function(){this._render([this.options.date])},render:function(e){var t,n,i,o,r;for(this._headerColumnCount=0,this._groups(),this.element.find(".k-event").remove(),e=new l.data.Query(e).sort([{field:"start",dir:"asc"},{field:"end",dir:"desc"}]).toArray(),t=[],this._eventsByResource(e,this.groupedResources,t),n=[],i=0,o=0;o<t.length;o++)r={groupIndex:o,maxRowCount:0,events:{}},n.push(r),this._renderEvents(t[o],o,r),i<r.maxRowCount&&(i=r.maxRowCount);this._setRowsHeight(n,t.length,i),this._positionEvents(n,t.length),this._currentTime(!1),this.trigger("activate")},
_positionEvents:function(t,n){var i,o,r,s,a;for(i=0;i<n;i++){o=t[i].events;for(r in o)if(s=o[r],e.isArray(s))for(a=0;a<s.length;a++)this._positionEvent(s[a]);else this._positionEvent(s)}},_setRowsHeight:function(t,n,i){var o,r,s,a,l,c=this.options.eventHeight+2,d=this._getBottomRowOffset(),u=this._groupedView,h=u._getVerticalGroupCount(n);for(n=this._isVerticallyGrouped()?h:1,o=0;o<n;o++)r=u._getVerticalRowCount(t,o,i),r=r?r:1,s=(c+2)*r+d,a=e(this.times.find("tr")[o]),l=e(this.content.find("tr")[o]),a.height(s),l.height(s);this._setContentWidth(),this.refreshLayout(),this._refreshSlots()},_getBottomRowOffset:function(){var e,t,n=.5*this.options.eventHeight,i=this._isMobile();return i?(e=30,t=60):(e=15,t=30),n>t?n=t:n<e&&(n=e),n},_positionEvent:function(e){var t,n,i,o=this.options.eventHeight+2,r=e.slotRange.innerRect(e.start,e.end,!1),s=this._adjustLeftPosition(r.left),a=r.right-r.left-2;a<0&&(a=0),a<this.options.eventMinWidth&&(t=e.slotRange.collection,n=t._slots[t._slots.length-1],i=n.offsetLeft+n.offsetWidth,a=this.options.eventMinWidth,i<s+a&&(a=i-r.left-2)),e.element.css({top:e.slotRange.start.offsetTop+e.rowIndex*(o+2)+"px",left:s,width:a})},_refreshSlots:function(){for(var e=0;e<this.groups.length;e++)this.groups[e].refresh()},_eventsByResource:function(e,t,n){var i,o,r,s,a=t[0];if(a)for(i=a.dataSource.view(),o=0;o<i.length;o++)r=this._resourceValue(a,i[o]),s=new l.data.Query(e).filter({field:a.field,operator:u.groupEqFilter(r)}).toArray(),t.length>1?this._eventsByResource(s,t.slice(1),n):n.push(s);else n.push(e)},_isInDateSlot:function(e){var t=e.start,n=e.end,i=g(this._startDate),o=l.date.addDays(g(this.visibleEndDate()),1);return t<o&&i<=n},_isInTimeSlot:function(e){var t,n=e._startTime||l.date.toUtcTime(e.start),i=e._endTime||l.date.toUtcTime(e.end),o=this._slotRanges;for(n===i&&(i+=1),t=0;t<o.length;t++)if(n<o[t].end&&o[t].start<i)return!0;return!1},_adjustEvent:function(e){var t,n=e.start,i=e.end,o=e._time("start"),r=e._time("end"),s=v(this.startTime()),a=v(this.endTime()),c=null,u=null,h=!1,f=!1;return e.isAllDay&&(n=g(n),o=0,i=g(i),r=_,u=l.date.addDays(i,1)),0===a&&(a=_),a<=s?(o<s&&o>=a&&(c=g(n),d(c,s),f=!0),r>a&&r<=s&&(u=g(i),d(u,a),h=!0)):(s>o?(c=g(n),d(c,s),f=!0):a<=o&&(c=g(n),c=l.date.addDays(c,1),d(c,s),f=!0),a<r?(u=g(i),d(u,a),h=!0):s>r&&(u=g(i),u=l.date.addDays(u,-1),d(u,a),h=!0)),t=e.clone({start:c?c:n,end:u?u:i,_startTime:c?l.date.toUtcTime(c):e._startTime,_endTime:u?l.date.toUtcTime(u):e._endTime,isAllDay:!1}),{occurrence:t,head:h,tail:f}},_renderEvents:function(e,t,n){var i,o,r,s,a,l,c,d,u,h,f;for(o=0,r=e.length;o<r;o++)i=e[o],this._isInDateSlot(i)&&(s=i.isAllDay||i.duration()>=_,a=this.content,(s||this._isInTimeSlot(i))&&(l=this._adjustEvent(i),c=this.groups[t],c._continuousEvents||(c._continuousEvents=[]),this._isInTimeSlot(l.occurrence)&&(d=c.slotRanges(l.occurrence,!1),u=d[0],h=u.start.index,f=u.end.index,this._groupedView._renderEvent(n,i,l,c,u,a,h,f))))},addContinuousEvent:function(e,t,n,i){var o=e._continuousEvents;o.push({element:n,isAllDay:i,uid:n.attr(l.attr("uid")),start:t.start,end:t.end})},_createEventElement:function(t,n,i,o){var r,s,a=this.eventTemplate,c=this.options.editable,d=this._isMobile(),u=c&&c.destroy!==!1&&!d,h=c&&c.resize!==!1,f=n._time("start"),m=n._time("end"),g=n.start,v=n.end,_=this.eventResources(n);return n._startTime&&f!==l.date.getMilliseconds(n.start)&&(g=new Date(f),g=l.timezone.apply(g,"Etc/UTC")),n._endTime&&m!==l.date.getMilliseconds(n.end)&&(v=new Date(m),v=l.timezone.apply(v,"Etc/UTC")),r=p({},{ns:l.ns,resizable:h,showDelete:u,head:i,tail:o,singleDay:1==this._dates.length,resources:_,inverseColor:!(!_||!_[0])&&this._shouldInverseResourceColor(_[0]),messages:this.options.messages},n,{start:g,end:v}),s=e(a(r)),this.angular("compile",function(){return{elements:s,data:[{dataItem:r}]}}),s},_arrangeRows:function(e,t,n){var i,o,s,a,l,c,d=t.start.index,h=t.end.index,f=e.slotRange.innerRect(e.start,e.end,!1),p=f.right+this.options.eventMinWidth,m=r(t.events(),f.left,p);for(t.addEvent({slotIndex:d,start:d,end:h,rectLeft:f.left,rectRight:p,element:e.element,uid:e.uid}),m.push({start:d,end:h,uid:e.uid}),i=u.createRows(m),n.maxRowCount<i.length&&(n.maxRowCount=i.length),o=0,s=i.length;o<s;o++)for(a=i[o].events,l=0,c=a.length;l<c;l++)n.events[a[l].uid].rowIndex=o},_groupCount:function(){var e=this.groupedResources,t=this._groupedView;return e.length?"vertical"===this._groupOrientation()?t._verticalCountForLevel(e.length-1):t._horizontalCountForLevel(e.length-1,this.columnLevels.length-1):1},_updateEventForSelection:function(e){var t=this._adjustEvent(e.clone());return t.occurrence},_eventOptionsForMove:function(e){return e.isAllDay?{isAllDay:!1}:{}},_updateEventForResize:function(e){e.isAllDay&&e.set("isAllDay",!1)},_updateMoveHint:function(e,t,n){var i,o,r,s=this.groups[t],a=e.clone({start:e.start,end:e.end}),l=a.duration();if(a.start=new Date(a.start.getTime()+n),a.end=new Date(+a.start+l),this._removeMoveHint(e.uid),this._isInDateSlot(a)&&(a.isAllDay||a.duration()>=_||this._isInTimeSlot(a)))for(i=this._adjustEvent(a),o=s.slotRanges(i.occurrence,!1),r=0;r<o.length;r++)this._groupedView._createMoveHint(o[r],i)},_appendMoveHint:function(e){e.appendTo(this.content),this._moveHint=this._moveHint.add(e)},_updateResizeHint:function(e,t,n,i){var o,r,s,a,c,d,h,f,p,m,g=this.groups[t],v=g.ranges(n,i,!1,!1);for(this._removeResizeHint(),o=0;o<v.length;o++)r=v[o],s=r.startSlot(),a=r.innerRect(n,i,!1),a.top=s.offsetTop,c=a.right-a.left,d=r.endSlot().offsetTop+s.offsetHeight-a.top,h=this._adjustLeftPosition(a.left),f=u.fn._createResizeHint.call(this,h,a.top,c,d),this._resizeHint=this._resizeHint.add(f);p="t",m=this.content,this._resizeHint.appendTo(m),this._resizeHint.find(".k-label-top,.k-label-bottom").text(""),this._resizeHint.first().addClass("k-first").find(".k-label-top").text(l.toString(l.timezone.toLocalDate(n),p)),this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(l.toString(l.timezone.toLocalDate(i),p))},selectionByElement:function(e){var t=e.offset();return this._slotByPosition(t.left,t.top)},_updateDirection:function(e,t,n,i,o){var r=t[0].start,s=t[t.length-1].end;n&&!o&&r.index===s.index&&r.collectionIndex===s.collectionIndex&&(e.backward=i)},_changeGroup:function(e,t){var n=t?"prevGroupSlot":"nextGroupSlot",i=this[n](e.start,e.groupIndex,!1);return i&&(e.groupIndex+=t?-1:1),this._groupedView._changeGroup(e,t,i),i},prevGroupSlot:function(e,t,n){var i=this.groups[t],o=i.ranges(e,e,n,!1)[0].start;if(!(t<=0))return this._groupedView._prevGroupSlot(o,i,n)},nextGroupSlot:function(e,t,n){var i=this.groups[t],o=i.ranges(e,e,n,!1)[0].start;if(!(t>=this.groups.length-1))return this._groupedView._nextGroupSlot(o,i,n)},_verticalSlots:function(e,t,n,i){var o=this._groupedView,r=o._verticalMethod(i,n),s=t[0].start,a=t[t.length-1].end,l=this.groups[e.groupIndex],c=o._normalizeVerticalSelection(e,t,i,n);return c&&(s=a=c),s=l[r](s),a=l[r](a),n||!this._isVerticallyGrouped()||s&&a||(s=a=o._verticalSlots(e,i,c)),{startSlot:s,endSlot:a}},_horizontalSlots:function(e,t,n,i){var o=i?"upSlot":"downSlot",r=t[0].start,s=t[t.length-1].end,a=this.groups[e.groupIndex],l={};return n?(l.startSlot=a[o](r),l.endSlot=a[o](s),n||!this._isHorizontallyGrouped()||r&&s||(l.startSlot=l.endSlot=this._changeGroup(e,i))):l=this._groupedView._horizontalSlots(e,a,o,r,s,n,i),l},_changeViewPeriod:function(e,t){var n,i=t?this.previousDate():this.nextDate(),o=e.start,r=e.end,s=new Date(i),a=new Date(i);return!this._isInRange(s,a)&&(e.start=s,e.end=a,this._isHorizontallyGrouped()&&(e.groupIndex=t?this.groups.length-1:0),n=r-o,t?(r=v(this.endTime()),r=0===r?_:r,d(e.start,r-n),d(e.end,r)):(o=v(this.startTime()),d(e.start,o),d(e.end,o+n)),e.events=[],!0)},move:function(e,t,n){var i,o,r,s,a,c=!1,d=this.groups[e.groupIndex],u=l.keys,h=this._groupedView,f=d.ranges(e.start,e.end,!1,!1);if(t===u.DOWN||t===u.UP){if(c=!0,r=t===u.UP,h._updateDirection(e,f,n,r),s=this._verticalSlots(e,f,n,r),h._changeVerticalViewPeriod(s,n,e,r))return c}else if((t===u.LEFT||t===u.RIGHT)&&(c=!0,r=t===u.LEFT,this._updateDirection(e,f,n,r,!1),s=this._horizontalSlots(e,f,n,r),h._changeHorizontalViewPeriod(s,n,e,r)))return c;return c&&(i=s.startSlot,o=s.endSlot,n?(a=e.backward,a&&i?e.start=i.startDate():!a&&o&&(e.end=o.endDate())):i&&o&&(e.start=i.startDate(),e.end=o.endDate()),e.events=[]),c},destroy:function(){var e=this;e.element&&e.element.off(C),e.footer&&e.footer.remove(),e._currentTimeUpdateTimer&&clearInterval(e._currentTimeUpdateTimer),u.fn.destroy.call(this),this._isMobile()&&e.options.editable&&(e.options.editable.create!==!1&&e._addUserEvents.destroy(),e.options.editable.update!==!1&&e._editUserEvents.destroy())}}),p(!0,c,{TimelineView:a,TimelineWeekView:a.extend({options:{name:"TimelineWeekView",title:"Timeline Week",selectedDateFormat:"{0:D} - {1:D}",selectedShortDateFormat:"{0:d} - {1:d}",majorTick:120},name:"timelineWeek",calculateDateRange:function(){var e,t,n=this.options.date,i=l.date.dayOfWeek(n,this.calendarInfo().firstDay,-1),o=[];for(e=0,t=7;e<t;e++)o.push(i),i=l.date.nextDay(i);this._render(o)}}),TimelineWorkWeekView:a.extend({options:{name:"TimelineWorkWeekView",title:"Timeline Work Week",selectedDateFormat:"{0:D} - {1:D}",selectedShortDateFormat:"{0:d} - {1:d}",majorTick:120},name:"timelineWorkWeek",nextDate:function(){var e=l.date.dayOfWeek(l.date.nextDay(this.endDate()),this.calendarInfo().firstDay,1);return l.date.addDays(e,this._workDays[0])},previousDate:function(){var e=l.date.dayOfWeek(this.startDate(),this.calendarInfo().firstDay,-1),t=this._workDays;return l.date.addDays(e,t[t.length-1]-7)},calculateDateRange:function(){for(var e=this.options.date,t=l.date.dayOfWeek(e,this.options.workWeekStart,-1),n=l.date.dayOfWeek(t,this.options.workWeekEnd,1),i=[];t<=n;)i.push(t),t=l.date.nextDay(t);this._render(i)}}),TimelineMonthView:a.extend({options:{name:"TimelineMonthView",title:"Timeline Month",selectedDateFormat:"{0:D} - {1:D}",selectedShortDateFormat:"{0:d} - {1:d}",workDayStart:new Date(1980,1,1,0,0,0),workDayEnd:new Date(1980,1,1,23,59,59),footer:!1,majorTick:1440,minorTickCount:1},name:"timelineMonth",calculateDateRange:function(){var e,t,n=this.options.date,i=l.date.firstDayOfMonth(n),o=l.date.lastDayOfMonth(n),r=[];for(e=0,t=o.getDate();e<t;e++)r.push(i),i=l.date.nextDay(i);this._render(r)}})})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.scheduler.min",["kendo.dropdownlist.min","kendo.editable.min","kendo.multiselect.min","kendo.window.min","kendo.datetimepicker.min","kendo.scheduler.recurrence.min","kendo.scheduler.view.min","kendo.scheduler.dayview.min","kendo.scheduler.agendaview.min","kendo.scheduler.monthview.min","kendo.scheduler.timelineview.min","kendo.mobile.actionsheet.min","kendo.mobile.pane.min","kendo.pdf.min"],e)}(function(){return function(e,t){function n(e,t){return t=t||"",e.startTimezone&&(t=e.startTimezone,e.endTimezone&&(t+=" | "+e.endTimezone)),t}function i(e,t){var n=t.timezone;n&&(e[M.attr("timezone")]=n)}function o(e,t){var n,i=t.model.fields[t.field].validation;i&&(n=i.dateCompare,n&&G(n)&&n.message&&(e[M.attr("dateCompare-msg")]=n.message))}function r(e,t){return function(n){return n=e(n),a(n,"apply",t),n||[]}}function s(e,t){return function(n){return n&&("[object Array]"===Y.call(n)||n instanceof M.data.ObservableArray||(n=[n])),a(n,"remove",t,!0),n=e(n),n||[]}}function a(e,t,n,i){var o,r,s;for(e=e||[],r=0,s=e.length;r<s;r++)o=e[r],i?o.startTimezone||o.endTimezone?n?(o.start=M.timezone.convert(o.start,o.startTimezone||o.endTimezone,n),o.end=M.timezone.convert(o.end,o.endTimezone||o.startTimezone,n),o.start=M.timezone[t](o.start,n),o.end=M.timezone[t](o.end,n)):(o.start=M.timezone[t](o.start,o.startTimezone||o.endTimezone),o.end=M.timezone[t](o.end,o.endTimezone||o.startTimezone)):n&&(o.start=M.timezone[t](o.start,n),o.end=M.timezone[t](o.end,n)):o.startTimezone||o.endTimezone?(o.start=M.timezone[t](o.start,o.startTimezone||o.endTimezone),o.end=M.timezone[t](o.end,o.endTimezone||o.startTimezone),n&&(o.start=M.timezone.convert(o.start,o.startTimezone||o.endTimezone,n),o.end=M.timezone.convert(o.end,o.endTimezone||o.startTimezone,n))):n&&(o.start=M.timezone[t](o.start,n),o.end=M.timezone[t](o.end,n)),i&&delete o.uid;return e}function l(e,t){for(var n,i=e.length,o=0;o<i;o++)if(n=e[o],n.uid===t)return n}function c(e,t,n){return e=n?M.timezone.convert(e,t,n):M.timezone.remove(e,t)}function d(e){var t,n,i,o,r,s,a,l,d,u,h,f;return!(e.filter("[name=end]").length&&(t=e.closest(".k-scheduler-edit-form"),n=t.find("[name=start]:visible"),i=t.find("[name=end]:visible"),i[0]&&n[0]&&(s=M.widgetInstance(n,M.ui),a=M.widgetInstance(i,M.ui),l=t.data("kendoEditable"),d=l?l.options.model:null,s&&a?(o=s.value(),r=a.value()):(o=M.parseDate(n.val()),r=M.parseDate(i.val())),o&&r)))||(d&&(u=n.attr(M.attr("timezone")),h=d.startTimezone,f=d.endTimezone,h=h||f,f=f||h,h&&(o=c(o,h,u),r=c(r,f,u))),o<=r)}function u(e,t,n,i){for(var o=e.length,r=[],s=0;s<o;s++)r=r.concat(e[s].expand(t,n,i));return r}function h(e){return delete e.name,delete e.prefix,delete e.remove,delete e.edit,delete e.add,delete e.navigate,e}function f(t,n){var i,o,r=(t.fields||t)[n],s=["url","email","number","date","boolean"],a=r?r.validation:{},l=M.attr("type"),c=e.inArray,d={};for(i in a)o=a[i],c(i,s)>=0?d[l]=i:M.isFunction(o)||(d[i]=G(o)?o.value||i:o),d[M.attr(i+"-msg")]=o.message;return d}function p(t,n){var i=f(n,t.field);return function(o){e(M.format('<select data-{0}bind="value:{1}" title="'+n.title+'">',M.ns,t.field)).appendTo(o).attr(i).kendoDropDownList({dataTextField:t.dataTextField,dataValueField:t.dataValueField,dataSource:t.dataSource,valuePrimitive:t.valuePrimitive,optionLabel:"None",template:M.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#',t.dataColorField,t.dataTextField)})}}function m(t){var n=f(t.model,t.field);return function(t,i){e('<textarea name="description" class="k-textbox" title="'+i.title+'"/>').attr(n).appendTo(t)}}function g(t,n){var i=f(n,t.field);return function(n){e(M.format('<select data-{0}bind="value:{1}">',M.ns,t.field)).appendTo(n).attr(i).kendoMultiSelect({dataTextField:t.dataTextField,dataValueField:t.dataValueField,dataSource:t.dataSource,valuePrimitive:t.valuePrimitive,itemTemplate:M.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#',t.dataColorField,t.dataTextField),tagTemplate:M.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#',t.dataColorField,t.dataTextField)})}}function v(t,n){var i=f(n,t.field);return function(n){var o,r,s="",a=t.dataSource.view();for(o=0,r=a.length;o<r;o++)s+=M.format('<option value="{0}">{1}</option>',M.getter(t.dataValueField)(a[o]),M.getter(t.dataTextField)(a[o]));e(M.format('<select data-{0}bind="value:{1}" multiple="multiple" data-{0}value-primitive="{3}">{2}</select>',M.ns,t.field,s,t.valuePrimitive)).appendTo(n).attr(i)}}function _(e,t){var n,i=e.end.getTime()-e.start.getTime(),o=new Date(e.start.getTime());return M.date.setTime(o,t),n=new Date(o.getTime()),M.date.setTime(n,i,!0),{start:o,end:n}}var b,w,y,k,x,C,S,T,D,A,E,I,M=window.kendo,R=M.date,F=M.support.input,z=R.MS_PER_DAY,P=R.getDate,B=M.date.getMilliseconds,L=M.recurrence,H=e.extend({F10:121},M.keys),N=M.ui,O=N.Widget,V=N.DataBoundWidget,U="string",W=N.Popup,j=N.Calendar,q=M.data.DataSource,G=e.isPlainObject,$=e.extend,K=e.proxy,Y=Object.prototype.toString,Q=e.isArray,X=".kendoScheduler",Z="click",J="mousedown",ee="change",te="cancel",ne="remove",ie="save",oe="add",re="edit",se="k-state-focused",ae="k-state-expanded",le=".k-scheduler-views",ce=/(?:value:start|value:end)(?:,|$)/,de=P(new Date),ue=",",he=/\;/g,fe="recurrenceException",pe="Are you sure you want to delete this event?",me="Do you want to delete only this event occurrence or the whole series?",ge="Do you want to edit only this event occurrence or the whole series?",ve="Are you sure you want to delete this event occurrence?",_e="Are you sure you want to delete the whole series?",be='<a class="k-button #=className#" #=attr# href="\\#">#=text#</a>',we=M.template('<li class="k-current-view" data-#=ns#name="#=view#"><a role="button" href="\\#" class="k-link">${views[view].title}</a></li>'),ye=M.template('<div class="k-floatwrap k-header k-scheduler-toolbar"># if (pdf) { #<ul class="k-reset k-scheduler-tools"><li><a role="button" href="\\#" class="k-button k-pdf"><span class="k-icon k-i-file-pdf"></span>${messages.pdf}</a></li></ul># } #<ul class="k-reset k-scheduler-navigation"><li class="k-state-default k-header k-nav-today"><a role="button" href="\\#" class="k-link" title="${messages.today}">${messages.today}</a></li><li class="k-state-default k-header k-nav-prev"><a role="button" href="\\#" class="k-link" title="${messages.previous}" aria-label="${messages.previous}"><span class="k-icon k-i-arrow-60-left" style="pointer-events: none"></span></a></li><li class="k-state-default k-header k-nav-next"><a role="button" href="\\#" class="k-link" title="${messages.next}" aria-label="${messages.next}"><span class="k-icon k-i-arrow-60-right" style="pointer-events: none"></span></a></li><li class="k-state-default k-nav-current"><a role="button" href="\\#" class="k-link"><span class="k-icon k-i-calendar"></span><span class="k-sm-date-format" data-#=ns#bind="text: formattedShortDate"></span><span class="k-lg-date-format" data-#=ns#bind="text: formattedDate"></span></a></li></ul>#if(viewsCount === 1){#<a role="button" data-#=ns#name="#=view#" href="\\#" class="k-link k-scheduler-refresh"><span class="k-icon k-i-reload"></span></a>#}else{#<ul class="k-reset k-header k-scheduler-views">#for(var view in views){#<li class="k-state-default k-view-#= view.toLowerCase() #" data-#=ns#name="#=view#"><a role="button" href="\\#" class="k-link">${views[view].title}</a></li>#}#</ul>#}#</div>'),ke=M.template('<div class="k-floatwrap k-header k-scheduler-toolbar"># if (pdf) { #<ul class="k-reset k-scheduler-tools"><li><a role="button" href="\\#" class="k-button k-pdf"><span class="k-icon k-i-file-pdf"></span>${messages.pdf}</a></li></ul># } #<ul class="k-reset k-header k-scheduler-navigation"><li class="k-state-default k-nav-today"><a role="button" href="\\#" class="k-link">${messages.today}</a></li></ul>#if(viewsCount === 1){#<a role="button" data-#=ns#name="#=view#" href="\\#" class="k-link k-scheduler-refresh"><span class="k-icon k-i-reload"></span></a>#}else{#<ul class="k-reset k-header k-scheduler-views">#for(var view in views){#<li class="k-state-default k-view-#= view.toLowerCase() #" data-#=ns#name="#=view#"><a role="button" href="\\#" class="k-link">${views[view].title}</a></li>#}#</ul>#}#</div><div class="k-floatwrap k-header k-scheduler-toolbar"><ul class="k-reset k-header k-scheduler-navigation"><li class="k-state-default k-nav-prev"><a role="button" href="\\#" class="k-link"><span class="k-icon k-i-arrow-60-left"></span></a></li><li class="k-state-default k-nav-current"><span class="k-sm-date-format" data-#=ns#bind="text: formattedShortDate"></span><span class="k-lg-date-format" data-#=ns#bind="text: formattedDate"></span></li><li class="k-state-default k-nav-next"><a role="button" href="\\#" class="k-link"><span class="k-icon k-i-arrow-60-right"></span></a></li></ul></div>'),xe=function(t,n){var r={name:n.field,title:n.title},s=F.date?"":M.attr("role")+'="datepicker" ',a=M.attr("role")+'="datetimepicker" ',l=n.model.isAllDay,c=M.attr("validate")+"='"+!l+"'",d=M.attr("validate")+"='"+l+"'";i(r,n),o(r,n),e('<input type="datetime-local" required '+M.attr("type")+'="date" '+a+M.attr("bind")+'="value:'+n.field+',invisible:isAllDay" '+c+"/>").attr(r).appendTo(t),e('<input type="date" required '+M.attr("type")+'="date" '+s+M.attr("bind")+'="value:'+n.field+',visible:isAllDay" '+d+"/>").attr(r).appendTo(t),e("<span "+M.attr("for")+'="'+n.field+'" class="k-invalid-msg"/>').hide().appendTo(t)},Ce=function(t,n){var r={name:n.field,title:n.title},s=n.model.isAllDay,a=M.attr("validate")+"='"+!s+"' ",l=M.attr("validate")+"='"+s+"' ";i(r,n),o(r,n),e('<input type="text" required '+M.attr("type")+'="date" '+M.attr("role")+'="datetimepicker" '+M.attr("bind")+'="value:'+n.field+',invisible:isAllDay" '+a+"/>").attr(r).appendTo(t),e('<input type="text" required '+M.attr("type")+'="date" '+M.attr("role")+'="datepicker" '+M.attr("bind")+'="value:'+n.field+',visible:isAllDay" '+l+"/>").attr(r).appendTo(t),e("<span "+M.attr("bind")+'="text: '+n.field+'Timezone"></span>').appendTo(t),"end"===n.field&&e("<span "+M.attr("bind")+'="text: startTimezone, invisible: endTimezone"></span>').appendTo(t),e("<span "+M.attr("for")+'="'+n.field+'" class="k-invalid-msg"/>').hide().appendTo(t)},Se=function(t,n){e("<div "+M.attr("bind")+'="value:'+n.field+'" />').attr({name:n.field}).appendTo(t).kendoRecurrenceEditor({start:n.model.start,timezone:n.timezone,messages:n.messages})},Te=function(t,n){e("<div "+M.attr("bind")+'="value:'+n.field+'" />').attr({name:n.field}).appendTo(t).kendoMobileRecurrenceEditor({start:n.model.start,timezone:n.timezone,messages:n.messages,pane:n.pane,value:n.model[n.field]})},De=function(t,i){var o=n(i.model,i.messages.noTimezone);e('<a href="#" class="k-button k-timezone-button" data-bind="invisible:isAllDay">'+o+"</a>").click(i.click).appendTo(t)},Ae=function(t,n){e('<a href="#" class="k-button" data-bind="invisible:isAllDay">'+n.messages.timezoneEditorButton+"</a>").click(n.click).appendTo(t)},Ee=function(t,n){e("<div "+M.attr("bind")+'="value:'+n.field+'" />').attr({name:n.field}).toggle(n.visible).appendTo(t).kendoMobileTimezoneEditor({optionLabel:n.noTimezone})},Ie=function(n,i){var o=i.visible||i.visible===t;e("<div "+M.attr("bind")+'="value:'+i.field+'" />').attr({name:i.field}).toggle(o).appendTo(n).kendoTimezoneEditor({optionLabel:i.noTimezone,title:i.title})},Me=M.Class.extend({init:function(t,n){var i=t.timezone;this.reader=n,n.model&&(this.model=n.model),this.timezone=i,this.data=r(e.proxy(this.data,this),i),this.serialize=s(e.proxy(this.serialize,this),i)},errors:function(e){return this.reader.errors(e)},parse:function(e){return this.reader.parse(e)},data:function(e){return this.reader.data(e)},total:function(e){return this.reader.total(e)},groups:function(e){return this.reader.groups(e)},aggregates:function(e){return this.reader.aggregates(e)},serialize:function(e){return this.reader.serialize(e)}}),Re=M.data.Model.define({init:function(e){var t=this;M.data.Model.fn.init.call(t,e),t._defaultId=t.defaults[t.idField]},_time:function(e){var t=this[e],n="_"+e+"Time";return this[n]?this[n]-M.date.toUtcTime(M.date.getDate(t)):B(t)},_date:function(e){var t="_"+e+"Time";return this[t]?this[t]-this._time(e):M.date.getDate(this[e])},clone:function(t,n){var i=this.uid,o=new this.constructor(e.extend({},this.toJSON(),t));return n||(o.uid=i),o},duration:function(){var e=this.end,t=this.start,n=(e.getTimezoneOffset()-t.getTimezoneOffset())*M.date.MS_PER_MINUTE;return e-t-n},expand:function(e,t,n){return L?L.expand(this,e,t,n):[this]},update:function(e){for(var t in e)this.set(t,e[t]);this._startTime&&this.set("_startTime",M.date.toUtcTime(this.start)),this._endTime&&this.set("_endTime",M.date.toUtcTime(this.end))},isMultiDay:function(){return this.isAllDay||this.duration()>=M.date.MS_PER_DAY},isException:function(){return!this.isNew()&&this.recurrenceId},isOccurrence:function(){return this.isNew()&&this.recurrenceId},isRecurring:function(){return!(!this.recurrenceRule&&!this.recurrenceId)},isRecurrenceHead:function(){return!(!this.id||!this.recurrenceRule)},toOccurrence:function(t){return t=e.extend(t,{recurrenceException:null,recurrenceRule:null,recurrenceId:this.id||this.recurrenceId}),t[this.idField]=this.defaults[this.idField],this.clone(t,!0)},toJSON:function(){var e=M.data.Model.fn.toJSON.call(this);return e.uid=this.uid,delete e._startTime,delete e._endTime,e},shouldSerialize:function(e){return M.data.Model.fn.shouldSerialize.call(this,e)&&"_defaultId"!==e},set:function(e,t){var n,i,o,r=this.isAllDay||!1;M.data.Model.fn.set.call(this,e,t),"isAllDay"==e&&t!=r&&(n=M.date.getDate(this.start),i=new Date(this.end),o=M.date.getMilliseconds(i),0===o&&t&&(o=z),this.set("start",n),t===!0?(M.date.setTime(i,-o),i<n&&(i=n)):M.date.setTime(i,z-o),this.set("end",i))},id:"id",fields:{id:{type:"number"},title:{defaultValue:"",type:"string"},start:{type:"date",validation:{required:!0}},startTimezone:{type:"string"},end:{type:"date",validation:{required:!0,dateCompare:{value:d}}},endTimezone:{type:"string"},recurrenceRule:{defaultValue:"",type:"string"},recurrenceException:{defaultValue:"",type:"string"},isAllDay:{type:"boolean",defaultValue:!1},description:{type:"string"}}}),Fe=q.extend({init:function(e){q.fn.init.call(this,$(!0,{},{schema:{modelBase:Re,model:Re}},e)),this.reader=new Me(this.options.schema,this.reader)},expand:function(e,t){var n,i=this.view(),o={};return e&&t&&(n=t.getTimezoneOffset(),t=new Date(t.getTime()+z-1),t.getTimezoneOffset()!==n&&(t=M.timezone.apply(t,n)),o={logic:"or",filters:[{logic:"and",filters:[{field:"start",operator:"gte",value:e},{field:"end",operator:"gte",value:e},{field:"start",operator:"lte",value:t}]},{logic:"and",filters:[{field:"start",operator:"lte",value:new Date(e.getTime()+z-1)},{field:"end",operator:"gte",value:e}]}]},i=new M.data.Query(u(i,e,t,this.reader.timezone)).filter(o).toArray()),i},cancelChanges:function(e){e&&e.isOccurrence()&&this._removeExceptionDate(e),q.fn.cancelChanges.call(this,e)},insert:function(e,t){if(t){if(!(t instanceof Re)){var n=t;t=this._createNewModel(),t.accept(n)}return(!this._pushCreated&&t.isRecurrenceHead()||t.recurrenceId)&&(t=t.recurrenceId?t:t.toOccurrence(),this._addExceptionDate(t)),q.fn.insert.call(this,e,t)}},pushCreate:function(e){this._pushCreated=!0,q.fn.pushCreate.call(this,e),this._pushCreated=!1},remove:function(e){return e.isRecurrenceHead()?this._removeExceptions(e):e.isRecurring()&&this._addExceptionDate(e),q.fn.remove.call(this,e)},_removeExceptions:function(e){for(var t=this.data().slice(0),n=t.shift(),i=e.id;n;)n.recurrenceId===i&&q.fn.remove.call(this,n),n=t.shift();e.set(fe,"")},_removeExceptionDate:function(e){var t,n,i,o;e.recurrenceId&&(t=this.get(e.recurrenceId),t&&(n=e.defaults.start,i=RegExp("(\\"+ue+"?)"+L.toExceptionString(n,this.reader.timezone)),o=(t.recurrenceException||"").replace(he,ue).replace(/\,$/,""),i.test(o)?t.set(fe,o.replace(i,"")):(n=e.start,i=RegExp("(\\"+ue+"?)"+L.toExceptionString(n,this.reader.timezone)),t.set(fe,o.replace(i,"")))))},_addExceptionDate:function(e){var t,n=e.start,i=this.reader.timezone,o=this.get(e.recurrenceId),r=(o.recurrenceException||"").replace(he,ue).replace(/\,$/,"");L.isException(r,n,i)||(t=L.toExceptionString(n,i),e.defaults.start=n,o.set(fe,r+(r&&t?ue:"")+t))}});Fe.create=function(e){(Q(e)||e instanceof M.data.ObservableArray)&&(e={data:e});var t=e||{},n=t.data;if(t.data=n,!(t instanceof Fe)&&t instanceof M.data.DataSource)throw Error("Incorrect DataSource type. Only SchedulerDataSource instances are supported");return t instanceof Fe?t:new Fe(t)},$(!0,M.data,{SchedulerDataSource:Fe,SchedulerDataReader:Me,SchedulerEvent:Re}),b={update:{text:"Save",className:"k-primary k-scheduler-update"},canceledit:{text:"Cancel",className:"k-scheduler-cancel"},destroy:{text:"Delete",imageClass:"k-i-close",className:"k-primary k-scheduler-delete",iconClass:"k-icon"}},w={mobile:{dateRange:xe,timezonePopUp:De,timezone:Ee,recurrence:Te,description:m,multipleResources:v,resources:p},desktop:{dateRange:Ce,timezonePopUp:Ae,timezone:Ie,recurrence:Se,description:m,multipleResources:g,resources:p}},y=M.Observable.extend({init:function(e,t){M.Observable.fn.init.call(this),this.element=e,this.options=$(!0,{},this.options,t),this.createButton=this.options.createButton,this.toggleDateValidationHandler=K(this._toggleDateValidation,this)},_toggleDateValidation:function(t){if("isAllDay"==t.field){var n,i,o,r=this.container,s=this.editable.options.model.isAllDay,a=M.attr("bind");r.find("["+a+"*=end],["+a+"*=start]").each(function(){n=e(this),ce.test(n.attr(a))&&(i=n.is("["+M.attr("role")+"=datetimepicker],[type*=datetime]"),o=s!==i,n.attr(M.attr("validate"),o))})}},fields:function(e,t){var n,i,o=this,r=o.options.messages,s=o.options.timezone,a=function(e){e.preventDefault(),o._initTimezoneEditor(t,this)},l=[{field:"title",title:r.editor.title},{field:"start",title:r.editor.start,editor:e.dateRange,timezone:s},{field:"end",title:r.editor.end,editor:e.dateRange,timezone:s},{field:"isAllDay",title:r.editor.allDayEvent}];M.timezone.windows_zones&&(l.push({field:"timezone",title:r.editor.timezone,editor:e.timezonePopUp,click:a,messages:r.editor,model:t}),l.push({field:"startTimezone",title:r.editor.startTimezone,editor:e.timezone,noTimezone:r.editor.noTimezone}),l.push({field:"endTimezone",title:r.editor.endTimezone,editor:e.timezone,noTimezone:r.editor.noTimezone})),t.recurrenceId||l.push({field:"recurrenceRule",title:r.editor.repeat,editor:e.recurrence,timezone:s,messages:r.recurrenceEditor,pane:this.pane}),"description"in t&&l.push({field:"description",title:r.editor.description,editor:e.description({model:t,field:"description"})});for(n=0;n<this.options.resources.length;n++)i=this.options.resources[n],l.push({field:i.field,title:i.title,editor:i.multiple?e.multipleResources(i,t):e.resources(i,t)});return l},end:function(){return this.editable.end()},_buildEditTemplate:function(e,t,n){var i,o,r,s,a=this.options.messages,l=$({},M.Template,this.options.templateSettings),c=l.paramName,d=this.options.editable.template,u="";if(d)typeof d===U&&(d=window.unescape(d)),u+=M.template(d,l)(e);else for(i=0,o=t.length;i<o;i++)r=t[i],"startTimezone"===r.field&&(u+='<div class="k-popup-edit-form k-scheduler-edit-form k-scheduler-timezones" style="display:none">',u+='<div class="k-edit-form-container">',u+='<div class="k-edit-label"></div>',u+='<div class="k-edit-field"><label class="k-check"><input class="k-timezone-toggle" type="checkbox" />'+a.editor.separateTimezones+"</label></div>"),u+='<div class="k-edit-label"><label for="'+r.field+'">'+(r.title||r.field||"")+"</label></div>",!e.editable||e.editable(r.field)?(n.push(r),u+="<div "+M.attr("container-for")+'="'+r.field+'" class="k-edit-field"></div>'):(s="#:",r.field?(r=M.expr(r.field,c),s+=r+"==null?'':"+r):s+="''",s+="#",s=M.template(s,l),u+='<div class="k-edit-field">'+s(e)+"</div>"),"endTimezone"===r.field&&(u+=this._createEndTimezoneButton());return u},_createEndTimezoneButton:function(){return"</div></div>"},_revertTimezones:function(e){e.set("startTimezone",this._startTimezone),e.set("endTimezone",this._endTimezone),delete this._startTimezone,delete this._endTimezone}}),k=y.extend({init:function(){y.fn.init.apply(this,arguments),this.pane=M.mobile.ui.Pane.wrap(this.element),this.pane.element.parent().css("height",this.options.height),this.view=this.pane.view(),this._actionSheetButtonTemplate=M.template('<li><a #=attr# class="k-button #=className#" href="\\#">#:text#</a></li>'),this._actionSheetPopupOptions=e(document.documentElement).hasClass("km-root")?{modal:!1}:{align:"bottom center",position:"bottom center",effect:"slideIn:up"}},options:{animations:{left:"slide",right:"slide:right"}},destroy:function(){this.close(),this.unbind(),this.pane.destroy()},_initTimezoneEditor:function(t){var i,o=this,r=o.pane,s=o.options.messages,a=o.timezoneView,l=o.container.find(".k-scheduler-timezones"),c=l.find(".k-timezone-toggle"),d=l.find(".k-edit-label:last").add(l.find(".k-edit-field:last")),u=function(e){if("startTimezone"===e.field){var n=t.startTimezone;c.prop("disabled",!n),n||(d.hide(),t.set("endTimezone",""),c.prop("checked",!1))}};o._startTimezone=t.startTimezone||"",o._endTimezone=t.endTimezone||"",a||(i='<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form k-mobile-list"><div data-role="header" class="k-header"><a href="#" class="k-button k-scheduler-cancel">'+s.cancel+"</a>"+s.editor.timezoneTitle+'<a href="#" class="k-button k-scheduler-update">'+s.save+"</a></div></div>",
this.timezoneView=a=r.append(i),a.contentElement().append(l.show()),a.element.on(Z+X,".k-scheduler-cancel, .k-scheduler-update",function(i){var a,l;i.preventDefault(),i.stopPropagation(),e(this).hasClass("k-scheduler-cancel")&&o._revertTimezones(t),t.unbind("change",u),a=r.element.find("#edit").data("kendoMobileView"),l=n(t,s.editor.noTimezone),a.contentElement().find(".k-timezone-button").text(l),r.navigate(a,o.options.animations.right)}),c.click(function(){d.toggle(c.prop("checked")),t.set("endTimezone","")}),t.bind("change",u)),c.prop("checked",t.endTimezone).prop("disabled",!t.startTimezone),t.endTimezone?d.show():d.hide(),r.navigate(a,o.options.animations.left)},_createActionSheetButton:function(e){return e.template=this._actionSheetButtonTemplate,this.createButton(e)},showDialog:function(t){var n,i,o="",r='<ul><li class="km-actionsheet-title">'+t.title+"</li>",s=this.element.find(".k-event["+M.attr("uid")+"='"+t.model.uid+"']");for(this.container&&(s=this.container.find(".k-scheduler-delete"),s[0]&&(o="phone")),n=0;n<t.buttons.length;n++)r+=this._createActionSheetButton(t.buttons[n]);r+="</ul>",i=e(r).appendTo(this.pane.view().element).kendoMobileActionSheet({type:o,cancel:this.options.messages.cancel,cancelTemplate:'<li class="km-actionsheet-cancel"><a class="k-button" href="\\#">#:cancel#</a></li>',close:function(){this.destroy()},command:function(n){var o=i.element.find("li:not(.km-actionsheet-cancel) > .k-button").index(e(n.currentTarget));o>-1&&(i.close(),t.buttons[o].click())},popup:this._actionSheetPopupOptions}).data("kendoMobileActionSheet"),i.open(s)},editEvent:function(t){var n,i,o,r,s,a=this.pane,l="",c=this.options.messages,d=c.save,u=c.destroy,h=c.cancel,f=c.editor.editorTitle;return l+='<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form k-mobile-list" id="edit" '+M.attr("uid")+'="'+t.uid+'"><div data-role="header" class="k-header"><a href="#" class="k-button k-scheduler-cancel">'+h+"</a>"+f+'<a href="#" class="k-button k-scheduler-update">'+d+"</a></div>",n=this.fields(w.mobile,t),i=this,o=[],l+=this._buildEditTemplate(t,n,o),!t.isNew()&&this.options.editable&&this.options.editable.destroy!==!1&&(l+='<div class="k-edit-buttons"><a href="#" class="k-scheduler-delete k-button">'+u+"</a></div>"),l+="</div>",r=a.append(l),s=this.container=r.element,this.editable=s.kendoEditable({fields:o,model:t,clearContainer:!1,target:i.options.target,validateOnBlur:!0}).data("kendoEditable"),s.find("input[type=checkbox],input[type=radio]").parent(".k-edit-field").addClass("k-check").prev(".k-edit-label").addClass("k-check").click(function(){e(this).next().children("input").click()}),this.trigger("edit",{container:s,model:t})?this.trigger("cancel",{container:s,model:t}):(s.on(Z+X,"a.k-scheduler-edit, a.k-scheduler-cancel, a.k-scheduler-update, a.k-scheduler-delete",function(n){var o,r;n.preventDefault(),n.stopPropagation(),o=e(this),o.hasClass("k-scheduler-edit")?a.navigate("#edit",i.options.animations.right):(r="cancel",o.hasClass("k-scheduler-update")?r="save":o.hasClass("k-scheduler-delete")&&(r="remove"),i.trigger(r,{container:s,model:t}))}),a.navigate(r,i.options.animations.left),t.bind("change",i.toggleDateValidationHandler)),this.editable},_views:function(){return this.pane.element.find(M.roleSelector("view")).not(this.view.element)},close:function(){var e,t,n,i;if(this.container){for(this.pane.navigate("",this.options.animations.right),e=this._views(),n=0,i=e.length;n<i;n++)t=e.eq(n).data("kendoMobileView"),t&&t.purge();e.remove(),this.container=null,this.editable&&(this.editable.options.model.unbind("change",this.toggleDateValidationHandler),this.editable.destroy(),this.editable=null),this.timezoneView=null}}}),x=y.extend({destroy:function(){this.close(),this.unbind()},editEvent:function(t){var n,i,o,r=this,s=r.options.editable,a="<div "+M.attr("uid")+'="'+t.uid+'" class="k-popup-edit-form k-scheduler-edit-form"><div class="k-edit-form-container">',l=r.options.messages,c=l.save,d=l.cancel,u=l.destroy,h=this.fields(w.desktop,t),f=[];return a+=this._buildEditTemplate(t,h,f),i=G(s)?s.window:{},a+='<div class="k-edit-buttons k-state-default">',a+=this.createButton({name:"update",text:c,attr:n})+this.createButton({name:"canceledit",text:d,attr:n}),t.isNew()||s.destroy===!1||(a+=this.createButton({name:"delete",text:u,attr:n})),a+="</div></div></div>",o=this.container=e(a).appendTo(r.element).eq(0).kendoWindow($({modal:!0,resizable:!1,draggable:!0,title:l.editor.editorTitle,visible:!1,close:function(e){e.userTriggered&&r.trigger(te,{container:o,model:t})&&e.preventDefault()}},i)),r.editable=o.kendoEditable({fields:f,model:t,clearContainer:!1,validateOnBlur:!0,target:r.options.target}).data("kendoEditable"),r.trigger(re,{container:o,model:t})?r.trigger(te,{container:o,model:t}):(o.data("kendoWindow").center().open(),o.on(Z+X,"a.k-scheduler-cancel",function(e){e.preventDefault(),e.stopPropagation(),r.trigger(te,{container:o,model:t})}),o.on(Z+X,"a.k-scheduler-update",function(e){e.preventDefault(),e.stopPropagation(),r.trigger("save",{container:o,model:t})}),o.on(Z+X,"a.k-scheduler-delete",function(e){e.preventDefault(),e.stopPropagation(),r.trigger(ne,{container:o,model:t})}),M.cycleForm(o),t.bind("change",r.toggleDateValidationHandler)),r.editable},close:function(){var e=this,t=function(){e.editable&&(e.editable.options.model.unbind("change",e.toggleDateValidationHandler),e.editable.destroy(),e.editable=null,e.container=null),e.popup&&(e.popup.destroy(),e.popup=null)};e.editable?(e._timezonePopup&&e._timezonePopup.data("kendoWindow")&&(e._timezonePopup.data("kendoWindow").destroy(),e._timezonePopup=null),e.container.is(":visible")?e.container.data("kendoWindow").bind("deactivate",t).close():t()):t()},_createEndTimezoneButton:function(){var e=this.options.messages,t="";return t+='<div class="k-edit-buttons k-state-default">',t+=this.createButton({name:"savetimezone",text:e.save})+this.createButton({name:"canceltimezone",text:e.cancel}),t+="</div></div></div>"},showDialog:function(t){var n,i,o,r=M.format("<div class='k-popup-edit-form'><div class='k-edit-form-container'><p class='k-popup-message'>{0}</p>",t.text);for(r+='<div class="k-edit-buttons k-state-default">',n=0;n<t.buttons.length;n++)r+=this.createButton(t.buttons[n]);r+="</div></div></div>",i=this.element,this.popup&&this.popup.destroy(),o=this.popup=e(r).appendTo(i).eq(0).on("click",".k-button",function(n){n.preventDefault(),o.close();var i=e(n.currentTarget).index();t.buttons[i].click()}).kendoWindow({modal:!0,resizable:!1,draggable:!1,title:t.title,visible:!1,close:function(){this.destroy(),i.focus()}}).getKendoWindow(),o.center().open()},_initTimezoneEditor:function(e,t){var n,i=this,o=i.container.find(".k-scheduler-timezones"),r=o.find(".k-timezone-toggle"),s=o.find(".k-edit-label:last").add(o.find(".k-edit-field:last")),a=o.find(".k-scheduler-savetimezone"),l=o.find(".k-scheduler-canceltimezone"),c=i._timezonePopup,d=function(t){if("startTimezone"===t.field){var n=e.startTimezone;r.prop("disabled",!n),n||(s.hide(),e.set("endTimezone",""),r.prop("checked",!1))}};i._startTimezone=e.startTimezone,i._endTimezone=e.endTimezone,c||(i._timezonePopup=c=o.kendoWindow({modal:!0,resizable:!1,draggable:!0,title:i.options.messages.editor.timezoneEditorTitle,visible:!1,close:function(n){e.unbind("change",d),n.userTriggered&&i._revertTimezones(e),t&&t.focus()}}),r.click(function(){s.toggle(r.prop("checked")),e.set("endTimezone","")}),a.click(function(e){e.preventDefault(),n.close()}),l.click(function(t){t.preventDefault(),i._revertTimezones(e),n.close()}),e.bind("change",d)),r.prop("checked",e.endTimezone).prop("disabled",!e.startTimezone),e.endTimezone?s.show():s.hide(),n=c.data("kendoWindow"),n.center().open()}}),C=V.extend({init:function(t,n){var i=this;O.fn.init.call(i,t,n),i.options.views&&i.options.views.length||(i.options.views=["day","week"]),i.resources=[],i._initModel(),i._wrapper(),i._views(),i._toolbar(),i._dataSource(),i._resources(),i._resizeHandler=function(){i.resize()},i.wrapper.on("mousedown"+X+" selectstart"+X,function(t){e(t.target).is(":kendoFocusable")||t.preventDefault()}),i.options.editable&&i.options.editable.resize!==!1&&i._resizable(),i._movable(),i._bindResize(),i.options.messages&&i.options.messages.recurrence&&(L.options=i.options.messages.recurrence),i._selectable(),i._ariaId=M.guid(),i._createEditor()},_bindResize:function(){e(window).on("resize"+X,this._resizeHandler)},_unbindResize:function(){e(window).off("resize"+X,this._resizeHandler)},dataItems:function(){var n,i,o,r,s,a=this,l=a.items(),c=a._data,d=e.map(l,function(t){return e(t).attr("data-uid")}),u={},h=d.length;for(n=0;n<h;n++)u[d[n]]=null;for(o=c.length,n=0;n<o;n++)r=c[n],u[r.uid]!==t&&(u[r.uid]=r);s=[];for(i in u)s.push(u[i]);return s},_isMobile:function(){var e=this.options;return e.mobile===!0&&M.support.mobileOS||"phone"===e.mobile||"tablet"===e.mobile},_isMobilePhoneView:function(){var e=this.options;return e.mobile===!0&&M.support.mobileOS&&!M.support.mobileOS.tablet||"phone"===e.mobile},_groupsByResource:function(e,t,n,i,o){var r,s,a,l,c,d,u;if(n||(n=[]),r=e[0]){for(a=r.dataSource.view(),l=0,c=0;c<a.length;c++)d=M.getter(r.dataValueField)(a[c]),u=t+l+c,s=this._groupsByResource(e.slice(1),u,n,d,r.field),s[r.field]=d,l=s.groupIndex,o&&i&&(s[o]=i),1===e.length&&(s.groupIndex=t+c,n.push(s));return s}return{}},data:function(){return this._data},select:function(n){var i,o,r,s,a,l,c,d,u,h,f=this,p=f.view(),m=f._selection,g=p.groups;if(n===t)return r=p._selectedSlots,m?(m&&m.events&&(o=f._selectedEvents()),{start:m.start,end:m.end,events:o,slots:r,resources:p._resourceBySlot(m)}):[];if(!n)return f._selection=null,f._old=null,p.clearSelection(),t;if(e.isArray(n)&&(n={events:n.splice(0)}),n.resources){a=[],l=[],p.groupedResources&&f._groupsByResource(p.groupedResources,0,l);for(s in n.resources)a.push({field:s,operator:"eq",value:n.resources[s]});i=new M.data.Query(l).filter(a).toArray()}return n.events&&n.events.length?(f._selectEvents(n.events,i),f._select(),t):(g&&n.start&&n.end&&(c=P(p._startDate),d=M.date.addDays(P(p._endDate),1),n.start<d&&c<=n.end&&(u=i&&i.length?g[i[0].groupIndex]:g[0],h=u.ranges(n.start,n.end,n.isAllDay,!1),h.length&&(f._selection={start:M.timezone.toLocalDate(h[0].start.start),end:M.timezone.toLocalDate(h[h.length-1].end.end),groupIndex:h[0].start.groupIndex,index:h[0].start.index,isAllDay:h[0].start.isDaySlot,events:[]},f._select()))),t)},_selectEvents:function(e,t){var n,i,o,r,s,a,l,c,d=this,u=d.view(),h=u.groups,f=e.length,p=t&&t.length;for(n=0;n<f;n++)if(h&&p){for(i=h[t[0].groupIndex],o=[],r=i.timeSlotCollectionCount(),s=i.daySlotCollectionCount(),a=0;a<r;a++)o=o.concat(i.getTimeSlotCollection(a).events());for(l=0;l<s;l++)o=o.concat(i.getDaySlotCollection(l).events());o=new M.data.Query(o).filter({field:"element[0].getAttribute('data-uid')",operator:"eq",value:e[n]}).toArray(),o[0]&&d._createSelection(o[0].element)}else c=u.element.find(M.format(".k-event[data-uid={0}], .k-task[data-uid={0}]",e[n])),c.length&&d._createSelection(c[0])},_selectable:function(){var t,n=this,i=n.wrapper,o=M.support.mobileOS?"touchend":"mousedown";n.options.selectable&&(n._tabindex(),i.on(o+X,".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event",function(e){var t=e.which,o=e.button,r=M.support.browser,s=t&&3===t||o&&2==o;M.support.mobileOS&&e.isDefaultPrevented()||(s||(e.ctrlKey&&(n._ctrlKey=e.ctrlKey),e.shiftKey&&(n._shiftKey=e.shiftKey),n._createSelection(e.currentTarget)),i.focus(),r.msie&&r.version<9&&setTimeout(function(){i.focus()}),n.toolbar.find("ul > li").removeClass(se))}),t=e.proxy(n._mouseMove,n),i.on("mousedown"+X,".k-scheduler-header-all-day td, .k-scheduler-content td",function(e){var n=e.which,o=e.button,r=n&&3===n||o&&2==o;r||i.on("mousemove"+X,".k-scheduler-header-all-day td, .k-scheduler-content td",t)}),i.on("mouseup"+X+" mouseleave"+X,function(){i.off("mousemove"+X,".k-scheduler-header-all-day td, .k-scheduler-content td",t)}),i.on("focus"+X,function(){n._selection||n._selectFirstSlot(),n._select()}),i.on("focusout"+X,function(t){n._ctrlKey=n._shiftKey=!1,n.toolbar.find("ul > li").removeClass(se),e(t.relatedTarget).closest(le).length||n.toolbar.find(le).removeClass(ae)}),i.on("keydown"+X,K(n._keydown,n)),i.on("keyup"+X,function(e){n._ctrlKey=e.ctrlKey,n._shiftKey=e.shiftKey}))},_selectFirstSlot:function(){this._createSelection(this.wrapper.find(".k-scheduler-content").find("td:first"))},_select:function(){var t,n,i,o,r,s=this,a=s.view(),l=s.wrapper,c=a.current(),d=s._selection,u=s._old?s._old.selection:null,h=s._old?s._old.eventsLength:null;if(d&&(c&&(c.removeAttribute("id"),c.removeAttribute("aria-label"),l.removeAttr("aria-activedescendant")),a.select(d),c=a.current(),c&&(u!==c||d.events&&h!==d.events.length))){if(t=e(c).data("uid"),s._old&&t&&t===e(s._old.selection).data("uid")&&d.events&&s._old.eventsLength===d.events.length)return;i=d,o=s._selectedEvents(),r=a._selectedSlots,o[0]?(i=o[0]||d,n=M.format(s.options.messages.ariaEventLabel,i.title,i.start,i.start)):n=M.format(s.options.messages.ariaSlotLabel,i.start,i.end),c.setAttribute("id",s._ariaId),c.setAttribute("aria-label",n),l.attr("aria-activedescendant",s._ariaId),s._old={selection:c,eventsLength:o.length},s.trigger("change",{start:d.start,end:d.end,events:o,slots:r,resources:a._resourceBySlot(d)})}},_selectedEvents:function(){for(var e,t=this._selection.events,n=t.length,i=0,o=[];i<n;i++)e=this.occurrenceByUid(t[i]),e&&o.push(e);return o},_mouseMove:function(t){var n=this;clearTimeout(n._moveTimer),n._moveTimer=setTimeout(function(){var i,o,r,s=n.view(),a=n._selection;a&&(i=s.selectionByElement(e(t.currentTarget)),i&&a.groupIndex===i.groupIndex&&(o=i.startDate(),r=i.endDate(),o>=a.end?a.backward=!1:r<=a.start&&(a.backward=!0),a.backward?a.start=o:a.end=r,n._select()))},5)},_viewByIndex:function(e){var t,n=this.views;for(t in n){if(!e)return t;e--}},_keydown:function(n){var i,o,r,s,a,l,c=this,d=n.keyCode,u=c.view(),h=u.options.editable,f=c._selection,p=e.extend(f),m=16===d||18===d||17===d||91===d||92===d,g=".k-scheduler-tools > li,.k-scheduler-navigation > li,.k-scheduler-views > li.k-state-selected:visible, .k-scheduler-views > li.k-current-view:visible",v=c.toolbar.find(g),_=c.toolbar.find(le),b=e(n.target).closest(le).length||c.toolbar.find(".k-scheduler-views .k-state-focused").length,w=_.children().index(c.toolbar.find("."+se)),y=M.support.isRtl(c.element),k=y?-1:1;if(w==-1&&(w=_.children().index(c.toolbar.find(".k-state-selected"))),c._ctrlKey=n.ctrlKey,c._shiftKey=n.shiftKey,d===H.F10)return c.toolbar.find("ul > li:first").focus().addClass(se),n.preventDefault(),t;if(d===H.TAB){if(c.toolbar.find("."+se).length)return o=v.index(c.toolbar.find("."+se)),o===-1&&c._focusedView&&(o=v.index(c.toolbar.find(".k-scheduler-views > .k-state-selected"))),r=n.shiftKey?v[o-1]:v[o+1],c.toolbar.find("."+se).removeClass(se),r?(e(r).addClass(se).focus(),c._focusedView=null,n.preventDefault(),t):(c.element.focus(),n.preventDefault(),t)}else if(d===H.ENTER||d===H.SPACEBAR){if(b&&c._focusedView&&!c._focusedView.hasClass("k-state-selected"))return s=c._focusedView.data().name,c.trigger("navigate",{view:s,action:"changeView",date:c.date()})||(c.view(s),_.removeClass(ae),c.toolbar.find(".k-current-view:visible").length&&(e(document.activeElement).blur(),c.toolbar.find(".k-current-view:visible").addClass(se).find(".k-link").focus())),n.preventDefault(),t;if(c.toolbar.find("."+se+":visible").length)return c.toolbar.find("."+se+":visible").click(),n.preventDefault(),t}else if(n.altKey&&d===H.DOWN){if(c.toolbar.find("."+se+":visible").length)return c.toolbar.find("."+se+":visible").click(),n.preventDefault(),t}else{if(d===H.RIGHT&&b)return e(c.toolbar.find("."+se)).removeClass(se),c._focusedView=e(y?w-1===0?_.children(":not(.k-current-view):last"):_.children()[w+1*k]:w+1===_.children().length?_.children(":not(.k-current-view):first"):_.children()[w+1*k]),c._focusedView.focus().addClass(se),n.preventDefault(),t;if(d===H.LEFT&&b)return e(c.toolbar.find("."+se)).removeClass(se),c._focusedView=e(y?w+1===_.children().length?_.children(":not(.k-current-view):first"):_.children()[w-1*k]:w-1===0?_.children(":not(.k-current-view):last"):_.children()[w-1*k]),c._focusedView.focus().addClass(se),n.preventDefault(),t;if(d===H.DOWN&&c.toolbar.find(le).hasClass(ae))return c.toolbar.find("."+se).removeClass(se),i=c._focusedView?_.find(c._focusedView).index():_.children(".k-scheduler-views > .k-state-selected").index(),c._focusedView=e(i+1===_.children().length?_.children(":not(.k-current-view):first"):_.children()[i+1*k]),c._focusedView.focus().addClass(se),n.preventDefault(),t;if(d===H.UP&&c.toolbar.find(le).hasClass(ae))return c.toolbar.find("."+se).removeClass(se),i=c._focusedView?_.find(c._focusedView).index():_.children(".k-scheduler-views > .k-state-selected").index(),c._focusedView=e(i-1===0?_.children(":not(.k-current-view):last"):_.children()[i-1*k]),c._focusedView.focus().addClass(se),n.preventDefault(),t;if(n.altKey&&d===H.DOWN&&c.toolbar.find(".k-nav-current").hasClass(se))return c._showCalendar(),n.preventDefault(),t;if(d===H.ESC&&c.popup&&c.popup.visible())return c.popup.close(),n.preventDefault(),t;if(d===H.ESC&&c.toolbar.find(le).hasClass(ae))return c.toolbar.find(le).removeClass(ae),c.toolbar.find(le).children().removeClass(se),c._focusedView=null,c.toolbar.find(".k-current-view").focus().addClass(se),n.preventDefault(),t}if(!m){if(!f)return c._selectFirstSlot(),c._select(),c.element.focus(),t;d===H.TAB?u.moveToEvent(f,n.shiftKey)&&(c._select(),c.element.focus(),n.preventDefault()):d===H.ENTER||d===H.SPACEBAR?f.events.length&&h?h.update!==!1&&c.editEvent(f.events[0]):h&&h.create!==!1&&(f.isAllDay&&(f=e.extend({},f,{end:M.date.addDays(f.end,-1)})),c.addEvent($({},f,u._resourceBySlot(f)))):d===H.DELETE&&h!==!1&&h.destroy!==!1?c.removeEvent(f.events[0]):d>=49&&d<=57?(a=c._viewByIndex(d-49),a&&!c.trigger("navigate",{view:a,action:"changeView",date:c.date()})&&c.view(a)):u.move(f,d,n.shiftKey)&&(u.inRange(f)?c._select():(l=c.date().getTime()>f.start.getTime()?"previous":"next",c.trigger("navigate",{view:c._selectedViewName,action:l,date:f.start})?(f.start=p.start,f.end=p.end):c.date(f.start)),c.toolbar.find("ul > li").removeClass(se),n.preventDefault()),c._adjustSelectedDate()}},_createSelection:function(t){var n,i,o=this._selection;t=e(t),t.is(".k-event")&&(n=t.attr(M.attr("uid")),o&&o.events.indexOf(n)!==-1&&!this._ctrlKey)||(o&&(this._ctrlKey||this._shiftKey)||(o=this._selection={events:[],groupIndex:0}),i=this.view().selectionByElement(t),i&&(o.groupIndex=i.groupIndex||0),n&&(i=l(this._data,n)),i&&i.uid&&(n=[i.uid]),this._updateSelection(i,n),this._adjustSelectedDate())},_updateSelection:function(e,n,i){var o,r,s,a=this._selection;e&&a&&(o=this.view(),e.uid&&(e=o._updateEventForSelection(e)),this._shiftKey&&a.start&&a.end?(r=e.end<a.end,a.end=e.endDate?e.endDate():e.end,r&&o._timeSlotInterval&&M.date.setTime(a.end,-o._timeSlotInterval())):(a.start=e.startDate?e.startDate():e.start,a.end=e.endDate?e.endDate():e.end),a.isAllDay="isDaySlot"in e?e.isDaySlot:e.isAllDay,null!==i&&i!==t&&(a.groupIndex=i),a.index=e.index,this._ctrlKey?(s=n&&n.length?a.events.indexOf(n[0]):-1,s>-1?a.events.splice(s,1):a.events=a.events.concat(n||[])):a.events=n||[])},options:{name:"Scheduler",date:de,editable:!0,autoBind:!0,snap:!0,mobile:!1,timezone:"",allDaySlot:!0,min:new Date(1900,0,1),max:new Date(2099,11,31),toolbar:null,footer:{},messages:{today:"Today",pdf:"Export to PDF",save:"Save",cancel:"Cancel",destroy:"Delete",deleteWindowTitle:"Delete event",next:"Next",previous:"Previous",ariaSlotLabel:"Selected from {0:t} to {1:t}",ariaEventLabel:"{0} on {1:D} at {2:t}",views:{day:"Day",week:"Week",workWeek:"Work Week",agenda:"Agenda",month:"Month",timeline:"Timeline",timelineWeek:"Timeline Week",timelineWorkWeek:"Timeline Work Week",timelineMonth:"Timeline Month"},recurrenceMessages:{deleteWindowTitle:"Delete Recurring Item",deleteWindowOccurrence:"Delete current occurrence",deleteWindowSeries:"Delete the series",editWindowTitle:"Edit Recurring Item",editWindowOccurrence:"Edit current occurrence",editWindowSeries:"Edit the series"},editable:{confirmation:pe},editor:{title:"Title",start:"Start",end:"End",allDayEvent:"All day event",description:"Description",repeat:"Repeat",timezone:"Timezone",startTimezone:"Start timezone",endTimezone:"End timezone",separateTimezones:"Use separate start and end time zones",timezoneEditorTitle:"Timezones",timezoneEditorButton:"Time zone",timezoneTitle:"Time zones",noTimezone:"No timezone",editorTitle:"Event"}},height:null,width:null,resources:[],group:{resources:[],orientation:"horizontal"},views:[],selectable:!1},events:[ne,re,te,ie,"add","dataBinding","dataBound","moveStart","move","moveEnd","resizeStart","resize","resizeEnd","navigate","change"],destroy:function(){var t,n=this;O.fn.destroy.call(n),n.dataSource&&(n.dataSource.unbind(ee,n._refreshHandler),n.dataSource.unbind("progress",n._progressHandler),n.dataSource.unbind("error",n._errorHandler)),n.calendar&&(n.calendar.destroy(),n.popup.destroy()),n.view()&&n.view().destroy(),n._editor&&n._editor.destroy(),this._moveDraggable&&this._moveDraggable.destroy(),this._resizeDraggable&&this._resizeDraggable.destroy(),t=n.element.add(n.wrapper).add(n.toolbar).add(n.popup),t.off(X),clearTimeout(n._moveTimer),n._model=null,n.toolbar=null,n.element=null,e(window).off("resize"+X,n._resizeHandler),M.destroy(n.wrapper)},setDataSource:function(e){this.options.dataSource=e,this._dataSource(),this.options.autoBind&&e.fetch?e.fetch():this.view(this._selectedView)},items:function(){var e=this.wrapper.find(".k-scheduler-content"),t=this.view();return t&&"agenda"===t.options.name?e.find(".k-task"):e.find(".k-event").add(this.wrapper.find(".k-scheduler-header-wrap").find(".k-scheduler-header-all-day").siblings())},_movable:function(){var n,i,o,r,s,a,l,c,d,u,h=this,f=0,p=[],m=[],g=h._isMobile(),v=h.options.editable&&h.options.editable.move!==!1,b=h.options.editable&&h.options.editable.resize!==!1;(v||b&&g)&&(g&&M.support.mobileOS.android&&(f=5),h._moveDraggable=new M.ui.Draggable(h.element,{distance:f,filter:".k-event",ignore:".k-resize-handle",holdToDrag:g,autoScroll:!0}),v&&h._moveDraggable.bind("dragstart",function(e){var s,f,m,v=h.view(),_=e.currentTarget;if(!v.options.editable||v.options.editable.move===!1)return e.preventDefault(),t;if(g&&!_.hasClass("k-event-active"))return h.element.find(".k-event-active").removeClass("k-event-active"),e.preventDefault(),t;if(a=h.occurrenceByUid(_.attr(M.attr("uid"))),l=a.clone(),u=a.clone(),l.update(v._eventOptionsForMove(l)),p=[],h._selection)for(s=h._selection.events,f=0;f<s.length;f++)m=h.occurrenceByUid(s[f]).clone(),m.update(v._eventOptionsForMove(m)),p.push(m);else p.push(l);n=v._slotByPosition(e.x.startLocation,e.y.startLocation),o=v._resourceBySlot(n),d=r=n.startOffset(e.x.startLocation,e.y.startLocation,h.options.snap),i=n,c=n,n&&!h.trigger("moveStart",{event:a})||e.preventDefault()}).bind("drag",function(t){var o,u,f,g,v,b=h.view(),w=b._slotByPosition(t.x.location,t.y.location);if(w){if(s=w.startOffset(t.x.location,t.y.location,h.options.snap),w.isDaySlot!==n.isDaySlot)if(w.isDaySlot!==c.isDaySlot)for(g=e(n.element).index(),v=e(w.element).parent().children().eq(g),n=b._slotByPosition(v.offset().left,v.offset().top),r=n.startOffset(t.x.location,t.y.location,!0),m=p.map(function(e){return e.clone()}),f=0;f<p.length;f++)p[f].isAllDay!=w.isDaySlot&&(p[f].isAllDay=w.isDaySlot,p[f].end=M.date.getDate(p[f].start),p[f].start=M.date.getDate(p[f].start),w.isDaySlot||(M.date.setTime(p[f].start,M.date.getMilliseconds(b.startTime())),M.date.setTime(p[f].end,M.date.getMilliseconds(b.startTime())+b._timeSlotInterval())));else n=e.extend(!0,{},c),r=d,p=m;for(o=s-r,f=0;f<p.length;f++)b._updateMoveHint(p[f],w.groupIndex,o);if(u=_(l,o),h.trigger("move",{event:a,slot:{element:w.element,start:w.startDate(),end:w.endDate(),isDaySlot:w.isDaySlot},resources:b._resourceBySlot(w),start:u.start,end:u.end}))for(f=0;f<p.length;f++)b._updateMoveHint(p[f],w.groupIndex,o);else i=w}}).bind("dragend",function(t){var n,d,u,f,g,v,b,w,y,k;if(h.view()._removeMoveHint(),n=s-r,d=_(l,n),u=d.start,f=d.end,g=h.view()._resourceBySlot(i),v=h.trigger("moveEnd",{event:a,slot:{element:i.element,start:i.startDate(),end:i.endDate()},start:u,end:f,resources:g}),!v&&(a.start.getTime()!==u.getTime()||a.end.getTime()!==f.getTime()||c.isDaySlot!==i.isDaySlot||M.stringify(g)!==M.stringify(o))){for(h._isMultiDrag=p.length>1,b=0;b<p.length;b++)w=p[b],d=_(w,n),y=h.view()._eventOptionsForMove(w),k=e.extend({isAllDay:w.isAllDay,start:d.start,end:d.end},y,g),h._updateEvent(null,w,k);h._isMultiDrag&&(h.dataSource.sync(),h._isMultiDrag=!1)}t.currentTarget.removeClass("k-event-active"),this.cancelHold(),p=[],m=[]}).bind("dragcancel",function(){h.view()._removeMoveHint(),this.cancelHold(),p=[],m=[]}),g&&(h._moveDraggable.bind("hold",function(e){h.element.find(".k-scheduler-monthview").length&&e.preventDefault(),h.element.find(".k-event-active").removeClass("k-event-active"),e.currentTarget.addClass("k-event-active")}),M.support.mobileOS.android||h._moveDraggable.userEvents.bind("press",function(e){e.preventDefault()})))},_resizable:function(){function t(e){var t,n={"k-resize-e":"east","k-resize-w":"west","k-resize-n":"north","k-resize-s":"south"};for(t in n)if(e.hasClass(t))return n[t]}var n,i,o,r,s,a=this,l=0;a._isMobile()&&M.support.mobileOS.android&&(l=5),a._resizeDraggable=new M.ui.Draggable(a.element,{distance:l,filter:".k-resize-handle",autoScroll:!0,dragstart:function(t){var l=e(t.currentTarget),c=l.closest(".k-event"),d=c.attr(M.attr("uid")),u=a.view();o=a.occurrenceByUid(d),r=o.clone(),u._updateEventForResize(r),s=u._slotByPosition(t.x.startLocation,t.y.startLocation),a.trigger("resizeStart",{event:o})&&t.preventDefault(),n=M.date.toUtcTime(r.start),i=M.date.toUtcTime(r.end)},drag:function(l){var c,d,u,h,f,p;s&&(c=e(l.currentTarget),d=t(c),u=a.view(),h=u._slotByPosition(l.x.location,l.y.location),h&&s.groupIndex==h.groupIndex&&(s=h,f=n,p=i,"south"==d?!s.isDaySlot&&s.end-M.date.toUtcTime(r.start)>=u._timeSlotInterval()&&(i=r.isAllDay?s.startOffset(l.x.location,l.y.location,a.options.snap):s.endOffset(l.x.location,l.y.location,a.options.snap)):"north"==d?!s.isDaySlot&&M.date.toUtcTime(r.end)-s.start>=u._timeSlotInterval()&&(n=s.startOffset(l.x.location,l.y.location,a.options.snap)):"east"==d?s.isDaySlot&&M.date.toUtcTime(M.date.getDate(s.endDate()))>=M.date.toUtcTime(M.date.getDate(r.start))?i=r.isAllDay?s.startOffset(l.x.location,l.y.location,a.options.snap):s.endOffset(l.x.location,l.y.location,a.options.snap):!s.isDaySlot&&s.end-M.date.toUtcTime(r.start)>=u._timeSlotInterval()&&(i=s.endOffset(l.x.location,l.y.location,a.options.snap)):"west"==d&&(s.isDaySlot&&M.date.toUtcTime(M.date.getDate(r.end))>=M.date.toUtcTime(M.date.getDate(s.startDate()))?n=s.startOffset(l.x.location,l.y.location,a.options.snap):!s.isDaySlot&&M.date.toUtcTime(r.end)-s.start>=u._timeSlotInterval()&&(n=s.startOffset(l.x.location,l.y.location,a.options.snap))),a.trigger("resize",{event:o,slot:{element:s.element,start:s.startDate(),end:s.endDate()},start:M.timezone.toLocalDate(n),end:M.timezone.toLocalDate(i),resources:u._resourceBySlot(s)})?(n=f,i=p):u._updateResizeHint(r,s.groupIndex,n,i)))},dragend:function(l){var c,d=e(l.currentTarget),u=new Date(r.start.getTime()),h=new Date(r.end.getTime()),f=t(d);a.view()._removeResizeHint(),"south"==f?h=M.timezone.toLocalDate(i):"north"==f?u=M.timezone.toLocalDate(n):"east"==f?h=s.isDaySlot?M.date.getDate(M.timezone.toLocalDate(i)):M.timezone.toLocalDate(i):"west"==f&&(s.isDaySlot?(u=new Date(M.timezone.toLocalDate(n)),u.setHours(0),u.setMinutes(0)):u=M.timezone.toLocalDate(n)),c=a.trigger("resizeEnd",{event:o,slot:{element:s.element,start:s.startDate(),end:s.endDate()},start:u,end:h,resources:a.view()._resourceBySlot(s)}),!c&&h.getTime()>=u.getTime()&&(r.start.getTime()==u.getTime()&&r.end.getTime()==h.getTime()||(a.view()._updateEventForResize(o),a._updateEvent(f,o,{start:u,end:h}))),s=null,o=null},dragcancel:function(){a.view()._removeResizeHint(),s=null,o=null}})},_updateEvent:function(e,t,n){var i,o=this,r=function(e,t){try{o._preventRefresh=!0,e.update(n),o._convertDates(e)}finally{o._preventRefresh=!1}o.trigger(ie,{event:e})||(t&&t(),o._isMultiDrag||o.dataSource.sync())},s=function(e){return e.recurrenceRule?o.dataSource.getByUid(e.uid):o.dataSource.get(e.recurrenceId)},a=function(){var i,a,l=s(t);"south"!=e&&"north"!=e||(n.start&&(i=M.date.getDate(l.start),M.date.setTime(i,B(n.start)),n.start=i),n.end&&(a=M.date.getDate(l.end),M.date.setTime(a,B(n.end)),n.end=a)),o.dataSource._removeExceptions(l),r(l)},l=function(){var e=s(t),n=function(){o._convertDates(e),o._selection&&o._selection.events.push(a)},i=e.toOccurrence({start:t.start,end:t.end}),a=i.uid;r(o.dataSource.add(i),n)};t.recurrenceRule||t.isOccurrence()?(i=o.options.messages.recurrenceMessages,o._showRecurringDialog(t,l,a,{title:i.editWindowTitle,text:i.editRecurring?i.editRecurring:ge,occurrenceText:i.editWindowOccurrence,seriesText:i.editWindowSeries})):r(o.dataSource.getByUid(t.uid))},_modelForContainer:function(t){return t=e(t).closest("["+M.attr("uid")+"]"),this.dataSource.getByUid(t.attr(M.attr("uid")))},showDialog:function(e){this._editor.showDialog(e)},focus:function(){this.wrapper.focus()},_confirmation:function(e,t){var n,i,o,r,s,a=this.options.editable;a===!0||a.confirmation!==!1?(n=this.options.messages,i=n.deleteWindowTitle,o=typeof a.confirmation===U?a.confirmation:n.editable.confirmation,this._isEditorOpened()&&t.isRecurring()&&(r=this.options.messages.recurrenceMessages,i=r.deleteWindowTitle,o=t.isException()?r.deleteRecurringConfirmation?r.deleteRecurringConfirmation:ve:r.deleteSeriesConfirmation?r.deleteSeriesConfirmation:_e),s=[{name:"destroy",text:n.destroy,click:function(){e()}}],this._isMobile()&&M.mobile.ui.Pane||s.push({name:"canceledit",text:n.cancel,click:function(){e(!0)}}),this._unbindResize(),this.showDialog({model:t,text:o,title:i,buttons:s}),this._bindResize()):e()},addEvent:function(e){var t,n,i=this._editor.editable,o=this.dataSource;e=e||{},n=this.trigger("add",{event:e}),!n&&(i&&i.end()||!i)&&(this.cancelEvent(),e&&e.toJSON&&(e=e.toJSON()),t=o.add(e),t&&(this.cancelEvent(),this._editEvent(t)))},saveEvent:function(){var e,t,n,i=this._editor;i&&(e=i.editable,t=i.container,n=this._modelForContainer(t),t&&e&&e.end()&&!this.trigger(ie,{container:t,event:n})&&(n.isRecurrenceHead()&&this.dataSource._removeExceptions(n),n.dirty||n.isOccurrence()||this._convertDates(n,"remove"),this.dataSource.sync()))},cancelEvent:function(){var e,t=this._editor,n=t.container;n&&(e=this._modelForContainer(n),e&&e.isOccurrence()&&(this._convertDates(e,"remove"),this._convertDates(this.dataSource.get(e.recurrenceId),"remove")),this.dataSource.cancelChanges(e),t.close())},editEvent:function(e){var t="string"==typeof e?this.occurrenceByUid(e):e;t&&(this.cancelEvent(),t.isRecurring()?this._editRecurringDialog(t):this._editEvent(t))},_editEvent:function(e){this._unbindResize(),this._createPopupEditor(e),this._bindResize()},_editRecurringDialog:function(e){var t=this,n=function(){e.isException()?t._editEvent(e):t.addEvent(e)},i=function(){e.recurrenceId&&(e=t.dataSource.get(e.recurrenceId)),t._editEvent(e)},o=t.options.messages.recurrenceMessages;t._showRecurringDialog(e,n,i,{title:o.editWindowTitle,text:o.editRecurring?o.editRecurring:ge,occurrenceText:o.editWindowOccurrence,seriesText:o.editWindowSeries})},_showRecurringDialog:function(e,t,n,i){var o=this.options.editable,r=G(o)?o.editRecurringMode:"dialog";"occurrence"===r||this._isMultiDrag?t():"series"===r?n():(this._unbindResize(),this.showDialog({model:e,title:i.title,text:i.text,buttons:[{text:i.occurrenceText,click:t},{text:i.seriesText,click:n}]}),this._bindResize())},_createButton:function(e){var t=e.template||be,n=typeof e===U?e:e.name||e.text,i={className:"k-scheduler-"+(n||"").replace(/\s/g,""),text:n,attr:""};if(!(n||G(e)&&e.template))throw Error("Custom commands should have name specified");
return G(e)?(e.className&&(e.className+=" "+i.className),"edit"===n&&G(e.text)&&(e=$(!0,{},e),e.text=e.text.edit),i=$(!0,i,b[n],e)):i=$(!0,i,b[n]),M.template(t)(i)},_convertDates:function(e,t){var n=this.dataSource.reader.timezone,i=e.startTimezone,o=e.endTimezone,r=e.start,s=e.start;t=t||"apply",i=i||o,o=o||i,i&&(n?"apply"===t?(r=M.timezone.convert(e.start,n,i),s=M.timezone.convert(e.end,n,o)):(r=M.timezone.convert(e.start,i,n),s=M.timezone.convert(e.end,o,n)):(r=M.timezone[t](e.start,i),s=M.timezone[t](e.end,o)),e._set("start",r),e._set("end",s))},_createEditor:function(){var e,n=this;e=n._editor=this._isMobile()&&M.mobile.ui.Pane?new k(this.wrapper,$({},this.options,{target:this,timezone:n.dataSource.reader.timezone,resources:n.resources,createButton:K(this._createButton,this)})):new x(this.wrapper,$({},this.options,{target:this,createButton:K(this._createButton,this),timezone:n.dataSource.reader.timezone,resources:n.resources})),e.bind("cancel",function(e){return n.trigger("cancel",{container:e.container,event:e.model})?(e.preventDefault(),t):(n.cancelEvent(),n.focus(),t)}),e.bind("edit",function(e){n.trigger(re,{container:e.container,event:e.model})&&e.preventDefault()}),e.bind("save",function(){n.saveEvent()}),e.bind("remove",function(e){n.removeEvent(e.model)})},_createPopupEditor:function(e){var t=this._editor;e.isNew()&&!e.isOccurrence()||(e.isOccurrence()&&this._convertDates(e.recurrenceId?this.dataSource.get(e.recurrenceId):e),this._convertDates(e)),this.editable=t.editEvent(e)},removeEvent:function(e){var t=this,n="string"==typeof e?t.occurrenceByUid(e):e;n&&(n.isRecurring()?t._deleteRecurringDialog(n):t._confirmation(function(e){e||t._removeEvent(n)},n))},occurrenceByUid:function(e){var t=this.dataSource.getByUid(e);return t||(t=l(this._data,e)),t},occurrencesInRange:function(e,t){return new M.data.Query(this._data).filter({logic:"or",filters:[{logic:"and",filters:[{field:"start",operator:"gte",value:e},{field:"end",operator:"gte",value:e},{field:"start",operator:"lt",value:t}]},{logic:"and",filters:[{field:"start",operator:"lte",value:e},{field:"end",operator:"gt",value:e}]}]}).toArray()},_removeEvent:function(e){this.trigger(ne,{event:e})||this.dataSource.remove(e)&&this.dataSource.sync()},_deleteRecurringDialog:function(e){var t,n,i,o,r,s=this,a=e,l=s.options.editable,c=G(l)?l.editRecurringMode:"dialog",d=function(){var e=a.recurrenceId?a:a.toOccurrence(),t=s.dataSource.get(e.recurrenceId);s._convertDates(t),s._removeEvent(e)},u=function(){a.recurrenceId&&(a=s.dataSource.get(a.recurrenceId)),s._removeEvent(a)};("dialog"!=c||s._isEditorOpened())&&(t=function(){s._confirmation(function(e){e||d()},a)},n=function(){s._confirmation(function(e){e||u()},a)}),i=n||u,o=t||d,s._isEditorOpened()?e.isException()?o():i():(r=s.options.messages.recurrenceMessages,s._showRecurringDialog(e,o,i,{title:r.deleteWindowTitle,text:r.deleteRecurring?r.deleteRecurring:me,occurrenceText:r.deleteWindowOccurrence,seriesText:r.deleteWindowSeries}))},_isEditorOpened:function(){return!!this._editor.container},_unbindView:function(e){var t=this;t.angular("cleanup",function(){return{elements:t.items()}}),e.destroy()},_bindView:function(e){var t=this;t.options.editable&&(t._viewRemoveHandler&&e.unbind(ne,t._viewRemoveHandler),t._viewRemoveHandler=function(e){t.removeEvent(e.uid)},e.bind(ne,t._viewRemoveHandler),t._viewAddHandler&&e.unbind(oe,t._viewAddHandler),t._viewAddHandler=function(e){t.addEvent(e.eventInfo)},e.bind(oe,this._viewAddHandler),t._viewEditHandler&&e.unbind(re,t._viewEditHandler),t._viewEditHandler=function(e){t.editEvent(e.uid)},e.bind(re,this._viewEditHandler)),t._viewNavigateHandler&&e.unbind("navigate",t._viewNavigateHandler),t._viewNavigateHandler=function(e){var n,i;e.view&&(n="isWorkDay"in e,i=n?"changeWorkDay":"changeView",t.trigger("navigate",{view:e.view,isWorkDay:e.isWorkDay,action:i,date:e.date})||(n&&(t._workDayMode=e.isWorkDay),t._selectView(e.view),t.date(e.date)))},e.bind("navigate",t._viewNavigateHandler),t._viewActivateHandler&&e.unbind("activate",t._viewActivateHandler),t._viewActivateHandler=function(){var e=this;t._selection&&(e.constrainSelection(t._selection),t._select(),t._adjustSelectedDate())},e.bind("activate",t._viewActivateHandler)},_selectView:function(e){var t,n,i,o=this;e&&o.views[e]&&(o._selectedView&&o._unbindView(o._selectedView),o._selectedView=o._renderView(e),o._selectedViewName=e,o._viewsCount>1&&(t=we({views:o.views,view:e,ns:M.ns}),n=o.toolbar.find(".k-scheduler-views li:first-child"),n.is(".k-current-view")?n.replaceWith(t):o.toolbar.find(".k-scheduler-views").prepend(t),i=o.toolbar.find(".k-scheduler-views li").removeClass("k-state-selected"),i.end().find(".k-view-"+e.replace(/\./g,"\\.").toLowerCase()).addClass("k-state-selected")))},view:function(e){var n=this;return e?(n._selectView(e),n.rebind(),t):n._selectedView},viewName:function(){return this.view().name},_renderView:function(e){var t=this._initializeView(e);return this._bindView(t),this._model.set("formattedDate",t.dateForTitle()),this._model.set("formattedShortDate",t.shortDateForTitle()),t},resize:function(e){var t=this.getSize(),n=this._size,i=this.view();i&&i.groups&&(!e&&n&&t.width===n.width&&t.height===n.height||(this.refresh({action:"resize"}),this._size=t))},_adjustSelectedDate:function(){var e=this._model.selectedDate,t=this._selection,n=t.start;n&&!M.date.isInDateRange(e,P(n),P(t.end))&&e.setFullYear(n.getFullYear(),n.getMonth(),n.getDate())},_initializeView:function(e){var t,n,i=this.views[e];if(i){if(t=G(i),n=i.type,typeof n===U&&(n=M.getter(i.type)(window)),!n)throw Error("There is no such view");i=new n(this.wrapper,h($(!0,{},this.options,t?i:{},{resources:this.resources,date:this.date(),showWorkHours:this._workDayMode})))}return i},_views:function(){var e,t,n,i,o,r,s,a,l,c=this.options.views;for(this.views={},this._viewsCount=0,s=0,a=c.length;s<a;s++)l=!1,e=c[s],i=G(e),i?(r=o=e.type?e.type:e,typeof r!==U&&(o=e.name||e.title,l=!0)):r=o=e,t=S[o],t&&!l&&(e.type=t.type,t.title=this.options.messages.views[o],"day"===t.type?t.messages={allDay:this.options.messages.allDay}:"agenda"===t.type&&(t.messages={event:this.options.messages.event,date:this.options.messages.date,time:this.options.messages.time})),e=$({title:o},t,i?e:{}),o&&(this.views[o]=e,this._viewsCount++,n&&!e.selected||(n=o));n&&(this._selectedViewName=n)},rebind:function(){this.dataSource.fetch()},_dataSource:function(){var e=this,t=e.options,n=t.dataSource;n=Q(n)?{data:n}:n,!t.timezone||n instanceof Fe?n instanceof Fe&&(t.timezone=n.options.schema?n.options.schema.timezone:""):n=$(!0,n,{schema:{timezone:t.timezone}}),e.dataSource&&e._refreshHandler?e.dataSource.unbind(ee,e._refreshHandler).unbind("progress",e._progressHandler).unbind("error",e._errorHandler):(e._refreshHandler=K(e.refresh,e),e._progressHandler=K(e._requestStart,e),e._errorHandler=K(e._error,e)),e.dataSource=M.data.SchedulerDataSource.create(n).bind(ee,e._refreshHandler).bind("progress",e._progressHandler).bind("error",e._errorHandler),e.options.dataSource=e.dataSource},_error:function(){this._progress(!1)},_requestStart:function(){this._progress(!0)},_progress:function(e){var t=this.element.find(".k-scheduler-content");M.ui.progress(t,e)},_resources:function(){var t,n,i,o,r,s=this,a=s.options.resources;for(t=0;t<a.length;t++){if(n=a[t],i=n.field,o=n.dataSource,!i||!o)throw Error('The "field" and "dataSource" options of the scheduler resource are mandatory.');s.resources.push({field:i,name:n.name||i,title:n.title||i,dataTextField:n.dataTextField||"text",dataValueField:n.dataValueField||"value",dataColorField:n.dataColorField||"color",valuePrimitive:null==n.valuePrimitive||n.valuePrimitive,multiple:n.multiple||!1,dataSource:M.data.DataSource.create(o)})}r=e.map(s.resources,function(e){return e.dataSource.fetch()}),e.when.apply(null,r).then(function(){s.options.autoBind?s.view(s._selectedViewName):s._selectView(s._selectedViewName)})},_initModel:function(){var e=this;e._model=M.observable({selectedDate:new Date(this.options.date),formattedDate:"",formattedShortDate:""}),e._model.bind("change",function(t){"selectedDate"===t.field&&e.view(e._selectedViewName)})},_wrapper:function(){var e=this,t=e.options,n=t.height,i=t.width;e.wrapper=e.element.addClass("k-widget k-scheduler k-floatwrap").attr("role","grid").attr("aria-multiselectable",!0),e._isMobile()&&e.wrapper.addClass("k-scheduler-mobile"),e._isMobilePhoneView()&&e.wrapper.addClass("k-scheduler-phone"),n&&e.wrapper.height(n),i&&e.wrapper.width(i)},date:function(e){return null!=e&&P(e)>=P(this.options.min)&&P(e)<=P(this.options.max)&&this._model.set("selectedDate",e),P(this._model.get("selectedDate"))},_toolbar:function(){var n,i,o=this,r=o.options,s=[];r.toolbar&&(s=e.isArray(r.toolbar)?r.toolbar:[r.toolbar]),n=this._isMobilePhoneView()?ke:ye,i=e(n({messages:r.messages,pdf:e.grep(s,function(e){return"pdf"==e||"pdf"==e.name}).length>0,ns:M.ns,view:o._selectedViewName,views:o.views,viewsCount:o._viewsCount})),o.wrapper.append(i),o.toolbar=i,M.bind(o.toolbar,o._model),i.on(Z+X,".k-pdf",function(e){e.preventDefault(),o.saveAsPDF()}),i.on(Z+X,".k-scheduler-navigation li",function(n){var i,r=e(this),s=new Date(o.date()),a="",l=new Date,c=o.options.timezone;if(n.preventDefault(),r.hasClass("k-nav-today"))a="today",c?(i=M.timezone.offset(l,c),s=M.timezone.convert(l,l.getTimezoneOffset(),i)):s=l;else if(r.hasClass("k-nav-next"))a="next",s=o.view().nextDate();else if(r.hasClass("k-nav-prev"))a="previous",s=o.view().previousDate();else if(r.hasClass("k-nav-current")&&!o._isMobilePhoneView())return o._showCalendar(),t;o.trigger("navigate",{view:o._selectedViewName,action:a,date:s})||o.date(s)}),i.on(Z+X,".k-scheduler-views li:not(.k-current-view), .k-scheduler-refresh",function(t){t.preventDefault();var n=e(this).attr(M.attr("name"));o.trigger("navigate",{view:n,action:"changeView",date:o.date()})||(o.view(n),o.element.find("."+ae).removeClass(ae))}),i.on(Z+X,".k-scheduler-views li.k-current-view",function(t){t.preventDefault(),o.element.find(".k-scheduler-views").toggleClass(ae),e(document).on(J+X,function(t){0===e(t.target).closest(".k-scheduler-views").length&&(o.element.find("."+ae).removeClass(ae),e(document).off(Z+X))})}),i.find("li").hover(function(){e(this).addClass("k-state-hover")},function(){e(this).removeClass("k-state-hover")})},_showCalendar:function(){var t=this,n=t.toolbar.find(".k-nav-current"),i=e('<div class="k-calendar-container"><div class="k-scheduler-calendar"/></div>');t.popup||(t.popup=new W(i,{anchor:n,open:function(){t.calendar||(t.calendar=new j(this.element.find(".k-scheduler-calendar"),{change:function(){var e=this.value();t.trigger("navigate",{view:t._selectedViewName,action:"changeDate",date:e})||(t.date(e),t.popup.close()),t._selectedView.element.focus(),t.toolbar.find(".k-nav-current").focus().addClass(se)},min:t.options.min,max:t.options.max})),t.calendar.element.on("keydown"+X,function(e){e.keyCode!==H.ESC&&e.keyCode!==H.TAB||(t.popup.close(),t._selectedView.element.focus(),t.toolbar.find(".k-nav-current").focus().addClass(se))}),t.calendar.value(t.date())},copyAnchorStyles:!1})),t.popup.open(),t.calendar.element.find("table").focus()},refresh:function(e){var t=this,n=this.view();this._progress(!1),this.angular("cleanup",function(){return{elements:t.items()}}),e=e||{},n&&(e&&"itemchange"===e.action&&(this._editor.editable||this._preventRefresh)||this.trigger("dataBinding",{action:e.action||"rebind",index:e.index,items:e.items})||(e&&"resize"===e.action||!this._editor||this._editor.close(),this._data=this.dataSource.expand(n.startDate(),n.visibleEndDate()),n.refreshLayout(),n.render(this._data),this.trigger("dataBound")))},slotByPosition:function(e,t){var n,i=this.view();return i._slotByPosition?(n=i._slotByPosition(e,t),n?{startDate:n.startDate(),endDate:n.endDate(),groupIndex:n.groupIndex,element:n.element,isDaySlot:n.isDaySlot}:null):null},slotByElement:function(t){var n=e(t).offset();return this.slotByPosition(n.left,n.top)},resourcesBySlot:function(e){return this.view()._resourceBySlot(e)}}),S={day:{type:"kendo.ui.DayView"},week:{type:"kendo.ui.WeekView"},workWeek:{type:"kendo.ui.WorkWeekView"},agenda:{type:"kendo.ui.AgendaView"},month:{type:"kendo.ui.MonthView"},timeline:{type:"kendo.ui.TimelineView"},timelineWeek:{type:"kendo.ui.TimelineWeekView"},timelineWorkWeek:{type:"kendo.ui.TimelineWorkWeekView"},timelineMonth:{type:"kendo.ui.TimelineMonthView"}},N.plugin(C),M.PDFMixin&&(M.PDFMixin.extend(C.prototype),T="k-scheduler-pdf-export",C.fn._drawPDF=function(t){var n,i,o,r=this.wrapper,s=r[0].style.cssText;return r.css({width:r.width(),height:r.height()}),r.addClass(T),n=this,i=new e.Deferred,o=r.find(".k-scheduler-content").find("table").css("table-layout","auto"),setTimeout(function(){o.css("table-layout","fixed"),n.resize(!0),n._drawPDFShadow({},{avoidLinks:n.options.pdf.avoidLinks}).done(function(e){var n={page:e,pageNumber:1,progress:1,totalPages:1};t.notify(n),i.resolve(n.page)}).fail(function(e){i.reject(e)}).always(function(){r[0].style.cssText=s,r.removeClass(T),n.resize(!0),n.resize(!0)})}),i}),D=O.extend({init:function(e,t){var n=this,i=M.timezone.windows_zones;if(!i||!M.timezone.zones_titles)throw Error("kendo.timezones.min.js is not included.");O.fn.init.call(n,e,t),n.wrapper=n.element,n._zonesQuery=new M.data.Query(i),n._zoneTitleId=M.guid(),n._zoneTitlePicker(),n._zonePicker(),n._zoneTitle.bind("cascade",function(){this.value()||n._zone.wrapper.hide()}),n._zone.bind("cascade",function(){n._value=this.value(),n.trigger("change")}),n.value(n.options.value)},options:{name:"TimezoneEditor",value:"",optionLabel:"No timezone"},events:["change"],_zoneTitlePicker:function(){var t=this,n=e('<input id="'+t._zoneTitleId+'" aria-label="'+t.options.title+'"/>').appendTo(t.wrapper);t._zoneTitle=new M.ui.DropDownList(n,{dataSource:M.timezone.zones_titles,dataValueField:"other_zone",dataTextField:"name",optionLabel:t.options.optionLabel})},_zonePicker:function(){var t=this,n=e('<input aria-label="'+t.options.title+'"/>').appendTo(this.wrapper);t._zone=new M.ui.DropDownList(n,{dataValueField:"zone",dataTextField:"territory",dataSource:t._zonesQuery.data,cascadeFrom:t._zoneTitleId,dataBound:function(){t._value=this.value(),this.wrapper.toggle(this.dataSource.view().length>1)}}),t._zone.wrapper.hide()},destroy:function(){O.fn.destroy.call(this),M.destroy(this.wrapper)},value:function(e){var n,i=this;return e===t?i._value:(n=i._zonesQuery.filter({field:"zone",operator:"eq",value:e}).data[0],n?(i._zoneTitle.value(n.other_zone),i._zone.value(n.zone)):i._zoneTitle.select(0),t)}}),N.plugin(D),A=M.template('<option value="#=other_zone#">#=name#</option>'),E=M.template('<option value="#=zone#">#=territory#</option>'),I=O.extend({init:function(e,t){var n=this,i=M.timezone.windows_zones;if(!i||!M.timezone.zones_titles)throw Error("kendo.timezones.min.js is not included.");O.fn.init.call(n,e,t),n.wrapper=n.element,n._zonesQuery=new M.data.Query(i),n._zoneTitlePicker(),n._zonePicker(),n.value(n.options.value)},options:{name:"MobileTimezoneEditor",optionLabel:"No timezone",value:""},events:["change"],_bindZones:function(e){var t=e?this._filter(e):[];this._zone.html(this._options(t,E))},_filter:function(e){return this._zonesQuery.filter({field:"other_zone",operator:"eq",value:e}).data},_options:function(e,t,n){var i=0,o="",r=e.length;for(n&&(o+=t({other_zone:"",name:n}));i<r;i++)o+=t(e[i]);return o},_zoneTitlePicker:function(){var t=this,n=t._options(M.timezone.zones_titles,A,t.options.optionLabel);t._zoneTitle=e("<select>"+n+"</select>").appendTo(t.wrapper).change(function(){var e=this.value,n=t._zone;t._bindZones(e),e&&n[0].children.length>1?n.show():n.hide(),t._value=n[0].value,t.trigger("change")})},_zonePicker:function(){var t=this;t._zone=e('<select style="display:none"></select>').appendTo(this.wrapper).change(function(){t._value=this.value,t.trigger("change")}),t._bindZones(t._zoneTitle.val()),t._value=t._zone[0].value},destroy:function(){O.fn.destroy.call(this),M.destroy(this.wrapper)},value:function(e){var n,i=this,o=i._zone,r="",s="";return e===t?i._value:(n=i._zonesQuery.filter({field:"zone",operator:"eq",value:e}).data[0],n&&(s=n.zone,r=n.other_zone),i._zoneTitle.val(r),i._bindZones(r),o.val(s),s=o[0].value,s&&o[0].children.length>1?o.show():o.hide(),i._value=s,t)}}),N.plugin(I)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.touch.min",["kendo.core.min","kendo.userevents.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.ui.Widget,o=e.proxy,r=Math.abs,s=20,a=i.extend({init:function(e,t){function r(e){return function(t){a._triggerTouch(e,t)}}function s(e){return function(t){a.trigger(e,{touches:t.touches,distance:t.distance,center:t.center,event:t.event})}}var a=this;i.fn.init.call(a,e,t),t=a.options,e=a.element,a.wrapper=e,a.events=new n.UserEvents(e,{filter:t.filter,surface:t.surface,minHold:t.minHold,multiTouch:t.multiTouch,allowSelection:!0,fastTap:t.fastTap,press:r("touchstart"),hold:r("hold"),tap:o(a,"_tap"),gesturestart:s("gesturestart"),gesturechange:s("gesturechange"),gestureend:s("gestureend")}),t.enableSwipe?(a.events.bind("start",o(a,"_swipestart")),a.events.bind("move",o(a,"_swipemove"))):(a.events.bind("start",o(a,"_dragstart")),a.events.bind("move",r("drag")),a.events.bind("end",r("dragend"))),n.notify(a)},events:["touchstart","dragstart","drag","dragend","tap","doubletap","hold","swipe","gesturestart","gesturechange","gestureend"],options:{name:"Touch",surface:null,global:!1,fastTap:!1,filter:null,multiTouch:!1,enableSwipe:!1,minXDelta:30,maxYDelta:20,maxDuration:1e3,minHold:800,doubleTapTimeout:800},cancel:function(){this.events.cancel()},destroy:function(){i.fn.destroy.call(this),this.events.destroy()},_triggerTouch:function(e,t){this.trigger(e,{touch:t.touch,event:t.event})&&t.preventDefault()},_tap:function(e){var t=this,i=t.lastTap,o=e.touch;i&&o.endTime-i.endTime<t.options.doubleTapTimeout&&n.touchDelta(o,i).distance<s?(t._triggerTouch("doubletap",e),t.lastTap=null):(t._triggerTouch("tap",e),t.lastTap=o)},_dragstart:function(e){this._triggerTouch("dragstart",e)},_swipestart:function(e){2*r(e.x.velocity)>=r(e.y.velocity)&&e.sender.capture()},_swipemove:function(e){var t=this,n=t.options,i=e.touch,o=e.event.timeStamp-i.startTime,s=i.x.initialDelta>0?"right":"left";r(i.x.initialDelta)>=n.minXDelta&&r(i.y.initialDelta)<n.maxYDelta&&o<n.maxDuration&&(t.trigger("swipe",{direction:s,touch:e.touch}),i.cancel())}});n.ui.plugin(a)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.gantt.list.min",["kendo.dom.min","kendo.touch.min","kendo.draganddrop.min","kendo.columnsorter.min","kendo.datetimepicker.min","kendo.editable.min"],e)}(function(){return function(e){function t(e){var t,n,i=[],o=e.className;for(t=0,n=e.level;t<n;t++)i.push(r("span",{className:o}));return i}function n(){var t=i._activeElement();t&&"body"!==t.nodeName.toLowerCase()&&e(t).blur()}var i=window.kendo,o=i.dom,r=o.element,s=o.text,a=i.support.browser,l=i.support.mobileOS,c=i.ui,d=c.Widget,u=e.extend,h=i._outerWidth,f=i._outerHeight,p=e.map,m=e.isFunction,g=a.msie&&a.version<9,v=i.keys,_={title:"Title",start:"Start Time",end:"End Time",percentComplete:"% Done",parentId:"Predecessor ID",id:"ID",orderId:"Order ID"},b="string",w=".kendoGanttList",y="click",k=".",x="<table style='visibility: hidden;'><tbody><tr style='height:{0}'><td>&nbsp;</td></tr></tbody></table>",C={wrapper:"k-treelist k-grid k-widget",header:"k-header",alt:"k-alt",rtl:"k-rtl",editCell:"k-edit-cell",group:"k-treelist-group",gridHeader:"k-grid-header",gridHeaderWrap:"k-grid-header-wrap",gridContent:"k-grid-content",gridContentWrap:"k-grid-content",selected:"k-state-selected",icon:"k-icon",iconCollapse:"k-i-collapse",iconExpand:"k-i-expand",iconHidden:"k-i-none",iconPlaceHolder:"k-icon k-i-none",input:"k-input",link:"k-link",resizeHandle:"k-resize-handle",resizeHandleInner:"k-resize-handle-inner",dropPositions:"k-i-insert-up k-i-insert-down k-i-plus k-i-insert-middle",dropTop:"k-i-insert-up",dropBottom:"k-i-insert-down",dropAdd:"k-i-plus",dropMiddle:"k-i-insert-middle",dropDenied:"k-i-cancel",dragStatus:"k-drag-status",dragClue:"k-drag-clue",dragClueText:"k-clue-text"},S=c.GanttList=d.extend({init:function(t,n){d.fn.init.call(this,t,n),0===this.options.columns.length&&this.options.columns.push("title"),this.dataSource=this.options.dataSource,this._columns(),this._layout(),this._domTrees(),this._header(),this._sortable(),this._editable(),this._selectable(),this._draggable(),this._resizable(),this._attachEvents(),this._adjustHeight(),this.bind("render",function(){var t,n;this.options.resizable&&(t=this.header.find("col"),n=this.content.find("col"),this.header.find("th").not(":last").each(function(i){var o=h(e(this));t.eq(i).width(o),n.eq(i).width(o)}),t.last().css("width","auto"),n.last().css("width","auto"))},!0)},_adjustHeight:function(){this.content&&this.content.height(this.element.height()-f(this.header.parent()))},destroy:function(){d.fn.destroy.call(this),this._reorderDraggable&&this._reorderDraggable.destroy(),this._tableDropArea&&this._tableDropArea.destroy(),this._contentDropArea&&this._contentDropArea.destroy(),this._columnResizable&&this._columnResizable.destroy(),this.touch&&this.touch.destroy(),this.timer&&clearTimeout(this.timer),this.content.off(w),this.header.find("thead").off(w),this.header.find(k+S.link).off(w),this.header=null,this.content=null,this.levels=null,i.destroy(this.element)},options:{name:"GanttList",selectable:!0,editable:!0,resizable:!1},_attachEvents:function(){var t=this,n=S.styles;t.content.on(y+w,"td > span."+n.icon+":not(."+n.iconHidden+")",function(n){var i=e(this),o=t._modelFromElement(i);o.set("expanded",!o.get("expanded")),n.stopPropagation()})},_domTrees:function(){this.headerTree=new o.Tree(this.header[0]),this.contentTree=new o.Tree(this.content[0])},_columns:function(){var e=this.options.columns,t=function(){this.field="",this.title="",this.editable=!1,this.sortable=!1};this.columns=p(e,function(e){return e=typeof e===b?{field:e,title:_[e]}:e,u(new t,e)})},_layout:function(){var t=this,n=this.options,o=this.element,r=S.styles,s=function(){var o,r=typeof n.rowHeight===b?n.rowHeight:n.rowHeight+"px",s=e(i.format(x,r));return t.content.append(s),o=f(s.find("tr")),s.remove(),o};o.addClass(r.wrapper).append("<div class='"+r.gridHeader+"'><div class='"+r.gridHeaderWrap+"'></div></div>").append("<div class='"+r.gridContentWrap+"'></div>"),this.header=o.find(k+r.gridHeaderWrap),this.content=o.find(k+r.gridContent),n.rowHeight&&(this._rowHeight=s())},_header:function(){var e=this.headerTree,t=r("colgroup",null,this._cols()),n=r("thead",{role:"rowgroup"},[r("tr",{role:"row"},this._ths())]),i=r("table",{style:{minWidth:this.options.listWidth+"px"},role:"grid"},[t,n]);e.render([i])},_render:function(e){var t,n,i,o={style:{minWidth:this.options.listWidth+"px"},tabIndex:0,role:"treegrid"};this._rowHeight&&(o.style.height=e.length*this._rowHeight+"px"),this.levels=[{field:null,value:0}],t=r("colgroup",null,this._cols()),n=r("tbody",{role:"rowgroup"},this._trs(e)),i=r("table",o,[t,n]),this.contentTree.render([i]),this.trigger("render")},_ths:function(){var e,t,n,i,o=this.columns,a=[];for(n=0,i=o.length;n<i;n++)e=o[n],t={"data-field":e.field,"data-title":e.title,className:S.styles.header,role:"columnheader"},a.push(r("th",t,[s(e.title)]));return this.options.resizable&&a.push(r("th",{className:S.styles.header,role:"columnheader"})),a},_cols:function(){var e,t,n,i,o,s=this.columns,a=[];for(i=0,o=s.length;i<o;i++)e=s[i],n=e.width,t=n&&0!==parseInt(n,10)?{style:{width:typeof n===b?n:n+"px"}}:null,a.push(r("col",t,[]));return this.options.resizable&&a.push(r("col",{style:{width:"1px"}})),a},_trs:function(e){var t,n,i,o,r,s=[],a=[],l=S.styles;for(o=0,r=e.length;o<r;o++)t=e[o],i=this._levels({idx:t.parentId,id:t.id,summary:t.summary}),n={"data-uid":t.uid,"data-level":i,role:"row"},t.summary&&(n["aria-expanded"]=t.expanded),o%2!==0&&a.push(l.alt),t.summary&&a.push(l.group),a.length&&(n.className=a.join(" ")),s.push(this._tds({task:t,attr:n,level:i})),a=[];return s},_tds:function(e){var t,n,i,o=[],s=this.columns;for(n=0,i=s.length;n<i;n++)t=s[n],o.push(this._td({task:e.task,column:t,level:e.level}));return this.options.resizable&&o.push(r("td",{role:"gridcell"})),r("tr",e.attr,o)},_td:function(e){var n,o,a,l=[],c=this.options.resourcesField,d=S.styles,u=e.task,h=e.column,f=u.get(h.field);if(h.field==c){for(f=f||[],n=[],a=0;a<f.length;a++)n.push(i.format("{0} [{1}]",f[a].get("name"),f[a].get("formatedValue")));n=n.join(", ")}else n=h.format?i.format(h.format,f):f;return"title"===h.field&&(l=t({level:e.level,className:d.iconPlaceHolder}),l.push(r("span",{className:d.icon+" "+(u.summary?u.expanded?d.iconCollapse:d.iconExpand:d.iconHidden)})),o=i.format("{0}, {1:P0}",n,u.percentComplete)),l.push(r("span",{"aria-label":o},[s(n)])),r("td",{role:"gridcell"},l)},_levels:function(e){var t,n,i,o=this.levels,r=e.summary,s=e.idx,a=e.id;for(n=0,i=o.length;n<i;n++)if(t=o[n],t.field==s)return r&&o.push({field:a,value:t.value+1}),t.value},_sortable:function(){var e,t,n,o,r,s=this,a=this.options.resourcesField,l=this.columns,c=this.header.find("th["+i.attr("field")+"]"),d=function(e){(0===s.dataSource.total()||s.editable&&s.editable.trigger("validate"))&&e.preventDefault()};for(o=0,r=c.length;o<r;o++)e=l[o],e.sortable&&e.field!==a&&(n=c.eq(o),t=n.data("kendoColumnSorter"),t&&t.destroy(),n.attr("data-"+i.ns+"field",e.field).kendoColumnSorter({dataSource:this.dataSource,change:d}));c=null},_selectable:function(){var t=this,n=this.options.selectable;n&&this.content.on(y+w,"tr",function(n){var i=e(this);t.editable&&t.editable.trigger("validate"),n.ctrlKey?t.clearSelection():t.select(i)})},select:function(e){var t=this.content.find(e),n=S.styles.selected;return t.length?(t.siblings(k+n).removeClass(n).attr("aria-selected",!1).end().addClass(n).attr("aria-selected",!0),void this.trigger("change")):this.content.find(k+n)},clearSelection:function(){var e=this.select();e.length&&(e.removeClass(S.styles.selected),this.trigger("change"))},_setDataSource:function(e){this.dataSource=e,this._sortable()},_editable:function(){var t=this,i=this.options.editable,o=S.styles,r="span."+o.icon+":not("+o.iconHidden+")",s=function(){var e=t.editable;e&&(e.end()?t._closeCell():e.trigger("validate"))},a=function(t){var i=e(t.currentTarget);i.hasClass(o.editCell)||n()};i&&i.update!==!1&&(this._startEditHandler=function(n){var i=n.currentTarget?e(n.currentTarget):n,o=t._columnFromElement(i);t.editable||o&&o.editable&&t._editCell({cell:i,column:o})},t.content.on("focusin"+w,function(){clearTimeout(t.timer),t.timer=null}).on("focusout"+w,function(){t.timer=setTimeout(s,1)}).on("keydown"+w,function(e){e.keyCode===v.ENTER&&e.preventDefault()}).on("keyup"+w,function(e){var i,o,r=e.keyCode;switch(r){case v.ENTER:n(),s();break;case v.ESC:t.editable&&(i=t._editableContainer,o=t._modelFromElement(i),t.trigger("cancel",{model:o,cell:i})||t._closeCell(!0))}}),l?t.touch=t.content.kendoTouch({filter:"td",touchstart:function(e){a(e.touch)},doubletap:function(n){e(n.touch.initialTouch).is(r)||t._startEditHandler(n.touch)}}).data("kendoTouch"):t.content.on("mousedown"+w,"td",function(e){a(e)}).on("dblclick"+w,"td",function(n){e(n.target).is(r)||t._startEditHandler(n)}))},_editCell:function(t){var n,o=this.options.resourcesField,r=S.styles,s=t.cell,a=t.column,l=this._modelFromElement(s),c=this.dataSource._createNewModel(l.toJSON()),d=c.fields[a.field]||c[a.field],u=d.validation,h=i.attr("type"),f=i.attr("bind"),p=i.attr("format"),v={name:a.field,required:!!d.validation&&d.validation.required===!0};return a.field===o?void a.editor(s,c):(this._editableContent=s.children().detach(),this._editableContainer=s,s.data("modelCopy",c),"date"!==d.type&&"date"!==e.type(d)||a.format&&!/H|m|s|F|g|u/.test(a.format)||(v[f]="value:"+a.field,v[h]="date",a.format&&(v[p]=i._extractFormat(a.format)),n=function(t,n){e('<input type="text"/>').attr(v).appendTo(t).kendoDateTimePicker({format:n.format})}),this.editable=s.addClass(r.editCell).kendoEditable({fields:{field:a.field,format:a.format,editor:a.editor||n},model:c,clearContainer:!1}).data("kendoEditable"),u&&u.dateCompare&&m(u.dateCompare)&&u.message&&(e("<span "+i.attr("for")+'="'+a.field+'" class="k-invalid-msg"/>').hide().appendTo(s),s.find("[name="+a.field+"]").attr(i.attr("dateCompare-msg"),u.message)),this.editable.bind("validate",function(e){var t=this.element.find(":kendoFocusable:first").focus();g&&t.focus(),e.preventDefault()}),void(this.trigger("edit",{model:l,cell:s})&&this._closeCell(!0)))},_closeCell:function(e){var t=S.styles,n=this._editableContainer,i=this._modelFromElement(n),o=this._columnFromElement(n),r=o.field,s=n.data("modelCopy"),a={};a[r]=s.get(r),n.empty().removeData("modelCopy").removeClass(t.editCell).append(this._editableContent),this.editable.unbind(),this.editable.destroy(),this.editable=null,this._editableContainer=null,this._editableContent=null,e||("start"===r&&(a.end=new Date(a.start.getTime()+i.duration())),this.trigger("update",{task:i,updateInfo:a}))},_draggable:function(){var t,n=this,o=null,r=!0,s=S.styles,a=i.support.isRtl(this.element),c="tr["+i.attr("level")+" = 0]:last",d={},h=this.options.editable,f=function(){o=null,t=null,r=!0,d={}},p=function(e){for(var t=e;t;){if(o.get("id")===t.get("id")){r=!1;break}t=n.dataSource.taskParent(t)}},m=function(){var n=e(t).height(),o=i.getOffset(t).top;u(t,{beforeLimit:o+.25*n,afterLimit:o+.75*n})},g=function(e){var n,o,r,a,l;t&&(n=e.location,o=s.dropAdd,r="add",a=parseInt(t.attr(i.attr("level")),10),n<=t.beforeLimit?(l=t.prev(),o=s.dropTop,r="insert-before"):n>=t.afterLimit&&(l=t.next(),o=s.dropBottom,r="insert-after"),l&&parseInt(l.attr(i.attr("level")),10)===a&&(o=s.dropMiddle),d.className=o,d.command=r)},v=function(){return n._reorderDraggable.hint.children(k+s.dragStatus).removeClass(s.dropPositions)};h&&h.reorder!==!1&&h.update!==!1&&(this._reorderDraggable=this.content.kendoDraggable({distance:10,holdToDrag:l,group:"listGroup",filter:"tr[data-uid]",ignore:k+s.input,hint:function(t){return e('<div class="'+s.header+" "+s.dragClue+'"/>').css({width:300,paddingLeft:t.css("paddingLeft"),paddingRight:t.css("paddingRight"),lineHeight:t.height()+"px",paddingTop:t.css("paddingTop"),paddingBottom:t.css("paddingBottom")}).append('<span class="'+s.icon+" "+s.dragStatus+'" /><span class="'+s.dragClueText+'"/>')},cursorOffset:{top:-20,left:0},container:this.content,dragstart:function(e){var t=n.editable;return t&&t.reorder!==!1&&t.trigger("validate")?void e.preventDefault():(o=n._modelFromElement(e.currentTarget),this.hint.children(k+s.dragClueText).text(o.get("title")),void(a&&this.hint.addClass(s.rtl)))},drag:function(e){r&&(g(e.y),v().addClass(d.className))},dragend:function(){f()},dragcancel:function(){f()}}).data("kendoDraggable"),this._tableDropArea=this.content.kendoDropTargetArea({distance:0,group:"listGroup",filter:"tr[data-uid]",dragenter:function(e){t=e.dropTarget,p(n._modelFromElement(t)),m(),v().toggleClass(s.dropDenied,!r)},dragleave:function(){r=!0,v()},drop:function(){var e=n._modelFromElement(t),i=e.orderId,s={parentId:e.parentId};if(r){switch(d.command){case"add":s.parentId=e.id;break;case"insert-before":s.orderId=e.parentId===o.parentId&&e.orderId>o.orderId?i-1:i;break;case"insert-after":s.orderId=e.parentId===o.parentId&&e.orderId>o.orderId?i:i+1}n.trigger("update",{task:o,updateInfo:s})}}}).data("kendoDropTargetArea"),this._contentDropArea=this.element.kendoDropTargetArea({distance:0,group:"listGroup",filter:k+s.gridContent,drop:function(){var e=n._modelFromElement(n.content.find(c)),t=e.orderId,i={parentId:null,orderId:null!==o.parentId?t+1:t};n.trigger("update",{task:o,updateInfo:i})}}).data("kendoDropTargetArea"))},_resizable:function(){var t=this,n=S.styles,i=function(i){var o,r,s=e(i.currentTarget),a=t.resizeHandle,l=s.position(),c=l.left,d=h(s),u=s.closest("div"),p=i.clientX+e(window).scrollLeft(),m=t.options.columnResizeHandleWidth;
return c+=u.scrollLeft(),a||(a=t.resizeHandle=e('<div class="'+n.resizeHandle+'"><div class="'+n.resizeHandleInner+'" /></div>')),o=s.offset().left+d,(r=p>o-m&&p<o+m)?(u.append(a),void a.show().css({top:l.top,left:c+d-m-1,height:f(s),width:3*m}).data("th",s)):void a.hide()};this.options.resizable&&(this._columnResizable&&this._columnResizable.destroy(),this.header.find("thead").on("mousemove"+w,"th",i),this._columnResizable=this.header.kendoResizable({handle:k+n.resizeHandle,start:function(n){var i=e(n.currentTarget).data("th"),o="col:eq("+i.index()+")",r=t.header.find("table"),s=t.content.find("table");t.element.addClass("k-grid-column-resizing"),this.col=s.children("colgroup").find(o).add(r.find(o)),this.th=i,this.startLocation=n.x.location,this.columnWidth=h(i),this.table=r.add(s),this.totalWidth=this.table.width()-h(r.find("th:last"))},resize:function(e){var t=11,n=e.x.location-this.startLocation;this.columnWidth+n<t&&(n=t-this.columnWidth),this.table.css({minWidth:this.totalWidth+n}),this.col.width(this.columnWidth+n)},resizeend:function(){var e,n,i;t.element.removeClass("k-grid-column-resizing"),e=Math.floor(this.columnWidth),n=Math.floor(h(this.th)),i=t.columns[this.th.index()],t.trigger("columnResize",{column:i,oldWidth:e,newWidth:n}),this.table=this.col=this.th=null}}).data("kendoResizable"))},_modelFromElement:function(e){var t=e.closest("tr"),n=this.dataSource.getByUid(t.attr(i.attr("uid")));return n},_columnFromElement:function(e){var t=e.closest("td"),n=t.parent(),i=n.children().index(t);return this.columns[i]}});u(!0,c.GanttList,{styles:C})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.gantt.timeline.min",["kendo.dom.min","kendo.touch.min","kendo.draganddrop.min"],e)}(function(){return function(e){function t(e){return delete e.name,delete e.prefix,delete e.views,e}function n(e){var t=[],n=e.workWeekStart;for(t.push(n);e.workWeekEnd!=n;)n>6?n-=7:n++,t.push(n);return t}function i(){var t=kendo._activeElement();t&&"body"!==t.nodeName.toLowerCase()&&e(t).blur()}var o,r,s=kendo.ui.Widget,a=kendo.dom.element,l=kendo.dom.text,c=kendo.dom.html,d=e.isPlainObject,u=kendo._outerWidth,h=kendo._outerHeight,f=e.extend,p=e.proxy,m=kendo.support.browser,g=!1,v=kendo.keys,_=kendo.data.Query,b="string",w=".kendoGanttTimeline",y="click",k="dblclick",x="mousemove",C="mouseenter",S="mouseleave",T="keydown",D=".",A=kendo.template("#=kendo.toString(start, 't')#"),E=kendo.template("#=kendo.toString(start, 'ddd M/dd')#"),I=kendo.template("#=kendo.toString(start, 'ddd M/dd')# - #=kendo.toString(kendo.date.addDays(end, -1), 'ddd M/dd')#"),M=kendo.template("#=kendo.toString(start, 'MMM')#"),R=kendo.template("#=kendo.toString(start, 'yyyy')#"),F=kendo.template('<div class="#=styles.marquee#"><div class="#=styles.marqueeColor#"></div></div>'),z=kendo.template('<div style="z-index: 100002;" class="#=styles.tooltipWrapper#"><div class="#=styles.tooltipContent#"><div>#=messages.start#: #=kendo.toString(start, format)#</div><div>#=messages.end#: #=kendo.toString(end, format)#</div></div></div>'),P=kendo.template('<div style="z-index: 100002;" class="#=styles.tooltipWrapper#" ><div class="#=styles.tooltipContent#">#=text#%</div><div class="#=styles.tooltipCallout#" style="left:13px;"></div></div>'),B=kendo.template('<div class="#=kendo.htmlEncode(styles.taskDetails)#"><strong>#=kendo.htmlEncode(task.title)#</strong><div class="#=styles.taskDetailsPercent#">#=kendo.toString(task.percentComplete, "p0")#</div><ul class="#=styles.reset#"><li>#=messages.start#: #=kendo.toString(task.start, "h:mm tt ddd, MMM d")#</li><li>#=messages.end#: #=kendo.toString(task.end, "h:mm tt ddd, MMM d")#</li></ul></div>'),L="<table style='visibility: hidden;'><tbody><tr style='height:{0}'><td>&nbsp;</td></tr></tbody></table>",H={day:{type:"kendo.ui.GanttDayView"},week:{type:"kendo.ui.GanttWeekView"},month:{type:"kendo.ui.GanttMonthView"},year:{type:"kendo.ui.GanttYearView"}},N={alt:"k-alt",reset:"k-reset",nonWorking:"k-nonwork-hour",header:"k-header",gridHeader:"k-grid-header",gridHeaderWrap:"k-grid-header-wrap",gridContent:"k-grid-content",tasksWrapper:"k-gantt-tables",rowsTable:"k-gantt-rows",columnsTable:"k-gantt-columns",tasksTable:"k-gantt-tasks",dependenciesWrapper:"k-gantt-dependencies",resource:"k-resource",resourceAlt:"k-resource k-alt",task:"k-task",taskSingle:"k-task-single",taskMilestone:"k-task-milestone",taskSummary:"k-task-summary",taskWrap:"k-task-wrap",taskMilestoneWrap:"k-milestone-wrap",resourcesWrap:"k-resources-wrap",taskDot:"k-task-dot",taskDotStart:"k-task-start",taskDotEnd:"k-task-end",taskDragHandle:"k-task-draghandle",taskContent:"k-task-content",taskTemplate:"k-task-template",taskActions:"k-task-actions",taskDelete:"k-task-delete",taskComplete:"k-task-complete",taskDetails:"k-task-details",taskDetailsPercent:"k-task-pct",link:"k-link",icon:"k-icon",iconDelete:"k-i-close",taskResizeHandle:"k-resize-handle",taskResizeHandleWest:"k-resize-w",taskResizeHandleEast:"k-resize-e",taskSummaryProgress:"k-task-summary-progress",taskSummaryComplete:"k-task-summary-complete",line:"k-line",lineHorizontal:"k-line-h",lineVertical:"k-line-v",arrowWest:"k-arrow-w",arrowEast:"k-arrow-e",dragHint:"k-drag-hint",dependencyHint:"k-dependency-hint",tooltipWrapper:"k-widget k-tooltip k-popup k-group k-reset",tooltipContent:"k-tooltip-content",tooltipCallout:"k-callout k-callout-s",callout:"k-callout",marquee:"k-marquee k-gantt-marquee",marqueeColor:"k-marquee-color"},O=kendo.ui.GanttView=s.extend({init:function(e,t){s.fn.init.call(this,e,t),this.title=this.options.title||this.options.name,this.header=this.element.find(D+O.styles.gridHeader),this.content=this.element.find(D+O.styles.gridContent),this.contentWidth=this.content.width(),this._workDays=n(this.options),this._headerTree=t.headerTree,this._taskTree=t.taskTree,this._taskTemplate=t.taskTemplate?kendo.template(t.taskTemplate,f({},kendo.Template,t.templateSettings)):null,this._dependencyTree=t.dependencyTree,this._taskCoordinates={},this._currentTime()},destroy:function(){s.fn.destroy.call(this),clearTimeout(this._tooltipTimeout),this.headerRow=null,this.header=null,this.content=null,this._dragHint=null,this._resizeHint=null,this._resizeTooltip=null,this._taskTooltip=null,this._percentCompleteResizeTooltip=null,this._headerTree=null,this._taskTree=null,this._dependencyTree=null},options:{showWorkHours:!1,showWorkDays:!1,workDayStart:new Date(1980,1,1,8,0,0),workDayEnd:new Date(1980,1,1,17,0,0),workWeekStart:1,workWeekEnd:5,hourSpan:1,slotSize:100,currentTimeMarker:{updateInterval:1e4}},renderLayout:function(){this._slots=this._createSlots(),this._tableWidth=this._calculateTableWidth(),this.createLayout(this._layout()),this._slotDimensions(),this._adjustHeight(),this.content.find(D+O.styles.dependenciesWrapper).width(this._tableWidth)},_adjustHeight:function(){this.content&&this.content.height(this.element.height()-h(this.header))},createLayout:function(e){var t=this._headers(e),n=this._colgroup(),i=this._headerTree,o=a("thead",null,t),r=a("table",{style:{width:this._tableWidth+"px"}},[n,o]);i.render([r]),this.headerRow=this.header.find("table:first tr").last()},_slotDimensions:function(){var e,t,n,i,o=this.headerRow[0].children,r=this._timeSlots();for(n=0,i=o.length;n<i;n++)t=o[n],e=r[n],e.offsetLeft=t.offsetLeft,e.offsetWidth=t.offsetWidth},render:function(e){var t,n,i=e.length,o=O.styles,r=this._rowsTable(i),s=this._columnsTable(i),a=this._tasksTable(e),l=this.options.currentTimeMarker,c=this.options.calculatedSize;this._taskTree.render([r,s,a]),t=this.content.find(D+o.rowsTable),c&&(n=c.row*e.length,this.content.find(D+o.tasksTable).height(n),t.height(n)),this._contentHeight=t.height(),this._rowHeight=c?c.row:this._contentHeight/t.find("tr").length,this.content.find(D+o.columnsTable).height(this._contentHeight),l!==!1&&void 0!==l.updateInterval&&this._renderCurrentTime()},_rowsTable:function(e){var t,n,i=[],o=O.styles,r=[null,{className:o.alt}];for(n=0;n<e;n++)t=a("tr",r[n%2],[a("td",null,[l(" ")])]),i.push(t);return this._createTable(1,i,{className:o.rowsTable})},_columnsTable:function(){var e,t,n,i,o,r=[],s=O.styles,c=this._timeSlots(),d=c.length,u=0;for(o=0;o<d;o++)t=c[o],i={},n=t.span,u+=n,1!==n&&(i.colspan=n),t.isNonWorking&&(i.className=s.nonWorking),r.push(a("td",i,[l(" ")]));return e=a("tr",null,r),this._createTable(u,[e],{className:s.columnsTable})},_tasksTable:function(e){var t,n,i,o,r,s,l,c,d=[],u=O.styles,h=this._taskCoordinates={},f=this._calculateMilestoneWidth(),p=Math.round(f.width),m=this.options.resourcesField,v=[u.resource,u.resourceAlt],_=this.options.calculatedSize,b=this._calculateResourcesMargin(),w=this._calculateTaskBorderWidth(),y=function(e){var t=i.left,n=t+i.width;o.isMilestone()&&(t-=p/2,n=t+p),h[o.id]={start:t,end:n,rowIndex:e}};for(l=0,c=e.length;l<c;l++)o=e[l],i=this._taskPosition(o),i.borderWidth=w,t=a("tr",null),n=a("td"),o.start<=this.end&&o.end>=this.start&&(n.children.push(this._renderTask(e[l],i)),o[m]&&o[m].length&&(r=g?this._tableWidth-i.left:Math.max(i.width||f.clientWidth,0)+i.left,s={width:this._tableWidth-(r+b)+"px"},s[g?"right":"left"]=r+"px",_&&(s.height=_.cell+"px"),n.children.push(a("div",{className:u.resourcesWrap,style:s},this._renderResources(o[m],v[l%2])))),y(l)),t.children.push(n),d.push(t);return this._createTable(1,d,{className:O.styles.tasksTable})},_createTable:function(e,t,n){var i,o,r,s=[];for(r=0;r<e;r++)s.push(a("col"));return i=a("colgroup",null,s),o=a("tbody",null,t),n.style||(n.style={}),n.style.width=this._tableWidth+"px",a("table",n,[i,o])},_calculateTableWidth:function(){var e,t,n,i,o=this._timeSlots(),r=0,s=0;for(n=0,i=o.length;n<i;n++)e=o[n].span,s+=e,e>r&&(r=e);return t=Math.round(s*this.options.slotSize/r)},_calculateMilestoneWidth:function(){var t,n,i=O.styles.task+" "+O.styles.taskMilestone,o=e("<div class='"+i+"' style='visibility: hidden; position: absolute'>");return this.content.append(o),n=o[0].getBoundingClientRect(),t={width:n.right-n.left,clientWidth:o[0].clientWidth},o.remove(),t},_calculateResourcesMargin:function(){var t,n=e("<div class='"+O.styles.resourcesWrap+"' style='visibility: hidden; position: absolute'>");return this.content.append(n),t=parseInt(n.css(g?"margin-right":"margin-left"),10),n.remove(),t},_calculateTaskBorderWidth:function(){var t,n,i=O.styles.task+" "+O.styles.taskSingle,o=e("<div class='"+i+"' style='visibility: hidden; position: absolute'>");return this.content.append(o),n=kendo.getComputedStyles(o[0],["border-left-width"]),t=parseFloat(n["border-left-width"],10),o.remove(),t},_renderTask:function(e,t){var n,i,o,r=this.options.editable,s=t.left,l=O.styles,c=l.taskWrap,d=this.options.calculatedSize,u={},h={className:c,style:{left:s+"px"}};return d&&(h.style.height=d.cell+"px"),e.summary?i=this._renderSummary(e,t):e.isMilestone()?(i=this._renderMilestone(e,t),h.className+=" "+l.taskMilestoneWrap):i=this._renderSingleTask(e,t),n=a("div",h,[i]),r&&r.dependencyCreate!==!1&&(n.children.push(a("div",{className:l.taskDot+" "+l.taskDotStart})),n.children.push(a("div",{className:l.taskDot+" "+l.taskDotEnd}))),e.summary||e.isMilestone()||!r||r.dragPercentComplete===!1||r.update===!1||null!==this._taskTemplate||(o=Math.round(t.width*e.percentComplete),u[g?"right":"left"]=o+"px",n.children.push(a("div",{className:l.taskDragHandle,style:u}))),n},_renderSingleTask:function(e,t){var n,i,o,r=O.styles,s=Math.round(t.width*e.percentComplete),d=[],u=this.options.editable;return null!==this._taskTemplate?n=c(this._taskTemplate(e)):(n=l(e.title),d.push(a("div",{className:r.taskComplete,style:{width:s+"px"}}))),i=a("div",{className:r.taskContent},[a("div",{className:r.taskTemplate},[n])]),d.push(i),u&&(u.destroy!==!1&&i.children.push(a("span",{className:r.taskActions},[a("a",{className:r.link+" "+r.taskDelete,href:"#","aria-label":"Delete"},[a("span",{className:r.icon+" "+r.iconDelete})])])),u.resize!==!1&&u.update!==!1&&(i.children.push(a("span",{className:r.taskResizeHandle+" "+r.taskResizeHandleWest})),i.children.push(a("span",{className:r.taskResizeHandle+" "+r.taskResizeHandleEast})))),o=a("div",{className:r.task+" "+r.taskSingle,"data-uid":e.uid,style:{width:Math.max(t.width-2*t.borderWidth,0)+"px"}},d)},_renderMilestone:function(e){var t=O.styles,n=a("div",{className:t.task+" "+t.taskMilestone,"data-uid":e.uid});return n},_renderSummary:function(e,t){var n=O.styles,i=Math.round(t.width*e.percentComplete),o=a("div",{className:n.task+" "+n.taskSummary,"data-uid":e.uid,style:{width:t.width+"px"}},[a("div",{className:n.taskSummaryProgress,style:{width:i+"px"}},[a("div",{className:n.taskSummaryComplete,style:{width:t.width+"px"}})])]);return o},_renderResources:function(e,t){var n,i,o,r=[];for(i=0,o=e.length;i<o;i++)n=e[i],r.push(a("span",{className:t,style:{color:n.get("color")}},[l(n.get("name"))]));return g&&r.reverse(),r},_taskPosition:function(e){var t=Math.round,n=t(this._offset(g?e.end:e.start)),i=t(this._offset(g?e.start:e.end));return{left:n,width:i-n}},_offset:function(e){var t,n,i,o,r=this._timeSlots(),s=0;return r.length?(o=this._slotIndex("start",e),t=r[o],t.end<e?s=t.offsetWidth:t.start<=e&&(n=e-t.start,i=t.end-t.start,s=n/i*t.offsetWidth),g&&(s=t.offsetWidth+1-s),t.offsetLeft+s):0},_slotIndex:function(e,t,n){var i,o=this._timeSlots(),r=0,s=o.length-1;n&&(o=[].slice.call(o).reverse());do i=Math.ceil((s+r)/2),o[i][e]<t?r=i:(i===s&&i--,s=i);while(r!==s);return n&&(r=o.length-1-r),r},_timeByPosition:function(t,n,i){var o,r,s,a=this._slotByPosition(t);return n?i?a.end:a.start:(o=t-e(D+O.styles.tasksTable).offset().left,r=a.end-a.start,s=o-a.offsetLeft,g&&(s=a.offsetWidth-s),new Date(a.start.getTime()+r*(s/a.offsetWidth)))},_slotByPosition:function(t){var n=t-e(D+O.styles.tasksTable).offset().left,i=this._slotIndex("offsetLeft",n,g);return this._timeSlots()[i]},_renderDependencies:function(e){var t,n,i=[],o=this._dependencyTree;for(t=0,n=e.length;t<n;t++)i.push.apply(i,this._renderDependency(e[t]));o.render(i)},_renderDependency:function(e){var t,n,i,o,r=this._taskCoordinates[e.predecessorId],s=this._taskCoordinates[e.successorId];if(!r||!s)return[];for(n="_render"+["FF","FS","SF","SS"][g?3-e.type:e.type],t=this[n](r,s),i=0,o=t.length;i<o;i++)t[i].attr["data-uid"]=e.uid;return t},_renderFF:function(e,t){var n=this._dependencyFF(e,t,!1);return n[n.length-1].children[0]=this._arrow(!0),n},_renderSS:function(e,t){var n=this._dependencyFF(t,e,!0);return n[0].children[0]=this._arrow(!1),n.reverse()},_renderFS:function(e,t){var n=this._dependencyFS(e,t,!1);return n[n.length-1].children[0]=this._arrow(!1),n},_renderSF:function(e,t){var n=this._dependencyFS(t,e,!0);return n[0].children[0]=this._arrow(!0),n.reverse()},_dependencyFF:function(e,t,n){var i,o=this,r=[],s=0,a=0,l=0,c=0,d=n?"start":"end",u=2,h=1,f=this._rowHeight,p=10,m=e.rowIndex*f+Math.floor(f/2)-1,g=t.rowIndex*f+Math.floor(f/2)-1,v=O.styles,_=function(){r.push(o._line(v.line+" "+v.lineHorizontal,{left:s+"px",top:a+"px",width:l+"px"}))},b=function(){r.push(o._line(v.line+" "+v.lineVertical,{left:s+"px",top:a+"px",height:c+"px"}))};return s=e[d],a=m,l=p,i=t[d]-e[d],i>0!==n&&(l=Math.abs(i)+p),n?(s-=l,l-=h,_()):(_(),s+=l-u),g<a?(c=a-g,c+=u,a=g,b()):(c=g-a,c+=u,b(),a+=c-u),l=Math.abs(s-t[d]),n||(l-=h,s-=l),_(),r},_dependencyFS:function(e,t,n){var i=this,o=[],r=0,s=0,a=0,l=0,c=this._rowHeight,d=Math.floor(c/2),u=10,h=2*u,f=t.start-e.end,p=2,m=1,g=e.rowIndex*c+Math.floor(c/2)-1,v=t.rowIndex*c+Math.floor(c/2)-1,_=O.styles,b=function(){o.push(i._line(_.line+" "+_.lineHorizontal,{left:r+"px",top:s+"px",width:a+"px"}))},w=function(){o.push(i._line(_.line+" "+_.lineVertical,{left:r+"px",top:s+"px",height:l+"px"}))};return r=e.end,s=g,a=u,n&&(r+=m,f>h&&(a=f-(u-p)),a-=m),b(),r+=a-p,f<=h&&(l=n?Math.abs(v-g)-d:d,v<g?(s-=l,l+=p,w()):(w(),s+=l),a=e.end-t.start+h,a<u&&(a=u),r-=a-p,b()),v<g?(l=s-v,s=v,l+=p,w()):(l=v-s,w(),s+=l),a=t.start-r,n||(a-=m),b(),o},_line:function(e,t){return a("div",{className:e,style:t})},_arrow:function(e){return a("span",{className:e?O.styles.arrowWest:O.styles.arrowEast})},_colgroup:function(){var e,t,n,i=this._timeSlots(),o=i.length,r=[];for(e=0;e<o;e++)for(t=0,n=i[e].span;t<n;t++)r.push(a("col"));return a("colgroup",null,r)},_createDragHint:function(e){this._dragHint=e.clone().addClass(O.styles.dragHint).css("cursor","move"),e.parent().append(this._dragHint)},_updateDragHint:function(e){var t=this._offset(e);this._dragHint.css({left:t})},_removeDragHint:function(){this._dragHint.remove(),this._dragHint=null},_createResizeHint:function(t){var n,i,o=O.styles,r=this._taskCoordinates[t.id].rowIndex*this._rowHeight,s=this.options,a=s.messages;this._resizeHint=e(F({styles:o})).css({top:0,height:this._contentHeight}),this.content.append(this._resizeHint),this._resizeTooltip=e(z({styles:o,start:t.start,end:t.end,messages:a.views,format:s.resizeTooltipFormat})).css({top:0,left:0}),this.content.append(this._resizeTooltip),this._resizeTooltipWidth=u(this._resizeTooltip),n=h(this._resizeTooltip),i=r-n,i<0&&(i=r+this._rowHeight),this._resizeTooltipTop=i},_updateResizeHint:function(t,n,i){var o=this._offset(g?n:t),r=this._offset(g?t:n),s=r-o,a=i!==g?o:r,l=this._tableWidth-kendo.support.scrollbar(),c=this._resizeTooltipWidth,d=this.options,u=d.messages,h=e(D+O.styles.tasksTable).offset().left-e(D+O.styles.tasksWrapper).offset().left;g&&(o+=h),this._resizeHint.css({left:o,width:s}),this._resizeTooltip&&this._resizeTooltip.remove(),a-=Math.round(c/2),a<0?a=0:a+c>l&&(a=l-c),g&&(a+=h),this._resizeTooltip=e(z({styles:O.styles,start:t,end:n,messages:u.views,format:d.resizeTooltipFormat})).css({top:this._resizeTooltipTop,left:a,"min-width":c}).appendTo(this.content)},_removeResizeHint:function(){this._resizeHint.remove(),this._resizeHint=null,this._resizeTooltip.remove(),this._resizeTooltip=null},_updatePercentCompleteTooltip:function(t,n,i){var o,r,s,a;this._removePercentCompleteTooltip(),o=this._percentCompleteResizeTooltip=e(P({styles:O.styles,text:i})).appendTo(this.element),r=Math.round(u(o)/2),s=o.find(D+O.styles.callout),a=Math.round(u(s)/2),o.css({top:t-(h(o)+a),left:n-r}),s.css("left",r-a)},_removePercentCompleteTooltip:function(){this._percentCompleteResizeTooltip&&this._percentCompleteResizeTooltip.remove(),this._percentCompleteResizeTooltip=null},_updateDependencyDragHint:function(e,t,n){this._removeDependencyDragHint(),n?this._creteVmlDependencyDragHint(e,t):this._creteDependencyDragHint(e,t)},_creteDependencyDragHint:function(t,n){var i=O.styles,o=n.x-t.x,r=n.y-t.y,s=Math.sqrt(o*o+r*r),a=Math.atan(r/o);o<0&&(a+=Math.PI),e("<div class='"+i.line+" "+i.lineHorizontal+" "+i.dependencyHint+"'></div>").css({top:t.y,left:t.x,width:s,"transform-origin":"0% 0","-ms-transform-origin":"0% 0","-webkit-transform-origin":"0% 0",transform:"rotate("+a+"rad)","-ms-transform":"rotate("+a+"rad)","-webkit-transform":"rotate("+a+"rad)"}).appendTo(this.content)},_creteVmlDependencyDragHint:function(t,n){var i=e("<kvml:line class='"+O.styles.dependencyHint+"' style='position:absolute; top: 0px; left: 0px;' strokecolor='black' strokeweight='2px' from='"+t.x+"px,"+t.y+"px' to='"+n.x+"px,"+n.y+"px'></kvml:line>").appendTo(this.content);i[0].outerHTML=i[0].outerHTML},_removeDependencyDragHint:function(){this.content.find(D+O.styles.dependencyHint).remove()},_createTaskTooltip:function(t,n,i){var o,r=O.styles,s=this.options,a=this.content,l=a.offset(),c=a.width(),d=kendo.scrollLeft(a),f=e(n).parents("tr").first(),p=f.offset(),m=s.tooltip&&s.tooltip.template?kendo.template(s.tooltip.template):B,v=g?i-(l.left+d+kendo.support.scrollbar()):i-(l.left-d),_=p.top+h(f)-l.top+a.scrollTop(),b=this._taskTooltip=e('<div style="z-index: 100002;" class="'+r.tooltipWrapper+'" ><div class="'+r.taskContent+'"></div></div>');b.css({left:v,top:_}).appendTo(a).find(D+r.taskContent).append(m({styles:r,task:t,messages:s.messages.views})),h(b)<p.top-l.top&&b.css("top",p.top-l.top-h(b)+a.scrollTop()),o=u(b),o+v-d>c&&(v-=o,v<d&&(v=d+c-(o+17)),b.css("left",v))},_removeTaskTooltip:function(){this._taskTooltip&&this._taskTooltip.remove(),this._taskTooltip=null},_scrollTo:function(e){var t=e.offset().left,n=e.width(),i=t+n,o=e.closest("tr"),r=o.offset().top,s=o.height(),a=r+s,l=this.content,c=l.offset(),d=c.top,u=l.height(),h=d+u,f=c.left,p=l.width(),m=f+p,g=kendo.support.scrollbar();r<d?l.scrollTop(l.scrollTop()+(r-d)):a>h&&l.scrollTop(l.scrollTop()+(a+g-h)),t<f&&n>p&&i<m||i>m&&n<p?l.scrollLeft(l.scrollLeft()+(i+g-m)):(i>m&&n>p&&t>f||t<f&&n<p)&&l.scrollLeft(l.scrollLeft()+(t-f))},_scrollToDate:function(e){var t,n=this.start,i=this.end;e>=n&&e<i&&(t=this._offset(e),kendo.support.isRtl(this.element)&&(t=this._tableWidth-t),kendo.scrollLeft(this.content,t))},_timeSlots:function(){return this._slots&&this._slots.length?this._slots[this._slots.length-1]:[]},_headers:function(e){var t,n,i,o,r,s,l,d,u=[],h=O.styles;for(r=0,s=e.length;r<s;r++){for(t=e[r],n=[],l=0,d=t.length;l<d;l++)i=t[l],o=c(i.text),n.push(a("th",{colspan:i.span,className:h.header+(i.isNonWorking?" "+h.nonWorking:"")},[o]));u.push(a("tr",null,n))}return u},_hours:function(e,t){var n,i,o,r=[],s=this.options,a=s.workDayStart.getHours(),l=s.workDayEnd.getHours(),c=s.hourSpan;for(e=new Date(e),t=new Date(t),s.showWorkHours&&e.setHours(a);e<t;)n=new Date(e),o=n.getHours(),i=o>=a&&o<l,n.setHours(n.getHours()+c),o==n.getHours()&&n.setHours(n.getHours()+2*c),s.showWorkHours&&!i||r.push({start:e,end:n,isNonWorking:!i,span:1}),e=n;return r},_days:function(e,t){var n,i,o=[];for(e=new Date(e),t=new Date(t);e<t;)n=t<kendo.date.nextDay(e)?t:kendo.date.nextDay(e),i=this._isWorkDay(e),this.options.showWorkDays&&!i||o.push({start:e,end:n,isNonWorking:!i,span:1}),e=n;return o},_weeks:function(e,t){var n,i,o,r=[],s=this.calendarInfo().firstDay;for(e=new Date(e),t=new Date(t);e<t;)n=kendo.date.dayOfWeek(kendo.date.addDays(e,1),s,1),n>t&&(n=t),i=this._days(e,n),o=i.length,o>0&&r.push({start:i[0].start,end:i[o-1].end,span:o}),e=n;return r},_months:function(e,t){var n,i,o,r,s=[];for(e=new Date(e),t=new Date(t);e<t;)n=new Date(e),i=kendo.date.firstDayOfMonth(new Date(n.setMonth(n.getMonth()+1))),n=t<i?t:i,o=this._days(e,n),r=o.length,r>0&&s.push({start:o[0].start,end:o[r-1].end,span:r}),e=n;return s},_years:function(e,t){var n,i,o,r=[];for(e=new Date(e),t=new Date(t);e<t;)n=new Date(e),n=kendo.date.firstDayOfMonth(new Date(n.setMonth(12))),n>=t&&(n=t),o=n.getMonth()||12,i=o-e.getMonth(),r.push({start:e,end:n,span:i}),e=n;return r},_slotHeaders:function(e,t){var n,i,o,r=[];for(i=0,o=e.length;i<o;i++)n=e[i],r.push({text:t(n),isNonWorking:!!n.isNonWorking,span:n.span});return r},_isWorkDay:function(e){var t,n,i=e.getDay(),o=this._workDays;for(t=0,n=o.length;t<n;t++)if(o[t]===i)return!0;return!1},calendarInfo:function(){return kendo.getCulture().calendars.standard},_renderCurrentTime:function(){var t,n=this._getCurrentTime(),i=this._offset(n),o=e("<div class='k-current-time'></div>"),r=O.styles,s=e(D+r.tasksWrapper),a=e(D+r.tasksTable);this.content&&this._timeSlots().length&&(this.content.find(".k-current-time").remove(),t=this._timeSlots()[this._slotIndex("start",n)],n<t.start||n>t.end||(s.length&&a.length&&(i+=a.offset().left-s.offset().left),o.css({left:i+"px",top:"0px",width:"1px",height:this._contentHeight+"px"}).appendTo(this.content)))},_getCurrentTime:function(){return new Date},_currentTime:function(){var e=this.options.currentTimeMarker;e!==!1&&void 0!==e.updateInterval&&(this._renderCurrentTime(),this._currentTimeUpdateTimer=setInterval(p(this._renderCurrentTime,this),e.updateInterval))}});f(!0,O,{styles:N}),kendo.ui.GanttDayView=O.extend({name:"day",options:{timeHeaderTemplate:A,dayHeaderTemplate:E,resizeTooltipFormat:"h:mm tt ddd, MMM d"},range:function(e){var t=this.options.range;this.start=kendo.date.getDate(e.start),this.end=kendo.date.getDate(e.end),(kendo.date.getMilliseconds(e.end)>0||this.end.getTime()===this.start.getTime())&&(this.end=kendo.date.addDays(this.end,1)),t&&t.start&&(this.start=kendo.date.getDate(t.start),this.start.setHours(t.start.getHours())),t&&t.end&&(this.end=kendo.date.getDate(t.end),this.end.setHours(t.end.getHours()))},_createSlots:function(){var e,t,n,i,o=[],r=this._days(this.start,this.end),s=[];for(n=0,i=r.length;n<i;n++)e=r[n],t=this._hours(e.start,e.end),e.span=t.length,s.push.apply(s,t);return o.push(r),o.push(s),o},_layout:function(){var e=[],t=this.options;return e.push(this._slotHeaders(this._slots[0],kendo.template(t.dayHeaderTemplate))),e.push(this._slotHeaders(this._slots[1],kendo.template(t.timeHeaderTemplate))),e}}),kendo.ui.GanttWeekView=O.extend({name:"week",options:{dayHeaderTemplate:E,weekHeaderTemplate:I,resizeTooltipFormat:"h:mm tt ddd, MMM d"},range:function(e){var t,n=this.options.range,i=this.calendarInfo(),o=i.firstDay,r=e.end;o===r.getDay()&&r.setDate(r.getDate()+7),this.start=kendo.date.getDate(kendo.date.dayOfWeek(e.start,o,-1)),this.end=kendo.date.getDate(kendo.date.dayOfWeek(r,o,1)),n&&n.start&&(this.start=kendo.date.getDate(n.start)),n&&n.end&&(t=new Date(n.end),this.end=kendo.date.getDate(t)<n.end?kendo.date.getDate(new Date(t.setDate(t.getDate()+1))):kendo.date.getDate(t))},_createSlots:function(){var e=[];return e.push(this._weeks(this.start,this.end)),e.push(this._days(this.start,this.end)),e},_layout:function(){var e=[],t=this.options;return e.push(this._slotHeaders(this._slots[0],kendo.template(t.weekHeaderTemplate))),e.push(this._slotHeaders(this._slots[1],kendo.template(t.dayHeaderTemplate))),e}}),kendo.ui.GanttMonthView=O.extend({name:"month",options:{weekHeaderTemplate:I,monthHeaderTemplate:M,resizeTooltipFormat:"dddd, MMM d, yyyy"},range:function(e){var t,n=this.options.range;this.start=kendo.date.firstDayOfMonth(e.start),this.end=kendo.date.addDays(kendo.date.getDate(kendo.date.lastDayOfMonth(e.end)),1),n&&n.start&&(this.start=kendo.date.getDate(n.start)),n&&n.end&&(t=new Date(n.end),this.end=kendo.date.getDate(t)<n.end?kendo.date.getDate(new Date(t.setDate(t.getDate()+1))):kendo.date.getDate(t))},_createSlots:function(){var e=[];return e.push(this._months(this.start,this.end)),e.push(this._weeks(this.start,this.end)),e},_layout:function(){var e=[],t=this.options;return e.push(this._slotHeaders(this._slots[0],kendo.template(t.monthHeaderTemplate))),e.push(this._slotHeaders(this._slots[1],kendo.template(t.weekHeaderTemplate))),e}}),kendo.ui.GanttYearView=O.extend({name:"year",options:{yearHeaderTemplate:R,monthHeaderTemplate:M,resizeTooltipFormat:"dddd, MMM d, yyyy"},range:function(e){var t,n=this.options.range;this.start=kendo.date.firstDayOfMonth(new Date(e.start.setMonth(0))),this.end=kendo.date.firstDayOfMonth(new Date(e.end.setMonth(12))),n&&n.start&&(this.start=kendo.date.firstDayOfMonth(n.start)),n&&n.end&&(t=kendo.date.firstDayOfMonth(n.end),this.end=kendo.date.getDate(new Date(t.setMonth(t.getMonth()+1))))},_createSlots:function(){var t=[],n=this._months(this.start,this.end);return e(n).each(function(e,t){t.span=1}),t.push(this._years(this.start,this.end)),t.push(n),t},_layout:function(){var e=[],t=this.options;return e.push(this._slotHeaders(this._slots[0],kendo.template(t.yearHeaderTemplate))),e.push(this._slotHeaders(this._slots[1],kendo.template(t.monthHeaderTemplate))),e}}),o={wrapper:"k-timeline k-grid k-widget",gridHeader:"k-grid-header",gridHeaderWrap:"k-grid-header-wrap",gridContent:"k-grid-content",gridContentWrap:"k-grid-content",tasksWrapper:"k-gantt-tables",dependenciesWrapper:"k-gantt-dependencies",task:"k-task",line:"k-line",taskResizeHandle:"k-resize-handle",taskResizeHandleWest:"k-resize-w",taskDragHandle:"k-task-draghandle",taskComplete:"k-task-complete",taskDelete:"k-task-delete",taskWrapActive:"k-task-wrap-active",taskWrap:"k-task-wrap",taskDot:"k-task-dot",taskDotStart:"k-task-start",taskDotEnd:"k-task-end",hovered:"k-state-hover",selected:"k-state-selected",origin:"k-origin"},r=kendo.ui.GanttTimeline=s.extend({init:function(e,t){s.fn.init.call(this,e,t),this.options.views&&this.options.views.length||(this.options.views=["day","week","month"]),g=kendo.support.isRtl(e),this._wrapper(),this._domTrees(),this._views(),this._selectable(),this._draggable(),this._resizable(),this._percentResizeDraggable(),this._createDependencyDraggable(),this._attachEvents(),this._tooltip()},options:{name:"GanttTimeline",messages:{views:{day:"Day",week:"Week",month:"Month",year:"Year",start:"Start",end:"End"}},snap:!0,selectable:!0,editable:!0},destroy:function(){s.fn.destroy.call(this),clearTimeout(this._tooltipTimeout),this._currentTimeUpdateTimer&&clearInterval(this._currentTimeUpdateTimer),this._unbindView(this._selectedView),this._moveDraggable&&this._moveDraggable.destroy(),this._resizeDraggable&&this._resizeDraggable.destroy(),this._percentDraggable&&this._percentDraggable.destroy(),this._dependencyDraggable&&this._dependencyDraggable.destroy(),this.touch&&this.touch.destroy(),this._headerTree=null,this._taskTree=null,this._dependencyTree=null,this.wrapper.off(w),kendo.destroy(this.wrapper)},_wrapper:function(){var t=r.styles,n=this,i=this.options,o=function(){var o,r,s=typeof i.rowHeight===b?i.rowHeight:i.rowHeight+"px",a=e(kendo.format(L,s)),l=n.wrapper.find(D+t.tasksWrapper);return l.append(a),o=h(a.find("tr")),r=a.find("td").height(),a.remove(),{row:o,cell:r}};this.wrapper=this.element.addClass(t.wrapper).append("<div class='"+t.gridHeader+"'><div class='"+t.gridHeaderWrap+"'></div></div>").append("<div class='"+t.gridContentWrap+"'><div class='"+t.tasksWrapper+"'></div><div class='"+t.dependenciesWrapper+"'></div></div>"),i.rowHeight&&(this._calculatedSize=o())},_domTrees:function(){var e=r.styles,t=kendo.dom.Tree,n=this.wrapper;this._headerTree=new t(n.find(D+e.gridHeaderWrap)[0]),this._taskTree=new t(n.find(D+e.tasksWrapper)[0]),this._dependencyTree=new t(n.find(D+e.dependenciesWrapper)[0])},_views:function(){var e,t,n,i,o,r,s,a=this.options.views;for(this.views={},r=0,s=a.length;r<s;r++)e=a[r],t=d(e),t&&e.selectable===!1||(n=t?"string"!=typeof e.type?e.title:e.type:e,i=H[n],i&&(t&&(e.type=i.type),i.title=this.options.messages.views[n]),e=f({title:n},i,t?e:{}),n&&(this.views[n]=e,o&&!e.selected||(o=n)));o&&(this._selectedViewName=o)},view:function(e){return e&&(this._selectView(e),this.trigger("navigate",{view:e,action:"changeView"})),this._selectedView},_selectView:function(e){e&&this.views[e]&&(this._selectedView&&this._unbindView(this._selectedView),this._selectedView=this._initializeView(e),this._selectedViewName=e)},_viewByIndex:function(e){var t,n=this.views;for(t in n){if(!e)return t;e--}},_initializeView:function(e){var n,i,o,r=this.views[e];if(r){if(n=r.type,"string"==typeof n&&(n=kendo.getter(r.type)(window)),!n)throw Error("There is no such view");i={},f(i,this.options.range,r.range),o=r.date||this.options.date,r=new n(this.wrapper,t(f(!0,{headerTree:this._headerTree,taskTree:this._taskTree,dependencyTree:this._dependencyTree,calculatedSize:this._calculatedSize},r,this.options,{date:o,range:i})))}return r},_unbindView:function(e){e&&e.destroy()},_range:function(e){var t,n,i={field:"start",dir:"asc"},o={field:"end",dir:"desc"};return e&&e.length?(t=new _(e).sort(i).toArray()[0].start||new Date,n=new _(e).sort(o).toArray()[0].end||new Date,{start:new Date(t),end:new Date(n)}):{start:new Date,end:new Date}},_render:function(e){var t=this.view(),n=this._range(e),i=t.options.date;this._tasks=e,t.range(n),t.renderLayout(),t.render(e),i&&t._scrollToDate(i)},_renderDependencies:function(e){this.view()._renderDependencies(e)},_taskByUid:function(e){var t,n,i=this._tasks,o=i.length;for(n=0;n<o;n++)if(t=i[n],t.uid===e)return t},_draggable:function(){var e,t,n,o,s=this,a=this.options.snap,l=r.styles,c=this.options.editable,d=function(){s.view()._removeDragHint(),e&&e.css("opacity",1),e=null,t=null,s.dragInProgress=!1};c&&c.move!==!1&&c.update!==!1&&(this._moveDraggable=new kendo.ui.Draggable(this.wrapper,{distance:0,filter:D+l.task,holdToDrag:kendo.support.mobileOS,ignore:D+l.taskResizeHandle}),this._moveDraggable.bind("dragstart",function(i){var r=s.view();return e=i.currentTarget.parent(),t=s._taskByUid(i.currentTarget.attr("data-uid")),s.trigger("moveStart",{
task:t})?void i.preventDefault():(n=t.start,o=r._timeByPosition(i.x.location,a)-n,r._createDragHint(e),e.css("opacity",.5),clearTimeout(s._tooltipTimeout),void(s.dragInProgress=!0))}).bind("drag",kendo.throttle(function(e){var i,r,l;s.dragInProgress&&(i=s.view(),r=new Date(i._timeByPosition(e.x.location,a)-o),l=r,s.trigger("move",{task:t,start:r})||(n=r,g&&(l=new Date(n.getTime()+t.duration())),i._updateDragHint(l)))},15)).bind("dragend",function(){s.trigger("moveEnd",{task:t,start:n}),d()}).bind("dragcancel",function(){d()}).userEvents.bind("select",function(){i()}))},_resizable:function(){var e,t,n,o,s,a=this,l=this.options.snap,c=r.styles,d=this.options.editable,u=function(){a.view()._removeResizeHint(),e=null,t=null,a.dragInProgress=!1};d&&d.resize!==!1&&d.update!==!1&&(this._resizeDraggable=new kendo.ui.Draggable(this.wrapper,{distance:0,filter:D+c.taskResizeHandle,holdToDrag:!1}),this._resizeDraggable.bind("dragstart",function(i){return s=i.currentTarget.hasClass(c.taskResizeHandleWest),g&&(s=!s),e=i.currentTarget.closest(D+c.task),t=a._taskByUid(e.attr("data-uid")),a.trigger("resizeStart",{task:t})?void i.preventDefault():(n=t.start,o=t.end,a.view()._createResizeHint(t),clearTimeout(a._tooltipTimeout),void(a.dragInProgress=!0))}).bind("drag",kendo.throttle(function(e){var i,r;a.dragInProgress&&(i=a.view(),r=i._timeByPosition(e.x.location,l,!s),s?n=r<o?r:o:o=r>n?r:n,a.trigger("resize",{task:t,start:n,end:o})||i._updateResizeHint(n,o,s))},15)).bind("dragend",function(){a.trigger("resizeEnd",{task:t,resizeStart:s,start:n,end:o}),u()}).bind("dragcancel",function(){u()}).userEvents.bind("select",function(){i()}))},_percentResizeDraggable:function(){var e,t,n,o,s,a,l,c,d,h,f=this,p=r.styles,m=this.options.editable,v=function(){f.view()._removePercentCompleteTooltip(),t=null,e=null,f.dragInProgress=!1},_=function(e){t.find(D+p.taskComplete).width(e).end().siblings(D+p.taskDragHandle).css(g?"right":"left",e)};m&&m.dragPercentComplete!==!1&&m.update!==!1&&(this._percentDraggable=new kendo.ui.Draggable(this.wrapper,{distance:0,filter:D+p.taskDragHandle,holdToDrag:!1}),this._percentDraggable.bind("dragstart",function(i){return f.trigger("percentResizeStart")?void i.preventDefault():(t=i.currentTarget.siblings(D+p.task),e=f._taskByUid(t.attr("data-uid")),l=e.percentComplete,n=t.offset(),o=this.element.offset(),s=t.find(D+p.taskComplete).width(),a=u(t),clearTimeout(f._tooltipTimeout),void(f.dragInProgress=!0))}).bind("drag",kendo.throttle(function(e){if(f.dragInProgress){h=g?-e.x.initialDelta:e.x.initialDelta;var t=Math.max(0,Math.min(a,s+h));l=Math.round(t/a*100),_(t),c=n.top-o.top,d=n.left+t-o.left,g&&(d+=a-2*t),f.view()._updatePercentCompleteTooltip(c,d,l)}},15)).bind("dragend",function(){f.trigger("percentResizeEnd",{task:e,percentComplete:l/100}),v()}).bind("dragcancel",function(){_(s),v()}).userEvents.bind("select",function(){i()}))},_createDependencyDraggable:function(){var t,n,o,s=this,a=e(),l=e(),c=m.msie&&m.version<9,d=r.styles,f=this.options.editable,p=function(){t.css("display","").removeClass(d.hovered),t.parent().removeClass(d.origin),t=null,g(!1),l=e(),a=e(),s.view()._removeDependencyDragHint(),s.dragInProgress=!1},g=function(e){l.hasClass(d.origin)||(l.find(D+d.taskDot).css("display",e?"block":""),a.toggleClass(d.hovered,e))};f&&f.dependencyCreate!==!1&&(c&&document.namespaces&&document.namespaces.add("kvml","urn:schemas-microsoft-com:vml","#default#VML"),this._dependencyDraggable=new kendo.ui.Draggable(this.wrapper,{distance:0,filter:D+d.taskDot,holdToDrag:!1}),this._dependencyDraggable.bind("dragstart",function(e){var i,r;return s.trigger("dependencyDragStart")?void e.preventDefault():(t=e.currentTarget.css("display","block").addClass(d.hovered),t.parent().addClass(d.origin),i=t.offset(),r=s.wrapper.find(D+d.tasksWrapper).offset(),n=Math.round(i.left-r.left+h(t)/2),o=Math.round(i.top-r.top+u(t)/2),clearTimeout(s._tooltipTimeout),void(s.dragInProgress=!0))}).bind("drag",kendo.throttle(function(t){var i,r,u,h;s.dragInProgress&&(s.view()._removeDependencyDragHint(),i=e(kendo.elementUnderCursor(t)),r=s.wrapper.find(D+d.tasksWrapper).offset(),u=t.x.location-r.left,h=t.y.location-r.top,s.view()._updateDependencyDragHint({x:n,y:o},{x:u,y:h},c),g(!1),a=i.hasClass(d.taskDot)?i:e(),l=i.closest(D+d.taskWrap),g(!0))},15)).bind("dragend",function(){var e,n,i,o,r;a.length&&(e=t.hasClass(d.taskDotStart),n=a.hasClass(d.taskDotStart),i=e?n?3:2:n?1:0,o=s._taskByUid(t.siblings(D+d.task).attr("data-uid")),r=s._taskByUid(a.siblings(D+d.task).attr("data-uid")),o!==r&&s.trigger("dependencyDragEnd",{type:i,predecessor:o,successor:r})),p()}).bind("dragcancel",function(){p()}).userEvents.bind("select",function(){i()}))},_selectable:function(){var t=this,n=r.styles;this.options.selectable&&this.wrapper.on(y+w,D+n.task,function(n){n.stopPropagation(),n.ctrlKey?t.trigger("clear"):t.trigger("select",{uid:e(this).attr("data-uid")})}).on(y+w,D+n.taskWrap,function(t){t.stopPropagation(),e(this).css("z-index","0");var i=e(document.elementFromPoint(t.clientX,t.clientY));i.hasClass(n.line)&&i.click(),e(this).css("z-index","")}).on(y+w,D+n.tasksWrapper,function(){t.selectDependency().length>0?t.clearSelection():t.trigger("clear")}).on(y+w,D+n.line,function(e){e.stopPropagation(),t.selectDependency(this)})},select:function(e){var t=this.wrapper.find(e),n=r.styles;return t.length?(this.clearSelection(),t.addClass(n.selected),void(kendo.support.mobileOS&&t.parent().addClass(n.taskWrapActive))):this.wrapper.find(D+n.task+D+n.selected)},selectDependency:function(t){var n,i=this.wrapper.find(t),o=r.styles;return i.length?(this.clearSelection(),this.trigger("clear"),n=e(i).attr("data-uid"),void this.wrapper.find(D+o.line+"[data-uid='"+n+"']").addClass(o.selected)):this.wrapper.find(D+o.line+D+o.selected)},clearSelection:function(){var e=r.styles;this.wrapper.find(D+e.selected).removeClass(e.selected),kendo.support.mobileOS&&this.wrapper.find(D+e.taskWrapActive).removeClass(e.taskWrapActive)},_attachEvents:function(){var t=this,n=r.styles,i=this.options.editable;i&&(this._tabindex(),this.wrapper.on(y+w,D+n.taskDelete,function(i){t.trigger("removeTask",{uid:e(this).closest(D+n.task).attr("data-uid")}),i.stopPropagation(),i.preventDefault()}).on(T+w,function(e){var n,i=t.options.editable;e.keyCode===v.DELETE&&i&&i.dependencyDestroy!==!1&&(n=t.selectDependency(),n.length&&(t.trigger("removeDependency",{uid:n.attr("data-uid")}),t.clearSelection()))}),kendo.support.mobileOS?this.touch=this.wrapper.kendoTouch({filter:D+n.task,doubletap:function(n){t.options.editable.update!==!1&&t.trigger("editTask",{uid:e(n.touch.currentTarget).attr("data-uid")})}}).data("kendoTouch"):this.wrapper.on(k+w,D+n.task,function(n){t.options.editable.update!==!1&&(t.trigger("editTask",{uid:e(this).attr("data-uid")}),n.stopPropagation(),n.preventDefault())}))},_tooltip:function(){var t,n=this,i=this.options.tooltip,o=r.styles,s=function(e){t=e.clientX};i&&i.visible===!1||(kendo.support.mobileOS?(this.wrapper.on(y+w,D+o.taskDelete,function(e){e.stopPropagation(),n.view()._removeTaskTooltip()}).on(S+w,D+o.task,function(t){var i=e(t.relatedTarget).parents(D+o.taskWrap,D+o.task);0===i.length&&n.view()._removeTaskTooltip()}),this.touch&&this.touch.bind("tap",function(t){var i=t.touch.target,o=n._taskByUid(e(i).attr("data-uid")),r=t.touch.x.client;n.view()._taskTooltip&&n.view()._removeTaskTooltip(),n.view()._createTaskTooltip(o,i,r)}).bind("doubletap",function(){n.view()._removeTaskTooltip()})):this.wrapper.on(C+w,D+o.task,function(){var i=this,o=n._taskByUid(e(this).attr("data-uid"));n.dragInProgress||(n._tooltipTimeout=setTimeout(function(){n.view()._createTaskTooltip(o,i,t)},800),e(this).on(x,s))}).on(S+w,D+o.task,function(){clearTimeout(n._tooltipTimeout),n.view()._removeTaskTooltip(),e(this).off(x,s)}))}}),f(!0,r,{styles:o})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.gantt.min",["kendo.data.min","kendo.popup.min","kendo.window.min","kendo.resizable.min","kendo.gantt.list.min","kendo.gantt.timeline.min","kendo.grid.min","kendo.pdf.min"],e)}(function(){return function(e,t){function n(e){return"["+m.attr("uid")+(e?"='"+e+"']":"]")}function i(e){return delete e.name,delete e.prefix,delete e.remove,delete e.edit,delete e.add,delete e.navigate,e}function o(e){var t,n,i,o,r,s;if(e.filter("[name=end], [name=start]").length){for(t=e.attr("name"),n=m.widgetInstance(e,m.ui),i={},o=e;o!==window&&!r;)o=o.parent(),r=o.data("kendoEditable");return!(s=r?r.options.model:null)||(i.start=s.start,i.end=s.end,i[t]=n?n.value():m.parseDate(e.value()),i.start<=i.end)}return!0}function r(t,n){var i=t.parents("["+m.attr("role")+'="gantt"]'),o=[],r=s(i);t.attr(H,0),n&&r.each(function(t,n){o[t]=e(n).scrollTop()});try{t[0].setActive()}catch(a){t[0].focus()}n&&r.each(function(t,n){e(n).scrollTop(o[t])})}function s(t){return e(t).parentsUntil("body").filter(function(e,t){var n=m.getComputedStyles(t,["overflow"]);return"visible"!=n.overflow}).add(window)}var a,l,c,d,u,h,f,p,m=window.kendo,g=e.extend({F10:121},m.keys),v="matchMedia"in window,_=m.support.browser,b=m.support.mobileOS,w=m.Observable,y=m.ui.Widget,k=m.data.DataSource,x=m.data.ObservableObject,C=m.data.ObservableArray,S=m.data.Query,T=e.isArray,D=e.inArray,A=m.isFunction,E=e.proxy,I=e.extend,M=e.isPlainObject,R=e.map,F=m._outerWidth,z=m._outerHeight,P=3,B=".kendoGantt",L="p0",H="tabIndex",N="click",O="width",V="string",U={down:{origin:"bottom left",position:"top left"},up:{origin:"top left",position:"bottom left"}},W="aria-activedescendant",j="aria-label",q="gantt_active_cell",G="action-option-focused",$=".",K="Are you sure you want to delete this task?",Y="Are you sure you want to delete this dependency?",Q=m.template('<button class="#=styles.buttonToggle#" type="button" '+j+'="Toggle"><span class="#=styles.iconToggle#"></span></button>'),X='<button class="#=styles.button# #=className#" type="button" #if (action) {#data-action="#=action#"#}#><span class="#=iconClass#"></span><span>#=text#</span></button>',Z='<a class="#=className#" #=attr# href="\\#">#=text#</a>',J=m.template('<li class="#=styles.currentView# #=styles.viewButtonDefault#"><a href="\\#" class="#=styles.link#">&nbps;</a></li>'),ee=m.template('<ul class="#=styles.viewsWrapper#">#for(var view in views){#<li class="#=styles.viewButtonDefault# #=styles.viewButton#-#= view.toLowerCase() #" data-#=ns#name="#=view#"><a href="\\#" class="#=styles.link#">#=views[view].title#</a></li>#}#</ul>'),te=m.template('<div class="#=styles.popupWrapper#"><ul class="#=styles.popupList#" role="listbox">#for(var i = 0, l = actions.length; i < l; i++){#<li class="#=styles.item#" data-action="#=actions[i].data#" role="option">#=actions[i].text#</span>#}#</ul></div>'),ne=function(t,n){var i={name:n.field,title:n.title},o=n.model.fields[n.field].validation;o&&M(o)&&o.message&&(i[m.attr("dateCompare-msg")]=o.message),e('<input type="text" required '+m.attr("type")+'="date" '+m.attr("role")+'="datetimepicker" '+m.attr("bind")+'="value:'+n.field+'" '+m.attr("validate")+"='true' />").attr(i).appendTo(t),e("<span "+m.attr("for")+'="'+n.field+'" class="k-invalid-msg"/>').hide().appendTo(t)},ie=function(t,n){e('<a href="#" class="'+n.styles.button+'">'+n.messages.assignButton+"</a>").click(n.click).appendTo(t)},oe={wrapper:"k-widget k-gantt",rowHeight:"k-gantt-rowheight",listWrapper:"k-gantt-layout k-gantt-treelist",list:"k-gantt-treelist",timelineWrapper:"k-gantt-layout k-gantt-timeline",timeline:"k-gantt-timeline",splitBarWrapper:"k-splitbar k-state-default k-splitbar-horizontal k-splitbar-draggable-horizontal k-gantt-layout",splitBar:"k-splitbar",splitBarHover:"k-splitbar-horizontal-hover",popupWrapper:"k-list-container",popupList:"k-list k-reset",resizeHandle:"k-resize-handle",icon:"k-icon",item:"k-item",line:"k-line",buttonDelete:"k-gantt-delete",buttonCancel:"k-gantt-cancel",buttonSave:"k-gantt-update",buttonToggle:"k-gantt-toggle",primary:"k-primary",hovered:"k-state-hover",selected:"k-state-selected",focused:"k-state-focused",gridHeader:"k-grid-header",gridHeaderWrap:"k-grid-header-wrap",gridContent:"k-grid-content",tasks:"k-gantt-tasks",popup:{form:"k-popup-edit-form",editForm:"k-gantt-edit-form",formContainer:"k-edit-form-container",resourcesFormContainer:"k-resources-form-container",message:"k-popup-message",buttonsContainer:"k-edit-buttons k-state-default",button:"k-button",editField:"k-edit-field",editLabel:"k-edit-label",resourcesField:"k-gantt-resources"},toolbar:{headerWrapper:"k-floatwrap k-header k-gantt-toolbar",footerWrapper:"k-floatwrap k-header k-gantt-toolbar",toolbar:"k-gantt-toolbar",expanded:"k-state-expanded",views:"k-gantt-views",viewsWrapper:"k-reset k-header k-gantt-views",actions:"k-gantt-actions",button:"k-button k-button-icontext",buttonToggle:"k-button k-button-icon k-gantt-toggle",iconPlus:"k-icon k-i-plus",iconPdf:"k-icon k-i-file-pdf",iconToggle:"k-icon k-i-layout-1-by-4",viewButtonDefault:"k-state-default",viewButton:"k-view",currentView:"k-current-view",link:"k-link",pdfButton:"k-gantt-pdf",appendButton:"k-gantt-create"}},re=w.extend({init:function(e,t){w.fn.init.call(this),this.element=e,this.options=I(!0,{},this.options,t),this._popup()},options:{direction:"down",navigatable:!1},_current:function(e){var t=p.styles,n=this.list.find($+t.focused),i=n[e]();i.length&&(n.removeClass(t.focused).removeAttr("id"),i.addClass(t.focused).attr("id",G),this.list.find("ul").removeAttr(W).attr(W,G))},_popup:function(){var t=this,n=p.styles,i="li"+$+n.item,o=$+n.toolbar.appendButton,r=this.options.messages.actions,s=this.options.navigatable;this.list=e(te({styles:n,actions:[{data:"add",text:r.addChild},{data:"insert-before",text:r.insertBefore},{data:"insert-after",text:r.insertAfter}]})),this.element.append(this.list),this.popup=new m.ui.Popup(this.list,I({anchor:this.element.find(o),open:function(){t._adjustListWidth()},animation:this.options.animation},U[this.options.direction])),this.element.on(N+B,o,function(i){var o=e(this),r=o.attr(m.attr("action"));i.preventDefault(),r?t.trigger("command",{type:r}):(t.popup.open(),s&&t.list.find("li:first").addClass(n.focused).attr("id",G).end().find("ul").attr({TABINDEX:0,"aria-activedescendant":G}).focus())}),this.list.find(i).hover(function(){e(this).addClass(n.hovered)},function(){e(this).removeClass(n.hovered)}).end().on(N+B,i,function(){t.trigger("command",{type:e(this).attr(m.attr("action"))}),t.popup.close()}),s&&(this.popup.bind("close",function(){t.list.find(i).removeClass(n.focused).end().find("ul").attr(H,0),t.element.parents("["+m.attr("role")+'="gantt"]').find($+n.gridContent+" > table:first").focus()}),this.list.find("ul").on("keydown"+B,function(e){var i=e.keyCode;switch(i){case g.UP:e.preventDefault(),t._current("prev");break;case g.DOWN:e.preventDefault(),t._current("next");break;case g.ENTER:t.list.find($+n.focused).click();break;case g.ESC:e.preventDefault(),t.popup.close()}}))},_adjustListWidth:function(){var e,t,n=this.list,i=p.styles,o=n[0].style.width,r=this.element.find($+i.toolbar.appendButton),s=F(n);!n.data(O)&&o||(e=window.getComputedStyle?window.getComputedStyle(r[0],null):0,t=e?parseFloat(e.width):F(r),e&&(_.mozilla||_.msie)&&(t+=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight)+parseFloat(e.borderLeftWidth)+parseFloat(e.borderRightWidth)),o="border-box"!==n.css("box-sizing")?t-(F(n)-n.width()):t,s>o&&(o=s),n.css({fontFamily:r.css("font-family"),width:o}).data(O,o))},destroy:function(){clearTimeout(this._focusTimeout),this.popup.destroy(),this.element.off(B),this.list.off(B),this.unbind()}}),se=function(e,t){return function(n){var i,o;if(n=T(n)?{data:n}:n,i=n||{},o=i.data,i.data=o,!(i instanceof e)&&i instanceof k)throw Error("Incorrect DataSource type. Only "+t+" instances are supported");return i instanceof e?i:new e(i)}},ae=m.data.Model.define({id:"id",fields:{id:{type:"number"},predecessorId:{type:"number"},successorId:{type:"number"},type:{type:"number"}}}),le=k.extend({init:function(e){k.fn.init.call(this,I(!0,{},{schema:{modelBase:ae,model:ae}},e))},successors:function(e){return this._dependencies("predecessorId",e)},predecessors:function(e){return this._dependencies("successorId",e)},dependencies:function(e){var t=this.predecessors(e),n=this.successors(e);return t.push.apply(t,n),t},_dependencies:function(e,t){var n=this.view(),i={field:e,operator:"eq",value:t};return n=new S(n).filter(i).toArray()}});le.create=se(le,"GanttDependencyDataSource"),l=m.data.Model.define({duration:function(){var e=this.end,t=this.start;return e-t},isMilestone:function(){return 0===this.duration()},_offset:function(e){var t,n,i=["start","end"];for(n=0;n<i.length;n++)t=new Date(this.get(i[n]).getTime()+e),this.set(i[n],t)},id:"id",fields:{id:{type:"number"},parentId:{type:"number",defaultValue:null,validation:{required:!0}},orderId:{type:"number",validation:{required:!0}},title:{type:"string",defaultValue:"New task"},start:{type:"date",validation:{required:!0}},end:{type:"date",validation:{required:!0,dateCompare:o,message:"End date should be after or equal to the start date"}},percentComplete:{type:"number",validation:{required:!0,min:0,max:1,step:.01}},summary:{type:"boolean"},expanded:{type:"boolean",defaultValue:!0}}}),c=k.extend({init:function(e){k.fn.init.call(this,I(!0,{},{schema:{modelBase:l,model:l}},e))},remove:function(e){var t=e.get("parentId"),n=this.taskAllChildren(e);return this._removeItems(n),e=k.fn.remove.call(this,e),this._childRemoved(t,e.get("orderId")),e},add:function(e){if(e)return e=this._toGanttTask(e),this.insert(this.taskSiblings(e).length,e)},insert:function(e,t){if(t)return t=this._toGanttTask(t),t.set("orderId",e),t=k.fn.insert.call(this,e,t),this._reorderSiblings(t,this.taskSiblings(t).length-1),this._resolveSummaryFields(this.taskParent(t)),t},taskChildren:function(e){var n,i=this.view(),o={field:"parentId",operator:"eq",value:null},r=this._sort&&this._sort.length?this._sort:{field:"orderId",dir:"asc"};if(e){if(n=e.get("id"),n===t||null===n||""===n)return[];o.value=n}return i=new S(i).filter(o).sort(r).toArray()},taskAllChildren:function(e){var t=[],n=this,i=function(e){var o=n.taskChildren(e);t.push.apply(t,o),R(o,i)};return e?i(e):t=this.view(),t},taskSiblings:function(e){if(!e)return null;var t=this.taskParent(e);return this.taskChildren(t)},taskParent:function(e){return e&&null!==e.get("parentId")?this.get(e.parentId):null},taskLevel:function(e){for(var t=0,n=this.taskParent(e);null!==n;)t+=1,n=this.taskParent(n);return t},taskTree:function(e){var t,n,i,o,r=[],s=this.taskChildren(e);for(n=0,i=s.length;n<i;n++)t=s[n],r.push(t),t.get("expanded")&&(o=this.taskTree(t),r.push.apply(r,o));return r},update:function(e,n){var i,o,r=this,s=function(e,t){var n,i,o=r.taskAllChildren(e);for(n=0,i=o.length;n<i;n++)o[n]._offset(t)},a=function(e){var t=e.field,n=e.sender;switch(t){case"start":r._resolveSummaryStart(r.taskParent(n)),s(n,n.get(t).getTime()-i.getTime());break;case"end":r._resolveSummaryEnd(r.taskParent(n));break;case"percentComplete":r._resolveSummaryPercentComplete(r.taskParent(n));break;case"orderId":r._reorderSiblings(n,i)}};n.parentId!==t&&(i=e.get("parentId"),i!==n.parentId&&(e.set("parentId",n.parentId),r._childRemoved(i,e.get("orderId")),e.set("orderId",r.taskSiblings(e).length-1),r._resolveSummaryFields(r.taskParent(e))),delete n.parentId),e.bind("change",a);for(o in n)i=e.get(o),e.set(o,n[o]);e.unbind("change",a)},_resolveSummaryFields:function(e){e&&(this._updateSummary(e),this.taskChildren(e).length&&(this._resolveSummaryStart(e),this._resolveSummaryEnd(e),this._resolveSummaryPercentComplete(e)))},_resolveSummaryStart:function(e){var t=this,n=function(e){var n,i,o,r=t.taskChildren(e),s=r[0].start.getTime();for(i=1,o=r.length;i<o;i++)n=r[i].start.getTime(),n<s&&(s=n);return new Date(s)};this._updateSummaryRecursive(e,"start",n)},_resolveSummaryEnd:function(e){var t=this,n=function(e){var n,i,o,r=t.taskChildren(e),s=r[0].end.getTime();for(i=1,o=r.length;i<o;i++)n=r[i].end.getTime(),n>s&&(s=n);return new Date(s)};this._updateSummaryRecursive(e,"end",n)},_resolveSummaryPercentComplete:function(e){var t=this,n=function(e){var n=t.taskChildren(e),i=new S(n).aggregate([{field:"percentComplete",aggregate:"average"}]);return i.percentComplete.average};this._updateSummaryRecursive(e,"percentComplete",n)},_updateSummaryRecursive:function(e,t,n){var i,o;e&&(i=n(e),e.set(t,i),o=this.taskParent(e),o&&this._updateSummaryRecursive(o,t,n))},_childRemoved:function(e,t){var n,i,o=null===e?null:this.get(e),r=this.taskChildren(o);for(n=t,i=r.length;n<i;n++)r[n].set("orderId",n);this._resolveSummaryFields(o)},_reorderSiblings:function(e,t){var n,i=e.get("orderId"),o=i>t,r=o?t:i,s=o?i:t,a=o?r:r+1,l=this.taskSiblings(e);for(s=Math.min(s,l.length-1),n=r;n<=s;n++)l[n]!==e&&(l[n].set("orderId",a),a+=1)},_updateSummary:function(e){if(null!==e){var t=this.taskChildren(e).length;e.set("summary",t>0)}},_toGanttTask:function(e){if(!(e instanceof l)){var t=e;e=this._createNewModel(),e.accept(t)}return e}}),c.create=se(c,"GanttDataSource"),I(!0,m.data,{GanttDataSource:c,GanttTask:l,GanttDependencyDataSource:le,GanttDependency:ae}),d={desktop:{dateRange:ne,resources:ie}},u=m.Observable.extend({init:function(e,t){m.Observable.fn.init.call(this),this.element=e,this.options=I(!0,{},this.options,t),this.createButton=this.options.createButton},fields:function(t,n){var i,o=this,r=this.options,s=r.messages.editor,a=r.resources,l=function(e){e.preventDefault(),a.editor(o.container.find($+p.styles.popup.resourcesField),n)};return r.editable.template?i=e.map(n.fields,function(e,t){return{field:t}}):(i=[{field:"title",title:s.title},{field:"start",title:s.start,editor:t.dateRange},{field:"end",title:s.end,editor:t.dateRange},{field:"percentComplete",title:s.percentComplete,format:L}],n.get(a.field)&&i.push({field:a.field,title:s.resources,messages:s,editor:t.resources,click:l,styles:p.styles.popup})),i},_buildEditTemplate:function(e,t,n){var i,o,r,s,a=this.options.resources,l=this.options.editable.template,c=I({},m.Template,this.options.templateSettings),d=c.paramName,u=p.styles.popup,h="";if(l)typeof l===V&&(l=window.unescape(l)),h+=m.template(l,c)(e);else for(i=0,o=t.length;i<o;i++)r=t[i],h+='<div class="'+u.editLabel+'"><label for="'+r.field+'">'+(r.title||r.field||"")+"</label></div>",r.field===a.field&&(h+='<div class="'+u.resourcesField+'" style="display:none"></div>'),!e.editable||e.editable(r.field)?(n.push(r),h+="<div "+m.attr("container-for")+'="'+r.field+'" class="'+u.editField+'"></div>'):(s="#:",r.field?(r=m.expr(r.field,d),s+=r+"==null?'':"+r):s+="''",s+="#",s=m.template(s,c),h+='<div class="'+u.editField+'">'+s(e)+"</div>");return h}}),h=u.extend({destroy:function(){this.close(),this.unbind()},editTask:function(e){this.editable=this._createPopupEditor(e)},close:function(){var e=this,t=function(){e.editable&&(e.editable.destroy(),e.editable=null,e.container=null),e.popup&&(e.popup.destroy(),e.popup=null)};this.editable&&this.container.is(":visible")?(e.trigger("close",{window:e.container}),this.container.data("kendoWindow").bind("deactivate",t).close()):t()},showDialog:function(t){var n,i,o,r,s=t.buttons,a=p.styles.popup,l=m.format('<div class="{0}"><div class="{1}"><p class="{2}">{3}</p><div class="{4}">',a.form,a.formContainer,a.message,t.text,a.buttonsContainer);for(n=0,i=s.length;n<i;n++)l+=this.createButton(s[n]);l+="</div></div></div>",o=this.element,this.popup&&this.popup.destroy(),r=this.popup=e(l).appendTo(o).eq(0).on("click",$+a.button,function(t){t.preventDefault(),r.close();var n=e(t.currentTarget).index();s[n].click()}).kendoWindow({modal:!0,autoFocus:!1,resizable:!1,draggable:!1,title:t.title,visible:!1,deactivate:function(){this.destroy(),o.focus()}}).getKendoWindow(),r.center().open(),r.element.find(".k-primary").focus()},_createPopupEditor:function(t){var n,i,o=this,r={},s=this.options.messages,a=p.styles,l=a.popup,c=m.format('<div {0}="{1}" class="{2} {3}"><div class="{4}">',m.attr("uid"),t.uid,l.form,l.editForm,l.formContainer),u=this.fields(d.desktop,t),h=[];return c+=this._buildEditTemplate(t,u,h),c+='<div class="'+l.buttonsContainer+'">',c+=this.createButton({name:"update",text:s.save,className:p.styles.primary}),c+=this.createButton({name:"cancel",text:s.cancel}),o.options.editable.destroy!==!1&&(c+=this.createButton({name:"delete",text:s.destroy})),c+="</div></div></div>",n=this.container=e(c).appendTo(this.element).eq(0).kendoWindow(I({modal:!0,resizable:!1,draggable:!0,title:s.editor.editorTitle,visible:!1,close:function(e){e.userTriggered&&o.trigger("cancel",{container:n,model:t})&&e.preventDefault()}},r)),i=n.kendoEditable({fields:h,model:t,clearContainer:!1,validateOnBlur:!0,target:o.options.target}).data("kendoEditable"),m.cycleForm(n),this.trigger("edit",{container:n,model:t})?o.trigger("cancel",{container:n,model:t}):(n.data("kendoWindow").center().open(),n.on(N+B,$+a.buttonCancel,function(e){e.preventDefault(),e.stopPropagation(),o.trigger("cancel",{container:n,model:t})}),n.on(N+B,$+a.buttonSave,function(e){var i,r,s,a,l;for(e.preventDefault(),e.stopPropagation(),i=o.fields(d.desktop,t),r={},a=0,l=i.length;a<l;a++)s=i[a].field,r[s]=t.get(s);o.trigger("save",{container:n,model:t,updateInfo:r})}),n.on(N+B,$+a.buttonDelete,function(e){e.preventDefault(),e.stopPropagation(),o.trigger("remove",{container:n,model:t})})),i}}),f=y.extend({init:function(e,t){y.fn.init.call(this,e,t),this.wrapper=this.element,this.model=this.options.model,this.resourcesField=this.options.resourcesField,this.createButton=this.options.createButton,this._initContainer(),this._attachHandlers()},events:["save"],open:function(){this.window.center().open()},close:function(){this.window.bind("deactivate",E(this.destroy,this)).close()},destroy:function(){this._dettachHandlers(),this.grid.destroy(),this.grid=null,this.window.destroy(),this.window=null,y.fn.destroy.call(this),m.destroy(this.wrapper),this.element=this.wrapper=null},_attachHandlers:function(){var t=p.styles,n=this.grid,i=this._cancelProxy=E(this._cancel,this);this.container.on(N+B,$+t.buttonCancel,this._cancelProxy),this._saveProxy=E(this._save,this),this.container.on(N+B,$+t.buttonSave,this._saveProxy),this.window.bind("close",function(e){e.userTriggered&&i(e)}),n.wrapper.on(N+B,"input[type='checkbox']",function(){var t=e(this),i=e(t).closest("tr"),o=n.dataSource.getByUid(i.attr(m.attr("uid"))),r=e(t).is(":checked")?1:"";o.set("value",r)})},_dettachHandlers:function(){this._cancelProxy=null,this._saveProxy=null,this.container.off(B),this.grid.wrapper.off()},_cancel:function(e){e.preventDefault(),this.close()},_save:function(e){e.preventDefault(),this._updateModel(),this.wrapper.is($+p.styles.popup.resourcesField)||this.trigger("save",{container:this.wrapper,model:this.model}),this.close()},_initContainer:function(){var t=this,n=p.styles.popup,i=m.format('<div class="{0} {1}"><div class="{2} {3}"/></div>"',n.form,n.editForm,n.formContainer,n.resourcesFormContainer);i=e(i),this.container=i.find($+n.resourcesFormContainer),this.window=i.kendoWindow({modal:!0,resizable:!1,draggable:!0,visible:!1,title:this.options.messages.resourcesEditorTitle,open:function(){t.grid.resize(!0)}}).data("kendoWindow"),this._resourceGrid(),this._createButtons()},_resourceGrid:function(){var t=this,n=this.options.messages,i=e('<div id="resources-grid"/>').appendTo(this.container);this.grid=new m.ui.Grid(i,{columns:[{field:"name",title:n.resourcesHeader,template:"<label><input type='checkbox' value='#=name#'# if (value > 0 && value !== null) {#checked='checked'# } #/>#=name#</labe>"},{field:"value",title:n.unitsHeader,template:function(e){var t=e.format,n=null!==e.value?e.value:"";return t?m.toString(n,t):n}}],height:280,sortable:!0,editable:!0,filterable:!0,dataSource:{data:t.options.data,schema:{model:{id:"id",fields:{id:{from:"id"},name:{from:"name",type:"string",editable:!1},value:{from:"value",type:"number",defaultValue:""},format:{from:"format",type:"string"}}}}},save:function(e){var t=!!e.values.value;e.container.parent().find("input[type='checkbox']").prop("checked",t)}})},_createButtons:function(){var e,t,n=this.options.buttons,i='<div class="'+p.styles.popup.buttonsContainer+'">';for(e=0,t=n.length;e<t;e++)i+=this.createButton(n[e]);i+="</div>",this.container.append(i)},_updateModel:function(){var e,t,n,i=[],o=this.grid.dataSource.data();for(t=0,n=o.length;t<n;t++)e=o[t].get("value"),null!==e&&e>0&&i.push(o[t]);this.model[this.resourcesField]=i}}),p=y.extend({init:function(e,t,n){T(t)&&(t={dataSource:t}),a={append:{text:"Add Task",action:"add",className:p.styles.toolbar.appendButton,iconClass:p.styles.toolbar.iconPlus},pdf:{text:"Export to PDF",className:p.styles.toolbar.pdfButton,iconClass:p.styles.toolbar.iconPdf}},y.fn.init.call(this,e,t),n&&(this._events=n),this._wrapper(),this._resources(),this.options.views&&this.options.views.length||(this.options.views=["day","week","month"]),this._timeline(),this._toolbar(),this._footer(),this._adjustDimensions(),this._preventRefresh=!0,this.view(this.timeline._selectedViewName),this._preventRefresh=!1,this._dataSource(),this._assignments(),this._dropDowns(),this._list(),this._dependencies(),this._resizable(),this._scrollable(),this._dataBind(),this._attachEvents(),this._createEditor(),m.notify(this)},events:["dataBinding","dataBound","add","edit","remove","cancel","save","change","navigate","moveStart","move","moveEnd","resizeStart","resize","resizeEnd","columnResize"],options:{name:"Gantt",autoBind:!0,navigatable:!1,selectable:!0,editable:!0,resizable:!1,columnResizeHandleWidth:P,columns:[],views:[],dataSource:{},dependencies:{},resources:{},assignments:{},taskTemplate:null,messages:{save:"Save",cancel:"Cancel",destroy:"Delete",deleteTaskConfirmation:K,deleteDependencyConfirmation:Y,deleteTaskWindowTitle:"Delete task",deleteDependencyWindowTitle:"Delete dependency",views:{day:"Day",week:"Week",month:"Month",year:"Year",start:"Start",end:"End"},actions:{append:"Add Task",addChild:"Add Child",insertBefore:"Add Above",insertAfter:"Add Below",pdf:"Export to PDF"},editor:{editorTitle:"Task",resourcesEditorTitle:"Resources",title:"Title",start:"Start",end:"End",percentComplete:"Complete",resources:"Resources",assignButton:"Assign",resourcesHeader:"Resources",unitsHeader:"Units"}},showWorkHours:!0,showWorkDays:!0,toolbar:null,workDayStart:new Date(1980,1,1,8,0,0),workDayEnd:new Date(1980,1,1,17,0,0),workWeekStart:1,workWeekEnd:5,hourSpan:1,snap:!0,height:600,listWidth:"30%",rowHeight:null},select:function(e){var n=this.list;return e?(n.select(e),this.list.element.find("table[role=treegrid]").focus(),t):n.select()},clearSelection:function(){this.list.clearSelection()},destroy:function(){y.fn.destroy.call(this),this.dataSource&&(this.dataSource.unbind("change",this._refreshHandler),this.dataSource.unbind("progress",this._progressHandler),this.dataSource.unbind("error",this._errorHandler)),this.dependencies&&(this.dependencies.unbind("change",this._dependencyRefreshHandler),this.dependencies.unbind("error",this._dependencyErrorHandler)),this.timeline&&(this.timeline.unbind(),this.timeline.destroy()),this.list&&(this.list.unbind(),this.list.destroy()),this.footerDropDown&&this.footerDropDown.destroy(),this.headerDropDown&&this.headerDropDown.destroy(),this._editor&&this._editor.destroy(),this._resizeDraggable&&this._resizeDraggable.destroy(),this.toolbar.off(B),v&&(this._mediaQuery.removeListener(this._mediaQueryHandler),this._mediaQuery=null),e(window).off("resize"+B,this._resizeHandler),e(this.wrapper).off(B),this.toolbar=null,this.footer=null},setOptions:function(t){var n,i=m.deepExtend({},this.options,t),o=this._events;t.views||(n=this.view().name,i.views=e.map(this.options.views,function(e){var t=M(e),i=t?"string"!=typeof e.type?e.title:e.type:e;return n===i?t?e.selected=!0:e={type:i,selected:!0}:t&&(e.selected=!1),e})),t.dataSource||(i.dataSource=this.dataSource),t.dependencies||(i.dependencies=this.dependencies),t.resources||(i.resources=this.resources),t.assignments||(i.assignments=this.assignments),this.destroy(),this.element.empty(),
this.options=null,this.init(this.element,i,o),y.fn._setEvents.call(this,i)},_attachEvents:function(){this._resizeHandler=E(this.resize,this,!1),e(window).on("resize"+B,this._resizeHandler)},_wrapper:function(){var e=p.styles,t=[e.icon,e.resizeHandle].join(" "),n=this.options,i=n.height,o=n.width;this.wrapper=this.element.addClass(e.wrapper).append("<div class='"+e.listWrapper+"'><div></div></div>").append("<div class='"+e.splitBarWrapper+"'><div class='"+t+"'></div></div>").append("<div class='"+e.timelineWrapper+"'><div></div></div>"),this.wrapper.find($+e.list).width(n.listWidth),i&&this.wrapper.height(i),o&&this.wrapper.width(o),n.rowHeight&&this.wrapper.addClass(e.rowHeight)},_toolbar:function(){var t,n,i,o=this,r=p.styles,s=$+r.toolbar.views+" > li",a=$+r.toolbar.pdfButton,l=$+r.buttonToggle,c=$+r.gridContent,d=e($+r.list),u=e($+r.timeline),h=r.hovered,f=this.options.toolbar,_=e("<div class='"+r.toolbar.actions+"'>"),b=function(e){e.matches?d.css({display:"none","max-width":0}):(d.css({display:"inline-block",width:"30%","max-width":"none"}),u.css("display","inline-block"),o.refresh(),u.find(c).scrollTop(o.scrollTop)),o._resize()};A(f)||(f=typeof f===V?f:this._actions(f),f=E(m.template(f),this)),i=e(Q({styles:r.toolbar})),n=e(ee({ns:m.ns,views:this.timeline.views,styles:r.toolbar})),_.append(f({})),t=e("<div class='"+r.toolbar.headerWrapper+"'>").append(i).append(n).append(_),n.find("li").length>1&&n.prepend(J({styles:r.toolbar})),this.wrapper.prepend(t),this.toolbar=t,v&&(this._mediaQueryHandler=E(b,this),this._mediaQuery=window.matchMedia("(max-width: 480px)"),this._mediaQuery.addListener(this._mediaQueryHandler)),t.on(N+B,s,function(t){var i,s,a;t.preventDefault(),i=o.list,s=e(this).attr(m.attr("name")),a=n.find($+r.toolbar.currentView),a.is(":visible")&&a.parent().toggleClass(r.toolbar.expanded),i.editable&&i.editable.trigger("validate")||(o.trigger("navigate",{view:s})||o.view(s),o.toolbar.find($+r.focused).removeClass(r.focused))}).on("keydown"+B,s,function(t){var n=e($+r.toolbar.views).children(":not(.k-current-view)"),i=n.index(o._focusedView&&o._focusedView[0]||n.closest($+r.selected)[0]);t.keyCode===g.RIGHT?(e(o.toolbar.find($+r.focused)).removeClass(r.focused),o._focusedView=e(i+1===n.length?n[0]:n[i+1]),o._focusedView.focus().addClass(r.focused),t.preventDefault()):t.keyCode===g.LEFT?(e(o.toolbar.find($+r.focused)).removeClass(r.focused),o._focusedView=e(0===i?n[n.length-1]:n[i-1]),o._focusedView.focus().addClass(r.focused),t.preventDefault()):t.keyCode===g.DOWN&&o.toolbar.find($+r.toolbar.currentView).parent().hasClass(r.toolbar.expanded)?(e(o.toolbar.find($+r.focused)).removeClass(r.focused),o._focusedView=e(i+1===n.length?n[0]:n[i+1]),o._focusedView.focus().addClass(r.focused),t.preventDefault()):t.keyCode===g.UP&&o.toolbar.find($+r.toolbar.currentView).parent().hasClass(r.toolbar.expanded)?(e(o.toolbar.find($+r.focused)).removeClass(r.focused),o._focusedView=e(0===i?n[n.length-1]:n[i-1]),o._focusedView.focus().addClass(r.focused),t.preventDefault()):t.keyCode!==g.ENTER&&t.keyCode!==g.SPACEBAR||!o._focusedView?(t.keyCode===g.SPACEBAR||t.keyCode===g.ENTER||t.keyCode===g.DOWN&&t.altKey)&&o.toolbar.find($+r.toolbar.currentView+" > a").hasClass(r.focused)?(o.toolbar.find($+r.toolbar.currentView).parent().toggleClass(r.toolbar.expanded),t.preventDefault()):t.keyCode===g.ESC&&o.toolbar.find($+r.toolbar.currentView).parent().hasClass(r.toolbar.expanded)?(o.toolbar.find($+r.toolbar.currentView).parent().toggleClass(r.toolbar.expanded).blur(),o._focusedView=null,o.toolbar.find($+r.toolbar.currentView+" > a").addClass(r.focused).focus(),t.preventDefault()):t.keyCode>=49&&t.keyCode<=57&&o.view(o.timeline._viewByIndex(t.keyCode-49)):(o.view(o._focusedView.text().toLowerCase()),t.preventDefault())}).on(N+B,a,function(e){e.preventDefault(),o.saveAsPDF()}).on(N+B,l,function(e){e.preventDefault(),d.is(":visible")?(d.css({display:"none",width:"0"}),u.css({display:"inline-block",width:"100%"}),o.refresh(),u.find(c).scrollTop(o.scrollTop)):(u.css({display:"none",width:0}),d.css({display:"inline-block",width:"100%","max-width":"none"}).find(c).scrollTop(o.scrollTop)),o._resize()}),this.wrapper.on("focusout"+B,function(t){e(t.relatedTarget).closest($+r.toolbar.toolbar).length||o.toolbar.find($+r.focused).removeClass(r.focused),e(t.relatedTarget).closest($+r.toolbar.views).length||o.toolbar.find($+r.toolbar.views).removeClass(r.toolbar.expanded)}).find($+r.toolbar.toolbar+" li").hover(function(){e(this).addClass(h)},function(){e(this).removeClass(h)})},_actions:function(){var e,t,n=this.options,i=n.editable,o=n.toolbar,r="";if(!T(o)){if(!i||i.create===!1)return r;o=["append"]}for(e=0,t=o.length;e<t;e++)r+=this._createButton(o[e]);return r},_footer:function(){var t,n,i,o,r,s=this.options.editable;s&&s.create!==!1&&(t=p.styles.toolbar,n=this.options.messages.actions,i=e(m.template(X)(I(!0,{styles:t},a.append,{text:n.append}))),o=e("<div class='"+t.actions+"'>").append(i),r=e("<div class='"+t.footerWrapper+"'>").append(o),this.wrapper.append(r),this.footer=r)},_createButton:function(e){var t=e.template||X,n=this.options.messages.actions,i=typeof e===V?e:e.name||e.text,o=a[i]?a[i].className:"k-gantt-"+(i||"").replace(/\s/g,""),r={iconClass:"",action:"",text:i,className:o,styles:p.styles.toolbar};if(!(i||M(e)&&e.template))throw Error("Custom commands should have name specified");return r=I(!0,r,a[i],{text:n[i]}),M(e)&&(e.className&&D(r.className,e.className.split(" "))<0&&(e.className+=" "+r.className),r=I(!0,r,e)),m.template(t)(r)},_adjustDimensions:function(){var e=this.element,t=p.styles,n=$+t.list,i=$+t.timeline,o=$+t.splitBar,r=z(this.toolbar),s=this.footer?z(this.footer):0,a=e.height(),l=e.width(),c=F(e.find(o)),d=F(e.find(n));e.children([n,i,o].join(",")).height(a-(r+s)).end().children(i).width(l-(c+d)),l<d+c&&e.find(n).width(l-c)},_scrollTo:function(e){var t,i,o=this.timeline.view(),r=this.list,s=m.attr("uid"),a="string"==typeof e?e:e.closest("tr"+n()).attr(s),l=function(){0!==i.length&&t()};o.content.is(":visible")?(i=o.content.find(n(a)),t=function(){o._scrollTo(i)}):(i=r.content.find(n(a)),t=function(){i.get(0).scrollIntoView()}),l()},_dropDowns:function(){var e=this,t=$+p.styles.toolbar.actions,n=this.options.messages.actions,i=this.timeline,o=this.options.editable,r=function(t){var n,o=t.type,r=e.dataSource,s=r._createNewModel(),a=e.dataItem(e.select()),l=r.taskParent(a),c=i.view()._timeSlots()[0],d="add"===o?a:l,u=e.list.editable;u&&u.trigger("validate")||(s.set("title","New task"),d?(s.set("parentId",d.get("id")),s.set("start",d.get("start")),s.set("end",d.get("end"))):(s.set("start",c.start),s.set("end",c.end)),"add"!==o&&(n=a.get("orderId"),n="insert-before"===o?n:n+1),e._createTask(s,n))};o&&o.create!==!1&&(this.footerDropDown=new re(this.footer.children(t).eq(0),{messages:{actions:n},direction:"up",animation:{open:{effects:"slideIn:up"}},navigatable:e.options.navigatable}),this.headerDropDown=new re(this.toolbar.children(t).eq(0),{messages:{actions:n},navigatable:e.options.navigatable}),this.footerDropDown.bind("command",r),this.headerDropDown.bind("command",r))},_list:function(){var e,t,n=this,i=n.options.navigatable,o=p.styles,s=this.wrapper.find($+o.list),a=s.find("> div"),l=this.wrapper.find($+o.toolbar.actions+" > button"),c={columns:this.options.columns||[],dataSource:this.dataSource,selectable:this.options.selectable,editable:this.options.editable,resizable:this.options.resizable,columnResizeHandleWidth:this.options.columnResizeHandleWidth,listWidth:F(s),resourcesField:this.resources.field,rowHeight:this.options.rowHeight},d=c.columns,u=function(){i&&(n._current(n._cachedCurrent),r(n.list.content.find("table"),!0)),delete n._cachedCurrent};for(t=0;t<d.length;t++)e=d[t],e.field===this.resources.field&&"function"!=typeof e.editor&&(e.editor=E(this._createResourceEditor,this));this.list=new m.ui.GanttList(a,c),this.list.bind("render",function(){n._navigatable()},!0).bind("edit",function(e){n._cachedCurrent=e.cell,n.trigger("edit",{task:e.model,container:e.cell})&&e.preventDefault()}).bind("cancel",function(e){n.trigger("cancel",{task:e.model,container:e.cell})&&e.preventDefault(),u()}).bind("update",function(e){n._updateTask(e.task,e.updateInfo),u()}).bind("change",function(){n.trigger("change");var e=n.list.select();e.length?(l.removeAttr("data-action","add"),n.timeline.select("[data-uid='"+e.attr("data-uid")+"']")):(l.attr("data-action","add"),n.timeline.clearSelection())}).bind("columnResize",function(e){n.trigger("columnResize",{column:e.column,oldWidth:e.oldWidth,newWidth:e.newWidth})})},_timeline:function(){var e=this,n=p.styles,o=i(I(!0,{resourcesField:this.resources.field},this.options)),r=this.wrapper.find($+n.timeline+" > div"),s=$+n.toolbar.currentView+" > "+$+n.toolbar.link;this.timeline=new m.ui.GanttTimeline(r,o),this.timeline.bind("navigate",function(t){var i=t.view.replace(/\./g,"\\.").toLowerCase(),o=e.toolbar.find($+n.toolbar.views+" > li").removeClass(n.selected).end().find($+n.toolbar.viewButton+"-"+i).addClass(n.selected).find($+n.toolbar.link).text();e.toolbar.find(s).text(o),e.refresh()}).bind("moveStart",function(n){var i=e.list.editable;return i&&i.trigger("validate")?(n.preventDefault(),t):(e.trigger("moveStart",{task:n.task})&&n.preventDefault(),t)}).bind("move",function(t){var n=t.task,i=t.start,o=new Date(i.getTime()+n.duration());e.trigger("move",{task:n,start:i,end:o})&&t.preventDefault()}).bind("moveEnd",function(t){var n=t.task,i=t.start,o=new Date(i.getTime()+n.duration());e.trigger("moveEnd",{task:n,start:i,end:o})||e._updateTask(e.dataSource.getByUid(n.uid),{start:i,end:o})}).bind("resizeStart",function(n){var i=e.list.editable;return i&&i.trigger("validate")?(n.preventDefault(),t):(e.trigger("resizeStart",{task:n.task})&&n.preventDefault(),t)}).bind("resize",function(t){e.trigger("resize",{task:t.task,start:t.start,end:t.end})&&t.preventDefault()}).bind("resizeEnd",function(t){var n=t.task,i={};t.resizeStart?i.start=t.start:i.end=t.end,e.trigger("resizeEnd",{task:n,start:t.start,end:t.end})||e._updateTask(e.dataSource.getByUid(n.uid),i)}).bind("percentResizeStart",function(t){var n=e.list.editable;n&&n.trigger("validate")&&t.preventDefault()}).bind("percentResizeEnd",function(t){e._updateTask(e.dataSource.getByUid(t.task.uid),{percentComplete:t.percentComplete})}).bind("dependencyDragStart",function(t){var n=e.list.editable;n&&n.trigger("validate")&&t.preventDefault()}).bind("dependencyDragEnd",function(t){var n=e.dependencies._createNewModel({type:t.type,predecessorId:t.predecessor.id,successorId:t.successor.id});e._createDependency(n)}).bind("select",function(t){var n=e.list.editable;n&&n.trigger("validate"),e.select("[data-uid='"+t.uid+"']")}).bind("editTask",function(t){var n=e.list.editable;n&&n.trigger("validate")||e.editTask(t.uid)}).bind("clear",function(){e.clearSelection()}).bind("removeTask",function(t){var n=e.list.editable;n&&n.trigger("validate")||e.removeTask(e.dataSource.getByUid(t.uid))}).bind("removeDependency",function(t){var n=e.list.editable;n&&n.trigger("validate")||e.removeDependency(e.dependencies.getByUid(t.uid))})},_dataSource:function(){var e=this.options,t=e.dataSource;t=T(t)?{data:t}:t,this.dataSource&&this._refreshHandler?this.dataSource.unbind("change",this._refreshHandler).unbind("progress",this._progressHandler).unbind("error",this._errorHandler):(this._refreshHandler=E(this.refresh,this),this._progressHandler=E(this._requestStart,this),this._errorHandler=E(this._error,this)),this.dataSource=m.data.GanttDataSource.create(t).bind("change",this._refreshHandler).bind("progress",this._progressHandler).bind("error",this._errorHandler)},_dependencies:function(){var e=this.options.dependencies||{},t=T(e)?{data:e}:e;this.dependencies&&this._dependencyRefreshHandler?this.dependencies.unbind("change",this._dependencyRefreshHandler).unbind("error",this._dependencyErrorHandler):(this._dependencyRefreshHandler=E(this.refreshDependencies,this),this._dependencyErrorHandler=E(this._error,this)),this.dependencies=m.data.GanttDependencyDataSource.create(t).bind("change",this._dependencyRefreshHandler).bind("error",this._dependencyErrorHandler)},_resources:function(){var e=this.options.resources,t=e.dataSource||{};this.resources={field:"resources",dataTextField:"name",dataColorField:"color",dataFormatField:"format"},I(this.resources,e),this.resources.dataSource=m.data.DataSource.create(t)},_assignments:function(){var e=this.options.assignments,t=e.dataSource||{};this.assignments?this.assignments.dataSource.unbind("change",this._assignmentsRefreshHandler):this._assignmentsRefreshHandler=E(this.refresh,this),this.assignments={dataTaskIdField:"taskId",dataResourceIdField:"resourceId",dataValueField:"value"},I(this.assignments,e),this.assignments.dataSource=m.data.DataSource.create(t),this.assignments.dataSource.bind("change",this._assignmentsRefreshHandler)},_createEditor:function(){var e=this,n=this._editor=new h(this.wrapper,I({},this.options,{target:this,resources:{field:this.resources.field,editor:E(this._createResourceEditor,this)},createButton:E(this._createPopupButton,this)}));n.bind("cancel",function(n){var i=e.dataSource.getByUid(n.model.uid);return e.trigger("cancel",{container:n.container,task:i})?(n.preventDefault(),t):(e.cancelTask(),t)}).bind("edit",function(t){var n=e.dataSource.getByUid(t.model.uid);e.trigger("edit",{container:t.container,task:n})&&t.preventDefault()}).bind("save",function(t){var n=e.dataSource.getByUid(t.model.uid);e.saveTask(n,t.updateInfo)}).bind("remove",function(t){e.removeTask(t.model.uid)}).bind("close",e._onDialogClose)},_onDialogClose:function(){},_createResourceEditor:function(e,t){var n=this,i=t instanceof x?t:t.model,o=i.get("id"),r=this.options.messages,s=n.resources.field,a=this._resourceEditor=new f(e,{resourcesField:s,data:this._wrapResourceData(o),model:i,messages:I({},r.editor),buttons:[{name:"update",text:r.save,className:p.styles.primary},{name:"cancel",text:r.cancel}],createButton:E(this._createPopupButton,this),save:function(e){n._updateAssignments(e.model.get("id"),e.model.get(s))}});a.open()},_createPopupButton:function(e){var t=e.name||e.text,n={className:p.styles.popup.button+" k-gantt-"+(t||"").replace(/\s/g,""),text:t,attr:""};if(!(t||M(e)&&e.template))throw Error("Custom commands should have name specified");return M(e)&&(e.className&&(e.className+=" "+n.className),n=I(!0,n,e)),m.template(Z)(n)},view:function(e){return this.timeline.view(e)},range:function(e){var t=this.dataSource,n=this.view(),i=this.timeline;return e&&(n.options.range={start:e.start,end:e.end},i._render(t.taskTree()),i._renderDependencies(this.dependencies.view())),{start:n.start,end:n.end}},date:function(e){var t=this.view();return e&&(t.options.date=e,t._scrollToDate(e)),t.options.date},dataItem:function(e){var t,n;return e?(t=this.list,n=t.content.find(e),t._modelFromElement(n)):null},setDataSource:function(e){this.options.dataSource=e,this._dataSource(),this.list._setDataSource(this.dataSource),this.options.autoBind&&e.fetch()},setDependenciesDataSource:function(e){this.options.dependencies=e,this._dependencies(),this.options.autoBind&&e.fetch()},items:function(){return this.wrapper.children(".k-task")},_updateAssignments:function(e,t){for(var n,i,o,r,s,a,l,c=this.assignments.dataSource,d=this.assignments.dataTaskIdField,u=this.assignments.dataResourceIdField,h=!1,f=new S(c.view()).filter({field:d,operator:"eq",value:e}).toArray();f.length;){for(n=f[0],r=0,s=t.length;r<s;r++)if(i=t[r],n.get(u)===i.get("id")){o=t[r].get("value"),this._updateAssignment(n,o),t.splice(r,1),h=!0;break}h||this._removeAssignment(n),h=!1,f.shift()}for(a=0,l=t.length;a<l;a++)i=t[a],this._createAssignment(i,e);c.sync()},cancelTask:function(){var e=this._editor,t=e.container;t&&e.close()},editTask:function(e){var t,n="string"==typeof e?this.dataSource.getByUid(e):e;n&&(t=this.dataSource._createNewModel(n.toJSON()),t.uid=n.uid,this.cancelTask(),this._editTask(t))},_editTask:function(e){this._editor.editTask(e)},saveTask:function(e,t){var n=this._editor,i=n.container,o=n.editable;i&&o&&o.end()&&this._updateTask(e,t)},_updateTask:function(e,t){var n=this.resources.field;this.trigger("save",{task:e,values:t})||(this._preventRefresh=!0,this.dataSource.update(e,t),t[n]&&this._updateAssignments(e.get("id"),t[n]),this._syncDataSource())},_updateAssignment:function(e,t){var n=this.assignments.dataValueField;e.set(n,t)},removeTask:function(e){var t=this,n="string"==typeof e?this.dataSource.getByUid(e):e;n&&this._taskConfirm(function(e){e||t._removeTask(n)},n)},_createTask:function(e,n){if(!this.trigger("add",{task:e,dependency:null})){var i=this.dataSource;this._preventRefresh=!0,n===t?i.add(e):i.insert(n,e),this._scrollToUid=e.uid,this._syncDataSource()}},_createDependency:function(e){this.trigger("add",{task:null,dependency:e})||(this._preventDependencyRefresh=!0,this.dependencies.add(e),this._preventDependencyRefresh=!1,this.dependencies.sync())},_createAssignment:function(e,t){var n=this.assignments,i=n.dataSource,o=n.dataTaskIdField,r=n.dataResourceIdField,s=n.dataValueField,a=i._createNewModel();a[o]=t,a[r]=e.get("id"),a[s]=e.get("value"),i.add(a)},removeDependency:function(e){var t=this,n="string"==typeof e?this.dependencies.getByUid(e):e;n&&this._dependencyConfirm(function(e){e||t._removeDependency(n)},n)},_removeTaskDependencies:function(e,t){this._preventDependencyRefresh=!0;for(var n=0,i=t.length;n<i;n++)this.dependencies.remove(t[n]);this._preventDependencyRefresh=!1,this.dependencies.sync()},_removeTaskAssignments:function(e){var t,n,i=this.assignments.dataSource,o=i.view(),r={field:this.assignments.dataTaskIdField,operator:"eq",value:e.get("id")};for(o=new S(o).filter(r).toArray(),this._preventRefresh=!0,t=0,n=o.length;t<n;t++)i.remove(o[t]);this._preventRefresh=!1,i.sync()},_removeTask:function(e){var t=this.dependencies.dependencies(e.id);this.trigger("remove",{task:e,dependencies:t})||(this._removeTaskDependencies(e,t),this._removeTaskAssignments(e),this._preventRefresh=!0,this.dataSource.remove(e)&&this._syncDataSource(),this._preventRefresh=!1)},_removeDependency:function(e){this.trigger("remove",{task:null,dependencies:[e]})||this.dependencies.remove(e)&&this.dependencies.sync()},_removeAssignment:function(e){this.assignments.dataSource.remove(e)},_taskConfirm:function(e,t){var n=this.options.messages;this._confirm(e,{model:t,text:n.deleteTaskConfirmation,title:n.deleteTaskWindowTitle})},_dependencyConfirm:function(e,t){var n=this.options.messages;this._confirm(e,{model:t,text:n.deleteDependencyConfirmation,title:n.deleteDependencyWindowTitle})},_confirm:function(e,t){var n,i,o=this.options.editable;o===!0||o.confirmation!==!1?(n=this.options.messages,i=[{name:"delete",text:n.destroy,className:p.styles.primary,click:function(){e()}},{name:"cancel",text:n.cancel,click:function(){e(!0)}}],this.showDialog(I(!0,{},t,{buttons:i}))):e()},showDialog:function(e){this._editor.showDialog(e)},refresh:function(){var e,t,i,o,r,s;this._preventRefresh||this.list.editable||(this._progress(!1),e=this.dataSource,t=e.taskTree(),i=this._scrollToUid,s=-1,this.current&&(r=this.current.closest("tr").attr(m.attr("uid")),s=this.current.index()),this.trigger("dataBinding")||(0!==this.resources.dataSource.data().length&&this._assignResources(t),this._editor&&this._editor.close(),this.clearSelection(),this.list._render(t),this.timeline._render(t),this.timeline._renderDependencies(this.dependencies.view()),i&&(this._scrollTo(i),this.select(n(i))),(i||r)&&s>=0&&(o=this.list.content.find("tr"+n(i||r)+" > td:eq("+s+")"),this._current(o)),this._scrollToUid=null,this.trigger("dataBound")))},refreshDependencies:function(){this._preventDependencyRefresh||this.trigger("dataBinding")||(this.timeline._renderDependencies(this.dependencies.view()),this.trigger("dataBound"))},_assignResources:function(e){var t,n,i=this.resources,o=this.assignments,r=function(){var e=o.dataSource.view(),t={field:o.dataTaskIdField};return e=new S(e).group(t).toArray()},s=r(),a=function(e,t){var n,o,r=e.get("id");for(m.setter(i.field)(e,new C([])),n=0,o=s.length;n<o;n++)s[n].value===r&&t(e,s[n].items)},l=function(e,t){var n,r,s,a,l,c,d,u;for(n=0,r=t.length;n<r;n++)s=t[n],a=i.dataSource.get(s.get(o.dataResourceIdField)),l=s.get(o.dataValueField),c=s.get(o.dataResourceIdField),d=a.get(i.dataFormatField)||L,u=m.toString(l,d),e[i.field].push(new x({id:c,name:a.get(i.dataTextField),color:a.get(i.dataColorField),value:l,formatedValue:u}))};for(t=0,n=e.length;t<n;t++)a(e[t],l)},_wrapResourceData:function(e){var t,n,i,o=this,r=[],s=this.resources.dataSource.view(),a=this.assignments.dataSource.view(),l=new S(a).filter({field:o.assignments.dataTaskIdField,operator:"eq",value:e}).toArray(),c=function(e){var t=null;return new S(l).filter({field:o.assignments.dataResourceIdField,operator:"eq",value:e}).select(function(e){t+=e.get(o.assignments.dataValueField)}),t};for(n=0,i=s.length;n<i;n++)t=s[n],r.push({id:t.get("id"),name:t.get(o.resources.dataTextField),format:t.get(o.resources.dataFormatField)||L,value:c(t.id)});return r},_syncDataSource:function(){this._preventRefresh=!1,this._requestStart(),this.dataSource.sync()},_requestStart:function(){this._progress(!0)},_error:function(){this._progress(!1)},_progress:function(e){m.ui.progress(this.element,e)},_resizable:function(){var t,n,i,o=this,r=this.wrapper,s=p.styles,a=$+s.gridContent,l=r.find($+s.list),c=r.find($+s.timeline);this._resizeDraggable=r.find($+s.splitBar).height(l.height()).hover(function(){e(this).addClass(s.splitBarHover)},function(){e(this).removeClass(s.splitBarHover)}).end().kendoResizable({orientation:"horizontal",handle:$+s.splitBar,start:function(){t=l.width(),n=c.width(),i=c.find(a).scrollLeft()},resize:function(e){var s=e.x.initialDelta;m.support.isRtl(r)&&(s*=-1),t+s<0||n-s<0||(l.width(t+s),c.width(n-s),c.find(a).scrollLeft(i+s),o.timeline.view()._renderCurrentTime())}}).data("kendoResizable")},_scrollable:function(){var t=this,n=p.styles,i=$+n.gridContent,o=$+n.gridHeaderWrap,r=this.timeline.element.find(o),s=this.timeline.element.find(i),a=this.list.element.find(o),l=this.list.element.find(i);b&&l.css("overflow-y","auto"),s.on("scroll",function(){t.scrollTop=this.scrollTop,r.scrollLeft(this.scrollLeft),l.scrollTop(this.scrollTop)}),l.on("scroll",function(){a.scrollLeft(this.scrollLeft)}).on("DOMMouseScroll"+B+" mousewheel"+B,function(t){var n=s.scrollTop(),i=m.wheelDeltaY(t);i&&(t.preventDefault(),e(t.currentTarget).one("wheel"+B,!1),s.scrollTop(n+-i))})},_navigatable:function(){var i,o=this,s=this.options.navigatable,a=this.options.editable,l=this.list.header.find("table"),c=this.list.content.find("table"),d=p.styles,u=m.support.isRtl(this.wrapper),h=this.timeline.element.find($+d.gridContent),f=l.add(c),v=n(),_={collapse:!1,expand:!0},b=function(e){var t=o.timeline.view()._timeSlots()[0].offsetWidth;h.scrollLeft(h.scrollLeft()+(e?-t:t))},w=function(e){var t=o.timeline.view()._rowHeight;h.scrollTop(h.scrollTop()+(e?-t:t))},y=function(e){var t=o.current.parent("tr"+n()),i=o.current.index(),s=t[e]();0!==o.select().length&&o.clearSelection(),0!==s.length?(o._current(s.children("td:eq("+i+")")),o._scrollTo(o.current)):o.current.is("td")&&"prev"==e?r(l):o.current.is("th")&&"next"==e&&r(c)},k=function(e){var t=o.current[e]();0!==t.length&&(o._current(t),i=o.current.index())},x=function(e){var t=o.dataItem(o.current);t.summary&&t.expanded!==e&&t.set("expanded",e)},C=function(){var e,t,n=o.options.editable;n&&n.destroy!==!1&&!o.list.editable&&(e=o.select(),t=m.attr("uid"),e.length&&o.removeTask(e.attr(t)))};return e(this.wrapper).on("mousedown"+B,"tr"+v+", div"+v+":not("+$+d.line+")",function(t){var i,l=e(t.currentTarget),c=e(t.target).is(":button,a,:input,a>.k-icon,textarea,span.k-icon,span.k-link,.k-input,.k-multiselect-wrap");t.ctrlKey||(s&&(i=l.is("tr")?e(t.target).closest("td"):o.list.content.find("tr"+n(l.attr(m.attr("uid")))+" > td:first"),o._current(i)),!s&&!a||c||(o._focusTimeout=setTimeout(function(){r(o.list.content.find("table"),!0)},2)))}).on("keydown"+B,function(n){var i,o=n.keyCode,r=this,s=e(r._getToolbarItems()),a=s.index(r.toolbar.find($+d.focused)[0]);if(a===-1&&e(n.target).closest($+d.toolbar.views).length&&(a=s.index(r.toolbar.find(".k-gantt-views > .k-state-selected:visible > a, .k-current-view:visible > a")[0])),i=n.shiftKey?s[a-1]:s[a+1],o===g.F10)r.toolbar.find(".k-button:visible:first").addClass(d.focused).focus(),n.preventDefault();else if(o==g.TAB&&e(n.target).closest($+d.toolbar.toolbar).length){if(r.toolbar.find($+d.focused).removeClass(d.focused).blur(),i)return e(i).addClass(d.focused).focus(),n.preventDefault(),t;this.list.element.is(":visible")?this.list.element.find("table[role=treegrid]").focus():this.element.find($+d.tasks)[0].focus(),n.preventDefault()}}.bind(this)),s!==!0?(c.on("keydown"+B,function(e){e.keyCode==g.DELETE&&C()}),t):(f.on("focus"+B,function(){var t=this===c.get(0)?"td":"th",n=o.select(),r=o.current||e(n.length?n:this).find(t+":eq("+(i||0)+")");o._current(r),e(o.toolbar.find($+d.focused)).removeClass(d.focused),e(o.toolbar.find($+d.toolbar.currentView)).parent().removeClass(d.toolbar.expanded)}).on("blur"+B,function(){o._current(),this==l&&e(this).attr(H,-1)}).on("keydown"+B,function(t){var n,i=t.keyCode;if(o.current)switch(n=o.current.is("td"),i){case g.RIGHT:t.preventDefault(),t.altKey?b():t.ctrlKey?x(u?_.collapse:_.expand):k(u?"prev":"next");break;case g.LEFT:t.preventDefault(),t.altKey?b(!0):t.ctrlKey?x(u?_.expand:_.collapse):k(u?"next":"prev");break;case g.UP:t.preventDefault(),t.altKey?w(!0):y("prev");break;case g.DOWN:t.preventDefault(),t.altKey?w():y("next");break;case g.SPACEBAR:t.preventDefault(),n&&o.select(o.current.closest("tr"));break;case g.ENTER:t.preventDefault(),n?o.options.editable&&o.options.editable.update!==!1&&(o._cachedCurrent=o.current,o.list._startEditHandler(o.current),e(this).one("keyup",function(e){e.stopPropagation()})):o.current.children("a.k-link").click();break;case g.ESC:break;case g.DELETE:n&&C();break;default:i>=49&&i<=57&&o.view(o.timeline._viewByIndex(i-49))}}),t)},_getToolbarItems:function(){return this.toolbar.find(".k-gantt-toggle:visible").toArray().concat(this.toolbar.find(".k-gantt-actions > .k-button:visible").toArray(),this.toolbar.find(".k-gantt-views > .k-state-selected:visible > a, .k-current-view:visible > a").toArray())},_current:function(t){var n,i=p.styles;this.current&&this.current.length&&this.current.removeClass(i.focused).removeAttr("id"),t&&t.length?(this.current=t.addClass(i.focused).attr("id",q),n=e(m._activeElement()),n.is("table")&&this.wrapper.find(n).length>0&&n.removeAttr(W).attr(W,q)):this.current=null},_dataBind:function(){var t,n=this;n.options.autoBind&&(this._preventRefresh=!0,this._preventDependencyRefresh=!0,t=e.map([this.dataSource,this.dependencies,this.resources.dataSource,this.assignments.dataSource],function(e){return e.fetch()}),e.when.apply(null,t).done(function(){n._preventRefresh=!1,n._preventDependencyRefresh=!1,n.refresh()}))},_resize:function(){this._adjustDimensions(),this.timeline.view()._adjustHeight(),this.timeline.view()._renderCurrentTime(),this.list._adjustHeight()}}),m.PDFMixin&&(m.PDFMixin.extend(p.fn),p.fn._drawPDF=function(){var e=p.styles,t="."+e.list,n=this.wrapper.find(t).width(),i=this.wrapper.clone();return i.find(t).css("width",n),this._drawPDFShadow({content:i},{avoidLinks:this.options.pdf.avoidLinks})}),m.ui.plugin(p),I(!0,p,{styles:oe})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.treelist.min",["kendo.dom.min","kendo.data.min","kendo.columnsorter.min","kendo.editable.min","kendo.window.min","kendo.filtermenu.min","kendo.selectable.min","kendo.resizable.min","kendo.treeview.draganddrop.min"],e)}(function(){return function(e,t){function n(e){return function(t){return t[e]}}function i(e){return function(t){return!e(t)}}function o(){return"none"!==this.style.display}function r(n){var i,o=n.find(">tr:not(.k-filter-row)"),r=function(){var t=e(this);return!t.hasClass("k-group-cell")&&!t.hasClass("k-hierarchy-cell")},s=e();return o.length>1&&(s=o.find("th").filter(r).filter(function(){return this.rowSpan>1})),s=s.add(o.last().find("th").filter(r)),i=kendo.attr("index"),s.sort(function(n,o){var r,s;return n=e(n),o=e(o),r=n.attr(i),s=o.attr(i),r===t&&(r=e(n).index()),s===t&&(s=e(o).index()),r=parseInt(r,10),s=parseInt(s,10),r>s?1:r<s?-1:0}),s}function s(e){var t,n,i=[],o=e.className;for(t=0,n=e.level;t<n;t++)i.push(_("span",{className:o}));return i}function a(e){var t,n,i,o=0;for(n=0,i=e.length;n<i;n++)t=e[n].style.width,t&&t.indexOf("%")==-1&&(o+=parseInt(t,10));return o}function l(e,t){var n,i,o,r;e=e[0],t=t[0],e.rows.length!==t.rows.length&&(n=e.offsetHeight,i=t.offsetHeight,n>i?(o=t.rows[t.rows.length-1],r=n-i):(o=e.rows[e.rows.length-1],r=i-n),o.style.height=o.offsetHeight+r+"px")}function c(t){return e(t).is(":button,a,:input,a>.k-icon,textarea,span.k-select,span.k-icon,span.k-link,.k-input,.k-multiselect-wrap,.k-tool-icon")}function d(t,n){var i,o,r=I.msie||I.edge;if(n===!0){if(t=e(t),i=t.parent().scrollTop(),o=t.parent().scrollLeft(),r)try{t[0].setActive()}catch(s){t[0].focus()}else t[0].focus();t.parent().scrollTop(i).scrollLeft(o)}else e(t).one("focusin",function(e){e.preventDefault()}).focus()}var u,h,f,p,m=kendo.data,g=e.extend,v=kendo.dom,_=v.element,b=v.text,w=v.html,y=kendo._outerWidth,k=kendo.keys,x=kendo._outerHeight,C=kendo.ui,S=C.DataBoundWidget,T=m.DataSource,D=m.ObservableArray,A=m.Query,E=m.Model,I=kendo.support.browser,M=e.proxy,R=e.map,F=e.grep,z=e.inArray,P=e.isPlainObject,B=Array.prototype.push,L="string",H="change",N="error",O="progress",V=".",U=".kendoTreeList",W="click",j="mousedown",q="edit",G="save",$="expand",K="collapse",Y="remove",Q="dataBinding",X="dataBound",Z="cancel",J="tabIndex",ee="filterMenuInit",te="columnHide",ne="columnShow",ie="th.k-header",oe="columnReorder",re="columnResize",se="columnMenuInit",ae="columnLock",le="columnUnlock",ce="parentId",de="dragstart",ue="drag",he="drop",fe="dragend",pe="tr:visible",me="td:visible",ge="th:visible",ve=pe+" > td:first:visible",_e="tr:not(.k-footer-template):visible:last",be="th:visible",we=!1,ye="height",ke={wrapper:"k-treelist k-grid k-widget k-display-block",header:"k-header",button:"k-button",alt:"k-alt",editCell:"k-edit-cell",group:"k-treelist-group",gridToolbar:"k-grid-toolbar",gridHeader:"k-grid-header",gridHeaderWrap:"k-grid-header-wrap",gridContent:"k-grid-content",gridContentWrap:"k-grid-content",gridFilter:"k-grid-filter",footerTemplate:"k-footer-template",focused:"k-state-focused",loading:"k-i-loading",refresh:"k-i-reload",retry:"k-request-retry",selected:"k-state-selected",status:"k-status",link:"k-link",withIcon:"k-with-icon",filterable:"k-filterable",icon:"k-icon",iconFilter:"k-i-filter",iconCollapse:"k-i-collapse",iconExpand:"k-i-expand",iconHidden:"k-i-none",iconPlaceHolder:"k-icon k-i-none",input:"k-input",dropPositions:"k-i-insert-up k-i-insert-down k-i-plus k-i-insert-middle",dropTop:"k-i-insert-up",dropBottom:"k-i-insert-down",dropAdd:"k-i-plus",dropMiddle:"k-i-insert-middle",dropDenied:"k-i-cancel",dragStatus:"k-drag-status",dragClue:"k-drag-clue",dragClueText:"k-clue-text"},xe={create:{imageClass:"k-i-plus",className:"k-grid-add",methodName:"addRow"},createchild:{imageClass:"k-i-plus",className:"k-grid-add",methodName:"addRow"},destroy:{imageClass:"k-i-close",className:"k-grid-delete",methodName:"removeRow"},edit:{imageClass:"k-i-edit",className:"k-grid-edit",methodName:"editRow"},update:{imageClass:"k-i-check",className:"k-primary k-grid-update",methodName:"saveRow"},canceledit:{imageClass:"k-i-cancel",className:"k-grid-cancel",methodName:"_cancelEdit"},excel:{imageClass:"k-i-file-excel",className:"k-grid-excel",methodName:"saveAsExcel"},pdf:{imageClass:"k-i-file-pdf",className:"k-grid-pdf",methodName:"saveAsPDF"}},Ce=E.define({id:"id",parentId:ce,fields:{id:{type:"number"},parentId:{type:"number",nullable:!0}},init:function(e){E.fn.init.call(this,e),this._loaded=!1,this.parentIdField||(this.parentIdField=ce),
this.parentId=this.get(this.parentIdField)},accept:function(e){E.fn.accept.call(this,e),this.parentId=this.get(this.parentIdField)},set:function(e,t,n){e==ce&&this.parentIdField!=ce&&(this[this.parentIdField]=t),E.fn.set.call(this,e,t,n),e==this.parentIdField&&(this.parentId=this.get(this.parentIdField))},loaded:function(e){return e===t?this._loaded:(this._loaded=e,t)},shouldSerialize:function(e){return E.fn.shouldSerialize.call(this,e)&&"_loaded"!==e&&"_error"!=e&&"_edit"!=e&&!("parentId"!==this.parentIdField&&"parentId"===e)}});Ce.parentIdField=ce,Ce.define=function(e,n){var i,o;return n===t&&(n=e,e=Ce),i=n.parentId||ce,n.parentIdField=i,o=E.define(e,n),i&&(o.parentIdField=i),o},u=T.extend({init:function(e){T.fn.init.call(this,g(!0,{},{schema:{modelBase:Ce,model:Ce}},e))},_createNewModel:function(e){var t={},n=e instanceof E;return n&&(t=e),t=T.fn._createNewModel.call(this,t),n||(e.parentId&&(e[t.parentIdField]=e.parentId),t.accept(e)),t},_shouldWrap:function(){return!0},_push:function(e,t){var n=T.fn._readData.call(this,e);n||(n=e),this[t](n)},_readData:function(e,t){var n,i,o=this.data(),r=o;return e=T.fn._readData.call(this,e),n=o.toJSON().concat(e),t&&t.id&&(i=this.get(t.id),this.childNodes(i).length>0&&(n=e,r=this._subtree(this._childrenMap(this.data()),t.id))),this._replaceData(n,r),e instanceof D?e:o},_replaceData:function(e,t){var n,i=e.length;for(n=0;n<i;n++)t[n]=e[n];t.length=i},_readAggregates:function(e){var t=g(this._aggregateResult,this.reader.aggregates(e));return""in t&&(t[this._defaultParentId()]=t[""],delete t[""]),t},remove:function(e){var t=this._subtree(this._childrenMap(this.data()),e.id);this._removeItems(t),T.fn.remove.call(this,e)},_filterCallback:function(e){var t,n,i={},o=[],r=e.toArray();for(t=0;t<r.length;t++)for(n=r[t];n&&(i[n.id]||(i[n.id]=!0,o.push(n)),!i[n.parentId]);)i[n.parentId]=!0,n=this.parentNode(n),n&&o.push(n);return new A(o)},_subtree:function(e,t){var n,i,o=e[t]||[],r=this._defaultParentId();for(n=0,i=o.length;n<i;n++)o[n].id!==r&&(o=o.concat(this._subtree(e,o[n].id)));return o},_childrenMap:function(e){var t,n,i,o,r={};for(e=this._observeView(e),t=0;t<e.length;t++)n=e[t],i=n.id,o=n.parentId,r[i]=r[i]||[],r[o]=r[o]||[],r[o].push(n);return r},_calculateAggregates:function(e,t){var n,i,o,r,s,a;for(t=t||{},n={},s=t.filter,s&&(e=A.process(e,{filter:s,filterCallback:M(this._filterCallback,this)}).data),a=this._childrenMap(e),n[this._defaultParentId()]=new A(this._subtree(a,this._defaultParentId())).aggregate(t.aggregate),r=0;r<e.length;r++)i=e[r],o=this._subtree(a,i.id),n[i.id]=new A(o).aggregate(t.aggregate);return n},_queryProcess:function(e,t){var n,i,o,r,s,a,l;for(t=t||{},t.filterCallback=M(this._filterCallback,this),n=this._defaultParentId(),i=A.process(e,t),o=this._childrenMap(i.data),e=o[n]||[],s=0;s<e.length;s++)a=e[s],a.id!==n&&(l=o[a.id],r=!(!l||!l.length),a.loaded()||a.loaded(r||!a.hasChildren),(a.loaded()||a.hasChildren!==!0)&&(a.hasChildren=r),r&&(e=e.slice(0,s+1).concat(l,e.slice(s+1))));return i.data=e,i},_queueRequest:function(e,t){t.call(this)},_modelLoaded:function(e){var t=this.get(e);t.loaded(!0),t.hasChildren=this.childNodes(t).length>0},_modelError:function(e,t){this.get(e)._error=t},success:function(e,n){return n&&t!==n.id||(this._data=this._observe([])),T.fn.success.call(this,e,n)},load:function(t){var n="_query",i=this.options.serverSorting||this.options.serverPaging||this.options.serverFiltering||this.options.serverGrouping||this.options.serverAggregates,o=e.Deferred().resolve().promise();if(t.loaded()){if(i)return o}else t.hasChildren&&(n="read");return this[n]({id:t.id}).done(M(this._modelLoaded,this,t.id)).fail(M(this._modelError,this,t.id))},contains:function(e,t){for(var n=e.id;t;){if(t.parentId===n)return!0;t=this.parentNode(t)}return!1},_byParentId:function(e,t){var n,i,o=[],r=this.view();if(e===t)return[];for(i=0;i<r.length;i++)n=r.at(i),n.parentId==e&&o.push(n);return o},_defaultParentId:function(){return this.reader.model.fn.defaults[this.reader.model.parentIdField]},childNodes:function(e){return this._byParentId(e.id,this._defaultParentId())},rootNodes:function(){return this._byParentId(this._defaultParentId())},parentNode:function(e){return this.get(e.parentId)},level:function(e){var t=-1;e instanceof Ce||(e=this.get(e));do e=this.parentNode(e),t++;while(e);return t},filter:function(e){var n=T.fn.filter;return e===t?n.call(this,e):(n.call(this,e),t)}}),u.create=function(t){return e.isArray(t)?t={data:t}:t instanceof D&&(t={data:t.toJSON()}),t instanceof u?t:new u(t)},h=kendo.Observable.extend({init:function(e,t){kendo.Observable.fn.init.call(this),t=this.options=g(!0,{},this.options,t),this.element=e,this.bind(this.events,t),this.model=this.options.model,this.fields=this._fields(this.options.columns),this._initContainer(),this.createEditable()},events:[],_initContainer:function(){this.wrapper=this.element},createEditable:function(){var e=this.options;this.editable=new C.Editable(this.wrapper,{fields:this.fields,target:e.target,clearContainer:e.clearContainer,model:this.model})},_isEditable:function(e){return e.field&&this.model.editable(e.field)},_fields:function(e){var t,n,i,o=[];for(t=0,n=e.length;t<n;t++)i=e[t],this._isEditable(i)&&o.push({field:i.field,format:i.format,editor:i.editor});return o},end:function(){return this.editable.end()},close:function(){this.destroy()},destroy:function(){this.editable.destroy(),this.editable.element.find("["+kendo.attr("container-for")+"]").empty().end().removeAttr(kendo.attr("role")),this.model=this.wrapper=this.element=this.columns=this.editable=null}}),f=h.extend({init:function(e,t){h.fn.init.call(this,e,t),this._attachHandlers(),kendo.cycleForm(this.wrapper),this.open()},events:[Z,G],options:{window:{modal:!0,resizable:!1,draggable:!0,title:"Edit",visible:!1}},_initContainer:function(){var t=this.options,n=[];this.wrapper=e('<div class="k-popup-edit-form"/>').attr(kendo.attr("uid"),this.model.uid).append('<div class="k-edit-form-container"/>'),t.template?(this._appendTemplate(n),this.fields=[]):this._appendFields(n),this._appendButtons(n),new v.Tree(this.wrapper.children()[0]).render(n),this.wrapper.appendTo(t.appendTo),this.window=new C.Window(this.wrapper,t.window)},_appendTemplate:function(e){var t=this.options.template;typeof t===L&&(t=window.unescape(t)),t=kendo.template(t)(this.model),e.push(w(t))},_appendFields:function(e){var t,n,i,o=this.options.columns;for(t=0,n=o.length;t<n;t++)i=o[t],i.command||(e.push(w('<div class="k-edit-label"><label for="'+i.field+'">'+(i.title||i.field||"")+"</label></div>")),e.push(this._isEditable(i)?w("<div "+kendo.attr("container-for")+'="'+i.field+'" class="k-edit-field"></div>'):_("div",{"class":"k-edit-field"},[this.options.fieldRenderer(i,this.model)])))},_appendButtons:function(e){e.push(_("div",{"class":"k-edit-buttons k-state-default"},this.options.commandRenderer()))},_attachHandlers:function(){var e=this._cancelProxy=M(this._cancel,this);this.wrapper.on(W+U,".k-grid-cancel",this._cancelProxy),this._saveProxy=M(this._save,this),this.wrapper.on(W+U,".k-grid-update",this._saveProxy),this.window.bind("close",function(t){t.userTriggered&&e(t)})},_dettachHandlers:function(){this._cancelProxy=null,this._saveProxy=null,this.wrapper.off(U)},_cancel:function(e){this.trigger(Z,e)},_save:function(){this.trigger(G)},open:function(){this.window.center().open()},close:function(){this.window.bind("deactivate",M(this.destroy,this)).close()},destroy:function(){this.window.destroy(),this.window=null,this._dettachHandlers(),h.fn.destroy.call(this)}}),p=S.extend({init:function(t,n){if(S.fn.init.call(this,t,n),we=kendo.support.isRtl(t),this._dataSource(this.options.dataSource),this._aria(),this._columns(),this._layout(),this._navigatable(),this._selectable(),this._sortable(),this._resizable(),this._filterable(),this._attachEvents(),this._toolbar(),this._scrollable(),this._reorderable(),this._columnMenu(),this._minScreenSupport(),this._draggable(),this.options.autoBind&&this.dataSource.fetch(),this._hasLockedColumns){var i=this;this.wrapper.addClass("k-grid-lockedcolumns"),this._resizeHandler=function(){i.resize()},e(window).on("resize"+U,this._resizeHandler)}kendo.notify(this)},_draggable:function(){var t=this.options.editable;t&&t.move&&(this._dragging=new kendo.ui.HierarchicalDragAndDrop(this.wrapper,{$angular:this.$angular,autoScroll:!0,filter:"tbody>tr",itemSelector:"tr",allowedContainers:this.wrapper,hintText:function(t){var n=function(){return e(this).text()},i="<span class='k-header k-drag-separator' />";return t.children("td").map(n).toArray().join(i)},contains:M(function(e,t){var n=this.dataItem(t),i=this.dataItem(e);return i==n||this.dataSource.contains(i,n)},this),itemFromTarget:function(e){var t=e.closest("tr");return{item:t,content:t}},dragstart:M(function(e){this.wrapper.addClass("k-treelist-dragging");var t=this.dataItem(e);return this.trigger(de,{source:t})},this),drag:M(function(e){e.source=this.dataItem(e.source),this.trigger(ue,e)},this),drop:M(function(e){return e.source=this.dataItem(e.source),e.destination=this.dataItem(e.destination),this.wrapper.removeClass("k-treelist-dragging"),this.trigger(he,e)},this),dragend:M(function(e){var t=this.dataItem(e.destination),n=this.dataItem(e.source);n.set("parentId",t?t.id:null),e.source=n,e.destination=t,this.trigger(fe,e)},this),reorderable:!1,dropHintContainer:function(e){return e.children("td:eq(1)")},dropPositionFrom:function(e){return e.prevAll(".k-i-none").length>0?"after":"before"}}))},itemFor:function(e){return"number"==typeof e&&(e=this.dataSource.get(e)),this.tbody.find("["+kendo.attr("uid")+"="+e.uid+"]")},_scrollable:function(){var t,n,i;this.options.scrollable&&(t=this.thead.closest(".k-grid-header-wrap"),n=e(this.lockedContent).bind("DOMMouseScroll"+U+" mousewheel"+U,M(this._wheelScroll,this)),this.content.bind("scroll"+U,function(){t.scrollLeft(this.scrollLeft),n.scrollTop(this.scrollTop)}),i=kendo.touchScroller(this.content),i&&i.movable&&(this._touchScroller=i,i.movable.bind("change",function(e){t.scrollLeft(-e.sender.x),n&&n.scrollTop(-e.sender.y)})))},_wheelScroll:function(t){var n,i;t.ctrlKey||(n=kendo.wheelDeltaY(t),i=e(t.currentTarget),n&&(i[0].scrollHeight>i[0].clientHeight&&(i[0].scrollTop<i[0].scrollHeight-i[0].clientHeight&&n<0||i[0].scrollTop>0&&n>0)&&t.preventDefault(),i.one("wheel"+U,!1),this.content.scrollTop(this.content.scrollTop()+-n)))},_progress:function(){var e=this.options.messages;this.tbody.find("tr").length||this._showStatus(kendo.template("<span class='#= className #' /> #: messages.loading #")({className:ke.icon+" "+ke.loading,messages:e}))},_error:function(e){this.dataSource.rootNodes().length||this._render({error:e})},refresh:function(t){var n,i,o;t=t||{},"itemchange"==t.action&&this.editor||this.trigger(Q)||(n=e(this.current()),i=!1,this._cancelEditor(),this._render(),this._adjustHeight(),this.options.navigatable&&((this._isActiveInTable()||this.editor)&&(i=n.is("th"),o=Math.max(this.cellIndex(n),0)),this._restoreCurrent(o,i)),this.trigger(X))},_angularFooters:function(e){var t,n,i,o=this.dataSource.aggregates(),r=this._footerItems();for(t=0;t<r.length;t++)n=r.eq(t),i=o[n.attr("data-parentId")],this._angularFooter(e,n.find("td").get(),i)},_angularFooter:function(e,t,n){var i=this.columns;this.angular(e,function(){return{elements:t,data:R(i,function(e){return{column:e,aggregate:n&&n[e.field]}})}})},items:function(){return this._hasLockedColumns?this._items(this.tbody).add(this._items(this.lockedTable)):this._items(this.tbody)},_items:function(t){return t.find("tr").filter(function(){return!e(this).hasClass(ke.footerTemplate)})},_footerItems:function(){var t=this.tbody;return this._hasLockedColumns&&(t=t.add(this.lockedTable)),t.find("tr").filter(function(){return e(this).hasClass(ke.footerTemplate)})},dataItems:function(){var e,t,n,i=kendo.ui.DataBoundWidget.fn.dataItems.call(this);if(this._hasLockedColumns){for(e=i.length,t=Array(2*e),n=e;--n>=0;)t[n]=t[n+e]=i[n];i=t}return i},_showStatus:function(t){var n=this.element.find(".k-status"),i=e(this.content).add(this.lockedContent);n.length||(n=e("<div class='k-status' />").appendTo(this.element)),this._contentTree.render([]),this._hasLockedColumns&&this._lockedContentTree.render([]),i.hide(),n.html(t)},_hideStatus:function(){this.element.find(".k-status").remove(),e(this.content).add(this.lockedContent).show()},_adjustHeight:function(){var e,t,n=this.element,i=n.find(V+ke.gridContentWrap),o=n.find(V+ke.gridHeader),r=n.find(V+ke.gridToolbar),s=kendo.support.scrollbar();n.css(ye,this.options.height),t=function(e){var t,n;return!!e[0].style.height||(t=e.height(),e.height("auto"),n=e.height(),e.height(""),t!=n)},t(n)&&(e=n.height()-x(o)-x(r),i.height(e),this._hasLockedColumns&&(s=this.table[0].offsetWidth>this.table.parent()[0].clientWidth?s:0,this.lockedContent.height(e-s)))},_resize:function(){this._applyLockedContainersWidth(),this._adjustHeight()},_minScreenSupport:function(){var t=this.hideMinScreenCols();t&&(this.minScreenResizeHandler=M(this.hideMinScreenCols,this),e(window).on("resize",this.minScreenResizeHandler))},hideMinScreenCols:function(){var e,n,i,o=this.columns,r=!1,s=window.innerWidth>0?window.innerWidth:screen.width;for(e=0;e<o.length;e++)n=o[e],i=n.minScreenWidth,i!==t&&null!==i&&(r=!0,i>s?this.hideColumn(n):this.showColumn(n));return r},destroy:function(){S.fn.destroy.call(this);var t=this.dataSource;t.unbind(H,this._refreshHandler),t.unbind(N,this._errorHandler),t.unbind(O,this._progressHandler),this._navigatableTables=null,this._current=null,this._resizeHandler&&e(window).off("resize"+U,this._resizeHandler),this._dragging&&(this._dragging.destroy(),this._dragging=null),this.resizable&&(this.resizable.destroy(),this.resizable=null),this.reorderable&&(this.reorderable.destroy(),this.reorderable=null),this._draggableInstance&&this._draggableInstance.element&&(this._draggableInstance.destroy(),this._draggableInstance=null),this.minScreenResizeHandler&&e(window).off("resize",this.minScreenResizeHandler),this._destroyEditor(),this.element.off(U),this._touchScroller&&this._touchScroller.destroy(),this._autoExpandable=null,this._refreshHandler=this._errorHandler=this._progressHandler=this._dataSourceFetchProxy=null,this.thead=this.content=this.tbody=this.table=this.element=this.lockedHeader=this.lockedContent=null,this._statusTree=this._headerTree=this._contentTree=this._lockedHeaderColsTree=this._lockedContentColsTree=this._lockedHeaderTree=this._lockedContentTree=null},options:{name:"TreeList",columns:[],autoBind:!0,scrollable:!0,selectable:!1,sortable:!1,toolbar:null,height:null,columnMenu:!1,messages:{noRows:"No records to display",loading:"Loading...",requestFailed:"Request failed.",retry:"Retry",commands:{edit:"Edit",update:"Update",canceledit:"Cancel",create:"Add new record",createchild:"Add child record",destroy:"Delete",excel:"Export to Excel",pdf:"Export to PDF"}},excel:{hierarchy:!0},resizable:!1,filterable:!1,editable:!1,reorderable:!1},events:[H,q,G,Y,$,K,Q,X,Z,de,ue,he,fe,ee,te,ne,oe,re,se,ae,le],_toggle:function(n,i){var o=e.Deferred().resolve().promise(),r=n.loaded();return n._error&&(n.expanded=!1,n._error=t),!r&&n.expanded?o:(t===i&&(i=!n.expanded),n.expanded=i,r||(o=this.dataSource.load(n).always(M(function(){this._render(),this._syncLockedContentHeight()},this))),this._render(),this._syncLockedContentHeight(),o)},expand:function(e){return this._toggle(this.dataItem(e),!0)},collapse:function(e){return this._toggle(this.dataItem(e),!1)},_toggleChildren:function(t){var n=e(t.currentTarget),i=this.dataItem(n),o=i.expanded?K:$;this.trigger(o,{model:i})||this._toggle(i),t.preventDefault()},_navigatable:function(){var t,n,i=this;i.options.navigatable&&(t=i.table.add(i.lockedTable),n=i.thead.parent().add(e(">table",i.lockedHeader)),i.options.scrollable&&(t=t.add(n),n.attr(J,-1)),this._navigatableTables=t,t.on(kendo.support.touch?"touchstart"+U:"mousedown"+U,pe+">:visible",M(i._tableClick,i)).on("focus"+U,M(i._tableFocus,i)).on("focusout"+U,M(i._tableBlur,i)).on("keydown"+U,M(i._tableKeyDown,i)))},cellIndex:function(t){var n=0;return this.lockedTable&&!e.contains(this.lockedTable[0],t[0])&&(n=this.lockedColumns(this.columns).length),e(t).parent().children("td:visible").index(t)+n},_isActiveInTable:function(){var t=kendo._activeElement();return!!t&&(this.table[0]===t||e.contains(this.table[0],t)||this.lockedTable&&(this.lockedTable[0]===t||e.contains(this.lockedTable[0],t)))},_restoreCurrent:function(n,i){var o,r,s;n===t||n<0||(this._current&&this._current.removeClass("k-state-focused"),i?this.current(this.thead.find("th").eq(n)):(o=0,n=0,r=e(),this.lockedTable&&(r=this.lockedTable.find(">tbody>tr:visible").eq(o)),r=r.add(this.tbody.children().eq(o)),s=r.find(">td:visible").eq(n),this.current(s)),this._current&&d(this._current.closest("table")[0],!0))},current:function(t){var n=this._current;return t=e(t),!t.length||n&&n[0]===t[0]||(this._updateCurrentAttr(n,t),this._scrollCurrent()),this._current},_scrollCurrent:function(){var t,n,i,o,r,s=this._current,a=this.options.scrollable;s&&a&&(t=s.parent(),n=t.closest("table").parent(),i=n.is(".k-grid-content-locked,.k-grid-header-locked"),o=n.is(".k-grid-content-locked,.k-grid-content"),r=e(this.content)[0],o&&this._scrollTo(this._relatedRow(t)[0],r),this.lockedContent&&(this.lockedContent[0].scrollTop=r.scrollTop),i||this._scrollTo(s[0],r))},_scrollTo:function(t,n){var i,o=t.tagName.toLowerCase(),r="td"===o||"th"===o,s=t[r?"offsetLeft":"offsetTop"],a=t[r?"offsetWidth":"offsetHeight"],l=n[r?"scrollLeft":"scrollTop"],c=n[r?"clientWidth":"clientHeight"],d=s+a,u=0,h=0,f=0;we&&r&&(i=e(t).closest("table")[0],I.msie?h=i.offsetLeft:I.mozilla&&(f=i.offsetLeft-kendo.support.scrollbar())),l=Math.abs(l+h-f),u=l>s?s:d>l+c?a<=c?d-c:s:l,u=Math.abs(u+h)+f,n[r?"scrollLeft":"scrollTop"]=u},_aria:function(){var e=this.element.attr("id")||"aria";e&&(this._elementId=e+"_active_element")},_verticalContainer:function(e,t){var n=this._navigatableTables.length,i=Math.floor(n/2),o=z(e[0],this._navigatableTables);return t&&(i*=-1),o+=i,(o>=0||o<n)&&(e=this._navigatableTables.eq(o)),e.find(t?"thead":"tbody")},_updateCurrentAttr:function(t,n){var i=e(t).data("headerId");e(t).removeClass(ke.focused).closest("table").removeAttr("aria-activedescendant"),i?(i=i.replace(this._elementId,""),e(t).attr("id",i)):e(t).removeAttr("id"),n.data("headerId",n.attr("id")).attr("id",this._elementId).addClass(ke.focused).closest("table").attr("aria-activedescendant",this._elementId),this._current=n},_tableKeyDown:function(t){var n=!1,i=this.current(),o=e(t.target),r=!t.isDefaultPrevented()&&!o.is(":button,a,:input,a>.k-icon");i=i?i:e(this.lockedTable).add(this.table).find(ve),r&&t.keyCode==k.UP&&(n=this._moveUp(i)),r&&t.keyCode==k.DOWN&&(n=this._moveDown(i)),r&&t.keyCode==(we?k.LEFT:k.RIGHT)&&(n=t.altKey?this._handleExpand(i):this._moveRight(i)),r&&t.keyCode==(we?k.RIGHT:k.LEFT)&&(n=t.altKey?this._handleCollapse(i):this._moveLeft(i)),t.keyCode!=k.ENTER&&t.keyCode!=k.F2||(n=this._handleEnterKey(i,t.currentTarget,o)),t.keyCode==k.ESC&&(n=this._handleEscKey(i,t.currentTarget)),r&&t.keyCode==k.HOME&&(n=this._handleHome(i,t.ctrlKey)),r&&t.keyCode==k.END&&(n=this._handleEnd(i,t.ctrlKey)),n&&(t.preventDefault(),t.stopPropagation())},_handleExpand:function(e){var t=this,n=e.parent(),i=t.dataItem(n);return!e.hasClass("k-header")&&(!(!i||!i.hasChildren||i.expanded||t.trigger($,{model:i}))&&(this.expand(n),!0))},_handleCollapse:function(e){var t=this,n=e.parent(),i=t.dataItem(n);return!e.hasClass("k-header")&&(!(!(i&&i.hasChildren&&i.expanded)||t.trigger(K,{model:i}))&&(t.collapse(n),!0))},_handleHome:function(e,t){var n,i=e.parent(),o=i.parent(),r=this.lockedTable&&this.lockedTable.children("tbody")[0]===o[0],s=o[0]===this.tbody[0];if(t?n=this.lockedTable?this.lockedTable.find(ve):this.table.find(ve):(s||r)&&(s&&this.lockedTable&&(i=this._relatedRow(i)),n=i.children(me+":first")),n&&n.length)return this.current(n),!0},_handleEnd:function(e,t){var n,i=e.parent(),o=i.parent(),r=this.lockedTable&&this.lockedTable.children("tbody")[0]===o[0],s=o[0]===this.tbody[0];if(t?n=this.table.find(_e+">"+me+":last"):(s||r)&&(!s&&this.lockedTable&&(i=this._relatedRow(i)),n=i.children(me+":last")),n&&n.length)return this.current(n),!0},_handleEscKey:function(t,n){var i,o=kendo._activeElement();return t&&t.parent().hasClass("k-grid-edit-row")?(i=e(t).parent().index(),o&&o.blur(),this.cancelRow(),i>=0&&this.current(this.items().eq(i).children(me).first()),I.msie&&I.version<9&&document.body.focus(),d(n,!0),!0):!!t.has(o).length&&(d(n,!0),!0)},_handleEnterKey:function(t,n,i){var o,r=this.options.editable,s=i.closest("[role=gridcell]");return i.is("table")||e.contains(t[0],i[0])||(t=s),t.is("th")?(t.find(".k-link").click(),!0):(o=t.find(":kendoFocusable:first"),o[0]&&t.hasClass("k-state-focused")?(o.focus(),!0):!(!r||i.is(":button,.k-button,textarea"))&&(s[0]||(s=t),this._handleEditing(s,!1,n),!0))},_handleEditing:function(n,i,o){var r,s,a,l,c=this,u=e(kendo._activeElement()),h=I.msie;if(o=e(o),a=n.parent().hasClass("k-grid-edit-row"),c.editor){if(r=c.editor.wrapper,r&&e.contains(r[0],u[0])&&(I.opera?u.blur().change().triggerHandler("blur"):(u.blur(),h&&u.blur())),!c.editor)return d(o),t;if(!c.editor.end())return c.current(r.children().filter(me).first()),s=r.find(":kendoFocusable:first")[0],s&&s.focus(),t;c.saveRow(),a=!0}i&&c.current(i),d(o,!0),c.options.editable&&(!a&&!i||i)&&(l=c.current().index(),c.editRow(c.current().parent()),c.current(c.editor.wrapper.children().eq(l)),c.current().removeClass("k-state-focused"))},_moveRight:function(e){var t=e.nextAll(me).first(),n=e.parent();return e.hasClass("k-header")&&(t=e.next(ge),!t[0]&&this.lockedTable&&e.closest("table")[0]===this.lockedHeader.find("table")[0]&&(t=this.thead.find(ge+":first"))),!t[0]&&this.lockedTable&&e.closest("table")[0]===this.lockedTable[0]&&(t=this._relatedRow(n).children(me).first()),t[0]&&t[0]!==e[0]&&d(t.closest("table"),!0),this.current(t),!0},_moveLeft:function(e){var t=e.prevAll(me).first(),n=e.parent();return e.hasClass("k-header")&&(t=e.prev(ge),!t[0]&&this.lockedTable&&e.closest("table")[0]===this.thead.parent()[0]&&(t=this.lockedHeader.find(">table>thead>tr>"+ge+":last"))),!t[0]&&this.lockedTable&&e.closest("table")[0]===this.table[0]&&(t=this._relatedRow(n).children(me).last()),t[0]&&t[0]!==e[0]&&d(t.closest("table"),!0),this.current(t),!0},_moveUp:function(e){var t,n,i=e.parent(),o=i.prevAll(pe+":first");return o[0]?t=o.children().eq(e.index()):(n=this._verticalContainer(e.closest("table"),!0),t=n.find(be).eq(e.siblings(":visible").addBack().index(e)),t[0]&&d(t.closest("table"),!0)),this.current(t),!0},_moveDown:function(e){var t,n,i=e.parent(),o=i.nextAll(pe+":first");return o[0]?t=o.children().eq(e.index()):(n=this._verticalContainer(e.closest("table")),t=n.find(me).eq(e.siblings(":visible").addBack().index(e)),t[0]&&d(t.closest("table"),!0)),this.current(t),!0},_tableClick:function(t){var n=e(t.currentTarget),i=n.is("th"),o=this.table.add(this.lockedTable),r=this.thead.parent().add(e(">table",this.lockedHeader)),s=c(t.target),a=n.closest("table")[0];kendo.support.touch||a!==o[0]&&a!==o[1]&&a!==r[0]&&a!==r[1]||(this.options.navigatable&&this.current(n),!i&&s||setTimeout(function(){c(kendo._activeElement())&&e.contains(a,kendo._activeElement())||d(a,!0)}),i&&t.preventDefault())},_setTabIndex:function(e){this._navigatableTables.attr(J,-1),e.attr(J,0)},_tableFocus:function(t){var n=this.current(),i=e(t.currentTarget);n&&n.is(":visible")?n.addClass(ke.focused):this.current(i.find(ve)),this._setTabIndex(i)},_tableBlur:function(){var e=this.current();e&&e.removeClass(ke.focused)},_attachEvents:function(){var e=V+ke.iconCollapse+", ."+ke.iconExpand+", ."+ke.refresh,t=V+ke.retry;this.element.on(j+U,e,M(this._toggleChildren,this)).on(W+U,t,this._dataSourceFetchProxy).on(W+U,".k-button[data-command]",M(this._commandClick,this))},_commandByName:function(t){var n,i,o,r,s=this.columns,a=e.isArray(this.options.toolbar)?this.options.toolbar:[];if(t=t.toLowerCase(),xe[t])return xe[t];for(n=0;n<s.length;n++)if(o=s[n].command)for(i=0;i<o.length;i++)if(r=o[i].name,r&&r.toLowerCase()==t)return o[i];for(n=0;n<a.length;n++)if(r=a[n].name,r&&r.toLowerCase()==t)return a[n]},_commandClick:function(n){var i=e(n.currentTarget),o=i.attr("data-command"),r=this._commandByName(o),s=i.parentsUntil(this.wrapper,"tr");s=s.length?s:t,r&&(r.methodName?this[r.methodName](s):r.click&&r.click.call(this,n),n.preventDefault())},_ensureExpandableColumn:function(){var e,t;this._autoExpandable&&delete this._autoExpandable.expandable,e=F(this.columns,i(n("hidden"))),t=F(e,n("expandable")),this.columns.length&&!t.length&&(this._autoExpandable=e[0],e[0].expandable=!0)},_columns:function(){var e,t=this.options.columns||[];this.columns=R(t,function(e){return e="string"==typeof e?{field:e}:e,g({encoded:!0},e)}),e=this._lockedColumns(),e.length>0&&(this._hasLockedColumns=!0,this.columns=e.concat(this._nonLockedColumns())),this._ensureExpandableColumn(),this._columnTemplates(),this._columnAttributes()},_columnTemplates:function(){var e,t,n,i=this.columns;for(e=0,t=i.length;e<t;e++)n=i[e],n.template&&(n.template=kendo.template(n.template)),n.headerTemplate&&(n.headerTemplate=kendo.template(n.headerTemplate)),n.footerTemplate&&(n.footerTemplate=kendo.template(n.footerTemplate))},_columnAttributes:function(){function t(t){var n,i,o,r;if(t&&t.style)for(n=t.style.split(";"),t.style={},i=0;i<n.length;i++)o=n[i].split(":"),r=e.trim(o[0]),r&&(t.style[e.camelCase(r)]=e.trim(o[1]))}var n,i,o=this.columns;for(n=0,i=o.length;n<i;n++)t(o[n].attributes),t(o[n].headerAttributes)},_layout:function(){var e,t,n,i=this.columns,o=this.element,r="";this.wrapper=o.addClass(ke.wrapper),r="<div class='#= gridHeader #'>",this._hasLockedColumns&&(r+="<div class='k-grid-header-locked'><table role='grid'><colgroup></colgroup><thead role='rowgroup' /></table></div>"),r+="<div class='#= gridHeaderWrap #'><table role='grid'><colgroup></colgroup><thead role='rowgroup' /></table></div></div>",this._hasLockedColumns&&(r+="<div class='k-grid-content-locked'><table role='treegrid' tabindex='0'><colgroup></colgroup><tbody /></table></div>"),r+="<div class='#= gridContentWrap # k-auto-scrollable'><table role='treegrid' tabindex='0'><colgroup></colgroup><tbody /></table></div>",this.options.scrollable||(r="<table role='treegrid' tabindex='0'><colgroup></colgroup><thead class='#= gridHeader #' role='rowgroup' /><tbody /></table>"),this.options.toolbar&&(r="<div class='#= header # #= gridToolbar #' />"+r),o.append(kendo.template(r)(ke)+"<div class='k-status' />"),this.toolbar=o.find(V+ke.gridToolbar),e=o.find(V+ke.gridHeader).find("thead").addBack().filter("thead"),this.thead=e.last(),this.options.scrollable&&(t=kendo.support.isRtl(o),o.find("div."+ke.gridHeader).css(t?"padding-left":"padding-right",kendo.support.scrollbar())),n=o.find(V+ke.gridContentWrap),n.length?this.content=n:n=o,this.table=n.find(">table"),this.tbody=this.table.find(">tbody"),this._hasLockedColumns&&(this.lockedHeader=e.first().closest(".k-grid-header-locked"),this.lockedContent=o.find(".k-grid-content-locked"),this.lockedTable=this.lockedContent.children()),this._initVirtualTrees(),this._renderCols(),this._renderHeader(),this.angular("compile",function(){return{elements:e.find("th.k-header").get(),data:R(i,function(e){return{column:e}})}})},_initVirtualTrees:function(){this._headerColsTree=new v.Tree(this.thead.prev()[0]),this._contentColsTree=new v.Tree(this.tbody.prev()[0]),this._headerTree=new v.Tree(this.thead[0]),this._contentTree=new v.Tree(this.tbody[0]),this._statusTree=new v.Tree(this.element.children(".k-status")[0]),this.lockedHeader&&(this._lockedHeaderColsTree=new v.Tree(this.lockedHeader.find("colgroup")[0]),this._lockedContentColsTree=new v.Tree(this.lockedTable.find(">colgroup")[0]),this._lockedHeaderTree=new v.Tree(this.lockedHeader.find("thead")[0]),this._lockedContentTree=new v.Tree(this.lockedTable.find(">tbody")[0]))},_toolbar:function(){var t,n=this.options.toolbar,i=this.toolbar;n&&(e.isArray(n)?(t=this._buildCommands(n),new v.Tree(i[0]).render(t)):i.append(kendo.template(n)({})),this.angular("compile",function(){return{elements:i.get()}}))},_lockedColumns:function(){return F(this.columns,n("locked"))},_nonLockedColumns:function(){return F(this.columns,i(n("locked")))},_templateColumns:function(){return F(this.columns,n("template"))},_flushCache:function(){this.options.$angular&&this._templateColumns().length&&(this._contentTree.render([]),this._hasLockedColumns&&this._lockedContentTree.render([]))},_render:function(t){var n,i,o,r;t=t||{},n=this.options.messages,i=this.dataSource.rootNodes(),o=kendo.attr("uid"),r=this.select().removeClass("k-state-selected").map(function(t,n){return e(n).attr(o)}),this._absoluteIndex=0,this._angularItems("cleanup"),this._angularFooters("cleanup"),this._flushCache(),t.error?this._showStatus(kendo.template("#: messages.requestFailed # <button class='#= buttonClass #'>#: messages.retry #</button>")({buttonClass:[ke.button,ke.retry].join(" "),messages:n})):i.length?(this._hideStatus(),this._contentTree.render(this._trs({columns:this._nonLockedColumns(),aggregates:t.aggregates,selected:r,data:i,visible:!0,level:0})),this._hasLockedColumns&&(this._absoluteIndex=0,this._lockedContentTree.render(this._trs({columns:this._lockedColumns(),aggregates:t.aggregates,selected:r,data:i,visible:!0,level:0})))):this._showStatus(kendo.htmlEncode(n.noRows)),this._touchScroller&&this._touchScroller.contentResized(),this._muteAngularRebind(function(){this._angularItems("compile"),this._angularFooters("compile")}),this.items().filter(function(){return e.inArray(e(this).attr(o),r)>=0}).addClass("k-state-selected"),this._adjustRowsHeight()},_adjustRowsHeight:function(){var e,t,n,i,o,r,s,a,l,c,d,u,h,f;if(this._hasLockedColumns){for(e=this.table,t=this.lockedTable,n=e[0].rows,i=n.length,r=t[0].rows,s=e.add(t),a=s.length,l=[],c=this.lockedHeader.find("tr"),d=this.thead.find("tr"),c.add(d).height("auto").height(Math.max(c.height(),d.height())),o=0;o<i&&r[o];o++)n[o].style.height&&(n[o].style.height=r[o].style.height="");for(o=0;o<i&&r[o];o++)u=n[o].offsetHeight,h=r[o].offsetHeight,f=0,u>h?f=u:u<h&&(f=h),l.push(f);for(o=0;o<a;o++)s[o].style.display="none";for(o=0;o<i;o++)l[o]&&(n[o].style.height=r[o].style.height=l[o]+1+"px");for(o=0;o<a;o++)s[o].style.display=""}},_ths:function(e){var t,n,i,o,r,s,a,l,c=[];for(a=0,l=e.length;a<l;a++)t=e[a],i=[],o=[ke.header],n=t.headerTemplate?t.headerTemplate({}):t.title||t.field||"",s=t.headerTemplate?w(n):b(n),i.push(t.sortable?_("a",{href:"#",className:ke.link},[s]):s),r={"data-field":t.field,"data-title":t.title,style:t.hidden===!0?{display:"none"}:{},className:o.join(" "),role:"columnheader"},r=g(!0,{},r,t.headerAttributes),c.push(_("th",r,i));return c},_cols:function(e){var t,n,i,o=[];for(i=0;i<e.length;i++)e[i].hidden!==!0&&(t=e[i].width,n={},t&&0!==parseInt(t,10)&&(n.style={width:"string"==typeof t?t:t+"px"}),o.push(_("col",n)));return o},_renderCols:function(){var e=this._nonLockedColumns();this._headerColsTree.render(this._cols(e)),this.options.scrollable&&this._contentColsTree.render(this._cols(e)),this._hasLockedColumns&&(e=this._lockedColumns(),this._lockedHeaderColsTree.render(this._cols(e)),this._lockedContentColsTree.render(this._cols(e)))},_renderHeader:function(){var e=this._nonLockedColumns();this._headerTree.render([_("tr",{role:"row"},this._ths(e))]),this._hasLockedColumns&&(e=this._lockedColumns(),this._lockedHeaderTree.render([_("tr",{role:"row"},this._ths(e))]),this._applyLockedContainersWidth())},_applyLockedContainersWidth:function(){var e,t,n,i,o,r;this._hasLockedColumns&&(e=a(this.lockedHeader.find(">table>colgroup>col")),t=this.thead.parent(),n=a(t.find(">colgroup>col")),i=this.wrapper[0].clientWidth,o=kendo.support.scrollbar(),e>=i&&(e=i-3*o),this.lockedHeader.add(this.lockedContent).width(e),t.add(this.table).width(n),r=i-e-2,this.content.width(r),t.parent().width(r-o))},_trs:function(t){var n,i,o,r,s,a,l,c=[],d=t.level,u=t.data,h=this.dataSource,f=h.aggregates()||{},p=t.columns;
for(a=0,l=u.length;a<l;a++)o=[],n=u[a],s=n.loaded()&&h.childNodes(n),r=s&&s.length,i={role:"row"},i[kendo.attr("uid")]=n.uid,r&&(i["aria-expanded"]=!!n.expanded),t.visible?(this._absoluteIndex%2!==0&&o.push(ke.alt),this._absoluteIndex++):i.style={display:"none"},e.inArray(n.uid,t.selected)>=0&&o.push(ke.selected),r&&o.push(ke.group),n._edit&&o.push("k-grid-edit-row"),i.className=o.join(" "),c.push(this._tds({model:n,attr:i,level:d},p,M(this._td,this))),r&&(c=c.concat(this._trs({columns:p,aggregates:f,selected:t.selected,visible:t.visible&&!!n.expanded,data:s,level:d+1})));return this._hasFooterTemplate()&&(i={className:ke.footerTemplate,"data-parentId":n.parentId},t.visible||(i.style={display:"none"}),c.push(this._tds({model:f[n.parentId],attr:i,level:d},p,this._footerTd))),c},_footerTd:function(t){var n=[],i=t.column,o=t.column.footerTemplate||e.noop,r=t.model[i.field]||{},a={role:"gridcell",style:i.hidden===!0?{display:"none"}:{}};return i.expandable&&(n=n.concat(s({level:t.level+1,className:ke.iconPlaceHolder}))),i.attributes&&g(a,i.attributes),n.push(w(o(r)||"")),_("td",a,n)},_hasFooterTemplate:function(){return!!F(this.columns,function(e){return e.footerTemplate}).length},_tds:function(e,t,n){var i,o,r,s=[];for(o=0,r=t.length;o<r;o++)i=t[o],s.push(n({model:e.model,column:i,level:e.level}));return _("tr",e.attr,s)},_td:function(e){var t,n=[],i=e.model,o=e.column,r={role:"gridcell",style:o.hidden===!0?{display:"none"}:{}};return o.attributes&&g(!0,r,o.attributes),i._edit&&o.field&&i.editable(o.field)?r[kendo.attr("container-for")]=o.field:(o.expandable&&(n=s({level:e.level,className:ke.iconPlaceHolder}),t=[ke.icon],t.push(i.hasChildren?i.expanded?ke.iconCollapse:ke.iconExpand:ke.iconHidden),i._error?t.push(ke.refresh):!i.loaded()&&i.expanded&&t.push(ke.loading),n.push(_("span",{className:t.join(" ")})),r.style["white-space"]="nowrap"),o.command?(r.className&&r.className.indexOf("k-command-cell")!==-1?r.className+=" k-command-cell":r.className||(r.className="k-command-cell"),n=this._buildCommands(i._edit?["update","canceledit"]:o.command)):n.push(this._cellContent(o,i))),_("td",r,n)},_cellContent:function(e,n){var i;return e.template?i=e.template(n):e.field&&(i=n.get(e.field),null!==i&&e.format&&(i=kendo.format(e.format,i))),null!==i&&t!==i||(i=""),e.template||!e.encoded?w(i):b(i)},_buildCommands:function(e){var t,n=[];for(t=0;t<e.length;t++)n.push(this._button(e[t]));return n},_button:function(e){var t=(e.name||e).toLowerCase(),n=this.options.messages.commands[t],i=[];return e=g({},xe[t],{text:n},e),e.imageClass&&i.push(_("span",{className:["k-icon",e.imageClass].join(" ")})),_("button",{type:"button","data-command":t,className:["k-button k-button-icontext",e.className].join(" ")},i.concat([b(e.text||e.name)]))},_positionResizeHandle:function(n){var i,o,r,s=e(n.currentTarget),a=this.resizeHandle,l=s.position(),c=l.left,d=y(s),u=s.closest("div"),h=n.clientX+e(window).scrollLeft(),f=this.options.columnResizeHandleWidth||3;return c+=u.scrollLeft(),a||(a=this.resizeHandle=e('<div class="k-resize-handle"><div class="k-resize-handle-inner" /></div>')),i=s.offset().left+d,(o=h>i-f&&h<i+f)?(u.append(a),a.show().css({top:l.top,left:c+d-f-1,height:x(s),width:3*f}).data("th",s),r=this,a.off("dblclick"+U).on("dblclick"+U,function(){var t=s.index();e.contains(r.thead[0],s[0])&&(t+=F(r.columns,function(e){return e.locked&&!e.hidden}).length),r.autoFitColumn(t)}),t):(a.hide(),t)},autoFitColumn:function(t){var n,i,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,k=this,x=k.options,C=k.columns,S=kendo.support.browser,T=k.lockedHeader?r(k.lockedHeader.find(">table>thead")).filter(o).length:0;if(t="number"==typeof t?C[t]:P(t)?F(C,function(e){return e===t})[0]:F(C,function(e){return e.field===t})[0],t&&!t.hidden){for(n=z(t,C),a=t.locked,s=a?k.lockedHeader.children("table"):k.thead.parent(),i=s.find("[data-index='"+n+"']"),c=a?k.lockedTable:k.table,d=k.footer||e(),k.footer&&k.lockedContent&&(d=k.footer.children(a?".k-grid-footer-locked":".k-grid-footer-wrap")),u=d.find("table").first(),k.lockedHeader&&T>=n&&!a&&(n-=T),h=0;h<C.length&&C[h]!==t;h++)C[h].hidden&&n--;if(l=x.scrollable?s.find("col:not(.k-group-col):not(.k-hierarchy-col):eq("+n+")").add(c.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq("+n+")")).add(u.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq("+n+")")):c.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq("+n+")"),f=s.add(c).add(u),p=y(i),l.width(""),f.css("table-layout","fixed"),l.width("auto"),f.addClass("k-autofitting"),f.css("table-layout",""),m=Math.ceil(Math.max(y(i),y(c.find("tr").eq(0).children("td:visible").eq(n)),y(u.find("tr").eq(0).children("td:visible").eq(n)))),l.width(m),t.width=m,x.scrollable){for(g=s.find("col"),_=0,b=0,w=g.length;b<w;b+=1){if(v=g[b].style.width,!v||v.indexOf("%")!=-1){_=0;break}_+=parseInt(v,10)}_&&f.each(function(){this.style.width=_+"px"})}S.msie&&8==S.version&&(f.css("display","inline-table"),setTimeout(function(){f.css("display","table")},1)),f.removeClass("k-autofitting"),k.trigger(re,{column:t,oldWidth:p,newWidth:m}),k._applyLockedContainersWidth(),k._syncLockedContentHeight(),k._syncLockedHeaderHeight()}},_adjustLockedHorizontalScrollBar:function(){var e=this.table,t=e.parent(),n=e[0].offsetWidth>t[0].clientWidth?kendo.support.scrollbar():0;this.lockedContent.height(t.height()-n)},_syncLockedContentHeight:function(){this.lockedTable&&(this._touchScroller||this._adjustLockedHorizontalScrollBar(),this._adjustRowsHeight(this.table,this.lockedTable))},_syncLockedHeaderHeight:function(){var e,t;this.lockedHeader&&(e=this.lockedHeader.children("table"),t=this.thead.parent(),this._adjustRowsHeight(e,t),l(e,t))},_resizable:function(){if(this.options.resizable){this.resizable&&this.resizable.destroy();var t=this;e(this.lockedHeader).find("thead").add(this.thead).on("mousemove"+U,"th",e.proxy(this._positionResizeHandle,this)),this.resizable=new kendo.ui.Resizable(this.wrapper,{handle:".k-resize-handle",start:function(n){var i,o,r=e(n.currentTarget).data("th"),s="col:eq("+e.inArray(r[0],r.parent().children().filter(":visible"))+")";t.wrapper.addClass("k-grid-column-resizing"),t.lockedHeader&&e.contains(t.lockedHeader[0],r[0])?(i=t.lockedHeader,o=t.lockedTable):(i=t.thead.parent(),o=t.table),this.col=o.children("colgroup").find(s).add(i.find(s)),this.th=r,this.startLocation=n.x.location,this.columnWidth=y(r),this.table=this.col.closest("table"),this.totalWidth=this.table.width()},resize:function(e){var t=11,n=e.x.location-this.startLocation;this.columnWidth+n<t&&(n=t-this.columnWidth),this.table.width(this.totalWidth+n),this.col.width(this.columnWidth+n)},resizeend:function(){var e,n,i;t.wrapper.removeClass("k-grid-column-resizing"),e=this.th.attr("data-field"),n=F(t.columns,function(t){return t.field==e}),i=Math.floor(y(this.th)),n[0].width=i,t._resize(),t._adjustRowsHeight(),t.trigger(re,{column:n,oldWidth:this.columnWidth,newWidth:i}),this.table=this.col=this.th=null}})}},_sortable:function(){var t,n,i,o,r,s=this.columns,a=e(this.lockedHeader).add(this.thead).find("th"),l=kendo.attr("field"),c=this.options.sortable;if(c)for(o=0,r=a.length;o<r;o++)t=s[o],t.sortable!==!1&&!t.command&&t.field&&(i=a.eq(o),n=i.data("kendoColumnSorter"),n&&n.destroy(),i.attr(l,t.field).kendoColumnSorter(g({},c,t.sortable,{dataSource:this.dataSource})))},_filterable:function(){var t,n,i,o,r,s,a=e(this.lockedHeader).add(this.thead).find("th"),l=this.options.filterable;if(l&&!this.options.columnMenu)for(s=M(function(e){this.trigger(ee,{field:e.field,container:e.container})},this),t=0,n=a.length;t<n;t++)i=this.columns[t],o=a.eq(t),r=o.data("kendoFilterMenu"),r&&r.destroy(),i.command||i.filterable===!1||o.kendoFilterMenu(g(!0,{},l,i.filterable,{dataSource:this.dataSource,init:s}))},_change:function(){this.trigger(H)},_isLocked:function(){return null!==this.lockedHeader},_selectable:function(){var n,i,o,r,s=this,a=this.options.selectable,l=this.table,c=s._isLocked();a&&(a=kendo.ui.Selectable.parseOptions(a),this._hasLockedColumns&&(l=l.add(this.lockedTable),i=a.multiple&&a.cell),n=">tbody>tr:not(.k-footer-template)",a.cell&&(n+=">td"),this.selectable=new kendo.ui.Selectable(l,{filter:n,aria:!0,multiple:a.multiple,change:M(this._change,this),useAllItems:i,continuousItems:M(this._continuousItems,this,n,a.cell),relatedTarget:!a.cell&&this._hasLockedColumns?M(this._selectableTarget,this):t}),s.options.navigatable&&(o=a.multiple,r=a.cell,l.on("keydown"+U,function(n){var i=s.current(),a=n.target;if(n.keyCode===k.SPACEBAR&&!n.shiftKey&&e.inArray(a,l)>-1&&!i.is(".k-header")){if(n.preventDefault(),n.stopPropagation(),i=r?i:i.parent(),c&&!r&&(i=i.add(s._relatedRow(i))),o)if(n.ctrlKey){if(i.hasClass(ke.selected))return i.removeClass(ke.selected),s.trigger(H),t}else s.selectable.clear();else s.selectable.clear();r||(s.selectable._lastActive=i),s.selectable.value(i)}else!r&&(n.shiftKey&&n.keyCode==k.LEFT||n.shiftKey&&n.keyCode==k.RIGHT||n.shiftKey&&n.keyCode==k.UP||n.shiftKey&&n.keyCode==k.DOWN||n.keyCode===k.SPACEBAR&&n.shiftKey)&&(n.preventDefault(),n.stopPropagation(),i=i.parent(),c&&(i=i.add(s._relatedRow(i))),o?(s.selectable._lastActive||(s.selectable._lastActive=i),s.selectable.selectRange(s.selectable._firstSelectee(),i)):(s.selectable.clear(),s.selectable.value(i)))})))},_continuousItems:function(t,n){var i,o,r,s,a,l;if(this.lockedContent){for(i=e(t,this.lockedTable),o=e(t,this.table),r=n?this._lockedColumns().length:1,s=n?this.columns.length-r:1,a=[],l=0;l<i.length;l+=r)B.apply(a,i.slice(l,l+r)),B.apply(a,o.splice(0,s));return a}},_selectableTarget:function(t){var n,i,o,r=e();for(i=0,o=t.length;i<o;i++)n=this._relatedRow(t[i]),z(n[0],t)<0&&(r=r.add(n));return r},_relatedRow:function(t){var n,i,o=this.lockedTable;return t=e(t),o?(n=t.closest(this.table.add(this.lockedTable)),i=n.find(">tbody>tr").index(t),n=n[0]===this.table[0]?o:this.table,n.find(">tbody>tr").eq(i)):t},select:function(n){var i=this.selectable;return i?(t!==n&&(i.options.multiple||(i.clear(),n=n.first()),this._hasLockedColumns&&(n=n.add(e.map(n,M(this._relatedRow,this))))),i.value(n)):e()},clearSelection:function(){var e=this.select();e.length&&(this.selectable.clear(),this.trigger(H))},_dataSource:function(e){var t=this.dataSource;t&&(t.unbind(H,this._refreshHandler),t.unbind(N,this._errorHandler),t.unbind(O,this._progressHandler)),this._refreshHandler=M(this.refresh,this),this._errorHandler=M(this._error,this),this._progressHandler=M(this._progress,this),t=this.dataSource=u.create(e),t.bind(H,this._refreshHandler),t.bind(N,this._errorHandler),t.bind(O,this._progressHandler),this._dataSourceFetchProxy=M(function(){this.dataSource.fetch()},this)},setDataSource:function(e){this._dataSource(e),this._sortable(),this._filterable(),this._contentTree.render([]),this.options.autoBind&&this.dataSource.fetch()},dataItem:function(t){var n,i;return t instanceof Ce?t:(n=e(t).closest("tr"),i=this.dataSource.getByUid(n.attr(kendo.attr("uid"))))},editRow:function(e){var t;typeof e===L&&(e=this.tbody.find(e)),t=this.dataItem(e),t&&("popup"!=this._editMode()&&(t._edit=!0),this._cancelEditor(),this._render(),this._createEditor(t),this.trigger(q,{container:this.editor.wrapper,model:t}))},_cancelEdit:function(t){if(this.editor){var n;t=g(t,{container:this.editor.wrapper,model:this.editor.model}),this.trigger(Z,t)||(this.options.navigatable&&(n=this.items().index(e(this.current()).parent())),this.cancelRow(),this.options.navigatable&&(this.current(this.items().eq(n).children().filter(me).first()),d(this.table,!0)))}},cancelRow:function(){this._cancelEditor(),this._render()},saveRow:function(){var e,t=this.editor;t&&(e={model:t.model,container:t.wrapper},t.end()&&!this.trigger(G,e)&&this.dataSource.sync())},addRow:function(e){var n=this.editor,i=0,o={};if(!n||n.end())return e?(e instanceof Ce||(e=this.dataItem(e)),o[e.parentIdField]=e.id,i=this.dataSource.indexOf(e)+1,this.expand(e).then(M(this._insertAt,this,o,i)),t):(this._insertAt(o,i),t)},_insertAt:function(e,t){e=this.dataSource.insert(t,e);var n=this.itemFor(e);this.editRow(n)},removeRow:function(e){var t=this.dataItem(e),n={model:t,row:e};t&&!this.trigger(Y,n)&&(this.dataSource.remove(t),this.dataSource.sync())},_cancelEditor:function(){var e,t=this.editor;t&&(e=t.model,this._destroyEditor(),this.dataSource.cancelChanges(e),e._edit=!1)},_destroyEditor:function(){this.editor&&(this.editor.close(),this.editor=null)},_createEditor:function(e){var t,n,i=this.itemFor(e);i=i.add(this._relatedRow(i)),t=this._editMode(),n={columns:this.columns,model:e,target:this,clearContainer:!1,template:this.options.editable.template},"inline"==t?this.editor=new h(i,n):(g(n,{window:this.options.editable.window,commandRenderer:M(function(){return this._buildCommands(["update","canceledit"])},this),fieldRenderer:this._cellContent,save:M(this.saveRow,this),cancel:M(this._cancelEdit,this),appendTo:this.wrapper}),this.editor=new f(i,n))},_editMode:function(){var e="inline",t=this.options.editable;return t!==!0&&(e="string"==typeof t?t:t.mode||e),e.toLowerCase()},hideColumn:function(e){this._toggleColumnVisibility(e,!0)},showColumn:function(e){this._toggleColumnVisibility(e,!1)},_toggleColumnVisibility:function(e,t){e=this._findColumn(e),e&&e.hidden!==t&&(e.hidden=t,this._ensureExpandableColumn(),this._renderCols(),this._renderHeader(),this._render(),this._adjustTablesWidth(),this.trigger(t?te:ne,{column:e}),t||e.width||this.table.add(this.thead.closest("table")).width(""))},_findColumn:function(e){return e="number"==typeof e?this.columns[e]:P(e)?F(this.columns,function(t){return t===e})[0]:F(this.columns,function(t){return t.field===e})[0]},_adjustTablesWidth:function(){var e,t,n,i=this.thead.prev().children(),o=0;for(e=0,t=i.length;e<t;e++){if(n=i[e].style.width,!n||n.indexOf("%")!=-1){o=0;break}o+=parseInt(n,10)}o&&this.table.add(this.thead.closest("table")).width(o)},_reorderable:function(){var t,n,i;this.options.reorderable&&(t=this.options.scrollable===!0,n=(t?".k-grid-header:first ":"table:first>.k-grid-header ")+ie,i=this,this._draggableInstance=new C.Draggable(this.wrapper,{group:kendo.guid(),filter:n,hint:function(t){return e('<div class="k-header k-drag-clue" />').css({width:t.width(),paddingLeft:t.css("paddingLeft"),paddingRight:t.css("paddingRight"),lineHeight:t.height()+"px",paddingTop:t.css("paddingTop"),paddingBottom:t.css("paddingBottom")}).html(t.attr(kendo.attr("title"))||t.attr(kendo.attr("field"))||t.text()).prepend('<span class="k-icon k-drag-status k-i-cancel" />')}}),this.reorderable=new C.Reorderable(this.wrapper,{draggable:this._draggableInstance,dragOverContainers:M(this._allowDragOverContainers,this),inSameContainer:function(t){return e(t.source).parent()[0]===e(t.target).parent()[0]},change:function(e){var t=e.newIndex,n=e.oldIndex,o="before"===e.position,r=i.columns[n];i.trigger(oe,{newIndex:t,oldIndex:n,column:r}),i.reorderColumn(t,r,o)}}))},_allowDragOverContainers:function(e){return this.columns[e].lockable!==!1},reorderColumn:function(n,i,o){var r,s,a,l=this.columns,c=z(i,l),d=l[n],u=!!d.locked,h=this._nonLockedColumns().length;c!==n&&(u&&!i.locked&&1==h||!u&&i.locked&&l.length-h==1||(o===t&&(o=n<c),r=!!i.locked,r=r!=u,i.locked=u,l.splice(o?n:n+1,0,i),l.splice(c<n?c:c+1,1),this._renderCols(),s=e(this.lockedHeader).add(this.thead).find("th"),s.eq(c)[o?"insertBefore":"insertAfter"](s.eq(n)),a=this._headerTree.children[0].children,this._hasLockedColumns&&(a=this._lockedHeaderTree.children[0].children.concat(a)),a.splice(o?n:n+1,0,a[c]),a.splice(c<n?c:c+1,1),this._hasLockedColumns&&(this._lockedHeaderTree.children[0].children=a.splice(0,this._lockedColumns().length),this._headerTree.children[0].children=a),this._applyLockedContainersWidth(),this.refresh(),r&&(u?this.trigger(ae,{column:i}):this.trigger(le,{column:i}))))},lockColumn:function(e){var t,n=this.columns;e="number"==typeof e?n[e]:F(n,function(t){return t.field===e})[0],e&&!e.hidden&&(t=this._lockedColumns().length-1,this.reorderColumn(t,e,!1))},unlockColumn:function(e){var t,n=this.columns;e="number"==typeof e?n[e]:F(n,function(t){return t.field===e})[0],e&&!e.hidden&&(t=this._lockedColumns().length,this.reorderColumn(t,e,!0))},_columnMenu:function(){var t,n,i,o,r,s,a=e(this.lockedHeader).add(this.thead).find("th"),l=this.columns,c=this.options,d=c.columnMenu,u=M(this._columnMenuInit,this),h=this._lockedColumns().length;if(d)for("boolean"==typeof d&&(d={}),s=0;s<a.length;s++)t=l[s],t.field&&(n=a.eq(s).data("kendoColumnMenu"),n&&n.destroy(),o=!1,t.sortable!==!1&&d.sortable!==!1&&c.sortable!==!1&&(o=g({},c.sortable,{compare:(t.sortable||{}).compare})),r=!1,c.filterable&&t.filterable!==!1&&d.filterable!==!1&&(r=g({pane:this.pane},t.filterable,c.filterable)),i={dataSource:this.dataSource,values:t.values,columns:d.columns,sortable:o,filterable:r,messages:d.messages,owner:this,closeCallback:e.noop,init:u,pane:this.pane,lockedColumns:t.lockable!==!1&&h>0},c.$angular&&(i.$angular=c.$angular),a.eq(s).kendoColumnMenu(i))},_columnMenuInit:function(e){this.trigger(se,{field:e.field,container:e.container})}}),kendo.ExcelMixin&&kendo.ExcelMixin.extend(p.prototype),kendo.PDFMixin&&(kendo.PDFMixin.extend(p.prototype),p.fn._drawPDF=function(t){var n=new e.Deferred;return this._drawPDFShadow({width:this.wrapper.width()},{avoidLinks:this.options.pdf.avoidLinks}).done(function(e){var i={page:e,pageNumber:1,progress:1,totalPages:1};t.notify(i),n.resolve(i.page)}).fail(function(e){n.reject(e)}),n}),g(!0,kendo.data,{TreeListDataSource:u,TreeListModel:Ce}),g(!0,kendo.ui,{TreeList:p}),C.plugin(p)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("util/main.min",["kendo.core.min"],e)}(function(){return function(){function e(e){return e*e}function t(e){return"string"!=typeof e&&(e+="px"),e}function n(e){var t,n,i=[];if(e)for(t=c.toHyphens(e).split("-"),n=0;n<t.length;n++)i.push("k-pos-"+t[n]);return i.join(" ")}function i(e){for(var t={1:"i",10:"x",100:"c",2:"ii",20:"xx",200:"cc",3:"iii",30:"xxx",300:"ccc",4:"iv",40:"xl",400:"cd",5:"v",50:"l",500:"d",6:"vi",60:"lx",600:"dc",7:"vii",70:"lxx",700:"dcc",8:"viii",80:"lxxx",800:"dccc",9:"ix",90:"xc",900:"cm",1e3:"m"},n=[1e3,900,800,700,600,500,400,300,200,100,90,80,70,60,50,40,30,20,10,9,8,7,6,5,4,3,2,1],i="";e>0;)e<n[0]?n.shift():(i+=t[n[0]],e-=n[0]);return i}function o(e){var t,n,i,o,r;for(e=e.toLowerCase(),t={i:1,v:5,x:10,l:50,c:100,d:500,m:1e3},n=0,i=0,o=0;o<e.length;++o){if(r=t[e.charAt(o)],!r)return null;n+=r,r>i&&(n-=2*i),i=r}return n}function r(e){var t=Object.create(null);return function(){var n,i="";for(n=arguments.length;--n>=0;)i+=":"+arguments[n];return i in t?t[i]:t[i]=e.apply(this,arguments)}}function s(e){return l.test(e)}function a(e,t){function n(e){this.value=e}try{return e.call(t,function(e){throw new n(e)})}catch(i){if(i instanceof n)return i.value;throw i}}var l,c=window.kendo,d=c.deepExtend,u=Date.now;u||(u=function(){return(new Date).getTime()}),d(c,{util:{now:u,renderPos:n,renderSize:t,sqr:e,romanToArabic:o,arabicToRoman:i,memoize:r,isUnicodeLetter:s,withExit:a}}),l=RegExp("[\\u0041-\\u005A\\u0061-\\u007A\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]")}(),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("util/parse-xml.min",["kendo.core.min","util/main.min"],e)}(function(){"use strict";function e(e){var t,n=[];for(t=0;t<e.length;++t)n.push(e.charCodeAt(t));return n}function t(e,t){t>65535?(t-=65536,e.push(t>>>10&1023|55296,56320|1023&t)):e.push(t)}function n(e,n){function C(n){var i=e[q++];240&i^240?224&i^224?192&i^192?n.push(i):t(n,(31&i)<<6|63&e[q++]):t(n,(15&i)<<12|(63&e[q++])<<6|63&e[q++]):t(n,(3&i)<<18|(63&e[q++])<<12|(63&e[q++])<<6|63&e[q++])}function S(e){throw Error(e+", at "+q)}function T(t){for(var n=[];q<e.length&&t(e[q]);)n.push(e[q++]);return n}function D(e){return i.apply(0,T(e))}function A(){T(M)}function E(t){var n,i=q;for(n=0;n<t.length;++n)if(e[q++]!=t[n])return q=i,!1;return t}function I(e){E(e)||S("Expecting "+e.join(", "))}function M(e){return 9==e||10==e||13==e||32==e}function R(e){return e>=48&&e<=57}function F(e){return e>=48&&e<=57||(e|=32)>=97&&e<=102}function z(e){return 58==e||95==e||(e|=32)>=97&&e<=122}function P(e){return 45==e||R(e)||z(e)}function B(){for(var t=[];q<e.length;){if(E(a))return j("comment",i.apply(0,t));C(t)}}function L(){var e,t;E(h)?U():E(l)?B():(e=N(),t=W(e),G.push(t),E(c)?j("enter",e,t,!0):(I(p),j("enter",e,t),H(e),e!=N()&&S("Bad closing tag"),j("leave",e,t),A(),I(p)),G.pop())}function H(t){for(var n=[];q<e.length;){if(E(d))return n.length&&j("text",i.apply(0,n));if(E(r))for(;q<e.length&&!E(s);)C(n);else E(f)?(n.length&&j("text",i.apply(0,n)),L(),n=[]):E(v)?V(n):C(n)}S("Unclosed tag "+t)}function N(){return z(e[q])||S("Expecting XML name"),D(P)}function O(){var t,n=E(_)||E(b);for(n||S("Expecting string"),t=[];q<e.length;){if(E(n))return i.apply(0,t);E(v)?V(t):C(t)}S("Unfinished string")}function V(e){var n,i;E(w)?(n=E(y)||E(k)?parseInt(D(F),16):parseInt(D(R),10),isNaN(n)&&S("Bad numeric entity")):(i=N(),n=o[i],void 0===n&&S("Unknown entity "+i)),t(e,n),I(m)}function U(){j("decl",N(),W()),I(u)}function W(t){for(var n,i={$tag:t};q<e.length&&(A(),n=e[q],63!=n&&62!=n&&47!=n);)i[N()]=(I(g),O());return i}function j(e,t,i,o){var r=n&&n[e];r&&r.call($,t,i,o)}var q=0,G=[],$={is:function(e){for(var t=G.length,n=e.length;--t>=0&&--n>=0;)if(G[t].$tag!=e[n]&&"*"!=e[n])return!1;return n<0?G[G.length-1]:null},exit:function(){throw x},stack:G},K=[];for(C(K),65279!=K[0]&&(q=0);q<e.length;)A(),I(f),L(),A()}var i=String.fromCharCode,o={amp:38,lt:60,gt:62,quot:34,apos:39,nbsp:160},r=e("<![CDATA["),s=e("]]>"),a=e("-->"),l=e("!--"),c=e("/>"),d=e("</"),u=e("?>"),h=e("?"),f=e("<"),p=e(">"),m=e(";"),g=e("="),v=e("&"),_=e('"'),b=e("'"),w=e("#"),y=e("x"),k=e("X"),x={};kendo.util.parseXML=function(){try{return n.apply(this,arguments)}catch(e){if(e!==x)throw e}}},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/commands.min",["kendo.core.min","kendo.binder.min","kendo.window.min","kendo.list.min","kendo.tabstrip.min"],e)}(function(){!function(e){function t(e){var t=document.createElement("textarea");n(t).addClass("k-spreadsheet-clipboard").val(e).appendTo(document.body).focus().select(),document.execCommand("copy"),n(t).remove()}var n,i,o,r,s,a,l,c;e.support.browser.msie&&e.support.browser.version<9||(n=e.jQuery,i=e.spreadsheet.Command=e.Class.extend({init:function(e){this.options=e,this._workbook=e.workbook,this._property=e&&e.property,this._state={}},range:function(e){return void 0!==e&&this._setRange(e),this._range},_setRange:function(e){this._range=e},redo:function(){this.range().select(),this.exec()},undo:function(){this.setState(this._state)},getState:function(){this._state=this.range().getState(this._property)},setState:function(e){this.range().setState(e)},_forEachCell:function(e){var t=this.range(),n=t._ref;n.forEach(function(n){t.sheet().forEach(n.toRangeRef(),e.bind(this))}.bind(this))}}),o=i.extend({init:function(e){i.fn.init.call(this,e),this._target=e.target,this._value=e.value},exec:function(){this.getState(),this.setState(this._value)}}),e.spreadsheet.ColumnWidthCommand=o.extend({getState:function(){this._state=this.range().sheet().columnWidth(this._target)},setState:function(e){this.range().sheet().columnWidth(this._target,e)}}),e.spreadsheet.RowHeightCommand=o.extend({getState:function(){this._state=this.range().sheet().rowHeight(this._target)},setState:function(e){this.range().sheet().rowHeight(this._target,e)}}),e.spreadsheet.HyperlinkCommand=i.extend({init:function(e){i.fn.init.call(this,e),this._link=e.link},exec:function(){var e=this.range();this._prevLink=e.link(),this._prevUnderline=e.underline(),e.link(this._link),e.underline(!0),null==e.value()&&(this._hasSetValue=!0,e.value(this._link))},undo:function(){var e=this.range();e.link(this._prevLink),e.underline(this._prevUnderline),this._hasSetValue&&e.value(null)}}),e.spreadsheet.GridLinesChangeCommand=o.extend({getState:function(){this._state=this._range.sheet().showGridLines()},setState:function(e){this._range.sheet().showGridLines(e)}}),r=e.spreadsheet.PropertyChangeCommand=i.extend({_setRange:function(e){i.prototype._setRange.call(this,e.skipHiddenCells())},init:function(e){i.fn.init.call(this,e),this._value=e.value},exec:function(){var e=this.range();e.enable()&&(this.getState(),"format"===this.options.property&&this._workbook.trigger("changeFormat",{range:e}),e[this._property](this._value))}}),e.spreadsheet.ClearContentCommand=i.extend({exec:function(){return this.range().enable()?(this.getState(),void this.range().skipHiddenCells().clearContent()):{reason:"error",type:"cannotModifyDisabled"}}}),e.spreadsheet.EditCommand=r.extend({init:function(e){e.property=e.property||"input",r.fn.init.call(this,e)},rejectState:function(e){return this.undo(),{title:e.title,body:e.message,reason:"error",type:"validationError"}},editRange:function(){var e=this.range();return this.options.arrayFormula?e:e.sheet().activeCellSelection()},getState:function(){this._state=this.range().getState()},exec:function(){var t,n,i=this.options.arrayFormula,o=this.editRange();if(!o.enable())return{reason:"error",type:"rangeDisabled"};if(!o.canEditArrayFormula())return{reason:"error",type:"intersectsArray"};if(t=this._value,this.getState(),"value"==this._property)return void o.value(t);try{if(o.link(null),""===t?o.value(null):(o.input(t,{arrayFormula:i}),/\n/.test(o.value())&&o.wrap(!0)),o._adjustRowHeight(),n=o._getValidationState())return this.rejectState(n)}catch(r){if(r instanceof e.spreadsheet.calc.ParseError)return{title:"Error in formula",body:r+"",reason:"error"};throw r}}}),e.spreadsheet.TextWrapCommand=r.extend({init:function(e){e.property="wrap",r.fn.init.call(this,e),this._value=e.value},getState:function(){var e={};this.range().forEachRow(function(t){var n=t.topLeft().row;e[n]=t.sheet().rowHeight(n)}),this._state=this.range().getState(this._property),this._rowHeight=e},undo:function(){var e,t=this.range().sheet(),n=this._rowHeight;this.range().setState(this._state);for(e in n)t.rowHeight(e,n[e])}}),e.spreadsheet.AdjustDecimalsCommand=i.extend({init:function(e){this._decimals=e.value,e.property="format",i.fn.init.call(this,e)},exec:function(){var t=this.range().sheet(),n=this._decimals,i=e.spreadsheet.formatting;this.getState(),t.batch(function(){this.range().forEachCell(function(e,o,r){var s=r.format;(s||n>0)&&(s=i.adjustDecimals(s||"#",n),t.range(e,o).format(s))})}.bind(this))}}),e.spreadsheet.BorderChangeCommand=i.extend({init:function(e){e.property="border",i.fn.init.call(this,e),this._type=e.border,this._style=e.style},_batch:function(e){return this.range().sheet().batch(e,{})},exec:function(){var e=this;e.getState(),e._batch(function(){e[e._type](e._style)})},noBorders:function(){this.range().insideBorders(null),this.outsideBorders(null)},allBorders:function(e){this.range().insideBorders(e),this.outsideBorders(e)},leftBorder:function(e){this.range().leftColumn().borderLeft(e)},rightBorder:function(e){this.range().rightColumn().borderRight(e)},topBorder:function(e){this.range().topRow().borderTop(e);
},bottomBorder:function(e){this.range().bottomRow().borderBottom(e)},outsideBorders:function(e){var t=this.range();t.leftColumn().borderLeft(e),t.topRow().borderTop(e),t.rightColumn().borderRight(e),t.bottomRow().borderBottom(e)},insideBorders:function(e){this.range().insideBorders(e),this.outsideBorders(null)},insideHorizontalBorders:function(e){this.range().insideHorizontalBorders(e)},insideVerticalBorders:function(e){this.range().insideVerticalBorders(e)}}),e.spreadsheet.MergeCellCommand=i.extend({init:function(e){i.fn.init.call(this,e),this._type=e.value},exec:function(){this.getState(),this[this._type]()},activate:function(e){this.range().sheet().activeCell(e)},getState:function(){this._state=this.range().getState()},undo:function(){"unmerge"!==this._type&&(this.range().unmerge(),this.activate(this.range().topLeft())),this.range().setState(this._state)},cells:function(){var e=this.range(),t=e._ref;e.merge(),this.activate(t)},horizontally:function(){var e=this.range().topRow()._ref;this.range().forEachRow(function(e){e.merge()}),this.activate(e)},vertically:function(){var e=this.range().leftColumn()._ref;this.range().forEachColumn(function(e){e.merge()}),this.activate(e)},unmerge:function(){var e=this.range(),t=e._ref.topLeft;e.unmerge(),this.activate(t)}}),e.spreadsheet.FreezePanesCommand=i.extend({init:function(e){i.fn.init.call(this,e),this._type=e.value},exec:function(){this.getState(),this._topLeft=this.range().topLeft(),this[this._type]()},getState:function(){this._state=this.range().sheet().getState()},undo:function(){this.range().sheet().setState(this._state)},panes:function(){var e=this._topLeft,t=this.range().sheet();t.frozenColumns(e.col).frozenRows(e.row)},rows:function(){var e=this._topLeft,t=this.range().sheet();t.frozenRows(e.row)},columns:function(){var e=this._topLeft,t=this.range().sheet();t.frozenColumns(e.col)},unfreeze:function(){var e=this.range().sheet();e.frozenRows(0).frozenColumns(0)}}),e.spreadsheet.PasteCommand=i.extend({init:function(e){i.fn.init.call(this,e),this._clipboard=e.workbook.clipboard(),this._event=e.event},getState:function(){this._range=this._workbook.activeSheet().range(this._clipboard.pasteRef()),this._state=this._range.getState()},exec:function(){var e,t,n;return this.getState(),this._clipboard.parse(),e=this._clipboard.canPaste(),e.canPaste?(t=this._workbook.activeSheet().selection(),n=this._workbook.trigger("paste",{range:t}),void(n?this._event.preventDefault():(this._clipboard.paste(),t._adjustRowHeight()))):e.menuInvoked?{reason:"error",type:"useKeyboard"}:e.pasteOnMerged?{reason:"error",type:"modifyMerged"}:e.overflow?{reason:"error",type:"overflow"}:e.pasteOnDisabled?(this._event.preventDefault(),{reason:"error",type:"cannotModifyDisabled"}):{reason:"error"}}}),e.spreadsheet.AdjustRowHeightCommand=i.extend({exec:function(){var e=this.options,t=this._workbook.activeSheet(),n=e.range||t.range(e.rowIndex);n._adjustRowHeight()}}),e.spreadsheet.ToolbarPasteCommand=i.extend({exec:function(){return e.support.clipboard.paste?(this._workbook._view.clipboard.focus().select(),void document.execCommand("paste")):{reason:"error",type:"useKeyboard"}}}),e.spreadsheet.CutCommand=i.extend({_eventType:"cut",init:function(e){i.fn.init.call(this,e),this._clipboard=e.workbook.clipboard(),this._event=e.event},exec:function(){var e,t,n=this._clipboard.canCopy();if(n.canCopy){if(e=this._workbook.activeSheet().selection(),"cut"==this._eventType){if(!e.enable())return this._event.preventDefault(),{reason:"error",type:"cannotModifyDisabled"};this.getState()}t=this._workbook.trigger(this._eventType,{range:e}),t?this._event.preventDefault():"cut"==this._eventType?this._clipboard.cut():this._clipboard.copy()}else{if(n.menuInvoked)return{reason:"error",type:"useKeyboard"};if(n.multiSelection)return{reason:"error",type:"unsupportedSelection"}}}}),e.spreadsheet.CopyCommand=e.spreadsheet.CutCommand.extend({_eventType:"copy",undo:n.noop}),e.spreadsheet.ToolbarCopyCommand=i.extend({init:function(e){i.fn.init.call(this,e),this._clipboard=e.workbook.clipboard()},undo:n.noop,exec:function(){if(!e.support.clipboard.copy)return{reason:"error",type:"useKeyboard"};var n=this._workbook._view.clipboard;t(n.html()),n.trigger("copy")}}),e.spreadsheet.AutoFillCommand=i.extend({init:function(e){i.fn.init.call(this,e)},origin:function(e){this._origin=e},exec:function(){var t=this.range();if(!t.enable())return{reason:"error",type:"rangeDisabled"};if(t.intersectingArrayFormula())return{reason:"error",type:"intersectsArray"};this.getState();try{t.fillFrom(this._origin)}catch(n){if(n instanceof e.spreadsheet.Range.FillError)return{reason:"error",type:n.code};throw n}}}),e.spreadsheet.ToolbarCutCommand=i.extend({init:function(e){i.fn.init.call(this,e),this._clipboard=e.workbook.clipboard()},exec:function(){if(!e.support.clipboard.copy)return{reason:"error",type:"useKeyboard"};var n=this._workbook._view.clipboard;t(n.html()),n.trigger("cut")}}),e.spreadsheet.FilterCommand=i.extend({undo:function(){this.range().filter(this._state)},exec:function(){var e=this.range();this._state=e.hasFilter(),e.filter(!this._state)}}),e.spreadsheet.SortCommand=i.extend({undo:function(){var e=this.range().sheet();e.setState(this._state)},exec:function(){var e,t=this.range(),n=t.sheet(),i=n.activeCell(),o=this.options.sheet?i.topLeft.col:this.options.column||0,r="asc"===this.options.value;return this._state=n.getState(),this.options.sheet&&(t=this.expandRange()),(e=t.cantSort())?{reason:"error",type:e.code}:void t.sort({column:o,ascending:r})},expandRange:function(){var t=this.range().sheet();return new e.spreadsheet.Range(t._sheetRef,t)}}),s=e.spreadsheet.ApplyFilterCommand=i.extend({column:function(){return this.options.column||0},undo:function(){var e=this.range().sheet();e.clearFilter(this.column()),this._state.length&&this.range().filter(this._state)},getState:function(){var e=this.range().sheet(),t=e.filter();t&&(this._state=t.columns.filter(function(e){return e.index==this.column()}.bind(this)))},exec:function(){var t,n,i=this.range(),o=this.column(),r=i.sheet().filter(),s=!1;this.options.valueFilter?n={column:o,filter:new e.spreadsheet.ValueFilter(this.options.valueFilter)}:this.options.customFilter&&(n={column:o,filter:new e.spreadsheet.CustomFilter(this.options.customFilter)}),this.getState(),r&&r.ref.eq(i._ref)&&r.columns.length?(r.columns.forEach(function(e){e.index===o&&(s=!0)}),t=r.columns.map(function(e){return e.index===o?n:{column:e.index,filter:e.filter}}),s||t.push(n)):t=n,i.filter(t)}}),e.spreadsheet.ClearFilterCommand=s.extend({exec:function(){var e=this.range(),t=this.column();this.getState(),e.clearFilter(t)}}),e.spreadsheet.HideLineCommand=i.extend({init:function(e){i.fn.init.call(this,e),this.axis=e.axis},undo:function(){var e=this.range().sheet();e.setAxisState(this._state)},exec:function(){var e=this.range().sheet();this._state=e.getAxisState(),"row"==this.axis?e.axisManager().hideSelectedRows():e.axisManager().hideSelectedColumns()}}),e.spreadsheet.UnHideLineCommand=e.spreadsheet.HideLineCommand.extend({exec:function(){var e=this.range().sheet();this._state=e.getAxisState(),"row"==this.axis?e.axisManager().unhideSelectedRows():e.axisManager().unhideSelectedColumns()}}),a=i.extend({exec:function(){this._expandedRange=this._expand(this.range()),this._state=this._expandedRange.getState(),this._indexes=this._exec(this._expandedRange.sheet())},undo:function(){var e=this,t=e._expandedRange,n=t.sheet();n.batch(function(){e._indexes.forEach(function(t){e._undoOne(n,t),n._restoreModifiedFormulas(t.formulas)}),t.setState(e._state)},{layout:!0,recalc:!0})}}),e.spreadsheet.DeleteRowCommand=a.extend({_expand:function(e){return e.resize({left:-(1/0),right:+(1/0)})},_exec:function(e){return e.axisManager().deleteSelectedRows()},_undoOne:function(e,t){e.insertRow(t.index),e.rowHeight(t.index,t.height)}}),e.spreadsheet.DeleteColumnCommand=a.extend({_expand:function(e){return e.resize({top:-(1/0),bottom:+(1/0)})},_exec:function(e){return e.axisManager().deleteSelectedColumns()},_undoOne:function(e,t){e.insertColumn(t.index),e.columnWidth(t.index,t.width)}}),l=i.extend({init:function(e){i.fn.init.call(this,e),this._value=e.value},undo:function(){var e=this,t=e.range().sheet();t.batch(function(){for(var n=e._pos.count;--n>=0;)e._undoOne(t,e._pos.base)},{layout:!0,recalc:!0})}}),e.spreadsheet.AddColumnCommand=l.extend({exec:function(){var e=this.range().sheet(),t=e.axisManager().preventAddColumn();return t?t:void(this._pos="left"===this._value?e.axisManager().addColumnLeft():e.axisManager().addColumnRight())},_undoOne:function(e,t){e.deleteColumn(t)}}),e.spreadsheet.AddRowCommand=l.extend({exec:function(){var e=this.range().sheet(),t=e.axisManager().preventAddRow();return t?t:void(this._pos="above"===this._value?e.axisManager().addRowAbove():e.axisManager().addRowBelow())},_undoOne:function(e,t){e.deleteRow(t)}}),e.spreadsheet.EditValidationCommand=i.extend({init:function(e){i.fn.init.call(this,e),this._value=e.value},exec:function(){this.range().validation(this._value)}}),e.spreadsheet.OpenCommand=i.extend({cannotUndo:!0,exec:function(){var e,t=this.options.file;return null===t.name.match(/.xlsx$/i)?{reason:"error",type:"openUnsupported"}:(e=this.options.workbook,void e.fromFile(this.options.file).then(function(){var t=e.excelImportErrors;t&&t.length&&e._view.openDialog("importError",{errors:t})}))}}),e.spreadsheet.SaveAsCommand=i.extend({exec:function(){var e=this.options.name+this.options.extension;".xlsx"===this.options.extension?this.options.workbook.saveAsExcel({fileName:e}):".pdf"===this.options.extension&&this.options.workbook.saveAsPDF(n.extend(this.options.pdf,{workbook:this.options.workbook,fileName:e}))}}),c=i.extend({init:function(e){i.fn.init.call(this,e),this._name=e.name,this._value=e.value},getState:function(){this._state=this._workbook.nameDefinition(this._name)},setState:function(){this._workbook.nameDefinition(this._name,this._state),this._workbook.trigger("change",{recalc:!0})}}),e.spreadsheet.DefineNameCommand=c.extend({exec:function(){this.getState();try{this._workbook.defineName(this._name,this._value),this._workbook.trigger("change",{recalc:!0})}catch(e){return{title:"Error",body:e+"",reason:"error"}}}}),e.spreadsheet.DeleteNameCommand=c.extend({exec:function(){this.getState(),this._workbook.undefineName(this._name),this._workbook.trigger("change",{recalc:!0})}}))}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/formulabar.min",["kendo.core.min"],e)}(function(){!function(e){var t,n,i;e.support.browser.msie&&e.support.browser.version<9||(t=e.jQuery,n={wrapper:"k-spreadsheet-formula-bar"},i=e.ui.Widget.extend({init:function(n,o){e.ui.Widget.call(this,n,o),n=this.element.addClass(i.classNames.wrapper),this.formulaInput=new e.spreadsheet.FormulaInput(t("<div/>").appendTo(n))},destroy:function(){this.formulaInput&&this.formulaInput.destroy(),this.formulaInput=null}}),e.spreadsheet.FormulaBar=i,t.extend(!0,i,{classNames:n}))}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/formulainput.min",["kendo.core.min"],e)}(function(){!function(e,t){function n(e){return"("==e||"["==e||"{"==e}function i(e){return")"==e||"]"==e||"}"==e}function o(e,t){return"("==t?")"==e:"["==t?"]"==e:"{"==t&&"}"==e}function r(e,t){return e.begin<=t.begin&&e.end>=t.end}function s(t){return e.spreadsheet.calc.runtime.FUNCS[t.toLowerCase()]}function a(e,t){return!(!e||!t)&&("ref"==e.type&&"ref"==t.type?e.ref.eq(t.ref):e.value===t.value)}var l,c,d,u,h,f,p,m,g;e.support.browser.msie&&e.support.browser.version<9||(l=e.jQuery,c=e.ui.Widget,d=".kendoFormulaInput",u=e.keys,h={wrapper:"k-spreadsheet-formula-input",listWrapper:"k-spreadsheet-formula-list"},f=["font-family","font-size","font-stretch","font-style","font-weight","letter-spacing","text-transform","line-height"],p={27:"esc",37:"left",39:"right",35:"end",36:"home",32:"spacebar"},m=/(^_|[^a-z0-9]$)/i,g=c.extend({init:function(e,t){c.call(this,e,t),e=this.element,e.addClass(g.classNames.wrapper).attr("contenteditable",!0).attr("spellcheck",!1).css("white-space","pre"),this.options.autoScale&&e.on("input",this.scale.bind(this)),this._highlightedRefs=[],this._staticTokens=[],this._formulaSource(),this._formulaList(),this._popup(),this._tooltip(),e.on("keydown",this._keydown.bind(this)).on("keyup",this._keyup.bind(this)).on("blur",this._blur.bind(this)).on("input click",this._input.bind(this)).on("focus",this._focus.bind(this)).on("paste",this._paste.bind(this))},options:{name:"FormulaInput",autoScale:!1,filterOperator:"startswith",scalePadding:30,minLength:1},events:["keyup","focus"],enable:function(e){return void 0===e?"true"===this.element.attr("contenteditable"):(e?this.element.attr("contenteditable",e):this.element.removeAttr("contenteditable"),void this.element.toggleClass("k-state-disabled",!e))},getPos:function(){function e(e,t){try{!function o(n){if(n===e)throw t;if(1==n.nodeType)for(var i=n.firstChild;i;i=i.nextSibling)o(i);else 3==n.nodeType&&(t+=n.nodeValue.length)}(i)}catch(n){return n}}var n,i=this.element[0],o=t.getSelection(),r=e(o.focusNode,o.focusOffset),s=e(o.anchorNode,o.anchorOffset);if(null!=r&&null!=s)return r>s&&(n=r,r=s,s=n),{begin:r,end:s,collapsed:r==s}},setPos:function(e,n){function i(e,t){return e.startOffset!=t.startOffset||e.endOffset!=t.endOffset||e.startContainer!=t.endContainer||e.endContainer!=t.endContainer}function o(e,t){try{!function i(e){var n,o;if(3==e.nodeType){if(n=e.nodeValue.length,n>=t)throw e;t-=n}else if(1==e.nodeType)for(o=e.firstChild;o;o=o.nextSibling)i(o)}(e)}catch(n){return{node:n,pos:t}}}var r,s,a,l=this.element[0];e=o(l,e),n=null!=n?o(l,n):e,e&&n&&(r=document.createRange(),r.setStart(e.node,e.pos),r.setEnd(n.node,n.pos),s=t.getSelection(),a=s.getRangeAt(0),i(r,a)&&(s.removeAllRanges(),s.addRange(r)))},end:function(){this.setPos(this.length())},home:function(){this.setPos(0)},select:function(){this.setPos(0,this.length())},length:function(){return this.value().length},_formulaSource:function(){var t,n,i=[];for(n in e.spreadsheet.calc.runtime.FUNCS)m.test(n)||(t=n.toUpperCase(),i.push({value:t,text:t}));this.formulaSource=new e.data.DataSource({data:i})},_formulaList:function(){this.list=new e.ui.StaticList(l("<ul />").addClass(g.classNames.listWrapper).insertAfter(this.element),{autoBind:!1,selectable:!0,change:this._formulaListChange.bind(this),dataSource:this.formulaSource,dataValueField:"value",template:"#:data.value#"}),this.list.element.on("mousedown",function(e){e.preventDefault()})},_formulaListChange:function(){var e,t,n,i=this._tokenContext();i&&!this._mute&&(e=i.token,t=this.list.value()[0],n={replace:!0,token:e,end:e.end},i.nextToken&&"("==i.nextToken.value||(t+="("),this._replaceAt(n,t),this.popup.close())},_popup:function(){this.popup=new e.ui.Popup(this.list.element,{anchor:this.element})},_blur:function(){this.popup.close(),clearTimeout(this._focusId),this.trigger("blur")},_isFormula:function(){return/^=/.test(this.value())},_keydown:function(e){var t=e.keyCode;p[t]?(this.popup.close(),this._navigated=!0):this._move(t)&&(this._navigated=!0,e.preventDefault()),this._keyDownTimeout=setTimeout(this._syntaxHighlight.bind(this))},_keyup:function(){var e,t=this.popup;this._isFormula()&&!this._navigated&&(e=((this._tokenContext()||{}).token||{}).value,this.filter(e),e&&this.formulaSource.view().length?(t[t.visible()?"position":"open"](),this.list.focusFirst()):t.close()),this._navigated=!1,this._syntaxHighlight(),this.trigger("keyup")},_input:function(){this._syntaxHighlight()},_focus:function(){setTimeout(this._sync.bind(this)),this._focusTimeout=setTimeout(this._syntaxHighlight.bind(this)),this.trigger("focus")},_paste:function(n){var i,o,r;n.preventDefault(),i=this.getPos(),o=e.support.browser.msie?t.clipboardData.getData("Text"):n.originalEvent.clipboardData.getData("text/plain"),r=this.value(),r=r.substr(0,i.begin)+o+r.substr(i.end),this.value(r),this.setPos(i.begin+o.length),this.scale()},_move:function(e){var t=this.list,n=this.popup;if(n.visible()){if(e===u.DOWN)return t.focusNext(),t.focus()||t.focusFirst(),!0;if(e===u.UP)return t.focusPrev(),t.focus()||t.focusLast(),!0;if(e===u.ENTER)return t.select(t.focus()),n.close(),!0;if(e===u.TAB)return t.select(t.focus()),n.close(),!0;if(e===u.PAGEUP)return t.focusFirst(),!0;if(e===u.PAGEDOWN)return t.focusLast(),!0}return e===u.ENTER||e===u.TAB},_tokenContext:function(){var t,n,i,o=this.getPos(),s=this.value();if(!s||!o||!o.collapsed)return null;for(t=e.spreadsheet.calc.tokenize(s,this.row(),this.col()),i=0;i<t.length;++i)if(n=t[i],r(n,o)&&/^(?:str|sym|func)$/.test(n.type))return{token:n,nextToken:t[i+1]};return null},_sync:function(){this._editorToSync&&this.isActive()&&this._editorToSync.value(this.value())},_textContainer:function(){var t=e.getComputedStyles(this.element[0],f);t.position="absolute",t.visibility="hidden",t.whiteSpace="pre",t.top=-3333,t.left=-3333,this._span=l("<span style='white-space: pre'/>").css(t).insertAfter(this.element)},_tooltip:function(){this._cellTooltip=l('<div class="k-widget k-tooltip" style="position:absolute; display:none">A1</div>').insertAfter(this.element)},tooltip:function(e){this._cellTooltip.text(e)},toggleTooltip:function(e){this._cellTooltip.toggle(e)},isActive:function(){return this.element[0]===e._activeElement()},filter:function(e){!e||e.length<this.options.minLength||(this._mute=!0,this.list.select(-1),this._mute=!1,this.formulaSource.filter({field:this.list.options.dataValueField,operator:this.options.filterOperator,value:e}))},hide:function(){this.enable(!1),this.element.hide(),this._cellTooltip.hide()},show:function(){this.enable(!0),this.element.show()},row:function(){if(this.activeCell)return this.activeCell.row},col:function(){if(this.activeCell)return this.activeCell.col},position:function(e){e&&(this.show(),this.element.css({top:e.top+1+"px",left:e.left+1+"px"}),this._cellTooltip.css({top:e.top-this._cellTooltip.height()-10+"px",left:e.left}))},resize:function(e){e&&this.element.css({width:e.width-1,height:e.height-1})},canInsertRef:function(e){var t,n=this._canInsertRef(e),i=n&&n.token;if(i)for(t=0;t<this._staticTokens.length;t++)if(a(i,this._staticTokens[t]))return null;return n},_canInsertRef:function(t){function i(e){return e.begin>l.begin}function o(e){if(e){if(/^(?:num|str|bool|sym|ref)$/.test(e.type))return{replace:!0,token:e,end:e.end};if(/^(?:op|punc|startexp)$/.test(e.type))return e.end==l.end?s(e,c[u+1]):s(c[u-1],e)}}function s(e,t){if(null==e)return null;if(null==t)return/^(?:op|startexp)$/.test(e.type)||n(e.value)?{token:e,end:l.end}:null;if(a){if("op"==e.type&&/^(?:punc|op)$/.test(t.type))return{token:e,end:l.end}}else{if("startexp"==e.type)return{token:e,end:l.end};if(/^(?:op|punc)$/.test(e.type)&&/^[,;({]$/.test(e.value))return{token:e,end:l.end};if(/^(?:ref|sym)/.test(e.type))return{token:e,replace:!0,end:e.end};if(/^(?:ref|sym)/.test(t.type))return{token:t,replace:!0,end:t.end}}return!1}var a,l,c,d,u;if(this.popup.visible())return null;if(a=t,l=this.getPos(),l&&this._isFormula()){if(0===l.begin)return null;for(c=e.spreadsheet.calc.tokenize(this.value(),this.row(),this.col()),u=0;u<c.length;++u){if(d=c[u],r(d,l))return o(d);if(i(d))return s(c[u-1],d)}return s(d,null)}return null},refAtPoint:function(e){var t,n=this._canInsertRef();n&&(t=e.selection()._ref.simplify().clone().relative(0,0,3),e!==this.activeSheet&&(t=t.setSheet(e.name(),!0)),this._replaceAt(n,t.print(0,0)))},_replaceAt:function(e,t){var n,i=this.value(),o=e.token,r=i.substr(e.end);i=i.substr(0,e.replace?o.begin:e.end)+t,n=i.length,i+=r,this._value(i),this.setPos(n),this.scale(),this._syntaxHighlight()},syncWith:function(t){var n,i=this,o="input"+d,r=i._sync.bind(i);e.support.browser.msie&&(o="keydown"+d,n=function(){setTimeout(r)}),i._editorToSync=t,i.element.off(o).on(o,n||r)},scale:function(){var e,t,n=this.element;this._span||this._textContainer(),this._span.html(n.html()),e=this._span.width()+this.options.scalePadding,t=this._span.height(),e>n.width()&&n.width(e),t>n.height()&&n.height(t),this._sync()},_value:function(e){this.element.text(e)},value:function(e){if(void 0===e){var t=this.element[0].innerText;return t.replace(/\n$/,"")}this._value(e),this._syntaxHighlight()},highlightedRefs:function(){return this._highlightedRefs.slice()},_syntaxHighlight:function(){var t,a=this.getPos(),l=this.value(),c=e.spreadsheet.Pane.classNames.series,d=[],u=0,h=[],f=[];if(!a||a.collapsed){if(!/^=/.test(l))return(this._staticTokens.length||this._highlightedRefs.length)&&(this._staticTokens=[],this._highlightedRefs=[],this.element.text(l)),void(this.popup&&this.popup.close());f=e.spreadsheet.calc.tokenize(l,this.row(),this.col()),f.forEach(function(e){if(e.active=!1,e.cls=["k-syntax-"+e.type],"ref"==e.type&&(e.colorClass=c[u++%c.length],e.cls.push(e.colorClass),d.push(e)),a&&"punc"==e.type)if(n(e.value))h.unshift(e);else if(i(e.value)){var l=h.shift();l?o(e.value,l.value)?(r(e,a)||r(l,a))&&(e.cls.push("k-syntax-paren-match"),l.cls.push("k-syntax-paren-match")):(e.cls.push("k-syntax-error"),l.cls.push("k-syntax-error")):e.cls.push("k-syntax-error")}a&&r(e,a)&&(e.cls.push("k-syntax-at-point"),e.active=!0,t=e),"func"!=e.type||s(e.value)||a&&r(e,a)||e.cls.push("k-syntax-error")}),f.reverse().forEach(function(t){var n=t.begin,i=t.end,o=e.htmlEncode(l.substring(n,i));l=l.substr(0,n)+"<span class='"+t.cls.join(" ")+"'>"+o+"</span>"+l.substr(i)}),this.element.html(l),a&&this.setPos(a.begin,a.end),t&&/^(?:startexp|op|punc)$/.test(t.type)&&this._setStaticTokens(f),this._highlightedRefs=d}},_setStaticTokens:function(e){var t,n;for(this._staticTokens=[],t=0;t<e.length;t++)n=e[t],/^(?:num|str|bool|sym|ref)$/.test(n.type)&&this._staticTokens.push(n)},destroy:function(){this._editorToSync=null,this.element.off(d),clearTimeout(this._focusTimeout),clearTimeout(this._keyDownTimeout),this._cellTooltip=null,this._span=null,this.popup.destroy(),this.popup=null,c.fn.destroy.call(this)},insertNewline:function(){var e=this.value(),t=this.getPos(),n=t.end==e.length;e=e.substr(0,t.begin)+(n?"\n\n":"\n"+e.substr(t.end)),this.value(e),this.setPos(t.begin+1)}}),e.spreadsheet.FormulaInput=g,l.extend(!0,g,{classNames:h}))}(kendo,window)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/eventlistener.min",["kendo.core.min"],e)}(function(){!function(e){var t,n,i,o,r,s;e.support.browser.msie&&e.support.browser.version<9||(t=e.jQuery,n={8:"backspace",9:"tab",13:"enter",27:"esc",37:"left",38:"up",39:"right",40:"down",35:"end",36:"home",32:"spacebar",33:"pageup",34:"pagedown",46:"delete",113:":edit"},i=navigator.platform.toUpperCase().indexOf("MAC")>=0,o=function(e){return e>47&&e<58||e>64&&e<91||e>95&&e<112||e>185&&e<193||e>218&&e<223},r=function(e){var t=e.keyCode,i=n[t];return!i&&o(t)&&(i=":alphanum"),!i&&e.key&&1==e.key.length&&(i=":alphanum"),i},s=e.Class.extend({init:function(e,n,i){if(this._handlers={},this.target=e,this._observer=n||window,this.keyDownProxy=this.keyDown.bind(this),this.mouseProxy=this.mouse.bind(this),this.threshold=5,this._pressLocation=null,e.on("keydown",this.keyDownProxy),e.on("contextmenu mousedown cut copy paste scroll wheel click dblclick focus",this.mouseProxy),t(document.documentElement).on("mousemove mouseup",this.mouseProxy),i)for(var o in i)this.on(o,i[o])},keyDown:function(e){this.handleEvent(e,r(e.originalEvent))},mouse:function(e){var t,n,i,o,r;e.which?t=3==e.which:e.button&&(t=2==e.button),n=e.type,"mousedown"===n&&(t?n="rightmousedown":this._pressLocation={x:e.pageX,y:e.pageY}),"mouseup"===n&&(t||(this._pressLocation=null)),"mousemove"===n&&this._pressLocation&&(i=this._pressLocation.x-e.pageX,o=this._pressLocation.y-e.pageY,r=Math.sqrt(i*i+o*o),r>this.threshold&&(n="mousedrag")),this.handleEvent(e,n)},handleEvent:function(e,t){var n,o,r="";e.mod=i?e.metaKey:e.ctrlKey&&!e.altKey,e.altKey&&(r+="alt+"),e.shiftKey&&(r+="shift+"),e.ctrlKey&&(r+="ctrl+"),r+=t,n=this._handlers["*+"+t],n&&n.call(this._observer,e,r),o=this._handlers[r],o&&o.call(this._observer,e,r)},on:function(e,t){var n=this._handlers;"string"==typeof t&&(t=this._observer[t]),"string"==typeof e&&(e=e.split(",")),e.forEach(function(e){n[e]=t})},destroy:function(){this.target.off("keydown",this.keyDownProxy),this.target.off("keydown",this.mouseProxy),t(document.documentElement).off("mousemove mouseup",this.mouseProxy)}}),e.spreadsheet.EventListener=s)}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/rangelist.min",["kendo.core.min"],e)}(function(){!function(e){function t(e){if(e.left.level===e.level){var t=e;e=e.left,t.left=e.right,e.right=t}return e}function n(e){if(e.right.right.level===e.level){var t=e;e=e.right,t.right=e.left,e.left=t,e.level+=1}return e}function i(e,o){return e===c?new l(1,o,c,c):(e.value.start>o.start?e.left=i(e.left,o):e.right=i(e.right,o),n(t(e)))}function o(e,i){var r,s;if(e===c)return e;if(r=e.value.start-i.start,0===r)if(e.left!==c&&e.right!==c){for(s=e.left;s.right!==c;)s=s.right;e.value=s.value,e.left=o(e.left,e.value)}else e=e.left===c?e.right:e.left;else r>0?e.left=o(e.left,i):e.right=o(e.right,i);return(e.left.level<e.level-1||e.right.level<e.level-1)&&(e.level-=1,e.right.level>e.level&&(e.right.level=e.level),e=t(e),e.right=t(e.right),e.right.right=t(e.right.right),e=n(e),e.right=n(e.right)),e}function r(e,t){e!==c&&(r(e.left,t),t.push(e.value),r(e.right,t))}function s(e,t,n){if(e!==c){var i=e.value;t.start<i.start&&s(e.left,t,n),i.intersects(t)&&n.push(i),t.end>i.end&&s(e.right,t,n)}}function a(e,t,n){t!==c&&(a(e,t.left,n),e.insert(n(t.value)),a(e,t.right,n))}var l,c,d,u,h,f,p;e.support.browser.msie&&e.support.browser.version<9||(l=e.Class.extend({init:function(e,t,n,i){this.level=e,this.value=t,this.left=n,this.right=i}}),c=new function(){this.left=this,this.right=this,this.level=0},d=e.Class.extend({init:function(e,t,n){this.start=e,this.end=t,this.value=n},intersects:function(e){return e.start<=this.end&&e.end>=this.start},clone:function(){return new d(this.start,this.end,this.value)}}),u=e.Class.extend({init:function(){this.root=c},insert:function(e){this.root=i(this.root,e)},remove:function(e){this.root=o(this.root,e)},findrange:function(e){for(var t=this.root;t!=c;)if(e<t.value.start)t=t.left;else{if(!(e>t.value.end))return t.value;t=t.right}return null},values:function(){var e=[];return r(this.root,e),e},intersecting:function(e,t){var n=[];return s(this.root,new d(e,t),n),n},map:function(e){var t=new u;return a(t,this.root,e),t},clone:function(){return this.map(function(e){return e.clone()})},first:function(){for(var e=this.root;e.left!=c;)e=e.left;return e},last:function(){for(var e=this.root;e.right!=c;)e=e.right;return e}}),h=e.Class.extend({init:function(e,t,n){void 0===t?this.tree=e:(this.tree=new u,this.tree.insert(new d(e,t,n)))},values:function(){return this.tree.values()},map:function(e){return new h(this.tree.map(e))},intersecting:function(e,t){return this.tree.intersecting(e,t)},first:function(){return this.tree.first().value},last:function(){return this.tree.last().value},insert:function(e,t,n){return this.tree.insert(new d(e,t,n))},value:function(e,t,n){var i,o,r,s,a,l,c,d,u;if(void 0===n)return void 0===t&&(t=e),this.intersecting(e,t)[0].value;if(i=this.tree.intersecting(e-1,t+1),i.length)for(o=i[0],r=i[i.length-1],o.end<e&&(o.value===n?e=o.start:i.shift()),r.start>t&&(r.value===n?t=r.end:i.pop()),s=0,a=i.length;s<a;s++)l=i[s],c=l.value,d=l.start,u=l.end,this.tree.remove(l),d<e&&(c!==n?this.insert(d,e-1,c):e=d),u>t&&(c!==n?this.insert(t+1,u,c):t=u);this.insert(e,t,n)},expandedValues:function(e,t){var n,i=this.intersecting(e,t),o=[],r=0;for(n=e;n<=t;n++)i[r].end<n&&r++,o.push({index:n-e,value:i[r].value});return o},sortedIndices:function(e,t,n,i){var o=this.expandedValues(e,t),r=function(e,t){return e.value===t.value?e.index-t.index:n(e.value,t.value)};return i&&(r=function(e,t){var o=i[e.index],r=i[t.index];return o.value===r.value?n(e.value,t.value):e.index-t.index}),o.sort(r),o},sort:function(e,t,n){var i,o,r;if(1!==this.intersecting(e,t).length)for(i=this.expandedValues(e,t),o=0,r=n.length;o<r;o++)this.value(o+e,o+e,i[n[o].index].value)},copy:function(e,t,n){var i,o,r,s,a,l=this.intersecting(e,t),c=n;for(o=0,r=l.length;o<r;o++)s=l[o].start,s<e&&(s=e),a=l[o].end,a>t&&(a=t),i=c+(a-s),this.value(c,i,l[o].value),c=++i},iterator:function(e,t){return new f(e,t,this.intersecting(e,t))},getState:function(){return this.tree.clone()},setState:function(e){this.tree=e.clone()}}),f=e.Class.extend({init:function(e,t,n){this.start=e,this.end=t,this.index=0,this.ranges=n},unique:function(){return this.ranges.map(function(e){return e.value})},at:function(e){for(;this.ranges[this.index]&&this.ranges[this.index].end<e;)this.index++;return this.ranges[this.index]&&this.ranges[this.index].value},forEach:function(e){for(var t=this.start;t<=this.end;t++)e(this.at(t),t);this.index=0}}),p=h.extend({init:function(e,t,n){this.tree=new u,this.range=new d(e,t,n)},intersecting:function(e,t){var n,i,o,r=this.tree.intersecting(e,t),s=[];if(!r.length)return[this.range];for(i=0,o=r.length;i<o;i++)n=r[i],n.start>e&&s.push(new d(e,n.start-1,this.range.value)),s.push(n),e=n.end+1;return n.end<t&&s.push(new d(n.end+1,t,this.range.value)),s},insert:function(e,t,n){n!==this.range.value&&this.tree.insert(new d(e,t,n))},lastRangeStart:function(){var e=this.tree.root;if(e===c)return this.range.start;for(;e.right!==c;)e=e.right;return e.value.end+1}}),e.spreadsheet.RangeTree=u,e.spreadsheet.RangeList=h,e.spreadsheet.SparseRangeList=p,e.spreadsheet.ValueRange=d)}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/propertybag.min",["kendo.core.min"],e)}(function(){!function(e){function t(e){return e.replace(/M/g,"m").replace(/'/g,'"').replace(/tt/,"am/pm")}function n(e){return e=e.clone(),e.value=e.value.deepClone(),e}function i(){var e=this.map(n);return e.clone=i,e}var o,r,s;e.support.browser.msie&&e.support.browser.version<9||(o=e.Class.extend({init:function(e){this.list=e},get:function(e){return this.parse(this.list.value(e,e))},set:function(e,t,n){void 0===n&&(n=t,t=e),this.list.value(e,t,n)},parse:function(e){return e},copy:function(e,t,n){this.list.copy(e,t,n)},iterator:function(e,t){return this.list.iterator(e,t)}}),r=o.extend({set:function(e,t,n){this.list.value(e,t,JSON.stringify(n))},parse:function(e){return JSON.parse(e)}}),s=o.extend({init:function(e,t){o.prototype.init.call(this,e),this.formats=t},set:function(n,i,o){o instanceof Date&&(o=e.spreadsheet.dateToNumber(o),this.formats.value(n,i)||this.formats.value(n,i,t(e.culture().calendar.patterns.d))),this.list.value(n,i,o)}}),e.spreadsheet.PropertyBag=e.Class.extend({specs:[{property:o,name:"format",value:null,sortable:!0,serializable:!0},{property:s,name:"value",value:null,sortable:!0,serializable:!0,depends:"format"},{property:o,name:"formula",value:null,sortable:!0,serializable:!0},{property:o,name:"background",value:null,sortable:!0,serializable:!0},{property:r,name:"vBorders",value:null,sortable:!1,serializable:!1},{property:r,name:"hBorders",value:null,sortable:!1,serializable:!1},{property:o,name:"color",value:null,sortable:!0,serializable:!0},{property:o,name:"fontFamily",value:null,sortable:!0,serializable:!0},{property:o,name:"underline",value:null,sortable:!0,serializable:!0},{property:o,name:"fontSize",value:null,sortable:!0,serializable:!0},{property:o,name:"italic",value:null,sortable:!0,serializable:!0},{property:o,name:"bold",value:null,sortable:!0,serializable:!0},{property:o,name:"textAlign",value:null,sortable:!0,serializable:!0},{property:o,name:"verticalAlign",value:null,sortable:!0,serializable:!0},{property:o,name:"wrap",value:null,sortable:!0,serializable:!0},{property:o,name:"validation",value:null,sortable:!1,serializable:!0},{property:o,name:"enable",value:null,sortable:!1,serializable:!0},{property:o,name:"link",value:null,sortable:!1,serializable:!0
},{property:o,name:"editor",value:null,sortable:!1,serializable:!0}],init:function(t,n,o){o=o||{};var r=t*n-1;this.rowCount=t,this.columnCount=n,this.cellCount=r,this.properties={},this.lists={},this.specs.forEach(function(t){var n,i=t.name,s=o[i];void 0===s&&(s=t.value),this.lists[i]=new e.spreadsheet.SparseRangeList(0,r,s),n=this.properties[i]=new t.property(this.lists[i],this.lists[t.depends]),n.spec=t},this),this.lists.formula.tree.clone=i,this.lists.validation.tree.clone=i},getState:function(){var e={};return this.specs.forEach(function(t){e[t.name]=this.lists[t.name].getState()},this),e},setState:function(e){this.specs.forEach(function(t){this.lists[t.name].setState(e[t.name])},this)},get:function(e,t){if(void 0===t)return this.lists[e];switch(e){case"borderRight":t+=this.rowCount;case"borderLeft":e="vBorders";break;case"borderBottom":t++;case"borderTop":e="hBorders"}return t>this.cellCount?null:this.properties[e].get(t)},set:function(e,t,n,i){switch(e){case"borderRight":t+=this.rowCount,n+=this.rowCount;case"borderLeft":e="vBorders";break;case"borderBottom":t++,n++;case"borderTop":e="hBorders"}t<=n&&n<=this.cellCount&&this.properties[e].set(t,n,i)},fromJSON:function(e,t){var n,i;for(n=0;n<this.specs.length;n++)i=this.specs[n],i.serializable&&void 0!==t[i.name]&&this.set(i.name,e,e,t[i.name],!1);["borderLeft","borderRight","borderTop","borderBottom"].forEach(function(n){void 0!==t[n]&&this.set(n,e,e,t[n])},this)},copy:function(e,t,n){this.specs.forEach(function(i){this.properties[i.name].copy(e,t,n)},this)},iterator:function(e,t,n){var i=this.properties[e],o=i.iterator(t,n),r=o.at,s=this.cellCount;return o.at=function(e){return e>s?null:i.parse(r.call(o,e))},o.name=e,o.value=i.spec.value,o},sortable:function(){return this.specs.filter(function(e){return e.sortable}).map(function(e){return this.lists[e.name]},this)},iterators:function(e,t){return this.specs.reduce(function(n,i){return i.serializable&&n.push(this.iterator(i.name,e,t)),n}.bind(this),[])},forEach:function(e,t,n){function i(e,t,n){var i=t.at(n);i!==t.value&&(o[e]=i)}var o,r,s,a,l,c=this.iterators(e,t),d=this.iterator("hBorders",e,t+1),u=this.iterator("vBorders",e,t),h=this.iterator("vBorders",e+this.rowCount,t+this.rowCount);for(r=e;r<=t;r++){for(o={},s=0;s<c.length;s++)a=c[s],l=a.at(r),l!==a.value&&(o[a.name]=l);i("borderLeft",u,r),i("borderRight",h,r+this.rowCount),i("borderTop",d,r),(r+1)%this.rowCount&&i("borderBottom",d,r+1),n(o)}},forEachProperty:function(e){for(var t in this.properties)e(this.properties[t])}}),e.spreadsheet.ALL_PROPERTIES=e.spreadsheet.PropertyBag.prototype.specs.reduce(function(e,t){return t.serializable&&e.push(t.name),e},["borderTop","borderRight","borderBottom","borderLeft"]))}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/references.min",["kendo.core.min"],e)}(function(){"use strict";function e(t){var n=Math.floor(t/26)-1;return(n>=0?e(n):"")+String.fromCharCode(65+t%26)}function t(e){return/^[a-z0-9_]*$/i.test(e)?e:"'"+e.replace(/\x27/g,"\\'")+"'"}function n(n,i,o,r){var s="";return++i,isFinite(i)?null==r||2&r||(i="$"+i):i="",isFinite(o)?(s=e(o),null==r||1&r||(s="$"+s)):o="",n?t(n)+"!"+s+i:s+i}var i,o,r,s,a,l,c,d;kendo.support.browser.msie&&kendo.support.browser.version<9||(i=kendo.spreadsheet,o=kendo.Class,r=o.extend({type:"ref",sheet:"",clone:function(){return this},hasSheet:function(){return this._hasSheet},simplify:function(){return this},setSheet:function(e,t){return this.sheet=e,null!=t&&(this._hasSheet=t),this},absolute:function(){return this},relative:function(){return this},adjust:function(){return this},toString:function(){return this.relative(0,0,3,3).print(0,0)},forEach:function(e,t){e.call(t,this)},map:function(e,t){return e.call(t,this)},intersects:function(e){return this.intersect(e)!==s},isCell:function(){return!1},toRow:function(){return this},toColumn:function(){return this},first:function(){return this},lastRange:function(){return this},size:function(){return 1},rangeAt:function(){return this},nextRangeIndex:function(){return 0},previousRangeIndex:function(){return 0},eq:function(e){var t,n,i,o,r=this,a=e;if(r===s||a===s)return r===a;if((a instanceof l||a instanceof c&&!(r instanceof l))&&(r=e,a=this),r instanceof l)return a=a.simplify(),a instanceof l&&r.row==a.row&&r.col==a.col&&r.sheet==a.sheet;if(r instanceof c){if(a instanceof c)return a.topLeft.eq(r.topLeft)&&a.bottomRight.eq(r.bottomRight);if(a instanceof d)return a.single()&&r.eq(a.refs[0])}else if(r instanceof d&&a instanceof d){if(t=r.refs,n=a.refs,t.length!=n.length)return!1;for(i=0,o=t.length;i<o;i++)if(!t[i].eq(n[i]))return!1;return!0}return r===a},concat:function(e){return new d([this,e])},replaceAt:function(e,t){return t},forEachColumnIndex:function(e){this.forEachAxisIndex("col",e)},forEachRowIndex:function(e){this.forEachAxisIndex("row",e)},forEachAxisIndex:function(e,t){var n=[],i="row"===e?"forEachRow":"forEachColumn";this[i](function(t){var i=t.first()[e];n.indexOf(i)===-1&&n.push(i)}),n.sort(function(e,t){return e>t?1:e<t?-1:0}).forEach(t)},valid:function(){return!1},renameSheet:function(e,t){if(this.sheet&&this.sheet.toLowerCase()==e.toLowerCase())return this.sheet=t,!0}}),r.display=n,s=new(r.extend({init:function(){},print:function(){return"#NULL!"},eq:function(e){return e===this},forEach:function(){}})),a=r.extend({ref:"name",init:function(e){this.name=e},clone:function(){return new a(this.name).setSheet(this.sheet,this.hasSheet())},print:function(){var e=t(this.name);return this.hasSheet()&&(e=t(this.sheet)+"!"+e),e}}),l=r.extend({ref:"cell",init:function(e,t,n){this.row=e,this.col=t,this.rel=n||0},clone:function(){return new l(this.row,this.col,this.rel).setSheet(this.sheet,this.hasSheet())},intersect:function(e){return e instanceof l?this.eq(e)?this:s:e.intersect(this)},print:function(e,i,o){var r,s,a=this.col,l=this.row,c=this.rel;return null==e&&c?(s=this.hasSheet()?t(this.sheet)+"!":"",a=isFinite(a)?1&c?"C["+a+"]":"C"+(a+1):"",l=isFinite(l)?2&c?"R["+l+"]":"R"+(l+1):"",s+l+a):(r=this.absolute(e,i),o?(l=r.row%1048576,a=r.col%16384,l<0&&(l+=1048576),a<0&&(a+=16384),n(this._hasSheet&&this.sheet,l,a,c)):r.valid()?n(this._hasSheet&&this.sheet,r.row,r.col,c):"#REF!")},absolute:function(e,t){var n=this.clone();return n.rel&!1?n:(1&n.rel&&(n.col=(n.col+t)%16384),2&n.rel&&(n.row=(n.row+e)%1048576),n.rel=0,n)},toRangeRef:function(){return new c(this,this)},relative:function(e,t,n){var i,o;return null==n&&(n=this.rel),i=2&n?this.row-e:this.row,o=1&n?this.col-t:this.col,new l(i,o,n).setSheet(this.sheet,this.hasSheet())},height:function(){return 1},width:function(){return 1},toString:function(){return n(null,this.row,this.col,3)},isCell:function(){return!0},leftColumn:function(){return this},rightColumn:function(){return this},topRow:function(){return this},bottomRow:function(){return this},forEachRow:function(e){e(this.toRangeRef())},forEachColumn:function(e){e(this.toRangeRef())},adjust:function(e,t,n,i,o,r,a){var l=this.absolute(e,t);if(o){if(l.row>=r){if(a<0&&l.row<r-a)return s;l.row+=a}}else if(l.col>=r){if(a<0&&l.col<r-a)return s;l.col+=a}return null!=n&&null!=i&&(l=l.relative(n,i,this.rel)),l},valid:function(){if(this.rel)throw Error("valid() called on relative reference");var e=this.col,t=this.row;return!(isFinite(e)&&e<0||isFinite(t)&&t<0)}}),c=r.extend({ref:"range",init:function(e,t){e._hasSheet&&t._hasSheet&&e.sheet.toLowerCase()!=t.sheet.toLowerCase()&&(this.endSheet=t.sheet),this.topLeft=new l(e.row,e.col,e.rel),this.bottomRight=new l(t.row,t.col,t.rel),this.normalize()},clone:function(){return new c(this.topLeft.clone(),this.bottomRight.clone()).setSheet(this.sheet,this.hasSheet())},_containsRange:function(e){return this._containsCell(e.topLeft)&&this._containsCell(e.bottomRight)},_containsCell:function(e){return e.sheet==this.sheet&&e.row>=this.topLeft.row&&e.col>=this.topLeft.col&&e.row<=this.bottomRight.row&&e.col<=this.bottomRight.col},contains:function(e){if(e instanceof Array){var t=this;return e.some(function(e){return t.contains(e)})}return e instanceof l?this._containsCell(e):e instanceof c&&this._containsRange(e)},_intersectRange:function(e){var t,n,i,o,r,a,d,u;return this.sheet!=e.sheet?s:(t=this.topLeft.col,n=this.topLeft.row,i=this.bottomRight.col,o=this.bottomRight.row,r=e.topLeft.col,a=e.topLeft.row,d=e.bottomRight.col,u=e.bottomRight.row,t<=d&&r<=i&&n<=u&&a<=o?new c(new l(Math.max(n,a),Math.max(t,r)),new l(Math.min(o,u),Math.min(i,d))).setSheet(this.sheet,this.hasSheet()):s)},intersect:function(e){return e instanceof l?this._containsCell(e)?e:s:e instanceof c?this._intersectRange(e).simplify():e instanceof d?e.intersect(this):s},simplify:function(){return this.isCell()?new l(this.topLeft.row,this.topLeft.col,this.topLeft.rel).setSheet(this.sheet,this.hasSheet()):this},normalize:function(){var e,t=this.topLeft,n=this.bottomRight,i=t.row,o=t.col,r=n.row,s=n.col,a=2&t.rel,c=1&t.rel,d=2&n.rel,u=1&n.rel,h=!1;return i>r&&(h=!0,e=i,i=r,r=e,e=a,a=d,d=e),o>s&&(h=!0,e=o,o=s,s=e,e=c,c=u,u=e),h&&(this.topLeft=new l(i,o,c|a),this.bottomRight=new l(r,s,u|d)),this},print:function(e,n,i){if(i||this.absolute(e,n).valid()){var o=this.topLeft.print(e,n,i)+":"+this.bottomRight.print(e,n,i);return this.hasSheet()&&(o=t(this.sheet)+(this.endSheet?":"+t(this.endSheet):"")+"!"+o),o}return"#REF!"},absolute:function(e,t){return new c(this.topLeft.absolute(e,t),this.bottomRight.absolute(e,t)).setSheet(this.sheet,this.hasSheet())},relative:function(e,t,n,i){return null==i&&(i=n),new c(this.topLeft.relative(e,t,n),this.bottomRight.relative(e,t,i)).setSheet(this.sheet,this.hasSheet())},height:function(){if(this.topLeft.rel!=this.bottomRight.rel)throw Error("Mixed relative/absolute references");return this.bottomRight.row-this.topLeft.row+1},width:function(){if(this.topLeft.rel!=this.bottomRight.rel)throw Error("Mixed relative/absolute references");return this.bottomRight.col-this.topLeft.col+1},collapse:function(){return this.topLeft.toRangeRef()},leftColumn:function(){return new c(this.topLeft,new l(this.bottomRight.row,this.topLeft.col))},rightColumn:function(){return new c(new l(this.topLeft.row,this.bottomRight.col),this.bottomRight)},topRow:function(){return new c(this.topLeft,new l(this.topLeft.row,this.bottomRight.col))},bottomRow:function(){return new c(new l(this.bottomRight.row,this.topLeft.col),this.bottomRight)},toRangeRef:function(){return this},toRow:function(e){return e+=Math.max(0,this.topLeft.row),new c(new l(e,this.topLeft.col),new l(e,this.bottomRight.col)).setSheet(this.sheet,this.hasSheet())},toColumn:function(e){return e+=Math.max(0,this.topLeft.col),new c(new l(this.topLeft.row,e),new l(this.bottomRight.row,e)).setSheet(this.sheet,this.hasSheet())},toCell:function(e,t){return e+=Math.max(0,this.topLeft.row),t+=Math.max(0,this.topLeft.col),new l(e,t,0).setSheet(this.sheet,this.hasSheet())},forEachRow:function(e){var t,n=this.topLeft.row,i=this.bottomRight.row,o=this.topLeft.col,r=this.bottomRight.col;for(t=n;t<=i;t++)e(new c(new l(t,o),new l(t,r)))},forEachColumn:function(e){var t,n=this.topLeft.row,i=this.bottomRight.row,o=this.topLeft.col,r=this.bottomRight.col;for(t=o;t<=r;t++)e(new c(new l(n,t),new l(i,t)))},intersecting:function(e){return e.filter(function(e){return e.toRangeRef().intersects(this)},this)},union:function(e,t){var n,i=this.intersecting(e),o=this.topLeft.row,r=this.topLeft.col,s=this.bottomRight.row,a=this.bottomRight.col,d=!1;return i.forEach(function(e){e=e.toRangeRef(),e.topLeft.row<o&&(d=!0,o=e.topLeft.row),e.topLeft.col<r&&(d=!0,r=e.topLeft.col),e.bottomRight.row>s&&(d=!0,s=e.bottomRight.row),e.bottomRight.col>a&&(d=!0,a=e.bottomRight.col),t&&t(e)}),n=new c(new l(o,r),new l(s,a)),d?n.union(e,t):n},resize:function(e){function t(e){return e||0}var n=Math.max.bind(Math,0),i=this.topLeft.row+t(e.top),o=this.topLeft.col+t(e.left),r=this.bottomRight.row+t(e.bottom),a=this.bottomRight.col+t(e.right);return o<0&&a<0||i<0&&r<0?s:i<=r&&o<=a?new c(new l(n(i),n(o)),new l(n(r),n(a))):s},move:function(e,t){return new c(new l(this.topLeft.row+e,this.topLeft.col+t),new l(this.bottomRight.row+e,this.bottomRight.col+t))},first:function(){return this.topLeft.clone().setSheet(this.sheet,this.hasSheet())},isCell:function(){return!this.endSheet&&this.topLeft.eq(this.bottomRight)},toString:function(){return this.topLeft+":"+this.bottomRight},adjust:function(e,t,n,i,o,r,a){var l=this.topLeft.adjust(e,t,n,i,o,r,a),d=this.bottomRight.adjust(e,t,n,i,o,r,a);return l===s&&d===s?s:(l===s?(l=this.topLeft.absolute(e,t),o?l.row=r:l.col=r,null!=n&&null!=i&&(l=l.relative(n,i,this.topLeft.rel))):d===s&&(d=this.bottomRight.absolute(e,t),o?d.row=r-1:d.col=r-1,null!=n&&null!=i&&(d=d.relative(n,i,this.bottomRight.rel))),new c(l,d).setSheet(this.sheet,this.hasSheet()).simplify())},valid:function(){return this.topLeft.valid()&&this.bottomRight.valid()}}),d=r.extend({init:function(e){this.refs=e,this.length=e.length},clone:function(){return new d(this.refs.slice())},intersect:function(e){var t,n,i=[];for(t=0;t<this.length;++t)n=e.intersect(this.refs[t]),n!==s&&i.push(n);return i.length>0?new d(i).simplify():s},simplify:function(){var e=new d(this.refs.reduce(function(e,t){return t=t.simplify(),t!==s&&e.push(t),e},[]));return e.empty()?s:e.single()?e.refs[0]:e},absolute:function(e,t){return new d(this.refs.map(function(n){return n.absolute(e,t)}))},forEach:function(e,t){this.refs.forEach(function(n){n instanceof d?n.forEach(e,t):e.call(t,n)},t)},toRangeRef:function(){return this.refs[0].toRangeRef()},contains:function(e){return this.refs.some(function(t){return t.contains(e)})},map:function(e,t){var n=[];return this.forEach(function(i){n.push(e.call(t,i))}),new d(n)},first:function(){return this.refs[0].first()},lastRange:function(){return this.refs[this.length-1]},size:function(){return this.length},single:function(){return 1==this.length},empty:function(){return 0===this.length},isCell:function(){return this.single()&&this.refs[0].isCell()},rangeAt:function(e){return this.refs[e]},nextRangeIndex:function(e){return e===this.length-1?0:e+1},previousRangeIndex:function(e){return 0===e?this.length-1:e-1},concat:function(e){return new d(this.refs.concat([e]))},print:function(e,t,n){return this.refs.map(function(i){return i.print(e,t,n)}).join(",")},replaceAt:function(e,t){var n=this.refs.slice();return n.splice(e,1,t),new d(n)},leftColumn:function(){return this.map(function(e){return e.leftColumn()})},rightColumn:function(){return this.map(function(e){return e.rightColumn()})},topRow:function(){return this.map(function(e){return e.topRow()})},bottomRow:function(){return this.map(function(e){return e.bottomRow()})},forEachRow:function(e){this.forEach(function(t){t.forEachRow(e)})},forEachColumn:function(e){this.forEach(function(t){t.forEachColumn(e)})},adjust:function(e,t,n,i,o,r,s){return this.map(function(a){return a.adjust(e,t,n,i,o,r,s)}).simplify()},toString:function(){return this.refs.map(function(e){return""+e}).join(", ")},valid:function(){for(var e=this.refs.length;--e>=0;)if(this.refs[e].valid())return!1;return!0},renameSheet:function(e,t){this.refs.forEach(function(n){n.renameSheet(e,t)})}}),i.NULLREF=s,i.SHEETREF=new c(new l(0,0),new l(1/0,1/0)),i.FIRSTREF=new l(0,0),i.Ref=r,i.NameRef=a,i.CellRef=l,i.RangeRef=c,i.UnionRef=d,i.SHEETREF.print=function(){return"#SHEET"})},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/autofillcalculator.min",["kendo.core.min"],e)}(function(){!function(e){var t,n,i;e.support.browser.msie&&e.support.browser.version<9||(t=e.spreadsheet.RangeRef,n=e.spreadsheet.CellRef,i=e.Class.extend({init:function(e){this._grid=e},rectIsVertical:function(e,t,n,i){var o=this._grid.rectangle(e.toRangeRef()),r=this._grid.rectangle(t.toRangeRef());return Math.abs(r[i]-o[i])>Math.abs(o[n]-r[n])},autoFillDest:function(e,i){var o,r,s,a,l,c,d,u=e.topLeft,h=e.bottomRight,f=i.row>=u.row,p=i.col>=u.col;return o=f?p?4:3:p?2:1,4===o?(r=u,s=h,l=i.row>s.row||i.col>s.col,l&&(i=new n(Math.max(i.row,s.row),Math.max(i.col,s.col))),a=this.rectIsVertical(s,i,"right","bottom")?new n(i.row,s.col):new n(s.row,i.col)):3===o?(c=new n(u.col,h.row),i.row>h.row&&this.rectIsVertical(c,i,"left","bottom")?(r=u,a=new n(i.row,h.col)):(r=h,a=new n(u.row,i.col))):2===o?(d=new n(u.row,h.col),i.col>h.col&&!this.rectIsVertical(d,i,"right","top")?(r=u,a=new n(h.row,i.col)):(r=h,a=new n(i.row,u.col))):(r=h,a=this.rectIsVertical(u,i,"left","top")?new n(i.row,u.col):new n(u.row,i.col)),this._grid.normalize(new t(r,a))}}),e.spreadsheet.AutoFillCalculator=i)}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/navigator.min",["kendo.core.min","spreadsheet/autofillcalculator.min"],e)}(function(){!function(e){var t,n,i,o;e.support.browser.msie&&e.support.browser.version<9||(t=e.spreadsheet.RangeRef,n=e.spreadsheet.CellRef,i=e.Class.extend({init:function(e,t,n,i){this.rangeGetter=n,this.prevLeft=function(n){var o=i(this.range(n)),r=this.range(t.prevVisible(o.topLeft[e]));return i(r).topLeft[e]},this.nextRight=function(n){var o=i(this.range(n)),r=this.range(t.nextVisible(o.bottomRight[e]));return i(r).bottomRight[e]},this.nextLeft=function(n){var o=i(this.range(n));return t.nextVisible(o.bottomRight[e])},this.prevRight=function(n){var o=i(this.range(n));return t.prevVisible(o.topLeft[e])}},boundary:function(e,t){this.top=e,this.bottom=t},range:function(e){return this.rangeGetter(e,this.top,this.bottom)}}),o=e.Class.extend({init:function(t){this._sheet=t,this.columns=this._sheet._grid._columns,this.autoFillCalculator=new e.spreadsheet.AutoFillCalculator(t._grid),this.colEdge=new i("col",this._sheet._grid._columns,this.columnRange.bind(this),this.union.bind(this)),this.rowEdge=new i("row",this._sheet._grid._rows,this.rowRange.bind(this),this.union.bind(this))},height:function(e){this._viewPortHeight=e},union:function(e){return this._sheet.unionWithMerged(e)},columnRange:function(e,t,n){return this._sheet._ref(t,e,n-t,1)},rowRange:function(e,t,n){return this._sheet._ref(e,t,1,n-t)},selectionIncludesMergedCells:function(){return this._sheet.select().contains(this._sheet._mergedCells)},setSelectionValue:function(e){var t=this._sheet.selection();setTimeout(function(){t.value(e())})},selectAll:function(){this._sheet.select(this._sheet._sheetRef)},select:function(e,t,n){e=this.refForMode(e,t),n&&(e=this._sheet.select().concat(e)),this._sheet.select(e)},refForMode:function(e,t){var n=this._sheet._grid;switch(t){case"range":e=n.normalize(e);break;case"row":e=n.rowRef(e.row);break;case"column":e=n.colRef(e.col);break;case"sheet":e=this._sheet._sheetRef}return e},startSelection:function(e,n,i,o){if("autofill"==n)this._sheet.startAutoFill();else if(o&&"range"==n){var r=new t(this._sheet.activeCell().first(),e);this._sheet.select(r,!1,!1),this._sheet.startSelection()}else this._sheet.startSelection(),this.select(e,n,i)},completeSelection:function(){this._sheet.completeSelection()},selectForContextMenu:function(e,t){var n=this._sheet;n.select().contains(this.refForMode(e,t))||this.select(e,t)},modifySelection:function(e){var n,i,o=this.determineDirection(e),r=this._sheet,s=this._viewPortHeight,a=r._grid._rows,l=r._grid._columns,c=r.currentOriginalSelectionRange(),d=r.select().toRangeRef(),u=r.activeCell(),h=c.topLeft.clone(),f=c.bottomRight.clone();switch(this.colEdge.boundary(d.topLeft.row,d.bottomRight.row),this.rowEdge.boundary(d.topLeft.col,d.bottomRight.col),o){case"expand-left":h.col=this.colEdge.prevLeft(h.col),n=h;break;case"shrink-right":h.col=this.colEdge.nextLeft(h.col),n=h;break;case"expand-right":f.col=this.colEdge.nextRight(f.col),n=f;break;case"shrink-left":f.col=this.colEdge.prevRight(f.col),n=f;break;case"expand-up":h.row=this.rowEdge.prevLeft(h.row),n=h;break;case"shrink-down":h.row=this.rowEdge.nextLeft(h.row),n=h;break;case"expand-down":f.row=this.rowEdge.nextRight(f.row),n=f;break;case"shrink-up":f.row=this.rowEdge.prevRight(f.row),n=f;break;case"expand-page-up":h.row=a.prevPage(h.row,s);break;case"shrink-page-up":f.row=a.prevPage(f.row,s);break;case"expand-page-down":f.row=a.nextPage(f.row,s);break;case"shrink-page-down":h.row=a.nextPage(h.row,s);break;case"first-col":h.col=l.firstVisible(),f.col=u.bottomRight.col,n=h;break;case"last-col":f.col=l.lastVisible(),h.col=u.topLeft.col,n=f;break;case"first-row":h.row=a.firstVisible(),f.row=u.bottomRight.row,n=h;break;case"last-row":f.row=a.lastVisible(),h.row=u.topLeft.row,n=f;break;case"last":f.row=a.lastVisible(),f.col=l.lastVisible(),h=u.topLeft,n=f;break;case"first":h.row=a.firstVisible(),h.col=l.firstVisible(),f=u.bottomRight,n=h}return i=new t(h,f),this.union(i).intersects(u)?(n&&r.focus(n),void this.updateCurrentSelectionRange(i)):void this.modifySelection(o.replace("shrink","expand"))},moveActiveCell:function(e){var t=this._sheet,i=t.activeCell(),o=i.topLeft,r=i.bottomRight,s=t.originalActiveCell(),a=t._grid._rows,l=t._grid._columns,c=s.row,d=s.col;switch(e){case"left":d=l.prevVisible(o.col);break;case"up":c=a.prevVisible(o.row);break;case"right":d=l.nextVisible(r.col);break;case"down":c=a.nextVisible(r.row);break;case"first-col":d=l.firstVisible();break;case"last-col":d=l.lastVisible();break;case"first-row":c=a.firstVisible();break;case"last-row":c=a.lastVisible();break;case"last":c=a.lastVisible(),d=l.lastVisible();break;case"first":c=a.firstVisible(),d=l.firstVisible();break;case"next-page":c=a.nextPage(r.row,this._viewPortHeight);break;case"prev-page":c=a.prevPage(r.row,this._viewPortHeight)}t.select(new n(c,d))},navigateInSelection:function(e){for(var t,i=this._sheet,o=i.activeCell(),r=o.topLeft,s=i.originalActiveCell(),a=i._grid._rows,l=i._grid._columns,c=s.row,d=s.col,u=i.currentNavigationRange(),h=u.topLeft,f=u.bottomRight,p=!1,m=r.col,g=r.row;!p;){switch(t=new n(c,d),e){case"next":f.eq(t)?(u=i.nextNavigationRange(),c=u.topLeft.row,d=u.topLeft.col):(d=l.nextVisible(m,!0),d>f.col&&(d=h.col,c=a.nextVisible(c,!0)));break;case"previous":h.eq(t)?(u=i.previousNavigationRange(),c=u.bottomRight.row,d=u.bottomRight.col):(d=l.prevVisible(m,!0),d<h.col&&(d=f.col,c=a.prevVisible(c,!0)));break;case"lower":f.eq(t)?(u=i.nextNavigationRange(),c=u.topLeft.row,d=u.topLeft.col):(c=a.nextVisible(g,!0),c>f.row&&(c=h.row,d=l.nextVisible(d,!0)));break;case"upper":h.eq(t)?(u=i.previousNavigationRange(),c=u.bottomRight.row,d=u.bottomRight.col):(c=a.prevVisible(g,!0),c<h.row&&(c=f.row,d=l.prevVisible(d,!0)));break;default:throw Error("Unknown entry navigation: "+e)}p=!this.shouldSkip(c,d),m=d,g=c}i.singleCellSelection()?i.select(new n(c,d)):i.activeCell(new n(c,d))},extendSelection:function(e,n){var i,o=this._sheet,r=o._grid;return"autofill"===n?void this.resizeAutoFill(e):("range"===n?e=r.normalize(e):"row"===n?e=r.rowRef(e.row).bottomRight:"column"===n&&(e=r.colRef(e.col).bottomRight),i=o.originalActiveCell().toRangeRef(),void this.updateCurrentSelectionRange(new t(i.topLeft,e)))},shouldSkip:function(e,t){var i=new n(e,t),o=!1;return this._sheet.forEachMergedCell(function(e){e.intersects(i)&&!e.collapse().eq(i)&&(o=!0)}),o},resizeAutoFill:function(e){var t,n,i,o,r,s=this._sheet,a=s.select(),l=s._autoFillOrigin,c=this.autoFillCalculator.autoFillDest(a,e),d=this.punch(a,c);d||(o=s.range(c)._previewFillFrom(s.range(l)),o&&(n=o.direction,r=o.props,0===n||1==n?(i=r[r.length-1],t=i[i.length-1].value):2===n?(i=r[0],t=i[i.length-1].value):3===n&&(i=r[r.length-1],t=i[0].value))),s.updateAutoFill(c,d,t,n)},determineDirection:function(e){var t=this._sheet.currentSelectionRange(),n=this._sheet.activeCell(),i=n.topLeft.col==t.topLeft.col,o=n.bottomRight.col==t.bottomRight.col,r=n.topLeft.row==t.topLeft.row,s=n.bottomRight.row==t.bottomRight.row;switch(e){case"left":e=o?"expand-left":"shrink-left";break;case"right":e=i?"expand-right":"shrink-right";break;case"up":e=s?"expand-up":"shrink-up";break;case"down":e=r?"expand-down":"shrink-down";break;case"prev-page":e=s?"expand-page-up":"shrink-page-up";break;case"next-page":e=r?"expand-page-down":"shrink-page-down"}return e},updateCurrentSelectionRange:function(e){var t=this._sheet;t.select(t.originalSelect().replaceAt(t.selectionRangeIndex(),e),!1)},punch:function(e,i){var o,r,s;return i.topLeft.eq(e.topLeft)&&(i.bottomRight.row<e.bottomRight.row?(r=this.rowEdge.nextRight(i.bottomRight.row),o=new t(new n(r,e.topLeft.col),e.bottomRight)):i.bottomRight.col<e.bottomRight.col&&(s=this.colEdge.nextRight(i.bottomRight.col),o=new t(new n(e.topLeft.row,s),e.bottomRight))),o}}),e.spreadsheet.SheetNavigator=o)}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/axismanager.min",["kendo.core.min"],e)}(function(){!function(e){if(!(e.support.browser.msie&&e.support.browser.version<9)){var t=e.Class.extend({init:function(e){this._sheet=e},forEachSelectedColumn:function(e){var t=this._sheet;t.batch(function(){t.select().forEachColumnIndex(function(n,i){e(t,n,i)})},{layout:!0,recalc:!0})},forEachSelectedRow:function(e){var t=this._sheet;t.batch(function(){t.select().forEachRowIndex(function(n,i){e(t,n,i)})},{layout:!0,recalc:!0})},includesHiddenColumns:function(e){return this._sheet._grid._columns.includesHidden(e.topLeft.col,e.bottomRight.col)},includesHiddenRows:function(e){return this._sheet._grid._rows.includesHidden(e.topLeft.row,e.bottomRight.row)},selectionIncludesHiddenColumns:function(){return this.includesHiddenColumns(this._sheet.select())},selectionIncludesHiddenRows:function(){return this.includesHiddenRows(this._sheet.select())},deleteSelectedColumns:function(){var e=[];return this.forEachSelectedColumn(function(t,n,i){n-=i;var o=[];e.unshift({index:n,formulas:o,width:t.columnWidth(n)}),t._saveModifiedFormulas(o,function(){t.deleteColumn(n)})}),e},deleteSelectedRows:function(){var e=[];return this.forEachSelectedRow(function(t,n,i){n-=i;var o=[];e.unshift({index:n,formulas:o,height:t.rowHeight(n)}),t._saveModifiedFormulas(o,function(){t.deleteRow(n)})}),e},hideSelectedColumns:function(){var t,n,i,o,r,s,a;for(this.forEachSelectedColumn(function(e,t){e.hideColumn(t)}),t=this._sheet,n=t.select().toRangeRef(),i=n.topLeft.col,o=n.bottomRight.col,r=null;;){if(s=o<t._columns._count,a=i>=0,!a&&!s)break;if(s&&!t.isHiddenColumn(o)){r=o;break}if(a&&!t.isHiddenColumn(i)){r=i;break}i--,o++}null!==r&&(n=new e.spreadsheet.RangeRef(new e.spreadsheet.CellRef(0,r),new e.spreadsheet.CellRef(t._rows._count-1,r)),t.range(n).select())},hideSelectedRows:function(){var t,n,i,o,r,s,a;for(this.forEachSelectedRow(function(e,t){e.hideRow(t)}),t=this._sheet,n=t.select().toRangeRef(),i=n.topLeft.row,o=n.bottomRight.row,r=null;;){if(s=o<t._rows._count,a=i>=0,!a&&!s)break;if(s&&!t.isHiddenRow(o)){r=o;break}if(a&&!t.isHiddenRow(i)){r=i;break}i--,o++}null!==r&&(n=new e.spreadsheet.RangeRef(new e.spreadsheet.CellRef(r,0),new e.spreadsheet.CellRef(r,t._columns._count-1)),t.range(n).select())},unhideSelectedColumns:function(){this.forEachSelectedColumn(function(e,t){e.unhideColumn(t)})},unhideSelectedRows:function(){this.forEachSelectedRow(function(e,t){e.unhideRow(t)})},preventAddRow:function(){var e=this._sheet.select().toRangeRef(),t=e.height();return this._sheet.preventInsertRow(0,t)},preventAddColumn:function(){var e=this._sheet.select().toRangeRef(),t=e.width();return this._sheet.preventInsertColumn(0,t)},addColumnLeft:function(){var e,t=this._sheet,n=0;return t.batch(function(){t.select().forEachColumnIndex(function(i){e||(e=i),t.insertColumn(e),++n})},{recalc:!0,layout:!0}),{base:e,count:n}},addColumnRight:function(){var e,t=this._sheet,n=0;return t.batch(function(){t.select().forEachColumnIndex(function(t){e=t+1,++n});for(var i=0;i<n;++i)t.insertColumn(e)},{recalc:!0,layout:!0}),{base:e,count:n}},addRowAbove:function(){var e,t=this._sheet,n=0;return t.batch(function(){t.select().forEachRowIndex(function(i){e||(e=i),t.insertRow(e),++n})},{recalc:!0,layout:!0}),{base:e,count:n}},addRowBelow:function(){var e,t=this._sheet,n=0;return t.batch(function(){t.select().forEachRowIndex(function(t){e=t+1,++n});for(var i=0;i<n;++i)t.insertRow(e)},{recalc:!0,layout:!0}),{base:e,count:n}}});e.spreadsheet.AxisManager=t}}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/clipboard.min",["kendo.core.min"],e)}(function(){!function(e){function t(){var e=new c(0,0,0);return{ref:e,mergedCells:[],data:[],foreign:!0,origRef:e.toRangeRef()}}function n(e,t,n,i){var o,r=e.data||(e.data=[]);r[t]||(r[t]=[]),r[t][n]=i,o=e.origRef.bottomRight,o.row=Math.max(o.row,t),o.col=Math.max(o.col,n)}function i(e){return e.replace(/^-(?:ms|moz|webkit)-/,"")}function o(e){var t={};return["borderBottom","borderRight","borderLeft","borderTop"].forEach(function(n){t[n]="none"==e[n+"Style"]?null:{size:1,color:e[n+"Color"]}}),t}function r(e){var t=window.getComputedStyle(e),n=e.innerText,r=o(t),s={value:""===n?null:n,borderBottom:r.borderBottom,borderRight:r.borderRight,borderLeft:r.borderLeft,borderTop:r.borderTop,fontSize:parseInt(t["font-size"],10)};return"rgb(0, 0, 0)"!==t["background-color"]&&"rgba(0, 0, 0, 0)"!==t["background-color"]&&(s.background=t["background-color"]),"rgb(0, 0, 0)"!==t.color&&"rgba(0, 0, 0, 0)"!==t.color&&(s.color=t.color),"underline"==t["text-decoration"]&&(s.underline=!0),"italic"==t["font-style"]&&(s.italic=!0),"bold"==t["font-weight"]&&(s.bold=!0),"right"!==i(t["text-align"])&&(s.textAlign=i(t["text-align"])),"middle"!==t["vertical-align"]&&(s.verticalAlign=t["vertical-align"]),"normal"!==t["word-wrap"]&&(s.wrap=!0),s}function s(i){var o,s,a,l,d,u,h,f,p,m,g,v=t(),_=[],b=0,w=0;for(o=0;o<i.rows.length;++o)_.push([]);for(s=0;s<i.rows.length;++s,++b)for(a=i.rows[s],w=0,l=0;l<a.cells.length;++l){for(d=a.cells[l],u=d.rowSpan,h=d.colSpan;_[b][w];)w++;for(f=d.getAttribute("style"),p=/mso-ignore:colspan/.test(f),n(v,b,w,r(d)),(u>1||h>1&&!p)&&v.mergedCells.push(""+new e.spreadsheet.RangeRef(new c(b,w),new c(b+u-1,w+h-1))),m=b+u;--m>=b;)for(g=w+h;--g>=w;)m<_.length&&(_[m][g]=!0,m==b&&g==w||n(v,m,g,{}))}return v}function a(e){var i,o,r,s,a=t();if(e.indexOf("\t")===-1&&e.indexOf("\n")==-1)n(a,0,0,{value:e});else for(i=e.split("\n"),o=0;o<i.length;o++)for(r=i[o].split("\t"),s=0;s<r.length;s++)n(a,o,s,{value:r[s]});return a}var l,c,d;e.support.browser.msie&&e.support.browser.version<9||(l=e.jQuery,c=e.spreadsheet.CellRef,d=e.Class.extend({init:function(t){this._content={},this._externalContent={},this._internalContent={},this.workbook=t,this.origin=e.spreadsheet.NULLREF,this.iframe=document.createElement("iframe"),this.iframe.className="k-spreadsheet-clipboard-paste",this.menuInvoked=!1,this._uid=e.guid(),document.body.appendChild(this.iframe)},destroy:function(){document.body.removeChild(this.iframe)},canCopy:function(){var t={canCopy:!0},n=this.workbook.activeSheet().select();return n===e.spreadsheet.NULLREF&&(t.canCopy=!1),n instanceof e.spreadsheet.UnionRef&&(t.canCopy=!1,t.multiSelection=!0),this.menuInvoked&&(t.canCopy=!1,t.menuInvoked=!0),t},canPaste:function(){var e=this.workbook.activeSheet(),t=this.pasteRef(),n=e.range(t),i={canPaste:!0,pasteOnMerged:!1,pasteOnDisabled:!1};return n.enable()||(i.canPaste=!1,i.pasteOnDisabled=!0),t.eq(e.unionWithMerged(t))||(i.canPaste=!1,i.pasteOnMerged=!0),this.menuInvoked&&(i.canPaste=!1,i.menuInvoked=!0),(t.bottomRight.row>=e._rows._count||t.bottomRight.col>=e._columns._count)&&(i.canPaste=!1,i.overflow=!0),i},intersectsMerged:function(){var e,t=this.workbook.activeSheet();return this.parse(),this.origin=this._content.origRef,e=this.pasteRef(),!e.eq(t.unionWithMerged(e))},copy:function(){var e=this.workbook.activeSheet();this.origin=e.select(),this._internalContent=e.selection().getState(),delete this._externalContent.html,delete this._externalContent.plain},cut:function(){var e=this.workbook.activeSheet();this.copy(),e.range(e.select()).clear()},pasteRef:function(){var t,n,i,o,r=this.workbook.activeSheet();return this.origin===e.spreadsheet.NULLREF?r.select():(t=r.activeCell().first(),n=this.origin.first(),i=n.row-t.row,o=n.col-t.col,this.origin.relative(i,o,3))},
paste:function(){var e=this.workbook.activeSheet(),t=this.pasteRef();e.range(t).setState(this._content,this),e.triggerChange({recalc:!0,ref:t})},external:function(e){return e&&(e.html||e.plain)?void(this._externalContent=e):this._externalContent},isExternal:function(){return!this._isInternal()},parse:function(){var e,n,i,o=t();this._isInternal()?o=this._internalContent:(e=this._externalContent,e.html?(n=this.iframe.contentWindow.document,n.open(),n.write(e.html),n.close(),i=n.querySelector("table"),o=i?s(i):a(e.plain)):o=a(e.plain),this.origin=o.origRef),this._content=o},_isInternal:function(){var e,t;return void 0===this._externalContent.html||(e=!!l("<div/>").html(this._externalContent.html).find("table.kendo-clipboard-"+this._uid).length,t=!!l("<div/>").html(this._externalContent.plain).find("table.kendo-clipboard-"+this._uid).length,e||t)}}),e.spreadsheet.Clipboard=d)}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/range.min",["kendo.core.min","util/text-metrics.min","util/main.min"],e)}(function(){!function(e){function t(e,n,i){for(;e<=n&&i(e);)e++;if(e>n)return[];for(var o=e+1;o<=n;++o)if(i(o))return[{begin:e,end:o-1}].concat(t(o+1,n,i));return[{begin:e,end:n}]}function n(e){return e.replace(/M/g,"m").replace(/'/g,'"').replace(/tt/,"am/pm")}function i(t){return!/^=/.test(t)&&/number|percent/.test(e.spreadsheet.calc.parse(null,0,0,t).type)}function o(t,n,i,o){var r={baselineMarkerSize:0,width:o===!0?n+"px":"auto","font-size":(i||12)+"px","word-break":o===!0?"break-all":"normal","white-space":o===!0?"pre-wrap":"pre"};return e.util.measureText(t,r,{box:u,normalizeText:!1}).height}var r,s,a,l,c,d,u;e.support.browser.msie&&e.support.browser.version<9||(r=e.jQuery,s=e.spreadsheet.UnionRef,a=e.spreadsheet.CellRef,l=e.spreadsheet.RangeRef,c=["color","fontFamily","underline","italic","bold","textAlign","verticalAlign","background","format","link","editor","borderTop","borderRight","borderBottom","borderLeft"],d=e.Class.extend({init:function(e,t){this._sheet=t,this._ref=e},clone:function(){return new d(this._ref.clone(),this._sheet)},skipHiddenCells:function(){var e=[],n=this,i=n._sheet,o=i.isHiddenRow.bind(i),r=i.isHiddenColumn.bind(i);return n._ref.forEach(function(i){var s,c,d,u,h,f;for(i=n._normalize(i.toRangeRef()),s=i.topLeft,c=i.bottomRight,d=t(s.row,c.row,o),u=t(s.col,c.col,r),h=0;h<d.length;++h)for(f=0;f<u.length;++f)e.push(new l(new a(d[h].begin,u[f].begin),new a(d[h].end,u[f].end)))}),i.range(e.length>1?new s(e):e[0])},_normalize:function(e){return this._sheet._grid.normalize(e)},_set:function(e,t,n){var i=this,o=i._sheet;return i._ref.forEach(function(n){o._set(n.toRangeRef(),e,t)}),n||o.triggerChange({recalc:"formula"==e||"value"==e||"validation"==e,value:t,range:i,ref:i._ref}),i},_get:function(e){return this._sheet._get(this._ref.toRangeRef(),e)},_property:function(e,t){return void 0===t?this._get(e):this._set(e,t)},value:function(e){return void 0!==e&&this._set("formula",null,!0),this._property("value",e)},resize:function(e){var t=this._resizedRef(e);return new d(t,this._sheet)},_resizedRef:function(e){return this._ref.map(function(t){return t.toRangeRef().resize(e)})},input:function(t,o){var s,a,l,c,d,u,h;return o=r.extend({arrayFormula:!1},o),s=this._get("format"),void 0!==t?(l=this._ref.toRangeRef().topLeft,a=e.spreadsheet.calc.parse(this._sheet.name(),l.row,l.col,t,s),this._sheet.batch(function(){var i,r=null;"exp"==a.type?r=e.spreadsheet.calc.compile(a):"@"!=s?(i=s&&e.spreadsheet.formatting.type(a.value,s),"date"==a.type&&"date"!=i?this.format(a.format||n(e.culture().calendar.patterns.d)):"percent"==a.type&&"percent"!=i?this.format(100*a.value==(100*a.value|0)?"0%":"0.00%"):a.format&&(!s||a.currency||"number"==i&&"number"==a.type&&a.format.length>s.length)&&this.format(a.format)):"string"!=a.type&&(a.value=t),this.formula(r,o.arrayFormula),r||this.value(a.value)}.bind(this),{recalc:!0,value:t,ref:this._ref,editorChange:this._sheet.isInEditMode()}),this):(t=this._get("value"),c=this._get("formula"),d=s&&!c&&e.spreadsheet.formatting.type(t,s),c?t="="+c:s&&"date"==d&&(u=e.spreadsheet.formatting.text(t,s),a=e.spreadsheet.calc.parse(null,null,null,u,s),h=e.spreadsheet.formatting.text(a.value,s),u==h)?t=u:"date"===d?t=e.toString(e.spreadsheet.numberToDate(t),e.culture().calendar.patterns.d):"percent"===d?t=100*t+"%":"string"==typeof t&&(/^[=']/.test(t)||/^(?:true|false)$/i.test(t)||i(t))&&(t="'"+t),t)},enable:function(t){return void 0===t?!e.util.withExit(function(e){this._sheet.forEach(this._ref,function(t,n,i){i.enable===!1&&e(!0)})},this):this._property("enable",t)},formula:function(e,t){var n,i,o=this;return void 0===e?(n=o._get("formula"),n?""+n:null):(t?(i=this._ref.toRangeRef(),e=o._sheet.range(i.topLeft)._set("formula",e)._get("formula"),e&&e.setArrayFormulaRange(i)):o._set("formula",e),o)},intersectingArrayFormula:function(){var t=this._ref.clone().simplify().setSheet(this._sheet.name());return e.util.withExit(function(n){this._sheet._forFormulas(function(i){var o=i.arrayFormulaRange;o&&(o=t.intersect(o))!==e.spreadsheet.NULLREF&&n({formula:i,intersection:o})})},this)},canEditArrayFormula:function(){var e=this.intersectingArrayFormula();return!e||e.formula.arrayFormulaRange.eq(e.intersection)},validation:function(e){if(void 0===e){var t=this._get("validation");return t?t.toJSON():null}return this._property("validation",e)},_getValidationState:function(){var e,t,n,i=this._ref.toRangeRef(),o=i.topLeft.row,r=i.topLeft.col,s=i.bottomRight.row,a=i.bottomRight.col;for(e=r;e<=a;e++)for(t=o;t<=s;t++)if(n=this._sheet._validation(t,e),n&&"reject"===n.type&&n.value===!1)return n;return!1},merge:function(){return this._ref=this._sheet._merge(this._ref),this},unmerge:function(){var e=this._sheet._mergedCells;return this._ref.forEach(function(t){t.toRangeRef().intersecting(e).forEach(function(t){e.splice(e.indexOf(t),1)})}),this._sheet.triggerChange({}),this},select:function(){return this._sheet.select(this._ref),this},values:function(t){var n,i,o,r,a,l,c,d,u,h;if(this._ref instanceof s)throw Error("Unsupported for multiple ranges.");if(this._ref===e.spreadsheet.NULLREF){if(void 0!==t)throw Error("Unsupported for NULLREF.");return[]}if(n=this._ref.toRangeRef(),i=n.topLeft.row,o=n.topLeft.col,r=n.bottomRight.row,a=n.bottomRight.col,void 0===t){for(t=Array(n.height()),d=0;d<t.length;d++)t[d]=Array(n.width());for(l=o;l<=a;l++)for(c=i;c<=r;c++)t[c-i][l-o]=this._sheet._value(c,l);return t}for(this._sheet._set(n,"formula",null),l=o;l<=a;l++)for(c=i;c<=r;c++)u=t[c-i],u&&(h=u[l-o],void 0!==h&&this._sheet._value(c,l,h));return this._sheet.triggerChange({recalc:!0,ref:n}),this},_properties:function(t){var n,i,o,r,a,l,c,d,u,h,f;if(this._ref instanceof s)throw Error("Unsupported for multiple ranges.");if(this._ref===e.spreadsheet.NULLREF){if(void 0!==t)throw Error("Unsupported for NULLREF.");return[]}if(n=this._ref.toRangeRef(),i=n.topLeft.row,o=n.topLeft.col,r=n.bottomRight.row,a=n.bottomRight.col,d=this._sheet,void 0===t)return t=Array(n.height()),d.forEach(n,function(e,n,r){e-=i,n-=o;var s=t[e]||(t[e]=[]);s[n]=r}),t;for(n=n.clone(),h=function(e){var t=u[e];n.topLeft.row=n.bottomRight.row=c,n.topLeft.col=n.bottomRight.col=l,"value"==e&&d._set(n,"formula",null),d._set(n,e,t)},l=o;l<=a;l++)if(!d.isHiddenColumn(l))for(c=i;c<=r;c++)f=t[c-i],f&&!d.isHiddenRow(c)&&(u=f[l-o],u&&Object.keys(u).forEach(h));return d.triggerChange({recalc:!0,ref:this._ref}),this},clear:function(e){var t,n,i;return e=e||{},t=e.clearAll||!Object.keys(e).length,n=this._sheet,i={recalc:t||e.contentsOnly,ref:this._ref},n.batch(function(){i.recalc&&this.formula(null),t&&this.validation(null),(t||e.formatOnly)&&(c.forEach(function(t){e.keepBorders&&/^border/i.test(t)||this[t](null)}.bind(this)),this.unmerge())}.bind(this),i),this},clearContent:function(){return this.clear({contentsOnly:!0})},clearFormat:function(){return this.clear({formatOnly:!0})},isSortable:function(){return!this.cantSort()},cantSort:function(){var t,n,i,o,r,l;if(this._ref instanceof s)return{code:"cantSortMultipleSelection",message:"Unsupported for multiple ranges."};if(this._ref===e.spreadsheet.NULLREF)return{code:"cantSortNullRef",message:"Unsupported for NULLREF."};t=this._sheet._getMergedCells(this._ref.toRangeRef()),n=t.primary,i=t.secondary,o=null,r=null,l={};try{this._sheet.forEach(this,function(e,s){var c=new a(e,s).print(),d=n[c];if(d){if(null===o)o=d.width(),r=d.height();else if(o!=d.width()||r!=d.height())throw l}else if(!i[c]&&t.hasMerged)throw l})}catch(c){if(c!==l)throw c;return{code:"cantSortMixedCells",message:"Unsupported for range containing cells of different shapes."}}return!1},sort:function(e){var t=this.cantSort();if(t)throw Error(t.message);return void 0===e&&(e={column:0}),e=e instanceof Array?e:[e],this._sheet._sortBy(this._ref.toRangeRef(),e.map(function(e,t){return"number"==typeof e&&(e={column:e}),{index:void 0===e.column?t:e.column,ascending:void 0===e.ascending||e.ascending}})),this},isFilterable:function(){return!(this._ref instanceof s)},filter:function(e){if(this._ref instanceof s)throw Error("Unsupported for multiple ranges.");return e===!1?this.clearFilters():(e=e===!0?[]:e instanceof Array?e:[e],this._sheet._filterBy(this._ref.toRangeRef(),e.map(function(e,t){return{index:void 0===e.column?t:e.column,filter:e.filter}}))),this},clearFilter:function(e){this._sheet.clearFilter(e)},clearFilters:function(){var e,t=this._sheet.filter(),n=[];if(t){for(e=0;e<t.columns.length;e++)n.push(e);this._sheet.batch(function(){this.clearFilter(n),this._filter=null},{layout:!0,filter:!0})}},hasFilter:function(){var e=this._sheet.filter();return!!e},leftColumn:function(){return new d(this._ref.leftColumn(),this._sheet)},rightColumn:function(){return new d(this._ref.rightColumn(),this._sheet)},topRow:function(){return new d(this._ref.topRow(),this._sheet)},bottomRow:function(){return new d(this._ref.bottomRow(),this._sheet)},column:function(e){return new d(this._ref.toColumn(e),this._sheet)},row:function(e){return new d(this._ref.toRow(e),this._sheet)},forEachRow:function(e){this._ref.forEachRow(function(t){e(new d(t,this._sheet))}.bind(this))},forEachColumn:function(e){this._ref.forEachColumn(function(t){e(new d(t,this._sheet))}.bind(this))},sheet:function(){return this._sheet},topLeft:function(){return this._ref.toRangeRef().topLeft},intersectingMerged:function(){var e=this._sheet,t=[];return e._mergedCells.forEach(function(e){e.intersects(this._ref)&&t.push(""+e)}.bind(this)),t},getState:function(t){var n,i,o=this._ref.first(),r={ref:o,data:[],origRef:this._ref};return t?n="input"===t?["value","formula"]:"border"===t?["borderLeft","borderTop","borderRight","borderBottom"]:[t]:(n=e.spreadsheet.ALL_PROPERTIES,r.mergedCells=this.intersectingMerged()),i=r.data,this.forEachCell(function(t,r,s){var a={},l=t-o.row,c=r-o.col;i[l]||(i[l]=[]),i[l][c]=a,n.forEach(function(t){var n=void 0===s[t]?null:s[t];(n instanceof e.spreadsheet.calc.runtime.Formula||n instanceof e.spreadsheet.validation.Validation)&&(n=n.deepClone()),a[t]=n})}),r},setState:function(e,t){var n=this._sheet,i=this._ref.first(),o=e.ref.row-i.row,r=e.ref.col-i.col,s=t&&!t.isExternal(),a=t&&!s;n.batch(function(){var l,c;e.mergedCells&&this.unmerge(),l=i.row,c=this.hasFilter(),e.data.forEach(function(o,r){if(!(c&&s&&n.isHiddenRow(e.ref.row+r))){var d=i.col;o.forEach(function(o,u){var h,f;if(!(c&&s&&n.isHiddenColumn(e.ref.col+u))){if(h=t?n.range(l,d):n.range(i.row+r,i.col+u),h.enable()){for(f in o)"value"!=f&&(t&&"enable"==f||h._set(f,o[f]));if(!o.formula)if(a)try{null==o.value?h._set("value",null):h.input(o.value)}catch(p){h._set("value",o.value)}else h._set("value",o.value)}d++}}),l++}}),e.mergedCells&&e.mergedCells.forEach(function(e){e=n._ref(e).relative(o,r,3),n.range(e).merge()},this)}.bind(this),{recalc:!0,ref:this._ref})},_adjustRowHeight:function(){var t,n=this._sheet,i=this.getState(),o=[];for(t=0;t<i.mergedCells.length;t++)o.push(n.range(i.mergedCells[t]));this.forEachRow(function(t){if(!(t.topLeft().row>=t.sheet()._rows._count)){var i=t.sheet().rowHeight(t.topLeft().row);t.forEachCell(function(t,r,s){var a,l,c=n.range(t,r),d=0;for(a=0;a<o.length;a++)if(c._ref.intersects(o[a]._ref)){d+=s.width;break}l=Math.max(n.columnWidth(r),d),i=Math.max(i,e.spreadsheet.util.getTextHeight(s.value,l,s.fontSize,s.wrap))}),n.rowHeight(t.topLeft().row,Math.max(n.rowHeight(t.topLeft().row),i))}})},forEachCell:function(e){this._ref.forEach(function(t){this._sheet.forEach(t.toRangeRef(),e.bind(this))}.bind(this))},hasValue:function(){var t=this._sheet._defaultCellStyle;return e.util.withExit(function(e){this.forEachCell(function(n,i,o){var r,s;for(r in o)s=o[r],void 0!==s&&null!==s&&s!==t[r]&&e(!0)})},this)},wrap:function(t){return void 0===t?!!this._property("wrap"):(this.forEachRow(function(t){var n=t.sheet().rowHeight(t.topLeft().row);t.forEachCell(function(t,i,o){var r=this._sheet.columnWidth(i);null!==o.value&&void 0!==o.value&&(n=Math.max(n,e.spreadsheet.util.getTextHeight(o.value,r,o.fontSize,!0)))}),t.sheet().rowHeight(t.topLeft().row,n)}.bind(this)),this._property("wrap",t),this)},fontSize:function(t){return void 0===t?this._property("fontSize"):(this.forEachRow(function(n){var i=n.sheet().rowHeight(n.topLeft().row);n.forEachCell(function(n,o,r){var s=this._sheet.columnWidth(o);null!==r.value&&void 0!==r.value&&(i=Math.max(i,e.spreadsheet.util.getTextHeight(r.value,s,t,r.wrap)))}),n.sheet().rowHeight(n.topLeft().row,i)}.bind(this)),this._property("fontSize",t),this)},draw:function(e,t){this._sheet.draw(this,e,t)},insideBorders:function(e){return this.insideVerticalBorders(e).insideHorizontalBorders(e)},insideVerticalBorders:function(e){return this._ref.forEach(function(t){t instanceof l&&t.width()>1&&(t=t.clone(),t.topLeft.col++,this._sheet.range(t)._set("vBorders",e))},this),this},insideHorizontalBorders:function(e){return this._ref.forEach(function(t){t instanceof l&&t.height()>1&&(t=t.clone(),t.topLeft.row++,this._sheet.range(t)._set("hBorders",e))},this),this}}),r.each(c,function(e,t){d.prototype[t]=function(e){return this._property(t,e)}}),u=r('<div style="position: absolute !important; top: -4000px !important; height: auto !important;padding: 1px !important; margin: 0 !important; border: 1px solid black !important;line-height: normal !important; visibility: hidden !important;white-space: pre-wrap; word-break: break-all;" />')[0],e.spreadsheet.util={getTextHeight:o},e.spreadsheet.Range=d)}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/runtime.min",["spreadsheet/references.min"],e)}(function(){"use strict";function e(t){return t instanceof e?t:void(this.code=t)}function t(e,t,n){for(var i,o=n(e),r=e;++e<t;)i=n(e),i>o&&(o=i,r=e);return r}function n(e,t){if(e.constructor!==t.constructor)return!1;if(e instanceof A)return e.sheet==t.sheet&&e.row==t.row&&e.col==t.col&&e.rel==t.rel;if(e instanceof E)return n(e.topLeft,t.topLeft)&&n(e.bottomRight,t.bottomRight)&&e.endSheet==t.endSheet;if(e instanceof I){var i=e.refs.length;if(i!=t.refs.length)return!1;for(;--i>=0;)if(!n(e.refs[i],t.refs[i]))return!1}return!0}function i(t,n){function i(e){var t,n,o,s;return c=e[0],t="{ ",Array.isArray(c)?(h+="while (i < args.length) { ",f+="while (i < args.length) { ",t+="xargs.push(tmp = []); stack.push(xargs); xargs = tmp; ",t+="while (i < args.length) { ",t+=e.map(i).join(""),t+="} ",t+="xargs = stack.pop(); ",f+="} ",h+="} "):"+"==c?(h+="while (i < args.length) { ",f+="while (i < args.length) { ",t+="if (i >= args.length) return new CalcError('N/A'); ",t+="xargs.push(tmp = []); stack.push(xargs); xargs = tmp; ",t+="do { ",t+=e.slice(1).map(i).join(""),t+="} while (i < args.length); ",t+="xargs = stack.pop(); ",f+="} ",h+="} "):"?"==c?t+="if (!("+l(e[1])+")) return new CalcError(err); ":(n=e[1],Array.isArray(n)&&/^#?collect/.test(n[0])?(o=n[2],r(),t+="try {var $"+c+" = this.cellValues(args.slice(i",o&&(t+=", i + "+o),t+=")).filter(function($"+c+"){ ","collect"==n[0]&&(t+="if ($"+c+" instanceof CalcError) throw $"+c+"; "),t+="return "+l(n[1])+"; }, this); ",t+=o?"i += "+o+"; ":"i = args.length; ",t+="xargs.push($"+c+")} catch(ex) { if (ex instanceof CalcError) return ex; throw ex; } ",f+="toResolve.push(args.slice(i)); "):"rest"==n?t+="xargs.push(args.slice(i)); i = args.length; ":((g=/^\*/.test(c))&&(v=!0,c=c.substr(1)),t+="var $"+c+" = args[i++]; ",s=!1,/!$/.test(n)?(n=n.substr(0,n.length-1),s=!0):t+="if ($"+c+" instanceof CalcError) return $"+c+"; ",t+=a(n,s)+"xargs.push($"+c+"); ")),t+="} "}function r(){return d?"$"+c:(m=!0,d=!0,f+="toResolve.push(args[i++]); ","($"+c+" = this.force($"+c+"))")}function s(e){return"("+(e?"(typeof "+r()+" == 'number' ? ($"+c+" = round($"+c+"), true) : false) || ":"(typeof "+r()+" == 'number') || ")+"(typeof $"+c+" == 'boolean') || (typeof $"+c+" == 'string' && !/^(?:=|true|false)/i.test($"+c+") ? (tmp = kendo.spreadsheet.calc.parse(0, 0, 0, $"+c+"), /^date|number|percent$/.test(tmp.type) ? ($"+c+" = +tmp.value, true) : false) : false))"}function a(e,t){d=!1;var n="if (!("+l(e)+")) { ";return d&&!t&&(n+=" if ($"+c+" instanceof CalcError) return $"+c+"; "),n+="return new CalcError(err); } ",d||(f+="i++; "),h+=g?"var $"+c+" = this._arrayArg(args[i]); if ($"+c+") { xargs.push($"+c+"); width = Math.max(width, $"+c+".width); height = Math.max(height, $"+c+".height); arrays.push(true) } else { xargs.push(args[i]); arrays.push(false); } i++; ":"xargs.push(args[i++]); arrays.push(false); ",n}function l(e){if(Array.isArray(e)){if("or"==e[0])return"("+e.slice(1).map(l).join(") || (")+")";if("and"==e[0])return"("+e.slice(1).map(l).join(") && (")+")";if("values"==e[0])return"("+e.slice(1).map(function(e){return r()+" === "+e}).join(") || (")+")";if("null"==e[0])return"("+l("null")+" ? (($"+c+" = "+e[1]+"), true) : false)";if("between"==e[0]||"[between]"==e[0])return"("+r()+" >= "+e[1]+" && $"+c+" <= "+e[2]+" ? true : ((err = 'NUM'), false))";if("(between)"==e[0])return"("+r()+" > "+e[1]+" && $"+c+" < "+e[2]+" ? true : ((err = 'NUM'), false))";if("(between]"==e[0])return"("+r()+" > "+e[1]+" && $"+c+" <= "+e[2]+" ? true : ((err = 'NUM'), false))";if("[between)"==e[0])return"("+r()+" >= "+e[1]+" && $"+c+" < "+e[2]+" ? true : ((err = 'NUM'), false))";if("assert"==e[0]){var t=e[2]||"N/A";return"(("+e[1]+") ? true : (err = "+JSON.stringify(t)+", false))"}if("not"==e[0])return"!("+l(e[1])+")";throw Error("Unknown array type condition: "+e[0])}if("number"==e||"datetime"==e)return s(!0);if("integer"==e||"date"==e)return"("+s()+" && (($"+c+" |= 0), true))";if("divisor"==e)return"("+s(!0)+" && ($"+c+" == 0 ? ((err = 'DIV/0'), false) : true))";if("number+"==e)return"("+s(!0)+" && ($"+c+" >= 0 ? true : ((err = 'NUM'), false)))";if("integer+"==e)return"("+s()+" && (($"+c+" |= 0) >= 0 ? true : ((err = 'NUM'), false)))";if("number++"==e)return"("+s(!0)+" && ($"+c+" > 0 ? true : ((err = 'NUM'), false)))";if("integer++"==e)return"("+s()+" && (($"+c+" |= 0) > 0 ? true : ((err = 'NUM'), false)))";if("string"==e)return"((typeof "+r()+" == 'string' || typeof $"+c+" == 'boolean' || typeof $"+c+" == 'number') ? ($"+c+" += '', true) : ($"+c+" === undefined ? (($"+c+" = ''), true) : false))";if("boolean"==e)return"(typeof "+r()+" == 'boolean')";if("logical"==e)return"(typeof "+r()+" == 'boolean' || (typeof $"+c+" == 'number' ? ($"+c+" = !!$"+c+", true) : false))";if("matrix"==e)return r(),"((m = this.asMatrix($"+c+")) ? ($"+c+" = m) : false)";if("#matrix"==e)return"((m = this.asMatrix($"+c+")) ? ($"+c+" = m) : false)";if("ref"==e)return"($"+c+" instanceof kendo.spreadsheet.Ref)";if("area"==e)return"($"+c+" instanceof kendo.spreadsheet.CellRef || $"+c+" instanceof kendo.spreadsheet.RangeRef)";if("cell"==e)return"($"+c+" instanceof kendo.spreadsheet.CellRef)";if("null"==e)return"("+r()+" == null)";if("anyvalue"==e)return"("+r()+" != null && i <= args.length)";if("forced"==e)return"("+r()+", i <= args.length)";if("anything"==e)return"(i <= args.length)";if("blank"==e)return"("+r()+" == null || $"+c+" === '')";throw Error("Can't check for type: "+e)}var c,d,u,h="function arrayArgs(args) { var xargs = [], width = 0, height = 0, arrays = [], i = 0; ",f="function resolve(args, callback) { var toResolve = [], i = 0; ",p="'use strict'; function check(args) { var stack = [], tmp, xargs = [], i = 0, m, err = 'VALUE'; ",m=!1,g=!1,v=!1;return p+=n.map(i).join(""),p+="if (i < args.length) return new CalcError('N/A'); ",p+="return xargs; } ",h+="return { args: xargs, width: width, height: height, arrays: arrays }; } ",m?(f+="this.resolveCells(toResolve, callback); } ",u=Function("CalcError","round",p+f+h+" return { resolve: resolve, check: check, arrayArgs: arrayArgs };")):u=Function("CalcError","round",p+" return { check: check };"),u=u(e,o),v||delete u.arrayArgs,u}function o(e){return+e.toPrecision(14)}function r(e){return"number"==typeof e?o(e):e}function s(t,n,i){if(i instanceof e)return i;try{return n.apply(t,i)}catch(o){if(o instanceof e)return o;throw o}}function a(e,t,n,i){return function(o,r){function a(){var t,a,l,c,d,u,h;if(i&&(t=i.call(this,r),r=t.args,t.width>0&&t.height>0)){for(a=new F(this),l=0;l<t.height;++l)for(c=0;c<t.width;++c){for(d=[],u=0;u<r.length;++u)t.arrays[u]?(h=r[u],d[u]=h.get(l%h.height,c%h.width)):d[u]=r[u];d=n.call(this,d),a.set(l,c,s(this,e,d))}return o(a)}d=n.call(this,r),o(s(this,e,d))}t?t.call(this,r,a):a.call(this)}}function l(t,n,i,o){return function(r,s){function a(){var n,a,l,c,d,u,h,f,p;if(o&&(n=o.call(this,s),s=n.args,n.width>0&&n.height>0))for(a=new F(this),l=n.width*n.height,c=function(e,t){return function(n){if(a.set(e,t,n),--l,0===l)return r(a)}},d=0;d<n.height&&l>0;++d)for(u=0;u<n.width&&l>0;++u){for(h=[],f=0;f<s.length;++f)n.arrays[f]?(p=s[f],h[f]=p.get(d%p.height,u%p.width)):h[f]=s[f];if(h=i.call(this,h),h instanceof e){if(a.set(d,u,h),--l,0===l)return r(a)}else h.unshift(c(d,u)),t.apply(this,h)}else n=i.call(this,s),n instanceof e?r(n):(n.unshift(r),t.apply(this,n))}n?n.call(this,s,a):a.call(this)}}function c(e,t){return e=e.toLowerCase(),P[e]=t,{args:function(n,o){var r,s=i(e,n);return o&&(s.arrayArgs&&console.log(""+s.arrayArgs),s.resolve&&console.log(""+s.resolve),s.check&&console.log(""+s.check)),r=P[e]=a(t,s.resolve,s.check,s.arrayArgs),r.kendoSpreadsheetArgs=n,this},argsAsync:function(n,o){var r,s=i(e,n);return o&&(s.arrayArgs&&console.log(""+s.arrayArgs),s.resolve&&console.log(""+s.resolve),s.check&&console.log(""+s.check)),r=P[e]=l(t,s.resolve,s.check,s.arrayArgs),r.kendoSpreadsheetArgs=n,this}}}function d(e,t,n){return t++,(1461*(e+4800+((t-14)/12|0))/4|0)+(367*(t-2-12*((t-14)/12|0))/12|0)-(3*((e+4900+((t-14)/12|0))/100|0)/4|0)+n-32075}function u(e){var t,n,i,o,r,s,a;return t=e+68569,n=4*t/146097|0,t-=(146097*n+3)/4|0,o=4e3*(t+1)/1461001|0,t=t-(1461*o/4|0)+31,i=80*t/2447|0,s=t-(2447*i/80|0),t=i/11|0,r=i+2-12*t,a=100*(n-49)+o+t,r--,{year:a,month:r,date:s,day:(e+1)%7,ord:H[h(a)][r]+s}}function h(e){return e%4?0:e%100?1:e%400?0:1}function f(e){return h(e)?366:365}function p(e,t){return h(e)&&1==t?29:L[t]}function m(e){return u((0|e)+B)}function g(e,t,n){return d(e,t,n)-B}function v(e){var t,n,i,o,r=e-(0|e);return r<0&&r++,t=Math.round(V*r),n=Math.floor(t/O),t-=n*O,i=Math.floor(t/N),t-=i*N,o=Math.floor(t/1e3),t-=1e3*o,{hours:n,minutes:i,seconds:o,milliseconds:t}}function _(e){var t=m(e),n=v(e);return new Date(t.year,t.month,t.date,n.hours,n.minutes,n.seconds,n.milliseconds)}function b(e,t,n,i){return(e+(t+(n+i/1e3)/60)/60)/24}function w(e){var t=b(e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds());return e=g(e.getFullYear(),e.getMonth(),e.getDate()),e<0?e-1+t:e+t}function y(e,t){return t?kendo.parseExactDate(e,t)||kendo.parseExactDate(e,t.replace(/h/g,"H"))||kendo.parseExactDate(e):kendo.parseExactDate(e)||kendo.parseExactDate(e,["MMMM dd yyyy","MMMM dd yy","MMM dd yyyy","MMM dd yy","dd MMMM yyyy","dd MMMM yy","dd MMM yyyy","dd MMM yy","MMMM dd, yyyy","MMMM dd, yy","MMM dd, yyyy","MMM dd, yy","MMMM dd","MMM dd","MMMM yyyy","MMM yyyy","dd MMMM","dd MMM"])}function k(t){return function(n,i){return"string"==typeof n&&"string"!=typeof i&&(i=null==i?"":i+""),"string"!=typeof n&&"string"==typeof i&&(n=null==n?"":n+""),"number"==typeof n&&null==i&&(i=0),"number"==typeof i&&null==n&&(n=0),"string"==typeof n&&"string"==typeof i&&(n=n.toLowerCase(),i=i.toLowerCase()),typeof i==typeof n?t(n,i):new e("VALUE")}}var x,C,S,T,D,A,E,I,M,R,F,z,P,B,L,H,N,O,V,U,W,j;kendo.support.browser.msie&&kendo.support.browser.version<9||(x={},C=kendo.spreadsheet,C.calc=x,S=x.runtime={},T=kendo.Class,D=C.Ref,A=C.CellRef,E=C.RangeRef,I=C.UnionRef,M=C.NULLREF,e.prototype.toString=function(){return"#"+this.code+("NAME"==this.code?"?":"!")},R=T.extend({init:function(e,t,n,i){this.callback=e,this.formula=t,this.ss=n,this.parent=i},resolve:function(e){var t=this;e instanceof D?t.resolveCells([e],function(){t._resolve(e)}):t._resolve(e)},error:function(t){return new e(t)},_resolve:function(e){e=void 0===e?null:Array.isArray(e)?this.asMatrix(e):r(e);var t=this.formula;t.arrayFormulaRange?e=this.asMatrix(e)||this.asMatrix([[e]]):e instanceof E&&(e=this._arrayArg(e)),t.value=e,this.ss.onFormula(t)&&this.callback&&this.callback.call(t,e)},resolveCells:function(e,t){function n(e){e.exec(s.ss,function(){--o||t.call(s)},s)}function i(e){var t,n;for(t=0;t<e.length;++t)n=e[t],n.formula&&a.push(n.formula);return!0}var o,r,s=this,a=[];if(function l(e){var t,n;for(t=0;t<e.length;++t)n=e[t],n instanceof D&&i(s.getRefCells(n)),Array.isArray(n)&&l(n)}(e),!a.length)return t.call(s);for(o=a.length,r=0;r<a.length;++r)n(a[r])},cellValues:function(e,t){var n,i,o=[];for(n=0;n<e.length;++n)i=e[n],i instanceof D?(i=this.getRefData(i),o=o.concat(i)):Array.isArray(i)?o=o.concat(this.cellValues(i)):i instanceof F?o=o.concat(this.cellValues(i.data)):o.push(i);return t?t.apply(this,o):o},fetchName:function(t,n){var i,o=this.formula,r=this.ss.nameValue(t,o.sheet,o.row,o.col);r instanceof z?(r=r.clone(o.sheet,o.row,o.col,!0),i=new C.ValidationFormulaContext(this.ss.workbook),r.exec(i,n,this)):(r instanceof D&&(r=r.absolute(o.row,o.col),r.sheet||(r.sheet=o.sheet)),n(null==r?new e("NAME"):r))},force:function(e){return e instanceof D?this.getRefData(e):e},func:function(t,n,i){t=t.toLowerCase();var o=P[t];return o?o.call(this,n,i):void n(new e("NAME"))},bool:function(e){return e instanceof D&&(e=this.getRefData(e)),"string"==typeof e?"true"==e.toLowerCase():"number"==typeof e?0!==e:"boolean"==typeof e?e:null!=e},_arrayArg:function(t){var n=this.formula;return!n.arrayFormulaRange&&t instanceof E?1==t.height()&&n.col>=t.topLeft.col&&n.col<=t.bottomRight.col?this.getRefData(new A(t.topLeft.row,n.col).setSheet(t.sheet)):1==t.width()&&n.row>=t.topLeft.row&&n.row<=t.bottomRight.row?this.getRefData(new A(n.row,t.topLeft.col).setSheet(t.sheet)):new e("VALUE"):this.asMatrix(t)},asMatrix:function(e){var t,n,i,o,r,s,a;return e instanceof F?e:(t=this,e instanceof E?(n=e.topLeft,i=n.row,o=n.col,r=t.getRefCells(e),s=new F(t),isFinite(e.width())&&(s.width=e.width()),isFinite(e.height())&&(s.height=e.height()),isFinite(i)||(i=0),isFinite(o)||(o=0),r.forEach(function(e){s.set(e.row-i,e.col-o,e.value)}),s):Array.isArray(e)&&e.length>0?(s=new F(t),a=0,e.forEach(function(e){var n=0,i=1;e.forEach(function(e){var o=e instanceof E;e instanceof D&&!o&&(e=t.getRefData(e)),(o||Array.isArray(e))&&(e=t.asMatrix(e)),e instanceof F?(e.each(function(e,t,i){s.set(a+t,n+i,e)}),i=Math.max(i,e.height),n+=e.width):s.set(a,n++,e)}),a+=i}),s):void 0)},getRefCells:function(e,t){var n=this.formula;return this.ss.getRefCells(e,t,n.sheet,n.row,n.col)},getRefData:function(e){var t=this.formula;return this.ss.getData(e,t.sheet,t.row,t.col)},workbook:function(){return this.ss.workbook}}),F=T.extend({init:function(e){this.context=e,this.height=0,this.width=0,this.data=[]},clone:function(){var e=new F(this.context);return e.height=this.height,e.width=this.width,e.data=this.data.map(function(e){return e.slice()}),e},get:function(e,t){var n=this.data[e],i=n?n[t]:null;return i instanceof D?this.context.getRefData(i):i},set:function(e,t,n){var i=this.data[e];null==i&&(i=this.data[e]=[]),i[t]=n,e>=this.height&&(this.height=e+1),t>=this.width&&(this.width=t+1)},each:function(e,t){var n,i,o;for(n=0;n<this.height;++n)for(i=0;i<this.width;++i)if(o=this.get(n,i),(t||null!=o)&&(o=e.call(this.context,o,n,i),void 0!==o))return o},map:function(e,t){var n=new F(this.context);return this.each(function(t,i,o){n.set(i,o,e.call(this,t,i,o))},t),n},eachRow:function(e){var t,n;for(t=0;t<this.height;++t)if(n=e.call(this.context,t),void 0!==n)return n},eachCol:function(e){var t,n;for(t=0;t<this.width;++t)if(n=e.call(this.context,t),void 0!==n)return n},mapRow:function(e){var t=new F(this.context);return this.eachRow(function(n){t.set(n,0,e.call(this.context,n))}),t},mapCol:function(e){var t=new F(this.context);return this.eachCol(function(n){t.set(0,n,e.call(this.context,n))}),t},toString:function(){return JSON.stringify(this.data)},transpose:function(){var e=new F(this.context);return this.each(function(t,n,i){e.set(i,n,t)}),e},unit:function(e){var t,n,i,o;for(this.width=this.height=e,t=this.data=Array(e),n=e;--n>=0;)for(i=t[n]=Array(e),o=e;--o>=0;)i[o]=n==o?1:0;return this},multiply:function(t){var n,i,o,r,s,a,l=this,c=new F(l.context);for(n=0;n<l.height;++n)for(i=0;i<t.width;++i){for(o=0,r=0;r<l.width;++r){if(s=l.get(n,r),a=t.get(r,i),"number"!=typeof s||"number"!=typeof a)throw new e("VALUE");o+=s*a}c.set(n,i,o)}return c},adds:function(e,t){var n,i,o,r,s=this,a=new F(s.context),l=t?-1:1;for(n=0;n<s.height;++n)for(i=0;i<s.width;++i)o=s.get(n,i),r=e.get(n,i),a.set(n,i,o+l*r);return a},determinant:function(){var e,t,n,i,o,r=this.clone().data,s=r.length,a=1;for(e=0;e<s;e++){for(t=e;t<s&&!r[t][e];t++);if(t==s)return 0;if(t!=e)for(a=-a,i=e;i<s;i++)o=r[e][i],r[e][i]=r[t][i],r[t][i]=o;for(n=e+1;n<s;n++)for(i=e+1;i<s;i++)r[n][i]-=r[e][i]*r[n][e]/r[e][e];a*=r[e][e]}return a},inverse:function(){var e,n,i,o,r,s,a=this.width,l=this.augment(new F(this.context).unit(a)),c=l.data;for(n=0;n<a;++n){if(i=t(n,a,function(e){return c[e][n]}),!c[i][n])return null;for(n!=i&&(e=c[n],c[n]=c[i],c[i]=e),o=n+1;o<a;++o){for(r=n+1;r<2*a;++r)c[o][r]-=c[n][r]*c[o][n]/c[n][n];c[o][n]=0}}for(o=0;o<a;++o)for(s=c[o][o],r=0;r<2*a;++r)c[o][r]/=s;for(n=a;--n>=0;)for(o=n;--o>=0;)if(c[o][n])for(r=2*a;--r>=a;)c[o][r]-=c[n][r]*c[o][n];return l.slice(0,a,a,a)},augment:function(e){var t=this.clone(),n=t.width;return e.each(function(e,i,o){t.set(i,o+n,e)}),t},slice:function(e,t,n,i){var o,r,s=new F(this.context);for(o=0;o<n;++o)for(r=0;r<i;++r)s.set(o,r,this.get(e+o,t+r));return s}}),z=T.extend({init:function(e,t,n,i,o,r,s){this.refs=e,this.handler=t,this.print=n,this.absrefs=null,this.sheet=i,this.row=o,this.col=r,this.onReady=[],this.pending=!1,this.arrayFormulaRange=s},setArrayFormulaRange:function(e){this.arrayFormulaRange=e.clone().setSheet(this.sheet)},clone:function(e,t,n,i){var o=e.toLowerCase(),r=this.refs,s=this.arrayFormulaRange;return(i||o!=this.sheet.toLowerCase())&&(r=r.map(function(t){return t.hasSheet()||t.sheet&&t.sheet.toLowerCase()==o||(t=t.clone().setSheet(e)),t}),s&&(s=s.clone().setSheet(e))),new z(r,this.handler,this.print,e,t,n,s)},deepClone:function(){var e=this.refs.map(function(e){return e.clone()});return new z(e,this.handler,this.print,this.sheet,this.row,this.col)},resolve:function(e){this.pending=!1,this.onReady.forEach(function(t){t(e)})},exec:function(t,n,i){var o,r,s;if("value"in this)n&&n(this.value);else{for(n&&this.onReady.push(n),o=new R(this.resolve,this,t,i),r=0;i;){if(i.formula===this)return this.pending=!1,void o.resolve(new e("CIRCULAR"));i=i.parent,++r}if(this.pending)return;this.pending=!0,s=function(){this.absrefs||(this.absrefs=this.refs.map(function(e){return e.absolute(this.row,this.col)},this)),this.handler.call(o)}.bind(this),r<20?s():setTimeout(s,0)}},reset:function(){this.onReady=[],this.pending=!1,delete this.value},renameSheet:function(e,t){e=e.toLowerCase(),this.absrefs=null,this.sheet.toLowerCase()==e&&(this.sheet=t),this.refs.forEach(function(n){n.renameSheet(e,t);
})},adjust:function(e,t,i,o){function r(n){return n===M?n:n.sheet.toLowerCase()!=e?(c&&("row"==t&&s>=i&&(n=n.relative(o,0)),"col"==t&&a>=i&&(n=n.relative(0,o))),n):n.adjust(s,a,d,u,"row"==t,i,o)}var s,a,l,c,d,u,h,f,p;if(e=e.toLowerCase(),s=this.row,a=this.col,l=this.sheet.toLowerCase(),c=!1,l==e&&("row"==t&&s>=i&&(this.row+=o,c=!0),"col"==t&&a>=i&&(this.col+=o,c=!0)),d=this.row,u=this.col,this.absrefs=null,h=this.refs,f=c,this.refs=h.map(function(e){var t=r(e);return f||n(t,e)||(f=!0),t}),p=this.arrayFormulaRange,p&&(this.arrayFormulaRange=r(p),f||n(p,this.arrayFormulaRange)||(f=!0)),f)return new z(h,this.handler,this.print,this.sheet,s,a,p)},toString:function(){return this.print(this.row,this.col)}}),P=Object.create(null),P["if"]=function(t,n){var i=this,o=n[0],r=n[1],s=n[2];this.resolveCells([o],function(){var n=i.asMatrix(o);n?r(function(o){s(function(r){var s=i.asMatrix(o),a=i.asMatrix(r);t(n.map(function(t,n,l){return t instanceof e?t:i.bool(t)?s?s.get(n,l):o:a?a.get(n,l):r}))})}):(o=this.force(o),o instanceof e?t(o):i.bool(o)?r(t):s(t))})},P["φ"]=function(e){e((1+Math.sqrt(5))/2)},B=d(1900,0,-1),L=[31,28,31,30,31,30,31,31,30,31,30,31],H=[[0,31,59,90,120,151,181,212,243,273,304,334],[0,31,60,91,121,152,182,213,244,274,305,335]],N=6e4,O=60*N,V=24*O,S.CalcError=e,S.Formula=z,S.Matrix=F,S.packDate=g,S.unpackDate=m,S.packTime=b,S.unpackTime=v,S.serialToDate=_,S.dateToSerial=w,S.daysInMonth=p,S.isLeapYear=h,S.daysInYear=f,S.parseDate=y,S.limitPrecision=o,C.dateToNumber=w,C.numberToDate=_,C.defineFunction=c,C.CalcError=e,S.defineFunction=c,S.defineAlias=function(e,t){var n=P[t];if(!n)throw Error("Function "+t+" is not yet defined");n.kendoSpreadsheetAliases||(n.kendoSpreadsheetAliases=[t]),n.kendoSpreadsheetAliases.push(e),P[e]=n},S.FUNCS=P,U=["or","number",["null",0]],W=[["*a",U],["*b",U]],j=[["*a",["or","anyvalue",["null",0]]],["*b",["or","anyvalue",["null",0]]]],c("binary+",function(e,t){return e+t}).args(W),c("binary-",function(e,t){return e-t}).args(W),c("binary*",function(e,t){return e*t}).args(W),c("binary/",function(e,t){return e/t}).args([["*a",U],["*b","divisor"]]),c("binary^",function(e,t){return Math.pow(e,t)}).args(W),c("binary&",function(e,t){return null==e&&(e=""),null==t&&(t=""),""+e+t}).args([["*a",["or","number","string","boolean","null"]],["*b",["or","number","string","boolean","null"]]]),c("binary=",function(e,t){return e===t}).args(j),c("binary<>",function(e,t){return e!==t}).args(j),c("binary<",k(function(e,t){return e<t})).args(j),c("binary<=",k(function(e,t){return e<=t})).args(j),c("binary>",k(function(e,t){return e>t})).args(j),c("binary>=",k(function(e,t){return e>=t})).args(j),c("unary+",function(e){return e}).args([["*a",U]]),c("unary-",function(e){return-e}).args([["*a",U]]),c("unary%",function(e){return e/100}).args([["*a",U]]),c("binary:",function(e,t){return new E(e,t).setSheet(e.sheet||this.formula.sheet,e.hasSheet())}).args([["a","cell"],["b","cell"]]),c("binary,",function(e,t){return new I([e,t])}).args([["a","ref"],["b","ref"]]),c("binary ",function(e,t){return e.intersect(t)}).args([["a","ref"],["b","ref"]]),c("not",function(e){return!this.bool(e)}).args([["*a",["or","anyvalue",["null",0]]]]),c("isblank",function(e){return e instanceof A&&(e=this.getRefData(e),null==e)}).args([["*value","anything!"]]),c("iserror",function(t){return t instanceof e}).args([["*value","forced!"]]),c("iserr",function(t){return t instanceof e&&"N/A"!=t.code}).args([["*value","forced!"]]),c("isna",function(t){return t instanceof e&&"N/A"==t.code}).args([["*value","forced!"]]),c("islogical",function(e){return"boolean"==typeof e}).args([["*value","forced!"]]),c("isnontext",function(e){return"string"!=typeof e}).args([["*value","forced!"]]),c("istext",function(e){return"string"==typeof e}).args([["*value","forced!"]]),c("isnumber",function(e){return"number"==typeof e}).args([["*value","forced!"]]),c("isref",function(e){return e instanceof A||e instanceof E}).args([["*value","anything!"]]),P[",getname"]=function(e,t){this.fetchName(t[0],e)})},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/validation.min",["spreadsheet/runtime.min"],e)}(function(){"use strict";function e(e,t,o,a){var c,d,u,h;if("string"==typeof a&&(a=JSON.parse(a)),a.from&&("list"!==a.dataType||a.fromIsListValue||(a.from=kendo.format(r,a.from),a.fromIsListValue=!0),"date"===a.dataType&&(u=i.runtime.parseDate(a.from),u&&(a.from=kendo.format(s,a.from),a.fromIsDateValue=!0)),a.from=i.compile(i.parseFormula(e,t,o,a.from))),a.to&&("date"===a.dataType&&(h=i.runtime.parseDate(a.to),h&&(a.to=kendo.format(s,a.to),a.toIsDateValue=!0)),a.to=i.compile(i.parseFormula(e,t,o,a.to))),d="custom"==a.dataType?n.validationComparers.custom:"list"==a.dataType?n.validationComparers.list:n.validationComparers[a.comparerType],!d)throw kendo.format("'{0}' comparer is not implemented.",a.comparerType);return c=function(e){var t,n=this.to&&this.to_value?this.to_value:void 0;return null===e||""===e?this.value=!!this.allowNulls:"custom"==this.dataType?this.value=d(e,this.from_value,n):"list"==this.dataType?(t=this._getListData(),this.value=d(e,t,n)):this.value=d(e,this.from_value,n),this.value},new kendo.spreadsheet.validation.Validation(l.extend(a,{handler:c,sheet:e,row:t,col:o}))}var t,n,i,o,r,s,a,l=kendo.jQuery;kendo.support.browser.msie&&kendo.support.browser.version<9||(t=kendo.spreadsheet,n={},t.validation=n,i=t.calc,o=kendo.Class,r="_matrix({0})",s='DATEVALUE("{0}")',i.runtime.defineFunction("_matrix",function(e){return"string"==typeof e&&(e=this.asMatrix([e.split(/\s*,\s*/)])),e}).args([["m",["or","matrix","string"]]]),a=o.extend({init:function(e){this.handler=e.handler,this.from=e.from,this.to=e.to,this.dataType=e.dataType,this.comparerType=e.comparerType,this.type=e.type?e.type:"warning",this.allowNulls=!!e.allowNulls,this.fromIsDateValue=!!e.fromIsDateValue,this.toIsDateValue=!!e.toIsDateValue,this.showButton=e.showButton,this.fromIsListValue=!!e.fromIsListValue,this.sheet=e.sheet,this.row=e.row,this.col=e.col,e.tooltipMessageTemplate&&(this.tooltipMessageTemplate=e.tooltipMessageTemplate),e.tooltipTitleTemplate&&(this.tooltipTitleTemplate=e.tooltipTitleTemplate),e.messageTemplate&&(this.messageTemplate=e.messageTemplate),e.titleTemplate&&(this.titleTemplate=e.titleTemplate)},_formatMessages:function(e){var t=this.from?this.from_value:"",n=this.to?this.to_value:"",i=this.from?""+this.from:"",o=this.to?""+this.to:"",r=this.dataType,s=this.type,a=this.comparerType;return kendo.format(e,t,n,i,o,r,s,a)},_setMessages:function(){this.title="",this.message="",this.tooltipTitleTemplate&&(this.tooltipTitle=this._formatMessages(this.tooltipTitleTemplate)),this.tooltipMessageTemplate&&(this.tooltipMessage=this._formatMessages(this.tooltipMessageTemplate)),this.titleTemplate&&(this.title=this._formatMessages(this.titleTemplate)),this.messageTemplate&&(this.message=this._formatMessages(this.messageTemplate))},_getListData:function(){var e,t,n,i,o;if(!this.from_value||!this.from_value.data)return[];for(e=this.from_value.data,i=[],t=0;t<e.length;t++)if(o=e[t])for(n=0;n<o.length;n++)i.push(o[n]);return i},clone:function(e,t,n){var i=this._getOptions();return i.from&&(i.from=i.from.clone(e,t,n)),i.to&&(i.to=i.to.clone(e,t,n)),new a(l.extend(i,{handler:this.handler},{sheet:e,row:t,col:n}))},deepClone:function(){var e=new a(this);return e.from=e.from.deepClone(),e.to&&(e.to=e.to.deepClone()),e},exec:function(e,t,n,i){function o(t){return t instanceof kendo.spreadsheet.Ref&&(t=e.getData(t),Array.isArray(t)&&(t=t[0])),t}var r=this,s=function(e){r.from_value=o(e),r.value=r.handler.call(r,t,n),r._setMessages(),i&&i(r.value)};r.to?r.to.exec(e,function(t){r.to_value=o(t),r.from.exec(e,s)}):r.from.exec(e,s)},reset:function(){this.from&&this.from.reset(),this.to&&this.to.reset(),delete this.value},adjust:function(e,t,n,i){var o,r,s,l,c=this.row,d=this.col;if(this.from&&(o=this.from.adjust(e,t,n,i)),this.to&&(r=this.to.adjust(e,t,n,i)),this.sheet.toLowerCase()==e.toLowerCase())switch(t){case"row":c>=n&&(s=!0,this.row+=i);break;case"col":d>=n&&(s=!0,this.col+=i)}if(s||o||r)return l=new a(this),l.from=o,l.to=r,l.row=c,l.col=d,l},toJSON:function(){var e=this._getOptions();return e.from&&(e.from=""+e.from,"list"===e.dataType&&(e.from=e.from.replace(/^_matrix\((.*)\)$/i,"$1"),delete e.fromIsListValue),"date"===e.dataType&&this.fromIsDateValue&&(e.from=e.from.replace(/^DATEVALUE\("(.*)"\)$/i,"$1"),delete e.fromIsDateValue)),e.to&&(e.to=""+e.to,"date"===e.dataType&&this.toIsDateValue&&(e.to=e.to.replace(/^DATEVALUE\("(.*)"\)$/i,"$1"),delete e.toIsDateValue)),e},_getOptions:function(){return{from:this.from,to:this.to,dataType:this.dataType,type:this.type,comparerType:this.comparerType,row:this.row,col:this.col,sheet:this.sheet,allowNulls:this.allowNulls,fromIsListValue:this.fromIsListValue,fromIsDateValue:this.fromIsDateValue,toIsDateValue:this.toIsDateValue,tooltipMessageTemplate:this.tooltipMessageTemplate,tooltipTitleTemplate:this.tooltipTitleTemplate,messageTemplate:this.messageTemplate,titleTemplate:this.titleTemplate,showButton:this.showButton}}}),n.compile=e,n.validationComparers={greaterThan:function(e,t){return e>t},lessThan:function(e,t){return e<t},between:function(e,t,n){return e>=t&&e<=n},equalTo:function(e,t){return e==t},notEqualTo:function(e,t){return e!=t},greaterThanOrEqualTo:function(e,t){return e>=t},lessThanOrEqualTo:function(e,t){return e<=t},notBetween:function(e,t,n){return e<t||e>n},custom:function(e,t){return t},list:function(e,t){return t.indexOf(e)>-1}},n.Validation=a)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/sheet.min",["kendo.core.min","kendo.color.min","spreadsheet/runtime.min","spreadsheet/validation.min","spreadsheet/references.min"],e)}(function(){!function(e){var t,n,i,o,r,s,a;e.support.browser.msie&&e.support.browser.version<9||(t=e.spreadsheet.RangeRef,n=e.spreadsheet.UnionRef,i=e.spreadsheet.CellRef,o=e.spreadsheet.Range,s=e.Class.extend({init:function(t){this._sheet=t,this.selection=e.spreadsheet.FIRSTREF.toRangeRef(),this.originalSelection=e.spreadsheet.FIRSTREF.toRangeRef(),this._activeCell=e.spreadsheet.FIRSTREF.toRangeRef(),this.originalActiveCell=e.spreadsheet.FIRSTREF},currentSelectionRange:function(){return this.selection.rangeAt(this.selectionRangeIndex).toRangeRef()},currentOriginalNavigationRange:function(){return this.originalSelection.rangeAt(this.selectionRangeIndex).toRangeRef()},currentNavigationRange:function(){return this.singleCellSelection()?this._sheet._sheetRef:this.selection.rangeAt(this.selectionRangeIndex).toRangeRef()},nextNavigationRange:function(){return this.singleCellSelection()||(this.selectionRangeIndex=this.selection.nextRangeIndex(this.selectionRangeIndex)),this.currentNavigationRange()},previousNavigationRange:function(){return this.singleCellSelection()||(this.selectionRangeIndex=this.selection.previousRangeIndex(this.selectionRangeIndex)),this.currentNavigationRange()},activeCell:function(e){return e&&(this.originalActiveCell=e.first(),this._activeCell=this._sheet.unionWithMerged(e.toRangeRef()),this._sheet.focus(e),this._sheet.triggerChange({activeCell:!0,selection:!0})),this._activeCell},select:function(e,t,n){if(e){if(e.eq(this.originalSelection))return;this._sheet.triggerSelect(new o(e,this._sheet)),this.originalSelection=e,this.selection=t,n!==!1?(e.isCell()?(this._sheet.forEachMergedCell(e,function(t){e=t.topLeft}),this.activeCell(e)):this.activeCell(this.selection.lastRange().first()),this.selectionRangeIndex=this.selection.size()-1):this._sheet.triggerChange({selection:!0})}return this.selection},singleCellSelection:function(){return this._activeCell.eq(this.selection)}}),a=e.Observable.extend({init:function(){e.Observable.prototype.init.call(this),this._reinit.apply(this,arguments)},events:["commandRequest","afterInsertRow","afterDeleteRow","insertRow","insertColumn","deleteRow","deleteColumn","hideRow","hideColumn","unhideRow","unhideColumn","select"],_reinit:function(t,n,i,o,r,a,l){l=l||{},this._defaultCellStyle={background:l.background,color:l.color,fontFamily:l.fontFamily,fontSize:l.fontSize,italic:l.italic,bold:l.bold,underline:l.underline,wrap:l.wrap,verticalAlign:l.verticalAlign,textAlign:l.textAlign},this._rows=new e.spreadsheet.Axis(t,i),this._columns=new e.spreadsheet.Axis(n,o),this._mergedCells=[],this._frozenRows=0,this._frozenColumns=0,this._suspendChanges=!1,this._filter=null,this._showGridLines=!0,this._gridLinesColor=null,this._grid=new e.spreadsheet.Grid(this._rows,this._columns,t,n,r,a),this._sheetRef=this._grid.normalize(e.spreadsheet.SHEETREF),this._properties=new e.spreadsheet.PropertyBag(t,n,this._defaultCellStyle),this._sorter=new e.spreadsheet.Sorter(this._grid,this._properties.sortable()),this._viewSelection=new s(this),this._editSelection=new s(this),this._formulaSelections=[]},_selectionState:function(){return this._inEdit?this._editSelection:this._viewSelection},navigator:function(){return this._navigator||(this._navigator=new e.spreadsheet.SheetNavigator(this)),this._navigator},axisManager:function(){return this._axisManager||(this._axisManager=new e.spreadsheet.AxisManager(this)),this._axisManager},_name:function(e){return e?(this._sheetName=e,this):this._sheetName},name:function(){return this._name()},_property:function(e,t,n){return void 0===t?e():(e(t),this.triggerChange(n))},_field:function(e,t,n){return void 0===t?this[e]:(this[e]=t,this.triggerChange(n))},suspendChanges:function(e){return void 0===e?this._suspendChanges:(this._suspendChanges=e,this)},triggerChange:function(e){return this._suspendChanges||this.trigger("change",e),this},triggerSelect:function(e){this.trigger("select",{range:e})},setDataSource:function(t,n){this.dataSourceBinder&&this.dataSourceBinder.destroy(),this.dataSourceBinder=new e.spreadsheet.SheetDataSourceBinder({dataSource:t,sheet:this,columns:n}),this.dataSource=this.dataSourceBinder.dataSource},hideColumn:function(e){if(!this.trigger("hideColumn",{index:e}))return this._property(this._columns.hide.bind(this._columns),e,{layout:!0})},unhideColumn:function(e){if(!this.trigger("unhideColumn",{index:e}))return this._property(this._columns.unhide.bind(this._columns),e,{layout:!0})},isHiddenColumn:function(e){return this._grid._columns.hidden(e)},_copyRange:function(e,t){var n=this._grid,i=n.rowCount,o=n.normalize(e.topLeft),r=n.normalize(e.bottomRight),s=o.col*i+o.row,a=r.col*i+r.row,l=t.col*i+t.row;this._properties.copy(s,a,l)},_saveModifiedFormulas:function(e,t){var n,i=r;return r=e,n=t(),r=i,n},_restoreModifiedFormulas:function(t){var n=this._workbook;t.forEach(function(t){var i,o=n.sheetByName(t.sheet);t instanceof e.spreadsheet.calc.runtime.Formula&&(i=o._grid.cellRefIndex(t),o._properties.set("formula",i,i,t)),t instanceof e.spreadsheet.validation.Validation&&(i=o._grid.cellRefIndex(t),o._properties.set("validation",i,i,t))})},_adjustReferences:function(n,i,o,s){var a,l,c;this._mergedCells=s.reduce(function(e,r){return r=r.adjust(null,null,null,null,"row"==n,i,o),r instanceof t&&e.push(r),e},[]),this._workbook&&(a=this._name(),this._workbook._sheets.forEach(function(e){e._forFormulas(function(e){var t=e.adjust(a,n,i,o);t&&r&&r.push(t)}),e._forValidations(function(e){var t=e.adjust(a,n,i,o);t&&r&&r.push(t)})}),this._workbook.adjustNames(a,"row"==n,i,o)),l=this.select(),l=l.adjust(null,null,null,null,"row"==n,i,o),l!==e.spreadsheet.NULLREF&&this.select(l),c="col"==n?this._columns:this._rows,c.adjust(i,o)},_forFormulas:function(e){var t=this._properties,n=t.get("formula").values(),i=n.length;n.forEach(function(t,n){e.call(this,t.value,n,i)},this)},_forValidations:function(e){var t=this._properties;t.get("validation").values().forEach(function(t){e.call(this,t.value)},this)},preventInsertRow:function(e,t){var n,i;return this.selectedHeaders().allRows?{reason:"error",type:"insertRowWhenColumnIsSelected"}:(t=t||1,n=this._grid,i=this.range(n.rowCount-t,0,t,n.columnCount),!!i.hasValue()&&{reason:"error",type:"shiftingNonblankCells"})},preventInsertColumn:function(e,t){var n,i;return this.selectedHeaders().allCols?{reason:"error",type:"insertColumnWhenRowIsSelected"}:(t=t||1,n=this._grid,i=this.range(0,n.columnCount-t,n.rowCount,t),!!i.hasValue()&&{reason:"error",type:"shiftingNonblankCells"})},insertRow:function(e){var n=this.preventInsertRow(e);if(n)throw Error("Shifting nonblank cells off the worksheet is not supported!");if(!this.trigger("insertRow",{index:e}))return this.batch(function(){var n,r,s,a,l,c,d=this._grid,u=d.columnCount,h=d.rowCount,f=this.frozenRows();for(e<f&&this.frozenRows(f+1),n=this._mergedCells.slice(),r=0;r<u;r++)s=new t(new i(e,r),new i(e,r)),a=d.normalize(s.topLeft),l=d.normalize(s.bottomRight),c=new t(new i(a.row,a.col),new i(h-2,l.col)),this._copyRange(c,new i(a.row+1,a.col)),new o(s,this).clear({clearAll:!0,keepBorders:!0});this._adjustReferences("row",e,1,n)},{recalc:!0,layout:!0,insertRow:{index:e},ref:new t(new i(e,0),new i(1/0,1/0))}),this.trigger("afterInsertRow",{index:e}),this},isEnabledRow:function(e){var n=new t(new i(e,0),new i(e,this._grid.columnCount));return new o(n,this).enable()},deleteRow:function(e){if(!this.isEnabledRow(e))return this;if(!this.trigger("deleteRow",{index:e}))return this.batch(function(){var n,r,s,a,l,c,d,u=this._grid,h=u.columnCount,f=this.frozenRows();for(e<f&&this.frozenRows(f-1),n=this._mergedCells.slice(),r=0;r<h;r++)s=new t(new i(e,r),new i(e,r)),new o(s,this).clear({clearAll:!0,keepBorders:!0}),a=u.normalize(s.topLeft),l=u.normalize(s.bottomRight),c=new t(new i(a.row+1,a.col),new i(1/0,l.col)),this._copyRange(c,a),d=u.normalize(c.bottomRight),new o(new t(d,d),this).clear();this._adjustReferences("row",e,-1,n)},{recalc:!0,layout:!0,deleteRow:{index:e},ref:new t(new i(e,0),new i(1/0,1/0))}),this.trigger("afterDeleteRow",{index:e}),this},insertColumn:function(e){if(!this.trigger("insertColumn",{index:e}))return this.batch(function(){var n,r,s,a,l,c,d=this._grid,u=d.columnCount,h=this.frozenColumns();for(e<h&&this.frozenColumns(h+1),n=this._mergedCells.slice(),r=u;r>=e&&(s=new t(new i(0,r),new i(1/0,r)),new o(s,this).clear({clearAll:!0,keepBorders:!0}),r!=e);r--)a=d.normalize(s.topLeft),l=d.normalize(s.bottomRight),c=new t(new i(a.row,a.col-1),new i(l.row,l.col-1)),this._copyRange(c,a);this._adjustReferences("col",e,1,n)},{recalc:!0,layout:!0,insertColumn:{index:e},ref:new t(new i(0,e),new i(1/0,1/0))}),this},isEnabledColumn:function(e){var n=new t(new i(0,e),new i(1/0,e));return new o(n,this).enable()},deleteColumn:function(e){if(!this.isEnabledColumn(e))return this;if(!this.trigger("deleteColumn",{index:e}))return this.batch(function(){var n,r,s,a,l,c,d=this._grid,u=d.columnCount,h=this.frozenColumns();for(e<h&&this.frozenColumns(h-1),n=this._mergedCells.slice(),r=e;r<u&&(s=new t(new i(0,r),new i(1/0,r)),new o(s,this).clear({clearAll:!0,keepBorders:!0}),r!=u-1);r++)a=d.normalize(s.topLeft),l=d.normalize(s.bottomRight),c=new t(new i(a.row,a.col+1),new i(l.row,l.col+1)),this._copyRange(c,a);this._adjustReferences("col",e,-1,n)},{recalc:!0,layout:!0,deleteColumn:{index:e},ref:new t(new i(0,e),new i(1/0,1/0))}),this},hideRow:function(e){if(!this.trigger("hideRow",{index:e}))return this._property(this._rows.hide.bind(this._rows),e,{layout:!0})},unhideRow:function(e){if(!this.trigger("unhideRow",{index:e}))return this._property(this._rows.unhide.bind(this._rows),e,{layout:!0})},isHiddenRow:function(e){return this._grid._rows.hidden(e)},columnWidth:function(e,t){return this._property(this._columns.value.bind(this._columns,e,e),t,{layout:!0})},rowHeight:function(e,t){return this._property(this._rows.value.bind(this._rows,e,e),t,{layout:!0})},frozenRows:function(e){return this._field("_frozenRows",e,{layout:!0})},frozenColumns:function(e){return this._field("_frozenColumns",e,{layout:!0})},showGridLines:function(e){return this._field("_showGridLines",e,{layout:!0})},gridLinesColor:function(e){return this._field("_gridLinesColor",e,{layout:!0})},_ref:function(n,o,r,s){var a=null;return n instanceof e.spreadsheet.Ref?n:n instanceof e.spreadsheet.Range?n._ref.toRangeRef():("string"==typeof n?a=e.spreadsheet.calc.parseReference(n):(r||(r=1),s||(s=1),a=new t(new i(n,o),new i(n+r-1,o+s-1))),a)},range:function(e,t,n,i){return new o(this._ref(e,t,n,i),this)},_getMergedCells:function(e){var t=this._grid,n={},i={},o=!1;return this.forEachMergedCell(e,function(r){var s=r.topLeft;t.forEach(r,function(t){s.eq(t)?(n[t.print()]=r,o=!0):e.contains(t)&&(i[t.print()]=s,o=!0)})}),{primary:n,secondary:i,hasMerged:o}},forEachMergedCell:function(e,t){var n=!1;void 0===t&&(t=e,n=!0),this._mergedCells.forEach(function(i){(n||i.intersects(e))&&t(i)})},forEachFilterHeader:function(e,t){var n,i=!1;void 0===t&&(t=e,i=!0),this._filter&&(n=[],this._filter.ref.forEachColumn(function(t){(i||t.intersects(e))&&n.push(t.topLeft)}),this._mergedCells.forEach(function(e){n=n.map(function(t){return e.intersects(t)?e:t})}),n.reduce(function(e,t){return e.indexOf(t)<0&&e.push(t),e},[]).forEach(t))},forEach:function(e,i){function o(e){function n(e){i(l++,a,e)}var o,s,a,l,c,d;for(e instanceof t||(e=e.toRangeRef()),o=r._grid.normalize(e.topLeft),s=r._grid.normalize(e.bottomRight),a=o.col;a<=s.col;a++)l=o.row,c=r._grid.index(l,a),d=r._grid.index(s.row,a),r._properties.forEach(c,d,n)}var r=this;e instanceof t||(e=r._ref(e)),e instanceof n?e.forEach(o):o(e)},startResizing:function(e){this._initialPosition=e,this._resizeInProgress=!0},startAutoFill:function(){this._autoFillInProgress=!0;var e=this.select();this._autoFillOrigin=e,this._autoFillDest=e,this.triggerChange({selection:!0})},updateAutoFill:function(e,t,n,i){this._autoFillDest=e,this._autoFillPunch=t,this._autoFillHint=n,this._autoFillDirection=i,this.triggerChange({selection:!0})},autoFillRef:function(){return this._autoFillDest},autoFillPunch:function(){return this._autoFillPunch},autoFillInProgress:function(){return this._autoFillInProgress},resizingInProgress:function(){return this._resizeInProgress},completeResizing:function(){var e,t;this._resizeInProgress&&(this._resizeInProgress=!1,e=this.resizeHintPosition(),this._initialPosition&&e?(t=this.resizeHandlePosition(),t.col!==-(1/0)?this.trigger("commandRequest",{command:"ColumnWidthCommand",options:{target:t.col,value:this.columnWidth(t.col)-(this._initialPosition.x-e.x)}}):this.trigger("commandRequest",{command:"RowHeightCommand",options:{target:t.row,value:this.rowHeight(t.row)-(this._initialPosition.y-e.y)}})):this.trigger("change",{resize:!0}))},resizeHandlePosition:function(){return this._resizeHandlePosition},resizeHintPosition:function(e){return void 0!==e&&(this._resizeHintPosition=e,this.trigger("change",{resize:!0})),this._resizeHintPosition},removeResizeHandle:function(){this._resizeHandlePosition&&(this._resizeHintPosition=void 0,this._resizeHandlePosition=void 0,this._initialPosition=void 0,this.trigger("change",{resize:!0}))},positionResizeHandle:function(e){this._resizeHandlePosition=e,this.trigger("change",{resize:!0})},startSelection:function(){this._selectionInProgress=!0},completeSelection:function(){var e,t;this._selectionInProgress&&(this._selectionInProgress=!1,this._resizeHintPosition=void 0,this.trigger("change",{selection:!0})),this._autoFillInProgress&&(this._autoFillInProgress=!1,e=this._autoFillDest,t=this._autoFillOrigin,this._autoFillPunch?this.trigger("commandRequest",{command:"ClearContentCommand",options:{operatingRange:this.range(this._autoFillPunch)}}):e.eq(t)?this.triggerChange({selection:!0}):this.trigger("commandRequest",{command:"AutoFillCommand",options:{operatingRange:this.range(e),origin:this.range(t)}}),this._autoFillDest=null,this._autoFillPunch=null,this._autoFillOrigin=null,this.select(e))},selectionInProgress:function(){return this._selectionInProgress},select:function(e,t){var n,i=this._selectionState();return e&&(e=this._ref(e),e=this._grid.normalize(e),n=this._grid.isAxis(e)?e:this.unionWithMerged(e)),i.select(e,n,t)},originalSelect:function(){return this._selectionState().originalSelection},currentSelectionRange:function(){return this._selectionState().currentSelectionRange()},currentOriginalSelectionRange:function(){return this._selectionState().currentOriginalNavigationRange()},currentNavigationRange:function(){return this._selectionState().currentNavigationRange()},nextNavigationRange:function(){return this._selectionState().nextNavigationRange()},previousNavigationRange:function(){return this._selectionState().previousNavigationRange()},selectionRangeIndex:function(){return this._selectionState().selectionRangeIndex},activeCell:function(e){return this._selectionState().activeCell(e)},originalActiveCell:function(){return this._selectionState().originalActiveCell},singleCellSelection:function(){return this._selectionState().singleCellSelection()},unionWithMerged:function(e){var t=this._mergedCells;return e.map(function(e){return e.toRangeRef().union(t)})},trim:function(e){var t=[],n=this._grid;return this._properties.forEachProperty(function(i){t.push(n.trim(e,i.list))}),this.unionWithMerged(e.topLeft.toRangeRef().union(t))},focus:function(e){if(!e){var t=this._focus;return this._focus=null,t}this._focus=e.toRangeRef()},activeCellSelection:function(){return new o(this._grid.normalize(this.activeCell()),this)},selection:function(){return new o(this._grid.normalize(this._selectionState().selection),this)},selectedHeaders:function(){var e=this.select(),t={},n={},i=!1,o=!1,r=this._grid.rowCount-1,s=this._grid.columnCount-1;return e.forEach(function(e){var a,l,c,d,u,h="partial",f="partial";if(e=e.toRangeRef(),l=e.bottomRight,c=e.topLeft,d=c.col<=0&&l.col>=s,u=c.row<=0&&l.row>=r,u&&(o=!0,f="full"),d&&(i=!0,h="full"),!u)for(a=c.row;a<=l.row;a++)"full"!==t[a]&&(t[a]=h);if(!d)for(a=c.col;a<=l.col;a++)"full"!==n[a]&&(n[a]=f)}),{rows:t,cols:n,allRows:o,allCols:i,all:o&&i}},isInEditMode:function(e){return void 0===e?this._inEdit:(this._inEdit=e,void(e&&(this._editSelection.selection=this._viewSelection.selection.clone(),this._editSelection.originalSelection=this._viewSelection.originalSelection.clone(),this._editSelection._activeCell=this._viewSelection._activeCell.clone(),this._editSelection.originalActiveCell=this._viewSelection.originalActiveCell.clone())))},_setFormulaSelections:function(e){this._formulaSelections=(e||[]).slice(),this.triggerChange({selection:!0})},_viewActiveCell:function(){return this._viewSelection._activeCell.toRangeRef()},toJSON:function(){function t(e){Object.keys(l).forEach(function(t){e[t]===l[t]&&delete e[t]})}var n,i={},o=this._rows.toJSON("height",i),r=this._columns.toJSON("width",{}),s=this._viewSelection,a=[],l=this._defaultCellStyle||{};return this.forEach(e.spreadsheet.SHEETREF,function(n,r,s){if(t(s),0!==Object.keys(s).length){s.link&&a.push({ref:e.spreadsheet.Ref.display(null,n,r),target:s.link});var l=i[n];void 0===l&&(l=o.length,o.push({index:n}),i[n]=l),n=o[l],s.index=r,void 0===n.cells&&(n.cells=[]),s.formula&&(s.formula=s.formula.arrayFormulaRange?{src:""+s.formula,ref:""+s.formula.arrayFormulaRange}:""+s.formula),s.validation&&(s.validation=s.validation.toJSON()),s.color&&(s.color=e.parseColor(s.color).toCss()),s.background&&(s.background=e.parseColor(s.background).toCss()),s.borderTop&&s.borderTop.color&&(s.borderTop.color=e.parseColor(s.borderTop.color).toCss()),s.borderBottom&&s.borderBottom.color&&(s.borderBottom.color=e.parseColor(s.borderBottom.color).toCss()),s.borderRight&&s.borderRight.color&&(s.borderRight.color=e.parseColor(s.borderRight.color).toCss()),s.borderLeft&&s.borderLeft.color&&(s.borderLeft.color=e.parseColor(s.borderLeft.color).toCss()),n.cells.push(s)}}),n={name:this._name(),rows:o,columns:r,selection:""+s.selection,activeCell:""+s.activeCell(),frozenRows:this.frozenRows(),frozenColumns:this.frozenColumns(),showGridLines:this.showGridLines(),gridLinesColor:this.gridLinesColor(),mergedCells:this._mergedCells.map(function(e){return""+e}),hyperlinks:a,defaultCellStyle:l},this._sort&&(n.sort={ref:""+this._sort.ref,columns:this._sort.columns.map(function(e){return{index:e.index,ascending:e.ascending}})}),this._filter&&(n.filter={ref:""+this._filter.ref,columns:this._filter.columns.map(function(e){var t=e.filter.toJSON();return t.index=e.index,t})}),n},fromJSON:function(t){this.batch(function(){var n,i,o,r,s,a,l,c,d,u,h,f;if(void 0!==t.name&&this._name(t.name),void 0!==t.frozenColumns&&this.frozenColumns(t.frozenColumns),void 0!==t.frozenRows&&this.frozenRows(t.frozenRows),void 0!==t.columns&&this._columns.fromJSON("width",t.columns),void 0!==t.rows)for(this._rows.fromJSON("height",t.rows),n=0;n<t.rows.length;n++)if(i=t.rows[n],o=i.index,void 0===o&&(o=n),i.cells)for(r=0;r<i.cells.length;r++)s=i.cells[r],a=s.index,void 0===a&&(a=r),s.formula&&(l="string"!=typeof s.formula,c=l?s.formula.src:s.formula,d=this._compileFormula(o,a,c),l&&d.setArrayFormulaRange(e.spreadsheet.calc.parseReference(s.formula.ref)),s.formula=d),s.validation&&(s.validation=this._compileValidation(o,a,s.validation)),this._properties.fromJSON(this._grid.index(o,a),s);t.selection&&(this._viewSelection.selection=this._viewSelection.originalSelection=this._ref(t.selection)),t.activeCell&&(u=this._ref(t.activeCell),this._viewSelection._activeCell=u.toRangeRef(),this._viewSelection.originalActiveCell=u),t.mergedCells&&t.mergedCells.forEach(function(e){this.range(e).merge()},this),t.sort&&(this._sort={ref:this._ref(t.sort.ref),columns:t.sort.columns.slice(0)}),t.filter&&(h=t.filter.ref,f=void 0===t.filter.columns?[]:t.filter.columns,h?(this._filter={ref:this._ref(h),columns:f.map(function(t){return{index:t.index,filter:e.spreadsheet.Filter.create(t)}})},this._refreshFilter()):e.logToConsole("Dropping filter for sheet '"+t.name+"' due to missing ref")),void 0!==t.showGridLines&&(this._showGridLines=t.showGridLines),this._gridLinesColor=t.gridLinesColor}),this._rows._refresh(),this._columns._refresh()},formula:function(e){return this._properties.get("formula",this._grid.cellRefIndex(e))},validation:function(e){return this._properties.get("validation",this._grid.cellRefIndex(e))},resetFormulas:function(){this._forFormulas(function(e){e.reset()})},resetValidations:function(){this._forValidations(function(e){e.reset()})},recalc:function(e,t){function n(){r--,s!=o||r||t()}var i=this._properties.get("formula").values(),o=i.length,r=0,s=0;if(!o&&t)return t();for(;s<o;)r++,i[s++].value.exec(e,t?n:null)},revalidate:function(e){var n=this;this._forValidations(function(o){var r=new i(o.row,o.col),s=new t(r,r);o.exec(e,n._get(s,"value"),n._get(s,"format"))})},_value:function(e,t,n){var i=this._grid.index(e,t);return void 0===n?this._properties.get("value",i):void this._properties.set("value",i,i,n)},_validation:function(e,t){var n=this._grid.index(e,t);return this._properties.get("validation",n)},_compileValidation:function(t,n,i){return i instanceof e.spreadsheet.validation.Validation?i.clone(this._name(),t,n):(null!=i.from&&(i.from=(i.from+"").replace(/^=/,"")),null!=i.to&&(i.to=(i.to+"").replace(/^=/,"")),e.spreadsheet.validation.compile(this._name(),t,n,i))},_compileFormula:function(t,n,i){return i=i.replace(/^=/,""),i=e.spreadsheet.calc.parseFormula(this._name(),t,n,i),e.spreadsheet.calc.compile(i)},_copyValuesInRange:function(e,t,n,i){var o,r,s,a,l;for(o=e.col;o<=t.col;o++)for(r=this._grid.index(e.row,o),s=this._grid.index(t.row,o),a=r,l=e.row;a<=s;++a,++l)n=n.clone(this._name(),l,o),this._properties.set(i,a,a,n);return n},_set:function(t,n,i){var o,r,s,a=this._grid.normalize(t.topLeft),l=this._grid.normalize(t.bottomRight);if("number"==typeof i&&(i=e.spreadsheet.calc.runtime.limitPrecision(i)),i&&"formula"==n)"string"==typeof i&&(i=this._compileFormula(a.row,a.col,i)),i=this._copyValuesInRange(a,l,i,"formula");else if(i&&"validation"==n)i=this._compileValidation(a.row,a.col,i),i=this._copyValuesInRange(a,l,i,"validation");else for(o=a.col;o<=l.col;o++)r=this._grid.index(a.row,o),s=this._grid.index(l.row,o),this._properties.set(n,r,s,i),"formula"==n&&this._properties.set("value",r,s,null)},_get:function(e,t){var n=this._grid.normalize(e.topLeft),i=this._grid.index(n.row,n.col);
return this._properties.get(t,i)},batch:function(e,t){var n=this.suspendChanges();return this.suspendChanges(!0),e.call(this),this.suspendChanges(n).triggerChange(t||{recalc:!0})},_sortBy:function(e,t){var n=null;t.forEach(function(t){n=this._sorter.sortBy(e,t.index,this._properties.get("value"),t.ascending,n)},this),this._sort={ref:e,columns:t},this._refreshFilter(),this.forEach(e,function(e,t,n){var i,o,r=n.formula;r&&(i=e-r.row,0!==i&&(o=i>0?r.row:r.row+i,r.adjust(this.name(),"row",o,i)))}.bind(this)),this.triggerChange({recalc:!0})},_refreshFilter:function(){this._filter&&this._filterBy(this._filter.ref,this._filter.columns)},_filterBy:function(t,n){this.batch(function(){for(var i=t.topLeft.row;i<=t.bottomRight.row;i++)this._rows.hidden(i)&&this._rows.unhide(i);n.forEach(function(n){var i,o,r,s=t.resize({top:1}).toColumn(n.index),a=[];if(s!==e.spreadsheet.NULLREF)for(this.forEach(s,function(e,t,n){n.row=e,a.push(n)}),n.filter.prepare(a),i=0;i<a.length;i++)o=a[i],r=n.filter.value(o),n.filter.matches(r)===!1&&this.hideRow(o.row)},this),this._filter={ref:t,columns:n}},{recalc:!0,layout:!0,filter:!0})},filterColumn:function(e){var t=this.filter().ref;return e.toRangeRef().topLeft.col-t.topLeft.col},filter:function(){return this._filter},clearFilter:function(e){this._clearFilter(e instanceof Array?e:[e])},_clearFilter:function(e){this._filter&&this.batch(function(){this._filter.columns=this._filter.columns.filter(function(t){return e.indexOf(t.index)<0}),this._refreshFilter()},{recalc:!0,layout:!0,filter:!0})},getAxisState:function(){return{rows:this._rows.getState(),columns:this._columns.getState()}},setAxisState:function(e){this._rows.setState(e.rows),this._columns.setState(e.columns),this.triggerChange({layout:!0})},getState:function(){return{rows:this._rows.getState(),columns:this._columns.getState(),mergedCells:this._mergedCells.map(function(e){return e.clone()}),properties:this._properties.getState()}},setState:function(t){this._rows.setState(t.rows),this._columns.setState(t.columns),this._mergedCells=t.mergedCells,this._properties.setState(t.properties),this.triggerChange(e.spreadsheet.ALL_REASONS)},_merge:function(t){var n,i=this._mergedCells,r=this;return this.batch(function(){n=t.map(function(t){var n,s,a,l,c,d,u;return t instanceof e.spreadsheet.CellRef?t:(n=t.toRangeRef().union(i,function(e){i.splice(i.indexOf(e),1)}),s=new o(n,r),a=s._get("formula"),l=s.value(),c=s.format(),d=s.background(),s.value(null),s.format(null),s.background(null),u=new o(n.collapse(),r),a?u._set("formula",a):u.value(l),u.format(c),u.background(d),i.push(n),n)});var s=r._viewSelection;s.selection=r.unionWithMerged(s.originalSelection),s._activeCell=r.unionWithMerged(s.originalActiveCell)},{activeCell:!0,selection:!0}),n}}),e.spreadsheet.Sheet=a)}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/sheetsbar.min",["kendo.core.min","kendo.sortable.min"],e)}(function(){!function(e){var t,n,i,o,r,s;e.support.browser.msie&&e.support.browser.version<9||(t=e.jQuery,n=e._outerWidth,i=".",o=" ",r={sheetsBarWrapper:"k-widget k-header",sheetsBarSheetsWrapper:"k-tabstrip k-floatwrap k-tabstrip-bottom",sheetsBarActive:"k-spreadsheet-sheets-bar-active",sheetsBarInactive:"k-spreadsheet-sheets-bar-inactive",sheetsBarAdd:"k-spreadsheet-sheets-bar-add",sheetsBarRemove:"k-spreadsheet-sheets-remove",sheetsBarItems:"k-spreadsheet-sheets-items",sheetsBarEditor:"k-spreadsheet-sheets-editor",sheetsBarScrollable:"k-tabstrip-scrollable",sheetsBarNext:"k-tabstrip-next",sheetsBarPrev:"k-tabstrip-prev",sheetsBarKItem:"k-item k-state-default",sheetsBarKActive:"k-state-active k-state-tab-on-top",sheetsBarKTextbox:"k-textbox",sheetsBarKLink:"k-link",sheetsBarKIcon:"k-icon",sheetsBarKFontIcon:"k-icon",sheetsBarKButton:"k-button k-button-icon",sheetsBarKButtonBare:"k-bare",sheetsBarKArrowW:"k-i-arrow-60-left",sheetsBarKArrowE:"k-i-arrow-60-right",sheetsBarKReset:"k-reset k-tabstrip-items",sheetsBarKIconX:"k-i-close",sheetsBarKSprite:"k-sprite",sheetsBarKIconPlus:"k-i-plus",sheetsBarHintWrapper:"k-widget k-tabstrip k-tabstrip-bottom k-spreadsheet-sheets-items-hint",sheetsBarKResetItems:"k-reset k-tabstrip-items"},s=e.ui.Widget.extend({init:function(t,n){var o=s.classNames;e.ui.Widget.call(this,t,n),t=this.element,t.addClass(o.sheetsBarWrapper),this._openDialog=n.openDialog,this._tree=new e.dom.Tree(t[0]),this._tree.render([this._addButton(),this._createSheetsWrapper([])]),this._toggleScrollEvents(!0),this._createSortable(),this._sortable.bind("start",this._onSheetReorderStart.bind(this)),this._sortable.bind("end",this._onSheetReorderEnd.bind(this)),t.on("click",i+o.sheetsBarRemove,this._onSheetRemove.bind(this)),t.on("click","li",this._onSheetSelect.bind(this)),t.on("dblclick","li"+i+o.sheetsBarActive,this._createEditor.bind(this)),t.on("click",i+o.sheetsBarAdd,this._onAddSelect.bind(this))},options:{name:"SheetsBar",scrollable:{distance:200}},events:["select","reorder","rename"],_createEditor:function(){this._editor||(this._renderSheets(this._sheets,this._selectedIndex,!0),this._editor=this.element.find(e.format("input{0}{1}",i,s.classNames.sheetsBarEditor)).focus().on("keydown",this._onEditorKeydown.bind(this)).on("blur",this._onEditorBlur.bind(this)))},_destroyEditor:function(e){var t=e?null:this._editor.val();this._editor.off(),this._editor=null,this._renderSheets(this._sheets,this._selectedIndex,!1),this._onSheetRename(t)},renderSheets:function(e,t){!e||t<0||this._renderSheets(e,t,!1)},_renderSheets:function(t,r,a){var l,c,d,u,h,f,p,m,g,v,_,b=this,w=s.classNames;b._isRtl=e.support.isRtl(b.element),b._sheets=t,b._selectedIndex=r,b._renderHtml(a,!0),b._scrollableAllowed()&&(d=b._sheetsWrapper(),u=d.children(i+w.sheetsBarPrev),h=d.children(i+w.sheetsBarNext),f=2,p=b.element.find(i+w.sheetsBarAdd),m=n(p)+p.position().left+f,g=n(u)+f,v=b._sheetsGroup(),u.css({left:m}),d.addClass(w.sheetsBarScrollable+o+w.sheetsBarSheetsWrapper),v.css({marginLeft:m}),l=d[0].offsetWidth,c=v[0].scrollWidth,c+m>l?(_=Math.ceil(e.parseFloat(h.css("right"))),b._scrollableModeActive||(b._nowScrollingSheets=!1,b._scrollableModeActive=!0),v.css({marginLeft:g+m,marginRight:n(h)+_+f})):b._scrollableModeActive&&c<=l?(b._scrollableModeActive=!1,v.css({marginLeft:m,marginRight:""})):v.css({marginLeft:m}),b._toggleScrollButtons())},_toggleScrollButtons:function(e){var t=this,n=t._sheetsGroup(),o=t._sheetsWrapper(),r=n.scrollLeft(),a=o.find(i+s.classNames.sheetsBarPrev),l=o.find(i+s.classNames.sheetsBarNext);e===!1?(a.toggle(!1),l.toggle(!1)):(a.toggle(t._isRtl?r<n[0].scrollWidth-n[0].offsetWidth-1:0!==r),l.toggle(t._isRtl?0!==r:r<n[0].scrollWidth-n[0].offsetWidth-1))},_toggleScrollEvents:function(e){var t=this,n=s.classNames,o=t.options,r=t._sheetsWrapper(),a=r.children(i+n.sheetsBarPrev),l=r.children(i+n.sheetsBarNext);e?(a.on("mousedown",function(){t._nowScrollingSheets=!0,t._scrollSheetsByDelta(o.scrollable.distance*(t._isRtl?1:-1))}),l.on("mousedown",function(){t._nowScrollingSheets=!0,t._scrollSheetsByDelta(o.scrollable.distance*(t._isRtl?-1:1))}),a.add(l).on("mouseup",function(){t._nowScrollingSheets=!1})):(a.off(),l.off())},_renderHtml:function(t,n){var i,r,a,l,c,d,u=[],h=e.dom,f=h.element,p=this._sheets,m=this._selectedIndex,g=s.classNames;for(i=0;i<p.length;i++)r=p[i],a=i===m,l={className:g.sheetsBarKItem+o},c=[],l.className+=a?g.sheetsBarKActive+o+g.sheetsBarActive:g.sheetsBarInactive,a&&t?c.push(f("input",{type:"text",value:r.name(),className:g.sheetsBarKTextbox+o+g.sheetsBarEditor,maxlength:50},[])):(c.push(f("span",{className:g.sheetsBarKLink,title:r.name()},[h.text(r.name())])),p.length>1&&(d=f("span",{className:g.sheetsBarKIcon+o+g.sheetsBarKFontIcon+o+g.sheetsBarKIconX},[]),c.push(f("span",{className:g.sheetsBarKLink+o+g.sheetsBarRemove},[d])))),u.push(f("li",l,c));this._tree.render([this._addButton(),this._createSheetsWrapper(u,n)])},_createSheetsWrapper:function(t,n){var i,r=e.dom.element,a=s.classNames,l=[r("ul",{className:a.sheetsBarKReset},t)];return n=!0,n&&(i=a.sheetsBarKButton+o+a.sheetsBarKButtonBare+o,l.push(r("span",{className:i+a.sheetsBarPrev},[r("span",{className:a.sheetsBarKIcon+o+a.sheetsBarKArrowW},[])])),l.push(r("span",{className:i+a.sheetsBarNext},[r("span",{className:a.sheetsBarKIcon+o+a.sheetsBarKArrowE},[])]))),r("div",{className:a.sheetsBarItems},l)},_createSortable:function(){var n=s.classNames;this._sortable=new e.ui.Sortable(this.element,{filter:e.format("ul li.{0},ul li.{1}",n.sheetsBarActive,n.sheetsBarInactive),container:i+n.sheetsBarItems,axis:"x",animation:!1,ignore:"input",end:function(){this.draggable.hint&&this.draggable.hint.remove()},hint:function(e){var i=t(e).clone();return i.wrap("<div class='"+n.sheetsBarHintWrapper+"'><ul class='"+n.sheetsBarKResetItems+"'></ul></div>").closest("div")}})},_onEditorKeydown:function(e){this._editor&&(13===e.which&&this._destroyEditor(),27===e.which&&this._destroyEditor(!0))},_onEditorBlur:function(){this._editor&&this._destroyEditor()},_onSheetReorderEnd:function(e){e.preventDefault(),this.trigger("reorder",{oldIndex:e.oldIndex,newIndex:e.newIndex})},_onSheetReorderStart:function(e){this._editor&&e.preventDefault()},_onSheetRemove:function(e){var n,i=t(e.target).closest("li").text();this._editor&&this._destroyEditor(),n=function(e){var t=e.sender;t.isConfirmed()&&this.trigger("remove",{name:i,confirmation:!0})}.bind(this),this._openDialog("confirmation",{close:n})},_onSheetSelect:function(e){var n=t(e.target).text();return t(e.target).is(i+s.classNames.sheetsBarEditor)||!n?void e.preventDefault():(this._editor&&this._destroyEditor(),this._scrollSheetsToItem(t(e.target).closest("li")),void this.trigger("select",{name:n,isAddButton:!1}))},_onSheetRename:function(e){this._sheets[this._selectedIndex].name()!==e&&null!==e&&this.trigger("rename",{name:e,sheetIndex:this._selectedIndex})},_onAddSelect:function(){this.trigger("select",{isAddButton:!0})},_addButton:function(){var t=e.dom.element,n=s.classNames;return t("a",{className:n.sheetsBarAdd+o+n.sheetsBarKButton},[t("span",{className:n.sheetsBarKIcon+o+n.sheetsBarKFontIcon+o+n.sheetsBarKIconPlus},[])])},destroy:function(){this._sortable.destroy()},_scrollableAllowed:function(){var e=this.options;return e.scrollable&&!isNaN(e.scrollable.distance)},_scrollSheetsToItem:function(e){var t,i,o,r,s,a,l,c=this;c._scrollableModeActive&&(t=c._sheetsGroup(),i=t.scrollLeft(),o=n(e),r=c._isRtl?e.position().left:e.position().left-t.children().first().position().left,s=t[0].offsetWidth,a=Math.ceil(parseFloat(t.css("padding-left"))),c._isRtl?r<0?l=i+r-(s-i)-a:r+o>s&&(l=i+r-o+2*a):i+s<r+o?l=r+o-s+2*a:i>r&&(l=r-a),t.finish().animate({scrollLeft:l},"fast","linear",function(){c._toggleScrollButtons()}))},_sheetsGroup:function(){return this._sheetsWrapper().children("ul")},_sheetsWrapper:function(){return this.element.find(i+s.classNames.sheetsBarItems)},_scrollSheetsByDelta:function(e){var t=this,n=t._sheetsGroup(),i=n.scrollLeft();n.finish().animate({scrollLeft:i+e},"fast","linear",function(){t._nowScrollingSheets?t._scrollSheetsByDelta(e):t._toggleScrollButtons()})}}),e.spreadsheet.SheetsBar=s,t.extend(!0,s,{classNames:r}))}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/calc.min",["spreadsheet/runtime.min"],e)}(function(){"use strict";function e(e){e=e.toUpperCase();for(var t=0,n=0;n<e.length;++n)t=26*t+e.charCodeAt(n)-64;return t-1}function t(e){return parseInt(e,10)-1}function n(n,i){var o,r,s,a,l,d;if("#sheet"==n.toLowerCase())return _.SHEETREF;e:{if(!(o=/^(\$)?([a-z]+)(\$)?(\d+)$/i.exec(n))){for(a=c(n,{}),l=[];;){if(d=a.next(),d instanceof y)d.rel=0;else{if(!(d instanceof w))break e;d.topLeft.rel=0,d.bottomRight.rel=0}if(l.push(d),a.eof())break;if(!a.is("op",","))break e;a.next()}return 1==l.length?l[0]:new _.UnionRef(l)}if(r=t(o[4]),s=e(o[2]),r<1048576&&s<16384)return new y(t(o[4]),e(o[2]))}if(!i)throw Error("Cannot parse reference: "+n)}function i(e,t,n,i){function o(e){return e.index=v.length,v.push(e),e}function r(e,t,n){if(g(e,t))return i.next();var o=i.peek();o?i.croak("Expected "+e+" «"+t+"» but found "+o.type+" «"+o.value+"»"):n||i.croak("Expected "+e+" «"+t+"»")}function s(e){return m(f(u(e)),0,e)}function a(e){return"TRUE"==e.upper||"FALSE"==e.upper?"TRUE"==e.upper?D:A:o(new k(e.value))}function l(){var e,t=i.next();for(t=t.value,r("punc","("),e=[];;){if(g("punc",")"))break;if(g("op",","))e.push({type:"null"}),i.next();else{if(e.push(s(!1)),i.eof()||g("punc",")"))break;r("op",",")}}return r("punc",")",!0),{type:"func",func:t,args:e}}function d(t){return t.hasSheet()||t.setSheet(e),o(t)}function u(e){var t;return g("ref")?t=d(i.next()):g("func")?t=l():g("punc","(")?(i.next(),t=s(!0),r("punc",")",!0)):g("punc","{")?(i.next(),t=h(),r("punc","}",!0)):g("num")||g("str")||g("error")?t=i.next():g("sym")?t=a(i.next()):g("op","+")||g("op","-")?t={type:"prefix",op:i.next().value,exp:u(e)}:i.croak(i.peek()?g("punc","[")?"External reference not supported":"Parse error":"Incomplete expression"),p(t)}function h(){for(var e=[],t=[e],n=!0;!i.eof()&&!g("punc","}");)n?n=!1:g("punc",";")?(t.push(e=[]),i.next()):r("op",","),e.push(s(!1));return{type:"matrix",value:t}}function f(e){return g("punc","(")||g("ref")||g("num")||g("func")?{type:"binary",op:" ",left:e,right:s(!1)}:e}function p(e){return g("op","%")?(i.next(),p({type:"postfix",op:"%",exp:e})):e}function m(e,t,n){var o,r,s=g("op");return s&&(n||","!=s.value)&&(o=S[s.value],o>t)?(i.next(),r=m(u(n),o,n),m({type:"binary",op:s.value,left:e,right:r},t,n)):e}var g,v=[];return i=c(i,{row:t,col:n}),g=i.is,{type:"exp",ast:s(!0),refs:v,sheet:e,row:t,col:n}}function o(e,t){var n,o=i(null,0,0,e);if(!(o.ast instanceof k))throw new T("Invalid name: "+e);return o=o.ast,t instanceof b||(n=i(o.sheet,0,0,t),t=n.ast instanceof b?n.ast:/^(?:str|num|bool|error)$/.test(n.ast.type)?n.ast.value:a(n)),{name:o,value:t}}function r(e){function t(e,i,o){function r(t){var r=e.op,s=S[r]<o||!o&&","==r||"prefix"==i.type&&o==S[r]&&"-"==i.op||"binary"==i.type&&o==S[r]&&e===i.right;return n(t(),s)}switch(e.type){case"num":case"bool":return JSON.stringify(e.value);case"error":return JSON.stringify("#"+e.value);case"str":return JSON.stringify(JSON.stringify(e.value));case"ref":return"this.refs["+e.index+"].print(row, col, mod)";case"prefix":return r(function(){return JSON.stringify(e.op)+" + "+t(e.exp,e,S[e.op])});case"postfix":return r(function(){return t(e.exp,e,S[e.op])+" + "+JSON.stringify(e.op)});case"binary":return r(function(){var i=n(t(e.left,e,S[e.op]),e.left instanceof k&&":"==e.op),o=n(t(e.right,e,S[e.op]),e.right instanceof k&&":"==e.op);return i+" + "+JSON.stringify(e.op)+" + "+o});case"func":return JSON.stringify(e.func+"(")+" + "+(e.args.length>0?e.args.map(function(n){return t(n,e,0)}).join(" + ', ' + "):"''")+" + ')'";case"matrix":return"'{ ' + "+e.value.map(function(n){return n.map(function(n){return t(n,e,0)}).join(" + ', ' + ")}).join(" + '; ' + ")+"+ ' }'";case"null":return"''"}throw Error("Cannot make printer for node "+e.type)}function n(e,t){return t?"'(' + "+e+" + ')'":e}return E("function(row, col, mod){return("+t(e.ast,e,0)+")}")}function s(e,t){function n(e,t){switch(e.type){case"ref":return i(e,t);case"num":case"str":case"null":case"error":case"bool":return o(e,t);case"prefix":case"postfix":return s(e,t);case"binary":return a(e,t);case"func":return u(e,t);case"lambda":return h(e,t);case"matrix":return f(e.value,t,!0)}throw Error("Cannot CPS "+e.type)}function i(e,t){return"name"==e.ref?r(e,t):o(e,t)}function o(e,t){return t(e)}function r(e,t){return{type:"func",func:",getname",args:[p(t),e]}}function s(e,t){return n({type:"func",func:"unary"+e.op,args:[e.exp]},t)}function a(e,t){return n({type:"func",func:"binary"+e.op,args:[e.left,e.right]},t)}function l(e,t,i,o){return n(e,function(e){var r=p(o),s=m("T"),a=m("E");return{type:"func",func:"if",args:[r,e,{type:"lambda",vars:[s],body:n(t||D,function(e){return{type:"call",func:{type:"var",name:s},args:[e]}})},{type:"lambda",vars:[a],body:n(i||A,function(e){return{type:"call",func:{type:"var",name:a},args:[e]}})}]}})}function c(e,t){return 0===e.length?o(D,t):n({type:"func",func:"IF",args:[e[0],{type:"func",func:"AND",args:e.slice(1)},A]},t)}function d(e,t){return 0===e.length?o(A,t):n({type:"func",func:"IF",args:[e[0],D,{type:"func",func:"OR",args:e.slice(1)}]},t)}function u(e,t){switch(e.func.toLowerCase()){case"if":return l(e.args[0],e.args[1],e.args[2],t);case"and":return c(e.args,t);case"or":return d(e.args,t);case"true":return t(D);case"false":return t(A)}return function i(t,o){return o==e.args.length?{type:"func",func:e.func,args:t}:n(e.args[o],function(e){return i(t.concat([e]),o+1)})}([p(t)],0)}function h(e,t){var i=m("K"),o=n(e.body,function(e){return{type:"call",func:{type:"var",value:i},args:[e]}});return t({type:"lambda",vars:[i].concat(e.vars),body:o})}function f(e,t,i){var o=[];return function r(s){return s==e.length?t({type:"matrix",value:o}):(i?f:n)(e[s],function(e){return o[s]=e,r(s+1)})}(0)}function p(e){var t=m("R");return{type:"lambda",vars:[t],body:e({type:"var",name:t})}}function m(e){return e||(e=""),e="_"+e,e+ ++g}var g=0;return n(e,t)}function a(e){function t(e){var i=e.type;if("num"==i)return e.value+"";if("str"==i)return JSON.stringify(e.value);if("error"==i)return"context.error("+JSON.stringify(e.value)+")";if("return"==i)return"context.resolve("+t(e.value)+")";if("func"==i)return"context.func("+JSON.stringify(e.func)+", "+t(e.args[0])+", "+n(e.args.slice(1))+")";if("call"==i)return t(e.func)+"("+e.args.map(t).join(", ")+")";if("ref"==i)return"refs["+e.index+"]";if("bool"==i)return""+e.value;if("if"==i)return"(context.bool("+t(e.co)+") ? "+t(e.th)+" : "+t(e.el)+")";if("lambda"==i)return"(function("+e.vars.join(", ")+"){ return("+t(e.body)+") })";if("var"==i)return e.name;if("matrix"==i)return n(e.value);if("null"==i)return"null";throw Error("Cannot compile expression "+i)}function n(e){return"[ "+e.map(t).join(", ")+" ]"}var i,o=r(e),a=o.call(e),l=I[a];return l?l.clone(e.sheet,e.row,e.col):(i=t(s(e.ast,function(e){return{type:"return",value:e}})),i=["function(){","var context = this, refs = context.formula.absrefs",i,"}"].join(";\n"),l=new C.Formula(e.refs,E(i),o,e.sheet,e.row,e.col),I[a]=l.clone(e.sheet,e.row,e.col),l)}function l(e){return e}function c(n,i){function o(e,t){var n=r();return null==n||null!=e&&n.type!==e||null!=t&&n.value!==t?null:n}function r(){return null==C&&(C=a()),C}function s(){if(null!=C){var e=C;return C=null,e}return a()}function a(){var e,t=n.peek();return t&&("sym"!=t.type&&"rc"!=t.type&&"num"!=t.type||(e=b(8,d)||b(6,f)||b(6,p)||b(4,m)||b(4,g)||b(2,v)||b(2,_)),e||(e=n.next())),e}function c(o,r){var s,a,l,c,d;if("rc"==o.type)return!o.rel||i.forEditor||null!=i.row&&null!=i.col||n.croak("Cannot read relative cell in RC notation"),new y(o.row,o.col,o.rel);if("num"==o.type)return o.value<=1048577?S(new y(t(o.value),r?-(1/0):+(1/0),2)):null;if(s=o.value,a=/^(\$)?([a-z]+)(\$)?(\d+)$/i.exec(s))return l=t(a[4]),c=e(a[2]),l<=1048576&&c<=16383?S(new y(t(a[4]),e(a[2]),(a[1]?0:1)|(a[3]?0:2))):null;if(d="$"==s.charAt(0),d&&(s=s.substr(1)),/^\d+$/.test(s)){if(l=t(s),l<=1048576)return S(new y(t(s),r?-(1/0):+(1/0),d?0:2))}else if(c=e(s),c<=16383)return S(new y(r?-(1/0):+(1/0),e(s),d?0:1))}function d(e,t,n,i,o,r,s,a){if("sym"==e.type&&"op"==t.type&&":"==t.value&&"sym"==n.type&&"punc"==i.type&&"!"==i.value&&("sym"==o.type||"rc"==o.type||"num"==o.type&&o.value==o.value|0)&&"op"==r.type&&":"==r.value&&("sym"==s.type||"rc"==s.type||"num"==s.type&&s.value==s.value|0)&&s.type==o.type&&("punc"!=a.type||"("!=a.value||s.space)){var l=c(o,!0),d=c(s,!1);if(l&&d)return x(7),T(new w(l.setSheet(e.value,!0),d.setSheet(n.value,!0)).setSheet(e.value,!0),e,s)}}function f(e,t,n,i,o,r){var s,a;if("sym"==e.type&&"op"==t.type&&":"==t.value&&"sym"==n.type&&"punc"==i.type&&"!"==i.value&&("sym"==o.type||"rc"==o.type||"num"==o.type&&o.value==o.value|0)&&("punc"!=r.type||"("!=r.value||o.space)&&(s=c(o)))return x(5),a=s.clone(),T(new w(s.setSheet(e.value,!0),a.setSheet(n.value,!0)).setSheet(e.value,!0),e,o)}function p(e,t,n,i,o,r){if("sym"==e.type&&"punc"==t.type&&"!"==t.value&&("sym"==n.type||"rc"==n.type||"num"==n.type&&n.value==n.value|0)&&"op"==i.type&&":"==i.value&&("sym"==o.type||"rc"==o.type||"num"==o.type&&o.value==o.value|0)&&("punc"!=r.type||"("!=r.value||o.space)){var s=c(n,!0),a=c(o,!1);if(s&&a)return x(5),T(new w(s,a).setSheet(e.value,!0),e,o)}}function m(e,t,n,i){if("sym"==e.type&&"punc"==t.type&&"!"==t.value&&("sym"==n.type||"rc"==n.type||"num"==n.type&&n.value==n.value|0)&&("punc"!=i.type||"("!=i.value||n.space)){x(3);var o=c(n);return o&&isFinite(o.row)||(o=new k(n.value)),T(o.setSheet(e.value,!0),e,n)}}function g(e,t,n,i){if(("sym"==e.type||"rc"==e.type||"num"==e.type&&e.value==e.value|0)&&"op"==t.type&&":"==t.value&&("sym"==n.type||"rc"==n.type||"num"==n.type&&n.value==n.value|0)&&("punc"!=i.type||"("!=i.value||n.space)){var o=c(e,!0),r=c(n,!1);if(o&&r)return x(3),T(new w(o,r),e,n)}}function v(e,t){if(("sym"==e.type||"rc"==e.type)&&("punc"!=t.type||"("!=t.value||e.space)){var n=c(e);if(n&&isFinite(n.row)&&isFinite(n.col))return x(1),T(n,e,e)}}function _(e,t){if("sym"==e.type&&"punc"==t.type&&"("==t.value&&!e.space)return e.type="func",x(1),e}var b,x,C,S,T;return n=u(h(n),i),b=n.ahead,x=n.skip,C=null,S=null!=i.row&&null!=i.col?function(e){return 1&e.rel&&(e.col-=i.col),2&e.rel&&(e.row-=i.row),e}:l,T=i.forEditor?function(e,t,n){return e.begin=t.begin,e.end=n.end,e}:l,{peek:r,next:s,croak:n.croak,eof:n.eof,is:o}}function d(e){return" \t\n ​".indexOf(e)>=0}function u(e,t){function n(e){return/[0-9]/i.test(e)}function i(e){return/[a-z$_]/i.test(e)||v.isUnicodeLetter(e)}function o(e){return i(e)||n(e)||"."==e}function r(e){return e in S}function s(e){return"!;(){}[]".indexOf(e)>=0}function a(){var e=!1,t=T(function(t){return"."==t?!e&&(e=!0,!0):n(t)});return{type:"num",value:parseFloat(t)}}function l(t,n){return{type:"sym",value:t,upper:t.toUpperCase(),space:d(e.peek()),quote:n}}function c(e,t,n){if(!e&&!t&&!n)return null;if(!e&&!n||e&&n){var i=t?parseInt(t,10):0;return e?i:i-1}}function u(){var t,n,i=e.lookingAt(/^R(\[)?(-?[0-9]+)?(\])?C(\[)?(-?[0-9]+)?(\])?/i);return i&&(t=c(i[1],i[2],i[3]),n=c(i[4],i[5],i[6]),null!=t&&null!=n)?(e.skip(i),{type:"rc",row:t,col:n,rel:(i[4]||!(i[4]||i[5]||i[6])?1:0)|(i[1]||!(i[1]||i[2]||i[3])?2:0)}):l(T(o))}function h(){return e.next(),{type:"str",value:e.readEscaped('"')}}function f(){return e.next(),l(e.readEscaped("'"),!0)}function p(){return{type:"op",value:T(function(e,t){return t+e in S})}}function m(){return{type:"punc",value:e.next()}}function g(){if(e.eof())return null;var o,l=e.peek();return'"'==l?h():"'"==l?f():n(l)||"."==l?a():i(l)?u():r(l)?p():s(l)?m():(o=e.lookingAt(/^#([a-z\/]+)[?!]?/i))?(e.skip(o),{type:"error",value:o[1]}):(t.forEditor||e.croak("Can't handle character: "+l),{type:"error",value:e.next()})}function _(){for(var n,i;x.length<=C;)T(d),n=e.pos(),i=g(),t.forEditor&&i&&(i.begin=n,i.end=e.pos()),x.push(i);return x[C]}function b(){var e=_();return e&&C++,e}function w(e,t){for(var n=C,i=[];e-- >0;)i.push(b()||M);return C=n,t.apply(i,i)}function y(e){C+=e}function k(){return null==_()}var x=[],C=0,T=e.readWhile;return{next:b,peek:_,eof:k,croak:e.croak,ahead:w,skip:y}}function h(e){function t(){return u}function n(){var t=e.charAt(u++);return"\n"==t?(h++,f=0):f++,t}function i(){return e.charAt(u)}function o(){return""===i()}function r(t){throw new T(t+" (input: "+e+")",u)}function s(t){if("string"==typeof t)e.substr(u,t.length)!=t&&r("Expected "+t),a(t.length);else if(t instanceof RegExp){var n=t.exec(e.substr(u));if(n)return a(n[0].length),n}else a(t[0].length)}function a(e){for(;e-- >0;)n()}function l(e){for(var t,i=!1,r="";!o();)if(t=n(),i)r+=t,i=!1;else if("\\"==t)i=!0;else{if(t==e)break;r+=t}return r}function c(e){for(var t="";!o()&&e(i(),t);)t+=n();return t}function d(t){return t.exec(e.substr(u))}var u=0,h=1,f=0;return{next:n,peek:i,eof:o,croak:r,readWhile:c,readEscaped:l,lookingAt:d,skip:s,forward:a,pos:t}}function f(e,t,n){function i(){var i=e.next();return"sym"==i.type?"TRUE"==i.upper?(i.type="bool",i.value=!0):"FALSE"==i.upper&&(i.type="bool",i.value=!1):"ref"==i.type&&(i={type:"ref",ref:null!=t&&null!=n?i.absolute(t,n):i,begin:i.begin,end:i.end}),i}var o,r=[];for(e=c(e,{forEditor:!0,row:t,col:n});!e.eof();)r.push(i());return o=r[0],"op"==o.type&&"="==o.value&&(o.type="startexp"),r}function p(e,t,n){var i,o;for(t=t||0,n=n||0,e=c(e,{row:t,col:n}),i=[];!e.eof();){if(o=e.next(),"ref"!=o.type)throw new T("Expecting a reference but got: "+JSON.stringify(o));i.push(o.absolute(t,n))}return i}function m(e,t){var n=e+t,i=z[n];return i||(i="^(\\d+(COM\\d{3})*(DOT\\d+)?)",i=i.replace(/DOT/g,"\\"+t).replace(/COM/g,"\\"+e),i=RegExp(i),z[n]=i),i}function g(e,t){for(var n="";t-- >0;)n+=e;return n}var v,_,b,w,y,k,x,C,S,T,D,A,E,I,M,R,F,z;kendo.support.browser.msie&&kendo.support.browser.version<9||(v=kendo.util,_=kendo.spreadsheet,b=_.Ref,w=_.RangeRef,y=_.CellRef,k=_.NameRef,x=_.calc,C=x.runtime,S=Object.create(null),T=kendo.Class.extend({init:function(e,t){this.message=e,this.pos=t},toString:function(){return this.message}}),function(e){e.forEach(function(t,n){t.forEach(function(t){S[t]=e.length-n})})}([[":"],[" "],[","],["%"],["^"],["*","/"],["+","-"],["&"],["=","<",">","<=",">=","<>"]]),D={type:"bool",value:!0},A={type:"bool",value:!1},E=function(e){return function(t){var n=e[t];return n||(n=e[t]=Function("'use strict';return("+t+")")()),n}}(Object.create(null)),I=Object.create(null),M={type:"eof"},R=[],F=x.registerFormatParser=function(e){R.push(e)},x.parse=function(e,t,n,o,r){var s,a,l,c,d;if(o instanceof Date)return{type:"date",value:C.dateToSerial(o)};if("number"==typeof o)return{type:"number",value:o};if("boolean"==typeof o)return{type:"boolean",value:o};if(o+="",/^'/.test(o))return{type:"string",value:o.substr(1)};if(/^[0-9.]+%$/.test(o)&&(s=o.substr(0,o.length-1),a=parseFloat(s),!isNaN(a)&&a==s))return{type:"percent",value:a/100};if(/^=/.test(o))return o=o.substr(1),/\S/.test(o)?i(e,t,n,o):{type:"string",value:"="+o};for(l=0;l<R.length;++l)if(c=R[l](o))return c;return"true"==o.toLowerCase()?{type:"boolean",value:!0}:"false"==o.toLowerCase()?{type:"boolean",value:!1}:(d=C.parseDate(o,r))?{type:"date",value:C.dateToSerial(d)}:(a=parseFloat(o),!isNaN(a)&&o.length>0&&a==o?{type:"number",value:a}:{type:"string",value:o})},x.parseNameDefinition=o,x.parseFormula=i,x.parseReference=n,x.compile=a,x.parseSqref=p,x.InputStream=h,x.ParseError=T,x.tokenize=f,F(function(e){var t,n,i,o,r;return(t=/^(\d+):(\d+)$/.exec(e))?(n=parseInt(t[1],10),i=parseInt(t[2],10),{type:"date",format:"hh:mm",value:C.packTime(n,i,0,0)}):(t=/^(\d+):(\d+)(\.\d+)$/.exec(e))?(i=parseInt(t[1],10),o=parseInt(t[2],10),r=1e3*parseFloat(t[3]),{type:"date",format:"mm:ss.00",value:C.packTime(0,i,o,r)}):(t=/^(\d+):(\d+):(\d+)$/.exec(e))?(n=parseInt(t[1],10),i=parseInt(t[2],10),o=parseInt(t[3],10),{type:"date",format:"hh:mm:ss",value:C.packTime(n,i,o,0)}):(t=/^(\d+):(\d+):(\d+)(\.\d+)$/.exec(e))?(n=parseInt(t[1],10),i=parseInt(t[2],10),o=parseInt(t[3],10),r=1e3*parseFloat(t[4]),{type:"date",format:"hh:mm:ss.00",value:C.packTime(n,i,o,r)}):void 0}),F(function(e){var t,n,i,o=kendo.culture(),r=o.numberFormat[","],s=o.numberFormat["."],a=o.numberFormat.currency.symbol,l=m(r,s),c=RegExp("^\\s*\\"+a+"\\s*"),d=1,u="",f="",p=!1;if(e=h(e.replace(/^\s+|\s+$/g,"")),e.skip(/^-\s*/)&&(d=-1),(t=e.skip(c))&&(p=!0,u+='"'+t[0]+'"'),e.skip(/^-\s*/)){if(d<0)return null;d=-1}if(!(n=e.skip(l)))return null;if(u+="#",t=e.skip(c)){if(p)return null;p=!0,f='"'+t[0]+'"'}return e.eof()?((n[2]||p)&&(u+=",#"),n[3]&&(u+="."+g("0",n[3].length-1)),i=n[0].replace(RegExp("\\"+r,"g"),"").replace(RegExp("\\"+s,"g"),"."),u+=f,p&&(u+=";-"+u),{type:"number",currency:p,format:u,value:d*parseFloat(i)}):null}),z={})},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/excel-reader.min",["kendo.core.min","kendo.color.min","util/parse-xml.min","spreadsheet/calc.min"],e)}(function(){"use strict";function e(e,t,i){var o=new FileReader;o.onload=function(e){var o=new JSZip(e.target.result);n(o,t,i)},o.readAsArrayBuffer(e)}function t(e){return e=/^\//.test(e)?e.substr(1):"xl/"+e}function n(e,t,n){var o,a,l,c,d,u,h;D=t.excelImportErrors=[],o=g(e),a=v(e,"_rels/workbook.xml"),l=b(e,a.byType.theme[0]),c=_(e,l),d=[],u=0,m(e,"xl/workbook.xml",{enter:function(n,i){var r,l,h,f;this.is(B)?(r=i["r:id"],l=a.byId[r],h=i.name,f=s(e,l),d.push({workbook:t,zip:e,strings:o,styles:c,file:l,options:{name:h,rows:Math.max(t.options.rows||0,f.rows),columns:Math.max(t.options.columns||0,f.cols),columnWidth:f.columnWidth,rowHeight:f.rowHeight}})):this.is(V)&&i.activeTab&&(u=w(i.activeTab))},text:function(e){var n,i,o,r=this.is(I);!r||y(r["function"])||y(r.vbProcedure)||(n=r.localSheetId,i=null,null!=n&&(i=d[n].options.name),o=r.name,i&&(o="'"+i.replace(/\'/g,"\\'")+"'!"+o),f(i,null,function(){t.defineName(o,e,y(r.hidden))},"reading user-defined name: "+o))}}),h=new x.Deferred,h.progress(function(e){n&&n.notify(e)}).then(function(){var e=t.sheets();r(e),t.activeSheet(e[u]),n&&n.resolve()}),i(d,t,h)}function i(e,t,n){var i,r=(new x.Deferred).resolve();for(i=0;i<e.length;i++)!function(i,s){r=r.then(function(){var r,a,l=t.insertSheet(i.options);return l.suspendChanges(!0),r=o(l,i),a={sheet:l,progress:s/(e.length-1)},r.then(function(){n.notify(a)}),r})}(e[i],i);r.then(function(){n.resolve()})}function o(e,t){var n=new x.Deferred;return setTimeout(function(){c(t.zip,t.file,e,t.strings,t.styles),n.resolve()},0),n}function r(e){for(var t=0;t<e.length;t++)e[t].suspendChanges(!1).triggerChange({recalc:!0})}function s(e,n){var i={rows:0,cols:0};return m(e,t(n),{enter:function(e,t){if("dimension"==e){var n=S(t.ref);n.bottomRight&&(i.cols=n.bottomRight.col+1,i.rows=n.bottomRight.row+1)}else"sheetFormatPr"===e?(t.defaultColWidth&&(i.columnWidth=a(parseFloat(t.defaultColWidth))),t.defaultRowHeight&&(i.rowHeight=l(parseFloat(t.defaultRowHeight)))):this.is(z)&&this.exit()}}),i}function a(e){var t=7,n=(256*e+Math.floor(128/t))/256;return Math.floor(n)*t}function l(e){return 1.5625*e}function c(e,n,i,o,r){var s,c,g,_,b,k,x,C,I,B,H,N,V,$,K=i._columns._count,Y=null,Q=n.replace(/worksheets\//,"worksheets/_rels/"),X=v(e,Q),Z=[];D=i._workbook.excelImportErrors,m(e,t(n),{enter:function(e,t){var n,o,f,m,v,b,k,x,C,T,D;if(this.is(A))g=null,_=null,s=t.r,null==s&&(s=S(Y),s.col++,s=""+s),Y=s,c=t.t,o=t.s,null!=o&&p(i,s,r,o);else if(this.is(R))i.range(t.ref).merge();else if(this.is(E)){if(f=w(t.min)-1,m=Math.min(K,w(t.max))-1,t.width&&(v=a(parseFloat(t.width)),0!==v&&i._columns.values.value(f,m,v)),"1"===t.hidden||0===v)for(b=f;b<=m;b++)i.hideColumn(b);null!=t.style&&p(i,new kendo.spreadsheet.RangeRef(new kendo.spreadsheet.CellRef((-(1/0)),f),new kendo.spreadsheet.CellRef((+(1/0)),m)),r,t.style)}else this.is(z)?(k=w(t.r)-1,t.ht&&(x=l(parseFloat(t.ht)),0!==x&&i._rows.values.value(k,k,x)),"1"!==t.hidden&&0!==x||i.hideRow(k)):this.is(P)?t.activeCell&&(C=S(t.activeCell),i.select(C,!0)):this.is(F)?"frozen"==t.state&&(t.xSplit&&i.frozenColumns(w(t.xSplit)),t.ySplit&&i.frozenRows(w(t.ySplit))):this.is(U)?i.showGridLines(y(t.showGridLines,!0)):this.is(W)?(T=t["r:id"],D=X.byId[T],D&&i.range(t.ref).link(D)):this.is(["autoFilter"])?I=t.ref:I&&(this.is(["filterColumn"])?B=parseInt(t.colId,10):this.is(["customFilters"])?(H=y(t.and)?"and":"or",N=[]):this.is(["customFilter"])?(n=d(t.operator,t.val),n&&N.push({operator:n.operator,value:n.value})):this.is(["dynamicFilter"])?Z.push({column:B,filter:new kendo.spreadsheet.DynamicFilter({type:u(t.type)})}):this.is(["top10"])?Z.push({column:B,filter:new kendo.spreadsheet.TopFilter({value:h(t.val),type:function(e,t){return e&&t?"topPercent":t?"topNumber":e?"bottomPercent":"bottomNumber"}(y(t.percent),y(t.top))})}):this.is(["filters"])?(V=y(t.blank),$=[]):this.is(["filter"])&&$.push(h(t.val)))},leave:function(e,t){var n,r;this.is(A)?null!=_?(n=f(i,b||s,function(){i.range(b||s).formula(_,k)},"parsing formula"),n&&i.range(b||s).value(_).background("#ffaaaa")):null!=g&&(r=i.range(s),
r._get("formula")||(c&&"n"!=c?"s"==c?g=o[w(g)]:"b"==c?g="1"===g:"d"==c&&(g=kendo.parseDate(g)):g=parseFloat(g),null!=g&&r.value(g))):this.is(j)?!function(){var e=kendo.spreadsheet.calc.parseSqref(t.sqref),n=t.type.toLowerCase(),o=t.operator;/^(?:whole|decimal)$/.test(n)?n="number":"list"==n&&(o="list"),!o&&/^(?:number|date)$/.test(n)&&(o="between"),e.forEach(function(e){f(i,e,function(){i.range(e).validation({type:y(t.showErrorMessage,!0)?"reject":"warning",from:x,to:C,dataType:n,comparerType:T[o]||o,allowNulls:y(t.allowBlank),showButton:y(t.showDropDown)||"date"==n||"list"==n,messageTemplate:t.error,titleTemplate:t.errorTitle})},"parsing validation")})}():"cols"==e?i._columns._refresh():"sheetData"==e?i._rows._refresh():"autoFilter"==e?(i.range(I).filter(Z),I=null):I&&("customFilters"==e?Z.push({column:B,filter:new kendo.spreadsheet.CustomFilter({logic:H,criteria:N})}):"filters"==e&&Z.push({column:B,filter:new kendo.spreadsheet.ValueFilter({values:$,blanks:V})}))},text:function(e){var t;this.is(O)||this.is(L)?g=e:(t=this.is(M))?(_=e,k="array"==t.t,b=k||"shared"==t.t?t.ref:null):this.is(q)?x=e:this.is(G)&&(C=e)}})}function d(e,t){var n={equal:"eq",notEqual:"ne",greaterThan:"gt",greaterThanOrEqual:"gte",lessThan:"lt",lessThanOrEqual:"lte"}[e];return t=h(t),n&&"number"==typeof t?{operator:n,value:t}:"notEqual"!=e&&e||"string"!=typeof t?void 0:{operator:e?"doesnotmatch":"matches",value:t}}function u(e){return{Q1:"quarter1",Q2:"quarter2",Q3:"quarter3",Q4:"quarter4",M1:"january",M2:"february",M3:"march",M4:"april",M5:"may",M6:"june",M7:"july",M8:"august",M9:"september",M10:"october",M11:"november",M12:"december"}[e.toUpperCase()]||e}function h(e){var t=parseFloat(e);return isNaN(t)||t!=e?e:t}function f(e,t,n,i){try{return n(),!1}catch(o){var r={context:i,error:o+""};return e&&(r.sheet=e.name()),t&&(r.location=t+""),D.push(r),!0}}function p(e,t,n,i){function o(e){var t="string"==typeof e?e:e.formatCode;null==t||/^general$/i.test(t)||(t=t.replace(/^\[\$-[0-9]+\]/,""),u.format(t))}function r(e){"solid"==e.type&&u.background(e.color)}function s(e){u.fontFamily(e.name),u._property("fontSize",e.size),e.bold&&u.bold(!0),e.italic&&u.italic(!0)}function a(e){function t(t,n){var i,o,r=e[t];r&&(i=$[r.style],0!==i&&(o=r.color,null==o&&(o="#000"),u._property(n,{size:i,color:o})))}t("left","borderLeft"),t("top","borderTop"),t("right","borderRight"),t("bottom","borderBottom")}function l(e,t){var n=h[e];if(null!=n&&!n)return!1;if(d=h[t],c&&null==d){if(n=c[e],null!=n&&!n)return!1;d=c[t]}return null!=d}var c,d,u=e.range(t),h=n.inlineStyles[i];h.xfId&&(c=n.namedStyles[h.xfId]),l("applyBorder","borderId")&&a(n.borders[d]),l("applyFont","fontId")&&s(n.fonts[d]),l("applyAlignment","textAlign")&&u.textAlign(d),l("applyAlignment","verticalAlign")&&u.verticalAlign(d),l("applyAlignment","wrapText")&&u._property("wrap",d),l("applyFill","fillId")&&r(n.fills[d]),l("applyNumberFormat","numFmtId")&&o(n.numFmts[d]||K[d])}function m(e,t,n){var i=e.files[t];i&&C(i.asUint8Array(),n)}function g(e){var t=[],n=null;return m(e,"xl/sharedStrings.xml",{leave:function(){this.is(N)&&(t.push(n),n=null)},text:function(e){this.is(H)&&(null==n&&(n=""),n+=e)}}),t}function v(e,n){var i={byId:{},byType:{theme:[]}};return m(e,t(n)+".rels",{enter:function(e,t){var n,o;"Relationship"==e&&(i.byId[t.Id]=t.Target,n=t.Type.match(/\w+$/)[0],o=i.byType[n]||[],o.push(t.Target),i.byType[n]=o)}}),i}function _(e,t){function n(e){function t(t){null!=e[t]&&(n[t]=y(e[t]))}var n={borderId:w(e.borderId),fillId:w(e.fillId),fontId:w(e.fontId),numFmtId:w(e.numFmtId),pivotButton:y(e.pivotButton),quotePrefix:y(e.quotePrefix),xfId:w(e.xfId)};return t("applyAlignment"),t("applyBorder"),t("applyFill"),t("applyFont"),t("applyNumberFormat"),t("applyProtection"),n}function i(e){var n,i,o;return e.rgb?k(e.rgb):e.indexed?te[w(e.indexed)]:e.theme?(n=t.colorScheme[w(e.theme)])?(i=kendo.parseColor(n),e.tint&&(i=i.toHSL(),o=parseFloat(e.tint),i.l=o<0?i.l*(1+o):i.l*(1-o)+(100-100*(1-o))),i.toCssRgba()):te[0]:void 0}var o={fonts:[],numFmts:{},fills:[],borders:[],namedStyles:[],inlineStyles:[]},r=null,s=null,a=null,l=null;return m(e,"xl/styles.xml",{enter:function(e,t,c){if(this.is(ee))o.numFmts[t.numFmtId]=t;else if(this.is(X))o.fonts.push(r={});else if(r)"sz"==e?r.size=parseFloat(t.val):"name"==e?r.name=t.val:"b"==e?r.bold=y(t.val,!0):"i"==e&&(r.italic=y(t.val,!0));else if(this.is(Q))o.fills.push(s={});else if(s)"patternFill"==e?s.type=t.patternType:"fgColor"==e&&"solid"===s.type?s.color=i(t):"bgColor"==e&&"solid"!==s.type&&(s.color=i(t));else if(this.is(Y))o.borders.push(a={});else if(a){if(/^(?:left|top|right|bottom)$/.test(e)&&t.style&&(a[e]={style:t.style}),"color"==e){var d=this.stack[this.stack.length-2].$tag;a[d].color=i(t)}}else this.is(J)?(l=n(t),o.namedStyles.push(l),c&&(l=null)):this.is(Z)?(l=n(t),o.inlineStyles.push(l),c&&(l=null)):l&&"alignment"==e&&(/^(?:left|center|right|justify)$/.test(t.horizontal)&&(l.textAlign=t.horizontal),/^(?:top|center|bottom)$/.test(t.vertical)&&(l.verticalAlign=t.vertical),null!=t.wrapText&&(l.wrapText=y(t.wrapText)))},leave:function(e){this.is(X)?r=null:this.is(Q)?s=null:this.is(Y)?a=null:"xf"==e&&(l=null)}}),o}function b(e,n){function i(e,t,n){var i=e[t];e[t]=e[n],e[n]=i}var o=[],r={colorScheme:o},s=t(n);return e.files[s]&&(m(e,s,{enter:function(e,t){this.is(ie)?o.push(k("window"==t.val?"FFFFFFFF":"FF000000")):this.is(ne)&&o.push(k("FF"+t.val))}}),o.length>3&&(i(o,0,1),i(o,2,3))),r}function w(e){return null==e?null:parseInt(e,10)}function y(e,t){return null==e?t:"true"==e||e===!0||1==e}function k(e){var t=/^([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(e);return"rgba("+parseInt(t[2],16)+", "+parseInt(t[3],16)+", "+parseInt(t[4],16)+", "+parseInt(t[1],16)/255+")"}var x,C,S,T,D,A,E,I,M,R,F,z,P,B,L,H,N,O,V,U,W,j,q,G,$,K,Y,Q,X,Z,J,ee,te,ne,ie;kendo.support.browser.msie&&kendo.support.browser.version<9||(x=kendo.jQuery,C=kendo.util.parseXML,S=kendo.spreadsheet.calc.parseReference,T={greaterThanOrEqual:"greaterThanOrEqualTo",lessThanOrEqual:"lessThanOrEqualTo"},D=null,A=["sheetData","row","c"],E=["cols","col"],I=["definedNames","definedName"],M=["sheetData","row","c","f"],R=["mergeCells","mergeCell"],F=["sheetViews","sheetView","pane"],z=["sheetData","row"],P=["sheetViews","sheetView","selection"],B=["sheets","sheet"],L=["sheetData","row","c","is"],H=["t"],N=["si"],O=["sheetData","row","c","v"],V=["bookViews","workbookView"],U=["sheetViews","sheetView"],W=["hyperlinks","hyperlink"],j=["dataValidations","dataValidation"],q=["dataValidations","dataValidation","formula1"],G=["dataValidations","dataValidation","formula2"],$={none:0,thin:1,medium:2,dashed:1,dotted:1,thick:3,"double":3,hair:1,mediumDashed:2,dashDot:1,mediumDashDot:2,dashDotDot:1,mediumDashDotDot:2,slantDashDot:1},K={0:"General",1:"0",2:"0.00",3:"#,##0",4:"#,##0.00",9:"0%",10:"0.00%",11:"0.00E+00",12:"# ?/?",13:"# ??/??",14:"mm-dd-yy",15:"d-mmm-yy",16:"d-mmm",17:"mmm-yy",18:"h:mm AM/PM",19:"h:mm:ss AM/PM",20:"h:mm",21:"h:mm:ss",22:"m/d/yy h:mm",37:"#,##0 ;(#,##0)",38:"#,##0 ;[Red](#,##0)",39:"#,##0.00;(#,##0.00)",40:"#,##0.00;[Red](#,##0.00)",45:"mm:ss",46:"[h]:mm:ss",47:"mmss.0",48:"##0.0E+0",49:"@"},Y=["borders","border"],Q=["fills","fill"],X=["fonts","font"],Z=["cellXfs","xf"],J=["cellStyleXfs","xf"],ee=["numFmts","numFmt"],te=[k("FF000000"),k("FFFFFFFF"),k("FFFF0000"),k("FF00FF00"),k("FF0000FF"),k("FFFFFF00"),k("FFFF00FF"),k("FF00FFFF"),k("FF000000"),k("FFFFFFFF"),k("FFFF0000"),k("FF00FF00"),k("FF0000FF"),k("FFFFFF00"),k("FFFF00FF"),k("FF00FFFF"),k("FF800000"),k("FF008000"),k("FF000080"),k("FF808000"),k("FF800080"),k("FF008080"),k("FFC0C0C0"),k("FF808080"),k("FF9999FF"),k("FF993366"),k("FFFFFFCC"),k("FFCCFFFF"),k("FF660066"),k("FFFF8080"),k("FF0066CC"),k("FFCCCCFF"),k("FF000080"),k("FFFF00FF"),k("FFFFFF00"),k("FF00FFFF"),k("FF800080"),k("FF800000"),k("FF008080"),k("FF0000FF"),k("FF00CCFF"),k("FFCCFFFF"),k("FFCCFFCC"),k("FFFFFF99"),k("FF99CCFF"),k("FFFF99CC"),k("FFCC99FF"),k("FFFFCC99"),k("FF3366FF"),k("FF33CCCC"),k("FF99CC00"),k("FFFFCC00"),k("FFFF9900"),k("FFFF6600"),k("FF666699"),k("FF969696"),k("FF003366"),k("FF339966"),k("FF003300"),k("FF333300"),k("FF993300"),k("FF993366"),k("FF333399"),k("FF333333"),k("FF000000"),k("FFFFFFFF")],ne=["a:clrScheme","*","a:srgbClr"],ie=["a:clrScheme","*","a:sysClr"],kendo.spreadsheet.readExcel=e,kendo.spreadsheet._readSheet=c,kendo.spreadsheet._readStrings=g,kendo.spreadsheet._readStyles=_,kendo.spreadsheet._readTheme=b,kendo.spreadsheet._readWorkbook=n)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/workbook.min",["kendo.core.min","spreadsheet/runtime.min","spreadsheet/references.min","spreadsheet/excel-reader.min"],e)}(function(){!function(e){function t(e,t){function n(e,t,n){return void 0!==e?e:void 0!==t?t:n}var i,o,r,s,a,l,c=n(e.rowCount,t.rows,200),d=n(e.columnCount,t.columns,50),u=n(e.rowHeight,t.rowHeight,20),h=n(e.columnWidth,t.columnWidth,64),f=n(e.headerHeight,t.headerHeight,20),p=n(e.headerWidth,t.headerWidth,32);if(void 0!==e.rows)for(i=0;i<e.rows.length;++i)if(o=e.rows[i],r=n(o.index,i),r>=c&&(c=r+1),o.cells)for(s=0;s<o.cells.length;++s)a=o.cells[s],l=n(a.index,s),l>=d&&(d=l+1);return{rowCount:c,columnCount:d,rowHeight:u,columnWidth:h,headerHeight:f,headerWidth:p}}var n,i,o,r,s;e.support.browser.msie&&e.support.browser.version<9||(n=e.jQuery,i=e.spreadsheet.calc.runtime.Formula,o=e.spreadsheet.Ref,r=e.spreadsheet.CalcError,s=e.Observable.extend({init:function(t,n){e.Observable.fn.init.call(this),this.options=t,this._view=n,this._sheets=[],this._sheetsSearchCache={},this._sheet=this.insertSheet({rows:this.options.rows,columns:this.options.columns,rowHeight:this.options.rowHeight,columnWidth:this.options.columnWidth,headerHeight:this.options.headerHeight,headerWidth:this.options.headerWidth,dataSource:this.options.dataSource}),this.undoRedoStack=new e.util.UndoRedoStack,this.undoRedoStack.bind(["undo","redo"],this._onUndoRedo.bind(this)),this._context=new e.spreadsheet.FormulaContext(this),this._validationContext=new e.spreadsheet.ValidationFormulaContext(this),this._names=Object.create(null),this.fromJSON(this.options)},clipboard:function(){return this._clipboard||(this._clipboard=new e.spreadsheet.Clipboard(this)),this._clipboard},destroy:function(){this.unbind(),this._clipboard&&this._clipboard.destroy()},events:["cut","copy","paste","change","excelImport","excelExport","insertSheet","removeSheet","selectSheet","renameSheet","insertRow","insertColumn","deleteRow","deleteColumn","hideRow","hideColumn","unhideRow","unhideColumn","select","changeFormat"],_sheetChange:function(e){this.trigger("change",e)},_sheetInsertRow:function(e){this.trigger("insertRow",{sheet:e.sender,index:e.index})&&e.preventDefault()},_sheetInsertColumn:function(e){this.trigger("insertColumn",{sheet:e.sender,index:e.index})&&e.preventDefault()},_sheetDeleteRow:function(e){this.trigger("deleteRow",{sheet:e.sender,index:e.index})&&e.preventDefault()},_sheetDeleteColumn:function(e){this.trigger("deleteColumn",{sheet:e.sender,index:e.index})&&e.preventDefault()},_sheetHideRow:function(e){this.trigger("hideRow",{sheet:e.sender,index:e.index})&&e.preventDefault()},_sheetHideColumn:function(e){this.trigger("hideColumn",{sheet:e.sender,index:e.index})&&e.preventDefault()},_sheetUnhideRow:function(e){this.trigger("unhideRow",{sheet:e.sender,index:e.index})&&e.preventDefault()},_sheetUnhideColumn:function(e){this.trigger("unhideColumn",{sheet:e.sender,index:e.index})&&e.preventDefault()},_sheetSelect:function(e){this.trigger("select",e)},_sheetCommandRequest:function(e){this.trigger("commandRequest",e)},_inputForRef:function(t){return new e.spreadsheet.Range(t,this._sheet).input()},_onUndoRedo:function(e){e.command.range().select()},execute:function(t){var i,o=n.extend({workbook:this},t.options),r=new e.spreadsheet[t.command](o),s=this.activeSheet();return o.origin&&r.origin(o.origin),r.range(o.operatingRange?o.operatingRange:s.selection()),i=r.exec(),i&&"error"===i.reason||(r.cannotUndo?this.undoRedoStack.clear():this.undoRedoStack.push(r)),i},resetFormulas:function(){this._sheets.forEach(function(e){e.resetFormulas()})},resetValidations:function(){this._sheets.forEach(function(e){e.resetValidations()})},refresh:function(e){e.recalc&&(this.resetFormulas(),this.resetValidations(),this._sheet.recalc(this._context),this._sheet.revalidate(this._validationContext))},activeSheet:function(t){return void 0===t?this._sheet:void(this.sheetByName(t.name())&&(this._sheet=t,t.triggerChange(e.spreadsheet.ALL_REASONS)))},moveSheetToIndex:function(e,t){var n=this.sheetIndex(e),i=this._sheets;n!==-1&&(this._sheetsSearchCache={},i.splice(t,0,i.splice(n,1)[0]),this.trigger("change",{sheetSelection:!0}))},insertSheet:function(t){var n,i,o,r,s,a;if(t=t||{},n=this,i="number"==typeof t.index?t.index:n._sheets.length,r=n._sheets,s=function(e){e=e?e:1;var t="Sheet"+e;return n.sheetByName(t)?s(e+1):t},!t.name||!n.sheetByName(t.name))return this._sheetsSearchCache={},o=t.name||s(),a=new e.spreadsheet.Sheet(t.rows||this.options.rows,t.columns||this.options.columns,t.rowHeight||this.options.rowHeight,t.columnWidth||this.options.columnWidth,t.headerHeight||this.options.headerHeight,t.headerWidth||this.options.headerWidth,t.defaultCellStyle||this.options.defaultCellStyle),a._workbook=this,a._name(o),this._bindSheetEvents(a),r.splice(i,0,a),t.data&&a.fromJSON(t.data),t.dataSource&&a.setDataSource(t.dataSource),this.trigger("change",{sheetSelection:!0}),a},_bindSheetEvents:function(e){e.bind("change",this._sheetChange.bind(this)),e.bind("insertRow",this._sheetInsertRow.bind(this)),e.bind("insertColumn",this._sheetInsertColumn.bind(this)),e.bind("deleteRow",this._sheetDeleteRow.bind(this)),e.bind("deleteColumn",this._sheetDeleteColumn.bind(this)),e.bind("hideRow",this._sheetHideRow.bind(this)),e.bind("hideColumn",this._sheetHideColumn.bind(this)),e.bind("unhideRow",this._sheetUnhideRow.bind(this)),e.bind("unhideColumn",this._sheetUnhideColumn.bind(this)),e.bind("select",this._sheetSelect.bind(this)),e.bind("commandRequest",this._sheetCommandRequest.bind(this))},sheets:function(){return this._sheets.slice()},sheetByName:function(e){return this._sheets[this.sheetIndex(e)]},sheetByIndex:function(e){return this._sheets[e]},sheetIndex:function(e){var t,n=this._sheets,i=("string"==typeof e?e:e.name()).toLowerCase(),o=this._sheetsSearchCache[i];if(o>=0)return o;for(o=0;o<n.length;o++)if(t=n[o].name().toLowerCase(),this._sheetsSearchCache[t]=o,t===i)return o;return-1},renameSheet:function(e,t){var n=e.name().toLowerCase();if(t&&n!==t.toLowerCase()&&!this.sheetByName(t)&&(e=this.sheetByName(n),e&&(this._sheetsSearchCache={},!this.trigger("renameSheet",{sheet:e,newSheetName:t}))))return this._sheets.forEach(function(e){e._forFormulas(function(e){e.renameSheet(n,t)})}),this.forEachName(function(e,r){e.nameref.renameSheet(n,t)&&(this.undefineName(r),e.name=e.nameref.print(),this.nameDefinition(e.name,e)),(e.value instanceof o||e.value instanceof i)&&e.value.renameSheet(n,t)}.bind(this)),e._name(t),this.trigger("change",{sheetSelection:!0}),e},removeSheet:function(e){var t,n=this,i=n._sheets,o=e.name(),r=n.sheetIndex(e);1!==i.length&&(this.trigger("removeSheet",{sheet:e})||(this._sheetsSearchCache={},r>-1&&(e.unbind(),i.splice(r,1),n.activeSheet().name()===o?(t=i[r===i.length?r-1:r],n.activeSheet(t)):this.trigger("change",{recalc:!0,sheetSelection:!0}))))},_clearSheets:function(){for(var e=0;e<this._sheets.length;e++)this._sheets[e].unbind();this._sheets=[],this._sheetsSearchCache={},this._names={}},fromJSON:function(e){var n,i,o,r;if(e.sheets)for(this._clearSheets(),n=0;n<e.sheets.length;n++)i=e.sheets[n],o=t(i,this.options),r=this.insertSheet({rows:o.rowCount,columns:o.columnCount,rowHeight:o.rowHeight,columnWidth:o.columnWidth,headerHeight:o.headerHeight,headerWidth:o.headerWidth,data:i}),i.dataSource&&r.setDataSource(i.dataSource);this.activeSheet(e.activeSheet?this.sheetByName(e.activeSheet):this._sheets[0]),e.names&&e.names.forEach(function(e){this.defineName(e.name,e.value,e.hidden)},this)},toJSON:function(){this.resetFormulas(),this.resetValidations();var e=Object.keys(this._names).map(function(e){var t=this._names[e],n=t.value;return n instanceof o||n instanceof i?n=n.print(0,0,!0):n instanceof r?n+="":n=JSON.stringify(n),{value:n,hidden:t.hidden,name:t.name,sheet:t.nameref.sheet,localName:t.nameref.name}},this);return{activeSheet:this.activeSheet().name(),sheets:this._sheets.map(function(e){return e.recalc(this._context),e.revalidate(this._validationContext),e.toJSON()},this),names:e,columnWidth:this.options.columnWidth,rowHeight:this.options.rowHeight}},fromFile:function(t){var i=new n.Deferred,o=i.promise(),r={file:t,promise:o};return t&&!this.trigger("excelImport",r)?(this._clearSheets(),e.spreadsheet.readExcel(t,this,i)):i.reject(),o},saveAsExcel:function(t){var i,o;t=n.extend({},this.options.excel,t),i=this.toJSON(),this.trigger("excelExport",{workbook:i})||(o=new e.ooxml.Workbook(i),e.saveAs({dataURI:o.toDataURL(),fileName:i.fileName||t.fileName,proxyURL:t.proxyURL,forceProxy:t.forceProxy}))},draw:function(t,n){"function"!=typeof t||n||(n=t,t={});var i=[],o=this._sheets;!function r(s){if(s<o.length)o[s].draw(e.spreadsheet.SHEETREF,t,function(e){i.push(e),r(s+1)});else{var a=i[0];for(s=1;s<i.length;++s)a.children=a.children.concat(i[s].children);n(a)}}(0)},nameForRef:function(e,t){var n,i,r,s;void 0===t&&(t=e.sheet),t=t.toLowerCase(),n=e+"";for(i in this._names)if(r=this._names[i],s=r.value,s instanceof o&&(!s.sheet||s.sheet&&t==s.sheet.toLowerCase())&&s+""==n)return r;return{name:n}},defineName:function(t,n,i){var o=e.spreadsheet.calc.parseNameDefinition(t,n);t=o.name.print(),this._names[t.toLowerCase()]={value:o.value,hidden:i,name:t,nameref:o.name}},undefineName:function(e){delete this._names[e.toLowerCase()]},nameValue:function(e){return e=e.toLowerCase(),e in this._names?this._names[e].value:null},nameDefinition:function(e,t){return e=e.toLowerCase(),arguments.length>1&&(void 0===t?delete this._names[e]:this._names[e]=t),this._names[e]},forEachName:function(e){Object.keys(this._names).forEach(function(t){e(this._names[t],t)},this)},adjustNames:function(e,t,n,r){e=e.toLowerCase(),Object.keys(this._names).forEach(function(s){var a=this._names[s],l=a.value;l instanceof o&&l.sheet.toLowerCase()==e?a.value=l.adjust(null,null,null,null,t,n,r):l instanceof i&&l.adjust(e,t?"row":"col",n,r)},this)},options:{}}),e.spreadsheet.Workbook=s,e.PDFMixin&&(e.PDFMixin.extend(s.prototype),s.prototype.saveAsPDF=function(t){var i=new n.Deferred,o=i.promise(),r={promise:o};if(!this.trigger("pdfExport",r))return this._drawPDF(t,i).then(function(t){return e.drawing.exportPDF(t)}).done(function(n){e.saveAs({dataURI:n,fileName:t.fileName,proxyURL:t.proxyURL,forceProxy:t.forceProxy,proxyTarget:t.proxyTarget}),i.resolve()}).fail(function(e){i.reject(e)}),o},s.prototype._drawPDF=function(e){var t=new n.Deferred,i=function(e){t.resolve(e)};switch(e.area){case"workbook":e.workbook.draw(e,i);break;case"sheet":e.workbook.activeSheet().draw(e,i);break;case"selection":e.workbook.activeSheet().selection().draw(e,i)}return t.promise()}))}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/formulacontext.min",["kendo.core.min"],e)}(function(){var e,t,n,i,o,r,s,a;kendo.support.browser.msie&&kendo.support.browser.version<9||(e=kendo.spreadsheet,t=e.CellRef,n=e.RangeRef,i=e.UnionRef,o=e.NameRef,r=e.Ref,s=kendo.Class.extend({init:function(e){this.workbook=e},getRefCells:function(e,s,a,l,c){var d,u,h,f,p,m,g,v,_,b,w,y,k,x,C,S,T;if(e instanceof t)return d=this.workbook.sheetByName(e.sheet),d&&e.valid()?(u=d.formula(e),h=d.range(e.row,e.col).value(),null!=u||null!=h?[{formula:u,value:h,row:e.row,col:e.col,sheet:e.sheet,hidden:!!s&&(0===d.columnWidth(e.col)||0===d.rowHeight(e.row))}]:[]):[{value:new kendo.spreadsheet.calc.runtime.CalcError("REF")}];if(e instanceof n){if(f=this.workbook.sheetIndex(e.sheet),p=[],m=f,e.endSheet&&(m=this.workbook.sheetIndex(e.endSheet),f>m&&(g=f,f=m,m=g)),f<0||m<0||!e.valid())return[{value:new kendo.spreadsheet.calc.runtime.CalcError("REF")}];for(;f<=m;)for(d=this.workbook.sheetByIndex(f++),v=d._grid.normalize(e.topLeft),_=d._grid.normalize(e.bottomRight),b=d._grid.cellRefIndex(v),w=d._grid.cellRefIndex(_),y=d._properties.iterator("value",b,w),k=v.col;k<=_.col;++k)for(x=v.row;x<=_.row;++x)C=d._grid.index(x,k),u=d._properties.get("formula",C),h=y.at(C),null==u&&null==h||p.push({formula:u,value:h,row:x,col:k,sheet:d.name(),hidden:!!s&&(0===d.columnWidth(k)||0===d.rowHeight(x))});return p}if(e instanceof i){for(S=[],f=0;f<e.refs.length;++f)S=S.concat(this.getRefCells(e.refs[f],s,a,l,c));return S}return e instanceof o?(T=this.nameValue(e,a,l,c),T instanceof r?this.getRefCells(T,s,a,l,c):[{value:null==T?new kendo.spreadsheet.calc.runtime.CalcError("NAME"):T}]):[]},nameValue:function(e,t,n,i){var o;return e.hasSheet()?o=this.workbook.nameValue(e.print()):(e=e.clone().setSheet(t,!0),o=this.workbook.nameValue(e.print()),null==o&&(o=this.workbook.nameValue(e.name))),o instanceof r&&(o=o.absolute(n,i)),o},getData:function(e,n,i,r){var s,a=e instanceof t;return e instanceof o&&(a=this.workbook.nameValue(e.name)instanceof t),s=this.getRefCells(e,!1,n,i,r).map(function(e){var t=e.value;return t instanceof kendo.spreadsheet.calc.runtime.Formula&&(t=t.value),t}),a?s[0]:s},onFormula:function(e){var t,n,i,o,s,a=this.workbook.sheetByName(e.sheet),l=e.row,c=e.col,d=e.value,u=a.formula({row:l,col:c});return u===e&&(t=e.arrayFormulaRange,t?(o=d.width,s=d.height,a.forEach(t,function(e,t){void 0===n&&(n=e,i=t),a._value(e,t,d.get((e-n)%s,(t-i)%o))})):(d instanceof r&&(d=this.getData(d,e.sheet,l,c),Array.isArray(d)&&(d=d[0]),void 0===d&&(d=null)),d instanceof kendo.spreadsheet.calc.runtime.Matrix&&(d=d.get(0,0)),a._value(l,c,d)),clearTimeout(a._formulaContextRefresh),a._formulaContextRefresh=setTimeout(function(){a.batch(function(){},{layout:!0})},50),!0)}}),a=s.extend({onFormula:function(){return!0}}),e.FormulaContext=s,e.ValidationFormulaContext=a)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/controller.min",["kendo.core.min"],e)}(function(){!function(e){"use strict";function t(e){return e.map(function(e){return'[data-action="'+e+'"]'}).join(",")}var n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_;if(!(e.support.browser.msie&&e.support.browser.version<9)){n=e.jQuery,i=/:alphanum$/,o={up:"up",down:"down",left:"left",right:"right",home:"first-col","ctrl+left":"first-col",end:"last-col","ctrl+right":"last-col","ctrl+up":"first-row","ctrl+down":"last-row","ctrl+home":"first","ctrl+end":"last",pageup:"prev-page",pagedown:"next-page"},r={tab:"next","shift+tab":"previous",enter:"lower","shift+enter":"upper","delete":"clearContents",backspace:"clearContents","shift+:alphanum":"edit",":alphanum":"edit","ctrl+:alphanum":"ctrl","alt+ctrl+:alphanum":"edit",":edit":"edit"},s={wheel:"onWheel","*+mousedown":"onMouseDown",contextmenu:"onContextMenu","*+mousedrag":"onMouseDrag","*+mouseup":"onMouseUp","*+dblclick":"onDblClick",mousemove:"onMouseMove"},a={pageup:"onPageUp",pagedown:"onPageDown",mouseup:"onMouseUp","*+cut":"onCut","*+paste":"onPaste","*+copy":"onCopy"},l={esc:"onEditorEsc",enter:"onEditorBlur","alt+enter":"insertNewline","shift+enter":"onEditorBlur",tab:"onEditorBlur","shift+tab":"onEditorBlur","shift+ctrl+enter":"onEditorArrayFormula"},c=n.extend({focus:"onEditorBarFocus"},l),d=n.extend({focus:"onEditorCellFocus"},l),u={cell:"range",rowheader:"row",columnheader:"column",topcorner:"sheet",autofill:"autofill"},h=t(["cut","copy","paste","insert-left","insert-right","insert-above","insert-below"]),f=t(["unhide-row","unhide-column"]),p=[],m=[],g=[];for(v in o)p.push(v),m.push("shift+"+v);for(v in r)g.push(v);a[p]="onAction",a[m]="onShiftAction",a[g]="onEntryAction",d[p]="onEditorAction",d[m]="onEditorShiftAction",_=e.Class.extend({init:function(t,i){this.view=t,this.workbook(i),this.container=n(t.container),this.clipboardElement=n(t.clipboard),this.cellContextMenu=t.cellContextMenu,this.rowHeaderContextMenu=t.rowHeaderContextMenu,this.colHeaderContextMenu=t.colHeaderContextMenu,this.scroller=t.scroller,this.tabstrip=t.tabstrip,this.sheetsbar=t.sheetsbar,t.nameEditor.bind("enter",this.onNameEditorEnter.bind(this)),t.nameEditor.bind("cancel",this.onNameEditorCancel.bind(this)),t.nameEditor.bind("select",this.onNameEditorSelect.bind(this)),t.nameEditor.bind("delete",this.onNameEditorDelete.bind(this)),this.editor=t.editor,this.editor.bind("change",this.onEditorChange.bind(this)),this.editor.bind("activate",this.onEditorActivate.bind(this)),this.editor.bind("deactivate",this.onEditorDeactivate.bind(this)),this.editor.bind("update",this.onEditorUpdate.bind(this)),n(t.scroller).on("scroll",this.onScroll.bind(this)),this.listener=new e.spreadsheet.EventListener(this.container,this,s),this._enableEditorEvents(),this.sheetsbar&&(this.sheetsbar.bind("select",this.onSheetBarSelect.bind(this)),this.sheetsbar.bind("reorder",this.onSheetBarReorder.bind(this)),this.sheetsbar.bind("rename",this.onSheetBarRename.bind(this)),this.sheetsbar.bind("remove",this.onSheetBarRemove.bind(this))),this.cellContextMenu.bind("select",this.onContextMenuSelect.bind(this)),this.rowHeaderContextMenu.bind("select",this.onContextMenuSelect.bind(this)),this.colHeaderContextMenu.bind("select",this.onContextMenuSelect.bind(this)),this.cellContextMenu.element.add(this.rowHeaderContextMenu.element).add(this.colHeaderContextMenu.element).on("contextmenu",!1),this.tabstrip&&(this.tabstrip.bind("action",this.onCommandRequest.bind(this)),this.tabstrip.bind("dialog",this.onDialogRequest.bind(this)))},_enableEditorEvents:function(t){void 0===t||t?(this.keyListener=new e.spreadsheet.EventListener(this.clipboardElement,this,a),this.barKeyListener=new e.spreadsheet.EventListener(this.editor.barElement(),this,c),this.inputKeyListener=new e.spreadsheet.EventListener(this.editor.cellElement(),this,d)):(this.keyListener.destroy(),this.barKeyListener.destroy(),this.inputKeyListener.destroy())},_execute:function(e){var t=this._workbook.execute(e);return"EditCommand"!==e.command||t||this._workbook.trigger("change",{editorClose:!0}),t&&(this._preventNavigation=!0,"error"===t.reason?this.view.showError(t,function(){this.activateEditor(!1),this.editor.value(this._lastEditorValue),this.editor._value=this._workbook._inputForRef(this._workbook.activeSheet()._viewActiveCell()),this.editor.select()}.bind(this)):this.view.openDialog(t.reason)),t},_activeTooltip:function(){return""+this._workbook.activeSheet().activeCell().simplify()},onContextMenuSelect:function(e){var t,i=n(e.item).data("action");switch(i){case"cut":t={command:"ToolbarCutCommand",options:{workbook:this._workbook}};break;case"copy":t={command:"ToolbarCopyCommand",options:{workbook:this._workbook}};break;case"paste":t={command:"ToolbarPasteCommand",options:{workbook:this._workbook}};break;case"unmerge":t={command:"MergeCellCommand",options:{value:"unmerge"}};break;case"merge":this.view.openDialog("merge");break;case"hide-row":t={command:"HideLineCommand",options:{axis:"row"}};break;case"hide-column":t={command:"HideLineCommand",options:{axis:"column"}};break;case"unhide-row":t={command:"UnHideLineCommand",options:{axis:"row"}};break;case"unhide-column":t={command:"UnHideLineCommand",options:{axis:"column"}};break;case"delete-row":t={command:"DeleteRowCommand"};break;case"delete-column":t={command:"DeleteColumnCommand"}}t&&this._execute(t)},onSheetBarRemove:function(e){var t=this._workbook.sheetByName(e.name);t&&this._workbook.removeSheet(t)},destroy:function(){this.listener.destroy(),this._enableEditorEvents(!1),this.keyListener.destroy(),this.inputKeyListener.destroy()},onSheetBarSelect:function(e){var t,n=this._workbook;if(e.isAddButton){if(this._workbook.trigger("insertSheet"))return;t=n.insertSheet()}else t=n.sheetByName(e.name);if(n.activeSheet().name()!==t.name()){if(this._workbook.trigger("selectSheet",{sheet:t}))return;n.activeSheet(t)}},onSheetBarReorder:function(e){var t=this._workbook.sheetByIndex(e.oldIndex);this._workbook.moveSheetToIndex(t,e.newIndex),this._workbook.activeSheet(t)},onSheetBarRename:function(e){var t=this._workbook.sheetByIndex(e.sheetIndex);return this._workbook.sheetByName(e.name)?void this.view.showError({reason:"error",type:"duplicateSheetName"}):(this._workbook.renameSheet(t,e.name),void this.clipboardElement.focus())},sheet:function(e){this.navigator=e.navigator(),this.axisManager=e.axisManager()},workbook:function(e){this._workbook=e,this.clipboard=e.clipboard(),e.bind("commandRequest",this.onCommandRequest.bind(this))},refresh:function(){var e,t,n=this.editor,i=this._workbook,o=i.activeSheet();this._viewPortHeight=this.view.scroller.clientHeight,this.navigator.height(this._viewPortHeight),n.isActive()||this.isEditorDisabled||(n.enable(o.selection().enable()!==!1),this.resetEditorValue()),e=o.selection()._ref.simplify(),t=this._workbook.nameForRef(e,o.name()),this.view.nameEditor.value(t.name)},onScroll:function(){this.view.render()},onWheel:function(e){var t=e.originalEvent.deltaX,n=e.originalEvent.deltaY;1===e.originalEvent.deltaMode&&(t*=10,n*=10),this.scrollWith(t,n),e.preventDefault()},onAction:function(e,t){this.navigator.moveActiveCell(o[t]),e.preventDefault()},onPageUp:function(){this.scrollDown(-this._viewPortHeight)},onPageDown:function(){this.scrollDown(this._viewPortHeight)},onEntryAction:function(e,t){var n,o,s,a;if(e.mod){switch(n=!0,o=String.fromCharCode(e.keyCode)){case"A":this.navigator.selectAll();break;case"Y":this._workbook.undoRedoStack.redo();break;case"Z":this._workbook.undoRedoStack.undo();break;default:n=!1}n&&e.preventDefault()}else if(s=this._workbook.activeSheet().selection().enable()===!1,a=":edit"!==t,"delete"==t||"backspace"==t)s||this._execute({command:"ClearContentCommand"}),e.preventDefault();else if(i.test(t)||!a){if(s)return void e.preventDefault();a&&this.editor.value(""),this.activateEditor(a)}else this.navigator.navigateInSelection(r[t]),e.preventDefault()},onShiftAction:function(e,t){this.navigator.modifySelection(o[t.replace("shift+","")],this.appendSelection),e.preventDefault()},onMouseMove:function(e){var t,n=this._workbook.activeSheet();n.resizingInProgress()||n.selectionInProgress()||(t=this.objectAt(e),"columnresizehandle"===t.type||"rowresizehandle"===t.type?n.positionResizeHandle(t.ref):n.removeResizeHandle())},onMouseDown:function(e){var t,n=this.objectAt(e);if(n.pane&&(this.originFrame=n.pane),"editor"===n.type)return this.onEditorEsc(),this.openCustomEditor(),void e.preventDefault();if(this.editor.canInsertRef(!1)&&n.ref)return this._workbook.activeSheet()._setFormulaSelections(this.editor.highlightedRefs()),this.navigator.startSelection(n.ref,this._selectionMode,this.appendSelection,e.shiftKey),void e.preventDefault();if(this._preventNavigation=!1,this.editor.deactivate(),!this._preventNavigation){if(t=this._workbook.activeSheet(),"columnresizehandle"===n.type||"rowresizehandle"===n.type)return t.startResizing({x:n.x,y:n.y}),void e.preventDefault();if("filtericon"===n.type)return this.openFilterMenu(e),void e.preventDefault();this._selectionMode=u[n.type],this.appendSelection=e.mod,this.navigator.startSelection(n.ref,this._selectionMode,this.appendSelection,e.shiftKey)}},onContextMenu:function(t){var n,i,o,r,s,a=this._workbook.activeSheet();a.resizingInProgress()||(t.preventDefault(),this.cellContextMenu.close(),this.colHeaderContextMenu.close(),this.rowHeaderContextMenu.close(),i=this.objectAt(t),"columnresizehandle"!==i.type&&"rowresizehandle"!==i.type&&(this.navigator.selectForContextMenu(i.ref,u[i.type]),o=this.navigator._sheet.select()instanceof e.spreadsheet.UnionRef,r=!1,s=!1,"columnheader"==i.type?(n=this.colHeaderContextMenu,r=!o&&this.axisManager.selectionIncludesHiddenColumns()):"rowheader"==i.type?(n=this.rowHeaderContextMenu,r=!o&&this.axisManager.selectionIncludesHiddenRows()):(n=this.cellContextMenu,s=this.navigator.selectionIncludesMergedCells()),n.element.find(h).toggle(!o),
n.element.find(f).toggle(r),n.element.find("[data-action=unmerge]").toggle(s),setTimeout(function(){n.open(t.pageX,t.pageY)})))},prevent:function(e){e.preventDefault()},constrainResize:function(e,t){var n=this._workbook.activeSheet(),i=n.resizeHandlePosition();return!i||"outside"===e||"topcorner"===e||t.col<i.col||t.row<i.row},onMouseDrag:function(e){var t,n,i,o;if("sheet"!==this._selectionMode){if(t={clientX:e.clientX,clientY:e.clientY},n=this.objectAt(t),i=this._workbook.activeSheet(),i.resizingInProgress())return void(this.constrainResize(n.type,n.ref)||i.resizeHintPosition({x:n.x,y:n.y}));if("outside"===n.type)return void this.startAutoScroll(n);this.originFrame===n.pane?this.selectToLocation(t):(o=this.originFrame._grid,n.x>o.right&&this.scrollLeft(),n.y>o.bottom&&this.scrollTop(),n.y<o.top||n.x<o.left?this.startAutoScroll(n,t):this.selectToLocation(t)),e.preventDefault()}},onMouseUp:function(e){var t,n,i,o=this._workbook.activeSheet();if(o.completeResizing(),this.navigator.completeSelection(),this.stopAutoScroll(),t=this.editor.activeEditor()){for(n=e.target;n;){if(n===t.element[0])return;n=n.parentNode}i=this.objectAt(e),i&&i.ref&&t.canInsertRef(!1)&&(t.refAtPoint(o),o._setFormulaSelections(t.highlightedRefs()))}},onDblClick:function(e){var t,n=this.objectAt(e),i=this._workbook.activeSheet().selection().enable()===!1;"cell"!==n.type||i||(t=this._workbook.activeSheet().selection(),this.activateEditor(!t.value()&&!t.formula()),this.onEditorUpdate())},onCut:function(e){if(e){var t=this.clipboardElement.find("table.kendo-clipboard-"+this.clipboard._uid).detach();this.clipboardElement.append(t.clone(!1)),setTimeout(function(){this.clipboardElement.empty().append(t)}.bind(this))}this._execute({command:"CutCommand",options:{workbook:this.view._workbook,event:e.originalEvent||e}})},clipBoardValue:function(){return this.clipboardElement.html()},onPaste:function(t){var n,i,o,r="",s="";if(this.clipboard.menuInvoked=void 0===t,t){if(!t.originalEvent.clipboardData||!t.originalEvent.clipboardData.getData)return o=this.clipboardElement.find("table.kendo-clipboard-"+this.clipboard._uid).detach(),this.clipboardElement.empty(),void setTimeout(function(){var e=this.clipboardElement.html(),n=window.clipboardData.getData("Text").trim();(e||n)&&(this.clipboard.external({html:e,plain:n}),this.clipboardElement.empty().append(o),this._execute({command:"PasteCommand",options:{workbook:this.view._workbook,event:t.originalEvent||t}}),this.clipboard.menuInvoked=!0)}.bind(this));t.preventDefault(),n=!1,i=!1,window.DOMStringList&&t.originalEvent.clipboardData.types instanceof window.DOMStringList?(n=t.originalEvent.clipboardData.types.contains("text/html"),i=t.originalEvent.clipboardData.types.contains("text/plain")):(n=/text\/html/.test(t.originalEvent.clipboardData.types),i=/text\/plain/.test(t.originalEvent.clipboardData.types)),n&&(r=t.originalEvent.clipboardData.getData("text/html")),i&&(s=t.originalEvent.clipboardData.getData("text/plain").trim())}else{if(e.support.browser.msie)return this.clipboardElement.focus().select(),void document.execCommand("paste");this.clipboard.menuInvoked=!0}(r||s)&&(this.clipboard.external({html:r,plain:s}),this._execute({command:"PasteCommand",options:{workbook:this.view._workbook,event:t.originalEvent||t}}))},onCopy:function(e){this.clipboard.menuInvoked=void 0===e,this._execute({command:"CopyCommand",options:{workbook:this.view._workbook,event:e.originalEvent||e}})},scrollTop:function(){this.scroller.scrollTop=0},scrollLeft:function(){this.scroller.scrollLeft=0},scrollDown:function(e){this.scroller.scrollTop+=e},scrollRight:function(e){this.scroller.scrollLeft+=e},scrollWith:function(e,t){this.scroller.scrollTop+=t,this.scroller.scrollLeft+=e},objectAt:function(e){if(e){var t=this.container[0].getBoundingClientRect();return this.view.objectAt(e.clientX-t.left,e.clientY-t.top)}},selectToLocation:function(e){var t=this.objectAt(e);t.pane&&(this.extendSelection(t),this.lastKnownCellLocation=e,this.originFrame=t.pane),this.stopAutoScroll()},extendSelection:function(e){this.navigator.extendSelection(e.ref,this._selectionMode,this.appendSelection)},autoScroll:function(){var e=this._autoScrollTarget.x,t=this._autoScrollTarget.y,n=this.originFrame._grid,i=this.view.scroller,o=8,r=i.scrollLeft,s=i.scrollTop;e<n.left&&this.scrollRight(-o),e>n.right&&this.scrollRight(o),t<n.top&&this.scrollDown(-o),t>n.bottom&&this.scrollDown(o),s===i.scrollTop&&r===i.scrollLeft?this.selectToLocation(this.finalLocation):this.extendSelection(this.objectAt(this.lastKnownCellLocation))},startAutoScroll:function(e,t){this._scrollInterval||(this._scrollInterval=setInterval(this.autoScroll.bind(this),50)),this.finalLocation=t||this.lastKnownCellLocation,this._autoScrollTarget=e},stopAutoScroll:function(){clearInterval(this._scrollInterval),this._scrollInterval=null},openCustomEditor:function(){this.view.openCustomEditor()},openFilterMenu:function(e){var t=this.objectAt(e),n=this._workbook.activeSheet(),i=n.filterColumn(t.ref),o=this.view.createFilterMenu(i);o.bind("action",this.onCommandRequest.bind(this)),o.bind("action",o.close.bind(o)),o.openFor(e.target)},_saveEditorValue:function(e){var t=this.editor._range.sheet(),n=this.editor.value();this._workbook.activeSheet()!==t&&(this._workbook.activeSheet()._setFormulaSelections(),this._workbook.activeSheet(t)),t.isInEditMode(!1),this._lastEditorValue=n,this._execute({command:"EditCommand",options:{value:n,arrayFormula:e}})},onEditorChange:function(){this._saveEditorValue(!1)},onEditorArrayFormula:function(){this._saveEditorValue(!0),this.editor.deactivate(!0)},onEditorActivate:function(){var e=this._workbook,t=e.activeSheet();t._setFormulaSelections(this.editor.highlightedRefs()),t.isInEditMode(!0)},onEditorDeactivate:function(){var e=this._workbook.activeSheet();e.isInEditMode(!1),e._setFormulaSelections([])},onEditorUpdate:function(){this._workbook.activeSheet()._setFormulaSelections(this.editor.highlightedRefs())},onEditorBarFocus:function(){var e=this._workbook.activeSheet().selection().enable()===!1;e||this.editor.activate({range:this._workbook.activeSheet().selection(),rect:this.view.activeCellRectangle(),tooltip:this._activeTooltip()})},onEditorCellFocus:function(){this.editor.scale()},onEditorEsc:function(){this.resetEditorValue(),this.editor.deactivate(),this.clipboardElement.focus()},insertNewline:function(e){e.preventDefault(),this.editor.insertNewline()},onEditorBlur:function(e,t){this.editor.isFiltered()||(this._preventNavigation=!1,this.editor.deactivate(),this._preventNavigation||(this.clipboardElement.focus(),this.navigator.navigateInSelection(r[t])))},onEditorAction:function(e,t){var n=this.editor,i=this._workbook.activeSheet();this._casualEditing&&/^(?:up|right|down|left)$/.test(t)?(this.deactivateEditor(),this.navigator.moveActiveCell(o[t]),e.preventDefault()):n.canInsertRef(!0)&&(this.navigator.moveActiveCell(o[t]),n.activeEditor().refAtPoint(i),i._setFormulaSelections(n.highlightedRefs()),e.preventDefault())},onEditorShiftAction:function(e,t){var n=this.editor,i=this._workbook.activeSheet();n.canInsertRef(!0)&&(this.navigator.modifySelection(o[t.replace("shift+","")],this.appendSelection),n.activeEditor().refAtPoint(i),i._setFormulaSelections(n.highlightedRefs()),e.preventDefault())},resetEditorValue:function(){var e=this._workbook.activeSheet(),t=e.activeCell(),n=this._workbook._inputForRef(t),i=e.range(t).intersectingArrayFormula();i&&(n="="+i.formula),this.editor.value(n,!!i)},activateEditor:function(e){this._casualEditing=e,this.editor.activate({range:this._workbook.activeSheet().selection(),rect:this.view.activeCellRectangle(),tooltip:this._activeTooltip()}).focus()},deactivateEditor:function(){this.view.editor.deactivate()},onCommandRequest:function(e){e.command?this._execute(e):this._workbook.undoRedoStack[e.action]()},onDialogRequest:function(e){var t={pdfExport:this._workbook.options.pdf,excelExport:this._workbook.options.excel};e.options?n.extend(!0,e.options,t):e.options=t,this.view.openDialog(e.name,e.options)},onNameEditorEnter:function(){var t,n=this._workbook,i=n.activeSheet(),o=this.view.nameEditor.value(),r=e.spreadsheet.calc.parseReference(o,!0)||n.nameValue(o);return r instanceof e.spreadsheet.Ref?(r.sheet&&r.sheet.toLowerCase()!=i.name().toLowerCase()&&(t=n.sheetByName(r.sheet),t&&(n.activeSheet(t),i=t)),void i.range(r).select()):(r=i.selection()._ref.clone().simplify().setSheet(i.name(),!0),this._execute({command:"DefineNameCommand",options:{name:o,value:r}}),void this.clipboardElement.focus())},onNameEditorCancel:function(){this.clipboardElement.focus()},onNameEditorSelect:function(t){var n,i=t.name,o=this._workbook,r=o.activeSheet(),s=o.nameValue(i);return s instanceof e.spreadsheet.Ref?(s.sheet&&s.sheet.toLowerCase()!=r.name().toLowerCase()&&(n=o.sheetByName(s.sheet),n&&(o.activeSheet(n),r=n)),void r.range(s).select()):void this.clipboardElement.focus()},onNameEditorDelete:function(e){this._execute({command:"DeleteNameCommand",options:{name:e.name}}),this.clipboardElement.focus()}}),e.spreadsheet.Controller=_}}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/view.min",["kendo.core.min","kendo.menu.min","spreadsheet/sheetsbar.min","util/main.min"],e)}(function(){!function(e){function t(e){var t,n=window.getSelection();n.removeAllRanges(),t=document.createRange(),t.selectNodeContents(e),n.addRange(t)}function n(e,t){var n=e.trs[t].children;return n[n.length-2]}function i(e,t){var n=e.trs[t-1],i=e.trs[t].children.length-1;if(n&&i>=0)return n.children[i]}function o(e){return(e.size||1)+"px solid "+(e.color||"#000")}function r(e){return/:\/\//.test(e)||(e="http://"+e),e}function s(t,n,i,s){function a(t){var i,o=n.link;return o||"object"==typeof n.value&&(o=n.value.link),o?(i={textDecoration:"none"},n.color&&(i.color=n.color),n.underline&&(i.textDecoration="underline"),e.dom.element("a",{href:r(o),style:i,target:"_blank"},t?[t]:[])):t}var l,c,d,u,h,f,p,m,g,v,_,b=null!=n.value||null!=n.validation&&!n.validation.value||n.background||n.merged;if(i||b){if(l={},c=n.background,c&&(d=c,s&&(d=e.parseColor(d).toHSV(),d.v*=.9,d=d.toCssRgba()),d=o({color:d}),l.outline=d),c&&(l.backgroundColor=c),n.color&&(l.color=n.color),n.fontFamily&&(l.fontFamily=n.fontFamily),n.underline&&(l.textDecoration="underline"),n.italic&&(l.fontStyle="italic"),n.textAlign&&(l.textAlign=n.textAlign),n.bold&&(l.fontWeight="bold"),n.fontSize&&(l.fontSize=n.fontSize+"px"),n.wrap===!0&&(l.whiteSpace="pre-wrap",l.overflowWrap="break-word",l.wordWrap="break-word"),l.left=n.left+1+"px",l.top=n.top+1+"px",l.width=n.width-1+"px",l.height=n.height-1+"px",u=n.value,h=typeof u,n.format&&null!=u?(u=e.spreadsheet.formatting.format(u,n.format),u.__dataType&&(h=u.__dataType)):null!==u&&void 0!==u&&(u=e.dom.text(u)),!l.textAlign)switch(h){case"number":case"date":case"percent":case"currency":l.textAlign="right";break;case"boolean":l.textAlign="center"}return f=[w.cell],i&&f.push(i),n.enable===!1&&f.push("k-state-disabled"),n.merged&&f.push("k-spreadsheet-merged-cell"),p=n.verticalAlign||"bottom",u=p&&u?e.dom.element("div",{className:"k-vertical-align-"+p},[a(u)]):a(u),m=u?[u]:[],g={style:l},v=n.validation,v&&!v.value&&(m.push(e.dom.element("span",{className:"k-dirty"})),f.push("k-dirty-cell"),g.title=v.message),g.className=f.join(" "),_=e.dom.element("div",g,m),t.push(_),_}}function a(t,r,s){var a,l,c,d,u,h,f={};if(s.background&&(f.backgroundColor=s.background),s.color&&(f.color=s.color),s.fontFamily&&(f.fontFamily=s.fontFamily),s.underline&&(f.textDecoration="underline"),s.italic&&(f.fontStyle="italic"),s.textAlign&&(f.textAlign=s.textAlign),s.verticalAlign&&(f.verticalAlign="center"===s.verticalAlign?"middle":s.verticalAlign),s.bold&&(f.fontWeight="bold"),s.fontSize&&(f.fontSize=s.fontSize+"px"),s.wrap===!0&&(f.whiteSpace="pre-wrap",f.wordBreak="break-all"),s.borderRight?f.borderRight=o(s.borderRight):s.background&&(f.borderRightColor=s.background),s.borderBottom?f.borderBottom=o(s.borderBottom):s.background&&(f.borderBottomColor=s.background),a=s.value,l=typeof a,s.format&&null!=a&&(a=e.spreadsheet.formatting.format(a,s.format),a.__dataType&&(l=a.__dataType)),!f.textAlign)switch(l){case"number":case"date":case"percent":case"currency":f.textAlign="right";break;case"boolean":f.textAlign="center"}return c=null,s.enable===!1&&(c="k-state-disabled"),d=t.addCell(r,a,f,c,s.validation),s.borderLeft?(h=n(t,r),u=o(s.borderLeft),h&&u&&(h.attr.style.borderRight=u)):s.background&&(f.borderLeftColor=s.background),s.borderTop?(h=i(t,r),u=o(s.borderTop),h&&u&&(h.attr.style.borderBottom=u)):s.background&&(f.borderTopColor=s.background),d}function l(e,t,n){return e>=t&&e<=n}var c,d,u,h,f,p,m,g,v,_,b,w,y;e.support.browser.msie&&e.support.browser.version<9||(c=e.jQuery,d=e.spreadsheet.CellRef,u=".",h=7,f={view:"k-spreadsheet-view",fixedContainer:"k-spreadsheet-fixed-container",editContainer:"k-spreadsheet-edit-container",scroller:"k-spreadsheet-scroller",viewSize:"k-spreadsheet-view-size",clipboard:"k-spreadsheet-clipboard",cellEditor:"k-spreadsheet-cell-editor",barEditor:"k-spreadsheet-editor",topCorner:"k-spreadsheet-top-corner",filterHeadersWrapper:"k-filter-wrapper",filterRange:"k-filter-range",filterButton:"k-spreadsheet-filter",filterButtonActive:"k-state-active",horizontalResize:"k-horizontal-resize",verticalResize:"k-vertical-resize",icon:"k-icon",iconFilterDefault:"k-i-arrow-60-down",sheetsBar:"k-spreadsheet-sheets-bar",sheetsBarActive:"k-spreadsheet-sheets-bar-active",sheetsBarInactive:"k-spreadsheet-sheets-bar-inactive",cellContextMenu:"k-spreadsheet-cell-context-menu",rowHeaderContextMenu:"k-spreadsheet-row-header-context-menu",colHeaderContextMenu:"k-spreadsheet-col-header-context-menu"},e.spreadsheet.messages.view={nameBox:"Name Box",errors:{openUnsupported:"Unsupported format. Please select an .xlsx file.",shiftingNonblankCells:"Cannot insert cells due to data loss possibility. Select another insert location or delete the data from the end of your worksheet.",insertColumnWhenRowIsSelected:"Cannot insert column when all columns are selected.",insertRowWhenColumnIsSelected:"Cannot insert row when all rows are selected.",filterRangeContainingMerges:"Cannot create a filter within a range containing merges",sortRangeContainingMerges:"Cannot sort a range containing merges",cantSortMultipleSelection:"Cannot sort multiple selection",cantSortNullRef:"Cannot sort empty selection",cantSortMixedCells:"Cannot sort range containing cells of mixed shapes",validationError:"The value that you entered violates the validation rules set on the cell.",cannotModifyDisabled:"Cannot modify disabled cells."},tabs:{home:"Home",insert:"Insert",data:"Data"}},p=e.Class.extend({init:function(){this.cols=[],this.trs=[],this._height=0,this._width=0},addColumn:function(t){this._width+=t;var n=e.dom.element("col",{style:{width:t+"px"}});n.visible=t>0,this.cols.push(n)},addRow:function(t){var n,i=null;i={style:{height:t+"px"}},this._height+=t,n=e.dom.element("tr",i),n.visible=t>0,this.trs.push(n)},addCell:function(t,n,i,o,r){var s,a,l;return null!==n&&void 0!==n||(n=""),n instanceof e.dom.Node||(n=e.dom.text(n)),s=[n],a={style:i},r&&!r.value&&(s.push(e.dom.element("span",{className:"k-dirty"})),o=(o||"")+(o?" ":"")+"k-dirty-cell",a.title=r.message),o&&(a.className=o),l=e.dom.element("td",a,s),this.trs[t].children.push(l),l},toDomTree:function(t,n,i){this.trs=this.trs.filter(function(e){return e.visible});var o=0;return this.cols=this.cols.filter(function(e,t){return e.visible||(this.trs.forEach(function(e){e.children.splice(t-o,1)}),o++),e.visible},this),e.dom.element("table",{style:{left:t+"px",top:n+"px",height:this._height+"px",width:this._width+"px"},className:i},[e.dom.element("colgroup",null,this.cols),e.dom.element("tbody",null,this.trs)])}}),m='<ul class="#=classNames.cellContextMenu#"><li data-action=cut>Cut</li><li data-action=copy>Copy</li><li data-action=paste>Paste</li><li class="k-separator"></li><li data-action=merge>Merge</li><li data-action=unmerge>Unmerge</li></ul>',g='<ul class="#=classNames.rowHeaderContextMenu#"><li data-action=cut>Cut</li><li data-action=copy>Copy</li><li data-action=paste>Paste</li><li class="k-separator"></li><li data-action="delete-row">Delete</li><li data-action="hide-row">Hide</li><li data-action="unhide-row">Unhide</li></ul>',v='<ul class="#=classNames.colHeaderContextMenu#"><li data-action=cut>Cut</li><li data-action=copy>Copy</li><li data-action=paste>Paste</li><li class="k-separator"></li><li data-action="delete-column">Delete</li><li data-action="hide-column">Hide</li><li data-action="unhide-column">Unhide</li></ul>',e.spreadsheet.ContextMenu=e.ui.ContextMenu,_=e.template('<div class="#=classNames.view#"><div class="#=classNames.fixedContainer#"></div><div class="#=classNames.scroller#"><div class="#=classNames.viewSize#"></div></div><div tabindex="0" class="#=classNames.clipboard#" contenteditable=true></div><div class="#=classNames.cellEditor#"></div></div><div class="#=classNames.sheetsBar#"></div>'+m+g+v),b=e.Class.extend({init:function(t,n){var i,o=b.classNames;this.element=t,this.options=c.extend(!0,{messages:e.spreadsheet.messages.view},this.options,n),this._chrome(),this._dialogs=[],t.append(_({classNames:o})),this._formulaInput(),this.wrapper=t.find(u+o.view),this.container=t.find(u+o.fixedContainer)[0],this.scroller=t.find(u+o.scroller)[0],this.clipboard=t.find(u+o.clipboard),this.viewSize=c(this.scroller.firstChild),this.tree=new e.dom.Tree(this.container),this.clipboardContents=new e.dom.Tree(this.clipboard[0]),this.editor=new e.spreadsheet.SheetEditor(this),this._sheetsbar(),i={target:t,animation:!1,showOn:"never"},this.cellContextMenu=new e.spreadsheet.ContextMenu(t.find(u+o.cellContextMenu),i),this.colHeaderContextMenu=new e.spreadsheet.ContextMenu(t.find(u+o.colHeaderContextMenu),i),this.rowHeaderContextMenu=new e.spreadsheet.ContextMenu(t.find(u+o.rowHeaderContextMenu),i)},enableClipboard:function(e){this.isClipboardDeactivated=!e,e?this.clipboard.attr("contenteditable",e):this.clipboard.removeAttr("contenteditable")},_resize:function(){var t=c(this.formulaBar.element).parents(".k-spreadsheet-action-bar"),n=e._outerHeight,i=this.tabstrip?n(this.tabstrip.element):0,o=t?n(t):0,r=this.sheetsbar?n(this.sheetsbar.element):0;this.wrapper.height(this.element.height()-(i+o+r)),this.tabstrip&&this.tabstrip.quickAccessAdjust()},_chrome:function(){var t,n=c("<div class='k-spreadsheet-action-bar' />").prependTo(this.element),i=c("<div class='k-spreadsheet-name-editor' />").appendTo(n);this.nameEditor=new e.spreadsheet.NameEditor(i,this.options),t=c("<div />").appendTo(n),this.formulaBar=new e.spreadsheet.FormulaBar(t),this.options.toolbar&&this._tabstrip()},_formulaInput:function(){var t=this.element.find(u+b.classNames.cellEditor);this.formulaInput=new e.spreadsheet.FormulaInput(t,{autoScale:!0})},_sheetsbar:function(){if(this.options.sheetsbar){var t=c.extend(!0,{openDialog:this.openDialog.bind(this)},this.options.sheetsbar);this.sheetsbar=new e.spreadsheet.SheetsBar(this.element.find(u+b.classNames.sheetsBar),t)}},_tabstrip:function(){var t,n=this.options.messages.tabs,i=c.extend(!0,{home:!0,insert:!0,data:!0},this.options.toolbar),o=[];this.tabstrip&&(this.tabstrip.destroy(),this.element.children(".k-tabstrip").remove());for(t in i)(i[t]===!0||i[t]instanceof Array)&&o.push({id:t,text:n[t],content:""});this.tabstrip=new e.spreadsheet.TabStrip(c("<div />").prependTo(this.element),{animation:!1,dataTextField:"text",dataContentField:"content",dataSource:o,toolbarOptions:i,view:this}),this.tabstrip.select(0)},_executeCommand:function(e){this._sheet.trigger("commandRequest",e)},workbook:function(e){this._workbook=e,this.nameEditor._workbook=e},sheet:function(e){this._sheet=e},activeCellRectangle:function(){return this.cellRectangle(this._sheet._viewActiveCell())},_rectangle:function(e,t){return e._grid.boundingRectangle(t.toRangeRef())},isColumnResizer:function(e,t,n){var i,o,r=this._rectangle(t,n);return e-=this._sheet._grid._headerWidth,i=h/2,o=r.right-this.scroller.scrollLeft,o-i<=e&&e<=o+i},isRowResizer:function(e,t,n){var i,o,r=this._rectangle(t,n);return e-=this._sheet._grid._headerHeight,i=h/2,o=r.bottom-this.scroller.scrollTop,o-i<=e&&e<=o+i},isFilterIcon:function(t,n,i,o){var r=this,s=i._grid,a=s.rows.frozen?0:r.scroller.scrollTop,l=s.columns.frozen?0:r.scroller.scrollLeft;return t-=r._sheet._grid._headerWidth-l,n-=r._sheet._grid._headerHeight-a,e.util.withExit(function(e){r._sheet.forEachFilterHeader(o,function(o){var s=r._rectangle(i,o);i.filterIconRect(s).intersects(t,n)&&e(!0)})})},isAutoFill:function(e,t,n){var i,o=this._sheet.select();return!(o.size>1)&&(e-=this._sheet._grid._headerWidth,t-=this._sheet._grid._headerHeight,n._grid.columns.frozen||(e+=this.scroller.scrollLeft),n._grid.rows.frozen||(t+=this.scroller.scrollTop),i=this._rectangle(n,o),Math.abs(i.right-e)<8&&Math.abs(i.bottom-t)<8)},isEditButton:function(e,t,n){var i,o=this._sheet.activeCellCustomEditor();if(o&&(i=this.activeCellRectangle(),t>=i.top&&t<=i.bottom))return n._editorInLastColumn?e<i.left&&e>=i.left-20:e>i.right&&e<=i.right+20},objectAt:function(e,t){var n,i,o,r,s,a,l,c=this._sheet._grid;return e<0||t<0||e>this.scroller.clientWidth||t>this.scroller.clientHeight?n={type:"outside"}:e<c._headerWidth&&t<c._headerHeight?n={type:"topcorner"}:(i=this.paneAt(e,t),i?(o=i._grid.rows.indexVisible(t,this.scroller.scrollTop),r=i._grid.columns.indexVisible(e,this.scroller.scrollLeft),s="cell",a=new d(o,r),l=this._sheet.selectionInProgress(),this.isAutoFill(e,t,i)?s="autofill":this.isFilterIcon(e,t,i,a)?s="filtericon":!l&&e<c._headerWidth?(a=new d(o,(-(1/0))),s=this.isRowResizer(t,i,a)?"rowresizehandle":"rowheader"):!l&&t<c._headerHeight?(a=new d((-(1/0)),r),s=this.isColumnResizer(e,i,a)?"columnresizehandle":"columnheader"):this.isEditButton(e,t,i)&&(s="editor"),"cell"==s&&this._sheet.forEachMergedCell(a,function(e){a=e.topLeft}),n={type:s,ref:a}):n={type:"outside"}),n.pane=i,n.x=e,n.y=t,n},paneAt:function(e,t){return this.panes.filter(function(n){var i=n._grid;return l(t,i.top,i.bottom)&&l(e,i.left,i.right)})[0]},containingPane:function(e){return this.panes.filter(function(t){return!!t._grid.contains(e)})[0]},cellRectangle:function(e){var t=this.containingPane(e)._grid,n=this._sheet._grid.rectangle(e);return n.offset(t.headerWidth-(t.columns.frozen?0:this.scroller.scrollLeft),t.headerHeight-(t.rows.frozen?0:this.scroller.scrollTop))},refresh:function(e){var t,n,i=this._sheet;this.tabstrip&&this.tabstrip.refreshTools(i.range(i.activeCell())),e.sheetSelection&&this.sheetsbar&&this.sheetsbar.renderSheets(this._workbook.sheets(),this._workbook.sheetIndex(this._sheet)),this._resize(),this.viewSize[0].style.height=i._grid.totalHeight()+"px",this.viewSize[0].style.width=i._grid.totalWidth()+"px",e.layout&&(t=i.frozenColumns(),n=i.frozenRows(),this.panes=[this._pane(n,t)],t>0&&this.panes.push(this._pane(n,0,null,t)),n>0&&this.panes.push(this._pane(0,t,n,null)),n>0&&t>0&&this.panes.push(this._pane(0,0,n,t))),e.filter&&this._destroyFilterMenu(),e.activeCell&&(this._focus=i.activeCell().toRangeRef())},createFilterMenu:function(t){var n,i,o,r,s,a;return this._filterMenu&&this._filterMenu.options.column==t?this._filterMenu:(this._destroyFilterMenu(),n=this._sheet,i=n.filter().ref,o=new e.spreadsheet.Range(i,n),r=c("<div />").appendTo(this.element),s={column:t,range:o},a=new e.spreadsheet.FilterMenu(r,s),this._filterMenu=a,a)},selectClipBoardContents:function(){this.isClipboardDeactivated||(this.clipboard.focus(),t(this.clipboard[0]))},scrollIntoView:function(e){var t=!1,n=this.containingPane(e)._grid,i=n.scrollBoundaries(e),o=this.scroller,r=n.rows.frozen?0:o.scrollTop,s=n.columns.frozen?0:o.scrollLeft;return i.top<r&&(t=!0,o.scrollTop=i.scrollTop),i.bottom>r&&(t=!0,o.scrollTop=i.scrollBottom),i.left<s&&(t=!0,o.scrollLeft=i.scrollLeft),i.right>s&&(t=!0,o.scrollLeft=i.scrollRight),t},_destroyDialog:function(){this._dialogs.pop()},openCustomEditor:function(){var e=this,t=e._sheet.activeCell().first(),n=e._sheet.activeCellCustomEditor(),i=e._sheet.range(t);n.edit({range:i,rect:e.activeCellRectangle(),view:this,validation:this._sheet.validation(t),callback:function(t,n){e._executeCommand({command:"EditCommand",options:{operatingRange:i,property:n?"input":"value",value:t}})}})},openDialog:function(t,n){var i,o,r,s=e.spreadsheet.dialogs.create(t,n);if(s)return s.bind("action",this._executeCommand.bind(this)),s.bind("deactivate",this._destroyDialog.bind(this)),this._dialogs.push(s),i=this._sheet,o=i.activeCell(),r=new e.spreadsheet.Range(o,i),s.open(r),s},showError:function(t,n){var i,o=this.options.messages.errors,r=function(t){var n=t.sender.dialog().element;n.find(".k-button:first").focus(),n.find(".k-button, input").on("keydown",function(n){n.keyCode==e.keys.ESC&&t.sender.close()})},s=function(e){var t=e.sender;this.selectClipBoardContents(),t._retry&&n&&n()}.bind(this);e.spreadsheet.dialogs.registered(t.type)?(i={close:s},"validationError"===t.type&&(i=c.extend(i,{title:t.title||"Error",text:t.body?t.body:o[t.type],activate:r})),this.openDialog(t.type,i)):this.openDialog("message",{title:t.title||"Error",text:t.body?t.body:o[t.type],activate:r,close:s})},destroy:function(){this._dialogs.forEach(function(e){e.destroy()}),this.cellContextMenu.destroy(),this.rowHeaderContextMenu.destroy(),this.colHeaderContextMenu.destroy(),this.tabstrip&&this.tabstrip.destroy(),this._destroyFilterMenu()},_destroyFilterMenu:function(){this._filterMenu&&(this._filterMenu.destroy(),this._filterMenu=void 0,this._filterMenuColumn=void 0)},render:function(){var t,n,i,o,r,s,a,l,d;this.element.is(":visible")&&(t=this._sheet,n=t.focus(),n&&this.scrollIntoView(n)||(i=t.resizingInProgress()?t.resizeHandlePosition().col===-(1/0)?"column":"row":"none",this.wrapper.toggleClass(f.editContainer,this.editor.isActive()).toggleClass(f.horizontalResize,"row"==i).toggleClass(f.verticalResize,"column"==i),o=t._grid,r=this.scroller.scrollTop,s=this.scroller.scrollLeft,r<0&&(r=0),s<0&&(s=0),a=this.panes.map(function(e){return e.render(s,r)}),l=e.dom.element("div",{style:{width:o._headerWidth+"px",height:o._headerHeight+"px"},className:b.classNames.topCorner}),a.push(l),t.resizeHandlePosition()&&t.resizeHintPosition()&&a.push(this.renderResizeHint()),this.tree.render(a),d=e.support.scrollbar(),c(this.container).css({width:this.wrapper[0].clientWidth-d,height:this.wrapper[0].clientHeight-d}),this.editor.isActive()?this.editor.toggleTooltip(this.activeCellRectangle()):t.selectionInProgress()||t.resizingInProgress()||t.isInEditMode()||this.renderClipboardContents()))},renderResizeHint:function(){var t,n,i=this._sheet,o=i.resizeHandlePosition(),r=o.col!==-(1/0);return t=r?{height:this.scroller.clientHeight+"px",width:h+"px",left:i.resizeHintPosition().x+"px",top:"0px"}:{height:h+"px",width:this.scroller.clientWidth+"px",top:i.resizeHintPosition().y+"px",left:"0px"},n=y.classNames,e.dom.element("div",{className:n.resizeHint+(r?"":" "+n.resizeHintVertical),style:t},[e.dom.element("div",{className:n.resizeHintHandle}),e.dom.element("div",{className:n.resizeHintMarker})])},renderClipboardContents:function(){var e,t,n,i,o,r=this._sheet,s=r._grid,l=r.select().toRangeRef(),c=this._workbook.clipboard().canCopy();return c.canCopy===!1&&c.multiSelection?(this.clipboardContents.render([]),void this.selectClipBoardContents()):(l=r.trim(l),e=new p,t=s.rangeDimensions(l),t.rows.forEach(function(t){e.addRow(t)}),t.columns.forEach(function(t){e.addColumn(t)}),n=r._getMergedCells(l),i=n.primary,o=n.secondary,r.forEach(l,function(t,n,r){var s,c,u=new d(t,n).print();o[u]||(s=a(e,t-l.topLeft.row,r),c=i[u],c&&(s.attr.colspan=c.width(),s.attr.rowspan=c.height()))}),this.clipboardContents.render([e.toDomTree(0,0,"kendo-clipboard-"+this._workbook.clipboard()._uid)]),void this.selectClipBoardContents())},_pane:function(e,t,n,i){var o=new y(this._sheet,this._sheet._grid.pane({row:e,column:t,rowCount:n,columnCount:i}));return o.refresh(this.scroller.clientWidth,this.scroller.clientHeight),o}}),w={cell:"k-spreadsheet-cell",vaxis:"k-spreadsheet-vaxis",haxis:"k-spreadsheet-haxis",vborder:"k-spreadsheet-vborder",hborder:"k-spreadsheet-hborder",rowHeader:"k-spreadsheet-row-header",columnHeader:"k-spreadsheet-column-header",pane:"k-spreadsheet-pane",data:"k-spreadsheet-data",mergedCell:"k-spreadsheet-merged-cell",mergedCellsWrapper:"k-merged-cells-wrapper",activeCell:"k-spreadsheet-active-cell",selection:"k-spreadsheet-selection",selectionWrapper:"k-selection-wrapper",autoFillWrapper:"k-auto-fill-wrapper",single:"k-single",top:"k-top",right:"k-right",bottom:"k-bottom",left:"k-left",resizeHandle:"k-resize-handle",columnResizeHandle:"k-column-resize-handle",rowResizeHandle:"k-row-resize-handle",resizeHint:"k-resize-hint",resizeHintHandle:"k-resize-hint-handle",resizeHintMarker:"k-resize-hint-marker",resizeHintVertical:"k-resize-hint-vertical",selectionHighlight:"k-spreadsheet-selection-highlight",series:["k-series-a","k-series-b","k-series-c","k-series-d","k-series-e","k-series-f"]},y=e.Class.extend({init:function(e,t){this._sheet=e,this._grid=t},refresh:function(e,t){this._grid.refresh(e,t)},isVisible:function(e,t,n){return this._grid.view(e,t).ref.intersects(n)},render:function(t,n){var i,o,r,s,a,l,c=y.classNames,d=this._sheet,u=this._grid,h=u.view(t,n);return this._currentView=h,this._currentRect=this._rectangle(h.ref),this._selectedHeaders=d.selectedHeaders(),i=[],i.push(this.renderData()),i.push(this.renderSelection()),i.push(this.renderAutoFill()),i.push(this.renderEditorSelection()),i.push(this.renderFilterHeaders()),u.hasRowHeader&&(o=e.dom.element("div",{className:c.rowHeader,style:{width:u.headerWidth+"px",top:h.rowOffset+"px"}}),i.push(o),d.forEach(h.ref.leftColumn(),function(t){if(!d.isHiddenRow(t)){var n=t+1,i=d.rowHeight(t);o.children.push(e.dom.element("div",{className:this.headerClassName(t,"row"),style:{width:u.headerWidth+"px",height:i+"px"}},[e.dom.element("div",{className:"k-vertical-align-center"},[e.dom.text(n+"")])]))}}.bind(this))),u.hasColumnHeader&&(r=e.dom.element("div",{className:c.columnHeader,style:{top:"0px",left:h.columnOffset+"px",width:this._currentRect.width+"px",height:u.headerHeight+"px"}}),i.push(r),s=0,d.forEach(h.ref.topRow(),function(t,n){if(!d.isHiddenColumn(n)){var i=e.spreadsheet.Ref.display(null,1/0,n),o=d.columnWidth(n);r.children.push(e.dom.element("div",{className:this.headerClassName(n,"col"),style:{position:"absolute",left:s+"px",width:o+"px",height:u.headerHeight+"px"}},[e.dom.element("div",{className:"k-vertical-align-center"},[e.dom.text(i+"")])])),s+=o}}.bind(this))),d.resizeHandlePosition()&&(u.hasColumnHeader||u.hasRowHeader)&&(a=d._grid.normalize(d.resizeHandlePosition()),h.ref.intersects(a)&&(d.resizeHintPosition()||i.push(this.renderResizeHandle()))),l=[c.pane],u.hasColumnHeader&&l.push(c.top),u.hasRowHeader&&l.push(c.left),e.dom.element("div",{style:u.style,className:l.join(" ")},i)},headerClassName:function(e,t){var n,i,o,r=this._selectedHeaders;return"row"===t?(n=r.rows[e],i=r.allRows):(n=r.cols[e],i=r.allCols),o=n||(r.all?"full":i?"partial":"none"),o&&(o="k-selection-"+o),o},renderData:function(){var t,n,i=this._sheet,o=this._currentView,r=e.dom.element("div",{className:y.classNames.data,style:{position:"relative",left:o.columnOffset+"px",top:o.rowOffset+"px"}}),a=this._currentRect,l=e.spreadsheet.draw.doLayout(i,o.ref,{forScreen:!0}),c=i._showGridLines;return c&&(t=null,l.xCoords.forEach(function(n){n!==t&&(t=n,r.children.push(e.dom.element("div",{className:w.vaxis,style:{left:n+"px",height:a.height+"px",borderColor:i.gridLinesColor()}})))}),t=null,l.yCoords.forEach(function(n){n!==t&&(t=n,r.children.push(e.dom.element("div",{className:w.haxis,style:{top:n+"px",width:a.width+"px",borderColor:i.gridLinesColor()}})))})),n=e.spreadsheet.draw.Borders(),l.cells.forEach(function(e){n.add(e),s(r.children,e,null,c)}),n.vert.forEach(function(t){t.forEach(function(t){if(!t.rendered){t.rendered=!0;var n={left:t.x+"px",top:t.top+"px",height:t.bottom-t.top+1+"px",
borderWidth:t.size+"px",borderColor:t.color};1!=t.size&&(n.transform="translateX(-"+(t.size-1)/2+"px)"),r.children.push(e.dom.element("div",{className:w.vborder,style:n}))}})}),n.horiz.forEach(function(t){t.forEach(function(t){if(!t.rendered){t.rendered=!0;var n={top:t.y+"px",left:t.left+"px",width:t.right-t.left+"px",borderWidth:t.size+"px",borderColor:t.color};1!=t.size&&(n.transform="translateY(-"+(t.size-1)/2+"px)"),r.children.push(e.dom.element("div",{className:w.hborder,style:n}))}})}),r},renderResizeHandle:function(){var t,n=this._sheet,i=n.resizeHandlePosition(),o=this._rectangle(i),r=[y.classNames.resizeHandle];return i.col!==-(1/0)?(t={height:this._grid.headerHeight+"px",width:h+"px",left:o.right-h/2+"px",top:"0px"},r.push(f.horizontalResize)):(t={height:h+"px",width:this._grid.headerWidth+"px",top:o.bottom-h/2+"px",left:"0px"},r.push(f.verticalResize)),e.dom.element("div",{className:r.join(" "),style:t})},filterIconRect:function(t){var n=16,i=3;return new e.spreadsheet.Rectangle(t.right-n-i,t.top+i,n,n)},renderFilterHeaders:function(){function t(t){return e.dom.element("span",{className:r.icon+" "+t})}function n(n,i,o){var r,a={left:i.left+"px",top:i.top+"px"},l=s&&s.columns.some(function(e){return e.index===o}),c=n.filterButton;return l&&(c+=" "+n.filterButtonActive),r=e.dom.element("span",{className:c,style:a},[t(n.iconFilterDefault)])}var i=this._sheet,o=[],r=b.classNames,s=i.filter();return s&&this._addDiv(o,s.ref,r.filterRange),i.forEachFilterHeader(this._currentView.ref,function(e){var t=this._rectangle(e),i=this.filterIconRect(t),s=this._sheet.filterColumn(e),a=n(r,i,s);o.push(a)}.bind(this)),e.dom.element("div",{className:r.filterHeadersWrapper},o)},renderEditorSelection:function(){var t=y.classNames,n=this._sheet,i=[];return n._formulaSelections.forEach(function(n){var o=n.ref;o!==e.spreadsheet.NULLREF&&this._addDiv(i,o,t.selectionHighlight+" "+n.colorClass)}.bind(this)),e.dom.element("div",{className:t.selectionWrapper},i)},renderSelection:function(){var t=y.classNames,n=[],i=[t.activeCell],o=[t.selection],r=this._sheet,s=r.activeCell().toRangeRef(),a=this._activeFormulaColor(),l=r.select();return i=i.concat(a,this._directionClasses(s)),o=o.concat(a),r.singleCellSelection()&&i.push(t.single),1===l.size()&&o.push("k-single-selection"),this._sheet.autoFillPunch()&&o.push("k-dim-auto-fill-handle"),l.forEach(function(t){t!==e.spreadsheet.NULLREF&&this._addDiv(n,t,o.join(" "))}.bind(this)),this._addTable(n,s,i.join(" ")),e.dom.element("div",{className:t.selectionWrapper},n)},renderAutoFill:function(){var t,n,i,o,r,s,a,l=[];if(this._sheet.autoFillInProgress())if(t=this._sheet.autoFillRef(),n=this._sheet.autoFillPunch(),i=this._sheet._autoFillDirection,this._addDiv(l,t,"k-auto-fill"),n)this._addDiv(l,n,"k-auto-fill-punch");else if(void 0!==i){switch(i){case 0:o=t.bottomRight,r="k-auto-fill-br-hint";break;case 1:o=t.bottomRight,r="k-auto-fill-br-hint";break;case 2:o=new d(t.topLeft.row,t.bottomRight.col),r="k-auto-fill-tr-hint";break;case 3:o=new d(t.bottomRight.row,t.topLeft.col),r="k-auto-fill-bl-hint"}s=e.dom.element("span",{className:"k-tooltip"},[e.dom.text(this._sheet._autoFillHint)]),a=this._addDiv(l,o,r),a&&a.children.push(s)}return e.dom.element("div",{className:y.classNames.autoFillWrapper},l)},_addDiv:function(e,t,n){var i,o=this._currentView;return o.ref.intersects(t)&&(i=this._rectangle(t).resize(1,1).toDiv(n),e.push(i)),i},_addTable:function(t,n,i){var o,r,a=this,l=a._sheet,c=a._currentView,d=a._grid.columns._axis._count;c.ref.intersects(n)&&(o=a._rectangle(n),r=a._sheet.activeCellCustomEditor(),l.forEach(n.collapse(),function(n,l,c){var u,h,f;c.left=o.left,c.top=o.top,c.width=o.width,c.height=o.height,s(t,c,i,!0),r&&(u="k-button k-spreadsheet-editor-button",h=l==d-1,h&&(u+=" k-spreadsheet-last-column"),a._editorInLastColumn=h,f=e.dom.element("div",{className:u,style:{left:c.left+(h?0:c.width)+"px",top:c.top+"px",height:c.height+"px"}}),r.icon&&f.children.push(e.dom.element("span",{className:"k-icon "+r.icon})),t.push(f))}))},_activeFormulaColor:function(){var e,t=[];return this._sheet.isInEditMode()&&(e=this._sheet._formulaSelections.filter(function(e){return e.active&&"ref"==e.type})[0],e&&t.push(e.colorClass)),t},_directionClasses:function(e){var t=[],n=y.classNames,i=this._currentView.ref;return e.move(0,-1).intersects(i)||t.push(n.left),e.move(-1,0).intersects(i)||t.push(n.top),e.move(0,1).intersects(i)||t.push(n.right),e.move(1,0).intersects(i)||t.push(n.bottom),t},_rectangle:function(e){return this._grid.boundingRectangle(e.toRangeRef()).offset(-this._currentView.mergedCellLeft,-this._currentView.mergedCellTop)}}),e.spreadsheet.View=b,e.spreadsheet.Pane=y,e.spreadsheet.drawCell=s,c.extend(!0,b,{classNames:f}),c.extend(!0,y,{classNames:w}))}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/customeditors.min",["kendo.core.min","kendo.popup.min","kendo.calendar.min","kendo.listview.min","spreadsheet/sheet.min"],e)}(function(){!function(e){"use strict";var t,n;e.support.browser.msie&&e.support.browser.version<9||(t={},n=e.spreadsheet.registerEditor=function(e,n){t[e]=n},e.spreadsheet.Sheet.prototype.activeCellCustomEditor=function(){var e,n,i,o=this.activeCell().first();if(this.range(o).enable())return e=this.validation(o),n=this._properties.get("editor",this._grid.cellRefIndex(o)),null!=n?i=t[n]:e&&e.showButton&&(n="_validation_"+e.dataType,i=t[n]),"function"==typeof i&&(i=t[n]=i()),i},n("_validation_date",function(){function t(){o||(o=$("<div>").kendoCalendar(),r=$("<div>").kendoPopup(),o.appendTo(r),o=o.getKendoCalendar(),r=r.getKendoPopup(),o.bind("change",function(){r.close();var t=o.value();i.range.format()||i.range.format("yyyy-mm-dd"),i.callback(e.spreadsheet.dateToNumber(t))})),r.setOptions({anchor:i.view.element.find(".k-spreadsheet-editor-button")})}function n(){var n,s,a,l;t(),n=i.range.value(),o.value(null!=n?e.spreadsheet.numberToDate(n):null),s=i.validation,s?(a=e.ui.Calendar.fn.options.min,l=e.ui.Calendar.fn.options.max,/^(?:greaterThan|between)/.test(s.comparerType)&&(a=e.spreadsheet.numberToDate(s.from.value)),"between"==s.comparerType&&(l=e.spreadsheet.numberToDate(s.to.value)),"lessThan"==s.comparerType&&(l=e.spreadsheet.numberToDate(s.from.value)),o.setOptions({disableDates:function(t){var n=s.from?0|s.from.value:0,i=s.to?0|s.to.value:0;return t=0|e.spreadsheet.dateToNumber(t),!e.spreadsheet.validation.validationComparers[s.comparerType](t,n,i)},min:a,max:l})):o.setOptions({disableDates:null,min:null,max:null}),r.open()}var i,o,r;return{edit:function(e){i=e,n()},icon:"k-i-calendar"}}),n("_validation_list",function(){function t(){o||(o=$("<ul class='k-list k-reset'/>").kendoStaticList({template:"#:value#",selectable:!0,autoBind:!1}),r=$("<div>").kendoPopup(),o.appendTo(r),r=r.getKendoPopup(),o=o.getKendoStaticList(),o.bind("change",function(){r.close();var e=o.value()[0];e&&i.callback(e.value)})),r.setOptions({anchor:i.view.element.find(".k-spreadsheet-editor-button")})}function n(){var n,s,a;t(),n=i.validation.from.value,s=[],n&&n.each(function(e){s.push({value:e})}),a=new e.data.DataSource({data:s}),o.setDataSource(a),a.read(),r.open()}var i,o,r;return{edit:function(e){i=e,n()},icon:"k-i-arrow-60-down"}}))}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/grid.min",["kendo.core.min","spreadsheet/references.min"],e)}(function(){!function(e){var t,n,i,o,r,s;e.support.browser.msie&&e.support.browser.version<9||(t=e.spreadsheet.CellRef,n=e.spreadsheet.RangeRef,i=e.spreadsheet.UnionRef,o=e.Class.extend({init:function(e,t,n,i){this.left=e,this.width=n,this.right=e+n,this.top=t,this.height=i,this.bottom=t+i},offset:function(e,t){return new o(this.left+e,this.top+t,this.width,this.height)},resize:function(e,t){return new o(this.left,this.top,this.width+e,this.height+t)},intersects:function(e,t){return this.left<e&&e<this.left+this.width&&this.top<t&&t<this.top+this.height},toDiv:function(t){return e.dom.element("div",{className:t,style:{width:this.width+"px",height:this.height+"px",top:this.top+"px",left:this.left+"px"}})}}),r=e.Class.extend({init:function(e,t,n,i,o,r){this.rowCount=n,this.columnCount=i,this._columns=t,this._rows=e,this._headerHeight=o,this._headerWidth=r},isAxis:function(e){var t,n;return e=e.toRangeRef(),t=e.topLeft,n=e.bottomRight,0===t.row&&n.row===this.rowCount-1||0===t.col&&n.col===this.columnCount-1},width:function(e,t){return this._columns.sum(e,t)},height:function(e,t){return this._rows.sum(e,t)},totalHeight:function(){return this._rows.total+this._headerHeight},totalWidth:function(){return this._columns.total+this._headerWidth},index:function(e,t){return t*this.rowCount+e},cellRef:function(e){return new t(e%this.rowCount,e/this.rowCount>>0)},rowRef:function(e){return new n(new t(e,0),new t(e,this.columnCount-1))},colRef:function(e){return new n(new t(0,e),new t(this.rowCount-1,e))},cellRefIndex:function(e){return this.index(e.row,e.col)},normalize:function(e){return e instanceof n?new n(this.normalize(e.topLeft),this.normalize(e.bottomRight)).setSheet(e.sheet,e.hasSheet()):e instanceof i?e.map(function(e){return this.normalize(e)},this):(e instanceof t&&(e=e.clone(),e.col=Math.max(0,Math.min(this.columnCount-1,e.col)),e.row=Math.max(0,Math.min(this.rowCount-1,e.row))),e)},rectangle:function(e){var t=this.normalize(e.topLeft),n=this.normalize(e.bottomRight);return new o(this.width(0,t.col-1),this.height(0,t.row-1),this.width(t.col,n.col),this.height(t.row,n.row))},pane:function(t){return new s(new e.spreadsheet.PaneAxis(this._rows,t.row,t.rowCount,this._headerHeight),new e.spreadsheet.PaneAxis(this._columns,t.column,t.columnCount,this._headerWidth),this)},rangeDimensions:function(e){return{rows:this._rows.values.iterator(e.topLeft.row,e.bottomRight.row),columns:this._columns.values.iterator(e.topLeft.col,e.bottomRight.col)}},forEach:function(e,n){var i,o,r=this.normalize(e.topLeft),s=this.normalize(e.bottomRight);for(i=r.col;i<=s.col;i++)for(o=r.row;o<=s.row;o++)n(new t(o,i))},trim:function(e,i){var o,r,s,a,l,c=e.topLeft,d=e.bottomRight,u=c.row,h=c.col;for(o=c.col;o<=d.col;o++)r=this.index(c.row,o),s=this.index(d.row,o),a=i.tree.intersecting(r,s),a.length&&(l=this.cellRef(a[a.length-1].end),u=Math.max(u,l.row),h=o);return new n(e.topLeft,new t(Math.min(u,e.bottomRight.row),h))}}),s=e.Class.extend({init:function(e,t,n){this.rows=e,this.columns=t,this._grid=n,this.headerHeight=e.headerSize,this.headerWidth=t.headerSize,this.hasRowHeader=t.hasHeader,this.hasColumnHeader=e.hasHeader},refresh:function(e,t){var n,i;this.columns.viewSize(e),this.rows.viewSize(t),n=this.columns.paneSegment(),i=this.rows.paneSegment(),this.left=n.offset,this.top=i.offset,this.right=n.offset+n.length,this.bottom=i.offset+i.length,this.style={top:i.offset+"px",left:n.offset+"px",height:i.length+"px",width:n.length+"px"}},view:function(e,i){var o=this.rows.visible(i),r=this.columns.visible(e);return{rows:o,columns:r,rowOffset:o.offset,columnOffset:r.offset,mergedCellLeft:r.start,mergedCellTop:o.start,ref:new n(new t(o.values.start,r.values.start),new t(o.values.end,r.values.end))}},contains:function(e){return this.rows.contains(e.topLeft.row,e.bottomRight.row)&&this.columns.contains(e.topLeft.col,e.bottomRight.col)},index:function(e,t){return this._grid.index(e,t)},boundingRectangle:function(e){return this._grid.rectangle(e)},cellRefIndex:function(e){return this._grid.cellRefIndex(e)},scrollBoundaries:function(e){var t=this.boundingRectangle(e),n={top:Math.max(0,t.top-this.top+(this.hasColumnHeader?0:this.headerHeight)),left:Math.max(0,t.left-this.left+(this.hasRowHeader?0:this.headerWidth)),right:t.right-this.columns._viewSize+this.headerWidth,bottom:t.bottom-this.rows._viewSize+this.headerHeight},i=this.columns.defaultValue/2,o=this.rows.defaultValue/2;return n.scrollTop=n.top-o,n.scrollBottom=n.bottom+o,n.scrollLeft=n.left-i,n.scrollRight=n.right+i,n}}),e.spreadsheet.Grid=r,e.spreadsheet.PaneGrid=s,e.spreadsheet.Rectangle=o)}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/axis.min",["kendo.core.min"],e)}(function(){!function(e){var t,n;e.support.browser.msie&&e.support.browser.version<9||(t=e.Class.extend({init:function(t,n){this._value=n,this._count=t,this.values=new e.spreadsheet.RangeList(0,t-1,n),this._hidden=new e.spreadsheet.RangeList(0,t-1,0),this.scrollBarSize=e.support.scrollbar(),this._refresh()},adjust:function(e,t){t<0?(this.values.copy(e-t,this._count-1,e),this._hidden.copy(e-t,this._count-1,e)):(this.values.copy(e,this._count,e+t),this._hidden.copy(e,this._count,e+t),this.values.value(e,e+t-1,this._value),this._hidden.value(e,e+t-1,0)),this._refresh()},toJSON:function(e,t){var n,i,o,r,s,a=[],l=this.values.iterator(0,this._count-1);for(n=0;n<this._count;n++)i=l.at(n),o=this._hidden.value(n,n),(i!==this._value||o)&&(r=t[n],void 0===r&&(r=a.length,s={index:n},s[e]=i,o&&(s.hidden=o),a.push(s),t[n]=r));return a},fromJSON:function(e,t){var n,i,o,r;for(n=0;n<t.length;n++)i=t[n],o=i[e]||i.hidden,r=i.index,void 0===r&&(r=n),this.value(r,r,o),i.hidden&&this.hide(r)},hide:function(e){if(!this.hidden(e)){var t=this.value(e,e);this._hidden.value(e,e,t),this.value(e,e,0)}},hidden:function(e){return 0!==this._hidden.value(e,e)},includesHidden:function(e,t){return this._hidden.intersecting(e,t).length>1},nextVisible:function(e,t){var n,i=this._count-1;if(e===i)return t?e+1:e;for(n=e+1;n<=i;++n)if(!this.hidden(n))return n;return e},nextPage:function(e,t){return this.index(this.sum(0,e-1)+t)},prevPage:function(e,t){return this.index(this.sum(0,e)-t)},firstVisible:function(){var e=this._hidden.first();return 0===e.value?0:e.end+1},lastVisible:function(){var e=this._hidden.last();return 0===e.value?this._count-1:e.start-1},prevVisible:function(e,t){if(0===e)return t?-1:0;for(var n=e-1;n>=0;--n)if(!this.hidden(n))return n;return e},unhide:function(e){if(this.hidden(e)){var t=this._hidden.value(e,e);this._hidden.value(e,e,0),this.value(e,e,t)}},value:function(e,t,n){return void 0===n?this.values.iterator(e,t).at(0):(this.values.value(e,t,n),void this._refresh())},sum:function(e,t){var n,i=this.values.iterator(e,t),o=0;for(n=e;n<=t;n++)o+=i.at(n);return o},visible:function(e,t){var n,i,o,r,s,a,l=null,c=null,d=!1;return t>=this.total+this.scrollBarSize&&(d=!0),n=this._pixelValues.intersecting(e,t),l=n[0],c=n[n.length-1],l?(i=e-l.start,o=(i/l.value.value>>0)+l.value.start,r=i-(o-l.value.start)*l.value.value,s=t-c.start,a=(s/c.value.value>>0)+c.value.start,a>c.value.end&&(a=c.value.end),d&&(r+=c.value.value-(s-(a-c.value.start)*c.value.value)),r=Math.min(-r,0),{values:this.values.iterator(o,a),offset:r}):{values:this.values.iterator(0,0),offset:0}},index:function(e){for(var t=0,n=this.values.iterator(0,this._count-1),i=n.at(0);i<e&&t<this._count-1;)i+=n.at(++t);return t},indexVisible:function(e){var t=this.index(e);return this.hidden(t)&&(t=this.prevVisible(t)),t},_refresh:function(){var t=0;this._pixelValues=this.values.map(function(n){var i,o=t;return t+=(n.end-n.start+1)*n.value,i=t-1,new e.spreadsheet.ValueRange(o,i,n)}),this.total=t},getState:function(){return{values:this.values.getState(),hidden:this._hidden.getState()}},setState:function(e){this.values.setState(e.values),this._hidden.setState(e.hidden),this._refresh()}}),n=e.Class.extend({init:function(e,t,n,i){this._axis=e,this._start=t,this._count=n,this.hasHeader=0===t,this.headerSize=i,this.defaultValue=e._value,this.frozen=n>0},viewSize:function(e){this._viewSize=e},sum:function(e,t){return this._axis.sum(e,t-1)},start:function(){return this.sum(0,this._start)},size:function(){return this.sum(this._start,this._start+this._count)},index:function(e,t){return this._axis.index(e+(this.frozen?0:t)-this.headerSize)},indexVisible:function(e,t){return this._axis.indexVisible(e+(this.frozen?0:t)-this.headerSize)},paneSegment:function(){var e,t=this.start();return this.hasHeader||(t+=this.headerSize),this.frozen?(e=this.size(),this.hasHeader?e+=this.headerSize:e-=this.headerSize):e=this._viewSize-t,{offset:t,length:e}},visible:function(e){var t,n,i=this.start();return this.frozen?(t=this.size(),this.hasHeader||(t-=this.headerSize)):(t=this._viewSize-i-this.headerSize,i+=e),n=this._axis.visible(i,i+t-1),this.frozen&&(n.offset=0),n.start=i,this.hasHeader&&(n.offset+=this.headerSize,n.start-=this.headerSize),n},contains:function(e,t){return this.frozen?!(e>this._start+this._count)&&!(t<this._start):t>=this._start}}),e.spreadsheet.Axis=t,e.spreadsheet.PaneAxis=n)}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/filter.min",["kendo.core.min","kendo.data.min"],e)}(function(){!function(e){function t(e){var t=e.getMonth()+1;return t>=1&&t<=3?1:t>=4&&t<=6?2:t>=7&&t<=9?3:4}function n(t,n){if(t instanceof Date){var i=e.date.today();return i.setFullYear(i.getFullYear()+n),i.getFullYear()===t.getFullYear()}return!1}function i(t,n){if(t instanceof Date){var i=e.date.firstDayOfMonth(e.date.today());return i.setMonth(i.getMonth()+n,1),i.getTime()===e.date.firstDayOfMonth(t).getTime()}return!1}function o(t,n){var i,o;return n instanceof Date&&(i=e.date.dayOfWeek(e.date.getDate(t),1),o=e.date.dayOfWeek(e.date.getDate(n),1),i.getTime()===o.getTime())}if(!(e.support.browser.msie&&e.support.browser.version<9)){var r=e.spreadsheet.Filter=e.Class.extend({prepare:function(){},value:function(e){return e.value},matches:function(){throw Error("The 'matches' method is not implemented.")},toJSON:function(){throw Error("The 'toJSON' method is not implemented.")}});r.create=function(t){var n,i=t.filter;if(!i)throw Error("Filter type not specified.");if(n=e.spreadsheet[i.charAt(0).toUpperCase()+i.substring(1)+"Filter"],!n)throw Error("Filter type not recognized.");return new n(t)},e.spreadsheet.ValueFilter=r.extend({_values:[],_dates:[],_blanks:!1,init:function(e){void 0!==e.values&&(this._values=e.values),void 0!==e.blanks&&(this._blanks=e.blanks),void 0!==e.dates&&(this._dates=e.dates)},value:function(t){var n,i=t.value;return this._dates.length>0&&t.format&&"number"==typeof i&&(n=e.spreadsheet.formatting.type(i,t.format),"date"===n&&(i=e.spreadsheet.numberToDate(i))),i},matches:function(e){return null===e||void 0===e?this._blanks:e instanceof Date?this._dates.some(function(t){return!(t.year!==e.getFullYear()||void 0!==t.month&&t.month!==e.getMonth()||void 0!==t.day&&t.day!==e.getDate()||void 0!==t.hours&&t.hours!==e.getHours()||void 0!==t.minutes&&t.minutes!==e.getMinutes()||void 0!==t.seconds&&t.seconds!==e.getSeconds())}):this._values.indexOf(e)>=0},toJSON:function(){return{filter:"value",blanks:this._blanks,values:this._values.slice(0)}}}),e.spreadsheet.CustomFilter=r.extend({_logic:"and",init:function(t){if(void 0!==t.logic&&(this._logic=t.logic),void 0===t.criteria)throw Error("Must specify criteria.");this._criteria=t.criteria;var n=e.data.Query.filterExpr({logic:this._logic,filters:this._criteria}).expression;this._matches=Function("d","return "+n)},matches:function(e){return null!==e&&this._matches(e)},value:function(t){var n=t.value,i=this._criteria[0].value,o=i instanceof Date?"date":typeof i,r=typeof n;return t.format&&(r=e.spreadsheet.formatting.type(n,t.format)),r!=o?"string"==o&&(t.format&&(n=e.spreadsheet.formatting.text(n,t.format)),n+=""):"date"==r&&(n=e.spreadsheet.numberToDate(n)),n},toJSON:function(){return{filter:"custom",logic:this._logic,criteria:this._criteria}}}),e.spreadsheet.TopFilter=r.extend({init:function(e){this._type=e.type,this._value=e.value,this._values=[]},prepare:function(e){var t,n=e.map(this.value).sort().filter(function(e,t,n){return 0===t||e!==n[t-1]});n.sort("topNumber"===this._type||"topPercent"==this._type?function(e,t){return t-e}:function(e,t){return e-t}),t=this._value,"topPercent"!==this._type&&"bottomPercent"!==this._type||(t=n.length*t/100>>0),this._values=n.slice(0,t)},matches:function(e){return this._values.indexOf(e)>=0},toJSON:function(){return{filter:"top",type:this._type,value:this._value}}}),e.spreadsheet.DynamicFilter=r.extend({init:function(e){if(this._type=e.type,this._predicate=this[e.type],"function"!=typeof this._predicate)throw Error("DynamicFilter type '"+e.type+"' not recognized.")},value:function(t){var n,i=t.value;return t.format&&(n=e.spreadsheet.formatting.type(i,t.format),"date"===n&&(i=e.spreadsheet.numberToDate(i))),i},prepare:function(e){var t,n,i=0,o=0;for(t=0;t<e.length;t++)n=this.value(e[t]),"number"==typeof n&&(i+=n,o++);this._average=o>0?i/o:0},matches:function(e){return this._predicate(e)},aboveAverage:function(t){return t instanceof Date&&(t=e.spreadsheet.dateToNumber(t)),"number"==typeof t&&t>this._average},belowAverage:function(t){return t instanceof Date&&(t=e.spreadsheet.dateToNumber(t)),"number"==typeof t&&t<this._average},tomorrow:function(t){if(t instanceof Date){var n=e.date.addDays(e.date.today(),1);return e.date.getDate(t).getTime()===n.getTime()}return!1},today:function(t){return t instanceof Date&&e.date.isToday(t)},yesterday:function(t){if(t instanceof Date){var n=e.date.addDays(e.date.today(),-1);return e.date.getDate(t).getTime()===n.getTime()}return!1},nextWeek:function(t){return o(e.date.addDays(e.date.today(),7),t)},thisWeek:function(t){return o(e.date.today(),t)},lastWeek:function(t){return o(e.date.addDays(e.date.today(),-7),t)},nextMonth:function(e){return i(e,1)},thisMonth:function(e){return i(e,0)},lastMonth:function(e){return i(e,-1)},nextQuarter:function(n){var i,o;return n instanceof Date&&(i=e.date.today(),o=t(n)-t(i),1===o&&i.getFullYear()===n.getFullYear()||o==-3&&i.getFullYear()+1===n.getFullYear())},thisQuarter:function(n){var i,o;return n instanceof Date&&(i=e.date.today(),o=t(n)-t(i),0===o&&i.getFullYear()===n.getFullYear())},lastQuarter:function(n){var i,o;return n instanceof Date&&(i=e.date.today(),o=t(i)-t(n),1===o&&i.getFullYear()===n.getFullYear()||o==-3&&i.getFullYear()-1===n.getFullYear())},nextYear:function(e){return n(e,1)},thisYear:function(e){return n(e,0)},lastYear:function(e){return n(e,-1)},yearToDate:function(t){if(t instanceof Date){var n=e.date.today();return t.getFullYear()===n.getFullYear()&&t<=n}return!1},toJSON:function(){return{filter:"dynamic",type:this._type}}}),[1,2,3,4].forEach(function(n){e.spreadsheet.DynamicFilter.prototype["quarter"+n]=function(e){return e instanceof Date&&t(e)===n}}),e.cultures["en-US"].calendar.months.names.forEach(function(t,n){e.spreadsheet.DynamicFilter.prototype[t.toLowerCase()]=function(e){return e instanceof Date&&e.getMonth()===n}})}}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/sorter.min",["kendo.core.min"],e)}(function(){!function(e){if(!(e.support.browser.msie&&e.support.browser.version<9)){var t=e.Class.extend({init:function(e,t){this._grid=e,this._lists=t},indices:function(e,n,i,o){var r=t.ascendingComparer;return i===!1&&(r=t.descendingComparer),n.sortedIndices(this._grid.cellRefIndex(e.topLeft),this._grid.cellRefIndex(e.bottomRight),r,o)},sortBy:function(e,t,n,i,o){var r,s,a,l,c=this.indices(e.toColumn(t),n,i,o);for(r=e.topLeft.col;r<=e.bottomRight.col;r++)for(s=this._grid.index(e.topLeft.row,r),a=this._grid.index(e.bottomRight.row,r),l=0;l<this._lists.length;l++)s<this._lists[l].lastRangeStart()&&this._lists[l].sort(s,a,c);return c}});t.ascendingComparer=function(t,n){var i,o;if(null===t&&null===n)return 0;if(null===t)return 1;if(null===n)return-1;if(i=typeof t,o=typeof n,"number"===i)return"number"===o?t-n:-1;if("string"===i)switch(o){case"number":return 1;case"string":return t.localeCompare(n);default:return-1}if("boolean"===i)switch(o){case"number":return 1;case"string":return 1;case"boolean":return t-n;default:return-1}if(t instanceof e.spreadsheet.calc.runtime.CalcError)return n instanceof e.spreadsheet.calc.runtime.CalcError?0:1;throw Error("Cannot compare "+t+" and "+n)},t.descendingComparer=function(e,n){return null===e&&null===n?0:null===e?1:null===n?-1:t.ascendingComparer(n,e)},e.spreadsheet.Sorter=t}}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/numformat.min",["spreadsheet/calc.min","kendo.dom.min"],e)}(function(){"use strict";function e(e){function t(){var t=e.skip(d);if(t)return t[1].toLowerCase()}function n(){var t,n=e.skip(u);if(n&&(t=parseFloat(n[2]),!isNaN(t)))return{op:n[1],value:t}}function i(){for(var t,n=[],i=null;!e.eof()&&(t=r());)"date"==t.type?i&&/^(el)?time$/.test(i.type)&&"h"==i.part&&"m"==t.part&&t.format<3&&(t.type="time"):/^(el)?time$/.test(t.type)&&"s"==t.part&&i&&"date"==i.type&&"m"==i.part&&i.format<3&&(i.type="time"),/^(?:str|space|fill)$/.test(t.type)||(i=t),n.push(t);return n}function o(t){if("date"!=t.type||"m"==t.part&&t.format<3){var n=e.skip(/^\.(0+)/);n&&(t.fraction=n[1].length,"date"==t.type&&(t.type="time"))}return t}function r(){var t,n;if(n=e.skip(/^([#0?]+)(?:,([#0?]+))+/))return{type:"digit",sep:!0,format:n[1]+n[2],decimal:h};if(n=e.skip(/^[#0?]+/))return{type:"digit",sep:!1,format:n[0],decimal:h};if(n=e.skip(/^(e)([+-])/i))return{type:"exp",ch:n[1],sign:n[2]};if(n=e.skip(/^(d{1,4}|m{1,5}|yyyy|yy)/i))return n=n[1].toLowerCase(),o({type:"date",part:n.charAt(0),format:n.length});if(n=e.skip(/^(hh?|ss?)/i))return n=n[1],o({type:"time",part:n.toLowerCase().charAt(0),format:n.length,ampm:"hh"==n});if(n=e.skip(/^\[(hh?|mm?|ss?)\]/i))return n=n[1].toLowerCase(),o({type:"eltime",part:n.charAt(0),format:n.length});if(n=e.skip(/^(am\/pm|a\/p)/i))return n=n[1].split("/"),{type:"ampm",am:n[0],pm:n[1]};switch(t=e.next()){case";":return null;case"\\":return{type:"str",value:e.next()};case'"':return{type:"str",value:e.readEscaped(t)};case"@":return{type:"text"};case"_":return{type:"space",value:e.next()};case"*":return{type:"fill",value:e.next()};case".":return e.lookingAt(/^\s*[#0?]/)?(h=!0,{type:"dec"}):{type:"str",value:"."};case"%":return{type:"percent"};case",":return{type:"comma"}}return{type:"str",value:t}}function s(){h=!1;var e=t(),o=n();return!e&&o&&(e=t()),{color:e,cond:o,body:i()}}var a,c,h,f;for(e=l.InputStream(e),a=[],c=!1;!e.eof();)f=s(),a.push(f),f.cond&&(c=!0);return c||(1==a.length?a[0].cond="num":2==a.length?(a[0].cond={op:">=",value:0},a[1].cond={op:"<",value:0}):a.length>=3&&(a[0].cond={op:">",value:0},a[1].cond={op:"<",value:0},a[2].cond={op:"=",value:0},a.length>3&&(a[3].cond="text",a=a.slice(0,4)))),a}function t(e){function t(e){var t="";return e.color&&(t+="["+e.color+"]"),e.cond&&"text"!=e.cond&&"num"!=e.cond&&(t+="["+e.cond.op+e.cond.value+"]"),t+=e.body.map(i).join("")}function n(e,t){return t.fraction&&(e+="."+s("",t.fraction,"0")),e}function i(e){return"digit"==e.type?e.sep?e.format.charAt(0)+","+e.format.substr(1):e.format:"exp"==e.type?e.ch+e.sign:"date"==e.type||"time"==e.type?n(s("",e.format,e.part),e):"eltime"==e.type?n("["+s("",e.format,e.part)+"]",e):"ampm"==e.type?e.am+"/"+e.pm:"str"==e.type?JSON.stringify(e.value):"text"==e.type?"@":"space"==e.type?"_"+e.value:"fill"==e.type?"*"+e.value:"dec"==e.type?".":"percent"==e.type?"%":"comma"==e.type?",":void 0}return e.map(t).join(";")}function n(e,t){e.forEach(function(e){var n,i,o,r,a,l=t;if("text"!=e.cond){for(n=e.body,i=!1,o=n.length;0!==l&&--o>=0;)if(r=n[o],"digit"==r.type){if(r.decimal&&(i=!0,l>0?r.format+=s("",l,"0"):l<0&&(a=r.format.length,r.format=r.format.substr(0,a+l),l+=a-r.format.length),0===r.format.length))for(n.splice(o,1);--o>=0;){if(r=n[o],"digit"==r.type&&r.decimal){++o;break}if("dec"==r.type){n.splice(o,1);break}}if(l>0)break}!i&&l>0&&n.splice(o+1,0,{type:"dec"},{type:"digit",sep:!1,decimal:!0,format:s("",l,"0")})}})}function i(e){var t=0;return{next:function(){return e[t++]},eof:function(){return t>=e.length},ahead:function(n,i){if(t+n<=e.length){var o=i.apply(null,e.slice(t,t+n));return o&&(t+=n),o}},restart:function(){t=0}}}function o(e){function t(e,t){("digit"==e.type&&"comma"==t.type||"comma"==e.type&&e.hidden&&"comma"==t.type)&&(t.hidden=!0,u++)}var n,o,r=i(e.body),s=!1,a=!1,l=!1,c=0,d=/[\$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/,u=0,h="",f=!1,p=0,m=[],g=[],v=e.cond,_="";for("text"==v?_="if (typeof value == 'string' || value instanceof kendo.spreadsheet.CalcError) { ":"num"==v?_="if (typeof value == 'number') { ":v&&(n="="==v.op?"==":v.op,_="if (typeof value == 'number' && value "+n+" "+v.value+") { ",h+="value = Math.abs(value); "),e.color&&(h+="result.color = "+JSON.stringify(e.color)+"; ");!r.eof();)r.ahead(2,t),o=r.next(),"percent"==o.type?c++:"digit"==o.type?o.decimal?(p+=o.format.length,g.push(o.format)):(m.push(o.format),o.sep&&(f=!0)):"time"==o.type?(l=l||!!o.ampm,a=!0):"date"==o.type?s=!0:"ampm"==o.type&&(l=a=!0);for(c>0&&(h+="value *= "+Math.pow(100,c)+"; "),u>0&&(h+="value /= "+Math.pow(1e3,u)+"; "),m.length&&(h+="var intPart = runtime.formatInt(culture, value, "+JSON.stringify(m)+", "+p+", "+f+"); ",h+="var isNegative = parseInt(intPart[0]) < 0;"),g.length&&(h+="var decPart = runtime.formatDec(value, "+JSON.stringify(g)+", "+p+"); "),(m.length||g.length)&&(h+="type = 'number'; "),s&&(h+="var date = runtime.unpackDate(value); "),a&&(h+="var time = runtime.unpackTime(value); "),(s||a)&&(h+="type = 'date'; "),(c>0||u>0||m.length||g.length||s||a)&&(_||(_="if (typeof value == 'number') { ")),r.restart(),h+="var matchedCurrency = false;";!r.eof();)o=r.next(),"dec"==o.type?h+="output += culture.numberFormat['.']; ":"comma"!=o.type||o.hidden?"percent"==o.type?(h+="type = 'percent'; ",h+="output += culture.numberFormat.percent.symbol; "):"str"==o.type?(d.test(o.value)&&(h+="type = 'currency'; ",h+="if (isNegative) { output += '-'; matchedCurrency = true; }"),h+="output += "+JSON.stringify(o.value)+"; "):"text"==o.type?(h+="type = 'text'; ",h+="output += value; "):"space"==o.type?(h+="if (output) result.body.push(output); ",h+="output = ''; ",h+="result.body.push({ type: 'space', value: "+JSON.stringify(o.value)+" }); "):"fill"==o.type?h+="output += runtime.fill("+JSON.stringify(o.value)+"); ":"digit"==o.type?(h+="if (isNegative && intPart[0] && matchedCurrency) {intPart[0] = intPart[0].replace('-', '');}",h+="output += "+(o.decimal?"decPart":"intPart")+".shift(); "):"date"==o.type?h+="output += runtime.date(culture, date, "+JSON.stringify(o.part)+", "+o.format+"); ":"time"==o.type?h+="output += runtime.time(time, "+JSON.stringify(o.part)+", "+o.format+", "+l+", "+o.fraction+"); ":"eltime"==o.type?h+="output += runtime.eltime(value, "+JSON.stringify(o.part)+", "+o.format+", "+o.fraction+"); ":"ampm"==o.type&&(h+="output += time.hours < 12 ? "+JSON.stringify(o.am)+" : "+JSON.stringify(o.pm)+"; "):h+="output += ','; ";return h+="if (output) result.body.push(output); ",h+="result.type = type; ",h+="return result; ",_&&(h=_+h+"}"),h}function r(t){var n,i,r=h[t];return r||(n=e(t),i=n.map(o),i.push(f),i=i.join("\n"),i="'use strict'; return function(value, culture){ if (!culture) culture = kendo.culture(); var output = '', type = null, result = { body: [] }; "+i+"; return result; };",r=h[t]=Function("runtime",i)(p)),r}function s(e,t,n){for(e+="";e.length<t;)e=n+e;return e}function a(e){var t,n,i=e.body,o="";for(t=0;t<i.length;++t)n=i[t],"string"==typeof n?o+=n:"space"==n.type&&(o+=" ");return o}var l,c,d,u,h,f,p;kendo.support.browser.msie&&kendo.support.browser.version<9||(l=kendo.spreadsheet.calc,c=kendo.dom,d=/^\[(black|green|white|blue|magenta|yellow|cyan|red)\]/i,u=/^\[(<=|>=|<>|<|>|=)(-?[0-9.]+)\]/,h=Object.create(null),f=o({cond:"text",body:[{type:"text"}]}),p={unpackDate:l.runtime.unpackDate,unpackTime:l.runtime.unpackTime,date:function(e,t,n,i){switch(n){case"d":switch(i){case 1:return t.date;case 2:return s(t.date,2,"0");case 3:return e.calendars.standard.days.namesAbbr[t.day];case 4:return e.calendars.standard.days.names[t.day]}break;case"m":switch(i){case 1:return t.month+1;case 2:return s(t.month+1,2,"0");case 3:return e.calendars.standard.months.namesAbbr[t.month];case 4:return e.calendars.standard.months.names[t.month];case 5:return e.calendars.standard.months.names[t.month].charAt(0);
}break;case"y":switch(i){case 2:return t.year%100;case 4:return t.year}}return"##"},time:function(e,t,n,i,o){var r,a;switch(t){case"h":r=s(i?e.hours%12||12:e.hours,n,"0"),o&&(a=(e.minutes+(e.seconds+e.milliseconds/1e3)/60)/60);break;case"m":r=s(e.minutes,n,"0"),o&&(a=(e.seconds+e.milliseconds/1e3)/60);break;case"s":r=s(e.seconds,n,"0"),o&&(a=e.milliseconds/1e3)}return a&&(r+=p.toFixed(a,o).replace(/^0+/,"")),r},eltime:function(e,t,n,i){var o,r;switch(t){case"h":o=24*e;break;case"m":o=24*e*60;break;case"s":o=24*e*60*60}return i&&(r=o-(0|o)),o=s(0|o,n,"0"),r&&(o+=p.toFixed(r,i).replace(/^0+/,"")),o},fill:function(e){return e},formatInt:function(e,t,n,i,o){function r(t){o&&l&&l%3===0&&/^[0-9]$/.test(t)&&(c=e.numberFormat[","]+c),c=t+c,l++}var s,a,l,c,d,u,h,f;for(t=p.toFixed(t,i).replace(/\..*$/,""),i>0&&("0"===t?t="":"-0"===t&&(t="-")),s=t.length-1,a=[],l=0,d=n.length;--d>=0;){for(u=n[d],c="",h=u.length;--h>=0;)f=u.charAt(h),s<0?"0"==f?r("0"):"?"==f&&r(" "):(r("0"==t&&"?"==f?" ":t.charAt(s)),s--);if(0===d)for(;s>=0;)r(t.charAt(s--));a.unshift(c)}return a},formatDec:function(e,t,n){var i,o,r,s,a,l,c,d;for(e=p.toFixed(e,n),i=e.indexOf("."),e=i>=0?e.substr(i+1).replace(/0+$/,""):"",o=0,r=[],s=0;s<t.length;++s){for(a=t[s],l="",c=0;c<a.length;++c)d=a.charAt(c),o<e.length?l+=e.charAt(o++):"0"==d?l+="0":"?"==d&&(l+=" ");r.push(l)}return r},toFixed:function(e,t){var n,i,o=e+"",r=o.indexOf(".");if(r>=0){if(n=o.substr(0,r)||0,i=o.substr(r+1),i.length>14&&(i=Math.round(i/Math.pow(10,i.length-14))+""),i.length<t){for(;i.length<t;)i+="0";return n+"."+i}e=parseFloat(n+"."+i)}return e.toFixed(t)}},kendo.spreadsheet.formatting={compile:r,parse:e,format:function(e,t,n){var i,o,s,a=r(t)(e,n),l=c.element("span");for(l.__dataType=a.type,i=a.body,a.color&&(l.attr.style={color:a.color}),o=0;o<i.length;++o)s=i[o],"string"==typeof s?l.children.push(c.text(s)):"space"==s.type&&l.children.push(c.element("span",{style:{visibility:"hidden"}},[c.text(s.value)]));return l},text:function(e,t,n){var i=r(t)(e,n);return a(i)},textAndColor:function(e,t,n){var i=r(t)(e,n);return{text:a(i),color:i.color,type:i.type}},type:function(e,t){return r(t)(e).type},adjustDecimals:function(i,o){var r=e(i);return n(r,o),t(r)}})},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/runtime.functions.min",["spreadsheet/runtime.min","util/main.min"],e)}(function(){"use strict";function e(e){return(Math.exp(e)+Math.exp(-e))/2}function t(e){return(Math.exp(e)-Math.exp(-e))/2}function n(n){return t(n)/e(n)}function i(e,t){for(;t;){var n=e%t;e=t,t=n}return e}function o(e,t){return Math.abs(e*t)/i(e,t)}function r(e,t){for(var n,i,o,r=[],s=0,a=e[0];s<e.length;)r.push({matrix:e[s++],pred:G(e[s++])});for(n=0;n<a.height;++n)e:for(i=0;i<a.width;++i){for(s=0;s<r.length;++s)if(o=r[s].matrix.get(n,i),!r[s].pred(null==o||""===o?0:o))continue e;t(n,i)}}function s(e){return e.reduce(function(e,t){return e+t},0)/e.length}function a(e,t,n){return null==n&&(n=s(e)),e.reduce(function(e,t){return e+Math.pow(t-n,2)},0)/t}function l(e,t){return Math.sqrt(a(e,t))}function c(e,t,n){var i=0,o=0,r=null,s=null,a=!1;return e.forEach(function(e){e<t?(i++,r=null==r?e:Math.max(r,e)):e>t?(o++,s=null==s?e:Math.min(s,e)):a=!0}),i||o?a?n?(i+1)/(e.length+1):i/(i+o):((s-t)*c(e,r,n)+(t-r)*c(e,s,n))/(s-r):new A("N/A")}function d(e,t,n){var i,o=0,r=s(e),a=s(t),l=e.length;for(i=0;i<l;++i)o+=(e[i]-r)*(t[i]-a);return o/n}function u(e,t){var n,i,o;return e.sort(w),n=e.length,i=0|t,o=t-i,0===i?e[0]:i>=n?e[n-1]:(--i,e[i]+o*(e[i+1]-e[i]))}function h(e,t){var n=t*(e.length-1)+1;return u(e,n)}function f(e,t){var n=t*(e.length+1);return u(e,n)}function p(e,t,n){var i=[],o=1,r=2,s=4;return function a(t){if(t instanceof F)e.getRefCells(t,!0).forEach(function(e){var t,a=e.value;if(!(n&o&&e.hidden)){if(e.formula){if(t=e.formula.print(e.row,e.col),/^\s*(?:aggregate|subtotal)\s*\(/i.test(t)&&!(n&s))return;"value"in e.formula&&(a=e.formula.value)}n&r&&a instanceof A||("number"==typeof a||a instanceof A)&&i.push(a)}});else if(Array.isArray(t))for(var l=0;l<t.length;++l)a(t[l]);else t instanceof R?t.each(a):"number"==typeof t?i.push(t):t instanceof A&&!(n&r)&&i.push(t)}(t),i}function m(e,t,n,i){var o,r;if(i){for(o=0,r=0;r<=e;++r)o+=W(t,r)*Math.pow(n,r)*Math.pow(1-n,t-r);return o}return W(t,e)*Math.pow(n,e)*Math.pow(1-n,t-e)}function g(e){var t=B(P(e,0,1));return 4==t.day||3==t.day&&S.isLeapYear(e)?53:52}function v(e,t,n){var i=B(e),o=B(t);return n?(31==i.date&&(i.date=30),31==o.date&&(o.date=30)):(1==i.month&&1==o.month&&i.date==z(i.year,1)&&o.date==z(o.year,1)&&(o.date=30),i.date==z(i.year,i.month)?(i.date=30,31==o.date&&(o.date=30)):30==i.date&&31==o.date&&(o.date=30)),360*(o.year-i.year)+30*(o.month-i.month)+(o.date-i.date)}function _(e,t){this.link=e,this.text=t}function b(e){return"number"==typeof e||"boolean"==typeof e||null==e||""===e}function w(e,t){return e===t?0:e<t?-1:1}function y(e,t){return e===t?0:e<t?1:-1}var k,x,C,S,T,D,A,E,I,M,R,F,z,P,B,L,H,N,O,V,U,W,j,q,G;kendo.support.browser.msie&&kendo.support.browser.version<9||(k=kendo.util,x=kendo.spreadsheet,C=x.calc,S=C.runtime,T=S.defineFunction,D=S.defineAlias,A=S.CalcError,E=x.RangeRef,I=x.CellRef,M=x.UnionRef,R=S.Matrix,F=x.Ref,z=S.daysInMonth,P=S.packDate,B=S.unpackDate,L=S.daysInYear,["abs","cos","sin","acos","asin","tan","atan","exp","sqrt"].forEach(function(e){T(e,Math[e]).args([["*n","number"]])}),T("ln",Math.log).args([["*n","number"]]),T("log",function(e,t){return Math.log(e)/Math.log(t)}).args([["*num","number++"],["*base",["or","number++",["null",10]]],["?",["assert","$base != 1","DIV/0"]]]),T("log10",function(e){return Math.log(e)/Math.log(10)}).args([["*num","number++"]]),T("pi",function(){return Math.PI}).args([]),T("sqrtpi",function(e){return Math.sqrt(e*Math.PI)}).args([["*num","number+"]]),T("degrees",function(e){return 180*e/Math.PI%360}).args([["*radians","number"]]),T("radians",function(e){return Math.PI*e/180}).args([["*degrees","number"]]),T("cosh",e).args([["*num","number"]]),T("acosh",function(e){return Math.log(e+Math.sqrt(e-1)*Math.sqrt(e+1))}).args([["*num","number"],["?",["assert","$num >= 1"]]]),T("sinh",t).args([["*num","number"]]),T("asinh",function(e){return Math.log(e+Math.sqrt(e*e+1))}).args([["*num","number"]]),T("sec",function(e){return 1/Math.cos(e)}).args([["*num","number"]]),T("sech",function(t){return 1/e(t)}).args([["*num","number"]]),T("csc",function(e){return 1/Math.sin(e)}).args([["*num","number"]]),T("csch",function(e){return 1/t(e)}).args([["*num","number"]]),T("atan2",function(e,t){return Math.atan(t/e)}).args([["*x","divisor"],["*y","number"]]),T("tanh",n).args([["*num","number"]]),T("atanh",function(e){return Math.log(Math.sqrt(1-e*e)/(1-e))}).args([["*num",["and","number",["(between)",-1,1]]]]),T("cot",function(e){return 1/Math.tan(e)}).args([["*num","divisor"]]),T("coth",function(e){return 1/n(e)}).args([["*num","divisor"]]),T("acot",function(e){return Math.PI/2-Math.atan(e)}).args([["*num","number"]]),T("acoth",function(e){return Math.log((e+1)/(e-1))/2}).args([["*num","number"],["?",["or",["assert","$num < -1"],["assert","$num > 1"]]]]),T("power",function(e,t){return Math.pow(e,t)}).args([["*a","number"],["*b","number"]]),T("mod",function(e,t){return e%t}).args([["*a","number"],["*b","divisor"]]),T("quotient",function(e,t){return Math.floor(e/t)}).args([["*a","number"],["*b","divisor"]]),T("ceiling",function(e,t){return t?t*Math.ceil(e/t):0}).args([["*number","number"],["*significance","number"],["?",["assert","$significance >= 0 || $number < 0"]]]),T("ceiling.precise",function(e,t){return t=Math.abs(t),t?t*Math.ceil(e/t):0}).args([["*number","number"],["*significance",["or","number",["null",1]]]]),D("iso.ceiling","ceiling.precise"),T("ceiling.math",function(e,t,n){return t&&e?(e<0&&(!n&&t<0||n&&t>0)&&(t=-t),t?t*Math.ceil(e/t):0):0}).args([["*number","number"],["*significance",["or","number",["null","$number < 0 ? -1 : 1"]]],["*mode",["or","logical",["null",0]]]]),T("floor",function(e,t){return t?t*Math.floor(e/t):0}).args([["*number","number"],["*significance","number"],["?",["assert","$significance >= 0 || $number < 0"]]]),T("floor.precise",function(e,t){return t=Math.abs(t),t?t*Math.floor(e/t):0}).args([["*number","number"],["*significance",["or","number",["null",1]]]]),T("floor.math",function(e,t,n){return t&&e?(e<0&&(!n&&t<0||n&&t>0)&&(t=-t),t?t*Math.floor(e/t):0):0}).args([["*number","number"],["*significance",["or","number",["null","$number < 0 ? -1 : 1"]]],["*mode",["or","logical",["null",0]]]]),T("int",Math.floor).args([["*number","number"]]),T("mround",function(e,t){return t?t*Math.round(e/t):0}).args([["*number","number"],["*multiple","number"]]),T("round",function(e,t){var n=e<0?-1:1;return n<0&&(e=-e),t=Math.pow(10,t),e*=t,e=Math.round(e),n*e/t}).args([["*number","number"],["*digits","number"]]),T("roundup",function(e,t){return t=Math.pow(10,t),e*=t,e=e<0?Math.floor(e):Math.ceil(e),e/t}).args([["*number","number"],["*digits","number"]]),T("rounddown",function(e,t){return t=Math.pow(10,t),e*=t,e=e<0?Math.ceil(e):Math.floor(e),e/t}).args([["*number","number"],["*digits","number"]]),T("even",function(e){var t=e<0?Math.floor(e):Math.ceil(e);return t%2?t+(t<0?-1:1):t}).args([["*number","number"]]),T("odd",function(e){var t=e<0?Math.floor(e):Math.ceil(e);return t%2?t:t+(t<0?-1:1)}).args([["*number","number"]]),T("sign",function(e){return e<0?-1:e>0?1:0}).args([["*number","number"]]),T("gcd",function(e){var t,n=e[0];for(t=1;t<e.length;++t)n=i(n,e[t]);return n}).args([["numbers",["collect","number"]]]),T("lcm",function(e){var t,n=e[0];for(t=1;t<e.length;++t)n=o(n,e[t]);return n}).args([["numbers",["collect","number"]]]),T("sum",function(e){return e.reduce(function(e,t){return e+t},0)}).args([["numbers",["collect","number"]]]),T("product",function(e){return e.reduce(function(e,t){return e*t},1)}).args([["numbers",["collect","number"]]]),T("sumproduct",function(e,t){var n=0;return e.each(function(e,i,o){var r,s;if("number"==typeof e){for(r=0;r<t.length;++r){if(s=t[r].get(i,o),"number"!=typeof s)return;e*=s}n+=e}}),n}).args([["a1","matrix"],["+",["a2",["and","matrix",["assert","$a2.width == $a1.width"],["assert","$a2.height == $a1.height"]]]]]),T("sumsq",function(e){return e.reduce(function(e,t){return e+t*t},0)}).args([["numbers",["collect","number"]]]),T("sumx2my2",function(e,t){var n=0;return e.each(function(e,i,o){var r=t.get(i,o);"number"==typeof e&&"number"==typeof r&&(n+=e*e-r*r)}),n}).args([["a","matrix"],["b",["and","matrix",["assert","$b.width == $a.width"],["assert","$b.height == $a.height"]]]]),T("sumx2py2",function(e,t){var n=0;return e.each(function(e,i,o){var r=t.get(i,o);"number"==typeof e&&"number"==typeof r&&(n+=e*e+r*r)}),n}).args([["a","matrix"],["b",["and","matrix",["assert","$b.width == $a.width"],["assert","$b.height == $a.height"]]]]),T("sumxmy2",function(e,t){var n=0;return e.each(function(e,i,o){var r=t.get(i,o);"number"==typeof e&&"number"==typeof r&&(n+=(e-r)*(e-r))}),n}).args([["a","matrix"],["b",["and","matrix",["assert","$b.width == $a.width"],["assert","$b.height == $a.height"]]]]),T("seriessum",function(e,t,n,i){var o=0;return i.each(function(i){if("number"!=typeof i)throw new A("VALUE");o+=i*Math.pow(e,t),t+=n}),o}).args([["x","number"],["y","number"],["m","number"],["a","matrix"]]),T("min",function(e){return e.length?Math.min.apply(Math,e):0}).args([["numbers",["collect","number"]]]),T("max",function(e){return e.length?Math.max.apply(Math,e):0}).args([["numbers",["collect","number"]]]),T("counta",function(e){return e.length}).args([["values",["#collect","anyvalue"]]]),T("count",function(e){return e.length}).args([["numbers",["#collect","number"]]]),T("countunique",function(e){var t=0,n=[];return e.forEach(function(e){n.indexOf(e)<0&&(t++,n.push(e))}),t}).args([["values",["#collect","anyvalue"]]]),T("countblank",function(e){function t(e){null!=e&&""!==e||i++}function n(e){var n,i;for(n=0;n<e.length;++n)i=e[n],i instanceof R?i.each(t,!0):t(i)}var i=0;return n(e),i}).args([["+",["args",["or","matrix","anyvalue"]]]]),T("iseven",function(e){return e%2===0}).args([["*number","number"]]),T("isodd",function(e){return e%2!==0}).args([["*number","number"]]),T("n",function(e){return"boolean"==typeof e?e?1:0:"number"==typeof e?e:0}).args([["*value","anyvalue"]]),T("na",function(){return new A("N/A")}).args([]),H=[["m1","matrix"],["c1","anyvalue"],[["m2","matrix"],["c2","anyvalue"]]],T("countifs",function(e,t,n){var i=0;return n.unshift(e,t),r(n,function(){i++}),i}).args(H),N=[["range","matrix"]].concat(H),T("sumifs",function(e,t,n,i){i.unshift(e,b,t,n);var o=0;return r(i,function(t,n){var i=e.get(t,n);i&&(o+=i)}),o}).args(N),T("averageifs",function(e,t,n,i){i.unshift(e,b,t,n);var o=0,s=0;return r(i,function(t,n){var i=e.get(t,n);null!=i&&""!==i||(i=0),o+=i,s++}),s?o/s:new A("DIV/0")}).args(N),T("countif",function(e,t){t=G(t);var n=0;return e.each(function(e){t(e)&&n++}),n}).args([["range","matrix"],["*criteria","anyvalue"]]),O=[["range","matrix"],["*criteria","anyvalue"],["sumRange",["or",["and","matrix",["assert","$sumRange.width == $range.width"],["assert","$sumRange.height == $range.height"]],["null","$range"]]]],T("sumif",function(e,t,n){var i=0;return t=G(t),e.each(function(e,o,r){if(t(e)){var s=n.get(o,r);b(s)&&(i+=s||0)}}),i}).args(O),T("averageif",function(e,t,n){var i=0,o=0;return t=G(t),e.each(function(e,r,s){if(t(e)){var a=n.get(r,s);b(a)&&(i+=a||0,o++)}}),o?i/o:new A("DIV/0")}).args(O),function(e){e("large",function(e,t){return e.sort(y)[t]}),e("small",function(e,t){return e.sort(w)[t]})}(function(e,t){T(e,function(e,n){var i=[],o=e.each(function(e){return e instanceof A?e:void("number"==typeof e&&i.push(e))});return o?o:n>i.length?new A("NUM"):t(i,n-1)}).args([["array","matrix"],["*nth","number++"]])}),T("stdev.s",function(e){return l(e,e.length-1)}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length >= 2","NUM"]]]),T("stdev.p",function(e){return l(e,e.length)}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length >= 2","NUM"]]]),T("var.s",function(e){return a(e,e.length-1)}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length >= 2","NUM"]]]),T("var.p",function(e){return a(e,e.length)}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length >= 2","NUM"]]]),T("median",function(e){var t=e.length;return e.sort(w),t%2?e[t>>1]:(e[t>>1]+e[t>>2])/2}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length > 0","N/A"]]]),T("mode.sngl",function(e){var t,n,i,o,r,s;for(e.sort(w),t=null,n=0,i=1,o=null,r=0;r<e.length;++r)s=e[r],s!=t?(n=1,t=s):n++,n>i&&(i=n,o=s);return null==o?new A("N/A"):o}).args([["numbers",["collect","number"]]]),T("mode.mult",function(e){var t,n=Object.create(null),i=2,o=[];return e.forEach(function(e){var t=n[e]||0;n[e]=++t,t==i?o.push(e):t>i&&(i=t,o=[e])}),t=new R(this),o.forEach(function(e,n){t.set(n,0,e)}),t}).args([["numbers",["collect","number"]]]),T("geomean",function(e){var t=e.length,n=e.reduce(function(e,t){if(t<0)throw new A("NUM");return e*t},1);return Math.pow(n,1/t)}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length > 0","NUM"]]]),T("harmean",function(e){var t=e.length,n=e.reduce(function(e,t){if(!t)throw new A("DIV/0");return e+1/t},0);return t/n}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length > 0","NUM"]]]),T("trimmean",function(e,t){var n,i,o,r=e.length;for(e.sort(w),n=Math.floor(r*t),n%2&&--n,n/=2,i=0,o=n;o<r-n;++o)i+=e[o];return i/(r-2*n)}).args([["numbers",["collect","number",1]],["percent",["and","number",["[between)",0,1]]],["?",["assert","$numbers.length > 0","NUM"]]]),T("frequency",function(e,t){function n(t){for(var n=0;o<e.length&&e[o]>i&&e[o]<=t;)++n,++o;return n}var i,o,r;return e.sort(w),t.sort(w),i=-(1/0),o=0,r=new R(this),t.forEach(function(e,t){var o=n(e);i=e,r.set(t,0,o)}),r.set(r.height,0,e.length-o),r}).args([["data",["collect","number",1]],["bins",["collect","number",1]]]),T("rank.eq",function(e,t,n){t.sort(n?w:y);var i=t.indexOf(e);return i<0?new A("N/A"):i+1}).args([["value","number"],["numbers",["collect","number"]],["order",["or","logical",["null",!1]]]]),D("rank","rank.eq"),T("rank.avg",function(e,t,n){var i,o;if(t.sort(n?w:y),i=t.indexOf(e),i<0)return new A("N/A");for(o=i;t[o]==e;++o);return(i+o+1)/2}).args([["value","number"],["numbers",["collect","number"]],["order",["or","logical",["null",!1]]]]),T("kurt",function(e){var t=e.length,n=s(e),i=a(e,t-1,n),o=Math.sqrt(i),r=e.reduce(function(e,t){return e+Math.pow((t-n)/o,4)},0);return t*(t+1)/((t-1)*(t-2)*(t-3))*r-3*Math.pow(t-1,2)/((t-2)*(t-3))}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length >= 4","NUM"]]]),V=[["array",["collect","number",1]],["x","number"],["significance",["or",["null",3],"integer++"]],["?",["assert","$array.length > 0","NUM"]]],T("percentrank.inc",function(e,t,n){var i=c(e,t,0);return i=i.toFixed(n+1),parseFloat(i.substr(0,i.length-1))}).args(V),T("percentrank.exc",function(e,t,n){var i=c(e,t,1);return i=i.toFixed(n+1),parseFloat(i.substr(0,i.length-1))}).args(V),D("percentrank","percentrank.inc"),T("covariance.p",function(e,t){return d(e,t,e.length)}).args([["array1",["collect","number",1]],["array2",["collect","number",1]],["?",["assert","$array1.length == $array2.length","N/A"]],["?",["assert","$array1.length > 0","DIV/0"]]]),T("covariance.s",function(e,t){return d(e,t,e.length-1)}).args([["array1",["collect","number",1]],["array2",["collect","number",1]],["?",["assert","$array1.length == $array2.length","N/A"]],["?",["assert","$array1.length > 1","DIV/0"]]]),D("covar","covariance.p"),U=k.memoize(function(e){for(var t=2,n=1;t<=e;++t)n*=t;return n}),T("fact",U).args([["*n","integer+"]]),T("factdouble",function(e){for(var t=2+(1&e),n=1;t<=e;t+=2)n*=t;return n}).args([["*n","integer+"]]),T("multinomial",function(e){var t=1,n=0;return e.forEach(function(e){if(e<0)throw new A("NUM");n+=e,t*=U(e)}),U(n)/t}).args([["numbers",["collect","number"]]]),W=k.memoize(function(e,t){for(var n=t+1,i=1,o=1,r=1;i<=e-t;++n,++i)o*=n,r*=i;return o/r}),T("combin",W).args([["*n","integer++"],["*k",["and","integer",["[between]",0,"$n"]]]]),T("combina",function(e,t){return W(e+t-1,e-1)}).args([["*n","integer++"],["*k",["and","integer",["[between]",1,"$n"]]]]),T("average",function(e){var t=e.reduce(function(e,t){return e+t},0);return t/e.length}).args([["numbers",["collect",["and","number",["not","boolean"]]]],["?",["assert","$numbers.length > 0","DIV/0"]]]),T("averagea",function(e){var t=0,n=0;return e.forEach(function(e){"string"!=typeof e&&(t+=e),++n}),n?t/n:new A("DIV/0")}).args([["values",["collect","anyvalue"]]]),T("percentile.inc",h).args([["numbers",["collect","number",1]],["p",["and","number",["[between]",0,1]]]]),T("percentile.exc",f).args([["numbers",["collect","number",1]],["p",["and","number",["(between)",0,1]]]]),T("quartile.inc",function(e,t){return h(e,t/4)}).args([["numbers",["collect","number",1]],["quarter",["values",0,1,2,3,4]]]),T("quartile.exc",function(e,t){return f(e,t/4)}).args([["numbers",["collect","number",1]],["quarter",["values",0,1,2,3,4]]]),D("quartile","quartile.inc"),D("percentile","percentile.inc"),j=["AVERAGE","COUNT","COUNTA","MAX","MIN","PRODUCT","STDEV.S","STDEV.P","SUM","VAR.S","VAR.P","MEDIAN","MODE.SNGL","LARGE","SMALL","PERCENTILE.INC","QUARTILE.INC","PERCENTILE.EXC","QUARTILE.EXC"],T("aggregate",function(e,t,n,i){var o=this;o.resolveCells(i,function(){var r,s;if(t>12){if(r=p(o,i[0],n),s=i[1],s instanceof I&&(s=o.getRefData(s)),"number"!=typeof s)return e(new A("VALUE"))}else r=p(o,i,n);o.func(j[t-1],e,r)})}).argsAsync([["funcId",["values",1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19]],["options",["or",["null",0],["values",0,1,2,3,4,5,6,7]]],["args","rest"]]),T("subtotal",function(e,t){var n,i,o=this,r=t>100;for(r&&(t-=100),n=[],i=2;i<arguments.length;++i)n.push(arguments[i]);o.resolveCells(n,function(){var i=p(o,n,r?1:0);o.func(j[t-1],e,i)})}).argsAsync([["funcId",["values",1,2,3,4,5,6,7,8,9,10,11,101,102,103,104,105,106,107,108,109,110,111]],["+",["ref",["or","ref","#matrix"]]]]),T("avedev",function(e){var t=e.reduce(function(e,t){return e+t},0)/e.length;return e.reduce(function(e,n){return e+Math.abs(n-t)},0)/e.length}).args([["numbers",["collect","number"]],["?",["assert","$numbers.length >= 2","NUM"]]]),T("binom.dist",m).args([["successes","integer+"],["trials",["and","integer",["assert","$trials >= $successes"]]],["probability",["and","number",["[between]",0,1]]],["cumulative","logical"]]),D("binomdist","binom.dist"),T("binom.inv",function(e,t,n){for(var i=0;i<=e;++i)if(m(i,e,t,!0)>=n)return i;return new A("N/A")}).args([["trials","integer+"],["probability",["and","number",["[between]",0,1]]],["alpha",["and","number",["[between]",0,1]]]]),D("critbinom","binom.inv"),T("binom.dist.range",function(e,t,n,i){var o,r=0;for(o=n;o<=i;++o)r+=W(e,o)*Math.pow(t,o)*Math.pow(1-t,e-o);return r}).args([["trials","integer+"],["probability",["and","number",["[between]",0,1]]],["successes_min",["and","integer",["[between]",0,"$trials"]]],["successes_max",["or",["and","integer",["[between]","$successes_min","$trials"]],["null","$successes_min"]]]]),T("negbinom.dist",function(e,t,n,i){if(i){for(var o=0;e>=0;)o+=W(e+t-1,e)*Math.pow(n,t)*Math.pow(1-n,e),e--;return o}return W(e+t-1,e)*Math.pow(n,t)*Math.pow(1-n,e)}).args([["number_f","integer+"],["number_s","integer+"],["probability_s",["and","number",["[between]",0,1]]],["cumulative","logical"]]),D("negbinomdist","negbinom.dist"),T("address",function(e,t,n,i,o){var r=new I(e-1,t-1,n-1);return o&&r.setSheet(o,!0),i?r.print(0,0):r.print()}).args([["row","integer++"],["col","integer++"],["abs",["or",["null",1],["values",1,2,3,4]]],["a1",["or",["null",!0],"logical"]],["sheet",["or","null","string"]]]),T("areas",function(e){var t=0;return function n(e){e instanceof I||e instanceof E?t++:e instanceof M&&e.refs.forEach(n)}(e),t}).args([["ref","ref"]]),T("choose",function(e,t){return e>t.length?new A("N/A"):t[e-1]}).args([["*index","integer"],["+",["value","anything"]]]),T("column",function(e){return e?e instanceof I?e.col+1:this.asMatrix(e).mapCol(function(t){return t+e.topLeft.col+1}):this.formula.col+1}).args([["ref",["or","area","null"]]]),T("columns",function(e){return e instanceof F?e.width():e.width}).args([["ref",["or","area","#matrix"]]]),T("formulatext",function(e){var t=this.getRefCells(e)[0];return t.formula?t.formula.print(t.row,t.col):new A("N/A")}).args([["ref","ref"]]),T("hlookup",function(e,t,n,i){var o=null;return t.eachCol(function(n){var r=t.get(0,n);if(i){if(r>e)return!0;o=n}else if(r===e)return o=n,!0}),null==o?new A("N/A"):t.get(n-1,o)}).args([["value","anyvalue"],["range","matrix"],["row","integer++"],["approx",["or","logical",["null",!0]]]]),T("index",function(e,t,n,i,o){var r,s,a,l=this;if(t instanceof M&&(t=t.refs[o-1]),!n&&!i||!t)return e(new A("N/A"));if(t instanceof I&&(t=t.toRangeRef()),t instanceof E){if(n&&i)return i>t.width()||n>t.height()?e(new A("REF")):(r=t.toCell(n-1,i-1),void l.resolveCells([r],function(){e(l.getRefData(r))}));if(!n)return s=t.toColumn(i-1),void l.resolveCells([s],function(){e(l.asMatrix(s))});if(!i)return a=t.toRow(n-1),void l.resolveCells([a],function(){e(l.asMatrix(a))})}else if(t instanceof R){if(t.width>1&&t.height>1){if(n&&i)return e(t.get(n-1,i-1));if(!n)return e(t.mapRow(function(e){return t.get(e,i-1)}));if(!i)return e(t.mapCol(function(e){return t.get(n-1,e)}))}if(1==t.width)return e(t.get(n-1,0));if(1==t.height)return e(t.get(0,i-1))}else e(new A("REF"))}).argsAsync([["range",["or","ref","matrix"]],["row",["or","integer+","null"]],["col",["or","integer+","null"]],["areanum",["or","integer++",["null",1]]]]),T("indirect",function(e){var t,n;try{if(t=this.formula,n=C.parseFormula(t.sheet,t.row,t.col,e),!(n.ast instanceof F))throw 1;return n.ast.absolute(t.row,t.col)}catch(i){return new A("REF")}}).args([["thing","string"]]),T("match",function(e,t,n){var i,o=1;return 0===n?i=G(e):n===-1?i=G("<="+e):1===n&&(i=G(">="+e)),t.each(function(t){return null!=t&&i(t)?(0!==n&&e!=t&&--o,!0):void o++},!0)&&o>0?o:new A("N/A")}).args([["value","anyvalue"],["range","matrix"],["type",["or",["values",-1,0,1],["null",1]]]]),T("offset",function(e,t,n,i,o){var r=(e instanceof I?e:e.topLeft).clone();return r.row+=t,r.col+=n,r.row<0||r.col<0?new A("VALUE"):i>1||o>1?new E(r,new I(r.row+i-1,r.col+o-1)).setSheet(e.sheet,e.hasSheet()):r}).args([["ref","area"],["*rows","integer"],["*cols","integer"],["*height",["or","integer++",["null","$ref.height()"]]],["*width",["or","integer++",["null","$ref.width()"]]]]),T("row",function(e){return e?e instanceof I?e.row+1:this.asMatrix(e).mapRow(function(t){return t+e.topLeft.row+1}):this.formula.row+1}).args([["ref",["or","area","null"]]]),T("rows",function(e){return e instanceof F?e.height():e.height}).args([["ref",["or","area","#matrix"]]]),T("vlookup",function(e,t,n,i){var o=null;return"number"!=typeof e&&(i=!1),"string"==typeof e&&(e=e.toLowerCase()),t.eachRow(function(n){var r=t.get(n,0);if(i){if(r>e)return!0;o=n}else if("string"==typeof r&&(r=r.toLowerCase()),r===e)return o=n,!0}),null==o?new A("N/A"):t.get(o,n-1)}).args([["value","anyvalue"],["range","matrix"],["col","integer++"],["approx",["or","logical",["null",!0]]]]),T("date",function(e,t,n){return P(e,t-1,n)}).args([["*year","integer"],["*month","integer"],["*date","integer"]]),T("day",function(e){return B(e).date}).args([["*date","date"]]),T("month",function(e){return B(e).month+1}).args([["*date","date"]]),T("year",function(e){return B(e).year}).args([["*date","date"]]),T("weekday",function(e){return B(e).day+1}).args([["*date","date"]]),T("weeknum",function(e,t){var n,i=P(B(e).year,0,1),o=B(i);return 21==t?(n=3-(o.day+6)%7,n<0&&(n+=7),i+=n,o.date+=n,o.day=4,t=1):t=1==t?0:2==t?1:(t-10)%7,n=o.day-t,n<0&&(n+=7),i-=n,Math.ceil((e+1-i)/7)}).args([["*date","date"],["*type",["or",["null",1],["values",1,2,11,12,13,14,15,16,17,21]]]]),T("isoweeknum",function(e){var t=B(e),n=t.day||7,i=Math.floor((t.ord-n+10)/7);return i<1?g(t.year-1):53==i&&i>g(t.year)?1:i}).args([["*date","date"]]),T("now",function(){return S.dateToSerial(new Date)}).args([]),T("today",function(){return 0|S.dateToSerial(new Date)}).args([]),T("time",function(e,t,n){return S.packTime(e,t,n,0)}).args([["*hours","integer"],["*minutes","integer"],["*seconds","integer"]]),T("hour",function(e){return S.unpackTime(e).hours}).args([["*time","datetime"]]),T("minute",function(e){return S.unpackTime(e).minutes}).args([["*time","datetime"]]),T("second",function(e){return S.unpackTime(e).seconds}).args([["*time","datetime"]]),T("edate",function(e,t){var n=B(e),i=n.month+t,o=n.year+Math.floor(i/12);return i%=12,i<0&&(i+=12),n=Math.min(n.date,z(o,i)),P(o,i,n)}).args([["*start_date","date"],["*months","integer"]]),T("eomonth",function(e,t){var n=B(e),i=n.month+t,o=n.year+Math.floor(i/12);return i%=12,i<0&&(i+=12),n=z(o,i),P(o,i,n)}).args([["*start_date","date"],["*months","integer"]]),T("workday",function(e,t,n){var i,o=t>0?1:-1;for(t=Math.abs(t),i=B(e).day;t>0;)e+=o,i=(i+o)%7,i>0&&i<6&&n.indexOf(e)<0&&--t;return e}).args([["start_date","date"],["days","integer"],["holidays",["collect","date"]]]),T("networkdays",function(e,t,n){var i,o,r;for(e>t&&(i=e,e=t,t=i),o=0,r=B(e).day;e<=t;)r>0&&r<6&&n.indexOf(e)<0&&o++,e++,r=(r+1)%7;return o}).args([["start_date","date"],["end_date","date"],["holidays",["collect","date"]]]),T("days",function(e,t){return t-e}).args([["*start_date","date"],["*end_date","date"]]),S._days_360=v,T("days360",v).args([["*start_date","date"],["*end_date","date"],["*method",["or","logical",["null",!1]]]]),T("yearfrac",function(e,t,n){switch(n){case 0:return v(e,t,!1)/360;case 1:return(t-e)/L(B(e).year);case 2:return(t-e)/360;case 3:return(t-e)/365;case 4:return v(e,t,!0)/360}}).args([["*start_date","date"],["*end_date","date"],["*method",["or",["null",0],["values",0,1,2,3,4]]]]),T("datevalue",function(e){var t=S.parseDate(e);return t?S.dateToSerial(t):new A("VALUE")}).args([["*text","string"]]),T("timevalue",function(e){var t,n,i,o,r=e.toLowerCase().match(/(\d+):(\d+)(:(\d+)(\.(\d+))?)?\s*(am?|pm?)?/);return r?(t=parseFloat(r[1]),n=parseFloat(r[2]),i=r[3]?parseFloat(r[4]):0,o=r[7],o&&(t>12||t<1)?new A("VALUE"):(/^p/.test(o)&&(t+=12),S.packTime(t,n,i,0))):new A("VALUE")}).args([["*text","string"]]),T("mdeterm",function(e){var t=e.each(function(e){if("number"!=typeof e)return new A("VALUE")},!0);return t||e.determinant()}).args([["m",["and","matrix",["assert","$m.width == $m.height"]]]]),T("transpose",function(e){return e.transpose()}).args([["range","matrix"]]),T("mmult",function(e,t){return e.multiply(t)}).args([["a","matrix"],["b",["and","matrix",["assert","$b.height == $a.width"]]]]),T("munit",function(e){return new R(this).unit(e)}).args([["n","integer+"]]),T("minverse",function(e){var t=e.each(function(e){if("number"!=typeof e)return new A("VALUE")},!0);return t||e.inverse()||new A("VALUE")}).args([["m",["and","matrix",["assert","$m.width == $m.height"]]]]),T("rand",function(){return Math.random()}).args([]),T("randbetween",function(e,t){return e+Math.floor((t-e+1)*Math.random())}).args([["min","integer"],["max",["and","integer",["assert","$max >= $min"]]]]),T("true",function(){return!0}).args([]),T("false",function(){return!0}).args([]),T("roman",function(e){return k.arabicToRoman(e).toUpperCase()}).args([["*number","integer"]]),T("arabic",function(e){var t=k.romanToArabic(e);return null==t?new A("VALUE"):t}).args([["*roman","string"]]),T("base",function(e,t,n){for(var i=e.toString(t).toUpperCase();i.length<n;)i="0"+i;return i}).args([["*number","integer"],["*radix",["and","integer",["[between]",2,36]]],["*minLen",["or","integer+",["null",0]]]]),T("decimal",function(e,t){var n,i,o;for(e=e.toUpperCase(),n=0,i=0;i<e.length;++i){if(o=e.charCodeAt(i),o>=48&&o<=57)o-=48;else{if(!(o>=65&&o<55+t))return new A("VALUE");o-=55}n=n*t+o}return n}).args([["*text","string"],["*radix",["and","integer",["[between]",2,36]]]]),T("char",function(e){return String.fromCharCode(e)}).args([["*code","integer+"]]),q=/[\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g,
T("clean",function(e){return e.replace(q,"")}).args([["*text","string"]]),T("code",function(e){return e.charAt(0)}).args([["*text","string"]]),D("unichar","char"),D("unicode","code"),T("concatenate",function(e){var t,n="";for(t=0;t<e.length;++t)n+=e[t];return n}).args([["+",["*text","string"]]]),T("dollar",function(e,t){for(var n="$#,##0.DECIMALS;($#,##0.DECIMALS)",i="";t-- >0;)i+="0";return n=n.replace(/DECIMALS/g,i),x.formatting.text(e,n)}).args([["*number","number"],["*decimals",["or","integer++",["null",2]]]]),T("exact",function(e,t){return e===t}).args([["*text1","string"],["*text2","string"]]),T("find",function(e,t,n){var i=t.indexOf(e,n-1);return i<0?new A("VALUE"):i+1}).args([["*substring","string"],["*string","string"],["*start",["or","integer++",["null",1]]]]),T("fixed",function(e,t,n){var i,o=Math.pow(10,t);if(e=Math.round(e*o)/o,i=n?"0":"#,##0",t>0)for(i+=".";t-- >0;)i+="0";return x.formatting.text(e,i)}).args([["*number","number"],["*decimals",["or","integer",["null",2]]],["*noCommas",["or","boolean",["null",!1]]]]),T("left",function(e,t){return e.substr(0,t)}).args([["*text","string"],["*length",["or","integer+",["null",1]]]]),T("right",function(e,t){return e.substr(-t)}).args([["*text","string"],["*length",["or","integer+",["null",1]]]]),T("len",function(e){return e.length}).args([["*text","string"]]),T("lower",function(e){return e.toLowerCase()}).args([["*text","string"]]),T("upper",function(e){return e.toUpperCase()}).args([["*text","string"]]),T("ltrim",function(e){return e.replace(/^\s+/,"")}).args([["*text","string"]]),T("rtrim",function(e){return e.replace(/\s+$/,"")}).args([["*text","string"]]),T("trim",function(e){return e.replace(/^\s+|\s+$/,"")}).args([["*text","string"]]),T("mid",function(e,t,n){return e.substr(t-1,n)}).args([["*text","string"],["*start","integer++"],["*length","integer+"]]),T("proper",function(e){return e.toLowerCase().replace(/\b./g,function(e){return e.toUpperCase()})}).args([["*text","string"]]),T("replace",function(e,t,n,i){return e.substr(0,--t)+i+e.substr(t+n)}).args([["*text","string"],["*start","integer++"],["*length","integer+"],["*newText","string"]]),T("rept",function(e,t){for(var n="";t-- >0;)n+=e;return n}).args([["*text","string"],["*number","integer+"]]),T("search",function(e,t,n){var i=t.toLowerCase().indexOf(e.toLowerCase(),n-1);return i<0?new A("VALUE"):i+1}).args([["*substring","string"],["*string","string"],["*start",["or","integer++",["null",1]]]]),T("substitute",function(e,t,n,i){function o(){e=e.substring(0,r)+n+e.substring(r+t.length)}if(t===n)return e;for(var r=-1;(r=e.indexOf(t,r+1))>=0;)if(null==i)o();else if(0===--i){o();break}return e}).args([["*text","string"],["*oldText","string"],["*newText","string"],["*nth",["or","integer++","null"]]]),T("t",function(e){return"string"==typeof e?e:""}).args([["*value","anyvalue"]]),T("text",function(e,t){return x.formatting.text(e,t)}).args([["*value","anyvalue"],["*format","string"]]),T("value",function(e){return"number"==typeof e?e:"boolean"==typeof e?+e:(e=(e+"").replace(/[$€,]/g,""),e=parseFloat(e),isNaN(e)?new A("VALUE"):e)}).args([["*value","anyvalue"]]),_.prototype.toString=function(){return this.text},T("hyperlink",function(e,t){return new _(e,t)}).args([["*link","string"],["*text",["or","string",["null","$link"]]]]),T("iferror",function(e,t){return e instanceof A?t:e}).args([["*value","forced!"],["*value_if_error","anyvalue!"]]),G=function(){function e(e,t){if("string"==typeof t){var n=parseFloat(t);isNaN(n)||n!=t||(t=n)}return function(n){var i=t;return"string"==typeof n&&"string"==typeof i&&(n=n.toLowerCase(),i=i.toLowerCase()),e(n,i)}}function t(e){var t,n;return"string"==typeof e&&(e=e.toLowerCase()),/^[0-9.]+%$/.test(e)?(n=e.substr(0,e.length-1),t=parseFloat(n),isNaN(t)||t!=n||(e=t/100)):/^[0-9.]+$/.test(e)&&(t=parseFloat(e),isNaN(t)||t!=e||(e=t)),e}function n(e,n){return t(e)<t(n)}function i(e,n){return t(e)<=t(n)}function o(e,n){return t(e)>t(n)}function r(e,n){return t(e)>=t(n)}function s(e,t){return!a(e,t)}function a(e,n){return n instanceof RegExp?n.test(e):("string"!=typeof e&&"string"!=typeof n||(e+="",n+=""),t(e)==t(n))}var l=Object.create(null);return function(t){var c,d;return"function"==typeof t?t:(c=/^=(.*)$/.exec(t))?e(a,c[1]):(c=/^<>(.*)$/.exec(t))?e(s,c[1]):(c=/^<=(.*)$/.exec(t))?e(i,c[1]):(c=/^<(.*)$/.exec(t))?e(n,c[1]):(c=/^>=(.*)$/.exec(t))?e(r,c[1]):(c=/^>(.*)$/.exec(t))?e(o,c[1]):/[?*]/.exec(t)?(d=l[t],d||(d=t.replace(/(~\?|~\*|[\]({\+\.\|\^\$\\})\[]|[?*])/g,function(e){switch(e){case"~?":return"\\?";case"~*":return"\\*";case"?":return".";case"*":return".*";default:return"\\"+e}}),d=l[t]=RegExp("^"+d+"$","i")),e(a,d)):e(a,t)}}())},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/runtime.functions.2.min",["spreadsheet/runtime.min"],e)}(function(){"use strict";function e(e){var n,i,o,r;if(ct(e)>=3.3)return 1-t(e);for(n=e>0?1:-1,n==-1&&(e=-e),i=0,o=1,r=1;r<100;r++)i+=o,o*=2*e*e/(2*r+1);return 2*n/Math.sqrt(Math.PI)*e*Math.exp(-e*e)*i}function t(t){var n,i,o;if(ct(t)<3.3)return 1-e(t);for(n=1,t<0&&(n=-1,t=-t),i=t,o=8;o>=1;o-=.5)i=t+o/i;return i=1/(t+i),1==n?Math.exp(-t*t)/Math.sqrt(Math.PI)*i:2-Math.exp(-t*t)/Math.sqrt(Math.PI)*i}function n(e){var t,n=[1.000000000190015,76.18009172947146,-86.50532032941678,24.01409824083091,-1.231739572450155,.001208650973866179,-5395239384953e-18],i=e,o=e+5.5,r=n[0];for(o-=(e+.5)*Math.log(o),t=1;t<=6;t++)i+=1,r+=n[t]/i;return-o+Math.log(Math.sqrt(2*Math.PI)*r/e)}function i(e){if(e>0)return Math.exp(n(e));var t=Math.PI,o=-e;return-t/(o*i(o)*Math.sin(t*o))}function o(e,t){return n(e)+n(t)-n(e+t)}function r(e,t){return Math.exp(o(e,t))}function s(e,t){return t<e+1?a(e,t):1-l(e,t)}function a(e,t){var i,o=1/e,r=o,s=e,a=n(e);for(i=1;i<=st&&(s++,r*=t/s,o+=r,!(ct(r)<ct(o)*at));i++);return o*Math.exp(-t+e*Math.log(t)-a)}function l(e,t){var i,o,r=lt,s=r,a=0,l=1,c=t+1-e,d=n(e);for(i=1;i<=st&&(a=c+l*a,ct(a)<lt&&(a=lt),s=c+l/s,ct(s)<lt&&(s=lt),a=1/a,o=s*a,r*=o,!(ct(o-1)<at));i++)c+=2,l=-i*(i-e);return r*Math.exp(-t-d+e*Math.log(t))}function c(e,t,n,o){return o?s(t,e/n):Math.pow(e/n,t-1)*Math.exp(-e/n)/(n*i(t))}function d(e,t,n){var i,o,r,s,a,l;if(0===e)return 0;if(1==e)return 1/0;for(i=0,o=10,r=0,s=t*n,s>1&&(o*=s),a=0;a<st&&(r=.5*(i+o),l=c(r,t,n,!0),!(ct(e-l)<1e-16));a++)l>e?o=r:i=r;return r}function u(t,n){return n?.5+.5*e(t/Math.sqrt(2)):Math.exp(-t*t/2)/Math.sqrt(2*Math.PI)}function h(e){var t,n,i=[-39.69683028665376,220.9460984245205,-275.9285104469687,138.357751867269,-30.66479806614716,2.506628277459239],o=[-54.47609879822406,161.5858368580409,-155.6989798598866,66.80131188771972,-13.28068155288572],r=[-.007784894002430293,-.3223964580411365,-2.400758277161838,-2.549732539343734,4.374664141464968,2.938163982698783],s=[.007784695709041462,.3224671290700398,2.445134137142996,3.754408661907416],a=.02425,l=1-a;return e<a?(t=Math.sqrt(-2*Math.log(e)),(((((r[0]*t+r[1])*t+r[2])*t+r[3])*t+r[4])*t+r[5])/((((s[0]*t+s[1])*t+s[2])*t+s[3])*t+1)):l<e?(t=Math.sqrt(-2*Math.log(1-e)),-(((((r[0]*t+r[1])*t+r[2])*t+r[3])*t+r[4])*t+r[5])/((((s[0]*t+s[1])*t+s[2])*t+s[3])*t+1)):(t=e-.5,n=t*t,(((((i[0]*n+i[1])*n+i[2])*n+i[3])*n+i[4])*n+i[5])*t/(((((o[0]*n+o[1])*n+o[2])*n+o[3])*n+o[4])*n+1))}function f(e,t,n,i){return i?u((e-t)/n,!0):Math.exp(-(e-t)*(e-t)/(2*n*n))/(n*Math.sqrt(2*Math.PI))}function p(e,t,n){return t+n*h(e)}function m(e,t,n){return Math.exp((t-1)*Math.log(e)+(n-1)*Math.log(1-e)-o(t,n))}function g(e,t,n){var i=Math.exp(t*Math.log(e)+n*Math.log(1-e)-o(t,n));return e<(t+1)/(t+n+2)?i*v(t,n,e)/t:1-i*v(n,t,1-e)/n}function v(e,t,n){var i,o,r,s,a,l=e+t,c=e+1,d=e-1,u=1,h=1-l*n/c;for(ct(h)<lt&&(h=lt),h=1/h,a=h,i=1;i<=st&&(o=2*i,r=i*(t-i)*n/((d+o)*(e+o)),h=1+r*h,ct(h)<lt&&(h=lt),u=1+r/u,ct(u)<lt&&(u=lt),h=1/h,a*=h*u,r=-(e+i)*(l+i)*n/((e+o)*(c+o)),h=1+r*h,ct(h)<lt&&(h=lt),u=1+r/u,ct(u)<lt&&(u=lt),h=1/h,s=h*u,a*=s,!(ct(s-1)<at));i++);return a}function _(e,t,n){var i,o,r=0,s=1,a=0;for(i=0;i<st&&(a=.5*(r+s),o=g(a,t,n),!(ct(e-o)<at));i++)o>e?s=a:r=a;return a}function b(e,t,n,i,o){return g((e-i)/(o-i),t,n)}function w(e,t,n,i,o,r){return i?g((e-o)/(r-o),t,n):m((e-o)/(r-o),t,n)/(r-o)}function y(e,t,n,i,o){return i+(o-i)*_(e,t,n)}function k(e,t,n){return c(e,t/2,2,n)}function x(e,t){return 1-k(e,t,!0)}function C(e,t){return d(e,t/2,2)}function S(e,t){return C(1-e,t)}function T(e,t){var n,i,o,r,s,a=e.length,l=e[0].length,c=0;for(n=0;n<a;n++)for(i=0;i<l;i++)o=t[n][i],r=e[n][i]-o,r*=r,c+=r/o;return s=(a-1)*(l-1),x(c,s)}function D(e,t,n){return n?1-Math.exp(-t*e):t*Math.exp(-t*e)}function A(e,t,n){var i,o;if(n)return 1-k(2*t,2*(e+1),!0);for(i=0,o=2;o<=e;o++)i+=Math.log(o);return Math.exp(e*Math.log(t)-t-i)}function E(e,t,n,i){if(i)return g(t*e/(n+t*e),t/2,n/2);var o=t/n;return t/=2,n/=2,o/r(t,n)*Math.pow(o*e,t-1)/Math.pow(1+o*e,t+n)}function I(e,t,n){return 1-E(e,t,n,!0)}function M(e,t,n){return n/t*(1/y(e,n/2,t/2,0,1)-1)}function R(e,t,n){return n/t*(1/y(1-e,n/2,t/2,0,1)-1)}function F(e){var t,n=0,i=e.length;for(t=0;t<i;t++)n+=e[t];return n/i}function z(e,t){var n,i,o=0,r=e.length;for(n=0;n<r;n++)i=e[n]-t,o+=i*i;return o/(r-1)}function P(e,t){var n=e.length-1,i=t.length-1,o=z(e,F(e)),r=z(t,F(t));if(!o||!r)throw new Je("DIV/0");return 2*E(o/r,n,i,!0)}function B(e){return.5*Math.log((1+e)/(1-e))}function L(e){var t=Math.exp(2*e);return(t-1)/(t+1)}function H(e,t,n){return n?1-.5*g(t/(e*e+t),t/2,.5):1/(Math.sqrt(t)*r(.5,t/2))*Math.pow(1+e*e/t,-(t+1)/2)}function N(e,t){return 1-H(e,t,!0)}function O(e,t){return e<0&&(e=-e),2*N(e,t)}function V(e,t){var n=_(2*Math.min(e,1-e),t/2,.5);return n=Math.sqrt(t*(1-n)/n),e>.5?n:-n}function U(e,t){return V(1-e/2,t)}function W(e,t,n,i){var o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w=e.length,y=t.length;if(1==i){for(s=0,a=0,l=0;l<w;l++)c=e[l]-t[l],s+=c,a+=c*c;return d=s/w,o=d/Math.sqrt((a-s*d)/(w*(w-1))),1==n?N(o,w-1):O(o,w-1)}return u=F(e),h=F(t),f=z(e,u),p=z(t,h),3==i?(m=f/w,g=p/y,v=m+g,_=m/v,b=g/v,r=1/(_*_/(w-1)+b*b/(y-1)),o=ct(u-h)/Math.sqrt(v),1==n?N(o,r):O(o,r)):(r=w+y-2,o=ct(u-h)*Math.sqrt(r*w*y/((w+y)*((w-1)*f+(y-1)*p))),1==n?N(o,r):O(o,r))}function j(e,t,n){return-V(e/2,n-1)*t/Math.sqrt(n)}function q(e,t,n){return-h(e/2)*t/Math.sqrt(n)}function G(e){return u(e,!0)-.5}function $(e){return u(e)}function K(t,n,i,o){if(o)return.5+.5*e((Math.log(t)-n)/(i*Math.sqrt(2)));var r=Math.log(t)-n;return Math.exp(-r*r/(2*i*i))/(t*i*Math.sqrt(2*Math.PI))}function Y(e,t,n){return Math.exp(p(e,t,n))}function Q(e,t,n,i){var o,r,s,a=e.length,l=0;for(o=0;o<a;o++){if(t[o]<=0||t[o]>1)throw new Je("NUM");l+=t[o]}if(1!=l)throw new Je("NUM");for(r=0,o=0;o<a;o++)s=e[o],s>=n&&s<=i&&(r+=t[o]);return r}function X(e,t){var n,i,o,r=F(t),s=F(e),a=0,l=0;for(n=0,i=e.length;n<i;n++)o=t[n]-r,a+=o*(e[n]-s),l+=o*o;return a/l}function Z(e,t){var n,i,o,r=F(t),s=F(e),a=0,l=0;for(n=0,i=e.length;n<i;n++)o=t[n]-r,a+=o*(e[n]-s),l+=o*o;return s-a*r/l}function J(e,t){var n,i,o,r,s=F(e),a=F(t),l=0,c=0,d=0;for(n=0,i=e.length;n<i;n++)o=e[n]-s,r=t[n]-a,l+=o*r,c+=o*o,d+=r*r;return l/Math.sqrt(c*d)}function ee(e,t){var n=J(e,t);return n*n}function te(e,t){var n,i,o,r=t.length,s=F(t),a=F(e),l=0,c=0,d=0;for(n=0;n<r;n++)i=t[n]-s,o=e[n]-a,l+=o*o,c+=i*o,d+=i*i;return Math.sqrt((l-c*c/d)/(r-2))}function ne(e,t,n){var i,o,r,s,a,l,c=F(n),d=F(t),u=0,h=0;for(i=0,o=n.length;i<o;i++)r=n[i]-c,s=t[i]-d,u+=r*s,h+=r*r;if(0===h)throw new Je("N/A");return a=u/h,l=d-a*c,l+a*e}function ie(e){var t,n=e.height,i=0;for(t=0;t<n;t++)i+=e.data[t][0];return i/n}function oe(e,t){var n,i,o=e.height,r=0;for(n=0;n<o;n++)i=e.data[n][0]-t,r+=i*i;return r}function re(e,t,n,i){var o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k=0;for(t||(t=e.map(function(){return++k})),n&&(t=t.clone(),t.eachRow(function(e){t.data[e].unshift(1)}),++t.width),o=t.transpose(),r=o.multiply(t).inverse().multiply(o).multiply(e),s=[],k=r.height-1;k>=0;k--)s.push(r.data[k][0]);if(n||s.push(0),!i)return this.asMatrix([s]);for(a=t.multiply(r),l=e.adds(a,!0),c=n?ie(a):0,d=oe(a,c),u=n?ie(l):0,h=oe(l,u),f=[],f.push(d,h),p=d/(d+h),m=e.height-t.width,g=Math.sqrt(h/m),v=[],v.push(p,g),_=n?d/(t.width-1)/(h/m):p/t.width/((1-p)/m),b=[],b.push(_,m),w=o.multiply(t).inverse(),y=[],k=w.height-1;k>=0;k--)y.push(Math.sqrt(w.data[k][k]*h/m));return this.asMatrix([s,y,v,b,f])}function se(e,t,n,i){return re.call(this,e.map(Math.log),t,n,i).map(Math.exp)}function ae(e,t,n,i){var o,r,s=0;return t||(t=e.map(function(){return++s})),i&&(t=t.clone(),t.eachRow(function(e){t.data[e].unshift(1)}),++t.width),o=t.transpose(),r=o.multiply(t).inverse().multiply(o).multiply(e),n?i&&(n=n.clone(),n.eachRow(function(e){n.data[e].unshift(1)}),++n.width):n=t,n.multiply(r)}function le(e,t,n,i){return ae.call(this,e.map(Math.log),t,n,i).map(Math.exp)}function ce(e,t,n,i){var o,r,s,a,l,c=n||20,d=i||1e-7,u=t;for(o=1;o<=c;o++)if(r=e(u),s=r[0],a=r[1],l=s/a,u-=l,Math.abs(l)<d)return u;return new Je("NUM")}function de(e,t,n,i,o){var r=Math.pow(1+e,t),s=e?(r-1)/e:t;return-(i*r+n*s*(1+e*o))}function ue(e,t,n,i,o){if(!e)return-i-n*t;var r=Math.pow(1+e,t);return-(i+n*(r-1)/e*(1+e*o))/r}function he(e,t,n,i,o){if(!e)return-(i+n)/t;var r=Math.pow(1+e,t);return-e*(i+n*r)/((1+e*o)*(r-1))}function fe(e,t,n,i,o){if(!e)return-(i+n)/t;var r=t*(1+e*o);return Math.log((r-i*e)/(r+n*e))/Math.log(1+e)}function pe(e,t,n,i,o,r){function s(r){var s=Math.pow(1+r,e-1),a=s*(1+r);return[n*a+t*(1/r+o)*(a-1)+i,e*n*s+t*(-(a-1)/(r*r)+(1/r+o)*e*s)]}return ce(s,r)}function me(e,t,n,i,o,r){var s,a;return 1==r&&1==t?0:(s=he(e,n,i,o,r),a=de(e,t-1,s,i,r)*e,r?a/(1+e):a)}function ge(e,t,n,i,o,r){var s=he(e,n,i,o,r);return s-me(e,t,n,i,o,r)}function ve(e,t,n,i,o,r){var s,a,l,c,d,u;return 1==r&&(i--,o--),s=Math.pow(1+e,t),a=Math.pow(1+e,i-1),l=Math.pow(1+e,o),c=e*n*s/(s-1),d=a*n-(a-1)/e*c,u=l*n-(l-1)/e*c,u-d}function _e(e,t,n,i,o,r){var s,a=0;for(s=i;s<=o;s++)a+=me(e,s,t,n,0,r);return a}function be(e,t){var n,i,o=0;for(n=0,i=t.length;n<i;n++)o+=t[n]*Math.pow(1+e,-n-1);return o}function we(e,t){function n(t){var n,i,o=0,r=0;for(n=0,i=e.length;n<i;n++)o+=e[n]*Math.pow(1+t,-n-1),r+=-n*e[n]*Math.pow(1+t,-n-2);return[o,r]}return ce(n,t)}function ye(e,t){return Math.pow(1+e/t,t)-1}function ke(e,t){return t*(Math.pow(e+1,1/t)-1)}function xe(e,t,n){var i,o,r=0;for(i=0,o=t.length;i<o;i++)r+=t[i]*Math.pow(1+e,(n[0]-n[i])/365);return r}function Ce(e,t,n){function i(n){var i,o,r,s=e[0],a=0;for(i=1,o=e.length;i<o;i++)r=(t[0]-t[i])/365,s+=e[i]*Math.pow(1+n,r),a+=r*e[i]*Math.pow(1+n,r-1);return[s,a]}return ce(i,n)}function Se(e,t,n,i){var o=-i*e;return o*(1-t/n)}function Te(e,t,n,i,o){var r,s,a=1-Math.pow(t/e,1/n);if(a=Math.floor(1e3*a+.5)/1e3,r=e*a*o/12,1==i)return r;for(s=1;s<n;s++){if(s==i-1)return(e-r)*a;r+=(e-r)*a}return(e-r)*a*(12-o)/12}function De(e,t,n,i,o){var r=o/n,s=-e*(Math.pow(1-r,i-1)-1),a=(e-s)*r;return a=Math.min(a,Math.max(0,e-s-t))}function Ae(e,t,n){return(e-t)/n}function Ee(e,t,n,i){return(e-t)*(n-i+1)*2/(n*(n+1))}function Ie(e,t,n,i,o,r,s){function a(e,n){var i,o,r;return o=1==f?1==n?e:0:e*Math.pow(1-f,n-1),r=e*Math.pow(1-f,n),i=r<t?o-t:o-r,i<0?0:i}function l(e,n,i){var o,r,s,l=e-t,c=Math.ceil(i),d=0,u=0,h=!1;for(r=1;r<=c;r++)h?o=d:(s=a(e,r),d=l/(n-r+1),d>s?(o=d,h=!0):(o=s,l-=s)),r==c&&(o*=i+1-c),u+=o;return u}var c,d,u,h,f=r>=n?1:r/n,p=Math.floor(i),m=Math.ceil(o),g=0;if(s)for(c=p+1;c<=m;c++)d=a(e,c),c==p+1?d*=Math.min(o,p+1)-i:c==m&&(d*=o+1-m),g+=d;else u=n,i!=Math.floor(i)&&r>1&&i>=n/2&&(h=i-n/2,i=n/2,o-=h,u+=1),e-=l(e,u,i),g=l(e,n-i,o-i);return g}function Me(e,t){var n=tt(e),i=n.month+t,o=n.year+Math.floor(i/12);return i%=12,i<0&&(i+=12),n=Math.min(n.date,it(o,i)),et(o,i,n)}function Re(e,t,n){return 1==n||2==n||3==n?t-e:ot(e,t,n)}function Fe(e,t,n){var i,o,r,s=tt(e),a=tt(t),l=a.year-s.year;l>0&&(l=(l-1)*n),r=12/n;do l++,i=Me(t,-l*r);while(e<i);return l--,o=Me(t,-l*r),[i,o]}function ze(e,t,n){var i,o,r,s=tt(t),a=tt(e),l=s.year-a.year;for(l>0&&(l=(l-1)*n),i=e,r=12/n;t>i;)o=i,l++,i=Me(e,l*r);return[o,i]}function Pe(e,t,n,i){var o=Fe(e,t,n)[0];return Re(o,e,i)}function Be(e,t,n,i){if(1==i){var o=Fe(e,t,n);return Re(o[0],o[1],1)}return 3==i?365/n:360/n}function Le(e,t,n,i){var o=Fe(e,t,n)[1];return Re(e,o,i)}function He(e,t,n){return Fe(e,t,n)[0]}function Ne(e,t,n){return Fe(e,t,n)[1]}function Oe(e,t,n){var i=tt(e),o=tt(t),r=12*(o.year-i.year)+o.month-i.month;return 1+(r*n/12|0)}function Ve(e,t){return 3==t?365:1==t?nt(e)?366:365:360}function Ue(e,t,n,i,o){var r=Ve(tt(t).year,o);return n*i*Re(e,t,o)/r}function We(e,t,n,i,o,r,s,a){function l(e,t){return(t-e)*r/v|0}var c,d,u,h,f,p,m=0,g=o*i/r,v=s%2===0?360:365;return n<=t?(c=Fe(n,t,r),d=c[0],u=c[1],d<=e?g*Re(e,n,s)/Re(d,u,s):(c=Fe(e,d,r),h=c[0],f=c[1],p=l(f,n),g*(p+Re(e,f,s)/Re(h,f,s)+(n<u?Re(d,n,s)/Re(d,u,s):0)))):(c=ze(t,n,r),d=c[0],u=c[1],p=l(t,n),m=u==n?g*p:g*(p+Re(d,n,s)/Re(d,u,s)),a?(c=Fe(e,t,r),d=c[0],u=c[1],p=l(e,t),m+=g*(p+Re(e,u,s)/Re(d,u,s))):m)}function je(e,t,n,i,o){var r=o%2===0?360:nt(tt(e).year)?366:365;return(i-n)/i*r/Re(e,t,o)}function qe(e,t,n,i,o){var r=o%2===0?360:nt(tt(e).year)?366:365;return(i-n)/n*r/Re(e,t,o)}function Ge(e,t,n,i,o){var r=o%2===0?360:nt(tt(e).year)?366:365;return n/(1-i*Re(e,t,o)/r)}function $e(e,t,n,i,o,r,s){var a=1+((t-e)*r/(s%2===0?360:365)|0),l=Fe(e,t,r),c=l[0],d=l[1],u=Re(c,e,s),h=Re(e,d,s),f=Re(c,d,s),p=100*n/r,m=i/r,g=h/f;return 1==a?(o+p)/(1+g*m)-u/f*p:o/Math.pow(1+m,a-1+g)+p*Math.pow(1+m,1-a-g)*(Math.pow(1+m,a)-1)/m-u/f*p}function Ke(e,t,n,i,o){var r=Re(e,t,o),s=Ve(tt(t).year,o);return i-n*i*r/s}var Ye,Qe,Xe,Ze,Je,et,tt,nt,it,ot,rt,st,at,lt,ct;kendo.support.browser.msie&&kendo.support.browser.version<9||(Ye=kendo.spreadsheet,Qe=Ye.calc,Xe=Qe.runtime,Ze=Xe.defineFunction,Je=Xe.CalcError,et=Xe.packDate,tt=Xe.unpackDate,nt=Xe.isLeapYear,it=Xe.daysInMonth,ot=Xe._days_360,Ze("ERF",function(t,n){return null==n?e(t):e(n)-e(t)}).args([["lower_limit","number"],["upper_limit",["or","number","null"]]]),Ze("ERFC",t).args([["x","number"]]),Ze("GAMMALN",n).args([["x","number++"]]),Ze("GAMMA",i).args([["x","number"]]),Ze("GAMMA.DIST",c).args([["x","number+"],["alpha","number++"],["beta","number++"],["cumulative","logical"]]),Ze("GAMMA.INV",d).args([["p",["and","number",["[between]",0,1]]],["alpha","number++"],["beta","number++"]]),Ze("NORM.S.DIST",u).args([["z","number"],["cumulative","logical"]]),Ze("NORM.S.INV",h).args([["p",["and","number",["[between]",0,1]]]]),Ze("NORM.DIST",f).args([["x","number"],["mean","number"],["stddev","number++"],["cumulative","logical"]]),Ze("NORM.INV",p).args([["p",["and","number",["[between]",0,1]]],["mean","number"],["stddev","number++"]]),Ze("BETADIST",b).args([["x","number"],["alpha","number++"],["beta","number++"],["A",["or","number",["null",0]]],["B",["or","number",["null",1]]],["?",["assert","$x >= $A","NUM"]],["?",["assert","$x <= $B","NUM"]],["?",["assert","$A < $B","NUM"]]]),Ze("BETA.DIST",w).args([["x","number"],["alpha","number++"],["beta","number++"],["cumulative","logical"],["A",["or","number",["null",0]]],["B",["or","number",["null",1]]],["?",["assert","$x >= $A","NUM"]],["?",["assert","$x <= $B","NUM"]],["?",["assert","$A < $B","NUM"]]]),Ze("BETA.INV",y).args([["p",["and","number",["[between]",0,1]]],["alpha","number++"],["beta","number++"],["A",["or","number",["null",0]]],["B",["or","number",["null",1]]]]),Ze("CHISQ.DIST",k).args([["x","number+"],["deg_freedom","integer++"],["cumulative","logical"]]),Ze("CHISQ.DIST.RT",x).args([["x","number+"],["deg_freedom","integer++"]]),Ze("CHISQ.INV",C).args([["p",["and","number",["[between]",0,1]]],["deg_freedom","integer++"]]),Ze("CHISQ.INV.RT",S).args([["p",["and","number",["[between]",0,1]]],["deg_freedom","integer++"]]),Ze("CHISQ.TEST",function(e,t){return T(e.data,t.data)}).args([["actual_range","matrix"],["expected_range","matrix"],["?",["assert","$actual_range.width == $expected_range.width"]],["?",["assert","$actual_range.height == $expected_range.height"]]]),Ze("EXPON.DIST",D).args([["x","number+"],["lambda","number++"],["cumulative","logical"]]),Ze("POISSON.DIST",A).args([["x","integer+"],["mean","number+"],["cumulative","logical"]]),Ze("F.DIST",E).args([["x","number+"],["deg_freedom1","integer++"],["deg_freedom2","integer++"],["cumulative","logical"]]),Ze("F.DIST.RT",I).args([["x","number+"],["deg_freedom1","integer++"],["deg_freedom2","integer++"]]),Ze("F.INV",R).args([["p",["and","number",["[between]",0,1]]],["deg_freedom1","integer++"],["deg_freedom2","integer++"]]),Ze("F.INV.RT",M).args([["p",["and","number",["[between]",0,1]]],["deg_freedom1","integer++"],["deg_freedom2","integer++"]]),Ze("F.TEST",P).args([["array1",["collect","number",1]],["array2",["collect","number",1]],["?",["assert","$array1.length >= 2","DIV/0"]],["?",["assert","$array2.length >= 2","DIV/0"]]]),Ze("FISHER",B).args([["x",["and","number",["(between)",-1,1]]]]),Ze("FISHERINV",L).args([["y","number"]]),Ze("T.DIST",H).args([["x","number"],["deg_freedom","integer++"],["cumulative","logical"]]),Ze("T.DIST.RT",N).args([["x","number"],["deg_freedom","integer++"]]),Ze("T.DIST.2T",O).args([["x","number+"],["deg_freedom","integer++"]]),Ze("T.INV",V).args([["p",["and","number",["(between]",0,1]]],["deg_freedom","integer++"]]),Ze("T.INV.2T",U).args([["p",["and","number",["(between]",0,1]]],["deg_freedom","integer++"]]),Ze("T.TEST",W).args([["array1",["collect","number",1]],["array2",["collect","number",1]],["tails",["and","integer",["values",1,2]]],["type",["and","integer",["values",1,2,3]]],["?",["assert","$type != 1 || $array1.length == $array2.length","N/A"]],["?",["assert","$array1.length >= 2","DIV/0"]],["?",["assert","$array2.length >= 2","DIV/0"]]]),Ze("CONFIDENCE.T",j).args([["alpha",["and","number",["(between)",0,1]]],["standard_dev","number++"],["size",["and","integer++",["assert","$size != 1","DIV/0"]]]]),Ze("CONFIDENCE.NORM",q).args([["alpha",["and","number",["(between)",0,1]]],["standard_dev","number++"],["size",["and","integer++"]]]),Ze("GAUSS",G).args([["z","number"]]),Ze("PHI",$).args([["x","number"]]),Ze("LOGNORM.DIST",K).args([["x","number++"],["mean","number"],["standard_dev","number++"],["cumulative","logical"]]),Ze("LOGNORM.INV",Y).args([["probability",["and","number",["(between)",0,1]]],["mean","number"],["standard_dev","number++"]]),Ze("PROB",Q).args([["x_range",["collect","number",1]],["prob_range",["collect","number",1]],["lower_limit","number"],["upper_limit",["or","number",["null","$lower_limit"]]],["?",["assert","$prob_range.length == $x_range.length","N/A"]]]),Ze("SLOPE",X).args([["known_y",["collect","number",1]],["known_x",["collect","number",1]],["?",["assert","$known_x.length == $known_y.length","N/A"]],["?",["assert","$known_x.length > 0 && $known_y.length > 0","N/A"]]]),Ze("INTERCEPT",Z).args([["known_y",["collect","number",1]],["known_x",["collect","number",1]],["?",["assert","$known_x.length == $known_y.length","N/A"]],["?",["assert","$known_x.length > 0 && $known_y.length > 0","N/A"]]]),Ze("PEARSON",J).args([["array1",["collect","number",1]],["array2",["collect","number",1]],["?",["assert","$array2.length == $array1.length","N/A"]],["?",["assert","$array2.length > 0 && $array1.length > 0","N/A"]]]),Ze("RSQ",ee).args([["known_y",["collect","number",1]],["known_x",["collect","number",1]],["?",["assert","$known_x.length == $known_y.length","N/A"]],["?",["assert","$known_x.length > 0 && $known_y.length > 0","N/A"]],["?",["assert","$known_x.length != 1 && $known_y.length != 1","N/A"]]]),Ze("STEYX",te).args([["known_y",["collect","number",1]],["known_x",["collect","number",1]],["?",["assert","$known_x.length == $known_y.length","N/A"]],["?",["assert","$known_x.length >= 3 && $known_y.length >= 3","DIV/0"]]]),Ze("FORECAST",ne).args([["x","number"],["known_y",["collect","number",1]],["known_x",["collect","number",1]],["?",["assert","$known_x.length == $known_y.length","N/A"]],["?",["assert","$known_x.length > 0 && $known_y.length > 0","N/A"]]]),Ze("LINEST",re).args([["known_y","matrix"],["known_x",["or","matrix","null"]],["const",["or","logical",["null",!0]]],["stats",["or","logical",["null",!1]]]]),Ze("LOGEST",se).args([["known_y","matrix"],["known_x",["or","matrix","null"]],["const",["or","logical",["null",!0]]],["stats",["or","logical",["null",!1]]]]),Ze("TREND",ae).args([["known_y","matrix"],["known_x",["or","matrix","null"]],["new_x",["or","matrix","null"]],["const",["or","logical",["null",!0]]]]),Ze("GROWTH",le).args([["known_y","matrix"],["known_x",["or","matrix","null"]],["new_x",["or","matrix","null"]],["const",["or","logical",["null",!0]]]]),Ze("FV",de).args([["rate","number"],["nper","number"],["pmt",["or","number",["null",0]]],["pv",["or","number",["null",0]]],["type",["or",["values",0,1],["null",0]]],["?",["assert","$pmt || $pv"]]]),Ze("PV",ue).args([["rate","number"],["nper","number"],["pmt",["or","number",["null",0]]],["fv",["or","number",["null",0]]],["type",["or",["values",0,1],["null",0]]],["?",["assert","$pmt || $fv"]]]),Ze("PMT",he).args([["rate","number"],["nper","number"],["pmt","number"],["fv",["or","number",["null",0]]],["type",["or",["values",0,1],["null",0]]]]),Ze("NPER",fe).args([["rate","number"],["pmt","number"],["pv","number"],["fv",["or","number",["null",0]]],["type",["or",["values",0,1],["null",0]]]]),Ze("RATE",pe).args([["nper","number"],["pmt",["or","number",["null",0]]],["pv","number"],["fv",["or","number",["null",0]]],["type",["or",["values",0,1],["null",0]]],["guess",["or","number++",["null",.01]]],["?",["assert","$pmt || $fv"]]]),Ze("IPMT",me).args([["rate","number"],["per","number++"],["nper","number++"],["pv","number"],["fv",["or","number",["null",0]]],["type",["or",["values",0,1],["null",0]]],["?",["assert","$per >= 1 && $per <= $nper"]]]),Ze("PPMT",ge).args([["rate","number"],["per","number++"],["nper","number++"],["pv","number"],["fv",["or","number",["null",0]]],["type",["or",["values",0,1],["null",0]]],["?",["assert","$per >= 1 && $per <= $nper"]]]),Ze("CUMPRINC",ve).args([["rate","number++"],["nper","number++"],["pv","number++"],["start_period","number++"],["end_period","number++"],["type",["or",["values",0,1],["null",0]]],["?",["assert","$end_period >= $start_period","NUM"]]]),Ze("CUMIPMT",_e).args([["rate","number++"],["nper","number++"],["pv","number++"],["start_period","number++"],["end_period","number++"],["type",["or",["values",0,1],["null",0]]],["?",["assert","$end_period >= $start_period","NUM"]]]),Ze("NPV",be).args([["rate","number"],["values",["collect","number"]],["?",["assert","$values.length > 0","N/A"]]]),Ze("IRR",we).args([["values",["collect","number",1]],["guess",["or","number",["null",.1]]]]),Ze("EFFECT",ye).args([["nominal_rate","number++"],["npery","integer++"]]),Ze("NOMINAL",ke).args([["effect_rate","number++"],["npery","integer++"]]),Ze("XNPV",xe).args([["rate","number"],["values",["collect","number",1]],["dates",["collect","date",1]],["?",["assert","$values.length == $dates.length","NUM"]]]),Ze("XIRR",Ce).args([["values",["collect","number",1]],["dates",["collect","date",1]],["guess",["or","number",["null",.1]]],["?",["assert","$values.length == $dates.length","NUM"]]]),Ze("ISPMT",Se).args([["rate","number"],["per","number++"],["nper","number++"],["pv","number"],["?",["assert","$per >= 1 && $per <= $nper"]]]),Ze("DB",Te).args([["cost","number"],["salvage","number"],["life","number++"],["period","number++"],["month",["or","number",["null",12]]]]),Ze("DDB",De).args([["cost","number"],["salvage","number"],["life","number++"],["period","number++"],["factor",["or","number",["null",2]]]]),Ze("SLN",Ae).args([["cost","number"],["salvage","number"],["life","number++"]]),Ze("SYD",Ee).args([["cost","number"],["salvage","number"],["life","number++"],["per","number++"]]),Ze("VDB",Ie).args([["cost","number+"],["salvage","number+"],["life","number++"],["start_period","number+"],["end_period","number+"],["factor",["or","number+",["null",2]]],["no_switch",["or","logical",["null",!1]]],["?",["assert","$end_period >= $start_period","NUM"]]]),rt=[["settlement","date"],["maturity","date"],["frequency",["and","integer",["values",1,2,4]]],["basis",["or",["null",0],["and","integer",["values",0,1,2,3,4]]]],["?",["assert","$settlement < $maturity","NUM"]]],Ze("COUPDAYBS",Pe).args(rt),Ze("COUPDAYS",Be).args(rt),Ze("COUPDAYSNC",Le).args(rt),Ze("COUPPCD",He).args(rt),Ze("COUPNCD",Ne).args(rt),Ze("COUPNUM",Oe).args(rt),Ze("ACCRINTM",Ue).args([["issue","date"],["settlement","date"],["rate","number++"],["par",["or",["null",1e3],"number++"]],["basis",["or",["null",0],["and","integer",["values",0,1,2,3,4]]]],["?",["assert","$issue < $settlement","NUM"]]]),Ze("ACCRINT",We).args([["issue","date"],["first_interest","date"],["settlement","date"],["rate","number++"],["par",["or",["null",1e3],"number++"]],["frequency",["and","integer",["values",1,2,4]]],["basis",["or",["null",0],["and","integer",["values",0,1,2,3,4]]]],["calc_method",["or","logical",["null",!0]]],["?",["assert","$issue < $settlement","NUM"]]]),Ze("DISC",je).args([["settlement","date"],["maturity","date"],["pr","number++"],["redemption","number++"],["basis",["or",["null",0],["and","integer",["values",0,1,2,3,4]]]],["?",["assert","$settlement < $maturity","NUM"]]]),Ze("INTRATE",qe).args([["settlement","date"],["maturity","date"],["investment","number++"],["redemption","number++"],["basis",["or",["null",0],["and","integer",["values",0,1,2,3,4]]]],["?",["assert","$settlement < $maturity","NUM"]]]),Ze("RECEIVED",Ge).args([["settlement","date"],["maturity","date"],["investment","number++"],["discount","number++"],["basis",["or",["null",0],["and","integer",["values",0,1,2,3,4]]]],["?",["assert","$settlement < $maturity","NUM"]]]),Ze("PRICE",$e).args([["settlement","date"],["maturity","date"],["rate","number++"],["yld","number++"],["redemption","number++"],["frequency",["and","integer",["values",1,2,4]]],["basis",["or",["null",0],["and","integer",["values",0,1,2,3,4]]]],["?",["assert","$settlement < $maturity","NUM"]]]),Ze("PRICEDISC",Ke).args([["settlement","date"],["maturity","date"],["discount","number++"],["redemption","number++"],["basis",["or",["null",0],["and","integer",["values",0,1,2,3,4]]]],["?",["assert","$settlement < $maturity","NUM"]]]),st=300,at=2.2204e-16,lt=1e-30,ct=Math.abs)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/borderpalette.min",["kendo.core.min","kendo.colorpicker.min","kendo.popup.min"],e)}(function(){!function(e){function t(e){return function(t){return t.preventDefault(),e.apply(this,arguments)}}var n,i,o,r,s,a;e.support.browser.msie&&e.support.browser.version<9||(n=e.jQuery,i=["allBorders","insideBorders","insideHorizontalBorders","insideVerticalBorders","outsideBorders","leftBorder","topBorder","rightBorder","bottomBorder","noBorders"],o=e.spreadsheet.messages.borderPalette={allBorders:"All borders",insideBorders:"Inside borders",insideHorizontalBorders:"Inside horizontal borders",insideVerticalBorders:"Inside vertical borders",outsideBorders:"Outside borders",leftBorder:"Left border",topBorder:"Top border",rightBorder:"Right border",bottomBorder:"Bottom border",noBorders:"No border"},r=e.spreadsheet.messages.colorPicker={reset:"Reset color",customColor:"Custom color...",apply:"Apply",cancel:"Cancel"},s=e.ui.Widget.extend({init:function(n,i){e.ui.Widget.call(this,n,i),this.element=n,this.color=i.color,this._resetButton(),this._colorPalette(),this._customColorPalette(),this._customColorButton(),this.resetButton.on("click",t(this.resetColor.bind(this))),this.customColorButton.on("click",t(this.customColor.bind(this)))},options:{name:"ColorChooser"},events:["change"],destroy:function(){e.unbind(this.dialog.element.find(".k-action-buttons")),this.dialog.destroy(),this.colorPalette.destroy(),this.resetButton.off("click"),this.customColorButton.off("click")},value:function(e){return void 0===e?this.color:(this.color=e,this.customColorButton.find(".k-icon").css("background-color",this.color),this.colorPalette.value(null),this.flatColorPicker.value(this.color),void 0)},_change:function(e){this.color=e,this.trigger("change",{value:e})},_colorPalette:function(){var e=n("<div />",{"class":"k-spreadsheet-color-palette"}),t=this.colorPalette=n("<div />").kendoColorPalette({palette:["#ffffff","#000000","#d6ecff","#4e5b6f","#7fd13b","#ea157a","#feb80a","#00addc","#738ac8","#1ab39f","#f2f2f2","#7f7f7f","#a7d6ff","#d9dde4","#e5f5d7","#fad0e4","#fef0cd","#c5f2ff","#e2e7f4","#c9f7f1","#d8d8d8","#595959","#60b5ff","#b3bcca","#cbecb0","#f6a1c9","#fee29c","#8be6ff","#c7d0e9","#94efe3","#bfbfbf","#3f3f3f","#007dea","#8d9baf","#b2e389","#f272af","#fed46b","#51d9ff","#aab8de","#5fe7d5","#a5a5a5","#262626","#003e75","#3a4453","#5ea226","#af0f5b","#c58c00","#0081a5","#425ea9","#138677","#7f7f7f","#0c0c0c","#00192e","#272d37","#3f6c19","#750a3d","#835d00","#00566e","#2c3f71","#0c594f"],
value:this.color,change:function(e){this.customColorButton.find(".k-icon").css("background-color","transparent"),this.flatColorPicker.value(null),this._change(e.value)}.bind(this)}).data("kendoColorPalette");e.append(t.wrapper).appendTo(this.element)},_customColorPalette:function(){var t,i,o=n("<div />",{"class":"k-spreadsheet-window",html:"<div></div><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: apply'>"+r.apply+"</button><button class='k-button' data-bind='click: close'>"+r.cancel+"</button></div>"}),s=this.dialog=o.appendTo(document.body).kendoWindow({animation:!1,scrollable:!1,resizable:!1,maximizable:!1,modal:!0,visible:!1,width:268,open:function(){this.center()}}).data("kendoWindow");s.one("activate",function(){this.element.find("[data-role=flatcolorpicker]").data("kendoFlatColorPicker")._hueSlider.resize()}),t=this.flatColorPicker=s.element.children().first().kendoFlatColorPicker().data("kendoFlatColorPicker"),i=e.observable({apply:function(){this.customColorButton.find(".k-icon").css("background-color",t.value()),this.colorPalette.value(null),this._change(t.value()),s.close()}.bind(this),close:function(){t.value(null),s.close()}}),e.bind(s.element.find(".k-action-buttons"),i)},_resetButton:function(){this.resetButton=n("<a class='k-button k-reset-color' href='#'><span class='k-icon k-i-reset-color'></span>"+r.reset+"</a>").appendTo(this.element)},_customColorButton:function(){this.customColorButton=n("<a class='k-button k-custom-color' href='#'><span class='k-icon'></span>"+r.customColor+"</a>").appendTo(this.element)},resetColor:function(){this.colorPalette.value(null),this.flatColorPicker.value(null),this._change(null)},customColor:function(){this.dialog.open()}}),a=e.ui.Widget.extend({init:function(n,i){e.ui.Widget.call(this,n,i),this.element=n,this.color="#000",this.element.addClass("k-spreadsheet-border-palette"),this._borderTypePalette(),this._borderColorPalette(),this.element.on("click",".k-spreadsheet-border-type-palette .k-button",t(this._click.bind(this)))},options:{name:"BorderPalette"},events:["change"],destroy:function(){this.colorChooser.destroy(),this.element.off("click")},_borderTypePalette:function(){var t=o,r=i.map(function(n){return'<a title="'+t[n]+'" aria-label="'+t[n]+'" href="#" data-border-type="'+n+'" class="k-button k-button-icon"><span class="k-icon k-i-'+e.toHyphens(n)+'"></span></a>'}).join(""),s=n("<div />",{"class":"k-spreadsheet-border-type-palette",html:r});s.appendTo(this.element)},_borderColorPalette:function(){var e=n("<div />",{"class":"k-spreadsheet-border-color-palette"});e.appendTo(this.element),this.colorChooser=new s(e,{color:this.color,change:this._colorChange.bind(this)})},_click:function(e){this.type=n(e.currentTarget).data("borderType"),this.trigger("change",{type:this.type,color:this.color})},_colorChange:function(e){this.color=e.value,this.type&&this.trigger("change",{type:this.type,color:this.color})}}),e.spreadsheet.ColorChooser=s,e.spreadsheet.BorderPalette=a)}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/toolbar.min",["kendo.toolbar.min","kendo.colorpicker.min","kendo.combobox.min","kendo.dropdownlist.min","kendo.popup.min","spreadsheet/borderpalette.min"],e)}(function(){!function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C,S,T,D,A,E,I,M,R,F,z,P;e.support.browser.msie&&e.support.browser.version<9||(t=e.jQuery,n=e.ui.ToolBar,i=e.spreadsheet.messages.toolbar={addColumnLeft:"Add column left",addColumnRight:"Add column right",addRowAbove:"Add row above",addRowBelow:"Add row below",alignment:"Alignment",alignmentButtons:{justtifyLeft:"Align left",justifyCenter:"Center",justifyRight:"Align right",justifyFull:"Justify",alignTop:"Align top",alignMiddle:"Align middle",alignBottom:"Align bottom"},backgroundColor:"Background",bold:"Bold",borders:"Borders",copy:"Copy",cut:"Cut",deleteColumn:"Delete column",deleteRow:"Delete row",filter:"Filter",fontFamily:"Font",fontSize:"Font size",format:"Custom format...",formatTypes:{automatic:"Automatic",text:"Text",number:"Number",percent:"Percent",financial:"Financial",currency:"Currency",date:"Date",time:"Time",dateTime:"Date time",duration:"Duration",moreFormats:"More formats..."},formatDecreaseDecimal:"Decrease decimal",formatIncreaseDecimal:"Increase decimal",freeze:"Freeze panes",freezeButtons:{freezePanes:"Freeze panes",freezeRows:"Freeze rows",freezeColumns:"Freeze columns",unfreeze:"Unfreeze panes"},italic:"Italic",merge:"Merge cells",mergeButtons:{mergeCells:"Merge all",mergeHorizontally:"Merge horizontally",mergeVertically:"Merge vertically",unmerge:"Unmerge"},open:"Open...",paste:"Paste",quickAccess:{redo:"Redo",undo:"Undo"},exportAs:"Export...",toggleGridlines:"Toggle gridlines",sort:"Sort",sortButtons:{sortRangeAsc:"Sort range A to Z",sortRangeDesc:"Sort range Z to A"},textColor:"Text Color",textWrap:"Wrap text",underline:"Underline",validation:"Data validation...",hyperlink:"Link"},o={home:["open","exportAs",["cut","copy","paste"],["bold","italic","underline"],"hyperlink","backgroundColor","textColor","borders","fontSize","fontFamily","alignment","textWrap",["formatDecreaseDecimal","formatIncreaseDecimal"],"format","merge","freeze","filter","toggleGridlines"],insert:[["addColumnLeft","addColumnRight","addRowBelow","addRowAbove"],["deleteColumn","deleteRow"]],data:["sort","filter","validation"]},r={open:{type:"open",overflow:"never",iconClass:"file-excel"},exportAs:{type:"exportAsDialog",dialogName:"exportAs",overflow:"never",text:"",iconClass:"file-excel"},bold:{type:"button",command:"PropertyChangeCommand",property:"bold",value:!0,iconClass:"bold",togglable:!0},italic:{type:"button",command:"PropertyChangeCommand",property:"italic",value:!0,iconClass:"italic",togglable:!0},underline:{type:"button",command:"PropertyChangeCommand",property:"underline",value:!0,iconClass:"underline",togglable:!0},formatDecreaseDecimal:{type:"button",command:"AdjustDecimalsCommand",value:-1,iconClass:"decimal-decrease"},formatIncreaseDecimal:{type:"button",command:"AdjustDecimalsCommand",value:1,iconClass:"decimal-increase"},textWrap:{type:"button",command:"TextWrapCommand",property:"wrap",value:!0,iconClass:"text-wrap",togglable:!0},cut:{type:"button",command:"ToolbarCutCommand",iconClass:"cut"},copy:{type:"button",command:"ToolbarCopyCommand",iconClass:"copy"},paste:{type:"button",command:"ToolbarPasteCommand",iconClass:"paste"},separator:{type:"separator"},alignment:{type:"alignment",iconClass:"align-left"},backgroundColor:{type:"colorPicker",property:"background",iconClass:"paint"},textColor:{type:"colorPicker",property:"color",iconClass:"foreground-color"},fontFamily:{type:"fontFamily",property:"fontFamily",iconClass:"font-family"},fontSize:{type:"fontSize",property:"fontSize",iconClass:"font-size"},format:{type:"format",property:"format",iconClass:"custom-format"},filter:{type:"filter",property:"hasFilter",iconClass:"filter"},merge:{type:"merge",iconClass:"cells-merge"},freeze:{type:"freeze",iconClass:"pane-freeze"},borders:{type:"borders",iconClass:"borders-all"},formatCells:{type:"dialog",dialogName:"formatCells",overflow:"never"},hyperlink:{type:"dialog",dialogName:"hyperlink",iconClass:"link-horizontal",overflow:"never",text:""},toggleGridlines:{type:"button",command:"GridLinesChangeCommand",property:"gridLines",value:!0,iconClass:"border-no",togglable:!0},addColumnLeft:{type:"button",command:"AddColumnCommand",value:"left",iconClass:"table-column-insert-left"},addColumnRight:{type:"button",command:"AddColumnCommand",value:"right",iconClass:"table-column-insert-right"},addRowBelow:{type:"button",command:"AddRowCommand",value:"below",iconClass:"table-row-insert-below"},addRowAbove:{type:"button",command:"AddRowCommand",value:"above",iconClass:"table-row-insert-above"},deleteColumn:{type:"button",command:"DeleteColumnCommand",iconClass:"table-column-delete"},deleteRow:{type:"button",command:"DeleteRowCommand",iconClass:"table-row-delete"},sort:{type:"sort",iconClass:"sort-desc"},validation:{type:"dialog",dialogName:"validation",iconClass:"exception",overflow:"never"}},s=n.extend({init:function(e,i){var o,r;i.items=this._expandTools(i.tools||s.prototype.options.tools[i.toolbarName]),n.fn.init.call(this,e,i),o=this._click.bind(this),this.element.addClass("k-spreadsheet-toolbar"),this._addSeparators(this.element),r=this,this.element.on("keydown",function(e){var n;9===e.keyCode&&(n=r._nextTool(e.shiftKey?-1:1),n&&(document.activeElement.blur(),t(n).is(".k-upload-button")&&t(n).addClass("k-state-focused"),t(n).find("input").length?t(n).find("input").focus():n.focus(),e.preventDefault()))}),this.element.on("focusout",function(){t(this).find(".k-toolbar-first-visible").removeClass("k-state-focused")}),this.bind({click:o,toggle:o})},_nextTool:function(e){var n=this,i=n.element.find(".k-widget, .k-button, .k-button-group > a"),o=i.index(t(document.activeElement).closest(".k-widget, .k-button, .k-button-group > a"));if(o>0)return i[o+e]},_addSeparators:function(e){var t=e.children(".k-widget, a.k-button, .k-button-group");t.before("<span class='k-separator' />")},_expandTools:function(e){function n(e){var o=t.isPlainObject(e)?e:r[e]||{},s="k-icon k-i-"+o.iconClass,a=o.type,l={button:{showText:"overflow"},colorPicker:{toolIcon:s,spriteCssClass:s},borders:{spriteCssClass:s},alignment:{spriteCssClass:s},merge:{spriteCssClass:s},freeze:{spriteCssClass:s}},c=t.extend({name:o.name||e,text:i[o.name||e],icon:o.iconClass,attributes:{title:i[o.name||e],"aria-label":i[o.name||e]}},l[a],o);return"splitButton"==a&&(c.menuButtons=c.menuButtons.map(n)),c.attributes["data-tool"]=e,o.property&&(c.attributes["data-property"]=o.property),c}return e.reduce(function(e,i){return e.push(t.isArray(i)?{type:"buttonGroup",buttons:i.map(n)}:n.call(this,i)),e},[])},_click:function(e){var t,n=e.target.attr("data-tool"),i=r[n]||{},o=i.command;o&&(t={command:o,options:{property:i.property||null,value:i.value||null}},"boolean"==typeof t.options.value&&(t.options.value=!!e.checked||null),this.action(t))},events:["click","toggle","open","close","overflowOpen","overflowClose","action","dialog"],options:{name:"SpreadsheetToolBar",resizable:!0,tools:o},action:function(e){this.trigger("action",e)},dialog:function(e){this.trigger("dialog",e)},refresh:function(t){function n(e,t){var n,i=e.toolbar,o=e.overflow,r=i&&i.options.togglable||o&&o.options.togglable;r&&(n=!1,"boolean"==typeof t?n=t:"string"==typeof t&&(n=i.options.value===t),i.toggle(n),o&&o.toggle(n))}function i(e,t){var n=e.toolbar,i=e.overflow;n&&n.update&&n.update(t),i&&i.update&&i.update(t)}var o,r,s,a,l=t,c=this._tools();for(o=0;o<c.length;o++)r=c[o].property,s=c[o].tool,a=e.isFunction(l[r])?l[r]():l,"gridLines"==r&&(a=l.sheet().showGridLines()),"button"===s.type?n(s,a):i(s,a);this.resize()},_tools:function(){return this.element.find("[data-property]").toArray().map(function(e){return e=t(e),{property:e.attr("data-property"),tool:this._getItem(e)}}.bind(this))},destroy:function(){this.element.find("[data-command],.k-button").each(function(){var e=t(this),n=e.data("instance");n&&n.destroy&&n.destroy()}),n.fn.destroy.call(this)}}),e.spreadsheet.ToolBar=s,a=e.toolbar.Item.extend({init:function(e,n){var i=t("<select />").attr("title",e.attributes.title).attr("aria-label",e.attributes.title).kendoDropDownList({height:"auto"}).data("kendoDropDownList");this.dropDownList=i,this.element=i.wrapper,this.options=e,this.toolbar=n,this.attributes(),this.addUidAttr(),this.addOverflowAttr(),i.bind("open",this._open.bind(this)),i.bind("change",this._change.bind(this)),this.element.width(e.width).attr({"data-command":"PropertyChangeCommand","data-property":e.property})},_open:function(){var t,n=this.dropDownList,i=n.list;i.css({whiteSpace:"nowrap",width:"auto"}),t=i.width(),t?t+=20:t=n._listWidth,i.css("width",t+e.support.scrollbar()),n._listWidth=t},_change:function(e){var t=e.sender,n=t.value(),i=t.dataItem(),o=i?i.popup:void 0;o?this.toolbar.dialog({name:o}):this.toolbar.action({command:"PropertyChangeCommand",options:{property:this.options.property,value:"null"==n?null:n}})},value:function(e){return void 0===e?this.dropDownList.value():void this.dropDownList.value(e)}}),l=e.toolbar.Item.extend({init:function(e,n){this.element=t("<a href='#' class='k-button k-button-icon'><span class='"+e.spriteCssClass+"'></span><span class='k-icon k-i-arrow-60-down'></span></a>"),this.element.on("click touchend",this.open.bind(this)).attr("data-command",e.command),this.options=e,this.toolbar=n,this.attributes(),this.addUidAttr(),this.addOverflowAttr(),this._popup()},destroy:function(){this.popup.destroy()},open:function(e){e.preventDefault(),this.popup.toggle()},_popup:function(){var e=this.element;this.popup=t("<div class='k-spreadsheet-popup' />").appendTo(e).kendoPopup({anchor:e}).data("kendoPopup")}}),e.toolbar.registerComponent("dialog",e.toolbar.ToolBarButton.extend({init:function(t,n){e.toolbar.ToolBarButton.fn.init.call(this,t,n),this._dialogName=t.dialogName,this.element.bind("click touchend",this.open.bind(this)).data("instance",this)},open:function(){this.toolbar.dialog({name:this._dialogName})}})),e.toolbar.registerComponent("exportAsDialog",e.toolbar.Item.extend({init:function(e,n){this._dialogName=e.dialogName,this.toolbar=n,this._title=e.attributes.title,this.element=t("<button class='k-button k-button-icon'><span class='k-icon k-i-download' /></button>").attr("title",this._title).attr("aria-label",this._title).data("instance",this),this.element.bind("click",this.open.bind(this)).data("instance",this)},open:function(){this.toolbar.dialog({name:this._dialogName})}})),c=e.toolbar.OverflowButton.extend({init:function(t,n){e.toolbar.OverflowButton.fn.init.call(this,t,n),this.element.on("click touchend",this._click.bind(this)),this.message=this.options.text;var i=this.element.data("button");this.element.data(this.options.type,i)},_click:t.noop}),d=l.extend({init:function(t,n){l.fn.init.call(this,t,n),this.popup.element.addClass("k-spreadsheet-colorpicker"),this.colorChooser=new e.spreadsheet.ColorChooser(this.popup.element,{change:this._colorChange.bind(this)}),this.element.attr({"data-property":t.property}),this.element.data({type:"colorPicker",colorPicker:this,instance:this})},destroy:function(){this.colorChooser.destroy(),l.fn.destroy.call(this)},update:function(e){this.value(e)},value:function(e){this.colorChooser.value(e)},_colorChange:function(e){this.toolbar.action({command:"PropertyChangeCommand",options:{property:this.options.property,value:e.sender.value()}}),this.popup.close()}}),u=c.extend({init:function(e,t){e.iconName="text",c.fn.init.call(this,e,t)},_click:function(){this.toolbar.dialog({name:"colorPicker",options:{title:this.options.property,property:this.options.property}})}}),e.toolbar.registerComponent("colorPicker",d,u),h=[8,9,10,11,12,13,14,16,18,20,22,24,26,28,36,48,72],f=12,p=e.toolbar.Item.extend({init:function(e,n){var i=t("<input />").attr("aria-label",e.attributes.title).kendoComboBox({change:this._valueChange.bind(this),clearButton:!1,dataSource:e.fontSizes||h,value:f}).data("kendoComboBox");this.comboBox=i,this.element=i.wrapper,this.options=e,this.toolbar=n,this.attributes(),this.addUidAttr(),this.addOverflowAttr(),this.element.width(e.width).attr({"data-command":"PropertyChangeCommand","data-property":e.property}),this.element.data({type:"fontSize",fontSize:this})},_valueChange:function(t){this.toolbar.action({command:"PropertyChangeCommand",options:{property:this.options.property,value:e.parseInt(t.sender.value())}})},update:function(t){this.value(e.parseInt(t)||f)},value:function(e){return void 0===e?this.comboBox.value():void this.comboBox.value(e)}}),m=c.extend({_click:function(){this.toolbar.dialog({name:"fontSize",options:{sizes:h,defaultSize:f}})},update:function(e){this._value=e||f,this.element.find(".k-text").text(this.message+" ("+this._value+") ...")}}),e.toolbar.registerComponent("fontSize",p,m),g=["Arial","Courier New","Georgia","Times New Roman","Trebuchet MS","Verdana"],v="Arial",_=a.extend({init:function(e,t){a.fn.init.call(this,e,t);var n=this.dropDownList;n.setDataSource(e.fontFamilies||g),n.value(v),this.element.data({type:"fontFamily",fontFamily:this})},update:function(e){this.value(e||v)}}),b=c.extend({_click:function(){this.toolbar.dialog({name:"fontFamily",options:{fonts:g,defaultFont:v}})},update:function(e){this._value=e||v,this.element.find(".k-text").text(this.message+" ("+this._value+") ...")}}),e.toolbar.registerComponent("fontFamily",_,b),w=e.spreadsheet.formats={automatic:null,text:"@",number:"#,0.00",percent:"0.00%",financial:'_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',currency:"$#,##0.00;[Red]$#,##0.00",date:"m/d/yyyy",time:"h:mm:ss AM/PM",dateTime:"m/d/yyyy h:mm",duration:"[h]:mm:ss"},y=a.extend({_revertTitle:function(e){e.sender.value(""),e.sender.wrapper.width("auto")},init:function(e,t){var n,o;a.fn.init.call(this,e,t),n=this.dropDownList,o="<span class='k-icon k-i-"+e.iconClass+"' style='line-height: 1em; width: 1.35em;'></span>",n.bind("change",this._revertTitle.bind(this)),n.bind("dataBound",this._revertTitle.bind(this)),n.setOptions({dataValueField:"format",dataTextField:"name",dataValuePrimitive:!0,valueTemplate:o,template:"# if (data.sample) { #<span class='k-spreadsheet-sample'>#: data.sample #</span># } ##: data.name #"}),n.text(o),n.setDataSource([{format:w.automatic,name:i.formatTypes.automatic},{format:w.text,name:i.formatTypes.text},{format:w.number,name:i.formatTypes.number,sample:"1,499.99"},{format:w.percent,name:i.formatTypes.percent,sample:"14.50%"},{format:w.financial,name:i.formatTypes.financial,sample:"(1,000.12)"},{format:w.currency,name:i.formatTypes.currency,sample:"$1,499.99"},{format:w.date,name:i.formatTypes.date,sample:"4/21/2012"},{format:w.time,name:i.formatTypes.time,sample:"5:49:00 PM"},{format:w.dateTime,name:i.formatTypes.dateTime,sample:"4/21/2012 5:49:00"},{format:w.duration,name:i.formatTypes.duration,sample:"168:05:00"},{popup:"formatCells",name:i.formatTypes.moreFormats}]),this.element.data({type:"format",format:this})}}),k=c.extend({_click:function(){this.toolbar.dialog({name:"formatCells"})}}),e.toolbar.registerComponent("format",y,k),x=l.extend({init:function(e,t){l.fn.init.call(this,e,t),this._borderPalette(),this.element.data({type:"borders",instance:this})},destroy:function(){this.borderPalette.destroy(),l.fn.destroy.call(this)},_borderPalette:function(){var n=t("<div />").appendTo(this.popup.element);this.borderPalette=new e.spreadsheet.BorderPalette(n,{change:this._action.bind(this)})},_action:function(e){this.toolbar.action({command:"BorderChangeCommand",options:{border:e.type,style:{size:1,color:e.color}}})}}),C=c.extend({_click:function(){this.toolbar.dialog({name:"borders"})}}),e.toolbar.registerComponent("borders",x,C),S=l.extend({init:function(e,n){l.fn.init.call(this,e,n),this.element.attr({"data-property":"alignment"}),this._defineButtons(),this._commandPalette(),this.popup.element.on("click",".k-button",function(e){this._action(t(e.currentTarget))}.bind(this)),this.element.data({type:"alignment",alignment:this,instance:this})},_defineButtons:function(){this.buttons=[{property:"textAlign",value:"left",iconClass:"align-left",text:i.alignmentButtons.justtifyLeft},{property:"textAlign",value:"center",iconClass:"align-center",text:i.alignmentButtons.justifyCenter},{property:"textAlign",value:"right",iconClass:"align-right",text:i.alignmentButtons.justifyRight},{property:"textAlign",value:"justify",iconClass:"align-justify",text:i.alignmentButtons.justifyFull},{property:"verticalAlign",value:"top",iconClass:"align-top",text:i.alignmentButtons.alignTop},{property:"verticalAlign",value:"center",iconClass:"align-middle",text:i.alignmentButtons.alignMiddle},{property:"verticalAlign",value:"bottom",iconClass:"align-bottom",text:i.alignmentButtons.alignBottom}]},destroy:function(){this.popup.element.off(),l.fn.destroy.call(this)},update:function(e){var t=e.textAlign(),n=e.verticalAlign(),i=this.popup.element;i.find(".k-button").removeClass("k-state-active"),t&&i.find("[data-property=textAlign][data-value="+t+"]").addClass("k-state-active"),n&&i.find("[data-property=verticalAlign][data-value="+n+"]").addClass("k-state-active")},_commandPalette:function(){var e=this.buttons,n=t("<div />").appendTo(this.popup.element);e.forEach(function(i,o){var r="<a title='"+i.text+"' data-property='"+i.property+"' data-value='"+i.value+"' class='k-button k-button-icon'><span class='k-icon k-i-"+i.iconClass+"'></span></a>";0!==o&&e[o-1].property!==i.property&&n.append(t("<span class='k-separator' />")),n.append(r)})},_action:function(e){var t=e.attr("data-property"),n=e.attr("data-value");this.toolbar.action({command:"PropertyChangeCommand",options:{property:t,value:n}})}}),T=c.extend({_click:function(){this.toolbar.dialog({name:"alignment"})}}),e.toolbar.registerComponent("alignment",S,T),D=l.extend({init:function(e,n){l.fn.init.call(this,e,n),this._defineButtons(),this._commandPalette(),this.popup.element.on("click",".k-button",function(e){this._action(t(e.currentTarget))}.bind(this)),this.element.data({type:"merge",merge:this,instance:this})},_defineButtons:function(){this.buttons=[{value:"cells",iconClass:"cells-merge",text:i.mergeButtons.mergeCells},{value:"horizontally",iconClass:"cells-merge-horizontally",text:i.mergeButtons.mergeHorizontally},{value:"vertically",iconClass:"cells-merge-vertically",text:i.mergeButtons.mergeVertically},{value:"unmerge",iconClass:"table-unmerge",text:i.mergeButtons.unmerge}]},destroy:function(){this.popup.element.off(),l.fn.destroy.call(this)},_commandPalette:function(){var e=t("<div />").appendTo(this.popup.element);this.buttons.forEach(function(t){var n="<a title='"+t.text+"' data-value='"+t.value+"' class='k-button k-button-icontext'><span class='k-icon k-i-"+t.iconClass+"'></span>"+t.text+"</a>";e.append(n)})},_action:function(e){var t=e.attr("data-value");this.toolbar.action({command:"MergeCellCommand",options:{value:t}})}}),A=c.extend({_click:function(){this.toolbar.dialog({name:"merge"})}}),e.toolbar.registerComponent("merge",D,A),E=l.extend({init:function(e,n){l.fn.init.call(this,e,n),this._defineButtons(),this._commandPalette(),this.popup.element.on("click",".k-button",function(e){this._action(t(e.currentTarget))}.bind(this)),this.element.data({type:"freeze",freeze:this,instance:this})},_defineButtons:function(){this.buttons=[{value:"panes",iconClass:"pane-freeze",text:i.freezeButtons.freezePanes},{value:"rows",iconClass:"row-freeze",text:i.freezeButtons.freezeRows},{value:"columns",iconClass:"column-freeze",text:i.freezeButtons.freezeColumns},{value:"unfreeze",iconClass:"table-unmerge",text:i.freezeButtons.unfreeze}]},destroy:function(){this.popup.element.off(),l.fn.destroy.call(this)},_commandPalette:function(){var e=t("<div />").appendTo(this.popup.element);this.buttons.forEach(function(t){var n="<a title='"+t.text+"' data-value='"+t.value+"' class='k-button k-button-icontext'><span class='k-icon k-i-"+t.iconClass+"'></span>"+t.text+"</a>";e.append(n)})},_action:function(e){var t=e.attr("data-value");this.toolbar.action({command:"FreezePanesCommand",options:{value:t}})}}),I=c.extend({_click:function(){this.toolbar.dialog({name:"freeze"})}}),e.toolbar.registerComponent("freeze",E,I),M=a.extend({_revertTitle:function(e){e.sender.value(""),e.sender.wrapper.width("auto")},init:function(e,t){a.fn.init.call(this,e,t);var n=this.dropDownList;n.bind("change",this._revertTitle.bind(this)),n.bind("dataBound",this._revertTitle.bind(this)),n.setOptions({valueTemplate:"<span class='k-icon k-i-"+e.iconClass+"' style='line-height: 1em; width: 1.35em;'></span>",template:"<span class='k-icon k-i-#= iconClass #' style='line-height: 1em; width: 1.35em;'></span>#=text#",dataTextField:"text",dataValueField:"value"}),n.setDataSource([{value:"asc",sheet:!1,text:i.sortButtons.sortRangeAsc,iconClass:"sort-asc"},{value:"desc",sheet:!1,text:i.sortButtons.sortRangeDesc,iconClass:"sort-desc"}]),n.select(0),this.element.data({type:"sort",sort:this})},_change:function(e){var t=e.sender,n=t.dataItem();n&&this.toolbar.action({command:"SortCommand",options:{value:n.value,sheet:n.sheet}})},value:t.noop}),R=c.extend({_click:function(){this.toolbar.dialog({name:"sort"})}}),e.toolbar.registerComponent("sort",M,R),F=e.toolbar.ToolBarButton.extend({init:function(t,n){t.showText="overflow",e.toolbar.ToolBarButton.fn.init.call(this,t,n),this.element.on("click",this._click.bind(this)),this.element.data({type:"filter",filter:this})},_click:function(){this.toolbar.action({command:"FilterCommand"})},update:function(e){this.toggle(e)}}),z=c.extend({init:function(e,t){c.fn.init.call(this,e,t),this.element.data({type:"filter",filter:this})},_click:function(){this.toolbar.action({command:"FilterCommand"})},update:function(e){this.toggle(e)}}),e.toolbar.registerComponent("filter",F,z),P=e.toolbar.Item.extend({init:function(e,n){this.toolbar=n,this.element=t("<div class='k-button k-upload-button k-button-icon'><span class='k-icon k-i-folder-open' /></div>").data("instance",this),this._title=e.attributes.title,this._reset()},_reset:function(){this.element.find("input").remove(),t("<input type='file' autocomplete='off' accept='.xlsx'/>").attr("title",this._title).attr("aria-label",this._title).one("change",this._change.bind(this)).appendTo(this.element)},_change:function(e){this.toolbar.action({command:"OpenCommand",options:{file:e.target.files[0]}}),this._reset()}}),e.toolbar.registerComponent("open",P),e.spreadsheet.TabStrip=e.ui.TabStrip.extend({init:function(n,i){e.ui.TabStrip.fn.init.call(this,n,i),n.addClass("k-spreadsheet-tabstrip"),this._quickAccessButtons(),this.toolbars={};var o=i.dataSource;this.contentElements.each(function(e,n){this._toolbar(t(n),o[e].id,i.toolbarOptions[o[e].id])}.bind(this)),this.one("activate",function(){this.toolbars[this.options.dataSource[0].id].resize()})},events:e.ui.TabStrip.fn.events.concat(["action","dialog"]),destroy:function(){this.quickAccessToolBar.off("click"),e.ui.TabStrip.fn.destroy.call(this);for(var t in this.toolbars)this.toolbars[t].destroy()},action:function(e){this.trigger("action",e)},dialog:function(e){this.trigger("dialog",e)},refreshTools:function(e){var t,n=this.toolbars;for(t in n)n.hasOwnProperty(t)&&n[t].refresh(e)},_quickAccessButtons:function(){var n=[{title:i.quickAccess.undo,iconClass:"undo",action:"undo"},{title:i.quickAccess.redo,iconClass:"redo",action:"redo"}],o=e.template("<a href='\\#' title='#= title #' data-action='#= action #' class='k-button k-button-icon' aria-label='#= title #'><span class='k-icon k-i-#=iconClass#'></span></a>");this.quickAccessToolBar=t("<div />",{"class":"k-spreadsheet-quick-access-toolbar",html:e.render(o,n)}).insertBefore(this.wrapper),this.quickAccessToolBar.on("click",".k-button",function(e){e.preventDefault();var n=t(e.currentTarget).attr("data-action");this.action({action:n})}.bind(this)),this.quickAccessAdjust()},quickAccessAdjust:function(){this.tabGroup.css("padding-left",e._outerWidth(this.quickAccessToolBar))},_toolbar:function(t,n,i){var o,r;this.toolbars[n]&&(this.toolbars[n].destroy(),t.children(".k-toolbar").remove()),i&&(o=t.html("<div />").children("div"),r={tools:"boolean"==typeof i?void 0:i,toolbarName:n,action:this.action.bind(this),dialog:this.dialog.bind(this)},this.toolbars[n]=new e.spreadsheet.ToolBar(o,r))}}))}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/dialogs.min",["kendo.core.min","kendo.binder.min","kendo.validator.min"],e)}(function(){!function(e){function t(t,n){return e.spreadsheet.formatting.text(t,n)}function n(e,t){var n,i=[],r=[];for(n=0;n<t.length;n++)o.inArray(t[n][e],r)==-1&&(i.push(t[n]),r.push(t[n][e]));return i}function i(t,n){e.spreadsheet.dialogs.register(t,u.extend({options:{messageId:n}}))}var o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C,S,T,D,A;e.support.browser.msie&&e.support.browser.version<9||(o=e.jQuery,r=e.data.ObservableObject,s=e.spreadsheet.messages.dialogs={apply:"Apply",save:"Save",cancel:"Cancel",remove:"Remove",retry:"Retry",revert:"Revert",okText:"OK",formatCellsDialog:{title:"Format",categories:{number:"Number",currency:"Currency",date:"Date"}},fontFamilyDialog:{title:"Font"},fontSizeDialog:{title:"Font size"},bordersDialog:{title:"Borders"},alignmentDialog:{title:"Alignment",buttons:{justtifyLeft:"Align left",justifyCenter:"Center",justifyRight:"Align right",justifyFull:"Justify",alignTop:"Align top",alignMiddle:"Align middle",alignBottom:"Align bottom"}},mergeDialog:{title:"Merge cells",buttons:{mergeCells:"Merge all",mergeHorizontally:"Merge horizontally",mergeVertically:"Merge vertically",unmerge:"Unmerge"}},freezeDialog:{title:"Freeze panes",buttons:{freezePanes:"Freeze panes",freezeRows:"Freeze rows",freezeColumns:"Freeze columns",unfreeze:"Unfreeze panes"}},confirmationDialog:{text:"Are you sure you want to remove this sheet?",title:"Sheet remove"},validationDialog:{title:"Data Validation",hintMessage:"Please enter a valid {0} value {1}.",hintTitle:"Validation {0}",criteria:{any:"Any value",number:"Number",text:"Text",date:"Date",custom:"Custom Formula",list:"List"},comparers:{greaterThan:"greater than",lessThan:"less than",between:"between",notBetween:"not between",equalTo:"equal to",notEqualTo:"not equal to",greaterThanOrEqualTo:"greater than or equal to",lessThanOrEqualTo:"less than or equal to"},comparerMessages:{greaterThan:"greater than {0}",lessThan:"less than {0}",between:"between {0} and {1}",notBetween:"not between {0} and {1}",equalTo:"equal to {0}",notEqualTo:"not equal to {0}",greaterThanOrEqualTo:"greater than or equal to {0}",lessThanOrEqualTo:"less than or equal to {0}",custom:"that satisfies the formula: {0}"},labels:{criteria:"Criteria",comparer:"Comparer",min:"Min",max:"Max",value:"Value",start:"Start",end:"End",onInvalidData:"On invalid data",rejectInput:"Reject input",showWarning:"Show warning",showHint:"Show hint",hintTitle:"Hint title",hintMessage:"Hint message",ignoreBlank:"Ignore blank",showListButton:"Display button to show list",showCalendarButton:"Display button to show calendar"},placeholders:{typeTitle:"Type title",typeMessage:"Type message"}},exportAsDialog:{title:"Export...",labels:{scale:"Scale",fit:"Fit to page",fileName:"File name",saveAsType:"Save as type",exportArea:"Export",paperSize:"Paper size",margins:"Margins",orientation:"Orientation",print:"Print",guidelines:"Guidelines",center:"Center",horizontally:"Horizontally",vertically:"Vertically"}},modifyMergedDialog:{errorMessage:"Cannot change part of a merged cell."},rangeDisabledDialog:{errorMessage:"Destination range contains disabled cells."},intersectsArrayDialog:{errorMessage:"You cannot alter part of an array"},incompatibleRangesDialog:{errorMessage:"Incompatible ranges"},noFillDirectionDialog:{errorMessage:"Cannot determine fill direction"},duplicateSheetNameDialog:{errorMessage:"Duplicate sheet name"},overflowDialog:{errorMessage:"Cannot paste, because the copy area and the paste area are not the same size and shape."},useKeyboardDialog:{title:"Copying and pasting",errorMessage:"These actions cannot be invoked through the menu. Please use the keyboard shortcuts instead:",labels:{forCopy:"for copy",forCut:"for cut",forPaste:"for paste"}},unsupportedSelectionDialog:{errorMessage:"That action cannot be performed on multiple selection."},linkDialog:{title:"Hyperlink",labels:{text:"Text",url:"Address",removeLink:"Remove link"}}},a={},e.spreadsheet.dialogs={register:function(e,t){a[e]=t},registered:function(e){return!!a[e]},create:function(e,t){var n=a[e];if(n)return new n(t)}},l=e.spreadsheet.SpreadsheetDialog=e.Observable.extend({init:function(t){e.Observable.fn.init.call(this,t),this.options=o.extend(!0,{},this.options,t),this.bind(this.events,t)},events:["close","activate"],options:{autoFocus:!0},dialog:function(){return this._dialog||(this._dialog=o("<div class='k-spreadsheet-window k-action-window k-popup-edit-form' />").addClass(this.options.className||"").append(e.template(this.options.template)({
messages:e.spreadsheet.messages.dialogs||s,errors:this.options.errors})).appendTo(document.body).kendoWindow({autoFocus:!1,scrollable:!1,resizable:!1,modal:!0,visible:!1,width:this.options.width||320,title:this.options.title,open:function(){this.center()},close:this._onDialogClose.bind(this),activate:this._onDialogActivate.bind(this),deactivate:this._onDialogDeactivate.bind(this)}).data("kendoWindow")),this._dialog},_onDialogClose:function(){this.trigger("close",{action:this._action})},_onDialogActivate:function(){this.trigger("activate")},_onDialogDeactivate:function(){this.trigger("deactivate"),this.destroy()},destroy:function(){this._dialog&&(this._dialog.destroy(),this._dialog=null)},open:function(){this.dialog().open(),this.dialog().element.find(".k-primary").focus()},apply:function(){this.close()},close:function(){this._action="close",this.dialog().close()}}),c=e.spreadsheet.FormatCellsViewModel=r.extend({init:function(e){r.fn.init.call(this,e),this.useCategory(this.category)},useCategory:function(e){var t=e&&e.type||"number",n="currency"==t;this.category=e,this.set("showCurrencyFilter",n&&this.currencies.length>1),n?this.currency(this.currencies[0]):this.set("formats",this.allFormats[t+"Formats"]),this.useFirstFormat()},useFirstFormat:function(){this.formats.length&&this.set("format",this.formats[0].value)},currency:function(e){var n,i;return void 0!==e&&(this._currency=e,n=e.value,i=[{currency:n,decimals:!0},{currency:n,decimals:!0,iso:!0},{currency:n,decimals:!1}],i=i.map(function(e){return e=c.convert.currency(e),{value:e,name:t(1e3,e)}}),this.set("formats",i),this.useFirstFormat()),this._currency||this.currencies[0]},categoryFilter:function(e){return void 0!==e&&this.useCategory(e),this.category},preview:function(){var e=this.get("format"),n=this.value||0;return e&&e.length?t(n,e):n}}),c.convert={currency:function(e){function t(e,t){return Array(t+1).join(e)}var n=e.currency,i=n.pattern[1];return e.decimals&&(i=i.replace(/n/g,"n"+n["."]+t("0",n.decimals))),i=e.iso?'"'+n.abbr+'" '+i.replace(/\s*\$\s*/g,""):i.replace(/\$/g,n.symbol),i=i.replace(/n/g,"?")},date:function(e){return/T|Z/.test(e)?"":e.toLowerCase().replace(/tt/g,"AM/PM").replace(/'/g,'"')}},d=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.formatCellsDialog||s,i={title:n.title,categories:[{type:"number",name:n.categories.number},{type:"currency",name:n.categories.currency},{type:"date",name:n.categories.date}]};l.fn.init.call(this,o.extend(i,t)),this._generateFormats()},options:{className:"k-spreadsheet-format-cells",template:"<div class='k-edit-form-container'><div class='k-root-tabs' data-role='tabstrip' data-text-field='name' data-bind='source: categories, value: categoryFilter' data-animation='false' /><div class='k-spreadsheet-preview' data-bind='text: preview' /><script type='text/x-kendo-template' id='format-item-template'>\\#: data.name \\#</script><select data-role='dropdownlist' class='k-format-filter' data-text-field='description' data-value-field='value.name' data-bind='visible: showCurrencyFilter, value: currency, source: currencies' /><ul data-role='staticlist' tabindex='0' class='k-list k-reset' data-template='format-item-template' data-value-primitive='true' data-value-field='value' data-bind='source: formats, value: format' /><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button><button class='k-button' data-bind='click: close'>#: messages.cancel #</button></div></div>"},_generateFormats:function(){var i,r=this.options;r.currencies||(r.currencies=d.currenciesFrom(e.cultures)),r.numberFormats||(r.numberFormats=[{value:"#.00%",name:"100.00%"},{value:"#%",name:"100%"},{value:"#.00",name:"1024.00"},{value:"#,###.00",name:"1,024.00"}]),r.dateFormats||(i=e.cultures.current.calendars.standard.patterns,r.dateFormats=n("value",o.map(i,function(e){if(e=c.convert.date(e))return{value:e,name:t(34567.7678,e)}})))},open:function(t){var n,i,o=this.options,r=t.value(),s=o.categories.slice(0);this.viewModel=new c({currencies:o.currencies.slice(0),allFormats:{numberFormats:o.numberFormats.slice(0),dateFormats:o.dateFormats.slice(0)},categories:s,format:t.format(),category:r instanceof Date?s[2]:s[0],apply:this.apply.bind(this),close:this.close.bind(this),value:r}),l.fn.open.call(this),n=this.dialog().element,e.bind(n,this.viewModel),i=n.find("select.k-format-filter").data("kendoDropDownList"),o.currencies.length>10&&i.setOptions({filter:"contains"}),n.find(e.roleSelector("staticlist")).parent().addClass("k-list-wrapper")},apply:function(){var e=this.viewModel.format;l.fn.apply.call(this),this.trigger("action",{command:"PropertyChangeCommand",options:{property:"format",value:e}})}}),d.currenciesFrom=function(t){return n("description",o.map(t,function(t,n){var i,o;if(/-/.test(n))return i=t.numberFormat.currency,o=e.format("{0} ({1}, {2})",i.name,i.abbr,i.symbol),{description:o,value:i}}))},e.spreadsheet.dialogs.register("formatCells",d),e.spreadsheet.dialogs.FormatCellsDialog=d,u=l.extend({options:{className:"k-spreadsheet-message",title:"",messageId:"",text:"",template:"<div class='k-spreadsheet-message-content' data-bind='text: text' /><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: close'>#= messages.okText #</button></div>"},open:function(){var t,n;l.fn.open.call(this),t=this.options,n=t.text,t.messageId&&(n=e.getter(t.messageId,!0)(e.spreadsheet.messages.dialogs)),e.bind(this.dialog().element,{text:n,close:this.close.bind(this)})}}),e.spreadsheet.dialogs.register("message",u),h=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.confirmationDialog||s,i={title:n.title,text:n.text};l.fn.init.call(this,o.extend(i,t))},options:{className:"k-spreadsheet-message",messageId:"",template:"<div class='k-spreadsheet-message-content' data-bind='text: text' /><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: confirm'>#= messages.okText #</button><button class='k-button' data-bind='click: cancel'>#= messages.cancel #</button></div>"},open:function(){var t,n;l.fn.open.call(this),t=this.options,n=t.text,t.messageId&&(n=e.getter(t.messageId,!0)(e.spreadsheet.messages.dialogs)),e.bind(this.dialog().element,{text:n,confirm:this.confirm.bind(this),cancel:this.close.bind(this)})},isConfirmed:function(){return this._confirmed},confirm:function(){this._confirmed=!0,this.close()}}),e.spreadsheet.dialogs.register("confirmation",h),f=l.extend({options:{className:"k-spreadsheet-message",title:"",messageId:"",text:"",template:"<div class='k-spreadsheet-message-content' data-bind='text: text' /><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: retry'>#= messages.retry #</button><button class='k-button' data-bind='click: cancel'>#= messages.cancel #</button></div>"},open:function(){var t,n;l.fn.open.call(this),t=this.options,n=t.text,t.messageId&&(n=e.getter(t.messageId,!0)(e.spreadsheet.messages.dialogs)),e.bind(this.dialog().element,{text:n,retry:this.retry.bind(this),cancel:this.close.bind(this)})},retry:function(){this._retry=!0,this.close()}}),e.spreadsheet.dialogs.register("validationError",f),p=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.fontFamilyDialog||s;l.fn.init.call(this,o.extend({title:n.title},t)),this._list()},options:{template:"<ul class='k-list k-reset'></ul>"},_list:function(){var t=this.dialog().element.find("ul"),n=this.options.fonts,i=this.options.defaultFont;this.list=new e.ui.StaticList(t,{dataSource:new e.data.DataSource({data:n}),template:"#: data #",value:i,change:this.apply.bind(this)}),this.list.dataSource.fetch()},apply:function(e){l.fn.apply.call(this),this.trigger("action",{command:"PropertyChangeCommand",options:{property:"fontFamily",value:e.sender.value()[0]}})}}),e.spreadsheet.dialogs.register("fontFamily",p),m=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.fontSizeDialog||s;l.fn.init.call(this,o.extend({title:n.title},t)),this._list()},options:{template:"<ul class='k-list k-reset'></ul>"},_list:function(){var t=this.dialog().element.find("ul"),n=this.options.sizes,i=this.options.defaultSize;this.list=new e.ui.StaticList(t,{dataSource:new e.data.DataSource({data:n}),template:"#: data #",value:i,change:this.apply.bind(this)}),this.list.dataSource.fetch()},apply:function(t){l.fn.apply.call(this),this.trigger("action",{command:"PropertyChangeCommand",options:{property:"fontSize",value:e.parseInt(t.sender.value()[0])}})}}),e.spreadsheet.dialogs.register("fontSize",m),g=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.bordersDialog||s;l.fn.init.call(this,o.extend({title:n.title},t)),this.element=this.dialog().element,this._borderPalette(),this.viewModel=e.observable({apply:this.apply.bind(this),close:this.close.bind(this)}),e.bind(this.element.find(".k-action-buttons"),this.viewModel)},options:{width:177,template:"<div></div><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button><button class='k-button' data-bind='click: close'>#: messages.cancel #</button></div>"},apply:function(){l.fn.apply.call(this);var e=this.value();this.trigger("action",{command:"BorderChangeCommand",options:{border:e.type,style:{size:1,color:e.color}}})},_borderPalette:function(){var t=this.dialog().element.find("div:first");this.borderPalette=new e.spreadsheet.BorderPalette(t,{change:this.value.bind(this)})},value:function(e){return void 0===e?this._state:void(this._state=e)}}),e.spreadsheet.dialogs.register("borders",g),v=l.extend({init:function(t){l.fn.init.call(this,t),this.element=this.dialog().element,this.property=t.property,this.options.title=t.title,this.viewModel=e.observable({apply:this.apply.bind(this),close:this.close.bind(this)}),e.bind(this.element.find(".k-action-buttons"),this.viewModel)},options:{template:"<div></div><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button><button class='k-button' data-bind='click: close'>#: messages.cancel #</button></div>"},apply:function(){l.fn.apply.call(this),this.trigger("action",{command:"PropertyChangeCommand",options:{property:this.property,value:this.value()}})},value:function(e){return void 0===e?this._value:void(this._value=e.value)}}),_=v.extend({init:function(e){e.width=177,v.fn.init.call(this,e),this._colorPalette()},_colorPalette:function(){var e=this.dialog().element.find("div:first");this.colorPalette=e.kendoColorPalette({palette:["#ffffff","#000000","#d6ecff","#4e5b6f","#7fd13b","#ea157a","#feb80a","#00addc","#738ac8","#1ab39f","#f2f2f2","#7f7f7f","#a7d6ff","#d9dde4","#e5f5d7","#fad0e4","#fef0cd","#c5f2ff","#e2e7f4","#c9f7f1","#d8d8d8","#595959","#60b5ff","#b3bcca","#cbecb0","#f6a1c9","#fee29c","#8be6ff","#c7d0e9","#94efe3","#bfbfbf","#3f3f3f","#007dea","#8d9baf","#b2e389","#f272af","#fed46b","#51d9ff","#aab8de","#5fe7d5","#a5a5a5","#262626","#003e75","#3a4453","#5ea226","#af0f5b","#c58c00","#0081a5","#425ea9","#138677","#7f7f7f","#0c0c0c","#00192e","#272d37","#3f6c19","#750a3d","#835d00","#00566e","#2c3f71","#0c594f"],change:this.value.bind(this)}).data("kendoColorPalette")}}),e.spreadsheet.dialogs.register("colorPicker",_),b=v.extend({init:function(e){e.width=268,v.fn.init.call(this,e),this.dialog().setOptions({animation:!1}),this.dialog().one("activate",this._colorPicker.bind(this))},_colorPicker:function(){var e=this.dialog().element.find("div:first");this.colorPicker=e.kendoFlatColorPicker({change:this.value.bind(this)}).data("kendoFlatColorPicker")}}),e.spreadsheet.dialogs.register("customColor",b),w=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.alignmentDialog||s,i={title:n.title,buttons:[{property:"textAlign",value:"left",iconClass:"align-left",text:n.buttons.justtifyLeft},{property:"textAlign",value:"center",iconClass:"align-center",text:n.buttons.justifyCenter},{property:"textAlign",value:"right",iconClass:"align-right",text:n.buttons.justifyRight},{property:"textAlign",value:"justify",iconClass:"align-justify",text:n.buttons.justifyFull},{property:"verticalAlign",value:"top",iconClass:"align-top",text:n.buttons.alignTop},{property:"verticalAlign",value:"center",iconClass:"align-middle",text:n.buttons.alignMiddle},{property:"verticalAlign",value:"bottom",iconClass:"align-bottom",text:n.buttons.alignBottom}]};l.fn.init.call(this,o.extend(i,t)),this._list()},options:{template:"<ul class='k-list k-reset'></ul>"},_list:function(){var t=this.dialog().element.find("ul");this.list=new e.ui.StaticList(t,{dataSource:new e.data.DataSource({data:this.options.buttons}),template:"<a title='#=text#' data-property='#=property#' data-value='#=value#'><span class='k-icon k-i-#=iconClass#'></span>#=text#</a>",change:this.apply.bind(this)}),this.list.dataSource.fetch()},apply:function(e){var t=e.sender.value()[0];l.fn.apply.call(this),this.trigger("action",{command:"PropertyChangeCommand",options:{property:t.property,value:t.value}})}}),e.spreadsheet.dialogs.register("alignment",w),y=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.mergeDialog||s,i={title:n.title,buttons:[{value:"cells",iconClass:"cells-merge",text:n.buttons.mergeCells},{value:"horizontally",iconClass:"cells-merge-horizontally",text:n.buttons.mergeHorizontally},{value:"vertically",iconClass:"cells-merge-vertically",text:n.buttons.mergeVertically},{value:"unmerge",iconClass:"table-unmerge",text:n.buttons.unmerge}]};l.fn.init.call(this,o.extend(i,t)),this._list()},options:{template:"<ul class='k-list k-reset'></ul>"},_list:function(){var t=this.dialog().element.find("ul");this.list=new e.ui.StaticList(t,{dataSource:new e.data.DataSource({data:this.options.buttons}),template:"<a title='#=text#' data-value='#=value#'><span class='k-icon k-icon k-i-#=iconClass#'></span>#=text#</a>",change:this.apply.bind(this)}),this.list.dataSource.fetch()},apply:function(e){var t=e.sender.value()[0];l.fn.apply.call(this),this.trigger("action",{command:"MergeCellCommand",options:{value:t.value}})}}),e.spreadsheet.dialogs.register("merge",y),k=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.freezeDialog||s,i={title:n.title,buttons:[{value:"panes",iconClass:"pane-freeze",text:n.buttons.freezePanes},{value:"rows",iconClass:"row-freeze",text:n.buttons.freezeRows},{value:"columns",iconClass:"column-freeze",text:n.buttons.freezeColumns},{value:"unfreeze",iconClass:"table-unmerge",text:n.buttons.unfreeze}]};l.fn.init.call(this,o.extend(i,t)),this._list()},options:{template:"<ul class='k-list k-reset'></ul>"},_list:function(){var t=this.dialog().element.find("ul");this.list=new e.ui.StaticList(t,{dataSource:new e.data.DataSource({data:this.options.buttons}),template:"<a title='#=text#' data-value='#=value#'><span class='k-icon k-icon k-i-#=iconClass#'></span>#=text#</a>",change:this.apply.bind(this)}),this.list.dataSource.fetch()},apply:function(e){var t=e.sender.value()[0];l.fn.apply.call(this),this.trigger("action",{command:"FreezePanesCommand",options:{value:t.value}})}}),e.spreadsheet.dialogs.register("freeze",k),x=e.spreadsheet.ValidationCellsViewModel=r.extend({init:function(e){r.fn.init.call(this,e),this.bind("change",function(e){"criterion"===e.field&&(this.reset(),"custom"!==this.criterion&&"list"!==this.criterion||this.setHintMessageTemplate()),"comparer"===e.field&&this.setHintMessageTemplate(),"hintMessage"!=e.field&&"hintTitle"!=e.field||this._mute||(this.shouldBuild=!1),"from"!=e.field&&"to"!=e.field&&"hintMessageTemplate"!=e.field&&"type"!=e.field||!this.shouldBuild||this.buildMessages()}.bind(this)),this.reset()},buildMessages:function(){this._mute=!0,this.set("hintTitle",this.hintTitleTemplate?e.format(this.hintTitleTemplate,this.type):""),this.set("hintMessage",this.hintMessageTemplate?e.format(this.hintMessageTemplate,this.from,this.to):""),this._mute=!1},reset:function(){this.setComparers(),this.set("comparer",this.comparers[0].type),this.set("from",null),this.set("to",null),this.set("useCustomMessages",!1),this.shouldBuild=!0,this.hintTitleTemplate=this.defaultHintTitle,this.buildMessages()},setComparers:function(){var e,t,n=this.defaultComparers,i=[];if("text"===this.criterion)for(e=["equalTo","notEqualTo"],t=0;t<n.length;t++)e[0]==n[t].type&&(i.push(n[t]),e.shift());else i=n.slice();this.set("comparers",i)},setHintMessageTemplate:function(){"custom"!==this.criterion&&"list"!==this.criterion?this.set("hintMessageTemplate",e.format(this.defaultHintMessage,this.criterion,this.comparerMessages[this.comparer])):(this.set("hintMessageTemplate",""),this.set("hintMessage",""))},isAny:function(){return"any"===this.get("criterion")},isNumber:function(){return"number"===this.get("criterion")},showToForNumber:function(){return this.showTo()&&this.isNumber()},showToForDate:function(){return this.showTo()&&this.isDate()},isText:function(){return"text"===this.get("criterion")},isDate:function(){return"date"===this.get("criterion")},isList:function(){return"list"===this.get("criterion")},isCustom:function(){return"custom"===this.get("criterion")},showRemove:function(){return this.get("hasValidation")},showTo:function(){return"between"==this.get("comparer")||"notBetween"==this.get("comparer")},update:function(e){this.set("hasValidation",!!e),e&&this.fromValidationObject(e)},fromValidationObject:function(e){this.set("criterion",e.dataType),this.set("comparer",e.comparerType),this.set("from",e.from),this.set("to",e.to),this.set("type",e.type),this.set("ignoreBlank",e.allowNulls),this.set("showButton",e.showButton),e.messageTemplate||e.titleTemplate?(this.hintMessageTemplate=e.messageTemplate,this.hintMessage=e.messageTemplate,this.hintTitleTemplate=e.titleTemplate,this.hintTitle=e.titleTemplate,this.useCustomMessages=!0,this.buildMessages()):this.useCustomMessages=!1},toValidationObject:function(){if("any"===this.criterion)return null;var e={type:this.type,dataType:this.criterion,comparerType:this.comparer,from:this.from,to:this.to,allowNulls:this.ignoreBlank,showButton:this.showButton};return this.useCustomMessages&&(e.messageTemplate=this.shouldBuild?this.hintMessageTemplate:this.hintMessage,e.titleTemplate=this.hintTitle),e}}),C=l.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.validationDialog||s,i={title:n.title,hintMessage:n.hintMessage,hintTitle:n.hintTitle,criteria:[{type:"any",name:n.criteria.any},{type:"number",name:n.criteria.number},{type:"text",name:n.criteria.text},{type:"date",name:n.criteria.date},{type:"custom",name:n.criteria.custom},{type:"list",name:n.criteria.list}],comparers:[{type:"greaterThan",name:n.comparers.greaterThan},{type:"lessThan",name:n.comparers.lessThan},{type:"between",name:n.comparers.between},{type:"notBetween",name:n.comparers.notBetween},{type:"equalTo",name:n.comparers.equalTo},{type:"notEqualTo",name:n.comparers.notEqualTo},{type:"greaterThanOrEqualTo",name:n.comparers.greaterThanOrEqualTo},{type:"lessThanOrEqualTo",name:n.comparers.lessThanOrEqualTo}],comparerMessages:n.comparerMessages};l.fn.init.call(this,o.extend(i,t))},options:{width:450,criterion:"any",type:"reject",ignoreBlank:!0,showButton:!0,useCustomMessages:!1,errorTemplate:'<div class="k-widget k-tooltip k-tooltip-validation" style="margin:0.5em"><span class="k-icon k-i-warning"> </span>#= message #<div class="k-callout k-callout-n"></div></div>',template:'<div class="k-edit-form-container"><div class="k-edit-label"><label>#: messages.validationDialog.labels.criteria #:</label></div><div class="k-edit-field"><select data-role="dropdownlist" title="#: messages.validationDialog.labels.criteria #"data-text-field="name" data-value-field="type" data-bind="value: criterion, source: criteria" /></div><div data-bind="visible: isNumber"><div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div><div class="k-edit-field"><select data-role="dropdownlist" title="#: messages.validationDialog.labels.comparer #"data-text-field="name" data-value-field="type" data-bind="value: comparer, source: comparers" /></div><div class="k-edit-label"><label>#: messages.validationDialog.labels.min #:</label></div><div class="k-edit-field"><input name="#: messages.validationDialog.labels.min #" title="#: messages.validationDialog.labels.min #" placeholder="e.g. 10" class="k-textbox" data-bind="value: from, enabled: isNumber" required="required" /></div><div data-bind="visible: showTo"><div class="k-edit-label"><label>#: messages.validationDialog.labels.max #:</label></div><div class="k-edit-field"><input name="#: messages.validationDialog.labels.max #" title="#: messages.validationDialog.labels.max #" placeholder="e.g. 100" class="k-textbox" data-bind="value: to, enabled: showToForNumber" required="required" /></div></div></div><div data-bind="visible: isText"><div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div><div class="k-edit-field"><select data-role="dropdownlist" title="#: messages.validationDialog.labels.comparer #"data-text-field="name" data-value-field="type" data-bind="value: comparer, source: comparers" /></div><div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div><div class="k-edit-field"><input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isText" required="required" /></div></div><div data-bind="visible: isDate"><div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div><div class="k-edit-field"><select data-role="dropdownlist" title="#: messages.validationDialog.labels.comparer #"data-text-field="name" data-value-field="type" data-bind="value: comparer, source: comparers" /></div><div class="k-edit-label"><label>#: messages.validationDialog.labels.start #:</label></div><div class="k-edit-field"><input name="#: messages.validationDialog.labels.start #" title="#: messages.validationDialog.labels.start #" class="k-textbox" data-bind="value: from, enabled: isDate" required="required" /></div><div data-bind="visible: showTo"><div class="k-edit-label"><label>#: messages.validationDialog.labels.end #:</label></div><div class="k-edit-field"><input name="#: messages.validationDialog.labels.end #" title="#: messages.validationDialog.labels.end #" class="k-textbox" data-bind="value: to, enabled: showToForDate" required="required" /></div></div></div><div data-bind="visible: isCustom"><div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div><div class="k-edit-field"><input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isCustom" required="required" /></div></div><div data-bind="visible: isList"><div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div><div class="k-edit-field"><input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isList" required="required" /></div></div><div data-bind="visible: isList"><div class="k-edit-field"><input type="checkbox" name="showButton" id="listShowButton" class="k-checkbox" data-bind="checked: showButton"/><label for="listShowButton" class="k-checkbox-label"> #: messages.validationDialog.labels.showListButton #</label></div></div><div data-bind="visible: isDate"><div class="k-edit-field"><input type="checkbox" name="showButton" id="dateShowButton" class="k-checkbox" data-bind="checked: showButton"/><label for="dateShowButton" class="k-checkbox-label"> #: messages.validationDialog.labels.showCalendarButton #</label></div></div><div data-bind="invisible: isAny"><div class="k-edit-field"><input type="checkbox" title="#: messages.validationDialog.labels.ignoreBlank #" name="ignoreBlank" id="ignoreBlank" class="k-checkbox" data-bind="checked: ignoreBlank"/><label for="ignoreBlank" class="k-checkbox-label"> #: messages.validationDialog.labels.ignoreBlank #</label></div></div><div data-bind="invisible: isAny"><div class="k-hr"></div><div class="k-edit-label"><label>#: messages.validationDialog.labels.onInvalidData #:</label></div><div class="k-edit-field"><input type="radio" title="#: messages.validationDialog.labels.rejectInput #" id="validationTypeReject" name="validationType" value="reject" data-bind="checked: type" class="k-radio" /><label for="validationTypeReject" class="k-radio-label">#: messages.validationDialog.labels.rejectInput #</label> <input type="radio" title="#: messages.validationDialog.labels.showWarning #" id="validationTypeWarning"  name="validationType" value="warning" data-bind="checked: type" class="k-radio" /><label for="validationTypeWarning" class="k-radio-label">#: messages.validationDialog.labels.showWarning #</label></div></div><div data-bind="invisible: isAny" class="hint-wrapper"><div class="k-edit-field"><input type="checkbox" title="#: messages.validationDialog.labels.showHint #" name="useCustomMessages" id="useCustomMessages" class="k-checkbox" data-bind="checked: useCustomMessages" /><label class="k-checkbox-label" for="useCustomMessages"> #: messages.validationDialog.labels.showHint #</label></div><div data-bind="visible: useCustomMessages"><div class="k-edit-label"><label>#: messages.validationDialog.labels.hintTitle #:</label></div><div class="k-edit-field"><input class="k-textbox" title="#: messages.validationDialog.labels.hintTitle #" placeholder="#: messages.validationDialog.placeholders.typeTitle #" data-bind="value: hintTitle" /></div><div class="k-edit-label"><label>#: messages.validationDialog.labels.hintMessage #:</label></div><div class="k-edit-field"><input class="k-textbox" title="#: messages.validationDialog.labels.hintMessage #" placeholder="#: messages.validationDialog.placeholders.typeMessage #" data-bind="value: hintMessage" /></div></div></div><div class="k-action-buttons"><button class="k-button" data-bind="visible: showRemove, click: remove">#: messages.remove #</button><button class="k-button k-primary" data-bind="click: apply">#: messages.apply #</button><button class="k-button" data-bind="click: close">#: messages.cancel #</button></div></div>'},open:function(t){var n,i=this.options;this.viewModel=new x({type:i.type,defaultHintMessage:i.hintMessage,defaultHintTitle:i.hintTitle,defaultComparers:i.comparers.slice(0),comparerMessages:i.comparerMessages,criteria:i.criteria.slice(0),criterion:i.criterion,ignoreBlank:i.ignoreBlank,showButton:i.showButton,apply:this.apply.bind(this),close:this.close.bind(this),remove:this.remove.bind(this)}),this.viewModel.update(t.validation()),l.fn.open.call(this),n=this.dialog().element,this.validatable&&this.validatable.destroy(),e.bind(n,this.viewModel),this.validatable=new e.ui.Validator(n.find(".k-edit-form-container"),{validateOnBlur:!1,errorTemplate:this.options.errorTemplate||void 0})},apply:function(){this.validatable.validate()&&(l.fn.apply.call(this),this.trigger("action",{command:"EditValidationCommand",options:{value:this.viewModel.toValidationObject()}}))},remove:function(){this.viewModel.set("criterion","any"),this.apply()}}),e.spreadsheet.dialogs.register("validation",C),e.spreadsheet.dialogs.ValidationDialog=C,S=l.extend({init:function(t){var n,i=e.spreadsheet.messages.dialogs.exportAsDialog||s;l.fn.init.call(this,o.extend({title:i.title},t)),this.viewModel=e.observable({title:this.options.title,name:this.options.name,extension:this.options.extension,fileFormats:this.options.fileFormats,excel:t.excelExport,pdf:{proxyURL:t.pdfExport.proxyURL,forceProxy:t.pdfExport.forceProxy,title:t.pdfExport.title,author:t.pdfExport.author,subject:t.pdfExport.subject,keywords:t.pdfExport.keywords,creator:t.pdfExport.creator,date:t.pdfExport.date,fitWidth:this.options.pdf.fitWidth,area:this.options.pdf.area,areas:this.options.pdf.areas,paperSize:this.options.pdf.paperSize,paperSizes:this.options.pdf.paperSizes,margin:this.options.pdf.margin,margins:this.options.pdf.margins,landscape:this.options.pdf.landscape,guidelines:this.options.pdf.guidelines,hCenter:this.options.pdf.hCenter,vCenter:this.options.pdf.vCenter},apply:this.apply.bind(this),close:this.close.bind(this)}),n=this.dialog(),this.viewModel.bind("change",function(e){"extension"===e.field&&(this.set("showPdfOptions",".pdf"===this.extension),n.center())}),e.bind(n.element,this.viewModel)},options:{name:"Workbook",extension:".xlsx",fileFormats:[{description:"Excel Workbook (.xlsx)",extension:".xlsx"},{description:"Portable Document Format(.pdf)",extension:".pdf"}],pdf:{fitWidth:!0,area:"workbook",areas:[{area:"workbook",text:"Entire Workbook"},{area:"sheet",text:"Active Sheet"},{area:"selection",text:"Selection"}],paperSize:"a4",paperSizes:[{value:"a2",text:"A2 (420 mm × 594 mm)     "},{value:"a3",text:"A3 (297 mm x 420 mm)     "},{value:"a4",text:"A4 (210 mm x 297 mm)     "},{value:"a5",text:"A5 (148 mm x 210 mm)     "},{value:"b3",text:"B3 (353 mm × 500 mm)     "},{value:"b4",text:"B4 (250 mm x 353 mm)     "},{value:"b5",text:"B5 (176 mm x 250 mm)     "},{value:"folio",text:'Folio (8.5" x 13")       '},{value:"legal",text:'Legal (8.5" x 14")       '},{value:"letter",text:'Letter (8.5" x 11")      '},{value:"tabloid",text:'Tabloid (11" x 17")      '},{value:"executive",text:'Executive (7.25" x 10.5")'}],margin:{bottom:"0.75in",left:"0.7in",right:"0.7in",top:"0.75in"},margins:[{value:{bottom:"0.75in",left:"0.7in",right:"0.7in",top:"0.75in"},text:"Normal"},{value:{bottom:"0.75in",left:"0.25in",right:"0.25in",top:"0.75in"},text:"Narrow"},{value:{bottom:"1in",left:"1in",right:"1in",top:"1in"},text:"Wide"}],landscape:!0,guidelines:!0,hCenter:!0,vCenter:!0},width:520,template:"<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.fileName #:</label></div><div class='k-edit-field'><input class='k-textbox' data-bind='value: name' /></div><div ><div class='k-edit-label'><label>#: messages.exportAsDialog.labels.saveAsType #:</label></div><div class='k-edit-field'><select data-role='dropdownlist' class='k-file-format' data-text-field='description' data-value-field='extension' data-bind='value: extension, source: fileFormats' /></div></div><div class='k-export-config' data-bind='visible: showPdfOptions'><hr class='k-hr' /><div class='k-edit-label'><label>#: messages.exportAsDialog.labels.exportArea #:</label></div><div class='k-edit-field'><select data-role='dropdownlist' class='k-file-format' data-text-field='text' data-value-field='area' data-bind='value: pdf.area, source: pdf.areas' /></div><div class='k-edit-label'><label>#: messages.exportAsDialog.labels.paperSize#:</label></div><div class='k-edit-field'><select data-role='dropdownlist' class='k-file-format' data-text-field='text' data-value-field='value' data-bind='value: pdf.paperSize, source: pdf.paperSizes' /></div><div class='k-edit-label'><label>#: messages.exportAsDialog.labels.margins #:</label></div><div class='k-edit-field'><select data-role='dropdownlist' class='k-file-format' data-value-primitive='true'data-text-field='text' data-value-field='value' data-bind='value: pdf.margin, source: pdf.margins' /></div><div class='k-edit-label'><label>#: messages.exportAsDialog.labels.orientation #:</label></div><div class='k-edit-field'><div class='k-button-group'><input type='radio' id='k-orientation-portrait' name='orientation' data-type='boolean' data-bind='checked: pdf.landscape' value='false' /><label class='k-button k-button-icon k-group-start k-orientation-button' for='k-orientation-portrait'><span class='k-icon k-i-page-portrait'></span></label><input type='radio' id='k-orientation-landscape' name='orientation' data-type='boolean' data-bind='checked: pdf.landscape' value='true' /><label class='k-button k-button-icon k-group-end k-orientation-button' for='k-orientation-landscape'><span class='k-icon k-i-page-landscape'></span></label></div></div><div class='k-edit-label'><label>#: messages.exportAsDialog.labels.print #:</label></div><div class='k-edit-field'><input class='k-checkbox' id='guidelines' type='checkbox' data-bind='checked: pdf.guidelines'/><label class='k-checkbox-label' for='guidelines'>#: messages.exportAsDialog.labels.guidelines#</label></div><div class='k-edit-label'><label>#: messages.exportAsDialog.labels.scale #:</label></div><div class='k-edit-field'><input class='k-checkbox' id='fitWidth' type='checkbox' data-bind='checked: pdf.fitWidth'/><label class='k-checkbox-label' for='fitWidth'>#: messages.exportAsDialog.labels.fit #</label></div><div class='k-edit-label'><label>#: messages.exportAsDialog.labels.center #:</label></div><div class='k-edit-field'><input class='k-checkbox' id='hCenter' type='checkbox' data-bind='checked: pdf.hCenter'/><label class='k-checkbox-label' for='hCenter'>#: messages.exportAsDialog.labels.horizontally #</label><input class='k-checkbox' id='vCenter' type='checkbox' data-bind='checked: pdf.vCenter'/><label class='k-checkbox-label' for='vCenter'>#: messages.exportAsDialog.labels.vertically #</label></div><div class='k-page-orientation'><span class='k-icon k-i-page-portrait' data-bind='invisible: pdf.landscape'></span><span class='k-icon k-i-page-landscape' data-bind='visible: pdf.landscape'></span></div></div><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: apply'>#: messages.save #</button><button class='k-button' data-bind='click: close'>#: messages.cancel #</button></div>"
},apply:function(){l.fn.apply.call(this),this.trigger("action",{command:"SaveAsCommand",options:this.viewModel})}}),e.spreadsheet.dialogs.register("exportAs",S),i("modifyMerged","modifyMergedDialog.errorMessage"),i("rangeDisabled","rangeDisabledDialog.errorMessage"),i("intersectsArray","intersectsArrayDialog.errorMessage"),i("overflow","overflowDialog.errorMessage"),i("unsupportedSelection","unsupportedSelectionDialog.errorMessage"),i("incompatibleRanges","incompatibleRangesDialog.errorMessage"),i("noFillDirection","noFillDirectionDialog.errorMessage"),i("duplicateSheetName","duplicateSheetNameDialog.errorMessage"),T=u.extend({options:{width:640,title:"Errors in import",template:"<div class='k-spreadsheet-message-content k-spreadsheet-import-errors'><div class='k--header-message'>We encountered #= errors.length # errors while reading this file.  Please be aware that some formulas might be missing, or contain invalid results.</div><div class='k--errors'><table><thead><tr><th>Context</th><th>Error message</th></tr></thead># for (var i = 0; i < errors.length; ++i) { ## var err = errors[i]; #<tr><td>#: err.context #</td><td>#: err.error #</td></tr># } #</table></div></div><div class='k-action-buttons'><button class='k-button k-primary' data-bind='click: close'>#: messages.okText #</button></div>"}}),e.spreadsheet.dialogs.register("importError",T),D=u.extend({init:function(t){var n=e.spreadsheet.messages.dialogs.useKeyboardDialog||s;l.fn.init.call(this,o.extend({title:n.title},t))},options:{template:"#: messages.useKeyboardDialog.errorMessage #<div>Ctrl+C #: messages.useKeyboardDialog.labels.forCopy #</div><div>Ctrl+X #: messages.useKeyboardDialog.labels.forCut #</div><div>Ctrl+V #: messages.useKeyboardDialog.labels.forPaste #</div><div class=\"k-action-buttons\"><button class='k-button k-primary' data-bind='click: close'>#= messages.okText #</button></div>"}}),e.spreadsheet.dialogs.register("useKeyboard",D),A=l.extend({options:{template:"<div class='k-edit-label'><label>#: messages.linkDialog.labels.url #:</label></div><div class='k-edit-field'><input class='k-textbox' data-bind='value: url' title='#: messages.linkDialog.labels.url #' /></div><div class='k-action-buttons'><button class='k-button k-left' data-bind='click: remove'>#= messages.linkDialog.labels.removeLink #</button><button class='k-button k-primary' data-bind='click: apply'>#= messages.okText #</button><button class='k-button' data-bind='click: cancel'>#= messages.cancel #</button></div>",title:s.linkDialog.title,autoFocus:!1},open:function(t){var n,i,r=this;l.fn.open.apply(r,arguments),n=r.dialog().element,i=e.observable({url:t.link(),apply:function(){/\S/.test(i.url)||(i.url=null),r.trigger("action",{command:"HyperlinkCommand",options:{link:i.url}}),r.close()},remove:function(){i.url=null,i.apply()},cancel:r.close.bind(r)}),e.bind(n,i),n.find("input").focus().on("keydown",function(e){13==e.keyCode?(i.url=o(this).val(),e.stopPropagation(),e.preventDefault(),i.apply()):27==e.keyCode&&(e.stopPropagation(),e.preventDefault(),i.cancel())})}}),e.spreadsheet.dialogs.register("hyperlink",A))}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/sheetbinder.min",["kendo.core.min","kendo.data.min","spreadsheet/sheet.min"],e)}(function(){!function(e){var t,n;e.support.browser.msie&&e.support.browser.version<9||(t=function(e){return e},n=e.Class.extend({init:function(e){this.options=$.extend({},this.options,e),this.columns=this._normalizeColumns(this.options.columns),this._sheet(),this._dataSource(),this._header(),this._boundRowsCount=0,this.dataSource.fetch()},_sheet:function(){this.sheet=this.options.sheet,this._sheetChangeHandler=this._sheetChange.bind(this),this._sheetDeleteRowHandler=this._sheetDeleteRow.bind(this),this._sheetInsertRowHandler=this._sheetInsertRow.bind(this),this.sheet.bind("change",this._sheetChangeHandler).bind("afterDeleteRow",this._sheetDeleteRowHandler).bind("afterInsertRow",this._sheetInsertRowHandler)},_sheetInsertRow:function(e){void 0!==e.index&&this.dataSource.insert(Math.max(e.index-1,0),{})},_sheetDeleteRow:function(e){var t,n;void 0!==e.index&&(t=this.dataSource,n=t.view()[e.index-1],n&&t.remove(n))},_header:function(){this.sheet.batch(function(){this.columns.forEach(function(e,t){this.sheet.range(0,t).value(e.title)}.bind(this))}.bind(this))},_sheetChange:function(n){var i,o,r,s,a,l,c;n.insertRow||n.deleteRow||n.recalc&&n.ref&&(i=this.dataSource,o=i.view(),r=this.columns,i.reader.model&&(s=i.reader.model.fields),!r.length&&o.length&&(r=Object.keys(o[0].toJSON())),a=r.map(function(n){var i=n.field;return i&&s&&s[i]&&"date"==s[i].type?e.spreadsheet.numberToDate:t}),this._skipRebind=!0,l=this.sheet._grid.normalize(n.ref),c=this.sheet.range(l).values(),l.forEach(function(e){var t,n,s,l,d;for(e=e.toRangeRef(),n=0,s=e.topLeft.row;s<=e.bottomRight.row;s++){for(t=o[s-1],t||(t=i.insert(s-1,{}),o=i.view()),l=0,d=e.topLeft.col;d<=e.bottomRight.col&&d<r.length;d++)t.set(r[d].field,a[d](c[n][l++]));n++}}),this._boundRowsCount=i.view().length,this._skipRebind=!1)},_normalizeColumns:function(e){return e.map(function(e){var t=e.field||e;return{field:t,title:e.title||t}})},_dataSource:function(){var t=this.options,n=t.dataSource;n=Array.isArray(n)?{data:n}:n,this.dataSource&&this._changeHandler?this.dataSource.unbind("change",this._changeHandler):this._changeHandler=this._change.bind(this),this.dataSource=e.data.DataSource.create(n).bind("change",this._changeHandler)},_change:function(){var t,n,i;this._skipRebind||(t=this.dataSource.view(),n=this.columns,!n.length&&t.length&&(this.columns=n=this._normalizeColumns(Object.keys(t[0].toJSON())),this._header()),i=n.map(function(t){return e.getter(t.field)}),this.sheet.batch(function(){var e,n,o,r=Math.max(t.length,this._boundRowsCount);for(e=0;e<r;e++)for(n=0;n<i.length;n++)o=t[e]?i[n](t[e]):null,this.sheet.range(e+1,n).value(o)}.bind(this)),this._boundRowsCount=t.length)},destroy:function(){this.dataSource.unbind("change",this._changeHandler),this.sheet.unbind("change",this._sheetChangeHandler).unbind("deleteRow",this._sheetDeleteRowHandler).unbind("insertRow",this._sheetInsertRowHandler)},options:{columns:[]}}),e.spreadsheet.SheetDataSourceBinder=n)}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/filtermenu.min",["kendo.core.min","kendo.popup.min","kendo.treeview.min","kendo.numerictextbox.min","kendo.datepicker.min","kendo.datetimepicker.min"],e)}(function(){!function(e){function t(e){var t,n={},i=[];for(t=0;t<e.length;t++)n[e[t].value]?!n[e[t].value].checked&&e[t].checked&&(n[e[t].value].checked=!0):(n[e[t].value]=e[t],i.push(e[t]));return i}function n(t,i){var o,r,s,a,l,c,d=!1,u=t instanceof e.data.HierarchicalDataSource&&t.data(),h=this,f=this.values;for(o=0;o<u.length;o++)r=u[o],s=(""+r.text).toLowerCase(),a=i===!0||""===i||s.indexOf(i)>=0,l=n.bind(h),c=l(r.children,i),d=d||c||a,r.hidden=!a&&!c,i.length||f&&!f.length?r.checked=!r.hidden:f&&f.indexOf(r.text)!=-1&&(r.checked=!0);return u&&t.filter({field:"hidden",operator:"neq",value:!0}),d}function i(t){var n,o,r=t instanceof e.data.HierarchicalDataSource&&t.data();for(n=0;n<r.length;n++)o=r[n],o.checked=!1,o.hasChildren&&i(o.children)}function o(e){var t,n,i=c.operators,o=[];for(t in e)if(e.hasOwnProperty(t))for(n in e[t])e[t].hasOwnProperty(n)&&o.push({text:i[t][n],value:n,unique:t+"_"+n,type:t});return o}var r,s,a,l,c,d,u,h,f;e.support.browser.msie&&e.support.browser.version<9||(r=e.jQuery,s=e.ui.Widget,a={details:"k-details",button:"k-button",detailsSummary:"k-details-summary",detailsContent:"k-details-content",icon:"k-icon",iconCollapse:"k-i-arrow-45-down-right",iconExpand:"k-i-arrow-60-right",iconSearch:"k-i-zoom",textbox:"k-textbox",wrapper:"k-spreadsheet-filter-menu",filterByCondition:"k-spreadsheet-condition-filter",filterByValue:"k-spreadsheet-value-filter",valuesTreeViewWrapper:"k-spreadsheet-value-treeview-wrapper",actionButtons:"k-action-buttons"},l=s.extend({init:function(t,n){s.fn.init.call(this,t,n),this.element.addClass(f.classNames.details),this._summary=this.element.find("."+f.classNames.detailsSummary).on("click",this._toggle.bind(this));var i=n.expanded?f.classNames.iconCollapse:f.classNames.iconExpand;this._icon=r("<span />",{"class":f.classNames.icon+" "+i}).prependTo(this._summary),this._container=e.wrap(this._summary.next(),!0),n.expanded||this._container.hide()},options:{name:"Details"},events:["toggle"],visible:function(){return this.options.expanded},toggle:function(t){var n=e.fx(this._container).expand("vertical");n.stop()[t?"reverse":"play"](),this._icon.toggleClass(f.classNames.iconExpand,t).toggleClass(f.classNames.iconCollapse,!t),this.options.expanded=!t},_toggle:function(){var e=this.visible();this.toggle(e),this.trigger("toggle",{show:e})}}),c=e.spreadsheet.messages.filterMenu={sortAscending:"Sort range A to Z",sortDescending:"Sort range Z to A",filterByValue:"Filter by value",filterByCondition:"Filter by condition",apply:"Apply",search:"Search",addToCurrent:"Add to current selection",clear:"Clear",blanks:"(Blanks)",operatorNone:"None",and:"AND",or:"OR",operators:{string:{contains:"Text contains",doesnotcontain:"Text does not contain",startswith:"Text starts with",endswith:"Text ends with",matches:"Text matches",doesnotmatch:"Text does not match"},date:{eq:"Date is",neq:"Date is not",lt:"Date is before",gt:"Date is after"},number:{eq:"Is equal to",neq:"Is not equal to",gte:"Is greater than or equal to",gt:"Is greater than",lte:"Is less than or equal to",lt:"Is less than"}}},e.data.binders.spreadsheetFilterValue=e.data.Binder.extend({init:function(t,n,i){e.data.Binder.fn.init.call(this,t,n,i),this._change=r.proxy(this.change,this),r(this.element).on("change",this._change)},refresh:function(){var e=this,t=e.bindings.spreadsheetFilterValue.get();r(e.element).val(t instanceof Date?"":t)},change:function(){var e=this.element.value;this.bindings.spreadsheetFilterValue.set(e)}}),e.data.binders.widget.spreadsheetFilterValue=e.data.Binder.extend({init:function(t,n,i){e.data.Binder.fn.init.call(this,t.element[0],n,i),this.widget=t,this._change=r.proxy(this.change,this),this.widget.first("change",this._change)},refresh:function(){var e=this.bindings.spreadsheetFilterValue,t=e.get(),n=r(this.widget.element).data("filterType");this.widget.value("date"===n&&t instanceof Date||"number"===n&&!isNaN(t)?t:null)},change:function(){var e=this.widget.value(),t=this.bindings.spreadsheetFilterValue;t.set(e)}}),d={filterByValue:"<div class='"+a.detailsSummary+"'>#= messages.filterByValue #</div><div class='"+a.detailsContent+"'><div class='k-textbox k-space-right'><input placeholder='#= messages.search #' data-#=ns#bind='events: { input: filterValues }' /><span class='k-icon k-i-zoom' /></div><div data-#=ns#bind='visible: hasActiveSearch'><input class='k-checkbox' type='checkbox' data-#=ns#bind='checked: appendToSearch' id='_#=guid#' /><label class='k-checkbox-label' for='_#=guid#'>#= messages.addToCurrent #</label></div><div class='"+a.valuesTreeViewWrapper+"'><div data-#=ns#role='treeview' data-#=ns#checkboxes='{ checkChildren: true }' data-#=ns#bind='source: valuesDataSource, events: { check: valuesChange, select: valueSelect }' /></div></div>",filterByCondition:"<div class='"+a.detailsSummary+"'>#= messages.filterByCondition #</div><div class='"+a.detailsContent+'\'><div><select data-#=ns#role="dropdownlist"data-#=ns#bind="value: operator, source: operators, events: { change: operatorChange } "data-value-primitive="false"data-option-label="#=messages.operatorNone#"data-height="auto"data-text-field="text"data-value-field="unique"></select></div><div data-#=ns#bind="visible: isString"><input data-filter-type="string" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" class="k-textbox" /></div><div data-#=ns#bind="visible: isNumber"><input data-filter-type="number" data-#=ns#role="numerictextbox" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" /></div><div data-#=ns#bind="visible: isDate"><input data-filter-type="date" data-#=ns#role="datepicker" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" /></div></div>',menuItem:"<li data-command='#=command#' data-dir='#=dir#'><span class='k-icon k-i-#=iconClass#'></span>#=text#</li>",actionButtons:"<button data-#=ns#bind='click: apply' class='k-button k-primary'>#=messages.apply#</button><button data-#=ns#bind='click: clear' class='k-button'>#=messages.clear#</button>"},u=e.spreadsheet.FilterMenuViewModel=e.data.ObservableObject.extend({valuesChange:function(t){var n=t?t.sender.dataSource:this.valuesDataSource,i=function(e){return e.checked},o=function(t){return"date"===t.dataType?e.spreadsheet.dateToNumber(t.value):t.value},r=function(e,t,n){return n.lastIndexOf(e)===t},s=n.data(),a=s[0].children.data().toJSON(),l=a.filter(function(e){return"blank"===e.dataType});l=!!l.length&&l[0].checked,a=a.filter(i).map(o),this.appendToSearch&&this.valueFilter&&this.valueFilter.values.length&&(a=a.concat(this.valueFilter.values.toJSON()).sort().filter(r)),this.set("valueFilter",{values:a,blanks:l})},valueSelect:function(e){e.preventDefault();var t=e.sender.dataItem(e.node);t.set("checked",!t.checked)},hasActiveSearch:!1,appendToSearch:!1,filterValues:function(e){var t,o="string"==typeof e?e:r(e.target).val().toLowerCase(),s=this.valuesDataSource;this.set("hasActiveSearch",!!o),t=n.bind(this.valueFilter),i(s),t(s,o)},reset:function(){this.set("customFilter",{logic:"and",criteria:[{operator:null,value:null}]}),this.set("valueFilter",{values:[]})},operatorChange:function(e){var t=e.sender.dataItem();this.set("operatorType",t.type),this.get("customFilter")||this.reset(),this.set("customFilter.criteria[0].operator",t.value)},isNone:function(){return void 0===this.get("operatorType")},isString:function(){return"string"===this.get("operatorType")},isNumber:function(){return"number"===this.get("operatorType")},isDate:function(){return"date"===this.get("operatorType")}}),h=e.spreadsheet.FilterMenuController={valuesTree:function(e,t){return[{text:"All",expanded:!0,checked:!1,items:this.values(e.resize({top:1}),t)}]},values:function(n,i){var o=[],r=c,s=n.column(i),a=n.sheet();return s.forEachCell(function(t,n,i){var s,l,c,d=!0;a.isHiddenRow(t)&&(d=!1),s=i.value,l=i.dataType,c=i.text,l=void 0===s?"blank":i.format?e.spreadsheet.formatting.type(s,i.format):typeof s,c=null!==s&&i.format?e.spreadsheet.formatting.text(s,i.format):"blank"==l?r.blanks:s,"percent"!==l&&"currency"!==l||(l="number"),"date"===l&&(s=e.spreadsheet.numberToDate(s)),o.push({dataType:l,value:s,text:c,checked:d})}),o=t(o),o.sort(function(e,t){return e.dataType===t.dataType?0:"blank"===e.dataType||"blank"===t.dataType?"blank"===e.dataType?-1:1:"number"===e.dataType||"number"===t.dataType?"number"===e.dataType?-1:1:"date"===e.dataType||"date"===t.dataType?"date"===e.dataType?-1:1:0}),o},filterType:function(e,t){var n,i,o,r=e.sheet(),s=this.filterForColumn(t,r);return s=s&&s.filter.toJSON(),s&&"custom"==s.filter&&(i=s.criteria[0].value,i instanceof Date?n="date":"string"==typeof i?n="string":"number"==typeof i&&(n="number")),n||(o=this.values(e.row(1),t)[0],n=o&&o.dataType,"blank"==n&&(n=null)),n},filterForColumn:function(e,t){var n,i=t.filter();return i&&(n=i.columns.filter(function(t){return t.index===e})[0]),n},filter:function(e,t){var n,i,o,r,s=this.filterForColumn(e,t);if(s)return n=s.filter.toJSON(),i=n.filter,delete n.filter,o={type:i,options:n},r=n.criteria,r&&r.length&&(o.operator=r[0].operator),o}},f=s.extend({init:function(e,t){s.call(this,e,t),this.element.addClass(f.classNames.wrapper),this.viewModel=new u({active:"value",operator:null,operators:o(this.options.operators),clear:this.clear.bind(this),apply:this.apply.bind(this)}),this._filterInit(),this._popup(),this._sort(),this._filterByCondition(),this._filterByValue(),this._actionButtons()},options:{name:"FilterMenu",column:0,range:null,operators:{string:{contains:"Text contains",doesnotcontain:"Text does not contain",startswith:"Text starts with",endswith:"Text ends with",matches:"Text matches",doesnotmatch:"Text does not match"},date:{eq:"Date is",neq:"Date is not",lt:"Date is before",gt:"Date is after"},number:{eq:"Is equal to",neq:"Is not equal to",gte:"Is greater than or equal to",gt:"Is greater than",lte:"Is less than or equal to",lt:"Is less than"}}},events:["action"],destroy:function(){s.fn.destroy.call(this),this.menu.destroy(),this.valuesTreeView.destroy(),this.popup.destroy()},openFor:function(e){this.popup.setOptions({anchor:e}),this.popup.open()},close:function(){this.popup.close()},clear:function(){this.action({command:"ClearFilterCommand",options:{column:this.options.column}}),this.viewModel.reset(),this.close()},apply:function(){var e,t,n;this._active(),e={operatingRange:this.options.range,column:this.options.column},"value"===this.viewModel.active?(this.viewModel.valuesChange({sender:this.valuesTreeView}),t=this.viewModel.valueFilter.toJSON(),(t.blanks||t.values&&t.values.length)&&(e.valueFilter=t)):"custom"===this.viewModel.active&&(n=this.viewModel.customFilter.toJSON(),n.criteria.length&&null!==n.criteria[0].value&&(e.customFilter=n)),(e.valueFilter||e.customFilter)&&this.action({command:"ApplyFilterCommand",options:e})},action:function(e){this.trigger("action",r.extend({},e))},_filterInit:function(){var e,t=this.options.column,n=this.options.range,i=n.sheet(),o=h.filter(t,i);o?(e=h.filterType(n,t),this.viewModel.set("active",o.type),this.viewModel.set(o.type+"Filter",o.options),"custom"==o.type&&(this.viewModel.set("operator",e+"_"+o.operator),this.viewModel.set("operatorType",e))):this.viewModel.reset()},_popup:function(){this.popup=this.element.kendoPopup({copyAnchorStyles:!1}).data("kendoPopup")},_sort:function(){var t=e.template(f.templates.menuItem),n=c,i=[{command:"sort",dir:"asc",text:n.sortAscending,iconClass:"sort-asc"},{command:"sort",dir:"desc",text:n.sortDescending,iconClass:"sort-desc"}],o=r("<ul />",{html:e.render(t,i)}).appendTo(this.element);this.menu=o.kendoMenu({orientation:"vertical",select:function(e){var t=r(e.item).data("dir"),n=this.options.range.resize({top:1}),i={value:t,sheet:!1,operatingRange:n,column:this.options.column};n.isSortable()?this.action({command:"SortCommand",options:i}):this.close()}.bind(this)}).data("kendoMenu")},_appendTemplate:function(t,n,i,o){var s=e.template(t),a=r("<div class='"+n+"'/>").html(s({messages:c,guid:e.guid(),ns:e.ns}));return this.element.append(a),i&&(i=new l(a,{expanded:o,toggle:this._detailToggle.bind(this)})),e.bind(a,this.viewModel),a},_detailToggle:function(e){this.element.find("[data-role=details]").not(e.sender.element).data("kendoDetails").toggle(!e.show)},_filterByCondition:function(){var e="custom"===this.viewModel.active;this._appendTemplate(f.templates.filterByCondition,f.classNames.filterByCondition,!0,e)},_filterByValue:function(){var t,n="value"===this.viewModel.active,i=this._appendTemplate(f.templates.filterByValue,f.classNames.filterByValue,!0,n);this.valuesTreeView=i.find("[data-role=treeview]").data("kendoTreeView"),t=h.valuesTree(this.options.range,this.options.column),this.viewModel.set("valuesDataSource",new e.data.HierarchicalDataSource({data:t}))},_actionButtons:function(){this._appendTemplate(f.templates.actionButtons,f.classNames.actionButtons,!1)},_active:function(){var e=this.element.find("[data-role=details]").filter(function(e,t){return r(t).data("kendoDetails").visible()});e.hasClass(f.classNames.filterByValue)?this.viewModel.set("active","value"):e.hasClass(f.classNames.filterByCondition)&&this.viewModel.set("active","custom")}}),e.spreadsheet.FilterMenu=f,r.extend(!0,f,{classNames:a,templates:d}))}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/editor.min",["kendo.core.min"],e)}(function(){!function(e){function t(e,t){return e&&(e.top!==t.top||e.left!==t.left)}if(!(e.support.browser.msie&&e.support.browser.version<9)){var n=e.Observable.extend({init:function(t){e.Observable.fn.init.call(this),this.view=t,this.formulaBar=t.formulaBar,this._active=!1,this.barInput=t.formulaBar.formulaInput,this.cellInput=t.formulaInput,this.barInput.syncWith(this.cellInput),this.cellInput.syncWith(this.barInput),this.barInput.bind("keyup",this._triggerUpdate.bind(this)),this.cellInput.bind("keyup",this._triggerUpdate.bind(this)),this.barInput.bind("blur",this._blur.bind(this)),this.cellInput.bind("blur",this._blur.bind(this))},events:["activate","deactivate","change","update"],_blur:function(){this.deactivate()},_triggerUpdate:function(){this.trigger("update",{value:this.value()})},activeEditor:function(){var t=null,n=e._activeElement();return this.barElement()[0]===n?t=this.barInput:this.cellElement()[0]===n&&(t=this.cellInput),t},activate:function(e){return this._active=!0,this._rect=e.rect,this._range=e.range,this.cellInput.position(e.rect),this.cellInput.resize(e.rect),this.cellInput.tooltip(e.tooltip),this.cellInput.activeCell=this.barInput.activeCell=this._range.topLeft(),this.cellInput.activeSheet=this.barInput.activeSheet=this._range._sheet,this.trigger("activate"),this},deactivate:function(e){var t=this.cellInput;this._active&&(this._active=!1,e||t.value()==this._value||this.trigger("change",{value:t.value(),range:this._range}),this._rect=null,t.hide(),this.trigger("deactivate"))},enable:function(e){this.barInput.enable(e),this.cellInput.enable(e)},barElement:function(){return this.barInput.element},cellElement:function(){return this.cellInput.element},focus:function(e){e=e||"cell","cell"===e?(this.cellInput.element.focus(),this.cellInput.end()):this.barInput.element.focus()},isActive:function(){return this._active},isFiltered:function(){return this.barInput.popup.visible()||this.cellInput.popup.visible()},canInsertRef:function(e){var t=this.activeEditor();return t&&t.canInsertRef(e)},highlightedRefs:function(){var e=this.activeEditor(),t=[];return e&&(t=e.highlightedRefs()),t},scale:function(){this.cellInput.scale()},toggleTooltip:function(e){this.cellInput.toggleTooltip(t(this._rect,e))},value:function(e,t){return void 0===e?this.barInput.value():(null===e&&(e=""),this._value=e,this.barInput.value(e),this.cellInput.value(e),void this.barInput.element.toggleClass("k-spreadsheet-array-formula",!!t))},insertNewline:function(){this.activeEditor().insertNewline(),this.scale()},select:function(){this.activeEditor().select()}});e.spreadsheet.SheetEditor=n}}(kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/autofill.min",["spreadsheet/runtime.min","spreadsheet/range.min"],e)}(function(){"use strict";function e(e){var t,n,i,o,r,s=e.length,a=(s+1)/2,l=e.reduce(function(e,t){return e+t},0)/s,c=0,d=0;for(t=0;t<s;t++)n=t+1-a,i=e[t]-l,c+=n*i,d+=n*n;return d?(o=c/d,r=l-o*a,function(e){return r+o*(e+1)}):function(t){return e[t%e.length]}}function t(t){function o(e){var t,n=e[1]-e[0];for(t=2;t<e.length;++t)if(e[t]-e[t-1]!=n)return null;return n}function r(e){return e.map(function(e){return e.number})}var s=[],a=t.map(function(e){return e.formula||e.value});return i(a,function(t,n,i,l){var c,d,u,h,f;for("number"==i?(d=r(l),c=e(d)):"string"==i||"formula"==i||"boolean"==i?c=function(e,t){return a[t]}:Array.isArray(i)?1==l.length?c=function(e){return i[(l[0].number+e)%i.length]}:(u=o(r(l)),c=null==u?function(e){return l[e%l.length].value}:function(e){var t=l[0].number+u*e;return i[t%i.length]}):"null"!=i?(d=r(l),1==d.length&&d.push(d[0]+1),d=e(d),c=function(e,t){return a[t].replace(/^(.*\D)\d+/,"$1"+d(e,t))}):c=function(){return null},h={f:c,begin:t,end:n,len:n-t},f=t;f<n;++f)s[f]=h}),function(e,i){var o=s[i],r=e/a.length|0,l=e%a.length,c=r*o.len+l-o.begin,d=o.f(c,i),h=n(t[i]);return delete h.enable,d instanceof u?h.formula=d:h.value=d,h}}function n(e){var t={};return Object.keys(e||{}).forEach(function(n){t[n]=e[n]}),t}function i(e,t){var n,i,r=null,s=0,a=[];for(i=0;i<e.length;++i)n=o(e[i]),a.push(n),null!=r&&n.type!==r.type&&(t(s,i,r.type,a.slice(s,i)),s=i),r=n;t(s,i,r.type,a.slice(s,i))}function o(e){var t,n;if("number"==typeof e)return{type:"number",number:e};if("string"==typeof e)return(t=s(e))?t:(n=/^(.*\D)(\d+)/.exec(e),n?(e=e.replace(/^(.*\D)\d+/,"$1-######"),{type:e,match:n,number:parseFloat(n[2])}):{type:"string"});if("boolean"==typeof e)return{type:"boolean"};if(null==e)return{type:"null"};if(e instanceof u)return{type:"formula"};throw window.console.error(e),Error("Cannot fill data")}function r(){var e=kendo.culture();return[e.calendars.standard.days.namesAbbr,e.calendars.standard.days.names,e.calendars.standard.months.namesAbbr,e.calendars.standard.months.names]}function s(e){var t,n,i,o,s=e.toLowerCase(),a=r();for(t=0;t<a.length;++t)for(n=a[t],i=n.length;--i>=0;)if(o=n[i].toLowerCase(),o==s)return{type:n,number:i,value:e}}function a(e){var t,n,i=e.length,o=e[0].length,r=[];for(t=0;t<o;++t)for(r[t]=[],n=0;n<i;++n)r[t][n]=e[n][t];return r}var l,c,d,u,h,f,p;kendo.support.browser.msie&&kendo.support.browser.version<9||(l=kendo.spreadsheet,c=l.Range,d=l.calc.runtime,u=d.Formula,h="incompatibleRanges",f="noFillDirection",p=c.FillError=function(e){this.code=e},c.prototype._previewFillFrom=function(e,n){var i,o,r,s,l,c,d,u,m,g,v,_,b,w,y=this,k=y._sheet;if("string"==typeof e&&(e=k.range(e)),i=e._ref.toRangeRef().clone().setSheet(k.name()),o=y._ref.toRangeRef().clone().setSheet(k.name()),i.intersects(o)){if(i.eq(o))return null;if(o=o.clone(),i.topLeft.eq(o.topLeft))if(i.width()==o.width())o.topLeft.row+=i.height(),n=0;else{if(i.height()!=o.height())throw new p(h);o.topLeft.col+=i.width(),n=1}else{if(!i.bottomRight.eq(o.bottomRight))throw new p(h);if(i.width()==o.width())o.bottomRight.row-=i.height(),n=2;else{if(i.height()!=o.height())throw new p(h);o.bottomRight.col-=i.width(),n=3}}return k.range(o)._previewFillFrom(e,n)}if(null==n)if(i.topLeft.col==o.topLeft.col)n=i.topLeft.row<o.topLeft.row?0:2;else{if(i.topLeft.row!=o.topLeft.row)throw new p(f);n=i.topLeft.col<o.topLeft.col?1:3}if(r=1&n,s=2&n,r&&i.height()!=o.height()||!r&&i.width()!=o.width())throw new p(h);for(l=e._properties(),r?c=o.width():(l=a(l),c=o.height()),d=Array(l.length),u=0;u<l.length;++u)for(m=l[u],g=t(m),v=d[u]=Array(c),_=0;_<c;++_)b=s?-_-1:m.length+_,w=s?m.length-_%m.length-1:_%m.length,v[s?c-_-1:_]=g(b,w);return r||(d=a(d)),{props:d,direction:n,dest:y}},c.prototype.fillFrom=function(e,t){var n=this._previewFillFrom(e,t);return n.dest._properties(n.props),n.dest})},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/nameeditor.min",["kendo.core.min"],e)}(function(){!function(e){var t,n,i;e.support.browser.msie&&e.support.browser.version<9||(t=e.jQuery,n={input:"k-spreadsheet-name-editor",list:"k-spreadsheet-name-list"},i=e.ui.Widget.extend({init:function(i,o){var r,s,a;e.ui.Widget.call(this,i,o),i.addClass(n.input),r=o.messages.nameBox||"Name Box",s=new e.data.DataSource({transport:{read:function(t){var n=[];this._workbook.forEachName(function(t){!t.hidden&&t.value instanceof e.spreadsheet.Ref&&n.push({name:t.name})}),t.success(n)}.bind(this),cache:!1}}),a=t("<input />").attr("title",r).attr("aria-label",r),this.combo=a.appendTo(i).kendoComboBox({clearButton:!1,dataTextField:"name",dataValueField:"name",template:"#:data.name#<a class='k-button-delete' href='\\#'><span class='k-icon k-i-close'></span></a>",dataSource:s,autoBind:!1,ignoreCase:!0,change:this._on_listChange.bind(this),noDataTemplate:"<div></div>",open:function(){s.read()}}).getKendoComboBox(),this.combo.input.on("keydown",this._on_keyDown.bind(this)).on("focus",this._on_focus.bind(this)),this.combo.popup.element.addClass("k-spreadsheet-names-popup").on("mousemove",function(e){e.stopPropagation()}).on("click",".k-button-delete",function(e){e.preventDefault(),e.stopPropagation();var n=t(e.target).closest(".k-item");n=this.combo.dataItem(n),this._deleteItem(n.name)}.bind(this))},value:function(e){return void 0===e?this.combo.value():void this.combo.value(e)},_deleteItem:function(e){this.trigger("delete",{name:e})},_on_keyDown:function(e){switch(e.keyCode){case 27:this.combo.value(this._prevValue),this.trigger("cancel");break;case 13:this.trigger("enter")}},_on_focus:function(){this._prevValue=this.combo.value()},_on_listChange:function(){var e=this.combo.value();e&&this.trigger("select",{name:e})}}),e.spreadsheet.NameEditor=i)}(window.kendo)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("spreadsheet/print.min",["kendo.pdf.min","spreadsheet/sheet.min","spreadsheet/range.min","spreadsheet/references.min","spreadsheet/numformat.min","util/text-metrics.min"],e)}(function(){"use strict";function e(e,t,n,i,o){var r=0,s=[],a=t,l=0;return t&&n&&(n*=t),e.forEach(function(e,c){null!=i&&c<i&&(l+=e),t&&r+e>a&&(a-r<n&&(r=t*Math.ceil(r/t)+l,l>0&&o.push(r-l)),a+=t*Math.ceil(e/t)),s.push(r),r+=e}),s.push(r),s}function t(t,i,c){var d,u,h,f,p,m,g,v,b,w,y,k,x,C,S,T,D=t._grid;return i=D.normalize(i),d=[],u=[],h=[],f=t._getMergedCells(i),p=-1,m=-1,t.forEach(i,function(e,n,o){var r,a,l,g=e-i.topLeft.row,v=n-i.topLeft.col,b=t.rowHeight(e),w=t.columnWidth(n);v||u.push(b),g||h.push(w),!t.isHiddenColumn(n)&&!t.isHiddenRow(e)&&b&&w&&(r=c.forScreen||s(o),(c.emptyCells||r)&&(a=new _(e,n).print(),f.secondary[a]||(r?(p=Math.max(p,g),m=Math.max(m,v)):o.empty=!0,o.row=g,o.col=v,l=f.primary[a],l?(delete f.primary[a],o.merged=!0,o.rowspan=l.height(),o.colspan=l.width(),c.forScreen&&(o.width=t._columns.sum(l.topLeft.col,l.bottomRight.col),o.height=t._rows.sum(l.topLeft.row,l.bottomRight.row))):(o.rowspan=1,o.colspan=1),d.push(o))))}),u=u.slice(0,p+1),h=h.slice(0,m+1),g=c.pageWidth,v=c.pageHeight,b=c.scale||1,c.fitWidth&&(w=h.reduce(o,0),w>g&&(b=g/w)),g=Math.ceil(g/b),v=Math.ceil(v/b),y=[],k=e(u,v||0,c.maxEmpty,c.headerRows,y),x=e(h,g||0,c.maxEmpty),C=0,S=0,T=[],d=d.filter(function(e){return(!e.empty||!(e.row>p||e.col>m))&&(c.headerRows&&e.row<c.headerRows&&T.push(e),e.left=x[e.col],e.top=k[e.row],e.merged?c.forScreen?(e.right=e.left+e.width,e.bottom=e.top+e.height):(e.right=r(x,e.col+e.colspan),e.bottom=r(k,e.row+e.rowspan),e.width=e.right-e.left,e.height=e.bottom-e.top):(e.width=h[e.col],e.height=u[e.row],e.bottom=e.top+e.height,e.right=e.left+e.width),C=Math.max(C,e.right),S=Math.max(S,e.bottom),!0)}),Object.keys(f.primary).forEach(function(e){var n=f.primary[e];t.forEach(n.topLeft.toRangeRef(),function(e,o,r){var s=e-i.topLeft.row,a=o-i.topLeft.col;r.merged=!0,r.colspan=n.width(),r.rowspan=n.height(),r.top=s<0?-t._rows.sum(e,e-s-1):k[s],r.left=a<0?-t._columns.sum(o,o-a-1):x[a],r.height=t._rows.sum(n.topLeft.row,n.bottomRight.row),r.width=t._columns.sum(n.topLeft.col,n.bottomRight.col),r.height>0&&r.width>0&&(r.right=r.left+r.width,r.bottom=r.top+r.height,r.row=s,r.col=a,d.push(r))})}),c.headerRows&&(y.forEach(function(e){T.forEach(function(t){t=n(t),t.top+=e,t.bottom=t.top+t.height,d.push(t)}),k.push(e)}),k.sort(l)),{width:C,height:S,cells:d.sort(a),scale:b,xCoords:x,yCoords:k}}function n(e,t){return t||(t={}),Object.assign?Object.assign(t,e):Object.keys(e).reduce(function(t,n){return t[n]=e[n],t},t)}function i(e,t){return e.size===t.size&&e.color===t.color}function o(e,t){return e+t}function r(e,t){return t<e.length?e[t]:e[e.length-1]}function s(e){return null!=e.value||e.merged||null!=e.background||null!=e.borderRight||null!=e.borderBottom||null!=e.validation&&!e.validation.value}function a(e,t){return e.top<t.top?-1:e.top==t.top?e.left<t.left?-1:e.left==t.left?0:1:1}function l(e,t){return e<t?-1:e>t?1:0}function c(e,t,n,i){function o(o,r){var s,a,l,h,f,p,g=r*c,v=g+c,_=o*u,w=_+u,x=0,C=0,S=t.cells.filter(function(e){return!(e.right<=g||e.left>=v||e.bottom<=_||e.top>=w)&&(x=Math.max(e.bottom,x),C=Math.max(e.right,C),!0)});x=Math.min(x,w),C=Math.min(C,v),S.length>0&&(s=new b.Group,n.append(s),a=new b.Group,s.append(a),a.clip(b.Path.fromRect(new y.Rect([g-1,_-1],[C+1,x+1]))),l=y.Matrix.scale(t.scale,t.scale).multiplyCopy(y.Matrix.translate(-g,-_)),(i.hCenter||i.vCenter)&&(l=l.multiplyCopy(y.Matrix.translate(i.hCenter?(v-C)/2:0,i.vCenter?(w-x)/2:0))),
a.transform(l),i.guidelines&&(h=null,t.xCoords.forEach(function(e){e=Math.min(e,C),e!==h&&e>=g&&e<=v&&(h=e,a.append((new b.Path).moveTo(e,_).lineTo(e,x).close().stroke(i.guideColor,k)))}),h=null,t.yCoords.forEach(function(e){e=Math.min(e,x),e!==h&&e>=_&&e<=w&&(h=e,a.append((new b.Path).moveTo(g,e).lineTo(C,e).close().stroke(i.guideColor,k)))})),f=m(),S.forEach(function(t){d(t,a,i),f.add(t,e)}),p=new b.Group,f.vert.forEach(function(e){e.forEach(function(e){e.rendered||(e.rendered=!0,p.append((new b.Path).moveTo(e.x,e.top).lineTo(e.x,e.bottom).close().stroke(e.color,e.size)))})}),f.horiz.forEach(function(e){e.forEach(function(e){e.rendered||(e.rendered=!0,p.append((new b.Path).moveTo(e.left,e.y).lineTo(e.right,e.y).close().stroke(e.color,e.size)))})}),a.append(p))}var r,s,a=Math.ceil(t.width/i.pageWidth),l=Math.ceil(t.height/i.pageHeight),c=Math.ceil(i.pageWidth/t.scale),u=Math.ceil(i.pageHeight/t.scale);for(r=0;r<l;++r)for(s=0;s<a;++s)o(r,s)}function d(e,t,n){var i,o,r,s,a,l,c=new b.Group;if(t.append(c),i=new y.Rect([e.left,e.top],[e.width,e.height]),(e.background||e.merged)&&(o=i,n.guidelines&&(o=i.clone(),o.origin.x+=k/2+.1,o.origin.y+=k/2+.1,o.size.width-=k+.2,o.size.height-=k+.2),c.append(new b.Rect(o).fill(e.background||"#fff").stroke(null))),r=e.value,null!=r){if(s="number"==typeof r?"number":null,a=new b.Group,a.clip(b.Path.fromRect(i)),c.append(a),e.format?(l=w.textAndColor(r,e.format),r=l.text,l.type&&(s=l.type)):r+="",!e.textAlign)switch(s){case"number":case"date":case"percent":case"currency":e.textAlign="right";break;case"boolean":e.textAlign="center"}u(r,l&&l.color||e.color||"#000",e,a)}}function u(e,t,n,i){var o,r;switch(x||(x=document.createElement("div"),x.style.position="absolute",x.style.left="0px",x.style.top="0px",x.style.visibility="hidden",x.style.overflow="hidden",x.style.boxSizing="border-box",x.style.padding="2px 4px",x.style.lineHeight="normal",document.body.appendChild(x)),x.firstChild&&x.removeChild(x.firstChild),x.style.color=t,x.style.font=h(n),x.style.width=n.width+"px",x.style.textAlign=n.textAlign||"left",x.style.textDecoration=n.underline?"underline":"none",n.wrap?(x.style.whiteSpace="pre-wrap",x.style.overflowWrap=x.style.wordWrap="break-word"):(x.style.whiteSpace="pre",x.style.overflowWrap=x.style.wordWrap="normal"),x.appendChild(document.createTextNode(e)),o=0,n.verticalAlign){case"center":o=n.height-x.offsetHeight>>1;break;case void 0:case null:case"bottom":o=n.height-x.offsetHeight}o<0&&(o=0),r=kendo.drawing.drawDOM.drawText(x),r.transform(y.Matrix.translate(n.left,n.top+o)),i.append(r)}function h(e){var t=[];return e.italic&&t.push("italic"),e.bold&&t.push("bold"),t.push((e.fontSize||12)+"px"),t.push(e.fontFamily||"Arial"),t.join(" ")}function f(e,n,i,o){var r,s,a,l,d;null==i&&null==o&&(o=n,i={},n=v.SHEETREF),null==o&&(o=i,n instanceof v.Range||n instanceof v.Ref||"string"==typeof n?i={}:(i=n,n=v.SHEETREF)),i=kendo.jQuery.extend({paperSize:"A4",landscape:!0,margin:"1cm",guidelines:!0,guideColor:"#aaa",emptyCells:!0,fitWidth:!1,center:!1,headerRows:null,maxEmpty:.2,scale:1},i),r=new b.Group,s=kendo.pdf.getPaperOptions(i),r.options.set("pdf",{author:i.author,creator:i.creator,date:i.date,keywords:i.keywords,margin:s.margin,multiPage:!0,paperSize:s.paperSize,subject:i.subject,title:i.title}),a=s.paperSize[0],l=s.paperSize[1],s.margin&&(a-=s.margin.left+s.margin.right+1,l-=s.margin.top+s.margin.bottom+1),i.pageWidth=a,i.pageHeight=l,d=t(e,e._ref(n),i),c(e,d,r,i),o(r)}function p(){}function m(){function e(e,i){var o,r;i&&(o=i._properties,r=i._grid,e.borderLeft=o.get("vBorders",r.index(e.row,e.col)),e.borderRight=o.get("vBorders",r.index(e.row,e.col+e.colspan)),e.borderTop=o.get("hBorders",r.index(e.row,e.col)),e.borderBottom=o.get("hBorders",r.index(e.row+e.rowspan,e.col))),e.borderLeft&&t(e.row,e.col,e.borderLeft,e.left,e.top,e.bottom),e.borderRight&&t(e.row,e.col+e.colspan,e.borderRight,e.right,e.top,e.bottom),e.borderTop&&n(e.row,e.col,e.borderTop,e.top,e.left,e.right),e.borderBottom&&n(e.row+e.rowspan,e.col,e.borderBottom,e.bottom,e.left,e.right)}function t(e,t,n,o,s,a){var l=r[t]||(r[t]=new p),c=e>0&&l[e-1];c&&i(c,n)?(l[e]=c,c.bottom=a):l[e]={size:n.size,color:n.color,x:o,top:s,bottom:a}}function n(e,t,n,r,s,a){var l=o[e]||(o[e]=new p),c=t>0&&l[t-1];c&&i(c,n)?(l[t]=c,c.right=a):l[t]={size:n.size,color:n.color,y:r,left:s,right:a}}var o=new p,r=new p;return{add:e,horiz:o,vert:r}}function g(e){function t(e){var t,n;if(null!=e){for(t=12,n=e.length;--n>=0;)t+=o(e.charAt(n));return t}return 0}function i(e){return r?n(e,{borderLeft:r,borderTop:r,borderRight:r,borderBottom:r}):e}var o,r,s=new $.Deferred,a=s.promise();return e=n(e,{dataSource:null,guidelines:!0,guideColor:"#000",columns:null,headerBackground:"#999",headerColor:"#000",oddBackground:null,evenBackground:null,fontFamily:"Arial",fontSize:12,paperSize:"A4",margin:"1cm",landscape:!0,fitWidth:!1,scale:1,rowHeight:20,maxEmpty:.2}),kendo.drawing.pdf.defineFont(kendo.drawing.drawDOM.getFontFaces(document)),o=S(e.fontFamily,e.fontSize),r=e.guidelines?{size:1,color:e.guideColor}:null,e.dataSource.fetch(function(){var n,o,r,a,l,c=e.dataSource.data();return c.length?(n=e.columns,o=n.map(function(e){return e.title||e.field}),r=o.map(t),a=c.map(function(o,s){return{cells:n.map(function(n,a){var l=o[n.field];return r[a]=Math.max(t(l),r[a]),i({value:l,background:s%2?e.evenBackground:e.oddBackground})})}}),a.unshift({cells:o.map(function(t){return i({value:t,background:e.headerBackground,color:e.headerColor})})}),l=new kendo.spreadsheet.Sheet(a.length+1,n.length+1,e.rowHeight,50,20,20,{fontFamily:e.fontFamily,fontSize:e.fontSize,verticalAlign:"center"}),l.fromJSON({name:"Sheet1",rows:a,columns:r.map(function(e,t){return{index:t,width:e}})}),void l.draw({paperSize:e.paperSize,landscape:e.landscape,margin:e.margin,guidelines:!1,scale:e.scale,fitWidth:e.fitWidth,maxEmpty:e.maxEmpty,headerRows:1},s.resolve.bind(s))):s.reject("Empty dataset")}),a}var v,_,b,w,y,k,x,C,S;kendo.support.browser.msie&&kendo.support.browser.version<9||(v=kendo.spreadsheet,_=v.CellRef,b=kendo.drawing,w=v.formatting,y=kendo.geometry,k=.8,v.Sheet.prototype.draw=function(e,t,n){var i=this;i._workbook?i.recalc(i._workbook._context,function(){f(i,e,t,n)}):f(i,e,t,n)},p.prototype={forEach:function(e){Object.keys(this).forEach(function(t){e(this[t],t,this)},this)}},C={},S=function(e,t){var n,i,o,r,s=t+":"+e,a=C[s];if(!a){for(i=document.createElement("div"),i.style.position="fixed",i.style.left="-10000px",i.style.top="-10000px",i.style.fontFamily=e,i.style.fontSize=t+"px",i.style.whiteSpace="pre",o=32;o<128;++o)n=document.createElement("span"),n.appendChild(document.createTextNode(String.fromCharCode(o))),i.appendChild(n);for(document.body.appendChild(i),r={},o=32,n=i.firstChild;o<128&&n;++o,n=n.nextSibling)r[o]=n.offsetWidth;for(;n=i.firstChild;)i.removeChild(n);a=C[s]=function(e){var t=e.charCodeAt(0),o=r[t];return null==o&&(n=document.createElement("span"),n.appendChild(document.createTextNode(String.fromCharCode(t))),i.appendChild(n),o=r[t]=n.offsetWidth,i.removeChild(n)),o}}return a},v.draw={Borders:m,doLayout:t},v.drawTabularData=g)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.spreadsheet.min",["util/undoredostack.min","util/text-metrics.min","util/parse-xml.min","kendo.excel.min","kendo.progressbar.min","kendo.pdf.min","spreadsheet/commands.min","spreadsheet/formulabar.min","spreadsheet/formulainput.min","spreadsheet/eventlistener.min","spreadsheet/rangelist.min","spreadsheet/propertybag.min","spreadsheet/references.min","spreadsheet/navigator.min","spreadsheet/axismanager.min","spreadsheet/clipboard.min","spreadsheet/range.min","spreadsheet/sheet.min","spreadsheet/sheetsbar.min","spreadsheet/excel-reader.min","spreadsheet/workbook.min","spreadsheet/formulacontext.min","spreadsheet/controller.min","spreadsheet/view.min","spreadsheet/customeditors.min","spreadsheet/grid.min","spreadsheet/axis.min","spreadsheet/filter.min","spreadsheet/sorter.min","spreadsheet/runtime.min","spreadsheet/calc.min","spreadsheet/numformat.min","spreadsheet/runtime.functions.min","spreadsheet/runtime.functions.2.min","spreadsheet/toolbar.min","spreadsheet/dialogs.min","spreadsheet/sheetbinder.min","spreadsheet/filtermenu.min","spreadsheet/editor.min","spreadsheet/autofill.min","spreadsheet/nameeditor.min","spreadsheet/print.min"],e)}(function(){return function(e,t){var n,i,o,r,s,a,l,c,d,u;e.support.browser.msie&&e.support.browser.version<9||(n=e.jQuery,i=n.extend({F10:121,F11:122,B:66,I:73,U:85,N:78,H:72,A:65,PAGEDOWN:34,PAGEUP:33,DELETE:46,R:82},e.keys),o=e.ui.Widget,r=e.spreadsheet.Workbook,s=e.spreadsheet.Controller,a=e.spreadsheet.View,l=".kendoSpreadsheet",c={recalc:!0,selection:!0,activeCell:!0,layout:!0,sheetSelection:!0,resize:!0,editorChange:!1,editorClose:!1},d={wrapper:"k-widget k-spreadsheet"},u=e.ui.Widget.extend({init:function(e,t){o.fn.init.call(this,e,t),this.element.addClass(u.classNames.wrapper),this._view=new a(this.element,{messages:this.options.messages.view,toolbar:this.options.toolbar,sheetsbar:this.options.sheetsbar}),this._workbook=new r(this.options,this._view),this._controller=new s(this._view,this._workbook),this._autoRefresh=!0,this._bindWorkbookEvents(),this._view.workbook(this._workbook),this._view.enableClipboard(!1),this.refresh(),this._view.enableClipboard(!0),this._resizeHandler=function(){this.resize()}.bind(this),n(window).on("resize"+l,this._resizeHandler),this.element.on("keydown"+l,this._keyDown.bind(this))},_keyDown:function(e){var o,r=e.keyCode,s=n(".k-spreadsheet-quick-access-toolbar [title=Redo]");if(r===i.F11&&e.shiftKey)return this._view.sheetsbar._onAddSelect(),e.preventDefault(),t;if(e.altKey&&r===i.PAGEDOWN)this._view.sheetsbar.trigger("select",{name:this._view.sheetsbar._sheets[this._view.sheetsbar._selectedIndex+1].name(),isAddButton:!1});else if(e.altKey&&r===i.PAGEUP)this._view.sheetsbar.trigger("select",{name:this._view.sheetsbar._sheets[this._view.sheetsbar._selectedIndex-1].name(),isAddButton:!1});else{if(e.altKey&&r===i.DELETE)return o=function(e){var t=e.sender;t.isConfirmed()&&this._view.sheetsbar.trigger("remove",{name:this.activeSheet()._name(),confirmation:!0})}.bind(this),this._view.sheetsbar._openDialog("confirmation",{close:o}),e.preventDefault(),t;if(e.altKey&&r===i.R)return this._view.sheetsbar._createEditor(),e.preventDefault(),t;if(r===i.F10&&this._view.tabstrip||r===i.TAB&&!e.shiftKey&&n(document.activeElement).is(s))return this._view.tabstrip.toolbars[this._view.tabstrip.element.find("li.k-state-active").text().toLowerCase()].element.find(":not(.k-overflow-anchor):kendoFocusable:first").focus(),this._view.tabstrip.toolbars[this._view.tabstrip.element.find("li.k-state-active").text().toLowerCase()].element.find(".k-toolbar-first-visible").addClass("k-state-focused"),e.preventDefault(),t;if(e.ctrlKey&&r===i.B)n("[data-tool=bold]")[0].click();else if(e.ctrlKey&&r===i.I)n("[data-tool=italic]")[0].click();else if(e.ctrlKey&&r===i.U)n("[data-tool=underline]")[0].click();else{if(e.altKey&&r===i.H)return this._view.tabstrip.select(0),e.preventDefault(),t;if(e.altKey&&r===i.N)return this._view.tabstrip.select(1),e.preventDefault(),t;if(e.altKey&&r===i.A)return this._view.tabstrip.select(2),e.preventDefault(),t}}},_resize:function(){this.refresh({layout:!0})},_workbookChange:function(t){if(this._autoRefresh&&this.refresh(t),t.recalc&&t.ref){var n=t.range||new e.spreadsheet.Range(t.ref,this.activeSheet());this.trigger("change",{range:n})}},_workbookCut:function(e){this.trigger("cut",e)},_workbookCopy:function(e){this.trigger("copy",e)},_workbookPaste:function(e){this.trigger("paste",e)},activeSheet:function(e){return this._workbook.activeSheet(e)},moveSheetToIndex:function(e,t){return this._workbook.moveSheetToIndex(e,t)},insertSheet:function(e){return this._workbook.insertSheet(e)},sheets:function(){return this._workbook.sheets()},removeSheet:function(e){return this._workbook.removeSheet(e)},sheetByName:function(e){return this._workbook.sheetByName(e)},sheetIndex:function(e){return this._workbook.sheetIndex(e)},sheetByIndex:function(e){return this._workbook.sheetByIndex(e)},renameSheet:function(e,t){return this._workbook.renameSheet(e,t)},refresh:function(e){return e||(e=c),e.editorClose||(this._view.sheet(this._workbook.activeSheet()),this._controller.sheet(this._workbook.activeSheet()),this._workbook.refresh(e)),e.editorChange||(this._view.refresh(e),this._controller.refresh(),this._view.render(),this.trigger("render")),this},openDialog:function(e,t){return this._view.openDialog(e,t)},autoRefresh:function(e){return e!==t?(this._autoRefresh=e,e===!0&&this.refresh(),this):this._autoRefresh},toJSON:function(){return this._workbook.toJSON()},fromJSON:function(e){e.sheets?(this._workbook.destroy(),this._workbook=new r(n.extend({},this.options,e)),this._bindWorkbookEvents(),this._view.workbook(this._workbook),this._controller.workbook(this._workbook),this.activeSheet(this.activeSheet())):this.refresh()},fromFile:function(e,t){return this._workbook.fromFile(e,t)},saveAsPDF:function(e){this._workbook.saveAsPDF(n.extend({},this.options.pdf,e,{workbook:this._workbook}))},saveAsExcel:function(e){this._workbook.saveAsExcel(e)},draw:function(e,t){this._workbook.draw(e,t)},_workbookExcelExport:function(e){this.trigger("excelExport",e)&&e.preventDefault()},_workbookExcelImport:function(e){this.trigger("excelImport",e)?e.preventDefault():this._initProgress(e.promise)},_initProgress:function(t){var i=n("<div class='k-loading-mask' style='width: 100%; height: 100%; top: 0;'><div class='k-loading-color'/></div>").appendTo(this.element),o=n("<div class='k-loading-progress'>").appendTo(i).kendoProgressBar({type:"chunk",chunkCount:10,min:0,max:1,value:0}).data("kendoProgressBar");t.progress(function(e){o.value(e.progress)}).always(function(){e.destroy(i),i.remove()})},_workbookPdfExport:function(e){this.trigger("pdfExport",e)&&e.preventDefault()},_workbookInsertSheet:function(e){this.trigger("insertSheet",e)&&e.preventDefault()},_workbookRemoveSheet:function(e){this.trigger("removeSheet",e)&&e.preventDefault()},_workbookSelectSheet:function(e){this.trigger("selectSheet",e)&&e.preventDefault()},_workbookRenameSheet:function(e){this.trigger("renameSheet",e)&&e.preventDefault()},_workbookInsertRow:function(e){this.trigger("insertRow",e)&&e.preventDefault()},_workbookInsertColumn:function(e){this.trigger("insertColumn",e)&&e.preventDefault()},_workbookDeleteRow:function(e){this.trigger("deleteRow",e)&&e.preventDefault()},_workbookDeleteColumn:function(e){this.trigger("deleteColumn",e)&&e.preventDefault()},_workbookHideRow:function(e){this.trigger("hideRow",e)&&e.preventDefault()},_workbookHideColumn:function(e){this.trigger("hideColumn",e)&&e.preventDefault()},_workbookUnhideRow:function(e){this.trigger("unhideRow",e)&&e.preventDefault()},_workbookUnhideColumn:function(e){this.trigger("unhideColumn",e)&&e.preventDefault()},_workbookSelect:function(e){this.trigger("select",e)},_workbookChangeFormat:function(e){this.trigger("changeFormat",e)},_bindWorkbookEvents:function(){this._workbook.bind("cut",this._workbookCut.bind(this)),this._workbook.bind("copy",this._workbookCopy.bind(this)),this._workbook.bind("paste",this._workbookPaste.bind(this)),this._workbook.bind("change",this._workbookChange.bind(this)),this._workbook.bind("excelExport",this._workbookExcelExport.bind(this)),this._workbook.bind("excelImport",this._workbookExcelImport.bind(this)),this._workbook.bind("pdfExport",this._workbookPdfExport.bind(this)),this._workbook.bind("insertSheet",this._workbookInsertSheet.bind(this)),this._workbook.bind("removeSheet",this._workbookRemoveSheet.bind(this)),this._workbook.bind("selectSheet",this._workbookSelectSheet.bind(this)),this._workbook.bind("renameSheet",this._workbookRenameSheet.bind(this)),this._workbook.bind("insertRow",this._workbookInsertRow.bind(this)),this._workbook.bind("insertColumn",this._workbookInsertColumn.bind(this)),this._workbook.bind("deleteRow",this._workbookDeleteRow.bind(this)),this._workbook.bind("deleteColumn",this._workbookDeleteColumn.bind(this)),this._workbook.bind("hideRow",this._workbookHideRow.bind(this)),this._workbook.bind("hideColumn",this._workbookHideColumn.bind(this)),this._workbook.bind("unhideRow",this._workbookUnhideRow.bind(this)),this._workbook.bind("unhideColumn",this._workbookUnhideColumn.bind(this)),this._workbook.bind("select",this._workbookSelect.bind(this)),this._workbook.bind("changeFormat",this._workbookChangeFormat.bind(this))},destroy:function(){e.ui.Widget.fn.destroy.call(this),this._workbook.destroy(),this._controller.destroy(),this._view.destroy(),this._resizeHandler&&n(window).off("resize"+l,this._resizeHandler)},options:{name:"Spreadsheet",toolbar:!0,sheetsbar:!0,rows:200,columns:50,rowHeight:20,columnWidth:64,headerHeight:20,headerWidth:32,excel:{proxyURL:"",fileName:"Workbook.xlsx"},messages:{},pdf:{area:"workbook",fileName:"Workbook.pdf",proxyURL:"",paperSize:"a4",landscape:!0,margin:null,title:null,author:null,subject:null,keywords:null,creator:"Kendo UI PDF Generator v."+e.version,date:null},defaultCellStyle:{fontFamily:"Arial",fontSize:"12"}},defineName:function(e,t,n){return this._workbook.defineName(e,t,n)},undefineName:function(e){return this._workbook.undefineName(e)},nameValue:function(e){return this._workbook.nameValue(e)},forEachName:function(e){return this._workbook.forEachName(e)},cellContextMenu:function(){return this._view.cellContextMenu},rowHeaderContextMenu:function(){return this._view.rowHeaderContextMenu},colHeaderContextMenu:function(){return this._view.colHeaderContextMenu},events:["cut","copy","paste","pdfExport","excelExport","excelImport","change","render","removeSheet","selectSheet","renameSheet","insertRow","insertColumn","deleteRow","insertSheet","deleteColumn","hideRow","hideColumn","unhideRow","unhideColumn","select","changeFormat"]}),e.spreadsheet.ALL_REASONS=c,e.ui.plugin(u),n.extend(!0,u,{classNames:d}))}(window.kendo),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.pivot.configurator.min",["kendo.dom.min"],e)}(function(){return function(e,t){function n(e){for(var t,n=0,i=e.length;n<i;n++)if(2==e[n].type){t=!0;break}t&&e.splice(n+1,0,{caption:"KPIs",defaultHierarchy:"[KPIs]",name:"KPIs",uniqueName:"[KPIs]"})}function i(e){return{name:e.uniqueName,type:e.type}}function o(e){for(var t=0,n=e.length;t<n;t++)e[t].uniqueName=e[t].name,e[t].type="kpi";return e}function r(t){var n=e(t).closest(".k-pivot-setting");return n.length?n.data("kendoPivotSettingTarget"):null}function s(e,t,n){return{hierarchyUniqueName:e,uniqueName:t,caption:t,measure:t,name:t,type:n,kpi:!0}}function a(e){var t=e.name;return[s(t,e.value,"value"),s(t,e.goal,"goal"),s(t,e.status,"status"),s(t,e.trend,"trend")]}var l=window.kendo,c=l.ui,d=c.Widget,u=".kendoPivotConfigurator",h="mouseenter"+u+" mouseleave"+u,f=l.template('<p class="k-reset"><span class="k-icon #=icon#"></span>${name}</p><div class="k-list-container k-reset"/>'),p=d.extend({init:function(e,t){d.fn.init.call(this,e,t),this.element.addClass("k-widget k-fieldselector k-alt k-edit-form-container"),this._dataSource(),this._layout(),this.refresh(),l.notify(this)},events:[],options:{name:"PivotConfigurator",filterable:!1,sortable:!1,messages:{measures:"Drop Data Fields Here",columns:"Drop Column Fields Here",rows:"Drop Rows Fields Here",measuresLabel:"Measures",columnsLabel:"Columns",rowsLabel:"Rows",fieldsLabel:"Fields"}},_dataSource:function(){var t=this;t.dataSource&&t._refreshHandler?t.dataSource.unbind("change",t._refreshHandler).unbind("error",t._errorHandler).unbind("progress",t._progressHandler):(t._errorHandler=e.proxy(t._error,t),t._refreshHandler=e.proxy(t.refresh,t),t._progressHandler=e.proxy(t._requestStart,t)),t.dataSource=l.data.PivotDataSource.create(t.options.dataSource),t.dataSource.bind("change",t._refreshHandler).bind("error",t._errorHandler).bind("progress",t._progressHandler)},setDataSource:function(e){this.options.dataSource=e,this._dataSource(),this.measures&&this.measures.setDataSource(e),this.rows&&this.rows.setDataSource(e),this.columns&&this.columns.setDataSource(e),this.refresh()},_treeViewDataSource:function(){var t=this;return l.data.HierarchicalDataSource.create({schema:{model:{id:"uniqueName",hasChildren:function(e){return!("hierarchyUniqueName"in e||"aggregator"in e)}}},transport:{read:function(i){var r,s,l;e.isEmptyObject(i.data)?(r=t.dataSource.schemaDimensions(),r.done(function(e){t.dataSource.cubeBuilder||n(e),i.success(e)}).fail(i.error)):(s=t.treeView.dataSource.get(i.data.uniqueName),"[KPIs]"===s.uniqueName?(l=!0,r=t.dataSource.schemaKPIs(),r.done(function(e){i.success(o(e))}).fail(i.error)):"kpi"==s.type&&(l=!0,i.success(a(s))),l||(r=2==s.type?t.dataSource.schemaMeasures():s.dimensionUniqueName?t.dataSource.schemaLevels(i.data.uniqueName):t.dataSource.schemaHierarchies(i.data.uniqueName),r.done(i.success).fail(i.error)))}}})},_progress:function(e){l.ui.progress(this.element,e)},_error:function(){this._progress(!1)},_requestStart:function(){this._progress(!0)},_layout:function(){this.form=e('<div class="k-columns k-state-default k-floatwrap"/>').appendTo(this.element),this._fields(),this._targets()},_fields:function(){var t=e('<div class="k-state-default"><p class="k-reset"><span class="k-icon k-i-group"></span>'+this.options.messages.fieldsLabel+"</p></div>").appendTo(this.form),n='# if (item.type == 2 || item.uniqueName == "[KPIs]") { #<span class="k-icon k-i-#= (item.type == 2 ? "sum" : "kpi") #"></span># } else if (item.type && item.type !== "kpi") { #<span class="k-icon k-i-arrows-dimensions"></span># } ##: item.caption || item.name #';this.treeView=e("<div/>").appendTo(t).kendoTreeView({template:n,dataTextField:"caption",dragAndDrop:!0,autoBind:!1,dataSource:this._treeViewDataSource(),dragstart:function(e){var t=this.dataItem(e.sourceNode);(t.hasChildren||t.aggregator||t.measure)&&2!=t.type&&"[KPIs]"!==t.uniqueName||e.preventDefault()},drag:function(e){var t="k-i-cancel",n=r(e.dropTarget);n&&n.validate(this.dataItem(e.sourceNode))&&(t="k-i-plus"),e.setStatusClass(t)},drop:function(e){var t,n,o,s,l,c;if(e.preventDefault(),t=r(e.dropTarget),n=this.dataItem(e.sourceNode),t&&t.validate(n)){if(c=n.defaultHierarchy||n.uniqueName,"kpi"===n.type)for(l=a(n),s=l.length,c=[],o=0;o<s;o++)c.push(i(l[o]));else n.kpi&&(c=[i(n)]);t.add(c)}}}).data("kendoTreeView")},_createTarget:function(t,n){var i='<li class="k-item k-header" data-'+l.ns+'name="${data.name}">${data.name}',o=n.sortable,r="";return o&&(r+="#if (data.sortIcon) {#",r+='<span class="k-icon ${data.sortIcon}-sm"></span>',r+="#}#"),(n.filterable||o)&&(r+='<span class="k-icon k-i-more-vertical k-setting-fieldmenu"></span>'),r+='<span class="k-icon k-i-close k-setting-delete"></span>',i+='<span class="k-field-actions">'+r+"</span></li>",new l.ui.PivotSettingTarget(t,e.extend({dataSource:this.dataSource,hint:function(t){var n=e('<div class="k-fieldselector"><ul class="k-list k-reset"></ul></div>');return n.find(".k-list").append(t.clone()),n},template:i,emptyTemplate:'<li class="k-item k-empty">${data}</li>'},n))},_targets:function(){var t=e('<div class="k-state-default"/>').appendTo(this.form),n=e(f({name:this.options.messages.columnsLabel,icon:"k-i-columns"})).appendTo(t),i=e('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(n.last()),o=e(f({name:this.options.messages.rowsLabel,icon:"k-i-rows"})).appendTo(t),r=e('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(o.last()),s=e(f({name:this.options.messages.measuresLabel,icon:"k-i-sum"})).appendTo(t),a=e('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(s.last()),l=this.options;this.columns=this._createTarget(i,{filterable:l.filterable,sortable:l.sortable,connectWith:r,messages:{empty:l.messages.columns,fieldMenu:l.messages.fieldMenu}}),this.rows=this._createTarget(r,{filterable:l.filterable,sortable:l.sortable,setting:"rows",connectWith:i,messages:{empty:this.options.messages.rows,fieldMenu:this.options.messages.fieldMenu}}),this.measures=this._createTarget(a,{setting:"measures",messages:{empty:l.messages.measures}}),i.add(r).add(a).on(h,".k-item:not(.k-empty)",this._toggleHover)},_toggleHover:function(t){e(t.currentTarget).toggleClass("k-state-hover","mouseenter"===t.type)},_resize:function(){var e,t,n=this.element,i=this.options.height,o=l._outerHeight;i&&(n.height(i),n.is(":visible")&&(t=n.children(".k-columns").children("div.k-state-default"),i=n.innerHeight(),e=(o(n)-i)/2,i=i-(o(t,!0)-t.height())-e,t.height(i)))},refresh:function(){var e=this.dataSource;(e.cubeBuilder||this._cube!==e.cube()||this._catalog!==e.catalog())&&this.treeView.dataSource.fetch(),this._catalog=this.dataSource.catalog(),this._cube=this.dataSource.cube(),this._resize(),this._progress(!1)},destroy:function(){d.fn.destroy.call(this),this.dataSource.unbind("change",this._refreshHandler),this.form.find(".k-list").off(u),this.rows.destroy(),this.columns.destroy(),this.measures.destroy(),this.treeView.destroy(),this.element=null,this._refreshHandler=null}});c.plugin(p)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.angular.min",["kendo.core.min"],e)}(function(){return function(e,t,n){"use strict";function i(e){var t=T;try{return T=function(e){return e()},e()}finally{T=t}}function o(t,i,o,c,d,g){function v(){var n,g,v,_,b,x,S;return o.kRebind&&(n=e(e(i)[0].cloneNode(!0))),C=r(t,i,o,c,k).options,i.is("select")&&!function(t){var n,i;if(t.length>0)for(n=e(t[0]),!/\S/.test(n.text())&&/^\?/.test(n.val())&&n.remove(),i=0;i<t.length;i++)e(t[i]).off("$destroy")}(i[0].options),g=k.call(i,E=C).data(c),l(g,t,o,c,d),t.$emit("kendoWidgetCreated",g),v=f(t,g),o.kRebind&&m(g,t,i,n,o.kRebind,v,o),o.kNgDisabled&&(_=o.kNgDisabled,b=t.$eval(_),b&&g.enable(!b),s(g,t,i,_)),o.kNgReadonly&&(x=o.kNgReadonly,S=t.$eval(x),S&&g.readonly(S),a(g,t,i,x)),o.kNgModel&&h(g,t,o.kNgModel),w&&u(g,t,i,w,y),g&&p(g,i),g}var _,b,w,y,k,x,C,S,D,A,I,M,R,F;if(!(i instanceof jQuery))throw Error("The Kendo UI directives require jQuery to be available before AngularJS. Please include jquery before angular in the document.");if(_=o.kNgDelay,b=t.$eval(_),g=g||[],w=g[0],y=g[1],k=e(i)[c],!k)return window.console.error("Could not find: "+c),null;if(x=r(t,i,o,c,k),C=x.options,x.unresolved.length){for(S=[],D=0,A=x.unresolved.length;D<A;D++)I=x.unresolved[D],M=e.Deferred(function(e){var i=t.$watch(I.path,function(t){t!==n&&(i(),e.resolve())})}).promise(),S.push(M);return e.when.apply(null,S).then(v),n}return _&&!b?(R=t.$root||t,F=function(){var e=t.$watch(_,function(t){t!==n&&(e(),i.removeAttr(o.$attr.kNgDelay),_=null,T(v))})},/^\$(digest|apply)$/.test(R.$$phase)?F():t.$apply(F),n):v()}function r(i,o,r,s,a){function l(e,o){var r=t.copy(i.$eval(o));r===n?p.push({option:e,path:o}):c[e]=r}var c,d,u,h,f=s.replace(/^kendo/,""),p=[],m=r.kOptions||r.options,g=i.$eval(m);return m&&g===n&&p.push({option:"options",path:m}),c=t.extend({},r.defaultOptions,g),d=a.widget.prototype.options,u=a.widget.prototype.events,e.each(r,function(e,t){var n,i,o,r;"source"!==e&&"kDataSource"!==e&&"kScopeField"!==e&&"scopeField"!==e&&(n="data"+e.charAt(0).toUpperCase()+e.slice(1),0===e.indexOf("on")&&(i=e.replace(/^on./,function(e){return e.charAt(2).toLowerCase()}),u.indexOf(i)>-1&&(c[i]=t)),d.hasOwnProperty(n)?l(n,t):d.hasOwnProperty(e)&&!R[e]?l(e,t):M[e]||(o=e.match(/^k(On)?([A-Z].*)/),o&&(r=o[2].charAt(0).toLowerCase()+o[2].slice(1),o[1]&&"kOnLabel"!=e?c[r]=t:("kOnLabel"==e&&(r="onLabel"),l(r,t)))))}),h=r.kDataSource||r.source,h&&(c.dataSource=I(i,o,f,h)),c.$angular=[i],{options:c,unresolved:p}}function s(e,t,i,o){return kendo.ui.PanelBar&&e instanceof kendo.ui.PanelBar||kendo.ui.Menu&&e instanceof kendo.ui.Menu?(A.warn("k-ng-disabled specified on a widget that does not have the enable() method: "+e.options.name),n):(t.$watch(o,function(t,n){t!=n&&e.enable(!t)}),n)}function a(e,t,i,o){return"function"!=typeof e.readonly?(A.warn("k-ng-readonly specified on a widget that does not have the readonly() method: "+e.options.name),n):(t.$watch(o,function(t,n){t!=n&&e.readonly(t)}),n)}function l(e,t,n,i,o){if(n[o]){var r=S(n[o]).assign;if(!r)throw Error(o+" attribute used but expression in it is not assignable: "+n[i]);r(t,e)}}function c(e){return/checkbox|radio/i.test(e.attr("type"))?e.prop("checked"):e.val()}function d(e){return F.test(e[0].tagName)}function u(e,t,i,o,r){var s,a,l,u,h;e.value&&(a=!1,s=d(i)?function(){return c(i)}:function(){return e.value()},l=function(){var i=o.$viewValue;i===n&&(i=o.$modelValue),i===n&&(i=null),a=!0,setTimeout(function(){if(a=!1,e){var n=t[e.element.attr("k-ng-model")];n&&(i=n),e.options.autoBind!==!1||e.listView.bound()?e.value(i):i&&e.value(i)}},0)},o.$render=l,setTimeout(function(){o.$render!==l&&(o.$render=l)()}),d(i)&&i.on("change",function(){a=!0}),u=function(e){return function(){var n;a&&!i.is("select")||(e&&r&&(n=r.$pristine),o.$setViewValue(s()),e&&(o.$setPristine(),n&&r.$setPristine()),w(t))}},e.first("change",u(!1)),e.first("spin",u(!1)),kendo.ui.AutoComplete&&e instanceof kendo.ui.AutoComplete||e.first("dataBound",u(!0)),h=s(),isNaN(o.$viewValue)||h==o.$viewValue||(o.$isEmpty(o.$viewValue)?null!=h&&""!==h&&h!=o.$viewValue&&o.$setViewValue(h):e.value(o.$viewValue)),o.$setPristine())}function h(t,i,o){var r,s,a,l,c,d,u,h,f,p;return"function"!=typeof t.value?(A.warn("k-ng-model specified on a widget that does not have the value() method: "+t.options.name),n):(r=e(t.element).parents("form"),s=kendo.getter(r.attr("name"),!0)(i),a=S(o),l=a.assign,c=!1,d=kendo.ui.MultiSelect&&t instanceof kendo.ui.MultiSelect,u=function(e){return e&&d?e.length:0},h=u(a(i)),t.$angular_setLogicValue(a(i)),f=function(e,i){e===n&&(e=null),c||e==i&&u(e)==h||(h=u(e),t.$angular_setLogicValue(e))},d?i.$watchCollection(o,f):i.$watch(o,f),p=function(){c=!0,s&&s.$pristine&&s.$setDirty(),w(i,function(){l(i,t.$angular_getLogicValue()),h=u(a(i))}),c=!1},t.first("change",p),t.first("spin",p),n)}function f(e,t){var n=e.$on("$destroy",function(){n(),t&&(kendo.destroy(t.element),t=null)});return n}function p(t,n){function i(){s.disconnect()}function o(){s.observe(e(n)[0],{attributes:!0})}var r,s;window.MutationObserver&&t.wrapper&&(r=[].slice.call(e(n)[0].classList),s=new MutationObserver(function(n){i(),t&&(n.forEach(function(n){var i,o=e(t.wrapper)[0];switch(n.attributeName){case"class":i=[].slice.call(n.target.classList),i.forEach(function(e){r.indexOf(e)<0&&(o.classList.add(e),kendo.ui.ComboBox&&t instanceof kendo.ui.ComboBox&&t.input[0].classList.add(e))}),r.forEach(function(e){i.indexOf(e)<0&&(o.classList.remove(e),kendo.ui.ComboBox&&t instanceof kendo.ui.ComboBox&&t.input[0].classList.remove(e))}),r=i;break;case"disabled":"function"!=typeof t.enable||t.element.attr("readonly")||t.enable(!e(n.target).attr("disabled"));break;case"readonly":"function"!=typeof t.readonly||t.element.attr("disabled")||t.readonly(!!e(n.target).attr("readonly"))}}),o())}),o(),t.first("destroy",i))}function m(t,n,i,o,r,s,a){var l=n.$watch(r,function(r,c){var d,u,h,f,p;t._muteRebind||r===c||(l(),a._cleanUp&&a._cleanUp(),d=H[t.options.name],d&&d.forEach(function(t){var i=n.$eval(a["k"+t]);i&&o.append(e(i).attr(kendo.toHyphens("k"+t),""))}),u=e(t.wrapper)[0],h=e(t.element)[0],f="Upload"===t.options.name,f&&(i=e(h)),p=i.injector().get("$compile"),t._destroy(),s&&s(),t=null,h&&(u&&u.parentNode.replaceChild(h,u),e(i).replaceWith(o)),p(o)(n))},!0);w(n)}function g(e,t){return function(n,i){return e.call(t,n,i)}}function v(e,t){this[e]=kendo.stringify(t)}function _(e,n){function i(e,t){x.directive(e,["directiveFactory",function(n){return n.create(t,e)}])}var o,r,s,a,l=n?"Mobile":"";l+=e.fn.options.name,o=l,r="kendo"+l.charAt(0)+l.substr(1).toLowerCase(),l="kendo"+l,s=l.replace(/([A-Z])/g,"-$1"),P.indexOf(l.replace("kendo",""))==-1&&(a=l===r?[l]:[l,r],t.forEach(a,function(e){x.directive(e,function(){return{restrict:"E",replace:!0,template:function(e,t){var n=z[o]||"div",i=t.kScopeField||t.scopeField;return"<"+n+" "+s+(i?'="'+i+'"':"")+">"+e.html()+"</"+n+">"}}})})),B.indexOf(l.replace("kendo",""))>-1||(i(l,l),
r!=l&&i(r,l))}function b(t){return t=e(t),kendo.widgetInstance(t,kendo.ui)||kendo.widgetInstance(t,kendo.mobile.ui)||kendo.widgetInstance(t,kendo.dataviz.ui)}function w(e,t){var n=e.$root||e,i=/^\$(digest|apply)$/.test(n.$$phase);t?i?t():n.$apply(t):i||n.$digest()}function y(t,n){t.$destroy(),n&&e(n).removeData("$scope").removeData("$$kendoScope").removeData("$isolateScope").removeData("$isolateScopeNoTemplate").removeClass("ng-scope")}function k(n,i,o){var r,s,a;if(e.isArray(n))return t.forEach(n,function(e){k(e,i,o)});if("string"==typeof n){for(r=n.split("."),s=kendo;s&&r.length>0;)s=s[r.shift()];if(!s)return L.push([n,i,o]),!1;n=s.prototype}return a=n[i],n[i]=function(){var e=this,t=arguments;return o.apply({self:e,next:function(){return a.apply(e,arguments.length>0?arguments:t)}},t)},!0}var x,C,S,T,D,A,E,I,M,R,F,z,P,B,L,H;t&&t.injector&&(x=t.module("kendo.directives",[]),C=t.injector(["ng"]),S=C.get("$parse"),T=C.get("$timeout"),A=C.get("$log"),I=function(){var e={TreeList:"TreeListDataSource",TreeView:"HierarchicalDataSource",Scheduler:"SchedulerDataSource",PivotGrid:"PivotDataSource",PivotConfigurator:"PivotDataSource",PanelBar:"HierarchicalDataSource",Menu:"$PLAIN",ContextMenu:"$PLAIN"},t=function(e,t){return"$PLAIN"==t?e:kendo.data[t].create(e)};return function(n,i,o,r){var s=e[o]||"DataSource",a=n.$eval(r),l=t(a,s);return n.$watch(r,function(e){var n,o=b(i);o&&"function"==typeof o.setDataSource&&e!==a&&(n=t(e,s),o.setDataSource(n),a=e)}),l}}(),M={kDataSource:!0,kOptions:!0,kRebind:!0,kNgModel:!0,kNgDelay:!0},R={name:!0,title:!0,style:!0},F=/^(input|select|textarea)$/i,x.factory("directiveFactory",["$compile",function(t){var n,i,r=!1;return D=t,i=function(t,i){return{restrict:"AC",require:["?ngModel","^?form"],scope:!1,controller:["$scope","$attrs","$element",function(e,t){this.template=g(v,t),t._cleanUp=g(function(){this.template=null,t._cleanUp=null},this)}],link:function(s,a,l,c){var d,u=e(a),h=t.replace(/([A-Z])/g,"-$1");u.attr(h,u.attr("data-"+h)),u[0].removeAttribute("data-"+h),d=o(s,a,l,t,i,c),d&&(n&&clearTimeout(n),n=setTimeout(function(){s.$emit("kendoRendered"),r||(r=!0,e("form").each(function(){var t=e(this).controller("form");t&&t.$setPristine()}))}))}}},{create:i}}]),z={Editor:"textarea",NumericTextBox:"input",DatePicker:"input",DateTimePicker:"input",TimePicker:"input",AutoComplete:"input",ColorPicker:"input",MaskedTextBox:"input",MultiSelect:"input",Upload:"input",Validator:"form",Button:"button",MobileButton:"a",MobileBackButton:"a",MobileDetailButton:"a",ListView:"ul",MobileListView:"ul",PanelBar:"ul",TreeView:"ul",Menu:"ul",ContextMenu:"ul",ActionSheet:"ul"},P=["MobileView","MobileDrawer","MobileLayout","MobileSplitView","MobilePane","MobileModalView"],B=["MobileApplication","MobileView","MobileModalView","MobileLayout","MobileActionSheet","MobileDrawer","MobileSplitView","MobilePane","MobileScrollView","MobilePopOver"],t.forEach(["MobileNavBar","MobileButton","MobileBackButton","MobileDetailButton","MobileTabStrip","MobileScrollView","MobileScroller"],function(e){B.push(e),e="kendo"+e,x.directive(e,function(){return{restrict:"A",link:function(t,n,i){o(t,n,i,e,e)}}})}),L=[],kendo.onWidgetRegistered(function(t){L=e.grep(L,function(e){return!k.apply(null,e)}),_(t.widget,"Mobile"==t.prefix)}),k(["ui.Widget","mobile.ui.Widget"],"angular",function(o,r){var s,a=this.self;return"init"==o?(!r&&E&&(r=E),E=null,r&&r.$angular&&(a.$angular_scope=r.$angular[0],a.$angular_init(a.element,r)),n):(s=a.$angular_scope,s&&i(function(){var i,l,c=r(),d=c.elements,u=c.data;if(d.length>0)switch(o){case"cleanup":t.forEach(d,function(t){var n=e(t).data("$$kendoScope");n&&n!==s&&n.$$kendoScope&&y(n,t)});break;case"compile":i=a.element.injector(),l=i?i.get("$compile"):D,t.forEach(d,function(t,i){var o,r;c.scopeFrom?o=c.scopeFrom:(r=u&&u[i],r!==n?(o=e.extend(s.$new(),r),o.$$kendoScope=!0):o=s),e(t).data("$$kendoScope",o),l(t)(o)}),w(s)}}),n)}),k("ui.Widget","$angular_getLogicValue",function(){return this.self.value()}),k("ui.Widget","$angular_setLogicValue",function(e){this.self.value(e)}),k("ui.Select","$angular_getLogicValue",function(){var e=this.self.dataItem(),t=this.self.options.dataValueField;return e?this.self.options.valuePrimitive?t?e[t]:e:e.toJSON():null}),k("ui.Select","$angular_setLogicValue",function(e){var t=this.self,i=t.options,o=i.dataValueField,r=i.text||"";e===n&&(e=""),o&&!i.valuePrimitive&&e&&(r=e[i.dataTextField]||"",e=e[o||i.dataTextField]),t.options.autoBind!==!1||t.listView.bound()?t.value(e):!r&&e&&i.valuePrimitive?t.value(e):t._preselect(e,r)}),k("ui.MultiSelect","$angular_getLogicValue",function(){var t=this.self.dataItems().slice(0),n=this.self.options.dataValueField;return n&&this.self.options.valuePrimitive&&(t=e.map(t,function(e){return e[n]})),t}),k("ui.MultiSelect","$angular_setLogicValue",function(t){var n,i,o,r;null==t&&(t=[]),n=this.self,i=n.options,o=i.dataValueField,r=t,o&&!i.valuePrimitive&&(t=e.map(t,function(e){return e[o]})),i.autoBind!==!1||i.valuePrimitive||n.listView.bound()?n.value(t):n._preselect(r,t)}),k("ui.Widget","$angular_init",function(t,n){var i,o,r,s,a=this.self;if(n&&!e.isArray(n))for(i=a.$angular_scope,o=a.events.length;--o>=0;)r=a.events[o],s=n[r],s&&"string"==typeof s&&(n[r]=a.$angular_makeEventHandler(r,i,s))}),k("ui.Widget","$angular_makeEventHandler",function(e,t,n){return n=S(n),function(e){w(t,function(){n(t,{kendoEvent:e})})}}),k(["ui.Grid","ui.ListView","ui.TreeView","ui.PanelBar"],"$angular_makeEventHandler",function(e,n,i){return"change"!=e?this.next():(i=S(i),function(e){var o,r,s,a,l,c,d,u,h,f=e.sender,p=f.options,m={kendoEvent:e};for(t.isString(p.selectable)&&(o=p.selectable.indexOf("cell")!==-1,r=p.selectable.indexOf("multiple")!==-1),f._checkBoxSelection&&(r=!0),s=m.selected=this.select(),a=m.data=[],l=m.columns=[],d=0;d<s.length;d++)u=o?s[d].parentNode:s[d],h=f.dataItem(u),o?(t.element.inArray(h,a)<0&&a.push(h),c=t.element(s[d]).index(),t.element.inArray(c,l)<0&&l.push(c)):a.push(h);r||(m.dataItem=m.data=a[0],m.angularDataItem=kendo.proxyModelSetters(m.dataItem),m.selected=s[0]),w(n,function(){i(n,m)})})}),k("ui.Grid","$angular_init",function(i,o){if(this.next(),o.columns){var r=e.extend({},kendo.Template,o.templateSettings);t.forEach(o.columns,function(e){!e.field||e.template||e.format||e.values||e.encoded!==n&&!e.encoded||(e.template="<span ng-bind='"+kendo.expr(e.field,"dataItem")+"'>#: "+kendo.expr(e.field,r.paramName)+"#</span>")})}}),k("mobile.ui.ButtonGroup","value",function(e){var t=this.self;return null!=e&&(t.select(t.element.children("li.km-button").eq(e)),t.trigger("change"),t.trigger("select",{index:t.selectedIndex})),t.selectedIndex}),k("mobile.ui.ButtonGroup","_select",function(){this.next(),this.self.trigger("change")}),x.directive("kendoMobileApplication",function(){return{terminal:!0,link:function(e,t,n){o(e,t,n,"kendoMobileApplication","kendoMobileApplication")}}}).directive("kendoMobileView",function(){return{scope:!0,link:{pre:function(e,t,n){n.defaultOptions=e.viewOptions,n._instance=o(e,t,n,"kendoMobileView","kendoMobileView")},post:function(e,t,n){n._instance._layout(),n._instance._scroller()}}}}).directive("kendoMobileDrawer",function(){return{scope:!0,link:{pre:function(e,t,n){n.defaultOptions=e.viewOptions,n._instance=o(e,t,n,"kendoMobileDrawer","kendoMobileDrawer")},post:function(e,t,n){n._instance._layout(),n._instance._scroller()}}}}).directive("kendoMobileModalView",function(){return{scope:!0,link:{pre:function(e,t,n){n.defaultOptions=e.viewOptions,n._instance=o(e,t,n,"kendoMobileModalView","kendoMobileModalView")},post:function(e,t,n){n._instance._layout(),n._instance._scroller()}}}}).directive("kendoMobileSplitView",function(){return{terminal:!0,link:{pre:function(e,t,n){n.defaultOptions=e.viewOptions,n._instance=o(e,t,n,"kendoMobileSplitView","kendoMobileSplitView")},post:function(e,t,n){n._instance._layout()}}}}).directive("kendoMobilePane",function(){return{terminal:!0,link:{pre:function(e,t,n){n.defaultOptions=e.viewOptions,o(e,t,n,"kendoMobilePane","kendoMobilePane")}}}}).directive("kendoMobileLayout",function(){return{link:{pre:function(e,t,n){o(e,t,n,"kendoMobileLayout","kendoMobileLayout")}}}}).directive("kendoMobileActionSheet",function(){return{restrict:"A",link:function(t,n,i){n.find("a[k-action]").each(function(){e(this).attr("data-"+kendo.ns+"action",e(this).attr("k-action"))}),o(t,n,i,"kendoMobileActionSheet","kendoMobileActionSheet")}}}).directive("kendoMobilePopOver",function(){return{terminal:!0,link:{pre:function(e,t,n){n.defaultOptions=e.viewOptions,o(e,t,n,"kendoMobilePopOver","kendoMobilePopOver")}}}}).directive("kendoViewTitle",function(){return{restrict:"E",replace:!0,template:function(e){return"<span data-"+kendo.ns+"role='view-title'>"+e.html()+"</span>"}}}).directive("kendoMobileHeader",function(){return{restrict:"E",link:function(e,t){t.addClass("km-header").attr("data-role","header")}}}).directive("kendoMobileFooter",function(){return{restrict:"E",link:function(e,t){t.addClass("km-footer").attr("data-role","footer")}}}).directive("kendoMobileScrollViewPage",function(){return{restrict:"E",replace:!0,template:function(e){return"<div data-"+kendo.ns+"role='page'>"+e.html()+"</div>"}}}),t.forEach(["align","icon","rel","transition","actionsheetContext"],function(e){var t="k"+e.slice(0,1).toUpperCase()+e.slice(1);x.directive(t,function(){return{restrict:"A",priority:2,link:function(n,i,o){i.attr(kendo.attr(kendo.toHyphens(e)),n.$eval(o[t]))}}})}),H={TreeMap:["Template"],MobileListView:["HeaderTemplate","Template"],MobileScrollView:["EmptyTemplate","Template"],Grid:["AltRowTemplate","DetailTemplate","RowTemplate"],ListView:["EditTemplate","Template","AltTemplate"],Pager:["SelectTemplate","LinkTemplate"],PivotGrid:["ColumnHeaderTemplate","DataCellTemplate","RowHeaderTemplate"],Scheduler:["AllDayEventTemplate","DateHeaderTemplate","EventTemplate","MajorTimeHeaderTemplate","MinorTimeHeaderTemplate"],PanelBar:["Template"],TreeView:["Template"],Validator:["ErrorTemplate"]},function(){var e={};t.forEach(H,function(n,i){t.forEach(n,function(t){e[t]||(e[t]=[]),e[t].push("?^^kendo"+i)})}),t.forEach(e,function(e,t){var n="k"+t,i=kendo.toHyphens(n);x.directive(n,function(){return{restrict:"A",require:e,terminal:!0,compile:function(t,o){if(""===o[n]){t.removeAttr(i);var r=t[0].outerHTML;return function(t,o,s,a){for(var l;!l&&a.length;)l=a.shift();l?(l.template(n,r),o.remove()):A.warn(i+" without a matching parent widget found. It can be one of the following: "+e.join(", "))}}}}})})}())}(window.kendo.jQuery,window.angular),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.web.min",["kendo.core.min","kendo.router.min","kendo.view.min","kendo.fx.min","kendo.dom.min","kendo.data.odata.min","kendo.data.xml.min","kendo.data.min","kendo.ooxml.min","kendo.excel.min","kendo.data.signalr.min","kendo.binder.min","kendo.drawing.min","kendo.validator.min","kendo.userevents.min","kendo.draganddrop.min","kendo.mobile.scroller.min","kendo.groupable.min","kendo.reorderable.min","kendo.resizable.min","kendo.sortable.min","kendo.selectable.min","kendo.button.min","kendo.buttongroup.min","kendo.pager.min","kendo.popup.min","kendo.notification.min","kendo.tooltip.min","kendo.list.min","kendo.calendar.min","kendo.datepicker.min","kendo.dateinput.min","kendo.autocomplete.min","kendo.dropdownlist.min","kendo.combobox.min","kendo.multiselect.min","kendo.colorpicker.min","kendo.columnmenu.min","kendo.columnsorter.min","kendo.grid.min","kendo.listview.min","kendo.listbox.min","kendo.filebrowser.min","kendo.imagebrowser.min","kendo.editor.min","kendo.numerictextbox.min","kendo.maskedtextbox.min","kendo.mediaplayer.min","kendo.menu.min","kendo.editable.min","kendo.pivot.fieldmenu.min","kendo.filtercell.min","kendo.panelbar.min","kendo.progressbar.min","kendo.responsivepanel.min","kendo.tabstrip.min","kendo.timepicker.min","kendo.toolbar.min","kendo.datetimepicker.min","kendo.treeview.draganddrop.min","kendo.treeview.min","kendo.slider.min","kendo.splitter.min","kendo.upload.min","kendo.dialog.min","kendo.window.min","kendo.virtuallist.min","kendo.scheduler.view.min","kendo.scheduler.dayview.min","kendo.scheduler.agendaview.min","kendo.scheduler.monthview.min","kendo.scheduler.recurrence.min","kendo.scheduler.min","kendo.gantt.list.min","kendo.gantt.timeline.min","kendo.gantt.min","kendo.treelist.min","kendo.pivotgrid.min","kendo.spreadsheet.min","kendo.pivot.configurator.min","kendo.angular.min"],e)}(function(){"bundle all";return window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/core/kendo-core.min",["kendo.core.min","kendo.drawing.min"],e)}(function(){!function(e){function t(e){return Array.isArray(e)}function n(e,n){var i,o,r=t(n)?n:[n];for(i=0;i<r.length;i++)o=r[i],e.className.indexOf(o)===-1&&(e.className+=" "+o)}function i(e,t){e&&e.className&&(e.className=e.className.replace(t,"").replace(dt," "))}function o(e){var t,n=.5;for(e.options.stroke&&kendo.drawing.util.defined(e.options.stroke.width)&&e.options.stroke.width%2===0&&(n=0),t=0;t<e.segments.length;t++)e.segments[t].anchor().round(0).translate(n,n);return e}function r(e,t){return-e.x*t.y+e.y*t.x<0}function s(e){return"number"==typeof e&&!isNaN(e)}function a(e){return typeof e===ot}function l(e){return s(e)||a(e)&&isFinite(e)}function c(e){return"object"==typeof e}function d(e){return s(e)?e+"px":e}function u(e){return ut.test(e)}function h(e,n){var i,o,r,s,l,h=a(n)?[n]:n;if(t(h)){for(i={},o=window.getComputedStyle(e),r=0;r<h.length;r++)s=h[r],i[s]=u(s)?parseFloat(o[s]):o[s];return i}if(c(n))for(l in n)e.style[l]=d(n[l])}function f(e,t){void 0===t&&(t=0);var n={top:0,right:0,bottom:0,left:0};return"number"==typeof e?n[Me]=n[ze]=n[Re]=n[Fe]=e:(n[Me]=e[Me]||t,n[ze]=e[ze]||t,n[Re]=e[Re]||t,n[Fe]=e[Fe]||t),n}function p(e){void 0===e&&(e={});var t;return e.template?e.template=t=yt.compile(e.template):De(e.content)&&(t=e.content),t}function m(e,t){var n,i=e.length,o=[];for(n=0;n<i;n++)t(e[n])&&o.push(e[n]);return o}function g(e,t){var n,i;if(e.className)for(n=t.split(" "),i=0;i<n.length;i++)if(e.className.indexOf(n[i])!==-1)return!0}function v(e,t){if(t)return t.indexOf(e)!==-1}function _(e,t,n){return kendo.drawing.util.round(e+(t-e)*n,He)}function b(e,t){var n,i,o=e.length,r=[];for(n=0;n<o;n++)i=t(e[n]),kendo.drawing.util.defined(i)&&r.push(i);return r}function w(e){var t=0;return e.wheelDelta&&(t=-e.wheelDelta/120,t=t>0?Math.ceil(t):Math.floor(t)),e.detail&&(t=kendo.drawing.util.round(e.detail/3)),t}function y(e,t){var n=e.prototype;n.options=n.options?Te({},n.options,t):t}function k(e){var t,n,i,o=Ne,r=Oe;for(t=0,n=e.length;t<n;t++)i=e[t],null!==i&&isFinite(i)&&(o=Math.min(o,i),r=Math.max(r,i));return{min:o===Ne?void 0:o,max:r===Oe?void 0:r}}function x(e,t,n,i,o){var r=Lt(o);return new Ut(n+(e-n)*Math.cos(r)+(t-i)*Math.sin(r),i-(e-n)*Math.sin(r)+(t-i)*Math.cos(r))}function C(e,t){return e-t}function S(e,t){var n,i,o,r,s,a,l,c,d;return e.x1===t.x1&&e.y1===t.y1&&e.x2===t.x2&&e.y2===t.y2?t:(n=Math.min(e.x1,t.x1),i=Math.max(e.x1,t.x1),o=Math.min(e.x2,t.x2),r=Math.max(e.x2,t.x2),s=Math.min(e.y1,t.y1),a=Math.max(e.y1,t.y1),l=Math.min(e.y2,t.y2),c=Math.max(e.y2,t.y2),d=[],d[0]=new Wt(i,s,o,a),d[1]=new Wt(n,a,i,l),d[2]=new Wt(o,a,r,l),d[3]=new Wt(i,l,o,c),e.x1===n&&e.y1===s||t.x1===n&&t.y1===s?(d[4]=new Wt(n,s,i,a),d[5]=new Wt(o,l,r,c)):(d[4]=new Wt(o,s,r,a),d[5]=new Wt(n,l,i,c)),m(d,function(e){return e.height()>0&&e.width()>0})[0])}function T(t){var n,i,o=t.stops,r=t.innerRadius/t.radius*100,s=o.length,a=[];for(n=0;n<s;n++)i=e.extend({},o[n]),i.offset=(i.offset*(100-r)+r)/100,a.push(i);return a}function D(e){var t=e.origin,n=e.bottomRight();return new Wt(t.x,t.y,n.x,n.y)}function A(e,t){var n=e.tickX,i=e.tickY,r=e.position,s=new ve({stroke:{width:t.width,color:t.color}});return e.vertical?s.moveTo(n,r).lineTo(n+t.size,r):s.moveTo(r,i).lineTo(r,i+t.size),o(s),s}function E(e,t){var n=e.lineStart,i=e.lineEnd,r=e.position,s=new ve({stroke:{width:t.width,color:t.color,dashType:t.dashType}});return e.vertical?s.moveTo(n,r).lineTo(i,r):s.moveTo(r,n).lineTo(r,i),o(s),s}function I(e,t){var n=e.getTime()-t,i=e.getTimezoneOffset()-t.getTimezoneOffset();return n-i*xn}function M(e,t){return new Date(e.getTime()+t)}function R(e){var t;return e instanceof Date?t=e:e&&(t=new Date(e)),t}function F(e,t){var n,i;if(void 0===t&&(t=0),n=0,i=e.getDay(),!isNaN(i))for(;i!==t;)0===i?i=6:i--,n++;return M(e,-n*Sn)}function z(e,t){return 0===t&&23===e.getHours()&&(e.setHours(e.getHours()+2),!0)}function P(e,t){var n,i=new Date(e);return i.setMinutes(0,0,0),n=(e.getTimezoneOffset()-i.getTimezoneOffset())*xn,M(i,n+t*Cn)}function B(e,t,n,i){var o,r,s=e;return e&&(o=R(e),r=o.getHours(),n===wn?(s=new Date(o.getFullYear()+t,0,1),z(s,0)):n===bn?(s=new Date(o.getFullYear(),o.getMonth()+t,1),z(s,r)):n===_n?(s=B(F(o,i),7*t,vn),z(s,r)):n===vn?(s=new Date(o.getFullYear(),o.getMonth(),o.getDate()+t),z(s,r)):n===gn?s=P(o,t):n===mn?(s=M(o,t*xn),s.getSeconds()>0&&s.setSeconds(0)):n===pn?s=M(o,t*kn):n===fn&&(s=M(o,t)),n!==fn&&s.getMilliseconds()>0&&s.setMilliseconds(0)),s}function L(e,t,n){return B(R(e),0,t,n)}function H(e,t,n){var i=R(e);return i&&L(i,t,n).getTime()===i.getTime()?i:B(i,1,t,n)}function N(e,t){return e&&t?e.getTime()-t.getTime():-1}function O(e,t){return e.getTime()-t}function V(e){var n,i;if(t(e)){for(n=[],i=0;i<e.length;i++)n.push(V(e[i]));return n}if(e)return R(e).getTime()}function U(e,t){return e&&t?V(e)===V(t):e===t}function W(e,t,n){return I(e,t)/En[n]}function j(e,t,n,i){var o,r=R(e),s=R(t);return o=n===bn?r.getMonth()-s.getMonth()+12*(r.getFullYear()-s.getFullYear())+W(r,new Date(r.getFullYear(),r.getMonth()),vn)/new Date(r.getFullYear(),r.getMonth()+1,0).getDate():n===wn?r.getFullYear()-s.getFullYear()+j(r,new Date(r.getFullYear(),0),bn,1)/12:n===vn||n===_n?W(r,s,n):O(r,t)/En[n],o/i}function q(e,t,n){var i;return i=n===wn?t.getFullYear()-e.getFullYear():n===bn?12*q(e,t,wn)+t.getMonth()-e.getMonth():n===vn?Math.floor(O(t,e)/Sn):Math.floor(O(t,e)/En[n])}function G(e,t){for(var n,i,o=0,r=t.length-1;o<=r;)if(n=Math.floor((o+r)/2),i=t[n],i<e)o=n+1;else{if(!(i>e)){for(;U(t[n-1],e);)n--;return n}r=n-1}return t[n]<=e?n:n-1}function $(e,t){var n;return n=a(t)?e.parseDate(t)||R(t):R(t)}function K(e,n){var i,o;if(t(n)){for(i=[],o=0;o<n.length;o++)i.push($(e,n[o]));return i}return $(e,n)}function Y(e,t){var n,i;if(e instanceof Date){for(n=t.length,i=0;i<n;i++)if(U(t[i],e))return i;return-1}return t.indexOf(e)}function Q(e,t){var n,i,o,r=Ht(t-e,Ge-1);if(0===r){if(0===t)return.1;r=Math.abs(t)}return n=Math.pow(10,Math.floor(Math.log(r)/Math.log(10))),i=Ht(r/n,Ge),o=1,o=i<1.904762?.2:i<4.761904?.5:i<9.523809?1:2,Ht(n*o,Ge)}function X(e,t,n){var i,o,r;if(!e&&!t)return 0;if(e>=0&&t>=0){if(o=e===t?0:e,r=(t-o)/t,n===!1||!n&&r>zn)return 0;i=Math.max(0,o-(t-o)/2)}else i=e;return i}function Z(e,t,n){var i,o,r;if(!e&&!t)return 1;if(e<=0&&t<=0){if(o=e===t?0:t,r=Math.abs((o-e)/o),n===!1||!n&&r>zn)return 0;i=Math.min(0,o-(e-o)/2)}else i=t;return i}function J(e,t){return Ht(Math.floor(e/t)*t,Ge)}function ee(e,t){return Ht(Math.ceil(e/t)*t,Ge)}function te(e){return Math.max(Math.min(e,Rn),-Rn)}function ne(e,t,n){var i=n.narrowRange,o=X(e,t,i),r=Z(e,t,i),s=Q(o,r),a={majorUnit:s};return n.roundToMajorUnit!==!1&&(o<0&&re(o,s,1/3)&&(o-=s),r>0&&re(r,s,1/3)&&(r+=s)),a.min=J(o,s),a.max=ee(r,s),a}function ie(e,t){return{min:At(t.min)?Math.min(e.min,t.min):e.min,max:At(t.max)?Math.max(e.max,t.max):e.max,majorUnit:e.majorUnit}}function oe(e,t){var n,i,o,r,s=t;return t&&(n=At(t.min),i=At(t.max),o=n||i,o&&t.min===t.max&&(t.min>0?t.min=0:t.max=1),t.majorUnit?(e.min=J(e.min,t.majorUnit),e.max=ee(e.max,t.majorUnit)):o&&(s=Te(e,t),e.majorUnit=Q(s.min,s.max))),e.minorUnit=(s.majorUnit||e.majorUnit)/5,r=Te(e,s),r.min>=r.max&&(n&&!i?r.max=r.min+r.majorUnit:!n&&i&&(r.min=r.max-r.majorUnit)),r}function re(e,t,n){var i=Ht(Math.abs(e%t),Ge),o=t*(1-n);return 0===i||i>o}function se(e){var t=gn;return e>=An?t=wn:e>=Dn?t=bn:e>=Tn?t=_n:e>=Sn&&(t=vn),t}function ae(e,t,n){var i=n.min||e,o=n.max||t,r=n.baseUnit||(o&&i?se(I(o,i)):gn),s=En[r],a=L(V(i)-1,r)||R(o),l=H(V(o)+1,r),c=n.majorUnit?n.majorUnit:void 0,d=c||ee(Q(a.getTime(),l.getTime()),s)/s,u=q(a,l,r),h=ee(u,d),f=h-u,p=Math.floor(f/2),m=f-p;return n.baseUnit||delete n.baseUnit,n.baseUnit=n.baseUnit||r,n.min=n.min||B(a,-p,r),n.max=n.max||B(l,m,r),n.minorUnit=n.minorUnit||d/5,n.majorUnit=d,n}function le(e,t,n,i){var o=n.min,r=n.max;return At(n.axisCrossingValue)&&n.axisCrossingValue<=0&&ue(),At(i.max)?i.max<=0&&ue():r=t,At(i.min)?i.min<=0&&ue():o=e,{min:o,max:r}}function ce(e,t,n){var i=n.majorUnit,o=e;return e<=0?o=t<=1?Math.pow(i,-2):1:n.narrowRange||(o=Math.pow(i,Math.floor(he(e,i)))),o}function de(e,t){var n,i=Ht(he(e,t),Ge)%1;return n=e<=0?t:0!==i&&(i<.3||i>.9)?Math.pow(t,he(e,t)+.2):Math.pow(t,Math.ceil(he(e,t)))}function ue(){throw Error("Non positive values cannot be used for a logarithmic axis")}function he(e,t){return Math.log(e)/Math.log(t)}function fe(e,t){return 180-Math.abs(Math.abs(e-t)-180)}function pe(e){return e<=0?-1:1}var me,ge,ve,_e,be,we,ye,ke,xe,Ce,Se,Te,De,Ae,Ee,Ie,Me,Re,Fe,ze,Pe,Be,Le,He,Ne,Oe,Ve,Ue,We,je,qe,Ge,$e,Ke,Ye,Qe,Xe,Ze,Je,et,tt,nt,it,ot,rt,st,at,lt,ct,dt,ut,ht,ft,pt,mt,gt,vt,_t,bt,wt,yt,kt,xt,Ct,St,Tt,Dt,At,Et,It,Mt,Rt,Ft,zt,Pt,Bt,Lt,Ht,Nt,Ot,Vt,Ut,Wt,jt,qt,Gt,$t,Kt,Yt,Qt,Xt,Zt,Jt,en,tn,nn,on,rn,sn,an,ln,cn,dn,un,hn,fn,pn,mn,gn,vn,_n,bn,wn,yn,kn,xn,Cn,Sn,Tn,Dn,An,En,In,Mn,Rn,Fn,zn,Pn,Bn,Ln,Hn,Nn,On,Vn,Un,Wn,jn,qn,Gn,$n,Kn,Yn,Qn,Xn,Zn;window.kendo.dataviz=window.kendo.dataviz||{},me=kendo.drawing,ge=me.util,ve=me.Path,_e=me.Group,be=kendo.Class,we=kendo.geometry,ye=we.Rect,ke=we.Circle,xe=we.transform,Ce=we.Segment,Se=kendo.dataviz,Te=kendo.deepExtend,De=kendo.isFunction,Ae=kendo.getter,Ee="x",Ie="y",Me="top",Re="bottom",Fe="left",ze="right",Pe="center",Be="width",Le="height",He=3,Ne=Number.MAX_VALUE,Oe=-Number.MAX_VALUE,Ve=600,Ue=400,We="#fff",je="#000",qe="12px sans-serif",Ge=10,$e="axisLabelClick",Ke="noteClick",Ye="noteHover",Qe="outside",Xe="none",Ze="circle",Je="triangle",et="cross",tt="arc",nt="inside",it="value",ot="string",rt="object",st="date",at=/\{\d+:?/,lt=100,ct={X:Ee,Y:Ie,WIDTH:Be,HEIGHT:Le,DEFAULT_HEIGHT:Ue,DEFAULT_WIDTH:Ve,TOP:Me,LEFT:Fe,BOTTOM:Re,RIGHT:ze,CENTER:Pe,COORD_PRECISION:He,DEFAULT_PRECISION:Ge,CIRCLE:Ze,TRIANGLE:Je,CROSS:et,MAX_VALUE:Ne,MIN_VALUE:Oe,WHITE:We,BLACK:je,DEFAULT_FONT:qe,AXIS_LABEL_CLICK:$e,OUTSIDE:Qe,INSIDE:nt,NONE:Xe,NOTE_CLICK:Ke,NOTE_HOVER:Ye,VALUE:it,STRING:ot,OBJECT:rt,DATE:st,ARC:tt,FORMAT_REGEX:at,HIGHLIGHT_ZINDEX:lt},dt=/\s+/g,ut=/width|height|top|left|bottom|right/i,ht={format:function(e,t){return t},toString:function(e){return e},parseDate:function(e){return new Date(e)}},ft=ht,pt=be.extend({}),pt.register=function(e){ft=e},Object.defineProperties&&Object.defineProperties(pt,{implementation:{get:function(){return ft}}}),mt=/\{(\d+)(:[^\}]+)?\}/g,gt=be.extend({init:function(e){this._intlService=e},auto:function(e){for(var t,n=[],i=arguments.length-1;i-- >0;)n[i]=arguments[i+1];return t=this.intlService,a(e)&&e.match(at)?t.format.apply(t,[e].concat(n)):t.toString(n[0],e)},localeAuto:function(e,t,n){var i,o=this.intlService;return i=a(e)&&e.match(at)?e.replace(mt,function(e,i,r){var s=t[parseInt(i,10)];return o.toString(s,r?r.substring(1):"",n)}):o.toString(t[0],e,n)}}),Object.defineProperties&&Object.defineProperties(gt.fn,{intlService:{get:function(){return this._intlService||pt.implementation}}}),vt=be.extend({init:function(e,t){void 0===t&&(t={}),this._intlService=t.intlService,this.sender=t.sender||e,this.format=new gt(t.intlService),this.chart=e,this.rtl=t.rtl},notify:function(e,t){this.chart.trigger(e,t)}}),Object.defineProperties&&Object.defineProperties(vt.fn,{intl:{get:function(){return this._intlService||pt.implementation}}}),bt=be.extend({}),bt.register=function(e){_t=e},bt.create=function(e,t){if(_t)return _t.create(e,t)},wt={compile:function(e){return e}},yt=be.extend({}),yt.register=function(e){wt=e},yt.compile=function(e){return wt.compile(e)},kt={ChartService:vt,DomEventsBuilder:bt,FormatService:gt,IntlService:pt,TemplateService:yt},xt="trigger",Ct=be.extend({init:function(e,t){this.observer=e,this.handlerMap=Te({},this.handlerMap,t)},trigger:function(e,t){var n,i=this,o=i.observer,r=i.handlerMap;return r[e]?n=this.callObserver(r[e],t):o[xt]&&(n=this.callObserver(xt,e,t)),n},callObserver:function(e){for(var t=[],n=arguments.length-1;n-- >0;)t[n]=arguments[n+1];return this.observer[e].apply(this.observer,t)},requiresHandlers:function(e){var t,n=this;if(this.observer.requiresHandlers)return this.observer.requiresHandlers(e);for(t=0;t<e.length;t++)if(n.handlerMap[e[t]])return!0}}),St=kendo.drawing.util,Tt=St.append,Dt=St.bindEvents,At=St.defined,Et=St.deg,It=St.elementOffset,Mt=St.elementSize,Rt=St.eventElement,Ft=St.eventCoordinates,zt=St.last,Pt=St.limitValue,Bt=St.objectKey,Lt=St.rad,Ht=St.round,Nt=St.unbindEvents,Ot=St.valueOrDefault,Vt=be.extend({}),Vt.fetchFonts=function(e,t,n){void 0===n&&(n={depth:0});var i=5;!e||n.depth>i||!document.fonts||Object.keys(e).forEach(function(i){var o=e[i];"dataSource"!==i&&"$"!==i[0]&&o&&("font"===i?t.push(o):"object"==typeof o&&(n.depth++,Vt.fetchFonts(o,t,n),n.depth--))})},Vt.loadFonts=function(e,t){var n=[];if(e.length>0&&document.fonts){try{n=e.map(function(e){return document.fonts.load(e)})}catch(i){kendo.logToConsole(i)}Promise.all(n).then(t,t)}else t()},Vt.preloadFonts=function(e,t){var n=[];Vt.fetchFonts(e,n),Vt.loadFonts(n,t)},Ut=be.extend({init:function(e,t){this.x=e||0,this.y=t||0},clone:function(){return new Ut(this.x,this.y)},equals:function(e){return e&&this.x===e.x&&this.y===e.y},rotate:function(e,t){var n=Lt(t),i=Math.cos(n),o=Math.sin(n),r=e.x,s=e.y,a=this,l=a.x,c=a.y;return this.x=Ht(r+(l-r)*i+(c-s)*o,He),this.y=Ht(s+(c-s)*i-(l-r)*o,He),this},multiply:function(e){return this.x*=e,this.y*=e,this},distanceTo:function(e){var t=this.x-e.x,n=this.y-e.y;return Math.sqrt(t*t+n*n)}}),Ut.onCircle=function(e,t,n){var i=Lt(t);return new Ut(e.x-n*Math.cos(i),e.y-n*Math.sin(i))},Wt=be.extend({init:function(e,t,n,i){this.x1=e||0,this.y1=t||0,this.x2=n||0,this.y2=i||0},equals:function(e){return this.x1===e.x1&&this.x2===e.x2&&this.y1===e.y1&&this.y2===e.y2},width:function(){return this.x2-this.x1},height:function(){return this.y2-this.y1},translate:function(e,t){return this.x1+=e,this.x2+=e,this.y1+=t,this.y2+=t,this},move:function(e,t){var n=this.height(),i=this.width();return At(e)&&(this.x1=e,this.x2=this.x1+i),At(t)&&(this.y1=t,this.y2=this.y1+n),this},wrap:function(e){return this.x1=Math.min(this.x1,e.x1),this.y1=Math.min(this.y1,e.y1),this.x2=Math.max(this.x2,e.x2),this.y2=Math.max(this.y2,e.y2),this},wrapPoint:function(e){var n=t(e),i=n?e[0]:e.x,o=n?e[1]:e.y;return this.wrap(new Wt(i,o,i,o)),this},snapTo:function(e,t){return t!==Ee&&t||(this.x1=e.x1,this.x2=e.x2),t!==Ie&&t||(this.y1=e.y1,this.y2=e.y2),this},alignTo:function(e,t){var n,i,o=this.height(),r=this.width(),s=t===Me||t===Re?Ie:Ee,a=s===Ie?o:r;return t===Pe?(n=e.center(),i=this.center(),this.x1+=n.x-i.x,this.y1+=n.y-i.y):this[s+1]=t===Me||t===Fe?e[s+1]-a:e[s+2],this.x2=this.x1+r,this.y2=this.y1+o,this},shrink:function(e,t){return this.x2-=e,this.y2-=t,this},expand:function(e,t){return this.shrink(-e,-t),this},pad:function(e){var t=f(e);return this.x1-=t.left,this.x2+=t.right,this.y1-=t.top,this.y2+=t.bottom,this},unpad:function(e){var t=f(e);return t.left=-t.left,t.top=-t.top,t.right=-t.right,t.bottom=-t.bottom,this.pad(t)},clone:function(){return new Wt(this.x1,this.y1,this.x2,this.y2)},center:function(){return new Ut(this.x1+this.width()/2,this.y1+this.height()/2)},containsPoint:function(e){return e.x>=this.x1&&e.x<=this.x2&&e.y>=this.y1&&e.y<=this.y2},points:function(){return[new Ut(this.x1,this.y1),new Ut(this.x2,this.y1),new Ut(this.x2,this.y2),new Ut(this.x1,this.y2)]},getHash:function(){return[this.x1,this.y1,this.x2,this.y2].join(",")},overlaps:function(e){return!(e.y2<this.y1||this.y2<e.y1||e.x2<this.x1||this.x2<e.x1)},rotate:function(e){var t=this.width(),n=this.height(),i=this.center(),o=i.x,r=i.y,s=x(0,0,o,r,e),a=x(t,0,o,r,e),l=x(t,n,o,r,e),c=x(0,n,o,r,e);return t=Math.max(s.x,a.x,l.x,c.x)-Math.min(s.x,a.x,l.x,c.x),n=Math.max(s.y,a.y,l.y,c.y)-Math.min(s.y,a.y,l.y,c.y),this.x2=this.x1+t,this.y2=this.y1+n,this},toRect:function(){return new ye([this.x1,this.y1],[this.width(),this.height()])},hasSize:function(){return 0!==this.width()&&0!==this.height()},align:function(e,t,n){var i=t+1,o=t+2,r=t===Ee?Be:Le,s=this[r]();v(n,[Fe,Me])?(this[i]=e[i],this[o]=this[i]+s):v(n,[ze,Re])?(this[o]=e[o],this[i]=this[o]-s):n===Pe&&(this[i]=e[i]+(e[r]()-s)/2,this[o]=this[i]+s)}}),jt=be.extend({init:function(e,t,n,i,o){this.center=e,this.innerRadius=t,this.radius=n,this.startAngle=i,this.angle=o},clone:function(){return new jt(this.center,this.innerRadius,this.radius,this.startAngle,this.angle)},middle:function(){return this.startAngle+this.angle/2},setRadius:function(e,t){return t?this.innerRadius=e:this.radius=e,this},point:function(e,t){var n=Lt(e),i=Math.cos(n),o=Math.sin(n),r=t?this.innerRadius:this.radius,s=Ht(this.center.x-i*r,He),a=Ht(this.center.y-o*r,He);return new Ut(s,a)},adjacentBox:function(e,t,n){var i=this.clone().expand(e),o=i.middle(),r=i.point(o),s=t/2,a=n/2,l=Math.sin(Lt(o)),c=Math.cos(Lt(o)),d=r.x-s,u=r.y-a;return Math.abs(l)<.9&&(d+=s*-c/Math.abs(c)),Math.abs(c)<.9&&(u+=a*-l/Math.abs(l)),new Wt(d,u,d+t,u+n)},containsPoint:function(e){var t=this.center,n=this.innerRadius,i=this.radius,o=this.startAngle,s=this.startAngle+this.angle,a=e.x-t.x,l=e.y-t.y,c=new Ut(a,l),d=this.point(o),u=new Ut(d.x-t.x,d.y-t.y),h=this.point(s),f=new Ut(h.x-t.x,h.y-t.y),p=Ht(a*a+l*l,He);return(u.equals(c)||r(u,c))&&!r(f,c)&&p>=n*n&&p<=i*i},getBBox:function(){var e,t,n,i=this,o=new Wt(Ne,Ne,Oe,Oe),r=Ht(this.startAngle%360),s=Ht((r+this.angle)%360),a=this.innerRadius,l=[0,90,180,270,r,s].sort(C),c=l.indexOf(r),d=l.indexOf(s);for(e=r===s?l:c<d?l.slice(c,d+1):[].concat(l.slice(0,d+1),l.slice(c,l.length)),t=0;t<e.length;t++)n=i.point(e[t]),o.wrapPoint(n),o.wrapPoint(n,a);return a||o.wrapPoint(this.center),o},expand:function(e){return this.radius+=e,this}}),qt=jt.extend({init:function(e,t,n,i){jt.fn.init.call(this,e,0,t,n,i)},expand:function(e){return jt.fn.expand.call(this,e)},clone:function(){return new qt(this.center,this.radius,this.startAngle,this.angle)},setRadius:function(e){return this.radius=e,this}}),Gt=.001,$t=be.extend({createRing:function(e,t){var n,i,o,r,s,a,l=e.startAngle+180,c=e.angle+l;return e.angle>0&&l===c&&(c+=Gt),n=new we.Point(e.center.x,e.center.y),i=Math.max(e.radius,0),o=Math.max(e.innerRadius,0),r=new we.Arc(n,{startAngle:l,endAngle:c,radiusX:i,radiusY:i}),s=ve.fromArc(r,t).close(),o?(r.radiusX=r.radiusY=o,a=r.pointAt(c),s.lineTo(a.x,a.y),s.arc(c,l,o,o,!0)):s.lineTo(n.x,n.y),s}}),$t.current=new $t,Kt=be.extend({init:function(e){this.children=[],this.options=Te({},this.options,e)},reflow:function(e){var t,n,i,o=this.children;for(n=0;n<o.length;n++)i=o[n],i.reflow(e),t=t?t.wrap(i.box):i.box.clone();this.box=t||e},destroy:function(){var e,t=this.children;for(this.animation&&this.animation.destroy(),e=0;e<t.length;e++)t[e].destroy()},getRoot:function(){var e=this.parent;return e?e.getRoot():null},getSender:function(){var e=this.getService();if(e)return e.sender},getService:function(){for(var e=this;e;){if(e.chartService)return e.chartService;e=e.parent}},translateChildren:function(e,t){var n,i=this.children,o=i.length;for(n=0;n<o;n++)i[n].box.translate(e,t)},append:function(){var e,t,n=arguments,i=this;for(e=0;e<arguments.length;e++)t=n[e],i.children.push(t),t.parent=i},renderVisual:function(){this.options.visible!==!1&&(this.createVisual(),this.addVisual(),this.renderChildren(),this.createAnimation(),this.renderComplete())},addVisual:function(){this.visual&&(this.visual.chartElement=this,this.parent&&this.parent.appendVisual(this.visual))},renderChildren:function(){var e,t=this.children,n=t.length;for(e=0;e<n;e++)t[e].renderVisual()},createVisual:function(){this.visual=new _e({zIndex:this.options.zIndex,visible:Ot(this.options.visible,!0)})},createAnimation:function(){this.visual&&(this.animation=me.Animation.create(this.visual,this.options.animation))},appendVisual:function(e){e.chartElement||(e.chartElement=this),e.options.noclip?this.clipRoot().visual.append(e):At(e.options.zIndex)?this.stackRoot().stackVisual(e):this.isStackRoot?this.stackVisual(e):this.visual?this.visual.append(e):this.parent.appendVisual(e);
},clipRoot:function(){return this.parent?this.parent.clipRoot():this},stackRoot:function(){return this.parent?this.parent.stackRoot():this},stackVisual:function(e){var t,n,i,o=e.options.zIndex||0,r=this.visual.children,s=r.length;for(t=0;t<s&&(n=r[t],i=Ot(n.options.zIndex,0),!(i>o));t++);this.visual.insert(t,e)},traverse:function(e){var t,n,i=this.children,o=i.length;for(t=0;t<o;t++)n=i[t],e(n),n.traverse&&n.traverse(e)},closest:function(e){for(var t=this,n=!1;t&&!n;)n=e(t),n||(t=t.parent);if(n)return t},renderComplete:function(){},hasHighlight:function(){var e=(this.options||{}).highlight;return!(!this.createHighlight||e&&e.visible===!1)},toggleHighlight:function(t){var n,i=this,o=(this.options||{}).highlight||{},r=o.visual,s=this._highlight;if(!s){if(n={fill:{color:We,opacity:.2},stroke:{color:We,width:1,opacity:.2}},r){if(s=this._highlight=r(e.extend(this.highlightVisualArgs(),{createVisual:function(){return i.createHighlight(n)},sender:this.getSender(),series:this.series,dataItem:this.dataItem,category:this.category,value:this.value,percentage:this.percentage,runningTotal:this.runningTotal,total:this.total})),!s)return}else s=this._highlight=this.createHighlight(n);At(s.options.zIndex)||(s.options.zIndex=Ot(o.zIndex,this.options.zIndex)),this.appendVisual(s)}s.visible(t)},createGradientOverlay:function(t,n,i){var o=new ve(e.extend({stroke:{color:"none"},fill:this.createGradient(i),closed:t.options.closed},n));return o.segments.elements(t.segments.elements()),o},createGradient:function(e){if(this.parent)return this.parent.createGradient(e)}}),Kt.prototype.options={},Yt=Kt.extend({init:function(e){Kt.fn.init.call(this,e),this.options.margin=f(this.options.margin),this.options.padding=f(this.options.padding)},reflow:function(e){var t,n,i,o,r=this,s=this.options,a=s.width,l=s.height,c=s.shrinkToFit,d=a&&l,u=s.margin,h=s.padding,f=s.border.width,p=function(){r.align(e,Ee,s.align),r.align(e,Ie,s.vAlign),r.paddingBox=t.clone().unpad(u).unpad(f)},m=e.clone();for(d&&(m.x2=m.x1+a,m.y2=m.y1+l),c&&m.unpad(u).unpad(f).unpad(h),Kt.fn.reflow.call(this,m),t=d?this.box=new Wt(0,0,a,l):this.box,c&&d?(p(),m=this.contentBox=this.paddingBox.clone().unpad(h)):(m=this.contentBox=t.clone(),t.pad(h).pad(f).pad(u),p()),this.translateChildren(t.x1-m.x1+u.left+f+h.left,t.y1-m.y1+u.top+f+h.top),n=this.children,i=0;i<n.length;i++)o=n[i],o.reflow(o.box)},align:function(e,t,n){this.box.align(e,t,n)},hasBox:function(){var e=this.options;return e.border.width||e.background},createVisual:function(){Kt.fn.createVisual.call(this);var e=this.options;e.visible&&this.hasBox()&&this.visual.append(ve.fromRect(this.paddingBox.toRect(),this.visualStyle()))},visualStyle:function(){var e=this.options,t=e.border||{};return{stroke:{width:t.width,color:t.color,opacity:Ot(t.opacity,e.opacity),dashType:t.dashType},fill:{color:e.background,opacity:e.opacity},cursor:e.cursor}}}),y(Yt,{align:Fe,vAlign:Me,margin:{},padding:{},border:{color:je,width:0},background:"",shrinkToFit:!1,width:0,height:0,visible:!0}),Qt=Yt.extend({init:function(e,t){Yt.fn.init.call(this,e),this.pointData=t},getElement:function(){var e,t,n=this,i=n.options,o=n.paddingBox,r=i.type,s=i.rotation,a=o.center(),l=o.width()/2;return i.visible&&this.hasBox()?(e=this.visualStyle(),r===Ze?t=new me.Circle(new ke([Ht(o.x1+l,He),Ht(o.y1+o.height()/2,He)],l),e):r===Je?t=ve.fromPoints([[o.x1+l,o.y1],[o.x1,o.y2],[o.x2,o.y2]],e).close():r===et?(t=new me.MultiPath(e),t.moveTo(o.x1,o.y1).lineTo(o.x2,o.y2),t.moveTo(o.x1,o.y2).lineTo(o.x2,o.y1)):t=ve.fromRect(o.toRect(),e),s&&t.transform(xe().rotate(-s,[a.x,a.y])),t.options.zIndex=i.zIndex,t):null},createElement:function(){var e,t=this,n=this.options.visual,i=this.pointData||{};return e=n?n({value:i.value,dataItem:i.dataItem,sender:this.getSender(),series:i.series,category:i.category,rect:this.paddingBox.toRect(),options:this.visualOptions(),createVisual:function(){return t.getElement()}}):this.getElement()},visualOptions:function(){var e=this.options;return{background:e.background,border:e.border,margin:e.margin,padding:e.padding,type:e.type,size:e.width,visible:e.visible}},createVisual:function(){this.visual=this.createElement()}}),y(Qt,{type:Ze,align:Pe,vAlign:Pe}),Xt="linear",Zt="radial",Jt={glass:{type:Xt,rotation:0,stops:[{offset:0,color:We,opacity:0},{offset:.25,color:We,opacity:.3},{offset:1,color:We,opacity:0}]},sharpBevel:{type:Zt,stops:[{offset:0,color:We,opacity:.55},{offset:.65,color:We,opacity:0},{offset:.95,color:We,opacity:.25}]},roundedBevel:{type:Zt,stops:[{offset:.33,color:We,opacity:.06},{offset:.83,color:We,opacity:.2},{offset:.95,color:We,opacity:0}]},roundedGlass:{type:Zt,supportVML:!1,stops:[{offset:0,color:We,opacity:0},{offset:.5,color:We,opacity:.3},{offset:.99,color:We,opacity:0}]},sharpGlass:{type:Zt,supportVML:!1,stops:[{offset:0,color:We,opacity:.2},{offset:.15,color:We,opacity:.15},{offset:.17,color:We,opacity:.35},{offset:.85,color:We,opacity:.05},{offset:.87,color:We,opacity:.15},{offset:.99,color:We,opacity:0}]},bubbleShadow:{type:Zt,center:[.5,.5],radius:.5}},en=Kt.extend({init:function(e){Kt.fn.init.call(this,e);var t=this.options;t.width=parseInt(t.width,10),t.height=parseInt(t.height,10),this.gradients={}},reflow:function(){var e,t=this,n=t.options,i=t.children,o=new Wt(0,0,n.width,n.height);for(this.box=o.unpad(n.margin),e=0;e<i.length;e++)i[e].reflow(o),o=S(o,i[e].box)||new Wt},createVisual:function(){this.visual=new _e,this.createBackground()},createBackground:function(){var e=this.options,t=e.border||{},n=this.box.clone().pad(e.margin).unpad(t.width),i=ve.fromRect(n.toRect(),{stroke:{color:t.width?t.color:"",width:t.width,dashType:t.dashType},fill:{color:e.background,opacity:e.opacity},zIndex:-10});this.visual.append(i)},getRoot:function(){return this},createGradient:function(t){var n,i,o=this.gradients,r=Bt(t),s=Jt[t.gradient];return o[r]?n=o[r]:(i=e.extend({},s,t),"linear"===s.type?n=new me.LinearGradient(i):(t.innerRadius&&(i.stops=T(i)),n=new me.RadialGradient(i),n.supportVML=s.supportVML!==!1),o[r]=n),n}}),y(en,{width:Ve,height:Ue,background:We,border:{color:je,width:0},margin:f(5),zIndex:-2}),tn=Kt.extend({init:function(e){Kt.fn.init.call(this,e),this._initDirection()},_initDirection:function(){var e=this.options;e.vertical?(this.groupAxis=Ee,this.elementAxis=Ie,this.groupSizeField=Be,this.elementSizeField=Le,this.groupSpacing=e.spacing,this.elementSpacing=e.vSpacing):(this.groupAxis=Ie,this.elementAxis=Ee,this.groupSizeField=Le,this.elementSizeField=Be,this.groupSpacing=e.vSpacing,this.elementSpacing=e.spacing)},reflow:function(e){this.box=e.clone(),this.reflowChildren()},reflowChildren:function(){var e,t,n,i,o,r,s,a,l,c,d,u=this,h=this,f=h.box,p=h.elementAxis,m=h.groupAxis,g=h.elementSizeField,v=h.groupSizeField,_=this.groupOptions(),b=_.groups,w=_.groupsSize,y=_.maxGroupElementsSize,k=b.length,x=f[m+1]+this.alignStart(w,f[v]());if(k){for(e=x,t=0;t<k;t++){for(n=b[t],i=n.groupElements,o=f[p+1],r=i.length,s=0;s<r;s++)a=i[s],l=u.elementSize(a),c=e+u.alignStart(l[v],n.groupSize),d=new Wt,d[m+1]=c,d[m+2]=c+l[v],d[p+1]=o,d[p+2]=o+l[g],a.reflow(d),o+=l[g]+u.elementSpacing;e+=n.groupSize+u.groupSpacing}f[m+1]=x,f[m+2]=x+w,f[p+2]=f[p+1]+y}},alignStart:function(e,t){var n=0,i=this.options.align;return i===ze||i===Re?n=t-e:i===Pe&&(n=(t-e)/2),n},groupOptions:function(){var e,t,n,i=this,o=this,r=o.box,s=o.children,a=o.elementSizeField,l=o.groupSizeField,c=o.elementSpacing,d=o.groupSpacing,u=Ht(r[a]()),h=s.length,f=[],p=0,m=0,g=0,v=0,_=[];for(e=0;e<h;e++)t=s[e],t.box||t.reflow(r),n=i.elementSize(t),i.options.wrap&&Ht(m+c+n[a])>u&&(f.push({groupElements:_,groupSize:p,groupElementsSize:m}),v=Math.max(v,m),g+=d+p,p=0,m=0,_=[]),p=Math.max(p,n[l]),m>0&&(m+=c),m+=n[a],_.push(t);return f.push({groupElements:_,groupSize:p,groupElementsSize:m}),v=Math.max(v,m),g+=p,{groups:f,groupsSize:g,maxGroupElementsSize:v}},elementSize:function(e){return{width:e.box.width(),height:e.box.height()}},createVisual:function(){}}),y(tn,{vertical:!0,wrap:!0,vSpacing:0,spacing:0}),nn=me.Text,on=Kt.extend({init:function(e,t){Kt.fn.init.call(this,t),this.content=e,this.reflow(new Wt)},reflow:function(e){var t=this.options,n=t.size=ge.measureText(this.content,{font:t.font});this.baseline=n.baseline,this.box=new Wt(e.x1,e.y1,e.x1+n.width,e.y1+n.height)},createVisual:function(){var e=this.options,t=e.font,n=e.color,i=e.opacity,o=e.cursor;this.visual=new nn(this.content,this.box.toRect().topLeft(),{font:t,fill:{color:n,opacity:i},cursor:o})}}),y(on,{font:qe,color:je}),rn=/\n/m,sn=Yt.extend({init:function(e,t){Yt.fn.init.call(this,t),this.content=e,this._initContainer(),this.options._autoReflow!==!1&&this.reflow(new Wt)},_initContainer:function(){var e,t,n=this.options,i=(this.content+"").split(rn),o=new tn({vertical:!0,align:n.align,wrap:!1}),r=Te({},n,{opacity:1,animation:null});for(this.container=o,this.append(o),e=0;e<i.length;e++)t=new on(i[e].trim(),r),o.append(t)},reflow:function(e){var t,n,i,o,r=this.options,s=r.visual;this.container.options.align=r.align,s&&!this._boxReflow?(t=e,t.hasSize()||(this._boxReflow=!0,this.reflow(t),this._boxReflow=!1,t=this.box),n=this.visual=s(this.visualContext(t)),n&&(t=D(n.clippedBBox()||new ye),n.options.zIndex=r.zIndex),this.box=this.contentBox=this.paddingBox=t):(Yt.fn.reflow.call(this,e),r.rotation&&(i=f(r.margin),o=this.box.unpad(i),this.targetBox=e,this.normalBox=o.clone(),o=this.rotate(),o.translate(i.left-i.right,i.top-i.bottom),this.rotatedBox=o.clone(),o.pad(i)))},createVisual:function(){var e,t=this.options;t.visible&&(this.visual=new _e({transform:this.rotationTransform(),zIndex:t.zIndex,noclip:t.noclip}),this.hasBox()&&(e=ve.fromRect(this.paddingBox.toRect(),this.visualStyle()),this.visual.append(e)))},renderVisual:function(){if(this.options.visual){var e=this.visual;e&&!At(e.options.noclip)&&(e.options.noclip=this.options.noclip),this.addVisual(),this.createAnimation()}else Yt.fn.renderVisual.call(this)},visualOptions:function(){var e=this.options;return{background:e.background,border:e.border,color:e.color,font:e.font,margin:e.margin,padding:e.padding,visible:e.visible}},visualContext:function(e){var t=this;return{text:this.content,rect:e.toRect(),sender:this.getSender(),options:this.visualOptions(),createVisual:function(){return t._boxReflow=!0,t.reflow(e),t._boxReflow=!1,t.getDefaultVisual()}}},getDefaultVisual:function(){this.createVisual(),this.renderChildren();var e=this.visual;return delete this.visual,e},rotate:function(){var e=this.options;return this.box.rotate(e.rotation),this.align(this.targetBox,Ee,e.align),this.align(this.targetBox,Ie,e.vAlign),this.box},rotationTransform:function(){var e,t,n,i,o=this.options.rotation;return o?(e=this.normalBox.center(),t=e.x,n=e.y,i=this.rotatedBox.center(),xe().translate(i.x-t,i.y-n).rotate(o,[t,n])):null}}),an=Kt.extend({init:function(t){Kt.fn.init.call(this,t),this.append(new sn(this.options.text,e.extend({},this.options,{vAlign:this.options.position})))},reflow:function(e){Kt.fn.reflow.call(this,e),this.box.snapTo(e,Ee)}}),an.buildTitle=function(t,n,i){var o,r=t;return"string"==typeof t&&(r={text:t}),r=e.extend({visible:!0},i,r),r&&r.visible&&r.text&&(o=new an(r),n.append(o)),o},y(an,{color:je,position:Me,align:Pe,margin:f(5),padding:f(5)}),ln=sn.extend({init:function(e,t,n,i,o){sn.fn.init.call(this,t,o),this.text=t,this.value=e,this.index=n,this.dataItem=i,this.reflow(new Wt)},visualContext:function(e){var t=sn.fn.visualContext.call(this,e);return t.value=this.value,t.dataItem=this.dataItem,t.format=this.options.format,t.culture=this.options.culture,t},click:function(e,t){e.trigger($e,{element:Rt(t),value:this.value,text:this.text,index:this.index,dataItem:this.dataItem,axis:this.parent.options})},rotate:function(){var e,t;return this.options.alignRotation!==Pe?(e=this.normalBox.toRect(),t=this.rotationTransform(),this.box=D(e.bbox(t.matrix()))):sn.fn.rotate.call(this),this.box},rotationTransform:function(){var e,t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_=this.options,b=_.rotation;return b?_.alignRotation===Pe?sn.fn.rotationTransform.call(this):(e=xe().rotate(b).matrix(),t=this.normalBox.toRect(),n=this.targetBox.toRect(),i=_.rotationOrigin||Me,o=i===Me||i===Re?Ee:Ie,r=i===Me||i===Re?Ie:Ee,s=i===Me||i===Fe?n.origin:n.bottomRight(),a=t.topLeft().transformCopy(e),l=t.topRight().transformCopy(e),c=t.bottomRight().transformCopy(e),d=t.bottomLeft().transformCopy(e),u=ye.fromPoints(a,l,c,d),h={},h[r]=n.origin[r]-u.origin[r],f=Math.abs(a[r]+h[r]-s[r]),p=Math.abs(l[r]+h[r]-s[r]),Ht(f,Ge)===Ht(p,Ge)?(m=a,g=l):p<f?(m=l,g=c):(m=a,g=d),v=m[o]+(g[o]-m[o])/2,h[o]=n.center()[o]-v,xe().translate(h.x,h.y).rotate(b)):null}}),y(ln,{_autoReflow:!1}),cn=7,dn="#fff",un=Yt.extend({init:function(e,t,n){Yt.fn.init.call(this,t),this.fields=e,this.chartService=n,this.render()},hide:function(){this.options.visible=!1},show:function(){this.options.visible=!0},render:function(){var e,t,n,i,o,r,s,a,l,c=this.options;c.visible&&(e=c.label,t=c.icon,n=new Wt,i=t.size,o=this.fields.text,At(e)&&e.visible&&(a=p(e),a?o=a(this.fields):e.format&&(o=this.chartService.format.auto(e.format,o)),e.color||(e.color=e.position===nt?dn:t.background),this.label=new sn(o,Te({},e)),e.position!==nt||At(i)||(t.type===Ze?i=Math.max(this.label.box.width(),this.label.box.height()):(r=this.label.box.width(),s=this.label.box.height()),n.wrap(this.label.box))),t.width=r||i||cn,t.height=s||i||cn,l=new Qt(Te({},t)),this.marker=l,this.append(l),this.label&&this.append(this.label),l.reflow(new Wt),this.wrapperBox=n.wrap(l.box))},reflow:function(e){var t,n,i,o=this,r=o.options,s=o.label,a=o.marker,l=o.wrapperBox,c=e.center(),d=r.line.length,u=r.position;r.visible&&(v(u,[Fe,ze])?u===Fe?(i=l.alignTo(e,u).translate(-d,e.center().y-l.center().y),r.line.visible&&(t=[e.x1,c.y],this.linePoints=[t,[i.x2,c.y]],n=i.clone().wrapPoint(t))):(i=l.alignTo(e,u).translate(d,e.center().y-l.center().y),r.line.visible&&(t=[e.x2,c.y],this.linePoints=[t,[i.x1,c.y]],n=i.clone().wrapPoint(t))):u===Re?(i=l.alignTo(e,u).translate(e.center().x-l.center().x,d),r.line.visible&&(t=[c.x,e.y2],this.linePoints=[t,[c.x,i.y1]],n=i.clone().wrapPoint(t))):(i=l.alignTo(e,u).translate(e.center().x-l.center().x,-d),r.line.visible&&(t=[c.x,e.y1],this.linePoints=[t,[c.x,i.y2]],n=i.clone().wrapPoint(t))),a&&a.reflow(i),s&&(s.reflow(i),a&&(r.label.position===Qe&&s.box.alignTo(a.box,u),s.reflow(s.box))),this.contentBox=i,this.targetBox=e,this.box=n||i)},createVisual:function(){Yt.fn.createVisual.call(this),this.visual.options.noclip=this.options.noclip,this.options.visible&&this.createLine()},renderVisual:function(){var t=this,n=this.options,i=n.visual;n.visible&&i?(this.visual=i(e.extend(this.fields,{sender:this.getSender(),rect:this.targetBox.toRect(),options:{background:n.background,border:n.background,icon:n.icon,label:n.label,line:n.line,position:n.position,visible:n.visible},createVisual:function(){t.createVisual(),t.renderChildren();var e=t.visual;return delete t.visual,e}})),this.addVisual()):Yt.fn.renderVisual.call(this)},createLine:function(){var e,t=this.options.line;this.linePoints&&(e=ve.fromPoints(this.linePoints,{stroke:{color:t.color,width:t.width,dashType:t.dashType}}),o(e),this.visual.append(e))},click:function(e,t){var n=this.eventArgs(t);e.trigger(Ke,n)||t.preventDefault()},hover:function(e,t){var n=this.eventArgs(t);e.trigger(Ye,n)||t.preventDefault()},leave:function(e){e._unsetActivePoint()},eventArgs:function(t){var n=this.options;return e.extend(this.fields,{element:Rt(t),text:At(n.label)?n.label.text:"",visual:this.visual})}}),y(un,{icon:{visible:!0,type:Ze},label:{position:nt,visible:!0,align:Pe,vAlign:Pe},line:{visible:!0},visible:!0,position:Me,zIndex:2}),hn=Kt.extend({init:function(e,t){void 0===t&&(t=new vt),Kt.fn.init.call(this,e),this.chartService=t,this.options.visible||(this.options=Te({},this.options,{labels:{visible:!1},line:{visible:!1},margin:0,majorTickSize:0,minorTickSize:0})),this.options.minorTicks=Te({},{color:this.options.line.color,width:this.options.line.width,visible:this.options.minorTickType!==Xe},this.options.minorTicks,{size:this.options.minorTickSize,align:this.options.minorTickType}),this.options.majorTicks=Te({},{color:this.options.line.color,width:this.options.line.width,visible:this.options.majorTickType!==Xe},this.options.majorTicks,{size:this.options.majorTickSize,align:this.options.majorTickType}),this.options._deferLabels||this.createLabels(),this.createTitle(),this.createNotes()},labelsRange:function(){return{min:this.options.labels.skip,max:this.labelsCount()}},createLabels:function(){var e,t,n,i,o=this,r=this.options,s=r.vertical?ze:Pe,a=Te({},r.labels,{align:s,zIndex:r.zIndex}),l=Math.max(1,a.step);if(this.children=m(this.children,function(e){return!(e instanceof ln)}),this.labels=[],a.visible)for(e=this.labelsRange(),t=a.rotation,c(t)&&(a.alignRotation=t.align,a.rotation=t.angle),"auto"===a.rotation&&(a.rotation=0,r.autoRotateLabels=!0),n=e.min;n<e.max;n+=l)i=o.createAxisLabel(n,a),i&&(o.append(i),o.labels.push(i))},lineBox:function(){var e=this,t=e.options,n=e.box,i=t.vertical,o=t.labels.mirror,r=o?n.x1:n.x2,s=o?n.y2:n.y1,a=t.line.width||0;return i?new Wt(r,n.y1,r,n.y2-a):new Wt(n.x1,s,n.x2-a,s)},createTitle:function(){var e,t=this.options,n=Te({rotation:t.vertical?-90:0,text:"",zIndex:1,visualSize:!0},t.title);n.visible&&n.text&&(e=new sn(n.text,n),this.append(e),this.title=e)},createNotes:function(){var e,t,n,i=this,o=this.options,r=o.notes,s=r.data||[];for(this.notes=[],e=0;e<s.length;e++)t=Te({},r,s[e]),t.value=i.parseNoteValue(t.value),n=new un({value:t.value,text:t.label.text,dataItem:t},t,i.chartService),n.options.visible&&(At(n.options.position)?o.vertical&&!v(n.options.position,[Fe,ze])?n.options.position=o.reverse?Fe:ze:o.vertical||v(n.options.position,[Me,Re])||(n.options.position=o.reverse?Re:Me):n.options.position=o.vertical?o.reverse?Fe:ze:o.reverse?Re:Me,i.append(n),i.notes.push(n))},parseNoteValue:function(e){return e},renderVisual:function(){Kt.fn.renderVisual.call(this),this.createPlotBands()},createVisual:function(){Kt.fn.createVisual.call(this),this.createBackground(),this.createLine()},gridLinesVisual:function(){var e=this._gridLines;return e||(e=this._gridLines=new _e({zIndex:-2}),this.appendVisual(this._gridLines)),e},createTicks:function(e){function t(t,n,r){var a,l=t.length,c=Math.max(1,n.step);if(n.visible)for(a=n.skip;a<l;a+=c)At(r)&&a%r===0||(s.tickX=o?i.x2:i.x2-n.size,s.tickY=o?i.y1-n.size:i.y1,s.position=t[a],e.append(A(s,n)))}var n=this.options,i=this.lineBox(),o=n.labels.mirror,r=n.majorTicks.visible?n.majorUnit:0,s={vertical:n.vertical};t(this.getMajorTickPositions(),n.majorTicks),t(this.getMinorTickPositions(),n.minorTicks,r/n.minorUnit)},createLine:function(){var e,t,n=this.options,i=n.line,r=this.lineBox();i.width>0&&i.visible&&(e=new ve({stroke:{width:i.width,color:i.color,dashType:i.dashType}}),e.moveTo(r.x1,r.y1).lineTo(r.x2,r.y2),n._alignLines&&o(e),t=this._lineGroup=new _e,t.append(e),this.visual.append(t),this.createTicks(t))},getActualTickSize:function(){var e=this.options,t=0;return e.majorTicks.visible&&e.minorTicks.visible?t=Math.max(e.majorTicks.size,e.minorTicks.size):e.majorTicks.visible?t=e.majorTicks.size:e.minorTicks.visible&&(t=e.minorTicks.size),t},createBackground:function(){var e=this,t=e.options,n=e.box,i=t.background;i&&(this._backgroundPath=ve.fromRect(n.toRect(),{fill:{color:i},stroke:null}),this.visual.append(this._backgroundPath))},createPlotBands:function(){var e,t,n,i,o,r,s,a,l=this,c=this.options,d=c.plotBands||[],u=c.vertical,h=this.plotArea;if(0!==d.length){for(e=this._plotbandGroup=new _e({zIndex:-1}),t=m(this.pane.axes,function(e){return e.options.vertical!==l.options.vertical})[0],n=0;n<d.length;n++)i=d[n],o=void 0,r=void 0,u?(o=(t||h.axisX).lineBox(),r=l.getSlot(i.from,i.to,!0)):(o=l.getSlot(i.from,i.to,!0),r=(t||h.axisY).lineBox()),0!==o.width()&&0!==r.height()&&(s=new ye([o.x1,r.y1],[o.width(),r.height()]),a=ve.fromRect(s,{fill:{color:i.color,opacity:i.opacity},stroke:null}),e.append(a));this.appendVisual(e)}},createGridLines:function(e){function t(e,t,n){var i,o,r=e.length,s=Math.max(1,t.step);if(t.visible)for(i=t.skip;i<r;i+=s)o=Ht(e[i]),v(o,h)||i%n===0||a&&d===o||(u.position=o,f.append(E(u,t)),h.push(o))}var n=this.options,i=n.minorGridLines,o=n.majorGridLines,r=n.minorUnit,s=n.vertical,a=e.options.line.visible,l=o.visible?n.majorUnit:0,c=e.lineBox(),d=c[s?"y1":"x1"],u={lineStart:c[s?"x1":"y1"],lineEnd:c[s?"x2":"y2"],vertical:s},h=[],f=this.gridLinesVisual();return t(this.getMajorTickPositions(),o),t(this.getMinorTickPositions(),i,l/r),f.children},reflow:function(e){var t,n,i=this,o=i.options,r=i.labels,s=i.title,a=o.vertical,l=r.length,c=a?Be:Le,d=s?s.box[c]():0,u=this.getActualTickSize()+o.margin+d,h=(this.getRoot()||{}).box||e,f=h[c](),p=0;for(t=0;t<l;t++)n=r[t].box[c](),n+u<=f&&(p=Math.max(p,n));this.box=a?new Wt(e.x1,e.y1,e.x1+p+u,e.y2):new Wt(e.x1,e.y1,e.x2,e.y1+p+u),this.arrangeTitle(),this.arrangeLabels(),this.arrangeNotes()},getLabelsTickPositions:function(){return this.getMajorTickPositions()},labelTickIndex:function(e){return e.index},arrangeLabels:function(){var e,t,n,i,o,r,s,a,l,c,d,u=this,h=this,f=h.options,p=h.labels,m=!f.justified,g=f.vertical,v=this.lineBox(),_=f.labels.mirror,b=this.getLabelsTickPositions(),w=this.getActualTickSize()+f.margin;for(e=0;e<p.length;e++)t=p[e],n=u.labelTickIndex(t),i=g?t.box.height():t.box.width(),o=b[n]-i/2,r=void 0,s=void 0,a=void 0,g?(m&&(s=b[n],a=b[n+1],l=s+(a-s)/2,o=l-i/2),c=v.x2,_?(c+=w,t.options.rotationOrigin=Fe):(c-=w+t.box.width(),t.options.rotationOrigin=ze),r=t.box.move(c,o)):(m?(s=b[n],a=b[n+1]):(s=o,a=o+i),d=v.y1,_?(d-=w+t.box.height(),t.options.rotationOrigin=Re):(d+=w,t.options.rotationOrigin=Me),r=new Wt(s,d,a,d+t.box.height())),t.reflow(r)},autoRotateLabels:function(){var e,t,n,i,o,r,s;if(this.options.autoRotateLabels&&!this.options.vertical){for(e=this.getMajorTickPositions(),t=this.labels,i=0;i<t.length;i++)if(o=Math.abs(e[i+1]-e[i]),r=t[i].box,r.width()>o){if(r.height()>o){n=-90;break}n=-45}if(n){for(s=0;s<t.length;s++)t[s].options.rotation=n,t[s].reflow(new Wt);return!0}}},arrangeTitle:function(){var e=this,t=e.options,n=e.title,i=t.labels.mirror,o=t.vertical;n&&(o?(n.options.align=i?ze:Fe,n.options.vAlign=n.options.position):(n.options.align=n.options.position,n.options.vAlign=i?Me:Re),n.reflow(this.box))},arrangeNotes:function(){var e,t,n,i,o=this;for(e=0;e<this.notes.length;e++)t=o.notes[e],n=t.options.value,i=void 0,At(n)?(o.shouldRenderNote(n)?t.show():t.hide(),i=o.noteSlot(n)):t.hide(),t.reflow(i||o.lineBox())},noteSlot:function(e){return this.getSlot(e)},alignTo:function(e){var t=e.lineBox(),n=this.options.vertical,i=n?Ie:Ee;this.box.snapTo(t,i),n?this.box.shrink(0,this.lineBox().height()-t.height()):this.box.shrink(this.lineBox().width()-t.width(),0),this.box[i+1]-=this.lineBox()[i+1]-t[i+1],this.box[i+2]-=this.lineBox()[i+2]-t[i+2]},axisLabelText:function(e,t,n){var i=p(n),o=e;return i?o=i({value:e,dataItem:t,format:n.format,culture:n.culture}):n.format&&(o=this.chartService.format.localeAuto(n.format,[e],n.culture)),o},slot:function(e,t,n){var i=this.getSlot(e,t,n);if(i)return i.toRect()},contentBox:function(){var e,t=this.box.clone(),n=this.labels;return n.length&&(n[0].options.visible&&t.wrap(n[0].box),e=n[n.length-1],e.options.visible&&t.wrap(e.box)),t},limitRange:function(e,t,n,i,o){var r,s,a,l=this.options;return e<n&&o<0&&(!At(l.min)||l.min<=n)||i<t&&o>0&&(!At(l.max)||i<=l.max)?null:t<n&&o>0||i<e&&o<0?{min:e,max:t}:(r=t-e,s=e,a=t,e<n?(s=Pt(e,n,i),a=Pt(e+r,n+r,i)):t>i&&(a=Pt(t,n,i),s=Pt(t-r,n,i-r)),{min:s,max:a})},valueRange:function(){return{min:this.seriesMin,max:this.seriesMax}}}),y(hn,{labels:{visible:!0,rotation:0,mirror:!1,step:1,skip:0},line:{width:1,color:je,visible:!0},title:{visible:!0,position:Pe},majorTicks:{align:Qe,size:4,skip:0,step:1},minorTicks:{align:Qe,size:3,skip:0,step:1},axisCrossingValue:0,majorTickType:Qe,minorTickType:Xe,majorGridLines:{skip:0,step:1},minorGridLines:{visible:!1,width:1,color:je,skip:0,step:1},margin:5,visible:!0,reverse:!1,justified:!0,notes:{label:{text:""}},_alignLines:!0,_deferLabels:!1}),fn="milliseconds",pn="seconds",mn="minutes",gn="hours",vn="days",_n="weeks",bn="months",wn="years",yn=1,kn=1e3,xn=60*kn,Cn=60*xn,Sn=24*Cn,Tn=7*Sn,Dn=31*Sn,An=365*Sn,En={years:An,months:Dn,weeks:Tn,days:Sn,hours:Cn,minutes:xn,seconds:kn,milliseconds:yn},In=.01,Mn=hn.extend({init:function(e,t){hn.fn.init.call(this,e,t),this._ticks={},this._initCategories(this.options)},_initCategories:function(e){var t,n,i=(e.categories||[]).slice(0),o=At(e.min),r=At(e.max);e.categories=i,(o||r)&&i.length&&(e.srcCategories=e.categories,t=o?Math.floor(e.min):0,n=r?e.justified?Math.floor(e.max)+1:Math.ceil(e.max):i.length,e.categories=e.categories.slice(t,n))},rangeIndices:function(){var e,t=this.options,n=t.categories.length||1,i=s(t.min)?t.min%1:0;return e=s(t.max)&&t.max%1!==0&&t.max<this.totalRange().max?n-(1-t.max%1):n-(t.justified?1:0),{min:i,max:e}},totalRangeIndices:function(e){var t,n,i=this.options,o=s(i.min)?i.min:0;return t=s(i.max)?i.max:s(i.min)?o+i.categories.length:(i.srcCategories||i.categories).length-(i.justified?1:0)||1,e&&(n=this.totalRange(),o=Pt(o,0,n.max),t=Pt(t,0,n.max)),{min:o,max:t}},range:function(){var e=this.options;return{min:s(e.min)?e.min:0,max:s(e.max)?e.max:e.categories.length}},totalRange:function(){var e=this.options;return{min:0,max:Math.max(this._seriesMax||0,(e.srcCategories||e.categories).length)-(e.justified?1:0)}},getScale:function(){var e=this.rangeIndices(),t=e.min,n=e.max,i=this.lineBox(),o=this.options.vertical?i.height():i.width(),r=o/(n-t||1);return r*(this.options.reverse?-1:1)},getTickPositions:function(e){for(var t=this.options,n=t.vertical,i=t.reverse,o=this.rangeIndices(),r=o.min,s=o.max,a=this.lineBox(),l=this.getScale(),c=a[(n?Ie:Ee)+(i?2:1)],d=[],u=r%1!==0?Math.floor(r/1)+e:r;u<=s;)d.push(c+Ht(l*(u-r),He)),u+=e;return d},getLabelsTickPositions:function(){var e=this.getMajorTickPositions().slice(0),t=this.rangeIndices(),n=this.getScale(),i=this.lineBox(),o=this.options,r=o.vertical?Ie:Ee,s=o.reverse?2:1,a=o.reverse?1:2;return t.min%1!==0&&e.unshift(i[r+s]-n*(t.min%1)),t.max%1!==0&&e.push(i[r+a]+n*(1-t.max%1)),e},labelTickIndex:function(e){var t=this.rangeIndices(),n=e.index;return t.min>0&&(n-=Math.floor(t.min)),n},arrangeLabels:function(){hn.fn.arrangeLabels.call(this),this.hideOutOfRangeLabels()},hideOutOfRangeLabels:function(){var e,t,n,i,o,r=this,s=r.box,a=r.labels;a.length&&(e=this.options.vertical?Ie:Ee,t=s[e+1],n=s[e+2],i=a[0],o=zt(a),(i.box[e+1]>n||i.box[e+2]<t)&&(i.options.visible=!1),(o.box[e+1]>n||o.box[e+2]<t)&&(o.options.visible=!1))},getMajorTickPositions:function(){return this.getTicks().majorTicks},getMinorTickPositions:function(){return this.getTicks().minorTicks},getTicks:function(){var e=this.options,t=e.reverse,n=e.justified,i=this._ticks,o=this.rangeIndices(),r=this.lineBox(),s=r.getHash()+o.min+","+o.max+t+n;return i._hash!==s&&(i._hash=s,i.majorTicks=this.getTickPositions(1),i.minorTicks=this.getTickPositions(.5)),i},getSlot:function(e,t,n){var i,o,r=this.options,s=r.reverse,a=r.justified,l=r.vertical,c=this.rangeIndices(),d=c.min,u=l?Ie:Ee,h=this.lineBox(),f=this.getScale(),p=h[u+(s?2:1)],m=h.clone(),g=!At(t),v=Ot(e,0),_=Ot(t,v);return _=Math.max(_-1,v),_=Math.max(v,_),i=p+(v-d)*f,o=p+(_+1-d)*f,g&&a&&(o=i),n&&(i=Pt(i,h[u+1],h[u+2]),o=Pt(o,h[u+1],h[u+2])),m[u+1]=s?o:i,m[u+2]=s?i:o,m},limitSlot:function(e){var t=this.options.vertical,n=t?Ie:Ee,i=this.lineBox(),o=e.clone();return o[n+1]=Pt(e[n+1],i[n+1],i[n+2]),o[n+2]=Pt(e[n+2],i[n+1],i[n+2]),o},slot:function(e,t,n){var i=e,o=t;return"string"==typeof i&&(i=this.categoryIndex(i)),"string"==typeof o&&(o=this.categoryIndex(o)),hn.fn.slot.call(this,i,o,n)},pointCategoryIndex:function(e){var t,n,i=this.options,o=i.reverse,r=i.justified,s=i.vertical,a=s?Ie:Ee,l=this.lineBox(),c=this.rangeIndices(),d=o?c.max:c.min,u=this.getScale(),h=l[a+1],f=l[a+2],p=e[a];return p<h||p>f?null:(t=d+(p-h)/u,n=t%1,r?t=Math.round(t):0===n&&t>0&&t--,Math.floor(t))},getCategory:function(e){var t=this.pointCategoryIndex(e);return null===t?null:this.options.categories[t]},categoryIndex:function(e){var t=this.options,n=Y(e,t.srcCategories||t.categories);return n-Math.floor(t.min||0)},translateRange:function(e){var t=this.options,n=this.lineBox(),i=t.vertical?n.height():n.width(),o=t.categories.length,r=i/o,s=Ht(e/r,Ge);return{min:s,max:o+s}},zoomRange:function(e){var t=this.totalRangeIndices(),n=this.totalRange(),i=n.min,o=n.max,r=Pt(t.min+e,i,o),s=Pt(t.max-e,i,o);if(s-r>0)return{min:r,max:s}},scaleRange:function(e){var t=this.options.categories.length,n=e*t;return{min:-n,max:t+n}},labelsCount:function(){var e=this.labelsRange();return e.max-e.min},labelsRange:function(){var e,t=this.options,n=t.justified,i=t.labels,o=this.totalRangeIndices(!0),r=o.min,s=o.max,a=Math.floor(r);return n?(r=Math.ceil(r),s=Math.floor(s)):(r=Math.floor(r),s=Math.ceil(s)),e=r>i.skip?i.skip+i.step*Math.ceil((r-i.skip)/i.step):i.skip,{min:e-a,max:(t.categories.length?s+(n?1:0):0)-a}},createAxisLabel:function(e,t){var n=this.options,i=n.dataItems?n.dataItems[e]:null,o=Ot(n.categories[e],""),r=this.axisLabelText(o,i,t);return new ln(o,r,e,i,t)},shouldRenderNote:function(e){var t=this.totalRangeIndices();return Math.floor(t.min)<=e&&e<=Math.ceil(t.max)},noteSlot:function(e){var t=this.options,n=e-Math.floor(t.min||0);return this.getSlot(n)},arrangeNotes:function(){hn.fn.arrangeNotes.call(this),this.hideOutOfRangeNotes()},hideOutOfRangeNotes:function(){var e,t,n,i,o,r=this,s=r.notes,a=r.box;if(s&&s.length)for(e=this.options.vertical?Ie:Ee,t=a[e+1],n=a[e+2],i=0;i<s.length;i++)o=s[i],o.box&&(n<o.box[e+1]||o.box[e+2]<t)&&o.hide()},pan:function(e){var t=this.totalRangeIndices(!0),n=this.getScale(),i=Ht(e/n,Ge),o=this.totalRange(),r=t.min+i,s=t.max+i;return this.limitRange(r,s,0,o.max,i)},pointsRange:function(e,t){var n=this.options,i=n.reverse,o=n.vertical,r=o?Ie:Ee,s=this.lineBox(),a=this.totalRangeIndices(!0),l=this.getScale(),c=s[r+(i?2:1)],d=e[r]-c,u=t[r]-c,h=a.min+d/l,f=a.min+u/l,p=Math.min(h,f),m=Math.max(h,f);if(m-p>=In)return{min:p,max:m}},valueRange:function(){return this.range()}}),y(Mn,{type:"category",categories:[],vertical:!1,majorGridLines:{visible:!1,width:1,color:je},labels:{zIndex:1},justified:!1,_deferLabels:!0}),Rn=3e5,Fn={milliseconds:"HH:mm:ss.fff",seconds:"HH:mm:ss",minutes:"HH:mm",hours:"HH:mm",days:"M/d",weeks:"M/d",months:"MMM 'yy",years:"yyyy"},zn=.2,Pn="auto",Bn=[fn,pn,mn,gn,vn,_n,bn,wn],Ln="fit",Hn=Mn.extend({init:function(e,t){var n,i,o,r;Mn.fn.init.call(this,e,t),n=t.intl,i=this.options,i=Te({roundToBaseUnit:!0},i,{categories:K(n,i.categories),min:$(n,i.min),max:$(n,i.max)}),i.userSetBaseUnit=i.userSetBaseUnit||i.baseUnit,i.userSetBaseUnitStep=i.userSetBaseUnitStep||i.baseUnitStep,i.categories&&i.categories.length>0?(o=(i.baseUnit||"").toLowerCase(),r=o!==Ln&&!v(o,Bn),r&&(i.baseUnit=this.defaultBaseUnit(i)),o!==Ln&&i.baseUnitStep!==Pn||this.autoBaseUnit(i),this._groupsStart=B(i.categories[0],0,i.baseUnit,i.weekStartDay),this.groupCategories(i)):i.baseUnit=i.baseUnit||vn,this.options=i},_initCategories:function(){},shouldRenderNote:function(e){var t=this.range(),n=this.options.categories||[];return N(e,t.min)>=0&&N(e,t.max)<=0&&n.length},parseNoteValue:function(e){return $(this.chartService.intl,e)},noteSlot:function(e){return this.getSlot(e)},translateRange:function(e){var t,n,i=this.options,o=i.baseUnit,r=i.weekStartDay,s=i.vertical,a=this.lineBox(),l=s?a.height():a.width(),c=this.range(),d=l/(c.max-c.min),u=Ht(e/d,Ge);return c.min&&c.max&&(t=M(i.min||c.min,u),n=M(i.max||c.max,u),c={min:B(t,0,o,r),max:B(n,0,o,r)}),c},scaleRange:function(e){var t,n,i=Math.abs(e),o=this.range(),r=o.min,s=o.max;if(r&&s){for(;i--;)t=O(r,s),n=Math.round(.1*t),e<0?(r=M(r,n),s=M(s,-n)):(r=M(r,-n),s=M(s,n));o={min:r,max:s}}return o},defaultBaseUnit:function(e){var t,n,i,o,r,s=e.categories,a=At(s)?s.length:0,l=Ne;for(i=0;i<a;i++)o=s[i],o&&t&&(r=I(o,t),r>0&&(l=Math.min(l,r),n=l>=An?wn:l>=Dn-3*Sn?bn:l>=Tn?_n:l>=Sn?vn:l>=Cn?gn:l>=xn?mn:pn)),
t=o;return n||vn},_categoryRange:function(e){var t=e._range;return t||(t=e._range=k(e)),t},totalRange:function(){return{min:0,max:this.options.categories.length}},rangeIndices:function(){var e=this.options,t=e.categories,n=e.baseUnit,i=e.baseUnitStep||1,o=this.categoriesRange(),r=R(e.min||o.min),s=R(e.max||o.max),a=0,l=0;return t.length&&(a=j(r,t[0],n,i),l=j(s,t[0],n,i),e.roundToBaseUnit&&(a=Math.floor(a),l=e.justified?Math.floor(l):Math.ceil(l))),{min:a,max:l}},labelsRange:function(){var e=this.options,t=e.labels,n=this.rangeIndices(),i=Math.floor(n.min),o=Math.ceil(n.max);return{min:i+t.skip,max:e.categories.length?o+(e.justified?1:0):0}},categoriesRange:function(){var e=this.options,t=this._categoryRange(e.srcCategories||e.categories),n=R(t.max);return!e.justified&&U(n,this._roundToTotalStep(n,e,!1))&&(n=this._roundToTotalStep(n,e,!0,!0)),{min:R(t.min),max:n}},currentRange:function(){var e=this.options,t=e.roundToBaseUnit!==!1,n=this.categoriesRange(),i=e.min,o=e.max;return i||(i=t?this._roundToTotalStep(n.min,e,!1):n.min),o||(o=t?this._roundToTotalStep(n.max,e,!e.justified):n.max),{min:i,max:o}},datesRange:function(){var e=this._categoryRange(this.options.srcCategories||this.options.categories);return{min:R(e.min),max:R(e.max)}},pan:function(e){var t=this.options,n=this.lineBox(),i=t.vertical?n.height():n.width(),o=this.currentRange(),r=o.min,s=o.max,a=this.totalLimits(),l=i/(s-r),c=Ht(e/l,Ge),d=M(r,c),u=M(s,c),h=this.limitRange(V(d),V(u),V(a.min),V(a.max),c);if(h)return h.min=R(h.min),h.max=R(h.max),h.baseUnit=t.baseUnit,h.baseUnitStep=t.baseUnitStep||1,h.userSetBaseUnit=t.userSetBaseUnit,h.userSetBaseUnitStep=t.userSetBaseUnitStep,h},pointsRange:function(e,t){var n=Mn.fn.pointsRange.call(this,e,t),i=this.currentRange(),o=this.rangeIndices(),r=O(i.max,i.min)/(o.max-o.min),s=this.options,a=M(i.min,n.min*r),l=M(i.min,n.max*r);return{min:a,max:l,baseUnit:s.userSetBaseUnit,baseUnitStep:s.userSetBaseUnitStep}},zoomRange:function(e){var t,n,i,o,r,s,a,l,c,d=this.options,u=this.totalLimits(),h=d.weekStartDay,f=d.baseUnit,p=d.baseUnitStep||1,m=this.currentRange(),g=m.min,v=m.max,_=B(g,e*p,f,h),b=B(v,-e*p,f,h);if(d.userSetBaseUnit===Ln)if(t=d.autoBaseUnitSteps,n=d.maxDateGroups,i=zt(t[f])*n*En[f],o=O(v,g),r=O(b,_),s=Bn.indexOf(f),r<En[f]&&f!==fn)f=Bn[s-1],a=zt(t[f]),l=(o-(n-1)*a*En[f])/2,_=M(g,l),b=M(v,-l);else if(r>i&&f!==wn){c=0;do{s++,f=Bn[s],c=0,l=2*En[f];do a=t[f][c],c++;while(c<t[f].length&&l*a<o)}while(f!==wn&&l*a<o);l=(l*a-o)/2,l>0&&(_=M(g,-l),b=M(v,l),_=M(_,Pt(b,u.min,u.max)-b),b=M(b,Pt(_,u.min,u.max)-_))}if(_=R(Pt(_,u.min,u.max)),b=R(Pt(b,u.min,u.max)),_&&b&&O(b,_)>0)return{min:_,max:b,baseUnit:d.userSetBaseUnit,baseUnitStep:d.userSetBaseUnitStep}},totalLimits:function(){var e=this.options,t=this.datesRange(),n=this._roundToTotalStep(R(t.min),e,!1),i=t.max;return e.justified||(i=this._roundToTotalStep(i,e,!0,U(i,this._roundToTotalStep(i,e,!1)))),{min:n,max:i}},range:function(e){var t=e||this.options,n=t.categories,i=t.baseUnit===Ln,o=i?Bn[0]:t.baseUnit,r=t.baseUnitStep||1,s={baseUnit:o,baseUnitStep:r,weekStartDay:t.weekStartDay},a=this._categoryRange(n),l=R(t.min||a.min),c=R(t.max||a.max);return{min:this._roundToTotalStep(l,s,!1),max:this._roundToTotalStep(c,s,!0,!0)}},autoBaseUnit:function(e){for(var t,n,i,o=this._categoryRange(e.categories),r=R(e.max||o.max)-R(e.min||o.min),s=e.maxDateGroups||this.options.maxDateGroups,a=e.baseUnit===Ln,l=0,c=a?Bn[l++]:e.baseUnit,d=r/En[c],u=d,h=Te({},this.options.autoBaseUnitSteps,e.autoBaseUnitSteps);!n||d>=s;)if(t=t||h[c].slice(0),i=t.shift())n=i,d=u/n;else{if(c===zt(Bn)){n=Math.ceil(u/s);break}if(!a){d>s&&(n=Math.ceil(u/s));break}c=Bn[l++]||zt(Bn),u=r/En[c],t=null}e.baseUnitStep=n,e.baseUnit=c},groupCategories:function(e){var t,n,i=e.categories,o=e.baseUnit,r=e.baseUnitStep||1,s=R(k(i).max),a=this.range(e),l=a.min,c=a.max,d=[];for(n=l;n<c&&(d.push(n),t=B(n,r,o,e.weekStartDay),!(t>s)||e.max);n=t);e.srcCategories=i,e.categories=d},_roundToTotalStep:function(e,t,n,i){var o,r,s=t||this.options,a=s.baseUnit,l=s.baseUnitStep||1,c=this._groupsStart;return c?(o=j(e,c,a,l),r=n?Math.ceil(o):Math.floor(o),i&&r++,B(c,r*l,a,s.weekStartDay)):B(e,n?l:0,a,s.weekStartDay)},createAxisLabel:function(e,t){var n,i,o=this.options,r=o.dataItems?o.dataItems[e]:null,s=o.categories[e],a=o.baseUnit,l=t.dateFormats[a],c=!0;if(o.justified?(n=L(s,a,o.weekStartDay),c=U(n,s)):o.roundToBaseUnit||(c=!U(this.range().max,s)),c&&(t.format=t.format||l,i=this.axisLabelText(s,r,t)))return new ln(s,i,e,r,t)},categoryIndex:function(e){var t=this.options,n=t.categories,i=-1;return n.length&&(i=Math.floor(j(R(e),n[0],t.baseUnit,t.baseUnitStep||1))),i},getSlot:function(e,t,n){var i=e,o=t;return typeof i===rt&&(i=this.categoryIndex(i)),typeof o===rt&&(o=this.categoryIndex(o)),Mn.fn.getSlot.call(this,i,o,n)},valueRange:function(){var e=this.options,t=this._categoryRange(e.srcCategories||e.categories);return{min:R(t.min),max:R(t.max)}}}),y(Hn,{type:st,labels:{dateFormats:Fn},autoBaseUnitSteps:{milliseconds:[1,10,100],seconds:[1,2,5,15,30],minutes:[1,2,5,15,30],hours:[1,2,3],days:[1,2,3],weeks:[1,2],months:[1,2,3,6],years:[1,2,3,5,10,25,50]},maxDateGroups:10}),Nn=Math.pow(10,-Ge+1),On=hn.extend({init:function(e,t,n,i){var o=ne(e,t,n),r=ie(o,n);hn.fn.init.call(this,oe(o,n),i),this.totalMin=r.min,this.totalMax=r.max,this.totalMajorUnit=r.majorUnit,this.seriesMin=e,this.seriesMax=t},startValue:function(){return 0},range:function(){var e=this.options;return{min:e.min,max:e.max}},getDivisions:function(e){var t,n;return 0===e?1:(t=this.options,n=t.max-t.min,Math.floor(Ht(n/e,He))+1)},getTickPositions:function(e,t){var n,i=this.options,o=i.vertical,r=i.reverse,s=this.lineBox(),a=o?s.height():s.width(),l=i.max-i.min,c=a/l,d=e*c,u=this.getDivisions(e),h=(o?-1:1)*(r?-1:1),f=1===h?1:2,p=[],m=s[(o?Ie:Ee)+f],g=0;for(t&&(g=t/e),n=0;n<u;n++)n%g!==0&&p.push(Ht(m,He)),m+=d*h;return p},getMajorTickPositions:function(){return this.getTickPositions(this.options.majorUnit)},getMinorTickPositions:function(){return this.getTickPositions(this.options.minorUnit)},getSlot:function(e,t,n){var i,o,r,s,a,l,c,d,u,h,f,p,m,g;return void 0===n&&(n=!1),i=this.options,o=i.vertical,r=i.reverse,s=o?Ie:Ee,a=this.lineBox(),l=a[s+(r?2:1)],c=o?a.height():a.width(),d=r?-1:1,u=d*(c/(i.max-i.min)),h=new Wt(a.x1,a.y1,a.x1,a.y1),f=e,p=t,At(f)||(f=p||0),At(p)||(p=f||0),n&&(f=Math.max(Math.min(f,i.max),i.min),p=Math.max(Math.min(p,i.max),i.min)),o?(m=i.max-Math.max(f,p),g=i.max-Math.min(f,p)):(m=Math.min(f,p)-i.min,g=Math.max(f,p)-i.min),h[s+1]=te(l+u*(r?g:m)),h[s+2]=te(l+u*(r?m:g)),h},getValue:function(e){var t,n=this.options,i=n.vertical,o=n.reverse,r=+n.max,s=+n.min,a=i?Ie:Ee,l=this.lineBox(),c=l[a+(o?2:1)],d=i?l.height():l.width(),u=o?-1:1,h=u*(e[a]-c),f=(r-s)/d,p=h*f;return h<0||h>d?null:(t=i?r-p:s+p,Ht(t,Ge))},translateRange:function(e){var t=this.options,n=t.vertical,i=t.reverse,o=t.max,r=t.min,s=this.lineBox(),a=n?s.height():s.width(),l=o-r,c=a/l,d=Ht(e/c,Ge);return!n&&!i||n&&i||(d=-d),{min:r+d,max:o+d}},scaleRange:function(e){var t=this.options,n=-e*t.majorUnit;return{min:t.min-n,max:t.max+n}},labelsCount:function(){return this.getDivisions(this.options.majorUnit)},createAxisLabel:function(e,t){var n=this.options,i=Ht(n.min+e*n.majorUnit,Ge),o=this.axisLabelText(i,null,t);return new ln(i,o,e,null,t)},shouldRenderNote:function(e){var t=this.range();return t.min<=e&&e<=t.max},pan:function(e){var t=this.translateRange(e);return this.limitRange(t.min,t.max,this.totalMin,this.totalMax)},pointsRange:function(e,t){var n=this.getValue(e),i=this.getValue(t),o=Math.min(n,i),r=Math.max(n,i);if(this.isValidRange(o,r))return{min:o,max:r}},zoomRange:function(e){var t=this,n=t.totalMin,i=t.totalMax,o=this.scaleRange(e),r=Pt(o.min,n,i),s=Pt(o.max,n,i);if(this.isValidRange(r,s))return{min:r,max:s}},isValidRange:function(e,t){return t-e>Nn}}),y(On,{type:"numeric",min:0,max:1,vertical:!0,majorGridLines:{visible:!0,width:1,color:je},labels:{format:"#.####################"},zIndex:1}),Vn=hn.extend({init:function(e,t,n,i){var o=R(e),r=R(t),s=i.intl,a=n||{};a=Te(a||{},{min:$(s,a.min),max:$(s,a.max),axisCrossingValue:K(s,a.axisCrossingValues||a.axisCrossingValue)}),a=ae(o,r,a),hn.fn.init.call(this,a,i),this.seriesMin=o,this.seriesMax=r,this.totalMin=V(L(V(o)-1,a.baseUnit)),this.totalMax=V(H(V(r)+1,a.baseUnit))},range:function(){var e=this.options;return{min:e.min,max:e.max}},getDivisions:function(e){var t=this.options;return Math.floor(q(t.min,t.max,t.baseUnit)/e+1)},getTickPositions:function(e){var t,n,i,o=this.options,r=o.vertical,s=this.lineBox(),a=(r?-1:1)*(o.reverse?-1:1),l=1===a?1:2,c=s[(r?Ie:Ee)+l],d=this.getDivisions(e),u=O(o.max,o.min),h=r?s.height():s.width(),f=h/u,p=[c];for(t=1;t<d;t++)n=B(o.min,t*e,o.baseUnit),i=c+O(n,o.min)*f*a,p.push(Ht(i,He));return p},getMajorTickPositions:function(){return this.getTickPositions(this.options.majorUnit)},getMinorTickPositions:function(){return this.getTickPositions(this.options.minorUnit)},getSlot:function(e,t,n){return On.prototype.getSlot.call(this,R(e),R(t),n)},getValue:function(e){var t=On.prototype.getValue.call(this,e);return null!==t?R(t):null},labelsCount:function(){return this.getDivisions(this.options.majorUnit)},createAxisLabel:function(e,t){var n,i,o=this.options,r=e*o.majorUnit,s=o.min;return r>0&&(s=B(s,r,o.baseUnit)),n=t.dateFormats[o.baseUnit],t.format=t.format||n,i=this.axisLabelText(s,null,t),new ln(s,i,e,null,t)},translateRange:function(e,t){var n=this.options,i=n.baseUnit,o=n.weekStartDay,r=this.lineBox(),s=n.vertical?r.height():r.width(),a=this.range(),l=s/O(a.max,a.min),c=Ht(e/l,Ge),d=M(n.min,c),u=M(n.max,c);return t||(d=B(d,0,i,o),u=B(u,0,i,o)),{min:d,max:u}},scaleRange:function(e){for(var t,n,i=this.options,o=i.min,r=i.max,s=Math.abs(e);s--;)t=O(o,r),n=Math.round(.1*t),e<0?(o=M(o,n),r=M(r,-n)):(o=M(o,-n),r=M(r,n));return{min:o,max:r}},shouldRenderNote:function(e){var t=this.range();return N(e,t.min)>=0&&N(e,t.max)<=0},pan:function(e){var t=this.translateRange(e,!0),n=this.limitRange(V(t.min),V(t.max),this.totalMin,this.totalMax);if(n)return{min:R(n.min),max:R(n.max)}},pointsRange:function(e,t){var n=this.getValue(e),i=this.getValue(t),o=Math.min(n,i),r=Math.max(n,i);return{min:R(o),max:R(r)}},zoomRange:function(e){var t=this.scaleRange(e),n=R(Pt(V(t.min),this.totalMin,this.totalMax)),i=R(Pt(V(t.max),this.totalMin,this.totalMax));return{min:n,max:i}}}),y(Vn,{type:st,majorGridLines:{visible:!0,width:1,color:je},labels:{dateFormats:Fn}}),Un=10,Wn=hn.extend({init:function(e,t,n,i){var o=Te({majorUnit:Un,min:e,max:t},n),r=o.majorUnit,s=de(t,r),a=ce(e,t,o),l=le(a,s,o,n);o.max=l.max,o.min=l.min,o.minorUnit=n.minorUnit||Ht(r-1,Ge),hn.fn.init.call(this,o,i),this.totalMin=At(n.min)?Math.min(a,n.min):a,this.totalMax=At(n.max)?Math.max(s,n.max):s,this.logMin=Ht(he(l.min,r),Ge),this.logMax=Ht(he(l.max,r),Ge),this.seriesMin=e,this.seriesMax=t,this.createLabels()},startValue:function(){return this.options.min},getSlot:function(e,t,n){var i,o,r=this,s=r.options,a=r.logMin,l=r.logMax,c=s.reverse,d=s.vertical,u=s.majorUnit,h=d?Ie:Ee,f=this.lineBox(),p=f[h+(c?2:1)],m=d?f.height():f.width(),g=c?-1:1,v=g*(m/(l-a)),_=new Wt(f.x1,f.y1,f.x1,f.y1),b=e,w=t;return At(b)||(b=w||1),At(w)||(w=b||1),b<=0||w<=0?null:(n&&(b=Math.max(Math.min(b,s.max),s.min),w=Math.max(Math.min(w,s.max),s.min)),b=he(b,u),w=he(w,u),d?(i=l-Math.max(b,w),o=l-Math.min(b,w)):(i=Math.min(b,w)-a,o=Math.max(b,w)-a),_[h+1]=te(p+v*(c?o:i)),_[h+2]=te(p+v*(c?i:o)),_)},getValue:function(e){var t,n=this,i=n.options,o=n.logMin,r=n.logMax,s=i.reverse,a=i.vertical,l=i.majorUnit,c=this.lineBox(),d=a===s?1:-1,u=1===d?1:2,h=a?c.height():c.width(),f=(r-o)/h,p=a?Ie:Ee,m=c[p+u],g=d*(e[p]-m),v=g*f;return g<0||g>h?null:(t=o+v,Ht(Math.pow(l,t),Ge))},range:function(){var e=this.options;return{min:e.min,max:e.max}},scaleRange:function(e){var t=this.options.majorUnit,n=-e;return{min:Math.pow(t,this.logMin-n),max:Math.pow(t,this.logMax+n)}},translateRange:function(e){var t=this,n=t.options,i=t.logMin,o=t.logMax,r=n.reverse,s=n.vertical,a=n.majorUnit,l=this.lineBox(),c=s?l.height():l.width(),d=c/(o-i),u=Ht(e/d,Ge);return!s&&!r||s&&r||(u=-u),{min:Math.pow(a,i+u),max:Math.pow(a,o+u)}},labelsCount:function(){var e=Math.floor(this.logMax),t=Math.floor(e-this.logMin)+1;return t},getMajorTickPositions:function(){var e=[];return this.traverseMajorTicksPositions(function(t){e.push(t)},{step:1,skip:0}),e},createTicks:function(e){function t(t,n){c.tickX=s?a.x2:a.x2-n.size,c.tickY=s?a.y1-n.size:a.y1,c.position=t,e.append(A(c,n))}var n=this.options,i=n.majorTicks,o=n.minorTicks,r=n.vertical,s=n.labels.mirror,a=this.lineBox(),l=[],c={vertical:r};return i.visible&&this.traverseMajorTicksPositions(t,i),o.visible&&this.traverseMinorTicksPositions(t,o),l},createGridLines:function(e){function t(e,t){v(e,l)||(a.position=e,c.append(E(a,t)),l.push(e))}var n=this.options,i=n.minorGridLines,o=n.majorGridLines,r=n.vertical,s=e.lineBox(),a={lineStart:s[r?"x1":"y1"],lineEnd:s[r?"x2":"y2"],vertical:r},l=[],c=this.gridLinesVisual();return o.visible&&this.traverseMajorTicksPositions(t,o),i.visible&&this.traverseMinorTicksPositions(t,i),c.children},traverseMajorTicksPositions:function(e,t){var n,i,o=this._lineOptions(),r=o.lineStart,s=o.step,a=this,l=a.logMin,c=a.logMax;for(n=Math.ceil(l)+t.skip;n<=c;n+=t.step)i=Ht(r+s*(n-l),Ge),e(i,t)},traverseMinorTicksPositions:function(e,t){var n,i,o,r,s,a=this,l=this.options,c=l.min,d=l.max,u=l.minorUnit,h=l.majorUnit,f=this._lineOptions(),p=f.lineStart,m=f.step,g=this,v=g.logMin,_=g.logMax,b=Math.floor(v);for(n=b;n<_;n++)for(i=a._minorIntervalOptions(n),o=t.skip;o<u&&(r=i.value+o*i.minorStep,!(r>d));o+=t.step)r>=c&&(s=Ht(p+m*(he(r,h)-v),Ge),e(s,t))},createAxisLabel:function(e,t){var n=Math.ceil(this.logMin+e),i=Math.pow(this.options.majorUnit,n),o=this.axisLabelText(i,null,t);return new ln(i,o,e,null,t)},shouldRenderNote:function(e){var t=this.range();return t.min<=e&&e<=t.max},pan:function(e){var t=this.translateRange(e);return this.limitRange(t.min,t.max,this.totalMin,this.totalMax,-e)},pointsRange:function(e,t){var n=this.getValue(e),i=this.getValue(t),o=Math.min(n,i),r=Math.max(n,i);return{min:o,max:r}},zoomRange:function(e){var t=this,n=t.options,i=t.totalMin,o=t.totalMax,r=this.scaleRange(e),s=Pt(r.min,i,o),a=Pt(r.max,i,o),l=n.majorUnit,c=a>s&&n.min&&n.max&&Ht(he(n.max,l)-he(n.min,l),Ge)<1,d=!(n.min===i&&n.max===o)&&Ht(he(a,l)-he(s,l),Ge)>=1;if(c||d)return{min:s,max:a}},_minorIntervalOptions:function(e){var t=this.options,n=t.minorUnit,i=t.majorUnit,o=Math.pow(i,e),r=Math.pow(i,e+1),s=r-o,a=s/n;return{value:o,minorStep:a}},_lineOptions:function(){var e=this.options,t=e.reverse,n=e.vertical,i=n?Ie:Ee,o=this.lineBox(),r=n===t?1:-1,s=1===r?1:2,a=n?o.height():o.width(),l=r*(a/(this.logMax-this.logMin)),c=o[i+s];return{step:l,lineStart:c,lineBox:o}}}),y(Wn,{type:"log",majorUnit:Un,minorUnit:1,axisCrossingValue:1,vertical:!0,majorGridLines:{visible:!0,width:1,color:je},zIndex:1,_deferLabels:!0}),jn={createGridLines:function(e){var t,n,i=this.options,o=Math.abs(this.box.center().y-e.lineBox().y1),r=[],s=!1;return i.majorGridLines.visible&&(t=this.majorGridLineAngles(e),s=!0,r=this.renderMajorGridLines(t,o,i.majorGridLines)),i.minorGridLines.visible&&(n=this.minorGridLineAngles(e,s),Tt(r,this.renderMinorGridLines(n,o,i.minorGridLines,e,s))),r},renderMajorGridLines:function(e,t,n){return this.renderGridLines(e,t,n)},renderMinorGridLines:function(e,t,n,i,o){var r=this.radiusCallback&&this.radiusCallback(t,i,o);return this.renderGridLines(e,t,n,r)},renderGridLines:function(e,t,n,i){var o,r,s={stroke:{width:n.width,color:n.color,dashType:n.dashType}},a=this.box.center(),l=new ke([a.x,a.y],t),c=this.gridLinesVisual();for(o=0;o<e.length;o++)r=new ve(s),i&&(l.radius=i(e[o])),r.moveTo(l.center).lineTo(l.pointAt(e[o]+180)),c.append(r);return c.children},gridLineAngles:function(e,t,n,i,o){var r=this,s=this.intervals(t,n,i,o),a=e.options,l=a.visible&&(a.line||{}).visible!==!1;return b(s,function(e){var t=r.intervalAngle(e);if(!l||90!==t)return t})}},qn=Mn.extend({range:function(){return{min:0,max:this.options.categories.length}},reflow:function(e){this.box=e,this.reflowLabels()},lineBox:function(){return this.box},reflowLabels:function(){var e,t,n=this,i=this,o=i.labels,r=i.options.labels,s=r.skip||0,a=r.step||1,l=new Wt;for(e=0;e<o.length;e++)o[e].reflow(l),t=o[e].box,o[e].reflow(n.getSlot(s+e*a).adjacentBox(0,t.width(),t.height()))},intervals:function(e,t,n,i){var o,r,s,a,l,c,d,u,h;for(void 0===i&&(i=!1),o=this.options,r=o.categories.length,s=r/e||1,a=360/s,l=t||0,c=n||1,d=[],u=0,h=l;h<s;h+=c)u=o.reverse?360-h*a:h*a,u=Ht(u,He)%360,i&&v(u,i)||d.push(u);return d},majorIntervals:function(){return this.intervals(1)},minorIntervals:function(){return this.intervals(.5)},intervalAngle:function(e){return(360+e+this.options.startAngle)%360},majorAngles:function(){var e=this;return b(this.majorIntervals(),function(t){return e.intervalAngle(t)})},createLine:function(){return[]},majorGridLineAngles:function(e){var t=this.options.majorGridLines;return this.gridLineAngles(e,1,t.skip,t.step)},minorGridLineAngles:function(e,t){var n=this.options,i=n.minorGridLines,o=n.majorGridLines,r=t?this.intervals(1,o.skip,o.step):null;return this.gridLineAngles(e,.5,i.skip,i.step,r)},radiusCallback:function(e,t,n){var i,o,r,s;if(t.options.type!==tt)return i=Lt(360/(2*this.options.categories.length)),o=Math.cos(i)*e,r=this.majorAngles(),s=function(t){return!n&&v(t,r)?e:o}},createPlotBands:function(){var e,t,n,i,o,r,s,a=this,l=this.options.plotBands||[],c=this._plotbandGroup=new _e({zIndex:-1});for(e=0;e<l.length;e++)t=l[e],n=a.plotBandSlot(t),i=a.getSlot(t.from),o=t.from-Math.floor(t.from),n.startAngle+=o*i.angle,r=Math.ceil(t.to)-t.to,n.angle-=(r+o)*i.angle,s=$t.current.createRing(n,{fill:{color:t.color,opacity:t.opacity},stroke:{opacity:t.opacity}}),c.append(s);this.appendVisual(c)},plotBandSlot:function(e){return this.getSlot(e.from,e.to-1)},getSlot:function(e,t){var n,i,o,r,s=this.options,a=s.justified,l=this.box,c=this.majorAngles(),d=c.length,u=360/d,h=e;return s.reverse&&!a&&(h=(h+1)%d),h=Pt(Math.floor(h),0,d-1),n=c[h],a&&(n-=u/2,n<0&&(n+=360)),i=Pt(Math.ceil(t||h),h,d-1),o=i-h+1,r=u*o,new jt(l.center(),0,l.height()/2,n,r)},slot:function(e,t){var n=this.getSlot(e,t),i=n.startAngle+180,o=i+n.angle;return new we.Arc([n.center.x,n.center.y],{startAngle:i,endAngle:o,radiusX:n.radius,radiusY:n.radius})},pointCategoryIndex:function(e){var t,n,i=this,o=this.options.categories.length,r=null;for(t=0;t<o;t++)if(n=i.getSlot(t),n.containsPoint(e)){r=t;break}return r}}),y(qn,{startAngle:90,labels:{margin:f(10)},majorGridLines:{visible:!0},justified:!0}),Te(qn.prototype,jn),Gn=hn.extend({init:function(e,t){hn.fn.init.call(this,e,t);var n=this.options;n.minorUnit=n.minorUnit||n.majorUnit/2},getDivisions:function(e){return On.prototype.getDivisions.call(this,e)-1},reflow:function(e){this.box=e,this.reflowLabels()},reflowLabels:function(){var e,t,n=this,i=this,o=i.options,r=i.labels,s=i.options.labels,a=s.skip||0,l=s.step||1,c=new Wt,d=this.intervals(o.majorUnit,a,l);for(e=0;e<r.length;e++)r[e].reflow(c),t=r[e].box,r[e].reflow(n.getSlot(d[e]).adjacentBox(0,t.width(),t.height()))},lineBox:function(){return this.box},intervals:function(e,t,n,i){var o,r,s,a,l,c,d;for(void 0===i&&(i=!1),o=this.options.min,r=this.getDivisions(e),s=[],a=t||0,l=n||1,c=a;c<r;c+=l)d=(360+o+c*e)%360,i&&v(d,i)||s.push(d);return s},majorIntervals:function(){return this.intervals(this.options.majorUnit)},minorIntervals:function(){return this.intervals(this.options.minorUnit)},intervalAngle:function(e){return(540-e-this.options.startAngle)%360},createLine:function(){return[]},majorGridLineAngles:function(e){var t=this.options.majorGridLines;return this.gridLineAngles(e,this.options.majorUnit,t.skip,t.step)},minorGridLineAngles:function(e,t){var n=this.options,i=n.minorGridLines,o=n.majorGridLines,r=t?this.intervals(n.majorUnit,o.skip,o.step):null;return this.gridLineAngles(e,n.minorUnit,i.skip,i.step,r)},plotBandSlot:function(e){return this.getSlot(e.from,e.to)},getSlot:function(e,t){var n,i=this,o=i.options,r=i.box,s=o.startAngle,a=Pt(e,o.min,o.max),l=Pt(t||a,a,o.max);return o.reverse&&(a*=-1,l*=-1),a=(540-a-s)%360,l=(540-l-s)%360,l<a&&(n=a,a=l,l=n),new jt(r.center(),0,r.height()/2,a,l-a)},slot:function(e,t){var n,i,o,r,s,a,l;return void 0===t&&(t=e),n=this.options,i=360-n.startAngle,o=this.getSlot(e,t),r=Math.min(e,t),s=Math.max(e,t),n.reverse?(a=r,l=s):(a=360-s,l=360-r),a=(a+i)%360,l=(l+i)%360,new we.Arc([o.center.x,o.center.y],{startAngle:a,endAngle:l,radiusX:o.radius,radiusY:o.radius})},getValue:function(e){var t=this.options,n=this.box.center(),i=e.x-n.x,o=e.y-n.y,r=Math.round(Et(Math.atan2(o,i))),s=t.startAngle;return t.reverse||(r*=-1,s*=-1),(r+s+360)%360},valueRange:function(){return{min:0,max:2*Math.PI}}}),y(Gn,{type:"polar",startAngle:0,reverse:!1,majorUnit:60,min:0,max:360,labels:{margin:f(10)},majorGridLines:{color:je,visible:!0,width:1},minorGridLines:{color:"#aaa"}}),Te(Gn.prototype,jn,{createPlotBands:qn.prototype.createPlotBands,majorAngles:qn.prototype.majorAngles,range:On.prototype.range,labelsCount:On.prototype.labelsCount,createAxisLabel:On.prototype.createAxisLabel}),$n={options:{majorGridLines:{visible:!0}},createPlotBands:function(){var e,t,n,i,o,r,s,a,l,c,d=this,u=this.options,h=u.majorGridLines.type,f=u.plotBands;for(void 0===f&&(f=[]),e=this.plotArea.polarAxis,t=e.majorAngles(),n=e.box.center(),i=this._plotbandGroup=new _e({zIndex:-1}),o=0;o<f.length;o++)r=f[o],s={fill:{color:r.color,opacity:r.opacity},stroke:{opacity:r.opacity}},a=d.getSlot(r.from,r.to,!0),l=new jt(n,n.y-a.y2,n.y-a.y1,0,360),c=void 0,c=h===tt?$t.current.createRing(l,s):ve.fromPoints(d.plotBandPoints(l,t),s).close(),i.append(c);this.appendVisual(i)},plotBandPoints:function(e,t){var n,i=[],o=[],r=[e.center.x,e.center.y],s=new ke(r,e.innerRadius),a=new ke(r,e.radius);for(n=0;n<t.length;n++)i.push(s.pointAt(t[n]+180)),o.push(a.pointAt(t[n]+180));return i.reverse(),i.push(i[0]),o.push(o[0]),o.concat(i)},createGridLines:function(e){var t,n=this.options,i=this.radarMajorGridLinePositions(),o=e.majorAngles(),r=e.box.center(),s=[];return n.majorGridLines.visible&&(s=this.renderGridLines(r,i,o,n.majorGridLines)),n.minorGridLines.visible&&(t=this.radarMinorGridLinePositions(),Tt(s,this.renderGridLines(r,t,o,n.minorGridLines))),s},renderGridLines:function(e,t,n,i){var o,r,s,a,l,c,d,u={stroke:{width:i.width,color:i.color,dashType:i.dashType}},h=i.skip;for(void 0===h&&(h=0),o=i.step,void 0===o&&(o=0),r=this.gridLinesVisual(),s=h;s<t.length;s+=o)if(a=e.y-t[s],a>0)if(l=new ke([e.x,e.y],a),i.type===tt)r.append(new me.Circle(l,u));else{for(c=new ve(u),d=0;d<n.length;d++)c.lineTo(l.pointAt(n[d]+180));c.close(),r.append(c)}return r.children},getValue:function(e){var t,n,i,o,r,s,a,l=this.lineBox(),c=this.plotArea.polarAxis,d=c.majorAngles(),u=c.box.center(),h=e.distanceTo(u),f=h;return this.options.majorGridLines.type!==tt&&d.length>1&&(t=e.x-u.x,n=e.y-u.y,i=(Et(Math.atan2(n,t))+540)%360,d.sort(function(e,t){return fe(e,i)-fe(t,i)}),o=fe(d[0],d[1])/2,r=fe(i,d[0]),s=90-o,a=180-r-s,f=h*(Math.sin(Lt(a))/Math.sin(Lt(s)))),this.axisType().prototype.getValue.call(this,new Ut(l.x1,l.y2-f))}},Kn=On.extend({radarMajorGridLinePositions:function(){return this.getTickPositions(this.options.majorUnit)},radarMinorGridLinePositions:function(){var e=this.options,t=0;return e.majorGridLines.visible&&(t=e.majorUnit),this.getTickPositions(e.minorUnit,t)},axisType:function(){return On}}),Te(Kn.prototype,$n),Yn=Wn.extend({radarMajorGridLinePositions:function(){var e=[];return this.traverseMajorTicksPositions(function(t){e.push(t)},this.options.majorGridLines),e},radarMinorGridLinePositions:function(){var e=[];return this.traverseMinorTicksPositions(function(t){e.push(t)},this.options.minorGridLines),e},axisType:function(){return Wn}}),Te(Yn.prototype,$n),Qn=.333,Xn=.01,Zn=be.extend({init:function(e){this.closed=e},process:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f,p,m=this,g=e.slice(0),v=[],_=this.closed,b=g.length;if(b>2&&(this.removeDuplicates(0,g),b=g.length),b<2||2===b&&g[0].equals(g[1]))return v;for(t=g[0],n=g[1],i=g[2],v.push(new Ce(t));t.equals(g[b-1]);)_=!0,g.pop(),b--;if(2===b)return o=this.tangent(t,n,Ee,Ie),zt(v).controlOut(this.firstControlPoint(o,t,n,Ee,Ie)),v.push(new Ce(n,this.secondControlPoint(o,t,n,Ee,Ie))),v;for(_?(t=g[b-1],n=g[0],i=g[1],a=this.controlPoints(t,n,i),r=a[1],s=a[0]):(l=this.tangent(t,n,Ee,Ie),r=this.firstControlPoint(l,t,n,Ee,Ie)),c=r,d=0;d<=b-3;d++)m.removeDuplicates(d,g),b=g.length,d+3<=b&&(t=g[d],n=g[d+1],i=g[d+2],u=m.controlPoints(t,n,i),zt(v).controlOut(c),c=u[1],h=u[0],v.push(new Ce(n,h)));return _?(t=g[b-2],n=g[b-1],i=g[0],f=this.controlPoints(t,n,i),zt(v).controlOut(c),v.push(new Ce(n,f[0])),zt(v).controlOut(f[1]),v.push(new Ce(i,s))):(p=this.tangent(n,i,Ee,Ie),zt(v).controlOut(c),v.push(new Ce(i,this.secondControlPoint(p,n,i,Ee,Ie)))),v},removeDuplicates:function(e,t){for(;t[e+1]&&(t[e].equals(t[e+1])||t[e+1].equals(t[e+2]));)t.splice(e+1,1)},invertAxis:function(e,t,n){var i,o,r=!1;return e.x===t.x?r=!0:t.x===n.x?(t.y<n.y&&e.y<=t.y||n.y<t.y&&t.y<=e.y)&&(r=!0):(i=this.lineFunction(e,t),o=this.calculateFunction(i,n.x),e.y<=t.y&&n.y<=o||t.y<=e.y&&n.y>=o||(r=!0)),r},isLine:function(e,t,n){var i=this.lineFunction(e,t),o=this.calculateFunction(i,n.x);return e.x===t.x&&t.x===n.x||Ht(o,1)===Ht(n.y,1)},lineFunction:function(e,t){var n=(t.y-e.y)/(t.x-e.x),i=e.y-n*e.x;return[i,n]},controlPoints:function(e,t,n){var i,o,r,s,a,l,c=Ee,d=Ie,u=!1,h=!1;return this.isLine(e,t,n)?i=this.tangent(e,t,Ee,Ie):(o={x:this.isMonotonicByField(e,t,n,Ee),y:this.isMonotonicByField(e,t,n,Ie)},o.x&&o.y?(i=this.tangent(e,n,Ee,Ie),u=!0):(this.invertAxis(e,t,n)&&(c=Ie,d=Ee),o[c]?i=0:(r=n[d]<e[d]&&e[d]<=t[d]||e[d]<n[d]&&t[d]<=e[d]?pe((n[d]-e[d])*(t[c]-e[c])):-pe((n[c]-e[c])*(t[d]-e[d])),i=Xn*r,h=!0))),s=this.secondControlPoint(i,e,t,c,d),h&&(a=c,c=d,d=a),l=this.firstControlPoint(i,t,n,c,d),u&&(this.restrictControlPoint(e,t,s,i),this.restrictControlPoint(t,n,l,i)),[s,l]},restrictControlPoint:function(e,t,n,i){e.y<t.y?t.y<n.y?(n.x=e.x+(t.y-e.y)/i,n.y=t.y):n.y<e.y&&(n.x=t.x-(t.y-e.y)/i,n.y=e.y):n.y<t.y?(n.x=e.x-(e.y-t.y)/i,n.y=t.y):e.y<n.y&&(n.x=t.x+(e.y-t.y)/i,n.y=e.y)},tangent:function(e,t,n,i){var o,r=t[n]-e[n],s=t[i]-e[i];return o=0===r?0:s/r},isMonotonicByField:function(e,t,n,i){return n[i]>t[i]&&t[i]>e[i]||n[i]<t[i]&&t[i]<e[i]},firstControlPoint:function(e,t,n,i,o){var r=t[i],s=n[i],a=(s-r)*Qn;return this.point(r+a,t[o]+a*e,i,o)},secondControlPoint:function(e,t,n,i,o){var r=t[i],s=n[i],a=(s-r)*Qn;return this.point(s-a,n[o]-a*e,i,o)},point:function(e,t,n,i){var o=new we.Point;return o[n]=e,o[i]=t,o},calculateFunction:function(e,t){var n,i=e.length,o=0;for(n=0;n<i;n++)o+=Math.pow(t,n)*e[n];return o}}),Se.Gradients=Jt,kendo.deepExtend(kendo.dataviz,{constants:ct,services:kt,autoMajorUnit:Q,Point:Ut,Box:Wt,Ring:jt,Sector:qt,ShapeBuilder:$t,ShapeElement:Qt,ChartElement:Kt,BoxElement:Yt,RootElement:en,FloatElement:tn,Text:on,TextBox:sn,Title:an,AxisLabel:ln,Axis:hn,Note:un,CategoryAxis:Mn,DateCategoryAxis:Hn,DateValueAxis:Vn,NumericAxis:On,LogarithmicAxis:Wn,PolarAxis:Gn,RadarCategoryAxis:qn,RadarNumericAxis:Kn,RadarLogarithmicAxis:Yn,CurveProcessor:Zn,rectToBox:D,addClass:n,removeClass:i,alignPathToPixel:o,clockwise:r,convertableToNumber:l,deepExtend:Te,elementStyles:h,getSpacing:f,getTemplate:p,getter:Ae,grep:m,hasClasses:g,inArray:v,interpolateValue:_,InstanceObserver:Ct,isArray:t,isFunction:De,isNumber:s,isObject:c,isString:a,map:b,mousewheelDelta:w,FontLoader:Vt,setDefaultOptions:y,sparseArrayLimits:k,styleValue:d,append:Tt,bindEvents:Dt,Class:be,defined:At,deg:Et,elementOffset:It,elementSize:Mt,eventElement:Rt,eventCoordinates:Ft,last:zt,limitValue:Pt,logToConsole:kendo.logToConsole,objectKey:Bt,rad:Lt,round:Ht,unbindEvents:Nt,valueOrDefault:Ot,absoluteDateDiff:I,addDuration:B,addTicks:M,ceilDate:H,dateComparer:N,dateDiff:O,dateEquals:U,dateIndex:j,duration:q,floorDate:L,lteDateIndex:G,startOfWeek:F,toDate:R,parseDate:$,parseDates:K,toTime:V})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/core/core.min",["dataviz/core/kendo-core.min"],e)}(function(){!function(e){var t=kendo.dataviz,n=t.services,i=kendo.drawing;t.ExportMixin={extend:function(e,t){if(!e.exportVisual)throw Error("Mixin target has no exportVisual method defined.");e.exportSVG=this.exportSVG,e.exportImage=this.exportImage,e.exportPDF=this.exportPDF,t||(e.svg=this.svg,e.imageDataURL=this.imageDataURL)},exportSVG:function(e){return i.exportSVG(this.exportVisual(),e)},exportImage:function(e){return i.exportImage(this.exportVisual(e),e)},exportPDF:function(e){return i.exportPDF(this.exportVisual(),e)},svg:function(){if(i.svg.Surface)return i.svg.exportGroup(this.exportVisual());throw Error("SVG Export failed. Unable to export instantiate kendo.drawing.svg.Surface")},imageDataURL:function(){var t,n,o;if(!kendo.support.canvas)return null;if(i.canvas.Surface)return t=e("<div />").css({display:"none",width:this.element.width(),height:this.element.height()}).appendTo(document.body),n=new i.canvas.Surface(t[0]),n.draw(this.exportVisual()),o=n._rootElement.toDataURL(),n.destroy(),t.remove(),o;throw Error("Image Export failed. Unable to export instantiate kendo.drawing.canvas.Surface")}},n.IntlService.register({format:function(e){return kendo.format.apply(null,[e].concat(Array.prototype.slice.call(arguments,1)))},toString:kendo.toString,parseDate:kendo.parseDate}),n.TemplateService.register({compile:kendo.template}),t.Point2D=t.Point,t.Box2D=t.Box,t.mwDelta=function(e){return t.mousewheelDelta(e.originalEvent)}}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.core.min",["dataviz/core/kendo-core.min","dataviz/core/core.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/themes/chart-base-theme.min",["kendo.dataviz.core.min"],e)}(function(){!function(){var e,t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C,S,T,D,A,E,I,M,R,F;window.kendo.dataviz=window.kendo.dataviz||{},e=1.5,t=.4,n="#000",i="Arial, Helvetica, sans-serif",o="11px "+i,r="12px "+i,s="16px "+i,a="transparent",l="#fff",c=function(){return{icon:{border:{width:1}},label:{font:r,padding:3},line:{length:10,width:2},visible:!0}},d=function(){return{labels:{font:r},notes:c(),title:{font:s,margin:5}}},u=function(){return{highlight:{markers:{border:{}}},line:{opacity:1,width:0},markers:{size:6,visible:!1},opacity:.4}},h=function(){return{highlight:{markers:{border:{}}},line:{opacity:1,width:0},markers:{size:6,visible:!1},opacity:.4}},f=function(){return{gap:e,spacing:t}},p=function(){return{outliersField:"",meanField:"",border:{_brightness:.8,width:1},downColor:l,gap:1,highlight:{border:{opacity:1,width:2},whiskers:{width:3},mean:{width:2},median:{width:2}},mean:{width:2},median:{width:2},spacing:.3,whiskers:{width:2}}},m=function(){return{border:{width:0},labels:{background:a},opacity:.6}},g=function(){return{gap:e,spacing:t,target:{color:"#ff0000"}}},v=function(){return{border:{_brightness:.8,width:1},downColor:l,gap:1,highlight:{border:{opacity:1,width:2},line:{width:2}},line:{color:n,width:1},spacing:.3}},_=function(){return{gap:e,spacing:t}},b=function(){return{margin:1}},w=function(){return{width:2}},y=function(){return{gap:1,highlight:{line:{opacity:1,width:3}},line:{width:1},spacing:.3}},k=function(){return{line:{opacity:1,width:0},markers:{size:6,visible:!1},opacity:.5}},x=function(){return{markers:{visible:!1},width:2}},C=function(){return{gap:e,spacing:t}},S=function(){return{gap:e,spacing:t}},T=function(){return{width:1}},D=function(){return{gap:.5,line:{color:n,width:1},spacing:t}},A=function(){return{labels:{background:"",color:"",padding:{top:5,bottom:5,left:7,right:7}}}},E=function(){return{labels:{background:"",color:"",padding:{top:5,bottom:5,left:7,right:7}}}},I=function(e){return{visible:!0,labels:{font:o},overlay:e.gradients?{}:{
gradient:"none"},area:u(),rangeArea:h(),verticalRangeArea:h(),bar:f(),boxPlot:p(),bubble:m(),bullet:g(),candlestick:v(),column:_(),pie:A(),donut:b(),funnel:E(),horizontalWaterfall:D(),line:w(),notes:c(),ohlc:y(),radarArea:k(),radarLine:x(),polarArea:k(),polarLine:x(),rangeBar:C(),rangeColumn:S(),scatterLine:T(),verticalArea:u(),verticalBoxPlot:p(),verticalBullet:g(),verticalLine:w(),waterfall:D()}},M=function(){return{font:s}},R=function(){return{labels:{font:r}}},F=function(e){return void 0===e&&(e={}),{axisDefaults:d(),categoryAxis:{majorGridLines:{visible:!0}},navigator:{pane:{height:90,margin:{top:10}}},seriesDefaults:I(e),title:M(),legend:R()}},kendo.deepExtend(kendo.dataviz,{chartBaseTheme:F})}()},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/themes/auto-theme.min",["kendo.dataviz.core.min"],e)}(function(){function e(e){function n(e,t){o(e,i(t,"backgroundColor"))}function i(e,t){return s.find(".k-var--"+e).css(t)}function o(e,t){for(var n=r,i=e.split("."),o=i.shift();i.length>0;)n=n[o]=n[o]||{},o=i.shift();n[o]=t}var r,s;return!e&&t?t:(r={chart:kendo.dataviz.chartBaseTheme()},s=$('<div style="display: none">  <div class="k-var--accent"></div>  <div class="k-var--accent-contrast"></div>  <div class="k-var--base"></div>  <div class="k-var--background"></div>  <div class="k-var--normal-background"></div>  <div class="k-var--normal-text-color"></div>  <div class="k-var--hover-background"></div>  <div class="k-var--hover-text-color"></div>  <div class="k-var--selected-background"></div>  <div class="k-var--selected-text-color"></div>  <div class="k-var--chart-error-bars-background"></div>  <div class="k-var--chart-notes-background"></div>  <div class="k-var--chart-notes-border"></div>  <div class="k-var--chart-notes-lines"></div>  <div class="k-var--chart-crosshair-background"></div>  <div class="k-var--chart-inactive"></div>  <div class="k-var--chart-major-lines"></div>  <div class="k-var--chart-minor-lines"></div>  <div class="k-var--chart-area-opacity"></div>  <div class="k-widget">      <div class="k-var--chart-font"></div>      <div class="k-var--chart-title-font"></div>      <div class="k-var--chart-label-font"></div>  </div>  <div class="k-var--series">    <div class="k-var--series-a"></div>    <div class="k-var--series-b"></div>    <div class="k-var--series-c"></div>    <div class="k-var--series-d"></div>    <div class="k-var--series-e"></div>    <div class="k-var--series-f"></div>  </div></div>').appendTo(document.body),function(){n("chart.axisDefaults.crosshair.color","chart-crosshair-background"),n("chart.axisDefaults.labels.color","normal-text-color"),n("chart.axisDefaults.line.color","chart-major-lines"),n("chart.axisDefaults.majorGridLines.color","chart-major-lines"),n("chart.axisDefaults.minorGridLines.color","chart-minor-lines"),n("chart.axisDefaults.notes.icon.background","chart-notes-background"),n("chart.axisDefaults.notes.icon.border.color","chart-notes-border"),n("chart.axisDefaults.notes.line.color","chart-notes-lines"),n("chart.axisDefaults.title.color","normal-text-color"),n("chart.chartArea.background","background"),n("chart.legend.inactiveItems.labels.color","chart-inactive"),n("chart.legend.inactiveItems.markers.color","chart-inactive"),n("chart.legend.labels.color","normal-text-color"),n("chart.seriesDefaults.boxPlot.downColor","chart-major-lines"),n("chart.seriesDefaults.boxPlot.mean.color","base"),n("chart.seriesDefaults.boxPlot.median.color","base"),n("chart.seriesDefaults.boxPlot.whiskers.color","accent"),n("chart.seriesDefaults.bullet.target.color","accent"),n("chart.seriesDefaults.candlestick.downColor","normal-text-color"),n("chart.seriesDefaults.candlestick.line.color","normal-text-color"),n("chart.seriesDefaults.errorBars.color","chart-error-bars-background"),n("chart.seriesDefaults.horizontalWaterfall.line.color","chart-major-lines"),n("chart.seriesDefaults.icon.border.color","chart-major-lines"),n("chart.seriesDefaults.labels.background","background"),n("chart.seriesDefaults.labels.color","normal-text-color"),n("chart.seriesDefaults.notes.icon.background","chart-notes-background"),n("chart.seriesDefaults.notes.icon.border.color","chart-notes-border"),n("chart.seriesDefaults.notes.line.color","chart-notes-lines"),n("chart.seriesDefaults.verticalBoxPlot.downColor","chart-major-lines"),n("chart.seriesDefaults.verticalBoxPlot.mean.color","base"),n("chart.seriesDefaults.verticalBoxPlot.median.color","base"),n("chart.seriesDefaults.verticalBoxPlot.whiskers.color","accent"),n("chart.seriesDefaults.verticalBullet.target.color","accent"),n("chart.seriesDefaults.waterfall.line.color","chart-major-lines"),n("chart.title.color","normal-text-color"),o("chart.seriesDefaults.labels.opacity",i("chart-area-opacity","opacity")),n("diagram.shapeDefaults.fill.color","accent"),n("diagram.shapeDefaults.content.color","accent-contrast"),n("diagram.shapeDefaults.connectorDefaults.fill.color","normal-text-color"),n("diagram.shapeDefaults.connectorDefaults.stroke.color","accent-contrast"),n("diagram.shapeDefaults.connectorDefaults.hover.fill.color","accent-contrast"),n("diagram.shapeDefaults.connectorDefaults.hover.stroke.color","normal-text-color"),n("diagram.editable.resize.handles.stroke.color","normal-text-color"),n("diagram.editable.resize.handles.fill.color","normal-background"),n("diagram.editable.resize.handles.hover.stroke.color","normal-text-color"),n("diagram.editable.resize.handles.hover.fill.color","normal-text-color"),n("diagram.selectable.stroke.color","normal-text-color"),n("diagram.connectionDefaults.stroke.color","normal-text-color"),n("diagram.connectionDefaults.content.color","normal-text-color"),n("diagram.connectionDefaults.selection.handles.fill.color","accent-contrast"),n("diagram.connectionDefaults.selection.handles.stroke.color","normal-text-color"),n("diagram.connectionDefaults.selection.stroke.color","normal-text-color")}(),function(){function e(e){return i(e,"fontSize")+" "+i(e,"fontFamily")}var t=e("chart-font"),n=e("chart-title-font"),r=e("chart-label-font");o("chart.axisDefaults.labels.font",r),o("chart.axisDefaults.notes.label.font",t),o("chart.axisDefaults.title.font",t),o("chart.legend.labels.font",t),o("chart.seriesDefaults.labels.font",r),o("chart.seriesDefaults.notes.label.font",t),o("chart.title.font",n)}(),function(){function e(e){return e.toLowerCase().charCodeAt(0)-"a".charCodeAt(0)}function t(t){return e(t.match(/series-([a-z])$/)[1])}var n=$(".k-var--series div").toArray(),i=n.reduce(function(e,n){var i=t(n.className);return e[i]=$(n).css("backgroundColor"),e},[]);o("chart.seriesColors",i)}(),s.remove(),t=r,r)}var t;kendo.dataviz.autoTheme=e},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/themes/themes.min",["dataviz/themes/chart-base-theme.min"],e)}(function(){return function(e){function t(t,n){return e.map(t,function(e,t){return[[e,n[t]]]})}var n=window.kendo,i=n.dataviz.ui,o=n.deepExtend,r="#000",s="Arial,Helvetica,sans-serif",a="12px "+s,l="#fff",c=n.dataviz.chartBaseTheme({gradients:!0}),d={scale:{labels:{font:a}}},u={shapeDefaults:{hover:{opacity:.2},stroke:{width:0}},editable:{resize:{handles:{width:7,height:7}}},selectable:{stroke:{width:1,dashType:"dot"}},connectionDefaults:{stroke:{width:2},selection:{handles:{width:8,height:8}},editable:{tools:["edit","delete"]}}},h=i.themes,f=i.registerTheme=function(e,t){var n,i={};i.chart=o({},c,t.chart),i.gauge=o({},d,t.gauge),i.diagram=o({},u,t.diagram),i.treeMap=o({},t.treeMap),n=i.chart.seriesDefaults,n.verticalLine=o({},n.line),n.verticalArea=o({},n.area),n.rangeArea=o({},n.area),n.verticalRangeArea=o({},n.rangeArea),n.verticalBoxPlot=o({},n.boxPlot),n.polarArea=o({},n.radarArea),n.polarLine=o({},n.radarLine),h[e]=i};f("black",{chart:{title:{color:l},legend:{labels:{color:l},inactiveItems:{labels:{color:"#919191"},markers:{color:"#919191"}}},seriesDefaults:{labels:{color:l},errorBars:{color:l},notes:{icon:{background:"#3b3b3b",border:{color:"#8e8e8e"}},label:{color:l},line:{color:"#8e8e8e"}},pie:{overlay:{gradient:"sharpBevel"}},donut:{overlay:{gradient:"sharpGlass"}},line:{markers:{background:"#3d3d3d"}},scatter:{markers:{background:"#3d3d3d"}},scatterLine:{markers:{background:"#3d3d3d"}},waterfall:{line:{color:"#8e8e8e"}},horizontalWaterfall:{line:{color:"#8e8e8e"}},candlestick:{downColor:"#555",line:{color:l},border:{_brightness:1.5,opacity:1},highlight:{border:{color:l,opacity:.2}}},ohlc:{line:{color:l}}},chartArea:{background:"#3d3d3d"},seriesColors:["#0081da","#3aafff","#99c900","#ffeb3d","#b20753","#ff4195"],axisDefaults:{line:{color:"#8e8e8e"},labels:{color:l},majorGridLines:{color:"#545454"},minorGridLines:{color:"#454545"},title:{color:l},crosshair:{color:"#8e8e8e"},notes:{icon:{background:"#3b3b3b",border:{color:"#8e8e8e"}},label:{color:l},line:{color:"#8e8e8e"}}}},gauge:{pointer:{color:"#0070e4"},scale:{rangePlaceholderColor:"#1d1d1d",labels:{color:l},minorTicks:{color:l},majorTicks:{color:l},line:{color:l}}},diagram:{shapeDefaults:{fill:{color:"#0066cc"},connectorDefaults:{fill:{color:l},stroke:{color:"#384049"},hover:{fill:{color:"#3d3d3d"},stroke:{color:"#efefef"}}},content:{color:l}},editable:{resize:{handles:{fill:{color:"#3d3d3d"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:l}}}},rotate:{thumb:{stroke:{color:l},fill:{color:l}}}},selectable:{stroke:{color:l}},connectionDefaults:{stroke:{color:l},content:{color:l},selection:{handles:{fill:{color:"#3d3d3d"},stroke:{color:"#efefef"}}}}},treeMap:{colors:[["#0081da","#314b5c"],["#3aafff","#3c5464"],["#99c900","#4f5931"],["#ffeb3d","#64603d"],["#b20753","#543241"],["#ff4195","#643e4f"]]}}),f("blueopal",{chart:{title:{color:"#293135"},legend:{labels:{color:"#293135"},inactiveItems:{labels:{color:"#27A5BA"},markers:{color:"#27A5BA"}}},seriesDefaults:{labels:{color:r,background:l,opacity:.5},errorBars:{color:"#293135"},candlestick:{downColor:"#c4d0d5",line:{color:"#9aabb2"}},waterfall:{line:{color:"#9aabb2"}},horizontalWaterfall:{line:{color:"#9aabb2"}},notes:{icon:{background:"transparent",border:{color:"#9aabb2"}},label:{color:"#293135"},line:{color:"#9aabb2"}}},seriesColors:["#0069a5","#0098ee","#7bd2f6","#ffb800","#ff8517","#e34a00"],axisDefaults:{line:{color:"#9aabb2"},labels:{color:"#293135"},majorGridLines:{color:"#c4d0d5"},minorGridLines:{color:"#edf1f2"},title:{color:"#293135"},crosshair:{color:"#9aabb2"},notes:{icon:{background:"transparent",border:{color:"#9aabb2"}},label:{color:"#293135"},line:{color:"#9aabb2"}}}},gauge:{pointer:{color:"#005c83"},scale:{rangePlaceholderColor:"#daecf4",labels:{color:"#293135"},minorTicks:{color:"#293135"},majorTicks:{color:"#293135"},line:{color:"#293135"}}},diagram:{shapeDefaults:{fill:{color:"#7ec6e3"},connectorDefaults:{fill:{color:"#003f59"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:"#003f59"}}},content:{color:"#293135"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#003f59"},hover:{fill:{color:"#003f59"},stroke:{color:"#003f59"}}}},rotate:{thumb:{stroke:{color:"#003f59"},fill:{color:"#003f59"}}}},selectable:{stroke:{color:"#003f59"}},connectionDefaults:{stroke:{color:"#003f59"},content:{color:"#293135"},selection:{handles:{fill:{color:"#3d3d3d"},stroke:{color:"#efefef"}}}}},treeMap:{colors:[["#0069a5","#bad7e7"],["#0098ee","#b9e0f5"],["#7bd2f6","#ceeaf6"],["#ffb800","#e6e3c4"],["#ff8517","#e4d8c8"],["#e34a00","#ddccc2"]]}}),f("highcontrast",{chart:{title:{color:"#ffffff"},legend:{labels:{color:"#ffffff"},inactiveItems:{labels:{color:"#66465B"},markers:{color:"#66465B"}}},seriesDefaults:{labels:{color:"#ffffff"},errorBars:{color:"#ffffff"},notes:{icon:{background:"transparent",border:{color:"#ffffff"}},label:{color:"#ffffff"},line:{color:"#ffffff"}},pie:{overlay:{gradient:"sharpGlass"}},donut:{overlay:{gradient:"sharpGlass"}},line:{markers:{background:"#2c232b"}},scatter:{markers:{background:"#2c232b"}},scatterLine:{markers:{background:"#2c232b"}},area:{opacity:.5},waterfall:{line:{color:"#ffffff"}},horizontalWaterfall:{line:{color:"#ffffff"}},candlestick:{downColor:"#664e62",line:{color:"#ffffff"},border:{_brightness:1.5,opacity:1},highlight:{border:{color:"#ffffff",opacity:1}}},ohlc:{line:{color:"#ffffff"}}},chartArea:{background:"#2c232b"},seriesColors:["#a7008f","#ffb800","#3aafff","#99c900","#b20753","#ff4195"],axisDefaults:{line:{color:"#ffffff"},labels:{color:"#ffffff"},majorGridLines:{color:"#664e62"},minorGridLines:{color:"#4f394b"},title:{color:"#ffffff"},crosshair:{color:"#ffffff"},notes:{icon:{background:"transparent",border:{color:"#ffffff"}},label:{color:"#ffffff"},line:{color:"#ffffff"}}}},gauge:{pointer:{color:"#a7008f"},scale:{rangePlaceholderColor:"#2c232b",labels:{color:"#ffffff"},minorTicks:{color:"#2c232b"},majorTicks:{color:"#664e62"},line:{color:"#ffffff"}}},diagram:{shapeDefaults:{fill:{color:"#a7018f"},connectorDefaults:{fill:{color:l},stroke:{color:"#2c232b"},hover:{fill:{color:"#2c232b"},stroke:{color:l}}},content:{color:l}},editable:{resize:{handles:{fill:{color:"#2c232b"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:l}}}},rotate:{thumb:{stroke:{color:l},fill:{color:l}}}},selectable:{stroke:{color:l}},connectionDefaults:{stroke:{color:l},content:{color:l},selection:{handles:{fill:{color:"#2c232b"},stroke:{color:l}}}}},treeMap:{colors:[["#a7008f","#451c3f"],["#ffb800","#564122"],["#3aafff","#2f3f55"],["#99c900","#424422"],["#b20753","#471d33"],["#ff4195","#562940"]]}}),f("default",{chart:{title:{color:"#8e8e8e"},legend:{labels:{color:"#232323"},inactiveItems:{labels:{color:"#919191"},markers:{color:"#919191"}}},seriesDefaults:{labels:{color:r,background:l,opacity:.5},errorBars:{color:"#232323"},candlestick:{downColor:"#dedede",line:{color:"#8d8d8d"}},waterfall:{line:{color:"#8e8e8e"}},horizontalWaterfall:{line:{color:"#8e8e8e"}},notes:{icon:{background:"transparent",border:{color:"#8e8e8e"}},label:{color:"#232323"},line:{color:"#8e8e8e"}}},seriesColors:["#ff6800","#a0a700","#ff8d00","#678900","#ffb53c","#396000"],axisDefaults:{line:{color:"#8e8e8e"},labels:{color:"#232323"},minorGridLines:{color:"#f0f0f0"},majorGridLines:{color:"#dfdfdf"},title:{color:"#232323"},crosshair:{color:"#8e8e8e"},notes:{icon:{background:"transparent",border:{color:"#8e8e8e"}},label:{color:"#232323"},line:{color:"#8e8e8e"}}}},gauge:{pointer:{color:"#ea7001"},scale:{rangePlaceholderColor:"#dedede",labels:{color:"#2e2e2e"},minorTicks:{color:"#2e2e2e"},majorTicks:{color:"#2e2e2e"},line:{color:"#2e2e2e"}}},diagram:{shapeDefaults:{fill:{color:"#e15613"},connectorDefaults:{fill:{color:"#282828"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:"#282828"}}},content:{color:"#2e2e2e"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#282828"},hover:{fill:{color:"#282828"},stroke:{color:"#282828"}}}},rotate:{thumb:{stroke:{color:"#282828"},fill:{color:"#282828"}}}},selectable:{stroke:{color:"#a7018f"}},connectionDefaults:{stroke:{color:"#282828"},content:{color:"#2e2e2e"},selection:{handles:{fill:{color:l},stroke:{color:"#282828"}}}}},treeMap:{colors:[["#ff6800","#edcfba"],["#a0a700","#dadcba"],["#ff8d00","#edd7ba"],["#678900","#cfd6ba"],["#ffb53c","#eddfc6"],["#396000","#c6ceba"]]}}),f("silver",{chart:{title:{color:"#4e5968"},legend:{labels:{color:"#4e5968"},inactiveItems:{labels:{color:"#B1BCC8"},markers:{color:"#B1BCC8"}}},seriesDefaults:{labels:{color:"#293135",background:"#eaeaec",opacity:.5},errorBars:{color:"#4e5968"},notes:{icon:{background:"transparent",border:{color:"#4e5968"}},label:{color:"#4e5968"},line:{color:"#4e5968"}},line:{markers:{background:"#eaeaec"}},scatter:{markers:{background:"#eaeaec"}},scatterLine:{markers:{background:"#eaeaec"}},pie:{connectors:{color:"#A6B1C0"}},donut:{connectors:{color:"#A6B1C0"}},waterfall:{line:{color:"#a6b1c0"}},horizontalWaterfall:{line:{color:"#a6b1c0"}},candlestick:{downColor:"#a6afbe"}},chartArea:{background:"#eaeaec"},seriesColors:["#007bc3","#76b800","#ffae00","#ef4c00","#a419b7","#430B62"],axisDefaults:{line:{color:"#a6b1c0"},labels:{color:"#4e5968"},majorGridLines:{color:"#dcdcdf"},minorGridLines:{color:"#eeeeef"},title:{color:"#4e5968"},crosshair:{color:"#a6b1c0"},notes:{icon:{background:"transparent",border:{color:"#4e5968"}},label:{color:"#4e5968"},line:{color:"#4e5968"}}}},gauge:{pointer:{color:"#0879c0"},scale:{rangePlaceholderColor:"#f3f3f4",labels:{color:"#515967"},minorTicks:{color:"#515967"},majorTicks:{color:"#515967"},line:{color:"#515967"}}},diagram:{shapeDefaults:{fill:{color:"#1c82c2"},connectorDefaults:{fill:{color:"#515967"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:"#282828"}}},content:{color:"#515967"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#515967"},hover:{fill:{color:"#515967"},stroke:{color:"#515967"}}}},rotate:{thumb:{stroke:{color:"#515967"},fill:{color:"#515967"}}}},selectable:{stroke:{color:"#515967"}},connectionDefaults:{stroke:{color:"#515967"},content:{color:"#515967"},selection:{handles:{fill:{color:l},stroke:{color:"#515967"}}}}},treeMap:{colors:[["#007bc3","#c2dbea"],["#76b800","#dae7c3"],["#ffae00","#f5e5c3"],["#ef4c00","#f2d2c3"],["#a419b7","#e3c7e8"],["#430b62","#d0c5d7"]]}}),f("metro",{chart:{title:{color:"#777777"},legend:{labels:{color:"#777777"},inactiveItems:{labels:{color:"#CBCBCB"},markers:{color:"#CBCBCB"}}},seriesDefaults:{labels:{color:r},errorBars:{color:"#777777"},notes:{icon:{background:"transparent",border:{color:"#777777"}},label:{color:"#777777"},line:{color:"#777777"}},candlestick:{downColor:"#c7c7c7",line:{color:"#787878"}},waterfall:{line:{color:"#c7c7c7"}},horizontalWaterfall:{line:{color:"#c7c7c7"}},overlay:{gradient:"none"},border:{_brightness:1}},seriesColors:["#8ebc00","#309b46","#25a0da","#ff6900","#e61e26","#d8e404","#16aba9","#7e51a1","#313131","#ed1691"],axisDefaults:{line:{color:"#c7c7c7"},labels:{color:"#777777"},minorGridLines:{color:"#c7c7c7"},majorGridLines:{color:"#c7c7c7"},title:{color:"#777777"},crosshair:{color:"#c7c7c7"},notes:{icon:{background:"transparent",border:{color:"#777777"}},label:{color:"#777777"},line:{color:"#777777"}}}},gauge:{pointer:{color:"#8ebc00"},scale:{rangePlaceholderColor:"#e6e6e6",labels:{color:"#777"},minorTicks:{color:"#777"},majorTicks:{color:"#777"},line:{color:"#777"}}},diagram:{shapeDefaults:{fill:{color:"#8ebc00"},connectorDefaults:{fill:{color:r},stroke:{color:l},hover:{fill:{color:l},stroke:{color:r}}},content:{color:"#777"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#787878"},hover:{fill:{color:"#787878"},stroke:{color:"#787878"}}}},rotate:{thumb:{stroke:{color:"#787878"},fill:{color:"#787878"}}}},selectable:{stroke:{color:"#515967"}},connectionDefaults:{stroke:{color:"#787878"},content:{color:"#777"},selection:{handles:{fill:{color:l},stroke:{color:"#787878"}}}}},treeMap:{colors:[["#8ebc00","#e8f2cc"],["#309b46","#d6ebda"],["#25a0da","#d3ecf8"],["#ff6900","#ffe1cc"],["#e61e26","#fad2d4"],["#d8e404","#f7facd"],["#16aba9","#d0eeee"],["#7e51a1","#e5dcec"],["#313131","#d6d6d6"],["#ed1691","#fbd0e9"]]}}),f("metroblack",{chart:{title:{color:"#ffffff"},legend:{labels:{color:"#ffffff"},inactiveItems:{labels:{color:"#797979"},markers:{color:"#797979"}}},seriesDefaults:{border:{_brightness:1},labels:{color:"#ffffff"},errorBars:{color:"#ffffff"},notes:{icon:{background:"transparent",border:{color:"#cecece"}},label:{color:"#ffffff"},line:{color:"#cecece"}},line:{markers:{background:"#0e0e0e"}},bubble:{opacity:.6},scatter:{markers:{background:"#0e0e0e"}},scatterLine:{markers:{background:"#0e0e0e"}},candlestick:{downColor:"#828282",line:{color:"#ffffff"}},waterfall:{line:{color:"#cecece"}},horizontalWaterfall:{line:{color:"#cecece"}},overlay:{gradient:"none"}},chartArea:{background:"#0e0e0e"},seriesColors:["#00aba9","#309b46","#8ebc00","#ff6900","#e61e26","#d8e404","#25a0da","#7e51a1","#313131","#ed1691"],axisDefaults:{line:{color:"#cecece"},labels:{color:"#ffffff"},minorGridLines:{color:"#2d2d2d"},majorGridLines:{color:"#333333"},title:{color:"#ffffff"},crosshair:{color:"#cecece"},notes:{icon:{background:"transparent",border:{color:"#cecece"}},label:{color:"#ffffff"},line:{color:"#cecece"}}}},gauge:{pointer:{color:"#00aba9"},scale:{rangePlaceholderColor:"#2d2d2d",labels:{color:"#ffffff"},minorTicks:{color:"#333333"},majorTicks:{color:"#cecece"},line:{color:"#cecece"}}},diagram:{shapeDefaults:{fill:{color:"#00aba9"},connectorDefaults:{fill:{color:l},stroke:{color:"#0e0e0e"},hover:{fill:{color:"#0e0e0e"},stroke:{color:l}}},content:{color:l}},editable:{resize:{handles:{fill:{color:"#0e0e0e"},stroke:{color:"#787878"},hover:{fill:{color:"#787878"},stroke:{color:"#787878"}}}},rotate:{thumb:{stroke:{color:l},fill:{color:l}}}},selectable:{stroke:{color:"#787878"}},connectionDefaults:{stroke:{color:l},content:{color:l},selection:{handles:{fill:{color:"#0e0e0e"},stroke:{color:l}}}}},treeMap:{colors:[["#00aba9","#0b2d2d"],["#309b46","#152a19"],["#8ebc00","#28310b"],["#ff6900","#3e200b"],["#e61e26","#391113"],["#d8e404","#36390c"],["#25a0da","#132b37"],["#7e51a1","#241b2b"],["#313131","#151515"],["#ed1691","#3b1028"]]}}),f("moonlight",{chart:{title:{color:"#ffffff"},legend:{labels:{color:"#ffffff"},inactiveItems:{labels:{color:"#A1A7AB"},markers:{color:"#A1A7AB"}}},seriesDefaults:{labels:{color:"#ffffff"},errorBars:{color:"#ffffff"},notes:{icon:{background:"transparent",border:{color:"#8c909e"}},label:{color:"#ffffff"},line:{color:"#8c909e"}},pie:{overlay:{gradient:"sharpBevel"}},donut:{overlay:{gradient:"sharpGlass"}},line:{markers:{background:"#212a33"}},bubble:{opacity:.6},scatter:{markers:{background:"#212a33"}},scatterLine:{markers:{background:"#212a33"}},area:{opacity:.3},candlestick:{downColor:"#757d87",line:{color:"#ea9d06"},border:{_brightness:1.5,opacity:1},highlight:{border:{color:l,opacity:.2}}},waterfall:{line:{color:"#8c909e"}},horizontalWaterfall:{line:{color:"#8c909e"}},ohlc:{line:{color:"#ea9d06"}}},chartArea:{background:"#212a33"},seriesColors:["#ffca08","#ff710f","#ed2e24","#ff9f03","#e13c02","#a00201"],axisDefaults:{line:{color:"#8c909e"},minorTicks:{color:"#8c909e"},majorTicks:{color:"#8c909e"},labels:{color:"#ffffff"},majorGridLines:{color:"#3e424d"},minorGridLines:{color:"#2f3640"},title:{color:"#ffffff"},crosshair:{color:"#8c909e"},notes:{icon:{background:"transparent",border:{color:"#8c909e"}},label:{color:"#ffffff"},line:{color:"#8c909e"}}}},gauge:{pointer:{color:"#f4af03"},scale:{rangePlaceholderColor:"#2f3640",labels:{color:l},minorTicks:{color:"#8c909e"},majorTicks:{color:"#8c909e"},line:{color:"#8c909e"}}},diagram:{shapeDefaults:{fill:{color:"#f3ae03"},connectorDefaults:{fill:{color:l},stroke:{color:"#414550"},hover:{fill:{color:"#414550"},stroke:{color:l}}},content:{color:l}},editable:{resize:{handles:{fill:{color:"#414550"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:l}}}},rotate:{thumb:{stroke:{color:l},fill:{color:l}}}},selectable:{stroke:{color:l}},connectionDefaults:{stroke:{color:l},content:{color:l},selection:{handles:{fill:{color:"#414550"},stroke:{color:l}}}}},treeMap:{colors:[["#ffca08","#4e4b2b"],["#ff710f","#4e392d"],["#ed2e24","#4b2c31"],["#ff9f03","#4e422a"],["#e13c02","#482e2a"],["#a00201","#3b232a"]]}}),f("uniform",{chart:{title:{color:"#686868"},legend:{labels:{color:"#686868"},inactiveItems:{labels:{color:"#B6B6B6"},markers:{color:"#B6B6B6"}}},seriesDefaults:{labels:{color:"#686868"},errorBars:{color:"#686868"},notes:{icon:{background:"transparent",border:{color:"#9e9e9e"}},label:{color:"#686868"},line:{color:"#9e9e9e"}},pie:{overlay:{gradient:"sharpBevel"}},donut:{overlay:{gradient:"sharpGlass"}},line:{markers:{background:"#ffffff"}},bubble:{opacity:.6},scatter:{markers:{background:"#ffffff"}},scatterLine:{markers:{background:"#ffffff"}},area:{opacity:.3},candlestick:{downColor:"#cccccc",line:{color:"#cccccc"},border:{_brightness:1.5,opacity:1},highlight:{border:{color:"#cccccc",opacity:.2}}},waterfall:{line:{color:"#9e9e9e"}},horizontalWaterfall:{line:{color:"#9e9e9e"}},ohlc:{line:{color:"#cccccc"}}},chartArea:{background:"#ffffff"},seriesColors:["#527aa3","#6f91b3","#8ca7c2","#a8bdd1","#c5d3e0","#e2e9f0"],axisDefaults:{line:{color:"#9e9e9e"},minorTicks:{color:"#aaaaaa"},majorTicks:{color:"#888888"},labels:{color:"#686868"},majorGridLines:{color:"#dadada"},minorGridLines:{color:"#e7e7e7"},title:{color:"#686868"},crosshair:{color:"#9e9e9e"},notes:{icon:{background:"transparent",border:{color:"#9e9e9e"}},label:{color:"#686868"},line:{color:"#9e9e9e"}}}},gauge:{pointer:{color:"#527aa3"},scale:{rangePlaceholderColor:"#e7e7e7",labels:{color:"#686868"},minorTicks:{color:"#aaaaaa"},majorTicks:{color:"#888888"},line:{color:"#9e9e9e"}}},diagram:{shapeDefaults:{fill:{color:"#d1d1d1"},connectorDefaults:{fill:{color:"#686868"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:"#686868"}}},content:{color:"#686868"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#686868"},hover:{fill:{color:"#686868"},stroke:{color:"#686868"}}}},rotate:{thumb:{stroke:{color:"#686868"},fill:{color:"#686868"}}}},selectable:{stroke:{color:"#686868"}},connectionDefaults:{stroke:{color:"#686868"},content:{color:"#686868"},selection:{handles:{fill:{color:l},stroke:{color:"#686868"}}}}},treeMap:{colors:[["#527aa3","#d0d8e1"],["#6f91b3","#d6dde4"],["#8ca7c2","#dce1e7"],["#a8bdd1","#e2e6ea"],["#c5d3e0","#e7eaed"],["#e2e9f0","#edeff0"]]}}),f("bootstrap",{chart:{title:{color:"#333333"},legend:{labels:{color:"#333333"},inactiveItems:{labels:{color:"#999999"},markers:{color:"#9A9A9A"}}},seriesDefaults:{labels:{color:"#333333"},overlay:{gradient:"none"},errorBars:{color:"#343434"},notes:{icon:{background:"#000000",border:{color:"#000000"}},label:{color:"#333333"},line:{color:"#000000"}},pie:{overlay:{gradient:"none"}},donut:{overlay:{gradient:"none"}},line:{markers:{background:"#ffffff"}},bubble:{opacity:.6},scatter:{markers:{background:"#ffffff"}},scatterLine:{markers:{background:"#ffffff"}},area:{opacity:.8},candlestick:{downColor:"#d0d0d0",line:{color:"#333333"},border:{_brightness:1.5,opacity:1},highlight:{border:{color:"#b8b8b8",opacity:.2}}},waterfall:{line:{color:"#cccccc"}},horizontalWaterfall:{line:{color:"#cccccc"}},ohlc:{line:{color:"#333333"}}},chartArea:{background:"#ffffff"},seriesColors:["#428bca","#5bc0de","#5cb85c","#f2b661","#e67d4a","#da3b36"],axisDefaults:{line:{color:"#cccccc"},minorTicks:{color:"#ebebeb"},majorTicks:{color:"#cccccc"},labels:{color:"#333333"},majorGridLines:{color:"#cccccc"},minorGridLines:{color:"#ebebeb"},title:{color:"#333333"},crosshair:{color:"#000000"},notes:{icon:{background:"#000000",border:{color:"#000000"}},label:{color:"#ffffff"},line:{color:"#000000"}}}},gauge:{pointer:{color:"#428bca"},scale:{rangePlaceholderColor:"#cccccc",labels:{color:"#333333"},minorTicks:{color:"#ebebeb"},majorTicks:{color:"#cccccc"},line:{color:"#cccccc"}}},diagram:{shapeDefaults:{fill:{color:"#428bca"},connectorDefaults:{fill:{color:"#333333"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:"#333333"}}},content:{color:"#333333"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#333333"},hover:{fill:{color:"#333333"},stroke:{color:"#333333"}}}},rotate:{thumb:{stroke:{color:"#333333"},fill:{color:"#333333"}}}},selectable:{stroke:{color:"#333333"}},connectionDefaults:{stroke:{color:"#c4c4c4"},content:{color:"#333333"},selection:{handles:{fill:{color:l},stroke:{color:"#333333"}},stroke:{color:"#333333"}}}},treeMap:{colors:[["#428bca","#d1e0ec"],["#5bc0de","#d6eaf0"],["#5cb85c","#d6e9d6"],["#5cb85c","#f4e8d7"],["#e67d4a","#f2ddd3"],["#da3b36","#f0d0cf"]]}}),f("flat",{chart:{title:{color:"#4c5356"},legend:{labels:{color:"#4c5356"},inactiveItems:{labels:{color:"#CBCBCB"},markers:{color:"#CBCBCB"}}},seriesDefaults:{labels:{color:"#4c5356"},errorBars:{color:"#4c5356"},notes:{icon:{background:"transparent",border:{color:"#cdcdcd"}},label:{color:"#4c5356"},line:{color:"#cdcdcd"}},candlestick:{downColor:"#c7c7c7",line:{color:"#787878"}},area:{opacity:.9},waterfall:{line:{color:"#cdcdcd"}},horizontalWaterfall:{line:{color:"#cdcdcd"}},overlay:{gradient:"none"},border:{_brightness:1}},seriesColors:["#10c4b2","#ff7663","#ffb74f","#a2df53","#1c9ec4","#ff63a5","#1cc47b"],axisDefaults:{line:{color:"#cdcdcd"},labels:{color:"#4c5356"},minorGridLines:{color:"#cdcdcd"},majorGridLines:{color:"#cdcdcd"},title:{color:"#4c5356"},crosshair:{color:"#cdcdcd"},notes:{icon:{background:"transparent",border:{color:"#cdcdcd"}},label:{color:"#4c5356"},line:{color:"#cdcdcd"}}}},gauge:{pointer:{color:"#10c4b2"},scale:{rangePlaceholderColor:"#cdcdcd",labels:{color:"#4c5356"},minorTicks:{color:"#4c5356"},majorTicks:{color:"#4c5356"},line:{color:"#4c5356"}}},diagram:{shapeDefaults:{fill:{color:"#10c4b2"},connectorDefaults:{fill:{color:"#363940"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:"#363940"}}},content:{color:"#4c5356"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#363940"},hover:{fill:{color:"#363940"},stroke:{color:"#363940"}}}},rotate:{thumb:{stroke:{color:"#363940"},fill:{color:"#363940"}}}},selectable:{stroke:{color:"#363940"}},connectionDefaults:{stroke:{color:"#cdcdcd"},content:{color:"#4c5356"},selection:{handles:{fill:{color:l},stroke:{color:"#363940"}},stroke:{color:"#363940"}}}},treeMap:{colors:[["#10c4b2","#cff3f0"],["#ff7663","#ffe4e0"],["#ffb74f","#fff1dc"],["#a2df53","#ecf9dd"],["#1c9ec4","#d2ecf3"],["#ff63a5","#ffe0ed"],["#1cc47b","#d2f3e5"]]}}),f("material",{chart:{title:{color:"#444444"},legend:{labels:{color:"#444444"},inactiveItems:{labels:{color:"#CBCBCB"},markers:{color:"#CBCBCB"}}},seriesDefaults:{labels:{color:"#444444"},errorBars:{color:"#444444"},notes:{icon:{background:"transparent",border:{color:"#e5e5e5"}},label:{color:"#444444"},line:{color:"#e5e5e5"}},candlestick:{downColor:"#c7c7c7",line:{color:"#787878"}},area:{opacity:.9},waterfall:{line:{color:"#e5e5e5"}},horizontalWaterfall:{line:{color:"#e5e5e5"}},overlay:{gradient:"none"},border:{_brightness:1}},seriesColors:["#3f51b5","#03a9f4","#4caf50","#f9ce1d","#ff9800","#ff5722"],axisDefaults:{line:{color:"#e5e5e5"},labels:{color:"#444444"},minorGridLines:{color:"#e5e5e5"},majorGridLines:{color:"#e5e5e5"},title:{color:"#444444"},crosshair:{color:"#7f7f7f"},notes:{icon:{background:"transparent",border:{color:"#e5e5e5"}},label:{color:"#444444"},line:{color:"#e5e5e5"}}}},gauge:{pointer:{color:"#3f51b5"},scale:{rangePlaceholderColor:"#e5e5e5",labels:{color:"#444444"},minorTicks:{color:"#444444"},majorTicks:{color:"#444444"},line:{color:"#444444"}}},diagram:{shapeDefaults:{fill:{color:"#3f51b5"},connectorDefaults:{fill:{color:"#7f7f7f"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:"#7f7f7f"}}},content:{color:"#444444"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#444444"},hover:{fill:{color:"#444444"},stroke:{color:"#444444"}}}},rotate:{thumb:{stroke:{color:"#444444"},fill:{color:"#444444"}}}},selectable:{stroke:{color:"#444444"}},connectionDefaults:{stroke:{color:"#7f7f7f"},content:{color:"#444444"},selection:{handles:{fill:{color:l},stroke:{color:"#444444"}},stroke:{color:"#444444"}}}},treeMap:{colors:[["#3f51b5","#cff3f0"],["#03a9f4","#e5f6fe"],["#4caf50","#edf7ed"],["#f9ce1d","#fefae8"],["#ff9800","#fff4e5"],["#ff5722","#ffeee8"]]}}),f("materialblack",{chart:{title:{color:"#fff"},legend:{labels:{color:"#fff"},inactiveItems:{labels:{color:"#CBCBCB"},markers:{color:"#CBCBCB"}}},seriesDefaults:{labels:{color:"#fff"},errorBars:{color:"#fff"},notes:{icon:{background:"transparent",border:{color:"#e5e5e5"}},label:{color:"#fff"},line:{color:"#e5e5e5"}},candlestick:{downColor:"#c7c7c7",line:{color:"#787878"}},area:{opacity:.9},waterfall:{line:{color:"#4d4d4d"}},horizontalWaterfall:{line:{color:"#4d4d4d"}},overlay:{gradient:"none"},border:{_brightness:1}},chartArea:{background:"#1c1c1c"},seriesColors:["#3f51b5","#03a9f4","#4caf50","#f9ce1d","#ff9800","#ff5722"],axisDefaults:{line:{color:"#4d4d4d"},labels:{color:"#fff"},minorGridLines:{color:"#4d4d4d"},majorGridLines:{color:"#4d4d4d"},title:{color:"#fff"},crosshair:{color:"#7f7f7f"},notes:{icon:{background:"transparent",border:{color:"#4d4d4d"}},label:{color:"#fff"},line:{color:"#4d4d4d"}}}},gauge:{pointer:{color:"#3f51b5"},scale:{rangePlaceholderColor:"#4d4d4d",
labels:{color:"#fff"},minorTicks:{color:"#fff"},majorTicks:{color:"#fff"},line:{color:"#fff"}}},diagram:{shapeDefaults:{fill:{color:"#3f51b5"},connectorDefaults:{fill:{color:"#7f7f7f"},stroke:{color:l},hover:{fill:{color:l},stroke:{color:"#7f7f7f"}}},content:{color:"#fff"}},editable:{resize:{handles:{fill:{color:l},stroke:{color:"#fff"},hover:{fill:{color:"#fff"},stroke:{color:"#fff"}}}},rotate:{thumb:{stroke:{color:"#fff"},fill:{color:"#fff"}}}},selectable:{stroke:{color:"#fff"}},connectionDefaults:{stroke:{color:"#7f7f7f"},content:{color:"#fff"},selection:{handles:{fill:{color:l},stroke:{color:"#fff"}},stroke:{color:"#fff"}}}},treeMap:{colors:[["#3f51b5","#cff3f0"],["#03a9f4","#e5f6fe"],["#4caf50","#edf7ed"],["#f9ce1d","#fefae8"],["#ff9800","#fff4e5"],["#ff5722","#ffeee8"]]}}),function(){function e(){return{icon:{background:"#007cc0",border:{color:"#007cc0"}},label:{color:"#ffffff"},line:{color:r}}}var n="#333333",i="#7f7f7f",o="#bdbdbd",r="#c8c8c8",s="#dddddd",a=["#008fd3","#99d101","#f39b02","#f05662","#c03c53","#acacac"],c=["#cbe8f5","#eaf5cb","#fceacc","#fbdcdf","#f2d7dc","#eeeeee"],d=a[0],u=l;f("fiori",{chart:{title:{color:n},legend:{labels:{color:n},inactiveItems:{labels:{color:i},markers:{color:i}}},seriesDefaults:{labels:{color:n},errorBars:{color:n},notes:e(),candlestick:{downColor:r,line:{color:o}},area:{opacity:.8},waterfall:{line:{color:r}},horizontalWaterfall:{line:{color:r}},overlay:{gradient:"none"},border:{_brightness:1}},seriesColors:a,axisDefaults:{line:{color:r},labels:{color:n},minorGridLines:{color:s},majorGridLines:{color:r},title:{color:n},crosshair:{color:i},notes:e()}},gauge:{pointer:{color:d},scale:{rangePlaceholderColor:r,labels:{color:n},minorTicks:{color:n},majorTicks:{color:n},line:{color:n}}},diagram:{shapeDefaults:{fill:{color:d},connectorDefaults:{fill:{color:n},stroke:{color:u},hover:{fill:{color:u},stroke:{color:n}}},content:{color:n}},editable:{resize:{handles:{fill:{color:u},stroke:{color:o},hover:{fill:{color:o},stroke:{color:o}}}},rotate:{thumb:{stroke:{color:o},fill:{color:o}}}},selectable:{stroke:{color:o}},connectionDefaults:{stroke:{color:o},content:{color:o},selection:{handles:{fill:{color:u},stroke:{color:o}},stroke:{color:o}}}},treeMap:{colors:t(a,c)}})}(),function(){function e(){return{icon:{background:"#00b0ff",border:{color:"#00b0ff"}},label:{color:"#ffffff"},line:{color:r}}}var n="#4e4e4e",i="#7f7f7f",o="#bdbdbd",r="#c8c8c8",s="#e5e5e5",a=["#0072c6","#5db2ff","#008a17","#82ba00","#ff8f32","#ac193d"],c=["#cbe2f3","#deeffe","#cbe7d0","#e5f0cb","#fee8d5","#eed0d7"],d=a[0],u=l;f("office365",{chart:{title:{color:n},legend:{labels:{color:n},inactiveItems:{labels:{color:i},markers:{color:i}}},seriesDefaults:{labels:{color:n},errorBars:{color:n},notes:e(),candlestick:{downColor:r,line:{color:o}},area:{opacity:.8},waterfall:{line:{color:r}},horizontalWaterfall:{line:{color:r}},overlay:{gradient:"none"},border:{_brightness:1}},seriesColors:a,axisDefaults:{line:{color:r},labels:{color:n},minorGridLines:{color:s},majorGridLines:{color:r},title:{color:n},crosshair:{color:i},notes:e()}},gauge:{pointer:{color:d},scale:{rangePlaceholderColor:r,labels:{color:n},minorTicks:{color:n},majorTicks:{color:n},line:{color:n}}},diagram:{shapeDefaults:{fill:{color:d},connectorDefaults:{fill:{color:n},stroke:{color:u},hover:{fill:{color:u},stroke:{color:n}}},content:{color:n}},editable:{resize:{handles:{fill:{color:u},stroke:{color:o},hover:{fill:{color:o},stroke:{color:o}}}},rotate:{thumb:{stroke:{color:o},fill:{color:o}}}},selectable:{stroke:{color:o}},connectionDefaults:{stroke:{color:o},content:{color:o},selection:{handles:{fill:{color:u},stroke:{color:o}},stroke:{color:o}}}},treeMap:{colors:t(a,c)}})}(),function(){function e(){return{icon:{background:"#007cc0",border:{color:"#007cc0"}},label:{color:"#ffffff"},line:{color:r}}}var n="#32364c",i="#7f7f7f",o="#bdbdbd",r="#dfe0e1",s="#dfe0e1",a=["#ff4350","#ff9ea5","#00acc1","#80deea","#ffbf46","#ffd78c"],c=["#ffd9dc","#ffeced","#cceef3","#e6f8fb","#fff2da","#fff7e8"],d=a[0],u=l;f("nova",{chart:{title:{color:n},legend:{labels:{color:n},inactiveItems:{labels:{color:i},markers:{color:i}}},seriesDefaults:{labels:{color:n},errorBars:{color:n},notes:e(),candlestick:{downColor:r,line:{color:o}},area:{opacity:.8},waterfall:{line:{color:r}},horizontalWaterfall:{line:{color:r}},overlay:{gradient:"none"},border:{_brightness:1}},seriesColors:a,axisDefaults:{line:{color:r},labels:{color:n},minorGridLines:{color:s},majorGridLines:{color:r},title:{color:n},crosshair:{color:n},notes:e()}},gauge:{pointer:{color:d},scale:{rangePlaceholderColor:r,labels:{color:n},minorTicks:{color:n},majorTicks:{color:n},line:{color:n}}},diagram:{shapeDefaults:{fill:{color:d},connectorDefaults:{fill:{color:n},stroke:{color:u},hover:{fill:{color:u},stroke:{color:n}}},content:{color:n}},editable:{resize:{handles:{fill:{color:u},stroke:{color:o},hover:{fill:{color:o},stroke:{color:o}}}},rotate:{thumb:{stroke:{color:o},fill:{color:o}}}},selectable:{stroke:{color:o}},connectionDefaults:{stroke:{color:o},content:{color:o},selection:{handles:{fill:{color:u},stroke:{color:o}},stroke:{color:o}}}},treeMap:{colors:t(a,c)}})}(),function(){var e="#656565",n="rgba(0, 0, 0, .04)",i=["#ff6358","#ffd246","#78d237","#28b4c8","#2d73f5","#aa46be"],o=["#ffd9dc","#ffeced","#cceef3","#e6f8fb","#fff2da","#fff7e8"],r=i[0];f("default-v2",{chart:{},gauge:{pointer:{color:r},scale:{rangePlaceholderColor:n,labels:{color:e},minorTicks:{color:e},majorTicks:{color:e},line:{color:e}}},diagram:{},treeMap:{colors:t(i,o)}}),h.sass=h["default-v2"]}(),function(){var e="#292b2c",n="rgba(0, 0, 0, .04)",i=["#0275d8","#5bc0de","#5cb85c","#f0ad4e","#e67d4a","#d9534f"],o=["#ffd9dc","#ffeced","#cceef3","#e6f8fb","#fff2da","#fff7e8"],r=i[0];f("bootstrap-v4",{chart:{},gauge:{pointer:{color:r},scale:{rangePlaceholderColor:n,labels:{color:e},minorTicks:{color:e},majorTicks:{color:e},line:{color:e}}},diagram:{},treeMap:{colors:t(i,o)}})}()}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.themes.min",["kendo.dataviz.core.min","dataviz/themes/chart-base-theme.min","dataviz/themes/auto-theme.min","dataviz/themes/themes.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/chart/kendo-chart.min",["kendo.core.min","kendo.color.min","kendo.drawing.min","kendo.dataviz.core.min"],e)}(function(){!function(e){function t(e){var t,n,i=e.length,o=0;for(t=0;t<i;t++)n=e[t],Q(n)&&o++;return o}function n(e,t){if(null===t)return t;var n=me(e,!0);return n(t)}function i(e,t,n,o){var r,s,a,l,c;if(void 0===n&&(n={}),void 0===o&&(o=!1),r=n.defaults=n.defaults||{},s=n.depth=n.depth||0,a=!1,n.excluded=n.excluded||[],s>Wn)return null;for(l in e)!ke(l,n.excluded)&&e.hasOwnProperty(l)&&(c=e[l],xe(c)?(a=!0,o||(e[l]=Ce(c(t),r[l]))):Se(c)&&(o||(n.defaults=r[l]),n.depth++,a=i(c,t,n,o)||a,n.depth--));return a}function o(e){var t,n=e.length,i=0;for(t=0;t<n;t++)i=Math.max(i,e[t].data.length);return i}function r(e,t,n,i,o){var r=e.box,s=new it;return s[t]=r[t+n],s[i]=r[i+o],s}function s(e){for(var t=0;t<e.length;t++)if(pe(e[t].zIndex))return!0}function a(e){var t=e.overlay;return t&&t.gradient&&"none"!==t.gradient}function l(e,t){e.forEach(t)}function c(e,t){var n,i=e.length;for(n=i-1;n>=0;n--)t(e[n],n-i-1)}function d(e){return t(e)===e.length}function u(e){return pe(e)&&null!==e}function h(e){var t,n,i,o=e.series;for(t=0;t<o.length;t++)n=o[t],i=n.data,!i||ge(i[0])||Se(i[0])||(n.data=[i])}function f(){return"pane"+Ii++}function p(e,t,n){var i,o=t.visible;return pe(o)?o:(i=e.pointVisibility,i?i[n]:void 0)}function m(e){var t,n,i,o=e.data,r=[],s=0,a=0;for(t=0;t<o.length;t++)n=ct.current.bindPoint(e,t),i=n.valueFields.value,Pe(i)&&(i=parseFloat(i)),Q(i)?(n.visible=p(e,n.fields,t)!==!1,n.value=Math.abs(i),r.push(n),n.visible&&(s+=n.value),0!==i&&a++):r.push(null);return{total:s,points:r,count:a}}function g(e,t){return e&&t?e.toLowerCase()===t.toLowerCase():e===t}function v(e,t){var n,i,o=[],r=[].concat(t);for(n=0;n<e.length;n++)i=e[n],ke(i.type,r)&&o.push(i);return o}function _(e,t,n){var i,o;return null===t?t:(i="_date_"+e,o=t[i],o||(o=Be(n,me(e,!0)(t)),t[i]=o),o)}function b(e,t){var n=e.type,i=t instanceof Date;return!n&&i||g(n,ue)}function w(e){return 1===e.length?e[0]:e}function y(e){var t,n,i,o=e.length;if(o>0)for(n=0;n<o;n++)i=e[n].contentBox(),t?t.wrap(i):t=i.clone();return t||new be}function k(e,t){var n,i;for(n=0;n<e.length;n++)if(i=e[n],i&&i.pane===t)return i}function x(e){return""===e||null===e||"none"===e||"transparent"===e||!pe(e)}function C(e,t,n){var i,o=t,r=e;if(e.indexOf(".")>-1){for(i=e.split(".");i.length>1;)r=i.shift(),pe(o[r])||(o[r]={}),o=o[r];r=i.shift()}o[r]=n}function S(e,t){null!==t&&e.push(t)}function T(e,t,n){var i=[].concat(t instanceof He?e.categoryAxis:e.valueAxis);Te(i[t.axisIndex],n)}function D(e,t,n){return Ve(e,function(e){return 0===n&&!e.categoryAxis||e.categoryAxis===t})}function A(){this._defaultPrevented=!0}function E(e,t){var n=(t||"").toLowerCase(),i=e.event,o="none"===n&&!(i.ctrlKey||i.shiftKey||i.altKey)||i[n+"Key"];return o}function I(e){var t,n,i={};for(t=0;t<e.length;t++)n=e[t],n.axis.options.name&&(i[n.axis.options.name]={min:n.range.min,max:n.range.max});return i}function M(e){var t=document.createElement("div");return e&&(t.className=e),t}function R(e){for(var t=e;t&&!je(t,"k-handle");)t=t.parentNode;return t}function F(e){e.stopPropagation()}function z(e,t,n,i){var o=[].concat(n?e.yAxis:e.xAxis)[t];Te(o,i)}function P(e){var t,n,i=K.rad(e),o=Oe(Math.sin(i),he),r=Oe(Math.cos(i),he);return t=Math.abs(o)>Co?te:r<0?ce:oe,n=Math.abs(o)<xo?te:o<0?ie:ne,{horizontal:t,vertical:n}}function B(e,t,n,i){var o,r,s=(i.x-n.x)*(e.y-n.y)-(i.y-n.y)*(e.x-n.x),a=(i.y-n.y)*(t.x-e.x)-(i.x-n.x)*(t.y-e.y);return 0!==a&&(r=s/a,o=new _e(e.x+r*(t.x-e.x),e.y+r*(t.y-e.y))),o}function L(e,t){return e.value.x-t.value.x}function H(e){var t,n,i=ar;for(t=0;t<i.length;t++)n=i[t]+"Axes",e[n]&&(e[i[t]+"Axis"]=e[n],delete e[n])}function N(e,t){if(e)for(var n=0;n<e.length;n++)if(e[n].category===t)return[e[n]]}function O(e,t){function n(e){var t=(e||{}).color||o.color,n=Te({},a,a[i],o,o[i],{line:{color:t},labels:{color:t},title:{color:t}},e);return delete n[i],n}var i,o,r,s,a=(t||{}).axisDefaults||{};for(s=0;s<ar.length;s++)i=ar[s]+"Axis",o=e.axisDefaults||{},r=[].concat(e[i]),r=r.map(n),e[i]=r.length>1?r:r[0]}function V(e,t){var n,i,o,r=e.series,s=r.length,a=e.seriesDefaults,l=Te({},e.seriesDefaults),c=t?Te({},t.seriesDefaults):{},d=Te({},c);for(U(l),U(d),n=0;n<s;n++)i=r[n].type||e.seriesDefaults.type,o=Te({data:[]},d,c[i],{tooltip:e.tooltip},l,a[i]),r[n]._defaults=o,r[n]=Te({},o,r[n])}function U(e){delete e.bar,delete e.column,delete e.rangeColumn,delete e.line,delete e.verticalLine,delete e.pie,delete e.donut,delete e.area,delete e.verticalArea,delete e.scatter,delete e.scatterLine,delete e.bubble,delete e.candlestick,delete e.ohlc,delete e.boxPlot,delete e.bullet,delete e.verticalBullet,delete e.polarArea,delete e.polarLine,delete e.radarArea,delete e.radarLine,delete e.waterfall}function W(e){var t,n,i,o={};for(t=0;t<e.length;t++)n=e[t],i=n.options.name,i&&(o[i]=n.range());return o}function j(e,t){void 0===t&&(t=K.dateComparer);for(var n=1,i=e.length;n<i;n++)if(t(e[n],e[n-1])<0){e.sort(t);break}return e}function q(e,t){var n,i,o,r;for(void 0===t&&(t=K.dateComparer),n=j(e,t),i=n.length,o=i>0?[n[0]]:[],r=1;r<i;r++)0!==t(n[r],De(o))&&o.push(n[r]);return o}function G(e){var t,n,i,o,r=e.length,s=[];for(t=0;t<r;t++)for(n=e[t],i=n.length,o=0;o<i;o++)s[o]=s[o]||[],s[o].push(n[o]);return s}function $(e,t){var n,i,o,r;for(n in t)i=t[n],o=e[n],pe(o)&&(r=null===i,r||!pe(i)?(delete e[n],r&&delete t[n]):o&&Se(i)&&Se(o)&&$(o,i))}var K,Y,Q,X,Z,J,ee,te,ne,ie,oe,re,se,ae,le,ce,de,ue,he,fe,pe,me,ge,ve,_e,be,we,ye,ke,xe,Ce,Se,Te,De,Ae,Ee,Ie,Me,Re,Fe,ze,Pe,Be,Le,He,Ne,Oe,Ve,Ue,We,je,qe,Ge,$e,Ke,Ye,Qe,Xe,Ze,Je,et,tt,nt,it,ot,rt,st,at,lt,ct,dt,ut,ht,ft,pt,mt,gt,vt,_t,bt,wt,yt,kt,xt,Ct,St,Tt,Dt,At,Et,It,Mt,Rt,Ft,zt,Pt,Bt,Lt,Ht,Nt,Ot,Vt,Ut,Wt,jt,qt,Gt,$t,Kt,Yt,Qt,Xt,Zt,Jt,en,tn,nn,on,rn,sn,an,ln,cn,dn,un,hn,fn,pn,mn,gn,vn,_n,bn,wn,yn,kn,xn,Cn,Sn,Tn,Dn,An,En,In,Mn,Rn,Fn,zn,Pn,Bn,Ln,Hn,Nn,On,Vn,Un,Wn,jn,qn,Gn,$n,Kn,Yn,Qn,Xn,Zn,Jn,ei,ti,ni,ii,oi,ri,si,ai,li,ci,di,ui,hi,fi,pi,mi,gi,vi,_i,bi,wi,yi,ki,xi,Ci,Si,Ti,Di,Ai,Ei,Ii,Mi,Ri,Fi,zi,Pi,Bi,Li,Hi,Ni,Oi,Vi,Ui,Wi,ji,qi,Gi,$i,Ki,Yi,Qi,Xi,Zi,Ji,eo,to,no,io,oo,ro,so,ao,lo,co,uo,ho,fo,po,mo,go,vo,_o,bo,wo,yo,ko,xo,Co,So,To,Do,Ao,Eo,Io,Mo,Ro,Fo,zo,Po,Bo,Lo,Ho,No,Oo,Vo,Uo,Wo,jo,qo,Go,$o,Ko,Yo,Qo,Xo,Zo,Jo,er,tr,nr,ir,or,rr,sr,ar,lr,cr,dr,ur;window.kendo.dataviz=window.kendo.dataviz||{},K=kendo.dataviz,Y=K.Class,Q=K.isNumber,X=K.constants,Z=X.MAX_VALUE,J=X.MIN_VALUE,ee=X.VALUE,te=X.CENTER,ne=X.TOP,ie=X.BOTTOM,oe=X.LEFT,re=X.WHITE,se=X.CIRCLE,ae=X.X,le=X.Y,ce=X.RIGHT,de=X.BLACK,ue=X.DATE,he=X.DEFAULT_PRECISION,fe=X.ARC,pe=K.defined,me=K.getter,ge=K.isArray,ve=K.ChartElement,_e=K.Point,be=K.Box,we=K.alignPathToPixel,ye=K.setDefaultOptions,ke=K.inArray,xe=K.isFunction,Ce=K.valueOrDefault,Se=K.isObject,Te=K.deepExtend,De=K.last,Ae=K.eventElement,Ee=K.getTemplate,Ie=K.TextBox,Me=K.ShapeElement,Re=K.getSpacing,Fe=K.CurveProcessor,ze=K.append,Pe=K.isString,Be=K.parseDate,Le=K.styleValue,He=K.CategoryAxis,Ne=K.BoxElement,Oe=K.round,Ve=K.grep,Ue=K.DateCategoryAxis,We=K.elementStyles,je=K.hasClasses,qe=K.bindEvents,Ge=K.services,$e=K.unbindEvents,Ke=K.limitValue,Ye=kendo.support,Qe=kendo.drawing,Xe=Qe.Path,Ze=Qe.Animation,Je=Qe.AnimationFactory,et=Qe.Group,tt=kendo.Color,nt=kendo.geometry,it=nt.Point,ot=nt.transform,rt=Y.extend({init:function(e){this._axis=e,this.options=e.options},value:function(e){var t=this._axis,n=t.getCategory?t.getCategory(e):t.getValue(e);return n},slot:function(e,t,n){return void 0===n&&(n=!0),this._axis.slot(e,t,n)},range:function(){return this._axis.range()},valueRange:function(){return this._axis.valueRange()}}),st=kendo.Class.extend({init:function(e){this.visual=e.visual,this.chartsVisual=e.chartContainer.visual}}),at=Y.extend({init:function(e){this._plotArea=e,this.visual=e.visual,this.backgroundVisual=e._bgVisual}}),lt={min:function(e){var t,n,i=e.length,o=Z;for(t=0;t<i;t++)n=e[t],Q(n)&&(o=Math.min(o,n));return o===Z?e[0]:o},max:function(e){var t,n,i=e.length,o=J;for(t=0;t<i;t++)n=e[t],Q(n)&&(o=Math.max(o,n));return o===J?e[0]:o},sum:function(e){var t,n,i=e.length,o=0;for(t=0;t<i;t++)n=e[t],Q(n)&&(o+=n);return o},sumOrNull:function(e){var n=null;return t(e)&&(n=lt.sum(e)),n},count:function(e){var t,n,i=e.length,o=0;for(t=0;t<i;t++)n=e[t],null!==n&&pe(n)&&o++;return o},avg:function(e){var n=t(e),i=e[0];return n>0&&(i=lt.sum(e)/n),i},first:function(e){var t,n,i=e.length;for(t=0;t<i;t++)if(n=e[t],null!==n&&pe(n))return n;return e[0]}},ct=Y.extend({init:function(){this._valueFields={},this._otherFields={},this._nullValue={},this._undefinedValue={}},register:function(e,t,n){var i,o,r=this;for(void 0===t&&(t=[ee]),void 0===n&&(n={}),i=0;i<e.length;i++)o=e[i],r._valueFields[o]=t,r._otherFields[o]=n,r._nullValue[o]=r._makeValue(t,null),r._undefinedValue[o]=r._makeValue(t,void 0)},canonicalFields:function(e){return this.valueFields(e).concat(this.otherFields(e))},valueFields:function(e){return this._valueFields[e.type]||[ee]},otherFields:function(e){return this._otherFields[e.type]||[ee]},bindPoint:function(e,t,n){var i,o,r,s,a,l=e.data,c=pe(n)?n:l[t],d={valueFields:{value:c}},u=this.valueFields(e),h=this._otherFields[e.type];return null===c?o=this._nullValue[e.type]:pe(c)?Array.isArray(c)?(r=c.slice(u.length),o=this._bindFromArray(c,u),i=this._bindFromArray(r,h)):"object"==typeof c&&(s=this.sourceFields(e,u),a=this.sourceFields(e,h),o=this._bindFromObject(c,u,s),i=this._bindFromObject(c,h,a)):o=this._undefinedValue[e.type],pe(o)&&(1===u.length?d.valueFields.value=o[u[0]]:d.valueFields=o),d.fields=i||{},d},_makeValue:function(e,t){var n,i,o={},r=e.length;for(n=0;n<r;n++)i=e[n],o[i]=t;return o},_bindFromArray:function(e,t){var n,i,o={};if(t)for(n=Math.min(t.length,e.length),i=0;i<n;i++)o[t[i]]=e[i];return o},_bindFromObject:function(e,t,i){var o,r,s,a,l;if(void 0===i&&(i=t),o={},t)for(r=t.length,s=0;s<r;s++)a=t[s],l=i[s],o[a]=n(l,e);return o},sourceFields:function(e,t){var n,i,o,r,s=[];if(t)for(n=t.length,i=0;i<n;i++)o=t[i],r=o===ee?"field":o+"Field",s.push(e[r]||o);return s}}),ct.current=new ct,dt="stderr",ut="stddev",ht=/percent(?:\w*)\((\d+)\)/,ft=RegExp("^"+ut+"(?:\\((\\d+(?:\\.\\d+)?)\\))?$"),pt=Y.extend({init:function(e,t,n){this.initGlobalRanges(e,t,n)},initGlobalRanges:function(e,t,n){var i,o,r,s,a,l=t.data,c=ft.exec(e);c?(this.valueGetter=this.createValueGetter(t,n),i=this.getAverage(l),o=this.getStandardDeviation(l,i,!1),r=c[1]?parseFloat(c[1]):1,s={low:i.value-o*r,high:i.value+o*r},this.globalRange=function(){return s}):e.indexOf&&e.indexOf(dt)>=0&&(this.valueGetter=this.createValueGetter(t,n),a=this.getStandardError(l,this.getAverage(l)),this.globalRange=function(e){return{low:e-a,high:e+a}})},createValueGetter:function(e,t){var n,i,o,r=e.data,s=ct.current,a=s.valueFields(e),l=pe(r[0])?r[0]:{};return ge(l)?(i=t?a.indexOf(t):0,n=me("["+i+"]")):Q(l)?n=me():typeof l===X.OBJECT&&(o=s.sourceFields(e,a),n=me(o[a.indexOf(t)])),n},getErrorRange:function(e,t){var n,i,o,r;if(!pe(t))return null;if(this.globalRange)return this.globalRange(e);if(ge(t))n=e-t[0],i=e+t[1];else if(Q(o=parseFloat(t)))n=e-o,i=e+o;else{if(!(o=ht.exec(t)))throw Error("Invalid ErrorBar value: "+t);r=e*(parseFloat(o[1])/100),n=e-Math.abs(r),i=e+Math.abs(r)}return{low:n,high:i}},getStandardError:function(e,t){return this.getStandardDeviation(e,t,!0)/Math.sqrt(t.count)},getStandardDeviation:function(e,t,n){var i,o,r=this,s=e.length,a=n?t.count-1:t.count,l=0;for(i=0;i<s;i++)o=r.valueGetter(e[i]),Q(o)&&(l+=Math.pow(o-t.value,2));return Math.sqrt(l/a)},getAverage:function(e){var t,n,i=this,o=e.length,r=0,s=0;for(t=0;t<o;t++)n=i.valueGetter(e[t]),Q(n)&&(r+=n,s++);return{value:r/s,count:s}}}),mt=Ye.browser||{},gt=600,vt="fadeIn",_t="glass",bt=.8,wt=5,yt=mt.msie?.001:0,kt="errorLow",xt="errorHigh",Ct="xErrorLow",St="xErrorHigh",Tt="yErrorLow",Dt="yErrorHigh",At=8,Et="zero",It="interpolate",Mt="gap",Rt="above",Ft="below",zt="smooth",Pt="step",Bt="area",Lt="bar",Ht="boxPlot",Nt="bubble",Ot="bullet",Vt="candlestick",Ut="column",Wt="donut",jt="funnel",qt="horizontalWaterfall",Gt="line",$t="ohlc",Kt="pie",Yt="polarArea",Qt="polarLine",Xt="polarScatter",Zt="radarArea",Jt="radarColumn",en="radarLine",tn="rangeArea",nn="rangeBar",on="rangeColumn",rn="scatter",sn="scatterLine",an="verticalArea",ln="verticalBoxPlot",cn="verticalBullet",dn="verticalLine",un="verticalRangeArea",hn="waterfall",fn=[Lt,Ut,$t,Vt,Ht,ln,Ot,on,nn,hn,qt],pn="legendItemClick",mn="legendItemHover",gn="seriesClick",vn="seriesHover",_n="plotAreaClick",bn="plotAreaHover",wn="drag",yn="dragEnd",kn="dragStart",xn="zoomStart",Cn="zoom",Sn="zoomEnd",Tn="selectStart",Dn="select",An="selectEnd",En="render",In="showTooltip",Mn="hideTooltip",Rn="log",Fn="category",zn="insideEnd",Pn="insideBase",Bn="outsideEnd",Ln="DOMMouseScroll mousewheel",Hn=150,Nn={INITIAL_ANIMATION_DURATION:gt,FADEIN:vt,LEGEND_ITEM_CLICK:pn,LEGEND_ITEM_HOVER:mn,SERIES_CLICK:gn,SERIES_HOVER:vn,GLASS:_t,BORDER_BRIGHTNESS:bt,TOOLTIP_OFFSET:wt,START_SCALE:yt,ERROR_LOW_FIELD:kt,ERROR_HIGH_FIELD:xt,X_ERROR_LOW_FIELD:Ct,X_ERROR_HIGH_FIELD:St,Y_ERROR_LOW_FIELD:Tt,Y_ERROR_HIGH_FIELD:Dt,LINE_MARKER_SIZE:At,INTERPOLATE:It,ZERO:Et,SMOOTH:zt,STEP:Pt,CATEGORY:Fn,FUNNEL:jt,BAR:Lt,CANDLESTICK:Vt,PIE:Kt,COLUMN:Ut,AREA:Bt,VERTICAL_BULLET:cn,BOX_PLOT:Ht,OHLC:$t,WATERFALL:hn,LINE:Gt,BULLET:Ot,VERTICAL_LINE:dn,VERTICAL_AREA:an,RANGE_AREA:tn,VERTICAL_RANGE_AREA:un,RANGE_COLUMN:on,VERTICAL_BOX_PLOT:ln,RANGE_BAR:nn,HORIZONTAL_WATERFALL:qt,SCATTER:rn,SCATTER_LINE:sn,BUBBLE:Nt,RADAR_AREA:Zt,RADAR_LINE:en,RADAR_COLUMN:Jt,POLAR_LINE:Qt,POLAR_AREA:Yt,POLAR_SCATTER:Xt,RENDER:En,PLOT_AREA_CLICK:_n,PLOT_AREA_HOVER:bn,LOGARITHMIC:Rn,DRAG:wn,DRAG_START:kn,DRAG_END:yn,ZOOM_START:xn,ZOOM:Cn,ZOOM_END:Sn,SELECT_START:Tn,SELECT:Dn,SELECT_END:An,GAP:Mt,DONUT:Wt,INSIDE_END:zn,INSIDE_BASE:Pn,OUTSIDE_END:Bn,MOUSEWHEEL:Ln,MOUSEWHEEL_DELAY:Hn,SHOW_TOOLTIP:In,HIDE_TOOLTIP:Mn,EQUALLY_SPACED_SERIES:fn,ABOVE:Rt,BELOW:Ft},On=4,Vn=ve.extend({init:function(e,t,n,i,o,r){ve.fn.init.call(this,r),this.low=e,this.high=t,this.isVertical=n,this.chart=i,this.series=o},reflow:function(e){var t,n=this.options.endCaps,i=this.isVertical,o=this.getAxis(),r=o.getSlot(this.low,this.high),s=e.center(),a=this.getCapsWidth(e,i),l=i?s.x:s.y,c=l-a,d=l+a;i?(t=[new _e(s.x,r.y1),new _e(s.x,r.y2)],n&&t.push(new _e(c,r.y1),new _e(d,r.y1),new _e(c,r.y2),new _e(d,r.y2)),this.box=new be(c,r.y1,d,r.y2)):(t=[new _e(r.x1,s.y),new _e(r.x2,s.y)],n&&t.push(new _e(r.x1,c),new _e(r.x1,d),new _e(r.x2,c),new _e(r.x2,d)),this.box=new be(r.x1,c,r.x2,d)),this.linePoints=t},getCapsWidth:function(e,t){var n=t?e.width():e.height(),i=Math.min(Math.floor(n/2),On)||On;return i},createVisual:function(){var e=this,t=this.options,n=t.visual;n?this.visual=n({low:this.low,high:this.high,rect:this.box.toRect(),sender:this.getSender(),options:{endCaps:t.endCaps,color:t.color,line:t.line},createVisual:function(){e.createDefaultVisual();var t=e.visual;return delete e.visual,t}}):this.createDefaultVisual()},createDefaultVisual:function(){var e,t,n=this,i=this,o=i.options,r=i.linePoints,s={stroke:{color:o.color,width:o.line.width,dashType:o.line.dashType}};for(ve.fn.createVisual.call(this),e=0;e<r.length;e+=2)t=new Xe(s).moveTo(r[e].x,r[e].y).lineTo(r[e+1].x,r[e+1].y),we(t),n.visual.append(t)}}),ye(Vn,{animation:{type:vt,delay:gt},endCaps:!0,line:{width:2},zIndex:1}),Un=Vn.extend({getAxis:function(){var e=this.chart.seriesValueAxis(this.series);return e}}),Wn=5,jn=ve.extend({init:function(e,t){ve.fn.init.call(this,t),this.plotArea=e,this.chartService=e.chartService,this.categoryAxis=e.seriesCategoryAxis(t.series[0]),this.valueAxisRanges={},this.points=[],this.categoryPoints=[],this.seriesPoints=[],this.seriesOptions=[],this._evalSeries=[],this.render()},render:function(){this.traverseDataPoints(this.addValue.bind(this))},pointOptions:function(e,t){var n,i=this.seriesOptions[t];return i||(n=this.pointType().prototype.defaults,this.seriesOptions[t]=i=Te({},n,{vertical:!this.options.invertAxes},e)),i},plotValue:function(e){var t,n,i,o,r,s,a,l;if(!e)return 0;if(this.options.isStacked100&&Q(e.value)){for(t=e.categoryIx,n=this.categoryPoints[t],i=[],o=0,r=0;r<n.length;r++)if(s=n[r]){if(a=e.series.stack,l=s.series.stack,a&&l&&a.group!==l.group)continue;Q(s.value)&&(o+=Math.abs(s.value),i.push(Math.abs(s.value)))}if(o>0)return e.value/o}return e.value},plotRange:function(e,t){var n,i,o,r,s,a,l,c,d,u,h,f,p,m=this;if(void 0===t&&(t=0),n=this.categoryPoints[e.categoryIx],this.options.isStacked){for(i=this.plotValue(e),o=i>=0,r=t,s=!1,a=0;a<n.length&&(l=n[a],e!==l);a++){if(c=e.series.stack,d=l.series.stack,c&&d){if(typeof c===X.STRING&&c!==d)continue;if(c.group&&c.group!==d.group)continue}u=m.plotValue(l),(u>=0&&o||u<0&&!o)&&(r+=u,i+=u,s=!0,m.options.isStacked100&&(i=Math.min(i,1)))}return s&&(r-=t),[r,i]}return h=e.series,f=this.seriesValueAxis(h),p=this.categoryAxisCrossingValue(f),[p,K.convertableToNumber(e.value)?e.value:p]},stackLimits:function(e,t){var n,i,o,r,s,a=this,l=Z,c=J;for(n=0;n<this.categoryPoints.length;n++)if(i=a.categoryPoints[n])for(o=0;o<i.length;o++)r=i[o],r&&(r.series.stack!==t&&r.series.axis!==e||(s=a.plotRange(r,0)[1],pe(s)&&isFinite(s)&&(c=Math.max(c,s),l=Math.min(l,s))));return{min:l,max:c}},updateStackRange:function(){var e,t,n,i,o,r,s=this,a=this.options,l=a.isStacked,c=a.series,d={};if(l)for(e=0;e<c.length;e++)t=c[e],n=t.axis,i=n+t.stack,o=d[i],o||(o=s.stackLimits(n,t.stack),r=s.errorTotals,r&&(r.negative.length&&(o.min=Math.min(o.min,K.sparseArrayLimits(r.negative).min)),r.positive.length&&(o.max=Math.max(o.max,K.sparseArrayLimits(r.positive).max))),o.min!==Z||o.max!==J?d[i]=o:o=null),o&&(s.valueAxisRanges[n]=o)},addErrorBar:function(e,t,n){var i,o=e.value,r=e.series,s=e.seriesIx,a=e.options.errorBars,l=t.fields[kt],c=t.fields[xt];Q(l)&&Q(c)?i={low:l,high:c}:a&&pe(a.value)&&(this.seriesErrorRanges=this.seriesErrorRanges||[],this.seriesErrorRanges[s]=this.seriesErrorRanges[s]||new pt(a.value,r,ee),i=this.seriesErrorRanges[s].getErrorRange(o,a.value)),i&&(e.low=i.low,e.high=i.high,this.addPointErrorBar(e,n))},addPointErrorBar:function(e,t){var n,i,o,r=!this.options.invertAxes,s=e.options.errorBars,a=e.series,l=e.low,c=e.high;this.options.isStacked?(n=this.stackedErrorRange(e,t),l=n.low,c=n.high):(i={categoryIx:t,series:a},this.updateRange({value:l},i),this.updateRange({value:c},i)),o=new Un(l,c,r,this,a,s),e.errorBars=[o],e.append(o)},stackedErrorRange:function(e,t){var n=this.plotRange(e,0)[1]-e.value,i=e.low+n,o=e.high+n;return this.errorTotals=this.errorTotals||{positive:[],negative:[]},i<0&&(this.errorTotals.negative[t]=Math.min(this.errorTotals.negative[t]||0,i)),o>0&&(this.errorTotals.positive[t]=Math.max(this.errorTotals.positive[t]||0,o)),{low:i,high:o}},addValue:function(t,n){var i,o,r=n.categoryIx,s=n.series,a=n.seriesIx,l=this.categoryPoints[r];l||(this.categoryPoints[r]=l=[]),i=this.seriesPoints[a],i||(this.seriesPoints[a]=i=[]),o=this.createPoint(t,n),o&&(e.extend(o,n),o.owner=this,o.noteText=t.fields.noteText,pe(o.dataItem)||(o.dataItem=s.data[r]),this.addErrorBar(o,t,r)),this.points.push(o),i.push(o),l.push(o),this.updateRange(t.valueFields,n)},evalPointOptions:function(e,t,n,o,r,s){var a,l={defaults:r._defaults,excluded:["data","aggregate","_events","tooltip","content","template","visual","toggle","_outOfRangeMinPoint","_outOfRangeMaxPoint"]},c=this._evalSeries[s];return pe(c)||(this._evalSeries[s]=c=i(e,{},l,!0)),a=e,c&&(a=Te({},a),i(a,{value:t,category:n,index:o,series:r,dataItem:r.data[o]},l)),a},updateRange:function(e,t){var n=t.series.axis,i=e.value,o=this.valueAxisRanges[n];isFinite(i)&&null!==i&&(o=this.valueAxisRanges[n]=o||{min:Z,max:J},o.min=Math.min(o.min,i),o.max=Math.max(o.max,i))},seriesValueAxis:function(e){var t=this.plotArea,n=e.axis,i=n?t.namedValueAxes[n]:t.valueAxis;if(!i)throw Error("Unable to locate value axis with name "+n);return i},reflow:function(e){var t=this,n=this.categorySlots=[],i=this.points,o=this.categoryAxis,r=0;this.traverseDataPoints(function(e,s){var a,l,c,d=s.categoryIx,u=s.series,h=t.seriesValueAxis(u),f=i[r++],p=n[d];p||(n[d]=p=t.categorySlot(o,d,h)),f&&(a=t.plotRange(f,h.startValue()),l=t.valueSlot(h,a),l?(c=t.pointSlot(p,l),f.aboveAxis=t.aboveAxis(f,h),f.stackValue=a[1],t.options.isStacked100&&(f.percentage=t.plotValue(f)),t.reflowPoint(f,c)):f.visible=!1)}),this.reflowCategories(n),!this.options.clip&&this.options.limitPoints&&this.points.length&&this.limitPoints(),this.box=e},valueSlot:function(e,t){return e.getSlot(t[0],t[1],!this.options.clip)},limitPoints:function(){var e,t=this,n=this.categoryPoints,i=n[0].concat(De(n));for(e=0;e<i.length;e++)i[e]&&t.limitPoint(i[e])},limitPoint:function(e){var t=this.categoryAxis.limitSlot(e.box);t.equals(e.box)||e.reflow(t)},aboveAxis:function(e,t){var n=this.categoryAxisCrossingValue(t),i=e.value;return t.options.reverse?i<n:i>=n},categoryAxisCrossingValue:function(e){var t=this.categoryAxis,n=e.options,i=[].concat(n.axisCrossingValues||n.axisCrossingValue);return i[t.axisIndex||0]||0},reflowPoint:function(e,t){e.reflow(t)},reflowCategories:function(){},pointSlot:function(e,t){var n=this.options,i=n.invertAxes,o=i?t:e,r=i?e:t;return new be(o.x1,r.y1,o.x2,r.y2)},categorySlot:function(e,t){return e.getSlot(t)},traverseDataPoints:function(e){var t,n,i,r,s,a,l,c=this,d=this.options.series,u=this.categoryAxis.options.categories||[],h=o(d),f=d.length;for(t=0;t<f;t++)c._outOfRangeCallback(d[t],"_outOfRangeMinPoint",t,e);for(n=0;n<h;n++)for(i=0;i<f;i++)r=d[i],s=u[n],a=c._bindPoint(r,i,n),e(a,{category:s,categoryIx:n,series:r,seriesIx:i});for(l=0;l<f;l++)c._outOfRangeCallback(d[l],"_outOfRangeMaxPoint",l,e)},_outOfRangeCallback:function(e,t,n,i){var o,r,s=e[t];s&&(o=s.categoryIx,r=this._bindPoint(e,n,o,s.item),i(r,{category:s.category,categoryIx:o,series:e,seriesIx:n,dataItem:s.item}))},_bindPoint:function(e,t,n,i){var o,r;return this._bindCache||(this._bindCache=[]),o=this._bindCache[t],o||(o=this._bindCache[t]=[]),r=o[n],r||(r=o[n]=ct.current.bindPoint(e,n,i)),r},formatPointValue:function(e,t){return null===e.value?"":this.chartService.format.auto(t,e.value)},pointValue:function(e){return e.valueFields.value}}),ye(jn,{series:[],invertAxes:!1,isStacked:!1,clip:!0,limitPoints:!0}),qn={click:function(e,t){return e.trigger(gn,this.eventArgs(t))},hover:function(e,t){return e.trigger(vn,this.eventArgs(t))},eventArgs:function(e){return{value:this.value,percentage:this.percentage,stackValue:this.stackValue,category:this.category,series:this.series,dataItem:this.dataItem,runningTotal:this.runningTotal,total:this.total,element:Ae(e),originalEvent:e,point:this}}},Gn={createNote:function(){var e=this.options.notes,t=this.noteText||e.label.text;e.visible!==!1&&pe(t)&&null!==t&&(this.note=new K.Note({value:this.value,text:t,dataItem:this.dataItem,category:this.category,series:this.series},this.options.notes,this.owner.chartService),this.append(this.note))}},$n=ve.extend({init:function(e,t){ve.fn.init.call(this),this.value=e,this.options=t,this.aboveAxis=Ce(this.options.aboveAxis,!0),this.tooltipTracking=!0},render:function(){var e,t,n=this.options,i=n.markers,o=n.labels;this._rendered||(this._rendered=!0,i.visible&&i.size&&(this.marker=this.createMarker(),this.append(this.marker)),o.visible&&(e=Ee(o),t=this.value,e?t=e({dataItem:this.dataItem,category:this.category,value:this.value,percentage:this.percentage,stackValue:this.stackValue,series:this.series}):o.format&&(t=this.formatValue(o.format)),this.label=new Ie(t,Te({align:te,vAlign:te,margin:{left:5,right:5},zIndex:Ce(o.zIndex,this.series.zIndex)},o)),this.append(this.label)),this.createNote(),this.errorBar&&this.append(this.errorBar))},markerBorder:function(){var e=this.options.markers,t=e.background,n=Te({color:this.color},e.border);return pe(n.color)||(n.color=new tt(t).brightness(bt).toHex()),n},createVisual:function(){},createMarker:function(){var e=this.options.markers,t=new Me({type:e.type,width:e.size,height:e.size,rotation:e.rotation,background:e.background,border:this.markerBorder(),opacity:e.opacity,zIndex:Ce(e.zIndex,this.series.zIndex),animation:e.animation,visual:e.visual},{dataItem:this.dataItem,value:this.value,series:this.series,category:this.category});return t},markerBox:function(){return this.marker||(this.marker=this.createMarker(),this.marker.reflow(this._childBox)),this.marker.box},reflow:function(e){var t,n,i,o,r=this,s=this,a=s.options,l=s.aboveAxis,c=a.vertical;if(this.render(),this.box=e,t=e.clone(),c?l?t.y1-=t.height():t.y2+=t.height():l?t.x1+=t.width():t.x2-=t.width(),this._childBox=t,this.marker&&this.marker.reflow(t),this.reflowLabel(t),this.errorBars)for(n=0;n<this.errorBars.length;n++)r.errorBars[n].reflow(t);this.note&&(i=this.markerBox(),a.markers.visible&&a.markers.size||(o=i.center(),i=new be(o.x,o.y,o.x,o.y)),this.note.reflow(i))},reflowLabel:function(e){var t=this,n=t.options,i=t.label,o=n.labels.position;i&&(o=o===Rt?ne:o,o=o===Ft?ie:o,i.reflow(e),i.box.alignTo(this.markerBox(),o),i.reflow(i.box))},createHighlight:function(){var e=this.options.highlight.markers,t=this.markerBorder().color,n=this.options.markers,i=n.size+(n.border.width||0)+(e.border.width||0),o=new Me({type:n.type,width:i,height:i,rotation:n.rotation,background:e.color||t,border:{color:e.border.color,width:e.border.width,opacity:Ce(e.border.opacity,1)},opacity:Ce(e.opacity,1)});return o.reflow(this._childBox),o.getElement()},highlightVisual:function(){return(this.marker||{}).visual},highlightVisualArgs:function(){var e,t,n,i,o,r=this.marker;return r?(t=r.paddingBox.toRect(),e=r.visual):(n=this.options.markers.size,i=n/2,o=this.box.center(),t=new nt.Rect([o.x-i,o.y-i],[n,n])),{options:this.options,rect:t,visual:e}},tooltipAnchor:function(){var e,t,n,i,o=this.markerBox(),r=this.owner.pane.clipBox(),s=!r||r.overlaps(o);if(s)return e=o.x2+wt,
t=oe,this.aboveAxis?(n=o.y1,i=ie):(n=o.y2,i=ne),{point:new _e(e,n),align:{horizontal:t,vertical:i}}},formatValue:function(e){return this.owner.formatPointValue(this,e)},overlapsBox:function(e){var t=this.markerBox();return t.overlaps(e)},unclipElements:function(){this.label&&(this.label.options.noclip=!0),this.note&&(this.note.options.noclip=!0)}}),$n.prototype.defaults={vertical:!0,markers:{visible:!0,background:re,size:At,type:se,border:{width:2},opacity:1},labels:{visible:!1,position:Rt,margin:Re(3),padding:Re(4),animation:{type:vt,delay:gt}},notes:{label:{}},highlight:{markers:{border:{color:"#fff",width:2}},zIndex:X.HIGHLIGHT_ZINDEX},errorBars:{line:{width:1}}},Te($n.prototype,qn),Te($n.prototype,Gn),Kn=ve.extend({init:function(e,t,n){ve.fn.init.call(this),this.linePoints=e,this.series=t,this.seriesIx=n},points:function(){return this.toGeometryPoints(this.linePoints)},toGeometryPoints:function(e){var t,n,i=[];for(t=0,n=e.length;t<n;t++)e[t]&&e[t].visible!==!1&&i.push(e[t]._childBox.toRect().center());return i},createVisual:function(){var e,t=this,n=t.options,i=t.series,o=i.color,r=i._defaults;xe(o)&&r&&(o=r.color),e=Xe.fromPoints(this.points(),{stroke:{color:o,width:i.width,opacity:i.opacity,dashType:i.dashType},zIndex:i.zIndex}),n.closed&&e.close(),this.visual=e},aliasFor:function(e,t){return this.parent.getNearestPoint(t.x,t.y,this.seriesIx)}}),ye(Kn,{closed:!1}),Yn={calculateStepPoints:function(e){var t,n,i,o=this.parent.plotArea.seriesCategoryAxis(this.series),s=o.options,a=s.justified,l=s.vertical,c=s.reverse,d=l?ae:le,u=l?le:ae,h=c?2:1,f=h,p=r(e[0],d,h,u,f),m=[p];for(t=1;t<e.length;t++)n=r(e[t],d,h,u,f),p[d]!==n[d]&&(i=new it,i[d]=p[d],i[u]=n[u],m.push(i,n)),p=n;return a?p!==De(m)&&m.push(p):m.push(r(De(e),d,h,u,c?1:2)),m}},Qn=Kn.extend({points:function(){return this.calculateStepPoints(this.linePoints)}}),Te(Qn.prototype,Yn),Xn=Kn.extend({createVisual:function(){var e,t,n,i=this.series,o=i._defaults,r=i.color;xe(r)&&o&&(r=o.color),e=new Fe(this.options.closed),t=e.process(this.points()),n=new Xe({stroke:{color:r,width:i.width,opacity:i.opacity,dashType:i.dashType},zIndex:i.zIndex}),n.segments.push.apply(n.segments,t),this.visual=n}}),Zn={renderSegments:function(){var e,t,n,i,o,r,s,a,l=this,c=this,d=c.options,u=c.seriesPoints,h=d.series,f=u.length;for(this._segments=[],t=0;t<f;t++){for(n=h[t],i=l.sortPoints(u[t]),o=i.length,r=[],s=0;s<o;s++)a=i[s],a?r.push(a):l.seriesMissingValues(n)!==It&&(r.length>1&&(e=l.createSegment(r,n,t,e),l._addSegment(e)),r=[]);r.length>1&&(e=l.createSegment(r,n,t,e),l._addSegment(e))}this.children.unshift.apply(this.children,this._segments)},_addSegment:function(e){this._segments.push(e),e.parent=this},sortPoints:function(e){return e},seriesMissingValues:function(e){var t=e.missingValues,n=!t&&this.options.isStacked;return n?Et:t||It},getNearestPoint:function(e,t,n){var i,o,r,s,a,l=new _e(e,t),c=this.seriesPoints[n],d=Z;for(o=0;o<c.length;o++)r=c[o],r&&pe(r.value)&&null!==r.value&&r.visible!==!1&&(s=r.box,a=s.center().distanceTo(l),a<d&&(i=r,d=a));return i}},Jn=Ze.extend({setup:function(){this._setEnd(this.options.box.x1)},step:function(e){var t=this.options.box;this._setEnd(K.interpolateValue(t.x1,t.x2,e))},_setEnd:function(e){var t=this.element,n=t.segments,i=n[1].anchor(),o=n[2].anchor();t.suspend(),i.setX(e),t.resume(),o.setX(e)}}),ye(Jn,{duration:gt}),Je.current.register("clip",Jn),ei={createAnimation:function(){var e,t,n=this.getRoot();n&&(n.options||{}).transitions!==!1&&(e=n.box,t=Xe.fromRect(e.toRect()),this.visual.clip(t),this.animation=new Jn(t,{box:e}),s(this.options.series)&&this._setChildrenAnimation(t))},_setChildrenAnimation:function(e){var t,n,i=this.animationPoints();for(t=0;t<i.length;t++)n=i[t],n&&n.visual&&pe(n.visual.options.zIndex)&&n.visual.clip(e)}},ti=jn.extend({render:function(){jn.fn.render.call(this),this.updateStackRange(),this.renderSegments()},pointType:function(){return $n},createPoint:function(e,t){var n,i,o,r=t.categoryIx,s=t.category,a=t.series,l=t.seriesIx,c=this.seriesMissingValues(a),d=e.valueFields.value;if(!pe(d)||null===d){if(c!==Et)return null;d=0}return n=this.pointOptions(a,l),n=this.evalPointOptions(n,d,s,r,a,l),i=e.fields.color||a.color,xe(a.color)&&(i=n.color),o=new $n(d,n),o.color=i,this.append(o),o},plotRange:function(e){var t,n,i,o,r=this,s=this.plotValue(e);if(this.options.isStacked)for(t=e.categoryIx,n=this.categoryPoints[t],i=0;i<n.length&&(o=n[i],e!==o);i++)s+=r.plotValue(o),r.options.isStacked100&&(s=Math.min(s,1));return[s,s]},createSegment:function(e,t,n){var i,o=t.style;return new(i=o===Pt?Qn:o===zt?Xn:Kn)(e,t,n)},animationPoints:function(){var e,t=this.points,n=[];for(e=0;e<t.length;e++)n.push((t[e]||{}).marker);return n.concat(this._segments)}}),Te(ti.prototype,Zn,ei),ni=Kn.extend({init:function(e,t,n,i,o){Kn.fn.init.call(this,e,t,n),this.prevSegment=i,this.stackPoints=o},createVisual:function(){var e=this.series,t=e._defaults,n=e.line||{},i=e.color;xe(i)&&t&&(i=t.color),this.visual=new et({zIndex:e.zIndex}),this.createFill({fill:{color:i,opacity:e.opacity},stroke:null}),n.width>0&&n.visible!==!1&&this.createStroke({stroke:Te({color:i,opacity:e.opacity,lineCap:"butt"},n)})},strokeSegments:function(){var e=this._strokeSegments;return e||(e=this._strokeSegments=this.createStrokeSegments()),e},createStrokeSegments:function(){return this.segmentsFromPoints(this.points())},stackSegments:function(){return this.prevSegment?this.prevSegment.createStackSegments(this.stackPoints):this.createStackSegments(this.stackPoints)},createStackSegments:function(e){return this.segmentsFromPoints(this.toGeometryPoints(e)).reverse()},segmentsFromPoints:function(e){return e.map(function(e){return new nt.Segment(e)})},createStroke:function(e){var t=new Xe(e);t.segments.push.apply(t.segments,this.strokeSegments()),this.visual.append(t)},hasStackSegment:function(){return this.prevSegment||this.stackPoints&&this.stackPoints.length},createFill:function(e){var t,n,i=this.strokeSegments(),o=i.slice(0),r=this.hasStackSegment();r&&(t=this.stackSegments(),ze(o,t)),n=new Xe(e),n.segments.push.apply(n.segments,o),!r&&i.length>1&&this.fillToAxes(n),this.visual.append(n)},fillToAxes:function(e){var t=this.parent,n=t.options.invertAxes,i=t.seriesValueAxis(this.series),o=t.categoryAxisCrossingValue(i),r=i.getSlot(o,o,!0),s=this.strokeSegments(),a=s[0].anchor(),l=De(s).anchor(),c=n?r.x1:r.y1;n?e.lineTo(c,l.y).lineTo(c,a.y):e.lineTo(l.x,c).lineTo(a.x,c)}}),ii=ni.extend({createStrokeSegments:function(){return this.segmentsFromPoints(this.calculateStepPoints(this.linePoints))},createStackSegments:function(e){return this.segmentsFromPoints(this.calculateStepPoints(e)).reverse()}}),Te(ii.prototype,Yn),oi=ni.extend({createStrokeSegments:function(){var e=new Fe(this.options.closed),t=this.points();return e.process(t)},createStackSegments:function(){var e,t,n=this.strokeSegments(),i=[];for(e=n.length-1;e>=0;e--)t=n[e],i.push(new nt.Segment(t.anchor(),t.controlOut(),t.controlIn()));return i}}),ri=ti.extend({createSegment:function(e,t,n,i){var o,r,s,a,l=this.options.isStacked,c=(t.line||{}).style;return l&&n>0&&i&&(s=this.seriesMissingValues(t),"gap"!==s?(r=i.linePoints,o=i):r=this._gapStackPoints(e,n,c)),new(a=c===Pt?ii:c===zt?oi:ni)(e,t,n,o,r)},reflow:function(e){var t,n,i,o,r=this;if(ti.fn.reflow.call(this,e),t=this._stackPoints)for(n=0;n<t.length;n++)i=t[n],o=r.categoryAxis.getSlot(i.categoryIx),i.reflow(o)},_gapStackPoints:function(e,t,n){var i,o,r,s,a,l,c,d,u=this,h=this.seriesPoints,f=e[0].categoryIx,p=e.length;for(f<0&&(f=0,p--),i=f+p,o=this.seriesOptions[0]._outOfRangeMinPoint?1:0,r=[],this._stackPoints=this._stackPoints||[],s=f;s<i;s++){a=s+o,l=t,c=void 0;do l--,c=h[l][a];while(l>0&&!c);c?(n!==Pt&&s>f&&!h[l][a-1]&&r.push(u._previousSegmentPoint(s,a,a-1,l)),r.push(c),n!==Pt&&s+1<i&&!h[l][a+1]&&r.push(u._previousSegmentPoint(s,a,a+1,l))):(d=u._createGapStackPoint(s),u._stackPoints.push(d),r.push(d))}return r},_previousSegmentPoint:function(e,t,n,i){for(var o,r=this.seriesPoints,s=i;s>0&&!o;)s--,o=r[s][n];return o?o=r[s][t]:(o=this._createGapStackPoint(e),this._stackPoints.push(o)),o},_createGapStackPoint:function(e){var t=this.pointOptions({},0),n=new $n(0,t);return n.categoryIx=e,n.series={},n},seriesMissingValues:function(e){return e.missingValues||Et}}),si=Y.extend({init:function(){this.axisRanges={}},update:function(e){var t,n,i,o=this.axisRanges;for(t in e)n=e[t],i=o[t],o[t]=i=i||{min:Z,max:J},i.min=Math.min(i.min,n.min),i.max=Math.max(i.max,n.max)},reset:function(e){this.axisRanges[e]=void 0},query:function(e){return this.axisRanges[e]}}),ai=ve.extend({init:function(e,t){ve.fn.init.call(this,t),this.textBox=new Ie(e,this.options),this.append(this.textBox)},createVisual:function(){this.textBox.options.noclip=this.options.noclip},reflow:function(e){var t=this.options,n=t.vertical,i=t.aboveAxis,o=this.children[0],r=o.options,s=o.box,a=o.options.padding,l=e;r.align=n?te:oe,r.vAlign=n?ne:te,t.position===zn?n?(r.vAlign=ne,!i&&s.height()<e.height()&&(r.vAlign=ie)):r.align=i?ce:oe:t.position===te?(r.vAlign=te,r.align=te):t.position===Pn?n?r.vAlign=i?ie:ne:r.align=i?oe:ce:t.position===Bn&&(n?l=i?new be(e.x1,e.y1-s.height(),e.x2,e.y1):new be(e.x1,e.y2,e.x2,e.y2+s.height()):(r.align=te,l=i?new be(e.x2,e.y1,e.x2+s.width(),e.y2):new be(e.x1-s.width(),e.y1,e.x1,e.y2))),t.rotation||(n?a.left=a.right=(l.width()-o.contentBox.width())/2:a.top=a.bottom=(l.height()-o.contentBox.height())/2),o.reflow(l)},alignToClipBox:function(e){var t,n=this.options.vertical,i=n?le:ae,o=i+"1",r=i+"2",s=this.children[0],a=this.parent.box;(a[o]<e[o]||e[r]<a[r])&&(t=s.paddingBox.clone(),t[o]=Math.max(a[o],e[o]),t[r]=Math.min(a[r],e[r]),this.reflow(t))}}),ye(ai,{position:Bn,margin:Re(3),padding:Re(4),color:de,background:"",border:{width:1,color:""},aboveAxis:!0,vertical:!1,animation:{type:vt,delay:gt},zIndex:2}),li=6,ci=ve.extend({init:function(e,t){ve.fn.init.call(this),this.options=t,this.color=t.color||re,this.aboveAxis=Ce(this.options.aboveAxis,!0),this.value=e},render:function(){this._rendered||(this._rendered=!0,this.createLabel(),this.createNote(),this.errorBar&&this.append(this.errorBar))},createLabel:function(){var e,t,n=this.options,i=n.labels;i.visible&&(e=Ee(i),t=e?e({dataItem:this.dataItem,category:this.category,value:this.value,percentage:this.percentage,stackValue:this.stackValue,runningTotal:this.runningTotal,total:this.total,series:this.series}):this.formatValue(i.format),this.label=new ai(t,Te({vertical:n.vertical},i)),this.append(this.label))},formatValue:function(e){return this.owner.formatPointValue(this,e)},reflow:function(e){var t,n,i=this;if(this.render(),t=this.label,this.box=e,t&&(t.options.aboveAxis=this.aboveAxis,t.reflow(e)),this.note&&this.note.reflow(e),this.errorBars)for(n=0;n<this.errorBars.length;n++)i.errorBars[n].reflow(e)},createVisual:function(){var e,t=this,n=this,i=n.box,o=n.options,r=o.visual;this.visible!==!1&&(ve.fn.createVisual.call(this),r?(e=this.rectVisual=r({category:this.category,dataItem:this.dataItem,value:this.value,sender:this.getSender(),series:this.series,percentage:this.percentage,stackValue:this.stackValue,runningTotal:this.runningTotal,total:this.total,rect:i.toRect(),createVisual:function(){var e=new et;return t.createRect(e),e},options:o}),e&&this.visual.append(e)):i.width()>0&&i.height()>0&&this.createRect(this.visual))},createRect:function(e){var t,n,i,o,r,s=this.options,l=s.border,c=pe(l.opacity)?l.opacity:s.opacity,d=this.box.toRect();d.size.width=Math.round(d.size.width),t=this.rectVisual=Xe.fromRect(d,{fill:{color:this.color,opacity:s.opacity},stroke:{color:this.getBorderColor(),width:l.width,opacity:c,dashType:l.dashType}}),n=this.box.width(),i=this.box.height(),o=s.vertical?n:i,o>li&&(we(t),(n<1||i<1)&&(t.options.stroke.lineJoin="round")),e.append(t),a(s)&&(r=this.createGradientOverlay(t,{baseColor:this.color},Te({end:s.vertical?void 0:[0,1]},s.overlay)),e.append(r))},createHighlight:function(e){var t=Xe.fromRect(this.box.toRect(),e);return we(t)},highlightVisual:function(){return this.rectVisual},highlightVisualArgs:function(){return{options:this.options,rect:this.box.toRect(),visual:this.rectVisual}},getBorderColor:function(){var e=this.color,t=this.options.border,n=t._brightness||bt,i=t.color;return pe(i)||(i=new tt(e).brightness(n).toHex()),i},tooltipAnchor:function(){var e,t,n,i,o=this,r=o.options,s=o.box,a=o.aboveAxis,l=this.owner.pane.clipBox()||s,c=oe,d=ne;return r.vertical?(e=Math.min(s.x2,l.x2)+wt,a?t=Math.max(s.y1,l.y1):(t=Math.min(s.y2,l.y2),d=ie)):(n=Math.max(s.x1,l.x1),i=Math.min(s.x2,l.x2),r.isStacked?(d=ie,a?(c=ce,e=i):e=n,t=Math.max(s.y1,l.y1)-wt):(a?e=i+wt:(e=n-wt,c=ce),t=Math.max(s.y1,l.y1))),{point:new _e(e,t),align:{horizontal:c,vertical:d}}},overlapsBox:function(e){return this.box.overlaps(e)}}),Te(ci.prototype,qn),Te(ci.prototype,Gn),ci.prototype.defaults={border:{width:1},vertical:!0,overlay:{gradient:"glass"},labels:{visible:!1,format:"{0}"},opacity:1,notes:{label:{}}},di=ve.extend({init:function(e){ve.fn.init.call(this,e),this.forEach=e.rtl?c:l},reflow:function(e){var t=this.options,n=t.vertical,i=t.gap,o=t.spacing,r=this.children,s=r.length,a=n?le:ae,l=s+i+o*(s-1),c=(n?e.height():e.width())/l,d=e[a+1]+c*(i/2);this.forEach(r,function(t,n){var i=(t.box||e).clone();i[a+1]=d,i[a+2]=d+c,t.reflow(i),n<s-1&&(d+=c*o),d+=c})}}),ye(di,{vertical:!1,gap:0,spacing:0}),ui=ve.extend({reflow:function(e){var t,n,i,o=this,r=this.options.vertical?ae:le,s=this.children,a=s.length,l=this.box=new be;for(t=0;t<a;t++)n=s[t],n.visible!==!1&&(i=n.box.clone(),i.snapTo(e,r),0===t&&(l=o.box=i.clone()),n.reflow(i),l.wrap(i))}}),ye(ui,{vertical:!0}),hi=jn.extend({render:function(){jn.fn.render.call(this),this.updateStackRange()},pointType:function(){return ci},clusterType:function(){return di},stackType:function(){return ui},stackLimits:function(e,t){var n=jn.fn.stackLimits.call(this,e,t);return n},createPoint:function(e,t){var n,i,o,r,s,a,l=t.categoryIx,c=t.category,d=t.series,u=t.seriesIx,h=this,f=h.options,p=h.children,m=f.isStacked,g=this.pointValue(e),v=this.pointOptions(d,u),_=v.labels;return m&&_.position===Bn&&(_.position=zn),v.isStacked=m,n=e.fields.color||d.color,g<0&&v.negativeColor&&(n=v.negativeColor),v=this.evalPointOptions(v,g,c,l,d,u),xe(d.color)&&(n=v.color),i=this.pointType(),o=new i(g,v),o.color=n,r=p[l],r||(s=this.clusterType(),r=new s({vertical:f.invertAxes,gap:f.gap,spacing:f.spacing,rtl:!f.invertAxes&&(this.chartService||{}).rtl}),this.append(r)),m?(a=this.getStackWrap(d,r),a.append(o)):r.append(o),o},getStackWrap:function(e,t){var n,i,o,r=e.stack,s=r?r.group||r:r,a=t.children;if(typeof s===X.STRING){for(i=0;i<a.length;i++)if(a[i]._stackGroup===s){n=a[i];break}}else n=a[0];return n||(o=this.stackType(),n=new o({vertical:!this.options.invertAxes}),n._stackGroup=s,t.append(n)),n},categorySlot:function(e,t,n){var i,o,r=this.options,s=e.getSlot(t),a=n.startValue();return r.isStacked&&(i=n.getSlot(a,a,!0),o=r.invertAxes?ae:le,s[o+1]=s[o+2]=i[o+1]),s},reflowCategories:function(e){var t,n=this.children,i=n.length;for(t=0;t<i;t++)n[t].reflow(e[t])},createAnimation:function(){this._setAnimationOptions(),jn.fn.createAnimation.call(this),s(this.options.series)&&this._setChildrenAnimation()},_setChildrenAnimation:function(){var e,t,n,i=this,o=this.points;for(e=0;e<o.length;e++)t=o[e],n=t.visual,n&&pe(n.options.zIndex)&&(t.options.animation=i.options.animation,t.createAnimation())},_setAnimationOptions:function(){var e,t,n=this.options,i=n.animation||{};n.isStacked?(t=this.seriesValueAxis(n.series[0]),e=t.getSlot(t.startValue())):e=this.categoryAxis.getSlot(0),i.origin=new it(e.x1,e.y1),i.vertical=!n.invertAxes}}),ye(hi,{animation:{type:Lt}}),fi=ve.extend({init:function(e,t){ve.fn.init.call(this,t),this.value=e},reflow:function(e){var t,n,i=this,o=i.options,r=i.value,s=i.owner,a=s.seriesValueAxis(o),l=a.getSlot(r.open,r.close),c=a.getSlot(r.low,r.high);l.x1=c.x1=e.x1,l.x2=c.x2=e.x2,this.realBody=l,t=c.center().x,n=[],n.push([[t,c.y1],[t,l.y1]]),n.push([[t,l.y2],[t,c.y2]]),this.lines=n,this.box=c.clone().wrap(l),this._rendered||(this._rendered=!0,this.createNote()),this.reflowNote()},reflowNote:function(){this.note&&this.note.reflow(this.box)},createVisual:function(){ve.fn.createVisual.call(this),this._mainVisual=this.mainVisual(this.options),this.visual.append(this._mainVisual),this.createOverlay()},mainVisual:function(e){var t=new et;return this.createBody(t,e),this.createLines(t,e),t},createBody:function(e,t){var n=Xe.fromRect(this.realBody.toRect(),{fill:{color:this.color,opacity:t.opacity},stroke:null});t.border.width>0&&n.options.set("stroke",{color:this.getBorderColor(),width:t.border.width,dashType:t.border.dashType,opacity:Ce(t.border.opacity,t.opacity)}),we(n),e.append(n),a(t)&&e.append(this.createGradientOverlay(n,{baseColor:this.color},Te({end:t.vertical?void 0:[0,1]},t.overlay)))},createLines:function(e,t){this.drawLines(e,t,this.lines,t.line)},drawLines:function(e,t,n,i){var o,r,s;if(n)for(o={stroke:{color:i.color||this.color,opacity:Ce(i.opacity,t.opacity),width:i.width,dashType:i.dashType,lineCap:"butt"}},r=0;r<n.length;r++)s=Xe.fromPoints(n[r],o),we(s),e.append(s)},getBorderColor:function(){var e=this.options.border,t=e.color;return pe(t)||(t=new tt(this.color).brightness(e._brightness).toHex()),t},createOverlay:function(){var e=Xe.fromRect(this.box.toRect(),{fill:{color:re,opacity:0},stroke:null});this.visual.append(e)},createHighlight:function(){var e,t=this.options.highlight,n=this.color;return this.color=t.color||this.color,e=this.mainVisual(Te({},this.options,{line:{color:this.getBorderColor()}},t)),this.color=n,e},highlightVisual:function(){return this._mainVisual},highlightVisualArgs:function(){return{options:this.options,rect:this.box.toRect(),visual:this._mainVisual}},tooltipAnchor:function(){var e=this.box,t=this.owner.pane.clipBox()||e;return{point:new _e(e.x2+wt,Math.max(e.y1,t.y1)+wt),align:{horizontal:oe,vertical:ne}}},formatValue:function(e){return this.owner.formatPointValue(this,e)},overlapsBox:function(e){return this.box.overlaps(e)}}),ye(fi,{vertical:!0,border:{_brightness:.8},line:{width:2},overlay:{gradient:"glass"},tooltip:{format:"<table><tr><th colspan='2'>{4:d}</th></tr><tr><td>Open:</td><td>{0:C}</td></tr><tr><td>High:</td><td>{1:C}</td></tr><tr><td>Low:</td><td>{2:C}</td></tr><tr><td>Close:</td><td>{3:C}</td></tr></table>"},highlight:{opacity:1,border:{width:1,opacity:1},line:{width:1,opacity:1}},notes:{visible:!0,label:{}}}),Te(fi.prototype,qn),Te(fi.prototype,Gn),pi=jn.extend({reflowCategories:function(e){var t,n=this.children,i=n.length;for(t=0;t<i;t++)n[t].reflow(e[t])},addValue:function(e,t){var n,i,o=t.categoryIx,r=t.category,s=t.series,a=t.seriesIx,l=this,c=l.children,u=l.options,h=e.valueFields,f=this.splitValue(h),p=d(f),m=s.data[o],g=this.categoryPoints[o];g||(this.categoryPoints[o]=g=[]),p&&(n=this.createPoint(e,t)),i=c[o],i||(i=new di({vertical:u.invertAxes,gap:u.gap,spacing:u.spacing,rtl:!u.invertAxes&&(this.chartService||{}).rtl}),this.append(i)),n&&(this.updateRange(h,t),i.append(n),n.categoryIx=o,n.category=r,n.series=s,n.seriesIx=a,n.owner=this,n.dataItem=m,n.noteText=e.fields.noteText),this.points.push(n),g.push(n)},pointType:function(){return fi},createPoint:function(e,t){var n,i=t.categoryIx,o=t.category,r=t.series,s=t.seriesIx,a=this.pointType(),l=e.valueFields,c=Te({},r),d=e.fields.color||r.color;return c=this.evalPointOptions(c,l,o,i,r,s),r.type===Vt&&l.open>l.close&&(d=e.fields.downColor||r.downColor||r.color),xe(r.color)&&(d=c.color),c.vertical=!this.options.invertAxes,n=new a(l,c),n.color=d,n},splitValue:function(e){return[e.low,e.open,e.close,e.high]},updateRange:function(e,t){var n=t.series.axis,i=this.splitValue(e),o=this.valueAxisRanges[n];o=this.valueAxisRanges[n]=o||{min:Z,max:J},o=this.valueAxisRanges[n]={min:Math.min.apply(Math,i.concat([o.min])),max:Math.max.apply(Math,i.concat([o.max]))}},formatPointValue:function(e,t){var n=e.value;return this.chartService.format.auto(t,n.open,n.high,n.low,n.close,e.category)},animationPoints:function(){return this.points}}),Te(pi.prototype,ei),mi=fi.extend({init:function(e,t){fi.fn.init.call(this,e,t),this.createNote()},reflow:function(e){var t,n,i,o,r=this,s=r.options,a=r.value,l=r.owner,c=l.seriesValueAxis(s);this.boxSlot=n=c.getSlot(a.q1,a.q3),this.realBody=n,this.reflowBoxSlot(e),this.whiskerSlot=t=c.getSlot(a.lower,a.upper),this.reflowWhiskerSlot(e),i=c.getSlot(a.median),a.mean&&(o=c.getSlot(a.mean),this.meanPoints=this.calcMeanPoints(e,o)),this.whiskerPoints=this.calcWhiskerPoints(n,t),this.medianPoints=this.calcMedianPoints(e,i),this.box=t.clone().wrap(n),this.reflowNote()},reflowBoxSlot:function(e){this.boxSlot.x1=e.x1,this.boxSlot.x2=e.x2},reflowWhiskerSlot:function(e){this.whiskerSlot.x1=e.x1,this.whiskerSlot.x2=e.x2},calcMeanPoints:function(e,t){return[[[e.x1,t.y1],[e.x2,t.y1]]]},calcWhiskerPoints:function(e,t){var n=t.center().x;return[[[n-5,t.y1],[n+5,t.y1],[n,t.y1],[n,e.y1]],[[n-5,t.y2],[n+5,t.y2],[n,t.y2],[n,e.y2]]]},calcMedianPoints:function(e,t){return[[[e.x1,t.y1],[e.x2,t.y1]]]},renderOutliers:function(e){var t,n,i,o,r=this,s=this.value,a=s.outliers||[],l=3*Math.abs(s.q3-s.q1),c=[],d=e.markers||{};for(t=0;t<a.length;t++)n=a[t],d=n<s.q3+l&&n>s.q1-l?e.outliers:e.extremes,i=Te({},d.border),pe(i.color)||(i.color=pe(r.color)?r.color:new tt(d.background).brightness(bt).toHex()),o=new Me({type:d.type,width:d.size,height:d.size,rotation:d.rotation,background:d.background,border:i,opacity:d.opacity}),o.value=n,c.push(o);return this.reflowOutliers(c),c},reflowOutliers:function(e){var t,n,i,o=this,r=this.owner.seriesValueAxis(this.options),s=this.box.center();for(t=0;t<e.length;t++)n=e[t].value,i=r.getSlot(n),o.options.vertical?i.move(s.x):i.move(void 0,s.y),o.box=o.box.wrap(i),e[t].reflow(i)},mainVisual:function(e){var t,n,i=fi.fn.mainVisual.call(this,e),o=this.renderOutliers(e);for(t=0;t<o.length;t++)n=o[t].getElement(),n&&i.append(n);return i},createLines:function(e,t){this.drawLines(e,t,this.whiskerPoints,t.whiskers),this.drawLines(e,t,this.medianPoints,t.median),this.drawLines(e,t,this.meanPoints,t.mean)},getBorderColor:function(){return this.color?this.color:fi.fn.getBorderColor.call(this)}}),ye(mi,{border:{_brightness:.8},line:{width:2},median:{color:"#f6f6f6"},mean:{width:2,dashType:"dash",color:"#f6f6f6"},overlay:{gradient:"glass"},tooltip:{format:"<table><tr><th colspan='2'>{6:d}</th></tr><tr><td>Lower:</td><td>{0:C}</td></tr><tr><td>Q1:</td><td>{1:C}</td></tr><tr><td>Median:</td><td>{2:C}</td></tr><tr><td>Mean:</td><td>{5:C}</td></tr><tr><td>Q3:</td><td>{3:C}</td></tr><tr><td>Upper:</td><td>{4:C}</td></tr></table>"},highlight:{opacity:1,border:{width:1,opacity:1},line:{width:1,opacity:1}},notes:{visible:!0,label:{}},outliers:{visible:!0,size:At,type:X.CROSS,background:re,border:{width:2,opacity:1},opacity:0},extremes:{visible:!0,size:At,type:se,background:re,border:{width:2,opacity:1},opacity:0}}),Te(mi.prototype,qn),gi=mi.extend({reflowBoxSlot:function(e){this.boxSlot.y1=e.y1,this.boxSlot.y2=e.y2},reflowWhiskerSlot:function(e){this.whiskerSlot.y1=e.y1,this.whiskerSlot.y2=e.y2},calcMeanPoints:function(e,t){return[[[t.x1,e.y1],[t.x1,e.y2]]]},calcWhiskerPoints:function(e,t){var n=t.center().y;return[[[t.x1,n-5],[t.x1,n+5],[t.x1,n],[e.x1,n]],[[t.x2,n-5],[t.x2,n+5],[t.x2,n],[e.x2,n]]]},calcMedianPoints:function(e,t){return[[[t.x1,e.y1],[t.x1,e.y2]]]}}),vi=pi.extend({addValue:function(e,t){var n,i,o=t.categoryIx,r=t.category,s=t.series,a=t.seriesIx,l=this,c=l.children,u=l.options,h=e.valueFields,f=this.splitValue(h),p=d(f),m=s.data[o],g=this.categoryPoints[o];g||(this.categoryPoints[o]=g=[]),p&&(n=this.createPoint(e,t)),i=c[o],i||(i=new di({vertical:u.invertAxes,gap:u.gap,spacing:u.spacing,rtl:!u.invertAxes&&(this.chartService||{}).rtl}),this.append(i)),n&&(this.updateRange(h,t),i.append(n),n.categoryIx=o,n.category=r,n.series=s,n.seriesIx=a,n.owner=this,n.dataItem=m),this.points.push(n),g.push(n)},pointType:function(){return this.options.invertAxes?gi:mi},splitValue:function(e){return[e.lower,e.q1,e.median,e.q3,e.upper]},updateRange:function(e,t){var n=t.series.axis,i=this.valueAxisRanges[n],o=this.splitValue(e).concat(this.filterOutliers(e.outliers));pe(e.mean)&&(o=o.concat(e.mean)),i=this.valueAxisRanges[n]=i||{min:Z,max:J},i=this.valueAxisRanges[n]={min:Math.min.apply(Math,o.concat([i.min])),max:Math.max.apply(Math,o.concat([i.max]))}},formatPointValue:function(e,t){var n=e.value;return this.chartService.format.auto(t,n.lower,n.q1,n.median,n.q3,n.upper,n.mean,e.category)},filterOutliers:function(e){var t,n,i=(e||[]).length,o=[];for(t=0;t<i;t++)n=e[t],pe(n)&&null!==n&&o.push(n);return o}}),_i=Vn.extend({getAxis:function(){var e=this.chart.seriesAxes(this.series),t=this.isVertical?e.y:e.x;return t}}),bi=ve.extend({init:function(e,t){ve.fn.init.call(this,t),this.plotArea=e,this.chartService=e.chartService,this._initFields(),this.render()},_initFields:function(){this.xAxisRanges={},this.yAxisRanges={},this.points=[],this.seriesPoints=[],this.seriesOptions=[],this._evalSeries=[]},render:function(){this.traverseDataPoints(this.addValue.bind(this))},addErrorBar:function(e,t,n){var i,o=e.value[t],r=t+"Value",s=t+"ErrorLow",a=t+"ErrorHigh",l=n.seriesIx,c=n.series,d=e.options.errorBars,u=n[s],h=n[a];Q(o)&&(Q(u)&&Q(h)&&(i={low:u,high:h}),d&&pe(d[r])&&(this.seriesErrorRanges=this.seriesErrorRanges||{x:[],y:[]},this.seriesErrorRanges[t][l]=this.seriesErrorRanges[t][l]||new pt(d[r],c,t),i=this.seriesErrorRanges[t][l].getErrorRange(o,d[r])),i&&this.addPointErrorBar(i,e,t))},addPointErrorBar:function(e,t,n){var i,o=e.low,r=e.high,s=t.series,a=t.options.errorBars,l=n===le,c={};t[n+"Low"]=o,t[n+"High"]=r,t.errorBars=t.errorBars||[],i=new _i(o,r,l,this,s,a),t.errorBars.push(i),t.append(i),c[n]=o,this.updateRange(c,s),c[n]=r,this.updateRange(c,s)},addValue:function(t,n){var i,o=t.x,r=t.y,s=n.seriesIx,a=this.options.series[s],l=this.seriesMissingValues(a),c=this.seriesPoints[s],d=t;u(o)&&u(r)||(d=this.createMissingValue(d,l)),d&&(i=this.createPoint(d,n),i&&(e.extend(i,n),this.addErrorBar(i,ae,n),this.addErrorBar(i,le,n)),this.updateRange(d,n.series)),this.points.push(i),c.push(i)},seriesMissingValues:function(e){return e.missingValues},createMissingValue:function(){},updateRange:function(e,t){var n=this.chartService.intl,i=t.xAxis,o=t.yAxis,r=e.x,s=e.y,a=this.xAxisRanges[i],l=this.yAxisRanges[o];u(r)&&(a=this.xAxisRanges[i]=a||{min:Z,max:J},Pe(r)&&(r=Be(n,r)),a.min=Math.min(a.min,r),a.max=Math.max(a.max,r)),u(s)&&(l=this.yAxisRanges[o]=l||{min:Z,max:J},Pe(s)&&(s=Be(n,s)),l.min=Math.min(l.min,s),l.max=Math.max(l.max,s))},evalPointOptions:function(e,t,n){var o,r=n.series,s=n.seriesIx,a={defaults:r._defaults,excluded:["data","tooltip","content","template","visual","toggle","_outOfRangeMinPoint","_outOfRangeMaxPoint"]},l=this._evalSeries[s];return pe(l)||(this._evalSeries[s]=l=i(e,{},a,!0)),o=e,l&&(o=Te({},e),i(o,{value:t,series:r,dataItem:n.dataItem},a)),o},pointType:function(){return $n},pointOptions:function(e,t){var n,i=this.seriesOptions[t];return i||(n=this.pointType().prototype.defaults,this.seriesOptions[t]=i=Te({},n,{markers:{opacity:e.opacity},tooltip:{format:this.options.tooltip.format},labels:{format:this.options.labels.format}},e)),i},createPoint:function(e,t){var n,i=t.series,o=this.pointOptions(i,t.seriesIx),r=t.color||i.color;return o=this.evalPointOptions(o,e,t),xe(i.color)&&(r=o.color),n=new $n(e,o),n.color=r,this.append(n),n},seriesAxes:function(e){var t=e.xAxis,n=e.yAxis,i=this.plotArea,o=t?i.namedXAxes[t]:i.axisX,r=n?i.namedYAxes[n]:i.axisY;if(!o)throw Error("Unable to locate X axis with name "+t);if(!r)throw Error("Unable to locate Y axis with name "+n);return{x:o,y:r}},reflow:function(e){var t=this,n=this.points,i=!this.options.clip,o=0;this.traverseDataPoints(function(e,r){var s,a=n[o++],l=t.seriesAxes(r.series),c=l.x.getSlot(e.x,e.x,i),d=l.y.getSlot(e.y,e.y,i);a&&(c&&d?(s=t.pointSlot(c,d),a.reflow(s)):a.visible=!1)}),this.box=e},pointSlot:function(e,t){return new be(e.x1,t.y1,e.x2,t.y2)},traverseDataPoints:function(e){var t,n,i,o,r,s,a,l=this,c=this,d=c.options.series,u=c.seriesPoints;for(t=0;t<d.length;t++)for(n=d[t],i=u[t],i||(u[t]=[]),o=0;o<n.data.length;o++)r=l._bindPoint(n,t,o),s=r.valueFields,a=r.fields,e(s,Te({pointIx:o,series:n,seriesIx:t,dataItem:n.data[o],owner:l},a))},formatPointValue:function(e,t){var n=e.value;return this.chartService.format.auto(t,n.x,n.y)},animationPoints:function(){var e,t=this.points,n=[];for(e=0;e<t.length;e++)n.push((t[e]||{}).marker);return n}}),ye(bi,{series:[],tooltip:{format:"{0}, {1}"},labels:{format:"{0}, {1}"},clip:!0}),Te(bi.prototype,ei,{_bindPoint:jn.prototype._bindPoint}),wi=$n.extend({init:function(e,t){$n.fn.init.call(this,e,t),this.category=e.category},createHighlight:function(){var e=this.options.highlight,t=e.border,n=this.options.markers,i=this.box.center(),o=(n.size+n.border.width+t.width)/2,r=new et,s=new Qe.Circle(new nt.Circle([i.x,i.y+o/5+t.width/2],o+t.width/2),{stroke:{color:"none"},fill:this.createGradient({gradient:"bubbleShadow",color:n.background,stops:[{offset:0,color:n.background,opacity:.3},{offset:1,color:n.background,opacity:0}]})}),a=new Qe.Circle(new nt.Circle([i.x,i.y],o),{stroke:{color:t.color||new tt(n.background).brightness(bt).toHex(),width:t.width,opacity:t.opacity},fill:{color:n.background,opacity:e.opacity}});return r.append(s,a),r}}),wi.prototype.defaults=Te({},wi.prototype.defaults,{labels:{position:te},highlight:{opacity:1,border:{color:"#fff",width:2,opacity:1}}}),wi.prototype.defaults.highlight.zIndex=void 0,yi=bi.extend({_initFields:function(){this._maxSize=J,bi.fn._initFields.call(this)},addValue:function(e,t){null!==e.size&&(e.size>0||e.size<0&&t.series.negativeValues.visible)?(this._maxSize=Math.max(this._maxSize,Math.abs(e.size)),bi.fn.addValue.call(this,e,t)):(this.points.push(null),this.seriesPoints[t.seriesIx].push(null))},reflow:function(e){this.updateBubblesSize(e),bi.fn.reflow.call(this,e)},pointType:function(){return wi},createPoint:function(e,t){var n,i,o=t.series,r=o.data.length,s=t.pointIx*(gt/r),a={delay:s,duration:gt-s,type:Nt},l=t.color||o.color;return e.size<0&&o.negativeValues.visible&&(l=Ce(o.negativeValues.color,l)),n=Te({labels:{animation:{delay:s,duration:gt-s}}},this.pointOptions(o,t.seriesIx),{markers:{type:se,border:o.border,opacity:o.opacity,animation:a}}),n=this.evalPointOptions(n,e,t),xe(o.color)&&(l=n.color),n.markers.background=l,i=new wi(e,n),i.color=l,this.append(i),i},updateBubblesSize:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_=this,b=this,w=b.options.series,y=Math.min(e.width(),e.height());for(t=0;t<w.length;t++)for(n=w[t],i=_.seriesPoints[t],o=n.minSize||Math.max(.02*y,10),r=n.maxSize||.2*y,s=o/2,a=r/2,l=Math.PI*s*s,c=Math.PI*a*a,d=c-l,u=d/_._maxSize,h=0;h<i.length;h++)f=i[h],f&&(p=Math.abs(f.value.size)*u,m=Math.sqrt((l+p)/Math.PI),g=Ce(f.options.zIndex,0),v=g+(1-m/a),Te(f.options,{zIndex:v,markers:{size:2*m,zIndex:v},labels:{zIndex:v+1}}))},formatPointValue:function(e,t){var n=e.value;return this.chartService.format.auto(t,n.x,n.y,n.size,e.category)},createAnimation:function(){},createVisual:function(){}}),ye(yi,{tooltip:{format:"{3}"},labels:{format:"{3}"}}),ki=Me.extend({}),Te(ki.prototype,qn),xi=ve.extend({init:function(e,t){ve.fn.init.call(this,t),this.aboveAxis=this.options.aboveAxis,this.color=t.color||re,this.value=e},render:function(){var e=this.options;this._rendered||(this._rendered=!0,pe(this.value.target)&&(this.target=new ki({type:e.target.shape,background:e.target.color||this.color,opacity:e.opacity,zIndex:e.zIndex,border:e.target.border,vAlign:ne,align:ce}),this.target.value=this.value,this.target.dataItem=this.dataItem,this.target.series=this.series,this.append(this.target)),this.createNote())},reflow:function(e){var t,n,i,o,r,s,a,l,c,d,u;this.render(),t=this,n=t.options,i=t.target,o=t.owner,r=n.invertAxes,s=o.seriesValueAxis(this.options),a=o.categorySlot(o.categoryAxis,n.categoryIx,s),l=s.getSlot(this.value.target),c=r?l:a,d=r?a:l,i&&(u=new be(c.x1,d.y1,c.x2,d.y2),i.options.height=r?u.height():n.target.line.width,
i.options.width=r?n.target.line.width:u.width(),i.reflow(u)),this.note&&this.note.reflow(e),this.box=e},createVisual:function(){var e,t;ve.fn.createVisual.call(this),e=this.options,t=Xe.fromRect(this.box.toRect(),{fill:{color:this.color,opacity:e.opacity},stroke:null}),e.border.width>0&&t.options.set("stroke",{color:e.border.color||this.color,width:e.border.width,dashType:e.border.dashType,opacity:Ce(e.border.opacity,e.opacity)}),this.bodyVisual=t,we(t),this.visual.append(t)},createAnimation:function(){this.bodyVisual&&(this.animation=Ze.create(this.bodyVisual,this.options.animation))},createHighlight:function(e){return Xe.fromRect(this.box.toRect(),e)},highlightVisual:function(){return this.bodyVisual},highlightVisualArgs:function(){return{rect:this.box.toRect(),visual:this.bodyVisual,options:this.options}},formatValue:function(e){return this.owner.formatPointValue(this,e)}}),xi.prototype.tooltipAnchor=ci.prototype.tooltipAnchor,ye(xi,{border:{width:1},vertical:!1,opacity:1,target:{shape:"",border:{width:0,color:"green"},line:{width:2}},tooltip:{format:"Current: {0}<br />Target: {1}"}}),Te(xi.prototype,qn),Te(xi.prototype,Gn),Ci=jn.extend({init:function(e,t){h(t),jn.fn.init.call(this,e,t)},reflowCategories:function(e){var t,n=this.children,i=n.length;for(t=0;t<i;t++)n[t].reflow(e[t])},plotRange:function(e){var t=e.series,n=this.seriesValueAxis(t),i=this.categoryAxisCrossingValue(n);return[i,e.value.current||i]},createPoint:function(e,t){var n,i,o=t.categoryIx,r=t.category,s=t.series,a=t.seriesIx,l=this,c=l.options,d=l.children,u=e.valueFields,h=Te({vertical:!c.invertAxes,overlay:s.overlay,categoryIx:o,invertAxes:c.invertAxes},s),f=e.fields.color||s.color;return h=this.evalPointOptions(h,u,r,o,s,a),xe(s.color)&&(f=h.color),n=new xi(u,h),n.color=f,i=d[o],i||(i=new di({vertical:c.invertAxes,gap:c.gap,spacing:c.spacing,rtl:!c.invertAxes&&(this.chartService||{}).rtl}),this.append(i)),i.append(n),n},updateRange:function(e,t){var n=e.current,i=e.target,o=t.series.axis,r=this.valueAxisRanges[o];pe(n)&&!isNaN(n)&&pe(i&&!isNaN(i))&&(r=this.valueAxisRanges[o]=r||{min:Z,max:J},r.min=Math.min(r.min,n,i),r.max=Math.max(r.max,n,i))},formatPointValue:function(e,t){return this.chartService.format.auto(t,e.value.current,e.value.target)},pointValue:function(e){return e.valueFields.current},aboveAxis:function(e){var t=e.value.current;return t>0},createAnimation:function(){var e,t,n=this,i=this.points;for(this._setAnimationOptions(),e=0;e<i.length;e++)t=i[e],t.options.animation=n.options.animation,t.createAnimation()}}),Ci.prototype._setAnimationOptions=hi.prototype._setAnimationOptions,ye(Ci,{animation:{type:Lt}}),Si=Y.extend({init:function(e,t){this.chartService=e,this.options=Te({},this.options,t)},getStyle:function(e,t){var n,i,o=e.background,r=e.border.color;return t&&(n=t.color||t.options.color,o=Ce(o,n),r=Ce(r,n)),i=Re(e.padding||{},"auto"),{backgroundColor:o,borderColor:r,font:e.font,color:e.color,opacity:e.opacity,borderWidth:Le(e.border.width),paddingTop:Le(i.top),paddingBottom:Le(i.bottom),paddingLeft:Le(i.left),paddingRight:Le(i.right)}},show:function(e,t,n){e.format=t.format;var i=this.getStyle(t,n);e.style=i,!pe(t.color)&&new tt(i.backgroundColor).percBrightness()>180&&(e.className="k-chart-tooltip-inverse"),this.chartService.notify(In,e)},hide:function(){this.chartService&&this.chartService.notify(Mn)},destroy:function(){delete this.chartService}}),ye(Si,{border:{width:1},opacity:1}),Ti=Si.extend({init:function(e,t,n){Si.fn.init.call(this,e,n),this.crosshair=t,this.formatService=e.format,this.initAxisName()},initAxisName:function(){var e,t=this.crosshair.axis,n=t.plotArea;e=n.categoryAxis?t.getCategory?"categoryAxis":"valueAxis":t.options.vertical?"yAxis":"xAxis",this.axisName=e},showAt:function(e){var t=this,n=t.crosshair.axis,i=t.options,o=n[i.stickyMode?"getCategory":"getValue"](e),r=o;i.format?r=this.formatService.auto(i.format,o):n.options.type===ue&&(r=this.formatService.auto(n.options.labels.dateFormats[n.options.baseUnit],o)),this.show({point:e,anchor:this.getAnchor(),crosshair:this.crosshair,value:r,axisName:this.axisName,axisIndex:this.crosshair.axis.axisIndex},this.options)},hide:function(){this.chartService.notify(Mn,{crosshair:this.crosshair,axisName:this.axisName,axisIndex:this.crosshair.axis.axisIndex})},getAnchor:function(){var e,t,n,i=this,o=i.crosshair,r=i.options,s=r.position,a=r.padding,l=!o.axis.options.vertical,c=o.line.bbox();return l?(e=te,s===ie?(t=ne,n=c.bottomLeft().translate(0,a)):(t=ie,n=c.topLeft().translate(0,-a))):(t=te,s===oe?(e=ce,n=c.topLeft().translate(-a,0)):(e=oe,n=c.topRight().translate(a,0))),{point:n,align:{horizontal:e,vertical:t}}}}),ye(Ti,{padding:10}),Di=ve.extend({init:function(e,t,n){ve.fn.init.call(this,n),this.axis=t,this.stickyMode=t instanceof He;var i=this.options.tooltip;i.visible&&(this.tooltip=new Ti(e,this,Te({},i,{stickyMode:this.stickyMode})))},showAt:function(e){this.point=e,this.moveLine(),this.line.visible(!0),this.tooltip&&this.tooltip.showAt(e)},hide:function(){this.line.visible(!1),this.tooltip&&this.tooltip.hide()},moveLine:function(){var e,t,n=this,i=n.axis,o=n.point,r=i.options.vertical,s=this.getBox(),a=r?le:ae,l=new it(s.x1,s.y1);e=r?new it(s.x2,s.y1):new it(s.x1,s.y2),o&&(this.stickyMode?(t=i.getSlot(i.pointCategoryIndex(o)),l[a]=e[a]=t.center()[a]):l[a]=e[a]=o[a]),this.box=s,this.line.moveTo(l).lineTo(e)},getBox:function(){var e,t,n,i=this.axis,o=i.pane.axes,r=o.length,s=i.options.vertical,a=i.lineBox().clone(),l=s?ae:le;for(t=0;t<r;t++)n=o[t],n.options.vertical!==s&&(e?e.wrap(n.lineBox()):e=n.lineBox().clone());return a[l+1]=e[l+1],a[l+2]=e[l+2],a},createVisual:function(){ve.fn.createVisual.call(this);var e=this.options;this.line=new Xe({stroke:{color:e.color,width:e.width,opacity:e.opacity,dashType:e.dashType},visible:!1}),this.moveLine(),this.visual.append(this.line)},destroy:function(){this.tooltip&&this.tooltip.destroy(),ve.fn.destroy.call(this)}}),ye(Di,{color:de,width:2,zIndex:-1,tooltip:{visible:!1}}),Ai=ve.extend({init:function(e,t){ve.fn.init.call(this,e),this.pane=t},shouldClip:function(){var e,t=this.children,n=t.length;for(e=0;e<n;e++)if(t[e].options.clip===!0)return!0;return!1},_clipBox:function(){return this.pane.chartsBox()},createVisual:function(){var e,t,n;this.visual=new et({zIndex:0}),this.shouldClip()&&(e=this.clipBox=this._clipBox(),t=e.toRect(),n=Xe.fromRect(t),this.visual.clip(n),this.unclipLabels())},stackRoot:function(){return this},unclipLabels:function(){var e,t,n,i,o,r,s,a=this,l=a.children,c=a.clipBox;for(e=0;e<l.length;e++)for(t=l[e].points||{},n=t.length,i=0;i<n;i++)o=t[i],o&&o.visible!==!1&&o.overlapsBox&&o.overlapsBox(c)&&(o.unclipElements?o.unclipElements():(r=o.label,s=o.note,r&&r.options.visible&&(r.alignToClipBox&&r.alignToClipBox(c),r.options.noclip=!0),s&&s.options.visible&&(s.options.noclip=!0)))},destroy:function(){ve.fn.destroy.call(this),delete this.parent}}),Ai.prototype.isStackRoot=!0,Ei=Ne.extend({init:function(e){Ne.fn.init.call(this,e),this.id=f(),this.createTitle(),this.content=new ve,this.chartContainer=new Ai({},this),this.append(this.content),this.axes=[],this.charts=[]},createTitle:function(){var e=this.options.title;Se(e)&&(e=Te({},e,{align:e.position,position:ne})),this.title=K.Title.buildTitle(e,this,Ei.prototype.options.title)},appendAxis:function(e){this.content.append(e),this.axes.push(e),e.pane=this},appendChart:function(e){this.chartContainer.parent!==this.content&&this.content.append(this.chartContainer),this.charts.push(e),this.chartContainer.append(e),e.pane=this},empty:function(){var e,t,n=this,i=this.parent;if(i){for(e=0;e<this.axes.length;e++)i.removeAxis(n.axes[e]);for(t=0;t<this.charts.length;t++)i.removeChart(n.charts[t])}this.axes=[],this.charts=[],this.content.destroy(),this.content.children=[],this.chartContainer.children=[]},reflow:function(e){var t;De(this.children)===this.content&&(t=this.children.pop()),Ne.fn.reflow.call(this,e),t&&this.children.push(t),this.title&&(this.contentBox.y1+=this.title.box.height())},visualStyle:function(){var e=Ne.fn.visualStyle.call(this);return e.zIndex=-10,e},renderComplete:function(){this.options.visible&&this.createGridLines()},stackRoot:function(){return this},clipRoot:function(){return this},createGridLines:function(){var e,t,n,i,o,r,s=this.axes,a=s.concat(this.parent.axes),l=[],c=[];for(e=0;e<s.length;e++)for(t=s[e],n=t.options.vertical,i=n?l:c,o=0;o<a.length;o++)0===i.length&&(r=a[o],n!==r.options.vertical&&ze(i,t.createGridLines(r)))},refresh:function(){this.visual.clear(),this.content.parent=null,this.content.createGradient=this.createGradient.bind(this),this.content.renderVisual(),this.content.parent=this,this.title&&this.visual.append(this.title.visual),this.visual.append(this.content.visual),this.renderComplete()},chartsBox:function(){var e,t,n,i,o,r,s,a,l,c=this.axes,d=c.length,u=new be;for(e=0;e<d;e++)t=c[e],n=t.options.vertical?le:ae,i=t.lineBox(),u[n+1]=i[n+1],u[n+2]=i[n+2];if(0===u.x2)for(o=this.parent.axes,r=o.length,s=0;s<r;s++)a=o[s],a.options.vertical||(l=a.lineBox(),u.x1=l.x1,u.x2=l.x2);return u},clipBox:function(){return this.chartContainer.clipBox}}),Ii=1,Ei.prototype.isStackRoot=!0,ye(Ei,{zIndex:-1,shrinkToFit:!0,title:{align:oe},visible:!0}),Mi=ve.extend({init:function(e,t,n){ve.fn.init.call(this,t),this.initFields(e,t),this.series=e,this.initSeries(),this.charts=[],this.options.legend.items=[],this.axes=[],this.crosshairs=[],this.chartService=n,this.originalOptions=t,this.createPanes(),this.render(),this.createCrosshairs()},initFields:function(){},initSeries:function(){var e,t=this.series;for(e=0;e<t.length;e++)t[e].index=e},createPanes:function(){function e(e,t){Pe(e.title)&&(e.title={text:e.title}),e.title=Te({},t.title,e.title)}var t,n,i,o=this,r={title:{color:(this.options.title||{}).color}},s=[],a=this.options.panes||[],l=Math.max(a.length,1);for(t=0;t<l;t++)n=a[t]||{},e(n,r),i=new Ei(n),i.paneIndex=t,s.push(i),o.append(i);this.panes=s},createCrosshairs:function(e){var t,n,i,o,r,s=this;for(void 0===e&&(e=this.panes),t=0;t<e.length;t++)for(n=e[t],i=0;i<n.axes.length;i++)o=n.axes[i],o.options.crosshair&&o.options.crosshair.visible&&(r=new Di(s.chartService,o,o.options.crosshair),s.crosshairs.push(r),n.content.append(r))},removeCrosshairs:function(e){var t,n,i=this.crosshairs,o=e.axes;for(t=i.length-1;t>=0;t--)for(n=0;n<o.length;n++)if(i[t].axis===o[n]){i.splice(t,1);break}},hideCrosshairs:function(){var e,t=this.crosshairs;for(e=0;e<t.length;e++)t[e].hide()},findPane:function(e){var t,n,i=this.panes;for(n=0;n<i.length;n++)if(i[n].options.name===e){t=i[n];break}return t||i[0]},findPointPane:function(e){var t,n,i=this.panes;for(n=0;n<i.length;n++)if(i[n].box.containsPoint(e)){t=i[n];break}return t},appendAxis:function(e){var t=this.findPane(e.options.pane);t.appendAxis(e),this.axes.push(e),e.plotArea=this},removeAxis:function(e){var t,n,i=this,o=[];for(t=0;t<this.axes.length;t++)n=i.axes[t],e!==n?o.push(n):n.destroy();this.axes=o},appendChart:function(e,t){this.charts.push(e),t?t.appendChart(e):this.append(e)},removeChart:function(e){var t,n,i=this,o=[];for(t=0;t<this.charts.length;t++)n=i.charts[t],n!==e?o.push(n):n.destroy();this.charts=o},addToLegend:function(e){var t,n,i,o,r,s,a,l,c,d=e.length,h=this.options.legend,f=h.labels||{},p=h.inactiveItems||{},m=p.labels||{},g=[];for(t=0;t<d;t++)n=e[t],i=n.visible!==!1,n.visibleInLegend!==!1&&(o=n.name,r=i?Ee(f):Ee(m)||Ee(f),r&&(o=r({text:u(o)?o:"",series:n})),s=n._defaults,a=n.color,xe(a)&&s&&(a=s.color),l=void 0,c=void 0,i?(l={},c=a):(l={color:m.color,font:m.font},c=p.markers.color),u(o)&&""!==o&&g.push({text:o,labels:l,markerColor:c,series:n,active:i}));ze(h.items,g)},groupAxes:function(e){var t,n,i,o,r=[],s=[];for(t=0;t<e.length;t++)for(n=e[t].axes,i=0;i<n.length;i++)o=n[i],o.options.vertical?s.push(o):r.push(o);return{x:r,y:s,any:r.concat(s)}},groupSeriesByPane:function(){var e,t,n,i=this,o=this.series,r={};for(e=0;e<o.length;e++)t=o[e],n=i.seriesPaneName(t),r[n]?r[n].push(t):r[n]=[t];return r},filterVisibleSeries:function(e){var t,n,i=[];for(t=0;t<e.length;t++)n=e[t],n.visible!==!1&&i.push(n);return i},reflow:function(e){var t=this.options.plotArea,n=this.panes,i=Re(t.margin);this.box=e.clone().unpad(i),this.reflowPanes(),this.reflowAxes(n),this.reflowCharts(n)},redraw:function(e){var t,n,i=this,o=[].concat(e);for(this.initSeries(),t=0;t<o.length;t++)i.removeCrosshairs(o[t]),o[t].empty();for(this.render(o),this.reflowAxes(this.panes),this.reflowCharts(o),this.createCrosshairs(o),n=0;n<o.length;n++)o[n].refresh()},axisCrossingValues:function(e,t){var n,i=e.options,o=[].concat(i.axisCrossingValues||i.axisCrossingValue),r=t.length-o.length,s=o[0]||0;for(n=0;n<r;n++)o.push(s);return o},alignAxisTo:function(e,t,n,i){var o=e.getSlot(n,n,!0),r=e.options.reverse?2:1,s=t.getSlot(i,i,!0),a=t.options.reverse?2:1,l=e.box.translate(s[ae+a]-o[ae+r],s[le+a]-o[le+r]);e.pane!==t.pane&&l.translate(0,e.pane.box.y1-t.pane.box.y1),e.reflow(l)},alignAxes:function(e,t){var n,i,o,r,s,a,l,c,d,u,h,f,p,m,g=this,v=e[0],_=t[0],b=this.axisCrossingValues(v,t),w=this.axisCrossingValues(_,e),y={},x={},C={},S={};for(n=0;n<t.length;n++)i=t[n],o=i.pane,r=o.id,s=i.options.visible!==!1,a=k(e,o)||v,l=b,a!==v&&(l=g.axisCrossingValues(a,t)),g.alignAxisTo(i,a,w[n],l[n]),i.options._overlap||(Oe(i.lineBox().x1)===Oe(a.lineBox().x1)&&(y[r]&&i.reflow(i.box.alignTo(y[r].box,oe).translate(-i.options.margin,0)),s&&(y[r]=i)),Oe(i.lineBox().x2)===Oe(a.lineBox().x2)&&(i._mirrored||(i.options.labels.mirror=!i.options.labels.mirror,i._mirrored=!0),g.alignAxisTo(i,a,w[n],l[n]),x[r]&&i.reflow(i.box.alignTo(x[r].box,ce).translate(i.options.margin,0)),s&&(x[r]=i)),0!==n&&_.pane===i.pane&&(i.alignTo(_),i.reflow(i.box)));for(c=0;c<e.length;c++)d=e[c],u=d.pane,h=u.id,f=d.options.visible!==!1,p=k(t,u)||_,m=w,p!==_&&(m=g.axisCrossingValues(p,e)),g.alignAxisTo(d,p,b[c],m[c]),d.options._overlap||(Oe(d.lineBox().y1)===Oe(p.lineBox().y1)&&(d._mirrored||(d.options.labels.mirror=!d.options.labels.mirror,d._mirrored=!0),g.alignAxisTo(d,p,b[c],m[c]),C[h]&&d.reflow(d.box.alignTo(C[h].box,ne).translate(0,-d.options.margin)),f&&(C[h]=d)),Oe(d.lineBox().y2,X.COORD_PRECISION)===Oe(p.lineBox().y2,X.COORD_PRECISION)&&(S[h]&&d.reflow(d.box.alignTo(S[h].box,ie).translate(0,d.options.margin)),f&&(S[h]=d)),0!==c&&(d.alignTo(v),d.reflow(d.box)))},shrinkAxisWidth:function(e){var t,n,i,o,r=this.groupAxes(e).any,s=y(r),a=0;for(t=0;t<e.length;t++)n=e[t],n.axes.length>0&&(a=Math.max(a,s.width()-n.contentBox.width()));if(0!==a)for(i=0;i<r.length;i++)o=r[i],o.options.vertical||o.reflow(o.box.shrink(a,0))},shrinkAxisHeight:function(e){var t,n,i,o,r,s,a;for(n=0;n<e.length;n++)if(i=e[n],o=i.axes,r=Math.max(0,y(o).height()-i.contentBox.height()),0!==r){for(s=0;s<o.length;s++)a=o[s],a.options.vertical&&a.reflow(a.box.shrink(0,r));t=!0}return t},fitAxes:function(e){var t,n,i,o,r,s,a,l,c,d,u=this.groupAxes(e).any,h=0;for(t=0;t<e.length;t++)if(n=e[t],i=n.axes,o=n.contentBox,i.length>0)for(r=y(i),s=Math.max(o.y1-r.y1,o.y2-r.y2),h=Math.max(h,o.x1-r.x1),a=0;a<i.length;a++)l=i[a],l.reflow(l.box.translate(0,s));for(c=0;c<u.length;c++)d=u[c],d.reflow(d.box.translate(h,0))},reflowAxes:function(e){var t,n=this,i=this.groupAxes(e);for(t=0;t<e.length;t++)n.reflowPaneAxes(e[t]);i.x.length>0&&i.y.length>0&&(this.alignAxes(i.x,i.y),this.shrinkAxisWidth(e),this.autoRotateAxisLabels(i),this.alignAxes(i.x,i.y),this.shrinkAxisWidth(e)&&this.alignAxes(i.x,i.y),this.shrinkAxisHeight(e),this.alignAxes(i.x,i.y),this.shrinkAxisHeight(e)&&this.alignAxes(i.x,i.y),this.fitAxes(e))},autoRotateAxisLabels:function(e){var t,n,i,o,r=this,s=this,a=s.axes,l=s.panes;for(n=0;n<a.length;n++)i=a[n],i.autoRotateLabels()&&(t=!0);if(t){for(o=0;o<l.length;o++)r.reflowPaneAxes(l[o]);e.x.length>0&&e.y.length>0&&(this.alignAxes(e.x,e.y),this.shrinkAxisWidth(l))}},reflowPaneAxes:function(e){var t,n=e.axes,i=n.length;if(i>0)for(t=0;t<i;t++)n[t].reflow(e.contentBox)},reflowCharts:function(e){var t,n,i=this.charts,o=i.length,r=this.box;for(t=0;t<o;t++)n=i[t].pane,n&&!ke(n,e)||i[t].reflow(r)},reflowPanes:function(){var e,t,n,i,o,r,s,a,l,c=this,d=c.box,u=c.panes,h=u.length,f=d.height(),p=h,m=0,g=d.y1;for(e=0;e<h;e++)t=u[e],n=t.options.height,t.options.width=d.width(),t.options.height?(n.indexOf&&n.indexOf("%")&&(i=parseInt(n,10)/100,t.options.height=i*d.height()),t.reflow(d.clone()),f-=t.options.height):m++;for(o=0;o<h;o++)r=u[o],r.options.height||(r.options.height=f/m);for(s=0;s<h;s++)a=u[s],l=d.clone().move(d.x1,g),a.reflow(l),p--,g+=a.options.height},backgroundBox:function(){var e,t,n,i,o,r,s=this.axes,a=s.length;for(t=0;t<a;t++)for(n=s[t],i=0;i<a;i++)o=s[i],n.options.vertical!==o.options.vertical&&(r=n.lineBox().clone().wrap(o.lineBox()),e=e?e.wrap(r):r);return e||this.box},chartsBoxes:function(){var e,t=this.panes,n=[];for(e=0;e<t.length;e++)n.push(t[e].chartsBox());return n},addBackgroundPaths:function(e){var t,n=this.chartsBoxes();for(t=0;t<n.length;t++)e.paths.push(Xe.fromRect(n[t].toRect()))},backgroundContainsPoint:function(e){var t,n=this.chartsBoxes();for(t=0;t<n.length;t++)if(n[t].containsPoint(e))return!0},createVisual:function(){var e,t,n,i,o;ve.fn.createVisual.call(this),e=this.options.plotArea,t=e.opacity,n=e.background,i=e.border,void 0===i&&(i={}),x(n)&&(n=re,t=0),o=this._bgVisual=new Qe.MultiPath({fill:{color:n,opacity:t},stroke:{color:i.width?i.color:"",width:i.width,dashType:i.dashType},zIndex:-1}),this.addBackgroundPaths(o),this.appendVisual(o)},pointsByCategoryIndex:function(e){var t,n,i,o,r,s=this.charts,a=[];if(null!==e)for(t=0;t<s.length;t++)if(n=s[t],"_navigator"!==n.pane.options.name&&(i=s[t].categoryPoints[e],i&&i.length))for(o=0;o<i.length;o++)r=i[o],r&&pe(r.value)&&null!==r.value&&a.push(r);return a},pointsBySeriesIndex:function(e){return this.filterPoints(function(t){return t.series.index===e})},pointsBySeriesName:function(e){return this.filterPoints(function(t){return t.series.name===e})},filterPoints:function(e){var t,n,i,o,r,s=this.charts,a=[];for(t=0;t<s.length;t++)for(n=s[t],i=n.points,o=0;o<i.length;o++)r=i[o],r&&r.visible!==!1&&e(r)&&a.push(r);return a},findPoint:function(e){var t,n,i,o,r,s=this.charts;for(t=0;t<s.length;t++)for(n=s[t],i=n.points,o=0;o<i.length;o++)if(r=i[o],r&&r.visible!==!1&&e(r))return r},paneByPoint:function(e){var t,n,i=this.panes;for(t=0;t<i.length;t++)if(n=i[t],n.box.containsPoint(e))return n}}),ye(Mi,{series:[],plotArea:{margin:{}},background:"",border:{color:de,width:0},legend:{inactiveItems:{labels:{color:"#919191"},markers:{color:"#919191"}}}}),Ri={hover:function(e,t){this._dispatchEvent(e,t,bn)},click:function(e,t){this._dispatchEvent(e,t,_n)}},Fi=Y.extend({init:function(e,t,n){var i,o,r,s=t.canonicalFields(e),a=t.valueFields(e),l=t.sourceFields(e,s),c=this._seriesFields=[],d=n.query(e.type),u=e.aggregate||d;for(this._series=e,this._binder=t,i=0;i<s.length;i++){if(o=s[i],r=void 0,Se(u))r=u[o];else{if(0!==i&&!ke(o,a))break;r=u}r&&c.push({canonicalName:o,name:l[i],transform:xe(r)?r:lt[r]})}},aggregatePoints:function(e,t){var n,i,o,r,s,a=this,l=this,c=l._series,d=l._seriesFields,u=this._bindPoints(e||[]),h=u.dataItems[0],f={};for(!h||Q(h)||ge(h)||(n=function(){},n.prototype=h,f=new n),i=0;i<d.length;i++){if(o=d[i],r=a._bindField(u.values,o.canonicalName),s=o.transform(r,c,u.dataItems,t),!(null===s||!Se(s)||pe(s.length)||s instanceof Date)){f=s;break}pe(s)&&C(o.name,f,s)}return f},_bindPoints:function(e){var t,n,i=this,o=i._binder,r=i._series,s=[],a=[];for(t=0;t<e.length;t++)n=e[t],s.push(o.bindPoint(r,n)),a.push(r.data[n]);return{values:s,dataItems:a}},_bindField:function(e,t){var n,i,o,r,s=[],a=e.length;for(n=0;n<a;n++)i=e[n],o=i.valueFields,r=void 0,r=pe(o[t])?o[t]:i.fields[t],s.push(r);return s}}),zi=Y.extend({init:function(){this._defaults={}},register:function(e,t){var n,i=this;for(n=0;n<e.length;n++)i._defaults[e[n]]=t},query:function(e){return this._defaults[e]}}),zi.current=new zi,Pi=ci.extend({createLabel:function(){var e=this.options.labels,t=Te({},e,e.from),n=Te({},e,e.to);t.visible&&(this.labelFrom=this._createLabel(t),this.append(this.labelFrom)),n.visible&&(this.labelTo=this._createLabel(n),this.append(this.labelTo))},_createLabel:function(e){var t,n=Ee(e);return t=n?n({dataItem:this.dataItem,category:this.category,value:this.value,percentage:this.percentage,runningTotal:this.runningTotal,total:this.total,series:this.series}):this.formatValue(e.format),new ai(t,Te({vertical:this.options.vertical},e))},reflow:function(e){var t,n,i,o;this.render(),t=this,n=t.labelFrom,i=t.labelTo,o=t.value,this.box=e,n&&(n.options.aboveAxis=o.from>o.to,n.reflow(e)),i&&(i.options.aboveAxis=o.to>o.from,i.reflow(e)),this.note&&this.note.reflow(e)}}),Pi.prototype.defaults=Te({},Pi.prototype.defaults,{labels:{format:"{0} - {1}"},tooltip:{format:"{1}"}}),Bi=hi.extend({pointType:function(){return Pi},pointValue:function(e){return e.valueFields},formatPointValue:function(e,t){return null===e.value.from&&null===e.value.to?"":this.chartService.format.auto(t,e.value.from,e.value.to)},plotRange:function(e){return e?[e.value.from,e.value.to]:0},updateRange:function(e,t){var n=t.series.axis,i=e.from,o=e.to,r=this.valueAxisRanges[n];null!==e&&Q(i)&&Q(o)&&(r=this.valueAxisRanges[n]=r||{min:Z,max:J},r.min=Math.min(r.min,i),r.max=Math.max(r.max,i),r.min=Math.min(r.min,o),r.max=Math.max(r.max,o))},aboveAxis:function(e){var t=e.value;return t.from<t.to}}),Bi.prototype.plotLimits=jn.prototype.plotLimits,Li=$n.extend({aliasFor:function(){return this.parent}}),Hi="auto",Ni="{0}",Oi="{1}",Vi=ve.extend({init:function(e,t){ve.fn.init.call(this),this.value=e,this.options=t,this.aboveAxis=Ce(this.options.aboveAxis,!0),this.tooltipTracking=!0,this.initLabelsFormat()},render:function(){var e,t,n,i,o,r;this._rendered||(this._rendered=!0,e=this.options,t=e.markers,n=e.labels,i=this.value,o=this.fromPoint=new Li(i,Te({},this.options,{labels:n.from,markers:t.from})),r=this.toPoint=new Li(i,Te({},this.options,{labels:n.to,markers:t.to})),this.copyFields(o),this.copyFields(r),this.append(o),this.append(r))},reflow:function(e){var t,n;this.render(),t=e.from,n=e.to,this.positionLabels(t,n),this.fromPoint.reflow(t),this.toPoint.reflow(n),this.box=this.fromPoint.markerBox().clone().wrap(this.toPoint.markerBox())},createHighlight:function(){var e=new et;return e.append(this.fromPoint.createHighlight()),e.append(this.toPoint.createHighlight()),e},highlightVisual:function(){return this.visual},highlightVisualArgs:function(){return{options:this.options,from:this.fromPoint.highlightVisualArgs(),to:this.toPoint.highlightVisualArgs()}},tooltipAnchor:function(){var e,t,n,i,o,r,s=this.owner.pane.clipBox(),a=!s||s.overlaps(this.box);if(a)return e=this.box,t=e.center(),n=oe,this.options.vertical?(i=t.x,o=e.y1-wt,r=ie):(i=e.x2+wt,o=t.y,r=te),{point:new _e(i,o),align:{horizontal:n,vertical:r}}},formatValue:function(e){return this.owner.formatPointValue(this,e)},overlapsBox:function(e){return this.box.overlaps(e)},unclipElements:function(){this.fromPoint.unclipElements(),this.toPoint.unclipElements()},initLabelsFormat:function(){var t=this.options.labels;t.format||(t.from&&t.from.format||(t.from=e.extend({},t.from,{format:Ni})),t.to&&t.to.format||(t.to=e.extend({},t.to,{format:Oi})))},positionLabels:function(e,t){var n,i,o=this.options,r=o.labels,s=o.vertical;r.position===Hi&&(s?t.y1<=e.y1?(i=Rt,n=Ft):(i=Ft,n=Rt):t.x1<=e.x1?(i=oe,n=ce):(i=ce,n=oe),r.from&&r.from.position||(this.fromPoint.options.labels.position=n),r.to&&r.to.position||(this.toPoint.options.labels.position=i))},copyFields:function(e){e.dataItem=this.dataItem,e.category=this.category,e.series=this.series,e.color=this.color,e.owner=this.owner}}),Te(Vi.prototype,qn),Te(Vi.prototype,Gn),Vi.prototype.defaults={markers:{visible:!1,background:re,size:At,type:se,border:{width:2},opacity:1},labels:{visible:!1,margin:Re(3),padding:Re(4),animation:{type:vt,delay:gt},position:Hi},notes:{label:{}},highlight:{markers:{border:{color:re,width:2}},zIndex:X.HIGHLIGHT_ZINDEX},tooltip:{format:"{0} - {1}"}},Ui=ni.extend({createStrokeSegments:function(){return this.segmentsFromPoints(this.toGeometryPoints(this.toPoints()))},stackSegments:function(){var e=this.fromSegments;return this.fromSegments||(e=this.fromSegments=this.segmentsFromPoints(this.toGeometryPoints(this.fromPoints().reverse()))),e},createStroke:function(e){var t=new Xe(e),n=new Xe(e);t.segments.push.apply(t.segments,this.strokeSegments()),n.segments.push.apply(n.segments,this.stackSegments()),this.visual.append(t),this.visual.append(n)},hasStackSegment:function(){return!0},fromPoints:function(){return this.linePoints.map(function(e){return e.fromPoint})},toPoints:function(){return this.linePoints.map(function(e){return e.toPoint})}}),Wi=Ui.extend({createStrokeSegments:function(){return this.createCurveSegments(this.toPoints())},stackSegments:function(){var e=this.fromSegments;return this.fromSegments||(e=this.fromSegments=this.createCurveSegments(this.fromPoints().reverse())),e},createCurveSegments:function(e){var t=new Fe;return t.process(this.toGeometryPoints(e))}}),ji=Ui.extend({createStrokeSegments:function(){return this.segmentsFromPoints(this.calculateStepPoints(this.toPoints()))},stackSegments:function(){var e=this.fromSegments;return this.fromSegments||(e=this.fromSegments=this.segmentsFromPoints(this.calculateStepPoints(this.fromPoints())),e.reverse()),e}}),Te(ji.prototype,Yn),qi=jn.extend({render:function(){jn.fn.render.call(this),this.renderSegments()},pointType:function(){return Vi},createPoint:function(e,t){var n,i,o,r=t.categoryIx,s=t.category,a=t.series,l=t.seriesIx,c=e.valueFields;if(!u(c.from)&&!u(c.to)){if(this.seriesMissingValues(a)!==Et)return null;c={from:0,to:0}}return n=this.pointOptions(a,l),n=this.evalPointOptions(n,c,s,r,a,l),i=e.fields.color||a.color,xe(a.color)&&(i=n.color),o=new Vi(c,n),o.color=i,this.append(o),o},createSegment:function(e,t,n){var i,o=(t.line||{}).style;return new(i="smooth"===o?Wi:"step"===o?ji:Ui)(e,t,n)},plotRange:function(e,t){return e?[e.value.from,e.value.to]:[t,t]},valueSlot:function(e,t){var n=e.getSlot(t[0],t[0],!this.options.clip),i=e.getSlot(t[1],t[1],!this.options.clip);if(n&&i)return{from:n,to:i}},pointSlot:function(e,t){var n,i,o=t.from,r=t.to;return this.options.invertAxes?(n=new be(o.x1,e.y1,o.x2,e.y2),i=new be(r.x1,e.y1,r.x2,e.y2)):(n=new be(e.x1,o.y1,e.x2,o.y2),i=new be(e.x1,r.y1,e.x2,r.y2)),{from:n,to:i}},addValue:function(e,t){var n=e.valueFields;Q(n.from)||(n.from=n.to),Q(n.to)||(n.to=n.from),jn.fn.addValue.call(this,e,t)},updateRange:function(e,t){var n,i,o,r;null!==e&&Q(e.from)&&Q(e.to)&&(n=t.series.axis,i=this.valueAxisRanges[n]=this.valueAxisRanges[n]||{min:Z,max:J},o=e.from,r=e.to,i.min=Math.min(i.min,o,r),i.max=Math.max(i.max,o,r))},formatPointValue:function(e,t){var n=e.value;return this.chartService.format.auto(t,n.from,n.to)},animationPoints:function(){var e,t,n=this.points,i=[];for(e=0;e<n.length;e++)t=n[e],t&&(i.push((t.fromPoint||{}).marker),i.push((t.toPoint||{}).marker));return i.concat(this._segments)}}),Te(qi.prototype,Zn,ei),Gi=fi.extend({reflow:function(e){var t,n=this,i=n.options,o=n.value,r=n.owner,s=r.seriesValueAxis(i),a=[],l=[],c=[],d=s.getSlot(o.low,o.high),u=s.getSlot(o.open,o.open),h=s.getSlot(o.close,o.close);u.x1=h.x1=d.x1=e.x1,u.x2=h.x2=d.x2=e.x2,t=d.center().x,a.push([u.x1,u.y1]),a.push([t,u.y1]),l.push([t,h.y1]),l.push([h.x2,h.y1]),c.push([t,d.y1]),c.push([t,d.y2]),this.lines=[a,l,c],this.box=d.clone().wrap(u.clone().wrap(h)),this.reflowNote()},createBody:function(){}}),$i=pi.extend({pointType:function(){return Gi}}),Ki=ve.extend({init:function(e,t,n){ve.fn.init.call(this),this.from=e,this.to=t,this.series=n},linePoints:function(){var e,t,n=this.from,i=this,o=i.from.box,r=i.to.box,s=[];return n.isVertical?(e=n.aboveAxis?o.y1:o.y2,s.push([o.x1,e],[r.x2,e])):(t=n.aboveAxis?o.x2:o.x1,s.push([t,o.y1],[t,r.y2])),s},createVisual:function(){var e,t;ve.fn.createVisual.call(this),e=this.series.line||{},t=Xe.fromPoints(this.linePoints(),{stroke:{color:e.color,width:e.width,opacity:e.opacity,dashType:e.dashType}}),we(t),this.visual.append(t)}}),ye(Ki,{animation:{type:vt,delay:gt}}),Yi=hi.extend({render:function(){hi.fn.render.call(this),this.createSegments()},traverseDataPoints:function(e){var t,n,i,r,s,a,l,c,d,u,h=this.options.series,f=this.categoryAxis.options.categories||[],p=o(h),m=!this.options.invertAxes;for(t=0;t<h.length;t++)for(n=h[t],i=0,r=0,s=0;s<p;s++)a=ct.current.bindPoint(n,s),l=a.valueFields.value,c=a.fields.summary,d=i,u=void 0,c?"total"===c.toLowerCase()?(a.valueFields.value=i,d=0,u=i):(a.valueFields.value=r,u=d-r,r=0):Q(l)&&(r+=l,i+=l,u=i),e(a,{category:f[s],categoryIx:s,series:n,seriesIx:t,total:i,runningTotal:r,from:d,to:u,isVertical:m})},updateRange:function(e,t){hi.fn.updateRange.call(this,{value:t.to},t)},aboveAxis:function(e){return e.value>=0},plotRange:function(e){return[e.from,e.to]},createSegments:function(){var e,t,n,i,o,r,s,a=this,l=this.options.series,c=this.seriesPoints,d=this.segments=[];for(e=0;e<l.length;e++)if(t=l[e],n=c[e])for(i=void 0,o=0;o<n.length;o++)r=n[o],r&&i&&(s=new Ki(i,r,t),d.push(s),a.append(s)),i=r}}),Qi=[Bt,an,tn,un],Xi=[Gt,dn].concat(Qi),Zi=Mi.extend({initFields:function(e){var t,n,i=this;if(this.namedCategoryAxes={},this.namedValueAxes={},this.valueAxisRangeTracker=new si,e.length>0)for(this.invertAxes=ke(e[0].type,[Lt,Ot,dn,an,un,nn,qt,ln]),t=0;t<e.length;t++)if(n=e[t].stack,n&&"100%"===n.type){i.stack100=!0;break}},render:function(e){void 0===e&&(e=this.panes),this.createCategoryAxes(e),this.aggregateCategories(e),this.createCategoryAxesLabels(e),this.createCharts(e),this.createValueAxes(e)},removeAxis:function(e){var t=e.options.name;Mi.fn.removeAxis.call(this,e),e instanceof He?delete this.namedCategoryAxes[t]:(this.valueAxisRangeTracker.reset(t),delete this.namedValueAxes[t]),e===this.categoryAxis&&delete this.categoryAxis,e===this.valueAxis&&delete this.valueAxis},createCharts:function(e){var t,n,i,o,r,s,a=this,l=this.groupSeriesByPane();for(t=0;t<e.length;t++)if(n=e[t],i=l[n.options.name||"default"]||[],a.addToLegend(i),o=a.filterVisibleSeries(i))for(r=a.groupSeriesByCategoryAxis(o),s=0;s<r.length;s++)a.createChartGroup(r[s],n)},createChartGroup:function(e,t){this.createAreaChart(v(e,[Bt,an]),t),this.createRangeAreaChart(v(e,[tn,un]),t),this.createBarChart(v(e,[Ut,Lt]),t),this.createRangeBarChart(v(e,[on,nn]),t),this.createBulletChart(v(e,[Ot,cn]),t),this.createCandlestickChart(v(e,Vt),t),this.createBoxPlotChart(v(e,[Ht,ln]),t),this.createOHLCChart(v(e,$t),t),this.createWaterfallChart(v(e,[hn,qt]),t),this.createLineChart(v(e,[Gt,dn]),t)},aggregateCategories:function(e){var t,n,i,o,r,s=this,a=this.srcSeries||this.series,l=[];for(t=0;t<a.length;t++)n=a[t],i=s.seriesCategoryAxis(n),o=s.findPane(i.options.pane),r=g(i.options.type,ue),(r||n.categoryField)&&ke(o,e)?n=s.aggregateSeries(n,i):(Q(i.options.min)||Q(i.options.max))&&(n=s.filterSeries(n,i)),l.push(n);this.srcSeries=a,this.series=l},filterSeries:function(e,t){var n,i,o,r=t.totalRangeIndices(),s=t.options.justified,a=ke(e.type,Xi);return r.min=Q(t.options.min)?Math.floor(r.min):0,r.max=Q(t.options.max)?s?Math.floor(r.max)+1:Math.ceil(r.max):e.data.length,n=Te({},e),a&&(i=r.min-1,o=t.options.srcCategories||[],i>=0&&i<n.data.length&&(n._outOfRangeMinPoint={item:n.data[i],category:o[i],categoryIx:-1}),r.max<n.data.length&&(n._outOfRangeMaxPoint={item:n.data[r.max],category:o[r.max],categoryIx:r.max-r.min})),t._seriesMax=Math.max(t._seriesMax||0,n.data.length),n.data=(n.data||[]).slice(r.min,r.max),n},aggregateSeries:function(e,t){var i,o,r,s,a,l,c,d,u,h,f,p,m,v,b,w,y,k=this,x=ke(e.type,Xi),C=t.options,S=C.categories,T=C.srcCategories;for(void 0===T&&(T=S),i=C.dataItems,void 0===i&&(i=[]),o=g(t.options.type,ue),r=Te({},e),s=Te({},e),a=e.data,l=[],c=J,d=Z,u=n,o&&(u=_),p=0;p<a.length;p++)m=void 0,m=e.categoryField?u(e.categoryField,a[p],k.chartService.intl):T[p],pe(m)&&(v=t.categoryIndex(m),0<=v&&v<S.length?(l[v]=l[v]||[],l[v].push(p)):x&&(v<0?v===c?h.points.push(p):v>c&&(c=v,h={category:m,points:[p]}):v>=S.length&&(v===d?f.points.push(p):v<d&&(d=v,f={category:m,points:[p]
}))));for(b=new Fi(r,ct.current,zi.current),w=s.data=[],y=0;y<S.length;y++)w[y]=b.aggregatePoints(l[y],S[y]),l[y]&&(i[y]=w[y]);return h&&w.length&&(s._outOfRangeMinPoint={item:b.aggregatePoints(h.points,h.category),categoryIx:c,category:h.category}),f&&w.length&&(s._outOfRangeMaxPoint={item:b.aggregatePoints(f.points,f.category),categoryIx:d,category:f.category}),t.options.dataItems=i,s},appendChart:function(e,t){for(var n=e.options.series,i=this.seriesCategoryAxis(n[0]),r=i.options.categories,s=Math.max(0,o(n)-r.length);s--;)r.push("");this.valueAxisRangeTracker.update(e.valueAxisRanges),Mi.fn.appendChart.call(this,e,t)},seriesPaneName:function(e){var t=this.options,n=e.axis,i=[].concat(t.valueAxis),o=Ve(i,function(e){return e.name===n})[0],r=t.panes||[{}],s=(r[0]||{}).name||"default",a=(o||{}).pane||s;return a},seriesCategoryAxis:function(e){var t=e.categoryAxis,n=t?this.namedCategoryAxes[t]:this.categoryAxis;if(!n)throw Error("Unable to locate category axis with name "+t);return n},stackableChartOptions:function(e,t){var n=e.stack,i=n&&"100%"===n.type,o=t.options.clip;return{isStacked:n,isStacked100:i,clip:o}},groupSeriesByCategoryAxis:function(e){var t,n,i,o,r,s,a=[],l={};for(t=0;t<e.length;t++)n=e[t].categoryAxis||"$$default$$",l.hasOwnProperty(n)||(l[n]=!0,a.push(n));for(i=[],o=0;o<a.length;o++)r=a[o],s=D(e,r,o),0!==s.length&&i.push(s);return i},createBarChart:function(t,n){var i,o;0!==t.length&&(i=t[0],o=new hi(this,e.extend({series:t,invertAxes:this.invertAxes,gap:i.gap,spacing:i.spacing},this.stackableChartOptions(i,n))),this.appendChart(o,n))},createRangeBarChart:function(e,t){var n,i;0!==e.length&&(n=e[0],i=new Bi(this,{series:e,invertAxes:this.invertAxes,gap:n.gap,spacing:n.spacing}),this.appendChart(i,t))},createBulletChart:function(e,t){var n,i;0!==e.length&&(n=e[0],i=new Ci(this,{series:e,invertAxes:this.invertAxes,gap:n.gap,spacing:n.spacing,clip:t.options.clip}),this.appendChart(i,t))},createLineChart:function(t,n){var i,o;0!==t.length&&(i=t[0],o=new ti(this,e.extend({invertAxes:this.invertAxes,series:t},this.stackableChartOptions(i,n))),this.appendChart(o,n))},createAreaChart:function(t,n){var i,o;0!==t.length&&(i=t[0],o=new ri(this,e.extend({invertAxes:this.invertAxes,series:t},this.stackableChartOptions(i,n))),this.appendChart(o,n))},createRangeAreaChart:function(e,t){if(0!==e.length){var n=new qi(this,{invertAxes:this.invertAxes,series:e,clip:t.options.clip});this.appendChart(n,t)}},createOHLCChart:function(e,t){var n,i;0!==e.length&&(n=e[0],i=new $i(this,{invertAxes:this.invertAxes,gap:n.gap,series:e,spacing:n.spacing,clip:t.options.clip}),this.appendChart(i,t))},createCandlestickChart:function(e,t){var n,i;0!==e.length&&(n=e[0],i=new pi(this,{invertAxes:this.invertAxes,gap:n.gap,series:e,spacing:n.spacing,clip:t.options.clip}),this.appendChart(i,t))},createBoxPlotChart:function(e,t){var n,i;0!==e.length&&(n=e[0],i=new vi(this,{invertAxes:this.invertAxes,gap:n.gap,series:e,spacing:n.spacing,clip:t.options.clip}),this.appendChart(i,t))},createWaterfallChart:function(e,t){var n,i;0!==e.length&&(n=e[0],i=new Yi(this,{series:e,invertAxes:this.invertAxes,gap:n.gap,spacing:n.spacing}),this.appendChart(i,t))},axisRequiresRounding:function(e,t){var n,i,o,r,s,a=this,l=v(this.series,fn);for(n=0;n<this.series.length;n++)i=a.series[n],ke(i.type,Qi)&&(o=i.line,o&&o.style===Pt&&l.push(i));for(r=0;r<l.length;r++)if(s=l[r].categoryAxis||"",s===e||!s&&0===t)return!0},aggregatedAxis:function(e,t){var n,i,o=this.series;for(n=0;n<o.length;n++)if(i=o[n].categoryAxis||"",(i===e||!i&&0===t)&&o[n].categoryField)return!0},createCategoryAxesLabels:function(){var e,t=this.axes;for(e=0;e<t.length;e++)t[e]instanceof He&&t[e].createLabels()},createCategoryAxes:function(e){var t,n,i,o,r,s,a,l=this,c=this.invertAxes,d=[].concat(this.options.categoryAxis),u=[];for(t=0;t<d.length;t++)if(n=d[t],i=l.findPane(n.pane),ke(i,e)){if(o=n.name,r=n.categories,void 0===r&&(r=[]),n=Te({vertical:c,reverse:!c&&l.chartService.rtl,axisCrossingValue:c?Z:0},n),pe(n.justified)||(n.justified=l.isJustified()),l.axisRequiresRounding(o,t)&&(n.justified=!1),s=void 0,s=b(n,r[0])?new Ue(n,l.chartService):new He(n,l.chartService),o){if(l.namedCategoryAxes[o])throw Error("Category axis with name "+o+" is already defined");l.namedCategoryAxes[o]=s}s.axisIndex=t,u.push(s),l.appendAxis(s)}a=this.categoryAxis||u[0],this.categoryAxis=a,c?this.axisY=a:this.axisX=a},isJustified:function(){var e,t,n=this.series;for(e=0;e<n.length;e++)if(t=n[e],!ke(t.type,Qi))return!1;return!0},createValueAxes:function(e){var t,n,i,o,r,s,a,l,c,d=this,u=this.valueAxisRangeTracker,h=u.query(),f=[].concat(this.options.valueAxis),p=this.invertAxes,m={vertical:!p,reverse:p&&this.chartService.rtl},v=[];for(this.stack100&&(m.roundToMajorUnit=!1,m.labels={format:"P0"}),t=0;t<f.length;t++)if(n=f[t],i=d.findPane(n.pane),ke(i,e)){if(o=n.name,r=g(n.type,Rn)?{min:.1,max:1}:{min:0,max:1},s=u.query(o)||h||r,0===t&&s&&h&&(s.min=Math.min(s.min,h.min),s.max=Math.max(s.max,h.max)),a=void 0,a=g(n.type,Rn)?K.LogarithmicAxis:K.NumericAxis,l=new a(s.min,s.max,Te({},m,n),d.chartService),o){if(d.namedValueAxes[o])throw Error("Value axis with name "+o+" is already defined");d.namedValueAxes[o]=l}l.axisIndex=t,v.push(l),d.appendAxis(l)}c=this.valueAxis||v[0],this.valueAxis=c,p?this.axisX=c:this.axisY=c},_dispatchEvent:function(e,t,n){var i,o,r,s=e._eventCoordinates(t),a=new _e(s.x,s.y),l=this.pointPane(a),c=[],d=[];if(l){for(i=l.axes,o=0;o<i.length;o++)r=i[o],r.getValue?S(d,r.getValue(a)):S(c,r.getCategory(a));0===c.length&&S(c,this.categoryAxis.getCategory(a)),c.length>0&&d.length>0&&e.trigger(n,{element:Ae(t),originalEvent:t,category:w(c),value:w(d)})}},pointPane:function(e){var t,n,i=this.panes;for(t=0;t<i.length;t++)if(n=i[t],n.contentBox.containsPoint(e))return n},updateAxisOptions:function(e,t){T(this.options,e,t),T(this.originalOptions,e,t)}}),ye(Zi,{categoryAxis:{categories:[]},valueAxis:{}}),Te(Zi.prototype,Ri),Ji=Y.extend({init:function(){this._points=[]},destroy:function(){this._points=[]},show:function(e){var t,n,i=this,o=[].concat(e);for(this.hide(),t=0;t<o.length;t++)n=o[t],n&&n.toggleHighlight&&n.hasHighlight()&&(i.togglePointHighlight(n,!0),i._points.push(n))},togglePointHighlight:function(e,t){var n,i=(e.options.highlight||{}).toggle;i?(n={category:e.category,series:e.series,dataItem:e.dataItem,value:e.value,stackValue:e.stackValue,preventDefault:A,visual:e.highlightVisual(),show:t},i(n),n._defaultPrevented||e.toggleHighlight(t)):e.toggleHighlight(t)},hide:function(){for(var e=this,t=this._points;t.length;)e.togglePointHighlight(t.pop(),!1)},isHighlighted:function(e){var t,n,i=this._points;for(t=0;t<i.length;t++)if(n=i[t],e===n)return!0;return!1}}),eo=Y.extend({init:function(e,t){this.plotArea=e,this.options=Te({},this.options,t)},start:function(e){return this._active=E(e,this.options.key)},move:function(e){if(this._active){var t=this.axisRanges=this._panAxes(e,ae).concat(this._panAxes(e,le));if(t.length)return this.axisRanges=t,I(t)}},end:function(){var e=this._active;return this._active=!1,e},pan:function(){var e,t,n=this,i=n.plotArea,o=n.axisRanges;if(o.length){for(e=0;e<o.length;e++)t=o[e],i.updateAxisOptions(t.axis,t.range);i.redraw(i.panes)}},destroy:function(){delete this.plotArea},_panAxes:function(e,t){var n,i,o,r,s=this.plotArea,a=-e[t].delta,l=(this.options.lock||"").toLowerCase(),c=[];if(0!==a&&(l||"").toLowerCase()!==t)for(n=s.axes,i=0;i<n.length;i++)o=n[i],(t===ae&&!o.options.vertical||t===le&&o.options.vertical)&&(r=o.pan(a),r&&(r.limitRange=!0,c.push({axis:o,range:r})));return c}}),eo.prototype.options={key:"none",lock:"none"},to=Y.extend({init:function(e,t){this.chart=e,this.options=Te({},this.options,t),this.createElement()},createElement:function(){var e,t=this._marquee=document.createElement("div");t.className="k-marquee",e=document.createElement("div"),e.className="k-marquee-color",t.appendChild(e)},removeElement:function(){this._marquee.parentNode&&this._marquee.parentNode.removeChild(this._marquee)},setStyles:function(e){We(this._marquee,e)},start:function(e){var t,n,i,o,r;return!!(E(e,this.options.key)&&(t=this.chart,n=t._eventCoordinates(e),i=this._zoomPane=t._plotArea.paneByPoint(n),i&&i.clipBox()))&&(o=i.clipBox().clone(),r=this._elementOffset(),o.translate(r.left,r.top),this._zoomPaneClipBox=o,document.body.appendChild(this._marquee),this.setStyles({left:e.pageX+1,top:e.pageY+1,width:0,height:0}),!0)},_elementOffset:function(){var e=this.chart.element,t=We(e,["paddingLeft","paddingTop"]),n=t.paddingLeft,i=t.paddingTop,o=K.elementOffset(e);return{left:n+o.left,top:i+o.top}},move:function(e){var t=this._zoomPane;t&&this.setStyles(this._selectionPosition(e))},end:function(e){var t,n,i,o,r=this._zoomPane;if(r)return t=this._elementOffset(),n=this._selectionPosition(e),n.left-=t.left,n.top-=t.top,i={x:n.left,y:n.top},o={x:n.left+n.width,y:n.top+n.height},this._updateAxisRanges(i,o),this.removeElement(),delete this._zoomPane,I(this.axisRanges)},zoom:function(){var e,t,n,i=this.axisRanges;if(i&&i.length){for(e=this.chart._plotArea,t=0;t<i.length;t++)n=i[t],e.updateAxisOptions(n.axis,n.range);e.redraw(e.panes)}},destroy:function(){this.removeElement(),delete this._marquee,delete this.chart},_updateAxisRanges:function(e,t){var n,i,o,r,s=(this.options.lock||"").toLowerCase(),a=[],l=this._zoomPane.axes;for(n=0;n<l.length;n++)i=l[n],o=i.options.vertical,s===ae&&!o||s===le&&o||(r=i.pointsRange(e,t),r&&a.push({axis:i,range:r}));this.axisRanges=a},_selectionPosition:function(e){var t=this._zoomPaneClipBox,n={x:e.x.startLocation,y:e.y.startLocation},i=e.x.location,o=e.y.location,r=(this.options.lock||"").toLowerCase(),s=Math.min(n.x,i),a=Math.min(n.y,o),l=Math.abs(n.x-i),c=Math.abs(n.y-o);return r===ae&&(s=t.x1,l=t.width()),r===le&&(a=t.y1,c=t.height()),i>t.x2&&(l=t.x2-n.x),i<t.x1&&(l=n.x-t.x1),o>t.y2&&(c=t.y2-n.y),o<t.y1&&(c=n.y-t.y1),{left:Math.max(s,t.x1),top:Math.max(a,t.y1),width:l,height:c}}}),to.prototype.options={key:"shift",lock:"none"},no=Y.extend({init:function(e,t){this.chart=e,this.options=Te({},this.options,t)},updateRanges:function(e){var t,n,i,o,r=(this.options.lock||"").toLowerCase(),s=[],a=this.chart._plotArea.axes;for(t=0;t<a.length;t++)n=a[t],i=n.options.vertical,r===ae&&!i||r===le&&i||(o=n.zoomRange(-e),o&&s.push({axis:n,range:o}));return this.axisRanges=s,I(s)},zoom:function(){var e,t,n,i=this.axisRanges;if(i&&i.length){for(e=this.chart._plotArea,t=0;t<i.length;t++)n=i[t],e.updateAxisOptions(n.axis,n.range);e.redraw(e.panes)}},destroy:function(){delete this.chart}}),io=ve.extend({init:function(e,t){ve.fn.init.call(this,e),this.chartService=t},render:function(){var e,t,n=this,i=n.children,o=n.options,r=o.vertical;for(this.visual=new Qe.Layout(null,{spacing:r?0:o.spacing,lineSpacing:r?o.spacing:0,orientation:r?"vertical":"horizontal",reverse:o.rtl,alignItems:r?"start":"center"}),e=0;e<i.length;e++)t=i[e],t.reflow(new be),t.renderVisual()},reflow:function(e){this.visual.rect(e.toRect()),this.visual.reflow();var t=this.visual.clippedBBox();this.box=t?K.rectToBox(t):new be},renderVisual:function(){this.addVisual()},createVisual:function(){}}),oo=Ne.extend({init:function(e){Ne.fn.init.call(this,e),this.createContainer(),e.rtl?(this.createLabel(),this.createMarker()):(this.createMarker(),this.createLabel())},createContainer:function(){this.container=new K.FloatElement({vertical:!1,wrap:!1,align:te,spacing:this.options.spacing}),this.append(this.container)},createMarker:function(){this.container.append(new Me(this.markerOptions()))},markerOptions:function(){var e=this.options,t=e.markerColor;return Te({},e.markers,{background:t,border:{color:t}})},createLabel:function(){var e=this.options,t=Te({},e.labels);this.container.append(new Ie(e.text,t))},renderComplete:function(){var e,t;Ne.fn.renderComplete.call(this),e=this.options.cursor||{},t=this._itemOverlay=Xe.fromRect(this.container.box.toRect(),{fill:{color:re,opacity:0},stroke:null,cursor:e.style||e}),this.appendVisual(t)},click:function(e,t){var n=this.eventArgs(t);e.trigger(pn,n)||t.preventDefault()},hover:function(e,t){var n=this.eventArgs(t);return e.trigger(mn,n)||(t.preventDefault(),e._legendItemHover(n.seriesIndex,n.pointIndex)),!0},leave:function(e){e._unsetActivePoint()},eventArgs:function(e){var t=this.options;return{element:Ae(e),text:t.text,series:t.series,seriesIndex:t.series.index,pointIndex:t.pointIndex}},renderVisual:function(){var e=this,t=this.options,n=t.visual;n?(this.visual=n({active:t.active,series:t.series,sender:this.getSender(),pointIndex:t.pointIndex,options:{markers:this.markerOptions(),labels:t.labels},createVisual:function(){e.createVisual(),e.renderChildren(),e.renderComplete();var t=e.visual;return delete e.visual,t}}),this.addVisual()):Ne.fn.renderVisual.call(this)}}),ro="horizontal",so="pointer",ao="custom",lo=ve.extend({init:function(e,t){void 0===t&&(t={}),ve.fn.init.call(this,e),this.chartService=t,ke(this.options.position,[ne,ce,ie,oe,ao])||(this.options.position=ce),this.createContainer(),this.createItems()},createContainer:function(){var e=this.options,t=e.position,n=e.align,i=t,o=te;t===ao?i=oe:ke(t,[ne,ie])?(i="start"===n?oe:"end"===n?ce:te,o=t):n&&("start"===n?o=ne:"end"===n&&(o=ie)),this.container=new Ne({margin:e.margin,padding:e.padding,background:e.background,border:e.border,vAlign:o,align:i,zIndex:e.zIndex,shrinkToFit:!0}),this.append(this.container)},createItems:function(){var e,t,n,i=this.getService(),o=this.options,r=this.isVertical(),s=new io({vertical:r,spacing:o.spacing,rtl:i.rtl},i),a=o.items;for(o.reverse&&(a=a.slice(0).reverse()),e=a.length,t=0;t<e;t++)n=a[t],s.append(new oo(Te({},{markers:o.markers,labels:o.labels,rtl:i.rtl},o.item,n)));s.render(),this.container.append(s)},isVertical:function(){var e=this.options,t=e.orientation,n=e.position,i=n===ao&&t!==ro||(pe(t)?t!==ro:ke(n,[oe,ce]));return i},hasItems:function(){return this.container.children[0].children.length>0},reflow:function(e){var t=this.options,n=e.clone();return this.hasItems()?void(t.position===ao?(this.containerCustomReflow(n),this.box=n):this.containerReflow(n)):void(this.box=n)},containerReflow:function(e){var t,n=this,i=n.options,o=n.container,r=i.position,s=i.width,a=i.height,l=r===ne||r===ie?ae:le,c=this.isVertical(),d=e.clone(),u=e.clone();r!==oe&&r!==ce||(u.y1=d.y1=0),c&&a?(u.y2=u.y1+a,u.align(d,le,o.options.vAlign)):!c&&s&&(u.x2=u.x1+s,u.align(d,ae,o.options.align)),o.reflow(u),u=o.box,t=u.clone(),(i.offsetX||i.offsetY)&&(u.translate(i.offsetX,i.offsetY),this.container.reflow(u)),t[l+1]=e[l+1],t[l+2]=e[l+2],this.box=t},containerCustomReflow:function(e){var t=this,n=t.options,i=t.container,o=n.offsetX,r=n.offsetY,s=n.width,a=n.height,l=this.isVertical(),c=e.clone();l&&a?c.y2=c.y1+a:!l&&s&&(c.x2=c.x1+s),i.reflow(c),c=i.box,i.reflow(new be(o,r,o+c.width(),r+c.height()))},renderVisual:function(){this.hasItems()&&ve.fn.renderVisual.call(this)}}),ye(lo,{position:ce,items:[],offsetX:0,offsetY:0,margin:Re(5),padding:Re(5),border:{color:de,width:0},item:{cursor:so,spacing:6},spacing:6,background:"",zIndex:1,markers:{border:{width:0},width:15,height:3,type:"rect",align:oe,vAlign:te}}),co=Y.extend({init:function(){this._registry=[]},register:function(e,t){this._registry.push({type:e,seriesTypes:t})},create:function(e,t,n){var i,o,r,s=this._registry,a=s[0];for(o=0;o<s.length;o++)if(r=s[o],i=v(e,r.seriesTypes),i.length>0){a=r;break}return new a.type(i,t,n)}}),co.current=new co,uo=3,ho=.1,fo=Y.extend({init:function(e,t,n,i){var o=e.element;this.options=Te({},this.options,n),this.chart=e,this.observer=i,this.chartElement=o,this.categoryAxis=t,this._dateAxis=this.categoryAxis instanceof Ue,this.initOptions(),this.options.visible&&(this.createElements(),this.set(this._index(this.options.from),this._index(this.options.to)),this.bindEvents())},createElements:function(){var e,t,n,i,o,r,s=this.options,a=this.wrapper=M("k-selector");We(a,{top:s.offset.top,left:s.offset.left,width:s.width,height:s.height,direction:"ltr"}),e=this.selection=M("k-selection"),this.leftMask=M("k-mask"),this.rightMask=M("k-mask"),a.appendChild(this.leftMask),a.appendChild(this.rightMask),a.appendChild(e),e.appendChild(M("k-selection-bg")),t=this.leftHandle=M("k-handle k-left-handle"),n=this.rightHandle=M("k-handle k-right-handle"),t.appendChild(M()),n.appendChild(M()),e.appendChild(t),e.appendChild(n),this.chartElement.appendChild(a),i=We(e,["borderLeftWidth","borderRightWidth","height"]),o=We(t,"height").height,r=We(n,"height").height,s.selection={border:{left:i.borderLeftWidth,right:i.borderRightWidth}},We(t,{top:(i.height-o)/2}),We(n,{top:(i.height-r)/2}),a.style.cssText=a.style.cssText},bindEvents:function(){this._mousewheelHandler=this.options.mousewheel!==!1?this._mousewheel.bind(this):F;var e;qe(this.wrapper,(e={},e[Ln]=this._mousewheelHandler,e)),this._domEvents=Ge.DomEventsBuilder.create(this.wrapper,{start:this._start.bind(this),move:this._move.bind(this),end:this._end.bind(this),tap:this._tap.bind(this),press:this._press.bind(this),gesturestart:this._gesturestart.bind(this),gesturechange:this._gesturechange.bind(this),gestureend:this._gestureend.bind(this)})},initOptions:function(){var e,t,n,i=this,o=i.options,r=i.categoryAxis,s=r.pane.chartsBox(),a=this.chart.chartService.intl;this._dateAxis&&Te(o,{min:Be(a,o.min),max:Be(a,o.max),from:Be(a,o.from),to:Be(a,o.to)}),e=We(this.chartElement,["paddingLeft","paddingTop"]),t=e.paddingLeft,n=e.paddingTop,this.options=Te({},{width:s.width(),height:s.height()+ho,padding:{left:t,top:n},offset:{left:s.x1+t,top:s.y1+n},from:o.min,to:o.max},o)},destroy:function(){if(this._domEvents&&(this._domEvents.destroy(),delete this._domEvents),clearTimeout(this._mwTimeout),this._state=null,this.wrapper){var e;$e(this.wrapper,(e={},e[Ln]=this._mousewheelHandler,e)),this.chartElement.removeChild(this.wrapper)}},_rangeEventArgs:function(e){return{axis:this.categoryAxis.options,from:this._value(e.from),to:this._value(e.to)}},_start:function(e){var t,n=this.options,i=Ae(e);!this._state&&i&&(this.chart._unsetActivePoint(),this._state={moveTarget:R(i)||i,startLocation:e.x?e.x.location:0,range:{from:this._index(n.from),to:this._index(n.to)}},t=this._rangeEventArgs({from:this._index(n.from),to:this._index(n.to)}),this.trigger(Tn,t)&&(this._state=null))},_press:function(e){var t;t=this._state?this._state.moveTarget:R(Ae(e)),t&&K.addClass(t,"k-handle-active")},_move:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_;this._state&&(t=this,n=t._state,i=t.options,o=t.categoryAxis.options,r=n.range,s=n.moveTarget,a=o.reverse,l=this._index(i.from),c=this._index(i.to),d=this._index(i.min),u=this._index(i.max),h=n.startLocation-e.x.location,f={from:r.from,to:r.to},p=r.to-r.from,m=We(this.wrapper,"width").width/(o.categories.length-1),g=Math.round(h/m)*(a?-1:1),s&&(v=je(s,"k-left-handle"),_=je(s,"k-right-handle"),je(s,"k-selection k-selection-bg")?(r.from=Math.min(Math.max(d,l-g),u-p),r.to=Math.min(r.from+p,u)):v&&!a||_&&a?(r.from=Math.min(Math.max(d,l-g),u-1),r.to=Math.max(r.from+1,r.to)):(v&&a||_&&!a)&&(r.to=Math.min(Math.max(d+1,c-g),u),r.from=Math.min(r.to-1,r.from)),r.from===f.from&&r.to===f.to||(this.move(r.from,r.to),this.trigger(Dn,this._rangeEventArgs(r)))))},_end:function(){var e,t;this._state&&(e=this._state.moveTarget,e&&K.removeClass(e,"k-handle-active"),t=this._state.range,this.set(t.from,t.to),this.trigger(An,this._rangeEventArgs(t)),delete this._state)},_tap:function(e){var t=this,n=t.options,i=t.categoryAxis,o=this.chart._eventCoordinates(e),r=i.pointCategoryIndex(new _e(o.x,i.box.y1)),s=this._index(n.from),a=this._index(n.to),l=this._index(n.min),c=this._index(n.max),d=a-s,u=s+d/2,h={},f=3===e.event.which,p=Math.round(u-r);this._state||f||(this.chart._unsetActivePoint(),i.options.justified||p--,h.from=Math.min(Math.max(l,s-p),c-d),h.to=Math.min(h.from+d,c),this._start(e),this._state&&(this._state.range=h,this.trigger(Dn,this._rangeEventArgs(h)),this._end()))},_mousewheel:function(e){var t,n=this,i=K.mousewheelDelta(e);this._start({target:this.selection}),this._state&&(t=this._state.range,e.preventDefault(),e.stopPropagation(),Math.abs(i)>1&&(i*=uo),this.options.mousewheel.reverse&&(i*=-1),this.expand(i)&&this.trigger(Dn,{axis:this.categoryAxis.options,delta:i,originalEvent:e,from:this._value(t.from),to:this._value(t.to)}),this._mwTimeout&&clearTimeout(this._mwTimeout),this._mwTimeout=setTimeout(function(){n._end()},Hn))},_gesturestart:function(e){var t,n=this.options;this._state={range:{from:this._index(n.from),to:this._index(n.to)}},t=this._rangeEventArgs(this._state.range),this.trigger(Tn,t)?this._state=null:e.preventDefault()},_gestureend:function(){this._state&&(this.trigger(An,this._rangeEventArgs(this._state.range)),delete this._state)},_gesturechange:function(e){var t=this,n=t.chart,i=t._state,o=t.options,r=t.categoryAxis,s=i.range,a=n._toModelCoordinates(e.touches[0].x.location).x,l=n._toModelCoordinates(e.touches[1].x.location).x,c=Math.min(a,l),d=Math.max(a,l);e.preventDefault(),s.from=r.pointCategoryIndex(new _e(c))||o.min,s.to=r.pointCategoryIndex(new _e(d))||o.max,this.move(s.from,s.to),this.trigger(Dn,this._rangeEventArgs(s))},_index:function(e){var t=e;return e instanceof Date&&(t=this.categoryAxis.categoryIndex(e)),t},_value:function(e){var t=this.categoryAxis.options.categories,n=e;return this._dateAxis&&(n=e>t.length-1?this.options.max:t[Math.ceil(e)]),n},_slot:function(e){var t=this.categoryAxis,n=this._index(e);return t.getSlot(n,n,!0)},move:function(e,t){var n,i,o=this.options,r=this.categoryAxis.options.reverse,s=o.offset,a=o.padding,l=o.selection.border,c=r?t:e,d=r?e:t,u="x"+(r?2:1),h=this._slot(c),f=Oe(h[u]-s.left+a.left);We(this.leftMask,{width:f}),We(this.selection,{left:f}),h=this._slot(d),n=Oe(o.width-(h[u]-s.left+a.left)),We(this.rightMask,{width:n}),i=o.width-n,i!==o.width&&(i+=l.right),We(this.rightMask,{left:i}),We(this.selection,{width:Math.max(o.width-(f+n)-l.right,0)})},set:function(e,t){var n=this.options,i=this._index(n.min),o=this._index(n.max),r=Ke(this._index(e),i,o),s=Ke(this._index(t),r+1,o);n.visible&&this.move(r,s),n.from=this._value(r),n.to=this._value(s)},expand:function(e){var t=this.options,n=this._index(t.min),i=this._index(t.max),o=t.mousewheel.zoom,r=this._index(t.from),s=this._index(t.to),a={from:r,to:s},l=Te({},a);if(this._state&&(a=this._state.range),o!==ce&&(a.from=Ke(Ke(r-e,0,s-1),n,i)),o!==oe&&(a.to=Ke(Ke(s+e,a.from+1,i),n,i)),a.from!==l.from||a.to!==l.to)return this.set(a.from,a.to),!0},trigger:function(e,t){return(this.observer||this.chart).trigger(e,t)}}),ye(fo,{visible:!0,mousewheel:{zoom:"both"},min:J,max:Z}),po=Si.extend({show:function(e){var t,n;!e||!e.tooltipAnchor||this._current&&this._current===e||(t=Te({},this.options,e.options.tooltip),n=e.tooltipAnchor(),n?(this._current=e,Si.fn.show.call(this,{point:e,anchor:n},t,e)):this.hide())},hide:function(){delete this._current,Si.fn.hide.call(this)}}),mo=Si.extend({init:function(e,t){Si.fn.init.call(this,e.chartService,t),this.plotArea=e,this.formatService=e.chartService.format},showAt:function(e,t){var n,i,o,r=Ve(e,function(e){var t=e.series.tooltip,n=t&&t.visible===!1;return!n});r.length>0&&(n=r[0],i=this.plotArea.categoryAxis.getSlot(n.categoryIx),o=t?this._slotAnchor(t,i):this._defaultAnchor(n,i),this.show({anchor:o,shared:!0,points:e,category:n.category,categoryText:this.formatService.auto(this.options.categoryFormat,n.category),series:this.plotArea.series},this.options))},_slotAnchor:function(e,t){var n=this.plotArea.categoryAxis,i={horizontal:"left",vertical:"center"};return n.options.vertical||(e.x=t.center().x),{point:e,align:i}},_defaultAnchor:function(e,t){var n,i=e.owner.pane.chartsBox(),o=this.plotArea.categoryAxis.options.vertical,r=i.center(),s=t.center(),a={horizontal:"center",vertical:"center"};return n=o?new _e(r.x,s.y):new _e(s.x,r.y),{point:n,align:a}}}),ye(mo,{categoryFormat:"{0:d}"}),go=Ze.extend({setup:function(){var e,t,n=this,i=n.element,o=n.options,r=i.bbox();r?(this.origin=o.origin,e=o.vertical?le:ae,t=this.fromScale=new it(1,1),t[e]=yt,i.transform(ot().scale(t.x,t.y))):this.abort()},step:function(e){var t=K.interpolateValue(this.fromScale.x,1,e),n=K.interpolateValue(this.fromScale.y,1,e);this.element.transform(ot().scale(t,n,this.origin))},abort:function(){Ze.fn.abort.call(this),this.element.transform(null)}}),ye(go,{duration:gt}),Je.current.register(Lt,go),vo=Ze.extend({setup:function(){var e=this.center=this.element.bbox().center();this.element.transform(ot().scale(yt,yt,e))},step:function(e){this.element.transform(ot().scale(e,e,this.center))}}),ye(vo,{easing:"easeOutElastic"}),Je.current.register(Nt,vo),_o=Ze.extend({setup:function(){this.fadeTo=this.element.opacity(),this.element.opacity(0)},step:function(e){this.element.opacity(e*this.fadeTo)}}),ye(_o,{duration:200,easing:"linear"}),Je.current.register(vt,_o),bo=Ze.extend({setup:function(){this.element.transform(ot().scale(yt,yt,this.options.center))},step:function(e){this.element.transform(ot().scale(e,e,this.options.center))}}),ye(bo,{easing:"easeOutElastic",duration:gt}),Je.current.register(Kt,bo),wo=bi.extend({render:function(){bi.fn.render.call(this),this.renderSegments()},createSegment:function(e,t,n){var i,o=t.style;return new(i=o===zt?Xn:Kn)(e,t,n)},animationPoints:function(){var e=bi.fn.animationPoints.call(this);return e.concat(this._segments)},createMissingValue:function(e,t){if(t===Et){var n={x:e.x,y:e.y};return u(n.x)||(n.x=0),u(n.y)||(n.y=0),n}}}),Te(wo.prototype,Zn),yo=Mi.extend({initFields:function(){this.namedXAxes={},this.namedYAxes={},this.xAxisRangeTracker=new si,this.yAxisRangeTracker=new si},render:function(e){var t,n,i,o,r,s=this;for(void 0===e&&(e=this.panes),t=this.groupSeriesByPane(),n=0;n<e.length;n++)i=e[n],o=t[i.options.name||"default"]||[],s.addToLegend(o),r=s.filterVisibleSeries(o),r&&(s.createScatterChart(v(r,rn),i),s.createScatterLineChart(v(r,sn),i),s.createBubbleChart(v(r,Nt),i));this.createAxes(e)},appendChart:function(e,t){this.xAxisRangeTracker.update(e.xAxisRanges),this.yAxisRangeTracker.update(e.yAxisRanges),Mi.fn.appendChart.call(this,e,t)},removeAxis:function(e){var t=e.options.name;Mi.fn.removeAxis.call(this,e),e.options.vertical?(this.yAxisRangeTracker.reset(t),delete this.namedYAxes[t]):(this.xAxisRangeTracker.reset(t),delete this.namedXAxes[t]),e===this.axisX&&delete this.axisX,e===this.axisY&&delete this.axisY},seriesPaneName:function(e){var t=this.options,n=e.xAxis,i=[].concat(t.xAxis),o=Ve(i,function(e){return e.name===n})[0],r=e.yAxis,s=[].concat(t.yAxis),a=Ve(s,function(e){return e.name===r})[0],l=t.panes||[{}],c=l[0].name||"default",d=(o||{}).pane||(a||{}).pane||c;return d},createScatterChart:function(e,t){e.length>0&&this.appendChart(new bi(this,{series:e,clip:t.options.clip}),t)},createScatterLineChart:function(e,t){e.length>0&&this.appendChart(new wo(this,{series:e,clip:t.options.clip}),t)},createBubbleChart:function(e,t){e.length>0&&this.appendChart(new yi(this,{series:e,clip:t.options.clip}),t)},createXYAxis:function(e,t,n){var i,o,r,s,a,l,c,d,u=e.name,h=t?this.namedYAxes:this.namedXAxes,f=t?this.yAxisRangeTracker:this.xAxisRangeTracker,p=Te({reverse:!t&&this.chartService.rtl},e,{vertical:t}),m=g(p.type,Rn),v=f.query(),_=m?{min:.1,max:1}:{min:0,max:1},b=f.query(u)||v||_,w=[p.min,p.max],y=this.series;for(i=0;i<y.length;i++)if(o=y[i],r=o[t?"yAxis":"xAxis"],r===p.name||0===n&&!r){s=ct.current.bindPoint(o,0).valueFields,w.push(s[t?"y":"x"]);break}for(0===n&&v&&(b.min=Math.min(b.min,v.min),b.max=Math.max(b.max,v.max)),l=0;l<w.length;l++)if(w[l]instanceof Date){a=!0;break}if(c=g(p.type,ue)||!p.type&&a?K.DateValueAxis:m?K.LogarithmicAxis:K.NumericAxis,d=new c(b.min,b.max,p,this.chartService),d.axisIndex=n,u){if(h[u])throw Error((t?"Y":"X")+" axis with name "+u+" is already defined");h[u]=d}return this.appendAxis(d),d},createAxes:function(e){var t,n,i,o,r=this,s=this.options,a=[].concat(s.xAxis),l=[],c=[].concat(s.yAxis),d=[];for(t=0;t<a.length;t++)n=r.findPane(a[t].pane),ke(n,e)&&l.push(r.createXYAxis(a[t],!1,t));for(i=0;i<c.length;i++)o=r.findPane(c[i].pane),ke(o,e)&&d.push(r.createXYAxis(c[i],!0,i));this.axisX=this.axisX||l[0],this.axisY=this.axisY||d[0]},_dispatchEvent:function(e,t,n){var i,o,r,s,a=e._eventCoordinates(t),l=new _e(a.x,a.y),c=this.axes,d=c.length,u=[],h=[];for(i=0;i<d;i++)o=c[i],r=o.options.vertical?h:u,s=o.getValue(l),null!==s&&r.push(s);u.length>0&&h.length>0&&e.trigger(n,{element:Ae(t),originalEvent:t,x:w(u),y:w(h)})},updateAxisOptions:function(e,t){var n=e.options.vertical,i=this.groupAxes(this.panes),o=(n?i.y:i.x).indexOf(e);z(this.options,o,n,t),z(this.originalOptions,o,n,t)}}),ye(yo,{xAxis:{},yAxis:{}}),Te(yo.prototype,Ri),ko=ve.extend({init:function(e,t,n){ve.fn.init.call(this,n),this.value=e,this.sector=t},render:function(){var e,t,n,i=this.options.labels,o=this.owner.chartService,r=this.value;this._rendered||this.visible===!1||(this._rendered=!0,e=Ee(i),e?r=e({dataItem:this.dataItem,category:this.category,value:this.value,series:this.series,percentage:this.percentage}):i.format&&(r=o.format.auto(i.format,r)),i.visible&&(r||0===r)&&(i.position===te||i.position===zn?(i.color||(t=new tt(this.options.color).percBrightness(),i.color=t>180?de:re),i.background||(i.background=this.options.color)):(n=o.theme.seriesDefaults.labels,i.color=i.color||n.color,i.background=i.background||n.background),this.label=new Ie(r,Te({},i,{align:te,vAlign:"",animation:{type:vt,delay:this.animationDelay}})),this.append(this.label)))},reflow:function(e){this.render(),this.box=e,this.reflowLabel()},reflowLabel:function(){var e,t,n,i,o=this,r=o.options.labels,s=o.label,a=this.sector.clone(),l=r.distance,c=a.middle();s&&(e=s.box.height(),t=s.box.width(),r.position===te?(a.radius=Math.abs((a.radius-e)/2)+e,n=a.point(c),s.reflow(new be(n.x,n.y-e/2,n.x,n.y))):r.position===zn?(a.radius=a.radius-e/2,n=a.point(c),s.reflow(new be(n.x,n.y-e/2,n.x,n.y))):(n=a.clone().expand(l).point(c),n.x>=a.center.x?(i=n.x+t,s.orientation=ce):(i=n.x-t,s.orientation=oe),s.reflow(new be(i,n.y-e,n.x,n.y))))},createVisual:function(){var e,t,n=this,i=this,o=i.sector,r=i.options;ve.fn.createVisual.call(this),this.value&&(r.visual?(e=(o.startAngle+180)%360,t=r.visual({category:this.category,dataItem:this.dataItem,value:this.value,series:this.series,percentage:this.percentage,center:new it(o.center.x,o.center.y),radius:o.radius,innerRadius:o.innerRadius,startAngle:e,endAngle:e+o.angle,options:r,sender:this.getSender(),createVisual:function(){var e=new et;return n.createSegmentVisual(e),e}}),t&&this.visual.append(t)):this.createSegmentVisual(this.visual))},createSegmentVisual:function(e){var t=this,n=t.sector,i=t.options,o=i.border||{},r=o.width>0?{stroke:{color:o.color,width:o.width,opacity:o.opacity,dashType:o.dashType}}:{},s=i.color,l={color:s,opacity:i.opacity},c=this.createSegment(n,Te({fill:l,stroke:{opacity:i.opacity},zIndex:i.zIndex},r));e.append(c),a(i)&&e.append(this.createGradientOverlay(c,{baseColor:s,fallbackFill:l},Te({center:[n.center.x,n.center.y],innerRadius:n.innerRadius,radius:n.radius,userSpace:!0},i.overlay)))},createSegment:function(e,t){return t.singleSegment?new Qe.Circle(new nt.Circle(new it(e.center.x,e.center.y),e.radius),t):K.ShapeBuilder.current.createRing(e,t)},createAnimation:function(){var e=this,t=e.options,n=e.sector.center;Te(t,{animation:{center:[n.x,n.y],delay:this.animationDelay}}),ve.fn.createAnimation.call(this)},createHighlight:function(e){var t=this.options.highlight||{},n=t.border||{};return this.createSegment(this.sector,Te({},e,{fill:{color:t.color,opacity:t.opacity},stroke:{opacity:n.opacity,width:n.width,color:n.color}}))},highlightVisual:function(){return this.visual.children[0]},highlightVisualArgs:function(){var e=this.sector;return{options:this.options,radius:e.radius,innerRadius:e.innerRadius,center:new it(e.center.x,e.center.y),startAngle:e.startAngle,endAngle:e.angle+e.startAngle,visual:this.visual}},tooltipAnchor:function(){var e=this.sector.clone().expand(wt),t=e.middle(),n=e.point(t);return{point:n,align:P(t+180)}},formatValue:function(e){return this.owner.formatPointValue(this,e)}}),xo=Oe(K.rad(30),he),
Co=Oe(K.rad(60),he),ye(ko,{color:re,overlay:{gradient:"roundedBevel"},border:{width:.5},labels:{visible:!1,distance:35,font:X.DEFAULT_FONT,margin:Re(.5),align:se,zIndex:1,position:Bn},animation:{type:Kt},highlight:{visible:!0,border:{width:1}},visible:!0}),Te(ko.prototype,qn),So={createLegendItem:function(e,t,n){var i,o,r,s,a,l=this.options.legend||{},c=l.labels||{},d=l.inactiveItems||{},h=d.labels||{};n&&n.visibleInLegend!==!1&&(i=n.visible!==!1,o=i?Ee(c):Ee(h)||Ee(c),r=n.category,o&&(r=o({text:r,series:n.series,dataItem:n.dataItem,percentage:n.percentage,value:e})),i?(s={},a=t.color):(s={color:h.color,font:h.font},a=(d.markers||{}).color),u(r)&&""!==r&&this.legendItems.push({pointIndex:n.index,text:r,series:n.series,markerColor:a,labels:s}))}},To=70,Do=ve.extend({init:function(e,t){ve.fn.init.call(this,t),this.plotArea=e,this.chartService=e.chartService,this.points=[],this.legendItems=[],this.render()},render:function(){this.traverseDataPoints(this.addValue.bind(this))},traverseDataPoints:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f,p,g,v,_,b,w,y,k=this,x=this,C=x.options,S=x.plotArea.options.seriesColors;for(void 0===S&&(S=[]),t=S.length,n=C.series,i=n.length,o=0;o<i;o++)for(r=n[o],s=r.data,a=m(r),l=a.total,c=a.points,d=a.count,u=360/l,h=void 0,isFinite(u)||(h=360/d),f=void 0,f=pe(r.startAngle)?r.startAngle:C.startAngle,o!==i-1&&r.labels.position===Bn&&(r.labels.position=te),p=0;p<c.length;p++)g=c[p],g&&(v=g.fields,_=g.value,b=g.visible,w=0!==_?h||_*u:0,y=1!==s.length&&!!v.explode,xe(r.color)||(r.color=v.color||S[p%t]),e(g.valueFields.value,new K.Ring(null,0,0,f,w),{owner:k,category:pe(v.category)?v.category:"",index:p,series:r,seriesIx:o,dataItem:s[p],percentage:0!==l?_/l:0,explode:y,visibleInLegend:v.visibleInLegend,visible:b,zIndex:i-o,animationDelay:k.animationDelay(p,o,i)}),b!==!1&&(f+=w))},evalSegmentOptions:function(e,t,n){var o=n.series;i(e,{value:t,series:o,dataItem:n.dataItem,category:n.category,percentage:n.percentage},{defaults:o._defaults,excluded:["data","content","template","visual","toggle"]})},addValue:function(t,n,i){var o,r=Te({},i.series,{index:i.index});this.evalSegmentOptions(r,t,i),this.createLegendItem(t,r,i),i.visible!==!1&&(o=new ko(t,n,r),e.extend(o,i),this.append(o),this.points.push(o))},reflow:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k=this,x=k.options,C=k.points,S=k.seriesConfigs;for(void 0===S&&(S=[]),t=C.length,n=e.clone(),i=5,o=Math.min(n.width(),n.height()),r=o/2,s=o-.85*o,a=new be(n.x1,n.y1,n.x1+o,n.y1+o),l=a.center(),c=n.center(),d=x.series.length,u=[],h=[],f=Ce(x.padding,s),f=f>r-i?r-i:f,a.translate(c.x-l.x,c.y-l.y),p=r-f,m=new _e(p+a.x1+f,p+a.y1+f),g=0;g<t;g++)v=C[g],_=v.sector,b=v.seriesIx,_.radius=p,_.center=m,S.length&&(w=S[b],_.innerRadius=w.innerRadius,_.radius=w.radius),b===d-1&&v.explode&&(_.center=_.clone().setRadius(.15*_.radius).point(_.middle())),v.reflow(a),y=v.label,y&&y.options.position===Bn&&b===d-1&&(y.orientation===ce?h.push(y):u.push(y));u.length>0&&(u.sort(this.labelComparator(!0)),this.leftLabelsReflow(u)),h.length>0&&(h.sort(this.labelComparator(!1)),this.rightLabelsReflow(h)),this.box=a},leftLabelsReflow:function(e){var t=this.distanceBetweenLabels(e);this.distributeLabels(t,e)},rightLabelsReflow:function(e){var t=this.distanceBetweenLabels(e);this.distributeLabels(t,e)},distanceBetweenLabels:function(e){var t,n,i=De(this.points),o=i.sector,r=e.length-1,s=o.radius+i.options.labels.distance,a=[],l=e[0].box,c=Oe(l.y1-(o.center.y-s-l.height()-l.height()/2));for(a.push(c),t=0;t<r;t++)n=e[t+1].box,l=e[t].box,c=Oe(n.y1-l.y2),a.push(c);return c=Oe(o.center.y+s-e[r].box.y2-e[r].box.height()/2),a.push(c),a},distributeLabels:function(e,t){var n,i,o,r,s=this,a=e.length;for(r=0;r<a;r++)for(o=-e[r],n=i=r;o>0&&(n>=0||i<a);)o=s._takeDistance(e,r,--n,o),o=s._takeDistance(e,r,++i,o);this.reflowLabels(e,t)},_takeDistance:function(e,t,n,i){var o,r=i;return e[n]>0&&(o=Math.min(e[n],r),r-=o,e[n]-=o,e[t]+=o),r},reflowLabels:function(e,t){var n,i,o,r,s=this,a=De(this.points),l=a.sector,c=a.options.labels,d=t.length,u=c.distance,h=l.center.y-(l.radius+u)-t[0].box.height();for(e[0]+=2,i=0;i<d;i++)o=t[i],r=o.box,h+=e[i],n=s.hAlignLabel(r.x2,l.clone().expand(u),h,h+r.height(),o.orientation===ce),o.orientation===ce?(c.align!==se&&(n=l.radius+l.center.x+u),o.reflow(new be(n+r.width(),h,n,h))):(c.align!==se&&(n=l.center.x-l.radius-u),o.reflow(new be(n-r.width(),h,n,h))),h+=r.height()},createVisual:function(){var e,t,n,i,o,r,s,a,l,c,d,u,h,f,p=this,m=this,g=m.options.connectors,v=m.points,_=v.length,b=4;for(ve.fn.createVisual.call(this),this._connectorLines=[],e=0;e<_;e++)t=v[e],n=t.sector,i=t.label,o=n.middle(),r=(t.options.connectors||{}).color||g.color,i&&(s=new Xe({stroke:{color:r,width:g.width},animation:{type:vt,delay:t.animationDelay}}),i.options.position===Bn&&(a=i.box,l=n.center,c=n.point(o),d=new _e(a.x1,a.center().y),u=void 0,h=void 0,f=void 0,c=n.clone().expand(g.padding).point(o),s.moveTo(c.x,c.y),i.orientation===ce?(h=new _e(a.x1-g.padding,a.center().y),f=B(l,c,d,h),d=new _e(h.x-b,h.y),f=f||d,f.x=Math.min(f.x,d.x),p.pointInCircle(f,n.center,n.radius+b)||f.x<n.center.x?(u=n.center.x+n.radius+b,t.options.labels.align!==Ut?u<d.x?s.lineTo(u,c.y):s.lineTo(c.x+2*b,c.y):s.lineTo(u,c.y),s.lineTo(d.x,h.y)):(f.y=h.y,s.lineTo(f.x,f.y))):(h=new _e(a.x2+g.padding,a.center().y),f=B(l,c,d,h),d=new _e(h.x+b,h.y),f=f||d,f.x=Math.max(f.x,d.x),p.pointInCircle(f,n.center,n.radius+b)||f.x>n.center.x?(u=n.center.x-n.radius-b,t.options.labels.align!==Ut?u>d.x?s.lineTo(u,c.y):s.lineTo(c.x-2*b,c.y):s.lineTo(u,c.y),s.lineTo(d.x,h.y)):(f.y=h.y,s.lineTo(f.x,f.y))),s.lineTo(h.x,h.y),p._connectorLines.push(s),p.visual.append(s)))},labelComparator:function(e){var t=e?-1:1;return function(e,n){var i=(e.parent.sector.middle()+270)%360,o=(n.parent.sector.middle()+270)%360;return(i-o)*t}},hAlignLabel:function(e,t,n,i,o){var r=t.radius,s=t.center,a=s.x,l=s.y,c=Math.min(Math.abs(l-n),Math.abs(l-i));return c>r?e:a+Math.sqrt(r*r-c*c)*(o?1:-1)},pointInCircle:function(e,t,n){return Math.pow(t.x-e.x,2)+Math.pow(t.y-e.y,2)<Math.pow(n,2)},formatPointValue:function(e,t){return this.chartService.format.auto(t,e.value)},animationDelay:function(e){return e*To}}),ye(Do,{startAngle:90,connectors:{width:2,color:"#939393",padding:8},inactiveItems:{markers:{},labels:{}}}),Te(Do.prototype,So),Ao=Mi.extend({render:function(){this.createPieChart(this.series)},createPieChart:function(e){var t=e[0],n=new Do(this,{series:e,padding:t.padding,startAngle:t.startAngle,connectors:t.connectors,legend:this.options.legend});this.appendChart(n)},appendChart:function(e,t){Mi.fn.appendChart.call(this,e,t),ze(this.options.legend.items,e.legendItems)}}),Eo=ko.extend({reflowLabel:function(){var e,t,n=this,i=n.options.labels,o=n.label,r=this.sector.clone(),s=r.middle();o&&(e=o.box.height(),i.position===te?(r.radius-=(r.radius-r.innerRadius)/2,t=r.point(s),o.reflow(new be(t.x,t.y-e/2,t.x,t.y))):ko.fn.reflowLabel.call(this))},createSegment:function(e,t){return K.ShapeBuilder.current.createRing(e,t)}}),ye(Eo,{overlay:{gradient:"roundedGlass"},labels:{position:te},animation:{type:Kt}}),Te(Eo.prototype,qn),Io=50,Mo=Do.extend({addValue:function(t,n,i){var o,r=Te({},i.series,{index:i.index});this.evalSegmentOptions(r,t,i),this.createLegendItem(t,r,i),t&&i.visible!==!1&&(o=new Eo(t,n,r),e.extend(o,i),this.append(o),this.points.push(o))},reflow:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f=this,p=this.options,m=e.clone(),g=5,v=Math.min(m.width(),m.height()),_=v/2,b=v-.85*v,w=p.series,y=w.length,k=Ce(p.padding,b);for(k=k>_-g?_-g:k,t=_-k,n=0,o=0;o<y;o++)r=w[o],0===o&&pe(r.holeSize)&&(i=r.holeSize,t-=r.holeSize),pe(r.size)?t-=r.size:n++,pe(r.margin)&&o!==y-1&&(t-=r.margin);for(pe(i)||(s=(_-k)/(y+.75),i=.75*s,t-=i),a=i,l=0,this.seriesConfigs=[],u=0;u<y;u++)h=w[u],c=Ce(h.size,t/n),a+=l,d=a+c,f.seriesConfigs.push({innerRadius:a,radius:d}),l=h.margin||0,a=d;Do.fn.reflow.call(this,e)},animationDelay:function(e,t,n){return e*Io+gt*(t+1)/(n+1)}}),ye(Mo,{startAngle:90,connectors:{width:2,color:"#939393",padding:8}}),Ro=Ao.extend({render:function(){this.createDonutChart(this.series)},createDonutChart:function(e){var t=e[0],n=new Mo(this,{series:e,padding:t.padding,connectors:t.connectors,legend:this.options.legend});this.appendChart(n)}}),Fo=.15,zo=Mi.extend({initFields:function(){this.valueAxisRangeTracker=new si},render:function(){this.addToLegend(this.series),this.createPolarAxis(),this.createCharts(),this.createValueAxis()},alignAxes:function(){var e=this.valueAxis,t=e.range(),n=e.options.reverse?t.max:t.min,i=e.getSlot(n),o=this.polarAxis.getSlot(0).center,r=e.box.translate(o.x-i.x1,o.y-i.y1);e.reflow(r)},createValueAxis:function(){var e,t,n,i,o=this.valueAxisRangeTracker,r=o.query(),s=this.valueAxisOptions({roundToMajorUnit:!1,zIndex:-1});s.type===Rn?(e=K.RadarLogarithmicAxis,t={min:.1,max:1}):(e=K.RadarNumericAxis,t={min:0,max:1}),n=o.query(name)||r||t,n&&r&&(n.min=Math.min(n.min,r.min),n.max=Math.max(n.max,r.max)),i=new e(n.min,n.max,s,this.chartService),this.valueAxis=i,this.appendAxis(i)},reflowAxes:function(){var e,t,n=this,i=n.options.plotArea,o=n.valueAxis,r=n.polarAxis,s=n.box,a=Math.min(s.width(),s.height())*Fo,l=Re(i.padding||{},a),c=s.clone().unpad(l),d=c.clone();d.y2=d.y1+Math.min(d.width(),d.height()),d.align(c,le,te),e=d.clone().shrink(0,d.height()/2),r.reflow(d),o.reflow(e),t=o.lineBox().height()-o.box.height(),o.reflow(o.box.unpad({top:t})),this.axisBox=d,this.alignAxes(d)},backgroundBox:function(){return this.box}}),Po=bi.extend({pointSlot:function(e,t){var n=e.center.y-t.y1,i=_e.onCircle(e.center,e.startAngle,n);return new be(i.x,i.y,i.x,i.y)}}),ye(Po,{clip:!1}),Bo=wo.extend({}),Bo.prototype.pointSlot=Po.prototype.pointSlot,ye(Bo,{clip:!1}),Lo=oi.extend({fillToAxes:function(e){var t=this._polarAxisCenter();e.lineTo(t.x,t.y)},_polarAxisCenter:function(){var e=this.parent.plotArea.polarAxis,t=e.box.center();return t},strokeSegments:function(){var e,t,n,i=this._strokeSegments;return i||(e=this._polarAxisCenter(),t=new Fe((!1)),n=this.points(),n.push(e),i=this._strokeSegments=t.process(n),i.pop()),i}}),Ho=ni.extend({fillToAxes:function(e){var t=this.parent.plotArea.polarAxis,n=t.box.center(),i=new nt.Segment([n.x,n.y]);e.segments.unshift(i),e.segments.push(i)}}),No=Bo.extend({createSegment:function(e,t,n){var i,o=(t.line||{}).style;return i=o===zt?new Lo(e,t,n):new Ho(e,t,n)},createMissingValue:function(e,t){var n;return u(e.x)&&t!==It&&(n={x:e.x,y:e.y},t===Et&&(n.y=0)),n},seriesMissingValues:function(e){return e.missingValues||Et},_hasMissingValuesGap:function(){var e,t=this,n=this.options.series;for(e=0;e<n.length;e++)if(t.seriesMissingValues(n[e])===Mt)return!0},sortPoints:function(e){var t,n,i,o=this;if(e.sort(L),this._hasMissingValuesGap())for(t=0;t<e.length;t++)n=e[t],n&&(i=n.value,u(i.y)||o.seriesMissingValues(n.series)!==Mt||delete e[t]);return e}}),Oo=zo.extend({createPolarAxis:function(){var e=new K.PolarAxis(this.options.xAxis,this.chartService);this.polarAxis=e,this.axisX=e,this.appendAxis(e)},valueAxisOptions:function(e){return Te(e,{majorGridLines:{type:fe},minorGridLines:{type:fe}},this.options.yAxis)},createValueAxis:function(){zo.fn.createValueAxis.call(this),this.axisY=this.valueAxis},appendChart:function(e,t){this.valueAxisRangeTracker.update(e.yAxisRanges),Mi.prototype.appendChart.call(this,e,t)},createCharts:function(){var e=this.filterVisibleSeries(this.series),t=this.panes[0];this.createLineChart(v(e,[Qt]),t),this.createScatterChart(v(e,[Xt]),t),this.createAreaChart(v(e,[Yt]),t)},createLineChart:function(e,t){if(0!==e.length){var n=new Bo(this,{series:e});this.appendChart(n,t)}},createScatterChart:function(e,t){if(0!==e.length){var n=new Po(this,{series:e});this.appendChart(n,t)}},createAreaChart:function(e,t){if(0!==e.length){var n=new No(this,{series:e});this.appendChart(n,t)}},_dispatchEvent:function(e,t,n){var i=e._eventCoordinates(t),o=new _e(i.x,i.y),r=this.axisX.getValue(o),s=this.axisY.getValue(o);null!==r&&null!==s&&e.trigger(n,{element:Ae(t),x:r,y:s})},createCrosshairs:function(){}}),ye(Oo,{xAxis:{},yAxis:{}}),Te(Oo.prototype,Ri),Vo=ti.extend({pointSlot:function(e,t){var n=e.center.y-t.y1,i=_e.onCircle(e.center,e.middle(),n);return new be(i.x,i.y,i.x,i.y)},createSegment:function(e,t,n){var i,o,r=t.style;return i=r===zt?Xn:Kn,o=new i(e,t,n),e.length===t.data.length&&(o.options.closed=!0),o}}),ye(Vo,{clip:!1,limitPoints:!1}),Uo=oi.extend({fillToAxes:function(){}}),Wo=ni.extend({fillToAxes:function(){}}),jo=Vo.extend({createSegment:function(e,t,n,i){var o,r,s,a=this.options.isStacked,l=(t.line||{}).style;return a&&n>0&&i&&(r=i.linePoints.slice(0),o=i),l===zt?(s=new Uo(e,t,n,o,r),s.options.closed=!0):(e.push(e[0]),s=new Wo(e,t,n,o,r)),s},seriesMissingValues:function(e){return e.missingValues||Et}}),qo=Eo.extend({init:function(e,t){Eo.fn.init.call(this,e,null,t)}}),ye(qo,{overlay:{gradient:"none"},labels:{distance:10}}),Go=ve.extend({init:function(e){ve.fn.init.call(this,e),this.forEach=e.rtl?c:l},reflow:function(e){var t=this,n=t.options,i=t.children,o=n.gap,r=n.spacing,s=i.length,a=s+o+r*(s-1),l=e.angle/a,c=e.startAngle+l*(o/2);this.forEach(i,function(t){var n=e.clone();n.startAngle=c,n.angle=l,t.sector&&(n.radius=t.sector.radius),t.reflow(n),t.sector=n,c+=l+l*r})}}),ye(Go,{gap:1,spacing:0}),$o=ve.extend({reflow:function(e){var t,n,i=this,o=i.options.reverse,r=i.children,s=r.length,a=o?s-1:0,l=o?-1:1;for(this.box=new be,t=a;t>=0&&t<s;t+=l)n=r[t].sector,n.startAngle=e.startAngle,n.angle=e.angle}}),Ko=hi.extend({pointType:function(){return qo},clusterType:function(){return Go},stackType:function(){return $o},categorySlot:function(e,t){return e.getSlot(t)},pointSlot:function(e,t){var n=e.clone(),i=e.center.y;return n.radius=i-t.y1,n.innerRadius=i-t.y2,n},reflowPoint:function(e,t){e.sector=t,e.reflow()},createAnimation:function(){this.options.animation.center=this.box.toRect().center(),hi.fn.createAnimation.call(this)}}),Ko.prototype.reflow=jn.prototype.reflow,ye(Ko,{clip:!1,limitPoints:!1,animation:{type:"pie"}}),Yo=zo.extend({createPolarAxis:function(){var e=new K.RadarCategoryAxis(this.options.categoryAxis,this.chartService);this.polarAxis=e,this.categoryAxis=e,this.appendAxis(e),this.aggregateCategories(),this.createCategoryAxesLabels()},valueAxisOptions:function(e){return this._hasBarCharts&&Te(e,{majorGridLines:{type:fe},minorGridLines:{type:fe}}),this._isStacked100&&Te(e,{roundToMajorUnit:!1,labels:{format:"P0"}}),Te(e,this.options.valueAxis)},aggregateCategories:function(){Zi.prototype.aggregateCategories.call(this,this.panes)},createCategoryAxesLabels:function(){Zi.prototype.createCategoryAxesLabels.call(this,this.panes)},filterSeries:function(e){return e},createCharts:function(){var e=this.filterVisibleSeries(this.series),t=this.panes[0];this.createAreaChart(v(e,[Zt]),t),this.createLineChart(v(e,[en]),t),this.createBarChart(v(e,[Jt]),t)},chartOptions:function(e){var t,n,i={series:e},o=e[0];return o&&(t=this.filterVisibleSeries(e),n=o.stack,i.isStacked=n&&t.length>1,i.isStacked100=n&&"100%"===n.type&&t.length>1,i.isStacked100&&(this._isStacked100=!0)),i},createAreaChart:function(e,t){if(0!==e.length){var n=new jo(this,this.chartOptions(e));this.appendChart(n,t)}},createLineChart:function(e,t){if(0!==e.length){var n=new Vo(this,this.chartOptions(e));this.appendChart(n,t)}},createBarChart:function(e,t){var n,i,o;0!==e.length&&(n=e[0],i=this.chartOptions(e),i.gap=n.gap,i.spacing=n.spacing,o=new Ko(this,i),this.appendChart(o,t),this._hasBarCharts=!0)},seriesCategoryAxis:function(){return this.categoryAxis},_dispatchEvent:function(e,t,n){var i=e._eventCoordinates(t),o=new _e(i.x,i.y),r=this.categoryAxis.getCategory(o),s=this.valueAxis.getValue(o);null!==r&&null!==s&&e.trigger(n,{element:Ae(t),category:r,value:s})},createCrosshairs:function(){}}),Te(Yo.prototype,Ri,{appendChart:Zi.prototype.appendChart,aggregateSeries:Zi.prototype.aggregateSeries}),ye(Yo,{categoryAxis:{categories:[]},valueAxis:{}}),Qo=ve.extend({init:function(e,t,n){ve.fn.init.call(this,t),this.value=e,this.options.index=n.index},reflow:function(e){var t=this.points,n=this.children[0];this.box=new be(t[0].x,t[0].y,t[1].x,t[2].y),n&&n.reflow(new be(e.x1,t[0].y,e.x2,t[2].y))},createVisual:function(){var e,t=this,n=this.options;ve.fn.createVisual.call(this),e=n.visual?n.visual({category:this.category,dataItem:this.dataItem,value:this.value,series:this.series,percentage:this.percentage,points:this.points,options:n,sender:this.getSender(),createVisual:function(){return t.createPath()}}):this.createPath(),e&&this.visual.append(e)},createPath:function(){var e=this.options,t=e.border,n=Xe.fromPoints(this.points,{fill:{color:e.color,opacity:e.opacity},stroke:{color:t.color,opacity:t.opacity,width:t.width}}).close();return n},createHighlight:function(e){return Xe.fromPoints(this.points,e)},highlightVisual:function(){return this.visual.children[0]},highlightVisualArgs:function(){var e=Xe.fromPoints(this.points).close();return{options:this.options,path:e}},tooltipAnchor:function(){var e=this.box;return{point:new _e(e.center().x,e.y1),align:{horizontal:"center",vertical:"top"}}},formatValue:function(e){var t=this;return t.owner.formatPointValue(t,e)}}),ye(Qo,{color:re,border:{width:1}}),Te(Qo.prototype,qn),Xo=ve.extend({init:function(e,t){ve.fn.init.call(this,t),this.plotArea=e,this.points=[],this.labels=[],this.legendItems=[],this.render()},formatPointValue:function(e,t){return this.chartService.format.auto(t,e.value)},render:function(){var e,t,n,i,o,r,s,a,l,c,d,u=this,h=this,f=h.options,p=h.plotArea.options.seriesColors;if(void 0===p&&(p=[]),e=f.series[0],t=e.data)for(n=m(e),i=n.total,o=n.points,r=0;r<o.length;r++)s=o[r],s&&(a=s.fields,xe(e.color)||(e.color=a.color||p[r%p.length]),a=Te({index:r,owner:u,series:e,dataItem:t[r],percentage:s.value/i},a,{visible:s.visible}),l=s.valueFields.value,c=u.createSegment(l,a),d=u.createLabel(l,a),c&&d&&c.append(d))},evalSegmentOptions:function(e,t,n){var o=n.series;i(e,{value:t,series:o,dataItem:n.dataItem,index:n.index},{defaults:o._defaults,excluded:["data","content","template","toggle","visual"]})},createSegment:function(t,n){var i,o=Te({},n.series);if(this.evalSegmentOptions(o,t,n),this.createLegendItem(t,o,n),n.visible!==!1)return i=new Qo(t,o,n),e.extend(i,n),this.append(i),this.points.push(i),i},createLabel:function(e,t){var n,i,o,r=t.series,s=t.dataItem,a=Te({},this.options.labels,r.labels),l=e;if(a.visible)return n=Ee(a),n?l=n({dataItem:s,value:e,percentage:t.percentage,category:t.category,series:r}):a.format&&(l=this.plotArea.chartService.format.auto(a.format,l)),a.color||(i=new tt(r.color).percBrightness(),a.color=i>180?de:re,a.background||(a.background=r.color)),this.evalSegmentOptions(a,e,t),o=new Ie(l,Te({vAlign:a.position},a)),this.labels.push(o),o},labelPadding:function(){var e,t,n,i,o=this.labels,r={left:0,right:0};for(e=0;e<o.length;e++)t=o[e],n=t.options.align,n!==te&&(i=o[e].box.width(),n===oe?r.left=Math.max(r.left,i):r.right=Math.max(r.right,i));return r},dynamicSlopeReflow:function(e,t,n){var i,o,r,s,a,l,c,d,u,h,f,p=this,m=p.options,g=p.points,v=g.length,_=g[0],b=_;for(i=0;i<g.length;i++)g[i].percentage>b.percentage&&(b=g[i]);for(o=_.percentage/b.percentage*t,r=(t-o)/2,s=0,a=0;a<v;a++)l=g[a].percentage,c=g[a+1],d=c?c.percentage:l,u=g[a].points=[],h=m.dynamicHeight?n*l:n/v,f=void 0,f=l?(t-o*(d/l))/2:d?0:t/2,f=Ke(f,0,t),u.push(new it(e.x1+r,e.y1+s)),u.push(new it(e.x1+t-r,e.y1+s)),u.push(new it(e.x1+t-f,e.y1+h+s)),u.push(new it(e.x1+f,e.y1+h+s)),r=f,s+=h+m.segmentSpacing,o=Ke(t-2*f,0,t)},constantSlopeReflow:function(e,t,n){var i,o,r,s,a,l=this,c=l.options,d=l.points,u=d.length,h=c.neckRatio<=1,f=h?c.neckRatio*t:t,p=h?0:(t-t/c.neckRatio)/2,m=h?t:t-2*p,g=(m-f)/2,v=0;for(i=0;i<u;i++)o=d[i].points=[],r=d[i].percentage,s=c.dynamicHeight?g*r:g/u,a=c.dynamicHeight?n*r:n/u,o.push(new it(e.x1+p,e.y1+v)),o.push(new it(e.x1+t-p,e.y1+v)),o.push(new it(e.x1+t-p-s,e.y1+a+v)),o.push(new it(e.x1+p+s,e.y1+a+v)),p+=s,v+=a+c.segmentSpacing},reflow:function(e){var t,n,i,o,r,s=this.points,a=s.length;if(a)for(t=this.options,n=e.clone().unpad(this.labelPadding()),i=n.height()-t.segmentSpacing*(a-1),o=n.width(),t.dynamicSlope?this.dynamicSlopeReflow(n,o,i):this.constantSlopeReflow(n,o,i),r=0;r<a;r++)s[r].reflow(e)}}),ye(Xo,{neckRatio:.3,width:300,dynamicSlope:!1,dynamicHeight:!0,segmentSpacing:0,labels:{visible:!1,align:te,position:te,zIndex:1}}),Te(Xo.prototype,So),Zo=Mi.extend({render:function(){this.createFunnelChart(this.series)},createFunnelChart:function(e){var t=e[0],n=new Xo(this,{series:e,legend:this.options.legend,neckRatio:t.neckRatio,dynamicHeight:t.dynamicHeight,dynamicSlope:t.dynamicSlope,segmentSpacing:t.segmentSpacing,highlight:t.highlight});this.appendChart(n)},appendChart:function(e,t){Mi.fn.appendChart.call(this,e,t),ze(this.options.legend.items,e.legendItems)}}),Jo="color",er="first",tr="from",nr="max",ir="min",or="noteText",rr="summary",sr="to",co.current.register(Zi,[Lt,Ut,Gt,dn,Bt,an,Vt,$t,Ot,cn,Ht,ln,on,nn,hn,qt,tn,un]),co.current.register(yo,[rn,sn,Nt]),co.current.register(Ao,[Kt]),co.current.register(Ro,[Wt]),co.current.register(Zo,[jt]),co.current.register(Oo,[Yt,Qt,Xt]),co.current.register(Yo,[Zt,Jt,en]),ct.current.register([Lt,Ut,Gt,dn,Bt,an],[ee],[Fn,Jo,or,kt,xt]),ct.current.register([on,nn,tn,un],[tr,sr],[Fn,Jo,or]),ct.current.register([hn,qt],[ee],[Fn,Jo,or,rr]),ct.current.register([Yt,Qt,Xt],[ae,le],[Jo]),ct.current.register([Zt,Jt,en],[ee],[Jo]),ct.current.register([jt],[ee],[Fn,Jo,"visibleInLegend","visible"]),zi.current.register([Lt,Ut,Gt,dn,Bt,an,hn,qt],{value:nr,color:er,noteText:er,errorLow:ir,errorHigh:nr}),zi.current.register([on,nn,tn,un],{from:ir,to:nr,color:er,noteText:er}),zi.current.register([Zt,Jt,en],{value:nr,color:er}),ct.current.register([rn,sn,Nt],[ae,le],[Jo,or,Ct,St,Tt,Dt]),ct.current.register([Nt],[ae,le,"size"],[Jo,Fn,or]),ct.current.register([Vt,$t],["open","high","low","close"],[Fn,Jo,"downColor",or]),zi.current.register([Vt,$t],{open:nr,high:nr,low:ir,close:nr,color:er,downColor:er,noteText:er}),ct.current.register([Ht,ln],["lower","q1","median","q3","upper","mean","outliers"],[Fn,Jo,or]),zi.current.register([Ht,ln],{lower:nr,q1:nr,median:nr,q3:nr,upper:nr,mean:nr,outliers:er,color:er,noteText:er}),ct.current.register([Ot,cn],["current","target"],[Fn,Jo,"visibleInLegend",or]),zi.current.register([Ot,cn],{current:nr,target:nr,color:er,noteText:er}),ct.current.register([Kt,Wt],[ee],[Fn,Jo,"explode","visibleInLegend","visible"]),ar=[Fn,ee,ae,le],lr="mousemove",cr="contextmenu",dr=20,ur=Y.extend({init:function(e,t,n,i){var o,r=this;void 0===i&&(i={}),this.observers=[],this.addObserver(i.observer),this.chartService=new Ge.ChartService(this,i),this.chartService.theme=n,this._initElement(e),o=Te({},this.options,t),this._originalOptions=Te({},o),this._theme=n,this._initTheme(o,n),this._initSurface(),this._initHandlers(),this.bindCategories(),K.FontLoader.preloadFonts(t,function(){r._destroyed||(r.trigger("init"),r._redraw(),r._attachEvents())})},_initElement:function(e){for(this._setElementClass(e),e.style.position="relative";e.firstChild;)e.removeChild(e.firstChild);this.element=e},_setElementClass:function(e){K.addClass(e,"k-chart")},_initTheme:function(t,n){var i,o=[],r=t.series||[];for(i=0;i<r.length;i++)o.push(e.extend({},r[i]));t.series=o,H(t),this.applyDefaults(t,n),null===t.seriesColors&&delete t.seriesColors,this.options=Te({},n,t),this.applySeriesColors()},getSize:function(){return{width:this.element.offsetWidth,height:this.element.offsetHeight}},resize:function(e){var t=this.getSize(),n=this._size;(e||(t.width>0||t.height>0)&&(!n||t.width!==n.width||t.height!==n.height))&&(this._size=t,this._resize(t,e),this.trigger("resize",t))},_resize:function(){this._noTransitionsRedraw()},redraw:function(e){var t,n;this.applyDefaults(this.options),this.applySeriesColors(),e?(t=this._model._plotArea,n=t.findPane(e),t.redraw(n)):this._redraw()},getAxis:function(e){var t,n=this._plotArea.axes;for(t=0;t<n.length;t++)if(n[t].options.name===e)return new rt(n[t])},findAxisByName:function(e){return this.getAxis(e)},findPaneByName:function(e){var t,n=this._plotArea.panes;for(t=0;t<n.length;t++)if(n[t].options.name===e)return new st(n[t])},findPaneByIndex:function(e){var t=this._plotArea.panes;if(t[e])return new st(t[e])},plotArea:function(){return new at(this._plotArea)},toggleHighlight:function(e,t){var n,i,o,r=this._plotArea,s=(r.srcSeries||r.series||[])[0];xe(t)?n=r.filterPoints(t):(Se(t)?(i=t.series,o=t.category):i=o=t,n=s.type===Wt?N(r.pointsBySeriesName(i),o):s.type===Kt||s.type===jt?N((r.charts[0]||{}).points,o):r.pointsBySeriesName(i)),n&&this.togglePointsHighlight(e,n)},togglePointsHighlight:function(e,t){var n,i=this._highlight;for(n=0;n<t.length;n++)i.togglePointHighlight(t[n],e)},showTooltip:function(e){var t,n,i,o=this._sharedTooltip(),r=this,s=r._tooltip,a=r._plotArea;xe(e)?(t=a.findPoint(e),t&&o&&(n=t.categoryIx)):o&&pe(e)&&(n=a.categoryAxis.categoryIndex(e)),o?n>=0&&(i=this._plotArea.pointsByCategoryIndex(n),s.showAt(i)):t&&s.show(t)},hideTooltip:function(){this._tooltip.hide()},_initSurface:function(){var e=this.surface,t=this._surfaceWrap(),n=this.options.chartArea;n.width&&K.elementSize(t,{width:n.width}),n.height&&K.elementSize(t,{height:n.height}),e&&e.options.type===this.options.renderAs?(this.surface.clear(),this.surface.resize()):(e&&e.destroy(),this.surface=Qe.Surface.create(t,{type:this.options.renderAs}))},_surfaceWrap:function(){return this.element},_redraw:function(){var e=this._getModel();this._destroyView(),this._model=e,this._plotArea=e._plotArea,e.renderVisual(),this.options.transitions!==!1&&e.traverse(function(e){e.animation&&e.animation.setup()}),this._initSurface(),this.surface.draw(e.visual),this.options.transitions!==!1&&e.traverse(function(e){e.animation&&e.animation.play()}),this._tooltip=this._createTooltip(),this._highlight=new Ji,this._setupSelection(),this._createPannable(),this._createZoomSelection(),this._createMousewheelZoom(),this.trigger(En),this._navState||this._cancelDomEvents()},exportVisual:function(e){var t,n,i,o;return e&&(e.width||e.height||e.options)?(n=this.options,i=Te({},e.options,{chartArea:{width:e.width,height:e.height}}),$(this._originalOptions,i),this.options=Te({},this._originalOptions,i),this._initTheme(this.options,this._theme),this.bindCategories(),o=this._getModel(),o.renderVisual(),t=o.visual,this.options=n):t=this.surface.exportVisual(),t},_sharedTooltip:function(){return this._plotArea instanceof Zi&&this.options.tooltip.shared},_createPannable:function(){var e=this.options;e.pannable!==!1&&(this._pannable=new eo(this._plotArea,e.pannable))},_createZoomSelection:function(){var e=this.options.zoomable,t=(e||{}).selection;e!==!1&&t!==!1&&(this._zoomSelection=new to(this,t))},_toggleDomDrag:function(){var e,t,n;this.domEvents&&this.domEvents.toggleDrag&&(e=this.options.pannable,t=this.options.zoomable,n=(t||{}).selection,this.domEvents.toggleDrag(e||t!==!1&&n!==!1||this.requiresHandlers([kn,wn,yn])?!0:!1))},_createMousewheelZoom:function(){var e=this.options.zoomable,t=(e||{}).mousewheel;e!==!1&&t!==!1&&(this._mousewheelZoom=new no(this,t))},_toggleDomZoom:function(){var e,t;this.domEvents&&this.domEvents.toggleZoom&&(e=this.options.zoomable,t=(e||{}).mousewheel,this.domEvents.toggleZoom(e!==!1&&t!==!1||this.requiresHandlers([xn,Cn,Sn])?!0:!1))},_createTooltip:function(){var e,t=this,n=t.options.tooltip;return e=this._sharedTooltip()?this._createSharedTooltip(n):new po(this.chartService,n)},_createSharedTooltip:function(e){return new mo(this._plotArea,e)},applyDefaults:function(e,t){O(e,t),V(e,t)},applySeriesColors:function(){var e,t,n,i,o=this.options,r=o.series,s=o.seriesColors||[];for(e=0;e<r.length;e++)t=r[e],n=s[e%s.length],i=t._defaults,t.color=t.color||n,i&&(i.color=i.color||n)},_getModel:function(){var e=this.options,t=this._createPlotArea(),n=new K.RootElement(this._modelOptions());return n.chart=this,n._plotArea=t,K.Title.buildTitle(e.title,n),e.legend.visible&&n.append(new lo(t.options.legend,this.chartService)),n.append(t),n.reflow(),n},_modelOptions:function(){var e=this,t=e.options,n=e.element,i=K.elementSize(n);return this._size=null,Te({width:Math.floor(i.width)||X.DEFAULT_WIDTH,height:Math.floor(i.height)||X.DEFAULT_HEIGHT,transitions:t.transitions},t.chartArea)},_createPlotArea:function(e){var t=this.options,n=co.current.create(e?[]:t.series,t,this.chartService);return n},_hasSelection:function(){return this._selections&&this._selections.length},_setupSelection:function(){var e,t,n,i,o,r,s=this,a=this,l=a._plotArea.axes,c=this._selections=[];for(e=0;e<l.length;e++)t=l[e],n=t.options,t instanceof He&&n.select&&!n.vertical&&(i=0,o=n.categories.length-1,t instanceof Ue&&(i=n.categories[i],o=n.categories[o]),n.justified||(t instanceof Ue?o=K.addDuration(o,1,n.baseUnit,n.weekStartDay):o++),r=new fo(s,t,Te({min:i,max:o},n.select)),c.push(r))},_selectStart:function(e){return this.trigger(Tn,e)},_select:function(e){return this.trigger(Dn,e)},_selectEnd:function(e){return this.trigger(An,e)},_initHandlers:function(){this._clickHandler=this._click.bind(this),this._mousewheelHandler=this._mousewheel.bind(this),this._surfaceMouseenterHandler=this._mouseover.bind(this),this._surfaceMouseleaveHandler=this._mouseout.bind(this),this._mousemove=kendo.throttle(this._mousemove.bind(this),dr)},addObserver:function(e){e&&this.observers.push(e)},removeObserver:function(e){var t=this.observers.indexOf(e);t>=0&&this.observers.splice(t,1)},requiresHandlers:function(e){var t,n=this.observers;for(t=0;t<n.length;t++)if(n[t].requiresHandlers(e))return!0},trigger:function(e,t){var n,i,o;for(void 0===t&&(t={}),e===In&&(t.anchor.point=this._toDocumentCoordinates(t.anchor.point)),t.sender=this,n=this.observers,i=!1,o=0;o<n.length;o++)n[o].trigger(e,t)&&(i=!0);return i},_attachEvents:function(){var e,t,n=this,i=n.element,o=n.surface;o.bind("mouseenter",this._surfaceMouseenterHandler),o.bind("mouseleave",this._surfaceMouseleaveHandler),qe(i,(e={},e[cr]=this._clickHandler,e[Ln]=this._mousewheelHandler,e)),this._shouldAttachMouseMove()&&qe(i,(t={},t[lr]=this._mousemove,t)),this.domEvents=Ge.DomEventsBuilder.create(this.element,{start:this._start.bind(this),move:this._move.bind(this),end:this._end.bind(this),tap:this._tap.bind(this),gesturestart:this._gesturestart.bind(this),gesturechange:this._gesturechange.bind(this),gestureend:this._gestureend.bind(this)}),this._toggleDomDrag(),this._toggleDomZoom()},_cancelDomEvents:function(){this.domEvents&&this.domEvents.cancel&&this.domEvents.cancel()},_gesturestart:function(e){this._mousewheelZoom&&!this._stopDragEvent(e)&&(this._gestureDistance=e.distance,this._unsetActivePoint(),this.surface.suspendTracking())},_gestureend:function(e){this._zooming&&!this._stopDragEvent(e)&&(this.surface&&this.surface.resumeTracking(),this._zooming=!1,this.trigger(Sn,{}))},_gesturechange:function(e){var t,n,i,o,r=this._mousewheelZoom;r&&!this._stopDragEvent(e)&&(e.preventDefault(),t=this._gestureDistance,n=-e.distance/t+1,Math.abs(n)>=.1&&(n=Math.round(10*n),this._gestureDistance=e.distance,i={delta:n,axisRanges:W(this._plotArea.axes),originalEvent:e},!this._zooming&&this.trigger(xn,i)||(this._zooming||(this._zooming=!0),o=i.axisRanges=r.updateRanges(n),o&&!this.trigger(Cn,i)&&r.zoom())))},_mouseout:function(e){if(e.element){var t=this._drawingChartElement(e.element,e);t&&t.leave&&t.leave(this,e.originalEvent)}},_start:function(e){var t=this._eventCoordinates(e);!this._stopDragEvent(e)&&this._plotArea.backgroundContainsPoint(t)&&(this.requiresHandlers([kn,wn,yn])&&this._startNavigation(e,t,kn),this._pannable&&this._pannable.start(e)&&(this.surface.suspendTracking(),this._unsetActivePoint(),this._suppressHover=!0),this._zoomSelection&&this._zoomSelection.start(e)&&this.trigger(xn,{axisRanges:W(this._plotArea.axes),originalEvent:e}))},_move:function(e){var t,n,i,o,r,s,a,l,c=this,d=c._navState,u=c._pannable;if(!this._stopDragEvent(e)){if(u)t=u.move(e),t&&!this.trigger(wn,{axisRanges:t,originalEvent:e})&&u.pan();else if(d){for(n={},i=d.axes,o=0;o<i.length;o++)r=i[o],
s=r.options.name,s&&(a=r.options.vertical?e.y:e.x,l=a.startLocation-a.location,0!==l&&(n[r.options.name]=r.translateRange(l)));d.axisRanges=n,this.trigger(wn,{axisRanges:n,originalEvent:e})}this._zoomSelection&&this._zoomSelection.move(e)}},_end:function(e){var t,n;this._stopDragEvent(e)||(t=this._pannable,t&&t.end(e)?(this.surface.resumeTracking(),this.trigger(yn,{axisRanges:W(this._plotArea.axes),originalEvent:e}),this._suppressHover=!1):this._endNavigation(e,yn),this._zoomSelection&&(n=this._zoomSelection.end(e),n&&!this.trigger(Cn,{axisRanges:n,originalEvent:e})&&(this._zoomSelection.zoom(),this.trigger(Sn,{axisRanges:n,originalEvent:e}))))},_stopDragEvent:function(){return this._hasSelection()},_mousewheel:function(e){var t,n,i,o,r,s,a,l,c,d=this,u=K.mousewheelDelta(e),h=this._mousewheelZoom,f=this._eventCoordinates(e);if(this._plotArea.backgroundContainsPoint(f))if(h)t={delta:u,axisRanges:W(this._plotArea.axes),originalEvent:e},!this._zooming&&this.trigger(xn,t)||(e.preventDefault(),this._zooming||(this._unsetActivePoint(),this.surface.suspendTracking(),this._zooming=!0),this._mwTimeout&&clearTimeout(this._mwTimeout),t.axisRanges=h.updateRanges(u),t.axisRanges&&!this.trigger(Cn,t)&&h.zoom(),this._mwTimeout=setTimeout(function(){d.trigger(Sn,t),d._zooming=!1,d.surface&&d.surface.resumeTracking()},Hn));else if(n=this._navState,n||(i=this._startNavigation(e,f,xn),i||(n=this._navState)),n){for(o=n.totalDelta||u,n.totalDelta=o+u,r=this._navState.axes,s={},a=0;a<r.length;a++)l=r[a],c=l.options.name,c&&(s[c]=l.scaleRange(-o));this.trigger(Cn,{delta:u,axisRanges:s,originalEvent:e}),this._mwTimeout&&clearTimeout(this._mwTimeout),this._mwTimeout=setTimeout(function(){d._endNavigation(e,Sn)},Hn)}},_startNavigation:function(e,t,n){var i,o,r=this._model._plotArea,s=r.findPointPane(t),a=r.axes.slice(0);s&&(i=W(a),o=this.trigger(n,{axisRanges:i,originalEvent:e}),o?this._cancelDomEvents():(this._suppressHover=!0,this._unsetActivePoint(),this._navState={axisRanges:i,pane:s,axes:a}))},_endNavigation:function(e,t){this._navState&&(this.trigger(t,{axisRanges:this._navState.axisRanges,originalEvent:e}),this._suppressHover=!1,this._navState=null)},_getChartElement:function(e,t){var n=this.surface.eventTarget(e);if(n)return this._drawingChartElement(n,e,t)},_drawingChartElement:function(e,t,n){for(var i,o=e;o&&!i;)i=o.chartElement,o=o.parent;if(i)return i.aliasFor&&(i=i.aliasFor(t,this._eventCoordinates(t))),n&&(i=i.closest(n),i&&i.aliasFor&&(i=i.aliasFor())),i},_eventCoordinates:function(e){var t=K.eventCoordinates(e);return this._toModelCoordinates(t.x,t.y)},_elementPadding:function(){var e,t,n;return this._padding||(e=We(this.element,["paddingLeft","paddingTop"]),t=e.paddingLeft,n=e.paddingTop,this._padding={top:n,left:t}),this._padding},_toDocumentCoordinates:function(e){var t=this._elementPadding(),n=K.elementOffset(this.element);return{left:Oe(e.x+t.left+n.left),top:Oe(e.y+t.top+n.top)}},_toModelCoordinates:function(e,t){var n=this.element,i=K.elementOffset(n),o=this._elementPadding();return new _e(e-i.left-o.left,t-i.top-o.top)},_tap:function(e){var t=this,n=this.surface.eventTarget(e),i=this._drawingChartElement(n,e);this._activePoint===i?this._propagateClick(i,e):(this._startHover(n,e)||this._unsetActivePoint(),this._propagateClick(i,e)),this.handlingTap=!0,setTimeout(function(){t.handlingTap=!1},0)},_click:function(e){var t=this._getChartElement(e);this._propagateClick(t,e)},_propagateClick:function(e,t){for(var n=this,i=e;i;)i.click&&i.click(n,t),i=i.parent},_startHover:function(e,t){var n,i,o=this._drawingChartElement(e,t),r=this,s=r._tooltip,a=r._highlight;return!(this._suppressHover||!a||a.isHighlighted(o)||this._sharedTooltip())&&(n=this._drawingChartElement(e,t,function(e){return e.hover&&!(e instanceof Mi)}),n&&!n.hover(this,t)?(this._activePoint=n,i=Te({},i,n.options.tooltip),i.visible&&s.show(n),a.show(n),n):void 0)},_mouseover:function(e){var t,n=this._startHover(e.element,e.originalEvent);n&&n.tooltipTracking&&(this._mouseMoveTrackHandler=this._mouseMoveTrackHandler||this._mouseMoveTracking.bind(this),qe(document,(t={},t[lr]=this._mouseMoveTrackHandler,t)))},_mouseMoveTracking:function(e){var t,n,i,o=this,r=o.options,s=o._tooltip,a=o._highlight,l=o._activePoint,c=this._eventCoordinates(e);this._plotArea.box.containsPoint(c)?l&&l.tooltipTracking&&l.series&&l.parent.getNearestPoint&&(t=l.parent.getNearestPoint(c.x,c.y,l.seriesIx),t&&t!==l&&(t.hover(this,e),this._activePoint=t,n=Te({},r.tooltip,l.options.tooltip),n.visible&&s.show(t),a.show(t))):($e(document,(i={},i[lr]=this._mouseMoveTrackHandler,i)),this._unsetActivePoint())},_mousemove:function(e){var t=this._eventCoordinates(e);this._trackCrosshairs(t),this._plotArea.hover&&this._plotArea.hover(this,e),this._sharedTooltip()&&this._trackSharedTooltip(t,e)},_trackCrosshairs:function(e){var t,n,i=this._plotArea.crosshairs;for(t=0;t<i.length;t++)n=i[t],n.box.containsPoint(e)?n.showAt(e):n.hide()},_trackSharedTooltip:function(e,t){var n,i,o,r,s=this,a=s.options.tooltip,l=s._plotArea,c=s._plotArea.categoryAxis,d=s._tooltip,u=s._highlight;l.box.containsPoint(e)&&(n=c.pointCategoryIndex(e),n!==this._tooltipCategoryIx&&(i=l.pointsByCategoryIndex(n),o=i.map(function(e){return e.eventArgs(t)}),r=o[0]||{},r.categoryPoints=o,i.length>0&&!this.trigger(vn,r)?(a.visible&&d.showAt(i,e),u.show(i)):d.hide(),this._tooltipCategoryIx=n))},hideElements:function(){var e=this,t=e._plotArea,n=e._tooltip,i=e._highlight;this._mousemove.cancel(),t.hideCrosshairs(),i.hide(),n.hide(),delete this._tooltipCategoryIx},_unsetActivePoint:function(){var e=this,t=e._tooltip,n=e._highlight;this._activePoint=null,t&&t.hide(),n&&n.hide()},_deferRedraw:function(){this._redraw()},_clearRedrawTimeout:function(){this._redrawTimeout&&(clearInterval(this._redrawTimeout),this._redrawTimeout=null)},bindCategories:function(){var e,t,n=this,i=this.options,o=[].concat(i.categoryAxis);for(e=0;e<o.length;e++)t=o[e],t.autoBind!==!1&&n.bindCategoryAxisFromSeries(t,e)},bindCategoryAxisFromSeries:function(e,t){var i,o,r,s,a,l,c,d,u,h,f,p=this,m=this.options.series,g=m.length,v={},w=[];for(o=0;o<g;o++)if(r=m[o],s=r.categoryAxis===e.name||!r.categoryAxis&&0===t,a=r.data,l=a.length,r.categoryField&&s&&l>0)for(i=b(e,n(r.categoryField,a[0])),c=i?_:n,d=0;d<l;d++)u=a[d],h=c(r.categoryField,u,p.chartService.intl),!i&&v[h]||(w.push([h,u]),i||(v[h]=!0));w.length>0&&(i&&(w=q(w,function(e,t){return K.dateComparer(e[0],t[0])})),f=G(w),e.categories=f[0])},_isBindable:function(e){var t,n,i=ct.current.valueFields(e),o=!0;for(t=0;t<i.length;t++)if(n=i[t],n===ee?n="field":n+="Field",!pe(e[n])){o=!1;break}return o},_noTransitionsRedraw:function(){var e,t=this.options;t.transitions&&(t.transitions=!1,e=!0),this._redraw(),e&&(t.transitions=!0)},_legendItemHover:function(e,t){var n,i=this,o=i._plotArea,r=i._highlight,s=(o.srcSeries||o.series)[e];n=ke(s.type,[Kt,Wt,jt])?o.findPoint(function(n){return n.series.index===e&&n.index===t}):o.pointsBySeriesIndex(e),r.show(n)},_shouldAttachMouseMove:function(){return this._plotArea.crosshairs.length||this._tooltip&&this._sharedTooltip()||this.requiresHandlers([bn])},updateMouseMoveHandler:function(){var e,t;$e(this.element,(e={},e[lr]=this._mousemove,e)),this._shouldAttachMouseMove()&&qe(this.element,(t={},t[lr]=this._mousemove,t))},applyOptions:function(e,t){$(this._originalOptions,e),this._originalOptions=Te(this._originalOptions,e),this.options=Te({},this._originalOptions),t&&(this._theme=t,this.chartService.theme=t),this._initTheme(this.options,this._theme)},setOptions:function(e,t){this.applyOptions(e,t),this.bindCategories(),this.redraw(),this.updateMouseMoveHandler(),this._toggleDomDrag(),this._toggleDomZoom()},destroy:function(){var e,t;this._destroyed=!0,$e(this.element,(e={},e[cr]=this._clickHandler,e[Ln]=this._mousewheelHandler,e[lr]=this._mousemove,e)),this.domEvents&&(this.domEvents.destroy(),delete this.domEvents),$e(document,(t={},t[lr]=this._mouseMoveTrackHandler,t)),this._destroyView(),this.surface&&(this.surface.destroy(),this.surface=null),this._clearRedrawTimeout()},_destroyView:function(){var e=this,t=e._model,n=e._selections;if(t&&(t.destroy(),this._model=null),n)for(;n.length>0;)n.shift().destroy();this._unsetActivePoint(),this._tooltip&&this._tooltip.destroy(),this._highlight&&this._highlight.destroy(),this._zoomSelection&&(this._zoomSelection.destroy(),delete this._zoomSelection),this._pannable&&(this._pannable.destroy(),delete this._pannable),this._mousewheelZoom&&(this._mousewheelZoom.destroy(),delete this._mousewheelZoom)}}),ye(ur,{renderAs:"",chartArea:{},legend:{visible:!0,labels:{}},categoryAxis:{},seriesDefaults:{type:Ut,data:[],highlight:{visible:!0},labels:{},negativeValues:{visible:!1}},series:[],seriesColors:null,tooltip:{visible:!1},transitions:!0,valueAxis:{},plotArea:{},title:{},xAxis:{},yAxis:{},panes:[{}],pannable:!1,zoomable:!1}),kendo.deepExtend(kendo.dataviz,{constants:Nn,Aggregates:lt,AreaChart:ri,AreaSegment:ni,AxisGroupRangeTracker:si,Bar:ci,BarChart:hi,BarLabel:ai,BoxPlotChart:vi,BoxPlot:mi,BubbleChart:yi,Bullet:xi,BulletChart:Ci,CandlestickChart:pi,Candlestick:fi,CategoricalChart:jn,CategoricalErrorBar:Un,CategoricalPlotArea:Zi,Chart:ur,ChartContainer:Ai,ClipAnimation:Jn,ClusterLayout:di,Crosshair:Di,CrosshairTooltip:Ti,DefaultAggregates:zi,DonutChart:Mo,DonutPlotArea:Ro,DonutSegment:Eo,ErrorBarBase:Vn,ErrorRangeCalculator:pt,Highlight:Ji,SharedTooltip:mo,Legend:lo,LegendItem:oo,LegendLayout:io,LineChart:ti,LinePoint:$n,LineSegment:Kn,Pane:Ei,PieAnimation:bo,PieChart:Do,PieChartMixin:So,PiePlotArea:Ao,PieSegment:ko,PlotAreaBase:Mi,PlotAreaEventsMixin:Ri,PlotAreaFactory:co,PointEventsMixin:qn,RangeBar:Pi,RangeBarChart:Bi,RangeAreaPoint:Vi,RangeAreaChart:qi,ScatterChart:bi,ScatterErrorBar:_i,ScatterLineChart:wo,Selection:fo,SeriesAggregator:Fi,SeriesBinder:ct,SplineSegment:Xn,SplineAreaSegment:oi,StackWrap:ui,Tooltip:po,OHLCChart:$i,OHLCPoint:Gi,WaterfallChart:Yi,WaterfallSegment:Ki,XYPlotArea:yo,MousewheelZoom:no,ZoomSelection:to,Pannable:eo,ChartAxis:rt,ChartPane:st,ChartPlotArea:at,anyHasZIndex:s,appendIfNotNull:d,areNumbers:d,bindSegments:m,categoriesCount:o,countNumbers:t,equalsIgnoreCase:g,evalOptions:i,filterSeriesByType:v,getDateField:_,getField:n,hasGradientOverlay:a,hasValue:u,isDateAxis:b,segmentVisible:p,singleItemOrArray:w})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/chart/chart.min",["dataviz/chart/kendo-chart.min","kendo.data.min","kendo.dataviz.core.min","kendo.dataviz.themes.min","kendo.drawing.min","kendo.userevents.min"],e)}(function(){return function(e,t){function n(e){s.fn[e]=function(){var t=this._instance;if(t)return t[e].apply(t,arguments)}}function i(e,n){var i,o,r,s=[],a=e.groupNameTemplate,l=n.length;if(0===l)return r=T({},e),r.visibleInLegend=!1,[r];for(D(a)?(g.logToConsole("'groupNameTemplate' is obsolete and will be removed in future versions. Specify the group name template as 'series.name'"),a&&(i=P(a))):(i=P(e.name||""),0===i._slotCount&&(i=P(D(e.name)?"#= group.value #: #= series.name #":"#= group.value #"))),o=0;o<l;o++)r=T({},e),g.isFunction(r.color)||(r.color=t),r._groupIx=o,r._groupValue=n[o].value,s.push(r),i&&(r.name=i({series:r,group:n[o]}));return s}function o(e){for(var n in e)e[n]===t&&(e[n]="");return e}var r,s,a,l,c,d,u,h,f,p,m=".kendoChart",g=window.kendo,v=g.Class,_=g._outerWidth,b=g._outerHeight,w=g.dataviz,y=w.constants,k=w.Chart,x=w.SeriesBinder,C=g.ui.Widget,S=g.data.DataSource,T=g.deepExtend,D=w.defined,A=w.getField,E=w.InstanceObserver,I=w.inArray,M=w.services,R=e.proxy,F=e.isArray,z=e.extend,P=g.template,B="mouseleave"+m,L=y.AXIS_LABEL_CLICK,H=y.LEGEND_ITEM_CLICK,N=y.LEGEND_ITEM_HOVER,O=y.SERIES_CLICK,V=y.SERIES_HOVER,U=y.PLOT_AREA_CLICK,W=y.PLOT_AREA_HOVER,j=y.DRAG,q=y.DRAG_END,G=y.DRAG_START,$=y.ZOOM_START,K=y.ZOOM,Y=y.ZOOM_END,Q=y.SELECT_START,X=y.SELECT,Z=y.SELECT_END,J=y.RENDER,ee=y.NOTE_CLICK,te=y.NOTE_HOVER,ne="change",ie="dataBound",oe="leave",re=y.VALUE,se=y.PIE,ae=y.DONUT,le=y.FUNNEL,ce=g.Observable,de=150,ue=100,he="k-chart-tooltip-inverse",fe="k-chart-shared-tooltip",pe="rtl";for(M.DomEventsBuilder.register({create:function(e,t){return new g.UserEvents(e,T({global:!0,multiTouch:!0,fastTap:!0},t))}}),r=E.extend({handlerMap:{showTooltip:"_showTooltip",hideTooltip:"_hideTooltip",legendItemClick:"_onLegendItemClick",render:"_onRender",init:"_onInit"}}),s=C.extend({init:function(e,t){var n;g.destroy(e),C.fn.init.call(this,e),t&&(n=t.dataSource,delete t.dataSource),this.options=T({},this.options,t),this.wrapper=this.element,this._attachEvents(),t&&(t.dataSource=n),this._seriesVisibility=new c,this.bind(this.events,this.options),this._initDataSource(t),g.notify(this,w.ui)},events:[ie,O,V,L,H,N,U,W,G,j,q,$,K,Y,Q,X,Z,ee,te,J],options:{name:"Chart",renderAs:"",theme:"default",axisDefaults:{},chartArea:{},legend:{},categoryAxis:{},autoBind:!0,seriesDefaults:{},series:[],seriesColors:null,tooltip:{},transitions:!0,valueAxis:{},plotArea:{},title:{},xAxis:{},yAxis:{},panes:[{}],pannable:!1,zoomable:!1},items:function(){return e()},refresh:function(){var e=this,t=e._instance;t.applyDefaults(e.options),t.applySeriesColors(),e._bindSeries(),e._bindCategories(),e.trigger(ie),e._redraw()},getSize:function(){return g.dimensions(this.element)},redraw:function(e){this._size=null,this._instance.redraw(e)},setOptions:function(e){var t=this,n=e.dataSource;delete e.dataSource,C.fn._setEvents.call(t,e),this._instance.applyOptions(e,this._getThemeOptions(e)),this.options=this._instance.options,this._tooltip.setOptions(this.options.tooltip),this._seriesVisibility.setOptions(this.options),this._sourceSeries=null,n&&t.setDataSource(n),t._hasDataSource?t._onDataChanged():(t._bindCategories(),t.redraw()),t._instance.updateMouseMoveHandler()},setDataSource:function(e){var t=this;t.dataSource.unbind(ne,t._dataChangeHandler),t.dataSource=e=S.create(e),t._hasDataSource=!0,t._hasData=!1,e.bind(ne,t._dataChangeHandler),t.options.autoBind&&e.fetch()},destroy:function(){var e=this,t=e.dataSource;e.element.off(m),t&&t.unbind(ne,e._dataChangeHandler),e._instance&&(e._instance.destroy(),delete this._instance),this._tooltip&&(this._tooltip.destroy(),delete this._tooltip),this._destroyCrosshairTooltips(),C.fn.destroy.call(e)},findPaneByName:function(e){var t,n=this._plotArea.panes;for(t=0;t<n.length;t++)if(n[t].options.name===e)return new f(this,n[t])},findPaneByIndex:function(e){var t=this._plotArea.panes;if(t[e])return new f(this,t[e])},findSeries:function(e){var t,n=this._plotArea,i=n.srcSeries||n.series;for(t=0;t<i.length;t++)if(e(i[t]))return new p(this,i[t])},findSeriesByName:function(e){return this._createSeries({name:e})},findSeriesByIndex:function(e){return this._createSeries({index:e})},_createSeries:function(e){var t=this._seriesOptions(e);if(t)return new p(this,t)},_seriesOptions:function(e){var t,n,i=this._plotArea,o=i.srcSeries||i.series;if(D(e.index))t=o[e.index];else if(D(e.name))for(n=0;n<o.length;n++)if(o[n].name===e.name){t=o[n];break}return t},_attachEvents:function(){this.element.on(B,R(this._mouseleave,this))},_mouseleave:function(t){var n=this._instance,i=this._tooltip,o=t.relatedTarget;o&&e(o).closest(i.element).length||!n||n.handlingTap||n.hideElements()},_getThemeOptions:function(e){var n,i,o=(e||{}).theme;return"sass"===o||"default-v2"===o||"bootstrap-v4"===o?w.autoTheme().chart:D(o)?(n=w.ui.themes||{},i=n[o]||n[o.toLowerCase()]||{},i.chart||{}):t},_initChart:function(){this._createChart(this.options,this._getThemeOptions(this.options)),this.options=this._instance.options,this._seriesVisibility.setOptions(this.options)},_createChart:function(e,t){this._instance=new k(this.element[0],e,t,{observer:new r(this),sender:this,rtl:this._isRtl()})},_onInit:function(e){this._instance=e.sender},_initDataSource:function(e){var t=this,n=(e||{}).dataSource;t._dataChangeHandler=R(t._onDataChanged,t),t.dataSource=S.create(n).bind("change",t._dataChangeHandler),t._bindCategories(),n&&(t._hasDataSource=!0),this._initChart(),this._initTooltip(),n&&t.options.autoBind&&t.dataSource.fetch()},_destroyCrosshairTooltips:function(){var e,t=this._crosshairTooltips;if(t)for(e in t)t[e].destroy();this._crosshairTooltips={}},_getCrosshairTooltip:function(e,t){var n=this._crosshairTooltips=this._crosshairTooltips||{},i=e+t,o=n[i];return o||(o=n[i]=new h(this.element)),o},_showTooltip:function(e){if(e.crosshair){var t=this._getCrosshairTooltip(e.axisName,e.axisIndex);t.show(e)}else this._tooltip&&this._tooltip.show(e)},_hideTooltip:function(e){if(e.crosshair){var t=this._getCrosshairTooltip(e.axisName,e.axisIndex);t.hide()}else this._tooltip&&this._tooltip.hide(e)},_onRender:function(e){this._destroyCrosshairTooltips(),this._copyMembers(e.sender),this._hasDataSource&&!this._hasData&&this.options.autoBind||this.trigger(J)},_copyMembers:function(e){this.options=e.options,this._originalOptions=e._originalOptions,this.surface=e.surface,this._plotArea=e._plotArea,this._model=e._model,this._highlight=e._highlight,this._selections=e._selections,this._pannable=e._pannable,this._zoomSelection=e._zoomSelection,this._mousewheelZoom=e._mousewheelZoom},requiresHandlers:function(e){var t,n=this._events;for(t=0;t<e.length;t++)if(D(n[e[t]]))return!0},_initTooltip:function(){this._tooltip=this._createTooltip(),this._tooltip.bind(oe,R(this._tooltipleave,this))},_onLegendItemClick:function(e){this.trigger(H,e)||this._legendItemClick(e.seriesIndex,e.pointIndex)},_legendItemClick:function(t,n){var i,o,r,s=this._instance,a=s._plotArea,l=(a.srcSeries||a.series)[t];e.inArray(l.type,[se,ae,le])>=0?(i=l.data[n],i&&D(i.visible)?i.visible=!i.visible:(o=l.pointVisibility=l.pointVisibility||{},r=o[n],o[n]=!!D(r)&&!r)):(l.visible=!l.visible,this._seriesVisibility.save(l)),s._noTransitionsRedraw()},_createTooltip:function(){return new u(this.element,z({},this.options.tooltip,{rtl:this._isRtl()}))},_tooltipleave:function(){this._instance&&this._instance.hideElements()},_bindData:function(e){var t,n,o,r=this,s=r.options,a=r._sourceSeries||s.series,l=a.length,c=r.dataSource.view(),d=(r.dataSource.group()||[]).length>0,u=[],h=this._seriesVisibility;for(h.read(),t=0;t<l;t++)n=a[t],r._isBindable(n)&&d?(o=i(n,c),u=u.concat(o),h.applyByGroup(o,e)):(n=z({},n),u.push(n),h.applyByIndex(n,e));r._sourceSeries=a,s.series=u,this._instance.applySeriesColors(),r._bindSeries(),r._bindCategories(),this._hasData=!0},_onDataChanged:function(e){this._bindData(e),this.trigger(ie),this._redraw()},_bindSeries:function(){var e,t,n,i,o=this,r=o.dataSource.view(),s=o.options.series,a=s.length;for(e=0;e<a;e++)t=s[e],o._isBindable(t)&&(n=t._groupIx,i=D(n)?(r[n]||{}).items:r,t.autoBind!==!1&&(t.data=i))},_bindCategories:function(){var e,t,n=this,i=n.dataSource.view()||[],o=(n.dataSource.group()||[]).length>0,r=i,s=n.options,a=[].concat(s.categoryAxis);for(o&&i.length&&(r=i[0].items),e=0;e<a.length;e++)t=a[e],t.autoBind!==!1&&n._bindCategoryAxis(t,r,e)},_bindCategoryAxis:function(e,t,n){var i,o,r,s=(t||[]).length;if(e.field)for(e.categories=[],i=0;i<s;i++)r=t[i],o=A(e.field,r),0===i?(e.categories=[o],e.dataItems=[r]):(e.categories.push(o),e.dataItems.push(r));else this._instance&&this._instance.bindCategoryAxisFromSeries(e,n)},_isBindable:function(e){var t,n,i=x.current.valueFields(e),o=!0;for(n=0;n<i.length;n++)if(t=i[n],t===re?t="field":t+="Field",!D(e[t])){o=!1;break}return o},_isRtl:function(){return g.support.isRtl(this.element)&&this.element.css("direction")===pe}}),a=["getAxis","findAxisByName","plotArea","toggleHighlight","showTooltip","hideTooltip","exportVisual","_resize","_redraw","_noTransitionsRedraw","_legendItemHover","_eventCoordinates"],l=0;l<a.length;l++)n(a[l]);w.ExportMixin.extend(s.fn),g.PDFMixin&&g.PDFMixin.extend(s.fn),w.ui.plugin(s),c=v.extend({init:function(){this.groups={},this.index={},this.options={}},applyByGroup:function(e,t){if(t&&t.action||this.options.persistSeriesVisibility)for(var n=0;n<e.length;n++)this.groups[e[n]._groupValue]===!1&&(e[n].visible=!1);else this.groups={}},applyByIndex:function(e,t){t&&t.action||this.options.persistSeriesVisibility?this.index[e.index]===!1&&(e.visible=!1):this.index={}},save:function(e){e&&(this.options.persistSeriesVisibility?this.options.series[e.index].visible=e.visible:this.saveState(e))},setOptions:function(e){this.options=e,this.groups={},this.index={}},read:function(){var e,t,n=this.options;if(n.persistSeriesVisibility)for(e=n.series,t=0;t<e.length;t++)this.saveState(e[t])},saveState:function(e){D(e._groupValue)?this.groups[e._groupValue]=e.visible:this.index[e.index]=e.visible}}),d=g.geometry,u=ce.extend({init:function(t,n){var i,o=this;ce.fn.init.call(o),this.setOptions(n),o.chartElement=t,o.template=u.template,o.template||(o.template=u.template=g.template("<div class='k-tooltip k-chart-tooltip#= d.rtl ? \" k-rtl\" : \"\"#' style='display:none; position: absolute; font: #= d.font #;#if (d.border) {# border: #= d.border.width #px solid; #}#opacity: #= d.opacity #; filter: alpha(opacity=#= d.opacity * 100 #);'></div>",{useWithBlock:!1,paramName:"d"})),o.element=e(o.template(o.options)),o.move=R(o.move,o),o._mouseleave=R(o._mouseleave,o),i=g.format("[{0}='content'],[{0}='scroller']",g.attr("role")),o._mobileScroller=t.closest(i).data("kendoMobileScroller")},destroy:function(){this._clearShowTimeout(),this.element&&(this.element.off(B).remove(),this.element=null)},setOptions:function(e){this.options=T({},this.options,e)},options:{opacity:1,animation:{duration:de},sharedTemplate:"<table><th colspan='#= colspan #'>#= categoryText #</th># for(var i = 0; i < points.length; i++) { ## var point = points[i]; #<tr># if(colorMarker) { # <td><span class='k-chart-shared-tooltip-marker' style='background-color:#:point.series.color#'></span></td># } ## if(nameColumn) { # <td> #if (point.series.name) {# #: point.series.name #: #} else {# &nbsp; #}#</td># } #<td>#= content(point) #</td></tr># } #</table>",categoryFormat:"{0:d}"},move:function(){var e,t=this,n=t.options,i=t.element;t.anchor&&t.element&&(e=t._offset(),t.visible||i.css({top:e.top,left:e.left}),t.visible=!0,t._ensureElement(document.body),i.stop(!0,!0).show().animate({left:e.left,top:e.top},n.animation.duration))},_clearShowTimeout:function(){this.showTimeout&&(clearTimeout(this.showTimeout),this.showTimeout=null)},getAnchor:function(e){var t=this.anchor,n=t.point,i=t.align,o=n.left,r=n.top;return"center"===i.horizontal?o-=e.width/2:"right"===i.horizontal&&(o-=e.width),"center"===i.vertical?r-=e.height/2:"bottom"===i.vertical&&(r-=e.height),{x:o,y:r}},_offset:function(){var t,n,i=this,o=i._measure(),r=i.getAnchor(o),s=r.y,a=r.x,l=g.support.zoomLevel(),c=e(window),u=window.pageYOffset||document.documentElement.scrollTop||0,h=window.pageXOffset||document.documentElement.scrollLeft||0,f=(this._mobileScroller||{}).movable;return f&&1!==f.scale?(t=d.transform().scale(f.scale,f.scale,[f.x,f.y]),n=new d.Point(a,s).transform(t),a=n.x,s=n.y):(s+=i._fit(s-u,o.height,b(c)/l),a+=i._fit(a-h,o.width,_(c)/l)),{top:s,left:a}},show:function(e){this.anchor=e.anchor,this.element.css(o(e.style)),this.element.toggleClass(he,!!e.className),this.element.toggleClass(fe,!!e.shared);var t=e.shared?this._sharedContent(e):this._pointContent(e.point);this.element.html(t),this._clearShowTimeout(),this.showTimeout=setTimeout(this.move,ue)},hide:function(){var e=this;clearTimeout(e.showTimeout),e._hideElement(),e.visible&&(e.point=null,e.visible=!1,e.index=null)},_sharedContent:function(e){var t,n,i=e.points,o=w.grep(i,function(e){return D(e.series.name)}).length,r=e.series.length>1,s=1;return o&&s++,r&&s++,t=g.template(this.options.sharedTemplate),n=t({points:i,category:e.category,categoryText:e.categoryText,content:this._pointContent,colorMarker:r,nameColumn:o,colspan:s})},_measure:function(){this._ensureElement();var e={width:_(this.element),height:b(this.element)};return e},_ensureElement:function(){this.element&&this.element.appendTo(document.body).on(B,this._mouseleave)},_mouseleave:function(t){var n=t.relatedTarget,i=this.chartElement[0];n&&n!==i&&!e.contains(i,n)&&this.trigger(oe)},_hideElement:function(){var e=this,t=this.element;t&&t.fadeOut({always:function(){e.visible||t.off(B).remove()}})},_pointContent:function(e){var t,n,i=this,o=T({},i.options,e.options.tooltip);return D(e.value)&&(t=""+e.value),o.template?(n=P(o.template),t=n({value:e.value,category:e.category,series:e.series,dataItem:e.dataItem,percentage:e.percentage,runningTotal:e.runningTotal,total:e.total,low:e.low,high:e.high,xLow:e.xLow,xHigh:e.xHigh,yLow:e.yLow,yHigh:e.yHigh})):o.format&&(t=e.formatValue(o.format)),t},_fit:function(e,t,n){var i=0;return e+t>n&&(i=n-(e+t)),e<0&&(i=-e),i}}),h=u.extend({init:function(e,t){u.fn.init.call(this,e,t),this.element.addClass("k-chart-crosshair-tooltip")},show:function(e){var t=this.element;t&&(this.anchor=e.anchor,this.element.css(e.style),this.element.html(this.content(e)),this.move())},move:function(){var e=this,t=e.element,n=e._offset();e._ensureElement(),t.css({top:n.top,left:n.left}).show()},content:function(e){var t=e.value,n=e.crosshair.options.tooltip;return n.template&&(t=P(n.template)({value:t})),t},hide:function(){this.element.hide()}}),f=v.extend({init:function(e,t){this._chart=e,this._pane=t,this.visual=t.visual,this.chartsVisual=t.chartContainer.visual,this.name=t.options.name},series:function(){var e,t=this._chart,n=t._plotArea.groupSeriesByPane(),i=n[this.name||"default"],o=[];if(i)for(e=0;e<i.length;e++)o.push(new p(t,i[e]));return o}}),p=v.extend({init:function(e,t){this._chart=e,this._options=t},points:function(e){var t,n,i=this._points;return i||(t=this._seriesOptions(),n=this._chart._plotArea,this._points=i=n.pointsBySeriesIndex(t.index)),g.isFunction(e)&&(i=this._filterPoints(i,e)),i},data:function(e){var t,n,i,o,r=this._seriesOptions();return e&&(t=this._chart,n=t._plotArea,r.data=e,r.categoryField&&(i=n.seriesCategoryAxis(r),o=[].concat(t.options.categoryAxis),t._instance.bindCategoryAxisFromSeries(o[i.axisIndex],i.axisIndex)),t._noTransitionsRedraw(),this._clearFields()),r.data},findPoint:function(e){var t,n=this.points();for(t=0;t<n.length;t++)if(e(n[t]))return n[t]},toggleHighlight:function(e,t){t=t?g.isFunction(t)?this.points(t):F(t)?t:[t]:this.points(),this._chart._instance.togglePointsHighlight(e,t)},toggleVisibility:function(e,t){var n,i,o=this._chart,r=this._seriesOptions(),s=g.isFunction(t);if(s)if(I(r.type,[se,ae,le]))for(n=this._filterData(t),i=0;i<n.length;i++)n[i].visible=e;else r.visible=function(n){return!t(n.dataItem)||e};else r.visible=e,o._seriesVisibility.save(r);o._noTransitionsRedraw(),this._clearFields()},_filterData:function(e){var t,n=this._seriesOptions().data,i=n.length,o=[];for(t=0;t<i;t++)e(n[t])&&o.push(n[t]);return o},_filterPoints:function(e,t){var n,i=[],o=e.length;for(n=0;n<o;n++)t(e[n])&&i.push(e[n]);return i},_seriesOptions:function(){var e=this._series;return e||(e=this._series=this._chart._seriesOptions(this._options)),e},_clearFields:function(){delete this._points,delete this._series}}),w.Tooltip=u,w.CrosshairTooltip=h,w.ChartInstanceObserver=r,w.ChartPane=f,w.ChartSeries=p}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.chart.min",["dataviz/chart/kendo-chart.min","dataviz/chart/chart.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.gauge.min",["kendo.dataviz.core.min","kendo.drawing.min","kendo.dataviz.themes.min"],e)}(function(){return function(e,t){function n(e,t){var n=e.box,i=e.children[0].box,r=t.border||{},s=t.background||"",a=new D,l=A.fromRect(new E([n.x1,n.y1],[n.width(),n.height()]),{stroke:{}}),c=new I(e.text,new T(i.x1,i.y1),{font:t.font,fill:{color:t.color}}),d=o(c.bbox().clone(),t.padding),u=A.fromRect(d,{stroke:{color:r.width?r.color:"",width:r.width,dashType:r.dashType,lineJoin:"round",lineCap:"round"},fill:{color:s}});return a.append(l),a.append(u),a.append(c),a}function i(e,t,n){var i=b(e.from)?e.from:O,o=b(e.to)?e.to:N;return e.from=l.max(l.min(o,i),t),e.to=l.min(l.max(o,i),n),e}function o(e,t){var n=e.getOrigin(),i=e.getSize(),o=k(t);return e.setOrigin([n.x-o.left,n.y-o.top]),e.setSize([i.width+(o.left+o.right),i.height+(o.top+o.bottom)]),e}function r(e,t){var n=k(t);return n.left=-n.left,n.top=-n.top,n.right=-n.right,n.bottom=-n.bottom,o(e,n)}var s,a,l=Math,c=window.kendo,d=c.ui.Widget,u=c.deepExtend,h=c.dataviz,f=h.autoMajorUnit,p=h.ChartElement,m=h.NumericAxis,g=h.Axis,v=h.Box2D,_=c.Class,b=h.defined,w=h.isNumber,y=h.interpolateValue,k=h.getSpacing,x=h.round,C=h.geometry,S=h.drawing,T=C.Point,D=S.Group,A=S.Path,E=C.Rect,I=S.Text,M=150,R=250,F="arrow",z="arrowPointer",P="barPointer",B="#000",L=.05,H=h.COORD_PRECISION,N=Number.MAX_VALUE,O=-Number.MAX_VALUE,V=200,U=.5,W=200,j=60,q=60,G=5,$=l.PI/180,K=180,Y="inside",Q="linear",X="needle",Z="outside",J="radialPointer",ee="x",te="y",ne=_.extend({init:function(e,t){var n=this,i=e.options;p.fn.init.call(n,t),t=n.options,t.fill=t.color,n.scale=e,t.value=b(t.value)?l.min(l.max(t.value,i.min),i.max):i.min},options:{color:B},value:function(e){var n=this,i=n.options,o=i.value,r=n.scale.options;return 0===arguments.length?o:(i._oldValue=i._oldValue!==t?i.value:r.min,i.value=l.min(l.max(e,r.min),r.max),n.elements&&n.repaint(),t)}}),ie=ne.extend({options:{shape:X,cap:{size:L},arrow:{width:16,height:14},animation:{type:J,duration:M}},setRadius:function(e){var t=this;e&&(t.elements.clear(),t.render(t.parent,t.center,e))},setAngle:function(e){this.elements.transform(C.transform().rotate(e,this.center))},repaint:function(){var e=this,t=e.scale,n=e.options,i=t.slotAngle(n._oldValue),o=t.slotAngle(n.value);n.animation.transitions===!1?e.setAngle(o):new he(e.elements,u(n.animation,{oldAngle:i,newAngle:o})).play()},render:function(){var e=this,t=e.scale,n=t.arc.center,i=e.options,o=new D;return i.animation!==!1&&u(i.animation,{startAngle:0,center:n,reverse:t.options.reverse}),i.shape===X?o.append(e._renderNeedle(),e._renderCap()):o.append(e._renderArrow()),e.elements=o,e.setAngle($),o},reflow:function(e){var t=this,n=t.center=e.center,i=t.radius=e.getRadiusX(),o=t.capSize=Math.round(i*t.options.cap.size);t.bbox=E.fromPoints(new T(n.x-o,n.y-o),new T(n.x+o,n.y+o))},_renderNeedle:function(){var e=this,t=e.options,n=e.scale.options.minorTicks.size,i=e.center,o=t.color,r=new A({fill:{color:o},stroke:{color:o,width:U}});return r.moveTo(i.x+e.radius-n,i.y).lineTo(i.x,i.y-e.capSize/2).lineTo(i.x,i.y+e.capSize/2).close(),r},_renderCap:function(){var e=this,t=e.options,n=t.cap.color||t.color,i=new C.Circle(e.center,e.capSize),o=new S.Circle(i,{fill:{color:n},stroke:{color:n}});return o}}),oe=m.extend({init:function(e){var t=this;t.options=u({},t.options,e),t.options.majorUnit=t.options.majorUnit||f(t.options.min,t.options.max),t.options.minorUnit=t.options.minorUnit||t.options.majorUnit/10,g.fn.init.call(t,t.options)},options:{min:0,max:100,majorTicks:{size:15,align:Y,color:B,width:U,visible:!0},minorTicks:{size:10,align:Y,color:B,width:U,visible:!0},startAngle:-30,endAngle:210,labels:{position:Y,padding:2}},render:function(e,t){var n=this,i=n.renderArc(e,t);n.bbox=i.bbox(),n.labelElements=n.renderLabels(),n.ticks=n.renderTicks(),n.ranges=n.renderRanges()},reflow:function(e){var n=this,i=e.center(),o=l.min(e.height(),e.width())/2;return n.bbox===t?n.render(i,o):(n.bbox=n.arc.bbox(),n.radius(n.arc.getRadiusX()),n.repositionRanges(),n.renderLabels(),t)},slotAngle:function(e){var t,n=this.options,i=n.startAngle,o=n.reverse,r=n.endAngle-i,s=n.min,a=n.max;return t=o?n.endAngle-(e-s)/(a-s)*r:(e-s)/(a-s)*r+i,t+K},renderLabels:function(){var e,i,o,r,s,a,c,d,u,f,p,m,g,v,_=this,b=_.options,w=b.majorTicks.size,y=_.arc.clone(),k=y.getRadiusX(),x=_.tickAngles(y,b.majorUnit),S=_.labels,A=S.length,I=b.labels,M=I.padding,R=.05*k,F=b.rangeSize=b.rangeSize||.1*k,z=b.ranges||[],P=new D;for(_.options.rangeDistance!==t?R=_.options.rangeDistance:_.options.rangeDistance=R,I.position===Y&&(k-=w,z.length&&_.labelElements===t&&(k-=F+R),y.setRadiusX(k).setRadiusY(k)),
c=0;c<A;c++)s=S[c],e=s.box.width()/2,i=s.box.height()/2,r=x[c],o=(r-K)*$,f=I.position===Y,a=y.pointAt(r),d=a.x+l.cos(o)*(e+M)*(f?1:-1),u=a.y+l.sin(o)*(i+M)*(f?1:-1),s.reflow(new h.Box2D(d-e,u-i,d+e,u+i)),m=new T(s.box.x1,s.box.y1),_.labelElements===t?(p=n(s,b.labels),P.append(p)):(p=_.labelElements.children[c],g=p.bbox().origin,v=p.transform()||C.transform(),v.translate(m.x-g.x,m.y-g.y),p.transform(v)),_.bbox=E.union(_.bbox,p.bbox());return P},repositionRanges:function(){var e,t,n,i=this,o=i.ranges.children,r=i.options.rangeSize,s=i.options.rangeDistance;if(o.length>0){for(e=i.getRangeRadius(),i.options.labels.position===Y&&(e+=r+s),t=e+r/2,n=0;n<o.length;n++)o[n]._geometry.setRadiusX(t).setRadiusY(t);i.bbox=E.union(i.bbox,i.ranges.bbox())}},renderRanges:function(){var e,t,n,i,o,r,s=this,a=s.arc,l=new D,c=s.rangeSegments(),d=c.length,u=s.options.reverse,h=s.options.rangeSize,f=s.options.rangeDistance;if(d)for(i=s.getRangeRadius(),s.radius(s.radius()-h-f),r=0;r<d;r++)n=c[r],e=s.slotAngle(n[u?"to":"from"]),t=s.slotAngle(n[u?"from":"to"]),t-e!==0&&(o=new C.Arc(a.center,{radiusX:i+h/2,radiusY:i+h/2,startAngle:e,endAngle:t}),l.append(new S.Arc(o,{stroke:{width:h,color:n.color,opacity:n.opacity}})));return l},rangeSegments:function(){function e(e,t,n,i){return{from:e,to:t,color:n,opacity:i}}var t,n,o,r,s,a=this,l=a.options,c=l.ranges||[],d=c.length,u=l.rangePlaceholderColor,h=[],f=l.min,p=l.max;if(d)for(h.push(e(f,p,u)),r=0;r<d;r++)for(t=i(c[r],f,p),n=h.length,s=0;s<n;s++)if(o=h[s],o.from<=t.from&&t.from<=o.to){h.push(e(t.from,t.to,t.color,t.opacity)),o.from<=t.to&&t.to<=o.to&&h.push(e(t.to,o.to,u,t.opacity)),o.to=t.from;break}return h},getRangeRadius:function(){var e,t=this,n=t.options,i=n.majorTicks.size,o=n.rangeSize,r=n.rangeDistance,s=t.arc;return e=n.labels.position===Z?s.getRadiusX()-i-r-o:s.getRadiusX()-o},renderArc:function(e,t){var n=this,i=n.options,o=n.arc=new C.Arc(e,{radiusX:t,radiusY:t,startAngle:i.startAngle+K,endAngle:i.endAngle+K});return o},renderTicks:function(){function e(e,t,n,i){var o,r,s,a=new D,l=e.center,c=e.getRadiusX(),d=i.visible;if(d)for(o=0;o<t.length;o++)r=e.pointAt(t[o]),s=new T(l.x+c-i.size,l.y).rotate(t[o],l),a.append(new A({stroke:{color:i.color,width:i.width}}).moveTo(r).lineTo(s));return a}var t=this,n=t.arc,i=t.options,o=i.labels.position,r=new D,s=i.majorTicks.size,a=i.minorTicks.size,l=n.clone(),c=l.getRadiusX();return t.majorTickAngles=t.tickAngles(n,i.majorUnit),t.majorTicks=e(l,t.majorTickAngles,i.majorUnit,i.majorTicks),r.append(t.majorTicks),t._tickDifference=s-a,o===Z&&l.setRadiusX(c-s+a).setRadiusY(c-s+a),t.minorTickAngles=t.normalizeTickAngles(t.tickAngles(n,i.minorUnit)),t.minorTicks=e(l,t.minorTickAngles,i.minorUnit,i.minorTicks,i.majorUnit),r.append(t.minorTicks),r},normalizeTickAngles:function(e){var t,n=this,i=n.options,o=i.majorUnit/i.minorUnit;for(t=e.length-1;t>=0;t--)t%o===0&&e.splice(t,1);return e},tickAngles:function(e,t){var n,i=this,o=i.options,r=o.reverse,s=o.max-o.min,a=e.endAngle-e.startAngle,l=e.startAngle,c=s/t,d=a/c,u=[];for(r&&(l+=a,d=-d),n=0;n<c;n++)u.push(x(l,H)),l+=d;return x(l)<=e.endAngle&&u.push(l),u},radius:function(e){var n=this;return e?(n.arc.setRadiusX(e).setRadiusY(e),n.repositionTicks(n.majorTicks.children,n.majorTickAngles),n.repositionTicks(n.minorTicks.children,n.minorTickAngles,!0),t):n.arc.getRadiusX()},repositionTicks:function(e,t,n){var i,o,r,s,a,l=this,c=n?l._tickDifference||0:0,d=l.arc,u=d.getRadiusX();for(n&&l.options.labels.position===Z&&0!==c&&(d=l.arc.clone(),d.setRadiusX(u-c).setRadiusY(u-c)),i=0;i<e.length;i++)o=d.pointAt(t[i]),r=e[i].segments,s=o.x-r[0].anchor().x,a=o.y-r[0].anchor().y,e[i].transform((new C.Transformation).translate(s,a))}}),re=d.extend({init:function(t,n){var i,o,r,s,a,l=this,f=h.ui.themes||{};if(c.destroy(t),e(t).empty(),d.fn.init.call(l,t),l.wrapper=l.element,l._originalOptions=u({},n),i=u({},l.options,n),r=i.theme,s=f[r]||f[r.toLowerCase()],o=r&&s?s.gauge:{},l.options=u({},o,i),e.isArray(i.pointer))for(a=0;a<i.pointer.length;a++)l.options.pointer[a]=u({},o.pointer,i.pointer[a]);l.element.addClass("k-gauge"),l.surface=l._createSurface(),l.redraw()},options:{plotArea:{},theme:"default",renderAs:"",pointer:{},scale:{},gaugeArea:{}},destroy:function(){this.surface.destroy(),d.fn.destroy.call(this)},value:function(e){var n=this,i=n.pointers[0];return 0===arguments.length?i.value():(i.value(e),n._setValueOptions(e),t)},_draw:function(){var e=this.surface;e.clear(),e.draw(this._visuals)},exportVisual:function(){return this._visuals},allValues:function(t){var n,i=this,o=i.pointers,r=[];if(0===arguments.length){for(n=0;n<o.length;n++)r.push(o[n].value());return r}if(e.isArray(t))for(n=0;n<t.length;n++)w(t[n])&&o[n].value(t[n]);i._setValueOptions(t)},_setValueOptions:function(e){var t,n=[].concat(this.options.pointer);for(e=[].concat(e),t=0;t<e.length;t++)n[t].value=e[t]},_resize:function(){var e,t=this,n=t.options.transitions;for(t.options.transitions=!1,e=0;e<t.pointers.length;e++)t.pointers[e].options.animation.transitions=!1;for(t.redraw(),t.options.transitions=n,e=0;e<t.pointers.length;e++)t.pointers[e].options.animation.transitions=n},redraw:function(){var e,t=this,n=u(t._getSize(),t.options.gaugeArea),i=new E([0,0],[n.width,n.height]);t.surface.clear(),t.gaugeArea=t._createGaugeArea(),t.surface.element.css({width:n.width,height:n.height}),t._createModel(),e=r(i.bbox(),t._gaugeAreaMargin),t.reflow(e)},_createGaugeArea:function(){var e,t=this,n=t.options.gaugeArea,i=t.surface.size(),o=n.border||{},s=new E([0,0],[i.width,i.height]);return t._gaugeAreaMargin=n.margin||G,o.width>0&&(s=r(s,o.width)),e=A.fromRect(s,{stroke:{color:o.width?o.color:"",width:o.width,dashType:o.dashType,lineJoin:"round",lineCap:"round"},fill:{color:n.background}})},_createSurface:function(){var t,n=this,i=n.options,o=n._getSize();return o=i.gaugeArea?u(o,i.gaugeArea):o,t=e("<div></div>").appendTo(n.element).css({width:o.width,height:o.height}),new S.Surface.create(t,{type:i.renderAs})},getSize:function(){return this._getSize()},_getSize:function(){var e=this,t=e.element,n=t.width(),i=t.height();return n||(n=W),i||(i=V),{width:n,height:i}}}),se=re.extend({init:function(e,t){var n=this;re.fn.init.call(n,e,t),c.notify(n,h.ui)},options:{name:"RadialGauge",transitions:!0,gaugeArea:{background:""}},reflow:function(e){var t,n=this,i=n.pointers;for(n.scale.reflow(e),n._initialPlotArea=n.scale.bbox,t=0;t<i.length;t++)i[t].reflow(n.scale.arc),n._initialPlotArea=E.union(n._initialPlotArea,i[t].bbox);n.fitScale(e),n.alignScale(e),n._buildVisual(n.gaugeArea,i,n.scale),n._draw()},_buildVisual:function(e,t,n){var i,o,r=new D;for(r.append(e),r.append(n.ticks),r.append(n.ranges),o=0;o<t.length;o++)i=t[o],i.render(),r.append(i.elements),i.value(i.options.value);r.append(n.labelElements),this._visuals=r},fitScale:function(e){for(var t,n,i,o,r,s=this,a=s.scale,c=a.arc,d=s._initialPlotArea,u=l.abs(s.getDiff(d,e)),h=x(u,H),f=x(-u,H),p=0,m=0;!(!(m++<100)||(p=r===i?p+1:0,p>5)||h!=o&&(t=s.getPlotBox(h,e,c),0<=t&&t<=2)||f!=o&&(i=s.getPlotBox(f,e,c),0<=i&&i<=2)||(o=t>0&&i>0?2*h:t<0&&i<0?2*f:x((h+f)/2||1,H),n=s.getPlotBox(o,e,c),0<=n&&n<=2));)r=i,n>0?(f=o,i=n):(h=o,t=n)},getPlotBox:function(e,t,n){var i,o=this,r=o.scale,s=o.pointers,a=n.getRadiusX();for(n=n.clone(),n.setRadiusX(a+e).setRadiusY(a+e),r.arc=n,r.reflow(t),o.plotBbox=r.bbox,i=0;i<s.length;i++)s[i].reflow(n),o.plotBbox=E.union(o.plotBbox,s[i].bbox);return o.getDiff(o.plotBbox,t)},getDiff:function(e,t){return l.min(t.width()-e.width(),t.height()-e.height())},alignScale:function(e){var t,n=this,i=n.plotBbox.center(),o=e.center(),r=i.x-o.x,s=i.y-o.y,a=n.scale,l=n.pointers;for(a.arc.center.x-=r,a.arc.center.y-=s,a.reflow(e),t=0;t<l.length;t++)l[t].reflow(a.arc),n.plotBbox=E.union(a.bbox,l[t].bbox)},_createModel:function(){var t,n,i=this,o=i.options,r=o.pointer,s=i.scale=new oe(o.scale);for(i.pointers=[],r=e.isArray(r)?r:[r],n=0;n<r.length;n++)t=new ie(s,u({},r[n],{animation:{transitions:o.transitions}})),i.pointers.push(t)}}),ae=re.extend({init:function(e,t){var n=this;re.fn.init.call(n,e,t),c.notify(n,h.ui)},options:{name:"LinearGauge",transitions:!0,gaugeArea:{background:""},scale:{vertical:!0}},reflow:function(e){var t,n=this,i=n.pointers,o=e.origin.x,r=e.origin.y,s=new h.Box2D(o,r,o+e.width(),r+e.height());for(n.scale.reflow(s),t=0;t<i.length;t++)i[t].reflow();n.bbox=n._getBox(s),n._alignElements(),n._shrinkElements(),n._buildVisual(),n._draw()},_buildVisual:function(){var e,t,n=this,i=new D,o=n.scale.render(),r=n.pointers;for(i.append(n.gaugeArea),i.append(o),t=0;t<r.length;t++)e=r[t],i.append(e.render()),e.value(e.options.value);n._visuals=i},_createModel:function(){var t,n,i,o=this,r=o.options,s=r.pointer,a=o.scale=new le(r.scale);for(o.pointers=[],s=e.isArray(s)?s:[s],i=0;i<s.length;i++)n=u({},s[i],{animation:{transitions:r.transitions}}),t=n.shape===F?new de(a,n):new ue(a,n),o.pointers.push(t)},_getSize:function(){var e=this,t=e.element,n=t.width(),i=t.height(),o=e.options.scale.vertical;return n||(n=o?j:W),i||(i=o?V:q),{width:n,height:i}},_getBox:function(e){var t,n,i=this,o=i.scale,r=i.pointers,s=e.center(),a=r[0].box.clone().wrap(o.box);for(n=0;n<r.length;n++)a.wrap(r[n].box.clone());return o.options.vertical?(t=a.width()/2,a=new v(s.x-t,e.y1,s.x+t,e.y2)):(t=a.height()/2,a=new v(e.x1,s.y-t,e.x2,s.y+t)),a},_alignElements:function(){var e,t,n=this,i=n.scale,o=n.pointers,r=i.box,s=o[0].box.clone().wrap(i.box),a=n.bbox;for(t=0;t<o.length;t++)s.wrap(o[t].box.clone());for(i.options.vertical?(e=a.center().x-s.center().x,i.reflow(new v(r.x1+e,a.y1,r.x2+e,a.y2))):(e=a.center().y-s.center().y,i.reflow(new v(a.x1,r.y1+e,a.x2,r.y2+e))),t=0;t<o.length;t++)o[t].reflow(n.bbox)},_shrinkElements:function(){var e,t=this,n=t.scale,i=t.pointers,o=n.box.clone(),r=n.options.vertical?"y":"x",s=i[0].box;for(e=0;e<i.length;e++)s.wrap(i[e].box.clone());for(o[r+1]+=l.max(o[r+1]-s[r+1],0),o[r+2]-=l.max(s[r+2]-o[r+2],0),n.reflow(o),e=0;e<i.length;e++)i[e].reflow(t.bbox)}}),le=m.extend({init:function(e){var t=this;t.options=u({},t.options,e),t.options=u({},t.options,{labels:{mirror:t.options.mirror}}),t.options.majorUnit=t.options.majorUnit||f(t.options.min,t.options.max),g.fn.init.call(t,t.options),t.options.minorUnit=t.options.minorUnit||t.options.majorUnit/10},options:{min:0,max:50,majorTicks:{size:15,align:Y,color:B,width:U,visible:!0},minorTicks:{size:10,align:Y,color:B,width:U,visible:!0},line:{width:U},labels:{position:Y,padding:2},mirror:!1,_alignLines:!1},render:function(){var e=this,t=e.elements=new D,n=e.renderLabels(),i=e.renderLine(),o=e.renderTicks(),r=e.renderRanges();return t.append(i,n,o,r),t},renderRanges:function(){var e,t,n,o,r,s=this,a=s.options,l=a.min,c=a.max,d=a.ranges||[],u=a.vertical,h=a.labels.mirror,f=new D,p=d.length,m=a.rangeSize||a.minorTicks.size/2;if(p)for(r=0;r<p;r++)e=i(d[r],l,c),t=s.getSlot(e.from,e.to),n=u?s.lineBox():t,o=u?t:s.lineBox(),u?n.x1-=m*(h?-1:1):o.y2+=m*(h?-1:1),f.append(A.fromRect(new E([n.x1,o.y1],[n.x2-n.x1,o.y2-o.y1]),{fill:{color:e.color,opacity:e.opacity},stroke:{}}));return f},renderLabels:function(){var e,t=this,i=t.options,o=t.labels,r=new D;for(e=0;e<o.length;e++)r.append(n(o[e],i.labels));return r},renderLine:function(){var e,t=this,n=t.options,i=n.line,o=t.lineBox(),r=new D;return i.width>0&&i.visible&&(e=new A({stroke:{color:i.color,dashType:i.dashType,width:i.width}}),e.moveTo(o.x1,o.y1).lineTo(o.x2,o.y2),r.append(e)),r},renderTicks:function(){function e(e,i){var s,l=e.length;if(i.visible)for(s=i.skip;s<l;s+=i.step)s%i.skipUnit!==0&&(a.tickX=r?o.x2:o.x2-i.size,a.tickY=r?o.y1-i.size:o.y1,a.position=e[s],n.append(t.renderAxisTick(a,i)))}var t=this,n=new D,i=t.options,o=t.lineBox(),r=i.labels.mirror,s=i.majorTicks.visible?i.majorUnit:0,a={_alignLines:i._alignLines,vertical:i.vertical};return e(t.getMajorTickPositions(),i.majorTicks),e(t.getMinorTickPositions(),u({},{skipUnit:s/i.minorUnit},i.minorTicks)),n},renderAxisTick:function(e,t){var n,i,o,r=e.tickX,s=e.tickY,a=e.position;return e.vertical?(n=new T(r,a),i=new T(r+t.size,a)):(n=new T(a,s),i=new T(a,s+t.size)),o=new A({stroke:{color:t.color,width:t.width}}).moveTo(n).lineTo(i)}}),ce=ne.extend({init:function(e,t){var n=this;ne.fn.init.call(n,e,t),n.options=u({track:{visible:b(t.track)}},n.options)},options:{shape:P,track:{border:{width:1}},color:B,border:{width:1},opacity:1,margin:k(3),animation:{type:P},visible:!0},reflow:function(){var e,t,n,i=this,o=i.options,r=i.scale,s=r.lineBox(),a=o.track.size||o.size,l=o.size/2,c=r.options.mirror,d=k(o.margin),u=r.options.vertical,h=u?d[c?"left":"right"]:d[c?"bottom":"top"];h=c?-h:h,u?(n=new v(s.x1+h,s.y1,s.x1+h,s.y2),c?n.x1-=a:n.x2+=a,o.shape!==P&&(t=new v(s.x2+h,s.y1-l,s.x2+h,s.y2+l),e=t)):(n=new v(s.x1,s.y1-h,s.x2,s.y1-h),c?n.y2+=a:n.y1-=a,o.shape!==P&&(t=new v(s.x1-l,s.y1-h,s.x2+l,s.y1-h),e=t)),i.trackBox=n,i.pointerRangeBox=t,i.box=e||n.clone().pad(o.border.width)},getElementOptions:function(){var e=this.options;return{fill:{color:e.color,opacity:e.opacity},stroke:b(e.border)?{color:e.border.width?e.border.color||e.color:"",width:e.border.width,dashType:e.border.dashType,opacity:e.opacity}:null}},_margin:function(){var e=this,t=e.options,n=e.scale,i=n.options.mirror,o=k(t.margin),r=n.options.vertical,s=r?o[i?"left":"right"]:o[i?"bottom":"top"];return s}}),de=ce.extend({init:function(e,n){ce.fn.init.call(this,e,n),this.options.size===t&&(this.options.size=.6*this.scale.options.majorTicks.size)},pointerShape:function(){var e,t,n=this,i=n.options,o=n.scale,r=i.size,s=o.options.vertical,a=r/2,l=o.options.mirror?-1:1,c=o.options.reverse;return s?(e=c?"y2":"y1",t=[new T(0,0-a),new T(0-l*r,0),new T(0,0+a)]):(e=c?"x1":"x2",t=[new T(0-a,0),new T(0,0+l*r),new T(0+a,0)]),t},repaint:function(){var e=this,t=e.scale,n=e.options,i=new s(e.elements,u(n.animation,{vertical:t.options.vertical,mirror:t.options.mirror,margin:e._margin(n.margin),from:t.getSlot(n._oldValue),to:t.getSlot(n.value)}));n.animation.transitions===!1&&(i.options.duration=0),i.setup(),i.play()},render:function(){var e,t=this,n=t.options,i=new D,o=t.scale,r=t.getElementOptions(),s=t.pointerShape(n.value);return n.animation.type=z,i=new A({stroke:r.stroke,fill:r.fill}).moveTo(s[0]).lineTo(s[1]).lineTo(s[2]).close(),e=o.getSlot(n.value),i.transform(C.transform().translate(e.x1,e.y1)),t.elements=i,i}}),ue=ce.extend({init:function(e,n){ce.fn.init.call(this,e,n),this.options.size===t&&(this.options.size=.3*this.scale.options.majorTicks.size)},pointerShape:function(e){var t,n,i,o=this,r=o.options,s=o.scale,a=s.options.vertical,l=s.options.mirror,c=l==a?-1:1,d=r.size*c,u=s.getSlot(s.options.min),h=s.getSlot(e),f=a?te:ee,p=a?ee:te,m=o._margin()*c,g=new T;return g[f]=u[f+"1"],g[p]=u[p+"1"],t=new T,t[f]=h[f+"1"],t[p]=h[p+"1"],a?(g.translate(m,0),t.translate(m,0)):(g.translate(0,m),t.translate(0,m)),n=t.clone(),i=g.clone(),a?(n.translate(d,0),i.translate(d,0)):(n.translate(0,d),i.translate(0,d)),[g,t,n,i]},repaint:function(){var e,t=this,n=t.scale,i=t.options,o=t.pointerShape(i.value),r=t.elements.children[0],s=t.pointerShape(i._oldValue);r.moveTo(o[0]).lineTo(o[1]).lineTo(o[2]).lineTo(o[3]).close(),e=new a(r,u(i.animation,{reverse:n.options.reverse,vertical:n.options.vertical,oldPoints:[s[1],s[2]],newPoints:[o[1],o[2]]})),i.animation.transitions===!1&&(e.options.duration=0),e.setup(),e.play()},render:function(){var e=this,t=new D,n=e.getElementOptions(),i=new A({stroke:n.stroke,fill:n.fill});return t.append(i),e.elements=t,t}}),he=S.Animation.extend({init:function(e,t){S.Animation.fn.init.call(this,e,t),t=this.options,t.duration=l.max(l.abs(t.newAngle-t.oldAngle)/t.duration*1e3,1)},options:{easing:Q,duration:M},step:function(e){var t=this,n=t.options,i=y(n.oldAngle,n.newAngle,e);t.element.transform(C.transform().rotate(i,n.center))}});S.AnimationFactory.current.register(J,he),s=S.Animation.extend({options:{easing:Q,duration:R},setup:function(){var e,t,n=this.options,i=n.margin,o=n.from,r=n.to,s=n.vertical?"x1":"y1";n.mirror==n.vertical?(o[s]-=i,r[s]-=i):(o[s]+=i,r[s]+=i),e=this.fromScale=new T(o.x1,o.y1),t=this.toScale=new T(r.x1,r.y1),0!==n.duration&&(n.duration=l.max(e.distanceTo(t)/n.duration*1e3,1))},step:function(e){var t=y(this.fromScale.x,this.toScale.x,e),n=y(this.fromScale.y,this.toScale.y,e);this.element.transform(C.transform().translate(t,n))}}),S.AnimationFactory.current.register(z,s),a=S.Animation.extend({options:{easing:Q,speed:R},setup:function(){var e=this.options,t=e.newPoints,n=e.oldPoints,i=this.axis=e.vertical?te:ee,o=this.to=t[0][i],r=this.from=n[0][i];0!==e.duration&&(e.duration=l.max(l.abs(o-r)/e.speed*1e3,1)),this._set(r)},step:function(e){var t=y(this.from,this.to,e);this._set(t)},_set:function(e){var t="set"+this.axis.toUpperCase(),n=this.options.newPoints;n[0][t](e),n[1][t](e)}}),S.AnimationFactory.current.register(P,a),h.ui.plugin(se),h.ui.plugin(ae),h.ExportMixin.extend(re.fn),u(h,{Gauge:re,RadialPointer:ie,LinearPointer:ce,ArrowLinearPointer:de,BarLinearPointer:ue,LinearScale:le,RadialScale:oe,LinearGauge:ae,RadialGauge:se})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.barcode.min",["kendo.dataviz.core.min","kendo.drawing.min"],e)}(function(){return function(e,t){function n(e,t,n){return e.substring(t,t+n)}var i,o,r,s,a,l,c=window.kendo,d=c.ui.Widget,u=e.extend,h=c.deepExtend,f=e.inArray,p=e.isPlainObject,m=c.drawing,g=c.geometry,v=c.drawing.util,_=v.defined,b=c.dataviz,w=b.Box2D,y=b.TextBox,k=300,x=100,C=10,S=/^\d+$/,T=/^[a-z0-9]+$/i,D="Character '{0}' is not valid for symbology {1}",A=c.Class.extend({init:function(e){this.setOptions(e)},setOptions:function(e){var t=this;t.options=u({},t.options,e),t.quietZoneLength=t.options.addQuietZone?2*t.options.quietZoneLength:0},encode:function(e,t,n){var i=this;return _(e)&&(e+=""),i.initValue(e,t,n),i.options.addQuietZone&&i.addQuietZone(),i.addData(),i.options.addQuietZone&&i.addQuietZone(),{baseUnit:i.baseUnit,pattern:i.pattern}},options:{quietZoneLength:C,addQuietZone:!0,addCheckSum:!0},initValue:function(){},addQuietZone:function(){this.pattern.push(this.options.quietZoneLength||C)},addData:function(){},invalidCharacterError:function(e){throw Error(c.format(D,e,this.name))}}),E={},I=A.extend({minBaseUnitLength:.7,addData:function(){var e,t=this,n=t.value;for(t.addStart(),e=0;e<n.length;e++)t.addCharacter(n.charAt(e));t.options.addCheckSum&&t.pushCheckSum(),t.addStop(),t.prepareValues()},addCharacter:function(e){var t=this,n=t.characterMap[e];n||t.invalidCharacterError(e),t.addBase(n)},addBase:function(){}}),M={addCharacter:function(e){var t=this;t.characterMap[e]?t.addBase(t.characterMap[e]):e.charCodeAt(0)>127?t.invalidCharacterError(e):t.addExtended(e.charCodeAt(0))},addExtended:function(e){var n,i,o,r=this;for(i=0;i<r.extendedMappings.length;i++)if(n=r.extendedMappings[i].call(r,e)){for(o=0;o<n.length;o++)r.addBase(n[o]);return r.dataLength+=n.length-1,t}},extendedMappings:[function(e){if(97<=e&&e<=122){var t=this;return[t.characterMap[t.shiftCharacters[0]],t.characterMap[String.fromCharCode(e-32)]]}},function(e){if(33<=e&&e<=58){var t=this;return[t.characterMap[t.shiftCharacters[1]],t.characterMap[String.fromCharCode(e+32)]]}},function(e){if(1<=e&&e<=26){var t=this;return[t.characterMap[t.shiftCharacters[2]],t.characterMap[String.fromCharCode(e+64)]]}},function(e){var t,n,i,o=this;if(o.specialAsciiCodes[e])for(t=[],i=0;i<o.specialAsciiCodes[e].length;i++)t.push(o.characterMap[o.shiftCharacters[3]]),t.push(o.characterMap[o.specialAsciiCodes[e][i]]);else n=6*Math.floor(e/32)+(e-27)%32+64,t=[o.characterMap[o.shiftCharacters[3]],o.characterMap[String.fromCharCode(n)]];return t}],specialAsciiCodes:{0:["U"],64:["V"],96:["W"],127:["T","X","Y","Z"]},shiftValuesAsciiCodes:{39:36,40:47,41:43,42:37},characterMap:{"+":!1,"/":!1,$:!1,"%":!1},shiftCharacters:["SHIFT0","SHIFT1","SHIFT2","SHIFT3"]};E.code39=I.extend({name:"Code 39",checkSumMod:43,minRatio:2.5,maxRatio:3,gapWidth:1,splitCharacter:"|",initValue:function(e,t,n){var i=this;i.width=t,i.height=n,i.value=e,i.dataLength=e.length,i.pattern=[],i.patternString=""},prepareValues:function(){var e,t,n=this,i=n.minBaseUnitLength,o=n.maxRatio,r=n.minRatio,s=Math.max(.15*n.width,24);if(n.height<s)throw Error("Insufficient Height. The minimum height for value: "+n.value+" is: "+s);for(;(e=n.getBaseUnit(o))<i&&o>r;)o=parseFloat((o-.1).toFixed(1));if(e<i)throw t=Math.ceil(n.getBaseWidth(r)*i),Error("Insufficient width. The minimum width for value: "+n.value+" is: "+t);n.ratio=o,n.baseUnit=e,n.patternString=n.patternString.substring(0,n.patternString.length-1),n.pattern=n.pattern.concat(n.patternString.replace(/ratio/g,o).split(n.splitCharacter))},getBaseUnit:function(e){return this.width/this.getBaseWidth(e)},getBaseWidth:function(e){var t=this,n=3*(e+2);return t.quietZoneLength+n*(t.dataLength+2)+t.gapWidth*(t.dataLength+1)},addStart:function(){var e=this;e.addPattern(e.characterMap.START.pattern),e.addCharacterGap()},addBase:function(e){this.addPattern(e.pattern),this.addCharacterGap()},addStop:function(){this.addPattern(this.characterMap.START.pattern)},addPattern:function(e){for(var t=0;t<e.length;t++)this.patternString+=this.patternMappings[e.charAt(t)]},addCharacterGap:function(){var e=this;e.patternString+=e.gapWidth+e.splitCharacter},patternMappings:{b:"1|",w:"1|",B:"ratio|",W:"ratio|"},characterMap:{0:{pattern:"bwbWBwBwb",value:0},1:{pattern:"BwbWbwbwB",value:1},2:{pattern:"bwBWbwbwB",value:2},3:{pattern:"BwBWbwbwb",value:3},4:{pattern:"bwbWBwbwB",value:4},5:{pattern:"BwbWBwbwb",value:5},6:{pattern:"bwBWBwbwb",value:6},7:{pattern:"bwbWbwBwB",value:7},8:{pattern:"BwbWbwBwb",value:8},9:{pattern:"bwBWbwBwb",value:9},A:{pattern:"BwbwbWbwB",value:10},B:{pattern:"bwBwbWbwB",value:11},C:{pattern:"BwBwbWbwb",value:12},D:{pattern:"bwbwBWbwB",value:13},E:{pattern:"BwbwBWbwb",value:14},F:{pattern:"bwBwBWbwb",value:15},G:{pattern:"bwbwbWBwB",value:16},H:{pattern:"BwbwbWBwb",value:17},I:{pattern:"bwBwbWBwb",value:18},J:{pattern:"bwbwBWBwb",value:19},K:{pattern:"BwbwbwbWB",value:20},L:{pattern:"bwBwbwbWB",value:21},M:{pattern:"BwBwbwbWb",value:22},N:{pattern:"bwbwBwbWB",value:23},O:{pattern:"BwbwBwbWb",value:24},P:{pattern:"bwBwBwbWb",value:25},Q:{pattern:"bwbwbwBWB",value:26},R:{pattern:"BwbwbwBWb",value:27},S:{pattern:"bwBwbwBWb",value:28},T:{pattern:"bwbwBwBWb",value:29},U:{pattern:"BWbwbwbwB",value:30},V:{pattern:"bWBwbwbwB",value:31},W:{pattern:"BWBwbwbwb",value:32},X:{pattern:"bWbwBwbwB",value:33},Y:{pattern:"BWbwBwbwb",value:34},Z:{pattern:"bWBwBwbwb",value:35},"-":{pattern:"bWbwbwBwB",value:36},".":{pattern:"BWbwbwBwb",value:37}," ":{pattern:"bWBwbwBwb",value:38},$:{pattern:"bWbWbWbwb",value:39},"/":{pattern:"bWbWbwbWb",value:40},"+":{pattern:"bWbwbWbWb",value:41},"%":{pattern:"bwbWbWbWb",value:42},START:{pattern:"bWbwBwBwb"}},options:{addCheckSum:!1}}),E.code39extended=E.code39.extend(h({},M,{name:"Code 39 extended",characterMap:{SHIFT0:{pattern:"bWbwbWbWb",value:41},SHIFT1:{pattern:"bWbWbwbWb",value:40},SHIFT2:{pattern:"bWbWbWbwb",value:39},SHIFT3:{pattern:"bwbWbWbWb",value:42}}})),E.code93=I.extend({name:"Code 93",cCheckSumTotal:20,kCheckSumTotal:15,checkSumMod:47,initValue:function(e,t,n){var i=this;i.value=e,i.width=t,i.height=n,i.pattern=[],i.values=[],i.dataLength=e.length},prepareValues:function(){var e=this,t=Math.max(.15*e.width,24);if(e.height<t)throw Error("Insufficient Height");if(e.setBaseUnit(),e.baseUnit<e.minBaseUnitLength)throw Error("Insufficient Width")},setBaseUnit:function(){var e=this,t=2;e.baseUnit=e.width/(9*(e.dataLength+2+t)+e.quietZoneLength+1)},addStart:function(){var e=this.characterMap.START.pattern;this.addPattern(e)},addStop:function(){var e=this;e.addStart(),e.pattern.push(e.characterMap.TERMINATION_BAR)},addBase:function(e){this.addPattern(e.pattern),this.values.push(e.value)},pushCheckSum:function(){var e,t,n=this,i=n._getCheckValues();for(n.checksum=i.join(""),t=0;t<i.length;t++)e=n.characterMap[n._findCharacterByValue(i[t])],n.addPattern(e.pattern)},_getCheckValues:function(){var e,t,n,i=this,o=i.values,r=o.length,s=0;for(n=r-1;n>=0;n--)s+=i.weightedValue(o[n],r-n,i.cCheckSumTotal);for(e=s%i.checkSumMod,s=i.weightedValue(e,1,i.kCheckSumTotal),n=r-1;n>=0;n--)s+=i.weightedValue(o[n],r-n+1,i.kCheckSumTotal);return t=s%i.checkSumMod,[e,t]},_findCharacterByValue:function(e){for(var t in this.characterMap)if(this.characterMap[t].value===e)return t},weightedValue:function(e,t,n){return(t%n||n)*e},addPattern:function(e){var t,n;for(n=0;n<e.length;n++)t=parseInt(e.charAt(n),10),this.pattern.push(t)},characterMap:{0:{pattern:"131112",value:0},1:{pattern:"111213",value:1},2:{pattern:"111312",value:2},3:{pattern:"111411",value:3},4:{pattern:"121113",value:4},5:{pattern:"121212",value:5},6:{pattern:"121311",value:6},7:{pattern:"111114",value:7},8:{pattern:"131211",value:8},9:{pattern:"141111",value:9},A:{pattern:"211113",value:10},B:{pattern:"211212",value:11},C:{pattern:"211311",value:12},D:{pattern:"221112",value:13},E:{pattern:"221211",value:14},F:{pattern:"231111",value:15},G:{pattern:"112113",value:16},H:{pattern:"112212",value:17},I:{pattern:"112311",value:18},J:{pattern:"122112",value:19},K:{pattern:"132111",value:20},L:{pattern:"111123",value:21},M:{pattern:"111222",value:22},N:{pattern:"111321",value:23},O:{pattern:"121122",value:24},P:{pattern:"131121",value:25},Q:{pattern:"212112",value:26},R:{pattern:"212211",value:27},S:{pattern:"211122",value:28},T:{pattern:"211221",value:29},U:{pattern:"221121",value:30},V:{pattern:"222111",value:31},W:{pattern:"112122",value:32},X:{pattern:"112221",value:33},Y:{pattern:"122121",value:34},Z:{pattern:"123111",value:35},"-":{pattern:"121131",value:36},".":{pattern:"311112",value:37}," ":{pattern:"311211",value:38},$:{pattern:"321111",value:39},"/":{pattern:"112131",value:40},"+":{pattern:"113121",value:41},"%":{pattern:"211131",value:42},SHIFT0:{pattern:"122211",value:46},SHIFT1:{pattern:"311121",value:45},SHIFT2:{pattern:"121221",value:43},SHIFT3:{pattern:"312111",value:44},START:{pattern:"111141"},TERMINATION_BAR:"1"}}),E.code93extended=E.code93.extend(h({},M,{name:"Code 93 extended",pushCheckSum:function(){var e,t,n=this,i=n._getCheckValues();for(n.checksum=i.join(""),t=0;t<i.length;t++)e=i[t],n.shiftValuesAsciiCodes[e]?n.addExtended(n.shiftValuesAsciiCodes[e]):n.addPattern(n.characterMap[n._findCharacterByValue(e)].pattern)}})),i=c.Class.extend({init:function(e){this.encoding=e},addStart:function(){},is:function(){},move:function(){},pushState:function(){}}),o=i.extend({FNC4:"FNC4",init:function(e,t){var n=this;n.encoding=e,n.states=t,n._initMoves(t)},addStart:function(){this.encoding.addPattern(this.START)},is:function(e,t){var n=e.charCodeAt(t);return this.isCode(n)},move:function(e){for(var t=this,n=0;!t._moves[n].call(t,e)&&n<t._moves.length;)n++},pushState:function(e){var t,n,i=this,o=i.states,r=e.value,s=r.length;for(f("C",o)>=0&&(n=r.substr(e.index).match(/\d{4,}/g),n&&(s=r.indexOf(n[0],e.index)));(t=e.value.charCodeAt(e.index))>=0&&i.isCode(t)&&e.index<s;)i.encoding.addPattern(i.getValue(t)),e.index++},_initMoves:function(e){var t=this;t._moves=[],f(t.FNC4,e)>=0&&t._moves.push(t._moveFNC),f(t.shiftKey,e)>=0&&t._moves.push(t._shiftState),t._moves.push(t._moveState)},_moveFNC:function(e){if(e.fnc)return e.fnc=!1,e.previousState==this.key},_shiftState:function(e){var t=this;if(e.previousState==t.shiftKey&&(e.index+1>=e.value.length||t.encoding[t.shiftKey].is(e.value,e.index+1)))return t.encoding.addPattern(t.SHIFT),e.shifted=!0,!0},_moveState:function(){return this.encoding.addPattern(this.MOVE),!0},SHIFT:98}),r={},r.A=o.extend({key:"A",shiftKey:"B",isCode:function(e){return 0<=e&&e<96},getValue:function(e){return e<32?e+64:e-32},MOVE:101,START:103}),r.B=o.extend({key:"B",shiftKey:"A",isCode:function(e){return 32<=e&&e<128},getValue:function(e){return e-32},MOVE:100,START:104}),r.C=i.extend({key:"C",addStart:function(){this.encoding.addPattern(this.START)},is:function(e,t){var i=n(e,t,4);return(t+4<=e.length||2==e.length)&&S.test(i)},move:function(){this.encoding.addPattern(this.MOVE)},pushState:function(e){for(var t;(t=n(e.value,e.index,2))&&S.test(t)&&2==t.length;)this.encoding.addPattern(parseInt(t,10)),e.index+=2},getValue:function(e){return e},MOVE:99,START:105}),r.FNC4=i.extend({key:"FNC4",dependentStates:["A","B"],init:function(e,t){this.encoding=e,this._initSubStates(t)},addStart:function(e){var t=e.value.charCodeAt(0)-128,n=this._getSubState(t);this.encoding[n].addStart()},is:function(e,t){var n=e.charCodeAt(t);return this.isCode(n)},isCode:function(e){return 128<=e&&e<256},pushState:function(e){var t,n=this,i=n._initSubState(e),o=n.encoding,r=i.value.length;if(e.index+=r,r<3)for(;i.index<r;i.index++)t=i.value.charCodeAt(i.index),i.state=n._getSubState(t),i.previousState!=i.state&&(i.previousState=i.state,o[i.state].move(i)),o.addPattern(o[i.state].MOVE),o.addPattern(o[i.state].getValue(t));else i.state!=i.previousState&&o[i.state].move(i),n._pushStart(i),o.pushData(i,n.subStates),e.index<e.value.length&&n._pushStart(i);e.fnc=!0,e.state=i.state},_pushStart:function(e){var t=this;t.encoding.addPattern(t.encoding[e.state].MOVE),t.encoding.addPattern(t.encoding[e.state].MOVE)},_initSubState:function(e){var t=this,n={value:t._getAll(e.value,e.index),index:0};return n.state=t._getSubState(n.value.charCodeAt(0)),n.previousState=e.previousState==t.key?n.state:e.previousState,n},_initSubStates:function(e){var t,n=this;for(n.subStates=[],t=0;t<e.length;t++)f(e[t],n.dependentStates)>=0&&n.subStates.push(e[t])},_getSubState:function(e){var t,n=this;for(t=0;t<n.subStates.length;t++)if(n.encoding[n.subStates[t]].isCode(e))return n.subStates[t]},_getAll:function(e,t){for(var n,i="";(n=e.charCodeAt(t++))&&this.isCode(n);)i+=String.fromCharCode(n-128);return i}}),r.FNC1=i.extend({key:"FNC1",startState:"C",dependentStates:["C","B"],startAI:"(",endAI:")",init:function(e,t){this.encoding=e,this.states=t},addStart:function(){this.encoding[this.startState].addStart()},is:function(){return f(this.key,this.states)>=0},pushState:function(e){var t,n,i,o=this,r=o.encoding,s=e.value.replace(/\s/g,""),a=RegExp("["+o.startAI+o.endAI+"]","g"),l=e.index,c={state:o.startState};for(r.addPattern(o.START);;){if(c.index=0,i=s.charAt(l)===o.startAI?2:0,t=i>0?o.getBySeparator(s,l):o.getByLength(s,l),t.ai.length)n=l+i+t.id.length+t.ai.length;else if(n=s.indexOf(o.startAI,l+1),n<0){if(l+t.ai.max+t.id.length+i<s.length)throw Error("Separators are required after variable length identifiers");n=s.length}if(c.value=s.substring(l,n).replace(a,""),o.validate(t,c.value),r.pushData(c,o.dependentStates),n>=s.length)break;l=n,c.state!=o.startState&&(r[o.startState].move(c),c.state=o.startState),t.ai.length||r.addPattern(o.START)}e.index=e.value.length},validate:function(e,t){var n=t.substr(e.id.length),i=e.ai;if(!i.type&&!S.test(n))throw Error("Application identifier "+e.id+" is numeric only but contains non numeric character(s).");if("alphanumeric"==i.type&&!T.test(n))throw Error("Application identifier "+e.id+" is alphanumeric only but contains non alphanumeric character(s).");if(i.length&&i.length!==n.length)throw Error("Application identifier "+e.id+" must be "+i.length+" characters long.");if(i.min&&i.min>n.length)throw Error("Application identifier "+e.id+" must be at least "+i.min+" characters long.");if(i.max&&i.max<n.length)throw Error("Application identifier "+e.id+" must be at most "+i.max+" characters long.")},getByLength:function(e,t){var i,o,r,s=this;for(r=2;r<=4;r++)if(i=n(e,t,r),o=s.getAI(i)||s.getAI(i.substring(0,i.length-1)))return{id:i,ai:o};s.unsupportedAIError(i)},unsupportedAIError:function(e){throw Error(c.format("'{0}' is not a supported Application Identifier"),e)},getBySeparator:function(e,t){var n=this,i=e.indexOf(n.startAI,t),o=e.indexOf(n.endAI,i),r=e.substring(i+1,o),s=n.getAI(r)||n.getAI(r.substr(r.length-1));return s||n.unsupportedAIError(r),{ai:s,id:r}},getAI:function(e){var t,n,i,o=this.applicationIdentifiers,r=o.multiKey;if(o[e])return o[e];for(t=0;t<r.length;t++){if(r[t].ids&&f(e,r[t].ids)>=0)return r[t].type;
if(r[t].ranges)for(n=r[t].ranges,i=0;i<n.length;i++)if(n[i][0]<=e&&e<=n[i][1])return r[t].type}},applicationIdentifiers:{22:{max:29,type:"alphanumeric"},402:{length:17},7004:{max:4,type:"alphanumeric"},242:{max:6,type:"alphanumeric"},8020:{max:25,type:"alphanumeric"},703:{min:3,max:30,type:"alphanumeric"},8008:{min:8,max:12,type:"alphanumeric"},253:{min:13,max:17,type:"alphanumeric"},8003:{min:14,max:30,type:"alphanumeric"},multiKey:[{ids:["15","17","8005","8100"],ranges:[[11,13],[310,316],[320,336],[340,369]],type:{length:6}},{ids:["240","241","250","251","400","401","403","7002","8004","8007","8110"],ranges:[[-9]],type:{max:30,type:"alphanumeric"}},{ids:["7001"],ranges:[[410,414]],type:{length:13}},{ids:["10","21","254","420","8002"],type:{max:20,type:"alphanumeric"}},{ids:["00","8006","8017","8018"],type:{length:18}},{ids:["01","02","8001"],type:{length:14}},{ids:["422"],ranges:[[424,426]],type:{length:3}},{ids:["20","8102"],type:{length:2}},{ids:["30","37"],type:{max:8,type:"alphanumeric"}},{ids:["390","392"],type:{max:15,type:"alphanumeric"}},{ids:["421","423"],type:{min:3,max:15,type:"alphanumeric"}},{ids:["391","393"],type:{min:3,max:18,type:"alphanumeric"}},{ids:["7003","8101"],type:{length:10}}]},START:102}),s=A.extend({init:function(e){A.fn.init.call(this,e),this._initStates()},_initStates:function(){var e,t=this;for(e=0;e<t.states.length;e++)t[t.states[e]]=new r[t.states[e]](t,t.states)},initValue:function(e,t,n){var i=this;i.pattern=[],i.value=e,i.width=t,i.height=n,i.checkSum=0,i.totalUnits=0,i.index=0,i.position=1},addData:function(){var e=this,t={value:e.value,index:0,state:""};0!==e.value.length&&(t.state=t.previousState=e.getNextState(t,e.states),e.addStart(t),e.pushData(t,e.states),e.addCheckSum(),e.addStop(),e.setBaseUnit())},pushData:function(e,t){for(var n,i=this;;){if(i[e.state].pushState(e),e.index>=e.value.length)break;e.shifted?(n=e.state,e.state=e.previousState,e.previousState=n,e.shifted=!1):(e.previousState=e.state,e.state=i.getNextState(e,t),i[e.state].move(e))}},addStart:function(e){this[e.state].addStart(e),this.position=1},addCheckSum:function(){var e=this;e.checksum=e.checkSum%103,e.addPattern(e.checksum)},addStop:function(){this.addPattern(this.STOP)},setBaseUnit:function(){var e=this;e.baseUnit=e.width/(e.totalUnits+e.quietZoneLength)},addPattern:function(e){var t,n,i=this,o=""+i.characterMap[e];for(n=0;n<o.length;n++)t=parseInt(o.charAt(n),10),i.pattern.push(t),i.totalUnits+=t;i.checkSum+=e*i.position++},getNextState:function(e,t){for(var n=0;n<t.length;n++)if(this[t[n]].is(e.value,e.index))return t[n];this.invalidCharacterError(e.value.charAt(e.index))},characterMap:[212222,222122,222221,121223,121322,131222,122213,122312,132212,221213,221312,231212,112232,122132,122231,113222,123122,123221,223211,221132,221231,213212,223112,312131,311222,321122,321221,312212,322112,322211,212123,212321,232121,111323,131123,131321,112313,132113,132311,211313,231113,231311,112133,112331,132131,113123,113321,133121,313121,211331,231131,213113,213311,213131,311123,311321,331121,312113,312311,332111,314111,221411,431111,111224,111422,121124,121421,141122,141221,112214,112412,122114,122411,142112,142211,241211,221114,413111,241112,134111,111242,121142,121241,114212,124112,124211,411212,421112,421211,212141,214121,412121,111143,111341,131141,114113,114311,411113,411311,113141,114131,311141,411131,211412,211214,211232,2331112],STOP:106}),E.code128a=s.extend({name:"Code 128 A",states:["A"]}),E.code128b=s.extend({name:"Code 128 B",states:["B"]}),E.code128c=s.extend({name:"Code 128 C",states:["C"]}),E.code128=s.extend({name:"Code 128",states:["C","B","A","FNC4"]}),E["gs1-128"]=s.extend({name:"Code GS1-128",states:["FNC1","C","B"]}),a=A.extend({initValue:function(e,t){var n=this;n.pattern=[],n.value=e,n.checkSumLength=0,n.width=t},setBaseUnit:function(){var e=this,t=7;e.baseUnit=e.width/(12*(e.value.length+e.checkSumLength)+e.quietZoneLength+t)},addData:function(){var e,t=this,n=t.value;for(t.addPattern(t.START),e=0;e<n.length;e++)t.addCharacter(n.charAt(e));t.options.addCheckSum&&t.addCheckSum(),t.addPattern(t.STOP),t.setBaseUnit()},addCharacter:function(e){var t=this,n=t.characterMap[e];n||t.invalidCharacterError(e),t.addPattern(n)},addPattern:function(e){for(var t=0;t<e.length;t++)this.pattern.push(parseInt(e.charAt(t),10))},addCheckSum:function(){var e,t=this,n=t.checkSums[t.checkSumType],i=n.call(t.checkSums,t.value);for(t.checksum=i.join(""),e=0;e<i.length;e++)t.checkSumLength++,t.addPattern(t.characterMap[i[e]])},checkSums:{Modulo10:function(e){var t,n,i,o=[0,""],r=e.length%2;for(t=0;t<e.length;t++)o[(t+r)%2]+=parseInt(e.charAt(t),10);for(i=o[0],n=""+2*o[1],t=0;t<n.length;t++)i+=parseInt(n.charAt(t),10);return[(10-i%10)%10]},Modulo11:function(e){var t,n,i,o=0,r=11,s=e.length;for(i=0;i<s;i++)t=((s-i)%6||6)+1,o+=t*e.charAt(i);return n=(r-o%r)%r,10!=n?[n]:[1,0]},Modulo11Modulo10:function(e){var t,n=this.Modulo11(e);return t=e+n[0],n.concat(this.Modulo10(t))},Modulo10Modulo10:function(e){var t,n=this.Modulo10(e);return t=e+n[0],n.concat(this.Modulo10(t))}},characterMap:["12121212","12121221","12122112","12122121","12211212","12211221","12212112","12212121","21121212","21121221"],START:"21",STOP:"121",checkSumType:""}),E.msimod10=a.extend({name:"MSI Modulo10",checkSumType:"Modulo10"}),E.msimod11=a.extend({name:"MSI Modulo11",checkSumType:"Modulo11"}),E.msimod1110=a.extend({name:"MSI Modulo11 Modulo10",checkSumType:"Modulo11Modulo10"}),E.msimod1010=a.extend({name:"MSI Modulo10 Modulo10",checkSumType:"Modulo10Modulo10"}),E.code11=A.extend({name:"Code 11",cCheckSumTotal:10,kCheckSumTotal:9,kCheckSumMinLength:10,checkSumMod:11,DASH_VALUE:10,DASH:"-",START:"112211",STOP:"11221",initValue:function(e,t){var n=this;n.pattern=[],n.value=e,n.width=t,n.totalUnits=0},addData:function(){var e,t=this,n=t.value;for(t.addPattern(t.START),e=0;e<n.length;e++)t.addCharacter(n.charAt(e));t.options.addCheckSum&&t.addCheckSum(),t.addPattern(t.STOP),t.setBaseUnit()},setBaseUnit:function(){var e=this;e.baseUnit=e.width/(e.totalUnits+e.quietZoneLength)},addCheckSum:function(){var e,t=this,n=t.value,i=n.length,o=t.getWeightedSum(n,i,t.cCheckSumTotal)%t.checkSumMod;t.checksum=o+"",t.addPattern(t.characterMap[o]),i++,i>=t.kCheckSumMinLength&&(e=(o+t.getWeightedSum(n,i,t.kCheckSumTotal))%t.checkSumMod,t.checksum+=e,t.addPattern(t.characterMap[e]))},getWeightedSum:function(e,t,n){var i,o=0;for(i=0;i<e.length;i++)o+=this.weightedValue(this.getValue(e.charAt(i)),t,i,n);return o},weightedValue:function(e,t,n,i){var o=(t-n)%i||i;return o*e},getValue:function(e){var t=this;return isNaN(e)?(e!==t.DASH&&t.invalidCharacterError(e),t.DASH_VALUE):parseInt(e,10)},addCharacter:function(e){var t=this,n=t.getValue(e),i=t.characterMap[n];t.addPattern(i)},addPattern:function(e){var t,n;for(n=0;n<e.length;n++)t=parseInt(e.charAt(n),10),this.pattern.push(t),this.totalUnits+=t},characterMap:["111121","211121","121121","221111","112121","212111","122111","111221","211211","211111","112111"],options:{addCheckSum:!0}}),E.postnet=A.extend({name:"Postnet",START:"2",VALID_CODE_LENGTHS:[5,9,11],DIGIT_SEPARATOR:"-",initValue:function(e,t,n){var i=this;i.height=n,i.width=t,i.baseHeight=n/2,i.value=e.replace(RegExp(i.DIGIT_SEPARATOR,"g"),""),i.pattern=[],i.validate(i.value),i.checkSum=0,i.setBaseUnit()},addData:function(){var e,t=this,n=t.value;for(t.addPattern(t.START),e=0;e<n.length;e++)t.addCharacter(n.charAt(e));t.options.addCheckSum&&t.addCheckSum(),t.addPattern(t.START),t.pattern.pop()},addCharacter:function(e){var t=this,n=t.characterMap[e];t.checkSum+=parseInt(e,10),t.addPattern(n)},addCheckSum:function(){var e=this;e.checksum=(10-e.checkSum%10)%10,e.addCharacter(e.checksum)},setBaseUnit:function(){var e=this,t=3;e.baseUnit=e.width/(10*(e.value.length+1)+t+e.quietZoneLength)},validate:function(e){var t=this;if(S.test(e)||t.invalidCharacterError(e.match(/[^0-9]/)[0]),f(e.length,t.VALID_CODE_LENGTHS)<0)throw Error("Invalid value length. Valid lengths for the Postnet symbology are "+t.VALID_CODE_LENGTHS.join(","))},addPattern:function(e){var t,n,i=this;for(n=0;n<e.length;n++)t=i.height-i.baseHeight*e.charAt(n),i.pattern.push({width:1,y1:t,y2:i.height}),i.pattern.push(1)},characterMap:["22111","11122","11212","11221","12112","12121","12211","21112","21121","21211"]}),E.ean13=A.extend({initValue:function(e,t,n){if(e+="",12!=e.length||/\D/.test(e))throw Error('The value of the "EAN13" encoding should be 12 symbols');var i=this;i.pattern=[],i.options.height=n,i.baseUnit=t/(95+i.quietZoneLength),i.value=e,i.checksum=i.calculateChecksum(),i.leftKey=e[0],i.leftPart=e.substr(1,6),i.rightPart=e.substr(7)+i.checksum},addData:function(){var e=this;e.addPieces(e.characterMap.start),e.addSide(e.leftPart,e.leftKey),e.addPieces(e.characterMap.middle),e.addSide(e.rightPart),e.addPieces(e.characterMap.start)},addSide:function(e,t){var n,i=this;for(n=0;n<e.length;n++)t&&parseInt(i.keyTable[t].charAt(n),10)?i.addPieces(Array.prototype.slice.call(i.characterMap.digits[e.charAt(n)]).reverse(),!0):i.addPieces(i.characterMap.digits[e.charAt(n)],!0)},addPieces:function(e,t){var n,i=this;for(n=0;n<e.length;n++)i.pattern.push(t?{y1:0,y2:.95*i.options.height,width:e[n]}:e[n])},calculateChecksum:function(){var e,t,n=0,i=0,o=this.value.split("").reverse().join("");for(e=0;e<o.length;e++)e%2?i+=parseInt(o.charAt(e),10):n+=parseInt(o.charAt(e),10);return t=(10-(3*n+i)%10)%10},keyTable:["000000","001011","001101","001110","010011","011001","011100","010101","010110","011010"],characterMap:{digits:[[3,2,1,1],[2,2,2,1],[2,1,2,2],[1,4,1,1],[1,1,3,2],[1,2,3,1],[1,1,1,4],[1,3,1,2],[1,2,1,3],[3,1,1,2]],start:[1,1,1],middle:[1,1,1,1,1]}}),E.ean8=E.ean13.extend({initValue:function(e,t,n){var i=this;if(7!=e.length||/\D/.test(e))throw Error("Invalid value provided");i.value=e,i.options.height=n,i.checksum=i.calculateChecksum(i.value),i.leftPart=i.value.substr(0,4),i.rightPart=i.value.substr(4)+i.checksum,i.pattern=[],i.baseUnit=t/(67+i.quietZoneLength)}}),l=d.extend({init:function(t,n){var i=this;d.fn.init.call(i,t,n),i.element=e(t),i.wrapper=i.element,i.element.addClass("k-barcode").css("display","block"),i.surfaceWrap=e("<div />").css("position","relative").appendTo(this.element),i.surface=m.Surface.create(i.surfaceWrap,{type:i.options.renderAs}),i._setOptions(n),n&&_(n.value)&&i.redraw()},setOptions:function(e){this._setOptions(e),this.redraw()},redraw:function(){var e=this._getSize();this.surface.clear(),this.surface.setSize({width:e.width,height:e.height}),this.createVisual(),this.surface.draw(this.visual)},getSize:function(){return c.dimensions(this.element)},_resize:function(){this.redraw()},createVisual:function(){this.visual=this._render()},_render:function(){var e,t,n,i=this,o=i.options,r=o.value,s=o.text,a=b.getSpacing(s.margin),l=i._getSize(),c=o.border||{},d=i.encoding,u=new w(0,0,l.width,l.height).unpad(c.width).unpad(o.padding),h=u.height(),f=new m.Group;return i.contentBox=u,f.append(i._getBackground(l)),s.visible&&(n=m.util.measureText(r,{font:s.font}).height,h-=n+a.top+a.bottom),e=d.encode(r,u.width(),h),s.visible&&(t=r,o.checksum&&_(d.checksum)&&(t+=" "+d.checksum),f.append(i._getText(t))),i.barHeight=h,this._bandsGroup=this._getBands(e.pattern,e.baseUnit),f.append(this._bandsGroup),f},exportVisual:function(){return this._render()},_getSize:function(){var e=this,t=e.element,n=new g.Size(k,x);return t.width()>0&&(n.width=t.width()),t.height()>0&&(n.height=t.height()),e.options.width&&(n.width=e.options.width),e.options.height&&(n.height=e.options.height),n},value:function(e){var n=this;return _(e)?(n.options.value=e+"",n.redraw(),t):n.options.value},_getBands:function(e,t){var n,i,o,r,s,a=this,l=a.contentBox,c=l.x1,d=new m.Group;for(o=0;o<e.length;o++)i=p(e[o])?e[o]:{width:e[o],y1:0,y2:a.barHeight},n=i.width*t,o%2&&(r=g.Rect.fromPoints(new g.Point(c,i.y1+l.y1),new g.Point(c+n,i.y2+l.y1)),s=m.Path.fromRect(r,{fill:{color:a.options.color},stroke:null}),d.append(s)),c+=n;return d},_getBackground:function(e){var t=this,n=t.options,i=n.border||{},o=new w(0,0,e.width,e.height).unpad(i.width/2),r=m.Path.fromRect(o.toRect(),{fill:{color:n.background},stroke:{color:i.width?i.color:"",width:i.width,dashType:i.dashType}});return r},_getText:function(e){var t=this,n=t.options.text,i=t._textbox=new y(e,{font:n.font,color:n.color,align:"center",vAlign:"bottom",margin:n.margin});return i.reflow(t.contentBox),i.renderVisual(),i.visual},_setOptions:function(e){var t=this;if(t.type=(e.type||t.options.type).toLowerCase(),"upca"==t.type&&(t.type="ean13",e.value="0"+e.value),"upce"==t.type&&(t.type="ean8",e.value="0"+e.value),!E[t.type])throw Error("Encoding "+t.type+"is not supported.");t.encoding=new E[t.type],t.options=u(!0,t.options,e)},options:{name:"Barcode",renderAs:"svg",value:"",type:"code39",checksum:!1,width:0,height:0,color:"black",background:"white",text:{visible:!0,font:"16px Consolas, Monaco, Sans Mono, monospace, sans-serif",color:"black",margin:{top:0,bottom:0,left:0,right:0}},border:{width:0,dashType:"solid",color:"black"},padding:{top:0,bottom:0,left:0,right:0}}}),b.ExportMixin.extend(l.fn),b.ui.plugin(l),c.deepExtend(b,{encodings:E,Encoding:A})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.qrcode.min",["kendo.dataviz.core.min","kendo.drawing.min"],e)}(function(){return function(e,t){function n(e){return parseInt(e,2)}function i(e,t){var n=(+e).toString(2);return n.length<t&&(n=Array(t-n.length+1).join(0)+n),n}function o(e,t){for(var n=[],i=0;i<e.length;)n.push(e.substring(i,i+t)),i+=t;return n}function r(e,t,n,i){for(var o=0;o<e.length;o++)e[o][n][i]=t}function s(e,t,n,i){for(var o=0;o<ve.length;o++)e[o][n][i]=ve[o](n,i)?1^t:parseInt(t,10)}function a(){var e,t;for(t=1;t<255;t++)e=2*re[t-1],e>255&&(e=285^e),re[t]=e,oe[e]=t;e=2*re[t-1]^285,re[t]=e,re[-1]=0}function l(){var e,t,n,i=68;for(e=2;e<=i;e++)t=se[e-1],n=[e,0],se[e]=w(t,n)}function c(e,n){var i=[],o=e.length-1;do i[o]=re[(e[o]+n)%255],o--;while(e[o]!==t);return i}function d(e,t){return parseInt(e.charAt(t),10)}function u(e,t,n,i,o){t[e][i]=(t[e][i]<<1^o)%128,t[e][i]==ge&&(n[e]+=40)}function h(e,t,n,i,o,r){n[e][r]==i?o[e][r]++:(n[e][r]=i,o[e][r]>=5&&(t[e]+=3+o[e][r]-5),o[e][r]=1)}function f(e,t){var n=Math.floor(e/t*100),i=n%5,o=Math.abs(n-i-50),r=Math.abs(n+5-i-50),s=10*Math.min(o/5,r/5);return s}var p,m,g,v,_,b,w,y,k,x,C,S,T,D,A,E,I,M,R,F,z,P,B,L,H,N,O,V,U,W,j,q,G,$,K=window.kendo,Y=e.extend,Q=K.drawing,X=K.dataviz,Z=K.ui.Widget,J=X.Box2D,ee="0000",te="numeric",ne="alphanumeric",ie="byte",oe={1:0},re={0:1},se=[[1,0],[1,25,0]],ae={15:20,16:20,18:24,19:24,22:20,24:22,26:24,28:20,30:20,31:24,32:28,33:24,36:18,37:22,39:20,40:24},le=[{L:{groups:[[1,19]],totalDataCodewords:19,errorCodewordsPerBlock:7},M:{groups:[[1,16]],totalDataCodewords:16,errorCodewordsPerBlock:10},Q:{groups:[[1,13]],totalDataCodewords:13,errorCodewordsPerBlock:13},H:{groups:[[1,9]],totalDataCodewords:9,errorCodewordsPerBlock:17}},{L:{groups:[[1,34]],totalDataCodewords:34,errorCodewordsPerBlock:10},M:{groups:[[1,28]],totalDataCodewords:28,errorCodewordsPerBlock:16},Q:{groups:[[1,22]],totalDataCodewords:22,errorCodewordsPerBlock:22},H:{groups:[[1,16]],totalDataCodewords:16,errorCodewordsPerBlock:28}},{L:{groups:[[1,55]],totalDataCodewords:55,errorCodewordsPerBlock:15},M:{groups:[[1,44]],totalDataCodewords:44,errorCodewordsPerBlock:26},Q:{groups:[[2,17]],totalDataCodewords:34,errorCodewordsPerBlock:18},H:{groups:[[2,13]],totalDataCodewords:26,errorCodewordsPerBlock:22}},{L:{groups:[[1,80]],totalDataCodewords:80,errorCodewordsPerBlock:20},M:{groups:[[2,32]],totalDataCodewords:64,errorCodewordsPerBlock:18},Q:{groups:[[2,24]],totalDataCodewords:48,errorCodewordsPerBlock:26},H:{groups:[[4,9]],totalDataCodewords:36,errorCodewordsPerBlock:16}},{L:{groups:[[1,108]],totalDataCodewords:108,errorCodewordsPerBlock:26},M:{groups:[[2,43]],totalDataCodewords:86,errorCodewordsPerBlock:24},Q:{groups:[[2,15],[2,16]],totalDataCodewords:62,errorCodewordsPerBlock:18},H:{groups:[[2,11],[2,12]],totalDataCodewords:46,errorCodewordsPerBlock:22}},{L:{groups:[[2,68]],totalDataCodewords:136,errorCodewordsPerBlock:18},M:{groups:[[4,27]],totalDataCodewords:108,errorCodewordsPerBlock:16},Q:{groups:[[4,19]],totalDataCodewords:76,errorCodewordsPerBlock:24},H:{groups:[[4,15]],totalDataCodewords:60,errorCodewordsPerBlock:28}},{L:{groups:[[2,78]],totalDataCodewords:156,errorCodewordsPerBlock:20},M:{groups:[[4,31]],totalDataCodewords:124,errorCodewordsPerBlock:18},Q:{groups:[[2,14],[4,15]],totalDataCodewords:88,errorCodewordsPerBlock:18},H:{groups:[[4,13],[1,14]],totalDataCodewords:66,errorCodewordsPerBlock:26}},{L:{groups:[[2,97]],totalDataCodewords:194,errorCodewordsPerBlock:24},M:{groups:[[2,38],[2,39]],totalDataCodewords:154,errorCodewordsPerBlock:22},Q:{groups:[[4,18],[2,19]],totalDataCodewords:110,errorCodewordsPerBlock:22},H:{groups:[[4,14],[2,15]],totalDataCodewords:86,errorCodewordsPerBlock:26}},{L:{groups:[[2,116]],totalDataCodewords:232,errorCodewordsPerBlock:30},M:{groups:[[3,36],[2,37]],totalDataCodewords:182,errorCodewordsPerBlock:22},Q:{groups:[[4,16],[4,17]],totalDataCodewords:132,errorCodewordsPerBlock:20},H:{groups:[[4,12],[4,13]],totalDataCodewords:100,errorCodewordsPerBlock:24}},{L:{groups:[[2,68],[2,69]],totalDataCodewords:274,errorCodewordsPerBlock:18},M:{groups:[[4,43],[1,44]],totalDataCodewords:216,errorCodewordsPerBlock:26},Q:{groups:[[6,19],[2,20]],totalDataCodewords:154,errorCodewordsPerBlock:24},H:{groups:[[6,15],[2,16]],totalDataCodewords:122,errorCodewordsPerBlock:28}},{L:{groups:[[4,81]],totalDataCodewords:324,errorCodewordsPerBlock:20},M:{groups:[[1,50],[4,51]],totalDataCodewords:254,errorCodewordsPerBlock:30},Q:{groups:[[4,22],[4,23]],totalDataCodewords:180,errorCodewordsPerBlock:28},H:{groups:[[3,12],[8,13]],totalDataCodewords:140,errorCodewordsPerBlock:24}},{L:{groups:[[2,92],[2,93]],totalDataCodewords:370,errorCodewordsPerBlock:24},M:{groups:[[6,36],[2,37]],totalDataCodewords:290,errorCodewordsPerBlock:22},Q:{groups:[[4,20],[6,21]],totalDataCodewords:206,errorCodewordsPerBlock:26},H:{groups:[[7,14],[4,15]],totalDataCodewords:158,errorCodewordsPerBlock:28}},{L:{groups:[[4,107]],totalDataCodewords:428,errorCodewordsPerBlock:26},M:{groups:[[8,37],[1,38]],totalDataCodewords:334,errorCodewordsPerBlock:22},Q:{groups:[[8,20],[4,21]],totalDataCodewords:244,errorCodewordsPerBlock:24},H:{groups:[[12,11],[4,12]],totalDataCodewords:180,errorCodewordsPerBlock:22}},{L:{groups:[[3,115],[1,116]],totalDataCodewords:461,errorCodewordsPerBlock:30},M:{groups:[[4,40],[5,41]],totalDataCodewords:365,errorCodewordsPerBlock:24},Q:{groups:[[11,16],[5,17]],totalDataCodewords:261,errorCodewordsPerBlock:20},H:{groups:[[11,12],[5,13]],totalDataCodewords:197,errorCodewordsPerBlock:24}},{L:{groups:[[5,87],[1,88]],totalDataCodewords:523,errorCodewordsPerBlock:22},M:{groups:[[5,41],[5,42]],totalDataCodewords:415,errorCodewordsPerBlock:24},Q:{groups:[[5,24],[7,25]],totalDataCodewords:295,errorCodewordsPerBlock:30},H:{groups:[[11,12],[7,13]],totalDataCodewords:223,errorCodewordsPerBlock:24}},{L:{groups:[[5,98],[1,99]],totalDataCodewords:589,errorCodewordsPerBlock:24},M:{groups:[[7,45],[3,46]],totalDataCodewords:453,errorCodewordsPerBlock:28},Q:{groups:[[15,19],[2,20]],totalDataCodewords:325,errorCodewordsPerBlock:24},H:{groups:[[3,15],[13,16]],totalDataCodewords:253,errorCodewordsPerBlock:30}},{L:{groups:[[1,107],[5,108]],totalDataCodewords:647,errorCodewordsPerBlock:28},M:{groups:[[10,46],[1,47]],totalDataCodewords:507,errorCodewordsPerBlock:28},Q:{groups:[[1,22],[15,23]],totalDataCodewords:367,errorCodewordsPerBlock:28},H:{groups:[[2,14],[17,15]],totalDataCodewords:283,errorCodewordsPerBlock:28}},{L:{groups:[[5,120],[1,121]],totalDataCodewords:721,errorCodewordsPerBlock:30},M:{groups:[[9,43],[4,44]],totalDataCodewords:563,errorCodewordsPerBlock:26},Q:{groups:[[17,22],[1,23]],totalDataCodewords:397,errorCodewordsPerBlock:28},H:{groups:[[2,14],[19,15]],totalDataCodewords:313,errorCodewordsPerBlock:28}},{L:{groups:[[3,113],[4,114]],totalDataCodewords:795,errorCodewordsPerBlock:28},M:{groups:[[3,44],[11,45]],totalDataCodewords:627,errorCodewordsPerBlock:26},Q:{groups:[[17,21],[4,22]],totalDataCodewords:445,errorCodewordsPerBlock:26},H:{groups:[[9,13],[16,14]],totalDataCodewords:341,errorCodewordsPerBlock:26}},{L:{groups:[[3,107],[5,108]],totalDataCodewords:861,errorCodewordsPerBlock:28},M:{groups:[[3,41],[13,42]],totalDataCodewords:669,errorCodewordsPerBlock:26},Q:{groups:[[15,24],[5,25]],totalDataCodewords:485,errorCodewordsPerBlock:30},H:{groups:[[15,15],[10,16]],totalDataCodewords:385,errorCodewordsPerBlock:28}},{L:{groups:[[4,116],[4,117]],totalDataCodewords:932,errorCodewordsPerBlock:28},M:{groups:[[17,42]],totalDataCodewords:714,errorCodewordsPerBlock:26},Q:{groups:[[17,22],[6,23]],totalDataCodewords:512,errorCodewordsPerBlock:28},H:{groups:[[19,16],[6,17]],totalDataCodewords:406,errorCodewordsPerBlock:30}},{L:{groups:[[2,111],[7,112]],totalDataCodewords:1006,errorCodewordsPerBlock:28},M:{groups:[[17,46]],totalDataCodewords:782,errorCodewordsPerBlock:28},Q:{groups:[[7,24],[16,25]],totalDataCodewords:568,errorCodewordsPerBlock:30},H:{groups:[[34,13]],totalDataCodewords:442,errorCodewordsPerBlock:24}},{L:{groups:[[4,121],[5,122]],totalDataCodewords:1094,errorCodewordsPerBlock:30},M:{groups:[[4,47],[14,48]],totalDataCodewords:860,errorCodewordsPerBlock:28},Q:{groups:[[11,24],[14,25]],totalDataCodewords:614,errorCodewordsPerBlock:30},H:{groups:[[16,15],[14,16]],totalDataCodewords:464,errorCodewordsPerBlock:30}},{L:{groups:[[6,117],[4,118]],totalDataCodewords:1174,errorCodewordsPerBlock:30},M:{groups:[[6,45],[14,46]],totalDataCodewords:914,errorCodewordsPerBlock:28},Q:{groups:[[11,24],[16,25]],totalDataCodewords:664,errorCodewordsPerBlock:30},H:{groups:[[30,16],[2,17]],totalDataCodewords:514,errorCodewordsPerBlock:30}},{L:{groups:[[8,106],[4,107]],totalDataCodewords:1276,errorCodewordsPerBlock:26},M:{groups:[[8,47],[13,48]],totalDataCodewords:1e3,errorCodewordsPerBlock:28},Q:{groups:[[7,24],[22,25]],totalDataCodewords:718,errorCodewordsPerBlock:30},H:{groups:[[22,15],[13,16]],totalDataCodewords:538,errorCodewordsPerBlock:30}},{L:{groups:[[10,114],[2,115]],totalDataCodewords:1370,errorCodewordsPerBlock:28},M:{groups:[[19,46],[4,47]],totalDataCodewords:1062,errorCodewordsPerBlock:28},Q:{groups:[[28,22],[6,23]],totalDataCodewords:754,errorCodewordsPerBlock:28},H:{groups:[[33,16],[4,17]],totalDataCodewords:596,errorCodewordsPerBlock:30}},{L:{groups:[[8,122],[4,123]],totalDataCodewords:1468,errorCodewordsPerBlock:30},M:{groups:[[22,45],[3,46]],totalDataCodewords:1128,errorCodewordsPerBlock:28},Q:{groups:[[8,23],[26,24]],totalDataCodewords:808,errorCodewordsPerBlock:30},H:{groups:[[12,15],[28,16]],totalDataCodewords:628,errorCodewordsPerBlock:30}},{L:{groups:[[3,117],[10,118]],totalDataCodewords:1531,errorCodewordsPerBlock:30},M:{groups:[[3,45],[23,46]],totalDataCodewords:1193,errorCodewordsPerBlock:28},Q:{groups:[[4,24],[31,25]],totalDataCodewords:871,errorCodewordsPerBlock:30},H:{groups:[[11,15],[31,16]],totalDataCodewords:661,errorCodewordsPerBlock:30}},{L:{groups:[[7,116],[7,117]],totalDataCodewords:1631,errorCodewordsPerBlock:30},M:{groups:[[21,45],[7,46]],totalDataCodewords:1267,errorCodewordsPerBlock:28},Q:{groups:[[1,23],[37,24]],totalDataCodewords:911,errorCodewordsPerBlock:30},H:{groups:[[19,15],[26,16]],totalDataCodewords:701,errorCodewordsPerBlock:30}},{L:{groups:[[5,115],[10,116]],totalDataCodewords:1735,errorCodewordsPerBlock:30},M:{groups:[[19,47],[10,48]],totalDataCodewords:1373,errorCodewordsPerBlock:28},Q:{groups:[[15,24],[25,25]],totalDataCodewords:985,errorCodewordsPerBlock:30},H:{groups:[[23,15],[25,16]],totalDataCodewords:745,errorCodewordsPerBlock:30}},{L:{groups:[[13,115],[3,116]],totalDataCodewords:1843,errorCodewordsPerBlock:30},M:{groups:[[2,46],[29,47]],totalDataCodewords:1455,errorCodewordsPerBlock:28},Q:{groups:[[42,24],[1,25]],totalDataCodewords:1033,errorCodewordsPerBlock:30},H:{groups:[[23,15],[28,16]],totalDataCodewords:793,errorCodewordsPerBlock:30}},{L:{groups:[[17,115]],totalDataCodewords:1955,errorCodewordsPerBlock:30},M:{groups:[[10,46],[23,47]],totalDataCodewords:1541,errorCodewordsPerBlock:28},Q:{groups:[[10,24],[35,25]],totalDataCodewords:1115,errorCodewordsPerBlock:30},H:{groups:[[19,15],[35,16]],totalDataCodewords:845,errorCodewordsPerBlock:30}},{L:{groups:[[17,115],[1,116]],totalDataCodewords:2071,errorCodewordsPerBlock:30},M:{groups:[[14,46],[21,47]],totalDataCodewords:1631,errorCodewordsPerBlock:28},Q:{groups:[[29,24],[19,25]],totalDataCodewords:1171,errorCodewordsPerBlock:30},H:{groups:[[11,15],[46,16]],totalDataCodewords:901,errorCodewordsPerBlock:30}},{L:{groups:[[13,115],[6,116]],totalDataCodewords:2191,errorCodewordsPerBlock:30},M:{groups:[[14,46],[23,47]],totalDataCodewords:1725,errorCodewordsPerBlock:28},Q:{groups:[[44,24],[7,25]],totalDataCodewords:1231,errorCodewordsPerBlock:30},H:{groups:[[59,16],[1,17]],totalDataCodewords:961,errorCodewordsPerBlock:30}},{L:{groups:[[12,121],[7,122]],totalDataCodewords:2306,errorCodewordsPerBlock:30},M:{groups:[[12,47],[26,48]],totalDataCodewords:1812,errorCodewordsPerBlock:28},Q:{groups:[[39,24],[14,25]],totalDataCodewords:1286,errorCodewordsPerBlock:30},H:{groups:[[22,15],[41,16]],totalDataCodewords:986,errorCodewordsPerBlock:30}},{L:{groups:[[6,121],[14,122]],totalDataCodewords:2434,errorCodewordsPerBlock:30},M:{groups:[[6,47],[34,48]],totalDataCodewords:1914,errorCodewordsPerBlock:28},Q:{groups:[[46,24],[10,25]],totalDataCodewords:1354,errorCodewordsPerBlock:30},H:{groups:[[2,15],[64,16]],totalDataCodewords:1054,errorCodewordsPerBlock:30}},{L:{groups:[[17,122],[4,123]],totalDataCodewords:2566,errorCodewordsPerBlock:30},M:{groups:[[29,46],[14,47]],totalDataCodewords:1992,errorCodewordsPerBlock:28},Q:{groups:[[49,24],[10,25]],totalDataCodewords:1426,errorCodewordsPerBlock:30},H:{groups:[[24,15],[46,16]],totalDataCodewords:1096,errorCodewordsPerBlock:30}},{L:{groups:[[4,122],[18,123]],totalDataCodewords:2702,errorCodewordsPerBlock:30},M:{groups:[[13,46],[32,47]],totalDataCodewords:2102,errorCodewordsPerBlock:28},Q:{groups:[[48,24],[14,25]],totalDataCodewords:1502,errorCodewordsPerBlock:30},H:{groups:[[42,15],[32,16]],totalDataCodewords:1142,errorCodewordsPerBlock:30}},{L:{groups:[[20,117],[4,118]],totalDataCodewords:2812,errorCodewordsPerBlock:30},M:{groups:[[40,47],[7,48]],totalDataCodewords:2216,errorCodewordsPerBlock:28},Q:{groups:[[43,24],[22,25]],totalDataCodewords:1582,errorCodewordsPerBlock:30},H:{groups:[[10,15],[67,16]],totalDataCodewords:1222,errorCodewordsPerBlock:30}},{L:{groups:[[19,118],[6,119]],totalDataCodewords:2956,errorCodewordsPerBlock:30},M:{groups:[[18,47],[31,48]],totalDataCodewords:2334,errorCodewordsPerBlock:28},Q:{groups:[[34,24],[34,25]],totalDataCodewords:1666,errorCodewordsPerBlock:30},H:{groups:[[20,15],[61,16]],totalDataCodewords:1276,errorCodewordsPerBlock:30}}],ce=[1,0,1,1,1],de=[1,0,1],ue={L:"01",M:"00",Q:"11",H:"10"},he="101010000010010",fe="10100110111",pe="1111100100101",me=["11101100","00010001"],ge=93,ve=[function(e,t){return(e+t)%2===0},function(e){return e%2===0},function(e,t){return t%3===0},function(e,t){return(e+t)%3===0},function(e,t){return(Math.floor(e/2)+Math.floor(t/3))%2===0},function(e,t){return e*t%2+e*t%3===0},function(e,t){return(e*t%2+e*t%3)%2===0},function(e,t){return((e+t)%2+e*t%3)%2===0}],_e=/^\d+/,be="A-Z0-9 $%*+./:-",we="A-Z $%*+./:-",ye=RegExp("^["+we+"]+"),ke=RegExp("^["+be+"]+"),xe=RegExp("^[^"+be+"]+"),Ce=8,Se=5,Te=8,De=17,Ae=9,Ee=16,Ie=Math.round,Me=K.Class.extend({getVersionIndex:function(e){return e<10?0:e>26?2:1},getBitsCharacterCount:function(e){var t=this;return t.bitsInCharacterCount[t.getVersionIndex(e||40)]},getModeCountString:function(e,t){var n=this;return n.modeIndicator+i(e,n.getBitsCharacterCount(t))},encode:function(){},getStringBitsLength:function(){},getValue:function(){},modeIndicator:"",bitsInCharacterCount:[]}),Re={};Re[te]=Me.extend({bitsInCharacterCount:[10,12,14],modeIndicator:"0001",getValue:function(e){return parseInt(e,10)},encode:function(e,t){var n,r=this,s=o(e,3),a=r.getModeCountString(e.length,t);for(n=0;n<s.length-1;n++)a+=i(s[n],10);return a+i(s[n],1+3*s[n].length)},getStringBitsLength:function(e,t){var n=e%3;return 4+this.getBitsCharacterCount(t)+10*Math.floor(e/3)+3*n+(0===n?0:1)}}),Re[ne]=Me.extend({characters:{0:0,1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,A:10,B:11,C:12,D:13,E:14,F:15,G:16,H:17,I:18,J:19,K:20,L:21,M:22,N:23,O:24,P:25,Q:26,R:27,S:28,T:29,U:30,V:31,W:32,X:33,Y:34,Z:35," ":36,$:37,"%":38,"*":39,"+":40,"-":41,".":42,"/":43,":":44},bitsInCharacterCount:[9,11,13],modeIndicator:"0010",getValue:function(e){return this.characters[e]},encode:function(e,t){var n,r,s=this,a=o(e,2),l=s.getModeCountString(e.length,t);for(r=0;r<a.length-1;r++)n=45*s.getValue(a[r].charAt(0))+s.getValue(a[r].charAt(1)),l+=i(n,11);return n=2==a[r].length?45*s.getValue(a[r].charAt(0))+s.getValue(a[r].charAt(1)):s.getValue(a[r].charAt(0)),l+i(n,1+5*a[r].length)},getStringBitsLength:function(e,t){return 4+this.getBitsCharacterCount(t)+11*Math.floor(e/2)+6*(e%2)}}),Re[ie]=Me.extend({bitsInCharacterCount:[8,16,16],modeIndicator:"0100",getValue:function(e){var t=e.charCodeAt(0);if(t<=127||160<=t&&t<=255)return t;throw Error("Unsupported character: "+e)},encode:function(e,t){var n,o=this,r=o.getModeCountString(e.length,t);for(n=0;n<e.length;n++)r+=i(o.getValue(e.charAt(n)),8);return r},getStringBitsLength:function(e,t){return 4+this.getBitsCharacterCount(t)+8*e}}),p={};for(m in Re)p[m]=new Re[m];g=function(e){var n=this,i=e.length-1,o=e.length-1,r=o,s=-1,a=0;n.move=function(){i+=s*a,a^=1,o=r-a},n.getNextCell=function(){for(;e[i][o]!==t;)n.move(),(i<0||i>=e.length)&&(s=-s,r-=8!=r?2:3,o=r,i=s<0?e.length-1:0);return{row:i,column:o}},n.getNextRemainderCell=function(){if(n.move(),e[i][o]===t)return{row:i,column:o}}},v=function(e,t){var n,i,o,r,a,l,c=new g(e[0]);for(r=0;r<t.length;r++)for(n=t[r],i=0;n.length>0;){for(a=0;a<n.length;a++)for(l=0;l<8;l++)o=c.getNextCell(),s(e,n[a][i].charAt(l),o.row,o.column);for(i++;n[0]&&i==n[0].length;)n.splice(0,1)}for(;o=c.getNextRemainderCell();)s(e,0,o.row,o.column)},_=function(e,t){for(var n=8*t,i=0,o=0;e.length<n&&i<ee.length;)e+=ee.charAt(i++);for(e.length%8!==0&&(e+=Array(9-e.length%8).join("0"));e.length<n;)e+=me[o],o^=1;return e},b=function(e,t){var n,i=[],o=e.length-2;for(n=o;n>=0;n--)i[n]=e[n]^t[n];return i},w=function(e,n){var i,o,r=[];for(i=0;i<e.length;i++)for(o=0;o<n.length;o++)r[i+o]=r[i+o]===t?(e[i]+(n[o]>=0?n[o]:0))%255:oe[re[r[i+o]]^re[(e[i]+n[o])%255]];return r},a(),l(),y=function(e,t){var n,o,r=se[t-1],s=Array(t).concat(e),a=Array(s.length-r.length).concat(r),l=e.length,d=[];for(o=0;o<l;o++)n=c(a,oe[s[s.length-1]]),a.splice(0,1),s=b(n,s);for(o=s.length-1;o>=0;o--)d[t-1-o]=i(s[o],8);return d},k=function(e,t){var i,o,r,s,a,l,c,d,u=0,h=[],f=[],p=t.groups;for(l=0;l<p.length;l++)for(r=p[l][0],c=0;c<r;c++){for(o=p[l][1],i=[],s=[],d=1;d<=o;d++)a=e.substring(u,u+8),i.push(a),s[o-d]=n(a),u+=8;h.push(i),f.push(y(s,t.errorCodewordsPerBlock))}return[h,f]},x=function(e,t,n,i,o){var r,s,a=_e.exec(e),l=a?a[0]:"",c=ye.exec(e),d=c?c[0]:"",u=ke.exec(e),h=u?u[0]:"";return l&&(l.length>=t||e.length==l.length||l.length>=n&&!ke.test(e.charAt(l.length)))?(r=te,s=l):h&&(e.length==h.length||h.length>=i||o==ne)?(r=ne,s=l||d):(r=ie,s=h?h+xe.exec(e.substring(h.length))[0]:xe.exec(e)[0]),{mode:r,modeString:s}},C=function(e){var t,n,i=[],o=0;for(i.push(x(e,Ce,Se,Te,t)),t=i[0].mode,e=e.substr(i[0].modeString.length);e.length>0;)n=x(e,De,Ae,Ee,t),n.mode!=t?(t=n.mode,i.push(n),o++):i[o].modeString+=n.modeString,e=e.substr(n.modeString.length);return i},S=function(e){var t,n,i=0;for(n=0;n<e.length;n++)t=p[e[n].mode],i+=t.getStringBitsLength(e[n].modeString.length);return Math.ceil(i/8)},T=function(e,t){var n=0,i=le.length-1,o=Math.floor(le.length/2);do e<le[o][t].totalDataCodewords?i=o:n=o,o=n+Math.floor((i-n)/2);while(i-n>1);return e<=le[n][t].totalDataCodewords?o+1:i+1},D=function(e,t){var n,i,o="";for(i=0;i<e.length;i++)n=p[e[i].mode],
o+=n.encode(e[i].modeString,t);return o},A=function(e){var t,i,o=n(e),r="";if(0===o)return"101010000010010";for(t=E(n(e),fe,15),i=0;i<t.length;i++)r+=t.charAt(i)^he.charAt(i);return r},E=function(e,t,o){var r=n(t),s=t.length-1,a=e<<s,l=o-s,c=i(e,l),d=I(a,r);return d=c+i(d,s)},I=function(e,t){var n=t.toString(2).length,i=e.toString(2).length;do e^=t<<i-n,i=e.toString(2).length;while(i>=n);return e},M=function(e){var t,n,i=[],o=17+4*e;for(t=0;t<ve.length;t++)for(i[t]=Array(o),n=0;n<o;n++)i[t][n]=Array(o);return i},R=function(e,t){var n,i,o=e[0],s=0,a=t.length;for(n=0,i=8;n<=8;n++)6!==n&&r(e,d(t,a-1-s++),n,i);for(n=8,i=7;i>=0;i--)6!==i&&r(e,d(t,a-1-s++),n,i);for(s=0,i=o.length-1,n=8;i>=o.length-8;i--)r(e,d(t,a-1-s++),n,i);for(r(e,1,o.length-8,8),n=o.length-7,i=8;n<o.length;n++)r(e,d(t,a-1-s++),n,i)},F=function(e){return E(e,pe,18)},z=function(e,t){var n,i,o,s,a=e[0],l=a.length,c=0,u=l-11,h=l-11,f=0;for(s=0;s<t.length;s++)n=Math.floor(s/3),i=s%3,o=d(t,t.length-s-1),r(e,o,c+n,u+i),r(e,o,h+i,f+n)},P=function(e,t,n,i){var o,s,a,l=t.length+2,c=t.length+1;for(s=0;s<t.length;s++)for(a=s;a<l-s;a++)o=t[s],r(e,o,n+a,i+s),r(e,o,n+s,i+a),r(e,o,n+c-a,i+c-s),r(e,o,n+c-s,i+c-a)},B=function(e,t,n,i){var o=n,s=i,a=e[0];do r(e,0,o,i),r(e,0,n,s),o+=t[0],s+=t[1];while(o>=0&&o<a.length)},L=function(e){var t=e[0].length;P(e,ce,0,0),B(e,[-1,-1],7,7),P(e,ce,t-7,0),B(e,[1,-1],t-8,7),P(e,ce,0,t-7),B(e,[-1,1],7,t-8)},H=function(e,n){var i,o,r,s,a,l,c,d,u;if(!(n<2)){for(i=e[0],o=i.length,r=Math.floor(n/7),s=[6],c=0,(a=ae[n])?l=(o-13-a)/r:a=l=(o-13)/(r+1),s.push(s[c++]+a);s[c]+l<o;)s.push(s[c++]+l);for(d=0;d<s.length;d++)for(u=0;u<s.length;u++)i[s[d]][s[u]]===t&&P(e,de,s[d]-2,s[u]-2)}},N=function(e){var t,n=6,i=6,o=1,s=e[0].length;for(t=8;t<s-8;t++)r(e,o,n,t),r(e,o,t,i),o^=1},O=function(e){var t,n,i,o,r,s,a,l=[],c=[],d=[],p=[],m=[],g=0,v=1,_=e[0].length;for(n=0;n<e.length;n++)l[n]=0,d[n]=0,m[n]=[0,0],p[n]=[0,0],c[n]=[];for(n=0;n<_;n++)for(i=0;i<_;i++)for(o=0;o<e.length;o++)t=e[o],d[o]+=parseInt(t[n][i],10),c[o][g]===t[n][i]&&n+1<_&&i-1>=0&&t[n+1][i]==c[o][g]&&t[n+1][i-1]==c[o][g]&&(l[o]+=3),u(o,p,l,g,t[n][i]),u(o,p,l,v,t[i][n]),h(o,l,c,t[n][i],m,g),h(o,l,c,t[i][n],m,v);for(r=_*_,a=Number.MAX_VALUE,n=0;n<l.length;n++)l[n]+=f(d[n],r),l[n]<a&&(a=l[n],s=n);return s},V=function(e,t){this.dataString=e,this.version=t},U=function(){this.getEncodingResult=function(e,t){var n=C(e),i=S(n),o=T(i,t),r=D(n,o);return new V(r,o)}},W=function(){this.mode=p[this.encodingMode]},W.fn=W.prototype={encodingMode:ie,utfBOM:"111011111011101110111111",initialModeCountStringLength:20,getEncodingResult:function(e,t){var n=this,i=n.encode(e),o=n.getDataCodewordsCount(i),r=T(o,t),s=n.mode.getModeCountString(i.length/8,r)+i;return new V(s,r)},getDataCodewordsCount:function(e){var t=this,n=e.length,i=Math.ceil((t.initialModeCountStringLength+n)/8);return i},encode:function(e){var t,n=this,i=n.utfBOM;for(t=0;t<e.length;t++)i+=n.encodeCharacter(e.charCodeAt(t));return i},encodeCharacter:function(e){var t,n,o=this.getBytesCount(e),r=o-1,s="";if(1==o)s=i(e,8);else{for(t=8-o,n=0;n<r;n++)s=i(e>>6*n&63|128,8)+s;s=(e>>6*r|255>>t<<t).toString(2)+s}return s},getBytesCount:function(e){var t,n=this.ranges;for(t=0;t<n.length;t++)if(e<n[t])return t+1},ranges:[128,2048,65536,2097152,67108864]},j=function(e){return e&&e.toLowerCase().indexOf("utf_8")>=0?new W:new U},q=function(e,t,n){var o,r,s,a=new j(n),l=a.getEncodingResult(e,t),c=l.version,d=le[c-1][t],u=_(l.dataString,d.totalDataCodewords),h=k(u,d),f=M(c);return L(f),H(f,c),N(f),c>=7&&z(f,i(0,18)),R(f,i(0,15)),v(f,h),o=O(f),r=f[o],c>=7&&z([r],F(c)),s=ue[t]+i(o,3),R([r],A(s)),r},G={DEFAULT_SIZE:200,QUIET_ZONE_LENGTH:4,DEFAULT_ERROR_CORRECTION_LEVEL:"L",DEFAULT_BACKGROUND:"#fff",DEFAULT_DARK_MODULE_COLOR:"#000",MIN_BASE_UNIT_SIZE:1},$=Z.extend({init:function(t,n){var i=this;Z.fn.init.call(i,t,n),i.element=e(t),i.wrapper=i.element,i.element.addClass("k-qrcode"),i.surfaceWrap=e("<div />").css("position","relative").appendTo(this.element),i.surface=Q.Surface.create(i.surfaceWrap,{type:i.options.renderAs}),i.setOptions(n)},redraw:function(){var e=this._getSize();this.surfaceWrap.css({width:e,height:e}),this.surface.clear(),this.createVisual(),this.surface.draw(this.visual)},getSize:function(){return K.dimensions(this.element)},_resize:function(){this.redraw()},createVisual:function(){this.visual=this._render()},exportVisual:function(){return this._render()},_render:function(){var e,t,n,i,o,r,s,a=this,l=a._value,c=a.options.border||{},d=a.options.padding||0,u=c.width||0;return c.width=u,s=new Q.Group,l&&(n=q(l,a.options.errorCorrection,a.options.encoding),i=a._getSize(),r=i-2*(u+d),e=a._calculateBaseUnit(r,n.length),o=n.length*e,t=u+d+(r-o)/2,s.append(a._renderBackground(i,c)),s.append(a._renderMatrix(n,e,t))),s},_getSize:function(){var e,t,n,i=this;return i.options.size?e=parseInt(i.options.size,10):(t=i.element,n=Math.min(t.width(),t.height()),e=n>0?n:G.DEFAULT_SIZE),e},_calculateBaseUnit:function(e,t){var n=Math.floor(e/t);if(n<G.MIN_BASE_UNIT_SIZE)throw Error("Insufficient size.");return n*t>=e&&n-1>=G.MIN_BASE_UNIT_SIZE&&n--,n},_renderMatrix:function(e,t,n){var i,o,r,s,a,l,c,d,u=new Q.MultiPath({fill:{color:this.options.color},stroke:null});for(i=0;i<e.length;i++)for(o=n+i*t,r=0;r<e.length;){for(;0===e[i][r]&&r<e.length;)r++;if(r<e.length){for(s=r;1==e[i][r];)r++;a=Ie(n+s*t),l=Ie(o),c=Ie(n+r*t),d=Ie(o+t),u.moveTo(a,l).lineTo(a,d).lineTo(c,d).lineTo(c,l).close()}}return u},_renderBackground:function(e,t){var n=new J(0,0,e,e).unpad(t.width/2);return Q.Path.fromRect(n.toRect(),{fill:{color:this.options.background},stroke:{color:t.color,width:t.width}})},setOptions:function(e){var n=this;e=e||{},n.options=Y(n.options,e),e.value!==t&&(n._value=n.options.value+""),n.redraw()},value:function(e){var n=this;return e===t?n._value:(n._value=e+"",n.redraw(),t)},options:{name:"QRCode",renderAs:"svg",encoding:"ISO_8859_1",value:"",errorCorrection:G.DEFAULT_ERROR_CORRECTION_LEVEL,background:G.DEFAULT_BACKGROUND,color:G.DEFAULT_DARK_MODULE_COLOR,size:"",padding:0,border:{color:"",width:0}}}),X.ExportMixin.extend($.fn),X.ui.plugin($),K.deepExtend(X,{QRCode:$,QRCodeDefaults:G,QRCodeFunctions:{FreeCellVisitor:g,fillData:v,padDataString:_,generateErrorCodewords:y,xorPolynomials:b,getBlocks:k,multiplyPolynomials:w,chooseMode:x,getModes:C,getDataCodewordsCount:S,getVersion:T,getDataString:D,encodeFormatInformation:A,encodeBCH:E,dividePolynomials:I,initMatrices:M,addFormatInformation:R,encodeVersionInformation:F,addVersionInformation:z,addCentricPattern:P,addFinderSeparator:B,addFinderPatterns:L,addAlignmentPatterns:H,addTimingFunctions:N,scoreMaskMatrixes:O,encodeData:q,UTF8Encoder:W},QRCodeFields:{modes:p,powersOfTwo:oe,powersOfTwoResult:re,generatorPolynomials:se}})}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/stock/kendo-stock-chart.min",["kendo.dataviz.chart.min"],e)}(function(){!function(){function e(e,t){var n=document.createElement("div");return n.className=e,t&&(n.style.cssText=t),n}function t(){}function n(e){return t.prototype=e,new t}var i,o,r,s,a,l,c,d,u,h,f,p,m,g,v,_;window.kendo.dataviz=window.kendo.dataviz||{},i=kendo.dataviz,o=i.elementStyles,r=i.deepExtend,s=i.toTime,a=i.constants,l=i.Chart,c=kendo.drawing,d=c.Animation.extend({setup:function(){this._initialOpacity=parseFloat(o(this.element,"opacity").opacity)},step:function(e){o(this.element,{opacity:i.interpolateValue(this._initialOpacity,0,e)+""})},abort:function(){c.Animation.fn.abort.call(this),o(this.element,{display:"none",opacity:this._initialOpacity+""})},cancel:function(){c.Animation.fn.abort.call(this),o(this.element,{opacity:this._initialOpacity+""})}}),u=i.Class.extend({init:function(e,t,n){this.options=r({},this.options,n),this.container=e,this.chartService=t;var i=o(e,["paddingLeft","paddingTop"]);this.chartPadding={top:i.paddingTop,left:i.paddingLeft},this.createElements(),e.appendChild(this.element)},createElements:function(){var t=this.element=e("k-navigator-hint","display: none; position: absolute; top: 1px; left: 1px;"),n=this.tooltip=e("k-tooltip k-chart-tooltip"),i=this.scroll=e("k-scroll");n.innerHTML="&nbsp;",t.appendChild(n),t.appendChild(i)},show:function(e,t,n){var r,a=this,l=a.element,c=a.options,d=a.scroll,u=a.tooltip,h=i.toDate(s(e)+s(t-e)/2),f=.4*n.width(),p=n.center().x-f,m=n.center().x,g=m-p,v=c.max-c.min,_=g/v,b=h-c.min,w=this.chartService.intl.format(c.format,e,t),y=i.getTemplate(c);this.clearHideTimeout(),this._visible||(o(l,{visibility:"hidden",display:"block"}),this._visible=!0),y&&(w=y({from:e,to:t})),u.innerHTML=w,o(u,{left:n.center().x-u.offsetWidth/2,top:n.y1}),r=o(u,["marginTop","borderTopWidth","height"]),o(d,{width:f,left:p+b*_,top:n.y1+r.marginTop+r.borderTopWidth+r.height/2}),o(l,{visibility:"visible"})},clearHideTimeout:function(){this._hideTimeout&&clearTimeout(this._hideTimeout),this._hideAnimation&&this._hideAnimation.cancel()},hide:function(){var e=this;this.clearHideTimeout(),this._hideTimeout=setTimeout(function(){e._visible=!1,e._hideAnimation=new d(e.element),e._hideAnimation.setup(),e._hideAnimation.play()},this.options.hideDelay)},destroy:function(){this.clearHideTimeout(),this.container&&this.container.removeChild(this.element),delete this.container,delete this.chartService,delete this.element,delete this.tooltip,delete this.scroll}}),i.setDefaultOptions(u,{format:"{0:d} - {1:d}",hideDelay:500}),h="_navigator",f=h,p={NAVIGATOR_AXIS:f,NAVIGATOR_PANE:h},m=3,g=i.Class.extend({init:function(e){var t,n,o;this.chart=e,t=this.options=r({},this.options,e.options.navigator),n=t.select,n&&(n.from=this.parseDate(n.from),n.to=this.parseDate(n.to)),i.defined(t.hint.visible)||(t.hint.visible=t.visible),this.chartObserver=new i.InstanceObserver(this,(o={},o[a.DRAG]="_drag",o[a.DRAG_END]="_dragEnd",o[a.ZOOM]="_zoom",o[a.ZOOM_END]="_zoomEnd",o)),e.addObserver(this.chartObserver)},parseDate:function(e){return i.parseDate(this.chart.chartService.intl,e)},destroy:function(){this.chart&&(this.chart.removeObserver(this.chartObserver),delete this.chart),this.selection&&(this.selection.destroy(),delete this.selection),this.hint&&(this.hint.destroy(),delete this.hint)},redraw:function(){this._redrawSelf(),this.initSelection()},initSelection:function(){var e=this,t=e.chart,o=e.options,r=this.mainAxis(),s=r.range(),a=s.min,l=s.max,c=o.select,d=c.from,h=c.to,f=c.mousewheel,p=n(r),m=r.options.categories,g=this.selection;0!==m.length&&(g&&g.destroy(),p.box=r.box,g=this.selection=new i.Selection(t,p,{min:a,max:l,from:d||a,to:h||l,mousewheel:i.valueOrDefault(f,{zoom:"left"}),visible:o.visible},new i.InstanceObserver(this,{selectStart:"_selectStart",select:"_select",selectEnd:"_selectEnd"})),this.hint&&this.hint.destroy(),o.hint.visible&&(this.hint=new u(t.element,t.chartService,{min:a,max:l,template:i.getTemplate(o.hint),format:o.hint.format})))},setRange:function(){var e,t=this.chart._createPlotArea(!0),n=t.namedCategoryAxes[f],i=n.range(),o=i.min,s=i.max,a=this.options.select||{},l=a.from||o;l<o&&(l=o),e=a.to||s,e>s&&(e=s),this.options.select=r({},a,{from:l,to:e}),this.filterAxes()},_redrawSelf:function(e){var t=this.chart._plotArea;t&&t.redraw(i.last(t.panes),e)},redrawSlaves:function(){var e=this.chart,t=e._plotArea,n=t.panes.slice(0,-1);t.srcSeries=e.options.series,t.options.categoryAxis=e.options.categoryAxis,t.redraw(n)},_drag:function(e){var t,n,o,r=this,a=r.chart,l=r.selection,c=a._eventCoordinates(e.originalEvent),d=this.mainAxis(),u=d.datesRange(),h=d.pane.box.containsPoint(c),f=a._plotArea.categoryAxis,p=e.axisRanges[f.options.name],m=this.options.select;p&&!h&&l&&(t=m.from&&m.to?s(m.to)-s(m.from):s(l.options.to)-s(l.options.from),n=i.toDate(i.limitValue(s(p.min),u.min,s(u.max)-t)),o=i.toDate(i.limitValue(s(n)+t,s(u.min)+t,u.max)),this.options.select={from:n,to:o},this.options.liveDrag&&(this.filterAxes(),this.redrawSlaves()),l.set(n,o),this.showHint(n,o))},_dragEnd:function(){this.filterAxes(),this.filter(),this.redrawSlaves(),this.hint&&this.hint.hide()},readSelection:function(){var e=this,t=e.selection.options,n=t.from,i=t.to,o=e.options.select;o.from=n,o.to=i},filterAxes:function(){var e,t,n,i,o,r,s=this,a=s.options.select;for(void 0===a&&(a={}),e=s.chart,t=e.options.categoryAxis,n=a.from,i=a.to,o=0;o<t.length;o++)r=t[o],r.pane!==h&&(r.min=n,r.max=i)},filter:function(){var e,t=this,n=t.chart,o=t.options.select;n.requiresHandlers(["navigatorFilter"])&&(e=new i.DateCategoryAxis(r({baseUnit:"fit"},n.options.categoryAxis[0],{categories:[o.from,o.to]}),n.chartService).options,this.chart.trigger("navigatorFilter",{from:i.addDuration(e.min,-e.baseUnitStep,e.baseUnit),to:i.addDuration(e.max,e.baseUnitStep,e.baseUnit)}))},_zoom:function(e){var t,n,o=this,r=o.chart._plotArea.categoryAxis,s=o.selection,a=o.options,l=a.select,c=a.liveDrag,d=this.mainAxis().options.categories,u=e.delta;s&&(t=i.lteDateIndex(s.options.from,d),n=i.lteDateIndex(s.options.to,d),e.originalEvent.preventDefault(),Math.abs(u)>1&&(u*=m),n-t>1?(s.expand(u),this.readSelection()):(r.options.min=l.from,l.from=r.scaleRange(-e.delta).min),c&&(this.filterAxes(),this.redrawSlaves()),s.set(l.from,l.to),this.showHint(this.options.select.from,this.options.select.to))},_zoomEnd:function(e){this._dragEnd(e)},showHint:function(e,t){var n=this.chart._plotArea;this.hint&&this.hint.show(e,t,n.backgroundBox())},_selectStart:function(e){return this.chart._selectStart(e)},_select:function(e){return this.showHint(e.from,e.to),this.chart._select(e)},_selectEnd:function(e){return this.hint&&this.hint.hide(),this.readSelection(),this.filterAxes(),this.filter(),this.redrawSlaves(),this.chart._selectEnd(e)},mainAxis:function(){var e=this.chart._plotArea;if(e)return e.namedCategoryAxes[f]},select:function(e,t){var n=this.options.select;return e&&t&&(n.from=this.parseDate(e),n.to=this.parseDate(t),this.filterAxes(),this.filter(),this.redrawSlaves(),this.selection.set(e,t)),{from:n.from,to:n.to}}}),g.setup=function(e,t){var n,i,o;void 0===e&&(e={}),void 0===t&&(t={}),e.__navi||(e.__navi=!0,n=r({},t.navigator,e.navigator),i=e.panes=[].concat(e.panes),o=r({},n.pane,{name:h}),n.visible||(o.visible=!1,o.height=.1),i.push(o),g.attachAxes(e,n),g.attachSeries(e,n,t))},g.attachAxes=function(e,t){var n=t.series||[],o=e.categoryAxis=[].concat(e.categoryAxis),s=e.valueAxis=[].concat(e.valueAxis),l=i.filterSeriesByType(n,a.EQUALLY_SPACED_SERIES),c=0===l.length,d=r({type:"date",pane:h,roundToBaseUnit:!c,justified:c,_collapse:!1,majorTicks:{visible:!0},tooltip:{visible:!1},labels:{step:1},autoBind:t.autoBindElements,autoBaseUnitSteps:{minutes:[1],hours:[1,2],days:[1,2],weeks:[],months:[1],years:[1]}}),u=t.categoryAxis;o.push(r({},d,{maxDateGroups:200},u,{name:f,title:null,baseUnit:"fit",baseUnitStep:"auto",labels:{visible:!1},majorTicks:{visible:!1}}),r({},d,u,{name:f+"_labels",maxDateGroups:20,baseUnitStep:"auto",plotBands:[],autoBaseUnitSteps:{minutes:[]},_overlap:!0}),r({},d,u,{name:f+"_ticks",maxDateGroups:200,majorTicks:{width:.5},plotBands:[],title:null,labels:{visible:!1,mirror:!0},_overlap:!0})),s.push(r({name:f,pane:h,majorGridLines:{visible:!1},visible:!1},t.valueAxis))},g.attachSeries=function(e,t,n){var i,o=e.series=e.series||[],s=[].concat(t.series||[]),a=n.seriesColors,l=t.seriesDefaults;for(i=0;i<s.length;i++)o.push(r({color:a[i%a.length],categoryField:t.dateField,visibleInLegend:!1,tooltip:{visible:!1}},l,s[i],{axis:f,categoryAxis:f,autoBind:t.autoBindElements}))},v=28,_=l.extend({applyDefaults:function(e,t){var n=i.elementSize(this.element).width||a.DEFAULT_WIDTH,o=t,s={seriesDefaults:{categoryField:e.dateField},axisDefaults:{categoryAxis:{name:"default",majorGridLines:{visible:!1},labels:{step:2},majorTicks:{visible:!1},maxDateGroups:Math.floor(n/v)}}};o&&(o=r({},o,s)),g.setup(e,o),l.fn.applyDefaults.call(this,e,o)},_setElementClass:function(e){i.addClass(e,"k-chart k-stockchart")},setOptions:function(e){this.destroyNavigator(),l.fn.setOptions.call(this,e)},_resize:function(){var e=this.options.transitions;this.options.transitions=!1,this._fullRedraw(),this.options.transitions=e},_redraw:function(){var e=this.navigator;!this._dirty()&&e&&e.options.partialRedraw?e.redrawSlaves():this._fullRedraw()},_dirty:function(){var e=this.options,t=[].concat(e.series,e.navigator.series),n=i.grep(t,function(e){return e&&e.visible}).length,o=this._seriesCount!==n;return this._seriesCount=n,o},_fullRedraw:function(){var e=this.navigator;e||(e=this.navigator=new g(this),this.trigger("navigatorCreated",{navigator:e})),e.setRange(),l.fn._redraw.call(this),e.initSelection()},_trackSharedTooltip:function(e){var t=this._plotArea,n=t.paneByPoint(e);n&&n.options.name===h?this._unsetActivePoint():l.fn._trackSharedTooltip.call(this,e)},bindCategories:function(){l.fn.bindCategories.call(this),this.copyNavigatorCategories()},copyNavigatorCategories:function(){var e,t,n,i=[].concat(this.options.categoryAxis);for(t=0;t<i.length;t++)n=i[t],n.name===f?e=n.categories:e&&n.pane===h&&(n.categories=e)},destroyNavigator:function(){this.navigator&&(this.navigator.destroy(),this.navigator=null)},destroy:function(){this.destroyNavigator(),l.fn.destroy.call(this)},_stopDragEvent:function(e){var t=this._eventCoordinates(e),n=this._plotArea.paneByPoint(t);return l.fn._stopDragEvent.call(this,e)||n&&n.options.name===h}}),i.setDefaultOptions(_,{dateField:"date",axisDefaults:{categoryAxis:{type:"date",baseUnit:"fit",justified:!0},valueAxis:{narrowRange:!0,labels:{format:"C"}}},navigator:{select:{},seriesDefaults:{markers:{visible:!1},tooltip:{visible:!0},line:{width:2}},hint:{},visible:!0},tooltip:{visible:!0},legend:{visible:!1}}),kendo.deepExtend(kendo.dataviz,{constants:p,Navigator:g,NavigatorHint:u,StockChart:_})}()},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/stock/stock-chart.min",["dataviz/stock/kendo-stock-chart.min"],e)}(function(){!function(e){function t(e,t){return[{field:"Date",operator:"gte",value:e},{field:"Date",operator:"lt",value:t}]}var n=window.kendo,i=n.dataviz,o=i.ChartInstanceObserver,r=i.ui.Chart,s=i.StockChart,a=i.constants,l=a.NAVIGATOR_AXIS,c=a.NAVIGATOR_PANE,d=n.deepExtend,u=i.defined,h=e.proxy,f="change",p=o.extend({handlerMap:{navigatorFilter:"_onNavigatorFilter",navigatorCreated:"_onNavigatorCreated"}}),m=r.extend({options:{name:"StockChart",dateField:"date",axisDefaults:{categoryAxis:{type:"date",baseUnit:"fit",justified:!0},valueAxis:{narrowRange:!0,labels:{format:"C"}}},navigator:{select:{},seriesDefaults:{markers:{visible:!1},tooltip:{visible:!0,template:"#= kendo.toString(category, 'd') #"},line:{width:2}},hint:{},visible:!0},tooltip:{visible:!0},legend:{visible:!1},persistSeriesVisibility:!0},_createChart:function(e,t){this._initNavigatorOptions(e),this._instance=new s(this.element[0],e,t,{observer:new p(this),sender:this,rtl:this._isRtl()})},_initNavigatorOptions:function(e){var t=e.navigator||{},i=n.support,o=i.touch,r=i.browser.mozilla;d(t,{autoBindElements:!t.dataSource,partialRedraw:t.dataSource,liveDrag:!o&&!r})},_initDataSource:function(e){var o,s,a,l,c=e||{},u=c.dataSource,h=u&&u.serverFiltering,f=[].concat(c.categoryAxis)[0],p=c.navigator||{},m=p.select,g=m&&m.from&&m.to;h&&g&&(o=[].concat(u.filter||[]),s=n.parseDate(m.from),a=n.parseDate(m.to),l=new i.DateCategoryAxis(d({baseUnit:"fit"},f,{categories:[s,a]}),n),u.filter=t(l.range().min,a).concat(o)),r.fn._initDataSource.call(this,e)},_onNavigatorCreated:function(e){this._instance=e.sender,this.options=e.sender.options,this._navigator=this.navigator=e.navigator,this._initNavigatorDataSource()},_initNavigatorDataSource:function(){var e=this.options.navigator,t=e.autoBind,i=e.dataSource;i&&(this._navigatorDataChangedHandler=this._navigatorDataChangedHandler||h(this._onNavigatorDataChanged,this),this._navigatorDataSource=n.data.DataSource.create(i).bind(f,this._navigatorDataChangedHandler),u(t)||(t=this.options.autoBind),t&&this._navigatorDataSource.fetch())},_bindNavigatorSeries:function(e,t){var n,i,o=e.length;for(n=0;n<o;n++)i=e[n],i.axis==l&&this._isBindable(i)&&(i.data=t)},_onNavigatorDataChanged:function(){var e,t,n,i,o=this,r=o._instance,s=o.options.categoryAxis,a=s.length,d=o._navigatorDataSource.view();for(this._bindNavigatorSeries(o.options.series,d),o._sourceSeries&&this._bindNavigatorSeries(o._sourceSeries,d),e=0;e<a;e++)t=s[e],t.pane==c&&(t.name==l?(o._bindCategoryAxis(t,d,e),n=t.categories):t.categories=n);r._model&&(i=this.navigator,i.redraw(),i.setRange(),(!o.options.dataSource||o.options.dataSource&&o._dataBound)&&i.redrawSlaves())},_bindCategories:function(){r.fn._bindCategories.call(this),this._instance&&this._instance.copyNavigatorCategories()},_onDataChanged:function(){r.fn._onDataChanged.call(this),this._dataBound=!0},setOptions:function(e){this._removeNavigatorDataSource(),this._initNavigatorOptions(e),this._instance.destroyNavigator(),r.fn.setOptions.call(this,e)},_onNavigatorFilter:function(e){this.dataSource.filter(t(e.from,e.to))},requiresHandlers:function(e){var t,n;return i.inArray("navigatorFilter",e)?(t=this.dataSource,n=t&&t.options.serverFiltering,n&&this.options.navigator.dataSource):r.fn.requiresHandlers.call(this,e)},_removeNavigatorDataSource:function(){var e=this._navigatorDataSource;e&&(e.unbind(f,this._navigatorDataChangedHandler),delete this._navigatorDataSource)},destroy:function(){r.fn.destroy.call(this),this._removeNavigatorDataSource()}});i.ui.plugin(m)}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.stock.min",["dataviz/stock/kendo-stock-chart.min","dataviz/stock/stock-chart.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/sparkline/kendo-sparkline.min",["kendo.dataviz.chart.min"],e)}(function(){!function(){function e(e){var t,n,i=[];for(t=0;t<e.length;t++)n=e[t],i[t]=n.style.display,n.style.display="none";return i}function t(e,t){for(var n=0;n<e.length;n++)e[n].style.display=t[n]}function n(e){return i.isNumber(e)?[e]:e}var i,o,r,s,a,l,c,d,u,h,f;window.kendo.dataviz=window.kendo.dataviz||{},i=kendo.dataviz,o=i.constants,r=i.Chart,s=i.elementSize,a=i.deepExtend,l=-2,c=i.SharedTooltip.extend({_slotAnchor:function(e,t){var n,o=this.plotArea.categoryAxis,r=o.options.vertical,s=r?{horizontal:"left",vertical:"center"}:{horizontal:"center",vertical:"bottom"};return n=r?new i.Point(this.plotArea.box.x2,t.center().y):new i.Point(t.center().x,l),{point:n,align:s}},_defaultAnchor:function(e,t){return this._slotAnchor({},t)}}),d=150,u=150,h=[o.BAR,o.BULLET],f=r.extend({_setElementClass:function(e){i.addClass(e,"k-sparkline")},_initElement:function(e){r.fn._initElement.call(this,e),this._initialWidth=Math.floor(s(e).width)},_resize:function(){var n=this.element,i=e(n.childNodes);this._initialWidth=Math.floor(s(n).width),t(n.childNodes,i),r.fn._resize.call(this)},_modelOptions:function(){var n,i=this.options,o=this._surfaceWrap(),r=e(o.childNodes),l=document.createElement("span");return l.innerHTML="&nbsp;",o.appendChild(l),n=a({width:this._autoWidth,height:s(o).height,transitions:i.transitions},i.chartArea,{inline:!0,align:!1}),s(o,{width:n.width,height:n.height}),o.removeChild(l),t(o.childNodes,r),this.surface.resize(),n},_surfaceWrap:function(){if(!this.stage){var e=this.stage=document.createElement("span");this.element.appendChild(e)}return this.stage},_createPlotArea:function(e){var t=r.fn._createPlotArea.call(this,e);return this._autoWidth=this._initialWidth||this._calculateWidth(t),t},_calculateWidth:function(e){var t,n,r,a,l,c,h=this.options,f=i.getSpacing(h.chartArea.margin),p=e.charts,m=this._surfaceWrap(),g=0;for(t=0;t<p.length;t++)if(n=p[t],r=(n.options.series||[])[0]){if(r.type===o.BAR)return d;if(r.type===o.BULLET)return u;if(r.type===o.PIE)return s(m).height;a=n.categoryAxis,a&&(l=a.options.categories.length*(!n.options.isStacked&&i.inArray(r.type,[o.COLUMN,o.VERTICAL_BULLET])?n.seriesOptions.length:1),g=Math.max(g,l))}return c=g*h.pointWidth,c>0&&(c+=f.left+f.right),c},_createSharedTooltip:function(e){return new c(this._plotArea,e)}}),f.normalizeOptions=function(e){var t=n(e);return t=i.isArray(t)?{seriesDefaults:{data:t}}:a({},t),t.series||(t.series=[{data:n(t.data)}]),a(t,{seriesDefaults:{type:t.type}}),(i.inArray(t.series[0].type,h)||i.inArray(t.seriesDefaults.type,h))&&(t=a({},{categoryAxis:{crosshair:{visible:!1}}},t)),t},i.setDefaultOptions(f,{chartArea:{margin:2},axisDefaults:{visible:!1,majorGridLines:{visible:!1},valueAxis:{narrowRange:!0}},seriesDefaults:{type:"line",area:{line:{width:.5}},bar:{stack:!0},padding:2,width:.5,overlay:{gradient:null},highlight:{visible:!1},border:{width:0},markers:{size:2,visible:!1}},tooltip:{visible:!0,shared:!0},categoryAxis:{crosshair:{visible:!0,tooltip:{visible:!1}}},legend:{visible:!1},transitions:!1,pointWidth:5,panes:[{clip:!1}]}),kendo.deepExtend(kendo.dataviz,{Sparkline:f})}()},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/sparkline/sparkline.min",["dataviz/sparkline/kendo-sparkline.min"],e)}(function(){!function(e){var t,n=kendo.dataviz,i=n.ui.Chart,o=n.Sparkline,r=n.ChartInstanceObserver,s=e.extend,a=i.extend({init:function(e,t){var n=t;n instanceof kendo.data.ObservableArray&&(n={seriesDefaults:{data:n}}),i.fn.init.call(this,e,o.normalizeOptions(n))},_createChart:function(e,t){this._instance=new o(this.element[0],e,t,{observer:new r(this),sender:this,rtl:this._isRtl()})},_createTooltip:function(){return new t(this.element,s({},this.options.tooltip,{rtl:this._isRtl()}))},options:{name:"Sparkline",chartArea:{margin:2},axisDefaults:{visible:!1,majorGridLines:{visible:!1},valueAxis:{narrowRange:!0}},seriesDefaults:{type:"line",area:{line:{width:.5}},bar:{stack:!0},padding:2,width:.5,overlay:{gradient:null},highlight:{visible:!1},border:{width:0},markers:{size:2,visible:!1}},tooltip:{visible:!0,shared:!0},categoryAxis:{crosshair:{visible:!0,tooltip:{visible:!1}}},legend:{visible:!1},transitions:!1,pointWidth:5,panes:[{clip:!1}]}});n.ui.plugin(a),t=n.Tooltip.extend({options:{animation:{duration:0}},_hideElement:function(){this.element&&this.element.hide().remove()}}),n.SparklineTooltip=t}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.sparkline.min",["dataviz/sparkline/kendo-sparkline.min","dataviz/sparkline/sparkline.min"],e)}(function(){},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/location.min",["kendo.drawing.min","util/main.min"],e)}(function(){!function(e,t){var n,i=Math,o=i.abs,r=i.atan,s=i.atan2,a=i.cos,l=i.max,c=i.min,d=i.sin,u=i.tan,h=window.kendo,f=h.Class,p=h.dataviz,m=h.deepExtend,g=h.drawing.util,v=g.defined,_=g.deg,b=g.rad,w=g.round,y=g.valueOrDefault,k=h.util.sqr,x=f.extend({init:function(e,t){1===arguments.length?(this.lat=e[0],this.lng=e[1]):(this.lat=e,this.lng=t)},DISTANCE_ITERATIONS:100,DISTANCE_CONVERGENCE:1e-12,DISTANCE_PRECISION:2,FORMAT:"{0:N6},{1:N6}",toArray:function(){return[this.lat,this.lng]},equals:function(e){return e&&e.lat===this.lat&&e.lng===this.lng},clone:function(){return new x(this.lat,this.lng)},round:function(e){return this.lng=w(this.lng,e),this.lat=w(this.lat,e),this},wrap:function(){return this.lng=this.lng%180,this.lat=this.lat%90,this},distanceTo:function(e,t){return this.greatCircleTo(e,t).distance},destination:function(e,t,n){var o,r,l,c,u;return t=b(t),n=n||p.map.datums.WGS84,o=b(this.lat),r=b(this.lng),l=e/h.dataviz.map.datums.WGS84.a,c=i.asin(d(o)*a(l)+a(o)*d(l)*a(t)),u=r+s(d(t)*d(l)*a(o),a(l)-d(o)*d(c)),new x(_(c),_(u))},greatCircleTo:function(e,t){var n,l,c,h,f,m,g,v,y,C,S,T,D,A,E,I,M,R,F,z,P,B,L,H,N,O,V,U,W;if(e=x.create(e),t=t||p.map.datums.WGS84,!e||this.clone().round(8).equals(e.clone().round(8)))return{distance:0,azimuthFrom:0,azimuthTo:0};for(n=t.a,l=t.b,c=t.f,h=b(e.lng-this.lng),f=r((1-c)*u(b(this.lat))),m=d(f),g=a(f),v=r((1-c)*u(b(e.lat))),y=d(v),C=a(v),S=h,D=this.DISTANCE_ITERATIONS,A=!1;!A&&D-- >0;)E=d(S),I=a(S),M=i.sqrt(k(C*E)+k(g*y-m*C*I)),F=m*y+g*C*I,P=s(M,F),B=g*C*E/M,R=1-k(B),z=0,0!==R&&(z=F-2*m*y/R),T=S,L=c/16*R*(4+c*(4-3*R)),S=h+(1-L)*c*B*(P+L*M*(z+L*F*(-1+2*k(z)))),A=o(S-T)<=this.DISTANCE_CONVERGENCE;return H=R*(k(n)-k(l))/k(l),N=1+H/16384*(4096+H*(-768+H*(320-175*H))),O=H/1024*(256+H*(-128+H*(74-47*H))),V=O*M*(z+O/4*(F*(-1+2*k(z))-O/6*z*(-3+4*k(M))*(-3+4*k(z)))),U=s(C*E,g*y-m*C*I),W=s(g*E,-m*C+g*y*I),{distance:w(l*N*(P-V),this.DISTANCE_PRECISION),azimuthFrom:_(U),azimuthTo:_(W)}}});x.fn.toString=function(){return h.format(this.FORMAT,this.lat,this.lng)},x.fromLngLat=function(e){return new x(e[1],e[0])},x.fromLatLng=function(e){return new x(e[0],e[1])},x.create=function(e,t){if(v(e))return e instanceof x?e.clone():1===arguments.length&&2===e.length?x.fromLatLng(e):new x(e,t)},n=f.extend({init:function(e,t){e=x.create(e),t=x.create(t),e.lng+180>t.lng+180&&e.lat+90<t.lat+90?(this.se=e,this.nw=t):(this.se=t,this.nw=e)},contains:function(e){var t=this.nw,n=this.se,i=y(e.lng,e[1]),o=y(e.lat,e[0]);return e&&i+180>=t.lng+180&&i+180<=n.lng+180&&o+90>=n.lat+90&&o+90<=t.lat+90},center:function(){var e=this.nw,t=this.se,n=e.lng+(t.lng-e.lng)/2,i=e.lat+(t.lat-e.lat)/2;return new x(i,n)},containsAny:function(e){var t,n=!1;for(t=0;t<e.length;t++)n=n||this.contains(e[t]);return n},include:function(e){var t=this.nw,n=this.se,i=y(e.lng,e[1]),o=y(e.lat,e[0]);t.lng=c(t.lng,i),t.lat=l(t.lat,o),n.lng=l(n.lng,i),n.lat=c(n.lat,o)},includeAll:function(e){for(var t=0;t<e.length;t++)this.include(e[t])},edges:function(){var e=this.nw,t=this.se;return{nw:this.nw,ne:new x(e.lat,t.lng),se:this.se,sw:new x(t.lat,e.lng)}},toArray:function(){var e=this.nw,t=this.se;return[e,new x(e.lat,t.lng),t,new x(t.lat,e.lng)]},overlaps:function(e){return this.containsAny(e.toArray())||e.containsAny(this.toArray())}}),n.World=new n([90,-180],[-90,180]),n.create=function(e,i){return e instanceof n?e:e&&i?new n(e,i):e&&4===e.length&&!i?new n([e[0],e[1]],[e[2],e[3]]):t},m(p,{map:{Extent:n,Location:x}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/attribution.min",["kendo.drawing.min"],e)}(function(){!function(){var e=window.kendo,t=e.ui.Widget,n=e.template,i=e.drawing.util,o=i.valueOrDefault,r=i.defined,s=t.extend({init:function(e,n){t.fn.init.call(this,e,n),this._initOptions(n),this.items=[],this.element.addClass("k-widget k-attribution")},options:{name:"Attribution",separator:"&nbsp;|&nbsp;",itemTemplate:"#= text #"},filter:function(e,t){this._extent=e,this._zoom=t,this._render()},add:function(e){r(e)&&("string"==typeof e&&(e={text:e}),this.items.push(e),this._render())},remove:function(e){var t,n,i=[];for(t=0;t<this.items.length;t++)n=this.items[t],n.text!==e&&i.push(n);this.items=i,this._render()},clear:function(){this.items=[],this.element.empty()},_render:function(){var e,t,i,o=[],r=n(this.options.itemTemplate);for(e=0;e<this.items.length;e++)t=this.items[e],i=this._itemText(t),""!==i&&o.push(r({text:i}));o.length>0?this.element.empty().append(o.join(this.options.separator)).show():this.element.hide()},_itemText:function(e){var t="",n=this._inZoomLevel(e.minZoom,e.maxZoom),i=this._inArea(e.extent);return n&&i&&(t+=e.text),t},_inZoomLevel:function(e,t){var n=!0;return e=o(e,-Number.MAX_VALUE),t=o(t,Number.MAX_VALUE),n=this._zoom>e&&this._zoom<t},_inArea:function(e){var t=!0;return e&&(t=e.contains(this._extent)),t}});e.dataviz.ui.plugin(s)}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/navigator.min",["kendo.core.min"],e)}(function(){!function(e){function t(e){return n.format('<button class="k-button k-navigator-{0}" aria-label="move {0}"><span class="k-icon k-i-arrow-60-{0}"/></button>',e)}var n=window.kendo,i=n.ui.Widget,o=n.keys,r=e.proxy,s=".kendoNavigator",a=t("up")+t("right")+t("down")+t("left"),l=i.extend({init:function(e,t){i.fn.init.call(this,e,t),this._initOptions(t),this.element.addClass("k-widget k-header k-shadow k-navigator").append(a).on("click"+s,".k-button",r(this,"_click"));
var o=this.element.parent().closest("["+n.attr("role")+"]");this._keyroot=o.length>0?o:this.element,this._tabindex(this._keyroot),this._keydown=r(this._keydown,this),this._keyroot.on("keydown",this._keydown)},options:{name:"Navigator",panStep:1},events:["pan"],dispose:function(){this._keyroot.off("keydown",this._keydown)},_pan:function(e,t){var n=this.options.panStep;this.trigger("pan",{x:e*n,y:t*n})},_click:function(t){var n=0,i=0,o=e(t.currentTarget);o.is(".k-navigator-up")?i=1:o.is(".k-navigator-down")?i=-1:o.is(".k-navigator-right")?n=1:o.is(".k-navigator-left")&&(n=-1),this._pan(n,i),t.preventDefault()},_keydown:function(e){switch(e.which){case o.UP:this._pan(0,1),e.preventDefault();break;case o.DOWN:this._pan(0,-1),e.preventDefault();break;case o.RIGHT:this._pan(1,0),e.preventDefault();break;case o.LEFT:this._pan(-1,0),e.preventDefault()}}});n.dataviz.ui.plugin(l)}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/zoom.min",["kendo.core.min"],e)}(function(){!function(e){function t(e,t){return n.format('<button class="k-button k-zoom-{0}" title="zoom-{0}" aria-label="zoom-{0}"><span class="k-icon {1}"></span></button>',e,t)}var n=window.kendo,i=n.ui.Widget,o=n.keys,r=e.proxy,s=".kendoZoomControl",a=t("in","k-i-plus")+t("out","k-i-minus"),l=187,c=189,d=61,u=173,h=i.extend({init:function(e,t){i.fn.init.call(this,e,t),this._initOptions(t),this.element.addClass("k-widget k-zoom-control k-button-wrap k-buttons-horizontal k-button-group k-group-horizontal").append(a).on("click"+s,".k-button",r(this,"_click"));var o=this.element.parent().closest("["+n.attr("role")+"]");this._keyroot=o.length>0?o:this.element,this._tabindex(this._keyroot),this._keydown=r(this._keydown,this),this._keyroot.on("keydown",this._keydown)},options:{name:"ZoomControl",zoomStep:1},events:["change"],_change:function(e){var t=this.options.zoomStep;this.trigger("change",{delta:e*t})},_click:function(t){var n=e(t.currentTarget),i=1;n.is(".k-zoom-out")&&(i=-1),this._change(i),t.preventDefault()},_keydown:function(e){switch(e.which){case o.NUMPAD_PLUS:case l:case d:this._change(1);break;case o.NUMPAD_MINUS:case c:case u:this._change(-1)}}});n.dataviz.ui.plugin(h)}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/crs.min",["dataviz/map/location.min","kendo.drawing.min"],e)}(function(){!function(e,t){var n=Math,i=n.atan,o=n.exp,r=n.pow,s=n.sin,a=n.log,l=n.tan,c=window.kendo,d=c.Class,u=c.dataviz,h=c.deepExtend,f=c.geometry,p=f.Point,m=u.map,g=m.Location,v=c.drawing.util,_=v.rad,b=v.deg,w=v.limitValue,y=n.PI,k=y/2,x=y/4,C=y/180,S={a:6378137,b:6356752.314245179,f:.0033528106647474805,e:.08181919084262149},T=d.extend({init:function(e){this._initOptions(e)},MAX_LNG:180,MAX_LAT:85.0840590501,INVERSE_ITERATIONS:15,INVERSE_CONVERGENCE:1e-12,options:{centralMeridian:0,datum:S},forward:function(e,t){var n=this,i=n.options,o=i.datum,r=o.a,s=i.centralMeridian,a=w(e.lat,-n.MAX_LAT,n.MAX_LAT),l=t?w(e.lng,-n.MAX_LNG,n.MAX_LNG):e.lng,c=_(l-s)*r,d=n._projectLat(a);return new p(c,d)},_projectLat:function(e){var t=this.options.datum,n=t.e,i=t.a,o=_(e),c=l(x+o/2),d=n*s(o),u=r((1-d)/(1+d),n/2);return i*a(c*u)},inverse:function(e,t){var n=this,i=n.options,o=i.datum,r=o.a,s=i.centralMeridian,a=e.x/(C*r)+s,l=w(n._inverseY(e.y),-n.MAX_LAT,n.MAX_LAT);return t&&(a=w(a,-n.MAX_LNG,n.MAX_LNG)),new g(l,a)},_inverseY:function(e){var t,a,l,c,d=this,u=d.options.datum,h=u.a,f=u.e,p=f/2,m=o(-e/h),g=k-2*i(m);for(t=0;t<=d.INVERSE_ITERATIONS&&(a=f*s(g),l=r((1-a)/(1+a),p),c=k-2*i(m*l)-g,g+=c,!(n.abs(c)<=d.INVERSE_CONVERGENCE));t++);return b(g)}}),D=T.extend({MAX_LAT:85.0511287798,_projectLat:function(e){var t=this.options.datum.a,n=_(e),i=l(x+n/2);return t*a(i)},_inverseY:function(e){var t=this.options.datum.a,n=o(-e/t);return b(k-2*i(n))}}),A=d.extend({forward:function(e){return new p(e.lng,e.lat)},inverse:function(e){return new g(e.y,e.x)}}),E=d.extend({init:function(){var e=this,t=e._proj=new D,n=this.c=2*y*t.options.datum.a;this._tm=f.transform().translate(.5,.5).scale(1/n,-1/n),this._itm=f.transform().scale(n,-n).translate(-.5,-.5)},toPoint:function(e,t,n){var i=this._proj.forward(e,n);return i.transform(this._tm).scale(t||1)},toLocation:function(e,t,n){return e=e.clone().scale(1/(t||1)).transform(this._itm),this._proj.inverse(e,n)}}),I=d.extend({init:function(){this._proj=new T},toPoint:function(e){return this._proj.forward(e)},toLocation:function(e){return this._proj.inverse(e)}}),M=d.extend({init:function(){this._proj=new A},toPoint:function(e){return this._proj.forward(e)},toLocation:function(e){return this._proj.inverse(e)}});h(u,{map:{crs:{EPSG3395:I,EPSG3857:E,EPSG4326:M},datums:{WGS84:S},projections:{Equirectangular:A,Mercator:T,SphericalMercator:D}}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/layers/base.min",["kendo.core.min","dataviz/map/location.min"],e)}(function(){!function(e,t){var n=e.proxy,i=window.kendo,o=i.Class,r=i.dataviz,s=i.deepExtend,a=r.map.Extent,l=i.drawing.util,c=l.defined,d=o.extend({init:function(t,i){this._initOptions(i),this.map=t,this.element=e("<div class='k-layer'></div>").css({zIndex:this.options.zIndex,opacity:this.options.opacity}).appendTo(t.scrollElement),this._beforeReset=n(this._beforeReset,this),this._reset=n(this._reset,this),this._resize=n(this._resize,this),this._panEnd=n(this._panEnd,this),this._activate(),this._updateAttribution()},destroy:function(){this._deactivate()},show:function(){this.reset(),this._activate(),this._applyExtent(!0)},hide:function(){this._deactivate(),this._setVisibility(!1)},reset:function(){this._beforeReset(),this._reset()},_reset:function(){this._applyExtent()},_beforeReset:e.noop,_resize:e.noop,_panEnd:function(){this._applyExtent()},_applyExtent:function(){var e=this.options,t=this.map.zoom(),n=!c(e.minZoom)||t>=e.minZoom,i=!c(e.maxZoom)||t<=e.maxZoom,o=a.create(e.extent),r=!o||o.overlaps(this.map.extent());this._setVisibility(n&&i&&r)},_setVisibility:function(e){this.element.css("display",e?"":"none")},_activate:function(){var e=this.map;e.bind("beforeReset",this._beforeReset),e.bind("reset",this._reset),e.bind("resize",this._resize),e.bind("panEnd",this._panEnd)},_deactivate:function(){var e=this.map;e.unbind("beforeReset",this._beforeReset),e.unbind("reset",this._reset),e.unbind("resize",this._resize),e.unbind("panEnd",this._panEnd)},_updateAttribution:function(){var e=this.map.attribution;e&&e.add(this.options.attribution)}});s(r,{map:{layers:{Layer:d}}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/layers/shape.min",["dataviz/map/layers/base.min","dataviz/map/location.min"],e)}(function(){!function(e,t){var n=e.proxy,i=window.kendo,o=i.Class,r=i.data.DataSource,s=i.dataviz,a=i.deepExtend,l=i.geometry,c=i.drawing,d=c.Group,u=c.util.last,h=c.util.defined,f=s.map,p=f.Location,m=f.layers.Layer,g=m.extend({init:function(e,t){this._pan=n(this._pan,this),m.fn.init.call(this,e,t),this.surface=c.Surface.create(this.element,{width:e.scrollElement.width(),height:e.scrollElement.height()}),this._initRoot(),this.movable=new i.ui.Movable(this.surface.element),this._markers=[],this._click=this._handler("shapeClick"),this.surface.bind("click",this._click),this._mouseenter=this._handler("shapeMouseEnter"),this.surface.bind("mouseenter",this._mouseenter),this._mouseleave=this._handler("shapeMouseLeave"),this.surface.bind("mouseleave",this._mouseleave),this._initDataSource()},options:{autoBind:!0},destroy:function(){m.fn.destroy.call(this),this.surface.destroy(),this.dataSource.unbind("change",this._dataChange)},setDataSource:function(e){this.dataSource&&this.dataSource.unbind("change",this._dataChange),this.dataSource=i.data.DataSource.create(e),this.dataSource.bind("change",this._dataChange),this.options.autoBind&&this.dataSource.fetch()},_reset:function(){m.fn._reset.call(this),this._translateSurface(),this._data&&this._load(this._data)},_initRoot:function(){this._root=new d,this.surface.draw(this._root)},_beforeReset:function(){this.surface.clear(),this._initRoot()},_resize:function(){this.surface.size(this.map.size())},_initDataSource:function(){var e=this.options.dataSource;this._dataChange=n(this._dataChange,this),this.dataSource=r.create(e).bind("change",this._dataChange),e&&this.options.autoBind&&this.dataSource.fetch()},_dataChange:function(e){this._data=e.sender.view(),this._load(this._data)},_load:function(e){var t,n,i;for(this._clearMarkers(),this._loader||(this._loader=new v(this.map,this.options.style,this)),t=new d,n=0;n<e.length;n++)i=this._loader.parse(e[n]),i&&t.append(i);this._root.clear(),this._root.append(t)},shapeCreated:function(e){var t,n=!1;return e instanceof c.Circle&&(n=h(this._createMarker(e))),n||(t={layer:this,shape:e},n=this.map.trigger("shapeCreated",t)),n},featureCreated:function(e){e.layer=this,this.map.trigger("shapeFeatureCreated",e)},_createMarker:function(e){var t=this.map.markers.bind({location:e.location},e.dataItem);return t&&this._markers.push(t),t},_clearMarkers:function(){for(var e=0;e<this._markers.length;e++)this.map.markers.remove(this._markers[e]);this._markers=[]},_pan:function(){this._panning||(this._panning=!0,this.surface.suspendTracking())},_panEnd:function(e){m.fn._panEnd.call(this,e),this._translateSurface(),this.surface.resumeTracking(),this._panning=!1},_translateSurface:function(){var e=this.map,t=e.locationToView(e.extent().nw);this.surface.translate&&(this.surface.translate(t),this.movable.moveTo({x:t.x,y:t.y}))},_handler:function(e){var t=this;return function(n){if(n.element){var i={layer:t,shape:n.element,originalEvent:n.originalEvent};t.map.trigger(e,i)}}},_activate:function(){m.fn._activate.call(this),this.map.bind("pan",this._pan)},_deactivate:function(){m.fn._deactivate.call(this),this.map.unbind("pan",this._pan)}}),v=o.extend({init:function(e,t,n){this.observer=n,this.locator=e,this.style=t},parse:function(e){var t=new d,n=!0;return"Feature"===e.type?(n=!1,this._loadGeometryTo(t,e.geometry,e),this._featureCreated(t,e)):this._loadGeometryTo(t,e,e),n&&t.children.length<2&&(t=t.children[0]),t},_shapeCreated:function(e){var t=!1;return this.observer&&this.observer.shapeCreated&&(t=this.observer.shapeCreated(e)),t},_featureCreated:function(e,t){this.observer&&this.observer.featureCreated&&this.observer.featureCreated({group:e,dataItem:t,properties:t.properties})},_loadGeometryTo:function(e,t,n){var i,o,r=t.coordinates;switch(t.type){case"LineString":o=this._loadPolygon(e,[r],n),this._setLineFill(o);break;case"MultiLineString":for(i=0;i<r.length;i++)o=this._loadPolygon(e,[r[i]],n),this._setLineFill(o);break;case"Polygon":this._loadPolygon(e,r,n);break;case"MultiPolygon":for(i=0;i<r.length;i++)this._loadPolygon(e,r[i],n);break;case"Point":this._loadPoint(e,r,n);break;case"MultiPoint":for(i=0;i<r.length;i++)this._loadPoint(e,r[i],n)}},_setLineFill:function(e){var t=e.segments;(t.length<4||!t[0].anchor().equals(u(t).anchor()))&&(e.options.fill=null)},_loadShape:function(e,t){return this._shapeCreated(t)||e.append(t),t},_loadPolygon:function(e,t,n){var i=this._buildPolygon(t);return i.dataItem=n,this._loadShape(e,i)},_buildPolygon:function(e){var t,n,i,o=e.length>1?c.MultiPath:c.Path,r=new o(this.style);for(t=0;t<e.length;t++)for(n=0;n<e[t].length;n++)i=this.locator.locationToView(p.fromLngLat(e[t][n])),0===n?r.moveTo(i.x,i.y):r.lineTo(i.x,i.y);return r},_loadPoint:function(e,t,n){var i=p.fromLngLat(t),o=this.locator.locationToView(i),r=new l.Circle(o,10),s=new c.Circle(r,this.style);return s.dataItem=n,s.location=i,this._loadShape(e,s)}});a(i.data,{schemas:{geojson:{type:"json",data:function(e){return"FeatureCollection"===e.type?e.features:"GeometryCollection"===e.type?e.geometries:e}}},transports:{geojson:{read:{dataType:"json"}}}}),a(s,{map:{layers:{shape:g,ShapeLayer:g},GeoJSONLoader:v}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/layers/bubble.min",["dataviz/map/layers/shape.min"],e)}(function(){!function(e,t){var n=window.kendo,i=n.getter,o=n.dataviz,r=n.deepExtend,s=n.geometry,a=n.drawing,l=a.util,c=l.defined,d=o.map,u=d.Location,h=d.layers.ShapeLayer,f=h.extend({options:{autoBind:!0,locationField:"location",valueField:"value",minSize:0,maxSize:100,scale:"sqrt",symbol:"circle"},_load:function(e){var t,n,o,r,s,a,l,d,h,f,p;if(this.surface.clear(),0!==e.length)for(t=this.options,n=i(t.valueField),e=e.slice(0),e.sort(function(e,t){return n(t)-n(e)}),o=this._scaleType(),s=0;s<e.length;s++)a=e[s],l=i(t.locationField)(a),d=i(t.valueField)(a),c(l)&&c(d)&&(r||(r=new o([0,d],[t.minSize,t.maxSize])),l=u.create(l),h=this.map.locationToView(l),f=r.map(d),p=this._createSymbol({center:h,size:f,style:t.style,dataItem:a,location:l}),p.dataItem=a,p.location=l,p.value=d,this._drawSymbol(p))},_scaleType:function(){var e=this.options.scale;return n.isFunction(e)?e:o.map.scales[e]},_createSymbol:function(e){var t=this.options.symbol;return n.isFunction(t)||(t=o.map.symbols[t]),t(e)},_drawSymbol:function(e){var t={layer:this,shape:e},n=this.map.trigger("shapeCreated",t);n||this.surface.draw(e)}}),p=n.Class.extend({init:function(e,t){var n,i;this._domain=e,this._range=t,n=Math.sqrt(e[1])-Math.sqrt(e[0]),i=t[1]-t[0],this._ratio=i/n},map:function(e){var t=(Math.sqrt(e)-Math.sqrt(this._domain[0]))*this._ratio;return this._range[0]+t}}),m={circle:function(e){var t=new s.Circle(e.center,e.size/2);return new a.Circle(t,e.style)},square:function(e){var t=new a.Path(e.style),n=e.size/2,i=e.center;return t.moveTo(i.x-n,i.y-n).lineTo(i.x+n,i.y-n).lineTo(i.x+n,i.y+n).lineTo(i.x-n,i.y+n).close(),t}};r(o,{map:{layers:{bubble:f,BubbleLayer:f},scales:{sqrt:p},symbols:m}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/layers/tile.min",["dataviz/map/layers/base.min","dataviz/map/location.min"],e)}(function(){!function(e,t){function n(e){return new u(g(e.x),g(e.y))}var i=Math,o=e.proxy,r=window.kendo,s=r.Class,a=r.template,l=r.dataviz,c=r.deepExtend,d=r.geometry,u=d.Point,h=l.map.layers.Layer,f=r.util,p=f.renderSize,m=r.drawing.util,g=m.round,v=m.limitValue,_=h.extend({init:function(e,t){h.fn.init.call(this,e,t),"string"==typeof this.options.subdomains&&(this.options.subdomains=this.options.subdomains.split(""));var n=this._viewType();this._view=new n(this.element,this.options)},destroy:function(){h.fn.destroy.call(this),this._view.destroy(),this._view=null},_beforeReset:function(){var e=this.map,t=e.locationToLayer(e.extent().nw).round();this._view.viewOrigin(t)},_reset:function(){h.fn._reset.call(this),this._updateView(),this._view.reset()},_viewType:function(){return b},_activate:function(){h.fn._activate.call(this),r.support.mobileOS||(this._pan||(this._pan=r.throttle(o(this._render,this),100)),this.map.bind("pan",this._pan))},_deactivate:function(){h.fn._deactivate.call(this),this._pan&&this.map.unbind("pan",this._pan)},_updateView:function(){var e=this._view,t=this.map,n=t.extent(),i={nw:t.locationToLayer(n.nw).round(),se:t.locationToLayer(n.se).round()};e.center(t.locationToLayer(t.center())),e.extent(i),e.zoom(t.zoom())},_resize:function(){this._render()},_panEnd:function(e){h.fn._panEnd.call(this,e),this._render()},_render:function(){this._updateView(),this._view.render()}}),b=s.extend({init:function(e,t){this.element=e,this._initOptions(t),this.pool=new y},options:{tileSize:256,subdomains:["a","b","c"],urlTemplate:""},center:function(e){this._center=e},extent:function(e){this._extent=e},viewOrigin:function(e){this._viewOrigin=e},zoom:function(e){this._zoom=e},pointToTileIndex:function(e){return new u(i.floor(e.x/this.options.tileSize),i.floor(e.y/this.options.tileSize))},tileCount:function(){var e=this.size(),t=this.pointToTileIndex(this._extent.nw),n=this._extent.nw,o=this.indexToPoint(t).translate(-n.x,-n.y);return{x:i.ceil((i.abs(o.x)+e.width)/this.options.tileSize),y:i.ceil((i.abs(o.y)+e.height)/this.options.tileSize)}},size:function(){var e=this._extent.nw,t=this._extent.se,n=t.clone().translate(-e.x,-e.y);return{width:n.x,height:n.y}},indexToPoint:function(e){var t=e.x,n=e.y;return new u(t*this.options.tileSize,n*this.options.tileSize)},subdomainText:function(){var e=this.options.subdomains;return e[this.subdomainIndex++%e.length]},destroy:function(){this.element.empty(),this.pool.empty()},reset:function(){this.pool.reset(),this.subdomainIndex=0,this.render()},render:function(){var e,t,n,i=this.tileCount(),o=this.pointToTileIndex(this._extent.nw);for(t=0;t<i.x;t++)for(n=0;n<i.y;n++)e=this.createTile({x:o.x+t,y:o.y+n}),e.visible||e.show()},createTile:function(e){var t=this.tileOptions(e),n=this.pool.get(this._center,t);return 0===n.element.parent().length&&this.element.append(n.element),n},tileOptions:function(e){var t=this.wrapIndex(e),i=this.indexToPoint(e),o=this._viewOrigin,r=i.clone().translate(-o.x,-o.y);return{index:t,currentIndex:e,point:i,offset:n(r),zoom:this._zoom,size:this.options.tileSize,subdomain:this.subdomainText(),urlTemplate:this.options.urlTemplate,errorUrlTemplate:this.options.errorUrlTemplate}},wrapIndex:function(e){var t=i.pow(2,this._zoom);return{x:this.wrapValue(e.x,t),y:v(e.y,0,t-1)}},wrapValue:function(e,t){var n=i.abs(e)%t;return e=e>=0?n:t-(0===n?t:n)}}),w=s.extend({init:function(e,t){this.id=e,this.visible=!0,this._initOptions(t),this.createElement(),this.show()},options:{urlTemplate:"",errorUrlTemplate:""},createElement:function(){this.element=e("<img style='position: absolute; display: block;' alt='' />").css({width:this.options.size,height:this.options.size}).on("error",o(function(e){this.errorUrl()?e.target.setAttribute("src",this.errorUrl()):e.target.removeAttribute("src")},this))},show:function(){var e,t=this.element[0];t.style.top=p(this.options.offset.y),t.style.left=p(this.options.offset.x),e=this.url(),e&&t.setAttribute("src",e),t.style.visibility="visible",this.visible=!0},hide:function(){this.element[0].style.visibility="hidden",this.visible=!1},url:function(){var e=a(this.options.urlTemplate);return e(this.urlOptions())},errorUrl:function(){var e=a(this.options.errorUrlTemplate);return e(this.urlOptions())},urlOptions:function(){var e=this.options;return{zoom:e.zoom,subdomain:e.subdomain,z:e.zoom,x:e.index.x,y:e.index.y,s:e.subdomain,quadkey:e.quadkey,q:e.quadkey,culture:e.culture,c:e.culture}},destroy:function(){this.element&&(this.element.remove(),this.element=null)}}),y=s.extend({init:function(){this._items=[]},options:{maxSize:100},get:function(e,t){return this._items.length>=this.options.maxSize&&this._remove(e),this._create(t)},empty:function(){var e,t=this._items;for(e=0;e<t.length;e++)t[e].destroy();this._items=[]},reset:function(){var e,t=this._items;for(e=0;e<t.length;e++)t[e].hide()},_create:function(e){var t,n,i=this._items,o=f.hashKey(""+e.point+(""+e.offset)+e.zoom+e.urlTemplate);for(n=0;n<i.length;n++)if(i[n].id===o){t=i[n];break}return t?t.show():(t=new w(o,e),this._items.push(t)),t},_remove:function(e){var t,n,i=this._items,o=-1,r=-1;for(t=0;t<i.length;t++)n=i[t].options.point.distanceTo(e),n>o&&!i[t].visible&&(r=t,o=n);r!==-1&&(i[r].destroy(),i.splice(r,1))}});c(l,{map:{layers:{tile:_,TileLayer:_,ImageTile:w,TilePool:y,TileView:b}}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/layers/bing.min",["dataviz/map/layers/tile.min"],e)}(function(){!function(e,t){var n=window.kendo,i=n.dataviz,o=n.deepExtend,r=n.drawing.util.defined,s=i.map.Extent,a=i.map.Location,l=i.map.layers.TileLayer,c=i.map.layers.TileView,d=l.extend({init:function(t,n){this.options.baseUrl=this._scheme()+"://dev.virtualearth.net/REST/v1/Imagery/Metadata/",l.fn.init.call(this,t,n),this._onMetadata=e.proxy(this._onMetadata,this),this._fetchMetadata()},options:{imagerySet:"road"},_fetchMetadata:function(){var t=this.options;if(!t.key)throw Error("Bing tile layer: API key is required");e.ajax({url:t.baseUrl+t.imagerySet,data:{output:"json",include:"ImageryProviders",key:t.key,uriScheme:this._scheme()},type:"get",dataType:"jsonp",jsonp:"jsonp",success:this._onMetadata})},_scheme:function(e){return e=e||window.location.protocol,"https"===e.replace(":","")?"https":"http"},_onMetadata:function(e){var t,n;e&&e.resourceSets.length&&(t=this.resource=e.resourceSets[0].resources[0],o(this._view.options,{urlTemplate:t.imageUrl.replace("{subdomain}","#= subdomain #").replace("{quadkey}","#= quadkey #").replace("{culture}","#= culture #"),subdomains:t.imageUrlSubdomains}),n=this.options,r(n.minZoom)||(n.minZoom=t.zoomMin),r(n.maxZoom)||(n.maxZoom=t.zoomMax),this._addAttribution(),"none"!==this.element.css("display")&&this._reset())},_viewType:function(){return u},_addAttribution:function(){var e,t,n,i,o,r=this.map.attribution;if(r&&(e=this.resource.imageryProviders))for(t=0;t<e.length;t++)for(n=e[t],i=0;i<n.coverageAreas.length;i++)o=n.coverageAreas[i],r.add({text:n.attribution,minZoom:o.zoomMin,maxZoom:o.zoomMax,extent:new s(new a(o.bbox[2],o.bbox[1]),new a(o.bbox[0],o.bbox[3]))})},imagerySet:function(e){return e?(this.options.imagerySet=e,this.map.attribution.clear(),this._fetchMetadata(),t):this.options.imagerySet}}),u=c.extend({options:{culture:"en-US"},tileOptions:function(e){var t=c.fn.tileOptions.call(this,e);return t.culture=this.options.culture,t.quadkey=this.tileQuadKey(this.wrapIndex(e)),t},tileQuadKey:function(e){var t,n,i,o="";for(i=this._zoom;i>0;i--)t=0,n=1<<i-1,0!==(e.x&n)&&t++,0!==(e.y&n)&&(t+=2),o+=t;return o}});o(i,{map:{layers:{bing:d,BingLayer:d,BingView:u}}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/layers/marker.min",["dataviz/map/layers/base.min","dataviz/map/location.min","kendo.data.min","kendo.tooltip.min"],e)}(function(){!function(e,t){var n=document,i=Math,o=e.inArray,r=e.proxy,s=window.kendo,a=s.Class,l=s.data.DataSource,c=s.ui.Tooltip,d=s.dataviz,u=s.deepExtend,h=d.map,f=h.Location,p=h.layers.Layer,m=p.extend({init:function(e,t){p.fn.init.call(this,e,t),this._markerClick=r(this._markerClick,this),this.element.on("click",".k-marker",this._markerClick),this.items=[],this._initDataSource()},destroy:function(){p.fn.destroy.call(this),this.element.off("click",".k-marker",this._markerClick),this.dataSource.unbind("change",this._dataChange),this.clear()},options:{zIndex:1e3,autoBind:!0,dataSource:{},locationField:"location",titleField:"title"},add:function(t){if(!e.isArray(t))return this._addOne(t);for(var n=0;n<t.length;n++)this._addOne(t[n])},remove:function(e){e.destroy();var t=o(e,this.items);t>-1&&this.items.splice(t,1)},clear:function(){for(var e=0;e<this.items.length;e++)this.items[e].destroy();this.items=[]},update:function(e){var t,n=e.location();n&&(e.showAt(this.map.locationToView(n)),t={marker:e,layer:this},this.map.trigger("markerActivate",t))},_reset:function(){var e,t;for(p.fn._reset.call(this),e=this.items,t=0;t<e.length;t++)this.update(e[t])},bind:function(e,t){var n,i,o=h.Marker.create(e,this.options);if(o.dataItem=t,n={marker:o,layer:this},i=this.map.trigger("markerCreated",n),!i)return this.add(o),o},setDataSource:function(e){this.dataSource&&this.dataSource.unbind("change",this._dataChange),this.dataSource=s.data.DataSource.create(e),this.dataSource.bind("change",this._dataChange),this.options.autoBind&&this.dataSource.fetch()},_addOne:function(e){var t=g.create(e,this.options);return t.addTo(this),t},_initDataSource:function(){var e=this.options.dataSource;this._dataChange=r(this._dataChange,this),this.dataSource=l.create(e).bind("change",this._dataChange),e&&this.options.autoBind&&this.dataSource.fetch()},_dataChange:function(e){this._load(e.sender.view())},_load:function(e){var t,n,i,o;for(this._data=e,this.clear(),t=s.getter(this.options.locationField),n=s.getter(this.options.titleField),i=0;i<e.length;i++)o=e[i],this.bind({location:t(o),title:n(o)},o)},_markerClick:function(t){var n={marker:e(t.target).data("kendoMarker"),layer:this};this.map.trigger("markerClick",n)}}),g=a.extend({init:function(e){this.options=e||{}},addTo:function(e){this.layer=e.markers||e,this.layer.items.push(this),this.layer.update(this)},location:function(e){return e?(this.options.location=f.create(e).toArray(),this.layer&&this.layer.update(this),this):f.create(this.options.location)},showAt:function(e){this.render(),this.element.css({left:i.round(e.x),top:i.round(e.y)}),this.tooltip&&this.tooltip.popup&&this.tooltip.popup._position()},hide:function(){this.element&&(this.element.remove(),this.element=null),this.tooltip&&(this.tooltip.destroy(),this.tooltip=null)},destroy:function(){this.layer=null,this.hide()},render:function(){var t,i;this.element||(t=this.options,i=this.layer,this.element=e(n.createElement("span")).addClass("k-marker k-icon k-i-marker-"+s.toHyphens(t.shape||"pin")).attr("title",t.title).attr(t.attributes||{}).data("kendoMarker",this).css("zIndex",t.zIndex),i&&i.element.append(this.element),this.renderTooltip())},renderTooltip:function(){var e,t,n=this,i=n.options.title,o=n.options.tooltip||{};o&&c&&(e=o.template,e&&(t=s.template(e),o.content=function(e){return e.location=n.location(),e.marker=n,t(e)}),(i||o.content||o.contentUrl)&&(this.tooltip=new c(this.element,o),this.tooltip.marker=this))}});g.create=function(e,t){return e instanceof g?e:new g(u({},t,e))},u(d,{map:{layers:{marker:m,MarkerLayer:m},Marker:g}})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/map/main.min",["dataviz/map/crs.min","dataviz/map/location.min"],e)}(function(){!function(e,t){var n=document,i=Math,o=i.min,r=i.pow,s=e.proxy,a=window.kendo,l=a.ui.Widget,c=a.deepExtend,d=a.dataviz,u=d.ui,h=a.geometry,f=h.Point,p=d.map,m=p.Extent,g=p.Location,v=p.crs.EPSG3857,_=a.util,b=_.renderPos,w=a.drawing.util,y=w.defined,k=w.limitValue,x=w.valueOrDefault,C="k-",S=.9,T=.93,D="DOMMouseScroll mousewheel",A=5,E=l.extend({init:function(e,t){a.destroy(e),l.fn.init.call(this,e),this._initOptions(t),this.bind(this.events,t),this.crs=new v,this.element.addClass(C+this.options.name.toLowerCase()).css("position","relative").empty().append(n.createElement("div")),this._viewOrigin=this._getOrigin(),this._initScroller(),this._initMarkers(),this._initControls(),this._initLayers(),this._reset(),this._mousewheel=s(this._mousewheel,this),this.element.bind("click",s(this._click,this)),this.element.bind(D,this._mousewheel)},options:{name:"Map",controls:{attribution:!0,navigator:{panStep:100},zoom:!0},layers:[],layerDefaults:{shape:{style:{fill:{color:"#fff"},stroke:{color:"#aaa",width:.5}}},bubble:{style:{fill:{color:"#fff",opacity:.5},stroke:{color:"#aaa",width:.5}}},marker:{shape:"pinTarget",tooltip:{position:"top"}}},center:[0,0],zoom:3,minSize:256,minZoom:1,maxZoom:19,markers:[],markerDefaults:{shape:"pinTarget",tooltip:{position:"top"}},wraparound:!0},events:["beforeReset","click","markerActivate","markerClick","markerCreated","pan","panEnd","reset","shapeClick","shapeCreated","shapeFeatureCreated","shapeMouseEnter","shapeMouseLeave","zoomEnd","zoomStart"],destroy:function(){this.scroller.destroy(),this.navigator&&this.navigator.destroy(),this.attribution&&this.attribution.destroy(),this.zoomControl&&this.zoomControl.destroy(),this.markers.destroy();for(var e=0;e<this.layers.length;e++)this.layers[e].destroy();l.fn.destroy.call(this)},zoom:function(e){var t=this.options;return y(e)?(e=i.round(k(e,t.minZoom,t.maxZoom)),t.zoom!==e&&(t.zoom=e,this._reset()),this):t.zoom},center:function(e){return e?(this.options.center=g.create(e).toArray(),this._reset(),this):g.create(this.options.center)},extent:function(e){return e?(this._setExtent(e),this):this._getExtent()},setOptions:function(e){l.fn.setOptions.call(this,e),this._reset()},locationToLayer:function(e,t){var n=!this.options.wraparound;return e=g.create(e),this.crs.toPoint(e,this._layerSize(t),n)},layerToLocation:function(e,t){var n=!this.options.wraparound;return e=f.create(e),this.crs.toLocation(e,this._layerSize(t),n)},locationToView:function(e){var t,n;return e=g.create(e),t=this.locationToLayer(this._viewOrigin),n=this.locationToLayer(e),n.translateWith(t.scale(-1))},viewToLocation:function(e,t){var n=this.locationToLayer(this._getOrigin(),t);return e=f.create(e),e=e.clone().translateWith(n),this.layerToLocation(e,t)},eventOffset:function(e){var t=this.element.offset(),n=e.originalEvent||e,i=x(n.pageX,n.clientX)-t.left,o=x(n.pageY,n.clientY)-t.top;return new h.Point(i,o)},eventToView:function(e){var t=this.eventOffset(e);return this.locationToView(this.viewToLocation(t))},eventToLayer:function(e){return this.locationToLayer(this.eventToLocation(e))},eventToLocation:function(e){var t=this.eventOffset(e);return this.viewToLocation(t)},viewSize:function(){var e=this.element,t=this._layerSize(),n=e.width();return this.options.wraparound||(n=o(t,n)),{width:n,height:o(t,e.height())}},exportVisual:function(){return this._reset(),!1},_setOrigin:function(e,t){var n,i=this.viewSize();return e=this._origin=g.create(e),n=this.locationToLayer(e,t),n.x+=i.width/2,n.y+=i.height/2,this.options.center=this.layerToLocation(n,t).toArray(),this},_getOrigin:function(e){var t,n=this.viewSize();return!e&&this._origin||(t=this.locationToLayer(this.center()),t.x-=n.width/2,t.y-=n.height/2,this._origin=this.layerToLocation(t)),this._origin},_setExtent:function(e){var t,n,o,r,s,a,l,c=m.create(e),d=c.se.clone();for(this.options.wraparound&&d.lng<0&&e.nw.lng>0&&(d.lng=180+(180+d.lng)),e=new m(c.nw,d),this.center(e.center()),t=this.element.width(),n=this.element.height(),o=this.options.maxZoom;o>=this.options.minZoom&&(r=this.locationToLayer(e.nw,o),s=this.locationToLayer(e.se,o),a=i.abs(s.x-r.x),l=i.abs(s.y-r.y),!(a<=t&&l<=n));o--);this.zoom(o)},_getExtent:function(){var e,t=this._getOrigin(),n=this.locationToLayer(t),i=this.viewSize();return n.x+=i.width,n.y+=i.height,e=this.layerToLocation(n),new m(t,e)},_zoomAround:function(e,t){this._setOrigin(this.layerToLocation(e,t),t),this.zoom(t)},_initControls:function(){var e=this.options.controls;u.Attribution&&e.attribution&&this._createAttribution(e.attribution),a.support.mobileOS||(u.Navigator&&e.navigator&&this._createNavigator(e.navigator),u.ZoomControl&&e.zoom&&this._createZoomControl(e.zoom))},_createControlElement:function(t,n){var i=t.position||n,o="."+b(i).replace(" ","."),r=e(".k-map-controls"+o,this.element);return 0===r.length&&(r=e("<div>").addClass("k-map-controls "+b(i)).appendTo(this.element)),e("<div>").appendTo(r)},_createAttribution:function(e){var t=this._createControlElement(e,"bottomRight");this.attribution=new u.Attribution(t,e)},_createNavigator:function(e){var t=this._createControlElement(e,"topLeft"),n=this.navigator=new u.Navigator(t,e);this._navigatorPan=s(this._navigatorPan,this),n.bind("pan",this._navigatorPan),this._navigatorCenter=s(this._navigatorCenter,this),n.bind("center",this._navigatorCenter)},_navigatorPan:function(e){var t=this,n=t.scroller,i=n.scrollLeft+e.x,o=n.scrollTop-e.y,r=this._virtualSize,s=this.element.height(),a=this.element.width();i=k(i,r.x.min,r.x.max-a),o=k(o,r.y.min,r.y.max-s),t.scroller.one("scroll",function(e){t._scrollEnd(e)}),t.scroller.scrollTo(-i,-o)},_navigatorCenter:function(){this.center(this.options.center)},_createZoomControl:function(e){var t=this._createControlElement(e,"topLeft"),n=this.zoomControl=new u.ZoomControl(t,e);this._zoomControlChange=s(this._zoomControlChange,this),n.bind("change",this._zoomControlChange)},_zoomControlChange:function(e){this.trigger("zoomStart",{originalEvent:e})||(this.zoom(this.zoom()+e.delta),this.trigger("zoomEnd",{originalEvent:e}))},_initScroller:function(){var e=a.support.mobileOS?T:S,t=this.options.zoomable!==!1,n=this.scroller=new a.mobile.ui.Scroller(this.element.children(0),{friction:e,velocityMultiplier:A,zoom:t,mousewheelScrolling:!1});n.bind("scroll",s(this._scroll,this)),n.bind("scrollEnd",s(this._scrollEnd,this)),
n.userEvents.bind("gesturestart",s(this._scaleStart,this)),n.userEvents.bind("gestureend",s(this._scale,this)),this.scrollElement=n.scrollElement},_initLayers:function(){var e,t,n,i,o,r=this.options.layers,s=this.layers=[];for(e=0;e<r.length;e++)t=r[e],n=t.type||"shape",i=this.options.layerDefaults[n],o=d.map.layers[n],s.push(new o(this,c({},i,t)))},_initMarkers:function(){this.markers=new p.layers.MarkerLayer(this,this.options.markerDefaults),this.markers.add(this.options.markers)},_scroll:function(e){var t=this.locationToLayer(this._viewOrigin).round(),n=e.sender.movable,i=new h.Point(n.x,n.y).scale(-1).scale(1/n.scale);t.x+=i.x,t.y+=i.y,this._scrollOffset=i,this._setOrigin(this.layerToLocation(t)),this.trigger("pan",{originalEvent:e,origin:this._getOrigin(),center:this.center()})},_scrollEnd:function(e){this._scrollOffset&&this._panComplete()&&(this._scrollOffset=null,this._panEndTS=new Date,this.trigger("panEnd",{originalEvent:e,origin:this._getOrigin(),center:this.center()}))},_panComplete:function(){return new Date-(this._panEndTS||0)>50},_scaleStart:function(e){if(this.trigger("zoomStart",{originalEvent:e})){var t=e.touches[1];t&&t.cancel()}},_scale:function(e){var t=this.scroller.movable.scale,n=this._scaleToZoom(t),i=new h.Point(e.center.x,e.center.y),o=this.viewToLocation(i,n),r=this.locationToLayer(o,n),s=r.translate(-i.x,-i.y);this._zoomAround(s,n),this.trigger("zoomEnd",{originalEvent:e})},_scaleToZoom:function(e){var t=this._layerSize()*e,n=t/this.options.minSize,o=i.log(n)/i.log(2);return i.round(o)},_reset:function(){this.attribution&&this.attribution.filter(this.center(),this.zoom()),this._viewOrigin=this._getOrigin(!0),this._resetScroller(),this.trigger("beforeReset"),this.trigger("reset")},_resetScroller:function(){var e,t,n,i,o=this.scroller,s=o.dimensions.x,a=o.dimensions.y,l=this._layerSize(),c=this.extent().nw,d=this.locationToLayer(c).round();o.movable.round=!0,o.reset(),o.userEvents.cancel(),e=this.zoom(),o.dimensions.forcedMinScale=r(2,this.options.minZoom-e),o.dimensions.maxScale=r(2,this.options.maxZoom-e),t={min:-d.x,max:l-d.x},n={min:-d.y,max:l-d.y},this.options.wraparound&&(t.max=20*l,t.min=-t.max),this.options.pannable===!1&&(i=this.viewSize(),t.min=n.min=0,t.max=i.width,n.max=i.height),s.makeVirtual(),a.makeVirtual(),s.virtualSize(t.min,t.max),a.virtualSize(n.min,n.max),this._virtualSize={x:t,y:n}},_renderLayers:function(){var e,t,n,i,o,r=this.options.layers,s=this.layers=[],a=this.scrollWrap;for(a.empty(),e=0;e<r.length;e++)t=r[e],n=t.type||"shape",i=this.options.layerDefaults[n],o=d.map.layers[n],s.push(new o(this,c({},i,t)))},_layerSize:function(e){return e=x(e,this.options.zoom),this.options.minSize*r(2,e)},_click:function(e){if(this._panComplete()){var t=this.eventOffset(e);this.trigger("click",{originalEvent:e,location:this.viewToLocation(t)})}},_mousewheel:function(e){var t,n,i,o,r,s,a,l;e.preventDefault(),t=d.mwDelta(e)>0?-1:1,n=this.options,i=this.zoom(),o=k(i+t,n.minZoom,n.maxZoom),n.zoomable!==!1&&o!==i&&(this.trigger("zoomStart",{originalEvent:e})||(r=this.eventOffset(e),s=this.viewToLocation(r),a=this.locationToLayer(s,o),l=a.translate(-r.x,-r.y),this._zoomAround(l,o),this.trigger("zoomEnd",{originalEvent:e})))}});d.ui.plugin(E)}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.map.min",["kendo.data.min","kendo.userevents.min","kendo.tooltip.min","kendo.mobile.scroller.min","kendo.draganddrop.min","kendo.dataviz.core.min","dataviz/map/location.min","dataviz/map/attribution.min","dataviz/map/navigator.min","dataviz/map/zoom.min","dataviz/map/crs.min","dataviz/map/layers/base.min","dataviz/map/layers/shape.min","dataviz/map/layers/bubble.min","dataviz/map/layers/tile.min","dataviz/map/layers/bing.min","dataviz/map/layers/marker.min","dataviz/map/main.min"],e)}(function(){return window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/diagram/utils.min",["kendo.core.min"],e)}(function(){!function(e,t){function n(e,n,i){function o(e){for(var t=1;e*t%1;)t*=10;return t}var r,s,a,l;if(t===e||t===n)return[];if(i&&u.sign(n-e)!=u.sign(i))throw"The sign of the increment should allow to reach the stop-value.";if(i=i||1,e=e||0,n=n||e,(n-e)/i===1/0)throw"Infinite range defined.";if(r=[],s=-1,l=o(Math.abs(i)),e*=l,n*=l,i*=l,e>n&&i>0&&(i=-i),i<0)for(;(a=e+i*++s)>=n;)r.push(a/l);else for(;(a=e+i*++s)<=n;)r.push(a/l);return r}function i(e,t){if(e==t)return 0;var n=t.x-e.x,i=e.y-t.y,o=Math.atan(n/i);return i>=0?n<0?o+2*Math.PI:o:o+Math.PI}var o,r,s=window.kendo,a=s.dataviz.diagram={},l=s.deepExtend,c=e.isArray,d=1e-6,u={};l(u,{isNearZero:function(e){return Math.abs(e)<d},isDefined:function(e){return t!==e},isUndefined:function(e){return t===e||null===e},isObject:function(e){return e===Object(e)},has:function(e,t){return Object.hasOwnProperty.call(e,t)},isString:function(e){return"[object String]"==Object.prototype.toString.call(e)},isBoolean:function(e){return"[object Boolean]"==Object.prototype.toString.call(e)},isType:function(e,t){return Object.prototype.toString.call(e)=="[object "+t+"]"},isNumber:function(e){return!isNaN(parseFloat(e))&&isFinite(e)},isEmpty:function(e){if(null===e)return!0;if(c(e)||u.isString(e))return 0===e.length;for(var t in e)if(u.has(e,t))return!1;return!0},simpleExtend:function(e,t){if(u.isObject(t))for(var n in t)e[n]=t[n]},initArray:function(e,t){var n,i=[];for(n=0;n<e;++n)i[n]=t;return i},serializePoints:function(e){var t,n,i=[];for(t=0;t<e.length;t++)n=e[t],i.push(n.x+";"+n.y);return i.join(";")},deserializePoints:function(e){var t,n=e.split(";"),i=[];if(n.length%2!==0)throw"Not an array of points.";for(t=0;t<n.length;t+=2)i.push(new a.Point(parseInt(n[t],10),parseInt(n[t+1],10)));return i},randomInteger:function(e,t){return parseInt(Math.floor(Math.random()*t)+e,10)},DFT:function(e,t){var n,i;if(t(e),e.childNodes)for(n=0;n<e.childNodes.length;n++)i=e.childNodes[n],this.DFT(i,t)},getMatrixAngle:function(e){return null===e||0===e.d?0:180*Math.atan2(e.b,e.d)/Math.PI},getMatrixScaling:function(e){var t=Math.sqrt(e.a*e.a+e.c*e.c),n=Math.sqrt(e.b*e.b+e.d*e.d);return[t,n]}}),u.sign=function(e){return e?e<0?-1:1:0},u.findAngle=function(e,t){return 180*i(e,t)/Math.PI},u.forEach=function(e,t,n){for(var i=0;i<e.length;i++)t.call(n,e[i],i,e)},u.any=function(e,t){for(var n=0;n<e.length;++n)if(t(e[n]))return e[n];return null},u.remove=function(e,t){for(var n;(n=u.indexOf(e,t))!==-1;)e.splice(n,1);return e},u.contains=function(e,t){return u.indexOf(e,t)!==-1},u.indexOf=function(t,n){return e.inArray(n,t)},u.fold=function(e,t,n,i){var o,r,s=arguments.length>2;for(o=0;o<e.length;o++)r=e[o],s?n=t.call(i,n,r,o,e):(n=r,s=!0);if(!s)throw"Reduce of empty array with no initial value";return n},u.find=function(e,t,n){var i;return u.any(e,function(e,o,r){return!!t.call(n,e,o,r)&&(i=e,!0)}),i},u.first=function(e,t,n){return 0===e.length?null:u.isUndefined(t)?e[0]:u.find(e,t,n)},u.insert=function(e,t,n){return e.splice(n,0,t),e},u.all=function(e,t,n){var i,o,r=!0;for(o=0;o<e.length&&(i=e[o],r=r&&t.call(n,i,o,e),r);o++);return r},u.clear=function(e){e.splice(0,e.length)},u.bisort=function(e,t,n){if(u.isUndefined(e))throw"First array is not specified.";if(u.isUndefined(t))throw"Second array is not specified.";if(e.length!=t.length)throw"The two arrays should have equal length";var i,o=[];for(i=0;i<e.length;i++)o.push({x:e[i],y:t[i]});for(o.sort(u.isUndefined(n)?function(e,t){return e.x-t.x}:function(e,t){return n(e.x,t.x)}),u.clear(e),u.clear(t),i=0;i<o.length;i++)e.push(o[i].x),t.push(o[i].y)},u.addRange=function(e,t){e.push.apply(e,t)},o={easeInOut:function(e){return-Math.cos(e*Math.PI)/2+.5}},r=s.Class.extend({init:function(){this.adapters=[],this.target=0,this.tick=0,this.interval=20,this.duration=800,this.lastTime=null,this.handlers=[];var e=this;this.transition=o.easeInOut,this.timerDelegate=function(){e.onTimerEvent()}},addAdapter:function(e){this.adapters.push(e)},onComplete:function(e){this.handlers.push(e)},removeHandler:function(t){this.handlers=e.grep(this.handlers,function(e){return e!==t})},trigger:function(){var e=this;this.handlers&&u.forEach(this.handlers,function(t){return t.call(null!==e.caller?e.caller:e)})},onStep:function(){},seekTo:function(e){this.seekFromTo(this.tick,e)},seekFromTo:function(e,t){this.target=Math.max(0,Math.min(1,t)),this.tick=Math.max(0,Math.min(1,e)),this.lastTime=(new Date).getTime(),this.intervalId||(this.intervalId=window.setInterval(this.timerDelegate,this.interval))},stop:function(){this.intervalId&&(window.clearInterval(this.intervalId),this.intervalId=null,this.trigger())},play:function(e){0!==this.adapters.length&&(null!==e&&(this.caller=e),this.initState(),this.seekFromTo(0,1))},reverse:function(){this.seekFromTo(1,0)},initState:function(){if(0!==this.adapters.length)for(var e=0;e<this.adapters.length;e++)this.adapters[e].initState()},propagate:function(){var e,t=this.transition(this.tick);for(e=0;e<this.adapters.length;e++)this.adapters[e].update(t)},onTimerEvent:function(){var e,t=(new Date).getTime(),n=t-this.lastTime;this.lastTime=t,e=n/this.duration*(this.tick<this.target?1:-1),Math.abs(e)>=Math.abs(this.tick-this.target)?this.tick=this.target:this.tick+=e;try{this.propagate()}finally{this.onStep.call(this),this.target==this.tick&&this.stop()}}}),s.deepExtend(a,{init:function(e){s.init(e,a.ui)},Utils:u,Range:n,Ticker:r})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/diagram/math.min",["dataviz/diagram/utils.min","kendo.dataviz.core.min"],e)}(function(){!function(e,t){function n(e){return Math.abs(e)<F}function i(e,t,i,o,r){var s,a,l,c,d=(t.x-e.x)*(o.y-i.y)-(t.y-e.y)*(o.x-i.x);if(!n(d)&&(s=(e.y-i.y)*(o.x-i.x)-(e.x-i.x)*(o.y-i.y),a=(e.y-i.y)*(t.x-e.x)-(e.x-i.x)*(t.y-e.y),l=s/d,c=a/d,!r||!(l<0||l>1||c<0||c>1)))return new A(e.x+l*(t.x-e.x),e.y+l*(t.y-e.y))}function o(e,t){var n,i,o;do n=2*Math.random()-1,i=2*Math.random()-1,o=n*n+i*i;while(!o||o>1);return e+t*n*Math.sqrt(-2*Math.log(o)/o)}function r(e){var t,n,i;for(D.isUndefined(e)&&(e=10),t="",n="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",i=e;i>0;--i)t+=n.charAt(Math.round(Math.random()*(n.length-1)));return t}var s,a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k=window.kendo,x=k.dataviz.diagram,C=k.Class,S=k.deepExtend,T=k.dataviz,D=x.Utils,A=T.Point2D,E=k.isFunction,I=D.contains,M=e.map,R=3,F=1e-6;S(A.fn,{plus:function(e){return new A(this.x+e.x,this.y+e.y)},minus:function(e){return new A(this.x-e.x,this.y-e.y)},offset:function(e){return new A(this.x-e,this.y-e)},times:function(e){return new A(this.x*e,this.y*e)},normalize:function(){return 0===this.length()?new A:this.times(1/this.length())},length:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},toString:function(){return"("+this.x+","+this.y+")"},lengthSquared:function(){return this.x*this.x+this.y*this.y},middleOf:function(e,t){return new A(t.x-e.x,t.y-e.y).times(.5).plus(e)},toPolar:function(e){var t,n,i,o=1;if(e&&(o=180/Math.PI),t=Math.atan2(Math.abs(this.y),Math.abs(this.x)),n=Math.PI/2,i=this.length(),0===this.x){if(0===this.y)return new u(0,0);if(this.y>0)return new u(i,o*n);if(this.y<0)return new u(i,3*o*n)}else if(this.x>0){if(0===this.y)return new u(i,0);if(this.y>0)return new u(i,o*t);if(this.y<0)return new u(i,o*(4*n-t))}else{if(0===this.y)return new u(i,2*n);if(this.y>0)return new u(i,o*(2*n-t));if(this.y<0)return new u(i,o*(2*n+t))}},isOnLine:function(e,t){var n,i,o,r,s;return e.x>t.x&&(n=t,t=e,e=n),i=new a(e.x,e.y).inflate(R,R),o=new a(t.x,t.y).inflate(R,R),!!i.union(o).contains(this)&&(e.x===t.x||e.y===t.y||(e.y<t.y?(r=i.x+(o.x-i.x)*(this.y-(i.y+i.height))/(o.y+o.height-(i.y+i.height)),s=i.x+i.width+(o.x+o.width-(i.x+i.width))*(this.y-i.y)/(o.y-i.y)):(r=i.x+(o.x-i.x)*(this.y-i.y)/(o.y-i.y),s=i.x+i.width+(o.x+o.width-(i.x+i.width))*(this.y-(i.y+i.height))/(o.y+o.height-(i.y+i.height))),this.x>r&&this.x<s))}}),S(A,{parse:function(e){var t=e.slice(1,e.length-1),n=t.split(","),i=parseInt(n[0],10),o=parseInt(n[1],10);if(!isNaN(i)&&!isNaN(o))return new A(i,o)}}),s=C.extend({init:function(e,t,n){this.point=e,this.left=t,this.right=n}}),a=C.extend({init:function(e,t,n,i){this.x=e||0,this.y=t||0,this.width=n||0,this.height=i||0},contains:function(e){return e.x>=this.x&&e.x<=this.x+this.width&&e.y>=this.y&&e.y<=this.y+this.height},inflate:function(e,n){return n===t&&(n=e),this.x-=e,this.y-=n,this.width+=2*e+1,this.height+=2*n+1,this},offset:function(e,t){var n=e,i=t;return e instanceof A&&(n=e.x,i=e.y),this.x+=n,this.y+=i,this},union:function(e){var t=Math.min(this.x,e.x),n=Math.min(this.y,e.y),i=Math.max(this.x+this.width,e.x+e.width),o=Math.max(this.y+this.height,e.y+e.height);return new a(t,n,i-t,o-n)},center:function(){return new A(this.x+this.width/2,this.y+this.height/2)},top:function(){return new A(this.x+this.width/2,this.y)},right:function(){return new A(this.x+this.width,this.y+this.height/2)},bottom:function(){return new A(this.x+this.width/2,this.y+this.height)},left:function(){return new A(this.x,this.y+this.height/2)},topLeft:function(){return new A(this.x,this.y)},topRight:function(){return new A(this.x+this.width,this.y)},bottomLeft:function(){return new A(this.x,this.y+this.height)},bottomRight:function(){return new A(this.x+this.width,this.y+this.height)},clone:function(){return new a(this.x,this.y,this.width,this.height)},isEmpty:function(){return!this.width&&!this.height},equals:function(e){return this.x===e.x&&this.y===e.y&&this.width===e.width&&this.height===e.height},rotatedBounds:function(e){var t=this.clone(),n=this.rotatedPoints(e),i=n[0],o=n[1],r=n[2],s=n[3];return t.x=Math.min(r.x,i.x,o.x,s.x),t.y=Math.min(r.y,i.y,o.y,s.y),t.width=Math.max(r.x,i.x,o.x,s.x)-t.x,t.height=Math.max(r.y,i.y,o.y,s.y)-t.y,t},rotatedPoints:function(e){var t=this,n=t.center(),i=t.bottomRight().rotate(n,360-e),o=t.topLeft().rotate(n,360-e),r=t.topRight().rotate(n,360-e),s=t.bottomLeft().rotate(n,360-e);return[o,r,i,s]},toString:function(e){return e=e||" ",this.x+e+this.y+e+this.width+e+this.height},scale:function(e,t,n,i,o){var r,s,a,l=this.topLeft(),c=this.center();l.rotate(c,360-o).rotate(i,o),r=n.minus(l),s=new A(r.x*e,r.y*t),a=r.minus(s),l=l.plus(a),l.rotate(i,360-o).rotate(c,o),this.x=l.x,this.y=l.y,this.width*=e,this.height*=t},zoom:function(e){return this.x*=e,this.y*=e,this.width*=e,this.height*=e,this},overlaps:function(e){var t=this.bottomRight(),n=e.bottomRight(),i=!(t.x<e.x||t.y<e.y||n.x<this.x||n.y<this.y);return i}}),l=C.extend({init:function(e,t){this.width=e,this.height=t}}),l.prototype.Empty=new l(0,0),a.toRect=function(e){return e instanceof a||(e=new a(e.x,e.y,e.width,e.height)),e},a.empty=function(){return new a(0,0,0,0)},a.fromPoints=function(e,t){if(isNaN(e.x)||isNaN(e.y)||isNaN(t.x)||isNaN(t.y))throw"Some values are NaN.";return new a(Math.min(e.x,t.x),Math.min(e.y,t.y),Math.abs(e.x-t.x),Math.abs(e.y-t.y))},c={lines:function(e,t,n,o){return i(e,t,n,o)},segments:function(e,t,n,o){return i(e,t,n,o,!0)},rectWithLine:function(e,t,n){return c.segments(t,n,e.topLeft(),e.topRight())||c.segments(t,n,e.topRight(),e.bottomRight())||c.segments(t,n,e.bottomLeft(),e.bottomRight())||c.segments(t,n,e.topLeft(),e.bottomLeft())},rects:function(e,t,n){var i,o,r=t.topLeft(),s=t.topRight(),a=t.bottomLeft(),l=t.bottomRight(),d=t.center();return n&&(r=r.rotate(d,n),s=s.rotate(d,n),a=a.rotate(d,n),l=l.rotate(d,n)),i=e.contains(r)||e.contains(s)||e.contains(a)||e.contains(l)||c.rectWithLine(e,r,s)||c.rectWithLine(e,r,a)||c.rectWithLine(e,s,l)||c.rectWithLine(e,a,l),i||(r=e.topLeft(),s=e.topRight(),a=e.bottomLeft(),l=e.bottomRight(),n&&(o=360-n,r=r.rotate(d,o),s=s.rotate(d,o),a=a.rotate(d,o),l=l.rotate(d,o)),i=t.contains(r)||t.contains(s)||t.contains(a)||t.contains(l)),i}},d=C.extend({init:function(e){this.container=a.toRect(e)},align:function(e,t){var n,i=t.toLowerCase().split(" ");for(n=0;n<i.length;n++)e=this._singleAlign(e,i[n]);return e},_singleAlign:function(e,t){return E(this[t])?this[t](e):e},left:function(e){return this._align(e,this._left)},center:function(e){return this._align(e,this._center)},right:function(e){return this._align(e,this._right)},stretch:function(e){return this._align(e,this._stretch)},top:function(e){return this._align(e,this._top)},middle:function(e){return this._align(e,this._middle)},bottom:function(e){return this._align(e,this._bottom)},_left:function(e,t){t.x=e.x},_center:function(e,t){t.x=(e.width-t.width)/2||0},_right:function(e,t){t.x=e.width-t.width},_top:function(e,t){t.y=e.y},_middle:function(e,t){t.y=(e.height-t.height)/2||0},_bottom:function(e,t){t.y=e.height-t.height},_stretch:function(e,t){t.x=0,t.y=0,t.height=e.height,t.width=e.width},_align:function(e,t){return e=a.toRect(e),t(this.container,e),e}}),u=C.extend({init:function(e,t){this.r=e,this.angle=t}}),h=C.extend({init:function(e,t,n,i,o,r){this.a=e||0,this.b=t||0,this.c=n||0,this.d=i||0,this.e=o||0,this.f=r||0},plus:function(e){this.a+=e.a,this.b+=e.b,this.c+=e.c,this.d+=e.d,this.e+=e.e,this.f+=e.f},minus:function(e){this.a-=e.a,this.b-=e.b,this.c-=e.c,this.d-=e.d,this.e-=e.e,this.f-=e.f},times:function(e){return new h(this.a*e.a+this.c*e.b,this.b*e.a+this.d*e.b,this.a*e.c+this.c*e.d,this.b*e.c+this.d*e.d,this.a*e.e+this.c*e.f+this.e,this.b*e.e+this.d*e.f+this.f)},apply:function(e){return new A(this.a*e.x+this.c*e.y+this.e,this.b*e.x+this.d*e.y+this.f)},applyRect:function(e){return a.fromPoints(this.apply(e.topLeft()),this.apply(e.bottomRight()))},toString:function(){return"matrix("+this.a+" "+this.b+" "+this.c+" "+this.d+" "+this.e+" "+this.f+")"}}),S(h,{fromSVGMatrix:function(e){var t=new h;return t.a=e.a,t.b=e.b,t.c=e.c,t.d=e.d,t.e=e.e,t.f=e.f,t},fromMatrixVector:function(e){var t=new h;return t.a=e.a,t.b=e.b,t.c=e.c,t.d=e.d,t.e=e.e,t.f=e.f,t},fromList:function(e){if(6!==e.length)throw"The given list should consist of six elements.";var t=new h;return t.a=e[0],t.b=e[1],t.c=e[2],t.d=e[3],t.e=e[4],t.f=e[5],t},translation:function(e,t){var n=new h;return n.a=1,n.b=0,n.c=0,n.d=1,n.e=e,n.f=t,n},unit:function(){return new h(1,0,0,1,0,0)},rotation:function(e,t,n){var i=new h;return i.a=Math.cos(e*Math.PI/180),i.b=Math.sin(e*Math.PI/180),i.c=-i.b,i.d=i.a,i.e=t-t*i.a+n*i.b||0,i.f=n-n*i.a-t*i.b||0,i},scaling:function(e,t){var n=new h;return n.a=e,n.b=0,n.c=0,n.d=t,n.e=0,n.f=0,n},parse:function(e){var t,n;if(e){if(e=e.trim(),"matrix"===e.slice(0,6).toLowerCase()){if(n=e.slice(7,e.length-1).trim(),t=n.split(","),6===t.length)return h.fromList(M(t,function(e){return parseFloat(e)}));if(t=n.split(" "),6===t.length)return h.fromList(M(t,function(e){return parseFloat(e)}))}if("("===e.slice(0,1)&&")"===e.slice(e.length-1)&&(e=e.substr(1,e.length-1)),e.indexOf(",")>0&&(t=e.split(","),6===t.length))return h.fromList(M(t,function(e){return parseFloat(e)}));if(e.indexOf(" ")>0&&(t=e.split(" "),6===t.length))return h.fromList(M(t,function(e){return parseFloat(e)}))}return t}}),f=C.extend({init:function(e,t,n,i,o,r){this.a=e||0,this.b=t||0,this.c=n||0,this.d=i||0,this.e=o||0,this.f=r||0},fromMatrix:function(e){var t=new f;return t.a=e.a,t.b=e.b,t.c=e.c,t.d=e.d,t.e=e.e,t.f=e.f,t}}),p={_distanceToLineSquared:function(e,t,n){function i(e,t){return(e.x-t.x)*(e.x-t.x)+(e.y-t.y)*(e.y-t.y)}if(t===n)return i(e,t);var o=n.x-t.x,r=n.y-t.y,s=(e.x-t.x)*o+(e.y-t.y)*r;return s<0?i(t,e):(s=(n.x-e.x)*o+(n.y-e.y)*r,s<0?i(n,e):(s=(n.x-e.x)*r-(n.y-e.y)*o,s*s/(o*o+r*r)))},distanceToLine:function(e,t,n){return Math.sqrt(this._distanceToLineSquared(e,t,n))},distanceToPolyline:function(e,t){var n,i,o,r,s=Number.MAX_VALUE;if(D.isUndefined(t)||0===t.length)return Number.MAX_VALUE;for(n=0;n<t.length-1;n++)i=t[n],o=t[n+1],r=this._distanceToLineSquared(e,i,o),r<s&&(s=r);return Math.sqrt(s)}},m=k.Class.extend({init:function(){this._buckets=[],this.length=0},add:function(e,t){var n=this._createGetBucket(e);return D.isDefined(t)&&(n.value=t),n},get:function(e){return this._bucketExists(e)?this._createGetBucket(e):null},set:function(e,t){this.add(e,t)},containsKey:function(e){return this._bucketExists(e)},remove:function(e){if(this._bucketExists(e)){var t=this._hash(e);return delete this._buckets[t],this.length--,e}},forEach:function(e){var t,n,i,o,r=this._hashes();for(t=0,n=r.length;t<n;t++)i=r[t],o=this._buckets[i],D.isUndefined(o)||e(o)},clone:function(){var e,t,n,i,o=new m,r=this._hashes();for(e=0,t=r.length;e<t;e++)n=r[e],i=this._buckets[n],D.isUndefined(i)||o.add(i.key,i.value);return o},_hashes:function(){var e,t=[];for(e in this._buckets)this._buckets.hasOwnProperty(e)&&t.push(e);return t},_bucketExists:function(e){var t=this._hash(e);return D.isDefined(this._buckets[t])},_createGetBucket:function(e){var t=this._hash(e),n=this._buckets[t];return D.isUndefined(n)&&(n={key:e},this._buckets[t]=n,this.length++),n},_hash:function(e){if(D.isNumber(e))return e;if(D.isString(e))return this._hashString(e);if(D.isObject(e))return this._objectHashId(e);throw"Unsupported key type."},_hashString:function(e){var t,n,i=0;if(0===e.length)return i;for(t=0;t<e.length;t++)n=e.charCodeAt(t),i=32*i-i+n;return i},_objectHashId:function(e){var t=e._hashId;return D.isUndefined(t)&&(t=r(),e._hashId=t),t}}),g=k.Observable.extend({init:function(t){var n,i=this;if(k.Observable.fn.init.call(i),this._hashTable=new m,this.length=0,D.isDefined(t))if(e.isArray(t))for(n=0;n<t.length;n++)this.add(t[n]);else t.forEach(function(e,t){this.add(e,t)},this)},add:function(e,t){var n=this._hashTable.get(e);n||(n=this._hashTable.add(e),this.length++,this.trigger("changed")),n.value=t},set:function(e,t){this.add(e,t)},get:function(e){var t=this._hashTable.get(e);if(t)return t.value;throw Error("Cannot find key "+e)},containsKey:function(e){return this._hashTable.containsKey(e)},remove:function(e){if(this.containsKey(e))return this.trigger("changed"),this.length--,this._hashTable.remove(e)},forEach:function(e,t){this._hashTable.forEach(function(n){e.call(t,n.key,n.value)})},forEachValue:function(e,t){this._hashTable.forEach(function(n){e.call(t,n.value)})},forEachKey:function(e,t){this._hashTable.forEach(function(n){e.call(t,n.key)})},keys:function(){var e=[];return this.forEachKey(function(t){e.push(t)}),e}}),v=k.Class.extend({init:function(){this._tail=null,this._head=null,this.length=0},enqueue:function(e){var t={value:e,next:null};this._head?(this._tail.next=t,this._tail=this._tail.next):(this._head=t,this._tail=this._head),this.length++},dequeue:function(){if(this.length<1)throw Error("The queue is empty.");var e=this._head.value;return this._head=this._head.next,this.length--,e},contains:function(e){for(var t=this._head;t;){if(t.value===e)return!0;t=t.next}return!1}}),_=k.Observable.extend({init:function(e){var t=this;k.Observable.fn.init.call(t),this._hashTable=new m,this.length=0,D.isDefined(e)&&(e instanceof m?e.forEach(function(e){this.add(e)}):e instanceof g&&e.forEach(function(e,t){this.add({key:e,value:t})},this))},contains:function(e){return this._hashTable.containsKey(e)},add:function(e){var t=this._hashTable.get(e);t||(this._hashTable.add(e,e),this.length++,this.trigger("changed"))},get:function(e){return this.contains(e)?this._hashTable.get(e).value:null},hash:function(e){return this._hashTable._hash(e)},remove:function(e){this.contains(e)&&(this._hashTable.remove(e),this.length--,this.trigger("changed"))},forEach:function(e,t){this._hashTable.forEach(function(t){e(t.value)},t)},toArray:function(){var e=[];return this.forEach(function(t){e.push(t)}),e}}),b=k.Class.extend({init:function(e,t){if(this.links=[],this.outgoing=[],this.incoming=[],this.weight=1,this.id=D.isDefined(e)?e:r(),D.isDefined(t)){this.associatedShape=t;var n=t.bounds();this.width=n.width,this.height=n.height,this.x=n.x,this.y=n.y}else this.associatedShape=null;this.data=null,this.type="Node",this.shortForm="Node '"+this.id+"'",this.isVirtual=!1},isIsolated:function(){return D.isEmpty(this.links)},bounds:function(e){return D.isDefined(e)?(this.x=e.x,this.y=e.y,this.width=e.width,this.height=e.height,t):new x.Rect(this.x,this.y,this.width,this.height)},isLinkedTo:function(e){var t=this;return D.any(t.links,function(n){return n.getComplement(t)===e})},getChildren:function(){var e,t,n,i;if(0===this.outgoing.length)return[];for(e=[],t=0,n=this.outgoing.length;t<n;t++)i=this.outgoing[t],e.push(i.getComplement(this));return e},getParents:function(){var e,t,n,i;if(0===this.incoming.length)return[];for(e=[],t=0,n=this.incoming.length;t<n;t++)i=this.incoming[t],e.push(i.getComplement(this));return e},clone:function(){var e=new b;return D.isDefined(this.weight)&&(e.weight=this.weight),D.isDefined(this.balance)&&(e.balance=this.balance),D.isDefined(this.owner)&&(e.owner=this.owner),e.associatedShape=this.associatedShape,e.x=this.x,e.y=this.y,e.width=this.width,e.height=this.height,e},adjacentTo:function(e){return null!==this.isLinkedTo(e)},removeLink:function(e){e.source===this&&(D.remove(this.links,e),D.remove(this.outgoing,e),e.source=null),e.target===this&&(D.remove(this.links,e),D.remove(this.incoming,e),e.target=null)},hasLinkTo:function(e){return D.any(this.outgoing,function(t){return t.target===e})},degree:function(){return this.links.length},incidentWith:function(e){return I(this.links,e)},getLinksWith:function(e){return D.all(this.links,function(t){return t.getComplement(this)===e},this)},getNeighbors:function(){var e=[];return D.forEach(this.incoming,function(t){e.push(t.getComplement(this))},this),D.forEach(this.outgoing,function(t){e.push(t.getComplement(this))},this),e}}),w=k.Class.extend({init:function(e,t,n,i){if(D.isUndefined(e))throw"The source of the new link is not set.";if(D.isUndefined(t))throw"The target of the new link is not set.";var o,s;o=D.isString(e)?new b(e):e,s=D.isString(t)?new b(t):t,this.source=o,this.target=s,this.source.links.push(this),this.target.links.push(this),this.source.outgoing.push(this),this.target.incoming.push(this),this.id=D.isDefined(n)?n:r(),this.associatedConnection=D.isDefined(i)?i:null,this.type="Link",this.shortForm="Link '"+this.source.id+"->"+this.target.id+"'"},getComplement:function(e){if(this.source!==e&&this.target!==e)throw"The given node is not incident with this link.";return this.source===e?this.target:this.source},getCommonNode:function(e){return this.source===e.source||this.source===e.target?this.source:this.target===e.source||this.target===e.target?this.target:null},isBridging:function(e,t){return this.source===e&&this.target===t||this.source===t&&this.target===e},getNodes:function(){return[this.source,this.target]},incidentWith:function(e){return this.source===e||this.target===e},adjacentTo:function(e){return I(this.source.links,e)||I(this.target.links,e)},changeSource:function(e){D.remove(this.source.links,this),D.remove(this.source.outgoing,this),e.links.push(this),e.outgoing.push(this),this.source=e},changeTarget:function(e){D.remove(this.target.links,this),D.remove(this.target.incoming,this),e.links.push(this),e.incoming.push(this),this.target=e},changesNodes:function(e,t){this.source===e?this.changeSource(t):this.target===e&&this.changeTarget(t)},reverse:function(){var e=this.source,t=this.target;return this.source=t,D.remove(e.outgoing,this),this.source.outgoing.push(this),this.target=e,D.remove(t.incoming,this),this.target.incoming.push(this),this},directTo:function(e){if(this.source!==e&&this.target!==e)throw"The given node is not incident with this link.";this.target!==e&&this.reverse()},createReverseEdge:function(){var e=this.clone();return e.reverse(),e.reversed=!0,e},clone:function(){var e=new w(this.source,this.target);return e}}),y=k.Class.extend({init:function(e){this.links=[],this.nodes=[],this._nodeMap=new g,this.diagram=null,this._root=null,D.isDefined(e)?D.isString(e)?this.id=e:(this.diagram=e,this.id=e.id):this.id=r(),this.bounds=new a,this._hasCachedRelationships=!1,this.type="Graph"},cacheRelationships:function(e){var t,n,i;if(D.isUndefined(e)&&(e=!1),!this._hasCachedRelationships||e){for(t=0,n=this.nodes.length;t<n;t++)i=this.nodes[t],i.children=this.getChildren(i),i.parents=this.getParents(i);this._hasCachedRelationships=!0}},assignLevels:function(e,t,n){var i,o,r,s;if(!e)throw"Start node not specified.";for(D.isUndefined(t)&&(t=0),this.cacheRelationships(),D.isUndefined(n)&&(n=new g,D.forEach(this.nodes,function(e){n.add(e,!1)})),n.set(e,!0),e.level=t,i=e.children,o=0,r=i.length;o<r;o++)s=i[o],s&&!n.get(s)&&this.assignLevels(s,t+1,n)},root:function(e){if(D.isUndefined(e)){if(this._root)return this._root;var t=D.first(this.nodes,function(e){return 0===e.incoming.length});return t?t:D.first(this.nodes)}this._root=e},getConnectedComponents:function(){var e,t,n,i,o;for(this.componentIndex=0,this.setItemIndices(),e=D.initArray(this.nodes.length,-1),t=0;t<this.nodes.length;t++)e[t]===-1&&(this._collectConnectedNodes(e,t),this.componentIndex++);for(n=[],i=0;i<this.componentIndex;++i)n[i]=new y;for(i=0;i<e.length;++i)o=n[e[i]],o.addNodeAndOutgoings(this.nodes[i]);return n.sort(function(e,t){return t.nodes.length-e.nodes.length}),n},_collectConnectedNodes:function(e,t){e[t]=this.componentIndex;var n=this.nodes[t];D.forEach(n.links,function(t){var i=t.getComplement(n),o=i.index;e[o]===-1&&this._collectConnectedNodes(e,o)},this)},calcBounds:function(){var e,t,n,i;if(this.isEmpty())return this.bounds=new a;for(e=null,t=0,n=this.nodes.length;t<n;t++)i=this.nodes[t],e=e?e.union(i.bounds()):i.bounds();return this.bounds=e},getSpanningTree:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,f=new y,p=new g;for(f.root=e.clone(),f.root.level=0,f.root.id=e.id,p.add(e,f.root),e.level=0,i=[],o=[],f._addNode(f.root),i.push(e),o.push(e),r=1;o.length>0;)for(s=o.pop(),a=0;a<s.links.length;a++)l=s.links[a],c=l.getComplement(s),I(i,c)||(c.level=s.level+1,r<c.level+1&&(r=c.level+1),I(o,c)||o.push(c),I(i,c)||i.push(c),p.containsKey(s)?t=p.get(s):(t=s.clone(),t.level=s.level,t.id=s.id,p.add(s,t)),p.containsKey(c)?n=p.get(c):(n=c.clone(),n.level=c.level,n.id=c.id,p.add(c,n)),d=new w(t,n),f.addLink(d));for(u=[],h=0;h<r;h++)u.push([]);return D.forEach(f.nodes,function(e){u[e.level].push(e)}),f.treeLevels=u,f.cacheRelationships(),f},takeRandomNode:function(t,n){if(D.isUndefined(t)&&(t=[]),D.isUndefined(n)&&(n=4),0===this.nodes.length)return null;if(1===this.nodes.length)return I(t,this.nodes[0])?null:this.nodes[0];var i=e.grep(this.nodes,function(e){return!I(t,e)&&e.degree()<=n});return D.isEmpty(i)?null:i[D.randomInteger(0,i.length)]},isEmpty:function(){return D.isEmpty(this.nodes)},isHealthy:function(){return D.all(this.links,function(e){return I(this.nodes,e.source)&&I(this.nodes,e.target)},this)},getParents:function(e){if(!this.hasNode(e))throw"The given node is not part of this graph.";return e.getParents()},getChildren:function(e){if(!this.hasNode(e))throw"The given node is not part of this graph.";return e.getChildren()},addLink:function(e,n,i){var o,r,s;if(D.isUndefined(e))throw"The source of the link is not defined.";if(D.isUndefined(n)){if(D.isDefined(e.type)&&"Link"===e.type)return this.addExistingLink(e),t;throw"The target of the link is not defined."}return o=this.getNode(e),D.isUndefined(o)&&(o=this.addNode(e)),r=this.getNode(n),D.isUndefined(r)&&(r=this.addNode(n)),s=new w(o,r),D.isDefined(i)&&(s.owner=i),this.links.push(s),s},removeAllLinks:function(){for(;this.links.length>0;){var e=this.links[0];this.removeLink(e)}},addExistingLink:function(e){var t,n;this.hasLink(e)||(this.links.push(e),this.hasNode(e.source.id)?(t=this.getNode(e.source.id),e.changeSource(t)):this.addNode(e.source),this.hasNode(e.target.id)?(n=this.getNode(e.target.id),e.changeTarget(n)):this.addNode(e.target))},hasLink:function(e){if(D.isString(e))return D.any(this.links,function(t){return t.id===e});if("Link"===e.type)return I(this.links,e);throw"The given object is neither an identifier nor a Link."},getNode:function(e){var t=e.id||e;if(this._nodeMap.containsKey(t))return this._nodeMap.get(t)},hasNode:function(e){var t=e.id||e;return this._nodeMap.containsKey(t)},_addNode:function(e){this.nodes.push(e),this._nodeMap.add(e.id,e)},_removeNode:function(e){D.remove(this.nodes,e),this._nodeMap.remove(e.id)},removeNode:function(e){
var t,n,i,o,r=e;if(D.isString(e)&&(r=this.getNode(e)),!D.isDefined(r))throw"The identifier should be a Node or the Id (string) of a node.";for(t=r.links,r.links=[],n=0,i=t.length;n<i;n++)o=t[n],this.removeLink(o);this._removeNode(r)},areConnected:function(e,t){return D.any(this.links,function(n){return n.source==e&&n.target==t||n.source==t&&n.target==e})},removeLink:function(e){D.remove(this.links,e),D.remove(e.source.outgoing,e),D.remove(e.source.links,e),D.remove(e.target.incoming,e),D.remove(e.target.links,e)},addNode:function(e,t,n){var i=null;if(!D.isDefined(e))throw"No Node or identifier for a new Node is given.";if(D.isString(e)){if(this.hasNode(e))return this.getNode(e);i=new b(e)}else{if(this.hasNode(e))return this.getNode(e);i=e}return D.isDefined(t)&&i.bounds(t),D.isDefined(n)&&(i.owner=n),this._addNode(i),i},addNodeAndOutgoings:function(e){this.hasNode(e)||this._addNode(e);var t=e.outgoing;e.outgoing=[],D.forEach(t,function(e){this.addExistingLink(e)},this)},setItemIndices:function(){var e;for(e=0;e<this.nodes.length;++e)this.nodes[e].index=e;for(e=0;e<this.links.length;++e)this.links[e].index=e},clone:function(e){var t,n=new y,i=D.isDefined(e)&&e===!0;return i&&(n.nodeMap=new g,n.linkMap=new g),t=new g,D.forEach(this.nodes,function(e){var o=e.clone();t.set(e,o),n._addNode(o),i&&n.nodeMap.set(o,e)}),D.forEach(this.links,function(e){if(t.containsKey(e.source)&&t.containsKey(e.target)){var o=n.addLink(t.get(e.source),t.get(e.target));i&&n.linkMap.set(o,e)}}),n},linearize:function(e){return y.Utils.linearize(this,e)},depthFirstTraversal:function(e,t){var n,i;if(D.isUndefined(e))throw"You need to supply a starting node.";if(D.isUndefined(t))throw"You need to supply an action.";if(!this.hasNode(e))throw"The given start-node is not part of this graph";n=this.getNode(e),i=[],this._dftIterator(n,t,i)},_dftIterator:function(e,t,n){var i,o,r,s;for(t(e),n.push(e),i=e.getChildren(),o=0,r=i.length;o<r;o++)s=i[o],I(n,s)||this._dftIterator(s,t,n)},breadthFirstTraversal:function(e,t){var n,i,o,r,s,a,l,c;if(D.isUndefined(e))throw"You need to supply a starting node.";if(D.isUndefined(t))throw"You need to supply an action.";if(!this.hasNode(e))throw"The given start-node is not part of this graph";for(n=this.getNode(e),i=new v,o=[],i.enqueue(n);i.length>0;)for(r=i.dequeue(),t(r),o.push(r),s=r.getChildren(),a=0,l=s.length;a<l;a++)c=s[a],I(o,c)||I(i,c)||i.enqueue(c)},_stronglyConnectedComponents:function(e,t,n,i,o,r,s){var a,l,c,d,u;for(n.add(t,s),i.add(t,s),s++,r.push(t),a=t.getChildren(),c=0,d=a.length;c<d;c++)l=a[c],n.containsKey(l)?I(r,l)&&i.add(t,Math.min(i.get(t),n.get(l))):(this._stronglyConnectedComponents(e,l,n,i,o,r,s),i.add(t,Math.min(i.get(t),i.get(l))));if(i.get(t)===n.get(t)){u=[];do l=r.pop(),u.push(l);while(l!==t);(!e||u.length>1)&&o.push(u)}},findCycles:function(e){var t,n,i,o,r,s,a;for(D.isUndefined(e)&&(e=!0),t=new g,n=new g,i=[],o=[],r=0,s=this.nodes.length;r<s;r++)a=this.nodes[r],t.containsKey(a)||this._stronglyConnectedComponents(e,a,t,n,i,o,0);return i},isAcyclic:function(){return D.isEmpty(this.findCycles())},isSubGraph:function(e){var t=e.linearize(),n=this.linearize();return D.all(t,function(e){return I(n,e)})},makeAcyclic:function(){var e,t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,v,_,b,w,y,k,x,C,S,T,A,E,I,M,R,F;if(this.isEmpty()||this.nodes.length<=1||this.links.length<=1)return[];if(2==this.nodes.length){if(e=[],this.links.length>1)for(t=this.links[0],n=t.source,i=0,o=this.links.length;i<o;i++)r=this.links[i],r.source!=n&&(s=r.reverse(),e.push(s));return e}for(a=this.clone(!0),l=this.nodes.length,c=new g,d=function(e){return 0===e.outgoing.length?2-l:0===e.incoming.length?l-2:e.outgoing.length-e.incoming.length},u=function(e,t){var n=d(e,l);t.containsKey(n)||t.set(n,[]),t.get(n).push(e)},D.forEach(a.nodes,function(e){u(e,c)}),h=[],f=[];a.nodes.length>0;){if(c.containsKey(2-l))for(_=c.get(2-l);_.length>0;){for(m=_.pop(),b=0;b<m.links.length;b++)w=m.links[b],p=w.getComplement(m),v=d(p,l),D.remove(c.get(v),p),p.removeLink(w),u(p,c);a._removeNode(m),f.unshift(m)}if(c.containsKey(l-2))for(y=c.get(l-2);y.length>0;){for(p=y.pop(),k=0;k<p.links.length;k++)x=p.links[k],m=x.getComplement(p),v=d(m,l),D.remove(c.get(v),m),m.removeLink(x),u(m,c);h.push(p),a._removeNode(p)}if(a.nodes.length>0)for(C=l-3;C>2-l;C--)if(c.containsKey(C)&&c.get(C).length>0){for(S=c.get(C),T=S.pop(),A=0;A<T.links.length;A++)E=T.links[A],I=E.getComplement(T),v=d(I,l),D.remove(c.get(v),I),I.removeLink(E),u(I,c);h.push(T),a._removeNode(T);break}}for(h=h.concat(f),M=new g,R=0;R<this.nodes.length;R++)M.set(a.nodeMap.get(h[R]),R);return F=[],D.forEach(this.links,function(e){M.get(e.source)>M.get(e.target)&&(e.reverse(),F.push(e))}),F}}),y.Predefined={EightGraph:function(){return y.Utils.parse(["1->2","2->3","3->4","4->1","3->5","5->6","6->7","7->3"])},Mindmap:function(){return y.Utils.parse(["0->1","0->2","0->3","0->4","0->5","1->6","1->7","7->8","2->9","9->10","9->11","3->12","12->13","13->14","4->15","4->16","15->17","15->18","18->19","18->20","14->21","14->22","5->23","23->24","23->25","6->26"])},ThreeGraph:function(){return y.Utils.parse(["1->2","2->3","3->1"])},BinaryTree:function(e){return D.isUndefined(e)&&(e=5),y.Utils.createBalancedTree(e,2)},Linear:function(e){return D.isUndefined(e)&&(e=10),y.Utils.createBalancedTree(e,1)},Tree:function(e,t){return y.Utils.createBalancedTree(e,t)},Forest:function(e,t,n){return y.Utils.createBalancedForest(e,t,n)},Workflow:function(){return y.Utils.parse(["0->1","1->2","2->3","1->4","4->3","3->5","5->6","6->3","6->7","5->4"])},Grid:function(e,t){var n,i,o,r,s,a=new x.Graph;if(e<=0&&t<=0)return a;for(n=0;n<e+1;n++)for(i=null,o=0;o<t+1;o++)r=new b(""+n+"."+o),a.addNode(r),i&&a.addLink(i,r),n>0&&(s=a.getNode(""+(n-1)+"."+o),a.addLink(s,r)),i=r;return a}},y.Utils={parse:function(e){var t,n,i,o,r,s=new x.Graph,a=e.slice();for(n=0,i=a.length;n<i;n++){if(o=a[n],D.isString(o)){if(o.indexOf("->")<0)throw"The link should be specified as 'a->b'.";if(r=o.split("->"),2!=r.length)throw"The link should be specified as 'a->b'.";t=new w(r[0],r[1]),s.addLink(t)}if(D.isObject(o)){if(!t)throw"Specification found before Link definition.";k.deepExtend(t,o)}}return s},linearize:function(e,t){var n,i,o,r;if(D.isUndefined(e))throw"Expected an instance of a Graph object in slot one.";for(D.isUndefined(t)&&(t=!1),n=[],i=0,o=e.links.length;i<o;i++)r=e.links[i],n.push(r.source.id+"->"+r.target.id),t&&n.push({id:r.id});return n},_addShape:function(e,t,n,i){return D.isUndefined(t)&&(t=new x.Point(0,0)),D.isUndefined(n)&&(n=r()),i=k.deepExtend({width:20,height:20,id:n,radius:10,fill:"#778899",data:"circle",undoable:!1,x:t.x,y:t.y},i),e.addShape(i)},_addConnection:function(e,t,n,i){return e.connect(t,n,i)},createDiagramFromGraph:function(e,t,n,i){var o,r,s,l,c,d,u,h,f,p,m,g,v,_,b,w;if(D.isUndefined(e))throw"The diagram surface is undefined.";if(D.isUndefined(t))throw"No graph specification defined.";for(D.isUndefined(n)&&(n=!0),D.isUndefined(i)&&(i=!1),o=e.element.clientWidth||200,r=e.element.clientHeight||200,s=[],d=0,u=t.nodes.length;d<u;d++)l=t.nodes[d],h=l.position,D.isUndefined(h)&&(h=D.isDefined(l.x)&&D.isDefined(l.y)?new A(l.x,l.y):new A(D.randomInteger(10,o-20),D.randomInteger(10,r-20))),f={},"0"===l.id||i&&k.deepExtend(f,{width:150*Math.random()+20,height:80*Math.random()+50,data:"rectangle",fill:{color:"#778899"}}),c=this._addShape(e,h,l.id,f),p=c.bounds(),D.isDefined(p)&&(l.x=p.x,l.y=p.y,l.width=p.width,l.height=p.height),s[l.id]=c;for(m=0;m<t.links.length;m++)g=t.links[m],v=s[g.source.id],D.isUndefined(v)||(_=s[g.target.id],D.isUndefined(_)||this._addConnection(e,v,_,{id:g.id}));if(n)for(b=new e.SpringLayout(e),b.layoutGraph(t,{limitToView:!1}),w=0;w<t.nodes.length;w++)l=t.nodes[w],c=s[l.id],c.bounds(new a(l.x,l.y,l.width,l.height))},createBalancedTree:function(e,t){var n,i,o,r,s,a,l,c,d,u;if(D.isUndefined(e)&&(e=3),D.isUndefined(t)&&(t=3),n=new x.Graph,i=-1,o=[],e<=0||t<=0)return n;for(s=new b(""+ ++i),n.addNode(s),n.root=s,o.push(s),a=0;a<e;a++){for(r=[],l=0;l<o.length;l++)for(c=o[l],d=0;d<t;d++)u=new b(""+ ++i),n.addLink(c,u),r.push(u);o=r}return n},createBalancedForest:function(e,t,n){var i,o,r,s,a,l,c,d,u,h,f;if(D.isUndefined(e)&&(e=3),D.isUndefined(t)&&(t=3),D.isUndefined(n)&&(n=5),i=new x.Graph,o=-1,r=[],e<=0||t<=0||n<=0)return i;for(a=0;a<n;a++)for(l=new b(""+ ++o),i.addNode(l),r=[l],c=0;c<e;c++){for(s=[],d=0;d<r.length;d++)for(u=r[d],h=0;h<t;h++)f=new b(""+ ++o),i.addLink(u,f),s.push(f);r=s}return i},createRandomConnectedGraph:function(e,t,n){var i,o,r,s,a,l,c,d,u,h;if(D.isUndefined(e)&&(e=40),D.isUndefined(t)&&(t=4),D.isUndefined(n)&&(n=!1),i=new x.Graph,o=-1,e<=0)return i;if(r=new b(""+ ++o),i.addNode(r),1===e)return i;if(e>1){for(s=1;s<e&&(a=i.takeRandomNode([],t),a);s++)l=i.addNode(""+s),i.addLink(a,l);if(!n&&e>1)for(c=D.randomInteger(1,e),d=0;d<c;d++)u=i.takeRandomNode([],t),h=i.takeRandomNode([],t),u&&h&&!i.areConnected(u,h)&&i.addLink(u,h);return i}},randomDiagram:function(e,t,n,i,o){var r=k.dataviz.diagram.Graph.Utils.createRandomConnectedGraph(t,n,i);y.Utils.createDiagramFromGraph(e,r,!1,o)}},k.deepExtend(x,{init:function(e){k.init(e,x.ui)},Point:A,Intersect:c,Geometry:p,Rect:a,Size:l,RectAlign:d,Matrix:h,MatrixVector:f,normalVariable:o,randomId:r,Dictionary:g,HashTable:m,Queue:v,Set:_,Node:b,Link:w,Graph:y,PathDefiner:s})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/diagram/svg.min",["kendo.drawing.min","dataviz/diagram/math.min"],e)}(function(){!function(e,t){function n(e,t){var n,i,o,r=this.options,s=!1;for(o=0;o<t.length;o++)i=t[o],n=e[i],H(n)&&r[i]!==n&&(r[i]=n,s=!0);return s}function i(e){return{x:e.x||0,y:e.y||0,width:e.width||0,height:e.height||0}}function o(e){if(e){var t=e;return N(t)&&(t={color:t}),t.color&&(t.color=r(t.color)),t}}function r(e){var t;return t=e!=q?new U.Color(e).toHex():e}function s(e,t){var n=t.x-e.x,i=t.y-e.y,o=U.util.deg(Math.atan2(i,n));return o}function a(e,t){return new U.Segment(new V.Point(e,t))}function l(e){if(e)return new V.Rect([e.x,e.y],[e.width,e.height])}var c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C,S,T,D,A,E,I=window.kendo,M=I.dataviz.diagram,R=I.Class,F=I.deepExtend,z=M.Point,P=M.Rect,B=M.Matrix,L=M.Utils,H=L.isNumber,N=L.isString,O=M.MatrixVector,V=I.geometry,U=I.drawing,W=U.util.defined,j=e.inArray,q="transparent",G={none:"none",arrowStart:"ArrowStart",filledCircle:"FilledCircle",arrowEnd:"ArrowEnd"},$=360,K="start",Y="end",Q="width",X="height",Z="x",J="y";M.Markers=G,c=R.extend({init:function(e,t){this.x=e,this.y=t},toMatrix:function(){return B.scaling(this.x,this.y)},toString:function(){return I.format("scale({0},{1})",this.x,this.y)},invert:function(){return new c(1/this.x,1/this.y)}}),d=R.extend({init:function(e,t){this.x=e,this.y=t},toMatrixVector:function(){return new O(0,0,0,0,this.x,this.y)},toMatrix:function(){return B.translation(this.x,this.y)},toString:function(){return I.format("translate({0},{1})",this.x,this.y)},plus:function(e){this.x+=e.x,this.y+=e.y},times:function(e){this.x*=e,this.y*=e},length:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},normalize:function(){0!==this.Length&&this.times(1/this.length())},invert:function(){return new d((-this.x),(-this.y))}}),u=R.extend({init:function(e,t,n){this.x=t||0,this.y=n||0,this.angle=e},toString:function(){return this.x&&this.y?I.format("rotate({0},{1},{2})",this.angle,this.x,this.y):I.format("rotate({0})",this.angle)},toMatrix:function(){return B.rotation(this.angle,this.x,this.y)},center:function(){return new z(this.x,this.y)},invert:function(){return new u($-this.angle,this.x,this.y)}}),u.ZERO=new u(0),u.create=function(e){return new u(e.angle,e.x,e.y)},u.parse=function(e){var t=e.slice(1,e.length-1).split(","),n=t[0],i=t[1],o=t[2],r=new u(n,i,o);return r},h=R.extend({init:function(e,n,i,o,r,s){this.translate=new d(e,n),i!==t&&o!==t&&(this.scale=new c(i,o)),r!==t&&(this.rotate=s?new u(r,s.x,s.y):new u(r))},toString:function(){var e=function(e){return e?""+e:""};return e(this.translate)+e(this.rotate)+e(this.scale)},render:function(e){e._transform=this,e._renderTransform()},toMatrix:function(){var e=B.unit();return this.translate&&(e=e.times(this.translate.toMatrix())),this.rotate&&(e=e.times(this.rotate.toMatrix())),this.scale&&(e=e.times(this.scale.toMatrix())),e},invert:function(){var e,n,i=this.rotate?this.rotate.invert():t,o=i?i.toMatrix():B.unit(),r=this.scale?this.scale.invert():t,s=r?r.toMatrix():B.unit(),a=new z((-this.translate.x),(-this.translate.y));return a=o.times(s).apply(a),e=new d(a.x,a.y),n=new h,n.translate=e,n.rotate=i,n.scale=r,n}}),f={_setScale:function(){var e=this.options,t=this._originWidth,n=this._originHeight,i=e.width/t,o=e.height/n;H(i)||(i=1),H(o)||(o=1),this._transform.scale=new c(i,o)},_setTranslate:function(){var e=this.options,t=e.x||0,n=e.y||0;this._transform.translate=new d(t,n)},_initSize:function(){var e=this.options,t=!1;e.autoSize!==!1&&(W(e.width)||W(e.height))&&(this._measure(!0),this._setScale(),t=!0),(W(e.x)||W(e.y))&&(this._setTranslate(),t=!0),t&&this._renderTransform()},_updateSize:function(e){var t=!1;return this.options.autoSize!==!1&&this._diffNumericOptions(e,[Q,X])&&(t=!0,this._measure(!0),this._setScale()),this._diffNumericOptions(e,[Z,J])&&(t=!0,this._setTranslate()),t&&this._renderTransform(),t}},p=R.extend({init:function(e){var t=this;t.options=F({},t.options,e),t.id=t.options.id,t._originSize=P.empty(),t._transform=new h},visible:function(e){return this.drawingContainer().visible(e)},redraw:function(e){e&&e.id&&(this.id=e.id)},position:function(e,n){var i=this.options;return W(e)?(W(n)?(i.x=e,i.y=n):e instanceof z&&(i.x=e.x,i.y=e.y),this._transform.translate=new d(i.x,i.y),this._renderTransform(),t):new z(i.x,i.y)},rotate:function(e,t){return W(e)&&(this._transform.rotate=new u(e,t.x,t.y),this._renderTransform()),this._transform.rotate||u.ZERO},drawingContainer:function(){return this.drawingElement},_renderTransform:function(){var e=this._transform.toMatrix();this.drawingContainer().transform(new V.Matrix(e.a,e.b,e.c,e.d,e.e,e.f))},_hover:function(){},_diffNumericOptions:n,_measure:function(e){var t,n,i;return!this._measured||e?(n=this._boundingBox()||new V.Rect,i=n.topLeft(),t=new P(i.x,i.y,n.width(),n.height()),this._originSize=t,this._originWidth=t.width,this._originHeight=t.height,this._measured=!0):t=this._originSize,t},_boundingBox:function(){return this.drawingElement.rawBBox()}}),m=p.extend({init:function(e){p.fn.init.call(this,e),e=this.options,e.fill=o(e.fill),e.stroke=o(e.stroke)},options:{stroke:{color:"gray",width:1},fill:{color:q}},fill:function(e,t){this._fill({color:r(e),opacity:t})},stroke:function(e,t,n){this._stroke({color:r(e),width:t,opacity:n})},redraw:function(e){var t,n;e&&(t=e.stroke,n=e.fill,t&&this._stroke(o(t)),n&&this._fill(o(n)),p.fn.redraw.call(this,e))},_hover:function(e){var t,n=this.drawingElement,i=this.options,r=i.hover;r&&r.fill&&(t=e?o(r.fill):i.fill,n.fill(t.color,t.opacity))},_stroke:function(e){var t,n=this.options;F(n,{stroke:e}),e=n.stroke,t=null,e.width>0&&(t={color:e.color,width:e.width,opacity:e.opacity,dashType:e.dashType}),this.drawingElement.options.set("stroke",t)},_fill:function(e){var t,n,i,o=this.options;F(o,{fill:e||{}}),t=o.fill,t.gradient?(n=t.gradient,i="radial"===n.type?U.RadialGradient:U.LinearGradient,this.drawingElement.fill(new i(n))):this.drawingElement.fill(t.color,t.opacity)}}),g=m.extend({init:function(e){e=this._textColor(e),m.fn.init.call(this,e),this._font(),this._initText(),this._initSize()},options:{fontSize:15,fontFamily:"sans-serif",stroke:{width:0},fill:{color:"black"},autoSize:!0},_initText:function(){var e=this.options;this.drawingElement=new U.Text(W(e.text)?e.text:"",new V.Point,{font:e.font}),this._fill(),this._stroke()},_textColor:function(e){return e&&e.color&&(e=F({},e,{fill:{color:e.color}})),e},_font:function(){var e,t=this.options;t.fontFamily&&W(t.fontSize)?(e=[],t.fontStyle&&e.push(t.fontStyle),t.fontWeight&&e.push(t.fontWeight),e.push(t.fontSize+(H(t.fontSize)?"px":"")),e.push(t.fontFamily),t.font=e.join(" ")):delete t.font},content:function(e){return this.drawingElement.content(e)},redraw:function(e){var t,n;e&&(t=!1,n=this.options,e=this._textColor(e),m.fn.redraw.call(this,e),(e.fontFamily||W(e.fontSize)||e.fontStyle||e.fontWeight)&&(F(n,{fontFamily:e.fontFamily,fontSize:e.fontSize,fontStyle:e.fontStyle,fontWeight:e.fontWeight}),this._font(),this.drawingElement.options.set("font",n.font),t=!0),e.text&&(this.content(e.text),t=!0),!this._updateSize(e)&&t&&this._initSize())}}),F(g.fn,f),v=m.extend({init:function(e){m.fn.init.call(this,e),this._initPath(),this._setPosition()},_setPosition:function(){var e=this.options,t=e.x,n=e.y;(W(t)||W(n))&&this.position(t||0,n||0)},redraw:function(e){e&&(m.fn.redraw.call(this,e),this._diffNumericOptions(e,[Q,X])&&this._drawPath(),this._diffNumericOptions(e,[Z,J])&&this._setPosition())},_initPath:function(){var e=this.options;this.drawingElement=new U.Path({stroke:e.stroke,closed:!0}),this._fill(),this._drawPath()},_drawPath:function(){var e=this.drawingElement,t=i(this.options),n=t.width,o=t.height;e.segments.elements([a(0,0),a(n,0),a(n,o),a(0,o)])}}),_=m.extend({init:function(e){m.fn.init.call(this,e);var t=this.options.anchor;this.anchor=new V.Point(t.x,t.y),this.createElement()},options:{stroke:{color:q,width:0},fill:{color:"black"}},_transformToPath:function(e,t){var n=t.transform();return e&&n&&(e=e.transformCopy(n)),e},redraw:function(e){e&&(e.position&&(this.options.position=e.position),m.fn.redraw.call(this,e))}}),b=_.extend({options:{radius:4,anchor:{x:0,y:0}},createElement:function(){var e=this.options;this.drawingElement=new U.Circle(new V.Circle(this.anchor,e.radius),{fill:e.fill,stroke:e.stroke})},positionMarker:function(e){var t,n,i=this.options,o=i.position,r=e.segments;t=o==K?r[0]:r[r.length-1],t&&(n=this._transformToPath(t.anchor(),e),this.drawingElement.transform(V.transform().translate(n.x,n.y)))}}),w=_.extend({options:{path:"M 0 0 L 10 5 L 0 10 L 3 5 z",anchor:{x:10,y:5}},createElement:function(){var e=this.options;this.drawingElement=U.Path.parse(e.path,{fill:e.fill,stroke:e.stroke})},positionMarker:function(e){var t,n,i=this._linePoints(e),o=i.start,r=i.end,a=V.transform();o&&a.rotate(s(o,r),r),r&&(t=this.anchor,n=r.clone().translate(-t.x,-t.y),a.translate(n.x,n.y)),this.drawingElement.transform(a)},_linePoints:function(e){var t,n,i,o,r,s=this.options,a=e.segments;if(s.position==K?(i=a[0],i&&(n=i.anchor(),t=i.controlOut(),o=a[1],!t&&o&&(t=o.anchor()))):(i=a[a.length-1],i&&(n=i.anchor(),t=i.controlIn(),r=a[a.length-2],!t&&r&&(t=r.anchor()))),n)return{start:this._transformToPath(t,e),end:this._transformToPath(n,e)}}}),y={_getPath:function(e){var t=this.drawingElement;if(t instanceof U.MultiPath&&(t=e==K?t.paths[0]:t.paths[t.paths.length-1]),t&&t.segments.length)return t},_normalizeMarkerOptions:function(e){var t=e.startCap,n=e.endCap;N(t)&&(e.startCap={type:t}),N(n)&&(e.endCap={type:n})},_removeMarker:function(e){var t=this._markers[e];t&&(this.drawingContainer().remove(t.drawingElement),delete this._markers[e])},_createMarkers:function(){var e=this.options;this._normalizeMarkerOptions(e),this._markers={},this._markers[K]=this._createMarker(e.startCap,K),this._markers[Y]=this._createMarker(e.endCap,Y)},_createMarker:function(e,n){var i,o,r=(e||{}).type,s=this._getPath(n);return s?(r==G.filledCircle?i=b:r==G.arrowStart||r==G.arrowEnd?i=w:this._removeMarker(n),i?(o=new i(F({},e,{position:n})),o.positionMarker(s),this.drawingContainer().append(o.drawingElement),o):t):(this._removeMarker(n),t)},_positionMarker:function(e){var t,n=this._markers[e];n&&(t=this._getPath(e),t?n.positionMarker(t):this._removeMarker(e))},_capMap:{start:"startCap",end:"endCap"},_redrawMarker:function(e,t,n){var i,o,r,s,a;return this._normalizeMarkerOptions(n),i=this.options,o=this._capMap[t],r=(i[o]||{}).type,s=n[o],a=!1,s?(i[o]=F({},i[o],s),s.type&&r!=s.type?(this._removeMarker(t),this._markers[t]=this._createMarker(i[o],t),a=!0):this._markers[t]&&this._markers[t].redraw(s)):e&&!this._markers[t]&&i[o]&&(this._markers[t]=this._createMarker(i[o],t),a=!0),a},_redrawMarkers:function(e,t){!this._redrawMarker(e,K,t)&&e&&this._positionMarker(K),!this._redrawMarker(e,Y,t)&&e&&this._positionMarker(Y)}},k=m.extend({init:function(e){m.fn.init.call(this,e),this.container=new U.Group,this._createElements(),this._initSize()},options:{autoSize:!0},drawingContainer:function(){return this.container},data:function(e){var n=this.options;return e?(n.data!=e&&(n.data=e,this._setData(e),this._initSize(),this._redrawMarkers(!0,{})),t):n.data},redraw:function(e){var t,n;e&&(m.fn.redraw.call(this,e),t=this.options,n=e.data,W(n)&&t.data!=n?(t.data=n,this._setData(n),this._updateSize(e)||this._initSize(),this._redrawMarkers(!0,e)):(this._updateSize(e),this._redrawMarkers(!1,e)))},_createElements:function(){var e=this.options;this.drawingElement=U.Path.parse(e.data||"",{stroke:e.stroke}),this._fill(),this.container.append(this.drawingElement),this._createMarkers()},_setData:function(e){var t=this.drawingElement,n=U.Path.parse(e||""),i=n.paths.slice(0);n.paths.elements([]),t.paths.elements(i)}}),F(k.fn,f),F(k.fn,y),x=m.extend({init:function(e){m.fn.init.call(this,e),this.container=new U.Group,this._initPath(),this._createMarkers()},drawingContainer:function(){return this.container},redraw:function(e){var t,n;e&&(e=e||{},t=e.from,n=e.to,t&&(this.options.from=t),n&&(this.options.to=n),t||n?(this._drawPath(),this._redrawMarkers(!0,e)):this._redrawMarkers(!1,e),m.fn.redraw.call(this,e))},_initPath:function(){var e=this.options,t=this.drawingElement=new U.Path({stroke:e.stroke});this._fill(),this._drawPath(),this.container.append(t)},_drawPath:function(){var e=this.options,t=this.drawingElement,n=e.from||new z,i=e.to||new z;t.segments.elements([a(n.x,n.y),a(i.x,i.y)])}}),F(x.fn,y),C=m.extend({init:function(e){m.fn.init.call(this,e),this.container=new U.Group,this._initPath(),this._createMarkers()},drawingContainer:function(){return this.container},points:function(e){var n=this.options;return e?(n.points=e,this._updatePath(),t):n.points},redraw:function(e){if(e){var t=e.points;m.fn.redraw.call(this,e),t&&this._pointsDiffer(t)?(this.points(t),this._redrawMarkers(!0,e)):this._redrawMarkers(!1,e)}},_initPath:function(){var e=this.options;this.drawingElement=new U.Path({stroke:e.stroke}),this._fill(),this.container.append(this.drawingElement),e.points&&this._updatePath()},_pointsDiffer:function(e){var t,n=this.options.points,i=n.length!==e.length;if(!i)for(t=0;t<e.length;t++)if(n[t].x!==e[t].x||n[t].y!==e[t].y){i=!0;break}return i},_updatePath:function(){var e,t,n=this.drawingElement,i=this.options,o=i.points,r=[];for(t=0;t<o.length;t++)e=o[t],r.push(a(e.x,e.y));n.segments.elements(r)},options:{points:[]}}),F(C.fn,y),S=p.extend({init:function(e){p.fn.init.call(this,e),this._initImage()},redraw:function(e){e&&(e.source&&this.drawingElement.src(e.source),this._diffNumericOptions(e,[Q,X,Z,J])&&this.drawingElement.rect(this._rect()),p.fn.redraw.call(this,e))},_initImage:function(){var e=this.options,t=this._rect();this.drawingElement=new U.Image(e.source,t,{})},_rect:function(){var e=i(this.options),t=new V.Point(e.x,e.y),n=new V.Size(e.width,e.height);return new V.Rect(t,n)}}),T=p.extend({init:function(e){this.children=[],p.fn.init.call(this,e),this.drawingElement=new U.Group,this._initSize()},options:{autoSize:!1},append:function(e){this.drawingElement.append(e.drawingContainer()),this.children.push(e),this._childrenChange=!0},remove:function(e){this._remove(e)&&(this._childrenChange=!0)},_remove:function(e){var t=j(e,this.children);if(t>=0)return this.drawingElement.removeAt(t),this.children.splice(t,1),!0},clear:function(){this.drawingElement.clear(),this.children=[],this._childrenChange=!0},toFront:function(e){var t,n;for(n=0;n<e.length;n++)t=e[n],this._remove(t)&&this.append(t)},toBack:function(e){this._reorderChildren(e,0)},toIndex:function(e,t){this._reorderChildren(e,t)},_reorderChildren:function(e,t){var n,i,o,r,s,a=this.drawingElement,l=a.children.slice(0),c=this.children,d=H(t);for(n=0;n<e.length;n++)s=e[n],r=s.drawingContainer(),i=j(s,c),i>=0&&(l.splice(i,1),c.splice(i,1),o=d?t:t[n],l.splice(o,0,r),c.splice(o,0,s));a.clear(),a.append.apply(a,l)},redraw:function(e){e&&(this._childrenChange?(this._childrenChange=!1,this._updateSize(e)||this._initSize()):this._updateSize(e),p.fn.redraw.call(this,e))},_boundingBox:function(){var e,t,n,i,o=this.children;for(i=0;i<o.length;i++)t=o[i],t.visible()&&t._includeInBBox!==!1&&(n=t.drawingContainer().clippedBBox(null),n&&(e=e?V.Rect.union(e,n):n));return e}}),F(T.fn,f),D=T.extend({init:function(e,t){this.children=[],p.fn.init.call(this,t),this.drawingElement=new U.Layout(l(e),t),this._initSize()},rect:function(e){if(e)this.drawingElement.rect(l(e));else{var t=this.drawingElement.rect();if(t)return new P(t.origin.x,t.origin.y,t.size.width,t.size.height)}},reflow:function(){this.drawingElement.reflow()},redraw:function(e){I.deepExtend(this.drawingElement.options,e),T.fn.redraw.call(this,e)}}),A=m.extend({init:function(e){m.fn.init.call(this,e),this._initCircle(),this._initSize()},redraw:function(e){if(e){var t=this.options;e.center&&(F(t,{center:e.center}),this._center.move(t.center.x,t.center.y)),this._diffNumericOptions(e,["radius"])&&this._circle.setRadius(t.radius),this._updateSize(e),m.fn.redraw.call(this,e)}},_initCircle:function(){var e,t=this.options,n=t.width,i=t.height,o=t.radius;W(o)||(W(n)||(n=i),W(i)||(i=n),t.radius=o=Math.min(n,i)/2),e=t.center||{x:o,y:o},this._center=new V.Point(e.x,e.y),this._circle=new V.Circle(this._center,o),this.drawingElement=new U.Circle(this._circle,{stroke:t.stroke}),this._fill()}}),F(A.fn,f),E=R.extend({init:function(e,t){t=t||{},this.element=e,this.surface=U.Surface.create(e,t),I.isFunction(this.surface.translate)&&(this.translate=this._translate),this.drawingElement=new U.Group,this._viewBox=new P(0,0,t.width,t.height),this.size(this._viewBox)},bounds:function(){var e=this.drawingElement.clippedBBox();return new P(0,0,e.width(),e.height())},size:function(e){var t=this._viewBox;return W(e)&&(t.width=e.width,t.height=e.height,this.surface.setSize(e)),{width:t.width,height:t.height}},_translate:function(e,t){var n=this._viewBox;return W(e)&&W(t)&&(n.x=e,n.y=t,this.surface.translate({x:e,y:t})),{x:n.x,y:n.y}},draw:function(){this.surface.draw(this.drawingElement)},append:function(e){return this.drawingElement.append(e.drawingContainer()),this},remove:function(e){this.drawingElement.remove(e.drawingContainer())},insertBefore:function(){},clear:function(){this.drawingElement.clear()},destroy:function(t){this.surface.destroy(),t&&e(this.element).remove()}}),I.deepExtend(M,{init:function(e){I.init(e,M.ui)},diffNumericOptions:n,Element:p,Scale:c,Translation:d,Rotation:u,Circle:A,Group:T,Rectangle:v,Canvas:E,Path:k,Layout:D,Line:x,MarkerBase:_,ArrowMarker:w,CircleMarker:b,Polyline:C,CompositeTransform:h,TextBlock:g,Image:S,VisualBase:m})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/diagram/services.min",["kendo.drawing.min","dataviz/diagram/svg.min"],e)}(function(){!function(e,t){function n(e,t){return t.charCodeAt(0)==e||t.toUpperCase().charCodeAt(0)==e}function i(e,t){var n;return e.x==-1&&e.y==-1?n=t.bottomRight():1==e.x&&1==e.y?n=t.topLeft():e.x==-1&&1==e.y?n=t.topRight():1==e.x&&e.y==-1?n=t.bottomLeft():0===e.x&&e.y==-1?n=t.bottom():0===e.x&&1==e.y?n=t.top():1==e.x&&0===e.y?n=t.left():e.x==-1&&0===e.y&&(n=t.right()),n}function o(e){var t=e.options.editable;return t&&t.drag!==!1}function r(e,t){var n,i,o,r;for(r=0;r<e.connectors.length;r++)if(n=e.connectors[r],i=n.position(),o=new j(i.x,i.y),o.inflate(re,re),o.contains(t))return n}function s(e){return e.ctrlKey===!1&&e.altKey===!1&&e.shiftKey===!1}var a,l,c,d,u,h,f,p,m,g,v,_,b,w,y,k,x,C,S,T,D,A,E,I,M,R,F,z,P,B,L,H,N=window.kendo,O=N.dataviz,V=O.diagram,U=N.Class,W=V.Group,j=V.Rect,q=V.Rectangle,G=V.Utils,$=G.isUndefined,K=V.Point,Y=V.Circle,Q=V.Ticker,X=N.deepExtend,Z=N.ui.Movable,J=N.support.browser,ee=N.drawing.util,te=ee.defined,ne=e.inArray,ie=e.proxy,oe={arrow:"default",grip:"pointer",cross:"pointer",add:"pointer",move:"move",select:"pointer",south:"s-resize",east:"e-resize",west:"w-resize",north:"n-resize",rowresize:"row-resize",colresize:"col-resize"},re=10,se="Auto",ae="Top",le="Right",ce="Left",de="Bottom",ue=10,he=10,fe="dragStart",pe="drag",me="dragEnd",ge="itemRotate",ve="itemBoundsChange",_e=5,be=5,we="mouseEnter",ye="mouseLeave",ke="zoomStart",xe="zoomEnd",Ce=-2e4,Se=2e4,Te=.9,De=.93,Ae=5,Ee="transparent",Ie="pan",Me="rotated",Re="source",Fe="target",ze={"-1":Re,1:Fe};V.Cursors=oe,a=N.Class.extend({init:function(e){this.layoutState=e,this.diagram=e.diagram},initState:function(){function e(e,t){var n=this.diagram.getShapeById(e);n&&(this.subjects.push(n),this.froms.push(n.bounds().topLeft()),this.tos.push(t.topLeft()))}this.froms=[],this.tos=[],this.subjects=[],this.layoutState.nodeMap.forEach(e,this)},update:function(e){if(!(this.subjects.length<=0))for(var t=0;t<this.subjects.length;t++)this.subjects[t].position(new K(this.froms[t].x+(this.tos[t].x-this.froms[t].x)*e,this.froms[t].y+(this.tos[t].y-this.froms[t].y)*e))}}),l=U.extend({init:function(e,t,n){this.animate=!$(n)&&n,this._initialState=e,this._finalState=t,this.title="Diagram layout"},undo:function(){this.setState(this._initialState)},redo:function(){this.setState(this._finalState)},setState:function(e){var t,n=e.diagram;this.animate?(e.linkMap.forEach(function(e,t){var i=n.getShapeById(e);i.visible(!1),i&&i.points(t)}),t=new Q,t.addAdapter(new a(e)),t.onComplete(function(){e.linkMap.forEach(function(e){var t=n.getShapeById(e);t.visible(!0)})}),t.play()):(e.nodeMap.forEach(function(e,t){var i=n.getShapeById(e);i&&i.position(t.topLeft())}),e.linkMap.forEach(function(e,t){var i=n.getShapeById(e);i&&i.points(t)}))}}),c=U.extend({init:function(e){this.units=[],this.title="Composite unit",e!==t&&this.units.push(e)},add:function(e){this.units.push(e)},undo:function(){for(var e=0;e<this.units.length;e++)this.units[e].undo()},redo:function(){for(var e=0;e<this.units.length;e++)this.units[e].redo()}}),d=U.extend({init:function(e,t,n){this.item=e,this._redoSource=t,this._redoTarget=n,te(t)&&(this._undoSource=e.source()),te(n)&&(this._undoTarget=e.target()),this.title="Connection Editing"},undo:function(){this._undoSource!==t&&this.item._updateConnector(this._undoSource,"source"),this._undoTarget!==t&&this.item._updateConnector(this._undoTarget,"target"),this.item.updateModel()},redo:function(){this._redoSource!==t&&this.item._updateConnector(this._redoSource,"source"),this._redoTarget!==t&&this.item._updateConnector(this._redoTarget,"target"),this.item.updateModel()}}),u=U.extend({init:function(e,t,n){this.item=e,this._undoSource=t,this._undoTarget=n,this._redoSource=e.source(),this._redoTarget=e.target(),this.title="Connection Editing"},undo:function(){this.item._updateConnector(this._undoSource,"source"),this.item._updateConnector(this._undoTarget,"target"),this.item.updateModel()},redo:function(){this.item._updateConnector(this._redoSource,"source"),this.item._updateConnector(this._redoTarget,"target"),this.item.updateModel()}}),h=U.extend({init:function(e){this.connection=e,this.diagram=e.diagram,this.targetConnector=e.targetConnector,this.title="Delete connection"},undo:function(){this.diagram._addConnection(this.connection,!1)},redo:function(){this.diagram.remove(this.connection,!1)}}),f=U.extend({init:function(e){this.shape=e,this.diagram=e.diagram,this.title="Deletion"},undo:function(){this.diagram._addShape(this.shape,!1),this.shape.select(!1)},redo:function(){this.shape.select(!1),this.diagram.remove(this.shape,!1)}}),p=U.extend({init:function(e,t,n){var i,o;for(this.shapes=e,this.undoStates=t,this.title="Transformation",this.redoStates=[],this.adorner=n,i=0;i<this.shapes.length;i++)o=this.shapes[i],this.redoStates.push(o.bounds())},undo:function(){var e,t;for(e=0;e<this.shapes.length;e++)t=this.shapes[e],
t.bounds(this.undoStates[e]),t.hasOwnProperty("layout")&&t.layout(t,this.redoStates[e],this.undoStates[e]),t.updateModel();this.adorner&&(this.adorner.refreshBounds(),this.adorner.refresh())},redo:function(){var e,t;for(e=0;e<this.shapes.length;e++)t=this.shapes[e],t.bounds(this.redoStates[e]),t.hasOwnProperty("layout")&&t.layout(t,this.undoStates[e],this.redoStates[e]),t.updateModel();this.adorner&&(this.adorner.refreshBounds(),this.adorner.refresh())}}),m=U.extend({init:function(e,t){this.connection=e,this.diagram=t,this.title="New connection"},undo:function(){this.diagram.remove(this.connection,!1)},redo:function(){this.diagram._addConnection(this.connection,!1)}}),g=U.extend({init:function(e,t){this.shape=e,this.diagram=t,this.title="New shape"},undo:function(){this.diagram.deselect(),this.diagram.remove(this.shape,!1)},redo:function(){this.diagram._addShape(this.shape,!1)}}),v=U.extend({init:function(e,t,n){this.initial=e,this.finalPos=t,this.diagram=n,this.title="Pan Unit"},undo:function(){this.diagram.pan(this.initial)},redo:function(){this.diagram.pan(this.finalPos)}}),_=U.extend({init:function(e,t,n){var i,o;for(this.shapes=t,this.undoRotates=n,this.title="Rotation",this.redoRotates=[],this.redoAngle=e._angle,this.adorner=e,this.center=e._innerBounds.center(),i=0;i<this.shapes.length;i++)o=this.shapes[i],this.redoRotates.push(o.rotate().angle)},undo:function(){var e,t;for(e=0;e<this.shapes.length;e++)t=this.shapes[e],t.rotate(this.undoRotates[e],this.center,!1),t.hasOwnProperty("layout")&&t.layout(t),t.updateModel();this.adorner&&(this.adorner._initialize(),this.adorner.refresh())},redo:function(){var e,t;for(e=0;e<this.shapes.length;e++)t=this.shapes[e],t.rotate(this.redoRotates[e],this.center,!1),t.hasOwnProperty("layout")&&t.layout(t),t.updateModel();this.adorner&&(this.adorner._initialize(),this.adorner.refresh())}}),b=U.extend({init:function(e,t,n){this.diagram=e,this.indices=n,this.items=t,this.title="Rotate Unit"},undo:function(){this.diagram._toIndex(this.items,this.indices)},redo:function(){this.diagram.toFront(this.items,!1)}}),w=U.extend({init:function(e,t,n){this.diagram=e,this.indices=n,this.items=t,this.title="Rotate Unit"},undo:function(){this.diagram._toIndex(this.items,this.indices)},redo:function(){this.diagram.toBack(this.items,!1)}}),y=N.Observable.extend({init:function(e){N.Observable.fn.init.call(this,e),this.bind(this.events,e),this.stack=[],this.index=0,this.capacity=100},events:["undone","redone"],begin:function(){this.composite=new c},cancel:function(){this.composite=t},commit:function(e){this.composite.units.length>0&&this._restart(this.composite,e),this.composite=t},addCompositeItem:function(e){this.composite?this.composite.add(e):this.add(e)},add:function(e,t){this._restart(e,t)},pop:function(){this.index>0&&(this.stack.pop(),this.index--)},count:function(){return this.stack.length},undo:function(){this.index>0&&(this.index--,this.stack[this.index].undo(),this.trigger("undone"))},redo:function(){this.stack.length>0&&this.index<this.stack.length&&(this.stack[this.index].redo(),this.index++,this.trigger("redone"))},_restart:function(e,t){this.stack.splice(this.index,this.stack.length-this.index),this.stack.push(e),t!==!1?this.redo():this.index++,this.stack.length>this.capacity&&(this.stack.splice(0,this.stack.length-this.capacity),this.index=this.capacity)},clear:function(){this.stack=[],this.index=0}}),k=U.extend({init:function(e){this.toolService=e},start:function(){},move:function(){},end:function(){},tryActivate:function(){return!1},getCursor:function(){return oe.arrow}}),x=k.extend({init:function(t){var n,i,o,r,s=this,a=N.support.mobileOS?De:Te;k.fn.init.call(s,t),n=s.toolService.diagram,i=n.canvas,o=n.scroller=s.scroller=e(n.scrollable).kendoMobileScroller({friction:a,velocityMultiplier:Ae,mousewheelScrolling:!1,zoom:!1,scroll:ie(s._move,s)}).data("kendoMobileScroller"),i.translate&&(s.movableCanvas=new Z(i.element)),r=function(e,t,n){e.makeVirtual(),e.virtualSize(t||Ce,n||Se)},r(o.dimensions.x),r(o.dimensions.y),o.disable()},tryActivate:function(e,t){var n=this.toolService,i=n.diagram.options.pannable,o=t.ctrlKey;return te(i.key)&&(o=i.key&&"none"!=i.key?t[i.key+"Key"]:s(t)&&!te(n.hoveredItem)),i!==!1&&o&&!te(n.hoveredAdorner)&&!te(n._hoveredConnector)},start:function(){this.scroller.enable()},move:function(){},_move:function(e){var t=this,n=t.toolService.diagram,i=n.canvas,o=new K(e.scrollLeft,e.scrollTop);i.translate?(n._storePan(o.times(-1)),t.movableCanvas.moveTo(o),i.translate(o.x,o.y)):o=o.plus(n._pan.times(-1)),n.trigger(Ie,{pan:o})},end:function(){this.scroller.disable()},getCursor:function(){return oe.move}}),C=U.extend({init:function(e){this.toolService=e},tryActivate:function(){return!0},start:function(e,t){var n=this.toolService,i=n.diagram,o=n.hoveredItem;o&&(n.selectSingle(o,t),o.adorner&&(this.adorner=o.adorner,this.handle=this.adorner._hitTest(e))),this.handle||(this.handle=i._resizingAdorner._hitTest(e),this.handle&&(this.adorner=i._resizingAdorner)),this.adorner&&(this.adorner.isDragHandle(this.handle)&&i.trigger(fe,{shapes:this.adorner.shapes,connections:[]})?(n.startPoint=e,n.end(e)):this.adorner.start(e))},move:function(e){this.adorner&&(this.adorner.move(this.handle,e),this.adorner.isDragHandle(this.handle)&&this.toolService.diagram.trigger(pe,{shapes:this.adorner.shapes,connections:[]}))},end:function(){var e,n=this.toolService.diagram,i=this.adorner;i&&(i.isDragHandle(this.handle)&&n.trigger(me,{shapes:i.shapes,connections:[]})?i.cancel():(e=i.stop(),e&&n.undoRedoService.add(e,!1))),this.adorner=t,this.handle=t},getCursor:function(e){return this.toolService.hoveredItem?this.toolService.hoveredItem._getCursor(e):oe.arrow}}),S=U.extend({init:function(e){this.toolService=e},tryActivate:function(e,t){var n=this.toolService,i=n.diagram.options.selectable,o=i&&i.multiple!==!1;return o&&(o=i.key&&"none"!=i.key?t[i.key+"Key"]:s(t)),o&&!te(n.hoveredItem)&&!te(n.hoveredAdorner)},start:function(e){var t=this.toolService.diagram;t.deselect(),t.selector.start(e)},move:function(e){var t=this.toolService.diagram;t.selector.move(e)},end:function(e,t){var n=this.toolService.diagram,i=this.toolService.hoveredItem,o=n.selector.bounds();i&&i.isSelected||t.ctrlKey||n.deselect(),o.isEmpty()||n.selectArea(o),n.selector.end()},getCursor:function(){return oe.arrow}}),T=U.extend({init:function(e){this.toolService=e,this.type="ConnectionTool"},tryActivate:function(){return this.toolService._hoveredConnector},start:function(e,t){var n=this.toolService,i=n.diagram,r=n._hoveredConnector,s=i._createConnection({},r._c,e);o(s)&&!i.trigger(fe,{shapes:[],connections:[s],connectionHandle:Fe})&&i._addConnection(s)?(n._connectionManipulation(s,r._c.shape,!0),n._removeHover(),n.selectSingle(n.activeConnection,t),"touchmove"==t.type&&(i._cachedTouchTarget=r.visual)):(s.source(null),n.end(e))},move:function(e){var t=this.toolService,n=t.activeConnection;return n.target(e),t.diagram.trigger(pe,{shapes:[],connections:[n],connectionHandle:Fe}),!0},end:function(e){var t,n=this.toolService,i=n.diagram,o=n.activeConnection,r=n.hoveredItem,s=n._hoveredConnector,a=i._cachedTouchTarget;o&&(t=s&&s._c!=o.sourceConnector?s._c:r&&r instanceof V.Shape?r.getConnector(se)||r.getConnector(e):e,o.target(t),i.trigger(me,{shapes:[],connections:[o],connectionHandle:Fe})?(i.remove(o,!1),i.undoRedoService.pop()):(o.updateModel(),i._syncConnectionChanges()),n._connectionManipulation(),a&&(i._connectorsAdorner.visual.remove(a),i._cachedTouchTarget=null))},getCursor:function(){return oe.arrow}}),D=U.extend({init:function(e){this.toolService=e,this.type="ConnectionTool"},tryActivate:function(e,t){var n=this.toolService,i=n.diagram,o=i.options.selectable,r=n.hoveredItem,s=o!==!1&&r&&r.path&&!(r.isSelected&&t.ctrlKey);return s&&(this._c=r),s},start:function(e,t){var n,i,r,s=this.toolService,a=this._c;s.selectSingle(a,t),n=a.adorner,n&&(i=n._hitTest(e),r=ze[i]),o(a)&&n&&!s.diagram.trigger(fe,{shapes:[],connections:[a],connectionHandle:r})?(this.handle=i,this.handleName=r,n.start(e)):(s.startPoint=e,s.end(e))},move:function(e){var t=this._c.adorner;if(o(this._c)&&t)return t.move(this.handle,e),this.toolService.diagram.trigger(pe,{shapes:[],connections:[this._c],connectionHandle:this.handleName}),!0},end:function(e){var t,n=this._c,i=n.adorner,r=this.toolService,s=r.diagram;i&&o(n)&&(t=i.stop(e),s.trigger(me,{shapes:[],connections:[n],connectionHandle:this.handleName})?t.undo():(s.undoRedoService.add(t,!1),n.updateModel(),s._syncConnectionChanges()))},getCursor:function(){return oe.move}}),A=U.extend({init:function(e){this.diagram=e,this.tools=[new x(this),new D(this),new T(this),new S(this),new C(this)],this.activeTool=t},start:function(e,t){return t=X({},t),this.activeTool&&this.activeTool.end(e,t),this._updateHoveredItem(e),this._activateTool(e,t),this.activeTool.start(e,t),this._updateCursor(e),this.diagram.focus(),this.diagram.canvas.surface.suspendTracking(),this.startPoint=e,!0},move:function(e,t){t=X({},t);var n=!0;return this.activeTool&&(n=this.activeTool.move(e,t)),n&&this._updateHoveredItem(e),this._updateCursor(e),!0},end:function(e,n){return n=X({},n),this.activeTool&&this.activeTool.end(e,n),this.diagram.canvas.surface.resumeTracking(),this.activeTool=t,this._updateCursor(e),!0},keyDown:function(e,t){var i,o=this.diagram;if(t=X({ctrlKey:!1,metaKey:!1,altKey:!1},t),!t.ctrlKey&&!t.metaKey||t.altKey){if(46===e||8===e)return i=this.diagram._triggerRemove(o.select()),i.length&&(this.diagram.remove(i,!0),this.diagram._syncChanges(),this.diagram._destroyToolBar()),!0;if(27===e)return this._discardNewConnection(),o.deselect(),o._destroyToolBar(),!0}else{if(n(e,"a"))return o.selectAll(),o._destroyToolBar(),!0;if(n(e,"z"))return o.undo(),o._destroyToolBar(),!0;if(n(e,"y"))return o.redo(),o._destroyToolBar(),!0;n(e,"c")?(o.copy(),o._destroyToolBar()):n(e,"x")?(o.cut(),o._destroyToolBar()):n(e,"v")?(o.paste(),o._destroyToolBar()):n(e,"l")?(o.layout(),o._destroyToolBar()):n(e,"d")&&(o._destroyToolBar(),o.copy(),o.paste())}},wheel:function(e,t){var n=this.diagram,i=t.delta,o=n.zoom(),r=n.options,s=r.zoomRate,a={point:e,meta:t,zoom:o};if(!n.trigger(ke,a))return i<0?o+=s:o-=s,o=N.dataviz.round(Math.max(r.zoomMin,Math.min(r.zoomMax,o)),2),a.zoom=o,n.zoom(o,a),n.trigger(xe,a),!0},setTool:function(e,t){e.toolService=this,this.tools[t]=e},selectSingle:function(e,t){var n,i=this.diagram,o=i.options.selectable;o&&!e.isSelected&&e.options.selectable!==!1&&(n=t.ctrlKey&&o.multiple!==!1,i.select(e,{addToSelection:n}))},_discardNewConnection:function(){this.newConnection&&(this.diagram.remove(this.newConnection),this.newConnection=t)},_activateTool:function(e,t){var n,i;for(n=0;n<this.tools.length;n++)if(i=this.tools[n],i.tryActivate(e,t)){this.activeTool=i;break}},_updateCursor:function(e){var t=this.diagram.element,n=this.activeTool?this.activeTool.getCursor(e):this.hoveredAdorner?this.hoveredAdorner._getCursor(e):this.hoveredItem?this.hoveredItem._getCursor(e):oe.arrow;t.css({cursor:n}),J.msie&&7==J.version&&(t[0].style.cssText=t[0].style.cssText)},_connectionManipulation:function(e,n,i){this.activeConnection=e,this.disabledShape=n,this.newConnection=i?this.activeConnection:t},_updateHoveredItem:function(e){var n=this._hitTest(e),i=this.diagram;n==this.hoveredItem||this.disabledShape&&n==this.disabledShape||(this.hoveredItem&&(i.trigger(ye,{item:this.hoveredItem}),this.hoveredItem._hover(!1)),n&&n.options.enable?(i.trigger(we,{item:n}),this.hoveredItem=n,this.hoveredItem._hover(!0)):this.hoveredItem=t)},_removeHover:function(){this.hoveredItem&&(this.hoveredItem._hover(!1),this.hoveredItem=t)},_hitTest:function(e){var n,i,o,r,s=this.diagram;if(this._hoveredConnector&&(this._hoveredConnector._hover(!1),this._hoveredConnector=t),s._connectorsAdorner._visible&&(n=s._connectorsAdorner._hitTest(e)))return n;if(n=this.diagram._resizingAdorner._hitTest(e)){if(this.hoveredAdorner=s._resizingAdorner,0!==n.x||0!==n.y)return;n=t}else this.hoveredAdorner=t;if(!this.activeTool||"ConnectionTool"!==this.activeTool.type){for(r=[],o=0;o<s._selectedItems.length;o++)i=s._selectedItems[o],i instanceof V.Connection&&r.push(i);n=this._hitTestItems(r,e)}return n||this._hitTestElements(e)},_hitTestElements:function(e){var t,n,i,o,s=this.diagram,a=this._hitTestItems(s.shapes,e),l=this._hitTestItems(s.connections,e);return this.activeTool&&"ConnectionTool"==this.activeTool.type||!a||!l||r(a,e)||(n=s.mainLayer,i=ne(a.visual,n.children),o=ne(l.visual,n.children),t=i>o?a:l),t||a||l},_hitTestItems:function(e,t){var n,i,o;for(n=e.length-1;n>=0;n--)if(i=e[n],o=i._hitTest(t))return o}}),E=N.Class.extend({init:function(){}}),I=E.extend({init:function(e){var t=this;E.fn.init.call(t),this.connection=e},hitTest:function(e){var t=this.getBounds().inflate(re);return!!t.contains(e)&&V.Geometry.distanceToPolyline(e,this.connection.allPoints())<re},getBounds:function(){var e,t=this.connection.allPoints(),n=t[0],i=t[t.length-1],o=Math.max(n.x,i.x),r=Math.min(n.x,i.x),s=Math.min(n.y,i.y),a=Math.max(n.y,i.y);for(e=1;e<t.length-1;++e)o=Math.max(o,t[e].x),r=Math.min(r,t[e].x),s=Math.min(s,t[e].y),a=Math.max(a,t[e].y);return new j(r,s,o-r,a-s)}}),M=I.extend({init:function(e){var t=this;I.fn.init.call(t),this.connection=e},route:function(){}}),R=I.extend({SAME_SIDE_DISTANCE_RATIO:5,init:function(e){var t=this;I.fn.init.call(t),this.connection=e},routePoints:function(e,t,n,i){var o;return o=n&&i?this._connectorPoints(e,t,n,i):this._floatingPoints(e,t,n)},route:function(){var e=this.connection._resolvedSourceConnector,t=this.connection._resolvedTargetConnector,n=this.connection.sourcePoint(),i=this.connection.targetPoint(),o=this.routePoints(n,i,e,t);this.connection.points(o)},_connectorSides:[{name:"Top",axis:"y",boundsPoint:"topLeft",secondarySign:1},{name:"Left",axis:"x",boundsPoint:"topLeft",secondarySign:1},{name:"Bottom",axis:"y",boundsPoint:"bottomRight",secondarySign:-1},{name:"Right",axis:"x",boundsPoint:"bottomRight",secondarySign:-1}],_connectorSide:function(e,t){var n,i,o,r,s,a=e.position(),l=e.shape.bounds(Me),c={topLeft:l.topLeft(),bottomRight:l.bottomRight()},d=this._connectorSides,u=ee.MAX_NUM;for(s=0;s<d.length;s++)r=d[s],o=r.axis,n=Math.round(Math.abs(a[o]-c[r.boundsPoint][o])),n<u?(u=n,i=r):n===u&&(a[o]-t[o])*r.secondarySign>(a[i.axis]-t[i.axis])*i.secondarySign&&(i=r);return i.name},_sameSideDistance:function(e){var t=e.shape.bounds(Me);return Math.min(t.width,t.height)/this.SAME_SIDE_DISTANCE_RATIO},_connectorPoints:function(e,t,n,i){var o,r,s=this._connectorSide(n,t),a=this._connectorSide(i,e),l=t.x-e.x,c=t.y-e.y,d=this._sameSideDistance(n),u=[];return s===ae||s==de?a==ae||a==de?s==a?(r=s==ae?Math.min(e.y,t.y)-d:Math.max(e.y,t.y)+d,u=[new K(e.x,r),new K(t.x,r)]):u=[new K(e.x,e.y+c/2),new K(t.x,e.y+c/2)]:u=[new K(e.x,t.y)]:a==ce||a==le?s==a?(o=s==ce?Math.min(e.x,t.x)-d:Math.max(e.x,t.x)+d,u=[new K(o,e.y),new K(o,t.y)]):u=[new K(e.x+l/2,e.y),new K(e.x+l/2,e.y+c)]:u=[new K(t.x,e.y)],u},_floatingPoints:function(e,t,n){var i,o,r,s=n?this._connectorSide(n,t):null,a=this._startHorizontal(e,t,s),l=[e,e,t,t],c=t.x-e.x,d=t.y-e.y,u=l.length;for(r=1;r<u-1;++r)a?r%2!==0?(i=c/(u/2),o=0):(i=0,o=d/((u-1)/2)):r%2!==0?(i=0,o=d/(u/2)):(i=c/((u-1)/2),o=0),l[r]=new K(l[r-1].x+i,l[r-1].y+o);return r--,l[u-2]=a&&r%2!==0||!a&&r%2===0?new K(l[u-1].x,l[u-2].y):new K(l[u-2].x,l[u-1].y),[l[1],l[2]]},_startHorizontal:function(e,t,n){var i;return i=null!==n&&(n===le||n===ce)||Math.abs(e.x-t.x)>Math.abs(e.y-t.y)}}),F=U.extend({init:function(e,t){var n=this;n.diagram=e,n.options=X({},n.options,t),n.visual=new W,n.diagram._adorners.push(n)},refresh:function(){}}),z=F.extend({init:function(e,t){var n,i,o,r=this;r.connection=e,n=r.connection.diagram,r._ts=n.toolService,F.fn.init.call(r,n,t),i=r.connection.sourcePoint(),o=r.connection.targetPoint(),r.spVisual=new Y(X(r.options.handles,{center:i})),r.epVisual=new Y(X(r.options.handles,{center:o})),r.visual.append(r.spVisual),r.visual.append(r.epVisual)},options:{handles:{}},_getCursor:function(){return oe.move},start:function(e){switch(this.handle=this._hitTest(e),this.startPoint=e,this._initialSource=this.connection.source(),this._initialTarget=this.connection.target(),this.handle){case-1:this.connection.targetConnector&&this._ts._connectionManipulation(this.connection,this.connection.targetConnector.shape);break;case 1:this.connection.sourceConnector&&this._ts._connectionManipulation(this.connection,this.connection.sourceConnector.shape)}},move:function(e,t){switch(e){case-1:this.connection.source(t);break;case 1:this.connection.target(t);break;default:var n=t.minus(this.startPoint);this.startPoint=t,this.connection.sourceConnector||this.connection.source(this.connection.sourcePoint().plus(n)),this.connection.targetConnector||this.connection.target(this.connection.targetPoint().plus(n))}return this.refresh(),!0},stop:function(e){var n,i=this.diagram.toolService,o=i.hoveredItem;return n=i._hoveredConnector?i._hoveredConnector._c:o&&o instanceof V.Shape?o.getConnector(se)||o.getConnector(e):e,this.handle===-1?this.connection.source(n):1===this.handle&&this.connection.target(n),this.handle=t,this._ts._connectionManipulation(),new u(this.connection,this._initialSource,this._initialTarget)},_hitTest:function(e){var t=this.connection.sourcePoint(),n=this.connection.targetPoint(),i=this.options.handles.width/2+re,o=this.options.handles.height/2+re,r=t.distanceTo(e),s=n.distanceTo(e),a=new j(t.x,t.y).inflate(i,o).contains(e),l=new j(n.x,n.y).inflate(i,o).contains(e),c=0;return a&&(!l||r<s)?c=-1:l&&(!a||s<r)&&(c=1),c},refresh:function(){this.spVisual.redraw({center:this.diagram.modelToLayer(this.connection.sourcePoint())}),this.epVisual.redraw({center:this.diagram.modelToLayer(this.connection.targetPoint())})}}),P=F.extend({init:function(e,t){var n=this;F.fn.init.call(n,e,t),n._refreshHandler=function(e){e.item==n.shape&&n.refresh()}},show:function(e){var t,n,i,o=this;for(o._visible=!0,o.shape=e,o.diagram.bind(ve,o._refreshHandler),t=e.connectors.length,o.connectors=[],o._clearVisual(),n=0;n<t;n++)i=new H(e.connectors[n]),o.connectors.push(i),o.visual.append(i.visual);o.visual.visible(!0),o.refresh()},_clearVisual:function(){var e=this;e.diagram._cachedTouchTarget?e._keepCachedTouchTarget():e.visual.clear()},_keepCachedTouchTarget:function(){var e,t=this,n=t.visual.children,i=n.length,o=ne(t.diagram._cachedTouchTarget,n);for(e=i-1;e>=0;e--)e!=o&&t.visual.remove(n[e])},destroy:function(){var e=this;e.diagram.unbind(ve,e._refreshHandler),e.shape=t,e._visible=t,e.visual.visible(!1)},_hitTest:function(e){var t,n;for(n=0;n<this.connectors.length;n++)if(t=this.connectors[n],t._hitTest(e)){t._hover(!0),this.diagram.toolService._hoveredConnector=t;break}},refresh:function(){if(this.shape){var t=this.shape.bounds();t=this.diagram.modelToLayer(t),this.visual.position(t.topLeft()),e.each(this.connectors,function(){this.refresh()})}}}),B=F.extend({init:function(e,t){var n=this;F.fn.init.call(n,e,t),n._manipulating=!1,n.map=[],n.shapes=[],n._initSelection(),n._createHandles(),n.redraw(),n.diagram.bind("select",function(e){n._initialize(e.selected)}),n._refreshHandler=function(){n._internalChange||(n.refreshBounds(),n.refresh())},n._rotatedHandler=function(){1==n.shapes.length&&(n._angle=n.shapes[0].rotate().angle),n._refreshHandler()},n.diagram.bind(ve,n._refreshHandler).bind(ge,n._rotatedHandler),n.refreshBounds(),n.refresh()},options:{handles:{fill:{color:"#fff"},stroke:{color:"#282828"},height:7,width:7,hover:{fill:{color:"#282828"},stroke:{color:"#282828"}}},selectable:{stroke:{color:"#778899",width:1,dashType:"dash"},fill:{color:Ee}},offset:10},_initSelection:function(){var e=this,t=e.diagram,n=t.options.selectable,i=X({},e.options.selectable,n);e.rect=new q(i),e.visual.append(e.rect)},_resizable:function(){return this.options.editable&&this.options.editable.resize!==!1},_handleOptions:function(){return(this.options.editable.resize||{}).handles||this.options.handles},_createHandles:function(){var e,t,n,i;if(this._resizable())for(e=this._handleOptions(),i=-1;i<=1;i++)for(n=-1;n<=1;n++)0===i&&0===n||(t=new q(e),t.drawingElement._hover=ie(this._hover,this),this.map.push({x:i,y:n,visual:t}),this.visual.append(t))},bounds:function(e){return e?(this._innerBounds=e.clone(),this._bounds=this.diagram.modelToLayer(e).inflate(this.options.offset,this.options.offset),t):this._bounds},_hitTest:function(e){var t,n,i,o,r=this.diagram.modelToLayer(e),s=this.map.length;if(this._angle&&(r=r.clone().rotate(this._bounds.center(),this._angle)),this._resizable())for(t=0;t<s;t++)if(o=this.map[t],n=new K(o.x,o.y),i=this._getHandleBounds(n),i.offset(this._bounds.x,this._bounds.y),i.contains(r))return n;if(this._bounds.contains(r))return new K(0,0)},_getHandleBounds:function(e){if(this._resizable()){var t=this._handleOptions(),n=t.width,i=t.height,o=new j(0,0,n,i);return e.x<0?o.x=-n/2:0===e.x?o.x=Math.floor(this._bounds.width/2)-n/2:e.x>0&&(o.x=this._bounds.width+1-n/2),e.y<0?o.y=-i/2:0===e.y?o.y=Math.floor(this._bounds.height/2)-i/2:e.y>0&&(o.y=this._bounds.height+1-i/2),o}},_getCursor:function(e){var t,n=this._hitTest(e);if(n&&n.x>=-1&&n.x<=1&&n.y>=-1&&n.y<=1&&this._resizable()){if(t=this._angle,t&&(t=360-t,n.rotate(new K(0,0),t),n=new K(Math.round(n.x),Math.round(n.y))),n.x==-1&&n.y==-1)return"nw-resize";if(1==n.x&&1==n.y)return"se-resize";if(n.x==-1&&1==n.y)return"sw-resize";if(1==n.x&&n.y==-1)return"ne-resize";if(0===n.x&&n.y==-1)return"n-resize";if(0===n.x&&1==n.y)return"s-resize";if(1==n.x&&0===n.y)return"e-resize";if(n.x==-1&&0===n.y)return"w-resize"}return this._manipulating?oe.move:oe.select},_initialize:function(){var e,t,n=this,i=n.diagram.select();for(n.shapes=[],e=0;e<i.length;e++)t=i[e],t instanceof V.Shape&&(n.shapes.push(t),t._rotationOffset=new K);n._angle=1==n.shapes.length?n.shapes[0].rotate().angle:0,n._startAngle=n._angle,n._rotates(),n._positions(),n.refreshBounds(),n.refresh(),n.redraw()},_rotates:function(){var e,t,n=this;for(n.initialRotates=[],e=0;e<n.shapes.length;e++)t=n.shapes[e],n.initialRotates.push(t.rotate().angle)},_positions:function(){var e,t,n=this;for(n.initialStates=[],e=0;e<n.shapes.length;e++)t=n.shapes[e],n.initialStates.push(t.bounds())},_hover:function(e,t){if(this._resizable()){var n=this._handleOptions(),i=n.hover,o=n.stroke,r=n.fill;e&&G.isDefined(i.stroke)&&(o=X({},o,i.stroke)),e&&G.isDefined(i.fill)&&(r=i.fill),t.stroke(o.color,o.width,o.opacity),t.fill(r.color,r.opacity)}},start:function(e){var t,n;for(this._sp=e,this._cp=e,this._lp=e,this._manipulating=!0,this._internalChange=!0,this.shapeStates=[],t=0;t<this.shapes.length;t++)n=this.shapes[t],this.shapeStates.push(n.bounds())},redraw:function(){var e,t,n=this._resizable();for(e=0;e<this.map.length;e++)t=this.map[e],t.visual.visible(n)},angle:function(e){return te(e)&&(this._angle=e),this._angle},rotate:function(){var e,t,n=this._innerBounds.center(),i=this.angle();for(this._internalChange=!0,e=0;e<this.shapes.length;e++)t=this.shapes[e],i=(i+this.initialRotates[e]-this._startAngle)%360,t.rotate(i,n);this.refresh()},move:function(e,n){var r,s,a,l,c,d,u,h,f,p,m,g,v,_,b=new K,w=new K,y=0;if(e.y===-2&&e.x===-1){for(l=this._innerBounds.center(),this._angle=this._truncateAngle(G.findAngle(l,n)),d=0;d<this.shapes.length;d++)c=this.shapes[d],u=(this._angle+this.initialRotates[d]-this._startAngle)%360,c.rotate(u,l),c.hasOwnProperty("layout")&&c.layout(c),this._rotating=!0;this.refresh()}else{if(this.shouldSnap()){if(g=this._truncateDistance(n.minus(this._lp)),0===g.x&&0===g.y)return this._cp=n,t;r=g,this._lp=new K(this._lp.x+g.x,this._lp.y+g.y)}else r=n.minus(this._cp);for(this.isDragHandle(e)?(w=b=r,s=!0):(this._angle&&r.rotate(new K(0,0),this._angle),e.x==-1?b.x=r.x:1==e.x&&(w.x=r.x),e.y==-1?b.y=r.y:1==e.y&&(w.y=r.y)),s||(f=i(e,this._innerBounds),p=(this._innerBounds.width+r.x*e.x)/this._innerBounds.width,m=(this._innerBounds.height+r.y*e.y)/this._innerBounds.height),d=0;d<this.shapes.length;d++){if(c=this.shapes[d],a=c.bounds(),s){if(!o(c))continue;h=this._displaceBounds(a,b,w,s)}else h=a.clone(),h.scale(p,m,f,this._innerBounds.center(),c.rotate().angle),v=h.center(),v.rotate(a.center(),-this._angle),h=new j(v.x-h.width/2,v.y-h.height/2,h.width,h.height);h.width>=c.options.minWidth&&h.height>=c.options.minHeight&&(_=a,c.bounds(h),c.hasOwnProperty("layout")&&c.layout(c,_,h),_.width===h.width&&_.height===h.height||c.rotate(c.rotate().angle),y+=1)}y&&(y==d?(h=this._displaceBounds(this._innerBounds,b,w,s),this.bounds(h)):this.refreshBounds(),this.refresh()),this._positions()}this._cp=n},isDragHandle:function(e){return 0===e.x&&0===e.y},cancel:function(){var e,n=this.shapes,i=this.shapeStates;for(e=0;e<n.length;e++)n[e].bounds(i[e]);this.refreshBounds(),this.refresh(),this._manipulating=t,this._internalChange=t,this._rotating=t},_truncatePositionToGuides:function(e){return this.diagram.ruler?this.diagram.ruler.truncatePositionToGuides(e):e},_truncateSizeToGuides:function(e){return this.diagram.ruler?this.diagram.ruler.truncateSizeToGuides(e):e},_truncateAngle:function(e){var t=this.snapOptions(),n=Math.max(t.angle||he,be);return t?Math.floor(e%360/n)*n:e%360},_truncateDistance:function(e){var t,n;return e instanceof V.Point?new V.Point(this._truncateDistance(e.x),this._truncateDistance(e.y)):(t=this.snapOptions()||{},n=Math.max(t.size||ue,_e),t?Math.floor(e/n)*n:e)},snapOptions:function(){var e=this.diagram.options.editable,t=((e||{}).drag||{}).snap||{};return t},shouldSnap:function(){var e=this.diagram.options.editable,t=(e||{}).drag,n=(t||{}).snap;return e!==!1&&t!==!1&&n!==!1},_displaceBounds:function(e,t,n,i){var o,r=e.topLeft().plus(t),s=e.bottomRight().plus(n),a=j.fromPoints(r,s);return i||(o=a.center(),o.rotate(e.center(),-this._angle),a=new j(o.x-a.width/2,o.y-a.height/2,a.width,a.height)),a},stop:function(){var e,n,i,o;if(this._cp!=this._sp)if(this._rotating)e=new _(this,this.shapes,this.initialRotates),this._rotating=!1;else if(this._diffStates()){if(this.diagram.ruler)for(n=0;n<this.shapes.length;n++)i=this.shapes[n],o=i.bounds(),o=this._truncateSizeToGuides(this._truncatePositionToGuides(o)),i.bounds(o),this.refreshBounds(),this.refresh();for(n=0;n<this.shapes.length;n++)i=this.shapes[n],i.updateModel();e=new p(this.shapes,this.shapeStates,this),this.diagram._syncShapeChanges()}return this._manipulating=t,this._internalChange=t,this._rotating=t,e},_diffStates:function(){var e,t=this.shapes,n=this.shapeStates;for(e=0;e<t.length;e++)if(!t[e].bounds().equals(n[e]))return!0;return!1},refreshBounds:function(){var e=1==this.shapes.length?this.shapes[0].bounds().clone():this.diagram.boundingBox(this.shapes,!0);this.bounds(e)},refresh:function(){var t,n,i,o,r=this;this.shapes.length>0?(n=this.bounds(),this.visual.visible(!0),this.visual.position(n.topLeft()),e.each(this.map,function(){t=r._getHandleBounds(new K(this.x,this.y)),this.visual.position(t.topLeft())}),this.visual.position(n.topLeft()),i=new K(n.width/2,n.height/2),this.visual.rotate(this._angle,i),this.rect.redraw({width:n.width,height:n.height}),this.rotationThumb&&(o=this.options.editable.rotate.thumb,this._rotationThumbBounds=new j(n.center().x,n.y+o.y,0,0).inflate(o.width),this.rotationThumb.redraw({x:n.width/2-o.width/2}))):this.visual.visible(!1)}}),L=U.extend({init:function(e){var t=e.options.selectable;this.options=X({},this.options,t),this.visual=new q(this.options),this.diagram=e},options:{stroke:{color:"#778899",width:1,dashType:"dash"},fill:{color:Ee}},start:function(e){this._sp=this._ep=e,this.refresh(),this.diagram._adorn(this,!0)},end:function(){this._sp=this._ep=t,this.diagram._adorn(this,!1)},bounds:function(e){return e&&(this._bounds=e),this._bounds},move:function(e){this._ep=e,this.refresh()},refresh:function(){if(this._sp){var e=j.fromPoints(this.diagram.modelToLayer(this._sp),this.diagram.modelToLayer(this._ep));this.bounds(j.fromPoints(this._sp,this._ep)),this.visual.position(e.topLeft()),this.visual.redraw({height:e.height+1,width:e.width+1})}}}),H=U.extend({init:function(e){this.options=X({},e.options),this._c=e,this.visual=new Y(this.options),this.refresh()},_hover:function(e){var t=this.options,n=t.hover,i=t.stroke,o=t.fill;e&&G.isDefined(n.stroke)&&(i=X({},i,n.stroke)),e&&G.isDefined(n.fill)&&(o=n.fill),this.visual.redraw({stroke:i,fill:o})},refresh:function(){var e=this._c.shape.diagram.modelToView(this._c.position()),t=e.minus(this._c.shape.bounds("transformed").topLeft()),n=new j(e.x,e.y,0,0);n.inflate(this.options.width/2,this.options.height/2),this._visualBounds=n,this.visual.redraw({center:new K(t.x,t.y)})},_hitTest:function(e){var t=this._c.shape.diagram.modelToView(e);return this._visualBounds.contains(t)}}),X(V,{CompositeUnit:c,TransformUnit:p,PanUndoUnit:v,AddShapeUnit:g,AddConnectionUnit:m,DeleteShapeUnit:f,DeleteConnectionUnit:h,ConnectionEditAdorner:z,ConnectionTool:T,ConnectorVisual:H,UndoRedoService:y,ResizingAdorner:B,Selector:L,ToolService:A,ConnectorsAdorner:P,LayoutUndoUnit:l,ConnectionEditUnit:d,ToFrontUnit:b,ToBackUnit:w,ConnectionRouterBase:E,PolylineRouter:M,CascadingRouter:R,SelectionTool:S,ScrollerTool:x,PointerTool:C,ConnectionEditTool:D,RotateUnit:_})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/diagram/layout.min",["dataviz/diagram/math.min"],e)}(function(){!function(e,t){var n=window.kendo,i=n.dataviz.diagram,o=i.Graph,r=i.Node,s=i.Link,a=n.deepExtend,l=i.Size,c=i.Rect,d=i.Dictionary,u=i.Set,h=i.Graph,f=i.Utils,p=i.Point,m=1e-6,g=Math.PI/180,v=f.contains,_=e.grep,b=n.Class.extend({defaultOptions:{type:"Tree",subtype:"Down",roots:null,animate:!1,limitToView:!1,friction:.9,nodeDistance:50,iterations:300,horizontalSeparation:90,verticalSeparation:50,underneathVerticalTopOffset:15,underneathHorizontalOffset:15,underneathVerticalSeparation:15,grid:{width:1500,offsetX:50,offsetY:50,componentSpacingX:20,componentSpacingY:20},layerSeparation:50,layeredIterations:2,startRadialAngle:0,endRadialAngle:360,radialSeparation:150,radialFirstLevelSeparation:200,keepComponentsInOneRadialLayout:!1,ignoreContainers:!0,layoutContainerChildren:!1,ignoreInvisible:!0,animateTransitions:!1},init:function(){},gridLayoutComponents:function(e){var t,n,i,o,r,s,a,l,c,d,u,h,m,g,v;if(!e)throw"No components supplied.";for(f.forEach(e,function(e){e.calcBounds()}),e.sort(function(e,t){return t.bounds.width-e.bounds.width}),t=this.options.grid.width,n=this.options.grid.componentSpacingX,i=this.options.grid.componentSpacingY,o=0,r=this.options.grid.offsetX,s=this.options.grid.offsetY,a=r,l=s,d=[],u=[];e.length>0;){for(a>=t&&(a=r,l+=o+i,o=0),h=e.pop(),this.moveToOffset(h,new p(a,l)),c=0;c<h.nodes.length;c++)u.push(h.nodes[c]);for(c=0;c<h.links.length;c++)d.push(h.links[c]);m=h.bounds,g=m.height,(g<=0||isNaN(g))&&(g=0),v=m.width,(v<=0||isNaN(v))&&(v=0),g>=o&&(o=g),a+=v+n}return{nodes:u,links:d}},moveToOffset:function(e,t){var n,i,o,r,s,a,l,d,u=e.bounds,h=t.x-u.x,f=t.y-u.y;for(n=0;n<e.nodes.length;n++)o=e.nodes[n],r=o.bounds(),0===r.width&&0===r.height&&0===r.x&&0===r.y&&(r=new c(0,0,0,0)),r.x+=h,r.y+=f,o.bounds(r);for(n=0;n<e.links.length;n++)if(s=e.links[n],s.points){for(a=[],l=s.points,i=0;i<l.length;i++)d=l[i],d.x+=h,d.y+=f,a.push(d);s.points=a}return this.currentHorizontalOffset+=u.width+this.options.grid.offsetX,new p(h,f)},transferOptions:function(e){this.options=n.deepExtend({},this.defaultOptions),f.isUndefined(e)||(this.options=n.deepExtend(this.options,e||{}))}}),w=n.Class.extend({init:function(e){this.nodeMap=new d,this.shapeMap=new d,this.nodes=[],this.edges=[],this.edgeMap=new d,this.finalNodes=[],this.finalLinks=[],this.ignoredConnections=[],this.ignoredShapes=[],this.hyperMap=new d,this.hyperTree=new o,this.finalGraph=null,this.diagram=e},convert:function(e){if(f.isUndefined(this.diagram))throw"No diagram to convert.";return this.options=n.deepExtend({ignoreInvisible:!0,ignoreContainers:!0,layoutContainerChildren:!1},e||{}),this.clear(),this._renormalizeShapes(),this._renormalizeConnections(),this.finalNodes=new d(this.nodes),this.finalLinks=new d(this.edges),this.finalGraph=new o,this.finalNodes.forEach(function(e){
this.finalGraph.addNode(e)},this),this.finalLinks.forEach(function(e){this.finalGraph.addExistingLink(e)},this),this.finalGraph},mapConnection:function(e){return this.edgeMap.get(e.id)},mapShape:function(e){return this.nodeMap.get(e.id)},getEdge:function(e,t){return f.first(e.links,function(n){return n.getComplement(e)===t})},clear:function(){this.finalGraph=null,this.hyperTree=!this.options.ignoreContainers&&this.options.layoutContainerChildren?new h:null,this.hyperMap=!this.options.ignoreContainers&&this.options.layoutContainerChildren?new d:null,this.nodeMap=new d,this.shapeMap=new d,this.nodes=[],this.edges=[],this.edgeMap=new d,this.ignoredConnections=[],this.ignoredShapes=[],this.finalNodes=[],this.finalLinks=[]},listToRoot:function(e){var t=[],n=e.container;if(!n)return t;for(t.push(n);n.parentContainer;)n=n.parentContainer,t.push(n);return t.reverse(),t},firstNonIgnorableContainer:function(e){return e.isContainer&&!this._isIgnorableItem(e)?e:e.parentContainer?this.firstNonIgnorableContainer(e.parentContainer):null},isContainerConnection:function(e,t){return!(!e.isContainer||!this.isDescendantOf(e,t))||t.isContainer&&this.isDescendantOf(t,e)},isDescendantOf:function(e,t){var n,i,o,r;if(!e.isContainer)throw"Expecting a container.";if(e===t)return!1;if(v(e.children,t))return!0;for(n=[],i=0,o=e.children.length;i<o;i++)r=e.children[i],r.isContainer&&this.isDescendantOf(r,t)&&n.push(r);return n.length>0},isIgnorableItem:function(e){return this.options.ignoreInvisible?(!e.isCollapsed||!this._isVisible(e))&&!(!e.isCollapsed&&this._isVisible(e)):e.isCollapsed&&!this._isTop(e)},isShapeMapped:function(e){return e.isCollapsed&&!this._isVisible(e)&&!this._isTop(e)},leastCommonAncestor:function(e,t){var n,i,o,r,s,a;if(!e)throw"Parameter should not be null.";if(!t)throw"Parameter should not be null.";if(!this.hyperTree)throw"No hypertree available.";if(n=this.listToRoot(e),i=this.listToRoot(t),o=null,f.isEmpty(n)||f.isEmpty(i))return this.hyperTree.root.data;for(r=n[0],s=i[0],a=0;r===s&&(o=n[a],a++,!(a>=n.length||a>=i.length));)r=n[a],s=i[a];return o?_(this.hyperTree.nodes,function(e){return e.data.container===o}):this.hyperTree.root.data},_isTop:function(e){return!e.parentContainer},_isVisible:function(e){return!!e.visible()&&(e.parentContainer?this._isVisible(e.parentContainer):e.visible())},_isCollapsed:function(e){return!(!e.isContainer||!e.isCollapsed)||e.parentContainer&&this._isCollapsed(e.parentContainer)},_renormalizeShapes:function(){var e,t,n,i;if(!this.options.ignoreContainers)throw"Containers are not supported yet, but stay tuned.";for(e=0,t=this.diagram.shapes.length;e<t;e++)n=this.diagram.shapes[e],this.options.ignoreInvisible&&!this._isVisible(n)||n.isContainer?this.ignoredShapes.push(n):(i=new r(n.id,n),i.isVirtual=!1,this.nodeMap.add(n.id,i),this.nodes.push(i))},_renormalizeConnections:function(){var e,t,n,i,o,r,a,l;if(0!==this.diagram.connections.length)for(e=0,t=this.diagram.connections.length;e<t;e++)if(n=this.diagram.connections[e],this.isIgnorableItem(n))this.ignoredConnections.push(n);else if(i=n.sourceConnector?n.sourceConnector.shape:null,o=n.targetConnector?n.targetConnector.shape:null,i&&o)if(!v(this.ignoredShapes,i)||this.shapeMap.containsKey(i))if(!v(this.ignoredShapes,o)||this.shapeMap.containsKey(o))if(this.shapeMap.containsKey(i)&&(i=this.shapeMap[i]),this.shapeMap.containsKey(o)&&(o=this.shapeMap[o]),r=this.mapShape(i),a=this.mapShape(o),r===a||this.areConnectedAlready(r,a))this.ignoredConnections.push(n);else{if(null===r||null===a)throw"A shape was not mapped to a node.";if(!this.options.ignoreContainers)throw"Containers are not supported yet, but stay tuned.";r.isVirtual||a.isVirtual?this.ignoredConnections.push(n):(l=new s(r,a,n.id,n),this.edgeMap.add(n.id,l),this.edges.push(l))}else this.ignoredConnections.push(n);else this.ignoredConnections.push(n);else this.ignoredConnections.push(n)},areConnectedAlready:function(e,t){return f.any(this.edges,function(n){return n.source===e&&n.target===t||n.source===t&&n.target===e})}}),y=b.extend({init:function(e){var t=this;if(b.fn.init.call(t),f.isUndefined(e))throw"Diagram is not specified.";this.diagram=e},layout:function(e){var t,n,o,r,s,a;if(this.transferOptions(e),t=new w(this.diagram),n=t.convert(e),!n.isEmpty()&&(o=n.getConnectedComponents(),!f.isEmpty(o))){for(r=0;r<o.length;r++)s=o[r],this.layoutGraph(s,e);return a=this.gridLayoutComponents(o),new i.LayoutState(this.diagram,a)}},layoutGraph:function(e,t){var n,i,o;for(f.isDefined(t)&&this.transferOptions(t),this.graph=e,n=9*this.options.nodeDistance,this.temperature=n,i=this._expectedBounds(),this.width=i.width,this.height=i.height,o=0;o<this.options.iterations;o++)this.refineStage=o>=5*this.options.iterations/6,this.tick(),this.temperature=this.refineStage?n/30:n*(1-o/(2*this.options.iterations))},tick:function(){var e,t,n;for(e=0;e<this.graph.nodes.length;e++)this._repulsion(this.graph.nodes[e]);for(e=0;e<this.graph.links.length;e++)this._attraction(this.graph.links[e]);for(e=0;e<this.graph.nodes.length;e++){if(t=this.graph.nodes[e],n=Math.sqrt(t.dx*t.dx+t.dy*t.dy),0===n)return;t.x+=Math.min(n,this.temperature)*t.dx/n,t.y+=Math.min(n,this.temperature)*t.dy/n,this.options.limitToView&&(t.x=Math.min(this.width,Math.max(t.width/2,t.x)),t.y=Math.min(this.height,Math.max(t.height/2,t.y)))}},_shake:function(e){var t=Math.random()*this.options.nodeDistance/4,n=2*Math.random()*Math.PI;e.x+=t*Math.cos(n),e.y-=t*Math.sin(n)},_InverseSquareForce:function(e,t,n){var i,o,r,s,a,l,c;return this.refineStage?(o=t.x-n.x,r=t.y-n.y,s=t.width/2,a=t.height/2,l=n.width/2,c=n.height/2,i=Math.pow(o,2)/Math.pow(s+l+this.options.nodeDistance,2)+Math.pow(r,2)/Math.pow(a+c+this.options.nodeDistance,2)):i=Math.pow(e,2)/Math.pow(this.options.nodeDistance,2),4*i/3},_SquareForce:function(e,t,n){return 1/this._InverseSquareForce(e,t,n)},_repulsion:function(e){e.dx=0,e.dy=0,f.forEach(this.graph.nodes,function(t){var n,i,o,r;if(t!==e){for(;e.x===t.x&&e.y===t.y;)this._shake(t);n=e.x-t.x,i=e.y-t.y,o=Math.sqrt(n*n+i*i),r=2*this._SquareForce(o,e,t),e.dx+=n/o*r,e.dy+=i/o*r}},this)},_attraction:function(e){var t,n,i,o,r,s,a=e.target,l=e.source;if(l!==a){for(;l.x===a.x&&l.y===a.y;)this._shake(a);t=l.x-a.x,n=l.y-a.y,i=Math.sqrt(t*t+n*n),o=5*this._InverseSquareForce(i,l,a),r=t/i*o,s=n/i*o,a.dx+=r,a.dy+=s,l.dx-=r,l.dy-=s}},_expectedBounds:function(){var e,t,n,i,o,r=this.graph.nodes.length,s=1.5,a=4;return 0===r?e:(e=f.fold(this.graph.nodes,function(e,t){var n=t.width*t.height;return n>0?e+=Math.sqrt(n):0},0,this),t=e/r,n=t*Math.ceil(Math.sqrt(r)),i=n*Math.sqrt(s),o=n/Math.sqrt(s),{width:i*a,height:o*a})}}),k=n.Class.extend({init:function(e){this.center=null,this.options=e},layout:function(e,t){if(this.graph=e,this.graph.nodes&&0!==this.graph.nodes.length){if(!v(this.graph.nodes,t))throw"The given root is not in the graph.";this.center=t,this.graph.cacheRelationships(),this.layoutSwitch()}},layoutLeft:function(e){var t,n,i,o,r,s,a,c;for(this.setChildrenDirection(this.center,"Left",!1),this.setChildrenLayout(this.center,"Default",!1),t=0,n=0,o=0;o<e.length;o++)r=e[o],r.TreeDirection="Left",s=this.measure(r,l.Empty),n=Math.max(n,s.Width),t+=s.height+this.options.verticalSeparation;for(t-=this.options.verticalSeparation,a=this.center.x-this.options.horizontalSeparation,i=this.center.y+(this.center.height-t)/2,o=0;o<e.length;o++)r=e[o],c=new p(a-r.Size.width,i),this.arrange(r,c),i+=r.Size.height+this.options.verticalSeparation},layoutRight:function(e){var t,n,i,o,r,s,a,c;for(this.setChildrenDirection(this.center,"Right",!1),this.setChildrenLayout(this.center,"Default",!1),t=0,n=0,o=0;o<e.length;o++)r=e[o],r.TreeDirection="Right",s=this.measure(r,l.Empty),n=Math.max(n,s.Width),t+=s.height+this.options.verticalSeparation;for(t-=this.options.verticalSeparation,a=this.center.x+this.options.horizontalSeparation+this.center.width,i=this.center.y+(this.center.height-t)/2,o=0;o<e.length;o++)r=e[o],c=new p(a,i),this.arrange(r,c),i+=r.Size.height+this.options.verticalSeparation},layoutUp:function(e){var t,n,i,o,r,s,a;for(this.setChildrenDirection(this.center,"Up",!1),this.setChildrenLayout(this.center,"Default",!1),t=0,o=0;o<e.length;o++)i=e[o],i.TreeDirection="Up",r=this.measure(i,l.Empty),t+=r.width+this.options.horizontalSeparation;for(t-=this.options.horizontalSeparation,s=this.center.x+this.center.width/2-t/2,o=0;o<e.length;o++)i=e[o],n=this.center.y-this.options.verticalSeparation-i.Size.height,a=new p(s,n),this.arrange(i,a),s+=i.Size.width+this.options.horizontalSeparation},layoutDown:function(e){var t,n,i,o,r,s,a;for(this.setChildrenDirection(this.center,"Down",!1),this.setChildrenLayout(this.center,"Default",!1),i=0,n=0;n<e.length;n++)t=e[n],t.treeDirection="Down",r=this.measure(t,l.Empty),i+=r.width+this.options.horizontalSeparation;for(i-=this.options.horizontalSeparation,s=this.center.x+this.center.width/2-i/2,o=this.center.y+this.options.verticalSeparation+this.center.height,n=0;n<e.length;n++)t=e[n],a=new p(s,o),this.arrange(t,a),s+=t.Size.width+this.options.horizontalSeparation},layoutRadialTree:function(){var e,t;if(this.setChildrenDirection(this.center,"Radial",!1),this.setChildrenLayout(this.center,"Default",!1),this.previousRoot=null,e=this.options.startRadialAngle*g,t=this.options.endRadialAngle*g,t<=e)throw"Final angle should not be less than the start angle.";this.maxDepth=0,this.origin=new p(this.center.x,this.center.y),this.calculateAngularWidth(this.center,0),this.maxDepth>0&&this.radialLayout(this.center,this.options.radialFirstLevelSeparation,e,t),this.center.Angle=t-e},tipOverTree:function(e,t){var n,i,o,r,s,a,c;for(f.isUndefined(t)&&(t=0),this.setChildrenDirection(this.center,"Down",!1),this.setChildrenLayout(this.center,"Default",!1),this.setChildrenLayout(this.center,"Underneath",!1,t),n=0,r=0;r<e.length;r++)o=e[r],o.TreeDirection="Down",s=this.measure(o,l.Empty),n+=s.width+this.options.horizontalSeparation;for(n-=this.options.horizontalSeparation,n-=e[e.length-1].width,n+=e[e.length-1].associatedShape.bounds().width,a=this.center.x+this.center.width/2-n/2,i=this.center.y+this.options.verticalSeparation+this.center.height,r=0;r<e.length;r++)o=e[r],c=new p(a,i),this.arrange(o,c),a+=o.Size.width+this.options.horizontalSeparation},calculateAngularWidth:function(e,t){var n,i,o,r,s,a,l;if(t>this.maxDepth&&(this.maxDepth=t),n=0,i=1e3,o=1e3,r=0===t?0:Math.sqrt(i*i+o*o)/t,e.children.length>0){for(s=0,a=e.children.length;s<a;s++)l=e.children[s],n+=this.calculateAngularWidth(l,t+1);n=Math.max(r,n)}else n=r;return e.sectorAngle=n,n},sortChildren:function(e){var t,n,i,o,r,s,a,l,c,d,u,h=0;if(e.parents.length>1)throw"Node is not part of a tree.";if(n=e.parents[0],n&&(i=new p(n.x,n.y),o=new p(e.x,e.y),h=this.normalizeAngle(Math.atan2(i.y-o.y,i.x-o.x))),r=e.children.length,0===r)return null;for(s=[],a=[],t=0;t<r;++t)l=e.children[t],c=new p(l.x,l.y),a[t]=t,s[t]=this.normalizeAngle(-h+Math.atan2(c.y-c.y,c.x-c.x));for(f.bisort(s,a),d=[],u=e.children,t=0;t<r;++t)d.push(u[a[t]]);return d},normalizeAngle:function(e){for(;e>2*Math.PI;)e-=2*Math.PI;for(;e<0;)e+=2*Math.PI;return e},radialLayout:function(e,t,n,i){var o,r,s,a,l,c=i-n,d=c/2,u=e.sectorAngle,h=0,f=this.sortChildren(e);for(o=0,r=f.length;o<r;o++)s=f[o],a=s,l=a.sectorAngle/u,s.children.length>0&&this.radialLayout(s,t+this.options.radialSeparation,n+h*c,n+(h+l)*c),this.setPolarLocation(s,t,n+h*c+l*d),a.angle=l*c,h+=l},setPolarLocation:function(e,t,n){e.x=this.origin.x+t*Math.cos(n),e.y=this.origin.y+t*Math.sin(n),e.BoundingRectangle=new c(e.x,e.y,e.width,e.height)},setChildrenDirection:function(e,t,n){var i=e.treeDirection;this.graph.depthFirstTraversal(e,function(e){e.treeDirection=t}),n||(e.treeDirection=i)},setChildrenLayout:function(e,t,n,i){f.isUndefined(i)&&(i=0);var o=e.childrenLayout;i>0?(this.graph.assignLevels(e),this.graph.depthFirstTraversal(e,function(e){e.level>=i+1&&(e.childrenLayout=t)})):(this.graph.depthFirstTraversal(e,function(e){e.childrenLayout=t}),n||(e.childrenLayout=o))},measure:function(e,t){var n,i,o,r,s,a,c,d=0,u=0,h=new l(0,0);if(!e)throw"";if(i=e.associatedShape.bounds(),o=i.width,r=i.height,1!==e.parents.length)throw"Node not in a spanning tree.";if(s=e.parents[0],"Undefined"===e.treeDirection&&(e.treeDirection=s.treeDirection),f.isEmpty(e.children))h=new l(Math.abs(o)<m?50:o,Math.abs(r)<m?25:r);else if(1===e.children.length){switch(e.treeDirection){case"Radial":n=this.measure(e.children[0],t),d=o+this.options.radialSeparation*Math.cos(e.AngleToParent)+n.width,u=r+Math.abs(this.options.radialSeparation*Math.sin(e.AngleToParent))+n.height;break;case"Left":case"Right":switch(e.childrenLayout){case"TopAlignedWithParent":break;case"BottomAlignedWithParent":break;case"Underneath":n=this.measure(e.children[0],t),d=o+n.width+this.options.underneathHorizontalOffset,u=r+this.options.underneathVerticalTopOffset+n.height;break;case"Default":n=this.measure(e.children[0],t),d=o+this.options.horizontalSeparation+n.width,u=Math.max(r,n.height);break;default:throw"Unhandled TreeDirection in the Radial layout measuring."}break;case"Up":case"Down":switch(e.childrenLayout){case"TopAlignedWithParent":case"BottomAlignedWithParent":break;case"Underneath":n=this.measure(e.children[0],t),d=Math.max(o,n.width+this.options.underneathHorizontalOffset),u=r+this.options.underneathVerticalTopOffset+n.height;break;case"Default":n=this.measure(e.children[0],t),u=r+this.options.verticalSeparation+n.height,d=Math.max(o,n.width);break;default:throw"Unhandled TreeDirection in the Down layout measuring."}break;default:throw"Unhandled TreeDirection in the layout measuring."}h=new l(d,u)}else{switch(e.treeDirection){case"Left":case"Right":switch(e.childrenLayout){case"TopAlignedWithParent":case"BottomAlignedWithParent":break;case"Underneath":for(d=o,u=r+this.options.underneathVerticalTopOffset,a=0;a<e.children.length;a++)c=e.children[a],n=this.measure(c,t),d=Math.max(d,n.width+this.options.underneathHorizontalOffset),u+=n.height+this.options.underneathVerticalSeparation;u-=this.options.underneathVerticalSeparation;break;case"Default":for(d=o,u=0,a=0;a<e.children.length;a++)c=e.children[a],n=this.measure(c,t),d=Math.max(d,o+this.options.horizontalSeparation+n.width),u+=n.height+this.options.verticalSeparation;u-=this.options.verticalSeparation;break;default:throw"Unhandled TreeDirection in the Right layout measuring."}break;case"Up":case"Down":switch(e.childrenLayout){case"TopAlignedWithParent":case"BottomAlignedWithParent":break;case"Underneath":for(d=o,u=r+this.options.underneathVerticalTopOffset,a=0;a<e.children.length;a++)c=e.children[a],n=this.measure(c,t),d=Math.max(d,n.width+this.options.underneathHorizontalOffset),u+=n.height+this.options.underneathVerticalSeparation;u-=this.options.underneathVerticalSeparation;break;case"Default":for(d=0,u=0,a=0;a<e.children.length;a++)c=e.children[a],n=this.measure(c,t),d+=n.width+this.options.horizontalSeparation,u=Math.max(u,n.height+this.options.verticalSeparation+r);d-=this.options.horizontalSeparation;break;default:throw"Unhandled TreeDirection in the Down layout measuring."}break;default:throw"Unhandled TreeDirection in the layout measuring."}h=new l(d,u)}return e.SectorAngle=Math.sqrt(d*d/4+u*u/4),e.Size=h,h},arrange:function(e,t){var n,i,o,r,s,a,l,d,u=e.associatedShape.bounds(),h=u.width,g=u.height;if(f.isEmpty(e.children))e.x=t.x,e.y=t.y,e.BoundingRectangle=new c(t.x,t.y,h,g);else switch(e.treeDirection){case"Left":switch(e.childrenLayout){case"TopAlignedWithParent":case"BottomAlignedWithParent":break;case"Underneath":for(d=t,e.x=d.x,e.y=d.y,e.BoundingRectangle=new c(e.x,e.y,e.width,e.height),l=t.y+g+this.options.underneathVerticalTopOffset,n=0;n<r.children.length;n++)r=r.children[n],a=d.x-r.associatedShape.width-this.options.underneathHorizontalOffset,i=new p(a,l),this.arrange(r,i),l+=r.Size.height+this.options.underneathVerticalSeparation;break;case"Default":for(d=new p(t.x+e.Size.width-h,t.y+(e.Size.height-g)/2),e.x=d.x,e.y=d.y,e.BoundingRectangle=new c(e.x,e.y,e.width,e.height),a=d.x-this.options.horizontalSeparation,l=t.y,n=0;n<e.children.length;n++)r=e.children[n],i=new p(a-r.Size.width,l),this.arrange(r,i),l+=r.Size.height+this.options.verticalSeparation;break;default:throw"Unsupported TreeDirection"}break;case"Right":switch(e.childrenLayout){case"TopAlignedWithParent":case"BottomAlignedWithParent":break;case"Underneath":for(d=t,e.x=d.x,e.y=d.y,e.BoundingRectangle=new c(e.x,e.y,e.width,e.height),a=t.x+h+this.options.underneathHorizontalOffset,l=t.y+g+this.options.underneathVerticalTopOffset,n=0;n<e.children.length;n++)r=e.children[n],i=new p(a,l),this.arrange(r,i),l+=r.Size.height+this.options.underneathVerticalSeparation;break;case"Default":for(d=new p(t.x,t.y+(e.Size.height-g)/2),e.x=d.x,e.y=d.y,e.BoundingRectangle=new c(e.x,e.y,e.width,e.height),a=t.x+h+this.options.horizontalSeparation,l=t.y,n=0;n<e.children.length;n++)r=e.children[n],i=new p(a,l),this.arrange(r,i),l+=r.Size.height+this.options.verticalSeparation;break;default:throw"Unsupported TreeDirection"}break;case"Up":if(d=new p(t.x+(e.Size.width-h)/2,t.y+e.Size.height-g),e.x=d.x,e.y=d.y,e.BoundingRectangle=new c(e.x,e.y,e.width,e.height),Math.abs(d.x-t.x)<m){for(s=0,n=0;n<e.children.length;n++)o=e.children[n],s+=o.Size.width+this.options.horizontalSeparation;s-=this.options.horizontalSeparation,a=t.x+(h-s)/2}else a=t.x;for(n=0;n<e.children.length;n++)r=e.children[n],l=d.y-this.options.verticalSeparation-r.Size.height,i=new p(a,l),this.arrange(r,i),a+=r.Size.width+this.options.horizontalSeparation;break;case"Down":switch(e.childrenLayout){case"TopAlignedWithParent":case"BottomAlignedWithParent":break;case"Underneath":for(d=t,e.x=d.x,e.y=d.y,e.BoundingRectangle=new c(e.x,e.y,e.width,e.height),a=t.x+this.options.underneathHorizontalOffset,l=t.y+g+this.options.underneathVerticalTopOffset,n=0;n<e.children.length;n++)r=e.children[n],i=new p(a,l),this.arrange(r,i),l+=r.Size.height+this.options.underneathVerticalSeparation;break;case"Default":if(d=new p(t.x+(e.Size.width-h)/2,t.y),e.x=d.x,e.y=d.y,e.BoundingRectangle=new c(e.x,e.y,e.width,e.height),Math.abs(d.x-t.x)<m){for(s=0,n=0;n<e.children.length;n++)o=e.children[n],s+=o.Size.width+this.options.horizontalSeparation;s-=this.options.horizontalSeparation,a=t.x+(h-s)/2}else a=t.x;for(n=0;n<e.children.length;n++)r=e.children[n],l=d.y+this.options.verticalSeparation+g,i=new p(a,l),this.arrange(r,i),a+=r.Size.width+this.options.horizontalSeparation;break;default:throw"Unsupported TreeDirection"}break;case"None":break;default:throw"Unsupported TreeDirection"}},layoutSwitch:function(){var e,t,n,i,o,r;if(this.center&&!f.isEmpty(this.center.children))switch(e=this.options.subtype,f.isUndefined(e)&&(e="Down"),r=this.center.children,e.toLowerCase()){case"radial":case"radialtree":this.layoutRadialTree();break;case"mindmaphorizontal":case"mindmap":t=this.center.children,1===this.center.children.length?this.layoutRight(t):(o=r.length/2,n=_(this.center.children,function(e){return f.indexOf(r,e)<o}),i=_(this.center.children,function(e){return f.indexOf(r,e)>=o}),this.layoutLeft(n),this.layoutRight(i));break;case"mindmapvertical":t=this.center.children,1===this.center.children.length?this.layoutDown(t):(o=r.length/2,n=_(this.center.children,function(e){return f.indexOf(r,e)<o}),i=_(this.center.children,function(e){return f.indexOf(r,e)>=o}),this.layoutUp(n),this.layoutDown(i));break;case"right":this.layoutRight(this.center.children);break;case"left":this.layoutLeft(this.center.children);break;case"up":case"bottom":this.layoutUp(this.center.children);break;case"down":case"top":this.layoutDown(this.center.children);break;case"tipover":case"tipovertree":if(this.options.tipOverTreeStartLevel<0)throw"The tip-over level should be a positive integer.";this.tipOverTree(this.center.children,this.options.tipOverTreeStartLevel);break;case"undefined":case"none":}}}),x=b.extend({init:function(e){var t=this;if(b.fn.init.call(t),f.isUndefined(e))throw"No diagram specified.";this.diagram=e},layout:function(e){var t,n;return this.transferOptions(e),t=new w(this.diagram),this.graph=t.convert(),n=this.layoutComponents(),new i.LayoutState(this.diagram,n)},layoutComponents:function(){var e,t,n,i,o,r,s,a;if(!this.graph.isEmpty()&&(e=this.graph.getConnectedComponents(),!f.isEmpty(e))){for(t=new k(this.options),n=[],i=0;i<e.length;i++){if(o=e[i],r=this.getTree(o),!r)throw"Failed to find a spanning tree for the component.";s=r.root,a=r.tree,t.layout(a,s),n.push(a)}return this.gridLayoutComponents(n)}},getTree:function(e){var t,n,i,o,r,s=null;if(this.options.roots&&this.options.roots.length>0)for(t=0,n=e.nodes.length;t<n;t++)for(i=e.nodes[t],o=0;o<this.options.roots.length;o++)if(r=this.options.roots[o],r===i.associatedShape){s=i;break}if(!s&&(s=e.root(),!s))throw"Unable to find a root for the tree.";return this.getTreeForRoot(e,s)},getTreeForRoot:function(e,t){var n=e.getSpanningTree(t);return f.isUndefined(n)||n.isEmpty()?null:{tree:n,root:n.root}}}),C=b.extend({init:function(e){var t=this;if(b.fn.init.call(t),f.isUndefined(e))throw"Diagram is not specified.";this.diagram=e},layout:function(e){var t,n,o,r,s,a;if(this.transferOptions(e),t=new w(this.diagram),n=t.convert(e),!n.isEmpty()&&(o=n.getConnectedComponents(),!f.isEmpty(o))){for(r=0;r<o.length;r++)s=o[r],this.layoutGraph(s,e);return a=this.gridLayoutComponents(o),new i.LayoutState(this.diagram,a)}},_initRuntimeProperties:function(){var e,t;for(e=0;e<this.graph.nodes.length;e++)t=this.graph.nodes[e],t.layer=-1,t.downstreamLinkCount=0,t.upstreamLinkCount=0,t.isVirtual=!1,t.uBaryCenter=0,t.dBaryCenter=0,t.upstreamPriority=0,t.downstreamPriority=0,t.gridPosition=0},_prepare:function(e){var t,n,i,o,r,s,a,l,c,u,h,p=[],m=new d,g=0;for(f.forEach(e.nodes,function(e){0===e.incoming.length&&(m.set(e,0),p.push(e))});p.length>0;)for(r=p.shift(),t=0;t<r.outgoing.length;t++)i=r.outgoing[t],s=i.target,o=m.containsKey(s)?Math.max(m.get(r)+1,m.get(s)):m.get(r)+1,m.set(s,o),o>g&&(g=o),v(p,s)||p.push(s);for(a=m.keys(),a.sort(function(e,t){var n=m.get(e),i=m.get(t);return f.sign(i-n)}),l=0;l<a.length;++l)if(c=a[l],u=Number.MAX_VALUE,0!==c.outgoing.length){for(n=0;n<c.outgoing.length;++n)i=c.outgoing[n],u=Math.min(u,m.get(i.target));u>1&&m.set(c,u-1)}for(this.layers=[],t=0;t<g+1;t++)h=[],h.linksTo={},this.layers.push(h);for(m.forEach(function(e,t){e.layer=t,this.layers[t].push(e)},this),n=0;n<this.layers.length;n++)for(h=this.layers[n],t=0;t<h.length;t++)h[t].gridPosition=t},layoutGraph:function(e,t){if(f.isUndefined(e))throw"No graph given or graph analysis of the diagram failed.";f.isDefined(t)&&this.transferOptions(t),this.graph=e,e.setItemIndices();var n=e.makeAcyclic();this._initRuntimeProperties(),this._prepare(e,t),this._dummify(),this._optimizeCrossings(),this._swapPairs(),this.arrangeNodes(),this._moveThingsAround(),this._dedummify(),f.forEach(n,function(e){e.points&&e.points.reverse()})},setMinDist:function(e,t,n){var i=e.layer,o=e.layerIndex;this.minDistances[i][o]=n},getMinDist:function(e,t){var n,i=0,o=e.layerIndex,r=t.layerIndex,s=e.layer,a=Math.min(o,r),l=Math.max(o,r);for(n=a;n<l;++n)i+=this.minDistances[s][n];return i},placeLeftToRight:function(e){var t,n,i,o,r,s,a,l,c,u,h=new d;for(i=0;i<this.layers.length;++i)if(o=e[i]){for(t=0;t<o.length;t++)n=o[t],h.containsKey(n)||this.placeLeft(n,h,i);for(r=Number.POSITIVE_INFINITY,t=0;t<o.length;t++)n=o[t],s=this.rightSibling(n),s&&this.nodeLeftClass.get(s)!==i&&(r=Math.min(r,h.get(s)-h.get(n)-this.getMinDist(n,s)));if(r===Number.POSITIVE_INFINITY){for(a=[],t=0;t<o.length;t++)for(n=o[t],l=[],f.addRange(l,this.upNodes.get(n)),f.addRange(l,this.downNodes.get(n)),c=0;c<l.length;c++)u=l[c],this.nodeLeftClass.get(u)<i&&a.push(h.get(u)-h.get(n));a.sort(),r=0===a.length?0:a.length%2===1?a[this.intDiv(a.length,2)]:(a[this.intDiv(a.length,2)-1]+a[this.intDiv(a.length,2)])/2}for(t=0;t<o.length;t++)n=o[t],h.set(n,h.get(n)+r)}return h},placeRightToLeft:function(e){var t,n,i,o,r,s,a,l,c,u,h=new d;for(i=0;i<this.layers.length;++i)if(o=e[i]){for(t=0;t<o.length;t++)n=o[t],h.containsKey(n)||this.placeRight(n,h,i);for(r=Number.NEGATIVE_INFINITY,t=0;t<o.length;t++)n=o[t],s=this.leftSibling(n),s&&this.nodeRightClass.get(s)!==i&&(r=Math.max(r,h.get(s)-h.get(n)+this.getMinDist(s,n)));if(r===Number.NEGATIVE_INFINITY){for(a=[],t=0;t<o.length;t++)for(n=o[t],l=[],f.addRange(l,this.upNodes.get(n)),f.addRange(l,this.downNodes.get(n)),c=0;c<l.length;c++)u=l[c],this.nodeRightClass.get(u)<i&&a.push(h.get(n)-h.get(u));a.sort(),r=0===a.length?0:a.length%2===1?a[this.intDiv(a.length,2)]:(a[this.intDiv(a.length,2)-1]+a[this.intDiv(a.length,2)])/2}for(t=0;t<o.length;t++)n=o[t],h.set(n,h.get(n)+r)}return h},_getLeftWing:function(){var e={value:null},t=this.computeClasses(e,1);return this.nodeLeftClass=e.value,t},_getRightWing:function(){var e={value:null},t=this.computeClasses(e,-1);return this.nodeRightClass=e.value,t},computeClasses:function(e,t){var n,i,o,r,s,a,l,c,u,h=0,f=e.value=new d;for(n=0;n<this.layers.length;++n)for(h=n,i=this.layers[n],o=1===t?0:i.length-1;0<=o&&o<i.length;o+=t)if(r=i[o],f.containsKey(r))h=f.get(r);else if(f.set(r,h),r.isVirtual)for(s=this._nodesInLink(r),a=0;a<s.length;a++)l=s[a],f.set(l,h);for(c=[],u=0;u<this.layers.length;u++)c.push(null);return f.forEach(function(e,t){null===c[t]&&(c[t]=[]),c[t].push(e)}),c},_isVerticalLayout:function(){return"up"===this.options.subtype.toLowerCase()||"down"===this.options.subtype.toLowerCase()||"vertical"===this.options.subtype.toLowerCase()},_isHorizontalLayout:function(){return"right"===this.options.subtype.toLowerCase()||"left"===this.options.subtype.toLowerCase()||"horizontal"===this.options.subtype.toLowerCase()},_isIncreasingLayout:function(){return"right"===this.options.subtype.toLowerCase()||"down"===this.options.subtype.toLowerCase()},_moveThingsAround:function(){function e(e,t){var n,i,o=Number.MIN_VALUE;for(n=0;n<e.length;++n)i=e[n],o=t._isVerticalLayout()?Math.max(o,i.height):Math.max(o,i.width);return o}var t,n,i,o,r,s,a,l,c,u,h,p,m,g,v,_,b,w,y,k,x,C,S,T,D,A,E;for(n=0;n<this.layers.length;++n)o=this.layers[n],o.sort(this._gridPositionComparer);for(this.minDistances=[],n=0;n<this.layers.length;++n)for(o=this.layers[n],this.minDistances[n]=[],r=0;r<o.length;++r)i=o[r],i.layerIndex=r,this.minDistances[n][r]=this.options.nodeDistance,r<o.length-1&&(this.minDistances[n][r]+=this._isVerticalLayout()?(i.width+o[r+1].width)/2:(i.height+o[r+1].height)/2);for(this.downNodes=new d,this.upNodes=new d,f.forEach(this.graph.nodes,function(e){this.downNodes.set(e,[]),this.upNodes.set(e,[])},this),f.forEach(this.graph.links,function(e){var t=e.source,n=e.target,i=null,o=null;t.layer>n.layer?(i=e.source,o=e.target):(o=e.source,i=e.target),this.downNodes.get(o).push(i),this.upNodes.get(i).push(o)},this),this.downNodes.forEachValue(function(e){e.sort(this._gridPositionComparer)},this),this.upNodes.forEachValue(function(e){e.sort(this._gridPositionComparer)},this),n=0;n<this.layers.length-1;++n)for(o=this.layers[n],s=0;s<o.length-1;s++)if(a=o[s],a.isVirtual&&(l=this.downNodes.get(a)[0],l.isVirtual))for(r=s+1;r<o.length;++r)i=o[r],i.isVirtual&&(c=this.downNodes.get(i)[0],c.isVirtual&&l.gridPosition>c.gridPosition&&(u=l.gridPosition,l.gridPosition=c.gridPosition,c.gridPosition=u,h=l.layerIndex,p=c.layerIndex,this.layers[n+1][h]=c,this.layers[n+1][p]=l,l.layerIndex=p,c.layerIndex=h));for(m=this._getLeftWing(),g=this._getRightWing(),v=this.placeLeftToRight(m),_=this.placeRightToLeft(g),b=new d,f.forEach(this.graph.nodes,function(e){b.set(e,(v.get(e)+_.get(e))/2)}),w=new d,y=new d,n=0;n<this.layers.length;++n)for(o=this.layers[n],k=-1,x=-1,r=0;r<o.length;++r)i=o[r],w.set(i,0),y.set(i,!1),i.isVirtual&&(k===-1?k=r:k===r-1?k=r:(x=r,w.set(o[k],0),b.get(i)-b.get(o[k])===this.getMinDist(o[k],i)?y.set(o[k],!0):y.set(o[k],!1),k=r));for(C=[1,-1],f.forEach(C,function(e){var n,i,o,r,s,a,l,c=1===e?0:this.layers.length-1;for(n=c;0<=n&&n<this.layers.length;n+=e){if(i=this.layers[n],o=this._firstVirtualNode(i),r=null,s=null,o!==-1)for(r=i[o],s=[],t=0;t<o;t++)s.push(i[t]);else r=null,s=i;if(s.length>0){for(this._sequencer(b,null,r,e,s),t=0;t<s.length-1;++t)this.setMinDist(s[t],s[t+1],b.get(s[t+1])-b.get(s[t]));r&&this.setMinDist(s[s.length-1],r,b.get(r)-b.get(s[s.length-1]))}for(;r;){if(a=this.nextVirtualNode(i,r)){if(w.get(r)===e){for(o=r.layerIndex,l=a.layerIndex,s=[],t=o+1;t<l;t++)s.push(i[t]);s.length>0&&this._sequencer(b,r,a,e,s),y.set(r,!0)}}else{for(o=r.layerIndex,s=[],t=o+1;t<i.length;t++)s.push(i[t]);if(s.length>0){for(this._sequencer(b,r,null,e,s),t=0;t<s.length-1;++t)this.setMinDist(s[t],s[t+1],b.get(s[t+1])-b.get(s[t]));this.setMinDist(r,s[0],b.get(s[0])-b.get(r))}}r=a}this.adjustDirections(n,e,w,y)}},this),S=this._isIncreasingLayout()?0:this.layers.length-1,T=function(e,t){return t._isIncreasingLayout()?e<t.layers.length:e>=0},D=this._isIncreasingLayout()?1:-1,A=0,t=S;T(t,this);t+=D){for(o=this.layers[t],E=e(o,this),r=0;r<o.length;++r)i=o[r],this._isVerticalLayout()?(i.x=b.get(i),i.y=A+E/2):(i.x=A+E/2,i.y=b.get(i));A+=this.options.layerSeparation+E}},adjustDirections:function(e,t,n,i){var o,r,s,a,l,c,d,u,h,f,p,m,g,v;if(!(e+t<0||e+t>=this.layers.length))for(o=null,r=null,s=this.layers[e+t],a=0;a<s.length;++a)if(l=s[a],l.isVirtual&&(c=this.getNeighborOnLayer(l,e),c.isVirtual)){if(o){for(d=i.get(r),u=this.layers[e],h=r.layerIndex,f=c.layerIndex,p=h+1;p<f;++p)u[p].isVirtual&&(d=d&&i.get(u[p]));if(d)for(n.set(o,t),m=o.layerIndex,g=l.layerIndex,v=m+1;v<g;++v)s[v].isVirtual&&n.set(s[v],t)}o=l,r=c}},getNeighborOnLayer:function(e,t){var n=this.upNodes.get(e)[0];return n.layer===t?n:(n=this.downNodes.get(e)[0],n.layer===t?n:null)},_sequencer:function(e,t,n,i,o){if(1===o.length&&this._sequenceSingle(e,t,n,i,o[0]),o.length>1){var r=o.length,s=this.intDiv(r,2);this._sequencer(e,t,n,i,o.slice(0,s)),this._sequencer(e,t,n,i,o.slice(s)),this.combineSequences(e,t,n,i,o)}},_sequenceSingle:function(e,t,n,i,o){var r=i===-1?this.downNodes.get(o):this.upNodes.get(o),s=r.length;0!==s&&(s%2===1?e.set(o,e.get(r[this.intDiv(s,2)])):e.set(o,(e.get(r[this.intDiv(s,2)-1])+e.get(r[this.intDiv(s,2)]))/2),t&&e.set(o,Math.max(e.get(o),e.get(t)+this.getMinDist(t,o))),n&&e.set(o,Math.min(e.get(o),e.get(n)-this.getMinDist(o,n))))},combineSequences:function(e,t,n,i,o){var r,s,a,l,c,d,u,h,f,p,m=o.length,g=this.intDiv(m,2),v=[];for(r=0;r<g;++r){for(s=0,l=i===-1?this.downNodes.get(o[r]):this.upNodes.get(o[r]),a=0;a<l.length;++a)c=l[a],e.get(c)>=e.get(o[r])?s++:(s--,v.push({k:e.get(c)+this.getMinDist(o[r],o[g-1]),v:2}));v.push({k:e.get(o[r])+this.getMinDist(o[r],o[g-1]),v:s})}for(t&&v.push({k:e.get(t)+this.getMinDist(t,o[g-1]),v:Number.MAX_VALUE}),v.sort(this._positionDescendingComparer),u=[],r=g;r<m;++r){for(s=0,l=i===-1?this.downNodes.get(o[r]):this.upNodes.get(o[r]),a=0;a<l.length;++a)c=l[a],e.get(c)<=e.get(o[r])?s++:(s--,u.push({k:e.get(c)-this.getMinDist(o[r],o[g]),v:2}));u.push({k:e.get(o[r])-this.getMinDist(o[r],o[g]),v:s})}for(n&&u.push({k:e.get(n)-this.getMinDist(n,o[g]),v:Number.MAX_VALUE}),u.sort(this._positionAscendingComparer),h=0,f=0,p=this.getMinDist(o[g-1],o[g]);e.get(o[g])-e.get(o[g-1])<p;)if(h<f){if(0===v.length){e.set(o[g-1],e.get(o[g])-p);break}d=v.shift(),h+=d.v,e.set(o[g-1],d.k),e.set(o[g-1],Math.max(e.get(o[g-1]),e.get(o[g])-p))}else{if(0===u.length){e.set(o[g],e.get(o[g-1])+p);break}d=u.shift(),f+=d.v,e.set(o[g],d.k),e.set(o[g],Math.min(e.get(o[g]),e.get(o[g-1])+p))}for(r=g-2;r>=0;r--)e.set(o[r],Math.min(e.get(o[r]),e.get(o[g-1])-this.getMinDist(o[r],o[g-1])));for(r=g+1;r<m;r++)e.set(o[r],Math.max(e.get(o[r]),e.get(o[g])+this.getMinDist(o[r],o[g])))},placeLeft:function(e,t,n){var i=Number.NEGATIVE_INFINITY;f.forEach(this._getComposite(e),function(e){var o=this.leftSibling(e);o&&this.nodeLeftClass.get(o)===this.nodeLeftClass.get(e)&&(t.containsKey(o)||this.placeLeft(o,t,n),i=Math.max(i,t.get(o)+this.getMinDist(o,e)))},this),i===Number.NEGATIVE_INFINITY&&(i=0),f.forEach(this._getComposite(e),function(e){t.set(e,i)})},placeRight:function(e,t,n){var i=Number.POSITIVE_INFINITY;f.forEach(this._getComposite(e),function(e){var o=this.rightSibling(e);o&&this.nodeRightClass.get(o)===this.nodeRightClass.get(e)&&(t.containsKey(o)||this.placeRight(o,t,n),
i=Math.min(i,t.get(o)-this.getMinDist(e,o)))},this),i===Number.POSITIVE_INFINITY&&(i=0),f.forEach(this._getComposite(e),function(e){t.set(e,i)})},leftSibling:function(e){var t=this.layers[e.layer],n=e.layerIndex;return 0===n?null:t[n-1]},rightSibling:function(e){var t=this.layers[e.layer],n=e.layerIndex;return n===t.length-1?null:t[n+1]},_getComposite:function(e){return e.isVirtual?this._nodesInLink(e):[e]},arrangeNodes:function(){var e,t,n,i,o,r,s,a;for(t=0;t<this.layers.length;t++)for(i=this.layers[t],n=0;n<i.length;n++)o=i[n],o.upstreamPriority=o.upstreamLinkCount,o.downstreamPriority=o.downstreamLinkCount;for(r=2,s=0;s<r;s++){for(e=this.layers.length-1;e>=1;e--)this.layoutLayer(!1,e);for(e=0;e<this.layers.length-1;e++)this.layoutLayer(!0,e)}for(a=Number.MAX_VALUE,t=0;t<this.layers.length;t++)for(i=this.layers[t],n=0;n<i.length;n++)o=i[n],a=Math.min(a,o.gridPosition);if(a<0)for(t=0;t<this.layers.length;t++)for(i=this.layers[t],n=0;n<i.length;n++)o=i[n],o.gridPosition=o.gridPosition-a},layoutLayer:function(e,t){var n,i,o,r;for(i=e?this.layers[n=t+1]:this.layers[n=t-1],o=[],r=0;r<i.length;r++)o.push(i[r]);o.sort(function(e,t){var n=(e.upstreamPriority+e.downstreamPriority)/2,i=(t.upstreamPriority+t.downstreamPriority)/2;return Math.abs(n-i)<1e-4?0:n<i?1:-1}),f.forEach(o,function(e){var t=e.gridPosition,n=this.calcBaryCenter(e),o=(e.upstreamPriority+e.downstreamPriority)/2;if(!(Math.abs(t-n)<1e-4||Math.abs(t-n)<.2501))if(t<n)for(;t<n&&this.moveRight(e,i,o);)t=e.gridPosition;else for(;t>n&&this.moveLeft(e,i,o);)t=e.gridPosition},this),n>0&&this.calcDownData(n-1),n<this.layers.length-1&&this.calcUpData(n+1)},moveRight:function(e,t,n){var i,o,r=f.indexOf(t,e);return r===t.length-1?(e.gridPosition=e.gridPosition+.5,!0):(i=t[r+1],o=(i.upstreamPriority+i.downstreamPriority)/2,i.gridPosition>e.gridPosition+1?(e.gridPosition=e.gridPosition+.5,!0):!(o>n||Math.abs(o-n)<1e-4)&&(!!this.moveRight(i,t,n)&&(e.gridPosition=e.gridPosition+.5,!0)))},moveLeft:function(e,t,n){var i,o,r=f.indexOf(t,e);return 0===r?(e.gridPosition=e.gridPosition-.5,!0):(i=t[r-1],o=(i.upstreamPriority+i.downstreamPriority)/2,i.gridPosition<e.gridPosition-1?(e.gridPosition=e.gridPosition-.5,!0):!(o>n||Math.abs(o-n)<1e-4)&&(!!this.moveLeft(i,t,n)&&(e.gridPosition=e.gridPosition-.5,!0)))},mapVirtualNode:function(e,t){this.nodeToLinkMap.set(e,t),this.linkToNodeMap.containsKey(t)||this.linkToNodeMap.set(t,[]),this.linkToNodeMap.get(t).push(e)},_nodesInLink:function(e){return this.linkToNodeMap.get(this.nodeToLinkMap.get(e))},_dummify:function(){var e,t,n,i,o,a,l,c,u,h,p,m,g,v,_,b,w,y,k,x;for(this.linkToNodeMap=new d,this.nodeToLinkMap=new d,u=this.graph.links.slice(0),h=this.layers,p=function(e,t,n){h[e].linksTo[t]=h[e].linksTo[t]||[],h[e].linksTo[t].push(n)},c=0;c<u.length;c++)if(m=u[c],g=m.source,v=m.target,_=g.layer,b=v.layer,w=g.gridPosition,y=v.gridPosition,k=(y-w)/Math.abs(b-_),x=g,_-b>1){for(l=_-1;l>b;l--){for(n=new r,n.x=g.x,n.y=g.y,n.width=g.width/100,n.height=g.height/100,e=h[l],t=(l-b)*k+w,t>e.length&&(t=e.length),w>=h[_].length-1&&y>=h[b].length-1?t=e.length:0===w&&0===y&&(t=0),n.layer=l,n.uBaryCenter=0,n.dBaryCenter=0,n.upstreamLinkCount=0,n.downstreamLinkCount=0,n.gridPosition=t,n.isVirtual=!0,f.insert(e,n,t),o=t+1;o<e.length;o++)i=e[o],i.gridPosition=i.gridPosition+1;a=new s(x,n),a.depthOfDumminess=0,p(l-1,l,a),x=n,this.graph._addNode(n),this.graph.addLink(a),n.index=this.graph.nodes.length-1,this.mapVirtualNode(n,m)}p(b-1,b,a),m.changeSource(x),m.depthOfDumminess=_-b-1}else if(_-b<-1){for(l=_+1;l<b;l++){for(n=new r,n.x=g.x,n.y=g.y,n.width=g.width/100,n.height=g.height/100,e=h[l],t=(l-_)*k+w,t>e.length&&(t=e.length),w>=h[_].length-1&&y>=h[b].length-1?t=e.length:0===w&&0===y&&(t=0),n.layer=l,n.uBaryCenter=0,n.dBaryCenter=0,n.upstreamLinkCount=0,n.downstreamLinkCount=0,n.gridPosition=t,n.isVirtual=!0,t&=t,f.insert(e,n,t),o=t+1;o<e.length;o++)i=e[o],i.gridPosition=i.gridPosition+1;a=new s(x,n),a.depthOfDumminess=0,p(l-1,l,a),x=n,this.graph._addNode(n),this.graph.addLink(a),n.index=this.graph.nodes.length-1,this.mapVirtualNode(n,m)}p(b-1,b,m),m.changeSource(x),m.depthOfDumminess=b-_-1}else p(_,b,m)},_dedummify:function(){for(var e,t,n,i,o,r,s,a,l=!0;l;)for(l=!1,e=0;e<this.graph.links.length;e++)if(t=this.graph.links[e],t.depthOfDumminess){for(n=[],n.unshift({x:t.target.x,y:t.target.y}),n.unshift({x:t.source.x,y:t.source.y}),i=t,o=t.depthOfDumminess,r=0;r<o;r++)s=i.source,a=s.incoming[0],n.unshift({x:a.source.x,y:a.source.y}),i=a;t.changeSource(i.source),t.depthOfDumminess=0,n.length>2?(n.splice(0,1),n.splice(n.length-1),t.points=n):t.points=[],l=!0;break}},_optimizeCrossings:function(){for(var e,t=-1,n=3,i=0;0!==t&&!(i++>n);){for(t=0,e=this.layers.length-1;e>=1;e--)t+=this.optimizeLayerCrossings(!1,e);for(e=0;e<this.layers.length-1;e++)t+=this.optimizeLayerCrossings(!0,e)}},calcUpData:function(e){var t,n,i,o,r,s,a,l,c;if(0!==e){for(t=this.layers[e],r=new u,s=this.layers[e-1],n=0;n<s.length;n++)r.add(s[n]);for(n=0;n<t.length;n++){for(a=t[n],l=0,c=0,i=0;i<a.incoming.length;i++)o=a.incoming[i],r.contains(o.source)&&(c++,l+=o.source.gridPosition);for(i=0;i<a.outgoing.length;i++)o=a.outgoing[i],r.contains(o.target)&&(c++,l+=o.target.gridPosition);c>0?(a.uBaryCenter=l/c,a.upstreamLinkCount=c):(a.uBaryCenter=n,a.upstreamLinkCount=0)}}},calcDownData:function(e){var t,n,i,o,r,s,a,l,c;if(e!==this.layers.length-1){for(t=this.layers[e],r=new u,s=this.layers[e+1],n=0;n<s.length;n++)r.add(s[n]);for(n=0;n<t.length;n++){for(a=t[n],l=0,c=0,i=0;i<a.incoming.length;i++)o=a.incoming[i],r.contains(o.source)&&(c++,l+=o.source.gridPosition);for(i=0;i<a.outgoing.length;i++)o=a.outgoing[i],r.contains(o.target)&&(c++,l+=o.target.gridPosition);c>0?(a.dBaryCenter=l/c,a.downstreamLinkCount=c):(a.dBaryCenter=n,a.downstreamLinkCount=0)}}},optimizeLayerCrossings:function(e,t){var n,i,o,r,s,a,l,c;for(i=e?this.layers[n=t+1]:this.layers[n=t-1],o=i.slice(0),e?this.calcUpData(n):this.calcDownData(n),r=this,i.sort(function(e,t){var n,i=r.calcBaryCenter(e),o=r.calcBaryCenter(t);return Math.abs(i-o)<1e-4?e.degree()===t.degree()?r.compareByIndex(e,t):e.degree()<t.degree()?1:-1:(n=1e3*(o-i),n>0?-1:n<0?1:r.compareByIndex(e,t))}),a=0,s=0;s<i.length;s++)i[s]!==o[s]&&a++;if(a>0)for(l=0,s=0;s<i.length;s++)c=i[s],c.gridPosition=l++;return a},_swapPairs:function(){for(var e,t,n,i,o,r,s,a,l,c,d,u,h,f,p,m,g,v=this.options.layeredIterations,_=0;;){if(_++>v)break;for(e=_%4<=1,t=_%4===1,n=e?0:this.layers.length-1;e?n<=this.layers.length-1:n>=0;n+=e?1:-1){for(i=this.layers[n],o=!1,r=!0,s=0,a=0;a<i.length-1;a++)l=0,c=0,d=0,r?(0!==n&&(l=this.countLinksCrossingBetweenTwoLayers(n-1,n)),n!==this.layers.length-1&&(c=this.countLinksCrossingBetweenTwoLayers(n,n+1)),e?l*=2:c*=2,d=l+c):d=s,0!==d&&(u=i[a],h=i[a+1],f=u.gridPosition,p=h.gridPosition,i[a]=h,i[a+1]=u,u.gridPosition=p,h.gridPosition=f,l=0,0!==n&&(l=this.countLinksCrossingBetweenTwoLayers(n-1,n)),c=0,n!==this.layers.length-1&&(c=this.countLinksCrossingBetweenTwoLayers(n,n+1)),e?l*=2:c*=2,m=l+c,g=!1,g=t?m>=d:m>d,g?(u=i[a],h=i[a+1],f=u.gridPosition,p=h.gridPosition,i[a]=h,i[a+1]=u,u.gridPosition=p,h.gridPosition=f,s=d,r=!1):(o=!0,r=!0));o&&(n!==this.layers.length-1&&this.calcUpData(n+1),0!==n&&this.calcDownData(n-1))}}},countLinksCrossingBetweenTwoLayers:function(e,t){var n,i,o,r,s,a,l,c,d,u,h,f,p=this.layers[e].linksTo[t],m=0,g=p.length;for(l=0;l<g;l++)for(n=p[l],c=l+1;c<g;c++)i=p[c],n.target.layer===t?(o=n.source,r=n.target):(o=n.target,r=n.source),i.target.layer===t?(s=i.source,a=i.target):(s=i.target,a=i.source),d=o.gridPosition,u=r.gridPosition,h=s.gridPosition,f=a.gridPosition,(d-h)*(u-f)<0&&m++;return m},calcBaryCenter:function(e){var t=e.upstreamLinkCount,n=e.downstreamLinkCount,i=e.uBaryCenter,o=e.dBaryCenter;return t>0&&n>0?(i+o)/2:t>0?i:n>0?o:0},_gridPositionComparer:function(e,t){return e.gridPosition<t.gridPosition?-1:e.gridPosition>t.gridPosition?1:0},_positionAscendingComparer:function(e,t){return e.k<t.k?-1:e.k>t.k?1:0},_positionDescendingComparer:function(e,t){return e.k<t.k?1:e.k>t.k?-1:0},_firstVirtualNode:function(e){for(var t=0;t<e.length;t++)if(e[t].isVirtual)return t;return-1},compareByIndex:function(e,t){var n=e.index,i=t.index;return n<i?1:n>i?-1:0},intDiv:function(e,t){return(e-e%t)/t},nextVirtualNode:function(e,t){var n,i=t.layerIndex;for(n=i+1;n<e.length;++n)if(e[n].isVirtual)return e[n];return null}}),S=n.Class.extend({init:function(e,t){if(f.isUndefined(e))throw"No diagram given";this.diagram=e,this.nodeMap=new d,this.linkMap=new d,this.capture(t?t:e)},capture:function(e){var t,n,o,r,s,a,l,d,u;if(e instanceof i.Graph){for(r=0;r<e.nodes.length;r++)t=e.nodes[r],o=t.associatedShape,this.nodeMap.set(o.visual.id,new c(t.x,t.y,t.width,t.height));for(r=0;r<e.links.length;r++)a=e.links[r],s=a.associatedConnection,this.linkMap.set(s.visual.id,a.points())}else if(e instanceof Array)for(n=e,r=0;r<n.length;r++)t=n[r],o=t.associatedShape,o&&this.nodeMap.set(o.visual.id,new c(t.x,t.y,t.width,t.height));else if(e.hasOwnProperty("links")&&e.hasOwnProperty("nodes")){for(n=e.nodes,l=e.links,r=0;r<n.length;r++)t=n[r],o=t.associatedShape,o&&this.nodeMap.set(o.visual.id,new c(t.x,t.y,t.width,t.height));for(r=0;r<l.length;r++)a=l[r],s=a.associatedConnection,s&&this.linkMap.set(s.visual.id,a.points)}else{for(d=this.diagram.shapes,u=this.diagram.connections,r=0;r<d.length;r++)o=d[r],this.nodeMap.set(o.visual.id,o.bounds());for(r=0;r<u.length;r++)s=u[r],this.linkMap.set(s.visual.id,s.points())}}});a(i,{init:function(e){n.init(e,i.ui)},SpringLayout:y,TreeLayout:x,GraphAdapter:w,LayeredLayout:C,LayoutBase:b,LayoutState:S})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("dataviz/diagram/dom.min",["kendo.data.min","kendo.draganddrop.min","kendo.toolbar.min","kendo.editable.min","kendo.window.min","kendo.dropdownlist.min","kendo.dataviz.core.min","kendo.dataviz.themes.min","dataviz/diagram/svg.min","dataviz/diagram/services.min","dataviz/diagram/layout.min"],e)}(function(){!function(e,t){function n(e){var t=e.originalEvent,n=0;return t.wheelDelta?(n=-t.wheelDelta/40,n=n>0?ye.ceil(n):ye.floor(n)):t.detail&&(n=t.detail),n}function i(e){return e.options.name.toLowerCase()===ze.toLowerCase()}function o(e,t){var n,o,r,s,a=Ne;for(r=0;r<t.length;r++)o=t[r],i(o)||(s=e.distanceTo(o.position()),s<a&&(a=s,n=o));return n}function r(e,t){var n,i,o,r=[],s=e.drawingContainer().children,a=s.length;for(n=0;n<t.length;n++)for(i=t[n],o=0;o<a;o++)if(s[o]==i.drawingContainer()){r.push(o);break}return r}function s(e){var t={};return e=e||{},ge(e.text)&&null!==e.text&&(t.text=e.text),ge(e.x)&&null!==e.x&&(t.x=e.x),ge(e.y)&&null!==e.y&&(t.y=e.y),ge(e.width)&&null!==e.width&&(t.width=e.width),ge(e.height)&&null!==e.height&&(t.height=e.height),ge(e.type)&&null!==e.type&&(t.type=e.type),t}function a(e){var t={};return e=e||{},ge(e.text)&&null!==e.text&&(t.content=e.text),ge(e.type)&&null!==e.type&&(t.type=e.type),ge(e.from)&&null!==e.from&&(t.from=e.from),ge(e.fromConnector)&&null!==e.fromConnector&&(t.fromConnector=e.fromConnector),ge(e.fromX)&&null!==e.fromX&&(t.fromX=e.fromX),ge(e.fromY)&&null!==e.fromY&&(t.fromY=e.fromY),ge(e.to)&&null!==e.to&&(t.to=e.to),ge(e.toConnector)&&null!==e.toConnector&&(t.toConnector=e.toConnector),ge(e.toX)&&null!==e.toX&&(t.toX=e.toX),ge(e.toY)&&null!==e.toY&&(t.toY=e.toY),t}function l(t,n){var i,o=this.dataSource.reader.model;o&&(i=o.fn.fields.text?"text":o.idField,e("<input name='"+n.field+"' />").appendTo(t).kendoDropDownList({dataValueField:o.idField,dataTextField:i,dataSource:this.dataSource.data().toJSON(),optionLabel:" ",valuePrimitive:!0}))}function c(e){this.dataItem=e,this.callbacks=[]}function d(){this.items={}}function u(e){var t=e;return e instanceof kendo.data.Model&&(t=e.toJSON(),t[e.idField]=e._defaultId),t}function h(e){var t,n,i=[],o=[];for(n=0;n<e.length;n++)t=e[n],t instanceof y?o.push(t):i.push(t);return{shapes:o,connections:i}}function f(e,t){return e.reader.model?new e.reader.model(t):new kendo.data.ObservableObject(t)}function p(e,t){ge(t[e])&&t.set(e,null)}function m(e,t,n){var i,o;for(o=0;o<n.length;o++)i=n[o],t&&!ge(t[i])&&(t[i]=e[i])}function g(e){var t=e.drawingContainer().clippedBBox(null);0===t.origin.x&&0===t.origin.y||e.position(-t.origin.x,-t.origin.y)}function v(e){e.preventDefault()}var _,b,w,y,k,x,C,S,T,D,A,E,I=kendo.dataviz,M=kendo.drawing,R=kendo.geometry,F=I.diagram,z=kendo.ui.Widget,P=kendo.Class,B=e.proxy,L=kendo.deepExtend,H=kendo._outerWidth,N=kendo._outerHeight,O=e.extend,V=kendo.data.HierarchicalDataSource,U=F.Canvas,W=F.Group,j=F.Rectangle,q=F.Circle,G=F.CompositeTransform,$=F.Rect,K=F.Path,Y=F.DeleteShapeUnit,Q=F.DeleteConnectionUnit,X=F.TextBlock,Z=F.Image,J=F.Point,ee=F.Intersect,te=F.ConnectionEditAdorner,ne=F.UndoRedoService,ie=F.ToolService,oe=F.Selector,re=F.ResizingAdorner,se=F.ConnectorsAdorner,ae=F.Cursors,le=F.Utils,ce=kendo.Observable,de=F.ToBackUnit,ue=F.ToFrontUnit,he=F.PolylineRouter,fe=F.CascadingRouter,pe=le.isUndefined,me=le.isDefined,ge=M.util.defined,ve=e.isArray,_e=kendo.isFunction,be=le.isString,we=e.isPlainObject,ye=Math,ke=["sass","default-v2","bootstrap-v4"],xe=".kendoDiagram",Ce="cascading",Se="itemBoundsChange",Te="change",De="click",Ae="drag",Ee="dragEnd",Ie="dragStart",Me="mouseEnter",Re="mouseLeave",Fe="error",ze="Auto",Pe="Top",Be="Right",Le="Left",He="Bottom",Ne=9007199254740992,Oe="select",Ve="itemRotate",Ue="pan",We="zoomStart",je="zoomEnd",qe="none",Ge=600,$e=600,Ke="rectangle",Ye=100,Qe=100,Xe=20,Ze=20,Je=0,et="Yellow",tt=Number.MAX_VALUE,nt=-Number.MAX_VALUE,it="absolute",ot="transformed",rt="rotated",st="transparent",at="width",lt="height",ct="x",dt="y",ut="DOMMouseScroll"+xe+" mousewheel"+xe,ht=.05,ft=5,pt='<a class="k-button k-button-icontext #=className#" href="\\#"><span class="#=iconClass# #=imageClass#"></span>#=text#</a>',mt=5;F.DefaultConnectors=[{name:Pe},{name:He},{name:Le},{name:Be},{name:ze,position:function(e){return e.getPosition("center")}}],_={cancel:{text:"Cancel",imageClass:"k-i-cancel",className:"k-diagram-cancel",iconClass:"k-icon"},update:{text:"Update",imageClass:"k-i-checkmark",className:"k-diagram-update",iconClass:"k-icon"}},F.shapeDefaults=function(e){var t={type:Ke,path:"",autoSize:!0,visual:null,x:Je,y:Je,minWidth:Xe,minHeight:Ze,width:Ye,height:Qe,hover:{},editable:{connect:!0,tools:[]},connectors:F.DefaultConnectors,rotation:{angle:0}};return le.simpleExtend(t,e),t},b=ce.extend({init:function(e){var t=this;t.dataItem=(e||{}).dataItem,ce.fn.init.call(t),t.options=L({id:F.randomId()},t.options,e),t.isSelected=!1,t.visual=new W({id:t.options.id,autoSize:t.options.autoSize}),t.id=t.options.id,t._template()},options:{hover:{},cursor:ae.grip,content:{align:"center middle"},selectable:!0,serializable:!0,enable:!0},_getCursor:function(e){return this.adorner?this.adorner._getCursor(e):this.options.cursor},visible:function(e){return pe(e)?this.visual.visible():(this.visual.visible(e),t)},bounds:function(){},refresh:function(){this.visual.redraw()},position:function(e){this.options.x=e.x,this.options.y=e.y,this.visual.position(e)},toString:function(){return this.options.id},serialize:function(){var e=L({},{options:this.options});return this.dataItem&&(e.dataItem=""+this.dataItem),e},_content:function(e){var n,i,o;return e!==t&&(n=this.options,F.Utils.isString(e)?n.content.text=e:L(n.content,e),i=n.content,o=this._contentVisual,o?this._updateContentVisual(i):this._createContentVisual(i)),this.options.content.text},_createContentVisual:function(e){e.text&&(this._contentVisual=new X(e),this._contentVisual._includeInBBox=!1,this.visual.append(this._contentVisual))},_updateContentVisual:function(e){this._contentVisual.redraw(e)},_hitTest:function(e){var t=this.bounds();return this.visible()&&t.contains(e)&&this.options.enable},_template:function(){var e,t,n=this;n.options.content.template&&(e=n.dataItem||{},t=kendo.template(n.options.content.template,{paramName:"dataItem"}),n.options.content.text=t(e))},_canSelect:function(){return this.options.selectable!==!1},toJSON:function(){return{id:this.options.id}}}),w=P.extend({init:function(e,t){this.options=L({},this.options,t),this.connections=[],this.shape=e},options:{width:7,height:7,fill:{color:et},hover:{}},position:function(){return this.options.position?this.options.position(this.shape):this.shape.getPosition(this.options.name)},toJSON:function(){return{shapeId:""+this.shape,connector:this.options.name}}}),w.parse=function(e,t){var n,i,o=t.split(":"),r=o[0],s=o[1]||ze;for(n=0;n<e.shapes.length;n++)if(i=e.shapes[n],i.options.id==r)return i.getConnector(s.trim())},y=b.extend({init:function(e,t){var n=this;b.fn.init.call(n,e),this.diagram=t,this.updateOptionsFromModel(),e=n.options,n.connectors=[],n.type=e.type,n.createShapeVisual(),n.updateBounds(),n.content(n.content()),n._createConnectors()},options:F.shapeDefaults(),_setOptionsFromModel:function(e){var t=s(e||this.dataItem);this.options=L({},this.options,t),this.redrawVisual()},updateOptionsFromModel:function(e,t){var n,i;this.diagram&&this.diagram._isEditable&&(n=s(e||this.dataItem),e&&t?I.inArray(t,["x","y","width","height"])?(i=this.bounds(),i[t]=e[t],this.bounds(i)):(this.options.visual?this._redrawVisual():n.type&&(this.options=L({},this.options,n),this._redrawVisual()),this.options.content&&(this._template(),this.content(this.options.content))):this.options=L({},this.options,n))},_redrawVisual:function(){this.visual.clear(),this._contentVisual=null,this.options.dataItem=this.dataItem,this.createShapeVisual(),this.updateBounds()},redrawVisual:function(){this._redrawVisual(),this.options.content&&(this._template(),this.content(this.options.content))},updateModel:function(e){var t,n,i=this.diagram;i&&i._isEditable&&(t=this._bounds,n=this.dataItem,n&&(i._suspendModelRefresh(),ge(n.x)&&t.x!==n.x&&n.set("x",t.x),ge(n.y)&&t.y!==n.y&&n.set("y",t.y),ge(n.width)&&t.width!==n.width&&n.set("width",t.width),ge(n.height)&&t.height!==n.height&&n.set("height",t.height),this.dataItem=n,i._resumeModelRefresh(),e&&i._syncShapeChanges()))},updateBounds:function(){var e=this.visual._measure(!0),t=this.options;this.bounds(new $(t.x,t.y,e.width,e.height)),this._rotate(),this._alignContent()},content:function(e){var t=this._content(e);return this._alignContent(),t},_alignContent:function(){var e,t,n,i,o,r=this.options.content||{},s=this._contentVisual;s&&r.align&&(e=this.visual._measure(),t=new F.RectAlign(e),n=s.drawingElement.bbox(null),i=new $(0,0,n.width(),n.height()),o=t.align(i,r.align),s.position(o.topLeft()))},_createConnectors:function(){var e,t,n=this.options,i=n.connectors.length,o=n.connectorDefaults;for(t=0;t<i;t++)e=new w(this,L({},o,n.connectors[t])),this.connectors.push(e)},bounds:function(e){var t,n;if(e)if(be(e))switch(e){case ot:t=this._transformedBounds();break;case it:t=this._transformedBounds(),n=this.diagram._pan,t.x+=n.x,t.y+=n.y;break;case rt:t=this._rotatedBounds();break;default:t=this._bounds}else this._setBounds(e),this._triggerBoundsChange(),this.diagram&&this.diagram._layouting||this.refreshConnections();else t=this._bounds;return t},_setBounds:function(e){var t=this.options,n=e.topLeft(),i=t.x=n.x,o=t.y=n.y,r=t.width=ye.max(e.width,t.minWidth),s=t.height=ye.max(e.height,t.minHeight);this._bounds=new $(i,o,r,s),this.visual.redraw({x:i,y:o,width:r,height:s})},position:function(e){return e?(this.bounds(new $(e.x,e.y,this._bounds.width,this._bounds.height)),t):this._bounds.topLeft()},clone:function(){var e=this.serialize();return e.options.id=F.randomId(),this.diagram&&this.diagram._isEditable&&ge(this.dataItem)&&(e.options.dataItem=u(this.dataItem)),new y(e.options)},select:function(e){var t,n,i=this.diagram;if(pe(e)&&(e=!0),this._canSelect()&&this.isSelected!=e)return t=[],n=[],this.isSelected=e,this.isSelected?(i._selectedItems.push(this),t.push(this)):(le.remove(i._selectedItems,this),n.push(this)),i._internalSelection||i._selectionChanged(t,n),!0},rotate:function(e,n,i){var o,r,s,a,l=this.visual.rotate();return e!==t&&(i!==!1&&this.diagram&&this.diagram.undoRedoService&&e!==l.angle&&this.diagram.undoRedoService.add(new F.RotateUnit(this.diagram._resizingAdorner,[this],[l.angle]),!1),o=this.bounds(),r=new J(o.width/2,o.height/2),n&&(s=e-l.angle,a=o.center().rotate(n,360-s).minus(r),this._rotationOffset=this._rotationOffset.plus(a.minus(o.topLeft())),this.position(a)),this.visual.rotate(e,r),this.options.rotation.angle=e,this.diagram&&this.diagram._connectorsAdorner&&this.diagram._connectorsAdorner.refresh(),this.refreshConnections(),this.diagram&&this.diagram.trigger(Ve,{item:this})),l},connections:function(e){var t,n,i,o,r,s,a,l=[];for(t=0;t<this.connectors.length;t++)for(r=this.connectors[t],o=r.connections,n=0,o;n<o.length;n++)i=o[n],"out"==e?(s=i.source(),s.shape&&s.shape==this&&l.push(i)):"in"==e?(a=i.target(),a.shape&&a.shape==this&&l.push(i)):l.push(i);return l},refreshConnections:function(){e.each(this.connections(),function(){this.refresh()})},getConnector:function(e){var t,n;if(!be(e))return e instanceof J?o(e,this.connectors):this.connectors.length?this.connectors[0]:null;for(e=e.toLocaleLowerCase(),t=0;t<this.connectors.length;t++)if(n=this.connectors[t],n.options.name.toLocaleLowerCase()==e)return n},getPosition:function(e){var t=this.bounds(),n=e.charAt(0).toLowerCase()+e.slice(1);return _e(t[n])?this._transformPoint(t[n]()):t.center()},redraw:function(e){var t,n;e&&(t=this.options,this.shapeVisual.redraw(this._visualOptions(e)),this._diffNumericOptions(e,[at,lt,ct,dt])&&(this.bounds(new $(t.x,t.y,t.width,t.height)),n=!0),e.connectors&&(t.connectors=e.connectors,this._updateConnectors()),t=L(t,e),(e.rotation||n)&&this._rotate(),t.content&&this.content(t.content))},_updateConnectors:function(){var e,t,n,i,o=this.connections();for(this.connectors=[],this._createConnectors(),i=0;i<o.length;i++)e=o[i],t=e.source(),n=e.target(),t.shape&&t.shape===this?e.source(this.getConnector(t.options.name)||null):n.shape&&n.shape===this&&e.target(this.getConnector(n.options.name)||null),e.updateModel()},_diffNumericOptions:F.diffNumericOptions,_visualOptions:function(e){return{data:e.path,source:e.source,hover:e.hover,fill:e.fill,stroke:e.stroke}},_triggerBoundsChange:function(){this.diagram&&this.diagram.trigger(Se,{item:this,bounds:this._bounds.clone()})},_transformPoint:function(e){var t=this.rotate(),n=this.bounds(),i=n.topLeft();return t.angle&&e.rotate(t.center().plus(i),360-t.angle),e},_transformedBounds:function(){var e=this.bounds(),t=e.topLeft(),n=e.bottomRight();return $.fromPoints(this.diagram.modelToView(t),this.diagram.modelToView(n))},_rotatedBounds:function(){var e=this.bounds().rotatedBounds(this.rotate().angle),t=e.topLeft(),n=e.bottomRight();return $.fromPoints(t,n)},_rotate:function(){var e=this.options.rotation;e&&e.angle&&this.rotate(e.angle),this._rotationOffset=new J},_hover:function(e){var t=this.options,n=t.hover,i=t.stroke,o=t.fill;e&&me(n.stroke)&&(i=L({},i,n.stroke)),e&&me(n.fill)&&(o=n.fill),this.shapeVisual.redraw({stroke:i,fill:o}),t.editable&&t.editable.connect&&this.diagram._showConnectors(this,e)},_hitTest:function(e){if(this.visible()){var t,n=this.bounds(),i=this.rotate().angle;if(e.isEmpty&&!e.isEmpty())return ee.rects(e,n,i?i:0);if(t=e.clone().rotate(n.center(),i),n.contains(t))return this}},toJSON:function(){return{shapeId:this.options.id}},createShapeVisual:function(){var e,t=this.options,n=this._visualOptions(t),i=t.visual,o=(t.type+"").toLocaleLowerCase();n.width=t.width,n.height=t.height,_e(i)?e=i.call(this,t):n.data?(e=new K(n),g(e)):e="rectangle"==o?new j(n):"circle"==o?new q(n):"text"==o?new X(n):"image"==o?new Z(n):new K(n),this.shapeVisual=e,this.visual.append(this.shapeVisual)}}),k=b.extend({init:function(e,t,n){var i=this;b.fn.init.call(i,n),this.updateOptionsFromModel(),this._initRouter(),i.path=new F.Polyline(i.options),i.path.fill(st),i.visual.append(i.path),i._sourcePoint=i._targetPoint=new J,i._setSource(e),i._setTarget(t),i.content(i.options.content),i.definers=[],ge(n)&&n.points&&i.points(n.points)},options:{hover:{stroke:{}},startCap:qe,endCap:qe,points:[],selectable:!0,fromConnector:ze,toConnector:ze},_setOptionsFromModel:function(e){this.updateOptionsFromModel(e||this.dataItem)},updateOptionsFromModel:function(e){var t,n,i,o;this.diagram&&this.diagram._isEditable&&(t=this.diagram._dataMap,n=a(e||this.dataItem),e?(ge(n.from)?(i=t[n.from],i&&ge(n.fromConnector)&&(i=i.getConnector(n.fromConnector)),this.source(i)):ge(n.fromX)&&ge(n.fromY)&&this.source(new J(n.fromX,n.fromY)),ge(n.to)?(o=t[n.to],o&&ge(n.toConnector)&&(o=o.getConnector(n.toConnector)),this.target(o)):ge(n.toX)&&ge(n.toY)&&this.target(new J(n.toX,n.toY)),ge(n.type)&&this.type()!==n.type&&(this.points([]),this.type(n.type)),this.dataItem=e,this._template(),this.redraw(this.options)):this.options=L({},n,this.options))},updateModel:function(e){if(this.diagram&&this.diagram._isEditable&&this.diagram.connectionsDataSource){var t=this.diagram.connectionsDataSource.getByUid(this.dataItem.uid);t&&(this.diagram._suspendModelRefresh(),ge(this.options.fromX)&&null!==this.options.fromX?(p("from",t),p("fromConnector",t),t.set("fromX",this.options.fromX),t.set("fromY",this.options.fromY)):(t.set("from",this.options.from),ge(t.fromConnector)&&t.set("fromConnector",this.sourceConnector?this.sourceConnector.options.name:null),p("fromX",t),p("fromY",t)),ge(this.options.toX)&&null!==this.options.toX?(p("to",t),p("toConnector",t),t.set("toX",this.options.toX),t.set("toY",this.options.toY)):(t.set("to",this.options.to),ge(t.toConnector)&&t.set("toConnector",this.targetConnector?this.targetConnector.options.name:null),p("toX",t),p("toY",t)),ge(this.options.type)&&ge(t.type)&&t.set("type",this.options.type),this.dataItem=t,this.diagram._resumeModelRefresh(),e&&this.diagram._syncConnectionChanges())}},sourcePoint:function(){return this._resolvedSourceConnector?this._resolvedSourceConnector.position():this._sourcePoint},_setSource:function(e){var n,i=e instanceof y,o=this.options.fromConnector||ze;i&&!e.getConnector(o)||(e!==t&&(this.from=e),this._removeFromSourceConnector(),null===e?this.sourceConnector&&(this._sourcePoint=(this._resolvedSourceConnector||this.sourceConnector).position(),this._clearSourceConnector(),this._setFromOptions(null,this._sourcePoint)):e instanceof w?(n=e.shape.dataItem,n&&this._setFromOptions(n.id),this.sourceConnector=e,this.sourceConnector.connections.push(this)):e instanceof J?(this._setFromOptions(null,e),this._sourcePoint=e,this.sourceConnector&&this._clearSourceConnector()):i&&(n=e.dataItem,n&&this._setFromOptions(n.id),this.sourceConnector=e.getConnector(o),this.sourceConnector.connections.push(this)))},source:function(e,t){return me(e)&&(t&&this.diagram&&this.diagram.undoRedoService.addCompositeItem(new F.ConnectionEditUnit(this,e)),this._setSource(e),this.refresh()),this.sourceConnector?this.sourceConnector:this._sourcePoint},_setFromOptions:function(e,t){this.options.from=e,t?(this.options.fromX=t.x,this.options.fromY=t.y):(this.options.fromX=null,this.options.fromY=null)},sourceDefiner:function(e){if(!e)return this._sourceDefiner||(this._sourceDefiner=new F.PathDefiner(this.sourcePoint(),null,null)),this._sourceDefiner;if(!(e instanceof F.PathDefiner))throw"The sourceDefiner needs to be a PathDefiner.";e.left=null,this._sourceDefiner=e,this.source(e.point)},targetPoint:function(){return this._resolvedTargetConnector?this._resolvedTargetConnector.position():this._targetPoint},_setTarget:function(e){var n,i=e instanceof y,o=this.options.toConnector||ze;i&&!e.getConnector(o)||(e!==t&&(this.to=e),this._removeFromTargetConnector(),null===e?this.targetConnector&&(this._targetPoint=(this._resolvedTargetConnector||this.targetConnector).position(),this._clearTargetConnector(),this._setToOptions(null,this._targetPoint)):e instanceof w?(n=e.shape.dataItem,n&&this._setToOptions(n.id),this.targetConnector=e,this.targetConnector.connections.push(this)):e instanceof J?(this._setToOptions(null,e),this._targetPoint=e,this.targetConnector&&this._clearTargetConnector()):i&&(n=e.dataItem,n&&this._setToOptions(n.id),this.targetConnector=e.getConnector(o),this.targetConnector.connections.push(this)))},target:function(e,n){return me(e)&&(n&&this.diagram&&this.diagram.undoRedoService.addCompositeItem(new F.ConnectionEditUnit(this,t,e)),this._setTarget(e),this.refresh()),this.targetConnector?this.targetConnector:this._targetPoint},_setToOptions:function(e,t){this.options.to=e,t?(this.options.toX=t.x,this.options.toY=t.y):(this.options.toX=null,this.options.toY=null)},targetDefiner:function(e){if(!e)return this._targetDefiner||(this._targetDefiner=new F.PathDefiner(this.targetPoint(),null,null)),this._targetDefiner;if(!(e instanceof F.PathDefiner))throw"The sourceDefiner needs to be a PathDefiner.";e.right=null,this._targetDefiner=e,this.target(e.point)},_updateConnectors:function(){this._updateConnector(this.source(),"source"),this._updateConnector(this.target(),"target")},_updateConnector:function(e,t){var n,i,o,r,s=this,a=s.diagram;e instanceof w&&!a.getShapeById(e.shape.id)?(n=e.shape.dataItem,i=e.options.name,o=function(){var o=a._dataMap[n.id];e=o.getConnector(i),s[t](e,!1),s.updateModel()},a._dataMap[n.id]?o():(r=a._inactiveShapeItems.getByUid(n.uid),r&&a._deferredConnectionUpdates.push(r.onActivate(o)))):s[t](e,!1)},content:function(e){var t=this._content(e);return ge(e)&&this._alignContent(),t},_createContentVisual:function(e){var t;return _e(e.visual)?t=e.visual.call(this,e):e.text&&(t=new X(e)),t&&(this._contentVisual=t,t._includeInBBox=!1,this.visual.append(t)),t},_updateContentVisual:function(e){_e(e.visual)?(this.visual.remove(this._contentVisual),this._createContentVisual(e)):this._contentVisual.redraw(e)},_alignContent:function(){var e,t,n,i,o,r,s,a,l,c,d,u,h,f,p,m;if(this._contentVisual){for(e=mt,t=this.allPoints(),n=ye.floor(t.length/2),i=n-1;i>0&&t[i].equals(t[n]);)i--,n++;o=t[n],r=t[i],s=this._contentVisual._measure(),a=s.width,l=s.height,c=t.length%2===0,d=r.distanceTo(o),c&&t.length>2&&d>0&&(r.y===o.y&&d<a||r.x===o.x&&d<l)&&(c=!1,e=0),c?(h=M.util.deg(ye.atan2(o.y-r.y,o.x-r.x)),u=new J((o.x-r.x)/2+r.x,(o.y-r.y)/2+r.y),90===ye.abs(h)?(u.x+=e,u.y-=l/2):h%180===0?(u.x-=a/2,u.y-=l+e):h<-90||0<h&&h<90?u.y-=l:(h<0||h>90)&&(u.x-=a,u.y-=l)):(f=ye.floor(t.length/2),u=t[f].clone(),r=t[f-1],o=t[f+1],p=r.x<=u.x&&o.x<=u.x?e:-s.width-e,m=r.y<=u.y&&o.y<=u.y?e:-s.height-e,u.x+=p,u.y+=m),this._contentVisual.position(u)}},select:function(e){var n,i,o=this.diagram;if(this._canSelect()&&this.isSelected!==e)return this.isSelected=e,n=[],i=[],this.isSelected?(this.adorner=new te(this,this.options.selection),o._adorn(this.adorner,!0),o._selectedItems.push(this),n.push(this)):this.adorner&&(o._adorn(this.adorner,!1),le.remove(o._selectedItems,this),this.adorner=t,i.push(this)),this.adorner&&this.adorner.refresh(),o._internalSelection||o._selectionChanged(n,i),!0},bounds:function(e){return!e||be(e)?this._bounds:(this._bounds=e,t)},type:function(e){var n=this.options;return e?(e!==n.type&&(n.type=e,this._initRouter(),this.refresh()),t):n.type},_initRouter:function(){var e=(this.options.type||"").toLowerCase();this._router=e==Ce?new fe(this):new he(this)},points:function(e){var t,n,i,o;if(!e){if(i=[],me(this.definers))for(o=0;o<this.definers.length;o++)i.push(this.definers[o].point);return i}for(this.definers=[],t=0;t<e.length;t++)if(n=e[t],n instanceof F.Point)this.definers.push(new F.PathDefiner(n));else{if(!n.hasOwnProperty("x")||!n.hasOwnProperty("y"))throw"A Connection point needs to be a Point or an object with x and y properties.";this.definers.push(new F.PathDefiner(new J(n.x,n.y)))}},allPoints:function(){var e,t=[this.sourcePoint()];if(this.definers)for(e=0;e<this.definers.length;e++)t.push(this.definers[e].point);return t.push(this.targetPoint()),t},refresh:function(){this._resolveConnectors(),this._refreshPath(),this._alignContent(),this.adorner&&this.adorner.refresh()},_resolveConnectors:function(){var e,t,n,r,s=this,a=s.source(),l=s.target();a instanceof J?e=a:a instanceof w&&(n=i(a)?a.shape.connectors:[a]),l instanceof J?t=l:l instanceof w&&(r=i(l)?l.shape.connectors:[l]),
e?r&&(s._resolvedTargetConnector=o(e,r)):n&&(t?s._resolvedSourceConnector=o(t,n):r&&this._resolveAutoConnectors(n,r))},_resolveAutoConnectors:function(e,t){var n,o,r,s,a,l,c,d,u,h,f,p=Ne,m=Ne;for(u=0;u<e.length;u++)if(c=e[u],!i(c))for(r=c.position(),h=0;h<t.length;h++)d=t[h],i(d)||(s=d.position(),f=ye.round(r.distanceTo(s)),f<p&&this.diagram&&this._testRoutePoints(r,s,c,d)&&(p=f,n=c,o=d),f<m&&(a=c,l=d,m=f));n&&(a=n,l=o),this._resolvedSourceConnector=a,this._resolvedTargetConnector=l},_testRoutePoints:function(e,t,n,i){var o,r,s,a,l,c,d=this._router,u=!0;if(d instanceof fe)for(o=d.routePoints(e,t,n,i),l=this._getRouteExclude(e,t,n.shape,i.shape),o.unshift(e),o.push(t),c=1;c<o.length;c++)if(r=o[c-1],s=o[c],a=new $(ye.min(r.x,s.x),ye.min(r.y,s.y),ye.abs(r.x-s.x),ye.abs(r.y-s.y)),a.width>0&&(a.x++,a.width-=2),a.height>0&&(a.y++,a.height-=2),!a.isEmpty()&&this.diagram._shapesQuadTree.hitTestRect(a,l)){u=!1;break}return u},_getRouteExclude:function(e,t,n,i){var o=[];return this._isPointInsideShape(e,n)&&o.push(n),this._isPointInsideShape(t,i)&&o.push(i),o},_isPointInsideShape:function(e,t){var n,i,o,r=t.bounds(),s=t.rotate().angle,a=r.x,l=r.y;return n=e.clone().rotate(r.center(),s),i=n.x,o=n.y,i>a&&i<a+r.width&&o>l&&o<l+r.height},redraw:function(e){if(e){this.options=L({},this.options,e);var t=this.options.points;ge(t)&&t.length>0&&(this.points(t),this._refreshPath()),(e&&e.content||e.text)&&this.content(e.content),this.path.redraw({fill:e.fill,stroke:e.stroke,startCap:e.startCap,endCap:e.endCap})}},clone:function(){var e=this.serialize();return this.diagram&&this.diagram._isEditable&&ge(this.dataItem)&&(e.options.dataItem=u(this.dataItem)),new k(this.from,this.to,e.options)},serialize:function(){var e=this.from.toJSON?this.from.toJSON:""+this.from,t=this.to.toJSON?this.to.toJSON:""+this.to,n=L({},{options:this.options,from:e,to:t});return ge(this.dataItem)&&(n.dataItem=""+this.dataItem),n.options.points=this.points(),n},_hitTest:function(e){if(this.visible()){var t=new J(e.x,e.y),n=this.sourcePoint(),i=this.targetPoint();if(e.isEmpty&&!e.isEmpty()&&e.contains(n)&&e.contains(i))return this;if(this._router.hitTest(t))return this}},_hover:function(e){var t=(this.options.stroke||{}).color;e&&me(this.options.hover.stroke.color)&&(t=this.options.hover.stroke.color),this.path.redraw({stroke:{color:t}})},_refreshPath:function(){ge(this.path)&&(this._drawPath(),this.bounds(this._router.getBounds()))},_drawPath:function(){var e,t,n;this._router&&this._router.route(),e=this.sourcePoint(),t=this.targetPoint(),n=this.points(),this.path.redraw({points:[e].concat(n,[t])})},_clearSourceConnector:function(){this.sourceConnector=t,this._resolvedSourceConnector=t},_clearTargetConnector:function(){this.targetConnector=t,this._resolvedTargetConnector=t},_removeFromSourceConnector:function(){this.sourceConnector&&le.remove(this.sourceConnector.connections,this)},_removeFromTargetConnector:function(){this.targetConnector&&le.remove(this.targetConnector.connections,this)},toJSON:function(){var e,t,n,i=this;return i.from&&i.from.toJSON?e=i.from.toJSON():(n=i._sourcePoint,e={x:n.x,y:n.y}),i.to&&i.to.toJSON?t=i.to.toJSON():(n=i._targetPoint,t={x:n.x,y:n.y}),{from:e,to:t}}}),x=z.extend({init:function(e,t){var n=this;kendo.destroy(e),z.fn.init.call(n,e,t),n._initTheme(),n._initElements(),n._extendLayoutOptions(n.options),n._initDefaults(t),n._interactionDefaults(),n._initCanvas(),n.mainLayer=new W({id:"main-layer"}),n.canvas.append(n.mainLayer),n._shapesQuadTree=new E(n),n._pan=new J,n._adorners=[],n.adornerLayer=new W({id:"adorner-layer"}),n.canvas.append(n.adornerLayer),n._createHandlers(),n._initialize(),n._resizingAdorner=new re(n,{editable:n.options.editable}),n._connectorsAdorner=new se(n),n._adorn(n._resizingAdorner,!0),n._adorn(n._connectorsAdorner,!0),n.selector=new oe(n),n._clipboard=[],n.pauseMouseHandlers=!1,n._fetchFreshData(),n._createGlobalToolBar(),n._createOptionElements(),n.zoom(n.options.zoom),n.canvas.draw()},options:{name:"Diagram",theme:"default",layout:"",zoomRate:.1,zoom:1,zoomMin:0,zoomMax:2,dataSource:{},draggable:!0,template:"",autoBind:!0,editable:{rotate:{},resize:{},text:!0,tools:[],drag:{snap:{size:10,angle:10}},remove:!0},pannable:{},selectable:{key:"none"},tooltip:{enabled:!0,format:"{0}"},copy:{enabled:!0,offsetX:20,offsetY:20},shapeDefaults:F.shapeDefaults({undoable:!0}),connectionDefaults:{editable:{tools:[]},type:Ce},shapes:[],connections:[]},events:[je,We,Ue,Oe,Ve,Se,Te,De,Me,Re,"toolBarClick","save","cancel","edit","remove","add","dataBound",Ie,Ae,Ee],items:function(){return e()},_createGlobalToolBar:function(){var e,t=this.options.editable;t&&(e=t.tools,!this._isEditable||e===!1||e&&0!==e.length||(e=["createShape","undo","redo","rotateClockwise","rotateAnticlockwise"]),e&&e.length&&(this.toolBar=new C(this,{tools:e||{},click:B(this._toolBarClick,this),modal:!1}),this.toolBar.element.css({textAlign:"left"}),this.element.prepend(this.toolBar.element),this._resize()))},createShape:function(){var e,t,n,i,o,r;(this.editor&&this.editor.end()||!this.editor)&&(e=this.dataSource,t=e.view()||[],n=t.length,i=f(e,{}),o=this._createShape(i,{}),this.trigger("add",{shape:o})||(e.insert(n,i),r=this._inactiveShapeItems.getByUid(i.uid),r.element=o,this.edit(o)))},_createShape:function(e,t){t=L({},this.options.shapeDefaults,t),t.dataItem=e;var n=new y(t,this);return n},createConnection:function(){var e,t,n,i,o;(this.editor&&this.editor.end()||!this.editor)&&(e=this.connectionsDataSource,t=e.view()||[],n=t.length,i=f(e,{}),o=this._createConnection(i),this.trigger("add",{connection:o})||(this._connectionsDataMap[i.uid]=o,e.insert(n,i),this.addConnection(o,!1),this.edit(o)))},_createConnection:function(e,t,n){var i,o=L({},this.options.connectionDefaults);return o.dataItem=e,i=new k(t||new J,n||new J,o)},editModel:function(e,t){var n,i,o,r;if(this.cancelEdit(),o=this.options.editable,"shape"==t)n=o.shapeEditors,i=o.shapeTemplate;else{if("connection"!=t)return;r=B(l,this),n=L({},{from:r,to:r},o.connectionEditors),i=o.connectionTemplate}this.editor=new T(this.element,{update:B(this._update,this),cancel:B(this._cancel,this),model:e,type:t,target:this,editors:n,template:i}),this.trigger("edit",this._editArgs())},edit:function(e){if(e.dataItem){var t=e instanceof y?"shape":"connection";this.editModel(e.dataItem,t)}},cancelEdit:function(){this.editor&&(this._getEditDataSource().cancelChanges(this.editor.model),this._destroyEditor())},saveEdit:function(){this.editor&&this.editor.end()&&!this.trigger("save",this._editArgs())&&this._getEditDataSource().sync()},_update:function(){this.editor&&this.editor.end()&&!this.trigger("save",this._editArgs())&&(this._getEditDataSource().sync(),this._destroyEditor())},_cancel:function(){var e,t;this.editor&&!this.trigger("cancel",this._editArgs())&&(e=this.editor.model,this._getEditDataSource().cancelChanges(e),t=this._connectionsDataMap[e.uid]||this._dataMap[e.id],t&&t._setOptionsFromModel(e),this._destroyEditor())},_getEditDataSource:function(){return"shape"===this.editor.options.type?this.dataSource:this.connectionsDataSource},_editArgs:function(){var e={container:this.editor.wrapper};return e[this.editor.options.type]=this.editor.model,e},_destroyEditor:function(){this.editor&&(this.editor.close(),this.editor=null)},_initElements:function(){this.wrapper=this.element.empty().css("position","relative").attr("tabindex",0).addClass("k-widget k-diagram"),this.scrollable=e("<div />").appendTo(this.element)},_initDefaults:function(e){var t=this.options,n=t.editable,i=t.shapeDefaults,o=t.connectionDefaults,r=(e||{}).shapeDefaults;n===!1?(i.editable=!1,o.editable=!1):(m(n,i.editable,["drag","remove","connect"]),m(n,o.editable,["drag","remove"])),r&&r.connectors&&(t.shapeDefaults.connectors=r.connectors)},_interactionDefaults:function(){var e=this.options,t=e.selectable,n=e.pannable,i=kendo.support.mobileOS;t&&!ge(t.multiple)&&(e.selectable=L({multiple:!i},e.selectable)),n&&!ge(n.key)&&(e.pannable=L({key:i?"none":"ctrl"},e.pannable))},_initCanvas:function(){var t=e("<div class='k-layer'></div>").appendTo(this.scrollable)[0],n=this.viewport();this.canvas=new U(t,{width:n.width||Ge,height:n.height||$e})},_createHandlers:function(){var e=this,t=e.element;t.on(ut,B(e._wheel,e)).on("keydown"+xe,B(e._keydown,e)),e._userEvents=new kendo.UserEvents(this.scrollable,{multiTouch:!0,fastTap:!0,tap:B(e._tap,e),start:B(e._dragStart,e),move:B(e._drag,e),end:B(e._dragEnd,e),gesturestart:B(e._gestureStart,e),gesturechange:B(e._gestureChange,e),gestureend:B(e._gestureEnd,e)}),e.toolService=new ie(e),this.scrollable.on("mouseover"+xe,B(e._mouseover,e)).on("mouseout"+xe,B(e._mouseout,e)).on("mousemove"+xe,B(e._mouseMove,e)).on("mousedown"+xe,B(e._mouseDown,e)).on("mouseup"+xe,B(e._mouseUp,e)),this._syncHandler=B(e._syncChanges,e),e._resizeHandler=B(e.resize,e,!1),kendo.onResize(e._resizeHandler),this.bind(We,B(e._destroyToolBar,e)),this.bind(Ue,B(e._destroyToolBar,e))},_dragStart:function(e){var t,n;this._pauseMouseHandlers=!0,t=this._eventPositions(e,!0),n=e.event,this.toolService.start(t,this._meta(n))&&(this._destroyToolBar(),n.preventDefault())},_drag:function(e){var t=this._eventPositions(e),n=e.event;this.toolService.move(t,this._meta(n))&&n.preventDefault()},_dragEnd:function(e){var t,n;this._pauseMouseHandlers=!1,t=this._eventPositions(e),n=e.event,this.toolService.end(t,this._meta(n))&&(this._createToolBar(),n.preventDefault())},_mouseMove:function(e){if(!this._pauseMouseHandlers){var t=this._eventPositions(e);this.toolService._updateHoveredItem(t),this.toolService._updateCursor(t)}},_mouseDown:function(){this._pauseMouseHandlers=!0},_mouseUp:function(){this._pauseMouseHandlers=!1},_tap:function(e){var t,n,i,o=this.toolService,r=this.options.selectable,s=this._eventPositions(e),a=this.focus();o._updateHoveredItem(s),o.hoveredItem?(t=o.hoveredItem,this.trigger("click",{item:t,point:s}),r&&t.options.selectable!==!1&&(n=r.multiple!==!1,i=kendo.support.mobileOS||this._meta(e.event).ctrlKey,t.isSelected?i?(this._destroyToolBar(),t.select(!1)):this._createToolBar(a):(this._destroyToolBar(),this.select(t,{addToSelection:n&&i}),this._createToolBar(a)))):r&&(this._destroyToolBar(),this.deselect())},_keydown:function(e){this.toolService.keyDown(e.keyCode,this._meta(e))&&e.preventDefault()},_wheel:function(e){var t=n(e),i=this._eventPositions(e),o=L(this._meta(e),{delta:t});this.toolService.wheel(i,o)&&e.preventDefault()},_meta:function(e){return{ctrlKey:e.ctrlKey,metaKey:e.metaKey,altKey:e.altKey,shiftKey:e.shiftKey,type:e.type}},_eventPositions:function(e,t){var n,i,o;return e.touch?(i=t?"startLocation":"location",n=new J(e.x[i],e.y[i])):(o=e.originalEvent,n=new J(o.pageX,o.pageY)),this.documentToModel(n)},_gestureStart:function(e){var t,n;this._destroyToolBar(),this.scroller.disable(),t=this.documentToModel(new J(e.center.x,e.center.y)),n={point:t,zoom:this.zoom()},this.trigger(We,n)||(this._gesture=e,this._initialCenter=t)},_gestureChange:function(e){var t,n,i=this._gesture,o=this._initialCenter,r=this.documentToView(new J(e.center.x,e.center.y)),s=e.distance/i.distance,a=this._zoom,l=!1;ye.abs(s-1)>=ht&&(this._zoom=a=this._getValidZoom(a*s),this.options.zoom=a,this._gesture=e,l=!0),t=o.times(a),n=r.minus(t),(l||this._pan.distanceTo(n)>=ft)&&(this._panTransform(n),this._updateAdorners()),e.preventDefault()},_gestureEnd:function(){this.options.pannable!==!1&&this.scroller.enable(),this.trigger(je,{point:this._initialCenter,zoom:this.zoom()})},_resize:function(){var e=this.viewport();this.canvas&&this.canvas.size(e),this.scrollable&&this.toolBar&&this.scrollable.height(e.height)},_mouseover:function(e){var t=e.target._kendoNode;t&&t.srcElement._hover&&t.srcElement._hover(!0,t.srcElement)},_mouseout:function(e){var t=e.target._kendoNode;t&&t.srcElement._hover&&t.srcElement._hover(!1,t.srcElement)},_initTheme:function(){var e,t=this,n=((t.options||{}).theme||"").toLowerCase(),i=I.ui.themes||{};e=ke.indexOf(n)!=-1?I.autoTheme().diagram:(i[n]||{}).diagram,t.options=L({},e,t.options),t.options.editable===!0&&L(t.options,{editable:(e||{}).editable})},_createOptionElements:function(){var e=this.options,t=e.shapes.length;t&&this._createShapes(),e.connections.length&&this._createConnections(),t&&e.layout&&this.layout(e.layout)},_createShapes:function(){var e,t,n=this,i=n.options,o=i.shapes;for(t=0;t<o.length;t++)e=o[t],n.addShape(e)},_createConnections:function(){var e,t,n,i,o=this,r=o.options,s=r.connectionDefaults,a=r.connections;for(i=0;i<a.length;i++)e=a[i],t=o._findConnectionTarget(e.from),n=o._findConnectionTarget(e.to),o.connect(t,n,L({},s,e))},_findConnectionTarget:function(e){var t,n,i;return e=e||{},t=this,n=be(e)?e:e.shapeId||e.id,n?(i=t.getShapeById(n),e.connector&&(i=i.getConnector(e.connector))):i=new J(e.x||0,e.y||0),i},destroy:function(){var e=this;z.fn.destroy.call(e),this._userEvents&&this._userEvents.destroy(),kendo.unbindResize(e._resizeHandler),e.clear(),e.element.off(xe),e.scroller.wrapper.off(xe),e.canvas.destroy(!0),e.canvas=t,e._destroyEditor(),e.destroyScroller(),e._destroyGlobalToolBar(),e._destroyToolBar()},destroyScroller:function(){var e=this.scroller;e&&(e.destroy(),e.element.remove(),this.scroller=null)},save:function(){var e,t,n,i={shapes:[],connections:[]};for(e=0;e<this.shapes.length;e++)n=this.shapes[e],n.options.serializable&&i.shapes.push(n.options);for(e=0;e<this.connections.length;e++)t=this.connections[e],i.connections.push(L({},t.options,t.toJSON()));return i},focus:function(){if(!this.element.is(kendo._activeElement())){var e,t=this.element,n=t[0],i=[],o=[],r=document.documentElement;do n=n.parentNode,n.scrollHeight>n.clientHeight&&(i.push(n),o.push(n.scrollTop));while(n!=r);for(t.focus(),e=0;e<i.length;e++)i[e].scrollTop=o[e];return!0}},load:function(e){this.clear(),this.setOptions(e),this._createShapes(),this._createConnections()},setOptions:function(e){L(this.options,e)},clear:function(){var e=this;e.select(!1),e.mainLayer.clear(),e._shapesQuadTree.clear(),e._initialize()},connect:function(e,t,n){var i,o;return this.connectionsDataSource&&this._isEditable?(o=this.connectionsDataSource.add({}),i=this._connectionsDataMap[o.uid],i.source(e),i.target(t),i.redraw(n),i.updateModel()):(i=new k(e,t,L({},this.options.connectionDefaults,n)),this.addConnection(i)),i},connected:function(e,t){var n,i;for(n=0;n<this.connections.length;n++)if(i=this.connections[n],i.from==e&&i.to==t)return!0;return!1},addConnection:function(e,t){return t!==!1&&this.undoRedoService.add(new F.AddConnectionUnit(e,this),!1),e.diagram=this,e._setOptionsFromModel(),e.refresh(),this.mainLayer.append(e.visual),this.connections.push(e),this.trigger(Te,{added:[e],removed:[]}),e},_addConnection:function(e,t){var n,i=this.connectionsDataSource;if(i&&this._isEditable){if(n=f(i,u(e.dataItem)),e.dataItem=n,e.updateModel(),!this.trigger("add",{connection:e}))return this._connectionsDataMap[n.uid]=e,i.add(n),this.addConnection(e,t),e._updateConnectors(),e}else if(!this.trigger("add",{connection:e}))return this.addConnection(e,t),e._updateConnectors(),e},addShape:function(e,t){var n,i=this.options.shapeDefaults;if(e instanceof y)n=e;else{if(e instanceof kendo.Class)return;i=L({},i,e||{}),n=new y(i,this)}return t!==!1&&this.undoRedoService.add(new F.AddShapeUnit(n,this),!1),this.shapes.push(n),n.diagram!==this&&(this._shapesQuadTree.insert(n),n.diagram=this),this.mainLayer.append(n.visual),this.trigger(Te,{added:[n],removed:[]}),n},_addShape:function(e,t){var n,i,o=this,r=o.dataSource;if(r&&this._isEditable){if(n=f(r,u(e.dataItem)),e.dataItem=n,e.updateModel(),!this.trigger("add",{shape:e}))return this.dataSource.add(n),i=this._inactiveShapeItems.getByUid(n.uid),i.element=e,i.undoable=t,e}else if(!this.trigger("add",{shape:e}))return this.addShape(e,t)},remove:function(e,t){var n,i,o,r;for(e=ve(e)?e.slice(0):[e],n=h(e),i=n.shapes,o=n.connections,ge(t)||(t=!0),t&&this.undoRedoService.begin(),this._suspendModelRefresh(),r=i.length-1;r>=0;r--)this._removeItem(i[r],t,o);for(r=o.length-1;r>=0;r--)this._removeItem(o[r],t);this._resumeModelRefresh(),t&&this.undoRedoService.commit(!1),this.trigger(Te,{added:[],removed:e})},_removeShapeDataItem:function(e){this._isEditable&&(this.dataSource.remove(e.dataItem),delete this._dataMap[e.dataItem.id])},_removeConnectionDataItem:function(e){this._isEditable&&(this.connectionsDataSource.remove(e.dataItem),delete this._connectionsDataMap[e.dataItem.uid])},_triggerRemove:function(e){var t,n,i,o,r=[];for(o=0;o<e.length;o++)t=e[o],i=t.options.editable,n=t instanceof y?{shape:t}:{connection:t},i&&i.remove!==!1&&!this.trigger("remove",n)&&r.push(t);return r},undo:function(){this.undoRedoService.undo()},redo:function(){this.undoRedoService.redo()},select:function(e,t){if(!me(e))return this._selectedItems;t=L({addToSelection:!1},t);var n,i,o=t.addToSelection,r=[],s=[];for(o||this.deselect(),this._internalSelection=!0,e instanceof Array?r=e:e instanceof b&&(r=[e]),n=0;n<r.length;n++)i=r[n],i.select(!0)&&s.push(i);this._selectionChanged(s,[]),this._internalSelection=!1},selectAll:function(){this.select(this.shapes.concat(this.connections))},selectArea:function(e){var t,n,i,o;if(this._internalSelection=!0,o=[],e instanceof $)for(n=this.shapes.concat(this.connections),t=0;t<n.length;t++)i=n[t],e&&!i._hitTest(e)||!i.options.enable||i.select(!0)&&o.push(i);this._selectionChanged(o,[]),this._internalSelection=!1},deselect:function(e){this._internalSelection=!0;var t,n,i=[],o=[];for(e instanceof Array?o=e:e instanceof b?o.push(e):me(e)||(o=this._selectedItems.slice(0)),n=0;n<o.length;n++)t=o[n],t.select(!1)&&i.push(t);this._selectionChanged([],i),this._internalSelection=!1},toFront:function(e,t){var n,i,o;e||(e=this._selectedItems.slice()),n=this._getDiagramItems(e),!ge(t)||t?(i=r(this.mainLayer,n.visuals),o=new ue(this,e,i),this.undoRedoService.add(o)):(this.mainLayer.toFront(n.visuals),this._fixOrdering(n,!0))},toBack:function(e,t){var n,i,o;e||(e=this._selectedItems.slice()),n=this._getDiagramItems(e),!ge(t)||t?(i=r(this.mainLayer,n.visuals),o=new de(this,e,i),this.undoRedoService.add(o)):(this.mainLayer.toBack(n.visuals),this._fixOrdering(n,!1))},bringIntoView:function(e,t){var n,i,o,r,s=this.viewport(),a=new F.RectAlign(s);0!==s.width&&0!==s.height&&(t=L({animate:!1,align:"center middle"},t),"none"==t.align&&(t.align="center middle"),e instanceof b?i=e.bounds(ot):ve(e)?i=this.boundingBox(e):e instanceof $&&(i=e.clone()),o=i.clone(),i.zoom(this._zoom),(i.width>s.width||i.height>s.height)&&(this._zoom=this._getValidZoom(ye.min(s.width/o.width,s.height/o.height)),i=o.clone().zoom(this._zoom)),this._zoomMainLayer(),n=i.clone(),a.align(i,t.align),r=i.topLeft().minus(n.topLeft()),this.pan(r.times(-1),t.animate))},alignShapes:function(e){var t,n,i,o,r,s,a;if(pe(e)&&(e="Left"),t=this.select(),0!==t.length){switch(e.toLowerCase()){case"left":case"top":n=tt;break;case"right":case"bottom":n=nt}for(o=0;o<t.length;o++)if(i=t[o],i instanceof y)switch(e.toLowerCase()){case"left":n=ye.min(n,i.options.x);break;case"top":n=ye.min(n,i.options.y);break;case"right":n=ye.max(n,i.options.x);break;case"bottom":n=ye.max(n,i.options.y)}for(r=[],s=[],o=0;o<t.length;o++)if(i=t[o],i instanceof y)switch(s.push(i),r.push(i.bounds()),e.toLowerCase()){case"left":case"right":i.position(new J(n,i.options.y));break;case"top":case"bottom":i.position(new J(i.options.x,n))}a=new F.TransformUnit(s,r),this.undoRedoService.add(a,!1)}},zoom:function(e,t){var n,i,o,r;return e&&(n=t?t.point:new F.Point(0,0),e=this._zoom=this._getValidZoom(e),pe(n)||(n=new F.Point(ye.round(n.x),ye.round(n.y)),i=n.times(e),o=this.modelToView(n),r=o.minus(i),this._storePan(new F.Point(ye.round(r.x),ye.round(r.y)))),t&&(t.zoom=e),this._panTransform(),this.canvas.surface.hideTooltip(),this._updateAdorners()),this._zoom},_getPan:function(e){var t=this.canvas;return t.translate||(e=e.plus(this._pan)),e},pan:function(e,n){var i,o;return e instanceof J?(i=this,o=i.scroller,e=i._getPan(e),e=e.times(-1),n?o.animatedScrollTo(e.x,e.y,function(){i._updateAdorners()}):(o.scrollTo(e.x,e.y),i._updateAdorners()),t):this._pan.times(-1)},viewport:function(){var e=this.element,t=e.width(),n=e.height();return this.toolBar&&(n-=N(this.toolBar.element)),new $(0,0,t,n)},copy:function(){var e,t;if(this.options.copy.enabled)for(this._clipboard=[],this._copyOffset=1,e=0;e<this._selectedItems.length;e++)t=this._selectedItems[e],this._clipboard.push(t)},cut:function(){var e,t;if(this.options.copy.enabled){for(this._clipboard=[],this._copyOffset=0,e=0;e<this._selectedItems.length;e++)t=this._selectedItems[e],this._clipboard.push(t);this.remove(this._clipboard,!0)}},paste:function(){var e,t,n,i,o,r,s,a;if(this._clipboard.length>0){for(i={},o=h(this._clipboard),r=o.connections,s=o.shapes,a={x:this._copyOffset*this.options.copy.offsetX,y:this._copyOffset*this.options.copy.offsetY},this.deselect(),n=0;n<s.length;n++)e=s[n],t=e.clone(),i[e.id]=t,t.position(new J(e.options.x+a.x,e.options.y+a.y)),t.diagram=this,t=this._addShape(t),t&&t.select();for(n=0;n<r.length;n++)e=r[n],t=this._addConnection(e.clone()),t&&(this._updateCopiedConnection(t,e,"source",i,a),this._updateCopiedConnection(t,e,"target",i,a),t.select(!0),t.updateModel());this._syncChanges(),this._copyOffset+=1}},_updateCopiedConnection:function(e,t,n,i,o){var r,s,a,l=t[n](),c=this;l instanceof w&&i[l.shape.id]?(a=i[l.shape.id],c.getShapeById(a.id)?e[n](a.getConnector(l.options.name)):(s=c._inactiveShapeItems.getByUid(a.dataItem.uid),s&&(r=function(t){a=c._dataMap[t.id],e[n](a.getConnector(l.options.name)),e.updateModel()},c._deferredConnectionUpdates.push(s.onActivate(r))))):e[n](new J(t[n+"Point"]().x+o.x,t[n+"Point"]().y+o.y))},boundingBox:function(e,t){var n,i,o,r=$.empty(),s=me(e)?this._getDiagramItems(e):{shapes:this.shapes};if(s.shapes.length>0)for(i=s.shapes[0],r=i.bounds(rt),o=1;o<s.shapes.length;o++)i=s.shapes[o],n=i.bounds(rt),t===!0&&(n.x-=i._rotationOffset.x,n.y-=i._rotationOffset.y),r=r.union(n);return r},_containerOffset:function(){var e=this.element.offset();return this.toolBar&&(e.top+=N(this.toolBar.element)),e},documentToView:function(e){var t=this._containerOffset();return new J(e.x-t.left,e.y-t.top)},viewToDocument:function(e){var t=this._containerOffset();return new J(e.x+t.left,e.y+t.top)},viewToModel:function(e){return this._transformWithMatrix(e,this._matrixInvert)},modelToView:function(e){return this._transformWithMatrix(e,this._matrix)},modelToLayer:function(e){return this._transformWithMatrix(e,this._layerMatrix)},layerToModel:function(e){return this._transformWithMatrix(e,this._layerMatrixInvert)},documentToModel:function(e){var t=this.documentToView(e);return this.canvas.translate||(t.x=t.x+this.scroller.scrollLeft,t.y=t.y+this.scroller.scrollTop),this.viewToModel(t)},modelToDocument:function(e){return this.viewToDocument(this.modelToView(e))},_transformWithMatrix:function(e,t){var n,i,o=e;return e instanceof J?t&&(o=t.apply(e)):(n=this._transformWithMatrix(e.topLeft(),t),i=this._transformWithMatrix(e.bottomRight(),t),o=$.fromPoints(n,i)),o},setDataSource:function(e){this.options.dataSource=e,this._dataSource(),this.options.autoBind&&this.dataSource.fetch()},setConnectionsDataSource:function(e){this.options.connectionsDataSource=e,this._connectionDataSource(),this.options.autoBind&&this.connectionsDataSource.fetch()},layout:function(e){var t,n,i,o,r;switch(this._layouting=!0,pe(e)&&(e=this.options.layout),t=pe(e)||pe(e.type)?"Tree":e.type,t.toLowerCase()){case"tree":n=new F.TreeLayout(this);break;case"layered":n=new F.LayeredLayout(this);break;case"forcedirected":case"force":case"spring":case"springembedder":n=new F.SpringLayout(this);break;default:throw"Layout algorithm '"+t+"' is not supported."}i=new F.LayoutState(this),o=n.layout(e),o&&(r=new F.LayoutUndoUnit(i,o,e?e.animate:null),this.undoRedoService.add(r)),this._layouting=!1,this._redrawConnections()},getShapeById:function(e){var t;return(t=le.first(this.shapes,function(t){return t.visual.id===e}))?t:t=le.first(this.connections,function(t){return t.visual.id===e})},getShapeByModelId:function(e){var t;return t=this._isEditable?this._dataMap[e]:le.first(this.shapes,function(t){return(t.dataItem||{}).id===e})},getShapeByModelUid:function(e){var t;return t=this._isEditable?le.first(this.shapes,function(t){return(t.dataItem||{}).uid===e}):this._dataMap[e]},getConnectionByModelId:function(e){var t;return this.connectionsDataSource&&(t=le.first(this.connections,function(t){return(t.dataItem||{}).id===e})),t},getConnectionByModelUid:function(e){var t;return this.connectionsDataSource&&(t=this._connectionsDataMap[e]),t},_extendLayoutOptions:function(e){e.layout&&(e.layout=L({},F.LayoutBase.fn.defaultOptions||{},e.layout))},_selectionChanged:function(e,t){(e.length||t.length)&&this.trigger(Oe,{selected:e,deselected:t})},_getValidZoom:function(e){return ye.min(ye.max(e,this.options.zoomMin),this.options.zoomMax)},_panTransform:function(e){var t=this,n=e||t._pan;t.canvas.translate?(t.scroller.scrollTo(n.x,n.y),t._zoomMainLayer()):(t._storePan(n),t._transformMainLayer())},_finishPan:function(){this.trigger(Ue,{total:this._pan,delta:Number.NaN})},_storePan:function(e){this._pan=e,this._storeViewMatrix()},_zoomMainLayer:function(){var e=this._zoom,t=new G(0,0,e,e);t.render(this.mainLayer),this._storeLayerMatrix(t),this._storeViewMatrix()},_transformMainLayer:function(){var e=this._pan,t=this._zoom,n=new G(e.x,e.y,t,t);n.render(this.mainLayer),this._storeLayerMatrix(n),this._storeViewMatrix()},_storeLayerMatrix:function(e){this._layerMatrix=e.toMatrix(),this._layerMatrixInvert=e.invert().toMatrix()},_storeViewMatrix:function(){var e=this._pan,t=this._zoom,n=new G(e.x,e.y,t,t);this._matrix=n.toMatrix(),this._matrixInvert=n.invert().toMatrix()},_toIndex:function(e,t){var n=this._getDiagramItems(e);this.mainLayer.toIndex(n.visuals,t),this._fixOrdering(n,!1)},_fixOrdering:function(e,t){var n,i,o=t?this.shapes.length-1:0,r=t?this.connections.length-1:0;for(n=0;n<e.shapes.length;n++)i=e.shapes[n],le.remove(this.shapes,i),le.insert(this.shapes,i,o);for(n=0;n<e.cons.length;n++)i=e.cons[n],le.remove(this.connections,i),le.insert(this.connections,i,r)},_getDiagramItems:function(e){var t,n,i={},o=e;for(i.visuals=[],i.shapes=[],i.cons=[],e?ve(e)||(o=[e]):o=this._selectedItems.slice(),t=0;t<o.length;t++)n=o[t],n instanceof y?(i.shapes.push(n),i.visuals.push(n.visual)):n instanceof k&&(i.cons.push(n),i.visuals.push(n.visual));return i},_removeItem:function(e,t,n){e.select(!1),e instanceof y?(this._removeShapeDataItem(e),this._removeShape(e,t,n)):e instanceof k&&(this._removeConnectionDataItem(e),this._removeConnection(e,t)),this.mainLayer.remove(e.visual)},_removeShape:function(e,t,n){var i,o,r,s,a=[],l=[];for(this.toolService._removeHover(),t&&this.undoRedoService.addCompositeItem(new Y(e)),le.remove(this.shapes,e),this._shapesQuadTree.remove(e),i=0;i<e.connectors.length;i++)for(r=e.connectors[i],s=0;s<r.connections.length;s++)o=r.connections[s],n&&I.inArray(o,n)||(o.sourceConnector==r?a.push(o):o.targetConnector==r&&l.push(o));for(i=0;i<a.length;i++)a[i].source(null,t),a[i].updateModel();for(i=0;i<l.length;i++)l[i].target(null,t),l[i].updateModel()},_removeConnection:function(e,t){e.sourceConnector&&le.remove(e.sourceConnector.connections,e),e.targetConnector&&le.remove(e.targetConnector.connections,e),t&&this.undoRedoService.addCompositeItem(new Q(e)),le.remove(this.connections,e)},_removeDataItems:function(e,t){var n,i,o,r;for(e=ve(e)?e:[e];e.length;)if(n=e.shift(),o=this._dataMap[n.uid],o&&(this._removeShapeConnections(o),this._removeItem(o,!1),delete this._dataMap[n.uid],t&&n.hasChildren&&n.loaded()))for(i=n.children.data(),r=0;r<i.length;r++)e.push(i[r])},_removeShapeConnections:function(e){var t,n=e.connections();if(n)for(t=0;t<n.length;t++)this._removeItem(n[t],!1)},_addDataItem:function(e,t){var n,i;if(ge(e))return(n=this._dataMap[e.id])?n:(i=L({},this.options.shapeDefaults),i.dataItem=e,n=new y(i,this),this.addShape(n,t!==!1),this._dataMap[e.id]=n,n)},_addDataItemByUid:function(e){var t,n;if(ge(e))return(t=this._dataMap[e.uid])?t:(n=L({},this.options.shapeDefaults),n.dataItem=e,t=new y(n,this),this.addShape(t),this._dataMap[e.uid]=t,t)},_addDataItems:function(e,t){var n,i,o,r,s;for(i=0;i<e.length;i++)n=e[i],o=this._addDataItemByUid(n),r=this._addDataItemByUid(t),r&&!this.connected(r,o)&&(s=this.connect(r,o))},_refreshSource:function(e){var t,n,i=this,o=e.node,r=e.action,s=e.items,a=i.options;if(e.field)for(t=0;t<s.length;t++)this._dataMap[s[t].uid]&&this._dataMap[s[t].uid].redrawVisual();else{if("remove"==r)this._removeDataItems(e.items,!0);else for(r&&"itemloaded"!==r||this._bindingRoots||(this._bindingRoots=!0,n=!0),r||o||i.clear(),this._addDataItems(s,o),t=0;t<s.length;t++)s[t].load();a.layout&&(n||"remove"==r||"add"==r)&&i.layout(a.layout),n&&(this.trigger("dataBound"),this._bindingRoots=!1)}},_addItem:function(e){e instanceof y?this.addShape(e):e instanceof k&&this.addConnection(e)},_createToolBar:function(e){var t,n,i,o,r,s,a,l,c,d=this.toolService.diagram;this.singleToolBar||1!==d.select().length||(t=d.select()[0],t&&t.options.editable!==!1&&(n=t.options.editable,i=n.tools,this._isEditable&&0===i.length&&(t instanceof y?i=["edit","rotateClockwise","rotateAnticlockwise"]:t instanceof k&&(i=["edit"]),n&&n.remove!==!1&&i.push("delete")),i&&i.length&&(o=20,this.singleToolBar=new C(d,{tools:i,click:B(this._toolBarClick,this),modal:!0,popupZIndex:parseInt(d.element.closest(".k-window").css("zIndex"),10)+10}),s=H(this.singleToolBar._popup.element),a=N(this.singleToolBar._popup.element),t instanceof y?(l=this.modelToView(t.bounds(rt)),r=new J(l.x,l.y).minus(new J((s-l.width)/2,a+o))):t instanceof k&&(c=this.modelToView(t.bounds()),r=new J(c.x,c.y).minus(new J((s-c.width-20)/2,a+o))),r?(this.canvas.translate||(r=r.minus(new J(this.scroller.scrollLeft,this.scroller.scrollTop))),r=this.viewToDocument(r),r=new J(ye.max(r.x,0),ye.max(r.y,0)),this.singleToolBar.showAt(r),e&&this.singleToolBar._popup.one("close",v)):this._destroyToolBar())))},_toolBarClick:function(e){this.trigger("toolBarClick",e),this._destroyToolBar()},_normalizePointZoom:function(e){return e.times(1/this.zoom())},_initialize:function(){this.shapes=[],this._selectedItems=[],this.connections=[],this._dataMap={},this._connectionsDataMap={},this._inactiveShapeItems=new d,this._deferredConnectionUpdates=[],this.undoRedoService=new ne({undone:this._syncHandler,redone:this._syncHandler}),this.id=F.randomId()},_fetchFreshData:function(){var e=this;e._dataSource(),e._isEditable&&e._connectionDataSource(),e.options.autoBind&&(e._isEditable?(this._loadingShapes=!0,this._loadingConnections=!0,e.dataSource.fetch(),e.connectionsDataSource.fetch()):e.dataSource.fetch())},_dataSource:function(){var e,t;ge(this.options.connectionsDataSource)?(this._isEditable=!0,e=this.options.dataSource||{},t=ve(e)?{data:e}:e,this.dataSource&&this._shapesRefreshHandler?this.dataSource.unbind("change",this._shapesRefreshHandler).unbind("requestStart",this._shapesRequestStartHandler).unbind("error",this._shapesErrorHandler):(this._shapesRefreshHandler=B(this._refreshShapes,this),this._shapesRequestStartHandler=B(this._shapesRequestStart,this),this._shapesErrorHandler=B(this._error,this)),this.dataSource=kendo.data.DataSource.create(t).bind("change",this._shapesRefreshHandler).bind("requestStart",this._shapesRequestStartHandler).bind("error",this._shapesErrorHandler)):(this._treeDataSource(),this._isEditable=!1)},_connectionDataSource:function(){var e,t=this.options.connectionsDataSource;t&&(e=ve(t)?{data:t}:t,this.connectionsDataSource&&this._connectionsRefreshHandler?this.connectionsDataSource.unbind("change",this._connectionsRefreshHandler).unbind("requestStart",this._connectionsRequestStartHandler).unbind("error",this._connectionsErrorHandler):(this._connectionsRefreshHandler=B(this._refreshConnections,this),this._connectionsRequestStartHandler=B(this._connectionsRequestStart,this),this._connectionsErrorHandler=B(this._connectionsError,this)),this.connectionsDataSource=kendo.data.DataSource.create(e).bind("change",this._connectionsRefreshHandler).bind("requestStart",this._connectionsRequestStartHandler).bind("error",this._connectionsErrorHandler));
},_shapesRequestStart:function(e){"read"==e.type&&(this._loadingShapes=!0)},_connectionsRequestStart:function(e){"read"==e.type&&(this._loadingConnections=!0)},_error:function(){this._loadingShapes=!1},_connectionsError:function(){this._loadingConnections=!1},_refreshShapes:function(e){"remove"===e.action?this._shouldRefresh()&&this._removeShapes(e.items):"itemchange"===e.action?this._shouldRefresh()&&this._updateShapes(e.items,e.field):"add"===e.action?this._inactiveShapeItems.add(e.items):"sync"===e.action?this._syncShapes(e.items):this.refresh()},_shouldRefresh:function(){return!this._suspended},_suspendModelRefresh:function(){this._suspended=(this._suspended||0)+1},_resumeModelRefresh:function(){this._suspended=ye.max((this._suspended||0)-1,0)},refresh:function(){this._loadingShapes=!1,this._loadingConnections||this._rebindShapesAndConnections()},_rebindShapesAndConnections:function(){this.clear(),this._addShapes(this.dataSource.view()),this.connectionsDataSource&&this._addConnections(this.connectionsDataSource.view(),!1),this.options.layout?this.layout(this.options.layout):this._redrawConnections(),this.trigger("dataBound")},refreshConnections:function(){this._loadingConnections=!1,this._loadingShapes||this._rebindShapesAndConnections()},_redrawConnections:function(){var e,t=this.connections;for(e=0;e<t.length;e++)t[e].refresh()},_removeShapes:function(e){var t,n,i=this._dataMap;for(n=0;n<e.length;n++)t=e[n],i[t.id]&&(this.remove(i[t.id],!1),i[t.id]=null)},_syncShapes:function(){var e=this,t=e._inactiveShapeItems;t.forEach(function(n){var i=n.dataItem,o=n.element;i.isNew()||(o?(o._setOptionsFromModel(),e.addShape(o,n.undoable),e._dataMap[i.id]=o):e._addDataItem(i),n.activate(),t.remove(i))})},_updateShapes:function(e,t){var n,i,o;for(n=0;n<e.length;n++)i=e[n],o=this._dataMap[i.id],o&&o.updateOptionsFromModel(i,t)},_addShapes:function(e){for(var t=0;t<e.length;t++)this._addDataItem(e[t],!1)},_refreshConnections:function(e){"remove"===e.action?this._shouldRefresh()&&this._removeConnections(e.items):"add"===e.action?this._addConnections(e.items):"sync"===e.action||("itemchange"===e.action?this._shouldRefresh()&&this._updateConnections(e.items):this.refreshConnections())},_removeConnections:function(e){for(var t=0;t<e.length;t++)this.remove(this._connectionsDataMap[e[t].uid],!1),this._connectionsDataMap[e[t].uid]=null},_updateConnections:function(e){var t,n,i;for(t=0;t<e.length;t++)n=e[t],i=this._connectionsDataMap[n.uid],i.updateOptionsFromModel(n)},_addConnections:function(e,t){var n,i,o=e.length;for(n=0;n<o;n++)i=e[n],this._addConnectionDataItem(i,t)},_addConnectionDataItem:function(e,t){var n,i,o,r;this._connectionsDataMap[e.uid]||(n=this._validateConnector(e.from),ge(n)&&null!==n||(n=new J(e.fromX,e.fromY)),i=this._validateConnector(e.to),ge(i)&&null!==i||(i=new J(e.toX,e.toY)),ge(n)&&ge(i)&&(o=L({},this.options.connectionDefaults),o.dataItem=e,r=new k(n,i,o),this._connectionsDataMap[e.uid]=r,this.addConnection(r,t)))},_validateConnector:function(e){var t;return ge(e)&&null!==e&&(t=this._dataMap[e]),t},_treeDataSource:function(){var e=this,t=e.options,n=t.dataSource;if(n=ve(n)?{data:n}:n,n instanceof kendo.data.DataSource&&!(n instanceof kendo.data.HierarchicalDataSource))throw Error("Incorrect DataSource type. If a single dataSource instance is set to the diagram then it should be a HierarchicalDataSource. You should set only the options instead of an instance or a HierarchicalDataSource instance or supply connectionsDataSource as well.");n.fields||(n.fields=[{field:"text"},{field:"url"},{field:"spriteCssClass"},{field:"imageUrl"}]),e.dataSource&&e._refreshHandler&&e._unbindDataSource(),e._refreshHandler=B(e._refreshSource,e),e._errorHandler=B(e._error,e),e.dataSource=V.create(n).bind(Te,e._refreshHandler).bind(Fe,e._errorHandler)},_unbindDataSource:function(){var e=this;e.dataSource.unbind(Te,e._refreshHandler).unbind(Fe,e._errorHandler)},_adorn:function(e,n){n!==t&&e&&(n?(this._adorners.push(e),this.adornerLayer.append(e.visual)):(le.remove(this._adorners,e),this.adornerLayer.remove(e.visual)))},_showConnectors:function(e,t){t?this._connectorsAdorner.show(e):this._connectorsAdorner.destroy()},_updateAdorners:function(){var e,t,n=this._adorners;for(e=0;e<n.length;e++)t=n[e],t.refreshBounds&&t.refreshBounds(),t.refresh()},_refresh:function(){for(var e=0;e<this.connections.length;e++)this.connections[e].refresh()},_destroyToolBar:function(){this.singleToolBar&&(this.singleToolBar.hide(),this.singleToolBar.destroy(),this.singleToolBar=null)},_destroyGlobalToolBar:function(){this.toolBar&&(this.toolBar.hide(),this.toolBar.destroy(),this.toolBar=null)},exportDOMVisual:function(){var e=this.canvas._viewBox,t=R.transform().translate(-e.x,-e.y),n=new R.Rect([0,0],[e.width,e.height]),i=M.Path.fromRect(n),o=new M.Group({transform:t}),r=new M.Group({clip:i}),s=this.canvas.drawingElement.children[0];return r.append(o),o.children.push(s),r},exportVisual:function(){var e=R.transform().scale(1/this._zoom),t=new M.Group({transform:e}),n=this.mainLayer.drawingElement;return t.children.push(n),t},_syncChanges:function(){this._syncShapeChanges(),this._syncConnectionChanges()},_syncShapeChanges:function(){this.dataSource&&this._isEditable&&this.dataSource.sync()},_syncConnectionChanges:function(){var t=this;t.connectionsDataSource&&t._isEditable&&(e.when.apply(e,t._deferredConnectionUpdates).then(function(){t.connectionsDataSource.sync()}),t.deferredConnectionUpdates=[])}}),I.ExportMixin.extend(x.fn,!0),kendo.PDFMixin&&kendo.PDFMixin.extend(x.fn),C=kendo.Observable.extend({init:function(e,t){kendo.Observable.fn.init.call(this),this.diagram=e,this.options=L({},this.options,t),this._tools=[],this.createToolBar(),this.createTools(),this.appendTools(),this.options.modal&&this.createPopup(),this.bind(this.events,t)},events:["click"],createPopup:function(){this.container=e("<div/>").append(this.element),this._popup=this.container.kendoPopup({}).getKendoPopup()},appendTools:function(){var e,t;for(e=0;e<this._tools.length;e++)t=this._tools[e],(t.buttons&&t.buttons.length||!ge(t.buttons))&&this._toolBar.add(t)},createToolBar:function(){this.element=e("<div/>"),this._toolBar=this.element.kendoToolBar({click:B(this.click,this),resizable:!1}).getKendoToolBar(),this.element.css("border","none")},createTools:function(){for(var e=0;e<this.options.tools.length;e++)this.createTool(this.options.tools[e])},createTool:function(e){we(e)||(e={name:e});var t=e.name+"Tool";this[t]?this[t](e):this._tools.push(L({},e,{attributes:this._setAttributes({action:e.name})}))},showAt:function(e){var t=parseInt(this.options.popupZIndex,10);this._popup&&(this._popup.open(e.x,e.y),t&&this._popup.wrapper.css("zIndex",t))},hide:function(){this._popup&&this._popup.close()},newGroup:function(){return{type:"buttonGroup",buttons:[]}},editTool:function(){this._tools.push({icon:"edit",showText:"overflow",type:"button",text:"Edit",attributes:this._setAttributes({action:"edit"})})},deleteTool:function(){this._tools.push({icon:"close",showText:"overflow",type:"button",text:"Delete",attributes:this._setAttributes({action:"delete"})})},rotateAnticlockwiseTool:function(e){this._appendGroup("rotate"),this._rotateGroup.buttons.push({icon:"rotate-left",showText:"overflow",text:"RotateAnticlockwise",group:"rotate",attributes:this._setAttributes({action:"rotateAnticlockwise",step:e.step})})},rotateClockwiseTool:function(e){this._appendGroup("rotate"),this._rotateGroup.buttons.push({icon:"rotate-right",attributes:this._setAttributes({action:"rotateClockwise",step:e.step}),showText:"overflow",text:"RotateClockwise",group:"rotate"})},createShapeTool:function(){this._appendGroup("create"),this._createGroup.buttons.push({icon:"shape",showText:"overflow",text:"CreateShape",group:"create",attributes:this._setAttributes({action:"createShape"})})},createConnectionTool:function(){this._appendGroup("create"),this._createGroup.buttons.push({icon:"connector",showText:"overflow",text:"CreateConnection",group:"create",attributes:this._setAttributes({action:"createConnection"})})},undoTool:function(){this._appendGroup("history"),this._historyGroup.buttons.push({icon:"undo",showText:"overflow",text:"Undo",group:"history",attributes:this._setAttributes({action:"undo"})})},redoTool:function(){this._appendGroup("history"),this._historyGroup.buttons.push({icon:"redo",showText:"overflow",text:"Redo",group:"history",attributes:this._setAttributes({action:"redo"})})},_appendGroup:function(e){var t="_"+e+"Group";this[t]||(this[t]=this.newGroup(),this._tools.push(this[t]))},_setAttributes:function(e){var t={};return e.action&&(t[kendo.attr("action")]=e.action),e.step&&(t[kendo.attr("step")]=e.step),t},_getAttributes:function(e){var t,n={},i=e.attr(kendo.attr("action"));return i&&(n.action=i),t=e.attr(kendo.attr("step")),t&&(n.step=t),n},click:function(t){var n=this._getAttributes(e(t.target)),i=n.action;i&&this[i]&&this[i](n),this.trigger("click",this.eventData(i,t.target))},eventData:function(e,t){var n,i,o=this.selectedElements(),r=o.length,s=[],a=[];for(i=0;i<r;i++)n=o[i],n instanceof y?s.push(n):a.push(n);return{shapes:s,connections:a,action:e,target:t}},"delete":function(){var e=this.diagram,t=e._triggerRemove(this.selectedElements());t.length&&(this.diagram.remove(t,!0),this.diagram._syncChanges())},edit:function(){var e=this.selectedElements();1===e.length&&this.diagram.edit(e[0])},rotateClockwise:function(e){var t=parseFloat(e.step||90);this._rotate(t)},rotateAnticlockwise:function(e){var t=parseFloat(e.step||90);this._rotate(-t)},_rotate:function(e){var t=this.diagram._resizingAdorner;t.angle(t.angle()+e),t.rotate()},selectedElements:function(){return this.diagram.select()},createShape:function(){this.diagram.createShape()},createConnection:function(){this.diagram.createConnection()},undo:function(){this.diagram.undo()},redo:function(){this.diagram.redo()},destroy:function(){this.diagram=null,this.element=null,this.options=null,this._toolBar&&this._toolBar.destroy(),this._popup&&this._popup.destroy()}}),S=kendo.Observable.extend({init:function(e,t){kendo.Observable.fn.init.call(this),this.options=O(!0,{},this.options,t),this.element=e,this.model=this.options.model,this.fields=this._getFields(),this._initContainer(),this.createEditable()},options:{editors:{}},_initContainer:function(){this.wrapper=this.element},createEditable:function(){var e=this.options;this.editable=new kendo.ui.Editable(this.wrapper,{fields:this.fields,target:e.target,clearContainer:!1,model:this.model})},_isEditable:function(e){return this.model.editable&&this.model.editable(e)},_getFields:function(){var e,t,n,i=[],o=this.model.fields;for(e in o)t={},this._isEditable(e)&&(n=this.options.editors[e],n&&(t.editor=n),t.field=e,i.push(t));return i},end:function(){return this.editable.end()},destroy:function(){this.editable.destroy(),this.editable.element.find("["+kendo.attr("container-for")+"]").empty(),this.model=this.wrapper=this.element=this.columns=this.editable=null}}),T=S.extend({init:function(e,t){S.fn.init.call(this,e,t),this.bind(this.events,this.options),this.open()},events:["update","cancel"],options:{window:{modal:!0,resizable:!1,draggable:!0,title:"Edit",visible:!1}},_initContainer:function(){var t,n=this;this.wrapper=e('<div class="k-popup-edit-form"/>').attr(kendo.attr("uid"),this.model.uid),t="",this.options.template?(t+=this._renderTemplate(),this.fields=[]):t+=this._renderFields(),t+=this._renderButtons(),this.wrapper.append(e('<div class="k-edit-form-container"/>').append(t)),this.window=new kendo.ui.Window(this.wrapper.appendTo(this.element),this.options.window),this.window.bind("close",function(e){e.userTriggered&&(e.sender.element.focus(),n._cancelClick(e))}),this._attachButtonEvents()},_renderTemplate:function(){var e=this.options.template;return"string"==typeof e&&(e=window.unescape(e)),e=kendo.template(e)(this.model)},_renderFields:function(){var e,t,n="";for(e=0;e<this.fields.length;e++)t=this.fields[e],n+='<div class="k-edit-label"><label for="'+t.field+'">'+(t.field||"")+"</label></div>",this._isEditable(t.field)&&(n+="<div "+kendo.attr("container-for")+'="'+t.field+'" class="k-edit-field"></div>');return n},_renderButtons:function(){var e='<div class="k-edit-buttons k-state-default">';return e+=this._createButton("update"),e+=this._createButton("cancel"),e+="</div>"},_createButton:function(e){return kendo.template(pt)(_[e])},_attachButtonEvents:function(){this._cancelClickHandler=B(this._cancelClick,this),this.window.element.on(De+xe,"a.k-diagram-cancel",this._cancelClickHandler),this._updateClickHandler=B(this._updateClick,this),this.window.element.on(De+xe,"a.k-diagram-update",this._updateClickHandler)},_updateClick:function(e){e.preventDefault(),this.trigger("update")},_cancelClick:function(e){e.preventDefault(),this.trigger("cancel")},open:function(){this.window.center().open()},close:function(){this.window.bind("deactivate",B(this.destroy,this)).close()},destroy:function(){this.window.close().destroy(),this.window.element.off(De+xe,"a.k-diagram-cancel",this._cancelClickHandler),this.window.element.off(De+xe,"a.k-diagram-update",this._updateClickHandler),this._cancelClickHandler=null,this._editUpdateClickHandler=null,this.window=null,S.fn.destroy.call(this)}}),c.fn=c.prototype={onActivate:function(t){var n=e.Deferred();return this.callbacks.push({callback:t,deferred:n}),n},activate:function(){var e,t,n=this.callbacks;for(t=0;t<n.length;t++)e=this.callbacks[t],e.callback(this.dataItem),e.deferred.resolve();this.callbacks=[]}},d.fn=d.prototype={add:function(e){for(var t=0;t<e.length;t++)this.items[e[t].uid]=new c(e[t])},forEach:function(e){for(var t in this.items)e(this.items[t])},getByUid:function(e){return this.items[e]},remove:function(e){delete this.items[e.uid]}},D=P.extend({init:function(){this.shapes=[]},_add:function(e,t){this.shapes.push({bounds:t,shape:e}),e._quadNode=this},insert:function(e,t){this._add(e,t)},remove:function(e){var t,n=this.shapes,i=n.length;for(t=0;t<i;t++)if(n[t].shape===e){n.splice(t,1);break}},hitTestRect:function(e,t){var n,i=this.shapes,o=i.length;for(n=0;n<o;n++)if(this._testRect(i[n].shape,e)&&!I.inArray(i[n].shape,t))return!0},_testRect:function(e,t){var n,i=e.rotate().angle,o=e.bounds();return n=i?ee.rects(t,o,-i):o.overlaps(t)}}),A=D.extend({init:function(e){D.fn.init.call(this),this.children=[],this.rect=e},inBounds:function(e){var t=this.rect,n=t.bottomRight(),i=e.bottomRight(),o=t.x<=e.x&&t.y<=e.y&&i.x<=n.x&&i.y<=n.y;return o},overlapsBounds:function(e){return this.rect.overlaps(e)},insert:function(e,t){var n,i=!1,o=this.children,r=o.length;if(this.inBounds(t)){if(!r&&this.shapes.length<4)this._add(e,t);else{for(r||this._initChildren(),n=0;n<o.length;n++)if(o[n].insert(e,t)){i=!0;break}i||this._add(e,t)}i=!0}return i},_initChildren:function(){var e,t,n=this.rect,i=this.children,o=this.shapes,r=n.center(),s=n.width/2,a=n.height/2;for(i.push(new A(new $(n.x,n.y,s,a)),new A(new $(r.x,n.y,s,a)),new A(new $(n.x,r.y,s,a)),new A(new $(r.x,r.y,s,a))),t=o.length-1;t>=0;t--)for(e=0;e<i.length;e++)if(i[e].insert(o[t].shape,o[t].bounds)){o.splice(t,1);break}},hitTestRect:function(e,t){var n,i=this.children,o=i.length,r=!1;if(this.overlapsBounds(e))if(D.fn.hitTestRect.call(this,e,t))r=!0;else for(n=0;n<o;n++)if(i[n].hitTestRect(e,t)){r=!0;break}return r}}),E=P.extend({ROOT_SIZE:1e3,init:function(e){var t=B(this._boundsChange,this);e.bind(Se,t),e.bind(Ve,t),this.initRoots()},initRoots:function(){this.rootMap={},this.root=new D},clear:function(){this.initRoots()},_boundsChange:function(e){e.item._quadNode&&e.item._quadNode.remove(e.item),this.insert(e.item)},insert:function(e){var t=e.bounds(rt),n=this.ROOT_SIZE,i=this.getSectors(t),o=i[0][0],r=i[1][0];this.inRoot(i)?this.root.insert(e,t):(this.rootMap[o]||(this.rootMap[o]={}),this.rootMap[o][r]||(this.rootMap[o][r]=new A(new $(o*n,r*n,n,n))),this.rootMap[o][r].insert(e,t))},remove:function(e){e._quadNode&&e._quadNode.remove(e)},inRoot:function(e){return e[0].length>1||e[1].length>1},getSectors:function(e){var t,n,i=this.ROOT_SIZE,o=e.bottomRight(),r=ye.floor(o.x/i),s=ye.floor(o.y/i),a=[[],[]];for(t=ye.floor(e.x/i);t<=r;t++)a[0].push(t);for(n=ye.floor(e.y/i);n<=s;n++)a[1].push(n);return a},hitTestRect:function(e,t){var n,i,o,r,s,a=this.getSectors(e);if(this.root.hitTestRect(e,t))return!0;for(n=0;n<a[0].length;n++)for(o=a[0][n],i=0;i<a[1].length;i++)if(r=a[1][i],s=(this.rootMap[o]||{})[r],s&&s.hitTestRect(e,t))return!0;return!1}}),I.ui.plugin(x),L(F,{Shape:y,Connection:k,Connector:w,DiagramToolBar:C,QuadNode:A,QuadRoot:D,ShapesQuadTree:E,PopupEditor:T})}(window.kendo.jQuery)},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.diagram.min",["kendo.data.min","kendo.draganddrop.min","kendo.userevents.min","kendo.mobile.scroller.min","kendo.drawing.min","dataviz/diagram/utils.min","dataviz/diagram/math.min","dataviz/diagram/svg.min","dataviz/diagram/services.min","dataviz/diagram/layout.min","dataviz/diagram/dom.min"],e)}(function(){return window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.treemap.min",["kendo.data.min","kendo.userevents.min","kendo.dataviz.themes.min"],e)}(function(){return function(e,t){function n(e,t){if(null===t)return t;var n=C(e,!0);return n(t)}function i(e){return typeof e!==F}function o(e,t,n){var i,o,l=a(e),c=a(t),d=u(e)-u(t)<0,h=[];for(h.push(e),i=0;i<n;i++)o={r:r(l.r,c.r,i,n,d),g:r(l.g,c.g,i,n,d),b:r(l.b,c.b,i,n,d)},h.push(s(o));return h.push(t),h}function r(e,t,n,i,o){var r,s=f.min(f.abs(e),f.abs(t)),a=f.max(f.abs(e),f.abs(t)),l=(a-s)/(i+1),c=l*(n+1);return r=o?s+c:a-c}function s(e){return"#"+l(e.r)+l(e.g)+l(e.b)}function a(e){e=e.replace("#","");var t=c(e);return{r:d(t.r),g:d(t.g),b:d(t.b)}}function l(e){var t=f.round(e).toString(16).toUpperCase();return 1===t.length&&(t="0"+t),t}function c(e){var t=e.length,n={};return 3===t?(n.r=e[0],n.g=e[1],n.b=e[2]):(n.r=e.substring(0,2),n.g=e.substring(2,4),n.b=e.substring(4,6)),n}function d(e){return parseInt(e.toString(16),16)}function u(e){var t=0;return e&&(e=a(e),t=f.sqrt(.241*e.r*e.r+.691*e.g*e.g+.068*e.b*e.b)),t}function h(e){var t=f.pow(10,4);return f.round(e*t)/t}var f=Math,p=e.proxy,m=e.isArray,g=window.kendo,v=g._outerHeight,_=g._outerWidth,b=g.Class,w=g.ui.Widget,y=g.template,k=g.deepExtend,x=g.data.HierarchicalDataSource,C=g.getter,S=g.dataviz,T=".kendoTreeMap",D="change",A="dataBound",E="itemCreated",I=Number.MAX_VALUE,M="mouseover"+T,R="mouseleave"+T,F="undefined",z=w.extend({init:function(t,n){g.destroy(t),e(t).empty(),w.fn.init.call(this,t,n),this.wrapper=this.element,this._initTheme(this.options),this.element.addClass("k-widget k-treemap"),this._setLayout(),this._originalOptions=k({},this.options),this._initDataSource(),this._attachEvents(),g.notify(this,S.ui)},options:{name:"TreeMap",theme:"default",autoBind:!0,textField:"text",valueField:"value",colorField:"color"},events:[A,E],_initTheme:function(e){var t=this,n=S.ui.themes||{},i=((e||{}).theme||"").toLowerCase(),o=(n[i]||{}).treeMap;t.options=k({},o,e)},_attachEvents:function(){this.element.on(M,p(this._mouseover,this)).on(R,p(this._mouseleave,this)),this._resizeHandler=p(this.resize,this,!1),g.onResize(this._resizeHandler)},_setLayout:function(){"horizontal"===this.options.type?(this._layout=new L((!1)),this._view=new H(this,this.options)):"vertical"===this.options.type?(this._layout=new L((!0)),this._view=new H(this,this.options)):(this._layout=new P,this._view=new B(this,this.options))},_initDataSource:function(){var e=this,t=e.options,n=t.dataSource;e._dataChangeHandler=p(e._onDataChange,e),e.dataSource=x.create(n).bind(D,e._dataChangeHandler),n&&e.options.autoBind&&e.dataSource.fetch()},setDataSource:function(e){var t=this;t.dataSource.unbind(D,t._dataChangeHandler),t.dataSource=e.bind(D,t._dataChangeHandler),e&&t.options.autoBind&&t.dataSource.fetch()},_onDataChange:function(e){var t,n,i,o,r=e.node,s=e.items,a=this.options;if(r){if(s.length){for(i=this._getByUid(r.uid),i.children=[],s=new g.data.Query(s)._sortForGrouping(a.valueField,"desc"),n=0;n<s.length;n++)t=s[n],i.children.push(this._wrapItem(t));o=this._view.htmlSize(i),this._layout.compute(i.children,i.coord,o),this._setColors(i.children),this._view.render(i)}}else this._cleanItems(),this.element.empty(),t=this._wrapItem(s[0]),this._layout.createRoot(t,_(this.element),v(this.element),"vertical"===this.options.type),this._view.createRoot(t),this._root=t,this._colorIdx=0;for(n=0;n<s.length;n++)s[n].load();r&&this.trigger(A,{node:r})},_cleanItems:function(){var e=this;e.angular("cleanup",function(){return{elements:e.element.find(".k-leaf div,.k-treemap-title,.k-treemap-title-vertical")}})},_setColors:function(e){var t,n,r,s,a=this.options.colors,l=this._colorIdx,c=a[l%a.length];for(m(c)&&(t=o(c[0],c[1],e.length)),r=!1,s=0;s<e.length;s++)n=e[s],i(n.color)||(n.color=t?t[s]:c),n.dataItem.hasChildren||(r=!0);r&&this._colorIdx++},_contentSize:function(e){this.view.renderHeight(e)},_wrapItem:function(e){var t={};return i(this.options.valueField)&&(t.value=n(this.options.valueField,e)),i(this.options.colorField)&&(t.color=n(this.options.colorField,e)),i(this.options.textField)&&(t.text=n(this.options.textField,e)),t.level=e.level(),t.dataItem=e,t},_getByUid:function(e){for(var t,n=[this._root];n.length;){if(t=n.pop(),t.dataItem.uid===e)return t;t.children&&(n=n.concat(t.children))}},dataItem:function(t){var n=e(t).attr(g.attr("uid")),i=this.dataSource;return i&&i.getByUid(n)},findByUid:function(e){return this.element.find(".k-treemap-tile["+g.attr("uid")+"='"+e+"']")},_mouseover:function(t){var n=e(t.target);n.hasClass("k-leaf")&&(this._removeActiveState(),n.removeClass("k-state-hover").addClass("k-state-hover"))},_removeActiveState:function(){this.element.find(".k-state-hover").removeClass("k-state-hover")},_mouseleave:function(){this._removeActiveState()},destroy:function(){w.fn.destroy.call(this),this.element.off(T),this.dataSource&&this.dataSource.unbind(D,this._dataChangeHandler),this._root=null,g.unbindResize(this._resizeHandler),g.destroy(this.element)},items:function(){return e()},getSize:function(){return g.dimensions(this.element)},_resize:function(){var e,t,n=this._root;n&&(e=this.element,t=e.children(),n.coord.width=_(e),n.coord.height=v(e),t.css({width:n.coord.width,height:n.coord.height}),this._resizeItems(n,t))},_resizeItems:function(e,t){var n,i,o,r;if(e.children&&e.children.length)for(n=t.children(".k-treemap-wrap").children(),this._layout.compute(e.children,e.coord,{text:this._view.titleSize(e,t)}),r=0;r<e.children.length;r++)i=e.children[r],o=n.filter("["+g.attr("uid")+"='"+i.dataItem.uid+"']"),this._view.setItemSize(i,o),this._resizeItems(i,o)},setOptions:function(e){var n=e.dataSource;e.dataSource=t,this._originalOptions=k(this._originalOptions,e),this.options=k({},this._originalOptions),this._setLayout(),this._initTheme(this.options),w.fn._setEvents.call(this,e),n&&this.setDataSource(x.create(n)),this.options.autoBind&&this.dataSource.fetch()}}),P=b.extend({createRoot:function(e,t,n){e.coord={width:t,height:n,top:0,left:0}},leaf:function(e){return!e.children},layoutChildren:function(e,t){var n,i,o,r,s=t.width*t.height,a=0,l=[];for(n=0;n<e.length;n++)l[n]=parseFloat(e[n].value),a+=l[n];for(n=0;n<l.length;n++)e[n].area=s*l[n]/a;i=this.layoutHorizontal()?t.height:t.width,o=[e[0]],r=e.slice(1),this.squarify(r,o,i,t)},squarify:function(e,t,n,i){this.computeDim(e,t,n,i)},computeDim:function(e,n,i,o){var r,s,a;return e.length+n.length==1?(r=1==e.length?e:n,this.layoutLast(r,i,o),t):(e.length>=2&&0===n.length&&(n=[e[0]],e=e.slice(1)),0===e.length?(n.length>0&&this.layoutRow(n,i,o),t):(s=e[0],this.worstAspectRatio(n,i)>=this.worstAspectRatio([s].concat(n),i)?this.computeDim(e.slice(1),n.concat([s]),i,o):(a=this.layoutRow(n,i,o),this.computeDim(e,[],a.dim,a)),t))},layoutLast:function(e,t,n){e[0].coord=n},layoutRow:function(e,t,n){return this.layoutHorizontal()?this.layoutV(e,t,n):this.layoutH(e,t,n)},orientation:"h",layoutVertical:function(){return"v"===this.orientation},layoutHorizontal:function(){return"h"===this.orientation},layoutChange:function(){this.orientation=this.layoutVertical()?"h":"v"},worstAspectRatio:function(e,t){var n,i,o,r,s;if(!e||0===e.length)return I;for(n=0,i=0,o=I,r=0;r<e.length;r++)s=e[r].area,n+=s,o=o<s?o:s,i=i>s?i:s;return f.max(t*t*i/(n*n),n*n/(t*t*o))},compute:function(e,t,n){if(t.width>=t.height&&this.layoutHorizontal()||this.layoutChange(),e&&e.length>0){var i={width:t.width,height:t.height-n.text,top:0,left:0};this.layoutChildren(e,i)}},layoutV:function(e,t,n){var i,o,r,s=this._totalArea(e),a=0;for(t=h(s/t),i=0;i<e.length;i++)o=h(e[i].area/t),e[i].coord={height:o,width:t,top:n.top+a,left:n.left},a+=o;return r={height:n.height,width:n.width-t,top:n.top,left:n.left+t},r.dim=f.min(r.width,r.height),r.dim!=r.height&&this.layoutChange(),r},layoutH:function(e,t,n){var i,o,r=this._totalArea(e),s=h(r/t),a=n.top,l=0;for(i=0;i<e.length;i++)e[i].coord={height:s,width:h(e[i].area/s),top:a,left:n.left+l},l+=e[i].coord.width;return o={height:n.height-s,width:n.width,top:n.top+s,left:n.left},o.dim=f.min(o.width,o.height),o.dim!=o.width&&this.layoutChange(),o},_totalArea:function(e){var t,n=0;for(t=0;t<e.length;t++)n+=e[t].area;return n}}),B=b.extend({init:function(t,n){this.options=k({},this.options,n),this.treeMap=t,this.element=e(t.element),this.offset=0},titleSize:function(e,t){var n=t.children(".k-treemap-title");return n.height()||0},htmlSize:function(e){var t,n,i=this._getByUid(e.dataItem.uid),o={text:0};return e.children&&(this._clean(i),t=this._getText(e),t&&(n=this._createTitle(e),i.append(n),this._compile(n,e.dataItem),o.text=n.height()),i.append(this._createWrap()),this.offset=(_(i)-i.innerWidth())/2),o},_compile:function(e,t){this.treeMap.angular("compile",function(){return{elements:e,data:[{dataItem:t}]}})},_getByUid:function(e){return this.element.find(".k-treemap-tile["+g.attr("uid")+"='"+e+"']")},render:function(e){var t,n,i,o,r=this._getByUid(e.dataItem.uid),s=e.children;if(s)for(t=r.find(".k-treemap-wrap"),n=0;n<s.length;n++)i=s[n],o=this._createLeaf(i),t.append(o),this._compile(o.children(),i.dataItem),this.treeMap.trigger(E,{element:o})},createRoot:function(e){var t=this._createLeaf(e);this.element.append(t),this._compile(t.children(),e.dataItem),this.treeMap.trigger(E,{element:t})},_clean:function(e){this.treeMap.angular("cleanup",function(){return{elements:e.children(":not(.k-treemap-wrap)")}}),e.css("background-color",""),e.removeClass("k-leaf"),e.removeClass("k-inverse"),e.empty()},_createLeaf:function(t){return this._createTile(t).css("background-color",t.color).addClass("k-leaf").toggleClass("k-inverse",this._tileColorBrightness(t)>180).append(e("<div></div>").html(this._getText(t)))},_createTile:function(t){var n=e("<div class='k-treemap-tile'></div>");return this.setItemSize(t,n),i(t.dataItem)&&i(t.dataItem.uid)&&n.attr(g.attr("uid"),t.dataItem.uid),n},_itemCoordinates:function(e){var t={width:e.coord.width,height:e.coord.height,left:e.coord.left,top:e.coord.top};return t.width+=t.left&&this.offset?2*this.offset:this.offset,t.height+=t.top?2*this.offset:this.offset,t},setItemSize:function(e,t){var n=this._itemCoordinates(e);t.css({width:n.width,height:n.height,left:n.left,top:n.top})},_getText:function(e){var t=e.text;return this.options.template&&(t=this._renderTemplate(e)),t},_renderTemplate:function(e){var t=y(this.options.template);return t({dataItem:e.dataItem,text:e.text})},_createTitle:function(t){return e("<div class='k-treemap-title'></div>").append(e("<div></div>").html(this._getText(t)))},_createWrap:function(){return e("<div class='k-treemap-wrap'></div>")},_tileColorBrightness:function(e){return u(e.color)}}),L=b.extend({createRoot:function(e,t,n,i){e.coord={width:t,height:n,top:0,left:0},e.vertical=i},init:function(e){this.vertical=e,this.quotient=e?1:0},compute:function(e,t,n){var i,o,r;e.length>0&&(i=t.width,o=t.height,this.vertical?o-=n.text:i-=n.text,r={width:i,height:o,top:0,left:0},this.layoutChildren(e,r))},layoutChildren:function(e,t){var n,i,o=t.width*t.height,r=0,s=[];for(n=0;n<e.length;n++)i=e[n],s[n]=parseFloat(e[n].value),r+=s[n],i.vertical=this.vertical;for(n=0;n<s.length;n++)e[n].area=o*s[n]/r;this.sliceAndDice(e,t)},sliceAndDice:function(e,t){var n=this._totalArea(e);e[0].level%2===this.quotient?this.layoutHorizontal(e,t,n):this.layoutVertical(e,t,n)},layoutHorizontal:function(e,t,n){var i,o,r,s=0;for(i=0;i<e.length;i++)o=e[i],r=o.area/(n/t.width),o.coord={height:t.height,width:r,top:t.top,left:t.left+s},s+=r},layoutVertical:function(e,t,n){var i,o,r,s=0;for(i=0;i<e.length;i++)o=e[i],r=o.area/(n/t.height),o.coord={height:r,width:t.width,top:t.top+s,left:t.left},s+=r},_totalArea:function(e){var t,n=0;for(t=0;t<e.length;t++)n+=e[t].area;return n}}),H=B.extend({htmlSize:function(e){var t,n,i=this._getByUid(e.dataItem.uid),o={text:0,offset:0};return e.children&&(this._clean(i),t=this._getText(e),t&&(n=this._createTitle(e),i.append(n),this._compile(n,e.dataItem),o.text=e.vertical?n.height():n.width()),i.append(this._createWrap()),this.offset=(_(i)-i.innerWidth())/2),o},titleSize:function(e,t){var n;return n=e.vertical?t.children(".k-treemap-title").height():t.children(".k-treemap-title-vertical").width(),n||0},_createTitle:function(t){var n;return n=e(t.vertical?"<div class='k-treemap-title'></div>":"<div class='k-treemap-title-vertical'></div>"),n.append(e("<div></div>").html(this._getText(t)))}});S.ui.plugin(z)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.dataviz.min",["kendo.core.min","kendo.fx.min","kendo.router.min","kendo.view.min","kendo.data.odata.min","kendo.data.xml.min","kendo.data.min","kendo.data.signalr.min","kendo.binder.min","kendo.userevents.min","kendo.draganddrop.min","kendo.mobile.scroller.min","kendo.popup.min","kendo.tooltip.min","kendo.drawing.min","kendo.dataviz.core.min","kendo.dataviz.themes.min","kendo.dataviz.chart.min","kendo.dataviz.gauge.min","kendo.dataviz.barcode.min","kendo.dataviz.qrcode.min","kendo.dataviz.stock.min","kendo.dataviz.sparkline.min","kendo.dataviz.map.min","kendo.dataviz.diagram.min","kendo.dataviz.treemap.min","kendo.angular.min"],e)}(function(){"bundle all";return window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.modalview.min",["kendo.mobile.shim.min","kendo.mobile.view.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile.ui,o=i.Shim,r=i.Widget,s="beforeOpen",a="open",l="close",c="init",d='<div class="km-modalview-wrapper" />',u=i.View.extend({init:function(e,t){var n=this;r.fn.init.call(n,e,t),n._id(),n._wrap(),n._shim(),this.options.$angular||(n._layout(),n._scroller(),n._model()),n.element.css("display",""),n.trigger(c)},events:[c,s,a,l],options:{name:"ModalView",modal:!0,width:null,height:null},destroy:function(){r.fn.destroy.call(this),this.shim.destroy()},open:function(t){var n=this;n.target=e(t),n.shim.show(),n._invokeNgController(),n.trigger("show",{view:n})},openFor:function(e){this.trigger(s,{target:e})||(this.open(e),this.trigger(a,{target:e}))},close:function(){this.element.is(":visible")&&!this.trigger(l)&&this.shim.hide()},_wrap:function(){var e,t,n=this,i=n.element,o=n.options;e=i[0].style.width||"auto",t=i[0].style.height||"auto",i.addClass("km-modalview").wrap(d),n.wrapper=i.parent().css({width:o.width||e||300,height:o.height||t||300}).addClass("auto"==t?" km-auto-height":""),i.css({width:"",height:""})},_shim:function(){var e=this;e.shim=new o(e.wrapper,{modal:e.options.modal,position:"center center",align:"center center",effect:"fade:in",className:"km-modalview-root",hide:function(t){e.trigger(l)&&t.preventDefault()}})}});i.plugin(u)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.drawer.min",["kendo.mobile.view.min","kendo.userevents.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile,o=n.support.mobileOS,r=n.effects.Transition,s=n.roleSelector,a="x",l=i.ui,c=!(o.ios&&7==o.majorVersion&&!o.appMode),d="beforeShow",u="init",h="show",f="hide",p="afterHide",m={
enable:e.noop},g=l.View.extend({init:function(t,o){var r,a,l,d,h;if(e(t).parent().prepend(t),i.ui.Widget.fn.init.call(this,t,o),this.options.$angular||(this._layout(),this._scroller()),this._model(),r=this.element.closest(s("pane")).data("kendoMobilePane"))this.pane=r,this.pane.bind("viewShow",function(e){d._viewShow(e)}),this.pane.bind("sameViewRequested",function(){d.hide()}),a=this.userEvents=new n.UserEvents(r.element,{fastTap:!0,filter:s("view splitview"),allowSelection:!0});else{if(this.currentView=m,l=e(this.options.container),!l)throw Error("The drawer needs a container configuration option set.");a=this.userEvents=new n.UserEvents(l,{fastTap:!0,allowSelection:!0}),this._attachTransition(l)}d=this,h=function(e){d.visible&&(d.hide(),e.preventDefault())},this.options.swipeToOpen&&c?(a.bind("press",function(){d.transition.cancel()}),a.bind("start",function(e){d._start(e)}),a.bind("move",function(e){d._update(e)}),a.bind("end",function(e){d._end(e)}),a.bind("tap",h)):a.bind("press",h),this.leftPositioned="left"===this.options.position,this.visible=!1,this.element.hide().addClass("km-drawer").addClass(this.leftPositioned?"km-left-drawer":"km-right-drawer"),this.trigger(u)},options:{name:"Drawer",position:"left",views:[],swipeToOpenViews:[],swipeToOpen:!0,title:"",container:null},events:[d,f,p,u,h],show:function(){this._activate()&&this._show()},hide:function(){this.currentView&&(this.currentView.enable(),g.current=null,this._moveViewTo(0),this.trigger(f,{view:this}))},openFor:function(){this.visible?this.hide():this.show()},destroy:function(){l.View.fn.destroy.call(this),this.userEvents.destroy()},_activate:function(){if(this.visible)return!0;var e=this._currentViewIncludedIn(this.options.views);return!(!e||this.trigger(d,{view:this}))&&(this._setAsCurrent(),this.element.show(),this.trigger(h,{view:this}),this._invokeNgController(),!0)},_currentViewIncludedIn:function(t){if(!this.pane||!t.length)return!0;var n=this.pane.view();return e.inArray(n.id.replace("#",""),t)>-1||e.inArray(n.element.attr("id"),t)>-1},_show:function(){this.currentView.enable(!1),this.visible=!0;var e=this.element.width();this.leftPositioned||(e=-e),this._moveViewTo(e)},_setAsCurrent:function(){g.last!==this&&(g.last&&g.last.element.hide(),this.element.show()),g.last=this,g.current=this},_moveViewTo:function(e){this.userEvents.cancel(),this.transition.moveTo({location:e,duration:400,ease:r.easeOutExpo})},_viewShow:function(e){return this.currentView&&this.currentView.enable(),this.currentView===e.view?(this.hide(),t):(this.currentView=e.view,this._attachTransition(e.view.element),t)},_attachTransition:function(e){var t=this,i=this.movable,o=i&&i.x;this.transition&&(this.transition.cancel(),this.movable.moveAxis("x",0)),i=this.movable=new n.ui.Movable(e),this.transition=new r({axis:a,movable:this.movable,onEnd:function(){0===i[a]&&(e[0].style.cssText="",t.element.hide(),t.trigger(p),t.visible=!1)}}),o&&(e.addClass("k-fx-hidden"),n.animationFrame(function(){e.removeClass("k-fx-hidden"),t.movable.moveAxis(a,o),t.hide()}))},_start:function(e){var i,o,r,s,a,l=e.sender;return Math.abs(e.x.velocity)<Math.abs(e.y.velocity)||n.triggeredByInput(e.event)||!this._currentViewIncludedIn(this.options.swipeToOpenViews)?(l.cancel(),t):(i=this.leftPositioned,o=this.visible,r=i&&o||!i&&!g.current,s=!i&&o||i&&!g.current,a=e.x.velocity<0,(r&&a||s&&!a)&&this._activate()?(l.capture(),t):(l.cancel(),t))},_update:function(e){var t,n=this.movable,i=n.x+e.x.delta;t=this.leftPositioned?Math.min(Math.max(0,i),this.element.width()):Math.max(Math.min(0,i),-this.element.width()),this.movable.moveAxis(a,t),e.event.preventDefault(),e.event.stopPropagation()},_end:function(e){var t,n=e.x.velocity,i=Math.abs(this.movable.x)>this.element.width()/2,o=.8;t=this.leftPositioned?n>-o&&(n>o||i):n<o&&(n<-o||i),t?this._show():this.hide()}});l.plugin(g)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.splitview.min",["kendo.mobile.pane.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile.ui,o=i.Widget,r="<div class='km-expanded-pane-shim' />",s=i.View,a=s.extend({init:function(t,s){var a,l,c=this;o.fn.init.call(c,t,s),t=c.element,e.extend(c,s),c._id(),c.options.$angular?c._overlay():(c._layout(),c._overlay()),c._style(),l=t.children(c._locate("modalview")),c.options.$angular?l.each(function(t,i){n.compileMobileDirective(e(i),s.$angular[0])}):n.mobile.init(l),c.panes=[],c._paramsHistory=[],c.options.$angular?(c.element.children(n.directiveSelector("pane")).each(function(){a=n.compileMobileDirective(e(this),s.$angular[0]),c.panes.push(a)}),c.element.children(n.directiveSelector("header footer")).each(function(){n.compileMobileDirective(e(this),s.$angular[0])})):c.content.children(n.roleSelector("pane")).each(function(){a=n.initWidget(this,{},i.roles),c.panes.push(a)}),c.expandedPaneShim=e(r).appendTo(c.element),c._shimUserEvents=new n.UserEvents(c.expandedPaneShim,{fastTap:!0,tap:function(){c.collapsePanes()}})},_locate:function(e){return this.options.$angular?n.directiveSelector(e):n.roleSelector(e)},options:{name:"SplitView",style:"horizontal"},expandPanes:function(){this.element.addClass("km-expanded-splitview")},collapsePanes:function(){this.element.removeClass("km-expanded-splitview")},_layout:function(){var e=this,t=e.element;e.transition=n.attrValue(t,"transition"),n.mobile.ui.View.prototype._layout.call(this),n.mobile.init(this.header.add(this.footer)),e.element.addClass("km-splitview"),e.content.addClass("km-split-content")},_style:function(){var t,n=this.options.style,i=this.element;n&&(t=n.split(" "),e.each(t,function(){i.addClass("km-split-"+this)}))},showStart:function(){var t=this;t.element.css("display",""),t.inited?this._invokeNgController():(t.inited=!0,e.each(t.panes,function(){this.options.initial?this.navigateToInitial():this.navigate("")}),t.trigger("init",{view:t})),t.trigger("show",{view:t})}});i.plugin(a)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.application.min",["kendo.mobile.pane.min","kendo.router.min"],e)}(function(){return function(e,t){function n(e,t){var n=[];return p&&n.push("km-on-"+p.name),n.push(e.skin?"km-"+e.skin:"ios"==e.name&&e.majorVersion>6?"km-ios7":"km-"+e.name),("ios"==e.name&&e.majorVersion<7||"ios"!=e.name)&&n.push("km-"+e.name+e.majorVersion),n.push("km-"+e.majorVersion),n.push("km-m"+(e.minorVersion?e.minorVersion[0]:0)),e.variant&&(e.skin&&e.skin===e.name||!e.skin||e.setDefaultPlatform===!1)&&n.push("km-"+(e.skin?e.skin:e.name)+"-"+e.variant),e.cordova&&n.push("km-cordova"),n.push(e.appMode?"km-app":"km-web"),t&&t.statusBarStyle&&n.push("km-"+t.statusBarStyle+"-status-bar"),n.join(" ")}function i(t){return"km-wp-"+(t.noVariantSet?0===parseInt(e("<div style='background: Background' />").css("background-color").split(",")[1],10)?"dark":"light":t.variant+" km-wp-"+t.variant+"-force")}function o(e){return p.wp?"-kendo-landscape"==e.css("animation-name"):Math.abs(window.orientation)/90==1}function r(e){return o(e)?y:v}function s(e){e.parent().addBack().css("min-height",window.innerHeight)}function a(){e("meta[name=viewport]").remove(),P.append(x({height:", width=device-width"+(o()?", height="+window.innerHeight+"px":d.mobileOS.flatVersion>=600&&d.mobileOS.flatVersion<700?", height="+window.innerWidth+"px":", height=device-height")}))}var l=window.kendo,c=l.mobile,d=l.support,u=c.ui.Widget,h=c.ui.Pane,f="ios7",p=d.mobileOS,m="blackberry"==p.device&&p.flatVersion>=600&&p.flatVersion<1e3&&p.appMode,g=.93,v="km-vertical",_="chrome"===p.browser,b=p.ios&&p.flatVersion>=700&&p.flatVersion<800&&(p.appMode||_),w=Math.abs(window.orientation)/90==1,y="km-horizontal",k={ios7:{ios:!0,browser:"default",device:"iphone",flatVersion:"700",majorVersion:"7",minorVersion:"0.0",name:"ios",tablet:!1},ios:{ios:!0,browser:"default",device:"iphone",flatVersion:"612",majorVersion:"6",minorVersion:"1.2",name:"ios",tablet:!1},android:{android:!0,browser:"default",device:"android",flatVersion:"442",majorVersion:"4",minorVersion:"4.2",name:"android",tablet:!1},blackberry:{blackberry:!0,browser:"default",device:"blackberry",flatVersion:"710",majorVersion:"7",minorVersion:"1.0",name:"blackberry",tablet:!1},meego:{meego:!0,browser:"default",device:"meego",flatVersion:"850",majorVersion:"8",minorVersion:"5.0",name:"meego",tablet:!1},wp:{wp:!0,browser:"default",device:"wp",flatVersion:"800",majorVersion:"8",minorVersion:"0.0",name:"wp",tablet:!1}},x=l.template('<meta content="initial-scale=#: data.scale #, maximum-scale=#: data.scale #, user-scalable=no#=data.height#" name="viewport" />',{usedWithBlock:!1}),C=l.template('<meta name="apple-mobile-web-app-capable" content="#= data.webAppCapable === false ? \'no\' : \'yes\' #" /> <meta name="apple-mobile-web-app-status-bar-style" content="#=data.statusBarStyle#" /> <meta name="msapplication-tap-highlight" content="no" /> ',{usedWithBlock:!1}),S=l.template("<style>.km-view { clip: rect(0 #= data.width #px #= data.height #px 0); }</style>",{usedWithBlock:!1}),T=p.android&&"chrome"!=p.browser||p.blackberry,D=l.template('<link rel="apple-touch-icon'+(p.android?"-precomposed":"")+'" # if(data.size) { # sizes="#=data.size#" #}# href="#=data.icon#" />',{usedWithBlock:!1}),A=("iphone"==p.device||"ipod"==p.device)&&p.majorVersion<7,E=("iphone"==p.device||"ipod"==p.device)&&p.majorVersion>=7,I=E?"none":null,M="mobilesafari"==p.browser?60:0,R=20,F=e(window),z=window.screen,P=e("head"),B="init",L=e.proxy,H=u.extend({init:function(t,n){c.application=this,e(e.proxy(this,"bootstrap",t,n))},bootstrap:function(t,n){var i,o,r;t=e(t),t[0]||(t=e(document.body)),u.fn.init.call(this,t,n),this.element.removeAttr("data-"+l.ns+"role"),this._setupPlatform(),this._attachMeta(),this._setupElementClass(),this._attachHideBarHandlers(),i=e.extend({},this.options),delete i.name,o=this,r=function(){o.pane=new h(o.element,i),o.pane.navigateToInitial(),o.options.updateDocumentTitle&&o._setupDocumentTitle(),o._startHistory(),o.trigger(B)},this.options.$angular?setTimeout(r):r()},options:{name:"Application",hideAddressBar:!0,browserHistory:!0,historyTransition:I,modelScope:window,statusBarStyle:"black",transition:"",retina:!1,platform:null,skin:null,updateDocumentTitle:!0,useNativeScrolling:!1},events:[B],navigate:function(e,t){this.pane.navigate(e,t)},replace:function(e,t){this.pane.replace(e,t)},scroller:function(){return this.view().scroller},hideLoading:function(){if(!this.pane)throw Error("The mobile application instance is not fully instantiated. Please consider activating loading in the application init event handler.");this.pane.hideLoading()},showLoading:function(){if(!this.pane)throw Error("The mobile application instance is not fully instantiated. Please consider activating loading in the application init event handler.");this.pane.showLoading()},changeLoadingMessage:function(e){if(!this.pane)throw Error("The mobile application instance is not fully instantiated. Please consider changing the message in the application init event handler.");this.pane.changeLoadingMessage(e)},view:function(){return this.pane.view()},skin:function(e){var t=this;return arguments.length?(t.options.skin=e||"",t.element[0].className="km-pane",t._setupPlatform(),t._setupElementClass(),t.options.skin):t.options.skin},destroy:function(){u.fn.destroy.call(this),this.pane.destroy(),this.options.browserHistory&&this.router.destroy()},_setupPlatform:function(){var t=this,o=t.options.platform,r=t.options.skin,s=[],a=p||k[f];o&&(a.setDefaultPlatform=!0,"string"==typeof o?(s=o.split("-"),a=e.extend({variant:s[1]},a,k[s[0]])):a=o),r&&(s=r.split("-"),p||(a.setDefaultPlatform=!1),a=e.extend({},a,{skin:s[0],variant:s[1]})),a.variant||(a.noVariantSet=!0,a.variant="dark"),t.os=a,t.osCssClass=n(t.os,t.options),"wp"==a.name&&(t.refreshBackgroundColorProxy||(t.refreshBackgroundColorProxy=e.proxy(function(){(t.os.variant&&t.os.skin&&t.os.skin===t.os.name||!t.os.skin)&&t.element.removeClass("km-wp-dark km-wp-light km-wp-dark-force km-wp-light-force").addClass(i(t.os))},t)),e(document).off("visibilitychange",t.refreshBackgroundColorProxy),e(document).off("resume",t.refreshBackgroundColorProxy),a.skin||(t.element.parent().css("overflow","hidden"),e(document).on("visibilitychange",t.refreshBackgroundColorProxy),e(document).on("resume",t.refreshBackgroundColorProxy),t.refreshBackgroundColorProxy()))},_startHistory:function(){this.options.browserHistory?(this.router=new l.Router({pushState:this.options.pushState,root:this.options.root,hashBang:this.options.hashBang}),this.pane.bindToRouter(this.router),this.router.start()):this.options.initial||this.pane.navigate("")},_resizeToScreenHeight:function(){var t,n=e("meta[name=apple-mobile-web-app-status-bar-style]").attr("content").match(/black-translucent|hidden/),i=this.element;t=_?window.innerHeight:o(i)?n?w?z.availWidth+R:z.availWidth:w?z.availWidth:z.availWidth-R:n?w?z.availHeight:z.availHeight+R:w?z.availHeight-R:z.availHeight,i.height(t)},_setupElementClass:function(){var t,n=this,i=n.element;i.parent().addClass("km-root km-"+(n.os.tablet?"tablet":"phone")),i.addClass(n.osCssClass+" "+r(i)),this.options.useNativeScrolling&&i.parent().addClass("km-native-scrolling"),_&&i.addClass("km-ios-chrome"),d.wpDevicePixelRatio&&i.parent().css("font-size",d.wpDevicePixelRatio+"em"),this.options.retina&&(i.parent().addClass("km-retina"),i.parent().css("font-size",d.devicePixelRatio*g+"em")),m&&a(),n.options.useNativeScrolling?i.parent().addClass("km-native-scrolling"):T&&(t=(screen.availWidth>screen.availHeight?screen.availWidth:screen.availHeight)+200,e(S({width:t,height:t})).appendTo(P)),b&&n._resizeToScreenHeight(),l.onResize(function(){i.removeClass("km-horizontal km-vertical").addClass(r(i)),n.options.useNativeScrolling&&s(i),b&&n._resizeToScreenHeight(),m&&a(),l.resize(i)})},_clearExistingMeta:function(){P.find("meta").filter("[name|='apple-mobile-web-app'],[name|='msapplication-tap'],[name='viewport']").remove()},_attachMeta:function(){var e,t=this.options,n=t.icon;if(this._clearExistingMeta(),m||P.prepend(x({height:"",scale:this.options.retina?1/d.devicePixelRatio:"1.0"})),P.prepend(C(t)),n){"string"==typeof n&&(n={"":n});for(e in n)P.prepend(D({icon:n[e],size:e}))}t.useNativeScrolling&&s(this.element)},_attachHideBarHandlers:function(){var e=this,t=L(e,"_hideBar");!d.mobileOS.appMode&&e.options.hideAddressBar&&A&&!e.options.useNativeScrolling&&(e._initialHeight={},F.on("load",t),l.onResize(function(){setTimeout(window.scrollTo,0,0,1)}))},_setupDocumentTitle:function(){var e=this,n=document.title;e.pane.bind("viewShow",function(e){var i=e.view.title;document.title=i!==t?i:n})},_hideBar:function(){var t=this,n=t.element;n.height(l.support.transforms.css+"calc(100% + "+M+"px)"),e(window).trigger(l.support.resize)}});l.mobile.Application=H,l.ui.plugin(H,l.mobile,"Mobile")}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.button.min",["kendo.userevents.min"],e)}(function(){return function(e,t){function n(t,n,i){e(n.target).closest(".km-button,.km-detail").toggleClass("km-state-active",i),d&&t.deactivateTimeoutID&&(clearTimeout(t.deactivateTimeoutID),t.deactivateTimeoutID=0)}function i(t){return e('<span class="km-badge">'+t+"</span>")}var o=window.kendo,r=o.mobile,s=r.ui,a=s.Widget,l=o.support,c=l.mobileOS,d=c.android&&c.flatVersion>=300,u="click",h="disabled",f="km-state-disabled",p=a.extend({init:function(e,t){var i,r=this;a.fn.init.call(r,e,t),i="up"===r.options.clickOn,r._wrap(),r._style(),i||r.element.attr("data-navigate-on-press",!0),r.options.enable=r.options.enable&&!r.element.attr(h),r.enable(r.options.enable),r._userEvents=new o.UserEvents(r.element,{allowSelection:!i,fastTap:!0,press:function(e){r._activate(e)},release:function(e){n(r,e,!1),i||e.event.stopPropagation()}}),r._userEvents.bind(i?"tap":"press",function(e){r._release(e)}),d&&r.element.on("move",function(e){r._timeoutDeactivate(e)})},destroy:function(){a.fn.destroy.call(this),this._userEvents.destroy()},events:[u],options:{name:"Button",icon:"",style:"",badge:"",clickOn:"up",enable:!0},badge:function(e){var t=this.badgeElement=this.badgeElement||i(e).appendTo(this.element);return e||0===e?(t.html(e),this):e===!1?(t.empty().remove(),this.badgeElement=!1,this):t.html()},enable:function(e){var n=this.element;t===e&&(e=!0),this.options.enable=e,e?n.removeAttr(h):n.attr(h,h),n.toggleClass(f,!e)},_timeoutDeactivate:function(e){this.deactivateTimeoutID||(this.deactivateTimeoutID=setTimeout(n,500,this,e,!1))},_activate:function(e){var t=document.activeElement,i=t?t.nodeName:"";this.options.enable&&(n(this,e,!0),"INPUT"!=i&&"TEXTAREA"!=i||t.blur())},_release:function(n){var i=this;if(!(n.which>1))return i.options.enable?(i.trigger(u,{target:e(n.target),button:i.element})&&n.preventDefault(),t):(n.preventDefault(),t)},_style:function(){var t,n=this.options.style,i=this.element;n&&(t=n.split(" "),e.each(t,function(){i.addClass("km-"+this)}))},_wrap:function(){var t=this,n=t.options.icon,o=t.options.badge,r='<span class="km-icon km-'+n,s=t.element.addClass("km-button"),a=s.children("span:not(.km-icon)").addClass("km-text"),l=s.find("img").addClass("km-image");!a[0]&&s.html()&&(a=s.wrapInner('<span class="km-text" />').children("span.km-text")),!l[0]&&n&&(a[0]||(r+=" km-notext"),t.iconElement=s.prepend(e(r+'" />'))),(o||0===o)&&(t.badgeElement=i(o).appendTo(s))}}),m=p.extend({options:{name:"BackButton",style:"back"},init:function(e,n){var i=this;p.fn.init.call(i,e,n),t===i.element.attr("href")&&i.element.attr("href","#:back")}}),g=p.extend({options:{name:"DetailButton",style:""},init:function(e,t){p.fn.init.call(this,e,t)},_style:function(){var t,n=this.options.style+" detail",i=this.element;n&&(t=n.split(" "),e.each(t,function(){i.addClass("km-"+this)}))},_wrap:function(){var t=this,n=t.options.icon,i='<span class="km-icon km-'+n,o=t.element,r=o.children("span"),s=o.find("img").addClass("km-image");!s[0]&&n&&(r[0]||(i+=" km-notext"),o.prepend(e(i+'" />')))}});s.plugin(p),s.plugin(m),s.plugin(g)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.buttongroup.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(e){return"k-"+e+" km-"+e}function i(t){return e('<span class="'+n("badge")+'">'+t+"</span>")}var o=window.kendo,r=o.mobile.ui,s=r.Widget,a="state-active",l="state-disabled",c="select",d="li:not(.km-"+a+")",u=s.extend({init:function(e,t){var i=this;s.fn.init.call(i,e,t),i.element.addClass("km-buttongroup k-widget k-button-group").find("li").each(i._button),i.element.on(i.options.selectOn,d,"_select"),i._enable=!0,i.select(i.options.index),i.options.enable||(i._enable=!1,i.wrapper.addClass(n(l)))},events:[c],options:{name:"ButtonGroup",selectOn:"down",index:-1,enable:!0},current:function(){return this.element.find(".km-"+a)},select:function(i){var o=this,r=-1;i!==t&&i!==-1&&o._enable&&!e(i).is(".km-"+l)&&(o.current().removeClass(n(a)),"number"==typeof i?(r=i,i=e(o.element[0].children[i])):i.nodeType&&(i=e(i),r=i.index()),i.addClass(n(a)),o.selectedIndex=r)},badge:function(t,n){var o,r=this.element;return isNaN(t)||(t=r.children().get(t)),t=r.find(t),o=e(t.children(".km-badge")[0]||i(n).appendTo(t)),n||0===n?(o.html(n),this):n===!1?(o.empty().remove(),this):o.html()},enable:function(e){t===e&&(e=!0),this.wrapper.toggleClass(n(l),!e),this._enable=this.options.enable=e},_button:function(){var t=e(this).addClass(n("button")),r=o.attrValue(t,"icon"),s=o.attrValue(t,"badge"),a=t.children("span"),l=t.find("img").addClass(n("image"));a[0]||(a=t.wrapInner("<span/>").children("span")),a.addClass(n("text")),!l[0]&&r&&t.prepend(e('<span class="'+n("icon")+" "+n(r)+'"/>')),(s||0===s)&&i(s).appendTo(t)},_select:function(e){e.which>1||e.isDefaultPrevented()||!this._enable||(this.select(e.currentTarget),this.trigger(c,{index:this.selectedIndex}))}});r.plugin(u)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.collapsible.min",["kendo.core.min"],e)}(function(){return function(e,t){var n=window.kendo,i=n.mobile.ui,o=i.Widget,r="km-collapsible",s="km-collapsible-header",a="km-collapsible-content",l="km-collapsibleinset",c="<div data-role='collapsible-header' class='"+s+"'></div>",d="<div data-role='collapsible-content' class='"+a+"'></div>",u="km-collapsed",h="km-expanded",f="km-animated",p="left",m="expand",g="collapse",v=o.extend({init:function(t,i){var s=this,a=e(t);o.fn.init.call(s,a,i),a.addClass(r),s._buildHeader(),s.content=a.children().not(s.header).wrapAll(d).parent(),s._userEvents=new n.UserEvents(s.header,{fastTap:!0,tap:function(){s.toggle()}}),a.addClass(s.options.collapsed?u:h),s.options.inset&&a.addClass(l),s.options.animation?(s.content.addClass(f),s.content.height(0),s.options.collapsed&&s.content.hide()):s.options.collapsed&&s.content.hide()},events:[m,g],options:{name:"Collapsible",collapsed:!0,collapseIcon:"arrow-n",expandIcon:"arrow-s",iconPosition:p,animation:!0,inset:!1},destroy:function(){o.fn.destroy.call(this),this._userEvents.destroy()},expand:function(e){var t=this.options.collapseIcon,i=this.content,o=n.support.mobileOS.ios;this.trigger(m)||(t&&this.header.find(".km-icon").removeClass().addClass("km-icon km-"+t),this.element.removeClass(u).addClass(h),this.options.animation&&!e?(i.off("transitionend"),i.show(),o&&i.removeClass(f),i.height(this._getContentHeight()),o&&i.addClass(f),n.resize(i)):i.show())},collapse:function(e){var t=this.options.expandIcon,n=this.content;this.trigger(g)||(t&&this.header.find(".km-icon").removeClass().addClass("km-icon km-"+t),this.element.removeClass(h).addClass(u),this.options.animation&&!e?(n.one("transitionend",function(){n.hide()}),n.height(0)):n.hide())},toggle:function(e){this.isCollapsed()?this.expand(e):this.collapse(e)},isCollapsed:function(){return this.element.hasClass(u)},resize:function(){!this.isCollapsed()&&this.options.animation&&this.content.height(this._getContentHeight())},_buildHeader:function(){var t=this.element.children(":header").wrapAll(c),n=e('<span class="km-icon"/>'),i=this.options.collapsed?this.options.expandIcon:this.options.collapseIcon,o=this.options.iconPosition;i&&(t.prepend(n),n.addClass("km-"+i)),this.header=t.parent(),this.header.addClass("km-icon-"+o)},_getContentHeight:function(){var e,t=this.content.attr("style");return this.content.css({position:"absolute",visibility:"hidden",height:"auto"}),e=this.content.height(),this.content.attr("style",t?t:""),e}});i.plugin(v)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.listview.min",["kendo.data.min","kendo.userevents.min","kendo.mobile.button.min"],e)}(function(){return function(e,t){function n(){return this.nodeType===v.TEXT_NODE&&this.nodeValue.match(W)}function i(e,t){t&&!e[0].querySelector(".km-icon")&&e.prepend('<span class="km-icon km-'+t+'"/>')}function o(e){i(e,D(e,"icon")),i(e,D(e.children(S),"icon"))}function r(e){var t=e.parent(),o=e.add(t.children(g.roleSelector("detailbutton"))),r=t.contents().not(o).not(n);r.length||(e.addClass("km-listview-link").attr(g.attr("role"),"listview-link"),i(e,D(t,"icon")),i(e,D(e,"icon")))}function s(e){if(e[0].querySelector("input[type=checkbox],input[type=radio]")){var t=e.parent();t.contents().not(e).not(function(){return 3==this.nodeType})[0]||(e.addClass("km-listview-label"),e.children("[type=checkbox],[type=radio]").addClass("km-widget km-icon km-check"))}}function a(t,n){e(t).css("transform","translate3d(0px, "+n+"px, 0px)")}var l,c,d,u,h,f,p,m,g=window.kendo,v=window.Node,_=g.mobile,b=_.ui,w=g._outerHeight,y=g.data.DataSource,k=b.DataBoundWidget,x=".km-list > li, > li:not(.km-group-container)",C=".km-listview-link, .km-listview-label",S="["+g.attr("icon")+"]",T=e.proxy,D=g.attrValue,A="km-group-title",E="km-state-active",I='<div class="'+A+'"><div class="km-text"></div></div>',M=g.template('<li><div class="'+A+'"><div class="km-text">#= this.headerTemplate(data) #</div></div><ul>#= kendo.render(this.template, data.items)#</ul></li>'),R='<div class="km-listview-wrapper" />',F=g.template('<form class="km-filter-form"><div class="km-filter-wrap"><input type="search" placeholder="#=placeholder#"/><a href="\\#" class="km-filter-reset" title="Clear"><span class="km-icon km-clear"></span><span class="km-text">Clear</span></a></div></form>'),z=".kendoMobileListView",P="styled",B="dataBound",L="dataBinding",H="itemChange",N="click",O="change",V="progress",U="function",W=/^\s+$/,j=/button/,q=g.Class.extend({init:function(e){var t,n,i=e.scroller();i&&(this.options=e.options,this.element=e.element,this.scroller=e.scroller(),this._shouldFixHeaders(),t=this,n=function(){t._cacheHeaders()},e.bind("resize",n),e.bind(P,n),e.bind(B,n),this._scrollHandler=function(e){t._fixHeader(e)},i.bind("scroll",this._scrollHandler))},destroy:function(){var e=this;e.scroller&&e.scroller.unbind("scroll",e._scrollHandler)},_fixHeader:function(t){if(this.fixedHeaders){var n,i,o,r=0,s=this.scroller,a=this.headers,l=t.scrollTop;do{if(n=a[r++],!n){o=e("<div />");break}i=n.offset,o=n.header}while(i+1>l);this.currentHeader!=r&&(s.fixedContainer.html(o.clone()),this.currentHeader=r)}},_shouldFixHeaders:function(){this.fixedHeaders="group"===this.options.type&&this.options.fixedHeaders},_cacheHeaders:function(){if(this._shouldFixHeaders(),this.fixedHeaders){var t=[],n=this.scroller.scrollTop;this.element.find("."+A).each(function(i,o){o=e(o),t.unshift({offset:o.position().top+n,header:o})}),this.headers=t,this._fixHeader({scrollTop:n})}}}),G=function(){return{page:1}},$=g.Class.extend({init:function(e){var t=this,n=e.options,i=e.scroller(),o=n.pullParameters||G;this.listView=e,this.scroller=i,e.bind("_dataSource",function(e){t.setDataSource(e.dataSource)}),i.setOptions({pullToRefresh:!0,pull:function(){t._pulled||(t._pulled=!0,t.dataSource.read(o.call(e,t._first)))},messages:{pullTemplate:n.messages.pullTemplate,releaseTemplate:n.messages.releaseTemplate,refreshTemplate:n.messages.refreshTemplate}})},setDataSource:function(e){var t=this;this._first=e.view()[0],this.dataSource=e,e.bind("change",function(){t._change()}),e.bind("error",function(){t._change()})},_change:function(){var e,t=this.scroller,n=this.dataSource;this._pulled&&t.pullHandled(),!this._pulled&&this._first||(e=n.view(),e[0]&&(this._first=e[0])),this._pulled=!1}}),K=g.Observable.extend({init:function(e){var t=this;g.Observable.fn.init.call(t),t.buffer=e.buffer,t.height=e.height,t.item=e.item,t.items=[],t.footer=e.footer,t.buffer.bind("reset",function(){t.refresh()})},refresh:function(){for(var e,t,n,i,o=this.buffer,r=this.items,s=!1;r.length;)r.pop().destroy();for(this.offset=o.offset,e=this.item,i=0;i<o.viewSize;i++){if(i===o.total()){s=!0;break}n=e(this.content(this.offset+r.length)),n.below(t),t=n,r.push(n)}this.itemCount=r.length,this.trigger("reset"),this._resize(),s&&this.trigger("endReached")},totalHeight:function(){if(!this.items[0])return 0;var e=this,t=e.items,n=t[0].top,i=t[t.length-1].bottom,o=(i-n)/e.itemCount,r=e.buffer.length-e.offset-e.itemCount;return(this.footer?this.footer.height:0)+i+r*o},batchUpdate:function(e){var t,n,i=this.height(),o=this.items,r=this.offset;if(o[0]){if(this.lastDirection)for(;o[o.length-1].bottom>e+2*i&&0!==this.offset;)this.offset--,t=o.pop(),t.update(this.content(this.offset)),t.above(o[0]),o.unshift(t);else for(;o[0].top<e-i;){if(n=this.offset+this.itemCount,n===this.buffer.total()){this.trigger("endReached");break}if(n===this.buffer.length)break;t=o.shift(),t.update(this.content(this.offset+this.itemCount)),t.below(o[o.length-1]),o.push(t),this.offset++}r!==this.offset&&this._resize()}},update:function(e){var t,n,i,o,r=this,s=this.items,a=this.height(),l=this.itemCount,c=a/2,d=(this.lastTop||0)>e,u=e-c,h=e+a+c;s[0]&&(this.lastTop=e,this.lastDirection=d,d?s[0].top>u&&s[s.length-1].bottom>h+c&&this.offset>0&&(this.offset--,t=s.pop(),n=s[0],t.update(this.content(this.offset)),s.unshift(t),t.above(n),r._resize()):s[s.length-1].bottom<h&&s[0].top<u-c&&(o=this.offset+l,o===this.buffer.total()?this.trigger("endReached"):o!==this.buffer.length&&(t=s.shift(),i=s[s.length-1],s.push(t),t.update(this.content(this.offset+this.itemCount)),r.offset++,t.below(i),r._resize())))},content:function(e){return this.buffer.at(e)},destroy:function(){this.unbind()},_resize:function(){var e=this.items,t=0,n=0,i=e[0],o=e[e.length-1];i&&(t=i.top,n=o.bottom),this.trigger("resize",{top:t,bottom:n}),this.footer&&this.footer.below(o)}});g.mobile.ui.VirtualList=K,l=g.Class.extend({init:function(t,n){var i=t.append([n],!0)[0],o=i.offsetHeight;e.extend(this,{top:0,element:i,listView:t,height:o,bottom:o})},update:function(e){this.element=this.listView.setDataItem(this.element,e)},above:function(e){e&&(this.height=this.element.offsetHeight,this.top=e.top-this.height,this.bottom=e.top,a(this.element,this.top))},below:function(e){e&&(this.height=this.element.offsetHeight,this.top=e.bottom,this.bottom=this.top+this.height,a(this.element,this.top))},destroy:function(){g.destroy(this.element),e(this.element).remove()}}),c='<div><span class="km-icon"></span><span class="km-loading-left"></span><span class="km-loading-right"></span></div>',d=g.Class.extend({init:function(t){this.element=e('<li class="km-load-more km-scroller-refresh" style="display: none"></li>').appendTo(t.element),this._loadIcon=e(c).appendTo(this.element)},enable:function(){this.element.show(),this.height=w(this.element,!0)},disable:function(){this.element.hide(),this.height=0},below:function(e){e&&(this.top=e.bottom,this.bottom=this.height+this.top,a(this.element,this.top))}}),u=d.extend({init:function(t,n){this._loadIcon=e(c).hide(),this._loadButton=e('<a class="km-load">'+t.options.messages.loadMoreText+"</a>").hide(),this.element=e('<li class="km-load-more" style="display: none"></li>').append(this._loadIcon).append(this._loadButton).appendTo(t.element);var i=this;this._loadButton.kendoMobileButton().data("kendoMobileButton").bind("click",function(){i._hideShowButton(),n.next()}),n.bind("resize",function(){i._showLoadButton()}),this.height=w(this.element,!0),this.disable()},_hideShowButton:function(){this._loadButton.hide(),this.element.addClass("km-scroller-refresh"),this._loadIcon.css("display","block")},_showLoadButton:function(){this._loadButton.show(),this.element.removeClass("km-scroller-refresh"),this._loadIcon.hide()}}),h=g.Class.extend({init:function(e){var t=this;this.chromeHeight=w(e.wrapper.children().not(e.element)),this.listView=e,this.scroller=e.scroller(),this.options=e.options,e.bind("_dataSource",function(e){t.setDataSource(e.dataSource,e.empty)}),e.bind("resize",function(){t.list.items.length&&(t.scroller.reset(),t.buffer.range(0),t.list.refresh())}),this.scroller.makeVirtual(),this._scroll=function(e){t.list.update(e.scrollTop)},this.scroller.bind("scroll",this._scroll),this._scrollEnd=function(e){t.list.batchUpdate(e.scrollTop)},this.scroller.bind("scrollEnd",this._scrollEnd)},destroy:function(){this.list.unbind(),this.buffer.unbind(),this.scroller.unbind("scroll",this._scroll),this.scroller.unbind("scrollEnd",this._scrollEnd)},setDataSource:function(t,n){var i,o,r,s,a=this,c=this.options,h=this.listView,f=h.scroller(),p=c.loadMore;if(this.dataSource=t,i=t.pageSize()||c.virtualViewSize,!i&&!n)throw Error("the DataSource does not have page size configured. Page Size setting is mandatory for the mobile listview virtual scrolling to work as expected.");this.buffer&&this.buffer.destroy(),o=new g.data.Buffer(t,Math.floor(i/2),p),r=p?new u(h,o):new d(h),this.list&&this.list.destroy(),s=new K({buffer:o,footer:r,item:function(e){return new l(h,e)},height:function(){return f.height()}}),s.bind("resize",function(){a.updateScrollerSize(),h.updateSize()}),s.bind("reset",function(){a.footer.enable()}),s.bind("endReached",function(){
r.disable(),a.updateScrollerSize()}),o.bind("expand",function(){s.lastDirection=!1,s.batchUpdate(f.scrollTop)}),e.extend(this,{buffer:o,scroller:f,list:s,footer:r})},updateScrollerSize:function(){this.scroller.virtualSize(0,this.list.totalHeight()+this.chromeHeight)},refresh:function(){this.list.refresh()},reset:function(){this.buffer.range(0),this.list.refresh()}}),f=g.Class.extend({init:function(e){var t,n=this;this.listView=e,this.options=e.options,t=this,this._refreshHandler=function(e){t.refresh(e)},this._progressHandler=function(){e.showLoading()},e.bind("_dataSource",function(e){n.setDataSource(e.dataSource)})},destroy:function(){this._unbindDataSource()},reset:function(){},refresh:function(e){var n,i,o,r,s,a,l,c=e&&e.action,d=e&&e.items,u=this.listView,h=this.dataSource,f=this.options.appendOnRefresh,p=h.view(),m=h.group(),g=m&&m[0];return"itemchange"===c?(u._hasBindingTarget()||(n=u.findByDataItem(d)[0],n&&u.setDataItem(n,d[0])),t):(s="add"===c&&!g||f&&!u._filter,a="remove"===c&&!g,s?i=[]:a&&(i=u.findByDataItem(d)),u.trigger(L,{action:c||"rebind",items:d,removedItems:i,index:e&&e.index})?(this._shouldShowLoading()&&u.hideLoading(),t):("add"!==c||g?"remove"!==c||g?g?u.replaceGrouped(p):f&&!u._filter?(o=u.prepend(p),r=p):u.replace(p):(o=[],u.remove(d)):(l=p.indexOf(d[0]),l>-1&&(o=u.insertAt(d,l),r=d)),this._shouldShowLoading()&&u.hideLoading(),u.trigger(B,{ns:b,addedItems:o,addedDataItems:r}),t))},setDataSource:function(e){this.dataSource&&this._unbindDataSource(),this.dataSource=e,e.bind(O,this._refreshHandler),this._shouldShowLoading()&&this.dataSource.bind(V,this._progressHandler)},_unbindDataSource:function(){this.dataSource.unbind(O,this._refreshHandler).unbind(V,this._progressHandler)},_shouldShowLoading:function(){var e=this.options;return!e.pullToRefresh&&!e.loadMore&&!e.endlessScroll}}),p=g.Class.extend({init:function(t){var n=this,i=t.options.filterable,o="change paste",r=this;this.listView=t,this.options=i,t.element.before(F({placeholder:i.placeholder||"Search..."})),i.autoFilter!==!1&&(o+=" keyup"),this.element=t.wrapper.find(".km-search-form"),this.searchInput=t.wrapper.find("input[type=search]").closest("form").on("submit"+z,function(e){e.preventDefault()}).end().on("focus"+z,function(){n._oldFilter=n.searchInput.val()}).on(o.split(" ").join(z+" ")+z,T(this._filterChange,this)),this.clearButton=t.wrapper.find(".km-filter-reset").on(N,T(this,"_clearFilter")).hide(),this._dataSourceChange=e.proxy(this._refreshInput,this),t.bind("_dataSource",function(e){e.dataSource.bind("change",r._dataSourceChange)})},_refreshInput:function(){var e=this.listView.dataSource.filter(),t=this.listView._filter.searchInput;t.val(e&&e.filters[0].field===this.listView.options.filterable.field?e.filters[0].value:"")},_search:function(e){this._filter=!0,this.clearButton[e?"show":"hide"](),this.listView.dataSource.filter(e)},_filterChange:function(e){var t=this;"paste"==e.type&&this.options.autoFilter!==!1?setTimeout(function(){t._applyFilter()},1):this._applyFilter()},_applyFilter:function(){var e=this.options,t=this.searchInput.val(),n=t.length?{field:e.field,operator:e.operator||"startswith",ignoreCase:e.ignoreCase,value:t}:null;t!==this._oldFilter&&(this._oldFilter=t,this._search(n))},_clearFilter:function(e){this.searchInput.val(""),this._search(null),e.preventDefault()}}),m=k.extend({init:function(t,n){var i=this;k.fn.init.call(this,t,n),t=this.element,n=this.options,n.scrollTreshold&&(n.scrollThreshold=n.scrollTreshold),t.on("down",C,"_highlight").on("move up cancel",C,"_dim"),this._userEvents=new g.UserEvents(t,{fastTap:!0,filter:x,allowSelection:!0,tap:function(e){i._click(e)}}),t.css("-ms-touch-action","auto"),t.wrap(R),this.wrapper=this.element.parent(),this._headerFixer=new q(this),this._itemsCache={},this._templates(),this.virtual=n.endlessScroll||n.loadMore,this._style(),this.options.$angular&&(this.virtual||this.options.pullToRefresh)?setTimeout(e.proxy(this,"_start")):this._start()},_start:function(){var e=this.options;this.options.filterable&&(this._filter=new p(this)),this._itemBinder=this.virtual?new h(this):new f(this),this.options.pullToRefresh&&(this._pullToRefreshHandler=new $(this)),this.setDataSource(e.dataSource),this._enhanceItems(this.items()),g.notify(this,b)},events:[N,L,B,H],options:{name:"ListView",style:"",type:"flat",autoBind:!0,fixedHeaders:!1,template:"#:data#",headerTemplate:'<span class="km-text">#:value#</span>',appendOnRefresh:!1,loadMore:!1,endlessScroll:!1,scrollThreshold:30,pullToRefresh:!1,messages:{loadMoreText:"Press to load more",pullTemplate:"Pull to refresh",releaseTemplate:"Release to refresh",refreshTemplate:"Refreshing"},pullOffset:140,filterable:!1,virtualViewSize:null},refresh:function(){this._itemBinder.refresh()},reset:function(){this._itemBinder.reset()},setDataSource:function(e){var t=!e;this.dataSource=y.create(e),this.trigger("_dataSource",{dataSource:this.dataSource,empty:t}),this.options.autoBind&&!t&&(this.items().remove(),this.dataSource.fetch())},destroy:function(){k.fn.destroy.call(this),g.destroy(this.element),this._userEvents.destroy(),this._itemBinder&&this._itemBinder.destroy(),this._headerFixer&&this._headerFixer.destroy(),this.element.unwrap(),delete this.element,delete this.wrapper,delete this._userEvents},items:function(){return"group"===this.options.type?this.element.find(".km-list").children():this.element.children().not(".km-load-more")},scroller:function(){return this._scrollerInstance||(this._scrollerInstance=this.element.closest(".km-scroll-wrapper").data("kendoMobileScroller")),this._scrollerInstance},showLoading:function(){var e=this.view();e&&e.loader&&e.loader.show()},hideLoading:function(){var e=this.view();e&&e.loader&&e.loader.hide()},insertAt:function(e,t,n){var i=this;return i._renderItems(e,function(o){if(0===t?i.element.prepend(o):t===-1?i.element.append(o):i.items().eq(t-1).after(o),n)for(var r=0;r<o.length;r++)i.trigger(H,{item:o.eq(r),data:e[r],ns:b})})},append:function(e,t){return this.insertAt(e,-1,t)},prepend:function(e,t){return this.insertAt(e,0,t)},replace:function(e){return this.options.type="flat",this._angularItems("cleanup"),g.destroy(this.element.children()),this.element.empty(),this._userEvents.cancel(),this._style(),this.insertAt(e,0)},replaceGrouped:function(t){this.options.type="group",this._angularItems("cleanup"),this.element.empty();var n=e(g.render(this.groupTemplate,t));this._enhanceItems(n.children("ul").children("li")),this.element.append(n),_.init(n),this._style(),this._angularItems("compile")},remove:function(e){var t=this.findByDataItem(e);this.angular("cleanup",function(){return{elements:t}}),g.destroy(t),t.remove()},findByDataItem:function(e){var t,n,i=[];for(t=0,n=e.length;t<n;t++)i[t]="[data-"+g.ns+"uid="+e[t].uid+"]";return this.element.find(i.join(","))},setDataItem:function(t,n){var i=this,o=function(o){var r=e(o[0]);g.destroy(t),i.angular("cleanup",function(){return{elements:[e(t)]}}),e(t).replaceWith(r),i.trigger(H,{item:r,data:n,ns:b})};return this._renderItems([n],o)[0]},updateSize:function(){this._size=this.getSize()},_renderItems:function(t,n){var i=e(g.render(this.template,t));return n(i),this.angular("compile",function(){return{elements:i,data:t.map(function(e){return{dataItem:e}})}}),_.init(i),this._enhanceItems(i),i},_dim:function(e){this._toggle(e,!1)},_highlight:function(e){this._toggle(e,!0)},_toggle:function(t,n){if(!(t.which>1)){var i=e(t.currentTarget),o=i.parent(),r=D(i,"role")||"",s=!r.match(j),a=t.isDefaultPrevented();s&&o.toggleClass(E,n&&!a)}},_templates:function(){var e=this.options.template,t=this.options.headerTemplate,n=' data-uid="#=arguments[0].uid || ""#"',i={},o={};typeof e===U&&(i.template=e,e="#=this.template(data)#"),this.template=T(g.template("<li"+n+">"+e+"</li>"),i),o.template=this.template,typeof t===U&&(o._headerTemplate=t,t="#=this._headerTemplate(data)#"),o.headerTemplate=g.template(t),this.groupTemplate=T(M,o)},_click:function(t){if(!(t.event.which>1||t.event.isDefaultPrevented())){var n,i=t.target,o=e(t.event.target),r=o.closest(g.roleSelector("button","detailbutton","backbutton")),s=g.widgetInstance(r,b),a=i.attr(g.attr("uid"));a&&(n=this.dataSource.getByUid(a)),this.trigger(N,{target:o,item:i,dataItem:n,button:s})&&t.preventDefault()}},_styleGroups:function(){var t=this.element.children();t.children("ul").addClass("km-list"),t.each(function(){var t=e(this),n=t.contents().first();t.addClass("km-group-container"),n.is("ul")||n.is("div."+A)||n.wrap(I)})},_style:function(){var e=this.options,t="group"===e.type,n=this.element,i="inset"===e.style;n.addClass("km-listview").toggleClass("km-list",!t).toggleClass("km-virtual-list",this.virtual).toggleClass("km-listinset",!t&&i).toggleClass("km-listgroup",t&&!i).toggleClass("km-listgroupinset",t&&i),n.parents(".km-listview")[0]||n.closest(".km-content").toggleClass("km-insetcontent",i),t&&this._styleGroups(),this.trigger(P)},_enhanceItems:function(t){t.each(function(){var t,n=e(this),i=!1;n.children().each(function(){t=e(this),t.is("a")?(r(t),i=!0):t.is("label")&&(s(t),i=!0)}),i||o(n)})}}),b.plugin(m)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.navbar.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(t,n){var i=n.find("["+o.attr("align")+"="+t+"]");if(i[0])return e('<div class="km-'+t+'item" />').append(i).prependTo(n)}function i(t){var n=t.siblings(),i=!!t.children("ul")[0],r=!!n[0]&&""===e.trim(t.text()),s=!(!o.mobile.application||!o.mobile.application.element.is(".km-android"));t.prevAll().toggleClass("km-absolute",i),t.toggleClass("km-show-title",r),t.toggleClass("km-fill-title",r&&!e.trim(t.html())),t.toggleClass("km-no-title",i),t.toggleClass("km-hide-title",s&&!n.children().is(":visible"))}var o=window.kendo,r=o.mobile,s=r.ui,a=s.Widget,l=a.extend({init:function(t,i){var o=this;a.fn.init.call(o,t,i),t=o.element,o.container().bind("show",e.proxy(this,"refresh")),t.addClass("km-navbar").wrapInner(e('<div class="km-view-title km-show-title" />')),o.leftElement=n("left",t),o.rightElement=n("right",t),o.centerElement=t.find(".km-view-title")},options:{name:"NavBar"},title:function(e){this.element.find(o.roleSelector("view-title")).text(e),i(this.centerElement)},refresh:function(e){var t=e.view;this.title(t.options.title)},destroy:function(){a.fn.destroy.call(this),o.destroy(this.element)}});s.plugin(l)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.scrollview.min",["kendo.fx.min","kendo.data.min","kendo.draganddrop.min"],e)}(function(){return function(e,t){function n(e){return"k-"+e+" km-"+e}var i,o,r,s,a,l,c,d,u=window.kendo,h=u.mobile,f=h.ui,p=e.proxy,m=u.effects.Transition,g=u.ui.Pane,v=u.ui.PaneDimensions,_=f.DataBoundWidget,b=u.data.DataSource,w=u.data.Buffer,y=u.data.BatchBuffer,k=Math,x=k.abs,C=k.ceil,S=k.round,T=k.max,D=k.min,A=k.floor,E="change",I="changing",M="refresh",R="current-page",F="virtual-page",z="function",P="itemChange",B="cleanup",L=3,H=-1,N=0,O=1,V=-1,U=0,W=1,j=u.Class.extend({init:function(t){var i=this,o=e("<ol class='"+n("pages")+"'/>");t.element.append(o),this._changeProxy=p(i,"_change"),this._refreshProxy=p(i,"_refresh"),t.bind(E,this._changeProxy),t.bind(M,this._refreshProxy),e.extend(i,{element:o,scrollView:t})},items:function(){return this.element.children()},_refresh:function(e){var t,i="";for(t=0;t<e.pageCount;t++)i+="<li/>";this.element.html(i),this.items().eq(e.page).addClass(n(R))},_change:function(e){this.items().removeClass(n(R)).eq(e.page).addClass(n(R))},destroy:function(){this.scrollView.unbind(E,this._changeProxy),this.scrollView.unbind(M,this._refreshProxy),this.element.remove()}});u.mobile.ui.ScrollViewPager=j,i="transitionEnd",o="dragStart",r="dragEnd",s=u.Observable.extend({init:function(t,n){var s,a,l,c,d,h,f=this;u.Observable.fn.init.call(this),this.element=t,this.container=t.parent(),s=new u.ui.Movable(f.element),a=new m({axis:"x",movable:s,onEnd:function(){f.trigger(i)}}),l=new u.UserEvents(t,{fastTap:!0,start:function(e){2*x(e.x.velocity)>=x(e.y.velocity)?l.capture():l.cancel(),f.trigger(o,e),a.cancel()},allowSelection:!0,end:function(e){f.trigger(r,e)}}),c=new v({element:f.element,container:f.container}),d=c.x,d.bind(E,function(){f.trigger(E)}),h=new g({dimensions:c,userEvents:l,movable:s,elastic:!0}),e.extend(f,{duration:n&&n.duration||1,movable:s,transition:a,userEvents:l,dimensions:c,dimension:d,pane:h}),this.bind([i,o,r,E],n)},size:function(){return{width:this.dimensions.x.getSize(),height:this.dimensions.y.getSize()}},total:function(){return this.dimension.getTotal()},offset:function(){return-this.movable.x},updateDimension:function(){this.dimension.update(!0)},refresh:function(){this.dimensions.refresh()},moveTo:function(e){this.movable.moveAxis("x",-e)},transitionTo:function(e,t,n){n?this.moveTo(-e):this.transition.moveTo({location:e,duration:this.duration,ease:t})}}),u.mobile.ui.ScrollViewElasticPane=s,a=u.Observable.extend({init:function(e,t,n){var i=this;u.Observable.fn.init.call(this),i.element=e,i.pane=t,i._getPages(),this.page=0,this.pageSize=n.pageSize||1,this.contentHeight=n.contentHeight,this.enablePager=n.enablePager,this.pagerOverlay=n.pagerOverlay},scrollTo:function(e,t){this.page=e,this.pane.transitionTo(-e*this.pane.size().width,m.easeOutExpo,t)},paneMoved:function(e,t,n,i){var o,r,s=this,a=s.pane,l=a.size().width*s.pageSize,c=S,d=t?m.easeOutBack:m.easeOutExpo;e===V?c=C:e===W&&(c=A),r=c(a.offset()/l),o=T(s.minSnap,D(-r*l,s.maxSnap)),r!=s.page&&n&&n({currentPage:s.page,nextPage:r})&&(o=-s.page*a.size().width),a.transitionTo(o,d,i)},updatePage:function(){var e=this.pane,t=S(e.offset()/e.size().width);return t!=this.page&&(this.page=t,!0)},forcePageUpdate:function(){return this.updatePage()},resizeTo:function(e){var t,n,i=this.pane,o=e.width;this.pageElements.width(o),"100%"===this.contentHeight&&(t=this.element.parent().height(),this.enablePager===!0&&(n=this.element.parent().find("ol.km-pages"),!this.pagerOverlay&&n.length&&(t-=u._outerHeight(n,!0))),this.element.css("height",t),this.pageElements.css("height",t)),i.updateDimension(),this._paged||(this.page=A(i.offset()/o)),this.scrollTo(this.page,!0),this.pageCount=C(i.total()/o),this.minSnap=-(this.pageCount-1)*o,this.maxSnap=0},_getPages:function(){this.pageElements=this.element.find(u.roleSelector("page")),this._paged=this.pageElements.length>0}}),u.mobile.ui.ScrollViewContent=a,l=u.Observable.extend({init:function(e,t,n){var i=this;u.Observable.fn.init.call(this),i.element=e,i.pane=t,i.options=n,i._templates(),i.page=n.page||0,i.pages=[],i._initPages(),i.resizeTo(i.pane.size()),i.pane.dimension.forceEnabled()},setDataSource:function(e){this.dataSource=b.create(e),this._buffer(),this._pendingPageRefresh=!1,this._pendingWidgetRefresh=!1},_viewShow:function(){var e=this;e._pendingWidgetRefresh&&(setTimeout(function(){e._resetPages()},0),e._pendingWidgetRefresh=!1)},_buffer:function(){var e=this.options.itemsPerPage;this.buffer&&this.buffer.destroy(),this.buffer=e>1?new y(this.dataSource,e):new w(this.dataSource,3*e),this._resizeProxy=p(this,"_onResize"),this._resetProxy=p(this,"_onReset"),this._endReachedProxy=p(this,"_onEndReached"),this.buffer.bind({resize:this._resizeProxy,reset:this._resetProxy,endreached:this._endReachedProxy})},_templates:function(){var e=this.options.template,t=this.options.emptyTemplate,n={},i={};typeof e===z&&(n.template=e,e="#=this.template(data)#"),this.template=p(u.template(e),n),typeof t===z&&(i.emptyTemplate=t,t="#=this.emptyTemplate(data)#"),this.emptyTemplate=p(u.template(t),i)},_initPages:function(){var e,t,n=this.pages,i=this.element;for(t=0;t<L;t++)e=new c(i),n.push(e);this.pane.updateDimension()},resizeTo:function(e){var t,n,i,o=this.pages,r=this.pane;for(t=0;t<o.length;t++)o[t].setWidth(e.width);"auto"===this.options.contentHeight?this.element.css("height",this.pages[1].element.height()):"100%"===this.options.contentHeight&&(n=this.element.parent().height(),this.options.enablePager===!0&&(i=this.element.parent().find("ol.km-pages"),!this.options.pagerOverlay&&i.length&&(n-=u._outerHeight(i,!0))),this.element.css("height",n),o[0].element.css("height",n),o[1].element.css("height",n),o[2].element.css("height",n)),r.updateDimension(),this._repositionPages(),this.width=e.width},scrollTo:function(e){var t,n=this.buffer;n.syncDataSource(),t=n.at(e),t&&(this._updatePagesContent(e),this.page=e)},paneMoved:function(e,t,n,i){var o,r=this,s=r.pane,a=s.size().width,l=s.offset(),c=Math.abs(l)>=a/3,d=t?u.effects.Transition.easeOutBack:u.effects.Transition.easeOutExpo,h=r.page+2>r.buffer.total(),f=0;e===W?0!==r.page&&(f=-1):e!==V||h?l>0&&c&&!h?f=1:l<0&&c&&0!==r.page&&(f=-1):f=1,o=r.page,f&&(o=f>0?o+1:o-1),n&&n({currentPage:r.page,nextPage:o})&&(f=0),0===f?r._cancelMove(d,i):f===-1?r._moveBackward(i):1===f&&r._moveForward(i)},updatePage:function(){var e=this.pages;return 0!==this.pane.offset()&&(this.pane.offset()>0?(e.push(this.pages.shift()),this.page++,this.setPageContent(e[2],this.page+1)):(e.unshift(this.pages.pop()),this.page--,this.setPageContent(e[0],this.page-1)),this._repositionPages(),this._resetMovable(),!0)},forcePageUpdate:function(){var e=this.pane.offset(),t=3*this.pane.size().width/4;return x(e)>t&&this.updatePage()},_resetMovable:function(){this.pane.moveTo(0)},_moveForward:function(e){this.pane.transitionTo(-this.width,u.effects.Transition.easeOutExpo,e)},_moveBackward:function(e){this.pane.transitionTo(this.width,u.effects.Transition.easeOutExpo,e)},_cancelMove:function(e,t){this.pane.transitionTo(0,e,t)},_resetPages:function(){this.page=this.options.page||0,this._updatePagesContent(this.page),this._repositionPages(),this.trigger("reset")},_onResize:function(){this.pageCount=C(this.dataSource.total()/this.options.itemsPerPage),this._pendingPageRefresh&&(this._updatePagesContent(this.page),this._pendingPageRefresh=!1),this.trigger("resize")},_onReset:function(){this.pageCount=C(this.dataSource.total()/this.options.itemsPerPage),this._resetPages()},_onEndReached:function(){this._pendingPageRefresh=!0},_repositionPages:function(){var e=this.pages;e[0].position(H),e[1].position(N),e[2].position(O)},_updatePagesContent:function(e){var t=this.pages,n=e||0;this.setPageContent(t[0],n-1),this.setPageContent(t[1],n),this.setPageContent(t[2],n+1)},setPageContent:function(t,n){var i=this.buffer,o=this.template,r=this.emptyTemplate,s=null;n>=0&&(s=i.at(n),e.isArray(s)&&!s.length&&(s=null)),this.trigger(B,{item:t.element}),t.content(null!==s?o(s):r({})),u.mobile.init(t.element),this.trigger(P,{item:t.element,data:s,ns:u.mobile.ui})}}),u.mobile.ui.VirtualScrollViewContent=l,c=u.Class.extend({init:function(t){this.element=e("<div class='"+n(F)+"'></div>"),this.width=t.width(),this.element.width(this.width),t.append(this.element)},content:function(e){this.element.html(e)},position:function(e){this.element.css("transform","translate3d("+this.width*e+"px, 0, 0)")},setWidth:function(e){this.width=e,this.element.width(e)}}),u.mobile.ui.VirtualPage=c,d=_.extend({init:function(e,t){var i,o,r,c=this;_.fn.init.call(c,e,t),t=c.options,e=c.element,u.stripWhitespace(e[0]),e.wrapInner("<div/>").addClass("k-widget "+n("scrollview")),this.options.enablePager&&(this.pager=new j(this),this.options.pagerOverlay&&e.addClass(n("scrollview-overlay"))),c.inner=e.children().first(),c.page=0,c.inner.css("height",t.contentHeight),c.pane=new s(c.inner,{duration:this.options.duration,transitionEnd:p(this,"_transitionEnd"),dragStart:p(this,"_dragStart"),dragEnd:p(this,"_dragEnd"),change:p(this,M)}),c.bind("resize",function(){c.pane.refresh()}),c.page=t.page,i=0===this.inner.children().length,o=i?new l(c.inner,c.pane,t):new a(c.inner,c.pane,t),o.page=c.page,o.bind("reset",function(){this._pendingPageRefresh=!1,c._syncWithContent(),c.trigger(M,{pageCount:o.pageCount,page:o.page})}),o.bind("resize",function(){c.trigger(M,{pageCount:o.pageCount,page:o.page})}),o.bind(P,function(e){c.trigger(P,e),c.angular("compile",function(){return{elements:e.item,data:[{dataItem:e.data}]}})}),o.bind(B,function(e){c.angular("cleanup",function(){return{elements:e.item}})}),c._content=o,c.setDataSource(t.dataSource),r=c.container(),r.nullObject?(c.viewInit(),c.viewShow()):r.bind("show",p(this,"viewShow")).bind("init",p(this,"viewInit"))},options:{name:"ScrollView",page:0,duration:400,velocityThreshold:.8,contentHeight:"auto",pageSize:1,itemsPerPage:1,bounceVelocityThreshold:1.6,enablePager:!0,pagerOverlay:!1,autoBind:!0,template:"",emptyTemplate:""},events:[I,E,M],destroy:function(){_.fn.destroy.call(this),u.destroy(this.element)},viewInit:function(){this.options.autoBind&&this._content.scrollTo(this._content.page,!0)},viewShow:function(){this.pane.refresh()},refresh:function(){var e=this._content;e.resizeTo(this.pane.size()),this.page=e.page,this.trigger(M,{pageCount:e.pageCount,page:e.page})},content:function(e){this.element.children().first().html(e),this._content._getPages(),this.pane.refresh()},value:function(e){var n=this.dataSource;return e?(this.scrollTo(n.indexOf(e),!0),t):n.at(this.page)},scrollTo:function(e,t){this._content.scrollTo(e,t),this._syncWithContent()},prev:function(){var e=this,n=e.page-1;e._content instanceof l?e._content.paneMoved(W,t,function(t){return e.trigger(I,t)}):n>-1&&e.scrollTo(n)},next:function(){var e=this,n=e.page+1;e._content instanceof l?e._content.paneMoved(V,t,function(t){return e.trigger(I,t)}):n<e._content.pageCount&&e.scrollTo(n)},setDataSource:function(e){if(this._content instanceof l){var t=!e;this.dataSource=b.create(e),this._content.setDataSource(this.dataSource),this.options.autoBind&&!t&&this.dataSource.fetch()}},items:function(){return this.element.find(".km-"+F)},_syncWithContent:function(){var e,n,i=this._content.pages,o=this._content.buffer;this.page=this._content.page,e=o?o.at(this.page):t,e instanceof Array||(e=[e]),n=i?i[1].element:t,this.trigger(E,{page:this.page,element:n,data:e})},_dragStart:function(){this._content.forcePageUpdate()&&this._syncWithContent()},_dragEnd:function(e){var t=this,n=e.x.velocity,i=this.options.velocityThreshold,o=U,r=x(n)>this.options.bounceVelocityThreshold;n>i?o=W:n<-i&&(o=V),this._content.paneMoved(o,r,function(e){return t.trigger(I,e)})},_transitionEnd:function(){this._content.updatePage()&&this._syncWithContent()}}),f.plugin(d)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.switch.min",["kendo.fx.min","kendo.userevents.min"],e)}(function(){return function(e,t){function n(e){return"k-"+e+" km-"+e}function i(e,t,n){return Math.max(t,Math.min(n,e))}var o=window.kendo,r=o.mobile.ui,s=o._outerWidth,a=r.Widget,l=o.support,c="change",d="switch-on",u="switch-off",h="margin-left",f="state-active",p="state-disabled",m="disabled",g=l.transitions.css===t?"":l.transitions.css,v=g+"transform",_=e.proxy,b='<span class="'+n("switch")+" "+n("widget")+'">        <span class="'+n("switch-wrapper")+'">            <span class="'+n("switch-background")+'"></span>        </span>         <span class="'+n("switch-container")+'">            <span class="'+n("switch-handle")+'">                 <span class="'+n("switch-label-on")+'">{0}</span>                 <span class="'+n("switch-label-off")+'">{1}</span>             </span>         </span>    </span>',w=a.extend({init:function(t,n){var i,r=this;a.fn.init.call(r,t,n),n=r.options,r.wrapper=e(o.format(b,n.onLabel,n.offLabel)),r.handle=r.wrapper.find(".km-switch-handle"),r.background=r.wrapper.find(".km-switch-background"),r.wrapper.insertBefore(r.element).prepend(r.element),r._drag(),r.origin=parseInt(r.background.css(h),10),r.constrain=0,r.snapPoint=0,t=r.element[0],t.type="checkbox",r._animateBackground=!0,i=r.options.checked,null===i&&(i=t.checked),r.check(i),r.options.enable=r.options.enable&&!r.element.attr(m),r.enable(r.options.enable),r.refresh(),o.notify(r,o.mobile.ui)},refresh:function(){var e=this,t=s(e.handle,!0);e.width=e.wrapper.width(),e.constrain=e.width-t,e.snapPoint=e.constrain/2,"number"!=typeof e.origin&&(e.origin=parseInt(e.background.css(h),10)),e.background.data("origin",e.origin),e.check(e.element[0].checked)},events:[c],options:{name:"Switch",onLabel:"on",offLabel:"off",checked:null,enable:!0},check:function(e){var i=this,o=i.element[0];return e===t?o.checked:(i._position(e?i.constrain:0),o.checked=e,i.wrapper.toggleClass(n(d),e).toggleClass(n(u),!e),t)},value:function(){return this.check.apply(this,arguments)},destroy:function(){a.fn.destroy.call(this),this.userEvents.destroy()},toggle:function(){var e=this;e.check(!e.element[0].checked)},enable:function(e){var i=this.element,o=this.wrapper;t===e&&(e=!0),this.options.enable=e,e?i.removeAttr(m):i.attr(m,m),o.toggleClass(n(p),!e)},_resize:function(){this.refresh()},_move:function(e){var t=this;e.preventDefault(),t._position(i(t.position+e.x.delta,0,t.width-s(t.handle,!0)))},_position:function(e){var t=this;t.position=e,t.handle.css(v,"translatex("+e+"px)"),t._animateBackground&&t.background.css(h,t.origin+e)},_start:function(){this.options.enable?(this.userEvents.capture(),this.handle.addClass(n(f))):this.userEvents.cancel()},_stop:function(){var e=this;e.handle.removeClass(n(f)),e._toggle(e.position>e.snapPoint)},_toggle:function(e){var t,i=this,r=i.handle,s=i.element[0],a=s.checked,l=o.mobile.application&&o.mobile.application.os.wp?100:200;i.wrapper.toggleClass(n(d),e).toggleClass(n(u),!e),i.position=t=e*i.constrain,i._animateBackground&&i.background.kendoStop(!0,!0).kendoAnimate({effects:"slideMargin",offset:t,reset:!0,reverse:!e,axis:"left",duration:l}),r.kendoStop(!0,!0).kendoAnimate({effects:"slideTo",duration:l,offset:t+"px,0",reset:!0,complete:function(){a!==e&&(s.checked=e,i.trigger(c,{checked:e}))}})},_drag:function(){var e=this;e.userEvents=new o.UserEvents(e.wrapper,{fastTap:!0,tap:function(){e.options.enable&&e._toggle(!e.element[0].checked)},start:_(e._start,e),move:_(e._move,e),end:_(e._stop,e)})}});r.plugin(w)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.tabstrip.min",["kendo.core.min"],e)}(function(){return function(e,t){function n(t){return e('<span class="km-badge">'+t+"</span>")}var i=window.kendo,o=i.mobile.ui,r=o.Widget,s="km-state-active",a="select",l=r.extend({init:function(t,n){var i=this;r.fn.init.call(i,t,n),i.container().bind("show",e.proxy(this,"refresh")),i.element.addClass("km-tabstrip").find("a").each(i._buildButton).eq(i.options.selectedIndex).addClass(s),i.element.on("down","a","_release")},events:[a],switchTo:function(t){var n,i,o=this.element.find("a"),r=0,s=o.length;if(!isNaN(t))return this._setActiveItem(o.eq(t)),!0;for(;r<s;r++)if(n=o[r],i=n.href.replace(/(\#.+)(\?.+)$/,"$1"),i.indexOf(t,i.length-t.length)!==-1)return this._setActiveItem(e(n)),!0;return!1},switchByFullUrl:function(e){var t;t=this.element.find("a[href$='"+e+"']"),this._setActiveItem(t)},clear:function(){this.currentItem().removeClass(s)},currentItem:function(){return this.element.children("."+s)},badge:function(t,i){var o,r=this.element;return isNaN(t)||(t=r.children().get(t)),t=r.find(t),o=e(t.find(".km-badge")[0]||n(i).insertAfter(t.children(".km-icon"))),i||0===i?(o.html(i),this):i===!1?(o.empty().remove(),this):o.html()},_release:function(t){if(!(t.which>1)){var n=this,i=e(t.currentTarget);i[0]!==n.currentItem()[0]&&(n.trigger(a,{item:i})?t.preventDefault():n._setActiveItem(i))}},_setActiveItem:function(e){e[0]&&(this.clear(),e.addClass(s))},_buildButton:function(){var t=e(this),o=i.attrValue(t,"icon"),r=i.attrValue(t,"badge"),s=t.find("img"),a=e('<span class="km-icon"/>');t.addClass("km-button").attr(i.attr("role"),"tab").contents().not(s).wrapAll('<span class="km-text"/>'),s[0]?s.addClass("km-image").prependTo(t):(t.prepend(a),o&&(a.addClass("km-"+o),(r||0===r)&&n(r).insertAfter(a)))},refresh:function(e){var t=e.view.id;t&&!this.switchTo(e.view.id)&&this.switchTo(t)},options:{name:"TabStrip",selectedIndex:0,enable:!0}});o.plugin(l)}(window.kendo.jQuery),window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.mobile.min",["kendo.core.min","kendo.fx.min","kendo.data.odata.min","kendo.data.xml.min","kendo.data.min","kendo.data.signalr.min","kendo.binder.min","kendo.validator.min","kendo.router.min","kendo.view.min","kendo.userevents.min","kendo.draganddrop.min","kendo.popup.min","kendo.touch.min","kendo.mobile.popover.min","kendo.mobile.loader.min","kendo.mobile.scroller.min","kendo.mobile.shim.min","kendo.mobile.view.min","kendo.mobile.modalview.min","kendo.mobile.drawer.min","kendo.mobile.splitview.min","kendo.mobile.pane.min","kendo.mobile.application.min","kendo.mobile.actionsheet.min","kendo.mobile.button.min","kendo.mobile.buttongroup.min","kendo.mobile.collapsible.min","kendo.mobile.listview.min","kendo.mobile.navbar.min","kendo.mobile.scrollview.min","kendo.mobile.switch.min","kendo.mobile.tabstrip.min","kendo.angular.min"],e)}(function(){"bundle all";return window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()}),function(e,define){define("kendo.all.min",["kendo.web.min","kendo.dataviz.min","kendo.mobile.min","kendo.drawing.min","kendo.dom.min"],e)}(function(){"bundle all";return window.kendo},"function"==typeof define&&define.amd?define:function(e,t,n){(n||t)()});
//# sourceMappingURL=kendo.all.min.js.map

(function() {
    'use strict';

    angular.module('app.corelib')
        .service('integrationsService', integrationsService);

    function integrationsService(
        $location,
        $rootScope,
        integrationsApi
    ) {
        var service = {
            redirectToProvider: redirectToProvider,
            getProviders: getProviders,
            disconnect: disconnect,
            getIntegrationsHistoryLogs: getIntegrationsHistoryLogs,
            getTenants: getTenants,
            getTenantsByProvider: getTenantsByProvider,
            getEmployees: getEmployees,
            getCompaniesByProviderAndTenant: getCompaniesByProviderAndTenant,
            providerTypes: integrationsApi.providerTypes
        };

        return service;

        function redirectToProvider(providerType) {
            integrationsApi.getOAuth2Url($location.path(), providerType)
                .then(resp => {
                    window.location.href = resp.data;
                });
        }

        function getProviders() {
            return integrationsApi.getProviders()
                .then(resp => {

                    let isConnectedToMyob = false;
                    let isConnectedToXero = false;

                    let accessTokenValidities = resp.data;

                    accessTokenValidities.forEach(access => {
                        switch (access.ProviderType.toLowerCase()) {
                            case service.providerTypes.myob.toLowerCase():
                                isConnectedToMyob = access.IsValid;
                                break;
                            case service.providerTypes.xero.toLowerCase():
                                isConnectedToXero = access.IsValid;
                                break;
                        }
                    });

                    return {
                        isConnectedToMyob: isConnectedToMyob,
                        isConnectedToXero: isConnectedToXero
                    }
                });
        }

        function disconnect(providerType) {
            return integrationsApi.disconnect(providerType)
                .then(resp => {
                    if (!resp.data) $rootScope.state.go('app.pages_auth_login-v2');
                });
        }

        function getIntegrationsHistoryLogs() {
            return integrationsApi.getIntegrationsHistoryLogs();
        }

        function getTenants() {
            return integrationsApi.getTenants();
        }

        function getTenantsByProvider(providerType) {
            return integrationsApi.getTenantsByProvider(providerType);
        }

        function getEmployees() {
            return integrationsApi.getEmployees();
        }

        function getCompaniesByProviderAndTenant(providerType, tenantId) {
            return integrationsApi.getCompaniesByProviderAndTenant(providerType, tenantId);
        }
    };
})();

angular.module('app.widgets')
    .directive('a8InfiniteScroll', [ "$window", function ($window) {
        return {
            link:function (scope, element, attrs) {
                var offset = parseInt(attrs.threshold) || 0;
                var e = element[0];

                element.bind('scroll', function () {
                    if (scope.$eval(attrs.canLoad) && e.scrollTop + e.offsetHeight >= e.scrollHeight - offset) {
                        scope.$apply(attrs.a8InfiniteScroll);
                    }
                });
            }
        };
    }]);
   /**
    * Storage service for Identity
    * rcnet 6.8.2016
    */
    (function() {
         'use strict';
    
        angular.module('app.corelib')
               .factory('identityTokenStorageService', identityTokenStorageService);
        
        /** @ngInject */
        function identityTokenStorageService($log, $window, tokenStorageKey, a8Enckey, localStorageService) { //$crypto
            var service = {
                getToken: getToken,
                setItem: setItem,
                getItem: getItem,
                remove: remove,
                getRefreshToken: getRefreshToken
            };
            
            return service;
            
            ///////  
            function setItem(key, val) {
                var k = decodeB64(a8Enckey);
                localStorageService.set(key, val);
                //var e = CryptoJS.AES.encrypt(val, k).toString();
                //localStorageService.set(key, e);
            }
            
            function getItem(key) {
                var k = decodeB64(a8Enckey);
                var v = localStorageService.get(key);
                return v;    
                //return v ? $crypto.decrypt(v, k) : null;
                //return v ? CryptoJS.AES.decrypt(v, k).toString(CryptoJS.enc.Utf8) : null;
            }
            
            function remove(key) {
                localStorageService.remove(key);
            }
           
            function getToken() {
               var userInfo = angular.fromJson(getItem(tokenStorageKey));
               return userInfo ? userInfo.AccessToken : null;
            } 

            function getRefreshToken() {
               var userInfo = angular.fromJson(getItem(tokenStorageKey));
               return userInfo ? userInfo.RefreshToken : null;
            } 
            
            function decodeB64(str) {
               var b64 = str.replace('-', '+').replace('_', '/');
               return $window.atob(b64);
            }       
        }
               
    })();
(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('identityService', identityService);

    /** @ngInject */
    function identityService(
        $q,
        $rootScope,
        authApi,
        appClientId,
        userDataModel,
        claimsService,
        exceptionService,
        identityTokenStorageService,
        tenantSettings,
        tokenStorageKey,
        $location
    ) {
        var callbacks = [];

        var service = {
            userData: new userDataModel(),
            country: tenantSettings.countryCode,
            setUser: setUser,
            loadUser: loadUser,
            fetchUserData: fetchUserData,
            isAuthenticated: isAuthenticated,
            userDataCallback: addUserDataCallback,
            checkAccess: checkAccess,
            expire: expire,
            setToken: setToken,
            setTokens: setTokens,
            getToken: getToken,
            refreshAccount: refreshAccount,
            getRefreshToken: getRefreshToken,
            setAllocationSettings: setAllocationSettings,
            getAllocationSettings: getAllocationSettings,
            tempClaims: null,
            saveUserSettingsToStorage: saveUserSettingsToStorage
        }

        activate();

        return service;

        function activate() {
            $rootScope.$on('identityService:invokeRefreshAccount', function(e, promise) {
                service.refreshAccount()
                    .then(function(resp) {
                        promise.resolve(resp);
                    })
                    .catch(function(ex) {
                        promise.reject(ex);
                    });
            });

            $rootScope.$on('identityService:expireAccount', function() {
                service.expire();
            });
        }

        function addUserDataCallback(cb) {
            callbacks.push(cb);
        }

        function setAllocationSettings(settings) {
            localStorage.setItem("AllocationSettings", JSON.stringify(settings));
        }

        function getAllocationSettings() {
            return JSON.parse(localStorage.getItem("AllocationSettings"));
        }

        function fetchUserData() {
            var deferred = $q.defer();

            authApi.getUserInfo()
                .then(function(resp) {

                    let appObj = resp.data.AppUser;
                    var obj = resp.data.User;
                    service.userData.map({
                        Email: obj.Email,
                        Settings: obj.Settings,
                        FullName: obj.FullName,
                        FirstName: appObj.Contact.FirstName,
                        PhotoUrl: obj.PhotoUrl,
                        ContactId: obj.ContactId,
                        UserId: obj.UserId,
                        Username: obj.Username
                    });

                    deferred.resolve(service.userData);

                    angular.forEach(callbacks, function(cbItem) {
                        (cbItem || angular.noop)(service.userData);
                    }, this);
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function setUser(user, jwtToken, refreshToken, rememberMe) {
            if (!user) {
                throw Error('setUser error: Invalid user parameter');
            }

            if (rememberMe != undefined && typeof rememberMe == 'boolean') {
                setRememberUserInfo(rememberMe);
            }

            service.userData.map(user);
            storeTokenToStorage(jwtToken, refreshToken);

            $rootScope.$broadcast('identityService:applyClaimsRules');
        }

        function storeTokenToStorage(jwtToken, refreshToken) {
            if (jwtToken) {
                service.userData.AccessToken = jwtToken;

                if (refreshToken && refreshToken != 'retain-existing')
                    service.userData.RefreshToken = refreshToken;

                var payload = claimsService.parseJwt(jwtToken)
                service.userData.Claims = claimsService.create(payload);
            }
            saveUserSettingsToStorage();
        }

        function saveUserSettingsToStorage() {
            var userIdent = angular.toJson(service.userData);
            identityTokenStorageService.setItem(tokenStorageKey, userIdent);
        }

        function isAuthenticated() {
            return (service.userData.ContactId && service.userData.AccessToken && service.userData.RefreshToken);
        }

        function refreshAccount() {
            var deferred = $q.defer();
            var refreshToken = getRefreshToken();

            if (!refreshToken) {
                $rootScope.$broadcast('loginService:logout');
            } else {
                authApi.postRefreshToken(appClientId, refreshToken)
                    .then(function(resp) {
                        if (resp.data.hasOwnProperty('Message') && resp.data.Message == 'invalid_grant') {
                            deferred.reject(resp.data);
                            return;
                        } else if (!resp.data.token && !resp.data.refreshToken) {
                            deferred.reject({
                                Message: 'No access token and refresh token returned.'
                            });
                            return;
                        }
                        setUser(resp.data.user, resp.data.token, resp.data.refreshToken, false);
                        deferred.resolve(resp.data);
                    })
                    .catch(function(ex) {
                        deferred.reject(ex);
                    });
            }

            return deferred.promise;
        }

        function loadUser() {
            reloadUserInfoFromStorage();
        }

        function getToken() {
            reloadUserInfoFromStorage();
            return service.userData.AccessToken;
        }

        function getRefreshToken() {
            reloadUserInfoFromStorage();
            return service.userData.RefreshToken;
        }

        function setToken(jwtToken) {
            storeTokenToStorage(jwtToken);
        }

        function setTokens(jwtToken, refreshToken) {
            storeTokenToStorage(jwtToken, refreshToken);
        }

        function reloadUserInfoFromStorage() {
            try {
                var userInfo = angular.fromJson(identityTokenStorageService.getItem(tokenStorageKey));
                service.userData.map(userInfo);
            } catch (ex) {
                exceptionService.resolve(ex);
                service.userData.reset();
            }
        }

        function expire() {
            service.userData.reset();
            identityTokenStorageService.remove(tokenStorageKey);
            $location.url('/');
        }

        function setRememberUserInfo(isRemember) {
            identityTokenStorageService.setItem('isRemember', isRemember);
        };

        function checkAccess(claimTypes) {
            var result = claimsService.checkAccess(isAuthenticated(), service.userData.Claims, claimTypes);
            return result;
        }
    }
})();

/**
 * SignalR service
 *
 * Rcnet 6.22.2016
 */
(function () {
    'use strict';

    angular.module('app.corelib')
        .service('hubService', hubService);

    /** @ngInject */
    function hubService ($mdToast, $log, $q, signalRService, notificationService, identityService, blockUI) {
        var service = {
            register: register,
            bulkImport: bulkImport,
            showToast: showToast
        };

        return service;

        ///////
        /**
         * Registration of client hub methods which is callable by the server.
         */
        function register () {

            signalRService.onConnected = function () {
                // For Unread Notifications
                signalRService.messageHub.on('pushUnreadNotifications', function (data) {
                    $log.log('Message Hub: New notifications received.');
                    notificationService.showNotifications(data);
                });
            }
        }

        /**
         * Bulk import OutBound calls
         */
        function bulkImport (importObj) {
            var deferred = $q.defer();
            var promise = signalRService.messageHub.invoke('bulkImportIndividualItems', importObj.m_Item1, importObj.m_Item2)
                .done(function (resp) {
                    if (resp === true) {
                        showToast('The bulk import process has successfully completed.');
                    } else {
                        showToast('The bulk import process failed.');
                    }
                    deferred.resolve(resp);
                }).fail(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }



        // function bulkImport(importObj) {
        //   var promise = signalRService.messageHub.invoke('bulkImportIndividualItems', importObj.m_Item1, importObj.m_Item2)
        //     .done(function (resp) {
        //       if (resp === true) {
        //         showToast('Bulk import successfully completed.');
        //       } else {
        //         showToast('Bulk import failed to process.');
        //       }
        //
        //       return resp;
        //     }).fail(function (error) {
        //       $log.debug('Invocation of receivedMessage failed. Error: ' + error);
        //       return error;
        //     });
        //
        //   return promise;
        // }

        function showToast (msg) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(msg)
                    .position('bottom right')
                    .hideDelay(1000)
            );
        }

    };
})();

'use strict';
var Z63 = (function (parent, $) {

    var MediaQueryListener = function() {
        this.afterElement = window.getComputedStyle ? window.getComputedStyle(document.body, ':after') : false;
        this.currentBreakpoint = '';
        this.lastBreakpoint = '';
        this.init();
    };

    MediaQueryListener.prototype = {

        init: function () {
            var self = this;
            
            if(!self.afterElement) {
                return;
            }

            self._resizeListener();

        },
        _resizeListener: function () {
            var self = this;

            $(window).on('resize orientationchange load', function() {
                self.currentBreakpoint = self.afterElement.getPropertyValue('content');
                
                if (self.currentBreakpoint !== self.lastBreakpoint) {
                    $(window).trigger('breakpoint-change', self.currentBreakpoint);
                    self.lastBreakpoint = self.currentBreakpoint;
                }
                
            });
        }

    };

    parent.mediaqueryListener = parent.mediaqueryListener || new MediaQueryListener();

    return parent;

}(Z63 || {}, jQuery));

angular.module("app.corelib").directive("fastRepeat",["$compile","$parse","$animate",function(a,b,c){"use strict";function d(a,b){return a.slice&&"$$"==a.slice(0,2)?void 0:b}function e(){return window.performance&&window.performance.now?window.performance.now():(new Date).getTime()}var f=angular.element,g=0,h=!1,i=/^(\d+\.\d+)\./.exec(angular.version.full)[1]>1.3;return{restrict:"A",transclude:"element",priority:1e3,compile:function(){return function(a,j,k,l,m){function n(){a.$$postDigest(function(){y.width(z.width()),w.$digest(),A(x,w,!0)})}function o(a,b){var c=w.$new(!1);c[s]=a,c.fastRepeatStatic=!1,c.fastRepeatDynamic=!0;var d=m(c,function(a){y.append(a)});return c.$$postDigest(function(){b(d)}),c.$digest(),c}var p,q=k.fastRepeat.split(" in "),r=q[1],s=q[0],t=b(r),u=b(k.fastRepeatDisableOpts)(a),v={},w=a.$new();w[s]=t(w)[0]||{},w.fastRepeatStatic=!0,w.fastRepeatDynamic=!1;var x=m(w,function(a){i?c.enabled(a,!1):c.enabled(!1,a)}),y=f("<div/>");f("body").append(y),w.$on("$destroy",function(){y.remove(),x.remove()}),y.css({position:"absolute",top:"-100%"});var z=j.parents().filter(function(){return"inline"!==f(this).css("display")}).first();y.width(z.width()),y.css({visibility:"hidden"}),y.append(x);var A=function(a,b,c){function d(c){return b[s]=c,b.$digest(),a.attr("fast-repeat-id",c.$$fastRepeatId),a.clone()}var e=t(b),h={};angular.forEach(e,function(a){a.$$fastRepeatId||(a.$$fastRepeatId=a.id?a.id:a._id?a._id:++g),h[a.$$fastRepeatId]=a}),angular.forEach(v,function(a,b){h[b]||a.el.detach()});var i=j;angular.forEach(e,function(a){var b=a.$$fastRepeatId,e=v[b];if(e){if(!e.compiled&&(c||!angular.equals(e.copy,a))||e.compiled&&e.item!==a){var g=d(a);e.el.replaceWith(g),e.el=g,e.copy=angular.copy(a),e.compiled=!1,e.item=a}}else u?(e={copy:angular.copy(a),item:a,el:f("<div/>"),compiled:!0},o(a,function(a){e.el.replaceWith(a),e.el=a})):e={copy:angular.copy(a),item:a,el:d(a)},v[b]=e;i.after(e.el.last()),i=e.el.last()})},B=!1;a.$watch(function(a){return JSON.stringify(t(a),d)},function(b){y.width(z.width()),B||(B=!0,h&&(p=e()),a.$$postDigest(function(){y.width(z.width()),w.$digest(),A(x,w),h&&(p=e()-p,console.log("Total time: ",p,"ms"),console.log("time per row: ",p/b.length)),B=!1}))},!1),k.fastRepeatWatch&&a.$watch(k.fastRepeatWatch,n,!0),a.$on("fastRepeatForceRedraw",n);var C=function(a){var b=f(this);if(!b.parents().filter("[fast-repeat-id]").length){a.stopPropagation();var c=b.attr("fast-repeat-id"),d=v[c].item,e=b.find("*").index(a.target),g=o(d,function(a){b.replaceWith(a),v[c]={compiled:!0,el:a,item:d},setTimeout(function(){e>=0?a.find("*").eq(e).trigger("click"):a.trigger("click")},0)});g.$digest()}};j.parent().on("click","[fast-repeat-id]",C);var D=function(){y.width(z.width())},E=f(window);E.on("resize",D),w.$on("$destroy",function(){E.off("resize",D),j.parent().off("click","[fast-repeat-id]",C)})}}}}]);

(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('exceptionService', exceptionService);

    function exceptionService(
        $mdDialog,
        $injector,
        $rootScope
    ) {
        var service = {
            resolve: resolveException,
            showError: showError,
            getExceptionMessage: getExceptionMessage
        };

        const DEFAULT_TITLE = 'An error occured';
        const GENERIC_ERROR_MESSAGE = 'Sorry, we encountered an error and were unable to complete your request.\n\nPlease try again later.\n\nIf the problem persists please contact Alloc8 Support';
        const GENERIC_ERROR_MESSAGE_WITH_ERRORID = `${GENERIC_ERROR_MESSAGE} and quote the following Error Id in your support request.\n\nError Id :`;

        return service;

        function getExceptionMessage(exception) {
            if (exception.hasOwnProperty('message') || exception.hasOwnProperty('Message')) {
                return exception.message || exception.Message;
            }

            if (typeof exception === 'string') {
                return exception;
            }
        }

        function resolveException(exception, options) {
            options = options || {};
            var defaults = {
                intercept400: null,
                intercept500: null,
                intercept404: null,
                interceptUnhandled: null,
                interceptNativeError: null
            };

            var optionBag = angular.extend({}, defaults, options),
                exceptionObj = {},
                isNativeException = false;

            // Process Exception status
            if (exception.hasOwnProperty('statusCode') || exception.hasOwnProperty('status')) {
                var status = 0;

                if (exception.status) {
                    status = exception.status;
                } else if (typeof exception.statusCode == 'string') {
                    status = (typeof exception.statusCode == 'string') ? exception.statusCode : status;
                }

                switch (status) {
                    case 400: // Bad Request
                        handleBadRequest(exception, optionBag, status);
                        break;

                    case 404: // Resource Not Found
                        handleResourceNotFound(exception, optionBag, status);
                        break;

                    case 500: // Internal Server error
                        handleInternalServer(exception, optionBag, status);
                        break;

                    case 401:
                        break;

                    case 403:
                        break;

                    default:
                        unhandledException(exception, optionBag, status);
                        break;
                }

                return;
            }

            var exceptionMessage = getExceptionMessage(exception);
            isNativeException = !!exceptionMessage;

            if (isNativeException) {
                if (optionBag.interceptNativeError != null || typeof optionBag.interceptNativeError === 'function') {
                    exceptionObj.errorInfo = {
                        message: exceptionMessage
                    };
                    optionBag.interceptNativeError(exceptionObj);
                } else {
                    var msg = getGenericErrorMessage(null);
                    showError(msg);
                }
            }
        }

        /**
         * Status code 500
         */
        function handleInternalServer(exception, optionBag, status) {
            if (exception == null) {
                return;
            }

            if (exception.hasOwnProperty('data') && exception.data.Data) {
                exception['errorInfo'] = createErrorInfo(exception.data.Data.ErrorNumber, (exception.data.Data.hasOwnProperty('ErrorId') ? exception.data.Data.ErrorId : null), exception.data.Data.ErrorMessage);

            } else if (exception.hasOwnProperty('data')) {
                exception['errorInfo'] = exception.data;
                exception.errorInfo['ErrorNumber'] = exception.data.ErrorNumber ? exception.data.ErrorNumber : exception.status;
                exception.errorInfo['ErrorMessage'] = exception.data.ErrorMessage ? exception.data.ErrorMessage : exception.data.ExceptionMessage;
                exception.errorInfo['ErrorId'] = exception.hasOwnProperty('ErrorId') ? exception.data.ErrorId : null;
            }

            if (optionBag.intercept500 != null || typeof optionBag.intercept500 == 'function') {
                if (exception.errorInfo)
                    var ret = optionBag.intercept500({
                        code: parseInt(exception.errorInfo.ErrorNumber),
                        message: exception.errorInfo.ErrorMessage,
                        error: exception,
                        status: status
                    });

                if (_.isObject(ret) && ret.hasOwnProperty('notifyVia') || ret == null && exception.errorInfo.hasOwnProperty('ErrorNumber')) {
                    notify(exception.errorInfo);
                }

            } else {

                if (exception.errorInfo.hasOwnProperty('ErrorNumber')) {
                    notify(exception.errorInfo);
                } else {
                    var stateProvider = $injector.get('$state');
                    stateProvider.go('app.pages_errors_error-500');
                }
            }
        }

        /**
         * Unhandled exception will be interpreted as Unknown exception
         */
        function unhandledException(exception, optionBag, status) {
            if (exception == null) {
                return;
            }

            if (exception.hasOwnProperty('data') && exception.data) {
                exception['errorInfo'] = exception.data;

            } else if (exception.hasOwnProperty('statusText')) {
                exception['errorInfo'] = exception.statusText;
            }

            if (optionBag.interceptUnhandled != null || typeof optionBag.interceptUnhandled == 'function') {
                optionBag.interceptUnhandled(exception, status);

            } else {
                var stateProvider = $injector.get('$state');
                stateProvider.go('app.pages_errors_error-unhandled', {
                    code: status.toString()
                });
            }
        }

        /**
         * Status code 400
         */
        function handleBadRequest(exception, optionBag, status) {
            if (exception == null) {
                return;
            }

            exception['errorInfo'] = {};

            // Extract and Add error info from badrequest
            if (exception.hasOwnProperty('responseText')) {
                exception['errorInfo'] = createModelStateError(JSON.parse(exception.responseText));

            } else if (exception.hasOwnProperty('data') && exception.data.hasOwnProperty('Message') && !exception.data.hasOwnProperty('ModelState')) {
                exception['errorInfo'] = createModelStateError(exception.data.MessageDetail ? exception.data.MessageDetail : exception.data.Message);

            } else if (exception.hasOwnProperty('data') && exception.data.hasOwnProperty('ModelState')) {
                exception['errorInfo'] = createModelStateError(null, exception.data.ModelState);

            } else {
                exception['errorInfo'] = createModelStateError(exception.data);
            }

            if (optionBag.intercept400 != null || typeof optionBag.intercept400 == 'function') {
                // Caller can examine errorInfo property to see the error msg === 'invalid_grant'
                optionBag.intercept400(exception, status);

            } else if (exception.errorInfo.ErrorMessage == 'invalid_grant') {
                msg = 'Invalid grant access. You need to re-login.';
                showError(msg, function() {
                    $rootScope.state.go('app.pages_auth_login-v2');
                });
                return;

            } else {

                var fmt = [];
                var msg = null;

                if (exception.errorInfo.ModelState != null && angular.isObject(exception.errorInfo.ModelState)) {
                    fmt.push('<ul>');
                    if (exception.errorInfo.ModelState[""]) {
                        for (var errorItm in exception.errorInfo.ModelState[""]) {
                            fmt.push('<li>' + exception.errorInfo.ModelState[""][errorItm] + '</li>');
                        }
                    } else {
                        for (var prop in exception.errorInfo.ModelState) {
                            fmt.push('<li><strong style="color: red;">' + prop + '</strong></li>');
                            fmt.push('<ul style="margin-bottom:5px; padding-left: 8px;">')
                            for (var errorItm in exception.errorInfo.ModelState[prop]) {
                                fmt.push('<li>' + exception.errorInfo.ModelState[prop][errorItm] + '</li>');
                            }
                            fmt.push('</ul>');
                        }
                    }
                    fmt.push('</ul>');
                    msg = fmt.join('\n');

                    showError(msg);
                } else {
                    notify(exception.errorInfo);
                }
            }
        };

        /**
         * Status code 404
         */
        function handleResourceNotFound(exception, optionBag, status) {
            if (exception.data && exception.data.Data) {
                exception['errorInfo'] = createErrorInfo(exception.data.Data.ErrorNumber, (exception.data.Data.hasOwnProperty('ErrorId') ? exception.data.Data.ErrorId : null), exception.data.Data.ErrorMessage);

            } else if (exception.data) {
                exception['errorInfo'] = createErrorInfo(status, (exception.data.hasOwnProperty('ErrorId') ? exception.data.ErrorId : null), exception.data);

            } else {
                exception['errorInfo'] = createErrorInfo(status, null, 'Resource or data not found. Please try again.');
            }

            if (optionBag.intercept404 != null || typeof optionBag.intercept404 == 'function') {
                if (exception.errorInfo)
                    var ret = optionBag.intercept404({
                        code: parseInt(exception.errorInfo.ErrorNumber),
                        message: exception.errorInfo.ErrorMessage,
                        error: exception,
                        status: status
                    });

                if (_.isObject(ret) && ret.hasOwnProperty('notifyVia') || ret == null && exception.errorInfo) {
                    notify(exception['errorInfo']);
                }

            } else {
                // Add http error
                notify(exception['errorInfo']);
            }
        };

        function showError(msg, func, title) {
            var dialogTitle = title ? title : DEFAULT_TITLE;

            msg = msg.replace(/(\n)/g, '<br>');

            var confirm = $mdDialog.alert()
                .title(dialogTitle)
                .htmlContent(msg)
                .ariaLabel(dialogTitle)
                .ok('Close')
                .multiple(true);

            if (!func) {
                $mdDialog.show(confirm);
                return;
            }

            $mdDialog.show(confirm)
                .then(func);
        }

        function notify(info) {
            let msg = getGenericErrorMessage(info.hasOwnProperty('ErrorId') ? info.ErrorId : null);

            showError(msg);
        }

        function getGenericErrorMessage(errorId) {
            if (errorId) {
                return `${GENERIC_ERROR_MESSAGE_WITH_ERRORID} ${errorId}`;
            }

            return `${GENERIC_ERROR_MESSAGE}.`;
        }

        function createErrorInfo(code, errorId, message) {
            return {
                ErrorNumber: code,
                ErrorId: errorId,
                ErrorMessage: message
            }
        }

        function createModelStateError(message, modelState) {
            return {
                ErrorNumber: 400,
                ErrorMessage: message,
                ModelState: modelState
            }
        }
    }
})();
/**
 * angular-drag-and-drop-lists v1.4.0
 *
 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
 * Copyright (c) 2014-2016 Google Inc.
 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
 *
 * License: MIT
 */
angular.module('dndLists', [])

  /**
   * Use the dnd-draggable attribute to make your element draggable
   *
   * Attributes:
   * - dnd-draggable      Required attribute. The value has to be an object that represents the data
   *                      of the element. In case of a drag and drop operation the object will be
   *                      serialized and unserialized on the receiving end.
   * - dnd-selected       Callback that is invoked when the element was clicked but not dragged.
   *                      The original click event will be provided in the local event variable.
   * - dnd-effect-allowed Use this attribute to limit the operations that can be performed. Options:
   *                      - "move": The drag operation will move the element. This is the default.
   *                      - "copy": The drag operation will copy the element. Shows a copy cursor.
   *                      - "copyMove": The user can choose between copy and move by pressing the
   *                        ctrl or shift key. *Not supported in IE:* In Internet Explorer this
   *                        option will be the same as "copy". *Not fully supported in Chrome on
   *                        Windows:* In the Windows version of Chrome the cursor will always be the
   *                        move cursor. However, when the user drops an element and has the ctrl
   *                        key pressed, we will perform a copy anyways.
   *                      - HTML5 also specifies the "link" option, but this library does not
   *                        actively support it yet, so use it at your own risk.
   * - dnd-moved          Callback that is invoked when the element was moved. Usually you will
   *                      remove your element from the original list in this callback, since the
   *                      directive is not doing that for you automatically. The original dragend
   *                      event will be provided in the local event variable.
   * - dnd-canceled       Callback that is invoked if the element was dragged, but the operation was
   *                      canceled and the element was not dropped. The original dragend event will
   *                      be provided in the local event variable.
   * - dnd-copied         Same as dnd-moved, just that it is called when the element was copied
   *                      instead of moved. The original dragend event will be provided in the local
   *                      event variable.
   * - dnd-dragstart      Callback that is invoked when the element was dragged. The original
   *                      dragstart event will be provided in the local event variable.
   * - dnd-dragend        Callback that is invoked when the drag operation ended. Available local
   *                      variables are event and dropEffect.
   * - dnd-type           Use this attribute if you have different kinds of items in your
   *                      application and you want to limit which items can be dropped into which
   *                      lists. Combine with dnd-allowed-types on the dnd-list(s). This attribute
   *                      should evaluate to a string, although this restriction is not enforced.
   * - dnd-disable-if     You can use this attribute to dynamically disable the draggability of the
   *                      element. This is useful if you have certain list items that you don't want
   *                      to be draggable, or if you want to disable drag & drop completely without
   *                      having two different code branches (e.g. only allow for admins).
   *                      **Note**: If your element is not draggable, the user is probably able to
   *                      select text or images inside of it. Since a selection is always draggable,
   *                      this breaks your UI. You most likely want to disable user selection via
   *                      CSS (see user-select).
   *
   * CSS classes:
   * - dndDragging        This class will be added to the element while the element is being
   *                      dragged. It will affect both the element you see while dragging and the
   *                      source element that stays at it's position. Do not try to hide the source
   *                      element with this class, because that will abort the drag operation.
   * - dndDraggingSource  This class will be added to the element after the drag operation was
   *                      started, meaning it only affects the original element that is still at
   *                      it's source position, and not the "element" that the user is dragging with
   *                      his mouse pointer.
   */
  .directive('dndDraggable', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround',
    function($parse,   $timeout,   dndDropEffectWorkaround,   dndDragTypeWorkaround) {
      return function(scope, element, attr) {
        // Set the HTML5 draggable attribute on the element
        element.attr("draggable", "true");

        // If the dnd-disable-if attribute is set, we have to watch that
        if (attr.dndDisableIf) {
          scope.$watch(attr.dndDisableIf, function(disabled) {
            element.attr("draggable", !disabled);
          });
        }

        /**
         * When the drag operation is started we have to prepare the dataTransfer object,
         * which is the primary way we communicate with the target element
         */
        element.on('dragstart', function(event) {
          event = event.originalEvent || event;

          // Check whether the element is draggable, since dragstart might be triggered on a child.
          if (element.attr('draggable') == 'false') return true;

          // Serialize the data associated with this element. IE only supports the Text drag type
          event.dataTransfer.setData("Text", angular.toJson(scope.$eval(attr.dndDraggable)));

          // Only allow actions specified in dnd-effect-allowed attribute
          event.dataTransfer.effectAllowed = attr.dndEffectAllowed || "move";

          // Add CSS classes. See documentation above
          element.addClass("dndDragging");
          $timeout(function() { element.addClass("dndDraggingSource"); }, 0);

          // Workarounds for stupid browsers, see description below
          dndDropEffectWorkaround.dropEffect = "none";
          dndDragTypeWorkaround.isDragging = true;

          // Save type of item in global state. Usually, this would go into the dataTransfer
          // typename, but we have to use "Text" there to support IE
          dndDragTypeWorkaround.dragType = attr.dndType ? scope.$eval(attr.dndType) : undefined;

          // Try setting a proper drag image if triggered on a dnd-handle (won't work in IE).
          if (event._dndHandle && event.dataTransfer.setDragImage) {
            event.dataTransfer.setDragImage(element[0], 0, 0);
          }

          // Invoke callback
          $parse(attr.dndDragstart)(scope, {event: event});

          event.stopPropagation();
        });

        /**
         * The dragend event is triggered when the element was dropped or when the drag
         * operation was aborted (e.g. hit escape button). Depending on the executed action
         * we will invoke the callbacks specified with the dnd-moved or dnd-copied attribute.
         */
        element.on('dragend', function(event) {
          event = event.originalEvent || event;

          // Invoke callbacks. Usually we would use event.dataTransfer.dropEffect to determine
          // the used effect, but Chrome has not implemented that field correctly. On Windows
          // it always sets it to 'none', while Chrome on Linux sometimes sets it to something
          // else when it's supposed to send 'none' (drag operation aborted).
          var dropEffect = dndDropEffectWorkaround.dropEffect;
          scope.$apply(function() {
            switch (dropEffect) {
              case "move":
                $parse(attr.dndMoved)(scope, {event: event});
                break;
              case "copy":
                $parse(attr.dndCopied)(scope, {event: event});
                break;
              case "none":
                $parse(attr.dndCanceled)(scope, {event: event});
                break;
            }
            $parse(attr.dndDragend)(scope, {event: event, dropEffect: dropEffect});
          });

          // Clean up
          element.removeClass("dndDragging");
          $timeout(function() { element.removeClass("dndDraggingSource"); }, 0);
          dndDragTypeWorkaround.isDragging = false;
          event.stopPropagation();
        });

        /**
         * When the element is clicked we invoke the callback function
         * specified with the dnd-selected attribute.
         */
        element.on('click', function(event) {
          if (!attr.dndSelected) return;

          event = event.originalEvent || event;
          scope.$apply(function() {
            $parse(attr.dndSelected)(scope, {event: event});
          });

          // Prevent triggering dndSelected in parent elements.
          event.stopPropagation();
        });

        /**
         * Workaround to make element draggable in IE9
         */
        element.on('selectstart', function() {
          if (this.dragDrop) this.dragDrop();
        });
      };
    }])

  /**
   * Use the dnd-list attribute to make your list element a dropzone. Usually you will add a single
   * li element as child with the ng-repeat directive. If you don't do that, we will not be able to
   * position the dropped element correctly. If you want your list to be sortable, also add the
   * dnd-draggable directive to your li element(s). Both the dnd-list and it's direct children must
   * have position: relative CSS style, otherwise the positioning algorithm will not be able to
   * determine the correct placeholder position in all browsers.
   *
   * Attributes:
   * - dnd-list             Required attribute. The value has to be the array in which the data of
   *                        the dropped element should be inserted.
   * - dnd-allowed-types    Optional array of allowed item types. When used, only items that had a
   *                        matching dnd-type attribute will be dropable.
   * - dnd-disable-if       Optional boolean expresssion. When it evaluates to true, no dropping
   *                        into the list is possible. Note that this also disables rearranging
   *                        items inside the list.
   * - dnd-horizontal-list  Optional boolean expresssion. When it evaluates to true, the positioning
   *                        algorithm will use the left and right halfs of the list items instead of
   *                        the upper and lower halfs.
   * - dnd-dragover         Optional expression that is invoked when an element is dragged over the
   *                        list. If the expression is set, but does not return true, the element is
   *                        not allowed to be dropped. The following variables will be available:
   *                        - event: The original dragover event sent by the browser.
   *                        - index: The position in the list at which the element would be dropped.
   *                        - type: The dnd-type set on the dnd-draggable, or undefined if unset.
   *                        - external: Whether the element was dragged from an external source.
   * - dnd-drop             Optional expression that is invoked when an element is dropped on the
   *                        list. The following variables will be available:
   *                        - event: The original drop event sent by the browser.
   *                        - index: The position in the list at which the element would be dropped.
   *                        - item: The transferred object.
   *                        - type: The dnd-type set on the dnd-draggable, or undefined if unset.
   *                        - external: Whether the element was dragged from an external source.
   *                        The return value determines the further handling of the drop:
   *                        - false: The drop will be canceled and the element won't be inserted.
   *                        - true: Signalises that the drop is allowed, but the dnd-drop
   *                          callback already took care of inserting the element.
   *                        - otherwise: All other return values will be treated as the object to
   *                          insert into the array. In most cases you want to simply return the
   *                          item parameter, but there are no restrictions on what you can return.
   * - dnd-inserted         Optional expression that is invoked after a drop if the element was
   *                        actually inserted into the list. The same local variables as for
   *                        dnd-drop will be available. Note that for reorderings inside the same
   *                        list the old element will still be in the list due to the fact that
   *                        dnd-moved was not called yet.
   * - dnd-external-sources Optional boolean expression. When it evaluates to true, the list accepts
   *                        drops from sources outside of the current browser tab. This allows to
   *                        drag and drop accross different browser tabs. Note that this will allow
   *                        to drop arbitrary text into the list, thus it is highly recommended to
   *                        implement the dnd-drop callback to check the incoming element for
   *                        sanity. Furthermore, the dnd-type of external sources can not be
   *                        determined, therefore do not rely on restrictions of dnd-allowed-type.
   *
   * CSS classes:
   * - dndPlaceholder       When an element is dragged over the list, a new placeholder child
   *                        element will be added. This element is of type li and has the class
   *                        dndPlaceholder set. Alternatively, you can define your own placeholder
   *                        by creating a child element with dndPlaceholder class.
   * - dndDragover          Will be added to the list while an element is dragged over the list.
   */
  .directive('dndList', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround',
    function($parse,   $timeout,   dndDropEffectWorkaround,   dndDragTypeWorkaround) {
      return function(scope, element, attr) {
        // While an element is dragged over the list, this placeholder element is inserted
        // at the location where the element would be inserted after dropping
        var placeholder = getPlaceholderElement();
        var placeholderNode = placeholder[0];
        var listNode = element[0];
        placeholder.remove();

        var horizontal = attr.dndHorizontalList && scope.$eval(attr.dndHorizontalList);
        var externalSources = attr.dndExternalSources && scope.$eval(attr.dndExternalSources);

        /**
         * The dragenter event is fired when a dragged element or text selection enters a valid drop
         * target. According to the spec, we either need to have a dropzone attribute or listen on
         * dragenter events and call preventDefault(). It should be noted though that no browser seems
         * to enforce this behaviour.
         */
        element.on('dragenter', function (event) {
          event = event.originalEvent || event;
          if (!isDropAllowed(event)) return true;
          event.preventDefault();
        });

        /**
         * The dragover event is triggered "every few hundred milliseconds" while an element
         * is being dragged over our list, or over an child element.
         */
        element.on('dragover', function(event) {
          event = event.originalEvent || event;

          if (!isDropAllowed(event)) return true;

          // First of all, make sure that the placeholder is shown
          // This is especially important if the list is empty
          if (placeholderNode.parentNode != listNode) {
            element.append(placeholder);
          }

          if (event.target !== listNode) {
            // Try to find the node direct directly below the list node.
            var listItemNode = event.target;
            while (listItemNode.parentNode !== listNode && listItemNode.parentNode) {
              listItemNode = listItemNode.parentNode;
            }

            if (listItemNode.parentNode === listNode && listItemNode !== placeholderNode) {
              // If the mouse pointer is in the upper half of the child element,
              // we place it before the child element, otherwise below it.
              if (isMouseInFirstHalf(event, listItemNode)) {
                listNode.insertBefore(placeholderNode, listItemNode);
              } else {
                listNode.insertBefore(placeholderNode, listItemNode.nextSibling);
              }
            }
          } else {
            // This branch is reached when we are dragging directly over the list element.
            // Usually we wouldn't need to do anything here, but the IE does not fire it's
            // events for the child element, only for the list directly. Therefore, we repeat
            // the positioning algorithm for IE here.
            if (isMouseInFirstHalf(event, placeholderNode, true)) {
              // Check if we should move the placeholder element one spot towards the top.
              // Note that display none elements will have offsetTop and offsetHeight set to
              // zero, therefore we need a special check for them.
              while (placeholderNode.previousElementSibling
              && (isMouseInFirstHalf(event, placeholderNode.previousElementSibling, true)
              || placeholderNode.previousElementSibling.offsetHeight === 0)) {
                listNode.insertBefore(placeholderNode, placeholderNode.previousElementSibling);
              }
            } else {
              // Check if we should move the placeholder element one spot towards the bottom
              while (placeholderNode.nextElementSibling &&
              !isMouseInFirstHalf(event, placeholderNode.nextElementSibling, true)) {
                listNode.insertBefore(placeholderNode,
                  placeholderNode.nextElementSibling.nextElementSibling);
              }
            }
          }

          // At this point we invoke the callback, which still can disallow the drop.
          // We can't do this earlier because we want to pass the index of the placeholder.
          if (attr.dndDragover && !invokeCallback(attr.dndDragover, event, getPlaceholderIndex())) {
            return stopDragover();
          }

          element.addClass("dndDragover");
          event.preventDefault();
          event.stopPropagation();
          return false;
        });

        /**
         * When the element is dropped, we use the position of the placeholder element as the
         * position where we insert the transferred data. This assumes that the list has exactly
         * one child element per array element.
         */
        element.on('drop', function(event) {
          event = event.originalEvent || event;

          if (!isDropAllowed(event)) return true;

          // The default behavior in Firefox is to interpret the dropped element as URL and
          // forward to it. We want to prevent that even if our drop is aborted.
          event.preventDefault();

          // Unserialize the data that was serialized in dragstart. According to the HTML5 specs,
          // the "Text" drag type will be converted to text/plain, but IE does not do that.
          var data = event.dataTransfer.getData("Text") || event.dataTransfer.getData("text/plain");
          var transferredObject;
          try {
            transferredObject = JSON.parse(data);
          } catch(e) {
            return stopDragover();
          }

          // Invoke the callback, which can transform the transferredObject and even abort the drop.
          var index = getPlaceholderIndex();
          if (attr.dndDrop) {
            transferredObject = invokeCallback(attr.dndDrop, event, index, transferredObject);
            if (!transferredObject) {
              return stopDragover();
            }
          }

          // Insert the object into the array, unless dnd-drop took care of that (returned true).
          if (transferredObject !== true) {
            scope.$apply(function() {
              scope.$eval(attr.dndList).splice(index, 0, transferredObject);
            });
          }
          invokeCallback(attr.dndInserted, event, index, transferredObject);

          // In Chrome on Windows the dropEffect will always be none...
          // We have to determine the actual effect manually from the allowed effects
          if (event.dataTransfer.dropEffect === "none") {
            if (event.dataTransfer.effectAllowed === "copy" ||
              event.dataTransfer.effectAllowed === "move") {
              dndDropEffectWorkaround.dropEffect = event.dataTransfer.effectAllowed;
            } else {
              dndDropEffectWorkaround.dropEffect = event.ctrlKey ? "copy" : "move";
            }
          } else {
            dndDropEffectWorkaround.dropEffect = event.dataTransfer.dropEffect;
          }

          // Clean up
          stopDragover();
          event.stopPropagation();
          return false;
        });

        /**
         * We have to remove the placeholder when the element is no longer dragged over our list. The
         * problem is that the dragleave event is not only fired when the element leaves our list,
         * but also when it leaves a child element -- so practically it's fired all the time. As a
         * workaround we wait a few milliseconds and then check if the dndDragover class was added
         * again. If it is there, dragover must have been called in the meantime, i.e. the element
         * is still dragging over the list. If you know a better way of doing this, please tell me!
         */
        element.on('dragleave', function(event) {
          event = event.originalEvent || event;

          element.removeClass("dndDragover");
          $timeout(function() {
            if (!element.hasClass("dndDragover")) {
              placeholder.remove();
            }
          }, 100);
        });

        /**
         * Checks whether the mouse pointer is in the first half of the given target element.
         *
         * In Chrome we can just use offsetY, but in Firefox we have to use layerY, which only
         * works if the child element has position relative. In IE the events are only triggered
         * on the listNode instead of the listNodeItem, therefore the mouse positions are
         * relative to the parent element of targetNode.
         */
        function isMouseInFirstHalf(event, targetNode, relativeToParent) {
          var mousePointer = horizontal ? (event.offsetX || event.layerX)
            : (event.offsetY || event.layerY);
          var targetSize = horizontal ? targetNode.offsetWidth : targetNode.offsetHeight;
          var targetPosition = horizontal ? targetNode.offsetLeft : targetNode.offsetTop;
          targetPosition = relativeToParent ? targetPosition : 0;
          return mousePointer < targetPosition + targetSize / 2;
        }

        /**
         * Tries to find a child element that has the dndPlaceholder class set. If none was found, a
         * new li element is created.
         */
        function getPlaceholderElement() {
          var placeholder;
          angular.forEach(element.children(), function(childNode) {
            var child = angular.element(childNode);
            if (child.hasClass('dndPlaceholder')) {
              placeholder = child;
            }
          });
          return placeholder || angular.element("<li class='dndPlaceholder'></li>");
        }

        /**
         * We use the position of the placeholder node to determine at which position of the array the
         * object needs to be inserted
         */
        function getPlaceholderIndex() {
          return Array.prototype.indexOf.call(listNode.children, placeholderNode);
        }

        /**
         * Checks various conditions that must be fulfilled for a drop to be allowed
         */
        function isDropAllowed(event) {
          // Disallow drop from external source unless it's allowed explicitly.
          if (!dndDragTypeWorkaround.isDragging && !externalSources) return false;

          // Check mimetype. Usually we would use a custom drag type instead of Text, but IE doesn't
          // support that.
          if (!hasTextMimetype(event.dataTransfer.types)) return false;

          // Now check the dnd-allowed-types against the type of the incoming element. For drops from
          // external sources we don't know the type, so it will need to be checked via dnd-drop.
          if (attr.dndAllowedTypes && dndDragTypeWorkaround.isDragging) {
            var allowed = scope.$eval(attr.dndAllowedTypes);
            if (angular.isArray(allowed) && allowed.indexOf(dndDragTypeWorkaround.dragType) === -1) {
              return false;
            }
          }

          // Check whether droping is disabled completely
          if (attr.dndDisableIf && scope.$eval(attr.dndDisableIf)) return false;

          return true;
        }

        /**
         * Small helper function that cleans up if we aborted a drop.
         */
        function stopDragover() {
          placeholder.remove();
          element.removeClass("dndDragover");
          return true;
        }

        /**
         * Invokes a callback with some interesting parameters and returns the callbacks return value.
         */
        function invokeCallback(expression, event, index, item) {
          return $parse(expression)(scope, {
            event: event,
            index: index,
            item: item || undefined,
            external: !dndDragTypeWorkaround.isDragging,
            type: dndDragTypeWorkaround.isDragging ? dndDragTypeWorkaround.dragType : undefined
          });
        }

        /**
         * Check if the dataTransfer object contains a drag type that we can handle. In old versions
         * of IE the types collection will not even be there, so we just assume a drop is possible.
         */
        function hasTextMimetype(types) {
          if (!types) return true;
          for (var i = 0; i < types.length; i++) {
            if (types[i] === "Text" || types[i] === "text/plain") return true;
          }

          return false;
        }
      };
    }])

  /**
   * Use the dnd-nodrag attribute inside of dnd-draggable elements to prevent them from starting
   * drag operations. This is especially useful if you want to use input elements inside of
   * dnd-draggable elements or create specific handle elements. Note: This directive does not work
   * in Internet Explorer 9.
   */
  .directive('dndNodrag', function() {
    return function(scope, element, attr) {
      // Set as draggable so that we can cancel the events explicitly
      element.attr("draggable", "true");

      /**
       * Since the element is draggable, the browser's default operation is to drag it on dragstart.
       * We will prevent that and also stop the event from bubbling up.
       */
      element.on('dragstart', function(event) {
        event = event.originalEvent || event;

        if (!event._dndHandle) {
          // If a child element already reacted to dragstart and set a dataTransfer object, we will
          // allow that. For example, this is the case for user selections inside of input elements.
          if (!(event.dataTransfer.types && event.dataTransfer.types.length)) {
            event.preventDefault();
          }
          event.stopPropagation();
        }
      });

      /**
       * Stop propagation of dragend events, otherwise dnd-moved might be triggered and the element
       * would be removed.
       */
      element.on('dragend', function(event) {
        event = event.originalEvent || event;
        if (!event._dndHandle) {
          event.stopPropagation();
        }
      });
    };
  })

  /**
   * Use the dnd-handle directive within a dnd-nodrag element in order to allow dragging with that
   * element after all. Therefore, by combining dnd-nodrag and dnd-handle you can allow
   * dnd-draggable elements to only be dragged via specific "handle" elements. Note that Internet
   * Explorer will show the handle element as drag image instead of the dnd-draggable element. You
   * can work around this by styling the handle element differently when it is being dragged. Use
   * the CSS selector .dndDragging:not(.dndDraggingSource) [dnd-handle] for that.
   */
  .directive('dndHandle', function() {
    return function(scope, element, attr) {
      element.attr("draggable", "true");

      element.on('dragstart dragend', function(event) {
        event = event.originalEvent || event;
        event._dndHandle = true;
      });
    };
  })

  /**
   * This workaround handles the fact that Internet Explorer does not support drag types other than
   * "Text" and "URL". That means we can not know whether the data comes from one of our elements or
   * is just some other data like a text selection. As a workaround we save the isDragging flag in
   * here. When a dropover event occurs, we only allow the drop if we are already dragging, because
   * that means the element is ours.
   */
  .factory('dndDragTypeWorkaround', function(){ return {} })

  /**
   * Chrome on Windows does not set the dropEffect field, which we need in dragend to determine
   * whether a drag operation was successful. Therefore we have to maintain it in this global
   * variable. The bug report for that has been open for years:
   * https://code.google.com/p/chromium/issues/detail?id=39399
   */
  .factory('dndDropEffectWorkaround', function(){ return {} });

(function() {
    'use strict';

    angular.module('app.corelib')
        .service('downloadService', downloadService);

    function downloadService(
        msgboxService,
        $http,
        tenantSettings
    ) {
        var service = {
            downloadFile: downloadFile
        };

        var downloadURL = null;

        return service;

        function downloadFile(apiString) {
            let uri = constructUri(apiString);
            uri.then(function(response) {
                var header = response.headers();
                var contentType = header['content-type'];
                try {
                    var blob = new Blob([response.data], {
                        type: contentType
                    });

                    if(downloadURL){
                        URL.revokeObjectURL(downloadURL);
                    }

                    downloadURL = URL.createObjectURL(blob)
                    
                    var anchor = angular.element('<a/>');
                    anchor.attr({
                        href: downloadURL,
                        target: '_blank',
                        download: header.filename
                    })[0].click();
                    
                } catch (ex) {
                    downloadError(ex)
                }
            }).catch(downloadError);
        }

        function constructUri(apiString) {
            let constructedApiUrl = tenantSettings.coreApiUrl + apiString;
            return $http({
                'method': 'GET',
                'url': constructedApiUrl,
                'responseType': 'blob'
            })
        }

        function downloadError(err) {
            msgboxService.alert('Download', 'There was an issue downloading the file', 'Okay')
        }
    }
})();

app.directive("xdHref", function() {
    return function linkFn (scope, elem, attrs) {
        scope.$watch(attrs.xdHref, function(newVal) {
            newVal && elem.attr("href", newVal);
        });
    };
});

app.directive('disallowSpaces', function() {
  return {
    restrict: 'A',

    link: function($scope, $element) {
      $element.bind('input', function() {
        $(this).val($(this).val().replace(/ /g, ''));
      });
    }
  };
});

var app = angular.module('app.decimal', []);
app.controller('appController', function($scope) {

  $scope.positiveNumber = 0;
  $scope.negativeNumber = 0;
  $scope.decimal = 0;
  $scope.decimalUpto = 0
  $scope.negativedecimal = 0;
  $scope.negativedecimalUpto = 0
  $scope.total = 0;
});
angular.module('app.decimal').directive('validNumber', function() {
  return {
    require: '?ngModel',
    link: function(scope, element, attrs, ngModelCtrl) {

      element.on('keydown', function(event) {
        var keyCode = []
        if (attrs.allowNegative == "true") {
          keyCode = [8, 9, 36, 35, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 109, 110, 173, 190, 189];
        } else {
          var keyCode = [8, 9, 36, 35, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 173, 190];
        }


        if (attrs.allowDecimal == "false") {

          var index = keyCode.indexOf(190);


          if (index > -1) {
            keyCode.splice(index, 1);
          }

        }

        if ($.inArray(event.which, keyCode) == -1) event.preventDefault();
        else {
          var oVal = ngModelCtrl.$modelValue || '';
          if ($.inArray(event.which, [109, 173]) > -1 && oVal.indexOf('-') > -1) event.preventDefault();
          else if ($.inArray(event.which, [110, 190]) > -1 && oVal.indexOf('.') > -1) event.preventDefault();
        }
      }).on('blur', function() {

          if (attrs.allowDecimal == "false") {
            ngModelCtrl.$setViewValue(element.val());
          } else {
            if (attrs.decimalUpto) {
              var fixedValue = parseFloat(element.val()).toFixed(attrs.decimalUpto);
            } else {
              var fixedValue = parseFloat(element.val()).toFixed(2);
            }

            if (attrs.max) {
              if (parseInt(attrs.max) < element.val()) {
                var fixedValue = null;
              }
            }
            ngModelCtrl.$setViewValue(fixedValue);
          }

          ngModelCtrl.$render();
          scope.$apply();
        });

      ngModelCtrl.$parsers.push(function(text) {
        var oVal = ngModelCtrl.$modelValue;
        var nVal = ngModelCtrl.$viewValue;
        if (parseFloat(nVal) != nVal) {

          if (nVal === null || nVal === undefined || nVal == '' || nVal == '-') oVal = nVal;

          ngModelCtrl.$setViewValue(oVal);
          ngModelCtrl.$render();
          return oVal;
        } else {
          var decimalCheck = nVal.split('.');
          if (!angular.isUndefined(decimalCheck[1])) {
            if (attrs.decimalUpto)
              decimalCheck[1] = decimalCheck[1].slice(0, attrs.decimalUpto);
            else
              decimalCheck[1] = decimalCheck[1].slice(0, 2);
            nVal = decimalCheck[0] + '.' + decimalCheck[1];
          }

          ngModelCtrl.$setViewValue(nVal);
          ngModelCtrl.$render();
          return nVal;
        }
      });

      // ngModelCtrl.$formatters.push(function(text) {
      //   if (text == '0' || text == null && attrs.allowDecimal == "false") return '0';
      //   else if (text == '0' || text == null && attrs.allowDecimal != "false" && attrs.decimalUpto == undefined) return '0.00';
      //   else if (text == '0' || text == null && attrs.allowDecimal != "false" && attrs.decimalUpto != undefined) return parseFloat(0).toFixed(attrs.decimalUpto);
      //   else if (attrs.allowDecimal != "false" && attrs.decimalUpto != undefined) return parseFloat(text).toFixed(attrs.decimalUpto);
      //   else return parseFloat(text).toFixed(2);
      // });
    }
  };
});


(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('dataCacheService2', dataCacheService2);

    /** @ngInject */
    function dataCacheService2(CacheFactory, $q) {
        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        function activate() {}

        function getInstance(groupName) {
            var objectCacheContext = function() {
                var self = this,
                    grp = '',
                    reqry = false,
                    cache = null;

                self.group = group;
                self.reQuery = requery;
                self.load = load;
                self.remove = remove;
                self.removeAll = removeAll;
                self.updateCache = updateCache;
                self.getCache = getCache;

                activate();

                function activate() {
                    if (groupName) {
                        group(groupName);
                    }
                }

                function group(name, opts) {
                    grp = name;

                    cache = CacheFactory.get(name);

                    if (!cache) {
                        cache = CacheFactory(name, opts);
                    }

                    return this;
                }


                function requery(reQuery) {
                    reqry = reQuery;
                    return this;
                }

                function remove(cacheKey) {
                    cache.remove(cacheKey);
                }

                function removeAll() {
                    cache.destroy();
                }

                function load(cacheKey, fn) {
                    var deferred = $q.defer();

                    if (cache) {
                        if (reqry) {
                            cache.remove(cacheKey);
                        }

                        if (!cache.get(cacheKey)) {
                            var resultPromise = (fn || angular.noop)();
                            var promise = null;

                            if (angular.isObject(resultPromise.$promise)) {
                                promise = resultPromise.$promise;
                            } else {
                                promise = $q.when(resultPromise);
                            }

                            promise.then(function(resp) {
                                if (resp) {
                                    cache.put(cacheKey, resp);
                                    deferred.resolve(angular.copy(resp));
                                }
                            }).catch(function(ex) {
                                deferred.reject(ex);
                            });

                        } else {
                            let obj = cache.get(cacheKey);
                            obj['fromCache'] = true;
                            deferred.resolve(angular.copy(obj));
                        }

                    } else {
                        throw new Error('Cache object is null.');
                    }

                    afterLoadExecution();

                    return deferred.promise;
                }

                function updateCache(cacheKey, data) {
                    cache.put(cacheKey, data);
                }

                function getCache(cacheKey) {
                    return cache.get(cacheKey);
                }

                function afterLoadExecution() {
                    reqry = false;
                }
            };

            return new objectCacheContext();
        }
    }
})();

/**
 * DataCaching
 * by Rcnet 9.5.2016
 */
(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('dataCacheService', dataCacheService);

    /** @ngInject */
    function dataCacheService($cacheFactory, $q) {
        var service = {
            getInstance: getInstance
        };

        activate();

        return service;

        //////
        function activate() {}

        /**
         * Return a Fluent Interface object
         */
        function getInstance(groupName) {
            var objectCacheContext = function() {
                var self = this,
                    grp = '',
                    reqry = false,
                    cache = null,
                    _capacity = 8;

                self.group = group;
                self.reQuery = requery;
                self.load = load;
                self.remove = remove;
                self.removeAll = removeAll;
                self.updateCache = updateCache;
                self.getCache = getCache;

                activate();

                //////

                function activate() {
                    if (groupName) {
                        group(groupName);
                    }
                }

                function group(name, capacityParam) {
                    grp = name;
                    _capacity = capacityParam;
                    cache = $cacheFactory.get(name);

                    if (!cache) {
                        cache = $cacheFactory(name, { capacity: capacityParam });
                    }

                    return this;
                }

                function capacity(value) {
                    _capacity = value;
                    return this;
                }

                function requery(reQuery) {
                    reqry = reQuery;
                    return this;
                }

                function remove(cacheName) {
                    cache.remove(cacheName);
                }

                function removeAll() {
                    cache.removeAll();
                }

                function load(cacheName, fn) {
                    var deferred = $q.defer();

                    if (cache) {
                        if (reqry) {
                            cache.remove(cacheName);
                        }

                        if (!cache.get(cacheName)) {
                            // Always convert result to promise (for deferred execution)
                            var resultPromise = (fn || angular.noop)();
                            var promise = null;

                            if (angular.isObject(resultPromise.$promise)) {
                                promise = resultPromise.$promise;
                            } else {
                                promise = $q.when(resultPromise);
                            }

                            promise.then(function(resp) {
                                if (resp) {
                                    cache.put(cacheName, resp);
                                    deferred.resolve(resp);
                                }
                            }).catch(function(ex) {
                                deferred.reject(ex);
                            });

                        } else {
                            let obj = cache.get(cacheName);
                            obj['fromCache'] = true;
                            deferred.resolve(obj);
                            //deferred.resolve(cache.get(cacheName));
                        }

                    } else {
                        throw new Error('Cache object is null.');
                    }

                    afterLoadExecution();

                    return deferred.promise;
                }

                function updateCache(name, data) {
                    cache.put(name, data);
                }

                function getCache(name) {
                    return cache.get(name);
                }

                /**
                 * Perform disposal
                 */
                function afterLoadExecution() {
                    reqry = false;
                    capacity = 8;
                }

            }; // End object instance 

            return new objectCacheContext();
        }


    }
})();
(function () {
    'use strict';

    angular.module('app.corelib')
        .directive('formValidator', formValidator);

    /** @ngInject */
    function formValidator() {
        return {
            restrict: 'A',
            scope: {
                ngModel: '=',
                type: '@',
                formFieldName: '=',
                formFieldRuleName: '=',
                formRules: '=',
                formFields: '=',
                formScope: '=',
                formLookUp: '='
            },
            controller: function (_, $scope) {

                var vm = $scope;

                vm.$watch('ngModel', function (new_val, old_val) {

                    //Prevent Implementation of rules
                    if (old_val == null && new_val == null) {
                        return;
                    }

                    if (_.isArray(old_val) && _.isArray(new_val)) {
                        if (old_val.length == 0 && new_val.length == 0) {
                            return;
                        }
                    }
                    //Prevent Implementation of rules

                    //Reset Rules
                    //Will only reset a rule IF the model that was changed is related to the rule
                    _.forEach(vm.formRules, function (rule) {
                        //Check if the field changed is related to a specific condition
                        let match = _.find(rule.IfConditions, {Field: vm.formFieldRuleName});
                        if (match) {
                            _.forEach(rule.ThenStatements, function (statement) {
                                // TODO: Check if each then properties are present
                                _.forEach(vm.formFields, function(field){
                                    if((field.FieldRuleName == vm.formFieldRuleName) && (vm.formFieldRuleName == statement.Field)){
                                        if(statement.CustomValidationRequiredType){
                                            field.IsRequired = false;
                                        }

                                        if(statement.RegexValidation){
                                            field.Pattern = null;
                                            field.WrongPatternMessage = null;
                                        }

                                        //Reset Lookup
                                        if ((field.FieldType == "single-select" || field.FieldType == "multi-select") && statement.AllowedValues) {
                                            let lookup = getValues(field.LookupModel);
                                            lookup.forEach(function (lookup) {
                                                lookup['Disabled'] = false;
                                            });
                                        }
                                        //Reset Lookup
                                    }
                                })
                            });
                        }
                    });
                    //Reset Rules

                    _.forEach(vm.formRules, function (rule) {

                        _.forEach(vm.formFields, function (field) {
                            let match = _.find(vm.formFields, {FieldName: field.FieldName});
                            if (match) {
                                field['FieldType'] = match.FieldType;
                            }
                        });

                        let matched_condition = _.find(rule.IfConditions, {Field: vm.formFieldRuleName});

                        if (matched_condition) {

                            let combined_conditions = _.groupBy(rule.IfConditions, "Field");

                            var satisified_conditions = 0;

                            //generate field type per condition
                            _.forEach(combined_conditions, function (conditions) {
                                let field_type = _.find(vm.formFields, {FieldRuleName: conditions[0].Field}).FieldType;
                                let model = _.find(vm.formFields, {FieldRuleName: conditions[0].Field}).Model;

                                if (field_type === "multi-select") {

                                    //Get Only Name/Value of Condition
                                    let cond = conditions.map(function (c) {
                                        return c.Value;
                                    });

                                    let model_value = getValues(model);

                                    if (model_value) {
                                        //Get Only Name/Value of a model
                                        let values = model_value.map(function (m) {
                                            return m['Name'] || m['TypeName'];
                                        });

                                        //Check if model contains all required values
                                        let satisfied = arrayContainsArray(values, cond);

                                        if (satisfied) {
                                            satisified_conditions++;
                                        }
                                    }
                                }

                                if (field_type === "text") {
                                    if (_.find(conditions, {Value: vm.formScope[model]})) {
                                        satisified_conditions++;
                                    }
                                }

                                if (field_type === "single-select") {
                                    let model_value = getValues(model);
                                    if (model_value) {
                                        let match = _.find(conditions, function (c) {
                                            if (_.isObject(model_value)) {
                                                return c.Value === (model_value['Name'] || model_value['TypeName'] || model_value);
                                            } else {
                                                return c.Id === (model_value['Id'] || model_value);
                                            }
                                        });
                                        if (match) {
                                            satisified_conditions++;
                                        }
                                    }
                                }
                            });
                            //generate field type per condition

                            //condition evaluator (If all conditions were satisfied)

                            let combined_condition_as_array = _.toArray(combined_conditions);

                            if (satisified_conditions === combined_condition_as_array.length) {
                                //Execute Then
                                //Satisfied Conditions
                                executeConditionPassed(rule);
                            }
                            //condition evaluator (If all conditions were satisfied)
                        }
                    });
                });

                function executeConditionPassed(rule) {
                    let results = rule.ThenStatements;
                    _.forEach(results, function (result) {
                        //Required Validator
                        if (result.CustomValidationRequiredType != null) {
                            _.forEach(vm.formFields, function (field) {
                                if (field.FieldRuleName === result.Field && (result.CustomValidationRequiredType == 1 || result.CustomValidationRequiredType == 0)) {
                                    field.IsRequired = true;
                                }else{
                                    field.IsRequired = false;
                                }
                            });
                        }
                        //Required Validator

                        //Pattern Validator
                        if (!_.isUndefined(result.RegexValidation)) {
                            _.forEach(vm.formFields, function (field) {
                                if (field.FieldRuleName === result.Field) {
                                    field.Pattern = result.RegexValidation;
                                    field.WrongPatternMessage = null;
                                }
                            });
                        }
                        //Pattern validator

                        //Options Limitations
                        if (!_.isUndefined(result.AllowedValues)) {
                            let lookup_model = _.find(vm.formFields, {FieldRuleName: result.Field}).LookupModel;
                            if (lookup_model) {
                                let lookup = getValues(lookup_model);
                                _.forEach(lookup, function (l) {
                                    if (!_.isNil(l.Id)) {
                                        if (_.find(result.AllowedValues, {Id: l.Id.toString()})) {
                                            l['Disabled'] = false;
                                        } else {
                                            l['Disabled'] = true;
                                        }
                                    } else {
                                        if (_.find(result.AllowedValues, {Id: l.id.toString()})) {
                                            l['Disabled'] = false;
                                        } else {
                                            l['Disabled'] = true;
                                        }
                                    }
                                });
                            }
                        }
                        //Options Limitations
                    });
                }

                function arrayContainsArray(superset, subset) {
                    if (0 === subset.length) {
                        return false;
                    }
                    return subset.every(function (value) {
                        return (superset.indexOf(value) >= 0);
                    });
                }

                function getValues(lookup_model) {
                    let sub_models = lookup_model.split(".");
                    let current_value = vm.formScope[sub_models[0]];
                    let lookup_value = null;

                    if (sub_models.length === 1) {
                        lookup_value = current_value;
                    } else {
                        sub_models.forEach(function (sub, index) {
                            if (index > 0) {
                                current_value = current_value[sub];
                            }
                        });
                        lookup_value = current_value;
                    }
                    return lookup_value;
                }
            }
        }
    };
})();


(function() {
  'use strict';

  // POST RELEASE
  // TODO(jelbourn): Demo that uses moment.js
  // TODO(jelbourn): make sure this plays well with validation and ngMessages.
  // TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
  // TODO(jelbourn): input behavior (masking? auto-complete?)
  // TODO(jelbourn): UTC mode
  // TODO(jelbourn): RTL


  angular.module('material.components.datepicker')
      .directive('formatDatepicker', datePickerDirective);

  /**
   * @ngdoc directive
   * @name mdDatepicker
   * @module material.components.datepicker
   *
   * @param {Date} ng-model The component's model. Expects a JavaScript Date object.
   * @param {expression=} ng-change Expression evaluated when the model value changes.
   * @param {Date=} md-min-date Expression representing a min date (inclusive).
   * @param {Date=} md-max-date Expression representing a max date (inclusive).
   * @param {String=} md-current-view Default view for the calendar. Defalts to 'month'.
   * @param {String=} md-placeholder The date input placeholder value.
   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
   * @param {boolean=} ng-required Whether a value is required for the datepicker.
   *
   * @description
   * `<md-datepicker>` is a component used to select a single date.
   * For information on how to configure internationalization for the date picker,
   * see `$mdDateLocaleProvider`.
   *
   * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
   * Supported attributes are:
   * * `required`: whether a required date is not set.
   * * `mindate`: whether the selected date is before the minimum allowed date.
   * * `maxdate`: whether the selected date is after the maximum allowed date.
   *
   * @usage
   * <hljs lang="html">
   *   <md-datepicker ng-model="birthday"></md-datepicker>
   * </hljs>
   *
   */
  function datePickerDirective() {
    return {
      template:
          // Buttons are not in the tab order because users can open the calendar via keyboard
          // interaction on the text input, and multiple tab stops for one component (picker)
          // may be confusing.
          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
              'tabindex="-1" aria-hidden="true" ' +
              'ng-click="ctrl.openCalendarPane($event)">' +
            '<md-icon class="md-datepicker-calendar-icon" md-svg-icon="md-calendar"></md-icon>' +
          '</md-button>' +
          '<div class="md-datepicker-input-container" ' +
              'ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
            '<input class="md-datepicker-input" aria-haspopup="true" ' +
                'ng-focus="ctrl.setFocused(true)" ng-blur="ctrl.setFocused(false)">' +
            '<md-button type="button" md-no-ink ' +
                'class="md-datepicker-triangle-button md-icon-button" ' +
                'ng-click="ctrl.openCalendarPane($event)" ' +
                'aria-label="{{::ctrl.dateLocale.msgOpenCalendar}}">' +
              '<div class="md-datepicker-expand-triangle"></div>' +
            '</md-button>' +
          '</div>' +

          // This pane will be detached from here and re-attached to the document body.
          '<div class="md-datepicker-calendar-pane md-whiteframe-z1">' +
            '<div class="md-datepicker-input-mask">' +
              '<div class="md-datepicker-input-mask-opaque"></div>' +
            '</div>' +
            '<div class="md-datepicker-calendar">' +
              '<md-calendar role="dialog" aria-label="{{::ctrl.dateLocale.msgCalendar}}" ' +
                  'md-min-date="ctrl.minDate" md-max-date="ctrl.maxDate"' +
                  'md-date-filter="ctrl.dateFilter"' +
                  'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
              '</md-calendar>' +
            '</div>' +
          '</div>',
      require: ['ngModel', 'formatDatepicker', '?^mdInputContainer'],
      scope: {
        dateformat: '=',
        minDate: '=mdMinDate',
        maxDate: '=mdMaxDate',
        placeholder: '@mdPlaceholder',
        dateFilter: '=mdDateFilter'
      },
      controller: DatePickerCtrl,
      controllerAs: 'ctrl',
      bindToController: true,
      link: function(scope, element, attr, controllers) {
        var ngModelCtrl = controllers[0];
        var mdDatePickerCtrl = controllers[1];

        var mdInputContainer = controllers[2];
        if (mdInputContainer) {
          throw Error('md-datepicker should not be placed inside md-input-container.');
        }

        mdDatePickerCtrl.configureNgModel(ngModelCtrl);
      }
    };
  }

  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
  var EXTRA_INPUT_SIZE = 3;

  /** Class applied to the container if the date is invalid. */
  var INVALID_CLASS = 'md-datepicker-invalid';

  /** Default time in ms to debounce input event by. */
  var DEFAULT_DEBOUNCE_INTERVAL = 500;

  /**
   * Height of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_HEIGHT = 368;

  /**
   * Width of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_WIDTH = 360;

  /**
   * Controller for md-datepicker.
   *
   * @ngInject @constructor
   */
  function DatePickerCtrl($scope, $element, $attrs, $compile, $timeout, $window,
      $mdConstant, $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF) {
    /** @final */
    this.$compile = $compile;

    /** @final */
    this.$timeout = $timeout;

    /** @final */
    this.$window = $window;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdConstant = $mdConstant;

    /* @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.$$rAF = $$rAF;

    /**
     * The root document element. This is used for attaching a top-level click handler to
     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
     * instead of body because, when scrolling is disabled, some browsers consider the body element
     * to be completely off the screen and propagate events directly to the html element.
     * @type {!angular.JQLite}
     */
    this.documentElement = angular.element(document.documentElement);

    /** @type {!angular.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {HTMLInputElement} */
    this.inputElement = $element[0].querySelector('input');

    /** @final {!angular.JQLite} */
    this.ngInputElement = angular.element(this.inputElement);

    /** @type {HTMLElement} */
    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');

    /** @type {HTMLElement} Floating calendar pane. */
    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');

    /** @type {HTMLElement} Calendar icon button. */
    this.calendarButton = $element[0].querySelector('.md-datepicker-button');

    /**
     * Element covering everything but the input in the top of the floating calendar pane.
     * @type {HTMLElement}
     */
    this.inputMask = $element[0].querySelector('.md-datepicker-input-mask-opaque');

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Attributes} */
    this.$attrs = $attrs;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @type {Date} */
    this.date = null;

    /** @type {boolean} */
    this.isFocused = false;

    /** @type {boolean} */
    this.isDisabled;
    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));

    /** @type {boolean} Whether the date-picker's calendar pane is open. */
    this.isCalendarOpen = false;

    /**
     * Element from which the calendar pane was opened. Keep track of this so that we can return
     * focus to it when the pane is closed.
     * @type {HTMLElement}
     */
    this.calendarPaneOpenedFrom = null;

    this.calendarPane.id = 'md-date-pane' + $mdUtil.nextUid();

    $mdTheming($element);

    /** Pre-bound click handler is saved so that the event listener can be removed. */
    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);

    /** Pre-bound resize handler so that the event listener can be removed. */
    this.windowResizeHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

    // Unless the user specifies so, the datepicker should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if (!$attrs.tabindex) {
      $element.attr('tabindex', '-1');
    }

    this.installPropertyInterceptors();
    this.attachChangeListeners();
    this.attachInteractionListeners();

    var self = this;
    $scope.$on('$destroy', function() {
      self.detachCalendarPane();
    });
  }

  /**
   * Sets up the controller's reference to ngModelController.
   * @param {!angular.NgModelController} ngModelCtrl
   */
  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl) {
    this.ngModelCtrl = ngModelCtrl;

    var self = this;
    ngModelCtrl.$render = function() {
      var value = self.ngModelCtrl.$viewValue;

      if (value && !(value instanceof Date)) {
        throw Error('The ng-model for md-datepicker must be a Date instance. ' +
            'Currently the model is a: ' + (typeof value));
      }

      self.date = value;
      self.date = new Date();
      self.inputElement.value = moment(self.date).format(self.$scope.$root.DateFormat);

      self.resizeInputElement();
      self.updateErrorState();
    };
  };

  /**
   * Attach event listeners for both the text input and the md-calendar.
   * Events are used instead of ng-model so that updates don't infinitely update the other
   * on a change. This should also be more performant than using a $watch.
   */
  DatePickerCtrl.prototype.attachChangeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-change', function(event, date) {
      self.ngModelCtrl.$setViewValue(date);
      self.date = date;
      self.inputElement.value = moment(date).format(self.$scope.$root.DateFormat);
      self.closeCalendarPane();
      self.resizeInputElement();
      self.updateErrorState();
    });

    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
    // TODO(chenmike): Add ability for users to specify this interval.
    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
        DEFAULT_DEBOUNCE_INTERVAL, self));
  };

  /** Attach event listeners for user interaction. */
  DatePickerCtrl.prototype.attachInteractionListeners = function() {
    var self = this;
    var $scope = this.$scope;
    var keyCodes = this.$mdConstant.KEY_CODE;

    // Add event listener through angular so that we can triggerHandler in unit tests.
    self.ngInputElement.on('keydown', function(event) {
      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
        self.openCalendarPane(event);
        $scope.$digest();
      }
    });

    $scope.$on('md-calendar-close', function() {
      self.closeCalendarPane();
    });
  };

  /**
   * Capture properties set to the date-picker and imperitively handle internal changes.
   * This is done to avoid setting up additional $watches.
   */
  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
    var self = this;

    if (this.$attrs.ngDisabled) {
      // The expression is to be evaluated against the directive element's scope and not
      // the directive's isolate scope.
      var scope = this.$scope.$parent;

      if (scope) {
        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
          self.setDisabled(isDisabled);
        });
      }
    }

    Object.defineProperty(this, 'placeholder', {
      get: function() { return self.inputElement.placeholder; },
      set: function(value) { self.inputElement.placeholder = value || ''; }
    });
  };

  /**
   * Sets whether the date-picker is disabled.
   * @param {boolean} isDisabled
   */
  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
    this.isDisabled = isDisabled;
    this.inputElement.disabled = isDisabled;
    this.calendarButton.disabled = isDisabled;
  };

  /**
   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
   *   - mindate: whether the selected date is before the minimum date.
   *   - maxdate: whether the selected flag is after the maximum date.
   *   - filtered: whether the selected date is allowed by the custom filtering function.
   *   - valid: whether the entered text input is a valid date
   *
   * The 'required' flag is handled automatically by ngModel.
   *
   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
   */
  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
    var date = opt_date || this.date;

    // Clear any existing errors to get rid of anything that's no longer relevant.
    this.clearErrorState();

    if (this.dateUtil.isValidDate(date)) {
      // Force all dates to midnight in order to ignore the time portion.
      date = this.dateUtil.createDateAtMidnight(date);

      if (this.dateUtil.isValidDate(this.minDate)) {
        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
      }

      if (this.dateUtil.isValidDate(this.maxDate)) {
        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
      }

      if (angular.isFunction(this.dateFilter)) {
        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
      }
    } else {
      // The date is seen as "not a valid date" if there is *something* set
      // (i.e.., not null or undefined), but that something isn't a valid date.
      this.ngModelCtrl.$setValidity('valid', date == null);
    }

    // TODO(jelbourn): Change this to classList.toggle when we stop using PhantomJS in unit tests
    // because it doesn't conform to the DOMTokenList spec.
    // See https://github.com/ariya/phantomjs/issues/12782.
    if (!this.ngModelCtrl.$valid) {
      this.inputContainer.classList.add(INVALID_CLASS);
    }
  };

  /** Clears any error flags set by `updateErrorState`. */
  DatePickerCtrl.prototype.clearErrorState = function() {
    this.inputContainer.classList.remove(INVALID_CLASS);
    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
      this.ngModelCtrl.$setValidity(field, true);
    }, this);
  };

  /** Resizes the input element based on the size of its content. */
  DatePickerCtrl.prototype.resizeInputElement = function() {
    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
  };

  /**
   * Sets the model value if the user input is a valid date.
   * Adds an invalid class to the input element if not.
   */
  DatePickerCtrl.prototype.handleInputEvent = function() {
    var inputString = this.inputElement.value;
    var parsedDate = inputString ? this.dateLocale.parseDate(inputString) : null;
    this.dateUtil.setDateTimeToMidnight(parsedDate);

    // An input string is valid if it is either empty (representing no date)
    // or if it parses to a valid date that the user is allowed to select.
    var isValidInput = inputString == '' || (
      this.dateUtil.isValidDate(parsedDate) &&
      this.dateLocale.isDateComplete(inputString) &&
      this.isDateEnabled(parsedDate)
    );

    // The datepicker's model is only updated when there is a valid input.
    if (isValidInput) {
      this.ngModelCtrl.$setViewValue(parsedDate);
      this.date = parsedDate;
    }

    this.updateErrorState(parsedDate);
  };

  /**
   * Check whether date is in range and enabled
   * @param {Date=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
  };

  /** Position and attach the floating calendar to the document. */
  DatePickerCtrl.prototype.attachCalendarPane = function() {
    var calendarPane = this.calendarPane;
    calendarPane.style.transform = '';
    this.$element.addClass('md-datepicker-open');

    var elementRect = this.inputContainer.getBoundingClientRect();
    var bodyRect = document.body.getBoundingClientRect();

    // Check to see if the calendar pane would go off the screen. If so, adjust position
    // accordingly to keep it within the viewport.
    var paneTop = elementRect.top - bodyRect.top;
    var paneLeft = elementRect.left - bodyRect.left;

    // If ng-material has disabled body scrolling (for example, if a dialog is open),
    // then it's possible that the already-scrolled body has a negative top/left. In this case,
    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
    // though, the top of the viewport should just be the body's scroll position.
    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
        -bodyRect.top :
        document.body.scrollTop;

    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
        -bodyRect.left :
        document.body.scrollLeft;

    var viewportBottom = viewportTop + this.$window.innerHeight;
    var viewportRight = viewportLeft + this.$window.innerWidth;

    // If the right edge of the pane would be off the screen and shifting it left by the
    // difference would not go past the left edge of the screen. If the calendar pane is too
    // big to fit on the screen at all, move it to the left of the screen and scale the entire
    // element down to fit.
    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
      } else {
        paneLeft = viewportLeft;
        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
        calendarPane.style.transform = 'scale(' + scale + ')';
      }

      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    // If the bottom edge of the pane would be off the screen and shifting it up by the
    // difference would not go past the top edge of the screen.
    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    calendarPane.style.left = paneLeft + 'px';
    calendarPane.style.top = paneTop + 'px';
    document.body.appendChild(calendarPane);

    // The top of the calendar pane is a transparent box that shows the text input underneath.
    // Since the pane is floating, though, the page underneath the pane *adjacent* to the input is
    // also shown unless we cover it up. The inputMask does this by filling up the remaining space
    // based on the width of the input.
    this.inputMask.style.left = elementRect.width + 'px';

    // Add CSS class after one frame to trigger open animation.
    this.$$rAF(function() {
      calendarPane.classList.add('md-pane-open');
    });
  };

  /** Detach the floating calendar pane from the document. */
  DatePickerCtrl.prototype.detachCalendarPane = function() {
    this.$element.removeClass('md-datepicker-open');
    this.calendarPane.classList.remove('md-pane-open');
    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');

    if (this.isCalendarOpen) {
      this.$mdUtil.enableScrolling();
    }

    if (this.calendarPane.parentNode) {
      // Use native DOM removal because we do not want any of the angular state of this element
      // to be disposed.
      this.calendarPane.parentNode.removeChild(this.calendarPane);
    }
  };

  /**
   * Open the floating calendar pane.
   * @param {Event} event
   */
  DatePickerCtrl.prototype.openCalendarPane = function(event) {
    if (!this.isCalendarOpen && !this.isDisabled) {
      this.isCalendarOpen = true;
      this.calendarPaneOpenedFrom = event.target;

      // Because the calendar pane is attached directly to the body, it is possible that the
      // rest of the component (input, etc) is in a different scrolling container, such as
      // an md-content. This means that, if the container is scrolled, the pane would remain
      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
      // also matches the native behavior for things like `<select>` on Mac and Windows.
      this.$mdUtil.disableScrollAround(this.calendarPane);

      this.attachCalendarPane();
      this.focusCalendar();

      // Attach click listener inside of a timeout because, if this open call was triggered by a
      // click, we don't want it to be immediately propogated up to the body and handled.
      var self = this;
      this.$mdUtil.nextTick(function() {
        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
        // events aren't propogated under most circumstances.
        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        self.documentElement.on('click touchstart', self.bodyClickHandler);
      }, false);

      window.addEventListener('resize', this.windowResizeHandler);
    }
  };

  /** Close the floating calendar pane. */
  DatePickerCtrl.prototype.closeCalendarPane = function() {
    if (this.isCalendarOpen) {
      this.detachCalendarPane();
      this.isCalendarOpen = false;
      this.calendarPaneOpenedFrom.focus();
      this.calendarPaneOpenedFrom = null;

      this.ngModelCtrl.$setTouched();

      this.documentElement.off('click touchstart', this.bodyClickHandler);
      window.removeEventListener('resize', this.windowResizeHandler);
    }
  };

  /** Gets the controller instance for the calendar in the floating pane. */
  DatePickerCtrl.prototype.getCalendarCtrl = function() {
    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
  };

  /** Focus the calendar in the floating pane. */
  DatePickerCtrl.prototype.focusCalendar = function() {
    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
    var self = this;
    this.$mdUtil.nextTick(function() {
      self.getCalendarCtrl().focus();
    }, false);
  };

  /**
   * Sets whether the input is currently focused.
   * @param {boolean} isFocused
   */
  DatePickerCtrl.prototype.setFocused = function(isFocused) {
    if (!isFocused) {
      this.ngModelCtrl.$setTouched();
    }
    this.isFocused = isFocused;
  };

  /**
   * Handles a click on the document body when the floating calendar pane is open.
   * Closes the floating calendar pane if the click is not inside of it.
   * @param {MouseEvent} event
   */
  DatePickerCtrl.prototype.handleBodyClick = function(event) {
    if (this.isCalendarOpen) {
      // TODO(jelbourn): way want to also include the md-datepicker itself in this check.
      var closest = this.$mdUtil.getClosest;
      var isInCalendar = closest(event.target, 'md-calendar-year') || closest(event.target, 'md-calendar-month');

      if (!isInCalendar) {
        this.closeCalendarPane();
      }

      this.$scope.$digest();
    }
  };
})();

angular.module('confirmOnExit', []).directive('confirmOnExit', function() {
    return {
        link: function($scope) {
            window.onbeforeunload = function() {
                if ($scope.form.$dirty) {
                    return "The form is dirty, do you want to stay on the page?";
                }
            }
        }
    }
});

/**
 * Created by Ben Rei on 2/13/2017.
 */
angular.module('app.corelib').directive('compareTo', function() {
  return {
    require: "ngModel",
    scope: {
      otherModelValue: "=compareTo"
    },
    link: function(scope, element, attributes, ngModel) {

      ngModel.$validators.compareTo = function(modelValue) {
        return modelValue == scope.otherModelValue;
      };

      scope.$watch("otherModelValue", function() {
        ngModel.$validate();
      });
    }
  };
});

(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('claimsUtilService', claimsUtilService)
        .constant(
            'payrollGroupClaimName', 'Manage Payroll Groups'
        );

    /** @ngInject */
    function claimsUtilService(
        _,
        claimsService,
        identityService,
        tenantSettings,
        payrollGroupClaimName
    ) {
        var service = {
            payrollGroupClaimName: payrollGroupClaimName,
            hasBranchAccess: hasBranchAccess,
            checkAccessByRole: checkAccessByRole,
            isSmsEnabled: isSmsEnabled,
            isAltusSpecialEnabled: isAltusSpecialEnabled,
            isPayrollEnabled: isPayrollEnabled,
            isBillingEnabled: isBillingEnabled,
            isTravelKmsInTimesheetEnabled: isTravelKmsInTimesheetEnabled,
            isInclementWeatherInTimesheetEnabled: isInclementWeatherInTimesheetEnabled,
            isDocumentManagementEnabled: isDocumentManagementEnabled,
            isMobileAppEnabled: isMobileAppEnabled,
            isXeroEnabled : isXeroEnabled,
            isMyobEnabled : isMyobEnabled,
            isCustomFormsEnabled: isCustomFormsEnabled,
            getTenantKey: getTenantKey,
            isWebhookEnabled: isWebhookEnabled,
            isCostProjectionEnabled: isCostProjectionEnabled,
            isEmergencyContactFieldsEnabled: isEmergencyContactFieldsEnabled,
            isCustomerOnboardingEnabled: isCustomerOnboardingEnabled,
            isSetupPackupInTimesheetEnabled: isSetupPackupInTimesheetEnabled,
            getOneDriveClientId: getOneDriveClientId,
            isEmailNotificationEnabled: isEmailNotificationEnabled,
            isSiteContactEmailNotificationEnabled: isSiteContactEmailNotificationEnabled,
            isPaperworkEmailEnabled: isPaperworkEmailEnabled,
            isCloningOfAttachmentsEnabled: isCloningOfAttachmentsEnabled,
            isTicketEndTimeOnMobileHiddenByDefaultEnabled: isTicketEndTimeOnMobileHiddenByDefaultEnabled,
            isPayrollGroupsEnabled: isPayrollGroupsEnabled,
            isSmartSchedulingEnabled : isSmartSchedulingEnabled,
            hasSmartSchedulingAccess : hasSmartSchedulingAccess,
            isShopTimeEnabled : isShopTimeEnabled,
            isLoadTimeEnabled : isLoadTimeEnabled,
            isContactlessSignatureEnabled: isContactlessSignatureEnabled,
            isConfigurableRequiredAttachmentsEnabled: isConfigurableRequiredAttachmentsEnabled,
            isSurchargesEnabled: isSurchargesEnabled,
            isLinkedItemsEnabled: isLinkedItemsEnabled,
            isEmailAttachmentPreferencesEnabled: isEmailAttachmentPreferencesEnabled,
            isCloneJobsUserAccessEnabled: isCloneJobsUserAccessEnabled
        };

        return service;

        function hasBranchAccess(branchIds) {
            const BRANCH_CLAIM = 'Branch'; // List of Branch(es) claims, includes branch ids
            const BRANCH_SU = 'BranchSU'; // Branch super user claims, includes either TRUE or FALSE

            // Check if branch super user
            if (claimsService.checkClaims(identityService.userData.Claims, BRANCH_SU, 'True')) return true;
            var branches = claimsService.getClaimValues(identityService.userData.Claims, BRANCH_CLAIM);

            for (var i = 0; i < branchIds.length; i++) {
                var branchObj = _.find(branches[0].split(','), function(o) {
                    return o === branchIds[i];
                });

                if (branchObj != null)
                    return true;
            }

            return false;
        }

        function checkAccessByRole(roleName) {
            return claimsService.checkClaims(identityService.userData.Claims, 'role', roleName);
        }

        function isSmsEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableSms");
        }

        function isCustomFormsEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableCustomForms");
        }

        function isDocumentManagementEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableDocumentManagement");
        }

        function isAltusSpecialEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableAltusSpecial");
        }

        function isPayrollEnabled() {
            return tenantSettings.enabledFeatures.includes("EnablePayroll");
        }

        function isBillingEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableBilling");
        }

        function isSurchargesEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableSurcharges");
        }

        function isLinkedItemsEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableLinkedItems");
        }

        function isEmailAttachmentPreferencesEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableEmailAttachmentPreferences");
        }

        function isCloneJobsUserAccessEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableCloneJobsUserAccess");
        }

        function isTravelKmsInTimesheetEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableTravelKmsInTimesheet");
        }

        function isInclementWeatherInTimesheetEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableInclementWeatherInTimesheet");
        }

        function isMobileAppEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableMessaging");
        }

        function isXeroEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableXero");
        }

        function isMyobEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableMyob");
        }

        function getTenantKey() {
            return tenantSettings.tenantKey;
        }

        function isWebhookEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableWebhook");
        }

        function isCostProjectionEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableCostProjection");
        }

        function isEmergencyContactFieldsEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableEmergencyContactFields");
        }

        function isCustomerOnboardingEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableCustomerOnboarding");
        }

        function isSetupPackupInTimesheetEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableSetupPackupInTimesheet");
        }

        function isEmailNotificationEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableEmailNotification");
        }

        function isSiteContactEmailNotificationEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableSiteContactEmailNotification");
        }

        function getOneDriveClientId() {
            return claimsService.getClaimValues(identityService.userData.Claims, 'oneDriveClientId')[0];
        }

        function isPaperworkEmailEnabled() {
            return tenantSettings.enabledFeatures.includes("EnablePaperworkEmail");
        }

        function isCloningOfAttachmentsEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableCloningOfAttachments");
        }

        function isTicketEndTimeOnMobileHiddenByDefaultEnabled() {
            return tenantSettings.enabledFeatures.includes("HideTicketEndTimeOnMobileByDefault");
        }

        function isPayrollGroupsEnabled() {
            return tenantSettings.enabledFeatures.includes("EnablePayrollGroups");
        }

        function isSmartSchedulingEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableSchedulingCopilot");
        }

        function hasSmartSchedulingAccess() {
            return claimsService.checkClaims(identityService.userData.Claims, 'role', 'Access Scheduling Copilot')
        }

        function isShopTimeEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableShopTimeInTimesheets");
        }

        function isLoadTimeEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableLoadTimeInTimesheets");
        }

        function isContactlessSignatureEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableContactlessSignature");
        }

        function isConfigurableRequiredAttachmentsEnabled() {
            return tenantSettings.enabledFeatures.includes("EnableConfigurableRequiredAttachments");
        }
    }
})();

    (function() {
         'use strict';
    
        angular.module('app.corelib')
               .factory('claimsService', claimsService);
        
        /** @ngInject */
        function claimsService($log, $injector, $window, _) {
            var service = {
                create: create,
                getClaimValues: getClaimValues,
                getClaims: getClaims,
                checkClaims: checkClaims,
                checkAccess: checkAccess,
                parseJwt: parseJwt
            };
            
            return service;
            
            ///////
            function create(claims) {
                // Create claims
                var claimsArr = [];
                
                for(var prop in claims) {
                    
                  if (prop === 'role' && claims[prop].length > 0 && typeof claims[prop] === 'object') {
                     angular.forEach(claims[prop], function(itm) {
                        claimsArr.push({ type: 'role', value: itm });                               
                     }, this);
                  }
                  else {
                    claimsArr.push({ type: prop, value: claims[prop] });
                  }
                }
            
                return claimsArr;
            }

            /**
            * Get Claim Value
            * @claimType - claim type parameter
            * @returns - Returns only claims value not the whole object
            */
            function getClaimValues(claims, claimType) {
                 var results = getClaims(claims, claimType);
                 
                 var res = [];
                 angular.forEach(results, function(itm) {
                     res.push(itm.value);
                 }, this);
                 
                 return res;
            }
            
           /**
            * Get claims object 
            * @returns - Returns the whole key value object
            */
            function getClaims(claims, claimType) {
                 var results = _.filter(claims, function(o) {
                    return o.type === claimType; 
                 });
                 
                 return results;
            }
            
            /**
            * It will check all the user assigned claims access in the declared claims pipeline for this user.
            * The result should be TRUE to be able to grant access.
            * @description - expected object properties: { claimType: '', claimValue: '' }
            * @claimsToCheck - accepts object claim or array of claims
            */
            function checkAccess(isAuthenticated, claims, claimsToCheck) {
                var isAllowed = true;

                if (!isAuthenticated)
                    return false;

                // If no claims to check then return TRUE otherwise check claims into his/her identity
                if (Object.prototype.toString.call(claimsToCheck) === '[object Array]') {

                    for (var i = 0; i < claimsToCheck.length; i++) {
                        // Search claims
                        isAllowed = checkClaims(claims, claimsToCheck[i]['type'], claimsToCheck[i]['value']);
                        if (!isAllowed)
                            break;
                    }

                    return isAllowed;
                } else if (typeof claimsToCheck === 'object') {
                    isAllowed = checkClaims(claims, claimsToCheck['type'], claimsToCheck['value']);
                    return isAllowed;
                }

                return true;
            }

            // ----------------
            // Helper methods
            // ----------------
            function checkClaims(claims, claimType, claimValue) {
                var results = _.filter(claims, function(o) {
                    return o.type === claimType && o.value === claimValue.toString(); 
                });
                
                return (results.length > 0);
            }
            
            function parseJwt (token) {
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace('-', '+').replace('_', '/');
                return JSON.parse($window.atob(base64));
            }
     
        };   
    })();
    
   
(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('businessesService', businessesService);

    /** @ngInject */
    function businessesService(
        tenantsApi) {

        var service = {
            getBusinesses: getBusinesses,
            getBusiness: getBusiness,
            getPayrollCompany: getPayrollCompany
        };

        return service;

        function getBusinesses() {
            return tenantsApi.getBusinesses();
        }

        function getBusiness(id) {
            return tenantsApi.getBusiness(id);
        }

        function getPayrollCompany() {
            return tenantsApi.getPayrollCompany();
        }
    }
})();
/**
 * AuthorizationInterceptor
 * Alloc8
 * by rcnet 6.18.2016
 *
 * Recover session if Token expire from the server
 * It resolves server issue for 401 and 403 status code
 * Unauthorized - is when the user does not login in to the system or no account yet but trying to access the page or resource
 * Forbidden - is when user has an login access but no permission on the specified resource or page.
 *
 * Changes
 *
 * EH 12.04.2017 RCNET Added detection and handler for multi-refresh token request.
 */
(function() {
    'use strict';

    angular.module('app.corelib')
        .factory('authorizationInterceptor', authorizationInterceptor);

    /** @ngInject */
    function authorizationInterceptor(
        $q,
        $rootScope,
        $location,
        $injector,
        $log,
        blockUI
    ) {
        var service = {
            response: response,
            responseError: responseError,
            isFetchingRefreshToken: false
        };

        // Refresh token Http Promise (tracking inFlight auth request)
        var inFlightAuthRequest = null;

        return service;

        function response(response) {
            if (response.config.skipInterceptor) {
                return response || $q.when(response);
            }

            if (response.status === 401 || response.status === 403) {
                $log.debug("Response " + response.status);
            }

            return response || $q.when(response);
        }

        function responseError(rejection) {
            switch (rejection.status) {
                case 401:
                    var deferred = $q.defer();
                    if (!inFlightAuthRequest) {
                        // Broadcast event then send deferred object
                        $log.debug('Resolving access issues, trying to perform RT...');
                        inFlightAuthRequest = $q.defer();
                        $rootScope.$broadcast('identityService:invokeRefreshAccount', inFlightAuthRequest);
                    }

                    inFlightAuthRequest.promise.then(function(resp) {
                        inFlightAuthRequest = null;

                        if (resp.token && resp.refreshToken) {
                            rejection.config.headers["Authorization"] = `Bearer ${resp.token}`;

                            // Replay http request (note: this can have multiple pending request just waiting for RT)
                            $injector.get('$http')(rejection.config).then(function(r) {
                                deferred.resolve(r);
                            }, function(ex) {
                                deferred.reject(ex);
                            });
                        } else {
                            deferred.reject('Invalid refresh token or access token returned.');
                        }

                    }).catch(function(ex) {
                        inFlightAuthRequest = null;
                        blockUI.stop();
                        $rootScope.$broadcast('loginService:logout');
                        return;
                    });

                    return deferred.promise;

                case 403:
                    if (rejection.config && rejection.config.skipForbiddenRedirect) {
                        return $q.reject(rejection);
                    }

                    $injector.get('$state').go('app.pages_errors_error-403', {
                        returnUrl: encodeURIComponent($location.path())
                    });
                    return;
            }

            return $q.reject(rejection);
        }
    };

})();

/**
 * AngularUI - The companion suite for AngularJS
 * @version v0.4.0 - 2013-02-15
 * @link http://angular-ui.github.com
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
angular.module("ui.config",[]).value("ui.config",{}),angular.module("ui.filters",["ui.config"]),angular.module("ui.directives",["ui.config"]),angular.module("ui",["ui.filters","ui.directives","ui.config"]),angular.module("ui.directives").directive("uiAnimate",["ui.config","$timeout",function(e,t){var n={};return angular.isString(e.animate)?n["class"]=e.animate:e.animate&&(n=e.animate),{restrict:"A",link:function(e,r,i){var s={};i.uiAnimate&&(s=e.$eval(i.uiAnimate),angular.isString(s)&&(s={"class":s})),s=angular.extend({"class":"ui-animate"},n,s),r.addClass(s["class"]),t(function(){r.removeClass(s["class"])},20,!1)}}}]),angular.module("ui.directives").directive("uiCalendar",["ui.config","$parse",function(e,t){return e.uiCalendar=e.uiCalendar||{},{require:"ngModel",restrict:"A",link:function(t,n,r,i){function a(){t.calendar=n.html("");var i=t.calendar.fullCalendar("getView");i&&(i=i.name);var o,u={defaultView:i,eventSources:s};r.uiCalendar?o=t.$eval(r.uiCalendar):o={},angular.extend(u,e.uiCalendar,o),t.calendar.fullCalendar(u)}var s=t.$eval(r.ngModel),o=0,u=function(){var e=t.$eval(r.equalsTracker);return o=0,angular.forEach(s,function(e,t){angular.isArray(e)&&(o+=e.length)}),angular.isNumber(e)?o+s.length+e:o+s.length};a(),t.$watch(u,function(e,t){a()})}}}]),angular.module("ui.directives").directive("uiCodemirror",["ui.config","$timeout",function(e,t){"use strict";var n=["cursorActivity","viewportChange","gutterClick","focus","blur","scroll","update"];return{restrict:"A",require:"ngModel",link:function(r,i,s,o){var u,a,f,l,c;if(i[0].type!=="textarea")throw new Error("uiCodemirror3 can only be applied to a textarea element");u=e.codemirror||{},a=angular.extend({},u,r.$eval(s.uiCodemirror)),f=function(e){return function(t,n){var i=t.getValue();i!==o.$viewValue&&(o.$setViewValue(i),r.$apply()),typeof e=="function"&&e(t,n)}},l=function(){c=CodeMirror.fromTextArea(i[0],a),c.on("change",f(a.onChange));for(var e=0,u=n.length,l;e<u;++e){l=a["on"+n[e].charAt(0).toUpperCase()+n[e].slice(1)];if(l===void 0)continue;if(typeof l!="function")continue;c.on(n[e],l)}o.$formatters.push(function(e){if(angular.isUndefined(e)||e===null)return"";if(angular.isObject(e)||angular.isArray(e))throw new Error("ui-codemirror cannot use an object or an array as a model");return e}),o.$render=function(){c.setValue(o.$viewValue)},s.uiRefresh&&r.$watch(s.uiRefresh,function(e,n){e!==n&&t(c.refresh)})},t(l)}}}]),angular.module("ui.directives").directive("uiCurrency",["ui.config","currencyFilter",function(e,t){var n={pos:"ui-currency-pos",neg:"ui-currency-neg",zero:"ui-currency-zero"};return e.currency&&angular.extend(n,e.currency),{restrict:"EAC",require:"ngModel",link:function(e,r,i,s){var o,u,a;o=angular.extend({},n,e.$eval(i.uiCurrency)),u=function(e){var n;return n=e*1,r.toggleClass(o.pos,n>0),r.toggleClass(o.neg,n<0),r.toggleClass(o.zero,n===0),e===""?r.text(""):r.text(t(n,o.symbol)),!0},s.$render=function(){a=s.$viewValue,r.val(a),u(a)}}}}]),angular.module("ui.directives").directive("uiDate",["ui.config",function(e){"use strict";var t;return t={},angular.isObject(e.date)&&angular.extend(t,e.date),{require:"?ngModel",link:function(t,n,r,i){var s=function(){return angular.extend({},e.date,t.$eval(r.uiDate))},o=function(){var e=s();if(i){var r=function(){t.$apply(function(){var e=n.datepicker("getDate");n.datepicker("setDate",n.val()),i.$setViewValue(e),n.blur()})};if(e.onSelect){var o=e.onSelect;e.onSelect=function(e,n){r(),t.$apply(function(){o(e,n)})}}else e.onSelect=r;n.bind("change",r),i.$render=function(){var e=i.$viewValue;if(angular.isDefined(e)&&e!==null&&!angular.isDate(e))throw new Error("ng-Model value must be a Date object - currently it is a "+typeof e+" - use ui-date-format to convert it from a string");n.datepicker("setDate",e)}}n.datepicker("destroy"),n.datepicker(e),i&&i.$render()};t.$watch(s,o,!0)}}}]).directive("uiDateFormat",["ui.config",function(e){var t={require:"ngModel",link:function(t,n,r,i){var s=r.uiDateFormat||e.dateFormat;s?(i.$formatters.push(function(e){if(angular.isString(e))return $.datepicker.parseDate(s,e)}),i.$parsers.push(function(e){if(e)return $.datepicker.formatDate(s,e)})):(i.$formatters.push(function(e){if(angular.isString(e))return new Date(e)}),i.$parsers.push(function(e){if(e)return e.toISOString()}))}};return t}]),angular.module("ui.directives").directive("uiEvent",["$parse",function(e){return function(t,n,r){var i=t.$eval(r.uiEvent);angular.forEach(i,function(r,i){var s=e(r);n.bind(i,function(e){var n=Array.prototype.slice.call(arguments);n=n.splice(1),t.$apply(function(){s(t,{$event:e,$params:n})})})})}}]),angular.module("ui.directives").directive("uiIf",[function(){return{transclude:"element",priority:1e3,terminal:!0,restrict:"A",compile:function(e,t,n){return function(e,t,r){var i,s;e.$watch(r.uiIf,function(r){i&&(i.remove(),i=undefined),s&&(s.$destroy(),s=undefined),r&&(s=e.$new(),n(s,function(e){i=e,t.after(e)}))})}}}}]),angular.module("ui.directives").directive("uiJq",["ui.config","$timeout",function(t,n){return{restrict:"A",compile:function(r,i){if(!angular.isFunction(r[i.uiJq]))throw new Error('ui-jq: The "'+i.uiJq+'" function does not exist');var s=t.jq&&t.jq[i.uiJq];return function(t,r,i){function u(){n(function(){r[i.uiJq].apply(r,o)},0,!1)}var o=[];i.uiOptions?(o=t.$eval("["+i.uiOptions+"]"),angular.isObject(s)&&angular.isObject(o[0])&&(o[0]=angular.extend({},s,o[0]))):s&&(o=[s]),i.ngModel&&r.is("select,input,textarea")&&r.on("change",function(){r.trigger("input")}),i.uiRefresh&&t.$watch(i.uiRefresh,function(e){u()}),u()}}}}]),angular.module("ui.directives").factory("keypressHelper",["$parse",function(t){var n={8:"backspace",9:"tab",13:"enter",27:"esc",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down",45:"insert",46:"delete"},r=function(e){return e.charAt(0).toUpperCase()+e.slice(1)};return function(e,i,s,o){var u,a=[];u=i.$eval(o["ui"+r(e)]),angular.forEach(u,function(e,n){var r,i;i=t(e),angular.forEach(n.split(" "),function(e){r={expression:i,keys:{}},angular.forEach(e.split("-"),function(e){r.keys[e]=!0}),a.push(r)})}),s.bind(e,function(t){var r=t.metaKey||t.altKey,s=t.ctrlKey,o=t.shiftKey,u=t.keyCode;e==="keypress"&&!o&&u>=97&&u<=122&&(u-=32),angular.forEach(a,function(e){var u=e.keys[n[t.keyCode]]||e.keys[t.keyCode.toString()]||!1,a=e.keys.alt||!1,f=e.keys.ctrl||!1,l=e.keys.shift||!1;u&&a==r&&f==s&&l==o&&i.$apply(function(){e.expression(i,{$event:t})})})})}}]),angular.module("ui.directives").directive("uiKeydown",["keypressHelper",function(e){return{link:function(t,n,r){e("keydown",t,n,r)}}}]),angular.module("ui.directives").directive("uiKeypress",["keypressHelper",function(e){return{link:function(t,n,r){e("keypress",t,n,r)}}}]),angular.module("ui.directives").directive("uiKeyup",["keypressHelper",function(e){return{link:function(t,n,r){e("keyup",t,n,r)}}}]),function(){function t(e,t,n,r){angular.forEach(t.split(" "),function(t){var i={type:"map-"+t};google.maps.event.addListener(n,t,function(t){r.triggerHandler(angular.extend({},i,t)),e.$$phase||e.$apply()})})}function n(n,r){e.directive(n,[function(){return{restrict:"A",link:function(e,i,s){e.$watch(s[n],function(n){t(e,r,n,i)})}}}])}var e=angular.module("ui.directives");e.directive("uiMap",["ui.config","$parse",function(e,n){var r="bounds_changed center_changed click dblclick drag dragend dragstart heading_changed idle maptypeid_changed mousemove mouseout mouseover projection_changed resize rightclick tilesloaded tilt_changed zoom_changed",i=e.map||{};return{restrict:"A",link:function(e,s,o){var u=angular.extend({},i,e.$eval(o.uiOptions)),a=new google.maps.Map(s[0],u),f=n(o.uiMap);f.assign(e,a),t(e,r,a,s)}}}]),e.directive("uiMapInfoWindow",["ui.config","$parse","$compile",function(e,n,r){var i="closeclick content_change domready position_changed zindex_changed",s=e.mapInfoWindow||{};return{link:function(e,o,u){var a=angular.extend({},s,e.$eval(u.uiOptions));a.content=o[0];var f=n(u.uiMapInfoWindow),l=f(e);l||(l=new google.maps.InfoWindow(a),f.assign(e,l)),t(e,i,l,o),o.replaceWith("<div></div>");var c=l.open;l.open=function(n,i,s,u,a,f){r(o.contents())(e),c.call(l,n,i,s,u,a,f)}}}}]),n("uiMapMarker","animation_changed click clickable_changed cursor_changed dblclick drag dragend draggable_changed dragstart flat_changed icon_changed mousedown mouseout mouseover mouseup position_changed rightclick shadow_changed shape_changed title_changed visible_changed zindex_changed"),n("uiMapPolyline","click dblclick mousedown mousemove mouseout mouseover mouseup rightclick"),n("uiMapPolygon","click dblclick mousedown mousemove mouseout mouseover mouseup rightclick"),n("uiMapRectangle","bounds_changed click dblclick mousedown mousemove mouseout mouseover mouseup rightclick"),n("uiMapCircle","center_changed click dblclick mousedown mousemove mouseout mouseover mouseup radius_changed rightclick"),n("uiMapGroundOverlay","click dblclick")}(),angular.module("ui.directives").directive("uiMask",[function(){return{require:"ngModel",link:function(e,t,n,r){r.$render=function(){var i=r.$viewValue||"";t.val(i),t.mask(e.$eval(n.uiMask))},r.$parsers.push(function(e){var n=t.isMaskValid()||angular.isUndefined(t.isMaskValid())&&t.val().length>0;return r.$setValidity("mask",n),n?e:undefined}),t.bind("keyup",function(){e.$apply(function(){r.$setViewValue(t.mask())})})}}}]),angular.module("ui.directives").directive("uiReset",["ui.config",function(e){var t=null;return e.reset!==undefined&&(t=e.reset),{require:"ngModel",link:function(e,n,r,i){var s;s=angular.element('<a class="ui-reset" />'),n.wrap('<span class="ui-resetwrap" />').after(s),s.bind("click",function(n){n.preventDefault(),e.$apply(function(){r.uiReset?i.$setViewValue(e.$eval(r.uiReset)):i.$setViewValue(t),i.$render()})})}}}]),angular.module("ui.directives").directive("uiRoute",["$location","$parse",function(e,t){return{restrict:"AC",compile:function(n,r){var i;if(r.uiRoute)i="uiRoute";else if(r.ngHref)i="ngHref";else{if(!r.href)throw new Error("uiRoute missing a route or href property on "+n[0]);i="href"}return function(n,r,s){function a(t){(hash=t.indexOf("#"))>-1&&(t=t.substr(hash+1)),u=function(){o(n,e.path().indexOf(t)>-1)},u()}function f(t){(hash=t.indexOf("#"))>-1&&(t=t.substr(hash+1)),u=function(){var i=new RegExp("^"+t+"$",["i"]);o(n,i.test(e.path()))},u()}var o=t(s.ngModel||s.routeModel||"$uiRoute").assign,u=angular.noop;switch(i){case"uiRoute":s.uiRoute?f(s.uiRoute):s.$observe("uiRoute",f);break;case"ngHref":s.ngHref?a(s.ngHref):s.$observe("ngHref",a);break;case"href":a(s.href)}n.$on("$routeChangeSuccess",function(){u()})}}}}]),angular.module("ui.directives").directive("uiScrollfix",["$window",function(e){"use strict";return{link:function(t,n,r){var i=n.offset().top;r.uiScrollfix?r.uiScrollfix.charAt(0)==="-"?r.uiScrollfix=i-r.uiScrollfix.substr(1):r.uiScrollfix.charAt(0)==="+"&&(r.uiScrollfix=i+parseFloat(r.uiScrollfix.substr(1))):r.uiScrollfix=i,angular.element(e).on("scroll.ui-scrollfix",function(){var t;if(angular.isDefined(e.pageYOffset))t=e.pageYOffset;else{var i=document.compatMode&&document.compatMode!=="BackCompat"?document.documentElement:document.body;t=i.scrollTop}!n.hasClass("ui-scrollfix")&&t>r.uiScrollfix?n.addClass("ui-scrollfix"):n.hasClass("ui-scrollfix")&&t<r.uiScrollfix&&n.removeClass("ui-scrollfix")})}}}]),angular.module("ui.directives").directive("uiSelect2",["ui.config","$timeout",function(e,t){var n={};return e.select2&&angular.extend(n,e.select2),{require:"?ngModel",compile:function(e,r){var i,s,o,u=e.is("select"),a=r.multiple!==undefined;return e.is("select")&&(s=e.find("option[ng-repeat], option[data-ng-repeat]"),s.length&&(o=s.attr("ng-repeat")||s.attr("data-ng-repeat"),i=jQuery.trim(o.split("|")[0]).split(" ").pop())),function(e,r,s,o){var f=angular.extend({},n,e.$eval(s.uiSelect2));u?(delete f.multiple,delete f.initSelection):a&&(f.multiple=!0);if(o){o.$render=function(){u?r.select2("val",o.$modelValue):a?o.$modelValue?angular.isArray(o.$modelValue)?r.select2("data",o.$modelValue):r.select2("val",o.$modelValue):r.select2("data",[]):angular.isObject(o.$modelValue)?r.select2("data",o.$modelValue):r.select2("val",o.$modelValue)},i&&e.$watch(i,function(e,n,i){if(!e)return;t(function(){r.select2("val",o.$viewValue),r.trigger("change")})});if(!u){r.bind("change",function(){e.$apply(function(){o.$setViewValue(r.select2("data"))})});if(f.initSelection){var l=f.initSelection;f.initSelection=function(e,t){l(e,function(e){o.$setViewValue(e),t(e)})}}}}s.$observe("disabled",function(e){r.select2(e&&"disable"||"enable")}),s.ngMultiple&&e.$watch(s.ngMultiple,function(e){r.select2(f)}),r.val(e.$eval(s.ngModel)),t(function(){r.select2(f),!f.initSelection&&!u&&o.$setViewValue(r.select2("data"))})}}}}]),angular.module("ui.directives").directive("uiShow",[function(){return function(e,t,n){e.$watch(n.uiShow,function(e,n){e?t.addClass("ui-show"):t.removeClass("ui-show")})}}]).directive("uiHide",[function(){return function(e,t,n){e.$watch(n.uiHide,function(e,n){e?t.addClass("ui-hide"):t.removeClass("ui-hide")})}}]).directive("uiToggle",[function(){return function(e,t,n){e.$watch(n.uiToggle,function(e,n){e?t.removeClass("ui-hide").addClass("ui-show"):t.removeClass("ui-show").addClass("ui-hide")})}}]),angular.module("ui.directives").directive("uiSortable",["ui.config",function(e){return{require:"?ngModel",link:function(t,n,r,i){var s,o,u,a,f,l,c,h,p;f=angular.extend({},e.sortable,t.$eval(r.uiSortable)),i&&(i.$render=function(){n.sortable("refresh")},u=function(e,t){t.item.sortable={index:t.item.index()}},a=function(e,t){t.item.sortable.resort=i},s=function(e,t){t.item.sortable.relocate=!0,i.$modelValue.splice(t.item.index(),0,t.item.sortable.moved)},o=function(e,t){i.$modelValue.length===1?t.item.sortable.moved=i.$modelValue.splice(0,1)[0]:t.item.sortable.moved=i.$modelValue.splice(t.item.sortable.index,1)[0]},onStop=function(e,n){if(n.item.sortable.resort&&!n.item.sortable.relocate){var r,i;i=n.item.sortable.index,r=n.item.index(),i<r&&r--,n.item.sortable.resort.$modelValue.splice(r,0,n.item.sortable.resort.$modelValue.splice(i,1)[0])}(n.item.sortable.resort||n.item.sortable.relocate)&&t.$apply()},h=f.start,f.start=function(e,t){u(e,t),typeof h=="function"&&h(e,t)},_stop=f.stop,f.stop=function(e,t){onStop(e,t),typeof _stop=="function"&&_stop(e,t)},p=f.update,f.update=function(e,t){a(e,t),typeof p=="function"&&p(e,t)},l=f.receive,f.receive=function(e,t){s(e,t),typeof l=="function"&&l(e,t)},c=f.remove,f.remove=function(e,t){o(e,t),typeof c=="function"&&c(e,t)}),n.sortable(f)}}}]),angular.module("ui.directives").directive("uiTinymce",["ui.config",function(e){return e.tinymce=e.tinymce||{},{require:"ngModel",link:function(t,n,r,i){var s,o={onchange_callback:function(e){e.isDirty()&&(e.save(),i.$setViewValue(n.val()),t.$$phase||t.$apply())},handle_event_callback:function(e){return this.isDirty()&&(this.save(),i.$setViewValue(n.val()),t.$$phase||t.$apply()),!0},setup:function(e){e.onSetContent.add(function(e,r){e.isDirty()&&(e.save(),i.$setViewValue(n.val()),t.$$phase||t.$apply())})}};r.uiTinymce?s=t.$eval(r.uiTinymce):s={},angular.extend(o,e.tinymce,s),setTimeout(function(){n.tinymce(o)})}}}]),angular.module("ui.directives").directive("uiValidate",function(){return{restrict:"A",require:"ngModel",link:function(e,t,n,r){var i,s,o={},u=e.$eval(n.uiValidate);if(!u)return;angular.isString(u)&&(u={validator:u}),angular.forEach(u,function(t,n){i=function(i){return e.$eval(t,{$value:i})?(r.$setValidity(n,!0),i):(r.$setValidity(n,!1),undefined)},o[n]=i,r.$formatters.push(i),r.$parsers.push(i)}),n.uiValidateWatch&&(s=e.$eval(n.uiValidateWatch),angular.isString(s)?e.$watch(s,function(){angular.forEach(o,function(e,t){e(r.$modelValue)})}):angular.forEach(s,function(t,n){e.$watch(t,function(){o[n](r.$modelValue)})}))}}}),angular.module("ui.filters").filter("format",function(){return function(e,t){if(!e)return e;var n=e.toString(),r;return t===undefined?n:!angular.isArray(t)&&!angular.isObject(t)?n.split("$0").join(t):(r=angular.isArray(t)&&"$"||":",angular.forEach(t,function(e,t){n=n.split(r+t).join(e)}),n)}}),angular.module("ui.filters").filter("highlight",function(){return function(e,t,n){return t||angular.isNumber(t)?(e=e.toString(),t=t.toString(),n?e.split(t).join('<span class="ui-match">'+t+"</span>"):e.replace(new RegExp(t,"gi"),'<span class="ui-match">$&</span>')):e}}),angular.module("ui.filters").filter("inflector",function(){function e(e){return e.replace(/^([a-z])|\s+([a-z])/g,function(e){return e.toUpperCase()})}function t(e,t){return e.replace(/[A-Z]/g,function(e){return t+e})}var n={humanize:function(n){return e(t(n," ").split("_").join(" "))},underscore:function(e){return e.substr(0,1).toLowerCase()+t(e.substr(1),"_").toLowerCase().split(" ").join("_")},variable:function(t){return t=t.substr(0,1).toLowerCase()+e(t.split("_").join(" ")).substr(1).split(" ").join(""),t}};return function(e,t,r){return t!==!1&&angular.isString(e)?(t=t||"humanize",n[t](e)):e}}),angular.module("ui.filters").filter("unique",function(){return function(e,t){if(t===!1)return e;if((t||angular.isUndefined(t))&&angular.isArray(e)){var n={},r=[],i=function(e){return angular.isObject(e)&&angular.isString(t)?e[t]:e};angular.forEach(e,function(e){var t,n=!1;for(var s=0;s<r.length;s++)if(angular.equals(i(r[s]),i(e))){n=!0;break}n||r.push(e)}),e=r}return e}});

/**
 * Created by Ben Rei on 8/25/2016.
 */
(function () {
  'use strict';

  angular.module('app.corelib')
    .service('ToastService', ToastService);

  /** @ngInject */
  function ToastService($mdToast) {
    var self = this;

    self.last = {
      bottom: true,
      top: false,
      left: false,
      right: true
    };

    self.toastPosition = angular.extend({},self.last);

    var service = {
      toast: toastMe
    };

    return service;

    function toastMe(message,delay){
      if(!delay){
        delay = 3000;
      }
      var pinTo = getToastPosition();
      return $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position(pinTo )
          .hideDelay(delay)
      );
    }

    function getToastPosition() {
      sanitizePosition();
      return Object.keys(self.toastPosition)
        .filter(function(pos) { return self.toastPosition[pos]; })
        .join(' ');
    };

    function sanitizePosition() {
      var current = self.toastPosition;
      if (current.bottom && self.last.top) current.top = false;
      if (current.top && self.last.bottom) current.bottom = false;
      if (current.right && self.last.left) current.left = false;
      if (current.left && self.last.right) current.right = false;
      self.last = angular.extend({}, current);
    };
  }
})();

(function() {
    'use strict';

    angular.module('app.navigation')
        .factory('pageHistoryService', pageHistoryService);

    /** @ngInject */
    function pageHistoryService(
        _,
        utils,
        pageHistoryApi,
        historyItemModel,
        msNavigationService,
        $injector,
        identityService,
        exceptionService) {

        var self = this;

        var service = {
            pageHistoryList: [],
            fetchPageHistory: fetchPageHistory,
            updateHistory: updateHistory,
            setHistorySize: setHistorySize,
            saveHistory: saveHistory,
            navigate: navigate,
            clearHistoryCache: clearHistoryCache
        };

        self.historySize = 5;

        return service;

        function navigate(id) {
            var stateProvider = $injector.get('$state');

            if (angular.isDefined(id)) {
                var historyItem = _.filter(service.pageHistoryList, function(o) {
                    return o.Id === id;
                });

                if (!utils.isUndefinedOrNull(historyItem) && historyItem.length > 0) {
                    stateProvider.go(historyItem[0].State, historyItem[0].Params);
                }
            }
        }

        function navigate(id) {
            var stateProvider = $injector.get('$state');

            if (angular.isDefined(id)) {
                var historyItem = _.filter(service.pageHistoryList, function(o) {
                    return o.Id === id;
                });

                if (!utils.isUndefinedOrNull(historyItem) && historyItem.length > 0) {
                    stateProvider.go(historyItem[0].State, historyItem[0].Params);
                }
            }
        }

        function fetchPageHistory() {
            var id = identityService.userData.ContactId;
            pageHistoryApi.getAll(id, self.historySize)
                .then(function(resp) {
                    var sortArr = _.sortBy(resp.data, ['Position']);
                    limit(sortArr);
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex, {
                        intercept500: function(e, status) {}
                    });
                });
        }

        function updateHistory(state, parameters) {
            if (state.name === 'app.pages_auth_login-v2' ||
                state.name === 'app.pages_errors_error-403' ||
                state.name === 'app.pages.error-unhandled' ||
                state.name === 'app.pages_auth_forgot-password')
                return;

            var title = getNavTitle(state.name);

            if (_.isNil(title) || title == "") {
                return;
            }

            var item = {
                Title: title,
                State: state.name,
                Url: state.url,
                Position: 0,
                Params: parameters
            };

            var numberOfMatches = _.filter(service.pageHistoryList, function(o) {
                    return o.Title === updateTitle(new historyItemModel(item))
                })
                .length;

            var filterPagehistory = [];
            if (numberOfMatches > 0) {
                filterPagehistory = _.filter(service.pageHistoryList, function(o) {
                    return o.Title != updateTitle(new historyItemModel(item))
                })
                service.pageHistoryList = filterPagehistory;
            }

            for (var i = 0; i < service.pageHistoryList.length; i++) {
                var currentItm = service.pageHistoryList[i];
                currentItm.Position = i + 1;
            }

            service.pageHistoryList.unshift(new historyItemModel(item));
            limit(service.pageHistoryList);
        }

        function saveHistory() {
            var promise = null;
            var data = angular.fromJson(angular.toJson(service.pageHistoryList));

            if (data) {
                var id = identityService.userData.ContactId;

                promise = pageHistoryApi.saveHistory(id, data)
                    .then(function(resp) {})
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }

            return promise;
        }

        function clearHistoryCache() {
            service.pageHistoryList.length = 0;
        }

        function limit(sourceArr) {
            var newList = _.slice(sourceArr, 0, self.historySize);
            rePopulate(newList);
        }

        function setHistorySize(size) {
            self.historySize = size;
        }

        function rePopulate(items) {
            if (items.length > 0) {
                service.pageHistoryList.length = 0
                angular.forEach(items, function(itm) {
                    var hist = new historyItemModel(itm);
                    if (hist.Params !== null) {
                        hist.Title = updateTitle(hist);
                    }
                    service.pageHistoryList.push(hist);
                }, this);
            }
        }

        function updateTitle(obj) {
            if (obj.Title === 'Timesheet') {
                return _.isNil(obj.Params.TicketNo) ? obj.Title : obj.Params.TicketNo + ' - ' + obj.Title;
            }

            if (obj.Title === 'Ticket Update') {
                let ticketNum = obj.Params.parentTicketNo != null ? obj.Params.parentTicketNo : obj.Params.ticketNumber;
                return ticketNum + ' - ' + obj.Title;
            }

            if (obj.Title === "Allocate Resource") {
                let ticketNum = obj.Params.parentTicketNo != null ? obj.Params.parentTicketNo : obj.Params.ticketNo;
                return ticketNum + ' - ' + obj.Title;
            }

            if (obj.Title === "Update Contact") {
                return obj.Params.cname + ' - ' + obj.Title;
            }

            if (obj.Title === "Update Company") {
                return obj.Params.cname + ' - ' + obj.Title;
            }

            if (obj.Title === "Item Update") {
                return obj.Params.itemName + ' - ' + obj.Title;
            }

            if (obj.Title === "Update Branch") {
                return obj.Params.branch + ' - ' + obj.Title;
            }

            return obj.Title;
        }

        function getNavTitle(stateName) {
            var parentMenu = msNavigationService.getNavigation()[0];
            var isFound = false;
            var title = '';

            angular.forEach(parentMenu.children, function(child) {
                if (!isFound) {
                    if (child.state === stateName) {
                        title = child.title;
                        isFound = true;
                    }

                    angular.forEach(child.children, function(childOfChild) {
                        if (childOfChild.state === stateName) {
                            title = childOfChild.title;
                            isFound = true;
                        }
                    });
                }
            }, this);

            if (!isFound) {
                var stateProvider = $injector.get('$state');
                var routerList = stateProvider.get();

                var routeItem = _.filter(routerList, function(o) {
                    return o.name === stateName;
                });

                if (angular.isDefined(routeItem) && routeItem.length > 0) {
                    title = routeItem[0].hasOwnProperty('title') ?
                        routeItem[0].title :
                        routeItem[0].name;
                }
            }

            return title;
        }
    }
})();

  /**
   *  History Item Model
  */
(function(){
   'use strict';
   
   angular.module('app.navigation')
          .service('historyItemModel', historyItemModel)
 
   /** @ngInject */
   function historyItemModel(utils) {
       
       return function(options){
          defaults = {
             Id: utils.newGuid(),
             Title: '',
             Url: '',
             State: null,
             Position: 0,
             Params: null
          };
        
         this.map = mapper; 
         this.map(options);
         
         ///////
         
         function mapper (optionBag) {
            var mapValue = optionBag || angular.copy(defaults);
            var opts = angular.extend({}, defaults, mapValue);
            
            this.Id = opts.Id;
            this.Title = opts.Title;
            this.Url = opts.Url;
            this.State = opts.State;
            this.Position = opts.Position;
            this.Params = opts.Params;
            
            return this; 
         }
       };
   };
   
})();
/**
 * Created by queenie maniquis on 12/20/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.webhooks', [])
        .config(config);

    /** @ngInject */
    function config ($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.webhooks', {
                url: '/webhooks'
                , views: {
                    'content@app': {
                        templateUrl: 'app/main/webhooks/webhooks.html'
                        , controller: 'WebhooksController as webhook'
                    }
                }
                , data: {
                    requireLogin: true
                }
                , title: 'Manage Webhooks'
                , titleBar: 'Alloc8 - Webhooks'
            });

        $translatePartialLoaderProvider.addPart('app/main/webhooks');
    }
})();

(function () {
    'use strict';

    angular.module('app.webhooks')
        .factory('webhooksService', webhooksService);

    function webhooksService(
        blockUI,
        utils,
        $q,
        hubService,
        webhooksApi,
        _) {

        let self = this;
        self.service = {};

        self.service.init = function () {
            self.service.modules = [
                {
                    "Module": 0,
                    "ModuleName": "Contacts",
                    "EntityTypes" : [
                        { "Id": "1", "Name": "Employee" },
                        { "Id": "2", "Name": "Client" },
                        { "Id": "3", "Name": "Labour Hire" },
                        { "Id": "4", "Name": "External" },
                        { "Id": "5", "Name": "Supplier" },
                        { "Id": "6", "Name": "Lead" },
                        { "Id": "7", "Name": "Competitor" }
                    ],
                    "isSameEndpoint": false,
                    "EndpointUrls":[
                        {
                            "Id":0,
                            "Name":"Create",
                            "Url":""
                        },{
                            "Id":1,
                            "Name":"Update",
                            "Url":""
                        },{
                            "Id":2,
                            "Name":"Archive",
                            "Url":""
                        },{
                            "Id":3,
                            "Name":"Unarchive",
                            "Url":""
                        }
                    ]
                },
                {
                    "Module": 1,
                    "ModuleName": "Companies",
                    "EntityTypes" : [
                        { "Id": "1", "Name": "Client" },
                        { "Id": "2", "Name": "Supplier" },
                        { "Id": "3", "Name": "Lead" },
                        { "Id": "4", "Name": "Competitor" },
                        { "Id": "5", "Name": "Employer" },
                        { "Id": "6", "Name": "Prospect" }
                    ],
                    "isSameEndpoint": false,
                    "EndpointUrls":[
                        {
                            "Id":0,
                            "Name":"Create",
                            "Url":""
                        },{
                            "Id":1,
                            "Name":"Update",
                            "Url":""
                        },{
                            "Id":2,
                            "Name":"Archive",
                            "Url":""
                        },{
                            "Id":3,
                            "Name":"Unarchive",
                            "Url":""
                        }
                    ]
                },
                {
                    "Module": 2,
                    "ModuleName": "Equipments",
                    "EntityTypes" : [
                        { "Id": "1", "Name": "Asset" },
                        { "Id": "2", "Name": "Inventory" },
                        { "Id": "3", "Name": "Rental" },
                        { "Id": "4", "Name": "People" },
                        { "Id": "5", "Name": "Vehicle" }
                    ],
                    "isSameEndpoint": false,
                    "EndpointUrls":[
                        {
                            "Id":0,
                            "Name":"Create",
                            "Url":""
                        },{
                            "Id":1,
                            "Name":"Update Active",
                            "Url":""
                        },{
                            "Id":2,
                            "Name":"Update Not in Service",
                            "Url":""
                        }
                    ]
                },
                {
                    "Module": 3,
                    "ModuleName": "Tickets",
                    "isSameEndpoint": false,
                    "EndpointUrls":[
                        {
                            "Id":0,
                            "Name":"Create",
                            "Url":""
                        },{
                            "Id":1,
                            "Name":"Update",
                            "Url":""
                        },{
                            "Id":2,
                            "Name":"Cancel",
                            "Url":""
                        }
                    ]
                },
                {
                    "Module": 4,
                    "ModuleName": "Allocated Resource Items",
                    "isSameEndpoint": false,
                    "EndpointUrls":[
                        {
                            "Id":0,
                            "Name":"Create",
                            "Url":""
                        },{
                            "Id":1,
                            "Name":"Update",
                            "Url":""
                        },{
                            "Id":2,
                            "Name":"Change Shift Times",
                            "Url":""
                        },{
                            "Id":3,
                            "Name":"Unallocate",
                            "Url":""
                        },{
                            "Id":4,
                            "Name":"Allocate",
                            "Url":""
                        },{
                            "Id":5,
                            "Name":"Delete",
                            "Url":""
                        }
                    ]
                },
                {
                    "Module": 5,
                    "ModuleName": "Timesheets",
                    "isSameEndpoint": false ,
                    "EndpointUrls":[
                        {
                            "Id":0,
                            "Name":"Create",
                            "Url":""
                        },{
                            "Id":1,
                            "Name":"Update",
                            "Url":""
                        }
                    ]
                },
                {
                    "Module": 6,
                    "ModuleName": "Payroll Export",
                    "isSameEndpoint": false,
                    "EndpointUrls":[
                        {
                            "Id":0,
                            "Name":"Export",
                            "Url":""
                        }
                    ]
                },
                {
                    "Module": 7,
                    "ModuleName": "Invoice Export",
                    "isSameEndpoint": false,
                    "EndpointUrls":[
                        {
                            "Id":0,
                            "Name":"Export",
                            "Url":""
                        }
                    ]
                }
            ];
        };

        self.service.getWebhooks = function() {
            let deferred = $q.defer();

            webhooksApi.getWebhooks().then(function (resp) {
                self.service.data = resp.data;
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateWebhooks = function(params) {
            let deferred = $q.defer();

            webhooksApi.putWebhooks(params).then(function (resp) {
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        return self.service;
    }
})();

/**
 * Created by queeniejgm on 12/20/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.webhooks')
        .controller('WebhooksController', WebhooksController);

    function WebhooksController (utils, blockUI, hubService, exceptionService, webhooksService) {
        let self = this;

        let formData = [];

        init();

        function init() {
            self.isLoading = true;
            webhooksService.init();
            self.moduleEnums = webhooksService.modules;
            formData = self.moduleEnums;
            webhooksService.getWebhooks().then(function (resp){
                self.data = resp.data;
                formatData();
            });
        }

        function formatData() {
            self.moduleEnums = _.map(self.moduleEnums, function(module) {
                if (_.isNil(self.data)) {
                    return;
                }
                let savedModuleIndex = _.findIndex(self.data.ModuleHookSettings, ['Module', module.Module]);
                module.EndpointUrls =  _.map(module.EndpointUrls, function(endpoint){
                    if (!_.isNil(self.data.ModuleHookSettings[savedModuleIndex])) {
                        let savedEndpoint = _.find(self.data.ModuleHookSettings[savedModuleIndex].EndpointUrls, ['Id', endpoint.Id]);
                        endpoint.Url = !_.isNil(savedEndpoint) ? savedEndpoint.Url : "";
                    }

                    return endpoint;
                });

                return module;
            });

            formData = self.moduleEnums;
            self.isLoading = false;
        }

        self.getModuleIndex = function(moduleId) {
            return !_.isNil(self.data) ? _.findIndex(self.data.ModuleHookSettings, ["Module",  moduleId]) : null;
        };

        self.getEndpointUrlIndex = function(endpointId, moduleId) {
            return !_.isNil(self.data.ModuleHookSettings[moduleId]) ? _.findIndex(self.data.ModuleHookSettings[moduleId].EndpointUrls, ["Id",  endpointId]) : null;
        };

        self.isEntitySelected = function(entityId, moduleId) {
            return !_.isNil(self.data.ModuleHookSettings[moduleId]) ?
                _.findIndex(self.data.ModuleHookSettings[moduleId].EntityTypes, function(entity) { return _.toString(entity.Id) === _.toString(entityId); }) >= 0 : false;
        };

        self.saveWebhooks = function() {
            blockUI.start();
            blockUI.message("Saving...");
            let params = formatParameters();

            webhooksService.updateWebhooks(params).then(function (resp){
                hubService.showToast(utils.translate('WEBHOOKS.MESSAGE_WEBHOOKS_SAVED'));
                self.moduleEnums = formData;
                blockUI.stop();
                init();
            }, function(err){
                exceptionService.resolve(err);
            });
        };

        function formatParameters() {
            _.map(formData, function(module) {
                module.EntityTypes = _.filter(module.EntityTypes, function(entity) { return _.includes(module.formEntityTypes, entity.Id); });
                if (module.isSameEndpoint) {
                    module.EndpointUrls = _.each(module.EndpointUrls, function(endpoint) { endpoint.Url = module.commonUrl; return endpoint; });
                }
                _.unset(module, 'formEntityTypes');
                _.unset(module, 'isSameEndpoint');
                _.unset(module, 'commonUrl');
                return module;
            });

            return {
                Id: self.data.Id,
                SecretKey: self.data.SecretKey,
                TechnicalContactEmail: self.data.TechnicalContactEmail,
                ModuleHookSettings: formData
            };
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.tax')
    .factory('taxService', taxService);

  /** @ngInject */
  function taxService(
    exceptionService,
    companyApi,
    hubService,
    taxApi,
    lookupApi,
    $q,
    blockUI) {

    var service = {
      loader : false,
      loaderMessage : null,
      getAllTax: getAllTax,
      getTaxLookups: getTaxLookups,
      getTax: getTax,
      deleteTaxRate: deleteTaxRate,
      getNonTaxExemptCompanies: getNonTaxExemptCompanies,
      getTaxExemptCompanies: getTaxExemptCompanies,
      addTaxExemptCompany: addTaxExemptCompany,
      removeTaxExemptCompany: removeTaxExemptCompany,
    };

    return service;

    function getTaxLookups() {
      var deferred = $q.defer();
      lookupApi
          .getTaxLookups()
          .then(function(resp) {
              deferred.resolve(resp)
          })
          .catch(function(ex) {
              deferred.reject(ex);
          });
      return deferred.promise;
    }

    function getTax(id)
    {
      var deferred = $q.defer();
      taxApi
          .get(id)
          .then(function(resp) {
              deferred.resolve(resp)
          })
          .catch(function(ex) {
              exceptionService.resolve(ex);
              deferred.reject(ex);
          });
      return deferred.promise;
    }

    async function getAllTax(includeDeleted = false) {

      try {
        service.loader = true;
        var taxes = (await taxApi.getAll(includeDeleted));

        service.loader = false;

        return taxes.data;

      } catch (ex) {
        service.loader = false;
        exceptionService.resolve(ex);
      }

    }
    
    async function deleteTaxRate(id) {
      try {
        blockUI.start({ message: 'Deleting Tax Rate...' });

        var hasUpdated = await taxApi.delete(id);

        blockUI.stop();

        await getAllTax(false);
        hubService.showToast('Tax Rate has been succesfully deleted.');

        return hasUpdated;
      } catch (ex) {
          blockUI.stop();
          exceptionService.resolve(ex);
      }
    }

    async function getNonTaxExemptCompanies() {
      try {
          service.loader = true;
          service.loaderMessage = "Loading Companies...";
          var companies = await companyApi.getNonTaxExemptCompanies();

          service.loader = false;

          return companies.data;
      } catch (ex) {
          service.loader = false;
          exceptionService.resolve(ex);
      }
    }

    async function getTaxExemptCompanies() {
      try {
          service.loader = true;
          service.loaderMessage = "Loading Companies...";
          var companies = await companyApi.getTaxExemptCompanies();

          service.loader = false;

          return companies.data;
      } catch (ex) {
          service.loader = false;
          exceptionService.resolve(ex);
      }
    }

    async function addTaxExemptCompany(companyId) {
      try {
        service.loader = true;
        service.loaderMessage = "Adding Tax Exempted Company... ";
        var hasUpdated = await companyApi.updateTaxExemptCompany(companyId, true);

        service.loader = false;
        service.loaderMessage = null;
        hubService.showToast('Company has been succesfully added to Tax Exempted Companies');

        return hasUpdated;
      } catch (ex) {
          service.loader = false;
          hubService.showToast('There was an error adding the Company from Tax Exempted Companies');
          exceptionService.resolve(ex);
      }
    }

    async function removeTaxExemptCompany(companyId) {
      try {
        service.loader = true;
        service.loaderMessage = "Removing Tax Exempted Company... ";
        var hasUpdated = await companyApi.updateTaxExemptCompany(companyId, false);

        service.loader = false;
        service.loaderMessage = null;
        hubService.showToast('Company has been succesfully removed from Tax Exempted Companies');

        return hasUpdated;
      } catch (ex) {
          service.loader = false;
          service.loaderMessage = null;
          hubService.showToast('There was an error removing the Company from Tax Exempted Companies');
          exceptionService.resolve(ex);
      }
    }

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tax')
    .controller('TaxController', TaxController);

  function TaxController(searchDelay, taxService, $mdDialog, $state, utils, historyLogService) {
    var vm = this;

    vm.model = {};
    vm.utilService = utils;
    vm.query = null;
    vm.searchTable = searchTable;
    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"lip><"clear">',
      pagingType: 'full_numbers',
      searchDelay: searchDelay,
      autoWidth: true,
      responsive: false
    };

    vm.dtTaxExemptCompanyOptions = {
      dom: '<"top"f>rt<"bottom"lip><"clear">',
      pagingType: 'full_numbers',
      searchDelay: searchDelay,
      autoWidth: true,
      responsive: false
    };

    vm.dtInstance = {};
    vm.dtTaxExemptCompanyInstance = {};
    
    vm.service = taxService;
    vm.createTaxRate = createTaxRate;
    vm.editTaxRate = editTaxRate;
    vm.querySearch = querySearch;
    vm.getTaxhistory = getTaxhistory;
    vm.getTaxeshistory = getTaxeshistory;
    vm.getAllTax = getAllTax;
    vm.deleteTaxRate = deleteTaxRate;
    vm.getNonTaxExemptCompanies = getNonTaxExemptCompanies;
    vm.addTaxExemptCompany = addTaxExemptCompany;
    vm.removeTaxExemptCompany = removeTaxExemptCompany;

    async function activate() {
      
      vm.nonTaxExemptCompanies = [];
      vm.taxExemptCompanies = [];
      vm.taxes = await getAllTax();
      vm.nonTaxExemptCompanies = await getNonTaxExemptCompanies();
      vm.taxExemptCompanies = await getTaxExemptCompanies();
    }
    
    activate();

    function createTaxRate() {
      $state.go('app.tax.create');
    }

    function searchTable() {
      setTimeout(function () {
       
      }, searchDelay);
    }

    function editTaxRate(tax) {
      $state.go('app.tax.update', {
        id: tax.Id
      });
    }

    async function getAllTax(includeDeleted = false){
      return await vm.service.getAllTax(includeDeleted);
    }

    async function deleteTaxRate(tax) {
      let confirm = $mdDialog.confirm()
      .title('Delete Tax Rate')
      .textContent('Are you sure you want to remove this Tax Rate?')
      .ok('Yes')
      .cancel('Cancel');

      $mdDialog.show(confirm).then(async function() {
        await vm.service.deleteTaxRate(tax.Id);
        vm.taxes = await vm.service.getAllTax();
      });
    }

    async function getNonTaxExemptCompanies() {
      return await vm.service.getNonTaxExemptCompanies();
    }

    async function getTaxExemptCompanies() {
      return await vm.service.getTaxExemptCompanies();
    }

    async function addTaxExemptCompany() {
      var hasUpdated = await vm.service.addTaxExemptCompany(vm.selectedItem.id);

      await refreshList();
      vm.selectedItem = null;

      return hasUpdated;
    }

    async function removeTaxExemptCompany(company) {
      let confirm = $mdDialog.confirm()
      .title('Remove Company')
      .textContent('Are you sure you want to remove this company?')
      .ok('Yes')
      .cancel('Cancel');

      $mdDialog.show(confirm).then(async function() {
        var hasUpdated = await vm.service.removeTaxExemptCompany(company.id);

        await refreshList();
  
        return hasUpdated;
      });
    }

    async function refreshList() {
      vm.taxExemptCompanies = await vm.service.getTaxExemptCompanies();
      vm.nonTaxExemptCompanies = await vm.service.getNonTaxExemptCompanies();
    }

    function querySearch(query) {
      let results = alasql("select * from ? where Name like '%" + query + "%'", [vm.nonTaxExemptCompanies]);
      return alasql('select * from ? order by Name', [results]);
    }

    async function getTaxhistory(tax) {
      await historyLogService.showHistoryLogV2([tax.Id], tax.Name);
    }
    
    async function getTaxeshistory() {

      let taxes = await getAllTax(true)
      let taxIds = taxes.map(c=> c.Id);
      await historyLogService.showHistoryLogV2(taxIds, 'Tax Rates');
    }
  }
  
})();
(function() {
    'use strict';

    angular
        .module('app.tags')
        .controller('TagsController', TagsController);

    /** @ngInject */
    function TagsController($mdDialog,
                            blockUI,
                            utils,
                            hubService,
                            tagsService) {
        let self = this;

        self.service = tagsService;
        self.dtOptions = {
            order: [],
            paging: true,
            searching: false,
            lengthChange: false,
            fixedColumns: true
        };
        self.dtInstance = {};

        self.service.init();

        self.launchAddTag = function(){
            $mdDialog.show({
                parent: angular.element(document.body)
                , templateUrl: 'app/main/tags/directives/addTags/add-tags.html'
                , controller: 'AddTagsController as vm'
            });
        };

        self.toggleIsActive = function(tag, index) {
            let params = { Id: tag.Id, IsActive: !tag.IsActive, IncludeInInvoicePdf: tag.IncludeInInvoicePdf };
            blockUI.start("Updating " + tag.Name + ", please wait...");
            self.hasError = false;
            self.service.updateTag(params, index, tag)
                .then(function(){
                    self.dtInstance.rerender();
                    blockUI.stop();
                    hubService.showToast(utils.translate('TAGS.MESSAGE_TAG_UPDATED'));
                }, function(err){
                    blockUI.stop();
                    self.hasError = true;
                    self.errorMessage = err.data.ErrorMessage;
                });
        };

        self.toggleIncludeInInvoicePdf = function(tag, index) {
            let params = { Id: tag.Id, IncludeInInvoicePdf: !tag.IncludeInInvoicePdf, IsActive: tag.IsActive };
            blockUI.start("Updating " + tag.Name + ", please wait...");
            self.hasError = false;
            self.service.updateTag(params, index, tag)
                .then(function(){
                    self.dtInstance.rerender();
                    blockUI.stop();
                    hubService.showToast(utils.translate('TAGS.MESSAGE_TAG_UPDATED'));
                }, function(err){
                    blockUI.stop();
                    self.hasError = true;
                    self.errorMessage = err.data.ErrorMessage;
                });
        };


    }
})();


(function () {
    "use strict";

    angular
        .module("app.smartScheduling", [])
        .factory("smartSchedulingService", smartSchedulingService);

    /** @ngInject */
    function smartSchedulingService($mdDialog, preScheduleApi, exceptionService) {
        var service = {
            generateSchedule: generateSchedule,
            showAllocationDialog: showAllocationDialog,
            confirmPreScheduleJobByTicketIds: confirmPreScheduleJobByTicketIds,
            updatePreScheduleJobStatus: updatePreScheduleJobStatus,
            getLinkedPreScheduleJobs: getLinkedPreScheduleJobs,
            getGeneratedPreSchedule: getGeneratedPreSchedule,
            retrySchedulingCopilot: retrySchedulingCopilot,
            cancelScheduling: cancelScheduling,
            showScheduleBooking: showScheduleBooking
        };

        return service;

        function showAllocationDialog(people, equipments) {
            return $mdDialog.show({
                controllerAs: "vm",
                controller: "SmartSchedulingAllocationDialogController",
                multiple: true,
                templateUrl: "app/main/smartScheduling/allocation-dialog.html",
                locals: {
                    people: people,
                    equipments: equipments,
                },
            });
        }

        async function generateSchedule(ticketId, resourceItems) {
            if (!ticketId || !(resourceItems && resourceItems.length > 0)) {
                return null;
            }

            var resources = resourceItems.map(function (resource) {
                return {
                    ResourceItemId: resource.Id,
                    ItemId: resource.ItemId,
                    ItemName: resource.ItemName,
                    ItemType: resource.ItemType,
                    IsVehicle: resource.IsVehicle,
                };
            });


            try {
                return await preScheduleApi.generateSchedule(
                    ticketId,
                    resources
                );
            } catch (ex) {
                exceptionService.resolve(ex);
            }
        }

        async function confirmPreScheduleJobByTicketIds(ticketIds) {
            try {
                return await preScheduleApi.confirmPreScheduleJobByTicketIds(ticketIds);
            } catch (ex) {
                exceptionService.resolve(ex);
            }
        }

        async function retrySchedulingCopilot(preScheduleJobId) {
            try {
                await preScheduleApi.retrySchedulingCopilot(preScheduleJobId);
                return true;
            } catch (ex) {
                exceptionService.resolve(ex);
                return false;
            }
        }

        async function updatePreScheduleJobStatus(preScheduleJobIds) {
            try {
                if (preScheduleJobIds && preScheduleJobIds.length <= 0) {
                    return;
                }

                return await preScheduleApi.updatePreScheduleJobStatus(preScheduleJobIds);
            } catch (ex) {
                exceptionService.resolve(ex);
            }
        }

        async function cancelScheduling(preScheduleJobId) {
            try {
                return await preScheduleApi.cancelScheduling(preScheduleJobId);
            } catch (ex) {
                exceptionService.resolve(ex);
                return false;
            }
        }

        async function getLinkedPreScheduleJobs(ticketId) {
            try {
                if (!ticketId) {
                    return;
                }

                return await preScheduleApi.getPreScheduleJobIdsByTicketId(ticketId);
            } catch (ex) {
                exceptionService.resolve(ex);
            }
        }

        async function getGeneratedPreSchedule(preScheduleJobId) {
            try {
                if (!preScheduleJobId) {
                    return;
                }

                return await preScheduleApi.getGeneratedPreSchedule(preScheduleJobId);
            } catch (ex) {
                exceptionService.resolve(ex);
            }
        }

        function showScheduleBooking() {
            var notif = $mdDialog.confirm()
                .parent(angular.element(document.body))
                .clickOutsideToClose(false)
                .title('Unlock Scheduling Copilot Now!')
                .htmlContent("Don't miss out on the chance to elevate your team's efficiency with Alloc8's powerful new tool for resource management!  <br\><br\> Contact our sales team today to learn more about how Scheduling Copilot can streamline your scheduling, optimize resource usage, and drive project success.")
                .ok('BOOK A SCHEDULING COPILOT DEMO')
                .cancel('NOT NOW')

            $mdDialog.show(notif).then(() => {
                window.open('https://meetings.hubspot.com/jack-lundberg?utm_medium=email&_hsenc=p2ANqtz--FZhMgoUcYmyNDRnKNUFZ83UkRe6_aDVbk-U325TZQTtQ5n1kZqayHPnu7QmlhVpgmzBBk5zRq1SvJJoGKk6i22-Jgkkmo_WZvyAaHCLYvTxcozvc&_hsmi=332872971&utm_content=332787283&utm_source=hs_email&uuid=e1dad1ad-0d76-42bc-b7e3-1fe89e0dc285', '_blank').focus();
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.smartScheduling")
        .controller(
            "SmartSchedulingAllocationDialogController",
            SmartSchedulingAllocationDialogController
        );

    /** @ngInject */
    function SmartSchedulingAllocationDialogController(
        $scope,
        $mdDialog,
        locals
    ) {
        var vm = this;

        var people = angular.copy(locals.people);
        var equipments = angular.copy(locals.equipments);

        vm.people = [];
        vm.equipments = [];
        vm.resourcesToAllocate = [];

        $scope.isAllPeopleChecked = true;
        $scope.isAllEquipmentsChecked = true;

        onOpen();

        function onOpen() {
            vm.people = people;
            vm.equipments = equipments;

            checkAllPeople();
            checkAllEquipments();
        }

        vm.cancel = cancel;
        vm.proceed = proceed;
        vm.checkAllPeople = checkAllPeople;
        vm.checkAllEquipments = checkAllEquipments;
        vm.checkPerson = checkPerson;
        vm.checkEquipment = checkEquipment;

        function checkAllPeople() {
            if ($scope.isAllPeopleChecked) {
                vm.people.forEach(function (person) {
                    if(person.isSelected) {
                        return;
                    }
                    
                    person.isSelected = true;
                    vm.resourcesToAllocate.push(person);
                });

                return;
            }

            vm.people.forEach(function (person) {
                person.isSelected = false;
                vm.resourcesToAllocate.splice(vm.resourcesToAllocate.indexOf(person), 1);
            });
        }

        function checkAllEquipments() {
            if ($scope.isAllEquipmentsChecked) {
                vm.equipments.forEach(function (equipment) {
                    if(equipment.isSelected) {
                        return;
                    }

                    equipment.isSelected = true;
                    vm.resourcesToAllocate.push(equipment);
                });

                return;
            }

            vm.equipments.forEach(function (equipment) {
                equipment.isSelected = false;
                vm.resourcesToAllocate.splice(vm.resourcesToAllocate.indexOf(equipment), 1);
            });
        }

        function checkResource(resource) {
            var indexOfResource = vm.resourcesToAllocate.indexOf(resource);

            if (indexOfResource === -1) {
                resource.isSelected = true;
                vm.resourcesToAllocate.push(resource);
                return;
            }

            resource.isSelected = false;
            vm.resourcesToAllocate.splice(indexOfResource, 1);
        }

        function checkPerson(person) {
            checkResource(person);
            $scope.isAllPeopleChecked = vm.people.every(x => x.isSelected);
        }

        function checkEquipment(equipment) {
            checkResource(equipment);
            $scope.isAllEquipmentsChecked = vm.equipments.every(x => x.isSelected);
        }

        function cancel() {
            vm.resourcesToAllocate = [];
            $mdDialog.hide(null);
        }

        function proceed() {
            $mdDialog.hide(vm.resourcesToAllocate);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.ratecards')
        .controller('RateCardsController', RateCardsController);

    function RateCardsController(
        $scope,
        utils,
        blockUI,
    ) {
        let self = this;
        self.utilService = utils;

        self.showManagePanel = true;
        self.showPricingPanel = false;
        self.currentNavItem = "manage";

        self.showManage = function() {
            self.currentNavItem = "manage";
            if (self.showManagePanel) {
                return;
            }

            reset();
            self.showManagePanel = true;
        };

        self.showPricing = function() {
            self.currentNavItem = "pricing";
            if (self.showPricingPanel) {
                return;
            }

            blockUI.start();
            reset();
            self.showPricingPanel = true;
        };

        function reset() {
            self.showManagePanel = false;
            self.showPricingPanel = false;
        }

        $scope.$on("switchToPricingTab", function() {
            self.showPricing();
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.reporting')
        .constant('reportType', {
            HOURS_WORKED: 13,
            JOB_SHIFTS_TIMESHEET: 24,
            BILL_OF_QUANTITIES: 38
        }); 
})();
(function() {
    'use strict';

    angular
        .module('app.rateCardSettings')
        .controller('RateCardSettingsController', RateCardSettingsController);

    function RateCardSettingsController(
        $scope,
        utils
    ) {
        let self = this;
        self.utilService = utils;

        self.showAllowancesPanel = true;
        self.showTimesheetsPanel = false;
        self.showPackagesPanel = false;
        self.currentNavItem = "allowances";

        self.showAllowances = function() {
            self.currentNavItem = "allowances";
            if (self.showAllowancesPanel) {
                return;
            }

            hideAllTabs();
            self.showAllowancesPanel = true;
        };

        self.showTimesheets = function() {
            self.currentNavItem = "timesheets";
            if (self.showTimesheetsPanel) {
                return;
            }

            hideAllTabs();
            self.showTimesheetsPanel = true;
        };

        self.showPackages = function() {
            self.currentNavItem = "packages";
            if (self.showPackagesPanel) {
                return;
            }

            hideAllTabs();
            self.showPackagesPanel = true;
        };

        function hideAllTabs() {
            self.showAllowancesPanel = false;
            self.showTimesheetsPanel = false;
            self.showPackagesPanel = false;
        }

        $scope.$on("switchToPricingTab", function() {
            self.showPricing();
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.payroll-group')
        .controller('PayrollGroupController', PayrollGroupController);

    /** @ngInject */
    function PayrollGroupController(
        $mdDialog,
        payrollGroupService,
        adminClaimsService,
        blockUI
    ) {
        var vm = this;

        vm.dtOptions = {
            order: [],
            paging: true,
            searching: true,
            lengthChange: false,
            fixedColumns: true
        };

        vm.dtInstance = {};
        vm.query = '';

        vm.searchTable = searchTable;
        vm.showHistoryLog = showHistoryLog;
        vm.showPayrollGroupDialog = showPayrollGroupDialog
        vm.add = add;
        vm.update = update;
        vm.service = payrollGroupService;

        vm.hasManagePayrollGroupsPermission = adminClaimsService.hasManagePayrollGroupsPermission;

        initialise();

        async function initialise() {
            await payrollGroupService.init();
        }

        function add() {
            showPayrollGroupDialog().then(function() {
                initialise();
            });
        }

        function update(payrollGroup) {
            showPayrollGroupDialog(payrollGroup).then(function() {
                initialise();
            });
        }

        function showPayrollGroupDialog(payrollGroup) {
            return $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/main/payrollGroups/dialogs/payroll-group-dialog.html',
                controller: 'PayrollGroupsDialogController as vm',
                locals: {
                    payrollGroup,
                    vm
                }
            });
        }

        function searchTable() {
            setTimeout(function () {
                vm.dtInstance.DataTable.search(vm.query);
                vm.dtInstance.DataTable.search(vm.query).draw();
            }, 1000);
        }

        function showHistoryLog(id, name) {
            blockUI.start('Loading History');

            payrollGroupService.getPayrollGroupHistory(id, name).then(function() {
                blockUI.stop();
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .service('PaperworkExceptionSignalRService', PaperworkExceptionSignalRService);

    /** @ngInject */
    function PaperworkExceptionSignalRService(signalRService,
                                              utils,
                                              $state,
                                              $rootScope) {

        var service = {
            register: register
        };

        var isInitialized = false;

        return service;

        function register() {
            signalRService.isConnected ? regs() : connect();
        }

        function connect(){
            $rootScope.$on('signalR_OnConnected', function () {
                if (!isInitialized) {
                    regs();
                    isInitialized = true;
                }
            });
        }

        function regs() {
            // signalRService.messageHub.on('downloadPaperworkCallback', function (resp) {
            //     //Download catcher
            //     var now = moment().format("YY-MM-DD-HH-mm-ss");
            //     var anchor = angular.element('<a/>');
            //     var filenameParts = resp.FileUri.split('/');
            //
            //     anchor.attr({
            //         href: encodeURI(resp.FileUri),
            //         target: '_blank',
            //         download: filenameParts[filenameParts.length-1]
            //     })[0].click();
            // });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .factory('PaperworkExceptionService', PaperworkExceptionService);

    function PaperworkExceptionService(
        paperworkExceptionsApi,
        filterModel,
        $q,
        invoiceApi
    ) {
        let service = {
            loadLookUps: loadLookUps,
            loadReport: loadReport,
            model: new filterModel,
            load_count: 0,
            report_types: [],
            report_types_all: [],
            branches: [],
            clients: []
        }

        return service;

        function loadLookUps() {
            return $q.all([
                paperworkExceptionsApi.loadBranches(),
                paperworkExceptionsApi.loadReportTypes(),
                invoiceApi.getClients()
            ]);
        }

        function loadReport(payload) {
            return paperworkExceptionsApi.loadReport(payload);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .service('paperWorkGridModel', paperWorkGridModel)

    function paperWorkGridModel(_) {
        return function (options, report_types) {

            var defaults = {
                HeaderColumns : [],
                ExceptionType : null,
                ReportType : null,
                ReportTypeName : null,
                DataRows : []
            };

            this.map = mapper;

            function mapper(opts) {
                //Data manipulation
                //Data setting
                angular.extend(this, defaults, opts);
                //Adding actual report name for header display
                this.ReportTypeName = getReportType(opts.ExceptionType);
                //To add 'IsSelected' property and order props according to header conditions
                this.DataRows.map(mapRows);
                //Reorder columns and add 'IsSelected' column
                this.HeaderColumns.forEach(mapColumns);
                this.HeaderColumns.unshift(formIsSelectedColumn());
                //Add Actions column
                this.HeaderColumns.push(formActionColumn(this.HeaderColumns.length++));
            }

            function formIsSelectedColumn(){
                //'IsSelected' column model
                return {
                    "HeaderKey": "IsSelected",
                    "HeaderName": "",
                    "FieldType": "c", //checkbox type
                    "OrderSequence": 0
                }
            }

            function formActionColumn(order){
                //'Actions' column model
                return {
                    "HeaderKey": "Actions",
                    "HeaderName": "Actions",
                    "FieldType": "a", //action column
                    "OrderSequence": order
                }
            }

            function mapRows(row){
                //To add 'IsSelected' property
                row['IsSelected'] = false;
                row['Actions'] = null;
            }

            function mapColumns(column){
                column.OrderSequence++;
            }

            function getReportType(Id){
                //Adding actual report name for header display
                var item = _.find(report_types, {Id : Id});
                return item ? item.Value : '';
            }

            this.map(options);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.paperwork.exceptions').controller('PaperworkExceptionsController', PaperworkExceptionsController);

    function PaperworkExceptionsController(mediaQueryService, msgboxService, utils, blockUI, PaperworkExceptionService, exceptionService, _, paperWorkGridModel, claimsUtilService) {

        var vm = this;
        vm.is_loading = false;
        vm.sidenav_model_copy = null;
        vm.service = PaperworkExceptionService;
        vm.media = mediaQueryService;

        vm.activate = activate;
        vm.loadLookups = loadLookups;
        vm.loadReport = loadReport;
        vm.limit = limit;
        vm.refreshList = refreshList;
        vm.openFilter = openFilter;
        vm.clientFilter = clientFilter;
        vm.filter_ids = [];
        vm.isInclementWeatherInTimesheetEnabled = claimsUtilService.isInclementWeatherInTimesheetEnabled();

        //lookup
        vm.branches = [];
        vm.report_types = [];
        vm.clients = [];
        //lookup

        //Grid Data
        vm.grid_data = [];

        //Grid Data

        function activate() {
            //Set model
            //Load branch and report types lookup
            vm.filterModel = setFilters(vm.service.model);
            vm.service.load_count++;
            vm.loadLookups();
        }

        function clientFilter(id) {
            if (!_.isNil(id)) {
                vm.filter_ids = id;
            }

            let data = !_.isNil(vm.grid_data_original[0]) ? mapGrid(angular.copy(vm.grid_data_original)) : [];
            if (id.length === 0) {
                vm.grid_data = data;
            } else {
                vm.grid_data = filterAdditional(data, vm.filter_ids);
            }
        }

        function openFilter() {
            let template = "app/main/paperworkExceptions/filterDialog/filter-dialog.html";
            let controller = "paperWorkDialogController as vm";
            let locals = {
                model: vm.filterModel,
                branches: vm.service.branches,
                report_types: vm.service.report_types,
                clients: vm.service.clients
            }
            msgboxService.showCustomDialog(template, controller, locals).then(loadReportFromDialog);
        }

        vm.activate();

        function loadReportFromDialog(resp) {
            if (resp) {
                loadReport(resp);
            }
        }

        function loadLookups() {
            if (vm.service.load_count <= 1) {
                blockUI.start(utils.translate("PAPERWORK_EXCEPTION.LOADING"));
                vm.service.loadLookUps().then(fetchLookUps).catch(handleError);
            } else {
                tweakReportTypes();
            }
        }

        function fetchLookUps(resp) {
            vm.service.branches = resp[0].data.filter(x => x.State != null);
            var allTypes = vm.isInclementWeatherInTimesheetEnabled ? resp[1].data : resp[1].data.filter(x => x.Id != 9);
            vm.service.report_types_all = allTypes;
            vm.service.report_types = allTypes.filter(function(t) { return !t.IsHidden; });
            vm.service.clients = resp[2].data;
            tweakReportTypes();
            blockUI.stop();
        }

        function tweakReportTypes() {
            if (vm.service.load_count <= 1) {
                vm.service.model.ReportTypes = _.isNil(vm.service.model.ReportTypes) ? [] : vm.service.model.ReportTypes
                vm.service.model.ReportTypes = vm.service.model.ReportTypes.length === 0 ? vm.service.report_types : vm.service.model.ReportTypes;
            } else {
                vm.service.model.ReportTypes = vm.service.model.ReportTypes;
            }
        }

        function setProcess(message) {
            vm.is_loading = true;
            vm.loader_message = message;
        }

        function stopProcess() {
            vm.is_loading = false;
            vm.loader_message = null;
        }

        function handleError(err) {
            blockUI.stop();
            stopProcess();
            exceptionService.resolve(err);
        }

        function loadReport() {
            setProcess(utils.translate("PAPERWORK_EXCEPTION.GENERATING_REPORT"));
            let transformed_model = vm.filterModel.transformToServerModel();
            vm.sidenav_model_copy = angular.copy(transformed_model);
            vm.service.loadReport(transformed_model).then(fetchGeneratedList).catch(handleError)
        }

        function refreshList() {
            setProcess(utils.translate("PAPERWORK_EXCEPTION.REFRESH_GRID"));
            vm.service.loadReport(vm.sidenav_model_copy).then(fetchGeneratedList).catch(handleError)
        }

        function fetchGeneratedList(resp) {
            //Data manipulation (Fetched list)
            //Performed after list of data has been returned for displaying
            vm.grid_data_original = resp.data;
            (!_.isNil(resp.data[0])) ? mapGrid(angular.copy(resp.data)): [];
            if (resp.data.length === 0) {
                showNoReportFetchedDialog();
            } else {
                vm.grid_data = (!_.isNil(vm.grid_data_original[0])) ? filterAdditional(mapGrid(angular.copy(vm.grid_data_original)), vm.filter_ids) : [];
                stopProcess();
            }
        }

        function filterAdditional(list, filter_ids) {
            if (vm.filter_ids.length > 0) {
                return _.filter(list, function(itm) {
                    return _.find(filter_ids, function(i) {
                        return i === itm.ExceptionType;
                    });
                });
            } else {
                return list;
            }
        }

        function showNoReportFetchedDialog() {
            vm.grid_data.length = 0;
            stopProcess();
            let msg = utils.translate("PAPERWORK_EXCEPTION.GOOD_WORK");
            let title = utils.translate("PAPERWORK_EXCEPTION.HEADER");
            msgboxService.show(msg, title);
        }


        function mapGrid(data) {
            return data.map(function(item) {
                return new paperWorkGridModel(item, vm.service.report_types_all);
            });
        }

        function setFilters(model) {
            model.StartDate = setStartDate(model.StartDate);
            model.EndDate = setEndDate(model.EndDate);
            return model;
        }

        function setEndDate(date) {
            return _.isNil(date) ? moment() : moment(date);
        }

        function setStartDate(date) {
            return _.isNil(date) ? (getDayOfTheWeek() === 0 ? getLastFriday() : getYesterday()) : moment(date);
        }

        function getLastFriday() {
            return moment(new Date()).add(-3, 'days');
        }

        function getYesterday() {
            return moment(new Date()).add(-1, 'days');
        }

        function getDayOfTheWeek() {
            return moment().weekday();
        }

        function limit(arr, title) {
            return (_.isNil(arr) || arr.length === 0) ? utils.translate(title) : limitDisplay(arr);
        }

        function limitDisplay(arr) {
            arr = flatToNamesOnly(arr);
            return arr.length > 3 ? (arr.slice(0, 3).join(", ")) + " + " + (arr.length - 3) + " " + utils.translate("MESSAGING.MORE") : arr.join(", ");
        }

        function flatToNamesOnly(arr) {
            return _.map(arr, function(itm) {
                return itm.Name || itm.Value;
            });
        }
    }

})();

(function() {
    'use strict';

    angular.module('app.paperwork.exceptions')
        .factory('paperworkExceptionsApi', paperworkExceptionsApi);

    function paperworkExceptionsApi(
        $http,
        tenantSettings
    ) {
        var api = tenantSettings.coreApiUrl + "api/exceptionReport/";
        var timesheet_api = tenantSettings.coreApiUrl + "api/timesheets/";

        return {
            loadBranches: loadBranches,
            loadReportTypes: loadReportTypes,
            loadReport: loadReport,
            fetchTimesheet: fetchTimesheet,
            saveTimesheet: saveTimesheet,
            resolve: resolve,
            downloadPDF: downloadPDF
        };

        function loadBranches() {
            let branches = tenantSettings.coreApiUrl + 'api/Branches/getbranchesandstates';
            return $http.get(branches);
        }

        function loadReportTypes() {
            return $http.get(api + 'ExceptionTypes');
        }

        function loadReport(payload) {
            return $http.post(api + 'reports', payload);
        }

        function fetchTimesheet(ticketId, contactId) {
            return $http.get(timesheet_api + ticketId + "/timesheet-details/" + contactId);
        }

        function saveTimesheet(ticketId, pay_load) {
            return $http.put(timesheet_api + ticketId , pay_load);
        }

        function resolve(payload) {
            return $http.post(api + 'resolve', payload);
        }

        function downloadPDF(payload) {
            let url = tenantSettings.coreApiUrl + "api/v1/paperwork/download/ticket/";
            return $http.post(url, payload);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.paperwork.exceptions.configurations')
        .factory('configOptionsService', configOptionsService);

    function configOptionsService(
        configOptionsApi
    ) {
        var service = {
            getValues: getValues,
            save: save
        };

        return service;

        function getValues() {
            return configOptionsApi.getValues();
        }

        function save(pay_load) {
            return configOptionsApi.save(pay_load);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.paperwork.exceptions.configurations').controller('PaperworkExceptionsConfigurationController', PaperworkExceptionsConfigurationController);

    function PaperworkExceptionsConfigurationController(utils, blockUI, $timeout, configOptionsService, mediaQueryService, exceptionService, $scope){
        var vm = this;

        vm.list = [];
        vm.is_loading = false;
        vm.is_loading_message = null;
        vm.media = mediaQueryService;
        vm.service = configOptionsService;

        vm.activate = activate;
        vm.save = save;

        function activate(){
            getList();
        }

        function getList(){
            vm.is_loading = true;
            $timeout(function(){
                vm.service.getValues().then(getListCallback).catch(processFailedCallback);
            }, 2000);
        }

        function save(pay_load){
            vm.is_loading = true;
            vm.service.save(pay_load).then(saveCallback).catch(processFailedCallback);
        }

        function saveCallback(){
            vm.is_loading = false;
            $scope.configOptions.$setPristine();
        }

        function getListCallback(resp){
            vm.list = resp.data.map(mapValuesAccordingly);
            saveCallback();
        }

        function mapValuesAccordingly(item){
            return {
                Id : item.Id,
                ConfigOptionId : item.ConfigOptionId,
                ConfigOptionOperator : item.ConfigOptionOperator,
                ConfigOptionText : item.ConfigOptionText,
                Value : parseValue(item.Value)
            }
        }

        function parseValue(value){
            return !value ? null : (isYesNo(value) ? value : parseFloat(value));
        }

        function isYesNo(value){
            let lowered_value = value.toLowerCase();
            return (lowered_value === "yes" || lowered_value === "no");
        }

        function processFailedCallback(error){
            exceptionService.resolve(error);
            saveCallback();
        }

        vm.activate();
    }

})();

(function() {
    'use strict';

    angular.module('app.paperwork.exceptions.configurations')
        .factory('configOptionsApi', configOptionsApi);

    function configOptionsApi(
        $http,
        tenantSettings
    ) {
        var api = tenantSettings.coreApiUrl + 'api/exceptionReport/Configurations';
        var api_save = tenantSettings.coreApiUrl + 'api/exceptionReport/Configuration';

        return {
            getValues: getValues,
            save: save
        };

        function getValues() {
            return $http.get(api)
        }

        function save(pay_load) {
            return $http.put(api_save + '/batch/update', pay_load);
        }
    }
})();

/**
 * Created by queenie maniquis on 06/22/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.messaging-format', [])
        .config(config);

    /** @ngInject */
    function config ($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.messaging-format', {
                url: '/messaging-format'
                , views: {
                    'content@app': {
                        templateUrl: 'app/main/messagingFormat/messaging-format.controller.html'
                        , controller: 'MessagingFormatController as messagingFormat'
                    }
                }
                , data: {
                    requireLogin: true,
                    validateAccess: ['adminClaimsService', function (adminClaimsService) {
                        return adminClaimsService.hasManageMessagingFormat;
                    }] 
                }
                , title: 'Manage Messaging Formats'
                , titleBar: 'Alloc8 - Manage Messaging Format'
            });

        $translatePartialLoaderProvider.addPart('app/main/messagingFormat');
    }
})();

(function () {
    'use strict';

    angular.module('app.messaging-format')
        .factory('messagingFormatService', messagingFormatService);

    function messagingFormatService(
        blockUI,
        utils,
        $q,
        hubService,
        messageFormatApi,
        _) {

        let self = this;
        self.service = {};

        self.service.getMessageFields = function() {
            let deferred = $q.defer();

            messageFormatApi.getMessageFormatFields().then(function (resp) {
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.getMessageTemplates = function() {
            let deferred = $q.defer();

            messageFormatApi.getMessageFormatList().then(function (resp) {
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.addMessageTemplate = function(params) {
            let deferred = $q.defer();

            messageFormatApi.postMessageFormats(params).then(function (resp) {
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        self.service.updateMessageTemplate = function(params, id) {
            let deferred = $q.defer();

            messageFormatApi.putMessageFormats(params, id).then(function (resp) {
                deferred.resolve({ data: resp.data });
            }).catch(function (ex) {
                deferred.reject(ex);
            });

            return deferred.promise;
        };

        return self.service;
    }
})();



/**
 * Created by queeniejgm on 04/06/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.messaging-format')
        .controller('MessagingFormatController', MessagingFormatController);

    /** @ngInject */
    function MessagingFormatController ( $scope,
                                         $q,
                                         utils,
                                         blockUI,
                                         hubService,
                                         messagingFormatService,
                                         exceptionService) {

        let self = this;
        self.service = messagingFormatService;
        self.messageFormatModel = [];

        self.$onInit = function () {
            init();
        };

        self.addMessagingFormatField = function(field){
            if (_.isNil(self.currentMessageFormatFocus)) {
                exceptionService.resolve(utils.translate('MESSAGE_FORMAT.ERROR_NO_SELECTED_FORMAT'));
                return;
            }

            let fieldID = "#" + self.currentMessageFormatFocus;
            let position = _.first(angular.element(fieldID)).selectionStart;
            let str = self.messageFormatModel[self.currentMessageFormatFocus];
            field = "{"+ field +"}";

            if (_.isNil(str)) {
                self.messageFormatModel[self.currentMessageFormatFocus] = field;
            } else {
                self.messageFormatModel[self.currentMessageFormatFocus] = str.substr(0, position) + field + str.substr(position);
            }
        };

        self.changeMessageFormatFocus = function(field){
            self.currentMessageFormatFocus = field;
        };

        self.saveMessageFormat = function(formatType, templateId){
            blockUI.start();
            let params = {
                "Type": {
                    "Key": formatType
                },
                "Content": self.messageFormatModel[formatType]
            };

            if (!templateId) {
                self.service.addMessageTemplate(params)
                    .then(function(resp){
                        blockUI.stop();
                        hubService.showToast(utils.translate('MESSAGE_FORMAT.MESSAGE_ADDED'));
                    }, function(err){
                        exceptionService.resolve(err);
                        blockUI.stop();
                    });
            } else {
                self.service.updateMessageTemplate(params, templateId)
                    .then(function(resp){
                        hubService.showToast(utils.translate('MESSAGE_FORMAT.MESSAGE_SAVED'));
                        blockUI.stop();
                    }, function(err){
                        exceptionService.resolve(err);
                        blockUI.stop();
                    });
            }
        };

        function init() {
            let uris = [getMessageFieldsLookup(), getMessageTemplatesLookup()];

            $q.all(uris).then(function(){


            }).catch(function(){
                exceptionService.resolve(err);
                blockUI.stop();
            });
        }

        function getMessageFieldsLookup() {
            self.service.getMessageFields()
                .then(function(resp){
                    self.messageFieldsLookup = resp.data;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getMessageTemplatesLookup() {
            self.service.getMessageTemplates()
                .then(function(resp){
                    self.messageTemplatesLookup = resp.data;

                    _.map(self.messageTemplatesLookup, function(lookup) {
                        self.messageFormatModel[lookup.Type.Key] = lookup.Content;
                    });

                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.integrations')
        .controller('integrationsViewController', integrationsViewController);

    function integrationsViewController(
        tabNames,
        integrationsService) {

        var vm = this;
        vm.tabNames = tabNames;
        vm.selectedTabName = vm.tabNames.settings;

        vm.getLogs = function() {
            return integrationsService.getIntegrationsHistoryLogs();
        }

        vm.onTabSelected = function(selectedTabName) {
            vm.selectedTabName = selectedTabName;
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.integrations')
        .constant('tabNames', {
            settings: 'Settings',
            history: 'History'
        });
})();

(function() {
    'use strict';

    angular
        .module('app.generalSettings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.generalSettings', {
            url: '/generalSettings',
            views: {
                'content@app': {
                    templateUrl: 'app/main/generalSettings/generalSettings.html',
                    controller: 'GeneralSettingsController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function(adminClaimsService) {
                    return adminClaimsService.hasAdminMenu;
                }]
            },
            title: 'General Settings',
            titleBar: 'Alloc8 - General Settings'
        });

        $translatePartialLoaderProvider.addPart('app/main/generalSettings');
    }

})();
(function() {
    'use strict';

    angular
        .module('app.generalSettings')
        .controller('GeneralSettingsController', GeneralSettingsController);

    function GeneralSettingsController(
        generalSettingsApi,
        tenantsApi,
        exceptionService,
        ToastService,
        claimsUtilService,
        identityService,
        blockUI,
        utils,
        payrollSettingsService,
        payrollSettingsFactory,
        lockoutSettingsService
    ) {
        var vm = this;

        vm.saveCompanySettings = saveCompanySettings;
        vm.saveCsvExportSettings = saveCsvExportSettings;
        vm.saveSystemSettings = saveSystemSettings;
        vm.saveFeatures = saveFeatures;
        vm.saveMobileTimesheetSettings = saveMobileTimesheetSettings;
        vm.saveAuthenticationSettings = saveAuthenticationSettings;
        vm.saveInvoiceSettings = saveInvoiceSettings;
        vm.savePayrollSettings = savePayrollSettings;
        vm.saveMobileSettings = saveMobileSettings;
        vm.savePaperworkSettings = savePaperworkSettings;

        vm.isAppSupportUser = identityService.userData.Email == 'app-support@alloc8.io';

        var isPayrollEnabled = claimsUtilService.isPayrollEnabled();
        var isBillingEnabled = claimsUtilService.isBillingEnabled();
        var isXeroEnabled = claimsUtilService.isXeroEnabled();
        var isMyobEnabled = claimsUtilService.isMyobEnabled();

        vm.enablePayrollGroups = claimsUtilService.isPayrollGroupsEnabled();
        vm.hasPayrollIntegration = isXeroEnabled || isMyobEnabled;
        vm.canUpdatePayrollCsvExportFormat = isPayrollEnabled && !isXeroEnabled && !isMyobEnabled;
        vm.canUpdateBillingCsvExportFormat = isBillingEnabled && !isXeroEnabled && !isMyobEnabled;

        vm.timesheetIntervals = ['1','5','10','15'];
        vm.externalAuthenticators = ['None','Google','Microsoft 365'];
        vm.measurementTypes = ['Kilometers','Miles'];

        vm.service = payrollSettingsService;
        vm.launchTimesheetHeadings = launchTimesheetHeadings;
        vm.getHeaderCodes = getHeaderCodes;
        vm.removeTimesheetHeading = removeTimesheetHeading;
        vm.addTimesheetHeadingsAndCodes = addTimesheetHeadingsAndCodes;
        vm.showSuccessDialog = false;
        vm.isPayrollEnabled = isPayrollEnabled;
        vm.failedToSaveInvoiceSettings = false;
        vm.hideGpsOnTimesheetPdf = false;
        vm.hideImageGpsOnPaperworkPdf = false;

        vm.claimsUtilService = claimsUtilService;

        activate();

        function activate() {
            blockUI.start();
            vm.service.initializePayrollSettings()
                .then(function(){
                    getPayrollSettings();
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });

            generalSettingsApi.getCompanyCodeFormats().then(function(resp) {
                vm.companyCodeFormats = resp.data;
            });

            generalSettingsApi.getPayrollCsvExportFormats().then(function(resp) {
                vm.payrollCsvExportFormats = resp.data;
            });

            generalSettingsApi.getBillingCsvExportFormats().then(function(resp) {
                vm.billingCsvExportFormats = resp.data;
            });

            tenantsApi.getGeneralSettings().then(function(resp) {
                var data = resp.data;
                vm.companyCodeFormat = data.CompanyCodeFormat;
                vm.enableViewInvoiceButtonAfterAllCompanySucceeded = data.ViewInvoiceAfterAllCompanySucceeded == null? '' : data.ViewInvoiceAfterAllCompanySucceeded.toLowerCase() === 'true';
                vm.enablePaymentClaim = data.EnablePaymentClaim == null? false : data.EnablePaymentClaim.toLowerCase() === 'true';
                vm.showEmployeeNamesOnInvoices = !data.ShowEmployeeNamesOnInvoices ? false : data.ShowEmployeeNamesOnInvoices.toLowerCase() === 'true';
                vm.requireCompanyCode = data.RequiresCompanyCode == null? '' : data.RequiresCompanyCode.toLowerCase() === 'true';
                vm.payrollCsvFormat = data.PayrollCsvExportSystem == null ? '' : data.PayrollCsvExportSystem;
                vm.billingCsvFormat = data.InvoiceCsvExportSystem == null ? '' : data.InvoiceCsvExportSystem;
                vm.enableGoogleAnalytics = data.EnableGoogleAnalytics == null ? false : (data.EnableGoogleAnalytics.toLowerCase() === 'true');
                vm.wijmoLicenseKey = data.WijmoLicenseKey == null ? '' : data.WijmoLicenseKey;
                vm.formsDbConnectionString = data.FormsDbConnectionString == null ? '' : data.FormsDbConnectionString;
                vm.storageAccountConnectionString = data.StorageAccountConnectionString == null ? '' : data.StorageAccountConnectionString;
                vm.tenantContainerName = data.TenantContainerName == null ? '' : data.TenantContainerName;
                vm.languageCode = data.LanguageCode == null ? '' : data.LanguageCode;
                vm.countryCode = data.CountryCode == null ? '' : data.CountryCode;
                vm.oneDriveClientId = data.OneDriveClientId == null ? '' : data.OneDriveClientId;
                vm.MobileTimesheetInterval = data.MobileTimesheetInterval == null ? '15' : data.MobileTimesheetInterval;
                vm.MobileTimesheetRequireWorkOrderNumber = data.MobileTimesheetRequireWorkOrderNumber == null ? false : data.MobileTimesheetRequireWorkOrderNumber.toLowerCase() === 'true';
                vm.auditUsingSql = data.AuditUsingSql === 'true' ? true : false;
                vm.externalAuthenticator = data.ExternalAuthenticator == null? 'None': data.ExternalAuthenticator;
                vm.allowLoginWithAlloc8ForAllUsers = data.AllowLoginWithAlloc8ForAllUsers == null? false:  (data.AllowLoginWithAlloc8ForAllUsers.toLowerCase() === 'true');
                vm.measurementForDistance = data.MeasurementForDistance == null? 'Kilometers': data.MeasurementForDistance;
                vm.hideGpsOnTimesheetPdf = data.HideGpsOnTimesheetPdf == null? false : data.HideGpsOnTimesheetPdf.toLowerCase() === 'true';
                vm.hideImageGpsOnPaperworkPdf = data.HideImageGpsOnPaperworkPdf == null? false : data.HideImageGpsOnPaperworkPdf.toLowerCase() === 'true';
                vm.hideNotesInTicketPDF = data.HideNotesInTicketPDF === 'true' ? true : false;

                vm.includeBreakTime =data.IncludeBreakTime === 'true' ? true : false;
                vm.includeTravelTime =data.IncludeTravelTime === 'true' ? true : false;
                vm.includeShopTime =data.IncludeShopTime === 'true' ? true : false;
                vm.includeLoadTime =data.IncludeLoadTime === 'true' ? true : false;
            });

            tenantsApi.getAllFeatures().then(function(resp) {
                vm.features = resp.data;
            });
        }

        

        function saveCompanySettings() {
            vm.faledToSaveCompanySettings = false;

            var payload = {
                RequiresCompanyCode: vm.requireCompanyCode.toString(),
                CompanyCodeFormat: vm.companyCodeFormat
            };

            tenantsApi.updateTenantSettings(payload).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast("Company settings updated successfully.");
                } else {
                    ToastService.toast("Failed to update the company settings.");
                    vm.faledToSaveCompanySettings = true;
                }
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
                vm.faledToSaveCompanySettings = true;
            });
        }

        function saveCsvExportSettings() {
            vm.faledToSaveCsvExportSettings = false;

            var payload = {
                PayrollCsvExportSystem: vm.payrollCsvFormat,
                InvoiceCsvExportSystem: vm.billingCsvFormat
            };

            tenantsApi.updateTenantSettings(payload).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast("CSV export settings updated successfully.");
                } else {
                    ToastService.toast("Failed to update the CSV export settings.");
                    vm.faledToSaveCsvExportSettings = true;
                }
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
                vm.faledToSaveCsvExportSettings = true;
            });
        }

        function saveSystemSettings() {
            vm.faledToSaveSystemSettings = false;

            var payload = {
                EnableGoogleAnalytics: vm.enableGoogleAnalytics.toString(),
                WijmoLicenseKey: vm.wijmoLicenseKey,
                LanguageCode: vm.languageCode,
                CountryCode: vm.countryCode,
                OneDriveClientId: vm.oneDriveClientId,
                MeasurementForDistance: vm.measurementForDistance.toString()
            };

            tenantsApi.updateTenantSettings(payload).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast("System settings updated successfully.");
                } else {
                    ToastService.toast("Failed to update the system settings.");
                    vm.faledToSaveSystemSettings = true;
                }
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
                vm.faledToSaveSystemSettings = true;
            });
        }

        function saveFeatures() {
            vm.faledToSaveFeatures = false;

            var enabledFeatures = vm.features
                .filter(feature => feature.isEnabled)
                .map(feature => feature.featureKey);

            tenantsApi.updatedEnabledFeatures(enabledFeatures).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();

                    lockoutSettingsService.updateLockoutSettings(enabledFeatures);
                 
                    ToastService.toast("Feature flags updated successfully.");
                } else {
                    ToastService.toast("Failed to update the feature flags.");
                    vm.faledToSaveFeatures = true;
                }
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
                vm.faledToSaveFeatures = true;
            });
        }

        function saveMobileTimesheetSettings() {
            vm.failedToSaveMobileTimesheetSettings = false;

            var payload = {
                MobileTimesheetInterval: vm.MobileTimesheetInterval,
                MobileTimesheetRequireWorkOrderNumber: vm.MobileTimesheetRequireWorkOrderNumber.toString()
            };

            tenantsApi.updateTenantSettings(payload).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast(utils.translate('GENERAL_SETTINGS.MOBILE_TIMESHEET_UPDATE_SUCCESSFUL'));
                } else {
                    ToastService.toast(utils.translate('GENERAL_SETTINGS.MOBILE_TIMESHEET_UPDATE_FAILED'));
                    vm.failedToSaveMobileTimesheetSettings = true;
                }
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
                vm.failedToSaveMobileTimesheetSettings = true;
            });
        }

        function saveAuthenticationSettings() {
            vm.failedToSaveAuthenticationSettings = false;

            var payload = {
                ExternalAuthenticator: vm.externalAuthenticator,
                AllowLoginWithAlloc8ForAllUsers: vm.allowLoginWithAlloc8ForAllUsers.toString()
            };

            tenantsApi.updateTenantSettings(payload).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast(utils.translate('GENERAL_SETTINGS.AUTHENTICATION_SETTINGS_UPDATE_SUCCESSFUL'));
                } else {
                    ToastService.toast(utils.translate('GENERAL_SETTINGS.AUTHENTICATION_SETTINGS_UPDATE_FAILED'));
                    vm.failedToSaveAuthenticationSettings = true;
                }
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
                vm.failedToSaveAuthenticationSettings = true;
            });
        }

        function launchTimesheetHeadings(timesheet, index) {
            payrollSettingsFactory.addTimesheetHeadings(timesheet, index);
        }

        function addTimesheetHeadingsAndCodes() {
            payrollSettingsFactory.addTimesheetHeadings();
        }

        function getPayrollSettings() {
            vm.payrollSettings = vm.service.getPayrollSettings();
        }

        function removeTimesheetHeading(timesheet) {
            blockUI.start();
            vm.service.removeTimesheetHeadingDetails(timesheet)
                .then(function(){
                    getPayrollSettings();
                    vm.showSuccessDialog = true;
                    blockUI.stop();
                }, function(err){
                    exceptionService.resolve(err);
                    blockUI.stop();
                });
        }

        function getHeaderCodes(timesheet) {
            return _.join(timesheet,",");
        }

        function saveInvoiceSettings() {
            tenantsApi.updateTenantSettings({
                ViewInvoiceAfterAllCompanySucceeded: vm.enableViewInvoiceButtonAfterAllCompanySucceeded.toString(),
                EnablePaymentClaim: vm.enablePaymentClaim.toString(),
                ShowEmployeeNamesOnInvoices: vm.showEmployeeNamesOnInvoices.toString()
            }).then(function(resp) {
                vm.failedToSaveInvoiceSettings = false;

                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast("Invoice settings updated successfully.");
                } else {
                    ToastService.toast("Failed to update the invoice settings.");
                }
            }).catch(function(e) {
                vm.failedToSaveInvoiceSettings = true;
                exceptionService.resolve(e);
            });
        }

        function saveMobileSettings(){
            vm.failedToSaveMobileSettings = false;

            var enabledFeatures = vm.features
                .filter(feature => feature.isEnabled)
                .map(feature => feature.featureKey);

            tenantsApi.updatedEnabledFeatures(enabledFeatures).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast("Mobile settings updated successfully.");
                } else {
                    ToastService.toast("Failed to update the mobile settings.");
                    vm.failedToSaveMobileSettings = true;
                }
            }).catch(function(e) {
                exceptionService.resolve(e);
                vm.failedToSaveMobileSettings = true;
            });
        }

        function savePayrollSettings(){
            var enabledFeatures = vm.features
                .filter(feature => feature.isEnabled)
                .map(feature => feature.featureKey);

            tenantsApi.updatedEnabledFeatures(enabledFeatures).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast("Payroll settings updated successfully.");
                } else {
                    ToastService.toast("Failed to update the payroll settings.");
                }
            }).catch(function(e) {
                vm.faledToSaveFeatures = true;
                exceptionService.resolve(e);
            });
        }

        function onChangeFeature(feature){
            if(feature.featureKey == "EnableMyob" || feature.featureKey == "EnableXero")
            {
                vm.hasPayrollIntegration = feature.isEnabled;
                vm.enablePayrollGroups = feature.isEnabled ? !feature.isEnabled : oldHasPayrollIntegrationValue;
            }

            if(feature.featureKey == "EnablePayroll"){
                vm.isPayrollEnabled = feature.isEnabled;
            }
        }

        function savePaperworkSettings() {
            vm.failedToSavePaperworkSettings = false;
            var payload = {
                IncludeBreakTime: vm.includeBreakTime ? 'true':'false',
                IncludeTravelTime: vm.includeTravelTime ? 'true':'false',
                IncludeShopTime: vm.includeShopTime ? 'true':'false',
                IncludeLoadTime: vm.includeLoadTime ? 'true':'false',
                HideGpsOnTimesheetPdf: vm.hideGpsOnTimesheetPdf.toString(),
                HideImageGpsOnPaperworkPdf: vm.hideImageGpsOnPaperworkPdf.toString(),
                HideNotesInTicketPDF: vm.hideNotesInTicketPDF===true ? 'true' : 'false'
            };

            tenantsApi.updateTenantSettings(payload).then(function(resp) {
                if (resp.data) {
                    refreshCachedTenantIdentity();
                    ToastService.toast(utils.translate('GENERAL_SETTINGS.PAPERWORK_SETTING_UPDATE_SUCCESSFUL'));
                    return;
                }

                ToastService.toast(utils.translate('GENERAL_SETTINGS.PAPERWORK_SETTING_UPDATE_FAILED'));
                vm.failedToSavePaperworkSettings = true;
            }).catch(function(e) {
                blockUI.stop();
                exceptionService.resolve(e);
                vm.failedToSavePaperworkSettings = true;
            });
        }

        function refreshCachedTenantIdentity() {
            generalSettingsApi.refreshCachedTenantIdentity();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.dashboard')
        .factory('dashboardService', dashboardService);

    function dashboardService(
        branchService,
        $mdDialog,
        dashboardApi,
        $q
    ) {
        var service = {
            lookups: [],
            dashboardDialogLoad: false,
            widgetTypes: [],
            widgets: [],
            datasets: [],
            userWidgets: [],
            showDialog: showDialog,
            getUserWidgets: getUserWidgets,
            getDatasets: getDatasets,
            getWidgetTypes: getWidgetTypes,
            getWidgetData: getWidgetData,
            getAvailableStaffsData: getAvailableStaffsData,
            getUnrosteredShiftsData: getUnrosteredShiftsData,
            getAvailableVehiclesData: getAvailableVehiclesData,
            getJobsBookedData: getJobsBookedData,
            loadLookups: loadLookups
        };

        return service;

        function showDialog() {
            showDialogContent();
        }

        function getUserWidgets(branches) {
            let deferred = $q.defer();
            if (service.userWidgets.length === 0) {
                dashboardApi.getStaticWidgets(branches).then(function(resp) {
                    deferred.resolve(resp.data);
                    service.userWidgets = resp.data;
                });
            } else {
                deferred.resolve(service.userWidgets);
            }
            return deferred.promise;
        }

        function getDatasets() {
            let deferred = $q.defer();
            dashboardApi.getWidgetDatasets().then(function(resp) {
                deferred.resolve(resp.data);
                service.datasets = resp.data;
            });
            return deferred.promise;
        }

        function getWidgetTypes() {
            let deferred = $q.defer();
            dashboardApi.getWidgetTypes().then(function(resp) {
                deferred.resolve(resp.data);
                service.widgetTypes = resp.data;
            });
            return deferred.promise;
        }

        function getLookups(allowCache) {
            let deferred = $q.defer();
            branchService.getAllBranches(allowCache).then(function(resp) {
                deferred.resolve(resp);
                service.lookups.Branches = resp;
                angular.forEach(service.lookups.Branches, function(branch) {
                    branch.id = branch.Id;
                })
            });
            return deferred.promise;
        }

        function loadLookups() {
            return $q.all([getLookups(true)]);
        }

        function showDialogContent() {
            service.dashboardDialogLoad = true;
            loadLookups().then(function() {
                service.dashboardDialogLoad = false;
                $mdDialog.show({
                    templateUrl: 'app/main/dashboard/manage/dashboard-manage-dialog.html',
                    controller: 'DashboardManageController as vm',
                    locals: {
                        userWidgets: service.userWidgets,
                        widgetTypes: service.widgetTypes,
                        datasets: service.datasets
                    }
                });
            });
        }

        function getWidgetData(params, forced) {
            let deferred = $q.defer();
            params.ForceRefresh = forced ? true : false;
            dashboardApi.getWidgetData(params).then(function(resp) {
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        function getAvailableStaffsData() {
            let deferred = $q.defer();
            dashboardApi.getAvailableStaffsData().then(function(resp) {
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        function getUnrosteredShiftsData() {
            let deferred = $q.defer();
            dashboardApi.getUnrosteredShiftsData().then(function(resp) {
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        function getAvailableVehiclesData() {
            let deferred = $q.defer();
            dashboardApi.getAvailableVehiclesData().then(function(resp) {
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        function getJobsBookedData() {
            let deferred = $q.defer();
            dashboardApi.getJobsBookedData().then(function(resp) {
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController)

        .directive('widgetTemplate', function () {
            return {
                restrict: 'E',
                scope: true,
                link: function (scope, element, attrs) {
                    scope.widget = JSON.parse(attrs['widget']);
                    scope.widget.currentRange = 8;
                    scope.widget.currentValue = "-";
                    scope.Id = scope.widget.Id;
                    if (scope.widget.Name === "Utilisation" || scope.widget.Name === "VehicleUtilisationPercent") {
                        scope.widget.currentRange = 5;
                    }
                    scope.getTemplateUrl = function () {
                        return 'app/main/dashboard/widgets/' + scope.widget.Type.Name + '.html';
                    };
                },
                template: '<div ng-include="getTemplateUrl()"></div>'
            };
        });

    /** @ngInject */
    function DashboardController ($timeout,
        utils,
        packeryService,
        identityService,
        localStorageService,
        $rootScope,
        $scope,
        blockUI,
        _,
        dashboardService,
        DashboardSignalRService) {

        var vm = this;
        var pckry = packeryService.Packery();

        vm.utilService = utils;
        vm.dashboardService = dashboardService;

        vm.isDraggable = true;
        vm.lockedStatus = "Unlocked";

        vm.lookups = {
            branches: [],
            divisions: []
        };

        vm.timeout = 60;

        vm.colors = [
            'red-fg',            // : key == 0,
            'light-blue-fg',     // : key == 1,
            'cyan-fg',           // : key == 2,
            'orange-fg',         // : key == 3,
            'light-green-fg',    // : key == 4,
            'teal-fg',           // : key == 5,
            'green-fg',          // : key == 6,
            'indigo-fg',         // : key == 7,
            'lime-fg',           // : key == 8,
            'yellow-fg',         // : key == 9,
            'amber-fg',          // : key == 10,
            'blue-fg',           // : key == 11,
            'deep-orange-fg',    // : key == 12,
            'brown-fg',          // : key == 13,
            'grey-fg',           // : key == 14,
            'blue-gray-fg',      // : key == 15,
            'deep-purple-fg',    // : key == 16,
            'pink-fg',           // : key == 17,
            'purple-fg',         // : key == 18,
        ];

        vm.dashboardSetup = localStorageService.get('dashboard.setup');
        if (!vm.dashboardSetup) {
            vm.dashboardSetup = {};
        }

        vm.widgets = {};
        vm.dashboardData = {};

        vm.timePeriods = {
            0: "Last month",
            1: "This month",
            2: "Next month",
            3: "Two weeks ago",
            4: "Last week",
            5: "This week",
            6: "Next week",
            7: "Yesterday",
            8: "Today",
            9: "Tomorrow",
            10: "All days in week"
        };

        vm.searchCriteria = localStorageService.get('dashboard.filter');
        vm.showDivisionFilter = true;
        if (!vm.searchCriteria) {
            vm.searchCriteria = {};
            var branchesKey = _.findIndex(identityService.userData.Claims, { type: "Branch" });
            var branchString = identityService.userData.Claims[branchesKey].value;
            if (branchString && typeof branchString === 'string') {
                vm.searchCriteria.Branches = branchString.split(',');
            }
            vm.searchCriteria.Divisions = -1;
            localStorageService.set('dashboard.filter', vm.searchCriteria);
        }


        $scope.$on('packeryInstantiated', function (e, el) {
        });

        $scope.$on('packeryObjectPacked', function (e, el) {
        });

        $scope.$on('getAllWidgetData', function () {
            vm.dashboardService.userWidgets.forEach(function (widget) {
                if(vm.widgets[widget.Id]){
                    vm.getWidgetData(widget.Id, widget.Name, vm.widgets[widget.Id].currentRange, false);
                }
            });
        });

        $scope.$on('prepWidgetData', function (ev, widgetData) {
            vm.prepWidgetData(widgetData);
        });

        vm.activate = activate;
        vm.initWidget = initWidget;
        vm.prepWidgetData = prepWidgetData;
        vm.getNewData = getNewData;
        vm.getWidgetData = getWidgetData;
        vm.displayData = displayData;
        vm.extractWidgetData = extractWidgetData;
        vm.refreshWidget = refreshWidget;
        vm.saveFilters = saveFilters;

        // Packery functions
        vm.saveDashboardSetup = saveDashboardSetup;
        vm.getWidgetPositions = getWidgetPositions;
        vm.setWidgetPositions = setWidgetPositions;
        vm.changeWidgetTimePeriod = changeWidgetTimePeriod;
        vm.toggleDraggable = toggleDraggable;
        vm.getHeight = getHeight;

        // fn listing
        function activate () {
            dashboardService.loadLookups().then(function () {
                vm.lookups.branches = dashboardService.lookups.Branches;
                if (vm.searchCriteria.Branches && vm.searchCriteria.Branches.length === 1) {
                    var match = alasql('select Name, Division from ? where id =?', [vm.lookups.branches, vm.searchCriteria.Branches[0]]);
                    if (match.length > 0) {
                        vm.lookups.divisions = match[0].Division;
                    }
                } else {
                    vm.lookups.divisions = [];
                }
                if (!vm.searchCriteria.Branches || vm.searchCriteria.Branches.length === 0 || vm.searchCriteria.Branches.length > 1 || vm.lookups.divisions.length === 0) {
                    vm.showDivisionFilter = false;
                } else {
                    vm.showDivisionFilter = true;
                }
                var branches = _.filter(vm.lookups.branches, function (b) {
                    return vm.searchCriteria.Branches.indexOf(b.Id) !== -1;
                });
                branches = alasql("SELECT Id, Name FROM ?", [branches]);
                dashboardService.getUserWidgets(branches);
            });
            DashboardSignalRService.register();
        }

        function initWidget (widget) {
            var Id = widget.Id;
            if (!vm.widgets[Id]) {
                vm.widgets[Id] = angular.copy(widget);
            }
            if (!vm.dashboardData[Id]) {
                vm.dashboardData[Id] = {};
            }

            var ranges = {
                "2W": "2 Weeks Ago",
                "LW": "Last Week",
                "TW": "This Week"
            };

            // BAR WIDGET - Utilization
            if (widget.Name === "Utilisation" || widget.Name === "VehicleUtilisation") {
                var wtype = "", color = [];
                if (widget.Name === "Utilisation") {
                    wtype = "multiBarChart";
                    color = ['#B3E5FC', '#03A9F4', '#DBEBC8', '#8BC34A'];
                }
                else if (widget.Name === "VehicleUtilisation") {
                    wtype = "multiBarHorizontalChart";
                    color = ['#03A9F4', '#8BC34A', '#B63330'];
                }
                vm.dashboardData[Id] = {
                    "title": widget.DisplayName,
                    "ranges": ranges,
                    "fullData": [],
                    "mainChart": []
                };
                vm.widgets[Id].title = vm.dashboardData[Id].title;
                vm.widgets[Id].mainChart = {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: wtype,
                            color: color,
                            //height: 534, // not needed anymore
                            margin: {
                                top: 44,
                                right: 32,
                                bottom: 32,
                                left: widget.Name === "VehicleUtilisation" ? 160 : 32
                            },
                            clipEdge: true,
                            groupSpacing: 0.3,
                            reduceXTicks: false,
                            stacked: false,
                            showControls: widget.Name !== "VehicleUtilisation",
                            duration: 250,
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {
                                return d.y;
                            },
                            yAxis: {
                                tickFormat: function (d) {
                                    return d;
                                }
                            },
                            legend: {
                                margin: {
                                    top: 8,
                                    bottom: 32
                                }
                            },
                            controls: {
                                margin: {
                                    top: 8,
                                    bottom: 32
                                }
                            },
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    },
                    data: []
                };
                vm.widgets[Id].days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                vm.widgets[Id].ranges = vm.dashboardData[Id].ranges;
                vm.widgets[Id].changeRange = function (range) {
                    var widgetName = this.Name;
                    vm.widgets[Id].currentRange = range; // "TW";

                    /**
                    * Update main chart data by iterating through the
                    * chart dataset and separately adding every single
                    * dataset by hand.
                    *
                    * You MUST NOT swap the entire data object by doing
                    * something similar to this:
                    * vm.widget.mainChart.data = chartData
                    *
                    * It would be easier but it won't work with the
                    * live updating / animated charts due to how d3
                    * works.
                    *
                    * If you don't need animated / live updating charts,
                    * you can simplify these greatly.
                    */
                    var mapped = {};
                    angular.forEach(vm.dashboardData[Id].mainChart, function (chartData, index) {
                        vm.widgets[Id].mainChart.data[index] = {
                            key: chartData.key,
                            values: chartData.values[range]
                        };
                        if (widgetName === "VehicleUtilisation") {
                            angular.forEach(chartData.values[range], function (data) {
                                if (mapped[data.x] === undefined) {
                                    mapped[data.x] = 0;
                                }
                                mapped[data.x] += data.y;
                            });
                        }
                    });
                    if (widgetName === "VehicleUtilisation") {
                        angular.forEach(vm.widgets[Id].mainChart.data, function (gData) {
                            gData.values = gData.values.filter(function (e) {
                                return this[e.x] !== 0;
                            }, mapped);
                        });
                    }
                };
                vm.widgets[Id].init = function () {
                    vm.widgets[Id].changeRange(5);
                };
            }
            else {
                vm.widgets[Id].currentValue = "-";
                vm.dashboardData[Id] = {
                    "title": widget.Name,
                    "fullData": [],
                    "mainChart": []
                };
            }
        }

        function prepWidgetData (widgetData) {
            if (!widgetData) {
                return;
            }
            var k = _.findIndex(vm.dashboardService.userWidgets, function (v) {
                var name = v.Name;
                name = name.replace(/\s/g, '');
                if (name.toUpperCase() === widgetData.Name.toUpperCase()) {
                    return true;
                }
                return false;
            });
            if (k === -1) {
                return;
            }
            var Id = vm.dashboardService.userWidgets[k].Id;
            var Name = vm.dashboardService.userWidgets[k].Name;

            var key = "";
            var branches = angular.copy(widgetData.BranchIds);
            branches = branches.sort();
            var params = {
                "WidgetId": Id,
                "BranchIds": branches,
                "TimePeriod": parseInt(widgetData.TimePeriod)
            };

            var cacheData = localStorageService.get("dashboard." + JSON.stringify(params));
            if (cacheData) {
                var c = new Date(cacheData.CreatedDate * 1000);
                var w = new Date(widgetData.CreatedDate * 1000);
                var day = moment(c).utc();
                var cur = moment(w).utc();
                if (cur.isAfter(day)) {
                    localStorageService.set("dashboard." + JSON.stringify(params), widgetData);
                }
            } else {
                localStorageService.set("dashboard." + JSON.stringify(params), widgetData);
            }

            if (!((JSON.stringify(widgetData.BranchIds.sort()) == JSON.stringify(vm.searchCriteria.Branches.sort())) && (widgetData.TimePeriod == vm.widgets[widgetData.WidgetId].currentRange))) {
                return;
            }

            vm.dashboardData[Id].fullData = widgetData;
            if (Name === "Utilisation" || Name === "VehicleUtilisation") {
                vm.extractWidgetData(Id, Name);
            }
            else {
                vm.dashboardService.userWidgets[k].DataSets = widgetData.Collections;
                if (!vm.dashboardService.userWidgets[k].DataPile) {
                    vm.dashboardService.userWidgets[k].DataPile = [];
                }
                vm.dashboardService.userWidgets[k].DataPile.push({ data: widgetData, criteria: vm.searchCriteria });
            }
            $timeout(function () {
                var blocker = blockUI.instances.get('block-' + Id);
                blocker.stop();
                vm.displayData(vm.dashboardService.userWidgets[k].Name, Id);
            });
        }

        function getNewData () {
            if (!vm.filterChange || vm.searchCriteria.Branches.length === 0) {
                return;
            }

            if (vm.searchCriteria.Branches && vm.searchCriteria.Branches.length === 1) {
                var match = alasql('select Name, Division from ? where id =?', [vm.lookups.branches, vm.searchCriteria.Branches[0]]);
                if (match.length > 0) {
                    vm.lookups.divisions = match[0].Division;
                }
            } else {
                vm.lookups.divisions = [];
            }
            if (!vm.searchCriteria.Branches || vm.searchCriteria.Branches.length === 0 || vm.searchCriteria.Branches.length > 1 || vm.lookups.divisions.length === 0) {
                vm.showDivisionFilter = false;
            } else {
                vm.showDivisionFilter = true;
            }
            vm.searchCriteria.Divisions = "-1";

            vm.dashboardService.userWidgets.forEach(function (widget) {
                vm.getWidgetData(widget.Id, widget.Name, vm.widgets[widget.Id].currentRange, false);
            });
            localStorageService.set('dashboard.filter', vm.searchCriteria);
        }

        function displayData (Name, Id) {
            var value = "-";
            var k = _.findIndex(vm.dashboardService.userWidgets, { Name: Name });
            if (vm.dashboardService.userWidgets[k].DataSets) {
                var dk = _.findIndex(vm.dashboardService.userWidgets[k].DataSets, function (d) {
                    if (d.DivisionId == vm.searchCriteria.Divisions) {
                        return true;
                    }
                    return false;
                });
                if (dk != -1) {
                    if (Name === "Utilisation" || Name === "VehicleUtilisation") {
                        value = vm.dashboardService.userWidgets[k].DataSets[dk].Datas.Values[0].Total;
                    }
                    else if(Name === "VehicleUtilisationPercent") {
                        value = vm.dashboardService.userWidgets[k].DataSets[dk].Datas.Values;
                    }
                    else {
                        value = vm.dashboardService.userWidgets[k].DataSets[dk].Datas[0].Total;
                    }
                    vm.widgets[Id].currentValue = value;
                }
            } else {
                vm.widgets[Id].currentValue = value;
            }
        }

        function extractWidgetData (Id, Name) {
            var mainChartData = [];
            if (!vm.dashboardData[Id].fullData.Collections) {
                return;
            }
            vm.dashboardData[Id].fullData.Collections.forEach(function (collection, i) {
                if (collection.DivisionId == vm.searchCriteria.Divisions) {
                    var pushData = {};
                    var key = collection.Datas.Key;
                    var order = 0;
                    if (key === "Allocated Staff" || key === "Required Staff") {
                        order = 0;
                    }
                    if (key === "Total Staff") {
                        order = 1;
                    }
                    if (key === "Allocated Vehicles" || key === "Required Vehicles") {
                        order = 2;
                    }
                    if (key === "Total Vehicles") {
                        order = 3;
                    }
                    pushData.key = key;
                    pushData.order = order;
                    pushData.values = {};
                    vm.widgets[Id].TimePeriods.forEach(function (period) {
                        pushData.values[period.Id] = [];
                    });
                    var val = collection.Datas.Values;
                    val.forEach(function (val, ii) {
                        var utcSeconds = val.Date; //1508025600;
                        //var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
                        //var day = moment(d.setUTCSeconds(utcSeconds)).format("ddd");
                        var d = new Date(utcSeconds * 1000);
                        var day = moment.utc(d).format("ddd");
                        if (Name === 'Utilisation') {
                            pushData.values[vm.widgets[Id].currentRange].push({ x: day, y: val.Total });
                        }
                        else if (Name === 'VehicleUtilisation') {
                            pushData.values[vm.widgets[Id].currentRange].push({ x: val.Name, y: val.Total });
                        }
                    });
                    mainChartData.push(pushData);
                }
            });
            mainChartData = _.sortBy(mainChartData, 'order');
            vm.dashboardData[Id].mainChart = mainChartData;
            vm.widgets[Id].changeRange(vm.widgets[Id].currentRange);
        }

        function getWidgetData (Id, Name, TimePeriod, forced) {
            vm.initWidget(vm.widgets[Id]);
            var blocker = blockUI.instances.get('block-' + Id);
            if (blocker.isBlocking()) {
                blocker.stop();
            }
            blocker.start({ message: 'Loading...' });
            $timeout(function () {
                blocker.stop();
            }, 1000 * vm.timeout);

            var branches = angular.copy(vm.searchCriteria.Branches);
            branches.sort();
            if(isNaN(TimePeriod) || _.isNil(TimePeriod)) {
                TimePeriod = Name !== "Utilisation" ? 8 : 5;
            }
            var params = {
                "WidgetId": Id, //wk,
                "BranchIds": branches,
                "TimePeriod": parseInt(TimePeriod)
            };

            var data = localStorageService.get("dashboard." + JSON.stringify(params));
            if (data && !forced) {
                var d = new Date(data.CacheExpirationDate * 1000);
                var day = moment(d).utc();
                var now = moment().utc();
                if (day.isAfter(moment())) {
                    $rootScope.$broadcast('prepWidgetData', data);
                } else {
                    $rootScope.$broadcast('prepWidgetData', data);
                    dashboardService.getWidgetData(params, false).then(function (data) {
                        $rootScope.$broadcast('prepWidgetData', data);
                    }, function (err) {
                        console.log('0x0001: ', err);
                    });
                }
            } else {
                dashboardService.getWidgetData(params, forced).then(function (data) {
                    $rootScope.$broadcast('prepWidgetData', data);
                }, function (err) {
                    console.log('0x0002: ', err);
                });
            }
        }

        function refreshWidget (widget, index) {
            vm.getWidgetData(widget.Id, widget.Name, vm.widgets[widget.Id].currentRange, true);
        }

        function saveFilters () {
            localStorageService.set('dashboard.filter', vm.searchCriteria);

            // Display data for selected division filter
            vm.dashboardService.userWidgets.forEach(function (widget) {
                if (widget.Name === 'Utilisation' || widget.Name === 'VehicleUtilisation') {
                    vm.extractWidgetData(widget.Id, widget.Name);
                } else {
                    vm.displayData(widget.Name, widget.Id);
                }
            });
        }

        function saveDashboardSetup () {
            // Use of actual elements to get setup
            var positions = {};
            vm.dashboardService.userWidgets.forEach(function (widget) {
                positions[widget.Id] = {
                    x: parseInt($("#" + widget.Id).css('left')),
                    y: parseInt($("#" + widget.Id).css('top'))
                };
            });
            vm.dashboardSetup = angular.copy(positions);
            localStorageService.set('dashboard.setup', vm.dashboardSetup);
        }

        function getWidgetPositions () {
            // Use of packery service to get setup
            pckry.then(function (pck) {
                var positions = {};
                if (pck.items && pck.items.length > 0) {
                    pck.items.forEach(function (e, i) {
                        var id = e.element.attributes.getNamedItem('id').value;
                        positions[id] = angular.copy(e.position);
                    });
                }
                vm.dashboardSetup = angular.copy(positions);
            });
        }

        function setWidgetPositions (id) {
            if (vm.dashboardSetup[id]) {
                $('#' + id + ".dragd").css('left', vm.dashboardSetup[id].x + 'px');
                $('#' + id + ".dragd").css('top', vm.dashboardSetup[id].y + 'px');
            }
        }

        function changeWidgetTimePeriod (widget, index, period) {
            var TimePeriod = period;
            vm.widgets[widget.Id].currentRange = period;
            vm.getWidgetData(widget.Id, widget.Name, TimePeriod, false);
        }

        function toggleDraggable () {
            if (vm.isDraggable) {
                vm.lockedStatus = "Unlocked";
            } else {
                vm.lockedStatus = "Locked";
            }
            vm.getWidgetPositions();
            vm.setWidgetPositions();
            return vm.isDraggable;
        }

        function getHeight (param) {
            var test = $('#' + param).find("div");
            if (test.length > 0) {
                return test[0].clientHeight;
            } else {
                return 0;
            }
        }

        vm.activate();
    }
})();

(function() {
    'use strict';

    angular.module('app.dashboard')
        .service('DashboardSignalRService', DashboardSignalRService);

    /** @ngInject */
    function DashboardSignalRService(
        signalRService,
        $timeout,
        $rootScope) {

        var service = {
            register: register
        };

        var isInitialized = false;

        return service;

        function register() {

            if (signalRService.isConnected) {
                regs();
            } else {
                $rootScope.$on('signalR_OnConnected', function() {
                    if (!isInitialized) {
                        regs();
                        isInitialized = true;
                    }
                });
            }

            function regs() {
                signalRService.messageHub.on('dashboardRefreshSingleWidget', function(data) {
                    $rootScope.$broadcast('prepWidgetData', data);
                });

                signalRService.messageHub.on('dashboardRefreshAll', function(data) {
                    $rootScope.$broadcast('getAllWidgetData');
                });

                $timeout(function() {
                    $rootScope.$broadcast('getAllWidgetData');
                }, 1000, true);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.custom-validations', ['dndLists', 'app.custom-validations-create'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.custom_rules_view', {
            url: '/custom/rules'
            , views: {
                'content@app': {
                    templateUrl: 'app/main/customValidations/custom-validations.html'
                    , controller: 'customValidationsController as vm'
                }
            }
            , data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasCustomRulesMenu;
                }] 
            },
            title : 'Manage Custom Rules',
            titleBar : 'Alloc8 - Custom Rules'
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.custom-validations')
        .factory('customValidationService', customValidationService);

    /** @ngInject */
    function customValidationService(
        customValidationsApi,
        $mdDialog,
        _,
        $timeout,
        exceptionService
    ) {
        let service = {
            rules: [],
            rulesJSON: [],
            loading: false,
            progress_message: null,
            loader_message: "Loading Rules ...",
            getRules: getRules,
            changeRuleStatus: changeRuleStatus,
            deleteRule: deleteRule,
        }

        return service;

        function getRules() {
            customValidationsApi.getCustomRules().then(function(resp) {
                service.rules = decorateRules(resp.data);
                service.loading = false;
            }).catch(function(ex) {
                service.loading = false;
                exceptionService.resolve(ex);
            });
        }

        function arrangeRules(rules) {
            return _.orderBy(rules, ['RuleName'], ['asc']);
        }

        function decorateRules(rules) {
            rules.forEach(function(rule) {
                rule['IsSaving'] = false;
            });
            return rules;
        }

        function deleteRule(rule) {
            let message = "Are you sure you want to delete this rule?";
            let confirm = $mdDialog.confirm()
                .title("Custom Rules")
                .textContent(message)
                .ok('Yes')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                rule['IsSaving'] = true;
                service.progress_message = "Deleting rule ...";
                $timeout(function() {
                    customValidationsApi.deleteRule(rule).then(function() {
                        rule['IsSaving'] = false;
                        service.progress_message = null;
                        let rules = deleteRuleFromList(rule.Id);
                        service.rules = decorateRules(rules);
                    }).catch(function(ex) {
                        rule['IsSaving'] = false;
                        exceptionService.resolve(ex);
                    });
                }, 1500)
            });
        }

        function deleteRuleFromList(Id) {
            return _.reject(service.rules, {
                Id: Id
            });
        }

        function changeRuleStatus(rule) {
            let message = "Are you sure you want to " + (rule.IsEnabled ? "disable" : "enable") + " this rule?";
            let confirm = $mdDialog.confirm()
                .title("Custom Rules")
                .textContent(message)
                .ok('Yes')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                rule['IsSaving'] = true;
                service.progress_message = rule.IsEnabled ? "Disabling rule ..." : "Enabling rule ...";
                rule.IsEnabled = !rule.IsEnabled;
                $timeout(function() {
                    customValidationsApi.changeRuleStatus(rule).then(function() {
                        rule['IsSaving'] = false;
                        service.progress_message = null;
                        service.rules = decorateRules(service.rules);
                    }).catch(function(ex) {
                        rule['IsSaving'] = false;
                        exceptionService.resolve(ex);
                    });
                }, 1500)
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.custom-validations')
        .controller('customValidationsController', customValidationsController);

    function customValidationsController(customValidationService, $state, _, $scope) {

        var vm = this;
        vm.service = customValidationService;
        vm.dtOptions = {
            dom : 'rt<"bottom"lip><"clear">',
            pagingType : 'full_numbers',
            autoWidth : true,
            responsive : false,
            ordering : false
        };

        vm.goToPlayArea = goToPlayArea;

        function activate(){
            vm.service.loading = true;
            vm.service.rules = [];
            vm.service.getRules()
        }

        $scope.$on("$destroy", function(){
            vm.service.rules.length = 0;
            vm.service.rulesJSON = null
            vm.service.loading = false
            vm.service.progress_message = null;
            vm.service.loader_message = null;
        });

        function goToPlayArea(rule){
            $state.go('app.custom_rules_create', {Id : _.isNil(rule) ? null : rule.Id});
        }

        activate();
    }
})();

(function() {
    'use strict';

    angular.module('app.custom-validations')
        .factory('customValidationsApi', customValidationsApi);

    function customValidationsApi(
        tenantSettings,
        _,
        $http
    ) {
        var customValidationRuleApiUrl = tenantSettings.coreApiUrl + 'api/customvalidationrule';

        return {
            getCustomRules: getCustomRules,
            changeRuleStatus: changeRuleStatus,
            deleteRule: deleteRule,
            saveRule: saveRule,
            getCustomRuleById: getCustomRuleById
        };

        function getCustomRules() {
            return $http.get(customValidationRuleApiUrl + "?module=0");
        }

        function getCustomRuleById(id) {
            return $http.get(customValidationRuleApiUrl + "/" + id);
        }

        function changeRuleStatus(rule) {
            return $http.put(customValidationRuleApiUrl + "/" + rule.Id, rule);
        }

        function deleteRule(rule) {
            return $http.delete(customValidationRuleApiUrl + "/" + rule.Id);
        }

        function saveRule(rule) {
            if (_.isNil(rule.Id)) {
                return $http.post(customValidationRuleApiUrl, rule);
            }

            return $http.put(customValidationRuleApiUrl + "/" + rule.Id, rule);
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.customFields')
    .controller('CustomisedFieldsController', CustomisedFieldsController);

  /** @ngInject */
  function CustomisedFieldsController(
              itemManagerService,
              $compile,
              _,
              utils,
              $scope,
              $mdDialog,
              customFieldsService,
              blockUI,
              EditMode,
              Id,
              Module) {

    //Data
    var vm = this;
    vm.Element = null;
    vm.Field = null;
    vm.MinValue = null;
    vm.MaxValue = null;
    vm.ValidationType = null;
    vm.Description = false;
    vm.Required = false;
    vm.CanBeValidated = false;
    vm.Lookups = [];
    vm.Variable = null;
    vm.Id = null;
    vm.Validate = true;
    vm.EditMode = false;
    vm.CategoryTypes = [];
    vm.IsVisible = true;
    vm.filteredFieldTypes = [];

    //Service
    vm.service = customFieldsService;
    vm.itemService = itemManagerService;

    //Fetch Look up
    vm.service.getLookUps(Module);

    //Methods
    vm.onSelectFieldType = onSelectFieldType;
    vm.close = close;
    vm.clearCustomFields = clearCustomFields;
    vm.initializeShortText = initializeShortText;
    vm.initializeWholeNUmber = initializeWholeNumber;
    vm.addMultipleItemsElementInitialize = addMultipleItemsElementInitialize;
    vm.addMultipleItemsElement = addMultipleItemsElement;
    vm.removeMultipleItemsElement = removeMultipleItemsElement;
    vm.addElementToForm = addElementToForm;
    vm.initializeWholeNumber = initializeWholeNumber;
    vm.initializeParagraph = initializeParagraph;
    vm.initializeEmail = initializeEmail;
    vm.initializeDecimal = initializeDecimal;
    vm.initializeUrl = initializeUrl;
    vm.mapField = mapField;
    vm.clearCustomFields();
    vm.Activate = Activate;
    vm.activateType = activateType;
    vm.initializeTime = initializeTime;

    vm.regexLabel = utils.translate("CUSTOMFIELDS.REGEX");
    vm.emailLabel = utils.translate("CUSTOMFIELDS.EMAIL");
    vm.decimalLabel = utils.translate("CUSTOMFIELDS.DECIMAL");
    vm.urlLabel = utils.translate("CUSTOMFIELDS.URL");
    vm.timeLabel = utils.translate("CUSTOMFIELDS.TIME");
    vm.chkboxLabel = utils.translate("CUSTOMFIELDS.CHKBOX");
    vm.wholLabel = utils.translate("CUSTOMFIELDS.WHOLE");
    vm.paragraphLabel = utils.translate("CUSTOMFIELDS.PARAGRAPH");
    vm.minLabel = utils.translate("CUSTOMFIELDS.MIN");
    vm.maxLabel = utils.translate("CUSTOMFIELDS.MAX");

    //Field Values
    var ShortAnswer =
      "<div layout='row'>" +
      "<md-input-container ng-show='vm.Validate'>" +
      "<input type='text'  ng-model='vm.ValidationType' placeholder='{{vm.regexLabel}}'>" +
      "</md-input-container>" +
      "</div>";

    var Email =
      "<div layout='row'>" +
      "<md-input-container flex>" +
      "<input type='text' placeholder='{{vm.emailLabel}}' ng-model='text0'>" +
      "</md-input-container>" +
      "</div>";

    var Decimal =
      "<div layout='row'>" +
      "<md-input-container flex>" +
      "<input type='text' placeholder='{{vm.decimalLabel}}' ng-model='text0'>" +
      "</md-input-container>" +
      "</div>";

    var Url =
      "<div layout='row'>" +
      "<md-input-container flex>" +
      "<input type='text' placeholder='{{vm.urlLabel}}' ng-model='text0'>" +
      "</md-input-container>" +
      "</div>";

    var Time =
      "<div layout='row'>" +
      "<md-input-container flex>" +
      "<input type='text' placeholder='{{vm.timeLabel}}' ng-model='text0' time-picker>" +
      "</md-input-container>" +
      "</div>";

    var CheckBox =
      "<md-checkbox ng-model='chkbox1'> Checkbox 1 </md-checkbox> <br>" +
      "<md-checkbox ng-model='chkbox2'> Checkbox 2 </md-checkbox>";

    //Whole Number element
    var WholeNumber =
      "<md-input-container ng-show='vm.Validate'>" +
      "<input type='number' ng-model='vm.MinValue' placeholder='{{vm.minLabel}}'>" +
      "</md-input-container>" +
      "<md-input-container ng-show='vm.Validate'>" +
      "<input type='number' ng-model='vm.MaxValue' placeholder='{{vm.maxLabel}}'>" +
      "</md-input-container>";

    var Dropdown =
      "<md-select ng-model='dropdown'>" +
      "<md-option>Value 1</md-option>" +
      "<md-option>Value 2</md-option>" +
      "</md-select>";

    var Paragraph =
      "<div layout='row'>" +
      "<md-input-container flex>" +
      "<textarea  ng-model='paragraph' md-maxlength='150' rows='5' md-select-on-focus placeholder='Paragraph'>" +
      "</md-input-container>" +
      "</div>";

    //Elements
    var multipleChoiceElem =
      "<md-radio-group>" +
      "<md-radio-button value='Option1' class='md-primary' disabled='true' aria-label='radio'></md-radio-button>" +
      "</md-radio-group>";

    var checkBoxElem =
      "<md-checkbox>" +
      "</md-checkbox>";

    var DropDownElem =
      "*";

    //Regular Multiple choice element
    var MultipleItemsElement = function(item) {

      vm['Option' + item.Id] = item.Value;

      var optionType = null;

      if(vm.Element.FieldValue == 1){
        optionType = multipleChoiceElem;
      }

      if(vm.Element.FieldValue == 2){
        optionType = checkBoxElem;
      }

      if(vm.Element.FieldValue == 12){
        optionType = checkBoxElem;
      }

      if(vm.Element.FieldValue == 4){
        optionType = DropDownElem;
      }

      var element =
        "<div layout='row' style='margin-bottom:-50px;margin-top:10px;'>" +
          "<div flex='5'>" +
              optionType +
          "</div>" +
          "<div flex='70'>" +
              "<md-input-container flex class='md-block' style='position:relative; top:-30px;'>" +
                  "<input type='text' " + " ng-model="+ "'vm.Option" + item.Id +"'>" +
              "</md-input-container>" +
          "</div>" +
          "<div flex>" +
              "<md-button style='position: relative;top:-10px;' class='md-accent' ng-click='vm.removeMultipleItemsElement(" + item.Id + ")' translate='CUSTOMFIELDS.REMOVE'></md-button>" +
          "</div>" +
        "</div>";

      return element;
    }

    function activateType(){
      if(Module == 1){
        vm.appear = true;
        vm.module = 1;
        vm.moduleType = utils.translate('CUSTOMFIELDS.CONTACT_TYPE');
      }

      if(Module == 2){
        vm.appear = true;
        vm.module = 2;
        vm.moduleType = utils.translate('CUSTOMFIELDS.COMPANY_TYPE');
      }

      if(Module == 3){
        vm.appear = false;
        vm.module = 3;
      }

      if(Module == 4){
        vm.appear = true;
        vm.module = 4;
        vm.moduleType = utils.translate('CUSTOMFIELDS.ITEM_TYPE');
      }

      if(Module == 5){
        vm.appear = true;
        vm.module = 5;
        vm.moduleType = utils.translate('CUSTOMFIELDS.JOB_TYPE');
      }
    }

    function returnOptionType(FieldValue){
      if(FieldValue == 1){
        return multipleChoiceElem;
      }

      if(FieldValue == 2){
        return checkBoxElem;
      }

      if(FieldValue == 12){
        return checkBoxElem;
      }

      if(FieldValue == 4){
        return DropDownElem;
      }
    }

    //Multiple Choice Element - Other
    var MultipleItemsOtherElement = function(item) {

      var optionType = returnOptionType(vm.Element.FieldValue);

      var element =
        "<div layout='row' style='margin-top:10px;'>" +
            "<div flex='5'>" +
                  optionType +
            "</div>" +
            "<div flex='70'>" +
                  "<span>Other...</span>" +
            "</div>" +
            "<div flex>" +
                "<md-button style='position: relative;top:-10px;' class='md-accent' ng-click='vm.removeMultipleItemsElement(" + item.Id + ")' translate='CUSTOMFIELDS.REMOVE'></md-button>" +
            "</div>" +
        "</div>";

      return element;
    }

    //Multiple Choice Element Links - Option only
    var MultipleItemsAddAction = function(){

      var optionType = returnOptionType(vm.Element.FieldValue);

      var element =
        "<div layout='row' style='margin-bottom:10px;margin-top:10px;'>" +
            "<div flex='5'>" +
                  optionType +
            "</div>" +
            "<div flex='50'>" +
                  "<a href='' class='md-primary' style='position:relative; color: #0073e8; position:left:-10px;text-decoration: none;' class='md-caption' ng-click='vm.addMultipleItemsElement(0)' translate='CUSTOMFIELDS.ADD_OPTION'></a>" +
            "</div>" +
        "</div>";

      return element;
    }

    //Multiple Choice Element Links - Option and Other
    var MultipleItemsAddOtherAction = function(){

      var optionType = returnOptionType(vm.Element.FieldValue);

      var element =
        "<div layout='row' style='margin-bottom:10px;margin-top:10px;'>" +
              "<div flex='5'>" +
                  optionType +
              "</div>" +
              "<div flex='50'>" +
                  "<a href='' class='md-primary' style='color: #0073e8;position:relative;bottom:5px;position:left:-10px;text-decoration: none;' class='md-caption' ng-click='vm.addMultipleItemsElement(0)'>Add option</a>" +
                  "<span style='position:relative;bottom:5px;'> or Add " + "<a href='' class='md-primary' ng-click='vm.addMultipleItemsElement(1)'><span class='md-body-2' style='color: #0073e8;' translate='CUSTOMFIELDS.OTHER'></span></a></span>"
              "</div>" +
      "</div>";

      return element;
    }

    //Close Dialog
    function close(){
      $mdDialog.hide(0);
    }

    //Clear Custom Fields
    function clearCustomFields(){
      vm.Element = null;
      vm.Field = null;
      vm.Description = null;
      vm.Required = false;
      vm.CanBeValidated = false;
      vm.MinValue = null;
      vm.MaxValue = null;
      vm.IsVisible = true;
    }

    //Save form element
    function addElementToForm()
    {
      //If chosen element is multiple choice
      if((vm.Element.FieldValue == 1) || (vm.Element.FieldValue == 2) || (vm.Element.FieldValue == 4) || (vm.Element.FieldValue == 12)){
        angular.forEach(vm.Element.Items, function(value, key){
          value.Value = vm['Option' + value.Id];
        });
      }

      vm.Element.Field = vm.Field;
      vm.Element.Description = vm.Description;
      vm.Element.Required = vm.Required;
      vm.Element.MinValue = vm.MinValue;
      vm.Element.MaxValue = vm.MaxValue;
      vm.Element.Variable = vm.Variable;
      vm.Element.ValidationType = vm.ValidationType;
      vm.Element.LookUps = angular.copy(vm.LookUps);
      vm.Element.Categories = vm.CategoryTypes;
      vm.Element.IsVisible = vm.IsVisible;

      if(angular.isDefined(vm.Id)){
        vm.Element.Id = vm.Id;
      }

      vm.Lookups = [];

      blockUI.start(utils.translate('CUSTOMFIELDS.SAVING'));
      customFieldsService.saveCustomFields(vm.Element, Module, vm.EditMode).then(function(resp){
        blockUI.stop();
        $mdDialog.hide(vm.Element);
      });
    }

    function initializeShortText(){
      return ShortAnswer;
    }

    function initializeTime(){
      return Time;
    }

    function initializeEmail(){
      return Email;
    }

    function initializeDecimal(){
      return Decimal;
    }

    function initializeUrl(){
      return Url;
    }

    function initializeParagraph(){
      return Paragraph;
    }

    function initializeWholeNumber(){
      return WholeNumber;
    }

    //Initialize Multiple Choice Form
    function addMultipleItemsElementInitialize(element){
      var el = "";

      angular.forEach(element.Items, function(value){
        if(value.Type == 'Regular'){
          el += MultipleItemsElement(value);
        }
        else{
          el += MultipleItemsOtherElement(value);
        }

        vm[value.Model] = value.Value;
      });

      if(vm.Element.FieldValue == 4 || vm.Element.FieldValue == 12){
        el += MultipleItemsAddAction();
      }
      else{
        var otherTypeCount = alasql("select * from ? where Type = 'Other'", [vm.Element.Items]);

        if(otherTypeCount.length > 0){
          el += MultipleItemsAddAction();
        }
        else{
          el += MultipleItemsAddOtherAction();
        }
      }
      return el;
    }

    //Remove Multiple Choice element
    function removeMultipleItemsElement(value){
      assignOptions();
      if(vm.Element.Items.length > 2){
        angular.forEach(vm.Element.Items, function(val, key){
          if(value == val.Id){
            vm.Element.Items.splice(key, 1);
          }
        });

        changeForm(vm.Element);
      }
    };

    //Bind option items in multi element items
    function assignOptions(){
      angular.forEach(vm.Element.Items, function(value){
        value.Value = vm['Option' + value.Id];
      });
    }

    //Adds option to element
    function addMultipleItemsElement(type){
      var lastID = vm.Element.Items.length > 0 ? alasql('select Id from ? order by Id desc', [vm.Element.Items])[0].Id : 0;
      var nextId = lastID + 1;
      var optionType = null;

      assignOptions();

      //Option Type
      if(type == 0){
        optionType = 'Regular';
      }
      else{
        optionType = 'Other';
      }

      var option = {
        Id : nextId,
        Value : 'Option',
        Name : 'Option' + nextId,
        Type : optionType
      }
      vm.Element.Items.push(option);
      changeForm(vm.Element);
    };

    function getRelatedFieldTypes(fields){
      let filteredFields = [];
      angular.forEach(fields, function(field){
        let res = alasql('select * from ? where FieldName = ?', [vm.service.FieldTypes, field]);
        if(res.length > 0){
          filteredFields.push(res[0]);
        }
      });
      return filteredFields;
    }

    function Activate(){
      vm.Lookups = [];
      if(EditMode){
        customFieldsService.getField(Id).then(function(resp){
          let fieldType = alasql('select * from ? where FieldValue = ?', [vm.service.FieldTypes, resp.data.FieldType])[0];
          vm.filteredFieldTypes = getRelatedFieldTypes(fieldType.Related);
          vm.EditMode = true;
          vm.lookup = resp.data.LookupTypes;
          vm.mapField(resp.data);
        });
      }
      else {
        vm.EditMode = false;
      }
    }

    function mapField(data){
      vm.LookUps = [];
      var field = alasql('select * from ? where FieldValue = ?', [vm.service.FieldTypes, parseInt(data.FieldType)]);
      vm.element = null;
      vm.Element = field[0];
      vm.FieldType = data.FieldType;
      vm.Description = data.Description;
      vm.Field = data.FieldTitle;
      vm.MinValue = data.MinValue;
      vm.MaxValue = data.MaxValue;
      vm.Required = data.IsRequired;
      vm.Variable = data.Variable
      vm.Id = data.id;
      vm.LookUps = data.LookupTypes;
      vm.ValidationType = data.ValidationRegexPattern;
      vm.IsVisible = data.IsVisible;

      if((vm.Element.FieldValue == 0) || (vm.Element.FieldValue == 3)){
        vm.CanBeValidated = true;
        vm.Validate = true;
      }
      else{
        vm.CanBeValidated = false;
        vm.Validate = true;
      }

      vm.Element.Items = [];

      //Convert Option to Items
      angular.forEach(data.Option, function(value, key){
        var option = {
          Id : key + 1,
          Value : value.Value,
          Name : value.Name,
          Type : value.Type
        }

        vm['Option' + (key + 1)] = value.Value;
        vm.Element.Items.push(option);
      });

      vm.lookUpBackUp = data.LookupTypes;

      //Category and Item Types Binding to Assets Module
      //Convert LookupTypes to LookUps
      if(vm.module == 4){
        //Category Type Binding
        angular.forEach(data.CategoryTypes, function(category1){
          angular.forEach(vm.service.CategoryTypes, function(category2){
            if(category1.Name == category2.Name){
              var category = {
                Id: category2.Id,
                Name: category2.Name
              }
              vm.CategoryTypes.push(category2);
              category2['Selected'] = true;
            }
          });
        });

        //Item Type Binding
        angular.forEach(data.LookupTypes, function(lookUp1){
          angular.forEach(vm.service.LookupTypes, function(lookUp2){
            if(lookUp1.Name == lookUp2.Name){
              lookUp2['Selected'] = true;
              var lookup =
              {
                Id : lookUp2.Id,
                TypeName : lookUp2.Name
              }
              vm.Lookups.push(lookup);
            }onSelectFieldType
          });
        });
      }

      vm.onSelectFieldType(data.FieldType);
    }

    //Bind elements to form for viewing
    function changeForm(el){
      var element = vm.addMultipleItemsElementInitialize(el);
      angular.element(document.querySelector('#form')).empty();
      angular.element(document.querySelector('#form')).append($compile(element)($scope));
    }

    //Replaces the item values to "Option"
    function cleanItems(Element){
      angular.forEach(Element.Items, function(item){
        item.Value = "Option";
      });
    }

    //If user changes the field type in dialog
    function onSelectFieldType(FieldType){
      var field = alasql('select * from ? where FieldValue = ?', [vm.service.FieldTypes, parseInt(FieldType)]);

      if(!vm.EditMode){
        cleanItems(field[0].Items)
        vm.element = null;
      }

      angular.element(document.querySelector('#form')).empty();

      //Short Text
      if(FieldType == 0){
        vm.Element = field[0];
        var generatedField = vm.initializeShortText();
        angular.element(document.querySelector('#form')).append($compile(generatedField)($scope));
      }

      if(FieldType == 13){
        vm.Element = field[0];
        var generatedField = vm.initializeTime();
        angular.element(document.querySelector('#form')).append($compile(generatedField)($scope));
      }

      if(FieldType == 2 || FieldType == 12 || FieldType == 4 || FieldType == 1){
        angular.forEach(field[0].Items, function(itm){
          itm.Value = "Option";
        });
        field[0].Items = _.isNil(vm.Element) ? field[0].Items : vm.Element.Items;
        vm.Element = field[0];
        var generatedField = vm.addMultipleItemsElementInitialize(vm.Element);
        angular.element(document.querySelector('#form')).append($compile(generatedField)($scope));
      }

      if(FieldType == 3){
        vm.Element = field[0];
        var generatedField = vm.initializeWholeNumber(vm.Element);
        angular.element(document.querySelector('#form')).append($compile(generatedField)($scope));
      }

      if(FieldType == 5){
        vm.Element = field[0];
      }

      if(FieldType == 6){
        vm.Element = field[0];
      }

      if(FieldType == 7){
        vm.Element = field[0];
      }

      if(FieldType == 8){
        vm.Element = field[0];
      }

      vm.CanBeValidated = field[0].CanBeValidated;
    }
    vm.Activate();
    vm.activateType();
  }
})();

(function() {
    'use strict';

    angular
        .module('app.contact')
        .constant('CONTACT_TYPES', {
            EMPLOYEE: 1,
            CLIENT: 2,
            LABOURHIRE: 3,
            EXTERNAL: 4
        })
        .constant('CONTACT_ROLES', {
            CREATE_EMPLOYEE: 'Create Employees',
            MANAGE_EMPLOYEE: 'Manage Employees',
            CREATE_LABOUR_HIRE: 'Create Labour Hire',
            PAYROLL: 'Payroll',
            MANAGE_EMPLOYEE_PAYROLL: 'Manage Employee Payroll',
            MANAGE_LOGIN_ACCOUNT: 'Manage Login Accounts',
            ARCHIVE_EMPLOYEE: 'Archive Employees',
            REMOVE_CONTACT_SKILL: 'Remove Contact Skills',
            MANAGE_CONTACT_SKILL: 'Manage Contact Skills'
        });
})();

(function () {
    'use strict';

    angular
        .module('app.commentRestrictions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.comment_restrictions', {
            url: '/comment/restrictions',
            views: {
                'content@app': {
                    templateUrl: 'app/main/commentRestriction/manage-comment-restrictions.html',
                    controller: 'CommentRestrictionsController as vm'
                }
            },
            data: {
                requireLogin: true,
                validateAccess: ['adminClaimsService', function (adminClaimsService) {
                    return adminClaimsService.hasCommentRestrictionsAccess;
                }] 
            },
            title: 'Manage Comment Restrictions',
            titleBar: 'Alloc8 - Comment Restrictions'
        });

        $translatePartialLoaderProvider.addPart('app/main/commentRestriction');
    }

})();

(function() {
    'use strict';

    angular.module('app.commentRestrictions')
        .factory('CommentRestrictionsService', CommentRestrictionsService);

    /** @ngInject */
    function CommentRestrictionsService(
        _,
        $q,
        $http,
        commentRestrictionsApi,
        $mdDialog,
        utils,
        exceptionService,
        hubService,
        commentRestrictionsModel
    ) {
        var service = {
            initial_module: 1,
            initializing: false,
            modules: [],
            header_message: null,
            initialize: initialize,
            openCommentRestrictionDialog: openCommentRestrictionDialog,
            deleteCommentRestriction: deleteCommentRestriction,
            save: save,
            update: update,
            reset: reset
        };

        return service;

        function getAllComments() {
            return commentRestrictionsApi.getCommentRestrictions();
        }

        function openCommentRestrictionDialog(forEdit, module, comment) {

            var prompt = $mdDialog.prompt()
                .title(utils.translate("COMMENT_RESTRICTION.HEADER"))
                .required(true)
                .initialValue(forEdit ? comment.Name : null)
                .placeholder(utils.translate("COMMENT_RESTRICTION.CLAIM_NAME"))
                .ok(utils.translate("COMMENT_RESTRICTION.SAVE"))
                .cancel(utils.translate("COMMENT_RESTRICTION.CANCEL"));

            $mdDialog.show(prompt).then(function(result) {
                if (forEdit) {
                    if (comment.Name != result) {
                        comment.Name = result;
                        let model = new commentRestrictionsModel(comment);
                        service.update(model.transformToModel(), comment, module);
                    }
                } else {
                    let model = new commentRestrictionsModel();
                    model.Name = result;
                    model.Group = module.Id;
                    model.GroupName = module.Name;
                    service.save(model.transformToModel(), module);
                }
            });
        }

        function save(model, module) {
            module.Saving = true;
            setTimeout(function() {
                commentRestrictionsApi.addCommentRestriction(model)
                    .then(function(resp) {
                        module.Comments.push(resp.data)
                        module.Comments = constructComments(module.Comments);
                        module.Saving = false;
                        hubService.showToast(utils.translate("COMMENT_RESTRICTION.ADD_SUCCESS"));
                    })
                    .catch(function(err) {
                        module.Saving = false;
                        exceptionService.resolve(err);
                    });
            }, 1500);
        }

        function update(model, comment, module) {
            module.Saving = true;
            comment.Saving = true;
            setTimeout(function() {
                commentRestrictionsApi.updateCommentRestriction(model)
                    .then(function() {
                        let new_comments = angular.copy(module.Comments);
                        new_comments.forEach(function(com) {
                            if (com.Id === comment.Id) {
                                com.Name = model.Name
                            }
                        });
                        module.Comments = constructComments(new_comments);
                        comment.Saving = false;
                        module.Saving = false;
                        hubService.showToast(utils.translate("COMMENT_RESTRICTION.UPDATE_SUCCESS"));
                    }).catch(function(err) {
                        comment.Saving = false;
                        module.Saving = false;
                        exceptionService.resolve(err);
                    });
            }, 1500);
        }

        function deleteCommentRestriction(comment, group, mod) {
            var confirm = $mdDialog.confirm()
                .title(utils.translate("COMMENT_RESTRICTION.HEADER"))
                .textContent(utils.translate("COMMENT_RESTRICTION.DELETE_QUESTION"))
                .ok(utils.translate("COMMENT_RESTRICTION.YES"))
                .cancel(utils.translate("COMMENT_RESTRICTION.NO"))

            $mdDialog.show(confirm).then(function() {
                mod.Saving = true;
                comment.Saving = true;
                setTimeout(function() {
                    commentRestrictionsApi.deleteCommentRestriction(comment.Id)
                        .then(function() {
                            service.modules.forEach(function(module) {
                                if (module.Id == group) {
                                    module.Comments = _.reject(module.Comments, {
                                        Id: comment.Id
                                    });
                                }
                            });
                            comment.Saving = false;
                            mod.Saving = false;
                            hubService.showToast(utils.translate("COMMENT_RESTRICTION.DELETE_SUCCESS"));
                        }).catch(function(err) {
                            mod.Saving = false;
                            comment.Saving = false;
                            exceptionService.resolve(err);
                        });
                }, 1500);

            });
        }

        function initialize() {
            service.reset();
            service.initializing = true;
            setTimeout(function() {
                $q.all([$http.get("app/main/CommentRestriction/lookups.json"), getAllComments()])
                    .then(function(resp) {
                        service.modules = resp[0].data.Modules;
                        service.modules.forEach(function(module) {
                            module.Comments = resp[1].data.filter(function(comment) {
                                return comment.Group == module.Id
                            });
                            module.Comments = constructComments(module.Comments);
                        });
                        service.initializing = false;
                    });
            }, 2000)
        }

        function constructComments(comments) {
            return orderComments(comments.map(function(comment) {
                return {
                    Id: comment.Id,
                    UserAccessClaimId: comment.UserAccessClaimId,
                    Name: comment.Name,
                    Group: comment.Group,
                    GroupName: comment.GroupName,
                    Saving: false
                }
            }));
        }

        function orderComments(comments) {
            return alasql("select * from ? order by Name", [comments]);
        }

        function reset() {
            service.modules = [];
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.commentRestrictions')
        .service('commentRestrictionsModel', commentRestrictionsModel);

    function commentRestrictionsModel() {
        return function (options) {
            var self = this;

            var defaults = {
                Id : null,
                UserAccessClaimId : null,
                Name : null,
                Group : null,
                GroupName : null,
                Saving : false
            };

            self.map = mapper;
            self.transformToModel = transformToModel;
            self.reset = reset;

            self.map(options);

            function mapper(opts) {
                var mapValue = opts || {}
                    , opts = angular.extend(this, defaults, mapValue);
            }

            function reset() {
                this.Id = null;
                this.UserAccessClaimId = null;
                this.Name = null;
                this.Group = null;
                this.GroupName = null;
                this.Saving = false;
            }

            function transformToModel() {
                var serverModel = {
                    Id : self.Id,
                    UserAccessClaimId : self.UserAccessClaimId,
                    Name : self.Name,
                    Group : self.Group,
                    GroupName : self.GroupName
                }
                return serverModel;
            }

        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.commentRestrictions')
        .controller('CommentRestrictionsController', CommentRestrictionsController);

    function CommentRestrictionsController(CommentRestrictionsService, mediaQueryService) {

        var vm = this;
        vm.service = CommentRestrictionsService;
        vm.mediaService = mediaQueryService;
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            sort: true
        };

        vm.activate = activate;

        function activate(){
            vm.service.initialize();
        }

        vm.activate();
    }
})();

{
    angular.module('app.commentRestrictions')
        .factory('commentRestrictionsApi', commentRestrictionsApi);

    /** @ngInject */
    function commentRestrictionsApi(
        $http,
        tenantSettings
    ) {
        return {
            getCommentRestrictions: getCommentRestrictions,
            deleteCommentRestriction: deleteCommentRestriction,
            addCommentRestriction: addCommentRestriction,
            updateCommentRestriction: updateCommentRestriction
        };

        function getCommentRestrictions() {
            return $http.get(tenantSettings.coreApiUrl + "/api/comments/restrictions")
        }

        function deleteCommentRestriction(Id) {
            return $http.delete(tenantSettings.coreApiUrl + "/api/comments/restrictions/" + Id);
        }

        function addCommentRestriction(pay_load) {
            return $http.post(tenantSettings.coreApiUrl + "/api/comments/restrictions/", pay_load);
        }

        function updateCommentRestriction(pay_load) {
            return $http.put(tenantSettings.coreApiUrl + "/api/comments/restrictions/" + pay_load.Id, pay_load);
        }
    }
}

(function() {
    'use strict';

    angular
        .module('app.manage-awards')
        .constant('CONDITION_OPERATORS', {
            OR: 0,
            AND: 1
        })
        .constant('CONDITION_VALUE_TYPES', {
            TEXT: 1,
            NUMBER: 2,
            HOURS: 3,
            BOOLEAN: 4,
            KMS: 5,
            DAY: 6,
            DAYS: 7,
            EMPLOYMENT_STATUSES: 8
        });
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'blue-grey',
                hues: {
                    'default': '700',
                    'hue-1'  : '700',
                    'hue-2'  : '700',
                    'hue-3'  : '700'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            switch (color.length) {
                case 3:
                    return 'rgb(' + color.join(',') + ')';
                case 4:
                    return 'rgba(' + color.join(',') + ')';
                default:
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                return;
            }

            if ( !angular.isArray(resource) )
            {
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService(
        $q,
        apiService
    ) {
        var service = {
            resolve: resolve
        };

        return service;

        function resolve(action, parameters) {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if (!resource || !method) {
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if (!apiObject) {
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            } else {
                apiObject[method](params,

                    // Success
                    function(response) {
                        deferred.resolve(response);
                    },

                    // Error
                    function(response) {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        function getApiObject(resource) {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.');
            var apiObject = apiService;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for (var l = 0; l < resourceParts.length; l++) {
                if (angular.isUndefined(apiObject[resourceParts[l]])) {
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if (!apiObject) {
                return false;
            }

            return apiObject;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate () {
        return function (value) {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if (diff < (60 * 60 * 1000)) {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if (diff < (60 * 60 * 24 * 1000)) {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if (diff < (60 * 60 * 24 * 7 * 1000)) {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.toolbar', [])
    .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {

    $translatePartialLoaderProvider.addPart('app/toolbar');
  }
})();

(function() {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(
        $rootScope,
        $mdSidenav,
        $translate,
        $mdToast,
        authApi,
        identityService,
        pageHistoryService,
        exceptionService,
        todoNotificationService,
        loginService) {

        var vm = this;

        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            }
        };

        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.hasNotifications = todoNotificationService.hasUnreadNotification;

        init();

        function init() {
            vm.userStatus = vm.userStatusOptions[0];
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            identityService.fetchUserData()
                .then(function(resp) {
                    vm.userData = resp;
                })
                .catch(function(ex) {
                    exceptionService.resolve(ex);
                });
        }

        function toggleSidenav(sidenavId) {
            todoNotificationService.refreshNotifications({
                refreshMode: todoNotificationService.refreshOptions.getAll
            });
            $mdSidenav(sidenavId)
                .toggle();
        }

        function setUserStatus(status) {
            vm.userStatus = status;
        }

        function logout() {

            var promise = pageHistoryService.saveHistory();
            if (promise) {
                promise.finally(function() {
                    pageHistoryService.clearHistoryCache();

                    authApi.logout()
                        .then(function() {
                            loginService.onLogout();
                        })
                        .catch(function(ex) {
                            exceptionService.resolve(ex);
                        });
                });
            } else {
                pageHistoryService.clearHistoryCache();

                authApi.logout()
                    .then(function() {
                        loginService.onLogout();
                    })
                    .catch(function(ex) {
                        exceptionService.resolve(ex);
                    });
            }
        }

        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            $translate.use(lang.code);
        }

        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        vm.hasNotifications = function() {
            return todoNotificationService.hasUnreadData();
        };

        vm.getHeaderText = function() {
            let ticketNum = $rootScope.state.params.ticketNumber || $rootScope.state.params.TicketNo || $rootScope.state.params.ticketNo;
            let ticketDate = $rootScope.state.current.ticketStartDate;
            let ticketDisplayDate = _.isNil(ticketDate) ?
                "" : " (" + moment(ticketDate)
                .format("dddd, Do MMM YYYY") + ")";

            return _.isNil(ticketNum) ? $rootScope.state.current.title :
                $rootScope.state.current.title + " #" + ticketNum + ticketDisplayDate;
        };

        $rootScope.$on("LoadToolbarUserData", init);
    }
})();

/*!
 * Draggabilly PACKAGED v1.1.1
 * Make that shiz draggable
 * http://draggabilly.desandro.com
 * MIT license
 */

!function(a){function b(a){return new RegExp("(^|\\s+)"+a+"(\\s+|$)")}function c(a,b){var c=d(a,b)?f:e;c(a,b)}var d,e,f;"classList"in document.documentElement?(d=function(a,b){return a.classList.contains(b)},e=function(a,b){a.classList.add(b)},f=function(a,b){a.classList.remove(b)}):(d=function(a,c){return b(c).test(a.className)},e=function(a,b){d(a,b)||(a.className=a.className+" "+b)},f=function(a,c){a.className=a.className.replace(b(c)," ")});var g={hasClass:d,addClass:e,removeClass:f,toggleClass:c,has:d,add:e,remove:f,toggle:c};"function"==typeof define&&define.amd?define("classie/classie",g):a.classie=g}(window),function(){function a(){}function b(a,b){for(var c=a.length;c--;)if(a[c].listener===b)return c;return-1}function c(a){return function(){return this[a].apply(this,arguments)}}var d=a.prototype;d.getListeners=function(a){var b,c,d=this._getEvents();if("object"==typeof a){b={};for(c in d)d.hasOwnProperty(c)&&a.test(c)&&(b[c]=d[c])}else b=d[a]||(d[a]=[]);return b},d.flattenListeners=function(a){var b,c=[];for(b=0;b<a.length;b+=1)c.push(a[b].listener);return c},d.getListenersAsObject=function(a){var b,c=this.getListeners(a);return c instanceof Array&&(b={},b[a]=c),b||c},d.addListener=function(a,c){var d,e=this.getListenersAsObject(a),f="object"==typeof c;for(d in e)e.hasOwnProperty(d)&&-1===b(e[d],c)&&e[d].push(f?c:{listener:c,once:!1});return this},d.on=c("addListener"),d.addOnceListener=function(a,b){return this.addListener(a,{listener:b,once:!0})},d.once=c("addOnceListener"),d.defineEvent=function(a){return this.getListeners(a),this},d.defineEvents=function(a){for(var b=0;b<a.length;b+=1)this.defineEvent(a[b]);return this},d.removeListener=function(a,c){var d,e,f=this.getListenersAsObject(a);for(e in f)f.hasOwnProperty(e)&&(d=b(f[e],c),-1!==d&&f[e].splice(d,1));return this},d.off=c("removeListener"),d.addListeners=function(a,b){return this.manipulateListeners(!1,a,b)},d.removeListeners=function(a,b){return this.manipulateListeners(!0,a,b)},d.manipulateListeners=function(a,b,c){var d,e,f=a?this.removeListener:this.addListener,g=a?this.removeListeners:this.addListeners;if("object"!=typeof b||b instanceof RegExp)for(d=c.length;d--;)f.call(this,b,c[d]);else for(d in b)b.hasOwnProperty(d)&&(e=b[d])&&("function"==typeof e?f.call(this,d,e):g.call(this,d,e));return this},d.removeEvent=function(a){var b,c=typeof a,d=this._getEvents();if("string"===c)delete d[a];else if("object"===c)for(b in d)d.hasOwnProperty(b)&&a.test(b)&&delete d[b];else delete this._events;return this},d.emitEvent=function(a,b){var c,d,e,f,g=this.getListenersAsObject(a);for(e in g)if(g.hasOwnProperty(e))for(d=g[e].length;d--;)c=g[e][d],f=c.listener.apply(this,b||[]),(f===this._getOnceReturnValue()||c.once===!0)&&this.removeListener(a,c.listener);return this},d.trigger=c("emitEvent"),d.emit=function(a){var b=Array.prototype.slice.call(arguments,1);return this.emitEvent(a,b)},d.setOnceReturnValue=function(a){return this._onceReturnValue=a,this},d._getOnceReturnValue=function(){return this.hasOwnProperty("_onceReturnValue")?this._onceReturnValue:!0},d._getEvents=function(){return this._events||(this._events={})},"function"==typeof define&&define.amd?define("eventEmitter/EventEmitter",[],function(){return a}):"object"==typeof module&&module.exports?module.exports=a:this.EventEmitter=a}.call(this),function(a){var b=document.documentElement,c=function(){};b.addEventListener?c=function(a,b,c){a.addEventListener(b,c,!1)}:b.attachEvent&&(c=function(b,c,d){b[c+d]=d.handleEvent?function(){var b=a.event;b.target=b.target||b.srcElement,d.handleEvent.call(d,b)}:function(){var c=a.event;c.target=c.target||c.srcElement,d.call(b,c)},b.attachEvent("on"+c,b[c+d])});var d=function(){};b.removeEventListener?d=function(a,b,c){a.removeEventListener(b,c,!1)}:b.detachEvent&&(d=function(a,b,c){a.detachEvent("on"+b,a[b+c]);try{delete a[b+c]}catch(d){a[b+c]=void 0}});var e={bind:c,unbind:d};"function"==typeof define&&define.amd?define("eventie/eventie",e):a.eventie=e}(this),function(a){function b(a){if(a){if("string"==typeof d[a])return a;a=a.charAt(0).toUpperCase()+a.slice(1);for(var b,e=0,f=c.length;f>e;e++)if(b=c[e]+a,"string"==typeof d[b])return b}}var c="Webkit Moz ms Ms O".split(" "),d=document.documentElement.style;"function"==typeof define&&define.amd?define("get-style-property/get-style-property",[],function(){return b}):a.getStyleProperty=b}(window),function(a){function b(a){var b=parseFloat(a),c=-1===a.indexOf("%")&&!isNaN(b);return c&&b}function c(){for(var a={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},b=0,c=g.length;c>b;b++){var d=g[b];a[d]=0}return a}function d(a){function d(a){if("string"==typeof a&&(a=document.querySelector(a)),a&&"object"==typeof a&&a.nodeType){var d=f(a);if("none"===d.display)return c();var i={};i.width=a.offsetWidth,i.height=a.offsetHeight;for(var j=i.isBorderBox=!(!h||!d[h]||"border-box"!==d[h]),k=0,l=g.length;l>k;k++){var m=g[k],n=d[m],o=parseFloat(n);i[m]=isNaN(o)?0:o}var p=i.paddingLeft+i.paddingRight,q=i.paddingTop+i.paddingBottom,r=i.marginLeft+i.marginRight,s=i.marginTop+i.marginBottom,t=i.borderLeftWidth+i.borderRightWidth,u=i.borderTopWidth+i.borderBottomWidth,v=j&&e,w=b(d.width);w!==!1&&(i.width=w+(v?0:p+t));var x=b(d.height);return x!==!1&&(i.height=x+(v?0:q+u)),i.innerWidth=i.width-(p+t),i.innerHeight=i.height-(q+u),i.outerWidth=i.width+r,i.outerHeight=i.height+s,i}}var e,h=a("boxSizing");return function(){if(h){var a=document.createElement("div");a.style.width="200px",a.style.padding="1px 2px 3px 4px",a.style.borderStyle="solid",a.style.borderWidth="1px 2px 3px 4px",a.style[h]="border-box";var c=document.body||document.documentElement;c.appendChild(a);var d=f(a);e=200===b(d.width),c.removeChild(a)}}(),d}var e=document.defaultView,f=e&&e.getComputedStyle?function(a){return e.getComputedStyle(a,null)}:function(a){return a.currentStyle},g=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"];"function"==typeof define&&define.amd?define("get-size/get-size",["get-style-property/get-style-property"],d):a.getSize=d(a.getStyleProperty)}(window),function(a){function b(a,b){for(var c in b)a[c]=b[c];return a}function c(){}function d(d,e,g,j,k){function m(a,c){this.element="string"==typeof a?f.querySelector(a):a,this.options=b({},this.options),b(this.options,c),this._create()}function n(){return!1}function o(a,b){a.x=void 0!==b.pageX?b.pageX:b.clientX,a.y=void 0!==b.pageY?b.pageY:b.clientY}function p(a,b,c){return c=c||"round",b?Math[c](a/b)*b:a}var q=j("transform"),r=!!j("perspective");b(m.prototype,e.prototype),m.prototype.options={},m.prototype._create=function(){this.position={},this._getPosition(),this.startPoint={x:0,y:0},this.dragPoint={x:0,y:0},this.startPosition=b({},this.position);var a=h(this.element);"relative"!==a.position&&"absolute"!==a.position&&(this.element.style.position="relative"),this.enable(),this.setHandles()},m.prototype.setHandles=function(){this.handles=this.options.handle?this.element.querySelectorAll(this.options.handle):[this.element];for(var b=0,c=this.handles.length;c>b;b++){var d=this.handles[b];a.navigator.pointerEnabled?(g.bind(d,"pointerdown",this),d.style.touchAction="none"):a.navigator.msPointerEnabled?(g.bind(d,"MSPointerDown",this),d.style.msTouchAction="none"):(g.bind(d,"mousedown",this),g.bind(d,"touchstart",this),t(d))}};var s="attachEvent"in f.documentElement,t=s?function(a){"IMG"===a.nodeName&&(a.ondragstart=n);for(var b=a.querySelectorAll("img"),c=0,d=b.length;d>c;c++){var e=b[c];e.ondragstart=n}}:c;m.prototype._getPosition=function(){var a=h(this.element),b=parseInt(a.left,10),c=parseInt(a.top,10);this.position.x=isNaN(b)?0:b,this.position.y=isNaN(c)?0:c,this._addTransformPosition(a)},m.prototype._addTransformPosition=function(a){if(q){var b=a[q];if(0===b.indexOf("matrix")){var c=b.split(","),d=0===b.indexOf("matrix3d")?12:4,e=parseInt(c[d],10),f=parseInt(c[d+1],10);this.position.x+=e,this.position.y+=f}}},m.prototype.handleEvent=function(a){var b="on"+a.type;this[b]&&this[b](a)},m.prototype.getTouch=function(a){for(var b=0,c=a.length;c>b;b++){var d=a[b];if(d.identifier===this.pointerIdentifier)return d}},m.prototype.onmousedown=function(a){var b=a.button;b&&0!==b&&1!==b||this.dragStart(a,a)},m.prototype.ontouchstart=function(a){this.isDragging||this.dragStart(a,a.changedTouches[0])},m.prototype.onMSPointerDown=m.prototype.onpointerdown=function(a){this.isDragging||this.dragStart(a,a)};var u={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"],MSPointerDown:["MSPointerMove","MSPointerUp","MSPointerCancel"]};m.prototype.dragStart=function(b,c){this.isEnabled&&(b.preventDefault?b.preventDefault():b.returnValue=!1,this.pointerIdentifier=void 0!==c.pointerId?c.pointerId:c.identifier,this._getPosition(),this.measureContainment(),o(this.startPoint,c),this.startPosition.x=this.position.x,this.startPosition.y=this.position.y,this.setLeftTop(),this.dragPoint.x=0,this.dragPoint.y=0,this._bindEvents({events:u[b.type],node:b.preventDefault?a:f}),d.add(this.element,"is-dragging"),this.isDragging=!0,this.emitEvent("dragStart",[this,b,c]),this.animate())},m.prototype._bindEvents=function(a){for(var b=0,c=a.events.length;c>b;b++){var d=a.events[b];g.bind(a.node,d,this)}this._boundEvents=a},m.prototype._unbindEvents=function(){var a=this._boundEvents;if(a&&a.events){for(var b=0,c=a.events.length;c>b;b++){var d=a.events[b];g.unbind(a.node,d,this)}delete this._boundEvents}},m.prototype.measureContainment=function(){var a=this.options.containment;if(a){this.size=k(this.element);var b=this.element.getBoundingClientRect(),c=i(a)?a:"string"==typeof a?f.querySelector(a):this.element.parentNode;this.containerSize=k(c);var d=c.getBoundingClientRect();this.relativeStartPosition={x:b.left-d.left,y:b.top-d.top}}},m.prototype.onmousemove=function(a){this.dragMove(a,a)},m.prototype.onMSPointerMove=m.prototype.onpointermove=function(a){a.pointerId===this.pointerIdentifier&&this.dragMove(a,a)},m.prototype.ontouchmove=function(a){var b=this.getTouch(a.changedTouches);b&&this.dragMove(a,b)},m.prototype.dragMove=function(a,b){o(this.dragPoint,b);var c=this.dragPoint.x-this.startPoint.x,d=this.dragPoint.y-this.startPoint.y,e=this.options.grid,f=e&&e[0],g=e&&e[1];c=p(c,f),d=p(d,g),c=this.containDrag("x",c,f),d=this.containDrag("y",d,g),c="y"===this.options.axis?0:c,d="x"===this.options.axis?0:d,this.position.x=this.startPosition.x+c,this.position.y=this.startPosition.y+d,this.dragPoint.x=c,this.dragPoint.y=d,this.emitEvent("dragMove",[this,a,b])},m.prototype.containDrag=function(a,b,c){if(!this.options.containment)return b;var d="x"===a?"width":"height",e=this.relativeStartPosition[a],f=p(-e,c,"ceil"),g=this.containerSize[d]-e-this.size[d];return g=p(g,c,"floor"),Math.min(g,Math.max(f,b))},m.prototype.onmouseup=function(a){this.dragEnd(a,a)},m.prototype.onMSPointerUp=m.prototype.onpointerup=function(a){a.pointerId===this.pointerIdentifier&&this.dragEnd(a,a)},m.prototype.ontouchend=function(a){var b=this.getTouch(a.changedTouches);b&&this.dragEnd(a,b)},m.prototype.dragEnd=function(a,b){this.isDragging=!1,delete this.pointerIdentifier,q&&(this.element.style[q]="",this.setLeftTop()),this._unbindEvents(),d.remove(this.element,"is-dragging"),this.emitEvent("dragEnd",[this,a,b])},m.prototype.onMSPointerCancel=m.prototype.onpointercancel=function(a){a.pointerId===this.pointerIdentifier&&this.dragEnd(a,a)},m.prototype.ontouchcancel=function(a){var b=this.getTouch(a.changedTouches);this.dragEnd(a,b)},m.prototype.animate=function(){if(this.isDragging){this.positionDrag();var a=this;l(function(){a.animate()})}};var v=r?function(a,b){return"translate3d( "+a+"px, "+b+"px, 0)"}:function(a,b){return"translate( "+a+"px, "+b+"px)"};return m.prototype.setLeftTop=function(){this.element.style.left=this.position.x+"px",this.element.style.top=this.position.y+"px"},m.prototype.positionDrag=q?function(){this.element.style[q]=v(this.dragPoint.x,this.dragPoint.y)}:m.prototype.setLeftTop,m.prototype.enable=function(){this.isEnabled=!0},m.prototype.disable=function(){this.isEnabled=!1,this.isDragging&&this.dragEnd()},m}for(var e,f=a.document,g=f.defaultView,h=g&&g.getComputedStyle?function(a){return g.getComputedStyle(a,null)}:function(a){return a.currentStyle},i="object"==typeof HTMLElement?function(a){return a instanceof HTMLElement}:function(a){return a&&"object"==typeof a&&1===a.nodeType&&"string"==typeof a.nodeName},j=0,k="webkit moz ms o".split(" "),l=a.requestAnimationFrame,m=a.cancelAnimationFrame,n=0;n<k.length&&(!l||!m);n++)e=k[n],l=l||a[e+"RequestAnimationFrame"],m=m||a[e+"CancelAnimationFrame"]||a[e+"CancelRequestAnimationFrame"];l&&m||(l=function(b){var c=(new Date).getTime(),d=Math.max(0,16-(c-j)),e=a.setTimeout(function(){b(c+d)},d);return j=c+d,e},m=function(b){a.clearTimeout(b)}),"function"==typeof define&&define.amd?define(["classie/classie","eventEmitter/EventEmitter","eventie/eventie","get-style-property/get-style-property","get-size/get-size"],d):"object"==typeof exports?module.exports=d(require("desandro-classie"),require("wolfy87-eventemitter"),require("eventie"),require("desandro-get-style-property"),require("get-size")):a.Draggabilly=d(a.classie,a.EventEmitter,a.eventie,a.getStyleProperty,a.getSize)}(window);

/*!
 * Packery PACKAGED v1.3.0
 * bin-packing layout library
 * http://packery.metafizzy.co
 *
 * Commercial use requires one-time purchase of a commercial license
 * http://packery.metafizzy.co/license.html
 *
 * Non-commercial use is licensed under the GPL v3 License
 *
 * Copyright 2014 Metafizzy
 */

(function(t){function e(){}function i(t){function i(e){e.prototype.option||(e.prototype.option=function(e){t.isPlainObject(e)&&(this.options=t.extend(!0,this.options,e))})}function o(e,i){t.fn[e]=function(o){if("string"==typeof o){for(var s=n.call(arguments,1),a=0,h=this.length;h>a;a++){var p=this[a],u=t.data(p,e);if(u)if(t.isFunction(u[o])&&"_"!==o.charAt(0)){var c=u[o].apply(u,s);if(void 0!==c)return c}else r("no such method '"+o+"' for "+e+" instance");else r("cannot call methods on "+e+" prior to initialization; "+"attempted to call '"+o+"'")}return this}return this.each(function(){var n=t.data(this,e);n?(n.option(o),n._init()):(n=new i(this,o),t.data(this,e,n))})}}if(t){var r="undefined"==typeof console?e:function(t){console.error(t)};return t.bridget=function(t,e){i(e),o(t,e)},t.bridget}}var n=Array.prototype.slice;"function"==typeof define&&define.amd?define("jquery-bridget/jquery.bridget",["jquery"],i):"object"==typeof exports?i(require("jquery")):i(t.jQuery)})(window),function(t){function e(t){return RegExp("(^|\\s+)"+t+"(\\s+|$)")}function i(t,e){var i=n(t,e)?r:o;i(t,e)}var n,o,r;"classList"in document.documentElement?(n=function(t,e){return t.classList.contains(e)},o=function(t,e){t.classList.add(e)},r=function(t,e){t.classList.remove(e)}):(n=function(t,i){return e(i).test(t.className)},o=function(t,e){n(t,e)||(t.className=t.className+" "+e)},r=function(t,i){t.className=t.className.replace(e(i)," ")});var s={hasClass:n,addClass:o,removeClass:r,toggleClass:i,has:n,add:o,remove:r,toggle:i};"function"==typeof define&&define.amd?define("classie/classie",s):"object"==typeof exports?module.exports=s:t.classie=s}(window),function(t){function e(t){if(t){if("string"==typeof n[t])return t;t=t.charAt(0).toUpperCase()+t.slice(1);for(var e,o=0,r=i.length;r>o;o++)if(e=i[o]+t,"string"==typeof n[e])return e}}var i="Webkit Moz ms Ms O".split(" "),n=document.documentElement.style;"function"==typeof define&&define.amd?define("get-style-property/get-style-property",[],function(){return e}):"object"==typeof exports?module.exports=e:t.getStyleProperty=e}(window),function(t){function e(t){var e=parseFloat(t),i=-1===t.indexOf("%")&&!isNaN(e);return i&&e}function i(){}function n(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0,i=s.length;i>e;e++){var n=s[e];t[n]=0}return t}function o(i){function o(){if(!d){d=!0;var n=t.getComputedStyle;if(p=function(){var t=n?function(t){return n(t,null)}:function(t){return t.currentStyle};return function(e){var i=t(e);return i||r("Style returned "+i+". Are you running this code in a hidden iframe on Firefox? "+"See http://bit.ly/getsizebug1"),i}}(),u=i("boxSizing")){var o=document.createElement("div");o.style.width="200px",o.style.padding="1px 2px 3px 4px",o.style.borderStyle="solid",o.style.borderWidth="1px 2px 3px 4px",o.style[u]="border-box";var s=document.body||document.documentElement;s.appendChild(o);var a=p(o);c=200===e(a.width),s.removeChild(o)}}}function a(t){if(o(),"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var i=p(t);if("none"===i.display)return n();var r={};r.width=t.offsetWidth,r.height=t.offsetHeight;for(var a=r.isBorderBox=!(!u||!i[u]||"border-box"!==i[u]),d=0,f=s.length;f>d;d++){var l=s[d],y=i[l];y=h(t,y);var m=parseFloat(y);r[l]=isNaN(m)?0:m}var g=r.paddingLeft+r.paddingRight,v=r.paddingTop+r.paddingBottom,x=r.marginLeft+r.marginRight,b=r.marginTop+r.marginBottom,w=r.borderLeftWidth+r.borderRightWidth,E=r.borderTopWidth+r.borderBottomWidth,_=a&&c,L=e(i.width);L!==!1&&(r.width=L+(_?0:g+w));var R=e(i.height);return R!==!1&&(r.height=R+(_?0:v+E)),r.innerWidth=r.width-(g+w),r.innerHeight=r.height-(v+E),r.outerWidth=r.width+x,r.outerHeight=r.height+b,r}}function h(t,e){if(getComputedStyle||-1===e.indexOf("%"))return e;var i=t.style,n=i.left,o=t.runtimeStyle,r=o&&o.left;return r&&(o.left=t.currentStyle.left),i.left=e,e=i.pixelLeft,i.left=n,r&&(o.left=r),e}var p,u,c,d=!1;return a}var r="undefined"==typeof console?i:function(t){console.error(t)},s=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"];"function"==typeof define&&define.amd?define("get-size/get-size",["get-style-property/get-style-property"],o):"object"==typeof exports?module.exports=o(require("desandro-get-style-property")):t.getSize=o(t.getStyleProperty)}(window),function(t){function e(e){var i=t.event;return i.target=i.target||i.srcElement||e,i}var i=document.documentElement,n=function(){};i.addEventListener?n=function(t,e,i){t.addEventListener(e,i,!1)}:i.attachEvent&&(n=function(t,i,n){t[i+n]=n.handleEvent?function(){var i=e(t);n.handleEvent.call(n,i)}:function(){var i=e(t);n.call(t,i)},t.attachEvent("on"+i,t[i+n])});var o=function(){};i.removeEventListener?o=function(t,e,i){t.removeEventListener(e,i,!1)}:i.detachEvent&&(o=function(t,e,i){t.detachEvent("on"+e,t[e+i]);try{delete t[e+i]}catch(n){t[e+i]=void 0}});var r={bind:n,unbind:o};"function"==typeof define&&define.amd?define("eventie/eventie",r):"object"==typeof exports?module.exports=r:t.eventie=r}(this),function(t){function e(t){"function"==typeof t&&(e.isReady?t():s.push(t))}function i(t){var i="readystatechange"===t.type&&"complete"!==r.readyState;e.isReady||i||n()}function n(){e.isReady=!0;for(var t=0,i=s.length;i>t;t++){var n=s[t];n()}}function o(o){return"complete"===r.readyState?n():(o.bind(r,"DOMContentLoaded",i),o.bind(r,"readystatechange",i),o.bind(t,"load",i)),e}var r=t.document,s=[];e.isReady=!1,"function"==typeof define&&define.amd?define("doc-ready/doc-ready",["eventie/eventie"],o):"object"==typeof exports?module.exports=o(require("eventie")):t.docReady=o(t.eventie)}(window),function(){function t(){}function e(t,e){for(var i=t.length;i--;)if(t[i].listener===e)return i;return-1}function i(t){return function(){return this[t].apply(this,arguments)}}var n=t.prototype,o=this,r=o.EventEmitter;n.getListeners=function(t){var e,i,n=this._getEvents();if(t instanceof RegExp){e={};for(i in n)n.hasOwnProperty(i)&&t.test(i)&&(e[i]=n[i])}else e=n[t]||(n[t]=[]);return e},n.flattenListeners=function(t){var e,i=[];for(e=0;t.length>e;e+=1)i.push(t[e].listener);return i},n.getListenersAsObject=function(t){var e,i=this.getListeners(t);return i instanceof Array&&(e={},e[t]=i),e||i},n.addListener=function(t,i){var n,o=this.getListenersAsObject(t),r="object"==typeof i;for(n in o)o.hasOwnProperty(n)&&-1===e(o[n],i)&&o[n].push(r?i:{listener:i,once:!1});return this},n.on=i("addListener"),n.addOnceListener=function(t,e){return this.addListener(t,{listener:e,once:!0})},n.once=i("addOnceListener"),n.defineEvent=function(t){return this.getListeners(t),this},n.defineEvents=function(t){for(var e=0;t.length>e;e+=1)this.defineEvent(t[e]);return this},n.removeListener=function(t,i){var n,o,r=this.getListenersAsObject(t);for(o in r)r.hasOwnProperty(o)&&(n=e(r[o],i),-1!==n&&r[o].splice(n,1));return this},n.off=i("removeListener"),n.addListeners=function(t,e){return this.manipulateListeners(!1,t,e)},n.removeListeners=function(t,e){return this.manipulateListeners(!0,t,e)},n.manipulateListeners=function(t,e,i){var n,o,r=t?this.removeListener:this.addListener,s=t?this.removeListeners:this.addListeners;if("object"!=typeof e||e instanceof RegExp)for(n=i.length;n--;)r.call(this,e,i[n]);else for(n in e)e.hasOwnProperty(n)&&(o=e[n])&&("function"==typeof o?r.call(this,n,o):s.call(this,n,o));return this},n.removeEvent=function(t){var e,i=typeof t,n=this._getEvents();if("string"===i)delete n[t];else if(t instanceof RegExp)for(e in n)n.hasOwnProperty(e)&&t.test(e)&&delete n[e];else delete this._events;return this},n.removeAllListeners=i("removeEvent"),n.emitEvent=function(t,e){var i,n,o,r,s=this.getListenersAsObject(t);for(o in s)if(s.hasOwnProperty(o))for(n=s[o].length;n--;)i=s[o][n],i.once===!0&&this.removeListener(t,i.listener),r=i.listener.apply(this,e||[]),r===this._getOnceReturnValue()&&this.removeListener(t,i.listener);return this},n.trigger=i("emitEvent"),n.emit=function(t){var e=Array.prototype.slice.call(arguments,1);return this.emitEvent(t,e)},n.setOnceReturnValue=function(t){return this._onceReturnValue=t,this},n._getOnceReturnValue=function(){return this.hasOwnProperty("_onceReturnValue")?this._onceReturnValue:!0},n._getEvents=function(){return this._events||(this._events={})},t.noConflict=function(){return o.EventEmitter=r,t},"function"==typeof define&&define.amd?define("eventEmitter/EventEmitter",[],function(){return t}):"object"==typeof module&&module.exports?module.exports=t:o.EventEmitter=t}.call(this),function(t){function e(t,e){return t[s](e)}function i(t){if(!t.parentNode){var e=document.createDocumentFragment();e.appendChild(t)}}function n(t,e){i(t);for(var n=t.parentNode.querySelectorAll(e),o=0,r=n.length;r>o;o++)if(n[o]===t)return!0;return!1}function o(t,n){return i(t),e(t,n)}var r,s=function(){if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0,n=e.length;n>i;i++){var o=e[i],r=o+"MatchesSelector";if(t[r])return r}}();if(s){var a=document.createElement("div"),h=e(a,"div");r=h?e:o}else r=n;"function"==typeof define&&define.amd?define("matches-selector/matches-selector",[],function(){return r}):"object"==typeof exports?module.exports=r:window.matchesSelector=r}(Element.prototype),function(t){function e(t,e){for(var i in e)t[i]=e[i];return t}function i(t){for(var e in t)return!1;return e=null,!0}function n(t){return t.replace(/([A-Z])/g,function(t){return"-"+t.toLowerCase()})}function o(t,o,r){function a(t,e){t&&(this.element=t,this.layout=e,this.position={x:0,y:0},this._create())}var h=r("transition"),p=r("transform"),u=h&&p,c=!!r("perspective"),d={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"otransitionend",transition:"transitionend"}[h],f=["transform","transition","transitionDuration","transitionProperty"],l=function(){for(var t={},e=0,i=f.length;i>e;e++){var n=f[e],o=r(n);o&&o!==n&&(t[n]=o)}return t}();e(a.prototype,t.prototype),a.prototype._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},a.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},a.prototype.getSize=function(){this.size=o(this.element)},a.prototype.css=function(t){var e=this.element.style;for(var i in t){var n=l[i]||i;e[n]=t[i]}},a.prototype.getPosition=function(){var t=s(this.element),e=this.layout.options,i=e.isOriginLeft,n=e.isOriginTop,o=parseInt(t[i?"left":"right"],10),r=parseInt(t[n?"top":"bottom"],10);o=isNaN(o)?0:o,r=isNaN(r)?0:r;var a=this.layout.size;o-=i?a.paddingLeft:a.paddingRight,r-=n?a.paddingTop:a.paddingBottom,this.position.x=o,this.position.y=r},a.prototype.layoutPosition=function(){var t=this.layout.size,e=this.layout.options,i={};e.isOriginLeft?(i.left=this.position.x+t.paddingLeft+"px",i.right=""):(i.right=this.position.x+t.paddingRight+"px",i.left=""),e.isOriginTop?(i.top=this.position.y+t.paddingTop+"px",i.bottom=""):(i.bottom=this.position.y+t.paddingBottom+"px",i.top=""),this.css(i),this.emitEvent("layout",[this])};var y=c?function(t,e){return"translate3d("+t+"px, "+e+"px, 0)"}:function(t,e){return"translate("+t+"px, "+e+"px)"};a.prototype._transitionTo=function(t,e){this.getPosition();var i=this.position.x,n=this.position.y,o=parseInt(t,10),r=parseInt(e,10),s=o===this.position.x&&r===this.position.y;if(this.setPosition(t,e),s&&!this.isTransitioning)return this.layoutPosition(),void 0;var a=t-i,h=e-n,p={},u=this.layout.options;a=u.isOriginLeft?a:-a,h=u.isOriginTop?h:-h,p.transform=y(a,h),this.transition({to:p,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})},a.prototype.goTo=function(t,e){this.setPosition(t,e),this.layoutPosition()},a.prototype.moveTo=u?a.prototype._transitionTo:a.prototype.goTo,a.prototype.setPosition=function(t,e){this.position.x=parseInt(t,10),this.position.y=parseInt(e,10)},a.prototype._nonTransition=function(t){this.css(t.to),t.isCleaning&&this._removeStyles(t.to);for(var e in t.onTransitionEnd)t.onTransitionEnd[e].call(this)},a.prototype._transition=function(t){if(!parseFloat(this.layout.options.transitionDuration))return this._nonTransition(t),void 0;var e=this._transn;for(var i in t.onTransitionEnd)e.onEnd[i]=t.onTransitionEnd[i];for(i in t.to)e.ingProperties[i]=!0,t.isCleaning&&(e.clean[i]=!0);if(t.from){this.css(t.from);var n=this.element.offsetHeight;n=null}this.enableTransition(t.to),this.css(t.to),this.isTransitioning=!0};var m=p&&n(p)+",opacity";a.prototype.enableTransition=function(){this.isTransitioning||(this.css({transitionProperty:m,transitionDuration:this.layout.options.transitionDuration}),this.element.addEventListener(d,this,!1))},a.prototype.transition=a.prototype[h?"_transition":"_nonTransition"],a.prototype.onwebkitTransitionEnd=function(t){this.ontransitionend(t)},a.prototype.onotransitionend=function(t){this.ontransitionend(t)};var g={"-webkit-transform":"transform","-moz-transform":"transform","-o-transform":"transform"};a.prototype.ontransitionend=function(t){if(t.target===this.element){var e=this._transn,n=g[t.propertyName]||t.propertyName;if(delete e.ingProperties[n],i(e.ingProperties)&&this.disableTransition(),n in e.clean&&(this.element.style[t.propertyName]="",delete e.clean[n]),n in e.onEnd){var o=e.onEnd[n];o.call(this),delete e.onEnd[n]}this.emitEvent("transitionEnd",[this])}},a.prototype.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(d,this,!1),this.isTransitioning=!1},a.prototype._removeStyles=function(t){var e={};for(var i in t)e[i]="";this.css(e)};var v={transitionProperty:"",transitionDuration:""};return a.prototype.removeTransitionStyles=function(){this.css(v)},a.prototype.removeElem=function(){this.element.parentNode.removeChild(this.element),this.emitEvent("remove",[this])},a.prototype.remove=function(){if(!h||!parseFloat(this.layout.options.transitionDuration))return this.removeElem(),void 0;var t=this;this.on("transitionEnd",function(){return t.removeElem(),!0}),this.hide()},a.prototype.reveal=function(){delete this.isHidden,this.css({display:""});var t=this.layout.options;this.transition({from:t.hiddenStyle,to:t.visibleStyle,isCleaning:!0})},a.prototype.hide=function(){this.isHidden=!0,this.css({display:""});var t=this.layout.options;this.transition({from:t.visibleStyle,to:t.hiddenStyle,isCleaning:!0,onTransitionEnd:{opacity:function(){this.isHidden&&this.css({display:"none"})}}})},a.prototype.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},a}var r=t.getComputedStyle,s=r?function(t){return r(t,null)}:function(t){return t.currentStyle};"function"==typeof define&&define.amd?define("outlayer/item",["eventEmitter/EventEmitter","get-size/get-size","get-style-property/get-style-property"],o):"object"==typeof exports?module.exports=o(require("wolfy87-eventemitter"),require("get-size"),require("desandro-get-style-property")):(t.Outlayer={},t.Outlayer.Item=o(t.EventEmitter,t.getSize,t.getStyleProperty))}(window),function(t){function e(t,e){for(var i in e)t[i]=e[i];return t}function i(t){return"[object Array]"===c.call(t)}function n(t){var e=[];if(i(t))e=t;else if(t&&"number"==typeof t.length)for(var n=0,o=t.length;o>n;n++)e.push(t[n]);else e.push(t);return e}function o(t,e){var i=f(e,t);-1!==i&&e.splice(i,1)}function r(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()}function s(i,s,c,f,l,y){function m(t,i){if("string"==typeof t&&(t=a.querySelector(t)),!t||!d(t))return h&&h.error("Bad "+this.constructor.namespace+" element: "+t),void 0;this.element=t,this.options=e({},this.constructor.defaults),this.option(i);var n=++g;this.element.outlayerGUID=n,v[n]=this,this._create(),this.options.isInitLayout&&this.layout()}var g=0,v={};return m.namespace="outlayer",m.Item=y,m.defaults={containerStyle:{position:"relative"},isInitLayout:!0,isOriginLeft:!0,isOriginTop:!0,isResizeBound:!0,isResizingContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}},e(m.prototype,c.prototype),m.prototype.option=function(t){e(this.options,t)},m.prototype._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),e(this.element.style,this.options.containerStyle),this.options.isResizeBound&&this.bindResize()},m.prototype.reloadItems=function(){this.items=this._itemize(this.element.children)},m.prototype._itemize=function(t){for(var e=this._filterFindItemElements(t),i=this.constructor.Item,n=[],o=0,r=e.length;r>o;o++){var s=e[o],a=new i(s,this);n.push(a)}return n},m.prototype._filterFindItemElements=function(t){t=n(t);for(var e=this.options.itemSelector,i=[],o=0,r=t.length;r>o;o++){var s=t[o];if(d(s))if(e){l(s,e)&&i.push(s);for(var a=s.querySelectorAll(e),h=0,p=a.length;p>h;h++)i.push(a[h])}else i.push(s)}return i},m.prototype.getItemElements=function(){for(var t=[],e=0,i=this.items.length;i>e;e++)t.push(this.items[e].element);return t},m.prototype.layout=function(){this._resetLayout(),this._manageStamps();var t=void 0!==this.options.isLayoutInstant?this.options.isLayoutInstant:!this._isLayoutInited;this.layoutItems(this.items,t),this._isLayoutInited=!0},m.prototype._init=m.prototype.layout,m.prototype._resetLayout=function(){this.getSize()},m.prototype.getSize=function(){this.size=f(this.element)},m.prototype._getMeasurement=function(t,e){var i,n=this.options[t];n?("string"==typeof n?i=this.element.querySelector(n):d(n)&&(i=n),this[t]=i?f(i)[e]:n):this[t]=0},m.prototype.layoutItems=function(t,e){t=this._getItemsForLayout(t),this._layoutItems(t,e),this._postLayout()},m.prototype._getItemsForLayout=function(t){for(var e=[],i=0,n=t.length;n>i;i++){var o=t[i];o.isIgnored||e.push(o)}return e},m.prototype._layoutItems=function(t,e){function i(){n.emitEvent("layoutComplete",[n,t])}var n=this;if(!t||!t.length)return i(),void 0;this._itemsOn(t,"layout",i);for(var o=[],r=0,s=t.length;s>r;r++){var a=t[r],h=this._getItemLayoutPosition(a);h.item=a,h.isInstant=e||a.isLayoutInstant,o.push(h)}this._processLayoutQueue(o)},m.prototype._getItemLayoutPosition=function(){return{x:0,y:0}},m.prototype._processLayoutQueue=function(t){for(var e=0,i=t.length;i>e;e++){var n=t[e];this._positionItem(n.item,n.x,n.y,n.isInstant)}},m.prototype._positionItem=function(t,e,i,n){n?t.goTo(e,i):t.moveTo(e,i)},m.prototype._postLayout=function(){this.resizeContainer()},m.prototype.resizeContainer=function(){if(this.options.isResizingContainer){var t=this._getContainerSize();t&&(this._setContainerMeasure(t.width,!0),this._setContainerMeasure(t.height,!1))}},m.prototype._getContainerSize=u,m.prototype._setContainerMeasure=function(t,e){if(void 0!==t){var i=this.size;i.isBorderBox&&(t+=e?i.paddingLeft+i.paddingRight+i.borderLeftWidth+i.borderRightWidth:i.paddingBottom+i.paddingTop+i.borderTopWidth+i.borderBottomWidth),t=Math.max(t,0),this.element.style[e?"width":"height"]=t+"px"}},m.prototype._itemsOn=function(t,e,i){function n(){return o++,o===r&&i.call(s),!0}for(var o=0,r=t.length,s=this,a=0,h=t.length;h>a;a++){var p=t[a];p.on(e,n)}},m.prototype.ignore=function(t){var e=this.getItem(t);e&&(e.isIgnored=!0)},m.prototype.unignore=function(t){var e=this.getItem(t);e&&delete e.isIgnored},m.prototype.stamp=function(t){if(t=this._find(t)){this.stamps=this.stamps.concat(t);for(var e=0,i=t.length;i>e;e++){var n=t[e];this.ignore(n)}}},m.prototype.unstamp=function(t){if(t=this._find(t))for(var e=0,i=t.length;i>e;e++){var n=t[e];o(n,this.stamps),this.unignore(n)}},m.prototype._find=function(t){return t?("string"==typeof t&&(t=this.element.querySelectorAll(t)),t=n(t)):void 0},m.prototype._manageStamps=function(){if(this.stamps&&this.stamps.length){this._getBoundingRect();for(var t=0,e=this.stamps.length;e>t;t++){var i=this.stamps[t];this._manageStamp(i)}}},m.prototype._getBoundingRect=function(){var t=this.element.getBoundingClientRect(),e=this.size;this._boundingRect={left:t.left+e.paddingLeft+e.borderLeftWidth,top:t.top+e.paddingTop+e.borderTopWidth,right:t.right-(e.paddingRight+e.borderRightWidth),bottom:t.bottom-(e.paddingBottom+e.borderBottomWidth)}},m.prototype._manageStamp=u,m.prototype._getElementOffset=function(t){var e=t.getBoundingClientRect(),i=this._boundingRect,n=f(t),o={left:e.left-i.left-n.marginLeft,top:e.top-i.top-n.marginTop,right:i.right-e.right-n.marginRight,bottom:i.bottom-e.bottom-n.marginBottom};return o},m.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},m.prototype.bindResize=function(){this.isResizeBound||(i.bind(t,"resize",this),this.isResizeBound=!0)},m.prototype.unbindResize=function(){this.isResizeBound&&i.unbind(t,"resize",this),this.isResizeBound=!1},m.prototype.onresize=function(){function t(){e.resize(),delete e.resizeTimeout}this.resizeTimeout&&clearTimeout(this.resizeTimeout);var e=this;this.resizeTimeout=setTimeout(t,100)},m.prototype.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},m.prototype.needsResizeLayout=function(){var t=f(this.element),e=this.size&&t;return e&&t.innerWidth!==this.size.innerWidth},m.prototype.addItems=function(t){var e=this._itemize(t);return e.length&&(this.items=this.items.concat(e)),e},m.prototype.appended=function(t){var e=this.addItems(t);e.length&&(this.layoutItems(e,!0),this.reveal(e))},m.prototype.prepended=function(t){var e=this._itemize(t);if(e.length){var i=this.items.slice(0);this.items=e.concat(i),this._resetLayout(),this._manageStamps(),this.layoutItems(e,!0),this.reveal(e),this.layoutItems(i)}},m.prototype.reveal=function(t){var e=t&&t.length;if(e)for(var i=0;e>i;i++){var n=t[i];n.reveal()}},m.prototype.hide=function(t){var e=t&&t.length;if(e)for(var i=0;e>i;i++){var n=t[i];n.hide()}},m.prototype.getItem=function(t){for(var e=0,i=this.items.length;i>e;e++){var n=this.items[e];if(n.element===t)return n}},m.prototype.getItems=function(t){if(t&&t.length){for(var e=[],i=0,n=t.length;n>i;i++){var o=t[i],r=this.getItem(o);r&&e.push(r)}return e}},m.prototype.remove=function(t){t=n(t);var e=this.getItems(t);if(e&&e.length){this._itemsOn(e,"remove",function(){this.emitEvent("removeComplete",[this,e])});for(var i=0,r=e.length;r>i;i++){var s=e[i];s.remove(),o(s,this.items)}}},m.prototype.destroy=function(){var t=this.element.style;t.height="",t.position="",t.width="";for(var e=0,i=this.items.length;i>e;e++){var n=this.items[e];n.destroy()}this.unbindResize();var o=this.element.outlayerGUID;delete v[o],delete this.element.outlayerGUID,p&&p.removeData(this.element,this.constructor.namespace)},m.data=function(t){var e=t&&t.outlayerGUID;return e&&v[e]},m.create=function(t,i){function n(){m.apply(this,arguments)}return Object.create?n.prototype=Object.create(m.prototype):e(n.prototype,m.prototype),n.prototype.constructor=n,n.defaults=e({},m.defaults),e(n.defaults,i),n.prototype.settings={},n.namespace=t,n.data=m.data,n.Item=function(){y.apply(this,arguments)},n.Item.prototype=new y,s(function(){for(var e=r(t),i=a.querySelectorAll(".js-"+e),o="data-"+e+"-options",s=0,u=i.length;u>s;s++){var c,d=i[s],f=d.getAttribute(o);try{c=f&&JSON.parse(f)}catch(l){h&&h.error("Error parsing "+o+" on "+d.nodeName.toLowerCase()+(d.id?"#"+d.id:"")+": "+l);continue}var y=new n(d,c);p&&p.data(d,t,y)}}),p&&p.bridget&&p.bridget(t,n),n},m.Item=y,m}var a=t.document,h=t.console,p=t.jQuery,u=function(){},c=Object.prototype.toString,d="function"==typeof HTMLElement||"object"==typeof HTMLElement?function(t){return t instanceof HTMLElement}:function(t){return t&&"object"==typeof t&&1===t.nodeType&&"string"==typeof t.nodeName},f=Array.prototype.indexOf?function(t,e){return t.indexOf(e)}:function(t,e){for(var i=0,n=t.length;n>i;i++)if(t[i]===e)return i;return-1};"function"==typeof define&&define.amd?define("outlayer/outlayer",["eventie/eventie","doc-ready/doc-ready","eventEmitter/EventEmitter","get-size/get-size","matches-selector/matches-selector","./item"],s):"object"==typeof exports?module.exports=s(require("eventie"),require("doc-ready"),require("wolfy87-eventemitter"),require("get-size"),require("desandro-matches-selector"),require("./item")):t.Outlayer=s(t.eventie,t.docReady,t.EventEmitter,t.getSize,t.matchesSelector,t.Outlayer.Item)}(window),function(t){function e(){function t(e){for(var i in t.defaults)this[i]=t.defaults[i];for(i in e)this[i]=e[i]}return i.Rect=t,t.defaults={x:0,y:0,width:0,height:0},t.prototype.contains=function(t){var e=t.width||0,i=t.height||0;return this.x<=t.x&&this.y<=t.y&&this.x+this.width>=t.x+e&&this.y+this.height>=t.y+i},t.prototype.overlaps=function(t){var e=this.x+this.width,i=this.y+this.height,n=t.x+t.width,o=t.y+t.height;return n>this.x&&e>t.x&&o>this.y&&i>t.y},t.prototype.getMaximalFreeRects=function(e){if(!this.overlaps(e))return!1;var i,n=[],o=this.x+this.width,r=this.y+this.height,s=e.x+e.width,a=e.y+e.height;return this.y<e.y&&(i=new t({x:this.x,y:this.y,width:this.width,height:e.y-this.y}),n.push(i)),o>s&&(i=new t({x:s,y:this.y,width:o-s,height:this.height}),n.push(i)),r>a&&(i=new t({x:this.x,y:a,width:this.width,height:r-a}),n.push(i)),this.x<e.x&&(i=new t({x:this.x,y:this.y,width:e.x-this.x,height:this.height}),n.push(i)),n},t.prototype.canFit=function(t){return this.width>=t.width&&this.height>=t.height},t}var i=t.Packery=function(){};"function"==typeof define&&define.amd?define("packery/js/rect",e):"object"==typeof exports?module.exports=e():(t.Packery=t.Packery||{},t.Packery.Rect=e())}(window),function(t){function e(t){function e(t,e,i){this.width=t||0,this.height=e||0,this.sortDirection=i||"downwardLeftToRight",this.reset()}e.prototype.reset=function(){this.spaces=[],this.newSpaces=[];var e=new t({x:0,y:0,width:this.width,height:this.height});this.spaces.push(e),this.sorter=i[this.sortDirection]||i.downwardLeftToRight},e.prototype.pack=function(t){for(var e=0,i=this.spaces.length;i>e;e++){var n=this.spaces[e];if(n.canFit(t)){this.placeInSpace(t,n);break}}},e.prototype.placeInSpace=function(t,e){t.x=e.x,t.y=e.y,this.placed(t)},e.prototype.placed=function(t){for(var e=[],i=0,n=this.spaces.length;n>i;i++){var o=this.spaces[i],r=o.getMaximalFreeRects(t);r?e.push.apply(e,r):e.push(o)}this.spaces=e,this.mergeSortSpaces()},e.prototype.mergeSortSpaces=function(){e.mergeRects(this.spaces),this.spaces.sort(this.sorter)},e.prototype.addSpace=function(t){this.spaces.push(t),this.mergeSortSpaces()},e.mergeRects=function(t){for(var e=0,i=t.length;i>e;e++){var n=t[e];if(n){var o=t.slice(0);o.splice(e,1);for(var r=0,s=0,a=o.length;a>s;s++){var h=o[s],p=e>s?0:1;n.contains(h)&&(t.splice(s+p-r,1),r++)}}}return t};var i={downwardLeftToRight:function(t,e){return t.y-e.y||t.x-e.x},rightwardTopToBottom:function(t,e){return t.x-e.x||t.y-e.y}};return e}if("function"==typeof define&&define.amd)define("packery/js/packer",["./rect"],e);else if("object"==typeof exports)module.exports=e(require("./rect"));else{var i=t.Packery=t.Packery||{};i.Packer=e(i.Rect)}}(window),function(t){function e(t,e,i){var n=t("transform"),o=function(){e.Item.apply(this,arguments)};o.prototype=new e.Item;var r=o.prototype._create;return o.prototype._create=function(){r.call(this),this.rect=new i,this.placeRect=new i},o.prototype.dragStart=function(){this.getPosition(),this.removeTransitionStyles(),this.isTransitioning&&n&&(this.element.style[n]="none"),this.getSize(),this.isPlacing=!0,this.needsPositioning=!1,this.positionPlaceRect(this.position.x,this.position.y),this.isTransitioning=!1,this.didDrag=!1},o.prototype.dragMove=function(t,e){this.didDrag=!0;var i=this.layout.size;t-=i.paddingLeft,e-=i.paddingTop,this.positionPlaceRect(t,e)},o.prototype.dragStop=function(){this.getPosition();var t=this.position.x!==this.placeRect.x,e=this.position.y!==this.placeRect.y;this.needsPositioning=t||e,this.didDrag=!1},o.prototype.positionPlaceRect=function(t,e,i){this.placeRect.x=this.getPlaceRectCoord(t,!0),this.placeRect.y=this.getPlaceRectCoord(e,!1,i)},o.prototype.getPlaceRectCoord=function(t,e,i){var n=e?"Width":"Height",o=this.size["outer"+n],r=this.layout[e?"columnWidth":"rowHeight"],s=this.layout.size["inner"+n];e||(s=Math.max(s,this.layout.maxY),this.layout.rowHeight||(s-=this.layout.gutter));var a;if(r){r+=this.layout.gutter,s+=e?this.layout.gutter:0,t=Math.round(t/r);var h;h=this.layout.options.isHorizontal?e?"ceil":"floor":e?"floor":"ceil";var p=Math[h](s/r);p-=Math.ceil(o/r),a=p}else a=s-o;return t=i?t:Math.min(t,a),t*=r||1,Math.max(0,t)},o.prototype.copyPlaceRectPosition=function(){this.rect.x=this.placeRect.x,this.rect.y=this.placeRect.y},o.prototype.removeElem=function(){this.element.parentNode.removeChild(this.element),this.layout.packer.addSpace(this.rect),this.emitEvent("remove",[this])},o}"function"==typeof define&&define.amd?define("packery/js/item",["get-style-property/get-style-property","outlayer/outlayer","./rect"],e):"object"==typeof exports?module.exports=e(require("desandro-get-style-property"),require("outlayer"),require("./rect")):t.Packery.Item=e(t.getStyleProperty,t.Outlayer,t.Packery.Rect)}(window),function(t){function e(t,e,i,n,o,r){function s(t,e){return t.position.y-e.position.y||t.position.x-e.position.x}function a(t,e){return t.position.x-e.position.x||t.position.y-e.position.y}var h=i.create("packery");return h.Item=r,h.prototype._create=function(){i.prototype._create.call(this),this.packer=new o,this.stamp(this.options.stamped);var t=this;this.handleDraggabilly={dragStart:function(e){t.itemDragStart(e.element)},dragMove:function(e){t.itemDragMove(e.element,e.position.x,e.position.y)},dragEnd:function(e){t.itemDragEnd(e.element)}},this.handleUIDraggable={start:function(e){t.itemDragStart(e.currentTarget)},drag:function(e,i){t.itemDragMove(e.currentTarget,i.position.left,i.position.top)},stop:function(e){t.itemDragEnd(e.currentTarget)}}},h.prototype._resetLayout=function(){this.getSize(),this._getMeasurements();var t=this.packer;this.options.isHorizontal?(t.width=Number.POSITIVE_INFINITY,t.height=this.size.innerHeight+this.gutter,t.sortDirection="rightwardTopToBottom"):(t.width=this.size.innerWidth+this.gutter,t.height=Number.POSITIVE_INFINITY,t.sortDirection="downwardLeftToRight"),t.reset(),this.maxY=0,this.maxX=0},h.prototype._getMeasurements=function(){this._getMeasurement("columnWidth","width"),this._getMeasurement("rowHeight","height"),this._getMeasurement("gutter","width")},h.prototype._getItemLayoutPosition=function(t){return this._packItem(t),t.rect},h.prototype._packItem=function(t){this._setRectSize(t.element,t.rect),this.packer.pack(t.rect),this._setMaxXY(t.rect)},h.prototype._setMaxXY=function(t){this.maxX=Math.max(t.x+t.width,this.maxX),this.maxY=Math.max(t.y+t.height,this.maxY)},h.prototype._setRectSize=function(t,i){var n=e(t),o=n.outerWidth,r=n.outerHeight;if(o||r){var s=this.columnWidth+this.gutter,a=this.rowHeight+this.gutter;o=this.columnWidth?Math.ceil(o/s)*s:o+this.gutter,r=this.rowHeight?Math.ceil(r/a)*a:r+this.gutter}i.width=Math.min(o,this.packer.width),i.height=Math.min(r,this.packer.height)},h.prototype._getContainerSize=function(){return this.options.isHorizontal?{width:this.maxX-this.gutter}:{height:this.maxY-this.gutter}},h.prototype._manageStamp=function(t){var e,i=this.getItem(t);if(i&&i.isPlacing)e=i.placeRect;else{var o=this._getElementOffset(t);e=new n({x:this.options.isOriginLeft?o.left:o.right,y:this.options.isOriginTop?o.top:o.bottom})}this._setRectSize(t,e),this.packer.placed(e),this._setMaxXY(e)},h.prototype.sortItemsByPosition=function(){var t=this.options.isHorizontal?a:s;this.items.sort(t)},h.prototype.fit=function(t,e,i){var n=this.getItem(t);n&&(this._getMeasurements(),this.stamp(n.element),n.getSize(),n.isPlacing=!0,e=void 0===e?n.rect.x:e,i=void 0===i?n.rect.y:i,n.positionPlaceRect(e,i,!0),this._bindFitEvents(n),n.moveTo(n.placeRect.x,n.placeRect.y),this.layout(),this.unstamp(n.element),this.sortItemsByPosition(),n.isPlacing=!1,n.copyPlaceRectPosition())},h.prototype._bindFitEvents=function(t){function e(){n++,2===n&&i.emitEvent("fitComplete",[i,t])}var i=this,n=0;t.on("layout",function(){return e(),!0}),this.on("layoutComplete",function(){return e(),!0
})},h.prototype.resize=function(){var t=e(this.element),i=this.size&&t,n=this.options.isHorizontal?"innerHeight":"innerWidth";i&&t[n]===this.size[n]||this.layout()},h.prototype.itemDragStart=function(t){this.stamp(t);var e=this.getItem(t);e&&e.dragStart()},h.prototype.itemDragMove=function(t,e,i){function n(){r.layout(),delete r.dragTimeout}var o=this.getItem(t);o&&o.dragMove(e,i);var r=this;this.clearDragTimeout(),this.dragTimeout=setTimeout(n,40)},h.prototype.clearDragTimeout=function(){this.dragTimeout&&clearTimeout(this.dragTimeout)},h.prototype.itemDragEnd=function(e){var i,n=this.getItem(e);if(n&&(i=n.didDrag,n.dragStop()),!n||!i&&!n.needsPositioning)return this.unstamp(e),void 0;t.add(n.element,"is-positioning-post-drag");var o=this._getDragEndLayoutComplete(e,n);n.needsPositioning?(n.on("layout",o),n.moveTo(n.placeRect.x,n.placeRect.y)):n&&n.copyPlaceRectPosition(),this.clearDragTimeout(),this.on("layoutComplete",o),this.layout()},h.prototype._getDragEndLayoutComplete=function(e,i){var n=i&&i.needsPositioning,o=0,r=n?2:1,s=this;return function(){return o++,o!==r?!0:(i&&(t.remove(i.element,"is-positioning-post-drag"),i.isPlacing=!1,i.copyPlaceRectPosition()),s.unstamp(e),s.sortItemsByPosition(),n&&s.emitEvent("dragItemPositioned",[s,i]),!0)}},h.prototype.bindDraggabillyEvents=function(t){t.on("dragStart",this.handleDraggabilly.dragStart),t.on("dragMove",this.handleDraggabilly.dragMove),t.on("dragEnd",this.handleDraggabilly.dragEnd)},h.prototype.bindUIDraggableEvents=function(t){t.on("dragstart",this.handleUIDraggable.start).on("drag",this.handleUIDraggable.drag).on("dragstop",this.handleUIDraggable.stop)},h.Rect=n,h.Packer=o,h}"function"==typeof define&&define.amd?define(["classie/classie","get-size/get-size","outlayer/outlayer","packery/js/rect","packery/js/packer","packery/js/item"],e):"object"==typeof exports?module.exports=e(require("desandro-classie"),require("get-size"),require("outlayer"),require("./rect"),require("./packer"),require("./item")):t.Packery=e(t.classie,t.getSize,t.Outlayer,t.Packery.Rect,t.Packery.Packer,t.Packery.Item)}(window);

(function() {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController($scope, $mdSidenav, $timeout, todoNotificationService) {
        init();

        function init() {

            $scope.$watch(
                function() {
                    return $mdSidenav('quick-panel').isOpen();
                },
                function(newValue, oldValue) {
                    if (!$mdSidenav('quick-panel').isOpen()) {
                        todoNotificationService.refreshNotifications();
                        $timeout(function() {
                            $('#dashboardBranch').blur();
                        }, 1000);
                    }
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController(
        $scope,
        pageHistoryService,
        cdnUrl) {
        var vm = this;

        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.pageHistory = pageHistoryService;
        vm.getLogoUrl = getLogoUrl;
        vm.getLogoClass = getLogoClass;

        function getLogoUrl() {
            let baseUrl = `${cdnUrl}/backgrounds/`;
            return !vm.folded ? `${baseUrl}Company-Logo-Large-Purple.png` : `${baseUrl}Company-Logo-Small-Purple.png`;
        }

        function getLogoClass() {
            return !vm.folded ? 'logo-image' : 'logo-image-small';
        }

        function toggleMsNavigationFolded() {
            vm.folded = !vm.folded;
        }

        vm.getQuickLinks = function() {
            return !_.isNil(pageHistoryService.pageHistoryList) ? pageHistoryService.pageHistoryList : [];
        };

        vm.hasQuickLinks = function() {
            return !_.isEmpty(vm.getQuickLinks());
        };

        $scope.$on('$stateChangeSuccess', function() {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active')
        });
    }
})();

(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('alloc8', [
            'angular-q-extras',
            'alloc8Constants',
            'app.core',
            'app.navigation',
            'app.toolbar',
            'app.quick-panel',
            'app.pages',
            'app.contact',
            'app.jobs',
            'app.branch',
            'app.dashboard',
            'app.company',
            'app.workforce',
            'app.integrations',
            'app.api',
            'app.corelib',
            'app.widgets',
            'app.skillsmatrix',
            'app.assets',
            'mdPickers',
            'app.projects',
            'app.audit',
            'app.jobs.whiteBoard',
            'app.admin',
            'app.resourceSearchFilter',
            'app.jobs.allocate',
            'angular-intro',
            'confirmOnExit',
            'app.jobs.timesheet',
            'ngPlacesAutocomplete',
            'ngMessages',
            'app.awards.view',
            'app.manage-awards',
            'app.generalSettings',
            'app.assets.manage.shift',
            'app.awards.interpreter',
            'ngSanitize',
            'angularTrix',
            'app.invoice',
            'ui.filters',
            'app.useraccess',
            'app.reporting',
            'app.skill_status_report',
            'app.holidays',
            'app.payroll',
            'app.equipment',
            'unsavedChanges',
            'angular-jwt',
            'react',
            'ngAnimate',
            'app.invoice.emailsender',
            'angular-packery',
            'app.customFields',
            'app.skilllevel.view',
            'app.lockout-settings.view',
            'app.training',
            'app.vehicle',
            'app.related-ticket-billing-preferences',
            'app.commentRestrictions',
            'app.customFieldsManager',
            'app.payroll-settings',
            'app.payroll-group',
            'app.invoice-export',
            'app.costEstimate',
            'app.ratecards',
            'app.rateCardSettings',
            'app.custom-validations',
            'app.messaging',
            'app.messaging-format',
            'app.paperwork.exceptions',
            'app.paperwork.exceptions.configurations',
            'app.paperwork.manage-paperwork',
            'app.resourceSidenav',
            'app.jobs.resourceWhiteboard',
            'app.webhooks',
            'app.customForms',
            'app.jobs.formsattachments',
            'app.tags',
            'app.attachmentTypes',
            'app.businesses',
            'app.smartScheduling',
            'app.tax',
            'app.tax.create'
        ]);

})();
(function () {
  'use strict';

  angular
    .module('alloc8')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope) {
    // Data

    //////////

    // Remove the splash screen
    $scope.$on('$viewContentAnimationEnded', function (event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast('msSplashScreen::remove');
      }
    });
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config(
        $ariaProvider,
        msScrollConfigProvider,
        $translateProvider,
        fuseConfigProvider,
        tenantSettings
    ) {
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: `{part}/i18n/${tenantSettings.languageCode}.json`
        });

        $translateProvider.preferredLanguage(tenantSettings.languageCode);
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        $ariaProvider.config({
            tabindex: false
        });

        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

{
    angular.module('app.api')
        .factory('workforceApi', workforceApi);

    /** @ngInject */
    function workforceApi(
        $http,
        tenantSettings
    ) {
        var workforceParticipationApiUrl = tenantSettings.coreApiUrl + 'api/workforceparticipation/';

        return {
            get: get,
            add: add,
            remove: remove,
            edit: edit
        };

        function get() {
            return $http.get(workforceParticipationApiUrl);
        }

        function add(payload) {
            return $http.post(workforceParticipationApiUrl, payload);
        }

        function remove(Id) {
            return $http.delete(workforceParticipationApiUrl + Id);
        }

        function edit(Id, payload) {
            payload['Id'] = Id;
            return $http.put(workforceParticipationApiUrl + Id, payload);
        }

    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('webhooksApi', webhooksApi);

    function webhooksApi(
        $http,
        tenantSettings
    ) {
        let self = this;
        let webhooksApi = tenantSettings.coreApiUrl + 'api/webhooks';

        self.request = {};

        self.request.getWebhooks = function() {
            return $http.get(webhooksApi + "/settings");
        };

        self.request.putWebhooks = function(params) {
            return $http.put(webhooksApi + "/settings", params);
        };

        return self.request;
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('vehicleApi', vehicleApi);

    /** @ngInject */
    function vehicleApi(
        $http,
        tenantSettings
    ) {
        var api = tenantSettings.coreApiUrl + 'api/vehiclelookup/vehicletypes';
        var apiMake = tenantSettings.coreApiUrl + 'api/vehiclelookup/vehiclemake';
        var apiModel = tenantSettings.coreApiUrl + 'api/vehiclelookup/vehiclemodel';

        return {
            getVehiclesMakesAndModels: getVehiclesMakesAndModels,
            getVehiclesMakes: getVehiclesMakes,
            getVehiclesModels: getVehiclesModels,
            addItem: addItem,
            editItem: editItem,
            deleteItem: deleteItem
        };

        function getApiURL(mode) {
            var api;
            if (mode === 'Make') {
                api = apiMake;
            } else if (mode === 'Model') {
                api = apiModel;
            }
            return api;
        }

        function getVehiclesMakesAndModels() {
            return $http.get(api);
        }

        function getVehiclesMakes() {
            return $http.get(apiMake);
        }

        function getVehiclesModels() {
            return $http.get(apiModel);
        }

        function addItem(mode, data) {
            return $http.post(getApiURL(mode), data);
        }

        function editItem(mode, data) {
            return $http.put(getApiURL(mode) + "/" + (data.id || data.Id), data);
        }

        function deleteItem(mode, Id) {
            return $http.delete(getApiURL(mode) + "/" + Id);
        }
    }
})();

{
    angular.module('app.api')
        .factory('userAccessApi', userAccessApi);

    function userAccessApi(
        $http,
        tenantSettings
    ) {
        let userAccessApiUrl = tenantSettings.coreApiUrl + "api/useraccess/";
        let usersListApiUrl = tenantSettings.coreApiUrl + "api/contacts/userslist";

        return {
            getAccessList: getAccessList,
            save: save,
            getUsers: getUsers
        };

        function getAccessList() {
            return $http.get(userAccessApiUrl + "getuseraccessclaims");
        }

        function save(payLoad, updatedContacts) {
            return $http.post(userAccessApiUrl + "updateuseraccessclaims", {
                UserAccessClaimViewModels: payLoad,
                UpdatedContacts: updatedContacts
            });
        }

        function getUsers() {
            return $http({
                method: 'GET',
                url: usersListApiUrl,
                cache: true
            });
        }
    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('trainingApi', trainingApi);

    /** @ngInject */
    function trainingApi(
        $http,
        tenantSettings
    ) {
        var apiGroup = tenantSettings.coreApiUrl + 'api/training/group';

        return {
            getTrainingsGroups: getTrainingsGroups,
            addTrainingGroup: addTrainingGroup,
            editTrainingGroup: editTrainingGroup,
            deleteTrainingGroup: deleteTrainingGroup,
            addTrainingGroupItem: addTrainingGroupItem,
            editTrainingGroupItem: editTrainingGroupItem,
            deleteTrainingGroupItem: deleteTrainingGroupItem,
            getTrainingsByBranch: getTrainingsByBranch,
            getTrainingsByBranchForContacts: getTrainingsByBranchForContacts
        };

        function getTrainingsGroups() {
            return $http.get(apiGroup);
        }

        function addTrainingGroup(trainingGroup) {
            return $http.post(apiGroup, trainingGroup);
        }

        function editTrainingGroup(trainingGroup) {
            return $http.put(apiGroup + "/" + (trainingGroup.id || trainingGroup.Id), trainingGroup);
        }

        function deleteTrainingGroup(Id) {
            return $http.delete(apiGroup + "/" + Id);
        }

        function addTrainingGroupItem(trainingGroup, item) {
            return $http.post(apiGroup + "/" + (trainingGroup.id || trainingGroup.Id) + "/item", item);
        }

        function editTrainingGroupItem(trainingGroup, item) {
            return $http.put(apiGroup + "/" + (trainingGroup.id || trainingGroup.Id) + "/item/" + (item.id || item.Id), item);
        }

        function deleteTrainingGroupItem(Id, ItemId) {
            return $http.delete(apiGroup + "/" + Id + "/item/" + ItemId);
        }

        function getTrainingsByBranch(branches) {
            return $http.post(apiGroup + "/trainings/lookup", branches);
        }

        function getTrainingsByBranchForContacts(branches) {
            return $http.post(apiGroup + "/contacts/trainings/lookup", branches);
        }
    }
})();

{
    angular.module('app.api')
        .factory('timesheetApi', timesheetApi);

    function timesheetApi(
        $http,
        tenantSettings
    ) {
        var timesheetsApiUrl = tenantSettings.coreApiUrl + 'api/timesheets/';

        return {
            getTimesheet: getTimesheet,
            hasSubmittedTimesheets: hasSubmittedTimesheets,
            checkIfTimesheetExported: checkIfTimesheetExported,
            saveTimesheet: saveTimesheet,
            lockUnlockTimesheet: lockUnlockTimesheet,
            validate: validate,
            recalculateAwardClassification:recalculateAwardClassification
        };

        function getTimesheet(ticketId) {
            return $http.get(timesheetsApiUrl + ticketId);
        }

        function hasSubmittedTimesheets(ticketId) {
            return $http.get(timesheetsApiUrl + ticketId + '/has-submitted-timesheets');
        }

        function checkIfTimesheetExported(ticketId) {
            return $http.get(timesheetsApiUrl + ticketId + '/has-exported-timesheets');
        }

        function saveTimesheet(payLoad) {
            return $http.post(timesheetsApiUrl , payLoad);
        }

        function lockUnlockTimesheet(ticketId, isLocked) {
            return $http.post(timesheetsApiUrl + ticketId + '?lockTimesheet=' + !isLocked);
        }

        function validate(timesheet) {
            return $http.post(timesheetsApiUrl + 'validate/changes', timesheet);
        }

        function recalculateAwardClassification(ticketId, contactId){
            return $http.get(timesheetsApiUrl + 'recalculate-timesheet-award/' + ticketId + '/' + contactId);
        }
    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('ticketsApi', ticketsApi);

    function ticketsApi(
        $http,
        tenantSettings
    ) {
        var ticketsUrl = tenantSettings.coreApiUrl + 'api/tickets';

        return {
            getTickets: getTickets,
            cancelTicket: cancelTicket,
            lockTicket: lockTicket,
            unlockTicket: unlockTicket,
            search: search,
            moveTicketToNewStartDate: moveTicketToNewStartDate,
            ticketbillingpreferences: ticketbillingpreferences,
            getRelatedTicket: getRelatedTicket,
            getRelatedTicketByCostEstimateSource: getRelatedTicketByCostEstimateSource,
            hasIncompleteRequiredForms: hasIncompleteRequiredForms,
            getTicketsWithFilters: getTicketsWithFilters,
            getTicketsWithFiltersForPaperwork: getTicketsWithFiltersForPaperwork,
            downloadPaperwork: downloadPaperwork,
            regeneratePaperworkPdfForTicketIds: regeneratePaperworkPdfForTicketIds,
            unlinkedRelatedTicket: unlinkedRelatedTicket
        };

        function getTickets() {
            return $http.get(ticketsUrl);
        }

        function ticketbillingpreferences(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/ticketbillingpreferences', payLoad);
        }

        function cancelTicket(ticketId) {
            return $http.post(ticketsUrl + '/' + ticketId + '/CancelJob=true')
        }

        function moveTicketToNewStartDate(id, startDate) {
            let data = $.param({
                id: id,
                startDate: startDate
            });
            return $http.put(ticketsUrl + '?' + data);
        }

        function lockTicket(id) {
            return $http.put(ticketsUrl + '/' + id + '/lock');
        }

        function unlockTicket(id) {
            return $http.put(ticketsUrl + '/' + id + '/unlock');
        }

        function search(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/search', payLoad);
        }

        function getRelatedTicket(id) {
            return $http.get(ticketsUrl + '/' + id + '/relatedticket');
        }

        function getRelatedTicketByCostEstimateSource(id) {
            return $http.get(ticketsUrl + '/costestimate/' + id + '/relatedticket');
        }

        function hasIncompleteRequiredForms(id) {
            return $http.get(ticketsUrl + '/' + id + '/has-incomplete-required-forms');
        }

        function getTicketsWithFilters(filters) {
            let epochStartDate = new Date(filters.startDate).toDateString();
            let epochEndDate = new Date(filters.endDate).toDateString();

            let customHeaders = {
                "X-FilteredTicket-Number": filters.filteredTicketNumber,
                "X-SelectedBranch-Ids": filters.selectedBranchIds,
                "X-StartDate": epochStartDate,
                "X-EndDate": epochEndDate,
                "X-SelectedCompany-Ids": filters.selectedCompanyIds,
                "X-SelectedProject-Ids": filters.selectedProjectIds,
                "X-SelectedTag-Ids": filters.selectedTagIds,
                "X-Include-Invoiced-Jobs": filters.includeInvoicedJobs
            };

            return $http.get(ticketsUrl + '/filtered-list', {
                headers: customHeaders
            });
        }

        function getTicketsWithFiltersForPaperwork(filters) {
            let epochStartDate = new Date(filters.startDate).toDateString();
            let epochEndDate = new Date(filters.endDate).toDateString();

            let customHeaders = {
                "X-FilteredTicket-Number": filters.filteredTicketNumber,
                "X-SelectedBranch-Ids": filters.selectedBranchIds,
                "X-StartDate": epochStartDate,
                "X-EndDate": epochEndDate,
                "X-SelectedCompany-Ids": filters.selectedCompanyIds,
                "X-SelectedProject-Ids": filters.selectedProjectIds,
                "X-SelectedTag-Ids": filters.selectedTagIds,
                "X-Include-Invoiced-Jobs": filters.includeInvoicedJobs
            };

            return $http.get(ticketsUrl + '/filtered-list-paperwork', {
                headers: customHeaders
            });
        }

        function downloadPaperwork(data) {
            return $http({
                method: 'POST',
                url: ticketsUrl + '/download-paperwork',
                data: data
            });
        }

        function regeneratePaperworkPdfForTicketIds(ticketIds) {
            return $http.post(ticketsUrl + '/regenerate-paperwork-pdf', ticketIds);
        }

        function unlinkedRelatedTicket(ticketId, unlinkRelatedTicket) {
            return $http.post(ticketsUrl + "/" + ticketId + "/relatedtickets?" + "unlinkRelatedTicket=" + unlinkRelatedTicket);
        }
    }
})();

{
    angular.module('app.api')
        .factory('termsApi', termsApi);

    /** @ngInject */
    function termsApi(
        $http,
        tenantSettings
    ) {
        return {
            getTerms: getTerms,
            saveTerm: saveTerm
        };

        function getTerms() {
            return $http.get(tenantSettings.coreApiUrl + 'api/termdays');
        }

        function saveTerm(name) {
            var payLoad = {
                Name: name
            }
            return $http.post(tenantSettings.coreApiUrl + 'api/termdays', payLoad);
        }
    }
}

(function() {
    angular.module('app.api')
        .factory('tenantsApi', tenantsApi);

    /** @ngInject */
    function tenantsApi(
        $http,
        tenantsApiUrl,
        claimsUtilService
    ) {
        var tenantKey = claimsUtilService.getTenantKey();

        return {
            getBusinesses: getBusinesses,
            createBusiness: createBusiness,
            getBusiness: getBusiness,
            saveBusiness: saveBusiness,
            getPayrollCompany: getPayrollCompany,
            getGeneralSettings: getGeneralSettings,
            updateTenantSettings: updateTenantSettings,
            getAllFeatures: getAllFeatures,
            updatedEnabledFeatures: updatedEnabledFeatures
        };

        function getBusinesses() {
            return $http.get(tenantsApiUrl + tenantKey + '/businesses');
        }

        function createBusiness(business) {
            return $http.post(tenantsApiUrl + tenantKey + '/businesses', business);
        }

        function getBusiness(id) {
            return $http.get(tenantsApiUrl + tenantKey + '/businesses/' + id);
        }

        function saveBusiness(id, formdata) {
            return $http({
                url: tenantsApiUrl + tenantKey + '/businesses/' + id,
                method: 'PUT',
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: angular.identity,
                data: formdata
            });
        }

        function getPayrollCompany() {
            return $http.get(tenantsApiUrl + tenantKey + '/businesses/payroll-company');
        }

        function getGeneralSettings() {
            return $http.get(tenantsApiUrl + tenantKey + '/general-settings');
        }

        function updateTenantSettings(payload) {
            return $http({
                method: 'PUT',
                url: tenantsApiUrl + tenantKey + '/settings/',
                data: payload
            });
        }

        function getAllFeatures() {
            return $http.get(tenantsApiUrl + tenantKey + '/features');
        }

        function updatedEnabledFeatures(payload) {
            return $http({
                method: 'PUT',
                url: tenantsApiUrl + tenantKey + '/enabled-features/',
                data: payload
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.tax')
        .factory('taxApi', taxApi);

    function taxApi(
        $http,
        tenantSettings
    ) {
        let taxApiUrl = tenantSettings.coreApiUrl + 'api/tax';
        let self = this;

        self.get = function(id) {
            return $http.get(taxApiUrl + '/' + id);
        };

        self.getAll = function(includeDeleted = true) {
            return $http.get(taxApiUrl + '?includeDeleted=' + includeDeleted);
        };

        self.add = function(params) {
            return $http.post(taxApiUrl, params);
        };

        self.update = function(id, params) {
            return $http.put(taxApiUrl + '/' + id, params);
        };
        
        self.delete = function(id) {
            return $http.delete(taxApiUrl + '/' + id);
        };
       
        return self;
    }
})();

(function() {
    'use strict';

    angular.module('app.tags')
        .factory('tagsApi', tagsApi);

    function tagsApi(
        $http,
        tenantSettings
    ) {
        let tagsApiUrl = tenantSettings.coreApiUrl + 'api/tags';
        let self = this;

        self.getAllTags = function() {
            return $http.get(tagsApiUrl + '?activeOnly=false');
        };

        self.getActiveTags = function() {
            return $http.get(tagsApiUrl + '?activeOnly=true');
        };

        self.add = function(params) {
            return $http.post(tagsApiUrl, params);
        };

        self.update = function(params) {
            return $http.put(tagsApiUrl + '/' + params.Id , params);
        };

        return self;
    }
})();

(function () {
    'use strict';

    angular.module('app.api')
        .factory('surchargesAPI', surchargesAPI);

    /** @ngInject */
    function surchargesAPI(
        $http,
        tenantSettings
    ) {
        var baseUrl = tenantSettings.coreApiUrl + 'api/rate-cards/surcharges';

        return {
            list: list,
            getById: getById,
            create: create,
            patch: patch,
            remove: remove
        };

        function list() {
            return $http.get(baseUrl);
        }

        function getById(id) {
            return $http.get(baseUrl + '/' + id);
        }

        function create(payload) {
            return $http.post(baseUrl, payload);
        }

        function patch(id, payload, eTag) {
            return $http({
                method: 'PATCH',
                url: baseUrl + '/' + id,
                data: payload,
                headers: {
                    'If-Match': eTag
                }
            });
        }

        function remove(id) {
            return $http.delete(baseUrl + '/' + id);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('stockCategoryApi', stockCategoryApi);

    /** @ngInject */
    function stockCategoryApi(
        $http,
        tenantSettings
    ) {
        var stockCategoriesApiUrl = tenantSettings.coreApiUrl + 'api/stockcategories';

        return {
            updateCategories: updateCategories,
            deleteCategories: deleteCategories
        };

        function updateCategories(data) {
            return $http.put(stockCategoriesApiUrl, data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function deleteCategories(data) {
            ;
            return $http.post(stockCategoriesApiUrl + '/bulk/delete', data, {
                'Accept': 'application/json, text/javascript'
            });
        }
    };
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('stateApi', stateApi);

    function stateApi(
        $http,
        $q,
        tenantSettings,
        alasql
    ) {
        var branchesApiUrl = tenantSettings.coreApiUrl + 'api/Branches';

        return {
            getStates: getStates
        };

        function getStates() {
            var deferred = $q.defer();

            $http.get(branchesApiUrl, {
                    cache: true
                })
                .then(function(resp) {
                    let results = alasql("SELECT DISTINCT State FROM ?", [resp.data]);

                    let finalResults = [];
                    angular.forEach(results, function(itm) {
                        finalResults.push({
                            id: itm.State,
                            value: itm.State
                        });
                    }, this);

                    deferred.resolve({
                        data: finalResults
                    });
                });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('skillsMatrixApi', skillsMatrixApi);

    /** @ngInject */
    function skillsMatrixApi(
        $http,
        tenantSettings
    ) {
        var apiGroup = tenantSettings.coreApiUrl + 'api/SkillsGroup';

        return {
            getSkillsGroups: getSkillsGroups,
            addSkillGroup: addSkillGroup,
            editSkillGroup: editSkillGroup,
            deleteSkillGroup: deleteSkillGroup,
            getSkillsByBranch: getSkillsByBranch,
            getSkillsByBranchForContacts: getSkillsByBranchForContacts,
            getSkillsandChildren: getSkillsandChildren
        };

        function getSkillsGroups() {
            return $http.get(apiGroup);
        }

        function addSkillGroup(skillGroup) {
            return $http.post(apiGroup, skillGroup);
        }

        function editSkillGroup(skillId, skillGroup) {
            return $http.put(apiGroup + "/" + skillId, skillGroup);
        }

        function deleteSkillGroup(Id) {
            return $http.delete(apiGroup + "/" + Id);
        }

        function getSkillsByBranch(branches) {
            return $http.post(apiGroup + "/skills/lookup", branches);
        }

        function getSkillsandChildren() {
            return $http.get(tenantSettings.coreApiUrl + "api/skills/lookup?parentsOnly=true");
        }

        function getSkillsByBranchForContacts(branches) {
            return $http.post(apiGroup + "/contacts/skills/lookup", branches);
        }
    }
})();

{
    angular.module('app.api')
        .factory('skillLevelApi', skillLevelApi);

    /** @ngInject */
    function skillLevelApi(
        $http,
        tenantSettings
    ) {
        var skillLevelApiUrl = tenantSettings.coreApiUrl + 'api/skilllevel/';

        return {
            getSkillsLevel: getSkillsLevel,
            addSkillsLevel: addSkillsLevel,
            deleteSkillsLevel: deleteSkillsLevel,
            editSkillsLevel: editSkillsLevel
        };

        function getSkillsLevel() {
            return $http.get(skillLevelApiUrl);
        }

        function addSkillsLevel(payload) {
            return $http.post(skillLevelApiUrl, payload);
        }

        function deleteSkillsLevel(Id) {
            return $http.delete(skillLevelApiUrl + Id);
        }

        function editSkillsLevel(Id, payload) {
            payload['Id'] = Id;
            return $http.put(skillLevelApiUrl + Id, payload);
        }

    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('resourceWhiteboardApi', resourceWhiteboardApi);

    /** @ngInject */
    function resourceWhiteboardApi(
        $http,
        tenantSettings
    ) {
        var whiteboardResourceApiUrl = tenantSettings.coreApiUrl + 'api/whiteboard/resource';

        return {
            getTicketsPerDay: getTicketsPerDay,
            getTicketsPerDayGroupByClient: getTicketsPerDayGroupByClient,
            getTicketsPerDayCount: getTicketsPerDayCount,
            getTicketsPerWeek: getTicketsPerWeek,
            getTicketsPerWeekGroupByClient: getTicketsPerWeekGroupByClient
        };

        function getTicketsPerDay(payload) {
            return $http.post(whiteboardResourceApiUrl + '/day', payload);
        }

        function getTicketsPerDayCount(payload) {
            return $http.post(whiteboardResourceApiUrl + '/day/count', payload);
        }

        function getTicketsPerDayGroupByClient(payload) {
            return $http.post(whiteboardResourceApiUrl + '/day/byclient', payload);
        }

        function getTicketsPerWeek(payload) {
            return $http.post(whiteboardResourceApiUrl + '/week', payload);
        }

        function getTicketsPerWeekGroupByClient(payload) {
            return $http.post(whiteboardResourceApiUrl + '/week/byclient', payload);
        }
    }
})();

{
    angular.module('app.api')
        .factory('reportsApi', reportsApi);

    /** @ngInject */
    function reportsApi(
        $http,
        tenantSettings
    ) {
        return {
            getAllReportJobs: getAllReportJobs,
            generateReport: generateReport,
            getReportType: getReportType,
            getReportJob: getReportJob,
            generateSkillStatusReport: generateSkillStatusReport,
            deleteReportJob: deleteReportJob
        };

        function getReportJob(reportJobId) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/report-jobs/' + reportJobId
            });
        }

        function getAllReportJobs() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/report-jobs'
            });
        }

        function generateReport(payLoad) {
            return $http({
                method: 'POST',
                url: tenantSettings.coreApiUrl + 'api/report-jobs',
                data: payLoad
            });
        }

        function generateSkillStatusReport() {
            return $http({
                method: 'POST',
                url: tenantSettings.coreApiUrl + 'api/report-jobs/generate-skill-status-report'
            });
        }

        function deleteReportJob(reportJobId) {
            return $http({
                method: 'DELETE',
                url: tenantSettings.coreApiUrl + 'api/report-jobs/' + reportJobId
            });
        }

        function getReportType() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/report-jobs/types'
            });
        }
    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('rateCardsApi', rateCardsApi);

    function rateCardsApi(
        $http,
        tenantSettings
    ) {
        let self = this;
        let rateCardsApiUrl = tenantSettings.coreApiUrl + 'api/ratecards';

        self.request = {};

        self.request.getRatecardAll = function() {
            return $http.get(rateCardsApiUrl + "/list");
        };

        self.request.getRatecard = function(ratecardId) {
            return $http.get(rateCardsApiUrl + "/" + ratecardId);
        };

        self.request.getAllowancesAll = function() {
            return $http.get(rateCardsApiUrl + "/allowances/lookup");
        };

        self.request.getTimesheetAdjustmentsAll = function() {
            return $http.get(rateCardsApiUrl + "/timesheetAdjustments/lookup");
        };

        self.request.getTimesheetAll = function() {
            return $http.get(rateCardsApiUrl + "/timesheetadjustments/list");
        };

        self.request.getFormats = function() {
            return $http.get(rateCardsApiUrl + "/formats/lookup");
        };

        self.request.getPackages = function() {
            return $http.get(rateCardsApiUrl + "/packages/lookup");
        };

        self.request.getTravelTypes = function() {
            return $http.get(rateCardsApiUrl + "/travelTypes/lookup");
        };

        self.request.getTravelOnlyChargeTypes = function() {
            return $http.get(rateCardsApiUrl + "/travelOnlyChargeTypes/lookup");
        };

        self.request.getVehicleChargeTypes = function() {
            return $http.get(rateCardsApiUrl + "/vehicleChargeTypes/lookup");
        };

        self.request.getRatecardPricingSpreadsheetData = function(ratecardId) {
            return $http.get(rateCardsApiUrl + '/' + ratecardId + '/spreadsheetData');
        };

        self.request.saveRatecardPricingData = function(ratecardId, params) {
            return $http.put(rateCardsApiUrl + '/' + ratecardId + '/spreadsheetData', params);
        };

        self.request.postBulkPricingUpdate = function(ratecardId, params, percentage, worksheetTypeQuery) {
            return $http.post(rateCardsApiUrl + '/' + ratecardId + '/spreadsheetData/bulkpriceupdate?percentage=' + percentage + worksheetTypeQuery, params);
        };

        self.request.postNewRatecard = function(params) {
            return $http.post(rateCardsApiUrl, params);
        };

        self.request.putRatecard = function(ratecardId, params) {
            return $http.put(rateCardsApiUrl + '/' + ratecardId, params);
        };

        self.request.archiveRatecard = function(ratecardId, isArchive) {
            return $http.patch(rateCardsApiUrl + '/' + ratecardId, isArchive);
        };

        self.request.getAllowanceTypes = function() {
            return $http.get(rateCardsApiUrl + '/allowances/types');
        };

        self.request.getAllowanceHourlyMultipliers = function() {
            return $http.get(rateCardsApiUrl + '/allowances/hourlyMultipliers');
        };

        self.request.getAllowanceDistanceMultipliers = function() {
            return $http.get(rateCardsApiUrl + '/allowances/distanceMultipliers');
        };

        self.request.getConditionTypes = function() {
            return $http.get(rateCardsApiUrl + '/allowances/conditions/types');
        };

        self.request.getConditionInputVariables = function() {
            return $http.get(rateCardsApiUrl + '/allowances/conditions/inputVariables');
        };

        self.request.getConditionCompareTypes = function() {
            return $http.get(rateCardsApiUrl + '/allowances/conditions/compareTypes');
        };

        self.request.getConditions = function() {
            return $http.get(rateCardsApiUrl + '/allowances/conditions/lookup');
        };

        self.request.getAllowance = function(allowanceId) {
            return $http.get(rateCardsApiUrl + "/allowances/" + allowanceId);
        };

        self.request.getAllowance = function(allowanceId) {
            return $http.get(rateCardsApiUrl + "/allowances/" + allowanceId);
        };

        self.request.getAllowancesTypes = function() {
            return $http.get(rateCardsApiUrl + '/allowances/types/lookups');
        };

        self.request.postRatecardAllowance = function(params) {
            return $http.post(rateCardsApiUrl + '/allowances', params);
        };

        self.request.putRatecardAllowance = function(allowanceId, params) {
            return $http.put(rateCardsApiUrl + '/allowances/' + allowanceId, params);
        };

        self.request.deleteRatecardAllowance = function(allowanceId) {
            return $http.delete(rateCardsApiUrl + '/allowances/' + allowanceId);
        };

        self.request.getTimesheetTypes = function() {
            return $http.get(rateCardsApiUrl + "/timesheetadjustments/types");
        };

        self.request.getTimesheetConditions = function() {
            return $http.get(rateCardsApiUrl + "/timesheetadjustments/conditions/lookup");
        };

        self.request.getTimesheetAdjustment = function(timesheetId) {
            return $http.get(rateCardsApiUrl + "/timesheetadjustments/" + timesheetId);
        };

        self.request.postRatecardTimesheet = function(params) {
            return $http.post(rateCardsApiUrl + '/timesheetadjustments', params);
        };

        self.request.deleteRatecardTimesheet = function(timesheetId) {
            return $http.delete(rateCardsApiUrl + '/timesheetadjustments/' + timesheetId);
        };

        self.request.putRatecardTimesheet = function(timesheetId, params) {
            return $http.put(rateCardsApiUrl + '/timesheetadjustments/' + timesheetId, params);
        };

        self.request.updateRatecardsPackage = function(packageId) {
            return $http.put(rateCardsApiUrl + '/packages/' + packageId);
        };

        self.request.deleteRateCardsPackage = function(packageId) {
            return $http.delete(rateCardsApiUrl + '/packages/' + packageId);
        };

        self.request.getInvoiceGroups = function() {
            return $http.get(rateCardsApiUrl + '/invoicegroups/lookup/');
        };

        self.request.updateRateCardRules = function(rateCardId) {
            return $http.put(rateCardsApiUrl + '/' + rateCardId + '/rule');
        }
        self.request.getEstablishmentFeeTypes = function() {
            return $http.get(rateCardsApiUrl + "/establishmentFeeTypes/lookup");
        };

        return self.request;
    }
})();

{
    angular.module('app.api')
        .factory('publicHolidayApi', publicHolidayApi);

    /** @ngInject */
    function publicHolidayApi(
        $http,
        tenantSettings
    ) {
        return {
            getHolidays: getHolidays,
            postHoliday: postHoliday,
            deleteHoliday: deleteHoliday,
            putHoliday: putHoliday
        };

        function getHolidays() {
            return $http.get(tenantSettings.coreApiUrl + 'api/publicholiday');
        }

        function postHoliday(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/publicholiday', payLoad);
        }

        function deleteHoliday(id) {
            return $http.delete(tenantSettings.coreApiUrl + 'api/publicholiday/' + id);
        }

        function putHoliday(id, payLoad) {
            return $http.put(tenantSettings.coreApiUrl + 'api/publicholiday/' + id, payLoad);
        }
    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('projectApi', projectApi);

    function projectApi(
        $http,
        tenantSettings
    ) {
        var projectApiUrl = tenantSettings.coreApiUrl + 'api/project';
        var projectsLookupApiUrl = tenantSettings.coreApiUrl + 'api/lookup/projects';

        return {
            getProjects: getProjects,
            putProject: putProject,
            postProject: postProject,
            getProjectByBranch: getProjectByBranch,
            getProjectById: getProjectById,
            getProjectsByCompanies: getProjectsByCompanies,
            getProjectsByEmployees: getProjectsByEmployees
        };

        function getProjects() {
            return $http.get(projectApiUrl);
        }

        function getProjectById(id) {
            return $http.get(projectApiUrl + "/" + id);
        }

        function postProject(payLoad) {
            return $http.post(projectApiUrl, payLoad);
        }

        function putProject(payLoad) {
            return $http.put(projectApiUrl + "/" + payLoad.id, payLoad);
        }

        function getProjectByBranch(id) {
            return projectApiUrl + "/branch/" + id
        }

        function getProjectsByCompanies(ids) {
            return $http({
                method: 'POST',
                url: projectsLookupApiUrl + '/company',
                data: ids
            });
        }

        function getProjectsByEmployees(ids) {
            return $http({
                method: 'POST',
                url: projectsLookupApiUrl + '/employee',
                data: ids
            });
        }
    }
})();

/* eslint-disable comma-dangle */
{
    angular.module("app.api").factory("preScheduleApi", preScheduleApi);

    /** @ngInject */
    function preScheduleApi($http, tenantSettings) {
        return {
            generateSchedule: generateSchedule,
            confirmPreScheduleJobByTicketIds: confirmPreScheduleJobByTicketIds,
            cancelScheduling: cancelScheduling,
            getGeneratedPreSchedule: getGeneratedPreSchedule,
            getGeneratedPreScheduleJobStatus: getGeneratedPreScheduleJobStatus,
            updatePreScheduleJobStatus: updatePreScheduleJobStatus,
            getPreScheduleJobIdsByTicketId: getPreScheduleJobIdsByTicketId,
            retrySchedulingCopilot: retrySchedulingCopilot
        };

        function getPreScheduleJobs(preScheduleJobIds) {
            return $http.get(tenantSettings.coreApiUrl+ 'api/preschedule/jobs?id=' + preScheduleJobIds.join(','));
        }

        function getGeneratedPreSchedule(preScheduleJobId) {
            return $http.get(tenantSettings.coreApiUrl + "api/preschedule/" + preScheduleJobId);
        }

        async function getGeneratedPreScheduleJobStatus(preScheduleJobIds) {
            if(!preScheduleJobIds || preScheduleJobIds.length === 0) {
                return [];
            }
            
            var result = await getPreScheduleJobs(preScheduleJobIds);
            return result.data;
        }

        function generateSchedule(ticketId, resources) {
            var requestBody = {
                tickets: [{
                    ticketId: ticketId,
                    resourceItems: resources
                }]
            }

           return $http.post(tenantSettings.coreApiUrl + "api/preschedule/", requestBody);
        }

        function confirmPreScheduleJobByTicketIds(ticketIds) {
           return $http.post(tenantSettings.coreApiUrl + "api/preschedule/status/confirm/ticket", ticketIds);
        }

        function cancelScheduling(preScheduleJobId){

            return $http.post(tenantSettings.coreApiUrl + "api/preschedule/" + preScheduleJobId + '/cancel');
        }

        function retrySchedulingCopilot(preScheduleJobId){

            return $http.post(tenantSettings.coreApiUrl + "api/preschedule/" + preScheduleJobId +'/retry');
        }

        function getGeneratedPreSchedule(preScheduleJobId) {
            return $http.get(tenantSettings.coreApiUrl + "api/preschedule/" + preScheduleJobId);
        }

        function updatePreScheduleJobStatus(preScheduleJobIds)
        {
            return $http.post(tenantSettings.coreApiUrl + 'api/preschedule/status', preScheduleJobIds);
        }

        function getPreScheduleJobIdsByTicketId(ticketId)
        {
            return $http.get(tenantSettings.coreApiUrl + 'api/preschedule/ticket/' + ticketId);
        }
    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('payrollSettingsApi', payrollSettingsApi);

    function payrollSettingsApi(
        $http,
        tenantSettings
    ) {
        var payrollSettingsApiUrl = tenantSettings.coreApiUrl + 'api/v1/payrollsettings';

        return {
            getAll: getAll,
            getExportFields: getExportFields,
            getFileExtension: getFileExtension,
            updatePayrollSettingsExportFileHeading: updatePayrollSettingsExportFileHeading,
            updatePayrollSettingsExportFileExtension: updatePayrollSettingsExportFileExtension,
            updatePayrollSettingsExportFormat: updatePayrollSettingsExportFormat,
            updatePayrollSettingsTaxCodes: updatePayrollSettingsTaxCodes,
            updatePayrollSettingsCompensationCodes: updatePayrollSettingsCompensationCodes,
            updatePayrollSettingsSuperannuationCodes: updatePayrollSettingsSuperannuationCodes,
            updatePayrollSettingsExportCodes: updatePayrollSettingsExportCodes,
            addPayrollSettingsTaxRates: addPayrollSettingsTaxRates,
            addPayrollSettingsCompensationRates: addPayrollSettingsCompensationRates,
            addPayrollSettingsSuperannuationRates: addPayrollSettingsSuperannuationRates,
            updatePayrollSettingsTaxRates: updatePayrollSettingsTaxRates,
            updatePayrollSettingsCompensationRates: updatePayrollSettingsCompensationRates,
            updatePayrollSettingsSuperannuationRates: updatePayrollSettingsSuperannuationRates,
            deletePayrollSettingsTaxRate: deletePayrollSettingsTaxRate,
            deletePayrollSettingsCompensationRate: deletePayrollSettingsCompensationRate,
            deletePayrollSettingsSuperannuationRate: deletePayrollSettingsSuperannuationRate,
            deletePayrollSettingsTimesheetDetails: deletePayrollSettingsTimesheetDetails,
            addPayrollSettingsTimesheetDetails: addPayrollSettingsTimesheetDetails,
            updatePayrollSettingsTimesheetDetails: updatePayrollSettingsTimesheetDetails,
            downloadPayrollSettingsAwardCodesAndRates: downloadPayrollSettingsAwardCodesAndRates
        };

        function getAll() {
            return $http.get(payrollSettingsApiUrl);
        }

        function getExportFields() {
            return $http.get(payrollSettingsApiUrl + '/exportfields');
        }

        function getFileExtension() {
            return $http.get(payrollSettingsApiUrl + "/exportFileExtension");
        }

        function updatePayrollSettingsExportFileExtension(params) {
            return $http.put(payrollSettingsApiUrl + '/exportFileExtension', '"' + params.fileExtension + '"');
        }

        function updatePayrollSettingsExportFileHeading(params) {
            return $http.put(payrollSettingsApiUrl + '/exportHeader', '"' + params.fileHeading + '"');
        }

        function updatePayrollSettingsExportFormat(params) {
            return $http.put(payrollSettingsApiUrl + '/exportFormat', params);
        }

        function updatePayrollSettingsTaxCodes(params) {
            return $http.put(payrollSettingsApiUrl + '/taxCodes', params.taxCodes);
        }

        function updatePayrollSettingsCompensationCodes(params) {
            return $http.put(payrollSettingsApiUrl + '/workerCompensationCodes', params.workerCompensationCodes);
        }

        function updatePayrollSettingsSuperannuationCodes(params) {
            return $http.put(payrollSettingsApiUrl + '/superannuationCodes', params.superannuationCodes);
        }

        function updatePayrollSettingsExportCodes(params) {
            return $http.put(payrollSettingsApiUrl + '/payrollExportCodes', params.payrollExportCodes);
        }

        function addPayrollSettingsTaxRates(year, rate, params) {
            return $http.post(payrollSettingsApiUrl + '/taxRates/' + year + '/' + rate, params);
        }

        function addPayrollSettingsCompensationRates(year, rate, params) {
            return $http.post(payrollSettingsApiUrl + '/workerCompensationRates/' + year + '/' + rate, params);
        }


        function addPayrollSettingsSuperannuationRates(year, rate, params) {
            return $http.post(payrollSettingsApiUrl + '/superannuationRates/' + year + '/' + rate, params);
        }

        function updatePayrollSettingsTaxRates(branchId, params) {
            return $http.put(payrollSettingsApiUrl + '/taxRates/' + branchId + '/' + params.Year, params);
        }

        function updatePayrollSettingsCompensationRates(branchId, params) {
            return $http.put(payrollSettingsApiUrl + '/workerCompensationRates/' + branchId + '/' + params.Year, params);
        }

        function updatePayrollSettingsSuperannuationRates(branchId, params) {
            return $http.put(payrollSettingsApiUrl + '/superannuationRates/' + branchId + '/' + params.Year, params);
        }

        function deletePayrollSettingsTaxRate(params) {
            return $http.delete(payrollSettingsApiUrl + '/taxRates/' + params.BranchId + '/' + params.Year);
        }

        function deletePayrollSettingsCompensationRate(params) {
            return $http.delete(payrollSettingsApiUrl + '/workerCompensationRates/' + params.BranchId + '/' + params.Year);
        }

        function deletePayrollSettingsSuperannuationRate(params) {
            return $http.delete(payrollSettingsApiUrl + '/superannuationRates/' + params.BranchId + '/' + params.Year);
        }

        function deletePayrollSettingsTimesheetDetails(params) {
            return $http.delete(payrollSettingsApiUrl + '/timesheetHeadings?headerName=' + params.Name);
        }

        function addPayrollSettingsTimesheetDetails(params) {
            return $http.post(payrollSettingsApiUrl + '/timesheetHeadings', params);
        }

        function updatePayrollSettingsTimesheetDetails(headingName, params) {
            return $http.put(payrollSettingsApiUrl + '/timesheetHeadings?headerName=' + headingName, params);
        }

        function downloadPayrollSettingsAwardCodesAndRates() {
            let header = new Headers();
            header.append('Content-Type', 'application/json');
            header.append('responseType', 'arrayBuffer');

            return $http({
                method: "post",
                responseType: 'arraybuffer',
                url: payrollSettingsApiUrl + '/awardCodes/export',
                timeout: 30000,
                headers: header
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('payrollInterpretJobsApi', payrollInterpretJobsApi);

    function payrollInterpretJobsApi(
        $http,
        tenantSettings
    ) {
        var payrollSettingsApiUrl = tenantSettings.coreApiUrl + 'api/payroll-interpret-jobs';

        return {
            getInterpretJobs: getInterpretJobs,
            getInterpretJob: getInterpretJob,
            deleteInterpretJob: deleteInterpretJob
        };

        function getInterpretJobs() {
            return $http.get(payrollSettingsApiUrl);
        }

        function getInterpretJob(interpretJobId) {
            return $http.get(payrollSettingsApiUrl + '/' + interpretJobId);
        }

        function deleteInterpretJob(interpretJobId) {
            return $http.delete(payrollSettingsApiUrl + '/' + interpretJobId);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.payroll-group')
        .factory('payrollGroupsApi', payrollGroupsApi);

    /** @ngInject */
    function payrollGroupsApi(
        $http,
        tenantSettings
    ) {
        let payrollGroupsApiUrl = tenantSettings.coreApiUrl + 'api/payrollgroup';

        return {
            getAll: getAll,
            add: add,
            update: update,
            archive: archive
        };

        function getAll() {
            return $http.get(payrollGroupsApiUrl);
        };

        function add(payrollGroup) {
            return $http.post(payrollGroupsApiUrl, payrollGroup);
        };

        function update(payrollGroup) {
            return $http.put(payrollGroupsApiUrl + '/' + payrollGroup.Id, payrollGroup);
        };

        function archive(payrollGroupId) {
            return $http.put(payrollGroupsApiUrl + '/archive/' + payrollGroupId);
        };
    }

})();
(function() {
    'use strict';

    angular.module('app.api')
        .factory('paymentClaimsApi', paymentClaimsApi);

    /** @ngInject */
    function paymentClaimsApi(
        $http,
        tenantSettings
    ) {
        var paymentClaimsApiUrl = tenantSettings.invoiceApiUrl + 'api/paymentclaim';

        var service = {
            downloadPaymentClaims: downloadPaymentClaims,
        };

        return service;

        function downloadPaymentClaims(data) {
            return $http({
                method: 'POST',
                url: paymentClaimsApiUrl,
                data: data,
                headers:{
                    'X-TenantKey': tenantSettings.tenantKey
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('passwordApi', passwordApi);

    /** @ngInject */
    function passwordApi(
        $http,
        tenantSettings
    ) {
        var accountsApiUrl = tenantSettings.coreApiUrl + 'api/accounts';

        return {
            updatePassword: updatePassword
        };

        function updatePassword(data) {
            return $http.post(accountsApiUrl + '/changepassword', data);
        }
    };
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('pageHistoryApi', pageHistoryApi);

    function pageHistoryApi(
        $http,
        tenantSettings
    ) {
        var sideBarPageHistoryApiUrl = tenantSettings.coreApiUrl + 'api/contacts/sidebarpagehistory';

        return {
            getAll: getAll,
            saveHistory: saveHistory
        };

        function getAll(id, recordSize) {
            var promise = $http.get(sideBarPageHistoryApiUrl + '/contact/' + id + '/size/' + recordSize);
            return promise;
        }

        function saveHistory(userId, data) {
            return $http.post(sideBarPageHistoryApiUrl + '/contact/' + userId, data, {
                'Accept': 'application/json, text/javascript'
            });
        }
    };
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('packagesApi', packagesApi);

    function packagesApi(
        $http,
        tenantSettings
    ) {
        let self = this;
        let packagesApiUrl = tenantSettings.coreApiUrl + 'api/package-templates';

        self.request = {};

        self.request.getPackageTemplate = function(packageId) {
            return $http.get(packagesApiUrl + '/' + packageId);
        };

        self.request.getPackageTemplates = function() {
            return $http.get(packagesApiUrl);
        };

        self.request.createPackageTemplate = function(params) {
            return $http.post(packagesApiUrl, params);
        };

        self.request.updatePackageTemplate = function(packageId, params) {
            return $http.put(packagesApiUrl + '/' + packageId, params);
        };

        self.request.deletePackageTemplate = function(packageId) {
            return $http.delete(packagesApiUrl + '/' + packageId);
        };

        return self.request;
    }
})();
(function() {
    'use strict';

    angular.module('app.api')
        .factory('oldAwardAPI', oldAwardAPI);

    /** @ngInject */
    function oldAwardAPI(
        $http,
        tenantSettings
    ) {
        return {
            getAwards: getAwards,
            getAwardsSummary: getAwardsSummary,
            saveAward: saveAward,
            editAward: editAward,
            getPayrates: getPayrates,
            getShiftRoles: getShiftRoles,
            updatePayrates: updatePayrates,
            saveShiftRole: saveShiftRole,
            editShiftRole: editShiftRole,
            getClassifications: getClassifications,
            getClassificationsLookup: getClassificationsLookup,
            saveClassification: saveClassification,
            saveClassificationV2: saveClassificationV2,
            editClassification: editClassification,
            editClassificationV2: editClassificationV2,
            getRolesByAwardAndBranch: getRolesByAwardAndBranch,
            getClassificationsByAwardAndBranch: getClassificationsByAwardAndBranch,
            interpret: interpret,
            deleteTemporaryInterpretedShifts: deleteTemporaryInterpretedShifts,
            _export: _export,
            reExport: reExport,
            archiveAward: archiveAward
        };

        function getAwardsSummary() {
            return $http.get(tenantSettings.coreApiUrl + "/api/award/summary");
        }
        function updatePayrates(awardId,payRateBundle)
        {
            return $http.put(tenantSettings.coreApiUrl + "/api/award/"+awardId+"/payrates", payRateBundle);
        }

        function getAwards() {
            return $http.get(tenantSettings.coreApiUrl + "/api/award");
        }

        function getPayrates(awardId) {
            return $http.get(tenantSettings.coreApiUrl + "/api/award/" + awardId + "/payrates");
        }

        function getRolesByAwardAndBranch(AwardId) {
            return $http.get(tenantSettings.coreApiUrl + "/api/awards/" + AwardId + "/shiftroles/lookup");
        }

        function getClassificationsByAwardAndBranch(awardId, branchId) {
            return $http.get(tenantSettings.coreApiUrl + "/api/awards/" + awardId + "/classifications/lookup?branchId=" + branchId);
        }

        function getShiftRoles() {
            return $http.get(tenantSettings.coreApiUrl + "/api/shiftrole");
        }

        function getClassifications() {
            return $http.get(tenantSettings.coreApiUrl + "/api/awardclassification");
        }

        function getClassificationsLookup() {
            return $http.get(tenantSettings.coreApiUrl + "/api/awardclassifications/lookup");
        }

        function saveAward(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/award", payLoad);
        }

        function saveShiftRole(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/shiftrole", payLoad);
        }

        function saveClassification(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/awardclassification", payLoad);
        }

        function saveClassificationV2(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/v2/awardclassifications", payLoad);
        }

        function editAward(payLoad) {
            return $http.put(tenantSettings.coreApiUrl + "/api/award/" + payLoad.Id, payLoad);
        }

        function editShiftRole(payLoad) {
            return $http.put(tenantSettings.coreApiUrl + "/api/shiftrole/" + payLoad.Id, payLoad);
        }

        function editClassification(payLoad) {
            return $http.put(tenantSettings.coreApiUrl + "/api/awardclassification/" + payLoad.Id, payLoad);
        }

        function editClassificationV2(payLoad, OldId) {
            var encodedId = encodeURIComponent(OldId);
            return $http.put(tenantSettings.coreApiUrl + "/api/v2/awardclassifications/" + encodeURIComponent(payLoad.Id) + "?groupId=" + encodedId, payLoad);
        }

        function interpret(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/payroll/interpretation", payLoad);
        }

        function deleteTemporaryInterpretedShifts(payLoad) {
            return $http({
                method: 'DELETE',
                url: tenantSettings.coreApiUrl + "/api/payroll/temporary-interpreted-shifts",
                data: payLoad,
                headers: { 'Content-Type': 'application/json' }
            });
        }

        function _export(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/timesheets/process/export", payLoad);
        }

        function reExport(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/timesheets/process/reexport", payLoad);
        }

        function archiveAward(payLoad) {
            return $http.put(tenantSettings.coreApiUrl + "/api/award/archive/" + payLoad.Id, payLoad);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('notificationApi', notificationApi);

    function notificationApi(
        $http,
        tenantSettings
    ) {
        var notificationsApiUrl = tenantSettings.coreApiUrl + 'api/notifications';

        return {
            getAll: getAll,
            getAllUnread: getAllUnread,
            hasUnreadNotifications: hasUnreadNotifications,
            getRead: getRead,
            dismissAll: dismissAll,
            markNotificationAsRead: markNotificationAsRead
        };

        function getAll(startIndex, pageSize) {
            return $http.get(notificationsApiUrl + '/all/' + startIndex + '/' + pageSize);
        }

        function getAllUnread() {
            return $http.get(notificationsApiUrl + '/unread');
        }

        function hasUnreadNotifications() {
            return $http.get(notificationsApiUrl + '/has-unread-notifications');
        }

        function getRead() {
            return $http.get(notificationsApiUrl + '/read');
        }

        function dismissAll() {
            return $http.post(notificationsApiUrl + '/todo/dismissall');
        }

        function markNotificationAsRead(id, type) {
            return $http.post(notificationsApiUrl + '/set/read?id=' + id + "&notificationType=" + type);
        }
    };
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('messageFormatApi', messageFormatApi);

    function messageFormatApi(
        $http,
        tenantSettings
    ) {
        let self = this;
        let messageFormatsApiUrl = tenantSettings.coreApiUrl + 'api/messageformats';

        self.request = {};

        self.request.getMessageFormatFields = function() {
            return $http.get(messageFormatsApiUrl + "/fields");
        };

        self.request.getMessageFormatList = function() {
            return $http.get(messageFormatsApiUrl + "/list");
        };

        self.request.postMessageFormats = function(params) {
            return $http.post(messageFormatsApiUrl, params);
        };

        self.request.putMessageFormats = function(params, id) {
            return $http.put(messageFormatsApiUrl + "/" + id, params);
        };

        return self.request;
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('lookupApi', lookupApi);

    /** @ngInject */
    function lookupApi(
        $http,
        $q,
        $timeout,
        tenantSettings
    ) {
        return {
            getContactLookups: getContactLookups,
            getBranches: getBranches,
            getCompanyTypes: getCompanyTypes,
            getCompanyLookups: getCompanyLookups,
            getAddressTypes: getAddressTypes,
            getContactTypes: getContactTypes,
            getItemTypes: getItemTypes,
            getStockLevelTracking: getStockLevelTracking,
            getHirePeriod: getHirePeriod,
            getItemCategories: getItemCategories,
            getBasicContactLookupsforContact: getBasicContactLookupsforContact,
            getBasicContactLookupsforCompany: getBasicContactLookupsforCompany,
            getTicketTypes: getTicketTypes,
            getBillingPeriod: getBillingPeriod,
            getItemTypes2: getItemTypes2,
            getCostCodes: getCostCodes,
            getNewBillingPeriodValues: getNewBillingPeriodValues,
            getNewBillingPeriodValues2: getNewBillingPeriodValues2,
            getMinifiedEquipmentTypes: getMinifiedEquipmentTypes,
            getMinifiedVehicleTypes: getMinifiedVehicleTypes,
            getMinifiedPeopleTypes: getMinifiedPeopleTypes,
            getMinifiedPeopleTypesByBranch: getMinifiedPeopleTypesByBranch,
            getNewBillingPeriodValues3: getNewBillingPeriodValues3,
            getMinifiedBranches: getMinifiedBranches,
            getTaxTypes: getTaxTypes,
            getVehicleOwnershipTypes: getVehicleOwnershipTypes,
            getEquipmentTypes: getEquipmentTypes,
            getItemTypes3: getItemTypes3,
            getTaxLookups: getTaxLookups
        };

        function getAddressTypes(allowCache) {
            allowCache = allowCache || true;
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/address/types',
                cache: allowCache
            });
        }

        function getEquipmentTypes() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/equipmenttypes'
            });
        }

        function getMinifiedEquipmentTypes(allowCache) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookups/equipmenttypes',
                cache: true
            });
        }

        function getMinifiedVehicleTypes(allowCache) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookups/vehicletypes',
                cache: allowCache
            });
        }

        function getMinifiedPeopleTypes(allowCache) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookups/shifttypes',
                cache: true
            });
        }

        function getMinifiedPeopleTypesByBranch(branchId) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookups/shifttypes/' + branchId,
                cache: true
            });
        }

        function getContactLookups(allowCache) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/all/contact',
                cache: allowCache
            });
        }

        function getBasicContactLookupsforContact() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/contacts/basic/contactbasic/',
                cache: true
            });
        }

        function getBasicContactLookupsforCompany() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/companies/basic/contactbasic/',
                cache: true
            });
        }

        function getBranches(allowCache) {
            allowCache = allowCache || true;
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/branches',
                cache: allowCache
            });
        }

        function getMinifiedBranches(allowCache) {
            allowCache = allowCache || true;
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/branches',
                cache: allowCache
            });
        }

        function getCompanyLookups() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/all/company'
            });
        }

        function getCompanyTypes(allowCache) {
            allowCache = allowCache || true;
            var promise = $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/company/types',
                cache: allowCache
            });

            return promise;
        }

        function getContactTypes(allowCache) {
            allowCache = allowCache || true;
            var promise = $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/contact/types',
                cache: allowCache
            });

            return promise;
        }

        /**
         * For Item Manager
         * Constants
         */
         function getItemTypes() {
            var deferred = $q.defer();
            var mockData = [{
                    Id: 1,
                    Name: 'Asset'
                },
                {
                    Id: 2,
                    Name: 'Inventory'
                },
                {
                    Id: 3,
                    Name: 'Rental'
                },
                {
                    Id: 4,
                    Name: 'People'
                },
                {
                    Id: 5,
                    Name: 'Vehicle'
                }
            ];

            $timeout(function() {
                deferred.resolve({
                    data: mockData
                });
            }, 1);

            return deferred.promise;
        }

        function getItemTypes2() {
            var deferred = $q.defer();
            var mockData = [{
                    id: 1,
                    TypeName: 'Asset'
                },
                {
                    id: 2,
                    TypeName: 'Inventory'
                },
                {
                    id: 3,
                    TypeName: 'Rental'
                },
                {
                    id: 4,
                    TypeName: 'People'
                }
            ];

            $timeout(function() {
                deferred.resolve({
                    data: mockData
                });
            }, 1);

            return deferred.promise;
        }

        function getItemTypes3() {
            var promise = $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/itemtypes'
            });

            return promise;
        }

        /**
         * For Item Manager
         */
        function getStockLevelTracking() {
            var mockData = [{
                    Id: 1,
                    Name: 'Do Not Track Stock Level Counts'
                },
                {
                    Id: 2,
                    Name: 'Stock Level Counts'
                },
                {
                    Id: 3,
                    Name: 'Stock Level Counts by Branch'
                }
            ];

            return $q.when({
                data: mockData
            });
        }

        /**
         * For Item Manager
         * Hire Period Constants
         */
        function getHirePeriod() {
            var deferred = $q.defer();
            var mockData = [{
                    Id: 1,
                    Name: 'Hourly'
                },
                {
                    Id: 2,
                    Name: 'Daily'
                },
                {
                    Id: 3,
                    Name: 'Weekly'
                },
                {
                    Id: 4,
                    Name: 'Fortnightly'
                },
                {
                    Id: 5,
                    Name: 'Monthly'
                },
                {
                    Id: 6,
                    Name: 'Quarterly'
                },
                {
                    Id: 7,
                    Name: 'Annually'
                },
                {
                    Id: 8,
                    Name: 'Inventory Unit Price'
                }
            ];

            $timeout(function() {
                deferred.resolve({
                    data: mockData
                });
            }, 1);

            return deferred.promise;
        }

        //Implemented 2/27/2017 when setting billing period was moved to ticket billing preference page
        function getNewBillingPeriodValues() {
            var deferred = $q.defer();
            var mockData = [{
                    Id: 1,
                    Name: 'Hourly'
                },
                {
                    Id: 2,
                    Name: 'Daily'
                },
                {
                    Id: 3,
                    Name: 'Weekly'
                },
                {
                    Id: 4,
                    Name: 'Fortnightly'
                },
                {
                    Id: 5,
                    Name: 'Monthly'
                },
                {
                    Id: 6,
                    Name: 'Quarterly'
                },
                {
                    Id: 7,
                    Name: 'Annually'
                }
            ];

            $timeout(function() {
                deferred.resolve({
                    data: mockData
                });
            }, 1);

            return deferred.promise;
        }

        function getNewBillingPeriodValues3() {
            var deferred = $q.defer();
            var mockData = [{
                    Id: 1,
                    Name: 'Hourly'
                },
                {
                    Id: 2,
                    Name: 'Daily'
                },
                {
                    Id: 3,
                    Name: 'Weekly'
                },
                {
                    Id: 5,
                    Name: 'Monthly'
                }
            ];

            $timeout(function() {
                deferred.resolve({
                    data: mockData
                });
            }, 1);

            return deferred.promise;
        }

        function getNewBillingPeriodValues2() {
            let deferred = $q.defer();
            let mockData = [{
                    ItemId: 0,
                    Id: 1,
                    IsNotBillable: true,
                    Name: 'Not Billable - Not Charged'
                },
                {
                    ItemId: 1,
                    Id: 1,
                    IsNotBillable: false,
                    Name: 'Hourly'
                },
                {
                    ItemId: 2,
                    Id: 2,
                    IsNotBillable: false,
                    Name: 'Daily'
                },
                {
                    ItemId: 3,
                    Id: 3,
                    IsNotBillable: false,
                    Name: 'Weekly'
                },
                {
                    ItemId: 4,
                    Id: 5,
                    IsNotBillable: false,
                    Name: 'Monthly'
                },
                {
                    ItemId: 5,
                    Id: 3,
                    IsNotBillable: true,
                    Name: 'Not Billable - Weekly'
                },
                {
                    ItemId: 6,
                    Id: 5,
                    IsNotBillable: true,
                    Name: 'Not Billable - Monthly'
                },
                {
                    ItemId: 7,
                    Id: 10,
                    IsNotBillable: false,
                    Name: 'Daily (5 Day Week Rate)'
                },
                {
                    ItemId: 8,
                    Id: 11,
                    IsNotBillable: false,
                    Name: 'Daily (7 Day Week Rate)'
                },
                {
                    ItemId: 9,
                    Id: 12,
                    IsNotBillable: false,
                    Name: 'Daily (Month Rate)'
                }
            ];

            $timeout(function() {
                deferred.resolve({
                    data: mockData
                });
            }, 1);

            return deferred.promise;
        }

        /**
         * Note: HirePeriod and Billing period has the same lookup values, or it refers to same meaning in the system :-) lol
         */
        function getBillingPeriod() {
            return getHirePeriod();
        }

        /**
         * Categories for Kit and Item
         */
        function getItemCategories(allowCache) {
            allowCache = allowCache || true;
            var promise = $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/all/categories',
                cache: allowCache
            });

            return promise;
        } // End func


        function getTicketTypes() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/tickets/types',
            })
        }

        function getCostCodes() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/invoice/lookup/costcodes',
                cache: true
            });
        }

        function getVehicleOwnershipTypes() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/vehicleownershiptypes',
                cache: true
            });
        }

        function getTaxTypes() {
            let deferred = $q.defer();
            $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/taxtypes',
                cache: true
            }).then(function(resp) {
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        function getTaxLookups()
        {
            let deferred = $q.defer();
            $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/all/tax'
            }).then(function(resp) {
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('loginBackgroundApi', loginBackgroundApi);

    /** @ngInject */
    function loginBackgroundApi(
        $q,
        $timeout,
        cdnUrl
    ) {
        return {
            getBackgroundList: getBackgroundList
        };

        function getBackgroundList() {

            var deferred = $q.defer();
        
            $timeout(function() {
                deferred.resolve({
                    data: [{
                        id: 0,
                        url: `${cdnUrl}/backgrounds/login-1.jpg`
                    },
                    {
                        id: 1,
                        url: `${cdnUrl}/backgrounds/login-2.jpg`
                    },                  
                    {
                        id: 3,
                        url: `${cdnUrl}/backgrounds/login-4.jpg`
                    },
                    {
                        id: 4,
                        url: `${cdnUrl}/backgrounds/login-5.jpg`
                    },
                    {
                        id: 5,
                        url: `${cdnUrl}/backgrounds/login-6.jpg`
                    }]
                });
            }, 2000);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('lockoutRulesApi', lockoutRulesApi);

    function lockoutRulesApi(
        $http,
        tenantSettings
    ) {
        var lockoutRulesApiUrl = tenantSettings.coreApiUrl + 'api/LockoutRules/';

        return {
            getRules: getRules,
            addRule: addRule,
            editRule: editRule,
            deleteRule: deleteRule
        };

        function getRules() {
            return $http.get(lockoutRulesApiUrl);
        }

        function addRule(payLoad) {
            return $http.post(lockoutRulesApiUrl, payLoad);
        }

        function editRule(payLoad) {
            return $http.put(lockoutRulesApiUrl + payLoad.Id, payLoad);
        }

        function deleteRule(Id) {
            return $http.delete(lockoutRulesApiUrl + Id);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('localisationApi', localisationApi);

    function localisationApi(
        $q,
        $http,
        localisationApiUrl,
        tenantSettings
    ) {
        return {
            getFieldSettings: getFieldSettings,
        };

        function getFieldSettings() {

            var deferred = $q.defer();
            var urlPath = localisationApiUrl + `field-settings/${tenantSettings.countryCode}`;

            $http.get(urlPath, {
                    cache: true
                })
                .then(function(resp) {
                    deferred.resolve(resp.data);
                });

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('jobsWhiteboardApi2', jobsWhiteboardApi2);

    /** @ngInject */
    function jobsWhiteboardApi2(
        $q,
        $http,
        tenantSettings,
        dataCacheService,
        $timeout,
        _
    ) {
        var cacheObj = dataCacheService.getInstance('whiteboardCacheApi');
        var whiteboardApiUrl = tenantSettings.coreApiUrl + 'api/whiteboard';
        var paperworkApiUrl = tenantSettings.coreApiUrl + 'api/v1/paperwork';

        var apiService = {
            getTicketsPerWeek: getTicketsPerWeek,
            getTicketsPerWeekGroupByClient: getTicketsPerWeekGroupByClient,
            getTicketsPerDay: getTicketsPerDay,
            getTicketsPerDayGroupByClient: getTicketsPerDayGroupByClient,
            getTicketsPerMonth: getTicketsPerMonth,
            getStatusList: getStatusList,
            getTicketPerIds: getTicketPerIds,
            getTicketDetailsGroupedByClientId: getTicketDetailsGroupedByClientId,
            getSingleTicketInformation: getSingleTicketInformation,
            getStatusInfo: getStatusInfo,
            getStatusInfoByArray: getStatusInfoByArray,
            downloadTicketPdf: downloadTicketPdf,
            downloadPaperworkPdf: downloadPaperworkPdf,
            downloadTimesheetPdf: downloadTimesheetPdf
        };

        activate();

        return apiService;

        function activate() {
            getStatusList();
        }

        function getTicketsPerWeek(start, end, filter, pageSize, pageToken, pageNo, wboardType, timeOfDay) {
            let param = {
                StartDate: start,
                EndDate: end,
                BranchFilters: _.map(filter.selectedBranches, 'id'),
                StateFilters: filter.selectedStates,
                TagIdsToFilter: _.map(filter.selectedTags, 'Id'),
                TagIdsToExclude: _.map(filter.excludedTags, 'Id'),
                PageSize: pageSize,
                PageToken: pageToken,
                PageNo: pageNo,
                WhiteboardType: wboardType,
                WhiteboardTimeOfShift: timeOfDay
            };

            return $http.post(whiteboardApiUrl + '/week', param, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function getTicketsPerWeekGroupByClient(start, end, filter, pageSize, pageToken, pageNo, wboardType, timeOfDay) {
            let param = {
                StartDate: start,
                EndDate: end,
                BranchFilters: _.map(filter.selectedBranches, 'id'),
                StateFilters: filter.selectedStates,
                TagIdsToFilter: _.map(filter.selectedTags, 'Id'),
                TagIdsToExclude: _.map(filter.excludedTags, 'Id'),
                PageSize: pageSize,
                PageNo: pageNo,
                PageToken: pageToken,
                WhiteboardType: wboardType,
                WhiteboardTimeOfShift: timeOfDay
            };

            return $http.post(whiteboardApiUrl + '/week/byclient', param, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function getTicketsPerDay(start, filter, pageSize, pageToken, pageNo, wboardType, timeOfDay) {
            let param = {
                StartDate: start,
                BranchFilters: _.map(filter.selectedBranches, 'id'),
                StateFilters: filter.selectedStates,
                TagIdsToFilter: _.map(filter.selectedTags, 'Id'),
                TagIdsToExclude: _.map(filter.excludedTags, 'Id'),
                PageSize: pageSize,
                PageNo: pageNo,
                PageToken: pageToken,
                WhiteboardType: wboardType,
                WhiteboardTimeOfShift: timeOfDay
            };

            var serverUrl = whiteboardApiUrl + '/day';
            return $http.post(serverUrl, param, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function getTicketsPerDayGroupByClient(start, filter, pageSize, pageToken, pageNo, wboardType, timeOfDay) {
            let param = {
                StartDate: start,
                BranchFilters: _.map(filter.selectedBranches, 'id'),
                StateFilters: filter.selectedStates,
                TagIdsToFilter: _.map(filter.selectedTags, 'Id'),
                TagIdsToExclude: _.map(filter.excludedTags, 'Id'),
                PageSize: pageSize,
                PageToken: pageToken,
                PageNo: pageNo,
                WhiteboardType: wboardType,
                WhiteboardTimeOfShift: timeOfDay
            };

            return $http.post(whiteboardApiUrl + '/day/byclient', param, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function getStatusList(reQuery) {
            var promiseCache = cacheObj.reQuery(reQuery)
                .load('urn:whiteboard:states', function() {
                    let deferred = $q.defer();
                    // TODO: FIX cacheObject, it can't handle return data from callback function. !!!
                    $timeout(function() {
                        let states = [{
                                "id": 0,
                                "name": "Awaiting Resourcing",
                                "color": "red",
                                "abbrev": "AR",
                                "sortOrder": "1"
                            },
                            {
                                "id": 1,
                                "name": "Completed",
                                "color": "blue",
                                "abbrev": 'C',
                                "sortOrder": '3'
                            },
                            {
                                "id": 2,
                                "name": "Ready to go",
                                "color": "green",
                                "abbrev": 'R',
                                "sortOrder": '4'
                            },
                            {
                                "id": 3,
                                "name": "Awaiting Details",
                                "color": "orange",
                                "abbrev": 'A',
                                "sortOrder": '2'
                            },
                            {
                                "id": 4,
                                "name": "Awaiting Resourcing",
                                "color": "red",
                                "abbrev": 'AR',
                                "sortOrder": '1'
                            },
                            {
                                "id": 7,
                                "name": "Scheduling Copilot is in progress",
                                "color": "light-purple",
                                "abbrev": 'AIP',
                                "sortOrder": '1'
                            },
                            {
                                "id": 8,
                                "name": "Scheduling Copilot is done",
                                "color": "purple",
                                "abbrev": 'AID',
                                "sortOrder": '1'
                            },
                            {
                                "id": 9,
                                "name": "Ready to go and Scheduling Copilot is done",
                                "color": "green",
                                "abbrev": 'AIR',
                                "sortOrder": '1'
                            },
                            {
                                "id": 10,
                                "name": "Job started more than 24 hours ago, all resources rostered & confirmed and Scheduling Copilot is done",
                                "color": "blue",
                                "abbrev": 'AIC',
                                "sortOrder": '1'
                            },
                            {
                                "id": 13,
                                "name": "A request to create the job from the external system is waiting for approval",
                                "color": "yellow",
                                "abbrev": 'CJPA',
                                "sortOrder": '1'
                            }
                        ];

                        deferred.resolve(states);
                    }, 5);

                    return deferred.promise;
                });

            return promiseCache;
        }

        function  getStatusInfo(id) {
            let arr = cacheObj.getCache('urn:whiteboard:states');
            let result = arr ? _.find(arr, function(o) {
                return o.id === parseInt(id);
            }) : {
                id: -1,
                name: 'not set',
                color: 'gray',
                sortOrder: '1'
            };
            if (result === undefined) {
                result = {
                    id: -1,
                    name: 'not set',
                    color: 'gray',
                    sortOrder: '1'
                };
            }
            return result;
        }

        function getStatusInfoByArray(arr) {
            var statusList = [];
            angular.forEach(arr, function(itm) {
                statusList.push(getStatusInfo(itm));
            });
            return statusList;
        }

        function getTicketsPerMonth(start, end, filter, wboardType) {
            let param = {
                StartDate: start,
                EndDate: end,
                BranchFilters: _.map(filter.selectedBranches, 'id'),
                StateFilters: filter.selectedStates,
                TagIdsToFilter: _.map(filter.selectedTags, 'Id'),
                TagIdsToExclude: _.map(filter.excludedTags, 'Id'),
                GroupByClient: filter.isGroupByClient,
                WhiteboardType: wboardType
            };

            return $http.post(whiteboardApiUrl + '/month', param, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function getTicketPerIds(ticketIds) {

            return $http({
                method: 'POST',
                url: whiteboardApiUrl + '/ticketlist',
                data: ticketIds
            });
        }

        function getTicketDetailsGroupedByClientId(companyCode, startDate, filter) {
            let param = {
                CompanyCode: companyCode,
                StartDate: startDate,
                BranchFilters: _.map(filter.selectedBranches, 'id'),
                StateFilters: filter.selectedStates,
                TagIdsToFilter: _.map(filter.selectedTags, 'Id'),
                TagIdsToExclude: _.map(filter.excludedTags, 'Id')
            };

            return $http.post(whiteboardApiUrl + '/info/byclient', param, {
                'Accept': 'application/json, text/javascript'
            });
        }

        /**
         * Replace this with true API
         */
        function getSingleTicketInformation(ticketId) {
            return $http({
                method: 'GET',
                url: whiteboardApiUrl + '/' + ticketId
            });
        }

        function downloadTicketPdf(id, ticketNo, token) {
            var payload = {
                RequestToken: token,
                TicketId: id,
                TicketNumber: ticketNo
            };

            return $http.post(`${tenantSettings.coreApiUrl}api/ticket/${id}/job-docket`, payload);
        }

        function downloadPaperworkPdf(id, ticketNo, token) {
            var payload = {
                RequestToken: token,
                TicketId: id,
                TicketNumber: ticketNo
            };
            return $http.post(paperworkApiUrl + '/download/paperwork', payload);
        }

        function downloadTimesheetPdf(id, ticketNo, token) {
            var payload = {
                RequestToken: token,
                TicketId: id,
                TicketNumber: ticketNo
            };
            return $http.post(paperworkApiUrl + '/download/ticket', payload);
        }
    }
})();

{
    angular.module('app.api')
        .factory('jobsApi', jobsApi);

    /** @ngInject */
    function jobsApi(
        $http,
        tenantSettings
    ) {
        return {
            getBranches: getBranches,
            getContactLookupsByBranch: getContactLookupsByBranch,
            getContactClientByBranchAndCompanyLookup: getContactClientByBranchAndCompanyLookup,
            getProjectByBranchAndCompanyLookup: getProjectByBranchAndCompanyLookup,
            getCompanyLookupsByBranch: getCompanyLookupsByBranch,
            getAssets: getAssets,
            getTicketsByJobId: getTicketsByJobId,
            getTicketByTicketId: getTicketByTicketId,
            getTicketWithCustomFieldsByTicketId: getTicketWithCustomFieldsByTicketId,
            saveJob: saveJob,
            deleteTicket: deleteTicket,
            updateTickets: updateTickets,
            cancelTicket: cancelTicket,
            getLatestJobLocations: getLatestJobLocations,
            getKitsbyBranch: getKitsbyBranch,
            getTicketPDF: getTicketPDF,
            chargeMinHours: chargeMinHours,
            lockUnlockTicket: lockUnlockTicket,
            cloneAllocations: cloneAllocations,
            validateAllocations : validateAllocations,
            validateMultipleTicketAllocations : validateMultipleTicketAllocations,
            cloneMultipleTicketsAllocation: cloneMultipleTicketsAllocation,
            getTicketsForConfirmation: getTicketsForConfirmation,
            sendJobDetails: sendJobDetails,
            getTicketInCostEstimate: getTicketInCostEstimate,
            checkProject: checkProject,
            unlinkDocumentById: unlinkDocumentById,
            composeEmail: composeEmail,
            sendEmail: sendEmail,
            getFormTemplatesByJobId: getFormTemplatesByJobId,
            updateTicketFormTemplates: updateTicketFormTemplates,
            getTagsByJobId: getTagsByJobId,
            updateTicketTags: updateTicketTags
        };

        function checkProject(companyId, ProjectId) {
            return $http({
                method: 'POST',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/project/' + companyId + '/' + ProjectId
            });
        }

        function getContactLookupsByBranch(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/contact/' + id
            });
        }

        function sendJobDetails(ticketId) {
            return $http.get(tenantSettings.coreApiUrl + 'api/messaging/' + ticketId + '/changejobdetails');
        }

        function getContactClientByBranchAndCompanyLookup(company, branch, allowCache) {
            allowCache = allowCache ? true : allowCache;
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/contact?' + 'companyId=' + company + '&' + 'branchId=' + branch,
                cache: allowCache
            });
        }

        function cloneAllocations(pay_load) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/clone', pay_load);
        }

        function validateAllocations(pay_load) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/validate-allocations', pay_load);
        }

        function validateMultipleTicketAllocations(pay_load) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/multiple-ticket-validate-allocations', pay_load);
        }

        function getBranches() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/branches'
            });
        }

        function getCompanyLookupsByBranch(payload) {
            return $http.post(tenantSettings.coreApiUrl + 'api/jobs/lookup/companies/', payload, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function getProjectByBranchAndCompanyLookup(branchId, companyId) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/project?branchId=' + branchId + '&companyId=' + companyId
            });
        }

        function getAssets(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/items/' + id
            });
        }

        function getKitsbyBranch(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/kititems/' + id
            });
        }

        function getTicketsByJobId(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/tickets/job/' + id
            });
        }

        function getTicketByTicketId(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/tickets/' + id
            });
        }

        function getTicketsForConfirmation(ids) {
            return $http.post(tenantSettings.coreApiUrl + 'api/tickets/confirmationList', ids);
        }

        function getTicketWithCustomFieldsByTicketId(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/tickets/customfield/modulepage?id=' + id
            });
        }

        function getTicketInCostEstimate(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/tickets/costestimate/customfield/modulepage?id=' + id
            });
        }

        function saveJob(payload) {
            return $http.post(tenantSettings.coreApiUrl + 'api/jobs/tickets', payload, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function deleteTicket(id) {
            return $http.delete(tenantSettings.coreApiUrl + 'api/tickets/' + id, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function updateTickets(data) {
            return $http.put(tenantSettings.coreApiUrl + 'api/tickets/' + data.id + (data.UnlinkTicket ? "?unlinkRelatedTicket=true" : ""), data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function cancelTicket(ticketId, reason, chargeMinHours) {
            let payLoad = {
                CancelReason: reason,
                HasMinimumHourCharge: chargeMinHours
            };
            return $http.put(tenantSettings.coreApiUrl + 'api/tickets/' + ticketId + '/cancelJob', payLoad);
        }

        function getLatestJobLocations(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/joblocations/' + id
            });
        }

        function getTicketPDF(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/ticket/pdf/' + id,
                responseType: 'arraybuffer'
            });
        }

        function chargeMinHours(id, isChargeMinHours) {
            let payLoad = JSON.stringify(isChargeMinHours)
            return $http.put(tenantSettings.coreApiUrl + 'api/tickets/' + id + '/minimumHourCharge', payLoad, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function lockUnlockTicket(id, isLocked) {
            return $http.post(tenantSettings.coreApiUrl + 'api/tickets/' + id + '?confirm=' + !isLocked);
        }

        function unlinkDocumentById(ticketId, documentId) {
            return $http.post(tenantSettings.coreApiUrl + 'api/jobs/' + ticketId + '/excluded-documents', JSON.stringify(documentId));
        }

        function composeEmail(ticketIds) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/composeEmail',
                params: {
                    ticketIds: ticketIds
                }
            });
        }

        function sendEmail(emailTemplateModel, ticketIds) {
            return $http({
                method: 'POST',
                url: tenantSettings.coreApiUrl + 'api/jobs/sendEmail',
                params: {
                    ticketIds: ticketIds
                },
                data: emailTemplateModel
            });
        }

        function getFormTemplatesByJobId(id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/tickets/' + id + '/form-templates');
        }

        function getTagsByJobId(id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/tickets/' + id + '/tags');
        }

        function updateTicketFormTemplates(
            ticketId,
            ticketLinkedFormTemplates,
            ticketUnlinkedFormTemplates,
            ticketOverriddenFormTemplates
        ) {
            let payLoad = {
                LinkedFormTemplates: ticketLinkedFormTemplates,
                UnlinkedFormTemplates: ticketUnlinkedFormTemplates,
                OverriddenFormTemplates: ticketOverriddenFormTemplates
            };
            return $http.put(`${tenantSettings.coreApiUrl}api/tickets/${ticketId}/form-templates`, payLoad);
        }

        function updateTicketTags(ticketId, tags) {
            return $http.put(`${tenantSettings.coreApiUrl}api/tickets/${ticketId}/tags`, tags);
        }

        function cloneMultipleTicketsAllocation(payload){
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/clone-multiple-tickets', payload);
        }
    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('jobMessagingApi', jobMessagingApi);

    /** @ngInject */
    function jobMessagingApi(
        $http,
        tenantSettings
    ) {
        var invoiceDistributionApiUrl = tenantSettings.coreApiUrl + 'api/InvoiceDistribution';
        var companiesApiUrl = tenantSettings.coreApiUrl + 'api/companies';
        var jobMessagingApiUrl = tenantSettings.coreApiUrl + 'api/jobmessaging';
        var allocationsApiUrl = tenantSettings.coreApiUrl + 'api/allocations';
        var messagingApiUrl = tenantSettings.coreApiUrl + 'api/messaging';

        var service = {
            getEmailTypes: getEmailTypes,
            addRecipient: addRecipient,
            removeRecipient: removeRecipient,
            getDefaultRecipients: getDefaultRecipients,
            addBatchRecipient: addBatchRecipient,
            download: download,
            tryFixInvoiceEmailIssues: tryFixInvoiceEmailIssues,
            sendMail: sendMail,
            getRecipientLogs: getRecipientLogs,
            getOverallStatus: getOverallStatus,
            getMessagingViewData: getMessagingViewData,
            sendJobMessages: sendJobMessages,
            acceptRejectJob: acceptRejectJob,
            getMessageLogs: getMessageLogs,
            resendNotification: resendNotification,
            acceptShifts: acceptShifts
        };

        return service;

        function getEmailTypes() {
            return $http({
                method: 'GET',
                url: companiesApiUrl + '/email/types',
                cache: true
            });
        }

        function addRecipient(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/AddRecipient',
                data: data
            });
        }

        function removeRecipient(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/RemoveRecipient',
                data: data
            });
        }

        function getDefaultRecipients(companyId) {
            return $http({
                method: 'GET',
                url: invoiceDistributionApiUrl + '/DefaultRecipients/' + companyId,
                cache: true
            });
        }

        function addBatchRecipient(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/DefaultRecipients/batch',
                data: data
            });
        }

        function download(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/download',
                data: data
            });
        }

        function tryFixInvoiceEmailIssues(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/FixInvoiceEmail',
                data: data
            });
        }

        function sendMail(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/SendEmail',
                data: data
            });
        }

        function getRecipientLogs(id) {
            return $http({
                method: 'GET',
                url: invoiceDistributionApiUrl + '/Recipient/Logs/' + id,
                cache: false
            });
        }

        function getOverallStatus(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/Invoice/OverallStatus',
                data: data
            });
        }

        function getMessagingViewData(data) {
            return $http({
                method: 'POST',
                url: jobMessagingApiUrl + '/list',
                data: data
            });
        }

        function sendJobMessages(payload) {
            return $http.post(jobMessagingApiUrl + '/messaging/send', payload);
        }

        function acceptRejectJob(id, payload) {
            return $http.post(allocationsApiUrl + '/' + id + '/confirmation', payload);
        }

        function acceptShifts(payload){
            return $http.post(allocationsApiUrl + '/accept-shifts', payload);
        }

        function getMessageLogs(payload) {
            return $http.get(jobMessagingApiUrl + '/' + payload.cId + '/' + payload.id + '/logs');
        }

        function resendNotification(ariId, cId, smsOnly) {
            return $http.post(messagingApiUrl + '/' + cId + '/' + ariId + '/resend?smsOnly=' + smsOnly);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('invoiceSettingsApi', invoiceSettingsApi);

    function invoiceSettingsApi(
        $http,
        tenantSettings
    ) {
        var invoiceSettingsApiUrl = tenantSettings.coreApiUrl + 'api/v1/invoiceSettings';

        return {
            getAll: getAll,
            getExportFields: getExportFields,
            getFileExtension: getFileExtension,
            updateInvoiceSettingsExportFileExtension: updateInvoiceSettingsExportFileExtension,
            updateInvoiceSettingsExportFileHeading: updateInvoiceSettingsExportFileHeading,
            updateInvoiceSettingsExportFormat: updateInvoiceSettingsExportFormat
        };

        function getAll() {
            return $http.get(invoiceSettingsApiUrl);
        }

        function getExportFields() {
            return $http.get(invoiceSettingsApiUrl + '/exportfields');
        }

        function getFileExtension() {
            return $http.get(invoiceSettingsApiUrl + "/exportFileExtension");
        }

        function updateInvoiceSettingsExportFileExtension(params) {
            return $http.put(invoiceSettingsApiUrl + '/exportFileExtension', '"' + params.fileExtension + '"');
        }

        function updateInvoiceSettingsExportFileHeading(params) {
            return $http.put(invoiceSettingsApiUrl + '/exportHeader', '"' + params.fileHeading + '"');
        }

        function updateInvoiceSettingsExportFormat(params) {
            return $http.put(invoiceSettingsApiUrl + '/exportFormat', params);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('invoiceDistributionApi', invoiceDistributionApi);

    /** @ngInject */
    function invoiceDistributionApi(
        $http,
        tenantSettings,
    ) {
        var invoiceDistributionApiUrl = tenantSettings.coreApiUrl + 'api/InvoiceDistribution';
        var companiesApiUrl = tenantSettings.coreApiUrl + 'api/companies';

        var service = {
            getEmailTypes: getEmailTypes,
            addRecipient: addRecipient,
            removeRecipient: removeRecipient,
            getDefaultRecipients: getDefaultRecipients,
            addBatchRecipient: addBatchRecipient,
            download: download,
            tryFixInvoiceEmailIssues: tryFixInvoiceEmailIssues,
            sendMail: sendMail,
            getRecipientLogs: getRecipientLogs,
            getOverallStatus: getOverallStatus
        };

        return service;

        function getEmailTypes() {
            return $http({
                method: 'GET',
                url: companiesApiUrl + '/email/types',
                cache: true
            });
        }

        function addRecipient(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/AddRecipient',
                data: data
            });
        }

        function removeRecipient(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/RemoveRecipient',
                data: data
            });
        }

        function getDefaultRecipients(companyId) {
            return $http({
                method: 'GET',
                url: invoiceDistributionApiUrl + '/DefaultRecipients/' + companyId,
                cache: true
            });
        }

        function addBatchRecipient(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/DefaultRecipients/batch',
                data: data
            });
        }

        function download(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/download',
                data: data
            });
        }

        function tryFixInvoiceEmailIssues(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/FixInvoiceEmail',
                data: data
            });
        }

        function sendMail(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/SendEmail',
                data: data
            });
        }

        function getRecipientLogs(id) {
            return $http({
                method: 'GET',
                url: invoiceDistributionApiUrl + '/Recipient/Logs/' + id,
                cache: false
            });
        }

        function getOverallStatus(data) {
            return $http({
                method: 'POST',
                url: invoiceDistributionApiUrl + '/Invoice/OverallStatus',
                data: data
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('invoiceApi', invoiceApi);

    /** @ngInject */
    function invoiceApi(
        $http,
        tenantSettings
    ) {
        var jobsApiUrl = tenantSettings.coreApiUrl + 'api/jobs';
        var invoiceApiUrl = tenantSettings.coreApiUrl + 'api/invoice';

        var service = {
            getClients: getClients,
            addLineItem: addLineItem,
            finalise: finalise,
            markAsReviewed: markAsReviewed,
            downloadInvoice: downloadInvoice,
            getPdfUrl: getPdfUrl,
            removeInvoice: removeInvoice,
            getItemCodes: getItemCodes,
            exportInvoice: exportInvoice,
            exportInvoiceToProvider: exportInvoiceToProvider,
            exportInvoicePaperworkToProvider: exportInvoicePaperworkToProvider,
            deleteInvoicePreview: deleteInvoicePreview,
            saveManualInvoice: saveManualInvoice,
            credit: credit,
            deleteInvoiceAndUnlockTicketAndTimesheet: deleteInvoiceAndUnlockTicketAndTimesheet,
            updatePurchaseOrderNumber: updatePurchaseOrderNumber,
            getRateCardItems: getRateCardItems,
            downloadReportLink: downloadReportLink,
            getTaxRoundingRules: getTaxRoundingRules,
            getExportViewList: getExportViewList
        };

        return service;

        function getClients(company, branch) {
            return $http({
                method: 'POST',
                url: jobsApiUrl + '/lookup/companies',
                data: {
                    BranchId: null,
                    DivisionId: null
                },
                cache: true
            });
        }

        function addLineItem(id, data) {
            return $http.put(invoiceApiUrl + '/lineitem/' + id, data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function finalise(ids) {
            return $http.put(invoiceApiUrl + '/finalize', ids, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function markAsReviewed(id, isReviewed) {
            return $http.put(invoiceApiUrl + '/reviewed/' + id + '/' + isReviewed);
        }

        function downloadInvoice(invoiceId) {
            return $http.get(invoiceApiUrl + '/' + invoiceId + '/pdf?isPreview=true', {
                responseType: 'arraybuffer'
            });
        }

        function getPdfUrl(id) {
            return $http({
                method: 'GET',
                url: invoiceApiUrl + '/pdf/' + id
            });
        }

        function removeInvoice(id) {
            return $http({
                method: 'DELETE',
                url: invoiceApiUrl + '/remove/' + id
            });
        }

        function getItemCodes() {
            return $http({
                method: 'GET',
                url: invoiceApiUrl + '/lookup/itemcodes',
                cache: true
            });
        }

        function exportInvoice(invoiceStartDate, invoiceEndDate, branches, companyIds, includeNotExportedOnly) {
            return $http({
                method: 'POST',
                url: invoiceApiUrl + '/export',
                data: {
                    InvoiceStartDate: invoiceStartDate,
                    InvoiceEndDate: invoiceEndDate,
                    Branches: branches,
                    CompanyIds: companyIds,
                    IncludeNotExportedOnly: includeNotExportedOnly
                }
            });
        }

        function exportInvoiceToProvider(invoiceNumber, providerType) {
            return $http({
                method: 'POST',
                url: invoiceApiUrl + `/export/${invoiceNumber}`,
                data: `'${providerType}'`,
                timeout: 180000
            });
        }

        function exportInvoicePaperworkToProvider(invoiceNumber, providerType) {
            return $http.post(invoiceApiUrl + `/export-paperwork/${invoiceNumber}`, `'${providerType}'`);
        }

        function deleteInvoicePreview(invoiceList) {
            return $http({
                method: 'POST',
                url: invoiceApiUrl + '/delete',
                data: invoiceList
            });
        }

        function saveManualInvoice(payload) {
            return $http({
                method: 'POST',
                url: invoiceApiUrl + '/manual/create',
                data: payload
            });
        }

        function credit(payload) {
            return $http({
                method: 'POST',
                url: invoiceApiUrl + '/credit',
                data: payload
            });
        }

        function deleteInvoiceAndUnlockTicketAndTimesheet(id, deleteFinalized) {
            return $http({
                method: 'DELETE',
                url: invoiceApiUrl + `/unlockandremove/${id}${(deleteFinalized ? "?deleteFinalized=true" : "")}`
            });
        }

        function updatePurchaseOrderNumber(id, purchaseOrderNum) {
            return $http({
                method: 'POST',
                url: invoiceApiUrl + '/purchaseOrder/update',
                data: {
                    invoiceId: id,
                    purchaseOrderNumber: purchaseOrderNum
                }
            });
        }

        function downloadReportLink(id, isPreview, includePaperwork) {
            var url = invoiceApiUrl + '/report/download/' + id;
            var params = {};
            if (isPreview) {
                params.isPreview = isPreview;
            }
            if (includePaperwork) {
                params.includePaperwork = includePaperwork;
            }
            return $http.get(url, { params: params });
        }

        function getRateCardItems(clientId) {

            return $http({
                method: 'GET',
                url: invoiceApiUrl + '/lookup/companyratecarditems/' + clientId
            });
        }

        function getTaxRoundingRules() {
            return $http.get(invoiceApiUrl + '/tax-rounding-rules');
        }

        function getExportViewList(payload) {
            return $http({
                method: 'POST',
                url: invoiceApiUrl + `/get-export-view-list`,
                data: payload
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('integrationsApi', integrationsApi);

    function integrationsApi(
        $http,
        tenantSettings,
        auditApi
    ) {
        var integrationsApiUrl = `${tenantSettings.coreApiUrl}api/integrations`;

        const INTEGRATIONS_HISTORY_GUID = '5e41856d-dbd0-42a0-af74-5f9e99a2723f';

        return {
            getOAuth2Url: getOAuth2Url,
            getProviders: getProviders,
            disconnect: disconnect,
            getIntegrationsHistoryLogs: getIntegrationsHistoryLogs,
            getTenants: getTenants,
            getTenantsByProvider: getTenantsByProvider,
            getEmployees: getEmployees,
            getEmployeesByProvider: getEmployeesByProvider,
            getCompaniesByProviderAndTenant: getCompaniesByProviderAndTenant,
            getJobsByProvider: getJobsByProvider,
            providerTypes: {
                myob: 'MYOB',
                xero: 'Xero'
            }
        };

        function getOAuth2Url(relativeReturnUrl, providerType) {
            return $http.get(`${integrationsApiUrl}/${providerType}/auth-url?relativeReturnUrl=${relativeReturnUrl}`);
        }

        function getProviders() {
            return $http.get(`${integrationsApiUrl}`);
        }

        function disconnect(providerType) {
            return $http.post(`${integrationsApiUrl}/${providerType}/disconnect`);
        }

        function getIntegrationsHistoryLogs() {
            return auditApi.getAuditEntries(INTEGRATIONS_HISTORY_GUID);
        }

        function getTenants() {
            return $http.get(`${integrationsApiUrl}/tenants`);
        }

        function getTenantsByProvider(providerType) {
            return $http.get(`${integrationsApiUrl}/${providerType}/tenants`);
        }

        function getEmployees() {
            return $http.get(`${integrationsApiUrl}/employees?countryCode=${tenantSettings.countryCode}`);
        }

        function getEmployeesByProvider(providerType) {
            return $http.get(`${integrationsApiUrl}/${providerType}/employees?countryCode=${tenantSettings.countryCode}`);
        }

        function getCompaniesByProviderAndTenant(providerType, tenantId) {
            return $http.get(`${integrationsApiUrl}/${providerType}/companies?tenantId=${tenantId}`);
        }

        function getJobsByProvider(providerType, tenantId) {
            return $http.get(`${integrationsApiUrl}/${providerType}/jobs?tenantId=${tenantId}`);
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.api')
        .factory('generalSettingsApi', generalSettingsApi);

    /** @ngInject */
    function generalSettingsApi(
        $http,
        tenantSettings
    ) {
        var generalSettingsApiUrl = tenantSettings.coreApiUrl + 'api/general-settings';

        var service = {
            getCompanyCodeFormats: getCompanyCodeFormats,
            getPayrollCsvExportFormats: getPayrollCsvExportFormats,
            getBillingCsvExportFormats: getBillingCsvExportFormats,
            refreshCachedTenantIdentity: refreshCachedTenantIdentity
        };

        return service;

        function getCompanyCodeFormats() {
            return $http.get(generalSettingsApiUrl + '/company-code-formats');
        }

        function getPayrollCsvExportFormats() {
            return $http.get(generalSettingsApiUrl + '/payroll-csv-formats');
        }

        function getBillingCsvExportFormats() {
            return $http.get(generalSettingsApiUrl + '/billing-csv-formats');
        }

        function refreshCachedTenantIdentity() {
            return $http.post(generalSettingsApiUrl + '/refresh-cached-tenant-identity');
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('externalApi', externalApi);

    function externalApi(
        $http,
        tenantSettings,
        auditApi
    ) {
        var externalApiUrl = tenantSettings.coreApiUrl + 'api/external';

        return {
            approveOrRejectTicket: approveOrRejectTicket
        };

        function approveOrRejectTicket(ticketId, data) {
            return $http({
                method: 'PATCH',
                url: externalApiUrl + '/jobs/' + ticketId + '/approve',
                data: data
            });
        }
    }
})();
(function() {
    "use strict";

    angular.module("app.api").factory("documentsApi", documentsApi);

    function documentsApi(
        $http,
        tenantSettings
    ) {
        let self = this;
        let documentsApi = tenantSettings.coreApiUrl + "api/documents";

        self.request = {};

        self.request.getModuleList = function() {
            return $http.get(documentsApi + "/modules/list");
        };

        self.request.getAllowedDocumentContentTypes = function() {
            return $http.get(documentsApi + "/allowedcontenttypes");
        };

        self.request.getAllDocumentsForResource = function(moduleId, resourceId) {
            return $http.get(documentsApi + "/list?moduleId=" + moduleId + "&relatedResourceId=" + resourceId);
        };

        self.request.removeDocumentById = function(documentId) {
            return $http.delete(documentsApi + "/" + documentId);
        };

        self.request.putDocument = function(documentId, documentName, attachmentTypeId) {
            return $http.put(documentsApi + "/" + documentId, {
                NewDocumentName: documentName,
                AttachmentTypeId: attachmentTypeId || null
            });
        };

        self.request.updateIncludePaperworkFlag = function(documentId, relatedResourceId, includeInPaperwork, isInheritedDocument) {
            return $http.put(documentsApi + "/" + documentId + "/include-paperwork?relatedResourceId=" + relatedResourceId + "&includeInPaperwork=" + includeInPaperwork + "&isInheritedDocument=" + isInheritedDocument);
        }

        return self.request;
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('dashboardApi', dashboardApi);

    function dashboardApi(
        $http,
        tenantSettings
    ) {
        var dashboardLookupApi = tenantSettings.coreApiUrl + 'api/lookup/all/widget/';
        var dashboardWidgetsApi = tenantSettings.coreApiUrl + 'api/widgets/';
        var dashboardOperationApi = tenantSettings.coreApiUrl + 'api/dashboard/admin/widget/';
        var dashboardDataApi = tenantSettings.coreApiUrl + 'api/dashboard/widget/refresh';

        return {
            getWidgetTypes: getWidgetTypes,
            getWidgetDatasets: getWidgetDatasets,
            add: add,
            getWidgets: getWidgets,
            edit: edit,
            deleteWidget: deleteWidget,
            getWidgetData: getWidgetData,
            getStaticWidgets: getStaticWidgets
        };

        function getWidgetTypes() {
            return $http.get(dashboardLookupApi + 'types');
        }

        function getWidgetDatasets() {
            return $http.get(dashboardLookupApi + 'datasets');
        }

        function getWidgets() {
            return $http.get(dashboardOperationApi);
        }

        function getStaticWidgets(branches) {
            return $http.post(dashboardWidgetsApi, branches);
        }

        function add(payLoad) {
            return $http.post(dashboardOperationApi, payLoad);
        }

        function edit(payLoad, Id) {
            return $http.put(dashboardOperationApi + Id, payLoad);
        }

        function deleteWidget(Id) {
            return $http.delete(dashboardOperationApi + Id);
        }

        function getWidgetData(params) {
            return $http.post(dashboardDataApi, params);
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('customFormsApi', customFormsApi);

    function customFormsApi($http,
        customFormsApiUrl,
        claimsUtilService) {

        var tenantKey = claimsUtilService.getTenantKey();

        return {
            getFormTemplates: getFormTemplates,
            getFormTemplate: getFormTemplate,
            getLatestFormTemplate: getLatestFormTemplate,
            createFormTemplate: createFormTemplate,
            updateFormTemplate: updateFormTemplate,
            publishFormTemplate: publishFormTemplate,
            deleteFormTemplate: deleteFormTemplate,
            cloneFormTemplate: cloneFormTemplate,
            updateFormSections: updateFormSections,
            deleteForm: deleteForm,
            generateFormTemplatePdf: generateFormTemplatePdf,
            downloadFormTemplatePdfInBase64: downloadFormTemplatePdfInBase64,
            moveToPosition: moveToPosition
        };

        function getFormTemplates(page, resultLimit, sortByField, sortByType) {
            return $http({
                method: 'GET',
                url: customFormsApiUrl + 'api/form-templates',
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('X-TenantKey', tenantKey);
                    xhr.setRequestHeader('X-Version', '2.0');
                    xhr.setRequestHeader('X-PageNumber', page);
                    xhr.setRequestHeader('X-ResultLimit', resultLimit);
                    xhr.setRequestHeader('X-SortByField', sortByField);
                    xhr.setRequestHeader('X-SortByType', sortByType);
                }
            });
        }

        function getFormTemplate(id) {
            return $http({
                method: 'GET',
                url: customFormsApiUrl + `api/form-templates/${id}`,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function getLatestFormTemplate(id) {
            return $http({
                method: 'GET',
                url: customFormsApiUrl + `api/form-templates/${id}/latest`,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function createFormTemplate(data) {
            return $http({
                method: 'POST',
                url: customFormsApiUrl + 'api/form-templates',
                data: data,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function updateFormTemplate(id, data) {
            return $http({
                method: 'PUT',
                url: customFormsApiUrl + `api/form-templates/${id}`,
                data: data,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function cloneFormTemplate(id, data) {
            return $http({
                method: 'POST',
                url: customFormsApiUrl + `api/form-templates/${id}/clone`,
                data: data,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function publishFormTemplate(id) {
            return $http({
                method: 'POST',
                url: customFormsApiUrl + `api/form-templates/${id}/publish`,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function deleteFormTemplate(id) {
            return $http({
                method: 'DELETE',
                url: customFormsApiUrl + `api/form-templates/${id}`,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function updateFormSections(data) {
            return $http({
                method: 'PUT',
                url: customFormsApiUrl + `api/form-templates/${data.formTemplateId}/sections`,
                data: data,
                headers: {
                    'X-TenantKey': tenantKey,
                    'X-Version': '1.1'
                }
            });
        }

        function deleteForm(id) {
            return $http({
                method: 'DELETE',
                url: customFormsApiUrl + `api/forms/${id}`,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function generateFormTemplatePdf(id, data, tenantKey) {
            return $http({
                method: 'POST',
                url: customFormsApiUrl + `api/form-templates/${id}/preview`,
                data: data,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function downloadFormTemplatePdfInBase64(id) {
            return $http({
                method: 'GET',
                url: customFormsApiUrl + `api/form-templates/${id}/preview/base64`,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }

        function moveToPosition(id, positionToMove) {
            return $http({
                method: 'POST',
                url: customFormsApiUrl + `api/form-templates/${id}/move-form-order/${positionToMove}`,
                headers: {
                    'X-TenantKey': tenantKey
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.api')
        .factory('customFieldsApi', customFieldsApi);

    function customFieldsApi(
        $http,
        tenantSettings
    ) {
        var customFieldsApiUrl = tenantSettings.coreApiUrl + 'api/CustomField';

        return {
            getCustomFields: getCustomFields,
            saveCustomFields: saveCustomFields,
            deleteField: deleteField,
            getField: getField,
            editCustomField: editCustomField
        };

        function getCustomFields() {
            return $http.get(customFieldsApiUrl);
        }

        function saveCustomFields(data) {
            return $http.post(customFieldsApiUrl, data);
        }

        function deleteField(id) {
            return $http.delete(customFieldsApiUrl + "/" + id);
        }

        function getField(id) {
            return $http.get(customFieldsApiUrl + "/" + id);
        }

        function editCustomField(data, id) {
            return $http.put(customFieldsApiUrl + "/" + id, data);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('costEstimateApi', costEstimateApi);

    /** @ngInject */
    function costEstimateApi(
        $http,
        tenantSettings,
    ) {
        var jobsApiUrl = tenantSettings.coreApiUrl + 'api/jobs';
        var costEstimateApiUrl = tenantSettings.coreApiUrl + 'api/costEstimate';
        var invoiceApiUrl = tenantSettings.coreApiUrl + 'api/invoice';

        var service = {
            getClients: getClients,
            addLineItem: addLineItem,
            finalise: finalise,
            generateCostEstimatePdf: generateCostEstimatePdf,
            getPdfUrl: getPdfUrl,
            removeInvoice: removeInvoice,
            getItemCodes: getItemCodes,
            exportInvoice: exportInvoice,
            saveManualInvoice: saveManualInvoice,
            credit: credit,
            creditReinvoice: creditReinvoice,
            deleteInvoiceAndUnlockTicketAndTimesheet: deleteInvoiceAndUnlockTicketAndTimesheet,
            updatePurchaseOrderNumber: updatePurchaseOrderNumber,
            getRateCardItems: getRateCardItems,
            generateCostEstimatePdfByGroupId: generateCostEstimatePdfByGroupId,
            getRateCards: getRateCards,
            getCostEstimates: getCostEstimates,
            regenerate: regenerate,
            getGroupDetail: getGroupDetail,
            setPrimary: setPrimary,
            cancel: cancelCostEstimate,
            cancelCostEstimateGroup: cancelCostEstimateGroup,
            getCostEstimateGroups: getCostEstimateGroups,
            getCostEstimateTicketForBooking: getCostEstimateTicketForBooking,
            getLostStates: getLostStates,
            getWinningCompanies: getWinningCompanies,
            getWinningCompetitors: getWinningCompetitors,
            markAsLost: markAsLost,
            toggleReview: toggleReview,
            getCostEstimate: getCostEstimate
        };

        return service;

        function getCostEstimate(costEstimateNumber) {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/' + costEstimateNumber
            });
        }

        function getClients(company, branch) {
            return $http({
                method: 'POST',
                url: jobsApiUrl + '/lookup/companies',
                data: {
                    BranchId: null,
                    DivisionId: null
                },
                cache: true
            });
        }

        function addLineItem(id, data) {
            let payload = {
                LineItemId: id,
                LineItems: data
            };
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/createViaLineItem/',
                data: payload
            });
        }

        function finalise(id) {
            return $http.put(costEstimateApiUrl + '/finalize/' + id, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function generateCostEstimatePdf(id) {
            return $http.get(costEstimateApiUrl + '/report/' + id + '/pdf');
        }

        function generateCostEstimatePdfByGroupId(groupId) {
            return $http.get(costEstimateApiUrl + '/report/group/' + groupId + '/pdf');
        }

        function getPdfUrl(id) {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/pdf/' + id
            });
        }

        function removeInvoice(id) {
            return $http({
                method: 'DELETE',
                url: costEstimateApiUrl + '/remove/' + id
            });
        }

        function getItemCodes() {
            //let data = { data: [{ Id: 1, ItemCode: 'Sample item 1' }, { Id: 2, ItemCode: 'Sample Item 2' }] };
            //return $q.when(data);
            return $http({
                method: 'GET',
                url: invoiceApiUrl + '/lookup/itemcodes',
                cache: true
            });
        }

        function exportInvoice(invoiceStartDate, invoiceEndDate, branches, companyIds, includeNotExportedOnly) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/export/csv',
                data: {
                    InvoiceStartDate: invoiceStartDate,
                    InvoiceEndDate: invoiceEndDate,
                    Branches: branches,
                    CompanyIds: companyIds,
                    IncludeNotExportedOnly: includeNotExportedOnly
                }
            });
        }

        function saveManualInvoice(payload) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/manual/create',
                data: payload
            });
        }

        function credit(payload) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/credit/reinvoice',
                data: payload
            });
        }

        function creditReinvoice(payload) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/credit/creditreinvoice',
                data: payload
            });
        }

        function deleteInvoiceAndUnlockTicketAndTimesheet(id) {
            return $http({
                method: 'DELETE',
                url: costEstimateApiUrl + '/unlockandremove/' + id
            });
        }

        function updatePurchaseOrderNumber(id, purchaseOrderNum) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/purchaseOrder/update',
                data: {
                    invoiceId: id,
                    purchaseOrderNumber: purchaseOrderNum
                }
            });
        }

        /**
         * Rate card items should based on client selected
         */
        function getRateCardItems(clientId) {
            return $http({
                method: 'GET',
                url: invoiceApiUrl + '/lookup/companyratecarditems/' + clientId
            });
        }

        function getRateCards() {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/getrates/'
            });
        }

        function getCostEstimates(groupId, showCancelled) {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/' + groupId + '/showcancelled/' + showCancelled
            });
        }

        function regenerate(groupId, rateCardId) {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/regenerate/' + groupId + '/rateid/' + rateCardId
            });
        }

        function getGroupDetail(groupId) {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/groupdetail/' + groupId
            });
        }

        function setPrimary(id) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/setPrimary/' + id
            });
        }

        function cancelCostEstimate(id) {
            return $http({
                method: 'DELETE',
                url: costEstimateApiUrl + '/cancel/' + id
            });
        }

        function getCostEstimateGroups(payload) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/groups/',
                data: payload
            });
        }

        function cancelCostEstimateGroup(groupId) {
            return $http({
                method: 'DELETE',
                url: costEstimateApiUrl + '/cancel/group/' + groupId
            });
        }

        function getCostEstimateTicketForBooking(groupId) {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/booking/ticket/' + groupId
            });
        }

        function getLostStates() {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/lookup/loststates'
            });
        }

        function getWinningCompanies(branchId) {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/lookup/winningcompanies/' + branchId
            });
        }

        function getWinningCompetitors(branchId) {
            return $http({
                method: 'GET',
                url: costEstimateApiUrl + '/lookup/winningcompetitors/' + branchId
            });
        }

        function markAsLost(payload) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/markaslost',
                data: payload
            });
        }

        function toggleReview(costEstimateId) {
            return $http({
                method: 'POST',
                url: costEstimateApiUrl + '/review/toggle/' + costEstimateId
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('contactApi', contactApi);

    function contactApi(
        $http,
        tenantSettings,
        auditApi
    ) {
        var contactsApiUrl = tenantSettings.coreApiUrl + 'api/contacts';
        var contactApiUrl = tenantSettings.coreApiUrl + 'api/contact'

        return {
            postContact: postContact,
            postContactMinify: postContactMinify,
            getContact: getContact,
            putContact: putContact,
            postArchive: postArchive,
            filterContact: filterContact,
            validateEmployeeCode: validateEmployeeCode,
            getAll: getAll,
            getActiveEmployees: getActiveEmployees,
            getAllEmployeesByBranchIds: getAllEmployeesByBranchIds,
            getContactBundled: getContactBundled,
            getContactEmpty: getContactEmpty,
            getUsersPerBranch: getUsersPerBranch,
            deleteFile: deleteFile,
            getDefaultEmployer: getDefaultEmployer,
            getMinifiedContactDetails: getMinifiedContactDetails,
            getContactHistory: getContactHistory,
            getEntryType: getEntryType,
            getRepeatType: getRepeatType,
            getContactCalendarById: getContactCalendarById,
            saveContactCalendar: saveContactCalendar,
            updateContactCalendar: updateContactCalendar,
            deleteContactCalendar: deleteContactCalendar,
            getBranches: getBranches,
            getEmployeesByBranchOrDivision: getEmployeesByBranchOrDivision,
            validateDuplicateContact: validateDuplicateContact,
            getAllCached: getAllCached,
            getRules: getRules,
            deleteUser: deleteUser,
            updateTimesheets: updateTimesheets,
            getXeroContacts: getXeroContacts,
            updateContactProviderEmployees: updateContactProviderEmployees,
            getEmployeesBelongToAllByBranches: getEmployeesBelongToAllByBranches,
            getContactsByPayrollGroupId: getContactsByPayrollGroupId,
            uploadTrainingDoc: contactsApiUrl + "/trainings/upload",
            getPagedCalendarEntries: getPagedCalendarEntries,
            getPagedCalendarEntriesCount: getPagedCalendarEntriesCount,
            getCalendarEntryTypeConfigurations: getCalendarEntryTypeConfigurations,
            saveCalendarEntryTypeConfiguration: saveCalendarEntryTypeConfiguration,
            approveCalendarEntry: approveCalendarEntry,
            rejectCalendarEntry: rejectCalendarEntry

        };

        function getRules() {
            return $http.get(tenantSettings.coreApiUrl + 'api/customvalidationrule?module=0');
        }

        function postContactMinify(data) {
            return $http.post(contactsApiUrl + '/minify', data);
        }

        function getAll() {
            return $http.get(contactsApiUrl);
        }

        function getActiveEmployees(branchIds) {
            return $http({
                method: 'POST',
                url: contactsApiUrl + '/active-employees',
                data: branchIds
            });
        }

        function getAllEmployeesByBranchIds(branchIds) {
            return $http({
                method: 'POST',
                url: contactsApiUrl + '/all-employees',
                data: branchIds
            });
        }

        function getXeroContacts() {
            return $http.get(`${contactsApiUrl}/xero`);
        }

        function getAllCached() {
            return $http({
                method: 'GET',
                url: contactsApiUrl,
                cache: true
            });
        }

        function postContact(data) {
            return $http.post(contactsApiUrl, data);
        }

        function getContactBundled(id) {
            return $http.get(contactsApiUrl + '/1?id=' + id);
        }

        function getContactEmpty() {
            return $http.get(contactsApiUrl + '/1?id=');
        }

        function getContact(id) {
            return $http.get(contactsApiUrl + '/' + id);
        }

        function putContact(data) {
            return $http.put(contactsApiUrl + '/' + data.id, data);
        }

        function postArchive(id, isArchived) {
            return $http.post(contactsApiUrl + '/' + id + '/Archive=' + isArchived);
        }

        function filterContact(data) {
            return $http.post(contactsApiUrl + '/filter', data);
        }

        function getUsersPerBranch(branchId) {
            return $http.get(contactsApiUrl + '/employees/' + branchId);
        }

        function validateEmployeeCode(code) {
            return $http.get(contactsApiUrl + '/employeecode/' + code);
        }

        function validateDuplicateContact(data) {
            return $http.post(contactsApiUrl + '/matches/', data);
        }

        function getDefaultEmployer() {
            return $http.get(tenantSettings.coreApiUrl + 'api/companies/employers');
        }

        function getMinifiedContactDetails(id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/contacts/details/minified/' + id);
        }

        function getContactHistory(entityId) {
            return auditApi.getAuditEntries(entityId);
        }

        function deleteFile(file) {
            var payLoad = [
                file
            ];
            return $http.post(tenantSettings.coreApiUrl + 'api/blobs/delete/', payLoad);
        }

        function getEntryType() {
            return $http.get(contactApiUrl + '/calendar/entry/lookup');
        }

        function getRepeatType() {
            return $http.get(contactApiUrl + '/calendar/repeat/lookup');
        }

        function getContactCalendarById(id, year) {
            var yearTobeGenerated = '/' + (year === undefined ? '' : year);
            return $http.get(contactApiUrl + '/calendar/all/' + id + yearTobeGenerated);
        }

        function getPagedCalendarEntries(data) {
            return $http.post(contactApiUrl + '/calendar/manage', data);
        }

        function getPagedCalendarEntriesCount(data) {
            return $http.post(contactApiUrl + '/calendar/manage/count', data);
        }

        function saveContactCalendar(data) {
            return $http.post(contactApiUrl + '/calendar/', data);
        }

        function updateContactCalendar(data) {
            return $http.put(contactApiUrl + '/calendar/', data);
        }

        function deleteContactCalendar(id) {
            return $http.put(contactApiUrl + '/calendar/' + id);
        }

        function getBranches() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/jobs/lookup/branches'
            });
        }

        function getEmployeesByBranchOrDivision(payload) {
            return $http.post(contactApiUrl + '/calendar/employees/lookup', payload);
        }

        function deleteUser(Id) {
            return $http.get(contactsApiUrl + '/deleteuser/' + Id);
        }

        function updateTimesheets(payload) {
            return $http.post(contactsApiUrl + '/updatetimesheets', payload);
        }

        function updateContactProviderEmployees(contacts) {
            return $http.post(contactsApiUrl + '/update-employees', contacts);
        }

        function getEmployeesBelongToAllByBranches(branchIds) {
            let params = branchIds.join(',');
            return $http.get(contactsApiUrl + '/employees-in-all-branches?branchIds=' + params);
        }

        function getContactsByPayrollGroupId(payrollGroupId) {
            return $http.get(contactsApiUrl + '/payroll-group/' + payrollGroupId);
        }

        function getCalendarEntryTypeConfigurations() {
            return $http.get(contactApiUrl + '/calendar/entry-type-configurations');
        }

        function saveCalendarEntryTypeConfiguration(data) {
            return $http.post(contactApiUrl + '/calendar/entry-type-configurations', data);
        }

        function approveCalendarEntry(id, data) {
            return $http.patch(contactApiUrl + '/calendar/manage/approve/' + id, data, { skipForbiddenRedirect: true });
        }

        function rejectCalendarEntry(id) {
            return $http.patch(contactApiUrl + '/calendar/manage/reject/' + id, null, { skipForbiddenRedirect: true });
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.api')
        .factory('companyCompetitorApi', companyCompetitorApi);

    function companyCompetitorApi(
        $http,
        tenantSettings
    ) {
        var competitorApiUrl = tenantSettings.coreApiUrl + 'api/competitor';

        return {
            createCompetitor: createCompetitor
        };

        function createCompetitor(payload) {
            return $http.post(competitorApiUrl + '/create/minified', payload);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('companyApi', companyApi);

    /** @ngInject */
    function companyApi(
        $http,
        tenantSettings,
        auditApi
    ) {
        var companiesApiUrl = tenantSettings.coreApiUrl + 'api/companies';

        return {
            postCompany: postCompany,
            postCompanyMinified: postCompanyMinified,
            getCompanies: getCompanies,
            getCompany: getCompany,
            getCompanyFormTemplates: getCompanyFormTemplates,
            updateCompany: updateCompany,
            updateCompanyMinified: updateCompanyMinified,
            postArchive: postArchive,
            filterCompany: filterCompany,
            validateCode: validateCode,
            getCompanyMinifiedDetails: getCompanyMinifiedDetails,
            getCompanyHistory: getCompanyHistory,
            validateDuplicateCompany: validateDuplicateCompany,
            getCreditTypes: getCreditTypes,
            getNonTaxExemptCompanies: getNonTaxExemptCompanies,
            getTaxExemptCompanies: getTaxExemptCompanies,
            updateTaxExemptCompany: updateTaxExemptCompany
        };

        ////////
        function postCompany(data) {
            return $http.post(companiesApiUrl, data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function postCompanyMinified(data) {
            return $http.post(companiesApiUrl + '/companyminified', data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function validateCode(code) {
            return $http.get(companiesApiUrl + '/companycode/' + code)
        }

        function getCompanyMinifiedDetails(id) {
            return $http.get(companiesApiUrl + '/details/minified/' + id)
        }

        function getCompanyHistory(entityId) {
            return auditApi.getAuditEntries(entityId);
        }

        function getCompanies() {
            return $http.get(companiesApiUrl);
        }

        function getCompany(id) {
            return $http.get(companiesApiUrl + '/' + id);
        }

        // Form templates linked to the company and each of its branches, grouped for the
        // attachment-preferences dialog (company group + one group per branch).
        function getCompanyFormTemplates(id) {
            return $http.get(companiesApiUrl + '/' + id + '/form-templates');
        }

        function getNonTaxExemptCompanies() {
            return $http.get(tenantSettings.coreApiUrl + 'api/companies/non-tax-exempt');
        }

        function getTaxExemptCompanies() {
            return $http.get(tenantSettings.coreApiUrl + 'api/companies/tax-exempt');
        }

        function updateTaxExemptCompany(companyId, isTaxExempt) {
            return $http.patch(tenantSettings.coreApiUrl + 'api/company/' + companyId + '/tax-exempt/' + isTaxExempt);
        }

        function updateCompany(data) {
            return $http.put(companiesApiUrl + '/' + data.id, data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function updateCompanyMinified(data) {
            return $http.put(companiesApiUrl + '/minified/' + data.Id, data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function postArchive(id, isArchived) {
            return $http.post(companiesApiUrl + '/' + id + '/Archive=' + isArchived, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function filterCompany(data) {
            return $http.post(companiesApiUrl + '/filter', data);
        }

        function validateDuplicateCompany(data) {
            return $http.post(companiesApiUrl + '/matches', data);
        }

        function getCreditTypes() {
            return $http.get(tenantSettings.coreApiUrl + 'api/lookup/company/credittypes');
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.api')
        .factory('commentApi', commentApi);

    function commentApi(
        tenantSettings,
        $http,
        $q,
        $timeout
    ) {
        var commentsApiUrl = tenantSettings.coreApiUrl + 'api/comments';

        return {
            getComments: getComments,
            getAllComments: getAllComments,
            addComment: addComment,
            editComment: editComment,
            deleteComment: deleteComment,
            getRestrictionTypes: getRestrictionTypes
        };

        function getComments(Id) {
            return $http.get(commentsApiUrl + '/' + Id);
        }

        function getAllComments(Id) {
            return $http.get(commentsApiUrl + '/all/' + Id);
        }

        function addComment(data) {
            return $http.post(commentsApiUrl, data);
        }

        function editComment(data) {
            return $http.put(commentsApiUrl + '/' + data.Id, data);
        }

        function deleteComment(Id) {
            return $http.delete(commentsApiUrl + '/' + Id);
        }

        function getRestrictionTypes(UserId) {
            var deferred = $q.defer();
            var mockData = [{
                    "Id": "-1",
                    "Name": "None",
                    "Tag": ""
                },
                {
                    "Id": "ffa3093f-0a93-42b4-bbd9-d67fae7c0544",
                    "Name": "HR Comment",
                    "Tag": "Contacts"
                },
                {
                    "Id": "ffa3093f-0a93-42b4-bbd9-d67fae7c0545",
                    "Name": "Payroll Comment",
                    "Tag": "Contacts"
                },
                {
                    "Id": "ffa3093f-0a93-42b4-bbd9-d67fae7c0546",
                    "Name": "Branch Admin Comment",
                    "Tag": "Contacts"
                },
                {
                    "Id": "ffa3093f-0a93-42b4-bbd9-d67fae7c0547",
                    "Name": "Invoicing Comment",
                    "Tag": "Companies"
                }
            ];
            $timeout(function() {
                deferred.resolve({
                    data: mockData
                });
            }, 200);
            //return deferred.promise;
            return $http.get(commentsApiUrl + '/restrictions/user');
        }
    }
})();

(function() {
  'use strict';

  angular.module('app.api')
      .factory('businessApi', businessApi);

  function businessApi(
      $http,
      tenantSettings,
      $q
  ) {
      var businessesApiUrl = tenantSettings.coreApiUrl + 'api/Businesses';

      return {
          createBusiness: createBusiness,
          updateBusiness: updateBusiness,
      };

      function createBusiness(data) {
          return $http.post(businessesApiUrl, data);
      }

      function updateBusiness(id, formData) {
          return $http({
              url: businessesApiUrl + "/" + id,
              method: 'PUT',
              headers: {
                  'Content-Type': undefined
              },
              transformRequest: angular.identity,
              data: formData
        });
      }
  }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('branchApi', branchApi);

    function branchApi(
        $http,
        tenantSettings,
        $q
    ) {
        var branchesApiUrl = tenantSettings.coreApiUrl + 'api/Branches';

        return {
            postBranch: postBranch,
            getBranches: getBranches,
            getBranch: getBranch,
            putBranch: putBranch,
            getBranchLookUp: getBranchLookUp,
            getBranchBundled: getBranchBundled,
            getBranchesAndStates: getBranchesAndStates,
            getBranchDivisions: getBranchDivisions
        };

        function postBranch(data) {
            return $http.post(branchesApiUrl, data);
        }

        function getBranches() {
            return $http({
                method: 'GET',
                url: branchesApiUrl
            });
        }

        function getBranch(id) {
            return $http.get(branchesApiUrl + "/" + id);
        }

        function getBranchBundled(id) {
            var query = [$http.get(branchesApiUrl + "/3?Id=" + id), $http.get('app/api/timezones.json')];
            return $q.all(query);
        }

        function putBranch(id, data) {
            return $http.put(branchesApiUrl + "/" + id, data);
        }

        function getBranchLookUp() {
            return $http.get(tenantSettings.coreApiUrl + "api/jobs/lookup/branches");
        }

        function getBranchesAndStates() {
            return $http.get(branchesApiUrl + "/getbranchesandstates");
        }

        function getBranchDivisions(branchId) {
            return $http.get(branchesApiUrl + "/" + branchId + "/divisions");
        }
    }
})();

{
    angular.module('app.api')
        .factory('awardsApi', awardsApi);

    /** @ngInject */
    function awardsApi(
        $http,
        tenantSettings
    ) {
        var awardsApiUrl = tenantSettings.coreApiUrl + 'api/awards';

        return {
            getAwards: getAwards,
            addAward: addAward,
            updateAward: updateAward,
            archiveAward: archiveAward,
            unarchiveAward: unarchiveAward,

            addClassification: addClassification,
            updateClassification: updateClassification,
            archiveClassification: archiveClassification,
            unarchiveClassification: unarchiveClassification,

            addClassificationRate: addClassificationRate,
            updateClassificationRate: updateClassificationRate,
            deleteClassificationRate: deleteClassificationRate,

            deleteTemporaryInterpretedShifts: deleteTemporaryInterpretedShifts,
            _export: _export,
            reExport: reExport
        };

        function getAwards() {
            return $http.get(awardsApiUrl);
        }

        function addAward(payload) {
            return $http.post(awardsApiUrl + `/`, payload);
        }

        function updateAward(awardId, payload) {
            return $http.put(awardsApiUrl + `/${awardId}`, payload);
        }

        function archiveAward(awardId) {
            return $http.put(awardsApiUrl + `/${awardId}/archive`);
        }

        function unarchiveAward(awardId) {
            return $http.put(awardsApiUrl + `/${awardId}/unarchive`);
        }

        function addClassification(awardId, payload) {
            return $http.post(awardsApiUrl + `/${awardId}/classification`, payload);
        }

        function updateClassification(awardId, classificationName, payload) {
            return $http.put(awardsApiUrl + `/${awardId}/classification/${classificationName}`, payload);
        }

        function archiveClassification(awardId, classificationName) {
            return $http.put(awardsApiUrl + `/${awardId}/classification/${classificationName}/archive`);
        }

        function unarchiveClassification(awardId, classificationName) {
            return $http.put(awardsApiUrl + `/${awardId}/classification/${classificationName}/unarchive`);
        }

        function addClassificationRate(awardId, classificationName, payload) {
            return $http.post(awardsApiUrl + `/${awardId}/classification/${classificationName}/rates`, payload);
        }

        function updateClassificationRate(awardId, classificationName, rateId, payload) {
            return $http.put(awardsApiUrl + `/${awardId}/classification/${classificationName}/rates/${rateId}`, payload);
        }

        function deleteClassificationRate(awardId, classificationName, rateId, rateType) {
            return $http({
                method: 'DELETE',
                url: awardsApiUrl + `/${awardId}/classification/${classificationName}/rates/${rateId}`,
                data: {
                    RateType: rateType
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        }

        function deleteTemporaryInterpretedShifts(payLoad) {
            return $http({
                method: 'DELETE',
                url: tenantSettings.coreApiUrl + "/api/payroll/temporary-interpreted-shifts",
                data: payLoad,
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        }

        function _export(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/timesheets/process/export", payLoad);
        }

        function reExport(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + "/api/timesheets/process/reexport", payLoad);
        }
    }
}

(function() {
    'use strict';

    angular.module('app.api')
        .factory('authApi', authApi);

    /** @ngInject */
    function authApi(
        $http,
        tenantSettings
    ) {
        var accountsApiUrl = tenantSettings.coreApiUrl + 'api/accounts';

        return {
            getUserInfo: getUserInfo,
            postLogin: postLogin,
            getExternalLogin: getExternalLogin,
            getMicrosoftSsoLogin: getMicrosoftSsoLogin,
            postRefreshToken: postRefreshToken,
            releaseNoteOff: releaseNoteOff,
            logout: logout
        };

        function getUserInfo() {
            return $http.get(accountsApiUrl + '/user/');
        }

        function logout() {
            return $http.get(accountsApiUrl + '/logout');
        }

        function postLogin(data) {
            return $http.post(accountsApiUrl + '/login', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
        }

        function getExternalLogin(provider) {

            return $http({
                method: 'GET',
                url: accountsApiUrl + '/ExternalLogins?provider='+provider+'&returnUrl=' + window.location.href + 'externalauth.html&generateState=true'
            });
        }

        function getMicrosoftSsoLogin() {
            var ssoApiUrl = tenantSettings.coreApiUrl + 'api/sso/microsoft';
            var returnUrl = window.location.origin + '/externalauth.html';

            return $http({
                method: 'GET',
                url: ssoApiUrl + '/login?returnUrl=' + encodeURIComponent(returnUrl)
            });
        }

        function postRefreshToken(clientId, refToken) {
            return $http({
                method: 'POST',
                url: accountsApiUrl + '/refreshtoken',
                data: {
                    clientId: clientId,
                    token: refToken
                }
            });
        }

        function releaseNoteOff() {
            return $http({
                method: 'POST',
                url: accountsApiUrl + '/releasenotes/off',
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('auditApi', auditApi);

    function auditApi(
        $http,
        tenantSettings,
        claimsUtilService,
        $q
    ) {
        var auditApiUrl = tenantSettings.auditApiUrl + 'api/audits/';
        var tenantKey = claimsUtilService.getTenantKey();

        return {
            getAuditEntries: getAuditEntries,
            getAuditEntriesV2: getAuditEntriesV2
        };

        function getAuditEntries(entityId) {
            var deferred = $q.defer();

            $http({
                    method: 'GET',
                    url: auditApiUrl + entityId,
                    headers: {
                        'X-TenantKey': tenantKey
                    }
                })
                .then(function(resp) {
                    var mappedResponse = mapToLegacyResponse(resp.data);

                    mappedResponse.data.sort((a, b) => new Date(b.LogDateUtc) - new Date(a.LogDateUtc));

                    deferred.resolve(mappedResponse);
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }

        function mapToLegacyResponse(data) {
            return {
                "data": data.map(item => ({
                    "id": item.entityId,
                    "Log": item.message,
                    "LogData": item.additionalData,
                    "LogDateUtc": moment(item.auditDateUtc + 'Z').toDate()
                }))
            }
        }

        function getAuditEntriesV2(entityIds) {
            var deferred = $q.defer();

            $http({
                    method: 'POST',
                    url: auditApiUrl,
                    headers: {
                        'X-TenantKey': tenantKey
                    },
                    data: entityIds
                })
                .then(function(resp) {
                    var mappedResponse = mapToLegacyResponse(resp.data);

                    mappedResponse.data.sort((a, b) => new Date(b.LogDateUtc) - new Date(a.LogDateUtc));

                    deferred.resolve(mappedResponse);
                })
                .catch(function(ex) {
                    deferred.reject(ex);
                });

            return deferred.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.api')
        .factory('attachmentTypesApi', attachmentTypesApi);

    function attachmentTypesApi(
        $http,
        tenantSettings
    ) {
        var baseUrl = tenantSettings.coreApiUrl + 'api/attachment-types';

        return {
            getAttachmentTypes: getAttachmentTypes,
            getAttachmentType: getAttachmentType,
            getSupportedFileTypes: getSupportedFileTypes,
            createAttachmentType: createAttachmentType,
            updateAttachmentType: updateAttachmentType,
        };

        function getAttachmentTypes() {
            return $http.get(baseUrl);
        }

        function getAttachmentType(id) {
            return $http.get(baseUrl + '/' + id);
        }

        function getSupportedFileTypes() {
            return $http.get(baseUrl + '/supported-file-types');
        }

        function createAttachmentType(data) {
            return $http.post(baseUrl, data);
        }

        function updateAttachmentType(id, data) {
            return $http.put(baseUrl + '/' + id, data);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.api')
        .factory('assetsApi', assetsApi);

    /** @ngInject */
    function assetsApi(
        $http,
        $q,
        tenantSettings
    ) {
        let costCodeApi = tenantSettings.coreApiUrl + 'api/costCode';
        let equipment = tenantSettings.coreApiUrl + 'api/equipment';
        let kitApi = tenantSettings.coreApiUrl + 'api/kititem';
        let itemApi = tenantSettings.coreApiUrl + 'api/stock';
        let stockTrackingApi = tenantSettings.coreApiUrl + 'api/stocklevelcounts';
        let individualItemApi = tenantSettings.coreApiUrl + 'api/individual';
        let stockCategoriesApi = tenantSettings.coreApiUrl + 'api/stockcategories';

        return {
            postCostCode: postCostCode,
            getCostCodes: getCostCodes,
            getCostCode: getCostCode,
            updateCostCode: updateCostCode,
            removeCostCode: removeCostCode,
            getIndividualItemStatus: getIndividualItemStatus,
            getDepreciationModelList: getDepreciationModelList,
            getEmployeeContacts: getEmployeeContacts,
            getCostCodeCategories: getCostCodeCategories,
            postKitItem: postKitItem,
            getKitItems: getKitItems,
            getKitItem: getKitItem,
            updateKitItem: updateKitItem,
            deleteKitItem: deleteKitItem,
            getIndividualTrackingTypes: getIndividualTrackingTypes,
            getCostCodes2: getCostCodes2,
            postItem: postItem,
            getItems: getItems,
            getItem: getItem,
            updateItem: updateItem,
            deleteItem: deleteItem,
            saveInitialStock: saveInitialStock,
            getStockLevelItem: getStockLevelItem,
            putStockLevelItem: putStockLevelItem,
            putStockLevelItemByBranch: putStockLevelItemByBranch,
            removeStockLevelItemByBranch: removeStockLevelItemByBranch,
            removeStockLevelItem: removeStockLevelItem,
            postIndividualItem: postIndividualItem,
            putConvertStockLevelItem: putConvertStockLevelItem,
            putConvertStockLevelItemByBranch: putConvertStockLevelItemByBranch,
            getIndividualItems: getIndividualItems,
            getIndividualItem: getIndividualItem,
            deleteIndividualItem: deleteIndividualItem,
            getStockLevelCounts: getStockLevelCounts,
            getActiveUsers: getActiveUsers,
            putIndividualItem: putIndividualItem,
            getStockLevelCategories: getStockLevelCategories,
            getIndividualItemsEquipmentOnly: getIndividualItemsEquipmentOnly,
            updateIndividualItemEquipmentOnly: updateIndividualItemEquipmentOnly,
            postMinifiedEquipment: postMinifiedEquipment,
            getEntryType: getEntryType,
            getRepeatType: getRepeatType,
            getEquipmentCalendarById: getEquipmentCalendarById,
            saveEquipmentCalendar: saveEquipmentCalendar,
            deleteEquipmentCalendar: deleteEquipmentCalendar,
            updateEquipmentCalendar: updateEquipmentCalendar
        };

        //////////

        // =============================
        //  Cost Codes APIs
        // =============================

        /**
         * Save Cost Code
         * @param data params
         * @returns a promise object
         */
        function postCostCode(data) {
            return $http.post(tenantSettings.coreApiUrl + 'api/costcode', data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function postMinifiedEquipment(payload) {
            return $http.post(individualItemApi + "/minified", payload);
        }

        function getCostCodes(allowCache) {
            allowCache = allowCache ? true : allowCache;
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/costcode/All',
                cache: allowCache
            });
        }

        function getCostCode(id) {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/costcode/' + id
            });
        }

        function updateCostCode(data) {
            return $http.put(tenantSettings.coreApiUrl + 'api/costcode/' + data.id,
                data, {
                    'Accept': 'application/json, text/javascript'
                });
        }

        function removeCostCode(id) {
            return $http.delete(tenantSettings.coreApiUrl + 'api/costcode/' + id, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function getCostCodes2(allowCache) {
            allowCache = allowCache || true;
            return $http({
                method: 'GET',
                url: costCodeApi + '/All',
                cache: allowCache
            });
        }

        function getIndividualItemStatus() {
            var data = [{
                    Id: 1,
                    Name: 'Active'
                },
                {
                    Id: 2,
                    Name: 'Not In Service'
                }
            ];

            return $q.when({
                data: data
            });
        }

        function getDepreciationModelList() {
            var data = [{
                    Id: 1,
                    Name: 'Year'
                },
                {
                    Id: 2,
                    Name: 'Percent Per Year'
                }
            ];
            return $q.when({
                data: data
            });
        }

        function getEmployeeContacts() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/Contacts'
            });
        }

        function getCostCodeCategories(allowCache) {
            allowCache = allowCache || true;
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/lookup/costcode/types',
                cache: allowCache
            });
        }


        // =============================
        //  Create Item API's
        // =============================

        function getItems() {
            return $http({
                method: 'GET',
                url: itemApi + '/all'
            });
        }

        function getItem(id) {
            return $http({
                method: 'GET',
                url: itemApi + '/' + id
            });
        }

        function getIndividualTrackingTypes() {
            var data = [{
                    id: 1,
                    Name: 'Yes, track individual item details'
                },
                {
                    id: 2,
                    Name: "No, don't track individual item details"
                },
            ];
            return $q.when({
                data: data
            });
        }

        function postItem(data) {
            return $http.post(itemApi, data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function updateItem(data) {
            return $http.put(itemApi + '/' + data.id, data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function deleteItem(itemId) {
            return $http.delete(itemApi + '/' + itemId);
        }

        function saveInitialStock(data) {
            return $http.post(stockTrackingApi, data, {
                'Accept': 'application/json, text/javascript'
            });
        }

        function getStockLevelItem(id) {
            return $http({
                method: 'GET',
                url: stockTrackingApi + '/' + id
            });
        }

        // Add Stock
        function putStockLevelItem(id, itemType, qty) {
            return $http.put(stockTrackingApi + '/add/' + id + '/' + itemType + '/' + qty, {
                'Accept': 'application/json, text/javascript'
            });
        };

        function putStockLevelItemByBranch(id, branchId, itemType, qty) {
            return $http.put(stockTrackingApi + '/add/' + id + '/' + branchId + '/' + itemType + '/' + qty, {
                'Accept': 'application/json, text/javascript'
            });
        };

        function removeStockLevelItemByBranch(id, branchId, itemType, qty) {
            return $http.put(stockTrackingApi + '/remove/' + id + '/' + branchId + '/' + itemType + '/' + qty, {
                'Accept': 'application/json, text/javascript'
            });
        };

        function removeStockLevelItem(id, itemType, qty) {
            return $http.put(stockTrackingApi + '/remove/' + id + '/' + itemType + '/' + qty, {
                'Accept': 'application/json, text/javascript'
            });
        };

        function postIndividualItem(data) {
            return $http.post(individualItemApi, data, {
                'Accept': 'application/json, text/javascript'
            });
        };

        function putConvertStockLevelItem(id, fromItemType, toItemType, qty) {
            return $http.put(stockTrackingApi + '/convert/' + id + '/' + fromItemType + '/' + toItemType + '/' + qty, {
                'Accept': 'application/json, text/javascript'
            });
        };

        function putConvertStockLevelItemByBranch(id, branchId, fromItemType, toItemType, qty) {
            return $http.put(stockTrackingApi + '/convert/' + id + '/' + branchId + '/' + fromItemType + '/' + toItemType + '/' + qty, {
                'Accept': 'application/json, text/javascript'
            });
        };

        // Grid (itemId)
        function getIndividualItems(id) {
            return $http({
                method: 'GET',
                url: individualItemApi + '/' + id
            });
        };

        // Details individual id
        function getIndividualItem(id) {
            return $http({
                method: 'GET',
                url: individualItemApi + '/item/' + id
            });
        };

        function deleteIndividualItem(id) {
            return $http({
                method: 'DELETE',
                url: individualItemApi + '/' + id
            });
        };

        function putIndividualItem(id, data) {
            return $http.put(individualItemApi + '/' + id,
                data, {
                    'Accept': 'application/json, text/javascript'
                }
            );
        };

        function getStockLevelCounts(id) {
            return $http({
                method: 'GET',
                url: stockTrackingApi + '/' + id
            });
        };

        function getActiveUsers() {
            return $http({
                method: 'GET',
                url: tenantSettings.coreApiUrl + 'api/contacts/users/contactbasic'
            });
        };


        // =============================
        //  Kit Items APIs
        // =============================
        function postKitItem(data) {
            return $http.post(kitApi, data, {
                'Accept': 'application/json, text/javascript'
            });
        };

        function getKitItems(id) {
            return $http({
                method: 'GET',
                url: id == null ? kitApi : kitApi + '/' + id
            });
        };

        function getKitItem(id) {
            return $http({
                method: 'GET',
                url: kitApi + '/' + id
            });
        };

        function updateKitItem(data) {
            return $http.put(kitApi + '/' + data.id, data, {
                'Accept': 'application/json, text/javascript'
            });
        };

        function deleteKitItem(kitId) {
            return $http.delete(kitApi + '/' + kitId);
        };

        // =============================
        //  Stock Level Category APIs
        // =============================
        function getStockLevelCategories(allowCache) {
            allowCache = allowCache || true;
            return $http({
                method: 'GET',
                url: stockCategoriesApi,
                cache: allowCache
            });
        };

        // =============================
        //  View Equipments APIs
        // =============================
        function getIndividualItemsEquipmentOnly() {
            return $http({
                method: 'GET',
                url: individualItemApi + '/view/equipments'
            });
        };

        //Individual/edit/equipments
        function updateIndividualItemEquipmentOnly(data) {
            return $http.put(individualItemApi + '/edit/equipments',
                data, {
                    'Accept': 'application/json, text/javascript'
                }
            );
        }

        function getEntryType() {
            return $http.get(equipment + '/calendar/entry/lookup');
        }

        function getRepeatType() {
            return $http.get(equipment + '/calendar/repeat/lookup');
        }

        function getEquipmentCalendarById(id, year) {
            let date = new Date();
            let current_year = date.getFullYear();
            var chosen_year = (year === undefined ? current_year : year);
            let req = equipment + '/calendar/all/' + id + "/" + chosen_year;
            return $http.get(req);
        }

        function saveEquipmentCalendar(data) {
            return $http.post(equipment + '/calendar/', data);
        }

        function deleteEquipmentCalendar(id) {
            return $http.put(equipment + '/calendar/' + id);
        }

        function updateEquipmentCalendar(data) {
            return $http.put(equipment + '/calendar/', data);
        }
    }
})();

{
    angular.module('app.api')
        .factory('allowanceAPI', allowanceAPI);

    /** @ngInject */
    function allowanceAPI(
        $http,
        tenantSettings
    ) {
        var allowanceApiUrl = tenantSettings.coreApiUrl + 'api/allowances';

        return {
            getAllowances: getAllowances,
            addAllowance: addAllowance,
            updateAllowance: updateAllowance,
        };

        function getAllowances() {
            return $http.get(allowanceApiUrl);
        }

        function addAllowance(data) {
            return $http.post(allowanceApiUrl, data);
        }

        function updateAllowance(data) {
            return $http.put(allowanceApiUrl + `/${data.Id}`, data);
        }
    }
}

{
    angular.module('app.api')
        .factory('allocationApi', allocationApi);

    /** @ngInject */
    function allocationApi(
        $http,
        tenantSettings
    ) {
        return {
            fetchTicket: fetchTicket,
            getAvailableResources: getAvailableResources,
            allocateResource: allocateResource,
            push: push,
            unAllocateResourceRegular: unAllocateResourceRegular,
            confirmResource: confirmResource,
            saveTimes: saveTimes,
            assignOperator: assignOperator,
            checkConflicts: checkConflicts,
            resetConflicts: resetConflicts,
            pushV2: pushV2,
            unconfirm: unconfirm,
            saveNotes: saveNotes,
            saveTimesheetManager: saveTimesheetManager,
            getAllocationSettings: getAllocationSettings,
            saveAllocationSettings: saveAllocationSettings,
            editItem: editItem,
            getResourceLike: getResourceLike,
            postResourceLike: postResourceLike,
            editBillingPreference: editBillingPreference,
            editBillingType: editBillingType,
            getCompanyCreditType: getCompanyCreditType,
            getShiftRoles: getShiftRoles,
            allocateEquipment: allocateEquipment,
            unAllocateResourceMultiDay: unAllocateResourceMultiDay,
            saveAdditionalSkills: saveAdditionalSkills,
            updateAriTags: updateAriTags,
            saveManageShiftAwards: saveManageShiftAwards,
            getAriAwardClassificationRestrictions: getAriAwardClassificationRestrictions,
            preload: preload,
            getRecipients: getRecipients,
            sendMessage: sendMessage,
            getSkills: getSkills,
            saveLinkedResourceItems: saveLinkedResourceItems,
            validateLinkedResourceItems: validateLinkedResourceItems,
            unlinkResourceItems: unlinkResourceItems
        };

        function preload(ticket_id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/allocation/preload/' + ticket_id);
        }

        function saveAdditionalSkills(Id, Skills) {
            let payload = {
                Id: Id,
                SkillIds: Skills
            };
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/additionalskills', payload);
        }

        function updateAriTags(ariId, params) {
            return $http.put(tenantSettings.coreApiUrl + 'api/allocation/' + ariId + '/tags', params);
        }

        function saveManageShiftAwards(ariId, params) {
            return $http.put(tenantSettings.coreApiUrl + 'api/allocations/' + ariId + '/shiftaward-settings', params);
        }

        function getAriAwardClassificationRestrictions(ariId) {
            return $http.get(tenantSettings.coreApiUrl + 'api/allocations/' + ariId + '/shiftawards-settings/restrictions');
        }

        function getCompanyCreditType(ticket_id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/allocation/companycredittype/' + ticket_id);
        }

        function fetchTicket(id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/allocation/' + id);
        }

        function editItem(data) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/edititem', data);
        }

        function editBillingPreference(data) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/changebillingpreference', data);
        }

        function editBillingType(data) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/changebillingtype', data);
        }

        function getAvailableResources(
            ariId,
            ticketId,
            ticketNumber,
            itemId,
            resourceType,
            shiftStart,
            shiftEnd,
            jobLongitude,
            jobLatitude,
            ticketBranchId,
            ticketCompanyId,
            ticketDivisionId,
            ticketProjectId,
            ticketSiteContactId
        ) {
            var payLoad = {
                AriId: ariId,
                TicketId: ticketId,
                TicketNumber: ticketNumber,
                ItemId: itemId,
                ResourceType: resourceType,
                ShiftStart: shiftStart,
                ShiftEnd: shiftEnd,
                JobLongitude: jobLongitude,
                JobLatitude: jobLatitude,
                TicketBranchId: ticketBranchId,
                TicketCompanyId: ticketCompanyId,
                TicketDivisionId: ticketDivisionId,
                TicketProjectId: ticketProjectId,
                TicketSiteContactId: ticketSiteContactId
            };

            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/v3/getAvailableResources', payLoad);
        }

        function assignOperator(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/assignoperatorV2', payLoad);
        }

        function unconfirm(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/unconfirmV2', payLoad);
        }

        function allocateResource(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/allocateV2', payLoad)
        }

        function allocateEquipment(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/multidayequipmentjob', payLoad)
        }

        function saveTimes(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/savetimesV2', payLoad)
        }

        function unAllocateResourceRegular(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/unallocateV2', payLoad)
        }

        function unAllocateResourceMultiDay(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/unallocateV2/multiday', payLoad)
        }

        function confirmResource(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/confirmV2', payLoad)
        }

        function push(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/push', payLoad)
        }

        function checkConflicts(payload) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/conflicts', payload)
        }

        function resetConflicts(payload) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/resetconflicts', payload)
        }

        function pushV2(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/notify', payLoad)
        }

        function getAllocationSettings() {
            return $http.get( tenantSettings.coreApiUrl + 'api/allocation/getsettings');
        }

        function saveAllocationSettings(userId, settings) {
            let payLoad = {
                id: userId,
                settings: settings
            };
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/savesettings', payLoad);
        }

        function saveNotes(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/savenotes', payLoad);
        }

        function saveTimesheetManager(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/saveTimesheetManager', payLoad);
        }

        function getResourceLike(Id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/allocation/resourcelike/' + Id);
        }

        function getShiftRoles(Id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/shiftroles/lookup?ariId=' + Id);
        }

        function postResourceLike(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/resourcelike/', payLoad);
        }

        function getRecipients(Id) {
            return $http.get(tenantSettings.coreApiUrl + 'api/allocation/' + Id + "/messaging");
        }

        function sendMessage(payLoad) {
            return $http.post(tenantSettings.coreApiUrl + 'api/jobmessaging/messaging/send', payLoad);
        }

        function getSkills() {
            return $http.get(tenantSettings.coreApiUrl + 'api/Skills');
        }

        function saveLinkedResourceItems(payload) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/resource-items/link', payload);
        }

        function validateLinkedResourceItems(payload) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/resource-items/validate-linked-items', payload);
        }

        function unlinkResourceItems(payload) {
            return $http.post(tenantSettings.coreApiUrl + 'api/allocation/resource-items/unlink', payload);
        }
    }
}

(function() {
    'use strict';

    angular
        .module('alloc8')
        .run(runBlock);

    /** @ngInject */
    function runBlock(
        $rootScope,
        $timeout,
        $window,
        enableGoogleAnalytics,
        $state,
        $location,
        $q,
        $injector,
        utils,
        $mdDateLocale,
        identityService,
        pageHistoryService,
        signalRService,
        hubService
    ) {
        $window.ga('create', 'UA-84479900-1', 'auto');

        initializeSignalR();

        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, options) {
            $rootScope.loadingProgress = true;
            routeNavigationRules(event, toState, toParams, fromState);
        });

        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            if (enableGoogleAnalytics) {
                $window.ga('send', 'pageview', $location.path());
            }

            $timeout(function() {
                $rootScope.titleBar = toState.titleBar;
                $rootScope.loadingProgress = false;
            }, 1000);

            if (fromState.name === 'app.pages_auth_login-v2' ||
                fromState.name === 'app.pages_errors_error-403' ||
                fromState.name === 'app.pages.error-unhandled' ||
                fromState.name === 'app.pages_auth_forgot-password' ||
                toState.name === 'app.pages_auth_login-v2') {
                return;
            }

            pageHistoryService.updateHistory(fromState, fromParams);
        });

        $rootScope.state = $state;

        $rootScope.$on('$destroy', function() {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        function routeNavigationRules(event, toState, toParams, fromState) {
            var isRouteDisabled = toState.data &&
                toState.data.shouldDisable &&
                $injector.invoke(toState.data.shouldDisable);

            if (isRouteDisabled) {
                event.preventDefault();
                $rootScope.state.go('app.pages_errors_error-404', {
                    returnUrl: encodeURIComponent($location.path())
                });
                return;
            }

            var shouldLogin = toState.data !== undefined &&
                toState.data.requireLogin &&
                !identityService.isAuthenticated();

            if (shouldLogin) {
                $state.go('app.pages_auth_login-v2');
                event.preventDefault();
                return;
            }

            if (identityService.isAuthenticated()) {
                var dateFormat = null;
                if (localStorage.getItem("dateFormat") != null) {
                    dateFormat = localStorage.getItem("dateFormat");
                } else {
                    dateFormat = utils.setDateFormat();
                }

                $mdDateLocale.formatDate = function(date) {
                    return utils.formatToLocaleDate(date, dateFormat);
                }
                $mdDateLocale.parseDate = function(dateString) {
                    return utils.parseToLocaleDate(dateString, dateFormat);
                };

                let shouldGoToMain = (fromState.name === '' && toState.name === '') || (toState.name === "app.pages_auth_login-v2" && identityService.isAuthenticated());

                if (shouldGoToMain) {
                    $state.go('app.dashboard');
                    event.preventDefault();
                } else  if (toState.data && toState.data.validateAccess) {
                    const hasAccess = $injector.invoke(toState.data.validateAccess)
                    if (!hasAccess) {
                        event.preventDefault();
                        $rootScope.state.go('app.pages_errors_error-403', {
                            returnUrl: encodeURIComponent($location.path())
                        });
                    }
                }

                // ==========================
                //  Custom Route Hooks
                // ==========================
                // Publish event to subcribers for custom routing handling.
                // This will give specific module/page to setup a custom router logic without polluting this router configuration. :)
                var routerCustomDeferred = $q.defer();
                $rootScope.$broadcast('$customRouteLogic', {
                    promise: routerCustomDeferred,
                    toState: toState
                });
                routerCustomDeferred.promise.then(function(newStateRoute) {
                    if (newStateRoute) {
                        $state.go(newStateRoute);
                        event.preventDefault();
                    }
                });

            }
        }

        function initializeSignalR() {
            if (identityService.isAuthenticated()) {
                signalRService.connect();
                hubService.register();
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('alloc8')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise('/pages/errors/error-404');
    
    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
    // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies', function (_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Get active layout
    var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    var layouts = {
      verticalNavigation: {
        main: 'app/core/layouts/vertical-navigation.html',
        toolbar: 'app/toolbar/toolbar.html',
        navigation: 'app/navigation/navigation.html'
      },
      contentOnly: {
        main: 'app/core/layouts/content-only.html',
        toolbar: '',
        navigation: ''
      },
      contentWithToolbar: {
        main: 'app/core/layouts/content-with-toolbar.html',
        toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: layouts[layoutStyle].main,
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: layouts[layoutStyle].toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: layouts[layoutStyle].navigation,
            controller: 'NavigationController as vm'
          },
          'quickPanel@app': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller: 'QuickPanelController as vm'
          }
        }
      });
  }
})();

{
  angular.module('alloc8')
    .filter('containsOf', function() {

    // Create the return function and set the required parameter name to **input**
    return function(input,assetType) {

      var out = [];
      if(assetType != 0){
        angular.forEach(input, function(item)
        {
          if(parseInt(assetType) === 4){
            if(_.find(item.ItemTypes, function(o) { return o == parseInt(assetType) && o == 4}))
            {
              out.push(item)
            }
          }
          else{
            if(_.find(item.ItemTypes, function(o) { return o >= parseInt(assetType) && o != 4}))
            {
              out.push(item)
            }
          }

        });
      }
      else{
        out = input;
      }

      return out;
    }

  })
  .filter('moment', function() {
    return function(dateString, format) {
        return moment(dateString).format(format);
    };
  })
  .filter('formatDay', function() {
    return function(repeat) {
       switch (repeat) {
            case 0:
              return "Sunday";
            case 1:
              return "Monday";
            case 2:
              return "Tuesday";
            case 3:
              return "Wendesday";;
            case 4:
              return "Thursday";
            case 5:
              return "Friday";
            case 6:
              return "Saturday";
            default:
            break;
        }
    };
});
}

(function () {
  'use strict';
  angular
    .module('alloc8')

    /**
     *  Manages tokens
     */
    .factory('tokenFactory', function ($cookies, $location) {
      return {
        generateBearer: function (token) {
          return "Bearer " + token;
        },
        expireTokens: function () {
          // Temporary logout
          $cookies.remove("presence");
          $cookies.remove("access_token");
          $location.url('/');
        }
      }
    })

    /**
     *  Manages timestamps
     */
    .factory('timeFactory', function () {
      return {
        timeParser: function (time) {
          var day =  moment.unix(time);
          return moment(day, "YYYYMMDD").fromNow();
        }
        , toPlural: function (count, of) {
          if (count > 1) {
            return count + " " + of + "s";
          } else {
            return count + " " + of;
          }
        }
        , todayDate: function () {
          var today = new Date()
            , convertTime = new Date(today).toISOString();
          return convertTime;
        }, formattedDate: function(chosenDate, _format){
          return moment(chosenDate.toString()).format(_format);
        }
      }
    })
    .factory('modalFactory', function ($mdDialog) {
      return {
        popUpModal: function (title, content, button) {
          alert = $mdDialog.alert({
            title: title,
            textContent: content,
            ok: button
          });
          $mdDialog
            .show(alert)
            .finally(function () {
              alert = undefined;
            });
        }
      }
    })
    .factory('validateFactory', function () {
      return {
        isNotEmpty: function (variable) {
          if (variable && variable !== null) {
            return variable;
          } else {
            return '';
          }
        }
        , isArrEmpty: function (arr) {
          if (arr.length <= 0)
            return [];
          else
            return arr;
        }
        , evalProp: function (prop) {
          if (prop === undefined)
            return null;
          else
            return prop;
        }
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('alloc8')
    .controller('IndexController', IndexController);

  /** @ngInject */
  //function IndexController(fuseTheming, AuthFactory) {
  function IndexController(fuseTheming, identityService, cdnUrl) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
    vm.cdnUrl = cdnUrl;

    //////////
    vm.auth = identityService.isAuthenticated(); //AuthFactory.isLoggedIn();
  }
})();


(function () {
    'use strict';
  
    /**
     * Decoupled version of constants
     */
    angular
      .module('alloc8Constants', []);
  
  })();
(function () {
    'use strict';

    angular
        .module('alloc8Constants')
        .constant('moment', moment)
        .constant('_', window._)
        .constant('$', $)
        .constant('alasql', alasql)

        .constant('enableGoogleAnalytics', false) //value must be true on live site/production only
        .constant('appClientId', '23d39294ce8f4cb2ab9b128682e5f2d1')
        .constant('tokenStorageKey', 'presence')
        .constant('a8Enckey', 'YUxsb2M4QWx0dXokMTIz')
        .constant('searchDelay', 100)
        .constant('NUM_TRIES_RECONNECT', 5)
        .constant('cdnUrl', 'https://alloc8cdn-ejejgwcca3b7debc.a02.azurefd.net')
        .constant('googleApiKey', 'AIzaSyC46XhcQBPHW_nYgOaImMAR0FxAuRgfa0E')
        .constant('googleDriveScope', 'https://www.googleapis.com/auth/drive')
        .constant('googleApiClientId', '915246833488-usbdpi88u1meeg0nf8jvttc4sb416dp8.apps.googleusercontent.com')
        .constant('googleDriveApiUrl', 'https://www.googleapis.com/drive/v3/')
        .constant('oneDriveEndpointHint', 'api.onedrive.com')
        .constant('oneDriveRedirectPath', '/onedrive-redirect.html')
        .constant('emailPattern','^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')
        .constant('restrictSpecialCharacters', '^[a-zA-Z0-9 ]+$')
})();

(function() {
    'use strict';

    angular
        .module('alloc8')
        .config(config)
        .run(runConfig);

    function config(
        unsavedWarningsConfigProvider,
        $mdThemingProvider,
        $httpProvider,
        blockUIConfig,
        localStorageServiceProvider,
        $mdIconProvider,
        fuseConfigProvider,
        tenantSettings,
        localisationFieldSettings,
        localisationServiceProvider
    ) {
        configureTheme($mdThemingProvider);

        unsavedWarningsConfigProvider.useTranslateService = false;

        configureIcons($mdIconProvider);

        configureInterceptors($httpProvider);

        configureBlockUI(blockUIConfig);

        configureLocalStorage(localStorageServiceProvider);

        configureFuse(fuseConfigProvider);

        localisationServiceProvider.config(tenantSettings, localisationFieldSettings);
    }

    function configureTheme(themingProvider) {
        var alloc8Blue = themingProvider.extendPalette('light-blue', {
            '600': '0073e8'
        });

        themingProvider.definePalette('light-blue', alloc8Blue);
        themingProvider.theme('custom').primaryPalette('light-blue');
    }

    function configureFuse(fuseConfigProvider) {
        fuseConfigProvider.config({
            'disableCustomScrollbarsOnMobile': false
        });
    }

    function configureIcons(iconProvider) {
        iconProvider
            .defaultIconSet("./assets/icons/avatars.svg", 128)
            .icon("menu", "./assets/icons/menu.svg", 24)
            .icon("share", "./assets/icons/share.svg", 24)
            .icon("code-tags-check", "./assets/icons/code-tags-check.svg", 24)
            .icon("delete", "./assets/icons/delete.svg", 24)
            .icon("dots-vertical", "./assets/icons/dots-vertical.svg", 24)
            .icon("checkbox-marked", "./assets/icons/checkbox-marked.svg", 24)
            .icon("time", "./assets/icons/clock.svg", 24)
            .icon("checkbox-marked-circle", "./assets/icons/checkbox-marked-circle.svg", 24)
            .icon("format-align-justify", "./assets/icons/format-align-justify.svg", 24)
            .icon("numeric-1-box-multiple-outline", "./assets/icons/numeric-1-box-multiple-outline.svg", 24)
            .icon("arrow-down-drop-circle", "./assets/icons/arrow-down-drop-circle.svg", 24)
            .icon("account-check", "./assets/icons/account-check.svg", 24)
            .icon("pencil", "./assets/icons/pencil.svg", 24)
            .icon("list", "./assets/icons/list.svg", 24)
            .icon("radio-checked2", "./assets/icons/radio-checked2.svg", 24)
            .icon("google_plus", "./assets/icons/google_plus.svg", 512)
            .icon("hangouts", "./assets/icons/hangouts.svg", 512)
            .icon("twitter", "./assets/icons/twitter.svg", 512)
            .icon("brush", "./assets/icons/brush.svg", 512)
            .icon("email", "./assets/icons/email.svg", 512)
            .icon("web", "./assets/icons/web.svg", 512)
            .icon("arrow-right-drop-circle", "./assets/icons/arrow-right-drop-circle.svg", 512)
            .icon("decimal-increase", "./assets/icons/decimal-increase.svg", 512)
            .icon("phone", "./assets/icons/phone.svg", 512)
            .icon("account", "./assets/icons/account-multiple-plus.svg", 512)
            .icon("bar", "./assets/icons/chart-bar-stacked.svg", 2000)
            .icon("pie", "./assets/icons/chart-pie.svg", 2000)
            .icon("number", "./assets/icons/numeric-1-box-outline.svg", 2000)
            .icon("line", "./assets/icons/chart-timeline.svg", 2000)
            .icon("star", "./assets/icons/star.svg", 2000)
            .icon("comment-account", "./assets/icons/comment-account.svg", 2000)
            .icon("emoticon-happy", "./assets/icons/emoticon-happy.svg", 2000)
            .icon("settings", "./assets/icons/settings.svg", 2000)
            .icon("settings-outlined", "./assets/icons/settings-outlined.svg", 2000)
            .icon("pin-outlined", "./assets/icons/pin-outlined.svg", 2000)
            .icon("calendar-clock", "./assets/icons/calendar-clock.svg", 2000)
            .icon("smart-schedule", "./assets/icons/smart-schedule.svg", 18)
            .icon("smart-schedule-white", "./assets/icons/smart-schedule-white.svg", 18)
            .icon("warning-circle", "./assets/icons/warning-circle.svg", 18)
            .icon("attachment-not-completed", "./assets/icons/attachment-not-completed.svg", 23)
            .icon("attachment-completed", "./assets/icons/attachment-completed.svg", 20)
            .icon("attachment-preferences", "./assets/icons/attachment-preferences.svg", 24);
    }

    function configureInterceptors($httpProvider) {
        // Http Provider
        $httpProvider.interceptors.push('sessionTokenInterceptor');

        // Authorization Interceptor
        $httpProvider.interceptors.push('authorizationInterceptor');
    }

    function configureBlockUI(blockUIConfig) {
        blockUIConfig.delay = 10;
        blockUIConfig.autoBlock = false;

        // Change the displayed message based on the http verbs being used.
        blockUIConfig.requestFilter = function(config) {
            var message;

            switch (config.method) {
                case 'GET':
                    message = 'Loading ...';
                    break;

                case 'POST':
                    message = 'Saving ...';
                    break;

                case 'DELETE':
                    message = 'Deleting ...';
                    break;

                case 'PUT':
                    message = 'Updating ...';
                    break;
            };

            return message;
        };
    }

    function configureLocalStorage(provider) {
        provider.setStorageType('localStorage');
    }

    function runConfig(
        $mdDateLocale,
        localisationService
    ) {
        setLocale($mdDateLocale, localisationService);
    }

    function setLocale($mdDateLocale, localisationService) {
        var settings = localisationService.getLocaleFormatSettings();

        $mdDateLocale.formatDate = function(date) {
            return date ? moment(date).format(settings.shortdateFormatWithSlash) : null;
        };

        $mdDateLocale.parseDate = function(dateString) {
            var m = moment(dateString, settings.shortdateFormatWithSlash, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocale.firstDayOfWeek = settings.firstDayOfWeek;
    }
})();

(function () {
    'use strict';

    angular.module('alloc8')
        .service('appConfigService', appConfigService);

    function appConfigService() {
        var self = this;
        var defaults = {
        };

        self.cfg = defaults;
        self.configure = configure;
        self.configure();

        function configure(opts) {
            var mappedValue = opts || {};
            self.cfg = angular.extend({}, defaults, mappedValue);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('alloc8')
        .factory('apiService', apiService);

    /** @ngInject */
    function apiService(
        $resource,
        tenantSettings
    ) {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allows you to
         * add hardcoded parameters to your API calls that you want them to be sent every
         * time you make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *          list     : $resource('http://api.example.com/blog);
         *          getById  : $resource('http://api.example.com/blog/:id', {id: '@id'});
         *          getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'},
         *              'get': {method: 'GET', params: {getByDate: true}}
         *          );
         *      }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        api.coreApiUrl = tenantSettings.coreApiUrl;

        // login
        api.auth = {
            token: api.coreApiUrl + 'auth/token'
        };

        api.notifs = {
            read: api.coreApiUrl + 'api/notifications/read',
            unread: api.coreApiUrl + 'api/notifications/unread'
        }

        api.accounts = {
            forgotPassword: api.coreApiUrl + 'api/accounts/forgotPassword',
            resetPassword: api.coreApiUrl + 'api/accounts/resetpassword',
            user: api.coreApiUrl + 'api/accounts/user'
        }

        api.contacts = {
            getContactList: api.coreApiUrl + 'api/Contacts',
            list: $resource(api.coreApiUrl + 'api/Contacts'),
            postImage: api.coreApiUrl + 'api/contacts/uploadimage'
        }

        api.tickets = {
            list: $resource(api.coreApiUrl + 'api/Tickets')
        }

        api.awards = {
            list: $resource(api.coreApiUrl + 'api/award')
        }

        api.branches = {
            list: $resource(api.coreApiUrl + 'api/branches')
        }

        api.company = {
            list: $resource(api.coreApiUrl + 'api/companies')
        }

        api.lookup = {
            getContactFields: api.coreApiUrl + 'api/lookup/all/contact',
            getAddressTypes: api.coreApiUrl + 'api/lookup/addresstypes',
            getUnitTypes: api.coreApiUrl + 'api/lookup/unittypes',
            getStreetTypes: api.coreApiUrl + 'api/lookup/streettypes',
            getAddressStates: api.coreApiUrl + 'api/lookup/addressstates',
            getPhoneTypes: api.coreApiUrl + 'api/lookup/phonetypes'
        }

        return api;
    }
})();

/**
 * Created by queenie maniquis on 04/10/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.payroll-settings', [
            'app.payroll-settings.manage'
        ])
        .config(config);

    /** @ngInject */
    function config ($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

    }
})();

(function () {
  'use strict';

  angular
    .module('app.pages', [
      'app.pages.auth.login-v2',
      //'app.pages.auth.register',
      //'app.pages.auth.register-v2',
      'app.pages.auth.forgot-password',
      'app.pages.auth.update-password',
      //'app.pages.auth.reset-password',
      //'app.pages.auth.lock',
      //'app.pages.coming-soon',
      'app.pages.error-403',
      'app.pages.error-404',
      'app.pages.error-500',
      'app.pages.error-unhandled',
      //'app.pages.invoice',
      //'app.pages.maintenance',
      'app.pages.profile'
      //'app.pages.search',
      //'app.pages.timeline'
    ])
    .config(config);

  /** @ngInject */
  function config() {
  }
})();

/**
 * Created by jbpb on 02/28/2018.
 */
(function () {
    'use strict';

    angular
        .module('app.invoice-export', [
            'app.invoice-export.manage'
        ])
        .config(config);

    /** @ngInject */
    function config ($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        //
    }
})();

(function () {
    'use strict';

    angular
        .module('app.customFieldsManager', ['app.custom-fields.view', 'app.custom-fields.binder'])
})();

(function() {
   'use strict'; 
   angular.module('app.shared.models', []); 
})();
angular.module("alloc8").run(["$templateCache", function($templateCache) {$templateCache.put("app/navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><img ng-class=\"vm.getLogoClass()\" ng-src=\"{{vm.getLogoUrl()}}\"><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><div class=\"scrollable\" ms-scroll=\"vm.msScrollOptions\"><div><page-history-navigation ng-if=\"vm.hasQuickLinks()\" history-size=\"3\" class=\"md-indent\" history-list=\"vm.getQuickLinks()\"></page-history-navigation></div><div><ms-navigation folded=\"vm.folded\"></ms-navigation></div></div>");
$templateCache.put("app/toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"sidenav-toggle\" layout-align=\"start center\" hide-gt-sm=\"\" flex=\"auto\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent margin-left-5\" md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular></div><div class=\"toolbar-separator\" hide-gt-sm=\"\"></div><div layout=\"row\" flex=\"100\" layout-align=\"space-between center\"><a8-header header-text=\"{{vm.getHeaderText()}}\" layout=\"row\" flex=\"auto\"></a8-header></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" ng-src=\"{{vm.userData.PhotoUrl}}\"></div><span class=\"username\" hide-xs=\"\">{{ vm.userData.FirstName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content class=\"user-nav\" width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button><i class=\"material-icons md-icon\">contact_support</i> <a href=\"https://alloc8.zendesk.com\" target=\"_blank\">Contact Support</a></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button><i class=\"material-icons md-icon\">auto_awesome</i> <a href=\"https://pages.alloc8.io/product-updates\" target=\"_blank\">Product Updates</a></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><span ng-if=\"vm.hasNotifications()\"><i class=\"material-icons md-active\">notifications_active</i> <small class=\"notification-badge\">1+</small></span> <span ng-if=\"!vm.hasNotifications()\"><i class=\"material-icons md-inactive\">notifications</i></span></md-button></div></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><md-tab><md-tab-label translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</md-tab-label><md-tab-body><md-content class=\"todo-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/todo/todo-tab.html\'\" ng-controller=\"TodoTabController as vm\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" class=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap=\"\" ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button ng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">Color Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap=\"\"><md-button ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" layout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" ng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" ng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex=\"\"></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div id=\"main-container\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div id=\"main-container\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/navigation/history/pageHistory.html","<ms-nav-item ms-nav-title=\"\" class=\"ms-nav-title quick-links-nav\" style=\"height: 30px;\"><div class=\"quick-links-title\"><span class=\"quick-links-divider\">Quick Links</span></div><div><ul class=\"quick-links-items\"><li ng-repeat=\"item in histVm.historyList\" class=\"link-item\"><ms-nav-item><a ms-nav-button=\"\" ng-click=\"histVm.onNavigate(item.Id)\" ui-sref-active=\"active\" md-ink-ripple=\"\"><div class=\"ms-nav-label\"><i class=\"icon s16 icon-history\"></i> <span>{{item.Title}}</span></div></a></ms-nav-item></li></ul></div><hr></ms-nav-item>");
$templateCache.put("app/main/commentRestriction/manage-comment-restrictions.html","<div id=\"branch-view\" class=\"manage-comment-restrictions page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div layout-padding=\"\" class=\"content\" layout=\"column\" flex=\"\"><md-progress-linear ng-if=\"vm.service.initializing\" class=\"md-hue-2\" md-mode=\"indeterminate\"></md-progress-linear><div><md-card layout-padding=\"\" layout-margin=\"\" class=\"md-whiteframe-3dp\" flex=\"50\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-repeat=\"module in vm.service.modules\"><md-card-header layout=\"column\"><div ng-if=\"module.Saving\" layout=\"row\" flex=\"\"><div><md-progress-circular md-diameter=\"20px\" class=\"md-light-blue-800-fg\" md-mode=\"indeterminate\"></md-progress-circular></div><div style=\"margin-left : 10px;\">{{\'COMMENT_RESTRICTION.SAVING\' | translate}}</div></div><div style=\"margin-top: 10px;\" ng-if=\"module.Saving\" flex=\"\"><md-progress-linear class=\"md-hue-2\" md-mode=\"indeterminate\"></md-progress-linear></div><md-card-header-text ng-if=\"!module.Saving\" class=\"md-subhead\" layout=\"row\"><span>{{module.Name}}</span> <span ng-if=\"module.Comments.length < 5\" ng-click=\"vm.service.openCommentRestrictionDialog(false, module, null)\" style=\"margin-left : 15px;\"><i style=\"cursor : pointer\" class=\"icon icon-plus-box teal-700-fg\"></i></span></md-card-header-text></md-card-header><md-content ng-style=\"{\'opacity\' : module.Saving ? \'0.5\' : \'1\'}\" ms-scroll=\"\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th translate=\"COMMENT_RESTRICTION.CLAIM_NAME\" style=\"width : 70%\" class=\"text-left\"></th><th ng-if=\"!module.Saving\" translate=\"COMMENT_RESTRICTION.ACTIONS\" style=\"width : 30%\" class=\"text-left\"></th></thead><tbody><tr class=\"task-item\" ng-repeat=\"comment in module.Comments\"><td style=\"width : 70%\"><span ng-if=\"!comment.Saving\">{{comment.Name}}</span><md-progress-linear ng-if=\"comment.Saving\" md-mode=\"indeterminate\"></md-progress-linear></td><td ng-if=\"!comment.Saving || !module.Saving\" style=\"width : 30%\"><i ng-if=\"!module.Saving\" ng-click=\"vm.service.openCommentRestrictionDialog(true, module, comment)\" style=\"cursor : pointer; font-size : 20px;\" class=\"icon icon-pencil teal-700-fg\"></i> <i ng-if=\"!module.Saving\" ng-click=\"vm.service.deleteCommentRestriction(comment, comment.Group, module)\" style=\"cursor : pointer; font-size : 20px;\" class=\"icon icon-trash red-500-fg\"></i></td></tr></tbody></table></md-content></md-card></div></div></div></div>");
$templateCache.put("app/main/customValidations/custom-validations.html","<div id=\"custom-validations\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><toolbar-loader message=\"vm.service.loader_message\" show=\"vm.service.loading\"></toolbar-loader></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\" layout-margin=\"\"><div layout=\"row\" layout-align=\"end center\" flex=\"\" style=\"position : relative; top :-30px\"><md-button ng-click=\"vm.goToPlayArea()\" class=\"md-fab md-mini md-accent\" aria-label=\"Create Contact\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>Create Rule</md-tooltip></md-icon></md-button></div><table class=\"dataTable row-border hover\" style=\"position : relative;top : -20px;\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"rule in vm.service.rules | orderBy : \'RuleName\'\"><td><span layout=\"row\" ng-if=\"rule.IsSaving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"15px\"></md-progress-circular><span style=\"margin-left : 10px; margin-top : -5px;\" class=\"md-body-2\">{{vm.service.progress_message}}</span></span> <span ng-if=\"!rule.IsSaving\">{{rule.RuleName}}</span></td><td><span ng-if=\"rule.IsSaving\"><md-icon style=\"font-size : 20px;\" class=\"blue-grey-300-fg\" md-font-icon=\"{{rule.IsEnabled ? \'icon-checkbox-marked-circle\' : \'icon-close-circle\'}}\"><md-tooltip>{{rule.IsEnabled ? \'This rule is active\' : \'This rule is inactive\'}}</md-tooltip></md-icon></span> <span ng-if=\"!rule.IsSaving\"><md-icon style=\"font-size : 20px;\" ng-class=\"{\'green-600-fg\' : rule.IsEnabled, \'red-600-fg\' : !rule.IsEnabled}\" md-font-icon=\"{{rule.IsEnabled ? \'icon-checkbox-marked-circle\' : \'icon-close-circle\'}}\"><md-tooltip>{{rule.IsEnabled ? \'This rule is active\' : \'This rule is inactive\'}}</md-tooltip></md-icon></span></td><td><span ng-if=\"!rule.IsSaving\"><md-icon ng-click=\"vm.service.deleteRule(rule)\" class=\"red-600-fg\" style=\"font-size : 20px; cursor : pointer\" md-font-icon=\"icon-delete\"><md-tooltip>Delete this rule</md-tooltip></md-icon><md-icon ng-click=\"vm.goToPlayArea(rule)\" class=\"blue-800-fg\" style=\"font-size : 20px; cursor : pointer\" md-font-icon=\"icon-eye\"><md-tooltip>View</md-tooltip></md-icon><md-icon ng-click=\"vm.service.changeRuleStatus(rule)\" style=\"font-size : 20px; cursor : pointer;\" ng-class=\"{\'blue-grey-600-fg\' : rule.IsEnabled, \'light-blue-800-fg\' : !rule.IsEnabled}\" md-font-icon=\"{{rule.IsEnabled ? \'icon-mouse-off\' : \'icon-mouse\'}}\"><md-tooltip>{{rule.IsEnabled ? \'Disable this rule\' : \'Enable this rule\'}}</md-tooltip></md-icon></span> <span ng-if=\"rule.IsSaving\"><md-icon class=\"blue-grey-300-fg\" style=\"font-size : 20px;\" md-font-icon=\"icon-delete\"></md-icon><md-icon class=\"blue-grey-300-fg\" style=\"font-size : 20px;\" md-font-icon=\"icon-eye\"></md-icon><md-icon class=\"blue-grey-300-fg\" style=\"font-size : 20px;\" md-font-icon=\"{{rule.IsEnabled ? \'icon-mouse-off\' : \'icon-mouse\'}}\"></md-icon></span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/generalSettings/generalSettings.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center pb-20\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"content\" flex=\"\"><div class=\"form-wrapper white-bg md-whiteframe-2dp\"><h2>{{\'GENERAL_SETTINGS.COMPANY_CODE_SETTINGS\' | translate}}</h2><div layout=\"row\" layout-wrap=\"\"><md-input-container><label translate=\"GENERAL_SETTINGS.COMPANY_CODE_FORMAT\"></label><md-select placeholder=\"{{\'GENERAL_SETTINGS.SELECT_A_SETTING\' | translate}}\" ng-model=\"vm.companyCodeFormat\" ng-model-options=\"{trackBy : \'$value.Id\'}\" required=\"\" name=\"CompanyCodeFormat\"><md-option ng-repeat=\"companyCodeFormat in vm.companyCodeFormats.Result\" ng-value=\"companyCodeFormat.Id\">{{ companyCodeFormat.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox ng-model=\"vm.requireCompanyCode\" ng-disabled=\"vm.requireCompanyCode\">{{\'GENERAL_SETTINGS.REQUIRE_COMPANY_CODE\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.saveCompanySettings()\"></md-button><div ng-if=\"vm.faledToSaveCompanySettings\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save the feature flags.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\" ng-if=\"vm.canUpdatePayrollCsvExportFormat || vm.canUpdateBillingCsvExportFormat\"><h2>{{\'GENERAL_SETTINGS.CSV_EXPORTS\' | translate}}</h2><div layout=\"row\" layout-wrap=\"\" ng-if=\"vm.canUpdatePayrollCsvExportFormat\"><md-input-container><label translate=\"GENERAL_SETTINGS.CSV_PAYROLL_EXPORT_FORMAT\"></label><md-select placeholder=\"{{\'GENERAL_SETTINGS.SELECT_A_SETTING\' | translate}}\" ng-model=\"vm.payrollCsvFormat\" required=\"\" name=\"PayrollCsvFormat\"><md-option ng-repeat=\"csvSystem in vm.payrollCsvExportFormats\" ng-value=\"csvSystem.Key\">{{ csvSystem.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"vm.canUpdateBillingCsvExportFormat\"><md-input-container><label translate=\"GENERAL_SETTINGS.CSV_INVOICE_EXPORT_FORMAT\"></label><md-select placeholder=\"{{\'GENERAL_SETTINGS.SELECT_A_SETTING\' | translate}}\" ng-model=\"vm.billingCsvFormat\" required=\"\" name=\"BillingCsvFormat\"><md-option ng-repeat=\"csvSystem in vm.billingCsvExportFormats\" ng-value=\"csvSystem.Key\">{{ csvSystem.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.saveCsvExportSettings()\"></md-button><div ng-if=\"vm.faledToSaveCsvExportSettings\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save the feature flags.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\"><h2>{{\'GENERAL_SETTINGS.MOBILE_SETTINGS\' | translate}}</h2><div layout=\"row\" layout-wrap=\"\" ng-repeat=\"feature in vm.features | orderBy : \'displayName\'\" ng-if=\"feature.featureKey == \'EnableWorkOrderNumberEditingInMobile\'\"><md-checkbox ng-model=\"feature.isEnabled\" ng-checked=\"feature.isEnabled\">{{feature.displayName}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\" ng-repeat=\"feature in vm.features | orderBy : \'displayName\'\" ng-if=\"feature.featureKey == \'RequireGpsCoordinatesForUploadedFiles\'\"><md-checkbox ng-model=\"feature.isEnabled\" ng-checked=\"feature.isEnabled\">{{feature.displayName}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.saveMobileSettings()\"></md-button><div ng-if=\"vm.failedToSaveMobileSettings\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save the mobile settings.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\"><h2>{{\'GENERAL_SETTINGS.MOBILE_TIMESHEET_SETTINGS\' | translate}}</h2><div layout=\"row\" layout-wrap=\"\"><md-input-container><label translate=\"GENERAL_SETTINGS.MOBILE_TIMESHEET_INTERVAL\"></label><md-select placeholder=\"{{\'GENERAL_SETTINGS.SELECT_A_TIME_INTERVAL\' | translate}}\" ng-model=\"vm.MobileTimesheetInterval\" required=\"\" name=\"TimesheetInterval\"><md-option ng-repeat=\"timesheetInterval in vm.timesheetIntervals\" ng-value=\"timesheetInterval\">{{ timesheetInterval }}</md-option></md-select></md-input-container></div><div layout=\"column\"><md-input-container flex=\"\"><md-checkbox ng-checked=\"vm.MobileTimesheetRequireWorkOrderNumber\" ng-model=\"vm.MobileTimesheetRequireWorkOrderNumber\" id=\"MobileTimesheetRequireWorkOrderNumber\">{{\'GENERAL_SETTINGS.MOBILE_REQUIRE_WORK_ORDER_NUMBER\' | translate}}</md-checkbox><div class=\"override-instruction\"><label class=\"require-work-order\" translate=\"GENERAL_SETTINGS.MOBILE_REQUIRE_WORK_ORDER_NUMBER_NOTE\"></label></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.saveMobileTimesheetSettings()\"></md-button><div ng-if=\"vm.failedToSaveMobileTimesheetSettings\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save the mobile timesheet settings.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\" ng-if=\"vm.isAppSupportUser\"><h2>{{\'GENERAL_SETTINGS.AUTHENTICATION_SETTINGS\' | translate}}</h2><div layout=\"row\" layout-wrap=\"\"><md-input-container><label translate=\"GENERAL_SETTINGS.EXTERNAL_AUTHENTICATION_PROVIDER\"></label><md-select ng-model=\"vm.externalAuthenticator\" required=\"\" name=\"ExternalAuthenticators\"><md-option ng-repeat=\"externalAuthenticator in vm.externalAuthenticators\" ng-value=\"externalAuthenticator\">{{ externalAuthenticator }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox ng-model=\"vm.allowLoginWithAlloc8ForAllUsers\" ng-show=\"vm.externalAuthenticator!=\'None\'\">{{\'GENERAL_SETTINGS.ALLOW_LOGIN_WITH_ALLOC8_ALL_USERS\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.saveAuthenticationSettings()\"></md-button><div ng-if=\"vm.failedToSaveAuthenticationSettings\" class=\"failed-to-save-setting\"><div>{{\'GENERAL_SETTINGS.AUTHENTICATION_SETTINGS_FAILED_MSG\' | translate}}</div><div>{{\'GENERAL_SETTINGS.PLEASE_TRY_AGAIN_MSG\' | translate }}</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\"><h2>{{\'GENERAL_SETTINGS.INVOICE.TITLE\' | translate}}</h2><div layout=\"row\" layout-wrap=\"\"><md-checkbox ng-model=\"vm.enableViewInvoiceButtonAfterAllCompanySucceeded\">{{\'GENERAL_SETTINGS.INVOICE.VIEW_INVOICE_AFTER_ALL_SUCCESS\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"vm.isAppSupportUser\"><md-checkbox ng-model=\"vm.enablePaymentClaim\">{{\'GENERAL_SETTINGS.INVOICE.ENABLE_PAYMENT_CLAIM\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"vm.isAppSupportUser\"><md-checkbox ng-model=\"vm.showEmployeeNamesOnInvoices\">{{\'GENERAL_SETTINGS.INVOICE.SHOW_EMPLOYEE_NAMES_ON_INVOICES\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.saveInvoiceSettings()\"></md-button><div ng-if=\"vm.failedToSaveInvoiceSettings\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save the invoice settings.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\" ng-if=\"vm.isPayrollEnabled\"><h2>{{\'GENERAL_SETTINGS.PAYROLL.TITLE\' | translate}}</h2><div layout=\"row\" layout-wrap=\"\" ng-repeat=\"feature in vm.features | orderBy : \'displayName\'\" ng-if=\"feature.featureKey == \'EnablePayrollGroups\'\"><md-checkbox ng-disabled=\"vm.hasPayrollIntegration\" ng-model=\"feature.isEnabled\" ng-checked=\"feature.isEnabled && !vm.hasPayrollIntegration\">{{feature.displayName}}</md-checkbox></div><span ng-show=\"vm.hasPayrollIntegration\" class=\"note-warning\" translate=\"GENERAL_SETTINGS.PAYROLL.PAYROLL_GROUP_WARNING\"></span><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.savePayrollSettings()\"></md-button><div ng-if=\"vm.failedToSavePayrollSettings\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save the payroll settings.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\" ng-if=\"vm.isAppSupportUser\"><h2>{{\'GENERAL_SETTINGS.SYSTEM_SETTINGS\' | translate}}</h2><div layout=\"row\" layout-wrap=\"\"><md-checkbox ng-model=\"vm.enableGoogleAnalytics\">{{\'GENERAL_SETTINGS.ENABLE_GOOGLE_ANALYTICS\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-input-container><label>Wijmo License Key</label> <input type=\"text\" name=\"WijmoLicenseKey\" ng-model=\"vm.wijmoLicenseKey\" style=\"font-weight: bold;\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-input-container><label>Language Code</label> <input type=\"text\" name=\"LanguageCode\" ng-model=\"vm.languageCode\" style=\"font-weight: bold;\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-input-container><label>Country Code</label> <input type=\"text\" name=\"CountryCode\" ng-model=\"vm.countryCode\" style=\"font-weight: bold;\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-input-container><label>OneDrive Client Id</label> <input type=\"text\" name=\"OneDriveClientId\" ng-model=\"vm.oneDriveClientId\" style=\"font-weight: bold;\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-input-container><label translate=\"GENERAL_SETTINGS.MEASUREMENT_FOR_DISTANCE\"></label><md-select ng-model=\"vm.measurementForDistance\" required=\"\" name=\"MeasurementForDistance\"><md-option ng-repeat=\"measurementType in vm.measurementTypes\" ng-value=\"measurementType\">{{ measurementType }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.saveSystemSettings()\"></md-button><div ng-if=\"vm.faledToSaveSystemSettings\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save the feature flags.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\" ng-if=\"vm.isAppSupportUser\"><h2>{{\'GENERAL_SETTINGS.FEATURES\' | translate}}</h2><div flex=\"\" layout-wrap=\"\" style=\"display: flex;\"><div layout=\"row\" layout-align=\"start center\" style=\"flex: 0 0 25%;\" ng-repeat=\"feature in vm.features | orderBy : \'displayName\'\" ng-if=\"feature.featureKey != \'EnablePayrollGroups\' && feature.featureKey != \'RequireGpsCoordinatesForUploadedFiles\' && feature.featureKey != \'EnableWorkOrderNumberEditingInMobile\'\"><md-checkbox ng-model=\"feature.isEnabled\">{{feature.displayName}}</md-checkbox><md-icon ng-if=\"feature.featureKey == \'EnableSurcharges\'\" md-svg-icon=\"icon-info\" class=\"s16 ml-4\" aria-label=\"{{\'GENERAL_SETTINGS.ENABLE_SURCHARGES_HELP\' | translate}}\"><md-tooltip md-direction=\"right\">{{\'GENERAL_SETTINGS.ENABLE_SURCHARGES_HELP\' | translate}}</md-tooltip></md-icon></div></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.saveFeatures()\"></md-button><div ng-if=\"vm.faledToSaveFeatures\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save the feature flags.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div class=\"form-wrapper white-bg md-whiteframe-2dp\"><h2>{{\'GENERAL_SETTINGS.PAPERWORK_SETTINGS\' | translate}}</h2><div layout=\"column\" layout-wrap=\"\"><label class=\"mb-20\" translate=\"GENERAL_SETTINGS.PAPERWORK_SHIFT_TOTAL\"></label><div layout=\"row\"><label flex=\"10\">Break Time</label> <label flex=\"3\">exclude</label><md-switch flex=\"3\" class=\"md-secondary m-0\" ng-model=\"vm.includeBreakTime\" style=\"margin-top: -5px;\"></md-switch><label flex=\"10\">include</label></div><div layout=\"row\"><label flex=\"10\">Travel Time</label> <label flex=\"3\">exclude</label><md-switch flex=\"3\" class=\"md-secondary m-0\" ng-model=\"vm.includeTravelTime\" style=\"margin-top: -5px;\"></md-switch><label flex=\"10\" class=\"flex-10\">include</label></div><div layout=\"row\" ng-if=\"vm.claimsUtilService.isLoadTimeEnabled()\"><label flex=\"10\">Load Time</label> <label flex=\"3\">exclude</label><md-switch flex=\"3\" class=\"md-secondary m-0\" ng-model=\"vm.includeLoadTime\" style=\"margin-top: -5px;\"></md-switch><label flex=\"10\">include</label></div><div layout=\"row\" ng-if=\"vm.claimsUtilService.isShopTimeEnabled()\"><label flex=\"10\">Shop Time</label> <label flex=\"3\">exclude</label><md-switch flex=\"3\" class=\"md-secondary m-0\" ng-model=\"vm.includeShopTime\" style=\"margin-top: -5px;\"></md-switch><label flex=\"10\" class=\"flex-10\">include</label></div></div><div layout=\"column\"><md-input-container flex=\"\"><md-checkbox ng-checked=\"vm.hideNotesInTicketPDF\" ng-model=\"vm.hideNotesInTicketPDF\" id=\"hideNotesInTicketPDF\">{{\'GENERAL_SETTINGS.HIDE_NOTES_IN_TICKET_PDF\' | translate}}</md-checkbox><div class=\"override-instruction\"><label id=\"label-hide-notes-in-ticket-pdf\" translate=\"GENERAL_SETTINGS.HIDE_NOTES_IN_TICKET_PDF_DESCRIPTION\"></label></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox ng-model=\"vm.hideGpsOnTimesheetPdf\">{{\'GENERAL_SETTINGS.HIDE_GPS_ON_TIMESHEET_PDF\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox ng-model=\"vm.hideImageGpsOnPaperworkPdf\">{{\'GENERAL_SETTINGS.HIDE_IMAGE_GPS_ON_PAPERWORK_PDF\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-button translate=\"GENERAL_SETTINGS.SAVE\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme ml-0\" ng-click=\"vm.savePaperworkSettings()\"></md-button><div ng-if=\"vm.failedToSavePaperworkSettings\" class=\"failed-to-save-setting\"><div>Something went wrong while trying to save paperwork settings.</div><div>Please try again. If problem persists contact Alloc8 support.</div></div></div></div><div layout=\"row\" class=\"timesheet-headings\" ng-if=\"vm.isPayrollEnabled\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'GENERAL_SETTINGS.TIMESHEET_HEADINGS\' | translate}}</h3></md-card-header-text><div flex=\"\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.launchTimesheetHeadings()\">{{\'GENERAL_SETTINGS.TIMESHEET_HEADINGS_ADD_BUTTON\' | translate}}</md-button></div></md-card-header><md-card-content class=\"m-0\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'GENERAL_SETTINGS.TIMESHEET_HEADINGS_NAME\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'GENERAL_SETTINGS.TIMESHEET_HEADINGS_CODES\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'GENERAL_SETTINGS.TIMESHEET_HEADINGS_DISPLAY_ORDER\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'GENERAL_SETTINGS.TIMESHEET_HEADINGS_ACTIONS\' | translate}}</th></thead><tbody><tr ng-repeat=\"timesheet in vm.payrollSettings.TimesheetHeadersAndCodes track by $index\"><td class=\"text-left\">{{timesheet.Name}}</td><td class=\"text-left header-codes\">{{ vm.getHeaderCodes(timesheet.HeaderCodes)}}</td><td class=\"text-left\">{{timesheet.DisplayOrder}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.launchTimesheetHeadings(timesheet, $index)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>{{\'GENERAL_SETTINGS.TIMESHEET_HEADINGS_EDIT\' | translate}}</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeTimesheetHeading(timesheet)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span>{{\'GENERAL_SETTINGS.TIMESHEET_HEADINGS_DELETE\' | translate}}</span></md-tooltip></md-button></td></tr></tbody></table></md-card-content></md-card></div></div></div></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"content white-bg\"><div class=\"mb-20 pv-2 ph-2\"><div layout=\"row\" layout-lt-lg=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><div flex=\"\" layout=\"row\"><md-input-container flex=\"\"><label translate=\"DASHBOARD.BRANCHES\"></label><md-select ng-model=\"vm.searchCriteria.Branches\" placeholder=\"{{\'DASHBOARD.BRANCHES\'| translate}}\" ng-change=\"vm.filterChange = true\" md-on-open=\"vm.filterChange = false\" md-on-close=\"vm.getNewData()\" multiple=\"\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch.id\" ng-repeat=\"branch in vm.lookups.branches\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"\" layout=\"row\"><md-input-container ng-if=\"vm.showDivisionFilter\" flex=\"\"><label translate=\"DASHBOARD.DIVISIONS\"></label><md-select ng-model=\"vm.searchCriteria.Divisions\" placeholder=\"{{\'DASHBOARD.DIVISIONS\'| translate}}\" ng-change=\"vm.saveFilters()\"><md-optgroup label=\"Divisions\"><md-option ng-value=\"\'-1\'\">All</md-option><md-option ng-value=\"\'0\'\">No Division</md-option><md-option ng-value=\"division.id\" ng-repeat=\"division in vm.lookups.divisions\">{{division.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div></div><div class=\"container\"><packery gutter=\"32\" draggable=\"false\" id=\"dragd-pckry\"><packery-object id=\"{{widget.Id}}\" block-ui=\"block-{{widget.Id}}\" ng-repeat=\"widget in vm.dashboardService.userWidgets\" class=\"row dragd {{ widget.Classes || \'\' }}\" ng-class=\"{ \'col-3\': widget.Type.Name === \'Number\', \'col-6\': widget.Type.Name === \'Tabular\', \'col-12\': widget.Type.Name === \'Bar\', \'h-x2\': widget.Type.Name === \'Tabular\', \'h-x3\': widget.Type.Name === \'Bar\' }\" style=\"z-index: 5;\"><widget-template widget=\"{{widget}}\"></widget-template></packery-object></packery></div></div></div>");
$templateCache.put("app/main/integrations/integrations.html","<div class=\"integrations\"><div><integrations-tabs on-tab-selected=\"vm.onTabSelected(selectedTabName)\"></integrations-tabs></div><div ng-if=\"vm.selectedTabName === vm.tabNames.settings\"><integrations-settings></integrations-settings></div><div ng-if=\"vm.selectedTabName === vm.tabNames.history\"><history-log-page get-logs=\"vm.getLogs()\"></history-log-page></div></div>");
$templateCache.put("app/main/messagingFormat/messaging-format.controller.html","<div class=\"page-layout simple fullwidth message-format\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><div layout=\"row\"><div flex=\"70\"><div flex=\"\"><form name=\"messageFormatForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div layout=\"row\" layout-wrap=\"\" class=\"md-accordion pb-30\" ng-repeat=\"template in messagingFormat.messageTemplatesLookup track by $index\"><md-toolbar class=\"toolbar-header\" ng-init=\"data.expanded = true\" ng-click=\"data.expanded = !data.expanded\"><div class=\"md-toolbar-tools\"><h2><label flex=\"100\" class=\"md-body-2\">{{ template.Type.Value }}</label></h2><span flex=\"\"></span> <span ng-class=\"{expandCollapse:true, active:data.expanded}\"></span></div></md-toolbar><md-input-container layout=\"column\" ng-class=\"{dataContent:true, activeContent:data.expanded}\"><textarea name=\"payrollSuperannuationCodes\" ng-model=\"messagingFormat.messageFormatModel[template.Type.Key]\" ng-focus=\"messagingFormat.changeMessageFormatFocus(template.Type.Key)\" id=\"{{template.Type.Key}}\" max-rows=\"5\">\r\n                                            </textarea><md-dialog-actions layout=\"row\" class=\"btn-save-message\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"messagingFormat.saveMessageFormat(template.Type.Key, template.Id)\">{{\'MESSAGE_FORMAT.BTN_SAVE\' | translate}}</md-button></md-dialog-actions></md-input-container></div></div></form></div></div><div flex=\"30\"><div flex=\"\"><div class=\"form-wrapper flex-100\"><div layout=\"row\" layout-wrap=\"\"><fieldset class=\"standard\" flex=\"100\"><legend><h2 flex=\"100\">{{\'MESSAGE_FORMAT.FIELDS_HEADER\' | translate}}</h2></legend><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"field in messagingFormat.messageFieldsLookup\" ng-click=\"messagingFormat.addMessagingFormatField(field.Key)\"><div class=\"md-list-item-text\"><h3>{{ field.Value }}</h3></div></md-list-item></md-list></fieldset></div></div></div></div></div></md-card></div></div></div></div>");
$templateCache.put("app/main/paperWorkConfigurationOptions/paperWorkConfigurationOptions.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"toolbar md-whiteframe-2dp\" ng-if=\"vm.is_loading\"><div class=\"toolbar-wrapper\"></div></div><div class=\"content\" flex=\"\" layout=\"row\"><form name=\"configOptions\" flex=\"\" layout=\"row\" layout-align=\"center Start\" a8-dirty-form-confirmation=\"\"><div layout=\"column\" layout-padding=\"\" layout-margin=\"\" class=\"white-bg md-whiteframe-4dp\" flex=\"50\" flex-lg=\"70\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><md-progress-linear style=\"padding : 0px;margin : 0px;\" ng-if=\"vm.is_loading\" md-mode=\"indeterminate\"></md-progress-linear><div flex=\"\"><config-large-header length=\"vm.list.length\" ng-if=\"!vm.media.isDeviceSmall()\"></config-large-header><config-small-header ng-if=\"vm.media.isDeviceSmall()\"></config-small-header></div><md-progress-linear ng-if=\"vm.is_loading\" md-mode=\"query\"></md-progress-linear><md-divider></md-divider><div dimmer=\"\" ng-model=\"vm.is_loading\" class=\"margin-top-0\" layout=\"column\" flex=\"\"><div ng-style=\"{\'margin-top\' : (vm.media.isDeviceBetweenConfigOptions()) ? \'-10px\' : \'0px\'}\" layout=\"column\" flex=\"\" ng-repeat=\"item in vm.list\"><div layout-align=\"center start\" layout-margin=\"\" flex=\"\"><config-large-view item=\"item\" class=\"border-bottom\"></config-large-view></div></div><div style=\"margin-top : 20px\" layout=\"row\" layout-align=\"end center\"><span><md-button translate=\"PAPERWORK_CONFIG.SAVE\" ng-if=\"!vm.is_loading\" ng-click=\"vm.save(vm.list)\" ng-disabled=\"configOptions.$invalid || vm.list.length === 0\" class=\"md-accent md-raised\"></md-button></span></div></div></div></form></div></div></div>");
$templateCache.put("app/main/paperworkExceptions/paperwork-exceptions-main.html","<div id=\"job-messaging\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-lg\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/paperworkExceptions/sidenav/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div ng-if=\"vm.media.showFilter()\" layout=\"row\" layout-align=\"start center\" style=\"position: absolute; top: 1em;\"><md-button class=\"md-icon-button\" aria-label=\"Toggle Sidenav\" ng-click=\"vm.openFilter()\" translate=\"\" translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" style=\"color : #333;\" md-font-icon=\"icon-filter\"></md-icon></md-button></div><paper-work-exceptions-main-view class=\"content-card classic\" refresh=\"vm.refreshList()\" is-busy=\"vm.is_loading\" filter=\"vm.clientFilter(id)\" loader-message=\"vm.loader_message\" grid-data=\"vm.grid_data\" layout=\"column\" flex=\"\"></paper-work-exceptions-main-view></div></div>");
$templateCache.put("app/main/payrollGroups/payroll-group.html","<div id=\"payroll-group-view\"><div class=\"toolbar md-whiteframe-2dp search-container\"><div class=\"toolbar-wrapper\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.query\" type=\"text\" ng-keyup=\"vm.searchTable()\" placeholder=\"Search\" translate=\"\" translate-attr-placeholder=\"PAYROLL_GROUPS.SEARCH\"></div></div></div><div class=\"payroll-group-page page-layout simple mr-20 ml-20 mt-20\" layout=\"column\"><div class=\"content\" layout=\"column\"><div class=\"\" layout=\"row\"><div class=\"card md-whiteframe mt-20\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-button class=\"md-fab md-mini md-accent pull-right btn-add\" ng-if=\"vm.hasManagePayrollGroupsPermission\" ng-click=\"vm.add()\"><md-icon class=\"icon-plus\"></md-icon></md-button><md-card-content class=\"m-0\"><table class=\"dataTable row-border hover manage-tags-table\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">{{\'PAYROLL_GROUPS.TABLE_HEADER_PAYROLL_GROUP\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'PAYROLL_GROUPS.TABLE_HEADER_ACTIONS\' | translate}}</span></div></th></thead><tbody><tr ng-repeat=\"payrollGroup in vm.service.payrollGroups track by $index\"><td class=\"text-left\">{{payrollGroup.Name}}</td><td class=\"text-left\"><md-button class=\"md-icon-button md-primary action-button\" ng-if=\"vm.hasManagePayrollGroupsPermission\" ng-click=\"vm.update(payrollGroup)\"><i class=\"icon icon-pencil ${editIconColor} s15\"><md-tooltip>{{\'PAYROLL_GROUPS.EDIT\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.showHistoryLog(payrollGroup.Id, payrollGroup.Name)\"><i class=\"icon icon-history orange-500-fg s15\"><md-tooltip>{{\'PAYROLL_GROUPS.VIEW_HISTORY\' | translate}}</md-tooltip></i></md-button></td></tr></tbody></table></md-card-content></md-card></div></div></div></div></div>");
$templateCache.put("app/main/rateCardSettings/rateCardSettings.html","<div class=\"page-layout simple fullwidth\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-content class=\"md-padding\"><md-nav-bar md-no-ink-bar=\"disableInkBar\" md-selected-nav-item=\"rateCard.currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"rateCard.showAllowances()\" aria-selected=\"{{rateCard.showAllowancesPanel}}\" name=\"allowances\">{{\'RATECARD_V2.MAIN_NAV_ALLOWANCES\' | translate}}</md-nav-item><md-nav-item md-nav-click=\"rateCard.showTimesheets()\" aria-selected=\"{{rateCard.showTimesheetsPanel}}\" name=\"timesheets\">{{\'RATECARD_V2.MAIN_NAV_TIMESHEET\' | translate}}</md-nav-item><md-nav-item md-nav-click=\"rateCard.showPackages()\" aria-selected=\"{{rateCard.showPackagesPanel}}\" name=\"packages\">{{\'RATECARD_V2.MAIN_NAV_PACKAGES\' | translate}}</md-nav-item></md-nav-bar></md-content></div></div><div class=\"content\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><div ng-view=\"\"></div><div ui-view=\"content@allowances\" ng-if=\"rateCard.showAllowancesPanel\" ng-cloak=\"\"></div><div ui-view=\"content@timesheets\" ng-if=\"rateCard.showTimesheetsPanel\" ng-cloak=\"\"></div><div ui-view=\"content@packages\" ng-if=\"rateCard.showPackagesPanel\" ng-cloak=\"\"></div></div></div></div>");
$templateCache.put("app/main/ratecards/ratecards.html","<div class=\"page-layout simple fullwidth\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-content class=\"md-padding\"><md-nav-bar md-no-ink-bar=\"disableInkBar\" md-selected-nav-item=\"rateCard.currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"rateCard.showManage()\" aria-selected=\"{{rateCard.showManagePanel}}\" name=\"manage\">{{\'RATECARDS.MAIN_NAV_INDEX\' | translate}}</md-nav-item><md-nav-item md-nav-click=\"rateCard.showPricing()\" aria-selected=\"{{rateCard.showPricingPanel}}\" name=\"pricing\">{{\'RATECARDS.MAIN_NAV_PRICING\' | translate}}</md-nav-item></md-nav-bar></md-content></div></div><div class=\"content\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><div ng-view=\"\"></div><div ui-view=\"content@manage\" ng-if=\"rateCard.showManagePanel\"></div><div ui-view=\"content@pricing\" ng-if=\"rateCard.showPricingPanel\" ng-cloak=\"\"></div></div></div></div>");
$templateCache.put("app/main/smartScheduling/allocation-dialog.html","<md-dialog aria-label=\"Allocate with Scheduling Copilot\" flex=\"40\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Allocate with Scheduling Copilot</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"></md-button></div></md-toolbar><md-dialog-content><div style=\"padding-bottom: 5px\">Select resources that will be included in Scheduling Copilot</div><md-card aria-label=\"People\" ng-hide=\"vm.people.length == 0\" flex=\"\"><md-card-content><md-checkbox flex=\"\" ng-model=\"isAllPeopleChecked\" ng-change=\"vm.checkAllPeople()\">All People</md-checkbox><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" ng-repeat=\"person in vm.people\"><md-checkbox ng-model=\"person.isSelected\" ng-change=\"vm.checkPerson(person)\">{{person.ItemNameDisplay}}</md-checkbox></div></div></md-card-content></md-card><md-card aria-label=\"Equipment\" ng-hide=\"vm.equipments.length == 0\" flex=\"\"><md-card-content><md-checkbox flex=\"\" ng-model=\"isAllEquipmentsChecked\" ng-change=\"vm.checkAllEquipments()\">All Equipment</md-checkbox><div layout=\"row\" layout-wrap=\"\"><div flex=\"33\" ng-repeat=\"equipment in vm.equipments\"><md-checkbox ng-model=\"equipment.isSelected\" ng-change=\"vm.checkEquipment(equipment)\">{{equipment.ItemNameDisplay}}</md-checkbox></div></div></md-card-content></md-card></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.cancel()\">Cancel</md-button><md-button ng-click=\"vm.proceed()\" class=\"md-raised md-accent\" ng-disabled=\"vm.resourcesToAllocate.length <= 0\">Proceed</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tags/tags.html","<div class=\"tags-page page-layout simple flex-50 ml-20 mt-20\" layout=\"column\"><div class=\"content\" layout=\"column\"><h3 class=\"md-title m-0 ml-10\">{{\'TAGS.LABEL_TAGS\' | translate}}</h3><div class=\"\" layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header class=\"pb-0\"><div flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"tagsCtrl.launchAddTag()\">{{\'TAGS.BUTTON_ADD_TAG\' | translate}}</md-button></div></md-card-header><md-card-content class=\"m-0\"><table class=\"dataTable row-border hover manage-tags-table\" datatable=\"ng\" dt-instance=\"tagsCtrl.dtInstance\" dt-options=\"tagsCtrl.dtOptions\"><thead><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAGS.TABLE_HEADER_TAG\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAGS.TABLE_HEADER_ACTIVE\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAGS.INCLUDE_IN_INVOICE_PDF\' | translate}}</span></div></th></thead><tbody><tr ng-repeat=\"tag in tagsCtrl.service.tags track by $index\" ng-class=\"{\'inactive\': !tag.IsActive}\"><td class=\"text-left\">{{tag.Name}}</td><td class=\"text-center\"><span class=\"hidden\">{{tag.IsActive}}</span><md-checkbox class=\"md-raised md-accent mt-0 mb-20 enable-checkbox\" ng-model=\"tag.IsActive\" ng-click=\"tagsCtrl.toggleIsActive(tag, $index)\"></md-checkbox></td><td class=\"text-center\"><span class=\"hidden\">{{tag.IncludeInInvoicePdf}}</span><md-checkbox class=\"md-raised md-accent mt-0 mb-20 enable-checkbox\" ng-model=\"tag.IncludeInInvoicePdf\" ng-disabled=\"!tag.IsActive\" ng-click=\"tagsCtrl.toggleIncludeInInvoicePdf(tag, $index)\"></md-checkbox></td></tr></tbody></table></md-card-content></md-card></div></div></div></div>");
$templateCache.put("app/main/tax/tax.html","<div class=\"center ms-scroll layout-column flex ps-container ps-theme-default ps-active-y\" layout=\"column\"><div class=\"content\" layout=\"column\"><toolbar-loader show=\"vm.service.loader\" message=\"vm.service.loaderMessage\"></toolbar-loader><div class=\"\" layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header class=\"pb-0\"><div layout=\"column\" layout-align=\"start stretch\" flex=\"100\"><div layout=\"row\" layout-gt-sm=\"row\" layout-align=\"start end\"><h3 class=\"md-title m-0 ml-10\" flex=\"100\">{{\'TAXRATES.HEADER\' | translate}}</h3><md-button class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.getTaxeshistory()\"><i class=\"icon icon-history orange-500-fg s15\"><md-tooltip>View History</md-tooltip></i></md-button></div><div layout=\"row\" layout-gt-sm=\"row\" layout-align=\"start start\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.createTaxRate()\">{{\'TAXRATES.ADD_BUTTON\' | translate}}</md-button></div></div></md-card-header><md-card-content class=\"m-0\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-instance=\"vm.dtInstance\"><thead><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAXRATES.TAX_NAME\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAXRATES.RATE\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAXRATES.APPLIED_TO\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAXRATES.ACTION\' | translate}}</span></div></th></thead><tbody><tr ng-repeat=\"tax in vm.taxes | orderBy : \'Name\' track by $index\" ng-class=\"\"><td class=\"text-left\">{{tax.Name}}</td><td class=\"text-left\">{{tax.Rate}}</td><td class=\"text-left\">{{tax.TaxApplyToName}}</td><td class=\"text-left\"><md-button class=\"md-icon-button\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\" ng-click=\"vm.editTaxRate(tax)\"><md-tooltip>Edit Tax</md-tooltip></md-icon></md-button><md-button class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.getTaxhistory(tax)\"><i class=\"icon icon-history orange-500-fg s15\"><md-tooltip>View History</md-tooltip></i></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.deleteTaxRate(tax)\" ng-disabled=\"vm.service.loader\"><i ng-class=\"{\'icon icon-trash s15\': vm.service.loader, \'icon icon-trash red-500-fg s15\': !vm.service.loader}\"><md-tooltip>Delete</md-tooltip></i></md-button></td></tr></tbody></table></md-card-content></md-card><md-card class=\"md-whiteframe-1dp\"><md-card-header class=\"pb-0\"><div layout=\"column\" layout-align=\"start stretch\" flex=\"100\"><div layout=\"row\" layout-gt-sm=\"row\" layout-align=\"start end\"><h3 class=\"md-title m-0 ml-10\" flex=\"100\">{{\'TAX_EXEMPTED_COMPANIES.HEADER\' | translate}}</h3></div><div layout=\"row\" layout-gt-sm=\"row\" layout-align=\"start start\"><md-autocomplete style=\"margin-top : 20px;\" flex=\"50\" md-no-cache=\"true\" md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.service.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(vm.service.searchText)\" md-item-text=\"item.Name\" md-min-length=\"0\" placeholder=\"Type a company\"><md-item-template><span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.Name}}</span></md-item-template><md-not-found>No matching companies found</md-not-found></md-autocomplete><md-button class=\"md-raised md-accent md-body-2\" style=\"margin : 20px;\" ng-click=\"vm.addTaxExemptCompany()\" ng-disabled=\"vm.service.loader\">{{\'TAX_EXEMPTED_COMPANIES.ADD_BUTTON\' | translate}}</md-button></div></div></md-card-header><md-card-content class=\"m-0\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtTaxExemptCompanyOptions\" dt-instance=\"vm.dtTaxExemptCompanyInstance\"><thead><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAX_EXEMPTED_COMPANIES.COMPANY_NAME\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAX_EXEMPTED_COMPANIES.COMPANY_CODE\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAX_EXEMPTED_COMPANIES.COMPANY_BRANCH\' | translate}}</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">{{\'TAX_EXEMPTED_COMPANIES.ACTION\' | translate}}</span></div></th></thead><tbody><tr ng-repeat=\"tax in vm.taxExemptCompanies track by $index\"><td class=\"text-left\">{{tax.Name}}</td><td class=\"text-left\">{{tax.CompanyCode}}</td><td class=\"text-left\"><span ng-repeat=\"branch in tax.Branches\">{{branch.Name}}<span ng-if=\"!$last\">,</span></span></td><td class=\"text-left\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeTaxExemptCompany(tax)\" ng-disabled=\"vm.service.loader\"><i ng-class=\"{\'icon icon-trash s15\': vm.service.loader, \'icon icon-trash red-500-fg s15\': !vm.service.loader}\"></i></md-button></td></tr></tbody></table></md-card-content></md-card></div></div></div></div>");
$templateCache.put("app/main/webhooks/webhooks.html","<div class=\"page-layout simple fullwidth element-doc-page webhooks\"><div ng-if=\"webhook.isLoading\" flex=\"\"><md-progress-linear class=\"md-hue-2\" md-mode=\"indeterminate\"></md-progress-linear></div><form name=\"webhooksForm\"><div ng-if=\"!webhook.isLoading\" class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent button-margin\" ng-click=\"webhook.saveWebhooks()\" ng-disabled=\"webhooksForm.$invalid\">{{\'WEBHOOKS.ACTION_SAVE\' | translate}}</md-button></div></div><div ng-if=\"!webhook.isLoading\" class=\"content\" layout=\"column\"><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-content class=\"m-0\"><div class=\"form-wrapper flex-100\"><h5 class=\"md-title m-0\">{{\'WEBHOOKS.LABEL_SECRET_KEY\' | translate}}</h5><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><input name=\"SecretKey\" id=\"SecretKey\" ng-model=\"webhook.data.SecretKey\" required=\"\"><div ng-messages=\"webhooksForm.SecretKey.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div></div><div class=\"form-wrapper flex-100\"><h5 class=\"md-title m-0\">{{\'WEBHOOKS.LABEL_TECHNICAL_EMAIL\' | translate}}</h5><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><input name=\"TechnicalContactEmail\" ng-model=\"webhook.data.TechnicalContactEmail\" type=\"email\" required=\"\"><div ng-messages=\"webhooksForm.TechnicalContactEmail.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"email\">Invalid email!</div></div></md-input-container></div></div></md-card-content></md-card><md-card class=\"md-whiteframe-1dp\"><md-card-content class=\"m-0 p-0\"><form name=\"webhooksForm\"><div class=\"form-wrapper flex-100\" ng-repeat=\"module in webhook.moduleEnums track by $index\" ng-init=\"$moduleIndex = webhook.getModuleIndex(module.Module);\"><md-toolbar class=\"toolbar-header\"><div class=\"md-toolbar-tools\"><h3 class=\"md-title mb-0\">{{ module.ModuleName }}</h3></div></md-toolbar><div class=\"layout-gt-sm-row layout-row\" ng-if=\"module.EntityTypes\"><md-input-container><md-select placeholder=\"Select Entity Type\" ng-model=\"module.formEntityTypes\" multiple=\"\"><md-option ng-repeat=\"entity in module.EntityTypes\" ng-value=\"entity.Id\" ng-selected=\"webhook.isEntitySelected(entity.Id, $moduleIndex)\">{{ entity.Name }}</md-option></md-select></md-input-container></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"module.isSameEndpoint\">{{\'WEBHOOKS.LABEL_SAME_ENDPOINT\' | translate}}</md-checkbox></md-input-container></div><div class=\"form-wrapper flex-100 p-0\" ng-if=\"module.isSameEndpoint\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label class=\"md-title m-0\">{{\'WEBHOOKS.LABEL_ENDPOINT\' | translate}}</label> <input name=\"commonUrl\" ng-model=\"module.commonUrl\" required=\"\"></md-input-container></div></div><div class=\"form-wrapper flex-100 p-0\" ng-if=\"!module.isSameEndpoint\"><div class=\"layout-gt-sm-row layout-row\" ng-repeat=\"endpoint in module.EndpointUrls track by $index\" ng-init=\"$urlIndex = webhook.getEndpointUrlIndex(endpoint.Id, $moduleIndex);\"><md-input-container layout=\"column\"><label class=\"md-title m-0\">{{ endpoint.Name }} Endpoint</label> <input ng-model=\"module.EndpointUrls[$urlIndex].Url\"></md-input-container></div></div></div></form></md-card-content></md-card></div></div></div></form></div>");
$templateCache.put("app/quick-panel/tabs/todo/todo-tab.html","<div class=\"main animate-slide-left\"><md-list class=\"recent\"><md-subheader class=\"md-no-sticky\" ng-show=\"vm.notifications.length > 0\"><span class=\"subheader\" translate=\"QUICKPANEL.UNREAD\">Unread</span> <a href=\"\" ng-click=\"vm.dismissAll()\" role=\"button\" ng-disabled=\"vm.hasUnreadData\">Dismiss all</a><div ng-if=\"vm.model.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div></md-subheader><md-list-item class=\"contact md-2-line unread\" ng-repeat=\"notification in vm.notifications| orderBy: \'NotificationDate\': true\" ng-click=\"vm.openNotification(notification)\"><div class=\"md-list-item-text\" layout=\"column\"><p class=\"last-message\">{{notification.Message}}</p><p class=\"datestamp\"><small>{{vm.getTimeAgo(notification.NotificationDate)}}</small></p></div><md-divider inset=\"\"></md-divider></md-list-item></md-list><md-divider ng-show=\"vm.notifications.length > 0\"></md-divider><div layout=\"row\" layout-align=\"center center\" class=\"grey-A100-bg margin-left-10 margin-right-10 padding-5\" ng-show=\"vm.notifications.length <= 0 && vm.readNotifications.length <= 0\"><div>You don\'t have any notifications yet.</div></div><md-list class=\"recent\"><md-subheader class=\"md-no-sticky\" ng-show=\"vm.readNotifications.length > 0\"><span class=\"subheader\" translate=\"QUICKPANEL.READ\">Read</span></md-subheader><md-list-item class=\"contact md-2-line\" ng-repeat=\"readNotification in vm.readNotifications| orderBy: \'NotificationDate\': true| limitTo: 20\" ng-click=\"vm.routeNotification(readNotification)\"><div class=\"md-list-item-text\" layout=\"column\"><p class=\"last-message\">{{readNotification.Message}}</p><p class=\"datestamp\"><small>{{vm.getTimeAgo(readNotification.NotificationDate)}}</small></p></div><md-divider inset=\"\"></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/shared/widgets/a8ActionPanel/a8ActionPanel.html","<section><div ng-show=\"actionPanelVm.model.isBusy\" layout-md=\"row\" layout=\"start start\" ng-cloak=\"\"><div flex=\"5\"><md-progress-circular class=\"md-accent md-hue-1\" md-mode=\"indeterminate\" md-diameter=\"60\"></md-progress-circular></div><div layout-padding=\"\" layout-margin=\"\"><span class=\"md-body-2\">{{actionPanelVm.model.message}}</span></div></div><ng-transclude ng-show=\"actionPanelVm.model.showTransclude\" ng-cloak=\"\"></ng-transclude></section>");
$templateCache.put("app/shared/widgets/a8Component_company_address/address-searchbox.html","<input type=\"text\" placeholder=\"Search\">");
$templateCache.put("app/shared/widgets/a8Component_company_address/address.html","<md-dialog aria-label=\"{{vm.title}}\" flex=\"40\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"searchbox-wrapperx\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"25\"><label>Address Type</label><md-select ng-model=\"vm.address.AddressType\" ng-model-options=\"{trackBy: \'$value.Id\'}\"><md-option ng-repeat=\"addressType in vm.addressTypes\" ng-value=\"addressType\">{{addressType.TypeName}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><div id=\"contactAddress-container\" class=\"searchbox-container\"></div></md-input-container></div><div class=\"searchbox-wrapperx\"><md-input-container class=\"md-block\" flex=\"\" layout-align=\"start center\"><md-button class=\"md-primary md-hue-1\" style=\"color: #fff;margin-top: -6px;\" aria-label=\"Use Android\" ng-click=\"vm.onShowExtraFields()\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon><md-tooltip>Input custom address</md-tooltip></md-button></md-input-container></div></div><div ng-show=\"vm.menu\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input type=\"text\" name=\"bldgName\" ng-model=\"vm.address.BldgName\" placeholder=\"Building Name\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input type=\"text\" name=\"streetNumber\" ng-model=\"vm.address.StreetNumber\" placeholder=\"Street Number\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"\"><input type=\"text\" name=\"streetName\" ng-model=\"vm.address.StreetName\" placeholder=\"Street Name\"></md-input-container><md-input-container flex-gt-sm=\"\"><input type=\"text\" name=\"city\" ng-model=\"vm.address.City\" placeholder=\"City\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"\"><input type=\"text\" name=\"state\" ng-model=\"vm.address.State\" placeholder=\"State\"></md-input-container><md-input-container flex-gt-sm=\"\"><input type=\"text\" name=\"postalCode\" ng-model=\"vm.address.PostCode\" placeholder=\"Postal Code\"></md-input-container></div></div><div style=\"display: none\"><ui-gmap-google-map center=\"map.center\" zoom=\"map.zoom\" draggable=\"true\" options=\"options\"><ui-gmap-search-box template=\"searchbox.template\" events=\"searchbox.events\" parentdiv=\"\'contactAddress-container\'\"></ui-gmap-search-box></ui-gmap-google-map></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onDone(vm.address)\" style=\"margin-right:20px;\">Done</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/a8Emails/a8Emails-view.html","<div class=\"main-style\"><div class=\"ms-responsive-table-wrapper\"><table class=\"simple kit-item-table\" ms-responsive-table=\"\"><tbody><tr ng-repeat=\"email in vm.ngModel\"><td width=\"80%\">{{email.EmailAddress}}<div><highlight-box ng-if=\"email.IsPrimary\" class=\"md-light-blue-800-bg\" content=\"Primary\"></highlight-box></div></td><td width=\"20%\"><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"vm.editEmail(email, $index)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'WIDGETS_LOC.SECTION\' | translate}}\"></delete-component></td></tr><tr><td style=\"padding-left: 0px;\"><add-button ng-click=\"vm.addEmail()\" title=\"Add Email Address\"></add-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/shared/widgets/a8Emails/a8EmailsDialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"20\" ng-cloak=\"\"><form name=\"emailForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"WIDGETS_LOC.PLACEHOLDER\"></label> <input type=\"email\" ng-pattern=\"vm.emailPattern\" name=\"emailItem\" ng-model=\"vm.emailAddress\" ng-maxlength=\"254\" required=\"\"><div ng-messages=\"emailForm.emailItem.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"email\"><span translate=\"WIDGETS_LOC.EMAIL_INVALID\"></span></div><div ng-message=\"maxlength\"><span translate=\"WIDGETS_LOC.EMAIL_MAX\"></span></div></div></md-input-container></div><div layout=\"row\" flex=\"\"><div layout-xs=\"column\" flex-xs=\"100\"><md-checkbox ng-model=\"vm.isPrimary\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"md-align-top-left\" flex=\"\">{{\'WIDGETS_LOC.IS_PRIMARY\' | translate}}</md-checkbox></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" translate=\"WIDGETS_LOC.SAVE\" ng-disabled=\"emailForm.$invalid\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/a8Header/a8Header.html","<div class=\"a8-header\" flex=\"auto\"><div class=\"header-text\" layout=\"row\" flex=\"auto\"><div layout=\"column\" layout-align=\"center center\" class=\"ml-24 page-title\">{{vm.headerText}} {{vm.headerVariable}}</div><div layout=\"column\" layout-align=\"center end\" flex=\"auto\" class=\"text-common mr-24\" ng-if=\"showEnvName\" ng-show=\"mediaQueryService.isDeviceSmall() || mediaQueryService.isDeviceMD()\">{{environmentName}}</div><div layout=\"column\" layout-align=\"center end\" flex=\"auto\" ng-if=\"showEnvName\" ng-hide=\"mediaQueryService.isDeviceSmall() || mediaQueryService.isDeviceMD()\" class=\"text-common mr-24\">{{environmentName}}</div></div></div>");
$templateCache.put("app/shared/widgets/a8HeaderWithSearch/a8-header-with-search.html","<div class=\"a8-header\" id=\"header-with-search\"><div style=\"height: 100px;\" layout=\"row\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\" flex=\"auto\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" type=\"text\" placeholder=\"{{\'REPORTING.SEARCH\' | translate}}\" ng-model=\"vm.srcData\" ng-model-options=\"{ debounce: 300 }\"></div></div></div></div>");
$templateCache.put("app/shared/widgets/a8Numbers/a8Numbers-view.html","<div><p class=\"md-subhead\" flex=\"100\">Numbers</p><div layout=\"column\" flex=\"100\"><a href=\"#\" ng-click=\"vm.addNumber()\">Add Number</a></div><br ng-if=\"vm.ngModel.length > 0\"><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th>Number</th><th>Number Type</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"number in vm.ngModel\" ng-if=\"vm.module == \'companies\'\"><td>{{number.Number}}</td><td>{{number.CompanyNumberType.TypeName}}</td><td><md-icon md-svg-icon=\"pencil\" ng-click=\"vm.editNumber(number, $index)\"><md-tooltip>Edit Number</md-tooltip></md-icon><delete-component index=\"$index\" tool-tip=\"Remove Number\" message=\"Are you sure you want to delete this item?\" callback=\"vm.remove\" section=\"Number\"></delete-component></td></tr><tr ng-repeat=\"number in vm.ngModel\" ng-if=\"vm.module == \'contacts\'\"><td>{{number.Number}}</td><td>{{number.ContactNumberType.TypeName}}</td><td><md-icon md-svg-icon=\"pencil\" class=\"teal-500-fg\" ng-click=\"vm.editNumber(number, $index)\"><md-tooltip>Edit Number</md-tooltip></md-icon><delete-component index=\"$index\" tool-tip=\"Remove Number\" message=\"Are you sure you want to delete this item?\" callback=\"vm.remove\" section=\"Number\"></delete-component></td></tr></tbody></table></md-card-content></md-card><br></div>");
$templateCache.put("app/shared/widgets/a8Numbers/a8NumbersDialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"25\" flex-md=\"50\" flex-sm=\"50\" ng-cloak=\"\"><form name=\"numberForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><label>Number Type</label><md-select ng-model=\"vm.numberType\" required=\"\" flex=\"\"><md-option ng-repeat=\"type in vm.contactTypes\" ng-value=\"type\" ng-selected=\"type.Selected\">{{type.TypeName}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label>Number</label> <input type=\"text\" ng-pattern=\"/^(\\d)+$/\" name=\"number\" ng-model=\"vm.number\" ng-maxlength=\"254\" required=\"\"><div ng-messages=\"numberForm.number.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"max\"><span>Allowable number of characters for Number is 254.</span></div><div ng-message=\"required\"><span>Number is required</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"numberForm.$invalid || vm.number == null || vm.numberType == null\" style=\"margin-right:20px;\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/a8PhoneNumbers/a8PhoneNumbers-view.html","<table class=\"simple kit-item-table\" ms-responsive-table=\"\"><tbody><tr ng-repeat=\"phone in vm.ngModel\"><td width=\"80%\">{{phone.Number}}<div><span class=\"highlight-box\">{{phone.PhoneType.TypeName}}</span> <span ng-if=\"phone.IsPrimary\" class=\"highlight-box-green\">Primary</span></div></td><td width=\"20%\"><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"vm.editNumber(phone, $index)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.PHONE_NUMBER_DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'WIDGETS_LOC.PHONE_NUMBER_DELETE_SECTION\' | translate}}\"></delete-component></td></tr><tr><td style=\"padding-left: 0px;\"><add-button ng-click=\"vm.addNumber()\" title=\"Add Phone Number\"></add-button></td></tr></tbody></table>");
$templateCache.put("app/shared/widgets/a8PhoneNumbers/a8PhoneNumbersDialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"20\" ng-cloak=\"\"><form name=\"numberForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><label translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_TYPE_PLACEHOLDER\"></label><md-select ng-model=\"vm.numberType\" required=\"\" flex=\"\"><md-option ng-repeat=\"type in vm.phoneTypes\" ng-value=\"type\" ng-selected=\"type.Selected\">{{type.TypeName}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_PLACEHOLDER\"></label> <input type=\"text\" name=\"number\" numeric-only=\"\" ng-model=\"vm.number\" ng-maxlength=\"15\" required=\"\"><div ng-messages=\"numberForm.number.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"max\"><span translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_ERROR_MESSAGE\"></span></div></div></md-input-container></div><div layout=\"row\" flex=\"\"><md-checkbox ng-model=\"vm.isPrimary\">{{\'WIDGETS_LOC.PHONE_NUMBER_DIALOG_IS_PRIMARY\' | translate}}</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"numberForm.$invalid || vm.number == null || vm.numberType == null\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/a8PhoneNumbers2/a8PhoneNumbers-view.html","<div layout=\"column\" flex=\"\"><p class=\"md-subhead\" flex=\"100\" translate=\"WIDGETS_LOC.PHONE_NUMBER_HEADER\"></p><div layout=\"column\" flex=\"100\"><a href=\"#\" ng-click=\"vm.addNumber()\" translate=\"WIDGETS_LOC.PHONE_NUMBER_HEADER_LINK\"></a></div><md-card id=\"email\" flex-xs=\"100\" flex=\"\" flex-gt-xs=\"90\" flex-sm=\"100\" flex-gt-sm=\"90\" flex-md=\"100\" flex-gt-md=\"50\"><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th translate=\"WIDGETS_LOC.PHONE_NUMBER_COLUMN_PHONE_NUMBER\"></th><th translate=\"WIDGETS_LOC.PHONE_NUMBER_COLUMN_PHONE_TYPE\"></th><th translate=\"WIDGETS_LOC.PHONE_NUMBER_COLUMN_PRIMARY\"></th><th translate=\"WIDGETS_LOC.PHONE_NUMBER_COLUMN_ACTIONS\"></th></tr></thead><tbody><tr ng-repeat=\"phone in vm.ngModel\"><td>{{phone.Number}}</td><td>{{phone.PhoneType.TypeName}}</td><td ng-bind=\"phone.IsPrimary === true ? (\'WIDGETS_LOC.PHONE_NUMBER_PRIMARY_YES\' | translate): (\'WIDGETS_LOC.PHONE_NUMBER_PRIMARY_NO\' | translate)\"></td><td><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"vm.editNumber(phone, $index)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.PHONE_NUMBER_DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'WIDGETS_LOC.PHONE_NUMBER_DELETE_SECTION\' | translate}}\"></delete-component></td></tr></tbody></table></md-card-content></md-card></div>");
$templateCache.put("app/shared/widgets/a8PhoneNumbers2/a8PhoneNumbersDialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"20\" ng-cloak=\"\"><form name=\"numberForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><label translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_TYPE_PLACEHOLDER\"></label><md-select ng-model=\"vm.numberType\" required=\"\" flex=\"\"><md-option ng-repeat=\"type in vm.phoneTypes\" ng-value=\"type\" ng-selected=\"type.Selected\">{{type.TypeName}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_PLACEHOLDER\"></label> <input type=\"text\" number-only=\"\" name=\"number\" ng-model=\"vm.number\" ng-maxlength=\"254\" required=\"\"><div ng-messages=\"numberForm.number.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"max\"><span translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_ERROR_MESSAGE\"></span></div></div></md-input-container></div><div layout=\"row\" flex=\"\"><md-checkbox ng-model=\"vm.isPrimary\">{{\'WIDGETS_LOC.PHONE_NUMBER_DIALOG_IS_PRIMARY\' | translate}}</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"numberForm.$invalid || vm.number == null || vm.numberType == null\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/a8PhoneNumbersCompany/a8PhoneNumbersCompany-view.html","<div layout=\"column\" flex=\"\"><p class=\"md-subhead\" flex=\"100\" translate=\"WIDGETS_LOC.PHONE_NUMBER_HEADER\"></p><div layout=\"column\" flex=\"100\"><a href=\"#\" ng-click=\"vm.addNumber()\" translate=\"WIDGETS_LOC.PHONE_NUMBER_HEADER_LINK\"></a></div><md-card id=\"email\" flex-xs=\"100\" flex=\"\" flex-gt-xs=\"90\" flex-sm=\"100\" flex-gt-sm=\"90\" flex-md=\"100\" flex-gt-md=\"50\"><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th translate=\"WIDGETS_LOC.PHONE_NUMBER_COLUMN_PHONE_NUMBER\"></th><th translate=\"WIDGETS_LOC.PHONE_NUMBER_COLUMN_PHONE_TYPE\"></th><th translate=\"WIDGETS_LOC.PHONE_NUMBER_COLUMN_PRIMARY\"></th><th translate=\"WIDGETS_LOC.PHONE_NUMBER_COLUMN_ACTIONS\"></th></tr></thead><tbody><tr ng-repeat=\"phone in vm.ngModel\"><td>{{phone.Number}}</td><td>{{phone.PhoneType.TypeName}}</td><td ng-bind=\"phone.IsPrimary === true ? (\'WIDGETS_LOC.PHONE_NUMBER_PRIMARY_YES\' | translate): (\'WIDGETS_LOC.PHONE_NUMBER_PRIMARY_NO\' | translate)\"></td><td><md-icon md-svg-icon=\"pencil\" class=\"teal-500-fg\" ng-click=\"vm.editNumber(phone, $index)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.PHONE_NUMBER_DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'WIDGETS_LOC.PHONE_NUMBER_DELETE_SECTION\' | translate}}\"></delete-component></td></tr></tbody></table></md-card-content></md-card></div>");
$templateCache.put("app/shared/widgets/a8PhoneNumbersCompany/a8PhoneNumbersCompanyDialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"20\" ng-cloak=\"\"><form name=\"numberForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><label translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_TYPE_PLACEHOLDER\"></label><md-select ng-model=\"vm.numberType\" required=\"\" flex=\"\"><md-option ng-repeat=\"type in vm.phoneTypes\" ng-value=\"type\" ng-selected=\"type.Selected\">{{type.TypeName}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_PLACEHOLDER\"></label> <input type=\"text\" name=\"number\" numeric-only=\"\" ng-model=\"vm.number\" ng-maxlength=\"15\" required=\"\"><div ng-messages=\"numberForm.number.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"max\"><span translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_NUMBER_ERROR_MESSAGE\"></span></div></div></md-input-container></div><div layout=\"row\" flex=\"\"><md-checkbox ng-model=\"vm.isPrimary\">{{\'WIDGETS_LOC.PHONE_NUMBER_DIALOG_IS_PRIMARY\' | translate}}</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"WIDGETS_LOC.PHONE_NUMBER_DIALOG_SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"numberForm.$invalid || vm.number == null || vm.numberType == null\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/addButton/addButton.html","<md-button class=\"md-accent\"><span style=\"position: relative; top: 5px;\"><i class=\"icon-plus-circle s25\"></i></span> <span>{{vm.title}}</span></md-button>");
$templateCache.put("app/shared/widgets/auditLog/audit-log.html","<md-dialog id=\"contact-create-email\" flex=\"60\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Audit Log</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onClose()\" style=\"margin-right:20px;\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/shared/widgets/a8EmailsWithType/a8AttachmentPreferences.html","<md-dialog id=\"attachment-preferences\" aria-label=\"{{ \'WIDGETS_LOC.ATTACHMENT_PREFERENCES.TITLE\' | translate }}\" flex=\"40\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.TITLE\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><p class=\"attachment-pref-default-note\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.NOTHING_TICKED_SENDS_ALL\"></p><div class=\"attachment-pref-section-header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.toggleSection(\'documents\')\"><h3 flex=\"\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.SECTION_DOCUMENTS\"></h3><i class=\"icon-chevron-up\" ng-if=\"vm.sections.documents\"></i> <i class=\"icon-chevron-down\" ng-if=\"!vm.sections.documents\"></i></div><div ng-if=\"vm.sections.documents\" layout=\"column\"><div class=\"attachment-pref-doc-header\"><span class=\"md-caption\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.PAGE_ORDER\"></span></div><ul class=\"attachment-pref-doc-list\" dnd-list=\"vm.documentRows\"><li class=\"attachment-pref-doc-row\" ng-repeat=\"row in vm.documentRows\" dnd-draggable=\"row\" dnd-moved=\"vm.onRowMoved($index)\" dnd-effect-allowed=\"move\"><md-checkbox ng-model=\"row.selected\" ng-disabled=\"vm.isRowLocked(row)\" ng-change=\"vm.onSelectionChanged()\"><span translate=\"{{row.labelKey}}\"></span></md-checkbox><span class=\"attachment-pref-page-order\" ng-bind=\"$index + 1\"></span><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"{{\'WIDGETS_LOC.ATTACHMENT_PREFERENCES.PAGE_ORDER\' | translate}}\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.moveRowUp(row)\" ng-disabled=\"vm.isFirstRow(row)\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon><span translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.MOVE_UP\"></span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.moveRowDown(row)\" ng-disabled=\"vm.isLastRow(row)\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon><span translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.MOVE_DOWN\"></span></md-button></md-menu-item></md-menu-content></md-menu></li></ul></div><md-divider></md-divider><div class=\"attachment-pref-section-header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.toggleSection(\'forms\')\"><h3 flex=\"\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.SECTION_FORMS\"></h3><i class=\"icon-chevron-up\" ng-if=\"vm.sections.forms\"></i> <i class=\"icon-chevron-down\" ng-if=\"!vm.sections.forms\"></i></div><div ng-if=\"vm.sections.forms\" layout=\"column\"><md-checkbox ng-model=\"vm.pref.IncludeAllForms\" ng-change=\"vm.onSelectionChanged()\"><span translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.ALL_FORMS\"></span></md-checkbox><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.loadingForms\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular></div><div ng-if=\"!vm.loadingForms\"><div ng-repeat=\"group in vm.formGroups\"><p class=\"md-caption\" ng-bind=\"group.translate ? (group.name | translate) : group.name\"></p><md-checkbox ng-repeat=\"item in group.items\" ng-model=\"vm.selectedForms[item.key]\" ng-change=\"vm.onSelectionChanged()\" class=\"md-align-top-left\">{{item.name}} <span ng-if=\"item.normallyIncluded\" class=\"md-caption\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.NORMALLY_INCLUDED\"></span></md-checkbox></div><p ng-if=\"!vm.formGroups.length\" class=\"md-caption\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.NO_FORMS\"></p></div></div><md-divider></md-divider><div class=\"attachment-pref-section-header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.toggleSection(\'attachments\')\"><h3 flex=\"\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.SECTION_ATTACHMENTS\"></h3><i class=\"icon-chevron-up\" ng-if=\"vm.sections.attachments\"></i> <i class=\"icon-chevron-down\" ng-if=\"!vm.sections.attachments\"></i></div><div ng-if=\"vm.sections.attachments\" layout=\"column\"><md-checkbox ng-model=\"vm.pref.IncludeAllAttachments\" ng-change=\"vm.onSelectionChanged()\"><span translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.ALL_ATTACHMENTS\"></span></md-checkbox><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.loadingAttachments\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular></div><div ng-if=\"!vm.loadingAttachments\"><div ng-repeat=\"group in vm.attachmentGroups\"><p class=\"md-caption\" ng-bind=\"group.translate ? (group.name | translate) : group.name\"></p><md-checkbox ng-repeat=\"item in group.items\" ng-model=\"vm.selectedDocIds[item.id]\" ng-change=\"vm.onSelectionChanged()\" class=\"md-align-top-left\">{{item.name}} <span ng-if=\"item.normallyIncluded\" class=\"md-caption\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.NORMALLY_INCLUDED\"></span></md-checkbox></div><p ng-if=\"!vm.attachmentGroups.length\" class=\"md-caption\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.NO_ATTACHMENTS\"></p></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.CANCEL\"></md-button><md-button class=\"md-raised md-accent attachment-pref-done\" ng-click=\"vm.onDone()\" translate=\"WIDGETS_LOC.ATTACHMENT_PREFERENCES.DONE\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/shared/widgets/a8EmailsWithType/a8Emails-viewWithType.html","<div><p class=\"md-subhead\" flex=\"100\" translate=\"WIDGETS_LOC.HEADER\"></p><div layout=\"column\" flex=\"100\"><a href=\"#\" ng-click=\"vm.addEmail()\" translate=\"WIDGETS_LOC.HEADER_LINK\"></a></div><br><md-card><md-card-content><div class=\"ms-responsive-table-wrapper\"><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th translate=\"WIDGETS_LOC.COLUMN_EMAIL\"></th><th translate=\"WIDGETS_LOC.COLUMN_PRIMARY\" ng-hide=\"vm.hidePrimary\"></th><th translate=\"WIDGETS_LOC.COLUMN_TYPE\"></th><th translate=\"WIDGETS_LOC.COLUMN_ACTIONS\"></th></tr></thead><tbody><tr ng-repeat=\"email in vm.ngModel\"><td>{{email.EmailAddress}}</td><td ng-hide=\"vm.hidePrimary\" ng-bind=\"email.IsPrimary === true ? (\'WIDGETS_LOC.PRIMARY_YES\' | translate) : (\'WIDGETS_LOC.PRIMARY_NO\' | translate)\"></td><td>{{vm.getEmailType(email.EmailType)}}</td><td><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"vm.editEmail(email, $index)\"></md-icon><md-icon md-svg-icon=\"attachment-preferences\" class=\"md-icon-edit md-icon-edit-spaced\" ng-if=\"vm.showAttachmentPreferences && (email.EmailType == 3 || email.EmailType == 4)\" ng-click=\"vm.editAttachmentPreferences(email)\" title=\"{{\'WIDGETS_LOC.ATTACHMENT_PREFERENCES.TOOLTIP\' | translate}}\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'WIDGETS_LOC.SECTION\' | translate}}\"></delete-component></td></tr></tbody></table></div></md-card-content></md-card><br></div>");
$templateCache.put("app/shared/widgets/a8EmailsWithType/a8EmailsWithTypeDialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"20\" ng-cloak=\"\"><form name=\"emailForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"WIDGETS_LOC.PLACEHOLDER\"></label> <input type=\"email\" name=\"emailItem\" ng-model=\"vm.emailAddress\" ng-pattern=\"vm.emailPattern\" ng-maxlength=\"254\" required=\"\"><div ng-messages=\"emailForm.emailItem.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"email\"><span translate=\"WIDGETS_LOC.EMAIL_INVALID\"></span></div><div ng-message=\"maxlength\"><span translate=\"WIDGETS_LOC.EMAIL_MAX\"></span></div></div></md-input-container><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"WIDGETS_LOC.EMAIL_TYPE\"></label><md-select ng-model=\"vm.type\" ng-change=\"vm.onEmailTypeChange(vm)\" required=\"\"><md-option value=\"1\" translate=\"WIDGETS_LOC.TYPE_BUSINESS\" ng-hide=\"vm.showSchedulingAlerts\"></md-option><md-option value=\"2\" translate=\"WIDGETS_LOC.TYPE_PERSONAL\" ng-hide=\"vm.showSchedulingAlerts\"></md-option><md-option value=\"3\" translate=\"WIDGETS_LOC.TYPE_ACCOUNTS\" ng-hide=\"vm.showSchedulingAlerts\"></md-option><md-option value=\"4\" translate=\"WIDGETS_LOC.TYPE_PAPERWORK\" ng-hide=\"vm.showSchedulingAlerts\"></md-option><md-option value=\"5\" translate=\"WIDGETS_LOC.TYPE_SCHEDULINGALERTS\" ng-show=\"vm.showSchedulingAlerts\"></md-option></md-select><div ng-show=\"vm.type==\'5\'\"><div class=\"alert\" translate=\"WIDGETS_LOC.SCHEDULINGALERTS_NOTE\" ng-hide=\"vm.IsDuplicate\" style=\"font-size: 12px;color: #ff8100\"></div><div class=\"alert\" ng-show=\"vm.IsDuplicate\" style=\"font-size: 12px;color: #ff8100\">Email Address of this Email Type already exists.</div></div><div ng-messages=\"emailForm.emailItem.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"WIDGETS_LOC.EMAIL_TYPE_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\" flex=\"\"><div layout-xs=\"column\" flex-xs=\"100\"><md-checkbox ng-model=\"vm.isPrimary\" aria-label=\"Primary Email Address\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"md-align-top-left\" ng-hide=\"vm.hidePrimary\" flex=\"\">{{\'WIDGETS_LOC.IS_PRIMARY\' | translate}}</md-checkbox></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"emailForm.$invalid || vm.IsDuplicate\" style=\"margin-right:20px;\" translate=\"WIDGETS_LOC.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/a8Pagination/a8Pagination.html","<div layout=\"row\" layout-align=\"end center\"><div ng-if=\"vm.showTotalRecords\"><section ng-if=\"vm.type === \'basic\'\"><strong>Showing {{vm.basicService.data.FirstItemOnPage}} to {{vm.basicService.data.LastItemOnPage}} of {{vm.basicService.data.TotalItemCount}} entries</strong></section></div><div><section ng-if=\"vm.type === \'basic\'\"><div layout=\"row\" layout-align=\"center center\"><div><md-button ng-click=\"vm.basicService.movePrev()\" ng-disabled=\"!vm.basicService.data.HasPreviousPage\">Prev</md-button></div><div><md-button ng-click=\"vm.basicService.moveNext()\" ng-disabled=\"!vm.basicService.data.HasNextPage\">Next</md-button></div></div></section><section ng-if=\"vm.type === \'numeric\'\"><h1>Numeric pager</h1></section></div></div>");
$templateCache.put("app/shared/widgets/commentComponent/comment.component.html","<md-button class=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"removeItem()\"><md-icon md-font-icon=\"icon icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip>{{toolTip}}</md-tooltip></md-button>");
$templateCache.put("app/shared/widgets/composedEmailTemplateDialog/composedEmailTemplateDialog.html","<md-dialog class=\"main-style\" id=\"composedEmailTemplate\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Send confirmation email</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content class=\"dialog-content\"><div class=\"email-headers\"><md-input-container class=\"md-block md-icon-float md-input-has-value\"><label for=\"emailTo\" class=\"email-input-label\">To:</label> <input type=\"text\" name=\"emailTo\" class=\"email-input-headers\" ng-model=\"vm.template.EmailTo\"></md-input-container><md-input-container class=\"md-block md-icon-float md-input-has-value\"><label for=\"emailCc\" class=\"email-input-label\">Cc:</label> <input type=\"text\" name=\"emailCc\" class=\"email-input-headers\" ng-model=\"vm.template.Cc\"></md-input-container><md-input-container class=\"md-block md-icon-float md-input-has-value\"><label for=\"emailSubject\" class=\"email-input-label\">Subject:</label> <input type=\"text\" name=\"emailSubject\" class=\"email-input-headers\" ng-model=\"vm.template.Subject\"></md-input-container></div><div id=\"emailContent\" contenteditable=\"true\" class=\"email-body\" ng-bind-html=\"vm.template.Content\" ng-model=\"vm.template.Content\"></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"dialog-actions\"><md-button class=\"btn-send\" ng-click=\"vm.onSendClick()\">Send</md-button><md-button class=\"md-fab md-mini md-accent\" ng-click=\"vm.onDeleteClick()\"><md-icon class=\"icon-trash\"></md-icon></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/shared/widgets/a8PaginationGrid/a8Pagination.html","<div layout=\"row\" layout-align=\"end center\"><div ng-if=\"vm.showTotalRecords\"><section><strong>Showing {{vm.basicService.data.FirstItemOnPage}} to {{vm.basicService.data.LastItemOnPage}} of {{vm.basicService.data.TotalItemCount}}<span ng-if=\"vm.basicService.isDownloading\">+</span> entries <span ng-if=\"vm.basicService.data.isFiltered\">(filtered from {{vm.basicService.data.RawTotalItemCount}} total entries)</span></strong></section></div><div><section><div layout=\"row\" layout-align=\"center center\"><div><md-button ng-click=\"vm.basicService.movePrev()\" ng-disabled=\"!vm.basicService.data.HasPreviousPage\">Prev</md-button></div><div><md-button ng-click=\"vm.basicService.moveNext()\" ng-disabled=\"!vm.basicService.data.HasNextPage\">Next</md-button></div></div></section></div></div>");
$templateCache.put("app/shared/widgets/comment/comment.html","<md-dialog id=\"comments-dialog\" block-ui=\"block-comment-component\" flex=\"70\" ng-cloak=\"\"><md-toolbar class=\"comments-dialog-toolbar\"><div class=\"md-toolbar-tools\"><h2>{{vm.module}} - {{vm.detail}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div><div flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\" class=\"search\"><md-input-container flex=\"\" class=\"search-input\"><input type=\"text\" name=\"search\" placeholder=\"Search comments\" ng-model=\"vm.search.Message\"></md-input-container></div></div></md-toolbar><md-dialog-content class=\"comments-dialog-content\"><md-content class=\"comments-list\"><md-list class=\"list-item\" ms-scroll=\"\"><md-list-item class=\"md-2-line item\" ng-repeat=\"msg in vm.filteredMessages| orderBy: \'-CreatedDate\'| startFrom: (vm.currentPage - 1) * vm.pageSize| limitTo: vm.pageSize| filter: vm.search as _results_comments\" ng-click=\"$event.stopPropagation(); $event.preventDefault();\"><div class=\"md-list-item-text\" flex=\"\" layout=\"column\" id=\"msg-{{msg.Id}}\"><h4 class=\"media-heading\">{{msg.User}} &nbsp;</h4><p class=\"msg\" ng-class=\"{\'removed\': msg.DeletedDate}\" ng-bind-html=\"msg.Message | nl2br\"></p><p class=\"datestamp\"><small>{{vm.displayDateStamp(msg.DeletedDateUtc || msg.UpdatedDateUtc || msg.CreatedDateUtc)}}</small></p></div><md-menu class=\"item-menu\" ng-show=\"msg.isUnlocked && msg.DeletedDate === null && !vm.isAdding && !vm.isEditing\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"1\"><md-menu-item><md-button ng-click=\"vm.editComment(msg)\" aria-label=\"Edit Comment\"><md-icon md-font-icon=\"icon-pencil\"><md-tooltip>Edit Comment</md-tooltip></md-icon>Edit Comment</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteComment(msg.Id)\" aria-label=\"Delete Comment\"><md-icon md-font-icon=\"icon-delete\"><md-tooltip>Delete Comment</md-tooltip></md-icon>Delete Comment</md-button></md-menu-item></md-menu-content></md-menu><md-divider inset=\"\"></md-divider></md-list-item><md-list-item class=\"md-no-focus md-no-ink md-3-line\" ng-show=\"_results_comments.length === 0\"><div class=\"md-list-item-text\"><p class=\"msg\">No comment found...</p></div><md-divider inset=\"\"></md-divider></md-list-item></md-list><div id=\"bottom\"></div></md-content></md-dialog-content><md-dialog-content><div flex=\"\" layout=\"row\"><button flex=\"\" layout=\"column\" layout-align=\"center center\" ng-disabled=\"vm.currentPage == 1\" ng-click=\"vm.currentPage = 1\">&lt; &lt; First</button> <button flex=\"\" layout=\"column\" layout-align=\"center center\" ng-disabled=\"vm.currentPage == 1\" ng-click=\"vm.currentPage = vm.currentPage - 1\">&lt; Previous</button> <span flex=\"\" layout=\"column\" layout-align=\"center center\">( {{vm.currentPage}} / {{vm.noOfPages || 1}} )</span> <button flex=\"\" layout=\"column\" layout-align=\"center center\" ng-disabled=\"vm.currentPage >= vm.noOfPages\" ng-click=\"vm.currentPage = vm.currentPage + 1\">Next &gt;</button> <button flex=\"\" layout=\"column\" layout-align=\"center center\" ng-disabled=\"vm.currentPage >= vm.noOfPages\" ng-click=\"vm.currentPage = vm.noOfPages\">Last &gt; &gt;</button></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"comments-dialog-actions\"><div flex=\"\" layout=\"column\"><div flex=\"\" layout=\"column\" ng-show=\"vm.isAdding || vm.isEditing\"><md-input-container class=\"input msg\" flex=\"\"><textarea rows=\"4\" class=\"msg-entry\" placeholder=\"Enter comment...\" md-detect-hidden=\"\" md-select-on-focus=\"\" ng-model=\"vm.service.model.Message\"></textarea></md-input-container></div><div flex=\"\" layout=\"row\"><div flex=\"30\" layout=\"column\" ng-show=\"vm.isAdding || vm.isEditing\"><md-input-container class=\"input\" flex=\"\"><label>Restrictions</label><md-select name=\"Restrictions\" ng-change=\"vm.restrictionsChanged()\" ng-model=\"vm.service.model.CommentRestrictionType\"><md-optgroup label=\"Restrictions\"><md-option ng-value=\"null\">None</md-option><md-option ng-value=\"item.Id\" ng-repeat=\"item in vm.RestrictionTypes\">{{item.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"\" layout=\"column\" layout-align=\"center end\"><md-input-container class=\"input\" flex=\"\"><md-button ng-show=\"!vm.isAdding && !vm.isEditing\" aria-label=\"Add Comment\" ng-click=\"vm.addComment()\" class=\"md-raised md-accent\">Add Comment</md-button><md-button ng-show=\"vm.isAdding || vm.isEditing\" aria-label=\"Cancel\" ng-click=\"vm.cancelEntry()\" class=\"md-raised md-accent\">Cancel</md-button><md-button ng-show=\"vm.isAdding || vm.isEditing\" ng-disabled=\"!vm.service.model.Message\" aria-label=\"Save\" ng-click=\"vm.saveComment()\" class=\"md-raised md-accent\">Save</md-button></md-input-container></div></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/shared/widgets/conditionComponent/_conditions.html","<div class=\"page-layout simple fullwidth ratecard-allowances\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><form name=\"createRatecardForm\"><div class=\"form-wrapper flex-100\"><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.NAME\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><input name=\"allowanceName\" ng-model=\"rateCardAllowance.formData.Name\" required=\"\"><div ng-messages=\"createRatecardForm.ratecardName.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"!rateCardAllowances.isEditRatecardActive\"><label flex=\"100\" class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.TYPE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\" required=\"\"><md-select name=\"rateCardFormat\" ng-model=\"t\"><md-option ng-value=\"conditionType.Id\" ng-repeat=\"conditionType in rateCardAllowances.conditionTypes\" required=\"\">{{ conditionType.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><label class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.INPUT_VARIABLE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"rateCradAllowances\" ng-model=\"rateCardAllowances.currentRatecard.formData.AllowancesHolder\" required=\"\"><md-option ng-value=\"inputVariable.Id\" ng-repeat=\"inputVariable in rateCardAllowances.inputVariables\" ng-selected=\"rateCardAllowances.isAllowanceSelected(allowance.Id)\">{{ inputVariable.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><label class=\"md-body-2\">{{\'WIDGETS_LOC.MAIN_ALLOWANCES_FORM_DISTANCE_MULTIPLIER\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"rateCardPackages\" ng-model=\"rateCardAllowances.currentRatecard.formData.PackagesHolder\" ng-change=\"rateCardAllowances.updatePackages()\" required=\"\"><md-option ng-value=\"compareType.Id\" ng-repeat=\"compareType in rateCardAllowances.compareType\" ng-selected=\"rateCardAllowances.isPackageSelected(package.Id)\">{{ compareType.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"!rateCardAllowances.isPackagesEmpty()\"><span ng-repeat=\"conditionOperator in rateCardAllowances.conditionOperators\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardAllowances.currentRatecard.formData.FormPackagesForShiftsWithSameTime\"><label>conditionOperator.Name</label></md-checkbox></span></div><div layout=\"row\" layout-wrap=\"\"><md-dialog-actions layout=\"row\" ng-if=\"rateCardAllowances.isEditRatecardActive && rateCardAllowances.hasRatecard() && rateCardAllowances.isCloneRatecardActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardAllowances.createNewRatecard()\" ng-disabled=\"(createRatecardForm.ratecardName.$invalid) || (createRatecardForm.rateCardFormat.$invalid) || (createRatecardForm.rateCardTravelTypes.$invalid)\">{{\'WIDGETS_LOC.MAIN_ADD\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-body-2\" ng-click=\"rateCardAllowances.toggleRatecardCreate()\" ng-disabled=\"\">{{\'RATECARD_V2.MAIN_CANCEL\' | translate}}</md-button></md-dialog-actions></div></div></form></div></div></div></div>");
$templateCache.put("app/shared/widgets/conditionComponent/conditionComponent.directive.html","<div layout=\"row\" layout-align=\"end center\" class=\"btn-add-condition\"><md-button ng-click=\"addTemplate()\" class=\"md-fab md-mini md-accent pull-right create-ratecard-btn\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_ADD_CONDITIONS\' | translate}}</md-tooltip></md-icon></md-button></div><div class=\"page-layout simple fullwidth condition-component\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><div id=\"condition-component-div\" dnd-list=\"conditionSrc\" dnd-dragover=\"dragoverCallback(index, external, type)\"></div></div></div><div class=\"no-conditions-message p-20\" flex=\"100\" ng-if=\"!conditionComponent.hasCondition()\"><div flex=\"\">{{\'WIDGETS_LOC.CONDITIONS.NO_CONDITION\' | translate}}</div></div></div></div>");
$templateCache.put("app/shared/widgets/conditionComponent/conditionContentComponent.directive.html","<div class=\"form-wrapper flex-100 md-accordion p-0 m-0\" id=\"{{conditionContentComponent.datacount}}\" dnd-draggable=\"conditionContentComponent.datasrc[conditionContentComponent.datacount]\" dnd-moved=\"conditionContentComponent.displayMoved(event)\" dnd-effect-allowed=\"move\" dnd-selected=\"selected = conditionContentComponent.datasrc[conditionContentComponent.datacount]\" dnd-disable-if=\"data.expanded\" ng-class=\"{\'selected\': selected === conditionContentComponent.datasrc[conditionContentComponent.datacount]}\"><md-toolbar ng-init=\"data.expanded = true\" ng-click=\"data.expanded = !data.expanded\"><div class=\"md-toolbar-tools\"><h2><span>{{ conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionName }}</span></h2><span flex=\"\"></span> <span ng-class=\"{expandCollapse:true, active:data.expanded}\"></span></div></md-toolbar><div ng-class=\"{dataContent:true, activeContent:data.expanded}\"><form name=\"createConditionForm\"><div layout=\"row\" layout-wrap=\"\" ng-if=\"!conditionContentComponent.isConditionNameHidden()\"><label flex=\"100\" class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.NAME\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><input name=\"conditionName\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionName\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.TYPE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\" required=\"\"><md-select name=\"conditionType\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionType\" ng-change=\"conditionContentComponent.onChangeConditionType(conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionType)\" required=\"\"><md-option ng-value=\"condition.ConditionType.Tag\" ng-repeat=\"condition in conditionContentComponent.lookups track by $index\">{{ condition.ConditionType.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].InputVariable || !conditionContentComponent.isLookupEmpty(conditionContentComponent.conditionSubLookup.InputVariables)\"><label class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.INPUT_VARIABLE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].InputVariable\" required=\"\"><md-option ng-value=\"inputVariable.Id\" ng-repeat=\"inputVariable in conditionContentComponent.conditionSubLookup.InputVariables | filter:conditionContentComponent.filterInputVariables\">{{ inputVariable.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"!conditionContentComponent.isShiftHoursWorked() && !conditionContentComponent.isTimeOfDay() && (conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionDecimalCompareType || !conditionContentComponent.isLookupEmpty(conditionContentComponent.conditionSubLookup.CompareTypes))\"><label class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.COMPARE_TYPE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"rateCardPackages\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionDecimalCompareType\" required=\"\"><md-option ng-value=\"compareType.Id\" ng-repeat=\"compareType in conditionContentComponent.conditionSubLookup.CompareTypes\">{{ compareType.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"conditionContentComponent.isDecimalValue()\"><label flex=\"100\" class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.CONDITION_VALUE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><input name=\"conditionDecimalValue\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionDecimalValue\" ng-pattern=\"/^[0-9]+([,.][0-9]+)?$/\" required=\"\"><div ng-messages=\"createConditionForm.conditionDecimalValue.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"conditionContentComponent.isStringValue()\"><label flex=\"100\" class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.CONDITION_VALUE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><input name=\"conditionStringValues\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionStringValues\" required=\"\"><div ng-messages=\"createRatecardForm.conditionStringValues.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"conditionContentComponent.isDayOfWeek()\"><fieldset class=\"standard\"><legend>{{\'WIDGETS_LOC.CONDITIONS.CONDITION_TYPE_DAYOFWEEK\' | translate}}</legend><md-input-container flex=\"100\" class=\"m-10\"><div flex-xs=\"\" flex=\"50\"><md-checkbox aria-label=\"Select All\" ng-checked=\"conditionContentComponent.checkedAllDayOfWeek()\" ng-click=\"conditionContentComponent.selectAllDayOfWeek()\"><span ng-if=\"conditionContentComponent.checkedAllDayOfWeek()\">Un-</span>Select All</md-checkbox></div></md-input-container><md-input-container flex=\"auto\" class=\"m-10\" ng-repeat=\"conditionDay in conditionContentComponent.conditionSubLookup.ConditionDays\"><md-checkbox aria-label=\"{{ conditionDay.Name }}\" ng-click=\"conditionContentComponent.toggleDayOfWeekSelection(conditionDay.Id)\" ng-checked=\"conditionContentComponent.isDayOfWeekChecked(conditionDay.Id)\" name=\"conditionDays\" value=\"{{conditionDay.Id}}\" ng-required=\"!conditionContentComponent.hasDayOfWeekChecked()\" ng-model=\"conditionDays\">{{ conditionDay.Name }}</md-checkbox></md-input-container></fieldset></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"conditionContentComponent.isTimeOfDay()\"><fieldset class=\"standard\"><legend>{{\'WIDGETS_LOC.CONDITIONS.CONDITION_TYPE_TIMEOFDAY\' | translate}}</legend><md-input-container flex=\"auto\" class=\"m-10\"><input type=\"text\" placeholder=\"{{ \'WIDGETS_LOC.CONDITIONS.CONDITION_TYPE_STARTTIME\' | translate }}\" time-picker=\"\" ng-blur=\"\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionJobStartTime\" ng-required=\"true\"></md-input-container><md-input-container flex=\"auto\" class=\"m-10\"><input type=\"text\" placeholder=\"{{ \'WIDGETS_LOC.CONDITIONS.CONDITION_TYPE_ENDTIME\' | translate }}\" time-picker=\"\" ng-blur=\"\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionJobEndTime\" ng-required=\"true\"></md-input-container></fieldset></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"conditionContentComponent.isShiftHoursWorked()\"><fieldset class=\"standard\"><legend>{{\'WIDGETS_LOC.CONDITIONS.CONDITION_TYPE_TOTAL_ORDINARY_HOURS\' | translate}}</legend><md-input-container flex=\"100\" class=\"m-10\"><label class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.COMPARE_TYPE\' | translate}}</label><md-select name=\"rateCardPackages\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionDecimalCompareType\" required=\"\"><md-option ng-value=\"compareType.Id\" ng-repeat=\"compareType in conditionContentComponent.conditionSubLookup.CompareTypes\">{{ compareType.Name }}</md-option></md-select></md-input-container><md-input-container flex=\"auto\" class=\"m-10\"><label class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.CONDITION_TYPE_TOTAL_ORDINARY_HOURS\' | translate}}</label> <input type=\"text\" placeholder=\"{{ \'WIDGETS_LOC.CONDITIONS.CONDITION_TYPE_TOTAL_ORDINARY_HOURS\' | translate }}\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionDecimalValue\" ng-required=\"true\" ng-pattern=\"/^[0-9]+([,.][0-9]+)?$/\"></md-input-container></fieldset></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"conditionContentComponent.isJobStartTime()\"><label flex=\"100\" class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.CONDITION_VALUE\' | translate}}</label><md-input-container flex=\"auto\" class=\"m-10\"><input type=\"text\" time-picker=\"\" ng-blur=\"\" ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionJobStartTime\" ng-required=\"true\" name=\"conditionJobStartTime\"><div ng-messages=\"createConditionForm.conditionDecimalValue.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"conditionContentComponent.hasOperator()\"><label class=\"md-body-2\">{{\'WIDGETS_LOC.CONDITIONS.CONDITION_OPERATOR\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-radio-group ng-model=\"conditionContentComponent.datasrc[conditionContentComponent.datacount].ConditionOperator\"><md-radio-button ng-repeat=\"operator in conditionContentComponent.conditionSubLookup.ConditionOperators\" ng-value=\"operator.Id\" aria-label=\"{{operator.label}}\">{{ operator.Name }}</md-radio-button></md-radio-group></md-input-container></div></form></div></div>");
$templateCache.put("app/shared/widgets/customMultiselect/customMultiselect.html","<div flex=\"\"><md-input-container class=\"md-block\"><label>{{vm.label}}</label><md-select md-selected-text=\"vm.formatDisplay()\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.ngModel\" ng-required=\"vm.isRequired\" name=\"vm.name\" multiple=\"\"><div ng-if=\"!vm.selectAll\" layout=\"row\" style=\"position : relative; left : -10px; margin-top : 5px; margin-bottom : 5px;\"><md-button style=\"position : relative; left : 4px;\" ng-click=\"vm.changeSelectOption()\" class=\"md-icon-button\"><i class=\"icon-checkbox-blank-outline\" style=\"font-size : 27px; color : #757575;\"></i></md-button><span style=\"position : relative; top : 12px; left : -2px;\">Select All</span></div><div ng-if=\"vm.selectAll\" layout=\"row\" style=\"position : relative; left : -10px; margin-top : 5px; margin-bottom : 5px;\"><md-button style=\"position : relative; left : 4px;\" ng-click=\"vm.changeSelectOption()\" class=\"md-icon-button\"><i class=\"icon-checkbox-marked\" style=\"font-size : 27px; color : #494D57;\"></i></md-button><span style=\"position : relative; top : 12px; left : -2px;\">Deselect All</span></div><md-option ng-value=\"vm.isFullObject ? option : option[vm.data]\" ng-repeat=\"option in vm.options\">{{option[vm.display]}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/shared/widgets/deleteComponent/delete.component.html","<md-button class=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"removeItem()\" ng-class=\"{\'display-none\':candelete==false}\"><md-icon md-font-icon=\"icon icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip>{{toolTip}}</md-tooltip></md-button>");
$templateCache.put("app/shared/widgets/documentManager/documentManager.directive.html","<div class=\"document-manager\" ng-cloak=\"ng-cloak\" layout=\"column\"><div layout=\"row\" ng-if=\"vm.modal\"><md-toolbar flex=\"\"><div class=\"md-toolbar-tools\"><h2>{{\'DOCUMENT_MANAGER.DIALOG_TITLE\' | translate}}</h2><span flex=\"flex\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar></div><div ng-if=\"!vm.modal\" layout=\"row\" layout-align=\"start center\" class=\"document-manager-header\"><div>{{\'DOCUMENT_MANAGER.HEADER\' | translate}}</div><md-button class=\"md-fab md-mini md-accent\" ng-click=\"vm.addAttachment()\" ng-disabled=\"vm.disableAdd\" ng-if=\"vm.hasAccessInDocumentJobs\"><md-icon class=\"icon-plus\"></md-icon></md-button></div><div ng-if=\"vm.isAttachmentTypesEnabled && vm.missingAttachmentsMessage\" class=\"missing-attachments-warning\">{{vm.missingAttachmentsMessage}}</div><div class=\"md-whiteframe-4dp\" layout=\"row\"><md-dialog-content class=\"document-manager-content p-10 m-20\" layout=\"column\" flex=\"100\" ng-if=\"vm.isLoading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-dialog-content><md-dialog-content class=\"document-manager-content p-10\" layout=\"column\" flex=\"100\" ng-if=\"!vm.isLoading\"><md-tabs md-border-bottom=\"md-border-bottom\" md-center-tabs=\"md-center-tabs\" md-stretch-tabs=\"md-stretch-tabs\" md-selected=\"vm.selectedUploadTab\" ng-if=\"vm.modal\"><md-tab label=\"{{\'DOCUMENT_MANAGER.TAB_LABEL_UPLOAD\' | translate}}\"></md-tab><md-tab label=\"{{\'DOCUMENT_MANAGER.TAB_LABEL_UPLOAD_EXTERNAL\' | translate}}\"></md-tab><md-tab label=\"{{\'DOCUMENT_MANAGER.TAB_LABEL_UPLOAD_URL\' | translate}}\"></md-tab></md-tabs><div ng-if=\"vm.modal && vm.isAttachmentTypesEnabled\" layout=\"row\" layout-align=\"start center\" class=\"attachment-type-selector pl-10 pr-10\"><md-input-container flex=\"\"><label>{{\'DOCUMENT_MANAGER.ATTACHMENT_TYPE_LABEL\' | translate}} *</label><md-select ng-model=\"vm.selectedAttachmentType\"><md-option ng-value=\"null\">Others</md-option><md-option ng-repeat=\"type in vm.selectableAttachmentTypes\" ng-value=\"type\">{{type.Name}}</md-option></md-select></md-input-container></div><div ng-if=\"vm.modal\"><md-card-content class=\"m-5\" ng-show=\"vm.selectedUploadTab === 0\"><form name=\"form.uploadDocumentsForm\"><div class=\"box-drop-file-area\" id=\"drop-area\"><p for=\"uploadDocument\" class=\"drop-file-area\"><i class=\"upload-icon icon-cloud-upload\"></i><br>{{ \'DOCUMENT_MANAGER.TAB_TEXT_DRAG_DROP\' | translate }}<br>or<br></p><md-button translate=\"DOCUMENT_MANAGER.TAB_BUTTON_UPLOAD_FILE\" class=\"select-file-button\" ng-click=\"vm.onUploadButtonClicked()\"></md-button><input type=\"file\" id=\"uploadDocument\" class=\"image-input\" accept=\"{{vm.getEffectiveAllowedExtensions()}}\" a8-file-upload=\"files\" upload-url=\"vm.getUploadUrl()\" on-upload-start=\"vm.onUploadStart()\" on-upload-validate=\"vm.onUploadValidate(fileObj)\" on-upload-completed=\"vm.onUploadCompleted(data)\" on-upload-error=\"vm.onUploadError(ex)\" max-files=\"25\" multiple=\"multiple\"><div ng-if=\"vm.showUploadProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear><span class=\"md-caption\">Uploading...</span></div></div></form></md-card-content><md-card-content class=\"m-5\" ng-show=\"vm.selectedUploadTab === 1\"><div class=\"box-drop-file-area\" id=\"drop-area\"><div class=\"drives\"><div class=\"upload-from-cloud-drive\"><md-button ng-click=\"vm.saveGoogleDriveDocument()\"><img src=\"assets/images/documentmanagement/google_drive.svg\" class=\"icon-google-drive\"></md-button><div ng-if=\"vm.showUploadProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear><span class=\"md-caption\">Uploading...</span></div></div><div class=\"upload-from-cloud-drive\"><md-button ng-click=\"vm.saveOneDriveDocument()\"><img src=\"assets/images/documentmanagement/one_drive.svg\" class=\"icon-one-drive\"></md-button><div ng-if=\"vm.showOneDriveUploadProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear><span class=\"md-caption\">Uploading...</span></div></div></div></div></md-card-content><md-card-content class=\"m-5\" ng-show=\"vm.selectedUploadTab === 2\"><div class=\"box-drop-file-area\" id=\"drop-area\"><div class=\"upload-from-web\"><md-input-container class=\"upload-from-web__name-section\"><input ng-model=\"vm.formData.documentName\" placeholder=\"{{\'DOCUMENT_MANAGER.FORM_UPLOAD_DOCUMENT_LINK_NAME\' | translate}}\" required=\"required\"></md-input-container><div class=\"upload-from-web__link-section\"><md-input-container class=\"md-block\"><input ng-model=\"vm.formData.documentUrl\" type=\"url\" placeholder=\"{{\'DOCUMENT_MANAGER.FORM_UPLOAD_DOCUMENT_LINK_URL\' | translate}}\" required=\"required\"></md-input-container><md-button class=\"md-accent md-raised upload-from-web__link-section-button\" ng-disabled=\"!(vm.formData.documentName && vm.formData.documentUrl)\" ng-click=\"vm.saveDocumentLink()\">{{\'WIDGETS_LOC.SAVE\' | translate}}</md-button></div></div><div ng-if=\"vm.showUploadProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear><span class=\"md-caption\">Uploading...</span></div></div></md-card-content></div><div ng-if=\"vm.modal\" class=\"md-caption pl-25 pb-10 text-center\"><span>Please note: Attachments over 5MB can not be included in paperwork.</span></div><md-card-content class=\"m-5\" ng-if=\"!vm.hideList\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th class=\"text-left secondary-text\">{{\'DOCUMENT_MANAGER.COL_NAME\' | translate}}</th><th class=\"text-left secondary-text\" ng-if=\"vm.isAttachmentTypesEnabled && (vm.showLevel || vm.modal)\">{{\'DOCUMENT_MANAGER.COL_ATTACHMENT_TYPE\' | translate}}</th><th class=\"text-left secondary-text\">{{\'DOCUMENT_MANAGER.COL_SIZE\' | translate}}</th><th class=\"text-left secondary-text\">{{\'DOCUMENT_MANAGER.COL_FILETYPE\' | translate}}</th><th class=\"text-left secondary-text\" ng-if=\"vm.showLevel\">{{\'DOCUMENT_MANAGER.COL_MODULE\' | translate}}</th><th class=\"text-left secondary-text\" ng-if=\"!vm.modal\">{{\'DOCUMENT_MANAGER.COL_UPLOAD_ORIGIN\' | translate}}</th><th class=\"text-left secondary-text\" ng-if=\"!vm.modal\">{{\'DOCUMENT_MANAGER.COL_INCLUDE_PAPERWORK\' | translate}}</th><th class=\"text-left secondary-text\">{{\'DOCUMENT_MANAGER.COL_MANAGE\' | translate}}</th></thead><tbody><tr ng-repeat=\"file in vm.documentsList track by $index\"><td class=\"text-left name-column\"><div ng-if=\"vm.isEdit(file.Id)\"><md-input-container flex=\"100\" class=\"mt-0 mb-10\"><input ng-model=\"vm.formData.EditName\" ng-blur=\"vm.saveDocument(file.Name)\" required=\"required\" ng-pattern=\'/^[^\\\\\\/:*?\"&lt;&gt;|]*$/\'><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"vm.updatingDocument\"></md-progress-linear></md-input-container><div ng-if=\"vm.hasFileNameError\" class=\"md-caption red-900-fg\">{{vm.fileNameError}}</div></div><div ng-if=\"!vm.isEdit(file.Id)\">{{file.Name}}</div></td><td class=\"text-left\" ng-if=\"vm.isAttachmentTypesEnabled && (vm.showLevel || vm.modal)\"><md-input-container ng-if=\"vm.isEdit(file.Id) && !vm.modal\" class=\"mt-0 mb-0 attachment-type-edit\" ng-mousedown=\"vm._keepEditMode = true\"><md-select ng-model=\"vm.editAttachmentTypeId\" ng-change=\"vm.saveAttachmentType(file)\" aria-label=\"Attachment Type\"><md-option ng-value=\"null\">Others</md-option><md-option ng-repeat=\"type in vm.attachmentTypes\" ng-value=\"type.Id\">{{type.Name}}</md-option></md-select></md-input-container><span ng-if=\"!vm.isEdit(file.Id) || vm.modal\">{{ vm.getAttachmentTypeName(file.AttachmentTypeId) }}</span></td><td class=\"text-left\">{{ file.DocumentFileSize }}</td><td class=\"text-left\">{{ file.DocumentType }}</td><td class=\"text-left\" ng-if=\"vm.showLevel\">{{ file.DocumentModuleName }}</td><td class=\"text-left\" ng-if=\"!vm.modal\">{{ file.UploadOrigin }}</td><td class=\"text-left\" ng-if=\"!vm.modal\"><md-checkbox ng-model=\"file.IncludeInPaperwork\" ng-change=\"vm.includePaperworkFlagChange(file)\" ng-disabled=\"file.DocumentType === \'Link\' || file.HasReachedFileSizeUploadThreshold || !vm.hasAccessInDocumentJobs || vm.disableCheckbox\" class=\"margin-bottom-5\"></md-checkbox><div ng-if=\"file.HasReachedFileSizeUploadThreshold\" class=\"md-caption yellow-900-fg\"><span>Attachments over 5MB can not be included in paperwork.</span></div></td><td class=\"text-left\"><md-button class=\"md-icon-button md-primary\" ng-href=\"{{file.DocumentUrl}}\" target=\"_blank\" rel=\"noopener noreferrer\" ng-attr-download=\"{{file.DocumentType === \'Link\' ? undefined : \'download\'}}\"><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.editDocument(file.Id, file.Name, file.AttachmentTypeId)\" ng-if=\"vm.canEdit(file) && vm.hasAccessInDocumentJobs\" ng-disabled=\"vm.disableEdit || vm.isEdit(file.Id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.removeDocument(file.Id)\" ng-if=\"vm.canRemove(file) && vm.hasAccessInDocumentJobs\" ng-disabled=\"vm.disableDelete\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.unlinkDocument(vm.relatedResourceId, file.Id)\" ng-if=\"vm.canUnlink(file) && vm.hasAccessInDocumentJobs\" ng-disabled=\"vm.disableUnlink\"><md-icon md-font-icon=\"icon-link-off\" ng-class=\"{\'red-500-fg\': !vm.disableUnlink, \'grey-500-fg\': vm.disableUnlink}\"></md-icon></md-button></td></tr></tbody></table></md-card-content></md-dialog-content></div></div>");
$templateCache.put("app/shared/widgets/formTemplatesList/formTemplates-list.html","<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" class=\"forms-manager\"><div lex-gt-sm=\"70\" flex-md=\"70\" flex-gt-md=\"70\" class=\"list-forms\" layout=\"column\"><div class=\"list-forms__header\">{{\'FORMS_MANAGER.FORMS\' | translate}}</div><div class=\"white-bg md-whiteframe-2dp\" flex=\"\" layout-padding=\"\" layout=\"row\"><div flex=\"\"><table id=\"formTemplateDataTable\" class=\"dataTable row-border hover\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.listDtInstance\"><thead><tr><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th></tr></thead></table></div></div></div><div flex=\"\" class=\"add-form\" layout=\"column\"><div class=\"add-form__header\">{{\'FORMS_MANAGER.ADD_FORMS\' | translate}}</div><div class=\"white-bg md-whiteframe-2dp\" flex=\"\" layout=\"column\" layout-padding=\"\"><div layout=\"column\"><div class=\"search-form\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon layout-margin=\"\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"\" type=\"text\" layout-margin=\"\" ng-model=\"vm.formTemplateNameSearch\" placeholder=\"Search form name\"></div><div><md-button layout-fill=\"\" class=\"md-accent md-raised md-default-theme md-ink-ripple\" ng-click=\"vm.searchFormTemplateClick()\" ng-disabled=\"vm.disableAdd\">{{\'FORMS_MANAGER.SEARCH\' | translate}}</md-button></div></div><div ng-hide=\"!vm.isDTSearchInitialized\" layout=\"column\" flex=\"\"><table id=\"searchDataTable\" class=\"datatable hover row-border\" datatable=\"\" dt-instance=\"vm.searchDtInstance\" dt-options=\"vm.searchDataOptions\" dt-columns=\"vm.searchDataColumns\"><thead ng-hide=\"true\"><tr><th></th><th></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/shared/widgets/historyLog/history-log.html","<md-dialog class=\"main-style\" id=\"history-log\" flex=\"70\" ng-cloak=\"\" ms-scroll=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>History Log - {{vm.module}} {{vm.detail}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"height : 500px;\"><div layout=\"column\" flex=\"\" ms-scroll=\"\"><table class=\"dataTable row-border hover\" ms-responsive-table=\"\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th></th><th></th></tr></thead></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/shared/widgets/historyLogPage/history-log-page.html","<div class=\"history-log-page\"><div class=\"header\"><h2>History</h2></div><div layout=\"column\" flex=\"\" ms-scroll=\"\"><table class=\"dataTable row-border hover\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th>Date</th><th>Log</th></tr></thead><tbody class=\"data-table-body\"><tr ng-repeat=\"log in vm.logs\"><td>{{log.LogDateUtc}}</td><td>{{log.Log}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/shared/widgets/historyLogV2/history-logV2.html","<md-dialog class=\"main-style\" id=\"history-log\" flex=\"70\" ng-cloak=\"\" ms-scroll=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>History Log - {{vm.headerTitle}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"height : 500px;\"><div layout=\"column\" flex=\"\" ms-scroll=\"\"><table class=\"dataTable row-border hover\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th>Date</th><th>Log</th></tr></thead><tbody><tr ng-repeat=\"log in vm.data\"><td>{{log.LogDateUtc | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{log.Log}}<table class=\"dataTable row-border\" ng-if=\"log.LogData && !vm.getLogData(log.LogData).PreviousValues\"><thead><tr><th>Field</th><th>Value</th></tr></thead><tbody><tr ng-repeat=\"field in vm.getLogData(log.LogData).Fields\"><td>{{field}}</td><td>{{vm.getValuesByField(vm.getLogData(log.LogData).Changes,field)}}</td></tr></tbody></table><table class=\"dataTable row-border\" ng-if=\"log.LogData && vm.getLogData(log.LogData).PreviousValues\"><thead><tr><th>Field</th><th style=\"color: #d32f2f;\">Previous</th><th>New</th></tr></thead><tbody><tr ng-repeat=\"field in vm.getLogData(log.LogData).Fields\"><td>{{field}}</td><td style=\"color: #d32f2f; text-decoration: line-through;\">{{vm.getValuesByField(vm.getLogData(log.LogData).PreviousValues,field)}}</td><td>{{vm.getValuesByField(vm.getLogData(log.LogData).NewValues,field)}}</td></tr></tbody></table></td></tr></tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/shared/widgets/jobForms/jobForms-list.html","<div id=\"jobFormsList\" layout=\"column\"><h2>Form Submissions</h2><div layout=\"row\"><div flex=\"\"><table id=\"jobFormsDataTable\" class=\"dataTable hover row-border\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\"><thead class=\"th-spacer\"><tr><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th></tr></thead></table></div></div></div>");
$templateCache.put("app/shared/widgets/multiAddress/multi-address.html","<div class=\"main-style\"><div class=\"ms-responsive-table-wrapper\"><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead ng-hide=\"true\"><tr><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"address in vm.ngModel\"><td width=\"80%\">{{address.FullAddress}}<div><span class=\"highlight-box\">{{address.addressType.TypeName || address.AddressType.TypeName}}</span></div></td><td width=\"20%\"><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"vm.editAddress(address, $index)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.MULTIPLE_ADDRESS_DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'WIDGETS_LOC.MULTIPLE_ADDRESS_SECTION\' | translate}}\"></delete-component></td></tr><tr><td style=\"padding-left: 0px;\"><add-button ng-click=\"vm.openDialog()\" title=\"Add Address\"></add-button></td><td></td></tr></tbody></table></div></div>");
$templateCache.put("app/shared/widgets/multiAddress2/multi-address.html","<div><p class=\"md-subhead\" flex=\"100\" translate=\"WIDGETS_LOC.MULTIPLE_ADDRESS_HEADER\"></p><div layout=\"column\" flex=\"100\"><a ng-click=\"vm.openDialog()\" translate=\"WIDGETS_LOC.MULTIPLE_ADDRESS_HEADER_LINK\"></a></div><br><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th translate=\"WIDGETS_LOC.MULTIPLE_ADDRESS_COLUMN_ADRESS_TYPE\"></th><th translate=\"WIDGETS_LOC.MULTIPLE_ADDRESS_COLUMN_ADRESS\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"address in vm.ngModel\"><td>{{address.addressType.TypeName || address.AddressType.TypeName}}</td><td>{{address.FullAddress}}</td><td><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit md-icon-edit teal-500-fg\" ng-click=\"vm.editAddress(address, $index)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.MULTIPLE_ADDRESS_DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'WIDGETS_LOC.MULTIPLE_ADDRESS_SECTION\' | translate}}\"></delete-component></td></tr></tbody></table></md-card-content></md-card><br></div>");
$templateCache.put("app/shared/widgets/multiAddressCompany/multi-address-company.html","<div><p class=\"md-subhead\" flex=\"100\" translate=\"WIDGETS_LOC.MULTIPLE_ADDRESS_HEADER\"></p><div layout=\"column\" flex=\"100\"><a ng-click=\"vm.openDialog()\" translate=\"WIDGETS_LOC.MULTIPLE_ADDRESS_HEADER_LINK\"></a></div><br><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th translate=\"WIDGETS_LOC.MULTIPLE_ADDRESS_COLUMN_ADRESS_TYPE\"></th><th translate=\"WIDGETS_LOC.MULTIPLE_ADDRESS_COLUMN_ADRESS\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"address in vm.ngModel\"><td>{{address.addressType.TypeName || address.AddressType.TypeName}}</td><td>{{address.FullAddress}}</td><td><md-icon md-svg-icon=\"pencil\" class=\"teal-500-fg\" ng-click=\"vm.editAddress(address, $index)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.MULTIPLE_ADDRESS_DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'WIDGETS_LOC.MULTIPLE_ADDRESS_SECTION\' | translate}}\"></delete-component></td></tr></tbody></table></md-card-content></md-card><br></div>");
$templateCache.put("app/shared/widgets/processorLoader/processorLoader.html","<div ng-if=\"vm.show\" layout=\"row\" layout-align=\"center center\"><span class=\"save_loader_style\"><table><tr><td>{{vm.message}}</td><td><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></td></tr></table></span></div>");
$templateCache.put("app/shared/widgets/requiredAttachmentTypes/add-required-attachment-type.html","<md-dialog id=\"add-required-attachment-type-dialog\" flex=\"40\" ng-cloak=\"\"><form name=\"addAttachmentTypeForm\" novalidate=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Attachment Type</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 24px 24px 0;\"><div ng-if=\"vm.isLoading\" layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"!vm.isLoading && vm.availableTypes.length === 0\"><p>No available attachment types to add. All active types are already linked.</p></div><div ng-if=\"!vm.isLoading && vm.availableTypes.length > 0\"><md-input-container class=\"md-block\" style=\"margin-bottom: 40px;\"><label>Attachment Type</label><md-select ng-model=\"vm.selectedType\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-change=\"vm.onTypeChange()\" required=\"\"><md-option ng-repeat=\"type in vm.availableTypes\" ng-value=\"type\"><span>{{type.Name}}</span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" style=\"margin-bottom: 40px;\"><label>Description</label> <input type=\"text\" ng-model=\"vm.description\" readonly=\"\" style=\"color: rgba(0,0,0,0.38);\"></md-input-container><md-input-container class=\"md-block\" style=\"margin-bottom: 40px;\"><label>Quantity</label> <input type=\"number\" ng-model=\"vm.quantity\" min=\"1\" required=\"\"></md-input-container></div></md-dialog-content></form><md-dialog-actions><md-button class=\"md-raised md-accent\" ng-click=\"vm.onAdd()\" ng-disabled=\"!vm.selectedType || !vm.quantity || vm.quantity < 1\">ADD</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/shared/widgets/requiredAttachmentTypes/required-attachment-types.html","<div><div layout=\"row\" layout-align=\"start center\" class=\"document-manager-header\"><div>Attachment Types</div><md-button class=\"md-fab md-mini md-accent\" ng-click=\"vm.spawnDialog()\"><md-icon class=\"icon-plus\"></md-icon></md-button></div><p class=\"md-body-1\" style=\"color: rgba(0,0,0,0.54);\">Define required attachment types before a job for this {{vm.entityName || \'branch\'}} can be marked as \'Ready to Go\'.</p><div class=\"md-whiteframe-4dp p-10\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"text-left secondary-text\">Attachment Type</th><th class=\"text-left secondary-text\">Description</th><th class=\"text-left secondary-text\">Quantity</th><th class=\"text-left secondary-text\">Manage</th></tr></thead><tbody><tr ng-repeat=\"type in vm.attachmentTypes track by type.AttachmentTypeId\"><td>{{vm.getTypeName(type.AttachmentTypeId)}}</td><td>{{vm.getTypeDescription(type.AttachmentTypeId)}}</td><td><input type=\"number\" ng-model=\"type.Quantity\" min=\"1\" style=\"width: 60px;\"></td><td><a href=\"#\" ng-click=\"vm.remove($index)\" style=\"text-transform: uppercase; color: rgba(0,0,0,0.54); text-decoration: none; font-weight: 500;\">REMOVE</a></td></tr></tbody></table></div></div>");
$templateCache.put("app/shared/widgets/sidenavFilterSmallScreenTemplate/sidenav-filter-small-screen.html","<md-button class=\"md-icon-button sidenav-toggle {{sidenavFilterSmallScreenevm.additionalClass}}\" hide-gt-md=\"\" aria-label=\"Toggle Sidenav\" translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon size-10 pt-10\" md-font-icon=\"icon-filter\"></md-icon></md-button><div ng-show=\"sidenavFilterSmallScreenevm.name\" class=\"pt-10\">{{sidenavFilterSmallScreenevm.name}}</div>");
$templateCache.put("app/shared/widgets/contactPreference/contact-preference-dialog.html","<md-dialog aria-label=\"Contact Address\" flex=\"25\" flex-md=\"50\" flex-sm=\"50\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"WIDGETS_LOC.CONTACT_PREFERENCE_HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"contactPreferenceDialogVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\"></md-icon></md-button></div></md-toolbar><form name=\"ContactPreferenceEntryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-autocomplete md-no-cache=\"true\" md-delay=\"500\" md-selected-item=\"contactPreferenceDialogVm.selectedContact\" md-search-text=\"contactPreferenceDialogVm.searchText\" md-selected-item-change=\"contactPreferenceDialogVm.selectedItemChange(item)\" md-items=\"item in contactPreferenceDialogVm.querySearch(contactPreferenceDialogVm.searchText)\" md-item-text=\"item.FullName\" md-min-length=\"0\" placeholder=\"{{\'WIDGETS_LOC.CONTACT_PREFERENCE_NAME_PLACEHOLDER\' | translate}}\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"{{\'WIDGETS_LOC.CONTACT_PREFERENCE_NAME_LABEL\' | translate}}\" flex=\"\" required=\"\" ng-disabled=\"contactPreferenceDialogVm.isEditMode\"><md-item-template><span md-highlight-text=\"contactPreferenceDialogVm.searchText\" md-highlight-flags=\"^i\">{{item.FullName}}</span></md-item-template></md-autocomplete></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><md-select class=\"md-block\" placeholder=\"Preference\" ng-model=\"contactPreferenceDialogVm.IsPreferred\"><md-option value=\"true\">{{\'WIDGETS_LOC.CONTACT_PREFERENCE_PREFERRED\' | translate}}</md-option><md-option value=\"false\">{{\'WIDGETS_LOC.CONTACT_PREFERENCE_NOT_PREFERRED\' | translate}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"contactPreferenceDialogVm.onAdd()\" class=\"md-accent md-raised\" ng-disabled=\"ContactPreferenceEntryForm.$invalid || ContactPreferenceEntryForm.$pristine\">{{contactPreferenceDialogVm.buttonText}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/contactPreference/contact-preference.html","<table class=\"simple kit-item-table\" ms-responsive-table=\"\"><tbody><tr ng-repeat=\"contact in contactPreferenceVm.ngModel | orderBy:contactPreferenceVm.sortType\"><td width=\"80%\">{{contact.FullName}}<div><span class=\"highlight-box\" ng-if=\"contact.IsPreferred\">Preferred</span> <span class=\"highlight-box-red\" ng-if=\"!contact.IsPreferred\">Not Preferred</span></div></td><td width=\"20%\"><md-icon md-font-icon=\"icon-pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"contactPreferenceVm.onEdit(contact.ContactBasic.id)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.CONTACT_PREFERENCE_DELETE_MESSAGE\' | translate}}\" callback=\"contactPreferenceVm.remove\" section=\"{{\'WIDGETS_LOC.CONTACT_PREFERENCE_DELETE_SECTION\' | translate}}\"></delete-component></td></tr><tr><td style=\"padding-left: 0px;\"><add-button ng-click=\"contactPreferenceVm.onAddContact()\" title=\"Add Contact Preference\"></add-button></td></tr></tbody></table>");
$templateCache.put("app/shared/widgets/tableSearchDirective/table-search.html","<div flex=\"100\" ng-if=\"vm.data.length > 0\" class=\"table-search-directive\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{\'WIDGETS_LOC.SEARCH\' | translate}}\" ng-model=\"vm.query\" ng-model-options=\"vm.options\" ng-keyup=\"vm.search()\"></md-input-container></div></div>");
$templateCache.put("app/shared/widgets/toolbarLoader/toolbar-loader.html","<div ng-if=\"vm.show\" class=\"toolbar-wrapper toolbar-loader\"><span class=\"md-caption\"><table><tr><td><b>{{vm.message}} &nbsp; &nbsp; &nbsp;</b></td><td><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></td></tr></table></span></div>");
$templateCache.put("app/shared/coreLib/preference/contact-preference.html","<md-dialog aria-label=\"{{vm.title}}\" flex=\"25\" ng-cloak=\"\"><form name=\"addressDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container flex=\"\"><input type=\"text\" class=\"md-block\" placeholder=\"Contact\" ng-model=\"vm.contact\"></md-input-container><md-input-container flex=\"\"><md-select class=\"md-block\" placeholder=\"Preference\" ng-model=\"vm.preference\"><md-option value=\"preferred\" selected=\"\">Preferred</md-option><md-option value=\"not preferred\">Not Preferred</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/contactPreference2/contact-preference-dialog.html","<md-dialog aria-label=\"Contact Address\" flex=\"25\" flex-md=\"50\" flex-sm=\"50\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"WIDGETS_LOC.CONTACT_PREFERENCE_HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"contactPreferenceDialogVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\"></md-icon></md-button></div></md-toolbar><form name=\"ContactPreferenceEntryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-autocomplete md-no-cache=\"true\" md-delay=\"500\" md-selected-item=\"contactPreferenceDialogVm.selectedContact\" md-search-text=\"contactPreferenceDialogVm.searchText\" md-selected-item-change=\"contactPreferenceDialogVm.selectedItemChange(item)\" md-items=\"item in contactPreferenceDialogVm.querySearch(contactPreferenceDialogVm.searchText)\" md-item-text=\"item.FullName\" md-min-length=\"0\" placeholder=\"{{\'WIDGETS_LOC.CONTACT_PREFERENCE_NAME_PLACEHOLDER\' | translate}}\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"{{\'WIDGETS_LOC.CONTACT_PREFERENCE_NAME_LABEL\' | translate}}\" flex=\"\" required=\"\" ng-disabled=\"contactPreferenceDialogVm.isEditMode\"><md-item-template><span md-highlight-text=\"contactPreferenceDialogVm.searchText\" md-highlight-flags=\"^i\">{{item.FullName}}</span></md-item-template></md-autocomplete></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><md-select class=\"md-block\" placeholder=\"Preference\" ng-model=\"contactPreferenceDialogVm.IsPreferred\"><md-option value=\"true\">{{\'WIDGETS_LOC.CONTACT_PREFERENCE_PREFERRED\' | translate}}</md-option><md-option value=\"false\">{{\'WIDGETS_LOC.CONTACT_PREFERENCE_NOT_PREFERRED\' | translate}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"WIDGETS_LOC.CONTACT_PREFERENCE_CANCELLED\" ng-click=\"contactPreferenceDialogVm.onCancel()\" class=\"md-accent md-raised\"></md-button><md-button ng-click=\"contactPreferenceDialogVm.onAdd()\" class=\"md-accent md-raised\" ng-disabled=\"ContactPreferenceEntryForm.$invalid || ContactPreferenceEntryForm.$pristine\">{{contactPreferenceDialogVm.buttonText}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/contactPreference2/contact-preference.html","<div><p class=\"md-subhead\" flex=\"100\" translate=\"WIDGETS_LOC.CONTACT_PREFERENCE_HEADER\"></p><div layout=\"column\" flex=\"100\"><a href=\"\" ng-click=\"contactPreferenceVm.onAddContact()\" translate=\"WIDGETS_LOC.CONTACT_PREFERENCE_HEADER_LINK\"></a></div><br><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"contactPreferenceVm.dtOptions\"><thead><tr><th translate=\"WIDGETS_LOC.CONTACT_PREFERENCE_COLUMN_NAME\"></th><th translate=\"WIDGETS_LOC.CONTACT_PREFERENCE_COLUMN_PREFERRED\"></th><th translate=\"WIDGETS_LOC.CONTACT_PREFERENCE_COLUMN_ACTIONS\"></th></tr></thead><tbody><tr ng-repeat=\"contact in contactPreferenceVm.ngModel | orderBy:contactPreferenceVm.sortType\"><td>{{contact.FullName}}</td><td ng-bind=\"contact.IsPreferred == true ? (\'WIDGETS_LOC.CONTACT_PREFERENCE_PREFERRED_YES\' | translate) : (\'WIDGETS_LOC.CONTACT_PREFERENCE_PREFERRED_NO\' | translate)\"></td><td><md-icon md-font-icon=\"icon-pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"contactPreferenceVm.onEdit(contact.ContactBasic.id)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.CONTACT_PREFERENCE_DELETE_MESSAGE\' | translate}}\" callback=\"contactPreferenceVm.remove\" section=\"{{\'WIDGETS_LOC.CONTACT_PREFERENCE_DELETE_SECTION\' | translate}}\"></delete-component></td></tr></tbody></table></md-card-content></md-card><br></div>");
$templateCache.put("app/shared/widgets/singleAddress/input-address-dialog.html","<md-dialog aria-label=\"{{vm.title}}\" flex=\"40\" flex-sm=\"90\" ng-cloak=\"\"><form name=\"addressDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"WIDGETS_LOC.SINGLE_ADDRESS_HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.showText\"><div layout=\"row\" flex=\"\" ng-if=\"vm.usedBy === \'JobBooking\'\"><md-input-container flex=\"\"><md-select name=\"lastAddresses\" ng-model=\"vm.jobLocation\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_LAST_10_PLACEHOLDER\' | translate}}\" md-on-close=\"vm.onChange()\"><md-option ng-repeat=\"jobLocation in vm.last10Addresses\" ng-value=\"jobLocation\">{{jobLocation.FullAddress}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" single-address=\"\" country=\"{{vm.localSettings.gmapCountry}}\" ng-model=\"vm.location\" call-back=\"vm.callBack\" md-autofocus=\"\"></md-input-container></div></div><div ng-if=\"vm.showMap\"><places-map custom-callback=\"vm.customCallbackFunction(pickedPlace)\" address=\"vm.initAddress\" text-input=\"vm.location\" country=\"{{vm.localSettings.gmapCountry}}\" draggable=\"true\" updatemarkerlabel=\"false\"></places-map></div><div ng-if=\"vm.addressDetailsSection\"><div layout=\"row\" flex=\"\" ng-if=\"vm.usedBy != \'JobBooking\'\"><md-input-container flex=\"\"><label translate=\"WIDGETS_LOC.SINGLE_ADDRESS_TYPE\"></label><md-select ng-model=\"vm.address.addressType\" ng-model-options=\"{trackBy: \'$value.Id\'}\" name=\"addressType\" required=\"\"><md-option ng-repeat=\"addressType in vm.addressTypes\" ng-value=\"addressType\">{{addressType.TypeName}}</md-option></md-select></md-input-container></div><div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input type=\"text\" name=\"addressPrefix\" ng-model=\"vm.address.AddressPrefix\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_PREFIX\' | translate}}\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input type=\"text\" name=\"bldgName\" ng-model=\"vm.address.BldgName\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_BLDG_NAME\' | translate}}\"></md-input-container></div><div layout-sm=\"column\" layout-xs=\"column\" layout-md=\"column\" layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"unitNumber\" ng-model=\"vm.address.UnitNumber\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_UNIT\' | translate}}\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><input type=\"text\" name=\"streetNumber\" ng-model=\"vm.address.StreetNumber\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_ST_NO\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"streetName\" ng-model=\"vm.address.StreetName\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_ST_NAME\' | translate}}\"></md-input-container></div><div layout-sm=\"column\" layout-xs=\"column\" layout-md=\"column\" layout=\"row\"><md-input-container><input type=\"text\" name=\"Suburb\" ng-model=\"vm.address.Suburb\" required=\"\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_SUBURB\' | translate}}\"></md-input-container><md-input-container><input type=\"text\" required=\"\" name=\"State\" ng-model=\"vm.address.State\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_STATE\' | translate}}\"></md-input-container><md-input-container><input type=\"text\" name=\"postalCode\" ng-model=\"vm.address.PostCode\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_POSTAL\' | translate}}\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"\"><label translate=\"WIDGETS_LOC.SINGLE_ADDRESS_COUNTRY\"></label><md-select ng-model=\"vm.address.Country\"><md-option ng-repeat=\"country in vm.countries\" ng-value=\"country.Name\">{{country.Name}}</md-option></md-select></md-input-container></div><div layout-sm=\"column\" layout-xs=\"column\" layout-md=\"column\" layout=\"row\"><md-input-container flex-gt-sm=\"\"><input type=\"text\" ng-disabled=\"true\" style=\"color :#3c3c3c\" ng-model=\"vm.address.Location.Latitude\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_LAT\' | translate}}\"></md-input-container><md-input-container flex-gt-sm=\"\"><input type=\"text\" style=\"color :#3c3c3c\" ng-disabled=\"true\" ng-model=\"vm.address.Location.Longitude\" placeholder=\"{{\'WIDGETS_LOC.SINGLE_ADDRESS_LONG\' | translate}}\"></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\"><span ng-if=\"vm.customAddress && !vm.showText\" translate=\"WIDGETS_LOC.SINGLE_ADDRESS_TIP\"></span></div><div flex=\"\" layout=\"row\" layout-align=\"end center\"><div><md-button translate=\"WIDGETS_LOC.SINGLE_ADDRESS_CUSTOM_ADDRESS\" class=\"md-raised md-accent\" ng-click=\"vm.showCustomAddress()\" ng-if=\"vm.customAddress\"></md-button><md-button translate=\"WIDGETS_LOC.SINGLE_ADDRESS_DROP_PIN\" class=\"md-raised md-accent\" ng-click=\"vm.dropPin()\" ng-if=\"vm.showPinButton\"></md-button><md-button translate=\"WIDGETS_LOC.SINGLE_ADDRESS_APPLY_ADDRESS\" class=\"md-raised md-accent\" ng-click=\"vm.applyPinAddress()\" ng-disabled=\"!vm.addressChaged\" ng-if=\"vm.customAddress && !vm.showText\"></md-button><md-button translate=\"WIDGETS_LOC.SINGLE_ADDRESS_SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"addressDialog.$invalid\" ng-if=\"vm.addressDetailsSection\"></md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/shared/widgets/singleAddress/job-latitude-longitude-dialog.html","<md-dialog aria-label=\"{{vm.title}}\" flex=\"40\" flex-sm=\"90\" ng-cloak=\"\"><form name=\"addressDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"WIDGETS_LOC.JOB_COORDINATES_HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.showMap\"><places-map address=\"vm.initAddress\" text-input=\"vm.location\" country=\"{{vm.localSettings.gmapCountry}}\"></places-map></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/shared/widgets/singleAddress/single-address.html","<div layout=\"column\" flex=\"\"><md-input-container><input type=\"text\" placeholder=\"{{singleAddressvm.placeholder}}\" ng-model=\"singleAddressvm.ngModel.FullAddress\" ng-click=\"singleAddressvm.showDialog()\" ng-readonly=\"true\" ng-disabled=\"singleAddressvm.isLocked || (singleAddressvm.isLockedByPreSchedule && singleAddressvm.isSmartSchedulingEnabled)\" ng-required=\"singleAddressvm.usedBy == \'JobBooking\'\"></md-input-container></div>");
$templateCache.put("app/main/assets/directives/hire-rate-dialog.html","<md-dialog aria-label=\"Contact Address\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'ASSETSMODULE.KIT_HIRE_RATE_DIALOG_HIRE_RATE\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"hireRateVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"hireRateEntryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.KIT_HIRE_RATE_DIALOG_HIRE_PERIOD\"></label><md-select name=\"hirePeriod\" ng-model=\"hireRateVm.hirePeriod\" required=\"\"><md-option ng-repeat=\"hireRate in hireRateVm.periods\" value=\"{{hireRate.Id}}\">{{hireRate.Name}}</md-option></md-select><div ng-messages=\"hireRateEntryForm.hirePeriod.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.KIT_HIRE_RATE_DIALOG_ITEM_TYPE_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.KIT_HIRE_RATE_DIALOG_HIRE_COST\"></label> <input type=\"number\" pattern=\"[0-9]+([\\.,][0-9]+)?\" step=\"1\" min=\"1\" name=\"cost\" ng-model=\"hireRateVm.cost\" placeholder=\"0.00\" required=\"\"><div ng-messages=\"hireRateEntryForm.cost.$error\" ng-show=\"hireRateEntryForm.cost.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.KIT_HIRE_RATE_DIALOG_HIRE_COST_FIELD_IS_REQUIRED\"></span></div><div ng-message=\"number\"><span translate=\"ASSETSMODULE.KIT_HIRE_RATE_DIALOG_NOT_A_VALID_NUMBER\"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"ASSETSMODULE.KIT_HIRE_RATE_DIALOG_CANCEL\" class=\"md-raised\" ng-click=\"hireRateVm.onCancel()\"></md-button><md-button ng-click=\"hireRateVm.onAdd()\" class=\"md-accent md-raised\" aria-label=\"Add\" ng-disabled=\"hireRateEntryForm.$invalid || hireRateEntryForm.$pristine\" translate=\"ASSETSMODULE.KIT_HIRE_RATE_DIALOG_ADD\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/directives/hire-rate.html","<div layout=\"column\" layout-gt-xs=\"row\" class=\"main-style\"><md-button class=\"md-accent md-raised\" ng-click=\"hireRateVm.onAddHireRate()\">{{\'ASSETSMODULE.KIT_HIRE_RATE_ADD_HIRE_RATE\' | translate}}</md-button><md-divider></md-divider></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><table class=\"simple hire-rate-table\" ms-responsive-table=\"\"><thead><tr><th>{{\'ASSETSMODULE.KIT_HIRE_RATE_HIRE_PERIOD\' | translate}}</th><th>{{\'ASSETSMODULE.KIT_HIRE_RATE_RATE\' | translate}}</th><th>{{\'ASSETSMODULE.KIT_HIRE_RATE_ACTIONS\' | translate}}</th></tr></thead><tfoot><tr><td colspan=\"3\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"hireRateVm.ngModel.length <= 0\"><span>{{\'ASSETSMODULE.KIT_HIRE_RATE_NO_CURRENT_HIRE_RATE\' | translate}}</span></div></td></tr></tfoot><tbody><tr ng-repeat=\"hireRate in hireRateVm.ngModel | orderBy:hireRateVm.sortType\"><td class=\"name\">{{hireRate.periodName}}</td><td class=\"hireCost\">{{hireRate.hireCost | currency}}</td><td class=\"actions\" style=\"padding-right: 0;\"><div layout=\"row\"><md-button class=\"md-icon-button\" style=\"padding-right: 0; margin-right: 0\" aria-label=\"Edit\" translate=\"\" translate-attr-aria-label=\"ASSETSMODULE.EDIT\" ng-click=\"hireRateVm.onEdit(hireRate.id)\"><md-icon md-font-icon=\"icon-pencil s20\"></md-icon><md-tooltip><span>Edit hire rate item.</span></md-tooltip></md-button><delete-component index=\"$index\" tool-tip=\"{{\'ASSETSMODULE.KIT_HIRE_RATE_REMOVE_PRICE\' | translate}}\" message=\"{{\'ASSETSMODULE.KIT_HIRE_RATE_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_PRICE?\' | translate}}\" callback=\"hireRateVm.remove\" section=\"{{\'ASSETSMODULE.KIT_HIRE_RATE_BASE_OR_HIRE_PRICE\' | translate}}\"></delete-component></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/branch/create/branch-create.html","<div id=\"branch-create\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-card-actions layout=\"row\" layout-align-start-center=\"\" layout-row=\"\"><md-button class=\"md-raised md-accent first-button-margin\" ng-show=\"vm.showFields\" translate=\"BRANCH_CREATE.SAVE\" ng-disabled=\"branchForm.$invalid || customfields.$invalid\" ng-click=\"vm.saveBranch()\"></md-button></md-card-actions></div></div><div class=\"content\" flex=\"\"><div id=\"branch\"><form name=\"branchForm\" novalidate=\"\" ng-show=\"vm.showFields\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"40\"><input type=\"text\" name=\"branchName\" ng-model=\"vm.service.branchData.Name\" placeholder=\"{{\'BRANCH_CREATE.NAME\' | translate}}\" ng-disabled=\"vm.isEditMode\" required=\"\"></md-input-container><md-input-container flex=\"40\"><label translate=\"BRANCH_CREATE.EMPLOYEE_CODE_PREFIX\"></label> <input type=\"text\" name=\"employeeCodePrefix\" ng-model=\"vm.service.branchData.EmployeeCodePrefix\" ng-pattern=\"/^[a-zA-Z\\s]*$/\" placeholder=\"{{\'BRANCH_CREATE.EMPLOYEE_CODE_PREFIX_HINT\' | translate}}\"></md-input-container><md-input-container flex=\"40\"><label translate=\"BRANCH_CREATE.BUSINESS\"></label><md-select placeholder=\"{{\'BRANCH_CREATE.SELECT_A_BUSINESS\' | translate}}\" ng-model=\"vm.service.branchData.InvoicingBusiness\" ng-model-options=\"{trackBy : \'$value.id || $value.Id\'}\" required=\"\" ng-change=\"vm.checkIfInvoicingBusinessIsNull()\" name=\"InvoicingBusiness\"><md-option value=\"\"></md-option><md-option ng-repeat=\"invoicingBusiness in vm.invoicingBusinesses\" ng-value=\"invoicingBusiness\">{{ invoicingBusiness.fields[\"BusinessName\"] }}</md-option></md-select></md-input-container><md-input-container flex=\"40\" ng-if=\"vm.claimsUtilService.isPayrollEnabled()\"><label translate=\"BRANCH_CREATE.AWARD\"></label><md-select placeholder=\"Award\" ng-model=\"vm.service.branchData.Award\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"award in vm.awards\" ng-value=\"award\" ng-disabled=\"award.IsArchived\">{{award.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"40\"><label translate=\"BRANCH_CREATE.TIMEZONE\"></label><md-select ng-model=\"vm.service.branchData.Timezone\" name=\"Timezone\" required=\"\"><md-option ng-value=\"timezone.Value\" ng-repeat=\"timezone in vm.timezones\">{{timezone.DisplayText}}</md-option></md-select></md-input-container><md-input-container flex=\"40\" ng-if=\"vm.isXeroEnabled\"><label translate=\"BRANCH_CREATE.COST_CENTRE\"></label> <input type=\"text\" name=\"costCentre\" ng-model=\"vm.service.branchData.CostCentre\" placeholder=\"{{\'BRANCH_CREATE.COST_CENTRE\' | translate}}\"></md-input-container></div></div><div class=\"form-wrapper md-whiteframe-1dp\"><h3>Address Details</h3><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"50\"><input type=\"text\" single-address=\"\" country=\"{{vm.countryGmap}}\" ng-model=\"vm.service.branchData.Address\" call-back=\"vm.callBack\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"30\"><input type=\"text\" name=\"addressPrefix\" ng-model=\"vm.service.branchData.AddressPrefix\" placeholder=\"{{\'BRANCH_CREATE.PREFIX\' | translate}}\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"30\"><input type=\"text\" name=\"Suburb\" ng-model=\"vm.service.branchData.Suburb\" placeholder=\"{{\'BRANCH_CREATE.SUBURB\' | translate}}\" required=\"\"></md-input-container><md-input-container flex=\"15\"><input type=\"text\" name=\"State\" ng-model=\"vm.service.branchData.State\" placeholder=\"{{\'BRANCH_CREATE.STATE\' | translate}}\" required=\"\"></md-input-container><md-input-container flex=\"15\"><input type=\"text\" name=\"PostCode\" ng-model=\"vm.service.branchData.Postcode\" placeholder=\"{{\'BRANCH_CREATE.CODE\' | translate}}\" required=\"\"><div ng-messages=\"formContact.PostCode.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please enter Post Code</span></div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"30\"><input type=\"text\" name=\"Latitude\" ng-model=\"vm.service.branchData.Location.Latitude\" placeholder=\"{{\'BRANCH_CREATE.LATITUDE\' | translate}}\"></md-input-container><md-input-container flex=\"30\"><input type=\"text\" name=\"Longitude\" ng-model=\"vm.service.branchData.Location.Longitude\" placeholder=\"{{\'BRANCH_CREATE.LONGITUDE\' | translate}}\"></md-input-container></div></div><div class=\"form-wrapper md-whiteframe-1dp\"><h3>Contact Details</h3><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"33\"><input type=\"text\" name=\"Phone\" ng-model=\"vm.service.branchData.Phone\" placeholder=\"{{\'BRANCH_CREATE.PHONE\' | translate}}\" required=\"\"></md-input-container><md-input-container flex=\"33\"><input type=\"text\" name=\"Fax\" ng-model=\"vm.service.branchData.Fax\" placeholder=\"{{\'BRANCH_CREATE.FAX\' | translate}}\"></md-input-container></div></div><div class=\"form-wrapper md-whiteframe-1dp\" ng-if=\"vm.isBranchSettingsSectionVisible\"><h3>{{\'BRANCH_CREATE.SETTINGS.TITLE\' | translate}}</h3><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\" ng-if=\"vm.isSendPaperworkToSiteContactOptionVisible\"><md-checkbox ng-model=\"vm.service.branchData.SendPaperworkToSiteContact\">{{\'BRANCH_CREATE.SETTINGS.SEND_PAPERWORK_TO_SITE_CONTACT\' | translate}}</md-checkbox></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\" ng-if=\"vm.claimsUtilService.isAltusSpecialEnabled()\"><md-checkbox ng-model=\"vm.service.branchData.AltusPaperworkForInvoiceEmail\">{{\'BRANCH_CREATE.SETTINGS.ALTUS_PAPERWORK_FOR_INVOICE_EMAIL\' | translate}}</md-checkbox></div></div><div flex=\"85\" ng-if=\"vm.isEditMode\"><a8-emails-with-type ng-model=\"vm.service.branchData.Emails\" hide-primary=\"true\" show-scheduling-alerts=\"true\"></a8-emails-with-type></div><div class=\"mt-20\"><divisions-directive flex=\"100\" ng-if=\"vm.isEditMode\" service=\"vm.service\"></divisions-directive></div><div class=\"mt-20\"><form-templates-list flex=\"\" form-types=\"vm.formTypes\" linked-form-templates=\"vm.service.linkedFormTemplates\" unlinked-form-templates=\"vm.service.unlinkedFormTemplates\" overridden-form-templates=\"vm.service.overriddenFormTemplates\" api=\"vm.service.formTemplatesListApi\" vehicles=\"vm.service.vehicles\" assets=\"vm.service.assets\" always-refresh-forms-list=\"vm.isEditMode\" applied-to=\'[\"AllBranches\"]\' ng-if=\"vm.claimsUtilService.isCustomFormsEnabled()\"></form-templates-list></div><div class=\"mt-20\"><document-manager module-id=\"5\" flex=\"1\" module-name=\"Branch\" related-resource-id=\"{{vm.branchId}}\" ng-if=\"vm.isEditMode && vm.claimsUtilService.isDocumentManagementEnabled()\" disable-add=\"!vm.hasDocumentsManagerBranches\" disable-edit=\"!vm.hasDocumentsManagerBranches\" disable-delete=\"!vm.hasDocumentsManagerBranches\"></document-manager></div><div class=\"mt-20\"><required-attachment-types attachment-types=\"vm.service.branchData.RequiredAttachmentTypes\" remove-callback=\"vm.service.removeRequiredAttachmentType\" ng-if=\"vm.isEditMode && vm.isConfigurableRequiredAttachmentsEnabled\"></required-attachment-types></div></form></div><div flex=\"80\" style=\"margin-top : 20px;\" ng-if=\"vm.claimsUtilService.isAltusSpecialEnabled()\"><custom-fields-binder ng-form=\"customfields\" is-disabled=\"vm.disableForm\" trigger-save=\"vm.service.saveTrigger\" font-size=\"1.6rem\" source=\"Branches\" padding=\"8px\" values=\"vm.service.branchData.CustomFields\" ng-model=\"vm.service.branchData.CustomFieldsValues\" fields-list=\"vm.fields\"></custom-fields-binder></div></div></div></div>");
$templateCache.put("app/main/awards/interpreter/awards-interpreter.html","<div id=\"award-view\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"form-wrapper md-whiteframe-1dp main-style mb-20\" layout=\"column\"><div layout=\"row\"><div layout=\"row\" ng-click=\"vm.service.showPayruns = !vm.service.showPayruns;\" style=\"cursor: pointer;\" ng-if=\"false\"><div class=\"mt-20\" style=\"margin-right: 6px;\"><i class=\"icon-chevron-up\" ng-if=\"!vm.service.showPayruns\"></i> <i class=\"icon-chevron-down\" ng-if=\"vm.service.showPayruns\"></i></div><h2 class=\"no-text-select\">Payruns</h2><span class=\"ml-5 font-size-12 mt-20 md-caption\" style=\"line-height: 24px;\">({{vm.payrollInterpretJobs.length}})</span></div><div flex=\"\"></div><div flex=\"15\" flex-lg=\"20\" flex-md=\"25\" flex-sm=\"25\" flex-xs=\"100\" layout=\"column\" layout-align=\"center center\" class=\"pl-15 pr-20\"><div ng-disabled=\"vm.service.isProcessing\" ng-click=\"vm.newPayrun()\" style=\"cursor: pointer;\" flex=\"15\" flex-xs=\"100\" flex-sm=\"30\" flex-md=\"25\" layout=\"row\" layout-align=\"center center\" class=\"pr-20\"><md-button class=\"md-fab md-mini md-accent pull-right btn-add\" aria-label=\"New Payrun\" style=\"background-color: #4A1EBD;\"><md-icon class=\"icon-plus\"></md-icon></md-button><div style=\"color: #BB06FE;\">New Payrun</div></div></div></div><div ng-show=\"vm.service.showPayruns\" layout=\"column\" class=\"p-20\" ng-if=\"false\"><span ng-if=\"vm.service.payrollInterpretJobs.length < 1\">There are no payruns to displays.</span><div ng-if=\"vm.service.payrollInterpretJobs.length > 0\" layout=\"column\"><span class=\"text-bold text-uppercase ml-10 mb-10\">Select To View</span><div layout=\"row\" layout-wrap=\"\" ms-scroll=\"\" style=\"max-height: 350px;\"><div class=\"card flex-25 p-15 no-text-select\" layout=\"row\" ng-repeat=\"interpretJob in vm.service.payrollInterpretJobs | orderBy: \'-GeneratedOn\'\" ng-click=\"vm.loadInterpretJob(interpretJob)\" style=\"cursor: pointer;\"><div flex=\"\" layout=\"column\" class=\"pt-10\"><div><span class=\"bold-text\">Branches:</span><span>{{interpretJob.InterpreterSettings.BranchesText}}</span></div><div><span class=\"bold-text\">Start date:</span><span>{{interpretJob.InterpreterSettings.StartDate | date:\'MM/dd/yyyy\'}}</span></div><div><span class=\"bold-text\">End date:</span><span>{{interpretJob.InterpreterSettings.EndDate | date:\'MM/dd/yyyy\'}}</span></div><div><span class=\"bold-text\">Generated by:</span><span>{{interpretJob.GeneratedBy}}</span></div><div><span>{{interpretJob.GeneratedOn | date:\'hh:mma MM/dd/yyyy\'}}</span></div></div><div flex=\"10\" layout=\"column\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.newPayrun(interpretJob)\"><md-icon md-font-icon=\"icon-replay\" class=\"icon s18\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.deleteInterpretJob(interpretJob)\"><md-icon md-font-icon=\"icon-trash\" class=\"icon s18 red-500-fg\"></md-icon></md-button></div></div></div></div></div></div><div class=\"form-wrapper md-whiteframe-1dp main-style\" layout=\"column\" ng-show=\"vm.service.showPayrunSettings\"><div layout=\"row\" ng-form=\"awardForm\" class=\"mb-15\"><div flex=\"33\" layout-align=\"start center\" class=\"pl-20 pr-20\"><md-input-container id=\"branches\"><label translate=\"RUN_PAYROLL.BRANCHES\"></label><md-select placeholder=\"{{\'RUN_PAYROLL.BRANCHES\' | translate}}\" md-selected-text=\"vm.utilService.getSelectedText(vm.service.selectedBranches, vm.utilService.translate(\'RUN_PAYROLL.BRANCHES\'), \'Name\')\" name=\"Branches\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\" ng-model=\"vm.service.selectedBranches\" multiple=\"\"><md-optgroup label=\"{{\'RUN_PAYROLL.STATES\' | translate}}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.service.branches| filter: {\'State\': \'!\'}| orderBy:[\'Name\'] as _states track by $index + \'-\' + branch.Id + \'-state\'\">{{branch.Name}}</md-option></md-optgroup><md-optgroup label=\"{{\'RUN_PAYROLL.BRANCHES\' | translate}}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.service.branches| filter: {\'State\': \'\'}| orderBy:[\'Name\'] as _branches track by $index + \'-\' + branch.Id\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"\" layout=\"row\"><label translate=\"RUN_PAYROLL.START_DATE\"></label><md-datepicker name=\"startDate\" ng-model=\"vm.service.startDate\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\" ng-change=\"vm.validateDates()\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\" required=\"\"></md-datepicker></md-input-container><md-input-container flex=\"\" layout=\"row\"><label translate=\"RUN_PAYROLL.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.service.endDate\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\" ng-change=\"vm.validateDates()\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\" required=\"\"></md-datepicker></md-input-container><span class=\"alert-error date-error-message\" ng-if=\"vm.dateErrorMessage\">{{vm.dateErrorMessage}}</span></div><div flex=\"33\" layout-align=\"start center\" class=\"pl-20 pr-20 pt-10 payroll-options\"><md-input-container><md-checkbox ng-model=\"vm.service.exportSalaryCodes\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\">Export Salary Codes</md-checkbox><div class=\"field-note pt-5\" ng-if=\"vm.isNewPayrun\">Used to export weekly salary codes only. Please note, salary employees who are added to a shift will be paid any relevant pay for each shift based on their award regardless of checking this option.</div></md-input-container><md-input-container><md-checkbox ng-model=\"vm.service.exportPermanentParttimeTopups\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\">Export Permanent Part-time Top-ups</md-checkbox><div class=\"field-note pt-5\" ng-if=\"vm.isNewPayrun\">Includes any Permanent Part-time minimum hours top-ups.</div></md-input-container><md-input-container><md-checkbox ng-model=\"vm.service.exportPermanentParttimePublicHolidayTopups\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\">Export Permanent Part-time Public Holiday Top-ups</md-checkbox><div class=\"field-note pt-5\" ng-if=\"vm.isNewPayrun\">Includes any Permanent Part-time public holiday minimum hours top-ups.</div></md-input-container><md-input-container><md-checkbox ng-model=\"vm.service.exportPermanentFulltimeTopups\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\">Export Permanent Full-time Top-ups</md-checkbox><div class=\"field-note pt-5\" ng-if=\"vm.isNewPayrun\">Includes any Permanent Full-time minimum hours top-ups.</div></md-input-container><md-input-container><md-checkbox ng-model=\"vm.service.exportPermanentFulltimePublicHolidayTopups\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\">Export Permanent Full-time Public Holiday Top-ups</md-checkbox><div class=\"field-note pt-5\" ng-if=\"vm.isNewPayrun\">Includes any Permanent Full-time public holiday minimum hours top-ups.</div></md-input-container><md-input-container><md-checkbox ng-model=\"vm.service.exportCalendarEntryTopups\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\">Export Calendar Entry Top-ups</md-checkbox><div class=\"field-note pt-5\" ng-if=\"vm.isNewPayrun\">Includes any calendar entry payments (for example, Toolbox meetings).</div></md-input-container><md-input-container ng-if=\"vm.isMyobEnabled && vm.service.isConnectedToMyob\"><md-checkbox ng-model=\"vm.service.overwriteExistingTimesheetsWhenExporting\" ng-disabled=\"vm.service.isProcessing || !vm.isNewPayrun\">Overwrite existing timesheets when exporting to MYOB if there is a mismatch error.</md-checkbox></md-input-container></div><div flex=\"33\" layout=\"column\" layout-align=\"start center\" class=\"pl-20 pr-20 buttons-bar\"><div ng-if=\"!vm.service.isProcessing\"><div class=\"row\"><md-button ng-disabled=\"awardForm.$invalid || vm.service.isProcessing || vm.service.isFailedToInterpret\" translate=\"RUN_PAYROLL.INTERPRET\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme first-button-margin\" ng-click=\"vm.interpret()\" ng-if=\"vm.isNewPayrun || vm.service.isFailedToInterpret\"></md-button></div><div class=\"row\" ng-if=\"vm.isIntegrationsEnabled && !vm.isNewPayrun && !vm.service.isFailedToInterpret\"><md-input-container class=\"ml-5 mt-10 mb-0\" flex=\"\" ng-if=\"vm.service.recordsHaveBeenValidated\"><md-checkbox ng-model=\"vm.service.revalidateAllTimesheets\" ng-disabled=\"vm.service.hasOtherPayrunInProgress || vm.service.payrollRecords == 0 || (!vm.service.isConnectedToMyob && !vm.service.isConnectedToXero) || !vm.shouldValidateAgainstProvider()\">Revalidate All</md-checkbox><div class=\"field-note pt-5\">Include records without errors.</div></md-input-container></div><div class=\"row\"><md-button ng-disabled=\"vm.service.payrollRecords == 0 || (!vm.service.isConnectedToMyob && !vm.service.isConnectedToXero) || !vm.shouldValidateAgainstProvider()\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme first-button-margin\" ng-click=\"vm.validate()\">Validate</md-button></div><div class=\"row\"><md-button ng-if=\"vm.isXeroEnabled && vm.adminClaimsService.hasRunPayrollPermission && !vm.isNewPayrun && !vm.service.isFailedToInterpret\" ng-disabled=\"vm.service.hasOtherPayrunInProgress || !vm.service.isConnectedToXero || !vm.service.userHasAccessToPayrollCompany || !vm.shouldExportToProvider() || vm.exportingTimesheetsTimeoutError\" type=\"submit\" class=\"md-accent md-raised first-button-margin\" ng-click=\"vm.exportToExternalProvider()\">Export</md-button><md-button ng-if=\"vm.isMyobEnabled && vm.adminClaimsService.hasRunPayrollPermission && !vm.service.isFailedToInterpret\" class=\"md-accent md-raised first-button-margin\" ng-disabled=\"vm.service.hasOtherPayrunInProgress || !vm.service.isConnectedToMyob || !vm.service.userHasAccessToPayrollCompany || !vm.shouldExportToProvider() || vm.exportingTimesheetsTimeoutError\" ng-click=\"vm.exportToExternalProvider()\" ng-show=\"!vm.isNewPayrun\">Export</md-button><md-button ng-if=\"!vm.isIntegrationsEnabled && !vm.isNewPayrun && !vm.service.isFailedToInterpret\" ng-disabled=\"vm.service.payrollRecords == 0\" type=\"submit\" class=\"md-accent md-raised first-button-margin\" ng-click=\"vm.exportToFile()\">Export</md-button><md-button ng-if=\"!vm.isIntegrationsEnabled && !vm.isNewPayrun && !vm.service.isFailedToInterpret\" ng-disabled=\"vm.service.payrollRecords == 0\" type=\"submit\" class=\"md-accent md-raised first-button-margin\" ng-click=\"vm.reExportAll()\">Re-export</md-button></div></div><div class=\"row mt-10 mb-10 instruction-warning\" ng-if=\"vm.isIntegrationsEnabled && !vm.service.userHasAccessToPayrollCompany\"><div class=\"mb-10\"><span translate=\"RUN_PAYROLL.NO_CONNECTION_FOUND\"></span></div><div><span translate=\"RUN_PAYROLL.INTEGRATIONS_PAGE\" ng-click=\"vm.redirectToIntegrationsPage()\" class=\"clickable-item\"></span> <span translate=\"RUN_PAYROLL.BUSINESSES_PAGE\" ng-click=\"vm.redirectToBusinessesPage()\" class=\"clickable-item\"></span></div></div><div class=\"row mt-10 mb-10\" ng-if=\"vm.isIntegrationsEnabled && vm.service.userHasAccessToPayrollCompany\"><span translate=\"RUN_PAYROLL.CONNECTED\"></span> <span><strong>{{vm.service.interpreterSettings.payrollConnectorType}}</strong></span></div></div></div><div layout=\"column\" ng-if=\"!vm.service.isFailedToInterpret && !vm.isNewPayrun\"><div flex=\"\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><payroll-widget ng-repeat=\"widget in vm.service.widgets\" widget=\"widget\" flex=\"20\" flex-sm=\"50\" flex-md=\"50\" ng-if=\"widget.value\"></payroll-widget></div></div><div ng-if=\"vm.service.isProcessing || vm.service.progressBarMessage || vm.service.progressBarErrorMessage\" layout-align=\"start start\" layout=\"column\"><div layout=\"column\" class=\"mb-10 ml-15\"><div layout=\"row\" ng-if=\"vm.service.progressBarMessage || vm.service.progressBarErrorMessage\"><span ng-if=\"vm.service.progressBarMessage\" ng-class=\"{\'instruction-warning\': vm.service.isProcessing, \'text-bold\': !vm.service.isProcessing }\">{{vm.service.progressBarMessage}}</span><md-progress-circular ng-if=\"vm.service.isProcessing\" md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent ml-10 mr-10\"></md-progress-circular></div><span ng-if=\"vm.service.progressBarErrorMessage\" class=\"instruction-warning mt-5\">{{vm.service.progressBarErrorMessage}}</span></div></div><div ng-if=\"!vm.service.isPageInitialLoad && !vm.service.isFailedToInterpret\"><div layout=\"column\" flex=\"\"><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\" ng-class=\"{\'ml-10\': vm.isIntegrationsEnabled}\"><md-input-container ng-if=\"vm.isIntegrationsEnabled && vm.service.recordsHaveBeenValidated\" style=\"flex: 1\"><label translate=\"RUN_PAYROLL.FILTER\"></label><md-select ng-model=\"vm.service.resultsFilterOption\" ng-change=\"vm.service.onResultsFilterOptionChange()\"><md-option ng-repeat=\"filterOption in vm.service.filterOptions\" value=\"{{filterOption}}\">{{filterOption}}</md-option></md-select></md-input-container><a8-grid-search-component ng-if=\"vm.service.payrollRecords.length > 0\" delay=\"vm.delay\" source=\"vm.dataGrid.grid.searchTerm\" layout-margin=\"\" style=\"flex: 15\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"ml-10\" ng-if=\"!vm.service.isProcessing && vm.showStatusColumn()\"><award-interpretation-error-message items=\"vm.service.payrollRecords\"></award-interpretation-error-message></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div ng-if=\"vm.service.isProcessing\"><div layout-align=\"start start\" layout=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.service.progressBarCurrent == 0 ? 0 : (vm.service.progressBarCurrent/vm.service.progressBarMax)*100}}\" class=\"md-accent\"></md-progress-linear></div></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Code\" field-label=\"{{\'RUN_PAYROLL.COLUMN_CODE\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"RuleName\" field-label=\"{{\'RUN_PAYROLL.COLUMN_NAME\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Qty\" field-label=\"{{\'RUN_PAYROLL.COLUMN_QTY\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"EmployeeNo\" field-label=\"{{\'RUN_PAYROLL.COLUMN_EMP_NO\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"EmployeeName\" field-label=\"{{\'RUN_PAYROLL.COLUMN_EMPLOYEE\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CalculatedPayString\" field-label=\"{{\'RUN_PAYROLL.COLUMN_PAY\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\" ng-if=\"vm.isMyobEnabled\"><div class=\"table-header\"><a8-sort-column sort-by=\"MyobJobNumber\" field-label=\"{{\'RUN_PAYROLL.COLUMN_MYOB_JOB_NO\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"ShiftDate\" field-label=\"{{\'RUN_PAYROLL.COLUMN_SHIFT_DATE\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th></tr></thead><tbody><tr ng-repeat-start=\"item in vm.dataGrid.grid.data track by $index\"><td><award-interpreter-output-item-error-column ng-if=\"vm.showStatusColumn(item)\" interpreter-output-item=\"item\"></award-interpreter-output-item-error-column>{{item.Code}}</td><td>{{item.RuleName}}</td><td>{{item.Qty}}</td><td>{{item.EmployeeNo}}</td><td>{{item.EmployeeName}}</td><td>{{item.CalculatedPayString}}</td><td ng-if=\"vm.isMyobEnabled\">{{ vm.getMyobJobNumber(item) }}</td><td>{{vm.toLocalDate(item.ShiftDate)}}</td></tr><tr ng-repeat-end=\"\" ng-if=\"item.showErrors\"><td colspan=\"7\"><award-interpreter-output-item-error-details errors=\"item.PayrollErrors\" redirect-to-company-action=\"vm.redirectToCompanyPage(item)\"></award-interpreter-output-item-error-details></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"vm.dataGrid.grid.behavior\" distinct-by=\"UniqueId\" on-init=\"vm.dataGrid.grid.onInit()\" on-error=\"vm.dataGrid.grid.onError(ex)\" on-completed=\"vm.dataGrid.grid.onCompleted(data)\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div></div></div></div>");
$templateCache.put("app/main/branch/view/branch-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button translate=\"BRANCH_VIEW.ADD\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vm.onCreate()\"></md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{\'BRANCH_VIEW.SEARCH\' | translate}}\" ng-model=\"vm.service.query\" ng-keyup=\"vm.searchTable()\"></md-input-container></div></div><table class=\"dataTable row-border hover\" dt-instance=\"vm.dtInstance\" style=\"margin-top :10px;\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BRANCH_VIEW.COLUMN_NAME\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BRANCH_VIEW.COLUMN_ADDRESS\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BRANCH_VIEW.COLUMN_SUBURB\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BRANCH_VIEW.COLUMN_STATE\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BRANCH_VIEW.COLUMN_POST_CODE\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BRANCH_VIEW.COLUMN_PHONE\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BRANCH_VIEW.COLUMN_FAX\"></span></div></th><th class=\"secondary-text\"></th></tr></thead><tbody><tr ng-repeat=\"branch in vm.branches\"><td class=\"branch-name\">{{ branch.Name }}</td><td>{{ branch.Address}}</td><td>{{ branch.Suburb}}</td><td>{{ branch.State}}</td><td>{{ branch.Postcode}}</td><td>{{ branch.Phone}}</td><td>{{ branch.Fax}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.onEdit(branch.Id, branch.Name)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>Edit Branch</span></md-tooltip></md-button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/business/edit/business-edit.html","<div id=\"business-edit\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp fixed\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent first-button-margin\" ng-disabled=\"businessForm.$invalid\" translate=\"BUSINESSMODULE.SAVE\" ng-click=\"vm.onSave()\"></md-button><md-button translate=\"BUSINESSMODULE.CANCEL\" class=\"md-raised\" ng-click=\"vm.onCancel()\"></md-button><md-button class=\"md-raised md-accent first-button-margin pl-10 pr-10\" ng-disabled=\"businessForm.$invalid\" ng-click=\"vm.showDeactivateAlert()\">{{ (vm.business[\'IsActive\'] === \'true\' ?\'BUSINESSMODULE.DEACTIVATEBUSINESS\':\'BUSINESSMODULE.ACTIVATEBUSINESS\') | translate}}</md-button><md-button class=\"md-raised md-accent first-button-margin pl-10 pr-10\" translate=\"BUSINESSMODULE.VIEW_HISTORY\" ng-click=\"vm.viewHistory()\"></md-button></div></div><div class=\"content\" flex=\"\"><div id=\"business\" ng-form=\"businessForm\"><form novalidate=\"\" name=\"businessdetails\"><div class=\"form-wrapper md-whiteframe-1dp\"><h2>Business Details</h2><div layout=\"column\" layout-gt-md=\"row\"><div layout=\"column\" flex=\"50\"><md-input-container class=\"pr-20\"><input type=\"text\" ng-model=\"vm.business[\'BusinessName\']\" name=\"{{\'BUSINESSMODULE.BUSINESS_NAME\' | translate}}\" placeholder=\"{{\'BUSINESSMODULE.BUSINESS_NAME\' | translate}}\" ng-required=\"\"></md-input-container><md-input-container class=\"pr-20\" ng-show=\"vm.IsInvoicing || vm.IsPayroll\"><p class=\"form-label\">{{\'BUSINESSMODULE.WHAT_FOR\' | translate}}</p><md-checkbox name=\"whatfor\" ng-show=\"vm.IsInvoicing\" ng-model=\"vm.business[\'IsInvoicing\']\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" ng-required=\"!vm.business[\'IsPayroll\']\" class=\"md-primary\">{{\'BUSINESSMODULE.INVOICING\' | translate}}</md-checkbox><md-checkbox name=\"whatfor\" id=\"isPayroll\" ng-show=\"vm.IsPayroll\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" ng-model=\"vm.business[\'IsPayroll\']\" class=\"md-primary\" ng-required=\"!vm.business[\'IsInvoicing\'] && !vm.payrollBusinessAlreadyExists\" ng-disabled=\"vm.payrollBusinessAlreadyExists\">{{\'BUSINESSMODULE.PAYROLL\' | translate}}</md-checkbox><div class=\"checkbox-group-instruction instruction-warning mb-10 ml-40\"><label ng-show=\"vm.payrollBusinessAlreadyExists\">{{\'BUSINESSMODULE.SINGLE_PAYROLLBUSINESS_ERROR\' | translate}}</label></div></md-input-container></div><md-input-container><div layout=\"row\" id=\"uploadLogo\"><div flex=\"1\" class=\"mr-20\"><p class=\"form-label\">{{\'BUSINESSMODULE.UPLOAD_LOGO\' | translate}}</p><input type=\"file\" class=\"btn btn-primary\" id=\"businessLogo\" a8-file-upload=\"files\" on-upload-validate=\"vm.onUploadValidate(fileObj)\"><div class=\"margin-top-10\"><label class=\"instruction-info\">{{\'BUSINESSMODULE.MAXIMUM_FILE_SIZE_LABEL\' | translate}}</label> <label class=\"instruction-info\">{{\'BUSINESSMODULE.RECOMMENDED_SIZE\' | translate}}</label> <label class=\"instruction-info\">{{\'BUSINESSMODULE.FORMATS\' | translate}}</label></div></div><div flex=\"90\" layout-align=\"start center\"><img class=\"profile-image avatar huge-rectangle\" src=\"assets/images/avatars/company.jpg\" ng-src=\"{{vm.updatedLogo}}\"></div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" class=\"mb-20\"><div flex=\"50\" ng-if=\"vm.isIntegrationsEnabled\"><md-input-container><md-select ng-model=\"vm.selectedPayrollCompany\" ng-disabled=\"!vm.isConnectedToIntegrationsProvider() || vm.isPayrollCompanyDropdownDisabled\" placeholder=\"{{\'BUSINESSMODULE.SELECT_ACCOUNT\' | translate}}\" ng-model-options=\"{trackBy : \'$value.CompanyId\'}\"><md-option ng-repeat=\"payrollCompany in vm.payrollCompanies\" ng-value=\"payrollCompany\">{{ vm.getPayrollCompanyName(payrollCompany) }}</md-option></md-select></md-input-container><br><div class=\"dropdown-instruction instruction-warning\" ng-if=\"vm.isIntegrationsEnabled && !vm.isConnectedToIntegrationsProvider()\"><label translate=\"BUSINESSMODULE.NO_CONNECTION_FOUND\"></label> <label translate=\"BUSINESSMODULE.INTEGRATIONS_PAGE\" ng-click=\"vm.redirectToIntegrationsPage()\" class=\"clickable-item\"></label></div></div></div></div><div class=\"form-wrapper md-whiteframe-1dp mt-20\" ng-show=\"vm.business[\'IsInvoicing\']===\'true\'\"><div><div class=\"mb-20\"><h2>Invoice Details</h2><label class=\"md-subhead\">{{\'BUSINESSMODULE.INVOICE_NOTE\' | translate}}</label></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex=\"50\" class=\"pr-20\"><input type=\"text\" ng-model=\"vm.business[\'ABN\']\" name=\"{{vm.registeredBusinessNumberDisplayName}}\" placeholder=\"{{vm.registeredBusinessNumberDisplayName}}\" ng-required=\"vm.business[\'IsInvoicing\']===\'true\'\" md-maxlength=\"vm.registeredBusinessNumberMaxCharLimit\"></md-input-container><md-input-container flex=\"50\"><input type=\"text\" ng-model=\"vm.business[\'TradingName\']\" placeholder=\"{{\'BUSINESSMODULE.TRADINGNAME\' | translate}}\" name=\"{{\'BUSINESSMODULE.TRADINGNAME\' | translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><div flex=\"50\" class=\"pr-20\"><md-input-container flex=\"\" class=\"padding-right-5\" ng-if=\"vm.isBankBranchCodeVisible\"><input type=\"text\" ng-model=\"vm.business[\'BSB\']\" placeholder=\"{{\'BUSINESSMODULE.BSB\' | translate}}\" name=\"{{\'BUSINESSMODULE.BSB\' | translate}}\"></md-input-container><md-input-container flex=\"30\" class=\"padding-left-5\"><input type=\"text\" ng-model=\"vm.business[\'AccountNumber\']\" placeholder=\"{{\'BUSINESSMODULE.ACCOUNTNUMBER\' | translate}}\" name=\"{{\'BUSINESSMODULE.ACCOUNTNUMBER\' | translate}}\" md-maxlength=\"vm.bankAccountNumberMaxCharLimit\"></md-input-container></div><md-input-container flex=\"50\"><input type=\"text\" ng-model=\"vm.business[\'PhoneNumber\']\" placeholder=\"{{\'BUSINESSMODULE.PHONENUMBER\' | translate}}\" name=\"{{\'BUSINESSMODULE.PHONENUMBER\' | translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><div flex=\"50\" class=\"pr-20\"><single-address ng-model=\"vm.BusinessAddress\" country=\"AU\" used-by=\"Business\" is-edit=\"true\" placeholder=\"{{ \'BUSINESSMODULE.BUSINESSADDRESS\' | translate }}\"></single-address></div><md-input-container flex=\"50\"><input type=\"text\" ng-model=\"vm.business[\'FaxNumber\']\" placeholder=\"{{\'BUSINESSMODULE.FAXNUMBER\' | translate}}\" name=\"{{\'BUSINESSMODULE.FAXNUMBER\' | translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex=\"50\" class=\"pr-20\"><input type=\"text\" ng-model=\"vm.business[\'RemittanceEmail\']\" name=\"email\" placeholder=\"{{\'BUSINESSMODULE.REMITTANCEEMAIL\' | translate}}\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"></md-input-container><md-input-container flex=\"50\"><label translate=\"BUSINESSMODULE.TAX_ROUNDING\"></label><md-select ng-model=\"vm.taxRoundingRule\" placeholder=\"{{\'BUSINESSMODULE.TAX_ROUNDING\' | translate}}\"><md-option ng-repeat=\"taxRoundingRule in vm.taxRoundingRules\" ng-value=\"taxRoundingRule.Id\">{{ taxRoundingRule.Name }}</md-option></md-select></md-input-container></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/business/history/business-history-log-data.html","<table class=\"dataTable row-border\"><thead><tr><th>Field</th><th>Value</th></tr></thead><tbody><tr ng-if=\"vm.changes.IsActive\"><td>{{\'BUSINESSMODULE.ACTIVE\' | translate}}</td><td>{{vm.changes.IsActive == \"true\" ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=\"vm.changes.BusinessName\"><td>{{\'BUSINESSMODULE.BUSINESS_NAME\' | translate}}</td><td>{{vm.changes.BusinessName}}</td></tr><tr ng-if=\"vm.changes.LogoUrl != null\"><td>{{\'BUSINESSMODULE.LOGO\' | translate}}</td><td>{{\'BUSINESSMODULE.LOGO_CHANGED\' | translate}}</td></tr><tr ng-if=\"vm.changes.IsInvoicing != null || vm.changes.IsPayroll != null\"><td>{{\'BUSINESSMODULE.WHAT_FOR\' | translate}}</td><td>{{vm.businessFor}}</td></tr><tr ng-if=\"vm.changes.AccountName != null\"><td>{{\'BUSINESSMODULE.SELECT_ACCOUNT\' | translate}}</td><td>{{vm.changes.AccountName}}</td></tr><tr ng-if=\"vm.changes.ABN != null\"><td>{{vm.registeredBusinessNumberDisplayName}}</td><td>{{vm.changes.ABN}}</td></tr><tr ng-if=\"vm.changes.AccountNumber != null\"><td>{{\'BUSINESSMODULE.ACCOUNTNUMBER\' | translate}}</td><td>{{vm.changes.AccountNumber}}</td></tr><tr ng-if=\"vm.changes.TradingName != null\"><td>{{\'BUSINESSMODULE.TRADINGNAME\' | translate}}</td><td>{{vm.changes.TradingName}}</td></tr><tr ng-if=\"vm.changes.BSB != null\"><td>{{\'BUSINESSMODULE.BSB\' | translate}}</td><td>{{vm.changes.BSB}}</td></tr><tr ng-if=\"vm.changes.PhoneNumber != null\"><td>{{\'BUSINESSMODULE.PHONENUMBER\' | translate}}</td><td>{{vm.changes.PhoneNumber}}</td></tr><tr ng-if=\"vm.businessAddress\"><td>{{\'BUSINESSMODULE.BUSINESSADDRESS\' | translate}}</td><td>{{vm.businessAddress}}</td></tr><tr ng-if=\"vm.changes.FaxNumber != null\"><td>{{\'BUSINESSMODULE.FAXNUMBER\' | translate}}</td><td>{{vm.changes.FaxNumber}}</td></tr><tr ng-if=\"vm.changes.RemittanceEmail != null\"><td>{{\'BUSINESSMODULE.REMITTANCEEMAIL\' | translate}}</td><td>{{vm.changes.RemittanceEmail}}</td></tr><tr ng-if=\"vm.changes.TaxRoundingRule != null\"><td>{{\'BUSINESSMODULE.TAX_ROUNDING\' | translate}}</td><td>{{vm.changes.TaxRoundingRule}}</td></tr></tbody></table>");
$templateCache.put("app/main/business/view/business-create-dialog.html","<md-dialog class=\"dashboard-manage\" id=\"business-create-dialog\" flex=\"40\" ng-cloak=\"\"><form name=\"businessform\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"BUSINESSMODULE.CREATE_BUSINESS\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><processor-loader show=\"vm.isSaving\" message=\"vm.loaderMessage\"></processor-loader><div layout=\"row\" dimmer=\"\" ng-model=\"vm.isSaving\"><md-input-container><p class=\"form-label\">{{\'BUSINESSMODULE.BUSINESS_NAME\' | translate}}</p><input type=\"text\" ng-model=\"vm.model.BusinessName\" required=\"\"></md-input-container></div><div ng-show=\"vm.model.IsInvoicing || vm.model.IsPayrollEnabled\"><p class=\"form-label\">{{\'BUSINESSMODULE.WHAT_FOR\' | translate}}</p><div layout=\"row\" dimmer=\"\" ng-model=\"vm.isSaving\"><div layout=\"column\" class=\"margin-right-10\"><md-checkbox ng-model=\"vm.model.IsInvoicing\" class=\"md-primary\">{{\'BUSINESSMODULE.INVOICING\' | translate}}</md-checkbox></div><div layout=\"column\" class=\"margin-right-10\"><md-checkbox id=\"isPayroll\" ng-hidden=\"vm.model.isPayroll!==true\" ng-disabled=\"vm.payrollBusinessAlreadyExists==true\" ng-model=\"vm.model.IsPayroll\" class=\"md-primary\">{{\'BUSINESSMODULE.PAYROLL\' | translate}}</md-checkbox><span ng-show=\"vm.payrollBusinessAlreadyExists==true\" style=\"color:#e8ab00\">{{\'BUSINESSMODULE.SINGLE_PAYROLLBUSINESS_ERROR\' | translate}}</span></div></div></div></md-dialog-content></form><md-dialog-actions dimmer=\"\" ng-model=\"vm.isSaving\"><md-button translate=\"BUSINESSMODULE.CANCEL\" class=\"md-raised\" ng-click=\"vm.onClose()\"></md-button><md-button translate=\"BUSINESSMODULE.NEXT\" class=\"md-raised md-accent\" ng-click=\"vm.save()\" ng-disabled=\"businessform.$invalid\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/business/view/business-view.html","<div id=\"business-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp search-container\"><div class=\"toolbar-wrapper\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.query\" type=\"text\" ng-keyup=\"vm.searchTable()\" placeholder=\"Search\" translate=\"\" translate-attr-placeholder=\"BUSINESSMODULE.SEARCH\"></div></div></div><div class=\"content\" style=\"background: none;\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp padding-10\"><md-button class=\"md-fab md-mini md-accent pull-right btn-add\" ng-click=\"vm.showDialog()\"><md-icon class=\"icon-plus\"></md-icon></md-button><table id=\"businessDataTable\" class=\"dataTable row-border hover\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" width=\"100%\"><thead><tr class=\"header-bg-color\"><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/company/details/company-dialog.html","<md-dialog class=\"company-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex=\"\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{vm.company.Image}}\" src=\"assets/images/avatars/company.jpg\" class=\"md-avatar avatar contact-avatar huge\"><div class=\"contact-name\">{{vm.company.Name}}</div><div class=\"contact-name\">({{vm.company.Code}})</div><div class=\"contact-address\"><table><tr><td><i class=\"icon icon-map-marker-radius white-500-fg s12\" ng-if=\"vm.company.PostalAddress\"></i> {{\'COMPANYMODULE.COMPANY_CARD_POSTAL_ADDRESS\' | translate}}</td><td>{{vm.company.PostalAddress}}</td></tr><tr><td><i class=\"icon icon-map-marker-multiple white-500-fg s12\" ng-if=\"vm.company.BusinessAddress\"></i> {{\'COMPANYMODULE.COMPANY_CARD_BUSINESS_ADDRESS\' | translate}}</td><td>{{vm.company.BusinessAddress}}</td></tr></table></div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div flex=\"\" layout=\"column\" class=\"md-body-1\"><div flex=\"\"><md-input-container ng-if=\"vm.company.Types\" class=\"md-block\"><md-icon md-font-icon=\"icon-city\"></md-icon><input ng-model=\"vm.company.Types\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.company.Website\" class=\"md-block\"><md-icon md-font-icon=\"icon-web\"></md-icon><input readonly=\"\" ng-model=\"vm.company.Website\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.company.Branches\" class=\"md-block\"><md-icon md-font-icon=\"icon-map-marker-multiple\"></md-icon><input ng-model=\"vm.company.Branches\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.company.Number\" class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.company.Number\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.company.EmailAddress\" class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input readonly=\"\" ng-model=\"vm.company.EmailAddress\" type=\"text\"></md-input-container></div><div ng-if=\"vm.company.CustomFieldsList.length > 0\" class=\"simple-table-container md-whiteframe-4dp\" flex=\"\"><table class=\"simple\"><tbody><tr ng-repeat=\"field in vm.company.CustomFieldsList\"><td><b>{{field.Title}}</b></td><td>{{field.FieldValue}}</td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/attachmentTypes/view/attachment-types-view.html","<div id=\"attachment-types-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp search-container\"><div class=\"toolbar-wrapper\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.query\" type=\"text\" ng-keyup=\"vm.searchTable()\" placeholder=\"Search\"></div></div></div><div class=\"content\" style=\"background: none;\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp padding-10\"><md-button class=\"md-fab md-mini md-accent pull-right btn-add\" ng-click=\"vm.showDialog()\"><md-icon class=\"icon-plus\"></md-icon></md-button><div class=\"card-header\"><h2 class=\"card-title\">Attachment Types</h2><p class=\"card-subtitle\">Define attachment types of uploaded documents (e.g. SWMS, Permits, Plans)</p><md-divider></md-divider></div><table id=\"attachmentTypesDataTable\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-instance=\"vm.dtInstance\" width=\"100%\"><thead><tr class=\"header-bg-color\"><th class=\"secondary-text\">Name</th><th class=\"secondary-text\">Description</th><th class=\"secondary-text\">File Type</th><th class=\"secondary-text\">Active</th><th class=\"secondary-text\">Actions</th></tr></thead><tbody><tr ng-repeat=\"item in vm.service.attachmentTypes track by item.Id\"><td>{{item.Name}}</td><td>{{item.Description}}</td><td>{{vm.getFileTypeNames(item.SupportedFileTypes)}}</td><td><span class=\"badge padding-2\" ng-class=\"{\'md-green-bg\': item.IsActive, \'md-orange-bg\': !item.IsActive}\" style=\"color: #fff; padding: 2px 8px; border-radius: 2px;\">{{item.IsActive ? \'Yes\' : \'No\'}}</span></td><td><md-button class=\"md-icon-button md-primary action-button\" ng-click=\"vm.editAttachmentType(item)\"><i class=\"icon icon-pencil teal-500-fg s15\"><md-tooltip>Edit Attachment Type</md-tooltip></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/attachmentTypes/view/manage-attachment-type-dialog.html","<md-dialog class=\"dashboard-manage\" id=\"attachment-type-dialog\" flex=\"40\" ng-cloak=\"\"><form name=\"attachmentTypeForm\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>{{vm.dialogTitle}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block field-name\"><label>Attachment Type Name</label> <input type=\"text\" ng-model=\"vm.model.Name\" required=\"\" md-maxlength=\"100\"></md-input-container><md-input-container class=\"md-block field-description\"><label>Description</label> <input type=\"text\" ng-model=\"vm.model.Description\"></md-input-container><md-input-container class=\"md-block field-file-type\"><label>File type</label><md-select ng-model=\"vm.model.SupportedFileTypes\" multiple=\"\" required=\"\"><md-option ng-repeat=\"type in vm.fileTypeOptions\" ng-value=\"type.Id\">{{type.Value}}</md-option></md-select></md-input-container><md-checkbox ng-model=\"vm.model.IsActive\" class=\"md-primary\">Active</md-checkbox></md-dialog-content></form><md-dialog-actions><md-button class=\"md-raised md-accent\" ng-click=\"vm.save()\" ng-disabled=\"attachmentTypeForm.$invalid || vm.isSaving\">SAVE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/customFieldsManager/binder/custom-fields-binder.html","<div ng-style=\"vm.style\" flex=\"\"><div flex=\"\" ng-repeat=\"field in vm.filtered_fields\"><description ng-if=\"field.FieldType == \'200\'\" field-detail=\"field\"></description><checkbox-binder ng-if=\"field.FieldType == \'2\'\" is-disabled=\"vm.isDisabled\" comply=\"vm.complyMultiple(data)\" field-detail=\"field\"></checkbox-binder><checkbox-with-entry-binder ng-if=\"field.FieldType == \'12\'\" comply=\"vm.complyMultiple(data)\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></checkbox-with-entry-binder><short-text-binder ng-if=\"field.FieldType == \'0\'\" is-disabled=\"vm.isDisabled\" comply=\"vm.comply()\" field-detail=\"field\"></short-text-binder><paragraph-binder ng-if=\"field.FieldType == \'5\'\" comply=\"vm.comply()\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></paragraph-binder><email-binder ng-if=\"field.FieldType == \'6\'\" comply=\"vm.comply()\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></email-binder><url-binder ng-if=\"field.FieldType == \'8\'\" comply=\"vm.comply()\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></url-binder><whole-number-binder ng-if=\"field.FieldType == \'3\'\" comply=\"vm.comply()\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></whole-number-binder><decimals-binder ng-if=\"field.FieldType == \'7\'\" comply=\"vm.comply()\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></decimals-binder><time-binder ng-if=\"field.FieldType == \'13\'\" comply=\"vm.comply()\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></time-binder><dropdown-binder ng-if=\"field.FieldType == \'4\'\" comply=\"vm.comply()\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></dropdown-binder><multiple-choice-binder ng-if=\"field.FieldType == \'1\'\" comply=\"vm.complyMultiple(data)\" is-disabled=\"vm.isDisabled\" field-detail=\"field\"></multiple-choice-binder></div><model-watcher model=\"vm.ngModel\" values=\"vm.values\" ng-if=\"false\" flex=\"\"></model-watcher></div>");
$templateCache.put("app/main/company/create/company-create.html","<div id=\"company-create\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent first-button-margin\" ng-show=\"companyVm.showFields\" ng-disabled=\"companyForm.$invalid || CustomForm.$invalid\" translate=\"COMPANYMODULE.SAVE\" ng-click=\"companyVm.onsave(0, companyForm)\"></md-button><md-button class=\"md-raised md-accent button-margin\" ng-show=\"companyVm.showFields && !companyVm.service.isEditMode\" ng-disabled=\"companyForm.$invalid || CustomForm.$invalid\" translate=\"COMPANYMODULE.SAVE_AND_CLOSE\" ng-click=\"companyVm.onsave(1, companyForm)\"></md-button><md-button class=\"md-raised md-accent button-margin\" a8-archive-dialog=\"\" ng-if=\"companyVm.service.show_archive_button\" a8-title=\"{{companyVm.model.IsArchived ? \'Unarchive\' : \'Archive\'}} Company\" a8-content=\"Are you sure you want to {{ companyVm.model.IsArchived ? \'Unarchive\' : \'Archive\' }} {{ companyVm.model.CompanyName }}?\" a8-label=\"{{ companyVm.model.IsArchived ? \'Unarchive\' : \'Archive\' }}\" a8-ok=\"{{ companyVm.model.IsArchived ? \'Unarchive\' : \'Archive\' }}\" a8-on-archive=\"companyVm.onArchive()\">{{ companyVm.model.IsArchived ? \"Unarchive\" : \"Archive\" }}</md-button><md-button class=\"md-raised md-accent button-margin\" translate=\"COMPANYMODULE.VIEW_HISTORY\" ng-click=\"companyVm.service.showCompanyHistory(companyVm.model.id, companyVm.model.CompanyName)\" ng-if=\"companyVm.editMode\"></md-button><md-button ng-click=\"companyVm.service.redirectToCompanyView()\" translate=\"COMPANYMODULE.VIEW_COMPANIES\" class=\"md-raised md-accent button-margin\"></md-button><md-button class=\"md-accent md-raised button-margin\" translate=\"MANAGE.VIEWCOMMENTS\" ng-if=\"companyVm.editMode && companyVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-click=\"companyVm.service.viewComments(companyVm.model.id, companyVm.model.CompanyName)\"></md-button></div></div><div class=\"content\" flex=\"\"><md-subheader ng-show=\"companyVm.showFields\" class=\"md-whiteframe-4dp\" flex=\"\" ng-if=\"companyForm.$error.required.length > 0 || customfields.$error.required.length > 0\"><b translate=\"COMPANYMODULE.REQUIRED_FIELDS\"></b><ul><li ng-repeat=\"error in companyForm.info.$error.required\">{{error.$name}}</li><li ng-repeat=\"error in companyForm.details.$error.required\">{{error.$name}}</li><li ng-repeat=\"error in customfields.$error.required\">{{error.$name}}</li></ul></md-subheader><div class=\"form-wrapper md-whiteframe-4dp\"><div id=\"company\" ng-form=\"companyForm\"><div style=\"color: brown; font-weight: bold; margin-bottom: 0.5em; cursor: pointer;\"><p ng-repeat=\"company in companyVm.service.duplicatedCompany\" ng-click=\"companyVm.service.showCompanyDetails(company.Id)\" ng-if=\"company.Name && company.Id !== companyVm.model.id\" style=\"margin: 0;\">Did you mean {{company.Name}}?</p></div><company-info-component></company-info-component><div flex=\"85\" ng-if=\"companyVm.checkAccessService.isAltusSpecialEnabled()\"><custom-fields-binder types=\"companyVm.service.companyInfoData.CompanyType\" ng-form=\"customfields\" font-size=\"1.6rem\" values=\"companyVm.service.companyInfoData.CustomFields\" trigger-save=\"companyVm.service.saveTrigger\" source=\"Companies\" padding=\"8px\" ng-model=\"companyVm.service.companyInfoData.CustomFieldsValues\" fields-list=\"companyVm.model.customisedFields\"></custom-fields-binder></div><company-details-component></company-details-component></div></div></div></div></div>");
$templateCache.put("app/main/company/view/company-view.html","<div id=\"company-view\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><a8-header-with-search src-data=\"vmCompanyView.dataGrid.searchText\" on-search=\"vmCompanyView.dataGrid.grid.onSearch(value)\"></a8-header-with-search><div class=\"toolbar md-whiteframe-2dp\"><div ng-if=\"!vmCompanyView.service.loader\" class=\"toolbar-wrapper header-filter\"><div class=\"item\"><md-checkbox ng-model=\"vmCompanyView.companyViewService.filterModel.isActive\">{{\'VIEWCOMPANIES.ACTIVE\' | translate}}</md-checkbox><md-checkbox ng-model=\"vmCompanyView.companyViewService.filterModel.isArchive\">{{\'VIEWCOMPANIES.ARCHIVED\' | translate}}</md-checkbox><md-input-container><label>{{\'VIEWCOMPANIES.COMPANY_TYPE\' | translate}}</label><md-select ng-model=\"vmCompanyView.companyViewService.filterModel.companyType\" md-on-open=\"vmCompanyView.service.loadCompanyTypes()\"><md-option ng-repeat=\"type in vmCompanyView.service.companyTypes\" value=\"{{type.id}}\">{{type.TypeName}}</md-option></md-select></md-input-container></div><div class=\"item\" layout-align=\"center center\"><md-button class=\"md-raised md-accent first-button-margin\" ng-click=\"vmCompanyView.viewDatesFilter()\" ng-disabled=\"vmCompanyView.dataGrid.grid.behavior.busy\">{{\'VIEWCOMPANIES.DATE_RANGE_BUTTON\' | translate}}</md-button><md-button class=\"md-raised md-accent button-margin\" ng-click=\"vmCompanyView.filterCompanies()\" ng-disabled=\"vmCompanyView.dataGrid.grid.behavior.busy\">{{\'VIEWCOMPANIES.FILTER\' | translate}}</md-button><md-button class=\"md-raised md-accent button-margin\" ng-click=\"vmCompanyView.resetFilter()\" ng-disabled=\"vmCompanyView.dataGrid.grid.behavior.busy\">{{\'VIEWCOMPANIES.RESET\' | translate}}</md-button></div></div><toolbar-loader show=\"vmCompanyView.service.loader\" message=\"vmCompanyView.service.loaderMessage\"></toolbar-loader></div><div class=\"content\" style=\"margin-top:20px;\" flex=\"\"><md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" ng-if=\"vmCompanyView.service.loader\"></md-progress-linear><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"\" layout=\"column\"><div flex=\"10\"><md-button ng-if=\"vmCompanyView.checkAccessService.checkAccessByRole(\'Create a New Company\')\" ng-click=\"vmCompanyView.service.onCreate()\" style=\"position : relative; float : right; margin-right : 30px; margin-top : -20px;\" class=\"md-fab md-mini md-accent\" aria-label=\"Create Company\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'VIEWCOMPANIES.CREATE_COMPANY_TOOLTIP\' | translate}}</md-tooltip></md-icon></md-button></div><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"vmCompanyView.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Name\" field-label=\"Name\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CompanyTypes\" field-label=\"Type\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Branches\" field-label=\"Branches\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Divisions\" field-label=\"Divisions\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CompanyCode\" field-label=\"Company Code\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"IsActive\" field-label=\"Active\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tfoot><tr><td colspan=\"8\"></td></tr></tfoot><tbody><tr ng-repeat=\"item in vmCompanyView.dataGrid.grid.data track by $index\"><td><md-button class=\"md-icon-button md-primary action-button\" ng-click=\"vmCompanyView.service.showCompanyDetails(item.Id)\" aria-label=\"Settings\"><i class=\"icon icon-city light-blue-500-fg s15\"></i></md-button></td><td><strong>{{item.Name}}</strong></td><td>{{item.CompanyTypes.join(\", \")}}</td><td>{{item.Branches.join(\", \")}}</td><td>{{item.Divisions.join(\", \")}}</td><td>{{item.CompanyCode}}</td><td>{{item.IsActive === true ? \'Yes\' : \'No\'}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vmCompanyView.service.onEdit(item.Id, item.Name)\"><i class=\"icon icon-pencil teal-500-fg s15\"></i></md-button><md-button class=\"md-icon-button margin-5\" ng-click=\"vmCompanyView.service.addContact(item)\"><i class=\"icon-account-plus blue-500-fg\"></i></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"vmCompanyView.dataGrid.grid.behavior\" on-init=\"vmCompanyView.dataGrid.grid.onInit()\" on-error=\"vmCompanyView.dataGrid.grid.onError(ex)\" on-completed=\"vmCompanyView.dataGrid.grid.onCompleted(data)\" on-data-filter=\"vmCompanyView.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div></div></div></div>");
$templateCache.put("app/main/costEstimate/preview/cost-estimate-preview.default.html","<div id=\"cost-estimate-preview\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/costEstimate/preview/sidenav/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"invRepVm.toggleSidenav(\'main-sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle Sidenav\" translate=\"\" translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><ce-custom-grid-search-component delay=\"invRepVm.delay\" src-data=\"invRepVm.model.grid.searchText\" on-search=\"invRepVm.model.grid.onSearch(value)\" api=\"invRepVm.model.customGridSearchComponentApi\" flex=\"\"></ce-custom-grid-search-component></div></div><ce-content-view-component class=\"content-card\" ng-class=\"classic\" layout=\"column\" flex=\"\"></ce-content-view-component></div></div>");
$templateCache.put("app/main/costEstimate/view/ce-list-view.html","<div id=\"ce-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" style=\"overflow: hidden;\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp toolbar-custom\"><div class=\"toolbar-wrapper\"><ce-report-filter-component></ce-report-filter-component></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"invPdfViewVm.delay\" source=\"invPdfViewVm.dataGrid.grid.searchTerm\" layout-margin=\"\" flex=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"invPdfViewVm.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CurrentCENumber\" field-label=\"CE#\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CompanyName\" field-label=\"Company Name\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"BranchName\" field-label=\"Branch Name\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CurrentCECreatedDate\" field-label=\"Created Date\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CostEstimateStatusText\" field-label=\"Cost Estimate Status\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CurrentCEAmount\" field-label=\"Amount\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tfoot><tr><td colspan=\"9\"></td></tr></tfoot><tbody><tr ng-repeat=\"ce in invPdfViewVm.dataGrid.grid.data track by $index\"><td>{{ce.CurrentCENumber}}</td><td>{{ce.CompanyName}}</td><td>{{ce.BranchName}}</td><td>{{ce.CurrentCECreatedDate}}</td><td><span class=\"status padding-2 margin-top-0 md-grey-500-bg grey-50-fg\" ng-if=\"ce.HasBeenCancelled\">Cancelled</span> <span class=\"status padding-2 margin-top-0 md-blue-500-bg grey-50-fg\" ng-if=\"invPdfViewVm.getStatus(ce.CostEstimateStatus) == 1 && !ce.HasBeenCancelled\">{{ ce.CostEstimateStatusText }}</span> <span class=\"status padding-2 margin-top-0 md-green-400-bg grey-50-fg\" ng-if=\"(invPdfViewVm.getStatus(ce.CostEstimateStatus) == 2 || invPdfViewVm.getStatus(ce.CostEstimateStatus) == 4) && !ce.HasBeenCancelled\">{{ ce.CostEstimateStatusText }}</span> <span class=\"status padding-2 margin-top-0 md-red-500-bg grey-50-fg\" ng-if=\"invPdfViewVm.getStatus((ce.CostEstimateStatus) == 3 || invPdfViewVm.getStatus(ce.CostEstimateStatus) == 5 || invPdfViewVm.getStatus(ce.CostEstimateStatus) == 6) && !ce.HasBeenCancelled\">{{ ce.CostEstimateStatusText }}</span></td><td><span ng-if=\"ce.CurrentCEAmount != \'\'\">$</span>{{ce.CurrentCEAmount}}</td><td><md-button class=\"md-icon-button\" aria-label=\"Credit\" ng-click=\"invPdfViewVm.previewCostEstimates(ce.Id)\"><md-icon md-font-icon=\"icon-document\"></md-icon><md-tooltip md-direction=\"bottom\">View Cost Estimates</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download file\" ng-click=\"invPdfViewVm.downloadPdfLink(ce.Id, $index)\" ng-disabled=\"ce.IsPdfGenerating\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip md-direction=\"bottom\">Download Pdf File</md-tooltip></md-button><md-button class=\"md-icon-button margin-left-0 padding-left-0\" aria-label=\"Cancel cost estimate\" ng-click=\"invPdfViewVm.cancelCostEstimate(ce.Id, ce.CompanyName)\" ng-disabled=\"ce.Status == 2 || ce.HasBeenCancelled\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip md-direction=\"bottom\">Cancel Cost Estimate</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"View history logs\" ng-click=\"invPdfViewVm.viewHistory(ce.Id, ce.CompanyName)\"><md-icon md-font-icon=\"icon-history\"></md-icon><md-tooltip md-direction=\"bottom\">View History</md-tooltip></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"invPdfViewVm.dataGrid.grid.behavior\" distinct-by=\"InvoiceNumber\" on-init=\"invPdfViewVm.dataGrid.grid.onInit()\" on-error=\"invPdfViewVm.dataGrid.grid.onError(ex)\" on-completed=\"invPdfViewVm.dataGrid.grid.onCompleted(data)\" on-data-filter=\"invPdfViewVm.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div></div></div>");
$templateCache.put("app/main/contact/details/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex=\"\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{vm.contact.ImageUrl}}\" src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar avatar contact-avatar huge\"><div class=\"contact-name\">{{vm.contact.Name}}</div><div class=\"contact-address\"><i class=\"icon icon-home white-500-fg s12\" ng-if=\"vm.contact.Addresses\"></i> {{vm.contact.Addresses}}</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div><md-input-container ng-if=\"vm.contact.Phones\" class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.contact.Phones\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.contact.Emails\" class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input readonly=\"\" ng-model=\"vm.contact.Emails\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.contact.Birthday\" class=\"md-block\"><md-icon md-font-icon=\"icon-cake\"></md-icon><input ng-model=\"vm.contact.Birthday\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.contact.ContactTypes\" class=\"md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><input ng-model=\"vm.contact.ContactTypes\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.contact.Branches\" class=\"md-block\"><md-icon md-font-icon=\"icon-map-marker-multiple\"></md-icon><input ng-model=\"vm.contact.Branches\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.contact.IsEmployee\" class=\"md-block\"><md-icon md-font-icon=\"icon-briefcase\"></md-icon><input ng-model=\"vm.contact.EmploymentStatus\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.contact.IsEmployee\" class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><input ng-model=\"vm.contact.AwardClassification\" readonly=\"\" type=\"text\"></md-input-container><md-input-container ng-if=\"vm.contact.IsEmployee\" class=\"md-block\"><md-icon md-svg-icon=\"calendar-clock\"></md-icon><input ng-model=\"vm.contact.StartDate | date\" readonly=\"\" type=\"text\"><md-tooltip>{{\'CONTACTSMODULE.START_DATE\' | translate}}</md-tooltip></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.openEditLink()\" ng-if=\"vm.showEditLink\">{{\'CONTACTSMODULE.EDIT_CONTACT\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/customFieldsManager/views/custom-fields-manager-view.html","<div class=\"page-layout carded left-sidenav custom-fields-manager\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/customFieldsManager/views/sidenav/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\">\'<div class=\"content\" layout=\"row\" layout-align=\"center start\" flex=\"\" special-scroll=\"\" scroll=\"vm.service.scroll_to_top\"><div flex=\"70\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" style=\"margin-top : 20px;\"><md-progress-linear ng-if=\"vm.service.loading\" md-mode=\"indeterminate\"></md-progress-linear><div style=\"color : white\" layout=\"column\" ng-if=\"(vm.mediaService.isDeviceSM() || vm.mediaService.isDeviceMD() || vm.mediaService.isDeviceXS()) && !vm.service.loading\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div class=\"md-title\" flex=\"\" layout=\"row\">Custom Fields Manager</div><div flex=\"\" layout=\"row\" layaout-align=\"space-between center\"><div style=\"margin-top : 26px;\" flex=\"5\" ng-if=\"!vm.service.something_has_been_selected\" ng-click=\"vm.service.prepareForAdd()\"><i style=\"color : white; cursor : pointer\" class=\"icon icon-plus-box\"><md-tooltip>Add New Field</md-tooltip></i></div><div style=\"margin-left : 30px;\" flex=\"80\" class=\"md-body-2\" layout=\"row\"><md-input-container class=\"md-block\"><md-select ng-disabled=\"vm.service.something_has_been_selected || vm.service.loading\" ng-model=\"vm.service.chosen_module\" ng-change=\"vm.service.getCustomFields(vm.service.chosen_module)\"><md-option ng-value=\"module.Id\" ng-repeat=\"module in vm.service.modules\">{{module.Name}}</md-option></md-select></md-input-container></div></div></div><div ng-if=\"vm.service.chosen_fields.length === 0\" layout=\"row\" flex=\"\" class=\"white-bg md-whiteframe-3dp md-body-2\"><div class=\"side-no-items\"></div><div layout=\"row\" style=\"margin-left : 10px;\" layout-align=\"center center\" flex=\"\" layout-padding=\"\"><span ng-if=\"vm.service.loading\">Loading Fields ...</span> <span ng-if=\"!vm.service.loading\">No Custom Fields</span></div></div><div class=\"top\"></div><div style=\"margin-top : 10px;\" class=\"md-whiteframe-3dp task-item\" flex=\"\" layout=\"row\" ms-scroll=\"\" ng-repeat=\"field in vm.service.chosen_fields\"><div flex=\"\" layout=\"row\" class=\"white-bg md-whiteframe-3dp\" ng-class=\"{\'task-item white-bg md-whiteframe-3dp\' : vm.service.initial_load, \'task-item white-bg md-whiteframe-3dp selected\' : !vm.service.initial_load && field.Selected, \'task-item white-bg md-whiteframe-3dp not-selected\' : !vm.service.initial_load && !field.Selected}\"><div flex=\"5\" ng-class=\"{\'side-selected\' : field.Selected, \'side-not-selected\' : !field.Selected, \'side-saving\' : field.Selected && vm.service.saving}\"></div><div flex=\"\" style=\"margin-left : 10px;\" layout-padding=\"\"><short-text-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 0 && !field.Selected\"></short-text-display><drop-down-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 4 && !field.Selected\"></drop-down-display><multiple-choice-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 1 && !field.Selected\"></multiple-choice-display><paragraph-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 5 && !field.Selected\"></paragraph-display><whole-number-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 3 && !field.Selected\"></whole-number-display><decimal-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 7 && !field.Selected\"></decimal-display><check-box-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 2 && !field.Selected\"></check-box-display><email-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 6 && !field.Selected\"></email-display><time-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 13 && !field.Selected\"></time-display><url-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 8 && !field.Selected\"></url-display><check-box-with-entry-display edit=\"field.Selected\" field=\"field\" ng-if=\"field.FieldType === 12 && !field.Selected\"></check-box-with-entry-display><editor-section flex=\"\" field=\"field\" ng-if=\"field.Selected\"></editor-section></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/customForms/components/formTemplates-formSettings.html","<md-dialog flex=\"30\" class=\"form-template-dialog\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2>{{vm.dialogTitle}}</h2><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"formTemplateForm\" class=\"md-inline-form\" novalidate=\"\"><md-content class=\"padding-20\"><div ng-if=\"!vm.isEditMode\" class=\"label-text margin-bottom-10\" translate=\"CUSTOMFORMSMODULE.SETTINGS.FORMSETUP\"></div><label ng-if=\"!vm.isEditMode\" class=\"help-text\" translate=\"CUSTOMFORMSMODULE.SETTINGS.FORMSETUP_HELP\"></label><md-input-container class=\"md-block\"><input md-maxlength=\"50\" required=\"\" name=\"formName\" placeholder=\"{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_NAME\'| translate}}\" ng-model=\"vm.formTemplate.name\"></md-input-container><span class=\"label-text\" translate=\"CUSTOMFORMSMODULE.SETTINGS.FORM_RELATE_TEXT\"></span><span class=\"required-star\">*</span><div layout=\"row\" flex=\"\"><md-input-container class=\"md-block\" flex=\"66\"><md-select placeholder=\"Please select\" ng-model=\"vm.formTemplate.formType\" ng-change=\"vm.onFormTypeChange()\" ng-disabled=\"vm.isEditMode || vm.formTemplate.isPublished || vm.isCloneMode\" required=\"\"><md-option value=\"Worker\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_TYPE_WORKER\'| translate}}</md-option><md-option value=\"Vehicle\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_TYPE_VEHICLE\'| translate}}</md-option><md-option value=\"Asset\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_TYPE_ASSET\'| translate}}</md-option><md-option value=\"Job\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_TYPE_JOB\'| translate}}</md-option></md-select></md-input-container></div><div class=\"label-text margin-bottom-5\" translate=\"CUSTOMFORMSMODULE.SETTINGS.APPLY_TO_MODULE_TITLE\"></div><label class=\"help-text\" translate=\"CUSTOMFORMSMODULE.SETTINGS.APPLY_TO_MODULE_DESCRIPTION\"></label><div layout=\"row\" flex=\"\"><md-input-container class=\"md-block\" flex=\"66\"><md-select placeholder=\"Please select\" ng-model=\"vm.formTemplate.appliedTo\" ng-disabled=\"!vm.formTemplate.formType || vm.formTemplate.isPublished\"><md-option value=\"\">{{\'CUSTOMFORMSMODULE.SETTINGS.APPLY_TO_NONE\'| translate}}</md-option><md-option ng-show=\"vm.isFormTypeVehicleOrAsset()\" value=\"AllAssets\">{{\'CUSTOMFORMSMODULE.SETTINGS.APPLY_TO_ALL_ASSETS\'| translate}}</md-option><md-option ng-show=\"vm.isFormTypeJobOrWorker()\" value=\"AllBranches\">{{\'CUSTOMFORMSMODULE.SETTINGS.APPLY_TO_ALL_BRANCH\'| translate}}</md-option><md-option ng-show=\"vm.isFormTypeJobOrWorker()\" value=\"AllCompanies\">{{\'CUSTOMFORMSMODULE.SETTINGS.APPLY_TO_ALL_COMPANIES\'| translate}}</md-option></md-select></md-input-container></div><div class=\"label-text margin-top-20\" translate=\"CUSTOMFORMSMODULE.SETTINGS.FORM_SETTINGS_TITLE\"></div><div layout=\"row\" flex=\"\"><md-checkbox name=\"isRequired\" class=\"padding-left-10\" ng-model=\"vm.formTemplate.isRequired\" ng-disabled=\"vm.formTemplate.allowMultipleSubmissions || vm.formTemplate.isPublished\" flex=\"80\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_SETTINGS_OPTION_REQUIRED\' | translate}}</md-checkbox></div><div layout=\"row\" flex=\"\"><md-checkbox name=\"allowMultipleSubmissions\" class=\"padding-left-10\" ng-model=\"vm.formTemplate.allowMultipleSubmissions\" ng-disabled=\"vm.formTemplate.isRequired || vm.formTemplate.isPublished\" flex=\"80\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_SETTINGS_OPTION_ALLOW_MULTIPLE_FORM_SUBMISSIONS\' | translate}}</md-checkbox></div><div layout=\"row\" flex=\"\"><md-checkbox name=\"includeInPaperwork\" class=\"padding-left-10\" ng-model=\"vm.formTemplate.includeInPaperwork\" ng-disabled=\"vm.formTemplate.isPublished\" flex=\"80\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_SETTINGS_OPTION_PAPERWORK_INCLUDED\' | translate}}</md-checkbox></div><div layout=\"row\" flex=\"\"><md-checkbox name=\"privateForm\" class=\"padding-left-10\" ng-model=\"vm.formTemplate.isPrivate\" ng-show=\"vm.formTemplate.formType ==\'Worker\'\" ng-disabled=\"vm.formTemplate.isPublished\" flex=\"80\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_SETTINGS_OPTION_PRIVATE_FORM\' | translate}}</md-checkbox></div><div layout=\"row\" class=\"padding-bottom-20\" flex=\"\"><md-checkbox name=\"timesheetManagerOnly\" class=\"padding-left-10\" ng-model=\"vm.formTemplate.isTimesheetManagersOnly\" ng-show=\"vm.formTemplate.formType ==\'Job\'\" ng-disabled=\"vm.formTemplate.isPublished\" flex=\"80\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_SETTINGS_OPTION_TIMESHEET_MANAGER_ONLY\' | translate}}</md-checkbox></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate=\"CUSTOMFORMSMODULE.CANCEL\"></md-button><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" type=\"submit\" ng-click=\"vm.isEditMode ? vm.updateFormTemplate() : (vm.isCloneMode ? vm.cloneFormTemplate() : vm.createFormTemplate())\" ng-disabled=\"formTemplateForm.$invalid\">{{ vm.dialogPrimaryButtonText }}</md-button></div></md-content></form></md-dialog>");
$templateCache.put("app/main/contact/calendar/contact-calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div ng-class=\"[\'header\', \'md-accent-bg\']\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span> <span class=\"logo-text\">{{vm.Name}}</span> &nbsp; &nbsp; <span class=\"logo-text\" translate=\"CALENDAR.CALENDAR\"></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate=\"\" translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate=\"\" translate-attr-aria-label=\"CALENDAR.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate=\"\" translate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.prev()\" aria-label=\"Previous\" translate=\"\" translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\" ng-click=\"vm.isOpen = true\" ng-if=\"!vm.isOpen\">{{vm.calendarView.title}}</div><div ng-if=\"vm.isOpen\"><md-datepicker ng-model=\"vm.myDate\" ng-blur=\"vm.gotoDate(vm.myDate)\" md-placeholder=\"Enter date\" md-current-view=\"year\" md-is-open=\"vm.isOpen\"></md-datepicker></div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.next()\" aria-label=\"Next\" translate=\"\" translate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate=\"\" translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/contact/timesheetUpdate/contact-timesheets.html","<md-dialog flex=\"30\" class=\"main-style\" flex-xs=\"\" flex-sm=\"\" flex-md=\"50\" ng-cloak=\"\"><form name=\"emailForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'CONTACTSMODULE.UPDATE_JOBS_AND_TIMESHEETS\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-class=\"{\'md-caption\' : vm.media.isDeviceSmall()}\" layout=\"column\" layout-margin=\"\"><div flex=\"\">{{vm.message}}</div><form name=\"timesheet\" flex=\"\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"\"><md-radio-group ng-model=\"vm.choice\"><md-radio-button value=\"0\">{{\'CONTACTSMODULE.YES_UPDATE_ALL\' | translate}}</md-radio-button><md-radio-button value=\"1\">{{\'CONTACTSMODULE.YES_UPDATE_SPECIFIC\' | translate}}</md-radio-button><md-radio-button value=\"2\">{{\'CONTACTSMODULE.NO_DO_NOT_UPDATE\' | translate}}</md-radio-button></md-radio-group></div><div flex=\"\" ng-if=\"vm.choice == 1\"><div style=\"width : 200px;\"><md-input-container class=\"md-block\" flex=\"\" layout=\"row\"><label translate=\"RESOURCEALLOCATION.JOB_START_DATE\"></label><md-datepicker ng-model=\"vm.start_date\" md-open-on-focus=\"\" class=\"md-block\" md-date-filter=\"vm.filterStartDate\" flex=\"none\" layout=\"row\"></md-datepicker></md-input-container></div><div style=\"width : 200px;\"><md-input-container class=\"md-block\" flex=\"\" layout=\"row\"><label translate=\"RESOURCEALLOCATION.JOB_END_DATE\"></label><md-datepicker ng-model=\"vm.end_date\" md-date-filter=\"vm.filterEndDate\" md-open-on-focus=\"\" class=\"md-block\" flex=\"none\" layout=\"row\"></md-datepicker></md-input-container></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" translate=\"WIDGETS_LOC.SAVE\" ng-disabled=\"timesheet.$invalid\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contact/create/contact-create.html","<div id=\"create-contact\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><div layout=\"column\" ng-if=\"vmContact.service.saving\" style=\"height : 50px;\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><div layout=\"row\" style=\"margin-top : 10px; margin-left : 15px;\"><md-progress-circular md-diameter=\"20px\" class=\"md-light-blue-800-fg\" md-mode=\"indeterminate\"></md-progress-circular><span style=\"margin-left : 10px; margin-top : 5px;\">{{vmContact.service.save_message}}</span></div></div></div></div><div ng-style=\"{\'opacity\' : vmContact.service.saving ? \'0.5\' : \'1\'}\" class=\"content\" flex=\"\"><div class=\"form-wrapper\" ng-form=\"contactForm\"><div style=\"color:brown; font-weight:bold; margin-bottom:0.5em; cursor:pointer;\" ng-init=\"vmContact.service.duplicatedContact = null\"><p ng-repeat=\"contact in vmContact.service.duplicatedContact\" ng-click=\"vmContact.service.showContactDetails(contact.Id, true)\" style=\"margin: 0;\">Did you mean {{contact.Name}}?</p></div><div id=\"personal\" ng-include=\"\'app/main/contact/create/personal/personal.html\'\"></div><div flex=\"\" flex-md=\"50\" flex-gt-md=\"50\" ng-if=\"vmContact.claimsUtilService.isAltusSpecialEnabled()\"><custom-fields-binder types=\"vmContact.service.contactData.ContactTypes\" trigger-save=\"vmContact.service.saveTrigger\" ng-form=\"customfields\" font-size=\"1.6rem\" values=\"vmContact.service.contactData.CustomFields\" source=\"Contacts\" padding=\"8px\" ng-model=\"vmContact.service.contactData.CustomFieldsValues\" fields-list=\"vmContact.service.customisedFields\"></custom-fields-binder></div><div id=\"contact\" ng-include=\"\'app/main/contact/create/work/work.html\'\" ng-controller=\"ContactsCreateWorkController as vmContactWork\"></div><div layout=\"row\" layout-xs=\"column\" style=\"position:relative; right: 8px;\" class=\"margin-right-10 margin-top-20\" ng-if=\"!vmContact.service.saving\"><div><md-button class=\"md-raised md-accent first-button-margin\" ng-disabled=\"!vmContact.isCreateButtonEnabled()\" ng-click=\"vmContact.onSave(0,contactForm)\" ng-show=\"vmContact.showFields\">{{vmContact.editMode ? \'Update\' : \'Create\'}}</md-button><md-button class=\"md-raised md-accent button-margin\" ng-disabled=\"!vmContact.isCreateButtonEnabled()\" ng-if=\"!vmContact.editMode\" ng-click=\"vmContact.onSave(1,contactForm)\" ng-hide=\"vmContact.editMode\">Create and Close</md-button><md-button class=\"md-raised md-accent button-margin\" ng-disabled=\"vmContact.saveDisabled\" ng-if=\"vmContact.editMode && vmContact.userContactId != vmContact.service.contactData.id && ((vmContact.hasEmployeeType && vmContact.hasArchiveEmployeesClaims) || !vmContact.hasEmployeeType)\" a8-archive-dialog=\"\" a8-title=\"{{vmContact.service.contactData.IsArchived ? \'Unarchive\' : \'Archive\'}}\" a8-content=\"Are you sure you want to {{ vmContact.service.contactData.IsArchived ? \'Unarchive\' : \'Archive\' }} {{ vmContact.service.contactData.FirstName + \' \' + vmContact.service.contactData.LastName}}?\" a8-label=\"{{ vmContact.service.contactData.IsArchived ? \'Unarchive\' : \'Archive\' }}\" a8-ok=\"{{ vmContact.service.contactData.IsArchived ? \'Unarchive\' : \'Archive\' }}\" a8-on-archive=\"vmContact.onArchive()\">{{ vmContact.service.contactData.IsArchived ? (vmContact.utilService.translate(\'CONTACTSMODULE.BUTTON_UNARCHIVE\')) : (vmContact.utilService.translate(\'CONTACTSMODULE.BUTTON_ARCHIVE\')) }}</md-button></div><div style=\"position: relative\" ng-style=\"{\'left\' : vmContact.mediaQueryService.isDeviceXS() ? \'3px\' : \'4px\'}\"><md-button class=\"md-raised md-accent button-margin\" translate=\"CONTACTSMODULE.VIEW_HISTORY\" ng-click=\"vmContact.service.showContactHistory(vmContact.service.contactData.id, vmContact.service.contactData.FirstName + \' \' + vmContact.service.contactData.LastName)\" ng-if=\"vmContact.editMode\"></md-button><md-button class=\"md-accent md-raised button-margin\" translate=\"MANAGE.VIEWCOMMENTS\" ng-if=\"vmContact.editMode\" ng-click=\"vmContact.service.viewComments(vmContact.service.contactData.id, vmContact.service.contactData.FirstName + \' \' + vmContact.service.contactData.LastName)\"></md-button><md-button class=\"md-accent md-raised button-margin\" translate=\"CONTACTSMODULE.REMOVE_ACCOUNT\" ng-click=\"vmContact.service.deleteUser(vmContact.service.contactData.FirstName, vmContact.service.contactData.LastName, vmContact.service.contactData.id)\" ng-if=\"vmContact.editMode && vmContact.service.contactData.HasAccount && vmContact.claimsUtilService.checkAccessByRole(\'Manage Login Accounts\') && (vmContact.userContactId != vmContact.service.contactData.id)\"></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/customForms/directives/form-builder.html","<div id=\"form-builder\" a8-dirty-form-confirmation=\"{{fb.isFormDirty}}\"><div class=\"white-bg md-whiteframe-4dp md-padding\"><div ng-attr-id=\"{{fb.formTemplateId}}\" ng-show=\"fb.isFormMode\"></div><div class=\"pdf-preview-body\" ng-show=\"!fb.isFormMode\"><iframe ng-src=\"{{fb.pdfUrl}}\" layout-fill=\"\" allowtransparency=\"true\"></iframe></div></div></div>");
$templateCache.put("app/main/customForms/edit/formTemplates-edit.html","<div id=\"form-template-edit\" class=\"page-layout simple right-sidenav\" layout=\"row\" flex=\"\"><div class=\"center\" layout=\"column\" style=\"overflow: hidden;\" flex=\"\" ms-scroll=\"\"><div class=\"md-toolbar-tools md-whiteframe-2dp\"><div><md-button class=\"md-raised md-accent md-button\" ng-click=\"vm.saveFormData()\">Save</md-button><md-button class=\"md-raised md-accent md-button\" ng-disabled=\"vm.isFormInPrintPreviewMode\" ng-click=\"vm.toggleFormPreview()\">{{vm.isFormInTestMode ? \'Close Test\' : \'Test Form\'}}</md-button><md-button class=\"md-raised md-accent md-button\" ng-disabled=\"vm.isFormInTestMode\" ng-click=\"vm.togglePrintPreview()\">{{vm.isFormInPrintPreviewMode ? \'Close Print Preview\' : \'Print Preview\'}}</md-button><md-button class=\"md-raised md-accent md-button\" ng-click=\"vm.publish()\" ng-hide=\"vm.formTemplate.isPublished\">Publish</md-button></div><span flex=\"\"></span><div><span style=\"margin-right: 10px;\"><strong>Status</strong>: {{ vm.formTemplate.isPublished ? \'Published\' : \'Draft\' }}</span> <span><strong>Last updated</strong>: {{ vm.formatUtcDateToLocalFormat(vm.formTemplate.lastUpdated) }}</span></div></div><div class=\"content\" layout=\"column\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp md-padding\"><div layout=\"column\"><div layout=\"row\" class=\"content-header\" layout-align=\"start center\" flex=\"\"><span class=\"md-headline\">{{ vm.formTemplate.name }}</span><md-button class=\"md-icon-button md-primary action-button\" aria-label=\"Update Settings\" ng-click=\"vm.updateSettings()\"><md-icon ng-bind=\"\'settings\'\"><md-tooltip>Update Settings</md-tooltip></md-icon></md-button></div><div layout=\"column\" layout-align=\"start start\" flex=\"\"><p class=\"text\"><span class=\"text-label\">Form Type:</span> {{ vm.formTemplate.formType }}</p><p class=\"text\"><span class=\"text-label\">Applied to:</span> {{ vm.formTemplate.appliedTo ? vm.formTemplate.appliedTo.split(vm.regExp).join(\' \') : \'Not set\' }}</p><p class=\"text\"><span class=\"text-label\">Required:</span> {{ vm.formTemplate.isRequired? \'Yes\' : \'No\' }}</p><p class=\"text\"><span class=\"text-label\">Allow multiple submissions:</span> {{ vm.formTemplate.allowMultipleSubmissions? \'Yes\' : \'No\' }}</p><p class=\"text\" ng-show=\"vm.formTemplate.formType==\'Worker\'\"><span class=\"text-label\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_SETTINGS_OPTION_PRIVATE_FORM\' | translate}}:</span> {{ vm.formTemplate.isPrivate ? \'Yes\' : \'No\' }}</p><p class=\"text\" ng-show=\"vm.formTemplate.formType==\'Job\'\"><span class=\"text-label\">{{\'CUSTOMFORMSMODULE.SETTINGS.FORM_SETTINGS_OPTION_TIMESHEET_MANAGER_ONLY\' | translate}}:</span> {{ vm.formTemplate.isTimesheetManagersOnly ? \'Yes\' : \'No\' }}</p></div></div></div><div flex=\"\"><form-builder api=\"vm.formBuilderApi\"></form-builder></div></div></div></div>");
$templateCache.put("app/main/customForms/view/formTemplates-view.html","<div id=\"formTemplates-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vm.createFormTemplate()\" translate=\"CUSTOMFORMSMODULE.LABEL_CREATEFORM\" ng-disabled=\"!vm.hasCreateEditPermission\"></md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\" style=\"padding: 10px;\"><table id=\"formTemplateDataTable\" class=\"dataTable row-border hover\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" width=\"100%\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th><th class=\"secondary-text\"></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/customisedFields/templates/dialog.html","<body><md-dialog flex=\"35\"><ng-form name=\"dialogform\"><md-card><md-card-title><div layout=\"column\" flex=\"\"><div flex=\"\" layout=\"row\"><div flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"text\" name=\"FieldName\" placeholder=\"{{\'CUSTOMFIELDS.FIELD_NAME\'| translate}}\" ng-model=\"vm.Field\" class=\"md-headline\" ng-required=\"true\"><div ng-messages=\"dialogform.FieldName.$error\"><p ng-message=\"required\">Field name is required.</p></div></md-input-container></div><div flex=\"\" ng-if=\"!vm.EditMode\"><md-select ng-model=\"vm.FieldType\" flex=\"\" placeholder=\"{{\'CUSTOMFIELDS.FIELD_TYPE\'| translate}}\" ng-change=\"vm.onSelectFieldType(vm.FieldType)\" ng-required=\"true\"><md-option ng-repeat=\"field in vm.service.FieldTypes\" value=\"{{field.FieldValue}}\"><md-icon md-svg-icon=\"{{field.Icon}}\" style=\"margin-right:10px;\"></md-icon>{{field.FieldName}}</md-option></md-select></div><div flex=\"\" ng-if=\"vm.EditMode\"><md-select ng-model=\"vm.FieldType\" flex=\"\" placeholder=\"{{\'CUSTOMFIELDS.FIELD_TYPE\'| translate}}\" ng-change=\"vm.onSelectFieldType(vm.FieldType)\" ng-required=\"true\"><md-option ng-repeat=\"field in vm.filteredFieldTypes\" value=\"{{field.FieldValue}}\"><md-icon md-svg-icon=\"{{field.Icon}}\" style=\"margin-right:10px;\"></md-icon>{{field.FieldName}}</md-option></md-select></div></div><div flex=\"\" layout=\"row\"><div flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"text\" placeholder=\"{{\'CUSTOMFIELDS.DESCRIPTION\'| translate}}\" ng-model=\"vm.Description\"></md-input-container></div><div flex=\"\" ng-if=\"vm.appear\"><md-select ng-model=\"vm.LookUps\" name=\"FieldType\" ng-model-options=\"{trackBy: \'$value.id\'}\" flex=\"\" placeholder=\"{{vm.moduleType}}\" ng-if=\"vm.module != 4\" multiple=\"\" ng-required=\"true\"><md-optgroup label=\"{{vm.moduleType}}\"><md-option ng-value=\"type\" ng-repeat=\"type in vm.service.LookupTypes\">{{type.TypeName}}</md-option></md-optgroup></md-select><md-select ng-model=\"vm.LookUps\" name=\"FieldType\" flex=\"\" ng-model-options=\"{trackBy: \'$value.id\'}\" placeholder=\"{{vm.moduleType}}\" ng-if=\"vm.module == 4\" multiple=\"\" ng-required=\"true\"><md-optgroup label=\"{{vm.moduleType}}\"><md-option ng-value=\"type\" ng-repeat=\"type in vm.service.LookupTypes\">{{type.TypeName}}</md-option></md-optgroup></md-select></div></div><div flex=\"\" layout=\"row\"><div flex=\"\" ng-if=\"vm.appear\"><md-select ng-model=\"vm.CategoryTypes\" name=\"FieldType\" flex=\"\" placeholder=\"Categories\" ng-if=\"vm.module == 4\" multiple=\"\"><md-optgroup label=\"{{\'CUSTOMFIELDS.CATEGORIES\'| translate}}\"><md-option ng-value=\"type\" ng-repeat=\"type in vm.service.CategoryTypes\">{{type.Name}}</md-option></md-optgroup></md-select></div></div></div></md-card-title><md-divider></md-divider><md-card-content><div flex=\"\" layout=\"column\"><div flex=\"\"><form id=\"form\"></form></div></div></md-card-content><md-divider></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\"><h4 class=\"md-subhead\">{{\'CUSTOMFIELDS.DISPLAY_ON_DETAILS\'| translate}}</h4><md-switch ng-model=\"vm.IsVisible\" ng-true-value=\"true\" ng-false-value=\"false\"></md-switch><md-button ng-click=\"vm.addElementToForm()\" class=\"md-accent md-raised\" ng-show=\"!vm.EditMode\" ng-disabled=\"dialogform.$invalid\" translate=\"CUSTOMFIELDS.ADD\"></md-button><md-button ng-show=\"vm.EditMode\" ng-click=\"vm.addElementToForm()\" class=\"md-accent md-raised\" ng-disabled=\"dialogform.$invalid\" translate=\"CUSTOMFIELDS.EDIT\"></md-button><div style=\"height:35px; width:0.5px;background:darkgrey;border-width:thin; opacity:10;margin-right:20px;\"></div><h4 class=\"md-subhead\">{{\'CUSTOMFIELDS.REQUIRED\' | translate}}</h4><md-switch ng-model=\"vm.Required\" ng-true-value=\"true\" ng-false-value=\"false\"></md-switch><h4 class=\"md-subhead\" ng-show=\"vm.CanBeValidated\">{{\'CUSTOMFIELDS.VALIDATE\' | translate}}</h4><md-switch ng-show=\"vm.CanBeValidated\" ng-model=\"vm.Validate\" ng-true-value=\"true\" ng-false-value=\"false\"></md-switch><md-button ng-click=\"vm.close()\" class=\"md-accent md-raised\" translate=\"CUSTOMFIELDS.CLOSE\"></md-button></md-card-actions></md-card></ng-form></md-dialog></body>");
$templateCache.put("app/main/equipment/calendar/equipment-calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div ng-class=\"[\'header\', \'md-accent-bg\']\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span> <span class=\"logo-text\">{{vm.Name}}</span> &nbsp; &nbsp; <span class=\"logo-text\" translate=\"CALENDAR.CALENDAR\"></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate=\"\" translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate=\"\" translate-attr-aria-label=\"CALENDAR.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate=\"\" translate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.prev()\" aria-label=\"Previous\" translate=\"\" translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\" ng-click=\"vm.isOpen = true\" ng-if=\"!vm.isOpen\">{{vm.calendarView.title}}</div><div ng-if=\"vm.isOpen\"><md-datepicker ng-model=\"vm.myDate\" ng-blur=\"vm.gotoDate(vm.myDate)\" md-placeholder=\"Enter date\" md-current-view=\"year\" md-is-open=\"vm.isOpen\"></md-datepicker></div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.next()\" aria-label=\"Next\" translate=\"\" translate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate=\"\" translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/contact/view/contact-view.html","<div id=\"contact-view\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><a8-header-with-search src-data=\"vm.dataGrid.searchText\" on-search=\"vm.dataGrid.grid.onSearch(value)\"></a8-header-with-search><div class=\"toolbar md-whiteframe-2dp\"><div ng-if=\"!vm.service.loader\" layout=\"column\" class=\"toolbar-wrapper header-filter\"><div class=\"item\"><md-checkbox ng-model=\"vm.contactViewService.filterModel.isActive\"><label translate=\"VIEWCONTACTS.ACTIVE\"></label></md-checkbox><md-checkbox ng-model=\"vm.contactViewService.filterModel.isArchive\"><label translate=\"VIEWCONTACTS.ARCHIVED\"></label></md-checkbox><md-input-container><label translate=\"VIEWCONTACTS.CONTACT_TYPE\"></label><md-select ng-model=\"vm.contactViewService.filterModel.contactType\" md-on-open=\"vm.service.getContactTypes()\"><md-option ng-value=\"\"></md-option><md-option ng-repeat=\"type in vm.service.contactTypes\" value=\"{{ type.id }}\">{{type.TypeName}}</md-option></md-select></md-input-container></div><div class=\"item\"><md-button translate=\"VIEWCONTACTS.DATE_RANGE_BUTTON\" class=\"md-raised md-accent first-button-margin\" ng-click=\"vm.contactViewDatesFilter()\" ng-disabled=\"vm.dataGrid.grid.behavior.busy\"></md-button><md-button translate=\"VIEWCONTACTS.FILTER\" class=\"md-raised md-accent button-margin\" ng-click=\"vm.filterContacts()\" ng-disabled=\"vm.dataGrid.grid.behavior.busy\"></md-button><md-button translate=\"VIEWCONTACTS.RESET\" class=\"md-raised md-accent button-margin\" ng-click=\"vm.resetFilter()\" ng-disabled=\"vm.dataGrid.grid.behavior.busy\"></md-button></div></div><toolbar-loader show=\"vm.service.loader\" message=\"vm.service.loaderMessage\"></toolbar-loader></div><div class=\"content\" style=\"margin-top : 20px;\" flex=\"\"><md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" ng-if=\"vm.service.loader\"></md-progress-linear><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"column\" flex=\"\"><div flex=\"10\"><md-button ng-click=\"vm.service.onCreate()\" style=\"position : relative; float : right; margin-right : 30px; margin-top : -20px;\" class=\"md-fab md-mini md-accent\" aria-label=\"Create Contact\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'VIEWCONTACTS.CREATE_CONTACT_TOOLTIP\' | translate}}</md-tooltip></md-icon></md-button></div><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th width=\"10%\"></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"FirstName\" field-label=\"Name\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"ContactTypes\" field-label=\"Type\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Position\" field-label=\"Position\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Email\" field-label=\"Email\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"EmployeeCode\" field-label=\"Employee Code\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Phone\" field-label=\"Mobile\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Branches\" field-label=\"Branches\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Divisions\" field-label=\"Divisions\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"IsActive\" field-label=\"Active\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tfoot><tr><td colspan=\"11\"></td></tr></tfoot><tbody><tr ng-repeat=\"item in vm.dataGrid.grid.data track by $index\"><td width=\"10%\"><i ng-click=\"vm.viewCard(item.Id)\" style=\"cursor : pointer\" class=\"icon icon-account light-blue-500-fg s15\"></i></td><td>{{item.FirstName}} {{item.LastName}}</td><td>{{item.ContactTypes.join(\", \")}}</td><td>{{item.Position}}</td><td>{{item.Email}}</td><td>{{item.EmployeeCode}}</td><td>{{item.Phone}}</td><td>{{item.Branches.join(\", \")}}</td><td>{{item.Divisions.join(\", \")}}</td><td>{{item.IsActive === true ? \'Yes\' : \'No\'}}</td><td><i ng-click=\"vm.onEdit(item.Id, item.FirstName, item.LastName)\" class=\"icon icon-pencil teal-500-fg\"></i> <i ng-click=\"vm.onOpenCalendar(item)\" ng-if=\"item.IsEmployee\" class=\"icon icon-calendar blue-500-fg\"></i></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"vm.dataGrid.grid.behavior\" on-init=\"vm.dataGrid.grid.onInit()\" on-error=\"vm.dataGrid.grid.onError(ex)\" on-completed=\"vm.dataGrid.grid.onCompleted(data)\" on-data-filter=\"vm.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div></div></div></div>");
$templateCache.put("app/main/dashboard/manage/dashboard-manage-dialog.html","<md-dialog id=\"dasboard-manage-dialog\" flex=\"40\" ng-cloak=\"\"><form name=\"widget\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"DASHBOARD.HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" dimmer=\"\" ng-model=\"vm.isSaving\" ng-if=\"!vm.showInputFields\"><div layout=\"row\"><md-button class=\"md-accent md-raised\" translate=\"DASHBOARD.ADD\" ng-click=\"vm.showFields(true, false)\"></md-button><span flex=\"\"></span></div><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"DASHBOARD.COLUMN_WIDGET_TYPE\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"DASHBOARD.COLUMN_REPORT_SOURCE\"></span></div></th><th></th></tr></thead><tbody><tr ng-repeat=\"widget in vm.user_widgets\"><td><md-icon ng-class=\"vm.getTypeDetail(widget.Type.Id).Class\" md-svg-icon=\"{{vm.getTypeDetail(widget.Type.Id).Icon}}\" style=\"margin-right : 20px;\"></md-icon>{{vm.getTypeDetail(widget.Type.Id).Alias}}</td><td>{{widget.Name}}</td><td><md-icon md-svg-icon=\"pencil\" class=\"teal-500-fg\" ng-click=\"vm.showFields(true, true, widget)\"></md-icon><delete-component index=\"widget\" message=\"{{\'DASHBOARD.DELETE_MESSAGE\' | translate}}\" callback=\"vm.deleteWidget\" section=\"{{\'DASHBOARD.HEADER\' | translate}}\"></delete-component></td></tr></tbody></table></div><processor-loader show=\"vm.isSaving\" message=\"vm.loaderMessage\"></processor-loader><div layout=\"column\" dimmer=\"\" ng-model=\"vm.isSaving\" ng-if=\"vm.showInputFields\"><div layout=\"column\"><md-input-container><label translate=\"DASHBOARD.COLUMN_REPORT_SOURCE\"></label><md-select ng-model=\"vm.data.ReportSource\" ng-model-options=\"{trackBy: \'$value.tempGUID\'}\" required=\"\"><md-option ng-value=\"source\" ng-repeat=\"source in vm.widgetTypes\"><md-icon ng-class=\"source.WidgetType.Class\" md-svg-icon=\"{{source.WidgetType.Icon}}\" style=\"margin-right : 20px;\"></md-icon>{{source.DisplayName}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.data.ReportSource.WidgetType.RequiresDatasets\"><label>{{\'DASHBOARD.DATA_SET\' | translate}}</label><md-select ng-model=\"vm.data.Datasets\" ng-model-options=\"{trackBy: \'$value.Name\'}\" md-selected-text=\"vm.utilService.getSelectedText(vm.data.Datasets, vm.utilService.translate(\'DASHBOARD.DATA_SET\'), \'DisplayName\')\" multiple=\"true\" required=\"\"><md-optgroup label=\"{{\'DASHBOARD.DATA_SET\' | translate}}\"><md-option ng-value=\"set\" ng-repeat=\"set in vm.datasets\">{{set.DisplayName}}</md-option></md-optgroup></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions ng-if=\"vm.showInputFields\" dimmer=\"\" ng-model=\"vm.isSaving\"><md-button translate=\"DASHBOARD.SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.save()\" ng-disabled=\"widget.$invalid\"></md-button><md-button translate=\"DASHBOARD.CANCEL\" class=\"md-raised\" ng-click=\"vm.showFields(false, false)\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/widgets/Bar.html","<ms-widget layout=\"row\" flex=\"\" ng-init=\"vm.initWidget(widget)\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap=\"\"><div class=\"pl-8 h3\"><div class=\"h2 secondary-text font-weight-500\">{{vm.widgets[Id].DisplayName}}</div></div><div class=\"\"><md-button class=\"ph-16\" ng-if=\"widget.Name == \'Utilisation\'\" ng-repeat=\"w in widget.TimePeriods\" ng-click=\"vm.changeWidgetTimePeriod(widget, $index, w.Id)\" ng-disabled=\"vm.widgets[Id].currentRange == w.Id\">{{w.Name}}</md-button><md-select class=\"simplified font-size-16\" ng-if=\"widget.Name == \'VehicleUtilisation\'\" style=\"display: inline-block\" ng-model=\"vm.widgets[Id].currentRange\" aria-label=\"Change range\" ng-change=\"vm.changeWidgetTimePeriod(vm.widgets[Id], $index, vm.widgets[Id].currentRange)\"><md-option ng-repeat=\"w in vm.widgets[Id].TimePeriods\" value=\"{{w.Id}}\" ng-selected=\"vm.widgets[Id].currentRange == w.Id\">{{w.Name}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.refreshWidget(widget, $index)\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\" class=\"bar-widget\"><div class=\"bars p-8\" layout=\"row\" flex=\"100\" flex-gt-sm=\"100\" style=\"overflow: auto; overflow-x: hidden; overflow-y: auto;\"><nvd3 class=\"remove-x-lines\" config=\"vm.widgets[Id].mainChart.config\" options=\"vm.widgets[Id].mainChart.options\" data=\"vm.widgets[Id].mainChart.data\"></nvd3></div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/dashboard/widgets/Number.html","<ms-widget layout=\"row\" flex=\"\" ng-init=\"vm.initWidget(widget)\" flippable=\"false\"><ms-widget-front class=\"white-bg\"><div class=\"pl-8\" layout=\"row\" layout-align=\"space-between center\" layout-wrap=\"\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widgets[Id].currentRange\" aria-label=\"Change range\" ng-change=\"vm.changeWidgetTimePeriod(vm.widgets[Id], $index, vm.widgets[Id].currentRange)\"><md-option ng-repeat=\"w in vm.widgets[Id].TimePeriods\" value=\"{{w.Id}}\" ng-selected=\"vm.widgets[Id].currentRange == w.Id\">{{w.Name}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.refreshWidget(vm.widgets[Id], $index)\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-15\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\" ng-class=\"{\'red-fg\': $index == 0, \'light-blue-fg\': $index == 1, \'orange-fg\': $index == 2, \'light-green-fg\': $index == 3}\">{{vm.widgets[Id].currentValue}}</div></div><div class=\"p-8 grey-50-bg border-top\" layout=\"column\" layout-align=\"center center\"><div class=\"h2 secondary-text font-weight-500\">{{vm.widgets[Id].DisplayName}}</div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/dashboard/widgets/Tabular.html","<ms-widget layout=\"row\" flex=\"\" ng-init=\"vm.initWidget(widget)\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap=\"\"><div class=\"pl-8 h3\"><div class=\"h2 secondary-text font-weight-500\">{{vm.widgets[Id].DisplayName}}</div></div><div><md-select class=\"simplified font-size-16\" ng-if=\"widget.Name == \'VehicleUtilisationPercent\'\" style=\"display: inline-block\" ng-model=\"vm.widgets[Id].currentRange\" aria-label=\"Change range\" ng-change=\"vm.changeWidgetTimePeriod(vm.widgets[Id], $index, vm.widgets[Id].currentRange)\"><md-option ng-repeat=\"w in vm.widgets[Id].TimePeriods\" value=\"{{w.Id}}\" ng-selected=\"vm.widgets[Id].currentRange == w.Id\">{{w.Name}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.refreshWidget(widget, $index)\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div layout=\"col\" flex=\"100\" layout-align=\"start\" class=\"w-content\" ms-scroll=\"\"><div class=\"font-size-24 line-height-32\" flex=\"100\"><table class=\"ph-16 pb-16 tabular\"><tr ng-if=\"vm.widgets[Id].currentValue && vm.widgets[Id].currentValue != \'-\' && vm.widgets[Id].currentValue.length > 0\" ng-repeat=\"val in vm.widgets[Id].currentValue\"><td>{{ val.Name }}</td><td>{{ val.Total }}</td></tr><tr ng-if=\"!vm.widgets[Id].currentValue || vm.widgets[Id].currentValue == \'-\' || vm.widgets[Id].currentValue.length == 0\"><td colspan=\"2\">No Data Available.</td></tr></table></div></div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/holidays/view/holidays-view.html","<div id=\"holidays-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button translate=\"HOLIDAYS.MAIN_ADD_PUBLIC_HOLIDAY\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vm.service.showHolidayDialog(null, false)\"></md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{\'HOLIDAYS.MAIN_SEARCH\' | translate}}\" ng-model=\"vm.service.query\" ng-keyup=\"vm.searchTable()\"></md-input-container></div></div><table class=\"dataTable row-border hover\" dt-instance=\"vm.dtInstance\" style=\"margin-top :10px;\" datatable=\"ng\" dt-column-defs=\"vm.dtColumnDefs\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'HOLIDAYS.MAIN_NAME\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'HOLIDAYS.MAIN_DATE\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'HOLIDAYS.MAIN_BRANCH\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'HOLIDAYS.MAIN_ACTIONS\' | translate}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"holiday in vm.service.holidays\"><td>{{holiday.HolidayName}}</td><td>{{vm.formatDate(holiday.HolidayDate)}}</td><td>{{vm.displayBranch(holiday)}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.service.showHolidayDialog($index, true)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>{{\'HOLIDAYS.MAIN_EDIT_HOLIDAY\' | translate}}</span></md-tooltip></md-button><delete-component index=\"holiday.Id\" tool-tip=\"{{\'HOLIDAYS.MAIN_DELETE_HOLIDAY\' | translate}}\" message=\"{{\'HOLIDAYS.MAIN_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_HOLIDAY?\' | translate}}\" callback=\"vm.remove\" section=\"{{\'HOLIDAYS.MAIN_HOLIDAYS\' | translate}}\"></delete-component></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/invoiceExport/manage/invoice-export-manage.html","<div class=\"page-layout simple fullwidth element-doc-page invoice-export\"><div class=\"content\" layout=\"column\"><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header class=\"pv-0\"><md-card-header-text><h3 class=\"md-title mb-0\">{{\'INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_FORMAT\' | translate}}</h3></md-card-header-text></md-card-header><md-card-content><form name=\"InvoiceExportFormatForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><div layout=\"column\" flex=\"70\"><md-input-container layout=\"column\" flex=\"15\" class=\"invoice-export-format\"><textarea name=\"ExportFormat\" id=\"ExportFormat\" data-caret-aware=\"cursor\" ng-model=\"vm.invoiceExportSettings.ExportFormat\" placeholder=\"e.g. T5,{employeeCode},{employeeNo},,{codeType},{code},{qty:0.00},,,,{exportDate:dd/MM/yyyy},{glCode},,,,,,,,,,,\" required=\"\">\r\n\r\n                                            </textarea><div ng-messages=\"InvoiceExportFormatForm.ExportFormat.$error\" ng-show=\"InvoiceExportFormatForm.ExportFormat.$dirty\"><div ng-message=\"required\">This is required!</div></div></md-input-container><md-input-container layout=\"column\" flex=\"85\" class=\"mt-5\"><div ui-ace=\"{ mode: \'javascript\' }\" name=\"ConditionalScript\" ng-model=\"vm.invoiceExportSettings.ConditionalScript\"></div></md-input-container></div><div layout=\"column\" flex=\"30\"><md-input-container layout=\"column\"><md-list class=\"export-fields\"><md-list-item ng-repeat=\"field in vm.invoiceExportSettings.ExportFields\" class=\"md-1-line\" layout=\"row\" ng-click=\"vm.addInvoiceExportFormatField(field.Key)\"><div layout=\"column\" flex=\"40\">{ {{ field.Key }} }</div><div layout=\"column\" flex=\"60\">{{ field.Value }}</div></md-list-item></md-list></md-input-container></div></div><div flex=\"10\" layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editInvoiceExportFormat()\" ng-disabled=\"InvoiceExportFormatForm.ExportFormat.$invalid && InvoiceExportFormatForm.ExportFormat.$touched\">{{\'INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content><md-card-content><h3 class=\"md-title mv-0\">{{\'INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_HEADING\' | translate}}</h3><form name=\"invoiceExportFileHeadingForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100 pv-0\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><input name=\"fileHeading\" ng-model=\"vm.invoiceExportSettings.ExportHeader\"></md-input-container></div><div flex=\"\" layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editInvoiceExportFileHeading()\" ng-disabled=\"!invoiceExportFileHeadingForm.fileHeading.$dirty\">{{\'INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content></md-card></div></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_FILE_EXT\' | translate}}</h3></md-card-header-text></md-card-header><md-card-content class=\"m-0\"><form name=\"exportFileExtensionForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><input name=\"fileExtension\" ng-model=\"vm.invoiceExportSettings.ExportFileExtension\" md-maxlength=\"15\" ng-pattern=\"/^[a-zA-Z\\s]*$/\" required=\"\"><div ng-messages=\"exportFileExtensionForm.fileExtension.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">File extension should not be more than 15 characters</div><div ng-message=\"pattern\">Invalid file extension format</div></div></md-input-container></div><div flex=\"\" layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editInvoiceExportFileExtension()\" ng-disabled=\"exportFileExtensionForm.fileExtension.$invalid && exportFileExtensionForm.fileExtension.$touched\">{{\'INVOICE_EXPORT.MAIN_VIEW_MANAGE_INVOICE_EXPORT_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content></md-card></div></div></div></div>");
$templateCache.put("app/main/customValidations/create/custom-validations-create.html","<div id=\"custom-validations\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><md-button ng-click=\"vm.service.saveRule(vm.service.rule_model)\" ng-disabled=\"!vm.service.rule_model.RuleName || vm.service.rule_model.RuleName == null || vm.service.rule_model.IfConditions.length == 0 || vm.service.rule_model.ThenStatements.length == 0\" class=\"md-raised md-accent first-button-margin\">Save<md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.service.viewRules()\" class=\"md-raised md-accent first-button-margin\">View Rules<md-tooltip>View this rule</md-tooltip></md-button></div><div class=\"content\" style=\"background-color : #F5F5F5\" flex=\"\"><div style=\"margin-top : -20px;\" layout=\"row\" flex=\"\" layout-margin=\"\"><div flex=\"\" layout-margin=\"\"><md-input-container md-no-float=\"\" class=\"md-block\"><md-icon style=\"color : #475A64\" md-font-icon=\"icon-format-size\"></md-icon><input class=\"md-body-2 md-accent\" type=\"text\" ng-model=\"vm.service.rule_model.RuleName\" placeholder=\"Rule Name\"></md-input-container></div></div><div style=\"margin-top : -25px;\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\" layout-margin=\"\"><if-component ng-model=\"vm.service.rule_model.IfConditions\" flex=\"40\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"></if-component><then-component ng-model=\"vm.service.rule_model.ThenStatements\" flex=\"60\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"></then-component></div></div></div></div>");
$templateCache.put("app/main/equipment/view/equipments-view-documents.html","<document-manager class=\"document-manager\" modal=\"true\" module-id=\"3\" module-name=\"Equipment\" related-resource-id=\"{{vm.assetId}}\" \"=\"\"></document-manager>");
$templateCache.put("app/main/equipment/view/equipments-view.html","<div id=\"contact-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div layout=\"column\" class=\"toolbar-wrapper\"><toolbar-loader show=\"vm.equipmentsService.loader\" message=\"vm.equipmentsService.loaderMessage\"></toolbar-loader></div></div><div class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"white-bg md-whiteframe-4dp\" style=\"margin-top:20px;\"><div layout=\"column\" flex=\"\"><div flex=\"100\"><md-button ng-click=\"vm.addEquipmentDialog()\" class=\"md-fab md-mini md-accent\" aria-label=\"{{\'EQUIPMENT_VIEW.CREATE_EQUIPMENT_TOOLTIP\' | translate}}\" style=\"float: right; margin-top: -20px;\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'EQUIPMENT_VIEW.CREATE_EQUIPMENT_TOOLTIP\' | translate}}</md-tooltip></md-icon></md-button></div><div flex=\"100\" layout-align=\"center center\" style=\"padding : 10px;\"><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"vm.delay\" source=\"vm.dataGrid.grid.searchTerm\" layout-margin=\"\" flex=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.hasUserBranchConflict()\"><span class=\"material-icons md-18 amber600\" style=\"padding: 5px 5px 5px 20px;\">warning</span> <strong style=\"padding: 5px 0\">There are users who don\'t belong to the same branch as the equipment they are assigned to.</strong></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"UniqueId\" field-label=\"{{\'EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_ID\' | translate}}\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"ItemName\" field-label=\"{{\'EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_ITEM_NAME\' | translate}}\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Description\" field-label=\"{{\'EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_DESCRIPTION\' | translate}}\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"FullName\" field-label=\"{{\'EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_USER\' | translate}}\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"BranchNames\" field-label=\"{{\'EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_BRANCH\' | translate}}\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"DivisionNames\" field-label=\"{{\'EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_DIVISIONS\' | translate}}\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"ItemStatus\" field-label=\"{{\'EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_STATUS\' | translate}}\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'EQUIPMENT_VIEW.VIEW_EQUIPMENT_COLUMN_ACTIONS\' | translate}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.dataGrid.grid.data track by $index\"><td>{{item.UniqueId}}</td><td>{{item.ItemName}}</td><td>{{item.Description}}</td><td><span ng-if=\"vm.hasUserBranchConflict(item)\" class=\"material-icons md-18 amber600\" style=\"padding: 0 5px;\">warning</span> {{item.FullName}}</td><td>{{item.BranchNames}}</td><td>{{item.DivisionNames}}</td><td>{{item.ItemStatus}}</td><td layout=\"row\"><md-button class=\"md-icon-button\" ng-if=\"vm.canEditIndividualEquipmentItem\" ng-click=\"vm.editEquipmentDialog(item)\"><i class=\"icon icon-pencil teal-500-fg s15\"></i></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.equipmentsService.viewCalendar(item)\"><i class=\"icon icon-calendar blue-500-fg s15\"></i></md-button><md-button class=\"md-icon-button\" ng-if=\"vm.isDocumentManagementEnabled && vm.canManageDocumentAssets\" ng-click=\"vm.viewDocuments(item.ItemId, item.ItemName, item.ItemType, item.ParentItemTypes)\"><i class=\"icon icon-folder-download blue-500-fg s15\"></i></md-button><md-button ng-if=\"vm.canDeleteEquipment\" class=\"md-icon-button\" ng-click=\"vm.confirmDeleteEquipment(item)\"><md-icon md-font-icon=\"icon-trash\" class=\"red-500-fg\"></md-icon><md-tooltip><span>Delete Equipment</span></md-tooltip></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"vm.dataGrid.grid.behavior\" distinct-by=\"UniqueId\" on-init=\"vm.dataGrid.grid.onInit()\" on-error=\"vm.dataGrid.grid.onError(ex)\" on-completed=\"vm.dataGrid.grid.onCompleted(data)\" on-data-filter=\"vm.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div></div></div></div></div>");
$templateCache.put("app/main/invoice/emailSender/email-sender.html","<div id=\"invoice-email-sender\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/invoice/emailSender/sidenav/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex=\"\"><sidenav-filter-small-screen hide-gt-md=\"\" ng-click=\"emailSenderVm.toggleSidenav(\'main-sidenav\')\"></sidenav-filter-small-screen><invoice-custom-grid-search-component src-data=\"emailSenderVm.model.dataGrid.grid.searchText\" on-search=\"emailSenderVm.model.dataGrid.grid.onSearch(value)\" api=\"emailSenderVm.model.customGridSearchComponent\" flex=\"\"></invoice-custom-grid-search-component></div></div><email-sender-content-view-component class=\"content-card\" ng-class=\"classic\" layout=\"column\" on-check-toggle=\"emailSenderVm.checkToggle(toggleFlag)\" on-check-single-item=\"emailSenderVm.checkSingleItem(id)\" on-check-payment-claim=\"emailSenderVm.checkPaymentClaim(status)\" on-download-invoice=\"emailSenderVm.downloadInvoice(includePaperwork, isPaperworkOnly, isPaymentClaim, paymentClaimRequestType)\" on-send-mail=\"emailSenderVm.sendEmail()\" on-open-issue=\"emailSenderVm.openIssue(issues)\" on-select-view-type=\"emailSenderVm.selectViewType(type)\" api=\"emailSenderVm.model.emailSenderContentApi\" flex=\"\"></email-sender-content-view-component></div></div>");
$templateCache.put("app/main/invoice/exportViewer/invoice-export-viewer.html","<div id=\"invoice-export\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center main-container\" layout=\"column\" style=\"overflow: hidden;\" flex=\"\" ms-scroll=\"\"><div flex=\"\"><div class=\"pt-10 white-bg md-whiteframe-2dp main-style\"><div class=\"export-filter-component\" layout=\"row\" ng-form=\"invoiceExportForm\"><div layout=\"column\" flex=\"33\" class=\"pl-20 pr-20\"><div class=\"layout-column\"><md-input-container flex=\"\" layout=\"row\"><label>Invoice Start Date</label><md-datepicker ng-model=\"invExportViewVm.exportFilterService.data.startDate\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\" required=\"\"></md-datepicker></md-input-container></div><div class=\"layout-column\"><md-input-container flex=\"\" layout=\"row\" class=\"mt-10 mb-0\"><label>Invoice End Date</label><md-datepicker ng-model=\"invExportViewVm.exportFilterService.data.endDate\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\" required=\"\"></md-datepicker></md-input-container></div><div class=\"layout-column\"><md-input-container class=\"mt-20 mb-0\"><md-select name=\"branches\" ng-model=\"invExportViewVm.exportFilterService.data.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"Branch(es)\" multiple=\"\"><md-optgroup label=\"Branch(es)\"><md-option ng-value=\"branch\" ng-repeat=\"branch in invExportViewVm.lookups.branchLookups\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"layout-column\"><md-input-container class=\"mt-20 mb-20\"><md-select name=\"Clients\" ng-model=\"invExportViewVm.exportFilterService.data.selectedClients\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"Client(s)\" multiple=\"\"><md-optgroup label=\"Client(s)\"><md-option ng-value=\"client\" ng-repeat=\"client in invExportViewVm.lookups.clientLookups\">{{client.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div layout=\"column\" flex=\"33\" class=\"pl-20 pr-20\"><md-input-container><md-checkbox ng-model=\"invExportViewVm.exportFilterService.data.includeNotExportedOnly\" class=\"mb-0\" ng-disabled=\"invExportViewVm.isExportingInvoices || invExportViewVm.exportService.isProcessing\">Export invoices that have not already been exported only</md-checkbox></md-input-container></div><div layout=\"column\" flex=\"33\" layout-align=\"start center\" class=\"pl-20 pr-20 buttons-bar\"><div><div class=\"row\"><md-button ng-disabled=\"invoiceExportForm.$invalid || invExportViewVm.isLoadingInvoices || invExportViewVm.isExportingInvoices || invExportViewVm.exportService.isProcessing\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme first-button-margin\" ng-click=\"invExportViewVm.viewInvoice()\">Load Invoices</md-button></div><div class=\"row\"><md-button ng-if=\"!invExportViewVm.isIntegrationsEnabled\" ng-disabled=\"invoiceExportForm.$invalid || invExportViewVm.dataGrid.grid.data.length === 0\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme button-margin\" ng-click=\"invExportViewVm.export()\">Export</md-button></div><div class=\"row\"><md-button ng-if=\"invExportViewVm.isBillingEnabled && invExportViewVm.isXeroEnabled\" ng-disabled=\"invoiceExportForm.$invalid || !invExportViewVm.hasSelectedInvoices() || !invExportViewVm.isConnectedToXero || invExportViewVm.isExportingInvoices || invExportViewVm.exportService.isProcessing\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme button-margin\" ng-click=\"invExportViewVm.exportInvoicesToProvider(invExportViewVm.integrationsService.providerTypes.xero)\">Export to Xero</md-button></div><div class=\"row\"><md-button ng-if=\"invExportViewVm.isBillingEnabled && invExportViewVm.isMyobEnabled\" ng-disabled=\"invoiceExportForm.$invalid || !invExportViewVm.hasSelectedInvoices() || !invExportViewVm.isConnectedToMyob || invExportViewVm.isExportingInvoices || invExportViewVm.exportService.isProcessing\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme button-margin\" ng-click=\"invExportViewVm.exportInvoicesToProvider(invExportViewVm.integrationsService.providerTypes.myob)\">Export to MYOB</md-button></div></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"invExportViewVm.isIntegrationsEnabled && !invExportViewVm.isConnectedToAProvider\"><div class=\"mb-10\"><span translate=\"INVOICE_EXPORT.NO_CONNECTION_FOUND\"></span></div><div><span translate=\"INVOICE_EXPORT.INTEGRATIONS_PAGE\" ng-click=\"invExportViewVm.redirectToIntegrationsPage()\" class=\"clickable-item\"></span> <span translate=\"INVOICE_EXPORT.BUSINESSES_PAGE\" ng-click=\"invExportViewVm.redirectToBusinessesPage()\" class=\"clickable-item\"></span></div></div><div class=\"mt-10 mb-10\" ng-if=\"invExportViewVm.invoicingConnectorType\"><span translate=\"INVOICE_EXPORT.CONNECTED\"></span> <span><strong>{{invExportViewVm.invoicingConnectorType}}</strong></span></div></div></div><div flex=\"\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"invExportViewVm.invoicingConnectorType\"><payroll-widget ng-repeat=\"widget in invExportViewVm.exportService.widgets\" widget=\"widget\" flex=\"20\" flex-sm=\"50\" flex-md=\"50\" ng-if=\"widget.value\"></payroll-widget></div><div ng-if=\"invExportViewVm.exportService.isProcessing || invExportViewVm.exportService.progressBarMessage || invExportViewVm.exportService.progressBarErrorMessage\" layout-align=\"start start\" layout=\"column\" class=\"pl-20 pr-20\"><div layout=\"column\" class=\"mb-10 ml-15\"><div layout=\"row\" ng-if=\"invExportViewVm.exportService.progressBarMessage || invExportViewVm.exportService.progressBarErrorMessage\"><span ng-if=\"invExportViewVm.exportService.progressBarMessage\" ng-class=\"{\'instruction-warning\': invExportViewVm.exportService.isProcessing, \'text-bold\': !invExportViewVm.exportService.isProcessing }\">{{invExportViewVm.exportService.progressBarMessage}}</span><md-progress-circular ng-if=\"invExportViewVm.exportService.isProcessing\" md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent ml-10 mr-10\"></md-progress-circular></div><span ng-if=\"invExportViewVm.exportService.progressBarErrorMessage\" class=\"instruction-warning mt-5\">{{invExportViewVm.exportService.progressBarErrorMessage}}</span></div></div><div class=\"pr-20 pl-20 pb-20 pt-0 ms-responsive-table-wrapper\" ng-show=\"!!invExportViewVm.dataGrid.filterData\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"invExportViewVm.dataGrid.grid.data && invExportViewVm.dataGrid.grid.data.length > 0\"><a8-grid-search-component delay=\"invExportViewVm.delay\" source=\"invExportViewVm.dataGrid.grid.searchTerm\" flex=\"\" layout-margin=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"invExportViewVm.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th ng-if=\"invExportViewVm.invoicingConnectorType\" class=\"column-select-item\"><md-checkbox class=\"md-primary\" ng-model=\"invExportViewVm.exportService.allItemsOnCurrentPageSelected\" ng-change=\"invExportViewVm.toggleSelectAllItems()\" ng-disabled=\"invExportViewVm.isExportingInvoices || invExportViewVm.exportService.isProcessing\"></md-checkbox></th><th class=\"secondary-text\"><a8-sort-column sort-by=\"InvoiceNumber\" field-label=\"Invoice No.\"></a8-sort-column></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"InvoiceDate\" field-label=\"Invoice Date\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CompanyName\" field-label=\"Company Name\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Branches\" field-label=\"Branches\"></a8-sort-column></div></th><th ng-if=\"invExportViewVm.isBillingEnabled && invExportViewVm.isIntegrationsEnabled\" class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"ExportToTenantName\" field-label=\"Export to\"></a8-sort-column></div></th><th ng-if=\"invExportViewVm.displayMyobJobNumberColumn\" class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"JobNumberHtml\" field-label=\"MYOB Job No.\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"PurchaseOrderHtml\" field-label=\"Purchase Order\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"TotalIncludingTax\" field-label=\"Total\"></a8-sort-column></div></th></tr></thead><tfoot><tr><td colspan=\"3\"></td></tr></tfoot><tbody><tr ng-repeat-start=\"invoice in invExportViewVm.dataGrid.grid.data track by $index\"><td class=\"column-select-item\" ng-if=\"invExportViewVm.invoicingConnectorType\"><md-checkbox ng-model=\"invoice.isSelected\" ng-if=\"!invoice.isExporting && !invExportViewVm.doesInvoiceHaveErrors(invoice)\" ng-disabled=\"invExportViewVm.isExportingInvoices || invExportViewVm.exportService.isProcessing\" class=\"md-primary\" ng-change=\"invExportViewVm.exportService.checkAllItemsOnCurrentPageSelected()\"></md-checkbox><md-progress-circular ng-if=\"invoice.isExporting\" md-mode=\"indeterminate\" layout-align=\"center center\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular><invoice-error-column invoice=\"invoice\" ng-if=\"!invoice.isExporting && invExportViewVm.doesInvoiceHaveErrors(invoice)\"></invoice-error-column></td><td>{{invoice.InvoiceNumber}}</td><td>{{invoice.InvoiceDate}}</td><td>{{invoice.CompanyName}}</td><td><span ng-bind-html=\"invoice.BranchesHtml\"></span></td><td ng-if=\"invExportViewVm.isBillingEnabled && invExportViewVm.isIntegrationsEnabled\">{{invoice.ExportToTenantName}}</td><td ng-if=\"invExportViewVm.displayMyobJobNumberColumn\"><span ng-bind-html=\"invoice.JobNumberHtml\"></span></td><td><span ng-bind-html=\"invoice.PurchaseOrderHtml\"></span></td><td>${{invoice.TotalIncludingTax}}</td></tr><tr ng-repeat-end=\"\" ng-if=\"invoice.showErrors\"><td></td><td colspan=\"8\"><invoice-error-details errors=\"invoice.InvoicingErrors\" invoice=\"invoice\" delete-action=\"invExportViewVm.confirmDeleteInvoice(invoice)\" redirect-to-company-page=\"invExportViewVm.redirectToCompanyPage(invoice)\" export-invoice-paperwork-callback=\"invExportViewVm.exportInvoicePaperwork(invoice, \'xero\')\"></invoice-error-details></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"invExportViewVm.dataGrid.grid.behavior\" distinct-by=\"InvoiceNumber\" on-init=\"invExportViewVm.dataGrid.grid.onInit()\" on-error=\"invExportViewVm.dataGrid.grid.onError(ex)\" on-completed=\"invExportViewVm.onInvoicesLoaded(data)\" on-data-filter=\"invExportViewVm.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div></div></div>");
$templateCache.put("app/main/invoice/reports/invoice-report-manager.default.html","<div id=\"invoice-report\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/invoice/reports/sidenav/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div layout=\"column\" flex=\"\"><div ng-show=\"!invRepVm.model.isViewingInvoices\" layout=\"column\" hide-gt-md=\"\"><div layout=\"row\" class=\"form-wrapper md-whiteframe-1dp main-style mb-20\"><sidenav-filter-small-screen layout=\"row\" name=\"{{invRepVm.showFiltersText}}\" additional-class=\"md-fab md-mini md-accent pull-right\" ng-click=\"invRepVm.toggleSidenav(\'main-sidenav\')\"></sidenav-filter-small-screen></div></div><div class=\"pl-30 pr-30\" layout=\"column\" flex=\"\"><div layout=\"column\" flex=\"\" ms-scroll=\"\"><div ng-if=\"invRepVm.sidenavModel.isLocked\" class=\"mt-20\"><div flex=\"\" layout=\"row\" layout-align=\"start end\"><div class=\"mr-10\" ng-if=\"invRepVm.model.invoiceGenerationProgress.hasMoreCompaniesToProcess\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"28\"></md-progress-circular></div><div ng-if=\"invRepVm.model.invoiceGenerationProgress.hasMoreCompaniesToProcess\"><span>Generating invoices for <strong>{{invRepVm.model.invoicingCompanies.length}}</strong> clients ...</span></div><div ng-if=\"!invRepVm.model.invoiceGenerationProgress.hasMoreCompaniesToProcess && invRepVm.model.invoiceGenerationProgress.totalNumberOfInvoices > 0\"><span>Generated invoices for <strong>{{invRepVm.model.invoicingCompanies.length}}</strong> clients.</span></div><div ng-if=\"!invRepVm.model.invoiceGenerationProgress.hasMoreCompaniesToProcess && invRepVm.model.invoiceGenerationProgress.totalNumberOfInvoices == 0\"><span>There were <strong>no</strong> invoices generated for <strong>{{invRepVm.model.invoicingCompanies.length}}</strong> clients.</span></div><div flex=\"\" layout=\"row\" layout-align=\"end center\"><md-button class=\"pl-10 pr-10 md-accent md-raised\" ng-click=\"invRepVm.viewInvoiceStatus()\" ng-disabled=\"invRepVm.model.isGeneratingInvoices\">Invoice Status</md-button><md-button class=\"pl-10 pr-10 md-accent md-raised\" ng-click=\"invRepVm.viewInvoices()\" ng-disabled=\"invRepVm.model.isViewingInvoices || invRepVm.model.invoiceGenerationProgress.hasMoreCompaniesToProcess || !invRepVm.model.invoiceGenerationProgress.canViewInvoices\">View Invoices</md-button></div></div><div flex=\"\" class=\"mt-10\" ng-if=\"invRepVm.model.invoiceGenerationProgress.hasMoreCompaniesToProcess\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div></div><div ng-if=\"invRepVm.model.isGeneratingInvoices\" class=\"mb-20\"><div ng-repeat=\"invoicingCompany in invRepVm.model.invoicingCompanies\" class=\"invoicing-company\" layout=\"row\" flex=\"60\" layout-align=\"start center\" ng-hide=\"invRepVm.hideCompanies && invoicingCompany.NumberOfInvoices === 0 && invoicingCompany.IsGenerated\"><div><md-icon ng-if=\"invoicingCompany.IsQueued\" class=\"icon job-queued\" md-font-icon=\"icon-clock\"></md-icon><md-icon ng-if=\"invoicingCompany.IsGenerated\" ng-class=\"{\'icon job-generated\': invoicingCompany.NumberOfInvoices > 0}\" md-font-icon=\"icon-check-circle\"></md-icon><md-icon ng-if=\"!invoicingCompany.IsQueued && !invoicingCompany.IsGenerated\" class=\"icon job-failed\" md-font-icon=\"icon-information\"></md-icon></div><div><span class=\"font-size-14 bold-text\">{{invoicingCompany.CompanyName}}</span><div ng-if=\"invoicingCompany.Notes\" class=\"md-caption\">{{invoicingCompany.Notes}}</div></div><div flex=\"\"></div><div><span ng-if=\"invoicingCompany.NumberOfInvoices > -1\" class=\"badge\">{{invoicingCompany.NumberOfInvoices}}</span></div></div></div><div ng-show=\"invRepVm.model.isViewingInvoices\" class=\"white-bg mt-10 p-10\" style=\"border: 1px solid #e6e6e6; border-radius: 6px;\"><div class=\"header\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"search-wrapper\" layout=\"row\" layout-align=\"start center\"><sidenav-filter-small-screen layout=\"row\" hide-gt-md=\"\" ng-click=\"invRepVm.toggleSidenav(\'main-sidenav\')\"></sidenav-filter-small-screen><invoice-custom-grid-search-component delay=\"invRepVm.delay\" src-data=\"invRepVm.model.grid.searchText\" on-search=\"invRepVm.model.grid.onSearch(value)\" api=\"invRepVm.model.customGridSearchComponentApi\" flex=\"\"></invoice-custom-grid-search-component></div></div></div><invoice-content-view-component ng-show=\"invRepVm.model.isViewingInvoices\" class=\"white-bg mt-10 p-10\" ng-class=\"classic\" layout=\"column\" flex=\"\"></invoice-content-view-component></div><div class=\"notification-bar md-whiteframe-1dp mt-10 mb-10 pl-20 pr-20\" layout-align=\"start center\" ng-show=\"invRepVm.model.enableRefresh\" layout=\"row\"><div flex=\"\"><div>There have been updates to the invoices that you are previewing.</div><div>Please <strong>refresh</strong> to sync up the changes.</div></div><div flex=\"10\" class=\"m-20\"><md-button class=\"md-accent md-raised button-margin\" type=\"button\" ng-click=\"invRepVm.model.refreshInvoicesGrid()\">Refresh</md-button></div></div></div></div></div>");
$templateCache.put("app/main/messaging/generalMessaging/messaging.html","<div class=\"messaging page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.service.is_sending || vm.service.is_loading\"></md-progress-linear><div class=\"content\" layout=\"row\" flex=\"auto\"><message-container flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" flex=\"\"></message-container><contacts-area sticky-contacts=\"\" flex=\"20\" ng-if=\"vm.mediaService.isDeviceMessagingBig() && vm.service.contacts_available.length > 0\"></contacts-area></div></div></div>");
$templateCache.put("app/main/invoice/view/invoice-list-view.html","<div id=\"invoice-pdf\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" style=\"overflow: hidden;\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp toolbar-custom\"><div class=\"toolbar-wrapper\"><invoice-report-filter-component></invoice-report-filter-component></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"invPdfViewVm.delay\" source=\"invPdfViewVm.dataGrid.grid.searchTerm\" layout-margin=\"\" flex=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"invPdfViewVm.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><a8-sort-column sort-by=\"InvoiceNumber\" field-label=\"Invoice No.\"></a8-sort-column></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"InvoiceDate\" field-label=\"Invoice Date\" default=\"true\" initial-default-dir=\"desc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CompanyName\" field-label=\"Company Name\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CompanyCode\" field-label=\"Company Code\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Branches\" field-label=\"Branches\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"PurchaseOrderHtml\" field-label=\"Purchase Order\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"JobDatesHtml\" field-label=\"Job Dates\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"TicketsHtml\" field-label=\"Ticket #\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"CreditType\" field-label=\"Type\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tfoot><tr><td colspan=\"9\"></td></tr></tfoot><tbody><tr ng-repeat=\"invoice in invPdfViewVm.dataGrid.grid.data track by $index\"><td>{{invoice.InvoiceNumber}}</td><td>{{invoice.InvoiceDate}}</td><td>{{invoice.CompanyName}}</td><td>{{invoice.CompanyCode}}</td><td><span ng-bind-html=\"invoice.BranchesHtml\"></span></td><td><span ng-bind-html=\"invoice.PurchaseOrderHtml\"></span></td><td><span ng-bind-html=\"invoice.JobDatesHtml\"></span></td><td><span ng-bind-html=\"invoice.TicketsHtml\"></span></td><td><div class=\"label\" ng-class=\"invoice.CreditTypeStatus.color\">{{invoice.CreditTypeStatus.text}}</div></td><td><md-button class=\"md-icon-button\" aria-label=\"Credit\" ng-click=\"invPdfViewVm.previewInvoice(invoice.RelatedInvoiceId)\" ng-hide=\"!invoice.HasInvoiceForCredit\" ng-disabled=\"!invoice.RelatedInvoiceId\"><md-icon md-font-icon=\"icon-clipboard-text\" ng-class=\"{\'pending-action\': invoice.HasInvoiceForCredit}\"></md-icon><md-tooltip md-direction=\"bottom\">Preview Invoice</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Credit\" ng-click=\"invPdfViewVm.credit(invoice.Id, invoice.InvoiceNumber)\" ng-hide=\"invoice.IsReInvoiced || invPdfViewVm.noAccess\"><md-icon md-font-icon=\"icon-minus-circle-outline\"></md-icon><md-tooltip md-direction=\"bottom\">Credit</md-tooltip></md-button><md-button class=\"md-icon-button margin-left-0 padding-left-0\" aria-label=\"Credit Reinvoice\" ng-click=\"invPdfViewVm.credit(invoice.Id, invoice.InvoiceNumber, true)\" ng-hide=\"invoice.IsReInvoiced || invPdfViewVm.noAccess\"><md-icon md-font-icon=\"icon-minus-circle\"></md-icon><md-tooltip md-direction=\"bottom\">Credit Reinvoice</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Change Purchase Order\" ng-click=\"invPdfViewVm.changePurchaseOrderNumber(invoice.Id, invoice.PurchaseOrderNumbers[0])\" ng-hide=\"invPdfViewVm.noPOAccess || invoice.CreditType == 1\"><md-icon md-font-icon=\"icon-table-edit\"></md-icon><md-tooltip md-direction=\"bottom\">Change PO</md-tooltip></md-button><md-button ng-if=\"invPdfViewVm.canDeleteInvoice\" class=\"md-icon-button\" aria-label=\"Delete Invoice\" ng-click=\"invPdfViewVm.confirmDeleteInvoice(invoice.Id, invoice.InvoiceNumber)\"><md-icon md-font-icon=\"icon-trash\" class=\"red-500-fg\"></md-icon><md-tooltip md-direction=\"bottom\">Delete Invoice</md-tooltip></md-button><md-menu md-offset=\"0 -5\"><md-button class=\"md-icon-button\" ng-click=\"invPdfViewVm.openMenu($mdMenu, $event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"grey-500-fg\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"menuItem in invPdfViewVm.getMenuItems(invoice)\"><md-button ng-click=\"invPdfViewVm.menuItemClick($index, invoice.InvoiceAndPaperworkPdfUri, invoice.InvoiceOnlyPdfUri, invoice.PaperworkOnlyPdfUri)\" ng-disabled=\"menuItem.disabled\"><md-icon md-font-icon=\"{{menuItem.icon}}\"></md-icon>{{menuItem.name}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"invPdfViewVm.dataGrid.grid.behavior\" distinct-by=\"InvoiceNumber\" on-init=\"invPdfViewVm.dataGrid.grid.onInit()\" on-error=\"invPdfViewVm.dataGrid.grid.onError(ex)\" on-completed=\"invPdfViewVm.dataGrid.grid.onCompleted(data)\" on-data-filter=\"invPdfViewVm.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div></div></div>");
$templateCache.put("app/main/lockoutSettings/view/lockout-settings-view.html","<div id=\"invoice-report\" class=\"page-layout carded left-sidenav main-style\" layout=\"row\"><div class=\"top-bg2 md-accent-bg\"></div>GU<div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div ng-if=\"vm.service.rules.length > 0\" class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.service.searchQuery\" type=\"text\" placeholder=\"{{\'REPORTING.SEARCH\' | translate}}\"></div></div></div><div class=\"content-card\" ng-class=\"classic\" layout=\"column\"><div class=\"toolbar \'toolbar-content\'\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div layout=\"row\" layout-align=\"start center space-between\" flex=\"\"><toolbar-loader show=\"vm.service.loader\" message=\"vm.service.loaderMessage\"></toolbar-loader><md-button class=\"md-accent md-raised\" translate=\"LOCKOUTSETTINGS.VIEW_ADD\" ng-if=\"(!vm.service.loader) && vm.service.selectedRule == null && vm.service.isDeviceBig()\" ng-click=\"vm.service.select(false, null)\"></md-button><md-button class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-if=\"(!vm.service.loader) && vm.service.selectedRule == null && vm.service.isDeviceSmall()\" ng-click=\"vm.service.select(false, null)\"><i class=\"icon icon-plus cyan-900-fg s15\"></i></md-button></div></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.service.loader\" class=\"md-accent\"></md-progress-linear><md-content class=\"md-default-theme default-height\" layout=\"row\" style=\"overflow: hidden\"><rules-component flex=\"25\" flex-sm=\"100\" flex-md=\"50\" flex-xs=\"100\" class=\"scrollable\" ms-scroll=\"\" ng-if=\"vm.showList()\" data=\"vm.service.rules\" loading=\"vm.service.loader\"></rules-component><md-divider vertical=\"\" ng-if=\"vm.service.isDeviceBig()\"></md-divider><lock-out-override-component flex=\"75\" flex-md=\"50\" class=\"scrollable\" ms-scroll=\"\" flex-sm=\"100\" flex-xs=\"100\" ng-if=\"vm.showDetails()\" loading=\"vm.service.loader\"></lock-out-override-component></md-content></div></div></div>");
$templateCache.put("app/main/jobs/equipmentTicketBilling/equipment-whiteboard.html","<div id=\"whiteboard-calendar\" class=\"page-layout simple main-style fullwidth doc-page\" layout=\"column\"><div class=\"content-card layout-column flex\" layout=\"column\" flex=\"\"><div class=\"content md-default-theme\" style=\"background: #E5E7E8\" flex=\"\" ms-scroll=\"\"><div flex=\"\" layout=\"row\" id=\"jobBoardComponent\"><week-component-directive datalist=\"vm.service.dataList\" flex=\"\"></week-component-directive></div></div></div></div>");
$templateCache.put("app/main/jobs/allocateResource/allocate-resource.html","<div id=\"allocate-resource\" class=\"page-layout simple fullwidth doc-page resource-messaging\" layout=\"column\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"pt-10 pl-20 pr-20 pb-20\" ng-if=\"!vm.mediaService.isDeviceResource738PX()\"><div class=\"toolbar-wrapper\"><md-button ng-if=\"!vm.service.showDroppableLoader\" class=\"md-raised md-accent button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_VIEW_TICKET\" ng-click=\"vm.editTicket()\"></md-button><md-button ng-if=\"!vm.service.showDroppableLoader && (vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled)\" class=\"md-raised md-accent button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_FORMS_AND_ATTACHMENTS\" ng-click=\"vm.goToFormsAndAttachment()\"></md-button><md-button class=\"md-raised md-accent button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_ALLOCATE_RESOURCE\" disabled=\"true\"></md-button><md-button ng-if=\"vm.service.peopleResource > 0 && !vm.service.showDroppableLoader && !vm.service.isSmartSchedulingFailed\" class=\"md-raised md-accent button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_TIMESHEETS\" ng-click=\"vm.goToTimesheetsPage()\"></md-button><md-button ng-if=\"vm.service.isSmartSchedulingFailed\" class=\"md-raised md-accent button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_TIMESHEETS\" ng-click=\"vm.goToTimesheetsPage()\" disabled=\"true\"></md-button></div><div class=\"toolbar-wrapper\"><md-button ng-if=\"!vm.service.showDroppableLoader\" class=\"md-raised button-margin\" translate=\"RESOURCEALLOCATION.DETAILS\" ng-click=\"vm.showTicketDetails()\"></md-button><md-button ng-if=\"!vm.service.showDroppableLoader\" class=\"md-raised button-margin\" translate=\"RESOURCEALLOCATION.VIEWHISTORY\" ng-click=\"vm.service.viewHistory()\"></md-button><md-button ng-if=\"!vm.service.showDroppableLoader\" class=\"md-raised button-margin\" translate=\"RESOURCEALLOCATION.REFRESH\" ng-click=\"vm.refresh()\"></md-button><md-button ng-if=\"vm.service.resource_like_flag.length > 0 && !vm.service.showDroppableLoader\" class=\"md-raised button-margin\" ng-click=\"vm.service.showResourceLikeDialog()\" translate=\"RESOURCEALLOCATION.RESOURCE_LIKE\"></md-button><md-button ng-if=\"vm.showJobAllocationButton() && vm.isMobileAppEnabled\" ng-click=\"vm.service.showJobAllocationDialog()\" class=\"md-raised button-margin\" translate=\"RESOURCEALLOCATION.SEND_JOB_NOTIFS\"></md-button><md-button ng-if=\"!vm.service.showDroppableLoader && !vm.service.is_equipment && vm.isMobileAppEnabled && !vm.service.isSmartSchedulingFailed\" ng-click=\"vm.service.showMessageDialog()\" class=\"md-raised button-margin\" translate=\"RESOURCEALLOCATION.SEND_MESSAGES\"></md-button><md-button ng-if=\"vm.service.isSmartSchedulingFailed\" ng-click=\"vm.service.showMessageDialog()\" class=\"md-raised button-margin\" translate=\"RESOURCEALLOCATION.SEND_MESSAGES\" disabled=\"true\"></md-button><md-button ng-if=\"vm.showAllocateResourceBySmartScheduling()\" ng-click=\"vm.generatePreSchedule()\" class=\"md-raised button-margin margin-right-2\">Allocate with Scheduling Copilot</md-button></div></div><div ng-if=\"!vm.service.isSmartSchedulingFailed && vm.isTicketLockedByPreSchedule()\" layout=\"row\" class=\"form-wrapper md-whiteframe-2dp p-0 br-10\"><div layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent ml-10 mr-10\"></md-progress-circular></div><span layout=\"column\" layout-align=\"center center\" translate=\"MANAGE.AI_RESOURCE_ALLOCATION_MESSAGE\"></span><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn\" ng-click=\"vm.cancelScheduling()\">Cancel</md-button></div></div><div id=\"smartSchedulingFailedSection\" ng-if=\"vm.service.isSmartSchedulingFailed\" layout=\"row\" class=\"form-wrapper md-whiteframe-2dp p-0 br-10\"><md-icon md-svg-icon=\"warning-circle\" class=\"red-400-fg\"></md-icon><span class=\"message\" layout=\"column\" layout-align=\"center center\" translate=\"MANAGE.AI_RESOURCE_ALLOCATION_FAILED_MESSAGE\"></span><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-cancel\" ng-click=\"vm.cancelScheduling()\">CANCEL</md-button><md-button class=\"md-retry\" ng-click=\"vm.retrySchedulingCopilot()\">RETRY</md-button></div></div><div ng-if=\"vm.isTicketAllocatedBySmartScheduling()\" layout=\"row\" class=\"form-wrapper md-whiteframe-2dp p-1 br-10 preschedule-legend-container\"><span layout=\"row\" layout-align=\"center center\">Resources in <span class=\"legend-deep-purple-circle\"></span> were allocated using Scheduling Copilot</span></div><div class=\"toolbar-wrapper device-sm\" ng-if=\"vm.mediaService.isDeviceResource738PX()\"><md-button class=\"md-icon-button action-button\" ng-click=\"vm.viewJobs()\"><i class=\"icon-briefcase-checked cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.VIEWJOB\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-click=\"vm.editTicket()\"><i class=\"icon-table-edit cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.EDITTICKET\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-click=\"vm.goToFormsAndAttachment()\" ng-if=\"vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled\"><i class=\"icon-library-books cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.FORMS_AND_ATTACHMENTS\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-click=\"vm.allocateResource()\" ng-if=\"vm.service.peopleResource > 0\"><i class=\"icon-timetable cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.TIMESHEET\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-click=\"vm.showTicketDetails()\"><i class=\"icon-view-list cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.DETAILS\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-click=\"vm.refresh()\"><i class=\"icon-refresh cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.REFRESH\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-click=\"vm.service.viewHistory()\"><i class=\"icon-calendar-clock cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.VIEWHISTORY\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-click=\"vm.service.showResourceLikeDialog()\" ng-if=\"vm.service.resource_like_flag.length > 0\"><i class=\"icon-account-multiple cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.RESOURCE_LIKE\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-if=\"vm.showJobAllocationButton()\" ng-click=\"vm.service.showJobAllocationDialog()\"><i class=\"icon-message-image cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.SEND_JOB_NOTIFS\' | translate}}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-if=\"!vm.service.showDroppableLoader && !vm.service.is_equipment\" ng-click=\"vm.service.showMessageDialog()\"><i class=\"icon-message-text-outline cyan-900-fg\"><md-tooltip>{{\'RESOURCEALLOCATION.SEND_MESSAGES\' | translate}}</md-tooltip></i></md-button></div></div><md-content md-disable-scroll-target=\"\"><div style=\"padding: 10px;\"><div ng-if=\"vm.service.costEstimate\" style=\"margin-bottom: 15px;\" class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><md-icon class=\"m-0 mr-8 md-default-theme md-font material-icons icon-receipt\" aria-hidden=\"true\"></md-icon><div class=\"h3\">Quotation</div></div></div><div class=\"pb-24\" layout=\"column\"><div class=\"h1 pl-8\">{{ vm.service.costEstimate.TotalIncludingTax | currency }}</div><div class=\"h3 secondary-text pl-8\" layout=\"column\"><span>#{{ vm.service.costEstimate.InvoiceNumber }}</span> <span>{{ vm.service.costEstimate.InvoiceDate | date: \'EEE, d MMM yyyy\' }}</span> <span>{{ vm.service.costEstimate.RateCard.Name}}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><md-icon class=\"m-0 mr-8 md-default-theme md-font material-icons icon-currency-usd\" aria-hidden=\"true\"></md-icon><div class=\"h3\">Payroll Projection</div></div></div><div class=\"pb-10\" layout=\"column\"><div ng-if=\"vm.service.projectedPayBreakdown && !vm.service.loadingCostProjection\" class=\"h1\">{{vm.service.projectedPayrollTotal | currency}}</div><div ng-if=\"vm.service.projectedPayBreakdown && !vm.service.loadingCostProjection\" class=\"h5 secondary-text\"><span class=\"noselect\" style=\"cursor: pointer;\" ng-click=\"vm.service.showBreakDown = !vm.service.showBreakDown\">{{vm.service.showBreakDown ? \'Hide Breakdown\': \'Show Breakdown\'}}</span></div><div ng-if=\"vm.service.projectedPayBreakdown && !vm.service.loadingCostProjection\" ng-repeat=\"item in vm.service.projectedPayBreakdown\" ng-show=\"vm.service.showBreakDown\" style=\"padding-top: 10px;\"><div>{{item.EmployeeName}}: {{item.TotalPay | currency}}</div><div ng-repeat=\"breakdown in item.PayBreakdown\" style=\"padding-left: 10px\"><span>{{breakdown.RuleName}}</span> <span>{{breakdown.Qty}}</span> <span>{{breakdown.Amount | currency}}</span> <span style=\"color: rgba(211, 208, 208, 0.829)\">{{breakdown.PayCode}}</span></div></div><div ng-if=\"vm.service.loadingCostProjection\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent droppable-spinner\"></md-progress-circular></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-fg ms-widget-front ng-scope\" layout-align=\"center center\" ng-style=\"{\'background-color\': vm.service.isBalancePositive ? \'#07cf52\' : \'#FF3366\'}\"><div ng-if=\"!vm.service.loadingCostProjection\" class=\"h1\" layout-align=\"center center\">{{vm.service.costEstimate.TotalIncludingTax - vm.service.projectedPayrollTotal | currency}}</div><div ng-if=\"vm.service.loadingCostProjection\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent droppable-spinner\"></md-progress-circular></div></ms-widget-front></ms-widget></div><div layout=\"row\" class=\"main-content\" ng-show=\"vm.mediaService.isResourceView1()\"><droppable-x-l></droppable-x-l></div><div layout=\"row\" class=\"main-content\" ng-show=\"vm.mediaService.isResourceView2()\"><droppable-between></droppable-between></div><div layout=\"row\" class=\"main-content\" ng-show=\"vm.mediaService.isResourceView3()\"><droppable-small></droppable-small></div><div layout=\"row\" class=\"main-content\" ng-show=\"vm.mediaService.isResourceView4()\"><droppable-between></droppable-between></div><div layout=\"row\" class=\"main-content\" ng-show=\"vm.mediaService.isResourceView5()\"><droppable-small></droppable-small></div></div></md-content><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-disable-scroll-target=\"#allocate-resource\" ms-scroll=\"\" md-component-id=\"right\"><div ng-include=\"\'app/main/jobs/allocateResource/components/draggableComponent/draggable-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/messaging/jobMessaging/job-messaging.html","<div id=\"job-messaging\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/messaging/jobMessaging/sidenav/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex=\"\"><sidenav-filter-small-screen hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\"></sidenav-filter-small-screen><job-messaging-custom-grid-search-component src-data=\"vm.dataGrid.grid.searchText\" on-search=\"vm.dataGrid.grid.onSearch(value)\" api=\"vm.customGridSearchComponent\" flex=\"\"></job-messaging-custom-grid-search-component></div></div><job-messaging-content-view-component class=\"content-card\" ng-class=\"classic\" layout=\"column\" on-check-toggle=\"vm.checkToggle(toggleFlag)\" on-check-single-item=\"vm.checkSingleItem(id)\" on-download-invoice=\"vm.downloadInvoice()\" on-send-message=\"vm.sendMessage()\" on-accept-shifts=\"vm.acceptShifts()\" on-open-issue=\"vm.openIssue(issues)\" on-select-view-type=\"vm.selectViewType(type)\" on-sort=\"vm.sort(sortDir)\" on-context-menu-click=\"vm.onContextMenuClick(contextParam)\" api=\"vm.jobSenderContentApi\" flex=\"\"></job-messaging-content-view-component></div></div>");
$templateCache.put("app/main/jobs/mapView/jobs-map-view.html","<div id=\"map-overview\" class=\"page-layout carded fullwidth ng-scope layout-row\" layout=\"row\"><div layout=\"column\" layout-padding=\"\" flex=\"\"><div layout=\"row\" flex=\"\"><div layout=\"row\" flex=\"\" layout-wrap=\"\"><div class=\"p-20\" flex=\"\" layout=\"column\"><div layout=\"row\"><div><md-input-container flex=\"\"><label class=\"filter-label-date\">{{ \'MAP_OVERVIEW.STARTDATE\' | translate }}</label><md-datepicker ng-model=\"vm.filters.startDate\" ng-required=\"\"></md-datepicker></md-input-container></div></div><div layout=\"row\"><div><md-input-container flex=\"\"><label class=\"filter-label-date\">{{ \'MAP_OVERVIEW.ENDDATE\' | translate }}</label><md-datepicker ng-model=\"vm.filters.endDate\" ng-required=\"\"></md-datepicker></md-input-container></div></div></div><div class=\"p-20\" flex=\"\" layout=\"column\"><md-input-container flex=\"\"><md-select name=\"branches\" ng-model=\"vm.filters.selectedBranchIds\" placeholder=\"{{ \'MAP_OVERVIEW.BRANCHES\' | translate }}\" multiple=\"\"><md-optgroup label=\"Branch(es)\"><md-option ng-value=\"branch.Id\" ng-repeat=\"branch in vm.branches\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"p-20\" flex=\"\" layout=\"column\"><md-input-container flex=\"\"><md-select name=\"companies\" ng-model=\"vm.filters.selectedCompanyIds\" placeholder=\"{{ \'MAP_OVERVIEW.CLIENTS\' | translate }}\" multiple=\"\"><md-option ng-value=\"company.Id\" ng-repeat=\"company in vm.companies\">{{company.Name + \' (\' + company.CompanyCode + \')\'}}</md-option></md-select></md-input-container></div><div class=\"p-20\" flex=\"\" layout=\"column\"><md-input-container flex=\"\"><md-select name=\"projects\" ng-model=\"vm.filters.selectedProjectIds\" placeholder=\"{{ \'MAP_OVERVIEW.PROJECTS\' | translate }}\" multiple=\"\"><md-option ng-value=\"project.id\" ng-repeat=\"project in vm.projects\">{{project.Name}}</md-option></md-select></md-input-container></div><div class=\"p-20\" flex=\"\" layout=\"column\"><md-input-container flex=\"\"><md-select name=\"tags\" ng-model=\"vm.filters.selectedTagIds\" placeholder=\"{{ \'MAP_OVERVIEW.TAGS\' | translate }}\" multiple=\"\"><md-option ng-value=\"tag.Id\" ng-repeat=\"tag in vm.tags\">{{tag.Name}}</md-option></md-select></md-input-container></div></div><div layout=\"column\" flex=\"15\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" aria-label=\"Reset\" ng-click=\"vm.loadTickets()\">Load Tickets</md-button></div></div><div id=\"googleMap\"></div></div></div>");
$templateCache.put("app/main/jobs/confirmBooking/confirm-booking.html","<div id=\"manage-kit\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.saveUpdatedTicket()\" ng-disabled=\"!vm.confirmBookingService.isClonedTicketUpdated\" ng-hide=\"!vm.isCloning\"><span translate=\"CONFIRMBOOKING.SAVE_UPDATED_TICKET_BUTTON\">Save</span><md-tooltip><span translate=\"CONFIRMBOOKING.SAVE_UPDATED_TICKET_BUTTONTOOLTIP\"></span></md-tooltip></md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.confirmTickets()\" ng-hide=\"vm.confirmBookingService.whereTo === \'submitAndEmail\'\" ng-disabled=\"vm.isCloning && vm.confirmBookingService.isClonedTicketUpdated\"><span translate=\"CONFIRMBOOKING.CONFIRMBUTTON\"></span><md-tooltip><span translate=\"CONFIRMBOOKING.CONFIRMBUTTONTOOLTIP\"></span></md-tooltip></md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.confirmTickets(true)\" ng-disabled=\"vm.isCloning && vm.confirmBookingService.isClonedTicketUpdated\"><span translate=\"CONFIRMBOOKING.CONFIRM_AND_EMAIL_BUTTON\"></span><md-tooltip><span translate=\"CONFIRMBOOKING.CONFIRM_AND_EMAIL_BUTTONTOOLTIP\"></span></md-tooltip></md-button></div></div><div class=\"content\" flex=\"\" ms-scroll=\"\"><form name=\"kitItemForm\" novalidate=\"\"><confirm-ticket-component ng-service=\"vm.confirmBookingService\" ng-job-service=\"vm.jobService\"></confirm-ticket-component></form></div></div></div>");
$templateCache.put("app/main/jobs/formsAndAttachments/forms-attachments.html","<div class=\"forms-attachments-page page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"toolbar md-whiteframe-2dp pt-10 pl-20 pr-20 pb-20\"><div class=\"toolbar-wrapper\"><div layout=\"row\" layout-align-start-center=\"\"><md-button translate=\"RESOURCEALLOCATION.BUTTON_VIEW_TICKET\" ng-click=\"vm.goToEditTicket()\" class=\"md-raised md-accent button-margin\"></md-button><md-button translate=\"RESOURCEALLOCATION.BUTTON_FORMS_AND_ATTACHMENTS\" class=\"md-raised md-accent button-margin\" disabled=\"true\"></md-button><md-button translate=\"RESOURCEALLOCATION.BUTTON_ALLOCATE_RESOURCE\" ng-click=\"vm.goToAllocateResourcePage()\" class=\"md-raised md-accent button-margin\" ng-disabled=\"!vm.canNavigateToAllocateResource\"></md-button><md-button translate=\"RESOURCEALLOCATION.BUTTON_TIMESHEETS\" class=\"md-raised md-accent button-margin\" ng-click=\"vm.goToTimesheet()\" ng-disabled=\"!vm.canNavigateToTimesheets\"></md-button></div></div><div class=\"toolbar-wrapper\"><div layout=\"row\" layout-align-start-center=\"\"><md-button translate=\"FORMSATTACHMENTS.BUTTON_DETAILS\" class=\"md-raised button-margin\" ng-click=\"vm.showTicketDetails()\"></md-button></div></div></div><div class=\"content\" layout=\"column\" ms-scroll=\"\"><div class=\"attachments-section md-whiteframe-2dp form-wrapper m-20\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" ng-if=\"vm.checkAccessService.isDocumentManagementEnabled()\"><document-manager flex=\"70\" layout=\"column\" ng-cloak=\"\" module-id=\"4\" module-name=\"Job\" related-resource-id=\"{{vm.ticketId}}\" excluded-documents=\"vm.excludedDocuments\" show-level=\"true\" disable-add=\"vm.isLocked || vm.isPendingApproval\" disable-edit=\"vm.isLocked || vm.isPendingApproval\" disable-delete=\"vm.isLocked || vm.isPendingApproval\" disable-unlink=\"vm.isTimesheetSubmitted || vm.isLocked || vm.isPendingApproval\" disable-checkbox=\"vm.isPendingApproval\" required-attachment-types=\"vm.service.requiredAttachmentTypes\"></document-manager><job-tags-component flex=\"\" layout=\"column\" ng-service=\"vm.service\" ticket-id=\"{{vm.ticketId}}\"></job-tags-component></div><div class=\"forms-section md-whiteframe-2dp form-wrapper m-20\" layout=\"column\" ng-if=\"vm.checkAccessService.isCustomFormsEnabled()\"><form-templates-list flex=\"\" ng-cloak=\"\" linked-form-templates=\"vm.linkedFormTemplates\" unlinked-form-templates=\"vm.unlinkedFormTemplates\" actual-linked-form-templates=\"vm.ticketLinkedFormTemplates\" actual-unlinked-form-templates=\"vm.ticketUnlinkedFormTemplates\" overridden-form-templates=\"vm.overriddenFormTemplates\" actual-overridden-form-templates=\"vm.ticketOverriddenFormTemplates\" api=\"vm.formTemplatesListApi\" applied-to=\'[\"AllCompanies\",\"AllBranches\",\"AllAssets\"]\' disable-add=\"vm.isTimesheetSubmitted || vm.isLocked || vm.isPendingApproval\" disable-unlink=\"vm.isTimesheetSubmitted || vm.isLocked || vm.isPendingApproval\" disable-checkbox=\"vm.isPendingApproval\" vehicles=\"vm.vehicles\" assets=\"vm.assets\"></form-templates-list></div><div class=\"form-submission-section md-whiteframe-2dp form-wrapper m-20\" layout=\"column\" ng-if=\"vm.hasCreatedForms()\"><job-forms-list flex=\"\" ng-cloak=\"\" forms-ids=\"vm.createdFormIds\" enable-delete=\"!vm.isLocked && !vm.isPendingApproval\"></job-forms-list></div></div><div class=\"toolbar md-whiteframe-2dp pt-10 pl-20 pr-20 pb-20\"><md-button translate=\"FORMSATTACHMENTS.BUTTON_SAVE\" class=\"md-raised md-accent first-button-margin\" ng-click=\"vm.saveForms()\" ng-disabled=\"vm.isPendingApproval\"></md-button></div></div>");
$templateCache.put("app/main/jobs/manage/jobs-manage.html","<div id=\"create-job\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><job-custom-fields ng-show=\"vm.showFields2\" flex=\"\"></job-custom-fields><div class=\"toolbar md-whiteframe-2dp pt-10 pl-20 pr-20 pb-20\"><div class=\"md-accent md-raised button-margin item\" ng-if=\"vm.service.jobModel.RelatedTicketId && vm.service.jobModel.RelatedTicketNumber && !vm.service.costEstimateGroupId\"><span class=\"md-caption\">This ticket is related to ticket #{{vm.service.jobModel.RelatedTicketNumber}} (<a href=\"#\" ng-click=\"vm.unlinkTicket()\">Unlink this ticket?</a>)</span></div><div class=\"toolbar-wrapper header-filter layout-row flex\"><md-button ng-if=\"vm.service.isEditMode\" class=\"md-raised md-accent button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_VIEW_TICKET\" disabled=\"true\"></md-button><md-button ng-if=\"vm.service.isEditMode && (vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled)\" class=\"md-accent md-raised button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_FORMS_AND_ATTACHMENTS\" ng-click=\"vm.goToFormsAndAttachment()\" ng-disabled=\"vm.service.jobModel.IsCancelled\"></md-button><md-button ng-if=\"vm.service.isEditMode\" class=\"md-accent md-raised button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_ALLOCATE_RESOURCE\" ng-click=\"vm.goToAllocateResourcePage()\" ng-disabled=\"!vm.service.canNavigateToAllocateResource()\"></md-button><md-button ng-if=\"vm.service.isEditMode\" class=\"md-accent md-raised button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_TIMESHEETS\" ng-click=\"vm.goToTimesheetsPage()\" ng-disabled=\"!vm.service.canNavigateToTimesheets()\"></md-button></div><div class=\"toolbar-wrapper header-filter layout-row flex\"><md-button ng-if=\"vm.service.isEditMode\" class=\"md-raised button-margin\" ng-click=\"vm.showEmailDialog()\" ng-disabled=\"!vm.service.canShowEmailDialog()\">Email Job Details</md-button><md-button ng-if=\"vm.service.isEditMode\" ng-click=\"vm.showHistory()\" class=\"md-raised button-margin margin-right-2\">View History</md-button><md-button ng-if=\"vm.service.isEditMode\" ng-click=\"vm.viewComments()\" class=\"md-raised button-margin margin-right-2\">View Comments</md-button><md-button ng-if=\"vm.showAllocateResourceBySmartScheduling()\" ng-click=\"vm.generatePreSchedule()\" class=\"md-raised button-margin margin-right-2\">Allocate with Scheduling Copilot</md-button><md-button ng-if=\"vm.showChargeMinimumHoursButton()\" ng-click=\"vm.openChargeMinimumHoursDialog()\" class=\"md-raised button-margin margin-right-2\">Charge Minimum Hours</md-button></div></div><div ng-if=\"!vm.service.isSmartSchedulingFailed && vm.service.isTicketLockedByPreSchedule()\" layout=\"row\" class=\"form-wrapper md-whiteframe-2dp p-0 br-10\"><div layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent ml-10 mr-10\"></md-progress-circular></div><span layout=\"column\" layout-align=\"center center\" translate=\"MANAGE.AI_RESOURCE_ALLOCATION_MESSAGE\"></span><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn\" ng-click=\"vm.cancelScheduling()\">Cancel</md-button></div></div><div id=\"smartSchedulingFailedSection\" ng-if=\"vm.service.isSmartSchedulingFailed\" layout=\"row\" class=\"form-wrapper md-whiteframe-2dp p-0 br-10\"><div layout=\"column\" layout-align=\"center center\"><md-icon md-svg-icon=\"warning-circle\" class=\"red-400-fg\"></md-icon></div><span class=\"message\" layout=\"column\" layout-align=\"center center\" translate=\"MANAGE.AI_RESOURCE_ALLOCATION_FAILED_MESSAGE\"></span><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-cancel\" ng-click=\"vm.cancelScheduling()\">CANCEL</md-button><md-button class=\"md-retry\" ng-click=\"vm.retrySchedulingCopilot()\">RETRY</md-button></div></div><div ng-if=\"vm.service.isSmartSchedulingSuccess\" layout=\"row\" class=\"smart-scheduling-success form-wrapper md-whiteframe-2dp p-0 br-10\"><div layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-check s18\"></md-icon></div><span layout=\"column\" class=\"message\" layout-align=\"center center\" translate=\"MANAGE.AI_RESOURCE_ALLOCATION_MESSAGE_SUCCESS\"></span><md-button class=\"md-warn\" ng-click=\"vm.hideProgressBar()\">Dismiss</md-button></div><form id=\"create-job-form\" name=\"stepper\" ng-show=\"!vm.showFields2\" foreign-service=\"vm.service\" novalidate=\"\" ms-scroll=\"\" a8-dirty-form-confirmation=\"\"><div class=\"content\" flex=\"\" ng-if=\"vm.translationService.orderby != \'\'\"><ordered-by-component ng-service=\"vm.service\"></ordered-by-component><job-details-component ng-service=\"vm.service\" stepper-form=\"stepper\"></job-details-component><job-resource ng-service=\"vm.service\"></job-resource></div></form><div class=\"md-whiteframe-2dp pt-5 pl-20 pr-20 pb-20 layout-row\"><md-button type=\"button\" class=\"md-accent md-raised button-margin\" ng-click=\"vm.saveJob(stepper)\" ng-disabled=\"vm.disableSaveButton()\">Save</md-button><div class=\"alert-error m-20 error-message\" ng-if=\"vm.showSubmitError\">Please fill out the required fields.</div></div></div>");
$templateCache.put("app/main/jobs/relatedTicketBillingPreferences/related-ticket-billing.html","<div id=\"whiteboard-calendar\" class=\"page-layout simple main-style fullwidth doc-page related_ticket_billing\" layout=\"column\"><div class=\"a8-header\" style=\"position :relative;\"><div style=\"height: 70px;\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"\" class=\"text-common\" style=\"position:relative; top:-20px;\" layout=\"column\"></div><div style=\"cursor: pointer; position: relative; top:-5px;\" layout-align=\"space-between center\" flex=\"\" layout=\"row\"><div flex=\"auto\" layout-align=\"start center\"><i class=\"icon-chevron-left\" ng-click=\"vm.service.adjustMonth(2)\"></i></div><div class=\"md-title\" layout=\"row\" layout-align=\"center center\" flex=\"auto\">{{vm.service.current_month}}</div><div flex=\"auto\" layout=\"row\" layout-align=\"end center\"><i class=\"icon-chevron-right\" ng-click=\"vm.service.adjustMonth(1)\"></i></div></div><div style=\"cursor: pointer; position: relative; top:-15px;\" layout=\"row\" layout-align=\"end center\" layout-padding=\"\" layout-margin=\"\" flex=\"\"><i class=\"icon-calendar-clock\" ng-click=\"vm.service.showMultipleDialog()\"></i></div></div></div><div class=\"content-card layout-column flex\" layout=\"column\" flex=\"\"><div class=\"content md-default-theme\" style=\"background: #E5E7E8\" flex=\"\" ms-scroll=\"\"><div flex=\"\" layout=\"column\" id=\"jobBoardComponent\"><div flex=\"\" layout=\"column\"><week-component-directive showdialog=\"vm.service.showDialog\" datalist=\"vm.service.weeks\" flex=\"\"></week-component-directive></div></div></div></div></div>");
$templateCache.put("app/main/jobs/resourceSidenav/resourceSidenav.html","<md-sidenav class=\"md-sidenav-right\" layout=\"column\" id=\"resourceSidenav\" ms-scroll=\"\" md-component-id=\"resource-sidenav\" md-whiteframe=\"4\"><resource-sidenav-toolbar></resource-sidenav-toolbar><resource-sidenav-options></resource-sidenav-options><div ng-hide=\"vm.service.isLoading\" class=\"margin-top-15\"><resource-divisions ng-if=\"vm.service.divisions.length > 0\" class=\"divisions\"></resource-divisions><resource-search class=\"search\"></resource-search></div><resource-list class=\"scrollable\" ms-scroll=\"\" list=\"vm.service.resources\"></resource-list></md-sidenav>");
$templateCache.put("app/main/jobs/ticketBilling/ticket-billing.html","<div id=\"invoice-report\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/jobs/ticketBilling/sidenav/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><ticket-billing-main-component class=\"content-card\" ng-class=\"classic\" layout=\"column\" flex=\"\"></ticket-billing-main-component></div></div>");
$templateCache.put("app/main/jobs/timeSheet/job-timesheet.html","<div id=\"job-timesheet\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\" flex=\"\"><div class=\"toolbar md-whiteframe-2dp pt-10 pl-20 pr-20 pb-20\"><div class=\"toolbar-wrapper\"><md-button ng-click=\"vm.edit()\" class=\"md-raised md-accent button-margin\" translate=\"RESOURCEALLOCATION.BUTTON_VIEW_TICKET\"></md-button><md-button translate=\"RESOURCEALLOCATION.BUTTON_FORMS_AND_ATTACHMENTS\" ng-click=\"vm.goToFormsAndAttachment()\" ng-if=\"vm.isDocumentManagementEnabled || vm.isCustomFormsEnabled\" class=\"md-raised md-accent button-margin\"></md-button><md-button translate=\"RESOURCEALLOCATION.BUTTON_ALLOCATE_RESOURCE\" ng-click=\"vm.goToAllocateResource()\" class=\"md-raised md-accent button-margin\"></md-button><md-button translate=\"RESOURCEALLOCATION.BUTTON_TIMESHEETS\" class=\"md-raised md-accent button-margin\" disabled=\"true\"></md-button></div><div class=\"toolbar-wrapper\"><md-button translate=\"TIMESHEET.TIMESHEET_DETAILS\" ng-disabled=\"awardForm.$invalid || !vm.service.timeSheet\" class=\"md-raised button-margin\" ng-click=\"vm.showTicketDetails()\"></md-button><md-button translate=\"TIMESHEET.TIMESHEET_VIEW_HISTORY\" ng-disabled=\"!vm.service.timeSheet\" class=\"md-raised button-margin\" ng-click=\"vm.service.viewHistory()\"></md-button><md-button translate=\"TIMESHEET.TIMESHEET_DOWNLOAD\" ng-click=\"vm.downloadTimesheetPdf()\" ng-disabled=\"!vm.service.hasGeneratedPaperworkPdf\" class=\"md-raised button-margin\"></md-button><md-button translate=\"{{ !vm.service.isLocked ? \'TIMESHEET.TIMESHEET_LOCK\': \'TIMESHEET.TIMESHEET_UNLOCK\' }}\" class=\"md-raised button-margin\" ng-disabled=\"!vm.service.timeSheet || vm.service.isTicketLocked\" ng-if=\"vm.canUnlockTimesheet\" ng-click=\"vm.service.lockUnlockTimesheet()\"></md-button></div></div><div class=\"content scroll\" layout=\"column\" flex=\"\" ms-scroll=\"\" style=\"position: relative;\"><div class=\"form-wrapper md-whiteframe-1dp\" layout=\"row\"><div class=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget ng-isolate-scope layout-column flex-gt-xs-50 flex-gt-md-25 flex-100\"><ms-widget-front class=\"p-16 blue-400-bg white-fg ms-widget-front ng-scope\"><div class=\"pb-24 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"layout-align-start-center layout-row\"><md-icon class=\"m-0 mr-8 md-default-theme md-font material-icons icon-numeric-0-box\" md-font-icon=\"icon-numeric-0-box\" aria-hidden=\"true\"></md-icon><div class=\"h3 ng-binding\" translate=\"TIMESHEET.TIMESHEET_TICKET_DETAILS\"></div></div></div><div class=\"pb-24 ng-scope layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div class=\"h2 secondary-text pl-8 ng-binding\" layout=\"column\"><span>#{{ vm.service.timeSheet.TicketNumber }}</span> <span layout=\"row\"><span>{{ vm.service.timeSheet.JobStartDate | date: \'EEE, d MMM yyyy\' }}</span> <span>&nbsp; - {{ vm.convertTime(vm.service.timeSheet.JobStartDate) }}</span></span></div></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget ng-isolate-scope layout-column flex-gt-xs-50 flex-gt-md-25 flex-100\"><ms-widget-front class=\"p-16 teal-400-bg white-fg ms-widget-front ng-scope\"><div class=\"pb-24 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"layout-align-start-center layout-row\"><md-icon class=\"m-0 mr-8 md-default-theme md-font material-icons icon-shopping\" md-font-icon=\"icon-shopping\" aria-hidden=\"true\"></md-icon><div class=\"h3 ng-binding\" translate=\"TIMESHEET.TIMESHEET_COMPANY\"></div></div></div><div class=\"pb-24 ng-scope layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div class=\"h2 ng-binding\">{{ vm.service.timeSheet.CompanyName }}</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget ng-isolate-scope layout-column flex-gt-xs-50 flex-gt-md-25 flex-100\"><ms-widget-front class=\"p-16 indigo-400-bg white-fg ms-widget-front ng-scope\"><div class=\"pb-24 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"layout-align-start-center layout-row\"><md-icon class=\"m-0 mr-8 md-default-theme md-font material-icons icon-map-marker\" md-font-icon=\"icon-harddisk\" aria-hidden=\"true\"></md-icon><div class=\"h3 ng-binding\" translate=\"TIMESHEET.TIMESHEET_TICKET_ADDRESS\"></div></div></div><div class=\"pb-24 ng-scope layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div class=\"h2 ng-binding\">{{ vm.service.timeSheet.JobAddress }}</div></div></ms-widget-front></ms-widget><ms-widget ng-if=\"vm.service.isTicketLocked || vm.service.timeSheet === null\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget ng-isolate-scope layout-column flex-gt-xs-50 flex-gt-md-25 flex-100\"><ms-widget-front class=\"p-16 red-400-bg white-fg ms-widget-front ng-scope\"><div class=\"pb-24 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"layout-align-start-center layout-row\"><md-icon class=\"m-0 mr-8 md-default-theme md-font material-icons icon-book-variant\" md-font-icon=\"icon-harddisk\" aria-hidden=\"true\"></md-icon><div class=\"h3 ng-binding\" translate=\"TIMESHEET.TIMESHEET_TICKET_STATUS\"></div></div></div><div class=\"pb-24 ng-scope layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div class=\"h2 ng-binding\" layout=\"column\"><span ng-if=\"vm.service.isTicketLocked\" translate=\"TIMESHEET.TIMESHEET_THIS_TICKET_IS_LOCKED\"></span> <span ng-if=\"vm.service.timeSheet === null\" translate=\"TIMESHEET.TIMESHEET_THIS_TICKET_HAS_NO_ALLOCATED_RESOURCES\"></span></div></div></ms-widget-front></ms-widget></div></div><div class=\"form-wrapper md-whiteframe-1dp\" layout=\"row\"><table class=\"dataTable hover\" ms-responsive-table=\"\" ondragstart=\"return false;\" ondrop=\"return false;\"><thead><tr><th class=\"icon-column\"></th><th class=\"icon-column\"></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TIMESHEET.EMPLOYEE\"></span></div></th><th class=\"secondary-text\" ng-if=\"vm.claimsUtilService.isShopTimeEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.SHOP_START\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 0)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.timeOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(0, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(0, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.claimsUtilService.isLoadTimeEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.LOAD_START\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 15)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.timeOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(15, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(15, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"!vm.checkIfTicketTypeIsTravelOnly()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.TRAVEL_START\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 1)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.timeOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(1, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(1, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" ng-if=\"vm.checkIfTicketTypeIsTravelOnly()\" translate=\"TIMESHEET.TRAVEL_START\"></span> <span class=\"column-title\" ng-if=\"!vm.checkIfTicketTypeIsTravelOnly()\" translate=\"TIMESHEET.JOB_START\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 2)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.timeOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(2, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(2, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.BREAK_START\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 3)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.timeOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(3, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(3, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.BREAK_FINISH\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 4)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.timeOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(4, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(4, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" ng-if=\"vm.checkIfTicketTypeIsTravelOnly()\" translate=\"TIMESHEET.TRAVEL_FINISH\"></span> <span class=\"column-title\" ng-if=\"!vm.checkIfTicketTypeIsTravelOnly()\" translate=\"TIMESHEET.JOB_FINISH\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 5)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.timeOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(5, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(5, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"!vm.checkIfTicketTypeIsTravelOnly()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.TRAVEL_FINISH\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 6)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.timeOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(6, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(6, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.claimsUtilService.isLoadTimeEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.LOAD_END\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 16)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.hourOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(16, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(16, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.claimsUtilService.isShopTimeEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.SHOP_END\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 14)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.hourOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(14, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(14, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.service.claimsUtilService.isTravelKmsInTimesheetEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\">{{\'TIMESHEET.TRAVEL_TO\' | translate}} ({{ vm.measurementForDistance }})</span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 7)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.travelOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(7, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(7, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.service.claimsUtilService.isTravelKmsInTimesheetEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\">{{\'TIMESHEET.TRAVEL_DURING\' | translate}} ({{ vm.measurementForDistance }})</span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 8)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.travelOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(8, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(8, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.service.claimsUtilService.isTravelKmsInTimesheetEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\">{{\'TIMESHEET.TRAVEL_FROM\' | translate}} ({{ vm.measurementForDistance }})</span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 9)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.travelOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(9, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(9, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.service.claimsUtilService.isInclementWeatherInTimesheetEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.INCLEMENT_WEATHER_HOURS\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 11)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.hourOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(11, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(11, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.service.claimsUtilService.isSetupPackupInTimesheetEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.SETUP_TIME_HOURS\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 12)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.hourOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(12, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(12, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.service.claimsUtilService.isSetupPackupInTimesheetEnabled()\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.PACKUP_TIME_HOURS\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 13)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.hourOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(13, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(13, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th><th class=\"secondary-text\" ng-if=\"vm.chargeableTravelAllowed\"><div class=\"table-header\" layout=\"row\"><div><span class=\"column-title\" translate=\"TIMESHEET.CHARGEABLE_TRAVEL\"></span></div><div ng-if=\"!vm.service.isLocked\" class=\"header-icon\"><md-menu md-offset=\"0 -5\"><i class=\"icon icon-chevron-double-down s11 blue-500-fg\" ng-click=\"vm.service.openMenu($mdMenu, $event, 17)\"></i><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"option in vm.service.hourOptions\"><md-button ng-if=\"vm.service.currentOption == option.Value\" ng-click=\"vm.service.changeColumnOption(17, option.Value)\"><span md-menu-align-target=\"\" style=\"color: red;\">{{ option.Display }}</span></md-button><md-button ng-if=\"vm.service.currentOption != option.Value\" ng-click=\"vm.service.changeColumnOption(17, option.Value)\"><span md-menu-align-target=\"\">{{ option.Display }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></th></tr></thead><tbody><tr ng-repeat-start=\"itm in vm.service.timeSheet.TicketTimesheetsDetails\" ng-attr-id=\"{{ \'row-\' + $index }}\"><td class=\"icon-column\"><i ng-if=\"(itm.ErrorCount > 0 || itm.WarningCount > 0) && !itm.isCollapsed\" class=\"icon icon-chevron-right\" style=\"cursor: pointer;\" ng-click=\"vm.service.showValidationMessages(itm)\"><md-tooltip>{{ \'TIMESHEET.SHOW_VALIDATIONS\' | translate }}</md-tooltip></i> <i ng-if=\"(itm.ErrorCount > 0 || itm.WarningCount > 0) && itm.isCollapsed\" class=\"icon icon-chevron-down\" style=\"cursor: pointer;\" ng-click=\"itm.isCollapsed = false\"><md-tooltip>{{ \'TIMESHEET.SHOW_VALIDATIONS\' | translate }}</md-tooltip></i></td><td class=\"icon-column\"><i class=\"icon icon-clipboard-account\" ng-click=\"vm.service.showRoleDialog(itm)\" style=\"color: steelblue; cursor: pointer;\"><md-tooltip>{{ vm.service.changeRoleCaption }}</md-tooltip></i></td><td ng-click=\"vm.service.showValidationMessages(itm)\" style=\"cursor: pointer;\">{{ itm.AllocatedItemName }}</td><td ng-if=\"vm.claimsUtilService.isShopTimeEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'ShopStartTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.SHOP_START\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.ShopStartTime)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 1, \'ShopStartTime\', $index, itm.ShopStartTime)\" ng-model=\"itm.ShopStartTime\" time-picker=\"\"></md-input-container></td><td ng-if=\"vm.claimsUtilService.isLoadTimeEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'LoadStartTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.LOAD_START\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.LoadStartTime)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 1, \'LoadStartTime\', $index, itm.LoadStartTime)\" ng-model=\"itm.LoadStartTime\" time-picker=\"\"></md-input-container></td><td ng-if=\"!vm.checkIfTicketTypeIsTravelOnly()\"><md-input-container><input ng-attr-id=\"{{ \'TravelStartTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.TRAVEL_START\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.TravelStartTime)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 1, \'TravelStartTime\', $index, itm.TravelStartTime)\" ng-model=\"itm.TravelStartTime\" time-picker=\"\"></md-input-container></td><td><md-input-container><input ng-attr-id=\"{{ \'JobStartTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.JOB_START\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.JobStartTime)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 2, \'JobStartTime\', $index, itm.JobStartTime)\" ng-model=\"itm.JobStartTime\" ng-class=\"{\'has-error\': !vm.service.isFieldValid(itm, \'JobStartTime\')}\" time-picker=\"\"></md-input-container></td><td><md-input-container><input ng-attr-id=\"{{ \'BreakStartTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.BREAK_START\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.BreakStartTime)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 3, \'BreakStartTime\', $index, itm.BreakStartTime)\" ng-model=\"itm.BreakStartTime\" ng-class=\"{\'has-error\': !vm.service.isFieldValid(itm, \'BreakStartTime\')}\" time-picker=\"\"></md-input-container></td><td><md-input-container><input ng-attr-id=\"{{ \'BreakEndTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.BREAK_FINISH\' | translate }}\" ng-change=\"vm.service.onTextChange($index)\" ng-focus=\"vm.service.onFocus(itm.BreakEndTime)\" ng-blur=\"vm.service.validateLine(itm, 4, \'BreakEndTime\', $index, itm.BreakEndTime)\" ng-model=\"itm.BreakEndTime\" ng-class=\"{\'has-error\': !vm.service.isFieldValid(itm, \'BreakEndTime\')}\" time-picker=\"\"></md-input-container></td><td><md-input-container><input ng-attr-id=\"{{ \'JobEndTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.JOB_FINISH\' | translate }}\" ng-change=\"vm.service.onTextChange($index)\" ng-focus=\"vm.service.onFocus(itm.JobEndTime)\" ng-blur=\"vm.service.validateLine(itm, 5, \'JobEndTime\', $index, itm.JobEndTime)\" ng-model=\"itm.JobEndTime\" ng-class=\"{\'has-error\': !vm.service.isFieldValid(itm, \'JobEndTime\')}\" time-picker=\"\"></md-input-container></td><td ng-if=\"!vm.checkIfTicketTypeIsTravelOnly()\"><md-input-container><input ng-attr-id=\"{{ \'TravelEndTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.TRAVEL_FINISH\' | translate }}\" ng-change=\"vm.service.onTextChange($index)\" ng-focus=\"vm.service.onFocus(itm.TravelEndTime)\" ng-blur=\"vm.service.validateLine(itm, 6, \'TravelEndTime\', $index, itm.TravelEndTime)\" ng-model=\"itm.TravelEndTime\" time-picker=\"\"></md-input-container></td><td ng-if=\"vm.claimsUtilService.isLoadTimeEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'LoadEndTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.LOAD_END\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.LoadEndTime)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 1, \'LoadEndTime\', $index, itm.LoadEndTime)\" ng-model=\"itm.LoadEndTime\" time-picker=\"\"></md-input-container></td><td ng-if=\"vm.claimsUtilService.isShopTimeEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'ShopEndTime-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.SHOP_END\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.ShopEndTime)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 1, \'ShopEndTime\', $index, itm.ShopEndTime)\" ng-model=\"itm.ShopEndTime\" time-picker=\"\"></md-input-container></td><td ng-if=\"vm.service.claimsUtilService.isTravelKmsInTimesheetEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'TravelToDistance-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.TRAVEL_TO\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.TravelToDistance)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 7, \'TravelToDistance\', $index, itm.TravelToDistance)\" ng-model=\"itm.TravelToDistance\"></md-input-container></td><td ng-if=\"vm.service.claimsUtilService.isTravelKmsInTimesheetEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'TravelDuringDistance-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.TRAVEL_DURING\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.TravelDuringDistance)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 8, \'TravelDuringDistance\', $index, itm.TravelDuringDistance)\" ng-model=\"itm.TravelDuringDistance\"></md-input-container></td><td ng-if=\"vm.service.claimsUtilService.isTravelKmsInTimesheetEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'TravelFromDistance-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.TRAVEL_FROM\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.TravelFromDistance)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 9, \'TravelFromDistance\', $index, itm.TravelFromDistance)\" ng-model=\"itm.TravelFromDistance\"></md-input-container></td><td ng-if=\"vm.service.claimsUtilService.isInclementWeatherInTimesheetEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'InclementWeatherHours-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.INCLEMENT_WEATHER_HOURS\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.InclementWeatherHours)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 11, \'InclementWeatherHours\', $index, itm.InclementWeatherHours)\" ng-model=\"itm.InclementWeatherHours\"></md-input-container></td><td ng-if=\"vm.service.claimsUtilService.isSetupPackupInTimesheetEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'SetupTimeHours-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.SETUP_TIME_HOURS\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.SetupTimeHours)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 11, \'SetupTimeHours\', $index, itm.SetupTimeHours)\" ng-model=\"itm.SetupTimeHours\"></md-input-container></td><td ng-if=\"vm.service.claimsUtilService.isSetupPackupInTimesheetEnabled()\"><md-input-container><input ng-attr-id=\"{{ \'PackupTimeHours-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.PACKUP_TIME_HOURS\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.PackupTimeHours)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 11, \'PackupTimeHours\', $index, itm.PackupTimeHours)\" ng-model=\"itm.PackupTimeHours\"></md-input-container></td><td ng-if=\"vm.chargeableTravelAllowed\"><md-input-container><input ng-attr-id=\"{{ \'ChargeableTravel-\' + $index }}\" type=\"text\" ng-disabled=\"vm.service.isLocked\" aria-label=\"{{ \'TIMESHEET.CHARGEABLE_TRAVEL\' | translate }}\" ng-focus=\"vm.service.onFocus(itm.ChargeableTravel)\" ng-change=\"vm.service.onTextChange($index)\" ng-blur=\"vm.service.validateLine(itm, 11, \'OverrideTravelHrs\', $index, itm.ChargeableTravel)\" ng-model=\"itm.ChargeableTravel\"></md-input-container></td></tr><tr class=\"validation-section\" ng-repeat=\"message in itm.validationMessages\" ng-if=\"itm.isCollapsed\" ng-repeat-end=\"\"><td class=\"icon-column\"></td><td class=\"icon-column\"><i class=\"icon icon-alert\" style=\"color: #ff7316;\"></i></td><td colspan=\"6\" class=\"validation-message\">{{ message }}</td></tr></tbody></table></div><div class=\"form-wrapper md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" ng-show=\"vm.service.operatorComments != null\"><h1 flex=\"\" translate=\"TIMESHEET.NOTES\"></h1><div flex=\"80\" layout-padding=\"\"><div class=\"paperwork-comments\"><h3>{{ vm.service.operatorComments }}</h3></div></div></div><div class=\"form-wrapper md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" ng-show=\"vm.service.hideGPSLocation\"><h1 flex=\"\" class=\"gps-coordinates-title\" translate=\"TIMESHEET.SUBMITTED_AT_LOCATION\"></h1><div flex=\"28\" class=\"gps-coordinates-values\" layout-padding=\"\"><div class=\"timesheet-edit-gps-coordinate\" ng-show=\"vm.service.hasGPSLocation\">{{vm.service.jobLatitude}}, {{vm.service.jobLongitude}}</div><div class=\"timesheet-edit-gps-coordinate\" ng-show=\"!vm.service.hasGPSLocation\">{{\'TIMESHEET.GPS_COORDINATE_NOT_FOUND\' | translate}}</div></div><md-button translate=\"TIMESHEET.SHOW_GOOGLE_MAP_BUTTON\" ng-show=\"vm.service.hasGPSLocation\" class=\"show-google-map-button md-raised md-accent\" ng-click=\"vm.applyPinAddress()\"></md-button></div><div class=\"form-wrapper md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" ng-show=\"(vm.service.timesheetEdits||[]).length > 0\"><h1 flex=\"\" translate=\"TIMESHEET.TIMESHEET_EDITS\"></h1><div flex=\"80\" layout-padding=\"\"><div ng-repeat=\"timesheetEdit in vm.service.timesheetEdits\"><div class=\"timesheet-edit-date\">{{ timesheetEdit.EditDate }}</div><div class=\"timesheet-edit-reason\">{{ timesheetEdit.EditReason }}</div></div></div></div><div class=\"form-wrapper md-whiteframe-1dp\" layout=\"column\" layout-padding=\"\" ng-show=\"vm.service.hasSignatures && vm.service.isMobileAppEnabled\"><h1 flex=\"\" translate=\"TIMESHEET.SIGNATURES\"></h1><div layout=\"row\"><div flex=\"40\" layout-padding=\"\"><h3 class=\"mb-0 pb-0\" translate=\"TIMESHEET.OPERATOR_SIGNOFF\"></h3><img md-whiteframe=\"1\" style=\"width: 400px; height: 200px;border-radius: 5px;\" ng-style=\"{\'margin-top\' : vm.showClientConfirmation() ? \'34px\' : \'0\'}\" ng-src=\"{{ vm.service.operatorSignatureImageUrl }}\"><div style=\"padding: 15px 0\"><strong translate=\"TIMESHEET.OPERATOR_NAME\"></strong> {{ vm.service.operatorName }}</div></div><div flex=\"40\" layout-padding=\"\"><h3 class=\"mb-0 pb-0\" translate=\"TIMESHEET.CLIENT_SIGNOFF\"></h3><div flex=\"100\" ng-if=\"vm.showClientConfirmation()\">I have read the shift notes and confirm any timesheet exceptions:</div><img ng-show=\"!vm.service.isClientOnSite && !vm.enableContactlessSignature\" md-whiteframe=\"1\" style=\"width: 400px; height: 200px;border-radius: 5px;\" src=\"assets/images/timesheet/client_not_on_site.jpg\"><div ng-if=\"vm.service.isPendingClientSignature && vm.enableContactlessSignature\" md-whiteframe=\"1\" style=\"width: 400px; height: 200px; border-radius: 5px; display: flex; align-items: center; justify-content: center; text-align: center;\">A request to obtain contactless signature has been sent. This will be updated once {{vm.service.clientName}} has submitted their signature.</div><img ng-show=\"(!vm.service.isPendingClientSignature && (vm.enableContactlessSignature || vm.service.clientSignatureImageUrl))\" md-whiteframe=\"1\" style=\"width: 400px; height: 200px;border-radius: 5px;\" ng-src=\"{{ vm.service.clientSignatureImageUrl }}\"><div style=\"padding: 15px 0\"><strong translate=\"TIMESHEET.CLIENT_NAME\"></strong> {{ vm.service.clientName }}</div></div></div></div></div><div class=\"toolbar md-whiteframe-2dp pt-10 pl-20 pr-20 pb-20\"><md-button translate=\"TIMESHEET.TIMESHEET_SAVE\" class=\"md-raised md-accent first-button-margin\" ng-disabled=\"vm.service.isSaveButtonDisabled()\" ng-click=\"vm.service.saveTimesheet($event)\"></md-button></div></div>");
$templateCache.put("app/main/jobs/view/jobs-filter.html","<div layout=\"column\" class=\"main-style jobs-filter-container\"><div class=\"toolbar-header layout-padding\"><div flex=\"\" layout=\"row\" layout-align=\"flex-start center\"><span flex=\"\"></span><div layout=\"row\"><div><md-button ng-if=\"!vm.viewFilters\" class=\"button-margin\" ng-click=\"vm.toggleViewFilters()\" flex=\"\" layout=\"row\"><span>Show Filter</span> <i class=\"icon-chevron-down ng-scope\"></i></md-button><md-button ng-if=\"vm.viewFilters\" class=\"button-margin\" ng-click=\"vm.toggleViewFilters()\" flex=\"\" layout=\"row\"><span>Hide Filter</span> <i class=\"icon-chevron-up ng-scope\"></i></md-button></div></div></div><div ng-if=\"vm.viewFilters\" layout=\"row\" flex=\"\"><div flex=\"30\" class=\"pr-20\"><div layout=\"column\" flex=\"auto\"><div flex=\"\" layout-align=\"center center\"><md-radio-group ng-model=\"vm.service.data.filterType\" layout=\"row\" layout-sm=\"column\" required=\"\"><md-radio-button value=\"1\" class=\"p-5\">Start Date</md-radio-button><md-radio-button value=\"2\" class=\"p-5\">Last Updated Date</md-radio-button><md-radio-button value=\"3\" class=\"p-5\">Created Date</md-radio-button></md-radio-group></div><div flex=\"\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" class=\"pt-10\"><md-input-container class=\"mb-0\"><label>Start Date</label><md-datepicker ng-model=\"vm.service.data.startDate\"></md-datepicker></md-input-container><span flex=\"5\"></span><md-input-container class=\"mb-0\"><label>End Date</label><md-datepicker ng-model=\"vm.service.data.endDate\"></md-datepicker></md-input-container></div><div class=\"warning-message\"><strong>Tip:</strong> To filter by date range, you can enter a start date or an end date by itself, or enter both the dates. If one of the dates is missing, the filter will default to a two week period.</div></div></div><div flex=\"\" layout=\"column\" class=\"pr-20\" layout-align=\"space-around start\"><div layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-align=\"space-around center\" layout-align-md=\"flex-start center\" layout-align-sm=\"flex-start center\"><md-checkbox ng-if=\"vm.claimsUtilService.isBillingEnabled()\" ng-model=\"vm.service.data.isQuotesOnly\" class=\"pr-20\">Quotes Only</md-checkbox><md-checkbox ng-model=\"vm.service.data.isIncludeRelated\" class=\"pr-20\">Include Related Tickets</md-checkbox><md-checkbox ng-model=\"vm.service.data.IsCancelled\" class=\"pr-20\">Show Cancelled Tickets</md-checkbox></div><div layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-align=\"space-around center\" layout-align-md=\"flex-start center\" layout-align-sm=\"flex-start center\"><md-input-container flex=\"\"><input type=\"text\" placeholder=\"Ticket #\" ng-model=\"vm.service.data.ticketNo\"></md-input-container><md-input-container flex=\"\"><md-select ng-model=\"vm.service.data.jobType\" ng-model-options=\"{trackBy : \'$value.Id\'}\" placeholder=\"Ticket Type\"><md-option ng-repeat=\"type in vm.service.ticketTypes\" ng-value=\"type\">{{type.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><md-select multiple=\"\" ng-model=\"vm.service.data.ticketStatus\" placeholder=\"Ticket Status\"><md-option ng-value=\"type.Id\" ng-repeat=\"type in vm.ticketStatus\">{{ type.Text }}</md-option></md-select></md-input-container><md-input-container flex=\"\"><md-select ng-model=\"vm.service.data.branches\" ng-model-options=\"{trackBy : \'$value.Id\'}\" placeholder=\"Branch(es)\" multiple=\"\"><md-optgroup label=\"States\"><md-option ng-repeat=\"branch in vm.service.branchesLookUps| filter: {State: null}\" ng-value=\"branch\">{{branch.Name}}</md-option></md-optgroup><md-optgroup label=\"Branch(es)\"><md-option ng-repeat=\"branch in vm.service.branchesLookUps| filter: {State: \'!!\'}\" ng-value=\"branch\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-md=\"column\" layout-sm=\"column\"><tag-filter label=\"Include Tags\" selectable-tags=\"vm.service.tags\" selected-tags=\"vm.service.includedTags\" filter-tag-ids=\"vm.service.data.tagIds\"></tag-filter><tag-filter label=\"Exclude Tags\" selectable-tags=\"vm.service.tags\" selected-tags=\"vm.service.excludedTags\" filter-tag-ids=\"vm.service.data.excludedTagIds\"></tag-filter></div></div><div flex=\"10\" flex-sm=\"15\" layout=\"column\"><md-button class=\"md-raised md-accent first-button-margin toolbar-button\" ng-click=\"vm.service.filterTickets()\" ng-disabled=\"vm.service.grid.behavior.busy\">Filter</md-button><md-button class=\"md-raised button-margin toolbar-button\" ng-click=\"vm.service.resetFilter()\" ng-disabled=\"vm.service.grid.behavior.busy\" id=\"step4\">Clear</md-button></div></div></div></div>");
$templateCache.put("app/main/jobs/view/jobs-view.html","<div id=\"job-view\" class=\"page-layout simple right-sidenav\" layout=\"row\" ng-intro-options=\"vm.IntroOptions\" ng-intro-method=\"CallMe\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"md-whiteframe-2dp mb-10\" ng-include=\"\'app/main/jobs/view/jobs-filter.html\'\"></div><div class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"white-bg md-whiteframe-4dp\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"vm.delay\" source=\"vm.service.grid.searchTerm\" layout-margin=\"\" flex=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.service.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple hire-rate-table a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><a8-sort-column sort-by=\"TicketNumber\" field-label=\"Ticket #\"></a8-sort-column></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ticket Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"BranchName\" field-label=\"Branch\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Division</span></div></th><th class=\"secondary-text company-name\"><div class=\"table-header\"><span class=\"column-title\">Company</span></div></th><th class=\"secondary-text tags\"><div class=\"table-header\"><span class=\"column-title\">Tags</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Site Contact</span></div></th><th class=\"secondary-text\"><a8-sort-column sort-by=\"StartDate\" field-label=\"Start Date And Time\"></a8-sort-column></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Confirmed</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tfoot><tr><td colspan=\"3\"></td></tr></tfoot><tbody><tr ng-repeat=\"ticket in vm.getTicketGridData() track by $index\" ng-dblclick=\"vm.showTicketInfo(ticket.Id)\"><td><a href=\"#\" class=\"clickable\" ng-click=\"vm.showTicketInfo(ticket.Id)\">{{ticket.TicketNumber}}</a></td><td>{{ticket.TicketType}}</td><td>{{ticket.BranchName}}</td><td>{{ticket.DivisionName}}</td><td>{{ticket.CompanyName}}</td><td>{{ticket.TagsForView}}</td><td>{{ticket.SiteContactFullName}}</td><td>{{ticket.StartDateForView}}</td><td>{{ticket.ConfirmedForView}}</td><td><div class=\"custom-tooltip\"><md-button ng-if=\"(ticket.IsLocked === false && vm.isTicketLockedByPreSchedule(ticket) == false) && ticket.IsCancelled === false\" class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.edit(ticket)\"><i class=\"icon icon-pencil teal-500-fg s15\"><md-tooltip>Edit Ticket</md-tooltip></i></md-button><md-button ng-if=\"ticket.IsLocked === true || vm.isTicketLockedByPreSchedule(ticket) === true || ticket.IsCancelled === true\" class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.edit(ticket)\"><i class=\"icon icon-view-list teal-500-fg s15\"><md-tooltip>View Ticket</md-tooltip></i></md-button></div><div class=\"custom-tooltip\" ng-if=\"vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled\"><md-button ng-disabled=\"ticket.IsCancelled\" class=\"md-icon-button md-primary action-button\" aria-label=\"Allocate Resource\" ng-click=\"vm.service.goToFormsAndAttachment(ticket.Id, ticket.TicketNumber)\"><i class=\"icon icon-library-books blue-500-fg s15\" ng-class=\"{\'grey-500-fg not-clickable-item\' : ticket.IsCancelled}\"><md-tooltip>Forms & Attachments</md-tooltip></i></md-button></div><div class=\"custom-tooltip\"><md-button ng-if=\"ticket.IsLocked === false && ticket.IsCancelled === false && ticket.TicketType !== \'Plan Only\'\" class=\"md-icon-button md-primary action-button\" aria-label=\"Allocate Resource\" ng-disabled=\"ticket.IsUnconfirmedDate || ticket.IsLocked\" ng-click=\"vm.service.allocateResource(ticket.Id, ticket.TicketNumber)\"><i class=\"icon icon-account-multiple-plus blue-500-fg s15\"><md-tooltip>Allocate Resource</md-tooltip></i></md-button><div ng-if=\"ticket.IsLocked === true || ticket.IsCancelled === true || ticket.TicketType === \'Plan Only\'\" class=\"view-job-icon\"><i class=\"icon icon-account-multiple-plus grey-500-fg s15 not-clickable-item\"></i></div></div><div class=\"custom-tooltip\"><md-button ng-if=\"ticket.IsCancelled === false && ticket.TicketType !== \'Plan Only\' && ticket.TicketType !== \'Equipment Only\' && !vm.isPendingApproval(ticket)\" class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-disabled=\"ticket.IsUnconfirmedDate || vm.isTicketLockedByPreSchedule(ticket)\" ng-click=\"vm.service.fillTimeSheet(ticket)\"><i class=\"icon icon-calendar-clock blue-grey-500-fg s15\"><md-tooltip>Edit Timesheet</md-tooltip></i></md-button><div ng-if=\"ticket.TicketType === \'Plan Only\' || ticket.TicketType === \'Equipment Only\' || vm.isPendingApproval(ticket)\" class=\"view-job-icon\"><i class=\"icon icon-calendar-clock grey-500-fg s15 not-clickable-item\"></i></div><div ng-if=\"ticket.IsLocked && vm.isTicketLockedByPreSchedule(ticket) && ticket.TicketType != \'Plan Only\' && ticket.TicketType != \'Equipment Only\' && ticket.TicketType != \'Internal\'\" class=\"view-job-icon\"><i class=\"icon icon-calendar-clock blue-grey-500-fg s15\" style=\"cursor : pointer\" ng-click=\"vm.service.fillTimeSheet(ticket)\"><md-tooltip>View Timesheet</md-tooltip></i></div></div><div class=\"custom-tooltip\" ng-if=\"vm.jobsClaims.hasCloneJobsPermission\"><md-button class=\"md-icon-button md-primary action-button\" ng-disabled=\"vm.isTicketLockedByPreSchedule(ticket)\" ng-if=\"!vm.isPendingApproval(ticket)\" aria-label=\"Settings\" ng-click=\"vm.clone(ticket)\"><i class=\"icon icon-content-copy teal-500-fg s15\"><md-tooltip>Clone Ticket</md-tooltip></i></md-button><div ng-if=\"vm.isPendingApproval(ticket)\" class=\"view-job-icon\"><i class=\"icon icon-content-copy teal-500-fg s15 not-clickable-item\"></i></div></div><div class=\"custom-tooltip\"><md-button ng-if=\"ticket.IsLocked === false && vm.isTicketLockedByPreSchedule(ticket) === false && ticket.IsCancelled === false\" class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.cancelTicket(ticket,$index, $event)\"><i class=\"icon icon-delete red-500-fg s15\"><md-tooltip>Cancel Ticket</md-tooltip></i></md-button><md-button ng-if=\"ticket.IsLocked === true || vm.isTicketLockedByPreSchedule(ticket) == true || ticket.IsCancelled === true\" class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-disabled=\"ticket.IsLocked || vm.isTicketLockedByPreSchedule(ticket)\"><i class=\"icon icon-delete grey-500-fg s15 not-clickable-item\"><md-tooltip>Cancel Ticket</md-tooltip></i></md-button><md-button class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.viewHistory(ticket.TicketNumber, ticket.Id)\"><i class=\"icon icon-history orange-500-fg s15\"><md-tooltip>View History</md-tooltip></i></md-button><md-menu md-offset=\"0 -5\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"grey-500-fg\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in vm.getMenuItems(ticket.TicketType, ticket.HasGeneratedPaperworkPdf)\" ng-hide=\"item.hidden()\"><md-button ng-click=\"vm.menuItemClick($index, ticket.Id, ticket.StartDate, ticket.TicketNumber)\" ng-disabled=\"vm.isButtonDisabled(item, ticket)\"><md-icon md-font-icon=\"{{item.icon}}\"></md-icon>{{item.name}}</md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"vm.service.grid.behavior\" on-init=\"vm.service.grid.onInit()\" on-error=\"vm.service.grid.onError(ex)\" on-completed=\"vm.service.grid.onCompleted(data)\" on-data-filter=\"vm.service.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div><div style=\"padding-bottom: 24px;\"></div></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"content\" flex=\"\"><md-tabs md-dynamic-height=\"\"><md-tab><md-tab-label><span translate=\"PROFILE.MY_DETAILS\">My Details</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" ng-include=\"\'app/main/pages/profile/tabs/my-details/my-details.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"PROFILE.MY_SETTINGS\">My Settings</span></md-tab-label><md-tab-body><md-content class=\"photos-videos-tab\" ng-include=\"\'app/main/pages/profile/tabs/my-settings/my-settings.html\'\"></md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/paperwork/manage-paperwork/manage-paperwork-sidenav.html","<md-content ms-scroll=\"\" class=\"content margin-left-15\" flex=\"\"><form name=\"regenerate-paperwork-filters\"><div class=\"navigation-simple\" layout=\"column\" flex=\"\"><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" ng-model=\"vm.filters.filteredTicketNumber\" ng-disabled=\"vm.isTicketNoFieldDisabled()\" name=\"{{ \'PAPERWORK.MANAGE_PAPERWORK.TICKETNUMBER\' | translate }}\" placeholder=\"{{ \'PAPERWORK.MANAGE_PAPERWORK.TICKETNUMBER\' | translate }}\"></md-input-container></div><div class=\"padding-top-10 padding-bottom-10 bold-text\" layout=\"row\" layout-align=\"center center\" style=\"font-size: 1.6rem\"><div>OR</div></div><div layout=\"row\"><md-input-container flex=\"\"><md-select name=\"branches\" ng-model=\"vm.filters.selectedBranchIds\" ng-disabled=\"vm.areFilterFieldsExceptTicketNoDisabled()\" ng-required=\"vm.areFilterFieldsRequired()\" placeholder=\"{{ \'PAPERWORK.MANAGE_PAPERWORK.BRANCHES\' | translate }}\" multiple=\"\"><md-optgroup label=\"Branch(es)\"><md-option ng-value=\"branch.Id\" ng-repeat=\"branch in vm.branches\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><md-select name=\"companies\" ng-model=\"vm.filters.selectedCompanyIds\" ng-disabled=\"vm.areFilterFieldsExceptTicketNoDisabled()\" placeholder=\"{{ \'PAPERWORK.MANAGE_PAPERWORK.CLIENTS\' | translate }}\" multiple=\"\"><md-option ng-value=\"company.Id\" ng-repeat=\"company in vm.companies\">{{company.Name + \' (\' + company.CompanyCode + \')\'}}</md-option></md-select></md-input-container></div><div class=\"regenerate-filter-dates\"><div layout=\"row\"><div><md-input-container flex=\"\"><label class=\"regenerate-filter-label-date\">{{ \'PAPERWORK.MANAGE_PAPERWORK.STARTDATE\' | translate }}</label><md-datepicker ng-model=\"vm.filters.startDate\" ng-disabled=\"vm.areFilterFieldsExceptTicketNoDisabled()\" ng-required=\"vm.areFilterFieldsRequired()\"></md-datepicker></md-input-container></div></div><div layout=\"row\"><div><md-input-container flex=\"\"><label class=\"regenerate-filter-label-date\">{{ \'PAPERWORK.MANAGE_PAPERWORK.ENDDATE\' | translate }}</label><md-datepicker ng-model=\"vm.filters.endDate\" ng-disabled=\"vm.areFilterFieldsExceptTicketNoDisabled()\" ng-required=\"vm.areFilterFieldsRequired()\"></md-datepicker></md-input-container></div></div></div><div layout=\"row\"><md-input-container flex=\"\"><md-select name=\"projects\" ng-model=\"vm.filters.selectedProjectIds\" ng-disabled=\"vm.areFilterFieldsExceptTicketNoDisabled()\" placeholder=\"{{ \'PAPERWORK.MANAGE_PAPERWORK.PROJECTS\' | translate }}\" multiple=\"\"><md-option ng-value=\"project.id\" ng-repeat=\"project in vm.projects\">{{project.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><md-select name=\"tags\" ng-model=\"vm.filters.selectedTagIds\" ng-disabled=\"vm.areFilterFieldsExceptTicketNoDisabled()\" placeholder=\"{{ \'PAPERWORK.MANAGE_PAPERWORK.TAGS\' | translate }}\" multiple=\"\"><md-option ng-value=\"tag.Id\" ng-repeat=\"tag in vm.tags\">{{tag.Name}}</md-option></md-select></md-input-container></div><div ng-if=\"vm.isBillingEnabled\" layout=\"row\"><md-input-container class=\"input-container-checkbox\" flex=\"\"><md-checkbox class=\"md-primary\" ng-model=\"vm.filters.includeInvoicedJobs\" ng-disabled=\"vm.areFilterFieldsExceptTicketNoDisabled()\">{{ \'PAPERWORK.MANAGE_PAPERWORK.INCLUDE_INVOICED_JOBS\' | translate}}</md-checkbox></md-input-container></div><div class=\"padding-bottom-15\"><md-button class=\"md-accent md-raised btn-show-result\" aria-label=\"Show Results\" ng-click=\"vm.showResults()\" ng-disabled=\"!vm.enableShowResultsButton()\">{{ \'PAPERWORK.MANAGE_PAPERWORK.SHOWRESULT\' | translate}}</md-button></div><div layout=\"row\"><md-button class=\"md-accent md-raised btn-clear\" aria-label=\"Clear\" ng-click=\"vm.clearFilters()\" ng-disabled=\"!vm.isClearFiltersButtonEnabled()\">{{ \'PAPERWORK.MANAGE_PAPERWORK.CLEAR\' | translate}}</md-button></div></div></form></md-content>");
$templateCache.put("app/main/paperwork/manage-paperwork/manage-paperwork.html","<div id=\"manage-paperwork\" class=\"page-layout carded left-sidenav\" layout=\"row\" ms-scroll=\"\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"manage-paperwork-sidenav\" ng-include=\"\'app/main/paperwork/manage-paperwork/manage-paperwork-sidenav.html\'\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"search-row\" layout=\"row\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\" flex=\"auto\"><sidenav-filter-small-screen id=\"manage-paperwork\" hide-gt-md=\"\" ng-click=\"vm.toggleSidenav(\'manage-paperwork-sidenav\')\"></sidenav-filter-small-screen><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input class=\"search-input\" type=\"text\" placeholder=\"{{ \'PAPERWORK.MANAGE_PAPERWORK.SEARCH\' | translate }}\" ng-model=\"vm.searchText\" ng-change=\"vm.searchTableResults()\" flex=\"\"></div></div></div><div class=\"main-content\" layout=\"row\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\" class=\"table-layout\"><div flex=\"\"><div class=\"content-header\" layout=\"column\"><md-input-container class=\"select-all-checkbox\" flex=\"\"><md-checkbox class=\"md-primary\" ng-show=\"vm.tableHasResults\" ng-model=\"isSelectAllChecked\" ng-checked=\"vm.areAllTicketsSelected()\" md-indeterminate=\"vm.isIndeterminate()\" ng-change=\"vm.toggleAllTicketSelections(isSelectAllChecked)\">{{ \'PAPERWORK.MANAGE_PAPERWORK.SELECTALL\' | translate}}</md-checkbox><md-button class=\"md-accent md-raised btn-download-selected\" ng-click=\"vm.downloadSelected()\" ng-disabled=\"vm.selectedTicketIds.length === 0\">{{ \'PAPERWORK.MANAGE_PAPERWORK.DOWNLOAD_SELECTED\' | translate}}</md-button><md-button class=\"md-accent md-raised btn-regenerate-paperwork\" ng-click=\"vm.regeneratePaperwork()\" ng-disabled=\"vm.selectedTicketIds.length === 0\">{{ \'PAPERWORK.MANAGE_PAPERWORK.REGENERATE_PAPERWORK\' | translate}}</md-button></md-input-container></div><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"vm.dtLoading\"></md-progress-linear><table class=\"dataTable row-border hover table-layout\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" dt-instance=\"vm.dtInstance\" ms-responsive-table=\"\" style=\"width: 100%\"><thead><tr><th ng-hide=\"true\"></th><th class=\"secondary-text\"><div class=\"table-header\" style=\"width:48px\"></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ticket #</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Branch</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Company</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Project</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Job Date</span></div></th><th class=\"secondary-text tags-column\"><div class=\"table-header\"><span class=\"column-title\">Tags</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Purchase<br>Order</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Invoiced?</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Paperwork<br>Last Created</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"ticket in vm.tickets track by $index\"><td ng-hide=\"true\">{{ticket.id}}</td><td><md-input-container flex=\"\"><md-checkbox class=\"md-primary td-checkbox\" ng-checked=\"vm.isTicketSelected(ticket.id)\" ng-model=\"isTicketChecked\" ng-change=\"vm.onTicketSelectionChange(ticket.id, isTicketChecked)\"></md-checkbox></md-input-container></td><td>{{ticket.TicketNumber}}</td><td>{{ticket.BranchName}}</td><td>{{ticket.CompanyName}}</td><td>{{ticket.ProjectName || \"-\"}}</td><td>{{ticket.StartDate | date: \"dd/MM/yyyy\"}}</td><td ng-bind=\"vm.displayFormattedTags(ticket.Tags)\"></td><td>{{ticket.PurchaseOrderNumber || \"-\"}}</td><td>{{ticket.IsLocked ? \"Yes\" : \"No\"}}</td><td><label ng-hide=\"ticket.showGenerateStatus || ticket.PaperworkPdfLastGeneratedDate\">-</label> <label ng-hide=\"ticket.showGenerateStatus || !ticket.PaperworkPdfLastGeneratedDate\"><span style=\"display:none\">{{ticket.PaperworkPdfLastGeneratedDate | date: \"yyyyMMddhhmmsssss\"}}</span> {{ticket.PaperworkPdfLastGeneratedDate | date: \"dd/MM/yyyy h:mm:ss a\"}}</label> <label class=\"label-paperwork-generate-status {{ticket.PaperworkPdfGenerateStatusClass}}\" ng-hide=\"!ticket.showGenerateStatus\">{{ticket.PaperworkPdfGenerateStatusDescription}}</label></td><td><div class=\"custom-tooltip\"><md-button class=\"md-icon-button md-primary action-button\" ng-click=\"vm.editTicket(ticket)\" ng-disabled=\"ticket.IsLocked\"><i class=\"icon icon-pencil s15\" ng-class=\"ticket.IsLocked ? \'icon-disabled\' : \'teal-500-fg\'\"><md-tooltip>Edit Ticket</md-tooltip></i></md-button></div><div class=\"custom-tooltip\"><md-button class=\"md-icon-button md-primary action-button\" ng-click=\"vm.editFormsAndAttachment(ticket)\"><i class=\"icon icon-library-books blue-500-fg s15\"><md-tooltip>Forms & Attachments</md-tooltip></i></md-button></div><div class=\"custom-tooltip\"><md-button class=\"md-icon-button md-primary action-button\" ng-click=\"vm.editTimesheet(ticket)\"><i class=\"icon icon-calendar-clock blue-grey-500-fg s15\"><md-tooltip>Edit Timesheet</md-tooltip></i></md-button></div><div class=\"custom-tooltip\"><md-button class=\"md-icon-button md-primary action-button\" ng-click=\"vm.downloadPaperworkPdf(ticket.FileUri)\" ng-disabled=\"!ticket.FileUri\"><i class=\"icon icon-file-document s15\" ng-class=\"ticket.FileUri ? \'blue-grey-500-fg\' : \'icon-disabled\'\"><md-tooltip>Download Paperwork</md-tooltip></i></md-button></div></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/main/payroll/allowances/allowances.dialog.html","<md-dialog id=\"allowances-dialog\" aria-label=\"Add Allowances\" flex=\"30\" ng-cloak=\"\"><form name=\"allowanceForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"{{\'ALLOWANCES.DIALOG.CLOSE\' | translate}}\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"ALLOWANCES.DIALOG.ALLOWANCE_NAME\"></label> <input type=\"text\" name=\"name\" ng-model=\"vm.name\" ng-maxlength=\"254\" required=\"\" ng-keyup=\"vm.onInputNameKeyUp()\"><div ng-messages=\"allowanceForm.name.$error\" role=\"alert\" multiple=\"\" class=\"field-note\"><div ng-message=\"valid\"><span translate=\"ALLOWANCES.DIALOG.ALLOWANCE_NAME_IN_USE\"></span></div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><label class=\"md-body-2\" translate=\"ALLOWANCES.DIALOG.ALLOWANCE_TYPE\"></label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-radio-group ng-model=\"vm.type\" layout=\"row\" layout-sm=\"column\" style=\"margin-top: 5px\"><md-radio-button value=\"1\" aria-checked=\"true\">{{\'ALLOWANCES.DIALOG.ALLOWANCE_TYPE_PER_HOUR\' | translate}}</md-radio-button><md-radio-button value=\"4\">{{\'ALLOWANCES.DIALOG.ALLOWANCE_TYPE_PER_SHIFT\' | translate}}</md-radio-button></md-radio-group><div role=\"note\" multiple=\"\" class=\"field-note\" ng-if=\"vm.type == 1\"><span translate=\"ALLOWANCES.DIALOG.ALLOWANCE_TYPE_PER_HOUR_FIELD_NOTE\"></span></div><div role=\"note\" multiple=\"\" class=\"field-note\" ng-if=\"vm.type == 4\"><span translate=\"ALLOWANCES.DIALOG.ALLOWANCE_TYPE_PER_SHIFT_FIELD_NOTE\"></span></div></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"ALLOWANCES.DIALOG.AMOUNT\"></label> <input type=\"text\" name=\"amount\" ng-model=\"vm.amount\" ng-maxlength=\"254\" required=\"\" a8-num-formatter=\"\" num-currency=\"$\" decimal-place=\"2\"><div ng-messages=\"allowanceForm.amount.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"max\"><span translate=\"\"></span></div></div></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"ALLOWANCES.DIALOG.PAYCODE\"></label> <input type=\"text\" name=\"paycode\" ng-model=\"vm.paycode\" ng-maxlength=\"254\" required=\"\" ng-keyup=\"vm.onInputPayCodeKeyUp()\"><div role=\"note\" multiple=\"\" class=\"field-note\" style=\"margin-top: 36px\"><span translate=\"ALLOWANCES.DIALOG.PAYCODE_FIELD_NOTE\"></span><div ng-messages=\"allowanceForm.paycode.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"valid\"><span translate=\"ALLOWANCES.DIALOG.PAYCODE_IN_USE\"></span></div></div></div></md-input-container></div><div layout=\"column\" ng-if=\"vm.updateMode\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\" style=\"margin-top: 0px\"><md-checkbox ng-model=\"vm.deactivate\">{{\'ALLOWANCES.DIALOG.DEACTIVATE\' | translate}}</md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button aria-label=\"{{\'ALLOWANCES.DIALOG.SAVE\' | translate}}\" translate=\"ALLOWANCES.DIALOG.SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"allowanceForm.$invalid || vm.amount == null || vm.name == null\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/allowances/allowances.html","<div id=\"allowances\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"column\" flex=\"\"><div class=\"header-text\"><h2>{{ \'ALLOWANCES.EMPLOYEE_ALLOWANCES\' | translate }}</h2><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\">{{ \'ALLOWANCES.DESCRIPTION_1\' | translate }}<br>{{ \'ALLOWANCES.DESCRIPTION_2\' | translate }}</div><div layout=\"column\"><div class=\"item\"><md-button ng-if=\"vm.hasModifyAllowancesAccess\" translate=\"ALLOWANCES.ADD_ALLOWANCE\" class=\"md-raised md-accent button-margin\" style=\"margin-left: 30px; margin-right: 50px;\" ng-click=\"vm.addAllowance()\" aria-label=\"Add Allowance\"></md-button></div></div></div></div><table class=\"dataTable row-border hover table-layout\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" dt-instance=\"vm.dtInstance\" ms-responsive-table=\"\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ALLOWANCES.ALLOWANCE_NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ALLOWANCES.TYPE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ALLOWANCES.AMOUNT\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ALLOWANCES.PAYCODE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ALLOWANCES.CREATED\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ALLOWANCES.ACTIVE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ALLOWANCES.ACTION\' | translate }}</span></div></th></tr></thead><tbody><tr ng-repeat=\"allowance in vm.allowances track by $index\"><td>{{allowance.Name}}</td><td>{{allowance.TypeDescription}}</td><td>{{allowance.Amount | currency:\"$\":2}}</td><td>{{allowance.PayCode}}</td><td>{{vm.formatDateTime(allowance.Timestamp)}}</td><td>{{(allowance.Active ? \'ALLOWANCES.YES\' : \'ALLOWANCES.NO\') | translate }}</td><td><md-button class=\"md-icon-button\" ng-if=\"vm.hasModifyAllowancesAccess\" ng-click=\"vm.editAllowance(allowance)\"><i class=\"icon icon-pencil teal-500-fg s20\"></i><md-tooltip><span>{{ \'ALLOWANCES.EDIT\' | translate }}</span></md-tooltip></md-button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/paperworkExceptions/filterDialog/filter-dialog.html","<md-dialog flex-xs=\"90\" flex-sm=\"90\" flex-md=\"50\" flex-lg=\"25\" ng-cloak=\"\"><form name=\"filterForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"PAPERWORK_EXCEPTION.PAPERWORK_FILTER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-body-2\"><div class=\"navigation-simple\" layout=\"column\" flex=\"100\"><div layout-margin=\"\"><div layout=\"row\"><custom-multi-select ng-model=\"vm.filterModel.BranchIds\" options=\"vm.branches\" data=\"full\" display=\"Name\" flex=\"auto\" limit=\"2\" required=\"true\" name=\"Branches\" label=\"{{\'PAPERWORK_EXCEPTION.BRANCHES\' | translate}}\"></custom-multi-select></div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"PAPERWORK_EXCEPTION.START_DATE\"></label><md-datepicker name=\"start_date\" ng-model=\"vm.filterModel.StartDate\" required=\"\"></md-datepicker><div ng-messages=\"basicInfoForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAPERWORK_EXCEPTION.START_DATE_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"PAPERWORK_EXCEPTION.END_DATE\"></label><md-datepicker name=\"end_date\" ng-model=\"vm.filterModel.EndDate\" required=\"\"></md-datepicker><div ng-messages=\"basicInfoForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAPERWORK_EXCEPTION.END_DATE_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\"><custom-multi-select ng-model=\"vm.filterModel.ReportTypes\" options=\"vm.report_types\" data=\"full\" display=\"Value\" flex=\"auto\" limit=\"1\" required=\"true\" name=\"reporttypes\" label=\"{{\'PAPERWORK_EXCEPTION.WARNING_RULES\' | translate}}\"></custom-multi-select></div><div layout=\"row\"><custom-multi-select ng-model=\"vm.filterModel.Clients\" options=\"vm.clients\" data=\"full\" display=\"Name\" flex=\"auto\" limit=\"1\" required=\"false\" name=\"Clients\" label=\"Client(s)\"></custom-multi-select></div><div layout=\"row\"><md-input-container flex=\"100\"><md-checkbox ng-model=\"vm.filterModel.IncludeExportedTickets\">{{\'PAPERWORK_EXCEPTION.INCLUDE_EXPORTED_TICKETS\' | translate}}</md-checkbox></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"filterForm.$invalid\" aria-label=\"Filter\" ng-click=\"vm.sendParams()\" translate=\"PAPERWORK_EXCEPTION.FILTER\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/payrates/payrates.detail.html","<div id=\"payrates-detail\" class=\"page-layout simple fullwidth white-bg\"><style>\r\n        .modified-row {\r\n            background-color: rgba(255, 235, 59, 0.2) !important; /* Light yellow background */\r\n        }\r\n        .modified-value {\r\n            color: #f57c00 !important; /* Orange text color */\r\n            font-weight: bold;\r\n        }\r\n    </style><div class=\"content\" layout=\"column\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"section-container\" style=\"margin-bottom: 24px;\"><div class=\"header-text\"><div layout=\"row\" layout-align=\"space-between center\"><div><h2 style=\"margin-left: 16px;\">Base Rates</h2></div><div><md-button class=\"md-raised md-accent\" ng-click=\"vm.recalculateRates()\" layout=\"row\" layout-align=\"center center\"><span style=\"text-align: center;\">Recalculate</span></md-button></div></div></div><div class=\"table-responsive\"><table class=\"dataTable row-border hover\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Classification</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Rate</span></div></th></tr></thead><tbody><tr ng-repeat=\"(classificationName, baseRate) in vm.baseRates\"><td>{{classificationName}}</td><td><md-input-container class=\"md-block no-margin\" style=\"margin: 0; padding: 0;\"><input type=\"number\" step=\"0.0001\" ng-model=\"baseRate\" aria-label=\"Rate\" style=\"text-align: right;\" ng-change=\"vm.baseRates[classificationName] = baseRate; vm.rateChanged(baseRate)\"></md-input-container></td></tr><tr ng-if=\"vm.baseRates.length === 0\"><td colspan=\"2\" class=\"text-center\">No base rates found</td></tr></tbody></table></div></div><md-divider></md-divider><div class=\"section-container\" style=\"margin-top: 24px;\"><div class=\"header-text\"><div layout=\"row\" layout-align=\"space-between center\"><div><h2 style=\"margin-left: 16px;\">Pay Rates</h2></div></div></div><div class=\"table-responsive\"><table class=\"dataTable row-border hover\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pay Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Loading</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pay Rate</span></div></th></tr></thead><tbody><tr ng-repeat=\"payRate in vm.paginatedPayRates\" ng-class=\"{\'modified-row\': payRate.isModified}\"><td>{{payRate.PayCode}}</td><td><span ng-if=\"payRate.Loading != null && !isNaN(payRate.Loading)\">{{payRate.Loading }}%</span> <span ng-if=\"payRate.Loading == null || isNaN(payRate.Loading)\">NA</span></td><td><md-input-container class=\"md-block no-margin\" style=\"margin: 0; padding: 0;\"><input type=\"number\" step=\"0.0001\" ng-model=\"payRate.Rate\" ng-change=\"vm.payRateChanged(payRate)\" aria-label=\"Pay Rate\" style=\"text-align: right;\" ng-class=\"{\'modified-value\': payRate.isModified}\"></md-input-container></td></tr><tr ng-if=\"vm.payRates.length === 0\"><td colspan=\"2\" class=\"text-center\">No pay rates found</td></tr></tbody></table><div layout=\"row\" layout-align=\"end center\" style=\"margin-top: 16px; padding: 0 16px;\"><div flex=\"\"><span>Showing {{vm.startIndex + 1}} to {{vm.endIndex}} of {{vm.payRates.length}} entries</span></div><div layout=\"row\" layout-align=\"center center\"><span style=\"margin-right: 8px;\">Show</span><md-select ng-model=\"vm.itemsPerPage\" ng-change=\"vm.changeItemsPerPage()\" aria-label=\"Items per page\" style=\"margin: 0; min-width: 60px;\"><md-option ng-value=\"10\">10</md-option><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select><span style=\"margin-left: 8px; margin-right: 16px;\">entries</span><md-button class=\"md-icon-button\" ng-click=\"vm.prevPage()\" ng-disabled=\"vm.currentPage === 1\"><md-icon>keyboard_arrow_left</md-icon></md-button><span>Page {{vm.currentPage}} of {{vm.totalPages}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.nextPage()\" ng-disabled=\"vm.currentPage === vm.totalPages\"><md-icon>keyboard_arrow_right</md-icon></md-button></div></div></div><div layout=\"row\" layout-align=\"start center\" style=\"margin: 16px;\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.saveChanges()\" layout=\"row\" layout-align=\"center center\"><span style=\"text-align: center;\">Save</span></md-button></div></div></div></div></div>");
$templateCache.put("app/main/payroll/payrates/payrates.detail.updated.html","<div class=\"section-container\" style=\"margin-top: 24px;\"><div class=\"header-text\"><div layout=\"row\" layout-align=\"space-between center\"><div><h2 style=\"margin-left: 16px;\">Pay Rates</h2></div></div></div><div class=\"table-responsive\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" dt-instance=\"vm.dtInstance\" ms-responsive-table=\"\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pay Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pay Rate</span></div></th></tr></thead><tbody><tr ng-repeat=\"payRate in vm.payRates\"><td>{{payRate.paycode}}</td><td><md-input-container class=\"md-block no-margin\" style=\"margin: 0; padding: 0;\"><input type=\"number\" step=\"0.0001\" ng-model=\"payRate.payrate\" ng-change=\"vm.payRateChanged(payRate)\" aria-label=\"Pay Rate\" style=\"text-align: right;\"></md-input-container></td></tr><tr ng-if=\"vm.payRates.length === 0\"><td colspan=\"2\" class=\"text-center\">No pay rates found</td></tr></tbody></table></div><div layout=\"row\" layout-align=\"start center\" style=\"margin: 16px;\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.saveChanges()\" layout=\"row\" layout-align=\"center center\"><span style=\"text-align: center;\">Save</span></md-button></div></div>");
$templateCache.put("app/main/payroll/payrates/payrates.dialog.html","<md-dialog class=\"dialog\" aria-label=\"{{vm.title | translate}}\"><form name=\"payrateForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container class=\"md-block\"><label>{{ \'PAYRATES.DIALOG.NAME\' | translate }}</label> <input name=\"name\" ng-model=\"vm.payrate.Name\" required=\"\"><div ng-messages=\"payrateForm.name.$error\" role=\"alert\"><div ng-message=\"required\">{{ \'PAYRATES.DIALOG.NAME_REQUIRED\' | translate }}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{ \'PAYRATES.DIALOG.DESCRIPTION\' | translate }}</label> <textarea name=\"description\" ng-model=\"vm.payrate.Description\" rows=\"3\"></textarea></md-input-container><md-input-container class=\"md-block\"><label>{{ \'PAYRATES.DIALOG.RATE\' | translate }}</label> <input name=\"rate\" type=\"number\" step=\"0.01\" min=\"0\" ng-model=\"vm.payrate.Rate\" required=\"\"><div ng-messages=\"payrateForm.rate.$error\" role=\"alert\"><div ng-message=\"required\">{{ \'PAYRATES.DIALOG.RATE_REQUIRED\' | translate }}</div><div ng-message=\"min\">{{ \'PAYRATES.DIALOG.RATE_MIN\' | translate }}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{ \'PAYRATES.DIALOG.TYPE\' | translate }}</label><md-select name=\"type\" ng-model=\"vm.payrate.Type\" required=\"\"><md-option ng-repeat=\"type in vm.payrateTypes\" value=\"{{type.id}}\">{{type.name | translate}}</md-option></md-select><div ng-messages=\"payrateForm.type.$error\" role=\"alert\"><div ng-message=\"required\">{{ \'PAYRATES.DIALOG.TYPE_REQUIRED\' | translate }}</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\">{{ \'PAYRATES.DIALOG.CANCEL\' | translate }}</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.save()\" ng-disabled=\"payrateForm.$invalid\">{{ \'PAYRATES.DIALOG.SAVE\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/payrates/payrates.html","<div id=\"payrates\" class=\"page-layout simple fullwidth white-bg\"><div class=\"content\" layout=\"column\"><div class=\"white-bg md-whiteframe-1dp\"><div class=\"header-text\"><div layout=\"row\" layout-align=\"space-between center\"><div><h2>{{ \'PAYRATES.AWARDS\' | translate }}</h2></div></div></div><div class=\"table-responsive\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" dt-instance=\"vm.dtInstance\" class=\"dataTable row-border hover\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'PAYRATES.GRID.NAME\' | translate }}</span></div></th><th class=\"secondary-text action-column\"><div class=\"table-header\"><span class=\"column-title\">{{ \'PAYRATES.GRID.ACTION\' | translate }}</span></div></th></tr></thead><tbody><tr ng-repeat=\"(id,name) in vm.awards\"><td>{{name}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.editPayrate(id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"top\">{{ \'PAYRATES.GRID.EDIT\' | translate }}</md-tooltip></md-button></td></tr><tr ng-if=\"vm.payrates.length === 0\"><td colspan=\"2\" class=\"text-center\">{{ \'PAYRATES.GRID.NO_RECORDS\' | translate }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/paperworkExceptions/sidenav/main-sidenav.html","<md-content ms-scroll=\"\" class=\"content margin-left-15\" flex=\"\"><form name=\"basicInfoForm\"><div class=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"Filter\" ng-click=\"vm.loadReport()\" translate=\"PAPERWORK_EXCEPTION.FILTER\" ng-disabled=\"basicInfoForm.$invalid\" ng-if=\"!vm.is_loading\"></md-button></div><div class=\"loading-threads margin-top-10\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.is_loading\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular><div class=\"margin-top-10\"><strong>{{vm.loader_message}}</strong></div></div><div class=\"navigation-simple\" layout=\"column\" flex=\"100\"><div layout-margin=\"\"><div layout=\"row\"><custom-multi-select ng-model=\"vm.filterModel.BranchIds\" options=\"vm.service.branches\" data=\"full\" display=\"Name\" disabled=\"vm.is_loading\" flex=\"auto\" limit=\"2\" required=\"true\" name=\"Branches\" label=\"{{\'PAPERWORK_EXCEPTION.BRANCHES\' | translate}}\"></custom-multi-select></div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"PAPERWORK_EXCEPTION.START_DATE\"></label><md-datepicker ng-disabled=\"vm.is_loading\" name=\"start_date\" ng-model=\"vm.filterModel.StartDate\" required=\"\"></md-datepicker><div ng-messages=\"basicInfoForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAPERWORK_EXCEPTION.START_DATE_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"PAPERWORK_EXCEPTION.END_DATE\"></label><md-datepicker ng-disabled=\"vm.is_loading\" name=\"end_date\" ng-model=\"vm.filterModel.EndDate\" required=\"\"></md-datepicker><div ng-messages=\"basicInfoForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAPERWORK_EXCEPTION.END_DATE_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\"><custom-multi-select ng-model=\"vm.filterModel.ReportTypes\" options=\"vm.service.report_types\" data=\"full\" display=\"Value\" disabled=\"vm.is_loading\" flex=\"auto\" limit=\"1\" required=\"true\" name=\"reporttypes\" label=\"{{\'PAPERWORK_EXCEPTION.WARNING_RULES\' | translate}}\"></custom-multi-select></div><div layout=\"row\"><custom-multi-select ng-model=\"vm.filterModel.Clients\" options=\"vm.service.clients\" data=\"full\" display=\"Name\" disabled=\"vm.is_loading\" flex=\"auto\" limit=\"1\" required=\"false\" name=\"Clients\" label=\"Client(s)\"></custom-multi-select></div><div layout=\"row\"><md-input-container class=\"mb-0\"><md-checkbox ng-model=\"vm.filterModel.IncludeExportedTickets\">{{\'PAPERWORK_EXCEPTION.INCLUDE_EXPORTED_TICKETS\' | translate}}</md-checkbox></md-input-container></div></div></div></form></md-content>");
$templateCache.put("app/main/payrollGroups/auditLog/payroll-group-audit-log.html","<table class=\"dataTable row-border\"><thead><tr><th>Field</th><th>Value</th></tr></thead><tbody><tr><td>{{vm.fieldLabel}}</td><td>{{vm.fieldValue}}</td></tr></tbody></table>");
$templateCache.put("app/main/payrollSettings/manage/payroll-settings-manage.html","<div class=\"page-layout simple fullwidth element-doc-page payroll-settings\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent button-margin\" ng-click=\"vm.downloadAwardCodes()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_DOWNLOAD_CODES_RATES\' | translate}}</md-button></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header class=\"pv-0\"><md-card-header-text><h3 class=\"mv-15 md-title\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_EXPORT_FORMAT\' | translate}}</h3></md-card-header-text></md-card-header><md-card-content class=\"pv-0\"><form name=\"PayrollExportFormatForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100 pv-0\"><div class=\"layout-gt-sm-row layout-row\"><div layout=\"column\" flex=\"70\"><md-input-container layout=\"column\" flex=\"15\" class=\"payroll-format\"><textarea name=\"ExportFormat\" id=\"ExportFormat\" data-caret-aware=\"cursor\" ng-model=\"vm.payrollSettings.ExportFormat\" placeholder=\"e.g. T5,{employeeCode},{employeeNo},,{codeType},{code},{qty:0.00},,,,{exportDate:dd/MM/yyyy},{glCode},,,,,,,,,,,\" required=\"\">\r\n\r\n                                            </textarea><div ng-messages=\"PayrollExportFormatForm.ExportFormat.$error\" ng-show=\"PayrollExportFormatForm.ExportFormat.$dirty\"><div ng-message=\"required\">This is required!</div></div></md-input-container><md-input-container layout=\"column\" flex=\"85\" class=\"mt-5\"><div ui-ace=\"{ mode: \'javascript\' }\" name=\"ConditionalScript\" ng-model=\"vm.payrollSettings.ConditionalScript\"></div></md-input-container></div><div layout=\"column\" flex=\"30\"><md-input-container layout=\"column\"><md-list><md-list-item ng-repeat=\"field in vm.payrollSettings.ExportFields\" class=\"md-1-line\" layout=\"row\" ng-click=\"vm.addExportFormatField(field.Key)\"><div layout=\"column\" flex=\"40\">{ {{ field.Key }} }</div><div layout=\"column\" flex=\"60\">{{ field.Value }}</div></md-list-item></md-list></md-input-container></div></div><div layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editExportFormat()\" ng-disabled=\"PayrollExportFormatForm.ExportFormat.$invalid && PayrollExportFormatForm.ExportFormat.$touched\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content><md-card-content><h3 class=\"md-title mb-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_EXPORT_HEADING\' | translate}}</h3><form name=\"exportFileHeadingForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100 pv-0\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><input name=\"fileHeading\" ng-model=\"vm.payrollSettings.ExportHeader\"></md-input-container></div><div flex=\"\" layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editExportFileHeading()\" ng-disabled=\"!exportFileHeadingForm.fileHeading.$dirty\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content></md-card></div></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_EXPORT_FILE_EXT\' | translate}}</h3></md-card-header-text></md-card-header><md-card-content class=\"m-0\"><form name=\"exportFileExtensionForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><input name=\"fileExtension\" ng-model=\"vm.payrollSettings.ExportFileExtension\" md-maxlength=\"15\" ng-pattern=\"/^[a-zA-Z\\s]*$/\" required=\"\"><div ng-messages=\"exportFileExtensionForm.fileExtension.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">File extension should not be more than 15 characters</div><div ng-message=\"pattern\">Invalid file extension format</div></div></md-input-container></div><div flex=\"\" layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editExportFileExtension()\" ng-disabled=\"exportFileExtensionForm.fileExtension.$invalid && exportFileExtensionForm.fileExtension.$touched\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content></md-card></div></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_CODES\' | translate}}</h3></md-card-header-text></md-card-header><md-card-content class=\"m-0\"><form name=\"payrollTaxCodesForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><textarea name=\"payrollTaxCodes\" ng-model=\"vm.payrollSettings.PayrollTaxCodesHolder\" max-rows=\"5\">\r\n\r\n                                        </textarea></md-input-container></div><div flex=\"\" layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editPayrollTaxCodes()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content></md-card></div></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_RATE_BRANCH\' | translate}}</h3></md-card-header-text><div flex=\"\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.launchTaxRateByBranch()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ADD_BUTTON\' | translate}}</md-button></div></md-card-header><md-card-content class=\"m-0\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_BRANCH\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_YEAR\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_RATE\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ACTIONS\' | translate}}</th></thead><tbody><tr ng-repeat=\"branchTaxRate in vm.payrollSettings.BranchPayrollTaxRates track by $index\"><td class=\"text-left\">{{branchTaxRate.BranchName}}</td><td class=\"text-left\">{{branchTaxRate.Year}}</td><td class=\"text-left\">{{branchTaxRate.TaxRate}} %</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.launchTaxRateByBranch(branchTaxRate, $index)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_RATE_BRANCH_EDIT\' | translate}}</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeTaxRateByBranch(branchTaxRate)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_RATE_BRANCH_DELETE\' | translate}}</span></md-tooltip></md-button></td></tr></tbody></table></md-card-content></md-card></div></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_CODES\' | translate}}</h3></md-card-header-text></md-card-header><md-card-content class=\"m-0\"><form name=\"payrollCompensationCodesForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><textarea name=\"payrollCompensationCodes\" ng-model=\"vm.payrollSettings.PayrollCompensationCodesHolder\" max-rows=\"5\">\r\n\r\n                                        </textarea></md-input-container></div><div flex=\"\" layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editPayrollCompensationCodes()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content></md-card></div></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE_BRANCH\' | translate}}</h3></md-card-header-text><div flex=\"\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.launchCompensationRateByBranch()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ADD_BUTTON\' | translate}}</md-button></div></md-card-header><md-card-content class=\"m-0\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_BRANCH\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_YEAR\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ACTIONS\' | translate}}</th></thead><tbody><tr ng-repeat=\"branchCompensationRate in vm.payrollSettings.BranchWorkerCompensationRates track by $index\"><td class=\"text-left\">{{branchCompensationRate.BranchName}}</td><td class=\"text-left\">{{branchCompensationRate.Year}}</td><td class=\"text-left\">{{branchCompensationRate.CompensationRate}} %</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.launchCompensationRateByBranch(branchCompensationRate, $index)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE_BRANCH_EDIT\' | translate}}</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeCompensationRateByBranch(branchCompensationRate)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE_BRANCH_DELETE\' | translate}}</span></md-tooltip></md-button></td></tr></tbody></table></md-card-content></md-card></div></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_CODES\' | translate}}</h3></md-card-header-text></md-card-header><md-card-content class=\"m-0\"><form name=\"payrollSuperannuationCodesForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><textarea name=\"payrollSuperannuationCodes\" ng-model=\"vm.payrollSettings.PayrollSuperannuationCodesHolder\" max-rows=\"5\">\r\n\r\n                                        </textarea></md-input-container></div><div flex=\"\" layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editPayrollSuperannuationCodes()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</md-button></div></div></form></md-card-content></md-card></div></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE_BRANCH\' | translate}}</h3></md-card-header-text><div flex=\"\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.launchSuperannuationRateByBranch()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ADD_BUTTON\' | translate}}</md-button></div></md-card-header><md-card-content class=\"m-0\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_BRANCH\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_YEAR\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ACTIONS\' | translate}}</th></thead><tbody><tr ng-repeat=\"branchSuperannuationRate in vm.payrollSettings.BranchSuperannuationRates track by $index\"><td class=\"text-left\">{{branchSuperannuationRate.BranchName}}</td><td class=\"text-left\">{{branchSuperannuationRate.Year}}</td><td class=\"text-left\">{{branchSuperannuationRate.SuperannuationRate}} %</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.launchSuperannuationRateByBranch(branchSuperannuationRate, $index)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE_BRANCH_EDIT\' | translate}}</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeSuperannuationRateByBranch(branchSuperannuationRate)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE_BRANCH_DELETE\' | translate}}</span></md-tooltip></md-button></td></tr></tbody></table></md-card-content></md-card></div></div><div layout=\"row\" class=\"payroll-export-codes\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><md-card-header><md-card-header-text><h3 class=\"md-title m-0\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_EXPORT_CODES\' | translate}}</h3></md-card-header-text><div flex=\"\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.editPayrollExportCodes()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_UPDATE_BUTTON\' | translate}}</md-button></div></md-card-header><md-card-content class=\"m-0 payroll-export-codes-sheet\"><wj-flex-sheet class=\"flex-sheet-holder\" control=\"vm.flexSheet\" initialized=\"vm.initializedFlexsheet(s)\" selected-sheet-index=\"0\"><wj-sheet class=\"flex-sheet\" name=\"Country\" items-source=\"vm.payrollCodes\" column-count=\"2\"></wj-sheet></wj-flex-sheet></md-card-content></md-card></div></div></div></div>");
$templateCache.put("app/main/payrollGroups/dialogs/payroll-group-dialog.html","<md-dialog id=\"payroll-group-dialog\" flex=\"30\" ng-cloak=\"\" block-ui=\"add-project\"><form name=\"payrollGroupForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.model.Id ? \"Edit\" : \"Add\"}} {{\'PAYROLL_GROUPS.MAIN_PAYROLL_GROUPS_DIALOG\'| translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container flex=\"\" class=\"md-block {{vm.errorMessage ? \'md-input-invalid\' : \'\'}}\"><input type=\"text\" name=\"Name\" ng-model=\"vm.model.Name\" maxlength=\"12\" ng-keypress=\"vm.keyPressAlphaNumeric($event)\" ng-paste=\"vm.pasteAlphaNumeric($event)\" placeholder=\"{{\'PAYROLL_GROUPS.MAIN_PAYROLL_GROUPS_NAME\' | translate}}\" required=\"\"><div ng-messages=\"payrollGroupForm.project.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"PAYROLL_GROUPS.MAIN_PAYROLL_GROUPS_NAME_IS_REQUIRED\"></span></div></div><div class=\"error-message\"><span class=\"error-duplicate-message\" ng-show=\"vm.errorMessage\">{{vm.errorMessage}}</span></div><div class=\"dialog-note\"><span translate=\"PAYROLL_GROUPS.FOOTNOTE\"></span></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"vm.cancel()\">{{\'PAYROLL_GROUPS.MAIN_CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-accent\" ng-show=\"{{vm.model.Id?true:false}}\" ng-click=\"vm.archive()\">{{\'PAYROLL_GROUPS.MAIN_ARCHIVE\' | translate}}</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.save()\" ng-disabled=\"payrollGroupForm.$invalid\">{{\'PAYROLL_GROUPS.MAIN_SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/projects/create/project-create.html","<div id=\"branch-create\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"toolbar md-whiteframe-2dp\"><toolbar-loader message=\"vm.service.isLoadingMessage\" show=\"vm.service.isLoading\"></toolbar-loader><div ng-if=\"!vm.service.isLoading\" class=\"toolbar-wrapper\"><md-card-actions layout=\"row\" layout-align-start-center=\"\" layout-row=\"\"><md-button ng-click=\"vm.service.save()\" translate=\"PROJECTS_CREATE.SAVE\" class=\"md-raised md-accent first-button-margin\" ng-disabled=\"projectForm.$invalid\"></md-button><md-button translate=\"PROJECTS_CREATE.VIEW_PROJECTS\" ng-click=\"vm.service.viewProjects()\" class=\"md-raised md-accent first-button-margin\"></md-button></md-card-actions></div></div><div ng-style=\"{\'opacity\' : vm.service.isLoading ? \'0.8\' : \'1\'}\" class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"form-wrapper md-whiteframe-4dp\" ng-form=\"projectForm\"><div layout=\"column\" flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"text\" name=\"project\" ng-model=\"vm.service.model.Name\" placeholder=\"{{\'PROJECTS_CREATE.NAME\' | translate}}\" required=\"\"></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label translate=\"PROJECTS_CREATE.BRANCHES\"></label><md-select placeholder=\"{{\'PROJECTS_CREATE.BRANCHES\' | translate}}\" ng-model=\"vm.service.model.Branches\" name=\"Branches\" md-selected-text=\"vm.utilService.getSelectedText(vm.service.model.Branches, \'Branches\', \'Name\')\" required=\"\" ng-model-options=\"{trackBy: \'$value.Id\'}\" multiple=\"\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.service.branches\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block\" ng-if=\"vm.claimsUtilService.isPayrollEnabled()\"><label translate=\"PROJECTS_CREATE.AWARD\"></label><md-select ng-model=\"vm.service.model.Award\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'PROJECTS_CREATE.AWARD\' | translate}}\"><md-option></md-option><md-option ng-value=\"award\" ng-repeat=\"award in vm.service.awards\">{{award.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block\" ng-if=\"vm.claimsUtilService.isBillingEnabled()\"><label translate=\"PROJECTS_CREATE.RATE_CARD\"></label><md-select ng-model=\"vm.service.model.RateCard\" ng-model-options=\"{trackBy: \'$value.Id\'}\" name=\"RateCard\" placeholder=\"{{\'PROJECTS_CREATE.RATE_CARD\' | translate}}\" ng-required=\"true\"><md-option ng-value=\"rateCard\" ng-repeat=\"rateCard in vm.service.rateCards\">{{rateCard.Name}}</md-option></md-select></md-input-container><md-chips ng-model=\"vm.service.model.Companies\" md-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.Name\" placeholder=\"{{\'PROJECTS_CREATE.CLIENTS\' | translate}}\"><span md-highlight-text=\"vm.searchText\">{{item.Name}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.Name}}</strong></span></md-chip-template></md-chips><md-input-container><md-checkbox ng-model=\"vm.service.model.IsPurchaseOrderMandatory\">{{\'PROJECTS_CREATE.PURCHASE_ORDER_IS_MANDATORY\' | translate}}</md-checkbox></md-input-container><project-skills skills=\"vm.service.skills\" ng-model=\"vm.service.model.ProjectSkills\"></project-skills><md-input-container><md-checkbox ng-model=\"vm.service.model.IsArchived\" ng-hide=\"!vm.service.isEditMode\">{{\'PROJECTS_CREATE.ARCHIVE\' | translate}}</md-checkbox></md-input-container></div></div></div></div></div>");
$templateCache.put("app/main/projects/view/project-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><toolbar-loader message=\"vm.projectService.isLoadingMessage\" show=\"vm.projectService.isLoading\"></toolbar-loader><div ng-if=\"!vm.projectService.isLoading\" class=\"toolbar-wrapper\"><md-button translate=\"PROJECTS_VIEW.ADD\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vm.projectService.addProject()\"></md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{\'PROJECTS_VIEW.SEARCH\' | translate}}\" ng-model=\"vm.projectService.query\" ng-keyup=\"vm.searchTable()\"></md-input-container></div></div><table class=\"dataTable row-border hover\" dt-instance=\"vm.dtInstance\" style=\"margin-top :20px;\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span class=\"column-title\" translate=\"PROJECTS_VIEW.COLUMN_NAME\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span class=\"column-title\" translate=\"PROJECTS_VIEW.COLUMN_COMPANIES\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PROJECTS_VIEW.COLUMN_BRANCHES\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PROJECTS_VIEW.COLUMN_ACTIONS\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"project in vm.projectService.projects\"><td class=\"project-name\">{{project.Name}}</td><td><span ng-bind-html=\"project.CompaniesFormattedHtml\"></span></td><td>{{project.FormattedBranches}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.projectService.editProject(project)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"PROJECTS_VIEW.EDIT\"></span></md-tooltip></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/rateCardSettings/allowances/allowances.html","<div class=\"page-layout simple fullwidth ratecard-allowances\" ng-if=\"!rateCardAllowances.isCreateRatecardAllowanceActive\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"rateCardAllowances.delay\" source=\"rateCardAllowances.dataGrid.grid.searchTerm\" layout-margin=\"\" flex=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\" flex-offset=\"95\" flex=\"5\" class=\"create-btn-holder\"><md-button ng-click=\"rateCardAllowances.showCreateRateCardAllowance()\" class=\"md-fab md-mini md-accent pull-right create-ratecard-allowances-btn\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'RATECARD_V2.MAIN_CREATE_RATECARD\' | translate}}</md-tooltip></md-icon></md-button></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"rateCardAllowances.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_NAME\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_TYPE\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.MAIN_ACTIONS\' | translate}}</span></div></th></thead><tbody><tr ng-repeat=\"allowance in rateCardAllowances.dataGrid.grid.data track by $index\"><td class=\"text-left\">{{allowance.Name}}</td><td class=\"text-left header-codes\">{{ allowance.Tag }}</td><td><md-button class=\"md-icon-button\" ng-click=\"rateCardAllowances.showCreateRateCardAllowance(allowance)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"rateCardAllowances.removeAllowance(allowance)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"rateCardAllowances.dataGrid.grid.behavior\" distinct-by=\"InvoiceNumber\" on-init=\"rateCardAllowances.dataGrid.grid.onInit()\" on-error=\"rateCardAllowances.dataGrid.grid.onError(ex)\" on-completed=\"rateCardAllowances.dataGrid.grid.onCompleted(data)\" on-data-filter=\"rateCardAllowances.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></md-card></div></div></div></div></div><div class=\"page-layout simple fullwidth ratecard-allowances\" ng-if=\"rateCardAllowances.isCreateRatecardAllowanceActive\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><form name=\"createAllowanceForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div layout=\"row\" layout-wrap=\"\"><h2 flex=\"100\" ng-if=\"!rateCardAllowances.isEditRatecardAllowanceActive\">{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_HEADER\' | translate}}</h2><h2 flex=\"100\" ng-if=\"rateCardAllowances.isEditRatecardAllowanceActive\">{{\'RATECARD_V2.MAIN_ALLOWANCES_EDIT_FORM_HEADER\' | translate}}</h2></div><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_NAME\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><input name=\"allowanceName\" ng-model=\"rateCardAllowances.formData.AllowanceName\" required=\"\"><div ng-messages=\"createAllowanceForm.allowanceName.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_TYPE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\" required=\"\"><md-select name=\"allowanceType\" ng-model=\"rateCardAllowances.formData.RateCardAllowanceType\" ng-change=\"rateCardAllowances.onChangeAllowanceType(rateCardAllowances.formData.RateCardAllowanceType)\" required=\"\"><md-option ng-value=\"lookup.Allowance.Id\" ng-repeat=\"lookup in rateCardAllowances.allowancesLookup\" required=\"\">{{ lookup.Allowance.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"rateCardAllowances.isHourlySelected() && !rateCardAllowances.isLookupEmpty(rateCardAllowances.allowanceMultipliersLookup.HourlyMultiplier)\"><label class=\"md-body-2\">{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_HOURLY_MULTIPLIER\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"allowanceHourlyMultiplier\" ng-model=\"rateCardAllowances.formData.RateCardAllowanceHourlyMultiplierVariable\"><md-option ng-value=\"hourlyMultiplier.Id\" ng-repeat=\"hourlyMultiplier in rateCardAllowances.allowanceMultipliersLookup.HourlyMultiplier\">{{ hourlyMultiplier.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"rateCardAllowances.isDistanceSelected() && !rateCardAllowances.isLookupEmpty(rateCardAllowances.allowanceMultipliersLookup.DistanceMultiplier)\"><label class=\"md-body-2\">{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_DISTANCE_MULTIPLIER\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"allowanceDistanceMultiplier\" ng-model=\"rateCardAllowances.formData.RateCardAllowanceDistanceMultiplierVariable\"><md-option ng-value=\"distanceMultiplier.Id\" ng-repeat=\"distanceMultiplier in rateCardAllowances.allowanceMultipliersLookup.DistanceMultiplier\">{{ distanceMultiplier.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"rateCardAllowances.isDistanceSelected() && !rateCardAllowances.isLookupEmpty(rateCardAllowances.allowanceMultipliersLookup.VehicleOwnershipTypes)\"><label class=\"md-body-2\">{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_OWNERSHIP_TYPE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\" ng-required=\"rateCardAllowances.isVehicleOwnershipTypeRequired()\"><md-select name=\"allowanceVehicleOwnershipType\" ng-required=\"rateCardAllowances.isVehicleOwnershipTypeRequired()\" ng-model=\"rateCardAllowances.formData.VehicleOwnershipType\"><md-option ng-value=\"item.Id\" ng-repeat=\"item in rateCardAllowances.allowanceMultipliersLookup.VehicleOwnershipTypes\">{{ item.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardAllowances.formData.AppliesToFullTime\"><label>{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_FULL_TIME\' | translate}}</label></md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardAllowances.formData.AppliesToCasual\"><label>{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_CASUAL_TIME\' | translate}}</label></md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><fieldset class=\"standard\" flex=\"100\"><legend><b>{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_CONDITIONS\' | translate}}</b></legend><condition-component layout-margin=\"\" flex=\"\" allowance-type=\"rateCardAllowances.formData.RateCardAllowanceType\" condition-src=\"conditionsArray\" condition-lookups=\"rateCardAllowances.allowanceConditionsLookup\"></condition-component></fieldset></div><div layout=\"row\" layout-wrap=\"\"><md-dialog-actions layout=\"row\" ng-if=\"rateCardAllowances.isCreateRatecardAllowanceActive && !rateCardAllowances.isEditRatecardAllowanceActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardAllowances.createAllowance()\" ng-disabled=\"!createAllowanceForm.$valid || (createConditionForm && !createConditionForm.$valid)\">{{\'RATECARD_V2.MAIN_ADD\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" ng-if=\"rateCardAllowances.isEditRatecardAllowanceActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardAllowances.updateAllowance()\" ng-disabled=\"(!createAllowanceForm.$valid && createAllowanceForm ) || (createConditionForm && !createConditionForm.$valid)\">{{\'RATECARD_V2.MAIN_SAVE\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-body-2\" ng-click=\"rateCardAllowances.toggleAllowanceCreate()\">{{\'RATECARD_V2.MAIN_CANCEL\' | translate}}</md-button></md-dialog-actions></div></div></form></div></div></div></div>");
$templateCache.put("app/main/payroll/timesheet/payroll-timesheet.html","<div class=\"main-style page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar\"><div class=\"toolbar-wrapper\" ng-if=\"!vm.service.loading\"><md-button class=\"first-button-margin md-raised md-accent\" translate=\"PAYROLL_TIMESHEETS.EXPORT\" ng-click=\"vm.service.generatePDF(vm.service.model)\" ng-disabled=\"vm.form.$invalid\"></md-button><md-button class=\"button-margin md-raised md-accent\" translate=\"PAYROLL_TIMESHEETS.RESET\" ng-click=\"vm.service.reset()\"></md-button></div><div class=\"toolbar-wrapper\" ng-if=\"vm.service.loading\" style=\"height : 64px ; padding-top : 20px; padding-left : 20px;\"><span class=\"md-caption\"><table><tr><td><b>{{vm.service.loadingMessage}} &nbsp; &nbsp; &nbsp;</b></td><td><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.service.loading\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></td></tr></table></span></div></div><div class=\"content\" flex=\"\"><md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" ng-if=\"vm.service.loading\"></md-progress-linear><div layout=\"column\" class=\"white-bg\"><div flex=\"\"><form name=\"vm.form\"><md-card class=\"main-style\"><md-card-content><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><div flex=\"\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"PAYROLL_TIMESHEETS.START_DATE\"></label><md-datepicker ng-model=\"vm.service.model.StartDate\" ng-required=\"true\" layout=\"row\" flex=\"\"></md-datepicker></md-input-container></div><div flex=\"\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"PAYROLL_TIMESHEETS.END_DATE\"></label><md-datepicker ng-model=\"vm.service.model.EndDate\" ng-required=\"true\" layout=\"row\" flex=\"\"></md-datepicker></md-input-container></div></div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><div flex=\"\"><md-input-container class=\"md-block\"><label translate=\"PAYROLL_TIMESHEETS.BRANCH\"></label><md-select ng-model=\"vm.service.model.BranchId\" ng-change=\"vm.service.changeBranch(vm.service.model.BranchId)\" ng-required=\"true\"><md-option ng-repeat=\"branch in vm.service.branches\" ng-value=\"branch.Id\">{{branch.Name}}</md-option></md-select></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><label translate=\"PAYROLL_TIMESHEETS.DIVISIONS\"></label><md-select ng-model=\"vm.service.model.DivisionId\"><md-option ng-repeat=\"division in vm.service.divisions\" ng-value=\"division.id\">{{division.Name}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-lt-lg=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-input-container layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-radio-group layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" ng-model=\"vm.service.model.ShouldUseTemporaryInterpretedShift\"><md-radio-button value=\"0\" class=\"md-primary\">{{\'PAYROLL_TIMESHEETS.EXPORTED_DATA\' | translate}}</md-radio-button><md-radio-button value=\"1\">{{\'PAYROLL_TIMESHEETS.INTERPRETED_DATA\' | translate}}</md-radio-button></md-radio-group></md-input-container></div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><div ng-if=\"vm.service.employees.length > 0\" flex=\"\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.service.selectedItem\" md-search-text=\"vm.service.searchText\" md-selected-item-change=\"vm.service.selectedItemChange(item)\" md-items=\"item in vm.service.querySearch(vm.service.searchText)\" md-item-text=\"vm.getEmployeeName(item.FullName, item.EmployeeCode)\" md-min-length=\"0\" placeholder=\"{{\'PAYROLL_TIMESHEETS.EMPLOYEE\' | translate}}\"><md-item-template><span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.FullName}} ({{item.EmployeeCode}})</span></md-item-template><md-not-found>{{\'PAYROLL_TIMESHEETS.START_TYPING\' | translate}}</md-not-found></md-autocomplete></div></div></md-card-content></md-card></form></div></div></div></div></div>");
$templateCache.put("app/main/payroll/update-payroll-contacts/update-payroll-contacts.html","<div id=\"update-payroll-contacts\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div ng-if=\"!vm.service.loader\" layout=\"column\" class=\"toolbar-wrapper header-filter\"><div class=\"item\"><md-button translate=\"UPDATE_PAYROLL_CONTACTS.AUTO_MATCH\" class=\"md-raised md-accent button-margin\" ng-click=\"vm.autoMatch()\" style=\"margin-left: 30px; width: 120px;\" ng-disabled=\"(!vm.isConnectedToMyob || vm.isMyobEmployeeDisabled) && (!vm.isConnectedToXero || vm.isXeroEmployeeDisabled)\"></md-button><md-button translate=\"UPDATE_PAYROLL_CONTACTS.SAVE\" class=\"md-raised md-accent button-margin\" ng-click=\"vm.save()\" style=\"margin-left: 14px; width: 52px; padding: 0\" ng-disabled=\"(!vm.isConnectedToMyob || vm.isMyobEmployeeDisabled) && (!vm.isConnectedToXero || vm.isXeroEmployeeDisabled)\"></md-button></div></div><toolbar-loader show=\"vm.service.loader\" message=\"vm.service.loaderMessage\"></toolbar-loader></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"(vm.isMyobEnabled && (vm.isMyobEmployeeDisabled || !vm.isConnectedToMyob)) || (vm.isXeroEnabled && (vm.isXeroEmployeeDisabled || !vm.isConnectedToXero))\"><label translate=\"UPDATE_PAYROLL_CONTACTS.NO_CONNECTION_FOUND\"></label> <label translate=\"UPDATE_PAYROLL_CONTACTS.INTEGRATIONS_PAGE\" ng-click=\"vm.redirectToIntegrationsPage()\" class=\"clickable-item\"></label> <label translate=\"UPDATE_PAYROLL_CONTACTS.BUSINESSES_PAGE\" ng-click=\"vm.redirectToBusinessesPage()\" class=\"clickable-item\"></label></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"column\" flex=\"\"><table class=\"dataTable row-border hover table-layout\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" dt-instance=\"vm.dtInstance\" ms-responsive-table=\"\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Employee Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Mobile</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Branches</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Divisions</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Active</span></div></th><th class=\"secondary-text\" ng-if=\"vm.isMyobEnabled\"><div class=\"table-header\"><span class=\"column-title\">MYOB Employee</span></div></th><th class=\"secondary-text\" ng-if=\"vm.isXeroEnabled\"><div class=\"table-header\"><span class=\"column-title\">Xero Employee</span></div></th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts track by $index\"><td>{{contact.FirstName}} {{contact.LastName}}</td><td>{{contact.Email}}</td><td>{{contact.EmployeeCode}}</td><td>{{contact.Phone}}</td><td>{{contact.Branches.join(\", \")}}</td><td>{{contact.Divisions.join(\", \")}}</td><td>{{contact.IsActive === true ? \'Yes\' : \'No\'}}</td><td ng-if=\"vm.isMyobEnabled\"><md-autocomplete md-search-text=\"myobEmployee.searchText\" md-items=\"myobEmployee in vm.searchEmployeeByName(myobEmployee.searchText, vm.myobEmployees)\" md-item-text=\"vm.formatEmployeeName(myobEmployee)\" md-selected-item=\"contact.MyobEmployee\" md-min-length=\"0\" ng-disabled=\"!vm.isConnectedToMyob || vm.isMyobEmployeeDisabled\"><md-item-template><span>{{ vm.formatEmployeeName(myobEmployee) }}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></td><td ng-if=\"vm.isXeroEnabled\"><md-autocomplete md-search-text=\"xeroEmployee.searchText\" md-items=\"xeroEmployee in vm.searchEmployeeByName(xeroEmployee.searchText, vm.xeroEmployees)\" md-item-text=\"vm.formatEmployeeName(xeroEmployee)\" md-selected-item=\"contact.XeroEmployee\" md-min-length=\"0\" ng-disabled=\"!vm.isConnectedToXero || vm.isXeroEmployeeDisabled\"><md-item-template><span>{{ vm.formatEmployeeName(xeroEmployee) }}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/reporting/view/view-reports-filter-dialog.html","<md-dialog flex=\"30\" id=\"reports-project\"><form name=\"reportForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"REPORTING.REPORTS_FILTER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelDialog()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><div layout=\"row\" layout-lt-lg=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><label translate=\"REPORTING.REPORT_TYPE\"></label><md-select ng-model=\"vm.searchCriteria.ReportType\" ng-change=\"vm.onReportTypeChange()\" name=\"ReportType\" ng-required=\"true\"><md-option ng-value=\"type.Id\" ng-repeat=\"type in vm.lookups.ReportTypes | orderBy:\'Name\'\">{{type.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-lt-lg=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><label translate=\"REPORTING.BRANCHES\"></label><md-select ng-model=\"vm.searchCriteria.Branches\" id=\"dashboardBranch\" placeholder=\"{{\'REPORTING.BRANCHES\' | translate}}\" md-selected-text=\"vm.getSelectedText(vm.searchCriteria.Branches, vm.utilService.translate(\'REPORTING.BRANCHES\'), \'Name\')\" multiple=\"\" ng-change=\"vm.onBranchChange()\" ng-required=\"vm.canSelectEmployee\"><md-optgroup label=\"{{\'REPORTING.STATES\' | translate}}\"><md-option ng-value=\"branch.Id + \'-state\'\" ng-repeat=\"branch in vm.lookups.branches| filter: {\'State\': \'!\'}| orderBy:[\'Name\'] as _states track by $index + \'-\' + branch.Id + \'-state\'\">{{branch.Name}}</md-option></md-optgroup><md-optgroup label=\"{{\'REPORTING.BRANCHES\' | translate}}\"><md-option ng-value=\"branch.Id\" ng-repeat=\"branch in vm.lookups.branches| filter: {\'State\': \'\'}| orderBy:[\'Name\'] as _branches track by $index + \'-\' + branch.Id\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div ng-show=\"vm.showRequiredSkills\" layout=\"row\" layout-lt-lg=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><label translate=\"REPORTING.SKILLS\"></label><md-select ng-model=\"vm.searchCriteria.RequiredSkills\" placeholder=\"{{\'REPORTING.SKILLS\' | translate}}\" multiple=\"\"><md-optgroup label=\"{{parentSkill}}\" ng-repeat=\"parentSkill in vm.parentSkills\"><md-option ng-value=\"skill.id\" ng-repeat=\"skill in vm.requiredSkills | filter: {ParentName: parentSkill} | orderBy:[\'SkillName\'] as _requiredskills track by $index + \'-\' + skill.id\">{{skill.SkillName}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container ng-hide=\"vm.canSelectEmployee || !vm.showClient\" flex=\"\"><md-chips ng-model-options=\"{debounce : 1500}\" ng-model=\"vm.searchCriteria.Companies\" md-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\" md-on-add=\"vm.onCompanyChange($chip)\" md-on-remove=\"vm.onCompanyRemove($chip)\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" placeholder=\"{{\'REPORTING.CLIENT\' | translate}}\" md-item-text=\"item.Name\"><span md-highlight-text=\"vm.searchText\">{{item.Name}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.Name}}</strong></span></md-chip-template></md-chips></md-input-container><md-input-container ng-show=\"vm.canSelectEmployee\" flex=\"\"><md-chips name=\"Employees\" ng-model-options=\"{debounce : 1500}\" ng-model=\"vm.searchCriteria.Employees\" md-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\" md-on-add=\"vm.onEmployeeChange($chip)\" md-on-remove=\"vm.onEmployeeRemove($chip)\" md-max-chips=\"vm.maxEmployeeLimit\"><md-autocomplete md-selected-item=\"vm.selectedEmployee\" md-search-text=\"vm.searchEmployeeText\" md-items=\"item in vm.querySearch(vm.searchEmployeeText)\" placeholder=\"{{\'REPORTING.EMPLOYEE\' | translate}}\" md-item-text=\"vm.getEmployeeName(item)\" ng-hide=\"vm.reachedMaxLimit\"><span md-highlight-text=\"vm.searchEmployeeText\">{{vm.getEmployeeName(item)}}</span></md-autocomplete><md-chip-template><span><strong>{{vm.getEmployeeName($chip)}}</strong></span></md-chip-template></md-chips></md-input-container><div layout=\"row\"><md-input-container flex=\"\"><md-select name=\"projects\" ng-model=\"vm.searchCriteria.Projects\" placeholder=\"Project(s)\" ,=\"\" multiple=\"\"><md-optgroup label=\"Projects(s)\"><md-option ng-value=\"project.id\" ng-repeat=\"project in vm.projectList | orderBy:[\'Name\'] as _projects track by $index + \'-\' + project.id\">{{project.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" ng-show=\"vm.showPayrollDataOptions\" layout-lt-lg=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><label translate=\"REPORTING.SELECT_DATA\"></label><md-select ng-model=\"vm.searchCriteria.ShouldUseTemporaryInterpretedShift\" name=\"SelectedData\"><md-option ng-value=\"option.Id\" ng-repeat=\"option in vm.payrollDataOptions\" ng-selected=\"option.IsDefault\">{{option.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.searchCriteria.ReportType == vm.reportType.vehicleUtilisation\"><md-input-container flex=\"\"><label translate=\"REPORTING.ITEM_TYPES\"></label><md-select name=\"itemTypes\" ng-model=\"vm.searchCriteria.ItemTypes\" placeholder=\"{{\'REPORTING.ITEM_TYPES\' | translate}}\" ,=\"\" multiple=\"\"><md-optgroup label=\"{{\'REPORTING.ITEM_TYPES\' | translate}}\"><md-option ng-value=\"itemType.TypeName\" ng-repeat=\"itemType in vm.itemTypeList | orderBy:[\'id\'] as itemTypes track by $index + \'-\' + itemType.id\">{{itemType.TypeName}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-lt-lg=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><div flex=\"\" layout=\"row\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"REPORTING.START_DATE\"></label><md-datepicker ng-model=\"vm.searchCriteria.StartDate\" ng-required=\"vm.dateRangeRequired\" ng-change=\"vm.onReportStartDateChange()\" md-min-date=\"vm.searchCriteria.MinStartDate\" layout=\"row\" flex=\"\"></md-datepicker></md-input-container></div><div flex=\"\" layout=\"row\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"REPORTING.END_DATE\"></label><md-datepicker ng-model=\"vm.searchCriteria.EndDate\" ng-required=\"vm.dateRangeRequired\" layout=\"row\" md-max-date=\"vm.searchCriteria.MaxEndDate\" ng-change=\"vm.onReportEndDateChange()\" flex=\"\"></md-datepicker></md-input-container></div></div><md-input-container ng-if=\"vm.searchCriteria.ReportType == vm.reportType.ticketTagged\" flex=\"\"><md-chips ng-model-options=\"{debounce : 1500}\" ng-model=\"vm.searchCriteria.Tags\" md-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\" md-on-add=\"vm.appendTagChip($chip)\" md-on-remove=\"vm.removeTagChip($chip)\" placeholder=\"{{\'REPORTING.TAGS\' | translate}}\"><md-autocomplete #tagautocmp=\"\" md-selected-item=\"vm.selectedTagItem\" md-search-text=\"vm.searchTagText\" md-items=\"item in vm.queryTagSearch(vm.searchTagText)\" placeholder=\"{{\'REPORTING.TAGS_PLACEHOLDER\' | translate}}\" md-item-text=\"item.Name\" style=\"width: 100%;\" md-min-length=\"0\" md-no-cache=\"true\"><span md-highlight-text=\"vm.searchTagText\">{{item.Name}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.Name}}</strong></span></md-chip-template></md-chips></md-input-container><md-input-container ng-if=\"vm.searchCriteria.ReportType == vm.reportType.ticketTagged\" flex=\"\"><md-chips ng-model-options=\"{debounce : 1500}\" ng-model=\"vm.searchCriteria.ExcludeTags\" md-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\" md-on-add=\"vm.appendTagChip($chip)\" md-on-remove=\"vm.removeTagChip($chip)\" placeholder=\"{{\'REPORTING.EXCLUDE_TAGS\' | translate}}\"><md-autocomplete #tagautocmp=\"\" md-selected-item=\"vm.selectedExcludeTagItem\" md-search-text=\"vm.searchExcludeTagText\" md-items=\"item in vm.queryTagSearch(vm.searchExcludeTagText)\" placeholder=\"{{\'REPORTING.TAGS_PLACEHOLDER\' | translate}}\" md-item-text=\"item.Name\" style=\"width: 100%;\" md-min-length=\"0\" md-no-cache=\"true\"><span md-highlight-text=\"vm.searchExcludeTagText\">{{item.Name}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.Name}}</strong></span></md-chip-template></md-chips></md-input-container><md-input-container ng-if=\"vm.reportOptions().showIncludeTravel\" flex=\"\"><md-checkbox ng-model=\"vm.searchCriteria.IncludeTravel\" style=\"margin-bottom: unset !important;\">Include Travel</md-checkbox><br><span class=\"warning-label\" translate=\"REPORTING.INCLUDE_TRAVEL_INFO\"></span></md-input-container><md-input-container ng-if=\"vm.reportOptions().showIncludeInactiveEmployees\" flex=\"\"><md-checkbox ng-model=\"vm.searchCriteria.IncludeInactiveEmployee\" style=\"margin-bottom: unset !important;\">Include Inactive Employees</md-checkbox><br></md-input-container><md-input-container ng-if=\"vm.reportOptions().showIncludeBreakInShiftTotal\" flex=\"\"><md-checkbox ng-model=\"vm.searchCriteria.IncludeBreakInShiftTotal\" style=\"margin-bottom: unset !important;\">Include Break in Shift Total</md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-accent\" translate=\"REPORTING.BUILD\" ng-click=\"vm.buildReport()\" ng-disabled=\"reportForm.$invalid\"></md-button><md-button class=\"md-raised\" translate=\"REPORTING.CANCEL\" ng-click=\"vm.cancelDialog()\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/reporting/view/view_reports.html","<div id=\"invoice-report\" class=\"page-layout carded left-sidenav main-style\" layout=\"row\"><div class=\"ml-20 mt-20 mb-20\" flex=\"25\" layout=\"column\" id=\"report-jobs\"><div class=\"layout-align-start-center\"><md-button class=\"ml-0 pl-10 pr-10 md-accent md-raised\" aria-label=\"PDF\" translate=\"REPORTING.SHOW_FILTERS\" ng-if=\"!vm.service.initializing\" ng-click=\"vm.service.showFilters()\"></md-button></div><div class=\"instruction-note pt-15 pb-10 mb-caption\" ng-if=\"vm.service.reportJobs.length > 0\"><label>The generated reports will be retained for 7 days.</label></div><div ms-scroll=\"\" ng-if=\"vm.service.reportJobs.length > 0\"><div ng-repeat=\"reportJob in vm.service.reportJobs\" layout=\"column\" class=\"white-bg md-whiteframe-2dp pl-20 pr-20 pb-20 mt-10 mb-10\" ng-class=\"{\'current-report-job\': reportJob.Id === vm.service.selectedReportJob.Id}\"><div layout=\"row\" style=\"border-bottom: solid;\" ng-class=\"{\'report-job-queued\': reportJob.JobStatus === \'Queued\', \'report-job-generated\': reportJob.JobStatus === \'Generated\', \'report-job-failed\': reportJob.JobStatus === \'Failed\'}\" layout-align=\"center center\"><h4 flex=\"auto\"><strong>{{reportJob.ReportName}}</strong></h4><span flex=\"15\" layout-align=\"center center\"><md-button class=\"md-icon-button margin-left-0 padding-left-0\" ng-click=\"vm.service.deleteReportJob(reportJob.Id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></span></div><div layout=\"row\" class=\"pt-20 pb-10\" layout-align=\"center center\"><div layout=\"column\" flex=\"auto\"><div ng-if=\"reportJob.hasStartDate && reportJob.hasEndDate\">Date range: {{reportJob.Filters.StartDate}} - {{reportJob.Filters.EndDate}}</div><div>{{reportJob.JobStatus}} on {{reportJob.StatusUpdatedOn}}</div><div ng-if=\"reportJob.isHoursWorkedReport\">Includes Travel: {{reportJob.hasTravelIncluded}}</div><div ng-if=\"reportJob.isHoursWorkedReport\">Includes Inactive Employee: {{reportJob.hasInactiveEmployeeIncluded}}</div><div ng-if=\"reportJob.showIncludeBreakInShiftTotal\">Includes Break: {{reportJob.includeBreakInShiftTotal}}</div></div><div flex=\"10\" layout-align=\"center center\" ng-if=\"reportJob.JobStatus === \'Queued\'\"><md-progress-circular md-mode=\"indeterminate\" layout-align=\"center center\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></div><div flex=\"15\" layout-align=\"center center\" ng-if=\"reportJob.JobStatus === \'Failed\'\"><md-button class=\"md-icon-button md-accent\" layout-align=\"center center\" ng-click=\"vm.service.requeueReportJob(reportJob.Id)\"><md-icon md-font-icon=\"icon-replay\"></md-icon></md-button></div><div flex=\"30\" layout-align=\"end center\" ng-if=\"reportJob.JobStatus === \'Generated\'\"><a class=\"md-button\" ng-if=\"reportJob.ReportExcelUrl\" href=\"{{reportJob.ReportExcelUrl}}\">Download</a><md-button class=\"md-accent md-raised\" layout-align=\"center center\" ng-click=\"vm.service.loadReportInGrid(reportJob.Id)\">View</md-button></div></div></div></div><div ng-if=\"vm.service.reportJobs.length < 1\" class=\"pt-20\"><div>There are no reports to display.</div><div>Recently generated reports will be displayed here.</div></div></div><div class=\"center\" layout=\"column\" flex=\"\"><div ng-if=\"vm.service.selectedReportJob.ReportData\" class=\"header\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"search-wrapper md-whiteframe-2dp\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.service.searchQuery\" ng-change=\"vm.service.searchTable()\" type=\"text\" placeholder=\"{{\'REPORTING.SEARCH\' | translate}}\"></div></div></div><div class=\"content-card mb-20\" ng-class=\"{\'mt-20\': !vm.service.selectedReportJob.ReportData}\" flex=\"auto\" layout=\"column\"><div class=\"toolbar \'toolbar-content\'\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div layout=\"row\" layout-align=\"start center space-between\" flex=\"\"><span class=\"md-caption\" ng-if=\"vm.service.toolbarText\"><b>{{vm.service.toolbarText}} &nbsp; &nbsp;</b></span><div layout=\"row\" ng-if=\"vm.service.selectedReportJob.ReportData.Rows.length > 0\" layout-align=\"end center\" flex=\"\"><md-button class=\"md-icon-button first-button-margin\" ng-if=\"!vm.service.initializing\" ng-click=\"vm.copyContent()\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><md-tooltip><span translate=\"REPORTING.BTN_COPY\"></span></md-tooltip></md-button><md-button class=\"md-icon-button button-margin\" ng-if=\"!vm.service.initializing\" ng-click=\"vm.exportToExcelFile()\"><md-icon md-font-icon=\"icon-file-excel-box\"></md-icon><md-tooltip><span translate=\"REPORTING.BTN_EXPORT_EXCEL\"></span></md-tooltip></md-button><md-button class=\"md-icon-button button-margin\" ng-if=\"!vm.service.initializing\" ng-click=\"vm.print()\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip><span translate=\"REPORTING.BTN_PRINT\"></span></md-tooltip></md-button></div></div><div ng-if=\"vm.service.selectedReportJob.ReportData != null && vm.service.selectedReportJob.ReportData.Headings\"><md-switch ng-model=\"vm.service.selectedReportJob.showWidgets\" aria-label=\"Show Details\">{{\'REPORTING.SHOW_DETAILS\' | translate}}</md-switch></div></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.service.initializing\" class=\"md-accent\"></md-progress-linear><headings-component ng-if=\"vm.service.selectedReportJob.ReportData.Headings && vm.service.selectedReportJob.showWidgets\" ng-model=\"vm\" ng-service=\"vm.service\"></headings-component><div layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.service.selectedReportJob.ReportData\"><div><i class=\"icon icon-file-document grey-200-fg\" style=\"font-size : 800px;\"></i></div></div><md-content class=\"md-default-theme\" ms-scroll=\"\"><div layout=\"column\"><view-reports-component data=\"vm.service.selectedReportJob.ReportData\" ng-if=\"vm.service.selectedReportJob.ReportData != null\" watch-depth=\"value\" haslink=\"vm.service.hasLink\" viewdetails=\"vm.showDetails\"></view-reports-component></div></md-content></div></div></div>");
$templateCache.put("app/main/rateCardSettings/timesheets/timesheets.html","<div class=\"page-layout simple fullwidth ratecard-timesheets\" ng-if=\"!rateCardTimesheets.isCreateRatecardTimesheetActive\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"rateCardTimesheets.delay\" source=\"rateCardTimesheets.dataGrid.grid.searchTerm\" layout-margin=\"\" flex=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\" flex-offset=\"95\" flex=\"5\" class=\"create-btn-holder\"><md-button ng-click=\"rateCardTimesheets.showCreateRateCardTimesheet()\" class=\"md-fab md-mini md-accent pull-right create-ratecard-timesheets-btn\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'RATECARD_V2.MAIN_TIMESHEETS_FORM_HEADER\' | translate}}</md-tooltip></md-icon></md-button></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"rateCardTimesheets.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.MAIN_TIMESHEETS_FORM_NAME\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.MAIN_TIMESHEETS_FORM_BREAK_TYPE\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.MAIN_ACTIONS\' | translate}}</span></div></th></thead><tbody><tr ng-repeat=\"timesheet in rateCardTimesheets.dataGrid.grid.data track by $index\"><td class=\"text-left\">{{timesheet.Name}}</td><td class=\"text-left header-codes\">{{ timesheet.Tag }}</td><td><md-button class=\"md-icon-button\" ng-click=\"rateCardTimesheets.showCreateRateCardTimesheet(timesheet)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"rateCardTimesheets.removeTimesheet(timesheet)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"rateCardTimesheets.dataGrid.grid.behavior\" distinct-by=\"InvoiceNumber\" on-init=\"rateCardTimesheets.dataGrid.grid.onInit()\" on-error=\"rateCardTimesheets.dataGrid.grid.onError(ex)\" on-completed=\"rateCardTimesheets.dataGrid.grid.onCompleted(data)\" on-data-filter=\"rateCardTimesheets.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></md-card></div></div></div></div></div><div class=\"page-layout simple fullwidth ratecard-timesheets\" ng-if=\"rateCardTimesheets.isCreateRatecardTimesheetActive\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><form name=\"createTimesheetForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div layout=\"row\" layout-wrap=\"\"><h2 flex=\"100\" ng-if=\"!rateCardTimesheets.isEditRatecardTimesheetActive\">{{\'RATECARD_V2.MAIN_TIMESHEETS_FORM_HEADER\' | translate}}</h2><h2 flex=\"100\" ng-if=\"rateCardTimesheets.isEditRatecardTimesheetActive\">{{\'RATECARD_V2.MAIN_TIMESHEETS_EDIT_FORM_HEADER\' | translate}}</h2></div><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARD_V2.MAIN_TIMESHEETS_FORM_NAME\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><input name=\"timesheetName\" ng-model=\"rateCardTimesheets.formData.Name\" required=\"\"><div ng-messages=\"createTimesheetForm.timesheetName.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-radio-group ng-model=\"rateCardTimesheets.formData.AdjustmentType\"><md-radio-button ng-repeat=\"timesheetType in rateCardTimesheets.timesheetTypesLookup\" ng-value=\"timesheetType.Id\" aria-label=\"{{timesheetType.Name}}\">{{ timesheetType.Name }}</md-radio-button></md-radio-group></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-show=\"rateCardTimesheets.formData.AdjustmentType == 1\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARD_V2.MAIN_TIMESHEETS_FORM_BREAK_HOURS\' | translate}}</label><md-input-container flex=\"10\" class=\"mt-0 mb-20\"><input name=\"breakHours\" ng-model=\"rateCardTimesheets.formData.AdjustmentDecimalValue\" ng-required=\"rateCardTimesheets.formData.AdjustmentType == 1\" ng-pattern=\"/^[0-9]+([,.][0-9]+)?$/\"> <span flex=\"10\" layout=\"row\" layout-align=\"center center\">{{\'RATECARD_V2.MAIN_HRS_LABEL\' | translate}}</span><div ng-messages=\"createTimesheetForm.breakHours.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"pattern\">Invalid {{\'RATECARD_V2.MAIN_TIMESHEETS_FORM_BREAK_HOURS\' | translate}} Format</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-show=\"rateCardTimesheets.formData.AdjustmentType == 1\"><fieldset class=\"standard\" flex=\"100\"><legend><b>{{\'RATECARD_V2.MAIN_ALLOWANCES_FORM_CONDITIONS\' | translate}}</b></legend><condition-component layout-margin=\"\" flex=\"\" condition-src=\"conditionsArray\" condition-lookups=\"rateCardTimesheets.timesheetConditionsLookup\" condition-name-hidden=\"true\"></condition-component></fieldset></div><div layout=\"row\" layout-wrap=\"\"><md-dialog-actions layout=\"row\" ng-if=\"rateCardTimesheets.isCreateRatecardTimesheetActive && !rateCardTimesheets.isEditRatecardTimesheetActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardTimesheets.createTimesheet()\" ng-disabled=\"!createTimesheetForm.$valid || (createConditionForm && !createConditionForm.$valid)\">{{\'RATECARD_V2.MAIN_ADD\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" ng-if=\"rateCardTimesheets.isEditRatecardTimesheetActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardTimesheets.updateTimesheet()\" ng-disabled=\"!createTimesheetForm.$valid || (createConditionForm && !createConditionForm.$valid)\">{{\'RATECARD_V2.MAIN_SAVE\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-body-2\" ng-click=\"rateCardTimesheets.toggleTimesheetCreate()\">{{\'RATECARD_V2.MAIN_CANCEL\' | translate}}</md-button></md-dialog-actions></div></div></form></div></div></div></div>");
$templateCache.put("app/main/ratecards/partials/_ratecard-pricing-bulkchange.html","<md-dialog flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\" flex=\"\"><h2>{{\'RATECARDS.MAIN_PRICING_CHANGE\' | translate}}</h2><md-button class=\"md-icon-button pull-right\" ng-click=\"rateCardPricing.closePricingModal()\"><md-icon class=\"pull-right\" md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\" ng-click=\"rateCardPricing.closePricingModal()\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-0\"><div class=\"layout-gt-sm-row layout-row\" ng-if=\"vm.hasError\">{{ vm.errorMessage }}</div><form name=\"changePricingByBulkForm\"><div layout=\"row\" layout-wrap=\"\"><div flex-offset=\"40\" flex=\"20\"><div flex=\"\"><md-input-container layout-align=\"center center\" pull-left=\"\"><input flex=\"\" name=\"bulkPricePercentage\" ng-model=\"rateCardPricing.bulkChangePercentage\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" type=\"number\"></md-input-container></div></div><div flex=\"20\" layout-align=\"center center\"><div flex=\"\" layout=\"row\" layout-align=\"center center\" pull-left=\"\">%</div></div><div flex-offset=\"10\" flex=\"40\" ng-repeat=\"sheet in rateCardPricing.getAvailableSheets()\"><div flex=\"\"><md-checkbox class=\"md-raised md-accent pull-left\" ng-click=\"rateCardPricing.toggleSheetSelection(sheet.WorksheetType)\" value=\"{{sheet.WorksheetType}}\">{{ sheet.WorksheetName }}</md-checkbox></div></div></div><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-body-2\" ng-click=\"rateCardPricing.closePricingModal()\">{{\'RATECARDS.MAIN_CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardPricing.computeBulkPrice()\" ng-disabled=\"!rateCardPricing.hasSelectedSheet() || changePricingByBulkForm.bulkPricePercentage.$invalid\">{{\'RATECARDS.MAIN_OK\' | translate}}</md-button></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ratecards/pricing/ratecard-pricing.html","<div class=\"page-layout simple fullwidth ratecard-pricing\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div class=\"form-wrapper flex-100\"><label ng-show=\"!rateCardPricing.hasSelectedRatecard()\">{{\'RATECARDS.MAIN_PRICING_RATECARDS_LABEL\' | translate}}</label><div class=\"layout-gt-sm-row layout-row\"><md-input-container flex=\"100\"><label>{{\'RATECARDS.MAIN_PRICING_RATECARDS_LIST\' | translate}}</label><md-select ng-model=\"rateCardPricing.selectedRatecard\" ng-change=\"rateCardPricing.updateSpreadsheet(rateCardPricing.selectedRatecard)\"><md-option ng-value=\"rc.Id\" ng-repeat=\"rc in rateCardPricing.ratecards\" required=\"\">{{rc.Name}}</md-option></md-select></md-input-container></div></div></div></div><div class=\"p-20\" layout=\"row\" layout-wrap=\"\" ng-show=\"rateCardPricing.hasSelectedRatecard()\"><div flex=\"100\" layout=\"row\"><div flex=\"\"><md-button class=\"md-raised md-accent pull-left\" ng-click=\"rateCardPricing.saveRatecardPricing()\">{{\'RATECARDS.MAIN_SAVE\' | translate}}</md-button></div><div flex=\"\" class=\"text-right\"><md-button class=\"md-raised md-accent pull-right\" ng-click=\"rateCardPricing.launchPricingModal()\">{{\'RATECARDS.MAIN_PRICING_BULK_CHANGE\' | translate}}</md-button></div></div><div flex=\"100\"><div flex=\"\"><wj-flex-sheet class=\"ratecard-pricing-flexsheet\" control=\"rateCardPricing.flexSheet\" initialized=\"rateCardPricing.initFlexsheet(s)\" ng-cloak=\"\"></wj-flex-sheet></div></div></div></md-card></div></div>");
$templateCache.put("app/main/rateCardSettings/packages/packages.html","<div class=\"page-layout simple fullwidth ratecard-allowances\" ng-if=\"!rateCardPackages.isCreateRatecardPackageActive\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"rateCardPackages.delay\" source=\"rateCardPackages.dataGrid.grid.searchTerm\" layout-margin=\"\" flex=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\" flex-offset=\"95\" flex=\"5\" class=\"create-btn-holder\"><md-button ng-click=\"rateCardPackages.showCreateRateCardPackage()\" class=\"md-fab md-mini md-accent pull-right create-ratecard-allowances-btn\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'RATECARD_V2.MAIN_PACKAGES_FORM_HEADER\' | translate}}</md-tooltip></md-icon></md-button></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"rateCardPackages.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.MAIN_PACKAGES_FORM_NAME\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.MAIN_ACTIONS\' | translate}}</span></div></th></thead><tbody><tr ng-repeat=\"package in rateCardPackages.dataGrid.grid.data track by $index\"><td class=\"text-left\">{{package.Name}}</td><td><md-button class=\"md-icon-button\" ng-click=\"rateCardPackages.showCreateRateCardPackage(package)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"rateCardPackages.removePackage(package.Id)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"rateCardPackages.dataGrid.grid.behavior\" distinct-by=\"Name\" on-init=\"rateCardPackages.dataGrid.grid.onInit()\" on-error=\"rateCardPackages.dataGrid.grid.onError(ex)\" on-completed=\"rateCardPackages.dataGrid.grid.onCompleted(data)\" on-data-filter=\"rateCardPackages.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></md-card></div></div></div></div></div><div class=\"page-layout simple fullwidth ratecard-packages\" ng-if=\"rateCardPackages.isCreateRatecardPackageActive\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><form name=\"createPackageForm\" a8-dirty-form-confirmation=\"\"><div class=\"form-wrapper flex-100\"><div layout=\"row\" layout-wrap=\"\"><h2 flex=\"100\" ng-if=\"!rateCardPackages.isEditRatecardPackageActive\">{{\'RATECARD_V2.MAIN_PACKAGES_FORM_HEADER\' | translate}}</h2><h2 flex=\"100\" ng-if=\"rateCardPackages.isEditRatecardPackageActive\">{{\'RATECARD_V2.MAIN_PACKAGES_EDIT_FORM_HEADER\' | translate}}</h2></div><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARD_V2.MAIN_PACKAGES_FORM_NAME\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><input name=\"packageName\" ng-model=\"rateCardPackages.formData.PackageName\" required=\"\"><div ng-messages=\"createPackageForm.packageName.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-input-container flex=\"100\" class=\"mt-0 mb-20 btn-add-package-group\"><md-button ng-click=\"rateCardPackages.addPackageGroupTemplate()\">{{\'RATECARD_V2.MAIN_PACKAGES_FORM_ADD_GROUP\' | translate}}</md-button></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><div id=\"package-group-wrap\" flex=\"100\"></div></div><div layout=\"row\" layout-wrap=\"\"><md-dialog-actions layout=\"row\" ng-if=\"rateCardPackages.isCreateRatecardPackageActive && !rateCardPackages.isEditRatecardPackageActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardPackages.createPackage()\" ng-disabled=\"createPackageForm.packageName.$invalid || (addPackageItemForm && !addPackageItemForm.$valid)\">{{\'RATECARD_V2.MAIN_ADD\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" ng-if=\"rateCardPackages.isEditRatecardPackageActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardPackages.updatePackage()\" ng-disabled=\"(!createPackageForm.$valid && createPackageForm.$touched ) || (addPackageItemForm && !addPackageItemForm.$valid && addPackageItemForm.$touched)\">{{\'RATECARD_V2.MAIN_SAVE\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-body-2\" ng-click=\"rateCardPackages.togglePackageCreate()\">{{\'RATECARD_V2.MAIN_CANCEL\' | translate}}</md-button></md-dialog-actions></div></div></form></div></div></div></div>");
$templateCache.put("app/main/skillsmatrix/manage/skillsmatrix-manage.html","<div id=\"skillsmatrix-project\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button translate=\"SKILLS.MAIN_VIEW_CREATE_A_NEW_SKILL_GROUP\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vm.addSkillGroup()\"></md-button></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><div class=\"card task-item md-whiteframe\" layout=\"column\" flex=\"\"><md-progress-linear ng-if=\"vm.service.saving\" md-mode=\"indeterminate\" class=\"md-hue-2\"></md-progress-linear><div><md-card layout-padding=\"\" layout-margin=\"\" class=\"md-whiteframe-1dp\" flex=\"100\" ng-repeat=\"skillGroup in vm.service.skillsMatrixGroups\"><md-card-header><md-card-header-text><h3 class=\"md-title\" inline-edit=\"skillGroup.GroupName\" inline-edit-callback=\"vm.editSkillGroupHeader(newValue, skillGroup)\" inline-edit-placeholder=\"{{\'SKILLS.MAIN_VIEW_SKILL_GROUP\' | translate}}\" inline-edit-btn-edit=\"\" inline-edit-on-blur=\"save\" inline-edit-on-click=\"\"></h3></md-card-header-text><div flex=\"10\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.addSkill(skillGroup, null, 0)\">{{\'SKILLS.MAIN_VIEW_ADD_SKILL\' | translate}}</md-button></div></md-card-header><md-content ms-scroll=\"\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'SKILLS.MAIN_VIEW_SKILL_NAME\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'SKILLS.MAIN_VIEW_PROTECTED\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'SKILLS.MAIN_VIEW_EXPIRATION_DATE\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'SKILLS.MAIN_VIEW_COMPANY_REQUIRED\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'SKILLS.MAIN_VIEW_ACTIONS\' | translate}}</th></thead><tbody><tr class=\"task-item\" ng-repeat=\"skill in skillGroup.Skills\"><td class=\"text-left\">{{skill.SkillName}}</td><td>{{skill.IsProtected ? vm.utilService.translate(\'SKILLS.MAIN_VIEW_YES\') : vm.utilService.translate(\'SKILLS.MAIN_VIEW_NO\')}}</td><td>{{skill.ExpiryIsMandatory ? vm.utilService.translate(\'SKILLS.MAIN_VIEW_YES\') : vm.utilService.translate(\'SKILLS.MAIN_VIEW_NO\')}}</td><td>{{skill.CompanyNotRequired ? vm.utilService.translate(\'SKILLS.MAIN_VIEW_NO\') : vm.utilService.translate(\'SKILLS.MAIN_VIEW_YES\')}}</td><td><md-button class=\"md-icon-button\" ng-if=\"!vm.service.saving\" ng-click=\"vm.editSkill(skillGroup, skill, 1)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"SKILLS.EDIT\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"!vm.service.saving\" ng-click=\"vm.removeSkill(skill.id, skillGroup)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"SKILLS.DELETE\"></span></md-tooltip></md-button></td></tr></tbody></table></md-content></md-card></div></div></div></div></div>");
$templateCache.put("app/main/training/manage/training-manage.html","<div class=\"page-layout simple fullwidth element-doc-page\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button translate=\"TRAININGS.MAIN_VIEW_CREATE_A_NEW_TRAINING_GROUP\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vm.addTrainingGroup()\"></md-button></div></div><div class=\"content\" layout=\"column\" md-scroll=\"\"><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\"><div><md-card class=\"md-whiteframe-1dp\" flex=\"100\" ng-repeat=\"trainingGroup in vm.service.trainingGroups\"><md-card-header><md-card-header-text><h3 class=\"md-title\" inline-edit=\"trainingGroup.GroupName\" inline-edit-callback=\"vm.editTrainingGroupHeader(newValue, trainingGroup)\" inline-edit-placeholder=\"{{\'TRAININGS.MAIN_VIEW_TRAINING_GROUP\' | translate}}\" inline-edit-btn-edit=\"\" inline-edit-on-blur=\"save\" inline-edit-on-click=\"\"></h3></md-card-header-text><div flex=\"auto\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.addTraining(trainingGroup, null, 0)\">{{\'TRAININGS.MAIN_VIEW_ADD_TRAINING\' | translate}}</md-button></div></md-card-header><md-content ms-scroll=\"\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'TRAININGS.MAIN_VIEW_TRAINING_NAME\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'TRAININGS.MAIN_VIEW_EXPIRATION_DATE\' | translate}}</th><th style=\"background-color: #f2f2f2;\" class=\"text-left\">{{\'TRAININGS.MAIN_VIEW_ACTIONS\' | translate}}</th></thead><tbody><tr ng-repeat=\"training in trainingGroup.Trainings\"><td class=\"text-left\">{{training.TrainingName}}</td><td>{{training.ExpiryIsMandatory ? vm.utilService.translate(\'TRAININGS.MAIN_VIEW_YES\') : vm.utilService.translate(\'TRAININGS.MAIN_VIEW_NO\')}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.editTraining(trainingGroup, training, 1)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>Edit Training</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeTraining(training.Id, trainingGroup)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span>Delete Training</span></md-tooltip></md-button></td></tr></tbody></table></md-content></md-card></div></div></div></div></div>");
$templateCache.put("app/main/tax/create-tax/create-tax.html","<div class=\"center ms-scroll layout-column flex ps-container ps-theme-default ps-active-y\" layout=\"column\"><div class=\"content\" layout=\"column\"><div class=\"\" layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\" ng-form=\"taxForm\"><md-card class=\"md-whiteframe-1dp\"><form name=\"taxForm\"><md-card-content class=\"m-0\"><div layout=\"column\" layout-align=\"start stretch\" flex=\"100\" ng-form=\"taxForm\"><div layout=\"row\" layout-gt-sm=\"row\" layout-align=\"start stretch\"><md-input-container flex=\"50\"><label>Tax Name</label> <input type=\"text\" name=\"search\" ng-model=\"vm.service.taxDataModel.Name\" required=\"\"></md-input-container><md-input-container flex=\"50\"><label>Tax Rate %</label> <input type=\"number\" name=\"search\" ng-model=\"vm.service.taxDataModel.Rate\" required=\"\"></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\" layout-align=\"start stretch\"><md-input-container id=\"applyTo\"><label translate=\"Where do you want to apply this to?\"></label><md-select placeholder=\"Where do you want to apply this to?\" ng-model=\"vm.service.taxDataModel.TaxApplyTo\" ng-change=\"vm.onTaxApplyToChange()\" ng-required=\"\"><md-option value=\"{{applyTo.Id}}\" ng-repeat=\"applyTo in vm.lookups.ApplyToResources\">{{applyTo.Name}}</md-option></md-select></md-input-container></div><div flex=\"100\" ng-if=\"vm.service.taxDataModel.TaxApplyTo == 1\" layout=\"column\" layout-align=\"start stretch\"><h3>Select Companies *</h3><md-input-container flex=\"100\"><label>Type a Company</label> <input type=\"text\" name=\"search\" ng-change=\"vm.searchCompanies(vm.searchCompany)\" ng-model=\"vm.searchCompany\" ng-model-options=\"{ debounce: 500 }\"></md-input-container><table class=\"dataTable row-border hover manage-taxrate-table\" datatable=\"ng\" dt-instance=\"vm.dtCompanyInstance\" dt-options=\"vm.dtOptions\"><thead><th class=\"text-center\" width=\"10%\"><div class=\"table-header text-center\"><md-checkbox ng-model=\"vm.service.taxDataModel.IsAppliedToAllCompanies\" ng-change=\"vm.toggleAllCompanies(vm.service.taxDataModel.IsAppliedToAllCompanies)\"></md-checkbox></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">Companies</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">Company Code</span></div></th></thead><tbody><tr ng-repeat=\"company in vm.filteredCompanies\"><td class=\"text-center\"><md-checkbox ng-model=\"company.IsChecked\" ng-change=\"vm.toggleCompanyItem(company)\"></md-checkbox></td><td class=\"text-left\">{{company.Name}}</td><td class=\"text-left\">{{company.CompanyCode}}</td></tr></tbody></table></div><div flex=\"100\" ng-if=\"vm.service.taxDataModel.TaxApplyTo == 2\" layout=\"column\" layout-align=\"start stretch\"><h3>Select Branches *</h3><md-input-container flex=\"100\"><label>Type a Branch</label> <input type=\"text\" name=\"search\" ng-change=\"vm.searchBranches(vm.searchBranch)\" ng-model=\"vm.searchBranch\" ng-model-options=\"{ debounce: 500 }\"></md-input-container><table class=\"dataTable row-border hover manage-taxrate-table\" datatable=\"ng\" dt-instance=\"vm.dtBranchesInstance\" dt-options=\"vm.dtOptions\"><thead><th class=\"text-center\" width=\"10%\"><div class=\"table-header text-center\"><md-checkbox ng-model=\"vm.service.taxDataModel.IsAppliedToAllBranches\" ng-change=\"vm.toggleAllBranches(vm.service.taxDataModel.IsAppliedToAllBranches)\"></md-checkbox></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">Branches</span></div></th></thead><tbody><tr ng-repeat=\"item in vm.filteredBranches\"><td class=\"text-center\"><md-checkbox ng-model=\"item.IsChecked\" ng-change=\"vm.toggleBranchItem(item)\"></md-checkbox></td><td class=\"text-left\">{{item.Name}}</td></tr></tbody></table></div><div flex=\"100\" ng-if=\"vm.service.taxDataModel.TaxApplyTo == 3\" layout=\"column\" layout-align=\"start stretch\"><h3>Select State/Province *</h3><md-input-container flex=\"100\"><label>Type a State</label> <input type=\"text\" name=\"search\" ng-change=\"vm.searchStates(vm.searchState)\" ng-model=\"vm.searchState\" ng-model-options=\"{ debounce: 500 }\"></md-input-container><table class=\"dataTable row-border hover manage-taxrate-table\" datatable=\"ng\" dt-instance=\"vm.dtStateInstance\" dt-options=\"vm.dtOptions\"><thead><th class=\"text-center\" width=\"10%\"><div class=\"table-header text-center\"><md-checkbox ng-model=\"vm.service.taxDataModel.IsAppliedToAllStates\" ng-change=\"vm.toggleAllStates(vm.service.taxDataModel.IsAppliedToAllStates)\"></md-checkbox></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">State/Provinces</span></div></th></thead><tbody><tr ng-repeat=\"item in vm.filteredStates\"><td class=\"text-center\"><md-checkbox ng-model=\"item.IsChecked\" ng-change=\"vm.toggleStateItem(item)\"></md-checkbox></td><td class=\"text-left\">{{item.Name}}</td></tr></tbody></table></div><div layout=\"column\" ng-if=\"vm.showTaxApplyTo()\" layout-align=\"start stretch\" flex=\"100\"><h3>Applied To</h3><md-checkbox ng-model=\"vm.service.taxDataModel.IsAppliedToAllItems\" ng-change=\"vm.toggleIsAppliedToAllItems(vm.service.taxDataModel.IsAppliedToAllItems)\">All Items</md-checkbox><md-checkbox ng-model=\"vm.service.taxDataModel.IsAppliedToAllShifts\" ng-change=\"vm.toggleIsAppliedToAllShifts(vm.service.taxDataModel.IsAppliedToAllShifts)\">All Shift Types</md-checkbox><md-checkbox ng-model=\"vm.service.taxDataModel.IsAppliedToAllPackages\" ng-change=\"vm.toggleIsAppliedToAllPackages(vm.service.taxDataModel.IsAppliedToAllPackages)\">All Packages</md-checkbox></div><div flex=\"100\" ng-if=\"vm.showAllItemsList()\" layout=\"column\" layout-align=\"start stretch\"><h3>Select Items *</h3><div layout=\"row\" layout-align=\"start stretch\"><md-input-container flex=\"100\"><label>Type an Item</label> <input type=\"text\" name=\"search\" ng-change=\"vm.searchItems(vm.searchItem,vm.filterType)\" ng-model=\"vm.searchItem\" ng-model-options=\"{ debounce: 500 }\"></md-input-container><md-select placeholder=\"Filter by Item Type\" ng-model=\"vm.filterType\" name=\"filterType\" flex=\"20\" ng-change=\"vm.searchItems(vm.searchItem, vm.filterType)\"><md-optgroup label=\"Filter by Item Type\"><md-option ng-value=\"filterType.Name\" ng-repeat=\"filterType in vm.lookups.ItemTypes\">{{filterType.Name}}</md-option></md-optgroup></md-select></div><table class=\"dataTable row-border hover manage-taxrate-table\" datatable=\"ng\" dt-instance=\"vm.dtItemsInstance\" dt-options=\"vm.dtOptions\"><thead><th class=\"text-center\" width=\"10%\"><div class=\"table-header text-center\"><md-checkbox ng-model=\"vm.allItemsChecked\" ng-change=\"vm.toggleCheckAllItems(vm.allItemsChecked)\"></md-checkbox></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">Items</span></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">Item Type</span></div></th></thead><tbody><tr ng-repeat=\"item in vm.filteredItems\"><td class=\"text-center\"><md-checkbox ng-model=\"item.IsChecked\" ng-change=\"vm.toggleItem(item)\"></md-checkbox></td><td class=\"text-left\">{{item.Name}}</td><td class=\"text-left\">{{item.Tag}}</td></tr></tbody></table></div><div flex=\"100\" ng-if=\"vm.showAllShiftsList()\" layout=\"column\" layout-align=\"start stretch\"><h3>Select Shift Types *</h3><md-input-container flex=\"100\"><label>Type a shift name</label> <input type=\"text\" name=\"search\" ng-change=\"vm.searchShiftTypes(vm.searchShiftType)\" ng-model=\"vm.searchShiftType\" ng-model-options=\"{ debounce: 500 }\"></md-input-container><table class=\"dataTable row-border hover manage-taxrate-table\" datatable=\"ng\" dt-instance=\"vm.dtShiftTypesInstance\" dt-options=\"vm.dtOptions\"><thead><th class=\"text-center\" width=\"10%\"><div class=\"table-header text-center\"><md-checkbox ng-model=\"vm.allShiftsChecked\" ng-change=\"vm.toggleCheckAllShifts(vm.allShiftsChecked)\"></md-checkbox></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">Shift Types</span></div></th></thead><tbody><tr ng-repeat=\"item in vm.filteredShiftTypes\"><td class=\"text-center\"><md-checkbox ng-model=\"item.IsChecked\" ng-change=\"vm.toggleShiftItem(item)\"></md-checkbox></td><td class=\"text-left\">{{item.Name}}</td></tr></tbody></table></div><div flex=\"100\" ng-if=\"vm.showAllPackagesList()\" layout=\"column\" layout-align=\"start stretch\"><h3>Select Packages *</h3><md-input-container flex=\"100\"><label>Type a package name</label> <input type=\"text\" name=\"search\" ng-change=\"vm.searchPackages(vm.searchPackage)\" ng-model=\"vm.searchPackage\" ng-model-options=\"{ debounce: 500 }\"></md-input-container><table class=\"dataTable row-border hover manage-taxrate-table\" datatable=\"ng\" dt-instance=\"vm.dtPackagetTypesInstance\" dt-options=\"vm.dtOptions\"><thead><th class=\"text-center\" width=\"10%\"><div class=\"table-header text-center\"><md-checkbox ng-model=\"vm.allPackagesChecked\" ng-change=\"vm.toggleCheckAllPackages(vm.allPackagesChecked)\"></md-checkbox></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">Package</span></div></th></thead><tbody><tr ng-repeat=\"item in vm.filteredPackages\"><td class=\"text-center\"><md-checkbox ng-model=\"item.IsChecked\" ng-change=\"vm.togglePackageItem(item)\"></md-checkbox></td><td class=\"text-left\">{{item.Name}}</td></tr></tbody></table></div></div><md-button type=\"button\" class=\"md-accent md-raised button-margin\" ng-if=\"vm.service.taxDataModel\" ng-disabled=\"taxForm.$invalid || vm.isDisabled()\" ng-click=\"vm.save()\">Save</md-button></md-card-content></form></md-card></div></div></div></div>");
$templateCache.put("app/main/useraccess/view/toolbar.html","<div class=\"toolbar md-whiteframe-2dp\"><div ng-if=\"!vm.service.loader\" class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent\" ng-disabled=\"vm.service.disableButton\" ng-click=\"vm.service.save()\">Save</md-button></div><div ng-if=\"vm.service.loader\" class=\"toolbar-wrapper\" style=\"height : 64px ; padding-top : 20px; padding-left : 20px;\"><span class=\"md-caption\"><table><tr><td><b>{{vm.service.loaderMessage}} &nbsp; &nbsp; &nbsp;</b></td><td><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.service.loader\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></td></tr></table></span></div></div>");
$templateCache.put("app/main/useraccess/view/useraccess-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/useraccess/view/toolbar.html\'\"></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div id=\"useraccess-view\" alyout=\"row\"><div layout=\"row\" ng-if=\"!vm.service.loader\" style=\"margin : 20px; padding-top : 20px;\" flex=\"\"><md-input-container><label>Select Access Type</label><md-select ng-model=\"vm.service.accessType\" ng-change=\"vm.service.getAccessFromAccessType(vm.service.accessType)\"><md-option ng-value=\"access\" ng-repeat=\"access in vm.service.accessGroups\">{{access}}</md-option></md-select></md-input-container></div><div flex=\"\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab ng-repeat=\"access in vm.service.accessTypeItems\" label=\"{{access.Name}}\" md-on-select=\"vm.service.changeTab(access)\"><md-content class=\"md-padding\"><md-toolbar md-scroll-shrink=\"\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h3><span>{{access.Name}}</span></h3></div></md-toolbar><div layout=\"row\" flex=\"\"><md-autocomplete style=\"margin-top : 20px;\" flex=\"50\" md-no-cache=\"true\" md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.service.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(vm.service.searchText)\" md-item-text=\"item.FullName\" md-min-length=\"0\" placeholder=\"Type name\"><md-item-template><span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.FullName}}</span></md-item-template><md-not-found>Nobody found</md-not-found></md-autocomplete><md-button class=\"md-raised md-accent\" style=\"margin : 20px;\" ng-click=\"vm.addUser()\">Add User</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\" datatable=\"ng\" style=\"margin-top :10px;\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Position</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th class=\"secondary-text\"></th></tr></thead><tbody><tr ng-repeat=\"contact in access.ContactIds | orderBy : \'FullName\' track by $index\" ng-if=\"vm.service.contactExists(contact)\"><td><b>{{vm.service.getContactInformation(contact, \"FullName\")}}</b></td><td>{{vm.service.getContactInformation(contact, \"Position\")}}</td><td>{{vm.service.getContactInformation(contact, \"Email\")}}</td><td>{{vm.service.getContactInformation(contact, \"Phone\")}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.removeUser(contact)\"><i class=\"icon icon-trash red-500-fg s15\"></i></md-button></td></tr></tbody></table></md-content></md-tab></md-tabs></div></div></div></div></div></div>");
$templateCache.put("app/main/vehicle/manage/vehicle-manage.1.html","<div class=\"page-layout simple fullwidth element-doc-page\"><div class=\"toolbar md-whiteframe-2dp\"></div><div class=\"content\" style=\"margin-top : 20px;\" flex=\"\" ms-scroll=\"\"><md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" ng-if=\"vm.service.loader\"></md-progress-linear><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"column\" flex=\"\"><div flex=\"10\"><md-button ng-click=\"vm.service.onCreate()\" style=\"position : relative; float : right; margin-right : 30px; margin-top : -20px;\" class=\"md-fab md-mini md-accent\" aria-label=\"Create Contact\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'VIEWCONTACTS.CREATE_CONTACT_TOOLTIP\' | translate}}</md-tooltip></md-icon></md-button></div><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Name\" field-label=\"Name\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tfoot><tr><td colspan=\"2\"></td></tr></tfoot><tbody><tr ng-repeat=\"item in [{\'Name\': \'Vehicle Make 1\'}, {\'Name\': \'Vehicle Make 2\'}] track by $index\"><td style=\"width: 90%\">{{item.Name}}</td><td style=\"width: 10%\"><md-button class=\"md-icon-button\" ng-click=\"vm.onEdit(item.Id, item.Name)\"><i class=\"icon icon-pencil teal-500-fg s15\"></i><md-tooltip><span>Edit Make</span></md-tooltip></md-button><md-button class=\"md-icon-button margin-5\" ng-click=\"vm.remove(item)\" style=\"margin-left: 0; padding-left: 0;\" aria-label=\"Delete sub category\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon icon-delete\"></md-icon><md-tooltip><span>Delete Make</span></md-tooltip></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"vm.dataGrid.grid.behavior\" on-init=\"vm.dataGrid.grid.onInit()\" on-error=\"vm.dataGrid.grid.onError(ex)\" on-completed=\"vm.dataGrid.grid.onCompleted(data)\" on-data-filter=\"vm.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div><div style=\"padding-top: 40px;\"></div><md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" ng-if=\"vm.service.loader\"></md-progress-linear><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"column\" flex=\"\"><div flex=\"10\"><md-button ng-click=\"vm.service.onCreate()\" style=\"position : relative; float : right; margin-right : 30px; margin-top : -20px;\" class=\"md-fab md-mini md-accent\" aria-label=\"Create Contact\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'VIEWCONTACTS.CREATE_CONTACT_TOOLTIP\' | translate}}</md-tooltip></md-icon></md-button></div><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Name\" field-label=\"Name\" default=\"true\" initial-default-dir=\"asc\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tfoot><tr><td colspan=\"2\"></td></tr></tfoot><tbody><tr ng-repeat=\"item in [{\'Name\': \'Vehicle Model 1\'}, {\'Name\': \'Vehicle Model 2\'}] track by $index\"><td style=\"width: 90%\">{{item.Name}}</td><td style=\"width: 10%\"><md-button class=\"md-icon-button\" ng-click=\"vm.onEdit(item.Id, item.Name)\"><i class=\"icon icon-pencil teal-500-fg s15\"></i><md-tooltip><span>Edit Model</span></md-tooltip></md-button><md-button class=\"md-icon-button margin-5\" ng-click=\"vm.remove(item)\" style=\"margin-left: 0; padding-left: 0;\" aria-label=\"Delete sub category\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon icon-delete\"></md-icon><md-tooltip><span>Delete Model</span></md-tooltip></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"vm.dataGrid.grid.behavior\" on-init=\"vm.dataGrid.grid.onInit()\" on-error=\"vm.dataGrid.grid.onError(ex)\" on-completed=\"vm.dataGrid.grid.onCompleted(data)\" on-data-filter=\"vm.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></div></div></div>");
$templateCache.put("app/main/vehicle/manage/vehicle-manage.html","<div class=\"page-layout simple fullwidth element-doc-page\"><div class=\"toolbar md-whiteframe-2dp\"></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><div><md-card class=\"md-whiteframe-1dp\" flex=\"100\"><md-card-header style=\"padding: 0 16px;\"><md-card-header-text><h3 class=\"md-title\">Vehicle Makes</h3></md-card-header-text><div flex=\"10\"><md-button ng-click=\"vm.addItem(\'Make\')\" style=\"position: relative; float: right; margin-right: 10px; margin-top: -20px;\" class=\"md-fab md-mini md-accent\" aria-label=\"{{\'VEHICLES.MAIN_VIEW_CREATE_A_NEW_VEHICLE_MAKE\' | translate}}\"><md-icon class=\"icon-plus\" style=\"font-size: 23px;\"><md-tooltip>{{\'VEHICLES.MAIN_VIEW_CREATE_A_NEW_VEHICLE_MAKE\' | translate}}</md-tooltip></md-icon></md-button></div></md-card-header><md-content ms-scroll=\"\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th style=\"background-color: #f2f2f2; width: 90%;\" class=\"text-left\">{{\'VEHICLES.MAIN_VIEW_VEHICLE_MAKE\' | translate}}</th><th style=\"background-color: #f2f2f2; width: 10%;\" class=\"text-left\">{{\'VEHICLES.MAIN_VIEW_ACTIONS\' | translate}}</th></thead><tbody><tr ng-repeat=\"data in vm.service.vehicleMakes\"><td class=\"text-left\" style=\"width: 90%;\">{{data.Value}}</td><td style=\"width: 10%;\"><md-button class=\"md-icon-button\" ng-click=\"vm.editVehicle(\'Make\', data)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>Edit Vehicle Make</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeVehicle(\'Make\', data.Id)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span>Delete Vehicle Make</span></md-tooltip></md-button></td></tr></tbody></table></md-content></md-card></div></div></div><div style=\"padding-top: 40px;\"></div><div layout=\"row\"><div class=\"card md-whiteframe\" layout=\"column\" flex=\"\" md-scroll=\"\"><div><md-card class=\"md-whiteframe-1dp\" flex=\"100\"><md-card-header style=\"padding: 0 16px;\"><md-card-header-text><h3 class=\"md-title\">Vehicle Models</h3></md-card-header-text><div flex=\"10\"><md-button ng-click=\"vm.addItem(\'Model\')\" style=\"position: relative; float: right; margin-right: 10px; margin-top: -20px;\" class=\"md-fab md-mini md-accent\" aria-label=\"{{\'VEHICLES.MAIN_VIEW_CREATE_A_NEW_VEHICLE_MODEL\' | translate}}\"><md-icon class=\"icon-plus\" style=\"font-size: 23px;\"><md-tooltip>{{\'VEHICLES.MAIN_VIEW_CREATE_A_NEW_VEHICLE_MODEL\' | translate}}</md-tooltip></md-icon></md-button></div></md-card-header><md-content ms-scroll=\"\"><table class=\"simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><th style=\"background-color: #f2f2f2; width: 90%;\" class=\"text-left\">{{\'VEHICLES.MAIN_VIEW_VEHICLE_MODEL\' | translate}}</th><th style=\"background-color: #f2f2f2; width: 10%;\" class=\"text-left\">{{\'VEHICLES.MAIN_VIEW_ACTIONS\' | translate}}</th></thead><tbody><tr ng-repeat=\"data in vm.service.vehicleModels\"><td class=\"text-left\" style=\"width: 90%;\">{{data.Value}}</td><td style=\"width: 10%;\"><md-button class=\"md-icon-button\" ng-click=\"vm.editVehicle(\'Model\', data)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>Edit Vehicle Model</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeVehicle(\'Model\', data.Id)\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span>Delete Vehicle Model</span></md-tooltip></md-button></td></tr></tbody></table></md-content></md-card></div></div></div></div></div>");
$templateCache.put("app/main/skilllevel/view/skill-level-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div ng-if=\"vm.service.loader\" class=\"toolbar-wrapper\" style=\"height : 64px ; padding-top : 20px; padding-left : 20px;\"><span class=\"md-caption\"><table><tr><td><b>{{vm.service.operationMessage}} &nbsp; &nbsp; &nbsp;</b></td><td><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.service.loader\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></td></tr></table></span></div><div ng-if=\"!vm.service.loader\" class=\"toolbar-wrapper\"><md-button translate=\"SKILLSLEVEL.ADD_BUTTON\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vm.service.showDialog(null, false)\"></md-button></div></div><div class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.query\" ng-keyup=\"vm.searchTable()\"></md-input-container></div></div><table class=\"dataTable row-border hover\" dt-instance=\"vm.dtInstance\" style=\"margin-top :10px;\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SKILLSLEVEL.COLUMN_NAME\"></span></div></th><th class=\"secondary-text\"></th></tr></thead><tbody><tr ng-repeat=\"skill in vm.service.skills_level\"><td>{{skill.Name}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.service.showDialog(skill, true)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon></md-button><delete-component index=\"skill.Id\" message=\"{{\'SKILLSLEVEL.DELETE_MESSAGE\' | translate}}\" callback=\"vm.service.deleteSkillsLevel\" section=\"{{\'SKILLSLEVEL.HEADER\' | translate}}\"></delete-component></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/ratecards/manage/ratecard-manage.html","<div class=\"page-layout simple fullwidth ratecard-manage\" ng-show=\"!rateCardManage.isCreateRatecardActive\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><div class=\"card md-whiteframe-1dp\" layout=\"column\" flex=\"\" md-scroll=\"\"><md-card class=\"md-whiteframe-1dp\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"rateCardManage.delay\" source=\"rateCardManage.dataGrid.grid.searchTerm\" layout-margin=\"\" flex=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\" flex-offset=\"95\" flex=\"5\" class=\"create-btn-holder\"><md-button ng-click=\"rateCardManage.showCreateRateCard()\" class=\"md-fab md-mini md-accent pull-right create-ratecminimumard-btn\"><md-icon class=\"icon-plus\" style=\"font-size : 23px;\"><md-tooltip>{{\'RATECARDS.MAIN_CREATE_RATECARD\' | translate}}</md-tooltip></md-icon></md-button></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"rateCardManage.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARDS.MAIN_VIEW_HEADER_NAME\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tfoot><tr><td colspan=\"9\"></td></tr></tfoot><tbody><tr ng-repeat=\"ratecard in rateCardManage.dataGrid.grid.data track by $index\"><td>{{ratecard.Name}}</td><td><md-button class=\"md-icon-button\" ng-click=\"rateCardManage.showCreateRateCard(ratecard)\"><i class=\"icon icon-pencil teal-500-fg s15\"></i></md-button><md-button class=\"md-icon-button\" ng-click=\"rateCardManage.showCreateRateCard(ratecard, true)\"><i class=\"icon icon-content-copy teal-500-fg s15\"></i></md-button></td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"rateCardManage.dataGrid.grid.behavior\" distinct-by=\"InvoiceNumber\" on-init=\"rateCardManage.dataGrid.grid.onInit()\" on-error=\"rateCardManage.dataGrid.grid.onError(ex)\" on-completed=\"rateCardManage.dataGrid.grid.onCompleted(data)\" on-data-filter=\"rateCardManage.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></md-card></div></div></div></div></div><div class=\"page-layout simple fullwidth ratecard-create\" ng-show=\"rateCardManage.isCreateRatecardActive\"><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\"><div flex=\"\"><form name=\"createRatecardForm\" a8-dirty-form-confirmation=\"\"><div layout=\"row\" layout-wrap=\"\"><h2 flex=\"100\" ng-if=\"!rateCardManage.isEditRatecardActive\">{{\'RATECARDS.MAIN_CREATE_RATECARD\' | translate}}</h2><h2 flex=\"100\" ng-if=\"rateCardManage.isEditRatecardActive && !rateCardManage.isCloneRatecardActive\">{{\'RATECARDS.MAIN_EDIT_RATECARD\' | translate}}</h2><h2 flex=\"100\" ng-if=\"rateCardManage.isEditRatecardActive && rateCardManage.isCloneRatecardActive\">{{\'RATECARDS.MAIN_CLONE_RATECARD\' | translate}}</h2></div><div layout=\"column\" layout-wrap=\"\" class=\"form-wrapper md-whiteframe-1dp margin-bottom-15\"><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_NAME\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><input name=\"ratecardName\" ng-model=\"rateCardManage.currentRatecard.formData.Name\" required=\"\"><div ng-messages=\"createRatecardForm.ratecardName.$error\"><div ng-message=\"required\">Please provide a name for this Rate Card.</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"rateCardManage.isEditRatecardActive\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_RATECARD_FORMAT\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><div layout=\"row\" layout-align=\"start center\">{{ rateCardManage.currentRatecard.formData.RateCardFormat.Name }}</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-primary md-body-2 mb-10 sync-btn-no-left-padding\" ng-click=\"rateCardManage.sync()\" ng-disabled=\"rateCardManage.service.isRateCardSyncing\" ng-if=\"rateCardManage.isEditRatecardActive\"><span ng-if=\"!rateCardManage.service.isRateCardSyncing\">Sync</span> <span ng-if=\"rateCardManage.service.isRateCardSyncing\" style=\"position: relative; display: inline-block;\"><span style=\"opacity: 0.5;\">Syncing</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" style=\"position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); pointer-events: none;\"></md-progress-circular></span></md-button><div layout=\"row\" layout-align=\"center center\" class=\"ml-10\"><md-icon md-font-icon=\"icon-information\" class=\"s20 md-accent\" aria-label=\"Sync info\"><md-tooltip md-direction=\"bottom\">Click Sync to apply the latest rules in the rate card.</md-tooltip></md-icon><span class=\"ml-5 md-caption\">Click Sync to apply the latest rules in the rate card.</span></div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"!rateCardManage.isEditRatecardActive\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_RATECARD_FORMAT\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"rateCardFormat\" ng-model=\"rateCardManage.currentRatecard.formData.RateCardFormat\" required=\"\"><md-option ng-value=\"format.Id\" ng-repeat=\"format in rateCardManage.formatsLookup\" required=\"\">{{ format.Name }}</md-option></md-select><div ng-messages=\"createRatecardForm.rateCardFormat.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardManage.currentRatecard.formData.InvoiceShiftsOnSeparateInvoice\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_INVOICE_SHIFTS_SEPARATE\' | translate}}</label></md-checkbox></div><div layout=\"column\" layout-wrap=\"\" flex=\"20\" class=\"mb-20\"><label flex=\"\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_MINIMUM_BILLING_HOURS\' | translate}}</label><div flex=\"\" layout=\"row\"><md-input-container flex=\"5\" class=\"mt-0 mb-5 mr-5\"><input name=\"minBillingHours\" type=\"number\" step=\"0.5\" ng-model=\"rateCardManage.currentRatecard.formData.MinimumBillingHours\"></md-input-container><span flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\">{{\'RATECARDS.MAIN_HRS_LABEL\' | translate}}</span></div><div flex=\"\" class=\"input-error-message\" ng-messages=\"createRatecardForm.minBillingHours.$error\"><div ng-message=\"number\">Please provide a whole or a decimal number.</div></div></div></div><div layout=\"column\" layout-wrap=\"\" class=\"form-wrapper md-whiteframe-1dp margin-top-15 margin-bottom-15\"><h2 flex=\"100\">Allowances</h2><div layout=\"row\" layout-wrap=\"\"><label class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_ALLOWANCES\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select class=\"ratecard-multiple-select\" name=\"rateCardAllowances\" ng-model=\"rateCardManage.currentRatecard.formData.AllowancesHolder\" multiple=\"\"><md-option ng-value=\"allowance.Id\" ng-repeat=\"allowance in rateCardManage.allowancesLookup\" ng-selected=\"rateCardManage.isAllowanceSelected(allowance.Id)\">{{ allowance.Name }}</md-option></md-select></md-input-container></div></div><div layout=\"column\" layout-wrap=\"\" class=\"form-wrapper md-whiteframe-1dp margin-top-15 margin-bottom-15\"><h2 flex=\"100\">Timesheet Adjustments</h2><div layout=\"row\" layout-wrap=\"\"><label class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_TIMESHEET\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select class=\"ratecard-multiple-select\" name=\"rateCardTimesheets\" ng-model=\"rateCardManage.currentRatecard.formData.TimesheetAdjustmentsHolder\" multiple=\"\"><md-option ng-value=\"timesheet.Id\" ng-repeat=\"timesheet in rateCardManage.timesheetLookup\" ng-selected=\"rateCardManage.isTimesheetSelected(timesheet.Id)\">{{ timesheet.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardManage.currentRatecard.formData.ChargeEmployeeBreaks\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_CHARGE_EMPLOYEE_BREAK\' | translate}}</label></md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardManage.currentRatecard.formData.ChargeEquipmentBreaks\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_CHARGE_EQUIPMENT_BREAK\' | translate}}</label></md-checkbox></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardManage.currentRatecard.formData.RoundAllHoursToNeareast15Minutes\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_ROUND_NEAREST_MINS\' | translate}}</label></md-checkbox></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"rateCardManage.isSetupPackupInTimesheetEnabled\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardManage.currentRatecard.formData.ExcludeSetupPackupHours\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_EXCLUDE_SETUP_PACKUP_HRS\' | translate}}</label></md-checkbox></div><div layout=\"row\" class=\"mb-20\"><div flex=\"20\"><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_TRIM_JOB_START\' | translate}}</label><md-input-container flex=\"25\" class=\"mt-0 mb-5 mr-5\"><input name=\"trimJobStart\" ng-model=\"rateCardManage.currentRatecard.formData.TrimJobStartByMinutes\" ng-pattern=\"/^[0-9]*$/\"></md-input-container><span flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\">{{\'RATECARDS.MAIN_MINUTES_LABEL\' | translate}}</span><div flex=\"100\" class=\"input-error-message\" ng-messages=\"createRatecardForm.trimJobStart.$error\"><div ng-message=\"pattern\">Please provide a whole number.</div></div></div></div><div flex=\"20\"><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_TRIM_JOB_END\' | translate}}</label><md-input-container flex=\"25\" class=\"mt-0 mb-5 mr-5\"><input name=\"trimJobEnd\" ng-model=\"rateCardManage.currentRatecard.formData.TrimJobEndByMinutes\" ng-pattern=\"/^[0-9]*$/\"></md-input-container><span flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\">{{\'RATECARDS.MAIN_MINUTES_LABEL\' | translate}}</span><div flex=\"100\" class=\"input-error-message\" ng-messages=\"createRatecardForm.trimJobEnd.$error\"><div ng-message=\"pattern\">Please provide a whole number.</div></div></div></div></div></div><div layout=\"column\" layout-wrap=\"\" class=\"form-wrapper md-whiteframe-1dp margin-top-15 margin-bottom-15\"><div layout=\"row\" layout-wrap=\"\"><h2 flex=\"100\">Packages</h2></div><div layout=\"row\" layout-wrap=\"\"><label class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_PACKAGES\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0\" style=\"margin-bottom:unset;\"><md-select class=\"ratecard-multiple-select\" name=\"rateCardPackages\" ng-model=\"rateCardManage.currentRatecard.formData.PackagesHolder\" ng-change=\"rateCardManage.updatePackages()\" multiple=\"\"><md-option ng-value=\"package.Id\" ng-repeat=\"package in rateCardManage.packagesLookup\" ng-selected=\"rateCardManage.isPackageSelected(package.Id)\" ,=\"\" ng-click=\"rateCardManage.isPackageClicked(package.Id)\">{{ package.Name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><button class=\"md-raised md-accent md-body-2 md-button md-default-theme md-ink-ripple order-preferences\" type=\"button\" ng-show=\"rateCardManage.currentRatecard.formData.PackagesHolder.length > 1\" ng-click=\"rateCardManage.openPackagesDialog()\">{{\'RATECARDS.PACKAGE_ORDER_PREFERENCES\' | translate}}</button></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"!rateCardManage.isPackagesEmpty()\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20 margin-top-15\" ng-model=\"rateCardManage.currentRatecard.formData.FormPackagesForShiftsWithSameTime\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_PACKAGES_SHIFTS_STARTEND_TIME\' | translate}}</label></md-checkbox></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"!rateCardManage.isPackagesEmpty()\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-disabled=\"!rateCardManage.isPackagesEmpty()\" ng-model=\"rateCardManage.currentRatecard.formData.AverageEmployeeBreakHours\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_AVG_BREAK_HRS\' | translate}}</label></md-checkbox></div></div><div layout=\"column\" layout-wrap=\"\" class=\"form-wrapper md-whiteframe-1dp margin-top-15 margin-bottom-15 ratecard-surcharges\" ng-if=\"rateCardManage.surchargesEnabled\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"space-between center\"><h2 flex=\"\">{{\'RATECARD_V2.SURCHARGES.TITLE\' | translate}}</h2><md-button class=\"md-raised md-accent surcharges-add-btn\" type=\"button\" ng-click=\"rateCardManage.openAddSurcharge()\">{{\'RATECARD_V2.SURCHARGES.ADD_BUTTON\' | translate}}</md-button></div><p class=\"md-caption surcharges-info-note\">{{\'RATECARD_V2.SURCHARGES.INFO_NOTE\' | translate}}</p><table class=\"simple a8grid surcharges-list\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.SURCHARGES.COL_NAME\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.SURCHARGES.COL_METHOD\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.SURCHARGES.COL_RATE\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.SURCHARGES.COL_TAXABLE\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.SURCHARGES.COL_STATUS\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.SURCHARGES.COL_EFFECTIVE_DATE\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'RATECARD_V2.SURCHARGES.COL_MANAGE\' | translate}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"surcharge in rateCardManage.getSurcharges() track by $index\"><td class=\"text-left\">{{surcharge.Name}}</td><td class=\"text-left\">{{rateCardManage.formatSurchargeMethod(surcharge)}}</td><td class=\"text-left\">{{rateCardManage.formatSurchargeRate(surcharge)}}</td><td class=\"text-left\">{{surcharge.IsTaxable ? (\'RATECARD_V2.SURCHARGES.YES\' | translate) : (\'RATECARD_V2.SURCHARGES.NO\' | translate)}}</td><td class=\"text-left\">{{surcharge.IsActive ? (\'RATECARD_V2.SURCHARGES.STATUS_ACTIVE\' | translate) : (\'RATECARD_V2.SURCHARGES.STATUS_INACTIVE\' | translate)}}</td><td class=\"text-left\">{{surcharge.EffectiveDate | date:\'dd/MM/yyyy\'}}</td><td class=\"surcharges-actions\"><md-button class=\"md-icon-button\" type=\"button\" ng-click=\"rateCardManage.openEditSurcharge(surcharge)\" aria-label=\"{{\'RATECARD_V2.SURCHARGES.EDIT_ARIA\' | translate}}\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" type=\"button\" ng-if=\"surcharge.Id\" ng-click=\"rateCardManage.openSurchargeHistory(surcharge)\" aria-label=\"{{\'RATECARD_V2.SURCHARGES.HISTORY_ARIA\' | translate}}\"><md-icon class=\"amber-500-fg\" md-font-icon=\"icon-history\"></md-icon></md-button><md-button class=\"md-icon-button\" type=\"button\" ng-click=\"rateCardManage.removeSurcharge(surcharge)\" aria-label=\"{{\'RATECARD_V2.SURCHARGES.DELETE_ARIA\' | translate}}\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr><tr ng-if=\"!rateCardManage.getSurcharges().length\"><td colspan=\"7\" class=\"text-center surcharges-empty\">{{\'RATECARD_V2.SURCHARGES.EMPTY\' | translate}}</td></tr></tbody></table></div><div layout=\"column\" layout-wrap=\"\" class=\"form-wrapper md-whiteframe-1dp margin-top-15 margin-bottom-15\"><h2 flex=\"100\">Charging Travel</h2><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_TRAVEL_TYPE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"rateCardTravelTypes\" ng-model=\"rateCardManage.currentRatecard.formData.TravelType\" ng-change=\"rateCardManage.onTravelTypeChange()\" required=\"\"><md-option ng-value=\"travelType.Key\" ng-repeat=\"travelType in rateCardManage.travelTypesLookup\" required=\"\">{{ travelType.Value }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_CHARGE_VEHICLE_ESTABLISHMENT_FEE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"rateCardEstablishmentFeeTypes\" ng-model=\"rateCardManage.currentRatecard.formData.EstablishmentFeeType\" required=\"\"><md-option ng-value=\"establishmentFee.Key\" ng-repeat=\"establishmentFee in rateCardManage.establishmentFeeTypesLookup\" required=\"\">{{ establishmentFee.Value }}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-hide=\"rateCardManage.isTravelHoursCheckboxHidden()\" layout-wrap=\"\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardManage.currentRatecard.formData.TravelHoursDoNotCountTowardsShiftHours\" ng-disabled=\"rateCardManage.isTravelChargedOnSeparateLine()\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_TRAVEL_HRS_COUNT_SHIFT_HRS\' | translate}}</label></md-checkbox></div><div flex=\"\" class=\"mb-20\"><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_TOTAL_LIMIT\' | translate}}</label><md-input-container flex=\"5\" class=\"mt-0 mb-5 mr-5\"><input name=\"maxTravelBillingTotal\" type=\"number\" ng-pattern=\"/^-?(?:\\d+|\\d+\\.(?:25|5|75))$/\" ng-disabled=\"rateCardManage.isToAndFromLimitSet() || rateCardManage.isTravelHoursFieldsDisabled\" ng-model=\"rateCardManage.currentRatecard.formData.MaximumBillingTravelTotalHours\"></md-input-container><span flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\">{{\'RATECARDS.MAIN_HRS_LABEL\' | translate}}</span><div flex=\"100\" class=\"input-error-message\" ng-messages=\"createRatecardForm.maxTravelBillingTotal.$error\"><div ng-message=\"pattern\">Only quarter-hour values are allowed (.25, .5, .75).</div><div ng-message=\"number\">Please provide a whole number.</div></div></div></div><div layout=\"row\" layout-wrap=\"\" class=\"mb-20\"><div flex=\"20\"><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_TO_LIMIT\' | translate}}</label><md-input-container flex=\"25\" class=\"mt-0 mb-5 mr-5\"><input name=\"maxTravelBillingTo\" type=\"number\" ng-pattern=\"/^-?(?:\\d+|\\d+\\.(?:25|5|75))$/\" ng-disabled=\"rateCardManage.isTotalLimitSet() || rateCardManage.isTravelHoursFieldsDisabled\" ng-model=\"rateCardManage.currentRatecard.formData.MaximumBillingTravelToHours\"></md-input-container><span flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\">{{\'RATECARDS.MAIN_HRS_LABEL\' | translate}}</span><div flex=\"100\" class=\"input-error-message\" ng-messages=\"createRatecardForm.maxTravelBillingTo.$error\"><div ng-message=\"pattern\">Only quarter-hour values are allowed (.25, .5, .75).</div><div ng-message=\"number\">Please provide a whole number.</div></div></div></div><div flex=\"20\"><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_FROM_LIMIT\' | translate}}</label><md-input-container flex=\"25\" class=\"mt-0 mb-5 mr-5\"><input name=\"maxTravelBillingFrom\" type=\"number\" ng-pattern=\"/^-?(?:\\d+|\\d+\\.(?:25|5|75))$/\" ng-disabled=\"rateCardManage.isTotalLimitSet() || rateCardManage.isTravelHoursFieldsDisabled\" ng-model=\"rateCardManage.currentRatecard.formData.MaximumBillingTravelFromHours\"></md-input-container><span flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\">{{\'RATECARDS.MAIN_HRS_LABEL\' | translate}}</span><div flex=\"100\" class=\"input-error-message\" ng-messages=\"createRatecardForm.maxTravelBillingFrom.$error\"><div ng-message=\"pattern\">Only quarter-hour values are allowed (.25, .5, .75).</div><div ng-message=\"number\">Please provide a whole number.</div></div></div></div></div><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_CHARGE_TYPE_TRAVEL_ONLY\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"rateCardTravelOnlyChargeType\" ng-model=\"rateCardManage.currentRatecard.formData.TravelOnlyChargeType\" ng-change=\"rateCardManage.onTravelOnlyChargeTypeChange()\" required=\"\"><md-option ng-value=\"travelType.Key\" ng-repeat=\"travelType in rateCardManage.travelOnlyChargeTypesLookup\" required=\"\">{{ travelType.Value }}</md-option></md-select></md-input-container></div></div><div layout=\"column\" layout-wrap=\"\" class=\"form-wrapper md-whiteframe-1dp margin-top-15 margin-bottom-15\"><h2 flex=\"100\">Charging Vehicles</h2><div layout=\"row\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_VEHICLE_CHARGE_TYPE\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"rateCardVehicleChargeType\" ng-model=\"rateCardManage.currentRatecard.formData.VehicleChargeType\" ng-change=\"rateCardManage.onVehicleChargeTypeChange()\" required=\"\"><md-option ng-value=\"vehicleChargeType.Key\" ng-repeat=\"vehicleChargeType in rateCardManage.vehicleChargeTypesLookup\" required=\"\">{{ vehicleChargeType.Value }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"rateCardManage.isAltusSpecialEnabled\"><md-checkbox class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-model=\"rateCardManage.currentRatecard.formData.VehicleTravelNotCharge\"><label>{{\'RATECARDS.MAIN_CREATE_FORM_VEHICLE_TRAVEL_CHARGE\' | translate}}</label></md-checkbox></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"rateCardManage.currentRatecard.formData.VehicleChargeType == rateCardManage.VehicleChargeTypes.ChargeVehicleAsWorkedHoursBasedOnRateCardFormat\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARDS.MAIN_CREATE_FORM_RATECARD_FORMAT\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><md-select name=\"vehicleRateCardFormat\" ng-model=\"rateCardManage.currentRatecard.formData.VehicleRateCardFormat.Id\" ng-change=\"rateCardManage.onVehicleRateCardFormatChange()\" ng-disabled=\"rateCardManage.disableVehicleRateCardFormat()\" required=\"\"><md-option ng-value=\"vehicleFormat.Id\" ng-repeat=\"vehicleFormat in rateCardManage.vehicleformatsLookup\" required=\"\">{{ vehicleFormat.Name }}</md-option></md-select><div ng-messages=\"createRatecardForm.vehicleRateCardFormat.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div></div><div layout=\"row\" layout-wrap=\"\"><md-dialog-actions layout=\"row\" ng-if=\"!rateCardManage.isEditRatecardActive && !rateCardManage.hasRatecard()\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardManage.createNewRatecard()\" ng-disabled=\"(createRatecardForm.ratecardName.$invalid) || (createRatecardForm.rateCardFormat.$invalid) || (createRatecardForm.rateCardVehicleChargeType.$invalid) || (createRatecardForm.vehicleRateCardFormat.$invalid) || (createRatecardForm.rateCardTravelTypes.$invalid) || (createRatecardForm.rateCardTravelOnlyChargeType.$invalid) || (createRatecardForm.minBillingHours.$invalid) || (createRatecardForm.trimJobStart.$invalid) || (createRatecardForm.trimJobEnd.$invalid) || (createRatecardForm.maxTravelBillingTotal.$invalid) || (createRatecardForm.maxTravelBillingTo.$invalid) || (createRatecardForm.maxTravelBillingFrom.$invalid)\">{{\'RATECARDS.MAIN_ADD\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" ng-if=\"rateCardManage.isEditRatecardActive && rateCardManage.hasRatecard() && !rateCardManage.isCloneRatecardActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardManage.saveRatecard()\" ng-disabled=\"(createRatecardForm.ratecardName.$invalid) || (createRatecardForm.rateCardVehicleChargeType.$invalid) || (createRatecardForm.vehicleRateCardFormat.$invalid) || (createRatecardForm.rateCardFormat.$invalid) || (createRatecardForm.rateCardTravelTypes.$invalid) || (createRatecardForm.rateCardTravelOnlyChargeType.$invalid) || (createRatecardForm.minBillingHours.$invalid) || (createRatecardForm.trimJobStart.$invalid) || (createRatecardForm.trimJobEnd.$invalid) || (createRatecardForm.maxTravelBillingTotal.$invalid) || (createRatecardForm.maxTravelBillingTo.$invalid) || (createRatecardForm.maxTravelBillingFrom.$invalid)\">{{\'RATECARDS.MAIN_SAVE\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" ng-if=\"rateCardManage.isEditRatecardActive && rateCardManage.hasRatecard() && rateCardManage.isCloneRatecardActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardManage.createNewRatecard()\" ng-disabled=\"(createRatecardForm.ratecardName.$invalid) || (createRatecardForm.rateCardFormat.$invalid) || (createRatecardForm.rateCardVehicleChargeType.$invalid) || (createRatecardForm.vehicleRateCardFormat.$invalid) || (createRatecardForm.rateCardTravelTypes.$invalid) || (createRatecardForm.rateCardTravelOnlyChargeType.$invalid) || (createRatecardForm.minBillingHours.$invalid) || (createRatecardForm.trimJobStart.$invalid) || (createRatecardForm.trimJobEnd.$invalid) || (createRatecardForm.maxTravelBillingTotal.$invalid) || (createRatecardForm.maxTravelBillingTo.$invalid) || (createRatecardForm.maxTravelBillingFrom.$invalid)\">{{\'RATECARDS.MAIN_ADD\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" ng-if=\"rateCardManage.isEditRatecardActive && rateCardManage.hasRatecard() && !rateCardManage.isCloneRatecardActive\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"rateCardManage.archiveRatecard($event)\">{{\'RATECARDS.MAIN_EDIT_FORM_ARCHIVE_\' | translate}}</md-button></md-dialog-actions><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-body-2\" ng-click=\"rateCardManage.toggleRatecardCreate(true)\" ng-disabled=\"\">{{\'RATECARDS.MAIN_CANCEL\' | translate}}</md-button></md-dialog-actions></div></form></div></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\"><div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\"> <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </div> <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren && !vm.isHidden()\"> <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\"><div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\"> <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </div> <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg2\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren && !vm.isHidden()\"> <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/main/workForceParticipation/view/work-force-participation-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div ng-if=\"vm.service.loader\" class=\"toolbar-wrapper\" style=\"height : 64px ; padding-top : 20px; padding-left : 20px;\"><span class=\"md-caption\"><table><tr><td><b>{{vm.service.operationMessage}} &nbsp; &nbsp; &nbsp;</b></td><td><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.service.loader\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></td></tr></table></span></div><div ng-if=\"!vm.service.loader\" class=\"toolbar-wrapper\"><md-button translate=\"WORKFORCE.ADD_BUTTON\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vm.service.showDialog(null, false)\"></md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.query\" ng-keyup=\"vm.searchTable()\"></md-input-container></div></div><table class=\"dataTable row-border hover\" dt-instance=\"vm.dtInstance\" style=\"margin-top :10px;\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORKFORCE.COLUMN_NAME\"></span></div></th><th class=\"secondary-text\"></th></tr></thead><tbody><tr ng-repeat=\"workforce in vm.service.workforce\"><td>{{workforce.Name}}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.service.showDialog(workforce, true)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon></md-button><delete-component index=\"workforce.Id\" message=\"{{\'WORKFORCE.DELETE_MESSAGE\' | translate}}\" callback=\"vm.service.remove\" section=\"{{\'WORKFORCE.HEADER\' | translate}}\"></delete-component></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/shared/widgets/a8Pagination/pageSize/a8PageSize.html","<md-select ng-model=\"vm.selected\" ng-change=\"vm.onPageSizeEvt()\"><md-option ng-repeat=\"item in ::vm.options\" ng-value=\"item\">{{item}}</md-option></md-select>");
$templateCache.put("app/shared/widgets/a8Pagination/sort/a8SortField.html","<div class=\"table-header\" ng-click=\"vm.onClickSort()\"><span class=\"column-title\">{{vm.fieldLabel}}</span><md-icon md-font-icon=\"{{vm.icon}}\"></md-icon></div>");
$templateCache.put("app/shared/widgets/a8Pagination/search/a8PagerSearch.html","<md-input-container><label>Search</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.source\" ng-model-options=\"vm.delay\"></md-input-container>");
$templateCache.put("app/shared/widgets/a8PaginationGrid/pageSize/a8GridPageSize.html","<md-select ng-model=\"vm.selected\" ng-change=\"vm.onPageSizeEvt()\"><md-option ng-repeat=\"item in ::vm.options\" ng-value=\"item\">{{item}}</md-option></md-select>");
$templateCache.put("app/shared/widgets/a8PaginationGrid/search/a8GridSearch.html","<md-input-container class=\"md-block\"><label>Search</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.source\" ng-model-options=\"vm.delay\"></md-input-container>");
$templateCache.put("app/shared/widgets/a8PaginationGrid/sort/a8SortColumn.html","<div class=\"table-header a8sort-column\" ng-click=\"vm.onClickSort()\"><span class=\"column-title\">{{vm.fieldLabel}}</span><md-icon md-font-icon=\"{{vm.icon}}\"></md-icon></div>");
$templateCache.put("app/shared/widgets/a8PaginationGrid/status/a8GridStatus.html","<label ng-if=\"vm.status\" class=\"md-grey-300-fg\"><strong>{{vm.status}}</strong></label>");
$templateCache.put("app/main/assets/manage/category/asset-category-dialog.html","<md-dialog aria-label=\"Add Category\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Category</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"addCategoryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>Category Name</label> <input type=\"text\" name=\"categoryName\" ng-model=\"vm.categoryName\" required=\"\"><div ng-messages=\"addCategoryForm.categoryName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Category name is required.</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Cancel</md-button><md-button ng-click=\"vm.onAdd()\" class=\"md-accent\" aria-label=\"Add\" ng-disabled=\"addCategoryForm.$invalid || addCategoryForm.$pristine\" translate=\"ASSETSMODULE.MANAGE_ADD_CATEGORY\">Add</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/category/asset-category-tree.html","<div id=\"asset-category-tree\"><script type=\"text/ng-template\" id=\"nodes_renderer.html\"><div ui-tree-handle class=\"tree-node tree-node-content\" layout=\"column\" flex> <div layout=\"row\"> <div layout=\"row\" flex=\"auto\" layout-align=\"start center\"> <div> <md-icon md-font-icon=\"collapse-expand icon-chevron-right icon s25\" ng-if=\"node.nodes && node.nodes.length > 0\" ng-show=\"collapsed\" data-nodrag ng-click=\"toggle(this)\"></md-icon> </div> <div> <md-icon md-font-icon=\"collapse-expand icon-chevron-down icon s25\" ng-if=\"node.nodes && node.nodes.length > 0\" ng-show=\"!collapsed\" data-nodrag ng-click=\"toggle(this)\"></md-icon> </div> <div class=\"margin-left-5\"> {{node.title}} </div> </div> <div layout=\"row\" layout-align=\"end center\" flex=\"nogrow\"> <md-button class=\"md-icon-button\" data-nodrag ng-click=\"vm.newSubItem(this)\" style=\"margin-right: 0; padding-right: 0;\" aria-label=\"Add new sub category\"> <md-icon md-font-icon=\"icon icon-plus-box\"></md-icon> <md-tooltip><span>New sub category</span></md-tooltip> </md-button> <md-button class=\"md-icon-button\" data-nodrag ng-click=\"vm.editItem(this)\" style=\"margin-right: 0; padding-right: 0;\" aria-label=\"Edit sub category\"> <md-icon class=\"teal-500-fg\" md-font-icon=\"icon icon-pencil\"></md-icon> <md-tooltip><span>Edit sub category</span></md-tooltip> </md-button> <md-button class=\"md-icon-button\" data-nodrag ng-click=\"vm.remove(this)\" style=\"margin-left: 0; padding-left: 0;\" aria-label=\"Delete sub category\"> <md-icon class=\"red-500-fg\" md-font-icon=\"icon icon-delete\"></md-icon> <md-tooltip><span>Delete sub category</span></md-tooltip> </md-button> </div> </div> </div> <ul ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-hide=\"collapsed\" class=\"manage-tree\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"> </li> </ul></script><md-button class=\"md-accent md-raised margin-left-0\" ng-click=\"vm.onAddRootCategory()\" ng-disabled=\"itemForm.$invalid\">Add Category<md-tooltip><span>Add Root Category Item</span></md-tooltip></md-button><md-divider></md-divider><br><div><div><div ui-tree=\"vm.treeOptions\" id=\"tree-root\" class=\"angular-ui-tree\" layout=\"column\"><ul ui-tree-nodes=\"\" ng-model=\"vm.source\" class=\"manage-tree\"><li ng-repeat=\"node in vm.source\" ui-tree-node=\"\" ng-include=\"\'nodes_renderer.html\'\"></li></ul></div></div></div><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"vm.source.length <= 0\"><span>No Current Category Record</span></div></div>");
$templateCache.put("app/main/assets/manage/category/asset-category.default.html","<div id=\"manage-item\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-primary md-raised head-button\" ng-click=\"manageCategoryVm.onSave()\" ng-disabled=\"!manageCategoryVm.model.isEdited\">Save<md-tooltip><span>Save/Update Item</span></md-tooltip></md-button></div></div><div class=\"content\" flex=\"\"><div layout=\"column\"><div class=\"md-title mt-0\">Category</div><div class=\"pb-16\">Add, edit and remove item.</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\" flex-xs=\"100\" flex-sm=\"100\"><asset-category-component source=\"manageCategoryVm.model.data\" remove-item=\"manageCategoryVm.removeItem(node)\" has-changes=\"manageCategoryVm.model.hasChanges()\"></asset-category-component></div></div></div></div></div></div>");
$templateCache.put("app/main/assets/manage/costCodes/cost-code-entry.html","<md-dialog aria-label=\"Contact Address\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.model.data.id ? \"Edit\":\"Add\"}} Cost Code</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"costCodeEntryForm\" class=\"md-inline-form\" ng-submit=\"vm.onSubmit()\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"code\" ng-model=\"vm.model.data.CodeNo\" placeholder=\"Code\" required=\"\"><div ng-messages=\"costCodeEntryForm.code.$error\" ng-show=\"costCodeEntryForm.code.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Cost Code field is required.</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"description\" ng-model=\"vm.model.data.Description\" placeholder=\"Description\" ng-required=\"true\" maxlength=\"50\"><div ng-messages=\"costCodeEntryForm.description.$error\" ng-show=\"costCodeEntryForm.description.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Description field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>Category</label><md-select ng-model=\"vm.model.data.CostCodeType\" ng-model-options=\"{trackBy: \'$value.TypeId\'}\" ng-required=\"true\"><md-option ng-repeat=\"category in vm.model.categoriesLookup\" ng-value=\"category\">{{category.TypeName}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Cancel</md-button><md-button type=\"submit\" class=\"md-accent\" aria-label=\"Submit\" ng-disabled=\"costCodeEntryForm.$invalid || costCodeEntryForm.$pristine\" translate=\"ASSETSMODULE.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/costCodes/cost-codes.default.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"costCodesVm.model.addNew()\">Add Cost Code</md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"Search\" ng-model=\"costCodesVm.model.query\" ng-keyup=\"costCodesVm.searchTable()\"></md-input-container></div></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"costCodesVm.dtInstance\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"costCodesVm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><span class=\"column-title\">Actions</span></th></tr></thead><tbody><tr ng-repeat=\"costCode in costCodesVm.gridModel\"><td>{{ costCode.CodeNo }}</td><td>{{ costCode.Description }}</td><td>{{ costCode.CostCodeType.TypeName }}</td><td><md-button class=\"md-icon-button\" ng-click=\"costCodesVm.onEdit(costCode.id)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>Edit Cost Codes</span></md-tooltip></md-button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/assets/manage/kit/kit.default.html","<div id=\"manage-kit\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-accent md-raised first-button-margin\" ng-click=\"kitVm.onSave()\" ng-disabled=\"kitItemForm.$invalid\" translate=\"{{kitVm.buttonSaveCaption}}\" ng-hide=\"{{!kitVm.model.isEditMode}}\"><md-icon md-font-icon=\"icon-content-save s20\"></md-icon><span>{{kitVm.buttonSaveCaption}}</span><md-tooltip><span>{{\'ASSETSMODULE.KIT_DEFAULT_SAVE/UPDATE_ITEM\' | translate}}</span></md-tooltip></md-button><md-button class=\"md-accent md-raised button-margin\" ng-click=\"kitVm.onSaveAndClose()\" ng-disabled=\"kitItemForm.$invalid\" ng-hide=\"{{kitVm.model.isEditMode}}\">{{\'ASSETSMODULE.KIT_DEFAULT_SAVE\' | translate}}<md-tooltip><span>{{\'ASSETSMODULE.KIT_DEFAULT_SAVE_ITEM\' | translate}}</span></md-tooltip></md-button></div></div><div class=\"content\" flex=\"\"><form name=\"kitItemForm\" novalidate=\"\" a8-dirty-form-confirmation=\"\"><basic-create-kit-item-component></basic-create-kit-item-component><sale-and-hire-price-component></sale-and-hire-price-component></form></div></div></div>");
$templateCache.put("app/main/assets/manage/item/item.default.html","<div id=\"manage-item\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-accent md-raised first-button-margin\" ng-click=\"itemVm.onSave()\" ng-disabled=\"itemVm.shouldDisableSaveButton()\" translate=\"{{itemVm.buttonSaveCaption}}\" ng-hide=\"!itemVm.model.isEditMode\"></md-button><md-button class=\"md-accent md-raised button-margin\" translate=\"ASSETSMODULE.ITEM_SAVE\" ng-click=\"itemVm.onSaveAndClose()\" ng-disabled=\"itemVm.shouldDisableSaveButton()\" ng-hide=\"itemVm.model.isEditMode\"></md-button></div></div><div class=\"content\" layout-wrap=\"\" flex=\"\"><form name=\"itemForm\" novalidate=\"\" a8-dirty-form-confirmation=\"\"><basic-create-item-component ng-if=\"!itemVm.customizedFieldService.manageCustomizedFields\"></basic-create-item-component><customized-field></customized-field><stock-level-component ng-if=\"!itemVm.customizedFieldService.manageCustomizedFields && itemVm.basicInfo.source == \'item\'\"></stock-level-component></form><individual-item-component ng-show=\"itemVm.model.showIndividualItemsSection && !itemVm.customizedFieldService.manageCustomizedFields && itemVm.basicInfo.source == \'item\'\"></individual-item-component><people-skill-component ng-if=\"!itemVm.customizedFieldService.manageCustomizedFields\"></people-skill-component><related-item-component ng-if=\"!itemVm.customizedFieldService.manageCustomizedFields && itemVm.basicInfo.source == \'item\'\"></related-item-component><md-content class=\"forms-manager form-wrapper md-whiteframe-2dp\" layout-padding=\"\" ng-if=\"itemVm.checkAccessService.isCustomFormsEnabled() && itemVm.basicInfo.source == \'item\'\"><form-templates-list flex=\"\" form-types=\"itemVm.formTypes\" hide-include-in-paperwork=\"itemVm.isItemForms\" linked-form-templates=\"itemVm.model.linkedFormTemplates\" unlinked-form-templates=\"itemVm.model.unlinkedFormTemplates\" overridden-form-templates=\"itemVm.model.overriddenFormTemplates\" api=\"itemVm.model.formTemplatesListApi\" vehicles=\"itemVm.model.vehicles\" assets=\"itemVm.model.assets\" always-refresh-forms-list=\"itemVm.editMode\" applied-to=\'[\"AllAssets\"]\' on-change=\"itemVm.onFormsChange()\"></form-templates-list></md-content></div></div></div>");
$templateCache.put("app/main/assets/directives/CustomizedFields/customized-fields.html","<div layout=\"column\" class=\"margin-bottom-20\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-button class=\"md-accent md-raised\" translate=\"ASSETSMODULE.ADD_NEW_FIELD\" ng-hide=\"vm.showFields\" ng-click=\"vm.showCustomizedFieldsDialog()\" style=\"position:relative;left:-12px;\"></md-button><md-button class=\"md-accent md-raised\" translate=\"ASSETSMODULE.ADD_NEW_FIELD_DONE\" ng-hide=\"vm.showFields\" ng-click=\"vm.onDone()\" style=\"position:relative;left:-12px;\"></md-button></div><div id=\"customisedFields\" layout=\"row\" flex=\"\"></div><div id=\"addedCustomisedFields\" layout=\"row\" flex=\"\"></div></div></div></div>");
$templateCache.put("app/main/branch/create/template/create-form.html","<div><form name=\"formContact\" novalidate=\"\" ng-show=\"vm.showFields\" a8-dirty-form-confirmation=\"\"><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"\"><input type=\"text\" name=\"branchName\" ng-model=\"vm.service.branchData.Name\" placeholder=\"{{\'BRANCH_CREATE.NAME\' | translate}}\" required=\"\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"addressPrefix\" ng-model=\"vm.service.branchData.AddressPrefix\" placeholder=\"{{\'BRANCH_CREATE.PREFIX\' | translate}}\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"\"><input type=\"text\" single-address=\"\" country=\"{{vm.countryGmap}}\" ng-model=\"vm.service.branchData.Address\" call-back=\"vm.callBack\"></md-input-container><md-input-container flex=\"\" ng-if=\"vm.checkAccessService.isPayrollEnabled()\"><label translate=\"BRANCH_CREATE.AWARD\"></label><md-select placeholder=\"Award\" ng-model=\"vm.service.branchData.Award\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"award in vm.awards\" ng-value=\"award\">{{award.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div layout-xs=\"column\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" flex-gt-lg=\"33\" flex-lg=\"33\" flex-md=\"33\" flex-gt-sm=\"33\"><md-input-container flex=\"\"><input type=\"text\" name=\"Suburb\" ng-model=\"vm.service.branchData.Suburb\" placeholder=\"{{\'BRANCH_CREATE.SUBURB\' | translate}}\" required=\"\"></md-input-container></div><div layout-xs=\"column\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" flex-gt-lg=\"33\" flex-lg=\"33\" flex-md=\"33\" flex-gt-sm=\"33\"><md-input-container flex=\"\"><input type=\"text\" name=\"State\" ng-model=\"vm.service.branchData.State\" placeholder=\"{{\'BRANCH_CREATE.STATE\' | translate}}\" required=\"\"></md-input-container></div><div layout-xs=\"column\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" flex-gt-lg=\"33\" flex-lg=\"33\" flex-md=\"33\" flex-gt-sm=\"33\"><md-input-container flex=\"\"><input type=\"text\" name=\"PostCode\" ng-model=\"vm.service.branchData.Postcode\" placeholder=\"{{\'BRANCH_CREATE.CODE\' | translate}}\" required=\"\"><div ng-messages=\"formContact.PostCode.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please enter Post Code</span></div></div></md-input-container></div></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"\"><input type=\"text\" name=\"Latitude\" ng-model=\"vm.service.branchData.Location.Latitude\" placeholder=\"{{\'BRANCH_CREATE.LATITUDE\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"Longitude\" ng-model=\"vm.service.branchData.Location.Longitude\" placeholder=\"{{\'BRANCH_CREATE.LONGITUDE\' | translate}}\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex=\"\"><input type=\"text\" name=\"Phone\" ng-model=\"vm.service.branchData.Phone\" placeholder=\"{{\'BRANCH_CREATE.PHONE\' | translate}}\" required=\"\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"Fax\" ng-model=\"vm.service.branchData.Fax\" placeholder=\"{{\'BRANCH_CREATE.FAX\' | translate}}\"></md-input-container><md-input-container flex=\"\"><label translate=\"BRANCH_CREATE.TIMEZONE\"></label><md-select ng-model=\"vm.service.branchData.Timezone\" name=\"Timezone\" required=\"\"><md-option ng-value=\"timezone.Value\" ng-repeat=\"timezone in vm.timezones\">{{timezone.DisplayText}}</md-option></md-select></md-input-container></div><divisions-directive flex=\"100\" ng-if=\"vm.isEditMode\" service=\"vm.service\"></divisions-directive><div layout=\"column\"><div layout=\"row\"><form-templates-list flex=\"\" form-types=\"vm.formTypes\" linked-form-templates=\"vm.service.linkedFormTemplates\" unlinked-form-templates=\"vm.service.unlinkedFormTemplates\" overridden-form-templates=\"vm.service.overriddenFormTemplates\" api=\"vm.service.formTemplatesListApi\" vehicles=\"vm.service.vehicles\" assets=\"vm.service.assets\" is-edit-mode=\"vm.isEditMode\" applied-to=\'[\"AllBranches\"]\' ng-if=\"vm.checkAccessService.isCustomFormsEnabled()\"></form-templates-list></div><div layout=\"row\"><document-manager module-id=\"5\" flex=\"100\" module-name=\"Branch\" related-resource-id=\"{{vm.branchId}}\" ng-if=\"vm.isEditMode && vm.checkAccessService.isDocumentManagementEnabled()\"></document-manager></div></div></form></div>");
$templateCache.put("app/main/awards/interpreter/directives/award-interpreter-output-item-error-column.html","<a href=\"#\" class=\"material-icons md-24 award-interpreter-output-item-error-status award-interpreter-output-item-column-icon\" ng-click=\"toggleColumn()\">{{columnStateIcon}}</a><md-icon class=\"award-interpreter-output-item-column-icon\" md-svg-src=\"{{errorStatusIcon}}\"></md-icon>");
$templateCache.put("app/main/awards/interpreter/directives/award-interpreter-output-item-error-details.html","<span ng-bind-html=\"displayErrors()\"></span><div ng-if=\"jobNumberNotFound\"><strong><label translate=\"RUN_PAYROLL.JOB_NUMBER_NOT_FOUND\"></label> <label translate=\"RUN_PAYROLL.UPDATE_THE_MYOB_JOB_NUMBER\" ng-click=\"redirectToCompanyAction()\" class=\"clickable-item\" style=\"text-decoration: underline\"></label> <label translate=\"RUN_PAYROLL.AND_TRY_AGAIN\"></label></strong></div>");
$templateCache.put("app/main/awards/interpreter/widgets/Number.html","<ms-widget layout=\"row\" flex=\"\" flippable=\"false\" class=\"m-15\"><ms-widget-front><div class=\"layout-column layout-align-center-center pt-15 pb-15 {{ vm.widget.cssClasses || \'\' }}\"><div class=\"font-size-62 line-height-62\">{{vm.widget.value}}</div><div class=\"p-8 h3 secondary-text font-weight-500\">{{vm.widget.displayName}}</div><div ng-if=\"vm.widget.secondaryText\" class=\"layout-row layout-align-center-center font-weight-500\"><span class=\"instruction-warning\">{{vm.widget.secondaryText}}</span></div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/awards/manage/addons/award-addons.html","<div id=\"award-addons\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"content\" layout=\"column\" layout-padding=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"\" class=\"m-10\" layout-align=\"center start\" layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"\" flex-xs=\"100\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.searchText\" ng-keyup=\"vm.searchTable()\"></md-input-container></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"vm.dtInstance\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" style=\"width: 30%\"><div class=\"table-header\"><span class=\"column-title\">Add-on Name</span></div></th><th class=\"secondary-text\" style=\"width: 30%\"><div class=\"table-header\"><span class=\"column-title\">Classification</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Pay Code</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Pay Rate</span></div></th><th class=\"secondary-text\" style=\"width: 10%\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"allowanceRate in vm.allowanceRates | orderBy:[\'AllowanceName\',\'ClassificationName\',\'PayCode\']\"><td><span>{{allowanceRate.AllowanceName}}</span></td><td><div>{{allowanceRate.ClassificationName}}</div></td><td><span>{{allowanceRate.PayCode}}</span></td><td><span>{{allowanceRate.PayRate | currency:\"$\":8}}</span></td><td><div ng-click=\"vm.viewConditions(allowanceRate)\" flex=\"25\" layout=\"row\" layout-align=\"start center\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-cog\" class=\"s20 mr-5\"></md-icon><span>Conditions</span></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/awards/manage/allowance-rates/award-allowance-rates.html","<div id=\"award-allowance-rates\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"content\" layout=\"column\" layout-padding=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"\" class=\"m-10\" layout-align=\"center start\" layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"\" flex-xs=\"100\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.searchText\" ng-keyup=\"vm.searchTable()\"></md-input-container></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"vm.dtInstance\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" style=\"width: 35%\"><div class=\"table-header\"><span class=\"column-title\">Classification</span></div></th><th class=\"secondary-text\" style=\"width: 20%\"><div class=\"table-header\"><span class=\"column-title\">Rate Type</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Pay Code</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Pay Rate</span></div></th></tr></thead><tbody><tr ng-repeat=\"classificationRate in vm.classificationRates | orderBy:[\'ClassificationName\',\'PayCode\']\"><td><span>{{classificationRate.ClassificationName}}</span></td><td class=\"md-caption\"><md-chips ng-if=\"allowanceRate.AppliesToFullTime\"><md-chip class=\"standard-rate\">Standard Rate</md-chip></md-chips><md-chips ng-if=\"!allowanceRate.AppliesToFullTime\"><md-chip class=\"casual-rate\">Casual Rate</md-chip></md-chips></td><td><span>{{classificationRate.PayCode}}</span></td><td><span>{{classificationRate.PayRate | currency:\"$\":8}}</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/awards/manage/allowances/award-allowances.html","<div id=\"award-allowances\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"content\" layout=\"column\" layout-padding=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"\" class=\"m-10\" layout-align=\"center start\" layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"\" flex-xs=\"100\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.searchText\" ng-keyup=\"vm.searchTable()\"></md-input-container></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"vm.dtInstance\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" style=\"width: 40%\"><div class=\"table-header\"><span class=\"column-title\">Allowance</span></div></th><th class=\"secondary-text\" style=\"width: 45%\"><div class=\"table-header\"><span class=\"column-title\">Classifications</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"allowance in vm.allowances | orderBy:[\'AllowanceName\']\"><td><div flex=\"\" layout=\"column\"><span>{{allowance.AllowanceName}}</span> <span class=\"md-caption\">{{allowance.AllowanceDescription}}</span></div><div flex=\"\" layout=\"row\" class=\"md-caption\"><md-chips><md-chip ng-class=\"{\'shift-allowance\': allowance.AllowanceCategoryId == 0, \'automatic-allowance\': allowance.AllowanceCategoryId == 1}\">{{allowance.AllowanceCategoryName}}</md-chip></md-chips></div></td><td><span ng-if=\"allowance.ClassificationNames.length > 0\">{{allowance.ClassificationNames.join(\', \')}}</span> <span ng-if=\"allowance.ClassificationNames.length === 0\" class=\"warning-text-small pt-5\">Not linked to any classifications !</span></td><td><div layout=\"column\" layout-align=\"center start\"><div ng-click=\"vm.viewConditions(allowance)\" layout=\"row\" layout-align=\"start center\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-cog\" class=\"s20 mr-5\"></md-icon><span>Conditions</span></div><div ng-click=\"vm.viewRates(allowance.AllowanceId)\" layout=\"row\" layout-align=\"start center\" class=\"pt-5 pb-5\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-eye\" class=\"s20 mr-5\"></md-icon><span>View Rates</span></div></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/awards/manage/awards/awards-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav main-style\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent first-button-margin\" ng-click=\"vm.service.addAward()\">Create a new Award</md-button><md-button class=\"md-raised md-accent button-margin\" ng-click=\"vm.service.addClassification()\">Create a new Classification</md-button><md-button class=\"md-raised md-accent button-margin\" ng-click=\"vm.service.addShiftRole()\">Create a new Shift Allowance</md-button></div></div><div class=\"content\" flex=\"\"><awards-component></awards-component><br><classifications-component></classifications-component><br><shifts-component></shifts-component><br></div></div></div>");
$templateCache.put("app/main/awards/manage/classifications/award-classifications.html","<div id=\"award-classification\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"content\" layout=\"column\" layout-padding=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"\" class=\"m-10\" layout-align=\"center start\" layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"\" flex-xs=\"100\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.searchText\" ng-keyup=\"vm.searchTable()\"></md-input-container><div ng-click=\"vm.addClassification()\" style=\"cursor: pointer;\" flex=\"15\" flex-xs=\"100\" flex-sm=\"30\" flex-md=\"25\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-fab md-mini md-accent pull-right btn-add\" aria-label=\"Add new Classification\" style=\"background-color: #4A1EBD;\"><md-icon class=\"icon-plus\"></md-icon></md-button><div style=\"color: #BB06FE;\">Add new Classification</div></div></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"vm.dtInstance\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" style=\"width: 25%\"><div class=\"table-header\"><span class=\"column-title\">Classification</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\" style=\"width: 25%\"><div class=\"table-header\"><span class=\"column-title\">Branches</span></div></th><th class=\"secondary-text\" style=\"width: 10%\"><div class=\"table-header\"><span class=\"column-title\">Base Rate of Pay</span></div></th><th class=\"secondary-text\" style=\"width: 10%\"><div class=\"table-header\"><span class=\"column-title\">Archived?</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"></th></tr></thead><tbody><tr ng-repeat=\"classification in vm.classifications | orderBy:[\'Name\']\"><td><span>{{classification.Name}}</span></td><td><span>{{classification.Description}}</span></td><td><span ng-if=\"classification.BranchNames.length > 0\">{{classification.BranchNames.join(\', \')}}</span> <span ng-if=\"classification.BranchNames.length === 0\" class=\"warning-text-small pt-5\">Not linked to any branches !</span></td><td><span>{{classification.BaseRateOfPay | currency:\"$\":8}}</span></td><td><md-icon ng-if=\"classification.IsArchived\" flex=\"\" layout-align=\"start center\" md-font-icon=\"icon-check\" class=\"s18\"></md-icon><md-icon ng-if=\"!classification.IsArchived\" flex=\"\" layout-align=\"start center\" md-font-icon=\"icon-close\" class=\"s18\"></md-icon></td><td layout=\"column\" layout-align=\"center start\"><div ng-click=\"vm.editClassification(classification.Name)\" layout=\"row\" layout-align=\"start center\" class=\"pt-5 pb-5\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-cog\" class=\"s20 mr-5\"></md-icon><span>Edit Classification</span></div><div ng-click=\"vm.viewRates(classification.Name)\" layout=\"row\" layout-align=\"start center\" class=\"pt-5 pb-5\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-eye\" class=\"s20 mr-5\"></md-icon><span>View Rates</span></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/awards/manage/dialogs/award-conditions-dialog.html","<md-dialog id=\"award-conditions-dialog\" flex=\"30\" flex-sm=\"60\" flex-xs=\"90\" ng-cloak=\"\" class=\"main-style\"><form name=\"awardConditionsForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"turncate\">{{vm.dialogTitle}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><div class=\"draggable-container\" flex=\"40\" flex-xs=\"100\" layout=\"column\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.conditions\"><div class=\"card\" layout=\"column\" ng-repeat=\"condition in vm.conditions | orderBy : \'ConditionOrder\'\"><div class=\"card-row\" ng-class=\"{\'drag-handle\': condition.CanReOrder}\" layout-align=\"center center\" layout=\"row\"><md-icon ng-if=\"condition.CanReOrder\" md-font-icon=\"icon-drag\" class=\"s18 mr-5\"></md-icon><md-icon ng-if=\"!condition.CanReOrder\" md-font-icon=\"icon-pin\" class=\"s18 mr-5\"></md-icon><div flex=\"\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"condition.ConditionOperatorName\" class=\"condition-operator mr-10\">{{condition.ConditionOperatorName}}</span> <span flex=\"45\" layout-align=\"start center\" class=\"no-text-select mr-10\">{{condition.ConditionName}}</span><div flex=\"5\" layout=\"row\" layout-align=\"start center\"><span class=\"no-text-select bold-text mr-10\">is</span></div><div flex=\"20\" layout=\"row\" layout-align=\"start center\"><span class=\"no-text-select mr-10\">{{condition.ConditionCompareTypeName}}</span></div><div flex=\"30\" layout=\"row\" layout-align=\"start center\" class=\"condition-value\"><md-icon ng-if=\"condition.ConditionValueTypeId == 4 && condition.ConditionValueDisplayText\" flex=\"\" layout-align=\"start center\" md-font-icon=\"icon-check\" class=\"s18\"></md-icon><md-icon ng-if=\"condition.ConditionValueTypeId == 4 && !condition.ConditionValueDisplayText\" flex=\"\" layout-align=\"start center\" md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span ng-if=\"condition.ConditionValueTypeId != 4 && condition.ConditionValueDisplayText\" class=\"no-text-select\">{{condition.ConditionValueDisplayText}}</span> <span ng-if=\"condition.ConditionValueTypeId != 4 && !condition.ConditionValueDisplayText\" class=\"no-text-select text-uppercase text-italic font-size-10\">Not Set</span></div></div></div></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/awards/manage/classification-rates/award-classification-rates.html","<div id=\"award-classification\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"content\" layout=\"column\" layout-padding=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"\" class=\"m-10\" layout-align=\"center start\" layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"\" flex-xs=\"100\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.searchText\" ng-keyup=\"vm.searchTable()\"></md-input-container></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"vm.dtInstance\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" style=\"width: 40%\"><div class=\"table-header\"><span class=\"column-title\">Rate</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Rate Type</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Pay Code</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">Pay Rate</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"></th></tr></thead><tbody><tr ng-repeat=\"classificationRate in vm.classificationRates | orderBy:[\'RateOrder\',\'PayCode\']\"><td><div>{{classificationRate.RateName}}</div><div class=\"md-caption\">{{classificationRate.RateDescription}}</div></td><td><span>{{classificationRate.RateTypeDisplayName}}</span></td><td><span>{{classificationRate.PayCode}}</span></td><td><div ng-if=\"classificationRate.PayCode && classificationRate.BaseRate > 0\">{{classificationRate.PayRate | currency:\"$\":8}}</div><div ng-if=\"classificationRate.PayCode && classificationRate.PayRate < classificationRate.BaseRate\" class=\"warning-text-small pt-5\">Lower than classification base rate !</div><div ng-if=\"classificationRate.PayCode && classificationRate.BaseRate <= 0\" class=\"warning-text-small pt-5\">Cannot calculate pay rate without a classfication base rate !</div></td><td><div ng-click=\"vm.editRate(classificationRate)\" layout-align=\"start center\" class=\"pt-5 pb-5\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-cog\" class=\"s20 mr-5\"></md-icon><span>Edit Rate</span></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/awards/manage/rates/award-rates.html","<div id=\"award-rates\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div layout=\"column\" layout-padding=\"\"><div class=\"white-bg md-whiteframe-1dp p-20\"><h2>Configured Rates</h2><div class=\"draggable-container\" flex=\"40\" flex-xs=\"100\" layout=\"column\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.rates\"><div class=\"draggable-item\" layout=\"row\" ng-repeat=\"rate in vm.rates\"><md-icon md-font-icon=\"icon-drag\" class=\"s18\" ng-class=\"{\'drag-handle\': rate.IsActive}\"></md-icon><div flex=\"60\" layout=\"column\" layout-align=\"center start\"><span class=\"bold-text\">{{rate.RateName}}</span> <span class=\"md-caption\">{{rate.RateDescription}}</span></div><span flex=\"\"></span><div ng-click=\"vm.viewConditions(rate)\" flex=\"25\" layout=\"row\" layout-align=\"start center\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-cog\" class=\"s20 mr-5\"></md-icon><span>Conditions</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/awards/manage/rules/award-rules.html","<div id=\"award-settings\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div layout=\"column\" layout-padding=\"\"><div class=\"white-bg md-whiteframe-1dp p-20\"><h2>Configured Award Rules</h2><div class=\"settings-container\" flex=\"40\" flex-xs=\"100\" layout=\"column\"><div class=\"setting-item\" layout=\"row\" ng-repeat=\"setting in vm.settings | orderBy: \'-IsEnabled\'\"><md-icon ng-if=\"setting.IsEnabled\" md-font-icon=\"icon-toggle-switch-on\" class=\"s18 icon-active\"></md-icon><md-icon ng-if=\"!setting.IsEnabled\" md-font-icon=\"icon-toggle-switch-off\" class=\"s18 icon-inactive\"></md-icon><div flex=\"60\" layout=\"column\" layout-align=\"center start\"><span class=\"bold-text\">{{setting.SettingName}}</span> <span class=\"md-caption\">{{setting.SettingDescription}}</span></div><span flex=\"\"></span><div ng-if=\"setting.IsEnabled && setting.Conditions.length > 0\" ng-click=\"vm.viewConditions(setting)\" flex=\"25\" layout=\"row\" layout-align=\"start center\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-cog\" class=\"s20\"></md-icon><span>Conditions</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/awards/manage/view/awards-view.html","<div id=\"awards-view\" class=\"page-layout simple right-sidenav main-style\" layout=\"column\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"content\" layout-padding=\"\"><div flex=\"\" class=\"m-10\" layout-align=\"end start\" layout=\"row\" layout-xs=\"column\"><div ng-click=\"vm.addAward()\" style=\"cursor: pointer;\" flex=\"15\" flex-xs=\"100\" flex-sm=\"30\" flex-md=\"25\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-fab md-mini md-accent pull-right btn-add\" aria-label=\"Add new Award\" style=\"background-color: #4A1EBD;\"><md-icon class=\"icon-plus\"></md-icon></md-button><div style=\"color: #BB06FE;\">Add new Award</div></div></div><div layout-align=\"start center\" layout=\"row\" layout-wrap=\"\"><div class=\"card\" flex=\"20\" flex-xs=\"100\" flex-sm=\"40\" flex-md=\"30\" ng-repeat=\"award in vm.service.awards | orderBy:[\'IsArchived\', \'Name\']\"><div layout=\"row\" layout-align=\"start-center\" class=\"card-row\"><span class=\"no-text-select mr-10 text-bold text-truncate font-size-14\">{{award.Name}}</span> <span flex=\"\"></span><div ng-click=\"vm.editAward(award)\" flex=\"25\" layout=\"row\" layout-align=\"start center\" style=\"cursor: pointer;\"><md-icon md-font-icon=\"icon-cog\" class=\"s18 mr-5\"></md-icon><span class=\"font-size-10\">Settings</span></div></div><hr class=\"card-row\"><div flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"card-row\"><span class=\"text-bold mr-20\">Agreement #</span> <span>{{award.AgreementNumber}}</span></div><hr class=\"card-row\"><div flex=\"\" layout=\"column\" layout-align=\"center start\" class=\"card-row\"><span class=\"text-bold text-uppercase mb-5\" style=\"color: #BB06FE;\">Expiry: {{award.AgreementExpiry | date:\'dd/MM/yyyy\'}}</span><div ng-if=\"award.IsArchived\"><md-icon md-font-icon=\"icon-toggle-switch-off\" class=\"s18 mr-5\" style=\"color: #ff4271\"></md-icon><span>Inactive</span></div><div ng-if=\"!award.IsArchived\"><md-icon md-font-icon=\"icon-toggle-switch-on\" class=\"s18 mr-5\" style=\"color: #00d488;\"></md-icon><span>Active</span></div></div><div flex=\"\" layout=\"column\" class=\"card-row\"><div class=\"card-full-button\" ng-click=\"vm.viewRates(award)\"><span class=\"button-text\">Pay Rates</span> <span flex=\"\"></span> <i class=\"icon-chevron-right\"></i></div><div class=\"card-full-button\" ng-click=\"vm.viewClassifications(award)\"><span class=\"button-text\">Classifications</span> <span flex=\"\"></span> <i class=\"icon-chevron-right\"></i></div><div class=\"card-full-button\" ng-click=\"vm.viewAllowances(award)\"><span class=\"button-text\">Allowances</span> <span flex=\"\"></span> <i class=\"icon-chevron-right\"></i></div><div class=\"card-full-button\" ng-click=\"vm.viewRules(award)\"><span class=\"button-text\">Rules & Conditions</span> <span flex=\"\"></span> <i class=\"icon-chevron-right\"></i></div><div class=\"card-full-button\" ng-click=\"vm.viewAddOns(award)\"><span class=\"button-text\">Add-ons</span> <span flex=\"\"></span> <i class=\"icon-chevron-right\"></i></div></div><div flex=\"\" layout=\"row\" class=\"card-row\" ng-if=\"award.ShiftAdjustments && award.ShiftAdjustments.length > 0\"><span class=\"button-text warning-text-small\">This award has Shift Adjustments.</span></div><div flex=\"\" layout=\"row\" layout-align=\"end center\" class=\"card-row md-caption font-size-10\"><span>Last Updated: {{award.UpdatedDate | date:\'dd/MM/yyyy\'}}</span></div></div></div></div></div></div>");
$templateCache.put("app/main/costEstimate/directives/customGridSearch/ce-custom-grid-search.html","<div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.srcData\" type=\"text\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Search for a Cost Estimate\" translate=\"\" translate-attr-placeholder=\"COST_ESTIMATE.SEARCH\"></div>");
$templateCache.put("app/main/costEstimate/directives/grid/ce-grid-pagination.html","<div></div>");
$templateCache.put("app/main/customFieldsManager/binder/modelWatcherDirective/modelWatcher.html","<md-card flex=\"\" class=\"blue-grey-200-bg\"><md-card-content layout=\"row\"><div layout=\"column\" flex=\"\" layout-padding=\"\" layout-margin=\"\"><span class=\"md-subhead\">Model</span><md-divider></md-divider><pre class=\"md-body-1\">\r\n                {{vm.model | json}}\r\n             </pre></div><md-divider></md-divider><div layout=\"column\" flex=\"\" layout-padding=\"\" layout-margin=\"\"><span class=\"md-subhead\">Values</span><md-divider></md-divider><pre class=\"md-body-1\">\r\n                {{vm.values | json}}\r\n            </pre></div></md-card-content></md-card>");
$templateCache.put("app/main/company/create/companyInfo/companyInfo.html","<div><form novalidate=\"\" name=\"info\" a8-dirty-form-confirmation=\"\"><div layout=\"column\" layout-gt-md=\"row\"><md-input-container flex=\"85\" flex-order-md=\"2\" flex-order-sm=\"2\" flex-order-xs=\"2\"><input type=\"text\" ng-model=\"companyInfoVm.companyInfo.CompanyName\" name=\"{{\'COMPANYMODULE.COMPANY_NAME\' | translate}}\" ng-blur=\"companyInfoVm.service.validateDuplicateCompany()\" placeholder=\"{{\'COMPANYMODULE.COMPANY_NAME\' | translate}}\" required=\"\"></md-input-container><div flex=\"15\" layout=\"column\" layout-align-gt-md=\"center center\" layout-align-md=\"center center\" layout-align-sm=\"center center\" layout-align-xs=\"center center\" flex-order-md=\"1\" flex-order-sm=\"1\" flex-order-xs=\"1\"><label class=\"image-input\" for=\"companyLogo\"><i class=\"icon icon-pencil s40\"></i> <img class=\"profile-image avatar huge\" src=\"assets/images/avatars/company.jpg\" ng-src=\"{{companyInfoVm.companyInfo.LogoUrl}}\"></label> <input type=\"file\" id=\"companyLogo\" class=\"image-input\" a8-file-upload=\"files\" upload-url=\"companyInfoVm.uploadUrl\" on-upload-start=\"companyInfoVm.onUploadStart()\" on-upload-validate=\"companyInfoVm.onUploadValidate(fileObj)\" on-upload-completed=\"companyInfoVm.onUploadCompleted(data)\" on-upload-error=\"companyInfoVm.onUploadError(ex)\"><div ng-if=\"companyInfoVm.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear><span class=\"md-caption\">Uploading...</span></div></div></div><div class=\"code\" layout=\"column\" layout-gt-md=\"row\" flex-gt-md=\"85\"><md-input-container flex=\"\"><input type=\"text\" ng-change=\"companyInfoVm.service.validate()\" ng-blur=\"companyInfoVm.service.validateCode(companyInfoVm.companyInfo.CompanyCode)\" ng-model=\"companyInfoVm.companyInfo.CompanyCode\" placeholder=\"{{\'COMPANYMODULE.COMPANY_CODE\' | translate}}\" name=\"{{\'COMPANYMODULE.COMPANY_CODE\' | translate}}\" ng-pattern=\"companyInfoVm.companyCodePattern\" ng-required=\"companyInfoVm.service.generalSettings.RequiresCompanyCode\"><div ng-if=\"companyInfoVm.service.generalSettings.CompanyCodeFormat === companyInfoVm.alphanumericFormat\" class=\"hint\">Enter a code of letters and/or numbers. Min of 4 to max 16 characters</div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" flex-gt-md=\"85\"><md-input-container flex=\"50\"><label translate=\"COMPANYMODULE.COMPANY_TYPES\"></label><md-select name=\"{{\'COMPANYMODULE.COMPANY_TYPES\' | translate}}\" placeholder=\"{{\'COMPANYMODULE.COMPANY_TYPES\' | translate}}\" ng-change=\"companyInfoVm.changeFields()\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"\" md-selected-text=\"companyInfoVm.utilService.getSelectedText(companyInfoVm.companyInfo.CompanyType, companyInfoVm.utilService.translate(\'COMPANYMODULE.COMPANY_TYPES\'), \'TypeName\')\" ng-model=\"companyInfoVm.companyInfo.CompanyType\" required=\"\"><md-optgroup label=\"Company Type\"><md-option ng-repeat=\"companyType in companyInfoVm.service.companyTypeList\" ng-value=\"companyType\">{{companyType.TypeName}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"50\"><input type=\"url\" name=\"website\" ng-model=\"companyInfoVm.companyInfo.Website\" placeholder=\"{{\'COMPANYMODULE.COMPANY_WEBSITE\' | translate}}\"></md-input-container></div></form></div>");
$templateCache.put("app/main/company/create/companyDetails/company-details.html","<div class=\"company-details\"><form class=\"md-inline-form\" name=\"details\" novalidate=\"\" unsaved-warning-form=\"\"><div layout=\"column\" layout-gt-sm=\"row\" flex-gt-md=\"85\"><md-input-container flex=\"50\"><label translate=\"COMPANYMODULE.COMPANY_BRANCHES\"></label><md-select name=\"{{\'COMPANYMODULE.COMPANY_BRANCHES\' | translate}}\" placeholder=\"{{\'COMPANYMODULE.COMPANY_BRANCHES\' | translate}}\" multiple=\"\" md-selected-text=\"detailsVm.utilService.getSelectedText(detailsVm.model.Branches2, detailsVm.utilService.translate(\'COMPANYMODULE.COMPANY_BRANCHES\'), \'Name\')\" ng-model-options=\"{trackBy : \'$value.Id\'}\" ng-model=\"detailsVm.model.Branches2\" ng-change=\"detailsVm.changeBranch()\" required=\"\"><md-optgroup label=\"{{\'COMPANYMODULE.COMPANY_BRANCHES\' | translate}}\"><md-option ng-repeat=\"branch in detailsVm.companyLookups.Branches\" ng-value=\"branch\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex-gt-md=\"85\"><md-input-container><label translate=\"COMPANYMODULE.COMPANY_DIVISIONS\"></label><md-select flex=\"\" placeholder=\"{{\'COMPANYMODULE.COMPANY_DIVISIONS\' | translate}}\" md-selected-text=\"detailsVm.utilService.getSelectedText(detailsVm.model.Division, detailsVm.utilService.translate(\'COMPANYMODULE.COMPANY_DIVISIONS\'), \'Name\')\" multiple=\"\" ng-model-options=\"{trackBy : \'$value.id\'}\" ng-model=\"detailsVm.model.Division\"><md-optgroup label=\"Divisions\"><md-option ng-value=\"itm\" ng-repeat=\"itm in detailsVm.companyLookups.filtered_divisions | unique:\'id\'\">{{itm.Name}} - [{{itm.BranchName}}]</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"detailsVm.service.isClient && detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_RATE_CARD\"></label><md-select flex=\"\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model-options=\"{trackBy : \'$value.Id\'}\" placeholder=\"Rate Card\" ng-model=\"detailsVm.model.RateCard\"><md-option ng-value=\"itm\" ng-repeat=\"itm in detailsVm.rateCards\">{{itm.Name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"detailsVm.service.isClient && detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_INVOICE_TERMS\"></label><md-select flex=\"\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model-options=\"{trackBy : \'$value.Id\'}\" placeholder=\"{{\'COMPANYMODULE.COMPANY_INVOICE_TERMS\' | translate}}\" ng-model=\"detailsVm.model.InvoiceTerm\"><md-option ng-value=\"itm\" ng-repeat=\"itm in detailsVm.termDays\">{{itm.Name}}</md-option></md-select><md-icon md-font-icon=\"icon-plus-box\" ng-if=\"detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-click=\"detailsVm.addInvoiceTerm()\"></md-icon></md-input-container></div><div layout=\"row\" ng-if=\"detailsVm.service.isClient\" layout-sm=\"column\" layout-md=\"column\" flex-gt-md=\"85\"><md-input-container flex=\"\" ng-if=\"detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_TRAVEL_BILLING_PREFERENCE\">Travel Billing Preference</label><md-select ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model-options=\"{trackBy: \'$value\'}\" ng-model=\"detailsVm.model.TravelBillingPreference\"><md-option value=\"0\">{{\'COMPANYMODULE.COMPANY_LOOKUP_USE_RATE_CARD_PREFERENCE\' | translate}}</md-option><md-option value=\"3\">{{\'COMPANYMODULE.COMPANY_LOOKUP_DO_NOT_CHARGE\' | translate}}</md-option><md-option value=\"1\">{{\'COMPANYMODULE.COMPANY_LOOKUP_CHARGE_AS_HOURS\' | translate}}</md-option><md-option value=\"2\" ng-if=\"detailsVm.checkAccessService.isAltusSpecialEnabled()\">{{\'COMPANYMODULE.COMPANY_LOOKUP_CHARGE_AS_FIXED\' | translate}}</md-option><md-option value=\"4\" ng-if=\"detailsVm.checkAccessService.isAltusSpecialEnabled()\">{{\'COMPANYMODULE.COMPANY_LOOKUP_CHARGE_AS_HOURS_KM\' | translate}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_EMPLOYEE_BREAKS\"></label><md-select ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model-options=\"{trackBy: \'$value\'}\" ng-model=\"detailsVm.model.ChargeForEmployeeBreaks\"><md-option ng-value=\"detailsVm.null\">{{\'COMPANYMODULE.COMPANY_LOOKUP_USE_RATE_CARD_PREFERENCE\' | translate}}</md-option><md-option value=\"1\">{{\'COMPANYMODULE.COMPANY_LOOKUP_YES\' | translate}}</md-option><md-option value=\"0\">{{\'COMPANYMODULE.COMPANY_LOOKUP_NO\' | translate}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_EQUIPMENT_BREAKS\"></label><md-select ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model-options=\"{trackBy: \'$value\'}\" ng-model=\"detailsVm.model.ChargeForEquipmentBreaks\"><md-option ng-value=\"detailsVm.null\">{{\'COMPANYMODULE.COMPANY_LOOKUP_USE_RATE_CARD_PREFERENCE\' | translate}}</md-option><md-option value=\"1\">{{\'COMPANYMODULE.COMPANY_LOOKUP_YES\' | translate}}</md-option><md-option value=\"0\">{{\'COMPANYMODULE.COMPANY_LOOKUP_NO\' | translate}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_INVOICE_TOTALLING\"></label><md-select ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model-options=\"{trackBy: \'$value\'}\" ng-model=\"detailsVm.model.InvoiceTotallingPreference\"><md-option ng-value=\"detailsVm.null\">{{\'COMPANYMODULE.COMPANY_LOOKUP_USE_RATE_CARD_PREFERENCE\' | translate}}</md-option><md-option value=\"1\">{{\'COMPANYMODULE.COMPANY_LOOKUP_TOTAL_INDIVIDUAL_ITEM\' | translate}}</md-option><md-option value=\"2\">{{\'COMPANYMODULE.COMPANY_LOOKUP_TOTAL_ALL_ITEMS\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"detailsVm.service.isClient\" layout-sm=\"column\" layout-md=\"column\" flex-gt-md=\"85\"><md-input-container flex=\"\" ng-if=\"detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_BATCH_INVOICES\"></label><md-select ng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model=\"detailsVm.model.BatchInvoices\"><md-option ng-value=\"itm.Id\" ng-repeat=\"itm in detailsVm.companyLookups.BatchInvoices\">{{itm.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_PDF_INVOICE_TEMPLATE\"></label><md-select ng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model=\"detailsVm.model.PdfInvoiceTemplate\"><md-option ng-value=\"itm.Id\" ng-repeat=\"itm in detailsVm.companyLookups.PDFInvoiceTemplate\">{{itm.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"detailsVm.checkAccessService.isBillingEnabled()\"><label translate=\"COMPANYMODULE.COMPANY_LINE_ITEM_TEMPLATE\"></label><md-select ng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model=\"detailsVm.model.LineItemTemplate\"><md-option ng-value=\"itm.Id\" ng-repeat=\"itm in detailsVm.companyLookups.LineItemTemplate\">{{itm.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"detailsVm.checkAccessService.isPayrollEnabled()\"><input numeric=\"\" decimals=\"3\" name=\"SiteAllowance\" ng-model=\"detailsVm.model.SiteAllowance\" type=\"text\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" min=\"0\" placeholder=\"{{\'COMPANYMODULE.COMPANY_SITE_ALLOWANCE\' | translate}}\"><div ng-messages=\"infoForm.SiteAllowance.$error\" role=\"alert\"><div ng-message=\"min\"><span translate=\"COMPANYMODULE.COMPANY_SITE_ALLOWANCE_MIN\"></span></div></div></md-input-container></div><div layout=\"row\" ng-if=\"detailsVm.service.isClient && detailsVm.checkAccessService.isBillingEnabled()\" layout-sm=\"column\" layout-md=\"column\" flex-gt-md=\"85\"><md-input-container flex=\"25\" flex-xs=\"100\" flex-sm=\"100\" flex-md=\"50\"><label translate=\"COMPANYMODULE.CREDIT_TYPE\"></label><md-select ng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" name=\"{{\'COMPANYMODULE.CREDIT_TYPE\' | translate}}\" placeholder=\"{{\'COMPANYMODULE.CREDIT_TYPE\' | translate}}\" ng-required=\"detailsVm.service.isClient && detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-change=\"detailsVm.changeCreditType(detailsVm.model.CreditType)\" ng-model=\"detailsVm.model.CreditType\"><md-option ng-value=\"itm.Id\" ng-repeat=\"itm in detailsVm.companyLookups.CreditTypes\">{{itm.Value}}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-show=\"detailsVm.service.isClient\" layout-sm=\"column\" layout-md=\"column\" flex-gt-md=\"85\"><md-input-container flex=\"25\" flex-xs=\"100\" flex-sm=\"100\" flex-md=\"50\"><label translate=\"COMPANYMODULE.LEGAL_ENTITY_NAME\"></label> <input type=\"text\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model=\"detailsVm.model.LegalEntityName\" name=\"legal_entity_name\" placeholder=\"{{\'COMPANYMODULE.LEGAL_ENTITY_NAME\' | translate}}\"></md-input-container></div><div layout=\"row\" layout-lt-md=\"column\" flex-gt-md=\"85\" ng-show=\"detailsVm.service.isClient\"><div flex=\"\"><md-checkbox ng-model=\"detailsVm.model.IsProjectMandatory\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\">{{\'COMPANYMODULE.COMPANY_PROJECT_IS_MANDATORY\' | translate}}</md-checkbox></div><div flex=\"\"><md-checkbox ng-model=\"detailsVm.model.IsPurchaseOrderMandatory\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\">{{\'COMPANYMODULE.PURCHASE_ORDER_IS_MANDATORY\' | translate}}</md-checkbox></div><div flex=\"\" ng-if=\"detailsVm.checkAccessService.isBillingEnabled()\"><md-checkbox ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" ng-model=\"detailsVm.model.EmailInvoices\">{{\'COMPANYMODULE.COMPANY_EMAIL_INVOICES\' | translate}}</md-checkbox></div><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\" md-no-ink=\"\" aria-label=\"Checkbox No Ink\" ng-model=\"detailsVm.model.IsInactive\" class=\"md-primary\">{{\'COMPANYMODULE.COMPANY_MARK_AS_INACTIVE\' | translate}}</md-checkbox></div></div><div layout=\"row\" layout-lt-md=\"column\" flex-gt-md=\"50\"><div flex=\"\" ng-show=\"detailsVm.isSendPaperworkToSiteContactCheckboxVisible\"><md-checkbox ng-model=\"detailsVm.model.SendPaperworkToSiteContact\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\">{{\'COMPANYMODULE.SEND_PAPERWORK_TO_SITE_CONTACT\' | translate}}</md-checkbox></div><div flex=\"\" ng-hide=\"!detailsVm.isContactlessSignatureEnabled\"><md-checkbox ng-model=\"detailsVm.model.RequireSignatureInInvoicing\" ng-disabled=\"!detailsVm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\">{{\'COMPANYMODULE.REQUIRE_SIGNATURE_IN_INVOICING\' | translate}}</md-checkbox></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex-gt-md=\"85\"><contact-preference-component2 name=\"form\" ng-model=\"detailsVm.model.ContactsPreferences\" contact-list=\"detailsVm.service.minified_contacts\" flex=\"100\"></contact-preference-component2></div><div layout=\"column\" flex=\"85\" ng-if=\"detailsVm.service.isClient && detailsVm.isMyobEnabled\"><myob-company ng-model=\"detailsVm.model\" branches=\"detailsVm.model.Branches2\"></myob-company></div><div layout=\"column\" flex=\"85\" ng-if=\"detailsVm.service.isClient && detailsVm.isXeroEnabled\"><xero-company ng-model=\"detailsVm.model\" branches=\"detailsVm.model.Branches2\"></xero-company></div><div layout=\"column\" flex=\"85\" ng-if=\"detailsVm.service.isClient && detailsVm.isPayrollEnabled\"><company-award ng-model=\"detailsVm.model\" branches=\"detailsVm.model.Branches2\"></company-award></div><div layout=\"column\" flex-gt-md=\"85\" ng-if=\"detailsVm.service.isEditMode\"><div ng-include=\"\'app/main/company/create/companyDetails/Skills/skills.html\'\"></div></div><div flex=\"85\"><a8-emails-with-type ng-model=\"detailsVm.model.Emails\" show-attachment-preferences=\"detailsVm.isEmailAttachmentPreferencesEnabled\" validate-duplicate=\"detailsVm.service.validateDuplicateCompany()\"></a8-emails-with-type></div><div flex=\"85\"><a8-phone-numbers-company ng-model=\"detailsVm.model.Mobiles\" phone-types=\"detailsVm.companyLookups.PhoneTypes\" validate-duplicate=\"detailsVm.service.validateDuplicateCompany()\"></a8-phone-numbers-company></div><div layout=\"column\" flex=\"85\"><multi-address-company ng-model=\"detailsVm.model.Addresses\"></multi-address-company></div><div layout=\"column\" flex=\"85\" ng-if=\"detailsVm.checkAccessService.isCustomFormsEnabled() || (detailsVm.checkAccessService.isDocumentManagementEnabled() && detailsVm.service.isEditMode)\"><p class=\"md-subhead\" translate=\"WIDGETS_LOC.FORMS_AND_ATTACHMENTS\"></p><md-card class=\"_md md-default-theme\"><md-card-content><div layout=\"column\"><div layout=\"row\" ng-if=\"detailsVm.checkAccessService.isCustomFormsEnabled()\"><form-templates-list flex=\"\" linked-form-templates=\"detailsVm.service.linkedFormTemplates\" form-types=\"detailsVm.formTypes\" unlinked-form-templates=\"detailsVm.service.unlinkedFormTemplates\" overridden-form-templates=\"detailsVm.service.overriddenFormTemplates\" api=\"detailsVm.service.formTemplatesListApi\" vehicles=\"detailsVm.service.vehicles\" assets=\"detailsVm.service.assets\" always-refresh-forms-list=\"detailsVm.service.isEditMode\" applied-to=\'[\"AllCompanies\"]\' ng-if=\"detailsVm.checkAccessService.isCustomFormsEnabled()\"></form-templates-list></div><div layout=\"row\" ng-if=\"detailsVm.service.isEditMode && detailsVm.checkAccessService.isDocumentManagementEnabled()\"><document-manager module-id=\"2\" flex=\"100\" module-name=\"Company\" related-resource-id=\"{{detailsVm.companyId}}\" disable-add=\"!detailsVm.adminClaimsService.hasDocumentsManagerCompanies\" disable-edit=\"!detailsVm.adminClaimsService.hasDocumentsManagerCompanies\" disable-delete=\"!detailsVm.adminClaimsService.hasDocumentsManagerCompanies\" ng-if=\"detailsVm.checkAccessService.isDocumentManagementEnabled()\"></document-manager></div></div></md-card-content></md-card></div><div layout=\"column\" flex=\"85\" ng-if=\"detailsVm.service.isEditMode && detailsVm.isConfigurableRequiredAttachmentsEnabled\"><required-attachment-types attachment-types=\"detailsVm.model.RequiredAttachmentTypes\" remove-callback=\"detailsVm.removeRequiredAttachmentType\" entity-name=\"company\"></required-attachment-types></div></form></div>");
$templateCache.put("app/main/company/create/companyDetails/invoice-term-dialog.html","<md-dialog class=\"main-style\" flex=\"30\" ng-cloak=\"\" block-ui=\"add-project\"><form name=\"holidayForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"COMPANYMODULE.COMPANY_INVOICE_TERMS_HEADERS\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"text\" name=\"Name\" ng-pattern=\"vm.invoiceTermPattern\" ng-model=\"vm.Name\" placeholder=\"{{\'COMPANYMODULE.COMPANY_INVOICE_TERMS_NAME\' | translate}}\" required=\"\"><div ng-messages=\"holidayForm.Name.$error\" ng-show=\"holidayForm.Name.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span translate=\"COMPANYMODULE.COMPANY_INVOICE_TERMS_NAME_INVALID_FORMAT\"></span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised\" translate=\"COMPANYMODULE.COMPANY_INVOICE_TERMS_CANCEL\" ng-click=\"vm.onClose()\"></md-button><md-button class=\"md-raised md-accent\" translate=\"COMPANYMODULE.COMPANY_INVOICE_TERMS_SAVE\" ng-click=\"vm.onSave()\" ng-disabled=\"holidayForm.$invalid\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/company/view/templates/dates.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"30\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'VIEWCOMPANIES.DATE_RANGE_HEADER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"auto\" ng-form=\"datesForm\"><div flex=\"\" layout-align=\"center center\"><md-radio-group ng-model=\"vm.service.filterModel.filterType\" layout=\"row\" layout-sm=\"column\" required=\"\"><md-radio-button value=\"1\" ng-checked=\"\">{{\'VIEWCOMPANIES.DATE_RANGE_CREATED_DATE\' | translate}}</md-radio-button><md-radio-button value=\"2\">{{\'VIEWCOMPANIES.DATE_RANGE_UPDATED_DATE\' | translate}}</md-radio-button></md-radio-group></div><div flex=\"\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-input-container><label>{{\'VIEWCOMPANIES.DATE_RANGE_START_DATE\' | translate}}</label><md-datepicker ng-model=\"vm.service.filterModel.startDate\"></md-datepicker></md-input-container><md-input-container><label>{{\'VIEWCOMPANIES.DATE_RANGE_END_DATE\' | translate}}</label><md-datepicker ng-model=\"vm.service.filterModel.endDate\"></md-datepicker></md-input-container></div><div flex=\"\" layout=\"row\">{{\'VIEWCOMPANIES.DATE_RANGE_TIP\' | translate}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"datesForm.$invalid\" ng-click=\"vm.applyFilter()\">{{\'VIEWCOMPANIES.DATE_RANGE_APPLY\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/costEstimate/preview/sidenav/main-sidenav.html","<md-content ms-scroll=\"\" class=\"content margin-left-15\" flex=\"\"><form name=\"basicInfoForm\"><div class=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"Generate\" ng-click=\"invRepVm.generatePreview()\" ng-disabled=\"basicInfoForm.$invalid || basicInfoForm.$pristine || invRepVm.sidenavModel.processingInvoice || invRepVm.sidenavModel.isLocked\">Generate</md-button></div><div class=\"loading-threads margin-top-10\" layout=\"column\" layout-align=\"center center\" ng-if=\"invRepVm.sidenavModel.processingInvoice\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular><div class=\"margin-top-10\"><strong>{{invRepVm.sidenavModel.generationMessage}}</strong></div></div><div class=\"navigation-simple\" layout=\"column\" flex=\"100\"><div layout-margin=\"\"><div layout=\"row\"><md-input-container flex=\"100\"><md-select name=\"rateCards\" ng-model=\"invRepVm.sidenavModel.data.selectedRate\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-disabled=\"invRepVm.sidenavModel.isLocked\" placeholder=\"Rate Card(s)\" md-autofocus=\"\"><md-optgroup label=\"Rate Card(s)\"><md-option ng-value=\"rate\" ng-repeat=\"rate in invRepVm.sidenavModel.rateCardLookups\">{{rate.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div></div></form></md-content>");
$templateCache.put("app/main/costEstimate/preview/winlost/win-lost-dialog.html","<md-dialog flex=\"35\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Lost Reason</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"companyManageDialogForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"row\"><md-input-container flex=\"100\"><label>Lost Status</label><md-select name=\"lostState\" ng-model=\"vm.inputModel.selectedLostStatus\" ng-change=\"vm.lostStatusChanged()\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"Lost Status\" required=\"\" md-autofocus=\"\"><md-optgroup label=\"Lost Status\"><md-option ng-value=\"status\" ng-repeat=\"status in vm.lostStates\">{{status.Value}}</md-option></md-optgroup></md-select></md-input-container></div><company-select-component label=\"vm.winningCompanyLabel\" ng-model=\"vm.winningCompaniesLookup\" on-select-company=\"vm.onSelectCompany(item)\" pre-select=\"vm.winningCompetitor\" ng-show=\"vm.inputModel.showWinningCompany\"></company-select-component><company-select-component label=\"vm.winningCompetitorLabel\" ng-model=\"vm.competitorsLookup\" on-select-company=\"vm.onSelectCompetitor(item)\" on-create-competitor=\"vm.onCreateCompetitor()\" allow-add=\"true\" pre-select=\"vm.selectedCompetitor\" ng-show=\"vm.inputModel.showCompetitor\"></company-select-component><md-input-container flex=\"\"><label>Winning Amount</label> <input type=\"text\" name=\"amount\" ng-model=\"vm.inputModel.winningAmount\" placeholder=\"0.00\" a8-num-formatter=\"\" num-currency=\"$\" decimal-place=\"2\"><div ng-messages=\"companyManageDialogForm.amount.$error\" ng-show=\"companyManageDialogForm.amount.$touched\" role=\"alert\"><div ng-message=\"number\"><span translate=\"COST_ESTIMATE.WINNING_AMOUNT_IS_INVALID\"></span></div></div></md-input-container><md-input-container class=\"md-block\" ng-show=\"vm.inputModel.showCompetitor\"><label>Lost Reason</label> <textarea ng-model=\"vm.inputModel.lostReason\" md-maxlength=\"150\" rows=\"5\" md-select-on-focus=\"\"></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\" translate=\"COST_ESTIMATE.COMPANYPOPUPCANCELTEXT\"></md-button><md-button class=\"md-accent\" aria-label=\"Update cost estimate Win Lost\" ng-click=\"vm.onUpdate()\" translate=\"COST_ESTIMATE.UPDATE\" ng-disabled=\"companyManageDialogForm.$invalid\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/costEstimate/view/ce-date-chooser/ce-date-chooser.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Dates</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"auto\" ng-form=\"datesForm\"><div flex=\"\" layout-align=\"center center\"><md-radio-group ng-model=\"vm.model.data.filterType\" layout=\"row\" layout-sm=\"column\" required=\"\"><md-radio-button value=\"1\" selected=\"\">Job Start Date</md-radio-button><md-radio-button value=\"2\">Invoice Date</md-radio-button></md-radio-group></div><div flex=\"\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-input-container><label>Start Date</label><md-datepicker ng-model=\"vm.model.data.startDate\" required=\"\"></md-datepicker></md-input-container><md-input-container><label>End Date</label><md-datepicker ng-model=\"vm.model.data.endDate\" required=\"\"></md-datepicker></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"datesForm.$invalid\" ng-click=\"vm.applyFilter()\">Apply Date Filter</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/customFieldsManager/views/sidenav/main-sidenav.html","<div class=\"header main-style sidenav-design\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-camera-iris\" class=\"icon title-icon\"></md-icon></span> <span class=\"logo-text\">Custom Fields Manager</span></div></div><md-content class=\"content margin-left-30\" layout=\"column\" flex=\"\" layout-padding=\"\"><div ng-if=\"!vm.service.loading\" style=\"width : 300px;\" layout=\"row\"><md-button ng-if=\"!vm.service.something_has_been_selected\" ng-click=\"vm.service.prepareForAdd()\" style=\"margin-left : -2px;\" class=\"md-accent md-raised\">Add</md-button></div><div class=\"navigation-simple\" layout=\"column\" flex=\"100\"><md-radio-group ng-disabled=\"vm.service.something_has_been_selected\" ng-change=\"vm.service.getCustomFields(vm.service.chosen_module)\" ng-model=\"vm.service.chosen_module\"><md-radio-button ng-value=\"module.Id\" ng-repeat=\"module in vm.service.modules\">{{module.Name}}</md-radio-button></md-radio-group></div></md-content>");
$templateCache.put("app/main/contact/calendar/calendar-entry/calendar-entry.html","<div id=\"calendar-entry\" class=\"page-layout simple\" layout=\"column\"><md-tabs class=\"white-bg md-whiteframe-4dp\" md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selectedTabIndex\"><md-tab label=\"ADD NEW CALENDAR ENTRY\" ng-click=\"vm.goToTab(0)\"></md-tab><md-tab label=\"MANAGE CALENDAR ENTRY REQUESTS\" ng-click=\"vm.goToTab(1)\" ng-if=\"vm.hasApproveCalendarEntries\"></md-tab></md-tabs><div class=\"tab-content-container md-whiteframe-4dp padding-20\" flex=\"\" ui-view=\"tab-content\"></div></div>");
$templateCache.put("app/main/contact/create/personal/personal.html","<div class=\"main-style\"><form name=\"personal\" novalidate=\"\" a8-dirty-form-confirmation=\"\"><input type=\"password\" style=\"display: none;\" autocomplete=\"new-password\"><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-md=\"10\" flex-gt-md=\"10\" flex-order-xs=\"2\" flex-order-sm=\"2\" flex-order-md=\"2\" layout=\"column\"><md-input-container flex=\"\" id=\"title\"><label translate=\"CONTACTSMODULE.TITLE\"></label><md-select ng-model=\"vmContact.service.contactData.ContactTitle\" ng-model-options=\"{trackBy: \'$value.ContactTitleId\'}\" id=\"contact-title\"><md-option value=\"\"></md-option><md-option ng-repeat=\"title in vmContact.ContactTitles\" ng-value=\"title\">{{ title.Title }}</md-option></md-select></md-input-container></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"20\" flex-order-xs=\"3\" flex-order-sm=\"3\" flex-order-md=\"3\" layout=\"column\"><md-input-container flex=\"\" id=\"first-name\"><input type=\"text\" ng-blur=\"vmContact.service.validateDuplicateContact()\" ng-model=\"vmContact.service.contactData.FirstName\" name=\"{{ \'CONTACTSMODULE.FIRSTNAME\'| translate }}\" placeholder=\"{{ \'CONTACTSMODULE.FIRSTNAME\'| translate }}\" ng-required=\"true\"></md-input-container></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"20\" flex-order-xs=\"4\" flex-order-sm=\"4\" flex-order-md=\"4\" layout=\"column\"><md-input-container flex=\"\" id=\"middle-name\"><input type=\"text\" name=\"{{ \'CONTACTSMODULE.MIDDLENAME\'| translate }}\" ng-model=\"vmContact.service.contactData.MiddleName\" placeholder=\"{{ \'CONTACTSMODULE.MIDDLENAME\'| translate }}\"></md-input-container></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"20\" flex-order-xs=\"5\" flex-order-sm=\"5\" flex-order-md=\"5\" layout=\"column\"><md-input-container flex=\"\" id=\"last-name\"><input type=\"text\" ng-blur=\"vmContact.service.validateDuplicateContact()\" ng-model=\"vmContact.service.contactData.LastName\" name=\"{{ \'CONTACTSMODULE.LASTNAME\'| translate }}\" placeholder=\"{{ \'CONTACTSMODULE.LASTNAME\'| translate }}\" ng-required=\"true\"><div ng-messages=\"personal.lastName.$error\" role=\"alert\"></div></md-input-container></div><div flex=\"none\" flex-md=\"100\" flex-gt-md=\"30\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\" layout-align=\"center center\"><label class=\"image-input\" for=\"contactPhoto\"><i class=\"icon icon-pencil s40\"></i> <img class=\"profile-image avatar huge\" src=\"assets/images/avatars/profile.jpg\" ng-src=\"{{ vmContact.service.contactData.ImageUrl }}\"></label> <input type=\"file\" id=\"contactPhoto\" class=\"image-input\" a8-file-upload=\"files\" upload-url=\"vmContact.uploadUrl\" on-upload-start=\"vmContact.onUploadStart()\" on-upload-validate=\"vmContact.onUploadValidate(fileObj)\" on-upload-completed=\"vmContact.onUploadSuccess(data)\" on-upload-error=\"vmContact.onUploadError(ex)\"><div ng-if=\"vmContact.showProgress\" flex=\"60\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear><span class=\"md-caption\">{{ \'CONTACTSMODULE.UPLOADING\'| translate }}...</span></div></div><div flex=\"none\" flex-md=\"10\" flex-gt-md=\"10\" flex-order-xs=\"7\" flex-order-sm=\"7\" flex-order-md=\"6\" layout=\"column\"><md-input-container flex=\"\" id=\"gender\"><label translate=\"CONTACTSMODULE.GENDER\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.GENDER\" name=\"{{ \'CONTACTSMODULE.GENDER\'| translate }}\" ng-model=\"vmContact.service.contactData.Gender\" ng-model-options=\"{trackBy : \'$value\'}\"><md-option ng-value=\"gender.Value\" ng-repeat=\"gender in vmContact.Gender\">{{ gender.Display }}</md-option></md-select></md-input-container></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"20\" flex-order-xs=\"6\" flex-order-sm=\"6\" flex-order-md=\"7\" layout=\"column\"><md-input-container flex=\"\" id=\"preferred-name\"><input type=\"text\" name=\"PreferredName\" ng-model=\"vmContact.service.contactData.PreferredName\" placeholder=\"{{ \'CONTACTSMODULE.PREFERRED\'| translate }}\" ng-maxlength=\"50\"></md-input-container></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"20\" flex-order-xs=\"8\" flex-order-sm=\"8\" flex-order-md=\"8\" layout=\"column\"><md-input-container flex=\"\" id=\"date-of-birth\"><label translate=\"CONTACTSMODULE.DOB\"></label><md-datepicker ng-model=\"vmContact.service.contactData.DateOfBirth\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container></div></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\"><md-input-container flex=\"\" id=\"position\"><input autocomplete=\"off\" type=\"text\" name=\"position\" ng-model=\"vmContact.service.contactData.Position\" placeholder=\"{{ \'CONTACTSMODULE.POSITION\'| translate }}\" ng-maxlength=\"50\"></md-input-container></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"50\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\"></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"2\" flex-order-sm=\"2\" flex-order-md=\"2\" layout=\"column\"><md-input-container flex=\"\" id=\"branches\"><label translate=\"CONTACTSMODULE.SELECT_BRANCH\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.SELECT_BRANCH\" multiple=\"\" name=\"{{ \'CONTACTSMODULE.SELECT_BRANCH\'| translate }}\" ng-model=\"vmContact.service.contactData.Branches2\" ng-change=\"vmContact.service.branchFunc()\" ng-model-options=\"{trackBy : \'$value.Id\'}\" ng-required=\"true\"><md-optgroup label=\"{{ \'CONTACTSMODULE.SELECT_BRANCH\'| translate }}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vmContact.contactLookupsService.contactLookupsObj.Branches\">{{ branch.Name }}</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"20\" ng-if=\"vmContact.hasEmployeeLabourHireType()\" flex-order-xs=\"1\" flex-order-sm=\"3\" flex-order-md=\"2\" layout=\"column\"><md-input-container flex=\"\" id=\"primary-branch\"><label translate=\"CONTACTSMODULE.PRIMARY_BRANCH\"></label><md-select ng-model=\"vmContact.service.contactData.PrimaryBranch\" ng-disabled=\"!vmContact.show_employee_fields\" ng-model-options=\"{trackBy : \'$value.Name\'}\" name=\"{{ \'CONTACTSMODULE.PRIMARY_BRANCH\'| translate }}\" ng-required=\"vmContact.show_employee_fields\"><md-option ng-repeat=\"branch in vmContact.service.SelectedBranches\" ng-value=\"branch\">{{ branch.Name }}</md-option></md-select></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"3\" layout=\"column\"><md-input-container flex=\"\" id=\"divisions\"><label translate=\"CONTACTSMODULE.DIVISIONS\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.DIVISIONS\" multiple=\"\" ng-model-options=\"{trackBy : \'$value.id\'}\" ng-change=\"vmContact.service.divisionsFunc()\" ng-model=\"vmContact.service.contactData.Division\"><md-optgroup label=\"{{ \'CONTACTSMODULE.DIVISIONS\'| translate }}\"><md-option ng-value=\"division\" ng-repeat=\"division in vmContact.service.Divisions | unique:\'id\'\">{{ division.Name }} - [{{ division.BranchName }}]</md-option></md-optgroup></md-select></md-input-container></div></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\"><md-input-container flex=\"\" id=\"contact-type\"><label translate=\"CONTACTSMODULE.CONTACT_TYPES\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.CONTACT_TYPES\" md-on-close=\"vmContact.evaluate()\" ng-change=\"vmContact.changeFields()\" md-selected-text=\"vmContact.utilService.getSelectedText(vmContact.service.contactData.ContactTypes, vmContact.utilService.translate(\'CONTACTSMODULE.CONTACT_TYPES\'), \'TypeName\')\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"\" ng-model=\"vmContact.service.contactData.ContactTypes\" form-validator=\"\" type=\"multi-select\" form-fields=\"vmContact.service.fields\" form-field-name=\"vmContact.service.fields[2].FieldName\" form-field-rule-name=\"vmContact.service.fields[2].FieldRuleName\" form-scope=\"vmContact\" form-look-up=\"vmContact.service.Contacts\" form-rules=\"vmContact.contactLookupsService.contactLookupsObj.Rules\" name=\"{{ \'CONTACTSMODULE.CONTACT_TYPES\'| translate }}\" ng-required=\"true\"><md-optgroup label=\"{{ \'CONTACTSMODULE.CONTACT_TYPES\'| translate }}\"><md-option ng-value=\"type\" ng-disabled=\"type.Disabled || type.Disabled\" ng-if=\"vmContact.canSelectContactType(type)\" ng-repeat=\"type in vmContact.service.Contacts\">{{ type.TypeName }}</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"20\" flex-order-xs=\"2\" flex-order-sm=\"2\" flex-order-md=\"2\" layout=\"column\" ng-if=\"vmContact.hasEmployeeLabourHireType()\"><md-input-container flex=\"\" id=\"employee-code\"><input form-validator=\"\" type=\"text\" ng-model=\"vmContact.service.contactData.EmployeeCode\" name=\"Employee Code\" form-fields=\"vmContact.service.fields\" form-field-name=\"vmContact.service.fields[3].FieldName\" form-field-rule-name=\"vmContact.service.fields[3].FieldRuleName\" form-scope=\"vmContact\" ng-disabled=\"!vmContact.show_employee_fields\" form-rules=\"vmContact.contactLookupsService.contactLookupsObj.Rules\" ng-required=\"vmContact.service.fields[3].IsRequired\" ng-pattern=\"vmContact.service.fields[3].Pattern\" placeholder=\"{{ \'CONTACTSMODULE.CODE\'| translate }}\"></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\" ng-if=\"vmContact.claimsUtilService.isMyobEnabled() && vmContact.adminClaimsService.hasRunPayrollPermission\"><md-autocomplete md-floating-label=\"{{\'CONTACTSMODULE.MYOB_EMPLOYEE\' | translate}}\" md-search-text=\"vmContact.myobSearchText\" md-items=\"myobEmployee in vmContact.searchMyobEmployeeByName(vmContact.myobSearchText)\" md-item-text=\"vmContact.formatMyobEmployeeName(myobEmployee)\" md-selected-item-change=\"vmContact.selectMyobEmployee(myobEmployee)\" md-selected-item=\"vmContact.service.contactData.MyobEmployee\" md-min-length=\"0\" ng-disabled=\"!vmContact.isConnectedToMyob || vmContact.isMyobEmployeeDisabled\"><md-item-template><span>{{ vmContact.formatMyobEmployeeName(myobEmployee) }}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><div class=\"dropdown-instruction instruction-warning\" ng-if=\"!vmContact.isConnectedToMyob\"><label translate=\"CONTACTSMODULE.INSTRUCTIONS.NO_CONNECTION_FOUND\"></label> <label translate=\"CONTACTSMODULE.INSTRUCTIONS.INTEGRATIONS_PAGE\" ng-click=\"vmContact.redirectToIntegrationsPage()\" class=\"clickable-item\"></label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"vmContact.isConnectedToMyob && !vmContact.payrollBusinessExists\"><label translate=\"CONTACTSMODULE.INSTRUCTIONS.NO_PAYROLL_ACCOUNT_SELECTED_MYOB\"></label> <label translate=\"CONTACTSMODULE.INSTRUCTIONS.BUSINESSES_PAGE\" ng-click=\"vmContact.redirectToBusinessesPage()\" class=\"clickable-item\"></label> <label translate=\"CONTACTSMODULE.INSTRUCTIONS.PROCEED\"></label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"!vmContact.myobPayrollCompanyEmployeesContainsSetEmployee\"><label translate=\"CONTACTSMODULE.INSTRUCTIONS.EMPLOYEE_ID_NOT_FOUND\"></label> <label translate=\"CONTACTSMODULE.INSTRUCTIONS.INTEGRATIONS_PAGE\" ng-click=\"vmContact.redirectToIntegrationsPage()\" class=\"clickable-item\"></label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"vmContact.isMyobEmployeeAutomatched\"><label>{{vmContact.myobAutomatchMessage}}</label></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\" ng-if=\"vmContact.claimsUtilService.isXeroEnabled() && vmContact.adminClaimsService.hasRunPayrollPermission\"><md-autocomplete md-floating-label=\"{{\'CONTACTSMODULE.XERO_EMPLOYEE\' | translate}}\" md-search-text=\"vmContact.xeroSearchText\" md-items=\"xeroEmployee in vmContact.searchXeroEmployeeByName(vmContact.xeroSearchText)\" md-item-text=\"vmContact.formatXeroEmployeeName(xeroEmployee)\" md-selected-item-change=\"vmContact.selectXeroEmployee(xeroEmployee)\" md-selected-item=\"vmContact.service.contactData.XeroEmployee\" md-min-length=\"0\" ng-disabled=\"!vmContact.isConnectedToXero || vmContact.isXeroEmployeeDisabled\"><md-item-template><span>{{ vmContact.formatXeroEmployeeName(xeroEmployee) }}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><div class=\"dropdown-instruction instruction-warning\" ng-if=\"!vmContact.isConnectedToXero\"><label translate=\"CONTACTSMODULE.INSTRUCTIONS.NO_CONNECTION_FOUND\"></label> <label translate=\"CONTACTSMODULE.INSTRUCTIONS.INTEGRATIONS_PAGE\" ng-click=\"vmContact.redirectToIntegrationsPage()\" class=\"clickable-item\"></label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"vmContact.isConnectedToXero && !vmContact.payrollBusinessExists\"><label translate=\"CONTACTSMODULE.INSTRUCTIONS.NO_PAYROLL_ACCOUNT_SELECTED_XERO\"></label> <label translate=\"CONTACTSMODULE.INSTRUCTIONS.BUSINESSES_PAGE\" ng-click=\"vmContact.redirectToBusinessesPage()\" class=\"clickable-item\"></label> <label translate=\"CONTACTSMODULE.INSTRUCTIONS.PROCEED\"></label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"!vmContact.xeroPayrollCompanyEmployeesContainsSetEmployee\"><label translate=\"CONTACTSMODULE.INSTRUCTIONS.EMPLOYEE_ID_NOT_FOUND\"></label> <label translate=\"CONTACTSMODULE.INSTRUCTIONS.INTEGRATIONS_PAGE\" ng-click=\"vmContact.redirectToIntegrationsPage()\" class=\"clickable-item\"></label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"vmContact.isXeroEmployeeAutomatched\"><label>{{vmContact.xeroAutomatchMessage}}</label></div></div><div flex=\"none\" flex-md=\"100\" flex-gt-md=\"100\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\"></div><div flex=\"none\" flex-md=\"35\" flex-gt-md=\"25\" flex-order-xs=\"4\" flex-order-sm=\"4\" flex-order-md=\"4\" layout=\"column\" ng-if=\"vmContact.hasEmployeeLabourHireType()\"><md-input-container flex=\"\" id=\"can-be-allocated\"><md-checkbox md-no-ink=\"\" aria-label=\"Is Allocatable\" ng-model=\"vmContact.service.contactData.IsAllocatable\" class=\"md-primary\">{{ \'CONTACTSMODULE.CAN_BE_ALLOCATED\'| translate }}</md-checkbox></md-input-container></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"25\" flex-order-xs=\"6\" flex-order-sm=\"6\" flex-order-md=\"6\" layout=\"column\"><md-input-container flex=\"\" id=\"mark-as-inactive\"><md-checkbox md-no-ink=\"\" aria-label=\"Is contact active\" ng-model=\"vmContact.service.contactData.IsInActive\" class=\"md-primary\">{{ \'CONTACTSMODULE.MARK_AS_INACTIVE\'| translate }}</md-checkbox></md-input-container></div></div><div ng-if=\"vmContact.hasEmployeeLabourHireType() || vmContact.claimsUtilService.checkAccessByRole(\'Manage App Access\')\" class=\"margin-top-20\" layout-xs=\"column\" layout-sm=\"column\" layout=\"row\" flex=\"\"><md-checkbox ng-change=\"vmContact.onCreateLoginChanged()\" ng-model=\"vmContact.service.contactData.AccessAlloc8WebApp\" ng-disabled=\"!(vmContact.claimsUtilService.checkAccessByRole(\'Manage Login Accounts\') && vmContact.show_employee_fields && (vmContact.hasEmployeeLabourHireType()))\">{{ \'CONTACTSMODULE.ACCESS_WEBSITE\' | translate }}</md-checkbox><md-checkbox ng-change=\"vmContact.onCreateLoginChanged()\" ng-model=\"vmContact.service.contactData.AccessAlloc8MobileApp\" ng-if=\"vmContact.isMobileAppEnabled\" ng-disabled=\"!(vmContact.claimsUtilService.checkAccessByRole(\'Manage App Access\') && vmContact.show_employee_fields && (vmContact.hasEmployeeLabourHireType()))\">{{ \'CONTACTSMODULE.ACCESS_MOBILE\' | translate }}</md-checkbox></div><div ng-show=\"vmContact.isExternalAuthenticationEnabled() && vmContact.service.contactData.AccessAlloc8WebApp\" flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"3\" flex-order-sm=\"3\" flex-order-md=\"3\" layout=\"column\" class=\"margin-btm-5\"><md-input-container flex=\"\"><md-checkbox ng-change=\"vmContact.onCreateLoginChanged()\" ng-model=\"vmContact.service.contactData.AccessLoginWithAlloc8\" ng-disabled=\"!(vmContact.claimsUtilService.checkAccessByRole(\'Manage Login Accounts\') && vmContact.show_employee_fields && (vmContact.hasEmployeeLabourHireType()))\">{{ \'CONTACTSMODULE.ACCESS_LOGIN_WITH_ALLOC8\' | translate }}</md-checkbox><div class=\"override-instruction margin-top-5\"><label translate=\"CONTACTSMODULE.ACCESS_LOGIN_WITH_ALLOC8_DESCRIPTION\"></label></div><br><br><div class=\"override-instruction\" ng-show=\"vmContact.isAllowLoginWithAlloc8EnabledForAllUsers==\'true\'\"><label class=\"instruction-warning\" translate=\"CONTACTSMODULE.ACCESS_NOTE\"></label></div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\" class=\"margin-top-20\"><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\" ng-if=\"vmContact.hasEmployeeLabourHireType()\"><md-input-container flex=\"\" id=\"start-date\"><label translate=\"CONTACTSMODULE.START_DATE\"></label><md-datepicker ng-model=\"vmContact.service.contactData.StartDate\" ng-disabled=\"!vmContact.show_employee_fields\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"2\" flex-order-sm=\"2\" flex-order-md=\"2\" layout=\"column\" ng-if=\"vmContact.hasEmployeeLabourHireType()\"><md-input-container flex=\"\" id=\"employment-status\"><label translate=\"CONTACTSMODULE.EMPLOYMENT\"></label><md-select ng-model=\"vmContact.service.contactData.EmploymentStatus\" form-validator=\"\" ng-disabled=\"!vmContact.showPayrollFields()\" type=\"single-select\" form-fields=\"vmContact.service.fields\" form-field-name=\"vmContact.service.fields[4].FieldName\" form-field-rule-name=\"vmContact.service.fields[4].FieldRuleName\" form-scope=\"vmContact\" form-look-up=\"vmContact.employment_status_lookup\" form-rules=\"vmContact.contactLookupsService.contactLookupsObj.Rules\" ng-required=\"vmContact.service.fields[4].IsRequired || vmContact.showPayrollFields()\" ng-pattern=\"vmContact.service.fields[4].Pattern\" name=\"{{ \'CONTACTSMODULE.EMPLOYMENT\'| translate }}\" ng-change=\"vmContact.employmentStatusChange()\"><md-option ng-if=\"!emp.Disabled\" ng-repeat=\"emp in vmContact.employment_status_lookup\" ng-value=\"emp.Id\">{{ emp.Name }}</md-option></md-select></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"3\" flex-order-sm=\"3\" flex-order-md=\"3\" layout=\"column\" ng-if=\"vmContact.isAwardAndClassificationSettingsEnabled()\" class=\"margin-btm-5\"><md-input-container flex=\"\" id=\"classification\"><label translate=\"CONTACTSMODULE.CLASSIFICATION\"></label><md-select id=\"classificationLookup\" translate-attr-placeholder=\"CONTACTSMODULE.CLASSIFICATION\" ng-disabled=\"!vmContact.showPayrollFields()\" name=\"{{ \'CONTACTSMODULE.CLASSIFICATION\'| translate }}\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"vmContact.service.contactData.AwardClassification\" form-validator=\"\" type=\"single-select\" form-fields=\"vmContact.service.fields\" form-field-name=\"vmContact.service.fields[1].FieldName\" form-field-rule-name=\"vmContact.service.fields[1].FieldRuleName\" form-scope=\"vmContact\" form-look-up=\"vmContact.classifications\" form-rules=\"vmContact.contactLookupsService.contactLookupsObj.Rules\"><md-option ng-disabled=\"class.Disabled\" ng-value=\"class\" ng-repeat=\"class in vmContact.classifications\" ng-if=\"!class.IsArchived\">{{ class.Name }}</md-option></md-select></md-input-container></div><div ng-if=\"vmContact.isAwardAndClassificationSettingsEnabled()\" flex=\"none\" flex-md=\"30\" flex-gt-md=\"50\" flex-order-xs=\"3\" flex-order-sm=\"3\" flex-order-md=\"3\" layout=\"column\"><md-input-container flex=\"\" id=\"classification-cannot-be-overridden\"><md-checkbox ng-disabled=\"!(vmContact.service.contactData.AwardClassification != null && vmContact.showPayrollFields())\" class=\"margin-btm-5\" ng-model=\"vmContact.service.contactData.IsClassificationCannotBeOverridden\">{{ \'CONTACTSMODULE.CLASSIFICATION_CANNOT_OVERRIDE\'| translate }}</md-checkbox><div class=\"override-instruction\"><label translate=\"CONTACTSMODULE.INSTRUCTIONS.CLASSIFICATION_OVERRIDE\"></label></div></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"6\" flex-order-sm=\"6\" flex-order-md=\"6\" layout=\"column\" ng-if=\"vmContact.isAwardAndClassificationSettingsEnabled()\"><md-input-container flex=\"\" id=\"award\"><label translate=\"CONTACTSMODULE.AWARD\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.AWARD\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-disabled=\"!vmContact.showPayrollFields()\" ng-model=\"vmContact.service.contactData.Award\" form-validator=\"\" type=\"single-select\" form-fields=\"vmContact.service.fields\" form-field-name=\"vmContact.service.fields[0].FieldName\" form-field-rule-name=\"vmContact.service.fields[0].FieldRuleName\" form-scope=\"vmContact\" form-look-up=\"vmContact.awards\" form-rules=\"vmContact.contactLookupsService.contactLookupsObj.Rules\" ng-required=\"vmContact.service.fields[0].IsRequired\" name=\"{{ \'CONTACTSMODULE.CONTACT_TYPES\'| translate }}\"><md-option ng-value=\"\"></md-option><md-option ng-if=\"!award.Disabled\" ng-value=\"award\" ng-repeat=\"award in vmContact.awards\">{{ award.Name }}</md-option></md-select></md-input-container><div class=\"dropdown-instruction\"><label translate=\"CONTACTSMODULE.INSTRUCTIONS.AWARDS_LOOKUP\" role=\"note\"></label></div><br></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"50\" flex-order-xs=\"6\" flex-order-sm=\"6\" flex-order-md=\"6\" layout=\"column\" ng-if=\"vmContact.isAwardAndClassificationSettingsEnabled()\"><md-input-container flex=\"\" id=\"award-cannot-be-overridden\" ng-if=\"vmContact.service.contactData.Award != null && vmContact.showPayrollFields()\"><md-checkbox ng-model=\"vmContact.service.contactData.IsAwardCannotBeOverridden\">{{ \'CONTACTSMODULE.AWARD_CANNOT_OVERRIDE\'| translate }}</md-checkbox><div class=\"override-instruction\"><label ng-if=\"vmContact.service.contactData.Award != null && vmContact.showPayrollFields()\" translate=\"CONTACTSMODULE.INSTRUCTIONS.AWARDS_OVERRIDE\"></label></div></md-input-container></div><div flex=\"none\" flex-md=\"30\" flex-gt-md=\"50\" flex-order-xs=\"6\" flex-order-sm=\"6\" flex-order-md=\"6\" layout=\"column\"><md-input-container flex=\"\" id=\"payrollGroup\" ng-if=\"vmContact.showPayrollGroupField\"><label translate=\"CONTACTSMODULE.PAYROLL_GROUP\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.PAYROLL_GROUP\" ng-model=\"vmContact.service.contactData.PayrollGroupId\" ng-disabled=\"!vmContact.enablePayrollGroupDropdown\" form-validator=\"\" type=\"single-select\" form-scope=\"vmContact\" form-look-up=\"vmContact.payrollGroup\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"payrollGroup.Id\" ng-repeat=\"payrollGroup in vmContact.payrollGroups\">{{ payrollGroup.Name }}</md-option></md-select></md-input-container></div><div flex=\"none\" flex-md=\"100\" flex-gt-md=\"100\" flex-order-xs=\"6\" flex-order-sm=\"6\" flex-order-md=\"6\" layout=\"column\"></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"4\" flex-order-sm=\"4\" flex-order-md=\"4\" layout=\"column\" ng-if=\"vmContact.hasEmployeeLabourHireType()\"><md-input-container flex=\"\" id=\"skill-level\"><label translate=\"CONTACTSMODULE.SKILL_LEVEL\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.SKILL_LEVEL\" ng-disabled=\"!vmContact.show_employee_fields\" name=\"{{ \'CONTACTSMODULE.SKILL_LEVEL\'| translate }}\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"vmContact.service.contactData.SkillLevel\"><md-option ng-value=\"skill\" ng-repeat=\"skill in vmContact.skillsLevel\">{{ skill.Name }}</md-option></md-select></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"5\" flex-order-sm=\"5\" flex-order-md=\"5\" layout=\"column\" ng-if=\"vmContact.hasEmployeeLabourHireType()\"><md-input-container flex=\"\" id=\"work-force-participation\"><label translate=\"CONTACTSMODULE.WORK_FORCE_PARTICIPATION\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.WORK_FORCE_PARTICIPATION\" ng-disabled=\"!vmContact.show_employee_fields\" name=\"{{ \'CONTACTSMODULE.SKILL_LEVEL\'| translate }}\" md-selected-text=\"vmContact.utilService.getSelectedText(vmContact.service.contactData.WorkforceParticipations, vmContact.utilService.translate(\'CONTACTSMODULE.WORK_FORCE_PARTICIPATION\'), \'Name\')\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"vmContact.service.contactData.WorkforceParticipations\" multiple=\"\"><md-option ng-value=\"workforce\" ng-repeat=\"workforce in vmContact.Workforce\">{{ workforce.Name }}</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"1\" flex-order-sm=\"1\" flex-order-md=\"1\" layout=\"column\" ng-if=\"vmContact.isAltusSpecialEnabled\"><md-input-container flex=\"\" id=\"communication-method\"><label translate=\"CONTACTSMODULE.COMM_METHOD\"></label><md-select name=\"{{ \'CONTACTSMODULE.COMM_METHOD\'| translate }}\" ng-model=\"vmContact.service.contactData.CommunicationMethod\" ng-model-options=\"{trackBy: \'$value.CommunicationMethodId\'}\" required=\"\"><md-option ng-repeat=\"method in vmContact.commMethods\" ng-value=\"method\">{{ method.MethodName }}</md-option></md-select></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"2\" flex-order-sm=\"2\" flex-order-md=\"2\" layout=\"column\" ng-if=\"vmContact.showPasswordField()\"><md-input-container flex=\"\" id=\"password\"><input type=\"password\" minlength=\"8\" name=\"{{ \'CONTACTSMODULE.PASSWORD\'| translate }}\" maxlength=\"20\" placeholder=\"{{ vmContact.passwordPlaceholder() }}\" disallow-spaces=\"\" autocomplete=\"off\" ng-disabled=\"vmContact.service.contactData.Emails.length === 0\" ng-model=\"vmContact.service.contactData.Password\" ng-required=\"true\"><div ng-messages=\"personal.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"CONTACTSMODULE.PASSWORD_REQUIRED_ERROR\"></span></div><div ng-message=\"minlength\"><span translate=\"CONTACTSMODULE.PASSWORD_MIN_LENGTH_ERROR\"></span></div></div></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"3\" flex-order-sm=\"3\" flex-order-md=\"3\" layout=\"column\" ng-if=\"vmContact.hasEmployeeLabourHireType()\"><md-input-container flex=\"\" id=\"shift-hours\"><input type=\"number\" min=\"0\" max=\"168\" name=\"{{ \'CONTACTSMODULE.SHIFT_HOURS\'| translate }}\" ng-disabled=\"!(vmContact.show_employee_fields && (vmContact.hasEmployeeLabourHireType()) && vmContact.claimsUtilService.checkAccessByRole(\'Manage Employee Payroll\') && vmContact.isPermanentEmployee)\" placeholder=\"{{ \'CONTACTSMODULE.SHIFT_HOURS\'| translate }}\" ng-model=\"vmContact.service.contactData.MinimumHours\" ng-required=\"vmContact.show_employee_fields && (vmContact.hasEmployeeLabourHireType()) && vmContact.claimsUtilService.checkAccessByRole(\'Manage Employee Payroll\') && vmContact.isPermanentEmployee\"><div ng-messages=\"personal.shiftHours.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'CONTACTSMODULE.SHIFT_HOURS_MINIMUM_SHIFT_HOURS_IS_REQUIRED\'| translate }}</span></div><div ng-message=\"min\"><span>{{ \'CONTACTSMODULE.SHIFT_HOURS_MINIMUM_SHIFT_HOURS_IS_0\'| translate }}</span></div><div ng-message=\"max\"><span>{{ \'CONTACTSMODULE.SHIFT_HOURS_MAXIMUM_SHIFT_HOURS_IS_168\'| translate }}</span></div></div></md-input-container></div><div flex=\"none\" flex-md=\"70\" flex-gt-md=\"50\" flex-order-xs=\"4\" flex-order-sm=\"4\" flex-order-md=\"4\" layout=\"column\"><md-input-container flex=\"\" id=\"resource-notes\"><label translate=\"CONTACTSMODULE.RESOURCE_NOTES\"></label> <textarea ng-model=\"vmContact.service.contactData.ResourceNotes\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\"></textarea></md-input-container></div></div><div layout=\"column\" flex-gt-md=\"80\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\" ng-if=\"vmContact.isEmergencyContactFieldsEnabled\"><div flex=\"auto\" layout=\"column\"><contact-component-header title=\"Emergency Contact\" show-action=\"false\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" layout=\"\" layout-align=\"left center\"><div class=\"container padding-20\"><div class=\"row padding-bottom-5\"><md-input-container id=\"emergency-contact-name\" class=\"md-block\"><label translate=\"CONTACTSMODULE.EMERGENCY_CONTACT.NAME\"></label> <input ng-model=\"vmContact.service.contactData.EmergencyContactName\" md-maxlength=\"150\" md-select-on-focus=\"\"></md-input-container></div><div class=\"row padding-bottom-5\"><md-input-container id=\"emergency-contact-phone\" class=\"md-block\"><label translate=\"CONTACTSMODULE.EMERGENCY_CONTACT.PHONE\"></label> <input ng-model=\"vmContact.service.contactData.EmergencyContactPhone\" md-maxlength=\"150\" md-select-on-focus=\"\"></md-input-container></div><div class=\"row padding-bottom-5\"><md-input-container id=\"emergency-contact-relationship\" class=\"md-block\"><label translate=\"CONTACTSMODULE.EMERGENCY_CONTACT.RELATIONSHIP\"></label> <input ng-model=\"vmContact.service.contactData.EmergencyContactRelationship\" md-maxlength=\"150\" md-select-on-focus=\"\"></md-input-container></div></div></md-whiteframe></content></div></div></form></div>");
$templateCache.put("app/main/contact/create/work/work.html","<div class=\"main-style\"><form name=\"form2\" class=\"md-inline-form\" novalidate=\"\"><div layout=\"column\" flex-gt-md=\"80\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"auto\" ng-class=\"{\'work-group padding-right-40\': vmContactWork.mediaQueryService.isDeviceXS(), \'work-group\': !vmContactWork.mediaQueryService.isDeviceXS()}\" layout=\"column\"><contact-component-header title=\"Email Addresses\" show-action=\"true\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" flex=\"\" layout=\"\" layout-align=\"center center\"><a8-emails ng-model=\"vmContactWork.model.Emails\" flex=\"\" validate-duplicate=\"vmContactWork.service.validateDuplicateContact()\"></a8-emails></md-whiteframe></content></div><div flex=\"\" ng-class=\"{\'work-group padding-right-40\': vmContactWork.mediaQueryService.isDeviceXS(), \'work-group\': !vmContactWork.mediaQueryService.isDeviceXS()}\" layout=\"column\"><contact-component-header title=\"Companies\" show-action=\"true\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" flex=\"\" layout=\"\" layout-align=\"center center\"><div ng-include=\"\'app/main/contact/create/work/company/companies.html\'\" flex=\"\"></div></md-whiteframe></content></div><div flex=\"\" ng-class=\"{\'margin-top-20 padding-right-40\': vmContactWork.mediaQueryService.isDeviceXS(), \'margin-top-20\': !vmContactWork.mediaQueryService.isDeviceXS()}\" layout=\"column\"><contact-component-header title=\"Addresses\" show-action=\"true\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" flex=\"\" layout=\"\" layout-align=\"center center\"><multi-address flex=\"\" ng-model=\"vmContactWork.model.Addresses\"></multi-address></md-whiteframe></content></div><div flex=\"\" ng-class=\"{\'work-group padding-right-40\': vmContactWork.mediaQueryService.isDeviceXS(), \'work-group\': !vmContactWork.mediaQueryService.isDeviceXS()}\" layout=\"column\"><contact-component-header title=\"Phone Numbers\" show-action=\"true\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" flex=\"\" layout=\"\" layout-align=\"center center\"><a8-phone-numbers flex=\"\" ng-model=\"vmContactWork.model.Phones\" phone-types=\"vmContactWork.PhoneTypes\"></a8-phone-numbers></md-whiteframe></content></div><div flex=\"\" ng-class=\"{\'work-group padding-right-40\': vmContactWork.mediaQueryService.isDeviceXS(), \'work-group\': !vmContactWork.mediaQueryService.isDeviceXS()}\" layout=\"column\"><contact-component-header title=\"Contact Preferences\" show-action=\"true\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" flex=\"\" layout=\"\" layout-align=\"center center\"><contact-preference-component name=\"Contact\" flex=\"\" contact-list=\"vmContactWork.service.minified_contacts\" ng-model=\"vmContactWork.model.ContactsPreferences\"></contact-preference-component></md-whiteframe></content></div><div flex=\"\" ng-class=\"{\'work-group padding-right-40\': vmContactWork.mediaQueryService.isDeviceXS(), \'work-group\': !vmContactWork.mediaQueryService.isDeviceXS()}\" layout=\"column\" ng-if=\"vmContactWork.service.isEditMode && vmContactWork.isAllowanceVisible && vmContact.hasEmployeeType\"><contact-component-header title=\"Allowances\" show-action=\"true\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" flex=\"\" layout=\"\" layout-align=\"center center\"><contact-allowances payroll-allowances=\"vmContactWork.model.PayrollAllowances\" allowances-lookup=\"vmContactWork.allowancesList\" ng-if=\"vmContactWork.service.isEditMode\" flex=\"\"></contact-allowances></md-whiteframe></content></div><div flex=\"\" ng-class=\"{\'work-group padding-right-40\': vmContactWork.mediaQueryService.isDeviceXS(), \'work-group\': !vmContactWork.mediaQueryService.isDeviceXS()}\" ng-if=\"vmContactWork.service.isEditMode\" layout=\"column\"><contact-component-header title=\"Skills\" show-action=\"true\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" flex=\"\" layout=\"\" layout-align=\"center center\"><contact-skills skills=\"vmContactWork.model.PersonalSkills\" skills-lookup=\"vmContactWork.skillsGroups\" companies=\"vmContactWork.companies\" contact=\"vmContactWork.service.contactData\" ng-if=\"vmContactWork.service.isEditMode\" flex=\"\"></contact-skills></md-whiteframe></content></div><div flex=\"\" ng-class=\"{\'work-group padding-right-40\': vmContactWork.mediaQueryService.isDeviceXS(), \'work-group\': !vmContactWork.mediaQueryService.isDeviceXS()}\" ng-if=\"vmContactWork.service.isEditMode\" layout=\"column\"><contact-component-header title=\"Training\" show-action=\"true\"></contact-component-header><content><md-whiteframe class=\"md-whiteframe-1dp padding-5\" flex=\"\" layout=\"\" layout-align=\"center center\"><contact-training list=\"vmContactWork.model.PersonalTrainings\" flex=\"\"></contact-training></md-whiteframe></content></div></div></form></div>");
$templateCache.put("app/main/customForms/view/dialog/moveToPosition-dialog.html","<md-dialog flex=\"30\" aria-label=\"Move to Postion dialog\"><form name=\"moveToPositionForm\"><md-dialog-content><h3 class=\"md-title\">Move to a Position</h3><div flex=\"\" layout=\"row\">Current Position: {{vm.CurrentPosition}}</div><div flex=\"\" layout=\"row\"><md-input-container><input required=\"\" ng-model=\"vm.positionToMove\" placeholder=\"Enter a position between 1 and {{vm.noOfRecords}}\" type=\"number\" min=\"1\" max=\"{{vm.noOfRecords}}\"></md-input-container></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised\" ng-click=\"vm.closeDialog()\">Close</md-button><md-button ng-disabled=\"moveToPositionForm.$invalid || vm.positionToMove >= vm.noOfRecords || vm.positionToMove<=0 || vm.positionToMove == vm.CurrentPosition\" class=\"md-raised md-accent\" ng-click=\"vm.moveToPosition()\">Move to Position</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contact/view/templates/dates.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"30\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'VIEWCONTACTS.DATE_RANGE_HEADER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"auto\" ng-form=\"datesForm\"><div flex=\"\" layout-align=\"center center\"><md-radio-group ng-model=\"vm.service.filterModel.filterType\" layout=\"row\" layout-sm=\"column\" required=\"\"><md-radio-button value=\"1\" selected=\"\">{{\'VIEWCONTACTS.DATE_RANGE_CREATED_DATE\' | translate}}</md-radio-button><md-radio-button value=\"2\">{{\'VIEWCONTACTS.DATE_RANGE_UPDATED_DATE\' | translate}}</md-radio-button></md-radio-group></div><div flex=\"\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-input-container><label>{{\'VIEWCONTACTS.DATE_RANGE_START_DATE\' | translate}}</label><md-datepicker ng-model=\"vm.service.filterModel.startDate\"></md-datepicker></md-input-container><md-input-container><label>{{\'VIEWCONTACTS.DATE_RANGE_END_DATE\' | translate}}</label><md-datepicker ng-model=\"vm.service.filterModel.endDate\"></md-datepicker></md-input-container></div><div flex=\"\" layout=\"row\">{{\'VIEWCONTACTS.DATE_RANGE_TIP\' | translate}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"datesForm.$invalid\" ng-click=\"vm.applyFilter()\">{{\'VIEWCONTACTS.DATE_RANGE_APPLY\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/integrations/directives/settings/settings.html","<div class=\"integration__settings\"><div class=\"integration__settings-connectors white-bg md-whiteframe-2dp\"><div></div><div ng-if=\"!vm.integrationSectionIsCollapsed\"><div class=\"connector\" ng-if=\"vm.isMyobEnabled\"><img src=\"assets/images/logos/myob.png\" alt=\"Connector logo\" ng-class=\"{ \'half-opacity\': !vm.isConnectedToMyob }\"><md-button class=\"md-accent md-raised md-button\" ng-if=\"!vm.isConnectedToMyob\" ng-click=\"vm.connect(\'myob\')\">{{\'INTEGRATION.CONNECT\' | translate}}</md-button><md-button class=\"md-accent md-raised md-button disconnect\" ng-if=\"vm.isConnectedToMyob\" ng-click=\"vm.disconnect(\'myob\')\">{{\'INTEGRATION.DISCONNECT\' | translate}}</md-button></div><div class=\"connector\" ng-if=\"vm.isXeroEnabled\"><img src=\"assets/images/logos/xero.png\" alt=\"Connector logo\" ng-class=\"{ \'half-opacity\': !vm.isConnectedToXero }\"><md-button class=\"md-accent md-raised md-button\" ng-if=\"!vm.isConnectedToXero\" ng-click=\"vm.connect(\'xero\')\">{{\'INTEGRATION.CONNECT\' | translate}}</md-button><md-button class=\"md-accent md-raised md-button disconnect\" ng-if=\"vm.isConnectedToXero\" ng-click=\"vm.disconnect(\'xero\')\">{{\'INTEGRATION.DISCONNECT\' | translate}}</md-button></div></div></div></div>");
$templateCache.put("app/main/integrations/directives/tabs/tabs.html","<div class=\"integration__tabs toolbar md-whiteframe-2dp\"><a href=\"#\" class=\"tab\" ng-class=\"{\'tab--selected\': vm.selectedTabName === vm.tabNames.settings}\" ng-click=\"vm.selectTab(vm.tabNames.settings)\">{{\'INTEGRATION.SETTINGS\' | translate}}</a> <a href=\"#\" class=\"tab\" ng-class=\"{\'tab--selected\': vm.selectedTabName === vm.tabNames.history}\" ng-click=\"vm.selectTab(vm.tabNames.history)\">{{\'INTEGRATION.HISTORY\' | translate}}</a></div>");
$templateCache.put("app/main/holidays/services/dialog/holiday-dialog.html","<md-dialog class=\"main-style\" flex=\"30\" ng-cloak=\"\" block-ui=\"add-project\"><form name=\"holidayForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.model.Id ? \"Edit\":\"Add\"}} {{\'HOLIDAYS.MAIN_HOLIDAY_DIALOG\'| translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"text\" name=\"Name\" ng-model=\"vm.model.HolidayName\" placeholder=\"{{\'HOLIDAYS.MAIN_HOLIDAY_NAME\' | translate}}\" required=\"\"><div ng-messages=\"holidayForm.project.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"HOLIDAYS.MAIN_HOLIDAY_NAME_IS_REQUIRED\"></span></div></div></md-input-container><md-input-container ng-if=\"!vm.model.IsNationalHoliday\"><label>{{\'HOLIDAYS.MAIN_BRANCH(ES)\' | translate}}</label><md-select placeholder=\"{{\'HOLIDAYS.MAIN_BRANCH(ES)\' | translate}}\" ng-model=\"vm.model.Branches\" name=\"Branches\" required=\"\" ng-change=\"vm.formatDivisions(vm.model.Branches)\" ng-model-options=\"{trackBy: \'$value.Id\'}\" md-selected-text=\"vm.utilService.getSelectedText(vm.model.Branches, \'Branch(es)\', \'Name\')\" multiple=\"\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.Branches\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"!vm.model.IsNationalHoliday\"><label>{{\'HOLIDAYS.MAIN_DIVISION(S)\' | translate}}</label><md-select placeholder=\"{{\'HOLIDAYS.MAIN_DIVISION(S)\' | translate}}\" ng-model=\"vm.model.Divisions\" name=\"Divisions\" md-selected-text=\"vm.utilService.getSelectedText(vm.model.Divisions, \'Division(s)\', \'Name\')\" ng-model-options=\"{trackBy : \'$value.Id\'}\" multiple=\"\"><md-optgroup label=\"{{\'HOLIDAYS.MAIN_DIVISION(S)\' | translate}}\"><md-option ng-value=\"division\" ng-repeat=\"division in vm.Divisions\">{{division.Name}} - [{{division.BranchName}}]</md-option></md-optgroup></md-select></md-input-container><div flex=\"\" layout=\"row\"><md-input-container flex=\"\" layout=\"row\"><label>{{\'HOLIDAYS.MAIN_DATE\' | translate}}</label><md-datepicker ng-model=\"vm.model.HolidayDate\" ng-required=\"true\" layout=\"row\" flex=\"\"></md-datepicker></md-input-container></div><md-checkbox ng-model=\"vm.model.IsNationalHoliday\">{{\'HOLIDAYS.MAIN_NATIONAL_HOLIDAY\' | translate}}</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"vm.onClose()\">{{\'HOLIDAYS.MAIN_CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.onSave()\" ng-disabled=\"holidayForm.$invalid\">{{\'HOLIDAYS.MAIN_SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoice/directives/customGridSearch/invoice-custom-grid-search.html","<div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.srcData\" type=\"text\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Search for an invoice\" translate=\"\" translate-attr-placeholder=\"INVOICE_REPORT.SEARCH\"></div>");
$templateCache.put("app/main/invoice/directives/invoiceGrid/invoice-grid-pagination.html","<div></div>");
$templateCache.put("app/main/customValidations/create/tester/tester.html","<md-dialog flex=\"30\" flex-sm=\"90\" flex-xs=\"90\" flex-md=\"70\" flex-lg=\"30\"><form name=\"numberForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Test Drive</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-body-1\"><md-input-container class=\"md-block\" flex=\"\"><label translate=\"CONTACTSMODULE.CONTACT_TYPES\"></label><md-select translate-attr-placeholder=\"CONTACTSMODULE.CONTACT_TYPES\" multiple=\"\" ng-model=\"vm.ContactTypes\" form-validator=\"\" type=\"multi-select\" form-fields=\"vm.fields\" form-field-name=\"vm.fields[2].FieldName\" form-field-rule-name=\"vm.fields[2].FieldRuleName\" form-scope=\"vm\" form-look-up=\"vm.Contacts\" form-rules=\"vm.rules\" name=\"{{\'CONTACTSMODULE.CONTACT_TYPES\'| translate}}\"><md-optgroup label=\"{{\'CONTACTSMODULE.CONTACT_TYPES\'| translate}}\"><md-option ng-value=\"type\" ng-disabled=\"type.Disabled || type.Disabled\" ng-repeat=\"type in vm.lookup.ContactTypes\">{{type.TypeName}}</md-option></md-optgroup></md-select></md-input-container></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/invoice/forms/manual-invoice/manual-invoice.html","<div id=\"manual-invoice\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center main-container\" layout=\"column\" style=\"overflow: hidden;\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme first-button-margin\" ng-click=\"manualInvoiceVm.saveInvoice()\" ng-disabled=\"itemForm.$invalid || manualInvoiceVm.lineItemsModel.data.length <= 0\">Save</md-button></div></div><div class=\"content\" flex=\"\"><div class=\"md-whiteframe-4dp main-style\"><form name=\"itemForm\" novalidate=\"\" a8-dirty-form-confirmation=\"\"><manual-invoice-entry-form-component on-client-selected=\"manualInvoiceVm.onClientSelected(data)\" layout-margin=\"\" layout-padding=\"\"></manual-invoice-entry-form-component></form><div class=\"ms-responsive-table-wrapper\"><line-item-manual-invoice-component client-id=\"manualInvoiceVm.formModel.data.selectedClient\" tax-rounding-rule=\"manualInvoiceVm.formModel.data.taxRoundingRule\" layout-margin=\"\" layout-padding=\"\"></line-item-manual-invoice-component></div></div></div></div></div>");
$templateCache.put("app/main/invoice/emailSender/sidenav/main-sidenav.html","<md-content ms-scroll=\"\" class=\"content margin-left-15\" flex=\"\"><form name=\"basicInfoForm\"><div class=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"Show Invoice\" ng-click=\"emailSenderVm.generatePreview()\" ng-disabled=\"basicInfoForm.$invalid || basicInfoForm.$pristine || emailSenderVm.model.sideNavModel.processingEmailDist || emailSenderVm.model.sideNavModel.isLocked\">Filter</md-button></div><div class=\"loading-threads margin-top-5\" layout=\"column\" layout-align=\"center center\" ng-if=\"emailSenderVm.model.sideNavModel.processingEmailDist\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular><div class=\"margin-top-10\"><strong>{{emailSenderVm.model.sideNavModel.progressMessage}}</strong></div></div><div class=\"navigation-simple\" layout=\"column\" flex=\"100\"><div layout-margin=\"\"><div layout=\"row\"><md-input-container flex=\"100\"><md-select name=\"branches\" ng-model=\"emailSenderVm.model.sideNavModel.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"Branch(es)\" ng-disabled=\"emailSenderVm.model.sideNavModel.isLocked\" multiple=\"\" required=\"\"><md-optgroup label=\"Branch(es)\"><md-option ng-value=\"branch\" ng-repeat=\"branch in emailSenderVm.model.branchLookups\">{{branch.Name}}</md-option></md-optgroup></md-select><div ng-messages=\"basicInfoForm.branches.$error\" role=\"alert\"><div ng-message=\"required\"><span>Branch is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Start Date</label><md-datepicker ng-model=\"emailSenderVm.model.sideNavModel.startDate\" ng-disabled=\"emailSenderVm.model.sideNavModel.isLocked\" required=\"\"></md-datepicker></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>End Date</label><md-datepicker ng-model=\"emailSenderVm.model.sideNavModel.endDate\" ng-disabled=\"emailSenderVm.model.sideNavModel.isLocked\" required=\"\"></md-datepicker></md-input-container></div><div class=\"m-0 pt-0 pb-0 pl-5 pr-0\"><md-input-container class=\"mb-0\" ng-show=\"emailSenderVm.isPaymentClaimEnabled\"><md-checkbox ng-model=\"emailSenderVm.showSingleClientSelection\" ng-change=\"emailSenderVm.checkPaymentClaim(emailSenderVm.showSingleClientSelection)\">For Payment Claim</md-checkbox></md-input-container></div><div layout=\"row\" ng-show=\"!emailSenderVm.showSingleClientSelection\"><md-input-container flex=\"100\"><md-select name=\"clients\" ng-model=\"emailSenderVm.model.sideNavModel.selectedClients\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-disabled=\"emailSenderVm.model.sideNavModel.isLocked\" placeholder=\"Client(s)\" multiple=\"\"><md-optgroup label=\"Client(s)\"><md-option ng-value=\"client\" ng-repeat=\"client in emailSenderVm.model.clientLookups\">{{client.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" ng-if=\"emailSenderVm.showSingleClientSelection\"><md-input-container flex=\"100\"><md-select name=\"client\" ng-model=\"emailSenderVm.model.sideNavModel.selectedClient\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-disabled=\"emailSenderVm.model.sideNavModel.isLocked\" placeholder=\"Client\" required=\"\"><md-optgroup label=\"Client\"><md-option ng-value=\"client\" ng-repeat=\"client in emailSenderVm.model.clientLookups\">{{client.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"!emailSenderVm.model.sideNavModel.isSending && emailSenderVm.model.sideNavModel.processingEmailDist\"><div class=\"custom-tooltip\"><md-button class=\"md-raised\" aria-label=\"Clear Preview\" ng-click=\"emailSenderVm.clearPreview()\"><md-icon md-font-icon=\"icon-filter-remove\" class=\"grey-700-fg\"></md-icon>Clear</md-button><span class=\"custom-tooltiptext\">Clear Preview</span></div></div></div></div></form></md-content>");
$templateCache.put("app/main/invoice/exportViewer/directives/invoice-error-column.html","<div layout=\"row\"><a href=\"#\" class=\"material-icons md-24 invoice-error-expand-icon\" ng-click=\"toggleColumn()\">{{toggleStateIcon}}</a><md-icon class=\"invoice-error-status-icon\" md-svg-src=\"{{statusIcon}}\"></md-icon></div>");
$templateCache.put("app/main/invoice/exportViewer/directives/invoice-error-details.html","<div ng-repeat=\"errorDescription in errorDescriptions\"><div ng-if=\"errorDescription.preText\"><strong ng-bind-html=\"errorDescription.preText\"></strong><br><br></div><strong ng-bind-html=\"errorDescription.text\"></strong> &nbsp; <strong><u><a href=\"#\" ng-if=\"errorDescription.action\" ng-click=\"errorDescription.action()\" style=\"text-decoration: underline\">{{errorDescription.actionText}}</a></u></strong> <strong ng-if=\"errorDescription.postText\">{{errorDescription.postText}}</strong></div>");
$templateCache.put("app/main/invoice/reports/sidenav/main-sidenav.html","<md-content ms-scroll=\"\" class=\"content ml-10 mr-10\" flex=\"\"><form name=\"basicInfoForm\"><div class=\"navigation-simple\" layout=\"column\" flex=\"\"><div layout-margin=\"\"><div layout=\"row\"><md-input-container flex=\"\"><md-select name=\"branches\" ng-model=\"invRepVm.sidenavModel.data.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"Branch(es)\" ng-disabled=\"invRepVm.sidenavModel.isLocked\" multiple=\"\" required=\"\"><md-optgroup label=\"States\"><md-option ng-value=\"branch\" ng-repeat=\"branch in invRepVm.sidenavModel.branchLookups | filter:{State: null}\">{{branch.Name}}</md-option></md-optgroup><md-optgroup label=\"Branch(es)\"><md-option ng-value=\"branch\" ng-repeat=\"branch in invRepVm.sidenavModel.branchLookups | filter:{State: \'!!\'}\">{{branch.Name}}</md-option></md-optgroup></md-select><div ng-messages=\"basicInfoForm.branches.$error\" role=\"alert\"><div ng-message=\"required\"><span>Branch is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>Start Date</label><md-datepicker name=\"start_date\" ng-model=\"invRepVm.sidenavModel.data.startDate\" ng-disabled=\"invRepVm.sidenavModel.isLocked\" required=\"\"></md-datepicker><div ng-messages=\"basicInfoForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><label>End Date</label><md-datepicker name=\"end_date\" ng-model=\"invRepVm.sidenavModel.data.endDate\" ng-disabled=\"invRepVm.sidenavModel.isLocked\" date-range-validator=\"\" date-range-compare-to=\"invRepVm.sidenavModel.data.startDate\" date-range-max-days=\"90\" required=\"\"></md-datepicker><div ng-messages=\"basicInfoForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div><div ng-message=\"dateRange\"><span>Please enter a duration that is not more than 90 days</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><md-select name=\"clients\" ng-model=\"invRepVm.sidenavModel.data.selectedClients\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-disabled=\"invRepVm.sidenavModel.isLocked\" placeholder=\"Client(s)\" multiple=\"\"><md-optgroup label=\"Client(s)\"><md-option ng-value=\"client\" ng-repeat=\"client in invRepVm.sidenavModel.clientLookups\">{{client.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\"><a href=\"#\" class=\"grey-400-fg\" ng-click=\"invRepVm.setInvoiceDate()\" ng-hide=\"invRepVm.sidenavModel.isOverrideInvoiceDate\">Set Invoice Date</a><div layout=\"row\" ng-show=\"invRepVm.sidenavModel.isOverrideInvoiceDate\"><md-input-container flex=\"100\"><label>Invoice Date</label><md-datepicker ng-model=\"invRepVm.sidenavModel.data.overrideInvoiceDate\"></md-datepicker></md-input-container></div></div><div class=\"m-0 pt-0 pb-0 pl-5 pr-0\"><md-input-container class=\"mb-0\"><md-checkbox ng-model=\"invRepVm.sidenavModel.data.showDetails\" ng-change=\"invRepVm.showDetails()\">Show ticket details</md-checkbox><md-checkbox ng-model=\"invRepVm.sidenavModel.data.showTags\" ng-change=\"invRepVm.showTags()\">Show Tags on Preview Invoice</md-checkbox><md-checkbox ng-model=\"invRepVm.sidenavModel.data.showIncludedTags\" ng-change=\"invRepVm.showIncludedTags()\" ng-if=\"invRepVm.sidenavModel.data.showTags\">Show Tags included in Invoice PDF</md-checkbox><md-checkbox ng-model=\"invRepVm.hideCompanies\" ng-change=\"!invRepVm.hideCompanies\">Hide companies without invoices</md-checkbox></md-input-container></div></div></div><div ng-show=\"!invRepVm.sidenavModel.isLocked\" class=\"mt-20 mb-20\"><div layout=\"row\"><md-button class=\"flex md-accent md-raised\" aria-label=\"Generate\" ng-click=\"invRepVm.generatePreview(null, false)\" ng-disabled=\"basicInfoForm.$invalid\">Generate</md-button></div></div><div ng-if=\"invRepVm.sidenavModel.isLocked\" class=\"mt-20 mb-20\"><div layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-raised\" ng-click=\"invRepVm.clearPreview()\">Clear</md-button><md-button class=\"md-raised\" ng-click=\"invRepVm.regenerate()\">Retry</md-button></div><div layout=\"row\" class=\"mt-5\"><md-button ng-if=\"invRepVm.model.isViewingInvoices\" class=\"flex md-raised md-warn\" ng-click=\"invRepVm.deletePreview()\" ng-disabled=\"invRepVm.isDeleteDisabled\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>Delete</md-button></div></div></form></md-content>");
$templateCache.put("app/main/invoice/view/credit-reinvoice/credit-reinvoice-dialog.html","<md-dialog id=\"credit-reinvoice\" aria-label=\"Credit Reinvoice\" flex=\"15\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Credit Reinvoice</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"auto\" ng-form=\"creditReinvoiceForm\"><div flex=\"\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-input-container><label>Invoice Date</label><md-datepicker name=\"creditReinvoice\" ng-model=\"vm.creditInvoiceDate\" required=\"\"></md-datepicker></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button md-no-ink=\"\" ng-disabled=\"creditReinvoiceForm.$invalid\" ng-click=\"vm.save()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/messaging/generalMessaging/sendMessageAsService/message.html","<md-dialog class=\"resource-messaging\" flex-md=\"50\" flex=\"40\" flex-xs=\"90\" flex-sm=\"90\" ng-cloak=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.SEND_MESSAGES\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" ng-click=\"vm.close()\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content id=\"job-message-wrapper\" flex=\"\"><message-container2 employees=\"vm.employees\"></message-container2></md-dialog-content></md-dialog>");
$templateCache.put("app/main/invoice/view/inv-date-chooser/inv-date-chooser.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Dates</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"auto\" ng-form=\"datesForm\"><div flex=\"\" layout-align=\"center center\"><md-radio-group ng-model=\"vm.model.data.filterType\" layout=\"row\" layout-sm=\"column\" required=\"\"><md-radio-button value=\"1\" selected=\"\">Job Start Date</md-radio-button><md-radio-button value=\"2\">Invoice Date</md-radio-button></md-radio-group></div><div flex=\"\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-input-container><label>Start Date</label><md-datepicker ng-model=\"vm.model.data.startDate\" required=\"\"></md-datepicker></md-input-container><md-input-container><label>End Date</label><md-datepicker ng-model=\"vm.model.data.endDate\" required=\"\"></md-datepicker></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"datesForm.$invalid\" ng-click=\"vm.applyFilter()\">Apply Date Filter</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoice/view/purchaseOrder/purchase-order-dialog.html","<md-dialog id=\"purchase-order\" aria-label=\"Purchase Order\" flex=\"18\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Purchase Order Number</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"poForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><md-input-container class=\"md-block\" flex=\"\"><input type=\"text\" placeholder=\"Purchase Order#\" ng-model=\"vm.purchaseOrderNumber\" required=\"\"></md-input-container></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"poForm.$invalid\" ng-click=\"vm.save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/messaging/jobMessaging/sidenav/main-sidenav.html","<md-content ms-scroll=\"\" class=\"content margin-left-15\" flex=\"\"><form name=\"basicInfoForm\"><div class=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"Filter Tickets\" ng-click=\"vm.generatePreview()\" ng-disabled=\"vm.sideNavModel.selectedBranches.length === 0 || basicInfoForm.$invalid || vm.sideNavModel.processingEmailDist || vm.sideNavModel.isLocked\">Filter</md-button></div><div class=\"loading-threads margin-top-5\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.sideNavModel.processingEmailDist\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular><div class=\"margin-top-10\"><strong>{{vm.sideNavModel.progressMessage}}</strong></div></div><div class=\"navigation-simple\" layout=\"column\" flex=\"100\"><div layout-margin=\"\"><div layout=\"row\"><custom-multi-select ng-model=\"vm.sideNavModel.selectedBranches\" options=\"vm.branchLookups\" data=\"full\" display=\"Name\" disabled=\"vm.sideNavModel.isLocked\" flex=\"auto\" limit=\"1\" required=\"true\" name=\"Branches\" label=\"Branch(es)\"></custom-multi-select></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Start Date</label><md-datepicker ng-model=\"vm.sideNavModel.startDate\" ng-disabled=\"vm.sideNavModel.isLocked\" required=\"\"></md-datepicker></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>End Date</label><md-datepicker ng-model=\"vm.sideNavModel.endDate\" ng-disabled=\"vm.sideNavModel.isLocked\" required=\"\"></md-datepicker></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><custom-multi-select ng-model=\"vm.sideNavModel.selectedCompanies\" options=\"vm.clientLookups\" data=\"full\" display=\"Name\" disabled=\"vm.sideNavModel.isLocked\" flex=\"auto\" limit=\"1\" required=\"false\" name=\"Clients\" label=\"Client(s)\"></custom-multi-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.sideNavModel.isSending && vm.sideNavModel.processingEmailDist\"><div class=\"custom-tooltip\"><md-button class=\"md-raised\" aria-label=\"Clear Preview\" ng-click=\"vm.clearPreview()\"><md-icon md-font-icon=\"icon-filter-remove\" class=\"grey-700-fg\"></md-icon>Clear</md-button><span class=\"custom-tooltiptext\">Clear Preview</span></div></div><message-status-component></message-status-component></div></div></form></md-content>");
$templateCache.put("app/main/messaging/jobMessaging/sidenav/message-status.html","<div layout=\"row\" flex=\"100\" class=\"sub-header margin-left-10\"><span><strong>Legend</strong></span></div><div ng-repeat=\"mc in vm.states | orderBy:\'orderSeq\'\" layout=\"row\" flex=\"100\" class=\"legend-item margin-left-10\"><span class=\"status margin-top-0\" ng-class=\"mc.color\"></span> <span class=\"margin-left-8 font-size-9\">{{mc.name}}</span></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/resource-wboard.default.html","<div id=\"resource-whiteboard-calendar\" class=\"page-layout carded fullwidth ng-scope layout-row pd-10\" layout=\"row\" ng-class=\"jobBoardVm.model.settings.bgcolor\"><div class=\"layout-column flex\" flex=\"\"><div ng-class=\"[\'header\']\"><div class=\"header-content margin-top-10\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top pt-10 pb-10\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{ jobBoardVm.navWhiteboardTypeText}}</span><md-menu md-offset=\"0 -5\"><div flex=\"\" layout=\"column\" layout-align=\"end center\" class=\"status-legend-button\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"jobBoardVm.openMenu($mdMenu, $event)\"><md-icon class=\"status-legend-color\" md-svg-icon=\"list\"></md-icon></md-button><span class=\"status-legend-color\">Status Legend</span></div><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in jobBoardVm.statusLegends\" ng-if=\"item.show != undefined && item.show != null ? item.show : true\"><div class=\"status-legend\"><md-icon class=\"status-legend-items {{item.color}}\" md-svg-icon=\"radio-checked2\"></md-icon></div><div flex=\"\" layout=\"column\" layout-align=\"end\"><b>{{item.name}}</b> <span>{{item.description}}</span></div></md-menu-item></md-menu-content></md-menu></div><date-navigation-component behavior=\"jobBoardVm.dateNavigationBehavior\" next=\"jobBoardVm.next()\" prev=\"jobBoardVm.prev()\" on-change-calendar=\"jobBoardVm.onChangeCalendar()\" style=\"height: 20px;\"></date-navigation-component><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.refreshData()\" aria-label=\"Refresh data\" translate=\"\" translate-attr-aria-label=\"SB.REFRESH_DATA\" ng-if=\"jobBoardVm.showRefreshButton\"><md-icon md-font-icon=\"icon-sync\" class=\"amber-700-fg\"></md-icon><md-tooltip><span translate=\"SB.REFRESH_DATA\">Refresh Data</span></md-tooltip></md-button><div ng-if=\"jobBoardVm.viewSettingOptions.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"jobBoardVm.getFilterPlaceholder(\'View Settings\', jobBoardVm.viewSettings)\" ng-model=\"jobBoardVm.viewSettings\"><md-option ng-value=\"option.Id\" ng-repeat=\"option in jobBoardVm.viewSettingOptions\" ng-selected=\"option.selected\">{{ option.Text }}</md-option><div class=\"pl-15\"><md-button class=\"md-raised md-accent button-margin ml-5 w-180\" ng-click=\"jobBoardVm.updateResourceWhiteViewSettings()\">Save</md-button></div></md-select></md-input-container></div><div><md-button ng-if=\"!jobBoardVm.filters.filterIsOpen\" class=\"button-margin\" ng-click=\"jobBoardVm.toggleFilters()\" flex=\"\" layout=\"row\"><span ng-class=\"{\'orange-600-fg\': jobBoardVm.filters.filterMode}\">Show Filter</span> <i class=\"icon-chevron-down ng-scope\"></i></md-button><md-button ng-if=\"jobBoardVm.filters.filterIsOpen\" class=\"button-margin\" ng-click=\"jobBoardVm.toggleFilters()\" flex=\"\" layout=\"row\"><span ng-class=\"{\'orange-600-fg\': jobBoardVm.filters.filterMode}\">Hide Filter</span> <i class=\"icon-chevron-up ng-scope\"></i></md-button></div><div flex=\"\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.setToday()\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\" ng-class=\"{\'orange-600-fg\': jobBoardVm.isToday()}\"></md-icon></md-button><span translate=\"WHITEBOARD.TODAY\" ng-class=\"{\'orange-600-fg\': jobBoardVm.isToday()}\"></span></div><div flex=\"\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.setToDailyView()\" aria-label=\"Day\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.DAY\"><md-icon md-font-icon=\"icon-view-day\" ng-class=\"{\'orange-600-fg\': jobBoardVm.dateNavigationService.isDaily}\"></md-icon></md-button><span translate=\"WHITEBOARD.DAY\" ng-class=\"{\'orange-600-fg\': jobBoardVm.dateNavigationService.isDaily}\"></span></div><div flex=\"\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.setToWeeklyView()\" aria-label=\"Week\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.WEEK\"><md-icon md-font-icon=\"icon-view-week\" ng-class=\"{\'orange-600-fg\': jobBoardVm.dateNavigationService.isWeekly}\"></md-icon></md-button><span translate=\"WHITEBOARD.WEEK\" ng-class=\"{\'orange-600-fg\': jobBoardVm.dateNavigationService.isWeekly}\"></span></div></div></div><div class=\"header-bottom\"><div><span ng-if=\"jobBoardVm.isDaily && jobBoardVm.totalCount !== null\">{{jobBoardVm.dataCount | number:0}} of {{jobBoardVm.totalCount | number:0}}</span><span ng-if=\"jobBoardVm.isDaily && jobBoardVm.totalCount === null && jobBoardVm.isLoadingCount\">{{jobBoardVm.dataCount | number:0}}+</span><span ng-if=\"jobBoardVm.isDaily && jobBoardVm.totalCount === null && !jobBoardVm.isLoadingCount\">{{jobBoardVm.dataCount | number:0}}</span><span ng-if=\"!jobBoardVm.isDaily\">{{jobBoardVm.dataCount | number:0}}</span> Ticket<span ng-if=\"jobBoardVm.dataCount > 1 || (jobBoardVm.isDaily && jobBoardVm.totalCount !== null && jobBoardVm.totalCount > 1)\">s</span></div></div></div><md-button class=\"add-event-button md-fab md-warn\" ng-click=\"jobBoardVm.addTicket($event)\" aria-label=\"Add event\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div flex=\"auto\" ng-hide=\"!jobBoardVm.filters.filterIsOpen\"><filter-whiteboard-component apply-filter=\"jobBoardVm.applyFilter()\" can-search-text=\"!jobBoardVm.isMonthly\" selected-show-hide-filters=\"jobBoardVm.viewSettings\" filter-search-text=\"jobBoardVm.filterSearchText\" is-resource-whiteboard=\"true\"></filter-whiteboard-component></div><div><md-input-container class=\"text-filter-input\"><input type=\"text\" ng-model=\"jobBoardVm.filterSearchText\" placeholder=\"{{\'WHITEBOARD.SEARCH\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"jobBoardVm.searchTextChange()\"></md-input-container></div></div><div id=\"wb-content1\" class=\"content-card layout-column flex\" layout=\"column\" flex=\"\"><md-content class=\"content md-default-theme\" flex=\"\"><job-board-rw-component headers=\"jobBoardVm.weekViewHeaderDates\" source-data=\"jobBoardVm.weekViewComponentData\" allow-grouping=\"jobBoardVm.allowGroupByClient\" show-related-ticket-number=\"jobBoardVm.showRelatedTicketNumber\" show-work-order-number=\"jobBoardVm.showWorkOrderNumber\" is-navigating=\"jobBoardVm.isNavigating\" whiteboard-type=\"jobBoardVm.whiteboardType\" show-project=\"jobBoardVm.showProject\" show-resources=\"jobBoardVm.showResources\" on-cancel-ticket=\"jobBoardVm.onWeekViewCancelTicket(cancelledTickets)\" ng-if=\"jobBoardVm.isWeekly\"></job-board-rw-component><job-board-day-view-rw-component header=\"jobBoardVm.dayViewHeaderText\" current-date=\"jobBoardVm.dayCurrentDate\" source-data=\"jobBoardVm.dayViewComponentData\" allow-grouping=\"jobBoardVm.allowGroupByClient\" show-related-ticket-number=\"jobBoardVm.showRelatedTicketNumber\" show-work-order-number=\"jobBoardVm.showWorkOrderNumber\" is-navigating=\"jobBoardVm.isNavigating\" whiteboard-type=\"jobBoardVm.whiteboardType\" show-project=\"jobBoardVm.showProject\" show-resources=\"jobBoardVm.showResources\" on-cancel-ticket=\"jobBoardVm.onDayViewCancelTicket(cancelledTickets)\" ng-if=\"jobBoardVm.isDaily\"></job-board-day-view-rw-component><div ng-if=\"jobBoardVm.isDaily\" class=\"infinite-scroll-indicator\" style=\"text-align: center; padding: 20px;\"><div ng-if=\"jobBoardVm.pagination.isLoading\" layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular><span style=\"margin-left: 10px;\">Loading more tickets...</span></div><div ng-if=\"!jobBoardVm.pagination.hasMore && !jobBoardVm.pagination.isLoading && jobBoardVm.dataCount > 0\" style=\"color: #666; font-style: italic; padding: 10px;\"><md-icon>check_circle</md-icon>All tickets loaded ({{jobBoardVm.dataCount}} total)</div></div></md-content></div></div><resource-sidenav></resource-sidenav></div>");
$templateCache.put("app/main/jobs/resourceSidenav/advanceOptions/advanceOptions.dialog.html","<md-dialog id=\"advanceOptions\" aria-label=\"Advance Options Form\" flex=\"50\" flex-md=\"50\" flex-sm=\"50\" ng-cloak=\"\"><form name=\"advanceOptionsForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Advance Options</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-card><md-card-title><span class=\"headerTitle\">Show Options</span></md-card-title><md-card-content class=\"font-size-14\" layout-align-md=\"center start\" layout-align-sm=\"center start\" layout-align-xs=\"center start\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\" layout-align=\"space-between center\"><div layout=\"column\"><md-switch ng-model=\"vm.options.showOption.suburb\" ng-change=\"vm.suburbDistanceChange(\'suburb\')\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.EMPLOYEESUBURB\' | translate }}</md-switch><md-switch ng-model=\"vm.options.showOption.distance\" ng-change=\"vm.suburbDistanceChange(\'distance\')\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.EMPLOYEEDISTANCE\' | translate }}</md-switch></div><div layout=\"column\"><md-switch ng-model=\"vm.options.showOption.disable\" ng-change=\"vm.suburbDistanceChange(\'disable\')\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.HIDESUBURBDISTANCE\' | translate }}</md-switch><md-switch ng-model=\"vm.options.showOption.employmentStatus\" ng-change=\"vm.employmentStatusChange()\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.EMPLOYEMENTSTATUS\' | translate }}</md-switch></div><div layout=\"column\"><md-switch ng-model=\"vm.options.showOption.showPrevAndNextShiftDetails\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.NEXT_SHIFT\' | translate }}</md-switch><md-switch ng-model=\"vm.options.showOption.vehicle\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.VEHICLE\' | translate }}</md-switch></div></md-card-content></md-card><md-card><md-card-title><span class=\"headerTitle\">Filter Option</span></md-card-title><md-card-content class=\"font-size-14\" layout-align-md=\"center start\" layout-align-sm=\"center start\" layout-align-xs=\"center start\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\" layout-align=\"space-between center\"><div layout=\"row\"><md-radio-group ng-model=\"vm.options.filterOption\" layout=\"column\" flex=\"\"><md-radio-button value=\"0\">{{ \'RESOURCEALLOCATION.CASUAL\' | translate }}</md-radio-button><md-radio-button value=\"1\">{{ \'RESOURCEALLOCATION.PARTTIME\' | translate }}</md-radio-button><md-radio-button value=\"2\">{{ \'RESOURCEALLOCATION.FULLTIME\' | translate }}</md-radio-button><md-radio-button value=\"3\"><label translate=\"RESOURCEALLOCATION.HIRE\"></label></md-radio-button></md-radio-group></div></md-card-content></md-card><md-card><md-card-title><span class=\"headerTitle\">Vehice Option</span></md-card-title><md-card-content class=\"font-size-14\" layout-align-md=\"center start\" layout-align-sm=\"center start\" layout-align-xs=\"center start\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\" layout-align=\"space-between center\"><div layout=\"row\"><md-switch ng-model=\"vm.options.hasVehicleFilter\" ng-change=\"vm.options.isVehicleFilterActive = true\" aria-label=\"Switch 1\">Has a Vehicle</md-switch></div></md-card-content></md-card><md-card ng-if=\"!vm.options.showOption.disable\"><md-card-title><span class=\"headerTitle\">Sort Options</span></md-card-title><md-card-content class=\"font-size-14\" layout-align-md=\"center start\" layout-align-sm=\"center start\" layout-align-xs=\"center start\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\" layout-align=\"space-between center\"><div layout=\"row\"><md-radio-group ng-model=\"vm.options.sortOption\" layout=\"column\" flex=\"\"><md-radio-button value=\"0\">{{ \'RESOURCEALLOCATION.EMPLOYEENAME\' | translate }}</md-radio-button><md-radio-button value=\"1\" ng-if=\"vm.options.showOption.suburb\">{{ \'RESOURCEALLOCATION.EMPLOYEESUBURB\' | translate }}</md-radio-button><md-radio-button value=\"2\" ng-if=\"vm.options.showOption.distance\">{{ \'RESOURCEALLOCATION.DISTANCETOJOB\' | translate }}</md-radio-button></md-radio-group></div></md-card-content></md-card></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\" ng-style=\"{\'background-image\':\'url({{vm.forgotPasswordBg}})\'}\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div layout=\"column\" layout-align=\"start center\"><img ng-src=\"assets/images/logos/alloc8-login-logo.png\" class=\"login-logo\" alt=\"Alloc8\"></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\" ng-if=\"!vm.sent\">Recover your password</div><form name=\"forgotPasswordForm\" ng-if=\"!vm.sent\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"forgotPasswordForm.email.$error\" ng-show=\"forgotPasswordForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div><div ng-message=\"success\"><span>Reset link sent</span></div></div></md-input-container><div ng-if=\"vm.error\" class=\"md-caption red-900-fg\">{{vm.error_message}}</div><md-button type=\"submit\" ng-click=\"vm.handleForgotPassword()\" class=\"md-raised md-accent\" aria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" ng-class=\"vm.isProcessing\"></md-button><div class=\"spinner-container el-placeholder\" ng-hide=\"!vm.show\"><svg class=\"spinner\" width=\"30px\" height=\"30px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div></form><div ng-if=\"vm.sent\">If you have an account with Alloc8, you will receive an email in a few minutes to reset your password.</div><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/jobs/services/cancelReasonDialog/cancel-reason.html","<md-dialog flex=\"30\" aria-label=\"Cancel dialog\"><form name=\"cancelForm\"><md-dialog-content><h3 class=\"md-title\">Reason for Cancelling Ticket #{{vm.ticket.TicketNumber}}</h3><div flex=\"\" layout=\"row\"><md-input-container><input required=\"\" ng-model=\"vm.reason\" placeholder=\"Reason for cancelling ticket\" type=\"text\"></md-input-container></div><div layout=\"row\" ng-hide=\"vm.isChargeMinHoursEnabled\"><md-input-container><md-checkbox ng-model=\"vm.chargeMinHours\">Charge Minimum Hours</md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised\" ng-click=\"vm.closeDialog()\">Abort</md-button><md-button ng-disabled=\"cancelForm.$invalid\" class=\"md-raised md-accent\" ng-click=\"vm.cancelTicket()\">Cancel Ticket</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\" ng-style=\"{ backgroundImage: \'url(\' + vm.loadedImage + \')\'}\"><div id=\"login-v2-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll=\"\"><div layout=\"column\" layout-align=\"start center\" style=\"padding: 70px; background-color: #0F1B2C;\"><img ng-src=\"{{vm.cdnUrl}}/backgrounds/Company-Logo-Large-Purple.png\" class=\"login-logo\" alt=\"Alloc8\"></div><div id=\"login-v2-form\"><div class=\"title\" translate=\"LOGIN_V2.TITLE\">Log in to your account</div><div layout=\"column\" layout-align=\"start center\" ng-if=\"vm.externalAuthenticator == \'Google\'\"><md-button ng-click=\"vm.getState(\'google\')\" class=\"md-raised google\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN_V2.WITH_GOOGLE\"></span></span></div></md-button></div><div layout=\"column\" layout-align=\"start center\" ng-if=\"vm.externalAuthenticator == \'Microsoft 365\'\"><md-button ng-click=\"vm.getState(\'microsoft\')\" class=\"md-raised microsoft\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-windows\"></md-icon><span translate=\"LOGIN_V2.WITH_MICROSOFT\"></span></span></div></md-button></div><div layout=\"column\" layout-align=\"start center\" ng-if=\"!vm.hasOnlyAlloc8Login && !vm.isAlloc8LoginSelected\"><md-button ng-click=\"vm.isAlloc8LoginSelected = true\" class=\"md-raised alloc8\"><div layout=\"row\" layout-align=\"center center\"><img class=\"png-icon\" ng-src=\"{{vm.cdnUrl}}/backgrounds/Company-Logo-Small-Purple.png\"> <span translate=\"LOGIN_V2.WITH_ALLOC8\"></span></div></md-button></div><form name=\"loginForm\" novalidate=\"\" ng-if=\"vm.isAlloc8LoginSelected || (vm.hasOnlyAlloc8Login && !vm.isAlloc8LoginSelected)\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.service.model.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"LOGIN_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"loginForm.email.$error\" ng-show=\"loginForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.service.model.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required=\"\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN_V2.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" ng-click=\"vm.handleLogin()\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-class=\"vm.service.model.isProcessing\" translate=\"LOGIN_V2.LOG_IN\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button><div layout=\"\" layout-align=\"center center\" class=\"alert-error\" ng-show=\"vm.service.model.showLoginError\">{{ vm.service.model.loginError }}</div><div class=\"spinner-container el-placeholder\" ng-hide=\"!vm.service.model.show\"><svg class=\"spinner\" width=\"30px\" height=\"30px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div></form></div><footer><span>Copyright &copy; {{ vm.copyright }} Alloc8</span></footer></div><div class=\"wrapper images-loaded\" images-loaded-events=\"vm.imageLoadedEvents\" images-loaded-options=\"{ background: true }\" images-loaded-watch=\"vm.backgroundImage\"><img ng-src=\"{{ vm.backgroundImage.url }}\" style=\"display: none;\"></div><div id=\"login-v2-reveal\" class=\"{{ vm.myClass }}\"></div></div>");
$templateCache.put("app/main/jobs/services/chargeMinimumHoursDialog/charge-minimum-hours.html","<md-dialog flex=\"25\" aria-label=\"Charge Minimum Hours dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Charge Minimum Hours</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-svg-icon=\"close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"column\"><md-checkbox ng-model=\"vm.chargeMinHours\" aria-label=\"Charge Minimum Hours\" class=\"mb-0\"><span class=\"md-title\" style=\"font-size: 16px;\">Charge Minimum Hours</span></md-checkbox><p class=\"md-caption text-muted ml-30\">Selecting this option will charge minimum hours to this cancelled ticket upon invoice generation</p></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.save()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/services/cloneAllocationDialog/clone-allocation.html","<md-dialog flex=\"30\" aria-label=\"Cancel dialog\"><form name=\"cancelForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"MANAGE.CLONE_DIALOG_TITLE\"></h2></div></md-toolbar><md-dialog-content layout=\"column\"><div ng-show=\"vm.canCloneAllocatedResources\"><h2 translate=\"MANAGE.CLONE_RESOURCES_SECTION_HEADER\"></h2><div layout=\"row\"><md-checkbox class=\"md-raised md-accent mt-0 mb-20 enable-checkbox\" ng-model=\"vm.shouldCloneResources\" ng-disabled=\"vm.isCloningInProgress || vm.shouldAllocateResourceBySmartScheduling\" ng-click=\"tagsCtrl.toggleActive(tag, $index)\"></md-checkbox><span class=\"md-subhead\" translate=\"MANAGE.ASK_CLONE_RESOURCES\"></span></div><div layout=\"row\" ng-if=\"vm.showAllocateResourceBySmartScheduling\"><md-checkbox class=\"md-raised md-accent mt-0 mb-20 enable-checkbox\" ng-model=\"vm.shouldAllocateResourceBySmartScheduling\" ng-disabled=\"vm.isCloningInProgress || vm.shouldCloneResources\" ng-click=\"tagsCtrl.toggleActive(tag, $index)\"></md-checkbox><span class=\"md-subhead\" translate=\"MANAGE.ASK_CLONE_ALLOCATE_RESOURCE_BY_AI\"></span></div><div layout=\"row\" ng-show=\"vm.canCloneShiftTimes\"><md-checkbox class=\"md-raised md-accent mt-0 mb-20 enable-checkbox\" ng-disabled=\"vm.isCloningInProgress\" ng-model=\"vm.shouldCloneShiftTimes\"></md-checkbox><span class=\"md-subhead\" translate=\"MANAGE.ASK_UPDATE_SHIFT_TIMES\"></span></div></div><div ng-show=\"vm.showCloneFormsAndAttachments\"><h2 translate=\"MANAGE.CLONE_FORMS_AND_ATTACHMENTS_SECTION_HEADER\"></h2><div layout=\"row\"><md-checkbox class=\"md-raised md-accent mt-0 mb-20 enable-checkbox\" ng-model=\"vm.shouldCloneForms\" ng-disabled=\"vm.isCloningInProgress\" ng-click=\"tagsCtrl.toggleActive(tag, $index)\"></md-checkbox><span class=\"md-subhead\" translate=\"MANAGE.ASK_CLONE_FORMS\"></span></div><div layout=\"row\" ng-show=\"vm.canCloneAttachments\"><md-checkbox class=\"md-raised md-accent mt-0 mb-20 enable-checkbox\" ng-model=\"vm.shouldCloneAttachments\" ng-disabled=\"vm.isCloningInProgress\" ng-click=\"tagsCtrl.toggleActive(tag, $index)\"></md-checkbox><span class=\"md-subhead\" translate=\"MANAGE.ASK_CLONE_ATTACHMENTS\"></span></div></div><span class=\"md-subhead\" ng-if=\"vm.isCloningInProgress\" layout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-diameter=\"40\"></md-progress-circular><span class=\"md-subhead\" translate=\"MANAGE.CLONE_RESOURCES_PROCESSING_MESSAGE\"></span></span></md-dialog-content><md-dialog-actions><md-button translate=\"MANAGE.PROCEED\" ng-disabled=\"vm.isCloningInProgress\" ng-click=\"vm.proceed()\" class=\"md-raised md-accent md-primary\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/auth/update-password/update-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\" ng-style=\"{\'background-image\':\'url({{vm.updatePasswordBg}})\'}\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div layout=\"column\" layout-align=\"start center\"><img ng-src=\"assets/images/logos/alloc8-login-logo.png\" class=\"login-logo\" alt=\"Alloc8\"></div><div ng-if=\"vm.token == null || vm.email == null\" class=\"title md-caption\">Please click the reset link sent to your email address</div><div ng-if=\"vm.token && vm.email\" class=\"title\" translate=\"UPDATEPASSWORD.TITLE\"></div><form ng-if=\"vm.token && vm.email\" ng-hide=\"vm.success\" name=\"updatePasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.password\" placeholder=\"Password\" ng-minlength=\"8\" translate=\"\" translate-attr-placeholder=\"UPDATEPASSWORD.PASSWORD\" required=\"\"><div ng-messages=\"updatePasswordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"UPDATEPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\"><span>Password must be at least 8 characters</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-if=\"updatePasswordForm.password.$valid\" ng-model=\"vm.confirmPassword\" placeholder=\"Confirm New Password\" translate=\"\" translate-attr-placeholder=\"UPDATEPASSWORD.CONFIRM_PASSWORD\" required=\"\"><div ng-if=\"(vm.password != vm.confirmPassword) && updatePasswordForm.password.$valid && updatePasswordForm.passwordConfirm.$touched\" role=\"alert\"><div><span style=\"color: red;font-size : 12px; line-height : 14px; margin-top : 15px;\">Confirm password does not match</span></div></div></md-input-container><div ng-if=\"vm.error\" class=\"md-caption red-900-fg\">{{vm.error_message}}</div><md-button type=\"submit\" ng-click=\"vm.handleUpdatePassword()\" ng-if=\"vm.password == vm.confirmPassword && updatePasswordForm.password.$valid\" class=\"md-raised md-accent\" aria-label=\"UPDATE\" translate=\"UPDATEPASSWORD.UPDATE\" translate-attr-aria-label=\"UPDATEPASSWORD.UPDATE\" ng-class=\"vm.isProcessing\"></md-button><div class=\"spinner-container el-placeholder\" ng-hide=\"!vm.show\"><svg class=\"spinner\" width=\"30px\" height=\"30px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div></form><div ng-if=\"vm.success\"><span translate=\"UPDATEPASSWORD.UPDATE_PASSWORD_SUCCESSFUL\">You have successfully changed your password.</span></div><div ng-if=\"vm.success && vm.isMobileAppRequest\"><span translate=\"UPDATEPASSWORD.UPDATE_PASSWORD_OPEN_APP\">Please open the Alloc8 App and log in.</span></div><div ng-if=\"vm.success && !vm.isMobileAppRequest\" class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"UPDATEPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/jobs/services/unconfirmJobDialog/unconfirm-job-dialog.html","<md-dialog id=\"unconfirm-job\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Unconfirmed Job</h2></div></md-toolbar><md-dialog-content><div class=\"padding-10\"><div>This job is being marked as Unconfirmed while there are shifts that have already been confirmed. Would you like to remove them?</div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised\" ng-click=\"vm.onNo()\">No, proceed with Save</md-button><md-button ng-disabled=\"cancelForm.$invalid\" class=\"md-raised md-accent\" ng-click=\"vm.onYes()\">Yes, unallocate resources</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/services/updateShiftTimesDialog/update-shift-times.html","<md-dialog id=\"update-shift-times\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Update shift times to the new job time?</h2></div></md-toolbar><md-dialog-content><div class=\"padding-10\"><div>{{vm.message}}</div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised\" ng-click=\"vm.onNo()\">No</md-button><md-button ng-disabled=\"cancelForm.$invalid\" class=\"md-raised md-accent\" ng-click=\"vm.onYes()\">Yes</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/job-board.default.html","<div id=\"whiteboard-calendar\" class=\"page-layout carded fullwidth ng-scope layout-row pd-20 pt-20\" layout=\"row\" ng-class=\"jobBoardVm.model.settings.bgcolor\"><div class=\"layout-column flex\" flex=\"\"><div ng-class=\"[\'header\']\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top pt-10 pb-10\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{ jobBoardVm.navWhiteboardTypeText}}</span><md-menu md-offset=\"0 -5\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"jobBoardVm.openMenu($mdMenu, $event)\"><md-icon md-font-icon=\"icon-menu\" class=\"amber-700-fg\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in jobBoardVm.whiteboardTypes\"><md-button ng-click=\"jobBoardVm.whiteboardTypeClick($index)\"><md-icon md-font-icon=\"{{item.icon}}\"></md-icon>{{item.name}}</md-button></md-menu-item></md-menu-content></md-menu></div><date-navigation-component behavior=\"jobBoardVm.dateNavigationBehavior\" next=\"jobBoardVm.next()\" prev=\"jobBoardVm.prev()\" on-change-calendar=\"jobBoardVm.onChangeCalendar()\" style=\"height: 20px;\"></date-navigation-component><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.refreshData()\" aria-label=\"Refresh data\" translate=\"\" translate-attr-aria-label=\"SB.REFRESH_DATA\" ng-if=\"jobBoardVm.showRefreshButton\"><md-icon md-font-icon=\"icon-sync\" class=\"amber-700-fg\"></md-icon><md-tooltip><span translate=\"SB.REFRESH_DATA\">Refresh Data</span></md-tooltip></md-button><md-button class=\"md-icon-button orange-600-fg\" ng-click=\"jobBoardVm.toggleFilters()\" aria-label=\"Filter Tickets\" translate=\"\" translate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\" ng-class=\"{\'orange-600-fg\': jobBoardVm.filters.filterMode}\"></md-icon><md-tooltip><span translate=\"SB.FILTER_CARDS\">Filter Tickets</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.setToday()\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"WHITEBOARD.TODAY\">Today</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.setToDailyView()\" aria-label=\"Day\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"WHITEBOARD.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.setToWeeklyView()\" aria-label=\"Week\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"WHITEBOARD.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"jobBoardVm.setToMonthlyView()\" aria-label=\"Month\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"WHITEBOARD.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\"><div>{{jobBoardVm.dataCount | number:0}} Ticket<span ng-if=\"jobBoardVm.dataCount > 1\">s</span></div></div></div><div flex=\"auto\" ng-hide=\"!jobBoardVm.filters.filterIsOpen\"><filter-whiteboard-component apply-filter=\"jobBoardVm.applyFilter()\" can-search-text=\"!jobBoardVm.isMonthly\" selected-show-hide-filters=\"jobBoardVm.viewSettingOptions\" filter-search-text=\"jobBoardVm.filterSearchText\"></filter-whiteboard-component></div><div><md-input-container class=\"text-filter-input\"><input type=\"text\" ng-model=\"jobBoardVm.filterSearchText\" placeholder=\"{{\'WHITEBOARD.SEARCH\' | translate}}\" ng-change=\"jobBoardVm.searchTextChange()\"></md-input-container></div></div><div id=\"wb-content\" class=\"content-card layout-column flex\" layout=\"column\" flex=\"\"><md-content class=\"content md-default-theme\" flex=\"\"><job-monthly-component behavior=\"jobBoardVm.calendarMoBehavior\" event-data=\"jobBoardVm.monthViewComponentData\" current-month-short=\"jobBoardVm.currentMonthShort\" on-render=\"jobBoardVm.onRender(calViewObj)\" on-change-view=\"jobBoardVm.onChangeView(e)\" ng-if=\"jobBoardVm.isMonthly\"></job-monthly-component><job-board-component show-project=\"jobBoardVm.showProject\" headers=\"jobBoardVm.weekViewHeaderDates\" source-data=\"jobBoardVm.weekViewComponentData\" allow-grouping=\"jobBoardVm.allowGroupByClient\" show-related-ticket-number=\"jobBoardVm.showRelatedTicketNumber\" is-navigating=\"jobBoardVm.isNavigating\" whiteboard-type=\"jobBoardVm.whiteboardType\" on-cancel-ticket=\"jobBoardVm.onWeekViewCancelTicket(cancelledTickets)\" ng-if=\"jobBoardVm.isWeekly\"></job-board-component><job-board-day-view-component show-project=\"jobBoardVm.showProject\" header=\"jobBoardVm.dayViewHeaderText\" current-date=\"jobBoardVm.dayCurrentDate\" source-data=\"jobBoardVm.dayViewComponentData\" allow-grouping=\"jobBoardVm.allowGroupByClient\" show-related-ticket-number=\"jobBoardVm.showRelatedTicketNumber\" is-navigating=\"jobBoardVm.isNavigating\" whiteboard-type=\"jobBoardVm.whiteboardType\" on-cancel-ticket=\"jobBoardVm.onDayViewCancelTicket(cancelledTickets)\" ng-if=\"jobBoardVm.isDaily\"></job-board-day-view-component></md-content></div></div></div>");
$templateCache.put("app/main/jobs/ticketBilling/main/ticket-billing-main.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"ticketBillingVm.service.loading\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><div layout=\"row\" hide-gt-md=\"\" class=\"form-wrapper md-whiteframe-1dp main-style mb-10\"><sidenav-filter-small-screen layout=\"row\" additional-class=\"md-fab md-mini md-accent pull-right\" name=\"{{ticketBillingVm.showFiltersText}}\" ng-click=\"ticketBillingVm.toggleSidenav(\'main-sidenav\')\"></sidenav-filter-small-screen></div><md-content ms-scroll=\"\"><ticket-billing-content-component ticketslist=\"ticketBillingVm.service.groupedTickets\" billingperiods=\"ticketBillingVm.service.billingPeriods\" ontranslate=\"ticketBillingVm.service.translate\" changeperiod=\"ticketBillingVm.service.ticketbillingpreferences\" onshowdetails=\"ticketBillingVm.showDetails\"></ticket-billing-content-component></md-content>");
$templateCache.put("app/main/jobs/ticketBilling/sidenav/main-sidenav.html","<md-content ms-scroll=\"\" class=\"content margin-left-15\" flex=\"\"><div class=\"compose-button\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.service.loadTickets()\" ng-if=\"ticketBillingForm.$valid\" aria-label=\"Generate\">Load Tickets</md-button></div><div class=\"navigation-simple\" layout=\"column\" flex=\"100\" ng-form=\"ticketBillingForm\"><div layout-margin=\"\"><div layout=\"row\"><md-input-container flex=\"100\"><label>Branch</label><md-select ng-model=\"vm.service.params.BranchId\" md-on-open=\"vm.service.loadBranches()\" ng-change=\"vm.service.loadClients()\" required=\"\"><md-option ng-repeat=\"branch in vm.service.branches\" ng-value=\"branch.Id\">{{branch.Name}}</md-option></md-select></md-input-container></div><div class=\"spinner-container el-placeholder\" ng-if=\"vm.service.loadingClients\"><svg class=\"spinner\" width=\"30px\" height=\"30px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div layout=\"row\" class=\"sidenav-design\" ng-if=\"vm.service.clients.length > 0\" id=\"company\"><md-autocomplete class=\"sidenav-design\" md-no-cache=\"true\" md-selected-item=\"vm.service.selectedItem\" md-search-text=\"vm.service.searchText\" md-selected-item-change=\"vm.service.selectedItemChange(item)\" md-items=\"item in vm.service.querySearch(vm.service.searchText)\" md-item-text=\"item.Name\" md-min-length=\"0\" placeholder=\"Client\"><md-item-template><span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.Name}}</span></md-item-template><md-not-found>Start typing client\'s name</md-not-found></md-autocomplete></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Start Date</label><md-datepicker ng-model=\"vm.service.params.StartDate\" required=\"\"></md-datepicker></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>End Date</label><md-datepicker ng-model=\"vm.service.params.EndDate\" required=\"\"></md-datepicker></md-input-container></div></div></div></md-content>");
$templateCache.put("app/main/jobs/widget/DraggableComponent/Draggable-Resource.html","<div class=\"md-whiteframe-1dp\" id=\"draggable-resource\" flex=\"20\" flex-xs=\"100\" flex-sm=\"30\" layout=\"column\"><md-content class=\"list\"><md-list style=\"height: 100%; padding-top: 0;\"><md-list-item><input type=\"text\" placeholder=\"{{ \'MANAGE.SEARCH\' | translate }}\" ng-enter=\"$event.preventDefault();\" ng-change=\"draggableResourcevm.searchTextChange(query.item.ItemName)\" ng-disabled=\"draggableResourcevm.ngService.jobModel.IsLocked || (draggableResourcevm.ngService.jobModel.IsLockedByPreSchedule && draggableResourcevm.isSmartSchedulingEnabled)\" class=\"md-block\" ng-model=\"query.item.ItemName\"></md-list-item><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.service.isLoading\" class=\"md-accent draggables\"></md-progress-circular><md-subheader style=\"z-index: 1\" class=\"md-no-sticky\" translate=\"\" ng-if=\"draggableResourcevm.ngService.kitsLookup.length > 0\"><div layout=\"row\"><div layout=\"row\" flex=\"\" translate=\"MANAGE.KIT\"></div><div div=\"\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"draggableResourcevm.ngService.isLoadingKit\" md-diameter=\"20px\" class=\"md-accent draggables\"></md-progress-circular></div></div></md-subheader><div class=\"list-scroll\" ms-scroll=\"\" style=\"margin-top: -9px\" ng-if=\"draggableResourcevm.ngService.kitsLookup.length > 0\"><draggable-kit-component kit-list=\"draggableResourcevm.ngService.kitsLookup\" resource-model=\"draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel\" on-double-click=\"draggableResourcevm.service.dropped\" on-mouse-enter=\"draggableResourcevm.removeClass\" on-click=\"draggableResourcevm.removeClass\" on-mouse-leave=\"draggableResourcevm.removeClass\" watch-depth=\"value\"></draggable-kit-component></div><md-subheader class=\"md-no-sticky\" translate=\"\"><div layout=\"row\"><div layout=\"row\" flex=\"\" translate=\"MANAGE.EQUIPMENT\"></div><div div=\"\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"draggableResourcevm.ngService.isLoadingAsset\" md-diameter=\"20px\" class=\"md-accent draggables\"></md-progress-circular></div></div></md-subheader><div ng-if=\"(draggableResourcevm.ngService.jobModel.TicketType == 1 || draggableResourcevm.ngService.jobModel.TicketType == 4) && draggableResourcevm.ngService.kitsLookup.length == 0\" class=\"list-scroll_equipmentOnlyNoKits\" ms-scroll=\"\"><div ng-repeat=\"item in draggableResourcevm.ngModel.nonPeopleAssets | filter: query.item.ItemName track by item.id\" ng-dblclick=\"draggableResourcevm.service.dropped(item.id,$event, draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseenter=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-click=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseleave=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" draggable=\"true\" draggable-data=\"{{item.id}}\" class=\"assets-item-inner\" onmouseover=\"this.style.background=\'#999999\'; this.style.color=\'#FFFFFF\';\" onmouseout=\"this.style.background=\'#FFFFFF\'; this.style.color=\'#000\';\"><p>{{item.ItemName}}</p></div></div><div ng-if=\"(draggableResourcevm.ngService.jobModel.TicketType == 1 || draggableResourcevm.ngService.jobModel.TicketType == 4) && draggableResourcevm.ngService.kitsLookup.length > 0\" class=\"list-scroll_equipment\" ms-scroll=\"\"><div ng-repeat=\"item in draggableResourcevm.ngModel.nonPeopleAssets | filter: query.item.ItemName track by item.id\" ng-dblclick=\"draggableResourcevm.service.dropped(item.id,$event, draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseenter=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-click=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseleave=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" draggable=\"true\" draggable-data=\"{{item.id}}\" class=\"assets-item-inner\" onmouseover=\"this.style.background=\'#999999\'; this.style.color=\'#FFFFFF\';\" onmouseout=\"this.style.background=\'#FFFFFF\'; this.style.color=\'#000\';\"><p>{{item.ItemName}}</p></div></div><div ng-if=\"(draggableResourcevm.ngService.jobModel.TicketType == 3 || draggableResourcevm.ngService.jobModel.TicketType == 7 || draggableResourcevm.ngService.jobModel.TicketType == 6) && draggableResourcevm.ngService.kitsLookup.length == 0\" class=\"list-scrollNoKits\" ms-scroll=\"\"><div ng-repeat=\"item in draggableResourcevm.ngModel.nonPeopleAssets | filter: query.item.ItemName track by item.id\" ng-dblclick=\"draggableResourcevm.service.dropped(item.id,$event, draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseenter=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-click=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseleave=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" draggable=\"true\" draggable-data=\"{{item.id}}\" class=\"assets-item-inner\" onmouseover=\"this.style.background=\'#999999\'; this.style.color=\'#FFFFFF\';\" onmouseout=\"this.style.background=\'#FFFFFF\'; this.style.color=\'#000\';\"><p>{{item.ItemName}}</p></div></div><div ng-if=\"(draggableResourcevm.ngService.jobModel.TicketType == 3 || draggableResourcevm.ngService.jobModel.TicketType == 7 || draggableResourcevm.ngService.jobModel.TicketType == 6) && draggableResourcevm.ngService.kitsLookup.length > 0\" class=\"list-scroll\" ms-scroll=\"\"><div ng-repeat=\"item in draggableResourcevm.ngModel.nonPeopleAssets | filter: query.item.ItemName track by item.id\" ng-dblclick=\"draggableResourcevm.service.dropped(item.id,$event, draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseenter=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-click=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseleave=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" draggable=\"true\" draggable-data=\"{{item.id}}\" class=\"assets-item-inner\" onmouseover=\"this.style.background=\'#999999\'; this.style.color=\'#FFFFFF\';\" onmouseout=\"this.style.background=\'#FFFFFF\'; this.style.color=\'#000\';\"><p>{{item.ItemName}}</p></div></div><md-subheader class=\"md-no-sticky\" translate=\"\" ng-if=\"draggableResourcevm.ngService.jobModel.TicketType == 3 || draggableResourcevm.ngService.jobModel.TicketType == 7 || draggableResourcevm.ngService.jobModel.TicketType == 6\"><div layout=\"row\"><div layout=\"row\" flex=\"\">Shift Types</div><div div=\"\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"draggableResourcevm.ngService.isLoadingAsset\" md-diameter=\"20px\" class=\"md-accent draggables\"></md-progress-circular></div></div></md-subheader><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.service.isLoadingAsset\" class=\"md-accent draggables\"></md-progress-circular><div class=\"list-scroll\" ms-scroll=\"\" ng-if=\"(draggableResourcevm.ngService.jobModel.TicketType == 3 || draggableResourcevm.ngService.jobModel.TicketType == 7 || draggableResourcevm.ngService.jobModel.TicketType == 6) && draggableResourcevm.ngService.kitsLookup.length > 0\"><div ng-repeat=\"item in draggableResourcevm.ngModel.peopleAssets | filter: query.item.ItemName track by item.id\" ng-dblclick=\"draggableResourcevm.service.dropped(item.id,$event, draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseenter=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-click=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseleave=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" draggable=\"true\" draggable-data=\"{{item.id}}\" class=\"assets-item-inner\" onmouseover=\"this.style.background=\'#999999\'; this.style.color=\'#FFFFFF\';\" onmouseout=\"this.style.background=\'#FFFFFF\'; this.style.color=\'#000\';\"><p>{{ item.ItemName }}</p></div></div><div class=\"list-scrollNoKits\" ms-scroll=\"\" ng-if=\"(draggableResourcevm.ngService.jobModel.TicketType == 3 || draggableResourcevm.ngService.jobModel.TicketType == 7 || draggableResourcevm.ngService.jobModel.TicketType == 6) && draggableResourcevm.ngService.kitsLookup.length == 0\"><div ng-repeat=\"item in draggableResourcevm.ngModel.peopleAssets | filter: query.item.ItemName track by item.id\" ng-dblclick=\"draggableResourcevm.service.dropped(item.id,$event, draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseenter=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-click=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" ng-mouseleave=\"draggableResourcevm.removeClass(draggableResourcevm.ngAuxmodel == undefined ? draggableResourcevm.ngService.jobModel.Resource : draggableResourcevm.ngAuxmodel)\" draggable=\"true\" draggable-data=\"{{item.id}}\" class=\"assets-item-inner\" onmouseover=\"this.style.background=\'#999999\'; this.style.color=\'#FFFFFF\';\" onmouseout=\"this.style.background=\'#FFFFFF\'; this.style.color=\'#000\';\"><p>{{ item.ItemName }}</p></div></div></md-list></md-content></div>");
$templateCache.put("app/main/jobs/widget/JobDuration/job-duration.html","<md-dialog aria-label=\"{{vm.title}}\" flex=\"25\" ng-cloak=\"\"><form name=\"jobDurationDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container ng-if=\"vm.jobDurationVisible\"><input type=\"text\" placeholder=\"Job Duration\" class=\"md-block\" ng-model=\"vm.JobDuration\"></md-input-container><mdp-date-picker ng-if=\"vm.jobEndDateVisible\" mdp-open-on-click=\"\" mdp-placeholder=\"Job End Date\" mdp-format=\"{{vm.dateFormat}}\" mdp-min-date=\"vm.minDate\" class=\"md-block\" ng-model=\"vm.JobEndDate\"></mdp-date-picker><div ng-if=\"vm.jobDurationVisible\"><a href=\"#\" class=\"md-caption\" ng-click=\"vm.showOtherOption()\">Enter End Date</a></div><div ng-if=\"vm.jobEndDateVisible\"><a href=\"#\" class=\"md-caption\" ng-click=\"vm.showOtherOption()\">Enter Job Duration</a></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-accent\" style=\"margin-right:20px;\" ng-click=\"vm.onDone()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/widget/JobDuration/job-duration_backup.html","<md-dialog aria-label=\"{{vm.title}}\" flex=\"25\" ng-cloak=\"\"><form name=\"jobDurationDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container ng-if=\"vm.jobDurationVisible\"><input type=\"text\" placeholder=\"Job Duration\" class=\"md-block\" ng-model=\"vm.JobDuration\"></md-input-container><mdp-date-picker ng-if=\"vm.jobEndDateVisible\" mdp-open-on-click=\"\" mdp-placeholder=\"Job End Date\" mdp-format=\"{{vm.dateFormat}}\" mdp-min-date=\"vm.minDate\" class=\"md-block\" ng-model=\"vm.JobEndDate\"></mdp-date-picker><div ng-if=\"vm.jobDurationVisible\"><a href=\"#\" class=\"md-caption\" ng-click=\"vm.showOtherOption()\">Enter End Date</a></div><div ng-if=\"vm.jobEndDateVisible\"><a href=\"#\" class=\"md-caption\" ng-click=\"vm.showOtherOption()\">Enter Job Duration</a></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-accent\" style=\"margin-right:20px;\" ng-click=\"vm.onDone()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/widget/DroppedAssetComponent/Dropped-Asset.html","<div id=\"dropped-asset\" ms-scroll=\"\" ng-style=\"droppedAssetComponentVm.containerHeightStyle\" style=\"display: block; position: relative;\"><form name=\"droppedAssetFrom\"><md-card ng-if=\"droppedAssetComponentVm.ngModel.length > 0\" layout=\"column\" style=\"padding-top: 10px;\"><md-card-content ng-class=\"{\'deleted\': item.IsDeleted}\" ng-repeat=\"item in droppedAssetComponentVm.ngModel | containsOf:droppedAssetComponentVm.ngType track by item.Id\" id=\"company-body\" onmouseover=\"this.style.background=\'#999999\'; this.style.color=\'#FFFFFF\';\" onmouseout=\"this.style.background=\'#FFFFFF\'; this.style.color=\'#000\';\"><div ng-class=\"item.ripple\" ng-show=\"!item.IsDeleted\" layout=\"row\" id=\"company-body-content\" ng-click=\"droppedAssetComponentVm.edit(item.Id, true);\"><div flex=\"70\" ng-class=\"{\'muted-text\': droppedAssetComponentVm.ngService.jobModel.IsLocked || (droppedAssetComponentVm.ngService.jobModel.IsLockedByPreSchedule && droppedAssetComponentVm.isSmartSchedulingEnabled) || droppedAssetComponentVm.ngService.jobModel.IsCancelled}\">{{item.ItemName}}</div><div flex=\"25\" style=\"padding-left: 18px;\" ng-class=\"{\'muted-text\': droppedAssetComponentVm.ngService.jobModel.IsLocked || (droppedAssetComponentVm.ngService.jobModel.IsLockedByPreSchedule && droppedAssetComponentVm.isSmartSchedulingEnabled) || droppedAssetComponentVm.ngService.jobModel.IsCancelled}\">{{item.ItemQuantity}}</div><div flex=\"5\" layout=\"row\" layout-align=\"end center\" ng-if=\"!droppedAssetComponentVm.ngService.jobModel.IsLocked && !droppedAssetComponentVm.ngService.jobModel.IsLockedByPreSchedule && !droppedAssetComponentVm.ngService.jobModel.IsCancelled\"><md-icon md-svg-icon=\"delete\" style=\"cursor: pointer;\" ng-click=\"droppedAssetComponentVm.removed(item.Id, $event, item.IsNew);\"></md-icon></div></div></md-card-content></md-card></form></div>");
$templateCache.put("app/main/jobs/widget/TagFilter/tag-filter.html","<div layout=\"column\" flex=\"\" class=\"tag-filter-container\"><div layout=\"row\" flex=\"\" class=\"tag-filter-autocomplete\"><md-autocomplete flex=\"auto\" md-input-name=\"tagFilter\" md-no-cache=\"true\" md-search-text=\"vm.searchText\" md-items=\"tag in vm.querySearchTag(vm.searchText)\" md-selected-item-change=\"vm.filterSelected()\" md-selected-item=\"vm.selectedItem\" md-min-length=\"0\" md-floating-label=\"{{::vm.label}}\" md-menu-class=\"autocomplete-tags-template\" md-menu-container-class=\"tags-filter-dropdown\"><md-item-template><span md-highlight-text=\"tag.searchText\" class=\"tag-item\">{{tag.Name}}</span></md-item-template></md-autocomplete></div><div layout=\"row\" flex=\"\" class=\"selected-tags\"><md-input-container flex=\"\"><span ng-repeat=\"tag in vm.selectedTags\" class=\"rounded-pill\" ng-class=\"{\'inactive\': !tag.IsActive}\">{{tag.Name}} <span class=\"delete\" ng-click=\"vm.removeTagFilter(tag)\">&nbsp;&nbsp;x&nbsp;&nbsp;</span></span></md-input-container></div></div>");
$templateCache.put("app/main/pages/errors/403/error-403.html","<div id=\"error-403\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR403.CODE\">Access denied</div><div class=\"message\" translate=\"ERROR403.MESSAGE\">You do not have permission to view this page.</div><div class=\"sub-message\" translate=\"ERROR403.SUBMESSAGE\">Contact your system administrator regarding this matter.</div><a class=\"report-link md-accent-color\" href=\"/dashboard\" translate=\"ERROR403.DASHBOARD\">Go to home</a></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" translate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div class=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate=\"\" translate-attr-placeholder=\"ERROR404.SEARCH\" flex=\"\"></div><a class=\"back-link md-accent-color\" href=\"/jobs/whiteboard\" translate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" translate=\"ERROR500.MESSAGE\">Your connection was interrupted</div><div class=\"sub-message\"><label translate=\"ERROR500.SUBMESSAGE\"></label><ul class=\"text-left ml-100 mr-100\"><li>Clearing your cache</li><li>Refreshing the page</li><li>Checking if the problem persists on a colleagues computer.</li></ul><label>If the above fail please <a class=\"md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\"></a></label></div></div></div>");
$templateCache.put("app/main/pages/errors/unhandled/error-unhandled.html","<div id=\"error-unhandled\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" ng-cloak=\"\">{{vm.code}}</div><div class=\"message\" translate=\"ERROR500.MESSAGE\">Your connection was interrupted</div><div class=\"sub-message\"><label translate=\"ERROR500.SUBMESSAGE\"></label><ul class=\"text-left ml-100 mr-100\"><li>Clearing your cache</li><li>Refreshing the page</li><li>Checking if the problem persists on a colleagues computer.</li></ul><label>If the above fail please <a class=\"md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\"></a></label></div></div></div>");
$templateCache.put("app/main/paperWorkConfigurationOptions/headers/Large/config-large-header.html","<div layout=\"row\"><div class=\"h2\" flex=\"none\">{{\'PAPERWORK_CONFIG.TITLE\' | translate}}</div><span class=\"ml-16 text-boxed blue-bg white-fg\">{{vm.length}} {{\'PAPERWORK_CONFIG.ITEMS\' | translate}}</span></div>");
$templateCache.put("app/main/paperWorkConfigurationOptions/headers/Small/config-small-header.html","<div layout=\"row\"><i class=\"icon pr-16 mr-16 icon-memory light-blue-900-fg\"></i><div class=\"h4 text-bold\" style=\"position :relative; top : 3px;\" flex=\"none\">{{\'PAPERWORK_CONFIG.TITLE\' | translate}}</div></div>");
$templateCache.put("app/main/paperWorkConfigurationOptions/views/ExtraSmall/config-extra-small-view.html","<div class=\"font-size-14\" layout-align=\"space-between start\" layout=\"column\" flex-sm=\"100\" flex-xs=\"100\"><div class=\"text-bold margin-bottom-10\">{{vm.item.ConfigOptionText}}</div><div ng-if=\"vm.isRelationalField(vm.item.ConfigOptionOperator)\" class=\"margin-top-10\"><md-radio-group ng-model=\"vm.item.ConfigOptionOperator\"><md-radio-button ng-value=\"0\">{{\'PAPERWORK_CONFIG.GREATER_THAN\' | translate}}</md-radio-button><md-radio-button ng-value=\"1\">{{\'PAPERWORK_CONFIG.GREATER_THAN_OR_EQUAL_TO\' | translate}}</md-radio-button></md-radio-group></div><md-radio-group ng-if=\"!vm.isRelationalField(vm.item.ConfigOptionOperator)\" ng-model=\"vm.item.Value\" layout=\"row\"><md-radio-button value=\"Yes\">{{\'PAPERWORK_CONFIG.YES\' | translate}}</md-radio-button><md-radio-button value=\"No\">{{\'PAPERWORK_CONFIG.NO\' | translate}}</md-radio-button></md-radio-group><div><md-input-container class=\"md-block\" ng-if=\"vm.isRelationalField(vm.item.ConfigOptionOperator)\" style=\"padding :0px; margin:0px; position : relative; top:-10px;\"><input ng-required=\"true\" min=\"0\" type=\"number\" ng-model=\"vm.item.Value\"></md-input-container></div></div>");
$templateCache.put("app/main/paperWorkConfigurationOptions/views/Large/config-extra-large-view.html","<div flex=\"\" layout=\"row\" class=\"md-body-1\"><div flex=\"10\"><i class=\"icon pr-16 mr-16 border-right icon-memory light-blue-900-fg\"></i></div><div flex=\"25\" class=\"text-bold\" flex-sm=\"100\" flex-xs=\"100\">{{vm.item.ConfigOptionText}}</div><div flex=\"\"></div><div flex=\"40\"><md-input-container class=\"md-block\" style=\"padding :0px; margin:0px; position : relative; top:-10px;\"><md-radio-group ng-if=\"vm.isRelationalField(vm.item.ConfigOptionOperator)\" ng-model=\"vm.item.ConfigOptionOperator\" layout=\"row\"><table width=\"100%\"><tr><td width=\"50%\"><md-radio-button value=\"0\">{{\'PAPERWORK_CONFIG.GREATER_THAN\' | translate}}</md-radio-button></td><td width=\"50%\"><md-radio-button value=\"1\">{{\'PAPERWORK_CONFIG.GREATER_THAN_OR_EQUAL_TO\' | translate}}</md-radio-button></td></tr></table></md-radio-group><md-radio-group ng-if=\"!vm.isRelationalField(vm.item.ConfigOptionOperator)\" ng-model=\"vm.item.Value\" layout=\"row\"><table width=\"100%\"><tr><td width=\"50%\"><md-radio-button value=\"Yes\">{{\'PAPERWORK_CONFIG.YES\' | translate}}</md-radio-button></td><td width=\"50%\"><md-radio-button value=\"No\">{{\'PAPERWORK_CONFIG.NO\' | translate}}</md-radio-button></td></tr></table></md-radio-group></md-input-container></div><div flex=\"auto\"></div><div flex=\"15\" flex-sm=\"100\" flex-xs=\"100\"><md-input-container class=\"md-block\" ng-if=\"vm.isRelationalField(vm.item.ConfigOptionOperator)\" style=\"padding :0px; margin:0px; position : relative; top:-10px;\"><input class=\"text-bold\" ng-required=\"itm.ConfigOptionOperator != null\" min=\"0\" type=\"number\" step=\"any\" ng-model=\"vm.item.Value\"></md-input-container></div></div>");
$templateCache.put("app/main/paperWorkConfigurationOptions/views/Small/config-small-view.html","<div flex=\"\" class=\"font-size-12 margin-bottom-40\"><div flex=\"\" layout=\"row\" layout-align=\"space-between start\"><div flex=\"40\" class=\"text-bold\">{{item.Name}}</div><span flex=\"5\"></span><div flex=\"30\"><md-input-container class=\"md-block\" style=\"padding-bottom :0px; margin:0px; position : relative; top:-10px;\"><md-radio-group ng-model=\"itm.Option\" layout=\"column\"><md-radio-button ng-value=\"0\">{{\'PAPERWORK_CONFIG.GREATER_THAN\' | translate}}</md-radio-button><md-radio-button ng-value=\"1\">{{\'PAPERWORK_CONFIG.GREATER_THAN_OR_EQUAL_TO\' | translate}}</md-radio-button></md-radio-group></md-input-container></div><span flex=\"5\"></span><div flex=\"20\" flex-sm=\"100\" flex-xs=\"100\"><md-input-container class=\"md-block\" style=\"padding :0px; margin:0px; position : relative; top:-10px; left:20px;\"><input ng-required=\"itm.Option != null\" min=\"0\" type=\"number\" ng-model=\"itm.Value\"></md-input-container></div></div></div>");
$templateCache.put("app/main/paperworkExceptions/directives/mainView/main-container.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.isBusy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"ml-15 text-bold\" ng-if=\"!vm.isBusy\">{{\'PAPERWORK_EXCEPTION.SHOWING\' | translate}} {{vm.getReportsLength()}} {{\'PAPERWORK_EXCEPTION.REPORTS\' | translate}}</div><div class=\"text-bold\" layout=\"row\" ng-if=\"vm.isBusy\"><md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span class=\"margin-left-10\">{{vm.loaderMessage}}</span></div><div layout=\"row\" layout-align=\"end center\" flex=\"\"><md-button ng-click=\"vm.save()\" ng-if=\"vm.activateSave() && !vm.isBusy\" class=\"md-warn md-raised\" translate=\"PAPERWORK_EXCEPTION.SAVE\"><md-tooltip><span translate=\"PAPERWORK_EXCEPTION.SAVE\"></span></md-tooltip></md-button><md-button class=\"md-icon-button action-button\" ng-if=\"vm.getReportsLength() > 0 && !vm.isBusy\"><i ng-click=\"vm.refresh()\" class=\"icon-refresh cyan-900-fg\" style=\"cursor : pointer;\"><md-tooltip><span translate=\"PAPERWORK_EXCEPTION.REFRESH\"></span></md-tooltip></i></md-button></div></div><div class=\"toolbar md-accent text-bold\" ng-if=\"vm.getReportsLength() > 0 && !vm.isBusy\" layout=\"row\" layout-align=\"space-between center\"><div ng-if=\"!vm.isBusy\"><md-input-container class=\"md-accent\"><label translate=\"PAPERWORK_EXCEPTION.REPORT_TYPES_FILTER\"></label><md-select ng-model=\"vm.report_filter\" ng-change=\"vm.filterReportsInClientSide()\" md-selected-text=\"vm.limit(vm.report_filter, \'PAPERWORK_EXCEPTION.REPORT_TYPES_FILTER\')\" multiple=\"\"><md-option ng-value=\"type\" ng-repeat=\"type in vm.service.report_types\">{{type.Value}}</md-option></md-select></md-input-container></div></div><md-progress-linear ng-if=\"vm.isBusy\" md-mode=\"query\" class=\"md-accent\"></md-progress-linear><div id=\"job-message-wrapper\" class=\"content-wrapper\" layout=\"column\" flex=\"\"><md-content ng-if=\"vm.gridData.length > 0\" class=\"content\" flex=\"\" ms-scroll=\"\" md-scroll=\"\"><paper-work-grid-container loader-message=\"vm.loaderMessage\" is-busy=\"vm.isBusy\" refresh=\"vm.refresh()\" handlecheckbox=\"vm.handle(params)\" grid-data=\"vm.gridData\"></paper-work-grid-container></md-content></div>");
$templateCache.put("app/main/paperwork/manage-paperwork/download/download-paperwork.html","<md-dialog id=\"download-paperwork\" aria-label=\"Send Bulk Paperwork\" flex=\"20\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"PAPERWORK.EMAILSENDER.SEND_BULK_PAPERWORK_TITLE\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"zipForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"column\" ng-if=\"!vm.downloadInProgress\"><md-input-container class=\"md-block\" flex=\"\"><label translate=\"PAPERWORK.EMAILSENDER.EMAIL\"></label> <input type=\"email\" name=\"email\" ng-model=\"vm.email\" step=\"1\" required=\"\"><div ng-messages=\"zipForm.email.$error\" ng-show=\"zipForm.email.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAPERWORK.EMAILSENDER.EMAIL_FIELD_IS_REQUIRED\"></span></div><div ng-message=\"email\"><span translate=\"PAPERWORK.EMAILSENDER.NOT_A_VALID_EMAIL\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label translate=\"PAPERWORK.EMAILSENDER.ZIP_FILE_SIZE\"></label> <input type=\"number\" name=\"zipSize\" ng-model=\"vm.zipSize\" step=\"1\" min=\"1\" max=\"20\" required=\"\"><div ng-messages=\"zipForm.zipSize.$error\" ng-show=\"zipForm.zipSize.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAPERWORK.EMAILSENDER.ZIP_SIZE_FIELD_IS_REQUIRED\"></span></div><div ng-message=\"number\"><span translate=\"PAPERWORK.EMAILSENDER.NOT_A_VALID_NUMBER\"></span></div><div ng-message=\"min\"><span translate=\"PAPERWORK.EMAILSENDER.MINIMUM_FILE_SIZE\"></span></div><div ng-message=\"max\"><span translate=\"PAPERWORK.EMAILSENDER.MAXIMUM_FILE_SIZE\"></span></div></div></md-input-container></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.downloadInProgress\"><span class=\"bold-text\" translate=\"PAPERWORK.EMAILSENDER.PREPARING_FILES\"></span><br><div class=\"center\">{{\'PAPERWORK.EMAILSENDER.EMAIL_INFO_1\' | translate}}</div><div class=\"center\">{{vm.email}}</div><div class=\"center\">{{\'PAPERWORK.EMAILSENDER.EMAIL_INFO_2\' | translate}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"vm.sendEmail()\" ng-disabled=\"zipForm.$invalid\" ng-if=\"!vm.downloadInProgress\">{{\'PAPERWORK.EMAILSENDER.SEND_EMAIL\' | translate}}</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.close()\" ng-if=\"vm.downloadInProgress\">{{\'PAPERWORK.EMAILSENDER.CLOSE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payrollSettings/directives/addCompensationRates/add-compensation-rates.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE_BRANCH_ADD\' | translate}}</h2><h2 ng-if=\"vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE_BRANCH_EDIT\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"layout-gt-sm-row layout-row\" ng-if=\"vm.hasError\">{{ vm.errorMessage }}</div><form name=\"addCompensationRatesByBranchForm\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container flex=\"100\" ng-if=\"!vm.isEdit()\"><label>{{\'SKILLS.DIRECTIVE_BRANCH(ES)\' | translate}}</label><md-select ng-model=\"vm.branchCompensation\" multiple=\"\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchesLookUp\" required=\"\">{{branch.Name}}</md-option></md-select></md-input-container><div ng-if=\"vm.isEdit()\">{{ vm.branchName }}</div></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_YEAR\' | translate}}</label> <input name=\"compensationRatesYear\" ng-model=\"vm.branchCompensationYear\" ng-pattern=\"/^[0-9]*$/\" ng-readonly=\"vm.isEdit()\" required=\"\"><div ng-messages=\"addCompensationRatesByBranchForm.compensationRatesYear.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"pattern\">Invalid Year</div></div></md-input-container></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_COMPENSATION_RATE\' | translate}}</label> <input name=\"compensationRates\" ng-model=\"vm.branchCompensationRate\" ng-pattern=\"/^[0-9]+(\\.[0-9]+)?$/\" required=\"\"><div ng-messages=\"addCompensationRatesByBranchForm.compensationRates.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"pattern\">Invalid Compensation Rate</div></div></md-input-container></div></div><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.addCompensationRatesByBranch()\" ng-disabled=\"addCompensationRatesByBranchForm.compensationRatesYear.$invalid || addCompensationRatesByBranchForm.compensationRates.$invalid\"><span ng-if=\"vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</span> <span ng-if=\"!vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ADD_BUTTON\' | translate}}</span></md-button></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/payrollSettings/directives/addTimesheetHeadings/add-timesheet-headings.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TIMESHEET_HEADINGS_ADD\' | translate}}</h2><h2 ng-if=\"vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TIMESHEET_HEADINGS_EDIT\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"layout-gt-sm-row layout-row\" ng-if=\"vm.hasError\">{{ vm.errorMessage }}</div><form name=\"addTimesheetHeadingsForm\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\" ng-if=\"!vm.isEdit()\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_NAME\' | translate}}</label> <input name=\"timesheetHeading\" ng-model=\"vm.timesheetHeading\" ng-readonly=\"vm.isEdit()\" required=\"\"><div ng-messages=\"addTimesheetHeadingsForm.timesheetHeading.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container><div ng-if=\"vm.isEdit()\">{{ vm.timesheetHeading }}</div></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_CODES\' | translate}}</label> <textarea name=\"timesheetCodes\" ng-model=\"vm.timesheetCodes\" max-rows=\"5\" required=\"\">\r\n                        </textarea><div ng-messages=\"addTimesheetHeadingsForm.timesheetCodes.$error\" ng-show=\"addTimesheetHeadingsForm.timesheetCodes.$dirty\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container flex=\"100\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_DISPLAY_ORDER\' | translate}}</label> <input name=\"timesheetDisplayOrder\" ng-model=\"vm.timesheetDisplayOrder\" type=\"number\" required=\"\"><div ng-messages=\"addTimesheetHeadingsForm.timesheetDisplayOrder.$error\" ng-show=\"addTimesheetHeadingsForm.timesheetDisplayOrder.$dirty\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div></div><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.addTimesheetHeadings()\" ng-disabled=\"addTimesheetHeadingsForm.timesheetCodes.$invalid || addTimesheetHeadingsForm.timesheetDisplayOrder.$invalid || addTimesheetHeadingsForm.timesheetHeading.$invalid\"><span ng-if=\"vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</span> <span ng-if=\"!vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ADD_BUTTON\' | translate}}</span></md-button></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/payrollSettings/directives/addSuperannuationRates/add-superannuation-rates.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE_BRANCH_ADD\' | translate}}</h2><h2 ng-if=\"vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE_BRANCH_EDIT\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"layout-gt-sm-row layout-row\" ng-if=\"vm.hasError\">{{ vm.errorMessage }}</div><form name=\"addSuperAnnuationRatesByBranchForm\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container flex=\"100\" ng-if=\"!vm.isEdit()\"><label>{{\'SKILLS.DIRECTIVE_BRANCH(ES)\' | translate}}</label><md-select ng-model=\"vm.branchSuperannuation\" multiple=\"\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchesLookUp\" required=\"\">{{branch.Name}}</md-option></md-select></md-input-container><div ng-if=\"vm.isEdit()\">{{ vm.branchName }}</div></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_YEAR\' | translate}}</label> <input name=\"superannuationRatesYear\" ng-model=\"vm.branchSuperannuationYear\" ng-pattern=\"/^[0-9]*$/\" ng-readonly=\"vm.isEdit()\" required=\"\"><div ng-messages=\"addSuperAnnuationRatesByBranchForm.superannuationRatesYear.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"pattern\">Invalid Year</div></div></md-input-container></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SUPERANNUATION_RATE\' | translate}}</label> <input name=\"superannuationRates\" ng-model=\"vm.branchSuperannuationRate\" ng-pattern=\"/^[0-9]+(\\.[0-9]+)?$/\" required=\"\"><div ng-messages=\"addSuperAnnuationRatesByBranchForm.superannuationRates.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"pattern\">Invalid Compensation Rate</div></div></md-input-container></div></div><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.addSuperannuationRatesByBranch()\" ng-disabled=\"addSuperAnnuationRatesByBranchForm.superannuationRatesYear.$invalid || addSuperAnnuationRatesByBranchForm.superannuationRates.$invalid\"><span ng-if=\"vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</span> <span ng-if=\"!vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ADD_BUTTON\' | translate}}</span></md-button></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/payrollSettings/directives/addTaxRates/add-tax-rates.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_RATE_BRANCH_ADD\' | translate}}</h2><h2 ng-if=\"vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_TAX_RATE_BRANCH_EDIT\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"layout-gt-sm-row layout-row\" ng-if=\"vm.hasError\">{{ vm.errorMessage }}</div><form name=\"addTaxRatesByBranchForm\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container flex=\"100\" ng-if=\"!vm.isEdit()\"><label>{{\'SKILLS.DIRECTIVE_BRANCH(ES)\' | translate}}</label><md-select ng-model=\"vm.branchTax\" multiple=\"\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchesLookUp\" required=\"\">{{branch.Name}}</md-option></md-select></md-input-container><div ng-if=\"vm.isEdit()\">{{ vm.branchName }}</div></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_YEAR\' | translate}}</label> <input name=\"taxRatesYear\" ng-model=\"vm.branchTaxYear\" ng-pattern=\"/^[0-9]*$/\" ng-readonly=\"vm.isEdit()\" required=\"\"><div ng-messages=\"addTaxRatesByBranchForm.taxRatesYear.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"pattern\">Invalid Year</div></div></md-input-container></div><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label>{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_RATE\' | translate}}</label> <input name=\"taxRates\" ng-model=\"vm.branchTaxRate\" ng-pattern=\"/^[0-9]+(\\.[0-9]+)?$/\" required=\"\"><div ng-messages=\"addTaxRatesByBranchForm.taxRates.$error\"><div ng-message=\"required\">This is required!</div><div ng-message=\"pattern\">Invalid Tax Rate</div></div></md-input-container></div></div><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.addTaxRatesByBranch()\" ng-disabled=\"addTaxRatesByBranchForm.taxRatesYear.$invalid || addTaxRatesByBranchForm.taxRates.$invalid\"><span ng-if=\"vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_SAVE_BUTTON\' | translate}}</span> <span ng-if=\"!vm.isEdit()\">{{\'PAYROLL_SETTINGS.MAIN_VIEW_MANAGE_PAYROLL_ADD_BUTTON\' | translate}}</span></md-button></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/projects/create/skills/project-skills.dialog.html","<md-dialog flex=\"25\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"100\" ng-cloak=\"\"><form name=\"skillform\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"PROJECTS_CREATE.ADD_SKILL\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-select ng-model=\"vm.skill_model\" required=\"\"><md-option ng-repeat=\"skill in vm.look_up\" ng-value=\"skill\">{{skill.Name}}</md-option></md-select></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"skillform.$invalid\" translate=\"PROJECTS_CREATE.SAVE\" ng-click=\"vm.onDone()\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/projects/create/skills/project-skills.html","<div flex=\"50\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><p class=\"md-subhead\" flex=\"100\" translate=\"PROJECTS_CREATE.SKILLS\"></p><div layout=\"column\" ng-if=\"vm.has_access\" flex=\"100\"><a href=\"#\" ng-click=\"vm.add()\" translate=\"PROJECTS_CREATE.ADD_SKILL\"></a></div><br><md-card style=\"margin-left : -3px;\"><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\"><thead><tr><th translate=\"PROJECTS_CREATE.SKILL\"></th><th ng-if=\"vm.has_access\" translate=\"PROJECTS_CREATE.ACTIONS\"></th></tr></thead><tbody><tr ng-repeat=\"skill in vm.ngModel | orderBy : \'Name\'\"><td>{{skill.Name}}</td><td ng-if=\"vm.has_access\"><delete-component index=\"skill\" tool-tip=\"{{\'PROJECTS_CREATE.REMOVE\' | translate}}\" message=\"{{\'PROJECTS_CREATE.REMOVE_QUESTION\' | translate}}\" callback=\"vm.remove\" section=\"{{\'PROJECTS_CREATE.SKILL\' | translate}}\"></delete-component></td></tr></tbody></table></md-card-content></md-card><br></div>");
$templateCache.put("app/main/rateCardSettings/directives/addPackageGroup/_add-package-item.html","<md-dialog flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\" flex=\"\"><h2>{{\'RATECARD_V2.MAIN_PACKAGES_FORM_ADD_ITEM\' | translate}}</h2><md-button class=\"md-icon-button pull-right\" ng-click=\"packageItemController.closePricingModal()\"><md-icon class=\"pull-right\" md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\" ng-click=\"packageItemController.closePricingModal()\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-0\"><div class=\"layout-gt-sm-row layout-row\" ng-if=\"vm.hasError\">{{ vm.errorMessage }}</div><div class=\"form-wrapper flex-100 add-package-group\"><form name=\"addPackageItemForm\"><div class=\"form-wrapper flex-100\"><div layout=\"row\" layout-wrap=\"\"><div layout=\"row\" flex=\"100\" layout-wrap=\"\"><label flex=\"100\" class=\"md-body-2\">{{\'RATECARD_V2.MAIN_PACKAGES_FORM_INVOICE_GROUP_NAME\' | translate}}</label><md-input-container flex=\"100\" class=\"mt-0 mb-20\" required=\"\"><md-select name=\"invoiceGroup\" ng-model=\"packageItemController.packageItem.formData.InvoiceGroupName\" required=\"\"><md-option ng-value=\"lookup\" ng-repeat=\"lookup in packageItemController.invoiceGroupsLookup\" required=\"\">{{ lookup }}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"100\" layout-wrap=\"\"><md-input-container flex=\"nogrow\" class=\"mx-20\"><input name=\"invoiceGroupQuantity\" type=\"number\" ng-model=\"packageItemController.packageItem.formData.Quantity\" placeholder=\"{{\'RATECARD_V2.MAIN_PACKAGES_FORM_QTY\' | translate}}\" min=\"1\" ng-pattern=\"/^[0-9]*$/\" required=\"\"><div ng-messages=\"addPackageGroupForm.packageGroupName.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"row\" flex=\"100\" layout-wrap=\"\"><md-dialog-actions flex=\"100\"><md-button class=\"md-raised md-body-2\" ng-click=\"packageItemController.closePricingModal()\">{{\'RATECARD_V2.MAIN_CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"packageItemController.addPricingItem()\" ng-disabled=\"addPackageItemForm.$invalid\">{{\'RATECARD_V2.MAIN_OK\' | translate}}</md-button></md-dialog-actions></div></div></div></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/rateCardSettings/directives/addPackageGroup/addPackageGroupComponent.directive.html","<div class=\"form-wrapper flex-100 add-package-group mt-10\"><form name=\"addPackageGroupForm\"><div class=\"form-wrapper flex-100 package-items-header\"><div layout=\"row\" layout-wrap=\"\"><label flex=\"90\" class=\"mt-0 mb-0\">{{\'RATECARD_V2.MAIN_PACKAGES_PACKAGE_GROUP_LABEL\' | translate}} {{ addPackageGroup.counter + 1 }}</label><md-input-container flex=\"10\" class=\"mt-0 mb-5\"><i ng-click=\"addPackageGroup.launchAddPackageItem()\" class=\"material-icons\">add_circle</i> <i class=\"material-icons\" ng-click=\"addPackageGroup.removePackageGroup(addPackageGroup.counter)\">delete</i></md-input-container></div></div><div class=\"form-wrapper flex-100 package-items-wrap mt-0 p-0\"><div layout=\"row\" layout-wrap=\"\"><div ng-repeat=\"group in addPackageGroup.datasrc[addPackageGroup.counter] track by $index\" flex=\"30\" class=\"package-item p-10 m-20\"><div layout=\"row\" layout-wrap=\"\"><md-input-container flex=\"\" class=\"mt-0 mb-5 package-items-btn\"><i ng-click=\"addPackageGroup.launchAddPackageItem(true, $index)\" class=\"material-icons\">add_circle</i> <i class=\"material-icons\" ng-click=\"addPackageGroup.removePackageGroup(addPackageGroup.counter, $index)\">delete</i></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-repeat=\"item in group.PackageItems\"><div class=\"item-remove-icon\" flex=\"10\"><i class=\"material-icons\" ng-click=\"addPackageGroup.removePackageItem(addPackageGroup.counter, $parent.$index, $index)\">remove_circle_outline</i></div><div class=\"item-name\" flex=\"70\">{{ item.InvoiceGroupName }}</div><div flex=\"20\"><md-input-container class=\"mx-20\"><input name=\"itemQuantity\" class=\"item-quantity\" type=\"number\" ng-model=\"addPackageGroup.datasrc[addPackageGroup.counter][$parent.$index].PackageItems[$index].Quantity\" ng-change=\"addPackageGroup.updateQuantity(addPackageGroup.counter)\" min=\"1\" ng-value=\"item.Quantity\" ng-pattern=\"/^[0-9]*$/\" required=\"\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-checkbox flex=\"auto\" class=\"md-raised md-accent pull-left mt-0 mb-20\" ng-change=\"addPackageGroup.updateInvoiceSeparatelyAlso(addPackageGroup.counter)\" ng-model=\"addPackageGroup.datasrc[addPackageGroup.counter][$parent.$index].PackageItems[$index].InvoiceSeparatelyAlso\"><label>{{\'RATECARD_V2.MAIN_PACKAGES_INVOICE_LINE_ITEM_LABEL\' | translate}}</label></md-checkbox></div></div></div></div></div></form></div>");
$templateCache.put("app/main/reporting/view/HeadingsComponent/headings.html","<div layout-gt-md=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-xs=\"column\" style=\"min-height: 200px;\"><ms-widget flippable=\"false\" flex-xl=\"20\" flex-lg=\"33\" flex-md=\"33\" flex-sm=\"33\" flex-xs=\"100\" ng-repeat=\"(key,value) in vm.ngService.selectedReportJob.ReportData.Headings\" ng-if=\"vm.ngService.selectedReportJob.ReportData != null\"><ms-widget-front class=\"padding-16 md-white-bg\" ng-repeat=\"(prop,val) in value\"><div ng-if=\"prop != \'headingColor\'\" class=\"pt-8 ng-scope layout-align-center-center layout-column\" layout=\"column\" layout-align=\"center center\"><div class=\"h3 secondary-text font-weight-500 ng-binding\">{{prop | uppercase}}</div><div class=\"font-size-32 line-height-32 wrap-text ng-binding {{value.headingColor}}\">{{val}}</div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/reporting/view/ReportViewerComponent/report_viewer.html","<div class=\"ms-responsive-table-wrapper\"><table ms-responsive-table=\"\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" ng-cloak=\"\" ng-if=\"vm.ngService.selectedReportJob.ReportData != null\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\" ng-repeat=\"header in vm.ngService.selectedReportJob.ReportData.Headers\"><div class=\"table-header\"><span class=\"column-title\">{{header[\"DisplayName\"]}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"data in vm.ngService.selectedReportJob.ReportData.Rows\"><td ng-repeat=\"model in vm.ngService.selectedReportJob.ReportData.Headers\">{{data[model[\"ModelName\"]]}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/rateCardSettings/surcharges/addSurcharge/addSurcharge.html","<md-dialog class=\"add-surcharge-dialog\" aria-label=\"{{\'RATECARD_V2.SURCHARGES.ADD_TITLE\' | translate}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{(addSurcharge.isEdit ? \'RATECARD_V2.SURCHARGES.EDIT_TITLE\' : \'RATECARD_V2.SURCHARGES.ADD_TITLE\') | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"addSurcharge.cancel()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><form name=\"surchargeForm\" novalidate=\"\"><div layout=\"row\" layout-wrap=\"\"><md-input-container flex-gt-sm=\"50\" flex=\"100\"><label>{{\'RATECARD_V2.SURCHARGES.NAME_LABEL\' | translate}}</label> <input ng-model=\"addSurcharge.formData.Name\" maxlength=\"100\" required=\"\"><div class=\"md-input-error\" ng-show=\"addSurcharge.errors.Name\">{{addSurcharge.errors.Name}}</div></md-input-container><md-input-container flex-gt-sm=\"50\" flex=\"100\"><label>{{\'RATECARD_V2.SURCHARGES.EFFECTIVE_DATE_LABEL\' | translate}}</label><md-datepicker ng-model=\"addSurcharge.formData.EffectiveDate\" md-placeholder=\"dd/mm/yyyy\" required=\"\"></md-datepicker><div class=\"md-input-error\" ng-show=\"addSurcharge.errors.EffectiveDate\">{{addSurcharge.errors.EffectiveDate}}</div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"start center\"><md-input-container flex-gt-sm=\"50\" flex=\"100\"><label>{{\'RATECARD_V2.SURCHARGES.METHOD_LABEL\' | translate}}</label><md-select ng-model=\"addSurcharge.formData.CalculationMethod\" ng-change=\"addSurcharge.onMethodChange()\" required=\"\"><md-option ng-value=\"addSurcharge.calculationMethods.PercentageInvoice\">{{\'RATECARD_V2.SURCHARGES.METHOD_PERCENTAGE_INVOICE\' | translate}}</md-option><md-option ng-value=\"addSurcharge.calculationMethods.PercentageVehicle\">{{\'RATECARD_V2.SURCHARGES.METHOD_PERCENTAGE_VEHICLE\' | translate}}</md-option><md-option ng-value=\"addSurcharge.calculationMethods.FixedVehicle\">{{\'RATECARD_V2.SURCHARGES.METHOD_FIXED_VEHICLE\' | translate}}</md-option></md-select></md-input-container><div flex-gt-sm=\"50\" flex=\"100\" layout=\"row\" layout-align=\"start center\" class=\"surcharge-active-row\"><md-checkbox ng-model=\"addSurcharge.formData.IsActive\">{{\'RATECARD_V2.SURCHARGES.ACTIVE_LABEL\' | translate}}</md-checkbox></div></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"addSurcharge.showRateInput()\"><md-input-container flex-gt-sm=\"50\" flex=\"100\"><label>{{\'RATECARD_V2.SURCHARGES.RATE_LABEL\' | translate}}</label> <input type=\"number\" min=\"0.01\" max=\"100\" step=\"0.01\" ng-model=\"addSurcharge.formData.RatePercentage\" required=\"\"><div class=\"md-input-error\" ng-show=\"addSurcharge.errors.RatePercentage\">{{addSurcharge.errors.RatePercentage}}</div></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"!addSurcharge.showRateInput()\" class=\"surcharge-fixed-vehicle-hint\"><p class=\"md-caption\" flex=\"\">{{\'RATECARD_V2.SURCHARGES.FIXED_VEHICLE_HINT\' | translate}}</p></div><div ng-if=\"addSurcharge.showIncludeAllowances()\" layout=\"row\" layout-wrap=\"\" class=\"surcharge-base-inclusions\"><md-checkbox ng-model=\"addSurcharge.formData.IncludeAllowances\">{{\'RATECARD_V2.SURCHARGES.INCLUDE_ALLOWANCES_LABEL\' | translate}}</md-checkbox><md-checkbox ng-model=\"addSurcharge.formData.IncludeEstablishmentFee\">{{\'RATECARD_V2.SURCHARGES.INCLUDE_ESTABLISHMENT_FEE_LABEL\' | translate}}</md-checkbox></div><div ng-if=\"addSurcharge.showShiftTypeSelector()\" class=\"surcharges-shift-section\" layout=\"column\"><label class=\"md-body-2 surcharges-shift-label\">{{\'RATECARD_V2.SURCHARGES.INCLUDED_SHIFTS_LABEL\' | translate}} *</label><md-input-container md-no-float=\"\" class=\"surcharges-shift-search\"><md-icon md-font-icon=\"icon-magnify\" class=\"surcharges-shift-search-icon\"></md-icon><input type=\"text\" ng-model=\"addSurcharge.shiftSearch\" placeholder=\"{{\'RATECARD_V2.SURCHARGES.SHIFT_SEARCH_PLACEHOLDER\' | translate}}\"></md-input-container><div class=\"surcharges-shift-list\" md-whiteframe=\"1\"><div ng-if=\"!addSurcharge.shiftSearch\"><div class=\"surcharges-shift-row surcharges-shift-orphan\" ng-repeat=\"orphanId in addSurcharge.getOrphanedShiftIds() track by orphanId\"><md-icon md-font-icon=\"icon-alert\" class=\"surcharges-shift-orphan-icon\"></md-icon><span class=\"surcharges-shift-orphan-label\">{{\'RATECARD_V2.SURCHARGES.SHIFT_ORPHANED\' | translate}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"addSurcharge.removeOrphanedShift(orphanId)\" aria-label=\"{{\'RATECARD_V2.SURCHARGES.SHIFT_ORPHAN_REMOVE_ARIA\' | translate}}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div><div class=\"surcharges-shift-row surcharges-shift-all\"><md-checkbox ng-checked=\"addSurcharge.isAllMode()\" md-indeterminate=\"addSurcharge.isPartialSelection()\" ng-click=\"addSurcharge.toggleAllMode()\">{{\'RATECARD_V2.SURCHARGES.SHIFT_ALL\' | translate}}</md-checkbox></div><div class=\"surcharges-shift-row\" ng-repeat=\"shift in addSurcharge.shiftTypes | filter:{ Name: addSurcharge.shiftSearch } track by shift.Id\"><md-checkbox ng-checked=\"addSurcharge.isShiftChecked(shift.Id)\" ng-click=\"addSurcharge.toggleShiftType(shift.Id)\">{{shift.Name}}</md-checkbox></div><p ng-if=\"!addSurcharge.shiftTypes.length && !addSurcharge.shiftTypesLoading\" class=\"md-caption surcharges-shift-empty\">{{\'RATECARD_V2.SURCHARGES.NO_SHIFT_TYPES\' | translate}}</p></div><p class=\"md-caption surcharges-shift-helper\" ng-if=\"addSurcharge.isAllMode()\">{{\'RATECARD_V2.SURCHARGES.SHIFT_ALL_HELPER_TEXT\' | translate}}</p><p class=\"md-caption surcharges-shift-helper\" ng-if=\"addSurcharge.isPartialSelection() === false && !addSurcharge.isAllMode()\">{{\'RATECARD_V2.SURCHARGES.SHIFT_SPECIFIC_HELPER_TEXT\' | translate}}</p><div class=\"md-input-error surcharges-shift-error\" ng-show=\"addSurcharge.errors.IncludedShiftTypeIds\">{{addSurcharge.errors.IncludedShiftTypeIds}}</div></div><div ng-if=\"addSurcharge.showVehicleTypeSelector()\" class=\"surcharges-shift-section\" layout=\"column\"><label class=\"md-body-2 surcharges-shift-label\">{{\'RATECARD_V2.SURCHARGES.INCLUDED_VEHICLES_LABEL\' | translate}} *</label><md-input-container md-no-float=\"\" class=\"surcharges-shift-search\"><md-icon md-font-icon=\"icon-magnify\" class=\"surcharges-shift-search-icon\"></md-icon><input type=\"text\" ng-model=\"addSurcharge.vehicleSearch\" placeholder=\"{{\'RATECARD_V2.SURCHARGES.VEHICLE_SEARCH_PLACEHOLDER\' | translate}}\"></md-input-container><div class=\"surcharges-shift-list\" md-whiteframe=\"1\"><div ng-if=\"!addSurcharge.vehicleSearch\"><div class=\"surcharges-shift-row surcharges-shift-orphan\" ng-repeat=\"orphanId in addSurcharge.getOrphanedVehicleIds() track by orphanId\"><md-icon md-font-icon=\"icon-alert\" class=\"surcharges-shift-orphan-icon\"></md-icon><span class=\"surcharges-shift-orphan-label\">{{\'RATECARD_V2.SURCHARGES.VEHICLE_ORPHANED\' | translate}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"addSurcharge.removeOrphanedVehicle(orphanId)\" aria-label=\"{{\'RATECARD_V2.SURCHARGES.VEHICLE_ORPHAN_REMOVE_ARIA\' | translate}}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div><div class=\"surcharges-shift-row surcharges-shift-all\"><md-checkbox ng-checked=\"addSurcharge.isAllVehicleMode()\" md-indeterminate=\"addSurcharge.isPartialVehicleSelection()\" ng-click=\"addSurcharge.toggleAllVehicleMode()\">{{\'RATECARD_V2.SURCHARGES.VEHICLE_ALL\' | translate}}</md-checkbox></div><div class=\"surcharges-shift-row\" ng-repeat=\"vehicle in addSurcharge.vehicleTypes | filter:{ Name: addSurcharge.vehicleSearch } track by vehicle.Id\"><md-checkbox ng-checked=\"addSurcharge.isVehicleChecked(vehicle.Id)\" ng-click=\"addSurcharge.toggleVehicleType(vehicle.Id)\">{{vehicle.Name}}</md-checkbox></div><p ng-if=\"!addSurcharge.vehicleTypes.length && !addSurcharge.vehicleTypesLoading\" class=\"md-caption surcharges-shift-empty\">{{\'RATECARD_V2.SURCHARGES.NO_VEHICLE_TYPES\' | translate}}</p></div><p class=\"md-caption surcharges-shift-helper\" ng-if=\"addSurcharge.isAllVehicleMode()\">{{\'RATECARD_V2.SURCHARGES.VEHICLE_ALL_HELPER_TEXT\' | translate}}</p><p class=\"md-caption surcharges-shift-helper\" ng-if=\"addSurcharge.isPartialVehicleSelection() === false && !addSurcharge.isAllVehicleMode()\">{{\'RATECARD_V2.SURCHARGES.VEHICLE_SPECIFIC_HELPER_TEXT\' | translate}}</p><div class=\"md-input-error surcharges-shift-error\" ng-show=\"addSurcharge.errors.IncludedVehicleTypeIds\">{{addSurcharge.errors.IncludedVehicleTypeIds}}</div></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-primary md-raised\" ng-click=\"addSurcharge.save()\">{{\'RATECARD_V2.SURCHARGES.SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/rateCardSettings/surcharges/historyLog/surcharge-history-log-data.html","<table class=\"surcharge-history-fields\" ng-if=\"vm.rows.length\"><thead><tr><th>Field</th><th ng-if=\"vm.hasPrevious\">Previous</th><th>New</th></tr></thead><tbody><tr ng-repeat=\"row in vm.rows track by $index\"><td class=\"surcharge-history-field-name\">{{row.FieldName}}</td><td ng-if=\"vm.hasPrevious\" class=\"surcharge-history-previous\">{{row.Previous}}</td><td>{{row.New}}</td></tr></tbody></table>");
$templateCache.put("app/main/rateCardSettings/packages/dialogs/package-dialog.html","<md-dialog id=\"package-dialog\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools bold-text\"><h4>{{\'RATECARD_V2.MAIN_PACKAGES_DIALOG_TITLE\' | translate}}</h4></div></md-toolbar><md-dialog-content><div class=\"bold-text\"><p><strong>{{\'RATECARD_V2.MAIN_PACKAGES_DIALOG_QUESTION\' | translate}}</strong></p><p>{{vm.packageGroupsMsg}}</p><p>{{\'RATECARD_V2.MAIN_PACKAGES_DIALOG_OPTION_NO\' | translate}}<br>{{\'RATECARD_V2.MAIN_PACKAGES_DIALOG_OPTION_YES\' | translate}}</p><p><span class=\"text-italic\">{{\'RATECARD_V2.MAIN_PACKAGES_DIALOG_NOTE\' | translate}}</span></p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"hasUserAccepted(false)\">{{\'RATECARD_V2.MAIN_PACKAGES_DIALOG_ANSWER_NO\' | translate}}</md-button><md-button class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" ng-click=\"hasUserAccepted(true)\">{{\'RATECARD_V2.MAIN_PACKAGES_DIALOG_ANSWER_YES\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/skillsmatrix/directive/addskill/add-skill.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form name=\"skill\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.Id ? \'SKILLS.DIRECTIVE_EDIT_SKILL\' : \'SKILLS.DIRECTIVE_ADD_SKILL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form><div layout=\"row\"><md-input-container flex=\"100\"><input type=\"text\" placeholder=\"{{\'SKILLS.DIRECTIVE_SKILL_NAME2\' | translate}}\" ng-model=\"vm.SkillName\" ng-enter=\"vm.onDone()\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'SKILLS.DIRECTIVE_PARENT_SKILL\' | translate}}</label><md-select ng-model=\"vm.ParentId\" ng-model-options=\"{trackBy: \'$value\'}\"><md-option ng-value=\"vm.null\"></md-option><md-option ng-value=\"skill.id\" ng-repeat=\"skill in vm.parentSkills\">{{skill.SkillName}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'SKILLS.DIRECTIVE_BRANCH(ES)\' | translate}}</label><md-select ng-model=\"vm.branches\" md-selected-text=\"vm.utilService.getSelectedText(vm.branches, vm.utilService.translate(\'SKILLS.DIRECTIVE_BRANCH(ES)\'), \'Name\')\" multiple=\"true\" ng-model-options=\"{trackBy: \'$value.Id\'}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchesLookUp\">{{branch.Name}}</md-option></md-select></md-input-container></div><br><div layout=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-xs=\"column\"><div flex=\"60\"><md-checkbox ng-model=\"vm.IsProtected\" aria-label=\"Protected Checkbox\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"md-align-top-left\">{{\'SKILLS.DIRECTIVE_PROTECTED\' | translate}}</md-checkbox></div><div flex=\"\"><md-checkbox ng-model=\"vm.ExpiryIsMandatory\" aria-label=\"Exipry Mandatory Checkbox\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"md-align-top-left\" flex=\"\">{{\'SKILLS.DIRECTIVE_EXPIRY_MANDATORY\' | translate}}</md-checkbox></div><div flex=\"\"><md-checkbox ng-model=\"vm.CompanyRequired\" aria-label=\"Company required\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"md-align-top-left\" flex=\"\">{{\'SKILLS.COMPANY_REQUIRED\' | translate}}</md-checkbox></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" style=\"margin-right:20px;\" ng-disabled=\"skill.$invalid\">{{\'SKILLS.DIRECTIVE_DONE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/skillsmatrix/directive/addskillgroup/add-skillgroup-button.html","<button ng-click=\"spawnCompanyDialog()\">{{\'SKILLS.DIRECTIVE_ADD_SKILL_GROUP\' | translate}}</button>");
$templateCache.put("app/main/skillsmatrix/directive/addskillgroup/add-skillgroup.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'SKILLS.DIRECTIVE_ADD_SKILL_REQUIREMENT\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" ng-form=\"skillGroup\"><md-input-container flex=\"100\"><input type=\"text\" placeholder=\"{{\'SKILLS.DIRECTIVE_SKILL_GROUP_NAME\' | translate}}\" ng-model=\"vm.title\" ng-enter=\"vm.onDone(vm.title)\" name=\"name\" required=\"\" md-autofocus=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onDone(vm.title)\" class=\"md-accent md-raised\" ng-disabled=\"skillGroup.$invalid\">{{\'SKILLS.DIRECTIVE_DONE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/training/directive/addtraining/add-training.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form name=\"training\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.Id ? \'TRAININGS.DIRECTIVE_EDIT_TRAINING\' : \'TRAININGS.DIRECTIVE_ADD_TRAINING\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form><div layout=\"row\"><md-input-container flex=\"100\"><input type=\"text\" placeholder=\"{{\'TRAININGS.DIRECTIVE_TRAINING_NAME2\' | translate}}\" ng-model=\"vm.TrainingName\" ng-enter=\"vm.onDone()\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'TRAININGS.DIRECTIVE_BRANCH(ES)\' | translate}}</label><md-select ng-model=\"vm.branches\" md-selected-text=\"vm.utilService.getSelectedText(vm.branches, vm.utilService.translate(\'TRAININGS.DIRECTIVE_BRANCH(ES)\'), \'Name\')\" multiple=\"true\" ng-model-options=\"{trackBy: \'$value.Id\'}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchesLookUp\">{{branch.Name}}</md-option></md-select></md-input-container></div><br><div layout=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-xs=\"column\"><div flex=\"\"><md-checkbox ng-model=\"vm.ExpiryIsMandatory\" aria-label=\"Exipry Mandatory Checkbox\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"md-align-top-left\" flex=\"\">{{\'TRAININGS.DIRECTIVE_EXPIRY_MANDATORY\' | translate}}</md-checkbox></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" style=\"margin-right:20px;\" ng-disabled=\"training.$invalid\">{{\'TRAININGS.DIRECTIVE_DONE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/tags/directives/addTags/add-tags.html","<md-dialog id=\"add-tag-dialog\" aria-label=\"Add Tag\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'TAGS.BUTTON_ADD_TAG_SMALL\' | translate}}</h2><span flex=\"\" class=\"flex\"></span><md-button class=\"md-icon-button text-right\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"addTagsForm\"><div class=\"form-wrapper flex-100\"><div class=\"layout-gt-sm-row layout-row\"><md-input-container layout=\"column\"><label>{{\'TAGS.LABEL_TAG_NAME\' | translate}}</label> <input name=\"tagName\" ng-model=\"vm.tagName\" maxlength=\"25\" required=\"\"><div ng-messages=\"addTagsForm.tagName.$error\"><div ng-message=\"required\">This is required!</div></div><div class=\"layout-gt-sm-row layout-row md-input-messages-animation\" ng-if=\"vm.hasError\">{{ vm.errorMessage }}</div></md-input-container></div></div><md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-body-2\" ng-click=\"vm.onCancel()\">{{\'TAGS.BUTTON_CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-accent md-body-2\" ng-click=\"vm.addTag()\" ng-disabled=\"addTagsForm.tagName.$invalid\">{{\'TAGS.BUTTON_ADD\' | translate}}</md-button></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/training/directive/addtraininggroup/add-traininggroup-button.html","<button ng-click=\"spawnCompanyDialog()\">{{\'TRAININGS.DIRECTIVE_ADD_TRAINING_GROUP\' | translate}}</button>");
$templateCache.put("app/main/training/directive/addtraininggroup/add-traininggroup.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'TRAININGS.DIRECTIVE_ADD_TRAINING_REQUIREMENT\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" ng-form=\"trainingGroup\"><md-input-container flex=\"100\"><input type=\"text\" placeholder=\"{{\'TRAININGS.DIRECTIVE_TRAINING_GROUP_NAME\' | translate}}\" ng-model=\"vm.title\" ng-enter=\"vm.onDone(vm.title)\" name=\"name\" required=\"\" md-autofocus=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onDone(vm.title)\" class=\"md-accent md-raised\" ng-disabled=\"trainingGroup.$invalid\">{{\'TRAININGS.DIRECTIVE_DONE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/training/directive/removetraining/remove-training.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'TRAININGS.DIRECTIVE_REMOVE_TRAINING\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>{{\'TRAININGS.DIRECTIVE_ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_TRAINING?\' | translate}}</md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onDone()\" class=\"md-raised md-accent md-body-2\">{{\'TRAININGS.DIRECTIVE_NO\' | translate}}</md-button><md-button ng-click=\"vm.onDone(true)\" class=\"md-raised md-accent md-body-2\">{{\'TRAININGS.DIRECTIVE_YES\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/vehicle/directive/addvehicle/add-vehicle.html","<md-dialog id=\"vehicle-create\" aria-label=\"Vehicle\" flex=\"25\" ng-cloak=\"\"><form name=\"vehicle\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"text-transform: capitalize;\">{{vm.Id ? \'VEHICLES.DIRECTIVE_EDIT_VEHICLE\' : \'VEHICLES.DIRECTIVE_ADD_VEHICLE\' | translate}} {{vm.variables.mode}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form><div layout=\"row\"><md-input-container flex=\"100\"><input type=\"text\" placeholder=\"{{\'VEHICLES.DIRECTIVE_VEHICLE_\' + vm.variables.mode.toUpperCase() | translate}}\" ng-model=\"vm.Value\" ng-enter=\"vm.onDone()\" required=\"\"></md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" style=\"margin-right:20px;\" ng-disabled=\"vehicle.$invalid\">{{\'VEHICLES.DIRECTIVE_DONE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/vehicle/directive/removevehicle/remove-vehicle.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"text-transform: capitalize;\">{{\'VEHICLES.DIRECTIVE_REMOVE_VEHICLE\' | translate}} {{vm.variables.mode}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>{{\'VEHICLES.DIRECTIVE_ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_VEHICLE_\' + vm.variables.mode.toUpperCase() + \'?\' | translate}}</md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onDone()\" class=\"md-raised md-accent md-body-2\">{{\'VEHICLES.DIRECTIVE_NO\' | translate}}</md-button><md-button ng-click=\"vm.onDone(true)\" class=\"md-raised md-accent md-body-2\">{{\'VEHICLES.DIRECTIVE_YES\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/skilllevel/view/dialog/add-skill-level-dialog.html","<md-dialog class=\"dashboard-manage\" id=\"skill-level-dialog\" flex=\"40\" ng-cloak=\"\"><form name=\"skilllevelform\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"SKILLSLEVEL.HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><processor-loader show=\"vm.isSaving\" message=\"vm.loaderMessage\"></processor-loader><div layout=\"column\" dimmer=\"\" ng-model=\"vm.isSaving\"><md-input-container><input type=\"text\" ng-model=\"vm.skill_name\" placeholder=\"{{\'SKILLSLEVEL.COLUMN_NAME\' | translate}}\" required=\"\"></md-input-container></div></md-dialog-content></form><md-dialog-actions dimmer=\"\" ng-model=\"vm.isSaving\"><md-button translate=\"SKILLSLEVEL.SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.save()\" ng-disabled=\"skilllevelform.$invalid\"></md-button><md-button translate=\"SKILLSLEVEL.CANCEL\" class=\"md-raised\" ng-click=\"vm.onClose()\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ratecards/manage/dialog/ratecard-manage-packages.html","<md-dialog id=\"ratecard-packages-dialog\" class=\"main-style\" aria-label=\"{{vm.caption}}\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'RATECARDS.PACKAGE_UPDATE_ORDER_TITLE\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"ratecardpackages\" novalidate=\"\"><div layout=\"row\"><md-input-container flex=\"\"><p>{{\'RATECARDS.PACKAGE_UPDATE_ORDER_MESSAGE\' | translate}}</p></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" class=\"mt-0 mb-20\"><ul dnd-list=\"vm.selectedPackagesOnReverseOrder\"><li ng-repeat=\"package in vm.selectedPackagesOnReverseOrder\" dnd-draggable=\"package\" dnd-moved=\"vm.onPackageMoved($index)\" dnd-effect-allowed=\"move\">{{package.Name}}</li></ul></md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button translate=\"RATECARDS.PACKAGE_UPDATE_ORDER\" ng-click=\"vm.onSave()\" class=\"md-raised md-accent\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/workForceParticipation/view/dialog/work-force-participation-dialog.html","<md-dialog class=\"dashboard-manage\" id=\"skill-level-dialog\" flex=\"40\" ng-cloak=\"\"><form name=\"form\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"WORKFORCE.HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><processor-loader show=\"vm.isSaving\" message=\"vm.loaderMessage\"></processor-loader><div layout=\"column\" dimmer=\"\" ng-model=\"vm.isSaving\"><md-input-container><input type=\"text\" ng-model=\"vm.name\" placeholder=\"{{\'WORKFORCE.COLUMN_NAME\' | translate}}\" required=\"\"></md-input-container></div></md-dialog-content></form><md-dialog-actions dimmer=\"\" ng-model=\"vm.isSaving\"><md-button translate=\"WORKFORCE.SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.save()\" ng-disabled=\"form.$invalid\"></md-button><md-button translate=\"WORKFORCE.CANCEL\" class=\"md-raised\" ng-click=\"vm.onClose()\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/assets/manage/kit/hirePrice/hire-price.html","<div layout=\"column\" class=\"margin-bottom-20\" ng-if=\"kitHirePriceVm.claimsUtilService.isBillingEnabled()\"><div layout=\"row\"><div class=\"form-wrapper2 md-whiteframe-1dp\" flex=\"\"><div ng-form=\"kitHirePriceForm\" class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>{{\'ASSETSMODULE.KIT_HIRE_PRICE_BASE_SALE_PRICE\' | translate}}</label> <input type=\"number\" name=\"baseSalePrice\" min=\"0\" ng-model=\"kitHirePriceVm.model.data.BaseSalePrice\" placeholder=\"0.00\" flex=\"30\" required=\"\"><div ng-messages=\"kitHirePriceForm.baseSalePrice.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.KIT_HIRE_PRICE_BASE_SALE_PRICE_IS_REQUIRED\"></span></div><div ng-message=\"number\"><span>{{\'ASSETSMODULE.KIT_HIRE_PRICE_NOT_A_VALID_NUMBER\' | translate}}</span></div><div ng-message=\"min\"><span>{{\'ASSETSMODULE.KIT_HIRE_PRICE_MINIMUM_BASE_SALE_PRICE_IS_0\' | translate}}</span></div></div></md-input-container></div><hire-rate-component ng-model=\"kitHirePriceVm.model.data.HireRateData\"></hire-rate-component></div></div></div></div>");
$templateCache.put("app/main/assets/manage/shift/view/shift-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"itemGridVm.addNew()\">{{ \'ASSETSMODULE.SHIFT_VIEW_ADD_NEW_SHIFT_TYPE\' | translate }}</md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{ \'ASSETSMODULE.SHIFT_VIEW_SEARCH\' | translate }}\" ng-model=\"itemGridVm.service.query1\" ng-keyup=\"itemGridVm.searchTable(1)\"></md-input-container></div></div><table class=\"dataTable row-border hover\" dt-instance=\"itemGridVm.dtInstance1\" style=\"margin-top :10px;\" datatable=\"ng\" dt-options=\"itemGridVm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ASSETSMODULE.SHIFT_VIEW_NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'ASSETSMODULE.SHIFT_VIEW_DESCRIPTION\' | translate }}</span></div></th><th class=\"secondary-text\"><span class=\"column-title\">{{ \'ASSETSMODULE.SHIFT_VIEW_ACTIONS\' | translate }}</span></th></tr></thead><tbody><tr ng-repeat=\"item in itemGridVm.service.shiftTypes\"><td>{{ item.ItemName }}</td><td>{{ item.Description }}</td><td><md-button class=\"md-icon-button\" ng-click=\"itemGridVm.onEdit(item.id)\"><i class=\"icon icon-pencil teal-500-fg s20\"></i><md-tooltip><span>{{ \'ASSETSMODULE.SHIFT_VIEW_EDIT_ITEM\' | translate }}</span></md-tooltip></md-button></td></tr></tbody></table></div><div class=\"spacer\"></div></div></div></div>");
$templateCache.put("app/main/assets/manage/item/basic/basic-create-item.html","<div layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div ng-form=\"basicInfoForm\" class=\"md-inline-form\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"itemName\" ng-model=\"basicInfoVm.model.data.ItemName\" placeholder=\"{{ (basicInfoVm.model.source == \'people\' ? \'ASSETSMODULE.ITEM_SHIFT_TYPE_NAME\' : \'ASSETSMODULE.ITEM_ITEM_NAME\') | translate}}\" required=\"\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"description\" ng-model=\"basicInfoVm.model.data.Description\" placeholder=\"{{\'ASSETSMODULE.VIEW_ITEM_COLUMN_ITEM_DESCRIPTION\' | translate}}\" md-maxlength=\"70\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container id=\"branches\"><label translate=\"ASSETSMODULE.ITEM_BRANCHES\"></label><md-select placeholder=\"Branch(es)\" md-selected-text=\"basicInfoVm.utilService.getSelectedText(basicInfoVm.model.data.Branches, \'Branch(es)\', \'Name\')\" multiple=\"\" name=\"Branches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"basicInfoVm.model.data.Branches\" ng-change=\"basicInfoVm.onBranchChange()\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch\" ng-repeat=\"branch in basicInfoVm.branches\" ng-selected=\"branch.Selected\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"\"><label></label></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-hide=\"basicInfoVm.model.source !== \'people\' || !basicInfoVm.claimsUtilService.isPayrollEnabled()\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.SHIFT_TYPE_AWARD\">Award</label><md-select name=\"awards\" ng-model=\"basicInfoVm.model.data.Award\" placeholder=\"{{\'ASSETSMODULE.SHIFT_TYPE_AWARD\' | translate}}\" ng-change=\"basicInfoVm.onAwardChange()\" ng-model-options=\"{ trackBy: \'$value.Id\'}\"><md-optgroup label=\"{{\'ASSETSMODULE.SHIFT_TYPE_AWARD_LIST\' | translate}}\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"award\" ng-repeat=\"award in basicInfoVm.awardsLookup | orderBy: \'Name\'\" ng-disabled=\"award.IsArchived\">{{award.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.SHIFT_TYPE_CLASSIFICATION\">Classification</label><md-select name=\"classifications\" ng-model=\"basicInfoVm.model.data.AwardClassification\" placeholder=\"{{\'ASSETSMODULE.SHIFT_TYPE_CLASSIFICATION\' | translate}}\" ng-required=\"basicInfoVm.model.data.Award !== null && basicInfoVm.model.data.Award !== undefined\" ng-model-options=\"{ trackBy: \'$value.Id\' }\"><md-optgroup label=\"{{\'ASSETSMODULE.SHIFT_TYPE_CLASSIFICATION_LIST\' | translate}}\"><md-option ng-value=\"classification\" ng-repeat=\"classification in basicInfoVm.awardClassificationsLookup\" ng-disabled=\"classification.isDisabled\">{{classification.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"basicInfoVm.model.source == \'people\' && basicInfoVm.claimsUtilService.isPayrollEnabled()\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.ITEM_ROLES\">Classification</label><md-select name=\"shiftRoles\" ng-model=\"basicInfoVm.model.data.ShiftRole\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'ASSETSMODULE.ITEM_ROLES\' | translate}}\" multiple=\"\"><md-optgroup label=\"{{\'ASSETSMODULE.ITEM_ROLES\' | translate}}\"><md-option ng-value=\"role\" ng-repeat=\"role in basicInfoVm.shiftRoles\">{{role.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container ng-if=\"basicInfoVm.claimsUtilService.isBillingEnabled()\"><input type=\"text\" name=\"InvoiceGroupName\" ng-model=\"basicInfoVm.model.data.InvoiceGroupName\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{\'ASSETSMODULE.ITEM_INVOICE_GROUP_NAME\' | translate}}\" required=\"\"><div ng-messages=\"basicInfoForm.InvoiceGroupName.$error\" role=\"alert\"><div ng-message=\"pattern\">{{\'ASSETSMODULE.ITEM_INVOICE_GROUP_NAME_ERROR_MESSAGE\' | translate}}</div></div></md-input-container></div><div layout=\"row\" ng-if=\"basicInfoVm.model.source == \'item\'\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.ITEM_TYPES\"></label><md-select name=\"itemType2\" required=\"\" placeholder=\"{{\'ASSETSMODULE.ITEM_TYPES\' | translate}}\" md-selected-text=\"basicInfoVm.utilService.getSelectedText(basicInfoVm.model.data.ItemTypes, \'Item Type(s)\', \'Name\')\" ng-model=\"basicInfoVm.model.data.ItemTypes\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-change=\"basicInfoVm.onItemTypeChange()\" ng-disabled=\"basicInfoVm.model.data.itemTypeDisabled\" multiple=\"true\"><md-option ng-value=\"item\" ng-repeat=\"item in basicInfoVm.itemTypes\">{{item.Name}}</md-option></md-select><div ng-messages=\"basicInfoForm.itemType2.$error\" role=\"alert\"><div ng-message=\"valid\">{{\'ASSETSMODULE.INVENTORY_MORE_THAN_ONE_ITEM_TYPE\' | translate}}</div></div></md-input-container><md-input-container flex=\"\" ng-if=\"basicInfoVm.claimsUtilService.isBillingEnabled()\"><label translate=\"ASSETSMODULE.ITEM_BILLING\"></label><md-select name=\"BillingPeriod\" ng-model=\"basicInfoVm.model.data.DefaultBillingPeriod\"><md-optgroup><md-option ng-value=\"item.Id\" ng-repeat=\"item in basicInfoVm.BillingPeriods\">{{item.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"basicInfoVm.model.source == \'item\'\" flex=\"\"><div layout=\"column\" flex=\"\"><md-checkbox aria-label=\"Requires Operator\" ng-model=\"basicInfoVm.model.data.RequiresOperator\" ng-change=\"basicInfoVm.onRequiresOperatorChange()\" class=\"md-primary\">{{\'ASSETSMODULE.REQUIRES_OPERATOR\' | translate}}</md-checkbox><md-checkbox aria-label=\"Requires Linked Items\" ng-model=\"basicInfoVm.model.data.RequireToBeLinked\" ng-change=\"basicInfoVm.onRequiresLinkedItemsChange()\" class=\"md-primary\" ng-if=\"basicInfoVm.claimsUtilService.isLinkedItemsEnabled()\">{{\'ASSETSMODULE.REQUIRES_LINKED_ITEMS\' | translate}}</md-checkbox></div><md-checkbox aria-label=\"Display Unique Item Id\" ng-model=\"basicInfoVm.model.data.DisplayUniqueId\" class=\"md-primary\" flex=\"\">{{\'ASSETSMODULE.UNIQUE_ID\' | translate}}</md-checkbox><md-checkbox aria-label=\"Allocatable\" ng-model=\"basicInfoVm.model.data.IsAllocatable\" class=\"md-primary\" flex=\"\">{{\'ASSETSMODULE.ALLOCATABLE\' | translate}}</md-checkbox></div><br><label ng-if=\"basicInfoVm.model.source == \'item\'\" translate=\"ASSETSMODULE.CATEGORIES\"></label><md-divider class=\"margin-top-5\" ng-if=\"basicInfoVm.model == \'item\'\"></md-divider><div id=\"categoryTree\" ng-if=\"basicInfoVm.model.source == \'item\'\" ivh-treeview=\"basicInfoVm.categoryModel.source\"><script type=\"text/ng-template\"><span ivh-treeview-toggle> <span ivh-treeview-twistie></span> </span> <a8-tree-md-box></a8-tree-md-box> <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle> {{trvw.label(node)}} </span> <div ivh-treeview-children></div></script></div></div></div></div></div>");
$templateCache.put("app/main/assets/manage/kit/kitview/kit-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" translate=\"ASSETSMODULE.VIEW_ADD_KIT\" ng-click=\"kitGridVm.addNew()\"></md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{\'ASSETSMODULE.VIEW_KIT_SEARCH\' | translate}}\" ng-model=\"kitGridVm.model.query\" ng-keyup=\"kitGridVm.searchTable()\"></md-input-container></div></div><table class=\"dataTable row-border hover\" datatable=\"ng\" ms-responsive-table=\"\" dt-instance=\"kitGridVm.dtInstance\" dt-options=\"kitGridVm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.VIEW_ITEM_COLUMN_KIT_NAME\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.VIEW_ITEM_COLUMN_KIT_DESCRIPTION\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.VIEW_ITEM_COLUMN_KIT_ITEMS\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.VIEW_ITEM_COLUMN_KIT_ACTIONS\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"kit in kitGridVm.gridModel\"><td>{{ kit.KitName }}</td><td>{{ kit.Description }}</td><td><ul class=\"kit-list\" ng-repeat=\"item in kit.Items\"><li>{{item}}</li></ul></td><td><md-icon md-font-icon=\"icon-pencil s20\" class=\"teal-500-fg\" ng-click=\"kitGridVm.onEdit(kit.id)\"><md-tooltip><span>Edit Kit Item</span></md-tooltip></md-icon><md-button ng-if=\"kitGridVm.canDeleteKit\" class=\"md-icon-button\" ng-click=\"kitGridVm.onRemove(kit.id, kit.KitName)\"><md-icon md-font-icon=\"icon-trash\" class=\"red-500-fg\"></md-icon><md-tooltip><span>Delete Item</span></md-tooltip></md-button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/assets/manage/item/costCode/cost-code.html","");
$templateCache.put("app/main/assets/manage/item/itemView/item-view.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"toolbar md-whiteframe-2dp\"><div class=\"toolbar-wrapper\"><md-button aria-label=\"sample\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"itemGridVm.addNew()\" translate=\"ASSETSMODULE.VIEW_ADD_ITEM\"></md-button></div></div><div class=\"content\" flex=\"\"><div class=\"white-bg md-whiteframe-4dp\" style=\"padding : 10px;\"><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{\'ASSETSMODULE.VIEW_ITEM_SEARCH\' | translate}}\" ng-model=\"itemGridVm.model.query\" ng-keyup=\"itemGridVm.searchTable()\"></md-input-container></div></div><table class=\"dataTable row-border hover\" ms-responsive-table=\"\" dt-instance=\"itemGridVm.dtInstance\" datatable=\"ng\" dt-options=\"itemGridVm.dtOptions\" dt-column-defs=\"itemGridVm.dtColumns\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.VIEW_ITEM_COLUMN_ITEM_NAME\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.VIEW_ITEM_COLUMN_ITEM_DESCRIPTION\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.VIEW_ITEM_COLUMN_ITEM_TYPES\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.VIEW_ITEM_COLUMN_ITEM_ACTIONS\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"item in itemGridVm.gridModel | filter : { ItemTypes : \'!\' + \'People\'}\"><td>{{ item.ItemName }}</td><td>{{ item.Description }}</td><td>{{item.ItemTypes}}</td><td><md-button class=\"md-icon-button\" ng-click=\"itemGridVm.onEdit(item.id, item.ItemName)\"><md-icon md-font-icon=\"icon-pencil\" class=\"teal-500-fg\"></md-icon><md-tooltip><span>Edit Item</span></md-tooltip></md-button><md-button ng-if=\"itemGridVm.canDeleteItem\" class=\"md-icon-button\" ng-click=\"itemGridVm.onRemove(item.id, item.ItemName)\"><md-icon md-font-icon=\"icon-trash\" class=\"red-500-fg\"></md-icon><md-tooltip><span>Delete Item</span></md-tooltip></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/assets/manage/item/peopleSkill/people-skill-dialog.html","<md-dialog aria-label=\"Contact Address\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{peopleSkillVm.headerTitle}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"peopleSkillVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"kitItemEntryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" flex=\"\"><md-input-container><md-select ng-model=\"peopleSkillVm.chosenSkill\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'ASSETSMODULE.PEOPLE_SKILL_SKILL_NAME\' | translate}}\" required=\"\"><md-option ng-repeat=\"skill in peopleSkillVm.skillsbybranch | orderBy : \'Name\'\" ng-value=\"skill\">{{skill.Name}}</md-option></md-select></md-input-container><md-input-container><md-select ng-model=\"peopleSkillVm.lockOutType\" placeholder=\"{{\'ASSETSMODULE.PEOPLE_SKILL_LOCKOUT_TYPE\' | translate}}\" required=\"\"><md-option ng-value=\"0\" translate=\"ASSETSMODULE.PEOPLE_SKILL_NO_LOCKOUT\"></md-option><md-option ng-value=\"1\" translate=\"ASSETSMODULE.PEOPLE_SKILL_SOFT_LOCKOUT\"></md-option><md-option ng-value=\"2\" translate=\"ASSETSMODULE.PEOPLE_SKILL_MEDIUM_LOCKOUT\"></md-option><md-option ng-value=\"3\" translate=\"ASSETSMODULE.PEOPLE_SKILL_HARD_LOCKOUT\"></md-option></md-select></md-input-container><md-input-container><label translate=\"ASSETSMODULE.PEOPLE_SKILL_BRANCHES\"></label><md-select ng-model=\"peopleSkillVm.Branches\" ng-model-options=\"{trackBy : \'$value.Id\'}\" multiple=\"\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch\" md-selected-text=\"peopleSkillVm.utilService.getSelectedText(peopleSkillVm.Branches, \'Branch(es)\', \'Name\')\" ng-repeat=\"branch in peopleSkillVm.branches\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"peopleSkillVm.onCancel()\" translate=\"ASSETSMODULE.PEOPLE_SKILL_CANCEL\" class=\"md-raised\"></md-button><md-button ng-click=\"peopleSkillVm.onAdd()\" class=\"md-accent md-raised\" ng-disabled=\"kitItemEntryForm.$invalid || kitItemEntryForm.$pristine\">{{peopleSkillVm.btnTitle}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/item/peopleSkill/people-skill.html","<div layout=\"column\" class=\"margin-bottom-20\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-button translate=\"ASSETSMODULE.PEOPLE_SKILL_ADD_SKILL\" class=\"md-accent md-raised\" ng-click=\"peopleSkillVm.onAdd()\"></md-button></div><div><table class=\"dataTable row-border hover\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"peopleSkillVm.dtOptions\" dt-column-defs=\"peopleSkillVm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.PEOPLE_SKILL_SKILL\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.PEOPLE_SKILL_SKILL_GROUP\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.PEOPLE_SKILL_BRANCHES\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.PEOPLE_SKILL_LOCKOUT\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.PEOPLE_SKILL_ACTIONS\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"skill in peopleSkillVm.service.data.ItemRequiredSkillsFormatted | orderBy : \'SkillName\'\"><td>{{skill.SkillName}}</td><td>{{skill.GroupName}}</td><td>{{skill.BranchesJoined}}</td><td>{{peopleSkillVm.getLockOut(skill.LockoutType)}}</td><td><md-button class=\"md-icon-button\" ng-click=\"peopleSkillVm.onEdit(skill)\"><md-icon md-font-icon=\"icon-pencil s20\"></md-icon><md-tooltip><span>Edit Skill</span></md-tooltip></md-button><delete-component index=\"skill\" tool-tip=\"{{\'ASSETSMODULE.PEOPLE_SKILL_REMOVE_SKILL\' | translate}}\" message=\"{{\'ASSETSMODULE.PEOPLE_SKILL_ARE_YOU_SRE_YOU_WANT_TO_DELETE_THIS_SKILL?\' | translate}}\" callback=\"peopleSkillVm.onRemove\" section=\"{{\'ASSETSMODULE.PEOPLE_SKILL_SKILL\' | translate}}\"></delete-component></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/assets/manage/item/relatedItem/related-item-dialog.html","<md-dialog aria-label=\"Contact Address\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{relatedItemVm.headerTitle}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"relatedItemVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"kitItemEntryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-autocomplete md-input-name=\"kitItem\" md-no-cache=\"true\" md-selected-item=\"relatedItemVm.itemSelected\" md-search-text=\"relatedItemVm.searchText\" md-selected-item-change=\"relatedItemVm.selectedItemChange(item)\" md-items=\"item in relatedItemVm.querySearch(relatedItemVm.searchText)\" md-item-text=\"item.ItemName\" md-min-length=\"0\" placeholder=\"{{\'ASSETSMODULE.RELATED_ITEM_DIALOG_LABEL_ITEM\' | translate}}\" md-floating-label=\"{{\'ASSETSMODULE.RELATED_ITEM_DIALOG_LABEL_ITEM\' | translate}}\" md-menu-class=\"autocomplete-custom-template\" flex=\"\" required=\"\"><md-item-template><span md-highlight-text=\"relatedItemVm.searchText\" md-highlight-flags=\"^i\">{{item.ItemName}}</span></md-item-template><md-not-found><strong style=\"color: blue;\">\"{{relatedItemVm.searchText}}\"</strong> not found.</md-not-found><div ng-messages=\"kitItemEntryForm.kitItem.$error\" ng-show=\"kitItemEntryForm.kitItem.$touched\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.RELATED_ITEM_DIALOG_VALIDATION_ITEM_REQUIRED\"></span></div></div></md-autocomplete></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.RELATED_ITEM_DIALOG_LABEL_QTY\"></label> <input type=\"number\" name=\"cost\" ng-model=\"relatedItemVm.qty\" placeholder=\"1\" ng-pattern=\"/^\\d+$/\" required=\"\"><div ng-messages=\"relatedItemVm.cost.$error\" ng-show=\"relatedItemVm.cost.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.RELATED_ITEM_DIALOG_VALIDATION_QTY_REQUIRED\"></span></div><div ng-message=\"number\"><span translate=\"ASSETSMODULE.RELATED_ITEM_DIALOG_VALIDATION_QTY_VALID_NUMBER\"></span></div><div ng-message=\"pattern\"><span translate=\"ASSETSMODULE.RELATED_ITEM_DIALOG_VALIDATION_QTY_VALID_NUMBER\"></span></div></div></md-input-container></div><md-checkbox ng-model=\"relatedItemVm.isRequired\" class=\"md-primary\" flex=\"\">{{\'ASSETSMODULE.RELATED_ITEM_REQUIRED\' | translate}}</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised\" translate=\"ASSETSMODULE.RELATED_ITEM_DIALOG_CANCEL_BUTTON\" ng-click=\"relatedItemVm.onCancel()\"></md-button><md-button ng-click=\"relatedItemVm.onAdd()\" class=\"md-raised md-accent\" ng-disabled=\"kitItemEntryForm.$invalid\">{{relatedItemVm.btnTitle}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/item/relatedItem/related-item.html","<div layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div layout=\"column\" layout-gt-xs=\"row\"><md-button class=\"md-accent md-raised\" translate=\"ASSETSMODULE.RELATED_ITEM_ADD_BUTTON\" ng-click=\"relatedItemVm.onAddRelatedItem()\"></md-button></div><div class=\"ms-responsive-table-wrapper\"><table class=\"dataTable row-border hover\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"relatedItemVm.dtOptions\" dt-column-defs=\"relatedItemVm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.RELATED_ITEM_COLUMN_ITEM\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.RELATED_ITEM_CONDITION\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.RELATED_ITEM_COLUMN_QTY\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ASSETSMODULE.REALTED_ITEM_COLUMN_ACTIONS\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"relatedItem in relatedItemVm.service.data.ItemPrerequisites\"><td width=\"35%\">{{relatedItem.ItemName}}</td><td width=\"15%\">{{ relatedItem.IsOptional ? \'Optional\' : \'Required\' }}</td><td width=\"10%\">{{relatedItem.Qty}}</td><td width=\"10%\"><md-button class=\"md-icon-button\" style=\"padding-right: 0; margin-right: 0\" aria-label=\"Edit\" translate=\"\" translate-attr-aria-label=\"ASSETSMODULE.EDIT\" hide=\"\" show-gt-sm=\"\" ng-click=\"relatedItemVm.onEdit(relatedItem.id)\"><md-icon md-font-icon=\"icon-pencil s20\"></md-icon><md-tooltip><span translate=\"ASSETSMODULE.RELATED_ITEM_DIALOG_EDIT_TITLE\"></span></md-tooltip></md-button><delete-component index=\"$index\" tool-tip=\"{{\'ASSETSMODULE.RELATED_ITEM_DIALOG_DELETE_TITLE\' | translate}}\" message=\"{{\'ASSETSMODULE.RELATED_ITEM_DIALOG_DELETE_MESSAGE\' | translate}}\" callback=\"relatedItemVm.remove\" section=\"{{\'ASSETSMODULE.RELATED_ITEM_DIALOG_DELETE_TITLE\' | translate}}\"></delete-component></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/branch/create/template/Divisions/divisions.html","");
$templateCache.put("app/main/assets/manage/kit/basic/basic-create-kit-item.html","<div layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div ng-form=\"\" name=\"basicKitInfoForm\" class=\"md-inline-form\" novalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"itemName\" ng-model=\"kitBasicVm.model.data.ItemName\" placeholder=\"Item Name\" required=\"\"><div ng-messages=\"basicKitInfoForm.itemName.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_KIT_ITEM_NAME_FIELD_IS_REQUIRED\' | translate}}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"description\" ng-model=\"kitBasicVm.model.data.Description\" placeholder=\"Description\" md-maxlength=\"70\"><div ng-messages=\"basicKitInfoForm.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_MAXIMUM_LENGTH_EXCEEDED\' | translate}}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container id=\"kitbranches\"><label< label=\"\"><md-select placeholder=\"{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_>BRANCH(ES)\' | translate}}\" md-selected-text=\"kitBasicVm.utilService.getSelectedText(kitBasicVm.model.data.Branches, \'Branch(es)\', \'Name\')\" multiple=\"\" name=\"Branches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"kitBasicVm.model.data.Branches\"><md-optgroup label=\"{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_>BRANCH(ES)\' | translate}}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in kitBasicVm.Branches\" ng-selected=\"branch.Selected\">{{branch.Name}}</md-option></md-optgroup></md-select></label<></md-input-container></div><kit-item-form-component></kit-item-form-component><br><label>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_CATEGORIES\' | translate}}</label><md-divider class=\"margin-top-5\"></md-divider><div id=\"categoryTree\" ivh-treeview=\"kitBasicVm.categoryModel.source\"><script type=\"text/ng-template\"><span ivh-treeview-toggle> <span ivh-treeview-twistie></span> </span> <a8-tree-md-box></a8-tree-md-box> <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle> {{trvw.label(node)}} </span> <div ivh-treeview-children></div></script></div></div></div></div></div>");
$templateCache.put("app/main/assets/manage/kit/basic/kit-item-dialog.html","<md-dialog aria-label=\"Contact Address\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_ADD_KIT_ITEM\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"kitItemVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"kitItemEntryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-autocomplete md-input-name=\"kitItem\" md-no-cache=\"true\" md-selected-item=\"kitItemVm.itemSelected\" md-search-text=\"kitItemVm.searchText\" md-selected-item-change=\"kitItemVm.selectedItemChange(item)\" md-items=\"item in kitItemVm.querySearch(kitItemVm.searchText)\" md-item-text=\"item.ItemName\" md-min-length=\"0\" placeholder=\"{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_SELECT_AN_ITEM\' | translate}}\" md-floating-label=\"{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_SELECT_AN_ITEM\' | translate}}\" md-menu-class=\"autocomplete-custom-template\" flex=\"\" required=\"\"><md-item-template><span md-highlight-text=\"kitItemVm.searchText\" md-highlight-flags=\"^i\">{{item.ItemName}}</span></md-item-template><md-not-found><strong style=\"color: blue;\">\"{{kitItemVm.searchText}}\"</strong> not found.</md-not-found><div ng-messages=\"kitItemEntryForm.kitItem.$error\" ng-show=\"kitItemEntryForm.kitItem.$touched\"><div ng-message=\"required\"><span>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_ITEM_FIELD_IS_REQUIRED\' | translate}}</span></div></div></md-autocomplete></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_QUANTITY\' | translate}}</label> <input type=\"number\" name=\"cost\" ng-model=\"kitItemVm.qty\" placeholder=\"0\" ng-pattern=\"/^\\d+$/\" required=\"\"><div ng-messages=\"kitItemEntryForm.cost.$error\" ng-show=\"kitItemEntryForm.cost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_QUANTITY_FIELD_IS_REQUIRED\' | translate}}</span></div><div ng-message=\"number\"><span>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_NOT_A_VALID_NUMBER\' | translate}}</span></div><div ng-message=\"pattern\"><span>{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_NOT_A_VALID_NUMBER\' | translate}}</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"kitItemVm.onCancel()\">{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_CANCEL\' | translate}}</md-button><md-button ng-click=\"kitItemVm.onAdd()\" class=\"md-accent md-raised\" aria-label=\"Add\" ng-disabled=\"kitItemEntryForm.$invalid || kitItemEntryForm.$pristine\" translate=\"ASSETSMODULE.HIRE_ADD\">{{\'ASSETSMODULE.BASIC_CREATE_KIT_ITEM_ADD\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/kit/basic/kit-item-form.html","<div layout=\"column\" layout-gt-xs=\"row\"><md-button class=\"md-accent md-raised\" ng-click=\"kitFormVm.onAddKitItem()\">{{\'ASSETSMODULE.KIT_ITEM_FORM_ADD_KIT_ITEM\' | translate}}</md-button><md-divider></md-divider></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"ms-responsive-table-wrapper\"><div class=\"flex\" flex=\"\"><table class=\"simple kit-item-table\" ms-responsive-table=\"\"><thead><tr><th>{{\'ASSETSMODULE.KIT_ITEM_FORM_ITEM\' | translate}}</th><th>{{\'ASSETSMODULE.KIT_ITEM_FORM_QTY\' | translate}}</th><th>{{\'ASSETSMODULE.KIT_ITEM_FORM_ACTIONS\' | translate}}</th></tr></thead><tfoot><tr><td colspan=\"3\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"kitFormVm.model.data.KitItems.length <= 0\"><span>{{\'ASSETSMODULE.KIT_ITEM_FORM_NO_CURRENT_KIT_ITEM\' | translate}}</span></div></td></tr></tfoot><tbody><tr ng-repeat=\"kitItem in kitFormVm.model.data.KitItems\"><td class=\"name\">{{kitItem.Items.ItemName}}</td><td class=\"qty\">{{kitItem.Quantity}}</td><td class=\"actions\" style=\"padding-right: 0;\"><div layout=\"row\"><md-button class=\"md-icon-button\" style=\"padding-right: 0; margin-right: 0\" aria-label=\"Edit\" translate=\"\" translate-attr-aria-label=\"ASSETSMODULE.EDIT\" hide=\"\" show-gt-sm=\"\" ng-click=\"kitFormVm.onEdit(kitItem.Items.id)\"><md-icon md-font-icon=\"icon-pencil s20\"></md-icon><md-tooltip><span>{{\'ASSETSMODULE.KIT_ITEM_FORM_EDIT_KIT_ITEM\' | translate}}</span></md-tooltip></md-button><delete-component index=\"$index\" tool-tip=\"{{\'ASSETSMODULE.KIT_ITEM_FORM_REMOVE_KIT_ITEM\' | translate}}\" message=\"{{\'ASSETSMODULE.KIT_ITEM_FORM_ARE_YOU_SRE_YOU_WANT_TO_DELETE_THIS_KIT_ITEM?\' | translate}}\" callback=\"kitFormVm.remove\" section=\"{{\'ASSETSMODULE.KIT_ITEM_FORM_KIT_ITEM\' | translate}}\"></delete-component></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/branch/create/template/directive/division.html","<div><p class=\"md-subhead\" flex=\"100\" translate=\"BRANCH_CREATE.DIVISIONS\"></p><div layout=\"column\" flex=\"100\"><add-division></add-division></div><md-card flex=\"\"><md-card-content><table class=\"simple kit-item-table\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th translate=\"BRANCH_CREATE.DIV_NAME\"></th><th translate=\"BRANCH_CREATE.DIV_ACTIONS\"></th></tr></thead><tbody><tr ng-repeat=\"division in vm.service.branchData.Division\"><td>{{division.Name}}</td><td><edit-division value=\"{{division}}\"></edit-division><delete-component index=\"$index\" message=\"{{\'BRANCH_CREATE.DIV_DELETE_MESSAGE\' | translate }}\" callback=\"vm.service.remove\" section=\"Divisions\"></delete-component></td></tr></tbody></table></md-card-content></md-card></div>");
$templateCache.put("app/main/awards/manage/awards/dialog/award-dialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"20\"><form name=\"awardForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\" ng-if=\"vm.source === \'classification\'\"><label>{{vm.idPlaceholder}}</label> <input type=\"text\" name=\"awardid\" ng-model=\"vm.Id\" required=\"\"><div ng-messages=\"awardForm.awardid.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{vm.idPlaceholder}} is required</span></div></div></md-input-container><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label>{{vm.namePlaceholder}}</label> <input type=\"text\" name=\"awardid\" ng-model=\"vm.Name\" required=\"\" ng-disabled=\"vm.isArchiveAward\" ng-pattern=\"vm.namePattern\"><div ng-messages=\"awardForm.awardid.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{vm.namePlaceholder}} is required</span></div></div></md-input-container><md-input-container id=\"branches\" ng-if=\"vm.source === \'classification\'\"><label>Branches</label><md-select placeholder=\"Branch(es)\" md-selected-text=\"vm.utilService.getSelectedText(vm.Branches, \'Branch(es)\', \'Name\')\" multiple=\"\" name=\"Branches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"vm.Branches\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.BranchesLookup\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\" ng-if=\"!vm.isArchiveAward\"><md-checkbox ng-model=\"vm.IsArchived\">{{vm.archiveCaption}}</md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" ng-if=\"!vm.isArchiveAward\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"awardForm.$invalid\">Save</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" ng-if=\"vm.isArchiveAward\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onArchive()\" ng-disabled=\"awardForm.$invalid\">{{vm.archiveButtonLabel}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/awards/manage/classifications/dialog/classification-dialog.html","<md-dialog flex=\"30\" flex-sm=\"60\" flex-xs=\"90\" ng-cloak=\"\" class=\"main-style\"><form name=\"classificationForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.isEditMode ? \'Edit Classification\' : \'Add Classification\'}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container flex=\"\"><label>Award</label> <input type=\"text\" name=\"awardName\" ng-model=\"vm.awardName\" disabled=\"\"></md-input-container><md-input-container flex=\"\"><label>Classification</label> <input type=\"text\" name=\"classificationName\" ng-model=\"vm.classificationName\" required=\"\"><div ng-messages=\"classificationForm.classificationName.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Classification Name is required</span></div></div></md-input-container><md-input-container flex=\"\"><label>Description</label> <input type=\"text\" name=\"classificationDescription\" ng-model=\"vm.description\"></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Base Rate of Pay</label> <input type=\"number\" name=\"baseRateOfPay\" ng-model=\"vm.baseRateOfPay\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,8})?$/\" required=\"\"><div ng-messages=\"classificationForm.baseRateOfPay.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Base Rate of Pay is required</span></div><div ng-message=\"pattern\"><span>Enter a number with up to 8 decimal places</span></div></div></md-input-container><md-input-container><label>Branches</label><md-select md-selected-text=\"vm.utilService.getSelectedText(vm.selectedBranches, \'Branches\', \'Name\')\" multiple=\"\" name=\"selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"vm.selectedBranches\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchesLookup\">{{branch.Name}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\" layout=\"column\" class=\"pl-10\"><span ng-if=\"vm.isArchived\" class=\"button-text warning-text-small\">This classification has been archived.</span> <span ng-if=\"vm.isAwardArchived\" class=\"button-text warning-text-small\">This award has been archived.</span></div><md-button ng-click=\"vm.isArchived ? vm.onUnarchive() : vm.onArchive()\" ng-disabled=\"classificationForm.$invalid || vm.isAwardArchived\" ng-if=\"vm.isEditMode\">{{vm.isArchived ? \'Unarchive\' : \'Archive\'}}</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.isEditMode ? vm.onUpdate() : vm.onAdd()\" ng-disabled=\"classificationForm.$invalid\">{{vm.isEditMode ? \'Save\' : \'Add\'}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/awards/manage/classification-rates/dialog/classification-rate-dialog.html","<md-dialog flex=\"30\" flex-sm=\"60\" flex-xs=\"90\" ng-cloak=\"\" class=\"main-style\"><form name=\"classificationForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Edit Classification Rate</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container flex=\"\"><label>Award</label> <input type=\"text\" name=\"awardName\" ng-model=\"vm.awardName\" disabled=\"\"></md-input-container><md-input-container flex=\"\"><label>Classification</label> <input type=\"text\" name=\"classificationName\" ng-model=\"vm.classificationName\" disabled=\"\"></md-input-container><md-input-container flex=\"\"><label>Rate</label><md-select name=\"rateId\" ng-model=\"vm.rateName\" placeholder=\"Rate\" ng-change=\"vm.onRateSelection()\" required=\"\" disabled=\"\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"payRate.Name\" ng-repeat=\"payRate in vm.payRates | orderBy: \'Order\'\">{{payRate.Name}}</md-option></md-select><div ng-messages=\"classificationForm.rateId.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Rate is required</span></div></div></md-input-container><md-input-container flex=\"\"><label>Rate Type</label><md-select name=\"rateType\" ng-model=\"vm.rateType\" placeholder=\"Rate Type\" ng-change=\"vm.onRateTypeSelection()\" required=\"\" disabled=\"\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"rateType.Id\" ng-repeat=\"rateType in vm.rateTypes\">{{rateType.Name}}</md-option></md-select><div ng-messages=\"classificationForm.rateType.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Rate Type is required</span></div></div></md-input-container><md-input-container flex=\"\"><label>Pay Code</label> <input type=\"text\" name=\"payCode\" ng-model=\"vm.payCode\" required=\"\"><div ng-messages=\"classificationForm.payCode.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Pay Code is required</span></div></div></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Pay Rate</label> <input type=\"number\" name=\"payRate\" ng-model=\"vm.payRate\" ng-min=\"vm.baseRateOfPay\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,8})?$/\" required=\"\"><div ng-messages=\"classificationForm.payRate.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Pay Rate is required</span></div><div ng-message=\"pattern\"><span>Enter a number with up to 8 decimal places</span></div><div ng-message=\"min\"><span>Pay Rate cannot be less than the Base Rate of {{vm.baseRateOfPay | currency:\"$\":8}}</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\" layout=\"column\" class=\"pl-10\"><span ng-if=\"vm.isArchived\" class=\"button-text warning-text-small\">This classification has been archived.</span></div><md-button class=\"md-warn\" ng-click=\"vm.onDelete()\" ng-disabled=\"classificationForm.$invalid\">Delete</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.onUpdate()\" ng-disabled=\"classificationForm.$invalid\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/awards/manage/view/dialog/award-dialog.html","<md-dialog flex=\"30\" flex-sm=\"60\" flex-xs=\"90\" ng-cloak=\"\" class=\"main-style\"><form name=\"awardForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.isEditMode ? \'Edit Award\' : \'Add Award\'}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label>Award Name</label> <input type=\"text\" name=\"awardName\" ng-model=\"vm.awardName\" ng-disabled=\"vm.isEditMode\" required=\"\"><div ng-messages=\"awardForm.awardName.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Award Name is required</span></div></div></md-input-container><md-input-container flex=\"\"><label>Agreement Name</label> <input type=\"text\" name=\"agreementName\" ng-model=\"vm.agreementName\"></md-input-container><md-input-container flex=\"\"><label>Agreement Number</label> <input type=\"text\" name=\"agreementNumber\" ng-model=\"vm.agreementNumber\"></md-input-container><md-input-container><label>Expiry Date</label><md-datepicker ng-model=\"vm.expiryDate\" md-open-on-focus=\"\"></md-datepicker></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.isArchived ? vm.onUnarchive() : vm.onArchive()\" ng-disabled=\"awardForm.$invalid\" ng-if=\"vm.isEditMode\">{{vm.isArchived ? \'Unarchive\' : \'Archive\'}}</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.isEditMode ? vm.onUpdate() : vm.onAdd()\" ng-disabled=\"awardForm.$invalid\">{{vm.isEditMode ? \'Save\' : \'Add\'}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/costEstimate/directives/grid/search/ceGridSearch.html","<md-input-container><label>Search</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.source\" ng-model-options=\"vm.delay\"></md-input-container>");
$templateCache.put("app/main/costEstimate/directives/grid/gridInfo/ce-grid-info.html","<section><strong>Showing {{vm.totalItems}}<span ng-if=\"vm.inProgress\">+</span> <span ng-if=\"vm.totalItems > 0\">invoices</span><span ng-if=\"vm.totalItems <= 0\">invoice</span> <span ng-if=\"vm.isFiltered\">(filtered from {{vm.rawTotalItemCount}} total entries)</span></strong></section>");
$templateCache.put("app/main/costEstimate/directives/grid/status/ce-status.html","<grid-info-component></grid-info-component><section><label class=\"text-capitalized font-size-9\">{{vm.status}}</label></section>");
$templateCache.put("app/main/customFieldsManager/binder/fields/checkbox/checkbox.html","<div flex=\"none\"><md-checkbox style=\"margin-top : 10px\" ng-disabled=\"vm.isDisabled\" ng-if=\"vm.fieldDetail.OptionType == \'Regular\'\" ng-change=\"vm.change(vm.fieldDetail.ModelValue)\" ng-model=\"vm.fieldDetail.ModelValue\">{{vm.fieldDetail.FieldTitle}}</md-checkbox><div style=\"margin-top : 10px\" ng-if=\"vm.fieldDetail.OptionType == \'Other\'\" flex=\"none\" layout=\"row\"><div><md-checkbox ng-change=\"vm.change(vm.fieldDetail.ModelValue)\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.fieldDetail.ModelValue\"></md-checkbox></div><div><md-input-container style=\"margin-top :-10px;\"><input type=\"text\" ng-model=\"vm.other_value\" ng-change=\"vm.complyMultiple(vm.other_value)\" ng-disabled=\"!vm.fieldDetail.ModelValue || vm.isDisabled\"></md-input-container></div></div></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/checkboxDescription/description.html","<div flex=\"\" class=\"md-body-2\" style=\"margin-bottom : 16px;\">{{vm.fieldDetail.Description}}</div>");
$templateCache.put("app/main/assets/manage/item/individualItem/depreciation-dialog.html","<md-dialog id=\"depreciation\" aria-label=\"Add Depreciation Item\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_DEPRECIATION\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"deprecVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"DepreciationEntryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_YEAR\"></label> <input type=\"text\" name=\"year\" ng-model=\"deprecVm.model.YearText\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_PERCENT_PER_YEAR\"></label> <input type=\"number\" numeric=\"\" decimals=\"2\" name=\"percentPerYear\" min=\"0\" max=\"100\" ng-model=\"deprecVm.model.PercentPerYear\" required=\"\"><div ng-messages=\"DepreciationEntryForm.percentPerYear.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_PERCENT_PER_YEAR_IS_REQUIRED\"></span></div><div ng-message=\"number\"><span translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_NOT_A_VALID_NUMBER\"></span></div><div ng-message=\"min\"><span translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_MINIMUM_VALUE_IS_0\"></span></div><div ng-message=\"max\"><span translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_MAXIMUM_VALUE_IS_100\"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"deprecVm.onCancel()\" class=\"md-raised\" translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_CANCEL\"></md-button><md-button ng-click=\"deprecVm.onAdd()\" class=\"md-accent md-raised\" aria-label=\"Add\" ng-disabled=\"DepreciationEntryForm.$invalid || DepreciationEntryForm.$pristine\" translate=\"ASSETSMODULE.DEPRECIATION_DIALOG_ADD\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/item/individualItem/import-dialog.html","<md-dialog id=\"import-file-item\" aria-label=\"Import Item\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"ASSETSMODULE.IMPORT_DIALOG_IMPORT_FILE\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><div layout=\"column\" layout-align=\"start start\" layout-margin=\"\"><a href=\"#\">{{\'ASSETSMODULE.IMPORT_DIALOG_DOWNLOAD_IMPORT_TEMPLATE\' | translate}}</a></div><form name=\"importFileItemForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex=\"80\" class=\"margin-top-30\"><label translate=\"ASSETSMODULE.IMPORT_DIALOG_FILE_NAME\"></label> <input type=\"text\" name=\"fileName\" ng-model=\"vm.fileName\" ng-disabled=\"true\"></md-input-container><div flex=\"20\"><input type=\"file\" id=\"importFile\" class=\"image-input\" a8-file-upload=\"files\" upload-url=\"vm.uploadUrl\" on-upload-start=\"vm.onUploadStart()\" on-upload-progress=\"vm.onUploadProgress(filename)\" on-upload-completed=\"vm.onUploadCompleted(data)\" on-upload-validate=\"vm.onUploadValidate(fileObj)\" on-upload-error=\"vm.onUploadError(ex)\" ng-disabled=\"vm.showProgress\"><md-button class=\"md-accent\" ng-disabled=\"vm.showProgress\"><label class=\"image-input\" ng-show=\"!vm.showProgress\" for=\"importFile\">{{\'ASSETSMODULE.IMPORT_DIALOG_CHOOSE_A_FILE\' | translate}}</label> <label class=\"image-input\" ng-show=\"vm.showProgress\" for=\"importFile\">{{\'ASSETSMODULE.IMPORT_DIALOG_UPLOADING\' | translate}}</label></md-button></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\"><label>{{\'ASSETSMODULE.IMPORT_DIALOG_FILE_SUPPORTED\' | translate}}</label></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"ASSETSMODULE.IMPORT_DIALOG_CANCEL\" ng-click=\"vm.onCancel()\" class=\"md-raised md-accent\" ng-disabled=\"vm.showProgress\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/item/individualItem/import-error-dialog.html","<md-dialog id=\"import-file-item\" aria-label=\"Import Error(s)\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"ASSETSMODULE.IMPORT_DIALOG_ERROR_IMPORT_ERROR\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onDone()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><h3 class=\"alert-error\" translate=\"ASSETSMODULE.IMPORT_DIALOG_ERROR_LIST_OF_ISSUES_ENCOUNTERED_UPON_PROCESSING\"></h3><p ng-bind-html=\"vm.issues\"></p></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onDone()\" translate=\"ASSETSMODULE.IMPORT_DIALOG_ERROR_DONE\" class=\"md-raised md-accent\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/assets/manage/item/individualItem/individual-item-approvals-dialog.html","<md-dialog flex=\"35\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Approvals</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vmApprovalChain.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><table datatable=\"ng\" class=\"dataTable row-border hover\" dt-options=\"vmApprovalChain.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">User</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vmApprovalChain.approvalList\"><td>{{item.Name}}</td><td ng-if=\"item.Status == \'User\'\"><i class=\"icon-checkbox-marked-circle green-500-fg\"><md-tooltip>Approve</md-tooltip></i> <i class=\"icon-cancel red-500-fg\"><md-tooltip>Reject</md-tooltip></i> <i class=\"icon-question-mark-circle orange-500-fg\"><md-tooltip>More Information</md-tooltip></i></td><td ng-if=\"item.Status != \'User\'\">{{item.Status}}</td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vmApprovalChain.onClose()\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/assets/manage/item/individualItem/individual-item-dialog.html","<md-dialog id=\"individual-item\" aria-label=\"Contact Address\" class=\"main-style\" flex=\"50\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_INDIVIDUAL_ITEM\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"indvVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"IndividualItemEntryForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content style=\"padding: 0 !important;\"><div class=\"form-wrapper\" flex=\"\"><md-tabs class=\"tab-content\" md-dynamic-height=\"\"><md-tab label=\"{{\'ASSETSMODULE.ITEM_DETAILS_TAB\' | translate}}\"><div layout=\"row\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"identifier\" ng-model=\"indvVm.model.data.UniqueItemId\" placeholder=\"{{indvVm.hasVehicleType ? \'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_REGISTRATION_NUMBER\': \'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_UNIQUE_ITEM_IDENTIFIER\' | translate}}\" required=\"\"><div ng-messages=\"IndividualItemEntryForm.identifier.$error\" ng-show=\"IndividualItemEntryForm.identifier.$touched\" role=\"alert\"><div ng-message=\"required\"><span>{{indvVm.hasVehicleType ? \'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_REGISTRATION_NUMBER_FIELD_IS_REQUIRED\': \'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_UNIQUE_INDENTIFIER_FIELD_IS_REQUIRED\' | translate}}</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"desc\" ng-model=\"indvVm.model.data.Description\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_DESCRIPTION\' | translate}}\" md-maxlength=\"70\"><div ng-messages=\"basicInfoForm.desc.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_MAXIMUM_LENGTH_EXCEEDED\"></span></div></div></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\"><md-input-container flex=\"50\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_TYPES\"></label><md-select name=\"itemType\" ng-model=\"indvVm.model.data.ItemType\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_TYPES\' | translate}}\" required=\"\"><md-option ng-repeat=\"item in indvVm.itemTypes\" ng-value=\"item\" ng-disabled=\"indvVm.isItemTypeDisabled(item)\">{{item.Name}}</md-option></md-select><div ng-messages=\"IndividualItemEntryForm.itemType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_TYPE_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_BRANCH\"></label><md-select name=\"branches\" multiple=\"\" ng-change=\"indvVm.model.getDivisionsAndUsers()\" ng-model=\"indvVm.model.data.Branches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_BRANCH\' | translate}}\" required=\"\"><md-option ng-value=\"branch\" ng-repeat=\"branch in indvVm.branches\">{{branch.Name}}</md-option></md-select><div ng-messages=\"IndividualItemEntryForm.branch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_BRANCH_FIELD_IS_REQUIRED\"></span></div></div></md-input-container><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_DIVISIONS\"></label><md-select name=\"Divisions\" multiple=\"\" ng-model=\"indvVm.model.data.Divisions\" md-selected-text=\"indvVm.utilService.getSelectedText(indvVm.model.data.Divisions, \'Division(s)\', \'Name\')\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_DIVISIONS\' | translate}}\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-optgroup label=\"Divisions\"><md-option ng-repeat=\"division in indvVm.model.divisionsLookup\" ng-value=\"division\">{{division.Name}} - ({{division.BranchName}})</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"indvVm.model.data.User\" md-search-text=\"indvVm.searchText\" md-selected-item-change=\"indvVm.selectedItemChange(item)\" md-items=\"item in indvVm.querySearch(indvVm.searchText)\" md-item-text=\"item.FullName\" md-min-length=\"0\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_SELECT_EMPLOYEE_CONTACT\' | translate}}\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ASSIGNED_TO_USER\' | translate}}\" flex=\"\"><md-item-template><span md-highlight-text=\"indvVm.searchText\" md-highlight-flags=\"^i\">{{item.FullName}}</span></md-item-template><md-not-found><span ng-if=\"indvVm.model.data.Branches == null\"><strong style=\"color: blue;\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_SELECT_YOUR_BRANCH_FIRST\' | translate}}</strong></span> <span ng-if=\"indvVm.model.data.Branches != null\"><strong style=\"color: blue;\">\"{{indvVm.searchText}}\"</strong> not found.</span></md-not-found></md-autocomplete></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"!indvVm.isVehicle()\"><md-input-container flex=\"50\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_STATUS\"></label><md-select name=\"itemStatus\" ng-model=\"indvVm.model.data.ItemStatus\" ng-change=\"indvVm.hasItemStatusChange()\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_STATUS\' | translate}}\" required=\"\"><md-option ng-repeat=\"itemState in indvVm.itemStates\" value=\"{{itemState.Id}}\">{{itemState.Name}}</md-option></md-select><div ng-messages=\"IndividualItemEntryForm.itemStatus.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_STATUS_IS_REQUIRED\"></span></div></div></md-input-container><md-input-container flex=\"50\" ng-if=\"indvVm.showStatusEffectiveDate\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_STATUS_EFFECTIVE_DATE\"></label><md-datepicker ng-model=\"indvVm.model.data.StatusEffectiveDate\" md-open-on-focus=\"\" required=\"\"></md-datepicker></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"indvVm.isVehicle()\"><md-input-container flex=\"50\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_STATUS\"></label><md-select name=\"itemStatus\" ng-model=\"indvVm.model.data.ItemStatus\" ng-change=\"indvVm.hasItemStatusChange()\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_STATUS\' | translate}}\" required=\"\"><md-option ng-repeat=\"itemState in indvVm.itemStates\" value=\"{{itemState.Id}}\">{{itemState.Name}}</md-option></md-select><div ng-messages=\"IndividualItemEntryForm.itemStatus.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ITEM_STATUS_IS_REQUIRED\"></span></div></div></md-input-container><md-input-container flex=\"50\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_OWNERSHIP_TYPE\"></label><md-select name=\"itemType\" ng-model=\"indvVm.model.data.VehicleOwnershipType\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_OWNERSHIP_TYPE\' | translate}}\"><md-option ng-value=\"\"></md-option><md-option ng-repeat=\"item in indvVm.vehicleOwnershipTypes\" ng-value=\"item.Id\">{{item.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\" ng-if=\"indvVm.isVehicle() && indvVm.showStatusEffectiveDate\"><md-input-container flex=\"50\" ng-if=\"indvVm.showStatusEffectiveDate\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_STATUS_EFFECTIVE_DATE\"></label><md-datepicker ng-model=\"indvVm.model.data.StatusEffectiveDate\" md-open-on-focus=\"\" required=\"\"></md-datepicker></md-input-container></div></md-tab><md-tab label=\"{{\'ASSETSMODULE.VEHICLE_DETAILS_TAB\' | translate}}\" ng-if=\"indvVm.hasVehicleType\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><md-select name=\"VehicleMake\" ng-model=\"indvVm.model.data.VehicleMake\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_MAKE\' | translate}}\" ng-required=\"indvVm.hasVehicleType\"><md-optgroup label=\"Makes\"><md-option ng-value=\"item\" ng-repeat=\"item in indvVm.vehicleService.vehicleMakes\">{{item.Value}}</md-option></md-optgroup></md-select><div ng-messages=\"IndividualItemEntryForm.VehicleMake.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_MAKE_IS_REQUIRED\"></span></div></div></md-input-container><md-input-container flex=\"\"><md-select name=\"VehicleModel\" ng-model=\"indvVm.model.data.VehicleModel\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_MODEL\' | translate}}\" ng-required=\"indvVm.hasVehicleType\"><md-optgroup label=\"Models\"><md-option ng-value=\"item\" ng-repeat=\"item in indvVm.vehicleService.vehicleModels\">{{item.Value}}</md-option></md-optgroup></md-select><div ng-messages=\"IndividualItemEntryForm.VehicleModel.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_MODEL_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"VehicleType\" ng-model=\"indvVm.model.data.VehicleType\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_TYPE\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"VehicleBody\" ng-model=\"indvVm.model.data.VehicleBody\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_BODY\' | translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"VehicleVin\" ng-model=\"indvVm.model.data.VehicleVin\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_VIN\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"EngineNumber\" ng-model=\"indvVm.model.data.VehicleEngineNumber\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_ENGINE_NUMBER\' | translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"number\" name=\"BuildYear\" ng-model=\"indvVm.model.data.VehicleBuildYear\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_VEHICLE_BUILD_YEAR\' | translate}}\"></md-input-container><div flex=\"\">&nbsp;</div></div></md-tab><md-tab label=\"{{\'ASSETSMODULE.FINANCIALS_TAB\' | translate}}\" ng-if=\"indvVm.claimsUtilService.isBillingEnabled()\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_COST_CODE\"></label><md-select ng-model=\"indvVm.model.data.CostCode\" ng-model-options=\"{trackBy: \'$value.id\'}\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_COST_CODE\' | translate}}\"><md-option></md-option><md-option ng-repeat=\"costCode in indvVm.costCodes\" ng-value=\"costCode\">{{costCode.CodeNo}} - {{costCode.Description}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><input type=\"number\" name=\"purchasePrice\" min=\"0\" ng-model=\"indvVm.model.data.PurchasePrice\" placeholder=\"{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_PURCHASE_COST\' | translate}} (0.00)\"><div ng-messages=\"IndividualItemEntryForm.purchasePrice.$error\" role=\"alert\"><div ng-message=\"number\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_NOT_A_VALID_NUMBER\"></span></div></div></md-input-container></div><br><div class=\"md-whiteframe-1dp padding-10\"><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\"><md-button class=\"md-accent md-raised padding-left-0 margin-left-0\" ng-click=\"indvVm.onAddDepreciation()\" ng-disabled=\"indvVm.model.disableAddDepreciation\">&nbsp;{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ADD_DEPRECIATION\' | translate}}</md-button><span class=\"margin-left-10 margin-top-0 padding-top-0\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_REMAINING\' | translate}} : {{indvVm.model.data.DepreciationTotalSummary}}%</span></div><div layout=\"column\" layout-gt-xs=\"row\"><table class=\"simple\" style=\"width: 850px;\" ms-responsive-table=\"\"><thead><tr><th>{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_YEAR\' | translate}}</th><th class=\"text-center\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_PERCENT_PER_YEAR\' | translate}} (%)</th><th class=\"text-right\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_ACTIONS\' | translate}}</th></tr></thead><tfoot><tr><td colspan=\"3\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"indvVm.model.data.Depreciation.length <= 0\"><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_NO_CURRENT_DEPRECIATION\"></span></div></td></tr></tfoot><tbody><tr ng-repeat=\"depreciation in indvVm.model.data.Depreciation\"><td class=\"depreciationYear\">{{depreciation.YearText}}</td><td class=\"percentPerYear text-center\">{{depreciation.PercentPerYear}}</td><td class=\"actions text-right\" style=\"padding-right: 0;\"><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" style=\"padding-right: 0; margin-right: 0\" aria-label=\"Edit\" translate=\"\" translate-attr-aria-label=\"ASSETSMODULE.DEPRECIATION_EDIT\" hide=\"\" show-gt-sm=\"\" ng-click=\"indvVm.onEdit(depreciation.id)\"><md-icon md-font-icon=\"icon-pencil s20\"></md-icon><md-tooltip><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_EDIT_DEPRECIATION_ITEM\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"ASSETSMODULE.DEPRECIATION_DELETE\" hide=\"\" show-gt-sm=\"\" ng-click=\"indvVm.onRemove($index)\" ng-disabled=\"($index + 1) != indvVm.model.data.Depreciation.length\"><md-icon md-font-icon=\"icon icon-delete s20\"></md-icon><md-tooltip><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_DELETE_THIS_DEPRECIATION_ITEM\"></span></md-tooltip></md-button></div></td></tr></tbody></table></div></div></md-tab></md-tabs></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"indvVm.onCancel()\" translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_DIALOG_CANCEL\" class=\"md-raised md-accent first-button-margin\"></md-button><md-button ng-click=\"indvVm.onAddUpdate()\" class=\"md-accent md-raised button-margin\" aria-label=\"Add\" ng-disabled=\"IndividualItemEntryForm.$invalid || IndividualItemEntryForm.$pristine || !indvVm.hasEditIndividualItem\" translate=\"ASSETSMODULE.INDV_ADD\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/item/individualItem/individual-item.html","<div layout=\"column\" class=\"margin-bottom-20\"><div layout=\"row\"><div class=\"form-wrapper2 md-whiteframe-1dp\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-button translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_ADD_INDIVIDUAL_ITEM\" class=\"md-raised md-accent padding-right-10 padding-left-10 first-button-margin\" ng-click=\"indvItemVm.onAdd()\"></md-button></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"indvItemVm.hasUserBranchConflict()\"><span class=\"material-icons md-18 amber600\" style=\"padding: 20px 5px 5px 20px;\">warning</span> <strong style=\"padding: 20px 0\">There are users who don\'t belong to the same branch as the equipment they are assigned to.</strong></div><div class=\"ms-responsive-table-wrapper\"><table class=\"dataTable row-border hover\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"indvItemVm.dtOptions\" dt-column-defs=\"indvItemVm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{indvItemVm.hasVehicleType() ? \'ASSETSMODULE.INDIVIDUAL_ITEM_VEHICLE_ID\' : \'ASSETSMODULE.INDIVIDUAL_ITEM_UNIQUE_ID\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_DESCRIPTION\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_BRANCH\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_USER\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_STATUS\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'ASSETSMODULE.INDIVIDUAL_ITEM_ACTIONS\' | translate}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in indvItemVm.model.data\"><td>{{ item.UniqueItemId }}</td><td>{{ item.Description }}</td><td>{{ item.BranchNames.join(\', \') }}</td><td><span ng-if=\"indvItemVm.hasUserBranchConflict(item)\" class=\"material-icons md-18 amber600\" style=\"padding: 0 5px;\">warning</span> {{ item.User.FirstName }} {{ item.User.LastName }}</td><td>{{ item.ItemStatusName }}</td><td><md-button class=\"md-icon-button\" aria-label=\"Edit\" translate=\"\" translate-attr-aria-label=\"ASSETSMODULE.EDIT_INDIVIDUAL_ITEM\" hide=\"\" show-gt-sm=\"\" ng-click=\"indvItemVm.onEdit(item.id)\" ng-disabled=\"!indvItemVm.hasEditIndividualItem\"><md-icon md-font-icon=\"icon-pencil s20\"></md-icon><md-tooltip><span translate=\"ASSETSMODULE.INDIVIDUAL_ITEM_EDIT_INDIVIDUAL_ITEM\"></span></md-tooltip></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/checkboxWithEntry/checkboxWithEntry.html","<div flex=\"none\"><div flex=\"none\" layout=\"row\"><table><tr><td style=\"width:auto;\"><md-checkbox ng-disabled=\"vm.isDisabled\" ng-change=\"vm.change(vm.fieldDetail.ModelValue)\" ng-model=\"vm.fieldDetail.ModelValue\">{{vm.fieldDetail.FieldTitle}}</md-checkbox></td><td style=\"width:50%;\"><md-input-container style=\"margin-top:-10px;\"><input type=\"text\" ng-model=\"vm.other_value\" ng-change=\"vm.complyMultiple(vm.other_value)\" ng-disabled=\"!vm.fieldDetail.ModelValue || vm.isDisabled\"></md-input-container></td></tr></table></div></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/decimals/decimals.html","<div flex=\"\"><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.fieldDetail.Value\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.comply()\" ng-required=\"vm.fieldDetail.IsRequired\" name=\"{{vm.fieldDetail.FieldTitle}}\" numeric=\"\" decimals=\"2\" placeholder=\"{{vm.fieldDetail.FieldTitle}}\"></md-input-container></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/dropDown/dropDown.html","<div flex=\"\"><md-input-container class=\"md-block\"><label>{{vm.fieldDetail.FieldTitle}}</label><md-select ng-model=\"vm.fieldDetail.Value\" ng-disabled=\"vm.isDisabled\" ng-required=\"vm.fieldDetail.IsRequired\" name=\"{{vm.fieldDetail.FieldTitle}}\" ng-change=\"vm.comply()\"><md-option ng-value=\"opt.Id\" ng-repeat=\"opt in vm.fieldDetail.Option\">{{opt.Value}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/email/email.html","<div flex=\"\"><md-input-container class=\"md-block\"><input type=\"email\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.fieldDetail.Value\" ng-change=\"vm.comply()\" ng-required=\"vm.fieldDetail.IsRequired\" name=\"{{vm.fieldDetail.FieldTitle}}\" placeholder=\"{{vm.fieldDetail.FieldTitle}}\"></md-input-container></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/multipleChoice/multipleChoice.html","<div flex=\"none\" layout=\"column\" style=\"padding-top : 8px; padding-bottom : 8px;\"><label class=\"md-body-2\">{{vm.fieldDetail.FieldTitle}} <span ng-if=\"vm.fieldDetail.IsRequired\" style=\"color : red\">*</span></label><div style=\"margin-top : 20px;\"><md-radio-group name=\"{{vm.fieldDetail.Value}}\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.complyMultiple(vm.fieldDetail.Value)\" ng-model=\"vm.fieldDetail.Value\" ng-required=\"vm.fieldDetail.IsRequired\"><md-radio-button ng-value=\"opt.Id\" ng-if=\"opt.Type == \'Regular\'\" ng-repeat=\"opt in vm.fieldDetail.Option | filter: { Type : \'Regular\'}\">{{opt.Value}}</md-radio-button><div layout=\"row\" ng-repeat=\"opt in vm.fieldDetail.Option | filter: { Type : \'Other\'}\"><div><md-radio-button ng-value=\"opt.Id\"></md-radio-button></div><div style=\"margin-top : -28px;\"><md-input-container><input type=\"text\" ng-change=\"vm.complyMultiple(vm.other_value)\" ng-disabled=\"!vm.enable_other_value\" ng-model=\"vm.other_value\"></md-input-container></div></div></md-radio-group></div></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/paragraph/paragraph.html","<div flex=\"\"><md-input-container class=\"md-block\"><label>{{vm.fieldDetail.FieldTitle}}</label> <textarea ng-model=\"vm.fieldDetail.Value\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.comply()\" ng-required=\"vm.fieldDetail.IsRequired\" name=\"{{vm.fieldDetail.FieldTitle}}\" ng-pattern=\"vm.fieldDetail.ValidationRegexPattern\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus=\"\"></textarea></md-input-container></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/shortText/shortText.html","<div flex=\"\" style=\"padding-top : 8px; padding-bottom : 8px;\"><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.fieldDetail.Value\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.comply()\" ng-required=\"vm.fieldDetail.IsRequired\" name=\"{{vm.fieldDetail.FieldTitle}}\" ng-pattern=\"vm.fieldDetail.ValidationRegexPattern\" placeholder=\"{{vm.fieldDetail.FieldTitle}}\"></md-input-container></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/time/time.html","<div flex=\"\"><md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.fieldDetail.Value\" ng-change=\"vm.comply()\" ng-required=\"vm.fieldDetail.IsRequired\" name=\"{{vm.fieldDetail.FieldTitle}}\" placeholder=\"{{vm.fieldDetail.FieldTitle}}\" time-picker=\"\"></md-input-container></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/url/url.html","<div flex=\"\"><md-input-container class=\"md-block\"><input type=\"url\" ng-model=\"vm.fieldDetail.Value\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.comply()\" ng-required=\"vm.fieldDetail.IsRequired\" name=\"{{vm.fieldDetail.FieldTitle}}\" placeholder=\"{{vm.fieldDetail.FieldTitle}}\"></md-input-container></div>");
$templateCache.put("app/main/customFieldsManager/binder/fields/wholeNumber/wholeNumber.html","<div flex=\"\"><md-input-container class=\"md-block\"><input type=\"number\" onkeydown=\"javascript: return event.keyCode == 69 ? false : true\" ng-paste=\"vm.paste($event)\" ng-model=\"vm.fieldDetail.Value\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.comply()\" ng-required=\"vm.fieldDetail.IsRequired\" name=\"{{vm.fieldDetail.FieldTitle}}\" min=\"{{vm.fieldDetail.MinValue}}\" max=\"{{vm.fieldDetail.MaxValue}}\" placeholder=\"{{vm.fieldDetail.FieldTitle}}\"></md-input-container></div>");
$templateCache.put("app/main/company/create/companyDetails/Skills/skills.html","<div flex=\"\"><p class=\"md-subhead\" flex=\"100\" translate=\"COMPANYMODULE.SKILLS_HEADER\"></p><company-skill-dialog ng-if=\"companyVm.Id.length > 0 && companyVm.checkAccessService.checkAccessByRole(\'Manage Company Skills\')\" branches=\"detailsVm.model.Branches2\" skills-list=\"detailsVm.skillsLookUps\"></company-skill-dialog><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"detailsVm.dtOptions\"><thead><tr><th translate=\"COMPANYMODULE.SKILLS_COLUMN_SKILL\"></th><th translate=\"COMPANYMODULE.SKILLS_COLUMN_GROUP\"></th><th translate=\"COMPANYMODULE.SKILLS_COLUMN_LOCKOUT\"></th><th translate=\"COMPANYMODULE.SKILLS_COLUMN_ACTIONS\" ng-if=\"companyVm.checkAccessService.checkAccessByRole(\'Manage Company Skills\') || companyVm.checkAccessService.checkAccessByRole(\'Remove Company Skills\')\"></th></tr></thead><tbody><tr ng-repeat=\"skill in detailsVm.model.formattedSkills\"><td>{{skill.SkillName}}</td><td>{{skill.GroupName}}</td><td>{{detailsVm.getLockOut(skill.LockoutType)}}</td><td ng-if=\"companyVm.checkAccessService.checkAccessByRole(\'Manage Company Skills\') || companyVm.checkAccessService.checkAccessByRole(\'Remove Company Skills\')\"><company-edit-skill-dialog skill=\"{{skill}}\" ng-if=\"companyVm.checkAccessService.checkAccessByRole(\'Manage Company Skills\')\" branches=\"detailsVm.model.Branches2\" skills-list=\"detailsVm.skillsLookUps\"></company-edit-skill-dialog><delete-component index=\"skill\" ng-if=\"companyVm.checkAccessService.checkAccessByRole(\'Remove Company Skills\')\" message=\"{{\'COMPANYMODULE.SKILLS_DELETE_MESSAGE\' | translate}}\" callback=\"detailsVm.removeSkill\" section=\"{{\'COMPANYMODULE.SKILLS_DELETE_SECTION\' | translate}}\"></delete-component></td></tr></tbody></table></md-card-content></md-card></div>");
$templateCache.put("app/main/company/create/companyDetails/address/address.html","<div flex=\"\"><p class=\"md-subhead\" flex=\"100\" translate=\"COMPANYMODULE.COMPANY_ADDRESS_DIALOG_HEADER\"></p><div layout=\"column\" flex=\"100\"><a8-add-address-company-dialog></a8-add-address-company-dialog></div><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\" dt-options=\"detailsVm.dtOptions\"><thead><tr><th translate=\"COMPANYMODULE.COMPANY_ADDRESS_COLUMN_ADDRESS\"></th><th translate=\"COMPANYMODULE.COMPANY_ADDRESS_COLUMN_TYPE\"></th><th translate=\"COMPANYMODULE.SKILLS_COLUMN_ACTIONS\"></th></tr></thead><tbody><tr ng-repeat=\"address in detailsVm.model.Address\"><td>{{address.FullAddress}}</td><td>{{address.AddressType.TypeName}}</td><td><a8-edit-address-company-dialog value=\"{{address}}\" index=\"{{$index}}\"></a8-edit-address-company-dialog><delete-component index=\"$index\" message=\"{{\'COMPANYMODULE.COMPANY_ADDRESS_DELETE_MESSAGE\' | translate}}\" callback=\"detailsVm.removeAddress\" section=\"{{\'COMPANYMODULE.COMPANY_ADDRESS_COLUMN_ADDRESS\' | translate}}\"></delete-component></td></tr></tbody></table></md-card-content></md-card></div>");
$templateCache.put("app/main/company/create/companyDetails/myob-company/myob-company.dialog.html","<md-dialog id=\"myobCompanies-dialog\" class=\"provider-company-dialog\" aria-label=\"Add MyobCompanies\" flex=\"30\" ng-cloak=\"\"><form name=\"myobCompanyForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"COMPANYMODULE.MYOBCOMPANY.HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.branch\" placeholder=\"{{\'COMPANYMODULE.MYOBCOMPANY.BRANCH\' | translate}}\" name=\"Branch\" ng-change=\"vm.onSelection()\" required=\"\"><md-option ng-repeat=\"branch in vm.branches\" ng-value=\"branch\">{{branch.Name}}</md-option></md-select><div ng-messages=\"myobCompanyForm.Branch.$error\" role=\"alert\"><div ng-message=\"valid\">The selected branch already has a MYOB Company assigned to it</div></div></md-input-container></div><div layout=\"column\"><md-autocomplete md-floating-label=\"{{\'COMPANYMODULE.MYOB_CUSTOMER\' | translate}}\" md-search-text=\"vm.searchText\" md-items=\"myobCustomer in vm.searchMyobCustomerByName(vm.searchText)\" md-item-text=\"vm.formatMyobCustomerName(myobCustomer)\" md-selected-item-change=\"vm.selectMyobCustomer(myobCustomer)\" md-selected-item=\"vm.myobCustomer\" md-min-length=\"0\" md-no-cache=\"true\" ng-required=\"true\" ng-disabled=\"!vm.isConnectedToMyob || vm.isMyobCustomerDisabled\"><md-item-template><span>{{ vm.formatMyobCustomerName(myobCustomer) }}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><div class=\"dropdown-instruction instruction-warning\" ng-if=\"vm.isMyobCustomerAutomatched\"><label>{{vm.automatchMessage}}</label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"!vm.isBusinessConnectedToMyob\"><label translate=\"COMPANYMODULE.INSTRUCTIONS.BUSINESS_HAS_NO_ACCOUNT\"></label></div><div class=\"dropdown-instruction instruction-warning loading\" ng-if=\"vm.isLoadingCompanies\"><label translate=\"COMPANYMODULE.INSTRUCTIONS.LOADING\"></label></div><md-autocomplete md-floating-label=\"{{\'COMPANYMODULE.MYOB_JOB_NUMBER\' | translate}}\" md-search-text=\"vm.jobSearchText\" md-items=\"myobJob in vm.searchMyobJob(vm.jobSearchText)\" md-item-text=\"vm.formatMyobJobName(myobJob)\" md-selected-item-change=\"vm.selectMyobJob(myobJob)\" md-selected-item=\"vm.myobJob\" md-min-length=\"0\" md-no-cache=\"true\" ng-disabled=\"!vm.isConnectedToMyob || vm.isMyobJobDisabled\"><md-item-template><span>{{ vm.formatMyobJobName(myobJob) }}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><div class=\"dropdown-instruction instruction-warning loading\" ng-if=\"vm.isLoadingJobs\"><label translate=\"COMPANYMODULE.INSTRUCTIONS.LOADING\"></label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"!vm.isConnectedToMyob\"><label translate=\"COMPANYMODULE.INSTRUCTIONS.NO_CONNECTION_FOUND\"></label> <label translate=\"COMPANYMODULE.INSTRUCTIONS.INTEGRATIONS_PAGE\" ng-click=\"vm.redirectToIntegrationsPage()\" class=\"clickable-item\"></label></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button translate=\"COMPANYMODULE.SAVE\" class=\"md-raised md-accent\" ng-disabled=\"myobCompanyForm.$invalid\" ng-click=\"vm.onDone()\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/company/create/companyDetails/myob-company/myob-company.html","<div><p class=\"md-subhead\" flex=\"100\" translate=\"COMPANYMODULE.MYOBCOMPANY.HEADER\"></p><div layout=\"column\" flex=\"100\" ng-if=\"vm.canManageClientCompanies\"><a href=\"#\" ng-click=\"vm.addMyobCompany()\" translate=\"COMPANYMODULE.MYOBCOMPANY.ADD_MYOBCOMPANY\"></a></div><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\"><thead><tr><th translate=\"COMPANYMODULE.MYOBCOMPANY.BRANCH\"></th><th translate=\"COMPANYMODULE.MYOBCOMPANY.MYOBCOMPANY\"></th><th translate=\"COMPANYMODULE.MYOBCOMPANY.MYOBJOB\"></th><th translate=\"COMPANYMODULE.MYOBCOMPANY.ACTIONS\" ng-if=\"vm.canManageClientCompanies\"></th></tr></thead><tbody><tr ng-repeat=\"myobCustomer in vm.ngModel.MyobCustomers\"><td>{{myobCustomer.BranchName}}</td><td>{{ vm.formatMyobCustomerName(myobCustomer) }}</td><td ng-style=\"{\'color\': (myobCustomer.isJobNotFound === true) ? \'red\' : \'black\'}\">{{ vm.formatMyobJobName(myobCustomer) }}</td><td ng-if=\"vm.canManageClientCompanies\"><md-icon md-font-icon=\"icon-pencil\" class=\"teal-500-fg\" ng-click=\"vm.addMyobCompany(myobCustomer)\"></md-icon><delete-component index=\"$index\" message=\"Are you sure you want to remove this MYOB Company?\" callback=\"vm.remove\" section=\"myobCompany\" candelete=\"vm.canManageClientCompanies\"></delete-component></td></tr></tbody></table></md-card-content></md-card><br></div>");
$templateCache.put("app/main/company/create/companyDetails/xero-company/xero-company.dialog.html","<md-dialog id=\"xeroCompanies-dialog\" class=\"provider-company-dialog\" aria-label=\"Add XeroCompanies\" flex=\"30\" ng-cloak=\"\"><form name=\"xeroCompanyForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"COMPANYMODULE.XEROCOMPANY.HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.branch\" placeholder=\"{{\'COMPANYMODULE.XEROCOMPANY.BRANCH\' | translate}}\" name=\"Branch\" ng-change=\"vm.onSelection()\" required=\"\"><md-option ng-repeat=\"branch in vm.branches\" ng-value=\"branch\">{{branch.Name}}</md-option></md-select><div ng-messages=\"xeroCompanyForm.Branch.$error\" role=\"alert\"><div ng-message=\"valid\">The selected branch already has a Xero Company assigned to it</div></div></md-input-container></div><div layout=\"column\"><md-autocomplete md-floating-label=\"{{\'COMPANYMODULE.XERO_CUSTOMER\' | translate}}\" md-search-text=\"vm.searchText\" md-items=\"xeroCustomer in vm.searchXeroCustomerByName(vm.searchText)\" md-item-text=\"vm.formatXeroCustomerName(xeroCustomer)\" md-selected-item-change=\"vm.selectXeroCustomer(xeroCustomer)\" md-selected-item=\"vm.xeroCustomer\" md-min-length=\"0\" md-no-cache=\"true\" ng-disabled=\"!vm.isConnectedToXero || vm.isXeroCustomerDisabled\"><md-item-template><span>{{ vm.formatXeroCustomerName(xeroCustomer) }}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><div class=\"dropdown-instruction instruction-warning\" ng-if=\"!vm.isConnectedToXero\"><label translate=\"COMPANYMODULE.INSTRUCTIONS.NO_CONNECTION_FOUND\"></label> <label translate=\"COMPANYMODULE.INSTRUCTIONS.INTEGRATIONS_PAGE\" ng-click=\"vm.redirectToIntegrationsPage()\" class=\"clickable-item\"></label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"vm.isXeroCustomerAutomatched\"><label>{{vm.automatchMessage}}</label></div><div class=\"dropdown-instruction instruction-warning\" ng-if=\"!vm.isBusinessConnectedToXero\"><label translate=\"COMPANYMODULE.INSTRUCTIONS.BUSINESS_HAS_NO_ACCOUNT\"></label></div><div class=\"dropdown-instruction instruction-warning loading\" ng-if=\"vm.isLoadingCompanies\"><label translate=\"COMPANYMODULE.INSTRUCTIONS.LOADING\"></label></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button translate=\"COMPANYMODULE.SAVE\" class=\"md-raised md-accent\" ng-disabled=\"xeroCompanyForm.$invalid\" ng-click=\"vm.onDone()\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/company/create/companyDetails/xero-company/xero-company.html","<div><p class=\"md-subhead\" flex=\"100\" translate=\"COMPANYMODULE.XEROCOMPANY.HEADER\"></p><div layout=\"column\" flex=\"100\" ng-if=\"vm.canManageClientCompanies\"><a href=\"#\" ng-click=\"vm.addXeroCompany()\" translate=\"COMPANYMODULE.XEROCOMPANY.ADD_XEROCOMPANY\"></a></div><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\"><thead><tr><th translate=\"COMPANYMODULE.XEROCOMPANY.BRANCH\"></th><th translate=\"COMPANYMODULE.XEROCOMPANY.XEROCOMPANY\"></th><th translate=\"COMPANYMODULE.XEROCOMPANY.ACTIONS\" ng-if=\"vm.canManageClientCompanies\"></th></tr></thead><tbody><tr ng-repeat=\"xeroCustomer in vm.ngModel.XeroCustomers\"><td>{{xeroCustomer.BranchName}}</td><td>{{ vm.formatXeroCustomerName(xeroCustomer) }}</td><td ng-if=\"vm.canManageClientCompanies\"><md-icon md-font-icon=\"icon-pencil\" class=\"teal-500-fg\" ng-click=\"vm.addXeroCompany(xeroCustomer)\"></md-icon><delete-component index=\"$index\" message=\"Are you sure you want to remove this Xero Company?\" callback=\"vm.remove\" section=\"xeroCompany\" candelete=\"vm.canManageClientCompanies\"></delete-component></td></tr></tbody></table></md-card-content></md-card><br></div>");
$templateCache.put("app/main/costEstimate/preview/dialogs/ce-confirm-dialog/ce-confirm-dialog.html","<md-dialog id=\"edit-cost-estimate-item\" aria-label=\"Confirm deletion\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h3>Deletion of Line Item</h3></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-content>Are you sure you want to delete this Cost Estimate Detail?</md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Cancel</md-button><md-button ng-click=\"vm.onYes()\">Yes</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/costEstimate/preview/dialogs/ce-line-item-val/ce-line-item-dialog.html","<md-dialog id=\"edit-cost-estimate-item\" aria-label=\"Cost Estimate Validation\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h3>Invalid Input</h3></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-content><span class=\"red-700-fg\">{{vm.desc}}</span></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/costEstimate/preview/dialogs/confirm-delete-checked-items/confirm-delete-cheked-items-dialog.html","<md-dialog id=\"edit-cost-estimate-item\" aria-label=\"Delete Cost Estimate\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h3>Deletion of Line Item(s)</h3></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-content>Are you sure you want to delete {{vm.desc}}?</md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Cancel</md-button><md-button ng-click=\"vm.onYes()\">Yes</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/costEstimate/preview/dialogs/edit-ce/ce-edit-line-item-dialog.html","<md-dialog id=\"edit-cost-estimate-item\" aria-label=\"Edite Cost Estimate\" flex=\"100\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span class=\"truncate-500\">Cost Estimate# {{vm.model.data.invoiceNo}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><ce-editable-line-item-component lineitems=\"vm.model.data.lineItems\" ratecarditems=\"vm.model.rateCardItems\" isaltusspecialenabled=\"vm.model.isAltusSpecialEnabled\" itemcodes=\"vm.model.itemCodes\" costcodes=\"vm.model.costCodesLookup\" onaddrow=\"vm.model.onAddRow\" ondelete=\"vm.model.onRemoveRow\" ontoggleedit=\"vm.model.onToggleEdit\" ondeleteselected=\"vm.model.onDeleteSelected\" onrefreshratecard=\"vm.model.onRefreshRateCard\" checkdescriptioncontroltype=\"vm.model.onCheckDescriptionControlType\" localization=\"vm.model.locale\" defaulttaxrate=\"vm.model.defaultTaxRate\" onedittaxrate=\"vm.model.onEditTaxRate\" oneditalltaxrate=\"vm.model.onEditAllTaxRate\" watch-depth=\"value\" onchangeitemcode=\"vm.model.onChangeItemCode\"></ce-editable-line-item-component><div class=\"red-500-fg text-center\" ng-show=\"vm.showLineItemValError\">* Provide at least one (1) line item to continue saving.</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\" class=\"md-raised\">Cancel</md-button><md-button ng-click=\"vm.onSave()\" ng-disabled=\"vm.model.disableSave\" class=\"md-accent md-raised\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/costEstimate/preview/directives/ceContent/ce-content-view.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"invContentVm.model.grid.api.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" ng-class=\"invContentVm.model.grid.api.busy ? \'toolbar-content-with-progress\' : \'toolbar-content\'\"><div layout=\"row\" layout-align=\"start center\"><ce-custom-grid-info-component src-data=\"invContentVm.model.gridInfo\" status=\"invContentVm.groupInfoModel.data.CostEstimateStatus\" status-text=\"invContentVm.groupInfoModel.data.CostEstimateStatusText\" view-cancelled=\"invContentVm.viewCancelled\"></ce-custom-grid-info-component></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-accent grey-50-fg md-raised\" aria-label=\"Book Job\" ng-click=\"invContentVm.bookJob()\" ng-hide=\"invContentVm.model.grid.data.length <= 0 || invContentVm.sideNavModel.isLocked || !invContentVm.sideNavModel.showRateCardItems()\">Book Job<md-tooltip><span>Book a job.</span></md-tooltip></md-button><md-button class=\"md-warn md-raised\" aria-label=\"PDF\" ng-click=\"invContentVm.markAsLost()\" ng-hide=\"invContentVm.model.grid.data.length <= 0 || invContentVm.sideNavModel.isLocked || !invContentVm.sideNavModel.showRateCardItems()\">Mark as lost<md-tooltip><span>Mark cost estimate as lost.</span></md-tooltip></md-button><div class=\"divider-vertical\"></div><md-button class=\"md-icon-button\" aria-label=\"View history logs\" ng-click=\"invContentVm.viewHistory(invContentVm.groupId, invContentVm.groupInfoModel.data.CompanyName)\"><md-icon md-font-icon=\"icon-history\"></md-icon><md-tooltip md-direction=\"bottom\">View History</md-tooltip></md-button><md-menu class=\"settings-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\" ng-disabled=\"invContentVm.model.contentLoading\"><md-icon md-font-icon=\"icon-filter\" ng-class=\"{ \'amber-700-fg\': invContentVm.viewMode != \'all\', \'\': invContentVm.viewMode == \'all\'}\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"invContentVm.showAll()\"><md-icon md-font-icon=\"{{invContentVm.viewMode == \'all\' ? \'icon-checkbox-marked\' : \'icon-checkbox-blank-outline\'}}\" class=\"md-accent\"></md-icon><span translate=\"INVOICE_REPORT.MENU1\">Show All</span></md-button></md-menu-item><md-menu-item hide-xs=\"\"><md-button ng-click=\"invContentVm.filterByReviewed()\"><md-icon md-font-icon=\"{{invContentVm.viewMode == \'byReviewed\' ? \'icon-checkbox-marked\' : \'icon-checkbox-blank-outline\'}}\" class=\"md-accent\"></md-icon><span translate=\"INVOICE_REPORT.MENU2\">Filter By Reviewed</span></md-button></md-menu-item><md-menu-item hide-xs=\"\"><md-button ng-click=\"invContentVm.notReviewed()\"><md-icon md-font-icon=\"{{invContentVm.viewMode == \'notReviewed\' ? \'icon-checkbox-marked\' : \'icon-checkbox-blank-outline\'}}\" class=\"md-accent\"></md-icon><span translate=\"INVOICE_REPORT.MENU3\">Not Reviewed</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><span id=\"anchor1\"></span><ce-item-list-component flex=\"100\"></ce-item-list-component><button class=\"btt-btn\" ng-click=\"invContentVm.gotoTop()\"><md-icon md-font-icon=\"icon-chevron-up\"></md-icon></button></md-content></div>");
$templateCache.put("app/main/costEstimate/preview/directives/customGridInfo/ce-custom-grid-info.html","<section><div class=\"action-buttons\" layout=\"row\" layout-align=\"start center\" hide=\"\" show-gt-xs=\"\"><div layout=\"row\" class=\"margin-right-5\"><span class=\"status padding-2 margin-top-0 md-grey-500-bg grey-50-fg\" ng-if=\"customGridInfoVm.viewCancelled\">Cancelled</span> <span class=\"status padding-2 margin-top-0 md-blue-500-bg grey-50-fg\" ng-if=\"customGridInfoVm.getStatusColor(customGridInfoVm.status) == 1 && !customGridInfoVm.viewCancelled\">{{ customGridInfoVm.statusText }}</span> <span class=\"status padding-2 margin-top-0 md-green-400-bg grey-50-fg\" ng-if=\"(customGridInfoVm.getStatusColor(customGridInfoVm.status) == 2 || customGridInfoVm.getStatusColor(customGridInfoVm.status) == 4) && !customGridInfoVm.viewCancelled\">{{ customGridInfoVm.statusText }}</span> <span class=\"status padding-2 margin-top-0 md-red-500-bg grey-50-fg\" ng-if=\"(customGridInfoVm.getStatusColor(customGridInfoVm.status) == 3 || customGridInfoVm.getStatusColor(customGridInfoVm.status) == 5 || customGridInfoVm.getStatusColor(customGridInfoVm.status) == 6) && !customGridInfoVm.viewCancelled\">{{ customGridInfoVm.statusText }}</span></div><div class=\"divider-vertical\"></div><strong class=\"margin-left-5\">Showing {{customGridInfoVm.srcData.totalItems}} <span ng-if=\"customGridInfoVm.srcData.inProgress\">+</span> <span ng-if=\"customGridInfoVm.srcData.totalItems > 1\">cost estimates</span> <span ng-if=\"customGridInfoVm.srcData.totalItems <= 1\">cost estimate</span> <span ng-if=\"customGridInfoVm.srcData.isFiltered\">(filtered from {{customGridInfoVm.srcData.rawTotalItemCount}} total entries)</span></strong></div></section>");
$templateCache.put("app/main/costEstimate/preview/winlost/company-select/company-select.html","<div flex=\"none\" flex-gt-sm=\"100\" flex-md=\"100\" flex-gt-md=\"100\" layout=\"row\"><form name=\"ClientAutoComplete\" flex=\"\" layout=\"row\"><md-autocomplete flex=\"\" ng-model-options=\"{ debounce: 500 }\" md-input-name=\"CompanyAutoCompleteField\" md-input-minlength=\"vm.minlength\" md-no-cache=\"true\" md-selected-item=\"vm.preSelect\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(vm.searchText)\" md-escape-options=\"\" md-clear-button=\"true\" md-item-text=\"item.Name\" md-floating-label=\"{{ vm.labelCaption }}\" ng-if=\"vm.showControl\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.Name}}</span></md-item-template><md-not-found><strong><a translate=\"COST_ESTIMATE.CLIENTNOTFOUND\"></a></strong></md-not-found><div ng-messages=\"ClientAutoComplete.Client.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"COST_ESTIMATE.CLIENTERROR\"></span></div></div></md-autocomplete><div layout=\"row\" layout-align=\"center center\" flex=\"10\" flex-sm=\"10\" ng-if=\"vm.allowAdd\"><md-button class=\"md-icon-button\" ng-click=\"vm.createCompetitor()\" aria-label=\"Crete Competitor\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><md-tooltip><span>Create new Competitor</span></md-tooltip></md-button></div></form></div>");
$templateCache.put("app/main/assets/manage/item/stockLevel/add-stock.html","<md-dialog aria-label=\"Add Stock\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"ASSETSMODULE.ADD_STOCK_HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"addStockVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"addStockForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"addStockVm.showBranch\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.ADD_STOCK_BRANCH\"></label><md-select name=\"stockBranch\" ng-model=\"addStockVm.branch\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-required=\"addStockVm.showBranch\"><md-option ng-repeat=\"itm in addStockVm.branches\" ng-value=\"itm\">{{itm.Name}}</md-option></md-select><div ng-messages=\"addStockForm.stockBranch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.ADD_STOCK_BRANCH_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.ADD_STOCK_ADD_TO_ITEM_TYPE\"></label><md-select name=\"stockItemType\" ng-model=\"addStockVm.itemType\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"itm in addStockVm.itemTypes\" ng-value=\"itm\">{{itm.Name}}</md-option></md-select><div ng-messages=\"addStockForm.stockItemType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.ADD_STOCK_ADD_TO_ITEM_TYPE_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.ADD_STOCK_QTY_TO_ADD\"></label> <input type=\"number\" name=\"qty\" ng-model=\"addStockVm.qty\" placeholder=\"0\" ng-pattern=\"/^\\d+$/\" required=\"\"><div ng-messages=\"addStockForm.qty.$error\" ng-show=\"addStockForm.qty.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.ADD_STOCK_QUANTITY_FIELD_IS_REQUIRED\"></span></div><div ng-message=\"number\"><span translate=\"ASSETSMODULE.ADD_STOCK_NOT_A_VALID_NUMBER\"></span></div><div ng-message=\"pattern\"><span translate=\"ASSETSMODULE.ADD_STOCK_NOT_A_VALID_NUMBER\"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"addStockVm.onCancel()\" translate=\"ASSETSMODULE.ADD_STOCK_CANCEL\"></md-button><md-button ng-click=\"addStockVm.onAdd()\" class=\"md-accent\" aria-label=\"Add\" ng-disabled=\"addStockForm.$invalid || addStockForm.$pristine\" translate=\"ASSETSMODULE.ADD_STOCK_ADD\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/item/stockLevel/convert-stock.html","<md-dialog aria-label=\"Convert Stock\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"ASSETSMODULE.CONVERT_STOCK_CONVERT_STOCK\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"convertStockVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"convertStockForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"convertStockVm.showBranch\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.CONVERT_STOCK_BRANCH\"></label><md-select name=\"stockBranch\" ng-model=\"convertStockVm.branch\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-required=\"convertStockVm.showBranch\"><md-option ng-repeat=\"itm in convertStockVm.branches\" ng-value=\"itm\">{{itm.Name}}</md-option></md-select><div ng-messages=\"convertStockForm.stockBranch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.CONVERT_STOCK_BRANCH_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.CONVERT_STOCK_CONVERT_FROM_ITEM_TYPE\"></label><md-select name=\"fromStockItemType\" ng-model=\"convertStockVm.fromItemType\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-change=\"convertStockVm.onConvertStockLevelChange()\" required=\"\"><md-option ng-repeat=\"itm in convertStockVm.fromItemTypes\" ng-value=\"itm\">{{itm.Name}}</md-option></md-select><div ng-messages=\"convertStockForm.fromStockItemType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.CONVERT_STOCK_FROM_ITEM_TYPE_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.CONVERT_STOCK_CONVERT_TO_ITEM_TYPE\"></label><md-select name=\"toStockItemType\" ng-model=\"convertStockVm.toItemType\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"itm in convertStockVm.toItemTypes\" ng-value=\"itm\">{{itm.Name}}</md-option></md-select><div ng-messages=\"convertStockForm.toStockItemType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.CONVERT_STOCK_TO_ITEM_TYPE_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.CONVERT_STOCK_QTY_TO_REMOVE\"></label> <input type=\"number\" name=\"qty\" ng-model=\"convertStockVm.qty\" placeholder=\"0\" ng-pattern=\"/^\\d+$/\" required=\"\"><div ng-messages=\"convertStockForm.qty.$error\" ng-show=\"convertStockForm.qty.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.CONVERT_STOCK_QUANTITY_FIELD_IS_REQUIRED\"></span></div><div ng-message=\"number\"><span translate=\"ASSETSMODULE.CONVERT_STOCK_NOT_A_VALID_NUMBER\"></span></div><div ng-message=\"pattern\"><span translate=\"ASSETSMODULE.CONVERT_STOCK_NOT_A_VALID_NUMBER\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.CONVERT_STOCK_REASON\"></label> <input type=\"text\" name=\"reason\" ng-model=\"convertStockVm.reason\" required=\"\"><div ng-messages=\"convertStockForm.reason.$error\" ng-show=\"convertStockForm.reason.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.CONVERT_STOCK_REASON_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"convertStockVm.onCancel()\" translate=\"ASSETSMODULE.CONVERT_STOCK_CANCEL\"></md-button><md-button ng-click=\"convertStockVm.onAdd()\" class=\"md-accent\" aria-label=\"Add\" ng-disabled=\"convertStockForm.$invalid || convertStockForm.$pristine\" translate=\"ASSETSMODULE.CONVERT_STOCK_ADD\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/item/stockLevel/remove-stock.html","<md-dialog aria-label=\"Remove Stock\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"ASSETSMODULE.REMOVE_STOCK_REMOVE_STOCK\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"removeStockVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"removeStockForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"removeStockVm.showBranch\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.REMOVE_STOCK_BRANCH\"></label><md-select name=\"removeStockBranch\" ng-model=\"removeStockVm.branch\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-required=\"addStockVm.showBranch\"><md-option ng-repeat=\"itm in removeStockVm.branches\" ng-value=\"itm\">{{itm.Name}}</md-option></md-select><div ng-messages=\"removeStockForm.removeStockBranch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.REMOVE_STOCK_BRANCH_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.REMOVE_STOCK_REMOVE_FROM_ITEM_TYPE\"></label><md-select name=\"itemType\" ng-model=\"removeStockVm.itemType\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"itm in removeStockVm.itemTypes\" ng-value=\"itm\">{{itm.Name}}</md-option></md-select><div ng-messages=\"removeStockForm.itemType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.REMOVE_STOCK_ITEM_TYPE_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.REMOVE_STOCK_QTY_TO_REMOVE\"></label> <input type=\"number\" name=\"qty\" ng-model=\"removeStockVm.qty\" placeholder=\"0\" ng-pattern=\"/^\\d+$/\" required=\"\"><div ng-messages=\"removeStockForm.qty.$error\" ng-show=\"removeStockForm.qty.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.REMOVE_STOCK_QUANTITY_FIELD_IS_REQUIRED\"></span></div><div ng-message=\"number\"><span translate=\"ASSETSMODULE.REMOVE_STOCK_NOT_A_VALID_NUMBER\"></span></div><div ng-message=\"pattern\"><span translate=\"ASSETSMODULE.REMOVE_STOCK_NOT_A_VALID_NUMBER\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.REMOVE_STOCK_REASON\"></label> <input type=\"text\" name=\"reason\" ng-model=\"removeStockVm.reason\" required=\"\"><div ng-messages=\"removeStockForm.reason.$error\" ng-show=\"removeStockForm.reason.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.REMOVE_STOCK_REASON_FIELD_IS_REQUIRED\"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"removeStockVm.onCancel()\" translate=\"ASSETSMODULE.REMOVE_STOCK_CANCEL\"></md-button><md-button ng-click=\"removeStockVm.onAdd()\" class=\"md-accent\" aria-label=\"Add\" ng-disabled=\"removeStockForm.$invalid || removeStockForm.$pristine\" translate=\"ASSETSMODULE.REMOVE_STOCK_REMOVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/assets/manage/item/stockLevel/stock-level.html","<div layout=\"column\" class=\"margin-bottom-20\" flex=\"100\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><div ng-form=\"stockLevelForm\" class=\"md-inline-form\" ng-show=\"stockLevelVm.model.isStockManagementVisible\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.ITEM_TRACK_INDIVIDUAL\"></label><md-select name=\"trackType\" ng-model=\"stockLevelVm.basicInfoModel.data.IndividualTrackingType\" ng-disabled=\"stockLevelVm.model.isTrackIndividualDisabled\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"stockLevelVm.onIndividualTrackingTypeChange()\" required=\"\"><md-option ng-repeat=\"indvTrackingType in stockLevelVm.individualTrackingTypesLookup\" ng-value=\"indvTrackingType\">{{indvTrackingType.Name}}</md-option></md-select><div ng-messages=\"stockLevelForm.trackType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.ITEM_TRACK_INDIVIDUAL_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.ITEM_STOCK_LEVEL_TRACKING\"></label><md-select name=\"stockLevelTracking\" ng-model=\"stockLevelVm.model.data.StockLevelTracking\" ng-disabled=\"stockLevelVm.model.isStockLevelTrackingDisabled\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-change=\"stockLevelVm.onStockLevelTrackingChange()\" required=\"\"><md-option ng-repeat=\"stockLevelTrack in stockLevelVm.itemTrackingLookup\" ng-value=\"stockLevelTrack\">{{stockLevelTrack.Name}}</md-option></md-select><div ng-messages=\"stockLevelForm.stockLevelTracking.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.ITEM_STOCK_LEVEL_TRACKING_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"stockLevelVm.model.isStockLevelCountsVisible\"><md-input-container flex=\"\" ng-show=\"stockLevelVm.model.isAssetSLCVisible\"><label translate=\"ASSETSMODULE.ITEM_STOCK_LEVEL_ASSETS\"></label> <input type=\"text\" name=\"assets\" ng-model=\"stockLevelVm.model.data.StockLevelByCount.Assets\" class=\"stock-qty\" placeholder=\"0\" ng-disabled=\"true\" required=\"\"></md-input-container><md-input-container flex=\"\" ng-show=\"stockLevelVm.model.isInventorySLCVisible\"><label translate=\"ASSETSMODULE.ITEM_STOCK_LEVEL_INVENTORY\"></label> <input type=\"text\" name=\"inventory\" ng-model=\"stockLevelVm.model.data.StockLevelByCount.Inventory\" class=\"stock-qty\" placeholder=\"0\" ng-disabled=\"true\" required=\"\"></md-input-container><md-input-container flex=\"\" ng-show=\"stockLevelVm.model.isPeopleSLCVisible\"><label translate=\"ASSETSMODULE.ITEM_STOCK_LEVEL_PEOPLE\"></label> <input type=\"text\" name=\"people\" ng-model=\"stockLevelVm.model.data.StockLevelByCount.People\" class=\"stock-qty\" placeholder=\"0\" ng-disabled=\"true\" required=\"\"></md-input-container></div><div class=\"scroll-container md-whiteframe-1dp padding-5 margin-bottom-10\" ng-show=\"stockLevelVm.model.isStockLevelCountsByBranchVisible\" ms-scroll=\"\"><div ng-repeat=\"branchItm in stockLevelVm.model.data.StockLevelByBranches\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><strong>{{branchItm.Branch}}</strong></md-input-container><md-input-container flex=\"\" ng-show=\"stockLevelVm.model.isAssetSLCbyBranchVisible\"><label translate=\"ASSETSMODULE.ITEM_STOCK_LEVEL_ASSETS\"></label> <input type=\"text\" name=\"assets\" ng-model=\"branchItm.Assets\" class=\"stock-qty\" placeholder=\"0\" ng-disabled=\"true\" required=\"\"></md-input-container><md-input-container flex=\"\" ng-show=\"stockLevelVm.model.isInventorySLCbyBranchVisible\"><label translate=\"ASSETSMODULE.ITEM_STOCK_LEVEL_INVENTORY\"></label> <input type=\"text\" name=\"inventory\" ng-model=\"branchItm.Inventory\" class=\"stock-qty\" placeholder=\"0\" ng-disabled=\"true\" required=\"\"></md-input-container><md-input-container flex=\"\" ng-show=\"stockLevelVm.model.isPeopleSLCbyBranchVisible\"><label translate=\"ASSETSMODULE.ITEM_STOCK_LEVEL_PEOPLE\"></label> <input type=\"text\" name=\"people\" ng-model=\"branchItm.People\" class=\"stock-qty\" placeholder=\"0\" ng-disabled=\"true\" required=\"\"></md-input-container></div></div></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.ITEM_LOW_STOCK_NOTIF\"></label><md-select name=\"lowStockNotif\" ng-model=\"stockLevelVm.basicInfoModel.data.LowStockNotification\" ng-change=\"stockLevelVm.onLowStockLevelChange()\" required=\"\"><md-option ng-repeat=\"lowStockNotif in stockLevelVm.lowStockNotificationsLookup\" value=\"{{lowStockNotif}}\">{{lowStockNotif}}</md-option></md-select><div ng-messages=\"stockLevelForm.lowStockNotif.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.ITEM_LOW_STOCK_NOTIF_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"stockLevelVm.model.isLowStockNotifVisible && (stockLevelVm.model.isAssetSLCVisible || stockLevelVm.model.isInventorySLCVisible || stockLevelVm.model.isPeopleSLCVisible)\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><div class=\"padding-top-10\"><md-input-container flex=\"30\" ng-if=\"stockLevelVm.model.isAssetSLCVisible\"><label translate=\"ASSETSMODULE.LOW_ASSET_WARNING\"></label> <input type=\"text\" name=\"assetWarning\" ng-model=\"stockLevelVm.basicInfoModel.data.LowAssetWarning\" placeholder=\"0\"></md-input-container><md-input-container flex=\"40\" ng-if=\"stockLevelVm.model.isInventorySLCVisible\"><label translate=\"ASSETSMODULE.LOW_INVENTORY_WARNING\"></label> <input type=\"text\" name=\"inventoryWarning\" ng-model=\"stockLevelVm.basicInfoModel.data.LowInventoryWarning\" placeholder=\"0\"></md-input-container><md-input-container flex=\"30\" ng-if=\"stockLevelVm.model.isPeopleSLCVisible\"><label translate=\"ASSETSMODULE.LOW_PEOPLE_WARNING\"></label> <input type=\"text\" name=\"peopleWarning\" ng-model=\"stockLevelVm.basicInfoModel.data.LowPeopleWarning\" placeholder=\"0\"></md-input-container></div></div></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label translate=\"ASSETSMODULE.VEHICLE_UTILISATION_DAILY_TARGET\"></label> <input type=\"number\" name=\"UtilisationTarget\" max=\"24\" ng-model=\"stockLevelVm.basicInfoModel.data.UtilisationTarget\" required=\"\"><div ng-messages=\"stockLevelForm.UtilisationTarget.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ASSETSMODULE.VEHICLE_UTILISATION_DAILY_TARGET_IS_REQUIRED\"></span></div><div ng-message=\"max\"><span translate=\"ASSETSMODULE.VEHICLE_UTILISATION_DAILY_TARGET_MAX\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container><div style=\"margin-bottom: 20px; padding-bottom: 20px;\"><label translate=\"ASSETSMODULE.VEHICLE_UTILISATION_TRACKING_DAYS\"></label></div><div ng-repeat=\"day in stockLevelVm.daysOfTheWeek track by $index\" flex=\"auto\"><md-checkbox class=\"md-raised md-accent pull-left\" style=\"margin-left: 20px; margin-top: 0; margin-bottom: 0;\" ng-checked=\"stockLevelVm.isTrackingDaySelected($index)\" ng-click=\"stockLevelVm.toggleTrackingDays($index)\">{{ day }}</md-checkbox></div></md-input-container></div></div></div></div></div>");
$templateCache.put("app/main/costEstimate/preview/winlost/create-competitor/create-competitor-dialog.html","<md-dialog flex=\"25\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Create Competitor</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"competitorManageDialogForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"competitor\" ng-model=\"vm.inputModel.companyName\" placeholder=\"Company Competitor Name\" md-autofocus=\"\" required=\"\"><div ng-messages=\"competitorManageDialogForm.competitor.$error\" ng-show=\"competitorManageDialogForm.competitor.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Competitor name is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Branches</label><md-select name=\"branch\" ng-model=\"vm.inputModel.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"Branch\" multiple=\"\" required=\"\"><md-optgroup label=\"Branch\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchesLookup\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\" translate=\"COST_ESTIMATE.COMPANYPOPUPCANCELTEXT\"></md-button><md-button class=\"md-accent\" aria-label=\"Update cost estimate Win Lost\" ng-click=\"vm.onUpdate()\" translate=\"COST_ESTIMATE.UPDATE\" ng-disabled=\"competitorManageDialogForm.$invalid\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/costEstimate/view/directive/ce-report-filter/ce-report-filter.html","<div layout=\"row\" layout-align=\"start center\"><div flex=\"20\"><div layout=\"row\"><md-input-container><label translate=\"INVOICE_REPORT.BRANCHES\"></label><md-select name=\"branches\" ng-model=\"invReportFilterVm.model.data.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'INVOICE_REPORT.BRANCHES\' | translate}}\" multiple=\"\"><md-optgroup label=\"{{\'INVOICE_REPORT.STATES\' | translate}}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in invReportFilterVm.model.branchLookups | filter:{State: null}\">{{branch.Name}}</md-option></md-optgroup><md-optgroup label=\"{{\'INVOICE_REPORT.BRANCHES\' | translate}}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in invReportFilterVm.model.branchLookups | filter:{State: \'!!\'}\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div flex=\"10\" class=\"margin-left-10\"><div layout=\"row\"><md-input-container class=\"cancelled-ce\" flex=\"\"><md-checkbox ng-model=\"invReportFilterVm.model.data.cancelledCostEstimate\">Show Cancelled CE</md-checkbox></md-input-container></div></div><div flex=\"\" flex-offset=\"5\"><md-input-container><md-button class=\"md-raised md-accent button-margin\" ng-click=\"invReportFilterVm.applyFilter()\">FILTER</md-button><md-button class=\"md-raised md-accent button-margin\" ng-click=\"invReportFilterVm.resetFilter()\">RESET</md-button></md-input-container></div></div>");
$templateCache.put("app/main/contact/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex=\"\"></span><md-button class=\"view-history-button md-fab\" ng-click=\"vm.viewHistory(vm.calendarEvent)\" aria-label=\"View history\"><md-icon md-font-icon=\"icon-history\"></md-icon></md-button><md-button class=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate=\"\" translate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex=\"\" ng-if=\"!vm.calendarEvent.IsAllDayEvent\"><span class=\"h4\">{{vm.start_time}} <span ng-if=\"vm.end_time\">-</span> {{vm.end_time}}</span></div><div layout=\"column\" flex=\"\" ng-if=\"vm.calendarEvent.IsAllDayEvent\"><span class=\"h4\">{{vm.calendarEvent.start | moment: \'MMMM Do YYYY\'}}(All Day) <span ng-if=\"vm.calendarEvent.end\">-</span> {{vm.calendarEvent.end.subtract(1) | moment: \'MMMM Do YYYY\'}}(All Day)</span></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/contact/calendar/calendar-entry/add/add-contact-calendar.html","<div class=\"add-calendar-entry\" layout=\"column\" flex=\"\"><div class=\"content md-padding\" flex=\"\" style=\"overflow: auto\"><form name=\"bulkCreateCalendar\" a8-dirty-form-confirmation=\"\" flex=\"\"><div layout-xl=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-xl=\"100\"><label>Branch(es)</label><md-select placeholder=\"Branch(es)\" multiple=\"\" name=\"Branches\" ng-model=\"addVm.branches\" ng-model-options=\"{trackBy : \'$value.Id\'}\" md-on-close=\"addVm.getDivisionByBranches(addVm.branches)\" md-container-class=\"add-calendar-select-container\" ng-required=\"true\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch\" ng-repeat=\"branch in addVm.Branches\">{{branch.Name}}</md-option></md-optgroup></md-select><div ng-messages=\"personal.Branches.$error\" role=\"alert\"><div ng-message=\"required\"><span>Branch is required.</span></div></div></md-input-container></div><div layout-xl=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" ng-if=\"addVm.branches.length > 0\" flex-xl=\"100\"><label>Division(s)</label><md-select placeholder=\"Division(s)\" multiple=\"\" md-on-close=\"addVm.getEmployeesbyBranchOrDivision(addVm.divisions)\" ng-model=\"addVm.divisions\" md-container-class=\"add-calendar-select-container\" ng-model-options=\"{trackBy : \'$value.id\'}\"><md-optgroup label=\"Divisions\"><md-option ng-value=\"division\" ng-repeat=\"division in addVm.Divisions\">{{division.Name}} - [{{division.branchName}}]</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\" ng-if=\"addVm.branches.length > 0\"><label></label><md-contact-chips flex=\"\" ng-required=\"true\" name=\"employee\" ng-model=\"addVm.employees\" md-contacts=\"addVm.querySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"Add one or more people by typing their name\" secondary-placeholder=\"Add one or more people by typing their name\"></md-contact-chips></md-input-container></div><div layout=\"row\" flex-xs=\"100\" flex-xl=\"50\" ng-if=\"addVm.branches.length > 0\"><md-input-container class=\"md-block\"><label>Entry Type</label><md-select name=\"EntryType\" ng-model=\"addVm.EntryType\" ng-required=\"true\" aria-label=\"Entry Type\" md-container-class=\"add-calendar-select-container\" placeholder=\"Entry Type\"><md-option ng-repeat=\"type in addVm.EntryTypeLookup\" ng-value=\"type.Id\">{{type.Value}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex-xs=\"100\" flex-xl=\"100\" ng-if=\"addVm.EntryType === 0 || addVm.EntryType === 1\"><md-input-container class=\"md-block\"><label>Reason for Unavailability</label><md-select name=\"EntryReason\" md-container-class=\"add-calendar-select-container\" ng-model=\"addVm.EntryReason\" ng-required=\"addVm.EntryType === 0 || addVm.EntryType === 1\" aria-label=\"Reason for Unavailability\" placeholder=\"Reason for Unavailability\"><md-option ng-value=\"1\">Illness</md-option><md-option ng-value=\"2\">Unapproved</md-option><md-option ng-value=\"3\" ng-if=\"addVm.EntryType === 0\">Vacation</md-option><md-option ng-value=\"4\" ng-if=\"addVm.EntryType === 1\">Emergency</md-option><md-option ng-value=\"10\" ng-if=\"addVm.EntryType === 0\">Fatigue</md-option><md-option ng-value=\"7\">Other</md-option></md-select></md-input-container></div><div layout=\"row\" flex-xs=\"100\" flex-xl=\"100\" ng-if=\"addVm.EntryType === 0 || addVm.EntryType === 1\"><md-input-container class=\"md-block\"><input autocomplete=\"off\" type=\"text\" name=\"Remarks\" ng-model=\"addVm.Remarks\" placeholder=\"Remarks\" maxlength=\"50\"></md-input-container></div><div ng-if=\"addVm.EntryType != null\"><div layout-xl=\"row\" layout-xs=\"column\" class=\"date-row\" flex-xs=\"100\" flex-xl=\"50\"><div layout-xl=\"column\" layout-xs=\"row\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\"><md-switch class=\"md-secondary\" ng-model=\"addVm.dateTimeRangeOption\" ng-change=\"addVm.onSelectOption(\'Date/Time Range\')\" aria-label=\"Date/Time Range\">Date and time range (One off)</md-switch></div><div layout-xl=\"column\" layout-xs=\"row\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\"><md-switch class=\"md-secondary\" ng-model=\"addVm.allDayOption\" ng-change=\"addVm.onSelectOption(\'All Day\')\" aria-label=\"All Day\">One or more full days (One off)</md-switch></div></div><div layout-xl=\"row\" layout-xs=\"column\" class=\"date-row\" flex-xs=\"100\" flex-xl=\"50\"><div layout-xl=\"column\" layout-xs=\"row\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\"><md-switch class=\"md-secondary\" ng-model=\"addVm.repeatPeriodOption\" ng-change=\"addVm.onSelectOption(\'Repeat Period\')\" aria-label=\"Repeat Period\">Repeated date and time range (Weekly)</md-switch></div><div layout-xl=\"column\" layout-xs=\"row\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\"><md-switch class=\"md-secondary\" ng-model=\"addVm.recurring\" ng-change=\"addVm.onSelectOption(\'Repeat in Specific Day\')\" aria-label=\"Repeat in Specific Day\">Repeated times on specific days</md-switch></div></div><div layout=\"row\" class=\"date-row\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"{{addVm.showTheEndDate ? 35:20}}\"><md-input-container class=\"md-block\" flex=\"{{addVm.showTheEndDate ? 40:70}}\"><label>Start Date</label><md-datepicker ng-change=\"addVm.validateDate(\'start\')\" ng-model=\"addVm.start\" md-placeholder=\"Start Date\" ng-required=\"true\" ng-blur=\"addVm.processDependency(addVm.start)\"></md-datepicker></md-input-container><div layout=\"row\" ng-if=\"!addVm.recurring\" layout-align=\"start center\"><md-button ng-if=\"!addVm.showTheEndDate\" class=\"md-icon-button md-primary action-button\" aria-label=\"Show End Date\" ng-click=\"addVm.showEndDate()\"><i class=\"icon icon-calendar-plus blue-500-fg s28\"><md-tooltip>Show End Date</md-tooltip></i></md-button><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" ng-if=\"addVm.showTheEndDate\"><label>End Date</label><md-datepicker ng-change=\"addVm.validateDate(\'end\')\" ng-model=\"addVm.end\" md-placeholder=\"End Date\" ng-blur=\"addVm.processDependency(addVm.start)\"></md-datepicker></md-input-container><md-button ng-if=\"addVm.showTheEndDate\" class=\"md-icon-button md-primary action-button\" aria-label=\"Hide End Date\" ng-click=\"addVm.showEndDate()\"><i class=\"icon icon-calendar-remove red-500-fg s28\"><md-tooltip>Hide End Date</md-tooltip></i></md-button></div></div></div><div layout=\"row\" ng-if=\"!addVm.allDayOption\" flex=\"\" layout-align=\"start center\"><md-input-container flex-xs=\"50\" flex-sm=\"50\" flex-md=\"25\" flex-lg=\"15\" flex-xl=\"15\" md-no-float=\"\"><label>Start Time</label> <input type=\"text\" time-picker=\"\" ng-model=\"addVm.startTime\" ng-blur=\"addVm.computeEndDate(\'start\')\" placeholder=\"Start Time\" ng-required=\"true\"></md-input-container><md-input-container flex-xs=\"50\" flex-sm=\"50\" flex-md=\"25\" flex-lg=\"15\" flex-xl=\"15\" md-no-float=\"\"><label>End Time</label> <input type=\"text\" time-picker=\"\" ng-model=\"addVm.endTime\" ng-blur=\"addVm.computeEndDate(\'end\')\" placeholder=\"End Time\" ng-required=\"true\"></md-input-container></div></div></div><div ng-if=\"addVm.recurring || addVm.repeatPeriodOption\" class=\"md-block\" flex=\"\"><fieldset class=\"demo-fieldset\"><md-input-container ng-if=\"addVm.recurring\" class=\"md-block\" flex-sm=\"100\" flex-md=\"75\" flex-lg=\"50\" flex-xl=\"50\"><legend class=\"demo-legend\">Repeat Type</legend><md-select name=\"RepeatType\" ng-model=\"addVm.Repeats.RepeatType\" ng-required=\"true\" ng-change=\"addVm.onSelectRepeatType()\" aria-label=\"Repeat Type\"><md-option ng-repeat=\"type in addVm.RepeatTypeLookup\" ng-value=\"type.Id\">{{type.Value}}</md-option></md-select></md-input-container><md-input-container ng-if=\"addVm.recurring\" class=\"md-block\" flex-sm=\"100\" flex-md=\"75\" flex-lg=\"50\" flex-xl=\"50\"><legend class=\"demo-legend\">Repeat Every</legend><md-select name=\"RepeatEvery\" ng-model=\"addVm.Repeats.RepeatEvery\" ng-required=\"true\" aria-label=\"Repeat Every\"><md-option ng-repeat=\"value in addVm.RepeatEvery\" ng-value=\"value\">{{value}} - {{addVm.convertToRepeatTypeValue(addVm.Repeats.RepeatType)}}</md-option></md-select></md-input-container><md-input-container ng-if=\"addVm.Repeats.RepeatType === 1 && addVm.recurring\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Repeats On</legend><div layout=\"row\" flex=\"\"><div><md-checkbox aria-label=\"Select All\" ng-checked=\"addVm.isChecked()\" md-indeterminate=\"addVm.isIndeterminate()\" ng-click=\"addVm.toggleAll()\"><span ng-if=\"addVm.isChecked()\">Diss</span><span ng-if=\"!addVm.isChecked()\">S</span>elect All</md-checkbox></div></div><div layout=\"row\" flex=\"\" style=\"font-size:12px\"><div class=\"demo-select-all-checkboxes\" flex=\"15\" ng-repeat=\"day in addVm.dayInWeek\"><md-checkbox ng-checked=\"addVm.exists(day, addVm.repeat)\" ng-click=\"addVm.toggle(day, addVm.repeat)\"><span ng-bind=\"addVm.convertToDayName(day)\"></span></md-checkbox></div></div></fieldset></md-input-container><div layout=\"row\"><legend class=\"demo-legend\">Ends On</legend></div><div layout=\"row\"><div layout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"addVm.Repeats.EndsOn\" md-placeholder=\"Ends On\"></md-datepicker></div></div></fieldset></div></form></div><div class=\"md-whiteframe-2dp pt-5 pl-20 pr-20 pb-20 layout-row\" style=\"margin: 0 -20px -20px -20px; background: #fff;\"><md-button class=\"md-raised md-accent\" ng-disabled=\"bulkCreateCalendar.$invalid || addVm.branches.length === 0 || !addVm.hasSelected || bulkCreateCalendar.employee.$viewValue.length === 0\" ng-click=\"addVm.bulkSave()\">SAVE</md-button><md-button class=\"md-raised md-accent\" ng-click=\"addVm.goToContactView()\">View Contacts</md-button></div></div>");
$templateCache.put("app/main/company/create/award/component/company-award.dialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"30\" ng-cloak=\"\"><form name=\"awardForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"COMPANYMODULE.COMPANY_AWARDS_HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.branch\" placeholder=\"{{\'COMPANYMODULE.COMPANY_AWARDS_COLUMN_BRANCH\' | translate}}\" name=\"Branch\" ng-change=\"vm.onSelection()\" required=\"\"><md-option ng-repeat=\"branch in vm.branches\" ng-value=\"branch\">{{branch.Name}}</md-option></md-select><div ng-messages=\"awardForm.Branch.$error\" role=\"alert\"><div ng-message=\"valid\">The selected branch already has an award assigned to it</div></div></md-input-container></div><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.award\" placeholder=\"{{\'COMPANYMODULE.COMPANY_AWARDS_COLUMN_AWARD\' | translate}}\" name=\"Award\" required=\"\"><md-option ng-repeat=\"award in vm.awards\" ng-disabled=\"award.IsArchived\" ng-value=\"award\">{{award.Name}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button translate=\"COMPANYMODULE.COMPANY_INVOICE_TERMS_SAVE\" class=\"md-raised md-accent\" ng-disabled=\"awardForm.$invalid\" ng-click=\"vm.onDone()\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/company/create/award/component/company-award.html","<div><p class=\"md-subhead\" flex=\"100\" translate=\"COMPANYMODULE.COMPANY_AWARDS_HEADER\"></p><div layout=\"column\" flex=\"100\" ng-if=\"vm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\"><a href=\"#\" ng-click=\"vm.addAward()\" translate=\"COMPANYMODULE.COMPANY_AWARDS_HEADER_LINK\"></a></div><md-card><md-card-content><table class=\"simple kit-item-table\" ms-responsive-table=\"\" datatable=\"ng\"><thead><tr><th translate=\"COMPANYMODULE.COMPANY_AWARDS_COLUMN_BRANCH\"></th><th translate=\"COMPANYMODULE.COMPANY_AWARDS_COLUMN_AWARD\"></th><th translate=\"COMPANYMODULE.COMPANY_AWARDS_COLUMN_ACTIONS\" ng-if=\"vm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\"></th></tr></thead><tbody><tr ng-repeat=\"award in vm.ngModel.Awards\" ng-show=\"!award.IsDeleted\"><td>{{award.BranchName}}</td><td>{{award.Award.Name}}</td><td ng-if=\"vm.checkAccessService.checkAccessByRole(\'Manage Client Companies\')\"><md-icon md-font-icon=\"icon-pencil\" class=\"teal-500-fg\" ng-click=\"vm.addAward(award)\"></md-icon><delete-component index=\"$index\" message=\"Are you sure you want to remove this award?\" callback=\"vm.remove(award)\" section=\"Award\"></delete-component></td></tr></tbody></table></md-card-content></md-card><br></div>");
$templateCache.put("app/main/company/create/award/component/company-update-award.dialog.html","<md-dialog id=\"company-update-award-dialog\" aria-label=\"Update Company Award\" flex=\"30\" ng-cloak=\"\"><form name=\"updateCompanyAwardForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"COMPANYMODULE.COMPANY_UPDATE_AWARD\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\">This award change will impact all future jobs for this company.<br>Do you want to update existing jobs for the following branch(es)?</div><div layout=\"row\" ng-repeat=\"award in vm.Awards\"><div layout=\"column\"><p><b>{{award.BranchName}}</b></p><div ng-init=\"award.AwardUpdateCondition=\'FromToday\'\"><label><input type=\"radio\" ng-model=\"award.AwardUpdateCondition\" value=\"FromToday\"> Apply from today</label><br><label><input type=\"radio\" ng-model=\"award.AwardUpdateCondition\" value=\"ForAllUnbilledJobs\"> Apply to all unbilled jobs</label></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button translate=\"COMPANYMODULE.CANCEL\" class=\"md-raised md-accent\" ng-click=\"vm.onCancel()\"></md-button><md-button translate=\"COMPANYMODULE.SAVE\" class=\"md-raised md-accent\" ng-disabled=\"updateCompanyAwardForm.$invalid\" ng-click=\"vm.onSave()\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contact/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><md-select name=\"EntryType\" ng-model=\"vm.calendarEvent.EntryType\" ng-change=\"vm.calendarEvent.EntryReason = \'\'\" ng-required=\"true\" aria-label=\"Entry Type\" placeholder=\"Entry Type\"><md-option ng-repeat=\"type in vm.EntryTypeLookup\" ng-value=\"type.Id\">{{type.Value}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.calendarEvent.EntryType === 0 || vm.calendarEvent.EntryType === 1\"><md-select name=\"EntryReason\" ng-model=\"vm.calendarEvent.EntryReason\" ng-required=\"vm.calendarEvent.EntryType === 0 || vm.calendarEvent.EntryType === 1\" aria-label=\"Reason for {{vm.calendarEvent.EntryType === 0 ? \'Unavailability\' : (vm.calendarEvent.EntryType === 1 ? \'Rejection\' : \'\')}}\" placeholder=\"Reason for {{vm.calendarEvent.EntryType === 0 ? \'Unavailability\' : (vm.calendarEvent.EntryType === 1 ? \'Rejection\' : \'\')}}\"><md-option ng-value=\"1\" ng-if=\"vm.dialogData.isContact\">Illness</md-option><md-option ng-value=\"2\" ng-if=\"vm.dialogData.isContact\">Unapproved</md-option><md-option ng-value=\"3\" ng-if=\"vm.dialogData.isContact && vm.calendarEvent.EntryType === 0\">Vacation</md-option><md-option ng-value=\"4\" ng-if=\"vm.dialogData.isContact && vm.calendarEvent.EntryType === 1\">Emergency</md-option><md-option ng-value=\"5\" ng-if=\"!vm.dialogData.isContact\">Damaged</md-option><md-option ng-value=\"6\" ng-if=\"!vm.dialogData.isContact\">Scheduled Service</md-option><md-option ng-value=\"8\" ng-if=\"vm.dialogData.isContact && vm.calendarEvent.EntryType === 1\">Did Not Reply</md-option><md-option ng-value=\"9\" ng-if=\"vm.dialogData.isContact && vm.calendarEvent.EntryType === 1\">Rejected via Messaging</md-option><md-option ng-value=\"10\" ng-if=\"vm.calendarEvent.EntryType === 0\">Fatigue</md-option><md-option ng-value=\"7\">Other</md-option></md-select></md-input-container><div layout=\"row\" flex-xs=\"100\" flex-xl=\"100\" ng-if=\"vm.calendarEvent.EntryType === 0 || vm.calendarEvent.EntryType === 1\"><md-input-container class=\"md-block\"><input autocomplete=\"off\" type=\"text\" name=\"Remarks\" ng-model=\"vm.calendarEvent.Remarks\" placeholder=\"Remarks\" maxlength=\"50\"></md-input-container></div><div layout=\"row\" class=\"date-row\"><div layout=\"column\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\"><md-switch class=\"md-secondary\" ng-model=\"vm.dateTimeRangeOption\" ng-change=\"vm.onSelectOption(\'Date/Time Range\')\" aria-label=\"Date/Time Range\">Date and time range (One off)</md-switch></div><div layout=\"column\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\"><md-switch class=\"md-secondary\" ng-model=\"vm.allDayOption\" ng-change=\"vm.onSelectOption(\'All Day\')\" aria-label=\"All Day\">One or more full days (One off)</md-switch></div></div><div layout=\"row\" class=\"date-row\"><div layout=\"column\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\"><md-switch class=\"md-secondary\" ng-model=\"vm.repeatPeriodOption\" ng-change=\"vm.onSelectOption(\'Repeat Period\')\" aria-label=\"Date/Time Range\">Repeated date and time range (Weekly)</md-switch></div><div layout=\"column\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\"><md-switch class=\"md-secondary\" ng-model=\"vm.recurring\" ng-change=\"vm.onSelectOption(\'Repeat in Specific Day\')\" aria-label=\"All Day\">Repeated times on specific days</md-switch></div></div><div layout=\"row\" class=\"date-row\"><div layout=\"row\"><md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\" ng-change=\"vm.validateDate(\'start\')\" ng-required=\"true\" ng-blur=\"vm.processDependency(vm.calendarEvent.start)\"></md-datepicker></div><div layout=\"row\" ng-if=\"!vm.recurring\"><md-button ng-if=\"!vm.showTheEndDate\" class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.showEndDate()\"><i class=\"icon icon-calendar-plus blue-500-fg s28\"><md-tooltip>Show End Date</md-tooltip></i></md-button><md-datepicker ng-if=\"vm.showTheEndDate\" ng-change=\"vm.validateDate(\'end\')\" ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\" ng-blur=\"vm.processDependency(vm.calendarEvent.start)\"></md-datepicker><md-button ng-if=\"vm.showTheEndDate\" class=\"md-icon-button md-primary action-button\" aria-label=\"Settings\" ng-click=\"vm.showEndDate()\"><i class=\"icon icon-calendar-remove red-500-fg s28\"><md-tooltip>Hide End Date</md-tooltip></i></md-button></div><div layout=\"row\" ng-if=\"!vm.allDayOption\" flex=\"\"><md-input-container flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\" md-no-float=\"\"><input type=\"text\" time-picker=\"\" ng-model=\"vm.calendarEvent.startTime\" ng-blur=\"vm.computeEndDate(\'start\')\" placeholder=\"Start Time\" ng-required=\"true\"></md-input-container><md-input-container flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\" md-no-float=\"\"><input type=\"text\" time-picker=\"\" ng-model=\"vm.calendarEvent.endTime\" ng-blur=\"vm.computeEndDate(\'end\')\" placeholder=\"End Time\" ng-required=\"true\"></md-input-container></div></div><div ng-if=\"vm.recurring || vm.repeatPeriodOption\" class=\"md-block\" flex=\"\"><fieldset class=\"demo-fieldset\"><md-input-container ng-if=\"vm.recurring\" class=\"md-block\" flex-sm=\"100\" flex-md=\"75\" flex-lg=\"50\" flex-xl=\"50\"><legend class=\"demo-legend\">Repeat Type</legend><md-select name=\"RepeatType\" ng-model=\"vm.calendarEvent.Repeats.RepeatType\" ng-required=\"true\" ng-change=\"vm.onSelectRepeatType()\" aria-label=\"Repeat Type\"><md-option ng-repeat=\"type in vm.RepeatTypeLookup\" ng-value=\"type.Id\">{{type.Value}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.recurring\" class=\"md-block\" flex-sm=\"100\" flex-md=\"75\" flex-lg=\"50\" flex-xl=\"50\"><legend class=\"demo-legend\">Repeat Every</legend><md-select name=\"RepeatEvery\" ng-model=\"vm.calendarEvent.Repeats.RepeatEvery\" ng-required=\"true\" aria-label=\"Repeat Every\" placeholder=\"\"><md-option ng-repeat=\"value in vm.RepeatEvery\" ng-value=\"value\">{{value}} - {{vm.convertToRepeatTypeValue(vm.calendarEvent.Repeats.RepeatType)}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.calendarEvent.Repeats.RepeatType === 1 && vm.recurring\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Repeats On</legend><div layout=\"row\" flex=\"\"><div><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"><span ng-if=\"vm.isChecked()\">Diss</span><span ng-if=\"!vm.isChecked()\">S</span>elect All</md-checkbox></div><br></div><div layout=\"row\" flex=\"\" style=\"font-size:12px\"><div class=\"demo-select-all-checkboxes\" flex=\"15\" ng-repeat=\"day in vm.dayInWeek\"><md-checkbox ng-checked=\"vm.exists(day, vm.repeat)\" ng-click=\"vm.toggle(day, vm.repeat)\"><span ng-bind=\"vm.convertToDayName(day)\"></span></md-checkbox></div></div></fieldset></md-input-container><div layout=\"row\"><legend class=\"demo-legend\">Ends On</legend></div><div layout=\"row\"></div><div layout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"vm.calendarEvent.Repeats.EndsOn\" md-placeholder=\"Ends On\"></md-datepicker></div></fieldset></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || !vm.hasSelected\" translate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button ng-if=\"vm.dialogData.type != \'add\'\" ng-click=\"vm.deleteEvent()\" class=\"md-icon-button\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contact/create/directives/componentHeader/contactComponentHeader.html","<header class=\"contact-component-header\" layout=\"row\" layout-padding=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">{{vm.title}}</span></header>");
$templateCache.put("app/main/contact/calendar/calendar-entry/manage/manage-calendar-entry.html","<div class=\"manage-calendar-entry md-whiteframe-4dp padding-20 {{manageVm.showSettings ? \'col-6\' : \'\'}}\" layout=\"column\" ms-scroll=\"\"><calendar-entry-settings ng-if=\"manageVm.showSettings\" on-close=\"manageVm.closeSettings()\" on-save=\"manageVm.closeSettings()\"></calendar-entry-settings><div ng-if=\"!manageVm.showSettings\" layout=\"column\" flex=\"\"><div layout=\"row\" class=\"header-bar\" layout-align=\"end center\"><md-button class=\"md-primary settings-button brad-10 margin-0 padding-left-10 padding-right-10\" aria-label=\"Settings\" ng-click=\"manageVm.openSettings()\"><md-icon md-svg-icon=\"settings-outlined\" class=\"margin-right-5\"></md-icon><span class=\"settings-label\">Settings</span></md-button></div><div layout=\"row\" layout-align=\"start start\" class=\"filters-row\"><div class=\"filter-date-range\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar\" class=\"s20 margin-right-5\"></md-icon><md-datepicker ng-model=\"manageVm.service.filters.startDate\" ng-change=\"manageVm.onStartDateChange()\" md-placeholder=\"Start date\" class=\"date-picker-compact\" ng-class=\"{\'date-picker-error\': manageVm.dateRangeError}\"></md-datepicker><span class=\"date-separator\">-</span><md-datepicker ng-model=\"manageVm.service.filters.endDate\" ng-change=\"manageVm.onEndDateChange()\" md-placeholder=\"End date\" class=\"date-picker-compact\" ng-class=\"{\'date-picker-error\': manageVm.dateRangeError}\"></md-datepicker></div><span class=\"date-range-error\" ng-if=\"manageVm.dateRangeError\">{{manageVm.dateRangeError}}</span></div><div class=\"filter-quick-dates\" layout=\"row\"><md-button class=\"md-raised quick-date-btn\" ng-click=\"manageVm.setLastMonth()\">Last Month</md-button><md-button class=\"md-raised quick-date-btn\" ng-click=\"manageVm.setThisMonth()\">This Month</md-button><md-button class=\"md-raised quick-date-btn\" ng-click=\"manageVm.setNextMonth()\">Next Month</md-button></div><md-input-container class=\"filter-branch\"><md-icon md-svg-icon=\"pin-outlined\" class=\"margin-right-5\"></md-icon><md-select name=\"branches\" ng-change=\"manageVm.onBranchChange()\" ng-model=\"manageVm.service.filters.selectedBranch\" placeholder=\"All branches\" multiple=\"\"><md-optgroup label=\"Branch(es)\"><md-option ng-value=\"branch.Id\" ng-repeat=\"branch in manageVm.service.branches\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><div class=\"filter-buttons\" layout=\"row\"><md-button class=\"md-raised filter-btn all\" ng-class=\"{\'active\': manageVm.service.filters.selectedFilter === manageVm.calendarEntryStatus.ALL}\" ng-click=\"manageVm.service.filters.selectedFilter = manageVm.calendarEntryStatus.ALL; manageVm.onStatusChange()\">All ({{manageVm.service.getAllCount()}})</md-button><md-button class=\"md-raised filter-btn pending\" ng-class=\"{\'active\': manageVm.service.filters.selectedFilter === manageVm.calendarEntryStatus.PENDING}\" ng-click=\"manageVm.service.filters.selectedFilter = manageVm.calendarEntryStatus.PENDING; manageVm.onStatusChange()\">Pending ({{manageVm.service.getPendingCount()}})</md-button><md-button class=\"md-raised filter-btn approved\" ng-class=\"{\'active\': manageVm.service.filters.selectedFilter === manageVm.calendarEntryStatus.APPROVED}\" ng-click=\"manageVm.service.filters.selectedFilter = manageVm.calendarEntryStatus.APPROVED; manageVm.onStatusChange()\">Approved ({{manageVm.service.getApprovedCount()}})</md-button><md-button class=\"md-raised filter-btn rejected\" ng-class=\"{\'active\': manageVm.service.filters.selectedFilter === manageVm.calendarEntryStatus.REJECTED}\" ng-click=\"manageVm.service.filters.selectedFilter = manageVm.calendarEntryStatus.REJECTED; manageVm.onStatusChange()\">Rejected ({{manageVm.service.getRejectedCount()}})</md-button></div></div><div layout=\"row\" class=\"search-row\" layout-align=\"start center\" ng-if=\"manageVm.service.employees.length > 0\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-chips class=\"searchEmployeeContainer\" ng-model=\"manageVm.service.filters.selectedEmployees\" md-on-add=\"manageVm.onSelectEmployee($chip)\" md-on-remove=\"manageVm.onRemoveEmployee($chip)\" name=\"contacts\"><md-autocomplete md-search-text=\"manageVm.searchText\" md-items=\"contact in manageVm.querySearch(manageVm.searchText)\" md-item-text=\"contact.Name\" class=\"md-body-1\" placeholder=\"Search one or more people by typing their name\"><span class=\"md-body-1 autocomplete-icon\" layout=\"row\"><div flex=\"10\" class=\"margin-top-10 margin-right-20\"><i class=\"light-blue-800-fg s30 icon icon-account margin-top-10\"></i></div><div flex=\"auto\" class=\"margin-top-15\">{{contact.Name}}</div></span></md-autocomplete><md-chip-template><strong>{{$chip.Name}}</strong></md-chip-template></md-chips></div><div layout=\"row\" layout-align=\"start-center\" class=\"bulk-actions\" ng-if=\"manageVm.canDoBulkActions()\"><md-checkbox class=\"margin-0\" ng-model=\"manageVm.service.selectAll\" ng-change=\"manageVm.toggleSelectAll()\" aria-label=\"Select All\">Select All</md-checkbox><div class=\"decision-buttons bulk-actions\"><md-button class=\"md-raised approve-btn white-text\" ng-disabled=\"manageVm.isBulkActionDisabled()\" ng-click=\"manageVm.bulkApprove()\"><i class=\"icon icon-check\"></i> Approve</md-button><md-button class=\"md-raised reject-btn white-text\" ng-disabled=\"manageVm.isBulkActionDisabled()\" ng-click=\"manageVm.bulkReject()\"><i class=\"icon icon-close\"></i> Reject</md-button></div></div><div class=\"requests-list\" flex=\"\"><toolbar-loader message=\"manageVm.service.isLoadingMessage\" show=\"manageVm.service.isLoading\"></toolbar-loader><md-card ng-repeat=\"request in manageVm.service.filteredRequests\" class=\"request-card\" ng-if=\"!manageVm.service.isLoading\"><md-card-content layout=\"row\" layout-align=\"start start\"><md-checkbox ng-model=\"request.selected\" ng-if=\"manageVm.canBeSelected(request)\" aria-label=\"Select request\"></md-checkbox><div flex=\"\" layout=\"column\" class=\"request-info\"><div layout=\"row\" layout-align=\"space-between center margin-bottom-10\"><span class=\"employee-name\">{{request.FullName}}</span></div><div layout=\"row\" layout-align=\"start-center\" class=\"request-details\"><span><md-icon md-svg-icon=\"pin-outlined\" class=\"margin-right-5 pin-outlined\"></md-icon>{{request.Branch}}</span> <span class=\"layout-row\" ng-if=\"request.PhoneNumber\"><i class=\"icon icon-phone margin-right-5\"></i> {{request.PhoneNumber}}</span></div><div class=\"request-dates\"><i class=\"icon icon-calendar\"></i> {{manageVm.fetchDate(request.StartDate)}} - {{manageVm.fetchDate(request.EndDate)}}</div><div class=\"unavailable-label\">Unavailable</div><div layout=\"row\" class=\"request-meta\"><span><strong>Reason:</strong> {{request.Reason}}</span> <span ng-if=\"request.Remarks\"><strong>Remarks:</strong> {{request.Remarks}}</span></div><div class=\"submitted-date\">Submitted {{manageVm.fetchDate(request.CreatedDate)}}</div></div><div layout=\"column\" class=\"action-buttons\"><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"View history logs\" ng-click=\"manageVm.viewHistory(request)\"><md-icon md-font-icon=\"icon-history\"></md-icon><md-tooltip md-direction=\"bottom\">View History</md-tooltip></md-button><span class=\"status-badge\" ng-class=\"manageVm.service.getStatusClass(request.Status)\">{{manageVm.getStatusDesc(request.Status)}}</span></div><div layout=\"column\" class=\"decision-buttons\" ng-if=\"request.Status === manageVm.calendarEntryStatus.PENDING\"><md-button class=\"md-raised approve-btn white-text\" ng-click=\"manageVm.approveRequest(request)\"><i class=\"icon icon-check\"></i> Approve</md-button><md-button class=\"md-raised reject-btn white-text\" ng-click=\"manageVm.rejectRequest(request)\"><i class=\"icon icon-close\"></i> Reject</md-button></div></div></md-card-content></md-card><div ng-if=\"manageVm.service.filteredRequests.length === 0 && !manageVm.service.isLoading\" class=\"no-requests\" layout=\"column\" layout-align=\"center center\"><i class=\"icon icon-calendar-blank s64\"></i><p>No calendar entry requests found</p></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"manageVm.service.hasMoreItems() && !manageVm.service.isLoading\"><md-button ng-click=\"manageVm.loadMore()\">Load More</md-button></div></div></div></div>");
$templateCache.put("app/main/contact/create/directives/nothingFound/nothing.found.html","<div layout=\"row\" layout-align=\"center center\" flex=\"\"><span class=\"text-bold\">No {{vm.title}} Found</span></div>");
$templateCache.put("app/main/contact/create/directives/fileViewer/file-viewer.html","<span class=\"file-viewer\"><i ng-click=\"vm.view(vm.file)\" class=\"icon-attachment md-primary text-bold\"><md-tooltip>View File</md-tooltip></i></span>");
$templateCache.put("app/main/costEstimate/preview/directives/ceItemList/ce-item-list.html","<ce-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div class=\"h4 grey-600-fg\" layout=\"row\" layout-align=\"center center\" style=\"margin-top: 25%;\" ng-if=\"invRepVm.model.grid.data.length <= 0\">No current record(s) to display.</div><cost-estimate-item-host-component invoicelist=\"invRepVm.model.grid.data | orderBy : \'-sortValue\'\" oneditinvoice=\"invRepVm.model.grid.editInvoice\" ondownloadinvoice=\"invRepVm.model.grid.generateCostEstimatePdf\" ondeleteinvoice=\"invRepVm.model.deleteInvoice\" oneditticket=\"invRepVm.model.editTicket\" onedittimesheet=\"invRepVm.model.editTimesheet\" onmarkasreviewed=\"invRepVm.model.markAsReviewed\" onsetasprimary=\"invRepVm.model.setAsPrimary\" showdetails=\"invRepVm.model.showDetails\" isfinalised=\"invRepVm.groupInfoService.data.Status == 2 || invRepVm.viewCancelled\" dateformat=\"invRepVm.dateFormat\" ng-disabled=\"invRepVm.model.grid.data.IsPdfGenerating\"></cost-estimate-item-host-component></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><ce-grid-pagination-component behavior=\"invRepVm.model.grid.api\" distinct-by=\"InvoiceNumber\" on-init=\"invRepVm.model.grid.onInit()\" on-error=\"invRepVm.model.grid.onError(ex)\" on-completed=\"invRepVm.model.grid.onCompleted(data)\" on-data-filter=\"invRepVm.model.grid.onDataFilter()\" on-data-loading=\"invRepVm.model.grid.onDataLoading()\" on-data-loading-completed=\"invRepVm.model.grid.onDataLoadingCompleted()\" on-ready=\"invRepVm.model.grid.onReady()\" custom-grid-search-service=\"invRepVm.customGridService\" allow-custom-client-side-filtering=\"invRepVm.model.grid.allowCustomClientSideFiltering\" on-apply-custom-client-side-filtering=\"invRepVm.model.grid.onCustomClientSideFiltering(data)\" auto-fetch=\"false\"></ce-grid-pagination-component></div></div></ce-grid-component>");
$templateCache.put("app/main/costEstimate/preview/directives/ceItemList/ce-popup-resource.html","<style>\r\n    table.simple {\r\n        font-family:  \"Roboto\", \"Helvetica Neue\", \"Arial\", sans-serif;\r\n        width: 100%;\r\n        border: none;\r\n        border-spacing: 0;\r\n        text-align: left;\r\n    }\r\n\r\n    table.simple.clickable tr {\r\n        cursor: pointer;\r\n    }\r\n\r\n    table.simple.clickable tr:hover {\r\n        background: rgba(0, 0, 0, 0.03);\r\n    }\r\n\r\n    table.simple th {\r\n        padding: 16px 8px;\r\n        font-weight: 500;\r\n        color: rgba(0, 0, 0, 0.54);\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n        white-space: nowrap;\r\n        min-width: 120px;\r\n    }\r\n\r\n    table.simple th:first-child {\r\n        padding-left: 24px;\r\n    }\r\n\r\n    table.simple th:last-child {\r\n        padding-right: 24px;\r\n    }\r\n\r\n    table.simple td {\r\n        padding: 9px 8px;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n    }\r\n\r\n    table.simple td:first-child {\r\n        padding-left: 24px;\r\n    }\r\n\r\n    table.simple td:last-child {\r\n        padding-right: 24px;\r\n    }\r\n\r\n    table.simple tr:last-child td {\r\n        border-bottom: none;\r\n    }\r\n\r\n    .invoice-table {\r\n        margin-top: 16pt;\r\n    }\r\n\r\n    thead {\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    th {\r\n        font-size: 10pt;\r\n        max-width: 60pt;\r\n    }\r\n\r\n    th:first-child {\r\n        padding-left: 0;\r\n    }\r\n\r\n    th:last-child {\r\n        padding-right: 0;\r\n    }\r\n\r\n    td {\r\n        font-size: 12px;\r\n        border-bottom: 0;\r\n        padding: 5px 8px;\r\n    }\r\n\r\n    td:first-child {\r\n        padding-left: 0;\r\n    }\r\n\r\n    td:last-child {\r\n        padding-right: 0;\r\n    }\r\n\r\n    tr:nth-child(odd) {\r\n        background-color: #f4f4f4;\r\n    }\r\n\r\n    tr:nth-child(even) {\r\n        background-color: #fff;\r\n    }\r\n\r\n    tbody:before {\r\n        content: \"-\";\r\n        display: block;\r\n        line-height: 1em;\r\n        color: transparent;\r\n    }\r\n\r\n    .title {\r\n        font-size: 10pt;\r\n    }\r\n\r\n    .detail {\r\n        margin-top: 4pt;\r\n        font-size: 9pt;\r\n        max-width: none;\r\n    }\r\n\r\n    .qty-col {\r\n        width: 100px;\r\n    }\r\n\r\n    .unit-price-col {\r\n        width: 120px;\r\n    }\r\n\r\n    .amt-col {\r\n        width: 130px;\r\n    }\r\n\r\n    .start-time-col {\r\n        width: 180px;\r\n    }\r\n\r\n    .end-time-col {\r\n        width: 180px;\r\n    }\r\n\r\n    .hrs-col {\r\n        width: 180px;\r\n    }\r\n</style><h1>Sample</h1><table class=\"simple invoice-table invoice-resource-table\"><thead><tr><th>Resource Item</th><th class=\"text-right start-time-col\">Start Time</th><th class=\"text-right end-time-col\">Break</th><th class=\"text-right end-time-col\">End Time</th><th class=\"text-right hrs-col\">Hours</th></tr></thead><tbody><tr><td>232228 - Traffic Controller (Albert Grant)</td><td class=\"text-right\">07:00</td><td class=\"text-right\">N/A</td><td class=\"text-right\">16:00</td><td class=\"text-right\">9</td></tr><tr><td>232229 - Traffic Controller (Albert Grant)</td><td class=\"text-right\">07:00</td><td class=\"text-right\">N/A</td><td class=\"text-right\">14:00</td><td class=\"text-right\">7</td></tr><tr><td>232243 - Traffic Controller (Karen Dunn)</td><td class=\"text-right\">10:00</td><td class=\"text-right\">12:00-12:30</td><td class=\"text-right\">18:00</td><td class=\"text-right\">7.5</td></tr><tr><td>232244 - Traffic Controller (Karen Dunn)</td><td class=\"text-right\">10:00</td><td class=\"text-right\">12:00-12:30</td><td class=\"text-right\">18:00</td><td class=\"text-right\">7.5</td></tr><tr><td>232245 - Traffic Controller (Karen Dunn)</td><td class=\"text-right\">10:00</td><td class=\"text-right\">12:00-12:30</td><td class=\"text-right\">18:00</td><td class=\"text-right\">7.5</td></tr><tr><td>232246 - Traffic Controller (Karen Dunn)</td><td class=\"text-right\">10:00</td><td class=\"text-right\">12:00-12:30</td><td class=\"text-right\">18:00</td><td class=\"text-right\">7.5</td></tr></tbody></table>");
$templateCache.put("app/main/contact/create/directives/highlightBox/highlight-box.html","<span class=\"highlight-box-directive margin-right-5 margin-bottom-5 {{vm.classes}}\">{{vm.trim(vm.content)}}<md-tooltip ng-if=\"vm.description\"><span ng-if=\"vm.content.length > 30\">{{vm.content}}</span></md-tooltip><md-tooltip ng-if=\"vm.isReference\"><span ng-if=\"vm.content.length > 15\">{{vm.content}}</span></md-tooltip></span>");
$templateCache.put("app/main/contact/create/work/allowances/contact-allowances.html","<div flex=\"\" class=\"contact-allowances\"><table class=\"simple kit-item-table allowance-list\" ms-responsive-table=\"\"><tbody><tr ng-repeat=\"allowance in vm.formattedAllowanceList\" ng-class=\"{\'inactive\': !allowance.isActive}\"><td width=\"80%\"><label>{{allowance.label}}</label><div class=\"margin-bottom-5\"><span class=\"md-body-2\">{{allowance.amount | currency:\"$\":2}} {{allowance.shiftType}}</span></div><span ng-if=\"!allowance.isActive\" class=\"highlight-box-red inactive-allowance-tag\">{{\'CONTACTSMODULE.ALLOWANCE.INACTIVE\' | translate}}</span></td><td width=\"20%\"><delete-component index=\"$index\" message=\"{{\'CONTACTSMODULE.ALLOWANCE.ALLOWANCE_DELETE_MESSAGE\' | translate}}\" callback=\"vm.removeAllowance(allowance.id)\" section=\"{{\'CONTACTSMODULE.ALLOWANCE.ALLOWANCE_SECTION\' | translate}}\" ng-if=\"vm.hasModifyAllowancesAccess\"></delete-component></td></tr><tr><div ng-if=\"vm.formattedAllowanceList.length < 1\" class=\"padding-20\">{{\'CONTACTSMODULE.ALLOWANCE.NO_ALLOWANCE_FOR_CONTACT\' | translate}}</div></tr><tr ng-if=\"vm.hasModifyAllowancesAccess\"><td style=\"padding-left: 0px;\"><add-button ng-click=\"vm.openDialog()\" title=\"Add Allowance\"></add-button><div class=\"dropdown-instruction instruction-warning\" ng-if=\"vm.addAllowanceError\"><label>{{vm.addAllowanceErrorMessage}}</label></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/contact/create/work/company/companies.html","<div flex=\"\"><table class=\"simple kit-item-table\" ms-responsive-table=\"\"><tbody><tr ng-repeat=\"company in vmContactWork.contactData.Companies\"><td width=\"80%\">{{company.Company.Name}}<div class=\"margin-bottom-5\"><span ng-if=\"company.Position != null && company.Position != \'\'\" class=\"md-body-2 text-italic\">Position : {{company.Position}}</span></div><div><highlight-box ng-if=\"company.ContactType.TypeName != null\" classes=\"md-light-blue-800-bg\" content=\"{{company.ContactType.TypeName}}\"></highlight-box><span class=\"highlight-box-green\" ng-if=\"company.Company.Branches.length > 0\"><span ng-repeat=\"branch in company.Company.Branches\">{{branch.Name}}<span ng-if=\"company.Company.Branches.length != ($index + 1)\">,</span></span></span></div></td><td width=\"20%\"><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"vmContactWork.editCompany(company, true, $index)\"></md-icon><delete-component index=\"$index\" message=\"{{\'CONTACTSMODULE.COMPANY_DELETE_MESSAGE\' | translate}}\" callback=\"vmContactWork.removeCompany\" section=\"{{\'CONTACTSMODULE.COMPANY_SECTION\' | translate}}\"></delete-component></td></tr><tr><td style=\"padding-left: 0px;\"><add-button ng-click=\"vmContactWork.showCompanyDialog()\" title=\"Add Company\"></add-button><company-dialog ng-hide=\"true\" behavior=\"vmContactWork.companyDialog\"></company-dialog></td></tr></tbody></table></div>");
$templateCache.put("app/main/contact/create/work/company/workInfo-company-link.html","<div><a href=\"#\" ng-click=\"spawnCompanyDialog()\" translate=\"CONTACTSMODULE.ADD_COMPANY\"></a></div>");
$templateCache.put("app/main/contact/create/work/company/workInfo-company.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form name=\"contactCompany\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"CONTACTSMODULE.COMPANY\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"column\" flex=\"\"><div layout=\"column\" flex=\"\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.service.selectedItem\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.Name\" md-min-length=\"0\" md-floating-label=\"Select Company\" placeholder=\"{{\'CONTACTSMODULE.COMPANY_ADD_PLACEHOLDER\' | translate}}\" md-menu-class=\"autocomplete-custom-template\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.Name}}</span></md-item-template></md-autocomplete></div><div layout=\"column\" flex=\"\"><md-input-container flex=\"\"><label translate=\"CONTACTSMODULE.COMPANY_CONTACT_TYPE\"></label><md-select ng-model=\"vm.model2.ContactType\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.validate()\" required=\"\"><md-option ng-repeat=\"title in vm.contactTypes\" ng-value=\"title\">{{ title.TypeName }}</md-option></md-select></md-input-container><md-input-container flex=\"40\"><input type=\"text\" ng-model=\"vm.model2.Position\" placeholder=\"{{\'CONTACTSMODULE.POSITION\' | translate}}\"></md-input-container><md-input-container flex=\"\"><label translate=\"CONTACTSMODULE.COMPANY_ADD_BRANCHES\"></label><md-select placeholder=\"{{\'CONTACTSMODULE.COMPANY_ADD_BRANCHES\' | translate}}\" multiple=\"\" ng-model=\"vm.branches\" required=\"\" ng-model-options=\"{trackBy: \'$value.Id\'}\"><md-optgroup label=\"Branch(es)\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.service.branchList\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"contactCompany.$invalid\" ng-click=\"vm.onDone(vm.model2)\" translate=\"CONTACTSMODULE.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contact/create/work/training/contact-training.html","<table class=\"simple kit-item-table\"><tbody><tr ng-repeat=\"training in vm.list | orderBy : \'TrainingName\'\"><td width=\"80%\">{{training.TrainingName}}<div class=\"margin-bottom-5\"><span ng-if=\"training.Description\" class=\"md-body-2 text-italic\">Description: {{training.Description}}</span></div><div><highlight-box ng-if=\"training.ReferenceNumber\" classes=\"highlight-box\" content=\"Ref: {{training.ReferenceNumber}}\"></highlight-box><highlight-box ng-if=\"training.CompletedDate\" classes=\"highlight-box\" content=\"Completed On: {{training.CompletedDate | date}}\"></highlight-box><span ng-if=\"training.ExpiryDate\" class=\"margin-right-5\" ng-class=\"{true: \'highlight-box-red\', false: \'highlight-box\'}[vm.isExpiringSoon(training.ExpiryDate)]\">Expiry: {{training.ExpiryDate | date}}</span><file-viewer ng-if=\"training.UploadFileName\" file=\"training.UploadFileName\"></file-viewer></div></td><td width=\"20%\"><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"vm.service.openTrainingDialog(true, training)\"></md-icon><delete-component index=\"$index\" message=\"{{\'WIDGETS_LOC.DELETE_MESSAGE\' | translate}}\" callback=\"vm.remove\" section=\"{{\'CONTACTSMODULE.TRAINING_HEADER\' | translate}}\"></delete-component></td></tr><tr><td style=\"padding-left: 0px;\"><add-button ng-click=\"vm.service.openTrainingDialog(false, null)\" title=\"Add Training\"></add-button></td></tr></tbody></table>");
$templateCache.put("app/main/equipment/services/dialogs/manageEquipment/manage-equipment-dialog.html","<md-dialog aria-label=\"Equipment\" class=\"main-style\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"EQUIPMENT_VIEW.MANAGE_EQUIPMENT\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><form name=\"IndividualItemEntryForm\" novalidate=\"\"><div layout=\"column\"><md-input-container flex=\"\"><label translate=\"EQUIPMENT_VIEW.MANAGE_UNIQUE_ITEM_IDENTIFIER\"></label> <input type=\"text\" name=\"identifier\" ng-disabled=\"vm.isEditMode\" ng-model=\"vm.model.data.UniqueItemId\" ng-required=\"!vm.isEditMode\"><div ng-messages=\"IndividualItemEntryForm.identifier.$error\" ng-show=\"IndividualItemEntryForm.identifier.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"EQUIPMENT_VIEW.MANAGE_UNIQUE_INDENTIFIER_FIELD_IS_REQUIRED\"></span></div></div></md-input-container><md-input-container flex=\"\"><label translate=\"EQUIPMENT_VIEW.MANAGE_DESCRIPTION\"></label> <input type=\"text\" name=\"desc\" ng-disabled=\"vm.isEditMode\" ng-model=\"vm.model.data.Description\" md-maxlength=\"70\" ng-required=\"!vm.isEditMode\"><div ng-messages=\"basicInfoForm.desc.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span translate=\"EQUIPMENT_VIEW.MANAGE_MAXIMUM_LENGTH_EXCEEDED\"></span></div></div></md-input-container></div><div layout=\"column\"><md-input-container flex=\"\"><label translate=\"EQUIPMENT_VIEW.MANAGE_ITEM\"></label><md-select name=\"branch\" ng-change=\"vm.onItemChange(vm.model.data.ItemId)\" ng-model=\"vm.model.data.ItemId\" ng-model-options=\"{trackBy: \'$value\'}\" ng-required=\"!vm.isEditMode\"><md-option ng-disabled=\"item.Disabled\" ng-value=\"item.id\" ng-repeat=\"item in vm.items\">{{item.ItemName}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label translate=\"EQUIPMENT_VIEW.MANAGE_TYPE\"></label><md-select name=\"branch\" ng-change=\"vm.onItemTypeChange()\" ng-model=\"vm.model.data.ItemType\" ng-model-options=\"{trackBy: \'$value\'}\" ng-required=\"!vm.isEditMode\"><md-option ng-disabled=\"item_type.Disabled\" ng-value=\"item_type.Id\" ng-repeat=\"item_type in vm.itemTypes\">{{item_type.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label translate=\"EQUIPMENT_VIEW.MANAGE_BRANCH\"></label><md-select name=\"branches\" multiple=\"\" ng-change=\"vm.onBranchSelectionChange()\" ng-model=\"vm.model.data.Branches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branches | unique : \'Name\'\" \"=\"\">{{branch.Name}}</md-option></md-select><div ng-messages=\"IndividualItemEntryForm.branch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"EQUIPMENT_VIEW.MANAGE_BRANCH_FIELD_IS_REQUIRED\"></span></div></div></md-input-container><md-input-container flex=\"\"><label translate=\"EQUIPMENT_VIEW.MANAGE_DIVISIONS\"></label><md-select name=\"Divisions\" multiple=\"\" ng-model=\"vm.model.data.Divisions\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.limit(vm.model.data.Divisions)\"><md-optgroup label=\"Divisions\"><md-option ng-repeat=\"division in vm.divisions\" ng-value=\"division\">{{division.Name}} - ({{division.BranchName}})</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"vm.isVehicle()\"><label translate=\"EQUIPMENT_VIEW.MANAGE_OWNERSHIP_TYPE\"></label><md-select name=\"branch\" ng-model=\"vm.model.data.VehicleOwnershipType\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"item.Id\" ng-repeat=\"item in vm.ownershipTypes\">{{item.Name}}</md-option></md-select></md-input-container></div><div layout=\"column\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.model.data.User\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.FullName\" md-min-length=\"0\" placeholder=\"{{\'EQUIPMENT_VIEW.MANAGE_SELECT_EMPLOYEE_CONTACT\' | translate}}\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"Assigned to User\" flex=\"\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.FullName}}</span></md-item-template><md-not-found><span ng-if=\"vm.model.data.Branches == null\"><strong style=\"color: blue;\">{{\'EQUIPMENT_VIEW.MANAGE_SELECT_YOUR_BRANCH_FIRST\' | translate}}</strong></span> <span ng-if=\"vm.model.data.Branches != null\"><strong style=\"color: blue;\">\"{{vm.searchText}}\"</strong> not found.</span></md-not-found></md-autocomplete><md-input-container flex=\"\"><label>{{\'EQUIPMENT_VIEW.MANAGE_ITEM_STATUS\' | translate}}</label><md-select name=\"itemStatus\" ng-model=\"vm.model.data.ItemStatus\" ng-change=\"vm.hasItemStatusChange()\" required=\"\"><md-option ng-repeat=\"itemState in vm.itemStates\" value=\"{{itemState.Id}}\">{{itemState.Name}}</md-option></md-select><div ng-messages=\"IndividualItemEntryForm.itemStatus.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"EQUIPMENT_VIEW.MANAGE_ITEM_STATUS_IS_REQUIRED\"></span></div></div></md-input-container><md-input-container flex=\"\" ng-if=\"vm.showStatusEffectiveDate\"><label>{{\'EQUIPMENT_VIEW.MANAGE_ITEM_STATUS_EFFECTIVE_DATE\' | translate}}</label><md-datepicker ng-model=\"vm.model.data.StatusEffectiveDate\" md-open-on-focus=\"\" required=\"\"></md-datepicker></md-input-container></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\" translate=\"EQUIPMENT_VIEW.MANAGE_CANCEL\" class=\"md-raised first-button-margin\"></md-button><md-button ng-click=\"vm.onUpdate()\" class=\"md-accent md-raised button-margin\" aria-label=\"Add\" ng-disabled=\"IndividualItemEntryForm.$invalid\" translate=\"EQUIPMENT_VIEW.MANAGE_SAVE\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/customValidations/create/components/if/if.html","<div class=\"layout-column\"><span layout=\"row\" class=\"text-semibold\" layout-margin=\"\" style=\"font-size : 13px;\"><span>Conditions</span> <span><md-icon style=\"font-size : 20px; margin-top : -3px; cursor : pointer; color : #475A64\" ng-click=\"vm.addCondition()\" md-font-icon=\"icon-plus-box\"><md-tooltip>Add condition</md-tooltip></md-icon></span></span><div flex=\"\"><table class=\"md-api-table\" flex=\"\"><thead><tr><th><span ng-style=\"{\'visibility\' : (vm.ngModel.length == 0) ? \'hidden\' : \'visible\' }\">Field</span></th><th></th><th><span ng-style=\"{\'visibility\' : (vm.ngModel.length == 0) ? \'hidden\' : \'visible\' }\">Value</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"condition in vm.ngModel\"><td class=\"text-bold\">{{condition.Alias}}</td><td class=\"text-bold\">=</td><td>{{condition.Value}}</td><td><md-icon style=\"font-size : 20px; cursor : pointer; color : #475A64; margin-top :-3px;\" ng-click=\"vm.addCondition(condition)\" md-font-icon=\"icon-pencil\"><md-tooltip>Edit</md-tooltip></md-icon><md-icon style=\"font-size : 20px; cursor : pointer; color : #475A64; margin-top :-3px;\" ng-click=\"vm.remove($index)\" md-font-icon=\"icon-close-circle\"><md-tooltip>Remove</md-tooltip></md-icon></td></tr><tr ng-if=\"vm.ngModel.length == 0\"><td class=\"no-data\" colspan=\"4\">No conditions found</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/customValidations/create/components/then/then.html","<div class=\"layout-column\"><span layout=\"row\" class=\"text-semibold\" layout-margin=\"\" style=\"font-size : 13px;\"><span>Then</span> <span><md-icon style=\"font-size : 20px; margin-top : -3px; cursor : pointer; color : #475A64\" ng-click=\"vm.addThenStatement()\" md-font-icon=\"icon-plus-box\"><md-tooltip>Add then statement</md-tooltip></md-icon></span></span><div flex=\"\"><table class=\"md-api-table\" flex=\"\"><thead><tr><th><span ng-style=\"{\'visibility\' : (vm.ngModel.length == 0) ? \'hidden\' : \'visible\' }\">Field</span></th><th ng-if=\"vm.mediaQueryService.isDeviceSM() || vm.mediaQueryService.isDeviceMD() || vm.mediaQueryService.isDeviceXS()\"></th><th ng-if=\"vm.mediaQueryService.isDeviceXL() || vm.mediaQueryService.isDeviceLG()\"><span ng-style=\"{\'visibility\' : (vm.ngModel.length == 0) ? \'hidden\' : \'visible\' }\">Regex Pattern</span></th><th ng-if=\"vm.mediaQueryService.isDeviceXL() || vm.mediaQueryService.isDeviceLG()\"><span ng-style=\"{\'visibility\' : (vm.ngModel.length == 0) ? \'hidden\' : \'visible\' }\">Is Required</span></th><th ng-if=\"vm.mediaQueryService.isDeviceXL() || vm.mediaQueryService.isDeviceLG()\"><span ng-style=\"{\'visibility\' : (vm.ngModel.length == 0) ? \'hidden\' : \'visible\' }\">Available Options</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"statement in vm.ngModel\" ng-if=\"vm.mediaQueryService.isDeviceXL() || vm.mediaQueryService.isDeviceLG()\"><td class=\"text-bold\">{{statement.Alias}}</td><td><code ng-if=\"statement.RegexValidation != null\">{{statement.RegexValidation}}</code></td><td><span>{{statement.CustomValidationRequiredType == 0 ? \'Required\' : \'Not required\'}}</span> <span class=\"text-boxed red-900-fg\" ng-if=\"statement.CustomValidationRequiredType == 0\"><b>(*)</b></span></td><td><span class=\"text-bold\" ng-if=\"statement.AllowedValues.length > 0\">Allowed Values :</span><ul ng-if=\"statement.AllowedValues.length > 0\"><li ng-repeat=\"value in statement.AllowedValues\">{{value.Name}}</li></ul></td><td align=\"right\"><md-icon style=\"font-size : 20px; cursor : pointer; color : #475A64; margin-top :-3px;\" ng-click=\"vm.addThenStatement(statement)\" md-font-icon=\"icon-pencil\"><md-tooltip>Edit</md-tooltip></md-icon><md-icon style=\"font-size : 20px; cursor : pointer; color : #475A64; margin-top :-3px;\" ng-click=\"vm.remove($index)\" md-font-icon=\"icon-close-circle\"><md-tooltip>Remove</md-tooltip></md-icon></td></tr><tr ng-repeat=\"statement in vm.ngModel\" ng-if=\"vm.mediaQueryService.isDeviceSM() || vm.mediaQueryService.isDeviceMD() || vm.mediaQueryService.isDeviceXS()\"><td class=\"text-bold\">{{statement.Alias}}</td><td><md-list><md-list-item style=\"padding : 0; margin-bottom : -10px;\" class=\"md-1-line text-bold\" ng-if=\"statement.RegexValidation != null\">Regex Pattern :</md-list-item><md-list-item style=\"padding : 0; margin-bottom : -10px;\" class=\"md-1-line\" ng-if=\"statement.RegexValidation != null\"><code ng-if=\"statement.RegexValidation != null\">{{statement.RegexValidation}}</code></md-list-item><md-list-item class=\"md-1-line text-bold\" style=\"padding : 0; margin-bottom : -10px;\"><span>{{statement.CustomValidationRequiredType == 0 ? \'Required\' : \'Not required\'}}</span> <span class=\"text-boxed red-900-fg\" ng-if=\"statement.CustomValidationRequiredType == 0\"><b>(*)</b></span></md-list-item><md-list-item style=\"padding : 0; margin-bottom : -10px;\" class=\"md-1-line text-bold\" ng-if=\"statement.AllowedValues.length > 0\">Allowed Values :</md-list-item><md-list-item style=\"padding : 0; margin-bottom : -10px;\" class=\"md-1-line\" ng-if=\"statement.AllowedValues.length > 0\"><ul><li ng-repeat=\"value in statement.AllowedValues\">{{value.Name}}</li></ul></md-list-item><md-list-item style=\"padding : 0; margin-bottom : -10px;\" class=\"md-1-line text-bold\" ng-if=\"vm.mediaQueryService.isDeviceXS()\">Actions :</md-list-item><md-list-item class=\"md-1-line\" layout=\"row\" style=\"padding : 0; margin :0\" ng-if=\"vm.mediaQueryService.isDeviceXS()\"><div><md-icon style=\"font-size : 20px; cursor : pointer; color : #475A64;\" ng-click=\"vm.addThenStatement(statement)\" md-font-icon=\"icon-pencil\"><md-tooltip>Edit</md-tooltip></md-icon><md-icon style=\"font-size : 20px; cursor : pointer; color : #475A64;\" ng-click=\"vm.remove($index)\" md-font-icon=\"icon-close-circle\"><md-tooltip>Remove</md-tooltip></md-icon></div></md-list-item></md-list></td><td align=\"right\"><md-icon style=\"font-size : 20px; cursor : pointer; color : #475A64; margin-top :-3px;\" ng-if=\"vm.mediaQueryService.isDeviceSM() || vm.mediaQueryService.isDeviceMD()\" ng-click=\"vm.addThenStatement(statement)\" md-font-icon=\"icon-pencil\"><md-tooltip>Edit</md-tooltip></md-icon><md-icon style=\"font-size : 20px; cursor : pointer; color : #475A64; margin-top :-3px;\" ng-if=\"vm.mediaQueryService.isDeviceSM() || vm.mediaQueryService.isDeviceMD()\" ng-click=\"vm.remove($index)\" md-font-icon=\"icon-close-circle\"><md-tooltip>Remove</md-tooltip></md-icon></td></tr><tr ng-if=\"vm.ngModel.length == 0 && (vm.mediaQueryService.isDeviceSM() || vm.mediaQueryService.isDeviceMD() || vm.mediaQueryService.isDeviceXS())\"><td class=\"no-data\" colspan=\"3\">No then statements found</td></tr><tr ng-if=\"vm.ngModel.length == 0 && (vm.mediaQueryService.isDeviceLG() || vm.mediaQueryService.isDeviceXL())\"><td class=\"no-data\" colspan=\"5\">No then statements found</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/invoice/directives/invoiceGrid/gridInfo/grid-info.html","<section><strong>Showing {{vm.totalItems}}<span ng-if=\"vm.inProgress\">+</span> <span ng-if=\"vm.totalItems > 0\">invoices</span><span ng-if=\"vm.totalItems <= 0\">invoice</span> <span ng-if=\"vm.isFiltered\">(filtered from {{vm.rawTotalItemCount}} total entries)</span></strong></section>");
$templateCache.put("app/main/invoice/directives/invoiceGrid/search/invoiceGridSearch.html","<md-input-container><label>Search</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.source\" ng-model-options=\"vm.delay\"></md-input-container>");
$templateCache.put("app/main/invoice/directives/invoiceGrid/status/invoice-status.html","<grid-info-component></grid-info-component><section><label class=\"text-capitalized font-size-9\">{{vm.status}}</label></section>");
$templateCache.put("app/main/invoice/emailSender/dialogs/company-recipient/company-recipient.html","<md-dialog id=\"company-recipient\" aria-label=\"Company Recipients\" flex=\"40\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Company Recipients - {{vm.companyName}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><form name=\"recipientForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"column\"><table class=\"simple company-recipients-table\" ms-responsive-table=\"\"><thead><tr><th>Select</th><th>Email</th><th>Email Type</th><th>Primary Email</th></tr></thead><tfoot><tr><td colspan=\"4\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"vm.recipients.length <= 0\"><span>No data to display.</span></div></td></tr></tfoot><tbody><tr ng-repeat=\"recipient in vm.recipients | orderBy:vm.Email\"><td><md-checkbox ng-model=\"recipient.isSelected\" ng-change=\"vm.updateCheckCount()\" aria-label=\"Select this email\"></md-checkbox></td><td class=\"email\">{{recipient.Email}}</td><td class=\"email-type\">{{vm.getEmailTypeDescription(recipient.EmailType)}}</td><td>{{vm.getDescriptionForIsPrimary(recipient.IsPrimary)}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"vm.addRecipient()\" ng-disabled=\"vm.checkCount <= 0\">Add</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoice/emailSender/dialogs/download/download-invoice.html","<md-dialog id=\"download-invoice\" aria-label=\"Send Bulk Invoices\" flex=\"20\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.Title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"zipForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"column\" ng-if=\"!vm.downloadInProgress\"><md-input-container class=\"md-block\" flex=\"\"><label translate=\"EMAILSENDER.EMAIL\"></label> <input type=\"email\" name=\"email\" ng-model=\"vm.email\" step=\"1\" required=\"\"><div ng-messages=\"zipForm.email.$error\" ng-show=\"zipForm.email.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"EMAILSENDER.EMAIL_FIELD_IS_REQUIRED\"></span></div><div ng-message=\"email\"><span translate=\"EMAILSENDER.NOT_A_VALID_EMAIL\"></span></div></div></md-input-container></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.downloadInProgress\"><br><div class=\"center\">{{\'EMAILSENDER.EMAIL_INFO_1\' | translate}}</div><div class=\"center\">{{vm.email}}</div><div class=\"center\">{{\'EMAILSENDER.EMAIL_INFO_2\' | translate}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"vm.sendEmail()\" ng-disabled=\"zipForm.$invalid\" ng-if=\"!vm.downloadInProgress\">{{\'EMAILSENDER.SEND_EMAIL\' | translate}}</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.close()\" ng-if=\"vm.downloadInProgress\">{{\'EMAILSENDER.CLOSE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoice/emailSender/dialogs/issue-dialog/issue-dialog.html","<md-dialog id=\"invoice-issue-dialog\" aria-label=\"Unresolved Issues\" flex=\"50\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Unresolved Issues ({{vm.issues.length}})</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><md-dialog-content><div layout=\"column\"><p>{{vm.message}}</p><table class=\"simple issue-dialog-table\" ms-responsive-table=\"\"><thead><tr><th>Invoice Number</th><th>Company Name</th><th>Reason</th></tr></thead><tfoot><tr><td colspan=\"4\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"vm.recipients.length <= 0\"><span>No data to display.</span></div></td></tr></tfoot><tbody><tr ng-repeat=\"issue in vm.issues\"><td>{{issue.InvoiceNumber}}</td><td>{{issue.CompanyName}}</td><td>{{issue.Reason}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"vm.onCancel()\" ng-if=\"!vm.isShowProceed\">Ok</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.onCancel()\" ng-if=\"vm.isShowProceed\">Cancel</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.onContinue()\" ng-if=\"vm.isShowProceed\">Continue</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoice/emailSender/dialogs/recipient/recipient-entry.html","<md-dialog id=\"manage-recipient\" aria-label=\"Recipient Entry\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recipient Entry</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><form name=\"recipientForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapperx\" flex=\"\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Email Address</label> <input type=\"email\" name=\"email\" ng-model=\"vm.model.email\" required=\"\"><div ng-messages=\"recipientForm.email.$error\" ng-show=\"recipientForm.email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Email field is required.</span></div><div ng-message=\"email\"><span>Not a valid email.</span></div></div></md-input-container></div><div layout=\"row\"><md-switch ng-model=\"vm.model.isUpdateCompany\" aria-label=\"Update company email\">Add this email to the company for future invoice distribution</md-switch></div><div class=\"red-700-fg h6\" ng-show=\"vm.showInlineError\">{{vm.inlineMsg}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onSave()\" class=\"md-accent md-raised\" aria-label=\"Ok\" ng-disabled=\"recipientForm.$invalid || recipientForm.$pristine || vm.showInlineError || vm.showProgress\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoice/emailSender/dialogs/recipient/recipient.html","<md-dialog id=\"manage-recipient\" aria-label=\"Manage Recipients\" flex=\"40\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Manage Recipients - {{vm.companyName}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><form name=\"recipientForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"column\"><table class=\"simple manage-recipients-table\" ms-responsive-table=\"\"><thead><tr><th>Email</th><th>Email Type</th><th>Primary Email</th><th class=\"text-right\">Actions</th></tr></thead><tfoot><tr><td colspan=\"4\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"vm.recipients.length <= 0\"><span>No data to display.</span></div></td></tr></tfoot><tbody><tr ng-repeat=\"recipient in vm.recipients | orderBy:vm.Email\"><td class=\"email\">{{recipient.Email}}</td><td class=\"email-type\">{{vm.getEmailTypeDescription(recipient.EmailType)}}</td><td>{{vm.getDescriptionForIsPrimary(recipient.IsPrimary)}}</td><td class=\"actions text-right\" style=\"padding-right: 0;\"><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" style=\"padding-right: 0; margin-right: 0\" aria-label=\"Remove recipient\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.onRemoveRecipient(recipient)\" ng-disabled=\"vm.showProgress\"><md-icon md-font-icon=\"icon-trash s20\"></md-icon><md-tooltip><span>Remove recipient</span></md-tooltip></md-button></div></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"vm.addRecipient()\" ng-disabled=\"vm.showProgress\">Add Email</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoice/emailSender/directives/customGridInfo/email-grid-info.html","<section><strong>Showing {{vm.srcData.totalItems}}<span ng-if=\"vm.srcData.inProgress\">+</span> <span ng-if=\"vm.srcData.totalItems > 1\">invoices</span><span ng-if=\"vm.srcData.totalItems <= 1\">invoice</span> <span ng-if=\"vm.srcData.isFiltered\">(filtered from {{vm.srcData.rawTotalItemCount}} total entries)</span></strong></section>");
$templateCache.put("app/main/invoice/emailSender/dialogs/recipient-logs/recipient-log.html","<md-dialog id=\"recipient-logs\" aria-label=\"Recipient Logs\" flex=\"40\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Recipient Logs - Invoice #{{vm.invoiceNumber}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><md-dialog-content><div layout=\"column\"><table class=\"simple recipients-logs-table\" ms-responsive-table=\"\"><thead><tr><th>Email</th><th>Status</th><th>Reason</th><th class=\"text-center\">Actions</th></tr></thead><tfoot><tr><td colspan=\"6\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"vm.recipients.length <= 0\"><span>No data to display.</span></div></td></tr></tfoot><tbody><tr ng-repeat=\"recipient in vm.recipients | orderBy:vm.Email\"><td class=\"email\">{{recipient.Email}}</td><td><div class=\"labels\"><span class=\"label\" ng-class=\"vm.getStatusColor(recipient.Status)\">{{vm.getStatus(recipient.Status)}}</span></div></td><td>{{recipient.StatusText == null ? \'N/A\' : recipient.StatusText}}</td><td class=\"actions text-center\" style=\"padding-right: 0;\"><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" aria-label=\"Re-send email\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.resend(recipient)\" ng-hide=\"recipient.Status == 2\"><md-icon md-font-icon=\"icon-email s20\"></md-icon><md-tooltip><span>Re-send</span></md-tooltip></md-button><div class=\"react-linear-activity react-linear-activity-custom\" ng-if=\"recipient.Status == 2\"><div class=\"react-indeterminate\"></div></div></div></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"vm.onCancel()\" ng-disabled=\"vm.showProgress\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoice/emailSender/directives/emailSenderContent/email-sender-content-view.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"invContentVm.isBusy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><div class=\"toolbar\" layout=\"column\" layout-align=\"space-between\" style=\"max-height: 150px; height: 100px;\"><div layout=\"row\" class=\"margin-override\"><md-checkbox class=\"main-checkbox md-primary\" ng-click=\"invContentVm.checkToggle()\" ng-checked=\"invContentVm.initialToggle\" ng-disabled=\"invContentVm.gridInfo.totalItems <= 0\"></md-checkbox><md-menu class=\"select-menu\" ng-disabled=\"invContentVm.isBusy || !invContentVm.initialToggle\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Filters\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"invContentVm.select(-1)\" aria-label=\"All\">All</md-button></md-menu-item><md-menu-item><md-button ng-click=\"invContentVm.select(1)\" aria-label=\"Sent\">Sent</md-button></md-menu-item><md-menu-item><md-button ng-click=\"invContentVm.select(2)\" aria-label=\"Unsent\">Unsent</md-button></md-menu-item><md-menu-item><md-button ng-click=\"invContentVm.select(3)\" aria-label=\"Failed\">Failed</md-button></md-menu-item><md-menu-item><md-button ng-click=\"invContentVm.select(4)\" aria-label=\"Skipped\">Skipped</md-button></md-menu-item></md-menu-content></md-menu><div class=\"action-buttons\" layout=\"row\" hide=\"\" show-gt-xs=\"\" style=\"padding-top: 0px;padding-bottom: 0px; width: 100%;\"><div layout=\"row\"><strong class=\"grey-600-fg\">{{invContentVm.viewTypeDesc}}</strong></div><div class=\"divider-vertical\" style=\"align-self: center;\"></div><md-switch style=\"margin:0px !important\" ng-model=\"invContentVm.isShowCreditNotes\" aria-label=\"Show credit notes in invoice listing\" ng-change=\"invContentVm.onCreditNoteChange(invContentVm.isShowCreditNotes)\">Show credit note</md-switch><div class=\"divider-vertical\" style=\"align-self: center;\"></div><md-button style=\"margin-right: 0px;\" class=\"md-icon-button\" ng-click=\"invContentVm.downloadInvoices()\" ng-disabled=\"invContentVm.isBusy || !invContentVm.initialToggle\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon><md-tooltip><span>Download Invoices Only</span></md-tooltip></md-button><span translate=\"SEND_INVOICE.INVOICES_ONLY\">Invoices Only</span><md-button style=\"margin-right: 0px;\" class=\"md-icon-button\" ng-click=\"invContentVm.downloadInvoicesAndPaperwork()\" ng-disabled=\"invContentVm.isBusy || !invContentVm.initialToggle\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon><md-tooltip><span>Download Invoices with Paperwork</span></md-tooltip></md-button><span translate=\"SEND_INVOICE.INVOICES_AND_PAPERWORK\">Invoices and Paperwork</span><md-button style=\"margin-right: 0px;\" class=\"md-icon-button\" ng-click=\"invContentVm.downloadPaperworkOnly()\" ng-disabled=\"invContentVm.isBusy || !invContentVm.initialToggle\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon><md-tooltip><span>Download Paperwork Only</span></md-tooltip></md-button><span translate=\"SEND_INVOICE.PAPERWORK_ONLY\">Paperwork Only</span><div class=\"pt-15\"><div class=\"layout-row\" ng-show=\"invContentVm.isPaymentClaimEnabled\"><md-button style=\"margin-right: 0px;\" class=\"md-icon-button\" ng-click=\"invContentVm.downloadPaymentClaims(invContentVm.paymentClaimRequestType.timesheetsOnly)\" ng-disabled=\"invContentVm.isBusy || invContentVm.checkPaymentClaim()\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon><md-tooltip><span>Download Timesheets Only</span></md-tooltip></md-button><span translate=\"SEND_INVOICE.TIMESHEETS_ONLY\">Timesheets Only*</span><md-button style=\"margin-right: 0px;\" class=\"md-icon-button\" ng-click=\"invContentVm.downloadPaymentClaims(invContentVm.paymentClaimRequestType.invoicesAndTimesheets)\" ng-disabled=\"invContentVm.isBusy || invContentVm.checkPaymentClaim()\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon><md-tooltip><span>Download Invoices and Timesheets</span></md-tooltip></md-button><span translate=\"SEND_INVOICE.INVOICES_AND_TIMESHEETS\">Invoices and Timesheets*</span></div><div class=\"layout-row\" ng-show=\"invContentVm.isPaymentClaimEnabled\"><div class=\"ml-20\">*Can only choose 1 client for this option</div></div></div><div class=\"divider-vertical\" style=\"align-self: center;\" ng-if=\"invContentVm.issues.length > 0\"></div><a href=\"#\" class=\"red-400-fg font-weight-900\" ng-if=\"invContentVm.issues.length > 0\" ng-click=\"invContentVm.openIssues()\">{{invContentVm.message}} ({{invContentVm.issues.length}})</a></div><div><md-button class=\"md-warn md-raised\" aria-label=\"Send Mail\" ng-click=\"invContentVm.sendMail()\" ng-disabled=\"invContentVm.isBusy || !invContentVm.initialToggle\">Send Mail<md-tooltip><span>Email Invoice</span></md-tooltip></md-button></div></div><div layout=\"row\" class=\"margin-override\"><div class=\"action-buttons\" layout=\"row\" hide=\"\" show-gt-xs=\"\" style=\"padding-top: 0px;padding-bottom: 0px; width: 100%;\"><div layout=\"row\" layout-align=\"start center\"><email-grid-info-component src-data=\"invContentVm.gridInfo\"></email-grid-info-component></div><div class=\"divider-vertical\" style=\"align-self: center;\" ng-if=\"invContentVm.selectedItemsCount > 0\"></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"invContentVm.selectedItemsCount > 0\">Selected: {{invContentVm.selectedItemsCount}}</div></div></div></div><div id=\"invoice-dist-wrapper\" class=\"content-wrapper\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\"><email-grid-content-component check-item=\"invContentVm.checkItem(id)\"></email-grid-content-component></md-content></div>");
$templateCache.put("app/main/invoice/emailSender/directives/emailGridContent/email-grid-content.html","<invoice-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div class=\"h4 grey-600-fg\" layout=\"row\" layout-align=\"center center\" style=\"margin-top: 25%;\" ng-if=\"emailGridContentVm.model.grid.data.length <= 0\">No current record(s) to display.</div><md-virtual-repeat-container id=\"vertical-container\" style=\"height: 800px;\"><div classname=\"thread-list\"><div classname=\"thread\"><div md-virtual-repeat=\"invoice in emailGridContentVm.model.grid.data\" class=\"repeated-item\" md-item-size=\"10\" flex=\"\"><div class=\"main-row-item unsent-item\"><div class=\"layout-row item\"><div class=\"layout-row flex-5 layout-align-start-center\"><div class=\"check-itm\"><div class=\"flex\"><md-checkbox aria-label=\"Checkbox\" ng-model=\"invoice.Selected\" ng-change=\"emailGridContentVm.onCheckeditem(invoice.Id)\"></md-checkbox></div></div></div><div class=\"layout-row flex-60 item-body\"><div><div class=\"margin-bottom-8\"><span class=\"item-title\">{{invoice.CompanyName}}</span></div><h5 class=\"margin-0 padding-0\">{{invoice.BranchName}}</h5><h6 class=\"margin-0 padding-0 grey-600-fg\">Recipients: <span ng-if=\"invoice.EmailRecipients.length > 4\">{{emailGridContentVm.getEmailRecipients(invoice.EmailRecipients)}}...</span> <span ng-if=\"invoice.EmailRecipients.length != 0 && invoice.EmailRecipients.length <= 4\">{{emailGridContentVm.getEmailRecipients(invoice.EmailRecipients)}}</span> <span ng-if=\"invoice.EmailRecipients.length == 0\">- No recipients -</span></h6><h5 class=\"margin-top-8 padding-top-2\">Total {{invoice.TotalIncludingTax | currency:\"$\":2}}</h5></div></div><div class=\"layout-row flex-25 layout-align-end-start item-body\"><div class=\"text-right\"><span>Invoice No# {{invoice.InvoiceNumber}}</span><br><span>PO# {{invoice.PurchaseOrderNumber}}</span><br><span>Company Code: {{invoice.CompanyCode}}</span></div></div><div class=\"layout-row flex-10 layout-align-end-center\"><div><div class=\"h6 text-center font-size-10\">{{invoice.ProcessStatus}}</div><div class=\"react-linear-activity\" ng-if=\"invoice.IsProcessing\"><div class=\"react-indeterminate\"></div></div><div class=\"text-center\" ng-if=\"!invoice.IsProcessing\"><a href=\"#\" ng-click=\"emailGridContentVm.addRecipient(invoice.Id, invoice.CompanyName, invoice.EmailRecipients, invoice.CompanyId)\"><i class=\"icon-account-plus s16 grey-500-fg margin-left-5 margin-top-5\"></i><md-tooltip>Add Recipients</md-tooltip></a> <a href=\"#\" ng-click=\"emailGridContentVm.onGetRecipientLogs(invoice.Id, invoice.InvoiceNumber, invoice.EmailRecipients)\"><i class=\"icon-message-text-outline s16 grey-500-fg margin-left-5 margin-top-5\"></i><md-tooltip>Log Entries</md-tooltip></a></div><span>{{invoice.InvoiceDate | date: \"dd MMM yyyy\"}}</span><div class=\"labels\"><span class=\"label sent\" ng-if=\"invoice.EmailDeliveryStatus == 1\">SENT</span> <span class=\"label unsent\" ng-if=\"invoice.EmailDeliveryStatus == 2\">UNSENT</span> <span class=\"label failed\" ng-if=\"invoice.EmailDeliveryStatus == 3\">FAILED</span> <span class=\"label skipped\" ng-if=\"invoice.EmailDeliveryStatus == 4\">SKIPPED</span></div></div></div></div></div></div></div></div></md-virtual-repeat-container></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><invoice-grid-pagination-component behavior=\"emailGridContentVm.model.grid.api\" distinct-by=\"InvoiceNumber\" on-init=\"emailGridContentVm.model.grid.onInit()\" on-error=\"emailGridContentVm.model.grid.onError(ex)\" on-completed=\"emailGridContentVm.model.grid.onCompleted(data)\" on-data-filter=\"emailGridContentVm.model.grid.onDataFilter()\" on-data-loading=\"emailGridContentVm.model.grid.onDataLoading()\" on-data-loading-completed=\"emailGridContentVm.model.grid.onDataLoadingCompleted()\" allow-custom-client-side-filtering=\"emailGridContentVm.model.grid.allowCustomClientSideFiltering\" on-apply-custom-client-side-filtering=\"emailGridContentVm.model.grid.onCustomClientSideFiltering(data)\" auto-fetch=\"false\"></invoice-grid-pagination-component></div></div></invoice-grid-component>");
$templateCache.put("app/main/invoice/reports/dialogs/confirm-delete-checked-items/confirm-delete-cheked-items-dialog.html","<md-dialog id=\"edit-invoice-item\" aria-label=\"Ticket Company View\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h3>Deletion of Line Item(s)</h3></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-content>Are you sure you want to delete {{vm.desc}}?</md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Cancel</md-button><md-button ng-click=\"vm.onYes()\">Yes</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoice/reports/dialogs/edit-invoice/edit-invoice-item-dialog.html","<md-dialog id=\"edit-invoice-item\" aria-label=\"Ticket Company View\" flex=\"100\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span class=\"truncate-500\">INV# {{vm.model.data.invoiceNo}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><editable-line-item-component lineitems=\"vm.model.data.lineItems\" ratecarditems=\"vm.model.rateCardItems\" isaltusspecialenabled=\"vm.model.isAltusSpecialEnabled\" itemcodes=\"vm.model.itemCodes\" costcodes=\"vm.model.costCodesLookup\" onaddrow=\"vm.model.onAddRow\" ondelete=\"vm.model.onRemoveRow\" ontoggleedit=\"vm.model.onToggleEdit\" ondeleteselected=\"vm.model.onDeleteSelected\" onrefreshratecard=\"vm.model.onRefreshRateCard\" checkdescriptioncontroltype=\"vm.model.onCheckDescriptionControlType\" localization=\"vm.model.locale\" defaulttaxrate=\"vm.model.defaultTaxRate\" onedittaxrate=\"vm.model.onEditTaxRate\" oneditalltaxrate=\"vm.model.onEditAllTaxRate\" watch-depth=\"value\" taxroundingrule=\"vm.model.taxRoundingRule\" onchangeitemcode=\"vm.model.onChangeItemCode\"></editable-line-item-component><div class=\"red-500-fg text-center\" ng-show=\"vm.showLineItemValError\">* Provide at least one (1) line item to continue saving.</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\" class=\"md-raised\">Cancel</md-button><md-button ng-click=\"vm.onSave()\" ng-disabled=\"vm.model.disableSave\" class=\"md-accent md-raised\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoice/reports/dialogs/inv-confirm-dialog/inv-confirm-dialog.html","<md-dialog id=\"edit-invoice-item\" aria-label=\"Ticket Company View\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h3>Deletion of invoice detail</h3></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-content>Are you sure you want to delete invoice detail for: {{vm.desc}} ?</md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Cancel</md-button><md-button ng-click=\"vm.onYes()\">Yes</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoice/reports/directives/customGridInfo/custom-grid-info.html","<section><strong>Showing {{customGridInfoVm.srcData.totalItems}}<span ng-if=\"customGridInfoVm.srcData.inProgress\">+</span> <span ng-if=\"customGridInfoVm.srcData.totalItems > 1\">invoices</span><span ng-if=\"customGridInfoVm.srcData.totalItems <= 1\">invoice</span> <span ng-if=\"customGridInfoVm.srcData.isFiltered\">(filtered from {{customGridInfoVm.srcData.rawTotalItemCount}} total entries)</span></strong></section>");
$templateCache.put("app/main/invoice/reports/dialogs/inv-line-item-val/inv-line-item-dialog.html","<md-dialog id=\"edit-invoice-item\" aria-label=\"Ticket Company View\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h3>Invalid Input</h3></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-content><span class=\"red-700-fg\">{{vm.desc}}</span></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoice/reports/directives/invoiceContent/invoice-content-view.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"invContentVm.model.grid.api.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><div class=\"toolbar p-15\" layout=\"row\" layout-align=\"space-between center\" ng-class=\"invContentVm.model.grid.api.busy ? \'toolbar-content-with-progress\' : \'toolbar-content\'\"><div layout=\"row\" layout-align=\"start center\"><custom-grid-info-component src-data=\"invContentVm.model.gridInfo\"></custom-grid-info-component></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-success md-raised\" aria-label=\"PDF\" translate=\"\" translate-attr-aria-label=\"INVOICE_REPORT.FINALISE\" ng-click=\"invContentVm.finalise()\" ng-disabled=\"invContentVm.model.grid.data.length <= 0 || (!invContentVm.model.gridInfo.canFinaliseInvoice)\">Finalise</md-button><md-menu class=\"settings-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\" ng-disabled=\"invContentVm.model.contentLoading\"><md-icon md-font-icon=\"icon-filter\" ng-class=\"{ \'amber-700-fg\': invContentVm.viewMode != \'all\', \'\': invContentVm.viewMode == \'all\'}\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"invContentVm.showAll()\"><md-icon md-font-icon=\"{{invContentVm.viewMode == \'all\' ? \'icon-checkbox-marked\' : \'icon-checkbox-blank-outline\'}}\" class=\"md-accent\"></md-icon><span translate=\"INVOICE_REPORT.MENU1\">Show All</span></md-button></md-menu-item><md-menu-item hide-xs=\"\"><md-button ng-click=\"invContentVm.filterByReviewed()\"><md-icon md-font-icon=\"{{invContentVm.viewMode == \'byReviewed\' ? \'icon-checkbox-marked\' : \'icon-checkbox-blank-outline\'}}\" class=\"md-accent\"></md-icon><span translate=\"INVOICE_REPORT.MENU2\">Filter By Reviewed</span></md-button></md-menu-item><md-menu-item hide-xs=\"\"><md-button ng-click=\"invContentVm.notReviewed()\"><md-icon md-font-icon=\"{{invContentVm.viewMode == \'notReviewed\' ? \'icon-checkbox-marked\' : \'icon-checkbox-blank-outline\'}}\" class=\"md-accent\"></md-icon><span translate=\"INVOICE_REPORT.MENU3\">Not Reviewed</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"column\" flex=\"\"><md-content flex=\"\" ms-scroll=\"{suppressScrollX: true}\"><report-viewer-component flex=\"\"></report-viewer-component></md-content></div>");
$templateCache.put("app/main/messaging/generalMessaging/components/contactsArea/contactsArea.html","<div class=\"contactsArea\" ng-class=\"{\'big-screen\' : vm.mediaService.isDeviceMessagingBig(), \'small-screen\' : vm.mediaService.isDeviceMessagingSmall()}\" layout=\"column\"><md-card class=\"contacts-area-big\" dimmer=\"\" ng-model=\"vm.service.is_sending\"><md-card-header layout=\"row\"><div layout=\"row\" flex=\"\"><span><i class=\"icon icon-uniform-color icon-account-circle\"></i></span> <span class=\"margin-left-10\" ng-class=\"{\'md-body-2 header-text\' : vm.service.mediaQueryService.isDevice1457(), \'md-subhead header-text\' : vm.service.mediaQueryService.isDeviceMessagingBig()}\">{{vm.service.mediaQueryService.isDevice1457() ? (\'MESSAGING.PEOPLE\' | translate) : (\'MESSAGING.AVAILABLE\' | translate)}}</span></div><div ng-if=\"!vm.service.is_loading\"><span><i ng-click=\"vm.showFilterDialog()\" class=\"icon-clickable s25 icon icon-filter-variant icon-uniform-color\"><md-tooltip>{{\'MESSAGING.FILTER_CONTACTS\' | translate}}</md-tooltip></i></span></div></md-card-header><md-card-content layout=\"column\" ng-style=\"{ \'opacity\' : (vm.service.is_sending || vm.service.is_loading) ? \'0.5\' : \'1\' }\"><div layout=\"row\"><div class=\"status\">{{\'MESSAGING.AVAILABLE\' | translate}} : {{vm.service.contacts_available.length}}</div></div><md-input-container class=\"md-block margin-top-20\"><input type=\"text\" placeholder=\"{{\'MESSAGING.SEARCH\' | translate}}\" ng-model=\"vm.service.query\"></md-input-container><div layout=\"row\" class=\"margin-left-15 margin-right-15\" ng-style=\"{\'border-bottom\' : (vm.service.contacts_ready > 0) ? \'3px\' : \'3px dashed teal\' }\"><span flex-auto=\"\"><i class=\"icon icon-clickable icon-account-multiple-plus\" ng-click=\"vm.service.addAll()\" style=\"color : #0b93d5\"><md-tooltip>Add all employees</md-tooltip></i></span> <span flex-auto=\"\" class=\"margin-left-20 margin-top-5 md-body-2\" style=\"color: #475A64;\"><a ng-click=\"vm.service.addAll()\" style=\"cursor: pointer;\">{{vm.service.mediaQueryService.isDevice1457() ? \'Add all\' : \'Add all Employees\'}}</a></span><div style=\"height : 40px;\"></div></div><div ng-if=\"vm.service.contacts_ready.length > 0\" layout=\"row\" class=\"margin-left-15 margin-right-15 margin-top-15\" style=\"border-bottom: 3px dashed teal;\"><span flex-auto=\"\"><i class=\"icon icon-clickable icon-account-remove red-700-fg\" ng-click=\"vm.service.removeAll()\"><md-tooltip>Remove All Selected</md-tooltip></i></span> <span flex-auto=\"\" class=\"margin-left-20 margin-top-5 md-body-2\" style=\"color: #475A64;\"><a ng-click=\"vm.service.removeAll()\" style=\"cursor: pointer;\">{{vm.service.mediaQueryService.isDevice1457() ? \'Remove all\' : \'Remove all Selected\'}}</a></span><div style=\"height : 40px;\"></div></div><div flex=\"\" class=\"margin-top-15 scrollable main-list\" ms-scroll=\"\"><md-list flex=\"\"><md-list-item flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"md-1-line\" ng-repeat=\"contact in vm.service.contacts_available | filter : vm.service.query | orderBy : \'Name\'\"><div class=\"flex-20\"><i ng-click=\"vm.service.onAddPerson(contact)\" ng-dblclick=\"vm.service.onRemovePerson(contact)\" ng-class=\"{\'green-600-fg icon-account-check\' : contact.Selected, \'blue-grey-700-fg icon-account-plus s20\' : !contact.Selected}\" class=\"icon icon-clickable\"><md-tooltip ng-if=\"contact.Selected\">{{\'MESSAGING.CONTACT_ADDED\' | translate}}</md-tooltip><md-tooltip ng-if=\"!contact.Selected\">{{\'MESSAGING.ADD_AS_RECIPIENT\' | translate}}</md-tooltip></i></div><div ng-dblclick=\"vm.service.onRemovePerson(contact)\" class=\"flex-80 list-name\" ng-class=\"{\'margin-left-10\' : vm.service.mediaQueryService.isDevice1457()}\"><span ng-class=\"{\'h5 margin-left-0\' : vm.service.mediaQueryService.isDevice1457(), \'md-body-2\' : !vm.service.mediaQueryService.isDevice1457(), \'text-strike grey-600-fg\' : contact.Selected}\">{{contact.Name}}</span><md-tooltip ng-if=\"contact.Selected\">{{\'MESSAGING.CONTACT_ADDED\' | translate}}</md-tooltip></div><md-divider></md-divider></md-list-item></md-list></div></md-card-content></md-card></div>");
$templateCache.put("app/main/messaging/generalMessaging/components/dialog/message-dialog.html","<md-dialog class=\"main-style message-dialog\" flex=\"{{vm.mediaService.isDeviceMessagingBig() ? 40 : 90}}\"><form name=\"messageFilter\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"MESSAGING.FILTER_CONTACTS\" ng-if=\"vm.mediaService.isDeviceMessagingBig() || (vm.mediaService.isDeviceMessagingSmall() && vm.showFiltersArea)\"></h2><h2 translate=\"MESSAGING.AVAILABLE\" ng-if=\"vm.mediaService.isDeviceMessagingSmall() && !vm.showFiltersArea\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-body-1\"><div ng-if=\"vm.messageDialogService.searching && vm.showFiltersArea\" layout=\"row\"><span class=\"md-body-1\">{{vm.messageDialogService.process_message}} &nbsp;&nbsp; ...</span></div><md-progress-linear class=\"margin-top-5\" ng-if=\"vm.messageDialogService.searching\" md-mode=\"indeterminate\"></md-progress-linear><span class=\"add-ticket\" ng-if=\"!vm.messageDialogService.searching && vm.showFiltersArea\" flex=\"\"><span flex=\"\"></span><md-icon ng-click=\"vm.changeSearchCriteria()\" class=\"ticket-icon\" md-font-icon=\"icon-ticket\"><md-tooltip>{{vm.filter_by_ticket_number ? (\'MESSAGING.FILTER_BY_CRITERIA\' | translate) : (\'MESSAGING.FILTER_BY_TICKET_NUMBER\' | translate)}}</md-tooltip></md-icon><a class=\"md-caption ticket-link\" ng-click=\"vm.filter_by_ticket_number = !vm.filter_by_ticket_number\">{{vm.filter_by_ticket_number ? (\'MESSAGING.FILTER_BY_CRITERIA\' | translate) : (\'MESSAGING.FILTER_BY_TICKET_NUMBER\' | translate)}}</a></span><div ng-if=\"!vm.showFiltersArea\" class=\"margin-top-25\" ng-style=\"{\'opacity\' : (vm.messageDialogService.searching) ? \'0.5\' : \'1\'}\" flex=\"\"><div class=\"margin-left-20\" layout=\"row\" flex=\"auto\"><div class=\"status\">{{\'MESSAGING.AVAILABLE\' | translate}} : {{vm.messagingService.contacts_available.length}}</div></div><md-subheader><md-input-container class=\"md-block margin-top-20\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.messagingService.query\"></md-input-container></md-subheader><div ng-if=\"vm.messagingService.contacts_available.length > 0\" layout=\"row\" class=\"margin-left-15 margin-right-15\" ng-style=\"{\'border-bottom\' : (vm.messagingService.contacts_ready > 0) ? \'3px\' : \'3px dashed teal\' }\"><span flex-auto=\"\"><i class=\"icon icon-clickable icon-account-multiple-plus\" ng-click=\"vm.messagingService.addAll()\" style=\"color : #0b93d5\"><md-tooltip>Add all employees</md-tooltip></i></span> <span flex-auto=\"\" class=\"margin-left-20 margin-top-5 md-body-2\" style=\"color: #475A64;\"><a ng-click=\"vm.messagingService.addAll()\" style=\"cursor: pointer;\">{{vm.messagingService.mediaQueryService.isDevice1457() ? \'Add all\' : \'Add all Employees\'}}</a></span><div style=\"height : 40px;\"></div></div><div ng-if=\"vm.messagingService.contacts_ready.length > 0\" layout=\"row\" class=\"margin-left-15 margin-right-15\" style=\"border-bottom: 3px dashed teal;\"><span flex-auto=\"\"><i class=\"icon icon-clickable icon-account-remove red-700-fg\" ng-click=\"vm.messagingService.removeAll()\"><md-tooltip>Remove All Selected</md-tooltip></i></span> <span flex-auto=\"\" class=\"margin-left-20 margin-top-5 md-body-2\" style=\"color: #475A64;\"><a ng-click=\"vm.messagingService.removeAll()\" style=\"cursor: pointer;\">{{vm.messagingService.mediaQueryService.isDevice1457() ? \'Remove all\' : \'Remove all Selected\'}}</a></span><div style=\"height : 40px;\"></div></div><md-list class=\"margin-top-20\"><md-list-item flex=\"\" class=\"list-item md-1-line\" ng-repeat=\"contact in vm.messagingService.contacts_available | filter : vm.messagingService.query | orderBy : \'Name\'\"><div class=\"flex-20\"><i ng-click=\"vm.messagingService.addPerson(contact)\" ng-class=\"{\'green-600-fg icon-account-check\' : contact.Selected, \'blue-grey-700-fg icon-account-plus s20\' : !contact.Selected}\" class=\"icon icon-clickable\"><md-tooltip ng-if=\"contact.Selected\">{{\'MESSAGING.CONTACT_ADDED\' | translate}}</md-tooltip><md-tooltip ng-if=\"!contact.Selected\">{{\'MESSAGING.ADD_AS_RECIPIENT\' | translate}}</md-tooltip></i></div><div class=\"flex-auto list-name\"><span ng-class=\"{\'text-strike grey-600-fg\' : contact.Selected}\">{{contact.Name}}</span><md-tooltip ng-if=\"contact.Selected\">{{\'MESSAGING.CONTACT_ADDED_2\' | translate}}</md-tooltip></div><div class=\"flex-10\" layout=\"row\" layout-align=\"end center\"><i ng-if=\"contact.Selected\" ng-click=\"vm.messagingService.onRemovePerson(contact)\" class=\"icon icon-clickable red-600-fg icon-account-remove\"><md-tooltip>{{\'MESSAGING.REMOVE_CONTACT\' | translate}}</md-tooltip></i></div><md-divider></md-divider></md-list-item></md-list></div><div ng-if=\"vm.showFiltersArea && !vm.filter_by_ticket_number\" class=\"margin-top-25\" ng-style=\"{\'opacity\' : (vm.messageDialogService.searching) ? \'0.5\' : \'1\'}\" flex=\"\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex=\"\"><md-input-container name=\"branch\" md-no-float=\"\" class=\"md-block\"><label translate=\"MESSAGING.BRANCH\"></label><md-select md-no-float=\"\" ng-change=\"vm.changeBranch(vm.search_model.BranchId)\" name=\"branch\" ng-disabled=\"vm.messageDialogService.searching\" ng-model=\"vm.search_model.BranchId\" required=\"\"><md-option ng-value=\"branch.Id\" ng-repeat=\"branch in vm.branch_lookup\">{{branch.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label translate=\"MESSAGING.DIVISIONS\"></label><md-select ng-model=\"vm.search_model.DivisionIds\" ng-change=\"vm.getCompanies()\" md-selected-text=\"vm.getDivisionsText(vm.search_model.DivisionIds, vm.division_lookup)\" ng-disabled=\"vm.messageDialogService.searching\" ng-model-options=\"{trackBy : \'$value\'}\" multiple=\"\"><md-option ng-value=\"division.Id\" ng-repeat=\"division in vm.division_lookup\">{{division.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex=\"\"><md-input-container class=\"md-block\"><label translate=\"MESSAGING.EMPLOYMENT_STATUS\"></label><md-select ng-disabled=\"vm.messageDialogService.searching\" ng-model-options=\"{trackBy : \'$value\'}\" ng-model=\"vm.search_model.EmploymentStatus\"><md-option ng-value=\"status.Id\" ng-repeat=\"status in vm.employment_status_list\">{{status.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label translate=\"MESSAGING.SKILL_LEVEL\"></label><md-select ng-disabled=\"vm.messageDialogService.searching\" ng-model-options=\"{trackBy : \'$value\'}\" ng-model=\"vm.search_model.SkillLevelId\"><md-option ng-value=\"level.Id\" ng-repeat=\"level in vm.skills_level_list\">{{level.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-input-container ng-if=\"vm.messageDialogService.Ticket == null\" class=\"md-block\"><label translate=\"MESSAGING.SKILLS\"></label><md-select ng-model=\"vm.search_model.SkillIds\" ng-model-options=\"{trackBy : \'$value\'}\" md-selected-text=\"vm.skillsSelected(vm.search_model.SkillIds, vm.Skills_list)\" ng-disabled=\"vm.messageDialogService.searching\" multiple=\"\"><md-option ng-value=\"skill.Id\" ng-repeat=\"skill in vm.Skills_list | orderBy : \'Name\'\">{{skill.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-autocomplete flex=\"\" ng-disabled=\"vm.messageDialogService.searching\" ng-if=\"vm.messageDialogService.Ticket == null && vm.search_model.BranchId != null && vm.company_list.length > 0\" class=\"company\" md-no-cache=\"true\" md-selected-item=\"vm.selectedItem\" md-selected-item-change=\"vm.itemChange(item)\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.Name\" md-require-match=\"\" md-floating-label=\"{{\'MESSAGING.COMPANY\' | translate}}\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.Name}}</span></md-item-template></md-autocomplete></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex=\"\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"MESSAGING.DATE\"></label><md-datepicker ng-required=\"vm.search_model.Time != null || vm.search_model.ShiftDuration != null\" ng-disabled=\"vm.messageDialogService.searching\" ng-model=\"vm.search_model.Date\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container><md-input-container flex=\"\" ng-disabled=\"vm.messageDialogService.searching\" class=\"md-block\"><input type=\"text\" ng-required=\"vm.search_model.Date != null\" ng-model=\"vm.search_model.Time\" time-picker=\"\" placeholder=\"{{\'MESSAGING.TIME\' | translate}}\"></md-input-container><md-input-container flex=\"\" ng-disabled=\"vm.messageDialogService.searching\" class=\"md-block\"><input type=\"number\" ng-model=\"vm.search_model.ShiftDuration\" placeholder=\"{{\'MESSAGING.SHIFT_DURATION\' | translate}}\"></md-input-container></div></div><div ng-if=\"vm.showFiltersArea && vm.filter_by_ticket_number\" class=\"margin-top-25\" ng-style=\"{\'opacity\' : (vm.messageDialogService.searching) ? \'0.5\' : \'1\'}\" flex=\"\"><div layout=\"row\" flex=\"\" ng-if=\"vm.isTicketNil(vm.ticket_detail)\"><md-input-container flex=\"\" ng-disabled=\"vm.messageDialogService.searching\" class=\"md-block\"><input type=\"number\" min=\"0\" ng-model=\"vm.ticket_number\" placeholder=\"{{\'MESSAGING.TICKET_NUMBER\' | translate}}\"></md-input-container><div><button ng-click=\"vm.addTicket(vm.ticket_number)\" ng-disabled=\"vm.isTicketNil(vm.ticket_number) || vm.isEmpty(vm.ticket_number)\" md-ink-ripple=\"\" style=\"font-size : 10px;\" class=\"md-fab md-mini md-button md-default-theme md-ink-ripple\" type=\"button\"><md-icon md-font-icon=\"icon-magnify\" class=\"md-default-theme\" role=\"img\"></md-icon></button></div></div><messaging-ticket-detail ng-if=\"!vm.isTicketNil(vm.ticket_detail)\"></messaging-ticket-detail><div style=\"margin-top : 20px;\" ng-if=\"!vm.isTicketNil(vm.ticket_detail)\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex=\"\"><md-input-container class=\"md-block\"><label translate=\"MESSAGING.EMPLOYMENT_STATUS\"></label><md-select ng-disabled=\"vm.messageDialogService.searching\" ng-model-options=\"{trackBy : \'$value\'}\" ng-model=\"vm.search_model.EmploymentStatus\"><md-option ng-value=\"status.Id\" ng-repeat=\"status in vm.employment_status_list\">{{status.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label translate=\"MESSAGING.SKILL_LEVEL\"></label><md-select ng-disabled=\"vm.messageDialogService.searching\" ng-model-options=\"{trackBy : \'$value\'}\" ng-model=\"vm.search_model.SkillLevelId\"><md-option ng-value=\"level.Id\" ng-repeat=\"level in vm.skills_level_list\">{{level.Name}}</md-option></md-select></md-input-container></div><div flex=\"\" layout=\"row\" ng-if=\"!vm.isTicketNil(vm.ticket_detail)\"><md-input-container class=\"md-block\"><label translate=\"MESSAGING.SHIFT\"></label><md-select ng-model=\"vm.search_model.ShiftId\" ng-required=\"true\" ng-disabled=\"vm.messageDialogService.searching\"><md-option ng-value=\"shift.Id\" ng-repeat=\"shift in vm.ticket_detail.Shifts\">{{shift.Name}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div layout=\"row\" flex=\"\"><md-button ng-click=\"vm.changeView()\" class=\"md-raised md-accent\" translate=\"MESSAGING.FILTER_OPTIONS\" ng-if=\"vm.mediaService.isDeviceMessagingSmall() && !vm.showFiltersArea\"></md-button><md-button ng-click=\"vm.changeView()\" class=\"md-raised md-accent\" translate=\"MESSAGING.SHOW_PEOPLE\" ng-if=\"vm.mediaService.isDeviceMessagingSmall() && vm.showFiltersArea && vm.messagingService.contacts_available.length > 0\"></md-button></div><div layout=\"row\" layout-align=\"end center\" flex=\"\"><md-button ng-if=\"vm.showFiltersArea\" ng-click=\"vm.filter()\" translate=\"MESSAGING.FILTER\" ng-disabled=\"vm.isDisabled(messageFilter)\" class=\"md-raised md-accent\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoice/reports/directives/reportViewer/invoice-popup-resource.html","<style>\r\n    table.simple {\r\n        font-family:  \"Roboto\", \"Helvetica Neue\", \"Arial\", sans-serif;\r\n        width: 100%;\r\n        border: none;\r\n        border-spacing: 0;\r\n        text-align: left;\r\n    }\r\n\r\n    table.simple.clickable tr {\r\n        cursor: pointer;\r\n    }\r\n\r\n    table.simple.clickable tr:hover {\r\n        background: rgba(0, 0, 0, 0.03);\r\n    }\r\n\r\n    table.simple th {\r\n        padding: 16px 8px;\r\n        font-weight: 500;\r\n        color: rgba(0, 0, 0, 0.54);\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n        white-space: nowrap;\r\n        min-width: 120px;\r\n    }\r\n\r\n    table.simple th:first-child {\r\n        padding-left: 24px;\r\n    }\r\n\r\n    table.simple th:last-child {\r\n        padding-right: 24px;\r\n    }\r\n\r\n    table.simple td {\r\n        padding: 9px 8px;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n    }\r\n\r\n    table.simple td:first-child {\r\n        padding-left: 24px;\r\n    }\r\n\r\n    table.simple td:last-child {\r\n        padding-right: 24px;\r\n    }\r\n\r\n    table.simple tr:last-child td {\r\n        border-bottom: none;\r\n    }\r\n\r\n    .invoice-table {\r\n        margin-top: 16pt;\r\n    }\r\n\r\n    thead {\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    th {\r\n        font-size: 10pt;\r\n        max-width: 60pt;\r\n    }\r\n\r\n    th:first-child {\r\n        padding-left: 0;\r\n    }\r\n\r\n    th:last-child {\r\n        padding-right: 0;\r\n    }\r\n\r\n    td {\r\n        font-size: 12px;\r\n        border-bottom: 0;\r\n        padding: 5px 8px;\r\n    }\r\n\r\n    td:first-child {\r\n        padding-left: 0;\r\n    }\r\n\r\n    td:last-child {\r\n        padding-right: 0;\r\n    }\r\n\r\n    tr:nth-child(odd) {\r\n        background-color: #f4f4f4;\r\n    }\r\n\r\n    tr:nth-child(even) {\r\n        background-color: #fff;\r\n    }\r\n\r\n    tbody:before {\r\n        content: \"-\";\r\n        display: block;\r\n        line-height: 1em;\r\n        color: transparent;\r\n    }\r\n\r\n    .title {\r\n        font-size: 10pt;\r\n    }\r\n\r\n    .detail {\r\n        margin-top: 4pt;\r\n        font-size: 9pt;\r\n        max-width: none;\r\n    }\r\n\r\n    .qty-col {\r\n        width: 100px;\r\n    }\r\n\r\n    .unit-price-col {\r\n        width: 120px;\r\n    }\r\n\r\n    .amt-col {\r\n        width: 130px;\r\n    }\r\n\r\n    .start-time-col {\r\n        width: 180px;\r\n    }\r\n\r\n    .end-time-col {\r\n        width: 180px;\r\n    }\r\n\r\n    .hrs-col {\r\n        width: 180px;\r\n    }\r\n</style><h1>Sample</h1><table class=\"simple invoice-table invoice-resource-table\"><thead><tr><th>Resource Item</th><th class=\"text-right start-time-col\">Start Time</th><th class=\"text-right end-time-col\">Break</th><th class=\"text-right end-time-col\">End Time</th><th class=\"text-right hrs-col\">Hours</th></tr></thead><tbody><tr><td>232228 - Traffic Controller (Albert Grant)</td><td class=\"text-right\">07:00</td><td class=\"text-right\">N/A</td><td class=\"text-right\">16:00</td><td class=\"text-right\">9</td></tr><tr><td>232229 - Traffic Controller (Albert Grant)</td><td class=\"text-right\">07:00</td><td class=\"text-right\">N/A</td><td class=\"text-right\">14:00</td><td class=\"text-right\">7</td></tr><tr><td>232243 - Traffic Controller (Karen Dunn)</td><td class=\"text-right\">10:00</td><td class=\"text-right\">12:00-12:30</td><td class=\"text-right\">18:00</td><td class=\"text-right\">7.5</td></tr><tr><td>232244 - Traffic Controller (Karen Dunn)</td><td class=\"text-right\">10:00</td><td class=\"text-right\">12:00-12:30</td><td class=\"text-right\">18:00</td><td class=\"text-right\">7.5</td></tr><tr><td>232245 - Traffic Controller (Karen Dunn)</td><td class=\"text-right\">10:00</td><td class=\"text-right\">12:00-12:30</td><td class=\"text-right\">18:00</td><td class=\"text-right\">7.5</td></tr><tr><td>232246 - Traffic Controller (Karen Dunn)</td><td class=\"text-right\">10:00</td><td class=\"text-right\">12:00-12:30</td><td class=\"text-right\">18:00</td><td class=\"text-right\">7.5</td></tr></tbody></table>");
$templateCache.put("app/main/invoice/reports/directives/reportViewer/report-viewer.html","<invoice-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div class=\"h4 grey-600-fg\" layout=\"row\" layout-align=\"center center\" style=\"margin-top: 25%;\" ng-if=\"invRepVm.model.grid.data.length <= 0\">No current record(s) to display.</div><inv-report-content-component invoicelist=\"invRepVm.model.grid.data\" oneditinvoice=\"invRepVm.model.grid.editInvoice\" ondownloadinvoice=\"invRepVm.model.grid.downloadInvoice\" ondeleteinvoice=\"invRepVm.model.deleteInvoice\" oneditticket=\"invRepVm.model.editTicket\" onedittimesheet=\"invRepVm.model.editTimesheet\" onmarkasreviewed=\"invRepVm.model.markAsReviewed\" showdetails=\"invRepVm.model.showDetails\" dateformat=\"invRepVm.dateFormat\" showtags=\"invRepVm.model.showTags\" showincludedtags=\"invRepVm.model.showIncludedTags\"></inv-report-content-component></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><invoice-grid-pagination-component behavior=\"invRepVm.model.grid.api\" distinct-by=\"InvoiceNumber\" on-init=\"invRepVm.model.grid.onInit()\" on-error=\"invRepVm.model.grid.onError(ex)\" on-completed=\"invRepVm.model.grid.onCompleted(data)\" on-data-filter=\"invRepVm.model.grid.onDataFilter()\" on-data-loading=\"invRepVm.model.grid.onDataLoading()\" on-data-loading-completed=\"invRepVm.model.grid.onDataLoadingCompleted()\" on-ready=\"invRepVm.model.grid.onReady()\" custom-grid-search-service=\"invRepVm.customGridService\" allow-custom-client-side-filtering=\"invRepVm.model.grid.allowCustomClientSideFiltering\" on-apply-custom-client-side-filtering=\"invRepVm.model.grid.onCustomClientSideFiltering(data)\" auto-fetch=\"false\"></invoice-grid-pagination-component></div></div></invoice-grid-component>");
$templateCache.put("app/main/invoice/view/directive/invoice-report-filter/invoice-report-filter.html","<div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div flex=\"50\" flex-xs=\"100\" layout=\"row\"><div flex=\"nogrow\"><md-input-container><md-button ng-click=\"invReportFilterVm.showDatesFilter()\" class=\"md-accent md-raised\">Date Range</md-button></md-input-container></div><md-input-container flex=\"70\"><input type=\"text\" ng-keypress=\"invReportFilterVm.disableString($event)\" placeholder=\"Ticket no. or Invoice no.\" ng-model=\"invReportFilterVm.model.data.ticketNoInvoiceNo\"></md-input-container><md-input-container flex=\"30\"><label translate=\"INVOICE_REPORT.BRANCHES\"></label><md-select name=\"branches\" ng-model=\"invReportFilterVm.model.data.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'INVOICE_REPORT.BRANCHES\' | translate}}\" multiple=\"\"><md-optgroup label=\"{{\'INVOICE_REPORT.STATES\' | translate}}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in invReportFilterVm.model.branchLookups | filter:{State: null}\">{{branch.Name}}</md-option></md-optgroup><md-optgroup label=\"{{\'INVOICE_REPORT.BRANCHES\' | translate}}\"><md-option ng-value=\"branch\" ng-repeat=\"branch in invReportFilterVm.model.branchLookups | filter:{State: \'!!\'}\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"auto\" flex-offset=\"5\" flex-offset-xs=\"0\" layout=\"row\"><md-input-container><md-button class=\"md-raised md-accent button-margin\" ng-click=\"invReportFilterVm.applyFilter()\">FILTER</md-button><md-button class=\"md-raised md-accent button-margin\" ng-click=\"invReportFilterVm.resetFilter()\">RESET</md-button></md-input-container></div></div>");
$templateCache.put("app/main/messaging/generalMessaging/sendMessageAsService/contacts/contacts.html","<div id=\"message-area-contacts\"><md-card-header layout=\"column\" flex=\"\"><div layout=\"row\" flex=\"\"><div flex=\"auto\"><span><i class=\"icon icon-account-circle icon-color\"></i></span> <span translate=\"MESSAGING.CONTACTS_SELECTED\" class=\"md-subhead text-bold\" style=\"position : relative; top : -5px;\"></span></div></div><div class=\"quick-fill\" layout=\"row\" layout-align=\"start center\" role=\"group\" aria-labelledby=\"{{vm.quickFillLabelId}}\" ng-if=\"vm.service.hasQuickFill()\"><span class=\"quick-fill-label\" id=\"{{vm.quickFillLabelId}}\" translate=\"MESSAGING.QUICK_FILL\"></span> <button type=\"button\" class=\"quick-fill-option\" ng-repeat=\"option in vm.quickFillOptions\" ng-click=\"vm.service.selectQuickFill(option.value)\" aria-pressed=\"{{vm.service.quickFill.selected === option.value}}\"><i class=\"icon\" aria-hidden=\"true\" ng-class=\"vm.service.quickFill.selected === option.value ? \'icon-radiobox-marked\' : \'icon-radiobox-blank\'\"></i> <span>{{ option.label | translate }}</span></button></div><div class=\"chips-section\"><md-chips ng-model=\"vm.service.contacts\" md-on-add=\"vm.service.onAddOrRemovePerson($chip)\" md-on-remove=\"vm.service.onAddOrRemovePerson($chip)\" name=\"contacts\"><md-autocomplete md-search-text=\"vm.searchText\" md-items=\"contact in vm.querySearch(vm.searchText)\" md-item-text=\"contact.Name\" class=\"md-body-1\" placeholder=\"Type a Name\"><span class=\"md-body-1 autocomplete-icon\" layout=\"row\"><div flex=\"10\" class=\"margin-top-10 margin-right-20\"><i class=\"light-blue-800-fg s30 icon icon-account margin-top-10\"></i></div><div flex=\"auto\" class=\"margin-top-15\">{{contact.Name}}</div></span></md-autocomplete><md-chip-template class=\"md-caption\"><strong>{{$chip.Name}}</strong></md-chip-template></md-chips><div ng-if=\"!vm.service.isSmsEnabled && vm.service.contactNamesWithoutDevices.length > 0\" class=\"margin-top-5\">{{vm.service.contactNamesWithoutDevices.join(\', \')}} {{vm.service.contactNamesWithoutDevices.length > 1 ? \'have\' : \'has\' }} no devices and SMS is not enabled.</div></div></md-card-header></div>");
$templateCache.put("app/main/messaging/generalMessaging/sendMessageAsService/container/container.html","<md-card layout-padding=\"\" layout-margin=\"\" block-ui=\"sendMessageUI\" ng-class=\"{\'big-screen md-whiteframe-3dp\' : vm.mediaService.isDeviceMessagingBig(), \'small-screen md-whiteframe-3dp\' : vm.mediaService.isDeviceMessagingSmall()}\"><contacts-selected2 employees=\"vm.employees\"></contacts-selected2><message-section2></message-section2></md-card>");
$templateCache.put("app/main/messaging/generalMessaging/sendMessageAsService/message/message.html","<div class=\"message-section\"><md-card-content><div flex=\"\" layout=\"column\"><div><span><i class=\"icon icon-message-reply\"></i></span> <span translate=\"MESSAGING.MESSAGE\" class=\"md-subhead text-bold\" style=\"position : relative; top : -5px;\"></span></div><special-text-area2 rows=\"vm.service.rows\" class=\"md-subhead\" limit=\"vm.service.message_chars_limit\" ng-model=\"vm.service.message\"></special-text-area2><div layout=\"row\" class=\"send-button\" layout-align=\"start center\"><span><md-button translate=\"MESSAGING.SEND\" ng-click=\"vm.service.send()\" ng-disabled=\"vm.service.isSendButtonDisabled()\" class=\"md-raised md-accent\"></md-button></span></div></div></md-card-content></div>");
$templateCache.put("app/main/lockoutSettings/view/components/overrideLockout/lockout-component-override.html","<div class=\"content scrollable\" id=\"lockout-settings\" layout=\"column\" ms-scroll=\"\"><div layout=\"column\" ng-if=\"!vm.service.selectedRule\"><div layout=\"row\" flex=\"\" style=\"margin-top: 200px\"><md-icon md-font-icon=\"settings\" class=\"{{vm.service.loader ? \'blue-grey-400-fg material-icons s240 spin\' : \'blue-grey-400-fg material-icons s240\'}}\" md-svg-src=\"settings\" role=\"img\" aria-label=\"Settings\"></md-icon></div></div><div layout=\"column\" ng-form=\"lockoutForm\" a8-dirty-form-confirmation=\"\" class=\"{{vm.service.saving ? \'is-saving\' : \'is-saved\'}}\" flex=\"\" ng-if=\"vm.service.selectedRule\"><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" flex=\"40\" layout-align=\"space-evenly\"><span class=\"md-title\" inline-edit-on-click=\"\" inline-edit-callback=\"vm.validate(newValue)\" inline-edit-on-blur=\"save\" inline-edit-btn-edit=\"\" inline-edit=\"vm.service.selectedRule.Name\"></span></div><div flex=\"60\" layout-align=\"end center\" layout=\"row\"><div ng-if=\"lockoutForm.$invalid\" css=\"md-caption\" flex=\"40\" style=\"color: #d50000; text-align: right; padding-right: 5px;\">There are errors in the settings below. Please correct and try again.</div><md-button class=\"md-accent md-raised first-button-margin\" ng-click=\"vm.service.save()\" ng-disabled=\"lockoutForm.$invalid\" ng-if=\"(!vm.service.loader || !vm.service.saving) && vm.service.selectedRule != null\" translate=\"LOCKOUTSETTINGS.VIEW_SAVE\"></md-button><md-button class=\"md-warn md-raised button-margin\" ng-click=\"vm.service.remove()\" ng-if=\"(!vm.service.loader || !vm.service.saving) && vm.service.selectedRule != null && !vm.service.selectedRule.IsGlobalSettings && vm.service.editMode\" translate=\"LOCKOUTSETTINGS.VIEW_DELETE\"></md-button><md-button class=\"md-raised button-margin\" ng-click=\"vm.service.cancel()\" ng-if=\"(!vm.service.loader || !vm.service.saving) && vm.service.selectedRule != null\" translate=\"LOCKOUTSETTINGS.VIEW_CANCEL\"></md-button></div></div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-md=\"column\" flex=\"10\" flex-md=\"20\" flex-sm=\"20\" flex-xs=\"20\" class=\"mt-20 mb-20\"><div flex=\"50\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><md-list class=\"md-body-1\"><md-subheader class=\"md-no-sticky warning-header\" style=\"color: #4097f6\" translate=\"LOCKOUTSETTINGS.VIEW_SETTINGS\"></md-subheader><md-list-item><p translate=\"LOCKOUTSETTINGS.VIEW_TRAVEL_HOURS_COUNT_TOWARDS_TOTAL_HOURS_WORKED\"></p><md-checkbox class=\"md-secondary\" ng-disabled=\"vm.service.shopTimeOrLoadTimeEnabled\" ng-model=\"vm.service.selectedRule.CountTravelHours\"></md-checkbox></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"breakHoursBetweenToResetInput\" decimal-upto=\"1\" min=\"0\" max=\"24\" ng-model=\"vm.service.selectedRule.StandardSettings.BreakHoursBetweenToReset\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_BREAK_BETWEEN_SHIFTS_REQUIRED_TO_RESET_24_HOUR_TOTAL\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.breakHoursBetweenToResetInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between 0.0 and 24.0</ng-message></ng-messages></md-list-item></md-list></div><md-divider></md-divider><div flex=\"50\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><md-list class=\"md-body-1\" ng-hide=\"vm.service.rules.length == 0\" ng-if=\"!vm.service.selectedRule.IsGlobalSettings\"><md-list-item><md-input-container class=\"md-block\"><label>{{\'LOCKOUTSETTINGS.VIEW_SHIFT_TYPES\' | translate}}</label><md-select ng-model=\"vm.service.selectedRule.ShiftTypes\" ng-model-options=\"{trackBy: \'$value.Id\'}\" md-selected-text=\"vm.utilService.getSelectedText(vm.service.selectedRule.ShiftTypes, vm.utilService.translate(\'LOCKOUTSETTINGS.VIEW_SHIFT_TYPES\'), \'Name\')\" multiple=\"\"><md-option ng-value=\"shift\" ng-repeat=\"shift in vm.service.shiftTypes\">{{shift.Name}}</md-option></md-select></md-input-container></md-list-item></md-list></div></div><md-divider></md-divider><div layout=\"column\" flex=\"40\"><div layout=\"row\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\">{{\'LOCKOUTSETTINGS.VIEW_STANDARD_SETTINGS\' | translate}}</div></md-toolbar></div><div layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex-sm=\"100\" flex-xs=\"100\" flex=\"100\" style=\"margin-top: 10px\"><div flex=\"50\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><md-list class=\"md-body-1\"><md-subheader class=\"md-no-sticky warning-header\" translate=\"LOCKOUTSETTINGS.VIEW_LOCK_OUT_RULES\"></md-subheader><p class=\"pl-15 pr-15 md-caption\" style=\"height: 60px;\" translate=\"LOCKOUTSETTINGS.VIEW_STANDARD_LOCK_OUT_RULES\"></p><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"StandardMaxShiftLength\" decimal-upto=\"1\" min=\"0.5\" max=\"24\" ng-model=\"vm.service.selectedRule.StandardSettings.MaxShiftLength\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_SHIFT_LENGTH\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.StandardMaxShiftLength.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between 0.5 and 24.0</ng-message></ng-messages></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"StandardMaxHoursIn24HourPeriod\" decimal-upto=\"1\" ng-min=\"vm.service.selectedRule.StandardSettings.MaxShiftLength\" max=\"24\" ng-model=\"vm.service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_HOURS_IN_24_HOUR_PERIOD\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.StandardMaxHoursIn24HourPeriod.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between {{vm.service.selectedRule.StandardSettings.MaxShiftLength}} and 24.0</ng-message></ng-messages></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"StandardMaxHoursIn7DayPeriod\" decimal-upto=\"1\" ng-min=\"vm.service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod\" max=\"168\" ng-model=\"vm.service.selectedRule.StandardSettings.MaxHoursIn7DayPeriod\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_HOURS_IN_7_DAY_PERIOD\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.StandardMaxHoursIn7DayPeriod.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between {{vm.service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod}} and 168.0</ng-message></ng-messages></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"MinBreakHoursBetweenShiftsInput\" decimal-upto=\"1\" min=\"0\" max=\"24\" ng-model=\"vm.service.selectedRule.StandardSettings.MinBreakHoursBetweenShifts\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MIN_BREAK_HOURS_BETWEEN_SHIFTS\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.MinBreakHoursBetweenShiftsInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between 0.0 and 24.0</ng-message></ng-messages></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"MaxContinuousShiftGap\" decimal-upto=\"1\" min=\"0\" ng-max=\"vm.service.getMaxValueForStandardShiftGap()\" ng-model=\"vm.service.selectedRule.StandardSettings.MaxContinuousShiftGap\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_CONTINUOUS_SHIFT_GAP\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.MaxContinuousShiftGap.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between 0 and {{vm.service.getMaxValueForStandardShiftGap()}}</ng-message></ng-messages></md-list-item></md-list></div><md-divider></md-divider><div flex=\"50\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><md-list class=\"md-body-1\"><md-subheader class=\"md-no-sticky warning-header\" translate=\"LOCKOUTSETTINGS.VIEW_WARNING_RULES\"></md-subheader><p class=\"pl-15 pr-15 md-caption\" style=\"height: 60px;\" translate=\"LOCKOUTSETTINGS.VIEW_STANDAR_WARNING_RULES\"></p><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"WarningMaxShiftLengthInput\" decimal-upto=\"1\" ng-max=\"vm.service.selectedRule.StandardSettings.MaxShiftLength\" min=\"0\" ng-model=\"vm.service.selectedRule.StandardSettings.WarningMaxShiftLength\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_SHIFT_LENGTH\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.WarningMaxShiftLengthInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between 0.0 and {{vm.service.selectedRule.StandardSettings.MaxShiftLength}}</ng-message></ng-messages><div ng-if=\"vm.service.selectedRule.StandardSettings.MaxShiftLength == vm.service.selectedRule.StandardSettings.WarningMaxShiftLength\" class=\"md-caption\" style=\"color: #FF7800\">{{\'LOCKOUTSETTINGS.VIEW_WARNING_WILL_NOT_BE_DISPLAYED\' | translate}}</div></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"WarningMaxHoursIn24HourPeriodInput\" decimal-upto=\"1\" ng-max=\"vm.service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod\" min=\"0\" ng-model=\"vm.service.selectedRule.StandardSettings.WarningMaxHoursIn24HourPeriod\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_HOURS_IN_24_HOUR_PERIOD\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.WarningMaxHoursIn24HourPeriodInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between 0.0 and {{vm.service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod}}</ng-message></ng-messages><div ng-if=\"vm.service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod == vm.service.selectedRule.StandardSettings.WarningMaxHoursIn24HourPeriod\" class=\"md-caption\" style=\"color: #FF7800\">{{\'LOCKOUTSETTINGS.VIEW_WARNING_WILL_NOT_BE_DISPLAYED\' | translate}}</div></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"WarningMaxHoursIn7DayPeriodInput\" decimal-upto=\"1\" ng-max=\"vm.service.selectedRule.StandardSettings.MaxHoursIn7DayPeriod\" min=\"0\" ng-model=\"vm.service.selectedRule.StandardSettings.WarningMaxHoursIn7DayPeriod\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_HOURS_IN_7_DAY_PERIOD\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.WarningMaxHoursIn7DayPeriodInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number 0.0 and {{vm.service.selectedRule.StandardSettings.MaxHoursIn7DayPeriod}}</ng-message></ng-messages><div ng-if=\"vm.service.selectedRule.StandardSettings.MaxHoursIn7DayPeriod == vm.service.selectedRule.StandardSettings.WarningMaxHoursIn7DayPeriod\" class=\"md-caption\" style=\"color: #FF7800\">{{\'LOCKOUTSETTINGS.VIEW_WARNING_WILL_NOT_BE_DISPLAYED\' | translate}}</div></md-list-item></md-list></div></div></div><div layout=\"column\" flex=\"40\"><div layout=\"row\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\">{{\'LOCKOUTSETTINGS.VIEW_OVERRIDE_SETTINGS\' | translate}}</div></md-toolbar></div><div layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex-sm=\"100\" flex-xs=\"100\" flex=\"100\" style=\"margin-top: 10px\"><div flex=\"50\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><md-list class=\"md-body-1\"><md-subheader class=\"md-no-sticky warning-header\" translate=\"LOCKOUTSETTINGS.VIEW_LOCK_OUT_RULES\"></md-subheader><p class=\"pl-15 pr-15 md-caption\" translate=\"LOCKOUTSETTINGS.VIEW_OVERRIDE_LOCK_OUT_RULES\"></p><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" ng-model=\"vm.service.selectedRule.OverrideSettings.MaxShiftLength\" allow-decimal=\"true\" name=\"OverrideMaxShiftLengthInput\" allow-negative=\"false\" decimal-upto=\"1\" max=\"24\" ng-min=\"vm.service.selectedRule.StandardSettings.MaxShiftLength\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_SHIFT_LENGTH\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.OverrideMaxShiftLengthInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between {{vm.service.selectedRule.StandardSettings.MaxShiftLength}} and 24.0</ng-message></ng-messages></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"OverrideMaxHoursIn24HourPeriodInput\" decimal-upto=\"1\" max=\"24\" ng-min=\"vm.service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod\" ng-model=\"vm.service.selectedRule.OverrideSettings.MaxHoursIn24HourPeriod\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_HOURS_IN_24_HOUR_PERIOD\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.OverrideMaxHoursIn24HourPeriodInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between {{vm.service.selectedRule.StandardSettings.MaxHoursIn24HourPeriod}} and 24.0</ng-message></ng-messages></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"OverrideMaxHoursIn7DayPeriodInput\" decimal-upto=\"1\" max=\"168\" ng-min=\"vm.service.selectedRule.StandardSettings.MaxHoursIn7DayPeriod\" ng-model=\"vm.service.selectedRule.OverrideSettings.MaxHoursIn7DayPeriod\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_HOURS_IN_7_DAY_PERIOD\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.OverrideMaxHoursIn7DayPeriodInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between {{vm.service.selectedRule.StandardSettings.MaxHoursIn7DayPeriod}} and 168.0</ng-message></ng-messages></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"OverrideMinBreakHoursBetweenShiftsInput\" decimal-upto=\"1\" ng-max=\"vm.service.selectedRule.StandardSettings.MinBreakHoursBetweenShifts\" ng-min=\"0\" ng-model=\"vm.service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MIN_BREAK_HOURS_BETWEEN_SHIFTS\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.OverrideMinBreakHoursBetweenShiftsInput.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between 0 and {{vm.service.selectedRule.StandardSettings.MinBreakHoursBetweenShifts}}</ng-message></ng-messages></md-list-item><md-list-item><md-input-container class=\"md-block\"><input type=\"number\" step=\"{{vm.service.step}}\" required=\"\" allow-decimal=\"true\" allow-negative=\"false\" name=\"OverrideMaxContinuousShiftGap\" decimal-upto=\"1\" ng-min=\"vm.service.getMinValueForOverrideShiftGap()\" ng-max=\"vm.service.getMaxValueForOverrideShiftGap()\" ng-model=\"vm.service.selectedRule.OverrideSettings.MaxContinuousShiftGap\" placeholder=\"{{\'LOCKOUTSETTINGS.VIEW_MAX_CONTINUOUS_SHIFT_GAP\' | translate}}\"></md-input-container><ng-messages class=\"input-error-message\" for=\"lockoutForm.OverrideMaxContinuousShiftGap.$error\"><ng-message when-exp=\"[\'min\', \'max\']\">Enter a number between {{vm.service.selectedRule.StandardSettings.MaxContinuousShiftGap >= vm.service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts ? vm.service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts + \' and \' + vm.service.selectedRule.StandardSettings.MaxContinuousShiftGap : vm.service.selectedRule.StandardSettings.MaxContinuousShiftGap + \' and \' + vm.service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts}}</ng-message><ng-message when-exp=\"[\'max\', \'min\']\">Enter a number between {{vm.service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts >= vm.service.selectedRule.StandardSettings.MaxContinuousShiftGap ? vm.service.selectedRule.StandardSettings.MaxContinuousShiftGap + \' and \' + vm.service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts : vm.service.selectedRule.OverrideSettings.MinBreakHoursBetweenShifts + \' and \' + vm.service.selectedRule.StandardSettings.MaxContinuousShiftGap}}</ng-message></ng-messages></md-list-item></md-list></div><md-divider></md-divider></div></div></div></div>");
$templateCache.put("app/main/lockoutSettings/view/components/rulesList/rules-component.html","<div id=\"lockout-settings\" ms-scroll=\"\" style=\"min-height : 800px;\"><md-list class=\"{{vm.service.saving ? \'is-saving\' : \'is-saved\'}}\"><md-subheader class=\"md-sticky\" style=\"background-color: #fafafa;\">{{\'LOCKOUTSETTINGS.VIEW_RULES_LIST\' | translate}}</md-subheader><rules-item ng-repeat=\"item in vm.data\" data=\"item\" ng-click=\"vm.selectRule(item)\" style=\"cursor: pointer;\"></rules-item></md-list></div>");
$templateCache.put("app/main/messaging/jobMessaging/dialogs/message-status-logs/message-dialog.html","<md-dialog id=\"message-dialog\" aria-label=\"Message Status Logs\" flex=\"50\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Message Status Logs</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><md-dialog-content><div layout=\"column\"><div class=\"ms-responsive-table-wrapper\"><a8-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-search-component delay=\"vm.delay\" source=\"vm.dataGrid.grid.searchTerm\" flex=\"\" layout-margin=\"\"></a8-grid-search-component></div><div layout=\"column\" layout-gt-xs=\"row\"><a8-grid-status-component layout-margin=\"\"></a8-grid-status-component></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.dataGrid.grid.behavior.busy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><table class=\"simple a8grid\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><a8-sort-column sort-by=\"MessageType\" field-label=\"Message Type\"></a8-sort-column></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"DateTimeSent\" field-label=\"Date Time Sent\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"SuccessfullySent\" field-label=\"Successfully Sent\"></a8-sort-column></div></th><th class=\"secondary-text\"><div class=\"table-header\"><a8-sort-column sort-by=\"Read\" field-label=\"Read\"></a8-sort-column></div></th></tr></thead><tfoot><tr><td colspan=\"3\"></td></tr></tfoot><tbody><tr ng-repeat=\"messaging in vm.dataGrid.grid.data track by $index\"><td>{{messaging.MessageType}}</td><td>{{messaging.DateTimeSent}}</td><td>{{messaging.SuccessfullySent}}</td><td>{{messaging.Read}}</td></tr></tbody></table></div></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"a8-pagination\"><div layout=\"row\" flex=\"40\" layout-align=\"start start\"><a8-grid-page-size-component source=\"[5, 10, 25, 50, 100, 1000]\" selected=\"10\" class=\"margin-left-20\"></a8-grid-page-size-component></div><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><a8-pagination-component-grid behavior=\"vm.dataGrid.grid.behavior\" on-init=\"vm.dataGrid.grid.onInit()\" on-error=\"vm.dataGrid.grid.onError(ex)\" on-completed=\"vm.dataGrid.grid.onCompleted(data)\" on-data-filter=\"vm.dataGrid.grid.onDataFilter()\"></a8-pagination-component-grid></div></div></a8-grid-component></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"vm.onCancel()\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/draggableComponent/draggable-sidenav.html","<md-toolbar class=\"md-accent\" flex=\"\" layout=\"column\"><div class=\"md-toolbar-tools\"><h1 ng-if=\"vm.service.fetchingAvailableResources\">{{ \'RESOURCEALLOCATION.FETCHING\' | translate }} {{ vm.service.clickSource == \"People\" ? vm.utilService.translate(\'RESOURCEALLOCATION.PEOPLE\') : vm.utilService.translate(\'RESOURCEALLOCATION.EQUIPMENT\') }}</h1><h1 ng-if=\"!vm.service.noAvailableItem && !vm.service.fetchingAvailableResources\">{{ \'RESOURCEALLOCATION.AVAILABLE\' | translate }} {{ vm.service.clickSource == \"People\" ? vm.utilService.translate(\'RESOURCEALLOCATION.PEOPLE\') : vm.utilService.translate(\'RESOURCEALLOCATION.EQUIPMENT\') }}</h1><h1 ng-if=\"vm.service.noAvailableItem && !vm.service.fetchingAvailableResources\">{{ \'RESOURCEALLOCATION.NO\' | translate }} {{ \'RESOURCEALLOCATION.AVAILABLE\' | translate }} {{ vm.service.clickSource == \"People\" ? vm.utilService.translate(\'RESOURCEALLOCATION.PEOPLE\') : vm.utilService.translate(\'RESOURCEALLOCATION.EQUIPMENT\') }}</h1><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.service.closeSideNav()\" ng-if=\"!vm.service.fetchingAvailableResources\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-content layout-padding=\"\" flex=\"\"><div flex=\"\" layout=\"column\" class=\"no-padding\"><div flex=\"\" layout=\"row\" ng-if=\"!vm.service.fetchingAvailableResources\"><md-switch ng-model=\"vm.service.viewAll\" style=\"margin-top: 5px;\" ng-if=\"!vm.service.fetchingAvailableResources\" ng-change=\"vm.service.toggleViewAll()\" aria-label=\"View All\">{{\'RESOURCEALLOCATION.VIEWALL\' | translate }}</md-switch><span flex=\"\"></span><md-button class=\"md-icon-button action-button\" ng-if=\"vm.service.clickSource == \'People\' && !vm.service.fetchingAvailableResources\" ng-click=\"vm.service.showFilter()\"><i ng-class=\"{\'icon-sort orange-500-fg\': vm.service.isFilterActive, \'icon-sort blue-500-fg\': !vm.service.isFilterActive }\"><md-tooltip>{{ \'RESOURCEALLOCATION.ADVANCEDOPTION\' | translate }}</md-tooltip></i></md-button><md-button class=\"md-icon-button action-button\" ng-if=\"vm.service.clickSource == \'People\' && !vm.service.fetchingAvailableResources\" ng-click=\"vm.service.resetFilter()\"><i class=\"icon-history blue-500-fg\"><md-tooltip>{{ \'RESOURCEALLOCATION.RESETOPTION\' | translate }}</md-tooltip></i></md-button></div><div flex=\"\" layout=\"row\"><md-input-container layout=\"row\" class=\"md-block\" flex=\"100\"><label>{{ \'RESOURCEALLOCATION.CHOOSE_DIVISION\' | translate }}</label><md-select ng-change=\"vm.service.selectWithDivision()\" ng-model-options=\"{trackBy: \'$value\'}\" ng-model=\"vm.service.chosen_division\"><md-option ng-value=\"-1\">{{ \'RESOURCEALLOCATION.DIVISIONS_ALL\' | translate }}</md-option><md-option ng-value=\"0\">{{vm.service.BranchName}} ({{ \'RESOURCEALLOCATION.NO_DIVISION\' | translate }})</md-option><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.service.divisions\">{{item.Name}}</md-option></md-select></md-input-container></div></div><div class=\"no-padding\" flex=\"\" layout=\"column\"><div ng-if=\"vm.service.hasLoadedOnce && !vm.service.fetchingAvailableResources\" layout=\"row\" layout-align=\"start center\"><md-input-container layout=\"row\" flex=\"100\"><input type=\"text\" placeholder=\"{{ \'RESOURCEALLOCATION.SEARCH\' | translate }}\" class=\"md-block\" ng-model=\"vm.service.searchText\" ng-change=\"vm.service.performSearch(vm.service.searchText)\" flex=\"100\"></md-input-container></div></div><div ng-if=\"vm.service.lookUps2.length === 0 && vm.service.hasLoadedOnce && !vm.service.fetchingAvailableResources && !vm.service.noAvailableItem && vm.service.searchText\" layout=\"column\" layout-align=\"center center\" style=\"padding: 40px 20px; text-align: center; color: rgba(0,0,0,0.54);\"><div style=\"font-size: 16px; margin-bottom: 8px;\">No resources found</div><div style=\"font-size: 14px;\">Try adjusting your search or filters</div></div><md-progress-circular style=\"margin : auto;\" md-mode=\"indeterminate\" ng-if=\"vm.service.fetchingAvailableResources\"></md-progress-circular><div flex=\"\" layout=\"column\" style=\"margin-top : -20px;\" ng-if=\"!vm.service.noAvailableItem\"><md-list ng-if=\"!vm.service.fetchingAvailableResources\"><div class=\"equipment-list-scroll\" ng-if=\"vm.service.clickSource == \'People\'\" flex=\"\"><draggable-person service=\"vm.service\" filter=\"0\" section-title=\"{{\'RESOURCEALLOCATION.COMPANY_PREFERRED\' | translate }}\"></draggable-person><draggable-person service=\"vm.service\" filter=\"1\" section-title=\"{{\'RESOURCEALLOCATION.EMPLOYEE_PREFERRED\' | translate }}\"></draggable-person><draggable-person service=\"vm.service\" filter=\"\" section-title=\"{{\'RESOURCEALLOCATION.GENERAL\' | translate }}\"></draggable-person></div><draggable-equipment service=\"vm.service\"></draggable-equipment></md-list></div></md-content>");
$templateCache.put("app/main/messaging/jobMessaging/directives/customGridInfo/job-messaging-grid-info.html","<section><strong>Showing {{vm.srcData.totalItems}} <span ng-if=\"vm.srcData.inProgress\">+</span> <span ng-if=\"vm.srcData.totalItems > 1\">tickets</span> <span ng-if=\"vm.srcData.totalItems <= 1\">ticket</span> <span ng-if=\"vm.srcData.isFiltered\">(filtered from {{vm.srcData.rawTotalItemCount}} total entries)</span></strong></section>");
$templateCache.put("app/main/messaging/jobMessaging/directives/customGridSearch/job-messaging-custom-grid-search.html","<div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.srcData\" type=\"text\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Search for people\" translate=\"\" translate-attr-placeholder=\"JOBMESSAGING_REPORT.SEARCH\"></div>");
$templateCache.put("app/main/messaging/jobMessaging/directives/jobMessagingGridContent/job-messaging-grid-content.html","<invoice-grid-component><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><div class=\"h4 grey-600-fg\" layout=\"row\" layout-align=\"center center\" style=\"margin-top: 25%;\" ng-if=\"vm.model.grid.data.length <= 0\">No current record(s) to display.</div><md-virtual-repeat-container id=\"vertical-container\" style=\"height: 800px;\"><div classname=\"thread-list\"><div classname=\"thread\"><div md-virtual-repeat=\"jm in vm.model.grid.data\" class=\"repeated-item-header\" flex=\"\"><div class=\"main-row-item unsent-item\" ng-if=\"jm.IsHeader && vm.showHeader\"><div class=\"layout-row item layout-align-start-center messaging-title-item\"><h2 class=\"amber-700-fg\">{{jm.Title}}</h2></div></div><div class=\"main-row-item unsent-item\" ng-if=\"!jm.IsHeader\"><div class=\"layout-row item padding-bottom-5 padding-top-5\"><div class=\"layout-row flex-5 layout-align-start-center\"><div class=\"check-itm\"><div class=\"flex\"><md-checkbox class=\"jm-check-box-item\" aria-label=\"Checkbox\" ng-model=\"jm.Selected\" ng-change=\"vm.onCheckeditem(jm.Id)\" ng-class=\"{disabled:!jm.canSendJobNotificationToAtLeastOnePerson}\" ng-disabled=\"!jm.canSendJobNotificationToAtLeastOnePerson\"></md-checkbox></div></div></div><div class=\"layout-row flex-80 item-body\"><div><div class=\"margin-bottom-8\"><span class=\"item-title\">{{jm.CompanyName}}</span><h5 class=\"margin-0 padding-0\">{{jm.BranchName}} <span ng-if=\"jm.DivisionName\">({{jm.DivisionName}})</span></h5></div><div class=\"margin-top-8 padding-top-2 padding-bottom-10 font-size-12\"><div><span class=\"person-status margin-top-5 margin-right-5\" style=\"padding-top: 4px; padding-bottom: 3px;\" ng-repeat=\"contact in jm.Contacts\" ng-class=\"[contact.applyAnimation, {\'notification-not-sent\': contact.isNotifNotYetSent, \'notification-queued\': contact.isSmsQueued, \'notification-failed\': contact.isFailedToSend, \'notification-viewed\': contact.isNotifSentViewed, \'notification-not-viewed\': contact.isNotifSentNotViewed, \'notification-waiting-for-reply\': contact.smsWaiting, \'notification-rejected\': contact.isJobRejected, \'notification-accepted\': contact.isJobAccepted}]\"><md-menu md-offset=\"0 -7\"><span md-menu-origin=\"\" ng-click=\"vm.onMenuClick($mdMenu,$event)\" class=\"clickable-item\"><span>{{contact.Name}}</span></span><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in vm.menus[contact.StatusCode]\"><md-button ng-click=\"vm.contextClick(item, contact, jm)\" ng-disabled=\"vm.isMenuDisabled(item, contact)\"><span md-menu-align-target=\"\">{{item.name}}</span></md-button></md-menu-item></md-menu-content></md-menu></span><div ng-if=\"jm.contactsThatCannotBeNotified.length > 0\" class=\"margin-top-5 margin-left-5\">Cannot send job notifications. There are no registered devices with Push Notification enabled for the following people: {{jm.contactsThatCannotBeNotified.join(\', \')}}</div></div></div></div></div><div class=\"layout-row flex-15 layout-align-end-start item-body\"><div class=\"text-right\"><span>Ticket #{{jm.TicketNumber}}</span><br><span>Company Code: {{jm.CompanyCode}}</span></div></div><div class=\"layout-row flex-10 layout-align-end-center\"><div><div class=\"h6 text-center font-size-10\">{{jm.ProcessStatus}}</div><div class=\"react-linear-activity\" ng-if=\"jm.IsProcessing\"><div class=\"react-indeterminate\"></div></div><div class=\"text-center\" ng-if=\"!jm.IsProcessing\"><a href=\"#\" ng-click=\"vm.sendMessageAll(jm.Contacts)\"><i class=\"icon-email s16 grey-500-fg margin-left-5 margin-top-5\"></i><md-tooltip>Send a message</md-tooltip></a></div><span>{{jm.StartDate | date: \"dd MMM yyyy\"}}</span></div></div></div></div></div></div></div></md-virtual-repeat-container></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div layout=\"row\" layout-align=\"end center\" flex=\"60\"><invoice-grid-pagination-component behavior=\"vm.model.grid.api\" on-init=\"vm.model.grid.onInit()\" default-sort=\"vm.model.defaultSorting\" on-error=\"vm.model.grid.onError(ex)\" on-completed=\"vm.model.grid.onCompleted(data)\" on-data-filter=\"vm.model.grid.onDataFilter()\" on-data-loading=\"vm.model.grid.onDataLoading()\" on-data-loading-completed=\"vm.model.grid.onDataLoadingCompleted()\" custom-grid-search-service=\"vm.model.customGridSearchService\" allow-custom-client-side-filtering=\"vm.model.grid.allowCustomClientSideFiltering\" on-apply-custom-client-side-filtering=\"vm.model.grid.onCustomClientSideFiltering(data)\" on-pre-load-grid-info=\"vm.model.grid.onPreloadGridInfo(data)\" auto-fetch=\"false\"></invoice-grid-pagination-component></div></div></invoice-grid-component>");
$templateCache.put("app/main/messaging/jobMessaging/directives/jobMessagingContent/accept-shifts-dialog.html","<md-dialog id=\"accept-shifts-dialog\" aria-label=\"Accept Shifts\" flex=\"30\" ng-cloak=\"\"><md-dialog-content><h2><strong>Accept {{vm.shiftsToAcceptCount}} Shifts?</strong></h2><div layout=\"column\"><div translate=\"JOBMESSAGING_REPORT.ACCEPT_SHIFTS_DIALOG_CONTENT\"></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\" translate=\"JOBMESSAGING_REPORT.CANCEL\">Cancel</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.onOk()\" translate=\"JOBMESSAGING_REPORT.ACCEPT_SHIFTS\">Accept Shifts</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/messaging/jobMessaging/directives/jobMessagingContent/job-messaging-content-view.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.isBusy\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><div class=\"toolbar\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div flex=\"10\" flex-xs=\"100\" layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"main-checkbox md-primary\" ng-click=\"vm.checkToggle()\" ng-checked=\"vm.initialToggle\" ng-disabled=\"vm.gridInfo.totalItems <= 0\"><strong>{{\'JOBMESSAGING_REPORT.SELECT_ALL\' | translate}}</strong></md-checkbox></div><div flex=\"35\" flex-xs=\"100\" layout=\"row\" layout-align=\"start center\"><label class=\"font-weight-500\" translate=\"JOBMESSAGING_REPORT.FILTER_BY\"></label><md-input-container flex=\"80\" class=\"margin-left-8 mt-0 mb-0\" layout-align=\"center center\"><md-select name=\"states\" ng-model=\"vm.selectedStates\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectState()\" md-selected-text=\"vm.utilService.getSelectedText(vm.selectedStates,\'Message States\', \'name\')\" placeholder=\"Status\" multiple=\"\"><md-optgroup label=\"Message State(s)\"><md-option ng-value=\"status\" ng-repeat=\"status in vm.statesLookup\">{{status.name}}</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"55\" flex-xs=\"100\" layout=\"row\" layout-align=\"end center\"><div flex=\"auto\" layout=\"row\" layout-align=\"start center\"><job-messaging-grid-info-component src-data=\"vm.gridInfo\"></job-messaging-grid-info-component></div><div flex=\"nogrow\" class=\"divider-vertical\" ng-if=\"vm.selectedItemsCount > 0\"></div><div flex=\"noshrink\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.selectedItemsCount > 0\">Selected: {{vm.selectedItemsCount}}</div><div flex=\"nogrow\" class=\"divider-vertical\"></div><md-button flex=\"nogrow\" class=\"md-warn md-raised\" aria-label=\"Send Mail\" ng-click=\"vm.sendMessage()\" ng-disabled=\"vm.isBusy || vm.selectedItemsCount == 0\">Send<md-tooltip><span>Send Message (SMS/Push Notification)</span></md-tooltip></md-button><md-button flex=\"noshrink\" class=\"md-accent md-raised\" aria-label=\"Accept Shifts\" ng-disabled=\"vm.isBusy || !(vm.shiftsToAcceptCount > 0 && vm.canAcceptShift)\" ng-click=\"vm.acceptShifts()\">Accept Shifts<md-tooltip><span>Accept Shifts</span></md-tooltip></md-button><md-menu flex=\"nogrow\" class=\"sort-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Sorting\"><md-icon md-font-icon=\"icon-sort\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.sort(\'asc\')\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"md-accent\"></md-icon><span translate=\"JOBMESSAGING_REPORT.SORT_ASC\">Sort by Date Ascending</span></md-button></md-menu-item><md-menu-item hide-xs=\"\"><md-button ng-click=\"vm.sort(\'desc\')\"><md-icon md-font-icon=\"icon-sort-descending\" class=\"md-accent\"></md-icon><span translate=\"JOBMESSAGING_REPORT.SORT_DESC\">Sort by Date Descending</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div id=\"job-message-wrapper\" class=\"content-wrapper\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\"><div ng-if=\"vm.isSmartSchedulingEnabled\" flex=\"auto\" layout=\"row\" layout-align=\"start center\" class=\"p-20\"><span translate=\"JOBMESSAGING_REPORT.SMART_SCHEDULING_JOBS_NOT_INCLUDED\" class=\"smart-scheduling-jobs-not-included-note\"></span></div><job-messaging-grid-content-component check-item=\"vm.checkItem(id)\" on-context-menu-click=\"vm.contextMenuClick(contextParam)\"></job-messaging-grid-content-component></md-content></div>");
$templateCache.put("app/main/jobs/formsAndAttachments/components/JobTagsComponent/job-tags.html","<div class=\"tag-form\"><h2 class=\"tag-form-header\">{{ \'FORMSATTACHMENTS.MANAGE_TAGS\' | translate }}</h2><div class=\"white-bg md-whiteframe-4dp\" flex=\"\" layout-padding=\"\" layout=\"column\"><md-input-container layout=\"row\" class=\"tags-autocomplete\" flex=\"none\"><md-autocomplete flex=\"auto\" md-input-name=\"ticketTags\" md-no-cache=\"true\" md-search-text=\"vm.searchText\" md-search-text-change=\"vm.searchTagChange(vm.searchText)\" md-items=\"tag in vm.getTicketTags() | orderBy:[\'-NumberOfUsages\', \'Name\'] | limitTo: 50\" md-selected-item-change=\"vm.addTag()\" md-selected-item=\"vm.selectedTag\" md-min-length=\"0\" md-floating-label=\"Tags\" md-menu-class=\"autocomplete-tags-template\"><md-item-template><span md-highlight-text=\"tag.searchText\" class=\"tag-item\">{{tag.Name}}</span></md-item-template></md-autocomplete></md-input-container><div layout=\"row\" flex=\"\" class=\"selected-tags\"><md-input-container flex=\"\"><span ng-repeat=\"tag in vm.ngService.ticketData.Tags\" class=\"rounded-pill\" ng-class=\"{\'inactive\': !tag.IsActive}\">{{tag.Name}} <span class=\"delete\" ng-click=\"vm.removeTag(tag)\">&nbsp;&nbsp;x&nbsp;&nbsp;</span></span></md-input-container></div></div></div>");
$templateCache.put("app/main/jobs/confirmBooking/components/DroppableConfirmTicketComponent/Droppable-Confirm-Ticket.html","<div layout=\"column\" id=\"droppable-resource\" flex=\"\"><div class=\"md-whiteframe-4dp\" layout=\"column\" flex=\"\"><md-toolbar layout=\"row\" class=\"md-primary resource-toolbar\"><div class=\"md-toolbar-tools\"><span translate=\"CONFIRMBOOKING.RESOURCEREQUIREMENT\"></span> <span flex=\"\"></span><md-button id=\"\" ng-click=\"droppableConfirmTicketVm.Add(droppableConfirmTicketVm.ngService.currentIndex)\">{{droppableConfirmTicketVm.ngService.currentLabel}}</md-button></div></md-toolbar><div droppable=\"\" droppable-function=\"droppableConfirmTicketVm.dropped\" flex=\"\" class=\"form-wrapper-2 scroll\" style=\"position: relative; background: #FFFFFF; padding: 10px;\"><md-card-content><div layout=\"row\" id=\"company-header-content\"><div flex=\"70\" class=\"md-body-2\" translate=\"CONFIRMBOOKING.ASSETPEOPLE\"></div><div flex=\"25\" class=\"md-body-2\" translate=\"CONFIRMBOOKING.QUANTITY\"></div><div flex=\"5\" class=\"md-body-2\"></div></div><md-divider></md-divider></md-card-content><dropped-asset-component ng-model=\"droppableConfirmTicketVm.ngModel\" ng-service=\"droppableConfirmTicketVm.ngService\" ticket-index=\"droppableConfirmTicketVm.ticketIndex\" ng-style-height=\"500px\" ng-type=\"0\"></dropped-asset-component></div></div></div>");
$templateCache.put("app/main/jobs/confirmBooking/components/confirmTicketComponent/confirm-ticket.html","<div id=\"confirmTicket\" layout=\"row\" flex=\"\" layout-align=\"center\" layout-fill=\"\"><md-content flex=\"\"><div flex=\"\"><md-list-item ng-repeat=\"ticket in vm.ngService.Tickets\" flex=\"\" class=\"item\" ng-class=\"{ \'selected-item\': $index == vm.selectedUserIndex}\"><div flex=\"\" class=\"user tile md-whiteframe-z1\" ng-class=\"{ \'selected md-whiteframe-z2\': $index == vm.selectedUserIndex}\" layout=\"column\"><div layout=\"row\" ng-click=\"vm.selectUserIndex($index, ticket)\" class=\"folded\" ng-class=\"{ \'selectedItem\': $index == vm.selectedUserIndex}\" ng-mouseleave=\"vm.markedChanges(ticket)\"><div flex=\"80\" layout=\"column\" layout-align=\"center start\"><h3>{{\'#\' + ticket.TicketNumber + \' - \'}} {{ticket.JobStartDateDisplay | date}}</h3></div><div flex=\"20\" layout=\"column\" layout-align=\"center end\"><a ng-click=\"vm.removeItem($event, $index, ticket.id)\" translate=\"CONFIRMBOOKING.REMOVE\"></a></div></div><div layout=\"column\" layout-fill=\"\" class=\"expanded\"><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" placeholder=\"{{ \'CONFIRMBOOKING.JOBSTARTIME\' | translate }}\" time-picker=\"\" ng-model=\"ticket.JobStartTime\" ng-required=\"true\" ng-keyup=\"vm.setUpdateFlag()\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" placeholder=\"{{ \'CONFIRMBOOKING.JOBENDTIME\' | translate }}\" time-picker=\"\" ng-model=\"ticket.JobEndTime\" ng-required=\"true\" ng-keyup=\"vm.setUpdateFlag()\"></md-input-container></div><div layout=\"row\" style=\"height:600px; position:relative;\"><droppable-confirm-ticket-component ng-model=\"ticket.ResourceItems\" ng-service=\"vm.ngService\" ticket-index=\"$index\"></droppable-confirm-ticket-component><draggable-resource-component ng-service=\"vm.ngJobService\" ng-auxmodel=\"ticket.ResourceItems\" ng-model=\"vm.ngJobService.classifiedAssetLookup\" fetch-data=\"true\" branch-id=\"ticket.BranchId\" ticket-type=\"ticket.TicketType\" ng-if=\"vm.ngService.showDraggables && vm.ngService.currentIndex == $index\"></draggable-resource-component></div></div></div></md-list-item></div></md-content></div>");
$templateCache.put("app/main/jobs/manage/components/ContactDropdownPopupComponent/contact-dropdown-popup-manage-dialog.html","<md-dialog flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"MANAGE.PERSONORDERINGTOOLTIP\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"manageContactDialogVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"contactAddDialogForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"column\"><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><input type=\"text\" placeholder=\"{{ \'MANAGE.CONTACTPOPUPFNAME\' | translate }}\" ng-model=\"manageContactDialogVm.FirstName\" class=\"md-block\" ng-required=\"true\"></md-input-container></div><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><input type=\"text\" placeholder=\"{{ \'MANAGE.CONTACTPOPUPLNAME\' | translate }}\" ng-model=\"manageContactDialogVm.LastName\" class=\"md-block\" ng-required=\"true\"></md-input-container></div><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><input type=\"text\" placeholder=\"{{ \'MANAGE.CONTACTPOPUPCONTACT\' | translate }}\" ng-model=\"manageContactDialogVm.Number\" class=\"md-block\" ng-required=\"true\"></md-input-container></div><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><input type=\"email\" ng-pattern=\"manageContactDialogVm.emailPattern\" placeholder=\"{{ \'MANAGE.CONTACTPOPUPEMAIL\' | translate }}\" ng-model=\"manageContactDialogVm.Email\" class=\"md-block\" ng-required=\"true\"></md-input-container></div><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><label translate=\"MANAGE.BRANCH\"></label><md-select name=\"branch\" ng-model=\"manageContactDialogVm.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{ \'MANAGE.BRANCH\' | translate }}\" ng-required=\"true\" multiple=\"\"><md-option ng-repeat=\"branch in manageContactDialogVm.Branches\" ng-value=\"branch\">{{branch.Name}}</md-option></md-select><div ng-messages=\"contactAddDialogForm.branch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MANAGE.BRANCHERROR\"></span></div></div></md-input-container></div><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><label translate=\"MANAGE.CONTACTPOPUPRNOTE\"></label> <textarea ng-model=\"manageContactDialogVm.ResourceNotes\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\"></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"manageContactDialogVm.onCancel()\" class=\"md-raised\" translate=\"MANAGE.CONTACTPOPUPCANCEL\"></md-button><md-button ng-click=\"manageContactDialogVm.onAdd()\" class=\"md-accent md-raised\" aria-label=\"Add\" ng-disabled=\"contactAddDialogForm.$invalid\" translate=\"MANAGE.CONTACTPOPUPADD\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/manage/components/ContactDropdownPopupComponent/contact-dropdown-popup.html","<div flex=\"none\" flex-gt-sm=\"100\" flex-md=\"100\" flex-gt-md=\"100\" layout=\"row\"><div flex=\"\" layout=\"row\" class=\"{contactDropDownPopUpComponentvm.hasMatchingResult ? \'\' : \'md-input-invalid\'\"><md-input-container flex=\"\" ng-if=\"(contactDropDownPopUpComponentvm.ngService.jobModel.IsLocked || contactDropDownPopUpComponentvm.isTicketLockedByPreSchedule() || contactDropDownPopUpComponentvm.ngService.jobModel.IsCancelled) && !contactDropDownPopUpComponentvm.ngService.isCloning\"><input type=\"text\" placeholder=\"{{contactDropDownPopUpComponentvm.attribute.placeholder}}\" ng-disabled=\"contactDropDownPopUpComponentvm.ngService.isEditMode || !contactDropDownPopUpComponentvm.ngService.jobModel.Client || contactDropDownPopUpComponentvm.isTicketLockedByPreSchedule()\" ng-model=\"contactDropDownPopUpComponentvm.ngModel.FullName\"></md-input-container><md-autocomplete ng-required=\"true\" ng-if=\"(!contactDropDownPopUpComponentvm.ngService.jobModel.IsLocked && !contactDropDownPopUpComponentvm.isTicketLockedByPreSchedule() && !contactDropDownPopUpComponentvm.ngService.jobModel.IsCancelled) || contactDropDownPopUpComponentvm.ngService.isCloning\" flex=\"\" ng-disabled=\"!contactDropDownPopUpComponentvm.ngService.jobModel.Client && !contactDropDownPopUpComponentvm.isTicketLockedByPreSchedule()\" md-input-name=\"Client\" md-no-cache=\"true\" md-selected-item=\"contactDropDownPopUpComponentvm.ngModel\" md-search-text-change=\"contactDropDownPopUpComponentvm.searchTextChange(contactDropDownPopUpComponentvm.searchText)\" md-search-text=\"contactDropDownPopUpComponentvm.searchText\" md-selected-item-change=\"contactDropDownPopUpComponentvm.selectedItemChange(contact)\" md-items=\"contact in contactDropDownPopUpComponentvm.querySearch(contactDropDownPopUpComponentvm.searchText)\" md-dropdown-items=\"0\" md-item-text=\"contact.FullName\" md-min-length=\"0\" md-clear-button=\"true\" md-floating-label=\"{{contactDropDownPopUpComponentvm.attribute.placeholder}}\"><span ng-if=\"!contactDropDownPopUpComponentvm.hasMatchingResult\" class=\"input-error-message\" translate=\"MANAGE.CONTACT_NOT_EXIST_ERROR\"></span><md-item-template><div style=\"display: table; width: 100%;\"><div style=\"display: table-cell; width: 25%; padding-right:5px\">{{contact.FullName}}</div><div style=\"display: table-cell; width: 25%; padding-right:5px\">{{contact.Phone == \'\' ? \'n/a\' : contact.Phone}}</div><div style=\"display: table-cell; width: 25%; padding-right:5px\">{{contact.Email == \'\' ? \'n/a\' : contact.Email}}</div><div style=\"display: table-cell; width: 25%; padding-right:5px\">{{contactDropDownPopUpComponentvm.formatResourceNotes(contact.ResourceNotes)}}</div></div></md-item-template><md-not-found><strong><span ng-if=\"contactDropDownPopUpComponentvm.ngService.jobModel.Branch == null\" translate=\"MANAGE.PERSONORDERINGNOTFOUNDNOCLIENT\"></span> <span ng-if=\"contactDropDownPopUpComponentvm.ngService.jobModel.Branch != null\" translate=\"MANAGE.PERSONORDERINGNOTFOUND\"></span></strong></md-not-found></md-autocomplete><div layout=\"row\" layout-align=\"center center\" flex=\"1\" flex-sm=\"10\" ng-if=\"contactDropDownPopUpComponentvm.showMoreInformationButton()\"><button class=\"md-icon-button md-button md-ink-ripple md-default-theme mr-0 ml-0\" type=\"button\" data-nodrag=\"\" ng-click=\"contactDropDownPopUpComponentvm.showDialog(this)\" aria-label=\"More Information\"><md-icon md-font-icon=\"icon-plus-box\" class=\"dp48 ng-scope md-font icon-plus-box material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></button><md-tooltip><span translate=\"MANAGE.PERSONORDERINGTOOLTIP\"></span></md-tooltip></div></div></div>");
$templateCache.put("app/main/jobs/manage/components/JobDetailsComponent/job-details.html","<div><div class=\"flex form-wrapper md-whiteframe-2dp m-20\"><h2>Job Details</h2><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-gt-sm=\"66\" flex-md=\"66\" flex-gt-md=\"66\" layout=\"column\" class=\"mr-15\"><single-address ng-model=\"vm.ngService.jobModel.JobLocation\" country=\"AU\" is-edit=\"vm.ngService.isEditMode\" placeholder=\"{{ \'MANAGE.ENTERLOCATION\' | translate }}\" used-by=\"JobBooking\" is-locked=\"(vm.ngService.jobModel.IsLocked || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" is-locked-by-pre-schedule=\"vm.ngService.jobModel.IsLockedByPreSchedule\" last-job-location=\"vm.ngService.last10JobLocation\"></single-address></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"column\" class=\"mr-15\"><contact-drop-down-pop-up-component ng-model=\"vm.ngService.jobModel.SiteContact\" ng-service=\"vm.ngService\" attribute=\"vm.contactAttribute\" id=\"site-contact\"></contact-drop-down-pop-up-component></div></div><div layout=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-gt-md=\"row\" layout-sm=\"column\" layout-md=\"column\" layout-xs=\"column\" layout-gt-xs=\"column\"><div flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"column\" class=\"mr-15\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"MANAGE.JOBSTARTDATE\"></label><md-datepicker ng-model=\"vm.ngService.jobModel.JobStartDate\" ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-required=\"true\" ng-change=\"vm.onChangeStartDate()\" md-date-filter=\"vm.filterStartDate\" md-open-on-focus=\"\" name=\"jobStartDate\" class=\"md-block\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container><div ng-messages=\"stepper.jobStartDate.$error\" role=\"alert\"><div ng-message=\"valid\">{{\'MANAGE.INVALIDDATE\' | translate}}</div><div ng-message=\"required\">{{\'MANAGE.REQUIREDDATE\' | translate}}</div></div></div><div flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" ng-if=\"vm.ngService.isEditMode && vm.ngService.jobModel.TicketType === 1\"><div flex=\"\" layout=\"row\" ng-if=\"vm.jobEndDateVisible || (vm.ngService.isEditMode && vm.ngService.jobModel.TicketType === 1)\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"MANAGE.JOBENDDATE\"></label><md-datepicker ng-model=\"vm.ngService.jobModel.JobEndDate\" ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-required=\"vm.jobEndDateVisible || (vm.ngService.isEditMode && vm.ngService.jobModel.TicketType === 1)\" ng-blur=\"vm.checkEndDate()\" md-open-on-focus=\"\" name=\"jobEndDate\" class=\"md-block dt\" flex=\"\" layout=\"row\"><div ng-messages=\"stepper.jobEndDate.$error\"><div ng-message=\"valid\">{{\'MANAGE.INVALIDDATE\' | translate}}</div><div ng-message=\"required\">{{\'MANAGE.REQUIREDDATE\' | translate}}</div></div></md-datepicker></md-input-container></div></div><div flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"row\" ng-if=\"!vm.ngService.isEditMode\"><div flex=\"\" layout=\"row\" ng-if=\"vm.jobEndDateVisible\"><div flex=\"\" layout=\"column\" class=\"mr-15\"><md-input-container flex=\"\" layout=\"row\"><span ng-show=\"vm.showError\" class=\"job-time-error\" translate=\"MANAGE.JOB_DAYS_ERROR\"></span> <label translate=\"MANAGE.JOBENDDATE\"></label><md-datepicker ng-model=\"vm.ngService.jobModel.JobEndDate\" ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-required=\"vm.jobEndDateVisible\" ng-blur=\"vm.checkEndDate()\" ng-change=\"vm.onChangeEndDate()\" md-open-on-focus=\"\" name=\"jobEndDate\" class=\"md-block\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container><div ng-messages=\"stepper.jobEndDate.$error\"><div ng-message=\"valid\">{{\'MANAGE.INVALIDDATE\' | translate}}</div><div ng-message=\"required\">{{\'MANAGE.REQUIREDDATE\' | translate}}</div></div></div><div layout=\"row\" layout-align=\"center center\"><a href=\"#\" class=\"md-caption\" ng-click=\"vm.showOtherOption()\">{{\'MANAGE.ENTERJOBDURATION\' | translate}}</a></div></div><div flex=\"\" ng-if=\"vm.jobDurationVisible\" layout=\"row\" class=\"mr-15\"><md-input-container flex=\"\"><input type=\"number\" pattern=\"[0-9]+([\\.,][0-9]+)?\" step=\"1\" min=\"1\" placeholder=\"{{ \'MANAGE.JOBDURATION\' | translate }}\" class=\"md-block\" ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-model=\"vm.ngService.jobModel.JobDuration\" ng-required=\"vm.jobDurationVisible\" ng-keyup=\"vm.onKeyUpJobDuration()\"> <span ng-show=\"vm.showJobDurationError\" class=\"job-time-error\" translate=\"MANAGE.JOB_DAYS_ERROR\"></span></md-input-container><div layout=\"row\" layout-align=\"center center\"><a href=\"#\" class=\"md-caption\" ng-click=\"vm.showOtherOption()\">{{\'MANAGE.ENTERENDDATE\' | translate}}</a></div></div></div></div><div layout=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-gt-md=\"row\" layout-sm=\"column\" layout-md=\"column\" layout-xs=\"column\" layout-gt-xs=\"column\"><div layout=\"row\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" class=\"mr-15\"><md-input-container layout=\"row\" flex=\"\" md-input-icon=\"vm.jobStartTimeIcon\"><input type=\"text\" placeholder=\"{{ \'MANAGE.JOBSTARTIME\' | translate }}\" time-picker=\"\" ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-blur=\"vm.validateJobEndDate()\" ng-model=\"vm.ngService.jobModel.JobStartTime\" ng-required=\"true\"></md-input-container></div><div flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"row\" class=\"mr-15\"><md-input-container flex=\"\" md-input-icon=\"vm.jobEndTimeIcon\"><input type=\"text\" placeholder=\"{{ \'MANAGE.JOBENDTIME\' | translate }}\" time-picker=\"\" ng-blur=\"vm.validateJobEndDate()\" ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-model=\"vm.ngService.jobModel.JobEndTime\" ng-required=\"true\"></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"row\" class=\"mr-15\"><md-input-container flex=\"\"><input type=\"text\" placeholder=\"{{ \'MANAGE.JOBLENGTHOFSHIFT\' | translate }}\" ng-disabled=\"true\" ng-model=\"vm.jobDuration | number : 2\"> <span ng-show=\"vm.jobDuration >= 14\" class=\"job-time-warning\" translate=\"MANAGE.JOBLENGTHWARNING\"></span></md-input-container></div><div flex-gt-sm=\"66\" flex-md=\"66\" flex-gt-md=\"66\" layout=\"row\" class=\"mr-15\"><md-input-container ng-if=\"(vm.ngService.jobModel.TicketType == \'3\' || vm.ngService.jobModel.TicketType == \'6\' || vm.ngService.jobModel.TicketType == \'7\') && !vm.ngService.isEditMode\" class=\"mb-0\" style=\"width:250px; flex:none;\"><md-checkbox ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-model=\"vm.ngService.jobModel.Is24HourRotation\" ng-change=\"vm.validateJobEndDate()\" ng-true-value=\"true\" ng-false-value=\"false\" ng-init=\"false\" class=\"md-primary md-align-top-left\">{{ \'MANAGE.HOURROTATION\' | translate }}</md-checkbox></md-input-container><md-input-container ng-if=\"(vm.ngService.jobModel.TicketType == \'3\' || vm.ngService.jobModel.TicketType == \'6\'|| vm.ngService.jobModel.TicketType == \'7\')\" class=\"mb-0\"><md-checkbox md-no-ink=\"\" aria-label=\"{{\'MANAGE.LONG_RUNNING_JOB\' | translate}}\" ng-model=\"vm.ngService.jobModel.IsLongRunningJob\" ng-disabled=\"((vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning)\" class=\"md-primary mb-0\">{{\'MANAGE.LONG_RUNNING_JOB\' | translate}}</md-checkbox></md-input-container></div></div></div><div class=\"flex form-wrapper md-whiteframe-2dp m-20\"><h2>Additional Details</h2><div ng-if=\"!vm.ngService.isEditMode && vm.ngService.jobModel.TicketType == \'1\' && vm.claimsUtilService.isBillingEnabled()\" layout=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-gt-md=\"row\" layout-sm=\"column\" layout-md=\"column\" layout-xs=\"column\" layout-gt-xs=\"column\"><md-input-container flex-lg=\"33\" flex-gt-lg=\"33\" layout=\"row\"><label>Billing Period</label><md-select class=\"md-block\" flex=\"\" layout=\"row\" ng-init=\"vm.ngService.jobModel.ItemBillingPeriod = null\" name=\"billingperiod\" ng-model=\"vm.ngService.jobModel.ItemBillingPeriod\" ng-required=\"!vm.ngService.isEditMode\" aria-label=\"Billing Period\" translate=\"\" translate-attr-aria-label=\"Billing Period\" md-on-open=\"vm.BillingPeriodChanged = false\" ng-change=\"vm.BillingPeriodChanged = true\" md-on-close=\"vm.onChangeBillingPeriod(vm.ngService.jobModel.ItemBillingPeriod)\" placeholder=\"Billing Period\"><md-option ng-repeat=\"bp in vm.ngService.billingPeriodLookup\" ng-value=\"bp.ItemId\">{{bp.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-gt-md=\"row\" layout-sm=\"column\" layout-md=\"column\" layout-xs=\"column\" layout-gt-xs=\"column\" ng-if=\"vm.claimsUtilService.isBillingEnabled()\"><md-input-container flex-lg=\"33\" flex-gt-lg=\"33\" layout=\"row\"><label translate=\"MANAGE.INVOICEAFTERDATE\"></label><md-datepicker ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-model=\"vm.ngService.jobModel.BillAfterDate\" md-open-on-focus=\"\" name=\"invoiceAfterDate\" class=\"md-block\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container></div><div layout=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-gt-md=\"row\" layout-sm=\"column\" layout-md=\"column\" layout-xs=\"column\" layout-gt-xs=\"column\" ng-if=\"!vm.ngService.jobModel.isThisAQuote\"><div layout=\"row\" flex-lg=\"33\" flex-gt-lg=\"33\"><md-input-container layout=\"row\" class=\"tags-autocomplete\" flex=\"\"><md-autocomplete flex=\"auto\" md-input-name=\"ticketTags\" md-no-cache=\"true\" md-search-text=\"vm.searchText\" md-search-text-change=\"vm.searchTagChange(vm.searchText)\" md-items=\"tag in vm.getTicketTags() | orderBy:[\'-NumberOfUsages\', \'Name\'] | limitTo: 50\" md-selected-item-change=\"vm.addTag()\" md-selected-item=\"vm.selectedTag\" md-min-length=\"0\" md-floating-label=\"Tags\" ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" md-menu-class=\"autocomplete-tags-template\"><md-item-template><span md-highlight-text=\"tag.searchText\" class=\"tag-item\">{{tag.Name}}</span></md-item-template></md-autocomplete></md-input-container></div><div layout=\"row\" flex-lg=\"33\" flex-gt-lg=\"33\" class=\"selected-tags\"><md-input-container flex=\"\"><span ng-repeat=\"tag in vm.ngService.jobModel.Tags\" class=\"rounded-pill\" ng-class=\"{\'inactive\': !tag.IsActive}\">{{tag.Name}} <span class=\"delete\" ng-click=\"vm.removeTag(tag)\">&nbsp;&nbsp;x&nbsp;&nbsp;</span></span></md-input-container></div></div><div layout=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-gt-md=\"row\" layout-sm=\"column\" layout-md=\"column\" layout-xs=\"column\" layout-gt-xs=\"column\" flex=\"\"><div flex-lg=\"66\" flex-gt-lg=\"66\" layout=\"row\"><md-input-container flex=\"\" class=\"no-errors-spacer\"><textarea md-maxlength=\"vm.jobDetailsMaxLength\" name=\"jobDetails\" rows=\"5\" placeholder=\"{{ \'MANAGE.JOBDETAILS\' | translate }}\" md-detect-hidden=\"\" md-select-on-focus=\"\" ng-disabled=\"(vm.ngService.jobModel.IsLocked || vm.isTicketLockedByPreSchedule(vm.ngService.jobModel) || vm.ngService.jobModel.IsCancelled) && !vm.ngService.isCloning\" ng-model=\"vm.ngService.jobModel.JobDetails\"></textarea><div class=\"job-details-footer md-caption\"><div class=\"job-details-error\" ng-messages=\"vm.stepperForm.jobDetails.$error\" role=\"alert\"><div ng-message=\"md-maxlength\" translate=\"MANAGE.JOBDETAILS_NOTES_MAX_LENGTH_ERROR_MESSAGE\"></div></div><span class=\"job-details-counter pt-5 grey-500-fg\">{{ \'MANAGE.JOBDETAILS_NOTES_MAX_LENGTH_MESSAGE\' | translate: { count: (vm.stepperForm.jobDetails.$viewValue || \'\').length, max: vm.jobDetailsMaxLength } }}</span></div></md-input-container></div></div></div><div class=\"flex form-wrapper md-whiteframe-2dp m-20\" ng-if=\"vm.claimsUtilService.isAltusSpecialEnabled()\"><h2>Custom Fields</h2><div id=\"contact-form\"><div class=\"customized-div\"><div id=\"customisedFields2\" flex=\"\" flex-gt-md=\"50\"></div><div id=\"addedCustomisedFields\" flex=\"\"></div></div></div></div></div>");
$templateCache.put("app/main/jobs/manage/components/OrderedByComponent/ordered-by.html","<div class=\"flex form-wrapper md-whiteframe-2dp m-20\"><h2>Ordered By</h2><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"column\" class=\"mr-15\"><md-input-container flex=\"100\"><label translate=\"MANAGE.TICKETTYPE\"></label><md-select name=\"ticketType\" ng-disabled=\"(OrderedByComponentvm.ngService.jobModel.IsLocked || OrderedByComponentvm.isTicketLockedByPreSchedule() || OrderedByComponentvm.ngService.jobModel.IsCancelled) && !OrderedByComponentvm.ngService.isCloning\" ng-model=\"OrderedByComponentvm.ngService.jobModel.TicketType\" ng-required=\"!OrderedByComponentvm.ngService.isEditMode\" aria-label=\"Ticket Type\" translate=\"\" translate-attr-aria-label=\"MANAGE.TICKETTYPE\" placeholder=\"{{ \'MANAGE.TICKETTYPE\' | translate }}\" md-on-close=\"OrderedByComponentvm.onChange(OrderedByComponentvm.ngService.jobModel.TicketType)\"><md-option ng-repeat=\"type in OrderedByComponentvm.ngService.ticketTypeLookup | filter: {Id: \'!2\'}\" ng-disabled=\"OrderedByComponentvm.disable(OrderedByComponentvm.ngService.jobModel.TicketType, type)\" ng-value=\"type.Id\">{{type.Name}}</md-option></md-select><div ng-messages=\"stepper.ticketType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MANAGE.TICKETTYPEERROR\"></span></div></div></md-input-container></div></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"column\" class=\"mr-15\"><md-input-container flex=\"100\" ng-if=\"!OrderedByComponentvm.ngService.isEditMode\"><label translate=\"MANAGE.BRANCH\"></label><md-select name=\"branch\" ng-disabled=\"OrderedByComponentvm.ngService.isEditMode\" aria-label=\"Branch\" translate=\"\" translate-attr-aria-label=\"MANAGE.BRANCH\" placeholder=\"{{ \'MANAGE.BRANCH\' | translate }}\" md-on-close=\"OrderedByComponentvm.onChanging(OrderedByComponentvm.ngService.jobModel.Branch)\" ng-model=\"OrderedByComponentvm.ngService.jobModel.Branch\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-required=\"!OrderedByComponentvm.ngService.isEditMode\"><md-option ng-repeat=\"branch in OrderedByComponentvm.ngService.branchLookup\" ng-value=\"branch\">{{branch.Name}}</md-option></md-select><div ng-messages=\"stepper.branch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MANAGE.BRANCHERROR\"></span></div></div></md-input-container><md-input-container flex=\"\" ng-if=\"OrderedByComponentvm.ngService.isEditMode || (OrderedByComponentvm.ngService.jobModel.IsLocked || (OrderedByComponentvm.isTicketLockedByPreSchedule()) && !OrderedByComponentvm.ngService.isCloning)\"><input type=\"text\" aria-label=\"Branch\" placeholder=\"{{ \'MANAGE.BRANCH\' | translate }}\" ng-disabled=\"OrderedByComponentvm.ngService.isEditMode\" ng-model=\"OrderedByComponentvm.ngService.jobModel.Branch.BranchName\"></md-input-container></div><division-drop-down-component ng-model=\"OrderedByComponentvm.ngService.jobModel.Division\" ng-service=\"OrderedByComponentvm.ngService\"></division-drop-down-component></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"column\" class=\"mr-15\"><company-drop-down-pop-up-component ng-model=\"OrderedByComponentvm.ngService.jobModel.Client\" self-service=\"OrderedByComponentvm.selfService\" ng-service=\"OrderedByComponentvm.ngService\"></company-drop-down-pop-up-component></div><div flex=\"none\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"column\"><contact-drop-down-pop-up-component ng-model=\"OrderedByComponentvm.ngService.jobModel.PersonOrdering\" ng-service=\"OrderedByComponentvm.ngService\" attribute=\"OrderedByComponentvm.contactAttribute\" id=\"person-ordering\"></contact-drop-down-pop-up-component></div></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"column\" class=\"mr-15\"><project-drop-down-pop-up-component ng-model=\"OrderedByComponentvm.ngService.jobModel.Project\" client=\"OrderedByComponentvm.ngService.jobModel.Client\" ng-service=\"OrderedByComponentvm.ngService\"></project-drop-down-pop-up-component></div><div flex=\"none\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"row\" class=\"mr-15\"><md-input-container ng-if=\"OrderedByComponentvm.claimsUtilService.isBillingEnabled()\" class=\"mb-0\"><md-checkbox md-no-ink=\"\" aria-label=\"{{\'MANAGE.COSTESTIMATE\' | translate}}\" ng-model=\"OrderedByComponentvm.ngService.jobModel.isThisAQuote\" ng-hide=\"OrderedByComponentvm.ngService.isEditMode || (OrderedByComponentvm.ngService.costEstimateGroupId != null && OrderedByComponentvm.ngService.isCloning)\" ng-disabled=\"((OrderedByComponentvm.ngService.jobModel.IsLocked || OrderedByComponentvm.isTicketLockedByPreSchedule() || OrderedByComponentvm.ngService.jobModel.IsCancelled) && !OrderedByComponentvm.ngService.isCloning) || ((OrderedByComponentvm.ngService.jobModel.HasResourcesAllocated || OrderedByComponentvm.ngService.jobModel.HasBeenCompleted) && !OrderedByComponentvm.ngService.isCloning)\" class=\"md-primary mb-0\">{{\'MANAGE.COSTESTIMATE\' | translate}}</md-checkbox></md-input-container><md-input-container class=\"mb-0\"><md-checkbox ng-model=\"OrderedByComponentvm.ngService.jobModel.IsUnconfirmedDate\" ng-disabled=\"((OrderedByComponentvm.ngService.jobModel.IsLocked || OrderedByComponentvm.isTicketLockedByPreSchedule() || OrderedByComponentvm.ngService.jobModel.IsCancelled) && !OrderedByComponentvm.ngService.isCloning) || (OrderedByComponentvm.ngService.jobModel.HasBeenCompleted && !OrderedByComponentvm.ngService.isCloning) || !(OrderedByComponentvm.claimsUtilService.checkAccessByRole(\'Confirm Internal Tickets\') || OrderedByComponentvm.ngService.jobModel.TicketType !== OrderedByComponentvm.ticketType.INTERNAL)\" ng-true-value=\"true\" ng-false-value=\"false\" ng-init=\"OrderedByComponentvm.ngService.jobModel.IsUnconfirmedDate == null ? false : OrderedByComponentvm.ngService.jobModel.IsUnconfirmedDate\" class=\"md-primary mb-0\" flex=\"\">{{ \'MANAGE.JOBUNCONFIRMED\' | translate }}</md-checkbox></md-input-container></div></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-sm=\"column\"><div flex=\"none\" layout=\"column\" layout-xs=\"row\" layout-sm=\"row\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" class=\"mr-15\"><md-input-container flex=\"\"><label translate=\"MANAGE.PURCHASEORDERNUMBER\"></label> <input type=\"text\" name=\"PurchaseOrderNumber\" aria-label=\"Purchase Order Number\" translate=\"\" translate-attr-aria-label=\"MANAGE.PURCHASEORDERNUMBER\" ng-model=\"OrderedByComponentvm.ngService.jobModel.PurchaseOrderNumber\" ng-disabled=\"(OrderedByComponentvm.ngService.jobModel.IsLocked || OrderedByComponentvm.isTicketLockedByPreSchedule() || OrderedByComponentvm.ngService.jobModel.IsCancelled) && !OrderedByComponentvm.ngService.isCloning\" ng-required=\"OrderedByComponentvm.ngService.jobModel.Project.IsPurchaseOrderMandatory || OrderedByComponentvm.ngService.jobModel.Client.IsPurchaseOrderMandatory\"><div ng-messages=\"stepper.PurchaseOrderNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MANAGE.PURCHASE_ORDER_NUMBER_ERROR\"></span></div></div></md-input-container></div><div flex=\"none\" layout=\"column\" layout-xs=\"row\" layout-sm=\"row\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" class=\"mr-15\"><md-input-container flex=\"\"><label translate=\"MANAGE.WORKORDERNUMBER\"></label> <input type=\"text\" name=\"WORKORDERNUMBER\" aria-label=\"Work Order Number\" translate=\"\" translate-attr-aria-label=\"MANAGE.WORKORDERNUMBER\" ng-model=\"OrderedByComponentvm.ngService.jobModel.WorkOrderNumber\" ng-disabled=\"(OrderedByComponentvm.ngService.jobModel.IsLocked || OrderedByComponentvm.isTicketLockedByPreSchedule() || OrderedByComponentvm.ngService.jobModel.IsCancelled) && !OrderedByComponentvm.ngService.isCloning\"></md-input-container></div></div></div>");
$templateCache.put("app/main/jobs/manage/components/customized/customized.html","<div flex=\"\"><div id=\"contact-form\"><div class=\"customized-div\"><div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"vm.showFields2\" flex=\"\"><md-button class=\"md-accent\" ng-click=\"vm.showCustomisedFieldsModal()\" style=\"position:relative;left:-12px;\" translate=\"MANAGE.ADDNEWFIELD\"></md-button><md-button class=\"md-accent\" ng-click=\"vm.showCustomisedFields()\" style=\"position:relative;left:-12px;\" translate=\"MANAGE.DONE\"></md-button></div><div id=\"customisedFields\" flex=\"\" flex-gt-md=\"50\"></div><div id=\"addedCustomisedFields\" flex=\"\"></div></div></div></div>");
$templateCache.put("app/main/jobs/manage/components/ResourceComponent/resource.html","<div flex=\"\" layout=\"column\" class=\"m-20 md-whiteframe-2dp form-wrapper\"><h2>Resources</h2><div flex=\"\" layout=\"row\" layout-xs=\"column\"><droppable-resource-component ng-service=\"JobResourceComponentvm.ngService\"></droppable-resource-component><draggable-resource-component ng-service=\"JobResourceComponentvm.ngService\" ng-model=\"JobResourceComponentvm.ngService.classifiedAssetLookup\"></draggable-resource-component></div></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/resources/jobBoardResources.html","<div layout=\"column\" id=\"job-board-resources\"><md-whiteframe ng-style=\"{\'background-color\': (vm.ticket.ticketType === 4 || (vm.ticket.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled)) ? \'white\' : \'#F7F7F7\'}\" ng-class=\"{\'main-container-people\' : itm.resourceType === 0, \'main-container-equipment\' : itm.resourceType != 0}\" ng-repeat=\"itm in vm.ticket.allocatedResourceItems\"><md-card-content><div layout=\"row\" layout-align=\"center stretch\"><div layout=\"column\" flex=\"auto\" ng-click=\"vm.getAvailableResources(vm.ticket, itm)\" ng-class=\"{\'not-clickable-item\': vm.isUnconfirmedDateCanAllocateResources(vm.ticket.IsUnconfirmedDate, itm.allocatedId)}\"><span class=\"text-semibold\" ng-class=\"{\'grey-700-fg\' : vm.isUnconfirmedDateCanAllocateResources(vm.ticket.IsUnconfirmedDate, itm.allocatedId)}\">{{itm.itemName}}</span> <span ng-class=\"{\'text-italic grey-700-fg\' : !vm.isAllocated(itm.allocatedId), \'light-blue-900-fg\' : vm.isAllocated(itm.allocatedId)}\">{{vm.isAllocated(itm.allocatedId) ? (itm.allocatedItemName || itm.allocatedCode) : \'(Unallocated)\'}}</span> <span ng-if=\"itm.allocatedId != null && itm.resourceType === 0 && vm.isMobileAppEnabled\" ng-class=\"vm.getClass(itm.messageStatus)\">{{vm.messageStatusService.getStatusName(itm.messageStatus)}}</span> <span class=\"teal-900-fg md-caption text-italic\">{{itm.allocatedCode != null ? \'(\' + itm.allocatedCode + \')\' : \'\'}}</span></div><div layout=\"row\" ng-if=\"vm.isAllocated(itm.allocatedId) && !itm.isProcessing && !vm.ticket.IsLocked && !(vm.ticket.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled)\" layout-align=\"end center\" flex=\"\"><i ng-class=\"{\'icon-account-remove\' : itm.resourceType === 0, \'icon-bookmark-remove\' : itm.resourceType != 0}\" ng-click=\"vm.deallocate(itm)\" class=\"remove red-400-fg action-button\"><md-tooltip>Remove Resource</md-tooltip></i></div><div layout=\"row\" ng-if=\"(vm.ticket.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled)\" layout-align=\"end center\" flex=\"\"><i class=\"icon-lock s18 blue-800-fg\"><md-tooltip>This ticket is locked. Allocating resources is no longer allowed.</md-tooltip></i></div></div><md-progress-linear ng-if=\"itm.isProcessing\" class=\"md-accent margin-top-10\"></md-progress-linear></md-card-content></md-whiteframe></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/ticketInfoNumber/ticketNumber.directive.html","<div id=\"ticket-number\" ng-if=\"!vm.allowGroupByClient && vm.whiteboardType == 3\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 font-weight-800 ticket-section\">#{{vm.ticketNumber}}</div><div ng-if=\"vm.showRelated && vm.relatedNumber != null\" class=\"grey-700-fg h6 ticket-section\">(#{{vm.relatedNumber}})</div></div><div flex=\"\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.purchaseOrderNumber\"><div class=\"grey-700-fg h6 font-weight-800 ticket-section layout-align-space-between\">{{vm.purchaseOrderNumber}}</div></div><div flex=\"\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.showWorkOrderNumber && vm.workOrderNumber\"><div class=\"grey-700-fg h6 font-weight-800 ticket-section layout-align-space-between\">{{vm.workOrderNumber}}</div></div></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/daily/jday.html","<div id=\"rwDailyboard\"><div class=\"list-wrapper\"><div class=\"list ticket-container\" layout=\"column\"><div class=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span>{{vm.header}}</span></div><md-menu md-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.addTicket($event, vm.currentDate)\" aria-label=\"Add Ticket\" translate=\"\" translate-attr-aria-label=\"SB.ADD_TICKET\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.ADD_TICKET\">Add Ticket</span></md-button></md-menu-item></md-menu-content></md-menu></div><div id=\"day-view-cards-container\" class=\"list-content\" layout=\"column\"><div class=\"list-cards\"><md-virtual-repeat-container id=\"dayview-vertical-container\" ms-scroll=\"\"><div md-virtual-repeat=\"tickets in vm.sourceData\" class=\"repeated-item\" flex=\"\" md-item-size=\"10\"><div layout=\"row\"><div ng-repeat=\"ticket in tickets\"><div class=\"list-card\"><daily-ticket-status-rw-component id=\"{{ticket.ticketNo}}\" status=\"ticket.status\" show-shift-allocation-icon=\"ticket.showShiftAllocationIcon\" is-day-shift=\"ticket.IsDayShift\" show-equipment-allocation-icon=\"ticket.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.showRequireAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" ticket-type=\"ticket.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.isEmailSent\" is-required-attachments-completed=\"ticket.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.hasRequiredAttachments\" allocated-resource-items=\"ticket.allocatedResourceItems\"></daily-ticket-status-rw-component><daily-ticket-footer-rw-component id=\"ticket.id\" ticket-no=\"ticket.ticketNo\" allow-group-by-client=\"vm.allowGrouping\" start-date=\"ticket.startDate\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" on-pre-schedule=\"vm.preSchedule(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" is-un-confirmed-date=\"ticket.IsUnconfirmedDate\" is-locked=\"ticket.IsLocked\" is-locked-by-pre-schedule=\"ticket.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled\" ticket-type=\"ticket.ticketType\" parent-ticket-no=\"ticket.parentTicketNo\" whiteboard-type=\"vm.whiteboardType\" has-generated-paperwork-pdf=\"ticket.hasGeneratedPaperworkPdf\" ticket=\"ticket\"></daily-ticket-footer-rw-component><daily-ticket-info-rw-component card-name=\"ticket.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.ticketCount\" start-date=\"ticket.startDate\" end-date=\"ticket.endDate\" branch=\"ticket.branch\" job-address=\"ticket.jobAddress\" job-location-address=\"ticket.jobLocationAddress\" project-name=\"ticket.projectName\" show-project=\"vm.showProject\" show-showresources=\"vm.showResources\" whiteboard-type=\"vm.whiteboardType\" ng-dblclick=\"vm.openCardTicket(ticket)\"></daily-ticket-info-rw-component><job-board-ticket-number ticket-number=\"ticket.ticketNo\" ng-class=\"{\'project\' : vm.showProject}\" related-number=\"ticket.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" whiteboard-type=\"vm.whiteboardType\" show-related=\"vm.showRelatedTicketNumber\" purchase-order-number=\"ticket.purchaseOrderNumber\" work-order-number=\"ticket.workOrderNumber\" show-work-order-number=\"vm.showWorkOrderNumber\"></job-board-ticket-number><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.IsLockedByPreSchedule && !ticket.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_IN_PROGRESS_MESSAGE\"></span></div><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn min-width-65\" ng-click=\"vm.cancelScheduling(ticket)\">Cancel</md-button></div></div></div><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_FAILED_MESSAGE\"></span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center\" class=\"ticket-actions\" ng-if=\"(ticket.status | filter:{abbrev:\'CJPA\'}).length\"><md-button type=\"button\" class=\"button-margin md-raised btn-approve\" ng-click=\"vm.approveTicket(ticket)\">Approve</md-button><md-button type=\"button\" class=\"md-accent md-warn md-raised button-margin btn-reject\" ng-click=\"vm.rejectTicket(ticket)\">Reject</md-button></div><job-board-resources-component ticket=\"ticket\" ng-if=\"vm.showResources\"></job-board-resources-component></div></div></div></div></md-virtual-repeat-container></div></div></div></div></div>");
$templateCache.put("app/main/jobs/resourceSidenav/components/divisions/resource-divisions.directive.html","<div layout=\"row\" layout-margin=\"\"><md-input-container class=\"md-block\" ng-if=\"vm.service.divisions.length > 0 && !vm.service.isLoading\"><label>Division</label><md-select ng-change=\"vm.service.changeDivision()\" class=\"md-body-2\" ng-model=\"vm.service.chosen_division\" ng-model-options=\"{trackBy : \'$value\'}\"><md-option ng-value=\"-1\">All Divisions</md-option><md-option ng-value=\"0\">No Division</md-option><md-option ng-value=\"division.id\" ng-repeat=\"division in vm.service.divisions | orderBy:\'Name\'\">{{division.Name}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/main/jobs/resourceSidenav/components/options/resource-options.directive.html","<div id=\"resource-sidenav-options\" layout=\"row\"><div flex=\"\" layout-margin=\"\" layout-align=\"space-between center\" layout=\"row\"><div flex=\"auto\"><md-switch ng-disabled=\"vm.service.isLoading\" ng-model=\"vm.service.viewAll\" ng-change=\"vm.service.toggleViewAll()\" aria-label=\"View All\"><span class=\"font-weight-500\">{{\'RESOURCEALLOCATION.VIEWALL\' | translate }}</span></md-switch></div><div ng-if=\"!vm.service.isLoading\" flex=\"none\" class=\"actions\" layout-margin=\"\" layout=\"row\" layout-align=\"end center\"><i ng-class=\"{\'icon-sort blue-500-fg\' : !vm.service.isFilterActive, \'icon-sort orange-500-fg\' : vm.service.isFilterActive}\" ng-click=\"vm.service.openFilterOptionsDialog()\" ng-if=\"vm.service.isAllocatingAPerson()\"></i> <i class=\"icon-history blue-500-fg\" ng-if=\"vm.service.isAllocatingAPerson()\" ng-click=\"vm.service.resetFilter()\"></i></div></div></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/weekly/jweek.html","<div id=\"board\" layout=\"row\"><div class=\"list-wrapper\" ng-repeat=\"list in vm.headers\"><div class=\"list ticket-container\" layout=\"column\" style=\"min-height:100%;\"><div class=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span>{{list.name}}</span></div><md-menu md-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.addTicket($event, list.headerDate)\" aria-label=\"Add Ticket\" translate=\"\" translate-attr-aria-label=\"SB.ADD_TICKET\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.ADD_TICKET\">Add Ticket</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><md-virtual-repeat-container id=\"vertical-container\" class=\"week-view\"><div md-virtual-repeat=\"ticket in vm.sourceData\" class=\"repeated-item\" flex=\"\"><div layout=\"row\"><div class=\"list-card md-whiteframe-2dp ticket-box\" ms-scroll2=\"\" style=\"height: 430px;\" ng-if=\"ticket.day0 != null\"><ticket-status-details-rw-component id=\"{{ticket.day0.ticketNo}}\" status=\"ticket.day0.status\" show-shift-allocation-icon=\"ticket.day0.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day0.IsDayShift\" show-equipment-allocation-icon=\"ticket.day0.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day0.showRequireAllocationIcon\" ticket-type=\"ticket.day0.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day0.isEmailSent\" is-required-attachments-completed=\"ticket.day0.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day0.hasRequiredAttachments\" allocated-resource-items=\"ticket.day0.allocatedResourceItems\"></ticket-status-details-rw-component><week-ticket-footer-rw-component id=\"ticket.day0.id\" ticket-no=\"ticket.day0.ticketNo\" parent-ticket-no=\"ticket.day0.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" is-un-confirmed-date=\"ticket.day0.IsUnconfirmedDate\" is-locked=\"ticket.day0.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day0.IsLockedByPreSchedule\" start-date=\"ticket.day0.startDate\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day0.ticketType\" has-generated-paperwork-pdf=\"ticket.day0.hasGeneratedPaperworkPdf\" whiteboard-type=\"vm.whiteboardType\" on-pre-schedule=\"vm.preSchedule(value)\" ticket=\"ticket.day0\"></week-ticket-footer-rw-component><week-ticket-info-rw-component card-name=\"ticket.day0.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day0.ticketCount\" start-date=\"ticket.day0.startDate\" end-date=\"ticket.day0.endDate\" branch=\"ticket.day0.branch\" job-address=\"ticket.day0.jobAddress\" job-location-address=\"ticket.day0.jobLocationAddress\" project-name=\"ticket.day0.projectName\" show-project=\"vm.showProject\" resource-items=\"ticket.day0.allocatedResourceItems\" ng-dblclick=\"vm.openCardTicket(ticket.day0)\"></week-ticket-info-rw-component><job-board-ticket-number related-number=\"ticket.day0.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" whiteboard-type=\"vm.whiteboardType\" show-related=\"vm.showRelatedTicketNumber\" ticket-number=\"ticket.day0.ticketNo\" purchase-order-number=\"ticket.day0.purchaseOrderNumber\" work-order-number=\"ticket.day0.workOrderNumber\" show-work-order-number=\"vm.showWorkOrderNumber\" is-locked=\"ticket.day0.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day0.IsLockedByPreSchedule\"></job-board-ticket-number><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day0.IsLockedByPreSchedule && !ticket.day0.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_IN_PROGRESS_MESSAGE\"></span></div><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn min-width-65\" ng-click=\"vm.cancelScheduling(ticket.day0)\">Cancel</md-button></div></div></div><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day0.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_FAILED_MESSAGE\"></span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center\" class=\"ticket-actions\" ng-if=\"(ticket.day0.status | filter:{abbrev:\'CJPA\'}).length\"><md-button type=\"button\" class=\"button-margin md-raised btn-approve\" ng-click=\"vm.approveTicket(ticket.day0)\">Approve</md-button><md-button type=\"button\" class=\"md-accent md-warn md-raised button-margin btn-reject\" ng-click=\"vm.rejectTicket(ticket.day0)\">Reject</md-button></div><job-board-resources-component ticket=\"ticket.day0\" ng-if=\"vm.showResources\"></job-board-resources-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 430px;\" ng-if=\"ticket.day0 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" ms-scroll2=\"\" style=\"height: 430px;\" ng-if=\"ticket.day1 != null\"><ticket-status-details-rw-component id=\"{{ticket.day1.ticketNo}}\" status=\"ticket.day1.status\" show-shift-allocation-icon=\"ticket.day1.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day1.IsDayShift\" show-equipment-allocation-icon=\"ticket.day1.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day1.showRequireAllocationIcon\" ticket-type=\"ticket.day1.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day1.isEmailSent\" is-required-attachments-completed=\"ticket.day1.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day1.hasRequiredAttachments\" allocated-resource-items=\"ticket.day1.allocatedResourceItems\"></ticket-status-details-rw-component><week-ticket-footer-rw-component id=\"ticket.day1.id\" ticket-no=\"ticket.day1.ticketNo\" parent-ticket-no=\"ticket.day1.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" is-un-confirmed-date=\"ticket.day1.IsUnconfirmedDate\" is-locked=\"ticket.day1.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day1.IsLockedByPreSchedule\" start-date=\"ticket.day1.startDate\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day1.ticketType\" has-generated-paperwork-pdf=\"ticket.day1.hasGeneratedPaperworkPdf\" whiteboard-type=\"vm.whiteboardType\" on-pre-schedule=\"vm.preSchedule(value)\" ticket=\"ticket.day1\"></week-ticket-footer-rw-component><week-ticket-info-rw-component card-name=\"ticket.day1.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day1.ticketCount\" start-date=\"ticket.day1.startDate\" end-date=\"ticket.day1.endDate\" branch=\"ticket.day1.branch\" job-address=\"ticket.day1.jobAddress\" job-location-address=\"ticket.day1.jobLocationAddress\" project-name=\"ticket.day1.projectName\" show-project=\"vm.showProject\" resource-items=\"ticket.day1.allocatedResourceItems\" ng-dblclick=\"vm.openCardTicket(ticket.day1)\"></week-ticket-info-rw-component><job-board-ticket-number related-number=\"ticket.day1.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" whiteboard-type=\"vm.whiteboardType\" show-related=\"vm.showRelatedTicketNumber\" ticket-number=\"ticket.day1.ticketNo\" purchase-order-number=\"ticket.day1.purchaseOrderNumber\" work-order-number=\"ticket.day1.workOrderNumber\" show-work-order-number=\"vm.showWorkOrderNumber\" is-locked=\"ticket.day1.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day1.IsLockedByPreSchedule\"></job-board-ticket-number><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day1.IsLockedByPreSchedule && !ticket.day1.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_IN_PROGRESS_MESSAGE\"></span></div><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn min-width-65\" ng-click=\"vm.cancelScheduling(ticket.day1)\">Cancel</md-button></div></div></div><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day1.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_FAILED_MESSAGE\"></span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center\" class=\"ticket-actions\" ng-if=\"(ticket.day1.status | filter:{abbrev:\'CJPA\'}).length\"><md-button type=\"button\" class=\"button-margin md-raised btn-approve\" ng-click=\"vm.approveTicket(ticket.day1)\">Approve</md-button><md-button type=\"button\" class=\"md-accent md-warn md-raised button-margin btn-reject\" ng-click=\"vm.rejectTicket(ticket.day1)\">Reject</md-button></div><job-board-resources-component ticket=\"ticket.day1\"></job-board-resources-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 430px;\" ng-if=\"ticket.day1 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" ms-scroll2=\"\" style=\"height: 430px;\" ng-if=\"ticket.day2 != null\"><ticket-status-details-rw-component id=\"{{ticket.day2.ticketNo}}\" status=\"ticket.day2.status\" show-shift-allocation-icon=\"ticket.day2.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day2.IsDayShift\" show-equipment-allocation-icon=\"ticket.day2.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day2.showRequireAllocationIcon\" ticket-type=\"ticket.day2.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day2.isEmailSent\" is-required-attachments-completed=\"ticket.day2.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day2.hasRequiredAttachments\" allocated-resource-items=\"ticket.day2.allocatedResourceItems\"></ticket-status-details-rw-component><week-ticket-footer-rw-component id=\"ticket.day2.id\" ticket-no=\"ticket.day2.ticketNo\" parent-ticket-no=\"ticket.day2.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" is-un-confirmed-date=\"ticket.day2.IsUnconfirmedDate\" is-locked=\"ticket.day2.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day2.IsLockedByPreSchedule\" start-date=\"ticket.day2.startDate\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day2.ticketType\" has-generated-paperwork-pdf=\"ticket.day2.hasGeneratedPaperworkPdf\" whiteboard-type=\"vm.whiteboardType\" on-pre-schedule=\"vm.preSchedule(value)\" ticket=\"ticket.day2\"></week-ticket-footer-rw-component><week-ticket-info-rw-component card-name=\"ticket.day2.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day2.ticketCount\" start-date=\"ticket.day2.startDate\" end-date=\"ticket.day2.endDate\" branch=\"ticket.day2.branch\" job-address=\"ticket.day2.jobAddress\" job-location-address=\"ticket.day2.jobLocationAddress\" project-name=\"ticket.day2.projectName\" show-project=\"vm.showProject\" resource-items=\"ticket.day2.allocatedResourceItems\" ng-dblclick=\"vm.openCardTicket(ticket.day2)\"></week-ticket-info-rw-component><job-board-ticket-number related-number=\"ticket.day2.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" whiteboard-type=\"vm.whiteboardType\" show-related=\"vm.showRelatedTicketNumber\" ticket-number=\"ticket.day2.ticketNo\" purchase-order-number=\"ticket.day2.purchaseOrderNumber\" work-order-number=\"ticket.day2.workOrderNumber\" show-work-order-number=\"vm.showWorkOrderNumber\" is-locked=\"ticket.day2.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day2.IsLockedByPreSchedule\"></job-board-ticket-number><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day2.IsLockedByPreSchedule && !ticket.day2.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_IN_PROGRESS_MESSAGE\"></span></div><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn min-width-65\" ng-click=\"vm.cancelScheduling(ticket.day2)\">Cancel</md-button></div></div></div><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day2.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_FAILED_MESSAGE\"></span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center\" class=\"ticket-actions\" ng-if=\"(ticket.day2.status | filter:{abbrev:\'CJPA\'}).length\"><md-button type=\"button\" class=\"button-margin md-raised btn-approve\" ng-click=\"vm.approveTicket(ticket.day2)\">Approve</md-button><md-button type=\"button\" class=\"md-accent md-warn md-raised button-margin btn-reject\" ng-click=\"vm.rejectTicket(ticket.day2)\">Reject</md-button></div><job-board-resources-component ticket=\"ticket.day2\"></job-board-resources-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 430px;\" ng-if=\"ticket.day2 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" ms-scroll2=\"\" style=\"height: 430px;\" ng-if=\"ticket.day3 != null\"><ticket-status-details-rw-component id=\"{{ticket.day3.ticketNo}}\" status=\"ticket.day3.status\" show-shift-allocation-icon=\"ticket.day3.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day3.IsDayShift\" show-equipment-allocation-icon=\"ticket.day3.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day3.showRequireAllocationIcon\" ticket-type=\"ticket.day3.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day3.isEmailSent\" is-required-attachments-completed=\"ticket.day3.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day3.hasRequiredAttachments\" allocated-resource-items=\"ticket.day3.allocatedResourceItems\"></ticket-status-details-rw-component><week-ticket-footer-rw-component id=\"ticket.day3.id\" ticket-no=\"ticket.day3.ticketNo\" parent-ticket-no=\"ticket.day3.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" is-un-confirmed-date=\"ticket.day3.IsUnconfirmedDate\" is-locked=\"ticket.day3.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day3.IsLockedByPreSchedule\" start-date=\"ticket.day3.startDate\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day3.ticketType\" has-generated-paperwork-pdf=\"ticket.day3.hasGeneratedPaperworkPdf\" whiteboard-type=\"vm.whiteboardType\" on-pre-schedule=\"vm.preSchedule(value)\" ticket=\"ticket.day3\"></week-ticket-footer-rw-component><week-ticket-info-rw-component card-name=\"ticket.day3.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day3.ticketCount\" start-date=\"ticket.day3.startDate\" end-date=\"ticket.day3.endDate\" branch=\"ticket.day3.branch\" job-address=\"ticket.day3.jobAddress\" job-location-address=\"ticket.day3.jobLocationAddress\" project-name=\"ticket.day3.projectName\" show-project=\"vm.showProject\" resource-items=\"ticket.day3.allocatedResourceItems\" ng-dblclick=\"vm.openCardTicket(ticket.day3)\"></week-ticket-info-rw-component><job-board-ticket-number related-number=\"ticket.day3.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" whiteboard-type=\"vm.whiteboardType\" show-related=\"vm.showRelatedTicketNumber\" ticket-number=\"ticket.day3.ticketNo\" purchase-order-number=\"ticket.day3.purchaseOrderNumber\" work-order-number=\"ticket.day3.workOrderNumber\" show-work-order-number=\"vm.showWorkOrderNumber\" is-locked=\"ticket.day3.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day3.IsLockedByPreSchedule\"></job-board-ticket-number><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day3.IsLockedByPreSchedule && !ticket.day3.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_IN_PROGRESS_MESSAGE\"></span></div><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn min-width-65\" ng-click=\"vm.cancelScheduling(ticket.day3)\">Cancel</md-button></div></div></div><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day3.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_FAILED_MESSAGE\"></span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center\" class=\"ticket-actions\" ng-if=\"(ticket.day3.status | filter:{abbrev:\'CJPA\'}).length\"><md-button type=\"button\" class=\"button-margin md-raised btn-approve\" ng-click=\"vm.approveTicket(ticket.day3)\">Approve</md-button><md-button type=\"button\" class=\"md-accent md-warn md-raised button-margin btn-reject\" ng-click=\"vm.rejectTicket(ticket.day3)\">Reject</md-button></div><job-board-resources-component ticket=\"ticket.day3\"></job-board-resources-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 430px;\" ng-if=\"ticket.day3 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" ms-scroll2=\"\" style=\"height: 430px;\" ng-if=\"ticket.day4 != null\"><ticket-status-details-rw-component id=\"{{ticket.day4.ticketNo}}\" status=\"ticket.day4.status\" show-shift-allocation-icon=\"ticket.day4.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day4.IsDayShift\" show-equipment-allocation-icon=\"ticket.day4.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day4.showRequireAllocationIcon\" ticket-type=\"ticket.day4.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day4.isEmailSent\" is-required-attachments-completed=\"ticket.day4.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day4.hasRequiredAttachments\" allocated-resource-items=\"ticket.day4.allocatedResourceItems\"></ticket-status-details-rw-component><week-ticket-footer-rw-component id=\"ticket.day4.id\" ticket-no=\"ticket.day4.ticketNo\" parent-ticket-no=\"ticket.day4.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" is-un-confirmed-date=\"ticket.day4.IsUnconfirmedDate\" is-locked=\"ticket.day4.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day4.IsLockedByPreSchedule\" start-date=\"ticket.day4.startDate\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day4.ticketType\" has-generated-paperwork-pdf=\"ticket.day4.hasGeneratedPaperworkPdf\" whiteboard-type=\"vm.whiteboardType\" on-pre-schedule=\"vm.preSchedule(value)\" ticket=\"ticket.day4\"></week-ticket-footer-rw-component><week-ticket-info-rw-component card-name=\"ticket.day4.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day4.ticketCount\" start-date=\"ticket.day4.startDate\" end-date=\"ticket.day4.endDate\" branch=\"ticket.day4.branch\" job-address=\"ticket.day4.jobAddress\" job-location-address=\"ticket.day4.jobLocationAddress\" project-name=\"ticket.day4.projectName\" show-project=\"vm.showProject\" resource-items=\"ticket.day4.allocatedResourceItems\" ng-dblclick=\"vm.openCardTicket(ticket.day4)\"></week-ticket-info-rw-component><job-board-ticket-number related-number=\"ticket.day4.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" whiteboard-type=\"vm.whiteboardType\" show-related=\"vm.showRelatedTicketNumber\" ticket-number=\"ticket.day4.ticketNo\" purchase-order-number=\"ticket.day4.purchaseOrderNumber\" work-order-number=\"ticket.day4.workOrderNumber\" show-work-order-number=\"vm.showWorkOrderNumber\" is-locked=\"ticket.day4.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day4.IsLockedByPreSchedule && !ticket.day4.isSmartSchedulingFailed\"></job-board-ticket-number><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day4.IsLockedByPreSchedule\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_IN_PROGRESS_MESSAGE\"></span></div><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn min-width-65\" ng-click=\"vm.cancelScheduling(ticket.day4)\">Cancel</md-button></div></div></div><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day4.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_FAILED_MESSAGE\"></span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center\" class=\"ticket-actions\" ng-if=\"(ticket.day4.status | filter:{abbrev:\'CJPA\'}).length\"><md-button type=\"button\" class=\"button-margin md-raised btn-approve\" ng-click=\"vm.approveTicket(ticket.day4)\">Approve</md-button><md-button type=\"button\" class=\"md-accent md-warn md-raised button-margin btn-reject\" ng-click=\"vm.rejectTicket(ticket.day4)\">Reject</md-button></div><job-board-resources-component ticket=\"ticket.day4\"></job-board-resources-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 430px;\" ng-if=\"ticket.day4 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" ms-scroll2=\"\" style=\"height: 430px;\" ng-if=\"ticket.day5 != null\"><ticket-status-details-rw-component id=\"{{ticket.day5.ticketNo}}\" status=\"ticket.day5.status\" show-shift-allocation-icon=\"ticket.day5.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day5.IsDayShift\" show-equipment-allocation-icon=\"ticket.day5.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day5.showRequireAllocationIcon\" ticket-type=\"ticket.day5.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day5.isEmailSent\" is-required-attachments-completed=\"ticket.day5.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day5.hasRequiredAttachments\" allocated-resource-items=\"ticket.day5.allocatedResourceItems\"></ticket-status-details-rw-component><week-ticket-footer-rw-component id=\"ticket.day5.id\" ticket-no=\"ticket.day5.ticketNo\" parent-ticket-no=\"ticket.day5.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" is-un-confirmed-date=\"ticket.day5.IsUnconfirmedDate\" is-locked=\"ticket.day5.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day5.IsLockedByPreSchedule\" start-date=\"ticket.day5.startDate\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day5.ticketType\" has-generated-paperwork-pdf=\"ticket.day5.hasGeneratedPaperworkPdf\" whiteboard-type=\"vm.whiteboardType\" on-pre-schedule=\"vm.preSchedule(value)\" ticket=\"ticket.day5\"></week-ticket-footer-rw-component><week-ticket-info-rw-component card-name=\"ticket.day5.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day5.ticketCount\" start-date=\"ticket.day5.startDate\" end-date=\"ticket.day5.endDate\" branch=\"ticket.day5.branch\" job-address=\"ticket.day5.jobAddress\" job-location-address=\"ticket.day5.jobLocationAddress\" project-name=\"ticket.day5.projectName\" show-project=\"vm.showProject\" resource-items=\"ticket.day5.allocatedResourceItems\" ng-dblclick=\"vm.openCardTicket(ticket.day5)\"></week-ticket-info-rw-component><job-board-ticket-number related-number=\"ticket.day5.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" whiteboard-type=\"vm.whiteboardType\" show-related=\"vm.showRelatedTicketNumber\" ticket-number=\"ticket.day5.ticketNo\" purchase-order-number=\"ticket.day5.purchaseOrderNumber\" work-order-number=\"ticket.day5.workOrderNumber\" show-work-order-number=\"vm.showWorkOrderNumber\" is-locked=\"ticket.day5.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day5.IsLockedByPreSchedule && !ticket.day5.isSmartSchedulingFailed\"></job-board-ticket-number><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day5.IsLockedByPreSchedule\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_IN_PROGRESS_MESSAGE\"></span></div><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn min-width-65\" ng-click=\"vm.cancelScheduling(ticket.day5)\">Cancel</md-button></div></div></div><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day5.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_FAILED_MESSAGE\"></span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center\" class=\"ticket-actions\" ng-if=\"(ticket.day5.status | filter:{abbrev:\'CJPA\'}).length\"><md-button type=\"button\" class=\"button-margin md-raised btn-approve\" ng-click=\"vm.approveTicket(ticket.day5)\">Approve</md-button><md-button type=\"button\" class=\"md-accent md-warn md-raised button-margin btn-reject\" ng-click=\"vm.rejectTicket(ticket.day5)\">Reject</md-button></div><job-board-resources-component ticket=\"ticket.day5\"></job-board-resources-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 430px;\" ng-if=\"ticket.day5 == null\"></div><div class=\"list-card md-whiteframe-2dp last-ticket-box\" ms-scroll2=\"\" style=\"height: 430px;\" ng-if=\"ticket.day6 != null\"><ticket-status-details-rw-component id=\"{{ticket.day6.ticketNo}}\" status=\"ticket.day6.status\" show-shift-allocation-icon=\"ticket.day6.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day6.IsDayShift\" show-equipment-allocation-icon=\"ticket.day6.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day6.showRequireAllocationIcon\" ticket-type=\"ticket.day6.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day7.isEmailSent\" is-required-attachments-completed=\"ticket.day6.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day6.hasRequiredAttachments\" allocated-resource-items=\"ticket.day6.allocatedResourceItems\"></ticket-status-details-rw-component><week-ticket-footer-rw-component id=\"ticket.day6.id\" ticket-no=\"ticket.day6.ticketNo\" parent-ticket-no=\"ticket.day6.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" is-un-confirmed-date=\"ticket.day6.IsUnconfirmedDate\" is-locked=\"ticket.day6.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day6.IsLockedByPreSchedule\" start-date=\"ticket.day6.startDate\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day6.ticketType\" has-generated-paperwork-pdf=\"ticket.day6.hasGeneratedPaperworkPdf\" whiteboard-type=\"vm.whiteboardType\" on-pre-schedule=\"vm.preSchedule(value)\" ticket=\"ticket.day6\"></week-ticket-footer-rw-component><week-ticket-info-rw-component card-name=\"ticket.day6.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day6.ticketCount\" start-date=\"ticket.day6.startDate\" end-date=\"ticket.day6.endDate\" branch=\"ticket.day6.branch\" job-address=\"ticket.day6.jobAddress\" job-location-address=\"ticket.day6.jobLocationAddress\" project-name=\"ticket.day6.projectName\" show-project=\"vm.showProject\" resource-items=\"ticket.day6.allocatedResourceItems\" ng-dblclick=\"vm.openCardTicket(ticket.day6)\"></week-ticket-info-rw-component><job-board-ticket-number related-number=\"ticket.day6.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" whiteboard-type=\"vm.whiteboardType\" show-related=\"vm.showRelatedTicketNumber\" ticket-number=\"ticket.day6.ticketNo\" purchase-order-number=\"ticket.day6.purchaseOrderNumber\" work-order-number=\"ticket.day6.workOrderNumber\" show-work-order-number=\"vm.showWorkOrderNumber\" is-locked=\"ticket.day6.IsLocked\" is-locked-by-pre-schedule=\"vm.isSmartSchedulingEnabled && ticket.day6.IsLockedByPreSchedule\"></job-board-ticket-number><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day6.IsLockedByPreSchedule && !ticket.day6.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_IN_PROGRESS_MESSAGE\"></span></div><div ng-if=\"vm.hasSmartSchedulingAccess\"><md-button class=\"md-warn min-width-65\" ng-click=\"vm.cancelScheduling(ticket.day6)\">Cancel</md-button></div></div></div><div id=\"ai-allocation\" ng-if=\"vm.isSmartSchedulingEnabled && ticket.day6.isSmartSchedulingFailed\"><div flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-700-fg h6 preschedule-section\"><span class=\"ai-failed-scheduling\" translate=\"MANAGE.AI_RESOURCE_WHITEBOARD_FAILED_MESSAGE\"></span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center\" class=\"ticket-actions\" ng-if=\"(ticket.day6.status | filter:{abbrev:\'CJPA\'}).length\"><md-button type=\"button\" class=\"button-margin md-raised btn-approve\" ng-click=\"vm.approveTicket(ticket.day6)\">Approve</md-button><md-button type=\"button\" class=\"md-accent md-warn md-raised button-margin btn-reject\" ng-click=\"vm.rejectTicket(ticket.day6)\">Reject</md-button></div><job-board-resources-component ticket=\"ticket.day6\"></job-board-resources-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 430px; margin-right: 0;\" ng-if=\"ticket.day6 == null\"></div></div></div></md-virtual-repeat-container></div>");
$templateCache.put("app/main/jobs/resourceSidenav/components/resourceList/resource-list.directive.html","<div id=\"resource-list\" flex=\"\" layout=\"column\"><div ng-if=\"vm.service.fetchError\" layout=\"row\" layout-align=\"space-between center\" style=\"padding: 12px 16px; background-color: #fdecea; color: #d50000;\"><span class=\"md-caption\">{{ \'RESOURCEALLOCATION.PANEL_FETCH_ERROR\' | translate }}</span><md-button class=\"md-raised md-warn\" ng-click=\"vm.service.retryFetch()\" style=\"margin: 0;\">{{ \'RESOURCEALLOCATION.RETRY\' | translate }}</md-button></div><div ng-if=\"vm.list.length === 0 && vm.service.hasLoadedOnce && !vm.service.isLoading && !vm.service.fetchError\" layout=\"column\" layout-align=\"center center\" style=\"padding: 40px 20px; text-align: center; color: rgba(0,0,0,0.54);\"><div style=\"font-size: 16px; margin-bottom: 8px;\">No resources found</div><div style=\"font-size: 14px;\">Try adjusting your search or filters</div></div><people-group ng-if=\"vm.service.isAllocatingAPerson()\" list=\"vm.list\" title=\"Company Preferred\"></people-group><people-group ng-if=\"vm.service.isAllocatingAPerson()\" list=\"vm.list\" title=\"Employee Preferred\"></people-group><people-group ng-if=\"vm.service.isAllocatingAPerson()\" list=\"vm.list\" title=\"General\"></people-group><equipment-group ng-if=\"vm.service.isAllocatingAnEquipment()\" list=\"vm.list\"></equipment-group></div>");
$templateCache.put("app/main/jobs/resourceSidenav/components/search/resource-search.directive.html","<div layout=\"row\" layout-margin=\"\" layout-align=\"start center\"><md-input-container flex=\"\" ng-if=\"vm.service.hasLoadedOnce && !vm.service.isLoading\"><input type=\"text\" ng-model=\"vm.service.searchText\" ng-change=\"vm.service.performSearch(vm.service.searchText)\" placeholder=\"Search\"></md-input-container><md-progress-circular ng-if=\"vm.service.isSearching\" md-mode=\"indeterminate\" md-diameter=\"20\" style=\"margin-left: 8px;\"></md-progress-circular></div>");
$templateCache.put("app/main/jobs/resourceSidenav/components/toolbar/resource-toolbar.directive.html","<md-toolbar md-scroll-shrink=\"\" class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"auto\"><h3><span ng-if=\"vm.service.isLoading\">Loading {{vm.service.isAllocatingAPerson() ? \'People\' : \'Equipment\'}} ...</span> <span ng-if=\"!vm.service.isLoading\">Available {{vm.service.isAllocatingAPerson() ? \'People\' : \'Equipment\'}}</span></h3></div><div flex=\"none\"><md-progress-circular md-diameter=\"30\" ng-if=\"vm.service.isLoading\" md-mode=\"indeterminate\"></md-progress-circular><md-icon ng-if=\"!vm.service.isLoading\" ng-click=\"vm.closeSidenav()\" md-svg-src=\"/assets/icons/ic_close_24px.svg\" style=\"cursor : pointer\" aria-label=\"Close\"></md-icon></div></div><md-progress-linear ng-if=\"vm.service.isLoading\" md-mode=\"query\"></md-progress-linear></md-toolbar>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/daily/jobBoardDayViewComponent.html","<div id=\"dailyboard\"><div class=\"list-wrapper\"><div class=\"list md-whiteframe-1dp ticket-container\" layout=\"column\"><div class=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span>{{vm.header}}</span></div><md-menu md-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.addTicket($event, vm.currentDate)\" aria-label=\"Add Ticket\" translate=\"\" translate-attr-aria-label=\"SB.ADD_TICKET\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.ADD_TICKET\">Add Ticket</span></md-button></md-menu-item></md-menu-content></md-menu></div><div id=\"day-view-cards-container\" class=\"list-content\" layout=\"column\"><div class=\"list-cards\"><md-virtual-repeat-container id=\"dayview-vertical-container\" ms-scroll=\"\"><div md-virtual-repeat=\"tickets in vm.sourceData\" class=\"repeated-item\" flex=\"\"><div layout=\"row\"><div ng-repeat=\"ticket in tickets\"><div class=\"list-card md-whiteframe-2dp\" style=\"height: auto;\"><daily-ticket-status-component status=\"ticket.status\" show-shift-allocation-icon=\"ticket.showShiftAllocationIcon\" is-day-shift=\"ticket.IsDayShift\" show-equipment-allocation-icon=\"ticket.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.showRequireAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" ticket-type=\"ticket.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.isEmailSent\" is-required-attachments-completed=\"ticket.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.hasRequiredAttachments\"></daily-ticket-status-component><daily-ticket-info-component card-name=\"ticket.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.ticketCount\" start-date=\"ticket.startDate\" end-date=\"ticket.endDate\" branch=\"ticket.branch\" job-address=\"ticket.jobAddress\" job-location-address=\"ticket.jobLocationAddress\" project-name=\"ticket.projectName\" show-project=\"vm.showProject\" whiteboard-type=\"vm.whiteboardType\" ng-dblclick=\"vm.openCardTicket(ticket)\"></daily-ticket-info-component><daily-ticket-footer-component id=\"ticket.id\" ticket=\"ticket\" ticket-no=\"ticket.ticketNo\" related-number=\"ticket.relatedNumber\" parent-ticket-no=\"ticket.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.ticketCount\" contains-people=\"ticket.hasPeople\" contains-equipment=\"ticket.hasEquipment\" is-un-confirmed-date=\"ticket.IsUnconfirmedDate\" is-locked=\"ticket.IsLocked\" is-locked-by-pre-schedule=\"ticket.IsLockedByPreSchedule\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.ticketType\" disable-billing-pref=\"vm.disableBillingPref\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" has-generated-paperwork-pdf=\"ticket.hasGeneratedPaperworkPdf\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" start-date=\"ticket.startDate\" whiteboard-type=\"vm.whiteboardType\"></daily-ticket-footer-component></div></div></div></div></md-virtual-repeat-container></div></div></div></div></div>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/dateNavigation/dateNavigation.html","<div id=\"dateNavigator\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"dateNavigationVm.goPrev()\" aria-label=\"Previous\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div flex=\"\" layout=\"column\" ng-click=\"dateNavigationVm.showCalendar()\" layout-align=\"center center\"><div class=\"title\">{{dateNavigationVm.title}}</div><div class=\"light-blue-900-fg\">Select date range</div></div><md-button class=\"md-icon-button arrow\" ng-click=\"dateNavigationVm.goNext()\" aria-label=\"Next\" translate=\"\" translate-attr-aria-label=\"WHITEBOARD.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/monthly/jobMonthly.html","<div id=\"calendarView\" ui-calendar=\"jobMonthlyVm.calendarUiConfig.calendar\" ng-model=\"jobMonthlyVm.eventData\" calendar=\"jobCalendar2\"></div>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/weekly/jobBoardComponent.html","<div id=\"board\" layout=\"row\"><div class=\"list-wrapper\" ng-repeat=\"list in vm.headers\"><div class=\"list md-whiteframe-1dp ticket-container\" layout=\"column\" style=\"min-height:100%;\"><div class=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span>{{list.name}}</span></div><md-menu md-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.addTicket($event, list.headerDate)\" aria-label=\"Add Ticket\" translate=\"\" translate-attr-aria-label=\"SB.ADD_TICKET\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.ADD_TICKET\">Add Ticket</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><md-virtual-repeat-container id=\"vertical-container\"><div md-virtual-repeat=\"ticket in vm.sourceData\" class=\"repeated-item\" flex=\"\"><div layout=\"row\"><div class=\"list-card md-whiteframe-2dp ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day0 != null\"><ticket-status-details-component status=\"ticket.day0.status\" show-shift-allocation-icon=\"ticket.day0.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day0.IsDayShift\" show-equipment-allocation-icon=\"ticket.day0.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day0.showRequireAllocationIcon\" ticket-type=\"ticket.day0.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day0.isEmailSent\" is-required-attachments-completed=\"ticket.day0.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day0.hasRequiredAttachments\"></ticket-status-details-component><week-ticket-info-component card-name=\"ticket.day0.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day0.ticketCount\" start-date=\"ticket.day0.startDate\" end-date=\"ticket.day0.endDate\" branch=\"ticket.day0.branch\" job-address=\"ticket.day0.jobAddress\" job-location-address=\"ticket.day0.jobLocationAddress\" project-name=\"ticket.day0.projectName\" show-project=\"vm.showProject\" ng-dblclick=\"vm.openCardTicket(ticket.day0)\"></week-ticket-info-component><week-ticket-footer-component id=\"ticket.day0.id\" ticket=\"ticket.day0\" ticket-no=\"ticket.day0.ticketNo\" related-number=\"ticket.day0.relatedNumber\" parent-ticket-no=\"ticket.day0.parentTicketNo\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day0.ticketCount\" contains-people=\"ticket.day0.hasPeople\" contains-equipment=\"ticket.day0.hasEquipment\" is-un-confirmed-date=\"ticket.day0.IsUnconfirmedDate\" is-locked=\"ticket.day0.IsLocked\" is-locked-by-pre-schedule=\"ticket.day0.IsLockedByPreSchedule\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day0.ticketType\" disable-billing-pref=\"vm.disableBillingPref\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" start-date=\"ticket.day0.startDate\" has-generated-paperwork-pdf=\"ticket.day0.hasGeneratedPaperworkPdf\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" whiteboard-type=\"vm.whiteboardType\"></week-ticket-footer-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day0 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day1 != null\"><ticket-status-details-component status=\"ticket.day1.status\" show-shift-allocation-icon=\"ticket.day1.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day1.IsDayShift\" show-equipment-allocation-icon=\"ticket.day1.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day1.showRequireAllocationIcon\" ticket-type=\"ticket.day1.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day1.isEmailSent\" is-required-attachments-completed=\"ticket.day1.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day1.hasRequiredAttachments\"></ticket-status-details-component><week-ticket-info-component card-name=\"ticket.day1.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day1.ticketCount\" start-date=\"ticket.day1.startDate\" end-date=\"ticket.day1.endDate\" branch=\"ticket.day1.branch\" job-address=\"ticket.day1.jobAddress\" job-location-address=\"ticket.day1.jobLocationAddress\" project-name=\"ticket.day1.projectName\" show-project=\"vm.showProject\" ng-dblclick=\"vm.openCardTicket(ticket.day1)\"></week-ticket-info-component><week-ticket-footer-component id=\"ticket.day1.id\" ticket=\"ticket.day1\" ticket-no=\"ticket.day1.ticketNo\" related-number=\"ticket.day1.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day1.ticketCount\" contains-people=\"ticket.day1.hasPeople\" contains-equipment=\"ticket.day1.hasEquipment\" is-un-confirmed-date=\"ticket.day1.IsUnconfirmedDate\" is-locked=\"ticket.day1.IsLocked\" is-locked-by-pre-schedule=\"ticket.day1.IsLockedByPreSchedule\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day1.ticketType\" disable-billing-pref=\"vm.disableBillingPref\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" start-date=\"ticket.day1.startDate\" has-generated-paperwork-pdf=\"ticket.day1.hasGeneratedPaperworkPdf\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" whiteboard-type=\"vm.whiteboardType\"></week-ticket-footer-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day1 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day2 != null\"><ticket-status-details-component status=\"ticket.day2.status\" show-shift-allocation-icon=\"ticket.day2.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day2.IsDayShift\" show-equipment-allocation-icon=\"ticket.day2.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day2.showRequireAllocationIcon\" ticket-type=\"ticket.day2.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day2.isEmailSent\" is-required-attachments-completed=\"ticket.day2.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day2.hasRequiredAttachments\"></ticket-status-details-component><week-ticket-info-component card-name=\"ticket.day2.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day2.ticketCount\" start-date=\"ticket.day2.startDate\" end-date=\"ticket.day2.endDate\" branch=\"ticket.day2.branch\" job-address=\"ticket.day2.jobAddress\" job-location-address=\"ticket.day2.jobLocationAddress\" project-name=\"ticket.day2.projectName\" show-project=\"vm.showProject\" ng-dblclick=\"vm.openCardTicket(ticket.day2)\"></week-ticket-info-component><week-ticket-footer-component id=\"ticket.day2.id\" ticket=\"ticket.day2\" ticket-no=\"ticket.day2.ticketNo\" related-number=\"ticket.day2.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day2.ticketCount\" contains-people=\"ticket.day2.hasPeople\" contains-equipment=\"ticket.day2.hasEquipment\" is-un-confirmed-date=\"ticket.day2.IsUnconfirmedDate\" is-locked=\"ticket.day2.IsLocked\" is-locked-by-pre-schedule=\"ticket.day2.IsLockedByPreSchedule\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day2.ticketType\" disable-billing-pref=\"vm.disableBillingPref\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" start-date=\"ticket.day2.startDate\" has-generated-paperwork-pdf=\"ticket.day2.hasGeneratedPaperworkPdf\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" whiteboard-type=\"vm.whiteboardType\"></week-ticket-footer-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day2 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day3 != null\"><ticket-status-details-component status=\"ticket.day3.status\" show-shift-allocation-icon=\"ticket.day3.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day3.IsDayShift\" show-equipment-allocation-icon=\"ticket.day3.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day3.showRequireAllocationIcon\" ticket-type=\"ticket.day3.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day3.isEmailSent\" is-required-attachments-completed=\"ticket.day3.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day3.hasRequiredAttachments\"></ticket-status-details-component><week-ticket-info-component card-name=\"ticket.day3.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day3.ticketCount\" start-date=\"ticket.day3.startDate\" end-date=\"ticket.day3.endDate\" branch=\"ticket.day3.branch\" job-address=\"ticket.day3.jobAddress\" job-location-address=\"ticket.day3.jobLocationAddress\" project-name=\"ticket.day3.projectName\" show-project=\"vm.showProject\" ng-dblclick=\"vm.openCardTicket(ticket.day3)\"></week-ticket-info-component><week-ticket-footer-component id=\"ticket.day3.id\" ticket=\"ticket.day3\" ticket-no=\"ticket.day3.ticketNo\" related-number=\"ticket.day3.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day3.ticketCount\" contains-people=\"ticket.day3.hasPeople\" contains-equipment=\"ticket.day3.hasEquipment\" is-un-confirmed-date=\"ticket.day3.IsUnconfirmedDate\" is-locked=\"ticket.day3.IsLocked\" is-locked-by-pre-schedule=\"ticket.day3.IsLockedByPreSchedule\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day3.ticketType\" disable-billing-pref=\"vm.disableBillingPref\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" start-date=\"ticket.day2.startDate\" has-generated-paperwork-pdf=\"ticket.day3.hasGeneratedPaperworkPdf\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" whiteboard-type=\"vm.whiteboardType\"></week-ticket-footer-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day3 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day4 != null\"><ticket-status-details-component status=\"ticket.day4.status\" show-shift-allocation-icon=\"ticket.day4.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day4.IsDayShift\" show-equipment-allocation-icon=\"ticket.day4.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day4.showRequireAllocationIcon\" ticket-type=\"ticket.day4.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day4.isEmailSent\" is-required-attachments-completed=\"ticket.day4.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day4.hasRequiredAttachments\"></ticket-status-details-component><week-ticket-info-component card-name=\"ticket.day4.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day4.ticketCount\" start-date=\"ticket.day4.startDate\" end-date=\"ticket.day4.endDate\" branch=\"ticket.day4.branch\" job-address=\"ticket.day4.jobAddress\" job-location-address=\"ticket.day4.jobLocationAddress\" project-name=\"ticket.day4.projectName\" show-project=\"vm.showProject\" ng-dblclick=\"vm.openCardTicket(ticket.day4)\"></week-ticket-info-component><week-ticket-footer-component id=\"ticket.day4.id\" ticket=\"ticket.day4\" ticket-no=\"ticket.day4.ticketNo\" related-number=\"ticket.day4.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day4.ticketCount\" contains-people=\"ticket.day4.hasPeople\" contains-equipment=\"ticket.day4.hasEquipment\" is-un-confirmed-date=\"ticket.day4.IsUnconfirmedDate\" is-locked=\"ticket.day4.IsLocked\" is-locked-by-pre-schedule=\"ticket.day4.IsLockedByPreSchedule\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day4.ticketType\" disable-billing-pref=\"vm.disableBillingPref\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" start-date=\"ticket.day4.startDate\" has-generated-paperwork-pdf=\"ticket.day4.hasGeneratedPaperworkPdf\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" whiteboard-type=\"vm.whiteboardType\"></week-ticket-footer-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day4 == null\"></div><div class=\"list-card md-whiteframe-2dp ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day5 != null\"><ticket-status-details-component status=\"ticket.day5.status\" show-shift-allocation-icon=\"ticket.day5.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day5.IsDayShift\" show-equipment-allocation-icon=\"ticket.day5.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day5.showRequireAllocationIcon\" ticket-type=\"ticket.day5.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day5.isEmailSent\" is-required-attachments-completed=\"ticket.day5.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day5.hasRequiredAttachments\"></ticket-status-details-component><week-ticket-info-component card-name=\"ticket.day5.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day5.ticketCount\" start-date=\"ticket.day5.startDate\" end-date=\"ticket.day5.endDate\" branch=\"ticket.day5.branch\" job-address=\"ticket.day5.jobAddress\" job-location-address=\"ticket.day5.jobLocationAddress\" project-name=\"ticket.day5.projectName\" show-project=\"vm.showProject\" ng-dblclick=\"vm.openCardTicket(ticket.day5)\"></week-ticket-info-component><week-ticket-footer-component id=\"ticket.day5.id\" ticket=\"ticket.day5\" ticket-no=\"ticket.day5.ticketNo\" related-number=\"ticket.day5.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day5.ticketCount\" contains-people=\"ticket.day5.hasPeople\" contains-equipment=\"ticket.day5.hasEquipment\" is-un-confirmed-date=\"ticket.day5.IsUnconfirmedDate\" is-locked=\"ticket.day5.IsLocked\" is-locked-by-pre-schedule=\"ticket.day5.IsLockedByPreSchedule\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day5.ticketType\" disable-billing-pref=\"vm.disableBillingPref\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" start-date=\"ticket.day5.startDate\" has-generated-paperwork-pdf=\"ticket.day5.hasGeneratedPaperworkPdf\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" whiteboard-type=\"vm.whiteboardType\"></week-ticket-footer-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 300px;\" ng-if=\"ticket.day5 == null\"></div><div class=\"list-card md-whiteframe-2dp last-ticket-box\" style=\"height: 290px;\" ng-if=\"ticket.day6 != null\"><ticket-status-details-component status=\"ticket.day6.status\" show-shift-allocation-icon=\"ticket.day6.showShiftAllocationIcon\" allow-group-by-client=\"vm.allowGrouping\" is-day-shift=\"ticket.day6.IsDayShift\" show-equipment-allocation-icon=\"ticket.day6.showEquipmentAllocationIcon\" show-require-allocation-icon=\"ticket.day6.showRequireAllocationIcon\" ticket-type=\"ticket.day6.ticketType\" whiteboard-type=\"vm.whiteboardType\" is-email-sent=\"ticket.day6.isEmailSent\" is-required-attachments-completed=\"ticket.day6.isRequiredAttachmentsCompleted\" has-required-attachments=\"ticket.day6.hasRequiredAttachments\"></ticket-status-details-component><week-ticket-info-component card-name=\"ticket.day6.name\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day6.ticketCount\" start-date=\"ticket.day6.startDate\" end-date=\"ticket.day6.endDate\" branch=\"ticket.day6.branch\" job-address=\"ticket.day6.jobAddress\" job-location-address=\"ticket.day6.jobLocationAddress\" project-name=\"ticket.day6.projectName\" show-project=\"vm.showProject\" ng-dblclick=\"vm.openCardTicket(ticket.day6)\"></week-ticket-info-component><week-ticket-footer-component id=\"ticket.day6.id\" ticket=\"ticket.day6\" ticket-no=\"ticket.day6.ticketNo\" related-number=\"ticket.day6.relatedNumber\" allow-group-by-client=\"vm.allowGrouping\" ticket-count=\"ticket.day6.ticketCount\" contains-people=\"ticket.day6.hasPeople\" contains-equipment=\"ticket.day6.hasEquipment\" is-un-confirmed-date=\"ticket.day6.IsUnconfirmedDate\" is-locked=\"ticket.day6.IsLocked\" is-locked-by-pre-schedule=\"ticket.day6.IsLockedByPreSchedule\" show-related-ticket-number=\"vm.showRelatedTicketNumber\" ticket-type=\"ticket.day6.ticketType\" disable-billing-pref=\"vm.disableBillingPref\" on-open-edit-ticket=\"vm.onOpenEditTicket(value)\" on-open-resource-allocation=\"vm.openResourceAlloc(value)\" on-open-timesheet=\"vm.openTimesheet(value)\" on-clone-ticket=\"vm.cloneTicket(value)\" on-cancel-ticket=\"vm.cancelTicket(value)\" on-add-related-ticket=\"vm.addRelatedTicket(value)\" on-download-pdf=\"vm.downloadPdf(value)\" on-ticket-billing-pref=\"vm.ticketBillingPref(value)\" start-date=\"ticket.day6.startDate\" has-generated-paperwork-pdf=\"ticket.day6.hasGeneratedPaperworkPdf\" on-download-paperwork-pdf=\"vm.onDownloadPaperworkPdf(value)\" on-download-timesheet-pdf=\"vm.onDownloadTimesheetPdf(value)\" whiteboard-type=\"vm.whiteboardType\"></week-ticket-footer-component></div><div class=\"list-card empty-ticket-box\" style=\"height: 300px; margin-right: 0;\" ng-if=\"ticket.day6 == null\"></div></div></div></md-virtual-repeat-container></div>");
$templateCache.put("app/main/jobs/widget/JobLocation/add/address-searchbox.html","<input type=\"text\" placeholder=\"Enter an Address\">");
$templateCache.put("app/main/jobs/widget/JobLocation/add/address.html","<md-dialog aria-label=\"{{vm.title}}\" flex=\"40\" ng-cloak=\"\"><form name=\"addressDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div id=\"contactAddress-container\" class=\"searchbox-container\" ng-if=\"vm.customAddressLink\"></div><br ng-if=\"vm.customAddressLink\"><br ng-if=\"vm.customAddressLink\"><div layout=\"row\" flex=\"\" ng-if=\"vm.customAddressLink\"><a ng-click=\"vm.onShowExtraFields()\" class=\"md-caption\">Input custom address</a></div><div ng-show=\"vm.menu\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input type=\"text\" name=\"bldgName\" ng-model=\"vm.address.BldgName\" placeholder=\"Building Name\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"20\"><input type=\"text\" name=\"unitNumber\" ng-model=\"vm.address.UnitNumber\" placeholder=\"Unit Number\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><input type=\"text\" name=\"streetNumber\" ng-model=\"vm.address.StreetNumber\" placeholder=\"Street Number\"></md-input-container><md-input-container flex-gt-sm=\"\"><input type=\"text\" name=\"streetName\" ng-model=\"vm.address.StreetName\" placeholder=\"Street Name\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"40\"><input type=\"text\" name=\"Suburb\" ng-model=\"vm.address.City\" placeholder=\"Suburb/Town/City\"></md-input-container><md-input-container flex-gt-sm=\"\" ng-show=\"vm.States.length > 0\"><label ng-show=\"vm.States.length > 0\">State</label><md-select ng-model=\"vm.address.State\" placeholder=\"State\" ng-show=\"vm.States.length > 0\"><md-option ng-repeat=\"state in vm.States\" ng-value=\"state.Name\">{{state.Name}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.States.length == 0\"><input type=\"text\" name=\"State\" ng-model=\"vm.address.State\" placeholder=\"State/Province\" ng-show=\"vm.States.length == 0\"></md-input-container><md-input-container flex-gt-sm=\"\"><input type=\"text\" name=\"postalCode\" ng-model=\"vm.address.PostCode\" placeholder=\"Postal/Zip Code\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex-gt-sm=\"\"><label>Country</label><md-select ng-model=\"vm.address.Country\" ng-change=\"vm.stateChanger(vm.address.Country, false)\"><md-option ng-repeat=\"country in vm.countries\" ng-value=\"country.Name\">{{country.Name}}</md-option></md-select></md-input-container></div></div><div style=\"display: none\"><ui-gmap-google-map center=\"map.center\" zoom=\"map.zoom\" draggable=\"true\" options=\"options\"><ui-gmap-search-box template=\"searchbox.template\" events=\"searchbox.events\" parentdiv=\"\'contactAddress-container\'\"></ui-gmap-search-box></ui-gmap-google-map></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone(vm.address)\" style=\"margin-right:20px;\" ng-disabled=\"addressDialog.$invalid\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/widget/DroppedAssetComponent/DroppedAssetManage/dropped-asset-dialog.html","<md-dialog id=\"dropped-asset\" aria-label=\"{{ \'MANAGE.DROPPED_ASSET\' | translate }}\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ droppedAssetDialogVm.assetName }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"droppedAssetDialogVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"{{ \'MANAGE.CLOSE_DIALOG\' | translate }}\"></md-icon></md-button></div></md-toolbar><form name=\"DroppedAssetEntryForm\" ng-submit=\"DroppedAssetEntryForm.$valid && droppedAssetDialogVm.onSave(droppedAssetDialogVm.toDelete)\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"!droppedAssetDialogVm.toDelete\"><md-input-container flex=\"\"><label translate=\"MANAGE.QUANTITY\"></label> <input type=\"number\" pattern=\"[0-9]+([\\.,][0-9]+)?\" step=\"1\" min=\"1\" required=\"\" name=\"qty\" ng-model=\"droppedAssetDialogVm.Quantity\" placeholder=\"0\"><div ng-messages=\"DroppedAssetEntryForm.qty.$error\" ng-show=\"DroppedAssetEntryForm.qty.$touched\" role=\"alert\"><div ng-message=\"required\"><span>{{ \'MANAGE.HIRE_COST_REQUIRED\' | translate }}</span></div><div ng-message=\"number\"><span>{{ \'MANAGE.INVALID_NUMBER\' | translate }}</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"!droppedAssetDialogVm.toDelete && droppedAssetDialogVm.jobService.jobModel.TicketType == 1 && droppedAssetDialogVm.claimsUtilService.isBillingEnabled()\"><md-input-container flex=\"\"><label translate=\"MANAGE.BILLING_PERIOD\"></label><md-select class=\"md-block\" flex=\"\" layout=\"row\" name=\"billingperiod\" ng-model=\"droppedAssetDialogVm.ItemBillingPeriod\" aria-label=\"{{ \'MANAGE.BILLING_PERIOD\' | translate }}\" translate=\"\" translate-attr-aria-label=\"{{ \'MANAGE.BILLING_PERIOD\' | translate }}\" md-on-open=\"droppedAssetDialogVm.BillingPeriodChanged = false\" ng-change=\"droppedAssetDialogVm.BillingPeriodChanged = true\" md-on-close=\"droppedAssetDialogVm.onChangeBillingPeriod(droppedAssetDialogVm.ItemBillingPeriod)\" placeholder=\"{{ \'MANAGE.BILLING_PERIOD\' | translate }}\"><md-option ng-repeat=\"bp in droppedAssetDialogVm.jobService.billingPeriodLookup\" ng-value=\"bp.ItemId\">{{ bp.Name }}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"droppedAssetDialogVm.jobService.jobModel.TicketType == 1 && droppedAssetDialogVm.jobService.isEditMode\"><md-radio-group ng-model=\"droppedAssetDialogVm.UpdateTransaction\" required=\"\"><md-radio-button ng-value=\"1\" selected=\"\">{{ \'MANAGE.UPDATE_THIS_TICKETS_DATE_ONWARDS\' | translate }}</md-radio-button><md-radio-button ng-value=\"2\">{{ \'MANAGE.UPDATE_THIS_TICKETS_DATE_ONLY\' | translate }}</md-radio-button><md-radio-button ng-value=\"3\" ng-if=\"droppedAssetDialogVm.claimsUtilService.isBillingEnabled()\">{{ \'MANAGE.UPDATE_ALL_UNBILLED\' | translate }}</md-radio-button><md-radio-button ng-value=\"4\">{{ \'MANAGE.UPDATE_SPECIFIC_DATE_RANGE\' | translate }}</md-radio-button></md-radio-group></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"(droppedAssetDialogVm.jobService.jobModel.TicketType == 1 && droppedAssetDialogVm.jobService.isEditMode) && droppedAssetDialogVm.UpdateTransaction == 4\"><div flex=\"\"><md-datepicker name=\"startDate\" md-placeholder=\"{{ \'MANAGE.JOBSTARTDATE\' | translate }}\" id=\"start-date\" ng-blur=\"droppedAssetDialogVm.checkApplyOnEndDate()\" ng-model=\"droppedAssetDialogVm.ApplyOnStartDate\" ng-required=\"droppedAssetDialogVm.UpdateTransaction == 4\"></md-datepicker><div ng-messages=\"DroppedAssetEntryForm.startDate.$error\" role=\"alert\"><div ng-message=\"mindate\"><span translate=\"MANAGE.INDIVIDUAL_ITEM_DIALOG_START_DATE_IS_REQUIRED\"></span></div></div></div><div flex=\"\"><md-datepicker name=\"endDate\" md-placeholder=\"{{ \'MANAGE.JOBENDDATE\' | translate }}\" id=\"end-date\" ng-blur=\"droppedAssetDialogVm.checkApplyOnEndDate()\" ng-model=\"droppedAssetDialogVm.ApplyOnEndDate\" ng-required=\"droppedAssetDialogVm.UpdateTransaction == 4\"></md-datepicker><div ng-messages=\"DroppedAssetEntryForm.endDate.$error\" role=\"alert\"><div ng-message=\"mindate\"><span translate=\"MANAGE.INDIVIDUAL_ITEM_DIALOG_END_DATE_IS_REQUIRED\"></span></div></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"droppedAssetDialogVm.onCancel()\" translate=\"MANAGE.MANAGEDROPPEDASSETCANCEL\"></md-button><md-button ng-click=\"droppedAssetDialogVm.onSave(droppedAssetDialogVm.toDelete)\" ng-disabled=\"DroppedAssetEntryForm.$invalid\" class=\"md-accent\" aria-label=\"{{ !droppedAssetDialogVm.toDelete ? \'Save\':\'Delete\'\" translate=\"{{ !droppedAssetDialogVm.toDelete ? \'MANAGE.MANAGEDROPPEDASSETSAVE\':\'MANAGE.MANAGEDROPPEDASSETREMOVE\' }}\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/widget/DroppedAssetComponent/DroppedAssetUnlinkItems/asset-unlink-items-dialog.html","<md-dialog class=\"main-style resource-removal\" flex=\"20\" flex-xs=\"25\" ng-cloak=\"\"><md-dialog-content style=\"padding-left: 40px; padding-right:40px;\"><div><div><h2 style=\"font-weight: bold;\">Change Resources</h2><p>You are about to change the resource(s) on this ticket.</p><span layout-wrap=\"\">Changing the resource(s) is going to unlink the following items from its related item:</span></div><br><div ng-repeat=\"itemToRemove in dialogUnlinkVm.items.resourcesToRemove\"><b>{{itemToRemove.ItemNameDisplay}}</b><ul><li ng-if=\"itemToRemove.ParentAllocatedResourceId === null\" ng-repeat=\"item in dialogUnlinkVm.items.linkedItems | filter : { ParentAllocatedResourceId : itemToRemove.Id }\">{{item.ItemNameDisplay}}</li><li ng-if=\"itemToRemove.ParentAllocatedResourceId != null\" ng-repeat=\"item in dialogUnlinkVm.items.linkedItems | filter : { Id : itemToRemove.ParentAllocatedResourceId }\">{{item.ItemNameDisplay}}</li></ul></div>Are you sure you want to proceed?</div></md-dialog-content><md-dialog-actions layout=\"column\" layout-align=\"center\" style=\"padding-bottom: 20px; padding-left: 40px; padding-right:40px;\"><md-button class=\"\" ng-click=\"dialogUnlinkVm.dismissDialog()\">Cancel</md-button><md-button class=\"md-accent\" ng-click=\"dialogUnlinkVm.onConfirm()\">Yes, change resources and unlink items</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/widget/DroppedAssetComponent/OptionalItemsSelector/optional-items-dialog.html","<md-dialog id=\"dropped-asset\" aria-label=\"{{ \'MANAGE.DROPPED_ASSET\' | translate }}\" flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Select Related Shift Type</h2></div></md-toolbar><md-dialog-content><div class=\"padding-20\"><h4 class=\"issue\" ng-if=\"dialogVm.item.disabled\">No related Shift Types can be added as they do not belong to the branch for this job. Please add or update the Shift Types and try again</h4><div ng-if=\"!dialogVm.item.disabled\">Select the related shift type for this {{dialogVm.item.ItemName}}</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap=\"\" ng-model=\"dialogVm.selectedOptionalItem\"><md-radio-button ng-repeat=\"optionalItem in dialogVm.optionalItems\" ng-value=\"optionalItem\" ng-disabled=\"optionalItem.disabled\"><span class=\"text-center font-size-14 mt-8\">{{optionalItem.ItemName}}</span></md-radio-button></md-radio-group></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"dialogVm.onCancel()\" translate=\"MANAGE.MANAGEDROPPEDASSETCANCEL\"></md-button><md-button ng-click=\"dialogVm.onSave()\" ng-disabled=\"DroppedAssetEntryForm.$invalid || dialogVm.item.disabled\" class=\"md-accent\" aria-label=\"Save\" translate=\"MANAGE.MANAGEDROPPEDASSETSAVE\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/timeSheet/service/dialog/dialog.html","<md-dialog class=\"main-style resource-dialog\" flex=\"30\" ng-cloak=\"\" block-ui=\"add-project\"><form name=\"holidayForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Timesheet Preferences</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container ng-if=\"vm.adminClaimsService.hasManageTimesheetPayroll\"><label>Award</label><md-select placeholder=\"Award\" ng-disabled=\"vm.line.IsAwardOverrideDisabled || vm.line.IsSalariedEmployee\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-change=\"vm.awardChanged = true\" md-on-open=\"vm.awardChanged = false\" md-on-close=\"vm.onAwardChange()\" ng-model=\"vm.line.Award\"><md-option ng-repeat=\"award in vm.service.awards\" ng-value=\"award\">{{award.Name}}</md-option></md-select><div ng-if=\"vm.line.IsAwardOverrideDisabled || vm.line.IsSalariedEmployee\" class=\"locked-note\">Award cannot be overriden.</div><div ng-if=\"vm.AwardInfoText && vm.isAwardClassificationRecalculated\" class=\"info-note\">{{vm.AwardInfoText}}</div></md-input-container><md-input-container style=\"position:relative;margin-top:17px;\" ng-if=\"vm.adminClaimsService.hasManageTimesheetPayroll\"><label>Classification</label><md-select placeholder=\"Classification\" ng-disabled=\"vm.line.IsClassificationOverrideDisabled || vm.line.IsSalariedEmployee\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"vm.line.AwardClassification\"><md-option ng-repeat=\"classification in vm.service.classifications\" ng-value=\"classification\" ng-disabled=\"classification.isDisabled\">{{classification.Name}}</md-option></md-select><div ng-if=\"vm.line.IsClassificationOverrideDisabled || vm.line.IsSalariedEmployee\" class=\"locked-note\">Classification cannot be overriden.</div><div ng-if=\"vm.ClassificationInfoText && vm.isAwardClassificationRecalculated\" class=\"info-note\">{{vm.ClassificationInfoText}}</div></md-input-container><md-input-container><label>Allowance(s)</label><md-select placeholder=\"Allowance(s)\" ng-disabled=\"vm.line.IsSalariedEmployee\" multiple=\"\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-model=\"vm.line.ShiftRoles\"><md-optgroup label=\"Allowance(s)\"><md-option ng-repeat=\"allowance in vm.service.shiftRoles\" ng-value=\"allowance\" ng-disabled=\"allowance.isDisabled\" ng-show=\"!allowance.isDisabled || true\">{{allowance.Name}}</md-option></md-optgroup></md-select></md-input-container><md-checkbox ng-model=\"vm.line.NoMinimumShift\" ng-disabled=\"vm.line.IsSalariedEmployee\" style=\"position:relative;top:10px;\">No Minimum Shift</md-checkbox><div ng-if=\"vm.isAwardClassificationRecalculated\" class=\"info-note\">{{ \'TIMESHEET.SAVE_UPDATED_SHIFTAWARD_INFO\' | translate}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onRecalculate()\" ng-if=\"vm.adminClaimsService.hasManageTimesheetPayroll\" flex=\"40\">{{ \'TIMESHEET.RECALCULATE_BUTTON\' | translate }}</md-button><md-button ng-disabled=\"vm.line.IsSalariedEmployee\" class=\"md-raised md-accent\" ng-click=\"vm.onSave()\">{{ \'TIMESHEET.TIMESHEET_SAVE\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/timeSheet/service/submitTimesheetDialog/submitTimesheetDialog.html","<md-dialog class=\"main-style timesheet-edit-dialog\" flex=\"30\" ng-cloak=\"\" block-ui=\"add-project\"><md-dialog-content><h1>{{(vm.service.hasSignatures ? \'SUBMITTED_TIMESHEET_EDIT_DIALOG.DIALOG_HEADER\' : \'SUBMITTED_TIMESHEET_EDIT_DIALOG.DIALOG_SUBMIT_TIMESHEET\') | translate }}</h1><h3 class=\"label-control\" ng-if=\"vm.service.isMobileAppEnabled\">{{(vm.service.hasSignatures ? \'SUBMITTED_TIMESHEET_EDIT_DIALOG.DIALOG_LABEL_SIGNATURE_EDIT_MODE\' : \'SUBMITTED_TIMESHEET_EDIT_DIALOG.DIALOG_LABEL_SIGNATURE_NON_EDIT_MODE\') | translate }}</h3><div class=\"parent-collection\" layout=\"column\" layout-gt-md=\"row\"><div class=\"radio-collection\" flex=\"auto\" ng-hide=\"!vm.service.isMobileAppEnabled\"><input type=\"radio\" class=\"form-radio\" ng-model=\"vm.isSignatureRequired\" ng-disabled=\"!vm.service.isMobileAppEnabled\" ng-value=\"true\" ng-checked=\"vm.isSignatureRequired === true && vm.isSignatureRequired !== null\" ng-change=\"vm.onRequireSignatureChange()\"> Yes <input type=\"radio\" class=\"form-radio\" ng-model=\"vm.isSignatureRequired\" ng-value=\"false\" ng-checked=\"!vm.isSignatureRequired && vm.isSignatureRequired !== null\" ng-change=\"vm.onRequireSignatureChange()\"> No</div><div class=\"note-collection\" flex=\"auto\"><h5 ng-hide=\"!vm.isSignatureRequired || vm.isSignatureRequired === null\" class=\"warning-message\">{{(vm.service.hasSignatures ? \'SUBMITTED_TIMESHEET_EDIT_DIALOG.REQUIRES_SIGNATURE_LABEL_EDIT_MODE\' : \'SUBMITTED_TIMESHEET_EDIT_DIALOG.REQUIRES_SIGNATURE_LABEL_NON_EDIT_MODE\') | translate }}</h5><h5 ng-hide=\"vm.isSignatureRequired || vm.isSignatureRequired === null\" class=\"warning-message\">{{(vm.service.hasSignatures ? \'SUBMITTED_TIMESHEET_EDIT_DIALOG.DOES_NOT_REQUIRE_SIGNATURE_LABEL_EDIT_MODE\' : \'\') | translate }}</h5></div></div><div class=\"edit-reason-section\" ng-hide=\"vm.isSignatureRequired === null\" flex=\"100\"><h3 class=\"label-control\" translate=\"SUBMITTED_TIMESHEET_EDIT_DIALOG.DIALOG_LABEL_REASON\" ng-hide=\"!vm.isSignatureRequired && vm.isFirstTimeSubmit\"></h3><textarea ng-hide=\"vm.isSignatureRequired || vm.isFirstTimeSubmit\" class=\"dialog-textarea-no\" ng-model=\"vm.reasonForEditing\" maxlength=\"{{vm.maxLength}}\" ng-change=\"vm.checkValue()\" required=\"\"> </textarea> <textarea ng-hide=\"!vm.isSignatureRequired\" class=\"dialog-textarea-yes\" ng-model=\"vm.reasonForEditing\" maxlength=\"{{vm.maxLength}}\" ng-change=\"vm.checkValue()\" required=\"\"></textarea> <label ng-hide=\"!vm.isSignatureRequired && vm.isFirstTimeSubmit\" class=\"character-count\">{{vm.maxLength - vm.reasonForEditing.length}} characters remaining</label></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"TIMESHEET.TIMESHEET_CLEAR_SIGNATURE_CANCEL\" class=\"flat-button\" ng-click=\"vm.onCancelClick()\"></md-button><md-button translate=\"SUBMITTED_TIMESHEET_EDIT_DIALOG.DIALOG_SUBMIT_TIMESHEET\" class=\"md-raised md-accent\" ng-click=\"vm.onSubmitClick()\" ng-disabled=\"vm.disableSubmit\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/profile/tabs/my-details/my-details.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"content\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate=\"\"><div class=\"image-input-wrapper\"><label class=\"image-input\" for=\"contactPhoto\"><i class=\"icon icon-pencil s40\"></i> <img class=\"profile-image avatar huge\" src=\"assets/images/avatars/profile.jpg\" ng-src=\"{{vm.profileData.ImageUrl}}\"></label> <input type=\"file\" id=\"contactPhoto\" class=\"image-input\" a8-file-upload=\"files\" upload-url=\"vm.uploadUrl\" on-upload-start=\"vm.onUploadStart()\" on-upload-validate=\"vm.onUploadValidate(fileObj)\" on-upload-completed=\"vm.onUploadSuccess(data)\" on-upload-error=\"vm.onUploadError(ex)\"><div ng-if=\"vmPersonal.showProgress\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear><span class=\"md-caption\">Uploading...</span></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.profileData.FirstName\" placeholder=\"First Name\" required=\"\"><div ng-messages=\"basicForm.firstname.$error\" ng-show=\"basicForm.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"middlename\" ng-model=\"vm.profileData.MiddleName\" placeholder=\"Middle Name\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.profileData.LastName\" placeholder=\"Last Name\" required=\"\"><div ng-messages=\"basicForm.lastname.$error\" ng-show=\"basicForm.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"vm.primaryEmail\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"basicForm.email.$error\" ng-show=\"basicForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Email field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div></md-input-container><div ayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" ng-pattern=\"/^(\\d)+$/\" name=\"phone\" ng-model=\"vm.primaryPhone\" placeholder=\"Phone\" required=\"\"><div ng-messages=\"basicForm.email.$error\" ng-show=\"basicForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Phone Number is required</span></div></div></md-input-container><md-input-container flex=\"\"><md-select ng-model=\"vm.phoneType\" placeholder=\"Phone Type\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"type in vm.PhoneTypes\" ng-value=\"type\">{{type.TypeName}}</md-option></md-select></md-input-container></div><md-button type=\"submit\" ng-click=\"vm.updateProfile()\" ng-disabled=\"basicForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"Submit\">Submit</md-button></form></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/my-settings/my-settings.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"content\" layout=\"column\"><div><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"\"><form name=\"updatePasswordForm\" class=\"md-inline-form\" novalidate=\"\"><div class=\"form-title\"></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"oldPassword\" ng-model=\"vm.passwordData.OldPassword\" placeholder=\"Old Password\" ng-required=\"true\"><div ng-messages=\"updatePasswordForm.oldPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span>Old Password is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"password\" ng-model=\"vm.passwordData.NewPassword\" placeholder=\"Password\" required=\"\"><div ng-messages=\"updatePasswordForm.password.$error\" ng-show=\"updatePasswordForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span>New Password is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.passwordData.ConfirmPassword\" compare-to=\"vm.passwordData.NewPassword\" placeholder=\"Password (Confirm)\" ng-required=\"true\"><div ng-messages=\"updatePasswordForm.passwordConfirm.$error\" ng-show=\"updatePasswordForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Password (Confirm) field is required.</span></div><div ng-message=\"compareTo\"><span>Must match the previous entry</span></div></div></md-input-container></div><md-button type=\"submit\" ng-click=\"vm.updatePassword()\" class=\"md-raised md-accent\" aria-label=\"UPDATE\" ng-disabled=\"updatePasswordForm.$invalid || updatePasswordForm.$pristine\" translate=\"UPDATEPASSWORD.UPDATE\" translate-attr-aria-label=\"UPDATEPASSWORD.UPDATE\" ng-class=\"vm.isProcessing\">Submit</md-button></form></div></div></div></div>");
$templateCache.put("app/main/paperworkExceptions/directives/mainView/gridContainer/grid-container.html","<div layout-margin=\"\" layout-padding=\"\" ms-scroll=\"\" md-scroll=\"\"><paper-work-dynamic-grid is-busy=\"vm.isBusy\" ng-if=\"data.DataRows.length > 0\" item=\"data\" refresh=\"vm.refresh()\" loader-message=\"vm.loaderMessage\" handlecheck=\"vm.handle(params)\" ng-repeat=\"data in vm.gridData\"></paper-work-dynamic-grid></div>");
$templateCache.put("app/main/paperworkExceptions/directives/mainView/searchBox/searchBox.html","<div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.srcData\" type=\"text\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"{{ \'PAPERWORK_EXCEPTION.SEARCH\' | translate}}\"></div>");
$templateCache.put("app/main/projects/services/dialogs/addProject/add-project.html","<md-dialog id=\"contact-create-email\" flex=\"30\" ng-cloak=\"\" block-ui=\"add-project\"><form name=\"projectForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Project</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"text\" name=\"project\" ng-model=\"vm.name\" placeholder=\"Project Name\" required=\"\"><div ng-messages=\"projectForm.project.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Project name is required.</span></div></div></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Branches</label><md-select ng-model=\"vm.branches\" multiple=\"\" ng-change=\"vm.branchHasChanged()\" md-selected-text=\"vm.utilService.getSelectedText(vm.branches, \'Branch(es)\', \'Name\')\" required=\"\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchLookUp\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Award</label><md-select ng-model=\"vm.Award\" placeholder=\"Award\"><md-option></md-option><md-option ng-value=\"award\" ng-repeat=\"award in vm.awards\">{{award.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Rate Card</label><md-select ng-model=\"vm.RateCard\" placeholder=\"Rate Card\" required=\"\"><md-option ng-value=\"rateCard\" ng-repeat=\"rateCard in vm.rateCardsList\">{{rateCard.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"vm.skills.length > 0\" class=\"md-block\"><label>Skills</label><md-select ng-model=\"vm.chosenSkills\" multiple=\"true\" placeholder=\"Skills\"><md-option ng-value=\"skill\" ng-repeat=\"skill in vm.skills\">{{skill.Name}}</md-option></md-select></md-input-container><md-contact-chips ng-model=\"vm.Clients\" md-contacts=\"vm.querySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" placeholder=\"Clients\" filter-selected=\"true\"></md-contact-chips></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onSave()\" ng-disabled=\"projectForm.$invalid\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/projects/services/dialogs/editProject/edit-project.html","<md-dialog id=\"contact-create-email\" class=\"main-style\" flex=\"30\" ng-cloak=\"\" block-ui=\"edit-project\"><form name=\"projectForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Edit Project</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"text\" name=\"project\" ng-model=\"vm.project.Name\" placeholder=\"Project Name\" required=\"\"><div ng-messages=\"projectForm.project.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Project name is required.</span></div></div></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Branches</label><md-select ng-model=\"vm.branches\" ng-change=\"vm.branchHasChanged()\" multiple=\"\" placeholder=\"Branches\" md-selected-text=\"vm.utilService.getSelectedText(vm.branches, \'Branch(es)\', \'Name\')\" required=\"\"><md-optgroup label=\"Branches\"><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branchLookUp\" ng-selected=\"branch.Selected\">{{branch.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Award</label><md-select ng-model=\"vm.Award\" placeholder=\"Award\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option></md-option><md-option ng-value=\"award\" ng-repeat=\"award in vm.awardsLookUp\">{{award.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Rate Card</label><md-select ng-model=\"vm.RateCard\" placeholder=\"Rate Card\" ng-model-options=\"{trackBy: \'$value.Id\'}\" required=\"\"><md-option ng-value=\"rateCard\" ng-repeat=\"rateCard in vm.rateCardsList\">{{rateCard.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-if=\"vm.skills.length > 0\" class=\"md-block\"><label>Skills</label><md-select ng-model=\"vm.chosenSkills\" multiple=\"true\" md-selected-text=\"vm.utilService.getSelectedText(vm.chosenSkills, \'Skills\', \'Name\')\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"Skills\"><md-option ng-value=\"skill\" ng-repeat=\"skill in vm.skills\">{{skill.Name}}</md-option></md-select></md-input-container><md-contact-chips ng-model=\"vm.Clients\" md-contacts=\"vm.querySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" placeholder=\"Clients\" filter-selected=\"true\"></md-contact-chips></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onSave()\" ng-disabled=\"projectForm.$invalid\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/reporting/view/report/skillStatus/skill-status-report.html","<div id=\"branch-view\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div class=\"content\" flex=\"\" id=\"skill-status-report\"><div class=\"white-bg md-whiteframe-4dp\" style=\"padding : 10px;\"><div layout=\"row\" class=\"skill-status-toolbar\"><div layout=\"column\" class=\"col-2\"><md-radio-group ng-model=\"vm.viewOption\" layout=\"column\" flex=\"\"><md-radio-button value=\"0\">{{ \'REPORT.GROUP_SKILLS\' | translate }}</md-radio-button><md-radio-button value=\"1\">{{ \'REPORT.INDIVIDUAL_SKILL\' | translate }}</md-radio-button></md-radio-group></div><div layout=\"column\" class=\"col-3\"><label class=\"bold-text\" translate=\"REPORT.BRANCHES\"></label><md-select ng-model=\"vm.searchCriteria.Branches\" class=\"branch-dropdown\" id=\"dashboardBranch\" placeholder=\"{{\'REPORT.BRANCHES\' | translate}}\" md-selected-text=\"vm.getSelectedText(vm.searchCriteria.Branches, vm.utilService.translate(\'REPORT.BRANCHES\'), \'Name\')\" multiple=\"\"><md-optgroup label=\"{{\'REPORT.BRANCHES\' | translate}}\"><md-option ng-value=\"branch.Id\" ng-repeat=\"branch in vm.lookups.branches| filter: {\'State\': \'\'}| orderBy:[\'Name\'] as _branches track by $index + \'-\' + branch.Id\">{{branch.Name}}</md-option></md-optgroup></md-select></div><div layout=\"column\" class=\"offset-6 col-1\"><md-button ng-click=\"vm.generate()\" ng-disabled=\"!vm.service.reportIsGenerated || vm.regeneratingView\" class=\"md-accent md-raised generate-button\" translate=\"REPORT.GENERATE\"></md-button></div></div><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><div class=\"md-block search-box\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input type=\"text\" placeholder=\"{{\'REPORT.VIEW_ITEM_SEARCH\' | translate}}\" ng-model=\"vm.service.query\" ng-keyup=\"vm.searchTable()\"></div></div></div><div layout=\"column\" layout-align=\"start start\" class=\"progress-bar\" ng-if=\"!vm.service.reportIsGenerated || vm.regeneratingView\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div><br><table id=\"skillStatusReportTable\" class=\"dataTable row-border hover\" ng-class=\"{\'ng-hide\' : !vm.service.reportIsGenerated || vm.regeneratingView}\" ms-responsive-table=\"\" dt-instance=\"vm.dtInstance\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumns\" ng-if=\"!vm.isGroupView\"><thead><tr><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.EMPLOYEE\"></span></div></th><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.BRANCHES\"></span></div></th><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.SKILLGROUP\"></span></div></th><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.SKILLS\"></span></div></th><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.SKILL_STATUS\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.gridModel\"><td>{{ item.employee }}</td><td>{{ item.branches }}</td><td>{{ item.skillGroup}}</td><td>{{ item.skill }}</td><td ng-class=\"item.skillBgColor\"><span class=\"ng-hide\">{{ item.skillStatusSortValue }}</span><div class=\"custom-tooltip\"><span class=\"custom-tooltiptext-right-hand-side bold-text\" translate=\"{{item.skillStatusTooltip}}\"></span> {{ item.skillStatus }}</div></td></tr></tbody></table><table id=\"skillStatusReportGroupViewTable\" class=\"dataTable row-border group-view-skill-table\" ms-responsive-table=\"ng\" dt-instance=\"vm.dtInstanceGroup\" datatable=\"\" dt-options=\"vm.dtOptionsGroup\" dt-column-defs=\"vm.dtColumnsGroup\" ng-if=\"vm.isGroupView\"><thead><tr><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.EMPLOYEE\"></span></div></th><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.BRANCHES\"></span></div></th><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.SKILLGROUP\"></span></div></th><th><div class=\"table-header\"><span class=\"column-title text-bold mb-5\" translate=\"REPORT.SKILL_STATUS_REPORT.SKILLS\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.gridModelGroup\"><td width=\"15%\">{{ item.employee }}</td><td width=\"32%\">{{ item.branches }}</td><td width=\"15%\">{{ item.skillGroup}}</td><td width=\"38%\" class=\"group-view-skill-table-column\"><span layout=\"row\" class=\"group-view-skill-row\" ng-repeat=\"skills in item.skillList track by $index\"><span layout=\"column col-9\" class=\"skill-name bold-text\" ng-class=\"skills.skillBgColor\">{{ skills.skill }}</span> <span layout=\"column col-3\" class=\"expiry-date custom-tooltip bold-text\" ng-class=\"vm.getGroupSkillsCss(skills.skillBgColor, $first, $last)\">{{ skills.skillStatus }} <span class=\"custom-tooltiptext-column-right\" translate=\"{{skills.skillStatusTooltip}}\"></span></span></span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/branch/create/template/Divisions/add/branch-division.html","<md-dialog id=\"contact-create-email\" flex=\"30\" ng-cloak=\"\" block-ui=\"add-division\"><form name=\"divisionForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"BRANCH_CREATE.ADD_DIV\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vmDivision.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"BRANCH_CREATE.DIV_NAME\"></label> <input type=\"text\" name=\"division\" ng-model=\"vmDivision.Name\" required=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"BRANCH_CREATE.SAVE\" class=\"md-raised md-accent\" ng-click=\"vmDivision.onSave()\" ng-disabled=\"divisionForm.$invalid\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/branch/create/template/Divisions/edit/branch-division-edit.html","<md-dialog id=\"contact-create-email\" flex=\"30\" ng-cloak=\"\" block-ui=\"edit-division\"><form name=\"divisionForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"BRANCH_CREATE.UPDATE_DIV\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vmDivision.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><label translate=\"BRANCH_CREATE.DIV_NAME\"></label> <input type=\"text\" name=\"division\" ng-model=\"vmDivision.Name\" required=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button translate=\"BRANCH_CREATE.SAVE\" class=\"md-raised md-accent\" ng-click=\"vmDivision.onSave()\" ng-disabled=\"divisionForm.$invalid\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/awards/manage/awards/components/awards/awards-component.html","<div class=\"md-title mt-0\">Awards</div><div class=\"pb-16\">Manage Awards.</div><div class=\"white-bg md-whiteframe-4dp\" block-ui=\"award-section\"><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.service.query1\" ng-keyup=\"vm.searchTable(1)\"></md-input-container></div></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"vm.dtInstance1\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"award in vm.service.awards\"><td width=\"70%\">{{award.Name}}</td><td width=\"30%\"><md-button class=\"md-icon-button\" ng-click=\"vm.service.editAward(award)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>Edit Award</span></md-tooltip></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/awards/manage/awards/components/shiftRoles/shifts-component.html","<div class=\"md-title mt-0\">Shift Allowances</div><div class=\"pb-16\">Manage Shift Allowances.</div><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.service.query3\" ng-keyup=\"vm.searchTable(3)\"></md-input-container></div></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"vm.dtInstance3\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"shiftAllowance in vm.service.shiftRoles\"><td width=\"70%\">{{shiftAllowance.Name}}</td><td width=\"30%\"><md-button class=\"md-icon-button\" ng-click=\"vm.service.editShiftRole(shiftAllowance)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>Edit Shift Allowance</span></md-tooltip></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/awards/manage/awards/components/classifications/classifications-component.html","<div class=\"md-title mt-0\">Classifications</div><div class=\"pb-16\">Manage Classifications.</div><div class=\"white-bg md-whiteframe-4dp\"><div flex=\"100\" style=\"margin-left : 10px; margin-right : 10px; margin-top :10px; margin-bottom : 10px;\" layout-align=\"center center\" layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"Search\" ng-model=\"vm.service.query2\" ng-keyup=\"vm.searchTable(2)\"></md-input-container></div></div><table class=\"dataTable row-border hover\" style=\"margin-top : 10px;\" dt-instance=\"vm.dtInstance2\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr style=\"background-color: #f2f2f2;\"><th class=\"secondary-text\" style=\"width: 20%\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\" style=\"width: 50%\"><div class=\"table-header\"><span class=\"column-title\">Branches</span></div></th><th class=\"secondary-text\" style=\"width: 20%\"><div class=\"table-header\"><span class=\"column-title\">Award Classification</span></div></th><th class=\"secondary-text\" style=\"width: 10%\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"classification in vm.service.classifications\"><td style=\"width: 20%\">{{classification.Name}}</td><td style=\"width: 50%\">{{vm._.map(classification.Branches, \"Name\").join(\', \')}}</td><td style=\"width: 0%\">{{classification.ClassificationId}}</td><td style=\"width: 10%\"><md-button class=\"md-icon-button\" ng-click=\"vm.service.editClassification(classification)\"><md-icon class=\"teal-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span>Edit Classification</span></md-tooltip></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/utils/actionSection/actionSection.html","<div layout=\"column\" ng-if=\"!vm.service.something_has_been_selected\" layout-align=\"center center\" flex=\"\" layout-padding=\"\"><div style=\"height : 100px; background-color: #475A64;\" layout=\"column\" class=\"md-whiteframe-3dp\" layout-padding=\"\"><div flex=\"\"><i ng-if=\"!vm.global_service.saving\" ng-click=\"vm.global_service.prepareForUpdate(vm.id)\" style=\"color : white; cursor : pointer\" class=\"icon icon-pocket\"><md-tooltip>Update</md-tooltip></i></div><div flex=\"\"><i ng-if=\"!vm.global_service.saving\" ng-click=\"vm.remove()\" style=\"color : white; cursor : pointer\" class=\"icon icon-trash s25\"><md-tooltip>Remove</md-tooltip></i></div></div></div>");
$templateCache.put("app/main/contact/calendar/calendar-entry/manage/settings/calendar-entry-settings.component.html","<div class=\"calendar-entry-settings-view\" layout=\"column\" flex=\"\"><div class=\"settings-header-bar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.isSaving\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><h2 class=\"margin-0\">Manage Calendar Entries</h2></div><div class=\"settings-content\" flex=\"\"><div class=\"settings-header\"><h3>Calendar Entry Type Settings</h3><p class=\"description\">Configure which entry types require approval</p></div><div ng-if=\"vm.isLoading\" layout=\"row\" layout-align=\"center center\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"entry-type-section\" ng-if=\"!vm.isLoading\"><h4 class=\"section-title\">Unavailable</h4><p class=\"section-subtitle\">Reasons:</p><div class=\"entry-type-list\"><div class=\"entry-type-row\" ng-repeat=\"entryType in vm.entryTypes\"><span class=\"entry-type-name\">{{entryType.Name}}</span><div class=\"entry-type-controls\"><span class=\"approval-badge\" ng-class=\"{\'auto-approved\': !entryType.IsRequiredApproval, \'requires-approval\': entryType.IsRequiredApproval}\"><md-icon md-font-icon=\"icon-check-circle\" ng-if=\"!entryType.IsRequiredApproval\"></md-icon><md-icon md-font-icon=\"icon-check-circle\" ng-if=\"entryType.IsRequiredApproval\"></md-icon>{{entryType.IsRequiredApproval ? \'Requires Approval\' : \'Auto-Approved\'}}</span><md-switch ng-model=\"entryType.IsRequiredApproval\" aria-label=\"Toggle approval requirement for {{entryType.name}}\" class=\"md-primary\" ng-disabled=\"vm.isSaving\"></md-switch></div></div></div></div><div class=\"settings-note\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon><span>Changes apply to new submissions only</span></div></div><div class=\"settings-actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.isSaving\">Cancel</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.isLoading || vm.isSaving\"><span ng-if=\"!vm.isSaving\">Save Changes</span> <span ng-if=\"vm.isSaving\">Saving...</span></md-button></div></div>");
$templateCache.put("app/main/contact/calendar/calendar-entry/manage/settings/calendar-entry-settings.html","<md-card class=\"calendar-entry-settings-card\"><md-card-header><md-card-header-text><span class=\"md-title\">Manage Calendar Entries</span></md-card-header-text><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.isSaving\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-card-header><md-card-content><div class=\"settings-header\"><h3>Calendar Entry Type Settings</h3><p class=\"description\">Configure which entry types require approval</p></div><div ng-if=\"vm.isLoading\" layout=\"row\" layout-align=\"center center\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"entry-type-section\" ng-if=\"!vm.isLoading\"><h4 class=\"section-title\">Unavailable</h4><p class=\"section-subtitle\">Reasons:</p><div class=\"entry-type-list\"><div class=\"entry-type-row\" ng-repeat=\"entryType in vm.entryTypes\"><span class=\"entry-type-name\">{{entryType.name}}</span><div class=\"entry-type-controls\"><span class=\"approval-badge\" ng-class=\"{\'auto-approved\': !entryType.requiresApproval, \'requires-approval\': entryType.requiresApproval}\"><md-icon md-font-icon=\"icon-check-circle\" ng-if=\"!entryType.requiresApproval\"></md-icon><md-icon md-font-icon=\"icon-check-circle\" ng-if=\"entryType.requiresApproval\"></md-icon>{{entryType.requiresApproval ? \'Requires Approval\' : \'Auto-Approved\'}}</span><md-switch ng-model=\"entryType.requiresApproval\" aria-label=\"Toggle approval requirement for {{entryType.name}}\" class=\"md-primary\" ng-disabled=\"vm.isSaving\"></md-switch></div></div></div></div><div class=\"settings-note\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon><span>Changes apply to new submissions only</span></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.isSaving\">Cancel</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.isLoading || vm.isSaving\"><span ng-if=\"!vm.isSaving\">Save Changes</span> <span ng-if=\"vm.isSaving\">Saving...</span></md-button></md-card-actions></md-card>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/checkBox/checkBoxDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div style=\"margin-top : 20px;\" ng-if=\"!vm.edit\" layout=\"column\"><md-checkbox ng-if=\"option.Type === \'Regular\'\" ng-model=\"option.Name\" ng-repeat=\"option in vm.options\">{{option.Value}}</md-checkbox><md-checkbox ng-if=\"option.Type === \'Other\'\" ng-model=\"option.Name\" ng-repeat=\"option in vm.options\">Other</md-checkbox></div><div flex=\"\" style=\"margin-top : 20px;\" layout=\"column\"><md-list ng-if=\"vm.edit\" flex=\"\"><md-list-item layout=\"row\" flex=\"70\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" layout-align=\"space-between center\" ng-repeat=\"option in vm.options\"><div flex=\"5\"><md-checkbox ng-disabled=\"true\" ng-model=\"vm.model\"></md-checkbox></div><span flex=\"\"></span><div flex=\"80\" ng-if=\"option.Type === \'Regular\'\"><md-input-container class=\"md-block\"><input ng-disabled=\"vm.service.saving\" class=\"md-body-2\" style=\"margin-top : -25px;\" ng-model=\"option.Value\" type=\"text\"></md-input-container></div><div flex=\"80\" ng-if=\"option.Type === \'Other\'\"><span class=\"md-body-2\" style=\"left : 4px; position : relative; top : -5px;\"><span ng-class=\"{\'grey-400-fg\' : vm.service.saving}\">Other</span></span></div><span flex=\"\"></span><div layout=\"row\" layout-align=\"end center\" flex=\"5\"><i ng-if=\"!vm.service.saving && vm.field.Option.length > 1\" ng-click=\"vm.removeItem($index)\" style=\"cursor : pointer; margin-top : -15px;\" class=\"icon icon-close s25 red-500-fg\"><md-tooltip>Remove</md-tooltip></i></div></md-list-item><md-list-item ng-if=\"!vm.service.saving\" layout=\"row\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" flex=\"70\" layout-align=\"space-between center\"><div flex=\"5\"><md-checkbox ng-disabled=\"true\" ng-model=\"vm.model\"></md-checkbox></div><span flex=\"\"></span><div style=\"margin-top : -10px;\" class=\"md-body-2\" flex=\"90\"><span><a style=\"cursor : pointer;\" ng-click=\"vm.addOption()\">ADD OPTION</a> <span ng-if=\"!vm.options_has_other\">or <a style=\"cursor : pointer;\" ng-click=\"vm.addOther()\">OTHER</a></span></span></div></md-list-item></md-list></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/checkBoxWithEntry/checkBoxWithEntry.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div style=\"margin-left : -15px; margin-top : 30px;\" ng-if=\"!vm.edit\" layout=\"column\"><md-list flex=\"\"><md-list-item style=\"margin-top : -15px;\" layout=\"row\" flex=\"70\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" layout-align=\"space-between center\" ng-repeat=\"option in vm.options\"><div flex=\"5\"><md-checkbox ng-model=\"option.Id\"></md-checkbox></div><span flex=\"\"></span><div flex=\"40\" ng-if=\"option.Type === \'Regular\'\"><md-input-container class=\"md-block\"><input ng-disabled=\"true\" style=\"margin-top : -25px;\" ng-model=\"option.Value\" type=\"text\"></md-input-container></div><span flex=\"\"></span><div flex=\"40\" ng-if=\"option.Type === \'Regular\'\"><md-input-container class=\"md-block\"><input ng-disabled=\"true\" ng-model=\"vm.other\" style=\"margin-top : -25px;\" type=\"text\"></md-input-container></div><span flex=\"\"></span></md-list-item></md-list></div><div flex=\"\" style=\"margin-top : 20px;\" layout=\"column\"><span style=\"margin-left : 17px; margin-bottom : 20px;\" ng-if=\"vm.edit\" class=\"md-body-2 blue-700-fg\">(Minimum of 2 Options)</span><md-list ng-if=\"vm.edit\" flex=\"\"><md-list-item layout=\"row\" flex=\"70\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" layout-align=\"space-between center\" ng-repeat=\"option in vm.options\"><div flex=\"5\"><md-checkbox ng-disabled=\"true\" ng-model=\"vm.model\"></md-checkbox></div><span flex=\"\"></span><div flex=\"80\" ng-if=\"option.Type === \'Regular\'\"><md-input-container class=\"md-block\"><input ng-disabled=\"vm.service.saving\" class=\"md-body-2\" style=\"margin-top : -25px;\" ng-model=\"option.Value\" type=\"text\"></md-input-container></div><div flex=\"80\" ng-if=\"option.Type === \'Other\'\"><span class=\"md-body-2\" style=\"left : 4px; position : relative; top : -5px;\"><span ng-class=\"{\'grey-400-fg\' : vm.service.saving}\">Other</span></span></div><span flex=\"\"></span><div layout=\"row\" layout-align=\"end center\" flex=\"5\"><i ng-if=\"!vm.service.saving && vm.field.Option.length > 1\" ng-click=\"vm.removeItem($index)\" style=\"cursor : pointer; margin-top : -15px;\" class=\"icon icon-close s25 red-500-fg\"><md-tooltip>Remove</md-tooltip></i></div></md-list-item><md-list-item ng-if=\"!vm.service.saving\" layout=\"row\" flex=\"70\" layout-align=\"space-between center\"><div flex=\"5\"><md-checkbox ng-disabled=\"true\" ng-model=\"vm.model\"></md-checkbox></div><span flex=\"\"></span><div style=\"margin-top : -10px;\" class=\"md-body-2\" flex=\"90\"><span><a style=\"cursor : pointer;\" ng-click=\"vm.addOption()\">ADD OPTION</a></span></div></md-list-item></md-list></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/decimal/decimalDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div flex=\"50\" layout=\"row\"><md-input-container class=\"md-icon-float md-block\"><md-icon style=\"font-size : 10px;\" md-svg-icon=\"decimal-increase\" class=\"s10 light-blue-700-fg\"></md-icon><input type=\"text\" placeholder=\"Decimal Value\" ng-disabled=\"true\"></md-input-container></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/dropDown/dropDownDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><md-select ng-if=\"!vm.edit\" ng-model=\"vm.model\"><md-option ng-value=\"option\" ng-repeat=\"option in vm.options\">{{option.Value}}</md-option></md-select><div flex=\"\" style=\"margin-top : 20px;\" layout=\"column\"><span style=\"margin-left : 17px; margin-bottom : 20px;\" ng-if=\"vm.edit\" class=\"md-body-2 blue-700-fg\">(Minimum of 2 Options)</span><md-list ng-if=\"vm.edit\" flex=\"\"><md-list-item layout=\"row\" flex=\"70\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" layout-align=\"space-between center\" ng-repeat=\"option in vm.options\"><div style=\"margin-top : -15px;\" flex=\"5\"><i class=\"icon icon-code-greater-than s25 blue-700-fg\"></i></div><span flex=\"\"></span><div flex=\"80\" ng-if=\"option.Type === \'Regular\'\"><md-input-container class=\"md-block\"><input ng-disabled=\"vm.service.saving\" class=\"md-body-2\" style=\"margin-top : -25px;\" ng-model=\"option.Value\" type=\"text\"></md-input-container></div><div flex=\"80\" ng-if=\"option.Type === \'Other\'\"><span class=\"md-body-2\" style=\"left : 4px; position : relative; top : -5px;\"><span ng-class=\"{\'grey-400-fg\' : vm.service.saving}\">Other</span></span></div><span flex=\"\"></span><div layout=\"row\" layout-align=\"end center\" flex=\"5\"><i ng-if=\"!vm.service.saving\" ng-click=\"vm.removeItem($index)\" style=\"cursor : pointer; margin-top : -15px;\" class=\"icon icon-close s25 red-500-fg\"><md-tooltip>Remove</md-tooltip></i></div></md-list-item><md-list-item ng-if=\"!vm.service.saving\" layout=\"row\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" flex=\"70\" layout-align=\"space-between center\"><div style=\"margin-top : -15px;\" flex=\"5\"><i class=\"icon icon-code-greater-than s25 blue-700-fg\"></i></div><span flex=\"\"></span><div style=\"margin-top : -10px;\" class=\"md-body-2\" flex=\"90\"><span><a style=\"cursor : pointer;\" ng-click=\"vm.addOption()\">ADD OPTION</a></span></div></md-list-item></md-list></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/email/email.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div flex=\"50\"><md-input-container class=\"md-block\"><md-icon style=\"font-size : 10px;\" md-svg-icon=\"email\" class=\"s10 light-blue-700-fg\"></md-icon><input type=\"text\" placeholder=\"Email Address\" ng-disabled=\"true\"></md-input-container></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/multipleChoice/multipleChoiceDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><md-radio-group ng-if=\"!vm.edit\" style=\"margin-top : 20px;\" ng-model=\"vm.model\"><md-radio-button ng-if=\"option.Type === \'Regular\'\" ng-value=\"option\" ng-repeat=\"option in vm.options\" class=\"md-primary\">{{option.Value}}</md-radio-button><md-radio-button ng-if=\"option.Type === \'Other\'\" ng-value=\"option\" ng-repeat=\"option in vm.options\" class=\"md-primary\">Other</md-radio-button></md-radio-group><div flex=\"\" style=\"margin-top : 20px;\" layout=\"column\"><span style=\"margin-left : 17px; margin-bottom : 20px;\" ng-if=\"vm.edit\" class=\"md-body-2 blue-700-fg\">(Minimum of 2 Options)</span><md-list ng-if=\"vm.edit\" flex=\"\"><md-list-item layout=\"row\" flex=\"70\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" layout-align=\"space-between center\" ng-repeat=\"option in vm.options\"><div flex=\"5\"><md-radio-group ng-disabled=\"true\" ng-model=\"vm.model\"><md-radio-button></md-radio-button></md-radio-group></div><span flex=\"\"></span><div flex=\"80\" ng-if=\"option.Type === \'Regular\'\"><md-input-container class=\"md-block\"><input ng-disabled=\"vm.service.saving\" class=\"md-body-2\" style=\"margin-top : -25px;\" ng-model=\"option.Value\" type=\"text\"></md-input-container></div><div flex=\"80\" ng-if=\"option.Type === \'Other\'\"><span class=\"md-body-2\" style=\"left : 4px; position : relative; top : -5px;\"><span ng-class=\"{\'grey-400-fg\' : vm.service.saving}\">Other</span></span></div><span flex=\"\"></span><div layout=\"row\" layout-align=\"end center\" flex=\"5\"><i ng-if=\"!vm.service.saving\" ng-click=\"vm.removeItem($index)\" style=\"cursor : pointer; margin-top : -15px;\" class=\"icon icon-close s25 red-500-fg\"><md-tooltip>Remove</md-tooltip></i></div></md-list-item><md-list-item ng-if=\"!vm.service.saving\" layout=\"row\" flex-xs=\"100\" flex-md=\"100\" flex-sm=\"100\" flex=\"70\" layout-align=\"space-between center\"><div flex=\"5\"><md-radio-group ng-disabled=\"true\" ng-model=\"vm.model\"><md-radio-button></md-radio-button></md-radio-group></div><span flex=\"\"></span><div style=\"margin-top : -10px;\" class=\"md-body-2\" flex=\"90\"><span><a style=\"cursor : pointer;\" ng-click=\"vm.addOption()\">ADD OPTION</a> <span ng-if=\"!vm.options_has_other\">or <a style=\"cursor : pointer;\" ng-click=\"vm.addOther()\">OTHER</a></span></span></div></md-list-item></md-list></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/paragraph/paragraphDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div flex=\"50\"><md-input-container class=\"md-block\"><md-icon style=\"font-size : 10px;\" md-svg-icon=\"menu\" class=\"mdi-18px light-blue-700-fg\"></md-icon><input type=\"text\" placeholder=\"Paragraph\" ng-disabled=\"true\"></md-input-container></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/shortText/shortTextDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span flex=\"\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"Short Answer Text\" ng-disabled=\"true\"></md-input-container></div></span></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/time/timeDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div flex=\"50\"><md-input-container class=\"md-block\"><md-icon style=\"font-size : 10px;\" md-svg-icon=\"time\" class=\"s10 light-blue-700-fg\"></md-icon><input type=\"text\" placeholder=\"Time\" ng-disabled=\"true\"></md-input-container></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/url/urlDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div flex=\"50\"><md-input-container class=\"md-block\"><md-icon style=\"font-size : 10px;\" md-svg-icon=\"web\" class=\"s10 light-blue-700-fg\"></md-icon><input type=\"text\" placeholder=\"URL\" ng-disabled=\"true\"></md-input-container></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/display/wholeNumber/wholeNumberDisplay.html","<div layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"90\"><span class=\"md-subhead\" ng-if=\"!vm.edit\">{{vm.field.FieldTitle}}</span><div ng-if=\"!vm.edit\" style=\"margin-top : 10px;\"><span ng-if=\"vm.field.Description != null\">({{vm.field.Description}}) -</span> <span class=\"grey-600-fg\">({{vm.field.FieldTypeName.Name}})</span></div><div ng-if=\"!vm.edit && vm.field.Lookups.length > 0\" class=\"light-blue-700-fg\" style=\"margin-top : 10px;\">({{vm.field.Lookups.join(\", \")}})</div><div flex=\"50\"><md-input-container class=\"md-block\"><md-icon style=\"font-size : 10px;\" md-svg-icon=\"numeric-1-box-multiple-outline\" class=\"s10 light-blue-700-fg\"></md-icon><input type=\"text\" placeholder=\"Whole Number\" ng-disabled=\"true\"></md-input-container></div></div><div ng-if=\"!vm.edit\" flex=\"auto\" style=\"width : 100px;\" layout=\"row\" layout-align=\"end center\"><action-section id=\"vm.field.id\"></action-section></div></div>");
$templateCache.put("app/main/contact/create/work/skills/add/contact-skill.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" class=\"main-style\" flex=\"25\" flex-md=\"50\" flex-sm=\"50\" ng-cloak=\"\" block-ui=\"contact-skill\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"CONTACTSMODULE.CONTACT_SKILL\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\"></md-icon></md-button></div></md-toolbar><form name=\"contactskill\"><md-dialog-content><div layout=\"column\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.errorMessage\" flex=\"\"><div style=\"background-color : #e74c3c; padding: 10px; color : white;\" class=\"md-caption\" flex=\"\">{{\'CONTACTSMODULE.SKILL_EXISTS\' | translate}}</div></div><br ng-if=\"vm.errorMessage\"><md-input-container flex=\"\"><label translate=\"CONTACTSMODULE.SKILLS_SKILL\"></label><md-select ng-model=\"vm.skill\" md-on-close=\"vm.changeSkill(vm.skill)\" ng-model-options=\"{trackBy : \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"skill in vm.skills | orderBy :\'SkillName\'\" ng-value=\"skill\">{{skill.SkillName}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.skill.Children.length > 0\" flex=\"\"><label translate=\"CONTACTSMODULE.SKILLS_SKILL_TYPE\"></label><md-select ng-model=\"vm.skilltype\" ng-change=\"vm.checkChildIfHasExpiry(vm.skilltype)\" ng-model-options=\"{trackBy : \'$value.Id\'}\" md-selected-text=\"vm.utilService.getSelectedText(vm.skilltype, vm.utilService.translate(\'CONTACTSMODULE.SKILLS_SKILL_TYPE\'), \'SkillName\')\" multiple=\"true\" required=\"\"><md-option ng-repeat=\"skill in vm.skill.Children\" ng-value=\"skill\">{{skill.SkillName}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" ng-model=\"vm.Description\" placeholder=\"{{\'CONTACTSMODULE.SKILLS_DESCRIPTION\' | translate}}\" name=\"description\"></md-input-container></div><md-chips ng-model=\"vm.companies2\" md-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-selected-item-change=\"vm.selectedItemChange(vm.selectedItem)\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.Name\" placeholder=\"{{\'CONTACTSMODULE.COMPANY_HEADER\' | translate}}\"><span md-highlight-text=\"vm.searchText\">{{item.Name}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.Name}}</strong></span></md-chip-template></md-chips><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" ng-model=\"vm.ReferenceNumber\" placeholder=\"Reference\"></md-input-container></div><div layout=\"row\" flex=\"\" ng-if=\"vm.showExpiry\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"CONTACTSMODULE.SKILLS_EXPIRY_DATE\"></label><md-datepicker ng-model=\"vm.ExpiryDate\" md-open-on-focus=\"\" md-min-date=\"vm.minDate\" class=\"md-block\" ng-required=\"true\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container></div><div layout=\"row\" ng-show=\"vm.uploadAdded || vm.UploadFileName != null\"><md-card flex=\"100\"><md-card-content><div layout=\"row\"><div flex=\"10\"><md-button class=\"md-icon-button md-primary\" style=\"color : red\"><md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button></div><div flex=\"60\"><span translate=\"CONTACTSMODULE.SKILLS_UPLOADED_FILE\" style=\"position : relative; top : 10px;\"></span></div><div flex=\"\"><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.skillsMatrixService.preview(vm.UploadFileName)\" style=\"color : red\"><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button></div><div flex=\"\"><div flex=\"\"><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.downloadFile(vm.UploadFileName)\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon></md-button></div></div><div flex=\"\"><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.removeUpload()\" style=\"color : red\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-card-content><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.showProgress\"></md-progress-linear></md-card></div></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\"><md-button translate=\"CONTACTSMODULE.SAVE\" ng-disabled=\"contactskill.$invalid\" class=\"md-raised md-accent\" ng-click=\"vm.addSkill(1)\"></md-button><aps-upload-file></aps-upload-file></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contact/create/work/allowances/dialog/contact-allowance-dialog.html","<md-dialog id=\"contact-skills-dialog\" class=\"main-style\" aria-label=\"{{vm.caption}}\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\" translate-attr-aria-label=\"CONTACTSMODULE.ALLOWANCE.DIALOG.CLOSE_DIALOG\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"contactAllowanceForm\" novalidate=\"\"><div layout=\"column\"><md-input-container flex=\"\"><label translate=\"CONTACTSMODULE.ALLOWANCE.DIALOG.ALLOWANCE\"></label><md-select ng-model=\"vm.payrollAllowance\" name=\"Allowance\" ng-model-options=\"{trackBy : \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"allowance in vm.allowancesLookup\" ng-value=\"allowance\">{{allowance.Name}}</md-option></md-select></md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\"><md-button translate=\"CONTACTSMODULE.ALLOWANCE.DIALOG.SAVE\" ng-click=\"vm.onSave()\" ng-disabled=\"contactAllowanceForm.$invalid\" class=\"md-raised md-accent\"></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/contact/create/work/skills/view/contact-skills.html","<table class=\"simple kit-item-table\" ms-responsive-table=\"\"><tbody><tr ng-repeat=\"skill in vm.skills | orderBy:\'SkillName\'\"><td width=\"80%\">{{skill.SkillName}}<div class=\"margin-bottom-5\"><div ng-if=\"skill.Description\" class=\"md-body-2 text-italic\">Description: {{skill.Description}}</div><div ng-if=\"skill.ClientCompany\" class=\"md-body-2 text-italic\">Client: {{skill.ClientCompany.Name}}</div></div><div><highlight-box is-reference=\"true\" ng-if=\"skill.ReferenceNumber\" classes=\"md-light-blue-800-bg margin-right-5\" content=\"Ref: {{skill.ReferenceNumber}}\"></highlight-box><span ng-if=\"skill.ExpiryDate\" class=\"margin-right-5\" ng-class=\"{true: \'highlight-box-red\', false: \'highlight-box\'}[vm.isExpiringSoon(skill.ExpiryDate)]\">Expiry: {{skill.ExpiryDate | date}}</span><file-viewer ng-if=\"skill.UploadFileName\" file=\"skill.UploadFileName\"></file-viewer></div></td><td width=\"20%\"><md-icon md-svg-icon=\"pencil\" class=\"md-icon-edit teal-500-fg\" ng-click=\"vm.openDialog(true, skill)\" ng-if=\"vm.canEditSkills\"></md-icon><delete-component ng-if=\"vm.canDeleteSkills\" index=\"skill\" message=\"{{\'CONTACTSMODULE.SKILLS_DELETE_MESSAGE\' | translate}}\" callback=\"vm.removeSkill\" section=\"{{\'CONTACTSMODULE.SKILLS_DELETE_SECTION\' | translate}}\"></delete-component></td></tr><tr><div ng-if=\"vm.skills.length < 1\" class=\"padding-20\">There are no skills for this contact.</div></tr><tr ng-if=\"vm.canAddSkills\"><td style=\"padding-left: 0px;\"><add-button ng-click=\"vm.openDialog(false, null)\" title=\"Add Skill\"></add-button></td></tr></tbody></table>");
$templateCache.put("app/main/customValidations/create/components/if/ifDialog/if-dialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"25\" flex-md=\"90\" flex-sm=\"90\" flex-xs=\"90\" ng-cloak=\"\"><form name=\"conditionForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Condition</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-body-1\"><div class=\"text-bold\" flex=\"\" ng-if=\"vm.properties.length == 0\" layout=\"row\" layout-align=\"center center\">No condition properties left</div><md-input-container ng-if=\"vm.properties.length > 0\" class=\"md-block\"><label>Field</label><md-select name=\"fieldName\" ng-disabled=\"vm.is_edit_mode\" ng-change=\"vm.changeField(vm.rule_model.FieldName)\" ng-model-options=\"{trackBy : \'$value\'}\" ng-model=\"vm.rule_model.FieldName\" required=\"\"><md-option ng-value=\"property.FieldName\" ng-repeat=\"property in vm.properties\">{{property.FieldName}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.rule_model.FieldName != null\"><label>Value</label><md-select name=\"fieldValue\" ng-model=\"vm.rule_model.Value\" ng-model-options=\"{trackBy : \'$value\'}\" required=\"\"><md-option value=\"{{option.id || option.Id}}\" ng-repeat=\"option in vm.available_options\">{{option.Name ? option.Name : option.TypeName}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.save()\" ng-disabled=\"conditionForm.$invalid\" class=\"md-raised md-accent\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contact/create/work/training/dialog/contact-training-dialog.html","<md-dialog id=\"contact-training-dialog\" class=\"main-style\" aria-label=\"{{vm.caption}}\" flex=\"25\" flex-md=\"50\" flex-sm=\"50\" ng-cloak=\"\"><form name=\"trainingForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><md-input-container><label translate=\"CONTACTSMODULE.TRAINING_HEADER\"></label><md-select ng-model=\"vm.model.Id\" ng-change=\"vm.onChangeItem(vm.model.Id)\" required=\"\"><md-option ng-repeat=\"training in vm.trainings | orderBy:\'TrainingName\'\" ng-value=\"training.Id\">{{training.TrainingName}}</md-option></md-select></md-input-container><md-input-container><label translate=\"CONTACTSMODULE.SKILLS_DESCRIPTION\"></label> <input type=\"text\" ng-model=\"vm.model.Description\"></md-input-container><md-input-container><label translate=\"CONTACTSMODULE.SKILLS_COLUMN_REFERENCE\"></label> <input type=\"text\" ng-model=\"vm.model.ReferenceNumber\"></md-input-container><div layout=\"row\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"CONTACTSMODULE.TRAINING_COMPLETED_DATE\"></label><md-datepicker ng-model=\"vm.model.CompletedDate\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container></div><div layout=\"row\" ng-if=\"vm.model.ExpiryIsMandatory\"><md-input-container flex=\"\" layout=\"row\"><label translate=\"CONTACTSMODULE.SKILLS_EXPIRY_DATE\"></label><md-datepicker ng-model=\"vm.model.ExpiryDate\" md-open-on-focus=\"\" class=\"md-block\" ng-required=\"true\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container></div><div layout=\"row\" ng-show=\"vm.uploadAdded || vm.model.UploadFileName != null\"><md-card flex=\"100\"><md-card-content><div layout=\"row\"><div flex=\"10\"><md-button class=\"md-icon-button md-primary\" style=\"color : red\"><md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button></div><div flex=\"60\"><span translate=\"CONTACTSMODULE.SKILLS_UPLOADED_FILE\" style=\"position : relative; top : 10px;\"></span></div><div><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.preview(vm.fileName)\" style=\"color : red\"><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button></div><div ng-if=\"vm.isEdit\"><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.downloadFile()\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon></md-button></div><div><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.removeUpload()\" style=\"color : red\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-card-content><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.showProgress\"></md-progress-linear></md-card></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.onDone()\" ng-disabled=\"trainingForm.$invalid\" class=\"md-raised md-accent\" translate=\"CONTACTSMODULE.TRAINING_SAVE\"></md-button><aps-upload-file></aps-upload-file><span flex=\"\"></span></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/customValidations/create/components/then/thenDialog/then-dialog.html","<md-dialog id=\"contact-create-email\" aria-label=\"Add Email Address\" flex=\"40\" flex-md=\"90\" flex-sm=\"90\" flex-xs=\"90\" ng-cloak=\"\"><form name=\"conditionForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Then</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-body-1\"><div class=\"text-bold\" flex=\"\" ng-if=\"vm.properties.length == 0\" layout=\"row\" layout-align=\"center center\">No then properties left</div><md-input-container ng-if=\"vm.properties.length > 0\" class=\"md-block\"><label>Field</label><md-select name=\"fieldName\" ng-disabled=\"vm.is_edit_mode\" ng-change=\"vm.changeField(vm.then_model.Field)\" ng-model-options=\"{trackBy : \'$value\'}\" ng-model=\"vm.then_model.Field\" required=\"\"><md-option ng-value=\"property.FieldName\" ng-repeat=\"property in vm.properties\">{{property.FieldName}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.then_model.Field != null && vm.isSelectType && vm.then_model.Field != \'Contact Types\'\"><label>Allowed Options</label><md-select name=\"fieldValue\" ng-model=\"vm.then_model.AllowedValues\" ng-model-options=\"{trackBy : \'$value.Id\'}\" md-selected-text=\"vm.utils.getSelectedText(vm.then_model.AllowedValues, \'Allowed Options\', \'Name|TypeName\')\" multiple=\"\" required=\"\"><md-option ng-value=\"option\" ng-repeat=\"option in vm.available_options\">{{option.Name ? option.Name : option.TypeName}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.then_model.Field != null && vm.isSelectType && vm.then_model.Field == \'Contact Types\'\"><label>Allowed Options</label><md-select name=\"fieldValue\" ng-model=\"vm.then_model.AllowedValues\" ng-model-options=\"{trackBy : \'$value.id\'}\" md-selected-text=\"vm.utils.getSelectedText(vm.then_model.AllowedValues, \'Allowed Options\', \'Name|TypeName\')\" multiple=\"\" required=\"\"><md-option ng-value=\"option\" ng-repeat=\"option in vm.available_options\">{{option.Name ? option.Name : option.TypeName}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.then_model.Field != null && !vm.isSelectType\"><input type=\"text\" ng-model=\"vm.then_model.RegexValidation\" placeholder=\"Regex Pattern\"></md-input-container><md-checkbox ng-model=\"vm.then_model.IsRequired\" ng-if=\"vm.then_model.Field\" class=\"text-bold\">This field is required</md-checkbox></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.save()\" ng-disabled=\"conditionForm.$invalid\" class=\"md-raised md-accent\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoice/forms/manual-invoice/directive/entry-form-manual-invoice/manual-invoice-entry-form.html","<div layout=\"column\" flex=\"\" ng-form=\"invoiceExportForm\"><md-input-container><md-select name=\"Clients\" ng-model=\"vm.model.data.selectedClient\" ng-model-options=\"{trackBy: \'$value.Id\'}\" ng-change=\"vm.onClientChange({{vm.model.data.selectedClient}})\" placeholder=\"Client(s)\" required=\"\"><md-optgroup label=\"Client(s)\"><md-option ng-value=\"client\" ng-repeat=\"client in vm.lookups.data.clientLookups\">{{client.Name}}</md-option></md-optgroup></md-select><div ng-messages=\"invoiceExportForm.Clients.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client is required.</span></div></div></md-input-container><div layout=\"row\"><md-input-container flex=\"100\"><md-select name=\"branches\" ng-model=\"vm.model.data.selectedBranch\" ng-change=\"vm.onBranchChange()\" placeholder=\"Branch(es)\" required=\"\"><md-optgroup label=\"Branch(es)\"><md-option ng-value=\"branch.Id\" ng-repeat=\"branch in vm.lookups.data.branchLookups | filter:{State: \'!!\'}\">{{branch.Name}}</md-option></md-optgroup></md-select><div ng-messages=\"invoiceExportForm.branches.$error\" role=\"alert\"><div ng-message=\"required\"><span>Branch is required.</span></div></div></md-input-container></div><md-input-container flex=\"\"><label>Invoice Date</label><md-datepicker name=\"invoiceDate\" ng-model=\"vm.model.data.invoiceDate\" md-open-on-focus=\"\" class=\"md-block\" flex=\"\" layout=\"row\" required=\"\"></md-datepicker></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"purchaseOrder\" ng-model=\"vm.model.data.purchaseOrderNumber\" aria-label=\"Purchase Order Number\" placeholder=\"Purchase Order Number\" required=\"\"><div ng-messages=\"invoiceExportForm.purchaseOrder.$error\" role=\"alert\"><div ng-message=\"required\"><span>Maximum length exceeded.</span></div></div></md-input-container><md-input-container><label>Invoice Terms</label><md-select name=\"terms\" flex=\"\" ng-model-options=\"{trackBy : \'$value.Id\'}\" placeholder=\"Invoice Terms\" ng-model=\"vm.model.data.invoiceTerms\" required=\"\"><md-option ng-value=\"term\" ng-repeat=\"term in vm.lookups.data.termLookups\">{{term.Name}}</md-option><div ng-messages=\"invoiceExportForm.terms.$error\" role=\"alert\"><div ng-message=\"required\"><span>Invoice terms is required.</span></div></div></md-select><md-icon md-font-icon=\"icon-plus-box\" ng-click=\"vm.addInvoiceTerm()\"></md-icon></md-input-container></div>");
$templateCache.put("app/main/invoice/forms/manual-invoice/directive/line-item-manual-invoice/line-item-manual-invoice.html","<div class=\"invoice-detail\" ng-dblclick=\"vm.editLineItem()\" alt=\"Add/Edit line item\"><div class=\"layout-column\"><div class=\"layout-row flex\"><div class=\"flex-100 margin-top-15\"><section layout-wrap=\"\"><md-button md-no-ink=\"\" class=\"md-accent margin-left-0\" ng-click=\"vm.editLineItem()\" ng-disabled=\"vm.clientId == null || vm.clientId.length <= 0\">Add Line Item</md-button></section><table class=\"simple invoice-table\" style=\"width: 100%; min-width: 100%;\"><thead><tr><th>Description</th><th class=\"text-right qty-col\">Qty</th><th class=\"text-right unit-price-col\">Unit Price</th><th class=\"text-right amt-col\">Amount</th></tr></thead><tfoot><tr><td colspan=\"4\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"vm.model.data.length <= 0\"><span>No current record(s) to display.</span></div></td></tr></tfoot><tbody><tr ng-repeat=\"lineItem in vm.model.data\"><td>{{lineItem.Description}}</td><td class=\"text-right\"><span ng-hide=\"lineItem.Quantity == null || lineItem.Quantity == 0\">{{lineItem.Quantity}}</span></td><td class=\"text-right\"><span ng-hide=\"lineItem.UnitPriceExcludingTax == null || lineItem.UnitPriceExcludingTax == 0\">${{lineItem.UnitPriceExcludingTax | number:2}}</span></td><td class=\"text-right\"><span ng-hide=\"lineItem.Amount == null || lineItem.Amount == 0\">${{lineItem.Amount | number:2}}</span></td></tr></tbody></table></div></div></div><div class=\"layout-column\"><div class=\"layout-row flex\"><div class=\"flex-100\"><table class=\"simple invoice-table-footer\" style=\"width: 100%; min-width: 100%;\"><tbody><tr class=\"subtotal\"><td>SUBTOTAL</td><td>${{vm.model.summary.SubTotal | number:2}}</td></tr><tr class=\"subtotal\" ng-show=\"vm.model.summary.Taxes && vm.model.summary.Taxes > 1\"><td>TOTAL TAX</td><td>${{vm.model.summary.TotalTax | number:2}}</td></tr><tr ng-repeat=\"tax in vm.model.summary.Taxes | filter:{IsLineItemTax: false}\"><td>{{tax.Name}} ({{tax.Rate}}%)</td><td class=\"text-right\">${{tax.TotalTaxApplied | number:2}}</td></tr><tr ng-repeat=\"tax in vm.model.summary.Taxes | filter:{IsLineItemTax: true}\"><td>{{tax.Name}} ({{tax.Rate}}%)</td><td class=\"text-right\">${{tax.TotalTaxApplied | number:2}}</td></tr><tr class=\"total\"><td>TOTAL</td><td>${{vm.model.summary.GrandTotal | number:2}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/messaging/generalMessaging/components/dialog/ticket-detail/ticket-detail.directive.html","<md-whiteframe style=\"margin-top : 20px;\" layout-padding=\"\" class=\"md-whiteframe-3dp\" flex=\"\" layout=\"column\"><div class=\"md-body-2 text-bold\">Ticket Details</div><div class=\"md-body-1\" layout=\"row\" flex=\"\" layout-align=\"space-between end\"><div flex=\"80\"><table><tr><td width=\"50%\" class=\"blue-800-fg text-bold\">Ticket #</td><td width=\"50%\">{{vm.ticket_detail.TicketNumber}}</td></tr><tr><td width=\"50%\" class=\"blue-800-fg text-bold\">Branch</td><td width=\"50%\">{{vm.ticket_detail.Branch}}</td></tr><tr><td width=\"50%\" class=\"blue-800-fg text-bold\">Division</td><td width=\"50%\">{{vm.ticket_detail.Division}}</td></tr></table></div><div flex=\"20\" layout=\"column\" layout-align=\"end end\"><div><md-icon ng-click=\"vm.removeTicket()\" class=\"icon-delete red-700-fg\" md-font-icon=\"icon-delete\"><md-tooltip>Remove Ticket</md-tooltip></md-icon></div></div></div></md-whiteframe>");
$templateCache.put("app/main/messaging/generalMessaging/components/messageArea/contacts/contacts.html","<div id=\"message-area-contacts\"><md-card-header layout=\"column\" flex=\"\"><div layout=\"row\" flex=\"\"><div flex=\"auto\"><span><i class=\"icon icon-account-circle icon-color\"></i></span> <span translate=\"MESSAGING.CONTACTS_SELECTED\" ng-class=\"{ \'md-body-2 header-text\': vm.service.mediaQueryService.isDevice1457(), \'md-subhead header-text\': vm.service.mediaQueryService.isDeviceMessagingBig() }\"></span></div><div ng-if=\"vm.service.mediaQueryService.isDeviceMessagingSmall() || (vm.service.mediaQueryService.isDeviceMessagingBig() && vm.service.contacts_available.length == 0)\" flex=\"auto\" layout=\"row\" layout-align=\"end center\"><span ng-if=\"!vm.service.is_loading\"><i ng-click=\"vm.showFilterDialog()\" class=\"icon-color filter s25 icon icon-filter-variant\"><md-tooltip>{{\'MESSAGING.FILTER_CONTACTS\' | translate}}</md-tooltip></i></span></div></div><div class=\"chips-section\"><md-chips ng-model=\"vm.service.contacts_ready\" md-on-add=\"vm.service.onAddPerson($chip)\" md-on-remove=\"vm.service.onRemovePerson($chip)\" name=\"contacts\"><md-autocomplete md-search-text=\"vm.searchText\" md-items=\"contact in vm.querySearch(vm.searchText)\" md-item-text=\"contact.Name\" class=\"md-body-1\" placeholder=\"Type a Name\"><span class=\"md-body-1 autocomplete-icon\" layout=\"row\"><div flex=\"10\" class=\"margin-top-10 margin-right-20\"><i class=\"light-blue-800-fg s30 icon icon-account margin-top-10\"></i></div><div flex=\"auto\" class=\"margin-top-15\">{{contact.Name}}</div></span></md-autocomplete><md-chip-template ng-class=\"{\'md-caption\' : vm.service.mediaQueryService.isDeviceMessagingSmall(), \'md-body-1\' : vm.service.mediaQueryService.isDeviceMessagingBig()}\"><strong>{{$chip.Name}}</strong></md-chip-template></md-chips><div ng-if=\"!vm.service.isSmsEnabled && vm.service.contactNamesWithoutDevices.length > 0\" class=\"margin-top-5\">{{vm.service.contactNamesWithoutDevices.join(\', \')}} {{vm.service.contactNamesWithoutDevices.length > 1 ? \'have\' : \'has\' }} no devices and SMS is not enabled.</div></div></md-card-header></div>");
$templateCache.put("app/main/messaging/generalMessaging/components/messageArea/container/container.html","<md-card layout-padding=\"\" layout-margin=\"\" ng-style=\"{ \'opacity\' : (vm.service.is_sending || vm.service.is_loading) ? \'0.5\' : \'1\' }\" ng-class=\"{\'big-screen md-whiteframe-3dp\' : vm.mediaService.isDeviceMessagingBig(), \'small-screen md-whiteframe-3dp\' : vm.mediaService.isDeviceMessagingSmall()}\"><contacts-selected></contacts-selected><message-section></message-section></md-card>");
$templateCache.put("app/main/messaging/generalMessaging/components/messageArea/message/message.html","<div class=\"message-section\"><md-card-content><div flex=\"\" layout=\"column\"><div><span><i class=\"icon icon-message-reply\"></i></span> <span translate=\"MESSAGING.MESSAGE\" ng-class=\"{\'md-body-2 header-text\' : vm.service.mediaQueryService.isDevice1457(), \'md-subhead header-text\' : vm.service.mediaQueryService.isDeviceMessagingBig() }\"></span></div><special-text-area rows=\"vm.service.rows\" ng-class=\"{\'md-subhead\' : vm.service.mediaQueryService.isDeviceMessagingBig(), \'md-body-1\' : vm.service.mediaQueryService.isDeviceMessagingSmall() }\" limit=\"vm.service.message_chars_limit\" ng-model=\"vm.service.message\"></special-text-area><div layout=\"row\" class=\"send-button\" layout-align=\"start center\"><span><md-button translate=\"MESSAGING.SEND\" ng-click=\"vm.service.send()\" ng-disabled=\"vm.service.isSendButtonDisabled()\" class=\"md-raised md-accent\"></md-button></span></div></div></md-card-content></div>");
$templateCache.put("app/main/messaging/generalMessaging/sendMessageAsService/message/textArea/textArea.html","<div class=\"textArea\" dimmer=\"\" ng-model=\"vm.is_sending\"><div><md-input-container class=\"bg md-block\"><textarea ng-model=\"vm.ngModel\" class=\"text-zone\" ng-disabled=\"vm.isDisabled\" ng-keypress=\"vm.limitChars(vm.ngModel)\" ng-change=\"vm.limitChars(vm.ngModel)\" rows=\"{{vm.rows}}\" md-select-on-focus=\"\">\r\n            </textarea></md-input-container></div><div layout=\"row\" class=\"md-body-2 counter\" layout-align=\"end center\"><span>{{vm.ngModel == null ? 0 : vm.ngModel.length}} / {{vm.limit}}</span></div></div>");
$templateCache.put("app/main/lockoutSettings/view/components/rulesList/ruleItem/rule-item.html","<md-list-item class=\"md-2-line md-container md-ink-ripple\" md-ink-ripple=\"\" ng-style=\"vm.service.selectedRule.Id == vm.data.Id ? {\'background-color\' : \'#dcd4d4\', \'padding\' : \'3px\'} : {\'background-color\' : \'#fafafa\', \'padding\' : \'3px\'}\"><div layout=\"row\" flex=\"\" style=\"margin-right : 10px;\"><span flex=\"\"></span><div layout=\"column\" flex=\"90\"><div layout=\"row\"><span class=\"pt-10 md-body-2 md-list-item-text\">{{vm.data.Name}}</span></div><div flex=\"70\" style=\"margin-top : 10px;\">{{vm.data.Description}} <span class=\"label md-list-item-text\" translate=\"LOCKOUTSETTINGS.VIEW_RULE\"></span> <span ng-if=\"vm.data.IsGlobalSettings\" class=\"global-label md-list-item-text\" translate=\"LOCKOUTSETTINGS.VIEW_GLOBAL_RULE\"></span></div></div></div><md-divider></md-divider></md-list-item>");
$templateCache.put("app/main/jobs/allocateResource/components/resourceLike/dialog/resource-like.dialog.html","<md-dialog class=\"main-style resource-like\" flex=\"50\" style=\"overflow: hidden\" ms-scroll=\"\"><form name=\"resourceLikeForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.RESOURCE_LIKE\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" ng-click=\"vm.close()\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" flex=\"\"><md-tabs ms-scroll=\"\" md-border-bottom=\"\" md-dynamic-height=\"\"><md-tab label=\"{{\'RESOURCEALLOCATION.SIMILAR_TICKETS\' | translate}} ({{vm.pasttickets.length}})\"><md-checkbox ng-change=\"vm.preSelect()\" style=\"position:relative; margin-top : 20px;\" ng-model=\"vm.resource_select_all\"><text class=\"md-body-2\">Auto Select</text></md-checkbox><md-card ng-repeat=\"ticket in vm.pasttickets\"><md-card-title><md-card-title-text><span class=\"md-subhead md-accent\">{{\'RESOURCEALLOCATION.RESOURCE_LIKE\' | translate}} <b><a ng-click=\"vm.showTicketDetails(ticket.Id)\">#{{ticket.TicketNumber}}</a></b></span></md-card-title-text></md-card-title><md-card-content><div layout=\"column\"><div layout=\"column\" flex=\"\"><div flex=\"column\" ng-show=\"selected_items.length > 0\"><md-card><md-card-header><md-card-header-text><span class=\"md-body-1\">{{\'RESOURCEALLOCATION.PEOPLE\' | translate }}</span></md-card-header-text></md-card-header><md-card-content layout=\"column\"><md-checkbox ng-model=\"item.Selected\" ng-change=\"vm.toggleData(item)\" ng-repeat=\"item in selected_items = (ticket.Items | filter : {ItemType : 4})\"><span class=\"md-body-1\">{{item.ItemName}} #{{item.Counter}} -<text class=\"md-body-2\" style=\"color : #455a64\">{{item.AllocatedItemName}}</text></span></md-checkbox></md-card-content></md-card></div><div flex=\"column\" ng-show=\"selected_items2.length > 0\"><md-card><md-card-header><md-card-header-text><span class=\"md-body-1\">{{\'RESOURCEALLOCATION.EQUIPMENT\' | translate }}</span></md-card-header-text></md-card-header><md-card-content layout=\"column\"><md-checkbox ng-model=\"item.Selected\" ng-change=\"vm.toggleData(item)\" ng-repeat=\"item in selected_items2 = (ticket.Items | filter : {ItemType : \'!4\' })\"><span class=\"md-body-1\">{{item.ItemName}} #{{item.Counter}} -<text class=\"md-body-2\" style=\"color : #455a64\">{{item.AllocatedItemName}}</text><text style=\"color : #455a64\" ng-if=\"item.OperatorId != null\">- {{item.OperatorName}}</text></span></md-checkbox></md-card-content></md-card></div></div></div></md-card-content></md-card></md-tab><md-tab ng-if=\"vm.pastTicketsCounter(vm.pasttickets) != 0\" label=\"{{\'RESOURCEALLOCATION.FUTURE_TICKETS\' | translate}} ({{vm.futuretickets.length - 1}})\"><md-card><md-card-content><div layout=\"column\"><md-checkbox ng-model=\"ticket.Selected\" ng-change=\"vm.toggleFutureData(ticket)\" ng-repeat=\"ticket in vm.futuretickets | orderBy : [\'Order\', \'StartDate\']\" class=\"md-body-1\"><text class=\"md-body-2 checkbox\" ng-if=\"ticket.TicketNumber != null\" ng-click=\"vm.showTicketDetails(ticket.Id)\">{{ticket.TicketNumber}}</text><text class=\"md-body-2 checkbox\" ng-if=\"ticket.TicketNumber == null\">{{ticket.Selected ? vm.utils.translate(\'RESOURCEALLOCATION.DESELECT_ALL\') : vm.utils.translate(\'RESOURCEALLOCATION.SELECT_ALL\')}}</text><text ng-if=\"ticket.TicketNumber != null\">-</text><text ng-if=\"ticket.TicketNumber != null\">{{ticket.StartDate | date}}</text><text ng-if=\"ticket.TicketNumber != null\">-</text><text class=\"md-body-2 checkbox\" ng-if=\"ticket.TicketNumber != null\">{{ticket.JobFullAddress}}</text></md-checkbox></div></md-card-content></md-card></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-disabled=\"vm.checkedItems == 0\" ng-click=\"vm.save()\" translate=\"RESOURCEALLOCATION.RESOURCE_NOW\"></md-button><md-button class=\"md-raised\" translate=\"RESOURCEALLOCATION.SHIFTNOTE_CANCEL\" ng-click=\"vm.close()\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/resourceLike/errorDialog/resource-like.error-dialog.html","<md-dialog class=\"main-style resource-like\" style=\"overflow: hidden\" ms-scroll=\"\"><form name=\"resourceLikeForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Resource Allocation Error</h2><span flex=\"\"></span><md-button class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" ng-click=\"vm.close()\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" flex=\"\"><span translate=\"RESOURCEALLOCATION.RESOURCE_LIKE_ALLOCATION_FAILED2\" class=\"md-subhead\"></span><div layout=\"row\" flex=\"\"><ul><li ng-repeat=\"error in vm.errorlist\" class=\"md-body-2\"><b ng-if=\"error.TicketNumber && vm.isObject(error)\" style=\"color : red\">Ticket #{{error.TicketNumber}}</b> <span ng-if=\"error.AllocatedItemName && vm.isObject(error)\">{{error.AllocatedItemName}}</span> <span ng-if=\"error.ResourceNotes && vm.isObject(error)\">- {{vm.formatMessage(error.ResourceNotes)}}</span> <span ng-if=\"!vm.isObject(error)\">{{error}}</span></li></ul></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent md-primary\" translate=\"RESOURCEALLOCATION.CLOSE\" ng-click=\"vm.close()\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/draggableComponent/advancedOptions/advanced-options.html","<md-dialog class=\"main-style\" flex=\"50\" flex-xs=\"100\" flex-sm=\"50\"><form name=\"notesForm\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'RESOURCEALLOCATION.ADVANCEDOPTION\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" ng-click=\"vm.close()\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\"><div layout=\"column\"><div><p class=\"md-subhead\"><b>{{ \'RESOURCEALLOCATION.SHOWOPTION\' | translate }}</b></p></div><div layout=\"column\" flex=\"\"><md-switch ng-model=\"vm.showOption.suburb\" ng-change=\"vm.suburbDistanceChange(\'suburb\')\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.EMPLOYEESUBURB\' | translate }}</md-switch><md-switch ng-model=\"vm.showOption.distance\" ng-change=\"vm.suburbDistanceChange(\'distance\')\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.EMPLOYEEDISTANCE\' | translate }}</md-switch><md-switch ng-model=\"vm.showOption.disable\" ng-change=\"vm.suburbDistanceChange(\'disable\')\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.HIDESUBURBDISTANCE\' | translate }}</md-switch><md-switch ng-model=\"vm.showOption.employmentStatus\" ng-change=\"vm.employmentStatusChange()\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.EMPLOYEMENTSTATUS\' | translate }}</md-switch><md-switch ng-model=\"vm.showOption.showPrevAndNextShiftDetails\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.NEXT_SHIFT\' | translate }}</md-switch><md-switch ng-model=\"vm.showOption.vehicle\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.VEHICLE\' | translate }}</md-switch></div><md-divider></md-divider></div><br><div layout=\"column\"><div><p class=\"md-subhead\"><b>{{ \'RESOURCEALLOCATION.FILTEROPTION\' | translate }}</b></p></div><div layout=\"column\" flex=\"\"><md-radio-group ng-model=\"vm.filterOption\" layout=\"column\" flex=\"\"><md-radio-button value=\"0\" ng-if=\"vm.showOption.employmentStatus\">{{ \'RESOURCEALLOCATION.CASUAL\' | translate }}</md-radio-button><md-radio-button value=\"1\" ng-if=\"vm.showOption.employmentStatus\">{{ \'RESOURCEALLOCATION.PARTTIME\' | translate }}</md-radio-button><md-radio-button value=\"2\" ng-if=\"vm.showOption.employmentStatus\">{{ \'RESOURCEALLOCATION.FULLTIME\' | translate }}</md-radio-button><md-radio-button value=\"3\" ng-if=\"vm.showOption.employmentStatus\"><label translate=\"RESOURCEALLOCATION.HIRE\"></label></md-radio-button><md-switch ng-model=\"vm.hasVehicleFilter\" ng-change=\"vm.activateVehicleFilter()\" aria-label=\"Switch 1\">{{ \'RESOURCEALLOCATION.HASVEHICLE\' | translate }}</md-switch></md-radio-group></div><md-divider></md-divider></div><br><div layout=\"column\" ng-if=\"vm.showOption.distance || vm.showOption.suburb\"><div><p class=\"md-subhead\"><b>{{ \'RESOURCEALLOCATION.SORTOPTION\' | translate }}</b></p></div><div layout=\"column\" flex=\"\"><md-radio-group ng-model=\"vm.sortOption\" layout=\"column\" flex=\"\"><md-radio-button value=\"0\">{{ \'RESOURCEALLOCATION.EMPLOYEENAME\' | translate }}</md-radio-button><md-radio-button value=\"1\" ng-if=\"vm.showOption.suburb\">{{ \'RESOURCEALLOCATION.EMPLOYEESUBURB\' | translate }}</md-radio-button><md-radio-button value=\"2\" ng-if=\"vm.showOption.distance\">{{ \'RESOURCEALLOCATION.DISTANCETOJOB\' | translate }}</md-radio-button></md-radio-group></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.save()\" ng-disabled=\"notesForm.$invalid\">{{ \'RESOURCEALLOCATION.FILTER\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/ResourceDialog/resource-dialog.html","<md-dialog class=\"resource-dialog\" flex=\"45\" flex-xs=\"100\" flex-sm=\"100\" ng-cloak=\"\" block-ui=\"resource-dialog\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>{{ vm.itemType == \"People\" ? vm.utilService.translate(\'RESOURCEALLOCATION.PEOPLE\') : vm.utilService.translate(\'RESOURCEALLOCATION.EQUIPMENT\') }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 8px;\"><md-tabs md-dynamic-height=\"\" ng-if=\"vm.itemType == \'People\'\"><md-tab label=\"{{ \'RESOURCEALLOCATION.CHANGE_SHIFT_TYPE\' | translate }}\" md-on-select=\"vm.onTabChanges(0)\"><md-content style=\"margin-top: 30px;\"><div layout=\"column\" flex=\"\"><span flex=\"\">{{ \'RESOURCEALLOCATION.CHANGE\' | translate }} <b>{{ vm.item.ItemName }}</b> {{ \'RESOURCEALLOCATION.TO\' | translate }}</span><md-input-container flex=\"\"><md-select ng-model=\"vm.chosenItem\" flex=\"\" required=\"\"><md-option ng-repeat=\"item in vm.list\" ng-value=\"item.Id\">{{ item.Name }}</md-option></md-select></md-input-container><div align=\"right\"><span flex=\"\"></span><md-button translate=\"RESOURCEALLOCATION.SHIFTNOTE_SAVE\" style=\"margin-bottom: 10px;\" class=\"md-raised md-accent\" ng-disabled=\"vm.chosenItem == null\" ng-click=\"vm.onSave()\"></md-button></div></div></md-content></md-tab><md-tab label=\"{{ \'RESOURCEALLOCATION.MANAGE_SHIFT_AWARDS\' | translate }}\" ng-if=\"vm.isPayrollEnabled\"><md-content ng-style=\"{ marginTop:\'30px\' }\"><form name=\"shiftclassificationform\"><div layout=\"column\" flex=\"\"><md-input-container ng-if=\"vm.adminClaimsService.hasManageTimesheetPayroll && vm.adminClaimsService.isPayrollEnabled\"><label translate=\"RESOURCEALLOCATION.AWARD\"></label><md-select placeholder=\"{{ \'RESOURCEALLOCATION.AWARD\' | translate }}\" ng-disabled=\"vm.ariRestriction.IsAwardCannotBeOverridden || vm.ariRestriction.IsSalariedEmployee\" required=\"\" ng-model-options=\"{ trackBy: \'$value.Id\' }\" ng-change=\"vm.item.awardChanged = true\" md-on-open=\"vm.item.awardChanged = false\" md-on-close=\"vm.onAwardChange()\" ng-model=\"vm.item.Award\"><md-option ng-repeat=\"award in vm.awards\" ng-value=\"award\">{{ award.Name }}</md-option></md-select><div ng-show=\"vm.ariRestriction.IsAwardCannotBeOverridden || vm.ariRestriction.IsSalariedEmployee\" class=\"locked-note\" translate=\"RESOURCEALLOCATION.AWARD_LOCKED\"></div><div class=\"info-note\">{{vm.updateAwardInof}}</div></md-input-container><md-input-container ng-if=\"vm.adminClaimsService.hasManageTimesheetPayroll && vm.adminClaimsService.isPayrollEnabled\"><label translate=\"RESOURCEALLOCATION.CLASSIFICATION\"></label><md-select placeholder=\"{{ \'RESOURCEALLOCATION.CLASSIFICATION\' | translate }}\" ng-disabled=\"vm.ariRestriction.IsClassificationCannotBeOverridden || vm.ariRestriction.IsSalariedEmployee\" required=\"\" ng-model-options=\"{ trackBy: \'$value.Id\' }\" ng-model=\"vm.item.AwardClassification\"><md-option ng-repeat=\"classification in vm.classifications\" ng-value=\"classification\" ng-disabled=\"classification.isDisabled\">{{ classification.Name }}</md-option></md-select><div ng-show=\"vm.ariRestriction.IsClassificationCannotBeOverridden || vm.ariRestriction.IsSalariedEmployee\" class=\"locked-note\" translate=\"RESOURCEALLOCATION.CLASSIFICATION_LOCKED\"></div><div class=\"info-note\">{{vm.updateAwardClassificationInof}}</div></md-input-container><md-input-container><label translate=\"RESOURCEALLOCATION.ROLES\"></label><md-select placeholder=\"{{ \'RESOURCEALLOCATION.ROLES\' | translate }}\" ng-disabled=\"vm.ariRestriction.IsSalariedEmployee\" multiple=\"\" ng-model-options=\"{ trackBy: \'$value.Id\' }\" ng-model=\"vm.item.ShiftRoles\"><md-optgroup label=\"{{ \'RESOURCEALLOCATION.ROLES\' | translate }}\"><md-option ng-repeat=\"role in vm.roles\" ng-value=\"role\" ng-disabled=\"role.isDisabled\">{{ role.Name }}</md-option></md-optgroup></md-select></md-input-container><md-checkbox ng-model=\"vm.item.NoMinimumShift\" ng-disabled=\"vm.ariRestriction.IsSalariedEmployee\" style=\"position: relative; top: 10px;\"><label translate=\"RESOURCEALLOCATION.NO_MINIMUM_SHIFT\"></label></md-checkbox><div align=\"left\"><label ng-if=\"vm.isAwardClassificationUpdated\" class=\"info-note\" translate=\"RESOURCEALLOCATION.AWARD_CLASSIFICATION_UPDATE_INFO\"></label></div><div align=\"right\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"vm.ariRestriction.IsSalariedEmployee\" translate=\"RESOURCEALLOCATION.RECALCULATE_AWARD\" ng-if=\"vm.adminClaimsService.hasManageTimesheetPayroll\" ng-click=\"vm.onRecalculateAward()\"></md-button><md-button translate=\"RESOURCEALLOCATION.SHIFTNOTE_SAVE\" ng-click=\"vm.saveManageShiftAwards(vm.item)\" ng-disabled=\"shiftclassificationform.$invalid || vm.ariRestriction.IsSalariedEmployee\" style=\"margin-bottom: 10px;\" class=\"md-raised md-accent\"></md-button></div></div></form></md-content></md-tab><md-tab label=\"{{ \'RESOURCEALLOCATION.ADDITIONAL_SKILLS_REQUIRED\' | translate }}\"><md-content style=\"margin-top: 30px;\"><form name=\"skills\"><div layout=\"column\" flex=\"\"><md-input-container class=\"md-block\" flex=\"\"><md-select ng-model=\"vm.lineItem.AdditionalSkillIds\" name=\"skills\" multiple=\"\" flex=\"\"><md-option ng-repeat=\"skill in vm.skills\" ng-value=\"skill.Id\">{{ skill.Name }}</md-option></md-select></md-input-container></div><div align=\"right\"><span flex=\"\"></span><md-button translate=\"RESOURCEALLOCATION.SHIFTNOTE_SAVE\" style=\"margin-bottom: 10px;\" ng-disabled=\"skills.$invalid\" ng-click=\"vm.saveSkills(vm.lineItem.AdditionalSkillIds)\" class=\"md-raised md-accent\"></md-button></div></form></md-content></md-tab></md-tabs><md-tabs md-dynamic-height=\"\" ng-if=\"vm.itemType != \'People\'\"><md-tab label=\"{{ \'RESOURCEALLOCATION.CHANGE_RESOURCE_TYPE\' | translate }}\" md-on-select=\"vm.onTabChanges(0)\"><form name=\"resourceTypeForm\" ng-if=\"vm.canChangeResourceType && vm.lineItem.AllocatedItemName == null\"><div layout=\"column\"><span flex=\"\" style=\"margin-top: 30px;\">{{ \'RESOURCEALLOCATION.CHANGE\' | translate }} <b>{{ vm.item.ItemName }}</b> {{ \'RESOURCEALLOCATION.TO\' | translate }}</span><md-input-container flex=\"\"><md-select ng-model=\"vm.chosenItem\" flex=\"\" required=\"\"><md-option ng-repeat=\"item in vm.list\" ng-value=\"item.Id\">{{ item.Name }}</md-option></md-select></md-input-container><div align=\"right\"><span flex=\"\"></span><md-button translate=\"RESOURCEALLOCATION.SHIFTNOTE_SAVE\" style=\"margin-bottom: 10px;\" class=\"md-raised md-accent\" ng-disabled=\"resourceTypeForm.$invalid\" ng-click=\"vm.onSave()\"></md-button></div></div></form><div flex=\"\" layout=\"row\" ng-if=\"vm.canChangeResourceType && vm.lineItem.AllocatedItemName != null\" layout-align=\"center center\"><div style=\"margin-top: 50px;\" class=\"md-body-1\">{{ \'RESOURCEALLOCATION.PLEASE_UNALLOCATE\' | translate }} <b>{{ vm.lineItem.AllocatedItemName }}</b></div></div><div flex=\"\" layout=\"row\" ng-if=\"!vm.canChangeResourceType\" layout-align=\"center center\"><div style=\"margin-top: 50px;\" class=\"md-body-1\">{{ \'RESOURCEALLOCATION.PLEASE_UNLINK\' | translate }} <b>{{ vm.item.ItemName }}</b> {{ \'RESOURCEALLOCATION.PLEASE_UNLINK_FIRST\' | translate }}</div></div></md-tab><md-tab label=\"{{ \'RESOURCEALLOCATION.CHANGE_BILLING_TYPE\' | translate }}\" md-on-select=\"vm.onTabChanges(1)\" ng-if=\"vm.checkAccessService.checkAccessByRole(\'Ticket Billing Preferences\') && vm.isBillingEnabled\"><form name=\"billingTypeForm\"><div layout=\"column\"><span flex=\"\" style=\"margin-top: 30px;\">{{ \'RESOURCEALLOCATION.BILL\' | translate }} <b>{{ vm.item.ItemName }}</b> {{ \'RESOURCEALLOCATION.AS\' | translate }}</span><md-input-container flex=\"\"><md-select ng-model=\"vm.chosenItem\" flex=\"\" required=\"\"><md-option ng-repeat=\"item in vm.list\" ng-value=\"item.Id\">{{ item.Name }}</md-option></md-select></md-input-container><div align=\"right\"><span flex=\"\"></span><md-button translate=\"RESOURCEALLOCATION.SHIFTNOTE_SAVE\" style=\"margin-bottom: 10px;\" class=\"md-raised md-accent\" ng-disabled=\"billingTypeForm.$invalid\" ng-click=\"vm.onSave()\"></md-button></div></div></form></md-tab><md-tab label=\"{{ \'RESOURCEALLOCATION.CHANGE_BILLING_PREFERENCE\' | translate }}\" md-on-select=\"vm.onTabChanges(2)\" ng-if=\"vm.checkAccessService.checkAccessByRole(\'Ticket Billing Preferences\') && vm.isBillingEnabled\"><form name=\"billingPreferenceForm\"><div layout=\"column\"><span flex=\"\" style=\"margin-top: 30px;\"><b>{{ vm.item.ItemName }}</b> {{ \'RESOURCEALLOCATION.BILLING_PERIOD\' | translate }}</span><md-input-container flex=\"\"><md-select ng-model=\"vm.chosenItem2\" ng-model-options=\"{ trackBy: \'$value.ItemId\' }\" flex=\"\" required=\"\"><md-option ng-repeat=\"item in vm.hirePeriods\" ng-value=\"item\">{{ item.Name }}</md-option></md-select></md-input-container><div align=\"right\"><span flex=\"\"></span><md-button translate=\"RESOURCEALLOCATION.SHIFTNOTE_SAVE\" style=\"margin-bottom: 10px;\" class=\"md-raised md-accent\" ng-disabled=\"billingPreferenceForm.$invalid\" ng-click=\"vm.onSave()\"></md-button></div></div></form></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/ResourceNote/resource-note.html","<md-dialog class=\"main-style\" flex=\"50\" flex-xs=\"100\" flex-sm=\"100\"><form name=\"notesForm\" novalidate=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.SHIFTNOTE_HEADER\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" ng-click=\"vm.close()\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\"><md-input-container class=\"md-block\"><textarea ng-model=\"vm.notes\" name=\"note\" flex=\"100\" placeholder=\"{{\'RESOURCEALLOCATION.SHIFTNOTE_PLACEHOLDER\' | translate}}\" md-maxlength=\"500\" md-select-on-focus=\"\">\r\n         </textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised\" translate=\"RESOURCEALLOCATION.SHIFTNOTE_CANCEL\" ng-click=\"vm.close()\"></md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.save()\" translate=\"RESOURCEALLOCATION.SHIFTNOTE_SAVE\" ng-disabled=\"notesForm.$invalid\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/assignOperator/assign-operator-dialog.html","<md-dialog class=\"main-style\" flex=\"50\" flex-xs=\"100\" ng-cloak=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.ASSIGN_OPERATOR\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\"><div layout=\"column\" flex=\"\"><form name=\"operatorForm\" flex=\"\"><md-input-container class=\"md-block\"><label>{{\'RESOURCEALLOCATION.OPERATOR\' | translate}}</label><md-select ng-model=\"vm.line.AssignedOperatorId\" ng-change=\"vm.service.assignOperator(vm.line)\" ng-model-options=\"{trackBy : \'$value\'}\" required=\"\"><md-option ng-value=\"operator.AllocatedId\" ng-repeat=\"operator in vm.operators\">{{operator.AllocatedItemName}}</md-option></md-select></md-input-container></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/jobAllocation/message.html","<md-dialog class=\"resource-messaging\" flex-md=\"50\" flex=\"40\" flex-xs=\"90\" flex-sm=\"90\" ng-cloak=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.SEND_JOB_NOTIFS\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" ng-click=\"vm.close()\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content id=\"job-message-wrapper\" flex=\"\"><div ng-if=\"vm.sending\" layout=\"row\" style=\"margin-bottom : 20px;\"><span class=\"md-body-1\">{{vm.message}}</span><md-progress-circular md-diameter=\"20px;\" ng-if=\"vm.sending\" md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.is_past_job\" style=\"margin-bottom : 20px;\"><span class=\"text-boxed\">This is a past job. You can no longer send job notifications</span></div><div class=\"text-bold margin-left-30\" ng-if=\"vm.items.length > 0\"><md-checkbox ng-model=\"vm.isSelectAllChecked\" ng-disabled=\"vm.is_past_job\" ng-change=\"vm.checkAll()\" aria-checked=\"false\">{{vm.isSelectAllChecked ? \'Deselect All\' : \'Select All\'}}</md-checkbox></div><div dimmer=\"\" ng-model=\"vm.sending\" ng-repeat=\"item in vm.items\"><div class=\"unsent-item\" ng-class=\"{\'main-row-item-resource message-unsent\' : !item.MessageSent, \'main-row-item-resource message-sent\' : item.MessageSent}\"><div class=\"layout-row item padding-bottom-5 padding-top-5\"><div class=\"layout-row flex-5 layout-align-start-center\"><div class=\"check-itm\"><div class=\"flex\"><md-checkbox ng-change=\"vm.analyzeCheckItems()\" ng-model=\"item.IsSelected\" ng-disabled=\"vm.isCheckboxDisabled(item)\" class=\"jm-check-box-item\" aria-label=\"Checkbox\" type=\"checkbox\" role=\"checkbox\" aria-checked=\"false\"></md-checkbox></div></div></div><div class=\"layout-row flex item-body\" ng-if=\"vm.media.isDeviceBig()\"><div ng-style=\"vm.isPastJobStyle()\" flex=\"\"><div layout=\"row\" flex=\"\" class=\"margin-bottom-8 margin-left-15\"><div flex=\"35\" class=\"item-name\">{{item.ContactName}}</div><div flex=\"none\" class=\"item-name\">{{item.Shift}}</div><span flex=\"\"></span><div flex=\"none\" ng-class=\"vm.getMessageStatus(item.MessageStatus)\" class=\"status-default\">{{vm.getMessageStatusText(item.MessageStatus)}}</div></div></div></div><div class=\"layout-row flex item-body\" ng-if=\"vm.media.isDeviceSmall() && !vm.media.isDeviceXS()\"><div flex=\"\" ng-style=\"vm.isPastJobStyle()\"><div layout=\"row\" flex=\"\" class=\"margin-bottom-8 margin-left-30\"><div flex=\"35\" layout=\"column\"><div class=\"item-name\">{{item.ContactName}}</div><div flex=\"none\" class=\"item-name\"><b>{{item.Shift}}</b></div></div><span flex=\"\"></span><div><div ng-style=\"vm.isPastJobStyle()\" flex=\"nogrow\" layout=\"row\" ng-class=\"vm.getMessageStatus(item.MessageStatus)\" class=\"status-default\">{{vm.getMessageStatusText(item.MessageStatus)}}</div></div></div></div></div><div class=\"layout-row flex item-body\" ng-if=\"vm.media.isDeviceSmall() && vm.media.isDeviceXS()\"><div flex=\"\"><div layout=\"column\" ng-style=\"vm.isPastJobStyle()\" flex=\"\" class=\"margin-bottom-8 margin-left-30\"><div flex=\"35\" layout=\"column\"><div class=\"item-name\">{{item.ContactName}}</div><div flex=\"none\" class=\"item-name\"><b>{{item.Shift}}</b></div></div><span flex=\"\"></span><div><div ng-style=\"vm.isPastJobStyle()\" ng-class=\"vm.getMessageStatus(item.MessageStatus)\" class=\"status-default\">{{vm.getMessageStatusText(item.MessageStatus)}}</div></div></div></div></div></div><div class=\"layout-row item padding-bottom-5 padding-top-5 margin-top-5\" ng-if=\"vm.displayUnableToSendJobNotificationMessage(item)\"><div class=\"layout-row flex-5 layout-align-start-center\"></div><div flex=\"\"><div layout=\"column\" class=\"margin-bottom-8 margin-left-15\"><div flex=\"35\" layout=\"column\"><div>Cannot send job notification. There are no registered devices with Push Notification enabled.</div></div></div></div></div></div></div></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button ng-click=\"vm.send()\" ng-if=\"vm.enable_button && !vm.sending\" class=\"md-raised md-accent\">Send Now</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/timeDialog/time-dialog.html","<md-dialog class=\"main-style\" flex-sm=\"50\" flex-md=\"30\" flex=\"20\" ng-cloak=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.SHIFT_TIMES\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><div layout=\"column\" flex=\"\"><form name=\"shiftClassification\" flex=\"\" layout=\"column\"><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{\'RESOURCEALLOCATION.STARTTIME\' | translate}}\" ng-blur=\"vm.service.formatTime(vm.line, \'start\')\" ng-model=\"vm.line.StartTime\" ng-focus=\"vm.service.setTime(vm.line.StartTime)\" time-picker=\"\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" placeholder=\"{{\'RESOURCEALLOCATION.ENDTIME\' | translate}}\" ng-blur=\"vm.service.formatTime(vm.line, \'end\')\" ng-model=\"vm.line.FinishTime\" ng-focus=\"vm.service.setTime(vm.line.FinishTime)\" time-picker=\"\"></md-input-container><md-button translate=\"RESOURCEALLOCATION.SHIFT_TIME_SAVE\" class=\"md-raised md-accent\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.save()\"></md-button></form></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/linkItems/link-items-dialog.html","<md-dialog class=\"main-style\" flex=\"20\" flex-xs=\"25\" ng-cloak=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.LINK_ITEMS\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.dismissDialog()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\"><div layout=\"column\" flex=\"\"><form name=\"linkitem\" flex=\"\"><span class=\"md-body-1\">Asset</span><md-input-container class=\"md-block\"><input type=\"text\" readonly=\"\" ng-value=\"vm.data.ItemName\"></md-input-container><span class=\"md-body-1\">Allocated Asset</span><md-input-container class=\"md-block\"><input type=\"text\" readonly=\"\" ng-value=\"vm.data.AllocatedItemName\"></md-input-container><span class=\"md-body-1\">Operator</span><md-input-container class=\"md-block\"><input type=\"text\" readonly=\"\" ng-value=\"vm.operatorName || \'Not Yet Allocated\'\"></md-input-container><div class=\"md-body-2\">Linked Items</div><div ng-repeat=\"itm in vm.linkItemRows\"><div layout=\"row\"><md-select ng-model=\"itm.id\" name=\"type\" flex=\"90\" flex-gt-sm=\"90\" ng-change=\"vm.onLinkItemChange(itm)\"><md-option ng-if=\"itm.equipmentLists.length === 0\" value=\"\" disabled=\"\">No available items to link</md-option><md-option ng-repeat=\"item in itm.equipmentLists track by item.Id\" ng-value=\"item.Id\">{{item.ItemName}}({{(item.AllocatedId ? item.AllocatedItemName : \"Not Yet Allocated\" )}})</md-option></md-select><md-button class=\"md-icon-button btn-remove-linked-item\" ng-click=\"vm.removeLinkItem(itm)\" aria-label=\"remove\" flex=\"10\" flex-gt-sm=\"10\"><md-icon md-svg-icon=\"/assets/icons/x-icon.svg\"></md-icon></md-button></div><div class=\"linked-item-issue\" ng-class=\"{\'linked-item-issue--blocking\': !issue.IsValidToAllocate && !issue.CanBeOverriden, \'linked-item-issue--overridable\': !issue.IsValidToAllocate && issue.CanBeOverriden}\" ng-repeat=\"issue in vm.issuesByItemId[itm.id].Issues\">{{issue.Message}}</div></div><md-button md-no-ink=\"\" class=\"md-primary bnt-linked-item\" ng-click=\"vm.addLinkItemRow()\"><i class=\"icon icon-plus-box s35\"></i>&nbsp; Link an item</md-button></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"\" ng-click=\"vm.dismissDialog()\">Cancel</md-button><md-button class=\"md-raised md-accent\" ng-disabled=\"!vm.isLinkedItemChange || (!vm.canSave && !vm.canOverride)\" ng-click=\"vm.onSave()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/overrideReason/override-reason-dialog.html","<md-dialog class=\"main-style\" flex=\"35\" flex-xs=\"100\" ng-cloak=\"\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.OVERRIDE_REASON_TITLE\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onClose()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\"><div layout=\"column\" flex=\"\"><form name=\"overrideReason\" flex=\"\"><div>{{\'RESOURCEALLOCATION.OVERRIDE_REASON_MESSAGE\' | translate}}</div><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.overrideReason\" placeholder=\"{{\'RESOURCEALLOCATION.OVERRIDE_REASON_PLACEHOLDER\' | translate}}\" required=\"\"></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onDone()\" ng-disabled=\"overrideReason.$invalid\">{{\'RESOURCEALLOCATION.ALLOCATE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/shiftTagsDialog/shift-tags-dialog.html","<md-dialog class=\"shift-tags-dialog\" flex=\"45\" flex-xs=\"100\" flex-sm=\"100\" ng-cloak=\"\" block-ui=\"shift-tags-dialog\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCEALLOCATION.SHIFT_TAGS_MODAL_TITLE\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex=\"\"><div layout=\"column\" flex=\"\"><form name=\"shiftTags\" flex=\"\" layout=\"column\"><md-input-container class=\"tags-autocomplete\" flex=\"\"><md-autocomplete flex=\"auto\" md-input-name=\"ticketTags\" md-no-cache=\"true\" md-search-text=\"vm.searchText\" md-items=\"tag in vm.getTicketTags() | orderBy:[\'-NumberOfUsages\', \'Name\']\" md-selected-item-change=\"vm.addTag()\" md-selected-item=\"vm.selectedTag\" md-min-length=\"0\" md-floating-label=\"Tags\" md-menu-class=\"autocomplete-tags-template\"><md-item-template><span md-highlight-text=\"tag.searchText\" class=\"tag-item\">{{tag.Name}}</span></md-item-template></md-autocomplete></md-input-container><md-chips ng-model=\"vm.selectedTags\" md-autocomplete-snap=\"\" md-transform-chip=\"vm.onSelectTag($chip)\" md-require-match=\"true\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-no-cache=\"true\" md-items=\"item in vm.getTicketTags()\" md-item-text=\"item.Name\"><span md-highlight-text=\"vm.searchText\">{{item.Name}}</span></md-autocomplete><md-chip-template is-tag-active=\"{{vm.isTagActive($chip.Id)}}\"><span><strong>{{$chip.Name}}</strong></span></md-chip-template></md-chips><div align=\"right\"><span flex=\"\"></span><md-button translate=\"RESOURCEALLOCATION.SHIFT_TIME_SAVE\" class=\"margin-top-25 md-raised md-accent\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.save()\"></md-button></div></form></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/jobs/manage/components/OrderedByComponent/DivisionDropdownComponent/division-dropdown.html","<div flex=\"none\" flex-gt-sm=\"33\" flex-md=\"33\" flex-gt-md=\"33\" layout=\"column\"><md-autocomplete ng-if=\"(divisionDropdownComponentvm.ngService.isCloning || !divisionDropdownComponentvm.ngService.isEditMode) || ((!divisionDropdownComponentvm.ngService.jobModel.IsLocked && !divisionDropdownComponentvm.isTicketLockedByPreSchedule() && !divisionDropdownComponentvm.ngService.jobModel.IsCancelled) && divisionDropdownComponentvm.ngService.isEditMode)\" flex=\"\" md-input-name=\"Division\" md-no-cache=\"true\" md-selected-item=\"divisionDropdownComponentvm.ngModel\" md-search-text-change=\"divisionDropdownComponentvm.searchTextChange(divisionDropdownComponentvm.searchText)\" md-search-text=\"divisionDropdownComponentvm.searchText\" md-selected-item-change=\"divisionDropdownComponentvm.selectedItemChange(item)\" md-items=\"item in divisionDropdownComponentvm.querySearch(divisionDropdownComponentvm.searchText)\" md-escape-options=\"\" md-clear-button=\"true\" md-item-text=\"item.Name\" md-floating-label=\"{{ \'MANAGE.DIVISION\' | translate }}\" md-min-length=\"0\"><md-item-template><span md-highlight-text=\"divisionDropdownComponentvm.searchText\">{{item.Name}}</span></md-item-template><md-not-found><strong><span ng-if=\"divisionDropdownComponentvm.ngService.jobModel.Branch == null\">{{ \'MANAGE.DIVISIONNOTFOUNDNOBRANCH\' | translate }}</span> <span ng-if=\"divisionDropdownComponentvm.ngService.jobModel.Branch != null\">{{ \'MANAGE.DIVISIONNOTFOUND\' | translate }}</span></strong></md-not-found></md-autocomplete><md-input-container flex=\"\" ng-if=\"(divisionDropdownComponentvm.ngService.jobModel.IsLocked || divisionDropdownComponentvm.isTicketLockedByPreSchedule() || divisionDropdownComponentvm.ngService.jobModel.IsCancelled) && !divisionDropdownComponentvm.ngService.isCloning\"><input type=\"text\" placeholder=\"{{ \'MANAGE.DIVISION\' | translate }}\" ng-disabled=\"divisionDropdownComponentvm.ngService.isEditMode\" ng-model=\"divisionDropdownComponentvm.ngService.jobModel.Division.DivisionName\"></md-input-container></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/daily/dailyTicketFooter/daily-ticket-footer-rw.html","<section ng-if=\"!vm.allowGroupByClient && vm.whiteboardType == 3\" style=\"background-color: #f7f7f7;\"><div class=\"list-card-footer\"><div class=\"layout-row flex footer-containerx\"><div class=\"layout-row layout-align-start-start flex-90\"><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: pointer;\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled) || vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-view-list s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: pointer;\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-border-color s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" ng-if=\"vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\"><i class=\"icon-library-books s18 grey-900-fg\" ng-click=\"vm.goToFormsAndAttachment()\"></i><md-tooltip><span>Forms & Attachments</span></md-tooltip></div><div ng-if=\"vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: default; display: inline-block; margin-right: 8px;\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-account-multiple-plus s18 not-clickable-item grey-500-fg\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div ng-if=\"!vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.isLocked || vm.ticketType == 4\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-account-multiple-plus s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"!vm.isLocked && vm.ticketType != 4\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"!vm.isLocked\" ng-click=\"vm.openResourceAllocation(vm.id, vm.ticketNo, vm.parentTicketNo)\"></i> <i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"vm.isLocked\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.showSmartScheduling()\" ng-click=\"vm.preSchedule($event, vm.id)\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><md-icon class=\"smart-schedule grey-900-fg\" md-svg-icon=\"smart-schedule\"></md-icon><md-tooltip><span>Scheduling Copilot</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right:8px;\" ng-if=\"vm.disableTimesheet()\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\" ng-if=\"!vm.disableTimesheet()\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-calendar-clock s18 grey-900-fg\" ng-click=\"vm.openTimesheet(vm.id, vm.isLocked, vm.isLockedByPreSchedule, vm.ticketNo)\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: pointer;\" ng-if=\"vm.jobsClaims.hasCloneJobsPermission\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-content-copy s18 grey-900-fg\" ng-if=\"!vm.disableCloneTicket()\" ng-click=\"vm.cloneTicket(vm.id, vm.ticketNo)\"></i> <i class=\"icon-content-copy s18 grey-500-fg not-clickable-item\" ng-if=\"vm.disableCloneTicket()\"></i><md-tooltip><span>Clone</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-delete s18\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule)\" ng-click=\"vm.cancelTicket(vm.id, vm.ticketNo)\"></i> <i class=\"icon-delete s18 grey-500-fg not-clickable-item\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule)\"></i><md-tooltip><span>Cancel</span></md-tooltip></div></div><div class=\"layout-row\" layout-align=\"end-center\" flex=\"\"><md-menu md-offset=\"0 48px\" class=\"options card-pop-menu\"><md-button class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" aria-label=\"Options\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-disabled=\"vm.disableAddRelatedTicket()\" ng-click=\"vm.addRelatedTicket($event, vm.id)\" aria-label=\"Add Related Ticket\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span>Add Related Ticket</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPdf($event, vm.id)\" aria-label=\"Download PDF\"><md-icon md-font-icon=\"icon-file-pdf\" md-menu-align-target=\"\"></md-icon><span>Download Ticket PDF</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.claimsUtilService.isBillingEnabled()\"><md-button ng-disabled=\"vm.disabledTicketBillingPreference()\" ng-click=\"vm.addTicketBillingPref($event, vm.startDate, vm.id)\" aria-label=\"Ticket Billing Preference\"><md-icon md-font-icon=\"icon-document\" md-menu-align-target=\"\"></md-icon><span>Ticket Billing Preference</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.isMobileAppEnabled\"><md-button ng-click=\"vm.downloadTimesheetPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Timesheet PDF\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-calendar\" md-menu-align-target=\"\"></md-icon><span>Download Timesheet PDF</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.isMobileAppEnabled\"><md-button ng-click=\"vm.downloadPaperworkPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Paperwork PDF\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-file-document\" md-menu-align-target=\"\"></md-icon><span>Download Paperwork PDF</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></section>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/daily/dailyTicketInfo/daily-ticket-info-rw.html","<div class=\"list-card-details\" style=\"height: auto;\" ng-class=\"{\'daily-ticket-info-container-big\': vm.showProject == true, \'daily-ticket-info-container-small\': vm.showProject == true}\"><div class=\"list-card-name multiline-truncate\">{{vm.cardName}}</div><div class=\"list-card-badges layout-align-start-center\" ng-if=\"vm.allowGroupByClient\"><span class=\"grey-600-fg layout-align-start-center\"><strong>{{vm.ticketCount}}</strong>&nbsp;Ticket<span ng-if=\"vm.ticketCount > 1\">s</span></span></div><div class=\"list-card-badges layout-align-start-center layout-row\" ng-if=\"!vm.allowGroupByClient\"><div class=\"flex-100\"><span class=\"ticket-date layout-align-start-center layout-row\"><i class=\"icon-clock s16\"></i> &nbsp;&nbsp;{{vm.startDate}}</span></div></div><div class=\"list-card-badges layout-align-start-center\" ng-if=\"!vm.allowGroupByClient\"><span class=\"ticket-branch layout-align-start-center\">{{vm.branch}}</span></div><div class=\"list-card-address grey-600-fg padding-bottom-5\" ng-if=\"!vm.allowGroupByClient\"><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.AddressPrefix,vm.jobLocationAddress.UnitNumber,vm.jobLocationAddress.BldgName])\">{{vm.getAddress([vm.jobLocationAddress.AddressPrefix,vm.jobLocationAddress.UnitNumber,vm.jobLocationAddress.BldgName])}}</p><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.StreetNumber,vm.jobLocationAddress.StreetName])\">{{vm.getAddress([vm.jobLocationAddress.StreetNumber,vm.jobLocationAddress.StreetName])}}</p><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.Suburb,vm.jobLocationAddress.State,vm.jobLocationAddress.PostCode])\">{{vm.getAddress([vm.jobLocationAddress.Suburb,vm.jobLocationAddress.State,vm.jobLocationAddress.PostCode])}}</p><p class=\"address-line\" ng-if=\"vm.jobLocationAddress.Country != null\">{{vm.getAddress([vm.jobLocationAddress.Country])}}</p></div><div class=\"list-card-project grey-600-fg padding-bottom-5 multiline-truncate\" ng-if=\"!vm.allowGroupByClient && vm.showProject\"><span ng-if=\"vm.projectName != null\">{{vm.projectName}}</span> <span ng-if=\"vm.projectName == null\">[No Project]</span></div></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/daily/dailyTicketStatus/daily-ticket-status-rw.html","<div class=\"list-card-labels layout-row layout-align-center-center\" ng-if=\"vm.whiteboardType == 3 && !vm.allowGroupByClient\"><div class=\"list-card-label2 padding-right-10 flex\" ng-class=\"vm.getHeaderColorClass()\"><div class=\"daily-divStyle-left-pane\"><i class=\"icon-weather-sunny s16 grey-50-fg\" ng-if=\"vm.isDayShift\"></i> <i class=\"icon-weather-night s16 grey-50-fg\" ng-if=\"!vm.isDayShift\"></i></div><div class=\"daily-divStyle-right-pane\"><md-icon md-svg-icon=\"attachment-not-completed\" class=\"s16 margin-right-5 attachment-not-met\" ng-if=\"vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted\"></md-icon><md-icon md-svg-icon=\"attachment-completed\" class=\"s16 margin-right-5 attachment-met\" ng-if=\"vm.hasRequiredAttachments && vm.isRequiredAttachmentsCompleted\"></md-icon><md-icon class=\"smart-schedule-rw-top s16 margin-right-5\" md-svg-icon=\"smart-schedule-white\" ng-show=\"vm.status[0].abbrev == \'AIP\' || vm.status[0].abbrev == \'AID\' || vm.status[0].abbrev == \'AIR\' || vm.status[0].abbrev == \'AIC\'\"></md-icon><i class=\"icon-email s16 margin-right-5 grey-50-fg\" ng-show=\"vm.isEmailSent\"></i> <i class=\"icon-checkbox-marked-circle s16 grey-50-fg\" ng-if=\"vm.status[0].abbrev === \'C\' || vm.status[0].abbrev === \'R\'\"></i> <i class=\"icon-account-multiple s16 margin-right-5 grey-50-fg\" ng-if=\"vm.ticketType != 1 && vm.showRequireAllocationIcon && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-account-alert s16 margin-right-5 grey-50-fg\" ng-if=\"vm.ticketType != 1 && vm.showShiftAllocationIcon && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-truck s16 grey-50-fg\" ng-if=\"((vm.status[0].abbrev != \'C\' || vm.status[0].abbrev != \'R\') && vm.showEquipmentAllocationIcon) && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-link-variant icon-link-horizontal s16 margin-right-5 grey-50-fg\" ng-if=\"vm.hasUnlinkedRequiredItem() && vm.status[0].abbrev != \'CJPA\'\"></i></div></div></div><div class=\"list-card-labels layout-row layout-align-center-center\" ng-if=\"vm.allowGroupByClient\"><div ng-repeat=\"stat in vm.status track by $index\" class=\"list-card-label2 padding-right-10 flex\" style=\"height: 20px;\" ng-class=\"{\'md-red-bg\': stat.abbrev == \'AR\', \'md-blue-bg\': stat.abbrev == \'C\', \'md-green-bg\': stat.abbrev == \'R\', \'md-orange-bg\': stat.abbrev == \'A\'}\"><div class=\"daily-divStyle-left-pane\"></div><div class=\"daily-divStyle-right-pane\"></div></div></div>");
$templateCache.put("app/main/jobs/manage/components/OrderedByComponent/CompanyDropdownPopupComponent/company-dropdown-popup-manage-dialog.html","<md-dialog flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{manageCompanyDialogVm.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"manageCompanyDialogVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"companyManageDialogForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"column\"><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><input type=\"text\" placeholder=\"{{\'MANAGE.COMPANYPOPUPNAME\' | translate}}\" ng-model=\"manageCompanyDialogVm.companyName\" ng-required=\"true\" class=\"md-block\"></md-input-container></div><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><label translate=\"MANAGE.BRANCH\"></label><md-select name=\"branch\" ng-model=\"manageCompanyDialogVm.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'MANAGE.BRANCH\' | translate}}\" ng-required=\"true\" multiple=\"\"><md-option ng-repeat=\"branch in manageCompanyDialogVm.branches\" ng-value=\"branch\">{{branch.Name}}</md-option></md-select><div ng-messages=\"companyManageDialogForm.branch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MANAGE.BRANCHERROR\"></span></div></div></md-input-container></div><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><label translate=\"MANAGE.CREDITTYPE\"></label><md-select name=\"creditType\" ng-model=\"manageCompanyDialogVm.selectedCreditType\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{\'MANAGE.CREDITTYPE\' | translate}}\" ng-required=\"true\"><md-option ng-repeat=\"creditType in manageCompanyDialogVm.creditTypes\" ng-value=\"creditType\">{{creditType.Value}}</md-option></md-select><div ng-messages=\"companyManageDialogForm.creditType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MANAGE.CREDITTYPE_ERROR\"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"manageCompanyDialogVm.onCancel()\" translate=\"MANAGE.COMPANYPOPUPCANCELTEXT\"></md-button><md-button ng-click=\"manageCompanyDialogVm.onAdd()\" class=\"md-accent\" aria-label=\"{{manageCompanyDialogVm.saveButtonText}}\" ng-disabled=\"companyManageDialogForm.$invalid\">{{manageCompanyDialogVm.saveButtonText}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/manage/components/OrderedByComponent/CompanyDropdownPopupComponent/company-dropdown-popup.html","<div flex=\"none\" flex-gt-sm=\"100\" flex-md=\"100\" flex-gt-md=\"100\" layout=\"row\"><div flex=\"\" layout=\"row\"><md-input-container flex=\"\" ng-if=\"!companyDropDownPopUpComponentvm.selfService.is_client_inactive && (companyDropDownPopUpComponentvm.ngService.jobModel.IsLocked || companyDropDownPopUpComponentvm.isTicketLockedByPreSchedule() || companyDropDownPopUpComponentvm.ngService.jobModel.IsCancelled) && !companyDropDownPopUpComponentvm.ngService.isCloning\"><input type=\"text\" placeholder=\"{{ \'MANAGE.CLIENT\' | translate }}\" ng-disabled=\"companyDropDownPopUpComponentvm.ngService.isEditMode\" ng-model=\"companyDropDownPopUpComponentvm.ngModel.Name\"></md-input-container><md-input-container flex=\"\" ng-if=\"companyDropDownPopUpComponentvm.selfService.is_client_inactive && (companyDropDownPopUpComponentvm.ngService.jobModel.IsLocked || companyDropDownPopUpComponentvm.isTicketLockedByPreSchedule() || companyDropDownPopUpComponentvm.ngService.jobModel.IsCancelled) && !companyDropDownPopUpComponentvm.ngService.isCloning\"><input type=\"text\" placeholder=\"{{ \'MANAGE.CLIENT\' | translate }}\" ng-disabled=\"companyDropDownPopUpComponentvm.ngService.isEditMode\" ng-model=\"companyDropDownPopUpComponentvm.selfService.client_name\"></md-input-container><md-autocomplete ng-if=\"((companyDropDownPopUpComponentvm.ngService.isEditMode && (!companyDropDownPopUpComponentvm.ngService.jobModel.IsLocked && !companyDropDownPopUpComponentvm.isTicketLockedByPreSchedule() && !companyDropDownPopUpComponentvm.ngService.jobModel.IsCancelled)) || (!companyDropDownPopUpComponentvm.ngService.isEditMode && (!companyDropDownPopUpComponentvm.ngService.jobModel.IsLocked && !companyDropDownPopUpComponentvm.isTicketLockedByPreSchedule() && !companyDropDownPopUpComponentvm.ngService.jobModel.IsCancelled))) || (companyDropDownPopUpComponentvm.ngService.isCloning)\" ng-required=\"true\" ng-model-options=\"{ debounce: 500 }\" flex=\"\" md-input-name=\"Client\" md-no-cache=\"true\" md-selected-item=\"companyDropDownPopUpComponentvm.ngModel\" md-search-text-change=\"companyDropDownPopUpComponentvm.searchTextChange(companyDropDownPopUpComponentvm.searchText)\" md-search-text=\"companyDropDownPopUpComponentvm.searchText\" md-selected-item-change=\"companyDropDownPopUpComponentvm.selectedItemChange(item)\" md-items=\"item in companyDropDownPopUpComponentvm.querySearch(companyDropDownPopUpComponentvm.searchText)\" md-escape-options=\"\" md-clear-button=\"true\" md-item-text=\"item.Name\" md-floating-label=\"{{ \'MANAGE.CLIENT\' | translate }}\" md-min-length=\"companyDropDownPopUpComponentvm.minlength\"><md-item-template><span md-highlight-text=\"companyDropDownPopUpComponentvm.searchText\">{{item.Name}}</span></md-item-template><md-not-found><strong><span ng-if=\"companyDropDownPopUpComponentvm.ngService.jobModel.Branch == null\" translate=\"MANAGE.CLIENTNOTFOUNDNOBRANCH\"></span> <span ng-if=\"companyDropDownPopUpComponentvm.ngService.jobModel.Branch != null\"><a ng-click=\"companyDropDownPopUpComponentvm.reloadAll()\" translate=\"MANAGE.CLIENTNOTFOUND\"></a></span></strong></md-not-found></md-autocomplete><div layout=\"row\" layout-align=\"center center\" flex=\"1\" flex-sm=\"10\" ng-if=\"((companyDropDownPopUpComponentvm.ngService.isEditMode && (!companyDropDownPopUpComponentvm.ngService.jobModel.IsLocked && !companyDropDownPopUpComponentvm.isTicketLockedByPreSchedule() && !companyDropDownPopUpComponentvm.ngService.jobModel.IsCancelled)) || (!companyDropDownPopUpComponentvm.ngService.isEditMode && (!companyDropDownPopUpComponentvm.ngService.jobModel.IsLocked && !companyDropDownPopUpComponentvm.isTicketLockedByPreSchedule() && !companyDropDownPopUpComponentvm.ngService.jobModel.IsCancelled))) || (companyDropDownPopUpComponentvm.ngService.isCloning)\"><md-button ng-if=\"companyDropDownPopUpComponentvm.companyClaims.hasCreateNewCompanyMenu\" class=\"md-icon-button mr-0 ml-0\" data-nodrag=\"\" ng-click=\"companyDropDownPopUpComponentvm.showDialog(this)\" aria-label=\"Add new project\"><md-icon md-font-icon=\"icon-plus-box\" class=\"dp48\"></md-icon><md-tooltip><span translate=\"MANAGE.CLIENTMENUNEW\"></span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/jobs/manage/components/OrderedByComponent/ProjectDropdownPopupComponent/project-dropdown-popup-add-dialog.html","<md-dialog flex=\"25\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"MANAGE.PROJECTPOPUPNEW\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"addProjectDialogVm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"projectAddDialogForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div layout=\"column\"><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><input name=\"project\" type=\"text\" placeholder=\"{{ \'MANAGE.PROJECTPOPUPNAME\' | translate }}\" ng-model=\"addProjectDialogVm.newProject\" class=\"md-block\" ng-required=\"true\"><div ng-messages=\"projectAddDialogForm.project.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MANAGE.PROJECTPOPUPERROR\"></span></div></div></md-input-container></div><div flex=\"\" layout=\"column\"><md-input-container flex=\"\"><label>Branch</label><md-select name=\"branch\" ng-model=\"addProjectDialogVm.selectedBranches\" ng-model-options=\"{trackBy: \'$value.Id\'}\" placeholder=\"{{ \'MANAGE.BRANCH\' | translate }}\" multiple=\"true\" ng-required=\"true\"><md-option ng-repeat=\"branch in addProjectDialogVm.branches\" ng-value=\"branch\">{{branch.Name}}</md-option></md-select><div ng-messages=\"projectAddDialogForm.branch.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MANAGE.BRANCHERROR\"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"addProjectDialogVm.onCancel()\" translate=\"MANAGE.PROJECTPOPUPCANCELTEXT\"></md-button><md-button ng-click=\"addProjectDialogVm.onAdd()\" class=\"md-accent\" aria-label=\"Add\" ng-disabled=\"projectAddDialogForm.$invalid\" translate=\"MANAGE.PROJECTPOPUPSAVETEXT\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/manage/components/OrderedByComponent/ProjectDropdownPopupComponent/project-dropdown-popup.html","<div flex=\"none\" flex-gt-sm=\"100\" flex-md=\"100\" flex-gt-md=\"100\" layout=\"row\"><md-input-container flex=\"\" ng-if=\"(projectDropDownPopUpComponentvm.ngService.jobModel.IsLocked || projectDropDownPopUpComponentvm.isTicketLockedByPreSchedule() || projectDropDownPopUpComponentvm.ngService.jobModel.IsCancelled) && !projectDropDownPopUpComponentvm.ngService.isCloning\"><input type=\"text\" placeholder=\"{{ \'MANAGE.PROJECT\' | translate }}\" ng-disabled=\"projectDropDownPopUpComponentvm.ngService.isEditMode || !projectDropDownPopUpComponentvm.ngService.jobModel.Client\" ng-model=\"projectDropDownPopUpComponentvm.ngModel.Name\"></md-input-container><md-autocomplete ng-disabled=\"!projectDropDownPopUpComponentvm.ngService.jobModel.Client\" ng-if=\"(!projectDropDownPopUpComponentvm.ngService.jobModel.IsLocked && !projectDropDownPopUpComponentvm.isTicketLockedByPreSchedule() && !projectDropDownPopUpComponentvm.ngService.jobModel.IsCancelled) || projectDropDownPopUpComponentvm.ngService.isCloning\" ng-required=\"projectDropDownPopUpComponentvm.ngService.jobModel.Client.IsProjectMandatory\" flex=\"\" md-no-cache=\"projectDropDownPopUpComponentvm.noCache\" md-selected-item=\"projectDropDownPopUpComponentvm.ngModel\" md-search-text-change=\"projectDropDownPopUpComponentvm.searchTextChange(projectDropDownPopUpComponentvm.searchText)\" md-search-text=\"projectDropDownPopUpComponentvm.searchText\" md-selected-item-change=\"projectDropDownPopUpComponentvm.selectedItemChange(item)\" md-items=\"item in projectDropDownPopUpComponentvm.querySearch(projectDropDownPopUpComponentvm.searchText)\" md-item-text=\"item.Name\" md-min-length=\"0\" md-clear-button=\"true\" md-floating-label=\"{{ \'MANAGE.PROJECT\' | translate }}\"><md-item-template><span md-highlight-text=\"projectDropDownPopUpComponentvm.searchText\">{{item.Name}}</span></md-item-template><md-not-found><strong><span ng-if=\"projectDropDownPopUpComponentvm.ngService.jobModel.Branch == null\" translate=\"MANAGE.PROJECTNOTFOUNDNOBRANCH\"></span> <span ng-if=\"projectDropDownPopUpComponentvm.ngService.jobModel.Client == null\" translate=\"MANAGE.PROJECTNOTFOUNDNOCLIENT\"></span> <span ng-if=\"projectDropDownPopUpComponentvm.ngService.jobModel.Branch != null && projectDropDownPopUpComponentvm.ngService.jobModel.Client\" translate=\"MANAGE.PROJECTNOTFOUND\"></span></strong></md-not-found></md-autocomplete><div layout=\"row\" layout-align=\"center center\" flex=\"1\" flex-sm=\"10\" ng-if=\"projectDropDownPopUpComponentvm.canCreateProject() && !projectDropDownPopUpComponentvm.ngService.jobModel.IsLocked && !projectDropDownPopUpComponentvm.isTicketLockedByPreSchedule() && !projectDropDownPopUpComponentvm.ngService.jobModel.IsCancelled\"><md-button ng-if=\"projectDropDownPopUpComponentvm.thereIsAClient(projectDropDownPopUpComponentvm.client)\" class=\"md-icon-button mr-0 ml-0\" data-nodrag=\"\" ng-click=\"projectDropDownPopUpComponentvm.showDialog(this)\" aria-label=\"Add new project\"><md-icon md-font-icon=\"icon-plus-box\" class=\"dp48\"></md-icon><md-tooltip><span translate=\"MANAGE.PROJECTTOOLTIP\"></span></md-tooltip></md-button></div></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/weekly/ticketFooter/week-ticket-footer-rw.html","<section ng-if=\"!vm.allowGroupByClient && vm.whiteboardType == 3\" style=\"background-color: #f7f7f7;\"><div class=\"list-card-footer list-card-footer-weekly\"><div class=\"layout-row flex footer-containerx\"><div class=\"layout-row layout-align-start-start flex-90\"><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: pointer;\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled) || vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-view-list s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: pointer;\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-border-color s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" ng-if=\"vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\"><i class=\"icon-library-books s18 grey-900-fg\" ng-click=\"vm.goToFormsAndAttachment()\"></i><md-tooltip><span>Forms & Attachments</span></md-tooltip></div><div ng-if=\"vm.isUnConfirmedDate\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: default; display: inline-block; margin-right: 8px;\"><i class=\"icon-account-multiple-plus s18 not-clickable-item grey-500-fg\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div ng-if=\"!vm.isUnConfirmedDate\" style=\"display: flex; flex-direction: row;\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.isLocked || vm.ticketType == 4\"><i class=\"icon-account-multiple-plus s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"!vm.isLocked && vm.ticketType != 4\"><i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"!vm.isLocked\" ng-click=\"vm.openResourceAllocation(vm.id, vm.ticketNo, vm.parentTicketNo)\"></i> <i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"vm.isLocked\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.showSmartScheduling()\" ng-click=\"vm.preSchedule(vm.id)\"><md-icon class=\"smart-schedule grey-900-fg\" md-svg-icon=\"smart-schedule\"></md-icon><md-tooltip><span>Scheduling Copilot</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.isTimesheetDisabled()\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\" ng-if=\"!vm.isTimesheetDisabled()\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-calendar-clock s18 grey-900-fg\" ng-click=\"vm.openTimesheet(vm.id, vm.isLocked, vm.isLockedByPreSchedule, vm.ticketNo)\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" style=\"cursor: pointer;\" ng-if=\"vm.jobsClaims.hasCloneJobsPermission\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-content-copy s18 grey-900-fg\" ng-if=\"!(vm.isSmartSchedulingEnabled && vm.isLockedByPreSchedule)\" ng-click=\"vm.cloneTicket(vm.id, vm.ticketNo)\"></i> <i class=\"icon-content-copy s18 grey-500-fg\" ng-if=\"vm.isSmartSchedulingEnabled && vm.isLockedByPreSchedule\"></i><md-tooltip><span>Clone</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8 margin-top-8\" ng-hide=\"vm.ticket.status[0].abbrev == \'CJPA\'\"><i class=\"icon-delete s18\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\" ng-click=\"vm.cancelTicket(vm.id, vm.ticketNo)\"></i> <i class=\"icon-delete s18 grey-500-fg\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"></i><md-tooltip><span>Cancel</span></md-tooltip></div></div><div class=\"layout-row\" layout-align=\"end-center\" flex=\"\"><md-menu md-offset=\"0 48px\" class=\"options card-pop-menu\"><md-button class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" aria-label=\"Options\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-disabled=\"vm.disableAddRelatedTicket()\" ng-click=\"vm.addRelatedTicket($event, vm.id)\" aria-label=\"Add Related Ticket\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span>Add Related Ticket</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPdf($event, vm.id)\" aria-label=\"Download PDF\"><md-icon md-font-icon=\"icon-file-pdf\" md-menu-align-target=\"\"></md-icon><span>Download Ticket PDF</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.claimsUtilService.isBillingEnabled()\"><md-button ng-disabled=\"vm.disabledTicketBillingPreference()\" ng-click=\"vm.addTicketBillingPref($event, vm.startDate, vm.id)\" aria-label=\"Ticket Billing Preference\"><md-icon md-font-icon=\"icon-document\" md-menu-align-target=\"\"></md-icon><span>Ticket Billing Preference</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.isMobileAppEnabled\"><md-button ng-click=\"vm.downloadTimesheetPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Timesheet PDF\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-calendar\" md-menu-align-target=\"\"></md-icon><span>Download Timesheet PDF</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.isMobileAppEnabled\"><md-button ng-click=\"vm.downloadPaperworkPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Paperwork PDF\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-file-document\" md-menu-align-target=\"\"></md-icon><span>Download Paperwork PDF</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></section>");
$templateCache.put("app/main/jobs/manage/components/ResourceComponent/DroppableComponent/Droppable-Resource.html","<div layout=\"column\" id=\"droppable-resource\" flex=\"\" flex-xs=\"100\"><div class=\"md-whiteframe-2dp\" layout=\"column\" id=\"equipment-dropzone\" ng-class=\"{\'full\': droppableVm.ngService.jobModel.TicketType === 1}\" flex=\"\"><div droppable=\"\" droppable-function=\"droppableVm.dropped\" flex=\"\" class=\"form-wrapper scroll\" style=\"position: relative\"><md-card-content><div layout=\"row\" style=\"padding-top: 6px; padding-bottom: 10px;\"><div flex=\"70\" class=\"md-body-2\" translate=\"MANAGE.ASSET\" style=\"padding-left: 6px;\"></div><div flex=\"25\" class=\"md-body-2\" translate=\"MANAGE.QUANTITY\"></div><div flex=\"5\" class=\"md-body-2\"></div></div></md-card-content><md-divider></md-divider><dropped-asset-component ng-model=\"droppableVm.ngService.jobModel.Resource\" ng-service=\"droppableVm.ngService\" ng-style-height=\"{{droppableVm.ngService.jobModel.TicketType == 1 ? \'458px\' : \'184px\'}}\" ng-type=\"1\"></dropped-asset-component></div></div><div ng-if=\"droppableVm.ngService.jobModel.TicketType == 3 || droppableVm.ngService.jobModel.TicketType == 7 || droppableVm.ngService.jobModel.TicketType == \'6\'\" class=\"md-whiteframe-1dp\" layout=\"column\" id=\"people-dropzone\" flex=\"\"><div droppable=\"\" droppable-function=\"droppableVm.dropped\" flex=\"\" class=\"form-wrapper scroll\" style=\"position: relative\"><md-card-content><div layout=\"row\" id=\"company-header-content\" style=\"padding-top: 6px; padding-bottom: 10px;\"><div flex=\"70\" class=\"md-body-2\" translate=\"MANAGE.SHIFTTYPE\" style=\"padding-left: 6px;\"></div><div flex=\"25\" class=\"md-body-2\" translate=\"MANAGE.QUANTITY\"></div><div flex=\"5\" class=\"md-body-2\"></div></div><md-divider></md-divider></md-card-content><dropped-asset-component ng-model=\"droppableVm.ngService.jobModel.Resource\" ng-service=\"droppableVm.ngService\" ng-style-height=\"184px\" ng-type=\"4\"></dropped-asset-component></div></div></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/weekly/ticketInfo/week-ticket-info-rw.html","<div class=\"list-card-details\" ng-class=\"vm.contentInfoCss\"><div class=\"list-card-name multiline-truncate\">{{vm.cardName}}</div><div class=\"list-card-sort-handle\"><i class=\"icon s16 icon-cursor-move\"></i></div><div class=\"list-card-badges layout-align-start-center\" ng-if=\"vm.allowGroupByClient\"><span class=\"grey-600-fg layout-align-start-center\"><strong>{{vm.ticketCount}}</strong>&nbsp;Ticket<span ng-if=\"vm.ticketCount > 1\">s</span></span></div><div class=\"list-card-badges layout-align-start-center layout-row\" ng-if=\"!vm.allowGroupByClient\"><div class=\"flex\"><span class=\"ticket-date small-font layout-align-start-center layout-row\"><i class=\"icon-clock s16\"></i> {{vm.startDate}}</span></div></div><div class=\"list-card-badges layout-align-start-center multiline-truncate\" ng-if=\"!vm.allowGroupByClient\">{{vm.branch}}</div><div class=\"list-card-address grey-600-fg padding-bottom-5\" ng-if=\"!vm.allowGroupByClient\"><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.AddressPrefix,vm.jobLocationAddress.UnitNumber,vm.jobLocationAddress.BldgName])\">{{vm.getAddress([vm.jobLocationAddress.AddressPrefix,vm.jobLocationAddress.UnitNumber,vm.jobLocationAddress.BldgName])}}</p><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.StreetNumber,vm.jobLocationAddress.StreetName])\">{{vm.getAddress([vm.jobLocationAddress.StreetNumber,vm.jobLocationAddress.StreetName])}}</p><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.Suburb,vm.jobLocationAddress.State,vm.jobLocationAddress.PostCode])\">{{vm.getAddress([vm.jobLocationAddress.Suburb,vm.jobLocationAddress.State,vm.jobLocationAddress.PostCode])}}</p><p class=\"address-line\" ng-if=\"vm.jobLocationAddress.Country != null\">{{vm.getAddress([vm.jobLocationAddress.Country])}}</p></div><div class=\"list-card-project grey-500-fg padding-bottom-5 multiline-truncate\" ng-if=\"!vm.allowGroupByClient && vm.showProject\"><span ng-if=\"vm.projectName != null\">{{vm.projectName}}</span><span ng-if=\"vm.projectName == null\">[No Project]</span></div></div>");
$templateCache.put("app/main/jobs/resourceWhiteboard/wboard/weekly/ticketStatusDetails/ticket-status-details-rw.html","<div class=\"list-card-details-status\" ng-if=\"vm.whiteboardType == 3 && !vm.allowGroupByClient\"><div class=\"list-card-labels layout-row layout-align-center-center\"><div class=\"list-card-label2 padding-right-10 flex\" ng-class=\"vm.getHeaderColorClass()\"><div class=\"divStyle-left-pane\"><i class=\"icon-weather-sunny s16 grey-50-fg\" ng-if=\"vm.isDayShift\"></i> <i class=\"icon-weather-night s16 grey-50-fg\" ng-if=\"!vm.isDayShift\"></i></div><div class=\"divStyle-right-pane\"><md-icon md-svg-icon=\"attachment-not-completed\" class=\"s16 margin-right-5 attachment-not-met\" ng-if=\"vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted\"></md-icon><md-icon md-svg-icon=\"attachment-completed\" class=\"s16 margin-right-5 attachment-met\" ng-if=\"vm.hasRequiredAttachments && vm.isRequiredAttachmentsCompleted\"></md-icon><md-icon class=\"smart-schedule-rw-top s16 margin-right-5\" md-svg-icon=\"smart-schedule-white\" ng-show=\"vm.status[0].abbrev == \'AIP\' || vm.status[0].abbrev == \'AID\' || vm.status[0].abbrev == \'AIR\' || vm.status[0].abbrev == \'AIC\' && vm.status[0].abbrev != \'CJPA\'\"></md-icon><i class=\"icon-email s16 margin-right-5 grey-50-fg\" ng-show=\"vm.isEmailSent\"></i> <i class=\"icon-checkbox-marked-circle s16 grey-50-fg\" ng-if=\"(vm.status[0].abbrev === \'C\' || vm.status[0].abbrev === \'R\') && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-truck s16 grey-50-fg\" ng-if=\"((vm.status[0].abbrev != \'C\' || vm.status[0].abbrev != \'R\') && vm.showEquipmentAllocationIcon) && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-account-alert s16 margin-right-5 grey-50-fg\" ng-if=\"vm.ticketType != 1 && vm.showShiftAllocationIcon && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-account-multiple s16 margin-right-5 grey-50-fg\" ng-if=\"vm.ticketType != 1 && vm.showRequireAllocationIcon && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-link-variant icon-link-horizontal s16 margin-right-5 grey-50-fg\" ng-if=\"vm.hasUnlinkedRequiredItem() && vm.status[0].abbrev != \'CJPA\'\"></i></div></div></div></div><div class=\"list-card-labels layout-row layout-align-center-center\" ng-if=\"vm.allowGroupByClient\"><div ng-repeat=\"stat in vm.status track by $index\" class=\"list-card-label2 padding-right-10 flex\" style=\"height: 20px;\" ng-class=\"{\'md-red-bg\': stat.abbrev == \'AR\', \'md-blue-bg\': stat.abbrev == \'C\', \'md-green-bg\': stat.abbrev == \'R\', \'md-orange-bg\': stat.abbrev == \'A\'}\"><div class=\"daily-divStyle-left-pane\"></div><div class=\"daily-divStyle-right-pane\"></div></div></div>");
$templateCache.put("app/main/jobs/relatedTicketBillingPreferences/services/dialogs/multiDay/multi-day.html","<md-dialog flex=\"25\" class=\"single-day main-style\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex=\"\">{{\'RELATEDTICKETBILLINGPREFERENCES.CHANGE_BILLING\' | translate}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\" layout=\"column\"><form name=\"multiday\"><md-input-container class=\"md-block\"><label translate=\"RELATEDTICKETBILLINGPREFERENCES.ITEMS\"></label><md-select multiple=\"\" name=\"Items\" required=\"\" md-selected-text=\"vm.utils.getSelectedText(vm.model.Items, \'Items\', \'Name\')\" ng-model=\"vm.model.ItemIds\"><md-option ng-value=\"item.Id\" ng-repeat=\"item in vm.unique_items | orderBy : \'Name\'\">{{item.Name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" layout=\"row\"><label translate=\"RELATEDTICKETBILLINGPREFERENCES.START_DATE\"></label><md-datepicker ng-model=\"vm.model.StartDate\" required=\"\" name=\"Start\" class=\"md-block\" flex=\"\" md-date-filter=\"vm.filterStartDate\" md-open-on-focus=\"\" layout=\"row\"></md-datepicker></md-input-container><md-input-container flex=\"\" layout=\"row\"><label translate=\"RELATEDTICKETBILLINGPREFERENCES.END_DATE\"></label><md-datepicker ng-model=\"vm.model.EndDate\" name=\"End\" required=\"\" md-date-filter=\"vm.filterEndDate\" class=\"md-block\" flex=\"\" md-open-on-focus=\"\" layout=\"row\"></md-datepicker></md-input-container><md-input-container class=\"md-block\"><label translate=\"RELATEDTICKETBILLINGPREFERENCES.BILLING_PERIOD\"></label><md-select ng-model=\"vm.model.BillingPeriod\" name=\"Billing\" required=\"\"><md-option ng-value=\"billing\" ng-repeat=\"billing in vm.billing_periods\"><span><i ng-class=\"vm.getClass(billing.Name)\" style=\"margin-right : 5px; position : relative; top : 5px;\"></i></span> <span>{{billing.Name}}</span></md-option></md-select></md-input-container></form></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button ng-click=\"vm.save()\" class=\"md-raised md-accent\" ng-disabled=\"multiday.$invalid\" translate=\"RELATEDTICKETBILLINGPREFERENCES.SAVE\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/relatedTicketBillingPreferences/services/dialogs/singleDay/single-day.html","<md-dialog flex=\"35\" class=\"single-day related_ticket_billing\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"{{vm.header}}\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content block-ui=\"blockUI\" flex=\"\"><div layout=\"column\" ng-if=\"vm.activity === null\"><div layout=\"row\" layout-align=\"center center\" flex=\"\"><md-radio-group ng-change=\"vm.changeActivity(vm.activity)\" layout=\"row\" ng-model=\"vm.activity\"><md-radio-button value=\"0\" class=\"md-primary\">{{\'RELATEDTICKETBILLINGPREFERENCES.OPTION-CHANGE-BILLING\' | translate}}</md-radio-button><md-radio-button value=\"1\">{{\'RELATEDTICKETBILLINGPREFERENCES.OPTION-CHANGE-QUANTITY\' | translate}}</md-radio-button><md-radio-button value=\"2\">{{\'RELATEDTICKETBILLINGPREFERENCES.OPTION-DELETE\' | translate}}</md-radio-button></md-radio-group></div></div><div layout=\"column\" ng-if=\"vm.activity === \'2\'\"><table class=\"dataTable row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th translate=\"RELATEDTICKETBILLINGPREFERENCES.SINGLE_DAY_DIALOG_ITEM\"></th><th translate=\"RELATEDTICKETBILLINGPREFERENCES.DELETE\"></th></tr></thead><tbody><tr ng-repeat=\"item in vm.items_copy.Items\" style=\"height : 20px;\"><td>{{item.ItemName}}</td><td><md-button class=\"md-icon-button action-button\" ng-click=\"vm.deleteItem(item)\"><i class=\"icon icon-delete red-500-fg s35\"></i></md-button></td></tr></tbody></table></div><div layout=\"column\" ng-if=\"vm.activity === \'1\'\"><table class=\"table-qty dataTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th translate=\"RELATEDTICKETBILLINGPREFERENCES.SINGLE_DAY_DIALOG_ITEM\"></th><th translate=\"RELATEDTICKETBILLINGPREFERENCES.QUANTITY\"></th><th translate=\"RELATEDTICKETBILLINGPREFERENCES.UPDATE\"></th></tr></thead><tbody><tr ng-repeat=\"item in vm.items_copy.Items\"><td height=\"10\">{{item.ItemName}}</td><td height=\"10\"><md-input-container style=\"margin:0; padding: 0; position : relative; top : -7px\"><input type=\"number\" ng-model=\"item.ItemQuantity\"></md-input-container></td><td height=\"10\" layout=\"row\" layout-align=\"start center\"><div style=\"position : relative; top : 10px\"><md-button ng-if=\"!item.IsSaving && item.ItemQuantity > 0\" ng-click=\"vm.update(item)\" class=\"md-icon-button action-button\"><i class=\"icon icon-check blue-500-fg s35\"></i></md-button><md-progress-circular ng-if=\"item.IsSaving\" class=\"blue-500-fg\" md-diameter=\"20px\"></md-progress-circular></div></td></tr></tbody></table></div><div layout=\"column\" ng-if=\"vm.activity === \'0\'\"><table class=\"dataTable row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th width=\"10%\"></th><th width=\"50%\" translate=\"RELATEDTICKETBILLINGPREFERENCES.SINGLE_DAY_DIALOG_ITEM\"></th><th width=\"40%\" translate=\"RELATEDTICKETBILLINGPREFERENCES.BILLING_PERIOD\"></th></tr></thead><tbody><tr ng-repeat=\"item in vm.items_copy.ResourceItems\" style=\"height : 20px;\"><td width=\"10%\"><i ng-class=\"vm.classService.getMultiDayItemColor(item.ItemBillingName)\" style=\"position : relative; top : -2px;\"></i></td><td width=\"50%\">{{item.ItemName}}</td><td width=\"40%\"><md-input-container style=\"margin : 0; padding : 0\" class=\"md-block\" flex=\"\"><md-select flex=\"\" class=\"md-block\" ng-model=\"item.ItemId\" ng-change=\"vm.changeBilling(item)\" ng-model-options=\"{trackBy : \'$value\'}\" placeholder=\"{{\'RELATEDTICKETBILLINGPREFERENCES.SINGLE_DAY_DIALOG_BILLING\' | translate}}\"><md-option ng-value=\"billing.ItemId\" ng-repeat=\"billing in vm.billing_periods\">{{billing.Name}}</md-option></md-select></md-input-container></td></tr></tbody></table><div flex=\"\" layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.updateSingle()\" class=\"md-raised md-accent\">Save</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/components/filter/filter-whiteboard.html","<div layout=\"row\" flex=\"\" class=\"jobs-whiteboard-filter-container\"><div layout=\"column\" flex=\"\"><div layout=\"row\" flex=\"\" style=\"flex-flow: row wrap;\"><div class=\"jobs-whiteboard-filter-item\"><md-input-container flex=\"\"><md-select placeholder=\"Grouping\" ng-model=\"vm.selectedTicketsGroupingId\"><md-option value=\"\">&nbsp;</md-option><md-option ng-value=\"grouping.Id\" ng-repeat=\"grouping in vm.filterGrouping\">{{ grouping.Text }}</md-option></md-select></md-input-container></div><div class=\"jobs-whiteboard-filter-item filter-branches\" ng-if=\"vm.branches.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"vm.getFilterPlaceholder(\'Branches\', vm.selectedBranchIds)\" ng-model=\"vm.selectedBranchIds\"><md-option ng-value=\"branch.Id\" ng-repeat=\"branch in vm.branches\">{{ branch.Name }}</md-option></md-select></md-input-container></div><div class=\"jobs-whiteboard-filter-item filter-states\" ng-if=\"vm.states.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"vm.getFilterPlaceholder(\'States\', vm.selectedStateIds)\" ng-model=\"vm.selectedStateIds\"><md-option ng-value=\"state.id\" ng-repeat=\"state in vm.states\">{{ state.value }}</md-option></md-select></md-input-container></div><div class=\"jobs-whiteboard-filter-item filter-timeofday\" ng-if=\"vm.filterTimeOfDay.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"vm.getFilterPlaceholder(\'Time of Day\', vm.selectedTimeOfDayIds)\" ng-model=\"vm.selectedTimeOfDayIds\"><md-option ng-value=\"time.Id\" ng-repeat=\"time in vm.filterTimeOfDay\">{{ time.Text }}</md-option></md-select></md-input-container></div><div class=\"jobs-whiteboard-filter-item filter-include-tags\" ng-if=\"vm.tags.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"vm.getFilterPlaceholder(\'Included Tags\', vm.selectedIncludedTags)\" ng-model=\"vm.selectedIncludedTags\" md-container-class=\"tags-filter-dropdown-whiteboard\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchText\" type=\"search\" aria-label=\"\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"vm.querySearchTag($event)\" autofocus=\"\"></md-select-header><md-option ng-value=\"tag.Id\" ng-repeat=\"tag in vm.tags | filter:{Name: vm.searchText}\" ng-disabled=\"tag.excluded\">{{ tag.Name }}</md-option></md-select></md-input-container></div><div class=\"jobs-whiteboard-filter-item filter-exclude-tags\" ng-if=\"vm.tags.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"vm.getFilterPlaceholder(\'Excluded Tags\', vm.selectedExcludedTags)\" ng-model=\"vm.selectedExcludedTags\" md-container-class=\"tags-filter-dropdown-whiteboard\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchText\" type=\"search\" aria-label=\"\" class=\"demo-header-searchbox _md-text\" ng-keydown=\"vm.querySearchTag($event)\" autofocus=\"\"></md-select-header><md-option ng-value=\"tag.Id\" ng-repeat=\"tag in vm.tags | filter:{Name: vm.searchText}\" ng-disabled=\"tag.included\">{{ tag.Name }}</md-option></md-select></md-input-container></div><div class=\"jobs-whiteboard-filter-item filter-ticketTypes\" ng-if=\"vm.ticketTypes.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"vm.getFilterPlaceholder(\'Ticket Types\', vm.selectedTicketTypeIds)\" ng-model=\"vm.selectedTicketTypeIds\"><md-option ng-value=\"type.Id\" ng-repeat=\"type in vm.ticketTypes\">{{ type.Text }}</md-option></md-select></md-input-container></div><div class=\"jobs-whiteboard-filter-item filter-timesheet-submission-types\" ng-if=\"vm.timesheetSubmissionTypes.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"vm.getFilterPlaceholder(\'Timesheet Submissions\', vm.selectedTimesheetSubmissionTypeIds)\" ng-model=\"vm.selectedTimesheetSubmissionTypeIds\"><md-option ng-value=\"type.Id\" ng-repeat=\"type in vm.timesheetSubmissionTypes\">{{ type.Text }}</md-option></md-select></md-input-container></div><div class=\"jobs-whiteboard-filter-item filter-ticket-status\" ng-if=\"vm.ticketStatus.length > 0\"><md-input-container><md-select multiple=\"\" md-selected-html=\"vm.getFilterPlaceholder(\'Ticket Status\', vm.selectedTicketStatus)\" ng-model=\"vm.selectedTicketStatus\"><md-option ng-value=\"type.Id\" ng-repeat=\"type in vm.ticketStatus\">{{ type.Text }}</md-option></md-select></md-input-container></div></div><div layout=\"row\"><div class=\"chips-fields\" ng-if=\"vm.selectedShowHideFilters.length > 0\"><md-chips ng-model=\"vm.selectedShowHideFilters\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"Fields\"><md-chip-template><span>{{vm.convertStartCase($chip)}}</span></md-chip-template></md-chips></div><div class=\"chips-branches\" ng-if=\"vm.selectedBranchIds.length > 0\"><md-chips ng-model=\"vm.selectedBranchIds\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"Branches\"><md-chip-template><span>{{vm.getSelectedBranchName($chip)}}</span></md-chip-template></md-chips></div><div class=\"chips-states\" ng-if=\"vm.selectedStateIds.length > 0\"><md-chips ng-model=\"vm.selectedStateIds\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"States\"><md-chip-template><span>{{$chip}}</span></md-chip-template></md-chips></div><div class=\"chips-timeofday\" ng-if=\"vm.selectedTimeOfDayIds.length > 0\"><md-chips ng-model=\"vm.selectedTimeOfDayIds\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"Time Of Day\"><md-chip-template><span>{{vm.convertStartCase($chip)}}</span></md-chip-template></md-chips></div><div class=\"chips-include-tags\" ng-if=\"vm.selectedIncludedTags.length > 0\"><md-chips ng-model=\"vm.selectedIncludedTags\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"Include Tags\"><md-chip-template><span>{{vm.getTagName($chip)}}</span></md-chip-template></md-chips></div><div class=\"chips-exclude-tags\" ng-if=\"vm.selectedExcludedTags.length > 0\"><md-chips ng-model=\"vm.selectedExcludedTags\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"Exclude Tags\"><md-chip-template><span>{{vm.getTagName($chip)}}</span></md-chip-template></md-chips></div><div class=\"chips-ticketTypes\" ng-if=\"vm.selectedTicketTypeIds.length > 0\"><md-chips ng-model=\"vm.selectedTicketTypeIds\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"Ticket Types\"><md-chip-template><span>{{vm.convertStartCase($chip)}}</span></md-chip-template></md-chips></div><div class=\"chips-timesheet-submission-types\" ng-if=\"vm.selectedTimesheetSubmissionTypeIds.length > 0\"><md-chips ng-model=\"vm.selectedTimesheetSubmissionTypeIds\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"Timesheet filter-timesheet-submission-types\"><md-chip-template><span>{{vm.convertStartCase($chip)}}</span></md-chip-template></md-chips></div><div class=\"chips-ticket-status\" ng-if=\"vm.selectedTicketStatus.length > 0\"><md-chips ng-model=\"vm.selectedTicketStatus\" md-removable=\"true\" readonly=\"true\" md-enable-chip-edit=\"false\" input-aria-label=\"Timesheet filter-timesheet-submission-types\"><md-chip-template><span>{{vm.convertStartCase($chip)}}</span></md-chip-template></md-chips></div></div><div class=\"row\"><span class=\"select-apply-button\" translate=\"WHITEBOARD.SELECT_APPLY_BUTTON\" ng-if=\"vm.cardFilters.hasFilterToApply\"></span></div></div><div class=\"mr-15\" flex=\"10\" layout=\"column\"><md-button class=\"md-raised md-accent button-margin\" ng-click=\"vm.onApplyFilter()\" ng-disabled=\"!vm.cardFilters.hasFilterToApply\">Apply</md-button><md-button class=\"md-raised button-margin\" ng-click=\"vm.clearFilters()\">Clear</md-button></div></div>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/dialogs/cardTicketDialog/card-ticket-dialog.html","<md-dialog id=\"company-card-ticket-list\" aria-label=\"Ticket Company View\" flex=\"60\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span class=\"truncate-500\">{{::vm.model.data.CompanyName}} {{::vm.model.data.Tickets.length > 1 ? \' - Tickets\' : \' - Ticket\'}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"\"><label>{{vm.nameLabel}}</label> <input type=\"text\" name=\"companyName\" ng-model=\"::vm.model.data.CompanyName\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"\"><label>Number of Tickets</label> <input type=\"number\" name=\"ticketCount\" ng-model=\"::vm.model.data.TicketCount\" ng-disabled=\"true\"></md-input-container></div></md-content><md-content><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ticket #</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ticket Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Branch</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text action-column\"><span class=\"column-title\">Actions</span></th></tr></thead><tbody><tr ng-repeat=\"item in ::vm.model.data.Tickets\" ng-dblclick=\"vm.viewJobDetails(item.Id)\"><td>{{ item.TicketNumber }}</td><td>{{ vm.model.getTicketTypeName(item.TicketType) }}</td><td>{{ item.BranchName }}</td><td>{{ vm.model.convertToJsDate(item.StartDate) }}</td><td>{{ vm.model.convertToJsDate(item.EndDate) }}</td><td class=\"job-ticket-badges\"><div class=\"badge padding-2\" ng-class=\"\'md-\'+item.StatusInfo.color+\'-bg\'\" layout=\"row\" layout-align=\"center center\"><span>{{item.StatusInfo.name}}</span></div></td><td class=\"actions text-right\" layout-align=\"center center\"><md-button class=\"md-icon-button\" aria-label=\"Edit\" translate=\"\" translate-attr-aria-label=\"ASSETSMODULE.EDIT\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.viewJobDetails(item.Id)\"><md-icon md-font-icon=\"icon-document s18\"></md-icon><md-tooltip><span>View Ticket Details</span></md-tooltip></md-button></td></tr></tbody></table></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onCancel()\">Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/dialogs/jobDetailDialog/job-detail-dialog.html","<md-dialog id=\"job-datail-dialog\" aria-label=\"Job Detail View\" flex=\"60\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.onBack()\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle s22\"></md-icon><md-tooltip><span>Back to Ticket Details</span></md-tooltip></md-button><h2>Job Details</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"TicketCompanyForm\" class=\"md-inline-form\" novalidate=\"\"><md-dialog-content><div class=\"form-wrapper\" flex=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><span class=\"md-headline\" layout-align=\"start center\">Energex</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>Project</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.model.companyName\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><label>Branch</label> <input type=\"number\" name=\"percentPerYear\" ng-model=\"vm.model.numberOfTickets\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><label>Division</label> <input type=\"number\" name=\"percentPerYear\" ng-model=\"vm.model.numberOfTickets\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"md-whiteframe-2dp padding-10\" flex=\"\"><md-input-container><label>Job Start Date</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.model.companyName\" ng-disabled=\"true\"></md-input-container><md-input-container><label>Job Finish Date</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.model.companyName\" ng-disabled=\"true\"></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onBack()\">Back</md-button><md-button ng-click=\"vm.onCancel()\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/dialogs/ticketDetailDialog/ticket-detail-dialog.html","<md-dialog class=\"ticket-detail-dialog\" aria-label=\"Ticket Detail View\" flex=\"60\" ng-cloak=\"\"><md-toolbar layout=\"column\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.onBack()\" ng-show=\"vm.showBack\" ng-cloak=\"\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle s22\"></md-icon><md-tooltip><span>Back to Ticket List</span></md-tooltip></md-button><span class=\"md-headline margin-left-2\">Ticket #{{ vm.model.TicketNumber }}</span> <span class=\"md-headline margin-left-20 truncate-500\">{{ vm.model.CompanyName }}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"30\"><label>Ticket Type</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.model.TicketTypeDesc\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"padding-bottom-0 margin-bottom-0\"><label>Start Date</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.model.StartDate\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"padding-bottom-0 margin-bottom-0\"><label>End Date</label> <input type=\"text\" name=\"projectName\" ng-model=\"vm.model.EndDate\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"80\"><label>Job Location</label> <input type=\"text\" name=\"jobLocation\" ng-model=\"vm.model.JobLocationAddress.FullAddress\" ng-disabled=\"true\"></md-input-container></div><md-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"40\"><label>Person Ordering</label> <input type=\"text\" name=\"contactName\" ng-model=\"vm.model.ClientName\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"20\"><label>Phone</label> <input type=\"text\" name=\"contactName\" ng-model=\"vm.model.ClientPhone\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"30\"><label>Email</label> <input type=\"text\" name=\"contactName\" ng-model=\"vm.model.ClientEmail\" ng-disabled=\"true\"></md-input-container></div></md-content><md-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"40\"><label>Site Contact</label> <input type=\"text\" name=\"contactName\" ng-model=\"vm.model.SiteContactName\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"20\"><label>Phone</label> <input type=\"text\" name=\"contactName\" ng-model=\"vm.model.SiteContactPhone\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"padding-bottom-0 margin-bottom-0\" flex=\"30\"><label>Email</label> <input type=\"text\" name=\"contactName\" ng-model=\"vm.model.SiteContactEmail\" ng-disabled=\"true\"></md-input-container></div></md-content><md-content><md-input-container class=\"padding-bottom-0 margin-bottom-0 md-block\"><label>Job Details</label> <textarea type=\"text\" style=\"color : black\" name=\"contactName\" ng-model=\"vm.model.JobDetails\" md-maxlength=\"150\" rows=\"2\" ng-disabled=\"true\"></textarea></md-input-container><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Resource</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Allocation</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Time</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End Time</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Equipment / Operator</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.model.AllocatedResourceItems\"><td>{{ item.Resource }}</td><td>{{ item.Allocation || item.AllocatedCode }}</td><td>{{ vm.convertTime(item.StartTime) }}</td><td>{{ vm.convertTime(item.EndTime) }}</td><td>{{ item.EquipmentOrOperator }}</td></tr><tr ng-repeat=\"item in vm.model.ResourceItems | filter: { IsAllocatable: false}\"><td>{{ item.ItemName }} x {{ item.ItemQuantity}}</td><td></td><td></td><td></td><td></td></tr></tbody></table></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.viewHistory(vm.model.id, vm.model.TicketNumber)\">View History</md-button><md-button ng-hide=\"vm.hideButtons\" class=\"md-raised md-accent\" ng-click=\"vm.Edit(vm.model.id, vm.model.TicketNumber, vm.model.ParentTicketNumber)\"><span ng-if=\"vm.model.IsLocked === false || (vm.model.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled) === false\">Edit Ticket</span> <span ng-if=\"vm.model.IsLocked === true || (vm.model.IsLockedByPreSchedule && vm.isSmartSchedulingEnabled) == true\">View Ticket</span></md-button><md-button ng-hide=\"vm.hideButtons\" class=\"md-raised md-accent\" ng-disabled=\"vm.model.IsUnconfirmedDate || vm.model.IsLocked || vm.model.TicketType === 4\" ng-click=\"vm.onOpenAllocateResource(vm.model.id, vm.model.TicketNumber)\">Allocate Resource</md-button><md-button ng-hide=\"vm.hideButtons\" class=\"md-raised md-accent\" ng-disabled=\"vm.model.IsUnconfirmedDate || vm.model.TicketType === 1 || vm.model.TicketType === 4 || vm.isPendingApproval\" ng-click=\"vm.onOpenTimesheet(vm.model, vm.model.IsLocked)\"><span ng-if=\"vm.model.IsLocked === false\">Edit Timesheet</span> <span ng-if=\"vm.model.IsLocked === true\">View Timesheet</span></md-button><md-button ng-if=\"vm.jobsClaims.hasCloneJobsPermission\" ng-hide=\"vm.hideButtons\" class=\"md-raised md-accent\" ng-disabled=\"vm.isPendingApproval\" ng-click=\"vm.cloneTicket(vm.model.id, vm.model.TicketNumber)\">Clone</md-button><md-button ng-hide=\"vm.hideButtons\" class=\"md-raised md-accent\" ng-click=\"vm.printPDF(vm.model.id)\">Print PDF</md-button><md-button ng-disabled=\"vm.model.IsLocked\" class=\"md-raised md-accent\" ng-click=\"vm.onBack()\" ng-show=\"vm.showBack\">Back</md-button><md-button ng-click=\"vm.onCancel()\">Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/paperworkExceptions/directives/mainView/gridContainer/dynamicGrid/dynamic-grid.html","<md-whiteframe class=\"main-style md-whiteframe-5dp dynamic-grid\" layout=\"column\" flex=\"\" layout-margin=\"\" layout-padding=\"\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-title\" ng-if=\"vm.media.isDeviceBig()\">{{vm.item.ReportTypeName}}</span> <span class=\"md-subhead text-bold\" ng-if=\"vm.media.isDeviceSmall()\">{{vm.item.ReportTypeName}}</span> <span><span class=\"ml-16 text-boxed blue-bg white-fg\">{{vm.item.DataRows.length}} {{\'PAPERWORK_EXCEPTION.ITEMS\' | translate}}</span></span></div><md-divider ng-if=\"vm.media.isDevice1426()\"></md-divider><div ng-if=\"vm.media.isDeviceLessThan1426()\" layout=\"column\" class=\"flex-100\"><small-paper-work-table flex=\"\" rows=\"vm.item.DataRows\" converttime=\"vm.convertTime\" showdialog=\"vm.showDetailsReact\" showtimesheet=\"vm.queryTimeSheetReact\" gototimesheet=\"vm.goToTimesheetReact\" downloadpdf=\"vm.downloadPDFReact\" handlechange=\"vm.handle\" headers=\"vm.item.HeaderColumns\"></small-paper-work-table></div><div class=\"flex-100\" style=\"margin-top : -50px\" ng-if=\"vm.media.isDevice1426()\"><large-paper-work-table flex=\"\" rows=\"vm.item.DataRows\" converttime=\"vm.convertTime\" showdialog=\"vm.showDetailsReact\" showtimesheet=\"vm.queryTimeSheetReact\" gototimesheet=\"vm.goToTimesheetReact\" downloadpdf=\"vm.downloadPDFReact\" handlechange=\"vm.handle\" headers=\"vm.item.HeaderColumns\"></large-paper-work-table></div></md-whiteframe>");
$templateCache.put("app/main/company/create/companyDetails/Skills/templates/add/company-skill.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form name=\"companySkillForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"COMPANYMODULE.SKILLS_COMPANY_SKILLS\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.skill\" placeholder=\"{{\'COMPANYMODULE.SKILLS_COLUMN_SKILL\' | translate}}\" required=\"\"><md-option ng-repeat=\"skill in vm.currentSkills\" ng-value=\"skill\">{{skill.SkillName}}</md-option></md-select></md-input-container><md-input-container><md-select ng-model=\"vm.lockout\" placeholder=\"Lockout Type\" required=\"\"><md-option value=\"0\">{{\'COMPANYMODULE.SKILLS_NO_LOCKOUT\' | translate}}</md-option><md-option value=\"1\">{{\'COMPANYMODULE.SKILLS_SOFT_LOCKOUT\' | translate}}</md-option><md-option value=\"2\">{{\'COMPANYMODULE.SKILLS_MEDIUM_LOCKOUT\' | translate}}</md-option><md-option value=\"3\">{{\'COMPANYMODULE.SKILLS_HARD_LOCKOUT\' | translate}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button translate=\"COMPANYMODULE.SAVE\" class=\"md-raised md-accent\" ng-click=\"vm.addSkill(1)\" ng-disabled=\"companySkillForm.$invalid\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/company/create/companyDetails/Skills/templates/edit/company-skill.html","<md-dialog id=\"contact-create-company\" aria-label=\"Contact Company\" flex=\"25\" ng-cloak=\"\"><form name=\"CompanySkillForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"COMPANYMODULE.SKILLS_COMPANY_SKILLS\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><md-select ng-model=\"vm.skill\" placeholder=\"{{\'COMPANYMODULE.SKILLS_COLUMN_SKILL\' | translate}}\" ng-model-options=\"{trackBy : \'$value.Id\'}\" required=\"\"><md-option ng-repeat=\"skill in vm.currentSkills\" ng-value=\"skill\">{{skill.SkillName}}</md-option></md-select></md-input-container><md-input-container><md-select ng-model=\"vm.lockout\" placeholder=\"Lockout Type\" required=\"\"><md-option value=\"0\">{{\'COMPANYMODULE.SKILLS_NO_LOCKOUT\' | translate}}</md-option><md-option value=\"1\">{{\'COMPANYMODULE.SKILLS_SOFT_LOCKOUT\' | translate}}</md-option><md-option value=\"2\">{{\'COMPANYMODULE.SKILLS_MEDIUM_LOCKOUT\' | translate}}</md-option><md-option value=\"3\">{{\'COMPANYMODULE.SKILLS_HARD_LOCKOUT\' | translate}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button translate=\"COMPANYMODULE.SAVE\" ng-click=\"vm.addSkill(1)\" class=\"ma-raised md-accent\" ng-disabled=\"CompanySkillForm.$invalid\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/customFieldsManager/views/directives/utils/editorSection/footerSection/editor-footer-section.html","<div layout=\"column\" style=\"margin-top : 30px;\" flex=\"\"><md-divider></md-divider><div ng-if=\"(vm.field.FieldType === 0 && vm.has_validation)\" layout=\"row\" flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input ng-disabled=\"vm.service.saving\" required=\"\" ng-model=\"vm.field.ValidationRegexPattern\" type=\"text\" placeholder=\"Regex Pattern\"></md-input-container></div><div ng-if=\"(vm.field.FieldType === 3 && vm.has_validation)\" layout=\"row\" flex=\"\"><md-input-container flex=\"\" class=\"md-block\"><input ng-disabled=\"vm.service.saving\" required=\"\" ng-model=\"vm.field.MinValue\" type=\"text\" placeholder=\"Min Value\"></md-input-container><md-input-container flex=\"\" class=\"md-block\"><input ng-disabled=\"vm.service.saving\" required=\"\" ng-model=\"vm.field.MaxValue\" type=\"text\" placeholder=\"Max Value\"></md-input-container></div><div flex=\"\" layout=\"row\" style=\"margin-top : 10px;\"><div flex=\"\" layout=\"row\" layout-align=\"end center\"><div style=\"height : auto;\" flex=\"50\" layout=\"column\"><div ng-if=\"vm.field.FieldType === 0 || vm.field.FieldType === 3\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div layout=\"row\" layout-align=\"start center\"><md-switch ng-disabled=\"vm.service.saving\" ng-change=\"vm.changeValidation()\" ng-model=\"vm.has_validation\"></md-switch></div><div layout=\"row\" layout-align=\"start center\" class=\"md-body-2\" flex=\"70\">Validate</div></div><div layout=\"row\" ng-if=\"!(vm.field.FieldType === 2 || vm.field.FieldType === 12)\" layout-align=\"start center\" flex=\"\"><div layout=\"row\" layout-align=\"start center\"><md-switch ng-disabled=\"vm.service.saving\" ng-model=\"vm.field.IsRequired\"></md-switch></div><div layout=\"row\" layout-align=\"start center\" class=\"md-body-2\" flex=\"70\">Required</div></div><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div layout=\"row\" layout-align=\"start center\"><md-switch ng-disabled=\"vm.service.saving\" ng-model=\"vm.field.IsVisible\"></md-switch></div><div layout=\"row\" layout-align=\"start center\" class=\"md-body-2\" flex=\"70\">Display on Details</div></div></div><div flex=\"50\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-md=\"column\" layout-align=\"center center\"><div ng-if=\"!vm.service.saving\" layout=\"row\" layout-align=\"end center\" flex=\"\" layout-padding=\"\"><div style=\"height : 50px; background-color: #475A64; width : 100px; max-width : 100px;\" layout=\"row\" class=\"md-whiteframe-3dp\" layout-align=\"center center\" layout-padding=\"\"><div ng-if=\"vm.form.$valid\"><i ng-click=\"vm.save(vm.field)\" style=\"color : white; cursor : pointer\" class=\"icon icon-content-save\"><md-tooltip>Save</md-tooltip></i></div><div><i ng-click=\"vm.closeForm()\" style=\"color : white; cursor : pointer\" class=\"icon icon-close-circle s25\"><md-tooltip>Cancel</md-tooltip></i></div></div></div></div></div></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/utils/editorSection/headerSection/editor-header-section.html","<div layout=\"column\" flex=\"\"><div ng-if=\"vm.service.saving\" flex=\"\" layout=\"row\"><div flex=\"5\"><md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular></div><div class=\"md-body 2\" flex=\"\">Saving ...</div></div><md-progress-linear style=\"margin-top : 10px;\" ng-if=\"vm.service.saving\" class=\"md-hue-2\" md-mode=\"indeterminate\"></md-progress-linear><div layout=\"column\" flex=\"\"><div layout-align=\"space-between center\" layout-align-md=\"center stretch\" layout-align-sm=\"center stretch\" layout-align-xs=\"center stretch\" flex=\"\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-md=\"column\"><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-md=\"100\" class=\"md-headline\"><md-input-container md-select-on-focus=\"\" md-no-float=\"\" class=\"md-block\"><input ng-disabled=\"vm.service.saving\" required=\"\" md-select-on-focus=\"\" ng-model=\"vm.field.FieldTitle\" placeholder=\"Field Title\" type=\"text\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-md=\"100\" layout=\"row\" flex=\"50\"><div flex=\"95\" flex-sm=\"100\" flex-xs=\"100\" flex-md=\"100\"><md-input-container style=\"background-color: #F5F5F5\" md-no-float=\"\" class=\"md-block\"><md-select ng-disabled=\"vm.service.saving\" aria-label=\"Field Type\" ng-change=\"vm.changeFields(vm.field.FieldType)\" required=\"\" class=\"md-body-2 inline-flex md-select-down\" ng-model=\"vm.field.FieldType\"><md-option style=\"background-color: #F5F5F5\" ng-value=\"field.Id\" ng-repeat=\"field in vm.field_types\"><span style=\"margin-left : 10px;\"><i style=\"position : relative; top : 3px;\" class=\"{{field.Icon}}\"></i> <b style=\"margin-left : 10px;\">{{field.Name}}</b></span></md-option></md-select></md-input-container></div></div></div><div style=\"margin-top : -15px;\" layout=\"row\" flex=\"\"><div flex=\"\"><md-input-container md-no-float=\"\" class=\"md-block\"><input ng-disabled=\"vm.service.saving\" ng-model=\"vm.field.Description\" placeholder=\"Description\" type=\"text\"></md-input-container></div></div><div ng-if=\"vm.field.AvailableFor != 3\" style=\"margin-top : -25px;\" layout=\"row\" flex=\"\"><div flex=\"\"><md-input-container md-no-float=\"\" class=\"md-block\"><md-select ng-disabled=\"vm.service.saving\" required=\"\" ng-model-options=\"{trackBy : \'$value.id\'}\" multiple=\"\" placeholder=\"{{vm.field.AvailableFor === 4 ? \'Item Type\' : \'Lookup Type\'}}\" class=\"md-body-2\" ng-model=\"vm.field.LookupTypes\"><md-option style=\"background-color: #F5F5F5\" ng-value=\"item\" ng-repeat=\"item in vm.service.lookup_types\"><span style=\"margin-left : 5px;\"><b>{{item.TypeName}}</b></span></md-option></md-select></md-input-container></div></div><div ng-if=\"vm.field.AvailableFor === 4\" style=\"margin-top : -25px;\" layout=\"row\" flex=\"\"><div flex=\"\"><md-input-container md-no-float=\"\" class=\"md-block\"><md-select ng-disabled=\"vm.service.saving\" required=\"\" ng-model-options=\"{trackBy : \'$value.Id\'}\" multiple=\"\" placeholder=\"Category Type\" class=\"md-body-2\" ng-model=\"vm.field.CategoryTypes\"><md-option style=\"background-color: #F5F5F5\" ng-value=\"category\" ng-repeat=\"category in vm.service.categories\"><span style=\"margin-left : 5px;\"><b>{{category.Name}}</b></span></md-option></md-select></md-input-container></div></div></div></div>");
$templateCache.put("app/main/customFieldsManager/views/directives/utils/editorSection/mainSection/editor-section.html","<div layout=\"column\" ng-form=\"customFields\" flex=\"\"><form name=\"customfields\" a8-dirty-form-confirmation=\"\"><editor-header-section field=\"vm.field_virtual_copy\"></editor-header-section><short-text-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 0\"></short-text-display><drop-down-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 4\"></drop-down-display><multiple-choice-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 1\"></multiple-choice-display><paragraph-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 5\"></paragraph-display><whole-number-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 3\"></whole-number-display><decimal-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 7\"></decimal-display><check-box-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 2\"></check-box-display><email-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 6\"></email-display><time-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 13\"></time-display><url-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 8\"></url-display><check-box-with-entry-display edit=\"vm.field_virtual_copy.Selected\" field=\"vm.field_virtual_copy\" ng-if=\"vm.field_virtual_copy.FieldType === 12\"></check-box-with-entry-display><editor-footer-section form=\"customfields\" style=\"margin-bottom : -20px\" field=\"vm.field_virtual_copy\"></editor-footer-section></form></div>");
$templateCache.put("app/main/contact/create/work/skills/view/dialog/contact-skill-dialog.html","<md-dialog id=\"contact-skills-dialog\" class=\"main-style\" aria-label=\"{{vm.caption}}\" flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{vm.caption}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"contactskill\" novalidate=\"\"><div layout=\"column\"><md-input-container flex=\"\"><label translate=\"CONTACTSMODULE.SKILLS_SKILL\"></label><md-select ng-model=\"vm.skills_model.Skill\" name=\"Skill\" ng-model-options=\"{trackBy : \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"skill in vm.skills_lookup | orderBy :\'SkillName\'\" ng-value=\"skill\" ng-disabled=\"skill.isOfInValidBranch\">{{skill.SkillName}}</md-option></md-select><div ng-show=\"vm.skills_model.Skill.isOfInValidBranch\" class=\"field-note pt-5\" style=\"color:#e8ab00\">The branch of the skill is invalid.</div></md-input-container><md-input-container ng-if=\"vm.skills_model.Skill.ChildSkills.length > 0\" flex=\"\"><label translate=\"CONTACTSMODULE.SKILLS_SKILL_TYPE\"></label><md-select ng-model=\"vm.skills_model.Skill_Children\" name=\"SkillType\" ng-model-options=\"{trackBy : \'$value.id\'}\" multiple=\"true\" required=\"\"><md-option ng-repeat=\"skill in vm.skills_model.Skill.ChildSkills\" ng-value=\"skill\" ng-disabled=\"skill.isOfInValidBranch\">{{skill.SkillName}}</md-option></md-select><div ng-show=\"vm.skills_model.isSkillChildrenOfInValidBranch\" class=\"field-note pt-5\" style=\"color:#e8ab00\">The branch of the skill is invalid.</div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" ng-model=\"vm.skills_model.Description\" placeholder=\"{{\'CONTACTSMODULE.SKILLS_DESCRIPTION\' | translate}}\" name=\"description\" ng-change=\"vm.sanitizeField(\'Description\')\"><div ng-show=\"vm.nullByteWarnings[\'Description\']\" class=\"field-note pt-5\" style=\"color:#e8ab00\">Description contains invalid characters.</div></md-input-container></div><div layout=\"column\"><md-input-container flex=\"\"><label translate=\"CONTACTSMODULE.SKILLS_AUTO_COMPANY_COMPLETE_PLACEHOLDER\"></label><md-select ng-model=\"vm.skills_model.Company\" name=\"Name\" ng-model-options=\"{trackBy : \'$value.id\'}\" ng-required=\"!vm.skills_model.Skill.CompanyNotRequired\"><md-option ng-repeat=\"company in vm.companies | orderBy :\'Name\'\" ng-value=\"company\">{{company.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\"><input type=\"text\" ng-model=\"vm.skills_model.ReferenceNumber\" placeholder=\"Reference\" name=\"ReferenceNumber\" ng-change=\"vm.sanitizeField(\'ReferenceNumber\')\"><div ng-show=\"vm.nullByteWarnings[\'ReferenceNumber\']\" class=\"field-note pt-5\" style=\"color:#e8ab00\">Reference contains invalid characters.</div></md-input-container></div><div layout=\"column\" flex=\"\"><md-input-container flex=\"\" layout=\"row\" style=\"flex-direction:column\"><label translate=\"CONTACTSMODULE.SKILLS_EXPIRY_DATE\"></label><md-datepicker ng-model=\"vm.skills_model.ExpiryDate\" md-open-on-focus=\"\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" name=\"Expiry\" class=\"md-block\" ng-required=\"vm.skills_model.Skill.ExpiryIsMandatory\" flex=\"\" layout=\"row\"></md-datepicker></md-input-container><div class=\"validation-messages\" ng-messages=\"contactskill.Expiry.$error\"><div ng-message=\"valid,maxdate,mindate\" class=\"expirydate-invalid-message\">{{\'CONTACTSMODULE.SKILLS_EXPIRY_DATE_INVALID\'|translate}}</div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.showProgress\"></md-progress-linear><div layout=\"row\" ng-show=\"vm.uploadAdded && vm.skills_model.UploadFileName != null\"><md-card flex=\"100\"><md-card-content><div layout=\"row\"><div flex=\"10\"><md-button class=\"md-icon-button md-primary\" style=\"color : red\"><md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button></div><div flex=\"60\" layout=\"column\" layout-align=\"center start\"><span>Uploaded File</span></div><div><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.skillsMatrixService.preview(vm.skills_model.UploadFileName)\"><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button></div><div ng-if=\"vm.is_edit\"><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.downloadFile()\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon></md-button></div><div><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.removeFile()\" style=\"color : red\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-card-content></md-card></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\"><md-button translate=\"CONTACTSMODULE.SAVE\" ng-click=\"vm.onSave()\" ng-disabled=\"contactskill.$invalid\" class=\"md-raised md-accent\"></md-button><aps-upload-file></aps-upload-file></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/messaging/generalMessaging/components/messageArea/message/textArea/textArea.html","<div class=\"textArea\" dimmer=\"\" ng-model=\"vm.service.is_sending\"><div><md-input-container class=\"bg md-block\"><textarea ng-model=\"vm.ngModel\" id=\"textarea\" class=\"text-zone\" ng-disabled=\"vm.isDisabled\" ng-keypress=\"vm.limitChars(vm.ngModel)\" ng-change=\"vm.limitChars(vm.ngModel)\" md-maxlength=\"vm.limit\" rows=\"{{vm.rows}}\" md-select-on-focus=\"\">\r\n            </textarea></md-input-container></div><div layout=\"row\" class=\"md-body-2 counter\" layout-align=\"end center\"><span>{{vm.ngModel == null ? 0 : vm.ngModel.length}} / {{vm.limit}}</span></div></div>");
$templateCache.put("app/main/invoice/reports/dialogs/edit-invoice/directives/editable-table/editable-table.html","<table class=\"simple editable-table\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text util-column\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th><th class=\"secondary-text desc-column\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">GL Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Item Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Qty</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit Price</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">GST</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th class=\"secondary-text action-column text-center\" style=\"width: 140px;\"><span class=\"column-title\">Actions</span></th></tr></thead><tfoot><tr><td colspan=\"9\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"editableTableVm.srcData.length <= 0\"><add-row-component row-id=\"-1\"></add-row-component><span>Add Line Item</span></div></td></tr></tfoot><tbody ui-sortable=\"editableTableVm.sortableOpts\" ng-model=\"editableTableVm.srcData\"><tr ng-repeat=\"item in editableTableVm.srcData\" ng-dblclick=\"editableTableVm.onDoubleClick(item.Id)\"><td><md-icon class=\"moveHandle\" md-font-icon=\"icon-drag s20\"></md-icon><add-row-component row-id=\"item.Id\"></add-row-component></td><td><field-editor-component props=\"editableTableVm.fieldDef[0]\" src-model=\"item.Description\" row-id=\"item.Id\"></field-editor-component></td><td><field-editor-component props=\"editableTableVm.fieldDef[1]\" src-model=\"item.CostCodeObj\" row-id=\"item.Id\"></field-editor-component></td><td><field-editor-component props=\"editableTableVm.fieldDef[2]\" src-model=\"item.ItemCodeObj\" row-id=\"item.Id\"></field-editor-component></td><td><field-editor-component props=\"editableTableVm.fieldDef[3]\" src-model=\"item.Quantity\" row-id=\"item.Id\"></field-editor-component></td><td><field-editor-component props=\"editableTableVm.fieldDef[4]\" src-model=\"item.UnitPriceExcludingTax\" row-id=\"item.Id\"></field-editor-component></td><td>{{item.UnitTax}}</td><td>{{item.Amount}}</td><td class=\"actions text-right\" layout-align=\"center center\"><row-action-pane-component row-id=\"item.Id\"></row-action-pane-component></td></tr></tbody></table>");
$templateCache.put("app/main/jobs/allocateResource/components/draggableComponent/draggableComponent/equipment/draggable-equipment.html","<div ng-if=\"vm.service.clickSource == \'Equipment\'\" class=\"equipment-list-scroll\" flex=\"\"><md-list-item ng-repeat=\"lookUp in selected_items = (vm.service.lookUps2 | filter : vm.service.searchText)\" flex=\"\" no-padding=\"\" class=\"md-1-line md-long-text\" ng-style=\"{\'margin-bottom\': $last ? \'15px\' : \'5px\'}\" style=\"overflow-wrap: break-word;\" ng-class=\"{\'selected\': $index == vm.selectedRow}\"><div layout=\"column\" flex=\"\" style=\"margin: 0px 0 10px 0;\"><div layout=\"row\"><span flex=\"10\" style=\"height: 40px;\"><md-button ng-if=\"lookUp.IsValidToAllocate\" no-padding=\"\" no-margin=\"\" style=\"left: -25px; padding-top: 10px;\" class=\"md-icon-button action-button\" ng-click=\"vm.allocateEquipment(lookUp)\"><i class=\"icon-plus blue-500-fg\" style=\"font-size : 20px;\"><md-tooltip>{{vm.utilService.translate(\'RESOURCEALLOCATION.CLICK_TO_ALLOCATE\')}}</md-tooltip></i></md-button><md-button ng-if=\"!lookUp.IsValidToAllocate && lookUp.CanBeOverridden\" no-padding=\"\" no-margin=\"\" style=\"left: -25px; padding-top: 10px;\" class=\"md-icon-button action-button\" ng-click=\"vm.allocateEquipment(lookUp)\"><i class=\"icon-plus red-500-fg\" style=\"font-size : 20px;\"><md-tooltip>{{vm.utilService.translate(\'RESOURCEALLOCATION.CLICK_TO_ALLOCATE\')}}</md-tooltip></i></md-button></span><div flex=\"\" class=\"md-caption\" style=\"padding-top: 12px;\"><strong><span ng-if=\"vm.service.displayUniqueId\">{{lookUp.Code}}</span> <span ng-if=\"vm.service.displayUniqueId && lookUp.Name\">-</span> <span ng-if=\"lookUp.Name\">{{lookUp.Name}}</span></strong></div></div><div layout=\"row\"><div flex=\"10\"></div><div flex=\"\" layout=\"column\"><div class=\"md-caption\" ng-style=\"{\'color\': (lookUp.OperatorId != null) ? \'steelblue\' : \'grey\'}\" style=\"padding-bottom: 2px; padding-top:2px;\">Operator: {{!lookUp.OperatorId ? \'No Operator Assigned\' : lookUp.OperatorName}}</div><div flex=\"\" ng-repeat=\"issue in lookUp.AllocationIssues\" ng-if=\"issue.IsVisible\" ng-style=\"{color: !issue.CanBeOverriden && !issue.IsValidToAllocate ? \'#d50000\' : \'#FF7800\'}\" style=\"padding-bottom: 2px; padding-top:2px;\" class=\"md-caption\">{{issue.Message}}</div></div></div></div></md-list-item></div>");
$templateCache.put("app/main/jobs/allocateResource/components/draggableComponent/draggableComponent/people/draggable-person.html","<div layout=\"column\"><span class=\"md-subhead blue-500-fg\" flex=\"\" ng-if=\"selected_items.length > 0\" style=\"margin-top : 5px;\"><p style=\"border-bottom : 2px solid #3F97F6;\">{{vm.sectionTitle}}</p></span><md-list-item ng-repeat=\"lookUp in selected_items = (vm.available_people | filter : vm.service.searchText)\" flex=\"\" no-padding=\"\" class=\"md-1-line md-long-text\" ng-style=\"{\'margin-bottom\': $last ? \'15px\' : \'5px\'}\" style=\"overflow-wrap: break-word;\" ng-class=\"{\'selected\': $index == vm.selectedRow}\"><div layout=\"column\" flex=\"\" style=\"margin: 0px 0 10px 0;\"><div layout=\"row\"><span flex=\"10\" style=\"height: 40px;\"><md-button ng-if=\"vm.showAllocateButton(lookUp) && !(vm.service.searchText && lookUp.HasPendingConflict)\" no-padding=\"\" no-margin=\"\" class=\"md-icon-button action-button\" style=\"left: -25px; padding-top: 10px;\" ng-click=\"vm.service.allocateToggle(lookUp)\"><i class=\"icon-plus blue-500-fg\" style=\"font-size : 20px;\"><md-tooltip>{{vm.utilService.translate(\'RESOURCEALLOCATION.CLICK_TO_ALLOCATE\')}}</md-tooltip></i></md-button><md-button ng-if=\"vm.showAllocateButtonOverride(lookUp) && !(vm.service.searchText && lookUp.HasPendingConflict)\" no-padding=\"\" no-margin=\"\" class=\"md-icon-button action-button\" style=\"left: -25px; padding-top: 10px;\" ng-click=\"vm.service.allocateOverride(lookUp)\"><i class=\"icon-plus red-500-fg\" style=\"font-size : 20px;\"><md-tooltip>{{vm.utilService.translate(\'RESOURCEALLOCATION.CLICK_TO_ALLOCATE\')}}</md-tooltip></i></md-button></span><span flex=\"\" style=\"padding-top: 12px;\"><a href=\"#\" ng-click=\"vm.service.showDetails(lookUp, evt)\"><strong>{{lookUp.Name}}</strong><md-tooltip>{{vm.utilService.translate(\'RESOURCEALLOCATION.CLICK_TO_VIEW_PROFILE\')}}</md-tooltip></a></span><span flex=\"25\" layout=\"row\"><div ng-if=\"vm.service.settings.showOption.employmentStatus\" style=\"padding-top: 12px;\" class=\"md-caption\"><span class=\"status\" style=\"border: 1px solid grey;\" ng-if=\"lookUp.EmploymentStatus == \'Casual\'\">{{vm.utilService.translate(\'RESOURCEALLOCATION.EMP_CAS\')}}</span> <span class=\"status\" style=\"border: 1px solid grey;\" ng-if=\"lookUp.EmploymentStatus == \'Permanent Parttime\'\">{{vm.utilService.translate(\'RESOURCEALLOCATION.EMP_PT\')}}</span> <span class=\"status\" style=\"border: 1px solid grey;\" ng-if=\"lookUp.EmploymentStatus == \'Labour Hire\'\">{{vm.utilService.translate(\'RESOURCEALLOCATION.EMP_LAB\')}}</span> <span class=\"status\" style=\"border: 1px solid grey;\" ng-if=\"lookUp.EmploymentStatus == \'Permanent Fulltime\'\">{{vm.utilService.translate(\'RESOURCEALLOCATION.EMP_FT\')}}</span> <span class=\"status\" style=\"border: 1px solid grey;\" ng-if=\"lookUp.EmploymentStatus == \'Salary\'\">{{vm.utilService.translate(\'RESOURCEALLOCATION.EMP_SAL\')}}</span><md-tooltip>{{lookUp.EmploymentStatus}}</md-tooltip></div><div ng-if=\"vm.service.settings.showOption.vehicle && lookUp.HasVehicle\" style=\"margin: 8px 3px 0px 3px;\"><md-icon md-font-set=\"material-icons\">drive_eta<md-tooltip>{{vm.utilService.translate(\'RESOURCEALLOCATION.THIS_HAS_VEHICLE\')}}</md-tooltip></md-icon></div></span></div><div flex=\"\" layout=\"row\"><div flex=\"10\"></div><div flex=\"\" layout=\"column\"><span ng-if=\"vm.service.settings.showOption.suburb\" class=\"md-caption\" style=\"padding-bottom: 2px; padding-top:2px;\">{{\'RESOURCEALLOCATION.SUBURB\' | translate}}: {{lookUp.Suburb ? lookUp.Suburb : \'Not Set\'}}</span> <span ng-if=\"vm.service.searchText && lookUp.HasPendingConflict\" class=\"md-caption\" style=\"color: #d50000; padding-bottom: 2px; padding-top:2px;\">{{ \'RESOURCEALLOCATION.PENDING_CALENDAR_WARNING\' | translate }}</span> <span ng-if=\"vm.service.settings.showOption.distance\" class=\"md-caption\" style=\"padding-bottom: 2px; padding-top:2px;\">{{\'RESOURCEALLOCATION.DISTANCE\' | translate}}: {{lookUp.DistanceToJob ? vm.service.round(lookUp.DistanceToJob) : \'Suburb Not Set\'}}</span> <span flex=\"\" style=\"padding-bottom: 2px; padding-top:2px; color: steelblue;\" class=\"md-caption\">{{lookUp.ResourceNotes}}</span> <span ng-repeat=\"issue in lookUp.AllocationIssues\" ng-style=\"{color: (issue.LockoutType === 3 ? \'#d50000\' : (!issue.CanBeOverriden && !issue.IsValidToAllocate ? \'#d50000\' : \'#FF7800\'))}\" style=\"padding-bottom: 2px; padding-top:2px;\" ng-if=\"issue.IsVisible\" class=\"md-caption\">{{issue.Message}}</span> <span flex=\"\" ng-if=\"vm.service.settings.showOption.showPrevAndNextShiftDetails && lookUp.LastShift\" style=\"padding-bottom: 2px; padding-top:8px; color: steelblue;\" class=\"md-caption\">{{lookUp.LastShift}}</span> <span flex=\"\" ng-if=\"vm.service.settings.showOption.showPrevAndNextShiftDetails && lookUp.NextShift\" style=\"padding-bottom: 2px; padding-top:8px; color: steelblue;\" class=\"md-caption\">{{lookUp.NextShift}}</span></div><div flex=\"15\"></div></div></div></md-list-item></div>");
$templateCache.put("app/main/jobs/resourceSidenav/components/resourceList/groups/equipment/equipment-group.directive.html","<md-list flex=\"\"><md-list-item class=\"md-1-line md-long-text\" ng-repeat=\"itm in vm.list | filter : vm.service.searchText\"><div flex=\"\" layout=\"column\" layout-align=\"center stretch\"><div flex=\"none\" layout=\"row\" class=\"padding-bottom-0 padding-top-0\" layout-padding=\"\" layout-align=\"start start\"><div flex=\"15\"><i ng-click=\"vm.allocate(itm)\" class=\"icon-plus blue-500-fg action-button\" ng-if=\"itm.IsValidToAllocate\"><md-tooltip>{{\'RESOURCEALLOCATION.CLICK_TO_ALLOCATE\' | translate}}</md-tooltip></i> <i class=\"icon-plus red-500-fg action-button\" ng-if=\"!itm.IsValidToAllocate && itm.CanBeOverridden\"><md-tooltip>{{\'RESOURCEALLOCATION.CLICK_TO_ALLOCATE\' | translate}}</md-tooltip></i></div><div class=\"nameSection\" flex=\"auto\" layout=\"column\" layout-align=\"center start\"><span class=\"itm-name\">{{itm.Name}} <strong>({{itm.Code}})</strong></span><div layout=\"column\" class=\"margin-top-10\"><span class=\"steelblue md-caption\" ng-style=\"{\'color\': (itm.OperatorId != null) ? \'steelblue\' : \'grey\'}\" style=\"padding-bottom: 2px; padding-top:2px;\">Operator: {{!itm.OperatorId ? \'No Operator Assigned\' : itm.OperatorName}}</span> <span flex=\"\" ng-repeat=\"issue in itm.AllocationIssues\" ng-style=\"{color: !issue.CanBeOverriden && !issue.IsValidToAllocate ? \'#d50000\' : \'#FF7800\'}\" style=\"padding-bottom: 2px; padding-top:2px;\" ng-if=\"issue.IsVisible\" class=\"md-caption\">{{issue.Message}}</span></div></div></div></div></md-list-item></md-list>");
$templateCache.put("app/main/jobs/resourceSidenav/components/resourceList/groups/people/people-group.directive.html","<md-list flex=\"\" ng-if=\"vm.show(vm.finalList)\"><div class=\"md-subhead headerInfo\">{{vm.title}}</div><md-list-item ng-if=\"itm.Show\" style=\"padding:0px;\" class=\"md-1-line md-long-text\" ng-style=\"{\'margin-bottom\': $last ? \'15px\' : \'0px\', \'margin-top\': $first ? \'15px\' : \'0px\'}\" ng-repeat=\"itm in vm.finalList | filter : vm.service.searchText\"><div flex=\"\" layout=\"column\" layout-align=\"center stretch\"><div flex=\"none\" layout=\"row\" style=\"padding-bottom: 0px; padding-top: 0px;\" layout-padding=\"\" layout-align=\"start start\"><div flex=\"15\"><i class=\"icon-plus blue-500-fg action-button\" ng-click=\"vm.allocate(itm, false)\" ng-if=\"vm.showAllocateButton(itm) && !itm.Allocated && !(vm.service.searchText && itm.HasPendingConflict)\"><md-tooltip>{{\'RESOURCEALLOCATION.CLICK_TO_ALLOCATE\' | translate}}</md-tooltip></i> <i class=\"icon-plus red-500-fg action-button\" ng-click=\"vm.allocate(itm, true)\" ng-if=\"vm.showAllocateButtonOverride(itm) && !itm.Allocated && !(vm.service.searchText && itm.HasPendingConflict)\"><md-tooltip>{{\'RESOURCEALLOCATION.CLICK_TO_ALLOCATE\' | translate}}</md-tooltip></i></div><div class=\"nameSection\" flex=\"auto\" layout=\"column\" layout-align=\"center start\"><strong class=\"itm-name\" ng-click=\"vm.showDetails(itm.Id, evt)\">{{itm.Name}}</strong><md-tooltip>Double click to show contact details</md-tooltip></div><div layout=\"row\" layout-align=\"space-between start\" class=\"employment\" flex=\"25\"><span class=\"employment-status margin-right-10\" ng-if=\"itm.EmploymentStatus != \'\'\">{{vm.getEmploymentStatus(itm.EmploymentStatus)}}</span> <span class=\"vehicleArea\" ng-if=\"vm.service.advanceOptions.showOption.vehicle\"><i ng-if=\"itm.HasVehicle\" class=\"icon-car blue-grey-500-fg vehicle\"><md-tooltip>{{\'RESOURCEALLOCATION.THIS_HAS_VEHICLE\' | translate}}</md-tooltip></i></span></div></div><div layout=\"row\" layout-padding=\"\" style=\"padding-bottom: 0px; padding-top: 0px;\"><div flex=\"15\"></div><div layout=\"column\" flex=\"85\"><span ng-if=\"vm.service.advanceOptions.showOption.suburb\" style=\"padding-bottom: 2px; padding-top:2px;\" class=\"md-caption\">{{\'RESOURCEALLOCATION.SUBURB\' | translate}}: {{itm.Suburb ? itm.Suburb : \'Not Set\'}}</span> <span ng-if=\"vm.service.searchText && itm.HasPendingConflict\" style=\"color: #d50000; padding-bottom: 2px; padding-top:2px;\" class=\"md-caption\">{{ \'RESOURCEALLOCATION.PENDING_CALENDAR_WARNING\' | translate }}</span> <span ng-if=\"vm.service.advanceOptions.showOption.distance\" style=\"padding-bottom: 2px; padding-top:2px;\" class=\"md-caption\">{{\'RESOURCEALLOCATION.DISTANCE\' | translate}}: {{itm.DistanceToJob ? vm.round(itm.DistanceToJob) : \'Suburb Not Set\'}}</span> <span class=\"steelblue md-caption\" style=\"padding-bottom: 2px; padding-top:2px;\">{{itm.ResourceNotes}}</span> <span flex=\"\" ng-repeat=\"issue in itm.AllocationIssues\" ng-if=\"issue.IsVisible\" ng-style=\"{color: (issue.LockoutType === 3 ? \'#d50000\' : (!issue.CanBeOverriden && !issue.IsValidToAllocate ? \'#d50000\' : \'#FF7800\'))}\" style=\"padding-bottom: 2px; padding-top:2px;\" class=\"md-caption\">{{issue.Message}}</span> <span flex=\"\" ng-if=\"vm.service.advanceOptions.showOption.showPrevAndNextShiftDetails && itm.LastShift\" style=\"padding-bottom: 2px; padding-top:8px; color : steelblue\" class=\"md-caption\">{{itm.LastShift}}</span> <span flex=\"\" ng-if=\"vm.service.advanceOptions.showOption.showPrevAndNextShiftDetails && itm.NextShift\" style=\"padding-bottom: 2px; padding-top:8px; color : steelblue\" class=\"md-caption\">{{itm.NextShift}}</span></div><div flex=\"15\"></div></div></div></md-list-item></md-list>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/daily/newComponents/dailyTicketFooter/daily-ticket-footer.html","<section ng-if=\"!vm.allowGroupByClient && vm.whiteboardType == 1\"><div class=\"list-card-footer margin-top-5\"><div class=\"layout-row flex\"><div class=\"layout-row layout-align-start-start flex-50\"><div><div class=\"list-card-footer-item margin-left-0\"><strong>#{{vm.ticketNo}}</strong></div></div></div><div class=\"layout-row layout-align-end-start flex-50\"><div><div class=\"list-card-footer-item margin-left-0\" ng-if=\"vm.showRelatedTicketNumber && (vm.relatedNumber != null)\">(#{{vm.relatedNumber}})</div></div></div></div></div><div class=\"list-card-footer\"><div class=\"layout-row flex footer-containerx\"><div class=\"layout-row layout-align-start-start flex-90\"><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><i class=\"icon-view-list s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><i class=\"icon-border-color s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" ng-if=\"vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\"><i class=\"icon-library-books s18 grey-900-fg\" ng-click=\"vm.goToFormsAndAttachment()\"></i><md-tooltip><span>Forms & Attachments</span></md-tooltip></div><div ng-if=\"vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: default; display: inline-block; margin-right: 8px;\"><i class=\"icon-account-multiple-plus s18 not-clickable-item grey-500-fg\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div ng-if=\"!vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.isLocked || vm.ticketType == 4\"><i class=\"icon-account-multiple-plus s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"!vm.isLocked && vm.ticketType != 4\"><i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"!vm.isLocked\" ng-click=\"vm.openResourceAllocation(vm.id, vm.ticketNo, vm.parentTicketNo)\"></i> <i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"vm.isLocked\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right:8px;\" ng-if=\"vm.disableTimesheet\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\" ng-if=\"vm.disableTimesheet == false\"><i class=\"icon-calendar-clock s18 grey-900-fg\" ng-click=\"vm.openTimesheet(vm.id, vm.isLocked, vm.isLockedByPreSchedule, vm.ticketNo)\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"vm.jobsClaims.hasCloneJobsPermission\"><i class=\"icon-content-copy s18 grey-900-fg\" ng-click=\"vm.cloneTicket(vm.id, vm.ticketNo)\"></i><md-tooltip><span>Clone</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\"><i class=\"icon-delete s18\" ng-if=\"!vm.isLocked && !vm.isLockedByPreSchedule\" ng-click=\"vm.cancelTicket(vm.id, vm.ticketNo)\"></i> <i class=\"icon-delete s18 grey-500-fg not-clickable-item\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"></i><md-tooltip><span>Cancel</span></md-tooltip></div></div><div class=\"layout-row\" layout-align=\"end-center\" flex=\"\"><md-menu md-offset=\"0 48px\" class=\"options card-pop-menu\"><md-button class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" aria-label=\"Options\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.addRelatedTicket($event, vm.id)\" aria-label=\"Add Related Ticket\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span>Add Related Ticket</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPdf($event, vm.id)\" aria-label=\"Download PDF\"><md-icon md-font-icon=\"icon-file-pdf\" md-menu-align-target=\"\"></md-icon><span>Download Ticket PDF</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.claimsUtilService.isBillingEnabled()\"><md-button ng-click=\"vm.addTicketBillingPref($event, vm.startDate, vm.id)\" aria-label=\"Ticket Billing Preference\"><md-icon md-font-icon=\"icon-document\" md-menu-align-target=\"\"></md-icon><span>Ticket Billing Preference</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadTimesheetPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Timesheet PDF\" ng-if=\"vm.isMobileAppEnabled\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-calendar\" md-menu-align-target=\"\"></md-icon><span>Download Timesheet PDF</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPaperworkPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Paperwork PDF\" ng-if=\"vm.isMobileAppEnabled\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-file-document\" md-menu-align-target=\"\"></md-icon><span>Download Paperwork PDF</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></section><section ng-if=\"!vm.allowGroupByClient && vm.whiteboardType == 2\"><div class=\"list-card-footer margin-top-5\"><div class=\"layout-row flex\"><div class=\"layout-row layout-align-start-start flex-50\"><div><div class=\"list-card-footer-item margin-left-0\"><strong>#{{vm.ticketNo}}</strong></div></div></div><div class=\"layout-row layout-align-end-start flex-50\"><div><div class=\"list-card-footer-item margin-left-0\" ng-if=\"vm.relatedNumber != null\">(#{{vm.relatedNumber}})</div></div></div></div></div><div class=\"list-card-footer-edge\"><div class=\"layout-row flex\"><div class=\"layout-row layout-align-start-start flex-90\"><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><i class=\"icon-view-list s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><i class=\"icon-border-color s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" ng-if=\"vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\"><i class=\"icon-library-books s18 grey-900-fg\" ng-click=\"vm.goToFormsAndAttachment()\"></i><md-tooltip><span>Forms & Attachments</span></md-tooltip></div><div ng-if=\"vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: default; margin-right:8px;\"><i class=\"icon-account-multiple-plus s18 not-clickable-item grey-500-fg\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"margin-right:8px;\"><i class=\"icon-timetable s18 grey-400-fg not-clickable-item\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div ng-if=\"!vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right:8px;\" ng-if=\"vm.isLocked\"><i class=\"icon-account-multiple-plus s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right:8px;\" ng-if=\"!vm.isLocked\"><i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"!vm.isLocked\" ng-click=\"vm.openResourceAllocation(vm.id, vm.ticketNo, vm.parentTicketNo)\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right:8px;\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i></div></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"vm.jobsClaims.hasCloneJobsPermission\"><i class=\"icon-content-copy s18 grey-900-fg\" ng-click=\"vm.cloneTicket(vm.id, vm.ticketNo)\"></i><md-tooltip><span>Clone</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\"><i class=\"icon-delete s18\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\" ng-click=\"vm.cancelTicket(vm.id, vm.ticketNo)\"></i> <i class=\"icon-delete s18 grey-500-fg not-clickable-item\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"></i><md-tooltip ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><span>Cancel</span></md-tooltip></div></div><div class=\"layout-row\" layout-align=\"end-center\" flex=\"\"><md-menu md-offset=\"0 48px\" class=\"options card-pop-menu\"><md-button class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" aria-label=\"Options\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"5\"><md-menu-item><md-button ng-click=\"vm.addRelatedTicket($event, vm.id)\" aria-label=\"Add Related Ticket\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span>Add Related Ticket</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPdf($event, vm.id)\" aria-label=\"Download PDF\"><md-icon md-font-icon=\"icon-file-pdf\" md-menu-align-target=\"\"></md-icon><span>Download Ticket PDF</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.claimsUtilService.isBillingEnabled()\"><md-button ng-click=\"vm.addTicketBillingPref($event, vm.startDate, vm.id)\" aria-label=\"Ticket Billing Preference\"><md-icon md-font-icon=\"icon-document\" md-menu-align-target=\"\"></md-icon><span>Ticket Billing Preference</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadTimesheetPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Timesheet PDF\" ng-if=\"vm.isMobileAppEnabled\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-calendar\" md-menu-align-target=\"\"></md-icon><span>Download Timesheet PDF</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPaperworkPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Paperwork PDF\" ng-if=\"vm.isMobileAppEnabled\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-document\" md-menu-align-target=\"\"></md-icon><span>Download Paperwork PDF</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></section>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/daily/newComponents/dailyTicketStatus/daily-ticket-status.html","<div class=\"list-card-labels layout-row layout-align-center-center\" ng-if=\"vm.whiteboardType == 1 && !vm.allowGroupByClient\"><div class=\"list-card-label2 padding-right-10 flex\" ng-class=\"vm.getHeaderColorClass()\"><div class=\"daily-divStyle-left-pane\"><i class=\"icon-weather-sunny s16 grey-50-fg\" ng-if=\"vm.isDayShift\"></i> <i class=\"icon-weather-night s16 grey-50-fg\" ng-if=\"!vm.isDayShift\"></i></div><div class=\"daily-divStyle-right-pane\"><md-icon md-svg-icon=\"attachment-not-completed\" class=\"s16 margin-right-5 attachment-not-met\" ng-if=\"vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted\"></md-icon><md-icon md-svg-icon=\"attachment-completed\" class=\"s16 margin-right-5 attachment-met\" ng-if=\"vm.hasRequiredAttachments && vm.isRequiredAttachmentsCompleted\"></md-icon><i class=\"icon-email s16 margin-right-5 grey-50-fg\" ng-show=\"vm.isEmailSent\"></i> <i class=\"icon-checkbox-marked-circle s16 grey-50-fg\" ng-if=\"vm.status[0].abbrev === \'C\' || vm.status[0].abbrev === \'R\' && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-account-multiple s16 margin-right-5 grey-50-fg\" ng-if=\"vm.ticketType != 1 && vm.showRequireAllocationIcon && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-account-alert s16 margin-right-5 grey-50-fg\" ng-if=\"vm.ticketType != 1 && vm.showShiftAllocationIcon && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-truck s16 grey-50-fg\" ng-if=\"((vm.status[0].abbrev != \'C\' || vm.status[0].abbrev != \'R\') && vm.showEquipmentAllocationIcon) && vm.status[0].abbrev != \'CJPA\'\"></i></div></div></div><div class=\"list-card-labels layout-row layout-align-center-center\" ng-if=\"vm.whiteboardType == 2 && !vm.allowGroupByClient\"><div class=\"list-card-label2 padding-right-10 flex\" ng-class=\"vm.getHeaderColorClass()\"><div class=\"daily-divStyle-left-pane\"><i class=\"icon-weather-sunny s16 grey-50-fg\" ng-if=\"vm.isDayShift\"></i> <i class=\"icon-weather-night s16 grey-50-fg\" ng-if=\"!vm.isDayShift\"></i></div><div class=\"daily-divStyle-right-pane\"><md-icon md-svg-icon=\"attachment-not-completed\" class=\"s16 margin-right-5 attachment-not-met\" ng-if=\"vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted\"></md-icon><md-icon md-svg-icon=\"attachment-completed\" class=\"s16 margin-right-5 attachment-met\" ng-if=\"vm.hasRequiredAttachments && vm.isRequiredAttachmentsCompleted\"></md-icon><i class=\"icon-email s16 margin-right-5 grey-50-fg\" ng-show=\"vm.isEmailSent\"></i> <i class=\"icon-checkbox-marked-circle s16 grey-50-fg\" ng-if=\"vm.status[0].abbrev === \'C\' || vm.status[0].abbrev === \'R\' && vm.status[0].abbrev != \'CJPA\'\"></i> <i class=\"icon-truck s16 grey-50-fg\" ng-if=\"((vm.status[0].abbrev != \'C\' || vm.status[0].abbrev != \'R\') && vm.showEquipmentAllocationIcon) && vm.status[0].abbrev != \'CJPA\'\"></i></div></div></div><div class=\"list-card-labels layout-row layout-align-center-center\" ng-if=\"vm.allowGroupByClient\"><div ng-repeat=\"stat in vm.status\" class=\"list-card-label2 padding-right-10 flex\" style=\"height: 20px;\" ng-class=\"{\'md-red-bg\': stat.abbrev == \'AR\', \'md-blue-bg\': stat.abbrev == \'C\', \'md-green-bg\': stat.abbrev == \'R\', \'md-orange-bg\': stat.abbrev == \'A\'}\"><div class=\"daily-divStyle-left-pane\"></div><div class=\"daily-divStyle-right-pane\"></div></div></div>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/daily/newComponents/dailyTicketInfo/daily-ticket-info.html","<div class=\"list-card-details\" style=\"height: auto;\" ng-class=\"{\'daily-ticket-info-container-big\': vm.showProject == true, \'daily-ticket-info-container-small\': vm.showProject == true}\"><div class=\"list-card-name multiline-truncate\">{{vm.cardName}}</div><div class=\"list-card-badges layout-align-start-center\" ng-if=\"vm.allowGroupByClient\"><span class=\"grey-600-fg layout-align-start-center\"><strong>{{vm.ticketCount}}</strong>&nbsp;Ticket<span ng-if=\"vm.ticketCount > 1\">s</span></span></div><div class=\"list-card-badges layout-align-start-center layout-row\" ng-if=\"!vm.allowGroupByClient\"><div class=\"flex-100\"><span class=\"ticket-date layout-align-start-center layout-row\"><i class=\"icon-clock s16\"></i> &nbsp;&nbsp;{{vm.startDate}}</span></div></div><div class=\"list-card-badges layout-align-start-center\" ng-if=\"!vm.allowGroupByClient\"><span class=\"ticket-branch layout-align-start-center\">{{vm.branch}}</span></div><div class=\"list-card-address grey-600-fg padding-bottom-5\" ng-if=\"!vm.allowGroupByClient\"><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.AddressPrefix,vm.jobLocationAddress.UnitNumber,vm.jobLocationAddress.BldgName])\">{{vm.getAddress([vm.jobLocationAddress.AddressPrefix,vm.jobLocationAddress.UnitNumber,vm.jobLocationAddress.BldgName])}}</p><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.StreetNumber,vm.jobLocationAddress.StreetName])\">{{vm.getAddress([vm.jobLocationAddress.StreetNumber,vm.jobLocationAddress.StreetName])}}</p><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.Suburb,vm.jobLocationAddress.State,vm.jobLocationAddress.PostCode])\">{{vm.getAddress([vm.jobLocationAddress.Suburb,vm.jobLocationAddress.State,vm.jobLocationAddress.PostCode])}}</p><p class=\"address-line\" ng-if=\"vm.jobLocationAddress.Country != null\">{{vm.getAddress([vm.jobLocationAddress.Country])}}</p></div><div class=\"list-card-project grey-600-fg padding-bottom-5 multiline-truncate\" ng-if=\"!vm.allowGroupByClient && vm.showProject\"><span ng-if=\"vm.projectName != null\">{{vm.projectName}}</span> <span ng-if=\"vm.projectName == null\">[No Project]</span></div></div>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/weekly/dialogs/allocationConflict/allocation-conflict-dialog.html","<md-dialog class=\"ticket-detail-dialog\" aria-label=\"Ticket Detail View\" flex=\"40\" ng-cloak=\"\"><md-toolbar layout=\"column\"><div class=\"md-toolbar-tools\"><span class=\"md-headline\">#{{vm.model.data.TicketNumber}}<md-tooltip><span>Ticket Number to move</span></md-tooltip></span> <span class=\"md-headline margin-left-20 truncate-500\">{{vm.model.data.CompanyName}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-content><span>Allocation conflict on the following resources. Do you still want to continue?</span><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th>Allocated Item</th><th>Item Name</th><th class=\"text-right\">Start Time</th><th class=\"text-right\">Finish Time</th></tr></thead><tfoot><tr><td colspan=\"3\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\" ng-show=\"vm.model.length <= 0\"><span>No Current Allocation Conflicts</span></div></td></tr></tfoot><tbody><tr ng-repeat=\"conflictItm in vm.model.data.Conflicts\"><td class=\"name\">{{conflictItm.AllocatedItemName}}</td><td class=\"name\">{{conflictItm.ItemName}}</td><td class=\"text-right\">{{conflictItm.StartTime}}</td><td class=\"text-right\">{{conflictItm.FinishTime}}</td></tr></tbody></table></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.onYes()\">Yes</md-button><md-button ng-click=\"vm.onNo()\">No</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/weekly/newComponents/ticketFooter/week-ticket-footer.html","<section ng-if=\"!vm.allowGroupByClient && vm.whiteboardType == 1\"><div class=\"list-card-footer margin-top-5\"><div class=\"layout-row flex\"><div class=\"layout-row layout-align-start-start flex-50\"><div><div class=\"list-card-footer-item margin-left-0\"><strong>#{{vm.ticketNo}}</strong></div></div></div><div class=\"layout-row layout-align-end-start flex-50\"><div><div class=\"list-card-footer-item margin-left-0\" ng-if=\"vm.showRelatedTicketNumber && (vm.relatedNumber != null)\">(#{{vm.relatedNumber}})</div></div></div></div></div><div class=\"list-card-footer list-card-footer-weekly\"><div class=\"layout-row flex footer-containerx\"><div class=\"layout-row layout-align-start-start flex-90\"><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><i class=\"icon-view-list s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><i class=\"icon-border-color s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" ng-if=\"vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\"><i class=\"icon-library-books s18 grey-900-fg\" ng-click=\"vm.goToFormsAndAttachment()\"></i><md-tooltip><span>Forms & Attachments</span></md-tooltip></div><div ng-if=\"vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: default; display: inline-block; margin-right: 8px;\"><i class=\"icon-account-multiple-plus s18 not-clickable-item grey-500-fg\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div ng-if=\"!vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.isLocked || vm.ticketType == 4\"><i class=\"icon-account-multiple-plus s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"!vm.isLocked && vm.ticketType != 4\"><i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"!vm.isLocked\" ng-click=\"vm.openResourceAllocation(vm.id, vm.ticketNo, vm.parentTicketNo)\"></i> <i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"vm.isLocked\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.isTimesheetDisabled()\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\" ng-if=\"!vm.isTimesheetDisabled()\"><i class=\"icon-calendar-clock s18 grey-900-fg\" ng-click=\"vm.openTimesheet(vm.id, vm.isLocked, vm.isLockedByPreSchedule, vm.ticketNo)\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"vm.jobsClaims.hasCloneJobsPermission\"><i class=\"icon-content-copy s18 grey-900-fg\" ng-click=\"vm.cloneTicket(vm.id, vm.ticketNo)\"></i><md-tooltip><span>Clone</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\"><i class=\"icon-delete s18\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\" ng-click=\"vm.cancelTicket(vm.id, vm.ticketNo)\"></i> <i class=\"icon-delete s18 grey-500-fg\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"></i><md-tooltip><span>Cancel</span></md-tooltip></div></div><div class=\"layout-row\" layout-align=\"end-center\" flex=\"\"><md-menu md-offset=\"0 48px\" class=\"options card-pop-menu\"><md-button class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" aria-label=\"Options\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.addRelatedTicket($event, vm.id)\" aria-label=\"Add Related Ticket\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span>Add Related Ticket</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPdf($event, vm.id)\" aria-label=\"Download PDF\"><md-icon md-font-icon=\"icon-file-pdf\" md-menu-align-target=\"\"></md-icon><span>Download Ticket PDF</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.claimsUtilService.isBillingEnabled()\"><md-button ng-click=\"vm.addTicketBillingPref($event, vm.startDate, vm.id)\" aria-label=\"Ticket Billing Preference\"><md-icon md-font-icon=\"icon-document\" md-menu-align-target=\"\"></md-icon><span>Ticket Billing Preference</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadTimesheetPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Timesheet PDF\" ng-if=\"vm.isMobileAppEnabled\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-calendar\" md-menu-align-target=\"\"></md-icon><span>Download Timesheet PDF</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPaperworkPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Paperwork PDF\" ng-if=\"vm.isMobileAppEnabled\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-file-document\" md-menu-align-target=\"\"></md-icon><span>Download Paperwork PDF</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></section><section ng-if=\"!vm.allowGroupByClient && vm.whiteboardType == 2\"><div class=\"list-card-footer margin-top-5\"><div class=\"layout-row flex\"><div class=\"layout-row layout-align-start-start flex-50\"><div><div class=\"list-card-footer-item margin-left-0\"><strong>#{{vm.ticketNo}}</strong></div></div></div><div class=\"layout-row layout-align-end-start flex-50\"><div><div class=\"list-card-footer-item margin-left-0\" ng-if=\"vm.relatedNumber != null\">(#{{vm.relatedNumber}})</div></div></div></div></div><div class=\"list-card-footer list-card-footer-weekly\"><div class=\"layout-row flex footer-containerx\"><div class=\"layout-row layout-align-start-start flex-90\"><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><i class=\"icon-view-list s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><i class=\"icon-border-color s18 grey-900-fg\" ng-click=\"vm.openEditTicket(vm.id, vm.ticketNo, vm.isLocked, vm.isLockedByPreSchedule, vm.parentTicketNo)\"></i><md-tooltip><span>Edit Ticket</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" ng-if=\"vm.isCustomFormsEnabled || vm.isDocumentManagementEnabled\" style=\"cursor: pointer; display: inline-block; margin-right: 8px;\"><i class=\"icon-library-books s18 grey-900-fg\" ng-click=\"vm.goToFormsAndAttachment()\"></i><md-tooltip><span>Forms & Attachments</span></md-tooltip></div><div ng-if=\"vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: default; display: inline-block; margin-right: 8px;\"><i class=\"icon-account-multiple-plus s18 not-clickable-item grey-500-fg\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\"><i class=\"icon-timetable s18 grey-400-fg not-clickable-item\"></i><md-tooltip><span>View Timesheet</span></md-tooltip></div></div><div ng-if=\"!vm.isUnConfirmedDate\"><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"vm.isLocked\"><i class=\"icon-account-multiple-plus s18 grey-400-fg not-clickable-item\"></i></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\" ng-if=\"!vm.isLocked\"><i class=\"icon-account-multiple-plus s18 grey-900-fg\" ng-if=\"!vm.isLocked\" ng-click=\"vm.openResourceAllocation(vm.id, vm.ticketNo, vm.parentTicketNo)\"></i><md-tooltip><span>Allocate Resource</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\" style=\"display: inline-block; margin-right: 8px;\"><i class=\"icon-calendar-clock s18 grey-400-fg not-clickable-item\"></i></div></div><div class=\"list-card-footer-item margin-right-8\" style=\"cursor: pointer;\" ng-if=\"vm.jobsClaims.hasCloneJobsPermission\"><i class=\"icon-content-copy s18 grey-900-fg\" ng-click=\"vm.cloneTicket(vm.id, vm.ticketNo)\"></i><md-tooltip><span>Clone</span></md-tooltip></div><div class=\"list-card-footer-item margin-right-8\"><i class=\"icon-delete s18\" ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\" ng-click=\"vm.cancelTicket(vm.id, vm.ticketNo)\"></i> <i class=\"icon-delete s18 grey-500-fg\" ng-if=\"vm.isLocked || (vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"></i><md-tooltip ng-if=\"!vm.isLocked && !(vm.isLockedByPreSchedule && vm.isSmartSchedulingEnabled)\"><span>Cancel</span></md-tooltip></div></div><div class=\"layout-row\" layout-align=\"end-center\" flex=\"\"><md-menu md-offset=\"0 48px\" class=\"options card-pop-menu\"><md-button class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" aria-label=\"Options\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.addRelatedTicket($event, vm.id)\" aria-label=\"Add Related Ticket\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target=\"\"></md-icon><span>Add Related Ticket</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPdf($event, vm.id)\" aria-label=\"Download PDF\"><md-icon md-font-icon=\"icon-file-pdf\" md-menu-align-target=\"\"></md-icon><span>Download Ticket PDF</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.claimsUtilService.isBillingEnabled()\"><md-button ng-click=\"vm.addTicketBillingPref($event, vm.startDate, vm.id)\" aria-label=\"Ticket Billing Preference\"><md-icon md-font-icon=\"icon-document\" md-menu-align-target=\"\"></md-icon><span>Ticket Billing Preference</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadTimesheetPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Timesheet PDF\" ng-if=\"vm.isMobileAppEnabled\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-calendar\" md-menu-align-target=\"\"></md-icon><span>Download Timesheet PDF</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadPaperworkPdf($event, vm.id, vm.ticketNo)\" aria-label=\"Download Paperwork PDF\" ng-if=\"vm.isMobileAppEnabled\" ng-disabled=\"!vm.hasGeneratedPaperworkPdf\"><md-icon md-font-icon=\"icon-document\" md-menu-align-target=\"\"></md-icon><span>Download Paperwork PDF</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></section>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/weekly/newComponents/ticketInfo/week-ticket-info.html","<div class=\"list-card-details\" ng-class=\"vm.contentInfoCss\"><div class=\"list-card-name multiline-truncate\">{{vm.cardName}}</div><div class=\"list-card-sort-handle\"><i class=\"icon s16 icon-cursor-move\"></i></div><div class=\"list-card-badges layout-align-start-center\" ng-if=\"vm.allowGroupByClient\"><span class=\"grey-600-fg layout-align-start-center\"><strong>{{vm.ticketCount}}</strong>&nbsp;Ticket<span ng-if=\"vm.ticketCount > 1\">s</span></span></div><div class=\"list-card-badges layout-align-start-center layout-row\" ng-if=\"!vm.allowGroupByClient\"><div class=\"flex\"><span class=\"ticket-date small-font layout-align-start-center layout-row\"><i class=\"icon-clock s16\"></i> {{vm.startDate}}</span></div></div><div class=\"list-card-badges layout-align-start-center\" ng-if=\"!vm.allowGroupByClient\">{{vm.branch}}</div><div class=\"list-card-address grey-600-fg padding-bottom-5\" ng-if=\"!vm.allowGroupByClient\"><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.AddressPrefix,vm.jobLocationAddress.UnitNumber,vm.jobLocationAddress.BldgName])\">{{vm.getAddress([vm.jobLocationAddress.AddressPrefix,vm.jobLocationAddress.UnitNumber,vm.jobLocationAddress.BldgName])}}</p><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.StreetNumber,vm.jobLocationAddress.StreetName])\">{{vm.getAddress([vm.jobLocationAddress.StreetNumber,vm.jobLocationAddress.StreetName])}}</p><p class=\"address-line\" ng-if=\"vm.getAddress([vm.jobLocationAddress.Suburb,vm.jobLocationAddress.State,vm.jobLocationAddress.PostCode])\">{{vm.getAddress([vm.jobLocationAddress.Suburb,vm.jobLocationAddress.State,vm.jobLocationAddress.PostCode])}}</p><p class=\"address-line\" ng-if=\"vm.jobLocationAddress.Country != null\">{{vm.getAddress([vm.jobLocationAddress.Country])}}</p></div><div class=\"list-card-project grey-500-fg padding-bottom-5 multiline-truncate\" ng-if=\"!vm.allowGroupByClient && vm.showProject\"><span ng-if=\"vm.projectName != null\">{{vm.projectName}}</span> <span ng-if=\"vm.projectName == null\">[No Project]</span></div></div>");
$templateCache.put("app/main/jobs/whiteBoard/jobBoard/weekly/newComponents/ticketStatusDetails/ticket-status-details.html","<div class=\"list-card-details-status\" ng-if=\"vm.whiteboardType == 1 && !vm.allowGroupByClient\"><div class=\"list-card-labels layout-row layout-align-center-center\"><div class=\"list-card-label2 padding-right-10 flex\" ng-class=\"vm.getHeaderColorClass()\"><div class=\"divStyle-left-pane\"><i class=\"icon-weather-sunny s16 grey-50-fg\" ng-if=\"vm.isDayShift\"></i> <i class=\"icon-weather-night s16 grey-50-fg\" ng-if=\"!vm.isDayShift\"></i></div><div class=\"divStyle-right-pane\"><md-icon md-svg-icon=\"attachment-not-completed\" class=\"s16 margin-right-5 attachment-not-met\" ng-if=\"vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted\"></md-icon><md-icon md-svg-icon=\"attachment-completed\" class=\"s16 margin-right-5 attachment-met\" ng-if=\"vm.hasRequiredAttachments && vm.isRequiredAttachmentsCompleted\"></md-icon><i class=\"icon-email s16 margin-right-5 grey-50-fg\" ng-show=\"vm.isEmailSent\"></i> <i class=\"icon-checkbox-marked-circle s16 grey-50-fg\" ng-if=\"vm.status[0].abbrev === \'C\' || vm.status[0].abbrev === \'R\'\"></i> <i class=\"icon-truck s16 grey-50-fg\" ng-if=\"(vm.status[0].abbrev != \'C\' || vm.status[0].abbrev != \'R\') && vm.showEquipmentAllocationIcon\"></i> <i class=\"icon-account-alert s16 margin-right-5 grey-50-fg\" ng-if=\"vm.ticketType != 1 && vm.showShiftAllocationIcon\"></i> <i class=\"icon-account-multiple s16 margin-right-5 grey-50-fg\" ng-if=\"vm.ticketType != 1 && vm.showRequireAllocationIcon\"></i></div></div></div></div><div class=\"list-card-details-status\" ng-if=\"vm.whiteboardType == 2 && !vm.allowGroupByClient\"><div class=\"list-card-labels layout-row layout-align-center-center\"><div class=\"list-card-label2 padding-right-10 flex\" ng-class=\"vm.getHeaderColorClass()\"><div class=\"divStyle-left-pane\"><i class=\"icon-weather-sunny s16 grey-50-fg\" ng-if=\"vm.isDayShift\"></i> <i class=\"icon-weather-night s16 grey-50-fg\" ng-if=\"!vm.isDayShift\"></i></div><div class=\"divStyle-right-pane\"><md-icon md-svg-icon=\"attachment-not-completed\" class=\"s16 margin-right-5 attachment-not-met\" ng-if=\"vm.hasRequiredAttachments && !vm.isRequiredAttachmentsCompleted\"></md-icon><md-icon md-svg-icon=\"attachment-completed\" class=\"s16 margin-right-5 attachment-met\" ng-if=\"vm.hasRequiredAttachments && vm.isRequiredAttachmentsCompleted\"></md-icon><i class=\"icon-email s16 margin-right-5 grey-50-fg\" ng-show=\"vm.isEmailSent\"></i> <i class=\"icon-checkbox-marked-circle s16 grey-50-fg\" ng-if=\"vm.status[0].abbrev === \'C\' || vm.status[0].abbrev === \'R\'\"></i> <i class=\"icon-truck s16 grey-50-fg\" ng-if=\"(vm.status[0].abbrev != \'C\' || vm.status[0].abbrev != \'R\') && vm.showEquipmentAllocationIcon\"></i></div></div></div></div><div class=\"list-card-labels layout-row layout-align-center-center\" ng-if=\"vm.allowGroupByClient\"><div ng-repeat=\"stat in vm.status\" class=\"list-card-label2 padding-right-10 flex\" style=\"height: 20px;\" ng-class=\"{\'md-red-bg\': stat.abbrev == \'AR\', \'md-blue-bg\': stat.abbrev == \'C\', \'md-green-bg\': stat.abbrev == \'R\', \'md-orange-bg\': stat.abbrev == \'A\'}\"><div class=\"daily-divStyle-left-pane\"></div><div class=\"daily-divStyle-right-pane\"></div></div></div>");
$templateCache.put("app/main/paperworkExceptions/directives/mainView/gridContainer/dynamicGrid/timeSheet/timesheet-dialog.html","<md-dialog flex=\"30\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"PAPERWORK_EXCEPTION.EDIT_TIMESHEET\" translate-attr-aria-label=\"PAPERWORK_EXCEPTION.EDIT_TIMESHEET\"></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.onCancel()\"><md-icon md-svg-src=\"/assets/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-form=\"timesheetForm\" layout=\"row\"><div flex=\"\" layout=\"column\"><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" time-picker=\"\" ng-model=\"vm.model.TravelStartTime\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.TRAVEL_START\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" time-picker=\"\" ng-model=\"vm.model.TravelEndTime\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.TRAVEL_FINISHED\' | translate}}\"></md-input-container></div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" required=\"\" time-picker=\"\" ng-model=\"vm.model.JobStartTime\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.JOB_START\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" required=\"\" time-picker=\"\" ng-model=\"vm.model.JobEndTime\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.JOB_FINISHED\' | translate}}\"></md-input-container></div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" time-picker=\"\" ng-model=\"vm.model.BreakStartTime\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.BREAK_START\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" time-picker=\"\" ng-model=\"vm.model.BreakEndTime\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.BREAK_FINISHED\' | translate}}\"></md-input-container></div><div layout=\"row\" layout-sm=\"column\" ng-if=\"vm.claimsUtilService.isTravelKmsInTimesheetEnabled()\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" numeric=\"2\" ng-model=\"vm.model.TravelFromDistance\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.TRAVEL_FROM\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" numeric=\"2\" ng-model=\"vm.model.TravelDuringDistance\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.TRAVEL_DURING\' | translate}}\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" numeric=\"2\" ng-model=\"vm.model.TravelToDistance\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.TRAVEL_TO\' | translate}}\"></md-input-container></div><div layout=\"row\" layout-sm=\"column\" ng-if=\"vm.claimsUtilService.isInclementWeatherInTimesheetEnabled()\" layout-xs=\"column\" flex=\"\"><md-input-container flex=\"\"><input type=\"text\" numeric=\"2\" ng-model=\"vm.model.InclementWeatherHours\" class=\"md-block\" placeholder=\"{{\'PAPERWORK_EXCEPTION.INCLEMENT_WEATHER_HOURS\' | translate}}\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.onSave()\" translate=\"PAPERWORK_EXCEPTION.SAVE\" ng-disabled=\"timesheetForm.$invalid\" style=\"margin-right:20px;\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoice/reports/dialogs/edit-invoice/directives/editable-table/add-row/add-row.html","<md-button class=\"md-icon-button\" aria-label=\"Edit\" hide=\"\" show-gt-sm=\"\" ng-click=\"addRowVm.add()\" ng-disabled=\"addRowVm.isActionDisabled\"><md-icon md-font-icon=\"icon-plus s20\" ng-if=\"addRowVm.showAdd\"></md-icon><md-tooltip><span>Add new row</span></md-tooltip></md-button>");
$templateCache.put("app/main/invoice/reports/dialogs/edit-invoice/directives/editable-table/field-editor/field-editor.html","<div ng-if=\"fieldEditorVm.props.controlType == \'text\'\"><div ng-if=\"!fieldEditorVm.isEditMode\">{{fieldEditorVm.srcModel}}</div><div ng-if=\"fieldEditorVm.isEditMode\"><md-input-container><input ng-model=\"fieldEditorVm.srcModel\" aria-label=\"input box\" ng-model-options=\"{ debounce: 100 }\" ng-change=\"fieldEditorVm.onChange(fieldEditorVm.props.modelProp)\"></md-input-container></div></div><div ng-if=\"fieldEditorVm.props.controlType == \'number\'\"><div ng-if=\"!fieldEditorVm.isEditMode\">{{fieldEditorVm.srcModel}}</div><div ng-if=\"fieldEditorVm.isEditMode\"><md-input-container><input type=\"text\" ng-model=\"fieldEditorVm.srcModel\" aria-label=\"input box\" ng-model-options=\"{ debounce: 100 }\" ng-change=\"fieldEditorVm.onChange(fieldEditorVm.props.modelProp)\" min=\"\" precision=\"2\" money=\"\"></md-input-container></div></div><div ng-if=\"fieldEditorVm.props.controlType == \'select\'\"><div ng-if=\"!fieldEditorVm.isEditMode\">{{fieldEditorVm.srcModel.Description}}</div><md-input-container ng-if=\"fieldEditorVm.isEditMode\" flex=\"\"><label>{{fieldEditorVm.props.label}}</label><md-select ng-model=\"fieldEditorVm.srcModel\" ng-model-options=\"fieldEditorVm.props.trackBy\"><md-option ng-repeat=\"lookupItem in fieldEditorVm.props.lookups\" ng-value=\"lookupItem\">{{lookupItem.Description}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/main/invoice/reports/dialogs/edit-invoice/directives/editable-table/row-action-pane/row-action-pane.html","<div ng-if=\"!rowActionPaneVm.isEditMode\"><md-button class=\"md-icon-button\" aria-label=\"Edit\" hide=\"\" show-gt-sm=\"\" ng-click=\"rowActionPaneVm.edit(rowActionPaneVm.rowId)\" ng-disabled=\"rowActionPaneVm.isActionDisabled\"><md-icon md-font-icon=\"icon-pencil s18\"></md-icon><md-tooltip><span>Edit row</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Remove\" hide=\"\" show-gt-sm=\"\" ng-click=\"rowActionPaneVm.remove(rowActionPaneVm.rowId)\" ng-disabled=\"rowActionPaneVm.isActionDisabled\"><md-icon md-font-icon=\"icon-trash s18\"></md-icon><md-tooltip><span>Remove row</span></md-tooltip></md-button></div><div ng-if=\"rowActionPaneVm.isEditMode\"><md-button class=\"md-icon-button\" aria-label=\"Update\" hide=\"\" show-gt-sm=\"\" ng-click=\"rowActionPaneVm.update(rowActionPaneVm.rowId)\"><md-icon md-font-icon=\"icon-check s18\"></md-icon><md-tooltip><span>Accept changes</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Cancel\" hide=\"\" show-gt-sm=\"\" ng-click=\"rowActionPaneVm.cancel(rowActionPaneVm.rowId)\"><md-icon md-font-icon=\"icon-cancel s18\"></md-icon><md-tooltip><span>Cancel editing</span></md-tooltip></md-button></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/BT/droppable-bt.html","<div layout=\"column\" id=\"droppable-allocate-resource-bt\" flex=\"\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"droppableVm.service.showDroppableLoader || droppableVm.service.reloader\"></md-progress-linear><div ng-include=\"\'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/BT/people.html\'\" style=\"padding-bottom: 20px; margin-top: -7px;\" ng-if=\"!droppableVm.service.is_equipment\"></div><a8-allocate-options ng-if=\"droppableVm.service.IsMultiDayEquipmentJob\" multiple=\"droppableVm.service.IsMultiDayEquipmentJob\" start-date=\"droppableVm.service.Equipment_StartDate\" end-date=\"droppableVm.service.Equipment_EndDate\" ng-model=\"droppableVm.service.allocation_option\" layout=\"row\"></a8-allocate-options><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"droppableVm.service.showDroppableLoader || droppableVm.service.reloader\"></md-progress-linear><div ng-include=\"\'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/BT/equipment.html\'\"></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/BT/equipment.html","<div class=\"md-whiteframe-6dp\" layout=\"column\" md-whiteframe=\"6\" ng-class=\"{\'equipment-dropzone-full\': droppableVm.service.is_equipment , \'equipment-dropzone\': !droppableVm.service.is_equipment}\" flex=\"\"><md-toolbar layout=\"row\" class=\"md-primary resource-toolbar\"><div class=\"md-toolbar-tools\"><span>{{ \'RESOURCEALLOCATION.EQUIPMENT\' | translate }}</span></div></md-toolbar><div droppable=\"\" flex=\"\" class=\"form-wrapper-2 scroll\" ms-scroll=\"\" style=\"position: relative\"><md-progress-circular class=\"md-accent droppable-spinner\" ng-if=\"droppableVm.service.showDroppableLoader\" md-mode=\"indeterminate\"></md-progress-circular><div class=\"ms-responsive-table-wrapper\" ng-disabled=\"true\"><table class=\"simple table-position\" ms-responsive-table=\"\" ng-show=\"!droppableVm.service.showDroppableLoader\" ng-class=\"{\'still-fetching\' : droppableVm.service.fetchingAvailableResources, \'fetched\' : !droppableVm.service.fetchingAvailableResources}\"><tfoot ng-if=\"droppableVm.service.droppables.length == 0\"><tr><td colspan=\"5\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\"><span>{{ \'RESOURCEALLOCATION.NOEQUIPMENT\' | translate }}</span></div></td></tr></tfoot><thead><tr><th>{{ \'RESOURCEALLOCATION.OPERATORSTATUS\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.ASSET\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.ALLOCATEDASSET\' | translate }}</th><th ng-if=\"!droppableVm.service.is_equipment\">{{ \'RESOURCEALLOCATION.OPERATOR\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.ACTIONS\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"itm in droppableVm.service.droppables | filter : { ItemType : \'!\' + 4 }\" ng-class=\"{\'selected\': (($index === droppableVm.service.selectedRow) && (droppableVm.service.clickSource === \'Equipment\'))}\"><td ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><span translate=\"RESOURCEALLOCATION.NOTYETALLOCATED\" ng-show=\"itm.Status == 1 || itm.Status == 5\" class=\"status md-red-900-bg\" style=\"padding : 3px;\"></span> <span translate=\"RESOURCEALLOCATION.OPERATORPENDING\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId == null && itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-blue-500-bg\" style=\"padding : 3px;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId != null && itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId == null && !itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span></td><td ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><span>{{itm.ItemNameDisplay}}</span><br><span style=\"color : steelblue;\">{{droppableVm.service.getBillTypeDisplay(itm)}}</span></td><td ng-class=\"{\'deep-purple-label\': (itm.IsAllocatedBySmartScheduling)}\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\" ng-bind=\"itm.AllocatedId ? (itm.AllocatedItemName || itm.AllocatedCode) : droppableVm.utilService.translate(\'RESOURCEALLOCATION.NOTYETALLOCATED\')\"></td><td ng-if=\"!droppableVm.service.is_equipment\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\">{{droppableVm.getOperatorName(itm.AssignedOperatorId, itm.AvailableOperators)}}</td><td><md-menu style=\"position :relative; margin-left : -15px; margin-top : -20px; margin-bottom : -20px\"><md-button aria-label=\"Open menu with custom trigger\" class=\"md-icon-button\" ng-click=\"$mdMenu.open()\"><i class=\"icon-menu blue-500-fg\"></i></md-button><md-menu-content width=\"3\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item ng-click=\"droppableVm.service.assignOperatorDialog(itm, itm.AvailableOperators)\" ng-if=\"itm.IsOperatorRequired && !droppableVm.service.is_equipment\" ng-hide=\"itm.Status == 1 || itm.Status == 4\"><md-button><md-icon class=\"icon icon-person-plus teal-500-fg s35\"></md-icon>{{\'RESOURCEALLOCATION.ASSIGN_OPERATOR\' | translate}}</md-button></md-menu-item><md-menu-item ng-hide=\"itm.Status == 1 || itm.Status == 5\" ng-click=\"droppableVm.unAllocate(itm, $index, \'Equipment\')\"><md-button><md-icon class=\"icon icon-bookmark-remove s25 red-500-fg\"></md-icon>{{\'RESOURCEALLOCATION.UNALLOCATE\' | translate}}</md-button></md-menu-item><md-menu-item ng-click=\"droppableVm.changeResource(itm, \'Equipment\', true)\"><md-button><md-icon class=\"icon icon-camera-switch teal-500-fg s35\"></md-icon>{{\'RESOURCEALLOCATION.CHANGE\' | translate}}</md-button></md-menu-item><md-menu-item ng-click=\"droppableVm.service.unassignOperator(itm)\" ng-show=\"itm.AssignedOperatorId != null\"><md-button><md-icon class=\"icon icon-account-remove s25 red-500-fg\"></md-icon>{{\'RESOURCEALLOCATION.REMOVEOPERATOR\' | translate}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/BT/people.html","<div class=\"md-whiteframe-6dp\" layout=\"column\" md-whiteframe=\"6\" id=\"people-dropzone\" flex=\"\"><md-toolbar layout=\"row\" class=\"md-primary resource-toolbar\"><div class=\"md-toolbar-tools\"><span>{{ \'RESOURCEALLOCATION.PEOPLE\' | translate }}</span></div></md-toolbar><div droppable=\"\" flex=\"\" class=\"form-wrapper-2 scroll\" ms-scroll=\"\" style=\"position: relative;\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"droppableVm.service.showDroppableLoader\" class=\"md-accent droppable-spinner\"></md-progress-circular><div class=\"ms-responsive-table-wrapper\"><table class=\"simple table-position\" ms-responsive-table=\"\" ng-show=\"!droppableVm.service.showDroppableLoader\" ng-class=\"{ \'still-fetching\': droppableVm.service.fetchingAvailableResources, \'fetched\': !droppableVm.service.fetchingAvailableResources }\"><tfoot ng-if=\"droppableVm.service.droppables.length == 0\"><tr><td colspan=\"9\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\"><span>{{ \'RESOURCEALLOCATION.NOPEOPLE\' | translate }}</span></div></td></tr></tfoot><thead fix-head=\"\"><tr><th>{{ \'RESOURCEALLOCATION.PERSON\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.ALLOCATEDPERSON\' | translate }}</th><th style=\"text-align: center;\" ng-if=\"droppableVm.isMobileAppEnabled\">{{ \'RESOURCEALLOCATION.TIMESHEET_MANAGER\' | translate }}</th><th style=\"text-align: center;\">{{ \'RESOURCEALLOCATION.STATUS\' | translate }}</th><th style=\"text-align: center;\">{{ \'RESOURCEALLOCATION.SHIFT_TIMES\' | translate }}</th><th ng-if=\"droppableVm.isPayrollEnabled\">{{ \'RESOURCEALLOCATION.AWARD_AND_CLASSIFICATION\' | translate }}</th><th ng-if=\"droppableVm.isPayrollEnabled\">{{ \'RESOURCEALLOCATION.SHIFT_ROLES\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.TAGS_HEADER\' | translate }}</th><th style=\"text-align: center;\">{{ \'RESOURCEALLOCATION.ACTIONS\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"itm in droppableVm.service.droppables | filter: { ItemType: 4 }\" ng-class=\"{ \'selected\': (($index === droppableVm.service.selectedRow) && (droppableVm.service.clickSource === \'People\')) }\"><td ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\">{{ itm.ItemNameDisplay }}</td><td ng-class=\"{\'deep-purple-label\': (itm.IsAllocatedBySmartScheduling)}\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\" ng-bind=\"itm.AllocatedItemName == \'\' || itm.AllocatedItemName == null ? droppableVm.utilService.translate(\'RESOURCEALLOCATION.NOTYETALLOCATED\') : itm.AllocatedItemName\"></td><td style=\"text-align: center;\" ng-if=\"droppableVm.isMobileAppEnabled\"><md-checkbox class=\"table-md-checkbox\" ng-model=\"itm.IsTimesheetManager\" ng-change=\"droppableVm.service.saveTimesheetManager(itm)\"></md-checkbox></td><td style=\"min-height: 80px; text-align: center;\" ng-if=\"droppableVm.isMobileAppEnabled\" ng-class=\"droppableVm.getMessageStatus(itm.MessageStatus)\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\"><p style=\"margin: 0px; padding: 0px;\">{{ droppableVm.getMessageStatusText(itm.MessageStatus) }}</p></td><td style=\"min-height: 80px; text-align: center;\" ng-if=\"!droppableVm.isMobileAppEnabled\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\"><p style=\"margin: 0px; padding: 0px;\">{{ droppableVm.service.getStatus(itm.Status) }}</p></td><td style=\"text-align: center;\" ng-click=\"droppableVm.service.assignTimeDialog(itm)\">{{ itm.StartTime }} - {{ itm.FinishTime }}</td><td style=\"max-width: 140px;\" ng-if=\"droppableVm.isPayrollEnabled && !itm.IsSalariedEmployee\"><p style=\"margin: 0;\">{{ itm.Award.Name }}</p><p style=\"margin: 0; padding-top: 4px;\">{{ itm.AwardClassification.Name }}</p></td><td style=\"max-width: 140px;\" ng-if=\"droppableVm.isPayrollEnabled && itm.IsSalariedEmployee\"><p style=\"margin: 0;\">{{ \'RESOURCEALLOCATION.SAL\' | translate }}</p></td><td style=\"max-width: 140px;\" ng-if=\"droppableVm.isPayrollEnabled\"><span ng-repeat=\"role in itm.ShiftRoles\">{{ role.Name + (!$last ? \",\" : \"\") }}</span></td><td style=\"width:50%; text-align: center;\" ng-click=\"droppableVm.service.showShiftTags(itm)\"></td><span class=\"grey-fg\" ng-if=\"itm.Tags.length == 0\">Add Tags</span> <span ng-repeat=\"tag in itm.Tags\" ng-if=\"itm.Tags.length > 0\">{{ tag.Name + (!$last ? \",\" : \"\") }}<br ng-if=\"!$last\"></span><td style=\"text-align: center;\"><md-menu><md-button aria-label=\"Open menu with custom trigger\" class=\"md-icon-button\" ng-click=\"$mdMenu.open()\"><i class=\"icon-menu blue-500-fg\"></i></md-button><md-menu-content width=\"3\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item ng-click=\"droppableVm.service.showNote(itm)\"><md-button><md-icon class=\"icon icon-comment-text-outline s15\" ng-class=\"{ \'orange-500-fg\': itm.Notes.length > 0, \'blue-500-fg\': itm.Notes == null || itm.Notes.length <= 0 }\"></md-icon>{{ \'RESOURCEALLOCATION.VIEWNOTES\' | translate }}</md-button></md-menu-item><md-menu-item ng-if=\"itm.Status == 2\" ng-click=\"droppableVm.confirm(itm)\"><md-button><md-icon class=\"icon icon-account-check teal-500-fg s35\"></md-icon>{{ \'RESOURCEALLOCATION.CONFIRM\' | translate }}</md-button></md-menu-item><md-menu-item ng-if=\"!(itm.Status == 1 || itm.Status == 5)\" ng-click=\"droppableVm.unAllocate(itm, $index, \'People\')\"><md-button><md-icon class=\"icon icon-account-remove red-500-fg s35\"></md-icon>{{ \'RESOURCEALLOCATION.UNALLOCATE\' | translate }}</md-button></md-menu-item><md-menu-item ng-click=\"droppableVm.changeResource(itm, \'People\')\" ng-if=\"itm.AllocatedId\"><md-button><md-icon class=\"icon icon-account-switch teal-500-fg s35\"></md-icon>{{ \'RESOURCEALLOCATION.CHANGE\' | translate }}</md-button></md-menu-item><md-menu-item ng-click=\"droppableVm.service.assignTimeDialog(itm)\"><md-button><md-icon class=\"icon icon-clock teal-500-fg s35\"></md-icon>{{ \'RESOURCEALLOCATION.SHIFT_TIME\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/OPT/top-option.html","<div droppable=\"\" class=\"md-whiteframe-6dp main-style\" layout=\"column\" md-whiteframe=\"6\" id=\"option-dropzone\" flex=\"\"><md-toolbar layout=\"row\" class=\"md-primary resource-toolbar\"><div class=\"md-toolbar-tools\"><span>{{\'RESOURCEALLOCATION.APPLY_CHANGES\' | translate}}</span></div></md-toolbar><div flex=\"\" class=\"form-wrapper-2\" layout=\"{{vm.layout}}\" layout-margin=\"\"><div flex=\"initial\"><md-radio-group ng-model=\"vm.ngModel\" layout=\"column\" layout-align=\"start start\" layout-margin=\"\"><md-radio-button value=\"0\">{{\'RESOURCEALLOCATION.UPDATE_TODAY_ONWARDS\' | translate}}</md-radio-button><md-radio-button value=\"1\">{{\'RESOURCEALLOCATION.UPDATE_TODAY_ONLY\' | translate}}</md-radio-button><md-radio-button value=\"2\" ng-if=\"vm.claimsUtilService.isBillingEnabled()\">{{\'RESOURCEALLOCATION.UPDATE_ALL_UNBILLED\' | translate}}</md-radio-button><md-radio-button value=\"3\">{{\'RESOURCEALLOCATION.UPDATE_SPECIFIC_DATE_RANGE\' | translate}}</md-radio-button></md-radio-group></div><md-divider ng-if=\"vm.ngModel === \'3\'\"></md-divider><div flex=\"initial\" layout-margin=\"\" ng-if=\"vm.ngModel === \'3\'\" layout=\"column\"><div style=\"width : 200px;\"><md-input-container class=\"md-block\" flex=\"\" layout=\"row\"><label translate=\"RESOURCEALLOCATION.JOB_START_DATE\"></label><md-datepicker ng-model=\"vm.startDate\" md-open-on-focus=\"\" class=\"md-block\" md-date-filter=\"vm.filterStartDate\" flex=\"none\" layout=\"row\"></md-datepicker></md-input-container></div><div style=\"width : 200px;\"><md-input-container class=\"md-block\" flex=\"\" layout=\"row\"><label translate=\"RESOURCEALLOCATION.JOB_END_DATE\"></label><md-datepicker ng-model=\"vm.endDate\" md-date-filter=\"vm.filterEndDate\" md-open-on-focus=\"\" class=\"md-block\" flex=\"none\" layout=\"row\"></md-datepicker></md-input-container></div></div></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/SM/droppable-sm.html","<div layout=\"column\" id=\"droppable-allocate-resource-sm\" flex=\"\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"droppableVm.service.showDroppableLoader || droppableVm.service.reloader\"></md-progress-linear><div ng-include=\"\'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/SM/people.html\'\" style=\"padding-bottom: 20px; margin-top: -7px;\" ng-if=\"!droppableVm.service.is_equipment\"></div><a8-allocate-options ng-if=\"droppableVm.service.IsMultiDayEquipmentJob\" multiple=\"droppableVm.service.IsMultiDayEquipmentJob\" start-date=\"droppableVm.service.Equipment_StartDate\" end-date=\"droppableVm.service.Equipment_EndDate\" ng-model=\"droppableVm.service.allocation_option\" layout=\"column\"></a8-allocate-options><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"droppableVm.service.showDroppableLoader || droppableVm.service.reloader\"></md-progress-linear><div ng-include=\"\'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/SM/equipment.html\'\"></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/SM/equipment.html","<div class=\"md-whiteframe-6dp\" layout=\"column\" md-whiteframe=\"6\" ng-class=\"{\'equipment-dropzone-full\': droppableVm.service.is_equipment , \'equipment-dropzone\': !droppableVm.service.is_equipment}\" flex=\"\"><md-toolbar layout=\"row\" class=\"md-primary resource-toolbar\"><div class=\"md-toolbar-tools\"><span>{{ \'RESOURCEALLOCATION.EQUIPMENT\' | translate }}</span></div></md-toolbar><div droppable=\"\" flex=\"\" class=\"form-wrapper-2 scroll\" ms-scroll=\"\" style=\"position: relative\"><md-progress-circular class=\"md-accent droppable-spinner\" ng-if=\"droppableVm.service.showDroppableLoader\" md-mode=\"indeterminate\"></md-progress-circular><div layout=\"column\" layout-padding=\"\" flex=\"\" ng-class=\"{\'still-fetching\' : droppableVm.service.fetchingAvailableResources, \'fetched\' : !droppableVm.service.fetchingAvailableResources}\"><md-card class=\"md-whiteframe-1dp\" ng-show=\"!droppableVm.service.showDroppableLoader\" ng-class=\"{\'selected md-whiteframe-1dp\': (($index === droppableVm.service.selectedRow) && (droppableVm.service.clickSource === \'Equipment\'))}\" flex=\"\" ng-repeat=\"itm in droppableVm.service.droppables | filter:{ ItemType : \'!\' + 4 }\"><table style=\"width: 100%; border-spacing: 12px;\"><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><td width=\"50%\"><b>{{\'RESOURCEALLOCATION.OPERATORSTATUS\' | translate }}</b></td><td width=\"50%\"><span translate=\"RESOURCEALLOCATION.NOTYETALLOCATED\" ng-show=\"itm.Status == 1 || itm.Status == 5\" class=\"status md-red-900-bg\" style=\"padding : 3px;\"></span> <span translate=\"RESOURCEALLOCATION.OPERATORPENDING\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId == null && itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-blue-500-bg\" style=\"padding : 3px;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId != null && itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId == null && !itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span></td></tr><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><td width=\"50%\"><b>{{\'RESOURCEALLOCATION.ASSET\' | translate}}</b></td><td width=\"50%\">{{itm.ItemNameDisplay}}</td></tr><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><td width=\"50%\"><b>{{\'RESOURCEALLOCATION.BILL_AS\' | translate}}</b></td><td width=\"50%\"><b>{{droppableVm.service.getBillTypeDisplay(itm)}}</b></td></tr><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><td width=\"50%\"><b>{{\'RESOURCEALLOCATION.ALLOCATEDASSET\' | translate}}</b></td><td style=\"color : steelblue\" width=\"50%\" ng-class=\"{\'deep-purple-label\': (itm.IsAllocatedBySmartScheduling)}\" ng-bind=\"itm.AllocatedId ? (itm.AllocatedItemName || itm.AllocatedCode) : droppableVm.utilService.translate(\'RESOURCEALLOCATION.NOTYETALLOCATED\')\"></td></tr><tr ng-if=\"!droppableVm.service.is_equipment\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><td width=\"50%\"><b>{{\'RESOURCEALLOCATION.OPERATOR\' | translate}}</b></td><td width=\"50%\">{{droppableVm.getOperatorName(itm.AssignedOperatorId, itm.AvailableOperators)}}</td></tr><tr><td width=\"50%\"><b>{{\'RESOURCEALLOCATION.ACTIONS\' | translate}}</b></td><td width=\"50%\"><md-menu style=\"margin-left : -17px;\"><md-button aria-label=\"Open menu with custom trigger\" class=\"md-icon-button\" ng-click=\"$mdMenu.open()\"><i class=\"icon-menu blue-500-fg\"></i></md-button><md-menu-content width=\"3\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item ng-click=\"\" ng-if=\"itm.IsOperatorRequired && !droppableVm.service.is_equipment\" ng-hide=\"itm.Status == 1 || itm.Status == 4\"><md-button><md-icon class=\"icon icon-person-plus teal-500-fg s35\"></md-icon>{{\'RESOURCEALLOCATION.ASSIGN_OPERATOR\' | translate}}</md-button></md-menu-item><md-menu-item ng-hide=\"itm.Status == 1 || itm.Status == 5\" ng-click=\"droppableVm.unAllocate(itm, $index, \'Equipment\')\"><md-button><md-icon class=\"icon icon-bookmark-remove s25 red-500-fg\"></md-icon>{{\'RESOURCEALLOCATION.UNALLOCATE\' | translate}}</md-button></md-menu-item><md-menu-item ng-click=\"droppableVm.changeResource(itm, \'Equipment\', true)\"><md-button><md-icon class=\"icon icon-camera-switch teal-500-fg s35\"></md-icon>{{\'RESOURCEALLOCATION.CHANGE\' | translate}}</md-button></md-menu-item><md-menu-item ng-click=\"droppableVm.service.unassignOperator(itm)\" ng-show=\"itm.AssignedOperatorId != null\"><md-button><md-icon class=\"icon icon-account-remove s25 red-500-fg\"></md-icon>{{\'RESOURCEALLOCATION.REMOVEOPERATOR\' | translate}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></table></md-card></div></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/SM/people.html","<div class=\"md-whiteframe-6dp\" layout=\"column\" md-whiteframe=\"6\" id=\"people-dropzone\" flex=\"\"><md-toolbar layout=\"row\" class=\"md-primary resource-toolbar\"><div class=\"md-toolbar-tools\"><span>{{ \'RESOURCEALLOCATION.PEOPLE\' | translate }}</span></div></md-toolbar><div droppable=\"\" flex=\"\" class=\"form-wrapper-2 scroll\" ms-scroll=\"\" style=\"position: relative;\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"droppableVm.service.showDroppableLoader\" class=\"md-accent droppable-spinner\"></md-progress-circular><div layout=\"column\" layout-padding=\"\" flex=\"\" ng-class=\"{ \'still-fetching\': droppableVm.service.fetchingAvailableResources, \'fetched\': !droppableVm.service.fetchingAvailableResources }\"><md-card class=\"md-whiteframe-1dp\" ng-show=\"!droppableVm.service.showDroppableLoader\" ng-class=\"{ \'selected md-whiteframe-1dp\': (($index === droppableVm.service.selectedRow) && (droppableVm.service.clickSource === \'People\')) }\" flex=\"\" ng-repeat=\"itm in droppableVm.service.droppables | filter: { ItemType: 4 }\"><table style=\"width: 100%; border-spacing: 12px;\"><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\"><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.PERSON\' | translate }}</b></td><td width=\"50%\">{{ itm.ItemNameDisplay }}</td></tr><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\"><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.ALLOCATEDPERSON\' | translate }}</b></td><td style=\"color: steelblue;\" width=\"50%\" ng-class=\"{\'deep-purple-label\': (itm.IsAllocatedBySmartScheduling)}\" ng-bind=\"itm.AllocatedItemName == \'\' || itm.AllocatedItemName == null ? droppableVm.utilService.translate(\'RESOURCEALLOCATION.NOTYETALLOCATED\') : itm.AllocatedItemName\"></td></tr><tr ng-if=\"droppableVm.isMobileAppEnabled\"><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.TIMESHEET_MANAGER\' | translate }}</b></td><td width=\"50%\"><md-checkbox class=\"table-md-checkbox\" ng-model=\"itm.IsTimesheetManager\" ng-change=\"droppableVm.service.saveTimesheetManager(itm)\"></md-checkbox></td></tr><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\" ng-if=\"droppableVm.isMobileAppEnabled\" ng-class=\"droppableVm.getMessageStatus(itm.MessageStatus)\"><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.STATUS\' | translate }}</b></td><td width=\"50%\">{{ droppableVm.getMessageStatusText(itm.MessageStatus) }}</td></tr><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\" ng-if=\"!droppableVm.isMobileAppEnabled\"><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.STATUS\' | translate }}</b></td><td width=\"50%\">{{ droppableVm.service.getStatus(itm.Status) }}</td></tr><tr ng-click=\"droppableVm.service.assignTimeDialog(itm)\"><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.SHIFT_TIME\' | translate }}</b></td><td width=\"50%\">{{ itm.StartTime }} - {{ itm.FinishTime }}</td></tr><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\" ng-if=\"droppableVm.isPayrollEnabled\"><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.AWARD_AND_CLASSIFICATION\' | translate }}</b></td><td width=\"50%\" ng-if=\"!itm.IsSalariedEmployee\"><p style=\"margin: 0;\">{{ itm.Award.Name }}</p><p style=\"margin: 0; padding-top: 4px;\">{{ itm.AwardClassification.Name }}</p></td><td width=\"50%\" ng-if=\"itm.IsSalariedEmployee\"><p style=\"margin: 0;\">{{ \'RESOURCEALLOCATION.SAL\' | translate }}</p></td></tr><tr ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\" ng-if=\"droppableVm.isPayrollEnabled\"><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.SHIFT_ROLES\' | translate }}</b></td><td width=\"50%\"><span ng-repeat=\"role in itm.ShiftRoles\">{{ role.Name + (!$last ? \",\" : \"\") }}</span></td></tr><tr><td style=\"text-align: center;\" width=\"50%\"></td><b>{{ \'RESOURCEALLOCATION.TAGS_HEADER\' | translate }}</b><td style=\"width:50%; text-align: center;\" ng-click=\"droppableVm.service.showShiftTags(itm)\"><span class=\"grey-fg\" ng-if=\"itm.Tags.length == 0\">Add Tags</span> <span ng-repeat=\"tag in itm.Tags\" ng-if=\"itm.Tags.length > 0\">{{ tag.Name + (!$last ? \",\" : \"\") }}<br ng-if=\"!$last\"></span></td></tr><tr><td width=\"50%\"><b>{{ \'RESOURCEALLOCATION.ACTIONS\' | translate }}</b></td><td width=\"50%\"><md-menu style=\"margin-left: -15px;\"><md-button aria-label=\"Open menu with custom trigger\" class=\"md-icon-button\" ng-click=\"$mdMenu.open()\"><i class=\"icon-menu blue-500-fg\"></i></md-button><md-menu-content width=\"3\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item ng-click=\"droppableVm.service.showNote(itm)\"><md-button><md-icon class=\"icon icon-comment-text-outline s15\" ng-class=\"{ \'orange-500-fg\': itm.Notes.length > 0, \'blue-500-fg\': itm.Notes == null || itm.Notes.length <= 0 }\"></md-icon>{{ \'RESOURCEALLOCATION.VIEWNOTES\' | translate }}</md-button></md-menu-item><md-menu-item ng-if=\"itm.Status == 2\" ng-click=\"droppableVm.confirm(itm)\"><md-button><md-icon class=\"icon icon-account-check teal-500-fg s35\"></md-icon>{{ \'RESOURCEALLOCATION.CONFIRM\' | translate }}</md-button></md-menu-item><md-menu-item ng-if=\"!(itm.Status == 1 || itm.Status == 5)\" ng-click=\"droppableVm.unAllocate(itm, $index, \'People\')\"><md-button><md-icon class=\"icon icon-account-remove red-500-fg s35\"></md-icon>{{ \'RESOURCEALLOCATION.UNALLOCATE\' | translate }}</md-button></md-menu-item><md-menu-item ng-click=\"droppableVm.changeResource(itm, \'People\')\" ng-if=\"itm.AllocatedId\"><md-button><md-icon class=\"icon icon-account-switch teal-500-fg s35\"></md-icon>{{ \'RESOURCEALLOCATION.CHANGE\' | translate }}</md-button></md-menu-item><md-menu-item ng-click=\"droppableVm.service.assignTimeDialog(itm)\"><md-button><md-icon class=\"icon icon-clock teal-500-fg s35\"></md-icon>{{ \'RESOURCEALLOCATION.SHIFT_TIME\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></table></md-card></div></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/XL/droppable-xl.html","<div layout=\"column\" flex=\"\"><div layout=\"column\" id=\"droppable-allocate-resource-xl\" flex=\"\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"droppableVm.service.showDroppableLoader || droppableVm.service.reloader\"></md-progress-linear><div ng-include=\"\'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/XL/people.html\'\" style=\"padding-bottom: 20px; margin-top: -7px;\" ng-if=\"!droppableVm.service.is_equipment\"></div><a8-allocate-options ng-if=\"droppableVm.service.IsMultiDayEquipmentJob\" multiple=\"droppableVm.service.IsMultiDayEquipmentJob\" start-date=\"droppableVm.service.Equipment_StartDate\" end-date=\"droppableVm.service.Equipment_EndDate\" layout=\"row\" ng-model=\"droppableVm.service.allocation_option\"></a8-allocate-options><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"droppableVm.service.showDroppableLoader || droppableVm.service.reloader\"></md-progress-linear><div ng-include=\"\'app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/XL/equipment.html\'\"></div></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/XL/equipment.html","<div layout=\"column\" md-whiteframe=\"6\" ng-class=\"{\'equipment-dropzone-full\': droppableVm.service.is_equipment , \'equipment-dropzone\': !droppableVm.service.is_equipment}\" flex=\"\"><md-toolbar layout=\"row\" class=\"md-primary resource-toolbar\"><div class=\"md-toolbar-tools\"><span>{{ \'RESOURCEALLOCATION.EQUIPMENT\' | translate }}</span></div></md-toolbar><div droppable=\"\" flex=\"\" class=\"form-wrapper-2 scroll\" ms-scroll=\"\" style=\"position: relative\"><md-progress-circular class=\"md-accent droppable-spinner\" ng-if=\"droppableVm.service.showDroppableLoader\" md-mode=\"indeterminate\"></md-progress-circular><div class=\"ms-responsive-table-wrapper\" ng-disabled=\"true\"><table class=\"simple table-position\" ms-responsive-table=\"\" ng-show=\"!droppableVm.service.showDroppableLoader\" ng-class=\"{\'still-fetching\' : droppableVm.service.fetchingAvailableResources, \'fetched\' : !droppableVm.service.fetchingAvailableResources, \'equipment-with-link-items\' : droppableVm.isLinkedItemsEnabled, \'no-linked-items\' : !droppableVm.hasLinkedItems()}\"><tfoot ng-if=\"droppableVm.service.droppables.length == 0\"><tr><td ng-attr-colspan=\"{{ 4 + (droppableVm.isLinkedItemsEnabled ? 1 : 0) + (!droppableVm.service.is_equipment ? 1 : 0) }}\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\"><span>{{ \'RESOURCEALLOCATION.NOEQUIPMENT\' | translate }}</span></div></td></tr></tfoot><thead><tr><th ng-if=\"droppableVm.isLinkedItemsEnabled\"></th><th>{{ \'RESOURCEALLOCATION.ASSET\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.ALLOCATEDASSET\' | translate }}</th><th ng-if=\"!droppableVm.service.is_equipment\">{{ \'RESOURCEALLOCATION.OPERATOR\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.OPERATORSTATUS\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.ACTIONS\' | translate }}</th></tr></thead><tbody><tr ng-repeat-start=\"itm in droppableVm.service.droppables | filter : droppableVm.equipmentListFilter\" ng-class=\"{\'selected\': (($index === droppableVm.service.selectedRow) && (droppableVm.service.clickSource === \'Equipment\'))}\" class=\"parent-asset-item\"><td ng-if=\"droppableVm.isLinkedItemsEnabled\" ng-init=\"linkedItemsCount = droppableVm.linkedItemsCount(itm.Id)\" ng-class=\"{\'main-timeline\': linkedItemsCount > 0}\"><md-icon ng-if=\"linkedItemsCount > 0\" class=\"arrow-svg-parent\" md-svg-src=\"/assets/icons/stat0-diamond.svg\" aria-label=\"Parent Item\"></md-icon></td><td ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><span>{{itm.ItemNameDisplay}}</span><br><span style=\"color : steelblue;\">{{droppableVm.service.getBillTypeDisplay(itm)}}</span></td><td ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\" ng-bind=\"itm.AllocatedId ? (itm.AllocatedItemName || itm.AllocatedCode) : droppableVm.utilService.translate(\'RESOURCEALLOCATION.NOTYETALLOCATED\')\"></td><td ng-if=\"!droppableVm.service.is_equipment\"><md-select style=\"padding : 0;margin : 0;\" ng-if=\"itm.IsOperatorRequired\" ng-disabled=\"droppableVm.service.fetchingAvailableResources\" ng-hide=\"itm.Status == 1 || itm.Status == 4\" ng-model=\"itm.AssignedOperatorId\" ng-change=\"droppableVm.service.assignOperator(itm)\" ng-class=\"droppableVm.service.setPeopleEquipmentColor(itm)\"><md-option ng-value=\"operator.AllocatedId\" ng-repeat=\"operator in itm.AvailableOperators\" ng-disabled=\"operator.IsAllocatedToEquipment\">{{operator.AllocatedItemName}}</md-option></md-select></td><td ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'Equipment\')\"><span translate=\"RESOURCEALLOCATION.NOTYETALLOCATED\" ng-show=\"itm.Status == 1 || itm.Status == 5\" class=\"status md-red-900-bg\" style=\"padding : 3px;\"></span> <span translate=\"RESOURCEALLOCATION.OPERATORPENDING\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId == null && itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-blue-500-bg\" style=\"padding : 3px;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId != null && itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(itm.Status == 3 || itm.Status == 2) && itm.AssignedOperatorId == null && !itm.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span></td><td><md-button ng-click=\"droppableVm.unAllocate(itm, $index, \'Equipment\')\" style=\"position :relative; margin-left : -15px; margin-top : -15px; margin-bottom : -15px\" ng-if=\"!(itm.Status == 1 || itm.Status == 5)\" class=\"md-icon-button action-button\"><i class=\"icon icon-bookmark-remove s25 red-500-fg\" style=\"padding : 0px; margin : 0px;\"><md-tooltip>{{ \'RESOURCEALLOCATION.UNALLOCATE\' | translate }}</md-tooltip></i></md-button><md-button style=\"position :relative; margin-left : -15px; margin-top : -15px; margin-bottom : -15px\" ng-if=\"itm.AssignedOperatorId != null\" class=\"md-icon-button action-button\" ng-click=\"droppableVm.service.unassignOperator(itm)\"><i class=\"icon icon-account-remove s25 red-500-fg\" style=\"padding : 0px; margin : 0px;\"><md-tooltip>{{ \'RESOURCEALLOCATION.REMOVEOPERATOR\' | translate }}</md-tooltip></i></md-button><md-button style=\"position :relative; margin-left : -15px; margin-top : -15px; margin-bottom : -15px\" class=\"md-icon-button action-button\" ng-click=\"droppableVm.changeResource(itm, \'Equipment\', true)\"><i class=\"icon icon-camera-switch teal-500-fg s35\"><md-tooltip>{{ \'RESOURCEALLOCATION.CHANGE\' | translate }}</md-tooltip></i></md-button><md-button ng-if=\"itm.IsOperatorRequired && droppableVm.isLinkedItemsEnabled\" style=\"position :relative; margin-left : -15px; margin-top : -15px; margin-bottom : -15px\" class=\"md-icon-button action-button\" ng-click=\"droppableVm.service.showLinkItemModal(itm,droppableVm.service.droppables )\"><svg viewbox=\"0 0 17 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"5\" y=\"1\" width=\"10\" height=\"5\" rx=\"1\" fill=\"#03A9F4\"></rect><rect x=\"5\" y=\"8\" width=\"10\" height=\"5\" rx=\"1\" fill=\"#03A9F4\"></rect><rect id=\"2\"></rect><title>{{ \'RESOURCEALLOCATION.LINK\' | translate }}</title><path d=\"M12 3H3C2.44772 3 2 3.44772 2 4V10C2 10.5523 2.44772 11 3 11H12\" stroke=\"#03A9F4\"></path></svg></md-button></td></tr><tr ng-repeat-end=\"\" ng-repeat=\"child in droppableVm.linkedItemsOf(itm.Id)\" ng-class=\"{\'selected\': (droppableVm.service.selectedItem.Id === child.Id) && (droppableVm.service.clickSource === \'Equipment\')}\" class=\"linked-items\"><td class=\"main-timeline\"><md-icon class=\"arrow-svg-child\" md-svg-src=\"/assets/icons/stat0-fill-none.svg\" aria-label=\"Linked Item\"></md-icon></td><td ng-click=\"droppableVm.service.loadResourcesForShift(child, -1, \'Equipment\')\"><span style=\"margin-left: 30px;\">{{child.ItemNameDisplay}}</span></td><td ng-click=\"droppableVm.service.loadResourcesForShift(child, -1, \'Equipment\')\" ng-bind=\"child.AllocatedId ? (child.AllocatedItemName || child.AllocatedCode) : droppableVm.utilService.translate(\'RESOURCEALLOCATION.NOTYETALLOCATED\')\"></td><td ng-if=\"!droppableVm.service.is_equipment\"></td><td><span translate=\"RESOURCEALLOCATION.NOTYETALLOCATED\" ng-show=\"child.Status == 1 || child.Status == 5\" class=\"status md-red-900-bg\" style=\"padding : 3px;\"></span> <span translate=\"RESOURCEALLOCATION.OPERATORPENDING\" ng-show=\"(child.Status == 3 || child.Status == 2) && child.AssignedOperatorId == null && child.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-blue-500-bg\" style=\"padding : 3px;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(child.Status == 3 || child.Status == 2) && droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(child.Status == 3 || child.Status == 2) && child.AssignedOperatorId != null && child.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span> <span translate=\"RESOURCEALLOCATION.COMPLETED\" ng-show=\"(child.Status == 3 || child.Status == 2) && child.AssignedOperatorId == null && !child.IsOperatorRequired && !droppableVm.service.is_equipment\" class=\"status md-green-300-bg\" style=\"padding : 3px; color : white;\"></span></td><td><md-button ng-click=\"droppableVm.unAllocate(child, $index, \'Equipment\')\" style=\"position :relative; margin-left : -15px; margin-top : -15px; margin-bottom : -15px\" ng-if=\"!(child.Status == 1 || child.Status == 5)\" class=\"md-icon-button action-button\"><i class=\"icon icon-bookmark-remove s25 red-500-fg\" style=\"padding : 0px; margin : 0px;\"><md-tooltip>{{ \'RESOURCEALLOCATION.UNALLOCATE\' | translate }}</md-tooltip></i></md-button><md-button style=\"position :relative; margin-left : -15px; margin-top : -15px; margin-bottom : -15px\" class=\"md-icon-button action-button\" ng-click=\"droppableVm.changeResource(child, \'Equipment\')\"><i class=\"icon icon-camera-switch teal-500-fg s35\"><md-tooltip>{{ \'RESOURCEALLOCATION.CHANGE\' | translate }}</md-tooltip></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/jobs/allocateResource/components/droppableComponent/components/droppable-components/XL/people.html","<div droppable=\"\" class=\"md-whiteframe-6dp\" layout=\"column\" md-whiteframe=\"6\" id=\"people-dropzone\" flex=\"\"><md-toolbar layout=\"row\" class=\"md-primary resource-toolbar\"><div class=\"md-toolbar-tools\"><span>{{ \'RESOURCEALLOCATION.PEOPLE\' | translate }}</span></div></md-toolbar><div flex=\"\" class=\"form-wrapper-2 scroll\" ms-scroll=\"\" style=\"position: relative;\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"droppableVm.service.showDroppableLoader\" class=\"md-accent droppable-spinner\"></md-progress-circular><div class=\"ms-responsive-table-wrapper\"><table class=\"simple table-position\" ms-responsive-table=\"\" ng-show=\"!droppableVm.service.showDroppableLoader\" ng-class=\"{ \'still-fetching\': droppableVm.service.fetchingAvailableResources, \'fetched\': !droppableVm.service.fetchingAvailableResources }\"><tfoot ng-if=\"droppableVm.service.droppables.length == 0\"><tr><td ng-attr-colspan=\"{{ 6 + (droppableVm.isMobileAppEnabled ? 1 : 0) + (droppableVm.isPayrollEnabled ? 2 : 0) }}\"><div class=\"padding-15 h6 app-grid-norecord secondary-text\"><span>{{ \'RESOURCEALLOCATION.NOPEOPLE\' | translate }}</span></div></td></tr></tfoot><thead fix-head=\"\"><tr><th>{{ \'RESOURCEALLOCATION.PERSON\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.ALLOCATEDPERSON\' | translate }}</th><th style=\"text-align: center;\" ng-if=\"droppableVm.isMobileAppEnabled\">{{ \'RESOURCEALLOCATION.TIMESHEET_MANAGER\' | translate }}</th><th style=\"text-align: center;\">{{ \'RESOURCEALLOCATION.STATUS\' | translate }}</th><th style=\"text-align: center;\">{{ \'RESOURCEALLOCATION.STARTTIME\' | translate }} / {{ \'RESOURCEALLOCATION.ENDTIME\' | translate }}</th><th ng-if=\"droppableVm.isPayrollEnabled\">{{ \'RESOURCEALLOCATION.AWARD_AND_CLASSIFICATION\' | translate }}</th><th ng-if=\"droppableVm.isPayrollEnabled\">{{ \'RESOURCEALLOCATION.SHIFT_ROLES\' | translate }}</th><th style=\"text-align: center;\">{{ \'RESOURCEALLOCATION.TAGS_HEADER\' | translate }}</th><th>{{ \'RESOURCEALLOCATION.ACTIONS\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"itm in droppableVm.service.droppables | filter: { ItemType: 4 }\" ng-class=\"{ \'selected\': (($index === droppableVm.service.selectedRow) && (droppableVm.service.clickSource === \'People\')) }\"><td ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\">{{ itm.ItemNameDisplay }}</td><td ng-class=\"{\'deep-purple-label\': (itm.IsAllocatedBySmartScheduling)}\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\" ng-bind=\"itm.AllocatedItemName == \'\' || itm.AllocatedItemName == null ? droppableVm.utilService.translate(\'RESOURCEALLOCATION.NOTYETALLOCATED\') : itm.AllocatedItemName\"></td><td style=\"text-align: center;\" ng-if=\"droppableVm.isMobileAppEnabled\"><md-checkbox class=\"table-md-checkbox\" ng-model=\"itm.IsTimesheetManager\" ng-change=\"droppableVm.service.saveTimesheetManager(itm)\"></md-checkbox></td><td style=\"min-height: 80px; text-align: center;\" ng-if=\"droppableVm.isMobileAppEnabled\" ng-class=\"droppableVm.getMessageStatus(itm.MessageStatus)\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\"><p style=\"margin: 0px; padding: 0px;\">{{ droppableVm.getMessageStatusText(itm.MessageStatus) }}</p></td><td style=\"min-height: 80px; text-align: center;\" ng-if=\"!droppableVm.isMobileAppEnabled\" ng-click=\"droppableVm.service.loadResourcesForShift(itm, $index, \'People\')\"><p style=\"margin: 0px; padding: 0px;\">{{ droppableVm.service.getStatus(itm.Status) }}</p></td><td ng-click=\"droppableVm.service.assignTimeDialog(itm)\" style=\"text-align: center;\">{{ itm.StartTime }} - {{ itm.FinishTime }}</td><td style=\"max-width: 160px;\" ng-if=\"droppableVm.isPayrollEnabled && !itm.IsSalariedEmployee\"><p style=\"margin: 0;\" ng-style=\"{\'color\': itm.DoShiftAndResourceHaveSameAward ? \'\' : \'red\'}\">{{ itm.Award.Name }}</p><p style=\"margin: 0; padding-top: 4px;\" ng-style=\"{\'color\': itm.DoShiftAndResourceHaveSameClassification ? \'\' : \'red\'}\">{{ itm.AwardClassification.Name }}</p></td><td style=\"max-width: 160px;\" ng-if=\"droppableVm.isPayrollEnabled && itm.IsSalariedEmployee\"><p style=\"margin: 0;\">{{ \'RESOURCEALLOCATION.SAL\' | translate }}</p></td><td style=\"max-width: 160px;\" ng-if=\"droppableVm.isPayrollEnabled\"><span ng-repeat=\"role in itm.ShiftRoles\">{{ role.Name + (!$last ? \",\" : \"\") }}</span></td><td style=\"max-width: 160px; text-align: center;\" ng-click=\"droppableVm.service.showShiftTags(itm)\"><span class=\"shift-add-tags-button\" ng-if=\"itm.Tags.length == 0\">Add Tags</span> <span ng-repeat=\"tag in itm.Tags\" ng-if=\"itm.Tags.length > 0\">{{ tag.Name + (!$last ? \",\" : \"\") }}<br ng-if=\"!$last\"></span></td><td><md-button style=\"margin:0; padding: 0;\" class=\"md-icon-button action-button\" ng-if=\"!(itm.Status == 1 || itm.Status == 5)\" ng-click=\"droppableVm.unAllocate(itm, $index, \'People\')\"><i class=\"icon icon-account-remove red-500-fg s35\"><md-tooltip>{{ \'RESOURCEALLOCATION.UNALLOCATE\' | translate }}</md-tooltip></i></md-button><md-button style=\"margin:0; padding: 0;\" class=\"md-icon-button action-button\" ng-if=\"itm.Status == 2\" ng-click=\"droppableVm.confirm(itm)\"><i class=\"icon icon-account-check teal-500-fg s35\"><md-tooltip>{{ \'RESOURCEALLOCATION.CONFIRM\' | translate }}</md-tooltip></i></md-button><md-button style=\"margin:0; padding: 0;\" ng-click=\"droppableVm.service.showNote(itm)\" class=\"md-icon-button action-button\"><i class=\"icon icon-comment-text-outline s15\" ng-class=\"{ \'orange-500-fg\': itm.Notes.length > 0, \'blue-500-fg\': itm.Notes == null || itm.Notes.length <= 0 }\"><md-tooltip>{{ \'RESOURCEALLOCATION.VIEWNOTES\' | translate }}</md-tooltip></i></md-button><md-button style=\"margin:0; padding: 0;\" ng-if=\"itm.AllocatedId\" class=\"md-icon-button action-button\" ng-click=\"droppableVm.changeResource(itm, \'People\')\"><i class=\"icon icon-account-switch teal-500-fg s35\"><md-tooltip>{{ \'RESOURCEALLOCATION.CHANGE\' | translate }}</md-tooltip></i></md-button><md-button style=\"margin:0; padding: 0;\" class=\"md-icon-button action-button p-0 m-0\" ng-disabled=\"droppableVm.service.fetchingAvailableResources\" ng-click=\"droppableVm.service.assignTimeDialog(itm)\"><i class=\"icon icon-clock teal-500-fg s35\"><md-tooltip>{{ \'RESOURCEALLOCATION.SHIFT_TIME\' | translate }}</md-tooltip></i></md-button></td></tr></tbody></table></div></div></div>");}]);